import * as React from "react";
import React__default, { createContext, useRef, useState, useEffect, useContext, useLayoutEffect, useMemo, useCallback, isValidElement, forwardRef as forwardRef$3, createElement as createElement$3, useImperativeHandle, useReducer, createRef, useSyncExternalStore } from "react";
import require$$2, { createPortal, flushSync } from "react-dom";
function getDefaultExportFromCjs$5(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
function getAugmentedNamespace$1(n2) {
  if (Object.prototype.hasOwnProperty.call(n2, "__esModule")) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      var isInstance = false;
      try {
        isInstance = this instanceof a3;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var jsxRuntime$3 = { exports: {} };
var reactJsxRuntime_production$3 = {};
var hasRequiredReactJsxRuntime_production$3;
function requireReactJsxRuntime_production$3() {
  if (hasRequiredReactJsxRuntime_production$3) return reactJsxRuntime_production$3;
  hasRequiredReactJsxRuntime_production$3 = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$3.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$3.jsx = jsxProd;
  reactJsxRuntime_production$3.jsxs = jsxProd;
  return reactJsxRuntime_production$3;
}
var reactJsxRuntime_development$3 = {};
var hasRequiredReactJsxRuntime_development$3;
function requireReactJsxRuntime_development$3() {
  if (hasRequiredReactJsxRuntime_development$3) return reactJsxRuntime_development$3;
  hasRequiredReactJsxRuntime_development$3 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$3.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$3.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$3.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$3;
}
var hasRequiredJsxRuntime$3;
function requireJsxRuntime$3() {
  if (hasRequiredJsxRuntime$3) return jsxRuntime$3.exports;
  hasRequiredJsxRuntime$3 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$3.exports = requireReactJsxRuntime_production$3();
  } else {
    jsxRuntime$3.exports = requireReactJsxRuntime_development$3();
  }
  return jsxRuntime$3.exports;
}
var jsxRuntimeExports$3 = requireJsxRuntime$3();
var alea$1 = { exports: {} };
var alea = alea$1.exports;
var hasRequiredAlea;
function requireAlea() {
  if (hasRequiredAlea) return alea$1.exports;
  hasRequiredAlea = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function Alea(seed) {
        var me2 = this, mash = Mash();
        me2.next = function() {
          var t4 = 2091639 * me2.s0 + me2.c * 23283064365386963e-26;
          me2.s0 = me2.s1;
          me2.s1 = me2.s2;
          return me2.s2 = t4 - (me2.c = t4 | 0);
        };
        me2.c = 1;
        me2.s0 = mash(" ");
        me2.s1 = mash(" ");
        me2.s2 = mash(" ");
        me2.s0 -= mash(seed);
        if (me2.s0 < 0) {
          me2.s0 += 1;
        }
        me2.s1 -= mash(seed);
        if (me2.s1 < 0) {
          me2.s1 += 1;
        }
        me2.s2 -= mash(seed);
        if (me2.s2 < 0) {
          me2.s2 += 1;
        }
        mash = null;
      }
      function copy2(f2, t4) {
        t4.c = f2.c;
        t4.s0 = f2.s0;
        t4.s1 = f2.s1;
        t4.s2 = f2.s2;
        return t4;
      }
      function impl(seed, opts) {
        var xg = new Alea(seed), state = opts && opts.state, prng = xg.next;
        prng.int32 = function() {
          return xg.next() * 4294967296 | 0;
        };
        prng.double = function() {
          return prng() + (prng() * 2097152 | 0) * 11102230246251565e-32;
        };
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      function Mash() {
        var n2 = 4022871197;
        var mash = function(data) {
          data = String(data);
          for (var i2 = 0; i2 < data.length; i2++) {
            n2 += data.charCodeAt(i2);
            var h2 = 0.02519603282416938 * n2;
            n2 = h2 >>> 0;
            h2 -= n2;
            h2 *= n2;
            n2 = h2 >>> 0;
            h2 -= n2;
            n2 += h2 * 4294967296;
          }
          return (n2 >>> 0) * 23283064365386963e-26;
        };
        return mash;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.alea = impl;
      }
    })(
      alea,
      module
    );
  })(alea$1);
  return alea$1.exports;
}
var xor128$1 = { exports: {} };
var xor128 = xor128$1.exports;
var hasRequiredXor128;
function requireXor128() {
  if (hasRequiredXor128) return xor128$1.exports;
  hasRequiredXor128 = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.x = 0;
        me2.y = 0;
        me2.z = 0;
        me2.w = 0;
        me2.next = function() {
          var t4 = me2.x ^ me2.x << 11;
          me2.x = me2.y;
          me2.y = me2.z;
          me2.z = me2.w;
          return me2.w ^= me2.w >>> 19 ^ t4 ^ t4 >>> 8;
        };
        if (seed === (seed | 0)) {
          me2.x = seed;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 64; k2++) {
          me2.x ^= strseed.charCodeAt(k2) | 0;
          me2.next();
        }
      }
      function copy2(f2, t4) {
        t4.x = f2.x;
        t4.y = f2.y;
        t4.z = f2.z;
        t4.w = f2.w;
        return t4;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xor128 = impl;
      }
    })(
      xor128,
      module
    );
  })(xor128$1);
  return xor128$1.exports;
}
var xorwow$1 = { exports: {} };
var xorwow = xorwow$1.exports;
var hasRequiredXorwow;
function requireXorwow() {
  if (hasRequiredXorwow) return xorwow$1.exports;
  hasRequiredXorwow = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.next = function() {
          var t4 = me2.x ^ me2.x >>> 2;
          me2.x = me2.y;
          me2.y = me2.z;
          me2.z = me2.w;
          me2.w = me2.v;
          return (me2.d = me2.d + 362437 | 0) + (me2.v = me2.v ^ me2.v << 4 ^ (t4 ^ t4 << 1)) | 0;
        };
        me2.x = 0;
        me2.y = 0;
        me2.z = 0;
        me2.w = 0;
        me2.v = 0;
        if (seed === (seed | 0)) {
          me2.x = seed;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 64; k2++) {
          me2.x ^= strseed.charCodeAt(k2) | 0;
          if (k2 == strseed.length) {
            me2.d = me2.x << 10 ^ me2.x >>> 4;
          }
          me2.next();
        }
      }
      function copy2(f2, t4) {
        t4.x = f2.x;
        t4.y = f2.y;
        t4.z = f2.z;
        t4.w = f2.w;
        t4.v = f2.v;
        t4.d = f2.d;
        return t4;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xorwow = impl;
      }
    })(
      xorwow,
      module
    );
  })(xorwow$1);
  return xorwow$1.exports;
}
var xorshift7$1 = { exports: {} };
var xorshift7 = xorshift7$1.exports;
var hasRequiredXorshift7;
function requireXorshift7() {
  if (hasRequiredXorshift7) return xorshift7$1.exports;
  hasRequiredXorshift7 = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function XorGen(seed) {
        var me2 = this;
        me2.next = function() {
          var X2 = me2.x, i2 = me2.i, t4, v2;
          t4 = X2[i2];
          t4 ^= t4 >>> 7;
          v2 = t4 ^ t4 << 24;
          t4 = X2[i2 + 1 & 7];
          v2 ^= t4 ^ t4 >>> 10;
          t4 = X2[i2 + 3 & 7];
          v2 ^= t4 ^ t4 >>> 3;
          t4 = X2[i2 + 4 & 7];
          v2 ^= t4 ^ t4 << 7;
          t4 = X2[i2 + 7 & 7];
          t4 = t4 ^ t4 << 13;
          v2 ^= t4 ^ t4 << 9;
          X2[i2] = v2;
          me2.i = i2 + 1 & 7;
          return v2;
        };
        function init2(me3, seed2) {
          var j2, X2 = [];
          if (seed2 === (seed2 | 0)) {
            X2[0] = seed2;
          } else {
            seed2 = "" + seed2;
            for (j2 = 0; j2 < seed2.length; ++j2) {
              X2[j2 & 7] = X2[j2 & 7] << 15 ^ seed2.charCodeAt(j2) + X2[j2 + 1 & 7] << 13;
            }
          }
          while (X2.length < 8) X2.push(0);
          for (j2 = 0; j2 < 8 && X2[j2] === 0; ++j2) ;
          if (j2 == 8) X2[7] = -1;
          else X2[j2];
          me3.x = X2;
          me3.i = 0;
          for (j2 = 256; j2 > 0; --j2) {
            me3.next();
          }
        }
        init2(me2, seed);
      }
      function copy2(f2, t4) {
        t4.x = f2.x.slice();
        t4.i = f2.i;
        return t4;
      }
      function impl(seed, opts) {
        if (seed == null) seed = +/* @__PURE__ */ new Date();
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (state.x) copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xorshift7 = impl;
      }
    })(
      xorshift7,
      module
    );
  })(xorshift7$1);
  return xorshift7$1.exports;
}
var xor4096$1 = { exports: {} };
var xor4096 = xor4096$1.exports;
var hasRequiredXor4096;
function requireXor4096() {
  if (hasRequiredXor4096) return xor4096$1.exports;
  hasRequiredXor4096 = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function XorGen(seed) {
        var me2 = this;
        me2.next = function() {
          var w2 = me2.w, X2 = me2.X, i2 = me2.i, t4, v2;
          me2.w = w2 = w2 + 1640531527 | 0;
          v2 = X2[i2 + 34 & 127];
          t4 = X2[i2 = i2 + 1 & 127];
          v2 ^= v2 << 13;
          t4 ^= t4 << 17;
          v2 ^= v2 >>> 15;
          t4 ^= t4 >>> 12;
          v2 = X2[i2] = v2 ^ t4;
          me2.i = i2;
          return v2 + (w2 ^ w2 >>> 16) | 0;
        };
        function init2(me3, seed2) {
          var t4, v2, i2, j2, w2, X2 = [], limit = 128;
          if (seed2 === (seed2 | 0)) {
            v2 = seed2;
            seed2 = null;
          } else {
            seed2 = seed2 + "\0";
            v2 = 0;
            limit = Math.max(limit, seed2.length);
          }
          for (i2 = 0, j2 = -32; j2 < limit; ++j2) {
            if (seed2) v2 ^= seed2.charCodeAt((j2 + 32) % seed2.length);
            if (j2 === 0) w2 = v2;
            v2 ^= v2 << 10;
            v2 ^= v2 >>> 15;
            v2 ^= v2 << 4;
            v2 ^= v2 >>> 13;
            if (j2 >= 0) {
              w2 = w2 + 1640531527 | 0;
              t4 = X2[j2 & 127] ^= v2 + w2;
              i2 = 0 == t4 ? i2 + 1 : 0;
            }
          }
          if (i2 >= 128) {
            X2[(seed2 && seed2.length || 0) & 127] = -1;
          }
          i2 = 127;
          for (j2 = 4 * 128; j2 > 0; --j2) {
            v2 = X2[i2 + 34 & 127];
            t4 = X2[i2 = i2 + 1 & 127];
            v2 ^= v2 << 13;
            t4 ^= t4 << 17;
            v2 ^= v2 >>> 15;
            t4 ^= t4 >>> 12;
            X2[i2] = v2 ^ t4;
          }
          me3.w = w2;
          me3.X = X2;
          me3.i = i2;
        }
        init2(me2, seed);
      }
      function copy2(f2, t4) {
        t4.i = f2.i;
        t4.w = f2.w;
        t4.X = f2.X.slice();
        return t4;
      }
      function impl(seed, opts) {
        if (seed == null) seed = +/* @__PURE__ */ new Date();
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (state.X) copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.xor4096 = impl;
      }
    })(
      xor4096,
      // window object or global
      module
    );
  })(xor4096$1);
  return xor4096$1.exports;
}
var tychei$1 = { exports: {} };
var tychei = tychei$1.exports;
var hasRequiredTychei;
function requireTychei() {
  if (hasRequiredTychei) return tychei$1.exports;
  hasRequiredTychei = 1;
  (function(module) {
    (function(global2, module2, define2) {
      function XorGen(seed) {
        var me2 = this, strseed = "";
        me2.next = function() {
          var b2 = me2.b, c2 = me2.c, d2 = me2.d, a2 = me2.a;
          b2 = b2 << 25 ^ b2 >>> 7 ^ c2;
          c2 = c2 - d2 | 0;
          d2 = d2 << 24 ^ d2 >>> 8 ^ a2;
          a2 = a2 - b2 | 0;
          me2.b = b2 = b2 << 20 ^ b2 >>> 12 ^ c2;
          me2.c = c2 = c2 - d2 | 0;
          me2.d = d2 << 16 ^ c2 >>> 16 ^ a2;
          return me2.a = a2 - b2 | 0;
        };
        me2.a = 0;
        me2.b = 0;
        me2.c = 2654435769 | 0;
        me2.d = 1367130551;
        if (seed === Math.floor(seed)) {
          me2.a = seed / 4294967296 | 0;
          me2.b = seed | 0;
        } else {
          strseed += seed;
        }
        for (var k2 = 0; k2 < strseed.length + 20; k2++) {
          me2.b ^= strseed.charCodeAt(k2) | 0;
          me2.next();
        }
      }
      function copy2(f2, t4) {
        t4.a = f2.a;
        t4.b = f2.b;
        t4.c = f2.c;
        t4.d = f2.d;
        return t4;
      }
      function impl(seed, opts) {
        var xg = new XorGen(seed), state = opts && opts.state, prng = function() {
          return (xg.next() >>> 0) / 4294967296;
        };
        prng.double = function() {
          do {
            var top2 = xg.next() >>> 11, bot = (xg.next() >>> 0) / 4294967296, result2 = (top2 + bot) / (1 << 21);
          } while (result2 === 0);
          return result2;
        };
        prng.int32 = xg.next;
        prng.quick = prng;
        if (state) {
          if (typeof state == "object") copy2(state, xg);
          prng.state = function() {
            return copy2(xg, {});
          };
        }
        return prng;
      }
      if (module2 && module2.exports) {
        module2.exports = impl;
      } else {
        this.tychei = impl;
      }
    })(
      tychei,
      module
    );
  })(tychei$1);
  return tychei$1.exports;
}
var seedrandom$4 = { exports: {} };
const __viteBrowserExternal = {};
const __viteBrowserExternal$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: __viteBrowserExternal
}, Symbol.toStringTag, { value: "Module" }));
const require$$0 = /* @__PURE__ */ getAugmentedNamespace$1(__viteBrowserExternal$1);
var seedrandom$3 = seedrandom$4.exports;
var hasRequiredSeedrandom$1;
function requireSeedrandom$1() {
  if (hasRequiredSeedrandom$1) return seedrandom$4.exports;
  hasRequiredSeedrandom$1 = 1;
  (function(module) {
    (function(global2, pool, math2) {
      var width = 256, chunks = 6, digits2 = 52, rngname = "random", startdenom = math2.pow(width, chunks), significance = math2.pow(2, digits2), overflow = significance * 2, mask = width - 1, nodecrypto;
      function seedrandom2(seed, options2, callback) {
        var key = [];
        options2 = options2 == true ? { entropy: true } : options2 || {};
        var shortseed = mixkey(flatten2(
          options2.entropy ? [seed, tostring(pool)] : seed == null ? autoseed() : seed,
          3
        ), key);
        var arc4 = new ARC4(key);
        var prng = function() {
          var n2 = arc4.g(chunks), d2 = startdenom, x2 = 0;
          while (n2 < significance) {
            n2 = (n2 + x2) * width;
            d2 *= width;
            x2 = arc4.g(1);
          }
          while (n2 >= overflow) {
            n2 /= 2;
            d2 /= 2;
            x2 >>>= 1;
          }
          return (n2 + x2) / d2;
        };
        prng.int32 = function() {
          return arc4.g(4) | 0;
        };
        prng.quick = function() {
          return arc4.g(4) / 4294967296;
        };
        prng.double = prng;
        mixkey(tostring(arc4.S), pool);
        return (options2.pass || callback || function(prng2, seed2, is_math_call, state) {
          if (state) {
            if (state.S) {
              copy2(state, arc4);
            }
            prng2.state = function() {
              return copy2(arc4, {});
            };
          }
          if (is_math_call) {
            math2[rngname] = prng2;
            return seed2;
          } else return prng2;
        })(
          prng,
          shortseed,
          "global" in options2 ? options2.global : this == math2,
          options2.state
        );
      }
      function ARC4(key) {
        var t4, keylen = key.length, me2 = this, i2 = 0, j2 = me2.i = me2.j = 0, s2 = me2.S = [];
        if (!keylen) {
          key = [keylen++];
        }
        while (i2 < width) {
          s2[i2] = i2++;
        }
        for (i2 = 0; i2 < width; i2++) {
          s2[i2] = s2[j2 = mask & j2 + key[i2 % keylen] + (t4 = s2[i2])];
          s2[j2] = t4;
        }
        (me2.g = function(count) {
          var t5, r2 = 0, i3 = me2.i, j3 = me2.j, s3 = me2.S;
          while (count--) {
            t5 = s3[i3 = mask & i3 + 1];
            r2 = r2 * width + s3[mask & (s3[i3] = s3[j3 = mask & j3 + t5]) + (s3[j3] = t5)];
          }
          me2.i = i3;
          me2.j = j3;
          return r2;
        })(width);
      }
      function copy2(f2, t4) {
        t4.i = f2.i;
        t4.j = f2.j;
        t4.S = f2.S.slice();
        return t4;
      }
      function flatten2(obj, depth) {
        var result2 = [], typ = typeof obj, prop;
        if (depth && typ == "object") {
          for (prop in obj) {
            try {
              result2.push(flatten2(obj[prop], depth - 1));
            } catch (e2) {
            }
          }
        }
        return result2.length ? result2 : typ == "string" ? obj : obj + "\0";
      }
      function mixkey(seed, key) {
        var stringseed = seed + "", smear, j2 = 0;
        while (j2 < stringseed.length) {
          key[mask & j2] = mask & (smear ^= key[mask & j2] * 19) + stringseed.charCodeAt(j2++);
        }
        return tostring(key);
      }
      function autoseed() {
        try {
          var out;
          if (nodecrypto && (out = nodecrypto.randomBytes)) {
            out = out(width);
          } else {
            out = new Uint8Array(width);
            (global2.crypto || global2.msCrypto).getRandomValues(out);
          }
          return tostring(out);
        } catch (e2) {
          var browser2 = global2.navigator, plugins2 = browser2 && browser2.plugins;
          return [+/* @__PURE__ */ new Date(), global2, plugins2, global2.screen, tostring(pool)];
        }
      }
      function tostring(a2) {
        return String.fromCharCode.apply(0, a2);
      }
      mixkey(math2.random(), pool);
      if (module.exports) {
        module.exports = seedrandom2;
        try {
          nodecrypto = require$$0;
        } catch (ex) {
        }
      } else {
        math2["seed" + rngname] = seedrandom2;
      }
    })(
      // global: `self` in browsers (including strict mode and web workers),
      // otherwise `this` in Node and other environments
      typeof self !== "undefined" ? self : seedrandom$3,
      [],
      // pool: entropy pool starts empty
      Math
      // math: package containing random, pow, and seedrandom
    );
  })(seedrandom$4);
  return seedrandom$4.exports;
}
var seedrandom$2;
var hasRequiredSeedrandom;
function requireSeedrandom() {
  if (hasRequiredSeedrandom) return seedrandom$2;
  hasRequiredSeedrandom = 1;
  var alea2 = requireAlea();
  var xor1282 = requireXor128();
  var xorwow2 = requireXorwow();
  var xorshift72 = requireXorshift7();
  var xor40962 = requireXor4096();
  var tychei2 = requireTychei();
  var sr2 = requireSeedrandom$1();
  sr2.alea = alea2;
  sr2.xor128 = xor1282;
  sr2.xorwow = xorwow2;
  sr2.xorshift7 = xorshift72;
  sr2.xor4096 = xor40962;
  sr2.tychei = tychei2;
  seedrandom$2 = sr2;
  return seedrandom$2;
}
var seedrandomExports = requireSeedrandom();
const seedrandom$1 = /* @__PURE__ */ getDefaultExportFromCjs$5(seedrandomExports);
const __variableDynamicImportRuntimeHelper = (glob$1, path$13, segs) => {
  const v2 = glob$1[path$13];
  if (v2) return typeof v2 === "function" ? v2() : Promise.resolve(v2);
  return new Promise((_2, reject2) => {
    (typeof queueMicrotask === "function" ? queueMicrotask : setTimeout)(reject2.bind(null, /* @__PURE__ */ new Error("Unknown variable dynamic import: " + path$13 + (path$13.split("/").length !== segs ? ". Note that variables only represent file names one level deep." : ""))));
  });
};
let urlAlphabet$1 = "useandom-26T198340PX75pxJACKVERYMINDBUSHWOLF_GQZbfghjklqvwyzrict";
let nanoid$1 = (size2 = 21) => {
  let id2 = "";
  let bytes = crypto.getRandomValues(new Uint8Array(size2 |= 0));
  while (size2--) {
    id2 += urlAlphabet$1[bytes[size2] & 63];
  }
  return id2;
};
var commonjsGlobal$2 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$4(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var colorName$1$2;
var hasRequiredColorName$2;
function requireColorName$2() {
  if (hasRequiredColorName$2) return colorName$1$2;
  hasRequiredColorName$2 = 1;
  colorName$1$2 = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  return colorName$1$2;
}
var colorNameExports$2 = requireColorName$2();
const colorName$3 = /* @__PURE__ */ getDefaultExportFromCjs$4(colorNameExports$2);
var nearestColor$2$2 = { exports: {} };
var nearestColor$1$2 = nearestColor$2$2.exports;
var hasRequiredNearestColor$2;
function requireNearestColor$2() {
  if (hasRequiredNearestColor$2) return nearestColor$2$2.exports;
  hasRequiredNearestColor$2 = 1;
  (function(module) {
    (function(context) {
      function nearestColor2(needle, colors) {
        needle = parseColor(needle);
        if (!needle) {
          return null;
        }
        var distanceSq, minDistanceSq = Infinity, rgb, value;
        colors || (colors = nearestColor2.DEFAULT_COLORS);
        for (var i2 = 0; i2 < colors.length; ++i2) {
          rgb = colors[i2].rgb;
          distanceSq = Math.pow(needle.r - rgb.r, 2) + Math.pow(needle.g - rgb.g, 2) + Math.pow(needle.b - rgb.b, 2);
          if (distanceSq < minDistanceSq) {
            minDistanceSq = distanceSq;
            value = colors[i2];
          }
        }
        if (value.name) {
          return {
            name: value.name,
            value: value.source,
            rgb: value.rgb,
            distance: Math.sqrt(minDistanceSq)
          };
        }
        return value.source;
      }
      nearestColor2.from = function from(availableColors) {
        var colors = mapColors(availableColors), nearestColorBase = nearestColor2;
        var matcher2 = function nearestColor3(hex) {
          return nearestColorBase(hex, colors);
        };
        matcher2.from = from;
        matcher2.or = function or2(alternateColors) {
          var extendedColors = colors.concat(mapColors(alternateColors));
          return nearestColor2.from(extendedColors);
        };
        return matcher2;
      };
      function mapColors(colors) {
        if (colors instanceof Array) {
          return colors.map(function(color) {
            return createColorSpec(color);
          });
        }
        return Object.keys(colors).map(function(name2) {
          return createColorSpec(colors[name2], name2);
        });
      }
      function parseColor(source) {
        var red, green, blue;
        if (typeof source === "object") {
          return source;
        }
        if (source in nearestColor2.STANDARD_COLORS) {
          return parseColor(nearestColor2.STANDARD_COLORS[source]);
        }
        var hexMatch = source.match(/^#?((?:[0-9a-f]{3}){1,2})$/i);
        if (hexMatch) {
          hexMatch = hexMatch[1];
          if (hexMatch.length === 3) {
            hexMatch = [
              hexMatch.charAt(0) + hexMatch.charAt(0),
              hexMatch.charAt(1) + hexMatch.charAt(1),
              hexMatch.charAt(2) + hexMatch.charAt(2)
            ];
          } else {
            hexMatch = [
              hexMatch.substring(0, 2),
              hexMatch.substring(2, 4),
              hexMatch.substring(4, 6)
            ];
          }
          red = parseInt(hexMatch[0], 16);
          green = parseInt(hexMatch[1], 16);
          blue = parseInt(hexMatch[2], 16);
          return { r: red, g: green, b: blue };
        }
        var rgbMatch = source.match(/^rgb\(\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\s*\)$/i);
        if (rgbMatch) {
          red = parseComponentValue(rgbMatch[1]);
          green = parseComponentValue(rgbMatch[2]);
          blue = parseComponentValue(rgbMatch[3]);
          return { r: red, g: green, b: blue };
        }
        throw Error('"' + source + '" is not a valid color');
      }
      function createColorSpec(input, name2) {
        var color = {};
        if (name2) {
          color.name = name2;
        }
        if (typeof input === "string") {
          color.source = input;
          color.rgb = parseColor(input);
        } else if (typeof input === "object") {
          if (input.source) {
            return createColorSpec(input.source, input.name);
          }
          color.rgb = input;
          color.source = rgbToHex(input);
        }
        return color;
      }
      function parseComponentValue(string2) {
        if (string2.charAt(string2.length - 1) === "%") {
          return Math.round(parseInt(string2, 10) * 255 / 100);
        }
        return Number(string2);
      }
      function rgbToHex(rgb) {
        return "#" + leadingZero(rgb.r.toString(16)) + leadingZero(rgb.g.toString(16)) + leadingZero(rgb.b.toString(16));
      }
      function leadingZero(value) {
        if (value.length === 1) {
          value = "0" + value;
        }
        return value;
      }
      nearestColor2.STANDARD_COLORS = {
        aqua: "#0ff",
        black: "#000",
        blue: "#00f",
        fuchsia: "#f0f",
        gray: "#808080",
        green: "#008000",
        lime: "#0f0",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        purple: "#800080",
        red: "#f00",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#fff",
        yellow: "#ff0"
      };
      nearestColor2.DEFAULT_COLORS = mapColors([
        "#f00",
        // r
        "#f80",
        // o
        "#ff0",
        // y
        "#0f0",
        // g
        "#00f",
        // b
        "#008",
        // i
        "#808"
        // v
      ]);
      nearestColor2.VERSION = "0.4.4";
      if (module && module.exports) {
        module.exports = nearestColor2;
      } else {
        context.nearestColor = nearestColor2;
      }
    })(nearestColor$1$2);
  })(nearestColor$2$2);
  return nearestColor$2$2.exports;
}
var nearestColorExports$2 = requireNearestColor$2();
const nearestColor$4 = /* @__PURE__ */ getDefaultExportFromCjs$4(nearestColorExports$2);
const canonicalColorHexByKey$2 = {
  black: "#000000",
  white: "#ffffff",
  gray: "#808080",
  red: "#ff0000",
  orange: "#ffa500",
  yellow: "#ffff00",
  green: "#008000",
  cyan: "#00ffff",
  blue: "#0000ff",
  purple: "#800080",
  pink: "#ffc0cb",
  brown: "#a52a2a"
};
const canonicalAnchorDefinitions$2 = Object.fromEntries(
  Object.entries(canonicalColorHexByKey$2).map(([canonical, hex]) => [
    canonical,
    { hex, canonical }
  ])
);
const extraAnchorDefinitions$2 = {
  silver: { hex: "#c0c0c0", canonical: "gray" },
  grayDark: { hex: "#4d4d4d", canonical: "gray" },
  grayCustom: { hex: "#757575", canonical: "gray" },
  grayLight: { hex: "#c8c8c8", canonical: "gray" },
  grayLighter: { hex: "#dcdcdc", canonical: "gray" },
  maroon: { hex: "#800000", canonical: "red" },
  redLight: { hex: "#f08080", canonical: "red" },
  redCustom: { hex: "#D4042D", canonical: "red" },
  redDark: { hex: "#8b0000", canonical: "red" },
  orangeLight: { hex: "#ffa07a", canonical: "orange" },
  orangeCustom: { hex: "#F19143", canonical: "orange" },
  orangePresetAccessible: { hex: "#a6510c", canonical: "orange" },
  orangeDark: { hex: "#ff8c00", canonical: "orange" },
  yellowLight: { hex: "#ffffe0", canonical: "yellow" },
  yellowDark: { hex: "#bdb76b", canonical: "yellow" },
  yellowgreen: { hex: "#9acd32", canonical: "green" },
  olive: { hex: "#808000", canonical: "green" },
  lime: { hex: "#00ff00", canonical: "green" },
  greenLight: { hex: "#90ee90", canonical: "green" },
  greenCustom: { hex: "#2ca02c", canonical: "green" },
  greenDark: { hex: "#006400", canonical: "green" },
  teal: { hex: "#008080", canonical: "green" },
  aqua: { hex: "#00ffff", canonical: "cyan" },
  cyanLight: { hex: "#e0ffff", canonical: "cyan" },
  cyanDark: { hex: "#008b8b", canonical: "cyan" },
  navy: { hex: "#000080", canonical: "blue" },
  blueCustom: { hex: "#648FFF", canonical: "blue" },
  bluePresetAccessible: { hex: "#1f5dff", canonical: "blue" },
  blueLight: { hex: "#add8e6", canonical: "blue" },
  blueDark: { hex: "#00008b", canonical: "blue" },
  fuchsia: { hex: "#ff00ff", canonical: "purple" },
  purpleCustom: { hex: "#644CD6", canonical: "purple" },
  purpleLight: { hex: "#dda0dd", canonical: "purple" },
  purpleDark: { hex: "#8b008b", canonical: "purple" },
  hotpink: { hex: "#ff69b4", canonical: "pink" },
  pinkDark: { hex: "#ff1493", canonical: "pink" },
  brownLight: { hex: "#deb887", canonical: "brown" },
  brownDark: { hex: "#8b4513", canonical: "brown" }
};
const anchorDefinitions$2 = {
  ...canonicalAnchorDefinitions$2,
  ...extraAnchorDefinitions$2
};
const matchColorHexByName$2 = Object.fromEntries(
  Object.entries(anchorDefinitions$2).map(([name2, definition2]) => [
    name2,
    definition2.hex
  ])
);
Object.fromEntries(
  Object.entries(anchorDefinitions$2).map(([name2, definition2]) => [
    name2,
    definition2.canonical
  ])
);
nearestColor$4.from(matchColorHexByName$2);
/* @__PURE__ */ new Set([
  ...Object.keys(colorName$3),
  "transparent",
  "currentcolor"
]);
function bytesToHex(bytes) {
  return Array.from(bytes, (byte) => byte.toString(16).padStart(2, "0")).join(
    ""
  );
}
function encodeFillPatternColorToken(color) {
  return bytesToHex(new TextEncoder().encode(color.trim()));
}
var r$2 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$1$2 = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, n$2 = function(r2, t24, n2) {
  return void 0 === t24 && (t24 = 0), void 0 === n2 && (n2 = Math.pow(10, t24)), Math.round(n2 * r2) / n2 + 0;
}, e$4 = function(r2, t24, n2) {
  return void 0 === t24 && (t24 = 0), void 0 === n2 && (n2 = 1), r2 > n2 ? n2 : r2 > t24 ? r2 : t24;
}, u$2 = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
}, a$2 = function(r2) {
  return { r: e$4(r2.r, 0, 255), g: e$4(r2.g, 0, 255), b: e$4(r2.b, 0, 255), a: e$4(r2.a) };
}, o$1$2 = function(r2) {
  return { r: n$2(r2.r), g: n$2(r2.g), b: n$2(r2.b), a: n$2(r2.a, 3) };
}, i$3 = /^#([0-9a-f]{3,8})$/i, s$2 = function(r2) {
  var t24 = r2.toString(16);
  return t24.length < 2 ? "0" + t24 : t24;
}, h$2 = function(r2) {
  var t24 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a2 = Math.max(t24, n2, e2), o2 = a2 - Math.min(t24, n2, e2), i2 = o2 ? a2 === t24 ? (n2 - e2) / o2 : a2 === n2 ? 2 + (e2 - t24) / o2 : 4 + (t24 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a2 ? o2 / a2 * 100 : 0, v: a2 / 255 * 100, a: u2 };
}, b$3 = function(r2) {
  var t24 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t24 = t24 / 360 * 6, n2 /= 100, e2 /= 100;
  var a2 = Math.floor(t24), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t24 - a2) * n2), s2 = e2 * (1 - (1 - t24 + a2) * n2), h2 = a2 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
}, g$3 = function(r2) {
  return { h: u$2(r2.h), s: e$4(r2.s, 0, 100), l: e$4(r2.l, 0, 100), a: e$4(r2.a) };
}, d$2 = function(r2) {
  return { h: n$2(r2.h), s: n$2(r2.s), l: n$2(r2.l), a: n$2(r2.a, 3) };
}, f$4 = function(r2) {
  return b$3((n2 = (t24 = r2).s, { h: t24.h, s: (n2 *= ((e2 = t24.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t24.a }));
  var t24, n2, e2;
}, c$2 = function(r2) {
  return { h: (t24 = h$2(r2)).h, s: (u2 = (200 - (n2 = t24.s)) * (e2 = t24.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t24.a };
  var t24, n2, e2, u2;
}, l$2 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p$2 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$3 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m$2 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y$3 = { string: [[function(r2) {
  var t24 = i$3.exec(r2);
  return t24 ? (r2 = t24[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: 4 === r2.length ? n$2(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : 6 === r2.length || 8 === r2.length ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: 8 === r2.length ? n$2(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t24 = v$3.exec(r2) || m$2.exec(r2);
  return t24 ? t24[2] !== t24[4] || t24[4] !== t24[6] ? null : a$2({ r: Number(t24[1]) / (t24[2] ? 100 / 255 : 1), g: Number(t24[3]) / (t24[4] ? 100 / 255 : 1), b: Number(t24[5]) / (t24[6] ? 100 / 255 : 1), a: void 0 === t24[7] ? 1 : Number(t24[7]) / (t24[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t24) {
  var n2 = l$2.exec(t24) || p$2.exec(t24);
  if (!n2) return null;
  var e2, u2, a2 = g$3({ h: (e2 = n2[1], u2 = n2[2], void 0 === u2 && (u2 = "deg"), Number(e2) * (r$2[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: void 0 === n2[5] ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f$4(a2);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = void 0 === o2 ? 1 : o2;
  return t$1$2(n2) && t$1$2(e2) && t$1$2(u2) ? a$2({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a2 = r2.a, o2 = void 0 === a2 ? 1 : a2;
  if (!t$1$2(n2) || !t$1$2(e2) || !t$1$2(u2)) return null;
  var i2 = g$3({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f$4(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a2 = r2.s, o2 = r2.v, i2 = r2.a, s2 = void 0 === i2 ? 1 : i2;
  if (!t$1$2(n2) || !t$1$2(a2) || !t$1$2(o2)) return null;
  var h2 = (function(r3) {
    return { h: u$2(r3.h), s: e$4(r3.s, 0, 100), v: e$4(r3.v, 0, 100), a: e$4(r3.a) };
  })({ h: Number(n2), s: Number(a2), v: Number(o2), a: Number(s2) });
  return b$3(h2);
}, "hsv"]] }, N$3 = function(r2, t24) {
  for (var n2 = 0; n2 < t24.length; n2++) {
    var e2 = t24[n2][0](r2);
    if (e2) return [e2, t24[n2][1]];
  }
  return [null, void 0];
}, x$3 = function(r2) {
  return "string" == typeof r2 ? N$3(r2.trim(), y$3.string) : "object" == typeof r2 && null !== r2 ? N$3(r2, y$3.object) : [null, void 0];
}, M$3 = function(r2, t24) {
  var n2 = c$2(r2);
  return { h: n2.h, s: e$4(n2.s + 100 * t24, 0, 100), l: n2.l, a: n2.a };
}, H$3 = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
}, $$3 = function(r2, t24) {
  var n2 = c$2(r2);
  return { h: n2.h, s: n2.s, l: e$4(n2.l + 100 * t24, 0, 100), a: n2.a };
}, j$3 = (function() {
  function r2(r3) {
    this.parsed = x$3(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return null !== this.parsed;
  }, r2.prototype.brightness = function() {
    return n$2(H$3(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H$3(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H$3(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o$1$2(this.rgba), t24 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a2 = r3.a) < 1 ? s$2(n$2(255 * a2)) : "", "#" + s$2(t24) + s$2(e2) + s$2(u2) + i2;
    var r3, t24, e2, u2, a2, i2;
  }, r2.prototype.toRgb = function() {
    return o$1$2(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o$1$2(this.rgba), t24 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t24 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t24 + ", " + n2 + ", " + e2 + ")";
    var r3, t24, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d$2(c$2(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d$2(c$2(this.rgba)), t24 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t24 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t24 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t24, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h$2(this.rgba), { h: n$2(r3.h), s: n$2(r3.s), v: n$2(r3.v), a: n$2(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w$2({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$2(M$3(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$2(M$3(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w$2(M$3(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$2($$3(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$2($$3(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return void 0 === r3 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return "number" == typeof r3 ? w$2({ r: (t24 = this.rgba).r, g: t24.g, b: t24.b, a: r3 }) : n$2(this.rgba.a, 3);
    var t24;
  }, r2.prototype.hue = function(r3) {
    var t24 = c$2(this.rgba);
    return "number" == typeof r3 ? w$2({ h: r3, s: t24.s, l: t24.l, a: t24.a }) : n$2(t24.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w$2(r3).toHex();
  }, r2;
})(), w$2 = function(r2) {
  return r2 instanceof j$3 ? r2 : new j$3(r2);
}, S$3 = [], k$3 = function(r2) {
  r2.forEach(function(r3) {
    S$3.indexOf(r3) < 0 && (r3(j$3, y$3), S$3.push(r3));
  });
};
var o$3 = function(o2) {
  var t24 = o2 / 255;
  return t24 < 0.04045 ? t24 / 12.92 : Math.pow((t24 + 0.055) / 1.055, 2.4);
}, t$4 = function(t24) {
  return 0.2126 * o$3(t24.r) + 0.7152 * o$3(t24.g) + 0.0722 * o$3(t24.b);
};
function a11yPlugin$2(o2) {
  o2.prototype.luminance = function() {
    return o3 = t$4(this.rgba), void 0 === (r2 = 2) && (r2 = 0), void 0 === n2 && (n2 = Math.pow(10, r2)), Math.round(n2 * o3) / n2 + 0;
    var o3, r2, n2;
  }, o2.prototype.contrast = function(r2) {
    void 0 === r2 && (r2 = "#FFF");
    var n2, a2, i2, e2, v2, u2, d2, c2 = r2 instanceof o2 ? r2 : new o2(r2);
    return e2 = this.rgba, v2 = c2.toRgb(), u2 = t$4(e2), d2 = t$4(v2), n2 = u2 > d2 ? (u2 + 0.05) / (d2 + 0.05) : (d2 + 0.05) / (u2 + 0.05), void 0 === (a2 = 2) && (a2 = 0), void 0 === i2 && (i2 = Math.pow(10, a2)), Math.floor(i2 * n2) / i2 + 0;
  }, o2.prototype.isReadable = function(o3, t24) {
    return void 0 === o3 && (o3 = "#FFF"), void 0 === t24 && (t24 = {}), this.contrast(o3) >= (e2 = void 0 === (i2 = (r2 = t24).size) ? "normal" : i2, "AAA" === (a2 = void 0 === (n2 = r2.level) ? "AA" : n2) && "normal" === e2 ? 7 : "AA" === a2 && "large" === e2 ? 3 : 4.5);
    var r2, n2, a2, i2, e2;
  };
}
function namesPlugin$2(e2, f2) {
  var a2 = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r2 = {};
  for (var d2 in a2) r2[a2[d2]] = d2;
  var l2 = {};
  e2.prototype.toName = function(f3) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var d3, i2, n2 = r2[this.toHex()];
    if (n2) return n2;
    if (null == f3 ? void 0 : f3.closest) {
      var o2 = this.toRgb(), t24 = 1 / 0, b2 = "black";
      if (!l2.length) for (var c2 in a2) l2[c2] = new e2(a2[c2]).toRgb();
      for (var g2 in a2) {
        var u2 = (d3 = o2, i2 = l2[g2], Math.pow(d3.r - i2.r, 2) + Math.pow(d3.g - i2.g, 2) + Math.pow(d3.b - i2.b, 2));
        u2 < t24 && (t24 = u2, b2 = g2);
      }
      return b2;
    }
  };
  f2.string.push([function(f3) {
    var r3 = f3.toLowerCase(), d3 = "transparent" === r3 ? "#0000" : a2[r3];
    return d3 ? new e2(d3).toRgb() : null;
  }, "name"]);
}
k$3([a11yPlugin$2, namesPlugin$2]);
const CANVAS_DARK_MODE_COLOR = "#121212";
let styleAttributes$2 = {
  lineColor: {
    componentType: "text",
    description: "Color used for line strokes (light mode)."
  },
  lineColorWord: {
    componentType: "text",
    description: "Human-readable name of the line color (light mode)."
  },
  lineColorDarkMode: {
    componentType: "text",
    description: "Color used for line strokes (dark mode)."
  },
  lineColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the line color (dark mode)."
  },
  lineOpacity: {
    componentType: "number",
    description: "Opacity of line strokes, 0 to 1."
  },
  lineWidth: {
    componentType: "number",
    description: "Stroke width for lines, in pixels."
  },
  lineWidthWord: {
    componentType: "text",
    description: "Human-readable name of the line width."
  },
  lineStyle: {
    componentType: "text",
    description: "Stroke style for lines.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Continuous, unbroken stroke." },
      {
        value: "dashed",
        description: "Stroke composed of evenly-spaced dashes."
      },
      {
        value: "dotted",
        description: "Stroke composed of evenly-spaced dots."
      }
    ]
  },
  lineStyleWord: {
    componentType: "text",
    description: "Human-readable name of the line style."
  },
  markerColor: {
    componentType: "text",
    description: "Color used for markers/points (light mode)."
  },
  markerColorWord: {
    componentType: "text",
    description: "Human-readable name of the marker color (light mode)."
  },
  markerColorDarkMode: {
    componentType: "text",
    description: "Color used for markers/points (dark mode)."
  },
  markerColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the marker color (dark mode)."
  },
  markerOpacity: {
    componentType: "number",
    description: "Opacity of markers/points, 0 to 1."
  },
  markerStyle: {
    componentType: "text",
    description: "Marker shape.",
    toLowerCase: true,
    validValues: [
      { value: "circle", description: "Circular marker." },
      { value: "square", description: "Square marker." },
      {
        value: "triangle",
        description: 'Triangular marker pointing up (alias for "triangleUp").'
      },
      {
        value: "triangleUp",
        description: "Triangular marker pointing up."
      },
      {
        value: "triangleDown",
        description: "Triangular marker pointing down."
      },
      {
        value: "triangleLeft",
        description: "Triangular marker pointing left."
      },
      {
        value: "triangleRight",
        description: "Triangular marker pointing right."
      },
      { value: "diamond", description: "Diamond-shaped marker." },
      { value: "cross", description: "Cross-shaped marker (×)." },
      { value: "plus", description: "Plus-shaped marker (+)." }
    ]
  },
  markerStyleWord: {
    componentType: "text",
    description: "Human-readable name of the marker style."
  },
  markerSize: {
    componentType: "number",
    description: "Marker size in pixels."
  },
  markerFilled: {
    componentType: "boolean",
    description: "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."
  },
  fillColor: {
    componentType: "text",
    description: "Fill color used inside closed shapes (light mode)."
  },
  fillColorWord: {
    componentType: "text",
    description: "Human-readable name of the fill color (light mode)."
  },
  fillColorDarkMode: {
    componentType: "text",
    description: "Fill color used inside closed shapes (dark mode)."
  },
  fillColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the fill color (dark mode)."
  },
  fillOpacity: {
    componentType: "number",
    description: "Opacity of solid fills, 0 to 1."
  },
  fillPatternOpacity: {
    componentType: "number",
    description: "Opacity of pattern fills (non-solid fillStyle), 0 to 1."
  },
  fillStyle: {
    componentType: "text",
    description: "Fill pattern used inside closed shapes.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Solid fill." },
      {
        value: "horizontal",
        description: "Horizontal line pattern."
      },
      {
        value: "vertical",
        description: "Vertical line pattern."
      },
      {
        value: "diagonal",
        description: "Diagonal line pattern (/)."
      },
      {
        value: "backDiagonal",
        description: "Back-diagonal line pattern (\\)."
      },
      {
        value: "dots",
        description: "Dots pattern."
      },
      {
        value: "diamonds",
        description: "Filled diamonds pattern."
      }
    ]
  },
  fillStyleWord: {
    componentType: "text",
    description: "Human-readable name of the fill style."
  },
  textColor: {
    componentType: "text",
    description: "Text color (light mode)."
  },
  textColorWord: {
    componentType: "text",
    description: "Human-readable name of the text color (light mode)."
  },
  textColorDarkMode: {
    componentType: "text",
    description: "Text color (dark mode)."
  },
  textColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the text color (dark mode)."
  },
  highContrastColor: {
    componentType: "text",
    description: "High-contrast accent color (light mode)."
  },
  highContrastColorWord: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (light mode)."
  },
  highContrastColorDarkMode: {
    componentType: "text",
    description: "High-contrast accent color (dark mode)."
  },
  highContrastColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (dark mode)."
  },
  backgroundColor: {
    componentType: "text",
    description: "Background color (light mode)."
  },
  backgroundColorWord: {
    componentType: "text",
    description: "Human-readable name of the background color (light mode)."
  },
  backgroundColorDarkMode: {
    componentType: "text",
    description: "Background color (dark mode)."
  },
  backgroundColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the background color (dark mode)."
  }
};
styleAttributes$2.markerStyle.validValues.filter(
  (entry) => entry.value !== "cross" && entry.value !== "plus"
);
const MARKER_OVERRIDE_KEYS$2 = [
  "markerStyle",
  "markerSize",
  "markerFilled"
];
const LINE_OVERRIDE_KEYS$2 = [
  "lineStyle",
  "lineWidth"
];
const FILL_OVERRIDE_KEYS$2 = [
  "fillOpacity",
  "fillPatternOpacity",
  "fillStyle"
];
const markerOverrideAttributes$2 = Object.fromEntries(
  MARKER_OVERRIDE_KEYS$2.map((key) => [key, styleAttributes$2[key]])
);
const lineOverrideAttributes$2 = Object.fromEntries(
  LINE_OVERRIDE_KEYS$2.map((key) => [key, styleAttributes$2[key]])
);
const fillOverrideAttributes$2 = Object.fromEntries(
  FILL_OVERRIDE_KEYS$2.map((key) => [key, styleAttributes$2[key]])
);
({
  ...markerOverrideAttributes$2,
  ...lineOverrideAttributes$2,
  ...fillOverrideAttributes$2
});
const STYLE_OVERRIDE_CATEGORIES$2 = {
  marker: markerOverrideAttributes$2,
  line: lineOverrideAttributes$2,
  fill: fillOverrideAttributes$2
};
for (const [category, group2] of Object.entries(STYLE_OVERRIDE_CATEGORIES$2)) {
  for (const [key, spec] of Object.entries(group2)) {
    if (key.toLowerCase().includes("color")) {
      throw new Error(
        `Style override category "${category}" contains color-related key "${key}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`
      );
    }
    if (key.endsWith("Opacity") && key !== "fillOpacity" && key !== "fillPatternOpacity") {
      throw new Error(
        `Style override category "${category}" contains contrast-feeding opacity key "${key}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`
      );
    }
    if (spec.componentType === "text" && !spec.toLowerCase) {
      throw new Error(
        `Style override key "${key}" in category "${category}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`
      );
    }
  }
}
function textRendererStyle(darkMode, selectedStyle) {
  let textColor = darkMode === "dark" ? selectedStyle.textColorDarkMode : selectedStyle.textColor;
  let backgroundColor = darkMode === "dark" ? selectedStyle.backgroundColorDarkMode : selectedStyle.backgroundColor;
  let style = {
    color: textColor
  };
  if (backgroundColor) {
    style.backgroundColor = backgroundColor;
  }
  return style;
}
var __create$2 = Object.create, __defProp$3 = Object.defineProperty, __getOwnPropDesc$2 = Object.getOwnPropertyDescriptor, __getOwnPropNames$2 = Object.getOwnPropertyNames, __getProtoOf$2 = Object.getPrototypeOf, __hasOwnProp$2 = Object.prototype.hasOwnProperty, __esmMin$2 = (t4, n2) => () => (t4 && (n2 = t4(t4 = 0)), n2), __commonJSMin$2 = (t4, n2) => () => (n2 || (t4((n2 = { exports: {} }).exports, n2), t4 = null), n2.exports), __exportAll$2 = (t4, n2) => {
  let r2 = {};
  for (var i2 in t4) __defProp$3(r2, i2, { get: t4[i2], enumerable: true });
  return __defProp$3(r2, Symbol.toStringTag, { value: `Module` }), r2;
}, __copyProps$2 = (t4, n2, r2, i2) => {
  if (n2 && typeof n2 == `object` || typeof n2 == `function`) for (var a2 = __getOwnPropNames$2(n2), o2 = 0, s2 = a2.length, c2; o2 < s2; o2++) c2 = a2[o2], !__hasOwnProp$2.call(t4, c2) && c2 !== r2 && __defProp$3(t4, c2, { get: ((t5) => n2[t5]).bind(null, c2), enumerable: !(i2 = __getOwnPropDesc$2(n2, c2)) || i2.enumerable });
  return t4;
}, __toESM$2 = (t4, n2, r2) => (r2 = t4 == null ? {} : __create$2(__getProtoOf$2(t4)), __copyProps$2(__defProp$3(r2, `default`, { value: t4, enumerable: true }), t4)), __toCommonJS$2 = (t4) => __hasOwnProp$2.call(t4, `module.exports`) ? t4[`module.exports`] : __copyProps$2(__defProp$3({}, `__esModule`, { value: true }), t4), get_tree$2 = function(t4) {
  if (t4 != null) return t4.tree === void 0 ? t4 : t4.tree;
};
function* subsets$2(t4, n2) {
  var r2 = t4.length;
  if (n2 === void 0 && (n2 = r2), n2 !== 0) {
    for (let n3 = 0; n3 < r2; n3++) yield [t4[n3]];
    if (n2 !== 1) for (let i2 = 0; i2 < r2; i2++) {
      let r3 = subsets$2(t4.slice(i2 + 1), n2 - 1);
      for (let n3 of r3) yield [t4[i2]].concat(n3);
    }
  }
}
var is_associative$1$2 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$5$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return flatten$5$2(t5);
  }), is_associative$1$2[r2]) {
    for (var a2 = [], o2 = 0; o2 < i2.length; o2++) Array.isArray(i2[o2]) && i2[o2][0] === r2 && i2[o2].length > 2 ? a2 = a2.concat(i2[o2].slice(1)) : a2.push(i2[o2]);
    i2 = a2;
  }
  return [r2].concat(i2);
}
var unflattenRight$2 = function(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenRight$2(t5);
  }), i2.length > 2 && is_associative$1$2[r2]) {
    for (var a2 = [r2, i2[0], void 0], o2 = a2, s2 = 1; s2 < i2.length - 1; s2++) o2[2] = [r2, i2[s2], void 0], o2 = o2[2];
    return o2[2] = i2[i2.length - 1], a2;
  }
  return [r2].concat(i2);
}, unflattenLeft$2 = function(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenLeft$2(t5);
  }), i2.length > 2 && is_associative$1$2[r2]) {
    for (var a2 = [r2, void 0, i2[i2.length - 1]], o2 = a2, s2 = i2.length - 2; s2 > 0; s2--) o2[1] = [r2, void 0, i2[s2]], o2 = o2[1];
    return o2[1] = i2[0], a2;
  }
  return [r2].concat(i2);
}, allChildren$2 = function(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return is_associative$1$2[n2] ? r2.reduce(function(t5, r3) {
    return Array.isArray(r3) && r3[0] === n2 ? t5.concat(allChildren$2(r3)) : t5.concat([r3]);
  }, []) : r2;
};
function _extends$5() {
  return _extends$5 = Object.assign ? Object.assign.bind() : function(t4) {
    for (var n2 = 1; n2 < arguments.length; n2++) {
      var r2 = arguments[n2];
      for (var i2 in r2) ({}).hasOwnProperty.call(r2, i2) && (t4[i2] = r2[i2]);
    }
    return t4;
  }, _extends$5.apply(null, arguments);
}
var DEFAULT_CONFIG$2 = { relTol: 1e-12, absTol: 1e-15, matrix: `Matrix`, number: `number`, numberFallback: `number`, precision: 64, predictable: false, randomSeed: null, legacySubset: false };
function getSafeProperty$2(t4, n2) {
  if (isSafeObjectProperty$2(t4, n2) || isSafeArrayProperty$2(t4, n2)) return t4[n2];
  throw isSafeMethod$2(t4, n2) ? Error(`Cannot access method "${n2}" as a property`) : t4 == null ? TypeError(`Cannot access property "${n2}": object is ${t4}`) : Error(`No access to property "` + n2 + `"`);
}
function setSafeProperty$2(t4, n2, r2) {
  if (isSafeObjectProperty$2(t4, n2) || isSafeArrayProperty$2(t4, n2)) return t4[n2] = r2, r2;
  throw Error(`No access to property "${n2}"`);
}
function isSafeObjectProperty$2(t4, n2) {
  return isPlainObject$6(t4) ? !(n2 in Object.prototype) : false;
}
function isSafeArrayProperty$2(t4, n2) {
  return Array.isArray(t4) ? typeof n2 == `number` || typeof n2 == `string` && isInteger$1$2(n2) || n2 === `length` : false;
}
function isInteger$1$2(t4) {
  return /^\d+$/.test(t4);
}
function getSafeMethod$2(t4, n2) {
  if (!isSafeMethod$2(t4, n2)) throw Error(`No access to method "` + n2 + `"`);
  return t4[n2];
}
function isSafeMethod$2(t4, n2) {
  return t4 == null || typeof t4[n2] != `function` || hasOwnProperty$1$4(t4, n2) && Object.getPrototypeOf && n2 in Object.getPrototypeOf(t4) ? false : safeNativeMethods$2.has(n2) ? true : !(n2 in Object.prototype || n2 in Function.prototype);
}
function isPlainObject$6(t4) {
  return typeof t4 == `object` && t4 && t4.constructor === Object;
}
var safeNativeMethods$2 = /* @__PURE__ */ new Set([`toString`, `valueOf`, `toLocaleString`]), ObjectWrappingMap$2 = class ObjectWrappingMap2 {
  constructor(t4) {
    this.wrappedObject = t4, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((t4) => this.has(t4)).values();
  }
  get(t4) {
    return getSafeProperty$2(this.wrappedObject, t4);
  }
  set(t4, n2) {
    return setSafeProperty$2(this.wrappedObject, t4, n2), this;
  }
  has(t4) {
    return isSafeObjectProperty$2(this.wrappedObject, t4) && t4 in this.wrappedObject;
  }
  entries() {
    return mapIterator$2(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    isSafeObjectProperty$2(this.wrappedObject, t4) && delete this.wrappedObject[t4];
  }
  clear() {
    for (var t4 of this.keys()) this.delete(t4);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}, PartitionedMap$2 = class PartitionedMap2 {
  constructor(t4, n2, r2) {
    this.a = t4, this.b = n2, this.bKeys = r2, this[Symbol.iterator] = this.entries;
  }
  get(t4) {
    return this.bKeys.has(t4) ? this.b.get(t4) : this.a.get(t4);
  }
  set(t4, n2) {
    return this.bKeys.has(t4) ? this.b.set(t4, n2) : this.a.set(t4, n2), this;
  }
  has(t4) {
    return this.b.has(t4) || this.a.has(t4);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator$2(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    return this.bKeys.has(t4) ? this.b.delete(t4) : this.a.delete(t4);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
};
function mapIterator$2(t4, n2) {
  return { next: () => {
    var r2 = t4.next();
    return r2.done ? r2 : { value: n2(r2.value), done: false };
  } };
}
function createEmptyMap$2() {
  return /* @__PURE__ */ new Map();
}
function createMap$1$2(t4) {
  if (!t4) return createEmptyMap$2();
  if (isMap$3(t4)) return t4;
  if (isObject$1$2(t4)) return new ObjectWrappingMap$2(t4);
  throw Error(`createMap can create maps from objects or Maps`);
}
function toObject$2(t4) {
  if (t4 instanceof ObjectWrappingMap$2) return t4.wrappedObject;
  var n2 = {};
  for (var r2 of t4.keys()) setSafeProperty$2(n2, r2, t4.get(r2));
  return n2;
}
function isNumber$2(t4) {
  return typeof t4 == `number`;
}
function isBigNumber$2(t4) {
  return !t4 || typeof t4 != `object` || typeof t4.constructor != `function` ? false : t4.isBigNumber === true && typeof t4.constructor.prototype == `object` && t4.constructor.prototype.isBigNumber === true || typeof t4.constructor.isDecimal == `function` && t4.constructor.isDecimal(t4) === true;
}
function isBigInt$2(t4) {
  return typeof t4 == `bigint`;
}
function isComplex$2(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isComplex === true || false;
}
function isFraction$2(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isFraction === true || false;
}
function isUnit$2(t4) {
  return t4 && t4.constructor.prototype.isUnit === true || false;
}
function isString$2(t4) {
  return typeof t4 == `string`;
}
var isArray$3 = Array.isArray;
function isMatrix$2(t4) {
  return t4 && t4.constructor.prototype.isMatrix === true || false;
}
function isCollection$2(t4) {
  return Array.isArray(t4) || isMatrix$2(t4);
}
function isDenseMatrix$2(t4) {
  return t4 && t4.isDenseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isSparseMatrix$2(t4) {
  return t4 && t4.isSparseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isRange$2(t4) {
  return t4 && t4.constructor.prototype.isRange === true || false;
}
function isIndex$2(t4) {
  return t4 && t4.constructor.prototype.isIndex === true || false;
}
function isBoolean$1$2(t4) {
  return typeof t4 == `boolean`;
}
function isResultSet$2(t4) {
  return t4 && t4.constructor.prototype.isResultSet === true || false;
}
function isHelp$2(t4) {
  return t4 && t4.constructor.prototype.isHelp === true || false;
}
function isFunction$1$2(t4) {
  return typeof t4 == `function`;
}
function isDate$3(t4) {
  return t4 instanceof Date;
}
function isRegExp$2(t4) {
  return t4 instanceof RegExp;
}
function isObject$1$2(t4) {
  return !!(t4 && typeof t4 == `object` && t4.constructor === Object && !isComplex$2(t4) && !isFraction$2(t4));
}
function isMap$3(t4) {
  return t4 ? t4 instanceof Map || t4 instanceof ObjectWrappingMap$2 || typeof t4.set == `function` && typeof t4.get == `function` && typeof t4.keys == `function` && typeof t4.has == `function` : false;
}
function isPartitionedMap$2(t4) {
  return isMap$3(t4) && isMap$3(t4.a) && isMap$3(t4.b);
}
function isObjectWrappingMap$2(t4) {
  return isMap$3(t4) && isObject$1$2(t4.wrappedObject);
}
function isNull$1$2(t4) {
  return t4 === null;
}
function isUndefined$1$2(t4) {
  return t4 === void 0;
}
function isAccessorNode$2(t4) {
  return t4 && t4.isAccessorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isArrayNode$2(t4) {
  return t4 && t4.isArrayNode === true && t4.constructor.prototype.isNode === true || false;
}
function isAssignmentNode$2(t4) {
  return t4 && t4.isAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isBlockNode$2(t4) {
  return t4 && t4.isBlockNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConditionalNode$2(t4) {
  return t4 && t4.isConditionalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConstantNode$2(t4) {
  return t4 && t4.isConstantNode === true && t4.constructor.prototype.isNode === true || false;
}
function rule2Node$2(t4) {
  return isConstantNode$2(t4) || isOperatorNode$2(t4) && t4.args.length === 1 && isConstantNode$2(t4.args[0]) && `-+~`.includes(t4.op);
}
function isFunctionAssignmentNode$2(t4) {
  return t4 && t4.isFunctionAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isFunctionNode$2(t4) {
  return t4 && t4.isFunctionNode === true && t4.constructor.prototype.isNode === true || false;
}
function isIndexNode$2(t4) {
  return t4 && t4.isIndexNode === true && t4.constructor.prototype.isNode === true || false;
}
function isNode$5(t4) {
  return t4 && t4.isNode === true && t4.constructor.prototype.isNode === true || false;
}
function isObjectNode$2(t4) {
  return t4 && t4.isObjectNode === true && t4.constructor.prototype.isNode === true || false;
}
function isOperatorNode$2(t4) {
  return t4 && t4.isOperatorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isParenthesisNode$2(t4) {
  return t4 && t4.isParenthesisNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRangeNode$2(t4) {
  return t4 && t4.isRangeNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRelationalNode$2(t4) {
  return t4 && t4.isRelationalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isSymbolNode$2(t4) {
  return t4 && t4.isSymbolNode === true && t4.constructor.prototype.isNode === true || false;
}
function isChain$2(t4) {
  return t4 && t4.constructor.prototype.isChain === true || false;
}
function typeOf$2(t4) {
  var n2 = typeof t4;
  return n2 === `object` ? t4 === null ? `null` : isBigNumber$2(t4) ? `BigNumber` : t4.constructor && t4.constructor.name ? t4.constructor.name : `Object` : n2;
}
function clone$3$2(t4) {
  var n2 = typeof t4;
  if (n2 === `number` || n2 === `bigint` || n2 === `string` || n2 === `boolean` || t4 == null) return t4;
  if (typeof t4.clone == `function`) return t4.clone();
  if (Array.isArray(t4)) return t4.map(function(t5) {
    return clone$3$2(t5);
  });
  if (t4 instanceof Date) return new Date(t4.valueOf());
  if (isBigNumber$2(t4)) return t4;
  if (isObject$1$2(t4)) return mapObject$1$2(t4, clone$3$2);
  if (n2 === `function`) return t4;
  throw TypeError(`Cannot clone: unknown type of value (value: ${t4})`);
}
function mapObject$1$2(t4, n2) {
  var r2 = {};
  for (var i2 in t4) hasOwnProperty$1$4(t4, i2) && (r2[i2] = n2(t4[i2]));
  return r2;
}
function extend$1$4(t4, n2) {
  for (var r2 in n2) hasOwnProperty$1$4(n2, r2) && (t4[r2] = n2[r2]);
  return t4;
}
function deepExtend$2(t4, n2) {
  if (Array.isArray(n2)) throw TypeError(`Arrays are not supported by deepExtend`);
  for (var r2 in n2) if (hasOwnProperty$1$4(n2, r2) && !(r2 in Object.prototype) && !(r2 in Function.prototype)) if (n2[r2] && n2[r2].constructor === Object) t4[r2] === void 0 && (t4[r2] = {}), t4[r2] && t4[r2].constructor === Object ? deepExtend$2(t4[r2], n2[r2]) : t4[r2] = n2[r2];
  else if (Array.isArray(n2[r2])) throw TypeError(`Arrays are not supported by deepExtend`);
  else t4[r2] = n2[r2];
  return t4;
}
function deepStrictEqual$2(t4, n2) {
  var r2, i2, a2;
  if (Array.isArray(t4)) {
    if (!Array.isArray(n2) || t4.length !== n2.length) return false;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) if (!deepStrictEqual$2(t4[i2], n2[i2])) return false;
    return true;
  } else if (typeof t4 == `function`) return t4 === n2;
  else if (t4 instanceof Object) {
    if (Array.isArray(n2) || !(n2 instanceof Object)) return false;
    for (r2 in t4) if (!(r2 in n2) || !deepStrictEqual$2(t4[r2], n2[r2])) return false;
    for (r2 in n2) if (!(r2 in t4)) return false;
    return true;
  } else return t4 === n2;
}
function deepFlatten$2(t4) {
  var n2 = {};
  return _deepFlatten$2(t4, n2), n2;
}
function _deepFlatten$2(t4, n2) {
  for (var r2 in t4) if (hasOwnProperty$1$4(t4, r2)) {
    var i2 = t4[r2];
    typeof i2 == `object` && i2 ? _deepFlatten$2(i2, n2) : n2[r2] = i2;
  }
}
function lazy$2(t4, n2, r2) {
  var i2 = true, a2;
  Object.defineProperty(t4, n2, { get: function() {
    return i2 &&= (a2 = r2(), false), a2;
  }, set: function(t5) {
    a2 = t5, i2 = false;
  }, configurable: true, enumerable: true });
}
function hasOwnProperty$1$4(t4, n2) {
  return t4 && Object.hasOwnProperty.call(t4, n2);
}
function isLegacyFactory$2(t4) {
  return t4 && typeof t4.factory == `function`;
}
function pickShallow$2(t4, n2) {
  for (var r2 = {}, i2 = 0; i2 < n2.length; i2++) {
    var a2 = n2[i2], o2 = t4[a2];
    o2 !== void 0 && (r2[a2] = o2);
  }
  return r2;
}
var MATRIX_OPTIONS$2 = [`Matrix`, `Array`], NUMBER_OPTIONS$2 = [`number`, `BigNumber`, `bigint`, `Fraction`];
function configFactory$2(t4, n2) {
  function r2(i2) {
    if (i2) {
      if (i2.epsilon !== void 0) {
        console.warn(`Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.`);
        var a2 = clone$3$2(i2);
        return a2.relTol = i2.epsilon, a2.absTol = i2.epsilon * 1e-3, delete a2.epsilon, r2(a2);
      }
      i2.legacySubset === true && console.warn(`Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.`);
      var o2 = clone$3$2(t4);
      validateOption$2(i2, `matrix`, MATRIX_OPTIONS$2), validateOption$2(i2, `number`, NUMBER_OPTIONS$2), deepExtend$2(t4, i2);
      var s2 = clone$3$2(t4);
      return n2(`config`, s2, o2, clone$3$2(i2)), s2;
    } else return clone$3$2(t4);
  }
  return r2.MATRIX_OPTIONS = MATRIX_OPTIONS$2, r2.NUMBER_OPTIONS = NUMBER_OPTIONS$2, Object.keys(DEFAULT_CONFIG$2).forEach((n3) => {
    Object.defineProperty(r2, n3, { get: () => t4[n3], enumerable: true, configurable: true });
  }), r2;
}
function validateOption$2(t4, n2, r2) {
  t4[n2] !== void 0 && !r2.includes(t4[n2]) && console.warn(`Warning: Unknown value "` + t4[n2] + `" for configuration option "` + n2 + `". Available options: ` + r2.map((t5) => JSON.stringify(t5)).join(`, `) + `.`);
}
var require_typed_function$2 = __commonJSMin$2(((t4, n2) => {
  (function(r2, i2) {
    typeof t4 == `object` && n2 !== void 0 ? n2.exports = i2() : typeof define == `function` && define.amd ? define(i2) : (r2 = typeof globalThis < `u` ? globalThis : r2 || self, r2[`'typed'`] = i2());
  })(t4, (function() {
    function t5() {
      return true;
    }
    function n3() {
      return false;
    }
    function r2() {
    }
    let i2 = `Argument is not a typed-function.`;
    function a2() {
      function o2(t6) {
        return typeof t6 == `object` && !!t6 && t6.constructor === Object;
      }
      let s2 = [{ name: `number`, test: function(t6) {
        return typeof t6 == `number`;
      } }, { name: `string`, test: function(t6) {
        return typeof t6 == `string`;
      } }, { name: `boolean`, test: function(t6) {
        return typeof t6 == `boolean`;
      } }, { name: `Function`, test: function(t6) {
        return typeof t6 == `function`;
      } }, { name: `Array`, test: Array.isArray }, { name: `Date`, test: function(t6) {
        return t6 instanceof Date;
      } }, { name: `RegExp`, test: function(t6) {
        return t6 instanceof RegExp;
      } }, { name: `Object`, test: o2 }, { name: `null`, test: function(t6) {
        return t6 === null;
      } }, { name: `undefined`, test: function(t6) {
        return t6 === void 0;
      } }], c2 = { name: `any`, test: t5, isAny: true }, l2, u2, d2 = 0, p2 = { createCount: 0 };
      function m2(t6) {
        let n4 = l2.get(t6);
        if (n4) return n4;
        let r3 = `Unknown type "` + t6 + `"`, i3 = t6.toLowerCase(), a3;
        for (a3 of u2) if (a3.toLowerCase() === i3) {
          r3 += `. Did you mean "` + a3 + `" ?`;
          break;
        }
        throw TypeError(r3);
      }
      function h2(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `any`, r3 = n4 ? m2(n4).index : u2.length, i3 = [];
        for (let n5 = 0; n5 < t6.length; ++n5) {
          if (!t6[n5] || typeof t6[n5].name != `string` || typeof t6[n5].test != `function`) throw TypeError(`Object with properties {name: string, test: function} expected`);
          let a4 = t6[n5].name;
          if (l2.has(a4)) throw TypeError(`Duplicate type name "` + a4 + `"`);
          i3.push(a4), l2.set(a4, { name: a4, test: t6[n5].test, isAny: t6[n5].isAny, index: r3 + n5, conversionsTo: [] });
        }
        let a3 = u2.slice(r3);
        u2 = u2.slice(0, r3).concat(i3).concat(a3);
        for (let t7 = r3 + i3.length; t7 < u2.length; ++t7) l2.get(u2[t7]).index = t7;
      }
      function g2() {
        l2 = /* @__PURE__ */ new Map(), u2 = [], d2 = 0, h2([c2], false);
      }
      g2(), h2(s2);
      function v2() {
        let t6;
        for (t6 of u2) l2.get(t6).conversionsTo = [];
        d2 = 0;
      }
      function y2(t6) {
        let n4 = u2.filter((n5) => {
          let r3 = l2.get(n5);
          return !r3.isAny && r3.test(t6);
        });
        return n4.length ? n4 : [`any`];
      }
      function b2(t6) {
        return t6 && typeof t6 == `function` && `_typedFunctionData` in t6;
      }
      function x2(t6, n4, r3) {
        if (!b2(t6)) throw TypeError(i2);
        let a3 = r3 && r3.exact, o3 = M2(Array.isArray(n4) ? n4.join(`,`) : n4), s3 = E(o3);
        if (!a3 || s3 in t6.signatures) {
          let n5 = t6._typedFunctionData.signatureMap.get(s3);
          if (n5) return n5;
        }
        let c3 = o3.length, l3;
        if (a3) {
          l3 = [];
          let n5;
          for (n5 in t6.signatures) l3.push(t6._typedFunctionData.signatureMap.get(n5));
        } else l3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < c3; ++t7) {
          let n5 = o3[t7], r4 = [], i3;
          for (i3 of l3) {
            let a4 = L2(i3.params, t7);
            if (!(!a4 || n5.restParam && !a4.restParam)) {
              if (!a4.hasAny) {
                let t8 = j2(a4);
                if (n5.types.some((n6) => !t8.has(n6.name))) continue;
              }
              r4.push(i3);
            }
          }
          if (l3 = r4, l3.length === 0) break;
        }
        let u3;
        for (u3 of l3) if (u3.params.length <= c3) return u3;
        throw TypeError(`Signature not found (signature: ` + (t6.name || `unnamed`) + `(` + E(o3, `, `) + `))`);
      }
      function S2(t6, n4, r3) {
        return x2(t6, n4, r3).implementation;
      }
      function w2(t6, n4) {
        let r3 = m2(n4);
        if (r3.test(t6)) return t6;
        let i3 = r3.conversionsTo;
        if (i3.length === 0) throw Error(`There are no conversions to ` + n4 + ` defined.`);
        for (let n5 = 0; n5 < i3.length; n5++) if (m2(i3[n5].from).test(t6)) return i3[n5].convert(t6);
        throw Error(`Cannot convert ` + t6 + ` to ` + n4);
      }
      function E(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `,`;
        return t6.map((t7) => t7.name).join(n4);
      }
      function D(t6) {
        let n4 = t6.indexOf(`...`) === 0, r3 = (n4 ? t6.length > 3 ? t6.slice(3) : `any` : t6).split(`|`).map((t7) => m2(t7.trim())), i3 = false, a3 = n4 ? `...` : ``;
        return { types: r3.map(function(t7) {
          return i3 = t7.isAny || i3, a3 += t7.name + `|`, { name: t7.name, typeIndex: t7.index, test: t7.test, isAny: t7.isAny, conversion: null, conversionIndex: -1 };
        }), name: a3.slice(0, -1), hasAny: i3, hasConversion: false, restParam: n4 };
      }
      function O2(t6) {
        let n4 = q2(t6.types.map((t7) => t7.name)), r3 = t6.hasAny, i3 = t6.name, a3 = n4.map(function(t7) {
          let n5 = m2(t7.from);
          return r3 = n5.isAny || r3, i3 += `|` + t7.from, { name: t7.from, typeIndex: n5.index, test: n5.test, isAny: n5.isAny, conversion: t7, conversionIndex: t7.index };
        });
        return { types: t6.types.concat(a3), name: i3, hasAny: r3, hasConversion: a3.length > 0, restParam: t6.restParam };
      }
      function j2(t6) {
        return t6.typeSet || (t6.typeSet = /* @__PURE__ */ new Set(), t6.types.forEach((n4) => t6.typeSet.add(n4.name))), t6.typeSet;
      }
      function M2(t6) {
        let n4 = [];
        if (typeof t6 != `string`) throw TypeError(`Signatures must be strings`);
        let r3 = t6.trim();
        if (r3 === ``) return n4;
        let i3 = r3.split(`,`);
        for (let t7 = 0; t7 < i3.length; ++t7) {
          let r4 = D(i3[t7].trim());
          if (r4.restParam && t7 !== i3.length - 1) throw SyntaxError(`Unexpected rest parameter "` + i3[t7] + `": only allowed for the last parameter`);
          if (r4.types.length === 0) return null;
          n4.push(r4);
        }
        return n4;
      }
      function N2(t6) {
        let n4 = se2(t6);
        return n4 ? n4.restParam : false;
      }
      function F(n4) {
        if (!n4 || n4.types.length === 0) return t5;
        if (n4.types.length === 1) return m2(n4.types[0].name).test;
        if (n4.types.length === 2) {
          let t6 = m2(n4.types[0].name).test, r3 = m2(n4.types[1].name).test;
          return function(n5) {
            return t6(n5) || r3(n5);
          };
        } else {
          let t6 = n4.types.map(function(t7) {
            return m2(t7.name).test;
          });
          return function(n5) {
            for (let r3 = 0; r3 < t6.length; r3++) if (t6[r3](n5)) return true;
            return false;
          };
        }
      }
      function I2(t6) {
        let n4, r3, i3;
        if (N2(t6)) {
          n4 = $2(t6).map(F);
          let r4 = n4.length, i4 = F(se2(t6)), a3 = function(t7) {
            for (let n5 = r4; n5 < t7.length; n5++) if (!i4(t7[n5])) return false;
            return true;
          };
          return function(t7) {
            for (let r5 = 0; r5 < n4.length; r5++) if (!n4[r5](t7[r5])) return false;
            return a3(t7) && t7.length >= r4 + 1;
          };
        } else if (t6.length === 0) return function(t7) {
          return t7.length === 0;
        };
        else if (t6.length === 1) return r3 = F(t6[0]), function(t7) {
          return r3(t7[0]) && t7.length === 1;
        };
        else if (t6.length === 2) return r3 = F(t6[0]), i3 = F(t6[1]), function(t7) {
          return r3(t7[0]) && i3(t7[1]) && t7.length === 2;
        };
        else return n4 = t6.map(F), function(t7) {
          for (let r4 = 0; r4 < n4.length; r4++) if (!n4[r4](t7[r4])) return false;
          return t7.length === n4.length;
        };
      }
      function L2(t6, n4) {
        return n4 < t6.length ? t6[n4] : N2(t6) ? se2(t6) : null;
      }
      function R2(t6, n4) {
        let r3 = L2(t6, n4);
        return r3 ? j2(r3) : /* @__PURE__ */ new Set();
      }
      function z2(t6) {
        return t6.conversion === null || t6.conversion === void 0;
      }
      function V2(t6, n4) {
        let r3 = /* @__PURE__ */ new Set();
        return t6.forEach((t7) => {
          let i3 = R2(t7.params, n4), a3;
          for (a3 of i3) r3.add(a3);
        }), r3.has(`any`) ? [`any`] : Array.from(r3);
      }
      function H2(t6, n4, r3) {
        let i3, a3, o3 = t6 || `unnamed`, s3 = r3, c3;
        for (c3 = 0; c3 < n4.length; c3++) {
          let t7 = [];
          if (s3.forEach((r4) => {
            let i4 = F(L2(r4.params, c3));
            (c3 < r4.params.length || N2(r4.params)) && i4(n4[c3]) && t7.push(r4);
          }), t7.length === 0) {
            if (a3 = V2(s3, c3), a3.length > 0) {
              let t8 = y2(n4[c3]);
              return i3 = TypeError(`Unexpected type of argument in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, actual: ` + t8.join(` | `) + `, index: ` + c3 + `)`), i3.data = { category: `wrongType`, fn: o3, index: c3, actual: t8, expected: a3 }, i3;
            }
          } else s3 = t7;
        }
        let l3 = s3.map(function(t7) {
          return N2(t7.params) ? 1 / 0 : t7.params.length;
        });
        if (n4.length < Math.min.apply(null, l3)) return a3 = V2(s3, c3), i3 = TypeError(`Too few arguments in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, index: ` + n4.length + `)`), i3.data = { category: `tooFewArgs`, fn: o3, index: n4.length, expected: a3 }, i3;
        let u3 = Math.max.apply(null, l3);
        if (n4.length > u3) return i3 = TypeError(`Too many arguments in function ` + o3 + ` (expected: ` + u3 + `, actual: ` + n4.length + `)`), i3.data = { category: `tooManyArgs`, fn: o3, index: n4.length, expectedLength: u3 }, i3;
        let d3 = [];
        for (let t7 = 0; t7 < n4.length; ++t7) d3.push(y2(n4[t7]).join(`|`));
        return i3 = TypeError(`Arguments of type "` + d3.join(`, `) + `" do not match any of the defined signatures of function ` + o3 + `.`), i3.data = { category: `mismatch`, actual: d3 }, i3;
      }
      function U2(t6) {
        let n4 = u2.length + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) && (n4 = Math.min(n4, t6.types[r3].typeIndex));
        return n4;
      }
      function W2(t6) {
        let n4 = d2 + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) || (n4 = Math.min(n4, t6.types[r3].conversionIndex));
        return n4;
      }
      function G2(t6, n4) {
        if (t6.hasAny) {
          if (!n4.hasAny) return 1;
        } else if (n4.hasAny) return -1;
        if (t6.restParam) {
          if (!n4.restParam) return 1;
        } else if (n4.restParam) return -1;
        if (t6.hasConversion) {
          if (!n4.hasConversion) return 1;
        } else if (n4.hasConversion) return -1;
        let r3 = U2(t6) - U2(n4);
        if (r3 < 0) return -1;
        if (r3 > 0) return 1;
        let i3 = W2(t6) - W2(n4);
        return i3 < 0 ? -1 : +(i3 > 0);
      }
      function K2(t6, n4) {
        let r3 = t6.params, i3 = n4.params, a3 = se2(r3), o3 = se2(i3), s3 = N2(r3), c3 = N2(i3);
        if (s3 && a3.hasAny) {
          if (!c3 || !o3.hasAny) return 1;
        } else if (c3 && o3.hasAny) return -1;
        let l3 = 0, u3 = 0, d3;
        for (d3 of r3) d3.hasAny && ++l3, d3.hasConversion && ++u3;
        let p3 = 0, m3 = 0;
        for (d3 of i3) d3.hasAny && ++p3, d3.hasConversion && ++m3;
        if (l3 !== p3) return l3 - p3;
        if (s3 && a3.hasConversion) {
          if (!c3 || !o3.hasConversion) return 1;
        } else if (c3 && o3.hasConversion) return -1;
        if (u3 !== m3) return u3 - m3;
        if (s3) {
          if (!c3) return 1;
        } else if (c3) return -1;
        let h3 = (r3.length - i3.length) * (s3 ? -1 : 1);
        if (h3 !== 0) return h3;
        let g3 = [], v3 = 0;
        for (let t7 = 0; t7 < r3.length; ++t7) {
          let n5 = G2(r3[t7], i3[t7]);
          g3.push(n5), v3 += n5;
        }
        if (v3 !== 0) return v3;
        let y3;
        for (y3 of g3) if (y3 !== 0) return y3;
        return 0;
      }
      function q2(t6) {
        if (t6.length === 0) return [];
        let n4 = t6.map(m2);
        t6.length > 1 && n4.sort((t7, n5) => t7.index - n5.index);
        let r3 = n4[0].conversionsTo;
        if (t6.length === 1) return r3;
        r3 = r3.concat([]);
        let i3 = new Set(t6);
        for (let t7 = 1; t7 < n4.length; ++t7) {
          let a3;
          for (a3 of n4[t7].conversionsTo) i3.has(a3.from) || (r3.push(a3), i3.add(a3.from));
        }
        return r3;
      }
      function J(t6, n4) {
        let r3 = n4;
        if (t6.some((t7) => t7.hasConversion)) {
          let i4 = N2(t6), a3 = t6.map(ee2);
          r3 = function() {
            let t7 = [], r4 = i4 ? arguments.length - 1 : arguments.length;
            for (let n5 = 0; n5 < r4; n5++) t7[n5] = a3[n5](arguments[n5]);
            return i4 && (t7[r4] = arguments[r4].map(a3[r4])), n4.apply(this, t7);
          };
        }
        let i3 = r3;
        if (N2(t6)) {
          let n5 = t6.length - 1;
          i3 = function() {
            return r3.apply(this, ce2(arguments, 0, n5).concat([ce2(arguments, n5)]));
          };
        }
        return i3;
      }
      function ee2(t6) {
        let n4, r3, i3, a3, o3 = [], s3 = [];
        switch (t6.types.forEach(function(t7) {
          t7.conversion && (o3.push(m2(t7.conversion.from).test), s3.push(t7.conversion.convert));
        }), s3.length) {
          case 0:
            return function(t7) {
              return t7;
            };
          case 1:
            return n4 = o3[0], i3 = s3[0], function(t7) {
              return n4(t7) ? i3(t7) : t7;
            };
          case 2:
            return n4 = o3[0], r3 = o3[1], i3 = s3[0], a3 = s3[1], function(t7) {
              return n4(t7) ? i3(t7) : r3(t7) ? a3(t7) : t7;
            };
          default:
            return function(t7) {
              for (let n5 = 0; n5 < s3.length; n5++) if (o3[n5](t7)) return s3[n5](t7);
              return t7;
            };
        }
      }
      function Y2(t6) {
        function n4(t7, r3, i3) {
          if (r3 < t7.length) {
            let a3 = t7[r3], o3 = [];
            if (a3.restParam) {
              let t8 = a3.types.filter(z2);
              t8.length < a3.types.length && o3.push({ types: t8, name: `...` + t8.map((t9) => t9.name).join(`|`), hasAny: t8.some((t9) => t9.isAny), hasConversion: false, restParam: true }), o3.push(a3);
            } else o3 = a3.types.map(function(t8) {
              return { types: [t8], name: t8.name, hasAny: t8.isAny, hasConversion: t8.conversion, restParam: false };
            });
            return ue2(o3, function(a4) {
              return n4(t7, r3 + 1, i3.concat([a4]));
            });
          } else return [i3];
        }
        return n4(t6, 0, []);
      }
      function te2(t6, n4) {
        let r3 = Math.max(t6.length, n4.length);
        for (let i4 = 0; i4 < r3; i4++) {
          let r4 = R2(t6, i4), a4 = R2(n4, i4), o4 = false, s4;
          for (s4 of a4) if (r4.has(s4)) {
            o4 = true;
            break;
          }
          if (!o4) return false;
        }
        let i3 = t6.length, a3 = n4.length, o3 = N2(t6), s3 = N2(n4);
        return o3 ? s3 ? i3 === a3 : a3 >= i3 : s3 ? i3 >= a3 : i3 === a3;
      }
      function ne2(t6) {
        return t6.map((t7) => he2(t7) ? pe2(t7.referToSelf.callback) : me2(t7) ? fe2(t7.referTo.references, t7.referTo.callback) : t7);
      }
      function X2(t6, n4, r3) {
        let i3 = [], a3;
        for (a3 of t6) {
          let t7 = r3[a3];
          if (typeof t7 != `number`) throw TypeError(`No definition for referenced signature "` + a3 + `"`);
          if (t7 = n4[t7], typeof t7 != `function`) return false;
          i3.push(t7);
        }
        return i3;
      }
      function ie2(t6, n4, r3) {
        let i3 = ne2(t6), a3 = Array(i3.length).fill(false), o3 = true;
        for (; o3; ) {
          o3 = false;
          let t7 = true;
          for (let s3 = 0; s3 < i3.length; ++s3) {
            if (a3[s3]) continue;
            let c3 = i3[s3];
            if (he2(c3)) i3[s3] = c3.referToSelf.callback(r3), i3[s3].referToSelf = c3.referToSelf, a3[s3] = true, t7 = false;
            else if (me2(c3)) {
              let r4 = X2(c3.referTo.references, i3, n4);
              r4 ? (i3[s3] = c3.referTo.callback.apply(this, r4), i3[s3].referTo = c3.referTo, a3[s3] = true, t7 = false) : o3 = true;
            }
          }
          if (t7 && o3) throw SyntaxError(`Circular reference detected in resolving typed.referTo`);
        }
        return i3;
      }
      function ae2(t6) {
        let n4 = /\bthis(\(|\.signatures\b)/;
        Object.keys(t6).forEach((r3) => {
          let i3 = t6[r3];
          if (n4.test(i3.toString())) throw SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        });
      }
      function Z2(t6, i3) {
        if (p2.createCount++, Object.keys(i3).length === 0) throw SyntaxError(`No signatures provided`);
        p2.warnAgainstDeprecatedThis && ae2(i3);
        let a3 = [], o3 = [], s3 = {}, c3 = [], l3;
        for (l3 in i3) {
          if (!Object.prototype.hasOwnProperty.call(i3, l3)) continue;
          let t7 = M2(l3);
          if (!t7) continue;
          a3.forEach(function(n5) {
            if (te2(n5, t7)) throw TypeError(`Conflicting signatures "` + E(n5) + `" and "` + E(t7) + `".`);
          }), a3.push(t7);
          let n4 = o3.length;
          o3.push(i3[l3]);
          let r3 = t7.map(O2), u4;
          for (u4 of Y2(r3)) {
            let t8 = E(u4);
            c3.push({ params: u4, name: t8, fn: n4 }), u4.every((t9) => !t9.hasConversion) && (s3[t8] = n4);
          }
        }
        c3.sort(K2);
        let u3 = ie2(o3, s3, ye3), d3;
        for (d3 in s3) Object.prototype.hasOwnProperty.call(s3, d3) && (s3[d3] = u3[s3[d3]]);
        let m3 = [], h3 = /* @__PURE__ */ new Map();
        for (d3 of c3) h3.has(d3.name) || (d3.fn = u3[d3.fn], m3.push(d3), h3.set(d3.name, d3));
        let g3 = m3[0] && m3[0].params.length <= 2 && !N2(m3[0].params), v3 = m3[1] && m3[1].params.length <= 2 && !N2(m3[1].params), y3 = m3[2] && m3[2].params.length <= 2 && !N2(m3[2].params), b3 = m3[3] && m3[3].params.length <= 2 && !N2(m3[3].params), x3 = m3[4] && m3[4].params.length <= 2 && !N2(m3[4].params), S3 = m3[5] && m3[5].params.length <= 2 && !N2(m3[5].params), w3 = g3 && v3 && y3 && b3 && x3 && S3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].test = I2(m3[t7].params);
        let D2 = g3 ? F(m3[0].params[0]) : n3, j3 = v3 ? F(m3[1].params[0]) : n3, L3 = y3 ? F(m3[2].params[0]) : n3, R3 = b3 ? F(m3[3].params[0]) : n3, z3 = x3 ? F(m3[4].params[0]) : n3, V3 = S3 ? F(m3[5].params[0]) : n3, H3 = g3 ? F(m3[0].params[1]) : n3, U3 = v3 ? F(m3[1].params[1]) : n3, W3 = y3 ? F(m3[2].params[1]) : n3, G3 = b3 ? F(m3[3].params[1]) : n3, q3 = x3 ? F(m3[4].params[1]) : n3, ee3 = S3 ? F(m3[5].params[1]) : n3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].implementation = J(m3[t7].params, m3[t7].fn);
        let ne3 = g3 ? m3[0].implementation : r2, X3 = v3 ? m3[1].implementation : r2, Z3 = y3 ? m3[2].implementation : r2, oe3 = b3 ? m3[3].implementation : r2, $3 = x3 ? m3[4].implementation : r2, se3 = S3 ? m3[5].implementation : r2, ce3 = g3 ? m3[0].params.length : -1, le3 = v3 ? m3[1].params.length : -1, ue3 = y3 ? m3[2].params.length : -1, de3 = b3 ? m3[3].params.length : -1, fe3 = x3 ? m3[4].params.length : -1, pe3 = S3 ? m3[5].params.length : -1, me3 = w3 ? 6 : 0, he3 = m3.length, ge3 = m3.map((t7) => t7.test), _e3 = m3.map((t7) => t7.implementation), ve3 = function() {
          for (let t7 = me3; t7 < he3; t7++) if (ge3[t7](arguments)) return _e3[t7].apply(this, arguments);
          return p2.onMismatch(t6, arguments, m3);
        };
        function ye3(t7, n4) {
          return arguments.length === ce3 && D2(t7) && H3(n4) ? ne3.apply(this, arguments) : arguments.length === le3 && j3(t7) && U3(n4) ? X3.apply(this, arguments) : arguments.length === ue3 && L3(t7) && W3(n4) ? Z3.apply(this, arguments) : arguments.length === de3 && R3(t7) && G3(n4) ? oe3.apply(this, arguments) : arguments.length === fe3 && z3(t7) && q3(n4) ? $3.apply(this, arguments) : arguments.length === pe3 && V3(t7) && ee3(n4) ? se3.apply(this, arguments) : ve3.apply(this, arguments);
        }
        try {
          Object.defineProperty(ye3, "name", { value: t6 });
        } catch {
        }
        return ye3.signatures = s3, ye3._typedFunctionData = { signatures: m3, signatureMap: h3 }, ye3;
      }
      function oe2(t6, n4, r3) {
        throw H2(t6, n4, r3);
      }
      function $2(t6) {
        return ce2(t6, 0, t6.length - 1);
      }
      function se2(t6) {
        return t6[t6.length - 1];
      }
      function ce2(t6, n4, r3) {
        return Array.prototype.slice.call(t6, n4, r3);
      }
      function le2(t6, n4) {
        for (let r3 = 0; r3 < t6.length; r3++) if (n4(t6[r3])) return t6[r3];
      }
      function ue2(t6, n4) {
        return Array.prototype.concat.apply([], t6.map(n4));
      }
      function de2() {
        let t6 = $2(arguments).map((t7) => E(M2(t7))), n4 = se2(arguments);
        if (typeof n4 != `function`) throw TypeError(`Callback function expected as last argument`);
        return fe2(t6, n4);
      }
      function fe2(t6, n4) {
        return { referTo: { references: t6, callback: n4 } };
      }
      function pe2(t6) {
        if (typeof t6 != `function`) throw TypeError(`Callback function expected as first argument`);
        return { referToSelf: { callback: t6 } };
      }
      function me2(t6) {
        return t6 && typeof t6.referTo == `object` && Array.isArray(t6.referTo.references) && typeof t6.referTo.callback == `function`;
      }
      function he2(t6) {
        return t6 && typeof t6.referToSelf == `object` && typeof t6.referToSelf.callback == `function`;
      }
      function ge2(t6, n4) {
        if (!t6) return n4;
        if (n4 && n4 !== t6) {
          let r3 = Error(`Function names do not match (expected: ` + t6 + `, actual: ` + n4 + `)`);
          throw r3.data = { actual: n4, expected: t6 }, r3;
        }
        return t6;
      }
      function _e2(t6) {
        let n4;
        for (let r3 in t6) Object.prototype.hasOwnProperty.call(t6, r3) && (b2(t6[r3]) || typeof t6[r3].signature == `string`) && (n4 = ge2(n4, t6[r3].name));
        return n4;
      }
      function ve2(t6, n4) {
        let r3;
        for (r3 in n4) if (Object.prototype.hasOwnProperty.call(n4, r3)) {
          if (r3 in t6 && n4[r3] !== t6[r3]) {
            let i3 = Error(`Signature "` + r3 + `" is defined twice`);
            throw i3.data = { signature: r3, sourceFunction: n4[r3], destFunction: t6[r3] }, i3;
          }
          t6[r3] = n4[r3];
        }
      }
      let ye2 = p2;
      p2 = function(t6) {
        let n4 = typeof t6 == `string`, r3 = +!!n4, i3 = n4 ? t6 : ``, a3 = {};
        for (let t7 = r3; t7 < arguments.length; ++t7) {
          let r4 = arguments[t7], s3 = {}, c3;
          if (typeof r4 == `function` ? (c3 = r4.name, typeof r4.signature == `string` ? s3[r4.signature] = r4 : b2(r4) && (s3 = r4.signatures)) : o2(r4) && (s3 = r4, n4 || (c3 = _e2(r4))), Object.keys(s3).length === 0) {
            let n5 = TypeError(`Argument to 'typed' at index ` + t7 + ` is not a (typed) function, nor an object with signatures as keys and functions as values.`);
            throw n5.data = { index: t7, argument: r4 }, n5;
          }
          n4 || (i3 = ge2(i3, c3)), ve2(a3, s3);
        }
        return Z2(i3 || ``, a3);
      }, p2.create = a2, p2.createCount = ye2.createCount, p2.onMismatch = oe2, p2.throwMismatchError = oe2, p2.createError = H2, p2.clear = g2, p2.clearConversions = v2, p2.addTypes = h2, p2._findType = m2, p2.referTo = de2, p2.referToSelf = pe2, p2.convert = w2, p2.findSignature = x2, p2.find = S2, p2.isTypedFunction = b2, p2.warnAgainstDeprecatedThis = true, p2.addType = function(t6, n4) {
        let r3 = `any`;
        n4 !== false && l2.has(`Object`) && (r3 = `Object`), p2.addTypes([t6], r3);
      };
      function be2(t6) {
        if (!t6 || typeof t6.from != `string` || typeof t6.to != `string` || typeof t6.convert != `function`) throw TypeError(`Object with properties {from: string, to: string, convert: function} expected`);
        if (t6.to === t6.from) throw SyntaxError(`Illegal to define conversion from "` + t6.from + `" to itself.`);
      }
      return p2.addConversion = function(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { override: false };
        be2(t6);
        let r3 = m2(t6.to), i3 = r3.conversionsTo.find((n5) => n5.from === t6.from);
        if (i3) if (n4 && n4.override) p2.removeConversion({ from: i3.from, to: t6.to, convert: i3.convert });
        else throw Error(`There is already a conversion from "` + t6.from + `" to "` + r3.name + `"`);
        r3.conversionsTo.push({ from: t6.from, convert: t6.convert, index: d2++ });
      }, p2.addConversions = function(t6, n4) {
        t6.forEach((t7) => p2.addConversion(t7, n4));
      }, p2.removeConversion = function(t6) {
        be2(t6);
        let n4 = m2(t6.to), r3 = le2(n4.conversionsTo, (n5) => n5.from === t6.from);
        if (!r3) throw Error(`Attempt to remove nonexistent conversion from ` + t6.from + ` to ` + t6.to);
        if (r3.convert !== t6.convert) throw Error(`Conversion to remove does not match existing conversion`);
        let i3 = n4.conversionsTo.indexOf(r3);
        n4.conversionsTo.splice(i3, 1);
      }, p2.resolve = function(t6, n4) {
        if (!b2(t6)) throw TypeError(i2);
        let r3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < r3.length; ++t7) if (r3[t7].test(n4)) return r3[t7];
        return null;
      }, p2;
    }
    return a2();
  }));
}));
function factory$2(t4, n2, r2, i2) {
  function a2(i3) {
    var a3 = pickShallow$2(i3, n2.map(stripOptionalNotation$2));
    return assertDependencies$2(t4, n2, i3), r2(a3);
  }
  return a2.isFactory = true, a2.fn = t4, a2.dependencies = n2.slice().sort(), i2 && (a2.meta = i2), a2;
}
function isFactory$2(t4) {
  return typeof t4 == `function` && typeof t4.fn == `string` && Array.isArray(t4.dependencies);
}
function assertDependencies$2(t4, n2, r2) {
  if (!n2.filter((t5) => !isOptionalDependency$2(t5)).every((t5) => r2[t5] !== void 0)) {
    var i2 = n2.filter((t5) => r2[t5] === void 0);
    throw Error(`Cannot create function "${t4}", some dependencies are missing: ${i2.map((t5) => `"${t5}"`).join(`, `)}.`);
  }
}
function isOptionalDependency$2(t4) {
  return t4 && t4[0] === `?`;
}
function stripOptionalNotation$2(t4) {
  return t4 && t4[0] === `?` ? t4.slice(1) : t4;
}
function isInteger$3(t4) {
  return typeof t4 == `boolean` ? true : Number.isFinite(t4) ? t4 === Math.round(t4) : false;
}
function safeNumberType$2(t4, n2) {
  if (n2.number === `bigint`) try {
    BigInt(t4);
  } catch {
    return n2.numberFallback;
  }
  return n2.number;
}
var sign$2$2 = Math.sign || function(t4) {
  return t4 > 0 ? 1 : t4 < 0 ? -1 : 0;
}, log2$1$2 = Math.log2 || function(t4) {
  return Math.log(t4) / Math.LN2;
}, log10$2$2 = Math.log10 || function(t4) {
  return Math.log(t4) / Math.LN10;
}, log1p$2 = Math.log1p || function(t4) {
  return Math.log(t4 + 1);
}, cbrt$1$2 = Math.cbrt || function(t4) {
  if (t4 === 0) return t4;
  var n2 = t4 < 0, r2;
  return n2 && (t4 = -t4), Number.isFinite(t4) ? (r2 = Math.exp(Math.log(t4) / 3), r2 = (t4 / (r2 * r2) + 2 * r2) / 3) : r2 = t4, n2 ? -r2 : r2;
}, expm1$2 = Math.expm1 || function(t4) {
  return t4 >= 2e-4 || t4 <= -2e-4 ? Math.exp(t4) - 1 : t4 + t4 * t4 / 2 + t4 * t4 * t4 / 6;
};
function formatNumberToBase$2(t4, n2, r2) {
  var i2 = { 2: `0b`, 8: `0o`, 16: `0x` }[n2], a2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger$3(r2)) throw Error(`size must be an integer`);
    if (t4 > 2 ** (r2 - 1) - 1 || t4 < -(2 ** (r2 - 1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!isInteger$3(t4)) throw Error(`Value must be an integer`);
    t4 < 0 && (t4 += 2 ** r2), a2 = `i${r2}`;
  }
  var o2 = ``;
  return t4 < 0 && (t4 = -t4, o2 = `-`), `${o2}${i2}${t4.toString(n2)}${a2}`;
}
function format$2$2(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (t4 === 1 / 0) return `Infinity`;
  if (t4 === -1 / 0) return `-Infinity`;
  if (isNaN(t4)) return `NaN`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions$2(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$2$2(t4, i2);
    case `exponential`:
      return toExponential$1$2(t4, i2);
    case `engineering`:
      return toEngineering$1$2(t4, i2);
    case `bin`:
      return formatNumberToBase$2(t4, 2, a2);
    case `oct`:
      return formatNumberToBase$2(t4, 8, a2);
    case `hex`:
      return formatNumberToBase$2(t4, 16, a2);
    case `auto`:
      return toPrecision$2(t4, i2, n2).replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function normalizeFormatOptions$2(t4) {
  var n2 = `auto`, r2, i2;
  if (t4 !== void 0) if (isNumber$2(t4)) r2 = t4;
  else if (isBigNumber$2(t4)) r2 = t4.toNumber();
  else if (isObject$1$2(t4)) t4.precision !== void 0 && (r2 = _toNumberOrThrow$2(t4.precision, () => {
    throw Error(`Option "precision" must be a number or BigNumber`);
  })), t4.wordSize !== void 0 && (i2 = _toNumberOrThrow$2(t4.wordSize, () => {
    throw Error(`Option "wordSize" must be a number or BigNumber`);
  })), t4.notation && (n2 = t4.notation);
  else throw Error(`Unsupported type of options, number, BigNumber, or object expected`);
  return { notation: n2, precision: r2, wordSize: i2 };
}
function splitNumber$2(t4) {
  var n2 = String(t4).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!n2) throw SyntaxError(`Invalid number ` + t4);
  var r2 = n2[1], i2 = n2[2], a2 = parseFloat(n2[4] || `0`), o2 = i2.indexOf(`.`);
  a2 += o2 === -1 ? i2.length - 1 : o2 - 1;
  var s2 = i2.replace(`.`, ``).replace(/^0*/, function(t5) {
    return a2 -= t5.length, ``;
  }).replace(/0*$/, ``).split(``).map(function(t5) {
    return parseInt(t5);
  });
  return s2.length === 0 && (s2.push(0), a2++), { sign: r2, coefficients: s2, exponent: a2 };
}
function toEngineering$1$2(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = roundDigits$2(splitNumber$2(t4), n2), i2 = r2.exponent, a2 = r2.coefficients, o2 = i2 % 3 == 0 ? i2 : i2 < 0 ? i2 - 3 - i2 % 3 : i2 - i2 % 3;
  if (isNumber$2(n2)) for (; n2 > a2.length || i2 - o2 + 1 > a2.length; ) a2.push(0);
  else for (var s2 = Math.abs(i2 - o2) - (a2.length - 1), c2 = 0; c2 < s2; c2++) a2.push(0);
  for (var l2 = Math.abs(i2 - o2), u2 = 1; l2 > 0; ) u2++, l2--;
  var d2 = a2.slice(u2).join(``), p2 = isNumber$2(n2) && d2.length || d2.match(/[1-9]/) ? `.` + d2 : ``, m2 = a2.slice(0, u2).join(``) + p2 + `e` + (i2 >= 0 ? `+` : ``) + o2.toString();
  return r2.sign + m2;
}
function toFixed$2$2(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = splitNumber$2(t4), i2 = typeof n2 == `number` ? roundDigits$2(r2, r2.exponent + 1 + n2) : r2, a2 = i2.coefficients, o2 = i2.exponent + 1, s2 = o2 + (n2 || 0);
  return a2.length < s2 && (a2 = a2.concat(zeros$2(s2 - a2.length))), o2 < 0 && (a2 = zeros$2(-o2 + 1).concat(a2), o2 = 1), o2 < a2.length && a2.splice(o2, 0, o2 === 0 ? `0.` : `.`), i2.sign + a2.join(``);
}
function toExponential$1$2(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(Number(t4))) return String(t4);
  var r2 = splitNumber$2(t4), i2 = n2 ? roundDigits$2(r2, n2) : r2, a2 = i2.coefficients, o2 = i2.exponent;
  a2.length < n2 && (a2 = a2.concat(zeros$2(n2 - a2.length)));
  var s2 = a2.shift();
  return i2.sign + s2 + (a2.length > 0 ? `.` + a2.join(``) : ``) + `e` + (o2 >= 0 ? `+` : ``) + o2;
}
function toPrecision$2(t4, n2, r2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var i2 = _toNumberOrDefault$1$2(r2?.lowerExp, -3), a2 = _toNumberOrDefault$1$2(r2?.upperExp, 5), o2 = splitNumber$2(t4), s2 = n2 ? roundDigits$2(o2, n2) : o2;
  if (s2.exponent < i2 || s2.exponent >= a2) return toExponential$1$2(t4, n2);
  var c2 = s2.coefficients, l2 = s2.exponent;
  c2.length < n2 && (c2 = c2.concat(zeros$2(n2 - c2.length))), c2 = c2.concat(zeros$2(l2 - c2.length + 1 + (c2.length < n2 ? n2 - c2.length : 0))), c2 = zeros$2(-l2).concat(c2);
  var u2 = l2 > 0 ? l2 : 0;
  return u2 < c2.length - 1 && c2.splice(u2 + 1, 0, `.`), s2.sign + c2.join(``);
}
function roundDigits$2(t4, n2) {
  for (var r2 = { sign: t4.sign, coefficients: t4.coefficients, exponent: t4.exponent }, i2 = r2.coefficients; n2 <= 0; ) i2.unshift(0), r2.exponent++, n2++;
  if (i2.length > n2 && i2.splice(n2, i2.length - n2)[0] >= 5) {
    var a2 = n2 - 1;
    for (i2[a2]++; i2[a2] === 10; ) i2.pop(), a2 === 0 && (i2.unshift(0), r2.exponent++, a2++), a2--, i2[a2]++;
  }
  return r2;
}
function zeros$2(t4) {
  for (var n2 = [], r2 = 0; r2 < t4; r2++) n2.push(0);
  return n2;
}
function digits$2(t4) {
  return t4.toExponential().replace(/e.*$/, ``).replace(/^0\.?0*|\./, ``).length;
}
function nearlyEqual$1$2(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return isNaN(t4) || isNaN(n2) ? false : !Number.isFinite(t4) || !Number.isFinite(n2) ? t4 === n2 : t4 === n2 ? true : Math.abs(t4 - n2) <= Math.max(r2 * Math.max(Math.abs(t4), Math.abs(n2)), i2);
}
var acosh$2$2 = Math.acosh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 - 1) + t4);
}, asinh$2$2 = Math.asinh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 + 1) + t4);
}, atanh$2$2 = Math.atanh || function(t4) {
  return Math.log((1 + t4) / (1 - t4)) / 2;
}, cosh$3$2 = Math.cosh || function(t4) {
  return (Math.exp(t4) + Math.exp(-t4)) / 2;
}, sinh$3$2 = Math.sinh || function(t4) {
  return (Math.exp(t4) - Math.exp(-t4)) / 2;
}, tanh$2$2 = Math.tanh || function(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 - 1) / (n2 + 1);
};
function copysign$2(t4, n2) {
  return true ^ (n2 > 0 ? true : n2 < 0 ? false : 1 / n2 == 1 / 0) ? -t4 : t4;
}
function _toNumberOrThrow$2(t4, n2) {
  if (isNumber$2(t4)) return t4;
  if (isBigNumber$2(t4)) return t4.toNumber();
  n2();
}
function _toNumberOrDefault$1$2(t4, n2) {
  return isNumber$2(t4) ? t4 : isBigNumber$2(t4) ? t4.toNumber() : n2;
}
var import_typed_function$2 = __toESM$2(require_typed_function$2()), _createTyped2$2 = function() {
  return _createTyped2$2 = import_typed_function$2.default.create, import_typed_function$2.default;
}, dependencies$322$2 = [`?BigNumber`, `?Complex`, `?DenseMatrix`, `?Fraction`], createTyped$2 = factory$2(`typed`, dependencies$322$2, function(t4) {
  var { BigNumber: n2, Complex: r2, DenseMatrix: i2, Fraction: a2 } = t4, o2 = _createTyped2$2();
  return o2.clear(), o2.addTypes([{ name: `number`, test: isNumber$2 }, { name: `Complex`, test: isComplex$2 }, { name: `BigNumber`, test: isBigNumber$2 }, { name: `bigint`, test: isBigInt$2 }, { name: `Fraction`, test: isFraction$2 }, { name: `Unit`, test: isUnit$2 }, { name: `identifier`, test: (t5) => isString$2 && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])*$/.test(t5) }, { name: `string`, test: isString$2 }, { name: `Chain`, test: isChain$2 }, { name: `Array`, test: isArray$3 }, { name: `Matrix`, test: isMatrix$2 }, { name: `DenseMatrix`, test: isDenseMatrix$2 }, { name: `SparseMatrix`, test: isSparseMatrix$2 }, { name: `Range`, test: isRange$2 }, { name: `Index`, test: isIndex$2 }, { name: `boolean`, test: isBoolean$1$2 }, { name: `ResultSet`, test: isResultSet$2 }, { name: `Help`, test: isHelp$2 }, { name: `function`, test: isFunction$1$2 }, { name: `Date`, test: isDate$3 }, { name: `RegExp`, test: isRegExp$2 }, { name: `null`, test: isNull$1$2 }, { name: `undefined`, test: isUndefined$1$2 }, { name: `AccessorNode`, test: isAccessorNode$2 }, { name: `ArrayNode`, test: isArrayNode$2 }, { name: `AssignmentNode`, test: isAssignmentNode$2 }, { name: `BlockNode`, test: isBlockNode$2 }, { name: `ConditionalNode`, test: isConditionalNode$2 }, { name: `ConstantNode`, test: isConstantNode$2 }, { name: `FunctionNode`, test: isFunctionNode$2 }, { name: `FunctionAssignmentNode`, test: isFunctionAssignmentNode$2 }, { name: `IndexNode`, test: isIndexNode$2 }, { name: `Node`, test: isNode$5 }, { name: `ObjectNode`, test: isObjectNode$2 }, { name: `OperatorNode`, test: isOperatorNode$2 }, { name: `ParenthesisNode`, test: isParenthesisNode$2 }, { name: `RangeNode`, test: isRangeNode$2 }, { name: `RelationalNode`, test: isRelationalNode$2 }, { name: `SymbolNode`, test: isSymbolNode$2 }, { name: `Map`, test: isMap$3 }, { name: `Object`, test: isObject$1$2 }]), o2.addConversions([{ from: `number`, to: `BigNumber`, convert: function(t5) {
    if (n2 || throwNoBignumber$2(t5), digits$2(t5) > 15) throw TypeError(`Cannot implicitly convert a number with >15 significant digits to BigNumber (value: ` + t5 + `). Use function bignumber(x) to convert to BigNumber.`);
    return new n2(t5);
  } }, { from: `number`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$2(t5), new r2(t5, 0);
  } }, { from: `BigNumber`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$2(t5), new r2(t5.toNumber(), 0);
  } }, { from: `bigint`, to: `number`, convert: function(t5) {
    if (t5 > 2 ** 53 - 1) throw TypeError(`Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: ` + t5 + `)`);
    return Number(t5);
  } }, { from: `bigint`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber$2(t5), new n2(t5.toString());
  } }, { from: `bigint`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction$2(t5), new a2(t5);
  } }, { from: `Fraction`, to: `BigNumber`, convert: function(t5) {
    throw TypeError(`Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.`);
  } }, { from: `Fraction`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$2(t5), new r2(t5.valueOf(), 0);
  } }, { from: `number`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction$2(t5);
    var n3 = new a2(t5);
    if (n3.valueOf() !== t5) throw TypeError(`Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: ` + t5 + `). Use function fraction(x) to convert to Fraction.`);
    return n3;
  } }, { from: `string`, to: `number`, convert: function(t5) {
    var n3 = Number(t5);
    if (isNaN(n3)) throw Error(`Cannot convert "` + t5 + `" to a number`);
    return n3;
  } }, { from: `string`, to: `BigNumber`, convert: function(t5) {
    n2 || throwNoBignumber$2(t5);
    try {
      return new n2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigNumber`);
    }
  } }, { from: `string`, to: `bigint`, convert: function(t5) {
    try {
      return BigInt(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigInt`);
    }
  } }, { from: `string`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction$2(t5);
    try {
      return new a2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Fraction`);
    }
  } }, { from: `string`, to: `Complex`, convert: function(t5) {
    r2 || throwNoComplex$2(t5);
    try {
      return new r2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Complex`);
    }
  } }, { from: `boolean`, to: `number`, convert: function(t5) {
    return +t5;
  } }, { from: `boolean`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber$2(t5), new n2(+t5);
  } }, { from: `boolean`, to: `bigint`, convert: function(t5) {
    return BigInt(+t5);
  } }, { from: `boolean`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction$2(t5), new a2(+t5);
  } }, { from: `boolean`, to: `string`, convert: function(t5) {
    return String(t5);
  } }, { from: `Array`, to: `Matrix`, convert: function(t5) {
    return i2 || throwNoMatrix$2(), new i2(t5);
  } }, { from: `Matrix`, to: `Array`, convert: function(t5) {
    return t5.valueOf();
  } }]), o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection$2(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection$2(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2;
});
function throwNoBignumber$2(t4) {
  throw Error(`Cannot convert value ${t4} into a BigNumber: no class 'BigNumber' provided`);
}
function throwNoComplex$2(t4) {
  throw Error(`Cannot convert value ${t4} into a Complex number: no class 'Complex' provided`);
}
function throwNoMatrix$2() {
  throw Error(`Cannot convert array into a Matrix: no class 'DenseMatrix' provided`);
}
function throwNoFraction$2(t4) {
  throw Error(`Cannot convert value ${t4} into a Fraction, no class 'Fraction' provided.`);
}
var name$321$2 = `ResultSet`, dependencies$321$2 = [], createResultSet$2 = factory$2(name$321$2, dependencies$321$2, () => {
  function t4(n2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    this.entries = n2 || [];
  }
  return t4.prototype.type = `ResultSet`, t4.prototype.isResultSet = true, t4.prototype.valueOf = function() {
    return this.entries;
  }, t4.prototype.toString = function() {
    return `[` + this.entries.map(String).join(`, `) + `]`;
  }, t4.prototype.toJSON = function() {
    return { mathjs: `ResultSet`, entries: this.entries };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.entries);
  }, t4;
}, { isClass: true }), EXP_LIMIT$2 = 9e15, MAX_DIGITS$2 = 1e9, NUMERALS$2 = `0123456789abcdef`, LN10$2 = `2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058`, PI$2 = `3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789`, DEFAULTS$2 = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT$2, maxE: EXP_LIMIT$2, crypto: false }, inexact$2, quadrant$2, external$2 = true, decimalError$2 = `[DecimalError] `, invalidArgument$2 = decimalError$2 + `Invalid argument: `, precisionLimitExceeded$2 = decimalError$2 + `Precision limit exceeded`, cryptoUnavailable$2 = decimalError$2 + `crypto unavailable`, tag$2 = `[object Decimal]`, mathfloor$2 = Math.floor, mathpow$2 = Math.pow, isBinary$2 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex$2 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal$2 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal$2 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE$2 = 1e7, LOG_BASE$2 = 7, MAX_SAFE_INTEGER$2 = 9007199254740991, LN10_PRECISION$2 = LN10$2.length - 1, PI_PRECISION$2 = PI$2.length - 1, P$3$2 = { toStringTag: tag$2 };
P$3$2.absoluteValue = P$3$2.abs = function() {
  var t4 = new this.constructor(this);
  return t4.s < 0 && (t4.s = 1), finalise$2(t4);
}, P$3$2.ceil = function() {
  return finalise$2(new this.constructor(this), this.e + 1, 2);
}, P$3$2.clampedTo = P$3$2.clamp = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  if (t4 = new a2(t4), n2 = new a2(n2), !t4.s || !n2.s) return new a2(NaN);
  if (t4.gt(n2)) throw Error(invalidArgument$2 + n2);
  return r2 = i2.cmp(t4), r2 < 0 ? t4 : i2.cmp(n2) > 0 ? n2 : new a2(i2);
}, P$3$2.comparedTo = P$3$2.cmp = function(t4) {
  var n2, r2, i2, a2, o2 = this, s2 = o2.d, c2 = (t4 = new o2.constructor(t4)).d, l2 = o2.s, u2 = t4.s;
  if (!s2 || !c2) return !l2 || !u2 ? NaN : l2 === u2 ? s2 === c2 ? 0 : !s2 ^ l2 < 0 ? 1 : -1 : l2;
  if (!s2[0] || !c2[0]) return s2[0] ? l2 : c2[0] ? -u2 : 0;
  if (l2 !== u2) return l2;
  if (o2.e !== t4.e) return o2.e > t4.e ^ l2 < 0 ? 1 : -1;
  for (i2 = s2.length, a2 = c2.length, n2 = 0, r2 = i2 < a2 ? i2 : a2; n2 < r2; ++n2) if (s2[n2] !== c2[n2]) return s2[n2] > c2[n2] ^ l2 < 0 ? 1 : -1;
  return i2 === a2 ? 0 : i2 > a2 ^ l2 < 0 ? 1 : -1;
}, P$3$2.cosine = P$3$2.cos = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.d ? r2.d[0] ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE$2, i2.rounding = 1, r2 = cosine$2(i2, toLessThanHalfPi$2(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise$2(quadrant$2 == 2 || quadrant$2 == 3 ? r2.neg() : r2, t4, n2, true)) : new i2(1) : new i2(NaN);
}, P$3$2.cubeRoot = P$3$2.cbrt = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor;
  if (!d2.isFinite() || d2.isZero()) return new p2(d2);
  for (external$2 = false, o2 = d2.s * mathpow$2(d2.s * d2, 1 / 3), !o2 || Math.abs(o2) == 1 / 0 ? (r2 = digitsToString$2(d2.d), t4 = d2.e, (o2 = (t4 - r2.length + 1) % 3) && (r2 += o2 == 1 || o2 == -2 ? `0` : `00`), o2 = mathpow$2(r2, 1 / 3), t4 = mathfloor$2((t4 + 1) / 3) - (t4 % 3 == (t4 < 0 ? -1 : 2)), o2 == 1 / 0 ? r2 = `5e` + t4 : (r2 = o2.toExponential(), r2 = r2.slice(0, r2.indexOf(`e`) + 1) + t4), i2 = new p2(r2), i2.s = d2.s) : i2 = new p2(o2.toString()), s2 = (t4 = p2.precision) + 3; ; ) if (c2 = i2, l2 = c2.times(c2).times(c2), u2 = l2.plus(d2), i2 = divide$1$2(u2.plus(d2).times(c2), u2.plus(l2), s2 + 2, 1), digitsToString$2(c2.d).slice(0, s2) === (r2 = digitsToString$2(i2.d)).slice(0, s2)) if (r2 = r2.slice(s2 - 3, s2 + 1), r2 == `9999` || !a2 && r2 == `4999`) {
    if (!a2 && (finalise$2(c2, t4 + 1, 0), c2.times(c2).times(c2).eq(d2))) {
      i2 = c2;
      break;
    }
    s2 += 4, a2 = 1;
  } else {
    (!+r2 || !+r2.slice(1) && r2.charAt(0) == `5`) && (finalise$2(i2, t4 + 1, 1), n2 = !i2.times(i2).times(i2).eq(d2));
    break;
  }
  return external$2 = true, finalise$2(i2, t4, p2.rounding, n2);
}, P$3$2.decimalPlaces = P$3$2.dp = function() {
  var t4, n2 = this.d, r2 = NaN;
  if (n2) {
    if (t4 = n2.length - 1, r2 = (t4 - mathfloor$2(this.e / LOG_BASE$2)) * LOG_BASE$2, t4 = n2[t4], t4) for (; t4 % 10 == 0; t4 /= 10) r2--;
    r2 < 0 && (r2 = 0);
  }
  return r2;
}, P$3$2.dividedBy = P$3$2.div = function(t4) {
  return divide$1$2(this, new this.constructor(t4));
}, P$3$2.dividedToIntegerBy = P$3$2.divToInt = function(t4) {
  var n2 = this, r2 = n2.constructor;
  return finalise$2(divide$1$2(n2, new r2(t4), 0, 1, 1), r2.precision, r2.rounding);
}, P$3$2.equals = P$3$2.eq = function(t4) {
  return this.cmp(t4) === 0;
}, P$3$2.floor = function() {
  return finalise$2(new this.constructor(this), this.e + 1, 3);
}, P$3$2.greaterThan = P$3$2.gt = function(t4) {
  return this.cmp(t4) > 0;
}, P$3$2.greaterThanOrEqualTo = P$3$2.gte = function(t4) {
  var n2 = this.cmp(t4);
  return n2 == 1 || n2 === 0;
}, P$3$2.hyperbolicCosine = P$3$2.cosh = function() {
  var t4, n2, r2, i2, a2, o2 = this, s2 = o2.constructor, c2 = new s2(1);
  if (!o2.isFinite()) return new s2(o2.s ? 1 / 0 : NaN);
  if (o2.isZero()) return c2;
  r2 = s2.precision, i2 = s2.rounding, s2.precision = r2 + Math.max(o2.e, o2.sd()) + 4, s2.rounding = 1, a2 = o2.d.length, a2 < 32 ? (t4 = Math.ceil(a2 / 3), n2 = (1 / tinyPow$2(4, t4)).toString()) : (t4 = 16, n2 = `2.3283064365386962890625e-10`), o2 = taylorSeries$2(s2, 1, o2.times(n2), new s2(1), true);
  for (var l2, u2 = t4, d2 = new s2(8); u2--; ) l2 = o2.times(o2), o2 = c2.minus(l2.times(d2.minus(l2.times(d2))));
  return finalise$2(o2, s2.precision = r2, s2.rounding = i2, true);
}, P$3$2.hyperbolicSine = P$3$2.sinh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  if (!a2.isFinite() || a2.isZero()) return new o2(a2);
  if (n2 = o2.precision, r2 = o2.rounding, o2.precision = n2 + Math.max(a2.e, a2.sd()) + 4, o2.rounding = 1, i2 = a2.d.length, i2 < 3) a2 = taylorSeries$2(o2, 2, a2, a2, true);
  else {
    t4 = 1.4 * Math.sqrt(i2), t4 = t4 > 16 ? 16 : t4 | 0, a2 = a2.times(1 / tinyPow$2(5, t4)), a2 = taylorSeries$2(o2, 2, a2, a2, true);
    for (var s2, c2 = new o2(5), l2 = new o2(16), u2 = new o2(20); t4--; ) s2 = a2.times(a2), a2 = a2.times(c2.plus(s2.times(l2.times(s2).plus(u2))));
  }
  return o2.precision = n2, o2.rounding = r2, finalise$2(a2, n2, r2, true);
}, P$3$2.hyperbolicTangent = P$3$2.tanh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 7, i2.rounding = 1, divide$1$2(r2.sinh(), r2.cosh(), i2.precision = t4, i2.rounding = n2)) : new i2(r2.s);
}, P$3$2.inverseCosine = P$3$2.acos = function() {
  var t4, n2 = this, r2 = n2.constructor, i2 = n2.abs().cmp(1), a2 = r2.precision, o2 = r2.rounding;
  return i2 === -1 ? n2.isZero() ? getPi$2(r2, a2 + 4, o2).times(0.5) : (r2.precision = a2 + 6, r2.rounding = 1, n2 = n2.asin(), t4 = getPi$2(r2, a2 + 4, o2).times(0.5), r2.precision = a2, r2.rounding = o2, t4.minus(n2)) : i2 === 0 ? n2.isNeg() ? getPi$2(r2, a2, o2) : new r2(0) : new r2(NaN);
}, P$3$2.inverseHyperbolicCosine = P$3$2.acosh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.lte(1) ? new i2(r2.eq(1) ? 0 : NaN) : r2.isFinite() ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(Math.abs(r2.e), r2.sd()) + 4, i2.rounding = 1, external$2 = false, r2 = r2.times(r2).minus(1).sqrt().plus(r2), external$2 = true, i2.precision = t4, i2.rounding = n2, r2.ln()) : new i2(r2);
}, P$3$2.inverseHyperbolicSine = P$3$2.asinh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return !r2.isFinite() || r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 2 * Math.max(Math.abs(r2.e), r2.sd()) + 6, i2.rounding = 1, external$2 = false, r2 = r2.times(r2).plus(1).sqrt().plus(r2), external$2 = true, i2.precision = t4, i2.rounding = n2, r2.ln());
}, P$3$2.inverseHyperbolicTangent = P$3$2.atanh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isFinite() ? a2.e >= 0 ? new o2(a2.abs().eq(1) ? a2.s / 0 : a2.isZero() ? a2 : NaN) : (t4 = o2.precision, n2 = o2.rounding, i2 = a2.sd(), Math.max(i2, t4) < 2 * -a2.e - 1 ? finalise$2(new o2(a2), t4, n2, true) : (o2.precision = r2 = i2 - a2.e, a2 = divide$1$2(a2.plus(1), new o2(1).minus(a2), r2 + t4, 1), o2.precision = t4 + 4, o2.rounding = 1, a2 = a2.ln(), o2.precision = t4, o2.rounding = n2, a2.times(0.5))) : new o2(NaN);
}, P$3$2.inverseSine = P$3$2.asin = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isZero() ? new o2(a2) : (n2 = a2.abs().cmp(1), r2 = o2.precision, i2 = o2.rounding, n2 === -1 ? (o2.precision = r2 + 6, o2.rounding = 1, a2 = a2.div(new o2(1).minus(a2.times(a2)).sqrt().plus(1)).atan(), o2.precision = r2, o2.rounding = i2, a2.times(2)) : n2 === 0 ? (t4 = getPi$2(o2, r2 + 4, i2).times(0.5), t4.s = a2.s, t4) : new o2(NaN));
}, P$3$2.inverseTangent = P$3$2.atan = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding;
  if (!u2.isFinite()) {
    if (!u2.s) return new d2(NaN);
    if (p2 + 4 <= PI_PRECISION$2) return s2 = getPi$2(d2, p2 + 4, m2).times(0.5), s2.s = u2.s, s2;
  } else if (u2.isZero()) return new d2(u2);
  else if (u2.abs().eq(1) && p2 + 4 <= PI_PRECISION$2) return s2 = getPi$2(d2, p2 + 4, m2).times(0.25), s2.s = u2.s, s2;
  for (d2.precision = c2 = p2 + 10, d2.rounding = 1, r2 = Math.min(28, c2 / LOG_BASE$2 + 2 | 0), t4 = r2; t4; --t4) u2 = u2.div(u2.times(u2).plus(1).sqrt().plus(1));
  for (external$2 = false, n2 = Math.ceil(c2 / LOG_BASE$2), i2 = 1, l2 = u2.times(u2), s2 = new d2(u2), a2 = u2; t4 !== -1; ) if (a2 = a2.times(l2), o2 = s2.minus(a2.div(i2 += 2)), a2 = a2.times(l2), s2 = o2.plus(a2.div(i2 += 2)), s2.d[n2] !== void 0) for (t4 = n2; s2.d[t4] === o2.d[t4] && t4--; ) ;
  return r2 && (s2 = s2.times(2 << r2 - 1)), external$2 = true, finalise$2(s2, d2.precision = p2, d2.rounding = m2, true);
}, P$3$2.isFinite = function() {
  return !!this.d;
}, P$3$2.isInteger = P$3$2.isInt = function() {
  return !!this.d && mathfloor$2(this.e / LOG_BASE$2) > this.d.length - 2;
}, P$3$2.isNaN = function() {
  return !this.s;
}, P$3$2.isNegative = P$3$2.isNeg = function() {
  return this.s < 0;
}, P$3$2.isPositive = P$3$2.isPos = function() {
  return this.s > 0;
}, P$3$2.isZero = function() {
  return !!this.d && this.d[0] === 0;
}, P$3$2.lessThan = P$3$2.lt = function(t4) {
  return this.cmp(t4) < 0;
}, P$3$2.lessThanOrEqualTo = P$3$2.lte = function(t4) {
  return this.cmp(t4) < 1;
}, P$3$2.logarithm = P$3$2.log = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding, h2 = 5;
  if (t4 == null) t4 = new d2(10), n2 = true;
  else {
    if (t4 = new d2(t4), r2 = t4.d, t4.s < 0 || !r2 || !r2[0] || t4.eq(1)) return new d2(NaN);
    n2 = t4.eq(10);
  }
  if (r2 = u2.d, u2.s < 0 || !r2 || !r2[0] || u2.eq(1)) return new d2(r2 && !r2[0] ? -1 / 0 : u2.s == 1 ? r2 ? 0 : 1 / 0 : NaN);
  if (n2) if (r2.length > 1) o2 = true;
  else {
    for (a2 = r2[0]; a2 % 10 == 0; ) a2 /= 10;
    o2 = a2 !== 1;
  }
  if (external$2 = false, c2 = p2 + h2, s2 = naturalLogarithm$2(u2, c2), i2 = n2 ? getLn10$2(d2, c2 + 10) : naturalLogarithm$2(t4, c2), l2 = divide$1$2(s2, i2, c2, 1), checkRoundingDigits$2(l2.d, a2 = p2, m2)) do
    if (c2 += 10, s2 = naturalLogarithm$2(u2, c2), i2 = n2 ? getLn10$2(d2, c2 + 10) : naturalLogarithm$2(t4, c2), l2 = divide$1$2(s2, i2, c2, 1), !o2) {
      +digitsToString$2(l2.d).slice(a2 + 1, a2 + 15) + 1 == 1e14 && (l2 = finalise$2(l2, p2 + 1, 0));
      break;
    }
  while (checkRoundingDigits$2(l2.d, a2 += 10, m2));
  return external$2 = true, finalise$2(l2, p2, m2);
}, P$3$2.minus = P$3$2.sub = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.constructor;
  if (t4 = new g2(t4), !h2.d || !t4.d) return !h2.s || !t4.s ? t4 = new g2(NaN) : h2.d ? t4.s = -t4.s : t4 = new g2(t4.d || h2.s !== t4.s ? h2 : NaN), t4;
  if (h2.s != t4.s) return t4.s = -t4.s, h2.plus(t4);
  if (u2 = h2.d, m2 = t4.d, c2 = g2.precision, l2 = g2.rounding, !u2[0] || !m2[0]) {
    if (m2[0]) t4.s = -t4.s;
    else if (u2[0]) t4 = new g2(h2);
    else return new g2(l2 === 3 ? -0 : 0);
    return external$2 ? finalise$2(t4, c2, l2) : t4;
  }
  if (r2 = mathfloor$2(t4.e / LOG_BASE$2), d2 = mathfloor$2(h2.e / LOG_BASE$2), u2 = u2.slice(), o2 = d2 - r2, o2) {
    for (p2 = o2 < 0, p2 ? (n2 = u2, o2 = -o2, s2 = m2.length) : (n2 = m2, r2 = d2, s2 = u2.length), i2 = Math.max(Math.ceil(c2 / LOG_BASE$2), s2) + 2, o2 > i2 && (o2 = i2, n2.length = 1), n2.reverse(), i2 = o2; i2--; ) n2.push(0);
    n2.reverse();
  } else {
    for (i2 = u2.length, s2 = m2.length, p2 = i2 < s2, p2 && (s2 = i2), i2 = 0; i2 < s2; i2++) if (u2[i2] != m2[i2]) {
      p2 = u2[i2] < m2[i2];
      break;
    }
    o2 = 0;
  }
  for (p2 && (n2 = u2, u2 = m2, m2 = n2, t4.s = -t4.s), s2 = u2.length, i2 = m2.length - s2; i2 > 0; --i2) u2[s2++] = 0;
  for (i2 = m2.length; i2 > o2; ) {
    if (u2[--i2] < m2[i2]) {
      for (a2 = i2; a2 && u2[--a2] === 0; ) u2[a2] = BASE$2 - 1;
      --u2[a2], u2[i2] += BASE$2;
    }
    u2[i2] -= m2[i2];
  }
  for (; u2[--s2] === 0; ) u2.pop();
  for (; u2[0] === 0; u2.shift()) --r2;
  return u2[0] ? (t4.d = u2, t4.e = getBase10Exponent$2(u2, r2), external$2 ? finalise$2(t4, c2, l2) : t4) : new g2(l2 === 3 ? -0 : 0);
}, P$3$2.modulo = P$3$2.mod = function(t4) {
  var n2, r2 = this, i2 = r2.constructor;
  return t4 = new i2(t4), !r2.d || !t4.s || t4.d && !t4.d[0] ? new i2(NaN) : !t4.d || r2.d && !r2.d[0] ? finalise$2(new i2(r2), i2.precision, i2.rounding) : (external$2 = false, i2.modulo == 9 ? (n2 = divide$1$2(r2, t4.abs(), 0, 3, 1), n2.s *= t4.s) : n2 = divide$1$2(r2, t4, 0, i2.modulo, 1), n2 = n2.times(t4), external$2 = true, r2.minus(n2));
}, P$3$2.naturalExponential = P$3$2.exp = function() {
  return naturalExponential$2(this);
}, P$3$2.naturalLogarithm = P$3$2.ln = function() {
  return naturalLogarithm$2(this);
}, P$3$2.negated = P$3$2.neg = function() {
  var t4 = new this.constructor(this);
  return t4.s = -t4.s, finalise$2(t4);
}, P$3$2.plus = P$3$2.add = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2 = this, m2 = p2.constructor;
  if (t4 = new m2(t4), !p2.d || !t4.d) return !p2.s || !t4.s ? t4 = new m2(NaN) : p2.d || (t4 = new m2(t4.d || p2.s === t4.s ? p2 : NaN)), t4;
  if (p2.s != t4.s) return t4.s = -t4.s, p2.minus(t4);
  if (u2 = p2.d, d2 = t4.d, c2 = m2.precision, l2 = m2.rounding, !u2[0] || !d2[0]) return d2[0] || (t4 = new m2(p2)), external$2 ? finalise$2(t4, c2, l2) : t4;
  if (o2 = mathfloor$2(p2.e / LOG_BASE$2), i2 = mathfloor$2(t4.e / LOG_BASE$2), u2 = u2.slice(), a2 = o2 - i2, a2) {
    for (a2 < 0 ? (r2 = u2, a2 = -a2, s2 = d2.length) : (r2 = d2, i2 = o2, s2 = u2.length), o2 = Math.ceil(c2 / LOG_BASE$2), s2 = o2 > s2 ? o2 + 1 : s2 + 1, a2 > s2 && (a2 = s2, r2.length = 1), r2.reverse(); a2--; ) r2.push(0);
    r2.reverse();
  }
  for (s2 = u2.length, a2 = d2.length, s2 - a2 < 0 && (a2 = s2, r2 = d2, d2 = u2, u2 = r2), n2 = 0; a2; ) n2 = (u2[--a2] = u2[a2] + d2[a2] + n2) / BASE$2 | 0, u2[a2] %= BASE$2;
  for (n2 && (u2.unshift(n2), ++i2), s2 = u2.length; u2[--s2] == 0; ) u2.pop();
  return t4.d = u2, t4.e = getBase10Exponent$2(u2, i2), external$2 ? finalise$2(t4, c2, l2) : t4;
}, P$3$2.precision = P$3$2.sd = function(t4) {
  var n2, r2 = this;
  if (t4 !== void 0 && t4 !== !!t4 && t4 !== 1 && t4 !== 0) throw Error(invalidArgument$2 + t4);
  return r2.d ? (n2 = getPrecision$2(r2.d), t4 && r2.e + 1 > n2 && (n2 = r2.e + 1)) : n2 = NaN, n2;
}, P$3$2.round = function() {
  var t4 = this, n2 = t4.constructor;
  return finalise$2(new n2(t4), t4.e + 1, n2.rounding);
}, P$3$2.sine = P$3$2.sin = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE$2, i2.rounding = 1, r2 = sine$2(i2, toLessThanHalfPi$2(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise$2(quadrant$2 > 2 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3$2.squareRoot = P$3$2.sqrt = function() {
  var t4, n2, r2, i2, a2, o2, s2 = this, c2 = s2.d, l2 = s2.e, u2 = s2.s, d2 = s2.constructor;
  if (u2 !== 1 || !c2 || !c2[0]) return new d2(!u2 || u2 < 0 && (!c2 || c2[0]) ? NaN : c2 ? s2 : 1 / 0);
  for (external$2 = false, u2 = Math.sqrt(+s2), u2 == 0 || u2 == 1 / 0 ? (n2 = digitsToString$2(c2), (n2.length + l2) % 2 == 0 && (n2 += `0`), u2 = Math.sqrt(n2), l2 = mathfloor$2((l2 + 1) / 2) - (l2 < 0 || l2 % 2), u2 == 1 / 0 ? n2 = `5e` + l2 : (n2 = u2.toExponential(), n2 = n2.slice(0, n2.indexOf(`e`) + 1) + l2), i2 = new d2(n2)) : i2 = new d2(u2.toString()), r2 = (l2 = d2.precision) + 3; ; ) if (o2 = i2, i2 = o2.plus(divide$1$2(s2, o2, r2 + 2, 1)).times(0.5), digitsToString$2(o2.d).slice(0, r2) === (n2 = digitsToString$2(i2.d)).slice(0, r2)) if (n2 = n2.slice(r2 - 3, r2 + 1), n2 == `9999` || !a2 && n2 == `4999`) {
    if (!a2 && (finalise$2(o2, l2 + 1, 0), o2.times(o2).eq(s2))) {
      i2 = o2;
      break;
    }
    r2 += 4, a2 = 1;
  } else {
    (!+n2 || !+n2.slice(1) && n2.charAt(0) == `5`) && (finalise$2(i2, l2 + 1, 1), t4 = !i2.times(i2).eq(s2));
    break;
  }
  return external$2 = true, finalise$2(i2, l2, d2.rounding, t4);
}, P$3$2.tangent = P$3$2.tan = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 10, i2.rounding = 1, r2 = r2.sin(), r2.s = 1, r2 = divide$1$2(r2, new i2(1).minus(r2.times(r2)).sqrt(), t4 + 10, 0), i2.precision = t4, i2.rounding = n2, finalise$2(quadrant$2 == 2 || quadrant$2 == 4 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3$2.times = P$3$2.mul = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor, m2 = d2.d, h2 = (t4 = new p2(t4)).d;
  if (t4.s *= d2.s, !m2 || !m2[0] || !h2 || !h2[0]) return new p2(!t4.s || m2 && !m2[0] && !h2 || h2 && !h2[0] && !m2 ? NaN : !m2 || !h2 ? t4.s / 0 : t4.s * 0);
  for (r2 = mathfloor$2(d2.e / LOG_BASE$2) + mathfloor$2(t4.e / LOG_BASE$2), l2 = m2.length, u2 = h2.length, l2 < u2 && (o2 = m2, m2 = h2, h2 = o2, s2 = l2, l2 = u2, u2 = s2), o2 = [], s2 = l2 + u2, i2 = s2; i2--; ) o2.push(0);
  for (i2 = u2; --i2 >= 0; ) {
    for (n2 = 0, a2 = l2 + i2; a2 > i2; ) c2 = o2[a2] + h2[i2] * m2[a2 - i2 - 1] + n2, o2[a2--] = c2 % BASE$2 | 0, n2 = c2 / BASE$2 | 0;
    o2[a2] = (o2[a2] + n2) % BASE$2 | 0;
  }
  for (; !o2[--s2]; ) o2.pop();
  return n2 ? ++r2 : o2.shift(), t4.d = o2, t4.e = getBase10Exponent$2(o2, r2), external$2 ? finalise$2(t4, p2.precision, p2.rounding) : t4;
}, P$3$2.toBinary = function(t4, n2) {
  return toStringBinary$2(this, 2, t4, n2);
}, P$3$2.toDecimalPlaces = P$3$2.toDP = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return r2 = new i2(r2), t4 === void 0 ? r2 : (checkInt32$2(t4, 0, MAX_DIGITS$2), n2 === void 0 ? n2 = i2.rounding : checkInt32$2(n2, 0, 8), finalise$2(r2, t4 + r2.e + 1, n2));
}, P$3$2.toExponential = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString$2(i2, true) : (checkInt32$2(t4, 0, MAX_DIGITS$2), n2 === void 0 ? n2 = a2.rounding : checkInt32$2(n2, 0, 8), i2 = finalise$2(new a2(i2), t4 + 1, n2), r2 = finiteToString$2(i2, true, t4 + 1)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3$2.toFixed = function(t4, n2) {
  var r2, i2, a2 = this, o2 = a2.constructor;
  return t4 === void 0 ? r2 = finiteToString$2(a2) : (checkInt32$2(t4, 0, MAX_DIGITS$2), n2 === void 0 ? n2 = o2.rounding : checkInt32$2(n2, 0, 8), i2 = finalise$2(new o2(a2), t4 + a2.e + 1, n2), r2 = finiteToString$2(i2, false, t4 + i2.e + 1)), a2.isNeg() && !a2.isZero() ? `-` + r2 : r2;
}, P$3$2.toFraction = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.d, v2 = h2.constructor;
  if (!g2) return new v2(h2);
  if (u2 = r2 = new v2(1), i2 = l2 = new v2(0), n2 = new v2(i2), o2 = n2.e = getPrecision$2(g2) - h2.e - 1, s2 = o2 % LOG_BASE$2, n2.d[0] = mathpow$2(10, s2 < 0 ? LOG_BASE$2 + s2 : s2), t4 == null) t4 = o2 > 0 ? n2 : u2;
  else {
    if (c2 = new v2(t4), !c2.isInt() || c2.lt(u2)) throw Error(invalidArgument$2 + c2);
    t4 = c2.gt(n2) ? o2 > 0 ? n2 : u2 : c2;
  }
  for (external$2 = false, c2 = new v2(digitsToString$2(g2)), d2 = v2.precision, v2.precision = o2 = g2.length * LOG_BASE$2 * 2; p2 = divide$1$2(c2, n2, 0, 1, 1), a2 = r2.plus(p2.times(i2)), a2.cmp(t4) != 1; ) r2 = i2, i2 = a2, a2 = u2, u2 = l2.plus(p2.times(a2)), l2 = a2, a2 = n2, n2 = c2.minus(p2.times(a2)), c2 = a2;
  return a2 = divide$1$2(t4.minus(r2), i2, 0, 1, 1), l2 = l2.plus(a2.times(u2)), r2 = r2.plus(a2.times(i2)), l2.s = u2.s = h2.s, m2 = divide$1$2(u2, i2, o2, 1).minus(h2).abs().cmp(divide$1$2(l2, r2, o2, 1).minus(h2).abs()) < 1 ? [u2, i2] : [l2, r2], v2.precision = d2, external$2 = true, m2;
}, P$3$2.toHexadecimal = P$3$2.toHex = function(t4, n2) {
  return toStringBinary$2(this, 16, t4, n2);
}, P$3$2.toNearest = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  if (r2 = new i2(r2), t4 == null) {
    if (!r2.d) return r2;
    t4 = new i2(1), n2 = i2.rounding;
  } else {
    if (t4 = new i2(t4), n2 === void 0 ? n2 = i2.rounding : checkInt32$2(n2, 0, 8), !r2.d) return t4.s ? r2 : t4;
    if (!t4.d) return t4.s &&= r2.s, t4;
  }
  return t4.d[0] ? (external$2 = false, r2 = divide$1$2(r2, t4, 0, n2, 1).times(t4), external$2 = true, finalise$2(r2)) : (t4.s = r2.s, r2 = t4), r2;
}, P$3$2.toNumber = function() {
  return +this;
}, P$3$2.toOctal = function(t4, n2) {
  return toStringBinary$2(this, 8, t4, n2);
}, P$3$2.toPower = P$3$2.pow = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2 = this, l2 = c2.constructor, u2 = +(t4 = new l2(t4));
  if (!c2.d || !t4.d || !c2.d[0] || !t4.d[0]) return new l2(mathpow$2(+c2, u2));
  if (c2 = new l2(c2), c2.eq(1)) return c2;
  if (i2 = l2.precision, o2 = l2.rounding, t4.eq(1)) return finalise$2(c2, i2, o2);
  if (n2 = mathfloor$2(t4.e / LOG_BASE$2), n2 >= t4.d.length - 1 && (r2 = u2 < 0 ? -u2 : u2) <= MAX_SAFE_INTEGER$2) return a2 = intPow$2(l2, c2, r2, i2), t4.s < 0 ? new l2(1).div(a2) : finalise$2(a2, i2, o2);
  if (s2 = c2.s, s2 < 0) {
    if (n2 < t4.d.length - 1) return new l2(NaN);
    if (t4.d[n2] & 1 || (s2 = 1), c2.e == 0 && c2.d[0] == 1 && c2.d.length == 1) return c2.s = s2, c2;
  }
  return r2 = mathpow$2(+c2, u2), n2 = r2 == 0 || !isFinite(r2) ? mathfloor$2(u2 * (Math.log(`0.` + digitsToString$2(c2.d)) / Math.LN10 + c2.e + 1)) : new l2(r2 + ``).e, n2 > l2.maxE + 1 || n2 < l2.minE - 1 ? new l2(n2 > 0 ? s2 / 0 : 0) : (external$2 = false, l2.rounding = c2.s = 1, r2 = Math.min(12, (n2 + ``).length), a2 = naturalExponential$2(t4.times(naturalLogarithm$2(c2, i2 + r2)), i2), a2.d && (a2 = finalise$2(a2, i2 + 5, 1), checkRoundingDigits$2(a2.d, i2, o2) && (n2 = i2 + 10, a2 = finalise$2(naturalExponential$2(t4.times(naturalLogarithm$2(c2, n2 + r2)), n2), n2 + 5, 1), +digitsToString$2(a2.d).slice(i2 + 1, i2 + 15) + 1 == 1e14 && (a2 = finalise$2(a2, i2 + 1, 0)))), a2.s = s2, external$2 = true, l2.rounding = o2, finalise$2(a2, i2, o2));
}, P$3$2.toPrecision = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString$2(i2, i2.e <= a2.toExpNeg || i2.e >= a2.toExpPos) : (checkInt32$2(t4, 1, MAX_DIGITS$2), n2 === void 0 ? n2 = a2.rounding : checkInt32$2(n2, 0, 8), i2 = finalise$2(new a2(i2), t4, n2), r2 = finiteToString$2(i2, t4 <= i2.e || i2.e <= a2.toExpNeg, t4)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3$2.toSignificantDigits = P$3$2.toSD = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return t4 === void 0 ? (t4 = i2.precision, n2 = i2.rounding) : (checkInt32$2(t4, 1, MAX_DIGITS$2), n2 === void 0 ? n2 = i2.rounding : checkInt32$2(n2, 0, 8)), finalise$2(new i2(r2), t4, n2);
}, P$3$2.toString = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString$2(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() && !t4.isZero() ? `-` + r2 : r2;
}, P$3$2.truncated = P$3$2.trunc = function() {
  return finalise$2(new this.constructor(this), this.e + 1, 1);
}, P$3$2.valueOf = P$3$2.toJSON = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString$2(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() ? `-` + r2 : r2;
};
function digitsToString$2(t4) {
  var n2, r2, i2, a2 = t4.length - 1, o2 = ``, s2 = t4[0];
  if (a2 > 0) {
    for (o2 += s2, n2 = 1; n2 < a2; n2++) i2 = t4[n2] + ``, r2 = LOG_BASE$2 - i2.length, r2 && (o2 += getZeroString$2(r2)), o2 += i2;
    s2 = t4[n2], i2 = s2 + ``, r2 = LOG_BASE$2 - i2.length, r2 && (o2 += getZeroString$2(r2));
  } else if (s2 === 0) return `0`;
  for (; s2 % 10 == 0; ) s2 /= 10;
  return o2 + s2;
}
function checkInt32$2(t4, n2, r2) {
  if (t4 !== ~~t4 || t4 < n2 || t4 > r2) throw Error(invalidArgument$2 + t4);
}
function checkRoundingDigits$2(t4, n2, r2, i2) {
  var a2, o2, s2, c2;
  for (o2 = t4[0]; o2 >= 10; o2 /= 10) --n2;
  return --n2 < 0 ? (n2 += LOG_BASE$2, a2 = 0) : (a2 = Math.ceil((n2 + 1) / LOG_BASE$2), n2 %= LOG_BASE$2), o2 = mathpow$2(10, LOG_BASE$2 - n2), c2 = t4[a2] % o2 | 0, i2 == null ? n2 < 3 ? (n2 == 0 ? c2 = c2 / 100 | 0 : n2 == 1 && (c2 = c2 / 10 | 0), s2 = r2 < 4 && c2 == 99999 || r2 > 3 && c2 == 49999 || c2 == 5e4 || c2 == 0) : s2 = (r2 < 4 && c2 + 1 == o2 || r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 100 | 0) == mathpow$2(10, n2 - 2) - 1 || (c2 == o2 / 2 || c2 == 0) && (t4[a2 + 1] / o2 / 100 | 0) == 0 : n2 < 4 ? (n2 == 0 ? c2 = c2 / 1e3 | 0 : n2 == 1 ? c2 = c2 / 100 | 0 : n2 == 2 && (c2 = c2 / 10 | 0), s2 = (i2 || r2 < 4) && c2 == 9999 || !i2 && r2 > 3 && c2 == 4999) : s2 = ((i2 || r2 < 4) && c2 + 1 == o2 || !i2 && r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 1e3 | 0) == mathpow$2(10, n2 - 3) - 1, s2;
}
function convertBase$2(t4, n2, r2) {
  for (var i2, a2 = [0], o2, s2 = 0, c2 = t4.length; s2 < c2; ) {
    for (o2 = a2.length; o2--; ) a2[o2] *= n2;
    for (a2[0] += NUMERALS$2.indexOf(t4.charAt(s2++)), i2 = 0; i2 < a2.length; i2++) a2[i2] > r2 - 1 && (a2[i2 + 1] === void 0 && (a2[i2 + 1] = 0), a2[i2 + 1] += a2[i2] / r2 | 0, a2[i2] %= r2);
  }
  return a2.reverse();
}
function cosine$2(t4, n2) {
  var r2, i2, a2;
  if (n2.isZero()) return n2;
  i2 = n2.d.length, i2 < 32 ? (r2 = Math.ceil(i2 / 3), a2 = (1 / tinyPow$2(4, r2)).toString()) : (r2 = 16, a2 = `2.3283064365386962890625e-10`), t4.precision += r2, n2 = taylorSeries$2(t4, 1, n2.times(a2), new t4(1));
  for (var o2 = r2; o2--; ) {
    var s2 = n2.times(n2);
    n2 = s2.times(s2).minus(s2).times(8).plus(1);
  }
  return t4.precision -= r2, n2;
}
var divide$1$2 = /* @__PURE__ */ (function() {
  function t4(t5, n3, r3) {
    var i2, a2 = 0, o2 = t5.length;
    for (t5 = t5.slice(); o2--; ) i2 = t5[o2] * n3 + a2, t5[o2] = i2 % r3 | 0, a2 = i2 / r3 | 0;
    return a2 && t5.unshift(a2), t5;
  }
  function n2(t5, n3, r3, i2) {
    var a2, o2;
    if (r3 != i2) o2 = r3 > i2 ? 1 : -1;
    else for (a2 = o2 = 0; a2 < r3; a2++) if (t5[a2] != n3[a2]) {
      o2 = t5[a2] > n3[a2] ? 1 : -1;
      break;
    }
    return o2;
  }
  function r2(t5, n3, r3, i2) {
    for (var a2 = 0; r3--; ) t5[r3] -= a2, a2 = +(t5[r3] < n3[r3]), t5[r3] = a2 * i2 + t5[r3] - n3[r3];
    for (; !t5[0] && t5.length > 1; ) t5.shift();
  }
  return function(i2, a2, o2, s2, c2, l2) {
    var u2, d2, p2, m2, h2, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2, L2 = i2.constructor, R2 = i2.s == a2.s ? 1 : -1, z2 = i2.d, V2 = a2.d;
    if (!z2 || !z2[0] || !V2 || !V2[0]) return new L2(!i2.s || !a2.s || (z2 ? V2 && z2[0] == V2[0] : !V2) ? NaN : z2 && z2[0] == 0 || !V2 ? R2 * 0 : R2 / 0);
    for (l2 ? (h2 = 1, d2 = i2.e - a2.e) : (l2 = BASE$2, h2 = LOG_BASE$2, d2 = mathfloor$2(i2.e / h2) - mathfloor$2(a2.e / h2)), F = V2.length, M2 = z2.length, b2 = new L2(R2), x2 = b2.d = [], p2 = 0; V2[p2] == (z2[p2] || 0); p2++) ;
    if (V2[p2] > (z2[p2] || 0) && d2--, o2 == null ? (D = o2 = L2.precision, s2 = L2.rounding) : D = c2 ? o2 + (i2.e - a2.e) + 1 : o2, D < 0) x2.push(1), g2 = true;
    else {
      if (D = D / h2 + 2 | 0, p2 = 0, F == 1) {
        for (m2 = 0, V2 = V2[0], D++; (p2 < M2 || m2) && D--; p2++) O2 = m2 * l2 + (z2[p2] || 0), x2[p2] = O2 / V2 | 0, m2 = O2 % V2 | 0;
        g2 = m2 || p2 < M2;
      } else {
        for (m2 = l2 / (V2[0] + 1) | 0, m2 > 1 && (V2 = t4(V2, m2, l2), z2 = t4(z2, m2, l2), F = V2.length, M2 = z2.length), j2 = F, S2 = z2.slice(0, F), w2 = S2.length; w2 < F; ) S2[w2++] = 0;
        I2 = V2.slice(), I2.unshift(0), N2 = V2[0], V2[1] >= l2 / 2 && ++N2;
        do
          m2 = 0, u2 = n2(V2, S2, F, w2), u2 < 0 ? (E = S2[0], F != w2 && (E = E * l2 + (S2[1] || 0)), m2 = E / N2 | 0, m2 > 1 ? (m2 >= l2 && (m2 = l2 - 1), v2 = t4(V2, m2, l2), y2 = v2.length, w2 = S2.length, u2 = n2(v2, S2, y2, w2), u2 == 1 && (m2--, r2(v2, F < y2 ? I2 : V2, y2, l2))) : (m2 == 0 && (u2 = m2 = 1), v2 = V2.slice()), y2 = v2.length, y2 < w2 && v2.unshift(0), r2(S2, v2, w2, l2), u2 == -1 && (w2 = S2.length, u2 = n2(V2, S2, F, w2), u2 < 1 && (m2++, r2(S2, F < w2 ? I2 : V2, w2, l2))), w2 = S2.length) : u2 === 0 && (m2++, S2 = [0]), x2[p2++] = m2, u2 && S2[0] ? S2[w2++] = z2[j2] || 0 : (S2 = [z2[j2]], w2 = 1);
        while ((j2++ < M2 || S2[0] !== void 0) && D--);
        g2 = S2[0] !== void 0;
      }
      x2[0] || x2.shift();
    }
    if (h2 == 1) b2.e = d2, inexact$2 = g2;
    else {
      for (p2 = 1, m2 = x2[0]; m2 >= 10; m2 /= 10) p2++;
      b2.e = p2 + d2 * h2 - 1, finalise$2(b2, c2 ? o2 + b2.e + 1 : o2, s2, g2);
    }
    return b2;
  };
})();
function finalise$2(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor;
  out: if (n2 != null) {
    if (p2 = t4.d, !p2) return t4;
    for (a2 = 1, c2 = p2[0]; c2 >= 10; c2 /= 10) a2++;
    if (o2 = n2 - a2, o2 < 0) o2 += LOG_BASE$2, s2 = n2, d2 = p2[m2 = 0], l2 = d2 / mathpow$2(10, a2 - s2 - 1) % 10 | 0;
    else if (m2 = Math.ceil((o2 + 1) / LOG_BASE$2), c2 = p2.length, m2 >= c2) if (i2) {
      for (; c2++ <= m2; ) p2.push(0);
      d2 = l2 = 0, a2 = 1, o2 %= LOG_BASE$2, s2 = o2 - LOG_BASE$2 + 1;
    } else break out;
    else {
      for (d2 = c2 = p2[m2], a2 = 1; c2 >= 10; c2 /= 10) a2++;
      o2 %= LOG_BASE$2, s2 = o2 - LOG_BASE$2 + a2, l2 = s2 < 0 ? 0 : d2 / mathpow$2(10, a2 - s2 - 1) % 10 | 0;
    }
    if (i2 = i2 || n2 < 0 || p2[m2 + 1] !== void 0 || (s2 < 0 ? d2 : d2 % mathpow$2(10, a2 - s2 - 1)), u2 = r2 < 4 ? (l2 || i2) && (r2 == 0 || r2 == (t4.s < 0 ? 3 : 2)) : l2 > 5 || l2 == 5 && (r2 == 4 || i2 || r2 == 6 && (o2 > 0 ? s2 > 0 ? d2 / mathpow$2(10, a2 - s2) : 0 : p2[m2 - 1]) % 10 & 1 || r2 == (t4.s < 0 ? 8 : 7)), n2 < 1 || !p2[0]) return p2.length = 0, u2 ? (n2 -= t4.e + 1, p2[0] = mathpow$2(10, (LOG_BASE$2 - n2 % LOG_BASE$2) % LOG_BASE$2), t4.e = -n2 || 0) : p2[0] = t4.e = 0, t4;
    if (o2 == 0 ? (p2.length = m2, c2 = 1, m2--) : (p2.length = m2 + 1, c2 = mathpow$2(10, LOG_BASE$2 - o2), p2[m2] = s2 > 0 ? (d2 / mathpow$2(10, a2 - s2) % mathpow$2(10, s2) | 0) * c2 : 0), u2) for (; ; ) if (m2 == 0) {
      for (o2 = 1, s2 = p2[0]; s2 >= 10; s2 /= 10) o2++;
      for (s2 = p2[0] += c2, c2 = 1; s2 >= 10; s2 /= 10) c2++;
      o2 != c2 && (t4.e++, p2[0] == BASE$2 && (p2[0] = 1));
      break;
    } else {
      if (p2[m2] += c2, p2[m2] != BASE$2) break;
      p2[m2--] = 0, c2 = 1;
    }
    for (o2 = p2.length; p2[--o2] === 0; ) p2.pop();
  }
  return external$2 && (t4.e > h2.maxE ? (t4.d = null, t4.e = NaN) : t4.e < h2.minE && (t4.e = 0, t4.d = [0])), t4;
}
function finiteToString$2(t4, n2, r2) {
  if (!t4.isFinite()) return nonFiniteToString$2(t4);
  var i2, a2 = t4.e, o2 = digitsToString$2(t4.d), s2 = o2.length;
  return n2 ? (r2 && (i2 = r2 - s2) > 0 ? o2 = o2.charAt(0) + `.` + o2.slice(1) + getZeroString$2(i2) : s2 > 1 && (o2 = o2.charAt(0) + `.` + o2.slice(1)), o2 = o2 + (t4.e < 0 ? `e` : `e+`) + t4.e) : a2 < 0 ? (o2 = `0.` + getZeroString$2(-a2 - 1) + o2, r2 && (i2 = r2 - s2) > 0 && (o2 += getZeroString$2(i2))) : a2 >= s2 ? (o2 += getZeroString$2(a2 + 1 - s2), r2 && (i2 = r2 - a2 - 1) > 0 && (o2 = o2 + `.` + getZeroString$2(i2))) : ((i2 = a2 + 1) < s2 && (o2 = o2.slice(0, i2) + `.` + o2.slice(i2)), r2 && (i2 = r2 - s2) > 0 && (a2 + 1 === s2 && (o2 += `.`), o2 += getZeroString$2(i2))), o2;
}
function getBase10Exponent$2(t4, n2) {
  var r2 = t4[0];
  for (n2 *= LOG_BASE$2; r2 >= 10; r2 /= 10) n2++;
  return n2;
}
function getLn10$2(t4, n2, r2) {
  if (n2 > LN10_PRECISION$2) throw external$2 = true, r2 && (t4.precision = r2), Error(precisionLimitExceeded$2);
  return finalise$2(new t4(LN10$2), n2, 1, true);
}
function getPi$2(t4, n2, r2) {
  if (n2 > PI_PRECISION$2) throw Error(precisionLimitExceeded$2);
  return finalise$2(new t4(PI$2), n2, r2, true);
}
function getPrecision$2(t4) {
  var n2 = t4.length - 1, r2 = n2 * LOG_BASE$2 + 1;
  if (n2 = t4[n2], n2) {
    for (; n2 % 10 == 0; n2 /= 10) r2--;
    for (n2 = t4[0]; n2 >= 10; n2 /= 10) r2++;
  }
  return r2;
}
function getZeroString$2(t4) {
  for (var n2 = ``; t4--; ) n2 += `0`;
  return n2;
}
function intPow$2(t4, n2, r2, i2) {
  var a2, o2 = new t4(1), s2 = Math.ceil(i2 / LOG_BASE$2 + 4);
  for (external$2 = false; ; ) {
    if (r2 % 2 && (o2 = o2.times(n2), truncate$2(o2.d, s2) && (a2 = true)), r2 = mathfloor$2(r2 / 2), r2 === 0) {
      r2 = o2.d.length - 1, a2 && o2.d[r2] === 0 && ++o2.d[r2];
      break;
    }
    n2 = n2.times(n2), truncate$2(n2.d, s2);
  }
  return external$2 = true, o2;
}
function isOdd$2(t4) {
  return t4.d[t4.d.length - 1] & 1;
}
function maxOrMin$2(t4, n2, r2) {
  for (var i2, a2 = new t4(n2[0]), o2 = 0; ++o2 < n2.length; ) if (i2 = new t4(n2[o2]), i2.s) a2[r2](i2) && (a2 = i2);
  else {
    a2 = i2;
    break;
  }
  return a2;
}
function naturalExponential$2(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2 = 0, d2 = 0, p2 = 0, m2 = t4.constructor, h2 = m2.rounding, g2 = m2.precision;
  if (!t4.d || !t4.d[0] || t4.e > 17) return new m2(t4.d ? t4.d[0] ? t4.s < 0 ? 0 : 1 / 0 : 1 : t4.s ? t4.s < 0 ? 0 : t4 : NaN);
  for (n2 == null ? (external$2 = false, l2 = g2) : l2 = n2, c2 = new m2(0.03125); t4.e > -2; ) t4 = t4.times(c2), p2 += 5;
  for (i2 = Math.log(mathpow$2(2, p2)) / Math.LN10 * 2 + 5 | 0, l2 += i2, r2 = o2 = s2 = new m2(1), m2.precision = l2; ; ) {
    if (o2 = finalise$2(o2.times(t4), l2, 1), r2 = r2.times(++d2), c2 = s2.plus(divide$1$2(o2, r2, l2, 1)), digitsToString$2(c2.d).slice(0, l2) === digitsToString$2(s2.d).slice(0, l2)) {
      for (a2 = p2; a2--; ) s2 = finalise$2(s2.times(s2), l2, 1);
      if (n2 == null) if (u2 < 3 && checkRoundingDigits$2(s2.d, l2 - i2, h2, u2)) m2.precision = l2 += 10, r2 = o2 = c2 = new m2(1), d2 = 0, u2++;
      else return finalise$2(s2, m2.precision = g2, h2, external$2 = true);
      else return m2.precision = g2, s2;
    }
    s2 = c2;
  }
}
function naturalLogarithm$2(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = 1, g2 = 10, v2 = t4, y2 = v2.d, b2 = v2.constructor, x2 = b2.rounding, S2 = b2.precision;
  if (v2.s < 0 || !y2 || !y2[0] || !v2.e && y2[0] == 1 && y2.length == 1) return new b2(y2 && !y2[0] ? -1 / 0 : v2.s == 1 ? y2 ? 0 : v2 : NaN);
  if (n2 == null ? (external$2 = false, d2 = S2) : d2 = n2, b2.precision = d2 += g2, r2 = digitsToString$2(y2), i2 = r2.charAt(0), Math.abs(o2 = v2.e) < 15e14) {
    for (; i2 < 7 && i2 != 1 || i2 == 1 && r2.charAt(1) > 3; ) v2 = v2.times(t4), r2 = digitsToString$2(v2.d), i2 = r2.charAt(0), h2++;
    o2 = v2.e, i2 > 1 ? (v2 = new b2(`0.` + r2), o2++) : v2 = new b2(i2 + `.` + r2.slice(1));
  } else return u2 = getLn10$2(b2, d2 + 2, S2).times(o2 + ``), v2 = naturalLogarithm$2(new b2(i2 + `.` + r2.slice(1)), d2 - g2).plus(u2), b2.precision = S2, n2 == null ? finalise$2(v2, S2, x2, external$2 = true) : v2;
  for (p2 = v2, l2 = s2 = v2 = divide$1$2(v2.minus(1), v2.plus(1), d2, 1), m2 = finalise$2(v2.times(v2), d2, 1), a2 = 3; ; ) {
    if (s2 = finalise$2(s2.times(m2), d2, 1), u2 = l2.plus(divide$1$2(s2, new b2(a2), d2, 1)), digitsToString$2(u2.d).slice(0, d2) === digitsToString$2(l2.d).slice(0, d2)) if (l2 = l2.times(2), o2 !== 0 && (l2 = l2.plus(getLn10$2(b2, d2 + 2, S2).times(o2 + ``))), l2 = divide$1$2(l2, new b2(h2), d2, 1), n2 == null) if (checkRoundingDigits$2(l2.d, d2 - g2, x2, c2)) b2.precision = d2 += g2, u2 = s2 = v2 = divide$1$2(p2.minus(1), p2.plus(1), d2, 1), m2 = finalise$2(v2.times(v2), d2, 1), a2 = c2 = 1;
    else return finalise$2(l2, b2.precision = S2, x2, external$2 = true);
    else return b2.precision = S2, l2;
    l2 = u2, a2 += 2;
  }
}
function nonFiniteToString$2(t4) {
  return String(t4.s * t4.s / 0);
}
function parseDecimal$2(t4, n2) {
  var r2, i2, a2;
  for ((r2 = n2.indexOf(`.`)) > -1 && (n2 = n2.replace(`.`, ``)), (i2 = n2.search(/e/i)) > 0 ? (r2 < 0 && (r2 = i2), r2 += +n2.slice(i2 + 1), n2 = n2.substring(0, i2)) : r2 < 0 && (r2 = n2.length), i2 = 0; n2.charCodeAt(i2) === 48; i2++) ;
  for (a2 = n2.length; n2.charCodeAt(a2 - 1) === 48; --a2) ;
  if (n2 = n2.slice(i2, a2), n2) {
    if (a2 -= i2, t4.e = r2 = r2 - i2 - 1, t4.d = [], i2 = (r2 + 1) % LOG_BASE$2, r2 < 0 && (i2 += LOG_BASE$2), i2 < a2) {
      for (i2 && t4.d.push(+n2.slice(0, i2)), a2 -= LOG_BASE$2; i2 < a2; ) t4.d.push(+n2.slice(i2, i2 += LOG_BASE$2));
      n2 = n2.slice(i2), i2 = LOG_BASE$2 - n2.length;
    } else i2 -= a2;
    for (; i2--; ) n2 += `0`;
    t4.d.push(+n2), external$2 && (t4.e > t4.constructor.maxE ? (t4.d = null, t4.e = NaN) : t4.e < t4.constructor.minE && (t4.e = 0, t4.d = [0]));
  } else t4.e = 0, t4.d = [0];
  return t4;
}
function parseOther$2(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2;
  if (n2.indexOf(`_`) > -1) {
    if (n2 = n2.replace(/(\d)_(?=\d)/g, `$1`), isDecimal$2.test(n2)) return parseDecimal$2(t4, n2);
  } else if (n2 === `Infinity` || n2 === `NaN`) return +n2 || (t4.s = NaN), t4.e = NaN, t4.d = null, t4;
  if (isHex$2.test(n2)) r2 = 16, n2 = n2.toLowerCase();
  else if (isBinary$2.test(n2)) r2 = 2;
  else if (isOctal$2.test(n2)) r2 = 8;
  else throw Error(invalidArgument$2 + n2);
  for (o2 = n2.search(/p/i), o2 > 0 ? (l2 = +n2.slice(o2 + 1), n2 = n2.substring(2, o2)) : n2 = n2.slice(2), o2 = n2.indexOf(`.`), s2 = o2 >= 0, i2 = t4.constructor, s2 && (n2 = n2.replace(`.`, ``), c2 = n2.length, o2 = c2 - o2, a2 = intPow$2(i2, new i2(r2), o2, o2 * 2)), u2 = convertBase$2(n2, r2, BASE$2), d2 = u2.length - 1, o2 = d2; u2[o2] === 0; --o2) u2.pop();
  return o2 < 0 ? new i2(t4.s * 0) : (t4.e = getBase10Exponent$2(u2, d2), t4.d = u2, external$2 = false, s2 && (t4 = divide$1$2(t4, a2, c2 * 4)), l2 && (t4 = t4.times(Math.abs(l2) < 54 ? mathpow$2(2, l2) : Decimal$2.pow(2, l2))), external$2 = true, t4);
}
function sine$2(t4, n2) {
  var r2, i2 = n2.d.length;
  if (i2 < 3) return n2.isZero() ? n2 : taylorSeries$2(t4, 2, n2, n2);
  r2 = 1.4 * Math.sqrt(i2), r2 = r2 > 16 ? 16 : r2 | 0, n2 = n2.times(1 / tinyPow$2(5, r2)), n2 = taylorSeries$2(t4, 2, n2, n2);
  for (var a2, o2 = new t4(5), s2 = new t4(16), c2 = new t4(20); r2--; ) a2 = n2.times(n2), n2 = n2.times(o2.plus(a2.times(s2.times(a2).minus(c2))));
  return n2;
}
function taylorSeries$2(t4, n2, r2, i2, a2) {
  var o2, s2, c2, l2, d2 = t4.precision, p2 = Math.ceil(d2 / LOG_BASE$2);
  for (external$2 = false, l2 = r2.times(r2), c2 = new t4(i2); ; ) {
    if (s2 = divide$1$2(c2.times(l2), new t4(n2++ * n2++), d2, 1), c2 = a2 ? i2.plus(s2) : i2.minus(s2), i2 = divide$1$2(s2.times(l2), new t4(n2++ * n2++), d2, 1), s2 = c2.plus(i2), s2.d[p2] !== void 0) {
      for (o2 = p2; s2.d[o2] === c2.d[o2] && o2--; ) ;
      if (o2 == -1) break;
    }
    o2 = c2, c2 = i2, i2 = s2, s2 = o2;
  }
  return external$2 = true, s2.d.length = p2 + 1, s2;
}
function tinyPow$2(t4, n2) {
  for (var r2 = t4; --n2; ) r2 *= t4;
  return r2;
}
function toLessThanHalfPi$2(t4, n2) {
  var r2, i2 = n2.s < 0, a2 = getPi$2(t4, t4.precision, 1), o2 = a2.times(0.5);
  if (n2 = n2.abs(), n2.lte(o2)) return quadrant$2 = i2 ? 4 : 1, n2;
  if (r2 = n2.divToInt(a2), r2.isZero()) quadrant$2 = i2 ? 3 : 2;
  else {
    if (n2 = n2.minus(r2.times(a2)), n2.lte(o2)) return quadrant$2 = isOdd$2(r2) ? i2 ? 2 : 3 : i2 ? 4 : 1, n2;
    quadrant$2 = isOdd$2(r2) ? i2 ? 1 : 4 : i2 ? 3 : 2;
  }
  return n2.minus(a2).abs();
}
function toStringBinary$2(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor, g2 = r2 !== void 0;
  if (g2 ? (checkInt32$2(r2, 1, MAX_DIGITS$2), i2 === void 0 ? i2 = h2.rounding : checkInt32$2(i2, 0, 8)) : (r2 = h2.precision, i2 = h2.rounding), !t4.isFinite()) d2 = nonFiniteToString$2(t4);
  else {
    for (d2 = finiteToString$2(t4), s2 = d2.indexOf(`.`), g2 ? (a2 = 2, n2 == 16 ? r2 = r2 * 4 - 3 : n2 == 8 && (r2 = r2 * 3 - 2)) : a2 = n2, s2 >= 0 && (d2 = d2.replace(`.`, ``), m2 = new h2(1), m2.e = d2.length - s2, m2.d = convertBase$2(finiteToString$2(m2), 10, a2), m2.e = m2.d.length), p2 = convertBase$2(d2, 10, a2), o2 = l2 = p2.length; p2[--l2] == 0; ) p2.pop();
    if (!p2[0]) d2 = g2 ? `0p+0` : `0`;
    else {
      if (s2 < 0 ? o2-- : (t4 = new h2(t4), t4.d = p2, t4.e = o2, t4 = divide$1$2(t4, m2, r2, i2, 0, a2), p2 = t4.d, o2 = t4.e, u2 = inexact$2), s2 = p2[r2], c2 = a2 / 2, u2 ||= p2[r2 + 1] !== void 0, u2 = i2 < 4 ? (s2 !== void 0 || u2) && (i2 === 0 || i2 === (t4.s < 0 ? 3 : 2)) : s2 > c2 || s2 === c2 && (i2 === 4 || u2 || i2 === 6 && p2[r2 - 1] & 1 || i2 === (t4.s < 0 ? 8 : 7)), p2.length = r2, u2) for (; ++p2[--r2] > a2 - 1; ) p2[r2] = 0, r2 || (++o2, p2.unshift(1));
      for (l2 = p2.length; !p2[l2 - 1]; --l2) ;
      for (s2 = 0, d2 = ``; s2 < l2; s2++) d2 += NUMERALS$2.charAt(p2[s2]);
      if (g2) {
        if (l2 > 1) if (n2 == 16 || n2 == 8) {
          for (s2 = n2 == 16 ? 4 : 3, --l2; l2 % s2; l2++) d2 += `0`;
          for (p2 = convertBase$2(d2, a2, n2), l2 = p2.length; !p2[l2 - 1]; --l2) ;
          for (s2 = 1, d2 = `1.`; s2 < l2; s2++) d2 += NUMERALS$2.charAt(p2[s2]);
        } else d2 = d2.charAt(0) + `.` + d2.slice(1);
        d2 = d2 + (o2 < 0 ? `p` : `p+`) + o2;
      } else if (o2 < 0) {
        for (; ++o2; ) d2 = `0` + d2;
        d2 = `0.` + d2;
      } else if (++o2 > l2) for (o2 -= l2; o2--; ) d2 += `0`;
      else o2 < l2 && (d2 = d2.slice(0, o2) + `.` + d2.slice(o2));
    }
    d2 = (n2 == 16 ? `0x` : n2 == 2 ? `0b` : n2 == 8 ? `0o` : ``) + d2;
  }
  return t4.s < 0 ? `-` + d2 : d2;
}
function truncate$2(t4, n2) {
  if (t4.length > n2) return t4.length = n2, true;
}
function abs$1$2(t4) {
  return new this(t4).abs();
}
function acos$1$2(t4) {
  return new this(t4).acos();
}
function acosh$1$2(t4) {
  return new this(t4).acosh();
}
function add$1$2(t4, n2) {
  return new this(t4).plus(n2);
}
function asin$1$2(t4) {
  return new this(t4).asin();
}
function asinh$1$2(t4) {
  return new this(t4).asinh();
}
function atan$1$2(t4) {
  return new this(t4).atan();
}
function atanh$1$2(t4) {
  return new this(t4).atanh();
}
function atan2$1$2(t4, n2) {
  t4 = new this(t4), n2 = new this(n2);
  var r2, i2 = this.precision, a2 = this.rounding, o2 = i2 + 4;
  return !t4.s || !n2.s ? r2 = new this(NaN) : !t4.d && !n2.d ? (r2 = getPi$2(this, o2, 1).times(n2.s > 0 ? 0.25 : 0.75), r2.s = t4.s) : !n2.d || t4.isZero() ? (r2 = n2.s < 0 ? getPi$2(this, i2, a2) : new this(0), r2.s = t4.s) : !t4.d || n2.isZero() ? (r2 = getPi$2(this, o2, 1).times(0.5), r2.s = t4.s) : n2.s < 0 ? (this.precision = o2, this.rounding = 1, r2 = this.atan(divide$1$2(t4, n2, o2, 1)), n2 = getPi$2(this, o2, 1), this.precision = i2, this.rounding = a2, r2 = t4.s < 0 ? r2.minus(n2) : r2.plus(n2)) : r2 = this.atan(divide$1$2(t4, n2, o2, 1)), r2;
}
function cbrt$3(t4) {
  return new this(t4).cbrt();
}
function ceil$2(t4) {
  return finalise$2(t4 = new this(t4), t4.e + 1, 2);
}
function clamp$3(t4, n2, r2) {
  return new this(t4).clamp(n2, r2);
}
function config$5(t4) {
  if (!t4 || typeof t4 != `object`) throw Error(decimalError$2 + `Object expected`);
  var n2, r2, i2, a2 = t4.defaults === true, o2 = [`precision`, 1, MAX_DIGITS$2, `rounding`, 0, 8, `toExpNeg`, -EXP_LIMIT$2, 0, `toExpPos`, 0, EXP_LIMIT$2, `maxE`, 0, EXP_LIMIT$2, `minE`, -EXP_LIMIT$2, 0, `modulo`, 0, 9];
  for (n2 = 0; n2 < o2.length; n2 += 3) if (r2 = o2[n2], a2 && (this[r2] = DEFAULTS$2[r2]), (i2 = t4[r2]) !== void 0) if (mathfloor$2(i2) === i2 && i2 >= o2[n2 + 1] && i2 <= o2[n2 + 2]) this[r2] = i2;
  else throw Error(invalidArgument$2 + r2 + `: ` + i2);
  if (r2 = `crypto`, a2 && (this[r2] = DEFAULTS$2[r2]), (i2 = t4[r2]) !== void 0) if (i2 === true || i2 === false || i2 === 0 || i2 === 1) if (i2) if (typeof crypto < `u` && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[r2] = true;
  else throw Error(cryptoUnavailable$2);
  else this[r2] = false;
  else throw Error(invalidArgument$2 + r2 + `: ` + i2);
  return this;
}
function cos$1$2(t4) {
  return new this(t4).cos();
}
function cosh$2$2(t4) {
  return new this(t4).cosh();
}
function clone$2$2(t4) {
  var n2, r2, i2;
  function a2(t5) {
    var n3, r3, i3, o2 = this;
    if (!(o2 instanceof a2)) return new a2(t5);
    if (o2.constructor = a2, isDecimalInstance$2(t5)) {
      o2.s = t5.s, external$2 ? !t5.d || t5.e > a2.maxE ? (o2.e = NaN, o2.d = null) : t5.e < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = t5.e, o2.d = t5.d.slice()) : (o2.e = t5.e, o2.d = t5.d ? t5.d.slice() : t5.d);
      return;
    }
    if (i3 = typeof t5, i3 === `number`) {
      if (t5 === 0) {
        o2.s = 1 / t5 < 0 ? -1 : 1, o2.e = 0, o2.d = [0];
        return;
      }
      if (t5 < 0 ? (t5 = -t5, o2.s = -1) : o2.s = 1, t5 === ~~t5 && t5 < 1e7) {
        for (n3 = 0, r3 = t5; r3 >= 10; r3 /= 10) n3++;
        external$2 ? n3 > a2.maxE ? (o2.e = NaN, o2.d = null) : n3 < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = n3, o2.d = [t5]) : (o2.e = n3, o2.d = [t5]);
        return;
      } else if (t5 * 0 != 0) {
        t5 || (o2.s = NaN), o2.e = NaN, o2.d = null;
        return;
      }
      return parseDecimal$2(o2, t5.toString());
    } else if (i3 !== `string`) throw Error(invalidArgument$2 + t5);
    return (r3 = t5.charCodeAt(0)) === 45 ? (t5 = t5.slice(1), o2.s = -1) : (r3 === 43 && (t5 = t5.slice(1)), o2.s = 1), isDecimal$2.test(t5) ? parseDecimal$2(o2, t5) : parseOther$2(o2, t5);
  }
  if (a2.prototype = P$3$2, a2.ROUND_UP = 0, a2.ROUND_DOWN = 1, a2.ROUND_CEIL = 2, a2.ROUND_FLOOR = 3, a2.ROUND_HALF_UP = 4, a2.ROUND_HALF_DOWN = 5, a2.ROUND_HALF_EVEN = 6, a2.ROUND_HALF_CEIL = 7, a2.ROUND_HALF_FLOOR = 8, a2.EUCLID = 9, a2.config = a2.set = config$5, a2.clone = clone$2$2, a2.isDecimal = isDecimalInstance$2, a2.abs = abs$1$2, a2.acos = acos$1$2, a2.acosh = acosh$1$2, a2.add = add$1$2, a2.asin = asin$1$2, a2.asinh = asinh$1$2, a2.atan = atan$1$2, a2.atanh = atanh$1$2, a2.atan2 = atan2$1$2, a2.cbrt = cbrt$3, a2.ceil = ceil$2, a2.clamp = clamp$3, a2.cos = cos$1$2, a2.cosh = cosh$2$2, a2.div = div$2, a2.exp = exp$1$2, a2.floor = floor$3, a2.hypot = hypot$1$2, a2.ln = ln$3, a2.log = log$1$2, a2.log10 = log10$1$2, a2.log2 = log2$3, a2.max = max$1$2, a2.min = min$1$2, a2.mod = mod$1$2, a2.mul = mul$2, a2.pow = pow$1$2, a2.random = random$1$2, a2.round = round$3, a2.sign = sign$1$2, a2.sin = sin$1$2, a2.sinh = sinh$2$2, a2.sqrt = sqrt$1$2, a2.sub = sub$2, a2.sum = sum$2, a2.tan = tan$1$2, a2.tanh = tanh$1$2, a2.trunc = trunc$1$2, t4 === void 0 && (t4 = {}), t4 && t4.defaults !== true) for (i2 = [`precision`, `rounding`, `toExpNeg`, `toExpPos`, `maxE`, `minE`, `modulo`, `crypto`], n2 = 0; n2 < i2.length; ) t4.hasOwnProperty(r2 = i2[n2++]) || (t4[r2] = this[r2]);
  return a2.config(t4), a2;
}
function div$2(t4, n2) {
  return new this(t4).div(n2);
}
function exp$1$2(t4) {
  return new this(t4).exp();
}
function floor$3(t4) {
  return finalise$2(t4 = new this(t4), t4.e + 1, 3);
}
function hypot$1$2() {
  var t4, n2, r2 = new this(0);
  for (external$2 = false, t4 = 0; t4 < arguments.length; ) if (n2 = new this(arguments[t4++]), n2.d) r2.d && (r2 = r2.plus(n2.times(n2)));
  else {
    if (n2.s) return external$2 = true, new this(1 / 0);
    r2 = n2;
  }
  return external$2 = true, r2.sqrt();
}
function isDecimalInstance$2(t4) {
  return t4 instanceof Decimal$2 || t4 && t4.toStringTag === tag$2 || false;
}
function ln$3(t4) {
  return new this(t4).ln();
}
function log$1$2(t4, n2) {
  return new this(t4).log(n2);
}
function log2$3(t4) {
  return new this(t4).log(2);
}
function log10$1$2(t4) {
  return new this(t4).log(10);
}
function max$1$2() {
  return maxOrMin$2(this, arguments, `lt`);
}
function min$1$2() {
  return maxOrMin$2(this, arguments, `gt`);
}
function mod$1$2(t4, n2) {
  return new this(t4).mod(n2);
}
function mul$2(t4, n2) {
  return new this(t4).mul(n2);
}
function pow$1$2(t4, n2) {
  return new this(t4).pow(n2);
}
function random$1$2(t4) {
  var n2, r2, i2, a2, o2 = 0, s2 = new this(1), c2 = [];
  if (t4 === void 0 ? t4 = this.precision : checkInt32$2(t4, 1, MAX_DIGITS$2), i2 = Math.ceil(t4 / LOG_BASE$2), !this.crypto) for (; o2 < i2; ) c2[o2++] = Math.random() * 1e7 | 0;
  else if (crypto.getRandomValues) for (n2 = crypto.getRandomValues(new Uint32Array(i2)); o2 < i2; ) a2 = n2[o2], a2 >= 429e7 ? n2[o2] = crypto.getRandomValues(new Uint32Array(1))[0] : c2[o2++] = a2 % 1e7;
  else if (crypto.randomBytes) {
    for (n2 = crypto.randomBytes(i2 *= 4); o2 < i2; ) a2 = n2[o2] + (n2[o2 + 1] << 8) + (n2[o2 + 2] << 16) + ((n2[o2 + 3] & 127) << 24), a2 >= 214e7 ? crypto.randomBytes(4).copy(n2, o2) : (c2.push(a2 % 1e7), o2 += 4);
    o2 = i2 / 4;
  } else throw Error(cryptoUnavailable$2);
  for (i2 = c2[--o2], t4 %= LOG_BASE$2, i2 && t4 && (a2 = mathpow$2(10, LOG_BASE$2 - t4), c2[o2] = (i2 / a2 | 0) * a2); c2[o2] === 0; o2--) c2.pop();
  if (o2 < 0) r2 = 0, c2 = [0];
  else {
    for (r2 = -1; c2[0] === 0; r2 -= LOG_BASE$2) c2.shift();
    for (i2 = 1, a2 = c2[0]; a2 >= 10; a2 /= 10) i2++;
    i2 < LOG_BASE$2 && (r2 -= LOG_BASE$2 - i2);
  }
  return s2.e = r2, s2.d = c2, s2;
}
function round$3(t4) {
  return finalise$2(t4 = new this(t4), t4.e + 1, this.rounding);
}
function sign$1$2(t4) {
  return t4 = new this(t4), t4.d ? t4.d[0] ? t4.s : 0 * t4.s : t4.s || NaN;
}
function sin$1$2(t4) {
  return new this(t4).sin();
}
function sinh$2$2(t4) {
  return new this(t4).sinh();
}
function sqrt$1$2(t4) {
  return new this(t4).sqrt();
}
function sub$2(t4, n2) {
  return new this(t4).sub(n2);
}
function sum$2() {
  var t4 = 0, n2 = arguments, r2 = new this(n2[t4]);
  for (external$2 = false; r2.s && ++t4 < n2.length; ) r2 = r2.plus(n2[t4]);
  return external$2 = true, finalise$2(r2, this.precision, this.rounding);
}
function tan$1$2(t4) {
  return new this(t4).tan();
}
function tanh$1$2(t4) {
  return new this(t4).tanh();
}
function trunc$1$2(t4) {
  return finalise$2(t4 = new this(t4), t4.e + 1, 1);
}
P$3$2[/* @__PURE__ */ Symbol.for(`nodejs.util.inspect.custom`)] = P$3$2.toString, P$3$2[Symbol.toStringTag] = `Decimal`;
var Decimal$2 = P$3$2.constructor = clone$2$2(DEFAULTS$2);
LN10$2 = new Decimal$2(LN10$2), PI$2 = new Decimal$2(PI$2);
var name$320$2 = `BigNumber`, dependencies$320$2 = [`?on`, `config`], createBigNumberClass$2 = factory$2(name$320$2, dependencies$320$2, (t4) => {
  var { on: n2, config: r2 } = t4, i2 = Decimal$2.clone({ precision: r2.precision, modulo: Decimal$2.EUCLID });
  return i2.prototype = Object.create(i2.prototype), i2.prototype.type = `BigNumber`, i2.prototype.isBigNumber = true, i2.prototype.toJSON = function() {
    return { mathjs: `BigNumber`, value: this.toString() };
  }, i2.fromJSON = function(t5) {
    return new i2(t5.value);
  }, n2 && n2(`config`, function(t5, n3) {
    t5.precision !== n3.precision && i2.config({ precision: t5.precision });
  }), i2;
}, { isClass: true }), cosh$1$2 = Math.cosh || function(t4) {
  return Math.abs(t4) < 1e-9 ? 1 - t4 : (Math.exp(t4) + Math.exp(-t4)) * 0.5;
}, sinh$1$2 = Math.sinh || function(t4) {
  return Math.abs(t4) < 1e-9 ? t4 : (Math.exp(t4) - Math.exp(-t4)) * 0.5;
}, cosm1$2 = function(t4) {
  let n2 = Math.PI / 4;
  if (-n2 > t4 || t4 > n2) return Math.cos(t4) - 1;
  let r2 = t4 * t4;
  return r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, hypot$3 = function(t4, n2) {
  return t4 = Math.abs(t4), n2 = Math.abs(n2), t4 < n2 && ([t4, n2] = [n2, t4]), t4 < 1e8 ? Math.sqrt(t4 * t4 + n2 * n2) : (n2 /= t4, t4 * Math.sqrt(1 + n2 * n2));
}, parser_exit$2 = function() {
  throw SyntaxError(`Invalid Param`);
};
function logHypot$2(t4, n2) {
  let r2 = Math.abs(t4), i2 = Math.abs(n2);
  return t4 === 0 ? Math.log(i2) : n2 === 0 ? Math.log(r2) : r2 < 3e3 && i2 < 3e3 ? Math.log(t4 * t4 + n2 * n2) * 0.5 : (t4 *= 0.5, n2 *= 0.5, 0.5 * Math.log(t4 * t4 + n2 * n2) + Math.LN2);
}
var P$2$2 = { re: 0, im: 0 }, parse$1$2 = function(t4, n2) {
  let r2 = P$2$2;
  if (t4 == null) r2.re = r2.im = 0;
  else if (n2 !== void 0) r2.re = t4, r2.im = n2;
  else switch (typeof t4) {
    case `object`:
      if (`im` in t4 && `re` in t4) r2.re = t4.re, r2.im = t4.im;
      else if (`abs` in t4 && `arg` in t4) {
        if (!isFinite(t4.abs) && isFinite(t4.arg)) return Complex$2.INFINITY;
        r2.re = t4.abs * Math.cos(t4.arg), r2.im = t4.abs * Math.sin(t4.arg);
      } else if (`r` in t4 && `phi` in t4) {
        if (!isFinite(t4.r) && isFinite(t4.phi)) return Complex$2.INFINITY;
        r2.re = t4.r * Math.cos(t4.phi), r2.im = t4.r * Math.sin(t4.phi);
      } else t4.length === 2 ? (r2.re = t4[0], r2.im = t4[1]) : parser_exit$2();
      break;
    case `string`:
      r2.im = r2.re = 0;
      let n3 = t4.replace(/_/g, ``).match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i2 = 1, a2 = 0;
      n3 === null && parser_exit$2();
      for (let t5 = 0; t5 < n3.length; t5++) {
        let o2 = n3[t5];
        o2 === ` ` || o2 === `	` || o2 === `
` || (o2 === `+` ? i2++ : o2 === `-` ? a2++ : o2 === `i` || o2 === `I` ? (i2 + a2 === 0 && parser_exit$2(), n3[t5 + 1] !== ` ` && !isNaN(n3[t5 + 1]) ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + n3[t5 + 1]), t5++) : r2.im += parseFloat((a2 % 2 ? `-` : ``) + `1`), i2 = a2 = 0) : ((i2 + a2 === 0 || isNaN(o2)) && parser_exit$2(), n3[t5 + 1] === `i` || n3[t5 + 1] === `I` ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + o2), t5++) : r2.re += parseFloat((a2 % 2 ? `-` : ``) + o2), i2 = a2 = 0));
      }
      i2 + a2 > 0 && parser_exit$2();
      break;
    case `number`:
      r2.im = 0, r2.re = t4;
      break;
    default:
      parser_exit$2();
  }
  return isNaN(r2.re) || isNaN(r2.im), r2;
};
function Complex$2(t4, n2) {
  if (!(this instanceof Complex$2)) return new Complex$2(t4, n2);
  let r2 = parse$1$2(t4, n2);
  this.re = r2.re, this.im = r2.im;
}
Complex$2.prototype = { re: 0, im: 0, sign: function() {
  let t4 = hypot$3(this.re, this.im);
  return new Complex$2(this.re / t4, this.im / t4);
}, add: function(t4, n2) {
  let r2 = parse$1$2(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex$2.NAN : Complex$2.INFINITY : new Complex$2(this.re + r2.re, this.im + r2.im);
}, sub: function(t4, n2) {
  let r2 = parse$1$2(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex$2.NAN : Complex$2.INFINITY : new Complex$2(this.re - r2.re, this.im - r2.im);
}, mul: function(t4, n2) {
  let r2 = parse$1$2(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  return i2 && s2 || a2 && o2 ? Complex$2.NAN : i2 || a2 ? Complex$2.INFINITY : r2.im === 0 && this.im === 0 ? new Complex$2(this.re * r2.re, 0) : new Complex$2(this.re * r2.re - this.im * r2.im, this.re * r2.im + this.im * r2.re);
}, div: function(t4, n2) {
  let r2 = parse$1$2(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  if (o2 && s2 || i2 && a2) return Complex$2.NAN;
  if (s2 || i2) return Complex$2.INFINITY;
  if (o2 || a2) return Complex$2.ZERO;
  if (r2.im === 0) return new Complex$2(this.re / r2.re, this.im / r2.re);
  if (Math.abs(r2.re) < Math.abs(r2.im)) {
    let t5 = r2.re / r2.im, n3 = r2.re * t5 + r2.im;
    return new Complex$2((this.re * t5 + this.im) / n3, (this.im * t5 - this.re) / n3);
  } else {
    let t5 = r2.im / r2.re, n3 = r2.im * t5 + r2.re;
    return new Complex$2((this.re + this.im * t5) / n3, (this.im - this.re * t5) / n3);
  }
}, pow: function(t4, n2) {
  let r2 = parse$1$2(t4, n2), i2 = this.re === 0 && this.im === 0;
  if (r2.re === 0 && r2.im === 0) return Complex$2.ONE;
  if (r2.im === 0) {
    if (this.im === 0 && this.re > 0) return new Complex$2(this.re ** +r2.re, 0);
    if (this.re === 0) switch ((r2.re % 4 + 4) % 4) {
      case 0:
        return new Complex$2(this.im ** +r2.re, 0);
      case 1:
        return new Complex$2(0, this.im ** +r2.re);
      case 2:
        return new Complex$2(-(this.im ** +r2.re), 0);
      case 3:
        return new Complex$2(0, -(this.im ** +r2.re));
    }
  }
  if (i2 && r2.re > 0) return Complex$2.ZERO;
  let a2 = Math.atan2(this.im, this.re), o2 = logHypot$2(this.re, this.im), s2 = Math.exp(r2.re * o2 - r2.im * a2), c2 = r2.im * o2 + r2.re * a2;
  return new Complex$2(s2 * Math.cos(c2), s2 * Math.sin(c2));
}, sqrt: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return t4 >= 0 ? new Complex$2(Math.sqrt(t4), 0) : new Complex$2(0, Math.sqrt(-t4));
  let r2 = hypot$3(t4, n2), i2 = Math.sqrt(0.5 * (r2 + Math.abs(t4))), a2 = Math.abs(n2) / (2 * i2);
  return t4 >= 0 ? new Complex$2(i2, n2 < 0 ? -a2 : a2) : new Complex$2(a2, n2 < 0 ? -i2 : i2);
}, exp: function() {
  let t4 = Math.exp(this.re);
  return this.im === 0 ? new Complex$2(t4, 0) : new Complex$2(t4 * Math.cos(this.im), t4 * Math.sin(this.im));
}, expm1: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$2(Math.expm1(t4) * Math.cos(n2) + cosm1$2(n2), Math.exp(t4) * Math.sin(n2));
}, log: function() {
  let t4 = this.re, n2 = this.im;
  return n2 === 0 && t4 > 0 ? new Complex$2(Math.log(t4), 0) : new Complex$2(logHypot$2(t4, n2), Math.atan2(n2, t4));
}, abs: function() {
  return hypot$3(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$2(Math.sin(t4) * cosh$1$2(n2), Math.cos(t4) * sinh$1$2(n2));
}, cos: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$2(Math.cos(t4) * cosh$1$2(n2), -Math.sin(t4) * sinh$1$2(n2));
}, tan: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) + cosh$1$2(n2);
  return new Complex$2(Math.sin(t4) / r2, sinh$1$2(n2) / r2);
}, cot: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) - cosh$1$2(n2);
  return new Complex$2(-Math.sin(t4) / r2, sinh$1$2(n2) / r2);
}, sec: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1$2(2 * n2) + 0.5 * Math.cos(2 * t4);
  return new Complex$2(Math.cos(t4) * cosh$1$2(n2) / r2, Math.sin(t4) * sinh$1$2(n2) / r2);
}, csc: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1$2(2 * n2) - 0.5 * Math.cos(2 * t4);
  return new Complex$2(Math.sin(t4) * cosh$1$2(n2) / r2, -Math.cos(t4) * sinh$1$2(n2) / r2);
}, asin: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex$2(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex$2(r2.re - n2, r2.im + t4).log();
  return new Complex$2(i2.im, -i2.re);
}, acos: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex$2(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex$2(r2.re - n2, r2.im + t4).log();
  return new Complex$2(Math.PI / 2 - i2.im, i2.re);
}, atan: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0) {
    if (n2 === 1) return new Complex$2(0, 1 / 0);
    if (n2 === -1) return new Complex$2(0, -1 / 0);
  }
  let r2 = t4 * t4 + (1 - n2) * (1 - n2), i2 = new Complex$2((1 - n2 * n2 - t4 * t4) / r2, -2 * t4 / r2).log();
  return new Complex$2(-0.5 * i2.im, 0.5 * i2.re);
}, acot: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex$2(Math.atan2(1, t4), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atan() : new Complex$2(t4 / r2, -n2 / r2).atan();
}, asec: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$2(0, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acos() : new Complex$2(t4 / r2, -n2 / r2).acos();
}, acsc: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$2(Math.PI / 2, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asin() : new Complex$2(t4 / r2, -n2 / r2).asin();
}, sinh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$2(sinh$1$2(t4) * Math.cos(n2), cosh$1$2(t4) * Math.sin(n2));
}, cosh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$2(cosh$1$2(t4) * Math.cos(n2), sinh$1$2(t4) * Math.sin(n2));
}, tanh: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1$2(t4) + Math.cos(n2);
  return new Complex$2(sinh$1$2(t4) / r2, Math.sin(n2) / r2);
}, coth: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1$2(t4) - Math.cos(n2);
  return new Complex$2(sinh$1$2(t4) / r2, -Math.sin(n2) / r2);
}, csch: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) - cosh$1$2(2 * t4);
  return new Complex$2(-2 * sinh$1$2(t4) * Math.cos(n2) / r2, 2 * cosh$1$2(t4) * Math.sin(n2) / r2);
}, sech: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) + cosh$1$2(2 * t4);
  return new Complex$2(2 * cosh$1$2(t4) * Math.cos(n2) / r2, -2 * sinh$1$2(t4) * Math.sin(n2) / r2);
}, asinh: function() {
  let t4 = this.im;
  this.im = -this.re, this.re = t4;
  let n2 = this.asin();
  return this.re = -this.im, this.im = t4, t4 = n2.re, n2.re = -n2.im, n2.im = t4, n2;
}, acosh: function() {
  let t4 = this.acos();
  if (t4.im <= 0) {
    let n2 = t4.re;
    t4.re = -t4.im, t4.im = n2;
  } else {
    let n2 = t4.im;
    t4.im = -t4.re, t4.re = n2;
  }
  return t4;
}, atanh: function() {
  let t4 = this.re, n2 = this.im, r2 = t4 > 1 && n2 === 0, i2 = 1 - t4, a2 = 1 + t4, o2 = i2 * i2 + n2 * n2, s2 = o2 === 0 ? new Complex$2(t4 === -1 ? 0 : t4 / 0, n2 === 0 ? 0 : n2 / 0) : new Complex$2((a2 * i2 - n2 * n2) / o2, (n2 * i2 + a2 * n2) / o2), c2 = s2.re;
  return s2.re = logHypot$2(s2.re, s2.im) / 2, s2.im = Math.atan2(s2.im, c2) / 2, r2 && (s2.im = -s2.im), s2;
}, acoth: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$2(0, Math.PI / 2);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atanh() : new Complex$2(t4 / r2, -n2 / r2).atanh();
}, acsch: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex$2(t4 === 0 ? 1 / 0 : Math.log(t4 + Math.sqrt(t4 * t4 + 1)), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asinh() : new Complex$2(t4 / r2, -n2 / r2).asinh();
}, asech: function() {
  let t4 = this.re, n2 = this.im;
  if (this.isZero()) return Complex$2.INFINITY;
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$2(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acosh() : new Complex$2(t4 / r2, -n2 / r2).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex$2.INFINITY;
  if (this.isInfinite()) return Complex$2.ZERO;
  let t4 = this.re, n2 = this.im, r2 = t4 * t4 + n2 * n2;
  return new Complex$2(t4 / r2, -n2 / r2);
}, conjugate: function() {
  return new Complex$2(this.re, -this.im);
}, neg: function() {
  return new Complex$2(-this.re, -this.im);
}, ceil: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$2(Math.ceil(this.re * t4) / t4, Math.ceil(this.im * t4) / t4);
}, floor: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$2(Math.floor(this.re * t4) / t4, Math.floor(this.im * t4) / t4);
}, round: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$2(Math.round(this.re * t4) / t4, Math.round(this.im * t4) / t4);
}, equals: function(t4, n2) {
  let r2 = parse$1$2(t4, n2);
  return Math.abs(r2.re - this.re) <= Complex$2.EPSILON && Math.abs(r2.im - this.im) <= Complex$2.EPSILON;
}, clone: function() {
  return new Complex$2(this.re, this.im);
}, toString: function() {
  let t4 = this.re, n2 = this.im, r2 = ``;
  return this.isNaN() ? `NaN` : this.isInfinite() ? `Infinity` : (Math.abs(t4) < Complex$2.EPSILON && (t4 = 0), Math.abs(n2) < Complex$2.EPSILON && (n2 = 0), n2 === 0 ? r2 + t4 : (t4 === 0 ? n2 < 0 && (n2 = -n2, r2 += `-`) : (r2 += t4, r2 += ` `, n2 < 0 ? (n2 = -n2, r2 += `-`) : r2 += `+`, r2 += ` `), n2 !== 1 && (r2 += n2), r2 + `i`));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return this.im === 0 ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return this.im === 0 && this.re === 0;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex$2.ZERO = new Complex$2(0, 0), Complex$2.ONE = new Complex$2(1, 0), Complex$2.I = new Complex$2(0, 1), Complex$2.PI = new Complex$2(Math.PI, 0), Complex$2.E = new Complex$2(Math.E, 0), Complex$2.INFINITY = new Complex$2(1 / 0, 1 / 0), Complex$2.NAN = new Complex$2(NaN, NaN), Complex$2.EPSILON = 1e-15;
var name$319$2 = `Complex`, dependencies$319$2 = [], createComplexClass$2 = factory$2(name$319$2, dependencies$319$2, () => (Object.defineProperty(Complex$2, "name", { value: `Complex` }), Complex$2.prototype.constructor = Complex$2, Complex$2.prototype.type = `Complex`, Complex$2.prototype.isComplex = true, Complex$2.prototype.toJSON = function() {
  return { mathjs: `Complex`, re: this.re, im: this.im };
}, Complex$2.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex$2.prototype.format = function(t4) {
  var n2 = ``, r2 = this.im, i2 = this.re, a2 = format$2$2(this.re, t4), o2 = format$2$2(this.im, t4), s2 = isNumber$2(t4) ? t4 : t4 ? t4.precision : null;
  if (s2 !== null) {
    var c2 = 10 ** -s2;
    Math.abs(i2 / r2) < c2 && (i2 = 0), Math.abs(r2 / i2) < c2 && (r2 = 0);
  }
  return n2 = r2 === 0 ? a2 : i2 === 0 ? r2 === 1 ? `i` : r2 === -1 ? `-i` : o2 + `i` : r2 < 0 ? r2 === -1 ? a2 + ` - i` : a2 + ` - ` + o2.substring(1) + `i` : r2 === 1 ? a2 + ` + i` : a2 + ` + ` + o2 + `i`, n2;
}, Complex$2.fromPolar = function(t4) {
  switch (arguments.length) {
    case 1:
      var n2 = arguments[0];
      if (typeof n2 == `object`) return Complex$2(n2);
      throw TypeError(`Input has to be an object with r and phi keys.`);
    case 2:
      var r2 = arguments[0], i2 = arguments[1];
      if (isNumber$2(r2)) {
        if (isUnit$2(i2) && i2.hasBase(`ANGLE`) && (i2 = i2.toNumber(`rad`)), isNumber$2(i2)) return new Complex$2({ r: r2, phi: i2 });
        throw TypeError(`Phi is not a number nor an angle unit.`);
      } else throw TypeError(`Radius r is not a number.`);
    default:
      throw SyntaxError(`Wrong number of arguments in function fromPolar`);
  }
}, Complex$2.prototype.valueOf = Complex$2.prototype.toString, Complex$2.fromJSON = function(t4) {
  return new Complex$2(t4);
}, Complex$2.compare = function(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}, Complex$2), { isClass: true });
typeof BigInt > `u` && (BigInt = function(t4) {
  if (isNaN(t4)) throw Error(``);
  return t4;
});
var C_ZERO$2 = BigInt(0), C_ONE$2 = BigInt(1), C_TWO$2 = BigInt(2), C_FIVE$2 = BigInt(5), C_TEN$2 = BigInt(10), MAX_CYCLE_LEN$2 = 2e3, P$1$2 = { s: C_ONE$2, n: C_ZERO$2, d: C_ONE$2 };
function assign$2(t4, n2) {
  try {
    t4 = BigInt(t4);
  } catch {
    throw InvalidParameter$2();
  }
  return t4 * n2;
}
function trunc$3(t4) {
  return typeof t4 == `bigint` ? t4 : Math.floor(t4);
}
function newFraction$2(t4, n2) {
  if (n2 === C_ZERO$2) throw DivisionByZero$2();
  let r2 = Object.create(Fraction$2.prototype);
  r2.s = t4 < C_ZERO$2 ? -C_ONE$2 : C_ONE$2, t4 = t4 < C_ZERO$2 ? -t4 : t4;
  let i2 = gcd$1$2(t4, n2);
  return r2.n = t4 / i2, r2.d = n2 / i2, r2;
}
function factorize$2(t4) {
  let n2 = {}, r2 = t4, i2 = C_TWO$2, a2 = C_FIVE$2 - C_ONE$2;
  for (; a2 <= r2; ) {
    for (; r2 % i2 === C_ZERO$2; ) r2 /= i2, n2[i2] = (n2[i2] || C_ZERO$2) + C_ONE$2;
    a2 += C_ONE$2 + C_TWO$2 * i2++;
  }
  return r2 === t4 ? n2[t4] = (n2[t4] || C_ZERO$2) + C_ONE$2 : r2 > 1 && (n2[r2] = (n2[r2] || C_ZERO$2) + C_ONE$2), n2;
}
var parse$5 = function(t4, n2) {
  let r2 = C_ZERO$2, i2 = C_ONE$2, a2 = C_ONE$2;
  if (t4 != null) if (n2 !== void 0) {
    if (typeof t4 == `bigint`) r2 = t4;
    else if (isNaN(t4)) throw InvalidParameter$2();
    else if (t4 % 1 != 0) throw NonIntegerParameter$2();
    else r2 = BigInt(t4);
    if (typeof n2 == `bigint`) i2 = n2;
    else if (isNaN(n2)) throw InvalidParameter$2();
    else if (n2 % 1 != 0) throw NonIntegerParameter$2();
    else i2 = BigInt(n2);
    a2 = r2 * i2;
  } else if (typeof t4 == `object`) {
    if (`d` in t4 && `n` in t4) r2 = BigInt(t4.n), i2 = BigInt(t4.d), `s` in t4 && (r2 *= BigInt(t4.s));
    else if (0 in t4) r2 = BigInt(t4[0]), 1 in t4 && (i2 = BigInt(t4[1]));
    else if (typeof t4 == `bigint`) r2 = t4;
    else throw InvalidParameter$2();
    a2 = r2 * i2;
  } else if (typeof t4 == `number`) {
    if (isNaN(t4)) throw InvalidParameter$2();
    if (t4 < 0 && (a2 = -C_ONE$2, t4 = -t4), t4 % 1 == 0) r2 = BigInt(t4);
    else {
      let n3 = 1, a3 = 0, o2 = 1, s2 = 1, c2 = 1, l2 = 1e7;
      for (t4 >= 1 && (n3 = 10 ** Math.floor(1 + Math.log10(t4)), t4 /= n3); o2 <= l2 && c2 <= l2; ) {
        let n4 = (a3 + s2) / (o2 + c2);
        if (t4 === n4) {
          o2 + c2 <= l2 ? (r2 = a3 + s2, i2 = o2 + c2) : c2 > o2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
          break;
        } else t4 > n4 ? (a3 += s2, o2 += c2) : (s2 += a3, c2 += o2), o2 > l2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
      }
      r2 = BigInt(r2) * BigInt(n3), i2 = BigInt(i2);
    }
  } else if (typeof t4 == `string`) {
    let n3 = 0, o2 = C_ZERO$2, s2 = C_ZERO$2, c2 = C_ZERO$2, l2 = C_ONE$2, u2 = C_ONE$2, d2 = t4.replace(/_/g, ``).match(/\d+|./g);
    if (d2 === null) throw InvalidParameter$2();
    if (d2[n3] === `-` ? (a2 = -C_ONE$2, n3++) : d2[n3] === `+` && n3++, d2.length === n3 + 1 ? s2 = assign$2(d2[n3++], a2) : d2[n3 + 1] === `.` || d2[n3] === `.` ? (d2[n3] !== `.` && (o2 = assign$2(d2[n3++], a2)), n3++, (n3 + 1 === d2.length || d2[n3 + 1] === `(` && d2[n3 + 3] === `)` || d2[n3 + 1] === `'` && d2[n3 + 3] === `'`) && (s2 = assign$2(d2[n3], a2), l2 = C_TEN$2 ** BigInt(d2[n3].length), n3++), (d2[n3] === `(` && d2[n3 + 2] === `)` || d2[n3] === `'` && d2[n3 + 2] === `'`) && (c2 = assign$2(d2[n3 + 1], a2), u2 = C_TEN$2 ** BigInt(d2[n3 + 1].length) - C_ONE$2, n3 += 3)) : d2[n3 + 1] === `/` || d2[n3 + 1] === `:` ? (s2 = assign$2(d2[n3], a2), l2 = assign$2(d2[n3 + 2], C_ONE$2), n3 += 3) : d2[n3 + 3] === `/` && d2[n3 + 1] === ` ` && (o2 = assign$2(d2[n3], a2), s2 = assign$2(d2[n3 + 2], a2), l2 = assign$2(d2[n3 + 4], C_ONE$2), n3 += 5), d2.length <= n3) i2 = l2 * u2, a2 = r2 = c2 + i2 * o2 + u2 * s2;
    else throw InvalidParameter$2();
  } else if (typeof t4 == `bigint`) r2 = t4, a2 = t4, i2 = C_ONE$2;
  else throw InvalidParameter$2();
  if (i2 === C_ZERO$2) throw DivisionByZero$2();
  P$1$2.s = a2 < C_ZERO$2 ? -C_ONE$2 : C_ONE$2, P$1$2.n = r2 < C_ZERO$2 ? -r2 : r2, P$1$2.d = i2 < C_ZERO$2 ? -i2 : i2;
};
function modpow$2(t4, n2, r2) {
  let i2 = C_ONE$2;
  for (; n2 > C_ZERO$2; t4 = t4 * t4 % r2, n2 >>= C_ONE$2) n2 & C_ONE$2 && (i2 = i2 * t4 % r2);
  return i2;
}
function cycleLen$2(t4, n2) {
  for (; n2 % C_TWO$2 === C_ZERO$2; n2 /= C_TWO$2) ;
  for (; n2 % C_FIVE$2 === C_ZERO$2; n2 /= C_FIVE$2) ;
  if (n2 === C_ONE$2) return C_ZERO$2;
  let r2 = C_TEN$2 % n2, i2 = 1;
  for (; r2 !== C_ONE$2; i2++) if (r2 = r2 * C_TEN$2 % n2, i2 > MAX_CYCLE_LEN$2) return C_ZERO$2;
  return BigInt(i2);
}
function cycleStart$2(t4, n2, r2) {
  let i2 = C_ONE$2, a2 = modpow$2(C_TEN$2, r2, n2);
  for (let t5 = 0; t5 < 300; t5++) {
    if (i2 === a2) return BigInt(t5);
    i2 = i2 * C_TEN$2 % n2, a2 = a2 * C_TEN$2 % n2;
  }
  return 0;
}
function gcd$1$2(t4, n2) {
  if (!t4) return n2;
  if (!n2) return t4;
  for (; ; ) {
    if (t4 %= n2, !t4) return n2;
    if (n2 %= t4, !n2) return t4;
  }
}
function Fraction$2(t4, n2) {
  if (parse$5(t4, n2), this instanceof Fraction$2) t4 = gcd$1$2(P$1$2.d, P$1$2.n), this.s = P$1$2.s, this.n = P$1$2.n / t4, this.d = P$1$2.d / t4;
  else return newFraction$2(P$1$2.s * P$1$2.n, P$1$2.d);
}
var DivisionByZero$2 = function() {
  return Error(`Division by Zero`);
}, InvalidParameter$2 = function() {
  return Error(`Invalid argument`);
}, NonIntegerParameter$2 = function() {
  return Error(`Parameters must be integer`);
};
Fraction$2.prototype = { s: C_ONE$2, n: C_ZERO$2, d: C_ONE$2, abs: function() {
  return newFraction$2(this.n, this.d);
}, neg: function() {
  return newFraction$2(-this.s * this.n, this.d);
}, add: function(t4, n2) {
  return parse$5(t4, n2), newFraction$2(this.s * this.n * P$1$2.d + P$1$2.s * this.d * P$1$2.n, this.d * P$1$2.d);
}, sub: function(t4, n2) {
  return parse$5(t4, n2), newFraction$2(this.s * this.n * P$1$2.d - P$1$2.s * this.d * P$1$2.n, this.d * P$1$2.d);
}, mul: function(t4, n2) {
  return parse$5(t4, n2), newFraction$2(this.s * P$1$2.s * this.n * P$1$2.n, this.d * P$1$2.d);
}, div: function(t4, n2) {
  return parse$5(t4, n2), newFraction$2(this.s * P$1$2.s * this.n * P$1$2.d, this.d * P$1$2.n);
}, clone: function() {
  return newFraction$2(this.s * this.n, this.d);
}, mod: function(t4, n2) {
  if (t4 === void 0) return newFraction$2(this.s * this.n % this.d, C_ONE$2);
  if (parse$5(t4, n2), C_ZERO$2 === P$1$2.n * this.d) throw DivisionByZero$2();
  return newFraction$2(this.s * (P$1$2.d * this.n) % (P$1$2.n * this.d), P$1$2.d * this.d);
}, gcd: function(t4, n2) {
  return parse$5(t4, n2), newFraction$2(gcd$1$2(P$1$2.n, this.n) * gcd$1$2(P$1$2.d, this.d), P$1$2.d * this.d);
}, lcm: function(t4, n2) {
  return parse$5(t4, n2), P$1$2.n === C_ZERO$2 && this.n === C_ZERO$2 ? newFraction$2(C_ZERO$2, C_ONE$2) : newFraction$2(P$1$2.n * this.n, gcd$1$2(P$1$2.n, this.n) * gcd$1$2(P$1$2.d, this.d));
}, inverse: function() {
  return newFraction$2(this.s * this.d, this.n);
}, pow: function(t4, n2) {
  if (parse$5(t4, n2), P$1$2.d === C_ONE$2) return P$1$2.s < C_ZERO$2 ? newFraction$2((this.s * this.d) ** P$1$2.n, this.n ** P$1$2.n) : newFraction$2((this.s * this.n) ** P$1$2.n, this.d ** P$1$2.n);
  if (this.s < C_ZERO$2) return null;
  let r2 = factorize$2(this.n), i2 = factorize$2(this.d), a2 = C_ONE$2, o2 = C_ONE$2;
  for (let t5 in r2) if (t5 !== `1`) {
    if (t5 === `0`) {
      a2 = C_ZERO$2;
      break;
    }
    if (r2[t5] *= P$1$2.n, r2[t5] % P$1$2.d === C_ZERO$2) r2[t5] /= P$1$2.d;
    else return null;
    a2 *= BigInt(t5) ** r2[t5];
  }
  for (let t5 in i2) if (t5 !== `1`) {
    if (i2[t5] *= P$1$2.n, i2[t5] % P$1$2.d === C_ZERO$2) i2[t5] /= P$1$2.d;
    else return null;
    o2 *= BigInt(t5) ** i2[t5];
  }
  return P$1$2.s < C_ZERO$2 ? newFraction$2(o2, a2) : newFraction$2(a2, o2);
}, log: function(t4, n2) {
  if (parse$5(t4, n2), this.s <= C_ZERO$2 || P$1$2.s <= C_ZERO$2) return null;
  let r2 = {}, i2 = factorize$2(P$1$2.n), a2 = factorize$2(P$1$2.d), o2 = factorize$2(this.n), s2 = factorize$2(this.d);
  for (let t5 in a2) i2[t5] = (i2[t5] || C_ZERO$2) - a2[t5];
  for (let t5 in s2) o2[t5] = (o2[t5] || C_ZERO$2) - s2[t5];
  for (let t5 in i2) t5 !== `1` && (r2[t5] = true);
  for (let t5 in o2) t5 !== `1` && (r2[t5] = true);
  let c2 = null, l2 = null;
  for (let t5 in r2) {
    let n3 = i2[t5] || C_ZERO$2, r3 = o2[t5] || C_ZERO$2;
    if (n3 === C_ZERO$2) {
      if (r3 !== C_ZERO$2) return null;
      continue;
    }
    let a3 = r3, s3 = n3, u2 = gcd$1$2(a3, s3);
    if (a3 /= u2, s3 /= u2, c2 === null && l2 === null) c2 = a3, l2 = s3;
    else if (a3 * l2 !== c2 * s3) return null;
  }
  return c2 !== null && l2 !== null ? newFraction$2(c2, l2) : null;
}, equals: function(t4, n2) {
  return parse$5(t4, n2), this.s * this.n * P$1$2.d === P$1$2.s * P$1$2.n * this.d;
}, lt: function(t4, n2) {
  return parse$5(t4, n2), this.s * this.n * P$1$2.d < P$1$2.s * P$1$2.n * this.d;
}, lte: function(t4, n2) {
  return parse$5(t4, n2), this.s * this.n * P$1$2.d <= P$1$2.s * P$1$2.n * this.d;
}, gt: function(t4, n2) {
  return parse$5(t4, n2), this.s * this.n * P$1$2.d > P$1$2.s * P$1$2.n * this.d;
}, gte: function(t4, n2) {
  return parse$5(t4, n2), this.s * this.n * P$1$2.d >= P$1$2.s * P$1$2.n * this.d;
}, compare: function(t4, n2) {
  parse$5(t4, n2);
  let r2 = this.s * this.n * P$1$2.d - P$1$2.s * P$1$2.n * this.d;
  return (C_ZERO$2 < r2) - (r2 < C_ZERO$2);
}, ceil: function(t4) {
  return t4 = C_TEN$2 ** BigInt(t4 || 0), newFraction$2(trunc$3(this.s * t4 * this.n / this.d) + (t4 * this.n % this.d > C_ZERO$2 && this.s >= C_ZERO$2 ? C_ONE$2 : C_ZERO$2), t4);
}, floor: function(t4) {
  return t4 = C_TEN$2 ** BigInt(t4 || 0), newFraction$2(trunc$3(this.s * t4 * this.n / this.d) - (t4 * this.n % this.d > C_ZERO$2 && this.s < C_ZERO$2 ? C_ONE$2 : C_ZERO$2), t4);
}, round: function(t4) {
  return t4 = C_TEN$2 ** BigInt(t4 || 0), newFraction$2(trunc$3(this.s * t4 * this.n / this.d) + this.s * ((this.s >= C_ZERO$2 ? C_ONE$2 : C_ZERO$2) + C_TWO$2 * (t4 * this.n % this.d) > this.d ? C_ONE$2 : C_ZERO$2), t4);
}, roundTo: function(t4, n2) {
  parse$5(t4, n2);
  let r2 = this.n * P$1$2.d, i2 = this.d * P$1$2.n, a2 = r2 % i2, o2 = trunc$3(r2 / i2);
  return a2 + a2 >= i2 && o2++, newFraction$2(this.s * o2 * P$1$2.n, P$1$2.d);
}, divisible: function(t4, n2) {
  return parse$5(t4, n2), !(!(P$1$2.n * this.d) || this.n * P$1$2.d % (P$1$2.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(t4) {
  let n2 = this.n, r2 = this.d;
  t4 ||= 15;
  let i2 = cycleLen$2(n2, r2), a2 = cycleStart$2(n2, r2, i2), o2 = this.s < C_ZERO$2 ? `-` : ``;
  if (o2 += trunc$3(n2 / r2), n2 %= r2, n2 *= C_TEN$2, n2 && (o2 += `.`), i2) {
    for (let t5 = a2; t5--; ) o2 += trunc$3(n2 / r2), n2 %= r2, n2 *= C_TEN$2;
    o2 += `(`;
    for (let t5 = i2; t5--; ) o2 += trunc$3(n2 / r2), n2 %= r2, n2 *= C_TEN$2;
    o2 += `)`;
  } else for (let i3 = t4; n2 && i3--; ) o2 += trunc$3(n2 / r2), n2 %= r2, n2 *= C_TEN$2;
  return o2;
}, toFraction: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO$2 ? `-` : ``;
  if (r2 === C_ONE$2) i2 += n2;
  else {
    let a2 = trunc$3(n2 / r2);
    t4 && a2 > C_ZERO$2 && (i2 += a2, i2 += ` `, n2 %= r2), i2 += n2, i2 += `/`, i2 += r2;
  }
  return i2;
}, toLatex: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO$2 ? `-` : ``;
  if (r2 === C_ONE$2) i2 += n2;
  else {
    let a2 = trunc$3(n2 / r2);
    t4 && a2 > C_ZERO$2 && (i2 += a2, n2 %= r2), i2 += `\\frac{`, i2 += n2, i2 += `}{`, i2 += r2, i2 += `}`;
  }
  return i2;
}, toContinued: function() {
  let t4 = this.n, n2 = this.d, r2 = [];
  do {
    r2.push(trunc$3(t4 / n2));
    let i2 = t4 % n2;
    t4 = n2, n2 = i2;
  } while (t4 !== C_ONE$2);
  return r2;
}, simplify: function(t4) {
  let n2 = BigInt(1 / (t4 || 1e-3) | 0), r2 = this.abs(), i2 = r2.toContinued();
  for (let t5 = 1; t5 < i2.length; t5++) {
    let a2 = newFraction$2(i2[t5 - 1], C_ONE$2);
    for (let n3 = t5 - 2; n3 >= 0; n3--) a2 = a2.inverse().add(i2[n3]);
    let o2 = a2.sub(r2);
    if (o2.n * n2 < o2.d) return a2.mul(this.s);
  }
  return this;
} };
var name$318$2 = `Fraction`, dependencies$318$2 = [], createFractionClass$2 = factory$2(name$318$2, dependencies$318$2, () => (Object.defineProperty(Fraction$2, "name", { value: `Fraction` }), Fraction$2.prototype.constructor = Fraction$2, Fraction$2.prototype.type = `Fraction`, Fraction$2.prototype.isFraction = true, Fraction$2.prototype.toJSON = function() {
  return { mathjs: `Fraction`, n: String(this.s * this.n), d: String(this.d) };
}, Fraction$2.fromJSON = function(t4) {
  return new Fraction$2(t4);
}, Fraction$2), { isClass: true }), name$317$2 = `Range`, dependencies$317$2 = [], createRangeClass$2 = factory$2(name$317$2, dependencies$317$2, () => {
  function t4(n2, r2, i2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    var a2 = n2 != null, o2 = r2 != null, s2 = i2 != null;
    if (a2) {
      if (isBigNumber$2(n2)) n2 = n2.toNumber();
      else if (typeof n2 != `number` && !isBigInt$2(n2)) throw TypeError(`Parameter start must be a number or bigint`);
    }
    if (o2) {
      if (isBigNumber$2(r2)) r2 = r2.toNumber();
      else if (typeof r2 != `number` && !isBigInt$2(r2)) throw TypeError(`Parameter end must be a number or bigint`);
    }
    if (s2) {
      if (isBigNumber$2(i2)) i2 = i2.toNumber();
      else if (typeof i2 != `number` && !isBigInt$2(i2)) throw TypeError(`Parameter step must be a number or bigint`);
    }
    if (this.start = a2 ? parseFloat(n2) : 0, this.end = o2 ? parseFloat(r2) : 0, this.step = s2 ? parseFloat(i2) : 1, s2 && nearlyEqual$1$2(this.step, 0)) throw Error(`Step must not be zero`);
  }
  return t4.prototype.type = `Range`, t4.prototype.isRange = true, t4.parse = function(n2) {
    if (typeof n2 != `string`) return null;
    var r2 = n2.split(`:`).map(function(t5) {
      return parseFloat(t5);
    });
    if (r2.some(function(t5) {
      return isNaN(t5);
    })) return null;
    switch (r2.length) {
      case 2:
        return new t4(r2[0], r2[1]);
      case 3:
        return new t4(r2[0], r2[2], r2[1]);
      default:
        return null;
    }
  }, t4.prototype.clone = function() {
    return new t4(this.start, this.end, this.step);
  }, t4.prototype.size = function() {
    var t5 = 0, n2 = this.start, r2 = this.step, i2 = this.end - n2;
    return sign$2$2(r2) === sign$2$2(i2) ? t5 = Math.ceil(i2 / r2) : i2 === 0 && (t5 = 0), isNaN(t5) && (t5 = 0), [t5];
  }, t4.prototype.min = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start : this.start + (t5 - 1) * this.step;
  }, t4.prototype.max = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start + (t5 - 1) * this.step : this.start;
  }, t4.prototype.forEach = function(t5) {
    var n2 = this.start, r2 = this.step, i2 = this.end, a2 = 0;
    if (r2 > 0) for (; n2 < i2; ) t5(n2, [a2], this), n2 += r2, a2++;
    else if (r2 < 0) for (; n2 > i2; ) t5(n2, [a2], this), n2 += r2, a2++;
  }, t4.prototype.map = function(t5) {
    var n2 = [];
    return this.forEach(function(r2, i2, a2) {
      n2[i2[0]] = t5(r2, i2, a2);
    }), n2;
  }, t4.prototype.toArray = function() {
    var t5 = [];
    return this.forEach(function(n2, r2) {
      t5[r2[0]] = n2;
    }), t5;
  }, t4.prototype.valueOf = function() {
    return this.toArray();
  }, t4.prototype.format = function(t5) {
    var n2 = format$2$2(this.start, t5);
    return this.step !== 1 && (n2 += `:` + format$2$2(this.step, t5)), n2 += `:` + format$2$2(this.end, t5), n2;
  }, t4.prototype.toString = function() {
    return this.format();
  }, t4.prototype.toJSON = function() {
    return { mathjs: `Range`, start: this.start, end: this.end, step: this.step };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.start, n2.end, n2.step);
  }, t4;
}, { isClass: true }), name$316$2 = `Matrix`, dependencies$316$2 = [], createMatrixClass$2 = factory$2(name$316$2, dependencies$316$2, () => {
  function t4() {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
  }
  return t4.prototype.type = `Matrix`, t4.prototype.isMatrix = true, t4.prototype.storage = function() {
    throw Error(`Cannot invoke storage on a Matrix interface`);
  }, t4.prototype.datatype = function() {
    throw Error(`Cannot invoke datatype on a Matrix interface`);
  }, t4.prototype.create = function(t5, n2) {
    throw Error(`Cannot invoke create on a Matrix interface`);
  }, t4.prototype.subset = function(t5, n2, r2) {
    throw Error(`Cannot invoke subset on a Matrix interface`);
  }, t4.prototype.get = function(t5) {
    throw Error(`Cannot invoke get on a Matrix interface`);
  }, t4.prototype.set = function(t5, n2, r2) {
    throw Error(`Cannot invoke set on a Matrix interface`);
  }, t4.prototype.resize = function(t5, n2) {
    throw Error(`Cannot invoke resize on a Matrix interface`);
  }, t4.prototype.reshape = function(t5, n2) {
    throw Error(`Cannot invoke reshape on a Matrix interface`);
  }, t4.prototype.clone = function() {
    throw Error(`Cannot invoke clone on a Matrix interface`);
  }, t4.prototype.size = function() {
    throw Error(`Cannot invoke size on a Matrix interface`);
  }, t4.prototype.map = function(t5, n2) {
    throw Error(`Cannot invoke map on a Matrix interface`);
  }, t4.prototype.forEach = function(t5) {
    throw Error(`Cannot invoke forEach on a Matrix interface`);
  }, t4.prototype[Symbol.iterator] = function() {
    throw Error(`Cannot iterate a Matrix interface`);
  }, t4.prototype.toArray = function() {
    throw Error(`Cannot invoke toArray on a Matrix interface`);
  }, t4.prototype.valueOf = function() {
    throw Error(`Cannot invoke valueOf on a Matrix interface`);
  }, t4.prototype.format = function(t5) {
    throw Error(`Cannot invoke format on a Matrix interface`);
  }, t4.prototype.toString = function() {
    throw Error(`Cannot invoke toString on a Matrix interface`);
  }, t4;
}, { isClass: true });
function formatBigNumberToBase$2(t4, n2, r2) {
  var i2 = t4.constructor, a2 = new i2(2), o2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger$3(r2)) throw Error(`size must be an integer`);
    if (t4.greaterThan(a2.pow(r2 - 1).sub(1)) || t4.lessThan(a2.pow(r2 - 1).mul(-1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!t4.isInteger()) throw Error(`Value must be an integer`);
    t4.lessThan(0) && (t4 = t4.add(a2.pow(r2))), o2 = `i${r2}`;
  }
  switch (n2) {
    case 2:
      return `${t4.toBinary()}${o2}`;
    case 8:
      return `${t4.toOctal()}${o2}`;
    case 16:
      return `${t4.toHexadecimal()}${o2}`;
    default:
      throw Error(`Base ${n2} not supported `);
  }
}
function format$1$2(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (!t4.isFinite()) return t4.isNaN() ? `NaN` : t4.gt(0) ? `Infinity` : `-Infinity`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions$2(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$1$2(t4, i2);
    case `exponential`:
      return toExponential$3(t4, i2);
    case `engineering`:
      return toEngineering$3(t4, i2);
    case `bin`:
      return formatBigNumberToBase$2(t4, 2, a2);
    case `oct`:
      return formatBigNumberToBase$2(t4, 8, a2);
    case `hex`:
      return formatBigNumberToBase$2(t4, 16, a2);
    case `auto`:
      var o2 = _toNumberOrDefault$3(n2?.lowerExp, -3), s2 = _toNumberOrDefault$3(n2?.upperExp, 5);
      if (t4.isZero()) return `0`;
      var c2, l2 = t4.toSignificantDigits(i2), u2 = l2.e;
      return c2 = u2 >= o2 && u2 < s2 ? l2.toFixed() : toExponential$3(t4, i2), c2.replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function toEngineering$3(t4, n2) {
  var r2 = t4.e, i2 = r2 % 3 == 0 ? r2 : r2 < 0 ? r2 - 3 - r2 % 3 : r2 - r2 % 3, a2 = t4.mul(10 ** -i2).toPrecision(n2);
  if (a2.includes(`e`)) {
    var o2 = t4.constructor;
    a2 = new o2(a2).toFixed();
  }
  return a2 + `e` + (r2 >= 0 ? `+` : ``) + i2.toString();
}
function toExponential$3(t4, n2) {
  return n2 === void 0 ? t4.toExponential() : t4.toExponential(n2 - 1);
}
function toFixed$1$2(t4, n2) {
  return t4.toFixed(n2);
}
function _toNumberOrDefault$3(t4, n2) {
  return isNumber$2(t4) ? t4 : isBigNumber$2(t4) ? t4.toNumber() : n2;
}
function endsWith$2(t4, n2) {
  var r2 = t4.length - n2.length, i2 = t4.length;
  return t4.substring(r2, i2) === n2;
}
function format$4(t4, n2) {
  var r2 = _format$2(t4, n2);
  return n2 && typeof n2 == `object` && `truncate` in n2 && r2.length > n2.truncate ? r2.substring(0, n2.truncate - 3) + `...` : r2;
}
function _format$2(t4, n2) {
  return typeof t4 == `number` ? format$2$2(t4, n2) : isBigNumber$2(t4) ? format$1$2(t4, n2) : looksLikeFraction$2(t4) ? !n2 || n2.fraction !== `decimal` ? `${t4.s * t4.n}/${t4.d}` : t4.toString() : Array.isArray(t4) ? formatArray$2(t4, n2) : isString$2(t4) ? stringify$2(t4) : typeof t4 == `function` ? t4.syntax ? String(t4.syntax) : `function` : t4 && typeof t4 == `object` ? typeof t4.format == `function` ? t4.format(n2) : t4 && t4.toString(n2) !== {}.toString() ? t4.toString(n2) : `{` + Object.keys(t4).map((r2) => stringify$2(r2) + `: ` + format$4(t4[r2], n2)).join(`, `) + `}` : String(t4);
}
function stringify$2(t4) {
  for (var n2 = String(t4), r2 = ``, i2 = 0; i2 < n2.length; ) {
    var a2 = n2.charAt(i2);
    r2 += a2 in controlCharacters$2 ? controlCharacters$2[a2] : a2, i2++;
  }
  return `"` + r2 + `"`;
}
var controlCharacters$2 = { '"': `\\"`, "\\": `\\\\`, "\b": `\\b`, "\f": `\\f`, "\n": `\\n`, "\r": `\\r`, "	": `\\t` };
function escape$4(t4) {
  var n2 = String(t4);
  return n2 = n2.replace(/&/g, `&amp;`).replace(/"/g, `&quot;`).replace(/'/g, `&#39;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`), n2;
}
function formatArray$2(t4, n2) {
  if (Array.isArray(t4)) {
    for (var r2 = `[`, i2 = t4.length, a2 = 0; a2 < i2; a2++) a2 !== 0 && (r2 += `, `), r2 += formatArray$2(t4[a2], n2);
    return r2 += `]`, r2;
  } else return format$4(t4, n2);
}
function looksLikeFraction$2(t4) {
  return t4 && typeof t4 == `object` && typeof t4.s == `bigint` && typeof t4.n == `bigint` && typeof t4.d == `bigint` || false;
}
function compareText$2(t4, n2) {
  if (!isString$2(t4)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf$2(t4) + `, index: 0)`);
  if (!isString$2(n2)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf$2(n2) + `, index: 1)`);
  return t4 === n2 ? 0 : t4 > n2 ? 1 : -1;
}
function DimensionError$2(t4, n2, r2) {
  if (!(this instanceof DimensionError$2)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.actual = t4, this.expected = n2, this.relation = r2, this.message = `Dimension mismatch (` + (Array.isArray(t4) ? `[` + t4.join(`, `) + `]` : t4) + ` ` + (this.relation || `!=`) + ` ` + (Array.isArray(n2) ? `[` + n2.join(`, `) + `]` : n2) + `)`, this.stack = Error().stack;
}
DimensionError$2.prototype = RangeError(), DimensionError$2.prototype.constructor = RangeError, DimensionError$2.prototype.name = `DimensionError`, DimensionError$2.prototype.isDimensionError = true;
function IndexError$2(t4, n2, r2) {
  if (!(this instanceof IndexError$2)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.index = t4, arguments.length < 3 ? (this.min = 0, this.max = n2) : (this.min = n2, this.max = r2), this.min !== void 0 && this.index < this.min ? this.message = `Index out of range (` + this.index + ` < ` + this.min + `)` : this.max !== void 0 && this.index >= this.max ? this.message = `Index out of range (` + this.index + ` > ` + (this.max - 1) + `)` : this.message = `Index out of range (` + this.index + `)`, this.stack = Error().stack;
}
IndexError$2.prototype = RangeError(), IndexError$2.prototype.constructor = RangeError, IndexError$2.prototype.name = `IndexError`, IndexError$2.prototype.isIndexError = true;
function arraySize$2(t4) {
  for (var n2 = []; Array.isArray(t4); ) n2.push(t4.length), t4 = t4[0];
  return n2;
}
function _validate$2(t4, n2, r2) {
  var i2, a2 = t4.length;
  if (a2 !== n2[r2]) throw new DimensionError$2(a2, n2[r2]);
  if (r2 < n2.length - 1) {
    var o2 = r2 + 1;
    for (i2 = 0; i2 < a2; i2++) {
      var s2 = t4[i2];
      if (!Array.isArray(s2)) throw new DimensionError$2(n2.length - 1, n2.length, `<`);
      _validate$2(t4[i2], n2, o2);
    }
  } else for (i2 = 0; i2 < a2; i2++) if (Array.isArray(t4[i2])) throw new DimensionError$2(n2.length + 1, n2.length, `>`);
}
function validate$2(t4, n2) {
  if (n2.length === 0) {
    if (Array.isArray(t4)) throw new DimensionError$2(t4.length, 0);
  } else _validate$2(t4, n2, 0);
}
function validateIndexSourceSize$2(t4, n2) {
  var r2 = t4.isMatrix ? t4._size : arraySize$2(t4);
  n2._sourceSize.forEach((t5, n3) => {
    if (t5 !== null && t5 !== r2[n3]) throw new DimensionError$2(t5, r2[n3]);
  });
}
function validateIndex$2(t4, n2) {
  if (t4 !== void 0) {
    if (!isNumber$2(t4) || !isInteger$3(t4)) throw TypeError(`Index must be an integer (value: ` + t4 + `)`);
    if (t4 < 0 || typeof n2 == `number` && t4 >= n2) throw new IndexError$2(t4, n2);
  }
}
function isEmptyIndex$2(t4) {
  for (var n2 = 0; n2 < t4._dimensions.length; ++n2) {
    var r2 = t4._dimensions[n2];
    if (r2._data && isArray$3(r2._data)) {
      if (r2._size[0] === 0) return true;
    } else if (r2.isRange) {
      if (r2.start === r2.end) return true;
    } else if (isString$2(r2) && r2.length === 0) return true;
  }
  return false;
}
function resize$2(t4, n2, r2) {
  if (!Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw Error(`Resizing to scalar is not supported`);
  return n2.forEach(function(t5) {
    if (!isNumber$2(t5) || !isInteger$3(t5) || t5 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$4(n2) + `)`);
  }), (isNumber$2(t4) || isBigNumber$2(t4)) && (t4 = [t4]), _resize$2(t4, n2, 0, r2 === void 0 ? 0 : r2), t4;
}
function _resize$2(t4, n2, r2, i2) {
  var a2, o2, s2 = t4.length, c2 = n2[r2], l2 = Math.min(s2, c2);
  if (t4.length = c2, r2 < n2.length - 1) {
    var u2 = r2 + 1;
    for (a2 = 0; a2 < l2; a2++) o2 = t4[a2], Array.isArray(o2) || (o2 = [o2], t4[a2] = o2), _resize$2(o2, n2, u2, i2);
    for (a2 = l2; a2 < c2; a2++) o2 = [], t4[a2] = o2, _resize$2(o2, n2, u2, i2);
  } else {
    for (a2 = 0; a2 < l2; a2++) for (; Array.isArray(t4[a2]); ) t4[a2] = t4[a2][0];
    for (a2 = l2; a2 < c2; a2++) t4[a2] = i2;
  }
}
function reshape$2(t4, n2) {
  var r2 = flatten$4$2(t4, true), i2 = r2.length;
  if (!Array.isArray(t4) || !Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw new DimensionError$2(0, i2, `!=`);
  n2 = processSizesWildcard$2(n2, i2);
  var a2 = product$1$2(n2);
  if (i2 !== a2) throw new DimensionError$2(a2, i2, `!=`);
  try {
    return _reshape$2(r2, n2);
  } catch (t5) {
    throw t5 instanceof DimensionError$2 ? new DimensionError$2(a2, i2, `!=`) : t5;
  }
}
function processSizesWildcard$2(t4, n2) {
  var r2 = product$1$2(t4), i2 = t4.slice(), a2 = -1, o2 = t4.indexOf(a2);
  if (t4.indexOf(a2, o2 + 1) >= 0) throw Error(`More than one wildcard in sizes`);
  var s2 = o2 >= 0, c2 = n2 % r2 === 0;
  if (s2) if (c2) i2[o2] = -n2 / r2;
  else throw Error(`Could not replace wildcard, since ` + n2 + ` is no multiple of ` + -r2);
  return i2;
}
function product$1$2(t4) {
  return t4.reduce((t5, n2) => t5 * n2, 1);
}
function _reshape$2(t4, n2) {
  for (var r2 = t4, i2, a2 = n2.length - 1; a2 > 0; a2--) {
    var o2 = n2[a2];
    i2 = [];
    for (var s2 = r2.length / o2, c2 = 0; c2 < s2; c2++) i2.push(r2.slice(c2 * o2, (c2 + 1) * o2));
    r2 = i2;
  }
  return r2;
}
function squeeze$2(t4, n2) {
  for (var r2 = arraySize$2(t4); Array.isArray(t4) && t4.length === 1; ) t4 = t4[0], r2.shift();
  for (var i2 = r2.length; r2[i2 - 1] === 1; ) i2--;
  return i2 < r2.length && (t4 = _squeeze$2(t4, i2, 0), r2.length = i2), t4;
}
function _squeeze$2(t4, n2, r2) {
  var i2, a2;
  if (r2 < n2) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _squeeze$2(t4[i2], n2, o2);
  } else for (; Array.isArray(t4); ) t4 = t4[0];
  return t4;
}
function unsqueeze$2(t4, n2, r2, i2) {
  var a2 = i2 || arraySize$2(t4);
  if (r2) for (var o2 = 0; o2 < r2; o2++) t4 = [t4], a2.unshift(1);
  for (t4 = _unsqueeze$2(t4, n2, 0); a2.length < n2; ) a2.push(1);
  return t4;
}
function _unsqueeze$2(t4, n2, r2) {
  var i2, a2;
  if (Array.isArray(t4)) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _unsqueeze$2(t4[i2], n2, o2);
  } else for (var s2 = r2; s2 < n2; s2++) t4 = [t4];
  return t4;
}
function flatten$4$2(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (!Array.isArray(t4)) return t4;
  if (typeof n2 != `boolean`) throw TypeError(`Boolean expected for second argument of flatten`);
  var r2 = [];
  return n2 ? a2(t4) : i2(t4), r2;
  function i2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      var a3 = t5[n3];
      Array.isArray(a3) ? i2(a3) : r2.push(a3);
    }
  }
  function a2(t5) {
    if (Array.isArray(t5[0])) for (var n3 = 0; n3 < t5.length; n3++) a2(t5[n3]);
    else for (var i3 = 0; i3 < t5.length; i3++) r2.push(t5[i3]);
  }
}
function map$1$2(t4, n2) {
  return Array.prototype.map.call(t4, n2);
}
function forEach$2(t4, n2) {
  Array.prototype.forEach.call(t4, n2);
}
function filter$1$2(t4, n2) {
  if (arraySize$2(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, n2);
}
function filterRegExp$2(t4, n2) {
  if (arraySize$2(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, (t5) => n2.test(t5));
}
function join$5(t4, n2) {
  return Array.prototype.join.call(t4, n2);
}
function identify$2(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  var n2 = [], r2 = 0;
  n2[0] = { value: t4[0], identifier: 0 };
  for (var i2 = 1; i2 < t4.length; i2++) t4[i2] === t4[i2 - 1] ? r2++ : r2 = 0, n2.push({ value: t4[i2], identifier: r2 });
  return n2;
}
function generalize$2(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  for (var n2 = [], r2 = 0; r2 < t4.length; r2++) n2.push(t4[r2].value);
  return n2;
}
function getArrayDataType$2(t4, n2) {
  for (var r2, i2 = 0, a2 = 0; a2 < t4.length; a2++) {
    var o2 = t4[a2], s2 = Array.isArray(o2);
    if (a2 === 0 && s2 && (i2 = o2.length), s2 && o2.length !== i2) return;
    var c2 = s2 ? getArrayDataType$2(o2, n2) : n2(o2);
    if (r2 === void 0) r2 = c2;
    else if (r2 !== c2) return `mixed`;
  }
  return r2;
}
function concatRecursive$2(t4, n2, r2, i2) {
  if (i2 < r2) {
    if (t4.length !== n2.length) throw new DimensionError$2(t4.length, n2.length);
    for (var a2 = [], o2 = 0; o2 < t4.length; o2++) a2[o2] = concatRecursive$2(t4[o2], n2[o2], r2, i2 + 1);
    return a2;
  } else return t4.concat(n2);
}
function concat$2() {
  var t4 = Array.prototype.slice.call(arguments, 0, -1), n2 = Array.prototype.slice.call(arguments, -1);
  if (t4.length === 1) return t4[0];
  if (t4.length > 1) return t4.slice(1).reduce(function(t5, r2) {
    return concatRecursive$2(t5, r2, n2, 0);
  }, t4[0]);
  throw Error(`Wrong number of arguments in function concat`);
}
function broadcastSizes$2() {
  for (var t4 = [...arguments], n2 = t4.map((t5) => t5.length), r2 = Math.max(...n2), i2 = Array(r2).fill(null), a2 = 0; a2 < t4.length; a2++) for (var o2 = t4[a2], s2 = n2[a2], c2 = 0; c2 < s2; c2++) {
    var l2 = r2 - s2 + c2;
    o2[c2] > i2[l2] && (i2[l2] = o2[c2]);
  }
  for (var u2 = 0; u2 < t4.length; u2++) checkBroadcastingRules$2(t4[u2], i2);
  return i2;
}
function checkBroadcastingRules$2(t4, n2) {
  for (var r2 = n2.length, i2 = t4.length, a2 = 0; a2 < i2; a2++) {
    var o2 = r2 - i2 + a2;
    if (t4[a2] < n2[o2] && t4[a2] > 1 || t4[a2] > n2[o2]) throw Error(`shape mismatch: mismatch is found in arg with shape (${t4}) not possible to broadcast dimension ${i2} with size ${t4[a2]} to size ${n2[o2]}`);
  }
}
function broadcastTo$2(t4, n2) {
  var r2 = arraySize$2(t4);
  if (deepStrictEqual$2(r2, n2)) return t4;
  checkBroadcastingRules$2(r2, n2);
  var i2 = broadcastSizes$2(r2, n2), a2 = i2.length, o2 = [...Array(a2 - r2.length).fill(1), ...r2], s2 = clone$1$2(t4);
  r2.length < a2 && (s2 = reshape$2(s2, o2), r2 = arraySize$2(s2));
  for (var c2 = 0; c2 < a2; c2++) r2[c2] < i2[c2] && (s2 = stretch$2(s2, i2[c2], c2), r2 = arraySize$2(s2));
  return s2;
}
function stretch$2(t4, n2, r2) {
  return concat$2(...Array(n2).fill(t4), r2);
}
function get$1$2(t4, n2) {
  if (!Array.isArray(t4)) throw Error(`Array expected`);
  if (!Array.isArray(n2)) throw Error(`Array expected for index`);
  var r2 = arraySize$2(t4);
  if (n2.length !== r2.length) throw new DimensionError$2(n2.length, r2.length);
  for (var i2 = 0; i2 < n2.length; i2++) validateIndex$2(n2[i2], r2[i2]);
  return n2.reduce((t5, n3) => t5[n3], t4);
}
function deepMap$1$2(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return [];
  if (r2) return o2(t4);
  var i2 = [];
  return a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) {
      for (var s2 = r3.length, c2 = Array(s2), l2 = 0; l2 < s2; l2++) i2[o3] = l2, c2[l2] = a2(r3[l2], o3 + 1);
      return c2;
    } else return n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) {
      for (var r3 = t5.length, i3 = Array(r3), a3 = 0; a3 < r3; a3++) i3[a3] = o2(t5[a3]);
      return i3;
    } else return n2(t5);
  }
}
function deepForEach$1$2(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return;
  if (r2) {
    o2(t4);
    return;
  }
  var i2 = [];
  a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) for (var s2 = r3.length, c2 = 0; c2 < s2; c2++) i2[o3] = c2, a2(r3[c2], o3 + 1);
    else n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) for (var r3 = t5.length, i3 = 0; i3 < r3; i3++) o2(t5[i3]);
    else n2(t5);
  }
}
function clone$1$2(t4) {
  return _extends$5([], t4);
}
function optimizeCallback$2(t4, n2, r2, i2) {
  if (import_typed_function$2.default.isTypedFunction(t4)) {
    var a2;
    if (i2) a2 = 1;
    else {
      var o2 = n2.isMatrix ? n2.size() : arraySize$2(n2);
      if (!o2.length || o2[o2.length - 1] === 0) return { isUnary: i2, fn: t4 };
      var s2 = o2.map(() => 0);
      a2 = _findNumberOfArgumentsTyped$2(t4, n2.isMatrix ? n2.get(s2) : get$1$2(n2, s2), s2, n2);
    }
    var c2;
    if (n2.isMatrix && n2.dataType !== `mixed` && n2.dataType !== void 0) {
      var l2 = _findSingleSignatureWithArity$2(t4, a2);
      c2 = l2 === void 0 ? t4 : l2;
    } else c2 = t4;
    return a2 >= 1 && a2 <= 3 ? { isUnary: a2 === 1, fn: function() {
      return _tryFunctionWithArgs$2(c2, [...arguments].slice(0, a2), r2, t4.name);
    } } : { isUnary: false, fn: function() {
      return _tryFunctionWithArgs$2(c2, [...arguments], r2, t4.name);
    } };
  }
  return i2 === void 0 ? { isUnary: _findIfCallbackIsUnary$2(t4), fn: t4 } : { isUnary: i2, fn: t4 };
}
function _findSingleSignatureWithArity$2(t4, n2) {
  var r2 = [];
  if (Object.entries(t4.signatures).forEach((t5) => {
    var [i2, a2] = t5;
    i2.split(`,`).length === n2 && r2.push(a2);
  }), r2.length === 1) return r2[0];
}
function _findIfCallbackIsUnary$2(t4) {
  if (t4.length !== 1) return false;
  var n2 = t4.toString();
  if (/arguments/.test(n2)) return false;
  var r2 = n2.match(/\(.*?\)/);
  return !/\.\.\./.test(r2);
}
function _findNumberOfArgumentsTyped$2(t4, n2, r2, i2) {
  for (var a2 = [n2, r2, i2], o2 = 3; o2 > 0; o2--) {
    var s2 = a2.slice(0, o2);
    if (import_typed_function$2.default.resolve(t4, s2) !== null) return o2;
  }
}
function _tryFunctionWithArgs$2(t4, n2, r2, i2) {
  try {
    return t4(...n2);
  } catch (t5) {
    _createCallbackError$2(t5, n2, r2, i2);
  }
}
function _createCallbackError$2(t4, n2, r2, i2) {
  if (t4 instanceof TypeError && t4.data?.category === `wrongType`) {
    var o2 = [];
    throw o2.push(`value: ${typeOf$2(n2[0])}`), n2.length >= 2 && o2.push(`index: ${typeOf$2(n2[1])}`), n2.length >= 3 && o2.push(`array: ${typeOf$2(n2[2])}`), TypeError(`Function ${r2} cannot apply callback arguments ${i2}(${o2.join(`, `)}) at index ${JSON.stringify(n2[1])}`);
  } else throw TypeError(`Function ${r2} cannot apply callback arguments to function ${i2}: ${t4.message}`);
}
var name$315$2 = `DenseMatrix`, dependencies$315$2 = [`Matrix`, `config`], createDenseMatrixClass$2 = factory$2(name$315$2, dependencies$315$2, (t4) => {
  var { Matrix: n2, config: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$2(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$2(t5)) t5.type === `DenseMatrix` ? (this._data = clone$3$2(t5._data), this._size = clone$3$2(t5._size), this._datatype = n3 || t5._datatype) : (this._data = t5.toArray(), this._size = t5.size(), this._datatype = n3 || t5._datatype);
    else if (t5 && isArray$3(t5.data) && isArray$3(t5.size)) this._data = t5.data, this._size = t5.size, validate$2(this._data, this._size), this._datatype = n3 || t5.datatype;
    else if (isArray$3(t5)) this._data = d2(t5), this._size = arraySize$2(this._data), validate$2(this._data, this._size), this._datatype = n3;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$2(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3;
  }
  i2.prototype = new n2(), i2.prototype.createDenseMatrix = function(t5, n3) {
    return new i2(t5, n3);
  }, Object.defineProperty(i2, "name", { value: `DenseMatrix` }), i2.prototype.constructor = i2, i2.prototype.type = `DenseMatrix`, i2.prototype.isDenseMatrix = true, i2.prototype.getDataType = function() {
    return getArrayDataType$2(this._data, typeOf$2);
  }, i2.prototype.storage = function() {
    return `dense`;
  }, i2.prototype.datatype = function() {
    return this._datatype;
  }, i2.prototype.create = function(t5, n3) {
    return new i2(t5, n3);
  }, i2.prototype.subset = function(t5, n3, r3) {
    switch (arguments.length) {
      case 1:
        return a2(this, t5);
      case 2:
      case 3:
        return s2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.get = function(t5) {
    return get$1$2(this._data, t5);
  }, i2.prototype.set = function(t5, n3, r3) {
    if (!isArray$3(t5)) throw TypeError(`Array expected`);
    if (t5.length < this._size.length) throw new DimensionError$2(t5.length, this._size.length, `<`);
    var i3, a3, o3, s3 = t5.map(function(t6) {
      return t6 + 1;
    });
    u2(this, s3, r3);
    var c3 = this._data;
    for (i3 = 0, a3 = t5.length - 1; i3 < a3; i3++) o3 = t5[i3], validateIndex$2(o3, c3.length), c3 = c3[o3];
    return o3 = t5[t5.length - 1], validateIndex$2(o3, c3.length), c3[o3] = n3, this;
  };
  function a2(t5, n3) {
    if (!isIndex$2(n3)) throw TypeError(`Invalid index`);
    if (r2.legacySubset ? n3.size().every((t6) => t6 === 1) : n3.isScalar()) return t5.get(n3.min());
    var a3 = n3.size();
    if (a3.length !== t5._size.length) throw new DimensionError$2(a3.length, t5._size.length);
    for (var s3 = n3.min(), c3 = n3.max(), l3 = 0, u3 = t5._size.length; l3 < u3; l3++) validateIndex$2(s3[l3], t5._size[l3]), validateIndex$2(c3[l3], t5._size[l3]);
    var d3 = new i2(), p2 = o2(t5._data, n3);
    return d3._size = p2.size, d3._datatype = t5._datatype, d3._data = p2.data, r2.legacySubset ? d3.reshape(n3.size()) : d3;
  }
  function o2(t5, n3) {
    var r3 = n3.size().length - 1, i3 = Array(r3);
    return { data: a3(t5), size: i3.filter((t6) => t6 !== null) };
    function a3(t6) {
      var o3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s3 = n3.dimension(o3);
      function c3(t7, n4) {
        return isNumber$2(t7) ? n4(t7) : t7.map(n4).valueOf();
      }
      return isNumber$2(s3) ? i3[o3] = null : i3[o3] = s3.size()[0], o3 < r3 ? c3(s3, (n4) => (validateIndex$2(n4, t6.length), a3(t6[n4], o3 + 1))) : c3(s3, (n4) => (validateIndex$2(n4, t6.length), t6[n4]));
    }
  }
  function s2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix$2(r3) ? (s3 = r3.size(), r3 = r3.valueOf()) : s3 = arraySize$2(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (!deepStrictEqual$2(s3, a3)) {
        if (s3.length === 0) r3 = broadcastTo$2([r3], a3);
        else try {
          r3 = broadcastTo$2(r3, a3);
        } catch {
        }
        s3 = arraySize$2(r3);
      }
      if (a3.length < t5._size.length) throw new DimensionError$2(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var l3 = 0, d3 = 0; a3[l3] === 1 && s3[l3] === 1; ) l3++;
        for (; a3[l3] === 1; ) d3++, l3++;
        r3 = unsqueeze$2(r3, a3.length, d3, s3);
      }
      if (!deepStrictEqual$2(a3, s3)) throw new DimensionError$2(a3, s3, `>`);
      u2(t5, n3.max().map(function(t6) {
        return t6 + 1;
      }), i3), c2(t5._data, n3, r3);
    }
    return t5;
  }
  function c2(t5, n3, r3) {
    var i3 = n3.size().length - 1;
    a3(t5, r3);
    function a3(t6, r4) {
      var o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s3 = n3.dimension(o3), c3 = (n4, i4) => {
        validateIndex$2(n4, t6.length), a3(t6[n4], r4[i4[0]], o3 + 1);
      }, l3 = (n4, i4) => {
        validateIndex$2(n4, t6.length), t6[n4] = r4[i4[0]];
      };
      o3 < i3 ? isNumber$2(s3) ? c3(s3, [0]) : s3.forEach(c3) : isNumber$2(s3) ? l3(s3, [0]) : s3.forEach(l3);
    }
  }
  i2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection$2(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    return l2(r3 ? this.clone() : this, i3, n3);
  };
  function l2(t5, n3, r3) {
    if (n3.length === 0) {
      for (var i3 = t5._data; isArray$3(i3); ) i3 = i3[0];
      return i3;
    }
    return t5._size = n3.slice(0), t5._data = resize$2(t5._data, t5._size, r3), t5;
  }
  i2.prototype.reshape = function(t5, n3) {
    var r3 = n3 ? this.clone() : this;
    return r3._data = reshape$2(r3._data, t5), r3._size = processSizesWildcard$2(t5, r3._size.reduce((t6, n4) => t6 * n4)), r3;
  };
  function u2(t5, n3, r3) {
    for (var i3 = t5._size.slice(0), a3 = false; i3.length < n3.length; ) i3.push(0), a3 = true;
    for (var o3 = 0, s3 = n3.length; o3 < s3; o3++) n3[o3] > i3[o3] && (i3[o3] = n3[o3], a3 = true);
    a3 && l2(t5, i3, r3);
  }
  i2.prototype.clone = function() {
    return new i2({ data: clone$3$2(this._data), size: clone$3$2(this._size), datatype: this._datatype });
  }, i2.prototype.size = function() {
    return this._size.slice(0);
  }, i2.prototype.map = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return r3.clone();
    var a3 = optimizeCallback$2(t5, r3, `map`, n3), o3 = a3.fn, s3 = r3.create(void 0, r3._datatype);
    if (s3._size = r3._size, n3 || a3.isUnary) return s3._data = m2(r3._data), s3;
    if (i3 === 0) {
      for (var c3 = r3.valueOf(), l3 = Array(c3.length), u3 = 0; u3 < c3.length; u3++) l3[u3] = o3(c3[u3], [u3], r3);
      return s3._data = l3, s3;
    }
    var d3 = [];
    return s3._data = p2(r3._data), s3;
    function p2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a4 = Array(t6.length);
      if (n4 < i3) for (var s4 = 0; s4 < t6.length; s4++) d3[n4] = s4, a4[s4] = p2(t6[s4], n4 + 1);
      else for (var c4 = 0; c4 < t6.length; c4++) d3[n4] = c4, a4[c4] = o3(t6[c4], d3.slice(), r3);
      return a4;
    }
    function m2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r4 = Array(t6.length);
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) r4[a4] = m2(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) r4[s4] = o3(t6[s4]);
      return r4;
    }
  }, i2.prototype.forEach = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return;
    var a3 = optimizeCallback$2(t5, r3, `map`, n3), o3 = a3.fn;
    if (n3 || a3.isUnary) {
      u3(r3._data);
      return;
    }
    if (i3 === 0) {
      for (var s3 = 0; s3 < r3._data.length; s3++) o3(r3._data[s3], [s3], r3);
      return;
    }
    var c3 = [];
    l3(r3._data);
    function l3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) c3[n4] = a4, l3(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) c3[n4] = s4, o3(t6[s4], c3.slice(), r3);
    }
    function u3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var r4 = 0; r4 < t6.length; r4++) u3(t6[r4], n4 + 1);
      else for (var a4 = 0; a4 < t6.length; a4++) o3(t6[a4]);
    }
  }, i2.prototype[Symbol.iterator] = function* () {
    var t5 = this._size.length - 1;
    if (!(t5 < 0)) {
      if (t5 === 0) {
        for (var n3 = 0; n3 < this._data.length; n3++) yield { value: this._data[n3], index: [n3] };
        return;
      }
      for (var r3 = Array(t5 + 1).fill(0), i3 = this._size.reduce((t6, n4) => t6 * n4, 1), a3 = 0; a3 < i3; a3++) {
        for (var o3 = this._data, s3 = 0; s3 < t5; s3++) o3 = o3[r3[s3]];
        yield { value: o3[r3[t5]], index: r3.slice() };
        for (var c3 = t5; c3 >= 0 && (r3[c3]++, !(r3[c3] < this._size[c3])); c3--) r3[c3] = 0;
      }
    }
  }, i2.prototype.rows = function() {
    var t5 = [];
    if (this.size().length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var n3 of this._data) t5.push(new i2([n3], this._datatype));
    return t5;
  }, i2.prototype.columns = function() {
    var t5 = this, n3 = [], r3 = this.size();
    if (r3.length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var a3 = this._data, o3 = function(r4) {
      var o4 = a3.map((t6) => [t6[r4]]);
      n3.push(new i2(o4, t5._datatype));
    }, s3 = 0; s3 < r3[1]; s3++) o3(s3);
    return n3;
  }, i2.prototype.toArray = function() {
    return clone$3$2(this._data);
  }, i2.prototype.valueOf = function() {
    return this._data;
  }, i2.prototype.format = function(t5) {
    return format$4(this._data, t5);
  }, i2.prototype.toString = function() {
    return format$4(this._data);
  }, i2.prototype.toJSON = function() {
    return { mathjs: `DenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber$2(t5) && (t5 = t5.toNumber()), !isNumber$2(t5) || !isInteger$3(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    for (var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, a3 = this._size[0], o3 = this._size[1], s3 = Math.min(a3 - r3, o3 - n3), c3 = [], l3 = 0; l3 < s3; l3++) c3[l3] = this._data[l3 + r3][l3 + n3];
    return new i2({ data: c3, size: [s3], datatype: this._datatype });
  }, i2.diagonal = function(t5, n3, r3, a3) {
    if (!isArray$3(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber$2(t6) && (t6 = t6.toNumber()), !isNumber$2(t6) || !isInteger$3(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), r3) {
      if (isBigNumber$2(r3) && (r3 = r3.toNumber()), !isNumber$2(r3) || !isInteger$3(r3)) throw TypeError(`The parameter k must be an integer number`);
    } else r3 = 0;
    var o3 = r3 > 0 ? r3 : 0, s3 = r3 < 0 ? -r3 : 0, c3 = t5[0], l3 = t5[1], u3 = Math.min(c3 - s3, l3 - o3), d3;
    if (isArray$3(n3)) {
      if (n3.length !== u3) throw Error(`Invalid value array length`);
      d3 = function(t6) {
        return n3[t6];
      };
    } else if (isMatrix$2(n3)) {
      var p2 = n3.size();
      if (p2.length !== 1 || p2[0] !== u3) throw Error(`Invalid matrix length`);
      d3 = function(t6) {
        return n3.get([t6]);
      };
    } else d3 = function() {
      return n3;
    };
    a3 ||= isBigNumber$2(d3(0)) ? d3(0).mul(0) : 0;
    var m2 = [];
    if (t5.length > 0) {
      m2 = resize$2(m2, t5, a3);
      for (var h2 = 0; h2 < u3; h2++) m2[h2 + s3][h2 + o3] = d3(h2);
    }
    return new i2({ data: m2, size: [c3, l3] });
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function(t5, n3) {
    if (!isNumber$2(t5) || !isInteger$3(t5) || !isNumber$2(n3) || !isInteger$3(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex$2(t5, this._size[0]), validateIndex$2(n3, this._size[0]), i2._swapRows(t5, n3, this._data), this;
  }, i2._swapRows = function(t5, n3, r3) {
    var i3 = r3[t5];
    r3[t5] = r3[n3], r3[n3] = i3;
  };
  function d2(t5) {
    return isMatrix$2(t5) ? d2(t5.valueOf()) : isArray$3(t5) ? t5.map(d2) : t5;
  }
  return i2;
}, { isClass: true }), name$314$2 = `clone`, dependencies$314$2 = [`typed`], createClone$2 = factory$2(name$314$2, dependencies$314$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$314$2, { any: clone$3$2 });
});
function _switch$1$2(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
function containsCollections$2(t4) {
  for (var n2 = 0; n2 < t4.length; n2++) if (isCollection$2(t4[n2])) return true;
  return false;
}
function deepForEach$3(t4, n2) {
  isMatrix$2(t4) ? t4.forEach((t5) => n2(t5), false, true) : deepForEach$1$2(t4, n2, true);
}
function deepMap$3(t4, n2, r2) {
  if (!r2) return isMatrix$2(t4) ? t4.map((t5) => n2(t5), false, true) : deepMap$1$2(t4, n2, true);
  var i2 = (t5) => t5 === 0 ? t5 : n2(t5);
  return isMatrix$2(t4) ? t4.map((t5) => i2(t5), false, true) : deepMap$1$2(t4, i2, true);
}
function reduce$1$2(t4, n2, r2) {
  var i2 = Array.isArray(t4) ? arraySize$2(t4) : t4.size();
  if (n2 < 0 || n2 >= i2.length) throw new IndexError$2(n2, i2.length);
  return isMatrix$2(t4) ? t4.create(_reduce$2(t4.valueOf(), n2, r2), t4.datatype()) : _reduce$2(t4, n2, r2);
}
function _reduce$2(t4, n2, r2) {
  var i2, a2, o2, s2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (s2 = _switch$1$2(t4), a2 = [], i2 = 0; i2 < s2.length; i2++) a2[i2] = _reduce$2(s2[i2], n2 - 1, r2);
    return a2;
  } else {
    for (o2 = t4[0], i2 = 1; i2 < t4.length; i2++) o2 = r2(o2, t4[i2]);
    return o2;
  }
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _reduce$2(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function scatter$2(t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2) {
  var p2 = t4._values, m2 = t4._index, h2 = t4._ptr, g2, v2, y2, b2;
  if (i2) for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? (i2[b2] = c2(i2[b2], p2[g2]), a2[b2] = o2) : (r2[b2] = o2, s2.push(b2), i2[b2] = p2[g2]);
  else for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? a2[b2] = o2 : (r2[b2] = o2, s2.push(b2));
}
var name$313$2 = `isInteger`, dependencies$313$2 = [`typed`, `equal`], createIsInteger$2 = factory$2(name$313$2, dependencies$313$2, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$313$2, { number: (t5) => Number.isFinite(t5) ? r2(t5, Math.round(t5)) : false, BigNumber: (t5) => t5.isFinite() ? r2(t5.round(), t5) : false, bigint: (t5) => true, Fraction: (t5) => t5.d === 1n, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), n1$4$2 = `number`, n2$3$2 = `number, number`;
function absNumber$2(t4) {
  return Math.abs(t4);
}
absNumber$2.signature = n1$4$2;
function addNumber$2(t4, n2) {
  return t4 + n2;
}
addNumber$2.signature = n2$3$2;
function subtractNumber$2(t4, n2) {
  return t4 - n2;
}
subtractNumber$2.signature = n2$3$2;
function multiplyNumber$2(t4, n2) {
  return t4 * n2;
}
multiplyNumber$2.signature = n2$3$2;
function unaryMinusNumber$2(t4) {
  return -t4;
}
unaryMinusNumber$2.signature = n1$4$2;
function unaryPlusNumber$2(t4) {
  return t4;
}
unaryPlusNumber$2.signature = n1$4$2;
function cbrtNumber$2(t4) {
  return cbrt$1$2(t4);
}
cbrtNumber$2.signature = n1$4$2;
function cubeNumber$2(t4) {
  return t4 * t4 * t4;
}
cubeNumber$2.signature = n1$4$2;
function expNumber$2(t4) {
  return Math.exp(t4);
}
expNumber$2.signature = n1$4$2;
function expm1Number$2(t4) {
  return expm1$2(t4);
}
expm1Number$2.signature = n1$4$2;
function lcmNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Parameters in function lcm must be integer numbers`);
  if (t4 === 0 || n2 === 0) return 0;
  for (var r2, i2 = t4 * n2; n2 !== 0; ) r2 = n2, n2 = t4 % r2, t4 = r2;
  return Math.abs(i2 / t4);
}
lcmNumber$2.signature = n2$3$2;
function logNumber$2(t4, n2) {
  return n2 ? Math.log(t4) / Math.log(n2) : Math.log(t4);
}
function log10Number$2(t4) {
  return log10$2$2(t4);
}
log10Number$2.signature = n1$4$2;
function log2Number$2(t4) {
  return log2$1$2(t4);
}
log2Number$2.signature = n1$4$2;
function nthRootNumber$2(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, r2 = n2 < 0;
  if (r2 && (n2 = -n2), n2 === 0) throw Error(`Root must be non-zero`);
  if (t4 < 0 && Math.abs(n2) % 2 != 1) throw Error(`Root must be odd when a is negative.`);
  if (t4 === 0) return r2 ? 1 / 0 : 0;
  if (!isFinite(t4)) return r2 ? 0 : t4;
  var i2 = Math.abs(t4) ** (1 / n2);
  return i2 = t4 < 0 ? -i2 : i2, r2 ? 1 / i2 : i2;
}
function signNumber$2(t4) {
  return sign$2$2(t4);
}
signNumber$2.signature = n1$4$2;
function squareNumber$2(t4) {
  return t4 * t4;
}
squareNumber$2.signature = n1$4$2;
function xgcdNumber$2(t4, n2) {
  var r2, i2, a2, o2 = 0, s2 = 1, c2 = 1, l2 = 0;
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Parameters in function xgcd must be integer numbers`);
  for (; n2; ) i2 = Math.floor(t4 / n2), a2 = t4 - i2 * n2, r2 = o2, o2 = s2 - i2 * o2, s2 = r2, r2 = c2, c2 = l2 - i2 * c2, l2 = r2, t4 = n2, n2 = a2;
  return t4 < 0 ? [-t4, -s2, -l2] : [t4, t4 ? s2 : 0, l2];
}
xgcdNumber$2.signature = n2$3$2;
function powNumber$2(t4, n2) {
  return t4 * t4 < 1 && n2 === 1 / 0 || t4 * t4 > 1 && n2 === -1 / 0 ? 0 : t4 ** +n2;
}
powNumber$2.signature = n2$3$2;
function roundNumber$2(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!isInteger$3(n2) || n2 < 0 || n2 > 15) throw Error(`Number of decimals in function round must be an integer from 0 to 15 inclusive`);
  return parseFloat(toFixed$2$2(t4, n2));
}
var n1$3$2 = `number`, n2$2$2 = `number, number`;
function bitAndNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function bitAnd`);
  return t4 & n2;
}
bitAndNumber$2.signature = n2$2$2;
function bitNotNumber$2(t4) {
  if (!isInteger$3(t4)) throw Error(`Integer expected in function bitNot`);
  return ~t4;
}
bitNotNumber$2.signature = n1$3$2;
function bitOrNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function bitOr`);
  return t4 | n2;
}
bitOrNumber$2.signature = n2$2$2;
function bitXorNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function bitXor`);
  return t4 ^ n2;
}
bitXorNumber$2.signature = n2$2$2;
function leftShiftNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function leftShift`);
  return t4 << n2;
}
leftShiftNumber$2.signature = n2$2$2;
function rightArithShiftNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function rightArithShift`);
  return t4 >> n2;
}
rightArithShiftNumber$2.signature = n2$2$2;
function rightLogShiftNumber$2(t4, n2) {
  if (!isInteger$3(t4) || !isInteger$3(n2)) throw Error(`Integers expected in function rightLogShift`);
  return t4 >>> n2;
}
rightLogShiftNumber$2.signature = n2$2$2;
function product$3(t4, n2) {
  if (n2 < t4) return 1;
  if (n2 === t4) return n2;
  var r2 = n2 + t4 >> 1;
  return product$3(t4, r2) * product$3(r2 + 1, n2);
}
function combinationsNumber$2(t4, n2) {
  if (!isInteger$3(t4) || t4 < 0 || !isInteger$3(n2) || n2 < 0) throw TypeError(`Positive integer value expected in function combinations`);
  if (n2 > t4) throw TypeError(`k must be less than or equal to n`);
  for (var r2 = t4 - n2, i2 = 1, a2 = n2 < r2 ? r2 + 1 : n2 + 1, o2 = 2, s2 = n2 < r2 ? n2 : r2, c2 = a2; c2 <= t4; ++c2) for (i2 *= c2; o2 <= s2 && i2 % o2 === 0; ) i2 /= o2, ++o2;
  return o2 <= s2 && (i2 /= product$3(o2, s2)), i2;
}
combinationsNumber$2.signature = `number, number`;
var pi$3 = Math.PI, tau$2 = 2 * Math.PI, e$3 = Math.E, phi$2 = 1.618033988749895, n1$2$2 = `number`, n2$1$2 = `number, number`;
function notNumber$2(t4) {
  return !t4;
}
notNumber$2.signature = n1$2$2;
function orNumber$2(t4, n2) {
  return !!(t4 || n2);
}
orNumber$2.signature = n2$1$2;
function xorNumber$2(t4, n2) {
  return !!t4 != !!n2;
}
xorNumber$2.signature = n2$1$2;
function andNumber$2(t4, n2) {
  return !!(t4 && n2);
}
andNumber$2.signature = n2$1$2;
function gammaNumber$2(t4) {
  var n2;
  if (isInteger$3(t4)) return t4 <= 0 ? Number.isFinite(t4) ? 1 / 0 : NaN : t4 > 171 ? 1 / 0 : product$3(1, t4 - 1);
  if (t4 < 0.5) return Math.PI / (Math.sin(Math.PI * t4) * gammaNumber$2(1 - t4));
  if (t4 >= 171.35) return 1 / 0;
  if (t4 > 85) {
    var r2 = t4 * t4, i2 = r2 * t4, a2 = i2 * t4, o2 = a2 * t4;
    return Math.sqrt(2 * Math.PI / t4) * (t4 / Math.E) ** +t4 * (1 + 1 / (12 * t4) + 1 / (288 * r2) - 139 / (51840 * i2) - 571 / (2488320 * a2) + 163879 / (209018880 * o2) + 5246819 / (75246796800 * o2 * t4));
  }
  --t4, n2 = gammaP$2[0];
  for (var s2 = 1; s2 < gammaP$2.length; ++s2) n2 += gammaP$2[s2] / (t4 + s2);
  var c2 = t4 + gammaG$2 + 0.5;
  return Math.sqrt(2 * Math.PI) * c2 ** +(t4 + 0.5) * Math.exp(-c2) * n2;
}
gammaNumber$2.signature = `number`;
var gammaG$2 = 4.7421875, gammaP$2 = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI$2 = 0.9189385332046728, lgammaSeries$2 = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber$2(t4) {
  if (t4 < 0) return NaN;
  if (t4 === 0) return 1 / 0;
  if (!Number.isFinite(t4)) return t4;
  if (t4 < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * t4)) - lgammaNumber$2(1 - t4);
  --t4;
  for (var n2 = t4 + 5 + 0.5, r2 = lgammaSeries$2[0], i2 = 6; i2 >= 1; i2--) r2 += lgammaSeries$2[i2] / (t4 + i2);
  return lnSqrt2PI$2 + (t4 + 0.5) * Math.log(n2) - n2 + Math.log(r2);
}
lgammaNumber$2.signature = `number`;
var n1$1$2 = `number`;
function acoshNumber$2(t4) {
  return acosh$2$2(t4);
}
acoshNumber$2.signature = n1$1$2;
function acotNumber$2(t4) {
  return Math.atan(1 / t4);
}
acotNumber$2.signature = n1$1$2;
function acothNumber$2(t4) {
  return Number.isFinite(t4) ? (Math.log((t4 + 1) / t4) + Math.log(t4 / (t4 - 1))) / 2 : 0;
}
acothNumber$2.signature = n1$1$2;
function acscNumber$2(t4) {
  return Math.asin(1 / t4);
}
acscNumber$2.signature = n1$1$2;
function acschNumber$2(t4) {
  var n2 = 1 / t4;
  return Math.log(n2 + Math.sqrt(n2 * n2 + 1));
}
acschNumber$2.signature = n1$1$2;
function asecNumber$2(t4) {
  return Math.acos(1 / t4);
}
asecNumber$2.signature = n1$1$2;
function asechNumber$2(t4) {
  var n2 = 1 / t4, r2 = Math.sqrt(n2 * n2 - 1);
  return Math.log(r2 + n2);
}
asechNumber$2.signature = n1$1$2;
function asinhNumber$2(t4) {
  return asinh$2$2(t4);
}
asinhNumber$2.signature = n1$1$2;
function atanhNumber$2(t4) {
  return atanh$2$2(t4);
}
atanhNumber$2.signature = n1$1$2;
function cotNumber$2(t4) {
  return 1 / Math.tan(t4);
}
cotNumber$2.signature = n1$1$2;
function cothNumber$2(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 + 1) / (n2 - 1);
}
cothNumber$2.signature = n1$1$2;
function cscNumber$2(t4) {
  return 1 / Math.sin(t4);
}
cscNumber$2.signature = n1$1$2;
function cschNumber$2(t4) {
  return t4 === 0 ? 1 / 0 : Math.abs(2 / (Math.exp(t4) - Math.exp(-t4))) * sign$2$2(t4);
}
cschNumber$2.signature = n1$1$2;
function secNumber$2(t4) {
  return 1 / Math.cos(t4);
}
secNumber$2.signature = n1$1$2;
function sechNumber$2(t4) {
  return 2 / (Math.exp(t4) + Math.exp(-t4));
}
sechNumber$2.signature = n1$1$2;
function sinhNumber$2(t4) {
  return sinh$3$2(t4);
}
sinhNumber$2.signature = n1$1$2;
var n1$6 = `number`;
function isNegativeNumber$2(t4) {
  return t4 < 0;
}
isNegativeNumber$2.signature = n1$6;
function isPositiveNumber$2(t4) {
  return t4 > 0;
}
isPositiveNumber$2.signature = n1$6;
function isNaNNumber$2(t4) {
  return Number.isNaN(t4);
}
isNaNNumber$2.signature = n1$6;
function nearlyEqual$3(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return t4.isNaN() || n2.isNaN() ? false : !t4.isFinite() || !n2.isFinite() ? t4.eq(n2) : t4.eq(n2) ? true : t4.minus(n2).abs().lte(t4.constructor.max(t4.constructor.max(t4.abs(), n2.abs()).mul(r2), i2));
}
var name$312$2 = `isNegative`, dependencies$312$2 = [`typed`, `config`], createIsNegative$2 = factory$2(name$312$2, dependencies$312$2, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$312$2, { number: (t5) => nearlyEqual$1$2(t5, 0, r2.relTol, r2.absTol) ? false : isNegativeNumber$2(t5), BigNumber: (t5) => nearlyEqual$3(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 < 0n, Fraction: (t5) => t5.s < 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$311$2 = `isNumeric`, dependencies$311$2 = [`typed`], createIsNumeric$2 = factory$2(name$311$2, dependencies$311$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$311$2, { "number | BigNumber | bigint | Fraction | boolean": () => true, "Complex | Unit | string | null | undefined | Node": () => false, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$310$2 = `hasNumericValue`, dependencies$310$2 = [`typed`, `isNumeric`], createHasNumericValue$2 = factory$2(name$310$2, dependencies$310$2, (t4) => {
  var { typed: n2, isNumeric: r2 } = t4;
  return n2(name$310$2, { boolean: () => true, string: function(t5) {
    return t5.trim().length > 0 && !isNaN(Number(t5));
  }, any: function(t5) {
    return r2(t5);
  } });
}), name$309$2 = `isPositive`, dependencies$309$2 = [`typed`, `config`], createIsPositive$2 = factory$2(name$309$2, dependencies$309$2, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$309$2, { number: (t5) => nearlyEqual$1$2(t5, 0, r2.relTol, r2.absTol) ? false : isPositiveNumber$2(t5), BigNumber: (t5) => nearlyEqual$3(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : !t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 > 0n, Fraction: (t5) => t5.s > 0n && t5.n > 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$308$2 = `isZero`, dependencies$308$2 = [`typed`, `equalScalar`], createIsZero$2 = factory$2(name$308$2, dependencies$308$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$308$2, { "number | BigNumber | Complex | Fraction": (t5) => r2(t5, 0), bigint: (t5) => t5 === 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$307$2 = `isNaN`, dependencies$307$2 = [`typed`], createIsNaN$2 = factory$2(name$307$2, dependencies$307$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$307$2, { number: isNaNNumber$2, BigNumber: function(t5) {
    return t5.isNaN();
  }, bigint: function(t5) {
    return false;
  }, Fraction: function(t5) {
    return false;
  }, Complex: function(t5) {
    return t5.isNaN();
  }, Unit: function(t5) {
    return Number.isNaN(t5.value);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$306$2 = `isBounded`, dependencies$306$2 = [`typed`], createIsBounded$2 = factory$2(name$306$2, dependencies$306$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$306$2, { number: (t5) => Number.isFinite(t5), "BigNumber | Complex": (t5) => t5.isFinite(), "bigint | Fraction": () => true, "null | undefined": () => false, Unit: n2.referToSelf((t5) => (n3) => t5(n3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => (Array.isArray(n3) || (n3 = n3.valueOf()), n3.every((n4) => t5(n4)))) });
}), name$305$2 = `isFinite`, dependencies$305$2 = [`typed`, `isBounded`, `map`], createIsFinite$2 = factory$2(name$305$2, dependencies$305$2, (t4) => {
  var { typed: n2, isBounded: r2, map: i2 } = t4;
  return n2(name$305$2, { "Array | Matrix": (t5) => i2(t5, r2), any: (t5) => r2(t5) });
}), name$304$2 = `typeOf`, dependencies$304$2 = [`typed`], createTypeOf$2 = factory$2(name$304$2, dependencies$304$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$304$2, { any: typeOf$2 });
});
function complexEquals$2(t4, n2, r2, i2) {
  return nearlyEqual$1$2(t4.re, n2.re, r2, i2) && nearlyEqual$1$2(t4.im, n2.im, r2, i2);
}
var createCompareUnits$2 = factory$2(`compareUnits`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (!r2.equalBase(i2)) throw Error(`Cannot compare units with different base`);
    return n2.find(t5, [r2.valueType(), i2.valueType()])(r2.value, i2.value);
  }) };
}), name$303$2 = `equalScalar`, dependencies$303$2 = [`typed`, `config`], createEqualScalar$2 = factory$2(name$303$2, dependencies$303$2, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303$2, { "boolean, boolean": function(t5, n3) {
    return t5 === n3;
  }, "number, number": function(t5, n3) {
    return nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.eq(n3) || nearlyEqual$3(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.equals(n3);
  }, "Complex, Complex": function(t5, n3) {
    return complexEquals$2(t5, n3, r2.relTol, r2.absTol);
  } }, createCompareUnits$2({ typed: n2 }));
});
factory$2(name$303$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303$2, { "number, number": function(t5, n3) {
    return nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  } });
});
var name$302$2 = `SparseMatrix`, dependencies$302$2 = [`typed`, `equalScalar`, `Matrix`], createSparseMatrixClass$2 = factory$2(name$302$2, dependencies$302$2, (t4) => {
  var { typed: n2, equalScalar: r2, Matrix: i2 } = t4;
  function a2(t5, n3) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$2(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$2(t5)) o2(this, t5, n3);
    else if (t5 && isArray$3(t5.index) && isArray$3(t5.ptr) && isArray$3(t5.size)) this._values = t5.values, this._index = t5.index, this._ptr = t5.ptr, this._size = t5.size, this._datatype = n3 || t5.datatype;
    else if (isArray$3(t5)) s2(this, t5, n3);
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$2(t5) + `)`);
    else this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = n3;
  }
  function o2(t5, n3, r3) {
    n3.type === `SparseMatrix` ? (t5._values = n3._values ? clone$3$2(n3._values) : void 0, t5._index = clone$3$2(n3._index), t5._ptr = clone$3$2(n3._ptr), t5._size = clone$3$2(n3._size), t5._datatype = r3 || n3._datatype) : s2(t5, n3.valueOf(), r3 || n3._datatype);
  }
  function s2(t5, i3, a3) {
    t5._values = [], t5._index = [], t5._ptr = [], t5._datatype = a3;
    var o3 = i3.length, s3 = 0, c3 = r2, l3 = 0;
    if (isString$2(a3) && (c3 = n2.find(r2, [a3, a3]) || r2, l3 = n2.convert(0, a3)), o3 > 0) {
      var u3 = 0;
      do {
        t5._ptr.push(t5._index.length);
        for (var d3 = 0; d3 < o3; d3++) {
          var p3 = i3[d3];
          if (isArray$3(p3)) {
            if (u3 === 0 && s3 < p3.length && (s3 = p3.length), u3 < p3.length) {
              var m3 = p3[u3];
              c3(m3, l3) || (t5._values.push(m3), t5._index.push(d3));
            }
          } else u3 === 0 && s3 < 1 && (s3 = 1), c3(p3, l3) || (t5._values.push(p3), t5._index.push(d3));
        }
        u3++;
      } while (u3 < s3);
    }
    for (; t5._ptr.length <= s3; ) t5._ptr.push(t5._index.length);
    t5._size = [o3, s3];
  }
  a2.prototype = new i2(), a2.prototype.createSparseMatrix = function(t5, n3) {
    return new a2(t5, n3);
  }, Object.defineProperty(a2, "name", { value: `SparseMatrix` }), a2.prototype.constructor = a2, a2.prototype.type = `SparseMatrix`, a2.prototype.isSparseMatrix = true, a2.prototype.getDataType = function() {
    return getArrayDataType$2(this._values, typeOf$2);
  }, a2.prototype.storage = function() {
    return `sparse`;
  }, a2.prototype.datatype = function() {
    return this._datatype;
  }, a2.prototype.create = function(t5, n3) {
    return new a2(t5, n3);
  }, a2.prototype.density = function() {
    var t5 = this._size[0], n3 = this._size[1];
    return t5 !== 0 && n3 !== 0 ? this._index.length / (t5 * n3) : 0;
  }, a2.prototype.subset = function(t5, n3, r3) {
    if (!this._values) throw Error(`Cannot invoke subset on a Pattern only matrix`);
    switch (arguments.length) {
      case 1:
        return c2(this, t5);
      case 2:
      case 3:
        return l2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  };
  function c2(t5, n3) {
    if (!isIndex$2(n3)) throw TypeError(`Invalid index`);
    if (n3.isScalar()) return t5.get(n3.min());
    var r3 = n3.size();
    if (r3.length !== t5._size.length) throw new DimensionError$2(r3.length, t5._size.length);
    var i3, o3, s3, c3, l3 = n3.min(), u3 = n3.max();
    for (i3 = 0, o3 = t5._size.length; i3 < o3; i3++) validateIndex$2(l3[i3], t5._size[i3]), validateIndex$2(u3[i3], t5._size[i3]);
    var d3 = t5._values, p3 = t5._index, m3 = t5._ptr, h3 = n3.dimension(0), g3 = n3.dimension(1), v2 = [], y2 = [];
    function b2(t6, n4) {
      y2[t6] = n4[0], v2[t6] = true;
    }
    Number.isInteger(h3) ? b2(h3, [0]) : h3.forEach(b2);
    var x2 = d3 ? [] : void 0, S2 = [], w2 = [];
    function E(t6) {
      for (w2.push(S2.length), s3 = m3[t6], c3 = m3[t6 + 1]; s3 < c3; s3++) i3 = p3[s3], v2[i3] === true && (S2.push(y2[i3]), x2 && x2.push(d3[s3]));
    }
    return Number.isInteger(g3) ? E(g3) : g3.forEach(E), w2.push(S2.length), new a2({ values: x2, index: S2, ptr: w2, size: r3, datatype: t5._datatype });
  }
  function l2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix$2(r3) ? (s3 = r3.size(), r3 = r3.toArray()) : s3 = arraySize$2(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (a3.length !== 1 && a3.length !== 2) throw new DimensionError$2(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var c3 = 0, l3 = 0; a3[c3] === 1 && s3[c3] === 1; ) c3++;
        for (; a3[c3] === 1; ) l3++, c3++;
        r3 = unsqueeze$2(r3, a3.length, l3, s3);
      }
      if (!deepStrictEqual$2(a3, s3)) throw new DimensionError$2(a3, s3, `>`);
      if (a3.length === 1) p3(n3.dimension(0), (n4, a4) => {
        validateIndex$2(n4), t5.set([n4, 0], r3[a4[0]], i3);
      });
      else {
        var u3 = n3.dimension(0), d3 = n3.dimension(1);
        p3(u3, (n4, a4) => {
          validateIndex$2(n4), p3(d3, (o4, s4) => {
            validateIndex$2(o4), t5.set([n4, o4], r3[a4[0]][s4[0]], i3);
          });
        });
      }
    }
    return t5;
    function p3(t6, n4) {
      isNumber$2(t6) ? n4(t6, [0]) : t6.forEach(n4);
    }
  }
  a2.prototype.get = function(t5) {
    if (!isArray$3(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError$2(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke get on a Pattern only matrix`);
    var n3 = t5[0], r3 = t5[1];
    validateIndex$2(n3, this._size[0]), validateIndex$2(r3, this._size[1]);
    var i3 = u2(n3, this._ptr[r3], this._ptr[r3 + 1], this._index);
    return i3 < this._ptr[r3 + 1] && this._index[i3] === n3 ? this._values[i3] : 0;
  }, a2.prototype.set = function(t5, i3, a3) {
    if (!isArray$3(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError$2(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke set on a Pattern only matrix`);
    var o3 = t5[0], s3 = t5[1], c3 = this._size[0], l3 = this._size[1], h3 = r2, g3 = 0;
    isString$2(this._datatype) && (h3 = n2.find(r2, [this._datatype, this._datatype]) || r2, g3 = n2.convert(0, this._datatype)), (o3 > c3 - 1 || s3 > l3 - 1) && (m2(this, Math.max(o3 + 1, c3), Math.max(s3 + 1, l3), a3), c3 = this._size[0], l3 = this._size[1]), validateIndex$2(o3, c3), validateIndex$2(s3, l3);
    var v2 = u2(o3, this._ptr[s3], this._ptr[s3 + 1], this._index);
    return v2 < this._ptr[s3 + 1] && this._index[v2] === o3 ? h3(i3, g3) ? d2(v2, s3, this._values, this._index, this._ptr) : this._values[v2] = i3 : h3(i3, g3) || p2(v2, o3, s3, i3, this._values, this._index, this._ptr), this;
  };
  function u2(t5, n3, r3, i3) {
    if (r3 - n3 === 0) return r3;
    for (var a3 = n3; a3 < r3; a3++) if (i3[a3] === t5) return a3;
    return n3;
  }
  function d2(t5, n3, r3, i3, a3) {
    r3.splice(t5, 1), i3.splice(t5, 1);
    for (var o3 = n3 + 1; o3 < a3.length; o3++) a3[o3]--;
  }
  function p2(t5, n3, r3, i3, a3, o3, s3) {
    a3.splice(t5, 0, i3), o3.splice(t5, 0, n3);
    for (var c3 = r3 + 1; c3 < s3.length; c3++) s3[c3]++;
  }
  a2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection$2(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    if (i3.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    return i3.forEach(function(t6) {
      if (!isNumber$2(t6) || !isInteger$3(t6) || t6 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$4(i3) + `)`);
    }), m2(r3 ? this.clone() : this, i3[0], i3[1], n3);
  };
  function m2(t5, i3, a3, o3) {
    var s3 = o3 || 0, c3 = r2, l3 = 0;
    isString$2(t5._datatype) && (c3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, l3 = n2.convert(0, t5._datatype), s3 = n2.convert(s3, t5._datatype));
    var u3 = !c3(s3, l3), d3 = t5._size[0], p3 = t5._size[1], m3, h3, g3;
    if (a3 > p3) {
      for (h3 = p3; h3 < a3; h3++) if (t5._ptr[h3] = t5._values.length, u3) for (m3 = 0; m3 < d3; m3++) t5._values.push(s3), t5._index.push(m3);
      t5._ptr[a3] = t5._values.length;
    } else a3 < p3 && (t5._ptr.splice(a3 + 1, p3 - a3), t5._values.splice(t5._ptr[a3], t5._values.length), t5._index.splice(t5._ptr[a3], t5._index.length));
    if (p3 = a3, i3 > d3) {
      if (u3) {
        var v2 = 0;
        for (h3 = 0; h3 < p3; h3++) {
          t5._ptr[h3] = t5._ptr[h3] + v2, g3 = t5._ptr[h3 + 1] + v2;
          var y2 = 0;
          for (m3 = d3; m3 < i3; m3++, y2++) t5._values.splice(g3 + y2, 0, s3), t5._index.splice(g3 + y2, 0, m3), v2++;
        }
        t5._ptr[p3] = t5._values.length;
      }
    } else if (i3 < d3) {
      var b2 = 0;
      for (h3 = 0; h3 < p3; h3++) {
        t5._ptr[h3] = t5._ptr[h3] - b2;
        var x2 = t5._ptr[h3], S2 = t5._ptr[h3 + 1] - b2;
        for (g3 = x2; g3 < S2; g3++) m3 = t5._index[g3], m3 > i3 - 1 && (t5._values.splice(g3, 1), t5._index.splice(g3, 1), b2++);
      }
      t5._ptr[h3] = t5._values.length;
    }
    return t5._size[0] = i3, t5._size[1] = a3, t5;
  }
  a2.prototype.reshape = function(t5, n3) {
    if (!isArray$3(t5)) throw TypeError(`Array expected`);
    if (t5.length !== 2) throw Error(`Sparse matrices can only be reshaped in two dimensions`);
    t5.forEach(function(n4) {
      if (!isNumber$2(n4) || !isInteger$3(n4) || n4 <= -2 || n4 === 0) throw TypeError(`Invalid size, must contain positive integers or -1 (size: ` + format$4(t5) + `)`);
    });
    var r3 = this._size[0] * this._size[1];
    if (t5 = processSizesWildcard$2(t5, r3), r3 !== t5[0] * t5[1]) throw Error(`Reshaping sparse matrix will result in the wrong number of elements`);
    var i3 = n3 ? this.clone() : this;
    if (this._size[0] === t5[0] && this._size[1] === t5[1]) return i3;
    for (var a3 = [], o3 = 0; o3 < i3._ptr.length; o3++) for (var s3 = 0; s3 < i3._ptr[o3 + 1] - i3._ptr[o3]; s3++) a3.push(o3);
    for (var c3 = i3._values.slice(), l3 = i3._index.slice(), d3 = 0; d3 < i3._index.length; d3++) {
      var m3 = l3[d3], h3 = a3[d3], g3 = m3 * i3._size[1] + h3;
      a3[d3] = g3 % t5[1], l3[d3] = Math.floor(g3 / t5[1]);
    }
    i3._values.length = 0, i3._index.length = 0, i3._ptr.length = t5[1] + 1, i3._size = t5.slice();
    for (var v2 = 0; v2 < i3._ptr.length; v2++) i3._ptr[v2] = 0;
    for (var y2 = 0; y2 < c3.length; y2++) {
      var b2 = l3[y2], x2 = a3[y2], S2 = c3[y2];
      p2(u2(b2, i3._ptr[x2], i3._ptr[x2 + 1], i3._index), b2, x2, S2, i3._values, i3._index, i3._ptr);
    }
    return i3;
  }, a2.prototype.clone = function() {
    return new a2({ values: this._values ? clone$3$2(this._values) : void 0, index: clone$3$2(this._index), ptr: clone$3$2(this._ptr), size: clone$3$2(this._size), datatype: this._datatype });
  }, a2.prototype.size = function() {
    return this._size.slice(0);
  }, a2.prototype.map = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke map on a Pattern only matrix`);
    var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback$2(t5, r3, `map`);
    return h2(this, 0, i3 - 1, 0, a3 - 1, function(t6, n4, i4) {
      return o3.fn(t6, [n4, i4], r3);
    }, n3);
  };
  function h2(t5, i3, o3, s3, c3, l3, u3) {
    var d3 = [], p3 = [], m3 = [], h3 = r2, g3 = 0;
    isString$2(t5._datatype) && (h3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, g3 = n2.convert(0, t5._datatype));
    for (var v2 = function(t6, n3, r3) {
      var i4 = l3(t6, n3, r3);
      h3(i4, g3) || (d3.push(i4), p3.push(n3));
    }, y2 = s3; y2 <= c3; y2++) {
      m3.push(d3.length);
      var b2 = t5._ptr[y2], x2 = t5._ptr[y2 + 1];
      if (u3) for (var S2 = b2; S2 < x2; S2++) {
        var w2 = t5._index[S2];
        w2 >= i3 && w2 <= o3 && v2(t5._values[S2], w2 - i3, y2 - s3);
      }
      else {
        for (var E = {}, D = b2; D < x2; D++) {
          var O2 = t5._index[D];
          E[O2] = t5._values[D];
        }
        for (var j2 = i3; j2 <= o3; j2++) v2(j2 in E ? E[j2] : 0, j2 - i3, y2 - s3);
      }
    }
    return m3.push(d3.length), new a2({ values: d3, index: p3, ptr: m3, size: [o3 - i3 + 1, c3 - s3 + 1] });
  }
  a2.prototype.forEach = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke forEach on a Pattern only matrix`);
    for (var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback$2(t5, r3, `forEach`), s3 = 0; s3 < a3; s3++) {
      var c3 = this._ptr[s3], l3 = this._ptr[s3 + 1];
      if (n3) for (var u3 = c3; u3 < l3; u3++) {
        var d3 = this._index[u3];
        o3.fn(this._values[u3], [d3, s3], r3);
      }
      else {
        for (var p3 = {}, m3 = c3; m3 < l3; m3++) {
          var h3 = this._index[m3];
          p3[h3] = this._values[m3];
        }
        for (var g3 = 0; g3 < i3; g3++) {
          var v2 = g3 in p3 ? p3[g3] : 0;
          o3.fn(v2, [g3, s3], r3);
        }
      }
    }
  }, a2.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw Error(`Cannot iterate a Pattern only matrix`);
    for (var t5 = this._size[1], n3 = 0; n3 < t5; n3++) for (var r3 = this._ptr[n3], i3 = this._ptr[n3 + 1], a3 = r3; a3 < i3; a3++) {
      var o3 = this._index[a3];
      yield { value: this._values[a3], index: [o3, n3] };
    }
  }, a2.prototype.toArray = function() {
    return g2(this._values, this._index, this._ptr, this._size, true);
  }, a2.prototype.valueOf = function() {
    return g2(this._values, this._index, this._ptr, this._size, false);
  };
  function g2(t5, n3, r3, i3, a3) {
    var o3 = i3[0], s3 = i3[1], c3 = [], l3, u3;
    for (l3 = 0; l3 < o3; l3++) for (c3[l3] = [], u3 = 0; u3 < s3; u3++) c3[l3][u3] = 0;
    for (u3 = 0; u3 < s3; u3++) for (var d3 = r3[u3], p3 = r3[u3 + 1], m3 = d3; m3 < p3; m3++) l3 = n3[m3], c3[l3][u3] = t5 ? a3 ? clone$3$2(t5[m3]) : t5[m3] : 1;
    return c3;
  }
  return a2.prototype.format = function(t5) {
    for (var n3 = this._size[0], r3 = this._size[1], i3 = this.density(), a3 = `Sparse Matrix [` + format$4(n3, t5) + ` x ` + format$4(r3, t5) + `] density: ` + format$4(i3, t5) + `
`, o3 = 0; o3 < r3; o3++) for (var s3 = this._ptr[o3], c3 = this._ptr[o3 + 1], l3 = s3; l3 < c3; l3++) {
      var u3 = this._index[l3];
      a3 += `
    (` + format$4(u3, t5) + `, ` + format$4(o3, t5) + `) ==> ` + (this._values ? format$4(this._values[l3], t5) : `X`);
    }
    return a3;
  }, a2.prototype.toString = function() {
    return format$4(this.toArray());
  }, a2.prototype.toJSON = function() {
    return { mathjs: `SparseMatrix`, values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, a2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber$2(t5) && (t5 = t5.toNumber()), !isNumber$2(t5) || !isInteger$3(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, i3 = this._size[0], o3 = this._size[1], s3 = Math.min(i3 - r3, o3 - n3), c3 = [], l3 = [], u3 = [];
    u3[0] = 0;
    for (var d3 = n3; d3 < o3 && c3.length < s3; d3++) for (var p3 = this._ptr[d3], m3 = this._ptr[d3 + 1], h3 = p3; h3 < m3; h3++) {
      var g3 = this._index[h3];
      if (g3 === d3 - n3 + r3) {
        c3.push(this._values[h3]), l3[c3.length - 1] = g3 - r3;
        break;
      }
    }
    return u3.push(c3.length), new a2({ values: c3, index: l3, ptr: u3, size: [s3, 1] });
  }, a2.fromJSON = function(t5) {
    return new a2(t5);
  }, a2.diagonal = function(t5, i3, o3, s3, c3) {
    if (!isArray$3(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber$2(t6) && (t6 = t6.toNumber()), !isNumber$2(t6) || !isInteger$3(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), o3) {
      if (isBigNumber$2(o3) && (o3 = o3.toNumber()), !isNumber$2(o3) || !isInteger$3(o3)) throw TypeError(`The parameter k must be an integer number`);
    } else o3 = 0;
    var l3 = r2, u3 = 0;
    isString$2(c3) && (l3 = n2.find(r2, [c3, c3]) || r2, u3 = n2.convert(0, c3));
    var d3 = o3 > 0 ? o3 : 0, p3 = o3 < 0 ? -o3 : 0, m3 = t5[0], h3 = t5[1], g3 = Math.min(m3 - p3, h3 - d3), v2;
    if (isArray$3(i3)) {
      if (i3.length !== g3) throw Error(`Invalid value array length`);
      v2 = function(t6) {
        return i3[t6];
      };
    } else if (isMatrix$2(i3)) {
      var y2 = i3.size();
      if (y2.length !== 1 || y2[0] !== g3) throw Error(`Invalid matrix length`);
      v2 = function(t6) {
        return i3.get([t6]);
      };
    } else v2 = function() {
      return i3;
    };
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < h3; w2++) {
      S2.push(b2.length);
      var E = w2 - d3;
      if (E >= 0 && E < g3) {
        var D = v2(E);
        l3(D, u3) || (x2.push(E + p3), b2.push(D));
      }
    }
    return S2.push(b2.length), new a2({ values: b2, index: x2, ptr: S2, size: [m3, h3] });
  }, a2.prototype.swapRows = function(t5, n3) {
    if (!isNumber$2(t5) || !isInteger$3(t5) || !isNumber$2(n3) || !isInteger$3(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex$2(t5, this._size[0]), validateIndex$2(n3, this._size[0]), a2._swapRows(t5, n3, this._size[1], this._values, this._index, this._ptr), this;
  }, a2._forEachRow = function(t5, n3, r3, i3, a3) {
    for (var o3 = i3[t5], s3 = i3[t5 + 1], c3 = o3; c3 < s3; c3++) a3(r3[c3], n3[c3]);
  }, a2._swapRows = function(t5, n3, r3, i3, a3, o3) {
    for (var s3 = 0; s3 < r3; s3++) {
      var c3 = o3[s3], l3 = o3[s3 + 1], d3 = u2(t5, c3, l3, a3), p3 = u2(n3, c3, l3, a3);
      if (d3 < l3 && p3 < l3 && a3[d3] === t5 && a3[p3] === n3) {
        if (i3) {
          var m3 = i3[d3];
          i3[d3] = i3[p3], i3[p3] = m3;
        }
        continue;
      }
      if (d3 < l3 && a3[d3] === t5 && (p3 >= l3 || a3[p3] !== n3)) {
        var h3 = i3 ? i3[d3] : void 0;
        a3.splice(p3, 0, n3), i3 && i3.splice(p3, 0, h3), a3.splice(p3 <= d3 ? d3 + 1 : d3, 1), i3 && i3.splice(p3 <= d3 ? d3 + 1 : d3, 1);
        continue;
      }
      if (p3 < l3 && a3[p3] === n3 && (d3 >= l3 || a3[d3] !== t5)) {
        var g3 = i3 ? i3[p3] : void 0;
        a3.splice(d3, 0, t5), i3 && i3.splice(d3, 0, g3), a3.splice(d3 <= p3 ? p3 + 1 : p3, 1), i3 && i3.splice(d3 <= p3 ? p3 + 1 : p3, 1);
      }
    }
  }, a2;
}, { isClass: true }), name$301$2 = `number`, dependencies$301$2 = [`typed`];
function getNonDecimalNumberParts$2(t4) {
  var n2 = t4.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return n2 ? { input: t4, radix: { "0b": 2, "0o": 8, "0x": 16 }[n2[1]], integerPart: n2[2], fractionalPart: n2[3] } : null;
}
function makeNumberFromNonDecimalParts$2(t4) {
  for (var n2 = parseInt(t4.integerPart, t4.radix), r2 = 0, i2 = 0; i2 < t4.fractionalPart.length; i2++) {
    var a2 = parseInt(t4.fractionalPart[i2], t4.radix);
    r2 += a2 / t4.radix ** +(i2 + 1);
  }
  var o2 = n2 + r2;
  if (isNaN(o2)) throw SyntaxError(`String "` + t4.input + `" is not a valid number`);
  return o2;
}
var createNumber$2 = factory$2(name$301$2, dependencies$301$2, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`number`, { "": function() {
    return 0;
  }, number: function(t5) {
    return t5;
  }, string: function(t5) {
    if (t5 === `NaN`) return NaN;
    var n3 = getNonDecimalNumberParts$2(t5);
    if (n3) return makeNumberFromNonDecimalParts$2(n3);
    var r3 = 0, i2 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    i2 && (r3 = Number(i2[2]), t5 = i2[1]);
    var a2 = Number(t5);
    if (isNaN(a2)) throw SyntaxError(`String "` + t5 + `" is not a valid number`);
    if (i2) {
      if (a2 > 2 ** r3 - 1) throw SyntaxError(`String "${t5}" is out of range`);
      a2 >= 2 ** (r3 - 1) && (a2 -= 2 ** r3);
    }
    return a2;
  }, BigNumber: function(t5) {
    return t5.toNumber();
  }, bigint: function(t5) {
    return Number(t5);
  }, Fraction: function(t5) {
    return t5.valueOf();
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), null: function(t5) {
    return 0;
  }, "Unit, string | Unit": function(t5, n3) {
    return t5.toNumber(n3);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return parseFloat(t5.value);
  }, r2;
}), name$300$2 = `bigint`, dependencies$300$2 = [`typed`], createBigint$2 = factory$2(name$300$2, dependencies$300$2, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`bigint`, { "": function() {
    return 0n;
  }, bigint: function(t5) {
    return t5;
  }, number: function(t5) {
    return BigInt(t5.toFixed());
  }, BigNumber: function(t5) {
    return BigInt(t5.round().toString());
  }, Fraction: function(t5) {
    return BigInt(t5.valueOf().toFixed());
  }, "string | boolean": function(t5) {
    return BigInt(t5);
  }, null: function(t5) {
    return 0n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return BigInt(t5.value);
  }, r2;
}), name$299$2 = `string`, dependencies$299$2 = [`typed`], createString$2 = factory$2(name$299$2, dependencies$299$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$299$2, { "": function() {
    return ``;
  }, number: format$2$2, null: function(t5) {
    return `null`;
  }, boolean: function(t5) {
    return t5 + ``;
  }, string: function(t5) {
    return t5;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)), any: function(t5) {
    return String(t5);
  } });
}), name$298$2 = `boolean`, dependencies$298$2 = [`typed`], createBoolean$2 = factory$2(name$298$2, dependencies$298$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$298$2, { "": function() {
    return false;
  }, boolean: function(t5) {
    return t5;
  }, number: function(t5) {
    return !!t5;
  }, null: function(t5) {
    return false;
  }, BigNumber: function(t5) {
    return !t5.isZero();
  }, string: function(t5) {
    var n3 = t5.toLowerCase();
    if (n3 === `true`) return true;
    if (n3 === `false`) return false;
    var r2 = Number(t5);
    if (t5 !== `` && !isNaN(r2)) return !!r2;
    throw Error(`Cannot convert "` + t5 + `" to a boolean`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$297$2 = `bignumber`, dependencies$297$2 = [`typed`, `BigNumber`], createBignumber$2 = factory$2(name$297$2, dependencies$297$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(`bignumber`, { "": function() {
    return new r2(0);
  }, number: function(t5) {
    return new r2(t5 + ``);
  }, string: function(t5) {
    var n3 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (n3) {
      var i2 = n3[2], a2 = r2(n3[1]), o2 = new r2(2).pow(Number(i2));
      if (a2.gt(o2.sub(1))) throw SyntaxError(`String "${t5}" is out of range`);
      var s2 = new r2(2).pow(Number(i2) - 1);
      return a2.gte(s2) ? a2.sub(o2) : a2;
    }
    return new r2(t5);
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Fraction: function(t5) {
    return new r2(String(t5.n)).div(String(t5.d)).times(String(t5.s));
  }, null: function(t5) {
    return new r2(0);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$296$2 = `complex`, dependencies$296$2 = [`typed`, `Complex`], createComplex$2 = factory$2(name$296$2, dependencies$296$2, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(`complex`, { "": function() {
    return r2.ZERO;
  }, number: function(t5) {
    return new r2(t5, 0);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return new r2(t5.toNumber(), n3.toNumber());
  }, Fraction: function(t5) {
    return new r2(t5.valueOf(), 0);
  }, Complex: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2(t5);
  }, null: function(t5) {
    return r2(0);
  }, Object: function(t5) {
    if (`re` in t5 && `im` in t5) return new r2(t5.re, t5.im);
    if (`r` in t5 && `phi` in t5 || `abs` in t5 && `arg` in t5) return new r2(t5);
    throw Error(`Expected object with properties (re and im) or (r and phi) or (abs and arg)`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$295$2 = `fraction`, dependencies$295$2 = [`typed`, `Fraction`], createFraction$2 = factory$2(name$295$2, dependencies$295$2, (t4) => {
  var { typed: n2, Fraction: r2 } = t4;
  return n2(`fraction`, { number: function(t5) {
    if (!Number.isFinite(t5) || isNaN(t5)) throw Error(t5 + ` cannot be represented as a fraction`);
    return new r2(t5);
  }, string: function(t5) {
    return new r2(t5);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "bigint, bigint": function(t5, n3) {
    return new r2(t5, n3);
  }, null: function(t5) {
    return new r2(0);
  }, BigNumber: function(t5) {
    return new r2(t5.toString());
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Fraction: function(t5) {
    return t5;
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Object: function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$294$2 = `matrix`, dependencies$294$2 = [`typed`, `Matrix`, `DenseMatrix`, `SparseMatrix`], createMatrix$2 = factory$2(name$294$2, dependencies$294$2, (t4) => {
  var { typed: n2, Matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$294$2, { "": function() {
    return o2([]);
  }, string: function(t5) {
    return o2([], t5);
  }, "string, string": function(t5, n3) {
    return o2([], t5, n3);
  }, Array: function(t5) {
    return o2(t5);
  }, Matrix: function(t5) {
    return o2(t5, t5.storage());
  }, "Array | Matrix, string": o2, "Array | Matrix, string, string": o2 });
  function o2(t5, n3, r3) {
    if (n3 === `dense` || n3 === "default" || n3 === void 0) return new i2(t5, r3);
    if (n3 === `sparse`) return new a2(t5, r3);
    throw TypeError(`Unknown matrix type ` + JSON.stringify(n3) + `.`);
  }
}), name$293$2 = `matrixFromFunction`, dependencies$293$2 = [`typed`, `matrix`, `isZero`], createMatrixFromFunction$2 = factory$2(name$293$2, dependencies$293$2, (t4) => {
  var { typed: n2, matrix: r2, isZero: i2 } = t4;
  return n2(name$293$2, { "Array | Matrix, function, string, string": function(t5, n3, r3, i3) {
    return a2(t5, n3, r3, i3);
  }, "Array | Matrix, function, string": function(t5, n3, r3) {
    return a2(t5, n3, r3);
  }, "Matrix, function": function(t5, n3) {
    return a2(t5, n3, `dense`);
  }, "Array, function": function(t5, n3) {
    return a2(t5, n3, `dense`).toArray();
  }, "Array | Matrix, string, function": function(t5, n3, r3) {
    return a2(t5, r3, n3);
  }, "Array | Matrix, string, string, function": function(t5, n3, r3, i3) {
    return a2(t5, i3, n3, r3);
  } });
  function a2(t5, n3, a3, o2) {
    var s2 = o2 === void 0 ? r2(a3) : r2(a3, o2);
    return s2.resize(t5), s2.forEach(function(t6, r3) {
      var a4 = n3(r3);
      i2(a4) || s2.set(r3, a4);
    }), s2;
  }
}), name$292$2 = `matrixFromRows`, dependencies$292$2 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromRows$2 = factory$2(name$292$2, dependencies$292$2, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$292$2, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one row is needed to construct a matrix.`);
    var n3 = s2(t5[0]), r3 = [];
    for (var a3 of t5) {
      var o3 = s2(a3);
      if (o3 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (o3 | 0));
      r3.push(i2(a3));
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$291$2 = `matrixFromColumns`, dependencies$291$2 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromColumns$2 = factory$2(name$291$2, dependencies$291$2, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$291$2, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one column is needed to construct a matrix.`);
    for (var n3 = s2(t5[0]), r3 = [], a3 = 0; a3 < n3; a3++) r3[a3] = [];
    for (var o3 of t5) {
      var c2 = s2(o3);
      if (c2 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (c2 | 0));
      for (var l2 = i2(o3), u2 = 0; u2 < n3; u2++) r3[u2].push(l2[u2]);
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$290$2 = `splitUnit`, dependencies$290$2 = [`typed`], createSplitUnit$2 = factory$2(name$290$2, dependencies$290$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$290$2, { "Unit, Array": function(t5, n3) {
    return t5.splitUnit(n3);
  } });
}), name$289$2 = `unaryMinus`, dependencies$289$2 = [`typed`], createUnaryMinus$2 = factory$2(name$289$2, dependencies$289$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$289$2, { number: unaryMinusNumber$2, "Complex | BigNumber | Fraction": (t5) => t5.neg(), bigint: (t5) => -t5, Unit: n2.referToSelf((t5) => (r2) => {
    var i2 = r2.clone();
    return i2.value = n2.find(t5, i2.valueType())(r2.value), i2;
  }), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)) });
}), name$288$2 = `unaryPlus`, dependencies$288$2 = [`typed`, `config`, `numeric`], createUnaryPlus$2 = factory$2(name$288$2, dependencies$288$2, (t4) => {
  var { typed: n2, config: r2, numeric: i2 } = t4;
  return n2(name$288$2, { number: unaryPlusNumber$2, Complex: function(t5) {
    return t5;
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return t5;
  }, Fraction: function(t5) {
    return t5;
  }, Unit: function(t5) {
    return t5.clone();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), boolean: function(t5) {
    return i2(+!!t5, r2.number);
  }, string: function(t5) {
    return i2(t5, safeNumberType$2(t5, r2));
  } });
}), name$287$2 = `abs`, dependencies$287$2 = [`typed`], createAbs$2 = factory$2(name$287$2, dependencies$287$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$287$2, { number: absNumber$2, "Complex | BigNumber | Fraction | Unit": (t5) => t5.abs(), bigint: (t5) => t5 < 0n ? -t5 : t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)) });
}), name$286$2 = `mapSlices`, dependencies$286$2 = [`typed`, `isInteger`], createMapSlices$2 = factory$2(name$286$2, dependencies$286$2, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$286$2, { "Array | Matrix, number | BigNumber, function": function(t5, n3, i2) {
    if (!r2(n3)) throw TypeError(`Integer number expected for dimension`);
    var a2 = Array.isArray(t5) ? arraySize$2(t5) : t5.size();
    if (n3 < 0 || n3 >= a2.length) throw new IndexError$2(n3, a2.length);
    return isMatrix$2(t5) ? t5.create(_mapSlices$2(t5.valueOf(), n3, i2), t5.datatype()) : _mapSlices$2(t5, n3, i2);
  } });
}, { formerly: `apply` });
function _mapSlices$2(t4, n2, r2) {
  var i2, a2, o2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (o2 = _switch$3(t4), a2 = [], i2 = 0; i2 < o2.length; i2++) a2[i2] = _mapSlices$2(o2[i2], n2 - 1, r2);
    return a2;
  } else return r2(t4);
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _mapSlices$2(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function _switch$3(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
var name$285$2 = `addScalar`, dependencies$285$2 = [`typed`], createAddScalar$2 = factory$2(name$285$2, dependencies$285$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$285$2, { "number, number": addNumber$2, "Complex, Complex": function(t5, n3) {
    return t5.add(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.plus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 + n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.add(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$284$2 = `subtractScalar`, dependencies$284$2 = [`typed`], createSubtractScalar$2 = factory$2(name$284$2, dependencies$284$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$284$2, { "number, number": subtractNumber$2, "Complex, Complex": function(t5, n3) {
    return t5.sub(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.minus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 - n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.sub(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$283$2 = `cbrt`, dependencies$283$2 = [`config`, `typed`, `isNegative`, `unaryMinus`, `matrix`, `Complex`, `BigNumber`, `Fraction`], createCbrt$2 = factory$2(name$283$2, dependencies$283$2, (t4) => {
  var { config: n2, typed: r2, isNegative: i2, unaryMinus: a2, matrix: o2, Complex: s2, BigNumber: c2, Fraction: l2 } = t4;
  return r2(name$283$2, { number: cbrtNumber$2, Complex: u2, "Complex, boolean": u2, BigNumber: function(t5) {
    return t5.cbrt();
  }, Unit: d2 });
  function u2(t5, r3) {
    var i3 = t5.arg() / 3, a3 = t5.abs(), c3 = new s2(cbrtNumber$2(a3), 0).mul(new s2(0, i3).exp());
    if (r3) {
      var l3 = [c3, new s2(cbrtNumber$2(a3), 0).mul(new s2(0, i3 + Math.PI * 2 / 3).exp()), new s2(cbrtNumber$2(a3), 0).mul(new s2(0, i3 - Math.PI * 2 / 3).exp())];
      return n2.matrix === `Array` ? l3 : o2(l3);
    } else return c3;
  }
  function d2(t5) {
    if (t5.value && isComplex$2(t5.value)) {
      var n3 = t5.clone();
      return n3.value = 1, n3 = n3.pow(1 / 3), n3.value = u2(t5.value), n3;
    } else {
      var r3 = i2(t5.value);
      r3 && (t5.value = a2(t5.value));
      var o3 = isBigNumber$2(t5.value) ? new c2(1).div(3) : isFraction$2(t5.value) ? new l2(1, 3) : 1 / 3, s3 = t5.pow(o3);
      return r3 && (s3.value = a2(s3.value)), s3;
    }
  }
}), name$282$2 = `matAlgo11xS0s`, dependencies$282$2 = [`typed`, `equalScalar`], createMatAlgo11xS0s$2 = factory$2(name$282$2, dependencies$282$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof d2 == `string` && (h2 = d2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), i2 = n2.convert(i2, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < m2; w2++) {
      S2[w2] = x2.length;
      for (var E = l2[w2], D = l2[w2 + 1], O2 = E; O2 < D; O2++) {
        var j2 = c2[O2], M2 = o2 ? y2(i2, s2[O2]) : y2(s2[O2], i2);
        g2(M2, v2) || (x2.push(j2), b2.push(M2));
      }
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: h2 });
  };
}), name$281$2 = `matAlgo12xSfs`, dependencies$281$2 = [`typed`, `DenseMatrix`], createMatAlgo12xSfs$2 = factory$2(name$281$2, dependencies$281$2, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = o2 ? g2(i2, 0) : g2(0, i2);
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
}), name$280$2 = `matAlgo14xDs`, dependencies$280$2 = [`typed`], createMatAlgo14xDs$2 = factory$2(name$280$2, dependencies$280$2, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype, u2, d2 = a2;
    typeof l2 == `string` && (u2 = l2, i2 = n2.convert(i2, u2), d2 = n2.find(a2, [u2, u2]));
    var p2 = c2.length > 0 ? r2(d2, 0, c2, c2[0], s2, i2, o2) : [];
    return t5.createDenseMatrix({ data: p2, size: clone$3$2(c2), datatype: u2 });
  };
  function r2(t5, n3, i2, a2, o2, s2, c2) {
    var l2 = [];
    if (n3 === i2.length - 1) for (var u2 = 0; u2 < a2; u2++) l2[u2] = c2 ? t5(s2, o2[u2]) : t5(o2[u2], s2);
    else for (var d2 = 0; d2 < a2; d2++) l2[d2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[d2], s2, c2);
    return l2;
  }
}), name$279$2 = `ceil`, dependencies$279$2 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen$1$2 = new Decimal$2(10), createCeilNumber$2 = factory$2(name$279$2, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.ceil(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1$2(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$279$2, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger$3(n3)) throw RangeError(`number of decimals in function ceil must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in ceil number must be in range 0-15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createCeil$2 = factory$2(name$279$2, dependencies$279$2, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$2({ typed: n2 }), p2 = createCeilNumber$2({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual$3(t6, n4, r2.relTol, r2.absTol), a3 = t5.ceil(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`ceil`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.ceil();
  }, "Complex, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen$1$2.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.ceil();
  }, "Fraction, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$3(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$3(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$278$2 = `cube`, dependencies$278$2 = [`typed`], createCube$2 = factory$2(name$278$2, dependencies$278$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$278$2, { number: cubeNumber$2, Complex: function(t5) {
    return t5.mul(t5).mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5).times(t5);
  }, bigint: function(t5) {
    return t5 * t5 * t5;
  }, Fraction: function(t5) {
    return t5.pow(3);
  }, Unit: function(t5) {
    return t5.pow(3);
  } });
}), name$277$2 = `exp`, dependencies$277$2 = [`typed`], createExp$2 = factory$2(name$277$2, dependencies$277$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$277$2, { number: expNumber$2, Complex: function(t5) {
    return t5.exp();
  }, BigNumber: function(t5) {
    return t5.exp();
  } });
}), name$276$2 = `expm1`, dependencies$276$2 = [`typed`, `Complex`], createExpm1$2 = factory$2(name$276$2, dependencies$276$2, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(name$276$2, { number: expm1Number$2, Complex: function(t5) {
    var n3 = Math.exp(t5.re);
    return new r2(n3 * Math.cos(t5.im) - 1, n3 * Math.sin(t5.im));
  }, BigNumber: function(t5) {
    return t5.exp().minus(1);
  } });
}), name$275$2 = `fix`, dependencies$275$2 = [`typed`, `Complex`, `matrix`, `ceil`, `floor`, `equalScalar`, `zeros`, `DenseMatrix`], createFixNumber$2 = factory$2(name$275$2, [`typed`, `ceil`, `floor`], (t4) => {
  var { typed: n2, ceil: r2, floor: i2 } = t4;
  return n2(name$275$2, { number: function(t5) {
    return t5 > 0 ? i2(t5) : r2(t5);
  }, "number, number": function(t5, n3) {
    return t5 > 0 ? i2(t5, n3) : r2(t5, n3);
  } });
}), createFix$2 = factory$2(name$275$2, dependencies$275$2, (t4) => {
  var { typed: n2, Complex: r2, matrix: i2, ceil: a2, floor: o2, equalScalar: s2, zeros: c2, DenseMatrix: l2 } = t4, u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: l2 }), d2 = createMatAlgo14xDs$2({ typed: n2 }), p2 = createFixNumber$2({ typed: n2, ceil: a2, floor: o2 });
  return n2(`fix`, { number: p2.signatures.number, "number, number | BigNumber": p2.signatures[`number,number`], Complex: function(t5) {
    return new r2(t5.re > 0 ? Math.floor(t5.re) : Math.ceil(t5.re), t5.im > 0 ? Math.floor(t5.im) : Math.ceil(t5.im));
  }, "Complex, number": function(t5, n3) {
    return new r2(t5.re > 0 ? o2(t5.re, n3) : a2(t5.re, n3), t5.im > 0 ? o2(t5.im, n3) : a2(t5.im, n3));
  }, "Complex, BigNumber": function(t5, n3) {
    var i3 = n3.toNumber();
    return new r2(t5.re > 0 ? o2(t5.re, i3) : a2(t5.re, i3), t5.im > 0 ? o2(t5.im, i3) : a2(t5.im, i3));
  }, BigNumber: function(t5) {
    return t5.isNegative() ? a2(t5) : o2(t5);
  }, "BigNumber, number | BigNumber": function(t5, n3) {
    return t5.isNegative() ? a2(t5, n3) : o2(t5, n3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.s < 0n ? t5.ceil() : t5.floor();
  }, "Fraction, number | BigNumber": function(t5, n3) {
    return t5.s < 0n ? a2(t5, n3) : o2(t5, n3);
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$3(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), "Array | Matrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$3(n3, (n4) => t5(n4, r3), true)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, 0) ? c2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$274$2 = `floor`, dependencies$274$2 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen$3 = new Decimal$2(10), createFloorNumber$2 = factory$2(name$274$2, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.floor(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1$2(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$274$2, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger$3(n3)) throw RangeError(`number of decimals in function floor must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in floor number must be in range 0 - 15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createFloor$2 = factory$2(name$274$2, dependencies$274$2, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$2({ typed: n2 }), p2 = createFloorNumber$2({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual$3(t6, n4, r2.relTol, r2.absTol), a3 = t5.floor(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`floor`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.floor();
  }, "Complex, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen$3.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.floor();
  }, "Fraction, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$3(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$3(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$273$2 = `matAlgo02xDS0`, dependencies$273$2 = [`typed`, `equalScalar`], createMatAlgo02xDS0$2 = factory$2(name$273$2, dependencies$273$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype || t5.getDataType(), u2 = i2._values, d2 = i2._index, p2 = i2._ptr, m2 = i2._size, h2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (c2.length !== m2.length) throw new DimensionError$2(c2.length, m2.length);
    if (c2[0] !== m2[0] || c2[1] !== m2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + c2 + `) must match Matrix B (` + m2 + `)`);
    if (!u2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var g2 = c2[0], v2 = c2[1], y2, b2 = r2, x2 = 0, S2 = a2;
    typeof l2 == `string` && l2 === h2 && l2 !== `mixed` && (y2 = l2, b2 = n2.find(r2, [y2, y2]), x2 = n2.convert(0, y2), S2 = n2.find(a2, [y2, y2]));
    for (var w2 = [], E = [], D = [], O2 = 0; O2 < v2; O2++) {
      D[O2] = E.length;
      for (var j2 = p2[O2], M2 = p2[O2 + 1], N2 = j2; N2 < M2; N2++) {
        var F = d2[N2], I2 = o2 ? S2(u2[N2], s2[F][O2]) : S2(s2[F][O2], u2[N2]);
        b2(I2, x2) || (E.push(F), w2.push(I2));
      }
    }
    return D[v2] = E.length, i2.createSparseMatrix({ values: w2, index: E, ptr: D, size: [g2, v2], datatype: l2 === t5._datatype && h2 === i2._datatype ? y2 : void 0 });
  };
}), name$272$2 = `matAlgo03xDSf`, dependencies$272$2 = [`typed`], createMatAlgo03xDSf$2 = factory$2(name$272$2, dependencies$272$2, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError$2(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2, y2 = 0, b2 = i2;
    typeof c2 == `string` && c2 === m2 && c2 !== `mixed` && (v2 = c2, y2 = n2.convert(0, v2), b2 = n2.find(i2, [v2, v2]));
    for (var x2 = [], S2 = 0; S2 < h2; S2++) x2[S2] = [];
    for (var w2 = [], E = [], D = 0; D < g2; D++) {
      for (var O2 = D + 1, j2 = d2[D], M2 = d2[D + 1], N2 = j2; N2 < M2; N2++) {
        var F = u2[N2];
        w2[F] = a2 ? b2(l2[N2], o2[F][D]) : b2(o2[F][D], l2[N2]), E[F] = O2;
      }
      for (var I2 = 0; I2 < h2; I2++) E[I2] === O2 ? x2[I2][D] = w2[I2] : x2[I2][D] = a2 ? b2(y2, o2[I2][D]) : b2(o2[I2][D], y2);
    }
    return t5.createDenseMatrix({ data: x2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$271$2 = `matAlgo05xSfSf`, dependencies$271$2 = [`typed`, `equalScalar`], createMatAlgo05xSfSf$2 = factory$2(name$271$2, dependencies$271$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$2(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = E ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var V2 = L2 + 1;
      for (R2 = c2[L2], z2 = c2[L2 + 1]; R2 < z2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = V2, j2 && (j2[I2] = o2[R2]);
      for (R2 = m2[L2], z2 = m2[L2 + 1]; R2 < z2; R2++) I2 = p2[R2], N2[I2] !== V2 && D.push(I2), F[I2] = V2, M2 && (M2[I2] = d2[R2]);
      if (E) for (R2 = O2[L2]; R2 < D.length; ) {
        I2 = D[R2];
        var H2 = N2[I2], U2 = F[I2];
        if (H2 === V2 || U2 === V2) {
          var W2 = H2 === V2 ? j2[I2] : S2, G2 = U2 === V2 ? M2[I2] : S2, K2 = w2(W2, G2);
          x2(K2, S2) ? D.splice(R2, 1) : (E.push(K2), R2++);
        }
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$270$2 = `matAlgo13xDD`, dependencies$270$2 = [`typed`], createMatAlgo13xDD$2 = factory$2(name$270$2, dependencies$270$2, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype, l2 = i2._data, u2 = i2._size, d2 = i2._datatype, p2 = [];
    if (s2.length !== u2.length) throw new DimensionError$2(s2.length, u2.length);
    for (var m2 = 0; m2 < s2.length; m2++) {
      if (s2[m2] !== u2[m2]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
      p2[m2] = s2[m2];
    }
    var h2, g2 = a2;
    typeof c2 == `string` && c2 === d2 && (h2 = c2, g2 = n2.find(a2, [h2, h2]));
    var v2 = p2.length > 0 ? r2(g2, 0, p2, p2[0], o2, l2) : [];
    return t5.createDenseMatrix({ data: v2, size: p2, datatype: h2 });
  };
  function r2(t5, n3, i2, a2, o2, s2) {
    var c2 = [];
    if (n3 === i2.length - 1) for (var l2 = 0; l2 < a2; l2++) c2[l2] = t5(o2[l2], s2[l2]);
    else for (var u2 = 0; u2 < a2; u2++) c2[u2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[u2], s2[u2]);
    return c2;
  }
});
function broadcast$2(t4, n2) {
  if (deepStrictEqual$2(t4.size(), n2.size())) return [t4, n2];
  var r2 = broadcastSizes$2(t4.size(), n2.size());
  return [t4, n2].map((t5) => _broadcastTo$2(t5, r2));
}
function _broadcastTo$2(t4, n2) {
  return deepStrictEqual$2(t4.size(), n2) ? t4 : t4.create(broadcastTo$2(t4.valueOf(), n2), t4.datatype());
}
var name$269$2 = `matrixAlgorithmSuite`, dependencies$269$2 = [`typed`, `matrix`], createMatrixAlgorithmSuite$2 = factory$2(name$269$2, dependencies$269$2, (t4) => {
  var { typed: n2, matrix: r2 } = t4, i2 = createMatAlgo13xDD$2({ typed: n2 }), a2 = createMatAlgo14xDs$2({ typed: n2 });
  return function(t5) {
    var o2 = t5.elop, s2 = t5.SD || t5.DS, c2;
    o2 ? (c2 = { "DenseMatrix, DenseMatrix": (t6, n3) => i2(...broadcast$2(t6, n3), o2), "Array, Array": (t6, n3) => i2(...broadcast$2(r2(t6), r2(n3)), o2).valueOf(), "Array, DenseMatrix": (t6, n3) => i2(...broadcast$2(r2(t6), n3), o2), "DenseMatrix, Array": (t6, n3) => i2(...broadcast$2(t6, r2(n3)), o2) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = (n3, r3) => t5.SS(...broadcast$2(n3, r3), o2, false)), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = (n3, r3) => t5.DS(...broadcast$2(n3, r3), o2, false), c2[`Array, SparseMatrix`] = (n3, i3) => t5.DS(...broadcast$2(r2(n3), i3), o2, false)), s2 && (c2[`SparseMatrix, DenseMatrix`] = (t6, n3) => s2(...broadcast$2(n3, t6), o2, true), c2[`SparseMatrix, Array`] = (t6, n3) => s2(...broadcast$2(r2(n3), t6), o2, true))) : (c2 = { "DenseMatrix, DenseMatrix": n2.referToSelf((t6) => (n3, r3) => i2(...broadcast$2(n3, r3), t6)), "Array, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$2(r2(n3), r2(a3)), t6).valueOf()), "Array, DenseMatrix": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$2(r2(n3), a3), t6)), "DenseMatrix, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$2(n3, r2(a3)), t6)) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.SS(...broadcast$2(r3, i3), n3, false))), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.DS(...broadcast$2(r3, i3), n3, false)), c2[`Array, SparseMatrix`] = n2.referToSelf((n3) => (i3, a3) => t5.DS(...broadcast$2(r2(i3), a3), n3, false))), s2 && (c2[`SparseMatrix, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => s2(...broadcast$2(r3, n3), t6, true)), c2[`SparseMatrix, Array`] = n2.referToSelf((t6) => (n3, i3) => s2(...broadcast$2(r2(i3), n3), t6, true))));
    var l2 = t5.scalar || `any`;
    (t5.Ds || t5.Ss) && (o2 ? (c2[`DenseMatrix,` + l2] = (t6, n3) => a2(t6, n3, o2, false), c2[l2 + `, DenseMatrix`] = (t6, n3) => a2(n3, t6, o2, true), c2[`Array,` + l2] = (t6, n3) => a2(r2(t6), n3, o2, false).valueOf(), c2[l2 + `, Array`] = (t6, n3) => a2(r2(n3), t6, o2, true).valueOf()) : (c2[`DenseMatrix,` + l2] = n2.referToSelf((t6) => (n3, r3) => a2(n3, r3, t6, false)), c2[l2 + `, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => a2(r3, n3, t6, true)), c2[`Array,` + l2] = n2.referToSelf((t6) => (n3, i3) => a2(r2(n3), i3, t6, false).valueOf()), c2[l2 + `, Array`] = n2.referToSelf((t6) => (n3, i3) => a2(r2(i3), n3, t6, true).valueOf())));
    var u2 = t5.sS === void 0 ? t5.Ss : t5.sS;
    return o2 ? (t5.Ss && (c2[`SparseMatrix,` + l2] = (n3, r3) => t5.Ss(n3, r3, o2, false)), u2 && (c2[l2 + `, SparseMatrix`] = (t6, n3) => u2(n3, t6, o2, true))) : (t5.Ss && (c2[`SparseMatrix,` + l2] = n2.referToSelf((n3) => (r3, i3) => t5.Ss(r3, i3, n3, false))), u2 && (c2[l2 + `, SparseMatrix`] = n2.referToSelf((t6) => (n3, r3) => u2(r3, n3, t6, true)))), o2 && o2.signatures && extend$1$4(c2, o2.signatures), c2;
  };
}), name$268$2 = `mod`, dependencies$268$2 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createMod$2 = factory$2(name$268$2, dependencies$268$2, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createFloor$2({ typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 }), d2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: o2 }), p2 = createMatAlgo03xDSf$2({ typed: n2 }), m2 = createMatAlgo05xSfSf$2({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: o2 }), g2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: c2 }), v2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: a2, concat: l2 });
  return n2(name$268$2, { "number, number": y2, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isZero() ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  }, "bigint, bigint": function(t5, n3) {
    if (n3 === 0n) return t5;
    if (t5 < 0) {
      var r3 = t5 % n3;
      return r3 === 0n ? r3 : r3 + n3;
    }
    return t5 % n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return n3.equals(0) ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  } }, v2({ SS: m2, DS: p2, SD: d2, Ss: h2, sS: g2 }));
  function y2(t5, n3) {
    return n3 === 0 ? t5 : t5 - n3 * u2(t5 / n3);
  }
}), name$267$2 = `matAlgo01xDSid`, dependencies$267$2 = [`typed`], createMatAlgo01xDSid$2 = factory$2(name$267$2, dependencies$267$2, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError$2(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2 = typeof c2 == `string` && c2 !== `mixed` && c2 === m2 ? c2 : void 0, y2 = v2 ? n2.find(i2, [v2, v2]) : i2, b2, x2, S2 = [];
    for (b2 = 0; b2 < h2; b2++) S2[b2] = [];
    var w2 = [], E = [];
    for (x2 = 0; x2 < g2; x2++) {
      for (var D = x2 + 1, O2 = d2[x2], j2 = d2[x2 + 1], M2 = O2; M2 < j2; M2++) b2 = u2[M2], w2[b2] = a2 ? y2(l2[M2], o2[b2][x2]) : y2(o2[b2][x2], l2[M2]), E[b2] = D;
      for (b2 = 0; b2 < h2; b2++) E[b2] === D ? S2[b2][x2] = w2[b2] : S2[b2][x2] = o2[b2][x2];
    }
    return t5.createDenseMatrix({ data: S2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$266$2 = `matAlgo04xSidSid`, dependencies$266$2 = [`typed`, `equalScalar`], createMatAlgo04xSidSid$2 = factory$2(name$266$2, dependencies$266$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$2(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = o2 && d2 ? [] : void 0, M2 = o2 && d2 ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2, V2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var H2 = L2 + 1;
      for (z2 = c2[L2], V2 = c2[L2 + 1], R2 = z2; R2 < V2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = H2, j2 && (j2[I2] = o2[R2]);
      for (z2 = m2[L2], V2 = m2[L2 + 1], R2 = z2; R2 < V2; R2++) if (I2 = p2[R2], N2[I2] === H2) {
        if (j2) {
          var U2 = w2(j2[I2], d2[R2]);
          x2(U2, S2) ? N2[I2] = null : j2[I2] = U2;
        }
      } else D.push(I2), F[I2] = H2, M2 && (M2[I2] = d2[R2]);
      if (j2 && M2) for (R2 = O2[L2]; R2 < D.length; ) I2 = D[R2], N2[I2] === H2 ? (E[R2] = j2[I2], R2++) : F[I2] === H2 ? (E[R2] = M2[I2], R2++) : D.splice(R2, 1);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$265$2 = `matAlgo10xSids`, dependencies$265$2 = [`typed`, `DenseMatrix`], createMatAlgo10xSids$2 = factory$2(name$265$2, dependencies$265$2, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = i2;
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
});
function ArgumentsError$2(t4, n2, r2, i2) {
  if (!(this instanceof ArgumentsError$2)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.fn = t4, this.count = n2, this.min = r2, this.max = i2, this.message = `Wrong number of arguments in function ` + t4 + ` (` + n2 + ` provided, ` + r2 + (i2 == null ? `` : `-` + i2) + ` expected)`, this.stack = Error().stack;
}
ArgumentsError$2.prototype = Error(), ArgumentsError$2.prototype.constructor = Error, ArgumentsError$2.prototype.name = `ArgumentsError`, ArgumentsError$2.prototype.isArgumentsError = true;
var name$264$2 = `gcd`, dependencies$264$2 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`, `concat`], gcdTypes$2 = `number | BigNumber | Fraction | Matrix | Array`, gcdManyTypesSignature$2 = `${gcdTypes$2}, ${gcdTypes$2}, ...${gcdTypes$2}`;
function is1d$2(t4) {
  return !t4.some((t5) => Array.isArray(t5));
}
var createGcd$2 = factory$2(name$264$2, dependencies$264$2, (t4) => {
  var { typed: n2, matrix: r2, config: i2, round: a2, equalScalar: o2, zeros: s2, BigNumber: c2, DenseMatrix: l2, concat: u2 } = t4, d2 = createMod$2({ typed: n2, config: i2, round: a2, matrix: r2, equalScalar: o2, zeros: s2, DenseMatrix: l2, concat: u2 }), p2 = createMatAlgo01xDSid$2({ typed: n2 }), m2 = createMatAlgo04xSidSid$2({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: l2 }), g2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: u2 });
  return n2(name$264$2, { "number, number": v2, "BigNumber, BigNumber": y2, "Fraction, Fraction": (t5, n3) => t5.gcd(n3) }, g2({ SS: m2, DS: p2, Ss: h2 }), { [gcdManyTypesSignature$2]: n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), Array: n2.referToSelf((t5) => (n3) => {
    if (n3.length === 1 && Array.isArray(n3[0]) && is1d$2(n3[0])) return t5(...n3[0]);
    if (is1d$2(n3)) return t5(...n3);
    throw new ArgumentsError$2(`gcd() supports only 1d matrices!`);
  }), Matrix: n2.referToSelf((t5) => (n3) => t5(n3.toArray())) });
  function v2(t5, n3) {
    if (!isInteger$3(t5) || !isInteger$3(n3)) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3; n3 !== 0; ) r3 = d2(t5, n3), t5 = n3, n3 = r3;
    return t5 < 0 ? -t5 : t5;
  }
  function y2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3 = new c2(0); !n3.isZero(); ) {
      var i3 = d2(t5, n3);
      t5 = n3, n3 = i3;
    }
    return t5.lt(r3) ? t5.neg() : t5;
  }
}), name$263$2 = `matAlgo06xS0S0`, dependencies$263$2 = [`typed`, `equalScalar`], createMatAlgo06xS0S0$2 = factory$2(name$263$2, dependencies$263$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = i2._values, u2 = i2._size, d2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (s2.length !== u2.length) throw new DimensionError$2(s2.length, u2.length);
    if (s2[0] !== u2[0] || s2[1] !== u2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
    var p2 = s2[0], m2 = s2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof c2 == `string` && c2 === d2 && c2 !== `mixed` && (h2 = c2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = o2 && l2 ? [] : void 0, x2 = [], S2 = [], w2 = b2 ? [] : void 0, E = [], D = [], O2 = 0; O2 < m2; O2++) {
      S2[O2] = x2.length;
      var j2 = O2 + 1;
      if (scatter$2(t5, O2, E, w2, D, j2, x2, y2), scatter$2(i2, O2, E, w2, D, j2, x2, y2), w2) for (var M2 = S2[O2]; M2 < x2.length; ) {
        var N2 = x2[M2];
        if (D[N2] === j2) {
          var F = w2[N2];
          g2(F, v2) ? x2.splice(M2, 1) : (b2.push(F), M2++);
        } else x2.splice(M2, 1);
      }
      else for (var I2 = S2[O2]; I2 < x2.length; ) D[x2[I2]] === j2 ? I2++ : x2.splice(I2, 1);
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: c2 === t5._datatype && d2 === i2._datatype ? h2 : void 0 });
  };
}), name$262$2 = `lcm`, dependencies$262$2 = [`typed`, `matrix`, `equalScalar`, `concat`], createLcm$2 = factory$2(name$262$2, dependencies$262$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0$2({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: a2 }), u2 = `number | BigNumber | Fraction | Matrix | Array`, d2 = {};
  return d2[`${u2}, ${u2}, ...${u2}`] = n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), n2(name$262$2, { "number, number": lcmNumber$2, "BigNumber, BigNumber": p2, "Fraction, Fraction": (t5, n3) => t5.lcm(n3) }, l2({ SS: s2, DS: o2, Ss: c2 }), d2);
  function p2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function lcm must be integer numbers`);
    if (t5.isZero()) return t5;
    if (n3.isZero()) return n3;
    for (var r3 = t5.times(n3); !n3.isZero(); ) {
      var i3 = n3;
      n3 = t5.mod(i3), t5 = i3;
    }
    return r3.div(t5).abs();
  }
});
function promoteLogarithm$2(t4, n2, r2, i2) {
  return function(a2) {
    if (a2 > 0 || r2.predictable) {
      if (a2 <= 0) return NaN;
      var o2 = a2.toString(16), s2 = o2.substring(0, 15);
      return t4 * (o2.length - s2.length) + n2(Number(`0x` + s2));
    }
    return i2(a2.toNumber());
  };
}
var name$261$2 = `log10`, dependencies$261$2 = [`typed`, `config`, `Complex`], log16$2 = log10Number$2(16), createLog10$2 = factory$2(name$261$2, dependencies$261$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return t5.log().div(Math.LN10);
  }
  function o2(t5) {
    return a2(new i2(t5, 0));
  }
  return n2(name$261$2, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log10Number$2(t5) : o2(t5);
  }, bigint: promoteLogarithm$2(log16$2, log10Number$2, r2, o2), Complex: a2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log() : o2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$260$2 = `log2`, dependencies$260$2 = [`typed`, `config`, `Complex`], createLog2$2 = factory$2(name$260$2, dependencies$260$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return o2(new i2(t5, 0));
  }
  return n2(name$260$2, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log2Number$2(t5) : a2(t5);
  }, bigint: promoteLogarithm$2(4, log2Number$2, r2, a2), Complex: o2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log(2) : a2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
  function o2(t5) {
    var n3 = Math.sqrt(t5.re * t5.re + t5.im * t5.im);
    return new i2(Math.log2 ? Math.log2(n3) : Math.log(n3) / Math.LN2, Math.atan2(t5.im, t5.re) / Math.LN2);
  }
}), name$259$2 = `multiplyScalar`, dependencies$259$2 = [`typed`], createMultiplyScalar$2 = factory$2(name$259$2, dependencies$259$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`multiplyScalar`, { "number, number": multiplyNumber$2, "Complex, Complex": function(t5, n3) {
    return t5.mul(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.times(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 * n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.mul(n3);
  }, "number | Fraction | BigNumber | Complex, Unit": (t5, n3) => n3.multiply(t5), "Unit, number | Fraction | BigNumber | Complex | Unit": (t5, n3) => t5.multiply(n3) });
}), name$258$2 = `multiply`, dependencies$258$2 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `equalScalar`, `dot`], createMultiply$2 = factory$2(name$258$2, dependencies$258$2, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, equalScalar: o2, dot: s2 } = t4, c2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: o2 }), l2 = createMatAlgo14xDs$2({ typed: n2 });
  function u2(t5, n3) {
    switch (t5.length) {
      case 1:
        switch (n3.length) {
          case 1:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vectors must have the same length`);
            break;
          case 2:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vector length (` + t5[0] + `) must match Matrix rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      case 2:
        switch (n3.length) {
          case 1:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix columns (` + t5[1] + `) must match Vector length (` + n3[0] + `)`);
            break;
          case 2:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix A columns (` + t5[1] + `) must match Matrix B rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      default:
        throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix A has ` + t5.length + ` dimensions)`);
    }
  }
  function d2(t5, n3, r3) {
    if (r3 === 0) throw Error(`Cannot multiply two empty vectors`);
    return s2(t5, n3);
  }
  function p2(t5, n3) {
    if (n3.storage() !== `dense`) throw Error(`Support for SparseMatrix not implemented`);
    return m2(t5, n3);
  }
  function m2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = u3[1], h3, g3 = i2, v3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && (h3 = c3, g3 = n2.find(i2, [h3, h3]), v3 = n2.find(a2, [h3, h3]));
    for (var y3 = [], b3 = 0; b3 < m3; b3++) {
      for (var x3 = v3(o3[0], l3[0][b3]), S3 = 1; S3 < p3; S3++) x3 = g3(x3, v3(o3[S3], l3[S3][b3]));
      y3[b3] = x3;
    }
    return t5.createDenseMatrix({ data: y3, size: [m3], datatype: c3 === t5._datatype && d3 === r3._datatype ? h3 : void 0 });
  }
  var h2 = n2(`_multiplyMatrixVector`, { "DenseMatrix, any": v2, "SparseMatrix, any": x2 }), g2 = n2(`_multiplyMatrixMatrix`, { "DenseMatrix, DenseMatrix": y2, "DenseMatrix, SparseMatrix": b2, "SparseMatrix, DenseMatrix": S2, "SparseMatrix, SparseMatrix": w2 });
  function v2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._datatype || r3.getDataType(), d3 = s3[0], p3 = s3[1], m3, h3 = i2, g3 = a2;
    c3 && u3 && c3 === u3 && typeof c3 == `string` && c3 !== `mixed` && (m3 = c3, h3 = n2.find(i2, [m3, m3]), g3 = n2.find(a2, [m3, m3]));
    for (var v3 = [], y3 = 0; y3 < d3; y3++) {
      for (var b3 = o3[y3], x3 = g3(b3[0], l3[0]), S3 = 1; S3 < p3; S3++) x3 = h3(x3, g3(b3[S3], l3[S3]));
      v3[y3] = x3;
    }
    return t5.createDenseMatrix({ data: v3, size: [d3], datatype: c3 === t5._datatype && u3 === r3._datatype ? m3 : void 0 });
  }
  function y2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = s3[1], h3 = u3[1], g3, v3 = i2, y3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && c3 !== `mixed` && (g3 = c3, v3 = n2.find(i2, [g3, g3]), y3 = n2.find(a2, [g3, g3]));
    for (var b3 = [], x3 = 0; x3 < p3; x3++) {
      var S3 = o3[x3];
      b3[x3] = [];
      for (var w3 = 0; w3 < h3; w3++) {
        for (var E = y3(S3[0], l3[0][w3]), D = 1; D < m3; D++) E = v3(E, y3(S3[D], l3[D][w3]));
        b3[x3][w3] = E;
      }
    }
    return t5.createDenseMatrix({ data: b3, size: [p3, h3], datatype: c3 === t5._datatype && d3 === r3._datatype ? g3 : void 0 });
  }
  function b2(t5, r3) {
    var s3 = t5._data, c3 = t5._size, l3 = t5._datatype || t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._size, h3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType();
    if (!u3) throw Error(`Cannot multiply Dense Matrix times Pattern only Matrix`);
    var g3 = c3[0], v3 = m3[1], y3, b3 = i2, x3 = a2, S3 = o2, w3 = 0;
    l3 && h3 && l3 === h3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]), S3 = n2.find(o2, [y3, y3]), w3 = n2.convert(0, y3));
    for (var E = [], D = [], O2 = [], j2 = r3.createSparseMatrix({ values: E, index: D, ptr: O2, size: [g3, v3], datatype: l3 === t5._datatype && h3 === r3._datatype ? y3 : void 0 }), M2 = 0; M2 < v3; M2++) {
      O2[M2] = D.length;
      var N2 = p3[M2], F = p3[M2 + 1];
      if (F > N2) for (var I2 = 0, L2 = 0; L2 < g3; L2++) {
        for (var R2 = L2 + 1, z2 = void 0, V2 = N2; V2 < F; V2++) {
          var H2 = d3[V2];
          I2 === R2 ? z2 = b3(z2, x3(s3[L2][H2], u3[V2])) : (z2 = x3(s3[L2][H2], u3[V2]), I2 = R2);
        }
        I2 === R2 && !S3(z2, w3) && (D.push(L2), E.push(z2));
      }
    }
    return O2[v3] = D.length, j2;
  }
  function x2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = [], v3 = [], y3 = [], b3, x3 = i2, S3 = a2, w3 = o2, E = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (b3 = u3, x3 = n2.find(i2, [b3, b3]), S3 = n2.find(a2, [b3, b3]), w3 = n2.find(o2, [b3, b3]), E = n2.convert(0, b3));
    var D = [], O2 = [];
    y3[0] = 0;
    for (var j2 = 0; j2 < h3; j2++) {
      var M2 = d3[j2];
      if (!w3(M2, E)) for (var N2 = l3[j2], F = l3[j2 + 1], I2 = N2; I2 < F; I2++) {
        var L2 = c3[I2];
        O2[L2] ? D[L2] = x3(D[L2], S3(M2, s3[I2])) : (O2[L2] = true, v3.push(L2), D[L2] = S3(M2, s3[I2]));
      }
    }
    for (var R2 = v3.length, z2 = 0; z2 < R2; z2++) g3[z2] = D[v3[z2]];
    return y3[1] = v3.length, t5.createSparseMatrix({ values: g3, index: v3, ptr: y3, size: [m3, 1], datatype: u3 === t5._datatype && p3 === r3._datatype ? b3 : void 0 });
  }
  function S2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = r3._size[1], v3, y3 = i2, b3 = a2, x3 = o2, S3 = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (v3 = u3, y3 = n2.find(i2, [v3, v3]), b3 = n2.find(a2, [v3, v3]), x3 = n2.find(o2, [v3, v3]), S3 = n2.convert(0, v3));
    for (var w3 = [], E = [], D = [], O2 = t5.createSparseMatrix({ values: w3, index: E, ptr: D, size: [m3, g3], datatype: u3 === t5._datatype && p3 === r3._datatype ? v3 : void 0 }), j2 = [], M2 = [], N2 = 0; N2 < g3; N2++) {
      D[N2] = E.length;
      for (var F = N2 + 1, I2 = 0; I2 < h3; I2++) {
        var L2 = d3[I2][N2];
        if (!x3(L2, S3)) for (var R2 = l3[I2], z2 = l3[I2 + 1], V2 = R2; V2 < z2; V2++) {
          var H2 = c3[V2];
          M2[H2] === F ? j2[H2] = y3(j2[H2], b3(L2, s3[V2])) : (M2[H2] = F, E.push(H2), j2[H2] = b3(L2, s3[V2]));
        }
      }
      for (var U2 = D[N2], W2 = E.length, G2 = U2; G2 < W2; G2++) w3[G2] = j2[E[G2]];
    }
    return D[g3] = E.length, O2;
  }
  function w2(t5, r3) {
    var o3 = t5._values, s3 = t5._index, c3 = t5._ptr, l3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType(), h3 = t5._size[0], g3 = r3._size[1], v3 = o3 && u3, y3, b3 = i2, x3 = a2;
    l3 && m3 && l3 === m3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]));
    for (var S3 = v3 ? [] : void 0, w3 = [], E = [], D = t5.createSparseMatrix({ values: S3, index: w3, ptr: E, size: [h3, g3], datatype: l3 === t5._datatype && m3 === r3._datatype ? y3 : void 0 }), O2 = v3 ? [] : void 0, j2 = [], M2, N2, F, I2, L2, R2, z2, V2, H2 = 0; H2 < g3; H2++) {
      E[H2] = w3.length;
      var U2 = H2 + 1;
      for (L2 = p3[H2], R2 = p3[H2 + 1], I2 = L2; I2 < R2; I2++) if (V2 = d3[I2], v3) for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] === U2 ? O2[z2] = b3(O2[z2], x3(u3[I2], o3[M2])) : (j2[z2] = U2, w3.push(z2), O2[z2] = x3(u3[I2], o3[M2]));
      else for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] !== U2 && (j2[z2] = U2, w3.push(z2));
      if (v3) for (var W2 = E[H2], G2 = w3.length, K2 = W2; K2 < G2; K2++) S3[K2] = O2[w3[K2]];
    }
    return E[g3] = w3.length, D;
  }
  return n2(name$258$2, a2, { "Array, Array": n2.referTo(`Matrix, Matrix`, (t5) => (n3, i3) => {
    u2(arraySize$2(n3), arraySize$2(i3));
    var a3 = t5(r2(n3), r2(i3));
    return isMatrix$2(a3) ? a3.valueOf() : a3;
  }), "Matrix, Matrix": function(t5, n3) {
    var r3 = t5.size(), i3 = n3.size();
    return u2(r3, i3), r3.length === 1 ? i3.length === 1 ? d2(t5, n3, r3[0]) : p2(t5, n3) : i3.length === 1 ? h2(t5, n3) : g2(t5, n3);
  }, "Matrix, Array": n2.referTo(`Matrix,Matrix`, (t5) => (n3, i3) => t5(n3, r2(i3))), "Array, Matrix": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3, i3.storage()), i3)), "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, a2, false);
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, a2, false);
  }, "any, SparseMatrix": function(t5, n3) {
    return c2(n3, t5, a2, true);
  }, "any, DenseMatrix": function(t5, n3) {
    return l2(n3, t5, a2, true);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, a2, false).valueOf();
  }, "any, Array": function(t5, n3) {
    return l2(r2(n3), t5, a2, true).valueOf();
  }, "any, any": a2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) });
}), name$257$2 = `nthRoot`, dependencies$257$2 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `concat`], createNthRoot$2 = factory$2(name$257$2, dependencies$257$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid$2({ typed: n2 }), c2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), d2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: o2 });
  function p2() {
    throw Error(`Complex number not supported in function nthRoot. Use nthRoots instead.`);
  }
  return n2(name$257$2, { number: nthRootNumber$2, "number, number": nthRootNumber$2, BigNumber: (t5) => m2(t5, new a2(2)), "BigNumber, BigNumber": m2, Complex: p2, "Complex, number": p2, Array: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(r2(n3), 2).valueOf()), DenseMatrix: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(n3, 2)), SparseMatrix: n2.referTo(`SparseMatrix,number`, (t5) => (n3) => t5(n3, 2)), "SparseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return l2(n3, r3, t5);
    throw Error(`Root must be non-zero`);
  }), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return s2(n3, r3, t5, false);
    throw Error(`Root must be non-zero`);
  }), "Array, SparseMatrix": n2.referTo(`DenseMatrix,SparseMatrix`, (t5) => (n3, i3) => t5(r2(n3), i3)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return u2(r3, n3, t5, true);
    throw Error(`Root must be non-zero`);
  }) }, d2({ scalar: `number | BigNumber`, SD: c2, Ss: u2, sS: false }));
  function m2(t5, n3) {
    var r3 = a2.precision, i3 = a2.clone({ precision: r3 + 2 }), o3 = new a2(0), s3 = new i3(1), c3 = n3.isNegative();
    if (c3 && (n3 = n3.neg()), n3.isZero()) throw Error(`Root must be non-zero`);
    if (t5.isNegative() && !n3.abs().mod(2).equals(1)) throw Error(`Root must be odd when a is negative.`);
    if (t5.isZero()) return c3 ? new i3(1 / 0) : 0;
    if (!t5.isFinite()) return c3 ? o3 : t5;
    var l3 = t5.abs().pow(s3.div(n3));
    return l3 = t5.isNeg() ? l3.neg() : l3, new a2((c3 ? s3.div(l3) : l3).toPrecision(r3));
  }
}), name$256$2 = `sign`, dependencies$256$2 = [`typed`, `BigNumber`, `Fraction`, `complex`], createSign$2 = factory$2(name$256$2, dependencies$256$2, (t4) => {
  var { typed: n2, BigNumber: r2, complex: i2, Fraction: a2 } = t4;
  return n2(name$256$2, { number: signNumber$2, Complex: function(t5) {
    return t5.im === 0 ? i2(signNumber$2(t5.re)) : t5.sign();
  }, BigNumber: function(t5) {
    return new r2(t5.cmp(0));
  }, bigint: function(t5) {
    return t5 > 0n ? 1n : t5 < 0n ? -1n : 0n;
  }, Fraction: function(t5) {
    return t5.n === 0n ? new a2(0) : new a2(t5.s);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), Unit: n2.referToSelf((t5) => (r3) => {
    if (!r3._isDerived() && r3.units[0].unit.offset !== 0) throw TypeError(`sign is ambiguous for units with offset`);
    return n2.find(t5, r3.valueType())(r3.value);
  }) });
}), name$255$2 = `sqrt`, dependencies$255$2 = [`config`, `typed`, `Complex`], createSqrt$2 = factory$2(name$255$2, dependencies$255$2, (t4) => {
  var { config: n2, typed: r2, Complex: i2 } = t4;
  return r2(`sqrt`, { number: a2, Complex: function(t5) {
    return t5.sqrt();
  }, BigNumber: function(t5) {
    return !t5.isNegative() || n2.predictable ? t5.sqrt() : a2(t5.toNumber());
  }, Unit: function(t5) {
    return t5.pow(0.5);
  } });
  function a2(t5) {
    return isNaN(t5) ? NaN : t5 >= 0 || n2.predictable ? Math.sqrt(t5) : new i2(t5, 0).sqrt();
  }
}), name$254$2 = `square`, dependencies$254$2 = [`typed`], createSquare$2 = factory$2(name$254$2, dependencies$254$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$254$2, { number: squareNumber$2, Complex: function(t5) {
    return t5.mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5);
  }, bigint: function(t5) {
    return t5 * t5;
  }, Fraction: function(t5) {
    return t5.mul(t5);
  }, Unit: function(t5) {
    return t5.pow(2);
  } });
}), name$253$2 = `subtract`, dependencies$253$2 = [`typed`, `matrix`, `equalScalar`, `subtractScalar`, `unaryMinus`, `DenseMatrix`, `concat`], createSubtract$2 = factory$2(name$253$2, dependencies$253$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, subtractScalar: a2, unaryMinus: o2, DenseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid$2({ typed: n2 }), u2 = createMatAlgo03xDSf$2({ typed: n2 }), d2 = createMatAlgo05xSfSf$2({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: s2 }), m2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: s2 }), h2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$253$2, { "any, any": a2 }, h2({ elop: a2, SS: d2, DS: l2, SD: u2, Ss: m2, sS: p2 }));
}), name$252$2 = `xgcd`, dependencies$252$2 = [`typed`, `config`, `matrix`, `BigNumber`], createXgcd$2 = factory$2(name$252$2, dependencies$252$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$252$2, { "number, number": function(t5, n3) {
    var a3 = xgcdNumber$2(t5, n3);
    return r2.matrix === `Array` ? a3 : i2(a3);
  }, "BigNumber, BigNumber": o2 });
  function o2(t5, n3) {
    var o3, s2, c2, l2 = new a2(0), u2 = new a2(1), d2 = l2, p2 = u2, m2 = u2, h2 = l2;
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function xgcd must be integer numbers`);
    for (; !n3.isZero(); ) s2 = t5.div(n3).floor(), c2 = t5.mod(n3), o3 = d2, d2 = p2.minus(s2.times(d2)), p2 = o3, o3 = m2, m2 = h2.minus(s2.times(m2)), h2 = o3, t5 = n3, n3 = c2;
    var g2 = t5.lt(l2) ? [t5.neg(), p2.neg(), h2.neg()] : [t5, t5.isZero() ? 0 : p2, h2];
    return r2.matrix === `Array` ? g2 : i2(g2);
  }
}), name$251$2 = `invmod`, dependencies$251$2 = [`typed`, `config`, `BigNumber`, `xgcd`, `equal`, `smaller`, `mod`, `add`, `isInteger`], createInvmod$2 = factory$2(name$251$2, dependencies$251$2, (t4) => {
  var { typed: n2, config: r2, BigNumber: i2, xgcd: a2, equal: o2, smaller: s2, mod: c2, add: l2, isInteger: u2 } = t4;
  return n2(name$251$2, { "number, number": d2, "BigNumber, BigNumber": d2 });
  function d2(t5, n3) {
    if (!u2(t5) || !u2(n3)) throw Error(`Parameters in function invmod must be integer numbers`);
    if (t5 = c2(t5, n3), o2(n3, 0)) throw Error(`Divisor must be non zero`);
    var r3 = a2(t5, n3);
    r3 = r3.valueOf();
    var [d3, p2] = r3;
    return o2(d3, i2(1)) ? (p2 = c2(p2, n3), s2(p2, i2(0)) && (p2 = l2(p2, n3)), p2) : NaN;
  }
}), name$250$2 = `matAlgo09xS0Sf`, dependencies$250$2 = [`typed`, `equalScalar`], createMatAlgo09xS0Sf$2 = factory$2(name$250$2, dependencies$250$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$2(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = [], N2, F, I2, L2, R2;
    for (F = 0; F < y2; F++) {
      O2[F] = D.length;
      var z2 = F + 1;
      if (j2) for (L2 = m2[F], R2 = m2[F + 1], I2 = L2; I2 < R2; I2++) N2 = p2[I2], M2[N2] = z2, j2[N2] = d2[I2];
      for (L2 = c2[F], R2 = c2[F + 1], I2 = L2; I2 < R2; I2++) if (N2 = s2[I2], j2) {
        var V2 = M2[N2] === z2 ? j2[N2] : S2, H2 = w2(o2[I2], V2);
        x2(H2, S2) || (D.push(N2), E.push(H2));
      } else D.push(N2);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$249$2 = `dotMultiply`, dependencies$249$2 = [`typed`, `matrix`, `equalScalar`, `multiplyScalar`, `concat`], createDotMultiply$2 = factory$2(name$249$2, dependencies$249$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, multiplyScalar: a2, concat: o2 } = t4, s2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo09xS0Sf$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 });
  return n2(name$249$2, createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: o2 })({ elop: a2, SS: c2, DS: s2, Ss: l2 }));
});
function bitAndBigNumber$2(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitAnd`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero() || n2.eq(-1) || t4.eq(n2)) return t4;
  if (n2.isZero() || t4.eq(-1)) return n2;
  if (!t4.isFinite() || !n2.isFinite()) {
    if (!t4.isFinite() && !n2.isFinite()) return t4.isNegative() === n2.isNegative() ? t4 : new r2(0);
    if (!t4.isFinite()) return n2.isNegative() ? t4 : t4.isNegative() ? new r2(0) : n2;
    if (!n2.isFinite()) return t4.isNegative() ? n2 : n2.isNegative() ? new r2(0) : t4;
  }
  return bitwise$2(t4, n2, function(t5, n3) {
    return t5 & n3;
  });
}
function bitNotBigNumber$2(t4) {
  if (t4.isFinite() && !t4.isInteger()) throw Error(`Integer expected in function bitNot`);
  var n2 = t4.constructor, r2 = n2.precision;
  n2.config({ precision: 1e9 });
  var i2 = t4.plus(new n2(1));
  return i2.s = -i2.s || null, n2.config({ precision: r2 }), i2;
}
function bitOrBigNumber$2(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitOr`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  var i2 = new r2(-1);
  return t4.isZero() || n2.eq(i2) || t4.eq(n2) ? n2 : n2.isZero() || t4.eq(i2) ? t4 : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !t4.isNegative() && n2.isNegative() || t4.isNegative() && !n2.isNegative() && !n2.isFinite() ? i2 : t4.isNegative() && n2.isNegative() ? t4.isFinite() ? t4 : n2 : t4.isFinite() ? n2 : t4 : bitwise$2(t4, n2, function(t5, n3) {
    return t5 | n3;
  });
}
function bitwise$2(t4, n2, r2) {
  var i2 = t4.constructor, a2, o2, s2 = +(t4.s < 0), c2 = +(n2.s < 0);
  if (s2) {
    a2 = decCoefficientToBinaryString$2(bitNotBigNumber$2(t4));
    for (var l2 = 0; l2 < a2.length; ++l2) a2[l2] ^= 1;
  } else a2 = decCoefficientToBinaryString$2(t4);
  if (c2) {
    o2 = decCoefficientToBinaryString$2(bitNotBigNumber$2(n2));
    for (var u2 = 0; u2 < o2.length; ++u2) o2[u2] ^= 1;
  } else o2 = decCoefficientToBinaryString$2(n2);
  var d2, p2, m2;
  a2.length <= o2.length ? (d2 = a2, p2 = o2, m2 = s2) : (d2 = o2, p2 = a2, m2 = c2);
  var h2 = d2.length, g2 = p2.length, v2 = r2(s2, c2) ^ 1, y2 = new i2(v2 ^ 1), b2 = new i2(1), x2 = new i2(2), S2 = i2.precision;
  for (i2.config({ precision: 1e9 }); h2 > 0; ) r2(d2[--h2], p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  for (; g2 > 0; ) r2(m2, p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  return i2.config({ precision: S2 }), v2 === 0 && (y2.s = -y2.s), y2;
}
function decCoefficientToBinaryString$2(t4) {
  for (var n2 = t4.d, r2 = n2[0] + ``, i2 = 1; i2 < n2.length; ++i2) {
    for (var a2 = n2[i2] + ``, o2 = 7 - a2.length; o2--; ) a2 = `0` + a2;
    r2 += a2;
  }
  for (var s2 = r2.length; r2.charAt(s2) === `0`; ) s2--;
  var c2 = t4.e, l2 = r2.slice(0, s2 + 1 || 1), u2 = l2.length;
  if (c2 > 0) if (++c2 > u2) for (c2 -= u2; c2--; ) l2 += `0`;
  else c2 < u2 && (l2 = l2.slice(0, c2) + `.` + l2.slice(c2));
  for (var d2 = [0], p2 = 0; p2 < l2.length; ) {
    for (var m2 = d2.length; m2--; ) d2[m2] *= 10;
    d2[0] += parseInt(l2.charAt(p2++));
    for (var h2 = 0; h2 < d2.length; ++h2) d2[h2] > 1 && ((d2[h2 + 1] === null || d2[h2 + 1] === void 0) && (d2[h2 + 1] = 0), d2[h2 + 1] += d2[h2] >> 1, d2[h2] &= 1);
  }
  return d2.reverse();
}
function bitXor$2(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitXor`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero()) return n2;
  if (n2.isZero()) return t4;
  if (t4.eq(n2)) return new r2(0);
  var i2 = new r2(-1);
  return t4.eq(i2) ? bitNotBigNumber$2(n2) : n2.eq(i2) ? bitNotBigNumber$2(t4) : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !n2.isFinite() ? i2 : new r2(t4.isNegative() === n2.isNegative() ? 1 / 0 : -1 / 0) : bitwise$2(t4, n2, function(t5, n3) {
    return t5 ^ n3;
  });
}
function leftShiftBigNumber$2(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function leftShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : !t4.isFinite() && !n2.isFinite() ? new r2(NaN) : n2.lt(55) ? t4.times(2 ** n2.toNumber() + ``) : t4.times(new r2(2).pow(n2));
}
function rightArithShiftBigNumber$2(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function rightArithShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : n2.isFinite() ? n2.lt(55) ? t4.div(2 ** n2.toNumber() + ``).floor() : t4.div(new r2(2).pow(n2)).floor() : t4.isNegative() ? new r2(-1) : t4.isFinite() ? new r2(0) : new r2(NaN);
}
var name$248$2 = `bitAnd`, dependencies$248$2 = [`typed`, `matrix`, `equalScalar`, `concat`], createBitAnd$2 = factory$2(name$248$2, dependencies$248$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0$2({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$248$2, { "number, number": bitAndNumber$2, "BigNumber, BigNumber": bitAndBigNumber$2, "bigint, bigint": (t5, n3) => t5 & n3 }, l2({ SS: s2, DS: o2, Ss: c2 }));
}), name$247$2 = `bitNot`, dependencies$247$2 = [`typed`], createBitNot$2 = factory$2(name$247$2, dependencies$247$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$247$2, { number: bitNotNumber$2, BigNumber: bitNotBigNumber$2, bigint: (t5) => ~t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$246$2 = `bitOr`, dependencies$246$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOr$2 = factory$2(name$246$2, dependencies$246$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid$2({ typed: n2 }), c2 = createMatAlgo04xSidSid$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$246$2, { "number, number": bitOrNumber$2, "BigNumber, BigNumber": bitOrBigNumber$2, "bigint, bigint": (t5, n3) => t5 | n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$245$2 = `matAlgo07xSSf`, dependencies$245$2 = [`typed`, `SparseMatrix`], createMatAlgo07xSSf$2 = factory$2(name$245$2, dependencies$245$2, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return function(t5, a2, o2) {
    var s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = a2._size, u2 = a2._datatype || a2._data === void 0 ? a2._datatype : a2.getDataType();
    if (s2.length !== l2.length) throw new DimensionError$2(s2.length, l2.length);
    if (s2[0] !== l2[0] || s2[1] !== l2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + l2 + `)`);
    var d2 = s2[0], p2 = s2[1], m2, h2 = 0, g2 = o2;
    typeof c2 == `string` && c2 === u2 && c2 !== `mixed` && (m2 = c2, h2 = n2.convert(0, m2), g2 = n2.find(o2, [m2, m2]));
    for (var v2 = [], y2 = [], b2 = Array(p2 + 1).fill(0), x2 = [], S2 = [], w2 = [], E = [], D = 0; D < p2; D++) {
      var O2 = D + 1, j2 = 0;
      i2(t5, D, w2, x2, O2), i2(a2, D, E, S2, O2);
      for (var M2 = 0; M2 < d2; M2++) {
        var N2 = w2[M2] === O2 ? x2[M2] : h2, F = E[M2] === O2 ? S2[M2] : h2, I2 = g2(N2, F);
        I2 !== 0 && I2 !== false && (y2.push(M2), v2.push(I2), j2++);
      }
      b2[D + 1] = b2[D] + j2;
    }
    return new r2({ values: v2, index: y2, ptr: b2, size: [d2, p2], datatype: c2 === t5._datatype && u2 === a2._datatype ? m2 : void 0 });
  };
  function i2(t5, n3, r3, i3, a2) {
    for (var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = c2[n3], u2 = c2[n3 + 1]; l2 < u2; l2++) {
      var d2 = s2[l2];
      r3[d2] = a2, i3[d2] = o2[l2];
    }
  }
}), name$244$2 = `bitXor`, dependencies$244$2 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createBitXor$2 = factory$2(name$244$2, dependencies$244$2, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf$2({ typed: n2 }), c2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$244$2, { "number, number": bitXorNumber$2, "BigNumber, BigNumber": bitXor$2, "bigint, bigint": (t5, n3) => t5 ^ n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$243$2 = `arg`, dependencies$243$2 = [`typed`], createArg$2 = factory$2(name$243$2, dependencies$243$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$243$2, { number: function(t5) {
    return Math.atan2(0, t5);
  }, BigNumber: function(t5) {
    return t5.constructor.atan2(0, t5);
  }, Complex: function(t5) {
    return t5.arg();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$242$2 = `conj`, dependencies$242$2 = [`typed`], createConj$2 = factory$2(name$242$2, dependencies$242$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$242$2, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.conjugate(), Unit: n2.referToSelf((t5) => (n3) => new n3.constructor(t5(n3.toNumeric()), n3.formatUnits())), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$241$2 = `im`, dependencies$241$2 = [`typed`], createIm$2 = factory$2(name$241$2, dependencies$241$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$241$2, { number: () => 0, "BigNumber | Fraction": (t5) => t5.mul(0), Complex: (t5) => t5.im, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$240$2 = `re`, dependencies$240$2 = [`typed`], createRe$2 = factory$2(name$240$2, dependencies$240$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$240$2, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.re, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$239$2 = `not`, dependencies$239$2 = [`typed`], createNot$2 = factory$2(name$239$2, dependencies$239$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$239$2, { "null | undefined": () => true, number: notNumber$2, Complex: function(t5) {
    return t5.re === 0 && t5.im === 0;
  }, BigNumber: function(t5) {
    return t5.isZero() || t5.isNaN();
  }, bigint: (t5) => !t5, Unit: n2.referToSelf((t5) => (r2) => n2.find(t5, r2.valueType())(r2.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$238$2 = `nullish`, dependencies$238$2 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullish$2 = factory$2(name$238$2, dependencies$238$2, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createMatAlgo03xDSf$2({ typed: n2 }), c2 = createMatAlgo14xDs$2({ typed: n2 }), l2 = createMatAlgo13xDD$2({ typed: n2 });
  return n2(name$238$2, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (t5, n3) => t5, "null, any": (t5, n3) => n3, "undefined, any": (t5, n3) => n3, "SparseMatrix, Array | Matrix": (t5, n3) => {
    var r3 = i2(t5), a3 = i2(n3);
    if (o2(r3, a3)) return t5;
    throw new DimensionError$2(r3, a3);
  }, "DenseMatrix, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5)), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, r3, t5, false)), "DenseMatrix, Array": n2.referToSelf((t5) => (n3, i3) => l2(n3, r2(i3), t5)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => c2(n3, r3, t5, false)), "Array, Array": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), r2(i3), t5).valueOf()), "Array, DenseMatrix": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), i3, t5)), "Array, SparseMatrix": n2.referToSelf((t5) => (n3, i3) => s2(r2(n3), i3, t5, false)), "Array, any": n2.referToSelf((t5) => (n3, i3) => c2(r2(n3), i3, t5, false).valueOf()) });
}), name$237$2 = `or`, dependencies$237$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOr$2 = factory$2(name$237$2, dependencies$237$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo03xDSf$2({ typed: n2 }), c2 = createMatAlgo05xSfSf$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$237$2, { "number, number": orNumber$2, "Complex, Complex": function(t5, n3) {
    return t5.re !== 0 || t5.im !== 0 || n3.re !== 0 || n3.im !== 0;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !t5.isNaN() || !n3.isZero() && !n3.isNaN();
  }, "bigint, bigint": orNumber$2, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$236$2 = `xor`, dependencies$236$2 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createXor$2 = factory$2(name$236$2, dependencies$236$2, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf$2({ typed: n2 }), c2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$236$2, { "number, number": xorNumber$2, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) != (n3.re !== 0 || n3.im !== 0);
  }, "bigint, bigint": xorNumber$2, "BigNumber, BigNumber": function(t5, n3) {
    return (!t5.isZero() && !t5.isNaN()) != (!n3.isZero() && !n3.isNaN());
  }, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$235$2 = `concat`, dependencies$235$2 = [`typed`, `matrix`, `isInteger`], createConcat$2 = factory$2(name$235$2, dependencies$235$2, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4;
  return n2(name$235$2, { "...Array | Matrix | number | BigNumber": function(t5) {
    var n3, a2 = t5.length, o2 = -1, s2, c2 = false, l2 = [];
    for (n3 = 0; n3 < a2; n3++) {
      var u2 = t5[n3];
      if (isMatrix$2(u2) && (c2 = true), isNumber$2(u2) || isBigNumber$2(u2)) {
        if (n3 !== a2 - 1) throw Error(`Dimension must be specified as last argument`);
        if (s2 = o2, o2 = u2.valueOf(), !i2(o2)) throw TypeError(`Integer number expected for dimension`);
        if (o2 < 0 || n3 > 0 && o2 > s2) throw new IndexError$2(o2, s2 + 1);
      } else {
        var d2 = clone$3$2(u2).valueOf(), p2 = arraySize$2(d2);
        if (l2[n3] = d2, s2 = o2, o2 = p2.length - 1, n3 > 0 && o2 !== s2) throw new DimensionError$2(s2 + 1, o2 + 1);
      }
    }
    if (l2.length === 0) throw SyntaxError(`At least one matrix expected`);
    for (var m2 = l2.shift(); l2.length; ) m2 = concat$2(m2, l2.shift(), o2);
    return c2 ? r2(m2) : m2;
  }, "...string": function(t5) {
    return t5.join(``);
  } });
}), name$234$2 = `column`, dependencies$234$2 = [`typed`, `Index`, `matrix`, `range`], createColumn$2 = factory$2(name$234$2, dependencies$234$2, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$234$2, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3$2(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex$2(n3, t5.size()[1]);
    var o3 = new r2(a2(0, t5.size()[0]), [n3]), s2 = t5.subset(o3);
    return isMatrix$2(s2) ? s2 : i2([[s2]]);
  }
}), name$233$2 = `count`, dependencies$233$2 = [`typed`, `size`, `prod`], createCount$2 = factory$2(name$233$2, dependencies$233$2, (t4) => {
  var { typed: n2, size: r2, prod: i2 } = t4;
  return n2(name$233$2, { string: function(t5) {
    return t5.length;
  }, "Matrix | Array": function(t5) {
    return i2(r2(t5));
  } });
}), name$232$2 = `cross`, dependencies$232$2 = [`typed`, `matrix`, `subtract`, `multiply`], createCross$2 = factory$2(name$232$2, dependencies$232$2, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, multiply: a2 } = t4;
  return n2(name$232$2, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function o2(t5, n3) {
    var r3 = Math.max(arraySize$2(t5).length, arraySize$2(n3).length);
    t5 = squeeze$2(t5), n3 = squeeze$2(n3);
    var o3 = arraySize$2(t5), s2 = arraySize$2(n3);
    if (o3.length !== 1 || s2.length !== 1 || o3[0] !== 3 || s2[0] !== 3) throw RangeError(`Vectors with length 3 expected (Size A = [` + o3.join(`, `) + `], B = [` + s2.join(`, `) + `])`);
    var c2 = [i2(a2(t5[1], n3[2]), a2(t5[2], n3[1])), i2(a2(t5[2], n3[0]), a2(t5[0], n3[2])), i2(a2(t5[0], n3[1]), a2(t5[1], n3[0]))];
    return r3 > 1 ? [c2] : c2;
  }
}), name$231$2 = `diag`, dependencies$231$2 = [`typed`, `matrix`, `DenseMatrix`, `SparseMatrix`], createDiag$2 = factory$2(name$231$2, dependencies$231$2, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$231$2, { Array: function(t5) {
    return o2(t5, 0, arraySize$2(t5), null);
  }, "Array, number": function(t5, n3) {
    return o2(t5, n3, arraySize$2(t5), null);
  }, "Array, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), arraySize$2(t5), null);
  }, "Array, string": function(t5, n3) {
    return o2(t5, 0, arraySize$2(t5), n3);
  }, "Array, number, string": function(t5, n3, r3) {
    return o2(t5, n3, arraySize$2(t5), r3);
  }, "Array, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), arraySize$2(t5), r3);
  }, Matrix: function(t5) {
    return o2(t5, 0, t5.size(), t5.storage());
  }, "Matrix, number": function(t5, n3) {
    return o2(t5, n3, t5.size(), t5.storage());
  }, "Matrix, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), t5.size(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return o2(t5, 0, t5.size(), n3);
  }, "Matrix, number, string": function(t5, n3, r3) {
    return o2(t5, n3, t5.size(), r3);
  }, "Matrix, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), t5.size(), r3);
  } });
  function o2(t5, n3, r3, i3) {
    if (!isInteger$3(n3)) throw TypeError(`Second parameter in function diag must be an integer`);
    var a3 = n3 > 0 ? n3 : 0, o3 = n3 < 0 ? -n3 : 0;
    switch (r3.length) {
      case 1:
        return s2(t5, n3, i3, r3[0], o3, a3);
      case 2:
        return c2(t5, n3, i3, r3, o3, a3);
    }
    throw RangeError(`Matrix for function diag must be 2 dimensional`);
  }
  function s2(t5, n3, r3, o3, s3, c3) {
    var l2 = [o3 + s3, o3 + c3];
    if (r3 && r3 !== `sparse` && r3 !== `dense`) throw TypeError(`Unknown matrix type ${r3}"`);
    var u2 = r3 === `sparse` ? a2.diagonal(l2, t5, n3) : i2.diagonal(l2, t5, n3);
    return r3 === null ? u2.valueOf() : u2;
  }
  function c2(t5, n3, i3, a3, o3, s3) {
    if (isMatrix$2(t5)) {
      var c3 = t5.diagonal(n3);
      return i3 === null ? c3.valueOf() : i3 === c3.storage() ? c3 : r2(c3, i3);
    }
    for (var l2 = Math.min(a3[0] - o3, a3[1] - s3), u2 = [], d2 = 0; d2 < l2; d2++) u2[d2] = t5[d2 + o3][d2 + s3];
    return i3 === null ? u2 : r2(u2);
  }
}), name$230$2 = `filter`, dependencies$230$2 = [`typed`], createFilter$2 = factory$2(name$230$2, dependencies$230$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`filter`, { "Array, function": _filterCallback$2, "Matrix, function": function(t5, n3) {
    return t5.create(_filterCallback$2(t5.valueOf(), n3), t5.datatype());
  }, "Array, RegExp": filterRegExp$2, "Matrix, RegExp": function(t5, n3) {
    return t5.create(filterRegExp$2(t5.valueOf(), n3), t5.datatype());
  } });
});
function _filterCallback$2(t4, n2) {
  var r2 = optimizeCallback$2(n2, t4, `filter`);
  return r2.isUnary ? filter$1$2(t4, r2.fn) : filter$1$2(t4, function(t5, n3, i2) {
    return r2.fn(t5, [n3], i2);
  });
}
var name$229$2 = `flatten`, dependencies$229$2 = [`typed`], createFlatten$2 = factory$2(name$229$2, dependencies$229$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$229$2, { Array: function(t5) {
    return flatten$4$2(t5);
  }, DenseMatrix: function(t5) {
    return t5.create(flatten$4$2(t5.valueOf(), true), t5.datatype());
  }, SparseMatrix: function(t5) {
    throw TypeError(`SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())`);
  } });
}), name$228$2 = `forEach`, dependencies$228$2 = [`typed`], createForEach$2 = factory$2(name$228$2, dependencies$228$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$228$2, { "Array, function": _forEach$2, "Matrix, function": function(t5, n3) {
    t5.forEach(n3);
  } });
});
function _forEach$2(t4, n2) {
  var r2 = optimizeCallback$2(n2, t4, name$228$2);
  deepForEach$1$2(t4, r2.fn, r2.isUnary);
}
var name$227$2 = `getMatrixDataType`, dependencies$227$2 = [`typed`], createGetMatrixDataType$2 = factory$2(name$227$2, dependencies$227$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$227$2, { Array: function(t5) {
    return getArrayDataType$2(t5, typeOf$2);
  }, Matrix: function(t5) {
    return t5.getDataType();
  } });
}), name$226$2 = `identity`, dependencies$226$2 = [`typed`, `config`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`], createIdentity$2 = factory$2(name$226$2, dependencies$226$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2, DenseMatrix: o2, SparseMatrix: s2 } = t4;
  return n2(name$226$2, { "": function() {
    return r2.matrix === `Matrix` ? i2([]) : [];
  }, string: function(t5) {
    return i2(t5);
  }, "number | BigNumber": function(t5) {
    return l2(t5, t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, string": function(t5, n3) {
    return l2(t5, t5, n3);
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return l2(t5, n3, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(t5, n3, r3) {
    return l2(t5, n3, r3);
  }, Array: function(t5) {
    return c2(t5);
  }, "Array, string": function(t5, n3) {
    return c2(t5, n3);
  }, Matrix: function(t5) {
    return c2(t5.valueOf(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return c2(t5.valueOf(), n3);
  } });
  function c2(t5, n3) {
    switch (t5.length) {
      case 0:
        return n3 ? i2(n3) : [];
      case 1:
        return l2(t5[0], t5[0], n3);
      case 2:
        return l2(t5[0], t5[1], n3);
      default:
        throw Error(`Vector containing two values expected`);
    }
  }
  function l2(t5, n3, r3) {
    var i3 = isBigNumber$2(t5) || isBigNumber$2(n3) ? a2 : null;
    if (isBigNumber$2(t5) && (t5 = t5.toNumber()), isBigNumber$2(n3) && (n3 = n3.toNumber()), !isInteger$3(t5) || t5 < 1 || !isInteger$3(n3) || n3 < 1) throw Error(`Parameters in function identity must be positive integers`);
    var c3 = i3 ? new a2(1) : 1, l3 = i3 ? new i3(0) : 0, u2 = [t5, n3];
    if (r3) {
      if (r3 === `sparse`) return s2.diagonal(u2, c3, 0, l3);
      if (r3 === `dense`) return o2.diagonal(u2, c3, 0, l3);
      throw TypeError(`Unknown matrix type "${r3}"`);
    }
    for (var d2 = resize$2([], u2, l3), p2 = t5 < n3 ? t5 : n3, m2 = 0; m2 < p2; m2++) d2[m2][m2] = c3;
    return d2;
  }
}), name$225$2 = `kron`, dependencies$225$2 = [`typed`, `matrix`, `multiplyScalar`], createKron$2 = factory$2(name$225$2, dependencies$225$2, (t4) => {
  var { typed: n2, matrix: r2, multiplyScalar: i2 } = t4;
  return n2(name$225$2, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function a2(t5, n3) {
    return t5.flatMap((t6) => n3.map((n4) => i2(t6, n4)));
  }
  function o2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (r3 < 0) {
      var i3 = arraySize$2(t5).length, s2 = arraySize$2(n3).length;
      for (r3 = Math.max(i3, s2); i3++ < r3; ) t5 = [t5];
      for (; s2++ < r3; ) n3 = [n3];
    }
    return r3 === 1 ? a2(t5, n3) : t5.flatMap((t6) => n3.map((n4) => o2(t6, n4, r3 - 1)));
  }
}), name$224$2 = `map`, dependencies$224$2 = [`typed`], createMap$3 = factory$2(name$224$2, dependencies$224$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$224$2, { "Array, function": c2, "Matrix, function": function(t5, n3) {
    return t5.map(n3);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (t5, n3, i3) => r2([t5, n3, ...i3.slice(0, i3.length - 1)], i3[i3.length - 1]) });
  function r2(t5, r3) {
    if (typeof r3 != `function`) throw Error(`Last argument must be a callback function`);
    var l2 = t5[0].isMatrix, u2 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize$2(t6)), d2 = broadcastSizes$2(...u2), p2 = t5.length, m2 = l2 ? (t6, n3) => t6.get(n3) : get$1$2, h2 = t5.map((t6, n3) => {
      var r4 = u2[n3].map(() => 0);
      return t6.isMatrix ? t6.get(r4) : get$1$2(t6, r4);
    }), g2 = n2.isTypedFunction(r3) ? s2(r3, h2, d2.map(() => 0), t5) : o2(r3, p2);
    if (g2 < 2) return i2(t5, a2(g2, r3, null));
    var v2 = l2 ? t5.map((n3) => n3.isMatrix ? n3.create(broadcastTo$2(n3.toArray(), d2), n3.datatype()) : t5[0].create(broadcastTo$2(n3.valueOf(), d2))) : t5.map((t6) => t6.isMatrix ? broadcastTo$2(t6.toArray(), d2) : broadcastTo$2(t6, d2)), y2 = a2(g2, r3, v2), b2 = (t6, n3) => y2([t6, ...v2.slice(1).map((t7) => m2(t7, n3))], n3);
    return l2 ? v2[0].map(b2) : c2(v2[0], b2);
  }
  function i2(t5, n3) {
    var r3 = t5[0], i3 = t5.map((t6) => t6.isMatrix ? t6.valueOf() : t6), a3 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize$2(t6)), o3 = broadcastSizes$2(...a3), s3 = a3.map((t6) => o3.length - t6.length), c3 = o3.length - 1, l2 = n3.length > 1 ? [] : null, u2 = p2(i3, 0);
    if (r3.isMatrix) {
      var d2 = r3.create();
      return d2._data = u2, d2._size = o3, d2;
    } else return u2;
    function p2(t6) {
      var r4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i4 = o3[r4], a4 = Array(i4);
      if (r4 < c3) for (var u3 = function(n4) {
        l2 && (l2[r4] = n4), a4[n4] = p2(t6.map((t7, i5) => s3[i5] > r4 ? t7 : t7.length === 1 ? t7[0] : t7[n4]), r4 + 1);
      }, d3 = 0; d3 < i4; d3++) u3(d3);
      else for (var m2 = function(i5) {
        l2 && (l2[r4] = i5), a4[i5] = n3(t6.map((t7) => t7.length === 1 ? t7[0] : t7[i5]), l2 ? l2.slice() : void 0);
      }, h2 = 0; h2 < i4; h2++) m2(h2);
      return a4;
    }
  }
  function a2(t5, n3, r3) {
    switch (t5) {
      case 0:
        return (t6) => n3(...t6);
      case 1:
        return (t6, r4) => n3(...t6, r4);
      case 2:
        return (t6, i3) => n3(...t6, i3, ...r3);
    }
  }
  function o2(t5, n3) {
    var r3 = t5.toString();
    if (/arguments/.test(r3)) return 2;
    var i3 = r3.match(/\(.*?\)/);
    return /\.\.\./.test(i3) || t5.length > n3 + 1 ? 2 : +(t5.length === n3 + 1);
  }
  function s2(t5, r3, i3, a3) {
    return n2.resolve(t5, [...r3, i3, ...a3]) === null ? n2.resolve(t5, [...r3, i3]) === null ? (n2.resolve(t5, r3), 0) : 1 : 2;
  }
  function c2(t5, n3) {
    var r3 = optimizeCallback$2(n3, t5, name$224$2);
    return deepMap$1$2(t5, r3.fn, r3.isUnary);
  }
}), name$223$2 = `diff`, dependencies$223$2 = [`typed`, `matrix`, `subtract`, `number`], createDiff$2 = factory$2(name$223$2, dependencies$223$2, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2 } = t4;
  return n2(name$223$2, { "Array | Matrix": function(t5) {
    return isMatrix$2(t5) ? r2(s2(t5.toArray())) : s2(t5);
  }, "Array | Matrix, number": function(t5, n3) {
    if (!isInteger$3(n3)) throw RangeError(`Dimension must be a whole number`);
    return isMatrix$2(t5) ? r2(o2(t5.toArray(), n3)) : o2(t5, n3);
  }, "Array, BigNumber": n2.referTo(`Array,number`, (t5) => (n3, r3) => t5(n3, a2(r3))), "Matrix, BigNumber": n2.referTo(`Matrix,number`, (t5) => (n3, r3) => t5(n3, a2(r3))) });
  function o2(t5, n3) {
    if (isMatrix$2(t5) && (t5 = t5.toArray()), !Array.isArray(t5)) throw RangeError(`Array/Matrix does not have that many dimensions`);
    if (n3 > 0) {
      var r3 = [];
      return t5.forEach((t6) => {
        r3.push(o2(t6, n3 - 1));
      }), r3;
    } else if (n3 === 0) return s2(t5);
    else throw RangeError(`Cannot have negative dimension`);
  }
  function s2(t5) {
    for (var n3 = [], r3 = t5.length, i3 = 1; i3 < r3; i3++) n3.push(c2(t5[i3 - 1], t5[i3]));
    return n3;
  }
  function c2(t5, n3) {
    isMatrix$2(t5) && (t5 = t5.toArray()), isMatrix$2(n3) && (n3 = n3.toArray());
    var r3 = Array.isArray(t5), a3 = Array.isArray(n3);
    if (r3 && a3) return l2(t5, n3);
    if (!r3 && !a3) return i2(n3, t5);
    throw TypeError(`Cannot calculate difference between 1 array and 1 non-array`);
  }
  function l2(t5, n3) {
    if (t5.length !== n3.length) throw RangeError(`Not all sub-arrays have the same length`);
    for (var r3 = [], i3 = t5.length, a3 = 0; a3 < i3; a3++) r3.push(c2(t5[a3], n3[a3]));
    return r3;
  }
}), name$222$2 = `ones`, dependencies$222$2 = [`typed`, `config`, `matrix`, `BigNumber`], createOnes$2 = factory$2(name$222$2, dependencies$222$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(`ones`, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(1) : 1;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize$2(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber$2(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger$3(t6) || t6 < 0) throw Error(`Parameters in function ones must be positive integers`);
    });
  }
});
function noBignumber$2() {
  throw Error(`No "bignumber" implementation available`);
}
function noFraction$2() {
  throw Error(`No "fraction" implementation available`);
}
function noMatrix$2() {
  throw Error(`No "matrix" implementation available`);
}
var name$221$2 = `range`, dependencies$221$2 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRange$2 = factory$2(name$221$2, dependencies$221$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, smaller: o2, smallerEq: s2, larger: c2, largerEq: l2, add: u2, isZero: d2, isPositive: p2 } = t4;
  return n2(name$221$2, { string: h2, "string, boolean": h2, number: function(t5) {
    throw TypeError(`Too few arguments to function range(): ${t5}`);
  }, boolean: function(t5) {
    throw TypeError(`Unexpected type of argument 1 to function range(): ${t5}, number|bigint|BigNumber|Fraction`);
  }, "number, number": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "number, number, number": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "number, number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "number, number, number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "bigint, bigint|number": function(t5, n3) {
    return m2(g2(t5, n3, 1n, false));
  }, "number, bigint": function(t5, n3) {
    return m2(g2(BigInt(t5), n3, 1n, false));
  }, "bigint, bigint|number, bigint|number": function(t5, n3, r3) {
    return m2(g2(t5, n3, BigInt(r3), false));
  }, "number, bigint, bigint|number": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), false));
  }, "bigint, bigint|number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1n, r3));
  }, "number, bigint, boolean": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, 1n, r3));
  }, "bigint, bigint|number, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, BigInt(r3), i3));
  }, "number, bigint, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), i3));
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = t5.constructor;
    return m2(g2(t5, n3, new r3(1), false));
  }, "BigNumber, BigNumber, BigNumber": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "BigNumber, BigNumber, boolean": function(t5, n3, r3) {
    var i3 = t5.constructor;
    return m2(g2(t5, n3, new i3(1), r3));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Fraction, Fraction": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "Fraction, Fraction, Fraction": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Fraction, Fraction, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "Fraction, Fraction, Fraction, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Unit, Unit, Unit": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Unit, Unit, Unit, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  } });
  function m2(t5) {
    return r2.matrix === `Matrix` ? i2 ? i2(t5) : noMatrix$2() : t5;
  }
  function h2(t5, n3) {
    var i3 = v2(t5);
    if (!i3) throw SyntaxError(`String "` + t5 + `" is no valid range`);
    return r2.number === `BigNumber` ? (a2 === void 0 && noBignumber$2(), m2(g2(a2(i3.start), a2(i3.end), a2(i3.step)))) : m2(g2(i3.start, i3.end, i3.step, n3));
  }
  function g2(t5, n3, r3, i3) {
    var a3 = [];
    if (d2(r3)) throw Error(`Step must be non-zero`);
    for (var m3 = p2(r3) ? i3 ? s2 : o2 : i3 ? l2 : c2, h3 = t5; m3(h3, n3); ) a3.push(h3), h3 = u2(h3, r3);
    return a3;
  }
  function v2(t5) {
    var n3 = t5.split(`:`).map(function(t6) {
      return Number(t6);
    });
    if (n3.some(function(t6) {
      return isNaN(t6);
    })) return null;
    switch (n3.length) {
      case 2:
        return { start: n3[0], end: n3[1], step: 1 };
      case 3:
        return { start: n3[0], end: n3[2], step: n3[1] };
      default:
        return null;
    }
  }
}), name$220$2 = `reshape`, dependencies$220$2 = [`typed`, `isInteger`, `matrix`], createReshape$2 = factory$2(name$220$2, dependencies$220$2, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$220$2, { "Matrix, Array": function(t5, n3) {
    return t5.reshape(n3, true);
  }, "Array, Array": function(t5, n3) {
    return n3.forEach(function(t6) {
      if (!r2(t6)) throw TypeError(`Invalid size for dimension: ` + t6);
    }), reshape$2(t5, n3);
  } });
}), name$219$2 = `resize`, dependencies$219$2 = [`config`, `matrix`], createResize$2 = factory$2(name$219$2, dependencies$219$2, (t4) => {
  var { config: n2, matrix: r2 } = t4;
  return function(t5, a2, o2) {
    if (arguments.length !== 2 && arguments.length !== 3) throw new ArgumentsError$2(`resize`, arguments.length, 2, 3);
    if (isMatrix$2(a2) && (a2 = a2.valueOf()), isBigNumber$2(a2[0]) && (a2 = a2.map(function(t6) {
      return isBigNumber$2(t6) ? t6.toNumber() : t6;
    })), isMatrix$2(t5)) return t5.resize(a2, o2, true);
    if (typeof t5 == `string`) return i2(t5, a2, o2);
    var s2 = Array.isArray(t5) ? false : n2.matrix !== `Array`;
    if (a2.length === 0) {
      for (; Array.isArray(t5); ) t5 = t5[0];
      return clone$3$2(t5);
    } else {
      Array.isArray(t5) || (t5 = [t5]), t5 = clone$3$2(t5);
      var c2 = resize$2(t5, a2, o2);
      return s2 ? r2(c2) : c2;
    }
  };
  function i2(t5, n3, r3) {
    if (r3 !== void 0) {
      if (typeof r3 != `string` || r3.length !== 1) throw TypeError(`Single character expected as defaultValue`);
    } else r3 = ` `;
    if (n3.length !== 1) throw new DimensionError$2(n3.length, 1);
    var i3 = n3[0];
    if (typeof i3 != `number` || !isInteger$3(i3)) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$4(n3) + `)`);
    if (t5.length > i3) return t5.substring(0, i3);
    if (t5.length < i3) {
      for (var a2 = t5, o2 = 0, s2 = i3 - t5.length; o2 < s2; o2++) a2 += r3;
      return a2;
    } else return t5;
  }
}), name$218$2 = `rotate`, dependencies$218$2 = [`typed`, `multiply`, `rotationMatrix`], createRotate$2 = factory$2(name$218$2, dependencies$218$2, (t4) => {
  var { typed: n2, multiply: r2, rotationMatrix: i2 } = t4;
  return n2(name$218$2, { "Array , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  } });
  function a2(t5, n3) {
    var r3 = Array.isArray(t5) ? arraySize$2(t5) : t5.size();
    if (r3.length > 2 || r3.length === 2 && r3[1] !== 1 || r3[0] !== n3) throw RangeError(`Vector must be of dimensions 1x${n3}`);
  }
}), name$217$2 = `rotationMatrix`, dependencies$217$2 = [`typed`, `config`, `multiplyScalar`, `addScalar`, `unaryMinus`, `norm`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`, `cos`, `sin`], createRotationMatrix$2 = factory$2(name$217$2, dependencies$217$2, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, addScalar: a2, unaryMinus: o2, norm: s2, BigNumber: c2, matrix: l2, DenseMatrix: u2, SparseMatrix: d2, cos: p2, sin: m2 } = t4;
  return n2(name$217$2, { "": function() {
    return r2.matrix === `Matrix` ? l2([]) : [];
  }, string: function(t5) {
    return l2(t5);
  }, "number | BigNumber | Complex | Unit": function(t5) {
    return h2(t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(t5, n3) {
    return h2(t5, n3);
  }, "number | BigNumber | Complex | Unit, Array": function(t5, n3) {
    var r3 = l2(n3);
    return g2(r3), b2(t5, r3, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(t5, n3) {
    return g2(n3), b2(t5, n3, n3.storage() || (r2.matrix === `Matrix` ? `dense` : void 0));
  }, "number | BigNumber | Complex | Unit, Array, string": function(t5, n3, r3) {
    var i3 = l2(n3);
    return g2(i3), b2(t5, i3, r3);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(t5, n3, r3) {
    return g2(n3), b2(t5, n3, r3);
  } });
  function h2(t5, n3) {
    var r3 = isBigNumber$2(t5) ? new c2(-1) : -1, a3 = p2(t5), o3 = m2(t5);
    return y2([[a3, i2(r3, o3)], [o3, a3]], n3);
  }
  function g2(t5) {
    var n3 = t5.size();
    if (n3.length < 1 || n3[0] !== 3) throw RangeError(`Vector must be of dimensions 1x3`);
  }
  function v2(t5) {
    return t5.reduce((t6, n3) => i2(t6, n3));
  }
  function y2(t5, n3) {
    if (n3) {
      if (n3 === `sparse`) return new d2(t5);
      if (n3 === `dense`) return new u2(t5);
      throw TypeError(`Unknown matrix type "${n3}"`);
    }
    return t5;
  }
  function b2(t5, n3, r3) {
    var i3 = s2(n3);
    if (i3 === 0) throw RangeError(`Rotation around zero vector`);
    var l3 = isBigNumber$2(t5) ? c2 : null, u3 = l3 ? new l3(1) : 1, d3 = l3 ? new l3(-1) : -1, h3 = l3 ? new l3(n3.get([0]) / i3) : n3.get([0]) / i3, g3 = l3 ? new l3(n3.get([1]) / i3) : n3.get([1]) / i3, b3 = l3 ? new l3(n3.get([2]) / i3) : n3.get([2]) / i3, x2 = p2(t5), S2 = a2(u3, o2(x2)), w2 = m2(t5), E = a2(x2, v2([h3, h3, S2])), D = a2(v2([h3, g3, S2]), v2([d3, b3, w2])), O2 = a2(v2([h3, b3, S2]), v2([g3, w2])), j2 = a2(v2([h3, g3, S2]), v2([b3, w2])), M2 = a2(x2, v2([g3, g3, S2])), N2 = a2(v2([g3, b3, S2]), v2([d3, h3, w2])), F = a2(v2([h3, b3, S2]), v2([d3, g3, w2])), I2 = a2(v2([g3, b3, S2]), v2([h3, w2])), L2 = a2(x2, v2([b3, b3, S2]));
    return y2([[E, D, O2], [j2, M2, N2], [F, I2, L2]], r3);
  }
}), name$216$2 = `row`, dependencies$216$2 = [`typed`, `Index`, `matrix`, `range`], createRow$2 = factory$2(name$216$2, dependencies$216$2, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$216$2, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3$2(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex$2(n3, t5.size()[0]);
    var o3 = a2(0, t5.size()[1]), s2 = new r2([n3], o3), c2 = t5.subset(s2);
    return isMatrix$2(c2) ? c2 : i2([[c2]]);
  }
}), name$215$2 = `size`, dependencies$215$2 = [`typed`], createSize$2 = factory$2(name$215$2, dependencies$215$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$215$2, { Matrix: (t5) => t5.size(), Array: arraySize$2, string: (t5) => [t5.length], "number | Complex | BigNumber | Unit | boolean | null": (t5) => [] });
}), name$214$2 = `squeeze`, dependencies$214$2 = [`typed`], createSqueeze$2 = factory$2(name$214$2, dependencies$214$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$214$2, { Array: function(t5) {
    return squeeze$2(clone$3$2(t5));
  }, Matrix: function(t5) {
    var n3 = squeeze$2(t5.toArray());
    return Array.isArray(n3) ? t5.create(n3, t5.datatype()) : n3;
  }, any: function(t5) {
    return clone$3$2(t5);
  } });
}), name$213$2 = `subset`, dependencies$213$2 = [`typed`, `matrix`, `zeros`, `add`], createSubset$2 = factory$2(name$213$2, dependencies$213$2, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4;
  return n2(name$213$2, { "Matrix, Index": function(t5, n3) {
    return isEmptyIndex$2(n3) ? r2() : (validateIndexSourceSize$2(t5, n3), t5.subset(n3));
  }, "Array, Index": n2.referTo(`Matrix, Index`, function(t5) {
    return function(n3, i3) {
      var a3 = t5(r2(n3), i3);
      return i3.isScalar() ? a3 : a3.valueOf();
    };
  }), "Object, Index": _getObjectProperty$2, "string, Index": _getSubstring$2, "Matrix, Index, any, any": function(t5, n3, r3, i3) {
    return isEmptyIndex$2(n3) ? t5 : (validateIndexSourceSize$2(t5, n3), t5.clone().subset(n3, o2(r3, n3), i3));
  }, "Array, Index, any, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3, o3) {
      var s2 = t5(r2(n3), i3, a3, o3);
      return s2.isMatrix ? s2.valueOf() : s2;
    };
  }), "Array, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3) {
      return t5(r2(n3), i3, a3, void 0).valueOf();
    };
  }), "Matrix, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, r3, i3) {
      return t5(n3, r3, i3, void 0);
    };
  }), "string, Index, string": _setSubstring$2, "string, Index, string, string": _setSubstring$2, "Object, Index, any": _setObjectProperty$2 });
  function o2(t5, n3) {
    if (typeof t5 == `string`) throw Error(`can't boradcast a string`);
    if (n3.isScalar()) return t5;
    var r3 = n3.size();
    if (r3.every((t6) => t6 > 0)) try {
      return a2(t5, i2(r3));
    } catch {
      return t5;
    }
    else return t5;
  }
});
function _getSubstring$2(t4, n2) {
  if (!isIndex$2(n2)) throw TypeError(`Index expected`);
  if (isEmptyIndex$2(n2)) return ``;
  if (validateIndexSourceSize$2(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError$2(n2.size().length, 1);
  var r2 = t4.length;
  validateIndex$2(n2.min()[0], r2), validateIndex$2(n2.max()[0], r2);
  var i2 = n2.dimension(0), a2 = ``;
  function o2(n3) {
    a2 += t4.charAt(n3);
  }
  return Number.isInteger(i2) ? o2(i2) : i2.forEach(o2), a2;
}
function _setSubstring$2(t4, n2, r2, i2) {
  if (!n2 || n2.isIndex !== true) throw TypeError(`Index expected`);
  if (isEmptyIndex$2(n2)) return t4;
  if (validateIndexSourceSize$2(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError$2(n2.size().length, 1);
  if (i2 !== void 0) {
    if (typeof i2 != `string` || i2.length !== 1) throw TypeError(`Single character expected as defaultValue`);
  } else i2 = ` `;
  var a2 = n2.dimension(0);
  if ((Number.isInteger(a2) ? 1 : a2.size()[0]) !== r2.length) throw new DimensionError$2(a2.size()[0], r2.length);
  var o2 = t4.length;
  validateIndex$2(n2.min()[0]), validateIndex$2(n2.max()[0]);
  for (var s2 = [], c2 = 0; c2 < o2; c2++) s2[c2] = t4.charAt(c2);
  function l2(t5, n3) {
    s2[t5] = r2.charAt(n3[0]);
  }
  if (Number.isInteger(a2) ? l2(a2, [0]) : a2.forEach(l2), s2.length > o2) for (var u2 = o2 - 1, d2 = s2.length; u2 < d2; u2++) s2[u2] || (s2[u2] = i2);
  return s2.join(``);
}
function _getObjectProperty$2(t4, n2) {
  if (!isEmptyIndex$2(n2)) {
    if (n2.size().length !== 1) throw new DimensionError$2(n2.size(), 1);
    var r2 = n2.dimension(0);
    if (typeof r2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
    return getSafeProperty$2(t4, r2);
  }
}
function _setObjectProperty$2(t4, n2, r2) {
  if (isEmptyIndex$2(n2)) return t4;
  if (n2.size().length !== 1) throw new DimensionError$2(n2.size(), 1);
  var i2 = n2.dimension(0);
  if (typeof i2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
  var a2 = clone$3$2(t4);
  return setSafeProperty$2(a2, i2, r2), a2;
}
var name$212$2 = `transpose`, dependencies$212$2 = [`typed`, `matrix`], createTranspose$2 = factory$2(name$212$2, dependencies$212$2, (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return n2(name$212$2, { Array: (t5) => i2(r2(t5)).valueOf(), Matrix: i2, any: clone$3$2 });
  function i2(t5) {
    var n3 = t5.size(), r3;
    switch (n3.length) {
      case 1:
        r3 = t5.clone();
        break;
      case 2:
        var i3 = n3[0], s2 = n3[1];
        if (s2 === 0) throw RangeError(`Cannot transpose a 2D matrix with no columns (size: ` + format$4(n3) + `)`);
        switch (t5.storage()) {
          case `dense`:
            r3 = a2(t5, i3, s2);
            break;
          case `sparse`:
            r3 = o2(t5, i3, s2);
            break;
        }
        break;
      default:
        throw RangeError(`Matrix must be a vector or two dimensional (size: ` + format$4(n3) + `)`);
    }
    return r3;
  }
  function a2(t5, n3, r3) {
    for (var i3 = t5._data, a3 = [], o3, s2 = 0; s2 < r3; s2++) {
      o3 = a3[s2] = [];
      for (var c2 = 0; c2 < n3; c2++) o3[c2] = clone$3$2(i3[c2][s2]);
    }
    return t5.createDenseMatrix({ data: a3, size: [r3, n3], datatype: t5._datatype });
  }
  function o2(t5, n3, r3) {
    for (var i3 = t5._values, a3 = t5._index, o3 = t5._ptr, s2 = i3 ? [] : void 0, c2 = [], l2 = [], u2 = [], d2 = 0; d2 < n3; d2++) u2[d2] = 0;
    var p2, m2, h2;
    for (p2 = 0, m2 = a3.length; p2 < m2; p2++) u2[a3[p2]]++;
    for (var g2 = 0, v2 = 0; v2 < n3; v2++) l2.push(g2), g2 += u2[v2], u2[v2] = l2[v2];
    for (l2.push(g2), h2 = 0; h2 < r3; h2++) for (var y2 = o3[h2], b2 = o3[h2 + 1], x2 = y2; x2 < b2; x2++) {
      var S2 = u2[a3[x2]]++;
      c2[S2] = h2, i3 && (s2[S2] = clone$3$2(i3[x2]));
    }
    return t5.createSparseMatrix({ values: s2, index: c2, ptr: l2, size: [r3, n3], datatype: t5._datatype });
  }
}), name$211$2 = `ctranspose`, dependencies$211$2 = [`typed`, `transpose`, `conj`], createCtranspose$2 = factory$2(name$211$2, dependencies$211$2, (t4) => {
  var { typed: n2, transpose: r2, conj: i2 } = t4;
  return n2(name$211$2, { any: function(t5) {
    return i2(r2(t5));
  } });
}), name$210$2 = `zeros`, dependencies$210$2 = [`typed`, `config`, `matrix`, `BigNumber`], createZeros$2 = factory$2(name$210$2, dependencies$210$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$210$2, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(0) : 0;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize$2(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber$2(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger$3(t6) || t6 < 0) throw Error(`Parameters in function zeros must be positive integers`);
    });
  }
}), name$209$2 = `fft`, dependencies$209$2 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `divideScalar`, `exp`, `tau`, `i`, `dotDivide`, `conj`, `pow`, `ceil`, `log2`], createFft$2 = factory$2(name$209$2, dependencies$209$2, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, divideScalar: o2, exp: s2, tau: c2, i: l2, dotDivide: u2, conj: d2, pow: p2, ceil: m2, log2: h2 } = t4;
  return n2(name$209$2, { Array: g2, Matrix: function(t5) {
    return t5.create(g2(t5.valueOf()), t5.datatype());
  } });
  function g2(t5) {
    var n3 = arraySize$2(t5);
    return n3.length === 1 ? b2(t5, n3[0]) : v2(t5.map((t6) => g2(t6, n3.slice(1))), 0);
  }
  function v2(t5, n3) {
    var r3 = arraySize$2(t5);
    if (n3 !== 0) return Array(r3[0]).fill(0).map((r4, i4) => v2(t5[i4], n3 - 1));
    if (r3.length === 1) return b2(t5);
    function i3(t6) {
      var n4 = arraySize$2(t6);
      return Array(n4[1]).fill(0).map((r4, i4) => Array(n4[0]).fill(0).map((n5, r5) => t6[r5][i4]));
    }
    return i3(v2(i3(t5), 1));
  }
  function y2(t5) {
    for (var n3 = t5.length, r3 = s2(o2(a2(-1, a2(l2, c2)), n3)), i3 = [], v3 = 1 - n3; v3 < n3; v3++) i3.push(p2(r3, o2(p2(v3, 2), 2)));
    for (var y3 = p2(2, m2(h2(n3 + n3 - 1))), x2 = [...Array(n3).fill(0).map((r4, o3) => a2(t5[o3], i3[n3 - 1 + o3])), ...Array(y3 - n3).fill(0)], S2 = [...Array(n3 + n3 - 1).fill(0).map((t6, n4) => o2(1, i3[n4])), ...Array(y3 - (n3 + n3 - 1)).fill(0)], w2 = b2(x2), E = b2(S2), D = u2(d2(g2(d2(Array(y3).fill(0).map((t6, n4) => a2(w2[n4], E[n4]))))), y3), O2 = [], j2 = n3 - 1; j2 < n3 + n3 - 1; j2++) O2.push(a2(D[j2], i3[j2]));
    return O2;
  }
  function b2(t5) {
    var n3 = t5.length;
    if (n3 === 1) return [t5[0]];
    if (n3 % 2 == 0) {
      for (var r3 = [...b2(t5.filter((t6, n4) => n4 % 2 == 0)), ...b2(t5.filter((t6, n4) => n4 % 2 == 1))], u3 = 0; u3 < n3 / 2; u3++) {
        var d3 = r3[u3], p3 = a2(r3[u3 + n3 / 2], s2(a2(a2(c2, l2), o2(-u3, n3))));
        r3[u3] = i2(d3, p3), r3[u3 + n3 / 2] = i2(d3, a2(-1, p3));
      }
      return r3;
    } else return y2(t5);
  }
}), name$208$2 = `ifft`, dependencies$208$2 = [`typed`, `fft`, `dotDivide`, `conj`], createIfft$2 = factory$2(name$208$2, dependencies$208$2, (t4) => {
  var { typed: n2, fft: r2, dotDivide: i2, conj: a2 } = t4;
  return n2(name$208$2, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$2(t5) ? t5.size() : arraySize$2(t5);
    return i2(a2(r2(a2(t5))), n3.reduce((t6, n4) => t6 * n4, 1));
  } });
});
function _typeof$2(t4) {
  "@babel/helpers - typeof";
  return _typeof$2 = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(t5) {
    return typeof t5;
  } : function(t5) {
    return t5 && typeof Symbol == `function` && t5.constructor === Symbol && t5 !== Symbol.prototype ? `symbol` : typeof t5;
  }, _typeof$2(t4);
}
function toPrimitive$2(t4, n2) {
  if (_typeof$2(t4) != `object` || !t4) return t4;
  var r2 = t4[Symbol.toPrimitive];
  if (r2 !== void 0) {
    var i2 = r2.call(t4, n2);
    if (_typeof$2(i2) != `object`) return i2;
    throw TypeError(`@@toPrimitive must return a primitive value.`);
  }
  return (n2 === `string` ? String : Number)(t4);
}
function toPropertyKey$2(t4) {
  var n2 = toPrimitive$2(t4, `string`);
  return _typeof$2(n2) == `symbol` ? n2 : n2 + ``;
}
function _defineProperty$4(t4, n2, r2) {
  return (n2 = toPropertyKey$2(n2)) in t4 ? Object.defineProperty(t4, n2, { value: r2, enumerable: true, configurable: true, writable: true }) : t4[n2] = r2, t4;
}
function ownKeys$3$2(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$3$2(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$3$2(Object(r2), true).forEach(function(n3) {
      _defineProperty$4(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$3$2(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$207$2 = `solveODE`, dependencies$207$2 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `max`, `map`, `abs`, `isPositive`, `isNegative`, `larger`, `smaller`, `matrix`, `bignumber`, `unaryMinus`], createSolveODE$2 = factory$2(name$207$2, dependencies$207$2, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, max: s2, map: c2, abs: l2, isPositive: u2, isNegative: d2, larger: p2, smaller: m2, matrix: h2, bignumber: g2, unaryMinus: v2 } = t4;
  function y2(t5) {
    return function(n3, h3, y3, b3) {
      if (!(h3.length === 2 && (h3.every(D) || h3.every(isUnit$2)))) throw Error(`"tspan" must be an Array of two numeric values or two units [tStart, tEnd]`);
      var x3 = h3[0], S3 = h3[1], O3 = p2(S3, x3), j2 = b3.firstStep;
      if (j2 !== void 0 && !u2(j2)) throw Error(`"firstStep" must be positive`);
      var M2 = b3.maxStep;
      if (M2 !== void 0 && !u2(M2)) throw Error(`"maxStep" must be positive`);
      var N2 = b3.minStep;
      if (N2 && d2(N2)) throw Error(`"minStep" must be positive or zero`);
      var F = [x3, S3, j2, N2, M2].filter((t6) => t6 !== void 0);
      if (!(F.every(D) || F.every(isUnit$2))) throw Error(`Inconsistent type of "t" dependant variables`);
      for (var I2 = 1, L2 = b3.tol ? b3.tol : 1e-4, R2 = b3.minDelta ? b3.minDelta : 0.2, z2 = b3.maxDelta ? b3.maxDelta : 5, V2 = b3.maxIter ? b3.maxIter : 1e4, H2 = [x3, S3, ...y3, M2, N2].some(isBigNumber$2), [U2, W2, G2, K2] = H2 ? [g2(t5.a), g2(t5.c), g2(t5.b), g2(t5.bp)] : [t5.a, t5.c, t5.b, t5.bp], q2 = j2 ? O3 ? j2 : v2(j2) : o2(i2(S3, x3), I2), J = [x3], ee2 = [y3], Y2 = i2(G2, K2), te2 = 0, ne2 = 0, X2 = w2(O3), ie2 = E(O3); X2(J[te2], S3); ) {
        var ae2 = [];
        q2 = ie2(J[te2], S3, q2), ae2.push(n3(J[te2], ee2[te2]));
        for (var Z2 = 1; Z2 < W2.length; ++Z2) ae2.push(n3(r2(J[te2], a2(W2[Z2], q2)), r2(ee2[te2], a2(q2, U2[Z2], ae2))));
        var oe2 = s2(l2(c2(a2(Y2, ae2), (t6) => isUnit$2(t6) ? t6.value : t6)));
        oe2 < L2 && L2 / oe2 > 1 / 4 && (J.push(r2(J[te2], q2)), ee2.push(r2(ee2[te2], a2(q2, G2, ae2))), te2++);
        var $2 = 0.84 * (L2 / oe2) ** (1 / 5);
        if (m2($2, R2) ? $2 = R2 : p2($2, z2) && ($2 = z2), $2 = H2 ? g2($2) : $2, q2 = a2(q2, $2), M2 && p2(l2(q2), M2) ? q2 = O3 ? M2 : v2(M2) : N2 && m2(l2(q2), N2) && (q2 = O3 ? N2 : v2(N2)), ne2++, ne2 > V2) throw Error(`Maximum number of iterations reached, try changing options`);
      }
      return { t: J, y: ee2 };
    };
  }
  function b2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 2], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 1 / 2, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(t5, n3, r3, i3);
  }
  function x2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 5], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(t5, n3, r3, i3);
  }
  function S2(t5, n3, r3, i3) {
    var a3 = i3.method ? i3.method : `RK45`, o3 = { RK23: b2, RK45: x2 };
    if (a3.toUpperCase() in o3) {
      var s3 = _objectSpread$3$2({}, i3);
      return delete s3.method, o3[a3.toUpperCase()](t5, n3, r3, s3);
    } else {
      var c3 = Object.keys(o3).map((t6) => `"${t6}"`), l3 = `${c3.slice(0, -1).join(`, `)} and ${c3.slice(-1)}`;
      throw Error(`Unavailable method "${a3}". Available methods are ${l3}`);
    }
  }
  function w2(t5) {
    return t5 ? m2 : p2;
  }
  function E(t5) {
    var n3 = t5 ? p2 : m2;
    return function(t6, a3, o3) {
      return n3(r2(t6, o3), a3) ? i2(a3, t6) : o3;
    };
  }
  function D(t5) {
    return isBigNumber$2(t5) || isNumber$2(t5);
  }
  function O2(t5, n3, r3, i3) {
    var a3 = S2(t5, n3.toArray(), r3.toArray(), i3);
    return { t: h2(a3.t), y: h2(a3.y) };
  }
  return n2(`solveODE`, { "function, Array, Array, Object": S2, "function, Matrix, Matrix, Object": O2, "function, Array, Array": (t5, n3, r3) => S2(t5, n3, r3, {}), "function, Matrix, Matrix": (t5, n3, r3) => O2(t5, n3, r3, {}), "function, Array, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3, [r3], {});
    return { t: i3.t, y: i3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3.toArray(), [r3], {});
    return { t: h2(i3.t), y: h2(i3.y.map((t6) => t6[0])) };
  }, "function, Array, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3, [r3], i3);
    return { t: a3.t, y: a3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3.toArray(), [r3], i3);
    return { t: h2(a3.t), y: h2(a3.y.map((t6) => t6[0])) };
  } });
}), name$206$2 = `erf`, dependencies$206$2 = [`typed`], createErf$2 = factory$2(name$206$2, dependencies$206$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`name`, { number: function(t5) {
    var n3 = Math.abs(t5);
    return n3 >= MAX_NUM$2 ? sign$2$2(t5) : n3 <= THRESH$2 ? sign$2$2(t5) * r2(n3) : n3 <= 4 ? sign$2$2(t5) * (1 - i2(n3)) : sign$2$2(t5) * (1 - a2(n3));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
  function r2(t5) {
    var n3 = t5 * t5, r3 = P$5[0][4] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 3; a3 += 1) r3 = (r3 + P$5[0][a3]) * n3, i3 = (i3 + Q$3[0][a3]) * n3;
    return t5 * (r3 + P$5[0][3]) / (i3 + Q$3[0][3]);
  }
  function i2(t5) {
    var n3 = P$5[1][8] * t5, r3 = t5, i3;
    for (i3 = 0; i3 < 7; i3 += 1) n3 = (n3 + P$5[1][i3]) * t5, r3 = (r3 + Q$3[1][i3]) * t5;
    var a3 = (n3 + P$5[1][7]) / (r3 + Q$3[1][7]), o2 = parseInt(t5 * 16) / 16, s2 = (t5 - o2) * (t5 + o2);
    return Math.exp(-o2 * o2) * Math.exp(-s2) * a3;
  }
  function a2(t5) {
    var n3 = 1 / (t5 * t5), r3 = P$5[2][5] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 4; a3 += 1) r3 = (r3 + P$5[2][a3]) * n3, i3 = (i3 + Q$3[2][a3]) * n3;
    var o2 = n3 * (r3 + P$5[2][4]) / (i3 + Q$3[2][4]);
    o2 = (SQRPI$2 - o2) / t5, n3 = parseInt(t5 * 16) / 16;
    var s2 = (t5 - n3) * (t5 + n3);
    return Math.exp(-n3 * n3) * Math.exp(-s2) * o2;
  }
}), THRESH$2 = 0.46875, SQRPI$2 = 0.5641895835477563, P$5 = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q$3 = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM$2 = 2 ** 53, name$205$2 = `zeta`, dependencies$205$2 = [`typed`, `config`, `multiply`, `pow`, `divide`, `factorial`, `equal`, `smallerEq`, `isBounded`, `isNegative`, `gamma`, `sin`, `subtract`, `add`, `?Complex`, `?BigNumber`, `pi`], createZeta$2 = factory$2(name$205$2, dependencies$205$2, (t4) => {
  var { typed: n2, config: r2, multiply: i2, pow: a2, divide: o2, factorial: s2, equal: c2, smallerEq: l2, isBounded: u2, isNegative: d2, gamma: p2, sin: m2, subtract: h2, add: g2, Complex: v2, BigNumber: y2, pi: b2 } = t4;
  return n2(name$205$2, { number: (t5) => x2(t5, (t6) => t6, () => 20), BigNumber: (t5) => x2(t5, (t6) => new y2(t6), () => Math.abs(Math.log10(r2.relTol))), Complex: S2 });
  function x2(t5, n3, r3) {
    return c2(t5, 0) ? n3(-0.5) : c2(t5, 1) ? n3(NaN) : u2(t5) ? w2(t5, n3, r3, (t6) => t6) : d2(t5) ? n3(NaN) : n3(1);
  }
  function S2(t5) {
    return t5.re === 0 && t5.im === 0 ? new v2(-0.5) : t5.re === 1 ? new v2(NaN, NaN) : t5.re === 1 / 0 && t5.im === 0 ? new v2(1) : t5.im === 1 / 0 || t5.re === -1 / 0 ? new v2(NaN, NaN) : w2(t5, (t6) => t6, (t6) => Math.round(1.3 * 15 + 0.9 * Math.abs(t6.im)), (t6) => t6.re);
  }
  function w2(t5, n3, r3, s3) {
    var c3 = r3(t5);
    if (s3(t5) > -(c3 - 1) / 2) return D(t5, n3(c3), n3);
    var l3 = i2(a2(2, t5), a2(n3(b2), h2(t5, 1)));
    return l3 = i2(l3, m2(i2(o2(n3(b2), 2), t5))), l3 = i2(l3, p2(h2(1, t5))), i2(l3, w2(h2(1, t5), n3, r3, s3));
  }
  function E(t5, n3) {
    for (var r3 = t5, c3 = t5; l2(c3, n3); c3 = g2(c3, 1)) {
      var u3 = o2(i2(s2(g2(n3, h2(c3, 1))), a2(4, c3)), i2(s2(h2(n3, c3)), s2(i2(2, c3))));
      r3 = g2(r3, u3);
    }
    return i2(n3, r3);
  }
  function D(t5, n3, r3) {
    for (var s3 = o2(1, i2(E(r3(0), n3), h2(1, a2(2, h2(1, t5))))), c3 = r3(0), u3 = r3(1); l2(u3, n3); u3 = g2(u3, 1)) c3 = g2(c3, o2(i2((-1) ** (u3 - 1), E(u3, n3)), a2(u3, t5)));
    return i2(s3, c3);
  }
}), name$204$2 = `mode`, dependencies$204$2 = [`typed`, `isNaN`, `isNumeric`], createMode$2 = factory$2(name$204$2, dependencies$204$2, (t4) => {
  var { typed: n2, isNaN: r2, isNumeric: i2 } = t4;
  return n2(name$204$2, { "Array | Matrix": a2, "...": function(t5) {
    return a2(t5);
  } });
  function a2(t5) {
    if (t5 = flatten$4$2(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate mode of an empty array`);
    for (var n3 = {}, a3 = [], o2 = 0, s2 = 0; s2 < t5.length; s2++) {
      var c2 = t5[s2];
      if (i2(c2) && r2(c2)) throw Error(`Cannot calculate mode of an array containing NaN values`);
      c2 in n3 || (n3[c2] = 0), n3[c2]++, n3[c2] === o2 ? a3.push(c2) : n3[c2] > o2 && (o2 = n3[c2], a3 = [c2]);
    }
    return a3;
  }
});
function improveErrorMessage$2(t4, n2, r2) {
  var i2;
  return String(t4).includes(`Unexpected type`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf$2(r2) + `, value: ` + JSON.stringify(r2) + `)` : ` (type: ` + t4.data.actual + `)`, TypeError(`Cannot calculate ` + n2 + `, unexpected type of argument` + i2)) : String(t4).includes(`complex numbers`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf$2(r2) + `, value: ` + JSON.stringify(r2) + `)` : ``, TypeError(`Cannot calculate ` + n2 + `, no ordering relation is defined for complex numbers` + i2)) : t4;
}
var name$203$2 = `prod`, dependencies$203$2 = [`typed`, `config`, `multiplyScalar`, `numeric`], createProd$2 = factory$2(name$203$2, dependencies$203$2, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, numeric: a2 } = t4;
  return n2(name$203$2, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`prod(A, dim) is not yet supported`);
  }, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    if (deepForEach$3(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage$2(n4, `prod`, t6);
      }
    }), typeof n3 == `string` && (n3 = a2(n3, safeNumberType$2(n3, r2))), n3 === void 0) throw Error(`Cannot calculate prod of an empty array`);
    return n3;
  }
}), name$202$2 = `format`, dependencies$202$2 = [`typed`], createFormat$2 = factory$2(name$202$2, dependencies$202$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$202$2, { any: format$4, "any, Object | function | number | BigNumber": format$4 });
}), name$201$2 = `bin`, dependencies$201$2 = [`typed`, `format`], createBin$2 = factory$2(name$201$2, dependencies$201$2, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$201$2, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `bin` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `bin`, wordSize: n3 });
  } });
}), name$200$2 = `oct`, dependencies$200$2 = [`typed`, `format`], createOct$2 = factory$2(name$200$2, dependencies$200$2, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$200$2, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `oct` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `oct`, wordSize: n3 });
  } });
}), name$199$2 = `hex`, dependencies$199$2 = [`typed`, `format`], createHex$2 = factory$2(name$199$2, dependencies$199$2, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$199$2, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `hex` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `hex`, wordSize: n3 });
  } });
}), printTemplate$2 = /\$([\w.]+)/g, name$198$2 = `print`, dependencies$198$2 = [`typed`], createPrint$2 = factory$2(name$198$2, dependencies$198$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$198$2, { "string, Object | Array": _print$2, "string, Object | Array, number | Object": _print$2 });
});
function _print$2(t4, n2, r2) {
  return t4.replace(printTemplate$2, function(t5, i2) {
    var a2 = i2.split(`.`), o2 = n2[a2.shift()];
    for (o2 !== void 0 && o2.isMatrix && (o2 = o2.toArray()); a2.length && o2 !== void 0; ) {
      var s2 = a2.shift();
      o2 = s2 ? o2[s2] : o2 + `.`;
    }
    return o2 === void 0 ? t5 : isString$2(o2) ? o2 : format$4(o2, r2);
  });
}
var name$197$2 = `to`, dependencies$197$2 = [`typed`, `matrix`, `concat`], createTo$2 = factory$2(name$197$2, dependencies$197$2, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$197$2, { "Unit, Unit | string": (t5, n3) => t5.to(n3) }, createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: i2 })({ Ds: true }));
}), name$196$2 = `toBest`, dependencies$196$2 = [`typed`], createToBest$2 = factory$2(name$196$2, dependencies$196$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$196$2, { Unit: (t5) => t5.toBest(), "Unit, string": (t5, n3) => t5.toBest(n3.split(`,`)), "Unit, string, Object": (t5, n3, r2) => t5.toBest(n3.split(`,`), r2), "Unit, Array": (t5, n3) => t5.toBest(n3), "Unit, Array, Object": (t5, n3, r2) => t5.toBest(n3, r2) });
}), name$195$2 = `isPrime`, dependencies$195$2 = [`typed`], createIsPrime$2 = factory$2(name$195$2, dependencies$195$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$195$2, { number: function(t5) {
    if (t5 <= 3) return t5 > 1;
    if (t5 % 2 == 0 || t5 % 3 == 0) return false;
    for (var n3 = 5; n3 * n3 <= t5; n3 += 6) if (t5 % n3 === 0 || t5 % (n3 + 2) === 0) return false;
    return true;
  }, bigint: function(t5) {
    if (t5 <= 3n) return t5 > 1n;
    if (t5 % 2n == 0n || t5 % 3n == 0n) return false;
    for (var n3 = 5n; n3 * n3 <= t5; n3 += 6n) if (t5 % n3 === 0n || t5 % (n3 + 2n) === 0n) return false;
    return true;
  }, BigNumber: function(t5) {
    if (t5.lte(3)) return t5.gt(1);
    if (t5.mod(2).eq(0) || t5.mod(3).eq(0)) return false;
    if (t5.lt(2 ** 32)) {
      for (var n3 = t5.toNumber(), r2 = 5; r2 * r2 <= n3; r2 += 6) if (n3 % r2 === 0 || n3 % (r2 + 2) === 0) return false;
      return true;
    }
    function i2(t6, n4, r3) {
      for (var i3 = 1; !n4.eq(0); ) n4.mod(2).eq(0) ? (n4 = n4.div(2), t6 = t6.mul(t6).mod(r3)) : (n4 = n4.sub(1), i3 = t6.mul(i3).mod(r3));
      return i3;
    }
    t5 = new (t5.constructor.clone({ precision: t5.toFixed(0).length * 2 }))(t5);
    for (var a2 = 0, o2 = t5.sub(1); o2.mod(2).eq(0); ) o2 = o2.div(2), a2 += 1;
    var s2 = null;
    if (t5.lt(`3317044064679887385961981`)) s2 = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((n4) => n4 < t5);
    else {
      var c2 = Math.min(t5.toNumber() - 2, Math.floor(2 * (t5.toFixed(0).length * Math.log(10)) ** 2));
      s2 = [];
      for (var l2 = 2; l2 <= c2; l2 += 1) s2.push(c2);
    }
    for (var u2 = 0; u2 < s2.length; u2 += 1) {
      var d2 = s2[u2], p2 = i2(t5.sub(t5).add(d2), o2, t5);
      if (!p2.eq(1)) {
        for (var m2 = 0, h2 = p2; !h2.eq(t5.sub(1)); m2 += 1, h2 = h2.mul(h2).mod(t5)) if (m2 === a2 - 1) return false;
      }
    }
    return true;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$194$2 = `numeric`, dependencies$194$2 = [`number`, `?bignumber`, `?fraction`], createNumeric$2 = factory$2(name$194$2, dependencies$194$2, (t4) => {
  var { number: n2, bignumber: r2, fraction: i2 } = t4, a2 = { string: true, number: true, BigNumber: true, Fraction: true }, o2 = { number: (t5) => n2(t5), BigNumber: r2 ? (t5) => r2(t5) : noBignumber$2, bigint: (t5) => BigInt(t5), Fraction: i2 ? (t5) => i2(t5) : noFraction$2 };
  return function(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `number`;
    if ((arguments.length > 2 ? arguments[2] : void 0) !== void 0) throw SyntaxError(`numeric() takes one or two arguments`);
    var r3 = typeOf$2(t5);
    if (!(r3 in a2)) throw TypeError(`Cannot convert ` + t5 + ` of type "` + r3 + `"; valid input types are ` + Object.keys(a2).join(`, `));
    if (!(n3 in o2)) throw TypeError(`Cannot convert ` + t5 + ` to type "` + n3 + `"; valid output types are ` + Object.keys(o2).join(`, `));
    return n3 === r3 ? t5 : o2[n3](t5);
  };
}), name$193$2 = `divideScalar`, dependencies$193$2 = [`typed`, `numeric`], createDivideScalar$2 = factory$2(name$193$2, dependencies$193$2, (t4) => {
  var { typed: n2, numeric: r2 } = t4;
  return n2(name$193$2, { "number, number": function(t5, n3) {
    return t5 / n3;
  }, "Complex, Complex": function(t5, n3) {
    return t5.div(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.div(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 / n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.div(n3);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (t5, n3) => t5.divide(n3), "number | Fraction | Complex | BigNumber, Unit": (t5, n3) => n3.divideInto(t5) });
}), name$192$2 = `pow`, dependencies$192$2 = [`typed`, `config`, `identity`, `multiply`, `matrix`, `inv`, `fraction`, `number`, `Complex`], createPow$2 = factory$2(name$192$2, dependencies$192$2, (t4) => {
  var { typed: n2, config: r2, identity: i2, multiply: a2, matrix: o2, inv: s2, number: c2, fraction: l2, Complex: u2 } = t4;
  return n2(name$192$2, { "number, number": d2, "Complex, Complex": function(t5, n3) {
    return t5.pow(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isInteger() || t5 >= 0 || r2.predictable ? t5.pow(n3) : new u2(t5.toNumber(), 0).pow(n3.toNumber(), 0);
  }, "bigint, bigint": (t5, n3) => t5 ** n3, "Fraction, Fraction": function(t5, n3) {
    var i3 = t5.pow(n3);
    if (i3 != null) return i3;
    if (r2.predictable) throw Error(`Result of pow is non-rational and cannot be expressed as a fraction`);
    return d2(t5.valueOf(), n3.valueOf());
  }, "Array, number": p2, "Array, BigNumber": function(t5, n3) {
    return p2(t5, n3.toNumber());
  }, "Matrix, number": m2, "Matrix, BigNumber": function(t5, n3) {
    return m2(t5, n3.toNumber());
  }, "Unit, number | BigNumber": function(t5, n3) {
    return t5.pow(n3);
  } });
  function d2(t5, n3) {
    if (r2.predictable && !isInteger$3(n3) && t5 < 0) try {
      var i3 = l2(n3), a3 = c2(i3);
      if ((n3 === a3 || Math.abs((n3 - a3) / n3) < 1e-14) && i3.d % 2n == 1n) return (i3.n % 2n == 0n ? 1 : -1) * (-t5) ** +n3;
    } catch {
    }
    return r2.predictable && (t5 < -1 && n3 === 1 / 0 || t5 > -1 && t5 < 0 && n3 === -1 / 0) ? NaN : isInteger$3(n3) || t5 >= 0 || r2.predictable ? powNumber$2(t5, n3) : t5 * t5 < 1 && n3 === 1 / 0 || t5 * t5 > 1 && n3 === -1 / 0 ? 0 : new u2(t5, 0).pow(n3, 0);
  }
  function p2(t5, n3) {
    if (!isInteger$3(n3)) throw TypeError(`For A^b, b must be an integer (value is ` + n3 + `)`);
    var r3 = arraySize$2(t5);
    if (r3.length !== 2) throw Error(`For A^b, A must be 2 dimensional (A has ` + r3.length + ` dimensions)`);
    if (r3[0] !== r3[1]) throw Error(`For A^b, A must be square (size is ` + r3[0] + `x` + r3[1] + `)`);
    if (n3 < 0) try {
      return p2(s2(t5), -n3);
    } catch (t6) {
      throw t6.message === `Cannot calculate inverse, determinant is zero` ? TypeError(`For A^b, when A is not invertible, b must be a positive integer (value is ` + n3 + `)`) : t6;
    }
    for (var o3 = i2(r3[0]).valueOf(), c3 = t5; n3 >= 1; ) (n3 & 1) == 1 && (o3 = a2(c3, o3)), n3 >>= 1, c3 = a2(c3, c3);
    return o3;
  }
  function m2(t5, n3) {
    return o2(p2(t5.valueOf(), n3));
  }
}), NO_INT$2 = `Number of decimals in function round must be an integer`, name$191$2 = `round`, dependencies$191$2 = [`typed`, `config`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`], createRound$2 = factory$2(name$191$2, dependencies$191$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, equalScalar: a2, zeros: o2, BigNumber: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: a2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$2({ typed: n2 });
  function p2(t5) {
    return Math.abs(splitNumber$2(t5).exponent);
  }
  return n2(name$191$2, { number: function(t5) {
    var n3 = roundNumber$2(t5, p2(r2.relTol));
    return roundNumber$2(nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol) ? n3 : t5);
  }, "number, number": function(t5, n3) {
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return roundNumber$2(t5, n3);
    var a3 = roundNumber$2(t5, i3);
    return roundNumber$2(nearlyEqual$1$2(t5, a3, r2.relTol, r2.absTol) ? a3 : t5, n3);
  }, "number, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$2);
    return new s2(t5).toDecimalPlaces(n3.toNumber());
  }, Complex: function(t5) {
    return t5.round();
  }, "Complex, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT$2);
    return t5.round(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$2);
    var r3 = n3.toNumber();
    return t5.round(r3);
  }, BigNumber: function(t5) {
    var n3 = new s2(t5).toDecimalPlaces(p2(r2.relTol));
    return (nearlyEqual$3(t5, n3, r2.relTol, r2.absTol) ? n3 : t5).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$2);
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return t5.toDecimalPlaces(n3.toNumber());
    var a3 = t5.toDecimalPlaces(i3);
    return (nearlyEqual$3(t5, a3, r2.relTol, r2.absTol) ? a3 : t5).toDecimalPlaces(n3.toNumber());
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.round();
  }, "Fraction, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT$2);
    return t5.round(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$2);
    return t5.round(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$3(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5, true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(i2(n3), r3, t5, false).valueOf()), "number | Complex | BigNumber | Fraction, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : u2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()) });
}), name$190$2 = `log`, dependencies$190$2 = [`config`, `typed`, `typeOf`, `divideScalar`, `Complex`], nlg16$2 = Math.log(16), createLog$2 = factory$2(name$190$2, dependencies$190$2, (t4) => {
  var { typed: n2, typeOf: r2, config: i2, divideScalar: a2, Complex: o2 } = t4;
  function s2(t5) {
    return t5.log();
  }
  function c2(t5) {
    return s2(new o2(t5, 0));
  }
  return n2(name$190$2, { number: function(t5) {
    return t5 >= 0 || i2.predictable ? logNumber$2(t5) : c2(t5);
  }, bigint: promoteLogarithm$2(nlg16$2, logNumber$2, i2, c2), Complex: s2, BigNumber: function(t5) {
    return !t5.isNegative() || i2.predictable ? t5.ln() : c2(t5.toNumber());
  }, "any, any": n2.referToSelf((t5) => (n3, i3) => {
    if (r2(n3) === `Fraction` && r2(i3) === `Fraction`) {
      var o3 = n3.log(i3);
      if (o3 !== null) return o3;
    }
    return a2(t5(n3), t5(i3));
  }) });
}), name$189$2 = `log1p`, dependencies$189$2 = [`typed`, `config`, `divideScalar`, `log`, `Complex`], createLog1p$2 = factory$2(name$189$2, dependencies$189$2, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, log: a2, Complex: o2 } = t4;
  return n2(name$189$2, { number: function(t5) {
    return t5 >= -1 || r2.predictable ? log1p$2(t5) : s2(new o2(t5, 0));
  }, Complex: s2, BigNumber: function(t5) {
    var n3 = t5.plus(1);
    return !n3.isNegative() || r2.predictable ? n3.ln() : s2(new o2(t5.toNumber(), 0));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)), "any, any": n2.referToSelf((t5) => (n3, r3) => i2(t5(n3), a2(r3))) });
  function s2(t5) {
    var n3 = t5.re + 1;
    return new o2(Math.log(Math.sqrt(n3 * n3 + t5.im * t5.im)), Math.atan2(t5.im, n3));
  }
}), name$188$2 = `nthRoots`, dependencies$188$2 = [`config`, `typed`, `divideScalar`, `Complex`], createNthRoots$2 = factory$2(name$188$2, dependencies$188$2, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, Complex: a2 } = t4, o2 = [function(t5) {
    return new a2(t5, 0);
  }, function(t5) {
    return new a2(0, t5);
  }, function(t5) {
    return new a2(-t5, 0);
  }, function(t5) {
    return new a2(0, -t5);
  }];
  function s2(t5, n3) {
    if (n3 < 0) throw Error(`Root must be greater than zero`);
    if (n3 === 0) throw Error(`Root must be non-zero`);
    if (n3 % 1 != 0) throw Error(`Root must be an integer`);
    if (t5 === 0 || t5.abs() === 0) return [new a2(0, 0)];
    var r3 = typeof t5 == `number`, i3;
    (r3 || t5.re === 0 || t5.im === 0) && (i3 = r3 ? 2 * (t5 < 0) : t5.im === 0 ? 2 * (t5.re < 0) : 2 * (t5.im < 0) + 1);
    for (var s3 = t5.arg(), c2 = t5.abs(), l2 = [], u2 = c2 ** (1 / n3), d2 = 0; d2 < n3; d2++) {
      var p2 = (i3 + 4 * d2) / n3;
      if (p2 === Math.round(p2)) {
        l2.push(o2[p2 % 4](u2));
        continue;
      }
      l2.push(new a2({ r: u2, phi: (s3 + 2 * Math.PI * d2) / n3 }));
    }
    return l2;
  }
  return n2(name$188$2, { Complex: function(t5) {
    return s2(t5, 2);
  }, "Complex, number": s2 });
}), name$187$2 = `dotPow`, dependencies$187$2 = [`typed`, `equalScalar`, `matrix`, `pow`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotPow$2 = factory$2(name$187$2, dependencies$187$2, (t4) => {
  var { typed: n2, equalScalar: r2, matrix: i2, pow: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$2({ typed: n2 }), u2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: r2 }), p2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: i2, concat: s2 }), h2 = {};
  for (var g2 in a2.signatures) Object.prototype.hasOwnProperty.call(a2.signatures, g2) && !g2.includes(`Matrix`) && !g2.includes(`Array`) && (h2[g2] = a2.signatures[g2]);
  return n2(name$187$2, m2({ elop: n2(h2), SS: u2, DS: l2, Ss: d2, sS: p2 }));
}), name$186$2 = `dotDivide`, dependencies$186$2 = [`typed`, `matrix`, `equalScalar`, `divideScalar`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotDivide$2 = factory$2(name$186$2, dependencies$186$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, divideScalar: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo03xDSf$2({ typed: n2 }), d2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: c2 }), p2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 });
  return n2(name$186$2, createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 })({ elop: a2, SS: d2, DS: u2, SD: l2, Ss: p2, sS: m2 }));
});
function createSolveValidation$2(t4) {
  var { DenseMatrix: n2 } = t4;
  return function(t5, r2, i2) {
    var a2 = t5.size();
    if (a2.length !== 2) throw RangeError(`Matrix must be two dimensional (size: ` + format$4(a2) + `)`);
    var o2 = a2[0];
    if (o2 !== a2[1]) throw RangeError(`Matrix must be square (size: ` + format$4(a2) + `)`);
    var s2 = [];
    if (isMatrix$2(r2)) {
      var c2 = r2.size(), l2 = r2._data;
      if (c2.length === 1) {
        if (c2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var u2 = 0; u2 < o2; u2++) s2[u2] = [l2[u2]];
        return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
      }
      if (c2.length === 2) {
        if (c2[0] !== o2 || c2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        if (isDenseMatrix$2(r2)) {
          if (i2) {
            s2 = [];
            for (var d2 = 0; d2 < o2; d2++) s2[d2] = [l2[d2][0]];
            return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
          }
          return r2;
        }
        if (isSparseMatrix$2(r2)) {
          for (var p2 = 0; p2 < o2; p2++) s2[p2] = [0];
          for (var m2 = r2._values, h2 = r2._index, g2 = r2._ptr, v2 = g2[1], y2 = g2[0]; y2 < v2; y2++) {
            var b2 = h2[y2];
            s2[b2][0] = m2[y2];
          }
          return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
        }
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
    if (isArray$3(r2)) {
      var x2 = arraySize$2(r2);
      if (x2.length === 1) {
        if (x2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var S2 = 0; S2 < o2; S2++) s2[S2] = [r2[S2]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      if (x2.length === 2) {
        if (x2[0] !== o2 || x2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var w2 = 0; w2 < o2; w2++) s2[w2] = [r2[w2][0]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
  };
}
var name$185$2 = `lsolve`, dependencies$185$2 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolve$2 = factory$2(name$185$2, dependencies$185$2, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$2({ DenseMatrix: c2 });
  return n2(name$185$2, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = 0; h2 < d3; h2++) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 + 1; b2 < u3; b2++) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = 0; v2 < d3; v2++) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1], D = w2; D < E; D++) {
          var O2 = m2[D];
          O2 === v2 ? b2 = p2[D] : O2 > v2 && (x2.push(p2[D]), S2.push(O2));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var j2 = i2(y2, b2), M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          r3[F] = [o2(r3[F][0] || 0, a2(j2, x2[M2]))];
        }
        g2[v2] = [j2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$184$2 = `usolve`, dependencies$184$2 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolve$2 = factory$2(name$184$2, dependencies$184$2, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$2({ DenseMatrix: c2 });
  return n2(name$184$2, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = d3 - 1; h2 >= 0; h2--) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 - 1; b2 >= 0; b2--) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = d3 - 1; v2 >= 0; v2--) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1] - 1; E >= w2; E--) {
          var D = m2[E];
          D === v2 ? b2 = p2[E] : D < v2 && (x2.push(p2[E]), S2.push(D));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var O2 = i2(y2, b2), j2 = 0, M2 = S2.length; j2 < M2; j2++) {
          var N2 = S2[j2];
          r3[N2] = [o2(r3[N2][0], a2(O2, x2[j2]))];
        }
        g2[v2] = [O2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$183$2 = `lsolveAll`, dependencies$183$2 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolveAll$2 = factory$2(name$183$2, dependencies$183$2, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$2({ DenseMatrix: c2 });
  return n2(name$183$2, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1], m2 = 0; m2 < p2; m2++) for (var h2 = r3.length, g2 = 0; g2 < h2; g2++) {
      var v2 = r3[g2];
      if (!s2(u3[m2][m2], 0)) {
        v2[m2] = i2(v2[m2], u3[m2][m2]);
        for (var y2 = m2 + 1; y2 < p2; y2++) v2[y2] = o2(v2[y2], a2(v2[m2], u3[y2][m2]));
      } else if (!s2(v2[m2], 0)) {
        if (g2 === 0) return [];
        r3.splice(g2, 1), --g2, --h2;
      } else if (g2 === 0) {
        var b2 = [...v2];
        b2[m2] = 1;
        for (var x2 = m2 + 1; x2 < p2; x2++) b2[x2] = o2(b2[x2], u3[x2][m2]);
        r3.push(b2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = 0; g2 < d3; g2++) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = w2; O2 < E; O2++) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 > g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$182$2 = `usolveAll`, dependencies$182$2 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolveAll$2 = factory$2(name$182$2, dependencies$182$2, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$2({ DenseMatrix: c2 });
  return n2(name$182$2, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1] - 1; p2 >= 0; p2--) for (var m2 = r3.length, h2 = 0; h2 < m2; h2++) {
      var g2 = r3[h2];
      if (!s2(u3[p2][p2], 0)) {
        g2[p2] = i2(g2[p2], u3[p2][p2]);
        for (var v2 = p2 - 1; v2 >= 0; v2--) g2[v2] = o2(g2[v2], a2(g2[p2], u3[v2][p2]));
      } else if (!s2(g2[p2], 0)) {
        if (h2 === 0) return [];
        r3.splice(h2, 1), --h2, --m2;
      } else if (h2 === 0) {
        var y2 = [...g2];
        y2[p2] = 1;
        for (var b2 = p2 - 1; b2 >= 0; b2--) y2[b2] = o2(y2[b2], u3[b2][p2]);
        r3.push(y2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = d3 - 1; g2 >= 0; g2--) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = E - 1; O2 >= w2; O2--) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 < g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$181$2 = `matAlgo08xS0Sid`, dependencies$181$2 = [`typed`, `equalScalar`], createMatAlgo08xS0Sid$2 = factory$2(name$181$2, dependencies$181$2, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$2(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    if (!o2 || !d2) throw Error(`Cannot perform operation on Pattern Sparse Matrices`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    for (var E = [], D = [], O2 = [], j2 = [], M2 = [], N2, F, I2, L2, R2 = 0; R2 < y2; R2++) {
      O2[R2] = D.length;
      var z2 = R2 + 1;
      for (F = c2[R2], I2 = c2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = s2[N2], M2[L2] = z2, j2[L2] = o2[N2], D.push(L2);
      for (F = m2[R2], I2 = m2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = p2[N2], M2[L2] === z2 && (j2[L2] = w2(j2[L2], d2[N2]));
      for (N2 = O2[R2]; N2 < D.length; ) {
        L2 = D[N2];
        var V2 = j2[L2];
        x2(V2, S2) ? D.splice(N2, 1) : (E.push(V2), N2++);
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), createUseMatrixForArrayScalar$2 = factory$2(`useMatrixForArrayScalar`, [`typed`, `matrix`], (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return { "Array, number": n2.referTo(`DenseMatrix, number`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "Array, BigNumber": n2.referTo(`DenseMatrix, BigNumber`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "number, Array": n2.referTo(`number, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()), "BigNumber, Array": n2.referTo(`BigNumber, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()) };
}), name$180$2 = `leftShift`, dependencies$180$2 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createLeftShift$2 = factory$2(name$180$2, dependencies$180$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$2({ typed: n2 }), l2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$2({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$2({ typed: n2 }), h2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$2({ typed: n2, matrix: r2 });
  return n2(name$180$2, { "number, number": leftShiftNumber$2, "BigNumber, BigNumber": leftShiftBigNumber$2, "bigint, bigint": (t5, n3) => t5 << n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$179$2 = `rightArithShift`, dependencies$179$2 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightArithShift$2 = factory$2(name$179$2, dependencies$179$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$2({ typed: n2 }), l2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$2({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$2({ typed: n2 }), h2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$2({ typed: n2, matrix: r2 });
  return n2(name$179$2, { "number, number": rightArithShiftNumber$2, "BigNumber, BigNumber": rightArithShiftBigNumber$2, "bigint, bigint": (t5, n3) => t5 >> n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$178$2 = `rightLogShift`, dependencies$178$2 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightLogShift$2 = factory$2(name$178$2, dependencies$178$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$2({ typed: n2 }), l2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$2({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$2({ typed: n2 }), h2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$2({ typed: n2, matrix: r2 });
  return n2(name$178$2, { "number, number": rightLogShiftNumber$2, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$177$2 = `and`, dependencies$177$2 = [`typed`, `matrix`, `equalScalar`, `zeros`, `not`, `concat`], createAnd$2 = factory$2(name$177$2, dependencies$177$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0$2({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo14xDs$2({ typed: n2 }), p2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$177$2, { "number, number": andNumber$2, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) && (n3.re !== 0 || n3.im !== 0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !n3.isZero() && !t5.isNaN() && !n3.isNaN();
  }, "bigint, bigint": andNumber$2, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)), "SparseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : u2(n3, r3, t5, false)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : d2(n3, r3, t5, false)), "any, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : u2(r3, n3, t5, true)), "any, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : d2(r3, n3, t5, true)), "Array, any": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3), i3).valueOf()), "any, Array": n2.referToSelf((t5) => (n3, i3) => t5(n3, r2(i3)).valueOf()) }, p2({ SS: l2, DS: c2 }));
}), name$176$2 = `compare`, dependencies$176$2 = [`typed`, `config`, `matrix`, `equalScalar`, `BigNumber`, `Fraction`, `DenseMatrix`, `concat`], createCompare$2 = factory$2(name$176$2, dependencies$176$2, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, BigNumber: o2, Fraction: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createMatAlgo03xDSf$2({ typed: n2 }), d2 = createMatAlgo05xSfSf$2({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: c2 }), m2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: a2, concat: l2 }), h2 = createCompareUnits$2({ typed: n2 });
  return n2(name$176$2, createCompareNumber$2({ typed: n2, config: r2 }), { "boolean, boolean": function(t5, n3) {
    return t5 === n3 ? 0 : t5 > n3 ? 1 : -1;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return nearlyEqual$3(t5, n3, r2.relTol, r2.absTol) ? new o2(0) : new o2(t5.cmp(n3));
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3 ? 0n : t5 > n3 ? 1n : -1n;
  }, "Fraction, Fraction": function(t5, n3) {
    return new s2(t5.compare(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, h2, m2({ SS: d2, DS: u2, Ss: p2 }));
}), createCompareNumber$2 = factory$2(name$176$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$176$2, { "number, number": function(t5, n3) {
    return nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol) ? 0 : t5 > n3 ? 1 : -1;
  } });
}), require_naturalSort$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function t5(n3, r2) {
    var i2 = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a2 = /(^[ ]*|[ ]*$)/g, o2 = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s2 = /^0x[0-9a-f]+$/i, c2 = /^0/, l2 = function(n4) {
      return t5.insensitive && (`` + n4).toLowerCase() || `` + n4;
    }, u2 = l2(n3).replace(a2, ``) || ``, d2 = l2(r2).replace(a2, ``) || ``, p2 = u2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), m2 = d2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), h2 = parseInt(u2.match(s2), 16) || p2.length !== 1 && u2.match(o2) && Date.parse(u2), g2 = parseInt(d2.match(s2), 16) || h2 && d2.match(o2) && Date.parse(d2) || null, v2, y2;
    if (g2) {
      if (h2 < g2) return -1;
      if (h2 > g2) return 1;
    }
    for (var b2 = 0, x2 = Math.max(p2.length, m2.length); b2 < x2; b2++) {
      if (v2 = !(p2[b2] || ``).match(c2) && parseFloat(p2[b2]) || p2[b2] || 0, y2 = !(m2[b2] || ``).match(c2) && parseFloat(m2[b2]) || m2[b2] || 0, isNaN(v2) !== isNaN(y2)) return isNaN(v2) ? 1 : -1;
      if (typeof v2 != typeof y2 && (v2 += ``, y2 += ``), v2 < y2) return -1;
      if (v2 > y2) return 1;
    }
    return 0;
  };
})), import_naturalSort$2 = __toESM$2(require_naturalSort$2()), name$175$2 = `compareNatural`, dependencies$175$2 = [`typed`, `compare`], createCompareNatural$2 = factory$2(name$175$2, dependencies$175$2, (t4) => {
  var { typed: n2, compare: r2 } = t4, i2 = r2.signatures[`boolean,boolean`];
  return n2(name$175$2, { "any, any": a2 });
  function a2(t5, n3) {
    var l2 = typeOf$2(t5), u2 = typeOf$2(n3), d2;
    if ((l2 === `number` || l2 === `BigNumber` || l2 === `Fraction` || l2 === `bigint`) && (u2 === `number` || u2 === `BigNumber` || u2 === `Fraction` || u2 === `bigint`)) return d2 = r2(t5, n3), d2.toString() === `0` ? (0, import_naturalSort$2.default)(l2, u2) : d2 > 0 ? 1 : -1;
    var p2 = [`Array`, `DenseMatrix`, `SparseMatrix`];
    if (p2.includes(l2) || p2.includes(u2)) return d2 = o2(a2, t5, n3), d2 === 0 ? (0, import_naturalSort$2.default)(l2, u2) : d2;
    if (l2 !== u2) return (0, import_naturalSort$2.default)(l2, u2);
    if (l2 === `Complex`) return compareComplexNumbers$2(t5, n3);
    if (l2 === `Unit`) return t5.equalBase(n3) ? a2(t5.value, n3.value) : s2(a2, t5.formatUnits(), n3.formatUnits());
    if (l2 === `boolean`) return i2(t5, n3);
    if (l2 === `string`) return (0, import_naturalSort$2.default)(t5, n3);
    if (l2 === `Object`) return c2(a2, t5, n3);
    if (l2 === `null` || l2 === `undefined`) return 0;
    throw TypeError(`Unsupported type of value "` + l2 + `"`);
  }
  function o2(t5, n3, r3) {
    return isSparseMatrix$2(n3) && isSparseMatrix$2(r3) ? s2(t5, n3.toJSON().values, r3.toJSON().values) : isSparseMatrix$2(n3) ? o2(t5, n3.toArray(), r3) : isSparseMatrix$2(r3) ? o2(t5, n3, r3.toArray()) : isDenseMatrix$2(n3) ? o2(t5, n3.toJSON().data, r3) : isDenseMatrix$2(r3) ? o2(t5, n3, r3.toJSON().data) : Array.isArray(n3) ? Array.isArray(r3) ? s2(t5, n3, r3) : o2(t5, n3, [r3]) : o2(t5, [n3], r3);
  }
  function s2(t5, n3, r3) {
    for (var i3 = 0, a3 = Math.min(n3.length, r3.length); i3 < a3; i3++) {
      var o3 = t5(n3[i3], r3[i3]);
      if (o3 !== 0) return o3;
    }
    return n3.length > r3.length ? 1 : n3.length < r3.length ? -1 : 0;
  }
  function c2(t5, n3, r3) {
    var i3 = Object.keys(n3), a3 = Object.keys(r3);
    i3.sort(import_naturalSort$2.default), a3.sort(import_naturalSort$2.default);
    var o3 = s2(t5, i3, a3);
    if (o3 !== 0) return o3;
    for (var c3 = 0; c3 < i3.length; c3++) {
      var l2 = t5(n3[i3[c3]], r3[a3[c3]]);
      if (l2 !== 0) return l2;
    }
    return 0;
  }
});
function compareComplexNumbers$2(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}
var name$174$2 = `compareText`, dependencies$174$2 = [`typed`, `matrix`, `concat`];
compareText$2.signature = `any, any`;
var createCompareText$2 = factory$2(name$174$2, dependencies$174$2, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$174$2, compareText$2, createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: i2 })({ elop: compareText$2, Ds: true }));
}), name$173$2 = `equal`, dependencies$173$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `SparseMatrix`], createEqual$2 = factory$2(name$173$2, dependencies$173$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$2({ typed: n2 }), l2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2 });
  return n2(name$173$2, createEqualNumber$2({ typed: n2, equalScalar: i2 }), d2({ elop: i2, SS: l2, DS: c2, Ss: u2 }));
}), createEqualNumber$2 = factory$2(name$173$2, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$173$2, { "any, any": function(t5, n3) {
    return t5 === null ? n3 === null : n3 === null ? t5 === null : t5 === void 0 ? n3 === void 0 : n3 === void 0 ? t5 === void 0 : r2(t5, n3);
  } });
}), name$172$2 = `equalText`, dependencies$172$2 = [`typed`, `compareText`, `isZero`], createEqualText$2 = factory$2(name$172$2, dependencies$172$2, (t4) => {
  var { typed: n2, compareText: r2, isZero: i2 } = t4;
  return n2(name$172$2, { "any, any": function(t5, n3) {
    return i2(r2(t5, n3));
  } });
}), name$171$2 = `smaller`, dependencies$171$2 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmaller$2 = factory$2(name$171$2, dependencies$171$2, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$2({ typed: n2 }), u2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits$2({ typed: n2 });
  function h2(t5, n3) {
    return t5.lt(n3) && !nearlyEqual$3(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$171$2, createSmallerNumber$2({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 < n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 < n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === -1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function(t5, n3) {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createSmallerNumber$2 = factory$2(name$171$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$171$2, { "number, number": function(t5, n3) {
    return t5 < n3 && !nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$170$2 = `smallerEq`, dependencies$170$2 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmallerEq$2 = factory$2(name$170$2, dependencies$170$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$2({ typed: n2 }), l2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits$2({ typed: n2 });
  return n2(name$170$2, createSmallerEqNumber$2({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 <= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.lte(n3) || nearlyEqual$3(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": (t5, n3) => t5 <= n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== 1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createSmallerEqNumber$2 = factory$2(name$170$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$170$2, { "number, number": function(t5, n3) {
    return t5 <= n3 || nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$169$2 = `larger`, dependencies$169$2 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLarger$2 = factory$2(name$169$2, dependencies$169$2, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$2({ typed: n2 }), u2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits$2({ typed: n2 });
  function h2(t5, n3) {
    return t5.gt(n3) && !nearlyEqual$3(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$169$2, createLargerNumber$2({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 > n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 > n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === 1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createLargerNumber$2 = factory$2(name$169$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$169$2, { "number, number": function(t5, n3) {
    return t5 > n3 && !nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$168$2 = `largerEq`, dependencies$168$2 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLargerEq$2 = factory$2(name$168$2, dependencies$168$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$2({ typed: n2 }), l2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits$2({ typed: n2 });
  return n2(name$168$2, createLargerEqNumber$2({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 >= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.gte(n3) || nearlyEqual$3(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 >= n3;
  }, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== -1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createLargerEqNumber$2 = factory$2(name$168$2, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$168$2, { "number, number": function(t5, n3) {
    return t5 >= n3 || nearlyEqual$1$2(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$167$2 = `deepEqual`, dependencies$167$2 = [`typed`, `equal`], createDeepEqual$2 = factory$2(name$167$2, dependencies$167$2, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$167$2, { "any, any": function(t5, n3) {
    return i2(t5.valueOf(), n3.valueOf());
  } });
  function i2(t5, n3) {
    if (Array.isArray(t5)) if (Array.isArray(n3)) {
      var a2 = t5.length;
      if (a2 !== n3.length) return false;
      for (var o2 = 0; o2 < a2; o2++) if (!i2(t5[o2], n3[o2])) return false;
      return true;
    } else return false;
    else if (Array.isArray(n3)) return false;
    else return r2(t5, n3);
  }
}), name$166$2 = `unequal`, dependencies$166$2 = [`typed`, `config`, `equalScalar`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createUnequal$2 = factory$2(name$166$2, dependencies$166$2, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$2({ typed: n2 }), u2 = createMatAlgo07xSSf$2({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: a2, concat: s2 });
  return n2(name$166$2, createUnequalNumber$2({ typed: n2, equalScalar: i2 }), p2({ elop: m2, SS: u2, DS: l2, Ss: d2 }));
  function m2(t5, n3) {
    return !i2(t5, n3);
  }
}), createUnequalNumber$2 = factory$2(name$166$2, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$166$2, { "any, any": function(t5, n3) {
    return t5 === null ? n3 !== null : n3 === null ? t5 !== null : t5 === void 0 ? n3 !== void 0 : n3 === void 0 ? t5 !== void 0 : !r2(t5, n3);
  } });
}), name$165$2 = `partitionSelect`, dependencies$165$2 = [`typed`, `isNumeric`, `isNaN`, `compare`], createPartitionSelect$2 = factory$2(name$165$2, dependencies$165$2, (t4) => {
  var { typed: n2, isNumeric: r2, isNaN: i2, compare: a2 } = t4, o2 = a2, s2 = (t5, n3) => -a2(t5, n3);
  return n2(name$165$2, { "Array | Matrix, number": function(t5, n3) {
    return c2(t5, n3, o2);
  }, "Array | Matrix, number, string": function(t5, n3, r3) {
    if (r3 === `asc`) return c2(t5, n3, o2);
    if (r3 === `desc`) return c2(t5, n3, s2);
    throw Error(`Compare string must be "asc" or "desc"`);
  }, "Array | Matrix, number, function": c2 });
  function c2(t5, n3, r3) {
    if (!isInteger$3(n3) || n3 < 0) throw Error(`k must be a non-negative integer`);
    if (isMatrix$2(t5)) {
      if (t5.size().length > 1) throw Error(`Only one dimensional matrices supported`);
      return l2(t5.valueOf(), n3, r3);
    }
    if (Array.isArray(t5)) return l2(t5, n3, r3);
  }
  function l2(t5, n3, a3) {
    if (n3 >= t5.length) throw Error(`k out of bounds`);
    for (var o3 = 0; o3 < t5.length; o3++) if (r2(t5[o3]) && i2(t5[o3])) return t5[o3];
    for (var s3 = 0, c3 = t5.length - 1; s3 < c3; ) {
      for (var l3 = s3, u2 = c3, d2 = t5[Math.floor(Math.random() * (c3 - s3 + 1)) + s3]; l3 < u2; ) if (a3(t5[l3], d2) >= 0) {
        var p2 = t5[u2];
        t5[u2] = t5[l3], t5[l3] = p2, --u2;
      } else ++l3;
      a3(t5[l3], d2) > 0 && --l3, n3 <= l3 ? c3 = l3 : s3 = l3 + 1;
    }
    return t5[n3];
  }
}), name$164$2 = `sort`, dependencies$164$2 = [`typed`, `matrix`, `compare`, `compareNatural`], createSort$2 = factory$2(name$164$2, dependencies$164$2, (t4) => {
  var { typed: n2, matrix: r2, compare: i2, compareNatural: a2 } = t4, o2 = i2, s2 = (t5, n3) => -i2(t5, n3);
  return n2(name$164$2, { Array: function(t5) {
    return l2(t5), t5.sort(o2);
  }, Matrix: function(t5) {
    return u2(t5), r2(t5.toArray().sort(o2), t5.storage());
  }, "Array, function": function(t5, n3) {
    return l2(t5), t5.sort(n3);
  }, "Matrix, function": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(n3), t5.storage());
  }, "Array, string": function(t5, n3) {
    return l2(t5), t5.sort(c2(n3));
  }, "Matrix, string": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(c2(n3)), t5.storage());
  } });
  function c2(t5) {
    if (t5 === `asc`) return o2;
    if (t5 === `desc`) return s2;
    if (t5 === `natural`) return a2;
    throw Error(`String "asc", "desc", or "natural" expected`);
  }
  function l2(t5) {
    if (arraySize$2(t5).length !== 1) throw Error(`One dimensional array expected`);
  }
  function u2(t5) {
    if (t5.size().length !== 1) throw Error(`One dimensional matrix expected`);
  }
}), name$163$2 = `max`, dependencies$163$2 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMax$2 = factory$2(name$163$2, dependencies$163$2, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4;
  return n2(name$163$2, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1$2(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`Scalar values expected in function max`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage$2(t6, `max`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach$3(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage$2(n4, `max`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate max of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType$2(n3, r2))), n3;
  }
}), name$162$2 = `min`, dependencies$162$2 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMin$2 = factory$2(name$162$2, dependencies$162$2, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4;
  return n2(name$162$2, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1$2(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`Scalar values expected in function min`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage$2(t6, `min`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach$3(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage$2(n4, `min`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate min of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType$2(n3, r2))), n3;
  }
}), name$161$2 = `ImmutableDenseMatrix`, dependencies$161$2 = [`smaller`, `DenseMatrix`], createImmutableDenseMatrixClass$2 = factory$2(name$161$2, dependencies$161$2, (t4) => {
  var { smaller: n2, DenseMatrix: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$2(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$2(t5) || isArray$3(t5)) {
      var a2 = new r2(t5, n3);
      this._data = a2._data, this._size = a2._size, this._datatype = a2._datatype, this._min = null, this._max = null;
    } else if (t5 && isArray$3(t5.data) && isArray$3(t5.size)) this._data = t5.data, this._size = t5.size, this._datatype = t5.datatype, this._min = t5.min === void 0 ? null : t5.min, this._max = t5.max === void 0 ? null : t5.max;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$2(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3, this._min = null, this._max = null;
  }
  return i2.prototype = new r2(), i2.prototype.type = `ImmutableDenseMatrix`, i2.prototype.isImmutableDenseMatrix = true, i2.prototype.subset = function(t5) {
    switch (arguments.length) {
      case 1:
        var n3 = r2.prototype.subset.call(this, t5);
        return isMatrix$2(n3) ? new i2({ data: n3._data, size: n3._size, datatype: n3._datatype }) : n3;
      case 2:
      case 3:
        throw Error(`Cannot invoke set subset on an Immutable Matrix instance`);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.set = function() {
    throw Error(`Cannot invoke set on an Immutable Matrix instance`);
  }, i2.prototype.resize = function() {
    throw Error(`Cannot invoke resize on an Immutable Matrix instance`);
  }, i2.prototype.reshape = function() {
    throw Error(`Cannot invoke reshape on an Immutable Matrix instance`);
  }, i2.prototype.clone = function() {
    return new i2({ data: clone$3$2(this._data), size: clone$3$2(this._size), datatype: this._datatype });
  }, i2.prototype.toJSON = function() {
    return { mathjs: `ImmutableDenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function() {
    throw Error(`Cannot invoke swapRows on an Immutable Matrix instance`);
  }, i2.prototype.min = function() {
    if (this._min === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(r3, t5)) && (t5 = r3);
      }), this._min = t5 === null ? void 0 : t5;
    }
    return this._min;
  }, i2.prototype.max = function() {
    if (this._max === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(t5, r3)) && (t5 = r3);
      }), this._max = t5 === null ? void 0 : t5;
    }
    return this._max;
  }, i2;
}, { isClass: true }), name$160$2 = `Index`, dependencies$160$2 = [`ImmutableDenseMatrix`, `getMatrixDataType`], createIndexClass$2 = factory$2(name$160$2, dependencies$160$2, (t4) => {
  var { ImmutableDenseMatrix: n2, getMatrixDataType: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._dimensions = [], this._sourceSize = [], this._isScalar = true;
    for (var t5 = 0, n3 = arguments.length; t5 < n3; t5++) {
      var o2 = t5 < 0 || arguments.length <= t5 ? void 0 : arguments[t5], s2 = isArray$3(o2), c2 = isMatrix$2(o2), l2 = typeof o2, u2 = null;
      if (isRange$2(o2)) this._dimensions.push(o2), this._isScalar = false;
      else if (s2 || c2) {
        var d2 = void 0;
        this._isScalar = false, r2(o2) === `boolean` ? (s2 && (d2 = a2(_booleansArrayToNumbersForIndex$2(o2).valueOf())), c2 && (d2 = a2(_booleansArrayToNumbersForIndex$2(o2._data).valueOf())), u2 = o2.valueOf().length) : d2 = a2(o2.valueOf()), this._dimensions.push(d2);
      } else if (l2 === `number`) this._dimensions.push(o2);
      else if (l2 === `bigint`) this._dimensions.push(Number(o2));
      else if (l2 === `string`) this._dimensions.push(o2);
      else throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      this._sourceSize.push(u2);
    }
  }
  i2.prototype.type = `Index`, i2.prototype.isIndex = true;
  function a2(t5) {
    for (var r3 = 0, i3 = t5.length; r3 < i3; r3++) if (!isNumber$2(t5[r3]) || !isInteger$3(t5[r3])) throw TypeError(`Index parameters must be positive integer numbers`);
    var a3 = new n2();
    return a3._data = t5, a3._size = [t5.length], a3;
  }
  return i2.prototype.clone = function() {
    var t5 = new i2();
    return t5._dimensions = clone$3$2(this._dimensions), t5._isScalar = this._isScalar, t5._sourceSize = this._sourceSize, t5;
  }, i2.create = function(t5) {
    var n3 = new i2();
    return i2.apply(n3, t5), n3;
  }, i2.prototype.size = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$2(i3) || isNumber$2(i3) ? 1 : i3.size()[0];
    }
    return t5;
  }, i2.prototype.max = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$2(i3) || isNumber$2(i3) ? i3 : i3.max();
    }
    return t5;
  }, i2.prototype.min = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$2(i3) || isNumber$2(i3) ? i3 : i3.min();
    }
    return t5;
  }, i2.prototype.forEach = function(t5) {
    for (var n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) t5(this._dimensions[n3], n3, this);
  }, i2.prototype.dimension = function(t5) {
    return isNumber$2(t5) ? this._dimensions[t5] ?? null : null;
  }, i2.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && isString$2(this._dimensions[0]);
  }, i2.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, i2.prototype.isScalar = function() {
    return this._isScalar;
  }, i2.prototype.toArray = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5.push(isString$2(i3) || isNumber$2(i3) ? i3 : i3.toArray());
    }
    return t5;
  }, i2.prototype.valueOf = i2.prototype.toArray, i2.prototype.toString = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      isString$2(i3) ? t5.push(JSON.stringify(i3)) : t5.push(i3.toString());
    }
    return `[` + t5.join(`, `) + `]`;
  }, i2.prototype.toJSON = function() {
    return { mathjs: `Index`, dimensions: this._dimensions };
  }, i2.fromJSON = function(t5) {
    return i2.create(t5.dimensions);
  }, i2;
}, { isClass: true });
function _booleansArrayToNumbersForIndex$2(t4) {
  var n2 = [];
  return t4.forEach((t5, r2) => {
    t5 && n2.push(r2);
  }), n2;
}
var name$159$2 = `FibonacciHeap`, dependencies$159$2 = [`smaller`, `larger`], createFibonacciHeapClass$2 = factory$2(name$159$2, dependencies$159$2, (t4) => {
  var { smaller: n2, larger: r2 } = t4, i2 = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._minimum = null, this._size = 0;
  }
  a2.prototype.type = `FibonacciHeap`, a2.prototype.isFibonacciHeap = true, a2.prototype.insert = function(t5, r3) {
    var i3 = { key: t5, value: r3, degree: 0 };
    if (this._minimum) {
      var a3 = this._minimum;
      i3.left = a3, i3.right = a3.right, a3.right = i3, i3.right.left = i3, n2(t5, a3.key) && (this._minimum = i3);
    } else i3.left = i3, i3.right = i3, this._minimum = i3;
    return this._size++, i3;
  }, a2.prototype.size = function() {
    return this._size;
  }, a2.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, a2.prototype.isEmpty = function() {
    return this._size === 0;
  }, a2.prototype.extractMinimum = function() {
    var t5 = this._minimum;
    if (t5 === null) return t5;
    for (var n3 = this._minimum, r3 = t5.degree, i3 = t5.child; r3 > 0; ) {
      var a3 = i3.right;
      i3.left.right = i3.right, i3.right.left = i3.left, i3.left = n3, i3.right = n3.right, n3.right = i3, i3.right.left = i3, i3.parent = null, i3 = a3, r3--;
    }
    return t5.left.right = t5.right, t5.right.left = t5.left, t5 === t5.right ? n3 = null : (n3 = t5.right, n3 = u2(n3, this._size)), this._size--, this._minimum = n3, t5;
  }, a2.prototype.remove = function(t5) {
    this._minimum = o2(this._minimum, t5, -1), this.extractMinimum();
  };
  function o2(t5, r3, i3) {
    r3.key = i3;
    var a3 = r3.parent;
    return a3 && n2(r3.key, a3.key) && (s2(t5, r3, a3), c2(t5, a3)), n2(r3.key, t5.key) && (t5 = r3), t5;
  }
  function s2(t5, n3, r3) {
    n3.left.right = n3.right, n3.right.left = n3.left, r3.degree--, r3.child === n3 && (r3.child = n3.right), r3.degree === 0 && (r3.child = null), n3.left = t5, n3.right = t5.right, t5.right = n3, n3.right.left = n3, n3.parent = null, n3.mark = false;
  }
  function c2(t5, n3) {
    var r3 = n3.parent;
    r3 && (n3.mark ? (s2(t5, n3, r3), c2(r3)) : n3.mark = true);
  }
  var l2 = function(t5, n3) {
    t5.left.right = t5.right, t5.right.left = t5.left, t5.parent = n3, n3.child ? (t5.left = n3.child, t5.right = n3.child.right, n3.child.right = t5, t5.right.left = t5) : (n3.child = t5, t5.right = t5, t5.left = t5), n3.degree++, t5.mark = false;
  };
  function u2(t5, a3) {
    var o3 = Math.floor(Math.log(a3) * i2) + 1, s3 = Array(o3), c3 = 0, u3 = t5;
    if (u3) for (c3++, u3 = u3.right; u3 !== t5; ) c3++, u3 = u3.right;
    for (var d2; c3 > 0; ) {
      for (var p2 = u3.degree, m2 = u3.right; d2 = s3[p2], d2; ) {
        if (r2(u3.key, d2.key)) {
          var h2 = d2;
          d2 = u3, u3 = h2;
        }
        l2(d2, u3), s3[p2] = null, p2++;
      }
      s3[p2] = u3, u3 = m2, c3--;
    }
    t5 = null;
    for (var g2 = 0; g2 < o3; g2++) d2 = s3[g2], d2 && (t5 ? (d2.left.right = d2.right, d2.right.left = d2.left, d2.left = t5, d2.right = t5.right, t5.right = d2, d2.right.left = d2, n2(d2.key, t5.key) && (t5 = d2)) : t5 = d2);
    return t5;
  }
  return a2;
}, { isClass: true }), name$158$2 = `Spa`, dependencies$158$2 = [`addScalar`, `equalScalar`, `FibonacciHeap`], createSpaClass$2 = factory$2(name$158$2, dependencies$158$2, (t4) => {
  var { addScalar: n2, equalScalar: r2, FibonacciHeap: i2 } = t4;
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._values = [], this._heap = new i2();
  }
  return a2.prototype.type = `Spa`, a2.prototype.isSpa = true, a2.prototype.set = function(t5, n3) {
    if (this._values[t5]) this._values[t5].value = n3;
    else {
      var r3 = this._heap.insert(t5, n3);
      this._values[t5] = r3;
    }
  }, a2.prototype.get = function(t5) {
    var n3 = this._values[t5];
    return n3 ? n3.value : 0;
  }, a2.prototype.accumulate = function(t5, r3) {
    var i3 = this._values[t5];
    i3 ? i3.value = n2(i3.value, r3) : (i3 = this._heap.insert(t5, r3), this._values[t5] = i3);
  }, a2.prototype.forEach = function(t5, n3, i3) {
    var a3 = this._heap, o2 = this._values, s2 = [], c2 = a3.extractMinimum();
    for (c2 && s2.push(c2); c2 && c2.key <= n3; ) c2.key >= t5 && (r2(c2.value, 0) || i3(c2.key, c2.value, this)), c2 = a3.extractMinimum(), c2 && s2.push(c2);
    for (var l2 = 0; l2 < s2.length; l2++) {
      var u2 = s2[l2];
      c2 = a3.insert(u2.key, u2.value), o2[c2.key] = c2;
    }
  }, a2.prototype.swap = function(t5, n3) {
    var r3 = this._values[t5], i3 = this._values[n3];
    if (!r3 && i3) r3 = this._heap.insert(t5, i3.value), this._heap.remove(i3), this._values[t5] = r3, this._values[n3] = void 0;
    else if (r3 && !i3) i3 = this._heap.insert(n3, r3.value), this._heap.remove(r3), this._values[n3] = i3, this._values[t5] = void 0;
    else if (r3 && i3) {
      var a3 = r3.value;
      r3.value = i3.value, i3.value = a3;
    }
  }, a2;
}, { isClass: true });
function lruQueue$2(t4) {
  var n2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null), o2 = 0, s2 = function(t5) {
    var s3 = a2[t5];
    if (s3 && (delete i2[s3], delete a2[t5], --n2, r2 === s3)) {
      if (!n2) {
        o2 = 0, r2 = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
    }
  };
  return t4 = Math.abs(t4), { hit: function(c2) {
    var l2 = a2[c2], u2 = ++o2;
    if (i2[u2] = c2, a2[c2] = u2, !l2) return ++n2, n2 <= t4 ? void 0 : (c2 = i2[r2], s2(c2), c2);
    if (delete i2[l2], r2 === l2) for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
  }, delete: s2, clear: function() {
    n2 = o2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1$2(t4) {
  var { hasher: n2, limit: r2 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return r2 ??= 1 / 0, n2 ??= JSON.stringify, function i2() {
    typeof i2.cache != `object` && (i2.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue$2(r2 || 1 / 0) });
    var a2 = [...arguments], o2 = n2(a2);
    if (i2.cache.values.has(o2)) return i2.cache.lru.hit(o2), i2.cache.values.get(o2);
    var s2 = t4.apply(t4, a2);
    return i2.cache.values.set(o2, s2), i2.cache.values.delete(i2.cache.lru.hit(o2)), s2;
  };
}
var createBigNumberE$2 = memoize$1$2(function(t4) {
  return new t4(1).exp();
}, { hasher: hasher$2 }), createBigNumberPhi$2 = memoize$1$2(function(t4) {
  return new t4(1).plus(new t4(5).sqrt()).div(2);
}, { hasher: hasher$2 }), createBigNumberPi$2 = memoize$1$2(function(t4) {
  return t4.acos(-1);
}, { hasher: hasher$2 }), createBigNumberTau$2 = memoize$1$2(function(t4) {
  return createBigNumberPi$2(t4).times(2);
}, { hasher: hasher$2 });
function hasher$2(t4) {
  return t4[0].precision;
}
function ownKeys$2$2(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$2$2(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$2$2(Object(r2), true).forEach(function(n3) {
      _defineProperty$4(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$2$2(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$157$2 = `Unit`, dependencies$157$2 = [`?on`, `config`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `abs`, `fix`, `round`, `equal`, `isNumeric`, `format`, `number`, `Complex`, `BigNumber`, `Fraction`], createUnitClass$2 = factory$2(name$157$2, dependencies$157$2, (t4) => {
  var { on: n2, config: r2, addScalar: i2, subtractScalar: a2, multiplyScalar: o2, divideScalar: s2, pow: c2, abs: l2, fix: u2, round: d2, equal: p2, isNumeric: m2, format: h2, number: g2, Complex: v2, BigNumber: y2, Fraction: b2 } = t4, x2 = g2, S2 = false, w2 = true;
  function E(t5, n3) {
    if (!(this instanceof E)) throw Error(`Constructor must be called with the new operator`);
    if (!(t5 == null || m2(t5) || isComplex$2(t5))) throw TypeError(`First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined`);
    if (this.fixPrefix = S2, this.skipAutomaticSimplification = w2, n3 === void 0) this.units = [], this.dimensions = ee2.map((t6) => 0);
    else if (typeof n3 == `string`) {
      var r3 = E.parse(n3);
      this.units = r3.units, this.dimensions = r3.dimensions;
    } else if (isUnit$2(n3) && n3.value === null) this.fixPrefix = n3.fixPrefix, this.skipAutomaticSimplification = n3.skipAutomaticSimplification, this.dimensions = n3.dimensions.slice(0), this.units = n3.units.map((t6) => _extends$5({}, t6));
    else throw TypeError(`Second parameter in Unit constructor must be a string or valueless Unit`);
    this.value = this._normalize(t5);
  }
  Object.defineProperty(E, "name", { value: `Unit` }), E.prototype.constructor = E, E.prototype.type = `Unit`, E.prototype.isUnit = true;
  var D, O2, j2;
  function M2() {
    for (; j2 === ` ` || j2 === `	`; ) I2();
  }
  function N2(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }
  function F(t5) {
    return t5 >= `0` && t5 <= `9`;
  }
  function I2() {
    O2++, j2 = D.charAt(O2);
  }
  function L2(t5) {
    O2 = t5, j2 = D.charAt(O2);
  }
  function R2() {
    var t5 = ``, n3 = O2;
    if (j2 === `+` ? I2() : j2 === `-` && (t5 += j2, I2()), !N2(j2)) return L2(n3), null;
    if (j2 === `.`) {
      if (t5 += j2, I2(), !F(j2)) return L2(n3), null;
    } else {
      for (; F(j2); ) t5 += j2, I2();
      j2 === `.` && (t5 += j2, I2());
    }
    for (; F(j2); ) t5 += j2, I2();
    if (j2 === `E` || j2 === `e`) {
      var r3 = ``, i3 = O2;
      if (r3 += j2, I2(), (j2 === `+` || j2 === `-`) && (r3 += j2, I2()), !F(j2)) return L2(i3), t5;
      for (t5 += r3; F(j2); ) t5 += j2, I2();
    }
    return t5;
  }
  function z2() {
    for (var t5 = ``; F(j2) || E.isValidAlpha(j2); ) t5 += j2, I2();
    var n3 = t5.charAt(0);
    return E.isValidAlpha(n3) ? t5 : null;
  }
  function V2(t5) {
    return j2 === t5 ? (I2(), t5) : null;
  }
  E.parse = function(t5, n3) {
    if (n3 ||= {}, D = t5, O2 = -1, j2 = ``, typeof D != `string`) throw TypeError(`Invalid argument in Unit.parse, string expected`);
    var i3 = new E();
    i3.units = [];
    var a3 = 1, o3 = false;
    I2(), M2();
    var s3 = R2(), c3 = null;
    if (s3) {
      if (r2.number === `BigNumber`) c3 = new y2(s3);
      else if (r2.number === `Fraction`) try {
        c3 = new b2(s3);
      } catch {
        c3 = parseFloat(s3);
      }
      else c3 = parseFloat(s3);
      M2(), V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) && (a3 = -1, o3 = true);
    }
    for (var l3 = [], u3 = 1; ; ) {
      for (M2(); j2 === `(`; ) l3.push(a3), u3 *= a3, a3 = 1, I2(), M2();
      var d3 = void 0;
      if (j2) {
        var p3 = j2;
        if (d3 = z2(), d3 === null) throw SyntaxError(`Unexpected "` + p3 + `" in "` + D + `" at index ` + O2.toString());
      } else break;
      var m3 = H2(d3);
      if (m3 === null) throw SyntaxError(`Unit "` + d3 + `" not found.`);
      var h3 = a3 * u3;
      if (M2(), V2(`^`)) {
        M2();
        var g3 = R2();
        if (g3 === null) throw SyntaxError(`In "` + t5 + `", "^" must be followed by a floating-point number`);
        h3 *= g3;
      }
      i3.units.push({ unit: m3.unit, prefix: m3.prefix, power: h3 });
      for (var v3 = 0; v3 < ee2.length; v3++) i3.dimensions[v3] += (m3.unit.dimensions[v3] || 0) * h3;
      for (M2(); j2 === `)`; ) {
        if (l3.length === 0) throw SyntaxError(`Unmatched ")" in "` + D + `" at index ` + O2.toString());
        u3 /= l3.pop(), I2(), M2();
      }
      if (o3 = false, V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) ? (a3 = -1, o3 = true) : a3 = 1, m3.unit.base) {
        var x3 = m3.unit.base.key;
        Z2.auto[x3] = { unit: m3.unit, prefix: m3.prefix };
      }
    }
    if (M2(), j2) throw SyntaxError(`Could not parse: "` + t5 + `"`);
    if (o3) throw SyntaxError(`Trailing characters: "` + t5 + `"`);
    if (l3.length !== 0) throw SyntaxError(`Unmatched "(" in "` + D + `"`);
    if (i3.units.length === 0 && !n3.allowNoUnits) throw SyntaxError(`"` + t5 + `" contains no units`);
    return i3.value = c3 === void 0 ? null : i3._normalize(c3), i3;
  }, E.prototype.clone = function() {
    var t5 = new E();
    t5.fixPrefix = this.fixPrefix, t5.skipAutomaticSimplification = this.skipAutomaticSimplification, t5.value = clone$3$2(this.value), t5.dimensions = this.dimensions.slice(0), t5.units = [];
    for (var n3 = 0; n3 < this.units.length; n3++) for (var r3 in t5.units[n3] = {}, this.units[n3]) hasOwnProperty$1$4(this.units[n3], r3) && (t5.units[n3][r3] = this.units[n3][r3]);
    return t5;
  }, E.prototype.valueType = function() {
    return typeOf$2(this.value);
  }, E.prototype._isDerived = function() {
    return this.units.length === 0 ? false : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, E.prototype._normalize = function(t5) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var n3 = t5, r3 = E._getNumberConverter(typeOf$2(t5)), i3 = 0; i3 < this.units.length; i3++) {
      var a3 = r3(this.units[i3].unit.value), s3 = r3(this.units[i3].prefix.value), l3 = r3(this.units[i3].power);
      n3 = o2(n3, c2(o2(a3, s3), l3));
    }
    return n3;
  }, E.prototype._denormalize = function(t5, n3) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var r3 = t5, i3 = E._getNumberConverter(typeOf$2(t5)), a3 = 0; a3 < this.units.length; a3++) {
      var l3 = i3(this.units[a3].unit.value), u3 = i3(this.units[a3].prefix.value), d3 = i3(this.units[a3].power);
      r3 = s2(r3, c2(o2(l3, u3), d3));
    }
    return r3;
  };
  var H2 = memoize$1$2((t5) => {
    if (hasOwnProperty$1$4(X2, t5)) {
      var n3 = X2[t5];
      return { unit: n3, prefix: n3.prefixes[``] };
    }
    for (var r3 in X2) if (hasOwnProperty$1$4(X2, r3) && endsWith$2(t5, r3)) {
      var i3 = X2[r3], a3 = t5.length - r3.length, o3 = t5.substring(0, a3), s3 = hasOwnProperty$1$4(i3.prefixes, o3) ? i3.prefixes[o3] : void 0;
      if (s3 !== void 0) return { unit: i3, prefix: s3 };
    }
    return null;
  }, { hasher: (t5) => t5[0], limit: 100 });
  E.isValuelessUnit = function(t5) {
    return H2(t5) !== null;
  }, E.prototype.hasBase = function(t5) {
    if (typeof t5 == `string` && (t5 = Y2[t5]), !t5) return false;
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equalBase = function(t5) {
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equals = function(t5) {
    return this.equalBase(t5) && p2(this.value, t5.value);
  }, E.prototype.multiply = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit$2(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) + (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var s3 = _objectSpread$2$2({}, r3.units[a3]);
      n3.units.push(s3);
    }
    return this.value !== null || r3.value !== null ? n3.value = o2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit$2(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.divideInto = function(t5) {
    return new E(t5).divide(this);
  }, E.prototype.divide = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit$2(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) - (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var o3 = _objectSpread$2$2(_objectSpread$2$2({}, r3.units[a3]), {}, { power: -r3.units[a3].power });
      n3.units.push(o3);
    }
    return this.value !== null || r3.value !== null ? n3.value = s2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit$2(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.pow = function(t5) {
    for (var n3 = this.clone(), r3 = 0; r3 < ee2.length; r3++) n3.dimensions[r3] = (this.dimensions[r3] || 0) * t5;
    for (var i3 = 0; i3 < n3.units.length; i3++) n3.units[i3].power *= t5;
    return n3.value === null ? n3.value = null : n3.value = c2(n3.value, t5), n3.skipAutomaticSimplification = false, U2(n3);
  };
  function U2(t5) {
    return t5.equalBase(Y2.NONE) && t5.value !== null && !r2.predictable ? t5.value : t5;
  }
  function W2(t5) {
    return E._getNumberConverter(typeOf$2(t5))(1);
  }
  E.prototype.abs = function() {
    var t5 = this.clone();
    if (t5.value !== null) if (t5._isDerived() || t5.units.length === 0 || t5.units[0].unit.offset === 0) t5.value = l2(t5.value);
    else {
      var n3 = t5._numberConverter(), r3 = o2(n3(t5.units[0].unit.value), n3(t5.units[0].unit.offset));
      t5.value = a2(l2(i2(t5.value, r3)), r3);
    }
    for (var s3 in t5.units) (t5.units[s3].unit.name === `VA` || t5.units[s3].unit.name === `VAR`) && (t5.units[s3].unit = X2.W);
    return t5;
  }, E.prototype.to = function(t5) {
    var n3 = this.value === null ? this._normalize(1) : this.value, r3;
    if (typeof t5 == `string`) r3 = E.parse(t5);
    else if (isUnit$2(t5)) r3 = t5.clone();
    else throw Error(`String or Unit expected as parameter`);
    if (!this.equalBase(r3)) throw Error(`Units do not match ('${r3.toString()}' != '${this.toString()}')`);
    if (r3.value !== null) throw Error(`Cannot convert to a unit with a value`);
    if (this.value === null || this._isDerived() || this.units.length === 0 || r3.units.length === 0 || this.units[0].unit.offset === r3.units[0].unit.offset) r3.value = clone$3$2(n3);
    else {
      var s3 = E._getNumberConverter(typeOf$2(n3)), c3 = this.units[0].unit.value, l3 = this.units[0].unit.offset, u3 = o2(c3, l3), d3 = r3.units[0].unit.value, p3 = r3.units[0].unit.offset, m3 = o2(d3, p3);
      r3.value = i2(n3, s3(a2(u3, m3)));
    }
    return r3.fixPrefix = true, r3.skipAutomaticSimplification = true, r3;
  }, E.prototype.toNumber = function(t5) {
    return x2(this.toNumeric(t5));
  }, E.prototype.toNumeric = function(t5) {
    var n3 = t5 ? this.to(t5) : this.clone();
    return n3._isDerived() || n3.units.length === 0 ? n3._denormalize(n3.value) : n3._denormalize(n3.value, n3.units[0].prefix.value);
  }, E.prototype.toString = function() {
    return this.format();
  }, E.prototype.toJSON = function() {
    return { mathjs: `Unit`, value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, E.fromJSON = function(t5) {
    var a3 = new E(t5.value, t5.unit ?? void 0);
    return a3.fixPrefix = t5.fixPrefix ?? S2, a3.skipAutomaticSimplification = t5.skipSimp ?? w2, a3;
  }, E.prototype.valueOf = E.prototype.toString, E.prototype.simplify = function() {
    var t5 = this.clone(), n3 = [], r3;
    for (var i3 in oe2) if (hasOwnProperty$1$4(oe2, i3) && t5.hasBase(Y2[i3])) {
      r3 = i3;
      break;
    }
    if (r3 === `NONE`) t5.units = [];
    else {
      var a3;
      if (r3 && hasOwnProperty$1$4(oe2, r3) && (a3 = oe2[r3]), a3) t5.units = [{ unit: a3.unit, prefix: a3.prefix, power: 1 }];
      else {
        for (var o3 = false, s3 = 0; s3 < ee2.length; s3++) {
          var c3 = ee2[s3];
          Math.abs(t5.dimensions[s3] || 0) > 1e-12 && (hasOwnProperty$1$4(oe2, c3) ? n3.push({ unit: oe2[c3].unit, prefix: oe2[c3].prefix, power: t5.dimensions[s3] || 0 }) : o3 = true);
        }
        n3.length < t5.units.length && !o3 && (t5.units = n3);
      }
    }
    return t5;
  }, E.prototype.toSI = function() {
    for (var t5 = this.clone(), n3 = [], r3 = 0; r3 < ee2.length; r3++) {
      var i3 = ee2[r3];
      if (Math.abs(t5.dimensions[r3] || 0) > 1e-12) if (hasOwnProperty$1$4(Z2.si, i3)) n3.push({ unit: Z2.si[i3].unit, prefix: Z2.si[i3].prefix, power: t5.dimensions[r3] || 0 });
      else throw Error(`Cannot express custom unit ` + i3 + ` in SI units`);
    }
    return t5.units = n3, t5.fixPrefix = true, t5.skipAutomaticSimplification = true, this.value === null ? t5 : (t5.value = null, this.to(t5));
  }, E.prototype.formatUnits = function() {
    for (var t5 = ``, n3 = ``, r3 = 0, i3 = 0, a3 = 0; a3 < this.units.length; a3++) this.units[a3].power > 0 ? (r3++, t5 += ` ` + this.units[a3].prefix.name + this.units[a3].unit.name, Math.abs(this.units[a3].power - 1) > 1e-15 && (t5 += `^` + this.units[a3].power)) : this.units[a3].power < 0 && i3++;
    if (i3 > 0) for (var o3 = 0; o3 < this.units.length; o3++) this.units[o3].power < 0 && (r3 > 0 ? (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, Math.abs(this.units[o3].power + 1) > 1e-15 && (n3 += `^` + -this.units[o3].power)) : (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, n3 += `^` + this.units[o3].power));
    t5 = t5.substr(1), n3 = n3.substr(1), r3 > 1 && i3 > 0 && (t5 = `(` + t5 + `)`), i3 > 1 && r3 > 0 && (n3 = `(` + n3 + `)`);
    var s3 = t5;
    return r3 > 0 && i3 > 0 && (s3 += ` / `), s3 += n3, s3;
  }, E.prototype.toBest = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t5 && !Array.isArray(t5)) throw Error(`Invalid unit type. Expected string or Unit.`);
    var r3 = this.units[0].unit.prefixes;
    if (t5 && t5.length > 0) {
      var i3 = t5.map((t6) => {
        var n4 = null;
        if (typeof t6 == `string`) {
          if (n4 = E.parse(t6), !n4) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        } else if (!isUnit$2(t6)) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        n4 === null && (n4 = t6.clone());
        try {
          return this.to(n4.formatUnits()), n4;
        } catch {
          throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        }
      }).map((t6) => t6.units[0].prefix);
      this.units[0].unit.prefixes = i3.reduce((t6, n4) => (t6[n4.name] = n4, t6), {}), this.units[0].prefix = i3[0];
    }
    var a3 = G2(this, n3).simp;
    return this.units[0].unit.prefixes = r3, a3.fixPrefix = true, a3;
  }, E.prototype.format = function(t5) {
    var { simp: n3, valueStr: r3, unitStr: i3 } = G2(this, t5), a3 = r3;
    return n3.value && isComplex$2(n3.value) && (a3 = `(` + a3 + `)`), i3.length > 0 && a3.length > 0 && (a3 += ` `), a3 += i3, a3;
  };
  function G2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = t5.skipAutomaticSimplification || t5.value === null ? t5.clone() : t5.simplify();
    K2(r3), q2(r3, n3.offset);
    var i3 = r3._denormalize(r3.value);
    return { simp: r3, valueStr: r3.value === null ? `` : h2(i3, n3 || {}), unitStr: r3.formatUnits() };
  }
  function K2(t5) {
    var n3 = false;
    for (var r3 in t5.value !== void 0 && t5.value !== null && isComplex$2(t5.value) && (n3 = Math.abs(t5.value.re) < 1e-14), t5.units) hasOwnProperty$1$4(t5.units, r3) && t5.units[r3].unit && (t5.units[r3].unit.name === `VA` && n3 ? t5.units[r3].unit = X2.VAR : t5.units[r3].unit.name === `VAR` && !n3 && (t5.units[r3].unit = X2.VA));
  }
  function q2(t5, n3) {
    t5.units.length === 1 && !t5.fixPrefix && Math.abs(t5.units[0].power - Math.round(t5.units[0].power)) < 1e-14 && (t5.units[0].prefix = t5._bestPrefix(n3));
  }
  E.prototype._bestPrefix = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1.2;
    if (this.units.length !== 1 || Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw Error(`Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!`);
    var n3 = this.value === null ? 0 : l2(this.value), r3 = l2(this.units[0].unit.value), i3 = this.units[0].prefix;
    if (n3 === 0) return i3;
    var a3 = this.units[0].power, o3 = Math.log(n3 / (i3.value * r3) ** +a3) / Math.LN10 - t5;
    if (o3 > -2.200001 && o3 < 1.800001) return i3;
    o3 = Math.abs(o3);
    var s3 = this.units[0].unit.prefixes;
    for (var c3 in s3) if (hasOwnProperty$1$4(s3, c3)) {
      var u3 = s3[c3];
      if (u3.scientific) {
        var d3 = Math.abs(Math.log(n3 / (u3.value * r3) ** +a3) / Math.LN10 - t5);
        (d3 < o3 || d3 === o3 && u3.name.length < i3.name.length) && (i3 = u3, o3 = d3);
      }
    }
    return i3;
  }, E.prototype.splitUnit = function(t5) {
    for (var n3 = this.clone(), r3 = [], o3 = 0; o3 < t5.length && (n3 = n3.to(t5[o3]), o3 !== t5.length - 1); o3++) {
      var s3 = n3.toNumeric(), c3 = d2(s3), l3 = void 0;
      l3 = p2(c3, s3) ? c3 : u2(n3.toNumeric());
      var m3 = new E(l3, t5[o3].toString());
      r3.push(m3), n3 = a2(n3, m3);
    }
    for (var h3 = 0, g3 = 0; g3 < r3.length; g3++) h3 = i2(h3, r3[g3].value);
    return p2(h3, this.value) && (n3.value = 0), r3.push(n3), r3;
  };
  var J = { NONE: { "": { name: ``, value: 1, scientific: true } }, SHORT: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 10, scientific: false }, h: { name: `h`, value: 100, scientific: false }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true }, R: { name: `R`, value: 1e27, scientific: true }, Q: { name: `Q`, value: 1e30, scientific: true }, d: { name: `d`, value: 0.1, scientific: false }, c: { name: `c`, value: 0.01, scientific: false }, m: { name: `m`, value: 1e-3, scientific: true }, u: { name: `u`, value: 1e-6, scientific: true }, n: { name: `n`, value: 1e-9, scientific: true }, p: { name: `p`, value: 1e-12, scientific: true }, f: { name: `f`, value: 1e-15, scientific: true }, a: { name: `a`, value: 1e-18, scientific: true }, z: { name: `z`, value: 1e-21, scientific: true }, y: { name: `y`, value: 1e-24, scientific: true }, r: { name: `r`, value: 1e-27, scientific: true }, q: { name: `q`, value: 1e-30, scientific: true } }, LONG: { "": { name: ``, value: 1, scientific: true }, deca: { name: `deca`, value: 10, scientific: false }, hecto: { name: `hecto`, value: 100, scientific: false }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true }, ronna: { name: `ronna`, value: 1e27, scientific: true }, quetta: { name: `quetta`, value: 1e30, scientific: true }, deci: { name: `deci`, value: 0.1, scientific: false }, centi: { name: `centi`, value: 0.01, scientific: false }, milli: { name: `milli`, value: 1e-3, scientific: true }, micro: { name: `micro`, value: 1e-6, scientific: true }, nano: { name: `nano`, value: 1e-9, scientific: true }, pico: { name: `pico`, value: 1e-12, scientific: true }, femto: { name: `femto`, value: 1e-15, scientific: true }, atto: { name: `atto`, value: 1e-18, scientific: true }, zepto: { name: `zepto`, value: 1e-21, scientific: true }, yocto: { name: `yocto`, value: 1e-24, scientific: true }, ronto: { name: `ronto`, value: 1e-27, scientific: true }, quecto: { name: `quecto`, value: 1e-30, scientific: true } }, SQUARED: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 100, scientific: false }, h: { name: `h`, value: 1e4, scientific: false }, k: { name: `k`, value: 1e6, scientific: true }, M: { name: `M`, value: 1e12, scientific: true }, G: { name: `G`, value: 1e18, scientific: true }, T: { name: `T`, value: 1e24, scientific: true }, P: { name: `P`, value: 1e30, scientific: true }, E: { name: `E`, value: 1e36, scientific: true }, Z: { name: `Z`, value: 1e42, scientific: true }, Y: { name: `Y`, value: 1e48, scientific: true }, R: { name: `R`, value: 1e54, scientific: true }, Q: { name: `Q`, value: 1e60, scientific: true }, d: { name: `d`, value: 0.01, scientific: false }, c: { name: `c`, value: 1e-4, scientific: false }, m: { name: `m`, value: 1e-6, scientific: true }, u: { name: `u`, value: 1e-12, scientific: true }, n: { name: `n`, value: 1e-18, scientific: true }, p: { name: `p`, value: 1e-24, scientific: true }, f: { name: `f`, value: 1e-30, scientific: true }, a: { name: `a`, value: 1e-36, scientific: true }, z: { name: `z`, value: 1e-42, scientific: true }, y: { name: `y`, value: 1e-48, scientific: true }, r: { name: `r`, value: 1e-54, scientific: true }, q: { name: `q`, value: 1e-60, scientific: true } }, CUBIC: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 1e3, scientific: false }, h: { name: `h`, value: 1e6, scientific: false }, k: { name: `k`, value: 1e9, scientific: true }, M: { name: `M`, value: 1e18, scientific: true }, G: { name: `G`, value: 1e27, scientific: true }, T: { name: `T`, value: 1e36, scientific: true }, P: { name: `P`, value: 1e45, scientific: true }, E: { name: `E`, value: 1e54, scientific: true }, Z: { name: `Z`, value: 1e63, scientific: true }, Y: { name: `Y`, value: 1e72, scientific: true }, R: { name: `R`, value: 1e81, scientific: true }, Q: { name: `Q`, value: 1e90, scientific: true }, d: { name: `d`, value: 1e-3, scientific: false }, c: { name: `c`, value: 1e-6, scientific: false }, m: { name: `m`, value: 1e-9, scientific: true }, u: { name: `u`, value: 1e-18, scientific: true }, n: { name: `n`, value: 1e-27, scientific: true }, p: { name: `p`, value: 1e-36, scientific: true }, f: { name: `f`, value: 1e-45, scientific: true }, a: { name: `a`, value: 1e-54, scientific: true }, z: { name: `z`, value: 1e-63, scientific: true }, y: { name: `y`, value: 1e-72, scientific: true }, r: { name: `r`, value: 1e-81, scientific: true }, q: { name: `q`, value: 1e-90, scientific: true } }, BINARY_SHORT_SI: { "": { name: ``, value: 1, scientific: true }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true } }, BINARY_SHORT_IEC: { "": { name: ``, value: 1, scientific: true }, Ki: { name: `Ki`, value: 1024, scientific: true }, Mi: { name: `Mi`, value: 1024 ** 2, scientific: true }, Gi: { name: `Gi`, value: 1024 ** 3, scientific: true }, Ti: { name: `Ti`, value: 1024 ** 4, scientific: true }, Pi: { name: `Pi`, value: 1024 ** 5, scientific: true }, Ei: { name: `Ei`, value: 1024 ** 6, scientific: true }, Zi: { name: `Zi`, value: 1024 ** 7, scientific: true }, Yi: { name: `Yi`, value: 1024 ** 8, scientific: true } }, BINARY_LONG_SI: { "": { name: ``, value: 1, scientific: true }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true } }, BINARY_LONG_IEC: { "": { name: ``, value: 1, scientific: true }, kibi: { name: `kibi`, value: 1024, scientific: true }, mebi: { name: `mebi`, value: 1024 ** 2, scientific: true }, gibi: { name: `gibi`, value: 1024 ** 3, scientific: true }, tebi: { name: `tebi`, value: 1024 ** 4, scientific: true }, pebi: { name: `pebi`, value: 1024 ** 5, scientific: true }, exi: { name: `exi`, value: 1024 ** 6, scientific: true }, zebi: { name: `zebi`, value: 1024 ** 7, scientific: true }, yobi: { name: `yobi`, value: 1024 ** 8, scientific: true } }, BTU: { "": { name: ``, value: 1, scientific: true }, MM: { name: `MM`, value: 1e6, scientific: true } } };
  J.SHORTLONG = _extends$5({}, J.SHORT, J.LONG), J.BINARY_SHORT = _extends$5({}, J.BINARY_SHORT_SI, J.BINARY_SHORT_IEC), J.BINARY_LONG = _extends$5({}, J.BINARY_LONG_SI, J.BINARY_LONG_IEC);
  var ee2 = [`MASS`, `LENGTH`, `TIME`, `CURRENT`, `TEMPERATURE`, `LUMINOUS_INTENSITY`, `AMOUNT_OF_SUBSTANCE`, `ANGLE`, `BIT`], Y2 = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var te2 in Y2) hasOwnProperty$1$4(Y2, te2) && (Y2[te2].key = te2);
  var ne2 = { name: ``, base: {}, value: 1, offset: 0, dimensions: ee2.map((t5) => 0) }, X2 = { meter: { name: `meter`, base: Y2.LENGTH, prefixes: J.LONG, value: 1, offset: 0 }, inch: { name: `inch`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, foot: { name: `foot`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yard: { name: `yard`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mile: { name: `mile`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, link: { name: `link`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rod: { name: `rod`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.0292, offset: 0 }, chain: { name: `chain`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, angstrom: { name: `angstrom`, base: Y2.LENGTH, prefixes: J.NONE, value: 1e-10, offset: 0 }, m: { name: `m`, base: Y2.LENGTH, prefixes: J.SHORT, value: 1, offset: 0 }, in: { name: `in`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, ft: { name: `ft`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yd: { name: `yd`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mi: { name: `mi`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, li: { name: `li`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rd: { name: `rd`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.02921, offset: 0 }, ch: { name: `ch`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, mil: { name: `mil`, base: Y2.LENGTH, prefixes: J.NONE, value: 254e-7, offset: 0 }, m2: { name: `m2`, base: Y2.SURFACE, prefixes: J.SQUARED, value: 1, offset: 0 }, sqin: { name: `sqin`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-8, offset: 0 }, sqft: { name: `sqft`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: `sqyd`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: `sqmi`, base: Y2.SURFACE, prefixes: J.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: `sqrd`, base: Y2.SURFACE, prefixes: J.NONE, value: 25.29295, offset: 0 }, sqch: { name: `sqch`, base: Y2.SURFACE, prefixes: J.NONE, value: 404.6873, offset: 0 }, sqmil: { name: `sqmil`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-14, offset: 0 }, acre: { name: `acre`, base: Y2.SURFACE, prefixes: J.NONE, value: 4046.86, offset: 0 }, hectare: { name: `hectare`, base: Y2.SURFACE, prefixes: J.NONE, value: 1e4, offset: 0 }, m3: { name: `m3`, base: Y2.VOLUME, prefixes: J.CUBIC, value: 1, offset: 0 }, L: { name: `L`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, l: { name: `l`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, litre: { name: `litre`, base: Y2.VOLUME, prefixes: J.LONG, value: 1e-3, offset: 0 }, cuin: { name: `cuin`, base: Y2.VOLUME, prefixes: J.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: `cuft`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: `cuyd`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: `teaspoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: `tablespoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 15e-6, offset: 0 }, drop: { name: `drop`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, gtt: { name: `gtt`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, minim: { name: `minim`, base: Y2.VOLUME, prefixes: J.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: `fluiddram`, base: Y2.VOLUME, prefixes: J.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: `fluidounce`, base: Y2.VOLUME, prefixes: J.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: `gill`, base: Y2.VOLUME, prefixes: J.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: `cc`, base: Y2.VOLUME, prefixes: J.NONE, value: 1e-6, offset: 0 }, cup: { name: `cup`, base: Y2.VOLUME, prefixes: J.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: `pint`, base: Y2.VOLUME, prefixes: J.NONE, value: 473176473e-12, offset: 0 }, quart: { name: `quart`, base: Y2.VOLUME, prefixes: J.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: `gallon`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: `beerbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: `oilbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: `hogshead`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.238480942392, offset: 0 }, g: { name: `g`, base: Y2.MASS, prefixes: J.SHORT, value: 1e-3, offset: 0 }, gram: { name: `gram`, base: Y2.MASS, prefixes: J.LONG, value: 1e-3, offset: 0 }, ton: { name: `ton`, base: Y2.MASS, prefixes: J.SHORT, value: 907.18474, offset: 0 }, t: { name: `t`, base: Y2.MASS, prefixes: J.SHORT, value: 1e3, offset: 0 }, tonne: { name: `tonne`, base: Y2.MASS, prefixes: J.LONG, value: 1e3, offset: 0 }, grain: { name: `grain`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dram: { name: `dram`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: `ounce`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: `poundmass`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: `hundredweight`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, stick: { name: `stick`, base: Y2.MASS, prefixes: J.NONE, value: 0.115, offset: 0 }, stone: { name: `stone`, base: Y2.MASS, prefixes: J.NONE, value: 6.35029318, offset: 0 }, gr: { name: `gr`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dr: { name: `dr`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: `oz`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: `lbm`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, cwt: { name: `cwt`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, s: { name: `s`, base: Y2.TIME, prefixes: J.SHORT, value: 1, offset: 0 }, min: { name: `min`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, h: { name: `h`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, second: { name: `second`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, sec: { name: `sec`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, minute: { name: `minute`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, hour: { name: `hour`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, day: { name: `day`, base: Y2.TIME, prefixes: J.NONE, value: 86400, offset: 0 }, week: { name: `week`, base: Y2.TIME, prefixes: J.NONE, value: 7 * 86400, offset: 0 }, month: { name: `month`, base: Y2.TIME, prefixes: J.NONE, value: 2629800, offset: 0 }, year: { name: `year`, base: Y2.TIME, prefixes: J.NONE, value: 31557600, offset: 0 }, decade: { name: `decade`, base: Y2.TIME, prefixes: J.NONE, value: 315576e3, offset: 0 }, century: { name: `century`, base: Y2.TIME, prefixes: J.NONE, value: 315576e4, offset: 0 }, millennium: { name: `millennium`, base: Y2.TIME, prefixes: J.NONE, value: 315576e5, offset: 0 }, hertz: { name: `Hertz`, base: Y2.FREQUENCY, prefixes: J.LONG, value: 1, offset: 0, reciprocal: true }, Hz: { name: `Hz`, base: Y2.FREQUENCY, prefixes: J.SHORT, value: 1, offset: 0, reciprocal: true }, rad: { name: `rad`, base: Y2.ANGLE, prefixes: J.SHORT, value: 1, offset: 0 }, radian: { name: `radian`, base: Y2.ANGLE, prefixes: J.LONG, value: 1, offset: 0 }, deg: { name: `deg`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, degree: { name: `degree`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, grad: { name: `grad`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, gradian: { name: `gradian`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, cycle: { name: `cycle`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcsec: { name: `arcsec`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcmin: { name: `arcmin`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, A: { name: `A`, base: Y2.CURRENT, prefixes: J.SHORT, value: 1, offset: 0 }, ampere: { name: `ampere`, base: Y2.CURRENT, prefixes: J.LONG, value: 1, offset: 0 }, K: { name: `K`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 0 }, degC: { name: `degC`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 273.15 }, degF: { name: `degF`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 459.67 }, degR: { name: `degR`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 0 }, kelvin: { name: `kelvin`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 0 }, celsius: { name: `celsius`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: `fahrenheit`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 459.67 }, rankine: { name: `rankine`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 0 }, mol: { name: `mol`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, mole: { name: `mole`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.LONG, value: 1, offset: 0 }, cd: { name: `cd`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, candela: { name: `candela`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.LONG, value: 1, offset: 0 }, N: { name: `N`, base: Y2.FORCE, prefixes: J.SHORT, value: 1, offset: 0 }, newton: { name: `newton`, base: Y2.FORCE, prefixes: J.LONG, value: 1, offset: 0 }, dyn: { name: `dyn`, base: Y2.FORCE, prefixes: J.SHORT, value: 1e-5, offset: 0 }, dyne: { name: `dyne`, base: Y2.FORCE, prefixes: J.LONG, value: 1e-5, offset: 0 }, lbf: { name: `lbf`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: `poundforce`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: `kip`, base: Y2.FORCE, prefixes: J.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: `kilogramforce`, base: Y2.FORCE, prefixes: J.NONE, value: 9.80665, offset: 0 }, J: { name: `J`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1, offset: 0 }, joule: { name: `joule`, base: Y2.ENERGY, prefixes: J.LONG, value: 1, offset: 0 }, erg: { name: `erg`, base: Y2.ENERGY, prefixes: J.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: `Wh`, base: Y2.ENERGY, prefixes: J.SHORT, value: 3600, offset: 0 }, BTU: { name: `BTU`, base: Y2.ENERGY, prefixes: J.BTU, value: 1055.05585262, offset: 0 }, eV: { name: `eV`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: `electronvolt`, base: Y2.ENERGY, prefixes: J.LONG, value: 1602176565e-28, offset: 0 }, W: { name: `W`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, watt: { name: `watt`, base: Y2.POWER, prefixes: J.LONG, value: 1, offset: 0 }, hp: { name: `hp`, base: Y2.POWER, prefixes: J.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: `VAR`, base: Y2.POWER, prefixes: J.SHORT, value: v2.I, offset: 0 }, VA: { name: `VA`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, Pa: { name: `Pa`, base: Y2.PRESSURE, prefixes: J.SHORT, value: 1, offset: 0 }, psi: { name: `psi`, base: Y2.PRESSURE, prefixes: J.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: `atm`, base: Y2.PRESSURE, prefixes: J.NONE, value: 101325, offset: 0 }, bar: { name: `bar`, base: Y2.PRESSURE, prefixes: J.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: `torr`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmHg: { name: `mmHg`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmH2O: { name: `mmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: `cmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 98.0665, offset: 0 }, coulomb: { name: `coulomb`, base: Y2.ELECTRIC_CHARGE, prefixes: J.LONG, value: 1, offset: 0 }, C: { name: `C`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 1, offset: 0 }, Ah: { name: `Ah`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 3600, offset: 0 }, farad: { name: `farad`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.LONG, value: 1, offset: 0 }, F: { name: `F`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.SHORT, value: 1, offset: 0 }, volt: { name: `volt`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.LONG, value: 1, offset: 0 }, V: { name: `V`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.SHORT, value: 1, offset: 0 }, ohm: { name: `ohm`, base: Y2.ELECTRIC_RESISTANCE, prefixes: J.SHORTLONG, value: 1, offset: 0 }, henry: { name: `henry`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, H: { name: `H`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, siemens: { name: `siemens`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, S: { name: `S`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, weber: { name: `weber`, base: Y2.MAGNETIC_FLUX, prefixes: J.LONG, value: 1, offset: 0 }, Wb: { name: `Wb`, base: Y2.MAGNETIC_FLUX, prefixes: J.SHORT, value: 1, offset: 0 }, tesla: { name: `tesla`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.LONG, value: 1, offset: 0 }, T: { name: `T`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, b: { name: `b`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: `bits`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 1, offset: 0 }, B: { name: `B`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: `bytes`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 8, offset: 0 } }, ie2 = { meters: `meter`, inches: `inch`, feet: `foot`, yards: `yard`, miles: `mile`, links: `link`, rods: `rod`, chains: `chain`, angstroms: `angstrom`, lt: `l`, litres: `litre`, liter: `litre`, liters: `litre`, teaspoons: `teaspoon`, tablespoons: `tablespoon`, minims: `minim`, fldr: `fluiddram`, fluiddrams: `fluiddram`, floz: `fluidounce`, fluidounces: `fluidounce`, gi: `gill`, gills: `gill`, cp: `cup`, cups: `cup`, pt: `pint`, pints: `pint`, qt: `quart`, quarts: `quart`, gal: `gallon`, gallons: `gallon`, bbl: `beerbarrel`, beerbarrels: `beerbarrel`, obl: `oilbarrel`, oilbarrels: `oilbarrel`, hogsheads: `hogshead`, gtts: `gtt`, grams: `gram`, tons: `ton`, tonnes: `tonne`, grains: `grain`, drams: `dram`, ounces: `ounce`, poundmasses: `poundmass`, hundredweights: `hundredweight`, sticks: `stick`, lb: `lbm`, lbs: `lbm`, kips: `kip`, kgf: `kilogramforce`, acres: `acre`, hectares: `hectare`, sqfeet: `sqft`, sqyard: `sqyd`, sqmile: `sqmi`, sqmiles: `sqmi`, mmhg: `mmHg`, mmh2o: `mmH2O`, cmh2o: `cmH2O`, seconds: `second`, secs: `second`, minutes: `minute`, mins: `minute`, hours: `hour`, hr: `hour`, hrs: `hour`, days: `day`, weeks: `week`, months: `month`, years: `year`, decades: `decade`, centuries: `century`, millennia: `millennium`, hertz: `hertz`, radians: `radian`, degrees: `degree`, gradians: `gradian`, cycles: `cycle`, arcsecond: `arcsec`, arcseconds: `arcsec`, arcminute: `arcmin`, arcminutes: `arcmin`, BTUs: `BTU`, watts: `watt`, joules: `joule`, amperes: `ampere`, amps: `ampere`, amp: `ampere`, coulombs: `coulomb`, volts: `volt`, ohms: `ohm`, farads: `farad`, webers: `weber`, teslas: `tesla`, electronvolts: `electronvolt`, moles: `mole`, bit: `bits`, byte: `bytes` };
  function ae2(t5) {
    if (t5.number === `BigNumber`) {
      var n3 = createBigNumberPi$2(y2);
      X2.rad.value = new y2(1), X2.deg.value = n3.div(180), X2.grad.value = n3.div(200), X2.cycle.value = n3.times(2), X2.arcsec.value = n3.div(648e3), X2.arcmin.value = n3.div(10800);
    } else X2.rad.value = 1, X2.deg.value = Math.PI / 180, X2.grad.value = Math.PI / 200, X2.cycle.value = Math.PI * 2, X2.arcsec.value = Math.PI / 648e3, X2.arcmin.value = Math.PI / 10800;
    X2.radian.value = X2.rad.value, X2.degree.value = X2.deg.value, X2.gradian.value = X2.grad.value;
  }
  ae2(r2), n2 && n2(`config`, function(t5, n3) {
    t5.number !== n3.number && ae2(t5);
  });
  var Z2 = { si: { NONE: { unit: ne2, prefix: J.NONE[``] }, LENGTH: { unit: X2.m, prefix: J.SHORT[``] }, MASS: { unit: X2.g, prefix: J.SHORT.k }, TIME: { unit: X2.s, prefix: J.SHORT[``] }, CURRENT: { unit: X2.A, prefix: J.SHORT[``] }, TEMPERATURE: { unit: X2.K, prefix: J.SHORT[``] }, LUMINOUS_INTENSITY: { unit: X2.cd, prefix: J.SHORT[``] }, AMOUNT_OF_SUBSTANCE: { unit: X2.mol, prefix: J.SHORT[``] }, ANGLE: { unit: X2.rad, prefix: J.SHORT[``] }, BIT: { unit: X2.bits, prefix: J.SHORT[``] }, FORCE: { unit: X2.N, prefix: J.SHORT[``] }, ENERGY: { unit: X2.J, prefix: J.SHORT[``] }, POWER: { unit: X2.W, prefix: J.SHORT[``] }, PRESSURE: { unit: X2.Pa, prefix: J.SHORT[``] }, ELECTRIC_CHARGE: { unit: X2.C, prefix: J.SHORT[``] }, ELECTRIC_CAPACITANCE: { unit: X2.F, prefix: J.SHORT[``] }, ELECTRIC_POTENTIAL: { unit: X2.V, prefix: J.SHORT[``] }, ELECTRIC_RESISTANCE: { unit: X2.ohm, prefix: J.SHORT[``] }, ELECTRIC_INDUCTANCE: { unit: X2.H, prefix: J.SHORT[``] }, ELECTRIC_CONDUCTANCE: { unit: X2.S, prefix: J.SHORT[``] }, MAGNETIC_FLUX: { unit: X2.Wb, prefix: J.SHORT[``] }, MAGNETIC_FLUX_DENSITY: { unit: X2.T, prefix: J.SHORT[``] }, FREQUENCY: { unit: X2.Hz, prefix: J.SHORT[``] } } };
  Z2.cgs = JSON.parse(JSON.stringify(Z2.si)), Z2.cgs.LENGTH = { unit: X2.m, prefix: J.SHORT.c }, Z2.cgs.MASS = { unit: X2.g, prefix: J.SHORT[``] }, Z2.cgs.FORCE = { unit: X2.dyn, prefix: J.SHORT[``] }, Z2.cgs.ENERGY = { unit: X2.erg, prefix: J.NONE[``] }, Z2.us = JSON.parse(JSON.stringify(Z2.si)), Z2.us.LENGTH = { unit: X2.ft, prefix: J.NONE[``] }, Z2.us.MASS = { unit: X2.lbm, prefix: J.NONE[``] }, Z2.us.TEMPERATURE = { unit: X2.degF, prefix: J.NONE[``] }, Z2.us.FORCE = { unit: X2.lbf, prefix: J.NONE[``] }, Z2.us.ENERGY = { unit: X2.BTU, prefix: J.BTU[``] }, Z2.us.POWER = { unit: X2.hp, prefix: J.NONE[``] }, Z2.us.PRESSURE = { unit: X2.psi, prefix: J.NONE[``] }, Z2.auto = JSON.parse(JSON.stringify(Z2.si));
  var oe2 = Z2.auto;
  for (var $2 in E.setUnitSystem = function(t5) {
    if (hasOwnProperty$1$4(Z2, t5)) oe2 = Z2[t5];
    else throw Error(`Unit system ` + t5 + ` does not exist. Choices are: ` + Object.keys(Z2).join(`, `));
  }, E.getUnitSystem = function() {
    for (var t5 in Z2) if (hasOwnProperty$1$4(Z2, t5) && Z2[t5] === oe2) return t5;
  }, E.typeConverters = { BigNumber: function(t5) {
    return t5 != null && t5.isFraction ? new y2(String(t5.n)).div(String(t5.d)).times(String(t5.s)) : new y2(t5 + ``);
  }, Fraction: function(t5) {
    return new b2(t5);
  }, Complex: function(t5) {
    return t5;
  }, number: function(t5) {
    return t5 != null && t5.isFraction ? g2(t5) : t5;
  } }, E.prototype._numberConverter = function() {
    var t5 = E.typeConverters[this.valueType()];
    if (t5) return t5;
    throw TypeError(`Unsupported Unit value type "` + this.valueType() + `"`);
  }, E._getNumberConverter = function(t5) {
    if (!E.typeConverters[t5]) throw TypeError(`Unsupported type "` + t5 + `"`);
    return E.typeConverters[t5];
  }, X2) if (hasOwnProperty$1$4(X2, $2)) {
    var se2 = X2[$2];
    se2.dimensions = se2.base.dimensions;
  }
  for (var ce2 in ie2) if (hasOwnProperty$1$4(ie2, ce2)) {
    var le2 = X2[ie2[ce2]], ue2 = {};
    for (var de2 in le2) hasOwnProperty$1$4(le2, de2) && (ue2[de2] = le2[de2]);
    ue2.name = ce2, X2[ce2] = ue2;
  }
  E.isValidAlpha = function(t5) {
    return /^[a-zA-Z]$/.test(t5);
  };
  function fe2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      if (j2 = t5.charAt(n3), n3 === 0 && !E.isValidAlpha(j2)) throw Error(`Invalid unit name (must begin with alpha character): "` + t5 + `"`);
      if (n3 > 0 && !(E.isValidAlpha(j2) || F(j2))) throw Error(`Invalid unit name (only alphanumeric characters are allowed): "` + t5 + `"`);
    }
  }
  return E.createUnit = function(t5, n3) {
    if (typeof t5 != `object`) throw TypeError(`createUnit expects first parameter to be of type 'Object'`);
    if (n3 && n3.override) {
      for (var r3 in t5) if (hasOwnProperty$1$4(t5, r3) && E.deleteUnit(r3), t5[r3].aliases) for (var i3 = 0; i3 < t5[r3].aliases.length; i3++) E.deleteUnit(t5[r3].aliases[i3]);
    }
    var a3;
    for (var o3 in t5) hasOwnProperty$1$4(t5, o3) && (a3 = E.createUnitSingle(o3, t5[o3]));
    return a3;
  }, E.createUnitSingle = function(t5, n3) {
    if (n3 ??= {}, typeof t5 != `string`) throw TypeError(`createUnitSingle expects first parameter to be of type 'string'`);
    if (hasOwnProperty$1$4(X2, t5)) throw Error(`Cannot create unit "` + t5 + `": a unit with that name already exists`);
    fe2(t5);
    var r3 = null, i3 = [], a3 = 0, o3, s3, c3;
    if (n3 && n3.type === `Unit`) r3 = n3.clone();
    else if (typeof n3 == `string`) n3 !== `` && (o3 = n3);
    else if (typeof n3 == `object`) o3 = n3.definition, s3 = n3.prefixes, a3 = n3.offset, c3 = n3.baseName, n3.aliases && (i3 = n3.aliases.valueOf());
    else throw TypeError(`Cannot create unit "` + t5 + `" from "` + n3.toString() + `": expecting "string" or "Unit" or "Object"`);
    if (i3) {
      for (var l3 = 0; l3 < i3.length; l3++) if (hasOwnProperty$1$4(X2, i3[l3])) throw Error(`Cannot create alias "` + i3[l3] + `": a unit with that name already exists`);
    }
    if (o3 && typeof o3 == `string` && !r3) try {
      r3 = E.parse(o3, { allowNoUnits: true });
    } catch (n4) {
      throw n4.message = `Could not create unit "` + t5 + `" from "` + o3 + `": ` + n4.message, n4;
    }
    else o3 && o3.type === `Unit` && (r3 = o3.clone());
    i3 ||= [], a3 ||= 0, s3 = s3 && s3.toUpperCase && J[s3.toUpperCase()] || J.NONE;
    var u3 = {};
    if (r3) {
      u3 = { name: t5, value: r3.value, dimensions: r3.dimensions.slice(0), prefixes: s3, offset: a3 };
      var d3 = false;
      for (var p3 in Y2) if (hasOwnProperty$1$4(Y2, p3)) {
        for (var m3 = true, h3 = 0; h3 < ee2.length; h3++) if (Math.abs((u3.dimensions[h3] || 0) - (Y2[p3].dimensions[h3] || 0)) > 1e-12) {
          m3 = false;
          break;
        }
        if (m3) {
          d3 = true, u3.base = Y2[p3];
          break;
        }
      }
      if (!d3) {
        c3 ||= t5 + `_STUFF`;
        var g3 = { dimensions: r3.dimensions.slice(0) };
        g3.key = c3, Y2[c3] = g3, oe2[c3] = { unit: u3, prefix: J.NONE[``] }, u3.base = Y2[c3];
      }
    } else {
      if (c3 ||= t5 + `_STUFF`, ee2.indexOf(c3) >= 0) throw Error(`Cannot create new base unit "` + t5 + `": a base unit with that name already exists (and cannot be overridden)`);
      for (var v3 in ee2.push(c3), Y2) hasOwnProperty$1$4(Y2, v3) && (Y2[v3].dimensions[ee2.length - 1] = 0);
      for (var y3 = { dimensions: [] }, b3 = 0; b3 < ee2.length; b3++) y3.dimensions[b3] = 0;
      y3.dimensions[ee2.length - 1] = 1, y3.key = c3, Y2[c3] = y3, u3 = { name: t5, value: 1, dimensions: Y2[c3].dimensions.slice(0), prefixes: s3, offset: a3, base: Y2[c3] }, oe2[c3] = { unit: u3, prefix: J.NONE[``] };
    }
    E.UNITS[t5] = u3;
    for (var x3 = 0; x3 < i3.length; x3++) {
      var S3 = i3[x3], w3 = {};
      for (var D2 in u3) hasOwnProperty$1$4(u3, D2) && (w3[D2] = u3[D2]);
      w3.name = S3, E.UNITS[S3] = w3;
    }
    return delete H2.cache, new E(null, t5);
  }, E.deleteUnit = function(t5) {
    delete E.UNITS[t5], delete H2.cache;
  }, E.PREFIXES = J, E.BASE_DIMENSIONS = ee2, E.BASE_UNITS = Y2, E.UNIT_SYSTEMS = Z2, E.UNITS = X2, E;
}, { isClass: true }), name$156$2 = `unit`, dependencies$156$2 = [`typed`, `Unit`], createUnitFunction$2 = factory$2(name$156$2, dependencies$156$2, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$156$2, { Unit: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2.isValuelessUnit(t5) ? new r2(null, t5) : r2.parse(t5, { allowNoUnits: true });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(t5, n3) {
    return new r2(t5, n3);
  }, "number | BigNumber | Fraction": function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$155$2 = `sparse`, dependencies$155$2 = [`typed`, `SparseMatrix`], createSparse$2 = factory$2(name$155$2, dependencies$155$2, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return n2(name$155$2, { "": function() {
    return new r2([]);
  }, string: function(t5) {
    return new r2([], t5);
  }, "Array | Matrix": function(t5) {
    return new r2(t5);
  }, "Array | Matrix, string": function(t5, n3) {
    return new r2(t5, n3);
  } });
}), name$154$2 = `createUnit`, dependencies$154$2 = [`typed`, `Unit`], createCreateUnit$2 = factory$2(name$154$2, dependencies$154$2, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$154$2, { "Object, Object": function(t5, n3) {
    return r2.createUnit(t5, n3);
  }, Object: function(t5) {
    return r2.createUnit(t5, {});
  }, "string, Unit | string | Object, Object": function(t5, n3, i2) {
    var a2 = {};
    return a2[t5] = n3, r2.createUnit(a2, i2);
  }, "string, Unit | string | Object": function(t5, n3) {
    var i2 = {};
    return i2[t5] = n3, r2.createUnit(i2, {});
  }, string: function(t5) {
    var n3 = {};
    return n3[t5] = {}, r2.createUnit(n3, {});
  } });
}), name$153$2 = `acos`, dependencies$153$2 = [`typed`, `config`, `Complex`], createAcos$2 = factory$2(name$153$2, dependencies$153$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$153$2, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.acos(t5) : new i2(t5, 0).acos();
  }, Complex: function(t5) {
    return t5.acos();
  }, BigNumber: function(t5) {
    return t5.acos();
  } });
}), name$152$2 = `acosh`, dependencies$152$2 = [`typed`, `config`, `Complex`], createAcosh$2 = factory$2(name$152$2, dependencies$152$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$152$2, { number: function(t5) {
    return t5 >= 1 || r2.predictable ? acoshNumber$2(t5) : t5 <= -1 ? new i2(Math.log(Math.sqrt(t5 * t5 - 1) - t5), Math.PI) : new i2(t5, 0).acosh();
  }, Complex: function(t5) {
    return t5.acosh();
  }, BigNumber: function(t5) {
    return t5.acosh();
  } });
}), name$151$2 = `acot`, dependencies$151$2 = [`typed`, `BigNumber`], createAcot$2 = factory$2(name$151$2, dependencies$151$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$151$2, { number: acotNumber$2, Complex: function(t5) {
    return t5.acot();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).atan();
  } });
}), name$150$2 = `acoth`, dependencies$150$2 = [`typed`, `config`, `Complex`, `BigNumber`], createAcoth$2 = factory$2(name$150$2, dependencies$150$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$150$2, { number: function(t5) {
    return t5 >= 1 || t5 <= -1 || r2.predictable ? acothNumber$2(t5) : new i2(t5, 0).acoth();
  }, Complex: function(t5) {
    return t5.acoth();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).atanh();
  } });
}), name$149$2 = `acsc`, dependencies$149$2 = [`typed`, `config`, `Complex`, `BigNumber`], createAcsc$2 = factory$2(name$149$2, dependencies$149$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$149$2, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? acscNumber$2(t5) : new i2(t5, 0).acsc();
  }, Complex: function(t5) {
    return t5.acsc();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).asin();
  } });
}), name$148$2 = `acsch`, dependencies$148$2 = [`typed`, `BigNumber`], createAcsch$2 = factory$2(name$148$2, dependencies$148$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$148$2, { number: acschNumber$2, Complex: function(t5) {
    return t5.acsch();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).asinh();
  } });
}), name$147$2 = `asec`, dependencies$147$2 = [`typed`, `config`, `Complex`, `BigNumber`], createAsec$2 = factory$2(name$147$2, dependencies$147$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$147$2, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? asecNumber$2(t5) : new i2(t5, 0).asec();
  }, Complex: function(t5) {
    return t5.asec();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acos();
  } });
}), name$146$2 = `asech`, dependencies$146$2 = [`typed`, `config`, `Complex`, `BigNumber`], createAsech$2 = factory$2(name$146$2, dependencies$146$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$146$2, { number: function(t5) {
    if (t5 <= 1 && t5 >= -1 || r2.predictable) {
      var n3 = 1 / t5;
      if (n3 > 0 || r2.predictable) return asechNumber$2(t5);
      var a3 = Math.sqrt(n3 * n3 - 1);
      return new i2(Math.log(a3 - n3), Math.PI);
    }
    return new i2(t5, 0).asech();
  }, Complex: function(t5) {
    return t5.asech();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acosh();
  } });
}), name$145$2 = `asin`, dependencies$145$2 = [`typed`, `config`, `Complex`], createAsin$2 = factory$2(name$145$2, dependencies$145$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$145$2, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.asin(t5) : new i2(t5, 0).asin();
  }, Complex: function(t5) {
    return t5.asin();
  }, BigNumber: function(t5) {
    return t5.asin();
  } });
}), name$144$2 = `asinh`, dependencies$144$2 = [`typed`], createAsinh$2 = factory$2(name$144$2, dependencies$144$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`asinh`, { number: asinhNumber$2, Complex: function(t5) {
    return t5.asinh();
  }, BigNumber: function(t5) {
    return t5.asinh();
  } });
}), name$143$2 = `atan`, dependencies$143$2 = [`typed`], createAtan$2 = factory$2(name$143$2, dependencies$143$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`atan`, { number: function(t5) {
    return Math.atan(t5);
  }, Complex: function(t5) {
    return t5.atan();
  }, BigNumber: function(t5) {
    return t5.atan();
  } });
}), name$142$2 = `atan2`, dependencies$142$2 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `DenseMatrix`, `concat`], createAtan2$2 = factory$2(name$142$2, dependencies$142$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0$2({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo03xDSf$2({ typed: n2 }), u2 = createMatAlgo09xS0Sf$2({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs$2({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$142$2, { "number, number": Math.atan2, "BigNumber, BigNumber": (t5, n3) => a2.atan2(t5, n3) }, m2({ scalar: `number | BigNumber`, SS: u2, DS: l2, SD: c2, Ss: d2, sS: p2 }));
}), name$141$2 = `atanh`, dependencies$141$2 = [`typed`, `config`, `Complex`], createAtanh$2 = factory$2(name$141$2, dependencies$141$2, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$141$2, { number: function(t5) {
    return t5 <= 1 && t5 >= -1 || r2.predictable ? atanhNumber$2(t5) : new i2(t5, 0).atanh();
  }, Complex: function(t5) {
    return t5.atanh();
  }, BigNumber: function(t5) {
    return t5.atanh();
  } });
}), createTrigUnit$2 = factory$2(`trigUnit`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { Unit: n2.referToSelf((t5) => (r2) => {
    if (!r2.hasBase(r2.constructor.BASE_UNITS.ANGLE)) throw TypeError(`Unit in function cot is no angle`);
    return n2.find(t5, r2.valueType())(r2.value);
  }) };
}), name$140$2 = `cos`, dependencies$140$2 = [`typed`], createCos$2 = factory$2(name$140$2, dependencies$140$2, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$2({ typed: n2 });
  return n2(name$140$2, { number: Math.cos, "Complex | BigNumber": (t5) => t5.cos() }, r2);
}), name$139$2 = `cosh`, dependencies$139$2 = [`typed`], createCosh$2 = factory$2(name$139$2, dependencies$139$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$139$2, { number: cosh$3$2, "Complex | BigNumber": (t5) => t5.cosh() });
}), name$138$2 = `cot`, dependencies$138$2 = [`typed`, `BigNumber`], createCot$2 = factory$2(name$138$2, dependencies$138$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$2({ typed: n2 });
  return n2(name$138$2, { number: cotNumber$2, Complex: (t5) => t5.cot(), BigNumber: (t5) => new r2(1).div(t5.tan()) }, i2);
}), name$137$2 = `coth`, dependencies$137$2 = [`typed`, `BigNumber`], createCoth$2 = factory$2(name$137$2, dependencies$137$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$137$2, { number: cothNumber$2, Complex: (t5) => t5.coth(), BigNumber: (t5) => new r2(1).div(t5.tanh()) });
}), name$136$2 = `csc`, dependencies$136$2 = [`typed`, `BigNumber`], createCsc$2 = factory$2(name$136$2, dependencies$136$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$2({ typed: n2 });
  return n2(name$136$2, { number: cscNumber$2, Complex: (t5) => t5.csc(), BigNumber: (t5) => new r2(1).div(t5.sin()) }, i2);
}), name$135$2 = `csch`, dependencies$135$2 = [`typed`, `BigNumber`], createCsch$2 = factory$2(name$135$2, dependencies$135$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$135$2, { number: cschNumber$2, Complex: (t5) => t5.csch(), BigNumber: (t5) => new r2(1).div(t5.sinh()) });
}), name$134$2 = `sec`, dependencies$134$2 = [`typed`, `BigNumber`], createSec$2 = factory$2(name$134$2, dependencies$134$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$2({ typed: n2 });
  return n2(name$134$2, { number: secNumber$2, Complex: (t5) => t5.sec(), BigNumber: (t5) => new r2(1).div(t5.cos()) }, i2);
}), name$133$2 = `sech`, dependencies$133$2 = [`typed`, `BigNumber`], createSech$2 = factory$2(name$133$2, dependencies$133$2, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$133$2, { number: sechNumber$2, Complex: (t5) => t5.sech(), BigNumber: (t5) => new r2(1).div(t5.cosh()) });
}), name$132$2 = `sin`, dependencies$132$2 = [`typed`], createSin$2 = factory$2(name$132$2, dependencies$132$2, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$2({ typed: n2 });
  return n2(name$132$2, { number: Math.sin, "Complex | BigNumber": (t5) => t5.sin() }, r2);
}), name$131$2 = `sinh`, dependencies$131$2 = [`typed`], createSinh$2 = factory$2(name$131$2, dependencies$131$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$131$2, { number: sinhNumber$2, "Complex | BigNumber": (t5) => t5.sinh() });
}), name$130$2 = `tan`, dependencies$130$2 = [`typed`], createTan$2 = factory$2(name$130$2, dependencies$130$2, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$2({ typed: n2 });
  return n2(name$130$2, { number: Math.tan, "Complex | BigNumber": (t5) => t5.tan() }, r2);
}), name$129$2 = `tanh`, dependencies$129$2 = [`typed`], createTanh$2 = factory$2(name$129$2, dependencies$129$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(`tanh`, { number: tanh$2$2, "Complex | BigNumber": (t5) => t5.tanh() });
}), name$128$2 = `setCartesian`, dependencies$128$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetCartesian$2 = factory$2(name$128$2, dependencies$128$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$128$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2 = [];
    if (i2(r2(t5), new o2(0)) !== 0 && i2(r2(n3), new o2(0)) !== 0) {
      var l2 = flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), u2 = flatten$4$2(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2);
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) c2.push([l2[d2], u2[p2]]);
    }
    return Array.isArray(t5) && Array.isArray(n3) ? c2 : new s2(c2);
  } });
}), name$127$2 = `setDifference`, dependencies$127$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDifference$2 = factory$2(name$127$2, dependencies$127$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$127$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0) c2 = [];
    else if (i2(r2(n3), new o2(0)) === 0) return flatten$4$2(t5.toArray());
    else {
      var l2 = identify$2(flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify$2(flatten$4$2(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2, p2 = 0; p2 < l2.length; p2++) {
        d2 = false;
        for (var m2 = 0; m2 < u2.length; m2++) if (a2(l2[p2].value, u2[m2].value) === 0 && l2[p2].identifier === u2[m2].identifier) {
          d2 = true;
          break;
        }
        d2 || c2.push(l2[p2]);
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize$2(c2) : new s2(generalize$2(c2));
  } });
}), name$126$2 = `setDistinct`, dependencies$126$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDistinct$2 = factory$2(name$126$2, dependencies$126$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$126$2, { "Array | Matrix": function(t5) {
    var n3;
    if (i2(r2(t5), new o2(0)) === 0) n3 = [];
    else {
      var c2 = flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2);
      n3 = [], n3.push(c2[0]);
      for (var l2 = 1; l2 < c2.length; l2++) a2(c2[l2], c2[l2 - 1]) !== 0 && n3.push(c2[l2]);
    }
    return Array.isArray(t5) ? n3 : new s2(n3);
  } });
}), name$125$2 = `setIntersect`, dependencies$125$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetIntersect$2 = factory$2(name$125$2, dependencies$125$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$125$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0 || i2(r2(n3), new o2(0)) === 0) c2 = [];
    else {
      var l2 = identify$2(flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify$2(flatten$4$2(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) if (a2(l2[d2].value, u2[p2].value) === 0 && l2[d2].identifier === u2[p2].identifier) {
        c2.push(l2[d2]);
        break;
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize$2(c2) : new s2(generalize$2(c2));
  } });
}), name$124$2 = `setIsSubset`, dependencies$124$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetIsSubset$2 = factory$2(name$124$2, dependencies$124$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$124$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (i2(r2(t5), new o2(0)) === 0) return true;
    if (i2(r2(n3), new o2(0)) === 0) return false;
    for (var s2 = identify$2(flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), c2 = identify$2(flatten$4$2(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2)), l2, u2 = 0; u2 < s2.length; u2++) {
      l2 = false;
      for (var d2 = 0; d2 < c2.length; d2++) if (a2(s2[u2].value, c2[d2].value) === 0 && s2[u2].identifier === c2[d2].identifier) {
        l2 = true;
        break;
      }
      if (l2 === false) return false;
    }
    return true;
  } });
}), name$123$2 = `setMultiplicity`, dependencies$123$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetMultiplicity$2 = factory$2(name$123$2, dependencies$123$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$123$2, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(t5, n3) {
    if (i2(r2(n3), new o2(0)) === 0) return 0;
    for (var s2 = flatten$4$2(Array.isArray(n3) ? n3 : n3.toArray()), c2 = 0, l2 = 0; l2 < s2.length; l2++) a2(s2[l2], t5) === 0 && c2++;
    return c2;
  } });
}), name$122$2 = `setPowerset`, dependencies$122$2 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetPowerset$2 = factory$2(name$122$2, dependencies$122$2, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$122$2, { "Array | Matrix": function(t5) {
    if (i2(r2(t5), new o2(0)) === 0) return [];
    for (var n3 = flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), l2 = [], u2 = 0; u2.toString(2).length <= n3.length; ) l2.push(s2(n3, u2.toString(2).split(``).reverse())), u2++;
    return c2(l2);
  } });
  function s2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3.length; i3++) n3[i3] === `1` && r3.push(t5[i3]);
    return r3;
  }
  function c2(t5) {
    for (var n3 = [], r3 = t5.length - 1; r3 > 0; r3--) for (var i3 = 0; i3 < r3; i3++) t5[i3].length > t5[i3 + 1].length && (n3 = t5[i3], t5[i3] = t5[i3 + 1], t5[i3 + 1] = n3);
    return t5;
  }
}), name$121$2 = `setSize`, dependencies$121$2 = [`typed`, `compareNatural`], createSetSize$2 = factory$2(name$121$2, dependencies$121$2, (t4) => {
  var { typed: n2, compareNatural: r2 } = t4;
  return n2(name$121$2, { "Array | Matrix": function(t5) {
    return Array.isArray(t5) ? flatten$4$2(t5).length : flatten$4$2(t5.toArray()).length;
  }, "Array | Matrix, boolean": function(t5, n3) {
    if (n3 === false || t5.length === 0) return Array.isArray(t5) ? flatten$4$2(t5).length : flatten$4$2(t5.toArray()).length;
    for (var i2 = flatten$4$2(Array.isArray(t5) ? t5 : t5.toArray()).sort(r2), a2 = 1, o2 = 1; o2 < i2.length; o2++) r2(i2[o2], i2[o2 - 1]) !== 0 && a2++;
    return a2;
  } });
}), name$120$2 = `setSymDifference`, dependencies$120$2 = [`typed`, `size`, `concat`, `subset`, `setDifference`, `Index`], createSetSymDifference$2 = factory$2(name$120$2, dependencies$120$2, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setDifference: o2, Index: s2 } = t4;
  return n2(name$120$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new s2(0)) === 0) return flatten$4$2(n3);
    if (a2(r2(n3), new s2(0)) === 0) return flatten$4$2(t5);
    var c2 = flatten$4$2(t5), l2 = flatten$4$2(n3);
    return i2(o2(c2, l2), o2(l2, c2));
  } });
}), name$119$2 = `setUnion`, dependencies$119$2 = [`typed`, `size`, `concat`, `subset`, `setIntersect`, `setSymDifference`, `Index`], createSetUnion$2 = factory$2(name$119$2, dependencies$119$2, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setIntersect: o2, setSymDifference: s2, Index: c2 } = t4;
  return n2(name$119$2, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new c2(0)) === 0) return flatten$4$2(n3);
    if (a2(r2(n3), new c2(0)) === 0) return flatten$4$2(t5);
    var l2 = flatten$4$2(t5), u2 = flatten$4$2(n3);
    return i2(s2(l2, u2), o2(l2, u2));
  } });
}), name$118$2 = `add`, dependencies$118$2 = [`typed`, `matrix`, `addScalar`, `equalScalar`, `DenseMatrix`, `SparseMatrix`, `concat`], createAdd$2 = factory$2(name$118$2, dependencies$118$2, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, equalScalar: a2, DenseMatrix: o2, SparseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid$2({ typed: n2 }), u2 = createMatAlgo04xSidSid$2({ typed: n2, equalScalar: a2 }), d2 = createMatAlgo10xSids$2({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$2({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$118$2, { "any, any": i2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) }, p2({ elop: i2, DS: l2, SS: u2, Ss: d2 }));
}), name$117$2 = `hypot`, dependencies$117$2 = [`typed`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `sqrt`, `smaller`, `isPositive`], createHypot$2 = factory$2(name$117$2, dependencies$117$2, (t4) => {
  var { typed: n2, abs: r2, addScalar: i2, divideScalar: a2, multiplyScalar: o2, sqrt: s2, smaller: c2, isPositive: l2 } = t4;
  return n2(name$117$2, { "... number | BigNumber": u2, Array: u2, Matrix: (t5) => u2(flatten$4$2(t5.toArray(), true)) });
  function u2(t5) {
    for (var n3 = 0, u3 = 0, d2 = 0; d2 < t5.length; d2++) {
      if (isComplex$2(t5[d2])) throw TypeError(`Unexpected type of argument to hypot`);
      var p2 = r2(t5[d2]);
      c2(u3, p2) ? (n3 = o2(n3, o2(a2(u3, p2), a2(u3, p2))), n3 = i2(n3, 1), u3 = p2) : n3 = i2(n3, l2(p2) ? o2(a2(p2, u3), a2(p2, u3)) : p2);
    }
    return o2(u3, s2(n3));
  }
}), name$116$2 = `norm`, dependencies$116$2 = [`typed`, `abs`, `add`, `pow`, `conj`, `sqrt`, `multiply`, `equalScalar`, `larger`, `smaller`, `matrix`, `ctranspose`, `eigs`], createNorm$2 = factory$2(name$116$2, dependencies$116$2, (t4) => {
  var { typed: n2, abs: r2, add: i2, pow: a2, conj: o2, sqrt: s2, multiply: c2, equalScalar: l2, larger: u2, smaller: d2, matrix: p2, ctranspose: m2, eigs: h2 } = t4;
  return n2(name$116$2, { number: Math.abs, Complex: function(t5) {
    return t5.abs();
  }, BigNumber: function(t5) {
    return t5.abs();
  }, boolean: function(t5) {
    return Math.abs(t5);
  }, Array: function(t5) {
    return D(p2(t5), 2);
  }, Matrix: function(t5) {
    return D(t5, 2);
  }, "Array, number | BigNumber | string": function(t5, n3) {
    return D(p2(t5), n3);
  }, "Matrix, number | BigNumber | string": function(t5, n3) {
    return D(t5, n3);
  } });
  function g2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      u2(i3, n3) && (n3 = i3);
    }, true), n3;
  }
  function v2(t5) {
    var n3;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      (!n3 || d2(i3, n3)) && (n3 = i3);
    }, true), n3 || 0;
  }
  function y2(t5, n3) {
    if (n3 === 1 / 0 || n3 === `inf`) return g2(t5);
    if (n3 === -1 / 0 || n3 === `-inf`) return v2(t5);
    if (n3 === `fro`) return D(t5, 2);
    if (typeof n3 == `number` && !isNaN(n3)) {
      if (!l2(n3, 0)) {
        var o3 = 0;
        return t5.forEach(function(t6) {
          o3 = i2(a2(r2(t6), n3), o3);
        }, true), a2(o3, 1 / n3);
      }
      return 1 / 0;
    }
    throw Error(`Unsupported parameter value`);
  }
  function b2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6, r3) {
      n3 = i2(n3, c2(t6, o2(t6)));
    }), r2(s2(n3));
  }
  function x2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[1], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function S2(t5) {
    var n3 = t5.size();
    if (n3[0] !== n3[1]) throw RangeError(`Invalid matrix dimensions`);
    var i3 = h2(c2(m2(t5), t5)).values.toArray(), a3 = i3[i3.length - 1];
    return r2(s2(a3));
  }
  function w2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[0], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function E(t5, n3) {
    if (n3 === 1) return x2(t5);
    if (n3 === 1 / 0 || n3 === `inf`) return w2(t5);
    if (n3 === `fro`) return b2(t5);
    if (n3 === 2) return S2(t5);
    throw Error(`Unsupported parameter value ` + n3);
  }
  function D(t5, n3) {
    var r3 = t5.size();
    if (r3.length === 1) return y2(t5, n3);
    if (r3.length === 2) {
      if (r3[0] && r3[1]) return E(t5, n3);
      throw RangeError(`Invalid matrix dimensions`);
    }
  }
}), name$115$2 = `dot`, dependencies$115$2 = [`typed`, `addScalar`, `multiplyScalar`, `conj`, `size`], createDot$2 = factory$2(name$115$2, dependencies$115$2, (t4) => {
  var { typed: n2, addScalar: r2, multiplyScalar: i2, conj: a2, size: o2 } = t4;
  return n2(name$115$2, { "Array | DenseMatrix, Array | DenseMatrix": c2, "SparseMatrix, SparseMatrix": l2 });
  function s2(t5, n3) {
    var r3 = o2(t5), i3 = o2(n3), a3, s3;
    if (r3.length === 1) a3 = r3[0];
    else if (r3.length === 2 && r3[1] === 1) a3 = r3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + r3.join(`, `) + `)`);
    if (i3.length === 1) s3 = i3[0];
    else if (i3.length === 2 && i3[1] === 1) s3 = i3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + i3.join(`, `) + `)`);
    if (a3 !== s3) throw RangeError(`Vectors must have equal length (` + a3 + ` != ` + s3 + `)`);
    if (a3 === 0) throw RangeError(`Cannot calculate the dot product of empty vectors`);
    return a3;
  }
  function c2(t5, c3) {
    var l3 = s2(t5, c3), u2 = isMatrix$2(t5) ? t5._data : t5, d2 = isMatrix$2(t5) ? t5._datatype || t5.getDataType() : void 0, p2 = isMatrix$2(c3) ? c3._data : c3, m2 = isMatrix$2(c3) ? c3._datatype || c3.getDataType() : void 0, h2 = o2(t5).length === 2, g2 = o2(c3).length === 2, v2 = r2, y2 = i2;
    if (d2 && m2 && d2 === m2 && typeof d2 == `string` && d2 !== `mixed`) {
      var b2 = d2;
      v2 = n2.find(r2, [b2, b2]), y2 = n2.find(i2, [b2, b2]);
    }
    if (!h2 && !g2) {
      for (var x2 = y2(a2(u2[0]), p2[0]), S2 = 1; S2 < l3; S2++) x2 = v2(x2, y2(a2(u2[S2]), p2[S2]));
      return x2;
    }
    if (!h2 && g2) {
      for (var w2 = y2(a2(u2[0]), p2[0][0]), E = 1; E < l3; E++) w2 = v2(w2, y2(a2(u2[E]), p2[E][0]));
      return w2;
    }
    if (h2 && !g2) {
      for (var D = y2(a2(u2[0][0]), p2[0]), O2 = 1; O2 < l3; O2++) D = v2(D, y2(a2(u2[O2][0]), p2[O2]));
      return D;
    }
    if (h2 && g2) {
      for (var j2 = y2(a2(u2[0][0]), p2[0][0]), M2 = 1; M2 < l3; M2++) j2 = v2(j2, y2(a2(u2[M2][0]), p2[M2][0]));
      return j2;
    }
  }
  function l2(t5, n3) {
    s2(t5, n3);
    for (var a3 = t5._index, o3 = t5._values, c3 = n3._index, l3 = n3._values, u2 = 0, d2 = r2, p2 = i2, m2 = 0, h2 = 0; m2 < a3.length && h2 < c3.length; ) {
      var g2 = a3[m2], v2 = c3[h2];
      if (g2 < v2) {
        m2++;
        continue;
      }
      if (g2 > v2) {
        h2++;
        continue;
      }
      g2 === v2 && (u2 = d2(u2, p2(o3[m2], l3[h2])), m2++, h2++);
    }
    return u2;
  }
}), name$114$2 = `trace`, dependencies$114$2 = [`typed`, `matrix`, `add`], createTrace$2 = factory$2(name$114$2, dependencies$114$2, (t4) => {
  var { typed: n2, matrix: r2, add: i2 } = t4;
  return n2(`trace`, { Array: function(t5) {
    return a2(r2(t5));
  }, SparseMatrix: o2, DenseMatrix: a2, any: clone$3$2 });
  function a2(t5) {
    var n3 = t5._size, r3 = t5._data;
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return clone$3$2(r3[0]);
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      case 2:
        var a3 = n3[0];
        if (a3 === n3[1]) {
          for (var o3 = 0, s2 = 0; s2 < a3; s2++) o3 = i2(o3, r3[s2][s2]);
          return o3;
        } else throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$4(n3) + `)`);
    }
  }
  function o2(t5) {
    var n3 = t5._values, r3 = t5._index, a3 = t5._ptr, o3 = t5._size, s2 = o3[0], c2 = o3[1];
    if (s2 === c2) {
      var l2 = 0;
      if (n3.length > 0) for (var u2 = 0; u2 < c2; u2++) for (var d2 = a3[u2], p2 = a3[u2 + 1], m2 = d2; m2 < p2; m2++) {
        var h2 = r3[m2];
        if (h2 === u2) {
          l2 = i2(l2, n3[m2]);
          break;
        }
        if (h2 > u2) break;
      }
      return l2;
    }
    throw RangeError(`Matrix must be square (size: ` + format$4(o3) + `)`);
  }
}), name$113$2 = `index`, dependencies$113$2 = [`typed`, `Index`], createIndex$2 = factory$2(name$113$2, dependencies$113$2, (t4) => {
  var { typed: n2, Index: r2 } = t4;
  return n2(name$113$2, { "...number | string | BigNumber | Range | Array | Matrix": function(t5) {
    var n3 = t5.map(function(t6) {
      return isBigNumber$2(t6) ? t6.toNumber() : isArray$3(t6) || isMatrix$2(t6) ? t6.map(function(t7) {
        return isBigNumber$2(t7) ? t7.toNumber() : t7;
      }) : t6;
    }), i2 = new r2();
    return r2.apply(i2, n3), i2;
  } });
}), keywords$2 = /* @__PURE__ */ new Set([`end`]), name$112$2 = `Node`, dependencies$112$2 = [`mathWithTransform`], createNode$2 = factory$2(name$112$2, dependencies$112$2, (t4) => {
  var { mathWithTransform: n2 } = t4;
  function r2(t5) {
    for (var n3 of [...keywords$2]) if (t5.has(n3)) throw Error(`Scope contains an illegal symbol, "` + n3 + `" is a reserved keyword`);
  }
  class i2 {
    get type() {
      return `Node`;
    }
    get isNode() {
      return true;
    }
    evaluate(t5) {
      return this.compile().evaluate(t5);
    }
    compile() {
      var t5 = this._compile(n2, {}), i3 = {}, a2 = null;
      function o2(n3) {
        var o3 = createMap$1$2(n3);
        return r2(o3), t5(o3, i3, a2);
      }
      return { evaluate: o2 };
    }
    _compile(t5, n3) {
      throw Error(`Method _compile must be implemented by type ` + this.type);
    }
    forEach(t5) {
      throw Error(`Cannot run forEach on a Node interface`);
    }
    map(t5) {
      throw Error(`Cannot run map on a Node interface`);
    }
    _ifNode(t5) {
      if (!isNode$5(t5)) throw TypeError(`Callback function must return a Node`);
      return t5;
    }
    traverse(t5) {
      t5(this, null, null);
      function n3(t6, r3) {
        t6.forEach(function(t7, i3, a2) {
          r3(t7, i3, a2), n3(t7, r3);
        });
      }
      n3(this, t5);
    }
    transform(t5) {
      function n3(r3, i3, a2) {
        var o2 = t5(r3, i3, a2);
        return o2 === r3 ? r3.map(n3) : o2;
      }
      return n3(this, null, null);
    }
    filter(t5) {
      var n3 = [];
      return this.traverse(function(r3, i3, a2) {
        t5(r3, i3, a2) && n3.push(r3);
      }), n3;
    }
    clone() {
      throw Error(`Cannot clone a Node interface`);
    }
    cloneDeep() {
      return this.map(function(t5) {
        return t5.cloneDeep();
      });
    }
    equals(t5) {
      return t5 ? this.type === t5.type && deepStrictEqual$2(this, t5) : false;
    }
    toString(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toString(t5) : n3;
    }
    _toString() {
      throw Error(`_toString not implemented for ` + this.type);
    }
    toJSON() {
      throw Error(`Cannot serialize object: toJSON not implemented by ` + this.type);
    }
    toHTML(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toHTML(t5) : n3;
    }
    _toHTML() {
      throw Error(`_toHTML not implemented for ` + this.type);
    }
    toTex(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toTex(t5) : n3;
    }
    _toTex(t5) {
      throw Error(`_toTex not implemented for ` + this.type);
    }
    _getCustomString(t5) {
      if (t5 && typeof t5 == `object`) switch (typeof t5.handler) {
        case `object`:
        case `undefined`:
          return;
        case `function`:
          return t5.handler(this, t5);
        default:
          throw TypeError(`Object or function expected as callback`);
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  }
  return i2;
}, { isClass: true, isNode: true });
function errorTransform$2(t4) {
  return t4 && t4.isIndexError ? new IndexError$2(t4.index + 1, t4.min + 1, t4.max === void 0 ? void 0 : t4.max + 1) : t4;
}
function accessFactory$2(t4) {
  var { subset: n2 } = t4;
  return function(t5, r2) {
    try {
      if (Array.isArray(t5)) return n2(t5, r2);
      if (t5 && typeof t5.subset == `function`) return t5.subset(r2);
      if (typeof t5 == `string`) return n2(t5, r2);
      if (typeof t5 == `object`) {
        if (!r2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return getSafeProperty$2(t5, r2.getObjectProperty());
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  };
}
var name$111$2 = `AccessorNode`, dependencies$111$2 = [`subset`, `Node`], createAccessorNode$2 = factory$2(name$111$2, dependencies$111$2, (t4) => {
  var { subset: n2, Node: r2 } = t4, i2 = accessFactory$2({ subset: n2 });
  function a2(t5) {
    return !(isAccessorNode$2(t5) || isArrayNode$2(t5) || isConstantNode$2(t5) || isFunctionNode$2(t5) || isObjectNode$2(t5) || isParenthesisNode$2(t5) || isSymbolNode$2(t5));
  }
  class o2 extends r2 {
    constructor(t5, n3) {
      var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      if (super(), !isNode$5(t5)) throw TypeError(`Node expected for parameter "object"`);
      if (!isIndexNode$2(n3)) throw TypeError(`IndexNode expected for parameter "index"`);
      this.object = t5, this.index = n3, this.optionalChaining = r3;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$111$2;
    }
    get isAccessorNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), a3 = this.index._compile(t5, n3), o3 = this.optionalChaining, s2 = isAccessorNode$2(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var c2 = this.index.getObjectProperty();
        return function(t6, n4, i3) {
          var a4 = i3 || {}, l2 = r3(t6, n4, a4);
          if (o3 && l2 == null) {
            a4.optionalShortCircuit = true;
            return;
          }
          if (!(s2 && a4 != null && a4.optionalShortCircuit)) return getSafeProperty$2(l2, c2);
        };
      } else return function(t6, n4, c3) {
        var l2 = c3 || {}, u2 = r3(t6, n4, l2);
        if (o3 && u2 == null) {
          l2.optionalShortCircuit = true;
          return;
        }
        if (!(s2 && l2 != null && l2.optionalShortCircuit)) return i2(u2, a3(t6, n4, u2));
      };
    }
    forEach(t5) {
      t5(this.object, `object`, this), t5(this.index, `index`, this);
    }
    map(t5) {
      return new o2(this._ifNode(t5(this.object, `object`, this)), this._ifNode(t5(this.index, `index`, this)), this.optionalChaining);
    }
    clone() {
      return new o2(this.object, this.index, this.optionalChaining);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5);
      a2(this.object) && (n3 = `(` + n3 + `)`);
      var r3 = this.optionalChaining ? this.index.dotNotation ? `?` : `?.` : ``;
      return n3 + r3 + this.index.toString(t5);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5);
      return a2(this.object) && (n3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n3 + this.index.toHTML(t5);
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5);
      return a2(this.object) && (n3 = `\\left(' + object + '\\right)`), n3 + this.index.toTex(t5);
    }
    toJSON() {
      return { mathjs: name$111$2, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(t5) {
      return new o2(t5.object, t5.index, t5.optionalChaining);
    }
  }
  return _defineProperty$4(o2, `name`, name$111$2), o2;
}, { isClass: true, isNode: true }), name$110$2 = `ArrayNode`, dependencies$110$2 = [`Node`], createArrayNode$2 = factory$2(name$110$2, dependencies$110$2, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.items = t5 || [], !Array.isArray(this.items) || !this.items.every(isNode$5)) throw TypeError(`Array containing Nodes expected`);
    }
    get type() {
      return name$110$2;
    }
    get isArrayNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = map$1$2(this.items, function(r4) {
        return r4._compile(t5, n3);
      });
      if (t5.config.matrix !== `Array`) {
        var i2 = t5.matrix;
        return function(t6, n4, a2) {
          return i2(map$1$2(r3, function(r4) {
            return r4(t6, n4, a2);
          }));
        };
      } else return function(t6, n4, i3) {
        return map$1$2(r3, function(r4) {
          return r4(t6, n4, i3);
        });
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.items.length; n3++) {
        var r3 = this.items[n3];
        t5(r3, `items[` + n3 + `]`, this);
      }
    }
    map(t5) {
      for (var n3 = [], i2 = 0; i2 < this.items.length; i2++) n3[i2] = this._ifNode(t5(this.items[i2], `items[` + i2 + `]`, this));
      return new r2(n3);
    }
    clone() {
      return new r2(this.items.slice(0));
    }
    _toString(t5) {
      return `[` + this.items.map(function(n3) {
        return n3.toString(t5);
      }).join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$110$2, items: this.items };
    }
    static fromJSON(t5) {
      return new r2(t5.items);
    }
    _toHTML(t5) {
      return `<span class="math-parenthesis math-square-parenthesis">[</span>` + this.items.map(function(n3) {
        return n3.toHTML(t5);
      }).join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      function n3(r3, i2) {
        var a2 = r3.some(isArrayNode$2) && !r3.every(isArrayNode$2), o2 = i2 || a2, s2 = o2 ? `&` : `\\\\`, c2 = r3.map(function(r4) {
          return r4.items ? n3(r4.items, !i2) : r4.toTex(t5);
        }).join(s2);
        return a2 || !o2 || o2 && !i2 ? `\\begin{bmatrix}` + c2 + `\\end{bmatrix}` : c2;
      }
      return n3(this.items, false);
    }
  }
  return _defineProperty$4(r2, `name`, name$110$2), r2;
}, { isClass: true, isNode: true });
function assignFactory$2(t4) {
  var { subset: n2, matrix: r2 } = t4;
  return function(t5, i2, a2) {
    try {
      if (Array.isArray(t5)) return r2(t5).subset(i2, a2).valueOf().forEach((n3, r3) => {
        t5[r3] = n3;
      }), t5;
      if (t5 && typeof t5.subset == `function`) return t5.subset(i2, a2);
      if (typeof t5 == `string`) return n2(t5, i2, a2);
      if (typeof t5 == `object`) {
        if (!i2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return setSafeProperty$2(t5, i2.getObjectProperty(), a2), t5;
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  };
}
var properties$2 = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: false, latexRightParens: false, latexParens: false } }, { "OperatorNode:or": { op: `or`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:xor": { op: `xor`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:and": { op: `and`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitOr": { op: `|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitXor": { op: `^|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitAnd": { op: `&`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:equal": { op: `==`, associativity: `left`, associativeWith: [] }, "OperatorNode:unequal": { op: `!=`, associativity: `left`, associativeWith: [] }, "OperatorNode:smaller": { op: `<`, associativity: `left`, associativeWith: [] }, "OperatorNode:larger": { op: `>`, associativity: `left`, associativeWith: [] }, "OperatorNode:smallerEq": { op: `<=`, associativity: `left`, associativeWith: [] }, "OperatorNode:largerEq": { op: `>=`, associativity: `left`, associativeWith: [] }, RelationalNode: { associativity: `left`, associativeWith: [] } }, { "OperatorNode:leftShift": { op: `<<`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightArithShift": { op: `>>`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightLogShift": { op: `>>>`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:to": { op: `to`, associativity: `left`, associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: `+`, associativity: `left`, associativeWith: [`OperatorNode:add`, `OperatorNode:subtract`] }, "OperatorNode:subtract": { op: `-`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { op: `*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] }, "OperatorNode:divide": { op: `/`, associativity: `left`, associativeWith: [], latexLeftParens: false, latexRightParens: false, latexParens: false }, "OperatorNode:dotMultiply": { op: `.*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `OperatorNode:dotMultiply`, `OperatorNode:doDivide`] }, "OperatorNode:dotDivide": { op: `./`, associativity: `left`, associativeWith: [] }, "OperatorNode:mod": { op: `mod`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] } }, { "OperatorNode:unaryPlus": { op: `+`, associativity: `right` }, "OperatorNode:unaryMinus": { op: `-`, associativity: `right` }, "OperatorNode:bitNot": { op: `~`, associativity: `right` }, "OperatorNode:not": { op: `not`, associativity: `right` } }, { "OperatorNode:pow": { op: `^`, associativity: `right`, associativeWith: [], latexRightParens: false }, "OperatorNode:dotPow": { op: `.^`, associativity: `right`, associativeWith: [] } }, { "OperatorNode:nullish": { op: `??`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:factorial": { op: `!`, associativity: `left` } }, { "OperatorNode:ctranspose": { op: `'`, associativity: `left` } }];
function unwrapParen$2(t4, n2) {
  if (!n2 || n2 !== `auto`) return t4;
  for (var r2 = t4; isParenthesisNode$2(r2); ) r2 = r2.content;
  return r2;
}
function getPrecedence$2(t4, n2, r2, i2) {
  var a2 = t4;
  n2 !== `keep` && (a2 = t4.getContent());
  for (var o2 = a2.getIdentifier(), s2 = null, c2 = 0; c2 < properties$2.length; c2++) if (o2 in properties$2[c2]) {
    s2 = c2;
    break;
  }
  if (o2 === `OperatorNode:multiply` && a2.implicit && r2 !== `show`) {
    var l2 = unwrapParen$2(a2.args[0], n2);
    !(isConstantNode$2(l2) && i2 && i2.getIdentifier() === `OperatorNode:divide` && rule2Node$2(unwrapParen$2(i2.args[0], n2))) && !(l2.getIdentifier() === `OperatorNode:divide` && rule2Node$2(unwrapParen$2(l2.args[0], n2)) && isConstantNode$2(unwrapParen$2(l2.args[1]))) && (s2 += 1);
  }
  return s2;
}
function getAssociativity$2(t4, n2) {
  var r2 = t4;
  n2 !== `keep` && (r2 = t4.getContent());
  var i2 = r2.getIdentifier(), a2 = getPrecedence$2(r2, n2);
  if (a2 === null) return null;
  var o2 = properties$2[a2][i2];
  if (hasOwnProperty$1$4(o2, `associativity`)) {
    if (o2.associativity === `left`) return `left`;
    if (o2.associativity === `right`) return `right`;
    throw Error(`'` + i2 + `' has the invalid associativity '` + o2.associativity + `'.`);
  }
  return null;
}
function isAssociativeWith$2(t4, n2, r2) {
  var i2 = r2 === `keep` ? t4 : t4.getContent(), a2 = r2 === `keep` ? n2 : t4.getContent(), o2 = i2.getIdentifier(), s2 = a2.getIdentifier(), c2 = getPrecedence$2(i2, r2);
  if (c2 === null) return null;
  var l2 = properties$2[c2][o2];
  if (hasOwnProperty$1$4(l2, `associativeWith`) && l2.associativeWith instanceof Array) {
    for (var u2 = 0; u2 < l2.associativeWith.length; u2++) if (l2.associativeWith[u2] === s2) return true;
    return false;
  }
  return null;
}
function getOperator$2(t4) {
  var n2 = `OperatorNode:` + t4;
  for (var r2 of properties$2) if (n2 in r2) return r2[n2].op;
  return null;
}
var name$109$2 = `AssignmentNode`, dependencies$109$2 = [`subset`, `?matrix`, `Node`], createAssignmentNode$2 = factory$2(name$109$2, dependencies$109$2, (t4) => {
  var { subset: n2, matrix: r2, Node: i2 } = t4, a2 = accessFactory$2({ subset: n2 }), o2 = assignFactory$2({ subset: n2, matrix: r2 });
  function s2(t5, n3, r3) {
    n3 ||= `keep`;
    var i3 = getPrecedence$2(t5, n3, r3), a3 = getPrecedence$2(t5.value, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), this.object = t5, this.index = r3 ? n3 : null, this.value = r3 || n3, !isSymbolNode$2(t5) && !isAccessorNode$2(t5)) throw TypeError(`SymbolNode or AccessorNode expected as "object"`);
      if (isSymbolNode$2(t5) && t5.name === `end`) throw Error(`Cannot assign to symbol "end"`);
      if (this.index && !isIndexNode$2(this.index)) throw TypeError(`IndexNode expected as "index"`);
      if (!isNode$5(this.value)) throw TypeError(`Node expected as "value"`);
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$109$2;
    }
    get isAssignmentNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), i3 = this.index ? this.index._compile(t5, n3) : null, s3 = this.value._compile(t5, n3), c3 = this.object.name;
      if (!this.index) {
        if (!isSymbolNode$2(this.object)) throw TypeError(`SymbolNode expected as object`);
        return function(t6, n4, r4) {
          var i4 = s3(t6, n4, r4);
          return t6.set(c3, i4), i4;
        };
      } else if (this.index.isObjectProperty()) {
        var l2 = this.index.getObjectProperty();
        return function(t6, n4, i4) {
          var a3 = r3(t6, n4, i4), o3 = s3(t6, n4, i4);
          return setSafeProperty$2(a3, l2, o3), o3;
        };
      } else if (isSymbolNode$2(this.object)) return function(t6, n4, a3) {
        var l3 = r3(t6, n4, a3), u3 = s3(t6, n4, a3), d3 = i3(t6, n4, l3);
        return t6.set(c3, o2(l3, d3, u3)), u3;
      };
      else {
        var u2 = this.object.object._compile(t5, n3);
        if (this.object.index.isObjectProperty()) {
          var d2 = this.object.index.getObjectProperty();
          return function(t6, n4, r4) {
            var a3 = u2(t6, n4, r4), c4 = getSafeProperty$2(a3, d2), l3 = i3(t6, n4, c4), p3 = s3(t6, n4, r4);
            return setSafeProperty$2(a3, d2, o2(c4, l3, p3)), p3;
          };
        } else {
          var p2 = this.object.index._compile(t5, n3);
          return function(t6, n4, r4) {
            var c4 = u2(t6, n4, r4), l3 = p2(t6, n4, c4), d3 = a2(c4, l3), m2 = i3(t6, n4, d3), h2 = s3(t6, n4, r4);
            return o2(c4, l3, o2(d3, m2, h2)), h2;
          };
        }
      }
    }
    forEach(t5) {
      t5(this.object, `object`, this), this.index && t5(this.index, `index`, this), t5(this.value, `value`, this);
    }
    map(t5) {
      return new c2(this._ifNode(t5(this.object, `object`, this)), this.index ? this._ifNode(t5(this.index, `index`, this)) : null, this._ifNode(t5(this.value, `value`, this)));
    }
    clone() {
      return new c2(this.object, this.index, this.value);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5), r3 = this.index ? this.index.toString(t5) : ``, i3 = this.value.toString(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `(` + i3 + `)`), n3 + r3 + ` = ` + i3;
    }
    toJSON() {
      return { mathjs: name$109$2, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(t5) {
      return new c2(t5.object, t5.index, t5.value);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5), r3 = this.index ? this.index.toHTML(t5) : ``, i3 = this.value.toHTML(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `<span class="math-paranthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-paranthesis math-round-parenthesis">)</span>`), n3 + r3 + `<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + i3;
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5), r3 = this.index ? this.index.toTex(t5) : ``, i3 = this.value.toTex(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `\\left(${i3}\\right)`), n3 + r3 + `=` + i3;
    }
  }
  return _defineProperty$4(c2, `name`, name$109$2), c2;
}, { isClass: true, isNode: true }), name$108$2 = `BlockNode`, dependencies$108$2 = [`ResultSet`, `Node`], createBlockNode$2 = factory$2(name$108$2, dependencies$108$2, (t4) => {
  var { ResultSet: n2, Node: r2 } = t4;
  class i2 extends r2 {
    constructor(t5) {
      if (super(), !Array.isArray(t5)) throw Error(`Array expected`);
      this.blocks = t5.map(function(t6) {
        var n3 = t6 && t6.node, r3 = t6 && t6.visible !== void 0 ? t6.visible : true;
        if (!isNode$5(n3)) throw TypeError(`Property "node" must be a Node`);
        if (typeof r3 != `boolean`) throw TypeError(`Property "visible" must be a boolean`);
        return { node: n3, visible: r3 };
      });
    }
    get type() {
      return name$108$2;
    }
    get isBlockNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = map$1$2(this.blocks, function(n3) {
        return { evaluate: n3.node._compile(t5, r3), visible: n3.visible };
      });
      return function(t6, r4, a2) {
        var o2 = [];
        return forEach$2(i3, function(n3) {
          var i4 = n3.evaluate(t6, r4, a2);
          n3.visible && o2.push(i4);
        }), new n2(o2);
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.blocks.length; n3++) t5(this.blocks[n3].node, `blocks[` + n3 + `].node`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.blocks.length; r3++) {
        var a2 = this.blocks[r3];
        n3[r3] = { node: this._ifNode(t5(a2.node, `blocks[` + r3 + `].node`, this)), visible: a2.visible };
      }
      return new i2(n3);
    }
    clone() {
      return new i2(this.blocks.map(function(t5) {
        return { node: t5.node, visible: t5.visible };
      }));
    }
    _toString(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toString(t5) + (n3.visible ? `` : `;`);
      }).join(`
`);
    }
    toJSON() {
      return { mathjs: name$108$2, blocks: this.blocks };
    }
    static fromJSON(t5) {
      return new i2(t5.blocks);
    }
    _toHTML(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toHTML(t5) + (n3.visible ? `` : `<span class="math-separator">;</span>`);
      }).join(`<span class="math-separator"><br /></span>`);
    }
    _toTex(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toTex(t5) + (n3.visible ? `` : `;`);
      }).join(`\\;\\;
`);
    }
  }
  return _defineProperty$4(i2, `name`, name$108$2), i2;
}, { isClass: true, isNode: true }), name$107$2 = `ConditionalNode`, dependencies$107$2 = [`Node`], createConditionalNode$2 = factory$2(name$107$2, dependencies$107$2, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5) {
    if (typeof t5 == `number` || typeof t5 == `boolean` || typeof t5 == `string`) return !!t5;
    if (t5) {
      if (isBigNumber$2(t5)) return !t5.isZero();
      if (isComplex$2(t5)) return !!(t5.re || t5.im);
      if (isUnit$2(t5)) return !!t5.value;
    }
    if (t5 == null) return false;
    throw TypeError(`Unsupported type of condition "` + typeOf$2(t5) + `"`);
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$5(t5)) throw TypeError(`Parameter condition must be a Node`);
      if (!isNode$5(n3)) throw TypeError(`Parameter trueExpr must be a Node`);
      if (!isNode$5(r3)) throw TypeError(`Parameter falseExpr must be a Node`);
      this.condition = t5, this.trueExpr = n3, this.falseExpr = r3;
    }
    get type() {
      return name$107$2;
    }
    get isConditionalNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.condition._compile(t5, n3), a2 = this.trueExpr._compile(t5, n3), o2 = this.falseExpr._compile(t5, n3);
      return function(t6, n4, s2) {
        return r2(i3(t6, n4, s2)) ? a2(t6, n4, s2) : o2(t6, n4, s2);
      };
    }
    forEach(t5) {
      t5(this.condition, `condition`, this), t5(this.trueExpr, `trueExpr`, this), t5(this.falseExpr, `falseExpr`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.condition, `condition`, this)), this._ifNode(t5(this.trueExpr, `trueExpr`, this)), this._ifNode(t5(this.falseExpr, `falseExpr`, this)));
    }
    clone() {
      return new i2(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$2(this, n3, t5 && t5.implicit), i3 = this.condition.toString(t5), a2 = getPrecedence$2(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `(` + i3 + `)`);
      var o2 = this.trueExpr.toString(t5), s2 = getPrecedence$2(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `(` + o2 + `)`);
      var c2 = this.falseExpr.toString(t5), l2 = getPrecedence$2(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `(` + c2 + `)`), i3 + ` ? ` + o2 + ` : ` + c2;
    }
    toJSON() {
      return { mathjs: name$107$2, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(t5) {
      return new i2(t5.condition, t5.trueExpr, t5.falseExpr);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$2(this, n3, t5 && t5.implicit), i3 = this.condition.toHTML(t5), a2 = getPrecedence$2(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var o2 = this.trueExpr.toHTML(t5), s2 = getPrecedence$2(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var c2 = this.falseExpr.toHTML(t5), l2 = getPrecedence$2(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), i3 + `<span class="math-operator math-conditional-operator">?</span>` + o2 + `<span class="math-operator math-conditional-operator">:</span>` + c2;
    }
    _toTex(t5) {
      return `\\begin{cases} {` + this.trueExpr.toTex(t5) + `}, &\\quad{\\text{if }\\;` + this.condition.toTex(t5) + `}\\\\{` + this.falseExpr.toTex(t5) + `}, &\\quad{\\text{otherwise}}\\end{cases}`;
    }
  }
  return _defineProperty$4(i2, `name`, name$107$2), i2;
}, { isClass: true, isNode: true }), require_dist$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = Object.assign || function(t5) {
    for (var n3 = 1; n3 < arguments.length; n3++) {
      var r3 = arguments[n3];
      for (var i3 in r3) Object.prototype.hasOwnProperty.call(r3, i3) && (t5[i3] = r3[i3]);
    }
    return t5;
  }, i2 = { "{": `\\{`, "}": `\\}`, "\\": `\\textbackslash{}`, "#": `\\#`, $: `\\$`, "%": `\\%`, "&": `\\&`, "^": `\\textasciicircum{}`, _: `\\_`, "~": `\\textasciitilde{}` }, a2 = { "–": `\\--`, "—": `\\---`, " ": `~`, "	": `\\qquad{}`, "\r\n": `\\newline{}`, "\n": `\\newline{}` }, o2 = function(t5, n3) {
    return r2({}, t5, n3);
  };
  n2.exports = function(t5) {
    for (var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s2 = n3.preserveFormatting, c2 = s2 === void 0 ? false : s2, l2 = n3.escapeMapFn, u2 = l2 === void 0 ? o2 : l2, d2 = String(t5), p2 = ``, m2 = u2(r2({}, i2), c2 ? r2({}, a2) : {}), h2 = Object.keys(m2), g2 = function() {
      var t6 = false;
      h2.forEach(function(n4, r3) {
        t6 || d2.length >= n4.length && d2.slice(0, n4.length) === n4 && (p2 += m2[h2[r3]], d2 = d2.slice(n4.length, d2.length), t6 = true);
      }), t6 || (p2 += d2.slice(0, 1), d2 = d2.slice(1, d2.length));
    }; d2; ) g2();
    return p2;
  };
})), import_dist$2 = __toESM$2(require_dist$2()), latexSymbols$2 = { Alpha: `A`, alpha: `\\alpha`, Beta: `B`, beta: `\\beta`, Gamma: `\\Gamma`, gamma: `\\gamma`, Delta: `\\Delta`, delta: `\\delta`, Epsilon: `E`, epsilon: `\\epsilon`, varepsilon: `\\varepsilon`, Zeta: `Z`, zeta: `\\zeta`, Eta: `H`, eta: `\\eta`, Theta: `\\Theta`, theta: `\\theta`, vartheta: `\\vartheta`, Iota: `I`, iota: `\\iota`, Kappa: `K`, kappa: `\\kappa`, varkappa: `\\varkappa`, Lambda: `\\Lambda`, lambda: `\\lambda`, Mu: `M`, mu: `\\mu`, Nu: `N`, nu: `\\nu`, Xi: `\\Xi`, xi: `\\xi`, Omicron: `O`, omicron: `o`, Pi: `\\Pi`, pi: `\\pi`, varpi: `\\varpi`, Rho: `P`, rho: `\\rho`, varrho: `\\varrho`, Sigma: `\\Sigma`, sigma: `\\sigma`, varsigma: `\\varsigma`, Tau: `T`, tau: `\\tau`, Upsilon: `\\Upsilon`, upsilon: `\\upsilon`, Phi: `\\Phi`, phi: `\\phi`, varphi: `\\varphi`, Chi: `X`, chi: `\\chi`, Psi: `\\Psi`, psi: `\\psi`, Omega: `\\Omega`, omega: `\\omega`, true: `\\mathrm{True}`, false: `\\mathrm{False}`, i: `i`, inf: `\\infty`, Inf: `\\infty`, infinity: `\\infty`, Infinity: `\\infty`, oo: `\\infty`, lim: `\\lim`, undefined: `\\mathbf{?}` }, latexOperators$2 = { transpose: `^\\top`, ctranspose: `^H`, factorial: `!`, pow: `^`, dotPow: `.^\\wedge`, unaryPlus: `+`, unaryMinus: `-`, bitNot: `\\~`, not: `\\neg`, multiply: `\\cdot`, divide: `\\frac`, dotMultiply: `.\\cdot`, dotDivide: `.:`, mod: `\\mod`, add: `+`, subtract: `-`, to: `\\rightarrow`, leftShift: `<<`, rightArithShift: `>>`, rightLogShift: `>>>`, equal: `=`, unequal: `\\neq`, smaller: `<`, larger: `>`, smallerEq: `\\leq`, largerEq: `\\geq`, bitAnd: `\\&`, bitXor: `\\underline{|}`, bitOr: `|`, and: `\\wedge`, xor: `\\veebar`, or: `\\vee` }, latexFunctions$2 = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: `\\left(\${args[0]}${latexOperators$2.add}\${args[1]}\\right)` }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: `\\left(\${args[0]}${latexOperators$2.dotDivide}\${args[1]}\\right)` }, dotMultiply: { 2: `\\left(\${args[0]}${latexOperators$2.dotMultiply}\${args[1]}\\right)` }, dotPow: { 2: `\\left(\${args[0]}${latexOperators$2.dotPow}\${args[1]}\\right)` }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: `\\left(e${latexOperators$2.pow}{\${args[0]}}-1\\right)`, fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: `\\left(\${args[0]}${latexOperators$2.mod}\${args[1]}\\right)` }, multiply: { 2: `\\left(\${args[0]}${latexOperators$2.multiply}\${args[1]}\\right)` }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: `\\left(\${args[0]}\\right)${latexOperators$2.pow}{\${args[1]}}` }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: `\\left(\${args[0]}${latexOperators$2.subtract}\${args[1]}\\right)` }, unaryMinus: { 1: `${latexOperators$2.unaryMinus}\\left(\${args[0]}\\right)` }, unaryPlus: { 1: `${latexOperators$2.unaryPlus}\\left(\${args[0]}\\right)` }, bitAnd: { 2: `\\left(\${args[0]}${latexOperators$2.bitAnd}\${args[1]}\\right)` }, bitNot: { 1: latexOperators$2.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: `\\left(\${args[0]}${latexOperators$2.bitOr}\${args[1]}\\right)` }, bitXor: { 2: `\\left(\${args[0]}${latexOperators$2.bitXor}\${args[1]}\\right)` }, leftShift: { 2: `\\left(\${args[0]}${latexOperators$2.leftShift}\${args[1]}\\right)` }, rightArithShift: { 2: `\\left(\${args[0]}${latexOperators$2.rightArithShift}\${args[1]}\\right)` }, rightLogShift: { 2: `\\left(\${args[0]}${latexOperators$2.rightLogShift}\${args[1]}\\right)` }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: `\\left(\${args[0]}${latexOperators$2.and}\${args[1]}\\right)` }, not: { 1: latexOperators$2.not + "\\left(${args[0]}\\right)" }, or: { 2: `\\left(\${args[0]}${latexOperators$2.or}\${args[1]}\\right)` }, xor: { 2: `\\left(\${args[0]}${latexOperators$2.xor}\${args[1]}\\right)` }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: `\\left(\${args[0]}\\right)${latexOperators$2.ctranspose}` }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: `{\${args[0]}}${latexOperators$2.pow}{\\frac{1}{2}}` }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: `\\left(\${args[0]}\\right)${latexOperators$2.transpose}` }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: `\\left(\${args[0]}\\right)${latexOperators$2.factorial}` }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: `\\left(\${args[0]}${latexOperators$2.equal}\${args[1]}\\right)` }, larger: { 2: `\\left(\${args[0]}${latexOperators$2.larger}\${args[1]}\\right)` }, largerEq: { 2: `\\left(\${args[0]}${latexOperators$2.largerEq}\${args[1]}\\right)` }, smaller: { 2: `\\left(\${args[0]}${latexOperators$2.smaller}\${args[1]}\\right)` }, smallerEq: { 2: `\\left(\${args[0]}${latexOperators$2.smallerEq}\${args[1]}\\right)` }, unequal: { 2: `\\left(\${args[0]}${latexOperators$2.unequal}\${args[1]}\\right)` }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: `\\left(\${args[0]}${latexOperators$2.to}\${args[1]}\\right)` }, numeric: function(t4, n2) {
  return t4.args[0].toTex();
}, number: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: `\\mathtt{""}`, 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, bigint: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, complex: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: `\\left(\\left(\${args[0]}\\right)+${latexSymbols$2.i}\\cdot\\left(\${args[1]}\\right)\\right)` }, matrix: { 0: `\\begin{bmatrix}\\end{bmatrix}`, 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: `\\begin{bsparse}\\end{bsparse}`, 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate$2 = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits$2 = { deg: `^\\circ` };
function escapeLatex$2(t4) {
  return (0, import_dist$2.default)(t4, { preserveFormatting: true });
}
function toSymbol$2(t4, n2) {
  return n2 = n2 === void 0 ? false : n2, n2 ? hasOwnProperty$1$4(latexUnits$2, t4) ? latexUnits$2[t4] : `\\mathrm{` + escapeLatex$2(t4) + `}` : hasOwnProperty$1$4(latexSymbols$2, t4) ? latexSymbols$2[t4] : escapeLatex$2(t4);
}
var name$106$2 = `ConstantNode`, dependencies$106$2 = [`Node`, `isBounded`], createConstantNode$2 = factory$2(name$106$2, dependencies$106$2, (t4) => {
  var { Node: n2, isBounded: r2 } = t4;
  class i2 extends n2 {
    constructor(t5) {
      super(), this.value = t5;
    }
    get type() {
      return name$106$2;
    }
    get isConstantNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.value;
      return function() {
        return r3;
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    clone() {
      return new i2(this.value);
    }
    _toString(t5) {
      return format$4(this.value, t5);
    }
    _toHTML(t5) {
      var n3 = this._toString(t5);
      switch (typeOf$2(this.value)) {
        case `number`:
        case `bigint`:
        case `BigNumber`:
        case `Fraction`:
          return `<span class="math-number">` + n3 + `</span>`;
        case `string`:
          return `<span class="math-string">` + n3 + `</span>`;
        case `boolean`:
          return `<span class="math-boolean">` + n3 + `</span>`;
        case `null`:
          return `<span class="math-null-symbol">` + n3 + `</span>`;
        case `undefined`:
          return `<span class="math-undefined">` + n3 + `</span>`;
        default:
          return `<span class="math-symbol">` + n3 + `</span>`;
      }
    }
    toJSON() {
      return { mathjs: name$106$2, value: this.value };
    }
    static fromJSON(t5) {
      return new i2(t5.value);
    }
    _toTex(t5) {
      var n3 = this._toString(t5);
      switch (typeOf$2(this.value)) {
        case `string`:
          return `\\mathtt{` + escapeLatex$2(n3) + `}`;
        case `number`:
        case `BigNumber`:
          if (!r2(this.value)) return this.value.valueOf() < 0 ? `-\\infty` : `\\infty`;
          var i3 = n3.toLowerCase().indexOf(`e`);
          return i3 === -1 ? n3 : n3.substring(0, i3) + `\\cdot10^{` + n3.substring(i3 + 1) + `}`;
        case `bigint`:
          return n3.toString();
        case `Fraction`:
          return this.value.toLatex();
        default:
          return n3;
      }
    }
  }
  return _defineProperty$4(i2, `name`, name$106$2), i2;
}, { isClass: true, isNode: true }), name$105$2 = `FunctionAssignmentNode`, dependencies$105$2 = [`typed`, `Node`], createFunctionAssignmentNode$2 = factory$2(name$105$2, dependencies$105$2, (t4) => {
  var { typed: n2, Node: r2 } = t4;
  function i2(t5, n3, r3) {
    var i3 = getPrecedence$2(t5, n3, r3), a3 = getPrecedence$2(t5.expr, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class a2 extends r2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      if (!Array.isArray(n3)) throw TypeError(`Array containing strings or objects expected for parameter "params"`);
      if (!isNode$5(r3)) throw TypeError(`Node expected for parameter "expr"`);
      if (keywords$2.has(t5)) throw Error(`Illegal function name, "` + t5 + `" is a reserved keyword`);
      var i3 = /* @__PURE__ */ new Set();
      for (var a3 of n3) {
        var o2 = typeof a3 == `string` ? a3 : a3.name;
        if (i3.has(o2)) throw Error(`Duplicate parameter name "${o2}"`);
        i3.add(o2);
      }
      this.name = t5, this.params = n3.map(function(t6) {
        return t6 && t6.name || t6;
      }), this.types = n3.map(function(t6) {
        return t6 && t6.type || `any`;
      }), this.expr = r3;
    }
    get type() {
      return name$105$2;
    }
    get isFunctionAssignmentNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = Object.create(r3);
      forEach$2(this.params, function(t6) {
        i3[t6] = true;
      });
      var a3 = this.expr, o2 = a3._compile(t5, i3), s2 = this.name, c2 = this.params, l2 = join$5(this.types, `,`), u2 = s2 + `(` + join$5(this.params, `, `) + `)`;
      return function(t6, r4, i4) {
        var d2 = {};
        d2[l2] = function() {
          for (var n3 = Object.create(r4), a4 = 0; a4 < c2.length; a4++) n3[c2[a4]] = arguments[a4];
          return o2(t6, n3, i4);
        };
        var p2 = n2(s2, d2);
        return p2.syntax = u2, p2.expr = a3.toString(), t6.set(s2, p2), p2;
      };
    }
    forEach(t5) {
      t5(this.expr, `expr`, this);
    }
    map(t5) {
      var n3 = this._ifNode(t5(this.expr, `expr`, this));
      return new a2(this.name, this.params.slice(0), n3);
    }
    clone() {
      return new a2(this.name, this.params.slice(0), this.expr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toString(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `(` + r3 + `)`), this.name + `(` + this.params.join(`, `) + `) = ` + r3;
    }
    toJSON() {
      var t5 = this.types;
      return { mathjs: name$105$2, name: this.name, params: this.params.map(function(n3, r3) {
        return { name: n3, type: t5[r3] };
      }), expr: this.expr };
    }
    static fromJSON(t5) {
      return new a2(t5.name, t5.params, t5.expr);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = [], a3 = 0; a3 < this.params.length; a3++) r3.push(`<span class="math-symbol math-parameter">` + escape$4(this.params[a3]) + `</span>`);
      var o2 = this.expr.toHTML(t5);
      return i2(this, n3, t5 && t5.implicit) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), `<span class="math-function">` + escape$4(this.name) + `</span><span class="math-parenthesis math-round-parenthesis">(</span>` + r3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + o2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toTex(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `\\left(${r3}\\right)`), `\\mathrm{` + this.name + `}\\left(` + this.params.map(toSymbol$2).join(`,`) + `\\right)=` + r3;
    }
  }
  return _defineProperty$4(a2, `name`, name$105$2), a2;
}, { isClass: true, isNode: true }), name$104$2 = `IndexNode`, dependencies$104$2 = [`Node`, `size`], createIndexNode$2 = factory$2(name$104$2, dependencies$104$2, (t4) => {
  var { Node: n2, size: r2 } = t4;
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), this.dimensions = t5, this.dotNotation = n3 || false, !Array.isArray(t5) || !t5.every(isNode$5)) throw TypeError(`Array containing Nodes expected for parameter "dimensions"`);
      if (this.dotNotation && !this.isObjectProperty()) throw Error(`dotNotation only applicable for object properties`);
    }
    get type() {
      return name$104$2;
    }
    get isIndexNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = map$1$2(this.dimensions, function(i4, a3) {
        if (i4.filter((t6) => t6.isSymbolNode && t6.name === `end`).length > 0) {
          var o2 = Object.create(n3);
          o2.end = true;
          var s2 = i4._compile(t5, o2);
          return function(t6, n4, i5) {
            if (!isMatrix$2(i5) && !isArray$3(i5) && !isString$2(i5)) throw TypeError(`Cannot resolve "end": context must be a Matrix, Array, or string but is ` + typeOf$2(i5));
            var o3 = r2(i5), c2 = Object.create(n4);
            return c2.end = o3[a3], s2(t6, c2, i5);
          };
        } else return i4._compile(t5, n3);
      }), a2 = getSafeProperty$2(t5, `index`);
      return function(t6, n4, r3) {
        return a2(...map$1$2(i3, function(i4) {
          return i4(t6, n4, r3);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.dimensions.length; n3++) t5(this.dimensions[n3], `dimensions[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this._ifNode(t5(this.dimensions[r3], `dimensions[` + r3 + `]`, this));
      return new i2(n3, this.dotNotation);
    }
    clone() {
      return new i2(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return this.dimensions.length === 1 && isConstantNode$2(this.dimensions[0]) && typeof this.dimensions[0].value == `string`;
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(t5) {
      return this.dotNotation ? `.` + this.getObjectProperty() : `[` + this.dimensions.join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$104$2, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(t5) {
      return new i2(t5.dimensions, t5.dotNotation);
    }
    _toHTML(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this.dimensions[r3].toHTML();
      return this.dotNotation ? `<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">` + escape$4(this.getObjectProperty()) + `</span>` : `<span class="math-parenthesis math-square-parenthesis">[</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      var n3 = this.dimensions.map(function(n4) {
        return n4.toTex(t5);
      });
      return this.dotNotation ? `.` + this.getObjectProperty() : `_{` + n3.join(`,`) + `}`;
    }
  }
  return _defineProperty$4(i2, `name`, name$104$2), i2;
}, { isClass: true, isNode: true }), name$103$2 = `ObjectNode`, dependencies$103$2 = [`Node`], createObjectNode$2 = factory$2(name$103$2, dependencies$103$2, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.properties = t5 || {}, t5 && (typeof t5 != `object` || !Object.keys(t5).every(function(n3) {
        return isNode$5(t5[n3]);
      }))) throw TypeError(`Object containing Nodes expected`);
    }
    get type() {
      return name$103$2;
    }
    get isObjectNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = {};
      for (var i2 in this.properties) if (hasOwnProperty$1$4(this.properties, i2)) {
        var a2 = stringify$2(i2), o2 = JSON.parse(a2);
        r3[o2] = getSafeProperty$2(this.properties, i2)._compile(t5, n3);
      }
      return function(t6, n4, i3) {
        var a3 = {};
        for (var o3 in r3) hasOwnProperty$1$4(r3, o3) && (a3[o3] = r3[o3](t6, n4, i3));
        return a3;
      };
    }
    forEach(t5) {
      for (var n3 in this.properties) hasOwnProperty$1$4(this.properties, n3) && t5(this.properties[n3], `properties[` + stringify$2(n3) + `]`, this);
    }
    map(t5) {
      var n3 = {};
      for (var i2 in this.properties) hasOwnProperty$1$4(this.properties, i2) && (n3[i2] = this._ifNode(t5(this.properties[i2], `properties[` + stringify$2(i2) + `]`, this)));
      return new r2(n3);
    }
    clone() {
      var t5 = {};
      for (var n3 in this.properties) hasOwnProperty$1$4(this.properties, n3) && (t5[n3] = this.properties[n3]);
      return new r2(t5);
    }
    _toString(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$4(this.properties, r3) && n3.push(stringify$2(r3) + `: ` + this.properties[r3].toString(t5));
      return `{` + n3.join(`, `) + `}`;
    }
    toJSON() {
      return { mathjs: name$103$2, properties: this.properties };
    }
    static fromJSON(t5) {
      return new r2(t5.properties);
    }
    _toHTML(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$4(this.properties, r3) && n3.push(`<span class="math-symbol math-property">` + escape$4(r3) + `</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>` + this.properties[r3].toHTML(t5));
      return `<span class="math-parenthesis math-curly-parenthesis">{</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-curly-parenthesis">}</span>`;
    }
    _toTex(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$4(this.properties, r3) && n3.push(`\\mathbf{` + r3 + `:} & ` + this.properties[r3].toTex(t5) + `\\\\`);
      return `\\left\\{\\begin{array}{ll}` + n3.join(`
`) + `\\end{array}\\right\\}`;
    }
  }
  return _defineProperty$4(r2, `name`, name$103$2), r2;
}, { isClass: true, isNode: true });
function createSubScope$2(t4, n2) {
  return new PartitionedMap$2(t4, new ObjectWrappingMap$2(n2), new Set(Object.keys(n2)));
}
var name$102$2 = `OperatorNode`, dependencies$102$2 = [`Node`], createOperatorNode$2 = factory$2(name$102$2, dependencies$102$2, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3) {
    var i3 = t5;
    if (n3 === `auto`) for (; isParenthesisNode$2(i3); ) i3 = i3.content;
    return isConstantNode$2(i3) ? true : isOperatorNode$2(i3) ? r2(i3.args[0], n3) : false;
  }
  function i2(t5, n3, i3, a3, o2) {
    var s2 = getPrecedence$2(t5, n3, i3), c2 = getAssociativity$2(t5, n3);
    if (n3 === `all` || a3.length > 2 && t5.getIdentifier() !== `OperatorNode:add` && t5.getIdentifier() !== `OperatorNode:multiply`) return a3.map(function(t6) {
      switch (t6.getContent().type) {
        case `ArrayNode`:
        case `ConstantNode`:
        case `SymbolNode`:
        case `ParenthesisNode`:
          return false;
        default:
          return true;
      }
    });
    var l2;
    switch (a3.length) {
      case 0:
        l2 = [];
        break;
      case 1:
        var u2 = getPrecedence$2(a3[0], n3, i3, t5);
        if (o2 && u2 !== null) {
          var d2, p2;
          if (n3 === `keep` ? (d2 = a3[0].getIdentifier(), p2 = t5.getIdentifier()) : (d2 = a3[0].getContent().getIdentifier(), p2 = t5.getContent().getIdentifier()), properties$2[s2][p2].latexLeftParens === false) {
            l2 = [false];
            break;
          }
          if (properties$2[u2][d2].latexParens === false) {
            l2 = [false];
            break;
          }
        }
        if (u2 === null) {
          l2 = [false];
          break;
        }
        if (u2 <= s2) {
          l2 = [true];
          break;
        }
        l2 = [false];
        break;
      case 2:
        var m2, h2 = getPrecedence$2(a3[0], n3, i3, t5), g2 = isAssociativeWith$2(t5, a3[0], n3);
        m2 = h2 === null ? false : h2 === s2 && c2 === `right` && !g2 ? true : h2 < s2;
        var v2, y2 = getPrecedence$2(a3[1], n3, i3, t5), b2 = isAssociativeWith$2(t5, a3[1], n3);
        if (v2 = y2 === null ? false : y2 === s2 && c2 === `left` && !b2 ? true : y2 < s2, o2) {
          var x2, S2, w2;
          n3 === `keep` ? (x2 = t5.getIdentifier(), S2 = t5.args[0].getIdentifier(), w2 = t5.args[1].getIdentifier()) : (x2 = t5.getContent().getIdentifier(), S2 = t5.args[0].getContent().getIdentifier(), w2 = t5.args[1].getContent().getIdentifier()), h2 !== null && (properties$2[s2][x2].latexLeftParens === false && (m2 = false), properties$2[h2][S2].latexParens === false && (m2 = false)), y2 !== null && (properties$2[s2][x2].latexRightParens === false && (v2 = false), properties$2[y2][w2].latexParens === false && (v2 = false));
        }
        l2 = [m2, v2];
        break;
      default:
        (t5.getIdentifier() === `OperatorNode:add` || t5.getIdentifier() === `OperatorNode:multiply`) && (l2 = a3.map(function(r3) {
          var a4 = getPrecedence$2(r3, n3, i3, t5), o3 = isAssociativeWith$2(t5, r3, n3), l3 = getAssociativity$2(r3, n3);
          return a4 === null ? false : s2 === a4 && c2 === l3 && !o3 ? true : a4 < s2;
        }));
        break;
    }
    if (a3.length >= 2 && t5.getIdentifier() === `OperatorNode:multiply` && t5.implicit && n3 !== `all` && i3 === `hide`) for (var E = 1; E < l2.length; ++E) r2(a3[E], n3) && !l2[E - 1] && (n3 !== `keep` || !isParenthesisNode$2(a3[E - 1])) && (l2[E] = true);
    return l2;
  }
  class a2 extends n2 {
    constructor(t5, n3, r3, i3, a3) {
      if (super(), typeof t5 != `string`) throw TypeError(`string expected for parameter "op"`);
      if (typeof n3 != `string`) throw TypeError(`string expected for parameter "fn"`);
      if (!Array.isArray(r3) || !r3.every(isNode$5)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      this.implicit = i3 === true, this.isPercentage = a3 === true, this.op = t5, this.fn = n3, this.args = r3 || [];
    }
    get type() {
      return name$102$2;
    }
    get isOperatorNode() {
      return true;
    }
    _compile(t5, n3) {
      if (typeof this.fn != `string` || !isSafeMethod$2(t5, this.fn)) throw t5[this.fn] ? Error(`No access to function "` + this.fn + `"`) : Error(`Function ` + this.fn + ` missing in provided namespace "math"`);
      var r3 = getSafeProperty$2(t5, this.fn), i3 = map$1$2(this.args, function(r4) {
        return r4._compile(t5, n3);
      });
      if (typeof r3 == `function` && r3.rawArgs === true) {
        var a3 = this.args;
        return function(n4, i4, o3) {
          return r3(a3, t5, createSubScope$2(n4, i4));
        };
      } else if (i3.length === 1) {
        var o2 = i3[0];
        return function(t6, n4, i4) {
          return r3(o2(t6, n4, i4));
        };
      } else if (i3.length === 2) {
        var s2 = i3[0], c2 = i3[1];
        return function(t6, n4, i4) {
          return r3(s2(t6, n4, i4), c2(t6, n4, i4));
        };
      } else return function(t6, n4, a4) {
        return r3.apply(null, map$1$2(i3, function(r4) {
          return r4(t6, n4, a4);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.args.length; r3++) n3[r3] = this._ifNode(t5(this.args[r3], `args[` + r3 + `]`, this));
      return new a2(this.op, this.fn, n3, this.implicit, this.isPercentage);
    }
    clone() {
      return new a2(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return this.args.length === 1;
    }
    isBinary() {
      return this.args.length === 2;
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity$2(this, n3), c2 = a3[0].toString(t5);
        o2[0] && (c2 = `(` + c2 + `)`);
        var l2 = /[a-zA-Z]+/.test(this.op);
        return s2 === `right` ? this.op + (l2 ? ` ` : ``) + c2 : s2 === `left` ? c2 + (l2 ? ` ` : ``) + this.op : c2 + this.op;
      } else if (a3.length === 2) {
        var u2 = a3[0].toString(t5), d2 = a3[1].toString(t5);
        return o2[0] && (u2 = `(` + u2 + `)`), o2[1] && (d2 = `(` + d2 + `)`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? u2 + ` ` + d2 : u2 + ` ` + this.op + ` ` + d2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var p2 = a3.map(function(n4, r4) {
          return n4 = n4.toString(t5), o2[r4] && (n4 = `(` + n4 + `)`), n4;
        });
        return this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? p2.join(` `) : p2.join(` ` + this.op + ` `);
      } else return this.fn + `(` + this.args.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$102$2, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(t5) {
      return new a2(t5.op, t5.fn, t5.args, t5.implicit, t5.isPercentage);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity$2(this, n3), c2 = a3[0].toHTML(t5);
        return o2[0] && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), s2 === `right` ? `<span class="math-operator math-unary-operator math-lefthand-unary-operator">` + escape$4(this.op) + `</span>` + c2 : c2 + `<span class="math-operator math-unary-operator math-righthand-unary-operator">` + escape$4(this.op) + `</span>`;
      } else if (a3.length === 2) {
        var l2 = a3[0].toHTML(t5), u2 = a3[1].toHTML(t5);
        return o2[0] && (l2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + l2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), o2[1] && (u2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + u2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? l2 + `<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>` + u2 : l2 + `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$4(this.op) + `</span>` + u2;
      } else {
        var d2 = a3.map(function(n4, r4) {
          return n4 = n4.toHTML(t5), o2[r4] && (n4 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n4 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n4;
        });
        return a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`) ? this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? d2.join(`<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>`) : d2.join(`<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$4(this.op) + `</span>`) : `<span class="math-function">` + escape$4(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + d2.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
      }
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, true), s2 = latexOperators$2[this.fn];
      if (s2 = s2 === void 0 ? this.op : s2, a3.length === 1) {
        var c2 = getAssociativity$2(this, n3), l2 = a3[0].toTex(t5);
        return o2[0] && (l2 = `\\left(${l2}\\right)`), c2 === `right` ? s2 + l2 : l2 + s2;
      } else if (a3.length === 2) {
        var u2 = a3[0], d2 = u2.toTex(t5);
        o2[0] && (d2 = `\\left(${d2}\\right)`);
        var p2 = a3[1].toTex(t5);
        o2[1] && (p2 = `\\left(${p2}\\right)`);
        var m2 = n3 === `keep` ? u2.getIdentifier() : u2.getContent().getIdentifier();
        switch (this.getIdentifier()) {
          case `OperatorNode:divide`:
            return s2 + `{` + d2 + `}{` + p2 + `}`;
          case `OperatorNode:pow`:
            switch (d2 = `{` + d2 + `}`, p2 = `{` + p2 + `}`, m2) {
              case `ConditionalNode`:
              case `OperatorNode:divide`:
                d2 = `\\left(${d2}\\right)`;
            }
            break;
          case `OperatorNode:multiply`:
            if (this.implicit && r3 === `hide`) return d2 + `~` + p2;
        }
        return d2 + s2 + p2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var h2 = a3.map(function(n4, r4) {
          return n4 = n4.toTex(t5), o2[r4] && (n4 = `\\left(${n4}\\right)`), n4;
        });
        return this.getIdentifier() === `OperatorNode:multiply` && this.implicit && r3 === `hide` ? h2.join(`~`) : h2.join(s2);
      } else return `\\mathrm{` + this.fn + `}\\left(` + a3.map(function(n4) {
        return n4.toTex(t5);
      }).join(`,`) + `\\right)`;
    }
    getIdentifier() {
      return this.type + `:` + this.fn;
    }
  }
  return _defineProperty$4(a2, `name`, name$102$2), a2;
}, { isClass: true, isNode: true }), name$101$2 = `ParenthesisNode`, dependencies$101$2 = [`Node`], createParenthesisNode$2 = factory$2(name$101$2, dependencies$101$2, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), !isNode$5(t5)) throw TypeError(`Node expected for parameter "content"`);
      this.content = t5;
    }
    get type() {
      return name$101$2;
    }
    get isParenthesisNode() {
      return true;
    }
    _compile(t5, n3) {
      return this.content._compile(t5, n3);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(t5) {
      t5(this.content, `content`, this);
    }
    map(t5) {
      return new r2(t5(this.content, `content`, this));
    }
    clone() {
      return new r2(this.content);
    }
    _toString(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `(` + this.content.toString(t5) + `)` : this.content.toString(t5);
    }
    toJSON() {
      return { mathjs: name$101$2, content: this.content };
    }
    static fromJSON(t5) {
      return new r2(t5.content);
    }
    _toHTML(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + this.content.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : this.content.toHTML(t5);
    }
    _toTex(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `\\left(${this.content.toTex(t5)}\\right)` : this.content.toTex(t5);
    }
  }
  return _defineProperty$4(r2, `name`, name$101$2), r2;
}, { isClass: true, isNode: true }), name$100$2 = `RangeNode`, dependencies$100$2 = [`Node`], createRangeNode$2 = factory$2(name$100$2, dependencies$100$2, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3, r3) {
    var i3 = getPrecedence$2(t5, n3, r3), a2 = {}, o2 = getPrecedence$2(t5.start, n3, r3);
    if (a2.start = o2 !== null && o2 <= i3 || n3 === `all`, t5.step) {
      var s2 = getPrecedence$2(t5.step, n3, r3);
      a2.step = s2 !== null && s2 <= i3 || n3 === `all`;
    }
    var c2 = getPrecedence$2(t5.end, n3, r3);
    return a2.end = c2 !== null && c2 <= i3 || n3 === `all`, a2;
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$5(t5) || !isNode$5(n3) || r3 && !isNode$5(r3)) throw TypeError(`Node expected`);
      if (arguments.length > 3) throw Error(`Too many arguments`);
      this.start = t5, this.end = n3, this.step = r3 || null;
    }
    get type() {
      return name$100$2;
    }
    get isRangeNode() {
      return true;
    }
    needsEnd() {
      return this.filter(function(t5) {
        return isSymbolNode$2(t5) && t5.name === `end`;
      }).length > 0;
    }
    _compile(t5, n3) {
      var r3 = t5.range, i3 = this.start._compile(t5, n3), a2 = this.end._compile(t5, n3);
      if (this.step) {
        var o2 = this.step._compile(t5, n3);
        return function(t6, n4, s2) {
          return r3(i3(t6, n4, s2), a2(t6, n4, s2), o2(t6, n4, s2));
        };
      } else return function(t6, n4, o3) {
        return r3(i3(t6, n4, o3), a2(t6, n4, o3));
      };
    }
    forEach(t5) {
      t5(this.start, `start`, this), t5(this.end, `end`, this), this.step && t5(this.step, `step`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.start, `start`, this)), this._ifNode(t5(this.end, `end`, this)), this.step && this._ifNode(t5(this.step, `step`, this)));
    }
    clone() {
      return new i2(this.start, this.end, this.step && this.step);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toString(t5);
      if (i3.start && (o2 = `(` + o2 + `)`), a2 = o2, this.step) {
        var s2 = this.step.toString(t5);
        i3.step && (s2 = `(` + s2 + `)`), a2 += `:` + s2;
      }
      var c2 = this.end.toString(t5);
      return i3.end && (c2 = `(` + c2 + `)`), a2 += `:` + c2, a2;
    }
    toJSON() {
      return { mathjs: name$100$2, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(t5) {
      return new i2(t5.start, t5.end, t5.step);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toHTML(t5);
      if (i3.start && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 = o2, this.step) {
        var s2 = this.step.toHTML(t5);
        i3.step && (s2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + s2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + s2;
      }
      var c2 = this.end.toHTML(t5);
      return i3.end && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + c2, a2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2 = this.start.toTex(t5);
      if (i3.start && (a2 = `\\left(${a2}\\right)`), this.step) {
        var o2 = this.step.toTex(t5);
        i3.step && (o2 = `\\left(${o2}\\right)`), a2 += `:` + o2;
      }
      var s2 = this.end.toTex(t5);
      return i3.end && (s2 = `\\left(${s2}\\right)`), a2 += `:` + s2, a2;
    }
  }
  return _defineProperty$4(i2, `name`, name$100$2), i2;
}, { isClass: true, isNode: true }), name$99$2 = `RelationalNode`, dependencies$99$2 = [`Node`], createRelationalNode$2 = factory$2(name$99$2, dependencies$99$2, (t4) => {
  var { Node: n2 } = t4, r2 = { equal: `==`, unequal: `!=`, smaller: `<`, larger: `>`, smallerEq: `<=`, largerEq: `>=` };
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), !Array.isArray(t5)) throw TypeError(`Parameter conditionals must be an array`);
      if (!Array.isArray(n3)) throw TypeError(`Parameter params must be an array`);
      if (t5.length !== n3.length - 1) throw TypeError(`Parameter params must contain exactly one more element than parameter conditionals`);
      this.conditionals = t5, this.params = n3;
    }
    get type() {
      return name$99$2;
    }
    get isRelationalNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this, i3 = this.params.map((r4) => r4._compile(t5, n3));
      return function(n4, a2, o2) {
        for (var s2, c2 = i3[0](n4, a2, o2), l2 = 0; l2 < r3.conditionals.length; l2++) if (s2 = c2, c2 = i3[l2 + 1](n4, a2, o2), !getSafeProperty$2(t5, r3.conditionals[l2])(s2, c2)) return false;
        return true;
      };
    }
    forEach(t5) {
      this.params.forEach((n3, r3) => t5(n3, `params[` + r3 + `]`, this), this);
    }
    map(t5) {
      return new i2(this.conditionals.slice(), this.params.map((n3, r3) => this._ifNode(t5(n3, `params[` + r3 + `]`, this)), this));
    }
    clone() {
      return new i2(this.conditionals, this.params);
    }
    _toString(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence$2(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence$2(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `(` + r3.toString(t5) + `)` : r3.toString(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += ` ` + r2[this.conditionals[s2]], o2 += ` ` + a2[s2 + 1];
      return o2;
    }
    toJSON() {
      return { mathjs: name$99$2, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(t5) {
      return new i2(t5.conditionals, t5.params);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence$2(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence$2(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + r3.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : r3.toHTML(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$4(r2[this.conditionals[s2]]) + `</span>` + a2[s2 + 1];
      return o2;
    }
    _toTex(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$2(this, n3, t5 && t5.implicit), i3 = this.params.map(function(i4, a3) {
        var o3 = getPrecedence$2(i4, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= r3 ? `\\left(` + i4.toTex(t5) + `\right)` : i4.toTex(t5);
      }), a2 = i3[0], o2 = 0; o2 < this.conditionals.length; o2++) a2 += latexOperators$2[this.conditionals[o2]] + i3[o2 + 1];
      return a2;
    }
  }
  return _defineProperty$4(i2, `name`, name$99$2), i2;
}, { isClass: true, isNode: true }), name$98$2 = `SymbolNode`, dependencies$98$2 = [`math`, `?Unit`, `Node`], createSymbolNode$2 = factory$2(name$98$2, dependencies$98$2, (t4) => {
  var { math: n2, Unit: r2, Node: i2 } = t4;
  function a2(t5) {
    return r2 ? r2.isValuelessUnit(t5) : false;
  }
  class o2 extends i2 {
    constructor(t5) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      this.name = t5;
    }
    get type() {
      return `SymbolNode`;
    }
    get isSymbolNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.name;
      if (n3[i3] === true) return function(t6, n4, r3) {
        return getSafeProperty$2(n4, i3);
      };
      if (i3 in t5) return function(n4, r3, a3) {
        return n4.has(i3) ? n4.get(i3) : getSafeProperty$2(t5, i3);
      };
      var s2 = a2(i3);
      return function(t6, n4, a3) {
        return t6.has(i3) ? t6.get(i3) : s2 ? new r2(null, i3) : o2.onUndefinedSymbol(i3);
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    static onUndefinedSymbol(t5) {
      throw Error(`Undefined symbol ` + t5);
    }
    clone() {
      return new o2(this.name);
    }
    _toString(t5) {
      return this.name;
    }
    _toHTML(t5) {
      var n3 = escape$4(this.name);
      return n3 === `true` || n3 === `false` ? `<span class="math-symbol math-boolean">` + n3 + `</span>` : n3 === `i` ? `<span class="math-symbol math-imaginary-symbol">` + n3 + `</span>` : n3 === `Infinity` ? `<span class="math-symbol math-infinity-symbol">` + n3 + `</span>` : n3 === `NaN` ? `<span class="math-symbol math-nan-symbol">` + n3 + `</span>` : n3 === `null` ? `<span class="math-symbol math-null-symbol">` + n3 + `</span>` : n3 === `undefined` ? `<span class="math-symbol math-undefined-symbol">` + n3 + `</span>` : `<span class="math-symbol">` + n3 + `</span>`;
    }
    toJSON() {
      return { mathjs: `SymbolNode`, name: this.name };
    }
    static fromJSON(t5) {
      return new o2(t5.name);
    }
    _toTex(t5) {
      var r3 = false;
      n2[this.name] === void 0 && a2(this.name) && (r3 = true);
      var i3 = toSymbol$2(this.name, r3);
      return i3[0] === `\\` ? i3 : ` ` + i3;
    }
  }
  return o2;
}, { isClass: true, isNode: true }), name$97$2 = `FunctionNode`, dependencies$97$2 = [`math`, `Node`, `SymbolNode`], createFunctionNode$2 = factory$2(name$97$2, dependencies$97$2, (t4) => {
  var n2, { math: r2, Node: i2, SymbolNode: a2 } = t4, o2 = (t5) => format$4(t5, { truncate: 78 });
  function s2(t5, n3, r3) {
    for (var i3 = ``, a3 = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, o3 = 0, s3; (s3 = a3.exec(t5)) !== null; ) if (i3 += t5.substring(o3, s3.index), o3 = s3.index, s3[0] === `$$`) i3 += `$`, o3++;
    else {
      o3 += s3[0].length;
      var c3 = n3[s3[1]];
      if (!c3) throw ReferenceError(`Template: Property ` + s3[1] + ` does not exist.`);
      if (s3[2] === void 0) switch (typeof c3) {
        case `string`:
          i3 += c3;
          break;
        case `object`:
          if (isNode$5(c3)) i3 += c3.toTex(r3);
          else if (Array.isArray(c3)) i3 += c3.map(function(t6, n4) {
            if (isNode$5(t6)) return t6.toTex(r3);
            throw TypeError(`Template: ` + s3[1] + `[` + n4 + `] is not a Node.`);
          }).join(`,`);
          else throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
          break;
        default:
          throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
      }
      else if (isNode$5(c3[s3[2]] && c3[s3[2]])) i3 += c3[s3[2]].toTex(r3);
      else throw TypeError(`Template: ` + s3[1] + `[` + s3[2] + `] is not a Node.`);
    }
    return i3 += t5.slice(o3), i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 == `string` && (t5 = new a2(t5)), !isNode$5(t5)) throw TypeError(`Node expected as parameter "fn"`);
      if (!Array.isArray(n3) || !n3.every(isNode$5)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      var i3 = typeof r3;
      if (!(i3 === `undefined` || i3 === `boolean`)) throw TypeError(`optional flag, if specified, must be boolean`);
      this.fn = t5, this.args = n3 || [], this.optional = !!r3;
    }
    get name() {
      return this.fn.name || ``;
    }
    get type() {
      return name$97$2;
    }
    get isFunctionNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.args.map((r4) => r4._compile(t5, n3)), i3 = this.optional || isAccessorNode$2(this.fn) && this.fn.optionalChaining;
      if (isSymbolNode$2(this.fn)) {
        var a3 = this.fn.name;
        if (n3[a3]) {
          var s3 = this.args;
          return function(n4, c3, l3) {
            var u3 = getSafeProperty$2(c3, a3);
            if (!(i3 && u3 === void 0)) {
              if (typeof u3 != `function`) throw TypeError(`Argument '${a3}' was not a function; received: ${o2(u3)}`);
              if (u3.rawArgs) return u3(s3, t5, createSubScope$2(n4, c3));
              var d3 = r3.map((t6) => t6(n4, c3, l3));
              return u3.apply(u3, d3);
            }
          };
        } else {
          var l2 = a3 in t5 ? getSafeProperty$2(t5, a3) : void 0, u2 = typeof l2 == `function` && l2.rawArgs === true, d2 = (n4) => {
            var r4;
            if (n4.has(a3)) r4 = n4.get(a3);
            else if (a3 in t5) r4 = getSafeProperty$2(t5, a3);
            else if (i3) r4 = void 0;
            else return c2.onUndefinedFunction(a3);
            if (typeof r4 == `function` || i3 && r4 === void 0) return r4;
            throw TypeError(`'${a3}' is not a function; its value is:
  ${o2(r4)}`);
          };
          if (u2) {
            var p2 = this.args;
            return function(n4, i4, a4) {
              var o3 = d2(n4);
              return o3.rawArgs === true ? o3(p2, t5, createSubScope$2(n4, i4)) : o3(...r3.map((t6) => t6(n4, i4, a4)));
            };
          } else switch (r3.length) {
            case 0:
              return function(t6, n4, r4) {
                var a4 = d2(t6);
                if (!(i3 && a4 === void 0)) return a4();
              };
            case 1:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0];
                  return o3(s4(t6, n4, a4));
                }
              };
            case 2:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0], c3 = r3[1];
                  return o3(s4(t6, n4, a4), c3(t6, n4, a4));
                }
              };
            default:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) return o3(...r3.map((r4) => r4(t6, n4, a4)));
              };
          }
        }
      } else if (isAccessorNode$2(this.fn) && isIndexNode$2(this.fn.index) && this.fn.index.isObjectProperty()) {
        var m2 = this.fn.object._compile(t5, n3), h2 = this.fn.index.getObjectProperty(), g2 = this.args;
        return function(n4, a4, o3) {
          var s4 = m2(n4, a4, o3);
          if (!(i3 && (s4 == null || s4[h2] === void 0))) {
            var c3 = getSafeMethod$2(s4, h2);
            if (c3 != null && c3.rawArgs) return c3(g2, t5, createSubScope$2(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, o3));
            return c3.apply(s4, l3);
          }
        };
      } else {
        var v2 = this.fn.toString(), y2 = this.fn._compile(t5, n3), b2 = this.args;
        return function(n4, a4, s4) {
          var c3 = y2(n4, a4, s4);
          if (!(i3 && c3 === void 0)) {
            if (typeof c3 != `function`) throw TypeError(`Expression '${v2}' did not evaluate to a function; value is:
  ${o2(c3)}`);
            if (c3.rawArgs) return c3(b2, t5, createSubScope$2(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, s4));
            return c3.apply(c3, l3);
          }
        };
      }
    }
    forEach(t5) {
      t5(this.fn, `fn`, this);
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = this._ifNode(t5(this.fn, `fn`, this)), r3 = [], i3 = 0; i3 < this.args.length; i3++) r3[i3] = this._ifNode(t5(this.args[i3], `args[` + i3 + `]`, this));
      return new c2(n3, r3);
    }
    clone() {
      return new c2(this.fn, this.args.slice(0));
    }
    toString(t5) {
      var n3, r3 = this.fn.toString(t5);
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$4(t5.handler, r3) && (n3 = t5.handler[r3](this, t5)), n3 === void 0 ? super.toString(t5) : n3;
    }
    _toString(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toString(t5);
      });
      return (isFunctionAssignmentNode$2(this.fn) ? `(` + this.fn.toString(t5) + `)` : this.fn.toString(t5)) + `(` + n3.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$97$2, fn: this.fn, args: this.args };
    }
    _toHTML(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toHTML(t5);
      });
      return `<span class="math-function">` + escape$4(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
    }
    toTex(t5) {
      var n3;
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$4(t5.handler, this.name) && (n3 = t5.handler[this.name](this, t5)), n3 === void 0 ? super.toTex(t5) : n3;
    }
    _toTex(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toTex(t5);
      }), i3;
      latexFunctions$2[this.name] && (i3 = latexFunctions$2[this.name]), r2[this.name] && (typeof r2[this.name].toTex == `function` || typeof r2[this.name].toTex == `object` || typeof r2[this.name].toTex == `string`) && (i3 = r2[this.name].toTex);
      var a3;
      switch (typeof i3) {
        case `function`:
          a3 = i3(this, t5);
          break;
        case `string`:
          a3 = s2(i3, this, t5);
          break;
        case `object`:
          switch (typeof i3[n3.length]) {
            case `function`:
              a3 = i3[n3.length](this, t5);
              break;
            case `string`:
              a3 = s2(i3[n3.length], this, t5);
              break;
          }
      }
      return a3 === void 0 ? s2(defaultTemplate$2, this, t5) : a3;
    }
    getIdentifier() {
      return this.type + `:` + this.name;
    }
  }
  return n2 = c2, _defineProperty$4(c2, `name`, name$97$2), _defineProperty$4(c2, `onUndefinedFunction`, function(t5) {
    throw Error(`Undefined function ` + t5);
  }), _defineProperty$4(c2, `fromJSON`, function(t5) {
    return new n2(t5.fn, t5.args);
  }), c2;
}, { isClass: true, isNode: true }), name$96$2 = `parse`, dependencies$96$2 = [`typed`, `numeric`, `config`, `AccessorNode`, `ArrayNode`, `AssignmentNode`, `BlockNode`, `ConditionalNode`, `ConstantNode`, `FunctionAssignmentNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `RangeNode`, `RelationalNode`, `SymbolNode`], createParse$2 = factory$2(name$96$2, dependencies$96$2, (t4) => {
  var { typed: n2, numeric: r2, config: i2, AccessorNode: a2, ArrayNode: o2, AssignmentNode: s2, BlockNode: c2, ConditionalNode: l2, ConstantNode: u2, FunctionAssignmentNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, ParenthesisNode: v2, RangeNode: y2, RelationalNode: b2, SymbolNode: x2 } = t4, S2 = n2(name$96$2, { string: function(t5) {
    return K2(t5, {});
  }, "Array | Matrix": function(t5) {
    return w2(t5, {});
  }, "string, Object": function(t5, n3) {
    return K2(t5, n3.nodes === void 0 ? {} : n3.nodes);
  }, "Array | Matrix, Object": w2 });
  function w2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3.nodes === void 0 ? {} : n3.nodes;
    return deepMap$3(t5, function(t6) {
      if (typeof t6 != `string`) throw TypeError(`String expected`);
      return K2(t6, r3);
    });
  }
  var E = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, D = { ",": true, "(": true, ")": true, "[": true, "]": true, "{": true, "}": true, '"': true, "'": true, ";": true, "+": true, "-": true, "*": true, ".*": true, "/": true, "./": true, "%": true, "^": true, ".^": true, "~": true, "!": true, "&": true, "|": true, "^|": true, "=": true, ":": true, "?": true, "?.": true, "??": true, "==": true, "!=": true, "<": true, ">": true, "<=": true, ">=": true, "<<": true, ">>": true, ">>>": true }, O2 = { mod: true, to: true, in: true, and: true, xor: true, or: true, not: true }, j2 = { true: true, false: false, null: null, undefined: void 0 }, M2 = [`NaN`, `Infinity`], N2 = { '"': `"`, "'": `'`, "\\": `\\`, "/": `/`, b: `\b`, f: `\f`, n: `
`, r: `\r`, t: `	` };
  function F() {
    return { extraNodes: {}, expression: ``, comment: ``, index: 0, token: ``, tokenType: E.NULL, nestingLevel: 0, conditionalLevel: null };
  }
  function I2(t5, n3) {
    return t5.expression.substr(t5.index, n3);
  }
  function L2(t5) {
    return I2(t5, 1);
  }
  function R2(t5) {
    t5.index++;
  }
  function z2(t5) {
    return t5.expression.charAt(t5.index - 1);
  }
  function V2(t5) {
    return t5.expression.charAt(t5.index + 1);
  }
  function H2(t5) {
    for (t5.tokenType = E.NULL, t5.token = ``, t5.comment = ``; ; ) {
      if (L2(t5) === `#`) for (; L2(t5) !== `
` && L2(t5) !== ``; ) t5.comment += L2(t5), R2(t5);
      if (S2.isWhitespace(L2(t5), t5.nestingLevel)) R2(t5);
      else break;
    }
    if (L2(t5) === ``) {
      t5.tokenType = E.DELIMITER;
      return;
    }
    if (L2(t5) === `
` && !t5.nestingLevel) {
      t5.tokenType = E.DELIMITER, t5.token = L2(t5), R2(t5);
      return;
    }
    var n3 = L2(t5), r3 = I2(t5, 2), i3 = I2(t5, 3);
    if (i3.length === 3 && D[i3]) {
      t5.tokenType = E.DELIMITER, t5.token = i3, R2(t5), R2(t5), R2(t5);
      return;
    }
    if (r3.length === 2 && D[r3] && (r3 !== `?.` || !S2.isDigit(t5.expression.charAt(t5.index + 2)))) {
      t5.tokenType = E.DELIMITER, t5.token = r3, R2(t5), R2(t5);
      return;
    }
    if (D[n3]) {
      t5.tokenType = E.DELIMITER, t5.token = n3, R2(t5);
      return;
    }
    if (S2.isDigitDot(n3)) {
      t5.tokenType = E.NUMBER;
      var a3 = I2(t5, 2);
      if (a3 === `0b` || a3 === `0o` || a3 === `0x`) {
        for (t5.token += L2(t5), R2(t5), t5.token += L2(t5), R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        if (L2(t5) === `.`) for (t5.token += `.`, R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        else if (L2(t5) === `i`) for (t5.token += `i`, R2(t5); S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        return;
      }
      if (L2(t5) === `.`) {
        if (t5.token += L2(t5), R2(t5), !S2.isDigit(L2(t5))) {
          t5.tokenType = E.DELIMITER;
          return;
        }
      } else {
        for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        S2.isDecimalMark(L2(t5), V2(t5)) && (t5.token += L2(t5), R2(t5));
      }
      for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      if (L2(t5) === `E` || L2(t5) === `e`) {
        if (S2.isDigit(V2(t5)) || V2(t5) === `-` || V2(t5) === `+`) {
          if (t5.token += L2(t5), R2(t5), (L2(t5) === `+` || L2(t5) === `-`) && (t5.token += L2(t5), R2(t5)), !S2.isDigit(L2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
          for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
          if (S2.isDecimalMark(L2(t5), V2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
        } else if (S2.isDecimalMark(V2(t5), t5.expression.charAt(t5.index + 2))) throw R2(t5), ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
      }
      return;
    }
    if (S2.isAlpha(L2(t5), z2(t5), V2(t5))) {
      for (; S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      hasOwnProperty$1$4(O2, t5.token) ? t5.tokenType = E.DELIMITER : t5.tokenType = E.SYMBOL;
      return;
    }
    for (t5.tokenType = E.UNKNOWN; L2(t5) !== ``; ) t5.token += L2(t5), R2(t5);
    throw ke2(t5, `Syntax error in part "` + t5.token + `"`);
  }
  function U2(t5) {
    do
      H2(t5);
    while (t5.token === `
`);
  }
  function W2(t5) {
    t5.nestingLevel++;
  }
  function G2(t5) {
    t5.nestingLevel--;
  }
  S2.isAlpha = function(t5, n3, r3) {
    return S2.isValidLatinOrGreek(t5) || S2.isValidMathSymbol(t5, r3) || S2.isValidMathSymbol(n3, t5);
  }, S2.isValidLatinOrGreek = function(t5) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(t5);
  }, S2.isValidMathSymbol = function(t5, n3) {
    return /^[\uD835]$/.test(t5) && /^[\uDC00-\uDFFF]$/.test(n3) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(n3);
  }, S2.isWhitespace = function(t5, n3) {
    return t5 === ` ` || t5 === `	` || t5 === ` ` || t5 === `
` && n3 > 0;
  }, S2.isDecimalMark = function(t5, n3) {
    return t5 === `.` && n3 !== `/` && n3 !== `*` && n3 !== `^`;
  }, S2.isDigitDot = function(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }, S2.isDigit = function(t5) {
    return t5 >= `0` && t5 <= `9`;
  };
  function K2(t5, n3) {
    var r3 = F();
    _extends$5(r3, { expression: t5, extraNodes: n3 }), H2(r3);
    var i3 = q2(r3);
    if (r3.token !== ``) throw r3.tokenType === E.DELIMITER ? Ae2(r3, `Unexpected operator ` + r3.token) : ke2(r3, `Unexpected part "` + r3.token + `"`);
    return i3;
  }
  function q2(t5) {
    var n3, r3 = [], i3;
    for (t5.token !== `` && t5.token !== `
` && t5.token !== `;` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment)); t5.token === `
` || t5.token === `;`; ) r3.length === 0 && n3 && (i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 })), H2(t5), t5.token !== `
` && t5.token !== `;` && t5.token !== `` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment), i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 }));
    return r3.length > 0 ? new c2(r3) : (n3 || (n3 = new u2(void 0), t5.comment && (n3.comment = t5.comment)), n3);
  }
  function J(t5) {
    var n3, r3, i3, a3, o3 = ee2(t5);
    if (t5.token === `=`) {
      if (isSymbolNode$2(o3)) return n3 = o3.name, U2(t5), i3 = J(t5), new s2(new x2(n3), i3);
      if (isAccessorNode$2(o3)) {
        if (o3.optionalChaining) throw ke2(t5, `Cannot assign to optional chain`);
        return U2(t5), i3 = J(t5), new s2(o3.object, o3.index, i3);
      } else if (isFunctionNode$2(o3) && isSymbolNode$2(o3.fn) && (a3 = true, r3 = [], n3 = o3.name, o3.args.forEach(function(t6, n4) {
        isSymbolNode$2(t6) ? r3[n4] = t6.name : a3 = false;
      }), a3)) return U2(t5), i3 = J(t5), new d2(n3, r3, i3);
      throw ke2(t5, `Invalid left hand side of assignment operator =`);
    }
    return o3;
  }
  function ee2(t5) {
    for (var n3 = Y2(t5); t5.token === `?`; ) {
      var r3 = t5.conditionalLevel;
      t5.conditionalLevel = t5.nestingLevel, U2(t5);
      var i3 = n3, a3 = J(t5);
      if (t5.token !== `:`) throw ke2(t5, `False part of conditional expression expected`);
      t5.conditionalLevel = null, U2(t5), n3 = new l2(i3, a3, J(t5)), t5.conditionalLevel = r3;
    }
    return n3;
  }
  function Y2(t5) {
    for (var n3 = te2(t5); t5.token === `or`; ) U2(t5), n3 = new g2(`or`, `or`, [n3, te2(t5)]);
    return n3;
  }
  function te2(t5) {
    for (var n3 = ne2(t5); t5.token === `xor`; ) U2(t5), n3 = new g2(`xor`, `xor`, [n3, ne2(t5)]);
    return n3;
  }
  function ne2(t5) {
    for (var n3 = X2(t5); t5.token === `and`; ) U2(t5), n3 = new g2(`and`, `and`, [n3, X2(t5)]);
    return n3;
  }
  function X2(t5) {
    for (var n3 = ie2(t5); t5.token === `|`; ) U2(t5), n3 = new g2(`|`, `bitOr`, [n3, ie2(t5)]);
    return n3;
  }
  function ie2(t5) {
    for (var n3 = ae2(t5); t5.token === `^|`; ) U2(t5), n3 = new g2(`^|`, `bitXor`, [n3, ae2(t5)]);
    return n3;
  }
  function ae2(t5) {
    for (var n3 = Z2(t5); t5.token === `&`; ) U2(t5), n3 = new g2(`&`, `bitAnd`, [n3, Z2(t5)]);
    return n3;
  }
  function Z2(t5) {
    for (var n3 = [oe2(t5)], r3 = [], i3 = { "==": `equal`, "!=": `unequal`, "<": `smaller`, ">": `larger`, "<=": `smallerEq`, ">=": `largerEq` }; hasOwnProperty$1$4(i3, t5.token); ) {
      var a3 = { name: t5.token, fn: i3[t5.token] };
      r3.push(a3), U2(t5), n3.push(oe2(t5));
    }
    return n3.length === 1 ? n3[0] : n3.length === 2 ? new g2(r3[0].name, r3[0].fn, n3) : new b2(r3.map((t6) => t6.fn), n3);
  }
  function oe2(t5) {
    for (var n3 = $2(t5), r3, i3, a3, o3 = { "<<": `leftShift`, ">>": `rightArithShift`, ">>>": `rightLogShift` }; hasOwnProperty$1$4(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), a3 = [n3, $2(t5)], n3 = new g2(r3, i3, a3);
    return n3;
  }
  function $2(t5) {
    for (var n3 = se2(t5), r3, i3, a3, o3 = { to: `to`, in: `to` }; hasOwnProperty$1$4(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), r3 === `in` && `])},;`.includes(t5.token) ? n3 = new g2(`*`, `multiply`, [n3, new x2(`in`)], true) : (a3 = [n3, se2(t5)], n3 = new g2(r3, i3, a3));
    return n3;
  }
  function se2(t5) {
    var n3, r3 = [];
    if (t5.token === `:`) {
      if (t5.conditionalLevel === t5.nestingLevel) throw ke2(t5, `The true-expression of a conditional operator may not be empty`);
      n3 = new u2(1);
    } else n3 = ce2(t5);
    if (t5.token === `:` && t5.conditionalLevel !== t5.nestingLevel) {
      for (r3.push(n3); t5.token === `:` && r3.length < 3; ) U2(t5), t5.token === `)` || t5.token === `]` || t5.token === `,` || t5.token === `` ? r3.push(new x2(`end`)) : r3.push(ce2(t5));
      n3 = r3.length === 3 ? new y2(r3[0], r3[2], r3[1]) : new y2(r3[0], r3[1]);
    }
    return n3;
  }
  function ce2(t5) {
    for (var n3 = le2(t5), r3, i3, a3, o3 = { "+": `add`, "-": `subtract` }; hasOwnProperty$1$4(o3, t5.token); ) {
      r3 = t5.token, i3 = o3[r3], U2(t5);
      var s3 = le2(t5);
      a3 = s3.isPercentage ? [n3, new g2(`*`, `multiply`, [n3, s3])] : [n3, s3], n3 = new g2(r3, i3, a3);
    }
    return n3;
  }
  function le2(t5) {
    for (var n3 = ue2(t5), r3 = n3, i3, a3, o3 = { "*": `multiply`, ".*": `dotMultiply`, "/": `divide`, "./": `dotDivide`, "%": `mod`, mod: `mod` }; hasOwnProperty$1$4(o3, t5.token); ) i3 = t5.token, a3 = o3[i3], U2(t5), r3 = ue2(t5), n3 = new g2(i3, a3, [n3, r3]);
    return n3;
  }
  function ue2(t5) {
    for (var n3 = de2(t5), r3 = n3; t5.tokenType === E.SYMBOL || t5.token === `in` && isConstantNode$2(n3) || t5.token === `in` && isOperatorNode$2(n3) && n3.fn === `unaryMinus` && isConstantNode$2(n3.args[0]) || t5.tokenType === E.NUMBER && !isConstantNode$2(r3) && (!isOperatorNode$2(r3) || r3.op === `!`) || t5.token === `(`; ) r3 = de2(t5), n3 = new g2(`*`, `multiply`, [n3, r3], true);
    return n3;
  }
  function de2(t5) {
    for (var n3 = fe2(t5), r3 = n3, i3 = []; t5.token === `/` && rule2Node$2(r3); ) if (i3.push(_extends$5({}, t5)), U2(t5), t5.tokenType === E.NUMBER) if (i3.push(_extends$5({}, t5)), U2(t5), t5.tokenType === E.SYMBOL || t5.token === `(` || t5.token === `in`) _extends$5(t5, i3.pop()), i3.pop(), r3 = fe2(t5), n3 = new g2(`/`, `divide`, [n3, r3]);
    else {
      i3.pop(), _extends$5(t5, i3.pop());
      break;
    }
    else {
      _extends$5(t5, i3.pop());
      break;
    }
    return n3;
  }
  function fe2(t5) {
    var n3 = pe2(t5);
    if (t5.token === `%`) {
      var r3 = _extends$5({}, t5);
      U2(t5);
      try {
        pe2(t5), _extends$5(t5, r3);
      } catch {
        n3 = new g2(`/`, `divide`, [n3, new u2(100)], false, true);
      }
    }
    return n3;
  }
  function pe2(t5) {
    var n3, r3, i3, a3 = { "-": `unaryMinus`, "+": `unaryPlus`, "~": `bitNot`, not: `not` };
    return hasOwnProperty$1$4(a3, t5.token) ? (i3 = a3[t5.token], n3 = t5.token, U2(t5), r3 = [pe2(t5)], new g2(n3, i3, r3)) : me2(t5);
  }
  function me2(t5) {
    var n3 = he2(t5), r3, i3, a3;
    return (t5.token === `^` || t5.token === `.^`) && (r3 = t5.token, i3 = r3 === `^` ? `pow` : `dotPow`, U2(t5), a3 = [n3, pe2(t5)], n3 = new g2(r3, i3, a3)), n3;
  }
  function he2(t5) {
    for (var n3 = ge2(t5); t5.token === `??`; ) U2(t5), n3 = new g2(`??`, `nullish`, [n3, ge2(t5)]);
    return n3;
  }
  function ge2(t5) {
    for (var n3 = _e2(t5), r3, i3, a3, o3 = { "!": `factorial`, "'": `ctranspose` }; hasOwnProperty$1$4(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], H2(t5), a3 = [n3], n3 = new g2(r3, i3, a3), n3 = ye2(t5, n3);
    return n3;
  }
  function _e2(t5) {
    var n3 = [];
    if (t5.tokenType === E.SYMBOL && hasOwnProperty$1$4(t5.extraNodes, t5.token)) {
      var r3 = t5.extraNodes[t5.token];
      if (H2(t5), t5.token === `(`) {
        if (n3 = [], W2(t5), H2(t5), t5.token !== `)`) for (n3.push(J(t5)); t5.token === `,`; ) H2(t5), n3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5);
      }
      return new r3(n3);
    }
    return ve2(t5);
  }
  function ve2(t5) {
    var n3, i3;
    return t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2 ? (i3 = t5.token, H2(t5), n3 = hasOwnProperty$1$4(j2, i3) ? new u2(j2[i3]) : M2.includes(i3) ? new u2(r2(i3, `number`)) : new x2(i3), n3 = ye2(t5, n3), n3) : be2(t5);
  }
  function ye2(t5, n3, r3) {
    for (var i3; ; ) {
      var o3 = false;
      t5.token === `?.` && (o3 = true, H2(t5));
      var s3 = (t5.token === `(` || t5.token === `[` || t5.token === `.`) && true;
      if (!(o3 || s3)) break;
      if (i3 = [], t5.token === `(`) if (o3 || isSymbolNode$2(n3) || isAccessorNode$2(n3)) {
        if (W2(t5), H2(t5), t5.token !== `)`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5), n3 = new p2(n3, i3, o3);
      } else return n3;
      else if (t5.token === `[`) {
        if (W2(t5), H2(t5), t5.token !== `]`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `]`) throw ke2(t5, `Parenthesis ] expected`);
        G2(t5), H2(t5), n3 = new a2(n3, new m2(i3), o3);
      } else {
        if (o3 || H2(t5), !(t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2)) {
          var c3 = `Property name expected after `;
          throw c3 += o3 ? `optional chain` : `dot`, ke2(t5, c3);
        }
        i3.push(new u2(t5.token)), H2(t5), n3 = new a2(n3, new m2(i3, true), o3);
      }
    }
    return n3;
  }
  function be2(t5) {
    var n3, r3;
    return t5.token === `"` || t5.token === `'` ? (r3 = xe2(t5, t5.token), n3 = new u2(r3), n3 = ye2(t5, n3), n3) : Se2(t5);
  }
  function xe2(t5, n3) {
    for (var r3 = ``; L2(t5) !== `` && L2(t5) !== n3; ) if (L2(t5) === `\\`) {
      R2(t5);
      var i3 = L2(t5), a3 = N2[i3];
      if (a3 !== void 0) r3 += a3, t5.index += 1;
      else if (i3 === `u`) {
        var o3 = t5.expression.slice(t5.index + 1, t5.index + 5);
        if (/^[0-9A-Fa-f]{4}$/.test(o3)) r3 += String.fromCharCode(parseInt(o3, 16)), t5.index += 5;
        else throw ke2(t5, `Invalid unicode character \\u${o3}`);
      } else throw ke2(t5, `Bad escape character \\${i3}`);
    } else r3 += L2(t5), R2(t5);
    if (H2(t5), t5.token !== n3) throw ke2(t5, `End of string ${n3} expected`);
    return H2(t5), r3;
  }
  function Se2(t5) {
    var n3, r3, i3, a3;
    if (t5.token === `[`) {
      if (W2(t5), H2(t5), t5.token !== `]`) {
        var s3 = Ce2(t5);
        if (t5.token === `;`) {
          for (i3 = 1, r3 = [s3]; t5.token === `;`; ) H2(t5), t5.token !== `]` && (r3[i3] = Ce2(t5), i3++);
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), a3 = r3[0].items.length;
          for (var c3 = 1; c3 < i3; c3++) if (r3[c3].items.length !== a3) throw Ae2(t5, `Column dimensions mismatch (` + r3[c3].items.length + ` !== ` + a3 + `)`);
          n3 = new o2(r3);
        } else {
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), n3 = s3;
        }
      } else G2(t5), H2(t5), n3 = new o2([]);
      return ye2(t5, n3);
    }
    return we2(t5);
  }
  function Ce2(t5) {
    for (var n3 = [J(t5)], r3 = 1; t5.token === `,`; ) H2(t5), t5.token !== `]` && t5.token !== `;` && (n3[r3] = J(t5), r3++);
    return new o2(n3);
  }
  function we2(t5) {
    if (t5.token === `{`) {
      W2(t5);
      var n3, r3 = {};
      do
        if (H2(t5), t5.token !== `}`) {
          if (t5.token === `"` || t5.token === `'`) n3 = xe2(t5, t5.token);
          else if (t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2) n3 = t5.token, H2(t5);
          else throw ke2(t5, `Symbol or string expected as object key`);
          if (t5.token !== `:`) throw ke2(t5, `Colon : expected after object key`);
          H2(t5), r3[n3] = J(t5);
        }
      while (t5.token === `,`);
      if (t5.token !== `}`) throw ke2(t5, `Comma , or bracket } expected after object value`);
      G2(t5), H2(t5);
      var i3 = new h2(r3);
      return i3 = ye2(t5, i3), i3;
    }
    return Te2(t5);
  }
  function Te2(t5) {
    var n3;
    if (t5.tokenType === E.NUMBER) {
      n3 = t5.token, H2(t5);
      var a3 = safeNumberType$2(n3, i2);
      return new u2(r2(n3, a3));
    }
    return Ee2(t5);
  }
  function Ee2(t5) {
    var n3;
    if (t5.token === `(`) {
      if (W2(t5), H2(t5), n3 = J(t5), t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
      return G2(t5), H2(t5), n3 = new v2(n3), n3 = ye2(t5, n3), n3;
    }
    return De2(t5);
  }
  function De2(t5) {
    throw t5.token === `` ? ke2(t5, `Unexpected end of expression`) : ke2(t5, `Value expected`);
  }
  function Oe2(t5) {
    return t5.index - t5.token.length + 1;
  }
  function ke2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  function Ae2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  return n2.addConversion({ from: `string`, to: `Node`, convert: S2 }), S2;
}), name$95$2 = `compile`, dependencies$95$2 = [`typed`, `parse`], createCompile$2 = factory$2(name$95$2, dependencies$95$2, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$95$2, { string: function(t5) {
    return r2(t5).compile();
  }, "Array | Matrix": function(t5) {
    return deepMap$3(t5, function(t6) {
      return r2(t6).compile();
    });
  } });
}), name$94$2 = `evaluate`, dependencies$94$2 = [`typed`, `parse`], createEvaluate$2 = factory$2(name$94$2, dependencies$94$2, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$94$2, { string: function(t5) {
    var n3 = createEmptyMap$2();
    return r2(t5).compile().evaluate(n3);
  }, "string, Map | Object": function(t5, n3) {
    return r2(t5).compile().evaluate(n3);
  }, "Array | Matrix": function(t5) {
    var n3 = createEmptyMap$2();
    return deepMap$3(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  }, "Array | Matrix, Map | Object": function(t5, n3) {
    return deepMap$3(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  } });
}), name$93$2 = `Parser`, dependencies$93$2 = [`evaluate`, `parse`], createParserClass$2 = factory$2(name$93$2, dependencies$93$2, (t4) => {
  var { evaluate: n2, parse: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    Object.defineProperty(this, "scope", { value: createEmptyMap$2(), writable: false });
  }
  i2.prototype.type = `Parser`, i2.prototype.isParser = true, i2.prototype.evaluate = function(t5) {
    return n2(t5, this.scope);
  }, i2.prototype.get = function(t5) {
    if (this.scope.has(t5)) return this.scope.get(t5);
  }, i2.prototype.getAll = function() {
    return toObject$2(this.scope);
  }, i2.prototype.getAllAsMap = function() {
    return this.scope;
  };
  function a2(t5) {
    if (t5.length === 0) return false;
    for (var n3 = 0; n3 < t5.length; n3++) {
      var i3 = t5.charAt(n3 - 1), a3 = t5.charAt(n3), o2 = t5.charAt(n3 + 1);
      if (!(r2.isAlpha(a3, i3, o2) || n3 > 0 && r2.isDigit(a3))) return false;
    }
    return true;
  }
  return i2.prototype.set = function(t5, n3) {
    if (!a2(t5)) throw Error(`Invalid variable name: '${t5}'. Variable names must follow the specified rules.`);
    return this.scope.set(t5, n3), n3;
  }, i2.prototype.remove = function(t5) {
    this.scope.delete(t5);
  }, i2.prototype.clear = function() {
    this.scope.clear();
  }, i2.prototype.toJSON = function() {
    var t5 = { mathjs: `Parser`, variables: {}, functions: {} };
    for (var [n3, r3] of this.scope) if (isFunction$1$2(r3)) {
      if (!isExpressionFunction$2(r3)) throw Error(`Cannot serialize external function ${n3}`);
      t5.functions[n3] = `${r3.syntax} = ${r3.expr}`;
    } else t5.variables[n3] = r3;
    return t5;
  }, i2.fromJSON = function(t5) {
    var n3 = new i2();
    return Object.entries(t5.variables).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.set(r3, i3);
    }), Object.entries(t5.functions).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.evaluate(i3);
    }), n3;
  }, i2;
}, { isClass: true });
function isExpressionFunction$2(t4) {
  return typeof t4 == `function` && typeof t4.syntax == `string` && typeof t4.expr == `string`;
}
var name$92$2 = `parser`, dependencies$92$2 = [`typed`, `Parser`], createParser$2 = factory$2(name$92$2, dependencies$92$2, (t4) => {
  var { typed: n2, Parser: r2 } = t4;
  return n2(name$92$2, { "": function() {
    return new r2();
  } });
}), name$91$2 = `lup`, dependencies$91$2 = [`typed`, `matrix`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `larger`, `equalScalar`, `unaryMinus`, `DenseMatrix`, `SparseMatrix`, `Spa`], createLup$2 = factory$2(name$91$2, dependencies$91$2, (t4) => {
  var { typed: n2, matrix: r2, abs: i2, addScalar: a2, divideScalar: o2, multiplyScalar: s2, subtractScalar: c2, larger: l2, equalScalar: u2, unaryMinus: d2, DenseMatrix: p2, SparseMatrix: m2, Spa: h2 } = t4;
  return n2(name$91$2, { DenseMatrix: function(t5) {
    return g2(t5);
  }, SparseMatrix: function(t5) {
    return v2(t5);
  }, Array: function(t5) {
    var n3 = g2(r2(t5));
    return { L: n3.L.valueOf(), U: n3.U.valueOf(), p: n3.p };
  } });
  function g2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], d3 = Math.min(n3, r3), m3 = clone$3$2(t5._data), h3 = [], g3 = [n3, d3], v3 = [], y2 = [d3, r3], b2, x2, S2, w2 = [];
    for (b2 = 0; b2 < n3; b2++) w2[b2] = b2;
    for (x2 = 0; x2 < r3; x2++) {
      if (x2 > 0) for (b2 = 0; b2 < n3; b2++) {
        var E = Math.min(b2, x2), D = 0;
        for (S2 = 0; S2 < E; S2++) D = a2(D, s2(m3[b2][S2], m3[S2][x2]));
        m3[b2][x2] = c2(m3[b2][x2], D);
      }
      var O2 = x2, j2 = 0, M2 = 0;
      for (b2 = x2; b2 < n3; b2++) {
        var N2 = m3[b2][x2], F = i2(N2);
        l2(F, j2) && (O2 = b2, j2 = F, M2 = N2);
      }
      if (x2 !== O2 && (w2[x2] = [w2[O2], w2[O2] = w2[x2]][0], p2._swapRows(x2, O2, m3)), x2 < n3) for (b2 = x2 + 1; b2 < n3; b2++) {
        var I2 = m3[b2][x2];
        u2(I2, 0) || (m3[b2][x2] = o2(m3[b2][x2], M2));
      }
    }
    for (x2 = 0; x2 < r3; x2++) for (b2 = 0; b2 < n3; b2++) {
      if (x2 === 0 && (b2 < r3 && (v3[b2] = []), h3[b2] = []), b2 < x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 0);
        continue;
      }
      if (b2 === x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 1);
        continue;
      }
      b2 < r3 && (v3[b2][x2] = 0), x2 < n3 && (h3[b2][x2] = m3[b2][x2]);
    }
    var L2 = new p2({ data: h3, size: g3 }), R2 = new p2({ data: v3, size: y2 }), z2 = [];
    for (b2 = 0, d3 = w2.length; b2 < d3; b2++) z2[w2[b2]] = b2;
    return { L: L2, U: R2, p: z2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
  function v2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], a3 = Math.min(n3, r3), c3 = t5._values, p3 = t5._index, g3 = t5._ptr, v3 = [], y2 = [], b2 = [], x2 = [n3, a3], S2 = [], w2 = [], E = [], D = [a3, r3], O2, j2, M2, N2 = [], F = [];
    for (O2 = 0; O2 < n3; O2++) N2[O2] = O2, F[O2] = O2;
    var I2 = function(t6, n4) {
      var r4 = F[t6], i3 = F[n4];
      N2[r4] = n4, N2[i3] = t6, F[t6] = i3, F[n4] = r4;
    }, L2 = function() {
      var t6 = new h2();
      j2 < n3 && (b2.push(v3.length), v3.push(1), y2.push(j2)), E.push(S2.length);
      var r4 = g3[j2], a4 = g3[j2 + 1];
      for (M2 = r4; M2 < a4; M2++) O2 = p3[M2], t6.set(N2[O2], c3[M2]);
      j2 > 0 && t6.forEach(0, j2 - 1, function(n4, r5) {
        m2._forEachRow(n4, v3, y2, b2, function(i3, a5) {
          i3 > n4 && t6.accumulate(i3, d2(s2(a5, r5)));
        });
      });
      var F2 = j2, L3 = t6.get(j2), R2 = i2(L3);
      t6.forEach(j2 + 1, n3 - 1, function(t7, n4) {
        var r5 = i2(n4);
        l2(r5, R2) && (F2 = t7, R2 = r5, L3 = n4);
      }), j2 !== F2 && (m2._swapRows(j2, F2, x2[1], v3, y2, b2), m2._swapRows(j2, F2, D[1], S2, w2, E), t6.swap(j2, F2), I2(j2, F2)), t6.forEach(0, n3 - 1, function(t7, n4) {
        t7 <= j2 ? (S2.push(n4), w2.push(t7)) : (n4 = o2(n4, L3), u2(n4, 0) || (v3.push(n4), y2.push(t7)));
      });
    };
    for (j2 = 0; j2 < r3; j2++) L2();
    return E.push(S2.length), b2.push(v3.length), { L: new m2({ values: v3, index: y2, ptr: b2, size: x2 }), U: new m2({ values: S2, index: w2, ptr: E, size: D }), p: N2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
}), name$90$2 = `qr`, dependencies$90$2 = [`typed`, `matrix`, `zeros`, `identity`, `isZero`, `equal`, `sign`, `sqrt`, `conj`, `unaryMinus`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `complex`], createQr$2 = factory$2(name$90$2, dependencies$90$2, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, identity: a2, isZero: o2, equal: s2, sign: c2, sqrt: l2, conj: u2, unaryMinus: d2, addScalar: p2, divideScalar: m2, multiplyScalar: h2, subtractScalar: g2, complex: v2 } = t4;
  return _extends$5(n2(name$90$2, { DenseMatrix: function(t5) {
    return b2(t5);
  }, SparseMatrix: function(t5) {
    return x2();
  }, Array: function(t5) {
    var n3 = b2(r2(t5));
    return { Q: n3.Q.valueOf(), R: n3.R.valueOf() };
  } }), { _denseQRimpl: y2 });
  function y2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], v3 = a2([n3], `dense`), y3 = v3._data, b3 = t5.clone(), x3 = b3._data, S2, w2, E, D = i2([n3], ``);
    for (E = 0; E < Math.min(r3, n3); ++E) {
      var O2 = x3[E][E], j2 = d2(s2(O2, 0) ? 1 : c2(O2)), M2 = u2(j2), N2 = 0;
      for (S2 = E; S2 < n3; S2++) N2 = p2(N2, h2(x3[S2][E], u2(x3[S2][E])));
      var F = h2(j2, l2(N2));
      if (!o2(F)) {
        var I2 = g2(O2, F);
        for (D[E] = 1, S2 = E + 1; S2 < n3; S2++) D[S2] = m2(x3[S2][E], I2);
        var L2 = d2(u2(m2(I2, F))), R2 = void 0;
        for (w2 = E; w2 < r3; w2++) {
          for (R2 = 0, S2 = E; S2 < n3; S2++) R2 = p2(R2, h2(u2(D[S2]), x3[S2][w2]));
          for (R2 = h2(R2, L2), S2 = E; S2 < n3; S2++) x3[S2][w2] = h2(g2(x3[S2][w2], h2(D[S2], R2)), M2);
        }
        for (S2 = 0; S2 < n3; S2++) {
          for (R2 = 0, w2 = E; w2 < n3; w2++) R2 = p2(R2, h2(y3[S2][w2], D[w2]));
          for (R2 = h2(R2, L2), w2 = E; w2 < n3; ++w2) y3[S2][w2] = m2(g2(y3[S2][w2], h2(R2, u2(D[w2]))), M2);
        }
      }
    }
    return { Q: v3, R: b3, toString: function() {
      return `Q: ` + this.Q.toString() + `
R: ` + this.R.toString();
    } };
  }
  function b2(t5) {
    var n3 = y2(t5), r3 = n3.R._data;
    if (t5._data.length > 0) for (var i3 = r3[0][0].type === `Complex` ? v2(0) : 0, a3 = 0; a3 < r3.length; ++a3) for (var o3 = 0; o3 < a3 && o3 < (r3[0] || []).length; ++o3) r3[a3][o3] = i3;
    return n3;
  }
  function x2(t5) {
    throw Error(`qr not implemented for sparse matrices yet`);
  }
});
function csPermute$2(t4, n2, r2, i2) {
  for (var a2 = t4._values, o2 = t4._index, s2 = t4._ptr, c2 = t4._size, l2 = t4._datatype, u2 = c2[0], d2 = c2[1], p2 = null, m2 = [], h2 = [], g2 = 0, v2 = 0; v2 < d2; v2++) {
    h2[v2] = g2;
    for (var y2 = r2 ? r2[v2] : v2, b2 = s2[y2], x2 = s2[y2 + 1], S2 = b2; S2 < x2; S2++) m2[g2] = o2[S2], p2 && (p2[g2] = a2[S2]), g2++;
  }
  return h2[d2] = g2, t4.createSparseMatrix({ values: p2, index: m2, ptr: h2, size: [u2, d2], datatype: l2 });
}
function csTdfs$2(t4, n2, r2, i2, a2, o2, s2) {
  var c2 = 0;
  for (r2[s2] = t4; c2 >= 0; ) {
    var l2 = r2[s2 + c2], u2 = r2[i2 + l2];
    u2 === -1 ? (c2--, o2[n2++] = l2) : (r2[i2 + l2] = r2[a2 + u2], ++c2, r2[s2 + c2] = u2);
  }
  return n2;
}
function csPost$2(t4, n2) {
  if (!t4) return null;
  var r2 = 0, i2, a2 = [], o2 = [], s2 = 0, c2 = n2, l2 = 2 * n2;
  for (i2 = 0; i2 < n2; i2++) o2[s2 + i2] = -1;
  for (i2 = n2 - 1; i2 >= 0; i2--) t4[i2] !== -1 && (o2[c2 + i2] = o2[s2 + t4[i2]], o2[s2 + t4[i2]] = i2);
  for (i2 = 0; i2 < n2; i2++) t4[i2] === -1 && (r2 = csTdfs$2(i2, r2, o2, s2, c2, a2, l2));
  return a2;
}
function csEtree$2(t4, n2) {
  if (!t4) return null;
  var r2 = t4._index, i2 = t4._ptr, a2 = t4._size, o2 = a2[0], s2 = a2[1], c2 = [], l2 = [], u2 = 0, d2 = s2, p2, m2;
  for (p2 = 0; p2 < o2; p2++) l2[d2 + p2] = -1;
  for (var h2 = 0; h2 < s2; h2++) {
    c2[h2] = -1, l2[u2 + h2] = -1;
    for (var g2 = i2[h2], v2 = i2[h2 + 1], y2 = g2; y2 < v2; y2++) {
      var b2 = r2[y2];
      for (p2 = l2[d2 + b2]; p2 !== -1 && p2 < h2; p2 = m2) m2 = l2[u2 + p2], l2[u2 + p2] = h2, m2 === -1 && (c2[p2] = h2);
      l2[d2 + b2] = h2;
    }
  }
  return c2;
}
function csFkeep$2(t4, n2, r2) {
  for (var i2 = t4._values, a2 = t4._index, o2 = t4._ptr, s2 = t4._size[1], c2 = 0, l2 = 0; l2 < s2; l2++) {
    var u2 = o2[l2];
    for (o2[l2] = c2; u2 < o2[l2 + 1]; u2++) n2(a2[u2], l2, i2 ? i2[u2] : 1, r2) && (a2[c2] = a2[u2], i2 && (i2[c2] = i2[u2]), c2++);
  }
  return o2[s2] = c2, a2.splice(c2, a2.length - c2), i2 && i2.splice(c2, i2.length - c2), c2;
}
function csFlip$2(t4) {
  return -t4 - 2;
}
var name$89$2 = `csAmd`, dependencies$89$2 = [`add`, `multiply`, `transpose`], createCsAmd$2 = factory$2(name$89$2, dependencies$89$2, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4;
  return function(t5, n3) {
    if (!n3 || t5 <= 0 || t5 > 3) return null;
    var r3 = n3._size, i3 = r3[0], u2 = r3[1], d2 = 0, p2 = Math.max(16, 10 * Math.sqrt(u2));
    p2 = Math.min(u2 - 2, p2);
    var m2 = a2(t5, n3, i3, u2, p2);
    csFkeep$2(m2, l2, null);
    for (var h2 = m2._index, g2 = m2._ptr, v2 = g2[u2], y2 = [], b2 = [], x2 = 0, S2 = u2 + 1, w2 = 2 * (u2 + 1), E = 3 * (u2 + 1), D = 4 * (u2 + 1), O2 = 5 * (u2 + 1), j2 = 6 * (u2 + 1), M2 = 7 * (u2 + 1), N2 = y2, F = o2(u2, g2, b2, x2, E, N2, w2, M2, S2, j2, D, O2), I2 = s2(u2, g2, b2, O2, D, j2, p2, S2, E, N2, w2), L2 = 0, R2, z2, V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2; I2 < u2; ) {
      for (V2 = -1; L2 < u2 && (V2 = b2[E + L2]) === -1; L2++) ;
      b2[w2 + V2] !== -1 && (N2[b2[w2 + V2]] = -1), b2[E + L2] = b2[w2 + V2];
      var ae2 = b2[D + V2], Z2 = b2[S2 + V2];
      I2 += Z2;
      var oe2 = 0;
      b2[S2 + V2] = -Z2;
      var $2 = g2[V2], se2 = ae2 === 0 ? $2 : v2, ce2 = se2;
      for (H2 = 1; H2 <= ae2 + 1; H2++) {
        for (H2 > ae2 ? (W2 = V2, G2 = $2, K2 = b2[x2 + V2] - ae2) : (W2 = h2[$2++], G2 = g2[W2], K2 = b2[x2 + W2]), U2 = 1; U2 <= K2; U2++) R2 = h2[G2++], !((q2 = b2[S2 + R2]) <= 0) && (oe2 += q2, b2[S2 + R2] = -q2, h2[ce2++] = R2, b2[w2 + R2] !== -1 && (N2[b2[w2 + R2]] = N2[R2]), N2[R2] === -1 ? b2[E + b2[O2 + R2]] = b2[w2 + R2] : b2[w2 + N2[R2]] = b2[w2 + R2]);
        W2 !== V2 && (g2[W2] = csFlip$2(V2), b2[j2 + W2] = 0);
      }
      for (ae2 !== 0 && (v2 = ce2), b2[O2 + V2] = oe2, g2[V2] = se2, b2[x2 + V2] = ce2 - se2, b2[D + V2] = -2, F = c2(F, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !((ee2 = b2[D + R2]) <= 0)) {
        q2 = -b2[S2 + R2];
        var le2 = F - q2;
        for ($2 = g2[R2], Y2 = g2[R2] + ee2 - 1; $2 <= Y2; $2++) W2 = h2[$2], b2[j2 + W2] >= F ? b2[j2 + W2] -= q2 : b2[j2 + W2] !== 0 && (b2[j2 + W2] = b2[O2 + W2] + le2);
      }
      for (J = se2; J < ce2; J++) {
        for (R2 = h2[J], Y2 = g2[R2], te2 = Y2 + b2[D + R2] - 1, ne2 = Y2, X2 = 0, ie2 = 0, $2 = Y2; $2 <= te2; $2++) if (W2 = h2[$2], b2[j2 + W2] !== 0) {
          var ue2 = b2[j2 + W2] - F;
          ue2 > 0 ? (ie2 += ue2, h2[ne2++] = W2, X2 += W2) : (g2[W2] = csFlip$2(V2), b2[j2 + W2] = 0);
        }
        b2[D + R2] = ne2 - Y2 + 1;
        var de2 = ne2, fe2 = Y2 + b2[x2 + R2];
        for ($2 = te2 + 1; $2 < fe2; $2++) {
          z2 = h2[$2];
          var pe2 = b2[S2 + z2];
          pe2 <= 0 || (ie2 += pe2, h2[ne2++] = z2, X2 += z2);
        }
        ie2 === 0 ? (g2[R2] = csFlip$2(V2), q2 = -b2[S2 + R2], oe2 -= q2, Z2 += q2, I2 += q2, b2[S2 + R2] = 0, b2[D + R2] = -1) : (b2[O2 + R2] = Math.min(b2[O2 + R2], ie2), h2[ne2] = h2[de2], h2[de2] = h2[Y2], h2[Y2] = V2, b2[x2 + R2] = ne2 - Y2 + 1, X2 = (X2 < 0 ? -X2 : X2) % u2, b2[w2 + R2] = b2[M2 + X2], b2[M2 + X2] = R2, N2[R2] = X2);
      }
      for (b2[O2 + V2] = oe2, d2 = Math.max(d2, oe2), F = c2(F + d2, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !(b2[S2 + R2] >= 0)) for (X2 = N2[R2], R2 = b2[M2 + X2], b2[M2 + X2] = -1; R2 !== -1 && b2[w2 + R2] !== -1; R2 = b2[w2 + R2], F++) {
        for (K2 = b2[x2 + R2], ee2 = b2[D + R2], $2 = g2[R2] + 1; $2 <= g2[R2] + K2 - 1; $2++) b2[j2 + h2[$2]] = F;
        var me2 = R2;
        for (z2 = b2[w2 + R2]; z2 !== -1; ) {
          var he2 = b2[x2 + z2] === K2 && b2[D + z2] === ee2;
          for ($2 = g2[z2] + 1; he2 && $2 <= g2[z2] + K2 - 1; $2++) b2[j2 + h2[$2]] !== F && (he2 = 0);
          he2 ? (g2[z2] = csFlip$2(R2), b2[S2 + R2] += b2[S2 + z2], b2[S2 + z2] = 0, b2[D + z2] = -1, z2 = b2[w2 + z2], b2[w2 + me2] = z2) : (me2 = z2, z2 = b2[w2 + z2]);
        }
      }
      for ($2 = se2, J = se2; J < ce2; J++) R2 = h2[J], !((q2 = -b2[S2 + R2]) <= 0) && (b2[S2 + R2] = q2, ie2 = b2[O2 + R2] + oe2 - q2, ie2 = Math.min(ie2, u2 - I2 - q2), b2[E + ie2] !== -1 && (N2[b2[E + ie2]] = R2), b2[w2 + R2] = b2[E + ie2], N2[R2] = -1, b2[E + ie2] = R2, L2 = Math.min(L2, ie2), b2[O2 + R2] = ie2, h2[$2++] = R2);
      b2[S2 + V2] = Z2, (b2[x2 + V2] = $2 - se2) === 0 && (g2[V2] = -1, b2[j2 + V2] = 0), ae2 !== 0 && (v2 = $2);
    }
    for (R2 = 0; R2 < u2; R2++) g2[R2] = csFlip$2(g2[R2]);
    for (z2 = 0; z2 <= u2; z2++) b2[E + z2] = -1;
    for (z2 = u2; z2 >= 0; z2--) b2[S2 + z2] > 0 || (b2[w2 + z2] = b2[E + g2[z2]], b2[E + g2[z2]] = z2);
    for (W2 = u2; W2 >= 0; W2--) b2[S2 + W2] <= 0 || g2[W2] !== -1 && (b2[w2 + W2] = b2[E + g2[W2]], b2[E + g2[W2]] = W2);
    for (V2 = 0, R2 = 0; R2 <= u2; R2++) g2[R2] === -1 && (V2 = csTdfs$2(R2, V2, b2, E, w2, y2, j2));
    return y2.splice(y2.length - 1, 1), y2;
  };
  function a2(t5, a3, o3, s3, c3) {
    var l3 = i2(a3);
    if (t5 === 1 && s3 === o3) return n2(a3, l3);
    if (t5 === 2) {
      for (var u2 = l3._index, d2 = l3._ptr, p2 = 0, m2 = 0; m2 < o3; m2++) {
        var h2 = d2[m2];
        if (d2[m2] = p2, !(d2[m2 + 1] - h2 > c3)) for (var g2 = d2[m2 + 1]; h2 < g2; h2++) u2[p2++] = u2[h2];
      }
      return d2[o3] = p2, a3 = i2(l3), r2(l3, a3);
    }
    return r2(l3, a3);
  }
  function o2(t5, n3, r3, i3, a3, o3, s3, l3, u2, d2, p2, m2) {
    for (var h2 = 0; h2 < t5; h2++) r3[i3 + h2] = n3[h2 + 1] - n3[h2];
    r3[i3 + t5] = 0;
    for (var g2 = 0; g2 <= t5; g2++) r3[a3 + g2] = -1, o3[g2] = -1, r3[s3 + g2] = -1, r3[l3 + g2] = -1, r3[u2 + g2] = 1, r3[d2 + g2] = 1, r3[p2 + g2] = 0, r3[m2 + g2] = r3[i3 + g2];
    var v2 = c2(0, 0, r3, d2, t5);
    return r3[p2 + t5] = -2, n3[t5] = -1, r3[d2 + t5] = 0, v2;
  }
  function s2(t5, n3, r3, i3, a3, o3, s3, c3, l3, u2, d2) {
    for (var p2 = 0, m2 = 0; m2 < t5; m2++) {
      var h2 = r3[i3 + m2];
      if (h2 === 0) r3[a3 + m2] = -2, p2++, n3[m2] = -1, r3[o3 + m2] = 0;
      else if (h2 > s3) r3[c3 + m2] = 0, r3[a3 + m2] = -1, p2++, n3[m2] = csFlip$2(t5), r3[c3 + t5]++;
      else {
        var g2 = r3[l3 + h2];
        g2 !== -1 && (u2[g2] = m2), r3[d2 + m2] = r3[l3 + h2], r3[l3 + h2] = m2;
      }
    }
    return p2;
  }
  function c2(t5, n3, r3, i3, a3) {
    if (t5 < 2 || t5 + n3 < 0) {
      for (var o3 = 0; o3 < a3; o3++) r3[i3 + o3] !== 0 && (r3[i3 + o3] = 1);
      t5 = 2;
    }
    return t5;
  }
  function l2(t5, n3) {
    return t5 !== n3;
  }
});
function csLeaf$2(t4, n2, r2, i2, a2, o2, s2) {
  var c2, l2, u2 = 0, d2;
  if (t4 <= n2 || r2[i2 + n2] <= r2[a2 + t4]) return -1;
  r2[a2 + t4] = r2[i2 + n2];
  var p2 = r2[o2 + t4];
  if (r2[o2 + t4] = n2, p2 === -1) u2 = 1, d2 = t4;
  else {
    for (u2 = 2, d2 = p2; d2 !== r2[s2 + d2]; d2 = r2[s2 + d2]) ;
    for (c2 = p2; c2 !== d2; c2 = l2) l2 = r2[s2 + c2], r2[s2 + c2] = d2;
  }
  return { jleaf: u2, q: d2 };
}
var name$88$2 = `csCounts`, dependencies$88$2 = [`transpose`], createCsCounts$2 = factory$2(name$88$2, dependencies$88$2, (t4) => {
  var { transpose: n2 } = t4;
  return function(t5, r2, i2, a2) {
    if (!t5 || !r2 || !i2) return null;
    var o2 = t5._size, s2 = o2[0], c2 = o2[1], l2, u2, d2, p2, m2, h2, g2, v2 = 4 * c2 + (a2 ? c2 + s2 + 1 : 0), y2 = [], b2 = 0, x2 = c2, S2 = 2 * c2, w2 = 3 * c2, E = 4 * c2, D = 5 * c2 + 1;
    for (d2 = 0; d2 < v2; d2++) y2[d2] = -1;
    var O2 = [], j2 = n2(t5), M2 = j2._index, N2 = j2._ptr;
    for (d2 = 0; d2 < c2; d2++) for (u2 = i2[d2], O2[u2] = +(y2[w2 + u2] === -1); u2 !== -1 && y2[w2 + u2] === -1; u2 = r2[u2]) y2[w2 + u2] = d2;
    if (a2) {
      for (d2 = 0; d2 < c2; d2++) y2[i2[d2]] = d2;
      for (l2 = 0; l2 < s2; l2++) {
        for (d2 = c2, h2 = N2[l2], g2 = N2[l2 + 1], m2 = h2; m2 < g2; m2++) d2 = Math.min(d2, y2[M2[m2]]);
        y2[D + l2] = y2[E + d2], y2[E + d2] = l2;
      }
    }
    for (l2 = 0; l2 < c2; l2++) y2[b2 + l2] = l2;
    for (d2 = 0; d2 < c2; d2++) {
      for (u2 = i2[d2], r2[u2] !== -1 && O2[r2[u2]]--, p2 = a2 ? y2[E + d2] : u2; p2 !== -1; p2 = a2 ? y2[D + p2] : -1) for (m2 = N2[p2]; m2 < N2[p2 + 1]; m2++) {
        l2 = M2[m2];
        var F = csLeaf$2(l2, u2, y2, w2, x2, S2, b2);
        F.jleaf >= 1 && O2[u2]++, F.jleaf === 2 && O2[F.q]--;
      }
      r2[u2] !== -1 && (y2[b2 + u2] = r2[u2]);
    }
    for (u2 = 0; u2 < c2; u2++) r2[u2] !== -1 && (O2[r2[u2]] += O2[u2]);
    return O2;
  };
}), name$87$2 = `csSqr`, dependencies$87$2 = [`add`, `multiply`, `transpose`], createCsSqr$2 = factory$2(name$87$2, dependencies$87$2, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4, a2 = createCsAmd$2({ add: n2, multiply: r2, transpose: i2 }), o2 = createCsCounts$2({ transpose: i2 });
  return function(t5, n3, r3) {
    var i3 = n3._ptr, c2 = n3._size[1], l2, u2 = {};
    if (u2.q = a2(t5, n3), t5 && !u2.q) return null;
    if (r3) {
      var d2 = t5 ? csPermute$2(n3, null, u2.q) : n3;
      u2.parent = csEtree$2(d2);
      var p2 = csPost$2(u2.parent, c2);
      if (u2.cp = o2(d2, u2.parent, p2, 1), d2 && u2.parent && u2.cp && s2(d2, u2)) for (u2.unz = 0, l2 = 0; l2 < c2; l2++) u2.unz += u2.cp[l2];
    } else u2.unz = 4 * i3[c2] + c2, u2.lnz = u2.unz;
    return u2;
  };
  function s2(t5, n3) {
    var r3 = t5._ptr, i3 = t5._index, a3 = t5._size, o3 = a3[0], s3 = a3[1];
    n3.pinv = [], n3.leftmost = [];
    var c2 = n3.parent, l2 = n3.pinv, u2 = n3.leftmost, d2 = [], p2 = 0, m2 = o3, h2 = o3 + s3, g2 = o3 + 2 * s3, v2, y2, b2, x2, S2;
    for (y2 = 0; y2 < s3; y2++) d2[m2 + y2] = -1, d2[h2 + y2] = -1, d2[g2 + y2] = 0;
    for (v2 = 0; v2 < o3; v2++) u2[v2] = -1;
    for (y2 = s3 - 1; y2 >= 0; y2--) for (x2 = r3[y2], S2 = r3[y2 + 1], b2 = x2; b2 < S2; b2++) u2[i3[b2]] = y2;
    for (v2 = o3 - 1; v2 >= 0; v2--) l2[v2] = -1, y2 = u2[v2], y2 !== -1 && (d2[g2 + y2]++ === 0 && (d2[h2 + y2] = v2), d2[p2 + v2] = d2[m2 + y2], d2[m2 + y2] = v2);
    for (n3.lnz = 0, n3.m2 = o3, y2 = 0; y2 < s3; y2++) if (v2 = d2[m2 + y2], n3.lnz++, v2 < 0 && (v2 = n3.m2++), l2[v2] = y2, !(--g2[y2] <= 0)) {
      n3.lnz += d2[g2 + y2];
      var w2 = c2[y2];
      w2 !== -1 && (d2[g2 + w2] === 0 && (d2[h2 + w2] = d2[h2 + y2]), d2[p2 + d2[h2 + y2]] = d2[m2 + w2], d2[m2 + w2] = d2[p2 + v2], d2[g2 + w2] += d2[g2 + y2]);
    }
    for (v2 = 0; v2 < o3; v2++) l2[v2] < 0 && (l2[v2] = y2++);
    return true;
  }
});
function csMarked$2(t4, n2) {
  return t4[n2] < 0;
}
function csMark$2(t4, n2) {
  t4[n2] = csFlip$2(t4[n2]);
}
function csUnflip$2(t4) {
  return t4 < 0 ? csFlip$2(t4) : t4;
}
function csDfs$2(t4, n2, r2, i2, a2) {
  var o2 = n2._index, s2 = n2._ptr, c2 = n2._size[1], l2, u2, d2, p2 = 0;
  for (i2[0] = t4; p2 >= 0; ) {
    t4 = i2[p2];
    var m2 = a2 ? a2[t4] : t4;
    csMarked$2(s2, t4) || (csMark$2(s2, t4), i2[c2 + p2] = m2 < 0 ? 0 : csUnflip$2(s2[m2]));
    var h2 = 1;
    for (u2 = i2[c2 + p2], d2 = m2 < 0 ? 0 : csUnflip$2(s2[m2 + 1]); u2 < d2; u2++) if (l2 = o2[u2], !csMarked$2(s2, l2)) {
      i2[c2 + p2] = u2, i2[++p2] = l2, h2 = 0;
      break;
    }
    h2 && (p2--, i2[--r2] = t4);
  }
  return r2;
}
function csReach$2(t4, n2, r2, i2, a2) {
  var o2 = t4._ptr, s2 = t4._size, c2 = n2._index, l2 = n2._ptr, u2 = s2[1], d2, p2, m2, h2 = u2;
  for (p2 = l2[r2], m2 = l2[r2 + 1], d2 = p2; d2 < m2; d2++) {
    var g2 = c2[d2];
    csMarked$2(o2, g2) || (h2 = csDfs$2(g2, t4, h2, i2, a2));
  }
  for (d2 = h2; d2 < u2; d2++) csMark$2(o2, i2[d2]);
  return h2;
}
var name$86$2 = `csSpsolve`, dependencies$86$2 = [`divideScalar`, `multiply`, `subtract`], createCsSpsolve$2 = factory$2(name$86$2, dependencies$86$2, (t4) => {
  var { divideScalar: n2, multiply: r2, subtract: i2 } = t4;
  return function(t5, a2, o2, s2, c2, l2, u2) {
    var d2 = t5._values, p2 = t5._index, m2 = t5._ptr, h2 = t5._size[1], g2 = a2._values, v2 = a2._index, y2 = a2._ptr, b2, x2, S2, w2, E = csReach$2(t5, a2, o2, s2, l2);
    for (b2 = E; b2 < h2; b2++) c2[s2[b2]] = 0;
    for (x2 = y2[o2], S2 = y2[o2 + 1], b2 = x2; b2 < S2; b2++) c2[v2[b2]] = g2[b2];
    for (var D = E; D < h2; D++) {
      var O2 = s2[D], j2 = l2 ? l2[O2] : O2;
      if (!(j2 < 0)) for (x2 = m2[j2], S2 = m2[j2 + 1], c2[O2] = n2(c2[O2], d2[u2 ? x2 : S2 - 1]), b2 = u2 ? x2 + 1 : x2, w2 = u2 ? S2 : S2 - 1; b2 < w2; b2++) {
        var M2 = p2[b2];
        c2[M2] = i2(c2[M2], r2(d2[b2], c2[O2]));
      }
    }
    return E;
  };
}), name$85$2 = `csLu`, dependencies$85$2 = [`abs`, `divideScalar`, `multiply`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createCsLu$2 = factory$2(name$85$2, dependencies$85$2, (t4) => {
  var { abs: n2, divideScalar: r2, multiply: i2, subtract: a2, larger: o2, largerEq: s2, SparseMatrix: c2 } = t4, l2 = createCsSpsolve$2({ divideScalar: r2, multiply: i2, subtract: a2 });
  return function(t5, a3, u2) {
    if (!t5) return null;
    var d2 = t5._size[1], p2, m2 = 100, h2 = 100;
    a3 && (p2 = a3.q, m2 = a3.lnz || m2, h2 = a3.unz || h2);
    var g2 = [], v2 = [], y2 = [], b2 = new c2({ values: g2, index: v2, ptr: y2, size: [d2, d2] }), x2 = [], S2 = [], w2 = [], E = new c2({ values: x2, index: S2, ptr: w2, size: [d2, d2] }), D = [], O2, j2, M2 = [], N2 = [];
    for (O2 = 0; O2 < d2; O2++) M2[O2] = 0, D[O2] = -1, y2[O2 + 1] = 0;
    m2 = 0, h2 = 0;
    for (var F = 0; F < d2; F++) {
      y2[F] = m2, w2[F] = h2;
      var I2 = p2 ? p2[F] : F, L2 = l2(b2, t5, I2, N2, M2, D, 1), R2 = -1, z2 = -1;
      for (j2 = L2; j2 < d2; j2++) if (O2 = N2[j2], D[O2] < 0) {
        var V2 = n2(M2[O2]);
        o2(V2, z2) && (z2 = V2, R2 = O2);
      } else S2[h2] = D[O2], x2[h2++] = M2[O2];
      if (R2 === -1 || z2 <= 0) return null;
      D[I2] < 0 && s2(n2(M2[I2]), i2(z2, u2)) && (R2 = I2);
      var H2 = M2[R2];
      for (S2[h2] = F, x2[h2++] = H2, D[R2] = F, v2[m2] = R2, g2[m2++] = 1, j2 = L2; j2 < d2; j2++) O2 = N2[j2], D[O2] < 0 && (v2[m2] = O2, g2[m2++] = r2(M2[O2], H2)), M2[O2] = 0;
    }
    for (y2[d2] = m2, w2[d2] = h2, j2 = 0; j2 < m2; j2++) v2[j2] = D[v2[j2]];
    return g2.splice(m2, g2.length - m2), v2.splice(m2, v2.length - m2), x2.splice(h2, x2.length - h2), S2.splice(h2, S2.length - h2), { L: b2, U: E, pinv: D };
  };
}), name$84$2 = `slu`, dependencies$84$2 = [`typed`, `abs`, `add`, `multiply`, `transpose`, `divideScalar`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createSlu$2 = factory$2(name$84$2, dependencies$84$2, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, transpose: o2, divideScalar: s2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 } = t4, p2 = createCsSqr$2({ add: i2, multiply: a2, transpose: o2 }), m2 = createCsLu$2({ abs: r2, divideScalar: s2, multiply: a2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 });
  return n2(name$84$2, { "SparseMatrix, number, number": function(t5, n3, r3) {
    if (!isInteger$3(n3) || n3 < 0 || n3 > 3) throw Error(`Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]`);
    if (r3 < 0 || r3 > 1) throw Error(`Partial pivoting threshold must be a number from 0 to 1`);
    var i3 = p2(n3, t5, false), a3 = m2(t5, i3, r3);
    return { L: a3.L, U: a3.U, p: a3.pinv, q: i3.q, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : ``) + `
`;
    } };
  } });
});
function csIpvec$2(t4, n2) {
  var r2, i2 = n2.length, a2 = [];
  if (t4) for (r2 = 0; r2 < i2; r2++) a2[t4[r2]] = n2[r2];
  else for (r2 = 0; r2 < i2; r2++) a2[r2] = n2[r2];
  return a2;
}
var name$83$2 = `lusolve`, dependencies$83$2 = [`typed`, `matrix`, `lup`, `slu`, `usolve`, `lsolve`, `DenseMatrix`], createLusolve$2 = factory$2(name$83$2, dependencies$83$2, (t4) => {
  var { typed: n2, matrix: r2, lup: i2, slu: a2, usolve: o2, lsolve: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$2({ DenseMatrix: c2 });
  return n2(name$83$2, { "Array, Array | Matrix": function(t5, n3) {
    t5 = r2(t5);
    var a3 = i2(t5);
    return d2(a3.L, a3.U, a3.p, null, n3).valueOf();
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix, number, number": function(t5, n3, r3, i3) {
    var o3 = a2(t5, r3, i3);
    return d2(o3.L, o3.U, o3.p, o3.q, n3);
  }, "Object, Array | Matrix": function(t5, n3) {
    return d2(t5.L, t5.U, t5.p, t5.q, n3);
  } });
  function u2(t5) {
    if (isMatrix$2(t5)) return t5;
    if (isArray$3(t5)) return r2(t5);
    throw TypeError(`Invalid Matrix LU decomposition`);
  }
  function d2(t5, n3, r3, i3, a3) {
    t5 = u2(t5), n3 = u2(n3), r3 && (a3 = l2(t5, a3, true), a3._data = csIpvec$2(r3, a3._data));
    var c3 = s2(t5, a3), d3 = o2(n3, c3);
    return i3 && (d3._data = csIpvec$2(i3, d3._data)), d3;
  }
}), name$82$2 = `polynomialRoot`, dependencies$82$2 = [`typed`, `isZero`, `equalScalar`, `add`, `subtract`, `multiply`, `divide`, `sqrt`, `unaryMinus`, `cbrt`, `typeOf`, `im`, `re`], createPolynomialRoot$2 = factory$2(name$82$2, dependencies$82$2, (t4) => {
  var { typed: n2, isZero: r2, equalScalar: i2, add: a2, subtract: o2, multiply: s2, divide: c2, sqrt: l2, unaryMinus: u2, cbrt: d2, typeOf: p2, im: m2, re: h2 } = t4;
  return n2(name$82$2, { "number|Complex, ...number|Complex": (t5, n3) => {
    for (var g2 = [t5, ...n3]; g2.length > 0 && r2(g2[g2.length - 1]); ) g2.pop();
    if (g2.length < 2) throw RangeError(`Polynomial [${t5}, ${n3}] must have a non-zero non-constant coefficient`);
    switch (g2.length) {
      case 2:
        return [u2(c2(g2[0], g2[1]))];
      case 3:
        var [v2, y2, b2] = g2, x2 = s2(2, b2), S2 = s2(y2, y2), w2 = s2(4, b2, v2);
        if (i2(S2, w2)) return [c2(u2(y2), x2)];
        var E = l2(o2(S2, w2));
        return [c2(o2(E, y2), x2), c2(o2(u2(E), y2), x2)];
      case 4:
        var [D, O2, j2, M2] = g2, N2 = u2(s2(3, M2)), F = s2(j2, j2), I2 = s2(3, M2, O2), L2 = a2(s2(2, j2, j2, j2), s2(27, M2, M2, D)), R2 = s2(9, M2, j2, O2);
        if (i2(F, I2) && i2(L2, R2)) return [c2(j2, N2)];
        var z2 = o2(F, I2), V2 = o2(L2, R2);
        return i2(a2(s2(18, M2, j2, O2, D), s2(j2, j2, O2, O2)), a2(s2(4, j2, j2, j2, D), s2(4, M2, O2, O2, O2), s2(27, M2, M2, D, D))) ? [c2(o2(s2(4, M2, j2, O2), a2(s2(9, M2, M2, D), s2(j2, j2, j2))), s2(M2, z2)), c2(o2(s2(9, M2, D), s2(j2, O2)), s2(2, z2))] : d2(i2(F, I2) ? V2 : c2(a2(V2, l2(o2(s2(V2, V2), s2(4, z2, z2, z2)))), 2), true).toArray().map((t6) => c2(a2(j2, t6, c2(z2, t6)), N2)).map((t6) => p2(t6) === `Complex` && i2(h2(t6), h2(t6) + m2(t6)) ? h2(t6) : t6);
      default:
        throw RangeError(`only implemented for cubic or lower-order polynomials, not ${g2}`);
    }
  } });
}), name$81$2 = `Help`, dependencies$81$2 = [`evaluate`], createHelpClass$2 = factory$2(name$81$2, dependencies$81$2, (t4) => {
  var { evaluate: n2 } = t4;
  function r2(t5) {
    if (!(this instanceof r2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (!t5) throw Error(`Argument "doc" missing`);
    this.doc = t5;
  }
  return r2.prototype.type = `Help`, r2.prototype.isHelp = true, r2.prototype.toString = function() {
    var t5 = this.doc || {}, r3 = `
`;
    if (t5.name && (r3 += `Name: ` + t5.name + `

`), t5.category && (r3 += `Category: ` + t5.category + `

`), t5.description && (r3 += `Description:
    ` + t5.description + `

`), t5.syntax && (r3 += `Syntax:
    ` + t5.syntax.join(`
    `) + `

`), t5.examples) {
      r3 += `Examples:
`;
      for (var i2 = false, a2 = n2(`config()`), o2 = { config: (t6) => (i2 = true, n2(`config(newConfig)`, { newConfig: t6 })) }, s2 = 0; s2 < t5.examples.length; s2++) {
        var c2 = t5.examples[s2];
        r3 += `    ` + c2 + `
`;
        var l2 = void 0;
        try {
          l2 = n2(c2, o2);
        } catch (t6) {
          l2 = t6;
        }
        l2 !== void 0 && !isHelp$2(l2) && (r3 += `        ` + format$4(l2, { precision: 14 }) + `
`);
      }
      r3 += `
`, i2 && n2(`config(originalConfig)`, { originalConfig: a2 });
    }
    return t5.mayThrow && t5.mayThrow.length && (r3 += `Throws: ` + t5.mayThrow.join(`, `) + `

`), t5.seealso && t5.seealso.length && (r3 += `See also: ` + t5.seealso.join(`, `) + `
`), r3;
  }, r2.prototype.toJSON = function() {
    var t5 = clone$3$2(this.doc);
    return t5.mathjs = `Help`, t5;
  }, r2.fromJSON = function(t5) {
    var n3 = {};
    return Object.keys(t5).filter((t6) => t6 !== `mathjs`).forEach((r3) => {
      n3[r3] = t5[r3];
    }), new r2(n3);
  }, r2.prototype.valueOf = r2.prototype.toString, r2;
}, { isClass: true }), name$80$2 = `Chain`, dependencies$80$2 = [`?on`, `math`, `typed`], createChainClass$2 = factory$2(name$80$2, dependencies$80$2, (t4) => {
  var { on: n2, math: r2, typed: i2 } = t4;
  function a2(t5) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    isChain$2(t5) ? this.value = t5.value : this.value = t5;
  }
  a2.prototype.type = `Chain`, a2.prototype.isChain = true, a2.prototype.done = function() {
    return this.value;
  }, a2.prototype.valueOf = function() {
    return this.value;
  }, a2.prototype.toString = function() {
    return format$4(this.value);
  }, a2.prototype.toJSON = function() {
    return { mathjs: `Chain`, value: this.value };
  }, a2.fromJSON = function(t5) {
    return new a2(t5.value);
  };
  function o2(t5, n3) {
    typeof n3 == `function` && (a2.prototype[t5] = c2(n3));
  }
  function s2(t5, n3) {
    lazy$2(a2.prototype, t5, function() {
      var t6 = n3();
      if (typeof t6 == `function`) return c2(t6);
    });
  }
  function c2(t5) {
    return function() {
      if (arguments.length === 0) return new a2(t5(this.value));
      for (var n3 = [this.value], r3 = 0; r3 < arguments.length; r3++) n3[r3 + 1] = arguments[r3];
      if (i2.isTypedFunction(t5)) {
        var o3 = i2.resolve(t5, n3);
        if (o3.params.length === 1) throw Error(`chain function ` + t5.name + ` cannot match rest parameter between chain value and additional arguments.`);
        return new a2(o3.implementation.apply(t5, n3));
      }
      return new a2(t5.apply(t5, n3));
    };
  }
  a2.createProxy = function(t5, n3) {
    if (typeof t5 == `string`) o2(t5, n3);
    else {
      var r3 = function(n4) {
        hasOwnProperty$1$4(t5, n4) && l2[n4] === void 0 && s2(n4, () => t5[n4]);
      };
      for (var i3 in t5) r3(i3);
    }
  };
  var l2 = { expression: true, docs: true, type: true, classes: true, json: true, error: true, isChain: true };
  return a2.createProxy(r2), n2 && n2(`import`, function(t5, n3, r3) {
    r3 || s2(t5, n3);
  }), a2;
}, { isClass: true }), eDocs$2 = { name: `e`, category: `Constants`, syntax: [`e`], description: `Euler's number, the base of the natural logarithm. Approximately equal to 2.71828`, examples: [`e`, `e ^ 2`, `exp(2)`, `log(e)`], seealso: [`exp`] }, falseDocs$2 = { name: `false`, category: `Constants`, syntax: [`false`], description: `Boolean value false`, examples: [`false`], seealso: [`true`] }, iDocs$2 = { name: `i`, category: `Constants`, syntax: [`i`], description: `Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.`, examples: [`i`, `i * i`, `sqrt(-1)`], seealso: [] }, InfinityDocs$2 = { name: `Infinity`, category: `Constants`, syntax: [`Infinity`], description: `Infinity, a number which is larger than the maximum number that can be handled by a floating point number.`, examples: [`Infinity`, `1 / 0`], seealso: [] }, LN10Docs$2 = { name: `LN10`, category: `Constants`, syntax: [`LN10`], description: `Returns the natural logarithm of 10, approximately equal to 2.302`, examples: [`LN10`, `log(10)`], seealso: [] }, LN2Docs$2 = { name: `LN2`, category: `Constants`, syntax: [`LN2`], description: `Returns the natural logarithm of 2, approximately equal to 0.693`, examples: [`LN2`, `log(2)`], seealso: [] }, LOG10EDocs$2 = { name: `LOG10E`, category: `Constants`, syntax: [`LOG10E`], description: `Returns the base-10 logarithm of E, approximately equal to 0.434`, examples: [`LOG10E`, `log(e, 10)`], seealso: [] }, LOG2EDocs$2 = { name: `LOG2E`, category: `Constants`, syntax: [`LOG2E`], description: `Returns the base-2 logarithm of E, approximately equal to 1.442`, examples: [`LOG2E`, `log(e, 2)`], seealso: [] }, NaNDocs$2 = { name: `NaN`, category: `Constants`, syntax: [`NaN`], description: `Not a number`, examples: [`NaN`, `0 / 0`], seealso: [] }, nullDocs$2 = { name: `null`, category: `Constants`, syntax: [`null`], description: `Value null`, examples: [`null`], seealso: [`true`, `false`] }, phiDocs$2 = { name: `phi`, category: `Constants`, syntax: [`phi`], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: [`phi`], seealso: [] }, piDocs$2 = { name: `pi`, category: `Constants`, syntax: [`pi`], description: `The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159`, examples: [`pi`, `sin(pi/2)`], seealso: [`tau`] }, SQRT12Docs$2 = { name: `SQRT1_2`, category: `Constants`, syntax: [`SQRT1_2`], description: `Returns the square root of 1/2, approximately equal to 0.707`, examples: [`SQRT1_2`, `sqrt(1/2)`], seealso: [] }, SQRT2Docs$2 = { name: `SQRT2`, category: `Constants`, syntax: [`SQRT2`], description: `Returns the square root of 2, approximately equal to 1.414`, examples: [`SQRT2`, `sqrt(2)`], seealso: [] }, tauDocs$2 = { name: `tau`, category: `Constants`, syntax: [`tau`], description: `Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.`, examples: [`tau`, `2 * pi`], seealso: [`pi`] }, trueDocs$2 = { name: `true`, category: `Constants`, syntax: [`true`], description: `Boolean value true`, examples: [`true`], seealso: [`false`] }, versionDocs$2 = { name: `version`, category: `Constants`, syntax: [`version`], description: `A string with the version number of math.js`, examples: [`version`], seealso: [] }, bignumberDocs$2 = { name: `bignumber`, category: `Construction`, syntax: [`bignumber(x)`], description: `Create a big number from a number or string.`, examples: [`0.1 + 0.2`, `bignumber(0.1) + bignumber(0.2)`, `bignumber("7.2")`, `bignumber("7.2e500")`, `bignumber([0.1, 0.2, 0.3])`], seealso: [`boolean`, `bigint`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, bigintDocs$2 = { name: `bigint`, category: `Construction`, syntax: [`bigint(x)`], description: `Create a bigint, an integer with an arbitrary number of digits, from a number or string.`, examples: [`123123123123123123 # a large number will lose digits`, `bigint("123123123123123123")`, `bignumber(["1", "3", "5"])`], seealso: [`boolean`, `bignumber`, `number`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, booleanDocs$2 = { name: `boolean`, category: `Construction`, syntax: [`x`, `boolean(x)`], description: `Convert a string or number into a boolean.`, examples: [`boolean(0)`, `boolean(1)`, `boolean(3)`, `boolean("true")`, `boolean("false")`, `boolean([1, 0, 1, 1])`], seealso: [`bignumber`, `complex`, `index`, `matrix`, `number`, `string`, `unit`] }, complexDocs$2 = { name: `complex`, category: `Construction`, syntax: [`complex()`, `complex(re, im)`, `complex(string)`], description: `Create a complex number.`, examples: [`complex()`, `complex(2, 3)`, `complex("7 - 2i")`], seealso: [`bignumber`, `boolean`, `index`, `matrix`, `number`, `string`, `unit`] }, createUnitDocs$2 = { name: `createUnit`, category: `Construction`, syntax: [`createUnit(definitions)`, `createUnit(name, definition)`], description: `Create a user-defined unit and register it with the Unit type.`, examples: [`createUnit("foo")`, `createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})`, `createUnit("mph", "1 mile/hour")`], seealso: [`unit`, `splitUnit`] }, fractionDocs$2 = { name: `fraction`, category: `Construction`, syntax: [`fraction(num)`, `fraction(matrix)`, `fraction(num,den)`, `fraction({n: num, d: den})`], description: `Create a fraction from a number or from integer numerator and denominator.`, examples: [`fraction(0.125)`, `fraction(1, 3) + fraction(2, 5)`, `fraction({n: 333, d: 53})`, `fraction([sqrt(9), sqrt(10), sqrt(11)])`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `string`, `unit`] }, indexDocs$2 = { name: `index`, category: `Construction`, syntax: [`[start]`, `[start:end]`, `[start:step:end]`, `[start1, start 2, ...]`, `[start1:end1, start2:end2, ...]`, `[start1:step1:end1, start2:step2:end2, ...]`], description: `Create an index to get or replace a subset of a matrix`, examples: [`A = [1, 2, 3; 4, 5, 6]`, `A[1, :]`, `A[1, 2] = 50`, `A[1:2, 1:2] = 1`, `B = [1, 2, 3]`, `B[B>1 and B<3]`], seealso: [`bignumber`, `boolean`, `complex`, `matrix`, `number`, `range`, `string`, `unit`] }, matrixDocs$2 = { name: `matrix`, category: `Construction`, syntax: [`[]`, `[a1, b1, ...; a2, b2, ...]`, `matrix()`, `matrix("dense")`, `matrix([...])`], description: `Create a matrix.`, examples: [`[]`, `[1, 2, 3]`, `[1, 2, 3; 4, 5, 6]`, `matrix()`, `matrix([3, 4])`, `matrix([3, 4; 5, 6], "sparse")`, `matrix([3, 4; 5, 6], "sparse", "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `sparse`] }, numberDocs$2 = { name: `number`, category: `Construction`, syntax: [`x`, `number(x)`, `number(unit, valuelessUnit)`], description: `Create a number or convert a string or boolean into a number.`, examples: [`2`, `2e3`, `4.05`, `number(2)`, `number("7.2")`, `number(true)`, `number([true, false, true, true])`, `number(unit("52cm"), "m")`], seealso: [`bignumber`, `bigint`, `boolean`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, sparseDocs$2 = { name: `sparse`, category: `Construction`, syntax: [`sparse()`, `sparse([a1, b1, ...; a1, b2, ...])`, `sparse([a1, b1, ...; a1, b2, ...], "number")`], description: `Create a sparse matrix.`, examples: [`sparse()`, `sparse([3, 4; 5, 6])`, `sparse([3, 0; 5, 0], "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `matrix`] }, splitUnitDocs$2 = { name: `splitUnit`, category: `Construction`, syntax: [`splitUnit(unit: Unit, parts: Unit[])`], description: `Split a unit in an array of units whose sum is equal to the original unit.`, examples: [`splitUnit(1 m, ["feet", "inch"])`], seealso: [`unit`, `createUnit`] }, stringDocs$2 = { name: `string`, category: `Construction`, syntax: [`"text"`, `string(x)`], description: `Create a string or convert a value to a string`, examples: [`"Hello World!"`, `string(4.2)`, `string(3 + 2i)`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `unit`] }, unitDocs$2 = { name: `unit`, category: `Construction`, syntax: [`value unit`, `unit(value, unit)`, `unit(string)`], description: `Create a unit.`, examples: [`5.5 mm`, `3 inch`, `unit(7.1, "kilogram")`, `unit("23 deg")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `string`] }, configDocs$2 = { name: `config`, category: `Core`, syntax: [`config()`, `config(options)`], description: `Get configuration or change configuration.`, examples: [`config()`, `1/3 + 1/4`, `config({number: "Fraction"})`, `1/3 + 1/4`], seealso: [] }, importDocs$2 = { name: `import`, category: `Core`, syntax: [`import(functions)`, `import(functions, options)`], description: `Import functions or constants from an object.`, examples: [`import({myFn: f(x)=x^2, myConstant: 32 })`, `myFn(2)`, `myConstant`], seealso: [] }, typedDocs$2 = { name: `typed`, category: `Core`, syntax: [`typed(signatures)`, `typed(name, signatures)`], description: `Create a typed function.`, examples: [`double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })`, `double(2)`, `double("hello")`], seealso: [] }, derivativeDocs$2 = { name: `derivative`, category: `Algebra`, syntax: [`derivative(expr, variable)`, `derivative(expr, variable, {simplify: boolean})`], description: `Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.`, examples: [`derivative("2x^3", "x")`, `derivative("2x^3", "x", {simplify: false})`, `derivative("2x^2 + 3x + 4", "x")`, `derivative("sin(2x)", "x")`, `f = parse("x^2 + x")`, `x = parse("x")`, `df = derivative(f, x)`, `df.evaluate({x: 3})`], seealso: [`simplify`, `parse`, `evaluate`] }, leafCountDocs$2 = { name: `leafCount`, category: `Algebra`, syntax: [`leafCount(expr)`], description: `Computes the number of leaves in the parse tree of the given expression`, examples: [`leafCount("e^(i*pi)-1")`, `leafCount(parse("{a: 22/7, b: 10^(1/2)}"))`], seealso: [`simplify`] }, lsolveDocs$2 = { name: `lsolve`, category: `Algebra`, syntax: [`x=lsolve(L, b)`], description: `Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolveAll`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lsolveAllDocs$2 = { name: `lsolveAll`, category: `Algebra`, syntax: [`x=lsolveAll(L, b)`], description: `Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolve`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lupDocs$2 = { name: `lup`, category: `Algebra`, syntax: [`lup(m)`], description: `Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U`, examples: [`lup([[2, 1], [1, 4]])`, `lup(matrix([[2, 1], [1, 4]]))`, `lup(sparse([[2, 1], [1, 4]]))`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `slu`, `qr`] }, lusolveDocs$2 = { name: `lusolve`, category: `Algebra`, syntax: [`x=lusolve(A, b)`, `x=lusolve(lu, b)`], description: `Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lusolve(a, b)`], seealso: [`lup`, `slu`, `lsolve`, `usolve`, `matrix`, `sparse`] }, polynomialRootDocs$2 = { name: `polynomialRoot`, category: `Algebra`, syntax: [`x=polynomialRoot(-6, 3)`, `x=polynomialRoot(4, -4, 1)`, `x=polynomialRoot(-8, 12, -6, 1)`], description: `Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.`, examples: [`a = polynomialRoot(-6, 11, -6, 1)`], seealso: [`cbrt`, `sqrt`] }, qrDocs$2 = { name: `qr`, category: `Algebra`, syntax: [`qr(A)`], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: [`qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])`], seealso: [`lup`, `slu`, `matrix`] }, rationalizeDocs$2 = { name: `rationalize`, category: `Algebra`, syntax: [`rationalize(expr)`, `rationalize(expr, scope)`, `rationalize(expr, scope, detailed)`], description: `Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.`, examples: [`rationalize("2x/y - y/(x+1)")`, `rationalize("2x/y - y/(x+1)", true)`], seealso: [`simplify`] }, resolveDocs$2 = { name: `resolve`, category: `Algebra`, syntax: [`resolve(node, scope)`], description: `Recursively substitute variables in an expression tree.`, examples: [`resolve(parse("1 + x"), { x: 7 })`, `resolve(parse("size(text)"), { text: "Hello World" })`, `resolve(parse("x + y"), { x: parse("3z") })`, `resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })`], seealso: [`simplify`, `evaluate`], mayThrow: [`ReferenceError`] }, simplifyDocs$2 = { name: `simplify`, category: `Algebra`, syntax: [`simplify(expr)`, `simplify(expr, rules)`], description: `Simplify an expression tree.`, examples: [`simplify("3 + 2 / 4")`, `simplify("2x + x")`, `f = parse("x * (x + 2 + x)")`, `simplified = simplify(f)`, `simplified.evaluate({x: 2})`], seealso: [`simplifyCore`, `derivative`, `evaluate`, `parse`, `rationalize`, `resolve`] }, simplifyConstantDocs$2 = { name: `simplifyConstant`, category: `Algebra`, syntax: [`simplifyConstant(expr)`, `simplifyConstant(expr, options)`], description: `Replace constant subexpressions of node with their values.`, examples: [`simplifyConstant("(3-3)*x")`, `simplifyConstant(parse("z-cos(tau/8)"))`], seealso: [`simplify`, `simplifyCore`, `evaluate`] }, simplifyCoreDocs$2 = { name: `simplifyCore`, category: `Algebra`, syntax: [`simplifyCore(node)`], description: `Perform simple one-pass simplifications on an expression tree.`, examples: [`simplifyCore(parse("0*x"))`, `simplifyCore(parse("(x+0)*2"))`], seealso: [`simplify`, `simplifyConstant`, `evaluate`] }, sluDocs$2 = { name: `slu`, category: `Algebra`, syntax: [`slu(A, order, threshold)`], description: `Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U`, examples: [`slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `lup`, `qr`] }, symbolicEqualDocs$2 = { name: `symbolicEqual`, category: `Algebra`, syntax: [`symbolicEqual(expr1, expr2)`, `symbolicEqual(expr1, expr2, options)`], description: `Returns true if the difference of the expressions simplifies to 0`, examples: [`symbolicEqual("x*y","y*x")`, `symbolicEqual("abs(x^2)", "x^2")`, `symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})`], seealso: [`simplify`, `evaluate`] }, usolveDocs$2 = { name: `usolve`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolveAll`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, usolveAllDocs$2 = { name: `usolveAll`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolve`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, absDocs$2 = { name: `abs`, category: `Arithmetic`, syntax: [`abs(x)`], description: `Compute the absolute value.`, examples: [`abs(3.5)`, `abs(-4.2)`], seealso: [`sign`] }, addDocs$2 = { name: `add`, category: `Operators`, syntax: [`x + y`, `add(x, y)`], description: `Add two values.`, examples: [`a = 2.1 + 3.6`, `a - 3.6`, `3 + 2i`, `3 cm + 2 inch`, `"2.3" + "4"`], seealso: [`subtract`] }, cbrtDocs$2 = { name: `cbrt`, category: `Arithmetic`, syntax: [`cbrt(x)`, `cbrt(x, allRoots)`], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: [`cbrt(64)`, `cube(4)`, `cbrt(-8)`, `cbrt(2 + 3i)`, `cbrt(8i)`, `cbrt(8i, true)`, `cbrt(27 m^3)`], seealso: [`square`, `sqrt`, `cube`, `multiply`] }, ceilDocs$2 = { name: `ceil`, category: `Arithmetic`, syntax: [`ceil(x)`, `ceil(x, n)`, `ceil(unit, valuelessUnit)`, `ceil(unit, n, valuelessUnit)`], description: `Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.`, examples: [`ceil(3.2)`, `ceil(3.8)`, `ceil(-4.2)`, `ceil(3.241cm, cm)`, `ceil(3.241cm, 2, cm)`], seealso: [`floor`, `fix`, `round`] }, cubeDocs$2 = { name: `cube`, category: `Arithmetic`, syntax: [`cube(x)`], description: `Compute the cube of a value. The cube of x is x * x * x.`, examples: [`cube(2)`, `2^3`, `2 * 2 * 2`], seealso: [`multiply`, `square`, `pow`] }, divideDocs$2 = { name: `divide`, category: `Operators`, syntax: [`x / y`, `divide(x, y)`], description: `Divide two values.`, examples: [`a = 2 / 3`, `a * 3`, `4.5 / 2`, `3 + 4 / 2`, `(3 + 4) / 2`, `18 km / 4.5`], seealso: [`multiply`] }, dotDivideDocs$2 = { name: `dotDivide`, category: `Operators`, syntax: [`x ./ y`, `dotDivide(x, y)`], description: `Divide two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a ./ b`], seealso: [`multiply`, `dotMultiply`, `divide`] }, dotMultiplyDocs$2 = { name: `dotMultiply`, category: `Operators`, syntax: [`x .* y`, `dotMultiply(x, y)`], description: `Multiply two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a .* b`], seealso: [`multiply`, `divide`, `dotDivide`] }, dotPowDocs$2 = { name: `dotPow`, category: `Operators`, syntax: [`x .^ y`, `dotPow(x, y)`], description: `Calculates the power of x to y element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a .^ 2`], seealso: [`pow`] }, expDocs$2 = { name: `exp`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Calculate the exponent of a value.`, examples: [`exp(1.3)`, `e ^ 1.3`, `log(exp(1.3))`, `x = 2.4`, `(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula`], seealso: [`expm`, `expm1`, `pow`, `log`] }, expmDocs$2 = { name: `expm`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.`, examples: [`expm([[0,2],[0,0]])`], seealso: [`exp`] }, expm1Docs$2 = { name: `expm1`, category: `Arithmetic`, syntax: [`expm1(x)`], description: `Calculate the value of subtracting 1 from the exponential value.`, examples: [`expm1(2)`, `pow(e, 2) - 1`, `log(expm1(2) + 1)`], seealso: [`exp`, `pow`, `log`] }, fixDocs$2 = { name: `fix`, category: `Arithmetic`, syntax: [`fix(x)`, `fix(x, n)`, `fix(unit, valuelessUnit)`, `fix(unit, n, valuelessUnit)`], description: `Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.`, examples: [`fix(3.2)`, `fix(3.8)`, `fix(-4.2)`, `fix(-4.8)`, `fix(3.241cm, cm)`, `fix(3.241cm, 2, cm)`], seealso: [`ceil`, `floor`, `round`] }, floorDocs$2 = { name: `floor`, category: `Arithmetic`, syntax: [`floor(x)`, `floor(x, n)`, `floor(unit, valuelessUnit)`, `floor(unit, n, valuelessUnit)`], description: `Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.`, examples: [`floor(3.2)`, `floor(3.8)`, `floor(-4.2)`, `floor(3.241cm, cm)`, `floor(3.241cm, 2, cm)`], seealso: [`ceil`, `fix`, `round`] }, gcdDocs$2 = { name: `gcd`, category: `Arithmetic`, syntax: [`gcd(a, b)`, `gcd(a, b, c, ...)`], description: `Compute the greatest common divisor.`, examples: [`gcd(8, 12)`, `gcd(-4, 6)`, `gcd(25, 15, -10)`], seealso: [`lcm`, `xgcd`] }, hypotDocs$2 = { name: `hypot`, category: `Arithmetic`, syntax: [`hypot(a, b, c, ...)`, `hypot([a, b, c, ...])`], description: `Calculate the hypotenuse of a list with values.`, examples: [`hypot(3, 4)`, `sqrt(3^2 + 4^2)`, `hypot(-2)`, `hypot([3, 4, 5])`], seealso: [`abs`, `norm`] }, invmodDocs$2 = { name: `invmod`, category: `Arithmetic`, syntax: [`invmod(a, b)`], description: `Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)`, examples: [`invmod(8, 12)`, `invmod(7, 13)`, `invmod(15151, 15122)`], seealso: [`gcd`, `xgcd`] }, lcmDocs$2 = { name: `lcm`, category: `Arithmetic`, syntax: [`lcm(x, y)`], description: `Compute the least common multiple.`, examples: [`lcm(4, 6)`, `lcm(6, 21)`, `lcm(6, 21, 5)`], seealso: [`gcd`] }, logDocs$2 = { name: `log`, category: `Arithmetic`, syntax: [`log(x)`, `log(x, base)`], description: `Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).`, examples: [`log(3.5)`, `a = log(2.4)`, `exp(a)`, `10 ^ 4`, `log(10000, 10)`, `log(10000) / log(10)`, `b = log(1024, 2)`, `2 ^ b`], seealso: [`exp`, `log1p`, `log2`, `log10`] }, log10Docs$2 = { name: `log10`, category: `Arithmetic`, syntax: [`log10(x)`], description: `Compute the 10-base logarithm of a value.`, examples: [`log10(0.00001)`, `log10(10000)`, `10 ^ 4`, `log(10000) / log(10)`, `log(10000, 10)`], seealso: [`exp`, `log`] }, log1pDocs$2 = { name: `log1p`, category: `Arithmetic`, syntax: [`log1p(x)`, `log1p(x, base)`], description: "Calculate the logarithm of a `value+1`", examples: [`log1p(2.5)`, `exp(log1p(1.4))`, `pow(10, 4)`, `log1p(9999, 10)`, `log1p(9999) / log(10)`], seealso: [`exp`, `log`, `log2`, `log10`] }, log2Docs$2 = { name: `log2`, category: `Arithmetic`, syntax: [`log2(x)`], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: [`log2(0.03125)`, `log2(16)`, `log2(16) / log2(2)`, `pow(2, 4)`], seealso: [`exp`, `log1p`, `log`, `log10`] }, modDocs$2 = { name: `mod`, category: `Operators`, syntax: [`x % y`, `x mod y`, `mod(x, y)`], description: `Calculates the modulus, the remainder of an integer division.`, examples: [`7 % 3`, `11 % 2`, `10 mod 4`, `isOdd(x) = x % 2`, `isOdd(2)`, `isOdd(3)`], seealso: [`divide`] }, multiplyDocs$2 = { name: `multiply`, category: `Operators`, syntax: [`x * y`, `multiply(x, y)`], description: `multiply two values.`, examples: [`a = 2.1 * 3.4`, `a / 3.4`, `2 * 3 + 4`, `2 * (3 + 4)`, `3 * 2.1 km`], seealso: [`divide`] }, normDocs$2 = { name: `norm`, category: `Arithmetic`, syntax: [`norm(x)`, `norm(x, p)`], description: `Calculate the norm of a number, vector or matrix.`, examples: [`abs(-3.5)`, `norm(-3.5)`, `norm(3 - 4i)`, `norm([1, 2, -3], Infinity)`, `norm([1, 2, -3], -Infinity)`, `norm([3, 4], 2)`, `norm([[1, 2], [3, 4]], 1)`, `norm([[1, 2], [3, 4]], "inf")`, `norm([[1, 2], [3, 4]], "fro")`] }, nthRootDocs$2 = { name: `nthRoot`, category: `Arithmetic`, syntax: [`nthRoot(a)`, `nthRoot(a, root)`], description: `Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".`, examples: [`4 ^ 3`, `nthRoot(64, 3)`, `nthRoot(9, 2)`, `sqrt(9)`], seealso: [`nthRoots`, `pow`, `sqrt`] }, nthRootsDocs$2 = { name: `nthRoots`, category: `Arithmetic`, syntax: [`nthRoots(A)`, `nthRoots(A, root)`], description: `Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.`, examples: [`nthRoots(1)`, `nthRoots(1, 3)`], seealso: [`sqrt`, `pow`, `nthRoot`] }, powDocs$2 = { name: `pow`, category: `Operators`, syntax: [`x ^ y`, `pow(x, y)`], description: `Calculates the power of x to y, x^y.`, examples: [`2^3`, `2*2*2`, `1 + e ^ (pi * i)`, `pow([[1, 2], [4, 3]], 2)`, `pow([[1, 2], [4, 3]], -1)`], seealso: [`multiply`, `nthRoot`, `nthRoots`, `sqrt`] }, roundDocs$2 = { name: `round`, category: `Arithmetic`, syntax: [`round(x)`, `round(x, n)`, `round(unit, valuelessUnit)`, `round(unit, n, valuelessUnit)`], description: `round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.`, examples: [`round(3.2)`, `round(3.8)`, `round(-4.2)`, `round(-4.8)`, `round(pi, 3)`, `round(123.45678, 2)`, `round(3.241cm, 2, cm)`, `round([3.2, 3.8, -4.7])`], seealso: [`ceil`, `floor`, `fix`] }, signDocs$2 = { name: `sign`, category: `Arithmetic`, syntax: [`sign(x)`], description: `Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.`, examples: [`sign(3.5)`, `sign(-4.2)`, `sign(0)`], seealso: [`abs`] }, sqrtDocs$2 = { name: `sqrt`, category: `Arithmetic`, syntax: [`sqrt(x)`], description: `Compute the square root value. If x = y * y, then y is the square root of x.`, examples: [`sqrt(25)`, `5 * 5`, `sqrt(-1)`], seealso: [`square`, `sqrtm`, `multiply`, `nthRoot`, `nthRoots`, `pow`] }, sqrtmDocs$2 = { name: `sqrtm`, category: `Arithmetic`, syntax: [`sqrtm(x)`], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: [`sqrtm([[33, 24], [48, 57]])`], seealso: [`sqrt`, `abs`, `square`, `multiply`] }, sylvesterDocs$2 = { name: `sylvester`, category: `Algebra`, syntax: [`sylvester(A,B,C)`], description: `Solves the real-valued Sylvester equation AX+XB=C for X`, examples: [`sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])`, `A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]`, `sylvester(A, B, C)`], seealso: [`schur`, `lyap`] }, schurDocs$2 = { name: `schur`, category: `Algebra`, syntax: [`schur(A)`], description: `Performs a real Schur decomposition of the real matrix A = UTU'`, examples: [`schur([[1, 0], [-4, 3]])`, `A = [[1, 0], [-4, 3]]`, `schur(A)`], seealso: [`lyap`, `sylvester`] }, lyapDocs$2 = { name: `lyap`, category: `Algebra`, syntax: [`lyap(A,Q)`], description: `Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P`, examples: [`lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])`, `A = [[-2, 0], [1, -4]]`, `Q = [[3, 1], [1, 3]]`, `lyap(A,Q)`], seealso: [`schur`, `sylvester`] }, squareDocs$2 = { name: `square`, category: `Arithmetic`, syntax: [`square(x)`], description: `Compute the square of a value. The square of x is x * x.`, examples: [`square(3)`, `sqrt(9)`, `3^2`, `3 * 3`], seealso: [`multiply`, `pow`, `sqrt`, `cube`] }, subtractDocs$2 = { name: `subtract`, category: `Operators`, syntax: [`x - y`, `subtract(x, y)`], description: `subtract two values.`, examples: [`a = 5.3 - 2`, `a + 2`, `2/3 - 1/6`, `2 * 3 - 3`, `2.1 km - 500m`], seealso: [`add`] }, unaryMinusDocs$2 = { name: `unaryMinus`, category: `Operators`, syntax: [`-x`, `unaryMinus(x)`], description: `Inverse the sign of a value. Converts booleans and strings to numbers.`, examples: [`-4.5`, `-(-5.6)`, `-"22"`], seealso: [`add`, `subtract`, `unaryPlus`] }, unaryPlusDocs$2 = { name: `unaryPlus`, category: `Operators`, syntax: [`+x`, `unaryPlus(x)`], description: `Converts booleans and strings to numbers.`, examples: [`+true`, `+"2"`], seealso: [`add`, `subtract`, `unaryMinus`] }, xgcdDocs$2 = { name: `xgcd`, category: `Arithmetic`, syntax: [`xgcd(a, b)`], description: `Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.`, examples: [`xgcd(8, 12)`, `gcd(8, 12)`, `xgcd(36163, 21199)`], seealso: [`gcd`, `lcm`] }, numDocs$2 = { name: `num`, category: `Fraction`, syntax: [`num(x)`], description: `Get the numerator of a fraction.`, examples: [`num(fraction(2, 3))`, `num(fraction(5, 8))`], seealso: [`den`, `fraction`] }, denDocs$2 = { name: `den`, category: `Fraction`, syntax: [`den(x)`], description: `Get the denominator of a fraction.`, examples: [`den(fraction(2, 3))`, `den(fraction(5, 8))`], seealso: [`num`, `fraction`] }, bitAndDocs$2 = { name: `bitAnd`, category: `Bitwise`, syntax: [`x & y`, `bitAnd(x, y)`], description: `Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0`, examples: [`5 & 3`, `bitAnd(53, 131)`, `[1, 12, 31] & 42`], seealso: [`bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitNotDocs$2 = { name: `bitNot`, category: `Bitwise`, syntax: [`~x`, `bitNot(x)`], description: `Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.`, examples: [`~1`, `~2`, `bitNot([2, -3, 4])`], seealso: [`bitAnd`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitOrDocs$2 = { name: `bitOr`, category: `Bitwise`, syntax: [`x | y`, `bitOr(x, y)`], description: `Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.`, examples: [`5 | 3`, `bitOr([1, 2, 3], 4)`], seealso: [`bitAnd`, `bitNot`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitXorDocs$2 = { name: `bitXor`, category: `Bitwise`, syntax: [`bitXor(x, y)`], description: `Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.`, examples: [`bitOr(1, 2)`, `bitXor([2, 3, 4], 4)`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `leftShift`, `rightArithShift`, `rightLogShift`] }, leftShiftDocs$2 = { name: `leftShift`, category: `Bitwise`, syntax: [`x << y`, `leftShift(x, y)`], description: `Bitwise left logical shift of a value x by y number of bits.`, examples: [`4 << 1`, `8 >> 1`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `rightArithShift`, `rightLogShift`] }, rightArithShiftDocs$2 = { name: `rightArithShift`, category: `Bitwise`, syntax: [`x >> y`, `rightArithShift(x, y)`], description: `Bitwise right arithmetic shift of a value x by y number of bits.`, examples: [`8 >> 1`, `4 << 1`, `-12 >> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightLogShift`] }, rightLogShiftDocs$2 = { name: `rightLogShift`, category: `Bitwise`, syntax: [`x >>> y`, `rightLogShift(x, y)`], description: `Bitwise right logical shift of a value x by y number of bits.`, examples: [`8 >>> 1`, `4 << 1`, `-12 >>> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`] }, bellNumbersDocs$2 = { name: `bellNumbers`, category: `Combinatorics`, syntax: [`bellNumbers(n)`], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: [`bellNumbers(3)`, `bellNumbers(8)`], seealso: [`stirlingS2`] }, catalanDocs$2 = { name: `catalan`, category: `Combinatorics`, syntax: [`catalan(n)`], description: `The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.`, examples: [`catalan(3)`, `catalan(8)`], seealso: [`bellNumbers`] }, compositionDocs$2 = { name: `composition`, category: `Combinatorics`, syntax: [`composition(n, k)`], description: `The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.`, examples: [`composition(5, 3)`], seealso: [`combinations`] }, stirlingS2Docs$2 = { name: `stirlingS2`, category: `Combinatorics`, syntax: [`stirlingS2(n, k)`], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: [`stirlingS2(5, 3)`], seealso: [`bellNumbers`, `bernoulli`] }, argDocs$2 = { name: `arg`, category: `Complex`, syntax: [`arg(x)`], description: `Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).`, examples: [`arg(2 + 2i)`, `atan2(3, 2)`, `arg(2 + 3i)`], seealso: [`re`, `im`, `conj`, `abs`] }, conjDocs$2 = { name: `conj`, category: `Complex`, syntax: [`conj(x)`], description: `Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.`, examples: [`conj(2 + 3i)`, `conj(2 - 3i)`, `conj(-5.2i)`], seealso: [`re`, `im`, `abs`, `arg`] }, imDocs$2 = { name: `im`, category: `Complex`, syntax: [`im(x)`], description: `Get the imaginary part of a complex number.`, examples: [`im(2 + 3i)`, `re(2 + 3i)`, `im(-5.2i)`, `im(2.4)`], seealso: [`re`, `conj`, `abs`, `arg`] }, reDocs$2 = { name: `re`, category: `Complex`, syntax: [`re(x)`], description: `Get the real part of a complex number.`, examples: [`re(2 + 3i)`, `im(2 + 3i)`, `re(-5.2i)`, `re(2.4)`], seealso: [`im`, `conj`, `abs`, `arg`] }, evaluateDocs$2 = { name: `evaluate`, category: `Expression`, syntax: [`evaluate(expression)`, `evaluate(expression, scope)`, `evaluate([expr1, expr2, expr3, ...])`, `evaluate([expr1, expr2, expr3, ...], scope)`], description: `Evaluate an expression or an array with expressions.`, examples: [`evaluate("2 + 3")`, `evaluate("sqrt(16)")`, `evaluate("2 inch to cm")`, `evaluate("sin(x * pi)", { "x": 1/2 })`, `evaluate(["width=2", "height=4","width*height"])`], seealso: [`parser`, `parse`, `compile`] }, parserDocs$2 = { name: `parser`, category: `Expression`, syntax: [`parser()`], description: `Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.`, examples: [`myParser = parser()`, `myParser.evaluate("sqrt(3^2 + 4^2)")`, `myParser.set("x", 3)`, `myParser.evaluate("y = x + 3")`, `myParser.evaluate(["y = x + 3", "y = y + 1"])`, `myParser.get("y")`], seealso: [`evaluate`, `parse`, `compile`] }, parseDocs$2 = { name: `parse`, category: `Expression`, syntax: [`parse(expr)`, `parse(expr, options)`, `parse([expr1, expr2, expr3, ...])`, `parse([expr1, expr2, expr3, ...], options)`], description: `Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().`, examples: [`node1 = parse("sqrt(3^2 + 4^2)")`, `node1.evaluate()`, `code1 = node1.compile()`, `code1.evaluate()`, `scope = {a: 3, b: 4}`, `node2 = parse("a * b")`, `node2.evaluate(scope)`, `code2 = node2.compile()`, `code2.evaluate(scope)`], seealso: [`parser`, `evaluate`, `compile`] }, compileDocs$2 = { name: `compile`, category: `Expression`, syntax: [`compile(expr) `, `compile([expr1, expr2, expr3, ...])`], description: `Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.`, examples: [`code1 = compile("sqrt(3^2 + 4^2)")`, `code1.evaluate() `, `code2 = compile("a * b")`, `code2.evaluate({a: 3, b: 4})`], seealso: [`parser`, `parse`, `evaluate`] }, helpDocs$2 = { name: `help`, category: `Expression`, syntax: [`help(object)`, `help(string)`], description: `Display documentation on a function or data type.`, examples: [`help(sqrt)`, `help("complex")`], seealso: [] }, distanceDocs$2 = { name: `distance`, category: `Geometry`, syntax: [`distance([x1, y1], [x2, y2])`, `distance([[x1, y1], [x2, y2]])`], description: `Calculates the Euclidean distance between two points.`, examples: [`distance([0,0], [4,4])`, `distance([[0,0], [4,4]])`], seealso: [] }, intersectDocs$2 = { name: `intersect`, category: `Geometry`, syntax: [`intersect(expr1, expr2, expr3, expr4)`, `intersect(expr1, expr2, expr3)`], description: `Computes the intersection point of lines and/or planes.`, examples: [`intersect([0, 0], [10, 10], [10, 0], [0, 10])`, `intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])`], seealso: [] }, andDocs$2 = { name: `and`, category: `Logical`, syntax: [`x and y`, `and(x, y)`], description: `Logical and. Test whether two values are both defined with a nonzero/nonempty value.`, examples: [`true and false`, `true and true`, `2 and 4`], seealso: [`not`, `or`, `xor`] }, notDocs$2 = { name: `not`, category: `Logical`, syntax: [`not x`, `not(x)`], description: `Logical not. Flips the boolean value of given argument.`, examples: [`not true`, `not false`, `not 2`, `not 0`], seealso: [`and`, `or`, `xor`] }, nullishDocs$2 = { name: `nullish`, category: `Logical`, syntax: [`x ?? y`, `nullish(x, y)`], description: `Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.`, examples: [`null ?? 42`, `undefined ?? 42`, `0 ?? 42`, `false ?? 42`, `null ?? undefined ?? 42`], seealso: [`and`, `or`, `not`] }, orDocs$2 = { name: `or`, category: `Logical`, syntax: [`x or y`, `or(x, y)`], description: `Logical or. Test if at least one value is defined with a nonzero/nonempty value.`, examples: [`true or false`, `false or false`, `0 or 4`], seealso: [`not`, `and`, `xor`] }, xorDocs$2 = { name: `xor`, category: `Logical`, syntax: [`x xor y`, `xor(x, y)`], description: `Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.`, examples: [`true xor false`, `false xor false`, `true xor true`, `0 xor 4`], seealso: [`not`, `and`, `or`] }, mapSlicesDocs$2 = { name: `mapSlices`, category: `Matrix`, syntax: [`mapSlices(A, dim, callback)`], description: `Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.`, examples: [`A = [[1, 2], [3, 4]]`, `mapSlices(A, 1, sum)`, `mapSlices(A, 2, prod)`], seealso: [`map`, `forEach`] }, columnDocs$2 = { name: `column`, category: `Matrix`, syntax: [`column(x, index)`], description: `Return a column from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `column(A, 1)`, `column(A, 2)`], seealso: [`row`, `matrixFromColumns`] }, concatDocs$2 = { name: `concat`, category: `Matrix`, syntax: [`concat(A, B, C, ...)`, `concat(A, B, C, ..., dim)`], description: `Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.`, examples: [`A = [1, 2; 5, 6]`, `B = [3, 4; 7, 8]`, `concat(A, B)`, `concat(A, B, 1)`, `concat(A, B, 2)`], seealso: [`det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, countDocs$2 = { name: `count`, category: `Matrix`, syntax: [`count(x)`], description: `Count the number of elements of a matrix, array or string.`, examples: [`a = [1, 2; 3, 4; 5, 6]`, `count(a)`, `size(a)`, `count("hello world")`], seealso: [`size`] }, crossDocs$2 = { name: `cross`, category: `Matrix`, syntax: [`cross(A, B)`], description: `Calculate the cross product for two vectors in three dimensional space.`, examples: [`cross([1, 1, 0],  [0, 1, 1])`, `cross([3, -3, 1], [4, 9, 2])`, `cross([2, 3, 4],  [5, 6, 7])`], seealso: [`multiply`, `dot`] }, ctransposeDocs$2 = { name: `ctranspose`, category: `Matrix`, syntax: [`x'`, `ctranspose(x)`], description: `Complex Conjugate and Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `ctranspose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, detDocs$2 = { name: `det`, category: `Matrix`, syntax: [`det(x)`], description: `Calculate the determinant of a matrix`, examples: [`det([1, 2; 3, 4])`, `det([-2, 2, 3; -1, 1, 3; 2, 0, -1])`], seealso: [`concat`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diagDocs$2 = { name: `diag`, category: `Matrix`, syntax: [`diag(x)`, `diag(x, k)`], description: `Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.`, examples: [`diag(1:3)`, `diag(1:3, 1)`, `a = [1, 2, 3; 4, 5, 6; 7, 8, 9]`, `diag(a)`], seealso: [`concat`, `det`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diffDocs$2 = { name: `diff`, category: `Matrix`, syntax: [`diff(arr)`, `diff(arr, dim)`], description: [`Create a new matrix or array with the difference of the passed matrix or array.`, `Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference`, `If no dimension parameter is passed it is assumed as dimension 0`, `Dimension is zero-based in javascript and one-based in the parser`, `Arrays must be 'rectangular' meaning arrays like [1, 2]`, `If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays`], examples: [`A = [1, 2, 4, 7, 0]`, `diff(A)`, `diff(A, 1)`, `B = [[1, 2], [3, 4]]`, `diff(B)`, `diff(B, 1)`, `diff(B, 2)`, `diff(B, bignumber(2))`, `diff([[1, 2], matrix([3, 4])], 2)`], seealso: [`subtract`, `partitionSelect`] }, dotDocs$2 = { name: `dot`, category: `Matrix`, syntax: [`dot(A, B)`, `A * B`], description: `Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn`, examples: [`dot([2, 4, 1], [2, 2, 3])`, `[2, 4, 1] * [2, 2, 3]`], seealso: [`multiply`, `cross`] }, eigsDocs$2 = { name: `eigs`, category: `Matrix`, syntax: [`eigs(x)`], description: `Calculate the eigenvalues and optionally eigenvectors of a square matrix`, examples: [`eigs([[5, 2.3], [2.3, 1]])`, `eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })`], seealso: [`inv`] }, filterDocs$2 = { name: `filter`, category: `Matrix`, syntax: [`filter(x, test)`], description: `Filter items in a matrix.`, examples: [`isPositive(x) = x > 0`, `filter([6, -2, -1, 4, 3], isPositive)`, `filter([6, -2, 0, 1, 0], x != 0)`], seealso: [`sort`, `map`, `forEach`] }, flattenDocs$2 = { name: `flatten`, category: `Matrix`, syntax: [`flatten(x)`], description: `Flatten a multi dimensional matrix into a single dimensional matrix.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `size(a)`, `b = flatten(a)`, `size(b)`], seealso: [`concat`, `resize`, `size`, `squeeze`] }, forEachDocs$2 = { name: `forEach`, category: `Matrix`, syntax: [`forEach(x, callback)`], description: `Iterates over all elements of a matrix/array, and executes the given callback function.`, examples: [`numberOfPets = {}`, `addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;`, `forEach(["Dog","Cat","Cat"], addPet)`, `numberOfPets`], seealso: [`map`, `sort`, `filter`] }, getMatrixDataTypeDocs$2 = { name: `getMatrixDataType`, category: `Matrix`, syntax: [`getMatrixDataType(x)`], description: `Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".`, examples: [`getMatrixDataType([1, 2, 3])`, `getMatrixDataType([[5 cm], [2 inch]])`, `getMatrixDataType([1, "text"])`, `getMatrixDataType([1, bignumber(4)])`], seealso: [`matrix`, `sparse`, `typeOf`] }, identityDocs$2 = { name: `identity`, category: `Matrix`, syntax: [`identity(n)`, `identity(m, n)`, `identity([m, n])`], description: `Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.`, examples: [`identity(3)`, `identity(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `identity(size(a))`], seealso: [`concat`, `det`, `diag`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, invDocs$2 = { name: `inv`, category: `Matrix`, syntax: [`inv(x)`], description: `Calculate the inverse of a matrix`, examples: [`inv([1, 2; 3, 4])`, `inv(4)`, `1 / 4`], seealso: [`concat`, `det`, `diag`, `identity`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, pinvDocs$2 = { name: `pinv`, category: `Matrix`, syntax: [`pinv(x)`], description: `Calculate the Moore–Penrose inverse of a matrix`, examples: [`pinv([1, 2; 3, 4])`, `pinv([[1, 0], [0, 1], [0, 1]])`, `pinv(4)`], seealso: [`inv`] }, kronDocs$2 = { name: `kron`, category: `Matrix`, syntax: [`kron(x, y)`], description: `Calculates the Kronecker product of 2 matrices or vectors.`, examples: [`kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])`, `kron([1,1], [2,3,4])`], seealso: [`multiply`, `dot`, `cross`] }, mapDocs$2 = { name: `map`, category: `Matrix`, syntax: [`map(x, callback)`, `map(x, y, ..., callback)`], description: `Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.`, examples: [`map([1, 2, 3], square)`, `map([1, 2], [3, 4], f(a,b) = a + b)`], seealso: [`filter`, `forEach`] }, matrixFromColumnsDocs$2 = { name: `matrixFromColumns`, category: `Matrix`, syntax: [`matrixFromColumns(...arr)`, `matrixFromColumns(row1, row2)`, `matrixFromColumns(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual columns.`, examples: [`matrixFromColumns([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromRows`, `matrixFromFunction`, `zeros`] }, matrixFromFunctionDocs$2 = { name: `matrixFromFunction`, category: `Matrix`, syntax: [`matrixFromFunction(size, fn)`, `matrixFromFunction(size, fn, format)`, `matrixFromFunction(size, fn, format, datatype)`, `matrixFromFunction(size, format, fn)`, `matrixFromFunction(size, format, datatype, fn)`], description: `Create a matrix by evaluating a generating function at each index.`, examples: [`f(I) = I[1] - I[2]`, `matrixFromFunction([3,3], f)`, `g(I) = I[1] - I[2] == 1 ? 4 : 0`, `matrixFromFunction([100, 100], "sparse", g)`, `matrixFromFunction([5], random)`], seealso: [`matrix`, `matrixFromRows`, `matrixFromColumns`, `zeros`] }, matrixFromRowsDocs$2 = { name: `matrixFromRows`, category: `Matrix`, syntax: [`matrixFromRows(...arr)`, `matrixFromRows(row1, row2)`, `matrixFromRows(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual rows.`, examples: [`matrixFromRows([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromColumns`, `matrixFromFunction`, `zeros`] }, onesDocs$2 = { name: `ones`, category: `Matrix`, syntax: [`ones(m)`, `ones(m, n)`, `ones(m, n, p, ...)`, `ones([m])`, `ones([m, n])`, `ones([m, n, p, ...])`], description: `Create a matrix containing ones.`, examples: [`ones(3)`, `ones(3, 5)`, `ones([2,3]) * 4.5`, `a = [1, 2, 3; 4, 5, 6]`, `ones(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, partitionSelectDocs$2 = { name: `partitionSelect`, category: `Matrix`, syntax: [`partitionSelect(x, k)`, `partitionSelect(x, k, compare)`], description: `Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.`, examples: [`partitionSelect([5, 10, 1], 2)`, `partitionSelect(["C", "B", "A", "D"], 1, compareText)`, `arr = [5, 2, 1]`, `partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]`, `arr`, `partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]`, `arr`], seealso: [`sort`] }, rangeDocs$2 = { name: `range`, category: `Type`, syntax: [`start:end`, `start:step:end`, `range(start, end)`, `range(start, end, step)`, `range(string)`], description: `Create a range. Lower bound of the range is included, upper bound is excluded.`, examples: [`1:5`, `3:-1:-3`, `range(3, 7)`, `range(0, 12, 2)`, `range("4:10")`, `range(1m, 1m, 3m)`, `a = [1, 2, 3, 4; 5, 6, 7, 8]`, `a[1:2, 1:2]`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, reshapeDocs$2 = { name: `reshape`, category: `Matrix`, syntax: [`reshape(x, sizes)`], description: `Reshape a multi dimensional array to fit the specified dimensions.`, examples: [`reshape([1, 2, 3, 4, 5, 6], [2, 3])`, `reshape([[1, 2], [3, 4]], [1, 4])`, `reshape([[1, 2], [3, 4]], [4])`, `reshape([1, 2, 3, 4], [-1, 2])`], seealso: [`size`, `squeeze`, `resize`] }, resizeDocs$2 = { name: `resize`, category: `Matrix`, syntax: [`resize(x, size)`, `resize(x, size, defaultValue)`], description: `Resize a matrix.`, examples: [`resize([1,2,3,4,5], [3])`, `resize([1,2,3], [5])`, `resize([1,2,3], [5], -1)`, `resize(2, [2, 3])`, `resize("hello", [8], "!")`], seealso: [`size`, `subset`, `squeeze`, `reshape`] }, rotateDocs$2 = { name: `rotate`, category: `Matrix`, syntax: [`rotate(w, theta)`, `rotate(w, theta, v)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotate([1, 0], pi / 2)`, `rotate(matrix([1, 0]), unit("35deg"))`, `rotate([1, 0, 0], unit("90deg"), [0, 0, 1])`, `rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))`], seealso: [`matrix`, `rotationMatrix`] }, rotationMatrixDocs$2 = { name: `rotationMatrix`, category: `Matrix`, syntax: [`rotationMatrix(theta)`, `rotationMatrix(theta, v)`, `rotationMatrix(theta, v, format)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotationMatrix(pi / 2)`, `rotationMatrix(unit("45deg"), [0, 0, 1])`, `rotationMatrix(1, matrix([0, 0, 1]), "sparse")`], seealso: [`cos`, `sin`] }, rowDocs$2 = { name: `row`, category: `Matrix`, syntax: [`row(x, index)`], description: `Return a row from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `row(A, 1)`, `row(A, 2)`], seealso: [`column`, `matrixFromRows`] }, sizeDocs$2 = { name: `size`, category: `Matrix`, syntax: [`size(x)`], description: `Calculate the size of a matrix.`, examples: [`size(2.3)`, `size("hello world")`, `a = [1, 2; 3, 4; 5, 6]`, `size(a)`, `size(1:6)`], seealso: [`concat`, `count`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, sortDocs$2 = { name: `sort`, category: `Matrix`, syntax: [`sort(x)`, `sort(x, compare)`], description: `Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.`, examples: [`sort([5, 10, 1])`, `sort(["C", "B", "A", "D"], "natural")`, `sortByLength(a, b) = size(a)[1] - size(b)[1]`, `sort(["Langdon", "Tom", "Sara"], sortByLength)`, `sort(["10", "1", "2"], "natural")`], seealso: [`map`, `filter`, `forEach`] }, squeezeDocs$2 = { name: `squeeze`, category: `Matrix`, syntax: [`squeeze(x)`], description: `Remove inner and outer singleton dimensions from a matrix.`, examples: [`a = zeros(3,2,1)`, `size(squeeze(a))`, `b = zeros(1,1,3)`, `size(squeeze(b))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `subset`, `trace`, `transpose`, `zeros`] }, subsetDocs$2 = { name: `subset`, category: `Matrix`, syntax: [`value(index)`, `value(index) = replacement`, `subset(value, [index])`, `subset(value, [index], replacement)`], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: [`d = [1, 2; 3, 4]`, `e = []`, `e[1, 1:2] = [5, 6]`, `e[2, :] = [7, 8]`, `f = d * e`, `f[2, 1]`, `f[:, 1]`, `f[[1,2], [1,3]] = [9, 10; 11, 12]`, `f`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `trace`, `transpose`, `zeros`] }, traceDocs$2 = { name: `trace`, category: `Matrix`, syntax: [`trace(A)`], description: `Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.`, examples: [`A = [1, 2, 3; -1, 2, 3; 2, 0, 3]`, `trace(A)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `transpose`, `zeros`] }, transposeDocs$2 = { name: `transpose`, category: `Matrix`, syntax: [`x'`, `transpose(x)`], description: `Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `transpose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, zerosDocs$2 = { name: `zeros`, category: `Matrix`, syntax: [`zeros(m)`, `zeros(m, n)`, `zeros(m, n, p, ...)`, `zeros([m])`, `zeros([m, n])`, `zeros([m, n, p, ...])`], description: `Create a matrix containing zeros.`, examples: [`zeros(3)`, `zeros(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `zeros(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`] }, fftDocs$2 = { name: `fft`, category: `Matrix`, syntax: [`fft(x)`], description: `Calculate N-dimensional Fourier transform`, examples: [`fft([[1, 0], [1, 0]])`], seealso: [`ifft`] }, ifftDocs$2 = { name: `ifft`, category: `Matrix`, syntax: [`ifft(x)`], description: `Calculate N-dimensional inverse Fourier transform`, examples: [`ifft([[2, 2], [0, 0]])`], seealso: [`fft`] }, bernoulliDocs$2 = { name: `bernoulli`, category: `Probability`, syntax: [`bernoulli(n)`], description: `The nth Bernoulli number`, examples: [`bernoulli(4)`, `bernoulli(fraction(12))`], seealso: [`combinations`, `gamma`, `stirlingS2`] }, combinationsDocs$2 = { name: `combinations`, category: `Probability`, syntax: [`combinations(n, k)`], description: `Compute the number of combinations of n items taken k at a time`, examples: [`combinations(7, 5)`], seealso: [`combinationsWithRep`, `permutations`, `factorial`] }, combinationsWithRepDocs$2 = { name: `combinationsWithRep`, category: `Probability`, syntax: [`combinationsWithRep(n, k)`], description: `Compute the number of combinations of n items taken k at a time with replacements.`, examples: [`combinationsWithRep(7, 5)`], seealso: [`combinations`, `permutations`, `factorial`] }, factorialDocs$2 = { name: `factorial`, category: `Probability`, syntax: [`n!`, `factorial(n)`], description: `Compute the factorial of a value`, examples: [`5!`, `5 * 4 * 3 * 2 * 1`, `3!`], seealso: [`combinations`, `combinationsWithRep`, `permutations`, `gamma`] }, gammaDocs$2 = { name: `gamma`, category: `Probability`, syntax: [`gamma(n)`], description: `Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.`, examples: [`gamma(4)`, `3!`, `gamma(1/2)`, `sqrt(pi)`], seealso: [`factorial`] }, lgammaDocs$2 = { name: `lgamma`, category: `Probability`, syntax: [`lgamma(n)`], description: `Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.`, examples: [`lgamma(4)`, `lgamma(1/2)`, `lgamma(i)`, `lgamma(complex(1.1, 2))`], seealso: [`gamma`] }, kldivergenceDocs$2 = { name: `kldivergence`, category: `Probability`, syntax: [`kldivergence(x, y)`], description: `Calculate the Kullback-Leibler (KL) divergence  between two distributions.`, examples: [`kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])`], seealso: [] }, multinomialDocs$2 = { name: `multinomial`, category: `Probability`, syntax: [`multinomial(A)`], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: [`multinomial([1, 2, 1])`], seealso: [`combinations`, `factorial`] }, permutationsDocs$2 = { name: `permutations`, category: `Probability`, syntax: [`permutations(n)`, `permutations(n, k)`], description: `Compute the number of permutations of n items taken k at a time`, examples: [`permutations(5)`, `permutations(5, 3)`], seealso: [`combinations`, `combinationsWithRep`, `factorial`] }, pickRandomDocs$2 = { name: `pickRandom`, category: `Probability`, syntax: [`pickRandom(array)`, `pickRandom(array, number)`, `pickRandom(array, weights)`, `pickRandom(array, number, weights)`, `pickRandom(array, weights, number)`], description: `Pick a random entry from a given array.`, examples: [`pickRandom(0:10)`, `pickRandom([1, 3, 1, 6])`, `pickRandom([1, 3, 1, 6], 2)`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)`], seealso: [`random`, `randomInt`] }, randomDocs$2 = { name: `random`, category: `Probability`, syntax: [`random()`, `random(max)`, `random(min, max)`, `random(size)`, `random(size, max)`, `random(size, min, max)`], description: `Return a random number.`, examples: [`random()`, `random(10, 20)`, `random([2, 3])`], seealso: [`pickRandom`, `randomInt`] }, randomIntDocs$2 = { name: `randomInt`, category: `Probability`, syntax: [`randomInt(max)`, `randomInt(min, max)`, `randomInt(size)`, `randomInt(size, max)`, `randomInt(size, min, max)`], description: `Return a random integer number`, examples: [`randomInt(10, 20)`, `randomInt([2, 3], 10)`], seealso: [`pickRandom`, `random`] }, compareDocs$2 = { name: `compare`, category: `Relational`, syntax: [`compare(x, y)`], description: `Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compare(2, 3)`, `compare(3, 2)`, `compare(2, 2)`, `compare(5cm, 40mm)`, `compare(2, [1, 2, 3])`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compareNatural`, `compareText`] }, compareNaturalDocs$2 = { name: `compareNatural`, category: `Relational`, syntax: [`compareNatural(x, y)`], description: `Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareNatural(2, 3)`, `compareNatural(3, 2)`, `compareNatural(2, 2)`, `compareNatural(5cm, 40mm)`, `compareNatural("2", "10")`, `compareNatural(2 + 3i, 2 + 4i)`, `compareNatural([1, 2, 4], [1, 2, 3])`, `compareNatural([1, 5], [1, 2, 3])`, `compareNatural([1, 2], [1, 2])`, `compareNatural({a: 2}, {a: 4})`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`, `compareText`] }, compareTextDocs$2 = { name: `compareText`, category: `Relational`, syntax: [`compareText(x, y)`], description: `Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareText("B", "A")`, `compareText("A", "B")`, `compareText("A", "A")`, `compareText("2", "10")`, `compare("2", "10")`, `compare(2, 10)`, `compareNatural("2", "10")`, `compareText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`] }, deepEqualDocs$2 = { name: `deepEqual`, category: `Relational`, syntax: [`deepEqual(x, y)`], description: `Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.`, examples: [`deepEqual([1,3,4], [1,3,4])`, `deepEqual([1,3,4], [1,3])`], seealso: [`equal`, `unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`] }, equalDocs$2 = { name: `equal`, category: `Relational`, syntax: [`x == y`, `equal(x, y)`], description: `Check equality of two values. Returns true if the values are equal, and false if not.`, examples: [`2+2 == 3`, `2+2 == 4`, `a = 3.2`, `b = 6-2.8`, `a == b`, `50cm == 0.5m`], seealso: [`unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`, `equalText`] }, equalTextDocs$2 = { name: `equalText`, category: `Relational`, syntax: [`equalText(x, y)`], description: `Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.`, examples: [`equalText("Hello", "Hello")`, `equalText("a", "A")`, `equal("2e3", "2000")`, `equalText("2e3", "2000")`, `equalText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`, `compareText`, `equal`] }, largerDocs$2 = { name: `larger`, category: `Relational`, syntax: [`x > y`, `larger(x, y)`], description: `Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 > 3`, `5 > 2*2`, `a = 3.3`, `b = 6-2.8`, `(a > b)`, `(b < a)`, `5 cm > 2 inch`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`] }, largerEqDocs$2 = { name: `largerEq`, category: `Relational`, syntax: [`x >= y`, `largerEq(x, y)`], description: `Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.`, examples: [`2 >= 1+1`, `2 > 1+1`, `a = 3.2`, `b = 6-2.8`, `(a >= b)`], seealso: [`equal`, `unequal`, `smallerEq`, `smaller`, `compare`] }, smallerDocs$2 = { name: `smaller`, category: `Relational`, syntax: [`x < y`, `smaller(x, y)`], description: `Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 < 3`, `5 < 2*2`, `a = 3.3`, `b = 6-2.8`, `(a < b)`, `5 cm < 2 inch`], seealso: [`equal`, `unequal`, `larger`, `smallerEq`, `largerEq`, `compare`] }, smallerEqDocs$2 = { name: `smallerEq`, category: `Relational`, syntax: [`x <= y`, `smallerEq(x, y)`], description: `Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.`, examples: [`2 <= 1+1`, `2 < 1+1`, `a = 3.2`, `b = 6-2.8`, `(a <= b)`], seealso: [`equal`, `unequal`, `larger`, `smaller`, `largerEq`, `compare`] }, unequalDocs$2 = { name: `unequal`, category: `Relational`, syntax: [`x != y`, `unequal(x, y)`], description: `Check unequality of two values. Returns true if the values are unequal, and false if they are equal.`, examples: [`2+2 != 3`, `2+2 != 4`, `a = 3.2`, `b = 6-2.8`, `a != b`, `50cm != 0.5m`, `5 cm != 2 inch`], seealso: [`equal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`] }, setCartesianDocs$2 = { name: `setCartesian`, category: `Set`, syntax: [`setCartesian(set1, set2)`], description: `Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.`, examples: [`setCartesian([1, 2], [3, 4])`], seealso: [`setUnion`, `setIntersect`, `setDifference`, `setPowerset`] }, setDifferenceDocs$2 = { name: `setDifference`, category: `Set`, syntax: [`setDifference(set1, set2)`], description: `Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setSymDifference`] }, setDistinctDocs$2 = { name: `setDistinct`, category: `Set`, syntax: [`setDistinct(set)`], description: `Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setDistinct([1, 1, 1, 2, 2, 3])`], seealso: [`setMultiplicity`] }, setIntersectDocs$2 = { name: `setIntersect`, category: `Set`, syntax: [`setIntersect(set1, set2)`], description: `Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIntersect([1, 2, 3, 4], [3, 4, 5, 6])`, `setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setDifference`] }, setIsSubsetDocs$2 = { name: `setIsSubset`, category: `Set`, syntax: [`setIsSubset(set1, set2)`], description: `Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIsSubset([1, 2], [3, 4, 5, 6])`, `setIsSubset([3, 4], [3, 4, 5, 6])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setMultiplicityDocs$2 = { name: `setMultiplicity`, category: `Set`, syntax: [`setMultiplicity(element, set)`], description: `Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setMultiplicity(1, [1, 2, 2, 4])`, `setMultiplicity(2, [1, 2, 2, 4])`], seealso: [`setDistinct`, `setSize`] }, setPowersetDocs$2 = { name: `setPowerset`, category: `Set`, syntax: [`setPowerset(set)`], description: `Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setPowerset([1, 2, 3])`], seealso: [`setCartesian`] }, setSizeDocs$2 = { name: `setSize`, category: `Set`, syntax: [`setSize(set)`, `setSize(set, unique)`], description: `Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setSize([1, 2, 2, 4])`, `setSize([1, 2, 2, 4], true)`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setSymDifferenceDocs$2 = { name: `setSymDifference`, category: `Set`, syntax: [`setSymDifference(set1, set2)`], description: `Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setUnionDocs$2 = { name: `setUnion`, category: `Set`, syntax: [`setUnion(set1, set2)`], description: `Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setUnion([1, 2, 3, 4], [3, 4, 5, 6])`, `setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setIntersect`, `setDifference`] }, zpk2tfDocs$2 = { name: `zpk2tf`, category: `Signal`, syntax: [`zpk2tf(z, p, k)`], description: `Compute the transfer function of a zero-pole-gain model.`, examples: [`zpk2tf([1, 2], [-1, -2], 1)`, `zpk2tf([1, 2], [-1, -2])`, `zpk2tf([1 - 3i, 2 + 2i], [-1, -2])`], seealso: [] }, freqzDocs$2 = { name: `freqz`, category: `Signal`, syntax: [`freqz(b, a)`, `freqz(b, a, w)`], description: `Calculates the frequency response of a filter given its numerator and denominator coefficients.`, examples: [`freqz([1, 2], [1, 2, 3])`, `freqz([1, 2], [1, 2, 3], [0, 1])`, `freqz([1, 2], [1, 2, 3], 512)`], seealso: [] }, erfDocs$2 = { name: `erf`, category: `Special`, syntax: [`erf(x)`], description: `Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x`, examples: [`erf(0.2)`, `erf(-0.5)`, `erf(4)`], seealso: [] }, zetaDocs$2 = { name: `zeta`, category: `Special`, syntax: [`zeta(s)`], description: `Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane`, examples: [`zeta(0.2)`, `zeta(-0.5)`, `zeta(4)`], seealso: [] }, madDocs$2 = { name: `mad`, category: `Statistics`, syntax: [`mad(a, b, c, ...)`, `mad(A)`], description: `Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.`, examples: [`mad(10, 20, 30)`, `mad([1, 2, 3])`], seealso: [`mean`, `median`, `std`, `abs`] }, maxDocs$2 = { name: `max`, category: `Statistics`, syntax: [`max(a, b, c, ...)`, `max(A)`, `max(A, dimension)`], description: `Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`max(2, 3, 4, 1)`, `max([2, 3, 4, 1])`, `max([2, 5; 4, 3])`, `max([2, 5; 4, 3], 1)`, `max([2, 5; 4, 3], 2)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, meanDocs$2 = { name: `mean`, category: `Statistics`, syntax: [`mean(a, b, c, ...)`, `mean(A)`, `mean(A, dimension)`], description: `Compute the arithmetic mean of a list of values.`, examples: [`mean(2, 3, 4, 1)`, `mean([2, 3, 4, 1])`, `mean([2, 5; 4, 3])`, `mean([2, 5; 4, 3], 1)`, `mean([2, 5; 4, 3], 2)`, `mean([1.0, 2.7, 3.2, 4.0])`], seealso: [`max`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, medianDocs$2 = { name: `median`, category: `Statistics`, syntax: [`median(a, b, c, ...)`, `median(A)`], description: `Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.`, examples: [`median(5, 2, 7)`, `median([3, -1, 5, 7])`], seealso: [`max`, `mean`, `min`, `prod`, `std`, `sum`, `variance`, `quantileSeq`] }, minDocs$2 = { name: `min`, category: `Statistics`, syntax: [`min(a, b, c, ...)`, `min(A)`, `min(A, dimension)`], description: `Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`min(2, 3, 4, 1)`, `min([2, 3, 4, 1])`, `min([2, 5; 4, 3])`, `min([2, 5; 4, 3], 1)`, `min([2, 5; 4, 3], 2)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`max`, `mean`, `median`, `prod`, `std`, `sum`, `variance`] }, modeDocs$2 = { name: `mode`, category: `Statistics`, syntax: [`mode(a, b, c, ...)`, `mode(A)`, `mode(A, a, b, B, c, ...)`], description: `Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.`, examples: [`mode(2, 1, 4, 3, 1)`, `mode([1, 2.7, 3.2, 4, 2.7])`, `mode(1, 4, 6, 1, 6)`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `std`, `sum`, `variance`] }, prodDocs$2 = { name: `prod`, category: `Statistics`, syntax: [`prod(a, b, c, ...)`, `prod(A)`], description: `Compute the product of all values.`, examples: [`prod(2, 3, 4)`, `prod([2, 3, 4])`, `prod([2, 5; 4, 3])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `std`, `sum`, `variance`] }, quantileSeqDocs$2 = { name: `quantileSeq`, category: `Statistics`, syntax: [`quantileSeq(A, prob[, sorted])`, `quantileSeq(A, [prob1, prob2, ...][, sorted])`, `quantileSeq(A, N[, sorted])`], description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`, examples: [`quantileSeq([3, -1, 5, 7], 0.5)`, `quantileSeq([3, -1, 5, 7], [1/3, 2/3])`, `quantileSeq([3, -1, 5, 7], 2)`, `quantileSeq([-1, 3, 5, 7], 0.5, true)`], seealso: [`mean`, `median`, `min`, `max`, `prod`, `std`, `sum`, `variance`] }, stdDocs$2 = { name: `std`, category: `Statistics`, syntax: [`std(a, b, c, ...)`, `std(A)`, `std(A, dimension)`, `std(A, normalization)`, `std(A, dimension, normalization)`], description: `Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`std(2, 4, 6)`, `std([2, 4, 6, 8])`, `std([2, 4, 6, 8], "uncorrected")`, `std([2, 4, 6, 8], "biased")`, `std([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `sum`, `variance`] }, cumSumDocs$2 = { name: `cumsum`, category: `Statistics`, syntax: [`cumsum(a, b, c, ...)`, `cumsum(A)`], description: `Compute the cumulative sum of all values.`, examples: [`cumsum(2, 3, 4, 1)`, `cumsum([2, 3, 4, 1])`, `cumsum([1, 2; 3, 4])`, `cumsum([1, 2; 3, 4], 1)`, `cumsum([1, 2; 3, 4], 2)`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, sumDocs$2 = { name: `sum`, category: `Statistics`, syntax: [`sum(a, b, c, ...)`, `sum(A)`, `sum(A, dimension)`], description: `Compute the sum of all values.`, examples: [`sum(2, 3, 4, 1)`, `sum([2, 3, 4, 1])`, `sum([2, 5; 4, 3])`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `variance`] }, varianceDocs$2 = { name: `variance`, category: `Statistics`, syntax: [`variance(a, b, c, ...)`, `variance(A)`, `variance(A, dimension)`, `variance(A, normalization)`, `variance(A, dimension, normalization)`], description: `Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`variance(2, 4, 6)`, `variance([2, 4, 6, 8])`, `variance([2, 4, 6, 8], "uncorrected")`, `variance([2, 4, 6, 8], "biased")`, `variance([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, corrDocs$2 = { name: `corr`, category: `Statistics`, syntax: [`corr(A,B)`], description: `Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.`, examples: [`corr([2, 4, 6, 8],[1, 2, 3, 6])`, `corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, acosDocs$2 = { name: `acos`, category: `Trigonometry`, syntax: [`acos(x)`], description: `Compute the inverse cosine of a value in radians.`, examples: [`acos(0.5)`, `acos(cos(2.3))`], seealso: [`cos`, `atan`, `asin`] }, acoshDocs$2 = { name: `acosh`, category: `Trigonometry`, syntax: [`acosh(x)`], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: [`acosh(1.5)`], seealso: [`cosh`, `asinh`, `atanh`] }, acotDocs$2 = { name: `acot`, category: `Trigonometry`, syntax: [`acot(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acot(0.5)`, `acot(cot(0.5))`, `acot(2)`], seealso: [`cot`, `atan`] }, acothDocs$2 = { name: `acoth`, category: `Trigonometry`, syntax: [`acoth(x)`], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: [`acoth(2)`, `acoth(0.5)`], seealso: [`acsch`, `asech`] }, acscDocs$2 = { name: `acsc`, category: `Trigonometry`, syntax: [`acsc(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acsc(2)`, `acsc(csc(0.5))`, `acsc(0.5)`], seealso: [`csc`, `asin`, `asec`] }, acschDocs$2 = { name: `acsch`, category: `Trigonometry`, syntax: [`acsch(x)`], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: [`acsch(0.5)`], seealso: [`asech`, `acoth`] }, asecDocs$2 = { name: `asec`, category: `Trigonometry`, syntax: [`asec(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asec(0.5)`, `asec(sec(0.5))`, `asec(2)`], seealso: [`acos`, `acot`, `acsc`] }, asechDocs$2 = { name: `asech`, category: `Trigonometry`, syntax: [`asech(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asech(0.5)`], seealso: [`acsch`, `acoth`] }, asinDocs$2 = { name: `asin`, category: `Trigonometry`, syntax: [`asin(x)`], description: `Compute the inverse sine of a value in radians.`, examples: [`asin(0.5)`, `asin(sin(0.5))`], seealso: [`sin`, `acos`, `atan`] }, asinhDocs$2 = { name: `asinh`, category: `Trigonometry`, syntax: [`asinh(x)`], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: [`asinh(0.5)`], seealso: [`acosh`, `atanh`] }, atanDocs$2 = { name: `atan`, category: `Trigonometry`, syntax: [`atan(x)`], description: `Compute the inverse tangent of a value in radians.`, examples: [`atan(0.5)`, `atan(tan(0.5))`], seealso: [`tan`, `acos`, `asin`] }, atan2Docs$2 = { name: `atan2`, category: `Trigonometry`, syntax: [`atan2(y, x)`], description: `Computes the principal value of the arc tangent of y/x in radians.`, examples: [`atan2(2, 2) / pi`, `angle = 60 deg in rad`, `x = cos(angle)`, `y = sin(angle)`, `atan2(y, x)`], seealso: [`sin`, `cos`, `tan`] }, atanhDocs$2 = { name: `atanh`, category: `Trigonometry`, syntax: [`atanh(x)`], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: [`atanh(0.5)`], seealso: [`acosh`, `asinh`] }, cosDocs$2 = { name: `cos`, category: `Trigonometry`, syntax: [`cos(x)`], description: `Compute the cosine of x in radians.`, examples: [`cos(2)`, `cos(pi / 4) ^ 2`, `cos(180 deg)`, `cos(60 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`acos`, `sin`, `tan`] }, coshDocs$2 = { name: `cosh`, category: `Trigonometry`, syntax: [`cosh(x)`], description: `Compute the hyperbolic cosine of x in radians.`, examples: [`cosh(0.5)`], seealso: [`sinh`, `tanh`, `coth`] }, cotDocs$2 = { name: `cot`, category: `Trigonometry`, syntax: [`cot(x)`], description: `Compute the cotangent of x in radians. Defined as 1/tan(x)`, examples: [`cot(2)`, `1 / tan(2)`], seealso: [`sec`, `csc`, `tan`] }, cothDocs$2 = { name: `coth`, category: `Trigonometry`, syntax: [`coth(x)`], description: `Compute the hyperbolic cotangent of x in radians.`, examples: [`coth(2)`, `1 / tanh(2)`], seealso: [`sech`, `csch`, `tanh`] }, cscDocs$2 = { name: `csc`, category: `Trigonometry`, syntax: [`csc(x)`], description: `Compute the cosecant of x in radians. Defined as 1/sin(x)`, examples: [`csc(2)`, `1 / sin(2)`], seealso: [`sec`, `cot`, `sin`] }, cschDocs$2 = { name: `csch`, category: `Trigonometry`, syntax: [`csch(x)`], description: `Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)`, examples: [`csch(2)`, `1 / sinh(2)`], seealso: [`sech`, `coth`, `sinh`] }, secDocs$2 = { name: `sec`, category: `Trigonometry`, syntax: [`sec(x)`], description: `Compute the secant of x in radians. Defined as 1/cos(x)`, examples: [`sec(2)`, `1 / cos(2)`], seealso: [`cot`, `csc`, `cos`] }, sechDocs$2 = { name: `sech`, category: `Trigonometry`, syntax: [`sech(x)`], description: `Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)`, examples: [`sech(2)`, `1 / cosh(2)`], seealso: [`coth`, `csch`, `cosh`] }, sinDocs$2 = { name: `sin`, category: `Trigonometry`, syntax: [`sin(x)`], description: `Compute the sine of x in radians.`, examples: [`sin(2)`, `sin(pi / 4) ^ 2`, `sin(90 deg)`, `sin(30 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`asin`, `cos`, `tan`] }, sinhDocs$2 = { name: `sinh`, category: `Trigonometry`, syntax: [`sinh(x)`], description: `Compute the hyperbolic sine of x in radians.`, examples: [`sinh(0.5)`], seealso: [`cosh`, `tanh`] }, tanDocs$2 = { name: `tan`, category: `Trigonometry`, syntax: [`tan(x)`], description: `Compute the tangent of x in radians.`, examples: [`tan(0.5)`, `sin(0.5) / cos(0.5)`, `tan(pi / 4)`, `tan(45 deg)`], seealso: [`atan`, `sin`, `cos`] }, tanhDocs$2 = { name: `tanh`, category: `Trigonometry`, syntax: [`tanh(x)`], description: `Compute the hyperbolic tangent of x in radians.`, examples: [`tanh(0.5)`, `sinh(0.5) / cosh(0.5)`], seealso: [`sinh`, `cosh`] }, toDocs$2 = { name: `to`, category: `Units`, syntax: [`x to unit`, `to(x, unit)`], description: `Change the unit of a value.`, examples: [`5 inch to cm`, `3.2kg to g`, `16 bytes in bits`], seealso: [] }, toBestDocs$2 = { name: `toBest`, category: `Units`, syntax: [`toBest(x)`, `toBest(x, unitList)`, `toBest(x, unitList, options)`], description: `Converts to the most appropriate display unit.`, examples: [`toBest(unit(5000, "m"))`, `toBest(unit(3500000, "W"))`, `toBest(unit(0.000000123, "A"))`, `toBest(unit(10, "m"), "cm")`, `toBest(unit(10, "m"), "mm,km", {offset: 1.5})`], seealso: [] }, binDocs$2 = { name: `bin`, category: `Utils`, syntax: [`bin(value)`], description: `Format a number as binary`, examples: [`bin(2)`], seealso: [`oct`, `hex`] }, cloneDocs$2 = { name: `clone`, category: `Utils`, syntax: [`clone(x)`], description: `Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices`, examples: [`clone(3.5)`, `clone(2 - 4i)`, `clone(45 deg)`, `clone([1, 2; 3, 4])`, `clone("hello world")`], seealso: [] }, formatDocs$2 = { name: `format`, category: `Utils`, syntax: [`format(value)`, `format(value, precision)`], description: `Format a value of any type as string.`, examples: [`format(2.3)`, `format(3 - 4i)`, `format([])`, `format(pi, 3)`], seealso: [`print`] }, hasNumericValueDocs$2 = { name: `hasNumericValue`, category: `Utils`, syntax: [`hasNumericValue(x)`], description: `Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.`, examples: [`hasNumericValue(2)`, `hasNumericValue("2")`, `isNumeric("2")`, `hasNumericValue(0)`, `hasNumericValue(bignumber(500))`, `hasNumericValue(fraction(0.125))`, `hasNumericValue(2 + 3i)`, `hasNumericValue([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `isNumeric`] }, hexDocs$2 = { name: `hex`, category: `Utils`, syntax: [`hex(value)`], description: `Format a number as hexadecimal`, examples: [`hex(240)`], seealso: [`bin`, `oct`] }, isIntegerDocs$2 = { name: `isInteger`, category: `Utils`, syntax: [`isInteger(x)`], description: `Test whether a value is an integer number.`, examples: [`isInteger(2)`, `isInteger(3.5)`, `isInteger([3, 0.5, -2])`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`] }, isNaNDocs$2 = { name: `isNaN`, category: `Utils`, syntax: [`isNaN(x)`], description: `Test whether a value is NaN (not a number)`, examples: [`isNaN(2)`, `isNaN(0 / 0)`, `isNaN(NaN)`, `isNaN(Infinity)`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`, `isFinite`, `isBounded`] }, isBoundedDocs$2 = { name: `isBounded`, category: `Utils`, syntax: [`isBounded(x)`], description: `Test whether a value or its entries are bounded.`, examples: [`isBounded(Infinity)`, `isBounded(bigint(3))`, `isBounded([3, -Infinity, -3])`], seealso: [`isFinite`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isFiniteDocs$2 = { name: `isFinite`, category: `Utils`, syntax: [`isFinite(x)`], description: `Test whether a value is finite, elementwise on collections.`, examples: [`isFinite(Infinity)`, `isFinite(bigint(3))`, `isFinite([3, -Infinity, -3])`], seealso: [`isBounded`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isNegativeDocs$2 = { name: `isNegative`, category: `Utils`, syntax: [`isNegative(x)`], description: `Test whether a value is negative: smaller than zero.`, examples: [`isNegative(2)`, `isNegative(0)`, `isNegative(-4)`, `isNegative([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isPositive`, `isZero`] }, isNumericDocs$2 = { name: `isNumeric`, category: `Utils`, syntax: [`isNumeric(x)`], description: `Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.`, examples: [`isNumeric(2)`, `isNumeric("2")`, `hasNumericValue("2")`, `isNumeric(0)`, `isNumeric(bignumber(500))`, `isNumeric(fraction(0.125))`, `isNumeric(2 + 3i)`, `isNumeric([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `hasNumericValue`, `isFinite`, `isBounded`] }, isPositiveDocs$2 = { name: `isPositive`, category: `Utils`, syntax: [`isPositive(x)`], description: `Test whether a value is positive: larger than zero.`, examples: [`isPositive(2)`, `isPositive(0)`, `isPositive(-4)`, `isPositive([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isPrimeDocs$2 = { name: `isPrime`, category: `Utils`, syntax: [`isPrime(x)`], description: `Test whether a value is prime: has no divisors other than itself and one.`, examples: [`isPrime(3)`, `isPrime(-2)`, `isPrime([2, 17, 100])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isZeroDocs$2 = { name: `isZero`, category: `Utils`, syntax: [`isZero(x)`], description: `Test whether a value is zero.`, examples: [`isZero(2)`, `isZero(0)`, `isZero(-4)`, `isZero([3, 0, -2, 0])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isPositive`] }, numericDocs$2 = { name: `numeric`, category: `Utils`, syntax: [`numeric(x)`], description: `Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.`, examples: [`numeric("4")`, `numeric("4", "number")`, `numeric("4", "bigint")`, `numeric("4", "BigNumber")`, `numeric("4", "Fraction")`, `numeric(4, "Fraction")`, `numeric(fraction(2, 5), "number")`], seealso: [`number`, `bigint`, `fraction`, `bignumber`, `string`, `format`] }, octDocs$2 = { name: `oct`, category: `Utils`, syntax: [`oct(value)`], description: `Format a number as octal`, examples: [`oct(56)`], seealso: [`bin`, `hex`] }, printDocs$2 = { name: `print`, category: `Utils`, syntax: [`print(template, values)`, `print(template, values, precision)`], description: `Interpolate values into a string template.`, examples: [`print("Lucy is $age years old", {age: 5})`, `print("The value of pi is $pi", {pi: pi}, 3)`, `print("Hello, $user.name!", {user: {name: "John"}})`, `print("Values: $1, $2, $3", [6, 9, 4])`], seealso: [`format`] }, typeOfDocs$2 = { name: `typeOf`, category: `Utils`, syntax: [`typeOf(x)`], description: `Get the type of a variable.`, examples: [`typeOf(3.5)`, `typeOf(2 - 4i)`, `typeOf(45 deg)`, `typeOf("hello world")`], seealso: [`getMatrixDataType`] }, solveODEDocs$2 = { name: `solveODE`, category: `Numeric`, syntax: [`solveODE(func, tspan, y0)`, `solveODE(func, tspan, y0, options)`], description: `Numerical Integration of Ordinary Differential Equations.`, examples: [`f(t,y) = y`, `tspan = [0, 4]`, `solveODE(f, tspan, 1)`, `solveODE(f, tspan, [1, 2])`, `solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })`], seealso: [`derivative`, `simplifyCore`] }, embeddedDocs$2 = { bignumber: bignumberDocs$2, bigint: bigintDocs$2, boolean: booleanDocs$2, complex: complexDocs$2, createUnit: createUnitDocs$2, fraction: fractionDocs$2, index: indexDocs$2, matrix: matrixDocs$2, number: numberDocs$2, sparse: sparseDocs$2, splitUnit: splitUnitDocs$2, string: stringDocs$2, unit: unitDocs$2, e: eDocs$2, E: eDocs$2, false: falseDocs$2, i: iDocs$2, Infinity: InfinityDocs$2, LN2: LN2Docs$2, LN10: LN10Docs$2, LOG2E: LOG2EDocs$2, LOG10E: LOG10EDocs$2, NaN: NaNDocs$2, null: nullDocs$2, pi: piDocs$2, PI: piDocs$2, phi: phiDocs$2, SQRT1_2: SQRT12Docs$2, SQRT2: SQRT2Docs$2, tau: tauDocs$2, true: trueDocs$2, version: versionDocs$2, speedOfLight: { description: `Speed of light in vacuum`, examples: [`speedOfLight`] }, gravitationConstant: { description: `Newtonian constant of gravitation`, examples: [`gravitationConstant`] }, planckConstant: { description: `Planck constant`, examples: [`planckConstant`] }, reducedPlanckConstant: { description: `Reduced Planck constant`, examples: [`reducedPlanckConstant`] }, magneticConstant: { description: `Magnetic constant (vacuum permeability)`, examples: [`magneticConstant`] }, electricConstant: { description: `Electric constant (vacuum permeability)`, examples: [`electricConstant`] }, vacuumImpedance: { description: `Characteristic impedance of vacuum`, examples: [`vacuumImpedance`] }, coulomb: { description: `Coulomb's constant. Deprecated in favor of coulombConstant`, examples: [`coulombConstant`] }, coulombConstant: { description: `Coulomb's constant`, examples: [`coulombConstant`] }, elementaryCharge: { description: `Elementary charge`, examples: [`elementaryCharge`] }, bohrMagneton: { description: `Bohr magneton`, examples: [`bohrMagneton`] }, conductanceQuantum: { description: `Conductance quantum`, examples: [`conductanceQuantum`] }, inverseConductanceQuantum: { description: `Inverse conductance quantum`, examples: [`inverseConductanceQuantum`] }, magneticFluxQuantum: { description: `Magnetic flux quantum`, examples: [`magneticFluxQuantum`] }, nuclearMagneton: { description: `Nuclear magneton`, examples: [`nuclearMagneton`] }, klitzing: { description: `Von Klitzing constant`, examples: [`klitzing`] }, bohrRadius: { description: `Bohr radius`, examples: [`bohrRadius`] }, classicalElectronRadius: { description: `Classical electron radius`, examples: [`classicalElectronRadius`] }, electronMass: { description: `Electron mass`, examples: [`electronMass`] }, fermiCoupling: { description: `Fermi coupling constant`, examples: [`fermiCoupling`] }, fineStructure: { description: `Fine-structure constant`, examples: [`fineStructure`] }, hartreeEnergy: { description: `Hartree energy`, examples: [`hartreeEnergy`] }, protonMass: { description: `Proton mass`, examples: [`protonMass`] }, deuteronMass: { description: `Deuteron Mass`, examples: [`deuteronMass`] }, neutronMass: { description: `Neutron mass`, examples: [`neutronMass`] }, quantumOfCirculation: { description: `Quantum of circulation`, examples: [`quantumOfCirculation`] }, rydberg: { description: `Rydberg constant`, examples: [`rydberg`] }, thomsonCrossSection: { description: `Thomson cross section`, examples: [`thomsonCrossSection`] }, weakMixingAngle: { description: `Weak mixing angle`, examples: [`weakMixingAngle`] }, efimovFactor: { description: `Efimov factor`, examples: [`efimovFactor`] }, atomicMass: { description: `Atomic mass constant`, examples: [`atomicMass`] }, avogadro: { description: `Avogadro's number`, examples: [`avogadro`] }, boltzmann: { description: `Boltzmann constant`, examples: [`boltzmann`] }, faraday: { description: `Faraday constant`, examples: [`faraday`] }, firstRadiation: { description: `First radiation constant`, examples: [`firstRadiation`] }, loschmidt: { description: `Loschmidt constant at T=273.15 K and p=101.325 kPa`, examples: [`loschmidt`] }, gasConstant: { description: `Gas constant`, examples: [`gasConstant`] }, molarPlanckConstant: { description: `Molar Planck constant`, examples: [`molarPlanckConstant`] }, molarVolume: { description: `Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa`, examples: [`molarVolume`] }, sackurTetrode: { description: `Sackur-Tetrode constant at T=1 K and p=101.325 kPa`, examples: [`sackurTetrode`] }, secondRadiation: { description: `Second radiation constant`, examples: [`secondRadiation`] }, stefanBoltzmann: { description: `Stefan-Boltzmann constant`, examples: [`stefanBoltzmann`] }, wienDisplacement: { description: `Wien displacement law constant`, examples: [`wienDisplacement`] }, molarMass: { description: `Molar mass constant`, examples: [`molarMass`] }, molarMassC12: { description: `Molar mass constant of carbon-12`, examples: [`molarMassC12`] }, gravity: { description: `Standard acceleration of gravity (standard acceleration of free-fall on Earth)`, examples: [`gravity`] }, planckLength: { description: `Planck length`, examples: [`planckLength`] }, planckMass: { description: `Planck mass`, examples: [`planckMass`] }, planckTime: { description: `Planck time`, examples: [`planckTime`] }, planckCharge: { description: `Planck charge`, examples: [`planckCharge`] }, planckTemperature: { description: `Planck temperature`, examples: [`planckTemperature`] }, derivative: derivativeDocs$2, lsolve: lsolveDocs$2, lsolveAll: lsolveAllDocs$2, lup: lupDocs$2, lusolve: lusolveDocs$2, leafCount: leafCountDocs$2, polynomialRoot: polynomialRootDocs$2, resolve: resolveDocs$2, simplify: simplifyDocs$2, simplifyConstant: simplifyConstantDocs$2, simplifyCore: simplifyCoreDocs$2, symbolicEqual: symbolicEqualDocs$2, rationalize: rationalizeDocs$2, slu: sluDocs$2, usolve: usolveDocs$2, usolveAll: usolveAllDocs$2, qr: qrDocs$2, abs: absDocs$2, add: addDocs$2, cbrt: cbrtDocs$2, ceil: ceilDocs$2, cube: cubeDocs$2, divide: divideDocs$2, dotDivide: dotDivideDocs$2, dotMultiply: dotMultiplyDocs$2, dotPow: dotPowDocs$2, exp: expDocs$2, expm: expmDocs$2, expm1: expm1Docs$2, fix: fixDocs$2, floor: floorDocs$2, gcd: gcdDocs$2, hypot: hypotDocs$2, lcm: lcmDocs$2, log: logDocs$2, log2: log2Docs$2, log1p: log1pDocs$2, log10: log10Docs$2, mod: modDocs$2, multiply: multiplyDocs$2, norm: normDocs$2, nthRoot: nthRootDocs$2, nthRoots: nthRootsDocs$2, pow: powDocs$2, round: roundDocs$2, sign: signDocs$2, sqrt: sqrtDocs$2, sqrtm: sqrtmDocs$2, square: squareDocs$2, subtract: subtractDocs$2, unaryMinus: unaryMinusDocs$2, unaryPlus: unaryPlusDocs$2, xgcd: xgcdDocs$2, invmod: invmodDocs$2, num: numDocs$2, den: denDocs$2, bitAnd: bitAndDocs$2, bitNot: bitNotDocs$2, bitOr: bitOrDocs$2, bitXor: bitXorDocs$2, leftShift: leftShiftDocs$2, rightArithShift: rightArithShiftDocs$2, rightLogShift: rightLogShiftDocs$2, bellNumbers: bellNumbersDocs$2, catalan: catalanDocs$2, composition: compositionDocs$2, stirlingS2: stirlingS2Docs$2, config: configDocs$2, import: importDocs$2, typed: typedDocs$2, arg: argDocs$2, conj: conjDocs$2, re: reDocs$2, im: imDocs$2, evaluate: evaluateDocs$2, help: helpDocs$2, parse: parseDocs$2, parser: parserDocs$2, compile: compileDocs$2, distance: distanceDocs$2, intersect: intersectDocs$2, and: andDocs$2, not: notDocs$2, nullish: nullishDocs$2, or: orDocs$2, xor: xorDocs$2, mapSlices: mapSlicesDocs$2, concat: concatDocs$2, count: countDocs$2, cross: crossDocs$2, column: columnDocs$2, ctranspose: ctransposeDocs$2, det: detDocs$2, diag: diagDocs$2, diff: diffDocs$2, dot: dotDocs$2, getMatrixDataType: getMatrixDataTypeDocs$2, identity: identityDocs$2, filter: filterDocs$2, flatten: flattenDocs$2, forEach: forEachDocs$2, inv: invDocs$2, pinv: pinvDocs$2, eigs: eigsDocs$2, kron: kronDocs$2, matrixFromFunction: matrixFromFunctionDocs$2, matrixFromRows: matrixFromRowsDocs$2, matrixFromColumns: matrixFromColumnsDocs$2, map: mapDocs$2, ones: onesDocs$2, partitionSelect: partitionSelectDocs$2, range: rangeDocs$2, resize: resizeDocs$2, reshape: reshapeDocs$2, rotate: rotateDocs$2, rotationMatrix: rotationMatrixDocs$2, row: rowDocs$2, size: sizeDocs$2, sort: sortDocs$2, squeeze: squeezeDocs$2, subset: subsetDocs$2, trace: traceDocs$2, transpose: transposeDocs$2, zeros: zerosDocs$2, fft: fftDocs$2, ifft: ifftDocs$2, sylvester: sylvesterDocs$2, schur: schurDocs$2, lyap: lyapDocs$2, solveODE: solveODEDocs$2, bernoulli: bernoulliDocs$2, combinations: combinationsDocs$2, combinationsWithRep: combinationsWithRepDocs$2, factorial: factorialDocs$2, gamma: gammaDocs$2, kldivergence: kldivergenceDocs$2, lgamma: lgammaDocs$2, multinomial: multinomialDocs$2, permutations: permutationsDocs$2, pickRandom: pickRandomDocs$2, random: randomDocs$2, randomInt: randomIntDocs$2, compare: compareDocs$2, compareNatural: compareNaturalDocs$2, compareText: compareTextDocs$2, deepEqual: deepEqualDocs$2, equal: equalDocs$2, equalText: equalTextDocs$2, larger: largerDocs$2, largerEq: largerEqDocs$2, smaller: smallerDocs$2, smallerEq: smallerEqDocs$2, unequal: unequalDocs$2, setCartesian: setCartesianDocs$2, setDifference: setDifferenceDocs$2, setDistinct: setDistinctDocs$2, setIntersect: setIntersectDocs$2, setIsSubset: setIsSubsetDocs$2, setMultiplicity: setMultiplicityDocs$2, setPowerset: setPowersetDocs$2, setSize: setSizeDocs$2, setSymDifference: setSymDifferenceDocs$2, setUnion: setUnionDocs$2, zpk2tf: zpk2tfDocs$2, freqz: freqzDocs$2, erf: erfDocs$2, zeta: zetaDocs$2, cumsum: cumSumDocs$2, mad: madDocs$2, max: maxDocs$2, mean: meanDocs$2, median: medianDocs$2, min: minDocs$2, mode: modeDocs$2, prod: prodDocs$2, quantileSeq: quantileSeqDocs$2, std: stdDocs$2, sum: sumDocs$2, variance: varianceDocs$2, corr: corrDocs$2, acos: acosDocs$2, acosh: acoshDocs$2, acot: acotDocs$2, acoth: acothDocs$2, acsc: acscDocs$2, acsch: acschDocs$2, asec: asecDocs$2, asech: asechDocs$2, asin: asinDocs$2, asinh: asinhDocs$2, atan: atanDocs$2, atanh: atanhDocs$2, atan2: atan2Docs$2, cos: cosDocs$2, cosh: coshDocs$2, cot: cotDocs$2, coth: cothDocs$2, csc: cscDocs$2, csch: cschDocs$2, sec: secDocs$2, sech: sechDocs$2, sin: sinDocs$2, sinh: sinhDocs$2, tan: tanDocs$2, tanh: tanhDocs$2, to: toDocs$2, toBest: toBestDocs$2, clone: cloneDocs$2, format: formatDocs$2, bin: binDocs$2, oct: octDocs$2, hex: hexDocs$2, isNaN: isNaNDocs$2, isBounded: isBoundedDocs$2, isFinite: isFiniteDocs$2, isInteger: isIntegerDocs$2, isNegative: isNegativeDocs$2, isNumeric: isNumericDocs$2, hasNumericValue: hasNumericValueDocs$2, isPositive: isPositiveDocs$2, isPrime: isPrimeDocs$2, isZero: isZeroDocs$2, print: printDocs$2, typeOf: typeOfDocs$2, numeric: numericDocs$2 }, name$79$2 = `help`, dependencies$79$2 = [`typed`, `mathWithTransform`, `Help`], createHelp$2 = factory$2(name$79$2, dependencies$79$2, (t4) => {
  var { typed: n2, mathWithTransform: r2, Help: i2 } = t4;
  return n2(name$79$2, { any: function(t5) {
    var n3, a2 = t5;
    if (typeof t5 != `string`) {
      for (n3 in r2) if (hasOwnProperty$1$4(r2, n3) && t5 === r2[n3]) {
        a2 = n3;
        break;
      }
    }
    var o2 = getSafeProperty$2(embeddedDocs$2, a2);
    if (!o2) {
      var s2 = typeof a2 == `function` ? a2.name : a2;
      throw Error(`No documentation found on "` + s2 + `"`);
    }
    return new i2(o2);
  } });
}), name$78$2 = `chain`, dependencies$78$2 = [`typed`, `Chain`], createChain$2 = factory$2(name$78$2, dependencies$78$2, (t4) => {
  var { typed: n2, Chain: r2 } = t4;
  return n2(name$78$2, { "": function() {
    return new r2();
  }, any: function(t5) {
    return new r2(t5);
  } });
}), name$77$2 = `det`, dependencies$77$2 = [`typed`, `matrix`, `subtractScalar`, `multiply`, `divideScalar`, `isZero`, `unaryMinus`], createDet$2 = factory$2(name$77$2, dependencies$77$2, (t4) => {
  var { typed: n2, matrix: r2, subtractScalar: i2, multiply: a2, divideScalar: o2, isZero: s2, unaryMinus: c2 } = t4;
  return n2(name$77$2, { any: function(t5) {
    return clone$3$2(t5);
  }, "Array | Matrix": function(t5) {
    var n3;
    switch (isMatrix$2(t5) ? n3 = t5.size() : Array.isArray(t5) ? (t5 = r2(t5), n3 = t5.size()) : n3 = [], n3.length) {
      case 0:
        return clone$3$2(t5);
      case 1:
        if (n3[0] === 1) return clone$3$2(t5.valueOf()[0]);
        if (n3[0] === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      case 2:
        var i3 = n3[0], a3 = n3[1];
        if (i3 === a3) return l2(t5.clone().valueOf(), i3);
        if (a3 === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$4(n3) + `)`);
    }
  } });
  function l2(t5, n3, r3) {
    if (n3 === 1) return clone$3$2(t5[0][0]);
    if (n3 === 2) return i2(a2(t5[0][0], t5[1][1]), a2(t5[1][0], t5[0][1]));
    for (var l3 = false, u2 = Array(n3).fill(0).map((t6, n4) => n4), d2 = 0; d2 < n3; d2++) {
      var p2 = u2[d2];
      if (s2(t5[p2][d2])) {
        var m2 = void 0;
        for (m2 = d2 + 1; m2 < n3; m2++) if (!s2(t5[u2[m2]][d2])) {
          p2 = u2[m2], u2[m2] = u2[d2], u2[d2] = p2, l3 = !l3;
          break;
        }
        if (m2 === n3) return t5[p2][d2];
      }
      for (var h2 = t5[p2][d2], g2 = d2 === 0 ? 1 : t5[u2[d2 - 1]][d2 - 1], v2 = d2 + 1; v2 < n3; v2++) for (var y2 = u2[v2], b2 = d2 + 1; b2 < n3; b2++) t5[y2][b2] = o2(i2(a2(t5[y2][b2], h2), a2(t5[y2][d2], t5[p2][b2])), g2);
    }
    var x2 = t5[u2[n3 - 1]][n3 - 1];
    return l3 ? c2(x2) : x2;
  }
}), name$76$2 = `inv`, dependencies$76$2 = [`typed`, `matrix`, `divideScalar`, `addScalar`, `multiply`, `unaryMinus`, `det`, `identity`, `abs`], createInv$2 = factory$2(name$76$2, dependencies$76$2, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, addScalar: a2, multiply: o2, unaryMinus: s2, det: c2, identity: l2, abs: u2 } = t4;
  return n2(name$76$2, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$2(t5) ? t5.size() : arraySize$2(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return isMatrix$2(t5) ? r2([i2(1, t5.valueOf()[0])]) : [i2(1, t5[0])];
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      case 2:
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) return isMatrix$2(t5) ? r2(d2(t5.valueOf(), a3, o3), t5.storage()) : d2(t5, a3, o3);
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$4(n3) + `)`);
    }
  }, any: function(t5) {
    return i2(1, t5);
  } });
  function d2(t5, n3, r3) {
    var d3, p2, m2, h2, g2;
    if (n3 === 1) {
      if (h2 = t5[0][0], h2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(1, h2)]];
    } else if (n3 === 2) {
      var v2 = c2(t5);
      if (v2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(t5[1][1], v2), i2(s2(t5[0][1]), v2)], [i2(s2(t5[1][0]), v2), i2(t5[0][0], v2)]];
    } else {
      var y2 = t5.concat();
      for (d3 = 0; d3 < n3; d3++) y2[d3] = y2[d3].concat();
      for (var b2 = l2(n3).valueOf(), x2 = 0; x2 < r3; x2++) {
        var S2 = u2(y2[x2][x2]), w2 = x2;
        for (d3 = x2 + 1; d3 < n3; ) u2(y2[d3][x2]) > S2 && (S2 = u2(y2[d3][x2]), w2 = d3), d3++;
        if (S2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
        d3 = w2, d3 !== x2 && (g2 = y2[x2], y2[x2] = y2[d3], y2[d3] = g2, g2 = b2[x2], b2[x2] = b2[d3], b2[d3] = g2);
        var E = y2[x2], D = b2[x2];
        for (d3 = 0; d3 < n3; d3++) {
          var O2 = y2[d3], j2 = b2[d3];
          if (d3 !== x2) {
            if (O2[x2] !== 0) {
              for (m2 = i2(s2(O2[x2]), E[x2]), p2 = x2; p2 < r3; p2++) O2[p2] = a2(O2[p2], o2(m2, E[p2]));
              for (p2 = 0; p2 < r3; p2++) j2[p2] = a2(j2[p2], o2(m2, D[p2]));
            }
          } else {
            for (m2 = E[x2], p2 = x2; p2 < r3; p2++) O2[p2] = i2(O2[p2], m2);
            for (p2 = 0; p2 < r3; p2++) j2[p2] = i2(j2[p2], m2);
          }
        }
      }
      return b2;
    }
  }
}), name$75$2 = `pinv`, dependencies$75$2 = [`typed`, `matrix`, `inv`, `deepEqual`, `equal`, `dotDivide`, `dot`, `ctranspose`, `divideScalar`, `multiply`, `add`, `Complex`], createPinv$2 = factory$2(name$75$2, dependencies$75$2, (t4) => {
  var { typed: n2, matrix: r2, inv: i2, deepEqual: a2, equal: o2, dotDivide: s2, dot: c2, ctranspose: l2, divideScalar: u2, multiply: d2, add: p2, Complex: m2 } = t4;
  return n2(name$75$2, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$2(t5) ? t5.size() : arraySize$2(t5);
    switch (n3.length) {
      case 1:
        return b2(t5) ? l2(t5) : n3[0] === 1 ? i2(t5) : s2(l2(t5), c2(t5, t5));
      case 2:
        if (b2(t5)) return l2(t5);
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) try {
          return i2(t5);
        } catch (t6) {
          if (!(t6 instanceof Error && t6.message.match(/Cannot calculate inverse, determinant is zero/))) throw t6;
        }
        return isMatrix$2(t5) ? r2(h2(t5.valueOf(), a3, o3), t5.storage()) : h2(t5, a3, o3);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$4(n3) + `)`);
    }
  }, any: function(t5) {
    return o2(t5, 0) ? clone$3$2(t5) : u2(1, t5);
  } });
  function h2(t5, n3, r3) {
    var { C: a3, F: o3 } = v2(t5, n3, r3), s3 = d2(i2(d2(l2(a3), a3)), l2(a3));
    return d2(d2(l2(o3), i2(d2(o3, l2(o3)))), s3);
  }
  function g2(t5, n3, r3) {
    for (var i3 = clone$3$2(t5), a3 = 0, o3 = 0; o3 < n3; o3++) {
      if (r3 <= a3) return i3;
      for (var c3 = o3; y2(i3[c3][a3]); ) if (c3++, n3 === c3 && (c3 = o3, a3++, r3 === a3)) return i3;
      [i3[c3], i3[o3]] = [i3[o3], i3[c3]];
      for (var l3 = i3[o3][a3], u3 = 0; u3 < r3; u3++) i3[o3][u3] = s2(i3[o3][u3], l3);
      for (var m3 = 0; m3 < n3; m3++) if (m3 !== o3) {
        l3 = i3[m3][a3];
        for (var h3 = 0; h3 < r3; h3++) i3[m3][h3] = p2(i3[m3][h3], d2(-1, d2(l3, i3[o3][h3])));
      }
      a3++;
    }
    return i3;
  }
  function v2(t5, n3, r3) {
    var i3 = g2(t5, n3, r3);
    return { C: t5.map((t6, r4) => t6.filter((t7, r5) => r5 < n3 && !y2(c2(i3[r5], i3[r5])))), F: i3.filter((t6, n4) => !y2(c2(i3[n4], i3[n4]))) };
  }
  function y2(t5) {
    return o2(p2(t5, m2(1, 1)), p2(0, m2(1, 1)));
  }
  function b2(t5) {
    return a2(p2(t5, m2(1, 1)), p2(d2(t5, 0), m2(1, 1)));
  }
});
function createComplexEigs$2(t4) {
  var { addScalar: n2, subtract: r2, flatten: i2, multiply: a2, multiplyScalar: o2, divideScalar: s2, sqrt: c2, abs: l2, bignumber: u2, diag: d2, size: p2, reshape: m2, inv: h2, qr: g2, usolve: v2, usolveAll: y2, equal: b2, complex: x2, larger: S2, smaller: w2, matrixFromColumns: E, dot: D } = t4;
  function O2(t5, n3, r3, i3) {
    var a3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, o3 = j2(t5, n3, r3, i3, a3);
    M2(t5, n3, r3, i3, a3, o3);
    var { values: s3, C: c3 } = N2(t5, n3, r3, i3, a3);
    return a3 ? { values: s3, eigenvectors: F(t5, n3, c3, o3, s3, r3, i3) } : { values: s3 };
  }
  function j2(t5, r3, i3, a3, c3) {
    var p3 = a3 === `BigNumber`, m3 = a3 === `Complex`, h3 = p3 ? u2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1, v3 = p3 ? u2(1) : 1, y3 = p3 ? u2(10) : 2, E2 = o2(y3, y3), D2;
    c3 && (D2 = Array(r3).fill(g3));
    for (var O3 = false; !O3; ) {
      O3 = true;
      for (var j3 = 0; j3 < r3; j3++) {
        for (var M3 = h3, N3 = h3, F2 = 0; F2 < r3; F2++) j3 !== F2 && (M3 = n2(M3, l2(t5[F2][j3])), N3 = n2(N3, l2(t5[j3][F2])));
        if (!b2(M3, 0) && !b2(N3, 0)) {
          for (var I3 = v3, L3 = M3, R3 = s2(N3, y3), z3 = o2(N3, y3); w2(L3, R3); ) L3 = o2(L3, E2), I3 = o2(I3, y3);
          for (; S2(L3, z3); ) L3 = s2(L3, E2), I3 = s2(I3, y3);
          if (w2(s2(n2(L3, N3), I3), o2(n2(M3, N3), 0.95))) {
            O3 = false;
            for (var V3 = s2(1, I3), H3 = 0; H3 < r3; H3++) j3 !== H3 && (t5[j3][H3] = o2(t5[j3][H3], V3), t5[H3][j3] = o2(t5[H3][j3], I3));
            c3 && (D2[j3] = o2(D2[j3], V3));
          }
        }
      }
    }
    return c3 ? d2(D2) : null;
  }
  function M2(t5, i3, a3, c3, d3, p3) {
    var m3 = c3 === `BigNumber`, h3 = m3 ? u2(0) : c3 === `Complex` ? x2(0) : 0;
    m3 && (a3 = u2(a3));
    for (var g3 = 0; g3 < i3 - 2; g3++) {
      for (var v3 = 0, y3 = h3, b3 = g3 + 1; b3 < i3; b3++) {
        var S3 = t5[b3][g3];
        w2(l2(y3), l2(S3)) && (y3 = S3, v3 = b3);
      }
      if (!w2(l2(y3), a3)) {
        if (v3 !== g3 + 1) {
          var E2 = t5[v3];
          t5[v3] = t5[g3 + 1], t5[g3 + 1] = E2;
          for (var D2 = 0; D2 < i3; D2++) {
            var O3 = t5[D2][v3];
            t5[D2][v3] = t5[D2][g3 + 1], t5[D2][g3 + 1] = O3;
          }
          if (d3) {
            var j3 = p3[v3];
            p3[v3] = p3[g3 + 1], p3[g3 + 1] = j3;
          }
        }
        for (var M3 = g3 + 2; M3 < i3; M3++) {
          var N3 = s2(t5[M3][g3], y3);
          if (N3 !== 0) {
            for (var F2 = 0; F2 < i3; F2++) t5[M3][F2] = r2(t5[M3][F2], o2(N3, t5[g3 + 1][F2]));
            for (var I3 = 0; I3 < i3; I3++) t5[I3][g3 + 1] = n2(t5[I3][g3 + 1], o2(N3, t5[I3][M3]));
            if (d3) for (var L3 = 0; L3 < i3; L3++) p3[M3][L3] = r2(p3[M3][L3], o2(N3, p3[g3 + 1][L3]));
          }
        }
      }
    }
    return p3;
  }
  function N2(t5, i3, o3, s3, c3) {
    var p3 = s3 === `BigNumber`, m3 = p3 ? u2(1) : s3 === `Complex` ? x2(1) : 1;
    p3 && (o3 = u2(o3));
    for (var h3 = clone$3$2(t5), v3 = [], y3 = i3, b3 = [], S3 = c3 ? d2(Array(i3).fill(m3)) : void 0, E2 = c3 ? d2(Array(y3).fill(m3)) : void 0, D2 = 0; D2 <= 100; ) {
      D2 += 1;
      for (var O3 = h3[y3 - 1][y3 - 1], j3 = 0; j3 < y3; j3++) h3[j3][j3] = r2(h3[j3][j3], O3);
      var { Q: M3, R: N3 } = g2(h3);
      h3 = a2(N3, M3);
      for (var F2 = 0; F2 < y3; F2++) h3[F2][F2] = n2(h3[F2][F2], O3);
      if (c3 && (E2 = a2(E2, M3)), y3 === 1 || w2(l2(h3[y3 - 1][y3 - 2]), o3)) {
        D2 = 0, v3.push(h3[y3 - 1][y3 - 1]), c3 && (b3.unshift([[1]]), R2(E2, i3), S3 = a2(S3, E2), y3 > 1 && (E2 = d2(Array(y3 - 1).fill(m3)))), --y3, h3.pop();
        for (var V3 = 0; V3 < y3; V3++) h3[V3].pop();
      } else if (y3 === 2 || w2(l2(h3[y3 - 2][y3 - 3]), o3)) {
        D2 = 0;
        var H3 = I2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1]);
        v3.push(...H3), c3 && (b3.unshift(L2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1], H3[0], H3[1], o3, s3)), R2(E2, i3), S3 = a2(S3, E2), y3 > 2 && (E2 = d2(Array(y3 - 2).fill(m3)))), y3 -= 2, h3.pop(), h3.pop();
        for (var U3 = 0; U3 < y3; U3++) h3[U3].pop(), h3[U3].pop();
      }
      if (y3 === 0) break;
    }
    if (v3.sort((t6, n3) => +r2(l2(t6), l2(n3))), D2 > 100) {
      var W3 = Error(`The eigenvalues failed to converge. Only found these eigenvalues: ` + v3.join(`, `));
      throw W3.values = v3, W3.vectors = [], W3;
    }
    return { values: v3, C: c3 ? a2(S3, z2(b3, i3)) : void 0 };
  }
  function F(t5, n3, o3, s3, c3, l3, p3) {
    var m3 = a2(h2(o3), t5, o3), g3 = p3 === `BigNumber`, v3 = p3 === `Complex`, S3 = g3 ? u2(0) : v3 ? x2(0) : 0, w3 = g3 ? u2(1) : v3 ? x2(1) : 1, E2 = [], D2 = [];
    for (var O3 of c3) {
      var j3 = V2(E2, O3, b2);
      j3 === -1 ? (E2.push(O3), D2.push(1)) : D2[j3] += 1;
    }
    for (var M3 = [], N3 = E2.length, F2 = Array(n3).fill(S3), I3 = d2(Array(n3).fill(w3)), L3 = function() {
      var t6 = E2[R3], c4 = r2(m3, a2(t6, I3)), u3 = y2(c4, F2);
      for (u3.shift(); u3.length < D2[R3]; ) {
        var d3 = H2(c4, n3, u3, l3, p3);
        if (d3 === null) break;
        u3.push(d3);
      }
      var g4 = a2(h2(s3), o3);
      u3 = u3.map((t7) => a2(g4, t7)), M3.push(...u3.map((n4) => ({ value: t6, vector: i2(n4) })));
    }, R3 = 0; R3 < N3; R3++) L3();
    return M3;
  }
  function I2(t5, i3, a3, s3) {
    var l3 = n2(t5, s3), u3 = r2(o2(t5, s3), o2(i3, a3)), d3 = o2(l3, 0.5), p3 = o2(c2(r2(o2(l3, l3), o2(4, u3))), 0.5);
    return [n2(d3, p3), r2(d3, p3)];
  }
  function L2(t5, n3, i3, a3, o3, s3, c3, d3) {
    var p3 = d3 === `BigNumber`, m3 = d3 === `Complex`, h3 = p3 ? u2(0) : m3 ? x2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1;
    if (w2(l2(i3), c3)) return [[g3, h3], [h3, g3]];
    if (S2(l2(r2(o3, s3)), c3)) return [[r2(o3, a3), r2(s3, a3)], [i3, i3]];
    var v3 = r2(t5, o3), y3 = r2(a3, o3);
    return w2(l2(n3), c3) && w2(l2(y3), c3) ? [[v3, g3], [i3, h3]] : [[n3, h3], [y3, g3]];
  }
  function R2(t5, n3) {
    for (var r3 = 0; r3 < t5.length; r3++) t5[r3].push(...Array(n3 - t5[r3].length).fill(0));
    for (var i3 = t5.length; i3 < n3; i3++) t5.push(Array(n3).fill(0)), t5[i3][i3] = 1;
    return t5;
  }
  function z2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3; i3++) r3[i3] = Array(n3).fill(0);
    var a3 = 0;
    for (var o3 of t5) {
      for (var s3 = o3.length, c3 = 0; c3 < s3; c3++) for (var l3 = 0; l3 < s3; l3++) r3[a3 + c3][a3 + l3] = o3[c3][l3];
      a3 += s3;
    }
    return r3;
  }
  function V2(t5, n3, r3) {
    for (var i3 = 0; i3 < t5.length; i3++) if (r3(t5[i3], n3)) return i3;
    return -1;
  }
  function H2(t5, n3, r3, i3, a3) {
    for (var o3 = a3 === `BigNumber` ? u2(1e3) : 1e3, s3, c3 = 0; c3 < 5; ++c3) {
      s3 = U2(n3, r3, a3);
      try {
        s3 = v2(t5, s3);
      } catch {
        continue;
      }
      if (S2(G2(s3), o3)) break;
    }
    if (c3 >= 5) return null;
    for (c3 = 0; ; ) {
      var l3 = v2(t5, s3);
      if (w2(G2(W2(s3, [l3])), i3)) break;
      if (++c3 >= 10) return null;
      s3 = K2(l3);
    }
    return s3;
  }
  function U2(t5, n3, r3) {
    var i3 = r3 === `BigNumber`, a3 = r3 === `Complex`, o3 = Array(t5).fill(0).map((t6) => 2 * Math.random() - 1);
    return i3 && (o3 = o3.map((t6) => u2(t6))), a3 && (o3 = o3.map((t6) => x2(t6))), o3 = W2(o3, n3), K2(o3, r3);
  }
  function W2(t5, n3) {
    var i3 = p2(t5);
    for (var o3 of n3) o3 = m2(o3, i3), t5 = r2(t5, a2(s2(D(o3, t5), D(o3, o3)), o3));
    return t5;
  }
  function G2(t5) {
    return l2(c2(D(t5, t5)));
  }
  function K2(t5, n3) {
    return a2(s2(n3 === `BigNumber` ? u2(1) : n3 === `Complex` ? x2(1) : 1, G2(t5)), t5);
  }
  return O2;
}
function createRealSymmetric$2(t4) {
  var { config: n2, addScalar: r2, subtract: i2, abs: a2, atan: o2, cos: s2, sin: c2, multiplyScalar: l2, inv: u2, bignumber: d2, multiply: p2, add: m2 } = t4;
  function h2(t5, r3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n2.relTol, a3 = arguments.length > 3 ? arguments[3] : void 0, o3 = arguments.length > 4 ? arguments[4] : void 0;
    if (a3 === `number`) return g2(t5, i3, o3);
    if (a3 === `BigNumber`) return v2(t5, i3, o3);
    throw TypeError(`Unsupported data type: ` + a3);
  }
  function g2(t5, n3, r3) {
    var i3 = t5.length, a3 = Math.abs(n3 / i3), o3, s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3).fill(0), s3[c3][c3] = 1;
    }
    for (var l3 = D(t5); Math.abs(l3[1]) >= Math.abs(a3); ) {
      var u3 = l3[0][0], d3 = l3[0][1];
      o3 = y2(t5[u3][u3], t5[d3][d3], t5[u3][d3]), t5 = E(t5, o3, u3, d3), r3 && (s3 = x2(s3, o3, u3, d3)), l3 = D(t5);
    }
    for (var p3 = Array(i3).fill(0), m3 = 0; m3 < i3; m3++) p3[m3] = t5[m3][m3];
    return j2(clone$3$2(p3), s3, r3);
  }
  function v2(t5, n3, r3) {
    var i3 = t5.length, o3 = a2(n3 / i3), s3, c3;
    if (r3) {
      c3 = Array(i3);
      for (var l3 = 0; l3 < i3; l3++) c3[l3] = Array(i3).fill(0), c3[l3][l3] = 1;
    }
    for (var u3 = O2(t5); a2(u3[1]) >= a2(o3); ) {
      var d3 = u3[0][0], p3 = u3[0][1];
      s3 = b2(t5[d3][d3], t5[p3][p3], t5[d3][p3]), t5 = w2(t5, s3, d3, p3), r3 && (c3 = S2(c3, s3, d3, p3)), u3 = O2(t5);
    }
    for (var m3 = Array(i3).fill(0), h3 = 0; h3 < i3; h3++) m3[h3] = t5[h3][h3];
    return j2(clone$3$2(m3), c3, r3);
  }
  function y2(t5, r3, i3) {
    var a3 = r3 - t5;
    return Math.abs(a3) <= n2.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * i3 / (r3 - t5));
  }
  function b2(t5, r3, s3) {
    var c3 = i2(r3, t5);
    return a2(c3) <= n2.relTol ? d2(-1).acos().div(4) : l2(0.5, o2(p2(2, s3, u2(c3))));
  }
  function x2(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = Array(a3).fill(0), l3 = Array(a3).fill(0), u3 = 0; u3 < a3; u3++) c3[u3] = o3 * t5[u3][r3] - s3 * t5[u3][i3], l3[u3] = s3 * t5[u3][r3] + o3 * t5[u3][i3];
    for (var d3 = 0; d3 < a3; d3++) t5[d3][r3] = c3[d3], t5[d3][i3] = l3[d3];
    return t5;
  }
  function S2(t5, n3, a3, o3) {
    for (var u3 = t5.length, p3 = s2(n3), m3 = c2(n3), h3 = Array(u3).fill(d2(0)), g3 = Array(u3).fill(d2(0)), v3 = 0; v3 < u3; v3++) h3[v3] = i2(l2(p3, t5[v3][a3]), l2(m3, t5[v3][o3])), g3[v3] = r2(l2(m3, t5[v3][a3]), l2(p3, t5[v3][o3]));
    for (var y3 = 0; y3 < u3; y3++) t5[y3][a3] = h3[y3], t5[y3][o3] = g3[y3];
    return t5;
  }
  function w2(t5, n3, a3, o3) {
    for (var u3 = t5.length, h3 = d2(s2(n3)), g3 = d2(c2(n3)), v3 = l2(h3, h3), y3 = l2(g3, g3), b3 = Array(u3).fill(d2(0)), x3 = Array(u3).fill(d2(0)), S3 = p2(d2(2), h3, g3, t5[a3][o3]), w3 = r2(i2(l2(v3, t5[a3][a3]), S3), l2(y3, t5[o3][o3])), E2 = m2(l2(y3, t5[a3][a3]), S3, l2(v3, t5[o3][o3])), D2 = 0; D2 < u3; D2++) b3[D2] = i2(l2(h3, t5[a3][D2]), l2(g3, t5[o3][D2])), x3[D2] = r2(l2(g3, t5[a3][D2]), l2(h3, t5[o3][D2]));
    t5[a3][a3] = w3, t5[o3][o3] = E2, t5[a3][o3] = d2(0), t5[o3][a3] = d2(0);
    for (var O3 = 0; O3 < u3; O3++) O3 !== a3 && O3 !== o3 && (t5[a3][O3] = b3[O3], t5[O3][a3] = b3[O3], t5[o3][O3] = x3[O3], t5[O3][o3] = x3[O3]);
    return t5;
  }
  function E(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = o3 * o3, l3 = s3 * s3, u3 = Array(a3).fill(0), d3 = Array(a3).fill(0), p3 = c3 * t5[r3][r3] - 2 * o3 * s3 * t5[r3][i3] + l3 * t5[i3][i3], m3 = l3 * t5[r3][r3] + 2 * o3 * s3 * t5[r3][i3] + c3 * t5[i3][i3], h3 = 0; h3 < a3; h3++) u3[h3] = o3 * t5[r3][h3] - s3 * t5[i3][h3], d3[h3] = s3 * t5[r3][h3] + o3 * t5[i3][h3];
    t5[r3][r3] = p3, t5[i3][i3] = m3, t5[r3][i3] = 0, t5[i3][r3] = 0;
    for (var g3 = 0; g3 < a3; g3++) g3 !== r3 && g3 !== i3 && (t5[r3][g3] = u3[g3], t5[g3][r3] = u3[g3], t5[i3][g3] = d3[g3], t5[g3][i3] = d3[g3]);
    return t5;
  }
  function D(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], a3 = 0; a3 < n3; a3++) for (var o3 = a3 + 1; o3 < n3; o3++) Math.abs(r3) < Math.abs(t5[a3][o3]) && (r3 = Math.abs(t5[a3][o3]), i3 = [a3, o3]);
    return [i3, r3];
  }
  function O2(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], o3 = 0; o3 < n3; o3++) for (var s3 = o3 + 1; s3 < n3; s3++) a2(r3) < a2(t5[o3][s3]) && (r3 = a2(t5[o3][s3]), i3 = [o3, s3]);
    return [i3, r3];
  }
  function j2(t5, n3, r3) {
    var i3 = t5.length, o3 = Array(i3), s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3);
    }
    for (var l3 = 0; l3 < i3; l3++) {
      for (var u3 = 0, d3 = t5[0], p3 = 0; p3 < t5.length; p3++) a2(t5[p3]) < a2(d3) && (u3 = p3, d3 = t5[u3]);
      if (o3[l3] = t5.splice(u3, 1)[0], r3) for (var m3 = 0; m3 < i3; m3++) s3[l3][m3] = n3[m3][u3], n3[m3].splice(u3, 1);
    }
    return r3 ? { values: o3, eigenvectors: s3.map((t6, n4) => ({ value: o3[n4], vector: t6 })) } : { values: o3 };
  }
  return h2;
}
var name$74$2 = `eigs`, dependencies$74$2 = `config.typed.matrix.addScalar.equal.subtract.abs.atan.cos.sin.multiplyScalar.divideScalar.inv.bignumber.multiply.add.larger.column.flatten.number.complex.sqrt.diag.size.reshape.qr.usolve.usolveAll.im.re.smaller.matrixFromColumns.dot`.split(`.`), createEigs$2 = factory$2(name$74$2, dependencies$74$2, (t4) => {
  var { config: n2, typed: r2, matrix: i2, addScalar: a2, subtract: o2, equal: s2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, divideScalar: m2, inv: h2, bignumber: g2, multiply: v2, add: y2, larger: b2, column: x2, flatten: S2, number: w2, complex: E, sqrt: D, diag: O2, size: j2, reshape: M2, qr: N2, usolve: F, usolveAll: I2, im: L2, re: R2, smaller: z2, matrixFromColumns: V2, dot: H2 } = t4, U2 = createRealSymmetric$2({ config: n2, addScalar: a2, subtract: o2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, inv: h2, bignumber: g2, multiply: v2, add: y2 }), W2 = createComplexEigs$2({ addScalar: a2, subtract: o2, multiply: v2, multiplyScalar: p2, flatten: S2, divideScalar: m2, sqrt: D, abs: c2, bignumber: g2, diag: O2, size: j2, reshape: M2, qr: N2, inv: h2, usolve: F, usolveAll: I2, equal: s2, complex: E, larger: b2, smaller: z2, matrixFromColumns: V2, dot: H2 });
  return r2(`eigs`, { Array: function(t5) {
    return G2(i2(t5));
  }, "Array, number|BigNumber": function(t5, n3) {
    return G2(i2(t5), { precision: n3 });
  }, "Array, Object"(t5, n3) {
    return G2(i2(t5), n3);
  }, Matrix: function(t5) {
    return G2(t5, { matricize: true });
  }, "Matrix, number|BigNumber": function(t5, n3) {
    return G2(t5, { precision: n3, matricize: true });
  }, "Matrix, Object": function(t5, n3) {
    var r3 = { matricize: true };
    return _extends$5(r3, n3), G2(t5, r3);
  } });
  function G2(t5) {
    var a3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o3 = `eigenvectors` in a3 ? a3.eigenvectors : true, s3 = K2(t5, a3.precision ?? n2.relTol, o3);
    return a3.matricize && (s3.values = i2(s3.values), o3 && (s3.eigenvectors = s3.eigenvectors.map((t6) => {
      var { value: n3, vector: r3 } = t6;
      return { value: n3, vector: i2(r3) };
    }))), o3 && Object.defineProperty(s3, "vectors", { enumerable: false, get: () => {
      throw Error(`eigs(M).vectors replaced with eigs(M).eigenvectors`);
    } }), s3;
  }
  function K2(t5, n3, r3) {
    var i3 = t5.toArray(), a3 = t5.size();
    if (a3.length !== 2 || a3[0] !== a3[1]) throw RangeError(`Matrix must be square (size: ${format$4(a3)})`);
    var o3 = a3[0];
    return J(i3, o3, n3) && (ee2(i3, o3), q2(i3, o3, n3)) ? U2(i3, o3, n3, Y2(t5, i3, o3), r3) : W2(i3, o3, n3, Y2(t5, i3, o3), r3);
  }
  function q2(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = i3; a3 < n3; a3++) if (b2(g2(c2(o2(t5[i3][a3], t5[a3][i3]))), r3)) return false;
    return true;
  }
  function J(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = 0; a3 < n3; a3++) if (b2(g2(c2(L2(t5[i3][a3]))), r3)) return false;
    return true;
  }
  function ee2(t5, n3) {
    for (var r3 = 0; r3 < n3; r3++) for (var i3 = 0; i3 < n3; i3++) t5[r3][i3] = R2(t5[r3][i3]);
  }
  function Y2(t5, n3, r3) {
    var i3 = t5.datatype();
    if (i3 === `number` || i3 === `BigNumber` || i3 === `Complex`) return i3;
    for (var a3 = false, o3 = false, s3 = false, c3 = 0; c3 < r3; c3++) for (var l3 = 0; l3 < r3; l3++) {
      var u3 = n3[c3][l3];
      if (isNumber$2(u3) || isFraction$2(u3)) a3 = true;
      else if (isBigNumber$2(u3)) o3 = true;
      else if (isComplex$2(u3)) s3 = true;
      else throw TypeError(`Unsupported type in Matrix: ` + typeOf$2(u3));
    }
    if (o3 && s3 && console.warn(`Complex BigNumbers not supported, this operation will lose precission.`), s3) {
      for (var d3 = 0; d3 < r3; d3++) for (var p3 = 0; p3 < r3; p3++) n3[d3][p3] = E(n3[d3][p3]);
      return `Complex`;
    }
    if (o3) {
      for (var m3 = 0; m3 < r3; m3++) for (var h3 = 0; h3 < r3; h3++) n3[m3][h3] = g2(n3[m3][h3]);
      return `BigNumber`;
    }
    if (a3) {
      for (var v3 = 0; v3 < r3; v3++) for (var y3 = 0; y3 < r3; y3++) n3[v3][y3] = w2(n3[v3][y3]);
      return `number`;
    } else throw TypeError(`Matrix contains unsupported types only.`);
  }
}), name$73$2 = `expm`, dependencies$73$2 = [`typed`, `abs`, `add`, `identity`, `inv`, `multiply`], createExpm$2 = factory$2(name$73$2, dependencies$73$2, (t4) => {
  var { typed: n2, abs: r2, add: i2, identity: a2, inv: o2, multiply: s2 } = t4;
  return n2(name$73$2, { Matrix: function(t5) {
    var n3 = t5.size();
    if (n3.length !== 2 || n3[0] !== n3[1]) throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
    for (var r3 = n3[0], u3 = l2(c2(t5), 1e-15), d2 = u3.q, p2 = u3.j, m2 = s2(t5, 2 ** -p2), h2 = a2(r3), g2 = a2(r3), v2 = 1, y2 = m2, b2 = -1, x2 = 1; x2 <= d2; x2++) x2 > 1 && (y2 = s2(y2, m2), b2 = -b2), v2 = v2 * (d2 - x2 + 1) / ((2 * d2 - x2 + 1) * x2), h2 = i2(h2, s2(v2, y2)), g2 = i2(g2, s2(v2 * b2, y2));
    for (var S2 = s2(o2(g2), h2), w2 = 0; w2 < p2; w2++) S2 = s2(S2, S2);
    return isSparseMatrix$2(t5) ? t5.createSparseMatrix(S2) : S2;
  } });
  function c2(t5) {
    for (var n3 = t5.size()[0], i3 = 0, a3 = 0; a3 < n3; a3++) {
      for (var o3 = 0, s3 = 0; s3 < n3; s3++) o3 += r2(t5.get([a3, s3]));
      i3 = Math.max(o3, i3);
    }
    return i3;
  }
  function l2(t5, n3) {
    for (var r3 = 30, i3 = 0; i3 < r3; i3++) for (var a3 = 0; a3 <= i3; a3++) {
      var o3 = i3 - a3;
      if (u2(t5, a3, o3) < n3) return { q: a3, j: o3 };
    }
    throw Error(`Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)`);
  }
  function u2(t5, n3, r3) {
    for (var i3 = 1, a3 = 2; a3 <= n3; a3++) i3 *= a3;
    for (var o3 = i3, s3 = n3 + 1; s3 <= 2 * n3; s3++) o3 *= s3;
    var c3 = o3 * (2 * n3 + 1);
    return 8 * (t5 / 2 ** r3) ** (2 * n3) * i3 * i3 / (o3 * c3);
  }
}), name$72$2 = `sqrtm`, dependencies$72$2 = [`typed`, `abs`, `add`, `multiply`, `map`, `sqrt`, `subtract`, `inv`, `size`, `max`, `identity`], createSqrtm$2 = factory$2(name$72$2, dependencies$72$2, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, map: o2, sqrt: s2, subtract: c2, inv: l2, size: u2, max: d2, identity: p2 } = t4, m2 = 1e3, h2 = 1e-6;
  function g2(t5) {
    var n3, o3 = 0, s3 = t5, g3 = p2(u2(t5));
    do {
      var v2 = s3;
      if (s3 = a2(0.5, i2(v2, l2(g3))), g3 = a2(0.5, i2(g3, l2(v2))), n3 = d2(r2(c2(s3, v2))), n3 > h2 && ++o3 > m2) throw Error(`computing square root of matrix: iterative method could not converge`);
    } while (n3 > h2);
    return s3;
  }
  return n2(name$72$2, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$2(t5) ? t5.size() : arraySize$2(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return o2(t5, s2);
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      case 2:
        if (n3[0] === n3[1]) return g2(t5);
        throw RangeError(`Matrix must be square (size: ` + format$4(n3) + `)`);
      default:
        throw RangeError(`Matrix must be at most two dimensional (size: ` + format$4(n3) + `)`);
    }
  } });
}), name$71$2 = `sylvester`, dependencies$71$2 = [`typed`, `schur`, `matrixFromColumns`, `matrix`, `multiply`, `range`, `concat`, `transpose`, `index`, `subset`, `add`, `subtract`, `identity`, `lusolve`, `abs`], createSylvester$2 = factory$2(name$71$2, dependencies$71$2, (t4) => {
  var { typed: n2, schur: r2, matrixFromColumns: i2, matrix: a2, multiply: o2, range: s2, concat: c2, transpose: l2, index: u2, subset: d2, add: p2, subtract: m2, identity: h2, lusolve: g2, abs: v2, config: y2 } = t4;
  return n2(name$71$2, { "Matrix, Matrix, Matrix": b2, "Array, Matrix, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), n3, r3);
  }, "Array, Array, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), r3);
  }, "Array, Matrix, Array": function(t5, n3, r3) {
    return b2(a2(t5), n3, a2(r3));
  }, "Matrix, Array, Matrix": function(t5, n3, r3) {
    return b2(t5, a2(n3), r3);
  }, "Matrix, Array, Array": function(t5, n3, r3) {
    return b2(t5, a2(n3), a2(r3));
  }, "Matrix, Matrix, Array": function(t5, n3, r3) {
    return b2(t5, n3, a2(r3));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), a2(r3)).toArray();
  } });
  function b2(t5, n3, y3) {
    for (var b3 = n3.size()[0], x2 = t5.size()[0], S2 = r2(t5), w2 = S2.T, E = S2.U, D = r2(o2(-1, n3)), O2 = D.T, j2 = D.U, M2 = o2(o2(l2(E), y3), j2), N2 = s2(0, x2), F = [], I2 = (t6, n4) => c2(t6, n4, 1), L2 = (t6, n4) => c2(t6, n4, 0), R2 = 0; R2 < b3; R2++) if (R2 < b3 - 1 && v2(d2(O2, u2(R2 + 1, R2))) > 1e-5) {
      for (var z2 = L2(d2(M2, u2(N2, [R2])), d2(M2, u2(N2, [R2 + 1]))), V2 = 0; V2 < R2; V2++) z2 = p2(z2, L2(o2(F[V2], d2(O2, u2(V2, R2))), o2(F[V2], d2(O2, u2(V2, R2 + 1)))));
      var H2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2)))), U2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2)))), W2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2 + 1)))), G2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2 + 1)))), K2 = g2(L2(I2(p2(w2, H2), U2), I2(W2, p2(w2, G2))), z2);
      F[R2] = K2.subset(u2(s2(0, x2), [0])), F[R2 + 1] = K2.subset(u2(s2(x2, 2 * x2), [0])), R2++;
    } else {
      for (var q2 = d2(M2, u2(N2, [R2])), J = 0; J < R2; J++) q2 = p2(q2, o2(F[J], d2(O2, u2(J, R2))));
      F[R2] = g2(m2(w2, o2(d2(O2, u2(R2, R2)), h2(x2))), q2);
    }
    return o2(E, o2(a2(i2(...F)), l2(j2)));
  }
}), name$70$2 = `schur`, dependencies$70$2 = [`typed`, `matrix`, `identity`, `multiply`, `qr`, `norm`, `subtract`], createSchur$2 = factory$2(name$70$2, dependencies$70$2, (t4) => {
  var { typed: n2, matrix: r2, identity: i2, multiply: a2, qr: o2, norm: s2, subtract: c2 } = t4;
  return n2(name$70$2, { Array: function(t5) {
    var n3 = l2(r2(t5));
    return { U: n3.U.valueOf(), T: n3.T.valueOf() };
  }, Matrix: function(t5) {
    return l2(t5);
  } });
  function l2(t5) {
    var n3 = t5.size()[0], r3 = t5, l3 = i2(n3), u2 = 0, d2;
    do {
      d2 = r3;
      var p2 = o2(r3), m2 = p2.Q, h2 = p2.R;
      if (r3 = a2(h2, m2), l3 = a2(l3, m2), u2++ > 100) break;
    } while (s2(c2(r3, d2)) > 1e-4);
    return { U: l3, T: r3 };
  }
}), name$69$2 = `lyap`, dependencies$69$2 = [`typed`, `matrix`, `sylvester`, `multiply`, `transpose`], createLyap$2 = factory$2(name$69$2, dependencies$69$2, (t4) => {
  var { typed: n2, matrix: r2, sylvester: i2, multiply: a2, transpose: o2 } = t4;
  return n2(name$69$2, { "Matrix, Matrix": function(t5, n3) {
    return i2(t5, o2(t5), a2(-1, n3));
  }, "Array, Matrix": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), a2(-1, n3));
  }, "Matrix, Array": function(t5, n3) {
    return i2(t5, o2(r2(t5)), r2(a2(-1, n3)));
  }, "Array, Array": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), r2(a2(-1, n3))).toArray();
  } });
}), name$68$2 = `divide`, dependencies$68$2 = [`typed`, `matrix`, `multiply`, `equalScalar`, `divideScalar`, `inv`], createDivide$2 = factory$2(name$68$2, dependencies$68$2, (t4) => {
  var { typed: n2, matrix: r2, multiply: i2, equalScalar: a2, divideScalar: o2, inv: s2 } = t4, c2 = createMatAlgo11xS0s$2({ typed: n2, equalScalar: a2 }), l2 = createMatAlgo14xDs$2({ typed: n2 });
  return n2(`divide`, extend$1$4({ "Array | Matrix, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, o2, false);
  }, "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, o2, false);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, o2, false).valueOf();
  }, "any, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  } }, o2.signatures));
}), name$67$2 = `distance`, dependencies$67$2 = [`typed`, `addScalar`, `subtractScalar`, `divideScalar`, `multiplyScalar`, `deepEqual`, `sqrt`, `abs`], createDistance$2 = factory$2(name$67$2, dependencies$67$2, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, deepEqual: s2, sqrt: c2, abs: l2 } = t4;
  return n2(name$67$2, { "Array, Array, Array": function(t5, n3, r3) {
    if (t5.length === 2 && n3.length === 2 && r3.length === 2) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!d2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!d2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (s2(n3, r3)) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      var o3 = i2(r3[1], n3[1]), c3 = i2(n3[0], r3[0]), l3 = i2(a2(r3[0], n3[1]), a2(n3[0], r3[1]));
      return y2(t5[0], t5[1], o3, c3, l3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object, Object": function(t5, n3, r3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2 && Object.keys(r3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers`);
      if (!d2(r3)) throw TypeError(`Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers`);
      if (s2(g2(n3), g2(r3))) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      if (`pointX` in t5 && `pointY` in t5 && `lineOnePtX` in n3 && `lineOnePtY` in n3 && `lineTwoPtX` in r3 && `lineTwoPtY` in r3) {
        var o3 = i2(r3.lineTwoPtY, n3.lineOnePtY), c3 = i2(n3.lineOnePtX, r3.lineTwoPtX), l3 = i2(a2(r3.lineTwoPtX, n3.lineOnePtY), a2(n3.lineOnePtX, r3.lineTwoPtY));
        return y2(t5.pointX, t5.pointY, o3, c3, l3);
      } else throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Array, Array": function(t5, n3) {
    if (t5.length === 2 && n3.length === 3) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!p2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      return y2(t5[0], t5[1], n3[0], n3[1], n3[2]);
    } else if (t5.length === 3 && n3.length === 6) {
      if (!p2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!h2(n3)) throw TypeError(`Array with 6 numbers or BigNumbers expected for second argument`);
      return b2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], n3[3], n3[4], n3[5]);
    } else if (t5.length === n3.length && t5.length > 0) {
      if (!m2(t5) || !m2(n3)) throw TypeError(`All values of an array should be numbers or BigNumbers`);
      return x2(t5, n3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object": function(t5, n3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 3) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `xCoeffLine` in n3 && `yCoeffLine` in n3 && `constant` in n3) return y2(t5.pointX, t5.pointY, n3.xCoeffLine, n3.yCoeffLine, n3.constant);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 6) {
      if (!p2(t5)) throw TypeError(`Values of pointX, pointY and pointZ should be numbers or BigNumbers`);
      if (!h2(n3)) throw TypeError(`Values of x0, y0, z0, a, b and c should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `x0` in n3 && `y0` in n3 && `z0` in n3 && `a` in n3 && `b` in n3 && `c` in n3) return b2(t5.pointX, t5.pointY, t5.pointZ, n3.x0, n3.y0, n3.z0, n3.a, n3.b, n3.c);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointOneX and pointOneY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of pointTwoX and pointTwoY should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3) return x2([t5.pointOneX, t5.pointOneY], [n3.pointTwoX, n3.pointTwoY]);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 3) {
      if (!p2(t5)) throw TypeError(`Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointOneZ` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3 && `pointTwoZ` in n3) return x2([t5.pointOneX, t5.pointOneY, t5.pointOneZ], [n3.pointTwoX, n3.pointTwoY, n3.pointTwoZ]);
      throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, Array: function(t5) {
    if (!v2(t5)) throw TypeError(`Incorrect array format entered for pairwise distance calculation`);
    return S2(t5);
  } });
  function u2(t5) {
    return typeof t5 == `number` || isBigNumber$2(t5);
  }
  function d2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]);
  }
  function p2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]);
  }
  function m2(t5) {
    return Array.isArray(t5) || (t5 = g2(t5)), t5.every(u2);
  }
  function h2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]) && u2(t5[3]) && u2(t5[4]) && u2(t5[5]);
  }
  function g2(t5) {
    for (var n3 = Object.keys(t5), r3 = [], i3 = 0; i3 < n3.length; i3++) r3.push(t5[n3[i3]]);
    return r3;
  }
  function v2(t5) {
    if (t5[0].length === 2 && u2(t5[0][0]) && u2(t5[0][1])) {
      if (t5.some((t6) => t6.length !== 2 || !u2(t6[0]) || !u2(t6[1]))) return false;
    } else if (t5[0].length === 3 && u2(t5[0][0]) && u2(t5[0][1]) && u2(t5[0][2])) {
      if (t5.some((t6) => t6.length !== 3 || !u2(t6[0]) || !u2(t6[1]) || !u2(t6[2]))) return false;
    } else return false;
    return true;
  }
  function y2(t5, n3, i3, s3, u3) {
    return o2(l2(r2(r2(a2(i3, t5), a2(s3, n3)), u3)), c2(r2(a2(i3, i3), a2(s3, s3))));
  }
  function b2(t5, n3, s3, l3, u3, d3, p3, m3, h3) {
    var g3 = [i2(a2(i2(u3, n3), h3), a2(i2(d3, s3), m3)), i2(a2(i2(d3, s3), p3), a2(i2(l3, t5), h3)), i2(a2(i2(l3, t5), m3), a2(i2(u3, n3), p3))];
    g3 = c2(r2(r2(a2(g3[0], g3[0]), a2(g3[1], g3[1])), a2(g3[2], g3[2])));
    var v3 = c2(r2(r2(a2(p3, p3), a2(m3, m3)), a2(h3, h3)));
    return o2(g3, v3);
  }
  function x2(t5, n3) {
    for (var o3 = t5.length, s3 = 0, l3 = 0, u3 = 0; u3 < o3; u3++) l3 = i2(t5[u3], n3[u3]), s3 = r2(a2(l3, l3), s3);
    return c2(s3);
  }
  function S2(t5) {
    for (var n3 = [], r3 = [], i3 = [], a3 = 0; a3 < t5.length - 1; a3++) for (var o3 = a3 + 1; o3 < t5.length; o3++) t5[0].length === 2 ? (r3 = [t5[a3][0], t5[a3][1]], i3 = [t5[o3][0], t5[o3][1]]) : t5[0].length === 3 && (r3 = [t5[a3][0], t5[a3][1], t5[a3][2]], i3 = [t5[o3][0], t5[o3][1], t5[o3][2]]), n3.push(x2(r3, i3));
    return n3;
  }
}), name$66$2 = `intersect`, dependencies$66$2 = [`typed`, `config`, `abs`, `add`, `addScalar`, `matrix`, `multiply`, `multiplyScalar`, `divideScalar`, `subtract`, `smaller`, `equalScalar`, `flatten`, `isZero`, `isNumeric`], createIntersect$2 = factory$2(name$66$2, dependencies$66$2, (t4) => {
  var { typed: n2, config: r2, abs: i2, add: a2, addScalar: o2, matrix: s2, multiply: c2, multiplyScalar: l2, divideScalar: u2, subtract: d2, smaller: p2, equalScalar: m2, flatten: h2, isZero: g2, isNumeric: v2 } = t4;
  return n2(`intersect`, { "Array, Array, Array": y2, "Array, Array, Array, Array": b2, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var i3 = y2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return i3 === null ? null : s2(i3);
  }, "Matrix, Matrix, Matrix, Matrix": function(t5, n3, r3, i3) {
    var a3 = b2(t5.valueOf(), n3.valueOf(), r3.valueOf(), i3.valueOf());
    return a3 === null ? null : s2(a3);
  } });
  function y2(t5, n3, r3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), !w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
    if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
    if (!E(r3)) throw TypeError(`Array with 4 numbers expected as third argument`);
    return M2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], r3[3]);
  }
  function b2(t5, n3, r3, i3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), i3 = x2(i3), t5.length === 2) {
      if (!S2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!S2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!S2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (!S2(i3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for fourth argument`);
      return D(t5, n3, r3, i3);
    } else if (t5.length === 3) {
      if (!w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      if (!w2(r3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for third argument`);
      if (!w2(i3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for fourth argument`);
      return j2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], i3[0], i3[1], i3[2]);
    } else throw TypeError(`Arrays with two or thee dimensional points expected`);
  }
  function x2(t5) {
    return t5.length === 1 ? t5[0] : t5.length > 1 && Array.isArray(t5[0]) && t5.every((t6) => Array.isArray(t6) && t6.length === 1) ? h2(t5) : t5;
  }
  function S2(t5) {
    return t5.length === 2 && v2(t5[0]) && v2(t5[1]);
  }
  function w2(t5) {
    return t5.length === 3 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]);
  }
  function E(t5) {
    return t5.length === 4 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]) && v2(t5[3]);
  }
  function D(t5, n3, s3, m3) {
    var h3 = t5, v3 = s3, y3 = d2(h3, n3), b3 = d2(v3, m3), x3 = d2(l2(y3[0], b3[1]), l2(b3[0], y3[1]));
    if (g2(x3) || p2(i2(x3), r2.relTol)) return null;
    var S3 = l2(b3[0], h3[1]), w3 = l2(b3[1], h3[0]), E2 = l2(b3[0], v3[1]), D2 = l2(b3[1], v3[0]);
    return a2(c2(y3, u2(o2(d2(d2(S3, w3), E2), D2), x3)), h3);
  }
  function O2(t5, n3, r3, i3, a3, s3, c3, u3, p3, m3, h3, g3) {
    var v3 = l2(d2(t5, n3), d2(r3, i3)), y3 = l2(d2(a3, s3), d2(c3, u3)), b3 = l2(d2(p3, m3), d2(h3, g3));
    return o2(o2(v3, y3), b3);
  }
  function j2(t5, n3, r3, i3, a3, s3, c3, p3, h3, v3, y3, b3) {
    var x3 = O2(t5, c3, v3, c3, n3, p3, y3, p3, r3, h3, b3, h3), S3 = O2(v3, c3, i3, t5, y3, p3, a3, n3, b3, h3, s3, r3), w3 = O2(t5, c3, i3, t5, n3, p3, a3, n3, r3, h3, s3, r3), E2 = O2(v3, c3, v3, c3, y3, p3, y3, p3, b3, h3, b3, h3), D2 = O2(i3, t5, i3, t5, a3, n3, a3, n3, s3, r3, s3, r3), j3 = d2(l2(x3, S3), l2(w3, E2)), M3 = d2(l2(D2, E2), l2(S3, S3));
    if (g2(M3)) return null;
    var N2 = u2(j3, M3), F = u2(o2(x3, l2(N2, S3)), E2), I2 = o2(t5, l2(N2, d2(i3, t5))), L2 = o2(n3, l2(N2, d2(a3, n3))), R2 = o2(r3, l2(N2, d2(s3, r3))), z2 = o2(c3, l2(F, d2(v3, c3))), V2 = o2(p3, l2(F, d2(y3, p3))), H2 = o2(h3, l2(F, d2(b3, h3)));
    return m2(I2, z2) && m2(L2, V2) && m2(R2, H2) ? [I2, L2, R2] : null;
  }
  function M2(t5, n3, r3, i3, a3, s3, c3, p3, m3, h3) {
    var g3 = l2(t5, c3), v3 = l2(i3, c3), y3 = l2(n3, p3), b3 = l2(a3, p3), x3 = l2(r3, m3), S3 = l2(s3, m3), w3 = u2(d2(d2(d2(h3, g3), y3), x3), d2(d2(d2(o2(o2(v3, b3), S3), g3), y3), x3));
    return [o2(t5, l2(w3, d2(i3, t5))), o2(n3, l2(w3, d2(a3, n3))), o2(r3, l2(w3, d2(s3, r3)))];
  }
}), name$65$2 = `sum`, dependencies$65$2 = [`typed`, `config`, `add`, `numeric`], createSum$2 = factory$2(name$65$2, dependencies$65$2, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4;
  return n2(name$65$2, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": s2, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`Scalar values expected in function sum`);
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    return deepForEach$3(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage$2(n4, `sum`, t6);
      }
    }), n3 === void 0 && (n3 = a2(0, r2.number)), typeof n3 == `string` && (n3 = a2(n3, safeNumberType$2(n3, r2))), n3;
  }
  function s2(t5, n3) {
    try {
      return reduce$1$2(t5, n3, i2);
    } catch (t6) {
      throw improveErrorMessage$2(t6, `sum`);
    }
  }
}), name$64$2 = `cumsum`, dependencies$64$2 = [`typed`, `add`, `unaryPlus`], createCumSum$2 = factory$2(name$64$2, dependencies$64$2, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4;
  return n2(name$64$2, { Array: a2, Matrix: function(t5) {
    return t5.create(a2(t5.valueOf(), t5.datatype()));
  }, "Array, number | BigNumber": s2, "Matrix, number | BigNumber": function(t5, n3) {
    return t5.create(s2(t5.valueOf(), n3), t5.datatype());
  }, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`All values expected to be scalar in function cumsum`);
    return a2(t5);
  } });
  function a2(t5) {
    try {
      return o2(t5);
    } catch (t6) {
      throw improveErrorMessage$2(t6, name$64$2);
    }
  }
  function o2(t5) {
    if (t5.length === 0) return [];
    for (var n3 = [i2(t5[0])], a3 = 1; a3 < t5.length; ++a3) n3.push(r2(n3[a3 - 1], t5[a3]));
    return n3;
  }
  function s2(t5, n3) {
    var r3 = arraySize$2(t5);
    if (n3 < 0 || n3 >= r3.length) throw new IndexError$2(n3, r3.length);
    try {
      return c2(t5, n3);
    } catch (t6) {
      throw improveErrorMessage$2(t6, name$64$2);
    }
  }
  function c2(t5, n3) {
    var r3, i3, a3;
    if (n3 <= 0) {
      var s3 = t5[0][0];
      if (Array.isArray(s3)) {
        for (a3 = _switch$1$2(t5), i3 = [], r3 = 0; r3 < a3.length; r3++) i3[r3] = c2(a3[r3], n3 - 1);
        return i3;
      } else return o2(t5);
    } else {
      for (i3 = [], r3 = 0; r3 < t5.length; r3++) i3[r3] = c2(t5[r3], n3 - 1);
      return i3;
    }
  }
}), name$63$2 = `mean`, dependencies$63$2 = [`typed`, `add`, `divide`], createMean$2 = factory$2(name$63$2, dependencies$63$2, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4;
  return n2(name$63$2, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": a2, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`Scalar values expected in function mean`);
    return o2(t5);
  } });
  function a2(t5, n3) {
    try {
      return i2(reduce$1$2(t5, n3, r2), (Array.isArray(t5) ? arraySize$2(t5) : t5.size())[n3]);
    } catch (t6) {
      throw improveErrorMessage$2(t6, `mean`);
    }
  }
  function o2(t5) {
    var n3, a3 = 0;
    if (deepForEach$3(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : r2(n3, t6), a3++;
      } catch (n4) {
        throw improveErrorMessage$2(n4, `mean`, t6);
      }
    }), a3 === 0) throw Error(`Cannot calculate the mean of an empty array`);
    return i2(n3, a3);
  }
}), name$62$2 = `median`, dependencies$62$2 = [`typed`, `add`, `divide`, `compare`, `partitionSelect`], createMedian$2 = factory$2(name$62$2, dependencies$62$2, (t4) => {
  var { typed: n2, add: r2, divide: i2, compare: a2, partitionSelect: o2 } = t4;
  function s2(t5) {
    try {
      t5 = flatten$4$2(t5.valueOf());
      var n3 = t5.length;
      if (n3 === 0) throw Error(`Cannot calculate median of an empty array`);
      if (n3 % 2 == 0) {
        for (var r3 = n3 / 2 - 1, i3 = o2(t5, r3 + 1), s3 = t5[r3], u2 = 0; u2 < r3; ++u2) a2(t5[u2], s3) > 0 && (s3 = t5[u2]);
        return l2(s3, i3);
      } else return c2(o2(t5, (n3 - 1) / 2));
    } catch (t6) {
      throw improveErrorMessage$2(t6, `median`);
    }
  }
  var c2 = n2({ "number | BigNumber | Complex | Unit": function(t5) {
    return t5;
  } }), l2 = n2({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(t5, n3) {
    return i2(r2(t5, n3), 2);
  } });
  return n2(name$62$2, { "Array | Matrix": s2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`median(A, dim) is not yet supported`);
  }, "...": function(t5) {
    if (containsCollections$2(t5)) throw TypeError(`Scalar values expected in function median`);
    return s2(t5);
  } });
}), name$61$2 = `mad`, dependencies$61$2 = [`typed`, `abs`, `map`, `median`, `subtract`], createMad$2 = factory$2(name$61$2, dependencies$61$2, (t4) => {
  var { typed: n2, abs: r2, map: i2, median: a2, subtract: o2 } = t4;
  return n2(name$61$2, { "Array | Matrix": s2, "...": function(t5) {
    return s2(t5);
  } });
  function s2(t5) {
    if (t5 = flatten$4$2(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate median absolute deviation (mad) of an empty array`);
    try {
      var n3 = a2(t5);
      return a2(i2(t5, function(t6) {
        return r2(o2(t6, n3));
      }));
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(`median`) ? TypeError(t6.message.replace(`median`, `mad`)) : improveErrorMessage$2(t6, `mad`);
    }
  }
}), DEFAULT_NORMALIZATION$2 = `unbiased`, name$60$2 = `variance`, dependencies$60$2 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVariance$2 = factory$2(name$60$2, dependencies$60$2, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4;
  return n2(name$60$2, { "Array | Matrix": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION$2);
  }, "Array | Matrix, string": l2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return u2(t5, n3, DEFAULT_NORMALIZATION$2);
  }, "Array | Matrix, number | BigNumber, string": u2, "...": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION$2);
  } });
  function l2(t5, n3) {
    var s3, l3 = 0;
    if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
    if (deepForEach$3(t5, function(t6) {
      try {
        s3 = s3 === void 0 ? t6 : r2(s3, t6), l3++;
      } catch (n4) {
        throw improveErrorMessage$2(n4, `variance`, t6);
      }
    }), l3 === 0) throw Error(`Cannot calculate variance of an empty array`);
    var u3 = o2(s3, l3);
    if (s3 = void 0, deepForEach$3(t5, function(t6) {
      var n4 = i2(t6, u3);
      s3 = s3 === void 0 ? a2(n4, n4) : r2(s3, a2(n4, n4));
    }), c2(s3)) return s3;
    switch (n3) {
      case `uncorrected`:
        return o2(s3, l3);
      case `biased`:
        return o2(s3, l3 + 1);
      case `unbiased`:
        var d2 = isBigNumber$2(s3) ? s3.mul(0) : 0;
        return l3 === 1 ? d2 : o2(s3, l3 - 1);
      default:
        throw Error(`Unknown normalization "` + n3 + `". Choose "unbiased" (default), "uncorrected", or "biased".`);
    }
  }
  function u2(t5, n3, r3) {
    try {
      if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
      return s2(t5, n3, (t6) => l2(t6, r3));
    } catch (t6) {
      throw improveErrorMessage$2(t6, `variance`);
    }
  }
}), name$59$2 = `quantileSeq`, dependencies$59$2 = [`typed`, `?bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeq$2 = factory$2(name$59$2, dependencies$59$2, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4;
  return n2(name$59$2, { "Array | Matrix, number | BigNumber": (t5, n3) => v2(t5, n3, false), "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, false, r3, v2), "Array | Matrix, number | BigNumber, boolean": v2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, v2), "Array | Matrix, Array | Matrix": (t5, n3) => y2(t5, n3, false), "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, false, r3, y2), "Array | Matrix, Array | Matrix, boolean": y2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, y2) });
  function g2(t5, n3, r3, i3, a3) {
    return h2(t5, i3, (t6) => a3(t6, n3, r3));
  }
  function v2(t5, n3, a3) {
    var s3, c3 = t5.valueOf();
    if (d2(n3, 0)) throw Error(`N/prob must be non-negative`);
    if (p2(n3, 1)) return isNumber$2(n3) ? b2(c3, n3, a3) : r2(b2(c3, n3, a3));
    if (m2(n3, 1)) {
      if (!u2(n3)) throw Error(`N must be a positive integer`);
      if (m2(n3, 4294967295)) throw Error(`N must be less than or equal to 2^32-1, as that is the maximum length of an Array`);
      var l3 = i2(n3, 1);
      s3 = [];
      for (var h3 = 0; d2(h3, n3); h3++) {
        var g3 = o2(h3 + 1, l3);
        s3.push(b2(c3, g3, a3));
      }
      return isNumber$2(n3) ? s3 : r2(s3);
    }
  }
  function y2(t5, n3, r3) {
    for (var i3 = t5.valueOf(), a3 = n3.valueOf(), o3 = [], s3 = 0; s3 < a3.length; ++s3) o3.push(b2(i3, a3[s3], r3));
    return o3;
  }
  function b2(t5, n3, r3) {
    var o3 = flatten$4$2(t5), d3 = o3.length;
    if (d3 === 0) throw Error(`Cannot calculate quantile of an empty sequence`);
    var p3 = isNumber$2(n3) ? n3 * (d3 - 1) : n3.times(d3 - 1), m3 = isNumber$2(n3) ? Math.floor(p3) : p3.floor().toNumber(), h3 = isNumber$2(n3) ? p3 % 1 : p3.minus(m3);
    if (u2(p3)) return r3 ? o3[p3] : c2(o3, isNumber$2(n3) ? p3 : p3.valueOf());
    var g3, v3;
    if (r3) g3 = o3[m3], v3 = o3[m3 + 1];
    else {
      v3 = c2(o3, m3 + 1), g3 = o3[m3];
      for (var y3 = 0; y3 < m3; ++y3) l2(o3[y3], g3) > 0 && (g3 = o3[y3]);
    }
    return i2(s2(g3, a2(1, h3)), s2(v3, h3));
  }
}), name$58$2 = `std`, dependencies$58$2 = [`typed`, `map`, `sqrt`, `variance`], createStd$2 = factory$2(name$58$2, dependencies$58$2, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4;
  return n2(name$58$2, { "Array | Matrix": o2, "Array | Matrix, string": o2, "Array | Matrix, number | BigNumber": o2, "Array | Matrix, number | BigNumber, string": o2, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5, n3) {
    if (t5.length === 0) throw SyntaxError(`Function std requires one or more parameters (0 provided)`);
    try {
      var o3 = a2.apply(null, arguments);
      return isCollection$2(o3) ? r2(o3, i2) : i2(o3);
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(` variance`) ? TypeError(t6.message.replace(` variance`, ` std`)) : t6;
    }
  }
}), name$57$2 = `corr`, dependencies$57$2 = [`typed`, `matrix`, `mean`, `sqrt`, `sum`, `add`, `subtract`, `multiply`, `pow`, `divide`], createCorr$2 = factory$2(name$57$2, dependencies$57$2, (t4) => {
  var { typed: n2, matrix: r2, sqrt: i2, sum: a2, add: o2, subtract: s2, multiply: c2, pow: l2, divide: u2 } = t4;
  return n2(name$57$2, { "Array, Array": function(t5, n3) {
    return d2(t5, n3);
  }, "Matrix, Matrix": function(t5, n3) {
    var i3 = d2(t5.toArray(), n3.toArray());
    return Array.isArray(i3) ? r2(i3) : i3;
  } });
  function d2(t5, n3) {
    var r3 = [];
    if (Array.isArray(t5[0]) && Array.isArray(n3[0])) {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same length.`);
      for (var i3 = 0; i3 < t5.length; i3++) {
        if (t5[i3].length !== n3[i3].length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
        r3.push(p2(t5[i3], n3[i3]));
      }
      return r3;
    } else {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
      return p2(t5, n3);
    }
  }
  function p2(t5, n3) {
    var r3 = t5.length, d3 = a2(t5), p3 = a2(n3), m2 = t5.reduce((t6, r4, i3) => o2(t6, c2(r4, n3[i3])), 0), h2 = a2(t5.map((t6) => l2(t6, 2))), g2 = a2(n3.map((t6) => l2(t6, 2)));
    return u2(s2(c2(r3, m2), c2(d3, p3)), i2(c2(s2(c2(r3, h2), l2(d3, 2)), s2(c2(r3, g2), l2(p3, 2)))));
  }
}), name$56$2 = `bernoulli`, dependencies$56$2 = [`typed`, `config`, `isInteger`, `number`, `?BigNumber`, `?Fraction`], createBernoulli$2 = factory$2(name$56$2, dependencies$56$2, (t4) => {
  var { typed: n2, config: r2, number: i2, BigNumber: a2, Fraction: o2 } = t4, s2 = [void 0], c2 = [void 0], l2 = [void 0], u2 = 50;
  return n2(name$56$2, { number: (t5) => _bernoulli$2(t5, (t6) => t6, s2, (t6, n3) => t6 + n3, (t6, n3) => t6 * n3, (t6, n3) => t6 / n3), "bigint | Fraction": (t5) => _bernoulli$2(i2(t5), (t6) => new o2(t6), c2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3)), BigNumber: (t5) => (r2.precision !== u2 && (l2 = [void 0], u2 = r2.precision), _bernoulli$2(i2(t5), (t6) => new a2(t6), l2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3))) });
});
function _bernoulli$2(t4, n2, r2, i2, a2, o2) {
  if (t4 < 0 || !isInteger$3(t4)) throw RangeError(`Bernoulli index must be nonnegative integer`);
  if (t4 === 0) return n2(1);
  if (t4 === 1) return o2(n2(-1), n2(2));
  if (t4 % 2 == 1) return n2(0);
  var s2 = n2(1);
  r2.length === 1 && r2.push([o2(s2, n2(-3)), o2(s2, n2(-2)), o2(s2, n2(6))]);
  for (var c2 = t4 / 2, l2 = n2(0), u2 = n2(2); r2.length <= c2; ) {
    for (var d2 = r2.length, p2 = Math.floor((d2 + 1) / 2), m2 = l2, h2 = 1; h2 < p2; ++h2) m2 = i2(m2, a2(r2[h2][0], r2[d2 - h2][0]));
    m2 = a2(m2, u2), d2 % 2 == 0 && (m2 = i2(m2, a2(r2[p2][0], r2[p2][0]))), m2 = o2(m2, n2(-(2 * d2 + 1)));
    var g2 = o2(a2(r2[d2 - 1][1], n2(-d2 * (2 * d2 - 1))), u2);
    r2.push([m2, g2, a2(g2, m2)]);
  }
  return r2[c2][2];
}
var name$55$2 = `combinations`, dependencies$55$2 = [`typed`], createCombinations$2 = factory$2(name$55$2, dependencies$55$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$55$2, { "number, number": combinationsNumber$2, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = t5.minus(n3), s2 = new r2(1);
    if (!isPositiveInteger$2$2(t5) || !isPositiveInteger$2$2(n3)) throw TypeError(`Positive integer value expected in function combinations`);
    if (n3.gt(t5)) throw TypeError(`k must be less than n in function combinations`);
    if (i2 = s2, n3.lt(o2)) for (a2 = s2; a2.lte(o2); a2 = a2.plus(s2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = s2; a2.lte(n3); a2 = a2.plus(s2)) i2 = i2.times(o2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$2$2(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$54$2 = `combinationsWithRep`, dependencies$54$2 = [`typed`], createCombinationsWithRep$2 = factory$2(name$54$2, dependencies$54$2, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$54$2, { "number, number": function(t5, n3) {
    if (!isInteger$3(t5) || t5 < 0 || !isInteger$3(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5 < 1) throw TypeError(`k must be less than or equal to n + k - 1`);
    return n3 < t5 - 1 ? product$3(t5, t5 + n3 - 1) / product$3(1, n3) : product$3(n3 + 1, t5 + n3 - 1) / product$3(1, t5 - 1);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = new r2(1), s2 = t5.minus(o2);
    if (!isPositiveInteger$1$2(t5) || !isPositiveInteger$1$2(n3)) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5.lt(o2)) throw TypeError(`k must be less than or equal to n + k - 1 in function combinationsWithRep`);
    if (i2 = o2, n3.lt(s2)) for (a2 = o2; a2.lte(s2); a2 = a2.plus(o2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = o2; a2.lte(n3); a2 = a2.plus(o2)) i2 = i2.times(s2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$1$2(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$53$2 = `gamma`, dependencies$53$2 = [`typed`, `config`, `multiplyScalar`, `pow`, `BigNumber`, `Complex`], createGamma$2 = factory$2(name$53$2, dependencies$53$2, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, pow: a2, BigNumber: o2, Complex: s2 } = t4;
  function c2(t5) {
    if (t5.im === 0) return gammaNumber$2(t5.re);
    if (t5.re < 0.5) {
      var n3 = new s2(1 - t5.re, -t5.im), r3 = new s2(Math.PI * t5.re, Math.PI * t5.im);
      return new s2(Math.PI).div(r3.sin()).div(c2(n3));
    }
    t5 = new s2(t5.re - 1, t5.im);
    for (var i3 = new s2(gammaP$2[0], 0), a3 = 1; a3 < gammaP$2.length; ++a3) {
      var o3 = new s2(gammaP$2[a3], 0);
      i3 = i3.add(o3.div(t5.add(a3)));
    }
    var l3 = new s2(t5.re + gammaG$2 + 0.5, t5.im), u2 = Math.sqrt(2 * Math.PI), d2 = l3.pow(t5.add(0.5)), p2 = l3.neg().exp();
    return i3.mul(u2).mul(d2).mul(p2);
  }
  return n2(name$53$2, { number: gammaNumber$2, Complex: c2, BigNumber: function(t5) {
    if (t5.isInteger()) return t5.isNegative() || t5.isZero() ? new o2(1 / 0) : l2(t5.minus(1));
    if (!t5.isFinite()) return new o2(t5.isNegative() ? NaN : 1 / 0);
    throw Error(`Integer BigNumber expected`);
  } });
  function l2(t5) {
    if (t5 < 8) return new o2([1, 1, 2, 6, 24, 120, 720, 5040][t5]);
    var n3 = r2.precision + (Math.log(t5.toNumber()) | 0), i3 = o2.clone({ precision: n3 });
    if (t5 % 2 == 1) return t5.times(l2(new o2(t5 - 1)));
    for (var a3 = t5, s3 = new i3(t5), c3 = t5.toNumber(); a3 > 2; ) a3 -= 2, c3 += a3, s3 = s3.times(c3);
    return new o2(s3.toPrecision(o2.precision));
  }
}), name$52$2 = `lgamma`, dependencies$52$2 = [`Complex`, `typed`], createLgamma$2 = factory$2(name$52$2, dependencies$52$2, (t4) => {
  var { Complex: n2, typed: r2 } = t4, i2 = 7, a2 = 7, o2 = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return r2(name$52$2, { number: lgammaNumber$2, Complex: s2, BigNumber: function() {
    throw Error(`mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber`);
  } });
  function s2(t5) {
    var r3 = 6.283185307179586, o3 = 1.1447298858494002, u2 = 0.1;
    if (t5.isNaN()) return new n2(NaN, NaN);
    if (t5.im === 0) return new n2(lgammaNumber$2(t5.re), 0);
    if (t5.re >= i2 || Math.abs(t5.im) >= a2) return c2(t5);
    if (t5.re <= u2) {
      var d2 = copysign$2(r3, t5.im) * Math.floor(0.5 * t5.re + 0.25), p2 = t5.mul(Math.PI).sin().log(), m2 = s2(new n2(1 - t5.re, -t5.im));
      return new n2(o3, d2).sub(p2).sub(m2);
    } else if (t5.im >= 0) return l2(t5);
    else return l2(t5.conjugate()).conjugate();
  }
  function c2(t5) {
    for (var r3 = t5.sub(0.5).mul(t5.log()).sub(t5).add(lnSqrt2PI$2), i3 = new n2(1, 0).div(t5), a3 = i3.div(t5), s3 = o2[0], c3 = o2[1], l3 = 2 * a3.re, u2 = a3.re * a3.re + a3.im * a3.im, d2 = 2; d2 < 8; d2++) {
      var p2 = c3;
      c3 = -u2 * s3 + o2[d2], s3 = l3 * s3 + p2;
    }
    var m2 = i3.mul(a3.mul(s3).add(c3));
    return r3.add(m2);
  }
  function l2(t5) {
    var r3 = 0, a3 = 0, o3 = t5;
    for (t5 = t5.add(1); t5.re <= i2; ) {
      o3 = o3.mul(t5);
      var s3 = +(o3.im < 0);
      s3 !== 0 && a3 === 0 && r3++, a3 = s3, t5 = t5.add(1);
    }
    return c2(t5).sub(o3.log()).sub(new n2(0, r3 * 2 * Math.PI * 1));
  }
}), name$51$2 = `factorial`, dependencies$51$2 = [`typed`, `gamma`], createFactorial$2 = factory$2(name$51$2, dependencies$51$2, (t4) => {
  var { typed: n2, gamma: r2 } = t4;
  return n2(name$51$2, { number: function(t5) {
    if (t5 < 0) throw Error(`Value must be non-negative`);
    return r2(t5 + 1);
  }, BigNumber: function(t5) {
    if (t5.isNegative()) throw Error(`Value must be non-negative`);
    return r2(t5.plus(1));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$50$2 = `kldivergence`, dependencies$50$2 = [`typed`, `matrix`, `divide`, `sum`, `multiply`, `map`, `dotDivide`, `log`, `isNumeric`], createKldivergence$2 = factory$2(name$50$2, dependencies$50$2, (t4) => {
  var { typed: n2, matrix: r2, divide: i2, sum: a2, multiply: o2, map: s2, dotDivide: c2, log: l2, isNumeric: u2 } = t4;
  return n2(name$50$2, { "Array, Array": function(t5, n3) {
    return d2(r2(t5), r2(n3));
  }, "Matrix, Array": function(t5, n3) {
    return d2(t5, r2(n3));
  }, "Array, Matrix": function(t5, n3) {
    return d2(r2(t5), n3);
  }, "Matrix, Matrix": function(t5, n3) {
    return d2(t5, n3);
  } });
  function d2(t5, n3) {
    var r3 = n3.size().length, d3 = t5.size().length;
    if (r3 > 1) throw Error(`first object must be one dimensional`);
    if (d3 > 1) throw Error(`second object must be one dimensional`);
    if (r3 !== d3) throw Error(`Length of two vectors must be equal`);
    if (a2(t5) === 0) throw Error(`Sum of elements in first object must be non zero`);
    if (a2(n3) === 0) throw Error(`Sum of elements in second object must be non zero`);
    var p2 = i2(t5, a2(t5)), m2 = a2(o2(p2, s2(c2(p2, i2(n3, a2(n3))), (t6) => l2(t6))));
    return u2(m2) ? m2 : NaN;
  }
}), name$49$2 = `multinomial`, dependencies$49$2 = [`typed`, `add`, `divide`, `multiply`, `factorial`, `isInteger`, `isPositive`], createMultinomial$2 = factory$2(name$49$2, dependencies$49$2, (t4) => {
  var { typed: n2, add: r2, divide: i2, multiply: a2, factorial: o2, isInteger: s2, isPositive: c2 } = t4;
  return n2(name$49$2, { "Array | Matrix": function(t5) {
    var n3 = 0, l2 = 1;
    return deepForEach$3(t5, function(t6) {
      if (!s2(t6) || !c2(t6)) throw TypeError(`Positive integer value expected in function multinomial`);
      n3 = r2(n3, t6), l2 = a2(l2, o2(t6));
    }), i2(o2(n3), l2);
  } });
}), name$48$2 = `permutations`, dependencies$48$2 = [`typed`, `factorial`], createPermutations$2 = factory$2(name$48$2, dependencies$48$2, (t4) => {
  var { typed: n2, factorial: r2 } = t4;
  return n2(name$48$2, { "number | BigNumber": r2, "number, number": function(t5, n3) {
    if (!isInteger$3(t5) || t5 < 0 || !isInteger$3(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3 > t5) throw TypeError(`second argument k must be less than or equal to first argument n`);
    return product$3(t5 - n3 + 1, t5);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3, i2;
    if (!isPositiveInteger$4(t5) || !isPositiveInteger$4(n3)) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3.gt(t5)) throw TypeError(`second argument k must be less than or equal to first argument n`);
    for (r3 = t5.mul(0).add(1), i2 = t5.minus(n3).plus(1); i2.lte(t5); i2 = i2.plus(1)) r3 = r3.times(i2);
    return r3;
  } });
});
function isPositiveInteger$4(t4) {
  return t4.isInteger() && t4.gte(0);
}
var require_alea$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = s2();
      n4.next = function() {
        var t7 = 2091639 * n4.s0 + n4.c * 23283064365386963e-26;
        return n4.s0 = n4.s1, n4.s1 = n4.s2, n4.s2 = t7 - (n4.c = t7 | 0);
      }, n4.c = 1, n4.s0 = r3(` `), n4.s1 = r3(` `), n4.s2 = r3(` `), n4.s0 -= r3(t6), n4.s0 < 0 && (n4.s0 += 1), n4.s1 -= r3(t6), n4.s1 < 0 && (n4.s1 += 1), n4.s2 -= r3(t6), n4.s2 < 0 && (n4.s2 += 1), r3 = null;
    }
    function a2(t6, n4) {
      return n4.c = t6.c, n4.s0 = t6.s0, n4.s1 = t6.s1, n4.s2 = t6.s2, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s3 = r3.next;
      return s3.int32 = function() {
        return r3.next() * 4294967296 | 0;
      }, s3.double = function() {
        return s3() + (s3() * 2097152 | 0) * 11102230246251565e-32;
      }, s3.quick = s3, o3 && (typeof o3 == `object` && a2(o3, r3), s3.state = function() {
        return a2(r3, {});
      }), s3;
    }
    function s2() {
      var t6 = 4022871197;
      return function(n4) {
        n4 = String(n4);
        for (var r3 = 0; r3 < n4.length; r3++) {
          t6 += n4.charCodeAt(r3);
          var i3 = 0.02519603282416938 * t6;
          t6 = i3 >>> 0, i3 -= t6, i3 *= t6, t6 = i3 >>> 0, i3 -= t6, t6 += i3 * 4294967296;
        }
        return (t6 >>> 0) * 23283064365386963e-26;
      };
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.alea = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor128$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.next = function() {
        var t7 = n4.x ^ n4.x << 11;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w ^= n4.w >>> 19 ^ t7 ^ t7 >>> 8;
      }, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor128 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorwow$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.x ^ n4.x >>> 2;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w = n4.v, (n4.d = n4.d + 362437 | 0) + (n4.v = n4.v ^ n4.v << 4 ^ (t7 ^ t7 << 1)) | 0;
      }, n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.v = 0, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, i3 == r3.length && (n4.d = n4.x << 10 ^ n4.x >>> 4), n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4.v = t6.v, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorwow = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorshift7$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.x, r4 = n4.i, i3 = t7[r4], a3;
        return i3 ^= i3 >>> 7, a3 = i3 ^ i3 << 24, i3 = t7[r4 + 1 & 7], a3 ^= i3 ^ i3 >>> 10, i3 = t7[r4 + 3 & 7], a3 ^= i3 ^ i3 >>> 3, i3 = t7[r4 + 4 & 7], a3 ^= i3 ^ i3 << 7, i3 = t7[r4 + 7 & 7], i3 ^= i3 << 13, a3 ^= i3 ^ i3 << 9, t7[r4] = a3, n4.i = r4 + 1 & 7, a3;
      };
      function r3(t7, n5) {
        var r4, i3 = [];
        if (n5 === (n5 | 0)) i3[0] = n5;
        else for (n5 = `` + n5, r4 = 0; r4 < n5.length; ++r4) i3[r4 & 7] = i3[r4 & 7] << 15 ^ n5.charCodeAt(r4) + i3[r4 + 1 & 7] << 13;
        for (; i3.length < 8; ) i3.push(0);
        for (r4 = 0; r4 < 8 && i3[r4] === 0; ++r4) ;
        for (r4 == 8 ? i3[7] = -1 : i3[r4], t7.x = i3, t7.i = 0, r4 = 256; r4 > 0; --r4) t7.next();
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.x = t6.x.slice(), n4.i = t6.i, n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.x && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorshift7 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor4096$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.w, r4 = n4.X, i3 = n4.i, a3, o3;
        return n4.w = t7 = t7 + 1640531527 | 0, o3 = r4[i3 + 34 & 127], a3 = r4[i3 = i3 + 1 & 127], o3 ^= o3 << 13, a3 ^= a3 << 17, o3 ^= o3 >>> 15, a3 ^= a3 >>> 12, o3 = r4[i3] = o3 ^ a3, n4.i = i3, o3 + (t7 ^ t7 >>> 16) | 0;
      };
      function r3(t7, n5) {
        var r4, i3, a3, o3, s2, c2 = [], l2 = 128;
        for (n5 === (n5 | 0) ? (i3 = n5, n5 = null) : (n5 += `\0`, i3 = 0, l2 = Math.max(l2, n5.length)), a3 = 0, o3 = -32; o3 < l2; ++o3) n5 && (i3 ^= n5.charCodeAt((o3 + 32) % n5.length)), o3 === 0 && (s2 = i3), i3 ^= i3 << 10, i3 ^= i3 >>> 15, i3 ^= i3 << 4, i3 ^= i3 >>> 13, o3 >= 0 && (s2 = s2 + 1640531527 | 0, r4 = c2[o3 & 127] ^= i3 + s2, a3 = r4 == 0 ? a3 + 1 : 0);
        for (a3 >= 128 && (c2[(n5 && n5.length || 0) & 127] = -1), a3 = 127, o3 = 512; o3 > 0; --o3) i3 = c2[a3 + 34 & 127], r4 = c2[a3 = a3 + 1 & 127], i3 ^= i3 << 13, r4 ^= r4 << 17, i3 ^= i3 >>> 15, r4 ^= r4 >>> 12, c2[a3] = i3 ^ r4;
        t7.w = s2, t7.X = c2, t7.i = a3;
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.i = t6.i, n4.w = t6.w, n4.X = t6.X.slice(), n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.X && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor4096 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_tychei$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.b, r4 = n4.c, i4 = n4.d, a3 = n4.a;
        return t7 = t7 << 25 ^ t7 >>> 7 ^ r4, r4 = r4 - i4 | 0, i4 = i4 << 24 ^ i4 >>> 8 ^ a3, a3 = a3 - t7 | 0, n4.b = t7 = t7 << 20 ^ t7 >>> 12 ^ r4, n4.c = r4 = r4 - i4 | 0, n4.d = i4 << 16 ^ r4 >>> 16 ^ a3, n4.a = a3 - t7 | 0;
      }, n4.a = 0, n4.b = 0, n4.c = -1640531527, n4.d = 1367130551, t6 === Math.floor(t6) ? (n4.a = t6 / 4294967296 | 0, n4.b = t6 | 0) : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 20; i3++) n4.b ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.a = t6.a, n4.b = t6.b, n4.c = t6.c, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.tychei = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require___vite_browser_external$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = {};
})), require_seedrandom$1$2 = __commonJSMin$2(((t4, n2) => {
  (function(t5, r2, i2) {
    var a2 = 256, o2 = 6, s2 = 52, c2 = `random`, l2 = i2.pow(a2, o2), u2 = i2.pow(2, s2), d2 = u2 * 2, p2 = a2 - 1, m2;
    function h2(t6, n3, s3) {
      var p3 = [];
      n3 = n3 == 1 ? { entropy: true } : n3 || {};
      var m3 = b2(y2(n3.entropy ? [t6, S2(r2)] : t6 ?? x2(), 3), p3), h3 = new g2(p3), w2 = function() {
        for (var t7 = h3.g(o2), n4 = l2, r3 = 0; t7 < u2; ) t7 = (t7 + r3) * a2, n4 *= a2, r3 = h3.g(1);
        for (; t7 >= d2; ) t7 /= 2, n4 /= 2, r3 >>>= 1;
        return (t7 + r3) / n4;
      };
      return w2.int32 = function() {
        return h3.g(4) | 0;
      }, w2.quick = function() {
        return h3.g(4) / 4294967296;
      }, w2.double = w2, b2(S2(h3.S), r2), (n3.pass || s3 || function(t7, n4, r3, a3) {
        return a3 && (a3.S && v2(a3, h3), t7.state = function() {
          return v2(h3, {});
        }), r3 ? (i2[c2] = t7, n4) : t7;
      })(w2, m3, `global` in n3 ? n3.global : this == i2, n3.state);
    }
    function g2(t6) {
      var n3, r3 = t6.length, i3 = this, o3 = 0, s3 = i3.i = i3.j = 0, c3 = i3.S = [];
      for (r3 || (t6 = [r3++]); o3 < a2; ) c3[o3] = o3++;
      for (o3 = 0; o3 < a2; o3++) c3[o3] = c3[s3 = p2 & s3 + t6[o3 % r3] + (n3 = c3[o3])], c3[s3] = n3;
      (i3.g = function(t7) {
        for (var n4, r4 = 0, o4 = i3.i, s4 = i3.j, c4 = i3.S; t7--; ) n4 = c4[o4 = p2 & o4 + 1], r4 = r4 * a2 + c4[p2 & (c4[o4] = c4[s4 = p2 & s4 + n4]) + (c4[s4] = n4)];
        return i3.i = o4, i3.j = s4, r4;
      })(a2);
    }
    function v2(t6, n3) {
      return n3.i = t6.i, n3.j = t6.j, n3.S = t6.S.slice(), n3;
    }
    function y2(t6, n3) {
      var r3 = [], i3 = typeof t6, a3;
      if (n3 && i3 == `object`) for (a3 in t6) try {
        r3.push(y2(t6[a3], n3 - 1));
      } catch {
      }
      return r3.length ? r3 : i3 == `string` ? t6 : t6 + `\0`;
    }
    function b2(t6, n3) {
      for (var r3 = t6 + ``, i3, a3 = 0; a3 < r3.length; ) n3[p2 & a3] = p2 & (i3 ^= n3[p2 & a3] * 19) + r3.charCodeAt(a3++);
      return S2(n3);
    }
    function x2() {
      try {
        var n3;
        return m2 && (n3 = m2.randomBytes) ? n3 = n3(a2) : (n3 = new Uint8Array(a2), (t5.crypto || t5.msCrypto).getRandomValues(n3)), S2(n3);
      } catch {
        var i3 = t5.navigator, o3 = i3 && i3.plugins;
        return [+/* @__PURE__ */ new Date(), t5, o3, t5.screen, S2(r2)];
      }
    }
    function S2(t6) {
      return String.fromCharCode.apply(0, t6);
    }
    if (b2(i2.random(), r2), typeof n2 == `object` && n2.exports) {
      n2.exports = h2;
      try {
        m2 = require___vite_browser_external$2();
      } catch {
      }
    } else typeof define == `function` && define.amd ? define(function() {
      return h2;
    }) : i2[`seed` + c2] = h2;
  })(typeof self < `u` ? self : t4, [], Math);
})), require_seedrandom$3 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_alea$2(), i2 = require_xor128$2(), a2 = require_xorwow$2(), o2 = require_xorshift7$2(), s2 = require_xor4096$2(), c2 = require_tychei$2(), l2 = require_seedrandom$1$2();
  l2.alea = r2, l2.xor128 = i2, l2.xorwow = a2, l2.xorshift7 = o2, l2.xor4096 = s2, l2.tychei = c2, n2.exports = l2;
})), import_seedrandom$2 = __toESM$2(require_seedrandom$3()), singletonRandom$2 = (0, import_seedrandom$2.default)(Date.now());
function createRng$2(t4) {
  var n2;
  function r2(t5) {
    n2 = t5 === null ? singletonRandom$2 : (0, import_seedrandom$2.default)(String(t5));
  }
  r2(t4);
  function i2() {
    return n2();
  }
  return i2;
}
var name$47$2 = `pickRandom`, dependencies$47$2 = [`typed`, `config`, `?on`], createPickRandom$2 = factory$2(name$47$2, dependencies$47$2, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng$2(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng$2(t5.randomSeed));
  }), n2(name$47$2, { "Array | Matrix": function(t5) {
    return o2(t5, {});
  }, "Array | Matrix, Object": function(t5, n3) {
    return o2(t5, n3);
  }, "Array | Matrix, number": function(t5, n3) {
    return o2(t5, { number: n3 });
  }, "Array | Matrix, Array | Matrix": function(t5, n3) {
    return o2(t5, { weights: n3 });
  }, "Array | Matrix, Array | Matrix, number": function(t5, n3, r3) {
    return o2(t5, { number: r3, weights: n3 });
  }, "Array | Matrix, number, Array | Matrix": function(t5, n3, r3) {
    return o2(t5, { number: n3, weights: r3 });
  } });
  function o2(t5, n3) {
    var { number: r3, weights: i3, elementWise: o3 = true } = n3, s2 = r3 === void 0;
    s2 && (r3 = 1);
    var c2 = isMatrix$2(t5) ? t5.create : isMatrix$2(i3) ? i3.create : null;
    t5 = t5.valueOf(), i3 &&= i3.valueOf(), o3 === true && (t5 = flatten$4$2(t5), i3 = flatten$4$2(i3));
    var l2 = 0;
    if (i3 !== void 0) {
      if (i3.length !== t5.length) throw Error(`Weights must have the same length as possibles`);
      for (var u2 = 0, d2 = i3.length; u2 < d2; u2++) {
        if (!isNumber$2(i3[u2]) || i3[u2] < 0) throw Error(`Weights must be an array of positive numbers`);
        l2 += i3[u2];
      }
    }
    for (var p2 = t5.length, m2 = [], h2; m2.length < r3; ) {
      if (i3 === void 0) h2 = t5[Math.floor(a2() * p2)];
      else for (var g2 = a2() * l2, v2 = 0, y2 = t5.length; v2 < y2; v2++) if (g2 -= i3[v2], g2 < 0) {
        h2 = t5[v2];
        break;
      }
      m2.push(h2);
    }
    return s2 ? m2[0] : c2 ? c2(m2) : m2;
  }
});
function randomMatrix$2(t4, n2) {
  var r2 = [];
  if (t4 = t4.slice(0), t4.length > 1) for (var i2 = 0, a2 = t4.shift(); i2 < a2; i2++) r2.push(randomMatrix$2(t4, n2));
  else for (var o2 = 0, s2 = t4.shift(); o2 < s2; o2++) r2.push(n2());
  return r2;
}
var name$46$2 = `random`, dependencies$46$2 = [`typed`, `config`, `?on`], createRandom$2 = factory$2(name$46$2, dependencies$46$2, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng$2(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng$2(t5.randomSeed));
  }), n2(name$46$2, { "": () => s2(0, 1), number: (t5) => s2(0, t5), "number, number": (t5, n3) => s2(t5, n3), "Array | Matrix": (t5) => o2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => o2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => o2(t5, n3, r3) });
  function o2(t5, n3, r3) {
    var i3 = randomMatrix$2(t5.valueOf(), () => s2(n3, r3));
    return isMatrix$2(t5) ? t5.create(i3, `number`) : i3;
  }
  function s2(t5, n3) {
    return t5 + a2() * (n3 - t5);
  }
}), name$45$2 = `randomInt`, dependencies$45$2 = [`typed`, `config`, `log2`, `?on`], createRandomInt$2 = factory$2(name$45$2, dependencies$45$2, (t4) => {
  var { typed: n2, config: r2, log2: i2, on: a2 } = t4, o2 = createRng$2(r2.randomSeed);
  return a2 && a2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (o2 = createRng$2(t5.randomSeed));
  }), n2(name$45$2, { "": () => c2(0, 2), number: (t5) => c2(0, t5), "number, number": (t5, n3) => c2(t5, n3), bigint: (t5) => l2(0n, t5), "bigint, bigint": l2, "Array | Matrix": (t5) => s2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => s2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => s2(t5, n3, r3) });
  function s2(t5, n3, r3) {
    var i3 = randomMatrix$2(t5.valueOf(), () => c2(n3, r3));
    return isMatrix$2(t5) ? t5.create(i3, `number`) : i3;
  }
  function c2(t5, n3) {
    return Math.floor(t5 + o2() * (n3 - t5));
  }
  function l2(t5, n3) {
    var r3 = 2n ** 30n, a3 = n3 - t5;
    if (a3 <= r3) return t5 + BigInt(c2(0, Number(a3)));
    for (var s3 = i2(a3), l3 = a3; l3 >= a3; ) {
      l3 = 0n;
      for (var u2 = 0; u2 < s3; ++u2) l3 = 2n * l3 + (o2() < 0.5 ? 0n : 1n);
    }
    return t5 + l3;
  }
}), name$44$2 = `stirlingS2`, dependencies$44$2 = [`typed`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `factorial`, `combinations`, `isNegative`, `isInteger`, `number`, `?bignumber`, `larger`], createStirlingS2$2 = factory$2(name$44$2, dependencies$44$2, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, pow: s2, factorial: c2, combinations: l2, isNegative: u2, isInteger: d2, number: p2, bignumber: m2, larger: h2 } = t4, g2 = [], v2 = [];
  return n2(name$44$2, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!d2(t5) || u2(t5) || !d2(n3) || u2(n3)) throw TypeError(`Non-negative integer value expected in function stirlingS2`);
    if (h2(n3, t5)) throw TypeError(`k must be less than or equal to n in function stirlingS2`);
    var i3 = !(isNumber$2(t5) && isNumber$2(n3)), o3 = i3 ? v2 : g2, s3 = i3 ? m2 : p2, c3 = p2(t5), l3 = p2(n3);
    if (o3[c3] && o3[c3].length > l3) return o3[c3][l3];
    for (var y2 = 0; y2 <= c3; ++y2) if (o3[y2] || (o3[y2] = [s3(+(y2 === 0))]), y2 !== 0) for (var b2 = o3[y2], x2 = o3[y2 - 1], S2 = b2.length; S2 <= y2 && S2 <= l3; ++S2) S2 === y2 ? b2[S2] = 1 : b2[S2] = r2(a2(s3(S2), x2[S2]), x2[S2 - 1]);
    return o3[c3][l3];
  } });
}), name$43$2 = `bellNumbers`, dependencies$43$2 = [`typed`, `addScalar`, `isNegative`, `isInteger`, `stirlingS2`], createBellNumbers$2 = factory$2(name$43$2, dependencies$43$2, (t4) => {
  var { typed: n2, addScalar: r2, isNegative: i2, isInteger: a2, stirlingS2: o2 } = t4;
  return n2(name$43$2, { "number | BigNumber": function(t5) {
    if (!a2(t5) || i2(t5)) throw TypeError(`Non-negative integer value expected in function bellNumbers`);
    for (var n3 = 0, s2 = 0; s2 <= t5; s2++) n3 = r2(n3, o2(t5, s2));
    return n3;
  } });
}), name$42$2 = `catalan`, dependencies$42$2 = [`typed`, `addScalar`, `divideScalar`, `multiplyScalar`, `combinations`, `isNegative`, `isInteger`], createCatalan$2 = factory$2(name$42$2, dependencies$42$2, (t4) => {
  var { typed: n2, addScalar: r2, divideScalar: i2, multiplyScalar: a2, combinations: o2, isNegative: s2, isInteger: c2 } = t4;
  return n2(name$42$2, { "number | BigNumber": function(t5) {
    if (!c2(t5) || s2(t5)) throw TypeError(`Non-negative integer value expected in function catalan`);
    return i2(o2(a2(t5, 2), t5), r2(t5, 1));
  } });
}), name$41$2 = `composition`, dependencies$41$2 = [`typed`, `addScalar`, `combinations`, `isNegative`, `isPositive`, `isInteger`, `larger`], createComposition$2 = factory$2(name$41$2, dependencies$41$2, (t4) => {
  var { typed: n2, addScalar: r2, combinations: i2, isPositive: a2, isNegative: o2, isInteger: s2, larger: c2 } = t4;
  return n2(name$41$2, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!s2(t5) || !a2(t5) || !s2(n3) || !a2(n3)) throw TypeError(`Positive integer value expected in function composition`);
    if (c2(n3, t5)) throw TypeError(`k must be less than or equal to n in function composition`);
    return i2(r2(t5, -1), r2(n3, -1));
  } });
}), name$40$2 = `leafCount`, dependencies$40$2 = [`parse`, `typed`], createLeafCount$2 = factory$2(name$40$2, dependencies$40$2, (t4) => {
  var { parse: n2, typed: r2 } = t4;
  function i2(t5) {
    var n3 = 0;
    return t5.forEach((t6) => {
      n3 += i2(t6);
    }), n3 || 1;
  }
  return r2(name$40$2, { Node: function(t5) {
    return i2(t5);
  } });
});
function isNumericNode$2(t4) {
  return isConstantNode$2(t4) || isOperatorNode$2(t4) && t4.isUnary() && isConstantNode$2(t4.args[0]);
}
function isConstantExpression$2(t4) {
  return !!(isConstantNode$2(t4) || (isFunctionNode$2(t4) || isOperatorNode$2(t4)) && t4.args.every(isConstantExpression$2) || isParenthesisNode$2(t4) && isConstantExpression$2(t4.content));
}
function ownKeys$1$2(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$1$2(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$1$2(Object(r2), true).forEach(function(n3) {
      _defineProperty$4(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$1$2(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$39$2 = `simplifyUtil`, dependencies$39$2 = [`FunctionNode`, `OperatorNode`, `SymbolNode`], createUtil$2 = factory$2(name$39$2, dependencies$39$2, (t4) => {
  var { FunctionNode: n2, OperatorNode: r2, SymbolNode: i2 } = t4, a2 = true, o2 = false, s2 = `defaultF`, c2 = { add: { trivial: a2, total: a2, commutative: a2, associative: a2 }, unaryPlus: { trivial: a2, total: a2, commutative: a2, associative: a2 }, subtract: { trivial: o2, total: a2, commutative: o2, associative: o2 }, multiply: { trivial: a2, total: a2, commutative: a2, associative: a2 }, divide: { trivial: o2, total: a2, commutative: o2, associative: o2 }, paren: { trivial: a2, total: a2, commutative: a2, associative: o2 }, defaultF: { trivial: o2, total: a2, commutative: o2, associative: o2 } }, l2 = { divide: { total: o2 }, log: { total: o2 } }, u2 = { subtract: { total: o2 }, abs: { trivial: a2 }, log: { total: a2 } };
  function d2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : c2, i3 = s2;
    if (typeof t5 == `string` ? i3 = t5 : isOperatorNode$2(t5) ? i3 = t5.fn.toString() : isFunctionNode$2(t5) ? i3 = t5.name : isParenthesisNode$2(t5) && (i3 = `paren`), hasOwnProperty$1$4(r3, i3)) {
      var a3 = r3[i3];
      if (hasOwnProperty$1$4(a3, n3)) return a3[n3];
      if (hasOwnProperty$1$4(c2, i3)) return c2[i3][n3];
    }
    if (hasOwnProperty$1$4(r3, s2)) {
      var o3 = r3[s2];
      return hasOwnProperty$1$4(o3, n3) ? o3[n3] : c2[s2][n3];
    }
    if (hasOwnProperty$1$4(c2, i3)) {
      var l3 = c2[i3];
      if (hasOwnProperty$1$4(l3, n3)) return l3[n3];
    }
    return c2[s2][n3];
  }
  function p2(t5) {
    return d2(t5, `commutative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function m2(t5) {
    return d2(t5, `associative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function h2(t5, n3) {
    var r3 = _objectSpread$1$2({}, t5);
    for (var i3 in n3) hasOwnProperty$1$4(t5, i3) ? r3[i3] = _objectSpread$1$2(_objectSpread$1$2({}, n3[i3]), t5[i3]) : r3[i3] = n3[i3];
    return r3;
  }
  function g2(t5, n3) {
    if (!t5.args || t5.args.length === 0) return t5;
    t5.args = v2(t5, n3);
    for (var r3 = 0; r3 < t5.args.length; r3++) g2(t5.args[r3], n3);
  }
  function v2(t5, n3) {
    var r3, i3 = [], a3 = function(t6) {
      for (var n4 = 0; n4 < t6.args.length; n4++) {
        var o3 = t6.args[n4];
        isOperatorNode$2(o3) && r3 === o3.op ? a3(o3) : i3.push(o3);
      }
    };
    return m2(t5, n3) ? (r3 = t5.op, a3(t5), i3) : t5.args;
  }
  function y2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) y2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.pop(); t5.args.length > 0; ) o3 = r3([t5.args.pop(), o3]);
        t5.args = o3.args;
      }
    }
  }
  function b2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) b2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.shift(); t5.args.length > 0; ) o3 = r3([o3, t5.args.shift()]);
        t5.args = o3.args;
      }
    }
  }
  function x2(t5) {
    return isOperatorNode$2(t5) ? function(n3) {
      try {
        return new r2(t5.op, t5.fn, n3, t5.implicit);
      } catch (t6) {
        return console.error(t6), [];
      }
    } : function(r3) {
      return new n2(new i2(t5.name), r3);
    };
  }
  return { createMakeNodeFunction: x2, hasProperty: d2, isCommutative: p2, isAssociative: m2, mergeContext: h2, flatten: g2, allChildren: v2, unflattenr: y2, unflattenl: b2, defaultContext: c2, realContext: l2, positiveContext: u2 };
}), name$38$2 = `simplify`, dependencies$38$2 = [`typed`, `parse`, `equal`, `resolve`, `simplifyConstant`, `simplifyCore`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`, `replacer`], createSimplify$2 = factory$2(name$38$2, dependencies$38$2, (t4) => {
  var { typed: n2, parse: r2, equal: i2, resolve: a2, simplifyConstant: o2, simplifyCore: s2, AccessorNode: c2, ArrayNode: l2, ConstantNode: u2, FunctionNode: d2, IndexNode: p2, ObjectNode: m2, OperatorNode: h2, ParenthesisNode: g2, SymbolNode: v2, replacer: y2 } = t4, { hasProperty: b2, isCommutative: x2, isAssociative: S2, mergeContext: w2, flatten: E, unflattenr: D, unflattenl: O2, createMakeNodeFunction: j2, defaultContext: M2, realContext: N2, positiveContext: F } = createUtil$2({ FunctionNode: d2, OperatorNode: h2, SymbolNode: v2 });
  n2.addConversion({ from: `Object`, to: `Map`, convert: createMap$1$2 });
  var I2 = n2(`simplify`, { Node: W2, "Node, Map": (t5, n3) => W2(t5, false, n3), "Node, Map, Object": (t5, n3, r3) => W2(t5, false, n3, r3), "Node, Array": W2, "Node, Array, Map": W2, "Node, Array, Map, Object": W2 });
  n2.removeConversion({ from: `Object`, to: `Map`, convert: createMap$1$2 }), I2.defaultContext = M2, I2.realContext = N2, I2.positiveContext = F;
  function L2(t5) {
    return t5.transform(function(t6) {
      return isParenthesisNode$2(t6) ? L2(t6.content) : t6;
    });
  }
  var R2 = { true: true, false: true, e: true, i: true, Infinity: true, LN2: true, LN10: true, LOG2E: true, LOG10E: true, NaN: true, phi: true, pi: true, SQRT1_2: true, SQRT2: true, tau: true };
  I2.rules = [s2, { l: `log(e)`, r: `1` }, { s: `n-n1 -> n+-n1`, assuming: { subtract: { total: true } } }, { s: `n-n -> 0`, assuming: { subtract: { total: false } } }, { s: `-(cl*v) -> v * (-cl)`, assuming: { multiply: { commutative: true }, subtract: { total: true } } }, { s: `-(cl*v) -> (-cl) * v`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { s: `-(v*cl) -> v * (-cl)`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { l: `-(n1/n2)`, r: `-n1/n2` }, { l: `-v`, r: `v * (-1)` }, { l: `(n1 + n2)*(-1)`, r: `n1*(-1) + n2*(-1)`, repeat: true }, { l: `n/n1^n2`, r: `n*n1^-n2` }, { l: `n/n1`, r: `n*n1^-1` }, { s: `(n1*n2)^n3 -> n1^n3 * n2^n3`, assuming: { multiply: { commutative: true } } }, { s: `(n1*n2)^(-1) -> n2^(-1) * n1^(-1)`, assuming: { multiply: { commutative: false } } }, { s: `(n ^ n1) ^ n2 -> n ^ (n1 * n2)`, assuming: { divide: { total: true } } }, { l: ` vd   * ( vd   * n1 + n2)`, r: `vd^2       * n1 +  vd   * n2` }, { s: ` vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { l: `n*n`, r: `n^2` }, { s: `n * n^n1 -> n^(n1+1)`, assuming: { divide: { total: true } } }, { s: `n^n1 * n^n2 -> n^(n1+n2)`, assuming: { divide: { total: true } } }, o2, { s: `n+n -> 2*n`, assuming: { add: { total: true } } }, { l: `n+-n`, r: `0` }, { l: `vd*n + vd`, r: `vd*(n+1)` }, { l: `n3*n1 + n3*n2`, r: `n3*(n1+n2)` }, { l: `n3^(-n4)*n1 +   n3  * n2`, r: `n3^(-n4)*(n1 + n3^(n4+1) *n2)` }, { l: `n3^(-n4)*n1 + n3^n5 * n2`, r: `n3^(-n4)*(n1 + n3^(n4+n5)*n2)` }, { s: `n*vd + vd -> (n+1)*vd`, assuming: { multiply: { commutative: false } } }, { s: `vd + n*vd -> (1+n)*vd`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3 + n2*n3 -> (n1+n2)*n3`, assuming: { multiply: { commutative: false } } }, { s: `n^n1 * n -> n^(n1+1)`, assuming: { divide: { total: true }, multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { l: `n*cd + cd`, r: `(n+1)*cd` }, { s: `cd*n + cd -> cd*(n+1)`, assuming: { multiply: { commutative: false } } }, { s: `cd + cd*n -> cd*(1+n)`, assuming: { multiply: { commutative: false } } }, o2, { s: `(-n)*n1 -> -(n*n1)`, assuming: { subtract: { total: true } } }, { s: `n1*(-n) -> -(n1*n)`, assuming: { subtract: { total: true }, multiply: { commutative: false } } }, { s: `ce+ve -> ve+ce`, assuming: { add: { commutative: true } }, imposeContext: { add: { commutative: false } } }, { s: `vd*cd -> cd*vd`, assuming: { multiply: { commutative: true } }, imposeContext: { multiply: { commutative: false } } }, { l: `n+-n1`, r: `n-n1` }, { l: `n+-(n1)`, r: `n-(n1)` }, { s: `n*(n1^-1) -> n/n1`, assuming: { multiply: { commutative: true } } }, { s: `n*n1^-n2 -> n/n1^n2`, assuming: { multiply: { commutative: true } } }, { s: `n^-1 -> 1/n`, assuming: { multiply: { commutative: true } } }, { l: `n^1`, r: `n` }, { s: `n*(n1/n2) -> (n*n1)/n2`, assuming: { multiply: { associative: true } } }, { s: `n-(n1+n2) -> n-n1-n2`, assuming: { addition: { associative: true, commutative: true } } }, { l: `1*n`, r: `n`, imposeContext: { multiply: { commutative: true } } }, { s: `n1/(n2/n3) -> (n1*n3)/n2`, assuming: { multiply: { associative: true } } }, { l: `n1/(-n2)`, r: `-n1/n2` }];
  function z2(t5, n3) {
    var i3 = {};
    if (t5.s) {
      var a3 = t5.s.split(`->`);
      if (a3.length === 2) i3.l = a3[0], i3.r = a3[1];
      else throw SyntaxError(`Could not parse rule: ` + t5.s);
    } else i3.l = t5.l, i3.r = t5.r;
    i3.l = L2(r2(i3.l)), i3.r = L2(r2(i3.r));
    for (var o3 of [`imposeContext`, `repeat`, `assuming`]) o3 in t5 && (i3[o3] = t5[o3]);
    if (t5.evaluate && (i3.evaluate = r2(t5.evaluate)), S2(i3.l, n3)) {
      var s3 = !x2(i3.l, n3), c3;
      s3 && (c3 = U2());
      var l3 = j2(i3.l), u3 = U2();
      i3.expanded = {}, i3.expanded.l = l3([i3.l, u3]), E(i3.expanded.l, n3), D(i3.expanded.l, n3), i3.expanded.r = l3([i3.r, u3]), s3 && (i3.expandedNC1 = {}, i3.expandedNC1.l = l3([c3, i3.l]), i3.expandedNC1.r = l3([c3, i3.r]), i3.expandedNC2 = {}, i3.expandedNC2.l = l3([c3, i3.expanded.l]), i3.expandedNC2.r = l3([c3, i3.expanded.r]));
    }
    return i3;
  }
  function V2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < t5.length; i3++) {
      var a3 = t5[i3], o3 = void 0, s3 = typeof a3;
      switch (s3) {
        case `string`:
          a3 = { s: a3 };
        case `object`:
          o3 = z2(a3, n3);
          break;
        case `function`:
          o3 = a3;
          break;
        default:
          throw TypeError(`Unsupported type of rule: ` + s3);
      }
      r3.push(o3);
    }
    return r3;
  }
  var H2 = 0;
  function U2() {
    return new v2(`_p` + H2++);
  }
  function W2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : createEmptyMap$2(), i3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o3 = i3.consoleDebug;
    n3 = V2(n3 || I2.rules, i3.context);
    var s3 = a2(t5, r3);
    s3 = L2(s3);
    for (var c3 = {}, l3 = s3.toString({ parenthesis: `all` }); !c3[l3]; ) {
      c3[l3] = true, H2 = 0;
      var u3 = l3;
      o3 && console.log(`Working on: `, l3);
      for (var d3 = 0; d3 < n3.length; d3++) {
        var p3 = ``;
        if (typeof n3[d3] == `function` ? (s3 = n3[d3](s3, i3), o3 && (p3 = n3[d3].name)) : (E(s3, i3.context), s3 = K2(s3, n3[d3], i3.context), o3 && (p3 = `${n3[d3].l.toString()} -> ${n3[d3].r.toString()}`)), o3) {
          var m3 = s3.toString({ parenthesis: `all` });
          m3 !== u3 && (console.log(`Applying`, p3, `produced`, m3), u3 = m3);
        }
        O2(s3, i3.context);
      }
      l3 = s3.toString({ parenthesis: `all` });
    }
    return s3;
  }
  function G2(t5, n3, r3) {
    var i3 = t5;
    if (t5) for (var a3 = 0; a3 < t5.length; ++a3) {
      var o3 = K2(t5[a3], n3, r3);
      o3 !== t5[a3] && (i3 === t5 && (i3 = t5.slice()), i3[a3] = o3);
    }
    return i3;
  }
  function K2(t5, n3, r3) {
    if (n3.assuming) {
      for (var i3 in n3.assuming) for (var a3 in n3.assuming[i3]) if (b2(i3, a3, r3) !== n3.assuming[i3][a3]) return t5;
    }
    var o3 = w2(n3.imposeContext, r3), s3 = t5;
    if (s3 instanceof h2 || s3 instanceof d2) {
      var u3 = G2(s3.args, n3, r3);
      u3 !== s3.args && (s3 = s3.clone(), s3.args = u3);
    } else if (s3 instanceof g2) {
      if (s3.content) {
        var v3 = K2(s3.content, n3, r3);
        v3 !== s3.content && (s3 = new g2(v3));
      }
    } else if (s3 instanceof l2) {
      var y3 = G2(s3.items, n3, r3);
      y3 !== s3.items && (s3 = new l2(y3));
    } else if (s3 instanceof c2) {
      var x3 = s3.object;
      s3.object && (x3 = K2(s3.object, n3, r3));
      var S3 = s3.index;
      s3.index && (S3 = K2(s3.index, n3, r3)), (x3 !== s3.object || S3 !== s3.index) && (s3 = new c2(x3, S3));
    } else if (s3 instanceof p2) {
      var E2 = G2(s3.dimensions, n3, r3);
      E2 !== s3.dimensions && (s3 = new p2(E2));
    } else if (s3 instanceof m2) {
      var D2 = false, O3 = {};
      for (var j3 in s3.properties) O3[j3] = K2(s3.properties[j3], n3, r3), O3[j3] !== s3.properties[j3] && (D2 = true);
      D2 && (s3 = new m2(O3));
    }
    var M3 = n3.r, N3 = te2(n3.l, s3, o3)[0];
    if (!N3 && n3.expanded && (M3 = n3.expanded.r, N3 = te2(n3.expanded.l, s3, o3)[0]), !N3 && n3.expandedNC1 && (M3 = n3.expandedNC1.r, N3 = te2(n3.expandedNC1.l, s3, o3)[0], N3 ||= (M3 = n3.expandedNC2.r, te2(n3.expandedNC2.l, s3, o3)[0])), N3) {
      var F2 = s3.implicit;
      s3 = M3.clone(), F2 && `implicit` in M3 && (s3.implicit = true), s3 = s3.transform(function(t6) {
        return t6.isSymbolNode && hasOwnProperty$1$4(N3.placeholders, t6.name) ? N3.placeholders[t6.name].clone() : t6;
      });
    }
    return n3.repeat && s3 !== t5 && (s3 = K2(s3, n3, r3)), s3;
  }
  function q2(t5, n3) {
    var r3 = [], i3, a3, o3 = j2(t5);
    if (x2(t5, n3)) for (var s3 = 0; s3 < t5.args.length; s3++) a3 = t5.args.slice(0), a3.splice(s3, 1), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([t5.args[s3], i3]));
    else for (var c3 = 1; c3 < t5.args.length; c3++) {
      var l3 = t5.args[0];
      c3 > 1 && (l3 = o3(t5.args.slice(0, c3))), a3 = t5.args.slice(c3), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([l3, i3]));
    }
    return r3;
  }
  function J(t5, n3) {
    var r3 = { placeholders: {} };
    if (!t5.placeholders && !n3.placeholders) return r3;
    if (!t5.placeholders) return n3;
    if (!n3.placeholders) return t5;
    for (var i3 in t5.placeholders) if (hasOwnProperty$1$4(t5.placeholders, i3) && (r3.placeholders[i3] = t5.placeholders[i3], hasOwnProperty$1$4(n3.placeholders, i3) && !ne2(t5.placeholders[i3], n3.placeholders[i3]))) return null;
    for (var a3 in n3.placeholders) hasOwnProperty$1$4(n3.placeholders, a3) && (r3.placeholders[a3] = n3.placeholders[a3]);
    return r3;
  }
  function ee2(t5, n3) {
    var r3 = [];
    if (t5.length === 0 || n3.length === 0) return r3;
    for (var i3, a3 = 0; a3 < t5.length; a3++) for (var o3 = 0; o3 < n3.length; o3++) i3 = J(t5[a3], n3[o3]), i3 && r3.push(i3);
    return r3;
  }
  function Y2(t5) {
    if (t5.length === 0) return t5;
    for (var n3 = t5.reduce(ee2), r3 = [], i3 = {}, a3 = 0; a3 < n3.length; a3++) {
      var o3 = JSON.stringify(n3[a3], y2);
      i3[o3] || (i3[o3] = true, r3.push(n3[a3]));
    }
    return r3;
  }
  function te2(t5, n3, r3, a3) {
    var o3 = [{ placeholders: {} }];
    if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return [];
      } else if (t5 instanceof d2 && t5.name !== n3.name) return [];
      if (n3.args.length === 1 && t5.args.length === 1 || !S2(n3, r3) && n3.args.length === t5.args.length || a3) {
        for (var s3 = [], c3 = 0; c3 < t5.args.length; c3++) {
          var l3 = te2(t5.args[c3], n3.args[c3], r3);
          if (l3.length === 0) break;
          s3.push(l3);
        }
        if (s3.length !== t5.args.length) {
          if (!x2(n3, r3) || t5.args.length === 1) return [];
          if (t5.args.length > 2) throw Error(`permuting >2 commutative non-associative rule arguments not yet implemented`);
          var p3 = te2(t5.args[0], n3.args[1], r3);
          if (p3.length === 0) return [];
          var m3 = te2(t5.args[1], n3.args[0], r3);
          if (m3.length === 0) return [];
          s3 = [p3, m3];
        }
        o3 = Y2(s3);
      } else if (n3.args.length >= 2 && t5.args.length === 2) {
        for (var g3 = q2(n3, r3), y3 = [], b3 = 0; b3 < g3.length; b3++) {
          var w3 = te2(t5, g3[b3], r3, true);
          y3 = y3.concat(w3);
        }
        return y3;
      } else if (t5.args.length > 2) throw Error(`Unexpected non-binary associative function: ` + t5.toString());
      else return [];
    } else if (t5 instanceof v2) {
      if (t5.name.length === 0) throw Error(`Symbol in rule has 0 length...!?`);
      if (R2[t5.name]) {
        if (t5.name !== n3.name) return [];
      } else switch (t5.name[1] >= `a` && t5.name[1] <= `z` ? t5.name.substring(0, 2) : t5.name[0]) {
        case `n`:
        case `_p`:
          o3[0].placeholders[t5.name] = n3;
          break;
        case `c`:
        case `cl`:
          if (isConstantNode$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `v`:
          if (!isConstantNode$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vl`:
          if (isSymbolNode$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `cd`:
          if (isNumericNode$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vd`:
          if (!isNumericNode$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ce`:
          if (isConstantExpression$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ve`:
          if (!isConstantExpression$2(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        default:
          throw Error(`Invalid symbol in rule: ` + t5.name);
      }
    } else if (t5 instanceof u2) {
      if (!i2(t5.value, n3.value)) return [];
    } else return [];
    return o3;
  }
  function ne2(t5, n3) {
    if (t5 instanceof u2 && n3 instanceof u2) {
      if (!i2(t5.value, n3.value)) return false;
    } else if (t5 instanceof v2 && n3 instanceof v2) {
      if (t5.name !== n3.name) return false;
    } else if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return false;
      } else if (t5 instanceof d2 && t5.name !== n3.name) return false;
      if (t5.args.length !== n3.args.length) return false;
      for (var r3 = 0; r3 < t5.args.length; r3++) if (!ne2(t5.args[r3], n3.args[r3])) return false;
    } else return false;
    return true;
  }
  return I2;
}), name$37$2 = `simplifyConstant`, dependencies$37$2 = [`typed`, `config`, `mathWithTransform`, `matrix`, `isBounded`, `?fraction`, `?bignumber`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `SymbolNode`], createSimplifyConstant$2 = factory$2(name$37$2, dependencies$37$2, (t4) => {
  var { typed: n2, config: r2, mathWithTransform: i2, matrix: a2, isBounded: o2, fraction: s2, bignumber: c2, AccessorNode: l2, ArrayNode: u2, ConstantNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, SymbolNode: v2 } = t4, { isCommutative: y2, isAssociative: b2, allChildren: x2, createMakeNodeFunction: S2 } = createUtil$2({ FunctionNode: p2, OperatorNode: g2, SymbolNode: v2 }), w2 = n2(`simplifyConstant`, { Node: (t5) => j2(z2(t5, {})), "Node, Object": function(t5, n3) {
    return j2(z2(t5, n3));
  } });
  function E(t5) {
    return isFraction$2(t5) ? t5.valueOf() : t5 instanceof Array ? t5.map(E) : isMatrix$2(t5) ? a2(E(t5.valueOf())) : t5;
  }
  function D(t5, n3, r3) {
    try {
      return i2[t5].apply(null, n3);
    } catch {
      return n3 = n3.map(E), N2(i2[t5].apply(null, n3), r3);
    }
  }
  var O2 = n2({ Fraction: I2, number: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, BigNumber: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, bigint: function(t5) {
    return t5 < 0n ? F(new d2(-t5)) : new d2(t5);
  }, Complex: function(t5) {
    throw Error(`Cannot convert Complex number to Node`);
  }, string: function(t5) {
    return new d2(t5);
  }, Matrix: function(t5) {
    return new u2(t5.valueOf().map((t6) => O2(t6)));
  } });
  function j2(t5) {
    return isNode$5(t5) ? t5 : O2(t5);
  }
  function M2(t5, n3) {
    if (n3 && n3.exactFractions !== false && o2(t5) && s2) {
      var r3 = s2(t5), i3 = n3 && typeof n3.fractionsLimit == `number` ? n3.fractionsLimit : 1 / 0;
      if (r3.valueOf() === t5 && r3.n < i3 && r3.d < i3) return r3;
    }
    return t5;
  }
  var N2 = n2({ "string, Object": function(t5, n3) {
    var i3 = safeNumberType$2(t5, r2);
    return i3 === `BigNumber` ? (c2 === void 0 && noBignumber$2(), c2(t5)) : i3 === `bigint` ? BigInt(t5) : i3 === `Fraction` ? (s2 === void 0 && noFraction$2(), s2(t5)) : M2(parseFloat(t5), n3);
  }, "Fraction, Object": function(t5, n3) {
    return t5;
  }, "BigNumber, Object": function(t5, n3) {
    return t5;
  }, "number, Object": function(t5, n3) {
    return M2(t5, n3);
  }, "bigint, Object": function(t5, n3) {
    return t5;
  }, "Complex, Object": function(t5, n3) {
    return t5.im === 0 ? M2(t5.re, n3) : t5;
  }, "Matrix, Object": function(t5, n3) {
    return a2(M2(t5.valueOf()));
  }, "Array, Object": function(t5, n3) {
    return t5.map(M2);
  } });
  function F(t5) {
    return new g2(`-`, `unaryMinus`, [t5]);
  }
  function I2(t5) {
    var n3 = (t6) => r2.number === `BigNumber` && c2 ? c2(t6) : Number(t6), i3 = t5.s * t5.n, a3 = i3 < 0n ? new g2(`-`, `unaryMinus`, [new d2(-n3(i3))]) : new d2(n3(i3));
    return t5.d === 1n ? a3 : new g2(`/`, `divide`, [a3, new d2(n3(t5.d))]);
  }
  function L2(t5, n3, r3) {
    if (!isIndexNode$2(n3)) return new l2(j2(t5), j2(n3));
    if (isArrayNode$2(t5) || isMatrix$2(t5)) {
      for (var i3 = Array.from(n3.dimensions); i3.length > 0; ) if (isConstantNode$2(i3[0]) && typeof i3[0].value != `string`) {
        var o3 = N2(i3.shift().value, r3);
        isArrayNode$2(t5) ? t5 = t5.items[o3 - 1] : (t5 = t5.valueOf()[o3 - 1], t5 instanceof Array && (t5 = a2(t5)));
      } else if (i3.length > 1 && isConstantNode$2(i3[1]) && typeof i3[1].value != `string`) {
        var s3 = N2(i3[1].value, r3), c3 = [], p3 = isArrayNode$2(t5) ? t5.items : t5.valueOf();
        for (var h3 of p3) if (isArrayNode$2(h3)) c3.push(h3.items[s3 - 1]);
        else if (isMatrix$2(t5)) c3.push(h3[s3 - 1]);
        else break;
        if (c3.length === p3.length) t5 = isArrayNode$2(t5) ? new u2(c3) : a2(c3), i3.splice(1, 1);
        else break;
      } else break;
      return i3.length === n3.dimensions.length ? new l2(j2(t5), n3) : i3.length > 0 ? (n3 = new m2(i3), new l2(j2(t5), n3)) : t5;
    }
    if (isObjectNode$2(t5) && n3.dimensions.length === 1 && isConstantNode$2(n3.dimensions[0])) {
      var g3 = n3.dimensions[0].value;
      return g3 in t5.properties ? t5.properties[g3] : new d2();
    }
    return new l2(j2(t5), n3);
  }
  function R2(t5, n3, r3, i3) {
    var a3 = n3.shift(), o3 = n3.reduce((n4, a4) => {
      if (!isNode$5(a4)) {
        var o4 = n4.pop();
        if (isNode$5(o4)) return [o4, a4];
        try {
          return n4.push(D(t5, [o4, a4], i3)), n4;
        } catch {
          n4.push(o4);
        }
      }
      return n4.push(j2(n4.pop())), [r3([n4.length === 1 ? n4[0] : r3(n4), j2(a4)])];
    }, [a3]);
    return o3.length === 1 ? o3[0] : r3([o3[0], O2(o3[1])]);
  }
  function z2(t5, n3) {
    switch (t5.type) {
      case `SymbolNode`:
        return t5;
      case `ConstantNode`:
        switch (typeof t5.value) {
          case `number`:
            return N2(t5.value, n3);
          case `bigint`:
            return N2(t5.value, n3);
          case `string`:
            return t5.value;
          default:
            if (!isNaN(t5.value)) return N2(t5.value, n3);
        }
        return t5;
      case `FunctionNode`:
        if (i2[t5.name] && i2[t5.name].rawArgs) return t5;
        if (![`add`, `multiply`].includes(t5.name)) {
          var r3 = t5.args.map((t6) => z2(t6, n3));
          if (!r3.some(isNode$5)) try {
            return D(t5.name, r3, n3);
          } catch {
          }
          if (t5.name === `size` && r3.length === 1 && isArrayNode$2(r3[0])) {
            for (var o3 = [], s3 = r3[0]; isArrayNode$2(s3); ) o3.push(s3.items.length), s3 = s3.items[0];
            return a2(o3);
          }
          return new p2(t5.name, r3.map(j2));
        }
      case `OperatorNode`:
        var c3 = t5.fn.toString(), l3, d3, g3 = S2(t5);
        if (isOperatorNode$2(t5) && t5.isUnary()) l3 = [z2(t5.args[0], n3)], d3 = isNode$5(l3[0]) ? g3(l3) : D(c3, l3, n3);
        else if (b2(t5, n3.context)) if (l3 = x2(t5, n3.context), l3 = l3.map((t6) => z2(t6, n3)), y2(c3, n3.context)) {
          for (var v3 = [], E2 = [], O3 = 0; O3 < l3.length; O3++) isNode$5(l3[O3]) ? E2.push(l3[O3]) : v3.push(l3[O3]);
          v3.length > 1 ? (d3 = R2(c3, v3, g3, n3), E2.unshift(d3), d3 = R2(c3, E2, g3, n3)) : d3 = R2(c3, l3, g3, n3);
        } else d3 = R2(c3, l3, g3, n3);
        else l3 = t5.args.map((t6) => z2(t6, n3)), d3 = R2(c3, l3, g3, n3);
        return d3;
      case `ParenthesisNode`:
        return z2(t5.content, n3);
      case `AccessorNode`:
        return L2(z2(t5.object, n3), z2(t5.index, n3), n3);
      case `ArrayNode`:
        var M3 = t5.items.map((t6) => z2(t6, n3));
        return M3.some(isNode$5) ? new u2(M3.map(j2)) : a2(M3);
      case `IndexNode`:
        return new m2(t5.dimensions.map((t6) => w2(t6, n3)));
      case `ObjectNode`:
        var F2 = {};
        for (var I3 in t5.properties) F2[I3] = w2(t5.properties[I3], n3);
        return new h2(F2);
      default:
        throw Error(`Unimplemented node type in simplifyConstant: ${t5.type}`);
    }
  }
  return w2;
}), name$36$2 = `simplifyCore`, dependencies$36$2 = [`typed`, `parse`, `equal`, `isZero`, `add`, `subtract`, `multiply`, `divide`, `pow`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createSimplifyCore$2 = factory$2(name$36$2, dependencies$36$2, (t4) => {
  var { typed: n2, parse: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, AccessorNode: d2, ArrayNode: p2, ConstantNode: m2, FunctionNode: h2, IndexNode: g2, ObjectNode: v2, OperatorNode: y2, ParenthesisNode: b2, SymbolNode: x2 } = t4, S2 = new m2(0), w2 = new m2(1), E = new m2(true), D = new m2(false);
  function O2(t5) {
    return isOperatorNode$2(t5) && [`and`, `not`, `or`].includes(t5.op);
  }
  var { hasProperty: j2, isCommutative: M2 } = createUtil$2({ FunctionNode: h2, OperatorNode: y2, SymbolNode: x2 });
  function N2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3 ? n3.context : void 0;
    if (j2(t5, `trivial`, r3)) {
      if (isFunctionNode$2(t5) && t5.args.length === 1) return N2(t5.args[0], n3);
      var o3 = false, s3 = 0;
      if (t5.forEach((t6) => {
        ++s3, s3 === 1 && (o3 = N2(t6, n3));
      }), s3 === 1) return o3;
    }
    var c3 = t5;
    if (isFunctionNode$2(c3)) {
      var l3 = getOperator$2(c3.name);
      if (l3) {
        if (c3.args.length > 2 && j2(c3, `associative`, r3)) for (; c3.args.length > 2; ) {
          var u3 = c3.args.pop(), m3 = c3.args.pop();
          c3.args.push(new y2(l3, c3.name, [u3, m3]));
        }
        c3 = new y2(l3, c3.name, c3.args);
      } else return new h2(N2(c3.fn), c3.args.map((t6) => N2(t6, n3)));
    }
    if (isOperatorNode$2(c3) && c3.isUnary()) {
      var b3 = N2(c3.args[0], n3);
      if (c3.op === `~` && isOperatorNode$2(b3) && b3.isUnary() && b3.op === `~` || c3.op === `not` && isOperatorNode$2(b3) && b3.isUnary() && b3.op === `not` && O2(b3.args[0])) return b3.args[0];
      var x3 = true;
      if (c3.op === `-` && isOperatorNode$2(b3) && (b3.isBinary() && b3.fn === `subtract` && (c3 = new y2(`-`, `subtract`, [b3.args[1], b3.args[0]]), x3 = false), b3.isUnary() && b3.op === `-`)) return b3.args[0];
      if (x3) return new y2(c3.op, c3.fn, [b3]);
    }
    if (isOperatorNode$2(c3) && c3.isBinary()) {
      var F = N2(c3.args[0], n3), I2 = N2(c3.args[1], n3);
      if (c3.op === `+`) {
        if (isConstantNode$2(F) && a2(F.value)) return I2;
        if (isConstantNode$2(I2) && a2(I2.value)) return F;
        isOperatorNode$2(I2) && I2.isUnary() && I2.op === `-` && (I2 = I2.args[0], c3 = new y2(`-`, `subtract`, [F, I2]));
      }
      if (c3.op === `-`) return isOperatorNode$2(I2) && I2.isUnary() && I2.op === `-` ? N2(new y2(`+`, `add`, [F, I2.args[0]]), n3) : isConstantNode$2(F) && a2(F.value) ? N2(new y2(`-`, `unaryMinus`, [I2])) : isConstantNode$2(I2) && a2(I2.value) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `*`) {
        if (isConstantNode$2(F)) {
          if (a2(F.value)) return S2;
          if (i2(F.value, 1)) return I2;
        }
        if (isConstantNode$2(I2)) {
          if (a2(I2.value)) return S2;
          if (i2(I2.value, 1)) return F;
          if (M2(c3, r3)) return new y2(c3.op, c3.fn, [I2, F], c3.implicit);
        }
        return new y2(c3.op, c3.fn, [F, I2], c3.implicit);
      }
      if (c3.op === `/`) return isConstantNode$2(F) && a2(F.value) ? S2 : isConstantNode$2(I2) && i2(I2.value, 1) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `^` && isConstantNode$2(I2)) {
        if (a2(I2.value)) return w2;
        if (i2(I2.value, 1)) return F;
      }
      if (c3.op === `and`) {
        if (isConstantNode$2(F)) if (F.value) {
          if (O2(I2)) return I2;
          if (isConstantNode$2(I2)) return I2.value ? E : D;
        } else return D;
        if (isConstantNode$2(I2)) if (I2.value) {
          if (O2(F)) return F;
        } else return D;
      }
      if (c3.op === `or`) {
        if (isConstantNode$2(F)) {
          if (F.value) return E;
          if (O2(I2)) return I2;
        }
        if (isConstantNode$2(I2)) {
          if (I2.value) return E;
          if (O2(F)) return F;
        }
      }
      return new y2(c3.op, c3.fn, [F, I2]);
    }
    if (isOperatorNode$2(c3)) return new y2(c3.op, c3.fn, c3.args.map((t6) => N2(t6, n3)));
    if (isArrayNode$2(c3)) return new p2(c3.items.map((t6) => N2(t6, n3)));
    if (isAccessorNode$2(c3)) return new d2(N2(c3.object, n3), N2(c3.index, n3));
    if (isIndexNode$2(c3)) return new g2(c3.dimensions.map((t6) => N2(t6, n3)));
    if (isObjectNode$2(c3)) {
      var L2 = {};
      for (var R2 in c3.properties) L2[R2] = N2(c3.properties[R2], n3);
      return new v2(L2);
    }
    return c3;
  }
  return n2(name$36$2, { Node: N2, "Node,Object": N2 });
}), name$35$2 = `resolve`, dependencies$35$2 = [`typed`, `parse`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`], createResolve$2 = factory$2(name$35$2, dependencies$35$2, (t4) => {
  var { typed: n2, parse: r2, ConstantNode: i2, FunctionNode: a2, OperatorNode: o2, ParenthesisNode: s2 } = t4;
  function c2(t5, n3) {
    var l2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!n3) return t5;
    if (isSymbolNode$2(t5)) {
      if (l2.has(t5.name)) {
        var u2 = Array.from(l2).join(`, `);
        throw ReferenceError(`recursive loop of variable definitions among {${u2}}`);
      }
      var d2 = n3.get(t5.name);
      if (isNode$5(d2)) {
        var p2 = new Set(l2);
        return p2.add(t5.name), c2(d2, n3, p2);
      } else if (typeof d2 == `number`) return r2(String(d2));
      else if (d2 !== void 0) return new i2(d2);
      else return t5;
    } else if (isOperatorNode$2(t5)) {
      var m2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new o2(t5.op, t5.fn, m2, t5.implicit);
    } else if (isParenthesisNode$2(t5)) return new s2(c2(t5.content, n3, l2));
    else if (isFunctionNode$2(t5)) {
      var h2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new a2(t5.name, h2);
    }
    return t5.map((t6) => c2(t6, n3, l2));
  }
  return n2(`resolve`, { Node: c2, "Node, Map | null | undefined": c2, "Node, Object": (t5, n3) => c2(t5, createMap$1$2(n3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array | Matrix, null | undefined": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array, Object": n2.referTo(`Array,Map`, (t5) => (n3, r3) => t5(n3, createMap$1$2(r3))), "Matrix, Object": n2.referTo(`Matrix,Map`, (t5) => (n3, r3) => t5(n3, createMap$1$2(r3))), "Array | Matrix, Map": n2.referToSelf((t5) => (n3, r3) => n3.map((n4) => t5(n4, r3))) });
}), name$34$2 = `symbolicEqual`, dependencies$34$2 = [`parse`, `simplify`, `typed`, `OperatorNode`], createSymbolicEqual$2 = factory$2(name$34$2, dependencies$34$2, (t4) => {
  var { parse: n2, simplify: r2, typed: i2, OperatorNode: a2 } = t4;
  function o2(t5, n3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o3 = r2(new a2(`-`, `subtract`, [t5, n3]), {}, i3);
    return isConstantNode$2(o3) && !o3.value;
  }
  return i2(name$34$2, { "Node, Node": o2, "Node, Node, Object": o2 });
}), name$33$2 = `derivative`, dependencies$33$2 = [`typed`, `config`, `parse`, `simplify`, `equal`, `isZero`, `numeric`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createDerivative$2 = factory$2(name$33$2, dependencies$33$2, (t4) => {
  var { typed: n2, config: r2, parse: i2, simplify: a2, equal: o2, isZero: s2, numeric: c2, ConstantNode: l2, FunctionNode: u2, OperatorNode: d2, ParenthesisNode: p2, SymbolNode: m2 } = t4;
  function h2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { simplify: true }, i3 = /* @__PURE__ */ new Map(), o3 = n3.name;
    function s3(t6) {
      var n4 = i3.get(t6);
      if (n4 !== void 0) return n4;
      var r4 = b2(s3, t6, o3);
      return i3.set(t6, r4), r4;
    }
    var c3 = x2(t5, s3);
    return r3.simplify ? a2(c3) : c3;
  }
  function g2(t5) {
    var n3 = i2(t5);
    if (!n3.isSymbolNode) throw TypeError(`Invalid variable. Cannot parse ${JSON.stringify(t5)} into a variable in function derivative`);
    return n3;
  }
  var v2 = n2(name$33$2, { "Node, SymbolNode": h2, "Node, SymbolNode, Object": h2, "Node, string": (t5, n3) => h2(t5, g2(n3)), "Node, string, Object": (t5, n3, r3) => h2(t5, g2(n3), r3) });
  v2._simplify = true, v2.toTex = function(t5) {
    return y2.apply(null, t5.args);
  };
  var y2 = n2(`_derivTex`, { "Node, SymbolNode": function(t5, n3) {
    return isConstantNode$2(t5) && typeOf$2(t5.value) === `string` ? y2(i2(t5.value).toString(), n3.toString(), 1) : y2(t5.toTex(), n3.toString(), 1);
  }, "Node, ConstantNode": function(t5, n3) {
    if (typeOf$2(n3.value) === `string`) return y2(t5, i2(n3.value));
    throw Error(`The second parameter to 'derivative' is a non-string constant`);
  }, "Node, SymbolNode, ConstantNode": function(t5, n3, r3) {
    return y2(t5.toString(), n3.name, r3.value);
  }, "string, string, number": function(t5, n3, r3) {
    return (r3 === 1 ? `{d\\over d` + n3 + `}` : `{d^{` + r3 + `}\\over d` + n3 + `^{` + r3 + `}}`) + `\\left[${t5}\\right]`;
  } }), b2 = n2(`_isConst`, { "function, ConstantNode, string": function() {
    return true;
  }, "function, SymbolNode, string": function(t5, n3, r3) {
    return n3.name !== r3;
  }, "function, ParenthesisNode, string": function(t5, n3, r3) {
    return t5(n3.content, r3);
  }, "function, FunctionAssignmentNode, string": function(t5, n3, r3) {
    return n3.params.includes(r3) ? t5(n3.expr, r3) : true;
  }, "function, FunctionNode | OperatorNode, string": function(t5, n3, r3) {
    return n3.args.every((n4) => t5(n4, r3));
  } }), x2 = n2(`_derivative`, { "ConstantNode, function": function() {
    return S2(0);
  }, "SymbolNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : S2(1);
  }, "ParenthesisNode, function": function(t5, n3) {
    return new p2(x2(t5.content, n3));
  }, "FunctionAssignmentNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : x2(t5.expr, n3);
  }, "FunctionNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    var r3 = t5.args[0], i3, a3 = false, o3 = false, s3;
    switch (t5.name) {
      case `cbrt`:
        a3 = true, s3 = new d2(`*`, `multiply`, [S2(3), new d2(`^`, `pow`, [r3, new d2(`/`, `divide`, [S2(2), S2(3)])])]);
        break;
      case `sqrt`:
      case `nthRoot`:
        if (t5.args.length === 1) a3 = true, s3 = new d2(`*`, `multiply`, [S2(2), new u2(`sqrt`, [r3])]);
        else if (t5.args.length === 2) return i3 = new d2(`/`, `divide`, [S2(1), t5.args[1]]), x2(new d2(`^`, `pow`, [r3, i3]), n3);
        break;
      case `log10`:
        i3 = S2(10);
      case `log`:
        if (!i3 && t5.args.length === 1) s3 = r3.clone(), a3 = true;
        else if (t5.args.length === 1 && i3 || t5.args.length === 2 && n3(t5.args[1])) s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`log`, [i3 || t5.args[1]])]), a3 = true;
        else if (t5.args.length === 2) return x2(new d2(`/`, `divide`, [new u2(`log`, [r3]), new u2(`log`, [t5.args[1]])]), n3);
        break;
      case `pow`:
        if (t5.args.length === 2) return x2(new d2(`^`, `pow`, [r3, t5.args[1]]), n3);
        break;
      case `exp`:
        s3 = new u2(`exp`, [r3.clone()]);
        break;
      case `sin`:
        s3 = new u2(`cos`, [r3.clone()]);
        break;
      case `cos`:
        s3 = new d2(`-`, `unaryMinus`, [new u2(`sin`, [r3.clone()])]);
        break;
      case `tan`:
        s3 = new d2(`^`, `pow`, [new u2(`sec`, [r3.clone()]), S2(2)]);
        break;
      case `sec`:
        s3 = new d2(`*`, `multiply`, [t5, new u2(`tan`, [r3.clone()])]);
        break;
      case `csc`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`cot`, [r3.clone()])]);
        break;
      case `cot`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csc`, [r3.clone()]), S2(2)]);
        break;
      case `asin`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `acos`:
        a3 = true, o3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `atan`:
        a3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `asec`:
        a3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acsc`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acot`:
        a3 = true, o3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `sinh`:
        s3 = new u2(`cosh`, [r3.clone()]);
        break;
      case `cosh`:
        s3 = new u2(`sinh`, [r3.clone()]);
        break;
      case `tanh`:
        s3 = new d2(`^`, `pow`, [new u2(`sech`, [r3.clone()]), S2(2)]);
        break;
      case `sech`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`tanh`, [r3.clone()])]);
        break;
      case `csch`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`coth`, [r3.clone()])]);
        break;
      case `coth`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csch`, [r3.clone()]), S2(2)]);
        break;
      case `asinh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `acosh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `atanh`:
        a3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `asech`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])])]);
        break;
      case `acsch`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acoth`:
        a3 = true, o3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `abs`:
        s3 = new d2(`/`, `divide`, [new u2(new m2(`abs`), [r3.clone()]), r3.clone()]);
        break;
      default:
        throw Error(`Cannot process function "` + t5.name + `" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported`);
    }
    var c3, l3;
    a3 ? (c3 = `/`, l3 = `divide`) : (c3 = `*`, l3 = `multiply`);
    var p3 = x2(r3, n3);
    return o3 && (p3 = new d2(`-`, `unaryMinus`, [p3])), new d2(c3, l3, [p3, s3]);
  }, "OperatorNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    if (t5.op === `+`) return new d2(t5.op, t5.fn, t5.args.map(function(t6) {
      return x2(t6, n3);
    }));
    if (t5.op === `-`) {
      if (t5.isUnary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3)]);
      if (t5.isBinary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3), x2(t5.args[1], n3)]);
    }
    if (t5.op === `*`) {
      var r3 = t5.args.filter(function(t6) {
        return n3(t6);
      });
      if (r3.length > 0) {
        var i3 = t5.args.filter(function(t6) {
          return !n3(t6);
        }), a3 = i3.length === 1 ? i3[0] : new d2(`*`, `multiply`, i3);
        return new d2(`*`, `multiply`, r3.concat(x2(a3, n3)));
      }
      return new d2(`+`, `add`, t5.args.map(function(r4) {
        return new d2(`*`, `multiply`, t5.args.map(function(t6) {
          return t6 === r4 ? x2(t6, n3) : t6.clone();
        }));
      }));
    }
    if (t5.op === `/` && t5.isBinary()) {
      var c3 = t5.args[0], l3 = t5.args[1];
      return n3(l3) ? new d2(`/`, `divide`, [x2(c3, n3), l3]) : n3(c3) ? new d2(`*`, `multiply`, [new d2(`-`, `unaryMinus`, [c3]), new d2(`/`, `divide`, [x2(l3, n3), new d2(`^`, `pow`, [l3.clone(), S2(2)])])]) : new d2(`/`, `divide`, [new d2(`-`, `subtract`, [new d2(`*`, `multiply`, [x2(c3, n3), l3.clone()]), new d2(`*`, `multiply`, [c3.clone(), x2(l3, n3)])]), new d2(`^`, `pow`, [l3.clone(), S2(2)])]);
    }
    if (t5.op === `^` && t5.isBinary()) {
      var p3 = t5.args[0], m3 = t5.args[1];
      if (n3(p3)) return isConstantNode$2(p3) && (s2(p3.value) || o2(p3.value, 1)) ? S2(0) : new d2(`*`, `multiply`, [t5, new d2(`*`, `multiply`, [new u2(`log`, [p3.clone()]), x2(m3.clone(), n3)])]);
      if (n3(m3)) {
        if (isConstantNode$2(m3)) {
          if (s2(m3.value)) return S2(0);
          if (o2(m3.value, 1)) return x2(p3, n3);
        }
        var h3 = new d2(`^`, `pow`, [p3.clone(), new d2(`-`, `subtract`, [m3, S2(1)])]);
        return new d2(`*`, `multiply`, [m3.clone(), new d2(`*`, `multiply`, [x2(p3, n3), h3])]);
      }
      return new d2(`*`, `multiply`, [new d2(`^`, `pow`, [p3.clone(), m3.clone()]), new d2(`+`, `add`, [new d2(`*`, `multiply`, [x2(p3, n3), new d2(`/`, `divide`, [m3.clone(), p3.clone()])]), new d2(`*`, `multiply`, [x2(m3, n3), new u2(`log`, [p3.clone()])])])]);
    }
    throw Error(`Cannot process operator "` + t5.op + `" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported`);
  } });
  function S2(t5, n3) {
    return new l2(c2(t5, safeNumberType$2(String(t5), r2)));
  }
  return v2;
}), name$32$2 = `rationalize`, dependencies$32$2 = `config.typed.equal.isZero.add.subtract.multiply.divide.pow.parse.simplifyConstant.simplifyCore.simplify.?bignumber.?fraction.mathWithTransform.matrix.AccessorNode.ArrayNode.ConstantNode.FunctionNode.IndexNode.ObjectNode.OperatorNode.SymbolNode.ParenthesisNode`.split(`.`), createRationalize$2 = factory$2(name$32$2, dependencies$32$2, (t4) => {
  var { config: n2, typed: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, parse: d2, simplifyConstant: p2, simplifyCore: m2, simplify: h2, fraction: g2, bignumber: v2, mathWithTransform: y2, matrix: b2, AccessorNode: x2, ArrayNode: S2, ConstantNode: w2, FunctionNode: E, IndexNode: D, ObjectNode: O2, OperatorNode: j2, SymbolNode: M2, ParenthesisNode: N2 } = t4;
  function F(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, i3 = L2(), a3 = I2(t5, n3, true, i3.firstRules), o3 = a3.variables.length, s3 = { exactFractions: false }, c3 = { exactFractions: true };
    if (t5 = a3.expression, o3 >= 1) {
      t5 = R2(t5);
      var l3, u3, d3 = true, p3 = false;
      t5 = h2(t5, i3.firstRules, {}, s3);
      for (var m3; u3 = d3 ? i3.distrDivRules : i3.sucDivRules, t5 = h2(t5, u3, {}, c3), d3 = !d3, m3 = t5.toString(), m3 !== l3; ) p3 = true, l3 = m3;
      p3 && (t5 = h2(t5, i3.firstRulesAgain, {}, s3)), t5 = h2(t5, i3.finalRules, {}, s3);
    }
    var g3 = [], v3 = {};
    return t5.type === `OperatorNode` && t5.isBinary() && t5.op === `/` ? (o3 === 1 && (t5.args[0] = z2(t5.args[0], g3), t5.args[1] = z2(t5.args[1])), r3 && (v3.numerator = t5.args[0], v3.denominator = t5.args[1])) : (o3 === 1 && (t5 = z2(t5, g3)), r3 && (v3.numerator = t5, v3.denominator = null)), r3 ? (v3.coefficients = g3, v3.variables = a3.variables, v3.expression = t5, v3) : t5;
  }
  return r2(name$32$2, { Node: F, "Node, boolean": (t5, n3) => F(t5, {}, n3), "Node, Object": F, "Node, Object, boolean": F });
  function I2(t5, n3, r3, i3) {
    var a3 = [], o3 = h2(t5, i3, n3, { exactFractions: false });
    r3 = !!r3;
    var s3 = `+-*` + (r3 ? `/` : ``);
    l3(o3);
    var c3 = {};
    return c3.expression = o3, c3.variables = a3, c3;
    function l3(t6) {
      var n4 = t6.type;
      if (n4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (n4 === `OperatorNode`) if (t6.op === `^`) {
        if (t6.args[1].type !== `ConstantNode` || !isInteger$3(parseFloat(t6.args[1].value))) throw Error(`There is a non-integer exponent`);
        l3(t6.args[0]);
      } else {
        if (!s3.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid in polynomial expression`);
        for (var r4 = 0; r4 < t6.args.length; r4++) l3(t6.args[r4]);
      }
      else if (n4 === `SymbolNode`) {
        var i4 = t6.name;
        a3.indexOf(i4) === -1 && a3.push(i4);
      } else if (n4 === `ParenthesisNode`) l3(t6.content);
      else if (n4 !== `ConstantNode`) throw Error(`type ` + n4 + ` is not allowed in polynomial expression`);
    }
  }
  function L2() {
    var t5 = [m2, { l: `n+n`, r: `2*n` }, { l: `n+-n`, r: `0` }, p2, { l: `n*(n1^-1)`, r: `n/n1` }, { l: `n*n1^-n2`, r: `n/n1^n2` }, { l: `n1^-1`, r: `1/n1` }, { l: `n*(n1/n2)`, r: `(n*n1)/n2` }, { l: `1*n`, r: `n` }], n3 = [{ l: `(-n1)/(-n2)`, r: `n1/n2` }, { l: `(-n1)*(-n2)`, r: `n1*n2` }, { l: `n1--n2`, r: `n1+n2` }, { l: `n1-n2`, r: `n1+(-n2)` }, { l: `(n1+n2)*n3`, r: `(n1*n3 + n2*n3)` }, { l: `n1*(n2+n3)`, r: `(n1*n2+n1*n3)` }, { l: `c1*n + c2*n`, r: `(c1+c2)*n` }, { l: `c1*n + n`, r: `(c1+1)*n` }, { l: `c1*n - c2*n`, r: `(c1-c2)*n` }, { l: `c1*n - n`, r: `(c1-1)*n` }, { l: `v/c`, r: `(1/c)*v` }, { l: `v/-c`, r: `-(1/c)*v` }, { l: `-v*-c`, r: `c*v` }, { l: `-v*c`, r: `-c*v` }, { l: `v*-c`, r: `-c*v` }, { l: `v*c`, r: `c*v` }, { l: `-(-n1*n2)`, r: `(n1*n2)` }, { l: `-(n1*n2)`, r: `(-n1*n2)` }, { l: `-(-n1+n2)`, r: `(n1-n2)` }, { l: `-(n1+n2)`, r: `(-n1-n2)` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }, { l: `-(-n1/n2)`, r: `(n1/n2)` }, { l: `-(n1/n2)`, r: `(-n1/n2)` }], r3 = [{ l: `(n1/n2 + n3/n4)`, r: `((n1*n4 + n3*n2)/(n2*n4))` }, { l: `(n1/n2 + n3)`, r: `((n1 + n3*n2)/n2)` }, { l: `(n1 + n2/n3)`, r: `((n1*n3 + n2)/n3)` }], i3 = [{ l: `(n1/(n2/n3))`, r: `((n1*n3)/n2)` }, { l: `(n1/n2/n3)`, r: `(n1/(n2*n3))` }], a3 = {};
    return a3.firstRules = t5.concat(n3, i3), a3.distrDivRules = r3, a3.sucDivRules = i3, a3.firstRulesAgain = t5.concat(n3), a3.finalRules = [m2, { l: `n*-n`, r: `-n^2` }, { l: `n*n`, r: `n^2` }, p2, { l: `n*-n^n1`, r: `-n^(n1+1)` }, { l: `n*n^n1`, r: `n^(n1+1)` }, { l: `n^n1*-n^n2`, r: `-n^(n1+n2)` }, { l: `n^n1*n^n2`, r: `n^(n1+n2)` }, { l: `n^n1*-n`, r: `-n^(n1+1)` }, { l: `n^n1*n`, r: `n^(n1+1)` }, { l: `n^n1/-n`, r: `-n^(n1-1)` }, { l: `n^n1/n`, r: `n^(n1-1)` }, { l: `n/-n^n1`, r: `-n^(1-n1)` }, { l: `n/n^n1`, r: `n^(1-n1)` }, { l: `n^n1/-n^n2`, r: `n^(n1-n2)` }, { l: `n^n1/n^n2`, r: `n^(n1-n2)` }, { l: `n1+(-n2*n3)`, r: `n1-n2*n3` }, { l: `v*(-c)`, r: `-c*v` }, { l: `n1+-n2`, r: `n1-n2` }, { l: `v*c`, r: `c*v` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }], a3;
  }
  function R2(t5, n3, r3) {
    var i3 = t5.type, a3 = arguments.length > 1;
    if (i3 === `OperatorNode` && t5.isBinary()) {
      var o3 = false, s3;
      if (t5.op === `^` && (t5.args[0].type === `ParenthesisNode` || t5.args[0].type === `OperatorNode`) && t5.args[1].type === `ConstantNode` && (s3 = parseFloat(t5.args[1].value), o3 = s3 >= 2 && isInteger$3(s3)), o3) {
        if (s3 > 2) {
          var c3 = t5.args[0];
          t5 = new j2(`*`, `multiply`, [c3, new j2(`^`, `pow`, [t5.args[0].cloneDeep(), new w2(s3 - 1)])]);
        } else t5 = new j2(`*`, `multiply`, [t5.args[0], t5.args[0].cloneDeep()]);
        a3 && (r3 === `content` ? n3.content = t5 : n3.args[r3] = t5);
      }
    }
    if (i3 === `ParenthesisNode`) R2(t5.content, t5, `content`);
    else if (i3 !== `ConstantNode` && i3 !== `SymbolNode`) for (var l3 = 0; l3 < t5.args.length; l3++) R2(t5.args[l3], t5, l3);
    if (!a3) return t5;
  }
  function z2(t5, n3) {
    n3 === void 0 && (n3 = []), n3[0] = 0;
    var r3 = {};
    r3.cte = 1, r3.oper = `+`, r3.fire = ``;
    var i3 = 0, a3 = ``;
    m3(t5, null, r3), i3 = n3.length - 1;
    for (var o3 = true, s3, c3 = i3; c3 >= 0; c3--) if (n3[c3] !== 0) {
      var l3 = new w2(o3 ? n3[c3] : Math.abs(n3[c3])), u3 = n3[c3] < 0 ? `-` : `+`;
      if (c3 > 0) {
        var d3 = new M2(a3);
        if (c3 > 1) {
          var p3 = new w2(c3);
          d3 = new j2(`^`, `pow`, [d3, p3]);
        }
        l3 = n3[c3] === -1 && o3 ? new j2(`-`, `unaryMinus`, [d3]) : Math.abs(n3[c3]) === 1 ? d3 : new j2(`*`, `multiply`, [l3, d3]);
      }
      s3 = o3 ? l3 : u3 === `+` ? new j2(`+`, `add`, [s3, l3]) : new j2(`-`, `subtract`, [s3, l3]), o3 = false;
    }
    if (o3) return new w2(0);
    return s3;
    function m3(t6, r4, o4) {
      var s4 = t6.type;
      if (s4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (s4 === `OperatorNode`) {
        if (!`+-*^`.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid`);
        if (r4 !== null && ((t6.fn === `unaryMinus` || t6.fn === `pow`) && r4.fn !== `add` && r4.fn !== `subtract` && r4.fn !== `multiply` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `multiply`) && r4.fn !== `add` && r4.fn !== `subtract` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `unaryMinus`) && o4.noFil !== 0)) throw Error(`Invalid ` + t6.op + ` placing`);
        (t6.op === `^` || t6.op === `*`) && (o4.fire = t6.op);
        for (var c4 = 0; c4 < t6.args.length; c4++) t6.fn === `unaryMinus` && (o4.oper = `-`), (t6.op === `+` || t6.fn === `subtract`) && (o4.fire = ``, o4.cte = 1, o4.oper = c4 === 0 ? `+` : t6.op), o4.noFil = c4, m3(t6.args[c4], t6, o4);
      } else if (s4 === `SymbolNode`) {
        if (t6.name !== a3 && a3 !== ``) throw Error(`There is more than one variable`);
        if (a3 = t6.name, r4 === null) {
          n3[1] = 1;
          return;
        }
        if (r4.op === `^` && o4.noFil !== 0) throw Error(`In power the variable should be the first parameter`);
        if (r4.op === `*` && o4.noFil !== 1) throw Error(`In multiply the variable should be the second parameter`);
        (o4.fire === `` || o4.fire === `*`) && (i3 < 1 && (n3[1] = 0), n3[1] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(1, i3));
      } else if (s4 === `ConstantNode`) {
        var l4 = parseFloat(t6.value);
        if (r4 === null) {
          n3[0] = l4;
          return;
        }
        if (r4.op === `^`) {
          if (o4.noFil !== 1) throw Error(`Constant cannot be powered`);
          if (!isInteger$3(l4) || l4 <= 0) throw Error(`Non-integer exponent is not allowed`);
          for (var u4 = i3 + 1; u4 < l4; u4++) n3[u4] = 0;
          l4 > i3 && (n3[l4] = 0), n3[l4] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(l4, i3);
          return;
        }
        o4.cte = l4, o4.fire === `` && (n3[0] += o4.cte * (o4.oper === `+` ? 1 : -1));
      } else throw Error(`Type ` + s4 + ` is not allowed`);
    }
  }
}), name$31$2 = `zpk2tf`, dependencies$31$2 = [`typed`, `add`, `multiply`, `Complex`, `number`], createZpk2tf$2 = factory$2(name$31$2, dependencies$31$2, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, number: o2 } = t4;
  return n2(name$31$2, { "Array,Array,number": function(t5, n3, r3) {
    return s2(t5, n3, r3);
  }, "Array,Array": function(t5, n3) {
    return s2(t5, n3, 1);
  }, "Matrix,Matrix,number": function(t5, n3, r3) {
    return s2(t5.valueOf(), n3.valueOf(), r3);
  }, "Matrix,Matrix": function(t5, n3) {
    return s2(t5.valueOf(), n3.valueOf(), 1);
  } });
  function s2(t5, n3, r3) {
    t5.some((t6) => t6.type === `BigNumber`) && (t5 = t5.map((t6) => o2(t6))), n3.some((t6) => t6.type === `BigNumber`) && (n3 = n3.map((t6) => o2(t6)));
    for (var s3 = [a2(1, 0)], l2 = [a2(1, 0)], u2 = 0; u2 < t5.length; u2++) {
      var d2 = t5[u2];
      typeof d2 == `number` && (d2 = a2(d2, 0)), s3 = c2(s3, [a2(1, 0), a2(-d2.re, -d2.im)]);
    }
    for (var p2 = 0; p2 < n3.length; p2++) {
      var m2 = n3[p2];
      typeof m2 == `number` && (m2 = a2(m2, 0)), l2 = c2(l2, [a2(1, 0), a2(-m2.re, -m2.im)]);
    }
    for (var h2 = 0; h2 < s3.length; h2++) s3[h2] = i2(s3[h2], r3);
    return [s3, l2];
  }
  function c2(t5, n3) {
    for (var o3 = [], s3 = 0; s3 < t5.length + n3.length - 1; s3++) {
      o3[s3] = a2(0, 0);
      for (var c3 = 0; c3 < t5.length; c3++) s3 - c3 >= 0 && s3 - c3 < n3.length && (o3[s3] = r2(o3[s3], i2(t5[c3], n3[s3 - c3])));
    }
    return o3;
  }
}), name$30$2 = `freqz`, dependencies$30$2 = [`typed`, `add`, `multiply`, `Complex`, `divide`, `matrix`], createFreqz$2 = factory$2(name$30$2, dependencies$30$2, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, divide: o2, matrix: s2 } = t4;
  return n2(name$30$2, { "Array, Array": function(t5, n3) {
    return c2(t5, n3, l2(512));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return c2(t5, n3, r3);
  }, "Array, Array, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    return c2(t5, n3, l2(r3));
  }, "Matrix, Matrix": function(t5, n3) {
    var r3 = l2(512), { w: i3, h: a3 } = c2(t5.valueOf(), n3.valueOf(), r3);
    return { w: s2(i3), h: s2(a3) };
  }, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var { h: i3 } = c2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return { h: s2(i3), w: s2(r3) };
  }, "Matrix, Matrix, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    var i3 = l2(r3), { h: a3 } = c2(t5.valueOf(), n3.valueOf(), i3);
    return { h: s2(a3), w: s2(i3) };
  } });
  function c2(t5, n3, s3) {
    for (var c3 = [], l3 = [], u2 = 0; u2 < s3.length; u2++) {
      for (var d2 = a2(0, 0), p2 = a2(0, 0), m2 = 0; m2 < t5.length; m2++) d2 = r2(d2, i2(t5[m2], a2(Math.cos(-m2 * s3[u2]), Math.sin(-m2 * s3[u2]))));
      for (var h2 = 0; h2 < n3.length; h2++) p2 = r2(p2, i2(n3[h2], a2(Math.cos(-h2 * s3[u2]), Math.sin(-h2 * s3[u2]))));
      c3.push(d2), l3.push(p2);
    }
    for (var g2 = [], v2 = 0; v2 < c3.length; v2++) g2.push(o2(c3[v2], l3[v2]));
    return { h: g2, w: s3 };
  }
  function l2(t5) {
    for (var n3 = [], r3 = 0; r3 < t5; r3++) n3.push(r3 / t5 * Math.PI);
    return n3;
  }
}), name$29$2 = `reviver`, dependencies$29$2 = [`classes`], createReviver$2 = factory$2(name$29$2, dependencies$29$2, (t4) => {
  var { classes: n2 } = t4;
  return function(t5, r2) {
    var i2 = n2[r2 && r2.mathjs];
    return i2 && typeof i2.fromJSON == `function` ? i2.fromJSON(r2) : r2;
  };
}), name$28$2 = `replacer`, dependencies$28$2 = [], createReplacer$2 = factory$2(name$28$2, dependencies$28$2, () => function(t4, n2) {
  return typeof n2 == `number` && (!Number.isFinite(n2) || isNaN(n2)) ? { mathjs: `number`, value: String(n2) } : typeof n2 == `bigint` ? { mathjs: `bigint`, value: String(n2) } : n2;
}), version$2 = `15.2.0`, createTrue$2 = factory$2(`true`, [], () => true), createFalse$2 = factory$2(`false`, [], () => false), createNull$2 = factory$2(`null`, [], () => null), createInfinity$2 = recreateFactory$2(`Infinity`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1 / 0) : 1 / 0;
}), createNaN$2 = recreateFactory$2(`NaN`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(NaN) : NaN;
}), createPi$2 = recreateFactory$2(`pi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPi$2(r2) : pi$3;
}), createTau$2 = recreateFactory$2(`tau`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberTau$2(r2) : tau$2;
}), createE$2 = recreateFactory$2(`e`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberE$2(r2) : e$3;
}), createPhi$2 = recreateFactory$2(`phi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPhi$2(r2) : phi$2;
}), createLN2$2 = recreateFactory$2(`LN2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).ln() : Math.LN2;
}), createLN10$2 = recreateFactory$2(`LN10`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(10).ln() : Math.LN10;
}), createLOG2E$2 = recreateFactory$2(`LOG2E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(2).ln()) : Math.LOG2E;
}), createLOG10E$2 = recreateFactory$2(`LOG10E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(10).ln()) : Math.LOG10E;
}), createSQRT1_2$2 = recreateFactory$2(`SQRT1_2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(`0.5`).sqrt() : Math.SQRT1_2;
}), createSQRT2$2 = recreateFactory$2(`SQRT2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).sqrt() : Math.SQRT2;
}), createI$2 = recreateFactory$2(`i`, [`Complex`], (t4) => {
  var { Complex: n2 } = t4;
  return n2.I;
}), createUppercasePi$2 = factory$2(`PI`, [`pi`], (t4) => {
  var { pi: n2 } = t4;
  return n2;
}), createUppercaseE$2 = factory$2(`E`, [`e`], (t4) => {
  var { e: n2 } = t4;
  return n2;
}), createVersion$2 = factory$2(`version`, [], () => version$2);
function recreateFactory$2(t4, n2, r2) {
  return factory$2(t4, n2, r2, { recreateOnConfigChange: true });
}
var createSpeedOfLight$2 = unitFactory$2(`speedOfLight`, `299792458`, `m s^-1`), createGravitationConstant$2 = unitFactory$2(`gravitationConstant`, `6.67430e-11`, `m^3 kg^-1 s^-2`), createPlanckConstant$2 = unitFactory$2(`planckConstant`, `6.62607015e-34`, `J s`), createReducedPlanckConstant$2 = unitFactory$2(`reducedPlanckConstant`, `1.0545718176461565e-34`, `J s`), createMagneticConstant$2 = unitFactory$2(`magneticConstant`, `1.25663706212e-6`, `N A^-2`), createElectricConstant$2 = unitFactory$2(`electricConstant`, `8.8541878128e-12`, `F m^-1`), createVacuumImpedance$2 = unitFactory$2(`vacuumImpedance`, `376.730313667`, `ohm`), createCoulomb$2 = unitFactory$2(`coulomb`, `8.987551792261171e9`, `N m^2 C^-2`), createCoulombConstant$2 = unitFactory$2(`coulombConstant`, `8.987551792261171e9`, `N m^2 C^-2`), createElementaryCharge$2 = unitFactory$2(`elementaryCharge`, `1.602176634e-19`, `C`), createBohrMagneton$2 = unitFactory$2(`bohrMagneton`, `9.2740100783e-24`, `J T^-1`), createConductanceQuantum$2 = unitFactory$2(`conductanceQuantum`, `7.748091729863649e-5`, `S`), createInverseConductanceQuantum$2 = unitFactory$2(`inverseConductanceQuantum`, `12906.403729652257`, `ohm`), createMagneticFluxQuantum$2 = unitFactory$2(`magneticFluxQuantum`, `2.0678338484619295e-15`, `Wb`), createNuclearMagneton$2 = unitFactory$2(`nuclearMagneton`, `5.0507837461e-27`, `J T^-1`), createKlitzing$2 = unitFactory$2(`klitzing`, `25812.807459304513`, `ohm`), createBohrRadius$2 = unitFactory$2(`bohrRadius`, `5.29177210903e-11`, `m`), createClassicalElectronRadius$2 = unitFactory$2(`classicalElectronRadius`, `2.8179403262e-15`, `m`), createElectronMass$2 = unitFactory$2(`electronMass`, `9.1093837015e-31`, `kg`), createFermiCoupling$2 = unitFactory$2(`fermiCoupling`, `1.1663787e-5`, `GeV^-2`), createFineStructure$2 = numberFactory$2(`fineStructure`, 0.0072973525693), createHartreeEnergy$2 = unitFactory$2(`hartreeEnergy`, `4.3597447222071e-18`, `J`), createProtonMass$2 = unitFactory$2(`protonMass`, `1.67262192369e-27`, `kg`), createDeuteronMass$2 = unitFactory$2(`deuteronMass`, `3.3435830926e-27`, `kg`), createNeutronMass$2 = unitFactory$2(`neutronMass`, `1.6749271613e-27`, `kg`), createQuantumOfCirculation$2 = unitFactory$2(`quantumOfCirculation`, `3.6369475516e-4`, `m^2 s^-1`), createRydberg$2 = unitFactory$2(`rydberg`, `10973731.568160`, `m^-1`), createThomsonCrossSection$2 = unitFactory$2(`thomsonCrossSection`, `6.6524587321e-29`, `m^2`), createWeakMixingAngle$2 = numberFactory$2(`weakMixingAngle`, 0.2229), createEfimovFactor$2 = numberFactory$2(`efimovFactor`, 22.7), createAtomicMass$2 = unitFactory$2(`atomicMass`, `1.66053906660e-27`, `kg`), createAvogadro$2 = unitFactory$2(`avogadro`, `6.02214076e23`, `mol^-1`), createBoltzmann$2 = unitFactory$2(`boltzmann`, `1.380649e-23`, `J K^-1`), createFaraday$2 = unitFactory$2(`faraday`, `96485.33212331001`, `C mol^-1`), createFirstRadiation$2 = unitFactory$2(`firstRadiation`, `3.7417718521927573e-16`, `W m^2`), createLoschmidt$2 = unitFactory$2(`loschmidt`, `2.686780111798444e25`, `m^-3`), createGasConstant$2 = unitFactory$2(`gasConstant`, `8.31446261815324`, `J K^-1 mol^-1`), createMolarPlanckConstant$2 = unitFactory$2(`molarPlanckConstant`, `3.990312712893431e-10`, `J s mol^-1`), createMolarVolume$2 = unitFactory$2(`molarVolume`, `0.022413969545014137`, `m^3 mol^-1`), createSackurTetrode$2 = numberFactory$2(`sackurTetrode`, -1.16487052358), createSecondRadiation$2 = unitFactory$2(`secondRadiation`, `0.014387768775039337`, `m K`), createStefanBoltzmann$2 = unitFactory$2(`stefanBoltzmann`, `5.67037441918443e-8`, `W m^-2 K^-4`), createWienDisplacement$2 = unitFactory$2(`wienDisplacement`, `2.897771955e-3`, `m K`), createMolarMass$2 = unitFactory$2(`molarMass`, `0.99999999965e-3`, `kg mol^-1`), createMolarMassC12$2 = unitFactory$2(`molarMassC12`, `11.9999999958e-3`, `kg mol^-1`), createGravity$2 = unitFactory$2(`gravity`, `9.80665`, `m s^-2`), createPlanckLength$2 = unitFactory$2(`planckLength`, `1.616255e-35`, `m`), createPlanckMass$2 = unitFactory$2(`planckMass`, `2.176435e-8`, `kg`), createPlanckTime$2 = unitFactory$2(`planckTime`, `5.391245e-44`, `s`), createPlanckCharge$2 = unitFactory$2(`planckCharge`, `1.87554603778e-18`, `C`), createPlanckTemperature$2 = unitFactory$2(`planckTemperature`, `1.416785e+32`, `K`);
function unitFactory$2(t4, n2, r2) {
  return factory$2(t4, [`config`, `Unit`, `BigNumber`], (t5) => {
    var { config: i2, Unit: a2, BigNumber: o2 } = t5, s2 = new a2(i2.number === `BigNumber` ? new o2(n2) : parseFloat(n2), r2);
    return s2.fixPrefix = true, s2;
  });
}
function numberFactory$2(t4, n2) {
  return factory$2(t4, [`config`, `BigNumber`], (t5) => {
    var { config: r2, BigNumber: i2 } = t5;
    return r2.number === `BigNumber` ? new i2(n2) : n2;
  });
}
function ownKeys$7(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$7(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$7(Object(r2), true).forEach(function(n3) {
      _defineProperty$4(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$7(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$27$2 = `mapSlices`, dependencies$27$2 = [`typed`, `isInteger`], createMapSlicesTransform$2 = factory$2(name$27$2, dependencies$27$2, (t4) => {
  var { typed: n2, isInteger: r2 } = t4, i2 = createMapSlices$2({ typed: n2, isInteger: r2 });
  return n2(`mapSlices`, { "...any": function(t5) {
    var n3 = t5[1];
    isNumber$2(n3) ? t5[1] = n3 - 1 : isBigNumber$2(n3) && (t5[1] = n3.minus(1));
    try {
      return i2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, _objectSpread$7({ isTransformFunction: true }, createMapSlices$2.meta)), name$26$2 = `column`, dependencies$26$2 = [`typed`, `Index`, `matrix`, `range`], createColumnTransform$2 = factory$2(name$26$2, dependencies$26$2, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createColumn$2({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`column`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$2(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true });
function compileInlineExpression$2(t4, n2, r2) {
  var i2 = t4.filter(function(t5) {
    return isSymbolNode$2(t5) && !(t5.name in n2) && !r2.has(t5.name);
  })[0];
  if (!i2) throw Error(`No undefined variable found in inline expression "` + t4 + `"`);
  var a2 = i2.name, o2 = /* @__PURE__ */ new Map(), s2 = new PartitionedMap$2(r2, o2, /* @__PURE__ */ new Set([a2])), c2 = t4.compile();
  return function(t5) {
    return o2.set(a2, t5), c2.evaluate(s2);
  };
}
var name$25$2 = `transformCallback`, dependencies$25$2 = [`typed`], createTransformCallback$2 = factory$2(name$25$2, dependencies$25$2, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2) {
    return n2.isTypedFunction(t5) ? r2(t5, i2) : _transformCallbackFunction$2(t5, t5.length, i2);
  };
  function r2(t5, i2) {
    var a2 = Object.fromEntries(Object.entries(t5.signatures).map((t6) => {
      var [a3, o2] = t6, s2 = a3.split(`,`).length;
      return n2.isTypedFunction(o2) ? [a3, r2(o2, i2)] : [a3, _transformCallbackFunction$2(o2, s2, i2)];
    }));
    return typeof t5.name == `string` ? n2(t5.name, a2) : n2(a2);
  }
});
function _transformCallbackFunction$2(t4, n2, r2) {
  return n2 === r2 ? t4 : n2 === r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims$2(n3[r2]);
    return t4(...i2, a2);
  } : n2 > r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims$2(n3[r2]), o2 = n3.slice(r2 + 1);
    return t4(...i2, a2, ...o2);
  } : t4;
}
function _transformDims$2(t4) {
  return t4.map((t5) => t5 + 1);
}
var name$24$2 = `filter`, dependencies$24$2 = [`typed`], createFilterTransform$2 = factory$2(name$24$2, dependencies$24$2, (t4) => {
  var { typed: n2 } = t4;
  function r2(t5, r3, a2) {
    var o2 = createFilter$2({ typed: n2 }), s2 = createTransformCallback$2({ typed: n2 });
    if (t5.length === 0) return o2();
    var c2 = t5[0];
    if (t5.length === 1) return o2(c2);
    var l2 = t5.length - 1, u2 = t5[l2];
    return c2 &&= i2(c2, a2), u2 &&= isSymbolNode$2(u2) || isFunctionAssignmentNode$2(u2) ? i2(u2, a2) : compileInlineExpression$2(u2, r3, a2), o2(c2, s2(u2, l2));
  }
  r2.rawArgs = true;
  function i2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return r2;
}, { isTransformFunction: true }), name$23$2 = `forEach`, dependencies$23$2 = [`typed`], createForEachTransform$2 = factory$2(name$23$2, dependencies$23$2, (t4) => {
  var { typed: n2 } = t4, r2 = createForEach$2({ typed: n2 }), i2 = createTransformCallback$2({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    var s2 = t5[0];
    if (t5.length === 1) return r2(s2);
    var c2 = t5.length - 1, l2 = t5[c2];
    return s2 &&= o2(s2, a3), l2 &&= isSymbolNode$2(l2) || isFunctionAssignmentNode$2(l2) ? o2(l2, a3) : compileInlineExpression$2(l2, n3, a3), r2(s2, i2(l2, c2));
  }
  a2.rawArgs = true;
  function o2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return a2;
}, { isTransformFunction: true }), name$22$2 = `index`, dependencies$22$2 = [`Index`, `getMatrixDataType`], createIndexTransform$2 = factory$2(name$22$2, dependencies$22$2, (t4) => {
  var { Index: n2, getMatrixDataType: r2 } = t4;
  return function() {
    for (var t5 = [], i2 = 0, a2 = arguments.length; i2 < a2; i2++) {
      var o2 = arguments[i2];
      if (isRange$2(o2)) o2.start--, o2.end -= o2.step > 0 ? 0 : 2;
      else if (o2 && o2.isSet === true) o2 = o2.map(function(t6) {
        return t6 - 1;
      });
      else if (isArray$3(o2) || isMatrix$2(o2)) r2(o2) !== `boolean` && (o2 = o2.map(function(t6) {
        return t6 - 1;
      }));
      else if (isNumber$2(o2) || isBigInt$2(o2)) o2--;
      else if (isBigNumber$2(o2)) o2 = o2.toNumber() - 1;
      else if (typeof o2 != `string`) throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      t5[i2] = o2;
    }
    var s2 = new n2();
    return n2.apply(s2, t5), s2;
  };
}, { isTransformFunction: true }), name$21$2 = `map`, dependencies$21$2 = [`typed`], createMapTransform$2 = factory$2(name$21$2, dependencies$21$2, (t4) => {
  var { typed: n2 } = t4, r2 = createMap$3({ typed: n2 }), i2 = createTransformCallback$2({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    if (t5.length === 1) return r2(t5[0]);
    var o2 = t5.length - 1, s2 = t5.slice(0, o2), c2 = t5[o2];
    return s2 = s2.map((t6) => l2(t6, a3)), c2 &&= isSymbolNode$2(c2) || isFunctionAssignmentNode$2(c2) ? l2(c2, a3) : compileInlineExpression$2(c2, n3, a3), r2(...s2, i2(c2, o2));
    function l2(t6, n4) {
      return t6.compile().evaluate(n4);
    }
  }
  return a2.rawArgs = true, a2;
}, { isTransformFunction: true });
function dimToZeroBase$2(t4) {
  return isNumber$2(t4) ? t4 - 1 : isBigNumber$2(t4) ? t4.minus(1) : t4;
}
function isNumberOrBigNumber$2(t4) {
  return isNumber$2(t4) || isBigNumber$2(t4);
}
function lastDimToZeroBase$2(t4) {
  if (t4.length === 2 && isCollection$2(t4[0])) {
    t4 = t4.slice();
    var n2 = t4[1];
    isNumberOrBigNumber$2(n2) && (t4[1] = dimToZeroBase$2(n2));
  }
  return t4;
}
var name$20$2 = `max`, dependencies$20$2 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMaxTransform$2 = factory$2(name$20$2, dependencies$20$2, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4, s2 = createMax$2({ typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 });
  return n2(`max`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$19$2 = `mean`, dependencies$19$2 = [`typed`, `add`, `divide`], createMeanTransform$2 = factory$2(name$19$2, dependencies$19$2, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4, a2 = createMean$2({ typed: n2, add: r2, divide: i2 });
  return n2(`mean`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$18$2 = `min`, dependencies$18$2 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMinTransform$2 = factory$2(name$18$2, dependencies$18$2, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4, s2 = createMin$2({ typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 });
  return n2(`min`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$17$2 = `range`, dependencies$17$2 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRangeTransform$2 = factory$2(name$17$2, dependencies$17$2, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 } = t4, h2 = createRange$2({ typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 });
  return n2(`range`, { "...any": function(t5) {
    return typeof t5[t5.length - 1] != `boolean` && t5.push(true), h2.apply(null, t5);
  } });
}, { isTransformFunction: true }), name$16$2 = `row`, dependencies$16$2 = [`typed`, `Index`, `matrix`, `range`], createRowTransform$2 = factory$2(name$16$2, dependencies$16$2, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createRow$2({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`row`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$2(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$15$2 = `subset`, dependencies$15$2 = [`typed`, `matrix`, `zeros`, `add`], createSubsetTransform$2 = factory$2(name$15$2, dependencies$15$2, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createSubset$2({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(`subset`, { "...any": function(t5) {
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$14$2 = `concat`, dependencies$14$2 = [`typed`, `matrix`, `isInteger`], createConcatTransform$2 = factory$2(name$14$2, dependencies$14$2, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4, a2 = createConcat$2({ typed: n2, matrix: r2, isInteger: i2 });
  return n2(`concat`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$2(r3) ? t5[n3] = r3 - 1 : isBigNumber$2(r3) && (t5[n3] = r3.minus(1));
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$13$2 = `diff`, dependencies$13$2 = [`typed`, `matrix`, `subtract`, `number`, `bignumber`], createDiffTransform$2 = factory$2(name$13$2, dependencies$13$2, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 } = t4, s2 = createDiff$2({ typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 });
  return n2(name$13$2, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$12$2 = `std`, dependencies$12$2 = [`typed`, `map`, `sqrt`, `variance`], createStdTransform$2 = factory$2(name$12$2, dependencies$12$2, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4, o2 = createStd$2({ typed: n2, map: r2, sqrt: i2, variance: a2 });
  return n2(`std`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$11$2 = `sum`, dependencies$11$2 = [`typed`, `config`, `add`, `numeric`], createSumTransform$2 = factory$2(name$11$2, dependencies$11$2, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4, o2 = createSum$2({ typed: n2, config: r2, add: i2, numeric: a2 });
  return n2(name$11$2, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$10$2 = `quantileSeq`, dependencies$10$2 = [`typed`, `bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeqTransform$2 = factory$2(name$10$2, dependencies$10$2, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4, g2 = createQuantileSeq$2({ typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 });
  return n2(`quantileSeq`, { "Array | Matrix, number | BigNumber": g2, "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, number | BigNumber, boolean": g2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)), "Array | Matrix, Array | Matrix": g2, "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, Array | Matrix, boolean": g2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)) });
  function v2(t5) {
    return lastDimToZeroBase$2([[], t5])[1];
  }
}, { isTransformFunction: true }), name$9$2 = `cumsum`, dependencies$9$2 = [`typed`, `add`, `unaryPlus`], createCumSumTransform$2 = factory$2(name$9$2, dependencies$9$2, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4, a2 = createCumSum$2({ typed: n2, add: r2, unaryPlus: i2 });
  return n2(name$9$2, { "...any": function(t5) {
    if (t5.length === 2 && isCollection$2(t5[0])) {
      var n3 = t5[1];
      isNumber$2(n3) ? t5[1] = n3 - 1 : isBigNumber$2(n3) && (t5[1] = n3.minus(1));
    }
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$8$2 = `variance`, dependencies$8$2 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVarianceTransform$2 = factory$2(name$8$2, dependencies$8$2, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4, l2 = createVariance$2({ typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 });
  return n2(name$8$2, { "...any": function(t5) {
    t5 = lastDimToZeroBase$2(t5);
    try {
      return l2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$2(t6);
    }
  } });
}, { isTransformFunction: true }), name$7$2 = `print`, dependencies$7$2 = [`typed`, `matrix`, `zeros`, `add`], createPrintTransform$2 = factory$2(name$7$2, dependencies$7$2, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createPrint$2({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(name$7$2, { "string, Object | Array": function(t5, n3) {
    return o2(s2(t5), n3);
  }, "string, Object | Array, number | Object": function(t5, n3, r3) {
    return o2(s2(t5), n3, r3);
  } });
  function s2(t5) {
    return t5.replace(printTemplate$2, (t6) => `$` + t6.slice(1).split(`.`).map(function(t7) {
      return !isNaN(t7) && t7.length > 0 ? parseInt(t7) - 1 : t7;
    }).join(`.`));
  }
}, { isTransformFunction: true }), name$6$2 = `and`, dependencies$6$2 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createAndTransform$2 = factory$2(name$6$2, dependencies$6$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createAnd$2({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$2(i3) && !c2(i3, true) ? false : c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$5$2 = `or`, dependencies$5$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOrTransform$2 = factory$2(name$5$2, dependencies$5$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createOr$2({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$2(i3) && s2(i3, false) ? true : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$4$2 = `nullish`, dependencies$4$2 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullishTransform$2 = factory$2(name$4$2, dependencies$4$2, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createNullish$2({ typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$2(i3) && i3 != null && i3 !== void 0 ? i3 : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$3$2 = `bitAnd`, dependencies$3$2 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createBitAndTransform$2 = factory$2(name$3$2, dependencies$3$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createBitAnd$2({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection$2(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === 0 || i3 === false) return 0;
    }
    return c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$2$2 = `bitOr`, dependencies$2$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOrTransform$2 = factory$2(name$2$2, dependencies$2$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createBitOr$2({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection$2(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === -1) return -1;
      if (i3 === true) return 1;
    }
    return s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$1$2 = `num`, dependencies$1$2 = [`typed`, `fraction`], createNum$2 = factory$2(name$1$2, dependencies$1$2, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name$1$2, { Fraction: (t5) => t5.s * t5.n, BigNumber: (t5) => {
    var n3 = r2(t5);
    return n3.s * n3.n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), name$e = `den`, dependencies$b = [`typed`, `fraction`], createDen$2 = factory$2(name$e, dependencies$b, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name$e, { Fraction: (t5) => t5.d, BigNumber: (t5) => r2(t5).d, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$3(n3, t5)) });
}), factoriesAny_exports$2 = __exportAll$2({ createAbs: () => createAbs$2, createAccessorNode: () => createAccessorNode$2, createAcos: () => createAcos$2, createAcosh: () => createAcosh$2, createAcot: () => createAcot$2, createAcoth: () => createAcoth$2, createAcsc: () => createAcsc$2, createAcsch: () => createAcsch$2, createAdd: () => createAdd$2, createAddScalar: () => createAddScalar$2, createAnd: () => createAnd$2, createAndTransform: () => createAndTransform$2, createArg: () => createArg$2, createArrayNode: () => createArrayNode$2, createAsec: () => createAsec$2, createAsech: () => createAsech$2, createAsin: () => createAsin$2, createAsinh: () => createAsinh$2, createAssignmentNode: () => createAssignmentNode$2, createAtan: () => createAtan$2, createAtan2: () => createAtan2$2, createAtanh: () => createAtanh$2, createAtomicMass: () => createAtomicMass$2, createAvogadro: () => createAvogadro$2, createBellNumbers: () => createBellNumbers$2, createBernoulli: () => createBernoulli$2, createBigNumberClass: () => createBigNumberClass$2, createBigint: () => createBigint$2, createBignumber: () => createBignumber$2, createBin: () => createBin$2, createBitAnd: () => createBitAnd$2, createBitAndTransform: () => createBitAndTransform$2, createBitNot: () => createBitNot$2, createBitOr: () => createBitOr$2, createBitOrTransform: () => createBitOrTransform$2, createBitXor: () => createBitXor$2, createBlockNode: () => createBlockNode$2, createBohrMagneton: () => createBohrMagneton$2, createBohrRadius: () => createBohrRadius$2, createBoltzmann: () => createBoltzmann$2, createBoolean: () => createBoolean$2, createCatalan: () => createCatalan$2, createCbrt: () => createCbrt$2, createCeil: () => createCeil$2, createChain: () => createChain$2, createChainClass: () => createChainClass$2, createClassicalElectronRadius: () => createClassicalElectronRadius$2, createClone: () => createClone$2, createColumn: () => createColumn$2, createColumnTransform: () => createColumnTransform$2, createCombinations: () => createCombinations$2, createCombinationsWithRep: () => createCombinationsWithRep$2, createCompare: () => createCompare$2, createCompareNatural: () => createCompareNatural$2, createCompareText: () => createCompareText$2, createCompile: () => createCompile$2, createComplex: () => createComplex$2, createComplexClass: () => createComplexClass$2, createComposition: () => createComposition$2, createConcat: () => createConcat$2, createConcatTransform: () => createConcatTransform$2, createConditionalNode: () => createConditionalNode$2, createConductanceQuantum: () => createConductanceQuantum$2, createConj: () => createConj$2, createConstantNode: () => createConstantNode$2, createCorr: () => createCorr$2, createCos: () => createCos$2, createCosh: () => createCosh$2, createCot: () => createCot$2, createCoth: () => createCoth$2, createCoulomb: () => createCoulomb$2, createCoulombConstant: () => createCoulombConstant$2, createCount: () => createCount$2, createCreateUnit: () => createCreateUnit$2, createCross: () => createCross$2, createCsc: () => createCsc$2, createCsch: () => createCsch$2, createCtranspose: () => createCtranspose$2, createCube: () => createCube$2, createCumSum: () => createCumSum$2, createCumSumTransform: () => createCumSumTransform$2, createDeepEqual: () => createDeepEqual$2, createDen: () => createDen$2, createDenseMatrixClass: () => createDenseMatrixClass$2, createDerivative: () => createDerivative$2, createDet: () => createDet$2, createDeuteronMass: () => createDeuteronMass$2, createDiag: () => createDiag$2, createDiff: () => createDiff$2, createDiffTransform: () => createDiffTransform$2, createDistance: () => createDistance$2, createDivide: () => createDivide$2, createDivideScalar: () => createDivideScalar$2, createDot: () => createDot$2, createDotDivide: () => createDotDivide$2, createDotMultiply: () => createDotMultiply$2, createDotPow: () => createDotPow$2, createE: () => createE$2, createEfimovFactor: () => createEfimovFactor$2, createEigs: () => createEigs$2, createElectricConstant: () => createElectricConstant$2, createElectronMass: () => createElectronMass$2, createElementaryCharge: () => createElementaryCharge$2, createEqual: () => createEqual$2, createEqualScalar: () => createEqualScalar$2, createEqualText: () => createEqualText$2, createErf: () => createErf$2, createEvaluate: () => createEvaluate$2, createExp: () => createExp$2, createExpm: () => createExpm$2, createExpm1: () => createExpm1$2, createFactorial: () => createFactorial$2, createFalse: () => createFalse$2, createFaraday: () => createFaraday$2, createFermiCoupling: () => createFermiCoupling$2, createFft: () => createFft$2, createFibonacciHeapClass: () => createFibonacciHeapClass$2, createFilter: () => createFilter$2, createFilterTransform: () => createFilterTransform$2, createFineStructure: () => createFineStructure$2, createFirstRadiation: () => createFirstRadiation$2, createFix: () => createFix$2, createFlatten: () => createFlatten$2, createFloor: () => createFloor$2, createForEach: () => createForEach$2, createForEachTransform: () => createForEachTransform$2, createFormat: () => createFormat$2, createFraction: () => createFraction$2, createFractionClass: () => createFractionClass$2, createFreqz: () => createFreqz$2, createFunctionAssignmentNode: () => createFunctionAssignmentNode$2, createFunctionNode: () => createFunctionNode$2, createGamma: () => createGamma$2, createGasConstant: () => createGasConstant$2, createGcd: () => createGcd$2, createGetMatrixDataType: () => createGetMatrixDataType$2, createGravitationConstant: () => createGravitationConstant$2, createGravity: () => createGravity$2, createHartreeEnergy: () => createHartreeEnergy$2, createHasNumericValue: () => createHasNumericValue$2, createHelp: () => createHelp$2, createHelpClass: () => createHelpClass$2, createHex: () => createHex$2, createHypot: () => createHypot$2, createI: () => createI$2, createIdentity: () => createIdentity$2, createIfft: () => createIfft$2, createIm: () => createIm$2, createImmutableDenseMatrixClass: () => createImmutableDenseMatrixClass$2, createIndex: () => createIndex$2, createIndexClass: () => createIndexClass$2, createIndexNode: () => createIndexNode$2, createIndexTransform: () => createIndexTransform$2, createInfinity: () => createInfinity$2, createIntersect: () => createIntersect$2, createInv: () => createInv$2, createInverseConductanceQuantum: () => createInverseConductanceQuantum$2, createInvmod: () => createInvmod$2, createIsBounded: () => createIsBounded$2, createIsFinite: () => createIsFinite$2, createIsInteger: () => createIsInteger$2, createIsNaN: () => createIsNaN$2, createIsNegative: () => createIsNegative$2, createIsNumeric: () => createIsNumeric$2, createIsPositive: () => createIsPositive$2, createIsPrime: () => createIsPrime$2, createIsZero: () => createIsZero$2, createKldivergence: () => createKldivergence$2, createKlitzing: () => createKlitzing$2, createKron: () => createKron$2, createLN10: () => createLN10$2, createLN2: () => createLN2$2, createLOG10E: () => createLOG10E$2, createLOG2E: () => createLOG2E$2, createLarger: () => createLarger$2, createLargerEq: () => createLargerEq$2, createLcm: () => createLcm$2, createLeafCount: () => createLeafCount$2, createLeftShift: () => createLeftShift$2, createLgamma: () => createLgamma$2, createLog: () => createLog$2, createLog10: () => createLog10$2, createLog1p: () => createLog1p$2, createLog2: () => createLog2$2, createLoschmidt: () => createLoschmidt$2, createLsolve: () => createLsolve$2, createLsolveAll: () => createLsolveAll$2, createLup: () => createLup$2, createLusolve: () => createLusolve$2, createLyap: () => createLyap$2, createMad: () => createMad$2, createMagneticConstant: () => createMagneticConstant$2, createMagneticFluxQuantum: () => createMagneticFluxQuantum$2, createMap: () => createMap$3, createMapSlices: () => createMapSlices$2, createMapSlicesTransform: () => createMapSlicesTransform$2, createMapTransform: () => createMapTransform$2, createMatrix: () => createMatrix$2, createMatrixClass: () => createMatrixClass$2, createMatrixFromColumns: () => createMatrixFromColumns$2, createMatrixFromFunction: () => createMatrixFromFunction$2, createMatrixFromRows: () => createMatrixFromRows$2, createMax: () => createMax$2, createMaxTransform: () => createMaxTransform$2, createMean: () => createMean$2, createMeanTransform: () => createMeanTransform$2, createMedian: () => createMedian$2, createMin: () => createMin$2, createMinTransform: () => createMinTransform$2, createMod: () => createMod$2, createMode: () => createMode$2, createMolarMass: () => createMolarMass$2, createMolarMassC12: () => createMolarMassC12$2, createMolarPlanckConstant: () => createMolarPlanckConstant$2, createMolarVolume: () => createMolarVolume$2, createMultinomial: () => createMultinomial$2, createMultiply: () => createMultiply$2, createMultiplyScalar: () => createMultiplyScalar$2, createNaN: () => createNaN$2, createNeutronMass: () => createNeutronMass$2, createNode: () => createNode$2, createNorm: () => createNorm$2, createNot: () => createNot$2, createNthRoot: () => createNthRoot$2, createNthRoots: () => createNthRoots$2, createNuclearMagneton: () => createNuclearMagneton$2, createNull: () => createNull$2, createNullish: () => createNullish$2, createNullishTransform: () => createNullishTransform$2, createNum: () => createNum$2, createNumber: () => createNumber$2, createNumeric: () => createNumeric$2, createObjectNode: () => createObjectNode$2, createOct: () => createOct$2, createOnes: () => createOnes$2, createOperatorNode: () => createOperatorNode$2, createOr: () => createOr$2, createOrTransform: () => createOrTransform$2, createParenthesisNode: () => createParenthesisNode$2, createParse: () => createParse$2, createParser: () => createParser$2, createParserClass: () => createParserClass$2, createPartitionSelect: () => createPartitionSelect$2, createPermutations: () => createPermutations$2, createPhi: () => createPhi$2, createPi: () => createPi$2, createPickRandom: () => createPickRandom$2, createPinv: () => createPinv$2, createPlanckCharge: () => createPlanckCharge$2, createPlanckConstant: () => createPlanckConstant$2, createPlanckLength: () => createPlanckLength$2, createPlanckMass: () => createPlanckMass$2, createPlanckTemperature: () => createPlanckTemperature$2, createPlanckTime: () => createPlanckTime$2, createPolynomialRoot: () => createPolynomialRoot$2, createPow: () => createPow$2, createPrint: () => createPrint$2, createPrintTransform: () => createPrintTransform$2, createProd: () => createProd$2, createProtonMass: () => createProtonMass$2, createQr: () => createQr$2, createQuantileSeq: () => createQuantileSeq$2, createQuantileSeqTransform: () => createQuantileSeqTransform$2, createQuantumOfCirculation: () => createQuantumOfCirculation$2, createRandom: () => createRandom$2, createRandomInt: () => createRandomInt$2, createRange: () => createRange$2, createRangeClass: () => createRangeClass$2, createRangeNode: () => createRangeNode$2, createRangeTransform: () => createRangeTransform$2, createRationalize: () => createRationalize$2, createRe: () => createRe$2, createReducedPlanckConstant: () => createReducedPlanckConstant$2, createRelationalNode: () => createRelationalNode$2, createReplacer: () => createReplacer$2, createReshape: () => createReshape$2, createResize: () => createResize$2, createResolve: () => createResolve$2, createResultSet: () => createResultSet$2, createReviver: () => createReviver$2, createRightArithShift: () => createRightArithShift$2, createRightLogShift: () => createRightLogShift$2, createRotate: () => createRotate$2, createRotationMatrix: () => createRotationMatrix$2, createRound: () => createRound$2, createRow: () => createRow$2, createRowTransform: () => createRowTransform$2, createRydberg: () => createRydberg$2, createSQRT1_2: () => createSQRT1_2$2, createSQRT2: () => createSQRT2$2, createSackurTetrode: () => createSackurTetrode$2, createSchur: () => createSchur$2, createSec: () => createSec$2, createSech: () => createSech$2, createSecondRadiation: () => createSecondRadiation$2, createSetCartesian: () => createSetCartesian$2, createSetDifference: () => createSetDifference$2, createSetDistinct: () => createSetDistinct$2, createSetIntersect: () => createSetIntersect$2, createSetIsSubset: () => createSetIsSubset$2, createSetMultiplicity: () => createSetMultiplicity$2, createSetPowerset: () => createSetPowerset$2, createSetSize: () => createSetSize$2, createSetSymDifference: () => createSetSymDifference$2, createSetUnion: () => createSetUnion$2, createSign: () => createSign$2, createSimplify: () => createSimplify$2, createSimplifyConstant: () => createSimplifyConstant$2, createSimplifyCore: () => createSimplifyCore$2, createSin: () => createSin$2, createSinh: () => createSinh$2, createSize: () => createSize$2, createSlu: () => createSlu$2, createSmaller: () => createSmaller$2, createSmallerEq: () => createSmallerEq$2, createSolveODE: () => createSolveODE$2, createSort: () => createSort$2, createSpaClass: () => createSpaClass$2, createSparse: () => createSparse$2, createSparseMatrixClass: () => createSparseMatrixClass$2, createSpeedOfLight: () => createSpeedOfLight$2, createSplitUnit: () => createSplitUnit$2, createSqrt: () => createSqrt$2, createSqrtm: () => createSqrtm$2, createSquare: () => createSquare$2, createSqueeze: () => createSqueeze$2, createStd: () => createStd$2, createStdTransform: () => createStdTransform$2, createStefanBoltzmann: () => createStefanBoltzmann$2, createStirlingS2: () => createStirlingS2$2, createString: () => createString$2, createSubset: () => createSubset$2, createSubsetTransform: () => createSubsetTransform$2, createSubtract: () => createSubtract$2, createSubtractScalar: () => createSubtractScalar$2, createSum: () => createSum$2, createSumTransform: () => createSumTransform$2, createSylvester: () => createSylvester$2, createSymbolNode: () => createSymbolNode$2, createSymbolicEqual: () => createSymbolicEqual$2, createTan: () => createTan$2, createTanh: () => createTanh$2, createTau: () => createTau$2, createThomsonCrossSection: () => createThomsonCrossSection$2, createTo: () => createTo$2, createToBest: () => createToBest$2, createTrace: () => createTrace$2, createTranspose: () => createTranspose$2, createTrue: () => createTrue$2, createTypeOf: () => createTypeOf$2, createTyped: () => createTyped$2, createUnaryMinus: () => createUnaryMinus$2, createUnaryPlus: () => createUnaryPlus$2, createUnequal: () => createUnequal$2, createUnitClass: () => createUnitClass$2, createUnitFunction: () => createUnitFunction$2, createUppercaseE: () => createUppercaseE$2, createUppercasePi: () => createUppercasePi$2, createUsolve: () => createUsolve$2, createUsolveAll: () => createUsolveAll$2, createVacuumImpedance: () => createVacuumImpedance$2, createVariance: () => createVariance$2, createVarianceTransform: () => createVarianceTransform$2, createVersion: () => createVersion$2, createWeakMixingAngle: () => createWeakMixingAngle$2, createWienDisplacement: () => createWienDisplacement$2, createXgcd: () => createXgcd$2, createXor: () => createXor$2, createZeros: () => createZeros$2, createZeta: () => createZeta$2, createZpk2tf: () => createZpk2tf$2 }), all$2 = factoriesAny_exports$2, require_tiny_emitter$2 = __commonJSMin$2(((t4, n2) => {
  function r2() {
  }
  r2.prototype = { on: function(t5, n3, r3) {
    var i2 = this.e ||= {};
    return (i2[t5] || (i2[t5] = [])).push({ fn: n3, ctx: r3 }), this;
  }, once: function(t5, n3, r3) {
    var i2 = this;
    function a2() {
      i2.off(t5, a2), n3.apply(r3, arguments);
    }
    return a2._ = n3, this.on(t5, a2, r3);
  }, emit: function(t5) {
    for (var n3 = [].slice.call(arguments, 1), r3 = ((this.e ||= {})[t5] || []).slice(), i2 = 0, a2 = r3.length; i2 < a2; i2++) r3[i2].fn.apply(r3[i2].ctx, n3);
    return this;
  }, off: function(t5, n3) {
    var r3 = this.e ||= {}, i2 = r3[t5], a2 = [];
    if (i2 && n3) for (var o2 = 0, s2 = i2.length; o2 < s2; o2++) i2[o2].fn !== n3 && i2[o2].fn._ !== n3 && a2.push(i2[o2]);
    return a2.length ? r3[t5] = a2 : delete r3[t5], this;
  } }, n2.exports = r2, n2.exports.TinyEmitter = r2;
})), import_tiny_emitter$2 = __toESM$2(require_tiny_emitter$2());
function mixin$1$2(t4) {
  var n2 = new import_tiny_emitter$2.default();
  return t4.on = n2.on.bind(n2), t4.off = n2.off.bind(n2), t4.once = n2.once.bind(n2), t4.emit = n2.emit.bind(n2), t4;
}
function importFactory$2(t4, n2, r2, i2) {
  function a2(t5, n3) {
    var r3 = arguments.length;
    if (r3 !== 1 && r3 !== 2) throw new ArgumentsError$2(`import`, r3, 1, 2);
    n3 ||= {};
    function i3(t6, r4, a4) {
      if (Array.isArray(r4)) r4.forEach((n4) => i3(t6, n4));
      else if (isObject$1$2(r4) || p2(r4)) for (var o3 in r4) hasOwnProperty$1$4(r4, o3) && i3(t6, r4[o3], o3);
      else if (isFactory$2(r4) || a4 !== void 0) {
        var s4 = isFactory$2(r4) ? v2(r4) ? r4.fn + `.transform` : r4.fn : a4;
        if (hasOwnProperty$1$4(t6, s4) && t6[s4] !== r4 && !n3.silent) throw Error(`Cannot import "` + s4 + `" twice`);
        t6[s4] = r4;
      } else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
    var a3 = {};
    for (var s3 in i3(a3, t5), a3) if (hasOwnProperty$1$4(a3, s3)) {
      var c3 = a3[s3];
      if (isFactory$2(c3)) u2(c3, n3);
      else if (d2(c3)) o2(s3, c3, n3);
      else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
  }
  function o2(n3, a3, o3) {
    if (o3.wrap && typeof a3 == `function` && (a3 = l2(a3)), m2(a3) && (a3 = t4(n3, { [a3.signature]: a3 })), t4.isTypedFunction(r2[n3]) && t4.isTypedFunction(a3)) {
      a3 = o3.override ? t4(n3, a3.signatures) : t4(r2[n3], a3), r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    var u3 = r2[n3] !== void 0, d3 = r2.Unit?.isValuelessUnit(n3);
    if (!u3 && !d3 || o3.override) {
      r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    if (!o3.silent) throw Error(`Cannot import "` + n3 + `": already exists`);
  }
  function s2(t5, n3) {
    n3 && typeof n3.transform == `function` ? (r2.expression.transform[t5] = n3.transform, h2(t5) && (r2.expression.mathWithTransform[t5] = n3.transform)) : (delete r2.expression.transform[t5], h2(t5) && (r2.expression.mathWithTransform[t5] = n3));
  }
  function c2(t5) {
    delete r2.expression.transform[t5], h2(t5) ? r2.expression.mathWithTransform[t5] = r2[t5] : delete r2.expression.mathWithTransform[t5];
  }
  function l2(t5) {
    var n3 = function() {
      for (var n4 = [], i3 = 0, a3 = arguments.length; i3 < a3; i3++) {
        var o3 = arguments[i3];
        n4[i3] = o3 && o3.valueOf();
      }
      return t5.apply(r2, n4);
    };
    return t5.transform && (n3.transform = t5.transform), n3;
  }
  function u2(n3, a3) {
    var l3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n3.fn;
    if (l3.includes(`.`)) throw Error(`Factory name should not contain a nested path. Name: ` + JSON.stringify(l3));
    var u3 = v2(n3) ? r2.expression.transform : r2, d3 = l3 in r2.expression.transform, p3 = hasOwnProperty$1$4(u3, l3) ? u3[l3] : void 0, m3 = function() {
      var i3 = {};
      n3.dependencies.map(stripOptionalNotation$2).forEach((t5) => {
        if (t5.includes(`.`)) throw Error(`Factory dependency should not contain a nested path. Name: ` + JSON.stringify(t5));
        t5 === `math` ? i3.math = r2 : t5 === `mathWithTransform` ? i3.mathWithTransform = r2.expression.mathWithTransform : t5 === `classes` ? i3.classes = r2 : i3[t5] = r2[t5];
      });
      var o3 = n3(i3);
      if (o3 && typeof o3.transform == `function`) throw Error(`Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"`);
      if (p3 === void 0 || a3.override) return o3;
      if (t4.isTypedFunction(p3) && t4.isTypedFunction(o3)) return t4(p3, o3);
      if (a3.silent) return p3;
      throw Error(`Cannot import "` + l3 + `": already exists`);
    }, h3 = n3.meta?.formerly ?? ``, y3 = v2(n3) || g2(n3), b2 = r2.expression.mathWithTransform;
    !n3.meta || n3.meta.lazy !== false ? (lazy$2(u3, l3, m3), h3 && lazy$2(u3, h3, m3), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy$2(b2, l3, () => u3[l3]), h3 && lazy$2(b2, h3, () => u3[l3]))) : (u3[l3] = m3(), h3 && (u3[h3] = u3[l3]), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy$2(b2, l3, () => u3[l3]), h3 && lazy$2(b2, h3, () => u3[l3]))), i2[l3] = n3, r2.emit(`import`, l3, m3);
  }
  function d2(t5) {
    return typeof t5 == `function` || typeof t5 == `number` || typeof t5 == `string` || typeof t5 == `boolean` || t5 === null || isUnit$2(t5) || isComplex$2(t5) || isBigNumber$2(t5) || isFraction$2(t5) || isMatrix$2(t5) || Array.isArray(t5);
  }
  function p2(t5) {
    return typeof t5 == `object` && t5[Symbol.toStringTag] === `Module`;
  }
  function m2(t5) {
    return typeof t5 == `function` && typeof t5.signature == `string`;
  }
  function h2(t5) {
    return !hasOwnProperty$1$4(y2, t5);
  }
  function g2(t5) {
    return !t5.fn.includes(`.`) && !hasOwnProperty$1$4(y2, t5.fn) && (!t5.meta || !t5.meta.isClass);
  }
  function v2(t5) {
    return t5 !== void 0 && t5.meta !== void 0 && t5.meta.isTransformFunction === true || false;
  }
  var y2 = { expression: true, type: true, docs: true, error: true, json: true, chain: true };
  return a2;
}
function create$1$2(t4, n2) {
  var r2 = _extends$5({}, DEFAULT_CONFIG$2, n2);
  if (typeof Object.create != `function`) throw Error(`ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.`);
  var i2 = mixin$1$2({ isNumber: isNumber$2, isComplex: isComplex$2, isBigNumber: isBigNumber$2, isBigInt: isBigInt$2, isFraction: isFraction$2, isUnit: isUnit$2, isString: isString$2, isArray: isArray$3, isMatrix: isMatrix$2, isCollection: isCollection$2, isDenseMatrix: isDenseMatrix$2, isSparseMatrix: isSparseMatrix$2, isRange: isRange$2, isIndex: isIndex$2, isBoolean: isBoolean$1$2, isResultSet: isResultSet$2, isHelp: isHelp$2, isFunction: isFunction$1$2, isDate: isDate$3, isRegExp: isRegExp$2, isObject: isObject$1$2, isMap: isMap$3, isPartitionedMap: isPartitionedMap$2, isObjectWrappingMap: isObjectWrappingMap$2, isNull: isNull$1$2, isUndefined: isUndefined$1$2, isAccessorNode: isAccessorNode$2, isArrayNode: isArrayNode$2, isAssignmentNode: isAssignmentNode$2, isBlockNode: isBlockNode$2, isConditionalNode: isConditionalNode$2, isConstantNode: isConstantNode$2, isFunctionAssignmentNode: isFunctionAssignmentNode$2, isFunctionNode: isFunctionNode$2, isIndexNode: isIndexNode$2, isNode: isNode$5, isObjectNode: isObjectNode$2, isOperatorNode: isOperatorNode$2, isParenthesisNode: isParenthesisNode$2, isRangeNode: isRangeNode$2, isRelationalNode: isRelationalNode$2, isSymbolNode: isSymbolNode$2, isChain: isChain$2 });
  i2.config = configFactory$2(r2, i2.emit), i2.expression = { transform: {}, mathWithTransform: { config: i2.config } };
  var a2 = [], o2 = [];
  function s2(t5) {
    if (isFactory$2(t5)) return t5(i2);
    var n3 = t5[Object.keys(t5)[0]];
    if (isFactory$2(n3)) return n3(i2);
    if (!isLegacyFactory$2(t5)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", t5), Error("Factory object with properties `type`, `name`, and `factory` expected");
    var c3 = a2.indexOf(t5), l3;
    return c3 === -1 ? (l3 = t5.math === true ? t5.factory(i2.type, r2, s2, i2.typed, i2) : t5.factory(i2.type, r2, s2, i2.typed), a2.push(t5), o2.push(l3)) : l3 = o2[c3], l3;
  }
  var c2 = {};
  function l2() {
    var t5 = [...arguments];
    return i2.typed.apply(i2.typed, t5);
  }
  l2.isTypedFunction = import_typed_function$2.default.isTypedFunction;
  var u2 = importFactory$2(l2, s2, i2, c2);
  return i2.import = u2, i2.on(`config`, () => {
    Object.values(c2).forEach((t5) => {
      t5 && t5.meta && t5.meta.recreateOnConfigChange && u2(t5, { override: true });
    });
  }), i2.create = create$1$2.bind(null, t4), i2.factory = factory$2, i2.import(Object.values(deepFlatten$2(t4))), i2.ArgumentsError = ArgumentsError$2, i2.DimensionError = DimensionError$2, i2.IndexError = IndexError$2, i2;
}
var require_numeric_1_2_6$2 = __commonJSMin$2(((exports) => {
  var numeric = exports === void 0 ? (function() {
  }) : exports;
  typeof global < `u` && (global.numeric = numeric), numeric.version = `1.2.6`, numeric.bench = function(t4, n2) {
    var r2, i2, a2, o2;
    for (n2 === void 0 && (n2 = 15), a2 = 0.5, r2 = /* @__PURE__ */ new Date(); ; ) {
      for (a2 *= 2, o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
      for (; o2 > 0; ) t4(), o2--;
      if (i2 = /* @__PURE__ */ new Date(), i2 - r2 > n2) break;
    }
    for (o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
    for (; o2 > 0; ) t4(), o2--;
    return i2 = /* @__PURE__ */ new Date(), 1e3 * (3 * a2 - 1) / (i2 - r2);
  }, numeric._myIndexOf = (function(t4) {
    var n2 = this.length, r2;
    for (r2 = 0; r2 < n2; ++r2) if (this[r2] === t4) return r2;
    return -1;
  }), numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(t4) {
    function n2(t5) {
      if (t5 === 0) return `0`;
      if (isNaN(t5)) return `NaN`;
      if (t5 < 0) return `-` + n2(-t5);
      if (isFinite(t5)) {
        var r3 = Math.floor(Math.log(t5) / Math.log(10)), i3 = t5 / 10 ** r3, a2 = i3.toPrecision(numeric.precision);
        return parseFloat(a2) === 10 && (r3++, i3 = 1, a2 = i3.toPrecision(numeric.precision)), parseFloat(a2).toString() + `e` + r3.toString();
      }
      return `Infinity`;
    }
    var r2 = [];
    function i2(t5) {
      var a2;
      if (t5 === void 0) return r2.push(Array(numeric.precision + 8).join(` `)), false;
      if (typeof t5 == `string`) return r2.push(`"` + t5 + `"`), false;
      if (typeof t5 == `boolean`) return r2.push(t5.toString()), false;
      if (typeof t5 == `number`) {
        var o2 = n2(t5), s2 = t5.toPrecision(numeric.precision), c2 = parseFloat(t5.toString()).toString(), l2 = [o2, s2, c2, parseFloat(s2).toString(), parseFloat(c2).toString()];
        for (a2 = 1; a2 < l2.length; a2++) l2[a2].length < o2.length && (o2 = l2[a2]);
        return r2.push(Array(numeric.precision + 8 - o2.length).join(` `) + o2), false;
      }
      if (t5 === null) return r2.push(`null`), false;
      if (typeof t5 == `function`) {
        r2.push(t5.toString());
        var u2 = false;
        for (a2 in t5) t5.hasOwnProperty(a2) && (u2 ? r2.push(`,
`) : r2.push(`
{`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
        return u2 && r2.push(`}
`), true;
      }
      if (t5 instanceof Array) {
        if (t5.length > numeric.largeArray) return r2.push(`...Large Array...`), true;
        var u2 = false;
        for (r2.push(`[`), a2 = 0; a2 < t5.length; a2++) a2 > 0 && (r2.push(`,`), u2 && r2.push(`
 `)), u2 = i2(t5[a2]);
        return r2.push(`]`), true;
      }
      r2.push(`{`);
      var u2 = false;
      for (a2 in t5) t5.hasOwnProperty(a2) && (u2 && r2.push(`,
`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
      return r2.push(`}`), true;
    }
    return i2(t4), r2.join(``);
  }, numeric.parseDate = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return Date.parse(t5.replace(/-/g, `/`));
      if (!(t5 instanceof Array)) throw Error(`parseDate: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseFloat = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return parseFloat(t5);
      if (!(t5 instanceof Array)) throw Error(`parseFloat: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseCSV = function(t4) {
    var n2 = t4.split(`
`), r2, i2, a2 = [], o2 = /(([^'",]*)|('[^']*')|("[^"]*")),/g, s2 = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, c2 = function(t5) {
      return t5.substr(0, t5.length - 1);
    }, l2 = 0;
    for (i2 = 0; i2 < n2.length; i2++) {
      var u2 = (n2[i2] + `,`).match(o2), d2;
      if (u2.length > 0) {
        for (a2[l2] = [], r2 = 0; r2 < u2.length; r2++) d2 = c2(u2[r2]), s2.test(d2) ? a2[l2][r2] = parseFloat(d2) : a2[l2][r2] = d2;
        l2++;
      }
    }
    return a2;
  }, numeric.toCSV = function(t4) {
    var n2 = numeric.dim(t4), r2, i2, a2 = n2[0], s2, c2;
    for (n2[1], c2 = [], r2 = 0; r2 < a2; r2++) {
      for (s2 = [], i2 = 0; i2 < a2; i2++) s2[i2] = t4[r2][i2].toString();
      c2[r2] = s2.join(`, `);
    }
    return c2.join(`
`) + `
`;
  }, numeric.getURL = function(t4) {
    var n2 = new XMLHttpRequest();
    return n2.open(`GET`, t4, false), n2.send(), n2;
  }, numeric.imageURL = function(t4) {
    function n2(t5) {
      var n3 = t5.length, r3, i3, a3, o3, s3, c2, l3, u3, d3 = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=`, p3 = ``;
      for (r3 = 0; r3 < n3; r3 += 3) i3 = t5[r3], a3 = t5[r3 + 1], o3 = t5[r3 + 2], s3 = i3 >> 2, c2 = ((i3 & 3) << 4) + (a3 >> 4), l3 = ((a3 & 15) << 2) + (o3 >> 6), u3 = o3 & 63, r3 + 1 >= n3 ? l3 = u3 = 64 : r3 + 2 >= n3 && (u3 = 64), p3 += d3.charAt(s3) + d3.charAt(c2) + d3.charAt(l3) + d3.charAt(u3);
      return p3;
    }
    function r2(t5, n3, r3) {
      n3 === void 0 && (n3 = 0), r3 === void 0 && (r3 = t5.length);
      var i3 = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], a3 = -1, o3 = 0;
      t5.length;
      var c2;
      for (c2 = n3; c2 < r3; c2++) o3 = (a3 ^ t5[c2]) & 255, a3 = a3 >>> 8 ^ i3[o3];
      return a3 ^ -1;
    }
    var i2 = t4[0].length, a2 = t4[0][0].length, o2, s2, l2, u2, d2, p2, m2, h2, g2, v2, y2 = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, a2 >> 24 & 255, a2 >> 16 & 255, a2 >> 8 & 255, a2 & 255, i2 >> 24 & 255, i2 >> 16 & 255, i2 >> 8 & 255, i2 & 255, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
    for (v2 = r2(y2, 12, 29), y2[29] = v2 >> 24 & 255, y2[30] = v2 >> 16 & 255, y2[31] = v2 >> 8 & 255, y2[32] = v2 & 255, o2 = 1, s2 = 0, m2 = 0; m2 < i2; m2++) {
      for (m2 < i2 - 1 ? y2.push(0) : y2.push(1), d2 = 3 * a2 + 1 + (m2 === 0) & 255, p2 = 3 * a2 + 1 + (m2 === 0) >> 8 & 255, y2.push(d2), y2.push(p2), y2.push(~d2 & 255), y2.push(~p2 & 255), m2 === 0 && y2.push(0), h2 = 0; h2 < a2; h2++) for (l2 = 0; l2 < 3; l2++) d2 = t4[l2][m2][h2], d2 = d2 > 255 ? 255 : d2 < 0 ? 0 : Math.round(d2), o2 = (o2 + d2) % 65521, s2 = (s2 + o2) % 65521, y2.push(d2);
      y2.push(0);
    }
    return g2 = (s2 << 16) + o2, y2.push(g2 >> 24 & 255), y2.push(g2 >> 16 & 255), y2.push(g2 >> 8 & 255), y2.push(g2 & 255), u2 = y2.length - 41, y2[33] = u2 >> 24 & 255, y2[34] = u2 >> 16 & 255, y2[35] = u2 >> 8 & 255, y2[36] = u2 & 255, v2 = r2(y2, 37), y2.push(v2 >> 24 & 255), y2.push(v2 >> 16 & 255), y2.push(v2 >> 8 & 255), y2.push(v2 & 255), y2.push(0), y2.push(0), y2.push(0), y2.push(0), y2.push(73), y2.push(69), y2.push(78), y2.push(68), y2.push(174), y2.push(66), y2.push(96), y2.push(130), `data:image/png;base64,` + n2(y2);
  }, numeric._dim = function(t4) {
    for (var n2 = []; typeof t4 == `object`; ) n2.push(t4.length), t4 = t4[0];
    return n2;
  }, numeric.dim = function(t4) {
    var n2, r2;
    return typeof t4 == `object` ? (n2 = t4[0], typeof n2 == `object` ? (r2 = n2[0], typeof r2 == `object` ? numeric._dim(t4) : [t4.length, n2.length]) : [t4.length]) : [];
  }, numeric.mapreduce = function(t4, n2) {
    return Function(`x`, `accum`, `_s`, `_k`, `if(typeof accum === "undefined") accum = ` + n2 + `;
if(typeof x === "number") { var xi = x; ` + t4 + `; return accum; }
if(typeof _s === "undefined") _s = numeric.dim(x);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i,xi;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) {
        accum = arguments.callee(x[i],accum,_s,_k+1);
    }    return accum;
}
for(i=_n-1;i>=1;i-=2) { 
    xi = x[i];
    ` + t4 + `;
    xi = x[i-1];
    ` + t4 + `;
}
if(i === 0) {
    xi = x[i];
    ` + t4 + `
}
return accum;`);
  }, numeric.mapreduce2 = function(t4, n2) {
    return Function(`x`, `var n = x.length;
var i,xi;
` + n2 + `;
for(i=n-1;i!==-1;--i) { 
    xi = x[i];
    ` + t4 + `;
}
return accum;`);
  }, numeric.same = function t4(n2, r2) {
    var i2, a2;
    if (!(n2 instanceof Array) || !(r2 instanceof Array) || (a2 = n2.length, a2 !== r2.length)) return false;
    for (i2 = 0; i2 < a2; i2++) if (n2[i2] !== r2[i2]) if (typeof n2[i2] == `object`) {
      if (!t4(n2[i2], r2[i2])) return false;
    } else return false;
    return true;
  }, numeric.rep = function(t4, n2, r2) {
    r2 === void 0 && (r2 = 0);
    var i2 = t4[r2], a2 = Array(i2), o2;
    if (r2 === t4.length - 1) {
      for (o2 = i2 - 2; o2 >= 0; o2 -= 2) a2[o2 + 1] = n2, a2[o2] = n2;
      return o2 === -1 && (a2[0] = n2), a2;
    }
    for (o2 = i2 - 1; o2 >= 0; o2--) a2[o2] = numeric.rep(t4, n2, r2 + 1);
    return a2;
  }, numeric.dotMMsmall = function(t4, n2) {
    var r2, i2, a2, o2 = t4.length, s2 = n2.length, c2 = n2[0].length, l2 = Array(o2), u2, d2, p2, m2;
    for (r2 = o2 - 1; r2 >= 0; r2--) {
      for (u2 = Array(c2), d2 = t4[r2], a2 = c2 - 1; a2 >= 0; a2--) {
        for (p2 = d2[s2 - 1] * n2[s2 - 1][a2], i2 = s2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += d2[i2] * n2[i2][a2] + d2[m2] * n2[m2][a2];
        i2 === 0 && (p2 += d2[0] * n2[0][a2]), u2[a2] = p2;
      }
      l2[r2] = u2;
    }
    return l2;
  }, numeric._getCol = function(t4, n2, r2) {
    var i2 = t4.length, a2;
    for (a2 = i2 - 1; a2 > 0; --a2) r2[a2] = t4[a2][n2], --a2, r2[a2] = t4[a2][n2];
    a2 === 0 && (r2[0] = t4[0][n2]);
  }, numeric.dotMMbig = function(t4, n2) {
    var r2 = numeric._getCol, i2 = n2.length, a2 = Array(i2), o2 = t4.length, s2 = n2[0].length, c2 = Array(o2), l2, u2 = numeric.dotVV, d2, p2;
    for (--i2, --o2, d2 = o2; d2 !== -1; --d2) c2[d2] = Array(s2);
    for (--s2, d2 = s2; d2 !== -1; --d2) for (r2(n2, d2, a2), p2 = o2; p2 !== -1; --p2) l2 = t4[p2], c2[p2][d2] = u2(l2, a2);
    return c2;
  }, numeric.dotMV = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2, o2 = Array(r2), s2 = numeric.dotVV;
    for (a2 = r2 - 1; a2 >= 0; a2--) o2[a2] = s2(t4[a2], n2);
    return o2;
  }, numeric.dotVM = function(t4, n2) {
    var i2, a2, o2 = t4.length, s2 = n2[0].length, l2 = Array(s2), p2, m2;
    for (a2 = s2 - 1; a2 >= 0; a2--) {
      for (p2 = t4[o2 - 1] * n2[o2 - 1][a2], i2 = o2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += t4[i2] * n2[i2][a2] + t4[m2] * n2[m2][a2];
      i2 === 0 && (p2 += t4[0] * n2[0][a2]), l2[a2] = p2;
    }
    return l2;
  }, numeric.dotVV = function(t4, n2) {
    var r2, i2 = t4.length, a2, o2 = t4[i2 - 1] * n2[i2 - 1];
    for (r2 = i2 - 2; r2 >= 1; r2 -= 2) a2 = r2 - 1, o2 += t4[r2] * n2[r2] + t4[a2] * n2[a2];
    return r2 === 0 && (o2 += t4[0] * n2[0]), o2;
  }, numeric.dot = function(t4, n2) {
    var r2 = numeric.dim;
    switch (r2(t4).length * 1e3 + r2(n2).length) {
      case 2002:
        return n2.length < 10 ? numeric.dotMMsmall(t4, n2) : numeric.dotMMbig(t4, n2);
      case 2001:
        return numeric.dotMV(t4, n2);
      case 1002:
        return numeric.dotVM(t4, n2);
      case 1001:
        return numeric.dotVV(t4, n2);
      case 1e3:
        return numeric.mulVS(t4, n2);
      case 1:
        return numeric.mulSV(t4, n2);
      case 0:
        return t4 * n2;
      default:
        throw Error(`numeric.dot only works on vectors and matrices`);
    }
  }, numeric.diag = function(t4) {
    var n2, r2, i2, a2 = t4.length, o2 = Array(a2), s2;
    for (n2 = a2 - 1; n2 >= 0; n2--) {
      for (s2 = Array(a2), r2 = n2 + 2, i2 = a2 - 1; i2 >= r2; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      for (i2 > n2 && (s2[i2] = 0), s2[n2] = t4[n2], i2 = n2 - 1; i2 >= 1; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      i2 === 0 && (s2[0] = 0), o2[n2] = s2;
    }
    return o2;
  }, numeric.getDiag = function(t4) {
    var n2 = Math.min(t4.length, t4[0].length), r2, i2 = Array(n2);
    for (r2 = n2 - 1; r2 >= 1; --r2) i2[r2] = t4[r2][r2], --r2, i2[r2] = t4[r2][r2];
    return r2 === 0 && (i2[0] = t4[0][0]), i2;
  }, numeric.identity = function(t4) {
    return numeric.diag(numeric.rep([t4], 1));
  }, numeric.pointwise = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `_s`, i2[t4.length + 1] = `_k`, i2[t4.length + 2] = `if(typeof _s === "undefined") _s = numeric.dim(` + c2 + `);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(` + t4.join(`,`) + `,_s,_k+1);
    return ret;
}
` + r2 + `
for(i=_n-1;i!==-1;--i) {
    ` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric.pointwise2 = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `var _n = ` + c2 + `.length;
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
` + r2 + `
for(i=_n-1;i!==-1;--i) {
` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric._biforeach = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) {
      o2(n2, r2);
      return;
    }
    var s2;
    for (s2 = i2[a2] - 1; s2 >= 0; s2--) t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
  }), numeric._biforeach2 = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) return o2(n2, r2);
    var s2, c2 = i2[a2], l2 = Array(c2);
    for (s2 = c2 - 1; s2 >= 0; --s2) l2[s2] = t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
    return l2;
  }), numeric._foreach = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) {
      a2(n2);
      return;
    }
    var o2;
    for (o2 = r2[i2] - 1; o2 >= 0; o2--) t4(n2[o2], r2, i2 + 1, a2);
  }), numeric._foreach2 = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) return a2(n2);
    var o2, s2 = r2[i2], c2 = Array(s2);
    for (o2 = s2 - 1; o2 >= 0; o2--) c2[o2] = t4(n2[o2], r2, i2 + 1, a2);
    return c2;
  }), numeric.ops2 = { add: `+`, sub: `-`, mul: `*`, div: `/`, mod: `%`, and: `&&`, or: `||`, eq: `===`, neq: `!==`, lt: `<`, gt: `>`, leq: `<=`, geq: `>=`, band: `&`, bor: `|`, bxor: `^`, lshift: `<<`, rshift: `>>`, rrshift: `>>>` }, numeric.opseq = { addeq: `+=`, subeq: `-=`, muleq: `*=`, diveq: `/=`, modeq: `%=`, lshifteq: `<<=`, rshifteq: `>>=`, rrshifteq: `>>>=`, bandeq: `&=`, boreq: `|=`, bxoreq: `^=` }, numeric.mathfuns = [`abs`, `acos`, `asin`, `atan`, `ceil`, `cos`, `exp`, `floor`, `log`, `round`, `sin`, `sqrt`, `tan`, `isNaN`, `isFinite`], numeric.mathfuns2 = [`atan2`, `pow`, `max`, `min`], numeric.ops1 = { neg: `-`, not: `!`, bnot: `~`, clone: `` }, numeric.mapreducers = { any: [`if(xi) return true;`, `var accum = false;`], all: [`if(!xi) return false;`, `var accum = true;`], sum: [`accum += xi;`, `var accum = 0;`], prod: [`accum *= xi;`, `var accum = 1;`], norm2Squared: [`accum += xi*xi;`, `var accum = 0;`], norminf: [`accum = max(accum,abs(xi));`, `var accum = 0, max = Math.max, abs = Math.abs;`], norm1: [`accum += abs(xi)`, `var accum = 0, abs = Math.abs;`], sup: [`accum = max(accum,xi);`, `var accum = -Infinity, max = Math.max;`], inf: [`accum = min(accum,xi);`, `var accum = Infinity, min = Math.min;`] }, (function() {
    var t4, n2;
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], numeric.ops2[n2] = n2;
    for (t4 in numeric.ops2) if (numeric.ops2.hasOwnProperty(t4)) {
      n2 = numeric.ops2[t4];
      var r2, i2, a2 = ``;
      numeric.myIndexOf.call(numeric.mathfuns2, t4) === -1 ? (r2 = function(t5, r3, i3) {
        return t5 + ` = ` + r3 + ` ` + n2 + ` ` + i3;
      }, i2 = numeric.opseq.hasOwnProperty(t4 + `eq`) ? function(t5, r3) {
        return t5 + ` ` + n2 + `= ` + r3;
      } : function(t5, r3) {
        return t5 + ` = ` + t5 + ` ` + n2 + ` ` + r3;
      }) : (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`, r2 = function(t5, r3, i3) {
        return t5 + ` = ` + n2 + `(` + r3 + `,` + i3 + `)`;
      }, i2 = function(t5, r3) {
        return t5 + ` = ` + n2 + `(` + t5 + `,` + r3 + `)`;
      }), numeric[t4 + `VV`] = numeric.pointwise2([`x[i]`, `y[i]`], r2(`ret[i]`, `x[i]`, `y[i]`), a2), numeric[t4 + `SV`] = numeric.pointwise2([`x`, `y[i]`], r2(`ret[i]`, `x`, `y[i]`), a2), numeric[t4 + `VS`] = numeric.pointwise2([`x[i]`, `y`], r2(`ret[i]`, `x[i]`, `y`), a2), numeric[t4] = Function(`var n = arguments.length, i, x = arguments[0], y;
var VV = numeric.` + t4 + `VV, VS = numeric.` + t4 + `VS, SV = numeric.` + t4 + `SV;
var dim = numeric.dim;
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof x === "object") {
      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);
      else x = numeric._biforeach2(x,y,dim(x),0,VS);
  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);
  else ` + i2(`x`, `y`) + `
}
return x;
`), numeric[n2] = numeric[t4], numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`, `x[i]`], i2(`ret[i]`, `x[i]`), a2), numeric[t4 + `eqS`] = numeric.pointwise2([`ret[i]`, `x`], i2(`ret[i]`, `x`), a2), numeric[t4 + `eq`] = Function(`var n = arguments.length, i, x = arguments[0], y;
var V = numeric.` + t4 + `eqV, S = numeric.` + t4 + `eqS
var s = numeric.dim(x);
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);
  else numeric._biforeach(x,y,s,0,S);
}
return x;
`);
    }
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], delete numeric.ops2[n2];
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], numeric.ops1[n2] = n2;
    for (t4 in numeric.ops1) numeric.ops1.hasOwnProperty(t4) && (a2 = ``, n2 = numeric.ops1[t4], numeric.myIndexOf.call(numeric.mathfuns, t4) !== -1 && Math.hasOwnProperty(n2) && (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`), numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`], `ret[i] = ` + n2 + `(ret[i]);`, a2), numeric[t4 + `eq`] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `x
var i;
var V = numeric.` + t4 + `eqV;
var s = numeric.dim(x);
numeric._foreach(x,s,0,V);
return x;
`), numeric[t4 + `V`] = numeric.pointwise2([`x[i]`], `ret[i] = ` + n2 + `(x[i]);`, a2), numeric[t4] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `(x)
var i;
var V = numeric.` + t4 + `V;
var s = numeric.dim(x);
return numeric._foreach2(x,s,0,V);
`));
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], delete numeric.ops1[n2];
    for (t4 in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(t4) && (n2 = numeric.mapreducers[t4], numeric[t4 + `V`] = numeric.mapreduce2(n2[0], n2[1]), numeric[t4] = Function(`x`, `s`, `k`, n2[1] + `if(typeof x !== "object") {    xi = x;
` + n2[0] + `;
    return accum;
}if(typeof s === "undefined") s = numeric.dim(x);
if(typeof k === "undefined") k = 0;
if(k === s.length-1) return numeric.` + t4 + `V(x);
var xi;
var n = x.length, i;
for(i=n-1;i!==-1;--i) {
   xi = arguments.callee(x[i]);
` + n2[0] + `;
}
return accum;
`));
  })(), numeric.truncVV = numeric.pointwise([`x[i]`, `y[i]`], `ret[i] = round(x[i]/y[i])*y[i];`, `var round = Math.round;`), numeric.truncVS = numeric.pointwise([`x[i]`, `y`], `ret[i] = round(x[i]/y)*y;`, `var round = Math.round;`), numeric.truncSV = numeric.pointwise([`x`, `y[i]`], `ret[i] = round(x/y[i])*y[i];`, `var round = Math.round;`), numeric.trunc = function(t4, n2) {
    return typeof t4 == `object` ? typeof n2 == `object` ? numeric.truncVV(t4, n2) : numeric.truncVS(t4, n2) : typeof n2 == `object` ? numeric.truncSV(t4, n2) : Math.round(t4 / n2) * n2;
  }, numeric.inv = function(t4) {
    var n2 = numeric.dim(t4), r2 = Math.abs, i2 = n2[0], a2 = n2[1], o2 = numeric.clone(t4), s2, c2, l2 = numeric.identity(i2), u2, d2, p2, m2, h2, t4;
    for (m2 = 0; m2 < a2; ++m2) {
      var g2 = -1, v2 = -1;
      for (p2 = m2; p2 !== i2; ++p2) h2 = r2(o2[p2][m2]), h2 > v2 && (g2 = p2, v2 = h2);
      for (c2 = o2[g2], o2[g2] = o2[m2], o2[m2] = c2, d2 = l2[g2], l2[g2] = l2[m2], l2[m2] = d2, t4 = c2[m2], h2 = m2; h2 !== a2; ++h2) c2[h2] /= t4;
      for (h2 = a2 - 1; h2 !== -1; --h2) d2[h2] /= t4;
      for (p2 = i2 - 1; p2 !== -1; --p2) if (p2 !== m2) {
        for (s2 = o2[p2], u2 = l2[p2], t4 = s2[m2], h2 = m2 + 1; h2 !== a2; ++h2) s2[h2] -= c2[h2] * t4;
        for (h2 = a2 - 1; h2 > 0; --h2) u2[h2] -= d2[h2] * t4, --h2, u2[h2] -= d2[h2] * t4;
        h2 === 0 && (u2[0] -= d2[0] * t4);
      }
    }
    return l2;
  }, numeric.det = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: det() only works on square matrices`);
    var r2 = n2[0], i2 = 1, a2, o2, s2, c2 = numeric.clone(t4), l2, u2, d2, p2, m2;
    for (o2 = 0; o2 < r2 - 1; o2++) {
      for (s2 = o2, a2 = o2 + 1; a2 < r2; a2++) Math.abs(c2[a2][o2]) > Math.abs(c2[s2][o2]) && (s2 = a2);
      for (s2 !== o2 && (p2 = c2[s2], c2[s2] = c2[o2], c2[o2] = p2, i2 *= -1), l2 = c2[o2], a2 = o2 + 1; a2 < r2; a2++) {
        for (u2 = c2[a2], d2 = u2[o2] / l2[o2], s2 = o2 + 1; s2 < r2 - 1; s2 += 2) m2 = s2 + 1, u2[s2] -= l2[s2] * d2, u2[m2] -= l2[m2] * d2;
        s2 !== r2 && (u2[s2] -= l2[s2] * d2);
      }
      if (l2[o2] === 0) return 0;
      i2 *= l2[o2];
    }
    return i2 * c2[o2][o2];
  }, numeric.transpose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2], --r2, l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = c2[0], l2[n2 - 1] = s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = s2[r2], --r2, o2[r2][0] = s2[r2];
      r2 === 0 && (o2[0][0] = s2[0]);
    }
    return o2;
  }, numeric.negtranspose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2], --r2, l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = -c2[0], l2[n2 - 1] = -s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = -s2[r2], --r2, o2[r2][0] = -s2[r2];
      r2 === 0 && (o2[0][0] = -s2[0]);
    }
    return o2;
  }, numeric._random = function t4(n2, r2) {
    var i2, a2 = n2[r2], o2 = Array(a2), s2;
    if (r2 === n2.length - 1) {
      for (s2 = Math.random, i2 = a2 - 1; i2 >= 1; i2 -= 2) o2[i2] = s2(), o2[i2 - 1] = s2();
      return i2 === 0 && (o2[0] = s2()), o2;
    }
    for (i2 = a2 - 1; i2 >= 0; i2--) o2[i2] = t4(n2, r2 + 1);
    return o2;
  }, numeric.random = function(t4) {
    return numeric._random(t4, 0);
  }, numeric.norm2 = function(t4) {
    return Math.sqrt(numeric.norm2Squared(t4));
  }, numeric.linspace = function(t4, n2, r2) {
    if (r2 === void 0 && (r2 = Math.max(Math.round(n2 - t4) + 1, 1)), r2 < 2) return r2 === 1 ? [t4] : [];
    var i2, a2 = Array(r2);
    for (r2--, i2 = r2; i2 >= 0; i2--) a2[i2] = (i2 * n2 + (r2 - i2) * t4) / r2;
    return a2;
  }, numeric.getBlock = function(t4, n2, r2) {
    var i2 = numeric.dim(t4);
    function a2(t5, o2) {
      var s2, c2 = n2[o2], l2 = r2[o2] - c2, u2 = Array(l2);
      if (o2 === i2.length - 1) {
        for (s2 = l2; s2 >= 0; s2--) u2[s2] = t5[s2 + c2];
        return u2;
      }
      for (s2 = l2; s2 >= 0; s2--) u2[s2] = a2(t5[s2 + c2], o2 + 1);
      return u2;
    }
    return a2(t4, 0);
  }, numeric.setBlock = function(t4, n2, r2, i2) {
    var a2 = numeric.dim(t4);
    function o2(t5, i3, s2) {
      var c2, l2 = n2[s2], u2 = r2[s2] - l2;
      if (s2 === a2.length - 1) for (c2 = u2; c2 >= 0; c2--) t5[c2 + l2] = i3[c2];
      for (c2 = u2; c2 >= 0; c2--) o2(t5[c2 + l2], i3[c2], s2 + 1);
    }
    return o2(t4, i2, 0), t4;
  }, numeric.getRange = function(t4, n2, r2) {
    var i2 = n2.length, a2 = r2.length, o2, s2, c2 = Array(i2), l2, u2;
    for (o2 = i2 - 1; o2 !== -1; --o2) for (c2[o2] = Array(a2), l2 = c2[o2], u2 = t4[n2[o2]], s2 = a2 - 1; s2 !== -1; --s2) l2[s2] = u2[r2[s2]];
    return c2;
  }, numeric.blockMatrix = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length < 4) return numeric.blockMatrix([t4]);
    var r2 = n2[0], i2 = n2[1], a2 = 0, o2 = 0, s2, c2, l2;
    for (s2 = 0; s2 < r2; ++s2) a2 += t4[s2][0].length;
    for (c2 = 0; c2 < i2; ++c2) o2 += t4[0][c2][0].length;
    var u2 = Array(a2);
    for (s2 = 0; s2 < a2; ++s2) u2[s2] = Array(o2);
    var d2 = 0, p2, m2, h2, g2, v2;
    for (s2 = 0; s2 < r2; ++s2) {
      for (p2 = o2, c2 = i2 - 1; c2 !== -1; --c2) for (l2 = t4[s2][c2], p2 -= l2[0].length, h2 = l2.length - 1; h2 !== -1; --h2) for (v2 = l2[h2], m2 = u2[d2 + h2], g2 = v2.length - 1; g2 !== -1; --g2) m2[p2 + g2] = v2[g2];
      d2 += t4[s2][0].length;
    }
    return u2;
  }, numeric.tensor = function(t4, n2) {
    if (typeof t4 == `number` || typeof n2 == `number`) return numeric.mul(t4, n2);
    var r2 = numeric.dim(t4), i2 = numeric.dim(n2);
    if (r2.length !== 1 || i2.length !== 1) throw Error(`numeric: tensor product is only defined for vectors`);
    var a2 = r2[0], o2 = i2[0], s2 = Array(a2), c2, l2, u2, d2;
    for (l2 = a2 - 1; l2 >= 0; l2--) {
      for (c2 = Array(o2), d2 = t4[l2], u2 = o2 - 1; u2 >= 3; --u2) c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2];
      for (; u2 >= 0; ) c2[u2] = d2 * n2[u2], --u2;
      s2[l2] = c2;
    }
    return s2;
  }, numeric.T = function(t4, n2) {
    this.x = t4, this.y = n2;
  }, numeric.t = function(t4, n2) {
    return new numeric.T(t4, n2);
  }, numeric.Tbinop = function(t4, n2, r2, i2, a2) {
    numeric.indexOf;
    if (typeof a2 != `string`) for (var s2 in a2 = ``, numeric) numeric.hasOwnProperty(s2) && (t4.indexOf(s2) >= 0 || n2.indexOf(s2) >= 0 || r2.indexOf(s2) >= 0 || i2.indexOf(s2) >= 0) && s2.length > 1 && (a2 += `var ` + s2 + ` = numeric.` + s2 + `;
`);
    return Function([`y`], `var x = this;
if(!(y instanceof numeric.T)) { y = new numeric.T(y); }
` + a2 + `
if(x.y) {  if(y.y) {    return new numeric.T(` + i2 + `);
  }
  return new numeric.T(` + r2 + `);
}
if(y.y) {
  return new numeric.T(` + n2 + `);
}
return new numeric.T(` + t4 + `);
`);
  }, numeric.T.prototype.add = numeric.Tbinop(`add(x.x,y.x)`, `add(x.x,y.x),y.y`, `add(x.x,y.x),x.y`, `add(x.x,y.x),add(x.y,y.y)`), numeric.T.prototype.sub = numeric.Tbinop(`sub(x.x,y.x)`, `sub(x.x,y.x),neg(y.y)`, `sub(x.x,y.x),x.y`, `sub(x.x,y.x),sub(x.y,y.y)`), numeric.T.prototype.mul = numeric.Tbinop(`mul(x.x,y.x)`, `mul(x.x,y.x),mul(x.x,y.y)`, `mul(x.x,y.x),mul(x.y,y.x)`, `sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))`), numeric.T.prototype.reciprocal = function() {
    var t4 = numeric.mul, n2 = numeric.div;
    if (this.y) {
      var r2 = numeric.add(t4(this.x, this.x), t4(this.y, this.y));
      return new numeric.T(n2(this.x, r2), n2(numeric.neg(this.y), r2));
    }
    return new T(n2(1, this.x));
  }, numeric.T.prototype.div = function(t4) {
    if (t4 instanceof numeric.T || (t4 = new numeric.T(t4)), t4.y) return this.mul(t4.reciprocal());
    var n2 = numeric.div;
    return this.y ? new numeric.T(n2(this.x, t4.x), n2(this.y, t4.x)) : new numeric.T(n2(this.x, t4.x));
  }, numeric.T.prototype.dot = numeric.Tbinop(`dot(x.x,y.x)`, `dot(x.x,y.x),dot(x.x,y.y)`, `dot(x.x,y.x),dot(x.y,y.x)`, `sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))`), numeric.T.prototype.transpose = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), t4(r2)) : new numeric.T(t4(n2));
  }, numeric.T.prototype.transjugate = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), numeric.negtranspose(r2)) : new numeric.T(t4(n2));
  }, numeric.Tunop = function(t4, n2, r2) {
    return typeof r2 != `string` && (r2 = ``), Function(`var x = this;
` + r2 + `
if(x.y) {  ` + n2 + `;
}
` + t4 + `;
`);
  }, numeric.T.prototype.exp = numeric.Tunop(`return new numeric.T(ex)`, `return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))`, `var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;`), numeric.T.prototype.conj = numeric.Tunop(`return new numeric.T(x.x);`, `return new numeric.T(x.x,numeric.neg(x.y));`), numeric.T.prototype.neg = numeric.Tunop(`return new numeric.T(neg(x.x));`, `return new numeric.T(neg(x.x),neg(x.y));`, `var neg = numeric.neg;`), numeric.T.prototype.sin = numeric.Tunop(`return new numeric.T(numeric.sin(x.x))`, `return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));`), numeric.T.prototype.cos = numeric.Tunop(`return new numeric.T(numeric.cos(x.x))`, `return x.exp().add(x.neg().exp()).div(2);`), numeric.T.prototype.abs = numeric.Tunop(`return new numeric.T(numeric.abs(x.x));`, `return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));`, `var mul = numeric.mul;`), numeric.T.prototype.log = numeric.Tunop(`return new numeric.T(numeric.log(x.x));`, `var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();
return new numeric.T(numeric.log(r.x),theta.x);`), numeric.T.prototype.norm2 = numeric.Tunop(`return numeric.norm2(x.x);`, `var f = numeric.norm2Squared;
return Math.sqrt(f(x.x)+f(x.y));`), numeric.T.prototype.inv = function() {
    var t4 = this;
    if (t4.y === void 0) return new numeric.T(numeric.inv(t4.x));
    var n2 = t4.x.length, r2, i2, a2, o2 = numeric.identity(n2), s2 = numeric.rep([n2, n2], 0), c2 = numeric.clone(t4.x), l2 = numeric.clone(t4.y), u2, d2, p2, m2, h2, g2, v2, y2, r2, i2, a2, b2, x2, S2, w2, E, D, O2;
    for (r2 = 0; r2 < n2; r2++) {
      for (S2 = c2[r2][r2], w2 = l2[r2][r2], b2 = S2 * S2 + w2 * w2, a2 = r2, i2 = r2 + 1; i2 < n2; i2++) S2 = c2[i2][r2], w2 = l2[i2][r2], x2 = S2 * S2 + w2 * w2, x2 > b2 && (a2 = i2, b2 = x2);
      for (a2 !== r2 && (O2 = c2[r2], c2[r2] = c2[a2], c2[a2] = O2, O2 = l2[r2], l2[r2] = l2[a2], l2[a2] = O2, O2 = o2[r2], o2[r2] = o2[a2], o2[a2] = O2, O2 = s2[r2], s2[r2] = s2[a2], s2[a2] = O2), u2 = c2[r2], d2 = l2[r2], h2 = o2[r2], g2 = s2[r2], S2 = u2[r2], w2 = d2[r2], i2 = r2 + 1; i2 < n2; i2++) E = u2[i2], D = d2[i2], u2[i2] = (E * S2 + D * w2) / b2, d2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = 0; i2 < n2; i2++) E = h2[i2], D = g2[i2], h2[i2] = (E * S2 + D * w2) / b2, g2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = r2 + 1; i2 < n2; i2++) {
        for (p2 = c2[i2], m2 = l2[i2], v2 = o2[i2], y2 = s2[i2], S2 = p2[r2], w2 = m2[r2], a2 = r2 + 1; a2 < n2; a2++) E = u2[a2], D = d2[a2], p2[a2] -= E * S2 - D * w2, m2[a2] -= D * S2 + E * w2;
        for (a2 = 0; a2 < n2; a2++) E = h2[a2], D = g2[a2], v2[a2] -= E * S2 - D * w2, y2[a2] -= D * S2 + E * w2;
      }
    }
    for (r2 = n2 - 1; r2 > 0; r2--) for (h2 = o2[r2], g2 = s2[r2], i2 = r2 - 1; i2 >= 0; i2--) for (v2 = o2[i2], y2 = s2[i2], S2 = c2[i2][r2], w2 = l2[i2][r2], a2 = n2 - 1; a2 >= 0; a2--) E = h2[a2], D = g2[a2], v2[a2] -= S2 * E - w2 * D, y2[a2] -= S2 * D + w2 * E;
    return new numeric.T(o2, s2);
  }, numeric.T.prototype.get = function(t4) {
    var n2 = this.x, r2 = this.y, i2 = 0, a2, o2 = t4.length;
    if (r2) {
      for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], r2 = r2[a2], i2++;
      return new numeric.T(n2, r2);
    }
    for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], i2++;
    return new numeric.T(n2);
  }, numeric.T.prototype.set = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = 0, o2, s2 = t4.length, c2 = n2.x, l2 = n2.y;
    if (s2 === 0) return l2 ? this.y = l2 : i2 && (this.y = void 0), this.x = r2, this;
    if (l2) {
      for (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2); a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, i2[o2] = l2, this;
    }
    if (i2) {
      for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, c2 instanceof Array ? i2[o2] = numeric.rep(numeric.dim(c2), 0) : i2[o2] = 0, this;
    }
    for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], a2++;
    return o2 = t4[a2], r2[o2] = c2, this;
  }, numeric.T.prototype.getRows = function(t4, n2) {
    var r2 = n2 - t4 + 1, i2, a2 = Array(r2), o2, s2 = this.x, c2 = this.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2 - t4] = s2[i2];
    if (c2) {
      for (o2 = Array(r2), i2 = t4; i2 <= n2; i2++) o2[i2 - t4] = c2[i2];
      return new numeric.T(a2, o2);
    }
    return new numeric.T(a2);
  }, numeric.T.prototype.setRows = function(t4, n2, r2) {
    var i2, a2 = this.x, o2 = this.y, s2 = r2.x, c2 = r2.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2] = s2[i2 - t4];
    if (c2) for (o2 || (o2 = numeric.rep(numeric.dim(a2), 0), this.y = o2), i2 = t4; i2 <= n2; i2++) o2[i2] = c2[i2 - t4];
    else if (o2) for (i2 = t4; i2 <= n2; i2++) o2[i2] = numeric.rep([s2[i2 - t4].length], 0);
    return this;
  }, numeric.T.prototype.getRow = function(t4) {
    var n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(n2[t4], r2[t4]) : new numeric.T(n2[t4]);
  }, numeric.T.prototype.setRow = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = n2.x, o2 = n2.y;
    return r2[t4] = a2, o2 ? (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2), i2[t4] = o2) : i2 &&= numeric.rep([a2.length], 0), this;
  }, numeric.T.prototype.getBlock = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = numeric.getBlock;
    return i2 ? new numeric.T(a2(r2, t4, n2), a2(i2, t4, n2)) : new numeric.T(a2(r2, t4, n2));
  }, numeric.T.prototype.setBlock = function(t4, n2, r2) {
    r2 instanceof numeric.T || (r2 = new numeric.T(r2));
    var i2 = this.x, a2 = this.y, o2 = numeric.setBlock, s2 = r2.x, c2 = r2.y;
    if (c2) return a2 ||= (this.y = numeric.rep(numeric.dim(this), 0), this.y), o2(i2, t4, n2, s2), o2(a2, t4, n2, c2), this;
    o2(i2, t4, n2, s2), a2 && o2(a2, t4, n2, numeric.rep(numeric.dim(s2), 0));
  }, numeric.T.rep = function(t4, n2) {
    var r2 = numeric.T;
    n2 instanceof r2 || (n2 = new r2(n2));
    var i2 = n2.x, a2 = n2.y, o2 = numeric.rep;
    return a2 ? new r2(o2(t4, i2), o2(t4, a2)) : new r2(o2(t4, i2));
  }, numeric.T.diag = function(t4) {
    t4 instanceof numeric.T || (t4 = new numeric.T(t4));
    var n2 = t4.x, r2 = t4.y, i2 = numeric.diag;
    return r2 ? new numeric.T(i2(n2), i2(r2)) : new numeric.T(i2(n2));
  }, numeric.T.eig = function() {
    if (this.y) throw Error(`eig: not implemented for complex matrices.`);
    return numeric.eig(this.x);
  }, numeric.T.identity = function(t4) {
    return new numeric.T(numeric.identity(t4));
  }, numeric.T.prototype.getDiag = function() {
    var t4 = numeric, n2 = this.x, r2 = this.y;
    return r2 ? new t4.T(t4.getDiag(n2), t4.getDiag(r2)) : new t4.T(t4.getDiag(n2));
  }, numeric.house = function(t4) {
    var n2 = numeric.clone(t4), r2 = (t4[0] >= 0 ? 1 : -1) * numeric.norm2(t4);
    n2[0] += r2;
    var i2 = numeric.norm2(n2);
    if (i2 === 0) throw Error(`eig: internal error`);
    return numeric.div(n2, i2);
  }, numeric.toUpperHessenberg = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: toUpperHessenberg() only works on square matrices`);
    var r2 = n2[0], i2, a2, o2, s2, c2, l2 = numeric.clone(t4), u2, d2, p2, m2, h2 = numeric.identity(r2), g2;
    for (a2 = 0; a2 < r2 - 2; a2++) {
      for (s2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) s2[i2 - a2 - 1] = l2[i2][a2];
      if (numeric.norm2(s2) > 0) {
        for (c2 = numeric.house(s2), u2 = numeric.getBlock(l2, [a2 + 1, a2], [r2 - 1, r2 - 1]), d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2 - a2 - 1], o2 = a2; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2];
        for (u2 = numeric.getBlock(l2, [0, a2 + 1], [r2 - 1, r2 - 1]), d2 = numeric.tensor(numeric.dot(u2, c2), c2), i2 = 0; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2], o2 = a2 + 1; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2 - 1];
        for (u2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) u2[i2 - a2 - 1] = h2[i2];
        for (d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (g2 = h2[i2], m2 = d2[i2 - a2 - 1], o2 = 0; o2 < r2; o2++) g2[o2] -= 2 * m2[o2];
      }
    }
    return { H: l2, Q: h2 };
  }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(t4, n2) {
    n2 === void 0 && (n2 = 1e4), t4 = numeric.clone(t4);
    numeric.clone(t4);
    var i2 = numeric.dim(t4)[0], a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = numeric.identity(i2), g2, v2, y2, b2, x2, S2, w2, E, D;
    if (i2 < 3) return { Q: h2, B: [[0, i2 - 1]] };
    var O2 = numeric.epsilon;
    for (D = 0; D < n2; D++) {
      for (w2 = 0; w2 < i2 - 1; w2++) if (Math.abs(t4[w2 + 1][w2]) < O2 * (Math.abs(t4[w2][w2]) + Math.abs(t4[w2 + 1][w2 + 1]))) {
        var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [w2, w2]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [w2 + 1, w2 + 1], [i2 - 1, i2 - 1]), n2);
        for (y2 = Array(w2 + 1), S2 = 0; S2 <= w2; S2++) y2[S2] = h2[S2];
        for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= w2; S2++) h2[S2] = b2[S2];
        for (y2 = Array(i2 - w2 - 1), S2 = w2 + 1; S2 < i2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.dot(M2.Q, y2), S2 = w2 + 1; S2 < i2; S2++) h2[S2] = b2[S2 - w2 - 1];
        return { Q: h2, B: j2.B.concat(numeric.add(M2.B, w2 + 1)) };
      }
      if (s2 = t4[i2 - 2][i2 - 2], c2 = t4[i2 - 2][i2 - 1], l2 = t4[i2 - 1][i2 - 2], u2 = t4[i2 - 1][i2 - 1], p2 = s2 + u2, d2 = s2 * u2 - c2 * l2, m2 = numeric.getBlock(t4, [0, 0], [2, 2]), p2 * p2 >= 4 * d2) {
        var N2 = 0.5 * (p2 + Math.sqrt(p2 * p2 - 4 * d2)), F = 0.5 * (p2 - Math.sqrt(p2 * p2 - 4 * d2));
        m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, N2 + F)), numeric.diag(numeric.rep([3], N2 * F)));
      } else m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, p2)), numeric.diag(numeric.rep([3], d2)));
      for (a2 = [m2[0][0], m2[1][0], m2[2][0]], o2 = numeric.house(a2), y2 = [t4[0], t4[1], t4[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < i2; E++) v2[E] -= 2 * x2[E];
      for (y2 = numeric.getBlock(t4, [0, 0], [i2 - 1, 2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < 3; E++) v2[E] -= 2 * x2[E];
      for (y2 = [h2[0], h2[1], h2[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (g2 = h2[S2], x2 = b2[S2], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      var I2;
      for (w2 = 0; w2 < i2 - 2; w2++) {
        for (E = w2; E <= w2 + 1; E++) if (Math.abs(t4[E + 1][E]) < O2 * (Math.abs(t4[E][E]) + Math.abs(t4[E + 1][E + 1]))) {
          var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [E, E]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [E + 1, E + 1], [i2 - 1, i2 - 1]), n2);
          for (y2 = Array(E + 1), S2 = 0; S2 <= E; S2++) y2[S2] = h2[S2];
          for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= E; S2++) h2[S2] = b2[S2];
          for (y2 = Array(i2 - E - 1), S2 = E + 1; S2 < i2; S2++) y2[S2 - E - 1] = h2[S2];
          for (b2 = numeric.dot(M2.Q, y2), S2 = E + 1; S2 < i2; S2++) h2[S2] = b2[S2 - E - 1];
          return { Q: h2, B: j2.B.concat(numeric.add(M2.B, E + 1)) };
        }
        for (I2 = Math.min(i2 - 1, w2 + 3), a2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) a2[S2 - w2 - 1] = t4[S2][w2];
        for (o2 = numeric.house(a2), y2 = numeric.getBlock(t4, [w2 + 1, w2], [I2, i2 - 1]), b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (v2 = t4[S2], x2 = b2[S2 - w2 - 1], E = w2; E < i2; E++) v2[E] -= 2 * x2[E - w2];
        for (y2 = numeric.getBlock(t4, [0, w2 + 1], [i2 - 1, I2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = w2 + 1; E <= I2; E++) v2[E] -= 2 * x2[E - w2 - 1];
        for (y2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (g2 = h2[S2], x2 = b2[S2 - w2 - 1], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      }
    }
    throw Error(`numeric: eigenvalue iteration does not converge -- increase maxiter?`);
  }, numeric.eig = function(t4, n2) {
    var r2 = numeric.toUpperHessenberg(t4), i2 = numeric.QRFrancis(r2.H, n2), a2 = numeric.T, o2 = t4.length, s2, c2, u2 = i2.B, d2 = numeric.dot(i2.Q, numeric.dot(r2.H, numeric.transpose(i2.Q))), p2 = new a2(numeric.dot(i2.Q, r2.Q)), m2, h2 = u2.length, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2 = Math.sqrt;
    for (c2 = 0; c2 < h2; c2++) if (s2 = u2[c2][0], s2 !== u2[c2][1]) {
      if (g2 = s2 + 1, v2 = d2[s2][s2], y2 = d2[s2][g2], b2 = d2[g2][s2], x2 = d2[g2][g2], y2 === 0 && b2 === 0) continue;
      S2 = -v2 - x2, w2 = v2 * x2 - y2 * b2, E = S2 * S2 - 4 * w2, E >= 0 ? (D = S2 < 0 ? -0.5 * (S2 - I2(E)) : -0.5 * (S2 + I2(E)), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2), j2 = (v2 - D) / N2, M2 = y2 / N2) : (F = I2(F), j2 = b2 / F, M2 = (x2 - D) / F), m2 = new a2([[M2, -j2], [j2, M2]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2)))) : (D = -0.5 * S2, O2 = 0.5 * I2(-E), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2 + O2 * O2), j2 = (v2 - D) / N2, M2 = y2 / N2, D = 0, O2 /= N2) : (F = I2(F + O2 * O2), j2 = b2 / F, M2 = (x2 - D) / F, D = O2 / F, O2 = 0), m2 = new a2([[M2, -j2], [j2, M2]], [[D, O2], [O2, -D]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2))));
    }
    var L2 = p2.dot(t4).dot(p2.transjugate()), o2 = t4.length, R2 = numeric.T.identity(o2);
    for (g2 = 0; g2 < o2; g2++) if (g2 > 0) for (c2 = g2 - 1; c2 >= 0; c2--) {
      var z2 = L2.get([c2, c2]), V2 = L2.get([g2, g2]);
      if (numeric.neq(z2.x, V2.x) || numeric.neq(z2.y, V2.y)) D = L2.getRow(c2).getBlock([c2], [g2 - 1]), O2 = R2.getRow(g2).getBlock([c2], [g2 - 1]), R2.set([g2, c2], L2.get([c2, g2]).neg().sub(D.dot(O2)).div(z2.sub(V2)));
      else {
        R2.setRow(g2, R2.getRow(c2));
        continue;
      }
    }
    for (g2 = 0; g2 < o2; g2++) D = R2.getRow(g2), R2.setRow(g2, D.div(D.norm2()));
    return R2 = R2.transpose(), R2 = p2.transjugate().dot(R2), { lambda: L2.getDiag(), E: R2 };
  }, numeric.ccsSparse = function(t4) {
    var n2 = t4.length, r2, i2, a2, o2, s2 = [];
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) {
      for (o2 = parseInt(o2); o2 >= s2.length; ) s2[s2.length] = 0;
      i2[o2] !== 0 && s2[o2]++;
    }
    var r2 = s2.length, c2 = Array(r2 + 1);
    for (c2[0] = 0, a2 = 0; a2 < r2; ++a2) c2[a2 + 1] = c2[a2] + s2[a2];
    var l2 = Array(c2[r2]), u2 = Array(c2[r2]);
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) i2[o2] !== 0 && (s2[o2]--, l2[c2[o2] + s2[o2]] = a2, u2[c2[o2] + s2[o2]] = i2[o2]);
    return [c2, l2, u2];
  }, numeric.ccsFull = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.ccsDim(t4), o2 = a2[0], s2 = a2[1], c2, l2, u2, d2, m2 = numeric.rep([o2, s2], 0);
    for (c2 = 0; c2 < s2; c2++) for (u2 = n2[c2], d2 = n2[c2 + 1], l2 = u2; l2 < d2; ++l2) m2[r2[l2]][c2] = i2[l2];
    return m2;
  }, numeric.ccsTSolve = function(t4, n2, r2, i2, a2) {
    var o2 = t4[0], s2 = t4[1], c2 = t4[2], l2 = o2.length - 1, u2 = Math.max, d2 = 0;
    i2 === void 0 && (r2 = numeric.rep([l2], 0)), i2 === void 0 && (i2 = numeric.linspace(0, r2.length - 1)), a2 === void 0 && (a2 = []);
    function p2(t5) {
      var n3;
      if (r2[t5] === 0) {
        for (r2[t5] = 1, n3 = o2[t5]; n3 < o2[t5 + 1]; ++n3) p2(s2[n3]);
        a2[d2] = t5, ++d2;
      }
    }
    var m2, h2, g2, v2, y2, b2, w2;
    for (m2 = i2.length - 1; m2 !== -1; --m2) p2(i2[m2]);
    for (a2.length = d2, m2 = a2.length - 1; m2 !== -1; --m2) r2[a2[m2]] = 0;
    for (m2 = i2.length - 1; m2 !== -1; --m2) h2 = i2[m2], r2[h2] = n2[h2];
    for (m2 = a2.length - 1; m2 !== -1; --m2) {
      for (h2 = a2[m2], g2 = o2[h2], v2 = u2(o2[h2 + 1], g2), y2 = g2; y2 !== v2; ++y2) if (s2[y2] === h2) {
        r2[h2] /= c2[y2];
        break;
      }
      for (w2 = r2[h2], y2 = g2; y2 !== v2; ++y2) b2 = s2[y2], b2 !== h2 && (r2[b2] -= w2 * c2[y2]);
    }
    return r2;
  }, numeric.ccsDFS = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS.prototype.dfs = function(t4, n2, r2, i2, a2, o2) {
    var s2 = 0, c2, l2 = a2.length, u2 = this.k, d2 = this.k1, p2 = this.j, m2, h2;
    if (i2[t4] === 0) for (i2[t4] = 1, p2[0] = t4, u2[0] = m2 = n2[t4], d2[0] = h2 = n2[t4 + 1]; ; ) if (m2 >= h2) {
      if (a2[l2] = p2[s2], s2 === 0) return;
      ++l2, --s2, m2 = u2[s2], h2 = d2[s2];
    } else c2 = o2[r2[m2]], i2[c2] === 0 ? (i2[c2] = 1, u2[s2] = m2, ++s2, p2[s2] = c2, m2 = n2[c2], d2[s2] = h2 = n2[c2 + 1]) : ++m2;
  }, numeric.ccsLPSolve = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = t4[0], l2 = t4[1], u2 = t4[2];
    c2.length - 1;
    var m2 = n2[0], h2 = n2[1], g2 = n2[2], v2, y2 = m2[a2], b2 = m2[a2 + 1], x2, w2, E, D, O2, N2;
    for (i2.length = 0, v2 = y2; v2 < b2; ++v2) s2.dfs(o2[h2[v2]], c2, l2, r2, i2, o2);
    for (v2 = i2.length - 1; v2 !== -1; --v2) r2[i2[v2]] = 0;
    for (v2 = y2; v2 !== b2; ++v2) x2 = o2[h2[v2]], r2[x2] = g2[v2];
    for (v2 = i2.length - 1; v2 !== -1; --v2) {
      for (x2 = i2[v2], w2 = c2[x2], E = c2[x2 + 1], D = w2; D < E; ++D) if (o2[l2[D]] === x2) {
        r2[x2] /= u2[D];
        break;
      }
      for (N2 = r2[x2], D = w2; D < E; ++D) O2 = o2[l2[D]], O2 !== x2 && (r2[O2] -= N2 * u2[D]);
    }
    return r2;
  }, numeric.ccsLUP1 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[v2]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[h2]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2, x2 = p2[h2], p2[h2] = p2[S2], p2[S2] = x2), x2 = o2[h2], S2 = l2[h2], E = p2[h2], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[v2], m2[g2] = 0, p2[v2] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsDFS0 = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS0.prototype.dfs = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = 0, l2, u2 = a2.length, d2 = this.k, p2 = this.k1, m2 = this.j, h2, g2;
    if (i2[t4] === 0) for (i2[t4] = 1, m2[0] = t4, d2[0] = h2 = n2[o2[t4]], p2[0] = g2 = n2[o2[t4] + 1]; ; ) {
      if (isNaN(h2)) throw Error(`Ow!`);
      if (h2 >= g2) {
        if (a2[u2] = o2[m2[c2]], c2 === 0) return;
        ++u2, --c2, h2 = d2[c2], g2 = p2[c2];
      } else l2 = r2[h2], i2[l2] === 0 ? (i2[l2] = 1, d2[c2] = h2, ++c2, m2[c2] = l2, l2 = o2[l2], h2 = n2[l2], p2[c2] = g2 = n2[l2 + 1]) : ++h2;
    }
  }, numeric.ccsLPSolve0 = function(t4, n2, r2, i2, a2, o2, s2, c2) {
    var l2 = t4[0], u2 = t4[1], d2 = t4[2];
    l2.length - 1;
    var h2 = n2[0], g2 = n2[1], v2 = n2[2], y2, b2 = h2[a2], x2 = h2[a2 + 1], S2, E, D, O2, j2, F;
    for (i2.length = 0, y2 = b2; y2 < x2; ++y2) c2.dfs(g2[y2], l2, u2, r2, i2, o2, s2);
    for (y2 = i2.length - 1; y2 !== -1; --y2) S2 = i2[y2], r2[s2[S2]] = 0;
    for (y2 = b2; y2 !== x2; ++y2) S2 = g2[y2], r2[S2] = v2[y2];
    for (y2 = i2.length - 1; y2 !== -1; --y2) {
      for (S2 = i2[y2], j2 = s2[S2], E = l2[S2], D = l2[S2 + 1], O2 = E; O2 < D; ++O2) if (u2[O2] === j2) {
        r2[j2] /= d2[O2];
        break;
      }
      for (F = r2[j2], O2 = E; O2 < D; ++O2) r2[u2[O2]] -= F * d2[O2];
      r2[j2] = F;
    }
  }, numeric.ccsLUP0 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve0, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS0(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, N2, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[N2[v2]]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[N2[h2]]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2), x2 = o2[h2], S2 = l2[h2], E = p2[N2[h2]], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[N2[v2]], m2[g2] = 0, p2[N2[v2]] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(t4) {
    return [numeric.sup(t4[1]) + 1, t4[0].length - 1];
  }, numeric.ccsGetBlock = function(t4, n2, r2) {
    var i2 = numeric.ccsDim(t4), a2 = i2[0], o2 = i2[1];
    n2 === void 0 ? n2 = numeric.linspace(0, a2 - 1) : typeof n2 == `number` && (n2 = [n2]), r2 === void 0 ? r2 = numeric.linspace(0, o2 - 1) : typeof r2 == `number` && (r2 = [r2]);
    var s2, u2 = n2.length, d2, p2 = r2.length, m2, h2, g2, v2 = numeric.rep([o2], 0), y2 = [], b2 = [], x2 = [v2, y2, b2], S2 = t4[0], w2 = t4[1], E = t4[2], D = numeric.rep([a2], 0), O2 = 0, j2 = numeric.rep([a2], 0);
    for (d2 = 0; d2 < p2; ++d2) {
      h2 = r2[d2];
      var M2 = S2[h2], N2 = S2[h2 + 1];
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 1, D[m2] = E[s2];
      for (s2 = 0; s2 < u2; ++s2) g2 = n2[s2], j2[g2] && (y2[O2] = s2, b2[O2] = D[n2[s2]], ++O2);
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 0;
      v2[d2 + 1] = O2;
    }
    return x2;
  }, numeric.ccsDot = function(t4, n2) {
    var r2 = t4[0], i2 = t4[1], a2 = t4[2], o2 = n2[0], s2 = n2[1], c2 = n2[2], l2 = numeric.ccsDim(t4), u2 = numeric.ccsDim(n2), d2 = l2[0];
    l2[1];
    var m2 = u2[1], h2 = numeric.rep([d2], 0), g2 = numeric.rep([d2], 0), v2 = Array(d2), y2 = numeric.rep([m2], 0), b2 = [], x2 = [], S2 = [y2, b2, x2], w2, E, D, O2, j2, M2, N2, F, I2, L2, R2;
    for (D = 0; D !== m2; ++D) {
      for (O2 = o2[D], j2 = o2[D + 1], I2 = 0, E = O2; E < j2; ++E) for (L2 = s2[E], R2 = c2[E], M2 = r2[L2], N2 = r2[L2 + 1], w2 = M2; w2 < N2; ++w2) F = i2[w2], g2[F] === 0 && (v2[I2] = F, g2[F] = 1, I2 += 1), h2[F] = h2[F] + a2[w2] * R2;
      for (O2 = y2[D], j2 = O2 + I2, y2[D + 1] = j2, E = I2 - 1; E !== -1; --E) R2 = O2 + E, w2 = v2[E], b2[R2] = w2, x2[R2] = h2[w2], g2[w2] = 0, h2[w2] = 0;
      y2[D + 1] = y2[D] + I2;
    }
    return S2;
  }, numeric.ccsLUPSolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U;
    t4.P;
    var o2 = n2[0], s2 = false;
    typeof o2 != `object` && (n2 = [[0, n2.length], numeric.linspace(0, n2.length - 1), n2], o2 = n2[0], s2 = true);
    var c2 = n2[1], l2 = n2[2], u2 = r2[0].length - 1, d2 = o2.length - 1, p2 = numeric.rep([u2], 0), m2 = Array(u2), h2 = numeric.rep([u2], 0), g2 = Array(u2), v2 = numeric.rep([d2 + 1], 0), y2 = [], b2 = [], x2 = numeric.ccsTSolve, S2, w2, E, D, O2, j2, M2 = 0;
    for (S2 = 0; S2 < d2; ++S2) {
      for (O2 = 0, E = o2[S2], D = o2[S2 + 1], w2 = E; w2 < D; ++w2) j2 = t4.Pinv[c2[w2]], g2[O2] = j2, h2[j2] = l2[w2], ++O2;
      for (g2.length = O2, x2(r2, h2, p2, g2, m2), w2 = g2.length - 1; w2 !== -1; --w2) h2[g2[w2]] = 0;
      if (x2(i2, p2, h2, m2, g2), s2) return h2;
      for (w2 = m2.length - 1; w2 !== -1; --w2) p2[m2[w2]] = 0;
      for (w2 = g2.length - 1; w2 !== -1; --w2) j2 = g2[w2], y2[M2] = j2, b2[M2] = h2[j2], h2[j2] = 0, ++M2;
      v2[S2 + 1] = M2;
    }
    return [v2, y2, b2];
  }, numeric.ccsbinop = function(t4, n2) {
    return n2 === void 0 && (n2 = ``), Function(`X`, `Y`, `var Xi = X[0], Xj = X[1], Xv = X[2];
var Yi = Y[0], Yj = Y[1], Yv = Y[2];
var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;
var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];
var x = numeric.rep([m],0),y = numeric.rep([m],0);
var xk,yk,zk;
var i,j,j0,j1,k,p=0;
` + n2 + `for(i=0;i<n;++i) {
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Xj[j];
    x[k] = 1;
    Zj[p] = k;
    ++p;
  }
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Yj[j];
    y[k] = Yv[j];
    if(x[k] === 0) {
      Zj[p] = k;
      ++p;
    }
  }
  Zi[i+1] = p;
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];
  j0 = Zi[i]; j1 = Zi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Zj[j];
    xk = x[k];
    yk = y[k];
` + t4 + `
    Zv[j] = zk;
  }
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;
}
return [Zi,Zj,Zv];`);
  }, (function() {
    var k, A, B, C;
    for (k in numeric.ops2) A = isFinite(eval(`1` + numeric.ops2[k] + `0`)) ? `[Y[0],Y[1],numeric.` + k + `(X,Y[2])]` : `NaN`, B = isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `[X[0],X[1],numeric.` + k + `(X[2],Y)]` : `NaN`, C = isFinite(eval(`1` + numeric.ops2[k] + `0`)) && isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `numeric.ccs` + k + `MM(X,Y)` : `NaN`, numeric[`ccs` + k + `MM`] = numeric.ccsbinop(`zk = xk ` + numeric.ops2[k] + `yk;`), numeric[`ccs` + k] = Function(`X`, `Y`, `if(typeof X === "number") return ` + A + `;
if(typeof Y === "number") return ` + B + `;
return ` + C + `;
`);
  })(), numeric.ccsScatter = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.sup(r2) + 1, o2 = n2.length, s2 = numeric.rep([a2], 0), c2 = Array(o2), l2 = Array(o2), u2 = numeric.rep([a2], 0), d2;
    for (d2 = 0; d2 < o2; ++d2) u2[r2[d2]]++;
    for (d2 = 0; d2 < a2; ++d2) s2[d2 + 1] = s2[d2] + u2[d2];
    var p2 = s2.slice(0), m2, h2;
    for (d2 = 0; d2 < o2; ++d2) h2 = r2[d2], m2 = p2[h2], c2[m2] = n2[d2], l2[m2] = i2[d2], p2[h2] = p2[h2] + 1;
    return [s2, c2, l2];
  }, numeric.ccsGather = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length - 1, o2 = r2.length, s2 = Array(o2), c2 = Array(o2), l2 = Array(o2), u2, d2, p2, m2, h2 = 0;
    for (u2 = 0; u2 < a2; ++u2) for (p2 = n2[u2], m2 = n2[u2 + 1], d2 = p2; d2 !== m2; ++d2) c2[h2] = u2, s2[h2] = r2[d2], l2[h2] = i2[d2], ++h2;
    return [s2, c2, l2];
  }, numeric.sdim = function t4(n2, r2, i2) {
    if (r2 === void 0 && (r2 = []), typeof n2 != `object`) return r2;
    for (var a2 in i2 === void 0 && (i2 = 0), i2 in r2 || (r2[i2] = 0), n2.length > r2[i2] && (r2[i2] = n2.length), n2) n2.hasOwnProperty(a2) && t4(n2[a2], r2, i2 + 1);
    return r2;
  }, numeric.sclone = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = 0), i2 === void 0 && (i2 = numeric.sdim(n2).length);
    var a2, o2 = Array(n2.length);
    if (r2 === i2 - 1) {
      for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = n2[a2]);
      return o2;
    }
    for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = t4(n2[a2], r2 + 1, i2));
    return o2;
  }, numeric.sdiag = function(t4) {
    var n2 = t4.length, r2, i2 = Array(n2), a2;
    for (r2 = n2 - 1; r2 >= 1; r2 -= 2) a2 = r2 - 1, i2[r2] = [], i2[r2][r2] = t4[r2], i2[a2] = [], i2[a2][a2] = t4[a2];
    return r2 === 0 && (i2[0] = [], i2[0][0] = t4[r2]), i2;
  }, numeric.sidentity = function(t4) {
    return numeric.sdiag(numeric.rep([t4], 1));
  }, numeric.stranspose = function(t4) {
    var n2 = [];
    t4.length;
    var i2, a2, o2;
    for (i2 in t4) if (t4.hasOwnProperty(i2)) for (a2 in o2 = t4[i2], o2) o2.hasOwnProperty(a2) && (typeof n2[a2] != `object` && (n2[a2] = []), n2[a2][i2] = o2[a2]);
    return n2;
  }, numeric.sLUP = function(t4, n2) {
    throw Error(`The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.`);
  }, numeric.sdotMM = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2 = numeric.stranspose(n2), o2 = a2.length, s2, c2, l2, u2, d2, p2, m2 = Array(r2), h2;
    for (l2 = r2 - 1; l2 >= 0; l2--) {
      for (h2 = [], s2 = t4[l2], d2 = o2 - 1; d2 >= 0; d2--) {
        for (u2 in p2 = 0, c2 = a2[d2], s2) s2.hasOwnProperty(u2) && u2 in c2 && (p2 += s2[u2] * c2[u2]);
        p2 && (h2[d2] = p2);
      }
      m2[l2] = h2;
    }
    return m2;
  }, numeric.sdotMV = function(t4, n2) {
    var r2 = t4.length, i2, a2, o2, s2 = Array(r2), c2;
    for (a2 = r2 - 1; a2 >= 0; a2--) {
      for (o2 in i2 = t4[a2], c2 = 0, i2) i2.hasOwnProperty(o2) && n2[o2] && (c2 += i2[o2] * n2[o2]);
      c2 && (s2[a2] = c2);
    }
    return s2;
  }, numeric.sdotVM = function(t4, n2) {
    var r2, i2, a2, o2, s2 = [];
    for (r2 in t4) if (t4.hasOwnProperty(r2)) for (i2 in a2 = n2[r2], o2 = t4[r2], a2) a2.hasOwnProperty(i2) && (s2[i2] || (s2[i2] = 0), s2[i2] += o2 * a2[i2]);
    return s2;
  }, numeric.sdotVV = function(t4, n2) {
    var r2, i2 = 0;
    for (r2 in t4) t4[r2] && n2[r2] && (i2 += t4[r2] * n2[r2]);
    return i2;
  }, numeric.sdot = function(t4, n2) {
    var r2 = numeric.sdim(t4).length, i2 = numeric.sdim(n2).length;
    switch (r2 * 1e3 + i2) {
      case 0:
        return t4 * n2;
      case 1001:
        return numeric.sdotVV(t4, n2);
      case 2001:
        return numeric.sdotMV(t4, n2);
      case 1002:
        return numeric.sdotVM(t4, n2);
      case 2002:
        return numeric.sdotMM(t4, n2);
      default:
        throw Error(`numeric.sdot not implemented for tensors of order ` + r2 + ` and ` + i2);
    }
  }, numeric.sscatter = function(t4) {
    var n2 = t4[0].length, r2, i2, a2, o2 = t4.length, s2 = [], c2;
    for (i2 = n2 - 1; i2 >= 0; --i2) if (t4[o2 - 1][i2]) {
      for (c2 = s2, a2 = 0; a2 < o2 - 2; a2++) r2 = t4[a2][i2], c2[r2] || (c2[r2] = []), c2 = c2[r2];
      c2[t4[a2][i2]] = t4[a2 + 1][i2];
    }
    return s2;
  }, numeric.sgather = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = []), i2 === void 0 && (i2 = []);
    var a2 = i2.length, o2, s2;
    for (o2 in n2) if (n2.hasOwnProperty(o2)) if (i2[a2] = parseInt(o2), s2 = n2[o2], typeof s2 == `number`) {
      if (s2) {
        if (r2.length === 0) for (o2 = a2 + 1; o2 >= 0; --o2) r2[o2] = [];
        for (o2 = a2; o2 >= 0; --o2) r2[o2].push(i2[o2]);
        r2[a2 + 1].push(s2);
      }
    } else t4(s2, r2, i2);
    return i2.length > a2 && i2.pop(), r2;
  }, numeric.cLU = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length, o2 = 0, s2, c2, l2, u2, d2, p2;
    for (s2 = 0; s2 < a2; s2++) n2[s2] > o2 && (o2 = n2[s2]);
    o2++;
    var m2 = Array(o2), h2 = Array(o2), g2 = numeric.rep([o2], 1 / 0), v2 = numeric.rep([o2], -1 / 0), y2, b2, x2;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], c2 = r2[l2], c2 < g2[s2] && (g2[s2] = c2), c2 > v2[s2] && (v2[s2] = c2);
    for (s2 = 0; s2 < o2 - 1; s2++) v2[s2] > v2[s2 + 1] && (v2[s2 + 1] = v2[s2]);
    for (s2 = o2 - 1; s2 >= 1; s2--) g2[s2] < g2[s2 - 1] && (g2[s2 - 1] = g2[s2]);
    var S2 = 0, w2 = 0;
    for (s2 = 0; s2 < o2; s2++) h2[s2] = numeric.rep([v2[s2] - g2[s2] + 1], 0), m2[s2] = numeric.rep([s2 - g2[s2]], 0), S2 += s2 - g2[s2] + 1, w2 += v2[s2] - s2 + 1;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], h2[s2][r2[l2] - g2[s2]] = i2[l2];
    for (s2 = 0; s2 < o2 - 1; s2++) for (u2 = s2 - g2[s2], y2 = h2[s2], c2 = s2 + 1; g2[c2] <= s2 && c2 < o2; c2++) if (d2 = s2 - g2[c2], p2 = v2[s2] - s2, b2 = h2[c2], x2 = b2[d2] / y2[u2], x2) {
      for (l2 = 1; l2 <= p2; l2++) b2[l2 + d2] -= x2 * y2[l2 + u2];
      m2[c2][s2 - g2[c2]] = x2;
    }
    var y2 = [], b2 = [], E = [], D = [], O2 = [], j2 = [], a2 = 0, M2 = 0, N2;
    for (s2 = 0; s2 < o2; s2++) {
      for (u2 = g2[s2], d2 = v2[s2], N2 = h2[s2], c2 = s2; c2 <= d2; c2++) N2[c2 - u2] && (y2[a2] = s2, b2[a2] = c2, E[a2] = N2[c2 - u2], a2++);
      for (N2 = m2[s2], c2 = u2; c2 < s2; c2++) N2[c2 - u2] && (D[M2] = s2, O2[M2] = c2, j2[M2] = N2[c2 - u2], M2++);
      D[M2] = s2, O2[M2] = s2, j2[M2] = 1, M2++;
    }
    return { U: [y2, b2, E], L: [D, O2, j2] };
  }, numeric.cLUsolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U, a2 = numeric.clone(n2), o2 = r2[0], s2 = r2[1], c2 = r2[2], l2 = i2[0], u2 = i2[1], d2 = i2[2], p2 = l2.length;
    o2.length;
    var h2 = a2.length, g2, y2 = 0;
    for (g2 = 0; g2 < h2; g2++) {
      for (; s2[y2] < g2; ) a2[g2] -= c2[y2] * a2[s2[y2]], y2++;
      y2++;
    }
    for (y2 = p2 - 1, g2 = h2 - 1; g2 >= 0; g2--) {
      for (; u2[y2] > g2; ) a2[g2] -= d2[y2] * a2[u2[y2]], y2--;
      a2[g2] /= d2[y2], y2--;
    }
    return a2;
  }, numeric.cgrid = function(t4, n2) {
    typeof t4 == `number` && (t4 = [t4, t4]);
    var r2 = numeric.rep(t4, -1), i2, a2, o2;
    if (typeof n2 != `function`) switch (n2) {
      case `L`:
        n2 = function(n3, r3) {
          return n3 >= t4[0] / 2 || r3 < t4[1] / 2;
        };
        break;
      default:
        n2 = function(t5, n3) {
          return true;
        };
        break;
    }
    for (o2 = 0, i2 = 1; i2 < t4[0] - 1; i2++) for (a2 = 1; a2 < t4[1] - 1; a2++) n2(i2, a2) && (r2[i2][a2] = o2, o2++);
    return r2;
  }, numeric.cdelsq = function(t4) {
    var n2 = [[-1, 0], [0, -1], [0, 1], [1, 0]], r2 = numeric.dim(t4), i2 = r2[0], a2 = r2[1], o2, s2, c2, l2, u2, d2 = [], p2 = [], m2 = [];
    for (o2 = 1; o2 < i2 - 1; o2++) for (s2 = 1; s2 < a2 - 1; s2++) if (!(t4[o2][s2] < 0)) {
      for (c2 = 0; c2 < 4; c2++) l2 = o2 + n2[c2][0], u2 = s2 + n2[c2][1], !(t4[l2][u2] < 0) && (d2.push(t4[o2][s2]), p2.push(t4[l2][u2]), m2.push(-1));
      d2.push(t4[o2][s2]), p2.push(t4[o2][s2]), m2.push(4);
    }
    return [d2, p2, m2];
  }, numeric.cdotMV = function(t4, n2) {
    var r2, i2 = t4[0], a2 = t4[1], o2 = t4[2], s2, c2 = i2.length, l2 = 0;
    for (s2 = 0; s2 < c2; s2++) i2[s2] > l2 && (l2 = i2[s2]);
    for (l2++, r2 = numeric.rep([l2], 0), s2 = 0; s2 < c2; s2++) r2[i2[s2]] += o2[s2] * n2[a2[s2]];
    return r2;
  }, numeric.Spline = function(t4, n2, r2, i2, a2) {
    this.x = t4, this.yl = n2, this.yr = r2, this.kl = i2, this.kr = a2;
  }, numeric.Spline.prototype._at = function(t4, n2) {
    var r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr, t4, c2, l2, u2, d2 = numeric.add, p2 = numeric.sub, m2 = numeric.mul;
    c2 = p2(m2(o2[n2], r2[n2 + 1] - r2[n2]), p2(a2[n2 + 1], i2[n2])), l2 = d2(m2(s2[n2 + 1], r2[n2] - r2[n2 + 1]), p2(a2[n2 + 1], i2[n2])), u2 = (t4 - r2[n2]) / (r2[n2 + 1] - r2[n2]);
    var h2 = u2 * (1 - u2);
    return d2(d2(d2(m2(1 - u2, i2[n2]), m2(u2, a2[n2 + 1])), m2(c2, h2 * (1 - u2))), m2(l2, h2 * u2));
  }, numeric.Spline.prototype.at = function(t4) {
    if (typeof t4 == `number`) {
      var n2 = this.x, r2 = n2.length, i2, a2, o2, s2 = Math.floor;
      for (i2 = 0, a2 = r2 - 1; a2 - i2 > 1; ) o2 = s2((i2 + a2) / 2), n2[o2] <= t4 ? i2 = o2 : a2 = o2;
      return this._at(t4, i2);
    }
    var r2 = t4.length, d2, p2 = Array(r2);
    for (d2 = r2 - 1; d2 !== -1; --d2) p2[d2] = this.at(t4[d2]);
    return p2;
  }, numeric.Spline.prototype.diff = function() {
    var t4 = this.x, n2 = this.yl, r2 = this.yr, i2 = this.kl, a2 = this.kr, o2 = n2.length, s2, c2, l2, u2 = i2, d2 = a2, p2 = Array(o2), m2 = Array(o2), h2 = numeric.add, g2 = numeric.mul, v2 = numeric.div, y2 = numeric.sub;
    for (s2 = o2 - 1; s2 !== -1; --s2) c2 = t4[s2 + 1] - t4[s2], l2 = y2(r2[s2 + 1], n2[s2]), p2[s2] = v2(h2(g2(l2, 6), g2(i2[s2], -4 * c2), g2(a2[s2 + 1], -2 * c2)), c2 * c2), m2[s2 + 1] = v2(h2(g2(l2, -6), g2(i2[s2], 2 * c2), g2(a2[s2 + 1], 4 * c2)), c2 * c2);
    return new numeric.Spline(t4, u2, d2, p2, m2);
  }, numeric.Spline.prototype.roots = function() {
    function t4(t5) {
      return t5 * t5;
    }
    var n2 = [], r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr;
    typeof i2[0] == `number` && (i2 = [i2], a2 = [a2], o2 = [o2], s2 = [s2]);
    var c2 = i2.length, l2 = r2.length - 1, u2, d2, p2, v2, y2, b2, x2, n2 = Array(c2), S2, w2, E, D, O2, j2, M2, N2, F, L2, R2, z2, V2, H2, U2, W2, G2 = Math.sqrt;
    for (u2 = 0; u2 !== c2; ++u2) {
      for (v2 = i2[u2], y2 = a2[u2], b2 = o2[u2], x2 = s2[u2], S2 = [], d2 = 0; d2 !== l2; d2++) {
        for (d2 > 0 && y2[d2] * v2[d2] < 0 && S2.push(r2[d2]), F = r2[d2 + 1] - r2[d2], r2[d2], D = v2[d2], O2 = y2[d2 + 1], w2 = b2[d2] / F, E = x2[d2 + 1] / F, N2 = t4(w2 - E + 3 * (D - O2)) + 12 * E * D, j2 = E + 3 * D + 2 * w2 - 3 * O2, M2 = 3 * (E + w2 + 2 * (D - O2)), N2 <= 0 ? (R2 = j2 / M2, L2 = R2 > r2[d2] && R2 < r2[d2 + 1] ? [r2[d2], R2, r2[d2 + 1]] : [r2[d2], r2[d2 + 1]]) : (R2 = (j2 - G2(N2)) / M2, z2 = (j2 + G2(N2)) / M2, L2 = [r2[d2]], R2 > r2[d2] && R2 < r2[d2 + 1] && L2.push(R2), z2 > r2[d2] && z2 < r2[d2 + 1] && L2.push(z2), L2.push(r2[d2 + 1])), H2 = L2[0], R2 = this._at(H2, d2), p2 = 0; p2 < L2.length - 1; p2++) {
          if (U2 = L2[p2 + 1], z2 = this._at(U2, d2), R2 === 0) {
            S2.push(H2), H2 = U2, R2 = z2;
            continue;
          }
          if (z2 === 0 || R2 * z2 > 0) {
            H2 = U2, R2 = z2;
            continue;
          }
          for (var K2 = 0; W2 = (R2 * U2 - z2 * H2) / (R2 - z2), !(W2 <= H2 || W2 >= U2); ) if (V2 = this._at(W2, d2), V2 * z2 > 0) U2 = W2, z2 = V2, K2 === -1 && (R2 *= 0.5), K2 = -1;
          else if (V2 * R2 > 0) H2 = W2, R2 = V2, K2 === 1 && (z2 *= 0.5), K2 = 1;
          else break;
          S2.push(W2), H2 = L2[p2 + 1], R2 = this._at(H2, d2);
        }
        z2 === 0 && S2.push(U2);
      }
      n2[u2] = S2;
    }
    return typeof this.yl[0] == `number` ? n2[0] : n2;
  }, numeric.spline = function(t4, n2, r2, i2) {
    var a2 = t4.length, o2 = [], s2 = [], c2 = [], l2, u2 = numeric.sub, d2 = numeric.mul, p2 = numeric.add;
    for (l2 = a2 - 2; l2 >= 0; l2--) s2[l2] = t4[l2 + 1] - t4[l2], c2[l2] = u2(n2[l2 + 1], n2[l2]);
    (typeof r2 == `string` || typeof i2 == `string`) && (r2 = i2 = `periodic`);
    var m2 = [[], [], []];
    switch (typeof r2) {
      case `undefined`:
        o2[0] = d2(3 / (s2[0] * s2[0]), c2[0]), m2[0].push(0, 0), m2[1].push(0, 1), m2[2].push(2 / s2[0], 1 / s2[0]);
        break;
      case `string`:
        o2[0] = p2(d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), d2(3 / (s2[0] * s2[0]), c2[0])), m2[0].push(0, 0, 0), m2[1].push(a2 - 2, 0, 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2] + 2 / s2[0], 1 / s2[0]);
        break;
      default:
        o2[0] = r2, m2[0].push(0), m2[1].push(0), m2[2].push(1);
        break;
    }
    for (l2 = 1; l2 < a2 - 1; l2++) o2[l2] = p2(d2(3 / (s2[l2 - 1] * s2[l2 - 1]), c2[l2 - 1]), d2(3 / (s2[l2] * s2[l2]), c2[l2])), m2[0].push(l2, l2, l2), m2[1].push(l2 - 1, l2, l2 + 1), m2[2].push(1 / s2[l2 - 1], 2 / s2[l2 - 1] + 2 / s2[l2], 1 / s2[l2]);
    switch (typeof i2) {
      case `undefined`:
        o2[a2 - 1] = d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), m2[0].push(a2 - 1, a2 - 1), m2[1].push(a2 - 2, a2 - 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2]);
        break;
      case `string`:
        m2[1][m2[1].length - 1] = 0;
        break;
      default:
        o2[a2 - 1] = i2, m2[0].push(a2 - 1), m2[1].push(a2 - 1), m2[2].push(1);
        break;
    }
    o2 = typeof o2[0] == `number` ? [o2] : numeric.transpose(o2);
    var h2 = Array(o2.length);
    if (typeof r2 == `string`) for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(m2)), o2[l2]), h2[l2][a2 - 1] = h2[l2][0];
    else for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.cLUsolve(numeric.cLU(m2), o2[l2]);
    return h2 = typeof n2[0] == `number` ? h2[0] : numeric.transpose(h2), new numeric.Spline(t4, n2, n2, h2, h2);
  }, numeric.fftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = -6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric._ifftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = 6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric.ifftpow2 = function(t4, n2) {
    numeric._ifftpow2(t4, n2), numeric.diveq(t4, t4.length), numeric.diveq(n2, n2.length);
  }, numeric.convpow2 = function(t4, n2, r2, i2) {
    numeric.fftpow2(t4, n2), numeric.fftpow2(r2, i2);
    var a2, o2 = t4.length, s2, c2, l2, u2;
    for (a2 = o2 - 1; a2 !== -1; --a2) s2 = t4[a2], l2 = n2[a2], c2 = r2[a2], u2 = i2[a2], t4[a2] = s2 * c2 - l2 * u2, n2[a2] = s2 * u2 + l2 * c2;
    numeric.ifftpow2(t4, n2);
  }, numeric.T.prototype.fft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = -3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2;
  }, numeric.T.prototype.ifft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = 3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2.div(r2);
  }, numeric.gradient = function(t4, n2) {
    var r2 = n2.length, i2 = t4(n2);
    if (isNaN(i2)) throw Error(`gradient: f(x) is a NaN!`);
    var a2 = Math.max, o2, s2 = numeric.clone(n2), c2, l2, u2 = Array(r2);
    numeric.div;
    numeric.sub;
    var m2, a2 = Math.max, g2 = 1e-3, v2 = Math.abs, y2 = Math.min, b2, x2, S2, w2 = 0, E, D, O2;
    for (o2 = 0; o2 < r2; o2++) for (var j2 = a2(1e-6 * i2, 1e-8); ; ) {
      if (++w2, w2 > 20) throw Error(`Numerical gradient fails`);
      if (s2[o2] = n2[o2] + j2, c2 = t4(s2), s2[o2] = n2[o2] - j2, l2 = t4(s2), s2[o2] = n2[o2], isNaN(c2) || isNaN(l2)) {
        j2 /= 16;
        continue;
      }
      if (u2[o2] = (c2 - l2) / (2 * j2), b2 = n2[o2] - j2, x2 = n2[o2], S2 = n2[o2] + j2, E = (c2 - i2) / j2, D = (i2 - l2) / j2, O2 = a2(v2(u2[o2]), v2(i2), v2(c2), v2(l2), v2(b2), v2(x2), v2(S2), 1e-8), m2 = y2(a2(v2(E - u2[o2]), v2(D - u2[o2]), v2(E - D)) / O2, j2 / O2), m2 > g2) j2 /= 16;
      else break;
    }
    return u2;
  }, numeric.uncmin = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.gradient;
    s2 === void 0 && (s2 = {}), r2 === void 0 && (r2 = 1e-8), i2 === void 0 && (i2 = function(n3) {
      return c2(t4, n3);
    }), a2 === void 0 && (a2 = 1e3), n2 = numeric.clone(n2);
    var l2 = n2.length, u2 = t4(n2), d2, p2;
    if (isNaN(u2)) throw Error(`uncmin: f(x0) is a NaN!`);
    var m2 = Math.max, h2 = numeric.norm2;
    r2 = m2(r2, numeric.epsilon);
    var g2, v2, y2, b2 = s2.Hinv || numeric.identity(l2), x2 = numeric.dot;
    numeric.inv;
    var w2 = numeric.sub, E = numeric.add, D = numeric.tensor, O2 = numeric.div, j2 = numeric.mul, M2 = numeric.all, N2 = numeric.isFinite, F = numeric.neg, I2 = 0, R2, z2, V2, H2, W2, K2, q2, Y2 = ``;
    for (v2 = i2(n2); I2 < a2; ) {
      if (typeof o2 == `function` && o2(I2, n2, u2, v2, b2)) {
        Y2 = `Callback returned true`;
        break;
      }
      if (!M2(N2(v2))) {
        Y2 = `Gradient has Infinity or NaN`;
        break;
      }
      if (g2 = F(x2(b2, v2)), !M2(N2(g2))) {
        Y2 = `Search direction has Infinity or NaN`;
        break;
      }
      if (q2 = h2(g2), q2 < r2) {
        Y2 = `Newton step smaller than tol`;
        break;
      }
      for (K2 = 1, p2 = x2(v2, g2), z2 = n2; I2 < a2 && !(K2 * q2 < r2); ) {
        if (R2 = j2(g2, K2), z2 = E(n2, R2), d2 = t4(z2), d2 - u2 >= 0.1 * K2 * p2 || isNaN(d2)) {
          K2 *= 0.5, ++I2;
          continue;
        }
        break;
      }
      if (K2 * q2 < r2) {
        Y2 = `Line search step size smaller than tol`;
        break;
      }
      if (I2 === a2) {
        Y2 = `maxit reached during line search`;
        break;
      }
      y2 = i2(z2), V2 = w2(y2, v2), W2 = x2(V2, R2), H2 = x2(b2, V2), b2 = w2(E(b2, j2((W2 + x2(V2, H2)) / (W2 * W2), D(R2, R2))), O2(E(D(H2, R2), D(R2, H2)), W2)), n2 = z2, u2 = d2, v2 = y2, ++I2;
    }
    return { solution: n2, f: u2, gradient: v2, invHessian: b2, iterations: I2, message: Y2 };
  }, numeric.Dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    this.x = t4, this.y = n2, this.f = r2, this.ymid = i2, this.iterations = a2, this.events = s2, this.message = o2;
  }, numeric.Dopri.prototype._at = function(t4, n2) {
    function r2(t5) {
      return t5 * t5;
    }
    var i2 = this, a2 = i2.x, o2 = i2.y, s2 = i2.f, c2 = i2.ymid;
    a2.length;
    var u2, d2, p2, m2, h2, g2, t4, y2, b2 = 0.5, x2 = numeric.add, S2 = numeric.mul, w2 = numeric.sub, E, D, O2;
    return u2 = a2[n2], d2 = a2[n2 + 1], m2 = o2[n2], h2 = o2[n2 + 1], y2 = d2 - u2, p2 = u2 + b2 * y2, g2 = c2[n2], E = w2(s2[n2], S2(m2, 1 / (u2 - p2) + 2 / (u2 - d2))), D = w2(s2[n2 + 1], S2(h2, 1 / (d2 - p2) + 2 / (d2 - u2))), O2 = [r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), r2(t4 - u2) * r2(t4 - d2) / r2(u2 - p2) / r2(d2 - p2), r2(t4 - u2) * (t4 - p2) / r2(d2 - u2) / (d2 - p2), (t4 - u2) * r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), (t4 - d2) * r2(t4 - u2) * (t4 - p2) / r2(u2 - d2) / (d2 - p2)], x2(x2(x2(x2(S2(m2, O2[0]), S2(g2, O2[1])), S2(h2, O2[2])), S2(E, O2[3])), S2(D, O2[4]));
  }, numeric.Dopri.prototype.at = function(t4) {
    var n2, r2, i2, a2 = Math.floor;
    if (typeof t4 != `number`) {
      var o2 = t4.length, s2 = Array(o2);
      for (n2 = o2 - 1; n2 !== -1; --n2) s2[n2] = this.at(t4[n2]);
      return s2;
    }
    var c2 = this.x;
    for (n2 = 0, r2 = c2.length - 1; r2 - n2 > 1; ) i2 = a2(0.5 * (n2 + r2)), c2[i2] <= t4 ? n2 = i2 : r2 = i2;
    return this._at(t4, n2);
  }, numeric.dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    a2 === void 0 && (a2 = 1e-6), o2 === void 0 && (o2 = 1e3);
    var c2 = [t4], l2 = [r2], u2 = [i2(t4, r2)], d2, p2, m2, h2, g2, v2, y2 = [], b2 = 1 / 5, x2 = [3 / 40, 9 / 40], S2 = [44 / 45, -56 / 15, 32 / 9], w2 = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], E = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], D = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], O2 = [0.5 * 6025192743 / 30085553152, 0, 0.5 * 51252292925 / 65400821598, 0.5 * -2691868925 / 45128329728, 0.5 * 187940372067 / 1594534317056, 0.5 * -1776094331 / 19743644256, 0.5 * 11237099 / 235043384], j2 = [1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], M2 = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], N2 = 0, F, I2, L2 = (n2 - t4) / 10, R2 = 0, z2 = numeric.add, V2 = numeric.mul, H2, U2, G2 = Math.min, K2 = Math.abs, q2 = numeric.norminf, J = Math.pow, ee2 = numeric.any, Y2 = numeric.lt, te2 = numeric.and;
    numeric.sub;
    var X2, ie2, ae2, Z2 = new numeric.Dopri(c2, l2, u2, y2, -1, ``);
    for (typeof s2 == `function` && (X2 = s2(t4, r2)); t4 < n2 && R2 < o2; ) {
      if (++R2, t4 + L2 > n2 && (L2 = n2 - t4), d2 = i2(t4 + j2[0] * L2, z2(r2, V2(b2 * L2, u2[N2]))), p2 = i2(t4 + j2[1] * L2, z2(z2(r2, V2(x2[0] * L2, u2[N2])), V2(x2[1] * L2, d2))), m2 = i2(t4 + j2[2] * L2, z2(z2(z2(r2, V2(S2[0] * L2, u2[N2])), V2(S2[1] * L2, d2)), V2(S2[2] * L2, p2))), h2 = i2(t4 + j2[3] * L2, z2(z2(z2(z2(r2, V2(w2[0] * L2, u2[N2])), V2(w2[1] * L2, d2)), V2(w2[2] * L2, p2)), V2(w2[3] * L2, m2))), g2 = i2(t4 + j2[4] * L2, z2(z2(z2(z2(z2(r2, V2(E[0] * L2, u2[N2])), V2(E[1] * L2, d2)), V2(E[2] * L2, p2)), V2(E[3] * L2, m2)), V2(E[4] * L2, h2))), H2 = z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * D[0])), V2(p2, L2 * D[2])), V2(m2, L2 * D[3])), V2(h2, L2 * D[4])), V2(g2, L2 * D[5])), v2 = i2(t4 + L2, H2), F = z2(z2(z2(z2(z2(V2(u2[N2], L2 * M2[0]), V2(p2, L2 * M2[2])), V2(m2, L2 * M2[3])), V2(h2, L2 * M2[4])), V2(g2, L2 * M2[5])), V2(v2, L2 * M2[6])), U2 = typeof F == `number` ? K2(F) : q2(F), U2 > a2) {
        if (L2 = 0.2 * L2 * J(a2 / U2, 0.25), t4 + L2 === t4) {
          Z2.msg = `Step size became too small`;
          break;
        }
        continue;
      }
      if (y2[N2] = z2(z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * O2[0])), V2(p2, L2 * O2[2])), V2(m2, L2 * O2[3])), V2(h2, L2 * O2[4])), V2(g2, L2 * O2[5])), V2(v2, L2 * O2[6])), ++N2, c2[N2] = t4 + L2, l2[N2] = H2, u2[N2] = v2, typeof s2 == `function`) {
        var oe2, $2 = t4, se2 = t4 + 0.5 * L2, ce2;
        if (ie2 = s2(se2, y2[N2 - 1]), ae2 = te2(Y2(X2, 0), Y2(0, ie2)), ee2(ae2) || ($2 = se2, se2 = t4 + L2, X2 = ie2, ie2 = s2(se2, H2), ae2 = te2(Y2(X2, 0), Y2(0, ie2))), ee2(ae2)) {
          for (var le2, ue2, de2, fe2, pe2 = 0, me2 = 1, he2 = 1; ; ) {
            if (typeof X2 == `number`) ce2 = (he2 * ie2 * $2 - me2 * X2 * se2) / (he2 * ie2 - me2 * X2);
            else for (ce2 = se2, I2 = X2.length - 1; I2 !== -1; --I2) X2[I2] < 0 && ie2[I2] > 0 && (ce2 = G2(ce2, (he2 * ie2[I2] * $2 - me2 * X2[I2] * se2) / (he2 * ie2[I2] - me2 * X2[I2])));
            if (ce2 <= $2 || ce2 >= se2) break;
            oe2 = Z2._at(ce2, N2 - 1), fe2 = s2(ce2, oe2), de2 = te2(Y2(X2, 0), Y2(0, fe2)), ee2(de2) ? (se2 = ce2, ie2 = fe2, ae2 = de2, he2 = 1, pe2 === -1 ? me2 *= 0.5 : me2 = 1, pe2 = -1) : ($2 = ce2, X2 = fe2, me2 = 1, pe2 === 1 ? he2 *= 0.5 : he2 = 1, pe2 = 1);
          }
          return H2 = Z2._at(0.5 * (t4 + ce2), N2 - 1), Z2.f[N2] = i2(ce2, oe2), Z2.x[N2] = ce2, Z2.y[N2] = oe2, Z2.ymid[N2 - 1] = H2, Z2.events = ae2, Z2.iterations = R2, Z2;
        }
      }
      t4 += L2, r2 = H2, X2 = ie2, L2 = G2(0.8 * L2 * J(a2 / U2, 0.25), 4 * L2);
    }
    return Z2.iterations = R2, Z2;
  }, numeric.LU = function(t4, n2) {
    n2 ||= false;
    var r2 = Math.abs, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2 = t4.length, h2 = m2 - 1, g2 = Array(m2);
    for (n2 || (t4 = numeric.clone(t4)), o2 = 0; o2 < m2; ++o2) {
      for (u2 = o2, l2 = t4[o2], p2 = r2(l2[o2]), a2 = o2 + 1; a2 < m2; ++a2) s2 = r2(t4[a2][o2]), p2 < s2 && (p2 = s2, u2 = a2);
      for (g2[o2] = u2, u2 != o2 && (t4[o2] = t4[u2], t4[u2] = l2, l2 = t4[o2]), c2 = l2[o2], i2 = o2 + 1; i2 < m2; ++i2) t4[i2][o2] /= c2;
      for (i2 = o2 + 1; i2 < m2; ++i2) {
        for (d2 = t4[i2], a2 = o2 + 1; a2 < h2; ++a2) d2[a2] -= d2[o2] * l2[a2], ++a2, d2[a2] -= d2[o2] * l2[a2];
        a2 === h2 && (d2[a2] -= d2[o2] * l2[a2]);
      }
    }
    return { LU: t4, P: g2 };
  }, numeric.LUsolve = function(t4, n2) {
    var r2, i2, a2 = t4.LU, o2 = a2.length, s2 = numeric.clone(n2), c2 = t4.P, l2, u2, p2;
    for (r2 = o2 - 1; r2 !== -1; --r2) s2[r2] = n2[r2];
    for (r2 = 0; r2 < o2; ++r2) for (l2 = c2[r2], c2[r2] !== r2 && (p2 = s2[r2], s2[r2] = s2[l2], s2[l2] = p2), u2 = a2[r2], i2 = 0; i2 < r2; ++i2) s2[r2] -= s2[i2] * u2[i2];
    for (r2 = o2 - 1; r2 >= 0; --r2) {
      for (u2 = a2[r2], i2 = r2 + 1; i2 < o2; ++i2) s2[r2] -= s2[i2] * u2[i2];
      s2[r2] /= u2[r2];
    }
    return s2;
  }, numeric.solve = function(t4, n2, r2) {
    return numeric.LUsolve(numeric.LU(t4, r2), n2);
  }, numeric.echelonize = function(t4) {
    var n2 = numeric.dim(t4), r2 = n2[0], i2 = n2[1], a2 = numeric.identity(r2), o2 = Array(r2), s2, c2, l2, u2, d2, p2, m2, h2, g2 = Math.abs, v2 = numeric.diveq;
    for (t4 = numeric.clone(t4), s2 = 0; s2 < r2; ++s2) {
      for (l2 = 0, d2 = t4[s2], p2 = a2[s2], c2 = 1; c2 < i2; ++c2) g2(d2[l2]) < g2(d2[c2]) && (l2 = c2);
      for (o2[s2] = l2, v2(p2, d2[l2]), v2(d2, d2[l2]), c2 = 0; c2 < r2; ++c2) if (c2 !== s2) {
        for (m2 = t4[c2], h2 = m2[l2], u2 = i2 - 1; u2 !== -1; --u2) m2[u2] -= d2[u2] * h2;
        for (m2 = a2[c2], u2 = r2 - 1; u2 !== -1; --u2) m2[u2] -= p2[u2] * h2;
      }
    }
    return { I: a2, A: t4, P: o2 };
  }, numeric.__solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.sum;
    numeric.log;
    var u2 = numeric.mul, d2 = numeric.sub, p2 = numeric.dot, m2 = numeric.div, h2 = numeric.add, g2 = t4.length, v2 = r2.length, y2, b2 = false, S2 = 0, w2 = 1;
    numeric.transpose(n2);
    numeric.svd;
    var M2 = numeric.transpose;
    numeric.leq;
    var F = Math.sqrt, I2 = Math.abs;
    numeric.muleq;
    numeric.norminf;
    numeric.any;
    var V2 = Math.min, H2 = numeric.all, U2 = numeric.gt, W2 = Array(g2), G2 = Array(v2);
    numeric.rep([v2], 1);
    var q2, J = numeric.solve, ee2 = d2(r2, p2(n2, o2)), Y2, te2 = p2(t4, t4), ne2;
    for (Y2 = S2; Y2 < a2; ++Y2) {
      var X2, ae2;
      for (X2 = v2 - 1; X2 !== -1; --X2) G2[X2] = m2(n2[X2], ee2[X2]);
      var Z2 = M2(G2);
      for (X2 = g2 - 1; X2 !== -1; --X2) W2[X2] = c2(Z2[X2]);
      w2 = 0.25 * I2(te2 / p2(t4, W2));
      var oe2 = 100 * F(te2 / p2(W2, W2));
      for ((!isFinite(w2) || w2 > oe2) && (w2 = oe2), ne2 = h2(t4, u2(w2, W2)), q2 = p2(Z2, G2), X2 = g2 - 1; X2 !== -1; --X2) q2[X2][X2] += 1;
      ae2 = J(q2, m2(ne2, w2), true);
      var $2 = m2(ee2, p2(n2, ae2)), se2 = 1;
      for (X2 = v2 - 1; X2 !== -1; --X2) $2[X2] < 0 && (se2 = V2(se2, -0.999 * $2[X2]));
      if (y2 = d2(o2, u2(ae2, se2)), ee2 = d2(r2, p2(n2, y2)), !H2(U2(ee2, 0))) return { solution: o2, message: ``, iterations: Y2 };
      if (o2 = y2, w2 < i2) return { solution: y2, message: ``, iterations: Y2 };
      if (s2) {
        var ce2 = p2(t4, ne2), le2 = p2(n2, ne2);
        for (b2 = true, X2 = v2 - 1; X2 !== -1; --X2) if (ce2 * le2[X2] < 0) {
          b2 = false;
          break;
        }
      } else b2 = !(o2[g2 - 1] >= 0);
      if (b2) return { solution: y2, message: `Unbounded`, iterations: Y2 };
    }
    return { solution: o2, message: `maximum iteration count exceeded`, iterations: Y2 };
  }, numeric._solveLP = function(t4, n2, r2, i2, a2) {
    var o2 = t4.length, s2 = r2.length, c2;
    numeric.sum;
    numeric.log;
    numeric.mul;
    var p2 = numeric.sub, m2 = numeric.dot;
    numeric.div;
    numeric.add;
    var v2 = numeric.rep([o2], 0).concat([1]), y2 = numeric.rep([s2, 1], -1), b2 = numeric.blockMatrix([[n2, y2]]), x2 = r2, c2 = numeric.rep([o2], 0).concat(Math.max(0, numeric.sup(numeric.neg(r2))) + 1), S2 = numeric.__solveLP(v2, b2, x2, i2, a2, c2, false), w2 = numeric.clone(S2.solution);
    if (w2.length = o2, numeric.inf(p2(r2, m2(n2, w2))) < 0) return { solution: NaN, message: `Infeasible`, iterations: S2.iterations };
    var E = numeric.__solveLP(t4, n2, r2, i2, a2 - S2.iterations, w2, true);
    return E.iterations += S2.iterations, E;
  }, numeric.solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    if (s2 === void 0 && (s2 = 1e3), o2 === void 0 && (o2 = numeric.epsilon), i2 === void 0) return numeric._solveLP(t4, n2, r2, o2, s2);
    var c2 = i2.length, l2 = i2[0].length, u2 = n2.length, d2 = numeric.echelonize(i2), p2 = numeric.rep([l2], 0), m2 = d2.P, h2 = [], g2;
    for (g2 = m2.length - 1; g2 !== -1; --g2) p2[m2[g2]] = 1;
    for (g2 = l2 - 1; g2 !== -1; --g2) p2[g2] === 0 && h2.push(g2);
    var v2 = numeric.getRange, y2 = numeric.linspace(0, c2 - 1), b2 = numeric.linspace(0, u2 - 1), x2 = v2(i2, y2, h2), S2 = v2(n2, b2, m2), w2 = v2(n2, b2, h2), E = numeric.dot, D = numeric.sub, O2 = E(S2, d2.I), j2 = D(w2, E(O2, x2)), M2 = D(r2, E(O2, a2)), N2 = Array(m2.length), F = Array(h2.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) N2[g2] = t4[m2[g2]];
    for (g2 = h2.length - 1; g2 !== -1; --g2) F[g2] = t4[h2[g2]];
    var I2 = D(F, E(N2, E(d2.I, x2))), L2 = numeric._solveLP(I2, j2, M2, o2, s2), R2 = L2.solution;
    if (R2 !== R2) return L2;
    var z2 = E(d2.I, D(a2, E(x2, R2))), V2 = Array(t4.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) V2[m2[g2]] = z2[g2];
    for (g2 = h2.length - 1; g2 !== -1; --g2) V2[h2[g2]] = R2[g2];
    return { solution: V2, message: L2.message, iterations: L2.iterations };
  }, numeric.MPStoLP = function(t4) {
    t4 instanceof String && t4.split(`
`);
    var n2 = 0, r2 = [`Initial state`, `NAME`, `ROWS`, `COLUMNS`, `RHS`, `BOUNDS`, `ENDATA`], i2 = t4.length, a2, o2, s2, c2 = 0, l2 = {}, u2 = [], d2 = 0, p2 = {}, m2 = 0, h2, g2 = [], v2 = [], y2 = [];
    function b2(i3) {
      throw Error(`MPStoLP: ` + i3 + `
Line ` + a2 + `: ` + t4[a2] + `
Current state: ` + r2[n2] + `
`);
    }
    for (a2 = 0; a2 < i2; ++a2) {
      s2 = t4[a2];
      var x2 = s2.match(/\S*/g), S2 = [];
      for (o2 = 0; o2 < x2.length; ++o2) x2[o2] !== `` && S2.push(x2[o2]);
      if (S2.length !== 0) {
        for (o2 = 0; o2 < r2.length && s2.substr(0, r2[o2].length) !== r2[o2]; ++o2) ;
        if (o2 < r2.length) {
          if (n2 = o2, o2 === 1 && (h2 = S2[1]), o2 === 6) return { name: h2, c: g2, A: numeric.transpose(v2), b: y2, rows: l2, vars: p2 };
          continue;
        }
        switch (n2) {
          case 0:
          case 1:
            b2(`Unexpected line`);
          case 2:
            switch (S2[0]) {
              case `N`:
                c2 === 0 ? c2 = S2[1] : b2(`Two or more N rows`);
                break;
              case `L`:
                l2[S2[1]] = d2, u2[d2] = 1, y2[d2] = 0, ++d2;
                break;
              case `G`:
                l2[S2[1]] = d2, u2[d2] = -1, y2[d2] = 0, ++d2;
                break;
              case `E`:
                l2[S2[1]] = d2, u2[d2] = 0, y2[d2] = 0, ++d2;
                break;
              default:
                b2(`Parse error ` + numeric.prettyPrint(S2));
            }
            break;
          case 3:
            p2.hasOwnProperty(S2[0]) || (p2[S2[0]] = m2, g2[m2] = 0, v2[m2] = numeric.rep([d2], 0), ++m2);
            var w2 = p2[S2[0]];
            for (o2 = 1; o2 < S2.length; o2 += 2) {
              if (S2[o2] === c2) {
                g2[w2] = parseFloat(S2[o2 + 1]);
                continue;
              }
              var E = l2[S2[o2]];
              v2[w2][E] = (u2[E] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            }
            break;
          case 4:
            for (o2 = 1; o2 < S2.length; o2 += 2) y2[l2[S2[o2]]] = (u2[l2[S2[o2]]] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            break;
          case 5:
            break;
          case 6:
            b2(`Internal error`);
        }
      }
    }
    b2(`Reached end of file without ENDATA`);
  }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(t4, n2, r2, i2, a2, o2, s2) {
    n2.seedrandom = function(d3, p2) {
      var m2 = [], h2;
      return d3 = u2(l2(p2 ? [d3, t4] : arguments.length ? d3 : [(/* @__PURE__ */ new Date()).getTime(), t4, window], 3), m2), h2 = new c2(m2), u2(h2.S, t4), n2.random = function() {
        for (var t5 = h2.g(i2), n3 = s2, c3 = 0; t5 < a2; ) t5 = (t5 + c3) * r2, n3 *= r2, c3 = h2.g(1);
        for (; t5 >= o2; ) t5 /= 2, n3 /= 2, c3 >>>= 1;
        return (t5 + c3) / n3;
      }, d3;
    };
    function c2(t5) {
      var n3, i3, a3 = this, o3 = t5.length, s3 = 0, c3 = a3.i = a3.j = a3.m = 0;
      for (a3.S = [], a3.c = [], o3 || (t5 = [o3++]); s3 < r2; ) a3.S[s3] = s3++;
      for (s3 = 0; s3 < r2; s3++) n3 = a3.S[s3], c3 = d2(c3 + n3 + t5[s3 % o3]), i3 = a3.S[c3], a3.S[s3] = i3, a3.S[c3] = n3;
      a3.g = function(t6) {
        var n4 = a3.S, i4 = d2(a3.i + 1), o4 = n4[i4], s4 = d2(a3.j + o4), c4 = n4[s4];
        n4[i4] = c4, n4[s4] = o4;
        for (var l3 = n4[d2(o4 + c4)]; --t6; ) i4 = d2(i4 + 1), o4 = n4[i4], s4 = d2(s4 + o4), c4 = n4[s4], n4[i4] = c4, n4[s4] = o4, l3 = l3 * r2 + n4[d2(o4 + c4)];
        return a3.i = i4, a3.j = s4, l3;
      }, a3.g(r2);
    }
    function l2(t5, n3, r3, i3, a3) {
      if (r3 = [], a3 = typeof t5, n3 && a3 == `object`) {
        for (i3 in t5) if (i3.indexOf(`S`) < 5) try {
          r3.push(l2(t5[i3], n3 - 1));
        } catch {
        }
      }
      return r3.length ? r3 : t5 + (a3 == `string` ? `` : `\0`);
    }
    function u2(t5, n3, r3, i3) {
      for (t5 += ``, r3 = 0, i3 = 0; i3 < t5.length; i3++) n3[d2(i3)] = d2((r3 ^= n3[d2(i3)] * 19) + t5.charCodeAt(i3));
      for (i3 in t5 = ``, n3) t5 += String.fromCharCode(n3[i3]);
      return t5;
    }
    function d2(t5) {
      return t5 & r2 - 1;
    }
    s2 = n2.pow(r2, i2), a2 = n2.pow(2, a2), o2 = a2 * 2, u2(n2.random(), t4);
  })([], numeric.seedrandom, 256, 6, 52), (function(t4) {
    function n2(t5) {
      if (typeof t5 != `object`) return t5;
      var r3 = [], i3, a3 = t5.length;
      for (i3 = 0; i3 < a3; i3++) r3[i3 + 1] = n2(t5[i3]);
      return r3;
    }
    function r2(t5) {
      if (typeof t5 != `object`) return t5;
      var n3 = [], i3, a3 = t5.length;
      for (i3 = 1; i3 < a3; i3++) n3[i3 - 1] = r2(t5[i3]);
      return n3;
    }
    function i2(t5, n3, r3) {
      var i3, a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (t5[o3][o3] = 1 / t5[o3][o3], c3 = -t5[o3][o3], i3 = 1; i3 < o3; i3 += 1) t5[i3][o3] = c3 * t5[i3][o3];
        if (s3 = o3 + 1, r3 < s3) break;
        for (a3 = s3; a3 <= r3; a3 += 1) for (c3 = t5[o3][a3], t5[o3][a3] = 0, i3 = 1; i3 <= o3; i3 += 1) t5[i3][a3] = t5[i3][a3] + c3 * t5[i3][o3];
      }
    }
    function a2(t5, n3, r3, i3) {
      var a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (c3 = 0, a3 = 1; a3 < o3; a3 += 1) c3 += t5[a3][o3] * i3[a3];
        i3[o3] = (i3[o3] - c3) / t5[o3][o3];
      }
      for (s3 = 1; s3 <= r3; s3 += 1) for (o3 = r3 + 1 - s3, i3[o3] = i3[o3] / t5[o3][o3], c3 = -i3[o3], a3 = 1; a3 < o3; a3 += 1) i3[a3] = i3[a3] + c3 * t5[a3][o3];
    }
    function o2(t5, n3, r3, i3) {
      var a3, o3, s3, c3, l2, u2;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        if (i3[1] = o3, u2 = 0, s3 = o3 - 1, s3 < 1) {
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        } else {
          for (c3 = 1; c3 <= s3; c3 += 1) {
            for (l2 = t5[c3][o3], a3 = 1; a3 < c3; a3 += 1) l2 -= t5[a3][o3] * t5[a3][c3];
            l2 /= t5[c3][c3], t5[c3][o3] = l2, u2 += l2 * l2;
          }
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        }
        i3[1] = 0;
      }
    }
    function s2(t5, n3, r3, s3, c3, l2, u2, d2, p2, m2, h2, g2, v2, y2, b2, x2) {
      var S2, w2, E, D, O2, j2, M2, N2, F, I2, L2, R2, z2 = Math.min(s3, m2), V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2;
      E = 2 * s3 + z2 * (z2 + 5) / 2 + 2 * m2 + 1, te2 = 1e-60;
      do
        te2 += te2, ne2 = 1 + 0.1 * te2, X2 = 1 + 0.2 * te2;
      while (ne2 <= 1 || X2 <= 1);
      for (S2 = 1; S2 <= s3; S2 += 1) b2[S2] = n3[S2];
      for (S2 = s3 + 1; S2 <= E; S2 += 1) b2[S2] = 0;
      for (S2 = 1; S2 <= m2; S2 += 1) g2[S2] = 0;
      if (O2 = [], x2[1] === 0) {
        if (o2(t5, r3, s3, O2), O2[1] !== 0) {
          x2[1] = 2;
          return;
        }
        a2(t5, r3, s3, n3), i2(t5, r3, s3);
      } else {
        for (w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = 0, S2 = 1; S2 <= w2; S2 += 1) c3[w2] = c3[w2] + t5[S2][w2] * n3[S2];
        for (w2 = 1; w2 <= s3; w2 += 1) for (n3[w2] = 0, S2 = w2; S2 <= s3; S2 += 1) n3[w2] = n3[w2] + t5[w2][S2] * c3[S2];
      }
      for (l2[1] = 0, w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = n3[w2], l2[1] += b2[w2] * c3[w2], b2[w2] = 0, S2 = w2 + 1; S2 <= s3; S2 += 1) t5[S2][w2] = 0;
      for (l2[1] = -l2[1] / 2, x2[1] = 0, M2 = s3, N2 = M2 + s3, L2 = N2 + z2, F = L2 + z2 + 1, I2 = F + z2 * (z2 + 1) / 2, V2 = I2 + m2, S2 = 1; S2 <= m2; S2 += 1) {
        for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * u2[w2][S2];
        b2[V2 + S2] = Math.sqrt(U2);
      }
      v2 = 0, y2[1] = 0, y2[2] = 0;
      function ae2() {
        for (y2[1] += 1, E = I2, S2 = 1; S2 <= m2; S2 += 1) {
          for (E += 1, U2 = -d2[S2], w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * c3[w2];
          if (Math.abs(U2) < te2 && (U2 = 0), S2 > h2) b2[E] = U2;
          else if (b2[E] = -Math.abs(U2), U2 > 0) {
            for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][S2] = -u2[w2][S2];
            d2[S2] = -d2[S2];
          }
        }
        for (S2 = 1; S2 <= v2; S2 += 1) b2[I2 + g2[S2]] = 0;
        for (R2 = 0, H2 = 0, S2 = 1; S2 <= m2; S2 += 1) b2[I2 + S2] < H2 * b2[V2 + S2] && (R2 = S2, H2 = b2[I2 + S2] / b2[V2 + S2]);
        return R2 === 0 ? 999 : 0;
      }
      function Z2() {
        for (S2 = 1; S2 <= s3; S2 += 1) {
          for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += t5[w2][S2] * u2[w2][R2];
          b2[S2] = U2;
        }
        for (D = M2, S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = 0;
        for (w2 = v2 + 1; w2 <= s3; w2 += 1) for (S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = b2[D + S2] + t5[S2][w2] * b2[w2];
        for (ee2 = true, S2 = v2; S2 >= 1; --S2) {
          for (U2 = b2[S2], E = F + S2 * (S2 + 3) / 2, D = E - S2, w2 = S2 + 1; w2 <= v2; w2 += 1) U2 -= b2[E] * b2[N2 + w2], E += w2;
          if (U2 /= b2[D], b2[N2 + S2] = U2, g2[S2] < h2 || U2 < 0) break;
          ee2 = false, j2 = S2;
        }
        if (!ee2) for (W2 = b2[L2 + j2] / b2[N2 + j2], S2 = 1; S2 <= v2 && !(g2[S2] < h2 || b2[N2 + S2] < 0); S2 += 1) H2 = b2[L2 + S2] / b2[N2 + S2], H2 < W2 && (W2 = H2, j2 = S2);
        for (U2 = 0, S2 = M2 + 1; S2 <= M2 + s3; S2 += 1) U2 += b2[S2] * b2[S2];
        if (Math.abs(U2) <= te2) {
          if (ee2) return x2[1] = 1, 999;
          for (S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - W2 * b2[N2 + S2];
          return b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + W2, 700;
        } else {
          for (U2 = 0, S2 = 1; S2 <= s3; S2 += 1) U2 += b2[M2 + S2] * u2[S2][R2];
          for (G2 = -b2[I2 + R2] / U2, Y2 = true, ee2 || W2 < G2 && (G2 = W2, Y2 = false), S2 = 1; S2 <= s3; S2 += 1) c3[S2] = c3[S2] + G2 * b2[M2 + S2], Math.abs(c3[S2]) < te2 && (c3[S2] = 0);
          for (l2[1] += G2 * U2 * (G2 / 2 + b2[L2 + v2 + 1]), S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - G2 * b2[N2 + S2];
          if (b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + G2, Y2) {
            for (v2 += 1, g2[v2] = R2, E = F + (v2 - 1) * v2 / 2 + 1, S2 = 1; S2 <= v2 - 1; S2 += 1) b2[E] = b2[S2], E += 1;
            if (v2 === s3) b2[E] = b2[s3];
            else {
              for (S2 = s3; S2 >= v2 + 1 && !(b2[S2] === 0 || (K2 = Math.max(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), q2 = Math.min(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), H2 = b2[S2 - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[S2 - 1] / H2, q2 = b2[S2] / H2, K2 === 1)); --S2) if (K2 === 0) for (b2[S2 - 1] = q2 * H2, w2 = 1; w2 <= s3; w2 += 1) H2 = t5[w2][S2 - 1], t5[w2][S2 - 1] = t5[w2][S2], t5[w2][S2] = H2;
              else for (b2[S2 - 1] = H2, J = q2 / (1 + K2), w2 = 1; w2 <= s3; w2 += 1) H2 = K2 * t5[w2][S2 - 1] + q2 * t5[w2][S2], t5[w2][S2] = J * (t5[w2][S2 - 1] + H2) - t5[w2][S2], t5[w2][S2 - 1] = H2;
              b2[E] = b2[v2];
            }
          } else {
            for (U2 = -d2[R2], w2 = 1; w2 <= s3; w2 += 1) U2 += c3[w2] * u2[w2][R2];
            if (R2 > h2) b2[I2 + R2] = U2;
            else if (b2[I2 + R2] = -Math.abs(U2), U2 > 0) {
              for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][R2] = -u2[w2][R2];
              d2[R2] = -d2[R2];
            }
            return 700;
          }
        }
        return 0;
      }
      function oe2() {
        if (E = F + j2 * (j2 + 1) / 2 + 1, D = E + j2, b2[D] === 0 || (K2 = Math.max(Math.abs(b2[D - 1]), Math.abs(b2[D])), q2 = Math.min(Math.abs(b2[D - 1]), Math.abs(b2[D])), H2 = b2[D - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[D - 1] / H2, q2 = b2[D] / H2, K2 === 1)) return 798;
        if (K2 === 0) {
          for (S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = b2[D - 1], b2[D - 1] = b2[D], b2[D] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = t5[S2][j2], t5[S2][j2] = t5[S2][j2 + 1], t5[S2][j2 + 1] = H2;
        } else {
          for (J = q2 / (1 + K2), S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = K2 * b2[D - 1] + q2 * b2[D], b2[D] = J * (b2[D - 1] + H2) - b2[D], b2[D - 1] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = K2 * t5[S2][j2] + q2 * t5[S2][j2 + 1], t5[S2][j2 + 1] = J * (t5[S2][j2] + H2) - t5[S2][j2 + 1], t5[S2][j2] = H2;
        }
        return 0;
      }
      function $2() {
        for (D = E - j2, S2 = 1; S2 <= j2; S2 += 1) b2[D] = b2[E], E += 1, D += 1;
        return b2[L2 + j2] = b2[L2 + j2 + 1], g2[j2] = g2[j2 + 1], j2 += 1, j2 < v2 ? 797 : 0;
      }
      function se2() {
        return b2[L2 + v2] = b2[L2 + v2 + 1], b2[L2 + v2 + 1] = 0, g2[v2] = 0, --v2, y2[2] += 1, 0;
      }
      for (ie2 = 0; ; ) {
        if (ie2 = ae2(), ie2 === 999) return;
        for (; ie2 = Z2(), ie2 !== 0; ) {
          if (ie2 === 999) return;
          if (ie2 === 700) if (j2 === v2) se2();
          else {
            for (; oe2(), ie2 = $2(), ie2 === 797; ) ;
            se2();
          }
        }
      }
    }
    function c2(t5, i3, a3, o3, c3, l2) {
      t5 = n2(t5), i3 = n2(i3), a3 = n2(a3);
      var u2, d2, p2, m2, h2, g2 = [], v2 = [], y2 = [], b2 = [], x2 = [], S2;
      if (c3 ||= 0, l2 = l2 ? n2(l2) : [void 0, 0], o3 = o3 ? n2(o3) : [], d2 = t5.length - 1, p2 = a3[1].length - 1, !o3) for (u2 = 1; u2 <= p2; u2 += 1) o3[u2] = 0;
      for (u2 = 1; u2 <= p2; u2 += 1) v2[u2] = 0;
      for (m2 = 0, h2 = Math.min(d2, p2), u2 = 1; u2 <= d2; u2 += 1) y2[u2] = 0;
      for (g2[1] = 0, u2 = 1; u2 <= 2 * d2 + h2 * (h2 + 5) / 2 + 2 * p2 + 1; u2 += 1) b2[u2] = 0;
      for (u2 = 1; u2 <= 2; u2 += 1) x2[u2] = 0;
      return s2(t5, i3, d2, d2, y2, g2, a3, o3, d2, p2, c3, v2, m2, x2, b2, l2), S2 = ``, l2[1] === 1 && (S2 = `constraints are inconsistent, no solution!`), l2[1] === 2 && (S2 = `matrix D in quadratic function is not positive definite!`), { solution: r2(y2), value: r2(g2), unconstrained_solution: r2(i3), iterations: r2(x2), iact: r2(v2), message: S2 };
    }
    t4.solveQP = c2;
  })(numeric), numeric.svd = function(t4) {
    var n2, r2 = numeric.epsilon, i2 = 1e-64 / r2, a2 = 50, o2 = 0, s2 = 0, c2 = 0, l2 = 0, u2 = 0, d2 = numeric.clone(t4), p2 = d2.length, m2 = d2[0].length;
    if (p2 < m2) throw `Need more rows than columns`;
    var h2 = Array(m2), g2 = Array(m2);
    for (s2 = 0; s2 < m2; s2++) h2[s2] = g2[s2] = 0;
    var v2 = numeric.rep([m2, m2], 0);
    function y2(t5, n3) {
      return t5 = Math.abs(t5), n3 = Math.abs(n3), t5 > n3 ? t5 * Math.sqrt(1 + n3 * n3 / t5 / t5) : n3 == 0 ? t5 : n3 * Math.sqrt(1 + t5 * t5 / n3 / n3);
    }
    var b2 = 0, x2 = 0, S2 = 0, w2 = 0, E = 0, D = 0, O2 = 0;
    for (s2 = 0; s2 < m2; s2++) {
      for (h2[s2] = x2, O2 = 0, u2 = s2 + 1, c2 = s2; c2 < p2; c2++) O2 += d2[c2][s2] * d2[c2][s2];
      if (O2 <= i2) x2 = 0;
      else for (b2 = d2[s2][s2], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2] = b2 - x2, c2 = u2; c2 < m2; c2++) {
        for (O2 = 0, l2 = s2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
        for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
      }
      for (g2[s2] = x2, O2 = 0, c2 = u2; c2 < m2; c2++) O2 += d2[s2][c2] * d2[s2][c2];
      if (O2 <= i2) x2 = 0;
      else {
        for (b2 = d2[s2][s2 + 1], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2 + 1] = b2 - x2, c2 = u2; c2 < m2; c2++) h2[c2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < p2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[c2][l2] * d2[s2][l2];
          for (l2 = u2; l2 < m2; l2++) d2[c2][l2] += O2 * h2[l2];
        }
      }
      E = Math.abs(g2[s2]) + Math.abs(h2[s2]), E > w2 && (w2 = E);
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      if (x2 != 0) {
        for (S2 = x2 * d2[s2][s2 + 1], c2 = u2; c2 < m2; c2++) v2[c2][s2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[s2][l2] * v2[l2][c2];
          for (l2 = u2; l2 < m2; l2++) v2[l2][c2] += O2 * v2[l2][s2];
        }
      }
      for (c2 = u2; c2 < m2; c2++) v2[s2][c2] = 0, v2[c2][s2] = 0;
      v2[s2][s2] = 1, x2 = h2[s2], u2 = s2;
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      for (u2 = s2 + 1, x2 = g2[s2], c2 = u2; c2 < m2; c2++) d2[s2][c2] = 0;
      if (x2 != 0) {
        for (S2 = d2[s2][s2] * x2, c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
          for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
        }
        for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = d2[c2][s2] / x2;
      } else for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = 0;
      d2[s2][s2] += 1;
    }
    for (r2 *= w2, l2 = m2 - 1; l2 != -1; l2 += -1) for (var j2 = 0; j2 < a2; j2++) {
      var M2 = false;
      for (u2 = l2; u2 != -1; u2 += -1) {
        if (Math.abs(h2[u2]) <= r2) {
          M2 = true;
          break;
        }
        if (Math.abs(g2[u2 - 1]) <= r2) break;
      }
      if (!M2) {
        o2 = 0, O2 = 1;
        var N2 = u2 - 1;
        for (s2 = u2; s2 < l2 + 1 && (b2 = O2 * h2[s2], h2[s2] = o2 * h2[s2], !(Math.abs(b2) <= r2)); s2++) for (x2 = g2[s2], S2 = y2(b2, x2), g2[s2] = S2, o2 = x2 / S2, O2 = -b2 / S2, c2 = 0; c2 < p2; c2++) E = d2[c2][N2], D = d2[c2][s2], d2[c2][N2] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      if (D = g2[l2], u2 == l2) {
        if (D < 0) for (g2[l2] = -D, c2 = 0; c2 < m2; c2++) v2[c2][l2] = -v2[c2][l2];
        break;
      }
      if (j2 >= a2 - 1) throw `Error: no convergence.`;
      for (w2 = g2[u2], E = g2[l2 - 1], x2 = h2[l2 - 1], S2 = h2[l2], b2 = ((E - D) * (E + D) + (x2 - S2) * (x2 + S2)) / (2 * S2 * E), x2 = y2(b2, 1), b2 = b2 < 0 ? ((w2 - D) * (w2 + D) + S2 * (E / (b2 - x2) - S2)) / w2 : ((w2 - D) * (w2 + D) + S2 * (E / (b2 + x2) - S2)) / w2, o2 = 1, O2 = 1, s2 = u2 + 1; s2 < l2 + 1; s2++) {
        for (x2 = h2[s2], E = g2[s2], S2 = O2 * x2, x2 = o2 * x2, D = y2(b2, S2), h2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = w2 * o2 + x2 * O2, x2 = -w2 * O2 + x2 * o2, S2 = E * O2, E *= o2, c2 = 0; c2 < m2; c2++) w2 = v2[c2][s2 - 1], D = v2[c2][s2], v2[c2][s2 - 1] = w2 * o2 + D * O2, v2[c2][s2] = -w2 * O2 + D * o2;
        for (D = y2(b2, S2), g2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = o2 * x2 + O2 * E, w2 = -O2 * x2 + o2 * E, c2 = 0; c2 < p2; c2++) E = d2[c2][s2 - 1], D = d2[c2][s2], d2[c2][s2 - 1] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      h2[u2] = 0, h2[l2] = b2, g2[l2] = w2;
    }
    for (s2 = 0; s2 < g2.length; s2++) g2[s2] < r2 && (g2[s2] = 0);
    for (s2 = 0; s2 < m2; s2++) for (c2 = s2 - 1; c2 >= 0; c2--) if (g2[c2] < g2[s2]) {
      for (o2 = g2[c2], g2[c2] = g2[s2], g2[s2] = o2, l2 = 0; l2 < d2.length; l2++) n2 = d2[l2][s2], d2[l2][s2] = d2[l2][c2], d2[l2][c2] = n2;
      for (l2 = 0; l2 < v2.length; l2++) n2 = v2[l2][s2], v2[l2][s2] = v2[l2][c2], v2[l2][c2] = n2;
      s2 = c2;
    }
    return { U: d2, S: g2, V: v2 };
  };
})), import_numeric_1_2_6$2 = __toESM$2(require_numeric_1_2_6$2());
function createInstance$2({ define_e: t4 = true, define_pi: n2 = true, define_i: r2 = true, pow_strict: i2 = true } = {}) {
  let a2 = { ...all$2 };
  delete a2.createTau, delete a2.createPhi, t4 || delete a2.createE, n2 || delete a2.createPi, r2 || delete a2.createI;
  let o2 = create$1$2(a2);
  o2.import(import_numeric_1_2_6$2.default, { wrap: true, silent: true });
  var s2 = o2.pow;
  function c2(t5, n3) {
    return n3 === 0 && typeof t5 == `number` && (t5 === 0 || !Number.isFinite(t5)) ? NaN : s2(t5, n3);
  }
  return i2 ? o2.import({ pow: c2 }, { override: true }) : o2.import({ pow: s2 }, { override: true }), o2.define_e = t4, o2.define_pi = n2, o2.define_i = r2, o2.pow_strict = i2, o2;
}
var mathjs_default$2 = createInstance$2(), function_normalizations$2 = { ln: `log`, arccos: `acos`, arccosh: `acosh`, arcsin: `asin`, arcsinh: `asinh`, arctan: `atan`, arctanh: `atanh`, arcsec: `asec`, arcsech: `asech`, arccsc: `acsc`, arccsch: `acsch`, arccot: `acot`, arccoth: `acoth`, cosec: `csc` }, create_trig_inverses_for$2 = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`], move_exponents_outside_for$2 = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`, `log`, `ln`];
function normalize_function_names$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    if (i2[0] === `sqrt`) return [`^`, normalize_function_names$2(i2[1]), 0.5];
    if (i2[0] === `cbrt`) return [`^`, normalize_function_names$2(i2[1]), [`/`, 1, 3]];
    if (i2[0] === `nthroot`) return i2.length !== 2 || i2[1][0] !== `tuple` || i2[1].length !== 3 ? [`^`, normalize_function_names$2(i2[1]), 0.5] : [`^`, normalize_function_names$2(i2[1][1]), [`/`, 1, normalize_function_names$2(i2[1][2])]];
    var a2 = normalize_function_names_sub$2(i2[0]);
    a2 = [`apply`, a2];
    var o2 = i2.slice(1).map(function(t5) {
      return normalize_function_names$2(t5);
    });
    return o2 = o2.length > 1 ? [`tuple`].concat(o2) : o2[0], a2.push(o2), a2;
  }
  return r2 === `^` && i2[0] === `e` && mathjs_default$2.define_e ? [`apply`, `exp`, normalize_function_names$2(i2[1])] : r2 === `binom` ? [`apply`, `nCr`, [`tuple`, normalize_function_names$2(i2[0]), normalize_function_names$2(i2[1])]] : [r2].concat(i2.map(function(t5) {
    return normalize_function_names$2(t5);
  }));
}
function normalize_function_names_sub$2(t4) {
  if (typeof t4 == `string`) return t4 in function_normalizations$2 ? function_normalizations$2[t4] : t4;
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `^` && r2.length === 2 && r2[1] === -1) {
    let t5 = normalize_function_names_sub$2(r2[0]);
    if (create_trig_inverses_for$2.includes(t5)) return `a` + t5;
  }
  return [n2].concat(r2.map(function(t5) {
    return normalize_function_names_sub$2(t5);
  }));
}
function normalize_applied_functions$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    let t5 = i2[0];
    if (t5[0] === `^`) {
      let n4 = t5[1], r4 = t5[2];
      return r4 !== -1 && move_exponents_outside_for$2.includes(n4) ? [`^`, [`apply`, n4, normalize_applied_functions$2(i2[1])], r4] : [`apply`, t5, normalize_applied_functions$2(i2[1])];
    }
    let n3 = 0;
    for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
    let r3 = [`apply`, t5, normalize_applied_functions$2(i2[1])];
    for (let t6 = 0; t6 < n3; t6++) r3 = [`prime`, r3];
    return r3;
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return normalize_applied_functions$2(t5);
  }));
}
function log_subscript_to_two_arg_log$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply` && i2.length === 2) {
    let t5 = i2[0];
    if (Array.isArray(t5) && t5.length === 3 && t5[0] === `_` && t5[1] === `log`) return [`apply`, `log`, [`tuple`, i2[1], t5[2]]];
  }
  return [r2, ...i2.map(log_subscript_to_two_arg_log$2)];
}
function substitute_abs$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `apply` && i2[0] === `abs` ? [`^`, [`^`, substitute_abs$2(i2[1]), 2], 0.5] : [r2].concat(i2.map(function(t5) {
    return substitute_abs$2(t5);
  }));
}
function constants_to_floats$2(t4) {
  var n2 = get_tree$2(t4);
  if (!(mathjs_default$2.define_e || mathjs_default$2.define_pi)) return n2;
  if (typeof n2 == `string`) {
    if (n2 === `e`) {
      if (mathjs_default$2.define_e) return mathjs_default$2.e;
    } else if (n2 === `pi` && mathjs_default$2.define_pi) return mathjs_default$2.pi;
    return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `^` && i2[0] === `e` ? [`^`, `e`, constants_to_floats$2(i2[1])] : [r2, ...i2.map(constants_to_floats$2)];
}
function normalize_angle_linesegment_arg_order$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `angle` && i2.length === 3 && compare_function$2(i2[0], i2[2]) === 1 || r2 === `linesegment` && i2.length === 2 && compare_function$2(i2[0], i2[1]) === 1 ? (i2.reverse(), [r2, ...i2]) : [r2, ...i2.map(normalize_angle_linesegment_arg_order$2)];
}
function normalize_negative_numbers$2(t4) {
  var n2 = get_tree$2(t4);
  function r2(t5) {
    if (typeof t5 == `number` && t5 >= 0) return [-t5, true];
    if (!Array.isArray(t5)) return [t5, false];
    if (t5[0] === `*` && typeof t5[1] == `number` && t5[1] >= 0) return [[`*`, -t5[1], ...t5.slice(2).map(normalize_negative_numbers$2)], true];
    if (t5[0] === `/` && t5.length === 3) {
      let [n3, i3] = r2(t5[1]);
      if (i3) return [[`/`, n3, normalize_negative_numbers$2(t5[2])], true];
    }
    return [t5, false];
  }
  if (!Array.isArray(n2)) return n2;
  let i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `-` && a2.length === 1) {
    if (typeof a2[0] == `number` && a2[0] >= 0) return -a2[0];
    if (Array.isArray(a2[0]) && a2[0][0] === `*`) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`*`, t5, ...a2[0].slice(2).map(normalize_negative_numbers$2)];
    }
    if (Array.isArray(a2[0]) && a2[0][0] === `/` && a2[0].length === 3) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`/`, t5, normalize_negative_numbers$2(a2[0][2])];
    }
  }
  return [i2, ...a2.map(normalize_negative_numbers$2)];
}
function tuples_to_vectors$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple`) return [`vector`].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors$2(t5);
  }));
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = tuples_to_vectors$2(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return tuples_to_vectors$2(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return tuples_to_vectors$2(t6);
    })), n3];
  } else if (r2 === `matrix`) {
    let t5 = i2[0], n3 = i2[1];
    return t5 = [`tuple`].concat(t5.slice(1).map(tuples_to_vectors$2)), n3 = [`tuple`].concat(n3.slice(1).map((t6) => [`tuple`].concat(t6.slice(1).map(tuples_to_vectors$2)))), [`matrix`, t5, n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors$2(t5);
  }));
}
function to_intervals$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals$2(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, false, false]], t5;
  }
  if (r2 === `array` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals$2(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, true, true]], t5;
  }
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = to_intervals$2(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return to_intervals$2(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return to_intervals$2(t6);
    })), n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return to_intervals$2(t5);
  }));
}
function altvectors_to_vectors$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `altvector` ? [`vector`].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors$2(t5);
  })) : [r2].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors$2(t5);
  }));
}
function padNumberStringToDigits$2(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) {
    if (t4.includes(`.`)) {
      if (t4[0] === `0` ? r2 += t4.match(/^0\.0*/)[0].length : r2++, t4.length < r2) {
        let n3 = r2 - t4.length;
        t4 += `0`.repeat(n3);
      }
    } else if (t4.length < r2) {
      let n3 = r2 - t4.length;
      t4 += `.` + `0`.repeat(n3);
    }
  }
  return t4;
}
function padNumberStringToDecimals$2(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) if (t4.includes(`.`)) {
    let n3 = t4.match(/\.\d*$/)[0].length - 1;
    if (n3 < r2) {
      let i2 = r2 - n3;
      t4 += `0`.repeat(i2);
    }
  } else t4 += `.` + `0`.repeat(r2);
  return t4;
}
function padNumberStringToDigitsAndDecimals$2(t4, n2, r2) {
  let i2 = Math.floor(n2);
  if (!(i2 > 0)) return padNumberStringToDecimals$2(t4, r2);
  let a2 = Math.floor(r2);
  if (!(a2 > 0)) return padNumberStringToDigits$2(t4, n2);
  if (t4.includes(`.`)) {
    t4[0] === `0` ? i2 += t4.match(/^0\.0*/)[0].length : i2++;
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length);
    let r3 = t4.match(/\.\d*$/)[0].length - 1;
    r3 < a2 && (n3 = Math.max(n3, a2 - r3)), n3 > 0 && (t4 += `0`.repeat(n3));
  } else {
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length), n3 = Math.max(n3, a2), t4 += `.` + `0`.repeat(n3);
  }
  return t4;
}
function remove_leading_negative_factor$2(t4) {
  if (typeof t4 == `number` && t4 < 0) return [-t4, true];
  if (!Array.isArray(t4)) return [t4, false];
  if (t4[0] === `-` && t4.length === 2) return [t4[1], true];
  if (t4[0] === `*` && t4.length >= 2) {
    let n2 = t4[1];
    if (typeof n2 == `number` && n2 < 0) return [[`*`, -n2, ...t4.slice(2)], true];
    if (Array.isArray(n2) && n2[0] === `-` && n2.length === 2) return [[`*`, n2[1], ...t4.slice(2)], true];
  }
  return [t4, false];
}
function normalize_display_negative_fractions_sub$2(t4, { inside_unary_minus: n2 = false } = {}) {
  if (!Array.isArray(t4)) return t4;
  let r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `-` && i2.length === 1) return [`-`, normalize_display_negative_fractions_sub$2(i2[0], { inside_unary_minus: true })];
  if (r2 === `+`) return [`+`, ...i2.map((t5) => normalize_display_negative_fractions_sub$2(t5, { inside_unary_minus: false }))];
  if (r2 === `*`) {
    if (i2.length === 0) return t4;
    let n3 = [normalize_display_negative_fractions_sub$2(i2[0], { inside_unary_minus: false })];
    for (let t5 = 1; t5 < i2.length; t5 += 1) n3.push(normalize_display_negative_fractions_sub$2(i2[t5], { inside_unary_minus: false }));
    return [`*`, ...n3];
  }
  if (r2 === `/` && i2.length === 2) {
    let t5 = i2[0], r3 = i2[1];
    if (!n2) {
      let [n3, i3] = remove_leading_negative_factor$2(t5);
      if (i3) return [`-`, [`/`, normalize_display_negative_fractions_sub$2(n3, { inside_unary_minus: false }), normalize_display_negative_fractions_sub$2(r3, { inside_unary_minus: false })]];
    }
    return [`/`, normalize_display_negative_fractions_sub$2(t5, { inside_unary_minus: false }), normalize_display_negative_fractions_sub$2(r3, { inside_unary_minus: false })];
  }
  return [r2, ...i2.map((t5) => normalize_display_negative_fractions_sub$2(t5, { inside_unary_minus: false }))];
}
function normalize_display_negative_fractions$2(t4) {
  return normalize_display_negative_fractions_sub$2(t4, { inside_unary_minus: false });
}
function expandScientificNotation$2(t4) {
  let n2 = t4.indexOf(`e`);
  if (n2 === -1) return t4;
  let r2 = t4.substring(0, n2), i2 = Number(t4.substring(n2 + 1)), a2 = ``;
  (r2[0] === `-` || r2[0] === `+`) && (a2 = r2[0] === `-` ? `-` : ``, r2 = r2.substring(1));
  let o2 = r2.indexOf(`.`);
  o2 === -1 && (o2 = r2.length);
  let s2 = r2.replace(`.`, ``), c2 = o2 + i2;
  return c2 <= 0 ? a2 + `0.` + `0`.repeat(-c2) + s2 : c2 >= s2.length ? a2 + s2 + `0`.repeat(c2 - s2.length) : a2 + s2.substring(0, c2) + `.` + s2.substring(c2);
}
var unicode_operators$2 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `± ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `⟨ ` + t4.join(`, `) + ` ⟩`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` ≤ `);
}, ge: function(t4) {
  return t4.join(` ≥ `);
}, ne: function(t4) {
  return t4.join(` ≠ `);
}, forall: function(t4) {
  return `∀ ` + t4[0];
}, exists: function(t4) {
  return `∃ ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` ∈ ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` ∉ ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` ∋ ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` ∌ ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` ⊂ ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` ⊆ ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` ⊄ ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` ⊈ ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` ⊃ ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` ⊇ ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` ⊅ ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` ⊉ ` + t4[1];
}, union: function(t4) {
  return t4.join(` ∪ `);
}, intersect: function(t4) {
  return t4.join(` ∩ `);
}, rightarrow: function(t4) {
  return t4.join(` → `);
}, leftarrow: function(t4) {
  return t4.join(` ← `);
}, leftrightarrow: function(t4) {
  return t4.join(` ↔ `);
}, implies: function(t4) {
  return t4.join(` ⟹ `);
}, impliedby: function(t4) {
  return t4.join(` ⟸ `);
}, iff: function(t4) {
  return t4.join(` ⟺ `);
}, perp: function(t4) {
  return t4.join(` ⟂ `);
}, parallel: function(t4) {
  return t4.join(` ∥ `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `∠` + t4.join(``) : `∠( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, nonunicode_operators$2 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `plusminus ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` <= `);
}, ge: function(t4) {
  return t4.join(` >= `);
}, ne: function(t4) {
  return t4.join(` ne `);
}, forall: function(t4) {
  return `forall ` + t4[0];
}, exists: function(t4) {
  return `exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` elementof ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` notelementof ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` containselement ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` notcontainselement ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` notsubset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` notsubseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` superset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` superseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` notsuperset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` notsuperseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` union `);
}, intersect: function(t4) {
  return t4.join(` intersect `);
}, rightarrow: function(t4) {
  return t4.join(` rightarrow `);
}, leftarrow: function(t4) {
  return t4.join(` leftarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` leftrightarrow `);
}, implies: function(t4) {
  return t4.join(` implies `);
}, impliedby: function(t4) {
  return t4.join(` impliedby `);
}, iff: function(t4) {
  return t4.join(` iff `);
}, perp: function(t4) {
  return t4.join(` perp `);
}, parallel: function(t4) {
  return t4.join(` parallel `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `angle ` + t4.join(``) : `angle( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, output_unicodeDefault$2 = true, astToText$2$2 = class astToText$22 {
  constructor({ output_unicode: t4 = output_unicodeDefault$2, padToDigits: n2 = null, padToDecimals: r2 = null, avoidScientificNotation: i2 = false, showBlanks: a2 = true, explicitMultiplicationSymbols: o2 = false } = {}) {
    this.output_unicode = t4, this.operators = unicode_operators$2, t4 || (this.operators = nonunicode_operators$2), this.padToDigits = n2, this.padToDecimals = r2, this.avoidScientificNotation = i2, this.showBlanks = a2, this.explicitMultiplicationSymbols = o2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions$2(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `...`;
    if (!(n2 in this.operators) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? this.operators[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return this.operators[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? this.output_unicode ? a2 += ` ≤ ` : a2 += ` <= ` : this.output_unicode ? a2 += ` ≥ ` : a2 += ` >= `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : this.operators[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `-` || n2 === `pm`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    if (n2 === `*`) {
      let t5 = r2.map((function(t6, n3) {
        let i2;
        return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedOrExplicitPlus(t6), !this.explicitMultiplicationSymbols && i2.match(/^[0-9]/) ? `* ` + i2 : t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2) : (i2 = this.factor(t6), t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2);
      }).bind(this));
      return this.explicitMultiplicationSymbols ? t5.join(`*`) : this.operators[n2](t5);
    }
    if (n2 === `/`) {
      let t5 = this.factor(r2[0]), i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `(` + t5 + `)`), this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2 + `)`), this.operators[n2]([t5, i2]);
    }
    return n2 === `unit` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  symbolConvert(t4) {
    let n2 = { alpha: `α`, beta: `β`, Gamma: `Γ`, gamma: `γ`, Delta: `Δ`, delta: `δ`, epsilon: `ε`, zeta: `ζ`, eta: `η`, Theta: `ϴ`, theta: `θ`, iota: `ι`, kappa: `κ`, Lambda: `Λ`, lambda: `λ`, mu: `μ`, nu: `ν`, Xi: `Ξ`, xi: `ξ`, Pi: `Π`, pi: `π`, rho: `ρ`, Sigma: `Σ`, sigma: `σ`, tau: `τ`, Upsilon: `Υ`, upsilon: `υ`, Phi: `Φ`, phi: `ϕ`, Psi: `Ψ`, psi: `ψ`, Omega: `Ω`, omega: `ω`, perp: `⟂`, int: `∫`, emptyset: `∅` };
    return this.output_unicode && t4 in n2 ? n2[t4] : !this.showBlanks && t4 === `＿` ? `` : t4;
  }
  simple_factor_or_function_or_parens(t4) {
    let n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` || n2.match(/^\(.*\)$/) || n2.match(/^⟨.*⟩$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.symbolConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return this.output_unicode ? `∞` : `infinity`;
      if (t4 === -1 / 0) return this.output_unicode ? `-∞` : `-infinity`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation$2(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals$2(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals$2(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals$2(i2, this.padToDigits, t5);
          }
        }
        return a2[0] === `+` ? i2 + ` * 10^` + a2.substring(1) : i2 + ` * 10^(` + a2 + `)`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) {
        let t6;
        return t6 = r2[0] < 0 ? `(` + r2[0].toString() + `)` : r2[0].toString(), r2[1] < 0 ? t6 + `^(` + r2[1].toString() + `)` : t6 + `^` + r2[1].toString();
      }
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `(` + t5.toString() + `)`);
      let i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2.toString() + `)`), t5 + `^` + i2;
    } else if (n2 === `_`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.factor(t5);
      return this.simple_factor_or_function_or_parens(t5) ? r3 : `(` + r3 + `)`;
    }).bind(this)));
    else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `(` + i2 + `)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `-`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `[ ` + i2 : `( ` + i2, n3[2] ? i2 += ` ]` : i2 += ` )`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `[ `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        i2 += `[ `;
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += `,`), i2 += ` `;
        i2 += `]`, r3 < t5[1] - 1 && (i2 += `,`), i2 += ` `;
      }
      return i2 += `]`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `∂`);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 && (c2 = c2 + `^` + o2), c2 = c2 + this.symbolConvert(s2) + `/`;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.symbolConvert(o3), i3 > 1 && (c2 = c2 + `^` + i3);
      }
      return c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `|` + this.statement(r2[1]) + `|`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `(` + t6 + `)!`;
      }
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3 += ` ` + t7.map((t8) => `d` + this.factor(t8[1])).join(` `));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3 = this.factor(r2[0]), i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `(` + i2 + `)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return this.operators[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `(` + this.statement(t4) + `)`;
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) ? `(` + n2 + `)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    let n2 = this.term(t4);
    return n2.match(/^± /) || n2.match(/^plusminus /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, astToText$1$2 = new astToText$2$2();
function subscripts_to_strings$2(t4, n2 = false) {
  var r2 = get_tree$2(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  return i2 === `_` && (n2 || a2.every((t5) => [`number`, `string`].includes(typeof t5))) ? astToText$1$2.convert(r2) : [i2].concat(a2.map((t5) => subscripts_to_strings$2(t5, n2)));
}
function strings_to_subscripts$2(t4) {
  var n2 = get_tree$2(t4);
  if (typeof n2 == `string`) {
    let t5 = n2.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (t5) {
      let n3 = Number(t5[1]);
      isNaN(n3) && (n3 = t5[1]);
      let r3 = Number(t5[2]);
      return isNaN(r3) && (r3 = t5[2]), [`_`, n3, r3];
    } else return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return [r2].concat(i2.map(strings_to_subscripts$2));
}
var normalization_exports$2 = __exportAll$2({ altvectors_to_vectors: () => altvectors_to_vectors$2, constants_to_floats: () => constants_to_floats$2, default_order: () => default_order$2, log_subscript_to_two_arg_log: () => log_subscript_to_two_arg_log$2, normalize_angle_linesegment_arg_order: () => normalize_angle_linesegment_arg_order$2, normalize_applied_functions: () => normalize_applied_functions$2, normalize_function_names: () => normalize_function_names$2, normalize_negative_numbers: () => normalize_negative_numbers$2, strings_to_subscripts: () => strings_to_subscripts$2, subscripts_to_strings: () => subscripts_to_strings$2, substitute_abs: () => substitute_abs$2, to_intervals: () => to_intervals$2, tuples_to_vectors: () => tuples_to_vectors$2 });
function get_all_units$2() {
  return { "%": { scale: (t4) => [`/`, t4, 100], only_scales: true }, $: { prefix: true, scale: (t4) => t4 }, deg: { scale: (t4) => [`/`, [`*`, t4, `pi`], 180], only_scales: true } };
}
var all_units$1$2 = get_all_units$2();
function get_unit_of_tree$2(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1$2) if (all_units$1$2[n2].prefix) {
      if (t4[1] === n2) return n2;
    } else if (t4[2] === n2) return n2;
  }
  return null;
}
function get_unit_value_of_tree$2(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1$2) if (all_units$1$2[n2].prefix) {
      if (t4[1] === n2) return [n2, t4[2]];
    } else if (t4[2] === n2) return [n2, t4[1]];
  }
  return null;
}
function remove_duplicate_negatives$2(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `-` && Array.isArray(r2[0]) && r2[0][0] === `-` ? remove_duplicate_negatives$2(r2[0][1]) : n2 === `-` && typeof r2[0] == `number` && r2[0] < 0 ? -r2[0] : (r2 = r2.map(remove_duplicate_negatives$2), [n2].concat(r2));
}
function normalize_negatives_in_factors$2(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(normalize_negatives_in_factors$2), n2 !== `*` && n2 !== `/`) return [n2].concat(r2);
  for (var i2 = 1, a2 = [], o2 = 0; o2 < r2.length; o2++) Array.isArray(r2[o2]) && r2[o2][0] === `-` ? (i2 *= -1, a2.push(r2[o2][1])) : typeof r2[o2] == `number` && r2[o2] < 0 ? (i2 *= -1, a2.push(-r2[o2])) : a2.push(r2[o2]);
  var s2 = [n2].concat(a2);
  return i2 === -1 && (s2 = [`-`, s2]), s2;
}
function normalize_negatives$2(t4) {
  var n2 = get_tree$2(t4);
  return n2 = remove_duplicate_negatives$2(n2), n2 = normalize_negatives_in_factors$2(n2), n2 = remove_duplicate_negatives$2(n2), n2 = normalize_negative_numbers$2(n2), n2;
}
function sort_key$2(t4, n2 = {}) {
  if (typeof t4 == `number`) return n2.ignore_negatives ? [0, `number`, Math.abs(t4)] : [0, `number`, t4];
  if (typeof t4 == `string`) return t4 === `-` || t4 === `+` ? [8, `plus_minus_string`, t4] : [1, `symbol`, t4];
  if (typeof t4 == `boolean`) return [1, `boolean`, t4];
  if (!Array.isArray(t4)) return [-1, `unknown`, t4];
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `^` && i2.length === 2) return [...sort_key$2(i2[0], n2), `power`, ...sort_key$2(i2[1], n2)];
  if (r2 === `apply`) {
    var a2 = [2, `function`, i2[0]];
    (i2[0] === `sqrt` || i2[0] === `cbrt` || i2[0] === `nthroot`) && (a2 = [5, `root`, i2[0] === `sqrt` ? 2 : i2[0] === `cbrt` ? 3 : i2[1][2] ?? 2]);
    var o2 = i2[1], s2 = 1, c2 = [];
    return Array.isArray(o2) ? (o2 = o2.slice(1), s2 = o2.length, c2 = o2.map((t5) => sort_key$2(t5, n2))) : c2 = [sort_key$2(o2, n2)], a2.push([s2, c2]), a2;
  } else if (r2 === `unit`) {
    let [r3, i3] = get_unit_value_of_tree$2(t4);
    if (r3) {
      let t5 = sort_key$2(i3, n2);
      return t5[1] += `_` + r3, t5;
    }
  }
  var l2 = i2.length, u2 = i2.map(sort_key$2, n2);
  return r2 === `*` ? [4, `product`, l2, u2] : r2 === `/` ? [4, `quotient`, l2, u2] : r2 === `+` ? [5, `sum`, l2, u2] : r2 === `-` ? n2.ignore_negatives ? u2[0] : [6, `minus`, l2, u2] : r2 === `pm` ? n2.ignore_negatives ? u2[0] : [6, `pm`, l2, u2] : [`tuple`, `vector`, `altvector`].includes(r2) ? [7, l2, u2] : r2 === `interval` ? i2[1][1] === false ? i2[1][2] === false ? [7, ...u2[0].slice(1)] : [8, l2, u2] : i2[1][2] === false ? [8, l2, u2] : [9, ...u2[0].slice(1)] : r2 === `array` ? [9, l2, u2] : [10, r2, l2, u2];
}
function arrayCompare$2(t4, n2) {
  if (Array.isArray(t4)) if (Array.isArray(n2)) {
    let r2 = Math.min(t4.length, n2.length);
    for (let i2 = 0; i2 < r2; i2++) {
      let r3 = arrayCompare$2(t4[i2], n2[i2]);
      if (r3 !== 0) return r3;
    }
    return t4.length < n2.length ? -1 : +(t4.length > n2.length);
  } else return 1;
  else if (Array.isArray(n2)) return -1;
  else return t4 < n2 ? -1 : +(t4 > n2);
}
function compare_function$2(t4, n2, r2 = {}) {
  return arrayCompare$2(sort_key$2(t4, r2), sort_key$2(n2, r2));
}
function coeff_factors_from_term$2(t4, n2) {
  if (typeof t4 == `string`) {
    let r2 = n2.indexOf(t4);
    r2 === -1 && (n2.push(t4), r2 = n2.length - 1);
    let i2 = [];
    return i2[r2] = 1, { factor_contains: i2, coeff: 1 };
  } else if (Array.isArray(t4)) {
    let r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `*`) {
      let t5 = [], r3 = [];
      for (let a2 of i2) {
        if (typeof a2 == `string`) {
          let t6 = n2.indexOf(a2);
          t6 === -1 && (n2.push(a2), t6 = n2.length - 1), r3[t6] === void 0 && (r3[t6] = 0), r3[t6]++;
          continue;
        } else if (Array.isArray(a2) && (a2[0] === `^` || a2[0] === `-`)) {
          let i3 = coeff_factors_from_term$2(a2, n2);
          for (let t6 in i3.factor_contains) r3[t6] === void 0 && (r3[t6] = 0), r3[t6] += i3.factor_contains[t6];
          i3.coeff !== 1 && t5.push(i3.coeff);
          continue;
        }
        t5.push(a2);
      }
      return t5 = t5.length === 0 ? 1 : t5.length === 1 ? t5[0] : [`*`, ...t5], { factor_contains: r3, coeff: t5 };
    } else if (r2 === `^`) {
      let t5 = i2[0], r3 = i2[1], a2 = [];
      if (typeof t5 == `string` && Number.isFinite(r3)) {
        let i3 = n2.indexOf(t5);
        return i3 === -1 && (n2.push(t5), i3 = n2.length - 1), a2[i3] = r3, { factor_contains: a2, coeff: 1 };
      }
    } else if (r2 === `-`) {
      let t5 = coeff_factors_from_term$2(i2[0], n2), r3 = -1;
      return typeof t5.coeff == `number` ? r3 *= t5.coeff : r3 = [`-`, t5.coeff], { factor_contains: t5.factor_contains, coeff: r3 };
    } else if (r2 === `/`) {
      let t5 = coeff_factors_from_term$2(i2[0], n2), r3 = [`/`, t5.coeff, i2[1]];
      return { factor_contains: t5.factor_contains, coeff: r3 };
    }
  }
  return { factor_contains: [], coeff: t4 };
}
function default_order$2(t4, n2) {
  n2 === void 0 && (n2 = {});
  var r2 = get_tree$2(t4);
  r2 = flatten$5$2(r2), r2 = normalize_negatives$2(r2);
  function i2(t5) {
    if (!Array.isArray(t5)) return t5;
    var r3 = t5[0], a2 = t5.slice(1);
    if (a2 = a2.map(i2), r3 === `+`) {
      let t6 = [], r4 = [], i3 = [];
      for (let n3 of a2) {
        let a3 = coeff_factors_from_term$2(n3, t6);
        r4.push(a3.factor_contains), i3.push(a3.coeff);
      }
      let o3 = [];
      for (let [n3, i4] of t6.entries()) {
        let t7 = { varname: i4, exponents_in_term: [] };
        for (let i5 = 0; i5 < r4.length; i5++) t7.exponents_in_term.push(r4[i5][n3] || 0);
        o3.push(t7);
      }
      o3.sort((t7, n3) => t7.varname < n3.varname ? -1 : 1);
      let s3 = [];
      for (let t7 = 0; t7 < i3.length; t7++) {
        let r5 = o3.reduce((n3, r6) => [...n3, -r6.exponents_in_term[t7]], []);
        r5.push(sort_key$2(i3[t7], n2)), s3.push(r5);
      }
      let c2 = [];
      for (let [t7, n3] of a2.entries()) c2.push({ term: n3, sort_key: s3[t7] });
      c2.sort((t7, n3) => arrayCompare$2(t7.sort_key, n3.sort_key)), a2 = c2.map((t7) => t7.term);
    } else if (r3 === `*`) {
      let t6 = [], r4 = [];
      for (let n3 of a2) [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n3[0]) ? r4.push(n3) : t6.push(n3);
      t6.sort((t7, r5) => compare_function$2(t7, r5, n2)), a2 = [...t6, ...r4];
    } else if (r3 === `=` || r3 === `and` || r3 === `or` || r3 === `ne` || r3 === `union` || r3 === `intersect`) a2.sort((t6, r4) => compare_function$2(t6, r4, n2));
    else if (r3 === `>` || r3 === `ge`) a2 = a2.reverse(), r3 = r3 === `>` ? `<` : `le`;
    else if (r3 === `gts`) {
      var o2 = a2[0], s2 = a2[1];
      if (o2[0] !== `tuple` || s2[0] !== `tuple`) throw Error(`Badly formed ast`);
      o2 = [`tuple`].concat(o2.slice(1).reverse()), s2 = [`tuple`].concat(s2.slice(1).reverse()), r3 = `lts`, a2 = [o2, s2];
    } else if (r3 === `ni` || r3 === `notni` || r3 === `superset` || r3 === `notsuperset` || r3 === `superseteq` || r3 === `notsuperseteq`) a2 = a2.reverse(), r3 === `ni` ? r3 = `in` : r3 === `notni` ? r3 = `notin` : r3 === `superset` ? r3 = `subset` : r3 === `notsuperset` ? r3 = `notsubset` : r3 === `superseteq` ? r3 = `subseteq` : r3 === `notsuperseteq` && (r3 = `notsubseteq`);
    else if (r3 === `-` && a2[0][0] === `*`) return a2[0][1] = [`-`, a2[0][1]], a2[0];
    return [r3].concat(a2);
  }
  return normalize_negatives$2(i2(r2));
}
var variables_exports$2 = __exportAll$2({ functions: () => functions$2$2, operators: () => operators$3$2, variables: () => variables$2 });
function leaves$2(t4, n2) {
  if (!Array.isArray(t4)) return [t4];
  var r2 = t4[0], i2 = t4.slice(1);
  return n2 && r2 === `_` && typeof i2[0] == `string` && (typeof i2[1] == `string` || typeof i2[1] == `number`) ? [i2[0] + `_` + i2[1]] : (r2 === `apply` && (i2 = t4.slice(2)), i2.length === 0 ? [] : i2.map(function(t5, r3) {
    return leaves$2(t5, n2);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function variables$2(t4, n2 = false) {
  var r2 = leaves$2(get_tree$2(t4), n2);
  return r2 = r2.filter(function(t5, n3) {
    return typeof t5 == `string` && (mathjs_default$2.define_e || t5 !== `e`) && (mathjs_default$2.define_pi || t5 !== `pi`) && (mathjs_default$2.define_i || t5 !== `i`);
  }), r2 = r2.filter(function(t5, n3, i2) {
    return n3 === r2.indexOf(t5);
  }), r2;
}
function operators_list$2(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `apply` && (r2 = t4.slice(2)), r2.length === 0 ? [n2] : [n2].concat(r2.map(function(t5, n3) {
    return operators_list$2(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function operators$3$2(t4) {
  var n2 = operators_list$2(get_tree$2(t4));
  return n2 = n2.filter(function(t5, n3) {
    return t5 !== `apply`;
  }), n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
function functions_list$2(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1), i2 = [];
  return n2 === `apply` && (i2 = [r2[0]], r2 = t4.slice(2)), i2.concat(r2.map(function(t5, n3) {
    return functions_list$2(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }, []));
}
function functions$2$2(t4) {
  var n2 = functions_list$2(get_tree$2(t4));
  return n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
var VERSION$2, root$2, ArrayProto$2, ObjProto$2, SymbolProto$2, push$4, slice$2, toString$1$2, hasOwnProperty$6, supportsArrayBuffer$2, supportsDataView$2, nativeIsArray$2, nativeKeys$2, nativeCreate$2, nativeIsView$2, _isNaN$2, _isFinite$2, hasEnumBug$2, nonEnumerableProps$2, MAX_ARRAY_INDEX$2, init__setup$2 = __esmMin$2((() => {
  VERSION$2 = `1.13.6`, root$2 = typeof self == `object` && self.self === self && self || typeof global == `object` && global.global === global && global || Function(`return this`)() || {}, ArrayProto$2 = Array.prototype, ObjProto$2 = Object.prototype, SymbolProto$2 = typeof Symbol < `u` ? Symbol.prototype : null, push$4 = ArrayProto$2.push, slice$2 = ArrayProto$2.slice, toString$1$2 = ObjProto$2.toString, hasOwnProperty$6 = ObjProto$2.hasOwnProperty, supportsArrayBuffer$2 = typeof ArrayBuffer < `u`, supportsDataView$2 = typeof DataView < `u`, nativeIsArray$2 = Array.isArray, nativeKeys$2 = Object.keys, nativeCreate$2 = Object.create, nativeIsView$2 = supportsArrayBuffer$2 && ArrayBuffer.isView, _isNaN$2 = isNaN, _isFinite$2 = isFinite, hasEnumBug$2 = !{ toString: null }.propertyIsEnumerable(`toString`), nonEnumerableProps$2 = [`valueOf`, `isPrototypeOf`, `toString`, `propertyIsEnumerable`, `hasOwnProperty`, `toLocaleString`], MAX_ARRAY_INDEX$2 = 2 ** 53 - 1;
}));
function restArguments$2(t4, n2) {
  return n2 = n2 == null ? t4.length - 1 : +n2, function() {
    for (var r2 = Math.max(arguments.length - n2, 0), i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = arguments[a2 + n2];
    switch (n2) {
      case 0:
        return t4.call(this, i2);
      case 1:
        return t4.call(this, arguments[0], i2);
      case 2:
        return t4.call(this, arguments[0], arguments[1], i2);
    }
    var o2 = Array(n2 + 1);
    for (a2 = 0; a2 < n2; a2++) o2[a2] = arguments[a2];
    return o2[n2] = i2, t4.apply(this, o2);
  };
}
var init_restArguments$2 = __esmMin$2((() => {
}));
function isObject$4(t4) {
  var n2 = typeof t4;
  return n2 === `function` || n2 === `object` && !!t4;
}
var init_isObject$2 = __esmMin$2((() => {
}));
function isNull$3(t4) {
  return t4 === null;
}
var init_isNull$2 = __esmMin$2((() => {
}));
function isUndefined$3(t4) {
  return t4 === void 0;
}
var init_isUndefined$2 = __esmMin$2((() => {
}));
function isBoolean$5(t4) {
  return t4 === true || t4 === false || toString$1$2.call(t4) === `[object Boolean]`;
}
var init_isBoolean$2 = __esmMin$2((() => {
  init__setup$2();
}));
function isElement$6(t4) {
  return !!(t4 && t4.nodeType === 1);
}
var init_isElement$2 = __esmMin$2((() => {
}));
function tagTester$2(t4) {
  var n2 = `[object ` + t4 + `]`;
  return function(t5) {
    return toString$1$2.call(t5) === n2;
  };
}
var init__tagTester$2 = __esmMin$2((() => {
  init__setup$2();
})), isString_default$2, init_isString$2 = __esmMin$2((() => {
  init__tagTester$2(), isString_default$2 = tagTester$2(`String`);
})), isNumber_default$2, init_isNumber$2 = __esmMin$2((() => {
  init__tagTester$2(), isNumber_default$2 = tagTester$2(`Number`);
})), isDate_default$2, init_isDate$2 = __esmMin$2((() => {
  init__tagTester$2(), isDate_default$2 = tagTester$2(`Date`);
})), isRegExp_default$2, init_isRegExp$2 = __esmMin$2((() => {
  init__tagTester$2(), isRegExp_default$2 = tagTester$2(`RegExp`);
})), isError_default$2, init_isError$2 = __esmMin$2((() => {
  init__tagTester$2(), isError_default$2 = tagTester$2(`Error`);
})), isSymbol_default$2, init_isSymbol$2 = __esmMin$2((() => {
  init__tagTester$2(), isSymbol_default$2 = tagTester$2(`Symbol`);
})), isArrayBuffer_default$2, init_isArrayBuffer$2 = __esmMin$2((() => {
  init__tagTester$2(), isArrayBuffer_default$2 = tagTester$2(`ArrayBuffer`);
})), isFunction$4, nodelist$2, isFunction_default$2, init_isFunction$2 = __esmMin$2((() => {
  init__tagTester$2(), init__setup$2(), isFunction$4 = tagTester$2(`Function`), nodelist$2 = root$2.document && root$2.document.childNodes, typeof /./ != `function` && typeof Int8Array != `object` && typeof nodelist$2 != `function` && (isFunction$4 = function(t4) {
    return typeof t4 == `function` || false;
  }), isFunction_default$2 = isFunction$4;
})), _hasObjectTag_default$2, init__hasObjectTag$2 = __esmMin$2((() => {
  init__tagTester$2(), _hasObjectTag_default$2 = tagTester$2(`Object`);
})), hasStringTagBug$2, isIE11$2, init__stringTagBug$2 = __esmMin$2((() => {
  init__setup$2(), init__hasObjectTag$2(), hasStringTagBug$2 = supportsDataView$2 && _hasObjectTag_default$2(new DataView(new ArrayBuffer(8))), isIE11$2 = typeof Map < `u` && _hasObjectTag_default$2(/* @__PURE__ */ new Map());
}));
function ie10IsDataView$2(t4) {
  return t4 != null && isFunction_default$2(t4.getInt8) && isArrayBuffer_default$2(t4.buffer);
}
var isDataView$2, isDataView_default$2, init_isDataView$2 = __esmMin$2((() => {
  init__tagTester$2(), init_isFunction$2(), init_isArrayBuffer$2(), init__stringTagBug$2(), isDataView$2 = tagTester$2(`DataView`), isDataView_default$2 = hasStringTagBug$2 ? ie10IsDataView$2 : isDataView$2;
})), isArray_default$2, init_isArray$2 = __esmMin$2((() => {
  init__setup$2(), init__tagTester$2(), isArray_default$2 = nativeIsArray$2 || tagTester$2(`Array`);
}));
function has$1$2(t4, n2) {
  return t4 != null && hasOwnProperty$6.call(t4, n2);
}
var init__has$2 = __esmMin$2((() => {
  init__setup$2();
})), isArguments$2, isArguments_default$2, init_isArguments$2 = __esmMin$2((() => {
  init__tagTester$2(), init__has$2(), isArguments$2 = tagTester$2(`Arguments`), (function() {
    isArguments$2(arguments) || (isArguments$2 = function(t4) {
      return has$1$2(t4, `callee`);
    });
  })(), isArguments_default$2 = isArguments$2;
}));
function isFinite$1$2(t4) {
  return !isSymbol_default$2(t4) && _isFinite$2(t4) && !isNaN(parseFloat(t4));
}
var init_isFinite$2 = __esmMin$2((() => {
  init__setup$2(), init_isSymbol$2();
}));
function isNaN$1$2(t4) {
  return isNumber_default$2(t4) && _isNaN$2(t4);
}
var init_isNaN$2 = __esmMin$2((() => {
  init__setup$2(), init_isNumber$2();
}));
function constant$2(t4) {
  return function() {
    return t4;
  };
}
var init_constant$2 = __esmMin$2((() => {
}));
function createSizePropertyCheck$2(t4) {
  return function(n2) {
    var r2 = t4(n2);
    return typeof r2 == `number` && r2 >= 0 && r2 <= MAX_ARRAY_INDEX$2;
  };
}
var init__createSizePropertyCheck$2 = __esmMin$2((() => {
  init__setup$2();
}));
function shallowProperty$2(t4) {
  return function(n2) {
    return n2?.[t4];
  };
}
var init__shallowProperty$2 = __esmMin$2((() => {
})), _getByteLength_default$2, init__getByteLength$2 = __esmMin$2((() => {
  init__shallowProperty$2(), _getByteLength_default$2 = shallowProperty$2(`byteLength`);
})), _isBufferLike_default$2, init__isBufferLike$2 = __esmMin$2((() => {
  init__createSizePropertyCheck$2(), init__getByteLength$2(), _isBufferLike_default$2 = createSizePropertyCheck$2(_getByteLength_default$2);
}));
function isTypedArray$2(t4) {
  return nativeIsView$2 ? nativeIsView$2(t4) && !isDataView_default$2(t4) : _isBufferLike_default$2(t4) && typedArrayPattern$2.test(toString$1$2.call(t4));
}
var typedArrayPattern$2, isTypedArray_default$2, init_isTypedArray$2 = __esmMin$2((() => {
  init__setup$2(), init_isDataView$2(), init_constant$2(), init__isBufferLike$2(), typedArrayPattern$2 = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/, isTypedArray_default$2 = supportsArrayBuffer$2 ? isTypedArray$2 : constant$2(false);
})), _getLength_default$2, init__getLength$2 = __esmMin$2((() => {
  init__shallowProperty$2(), _getLength_default$2 = shallowProperty$2(`length`);
}));
function emulatedSet$2(t4) {
  for (var n2 = {}, r2 = t4.length, i2 = 0; i2 < r2; ++i2) n2[t4[i2]] = true;
  return { contains: function(t5) {
    return n2[t5] === true;
  }, push: function(r3) {
    return n2[r3] = true, t4.push(r3);
  } };
}
function collectNonEnumProps$2(t4, n2) {
  n2 = emulatedSet$2(n2);
  var r2 = nonEnumerableProps$2.length, i2 = t4.constructor, a2 = isFunction_default$2(i2) && i2.prototype || ObjProto$2, o2 = `constructor`;
  for (has$1$2(t4, o2) && !n2.contains(o2) && n2.push(o2); r2--; ) o2 = nonEnumerableProps$2[r2], o2 in t4 && t4[o2] !== a2[o2] && !n2.contains(o2) && n2.push(o2);
}
var init__collectNonEnumProps$2 = __esmMin$2((() => {
  init__setup$2(), init_isFunction$2(), init__has$2();
}));
function keys$3(t4) {
  if (!isObject$4(t4)) return [];
  if (nativeKeys$2) return nativeKeys$2(t4);
  var n2 = [];
  for (var r2 in t4) has$1$2(t4, r2) && n2.push(r2);
  return hasEnumBug$2 && collectNonEnumProps$2(t4, n2), n2;
}
var init_keys$2 = __esmMin$2((() => {
  init_isObject$2(), init__setup$2(), init__has$2(), init__collectNonEnumProps$2();
}));
function isEmpty$2(t4) {
  if (t4 == null) return true;
  var n2 = _getLength_default$2(t4);
  return typeof n2 == `number` && (isArray_default$2(t4) || isString_default$2(t4) || isArguments_default$2(t4)) ? n2 === 0 : _getLength_default$2(keys$3(t4)) === 0;
}
var init_isEmpty$2 = __esmMin$2((() => {
  init__getLength$2(), init_isArray$2(), init_isString$2(), init_isArguments$2(), init_keys$2();
}));
function isMatch$2(t4, n2) {
  var r2 = keys$3(n2), i2 = r2.length;
  if (t4 == null) return !i2;
  for (var a2 = Object(t4), o2 = 0; o2 < i2; o2++) {
    var s2 = r2[o2];
    if (n2[s2] !== a2[s2] || !(s2 in a2)) return false;
  }
  return true;
}
var init_isMatch$2 = __esmMin$2((() => {
  init_keys$2();
}));
function _$1$2(t4) {
  if (t4 instanceof _$1$2) return t4;
  if (!(this instanceof _$1$2)) return new _$1$2(t4);
  this._wrapped = t4;
}
var init_underscore$2 = __esmMin$2((() => {
  init__setup$2(), _$1$2.VERSION = VERSION$2, _$1$2.prototype.value = function() {
    return this._wrapped;
  }, _$1$2.prototype.valueOf = _$1$2.prototype.toJSON = _$1$2.prototype.value, _$1$2.prototype.toString = function() {
    return String(this._wrapped);
  };
}));
function toBufferView$2(t4) {
  return new Uint8Array(t4.buffer || t4, t4.byteOffset || 0, _getByteLength_default$2(t4));
}
var init__toBufferView$2 = __esmMin$2((() => {
  init__getByteLength$2();
}));
function eq$2(t4, n2, r2, i2) {
  if (t4 === n2) return t4 !== 0 || 1 / t4 == 1 / n2;
  if (t4 == null || n2 == null) return false;
  if (t4 !== t4) return n2 !== n2;
  var a2 = typeof t4;
  return a2 !== `function` && a2 !== `object` && typeof n2 != `object` ? false : deepEq$2(t4, n2, r2, i2);
}
function deepEq$2(t4, n2, r2, i2) {
  t4 instanceof _$1$2 && (t4 = t4._wrapped), n2 instanceof _$1$2 && (n2 = n2._wrapped);
  var a2 = toString$1$2.call(t4);
  if (a2 !== toString$1$2.call(n2)) return false;
  if (hasStringTagBug$2 && a2 == `[object Object]` && isDataView_default$2(t4)) {
    if (!isDataView_default$2(n2)) return false;
    a2 = tagDataView$2;
  }
  switch (a2) {
    case `[object RegExp]`:
    case `[object String]`:
      return `` + t4 == `` + n2;
    case `[object Number]`:
      return +t4 == +t4 ? +t4 == 0 ? 1 / t4 == 1 / n2 : +t4 == +n2 : +n2 != +n2;
    case `[object Date]`:
    case `[object Boolean]`:
      return +t4 == +n2;
    case `[object Symbol]`:
      return SymbolProto$2.valueOf.call(t4) === SymbolProto$2.valueOf.call(n2);
    case `[object ArrayBuffer]`:
    case tagDataView$2:
      return deepEq$2(toBufferView$2(t4), toBufferView$2(n2), r2, i2);
  }
  var o2 = a2 === `[object Array]`;
  if (!o2 && isTypedArray_default$2(t4)) {
    if (_getByteLength_default$2(t4) !== _getByteLength_default$2(n2)) return false;
    if (t4.buffer === n2.buffer && t4.byteOffset === n2.byteOffset) return true;
    o2 = true;
  }
  if (!o2) {
    if (typeof t4 != `object` || typeof n2 != `object`) return false;
    var s2 = t4.constructor, c2 = n2.constructor;
    if (s2 !== c2 && !(isFunction_default$2(s2) && s2 instanceof s2 && isFunction_default$2(c2) && c2 instanceof c2) && `constructor` in t4 && `constructor` in n2) return false;
  }
  r2 ||= [], i2 ||= [];
  for (var l2 = r2.length; l2--; ) if (r2[l2] === t4) return i2[l2] === n2;
  if (r2.push(t4), i2.push(n2), o2) {
    if (l2 = t4.length, l2 !== n2.length) return false;
    for (; l2--; ) if (!eq$2(t4[l2], n2[l2], r2, i2)) return false;
  } else {
    var u2 = keys$3(t4), d2;
    if (l2 = u2.length, keys$3(n2).length !== l2) return false;
    for (; l2--; ) if (d2 = u2[l2], !(has$1$2(n2, d2) && eq$2(t4[d2], n2[d2], r2, i2))) return false;
  }
  return r2.pop(), i2.pop(), true;
}
function isEqual$2(t4, n2) {
  return eq$2(t4, n2);
}
var tagDataView$2, init_isEqual$2 = __esmMin$2((() => {
  init_underscore$2(), init__setup$2(), init__getByteLength$2(), init_isTypedArray$2(), init_isFunction$2(), init__stringTagBug$2(), init_isDataView$2(), init_keys$2(), init__has$2(), init__toBufferView$2(), tagDataView$2 = `[object DataView]`;
}));
function allKeys$2(t4) {
  if (!isObject$4(t4)) return [];
  var n2 = [];
  for (var r2 in t4) n2.push(r2);
  return hasEnumBug$2 && collectNonEnumProps$2(t4, n2), n2;
}
var init_allKeys$2 = __esmMin$2((() => {
  init_isObject$2(), init__setup$2(), init__collectNonEnumProps$2();
}));
function ie11fingerprint$2(t4) {
  var n2 = _getLength_default$2(t4);
  return function(r2) {
    if (r2 == null || _getLength_default$2(allKeys$2(r2))) return false;
    for (var i2 = 0; i2 < n2; i2++) if (!isFunction_default$2(r2[t4[i2]])) return false;
    return t4 !== weakMapMethods$2 || !isFunction_default$2(r2[forEachName$2]);
  };
}
var forEachName$2, hasName$2, commonInit$2, mapTail$2, mapMethods$2, weakMapMethods$2, setMethods$2, init__methodFingerprint$2 = __esmMin$2((() => {
  init__getLength$2(), init_isFunction$2(), init_allKeys$2(), forEachName$2 = `forEach`, hasName$2 = `has`, commonInit$2 = [`clear`, `delete`], mapTail$2 = [`get`, hasName$2, `set`], mapMethods$2 = commonInit$2.concat(forEachName$2, mapTail$2), weakMapMethods$2 = commonInit$2.concat(mapTail$2), setMethods$2 = [`add`].concat(commonInit$2, forEachName$2, hasName$2);
})), isMap_default$2, init_isMap$2 = __esmMin$2((() => {
  init__tagTester$2(), init__stringTagBug$2(), init__methodFingerprint$2(), isMap_default$2 = isIE11$2 ? ie11fingerprint$2(mapMethods$2) : tagTester$2(`Map`);
})), isWeakMap_default$2, init_isWeakMap$2 = __esmMin$2((() => {
  init__tagTester$2(), init__stringTagBug$2(), init__methodFingerprint$2(), isWeakMap_default$2 = isIE11$2 ? ie11fingerprint$2(weakMapMethods$2) : tagTester$2(`WeakMap`);
})), isSet_default$2, init_isSet$2 = __esmMin$2((() => {
  init__tagTester$2(), init__stringTagBug$2(), init__methodFingerprint$2(), isSet_default$2 = isIE11$2 ? ie11fingerprint$2(setMethods$2) : tagTester$2(`Set`);
})), isWeakSet_default$2, init_isWeakSet$2 = __esmMin$2((() => {
  init__tagTester$2(), isWeakSet_default$2 = tagTester$2(`WeakSet`);
}));
function values$2(t4) {
  for (var n2 = keys$3(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = t4[n2[a2]];
  return i2;
}
var init_values$2 = __esmMin$2((() => {
  init_keys$2();
}));
function pairs$2(t4) {
  for (var n2 = keys$3(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = [n2[a2], t4[n2[a2]]];
  return i2;
}
var init_pairs$2 = __esmMin$2((() => {
  init_keys$2();
}));
function invert$2(t4) {
  for (var n2 = {}, r2 = keys$3(t4), i2 = 0, a2 = r2.length; i2 < a2; i2++) n2[t4[r2[i2]]] = r2[i2];
  return n2;
}
var init_invert$2 = __esmMin$2((() => {
  init_keys$2();
}));
function functions$1$2(t4) {
  var n2 = [];
  for (var r2 in t4) isFunction_default$2(t4[r2]) && n2.push(r2);
  return n2.sort();
}
var init_functions$2 = __esmMin$2((() => {
  init_isFunction$2();
}));
function createAssigner$2(t4, n2) {
  return function(r2) {
    var i2 = arguments.length;
    if (n2 && (r2 = Object(r2)), i2 < 2 || r2 == null) return r2;
    for (var a2 = 1; a2 < i2; a2++) for (var o2 = arguments[a2], s2 = t4(o2), c2 = s2.length, l2 = 0; l2 < c2; l2++) {
      var u2 = s2[l2];
      (!n2 || r2[u2] === void 0) && (r2[u2] = o2[u2]);
    }
    return r2;
  };
}
var init__createAssigner$2 = __esmMin$2((() => {
})), extend_default$2, init_extend$2 = __esmMin$2((() => {
  init__createAssigner$2(), init_allKeys$2(), extend_default$2 = createAssigner$2(allKeys$2);
})), extendOwn_default$2, init_extendOwn$2 = __esmMin$2((() => {
  init__createAssigner$2(), init_keys$2(), extendOwn_default$2 = createAssigner$2(keys$3);
})), defaults_default$2, init_defaults$2 = __esmMin$2((() => {
  init__createAssigner$2(), init_allKeys$2(), defaults_default$2 = createAssigner$2(allKeys$2, true);
}));
function ctor$2() {
  return function() {
  };
}
function baseCreate$2(t4) {
  if (!isObject$4(t4)) return {};
  if (nativeCreate$2) return nativeCreate$2(t4);
  var n2 = ctor$2();
  n2.prototype = t4;
  var r2 = new n2();
  return n2.prototype = null, r2;
}
var init__baseCreate$2 = __esmMin$2((() => {
  init_isObject$2(), init__setup$2();
}));
function create$3(t4, n2) {
  var r2 = baseCreate$2(t4);
  return n2 && extendOwn_default$2(r2, n2), r2;
}
var init_create$2 = __esmMin$2((() => {
  init__baseCreate$2(), init_extendOwn$2();
}));
function clone$5(t4) {
  return isObject$4(t4) ? isArray_default$2(t4) ? t4.slice() : extend_default$2({}, t4) : t4;
}
var init_clone$2 = __esmMin$2((() => {
  init_isObject$2(), init_isArray$2(), init_extend$2();
}));
function tap$2(t4, n2) {
  return n2(t4), t4;
}
var init_tap$2 = __esmMin$2((() => {
}));
function toPath$1$2(t4) {
  return isArray_default$2(t4) ? t4 : [t4];
}
var init_toPath$2 = __esmMin$2((() => {
  init_underscore$2(), init_isArray$2(), _$1$2.toPath = toPath$1$2;
}));
function toPath$3(t4) {
  return _$1$2.toPath(t4);
}
var init__toPath$2 = __esmMin$2((() => {
  init_underscore$2(), init_toPath$2();
}));
function deepGet$2(t4, n2) {
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    if (t4 == null) return;
    t4 = t4[n2[i2]];
  }
  return r2 ? t4 : void 0;
}
var init__deepGet$2 = __esmMin$2((() => {
}));
function get$5(t4, n2, r2) {
  var i2 = deepGet$2(t4, toPath$3(n2));
  return isUndefined$3(i2) ? r2 : i2;
}
var init_get$2 = __esmMin$2((() => {
  init__toPath$2(), init__deepGet$2(), init_isUndefined$2();
}));
function has$4(t4, n2) {
  n2 = toPath$3(n2);
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    var a2 = n2[i2];
    if (!has$1$2(t4, a2)) return false;
    t4 = t4[a2];
  }
  return !!r2;
}
var init_has$2 = __esmMin$2((() => {
  init__has$2(), init__toPath$2();
}));
function identity$4(t4) {
  return t4;
}
var init_identity$2 = __esmMin$2((() => {
}));
function matcher$2(t4) {
  return t4 = extendOwn_default$2({}, t4), function(n2) {
    return isMatch$2(n2, t4);
  };
}
var init_matcher$2 = __esmMin$2((() => {
  init_extendOwn$2(), init_isMatch$2();
}));
function property$2(t4) {
  return t4 = toPath$3(t4), function(n2) {
    return deepGet$2(n2, t4);
  };
}
var init_property$2 = __esmMin$2((() => {
  init__deepGet$2(), init__toPath$2();
}));
function optimizeCb$2(t4, n2, r2) {
  if (n2 === void 0) return t4;
  switch (r2 ?? 3) {
    case 1:
      return function(r3) {
        return t4.call(n2, r3);
      };
    case 3:
      return function(r3, i2, a2) {
        return t4.call(n2, r3, i2, a2);
      };
    case 4:
      return function(r3, i2, a2, o2) {
        return t4.call(n2, r3, i2, a2, o2);
      };
  }
  return function() {
    return t4.apply(n2, arguments);
  };
}
var init__optimizeCb$2 = __esmMin$2((() => {
}));
function baseIteratee$2(t4, n2, r2) {
  return t4 == null ? identity$4 : isFunction_default$2(t4) ? optimizeCb$2(t4, n2, r2) : isObject$4(t4) && !isArray_default$2(t4) ? matcher$2(t4) : property$2(t4);
}
var init__baseIteratee$2 = __esmMin$2((() => {
  init_identity$2(), init_isFunction$2(), init_isObject$2(), init_isArray$2(), init_matcher$2(), init_property$2(), init__optimizeCb$2();
}));
function iteratee$2(t4, n2) {
  return baseIteratee$2(t4, n2, 1 / 0);
}
var init_iteratee$2 = __esmMin$2((() => {
  init_underscore$2(), init__baseIteratee$2(), _$1$2.iteratee = iteratee$2;
}));
function cb$2(t4, n2, r2) {
  return _$1$2.iteratee === iteratee$2 ? baseIteratee$2(t4, n2, r2) : _$1$2.iteratee(t4, n2);
}
var init__cb$2 = __esmMin$2((() => {
  init_underscore$2(), init__baseIteratee$2(), init_iteratee$2();
}));
function mapObject$3(t4, n2, r2) {
  n2 = cb$2(n2, r2);
  for (var i2 = keys$3(t4), a2 = i2.length, o2 = {}, s2 = 0; s2 < a2; s2++) {
    var c2 = i2[s2];
    o2[c2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_mapObject$2 = __esmMin$2((() => {
  init__cb$2(), init_keys$2();
}));
function noop$6() {
}
var init_noop$2 = __esmMin$2((() => {
}));
function propertyOf$2(t4) {
  return t4 == null ? noop$6 : function(n2) {
    return get$5(t4, n2);
  };
}
var init_propertyOf$2 = __esmMin$2((() => {
  init_noop$2(), init_get$2();
}));
function times$2(t4, n2, r2) {
  var i2 = Array(Math.max(0, t4));
  n2 = optimizeCb$2(n2, r2, 1);
  for (var a2 = 0; a2 < t4; a2++) i2[a2] = n2(a2);
  return i2;
}
var init_times$2 = __esmMin$2((() => {
  init__optimizeCb$2();
}));
function random$3(t4, n2) {
  return n2 ?? (n2 = t4, t4 = 0), t4 + Math.floor(Math.random() * (n2 - t4 + 1));
}
var init_random$2 = __esmMin$2((() => {
})), now_default$2, init_now$2 = __esmMin$2((() => {
  now_default$2 = Date.now || function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}));
function createEscaper$2(t4) {
  var n2 = function(n3) {
    return t4[n3];
  }, r2 = `(?:` + keys$3(t4).join(`|`) + `)`, i2 = RegExp(r2), a2 = RegExp(r2, `g`);
  return function(t5) {
    return t5 = t5 == null ? `` : `` + t5, i2.test(t5) ? t5.replace(a2, n2) : t5;
  };
}
var init__createEscaper$2 = __esmMin$2((() => {
  init_keys$2();
})), _escapeMap_default$2, init__escapeMap$2 = __esmMin$2((() => {
  _escapeMap_default$2 = { "&": `&amp;`, "<": `&lt;`, ">": `&gt;`, '"': `&quot;`, "'": `&#x27;`, "`": `&#x60;` };
})), escape_default$2, init_escape$2 = __esmMin$2((() => {
  init__createEscaper$2(), init__escapeMap$2(), escape_default$2 = createEscaper$2(_escapeMap_default$2);
})), _unescapeMap_default$2, init__unescapeMap$2 = __esmMin$2((() => {
  init_invert$2(), init__escapeMap$2(), _unescapeMap_default$2 = invert$2(_escapeMap_default$2);
})), unescape_default$2, init_unescape$2 = __esmMin$2((() => {
  init__createEscaper$2(), init__unescapeMap$2(), unescape_default$2 = createEscaper$2(_unescapeMap_default$2);
})), templateSettings_default$2, init_templateSettings$2 = __esmMin$2((() => {
  init_underscore$2(), templateSettings_default$2 = _$1$2.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g };
}));
function escapeChar$2(t4) {
  return `\\` + escapes$2[t4];
}
function template$2(t4, n2, r2) {
  !n2 && r2 && (n2 = r2), n2 = defaults_default$2({}, n2, _$1$2.templateSettings);
  var i2 = RegExp([(n2.escape || noMatch$2).source, (n2.interpolate || noMatch$2).source, (n2.evaluate || noMatch$2).source].join(`|`) + `|$`, `g`), a2 = 0, o2 = `__p+='`;
  t4.replace(i2, function(n3, r3, i3, s3, c3) {
    return o2 += t4.slice(a2, c3).replace(escapeRegExp$2, escapeChar$2), a2 = c3 + n3.length, r3 ? o2 += `'+
((__t=(` + r3 + `))==null?'':_.escape(__t))+
'` : i3 ? o2 += `'+
((__t=(` + i3 + `))==null?'':__t)+
'` : s3 && (o2 += `';
` + s3 + `
__p+='`), n3;
  }), o2 += `';
`;
  var s2 = n2.variable;
  if (s2) {
    if (!bareIdentifier$2.test(s2)) throw Error(`variable is not a bare identifier: ` + s2);
  } else o2 = `with(obj||{}){
` + o2 + `}
`, s2 = `obj`;
  o2 = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + o2 + `return __p;
`;
  var c2;
  try {
    c2 = Function(s2, `_`, o2);
  } catch (t5) {
    throw t5.source = o2, t5;
  }
  var l2 = function(t5) {
    return c2.call(this, t5, _$1$2);
  };
  return l2.source = `function(` + s2 + `){
` + o2 + `}`, l2;
}
var noMatch$2, escapes$2, escapeRegExp$2, bareIdentifier$2, init_template$2 = __esmMin$2((() => {
  init_defaults$2(), init_underscore$2(), init_templateSettings$2(), noMatch$2 = /(.)^/, escapes$2 = { "'": `'`, "\\": `\\`, "\r": `r`, "\n": `n`, "\u2028": `u2028`, "\u2029": `u2029` }, escapeRegExp$2 = /\\|'|\r|\n|\u2028|\u2029/g, bareIdentifier$2 = /^\s*(\w|\$)+\s*$/;
}));
function result$2(t4, n2, r2) {
  n2 = toPath$3(n2);
  var i2 = n2.length;
  if (!i2) return isFunction_default$2(r2) ? r2.call(t4) : r2;
  for (var a2 = 0; a2 < i2; a2++) {
    var o2 = t4?.[n2[a2]];
    o2 === void 0 && (o2 = r2, a2 = i2), t4 = isFunction_default$2(o2) ? o2.call(t4) : o2;
  }
  return t4;
}
var init_result$2 = __esmMin$2((() => {
  init_isFunction$2(), init__toPath$2();
}));
function uniqueId$2(t4) {
  var n2 = ++idCounter$2 + ``;
  return t4 ? t4 + n2 : n2;
}
var idCounter$2, init_uniqueId$2 = __esmMin$2((() => {
  idCounter$2 = 0;
}));
function chain$4(t4) {
  var n2 = _$1$2(t4);
  return n2._chain = true, n2;
}
var init_chain$2 = __esmMin$2((() => {
  init_underscore$2();
}));
function executeBound$2(t4, n2, r2, i2, a2) {
  if (!(i2 instanceof n2)) return t4.apply(r2, a2);
  var o2 = baseCreate$2(t4.prototype), s2 = t4.apply(o2, a2);
  return isObject$4(s2) ? s2 : o2;
}
var init__executeBound$2 = __esmMin$2((() => {
  init__baseCreate$2(), init_isObject$2();
})), partial$2, init_partial$2 = __esmMin$2((() => {
  init_restArguments$2(), init__executeBound$2(), init_underscore$2(), partial$2 = restArguments$2(function(t4, n2) {
    var r2 = partial$2.placeholder, i2 = function() {
      for (var a2 = 0, o2 = n2.length, s2 = Array(o2), c2 = 0; c2 < o2; c2++) s2[c2] = n2[c2] === r2 ? arguments[a2++] : n2[c2];
      for (; a2 < arguments.length; ) s2.push(arguments[a2++]);
      return executeBound$2(t4, i2, this, this, s2);
    };
    return i2;
  }), partial$2.placeholder = _$1$2;
})), bind_default$2, init_bind$2 = __esmMin$2((() => {
  init_restArguments$2(), init_isFunction$2(), init__executeBound$2(), bind_default$2 = restArguments$2(function(t4, n2, r2) {
    if (!isFunction_default$2(t4)) throw TypeError(`Bind must be called on a function`);
    var i2 = restArguments$2(function(a2) {
      return executeBound$2(t4, i2, n2, this, r2.concat(a2));
    });
    return i2;
  });
})), _isArrayLike_default$2, init__isArrayLike$2 = __esmMin$2((() => {
  init__createSizePropertyCheck$2(), init__getLength$2(), _isArrayLike_default$2 = createSizePropertyCheck$2(_getLength_default$2);
}));
function flatten$3$2(t4, n2, r2, i2) {
  if (i2 ||= [], !n2 && n2 !== 0) n2 = 1 / 0;
  else if (n2 <= 0) return i2.concat(t4);
  for (var a2 = i2.length, o2 = 0, s2 = _getLength_default$2(t4); o2 < s2; o2++) {
    var c2 = t4[o2];
    if (_isArrayLike_default$2(c2) && (isArray_default$2(c2) || isArguments_default$2(c2))) if (n2 > 1) flatten$3$2(c2, n2 - 1, r2, i2), a2 = i2.length;
    else for (var l2 = 0, u2 = c2.length; l2 < u2; ) i2[a2++] = c2[l2++];
    else r2 || (i2[a2++] = c2);
  }
  return i2;
}
var init__flatten$2 = __esmMin$2((() => {
  init__getLength$2(), init__isArrayLike$2(), init_isArray$2(), init_isArguments$2();
})), bindAll_default$2, init_bindAll$2 = __esmMin$2((() => {
  init_restArguments$2(), init__flatten$2(), init_bind$2(), bindAll_default$2 = restArguments$2(function(t4, n2) {
    n2 = flatten$3$2(n2, false, false);
    var r2 = n2.length;
    if (r2 < 1) throw Error(`bindAll must be passed function names`);
    for (; r2--; ) {
      var i2 = n2[r2];
      t4[i2] = bind_default$2(t4[i2], t4);
    }
    return t4;
  });
}));
function memoize$3(t4, n2) {
  var r2 = function(i2) {
    var a2 = r2.cache, o2 = `` + (n2 ? n2.apply(this, arguments) : i2);
    return has$1$2(a2, o2) || (a2[o2] = t4.apply(this, arguments)), a2[o2];
  };
  return r2.cache = {}, r2;
}
var init_memoize$2 = __esmMin$2((() => {
  init__has$2();
})), delay_default$2, init_delay$2 = __esmMin$2((() => {
  init_restArguments$2(), delay_default$2 = restArguments$2(function(t4, n2, r2) {
    return setTimeout(function() {
      return t4.apply(null, r2);
    }, n2);
  });
})), defer_default$2, init_defer$2 = __esmMin$2((() => {
  init_partial$2(), init_delay$2(), init_underscore$2(), defer_default$2 = partial$2(delay_default$2, _$1$2, 1);
}));
function throttle$2(t4, n2, r2) {
  var i2, a2, o2, s2, c2 = 0;
  r2 ||= {};
  var l2 = function() {
    c2 = r2.leading === false ? 0 : now_default$2(), i2 = null, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null);
  }, u2 = function() {
    var u3 = now_default$2();
    !c2 && r2.leading === false && (c2 = u3);
    var d2 = n2 - (u3 - c2);
    return a2 = this, o2 = arguments, d2 <= 0 || d2 > n2 ? (i2 &&= (clearTimeout(i2), null), c2 = u3, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null)) : !i2 && r2.trailing !== false && (i2 = setTimeout(l2, d2)), s2;
  };
  return u2.cancel = function() {
    clearTimeout(i2), c2 = 0, i2 = a2 = o2 = null;
  }, u2;
}
var init_throttle$2 = __esmMin$2((() => {
  init_now$2();
}));
function debounce$3(t4, n2, r2) {
  var i2, a2, o2, s2, c2, l2 = function() {
    var u3 = now_default$2() - a2;
    n2 > u3 ? i2 = setTimeout(l2, n2 - u3) : (i2 = null, r2 || (s2 = t4.apply(c2, o2)), i2 || (o2 = c2 = null));
  }, u2 = restArguments$2(function(u3) {
    return c2 = this, o2 = u3, a2 = now_default$2(), i2 || (i2 = setTimeout(l2, n2), r2 && (s2 = t4.apply(c2, o2))), s2;
  });
  return u2.cancel = function() {
    clearTimeout(i2), i2 = o2 = c2 = null;
  }, u2;
}
var init_debounce$2 = __esmMin$2((() => {
  init_restArguments$2(), init_now$2();
}));
function wrap$5(t4, n2) {
  return partial$2(n2, t4);
}
var init_wrap$2 = __esmMin$2((() => {
  init_partial$2();
}));
function negate$2(t4) {
  return function() {
    return !t4.apply(this, arguments);
  };
}
var init_negate$2 = __esmMin$2((() => {
}));
function compose$3() {
  var t4 = arguments, n2 = t4.length - 1;
  return function() {
    for (var r2 = n2, i2 = t4[n2].apply(this, arguments); r2--; ) i2 = t4[r2].call(this, i2);
    return i2;
  };
}
var init_compose$2 = __esmMin$2((() => {
}));
function after$2(t4, n2) {
  return function() {
    if (--t4 < 1) return n2.apply(this, arguments);
  };
}
var init_after$2 = __esmMin$2((() => {
}));
function before$2(t4, n2) {
  var r2;
  return function() {
    return --t4 > 0 && (r2 = n2.apply(this, arguments)), t4 <= 1 && (n2 = null), r2;
  };
}
var init_before$2 = __esmMin$2((() => {
})), once_default$2, init_once$2 = __esmMin$2((() => {
  init_partial$2(), init_before$2(), once_default$2 = partial$2(before$2, 2);
}));
function findKey$2(t4, n2, r2) {
  n2 = cb$2(n2, r2);
  for (var i2 = keys$3(t4), a2, o2 = 0, s2 = i2.length; o2 < s2; o2++) if (a2 = i2[o2], n2(t4[a2], a2, t4)) return a2;
}
var init_findKey$2 = __esmMin$2((() => {
  init__cb$2(), init_keys$2();
}));
function createPredicateIndexFinder$2(t4) {
  return function(n2, r2, i2) {
    r2 = cb$2(r2, i2);
    for (var a2 = _getLength_default$2(n2), o2 = t4 > 0 ? 0 : a2 - 1; o2 >= 0 && o2 < a2; o2 += t4) if (r2(n2[o2], o2, n2)) return o2;
    return -1;
  };
}
var init__createPredicateIndexFinder$2 = __esmMin$2((() => {
  init__cb$2(), init__getLength$2();
})), findIndex_default$2, init_findIndex$2 = __esmMin$2((() => {
  init__createPredicateIndexFinder$2(), findIndex_default$2 = createPredicateIndexFinder$2(1);
})), findLastIndex_default$2, init_findLastIndex$2 = __esmMin$2((() => {
  init__createPredicateIndexFinder$2(), findLastIndex_default$2 = createPredicateIndexFinder$2(-1);
}));
function sortedIndex$2(t4, n2, r2, i2) {
  r2 = cb$2(r2, i2, 1);
  for (var a2 = r2(n2), o2 = 0, s2 = _getLength_default$2(t4); o2 < s2; ) {
    var c2 = Math.floor((o2 + s2) / 2);
    r2(t4[c2]) < a2 ? o2 = c2 + 1 : s2 = c2;
  }
  return o2;
}
var init_sortedIndex$2 = __esmMin$2((() => {
  init__cb$2(), init__getLength$2();
}));
function createIndexFinder$2(t4, n2, r2) {
  return function(i2, a2, o2) {
    var s2 = 0, c2 = _getLength_default$2(i2);
    if (typeof o2 == `number`) t4 > 0 ? s2 = o2 >= 0 ? o2 : Math.max(o2 + c2, s2) : c2 = o2 >= 0 ? Math.min(o2 + 1, c2) : o2 + c2 + 1;
    else if (r2 && o2 && c2) return o2 = r2(i2, a2), i2[o2] === a2 ? o2 : -1;
    if (a2 !== a2) return o2 = n2(slice$2.call(i2, s2, c2), isNaN$1$2), o2 >= 0 ? o2 + s2 : -1;
    for (o2 = t4 > 0 ? s2 : c2 - 1; o2 >= 0 && o2 < c2; o2 += t4) if (i2[o2] === a2) return o2;
    return -1;
  };
}
var init__createIndexFinder$2 = __esmMin$2((() => {
  init__getLength$2(), init__setup$2(), init_isNaN$2();
})), indexOf_default$2, init_indexOf$2 = __esmMin$2((() => {
  init_sortedIndex$2(), init_findIndex$2(), init__createIndexFinder$2(), indexOf_default$2 = createIndexFinder$2(1, findIndex_default$2, sortedIndex$2);
})), lastIndexOf_default$2, init_lastIndexOf$2 = __esmMin$2((() => {
  init_findLastIndex$2(), init__createIndexFinder$2(), lastIndexOf_default$2 = createIndexFinder$2(-1, findLastIndex_default$2);
}));
function find$3(t4, n2, r2) {
  var i2 = (_isArrayLike_default$2(t4) ? findIndex_default$2 : findKey$2)(t4, n2, r2);
  if (i2 !== void 0 && i2 !== -1) return t4[i2];
}
var init_find$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_findIndex$2(), init_findKey$2();
}));
function findWhere$2(t4, n2) {
  return find$3(t4, matcher$2(n2));
}
var init_findWhere$2 = __esmMin$2((() => {
  init_find$2(), init_matcher$2();
}));
function each$3(t4, n2, r2) {
  n2 = optimizeCb$2(n2, r2);
  var i2, a2;
  if (_isArrayLike_default$2(t4)) for (i2 = 0, a2 = t4.length; i2 < a2; i2++) n2(t4[i2], i2, t4);
  else {
    var o2 = keys$3(t4);
    for (i2 = 0, a2 = o2.length; i2 < a2; i2++) n2(t4[o2[i2]], o2[i2], t4);
  }
  return t4;
}
var init_each$2 = __esmMin$2((() => {
  init__optimizeCb$2(), init__isArrayLike$2(), init_keys$2();
}));
function map$3(t4, n2, r2) {
  n2 = cb$2(n2, r2);
  for (var i2 = !_isArrayLike_default$2(t4) && keys$3(t4), a2 = (i2 || t4).length, o2 = Array(a2), s2 = 0; s2 < a2; s2++) {
    var c2 = i2 ? i2[s2] : s2;
    o2[s2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_map$2 = __esmMin$2((() => {
  init__cb$2(), init__isArrayLike$2(), init_keys$2();
}));
function createReduce$2(t4) {
  var n2 = function(n3, r2, i2, a2) {
    var o2 = !_isArrayLike_default$2(n3) && keys$3(n3), s2 = (o2 || n3).length, c2 = t4 > 0 ? 0 : s2 - 1;
    for (a2 || (i2 = n3[o2 ? o2[c2] : c2], c2 += t4); c2 >= 0 && c2 < s2; c2 += t4) {
      var l2 = o2 ? o2[c2] : c2;
      i2 = r2(i2, n3[l2], l2, n3);
    }
    return i2;
  };
  return function(t5, r2, i2, a2) {
    var o2 = arguments.length >= 3;
    return n2(t5, optimizeCb$2(r2, a2, 4), i2, o2);
  };
}
var init__createReduce$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_keys$2(), init__optimizeCb$2();
})), reduce_default$2, init_reduce$2 = __esmMin$2((() => {
  init__createReduce$2(), reduce_default$2 = createReduce$2(1);
})), reduceRight_default$2, init_reduceRight$2 = __esmMin$2((() => {
  init__createReduce$2(), reduceRight_default$2 = createReduce$2(-1);
}));
function filter$3(t4, n2, r2) {
  var i2 = [];
  return n2 = cb$2(n2, r2), each$3(t4, function(t5, r3, a2) {
    n2(t5, r3, a2) && i2.push(t5);
  }), i2;
}
var init_filter$2 = __esmMin$2((() => {
  init__cb$2(), init_each$2();
}));
function reject$2(t4, n2, r2) {
  return filter$3(t4, negate$2(cb$2(n2)), r2);
}
var init_reject$2 = __esmMin$2((() => {
  init_filter$2(), init_negate$2(), init__cb$2();
}));
function every$2(t4, n2, r2) {
  n2 = cb$2(n2, r2);
  for (var i2 = !_isArrayLike_default$2(t4) && keys$3(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (!n2(t4[s2], s2, t4)) return false;
  }
  return true;
}
var init_every$2 = __esmMin$2((() => {
  init__cb$2(), init__isArrayLike$2(), init_keys$2();
}));
function some$2(t4, n2, r2) {
  n2 = cb$2(n2, r2);
  for (var i2 = !_isArrayLike_default$2(t4) && keys$3(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (n2(t4[s2], s2, t4)) return true;
  }
  return false;
}
var init_some$2 = __esmMin$2((() => {
  init__cb$2(), init__isArrayLike$2(), init_keys$2();
}));
function contains$5(t4, n2, r2, i2) {
  return _isArrayLike_default$2(t4) || (t4 = values$2(t4)), (typeof r2 != `number` || i2) && (r2 = 0), indexOf_default$2(t4, n2, r2) >= 0;
}
var init_contains$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_values$2(), init_indexOf$2();
})), invoke_default$2, init_invoke$2 = __esmMin$2((() => {
  init_restArguments$2(), init_isFunction$2(), init_map$2(), init__deepGet$2(), init__toPath$2(), invoke_default$2 = restArguments$2(function(t4, n2, r2) {
    var i2, a2;
    return isFunction_default$2(n2) ? a2 = n2 : (n2 = toPath$3(n2), i2 = n2.slice(0, -1), n2 = n2[n2.length - 1]), map$3(t4, function(t5) {
      var o2 = a2;
      if (!o2) {
        if (i2 && i2.length && (t5 = deepGet$2(t5, i2)), t5 == null) return;
        o2 = t5[n2];
      }
      return o2 == null ? o2 : o2.apply(t5, r2);
    });
  });
}));
function pluck$2(t4, n2) {
  return map$3(t4, property$2(n2));
}
var init_pluck$2 = __esmMin$2((() => {
  init_map$2(), init_property$2();
}));
function where$2(t4, n2) {
  return filter$3(t4, matcher$2(n2));
}
var init_where$2 = __esmMin$2((() => {
  init_filter$2(), init_matcher$2();
}));
function max$4(t4, n2, r2) {
  var i2 = -1 / 0, a2 = -1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default$2(t4) ? t4 : values$2(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 > i2 && (i2 = o2);
  } else n2 = cb$2(n2, r2), each$3(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 > a2 || s2 === -1 / 0 && i2 === -1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_max$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_values$2(), init__cb$2(), init_each$2();
}));
function min$4(t4, n2, r2) {
  var i2 = 1 / 0, a2 = 1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default$2(t4) ? t4 : values$2(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 < i2 && (i2 = o2);
  } else n2 = cb$2(n2, r2), each$3(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 < a2 || s2 === 1 / 0 && i2 === 1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_min$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_values$2(), init__cb$2(), init_each$2();
}));
function toArray$3(t4) {
  return t4 ? isArray_default$2(t4) ? slice$2.call(t4) : isString_default$2(t4) ? t4.match(reStrSymbol$2) : _isArrayLike_default$2(t4) ? map$3(t4, identity$4) : values$2(t4) : [];
}
var reStrSymbol$2, init_toArray$2 = __esmMin$2((() => {
  init_isArray$2(), init__setup$2(), init_isString$2(), init__isArrayLike$2(), init_map$2(), init_identity$2(), init_values$2(), reStrSymbol$2 = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
}));
function sample$2(t4, n2, r2) {
  if (n2 == null || r2) return _isArrayLike_default$2(t4) || (t4 = values$2(t4)), t4[random$3(t4.length - 1)];
  var i2 = toArray$3(t4), a2 = _getLength_default$2(i2);
  n2 = Math.max(Math.min(n2, a2), 0);
  for (var o2 = a2 - 1, s2 = 0; s2 < n2; s2++) {
    var c2 = random$3(s2, o2), l2 = i2[s2];
    i2[s2] = i2[c2], i2[c2] = l2;
  }
  return i2.slice(0, n2);
}
var init_sample$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_values$2(), init__getLength$2(), init_random$2(), init_toArray$2();
}));
function shuffle$2(t4) {
  return sample$2(t4, 1 / 0);
}
var init_shuffle$2 = __esmMin$2((() => {
  init_sample$2();
}));
function sortBy$2(t4, n2, r2) {
  var i2 = 0;
  return n2 = cb$2(n2, r2), pluck$2(map$3(t4, function(t5, r3, a2) {
    return { value: t5, index: i2++, criteria: n2(t5, r3, a2) };
  }).sort(function(t5, n3) {
    var r3 = t5.criteria, i3 = n3.criteria;
    if (r3 !== i3) {
      if (r3 > i3 || r3 === void 0) return 1;
      if (r3 < i3 || i3 === void 0) return -1;
    }
    return t5.index - n3.index;
  }), `value`);
}
var init_sortBy$2 = __esmMin$2((() => {
  init__cb$2(), init_pluck$2(), init_map$2();
}));
function group$4(t4, n2) {
  return function(r2, i2, a2) {
    var o2 = n2 ? [[], []] : {};
    return i2 = cb$2(i2, a2), each$3(r2, function(n3, a3) {
      t4(o2, n3, i2(n3, a3, r2));
    }), o2;
  };
}
var init__group$2 = __esmMin$2((() => {
  init__cb$2(), init_each$2();
})), groupBy_default$2, init_groupBy$2 = __esmMin$2((() => {
  init__group$2(), init__has$2(), groupBy_default$2 = group$4(function(t4, n2, r2) {
    has$1$2(t4, r2) ? t4[r2].push(n2) : t4[r2] = [n2];
  });
})), indexBy_default$2, init_indexBy$2 = __esmMin$2((() => {
  init__group$2(), indexBy_default$2 = group$4(function(t4, n2, r2) {
    t4[r2] = n2;
  });
})), countBy_default$2, init_countBy$2 = __esmMin$2((() => {
  init__group$2(), init__has$2(), countBy_default$2 = group$4(function(t4, n2, r2) {
    has$1$2(t4, r2) ? t4[r2]++ : t4[r2] = 1;
  });
})), partition_default$2, init_partition$2 = __esmMin$2((() => {
  init__group$2(), partition_default$2 = group$4(function(t4, n2, r2) {
    t4[+!r2].push(n2);
  }, true);
}));
function size$4(t4) {
  return t4 == null ? 0 : _isArrayLike_default$2(t4) ? t4.length : keys$3(t4).length;
}
var init_size$2 = __esmMin$2((() => {
  init__isArrayLike$2(), init_keys$2();
}));
function keyInObj$2(t4, n2, r2) {
  return n2 in r2;
}
var init__keyInObj$2 = __esmMin$2((() => {
})), pick_default$2, init_pick$2 = __esmMin$2((() => {
  init_restArguments$2(), init_isFunction$2(), init__optimizeCb$2(), init_allKeys$2(), init__keyInObj$2(), init__flatten$2(), pick_default$2 = restArguments$2(function(t4, n2) {
    var r2 = {}, i2 = n2[0];
    if (t4 == null) return r2;
    isFunction_default$2(i2) ? (n2.length > 1 && (i2 = optimizeCb$2(i2, n2[1])), n2 = allKeys$2(t4)) : (i2 = keyInObj$2, n2 = flatten$3$2(n2, false, false), t4 = Object(t4));
    for (var a2 = 0, o2 = n2.length; a2 < o2; a2++) {
      var s2 = n2[a2], c2 = t4[s2];
      i2(c2, s2, t4) && (r2[s2] = c2);
    }
    return r2;
  });
})), omit_default$2, init_omit$2 = __esmMin$2((() => {
  init_restArguments$2(), init_isFunction$2(), init_negate$2(), init_map$2(), init__flatten$2(), init_contains$2(), init_pick$2(), omit_default$2 = restArguments$2(function(t4, n2) {
    var r2 = n2[0], i2;
    return isFunction_default$2(r2) ? (r2 = negate$2(r2), n2.length > 1 && (i2 = n2[1])) : (n2 = map$3(flatten$3$2(n2, false, false), String), r2 = function(t5, r3) {
      return !contains$5(n2, r3);
    }), pick_default$2(t4, r2, i2);
  });
}));
function initial$2(t4, n2, r2) {
  return slice$2.call(t4, 0, Math.max(0, t4.length - (n2 == null || r2 ? 1 : n2)));
}
var init_initial$2 = __esmMin$2((() => {
  init__setup$2();
}));
function first$2(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[0] : initial$2(t4, t4.length - n2);
}
var init_first$2 = __esmMin$2((() => {
  init_initial$2();
}));
function rest$2(t4, n2, r2) {
  return slice$2.call(t4, n2 == null || r2 ? 1 : n2);
}
var init_rest$2 = __esmMin$2((() => {
  init__setup$2();
}));
function last$2(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[t4.length - 1] : rest$2(t4, Math.max(0, t4.length - n2));
}
var init_last$2 = __esmMin$2((() => {
  init_rest$2();
}));
function compact$2(t4) {
  return filter$3(t4, Boolean);
}
var init_compact$2 = __esmMin$2((() => {
  init_filter$2();
}));
function flatten$2$2(t4, n2) {
  return flatten$3$2(t4, n2, false);
}
var init_flatten$2 = __esmMin$2((() => {
  init__flatten$2();
})), difference_default$2, init_difference$2 = __esmMin$2((() => {
  init_restArguments$2(), init__flatten$2(), init_filter$2(), init_contains$2(), difference_default$2 = restArguments$2(function(t4, n2) {
    return n2 = flatten$3$2(n2, true, true), filter$3(t4, function(t5) {
      return !contains$5(n2, t5);
    });
  });
})), without_default$2, init_without$2 = __esmMin$2((() => {
  init_restArguments$2(), init_difference$2(), without_default$2 = restArguments$2(function(t4, n2) {
    return difference_default$2(t4, n2);
  });
}));
function uniq$2(t4, n2, r2, i2) {
  isBoolean$5(n2) || (i2 = r2, r2 = n2, n2 = false), r2 != null && (r2 = cb$2(r2, i2));
  for (var a2 = [], o2 = [], s2 = 0, c2 = _getLength_default$2(t4); s2 < c2; s2++) {
    var l2 = t4[s2], u2 = r2 ? r2(l2, s2, t4) : l2;
    n2 && !r2 ? ((!s2 || o2 !== u2) && a2.push(l2), o2 = u2) : r2 ? contains$5(o2, u2) || (o2.push(u2), a2.push(l2)) : contains$5(a2, l2) || a2.push(l2);
  }
  return a2;
}
var init_uniq$2 = __esmMin$2((() => {
  init_isBoolean$2(), init__cb$2(), init__getLength$2(), init_contains$2();
})), union_default$2, init_union$2 = __esmMin$2((() => {
  init_restArguments$2(), init_uniq$2(), init__flatten$2(), union_default$2 = restArguments$2(function(t4) {
    return uniq$2(flatten$3$2(t4, true, true));
  });
}));
function intersection$2(t4) {
  for (var n2 = [], r2 = arguments.length, i2 = 0, a2 = _getLength_default$2(t4); i2 < a2; i2++) {
    var o2 = t4[i2];
    if (!contains$5(n2, o2)) {
      var s2;
      for (s2 = 1; s2 < r2 && contains$5(arguments[s2], o2); s2++) ;
      s2 === r2 && n2.push(o2);
    }
  }
  return n2;
}
var init_intersection$2 = __esmMin$2((() => {
  init__getLength$2(), init_contains$2();
}));
function unzip$2(t4) {
  for (var n2 = t4 && max$4(t4, _getLength_default$2).length || 0, r2 = Array(n2), i2 = 0; i2 < n2; i2++) r2[i2] = pluck$2(t4, i2);
  return r2;
}
var init_unzip$2 = __esmMin$2((() => {
  init_max$2(), init__getLength$2(), init_pluck$2();
})), zip_default$2, init_zip$2 = __esmMin$2((() => {
  init_restArguments$2(), init_unzip$2(), zip_default$2 = restArguments$2(unzip$2);
}));
function object$2(t4, n2) {
  for (var r2 = {}, i2 = 0, a2 = _getLength_default$2(t4); i2 < a2; i2++) n2 ? r2[t4[i2]] = n2[i2] : r2[t4[i2][0]] = t4[i2][1];
  return r2;
}
var init_object$2 = __esmMin$2((() => {
  init__getLength$2();
}));
function range$2(t4, n2, r2) {
  n2 ?? (n2 = t4 || 0, t4 = 0), r2 ||= n2 < t4 ? -1 : 1;
  for (var i2 = Math.max(Math.ceil((n2 - t4) / r2), 0), a2 = Array(i2), o2 = 0; o2 < i2; o2++, t4 += r2) a2[o2] = t4;
  return a2;
}
var init_range$2 = __esmMin$2((() => {
}));
function chunk$2(t4, n2) {
  if (n2 == null || n2 < 1) return [];
  for (var r2 = [], i2 = 0, a2 = t4.length; i2 < a2; ) r2.push(slice$2.call(t4, i2, i2 += n2));
  return r2;
}
var init_chunk$2 = __esmMin$2((() => {
  init__setup$2();
}));
function chainResult$2(t4, n2) {
  return t4._chain ? _$1$2(n2).chain() : n2;
}
var init__chainResult$2 = __esmMin$2((() => {
  init_underscore$2();
}));
function mixin$3(t4) {
  return each$3(functions$1$2(t4), function(n2) {
    var r2 = _$1$2[n2] = t4[n2];
    _$1$2.prototype[n2] = function() {
      var t5 = [this._wrapped];
      return push$4.apply(t5, arguments), chainResult$2(this, r2.apply(_$1$2, t5));
    };
  }), _$1$2;
}
var init_mixin$2 = __esmMin$2((() => {
  init_underscore$2(), init_each$2(), init_functions$2(), init__setup$2(), init__chainResult$2();
})), underscore_array_methods_default$2, init_underscore_array_methods$2 = __esmMin$2((() => {
  init_underscore$2(), init_each$2(), init__setup$2(), init__chainResult$2(), each$3([`pop`, `push`, `reverse`, `shift`, `sort`, `splice`, `unshift`], function(t4) {
    var n2 = ArrayProto$2[t4];
    _$1$2.prototype[t4] = function() {
      var r2 = this._wrapped;
      return r2 != null && (n2.apply(r2, arguments), (t4 === `shift` || t4 === `splice`) && r2.length === 0 && delete r2[0]), chainResult$2(this, r2);
    };
  }), each$3([`concat`, `join`, `slice`], function(t4) {
    var n2 = ArrayProto$2[t4];
    _$1$2.prototype[t4] = function() {
      var t5 = this._wrapped;
      return t5 != null && (t5 = n2.apply(t5, arguments)), chainResult$2(this, t5);
    };
  }), underscore_array_methods_default$2 = _$1$2;
})), modules_exports$2 = __exportAll$2({ VERSION: () => VERSION$2, after: () => after$2, all: () => every$2, allKeys: () => allKeys$2, any: () => some$2, assign: () => extendOwn_default$2, before: () => before$2, bind: () => bind_default$2, bindAll: () => bindAll_default$2, chain: () => chain$4, chunk: () => chunk$2, clone: () => clone$5, collect: () => map$3, compact: () => compact$2, compose: () => compose$3, constant: () => constant$2, contains: () => contains$5, countBy: () => countBy_default$2, create: () => create$3, debounce: () => debounce$3, default: () => underscore_array_methods_default$2, defaults: () => defaults_default$2, defer: () => defer_default$2, delay: () => delay_default$2, detect: () => find$3, difference: () => difference_default$2, drop: () => rest$2, each: () => each$3, escape: () => escape_default$2, every: () => every$2, extend: () => extend_default$2, extendOwn: () => extendOwn_default$2, filter: () => filter$3, find: () => find$3, findIndex: () => findIndex_default$2, findKey: () => findKey$2, findLastIndex: () => findLastIndex_default$2, findWhere: () => findWhere$2, first: () => first$2, flatten: () => flatten$2$2, foldl: () => reduce_default$2, foldr: () => reduceRight_default$2, forEach: () => each$3, functions: () => functions$1$2, get: () => get$5, groupBy: () => groupBy_default$2, has: () => has$4, head: () => first$2, identity: () => identity$4, include: () => contains$5, includes: () => contains$5, indexBy: () => indexBy_default$2, indexOf: () => indexOf_default$2, initial: () => initial$2, inject: () => reduce_default$2, intersection: () => intersection$2, invert: () => invert$2, invoke: () => invoke_default$2, isArguments: () => isArguments_default$2, isArray: () => isArray_default$2, isArrayBuffer: () => isArrayBuffer_default$2, isBoolean: () => isBoolean$5, isDataView: () => isDataView_default$2, isDate: () => isDate_default$2, isElement: () => isElement$6, isEmpty: () => isEmpty$2, isEqual: () => isEqual$2, isError: () => isError_default$2, isFinite: () => isFinite$1$2, isFunction: () => isFunction_default$2, isMap: () => isMap_default$2, isMatch: () => isMatch$2, isNaN: () => isNaN$1$2, isNull: () => isNull$3, isNumber: () => isNumber_default$2, isObject: () => isObject$4, isRegExp: () => isRegExp_default$2, isSet: () => isSet_default$2, isString: () => isString_default$2, isSymbol: () => isSymbol_default$2, isTypedArray: () => isTypedArray_default$2, isUndefined: () => isUndefined$3, isWeakMap: () => isWeakMap_default$2, isWeakSet: () => isWeakSet_default$2, iteratee: () => iteratee$2, keys: () => keys$3, last: () => last$2, lastIndexOf: () => lastIndexOf_default$2, map: () => map$3, mapObject: () => mapObject$3, matcher: () => matcher$2, matches: () => matcher$2, max: () => max$4, memoize: () => memoize$3, methods: () => functions$1$2, min: () => min$4, mixin: () => mixin$3, negate: () => negate$2, noop: () => noop$6, now: () => now_default$2, object: () => object$2, omit: () => omit_default$2, once: () => once_default$2, pairs: () => pairs$2, partial: () => partial$2, partition: () => partition_default$2, pick: () => pick_default$2, pluck: () => pluck$2, property: () => property$2, propertyOf: () => propertyOf$2, random: () => random$3, range: () => range$2, reduce: () => reduce_default$2, reduceRight: () => reduceRight_default$2, reject: () => reject$2, rest: () => rest$2, restArguments: () => restArguments$2, result: () => result$2, sample: () => sample$2, select: () => filter$3, shuffle: () => shuffle$2, size: () => size$4, some: () => some$2, sortBy: () => sortBy$2, sortedIndex: () => sortedIndex$2, tail: () => rest$2, take: () => first$2, tap: () => tap$2, template: () => template$2, templateSettings: () => templateSettings_default$2, throttle: () => throttle$2, times: () => times$2, toArray: () => toArray$3, toPath: () => toPath$1$2, transpose: () => unzip$2, unescape: () => unescape_default$2, union: () => union_default$2, uniq: () => uniq$2, unique: () => uniq$2, uniqueId: () => uniqueId$2, unzip: () => unzip$2, values: () => values$2, where: () => where$2, without: () => without_default$2, wrap: () => wrap$5, zip: () => zip_default$2 }), init_modules$2 = __esmMin$2((() => {
  init__setup$2(), init_restArguments$2(), init_isObject$2(), init_isNull$2(), init_isUndefined$2(), init_isBoolean$2(), init_isElement$2(), init_isString$2(), init_isNumber$2(), init_isDate$2(), init_isRegExp$2(), init_isError$2(), init_isSymbol$2(), init_isArrayBuffer$2(), init_isDataView$2(), init_isArray$2(), init_isFunction$2(), init_isArguments$2(), init_isFinite$2(), init_isNaN$2(), init_isTypedArray$2(), init_isEmpty$2(), init_isMatch$2(), init_isEqual$2(), init_isMap$2(), init_isWeakMap$2(), init_isSet$2(), init_isWeakSet$2(), init_keys$2(), init_allKeys$2(), init_values$2(), init_pairs$2(), init_invert$2(), init_functions$2(), init_extend$2(), init_extendOwn$2(), init_defaults$2(), init_create$2(), init_clone$2(), init_tap$2(), init_get$2(), init_has$2(), init_mapObject$2(), init_identity$2(), init_constant$2(), init_noop$2(), init_toPath$2(), init_property$2(), init_propertyOf$2(), init_matcher$2(), init_times$2(), init_random$2(), init_now$2(), init_escape$2(), init_unescape$2(), init_templateSettings$2(), init_template$2(), init_result$2(), init_uniqueId$2(), init_chain$2(), init_iteratee$2(), init_partial$2(), init_bind$2(), init_bindAll$2(), init_memoize$2(), init_delay$2(), init_defer$2(), init_throttle$2(), init_debounce$2(), init_wrap$2(), init_negate$2(), init_compose$2(), init_after$2(), init_before$2(), init_once$2(), init_findKey$2(), init_findIndex$2(), init_findLastIndex$2(), init_sortedIndex$2(), init_indexOf$2(), init_lastIndexOf$2(), init_find$2(), init_findWhere$2(), init_each$2(), init_map$2(), init_reduce$2(), init_reduceRight$2(), init_filter$2(), init_reject$2(), init_every$2(), init_some$2(), init_contains$2(), init_invoke$2(), init_pluck$2(), init_where$2(), init_max$2(), init_min$2(), init_shuffle$2(), init_sample$2(), init_sortBy$2(), init_groupBy$2(), init_indexBy$2(), init_countBy$2(), init_partition$2(), init_toArray$2(), init_size$2(), init_pick$2(), init_omit$2(), init_first$2(), init_initial$2(), init_last$2(), init_rest$2(), init_compact$2(), init_flatten$2(), init_without$2(), init_uniq$2(), init_union$2(), init_intersection$2(), init_difference$2(), init_unzip$2(), init_zip$2(), init_object$2(), init_range$2(), init_chunk$2(), init_mixin$2(), init_underscore_array_methods$2();
})), _$3, init_index_default$2 = __esmMin$2((() => {
  init_modules$2(), _$3 = mixin$3(modules_exports$2), _$3._ = _$3;
})), index_all_exports$2 = __exportAll$2({ VERSION: () => VERSION$2, after: () => after$2, all: () => every$2, allKeys: () => allKeys$2, any: () => some$2, assign: () => extendOwn_default$2, before: () => before$2, bind: () => bind_default$2, bindAll: () => bindAll_default$2, chain: () => chain$4, chunk: () => chunk$2, clone: () => clone$5, collect: () => map$3, compact: () => compact$2, compose: () => compose$3, constant: () => constant$2, contains: () => contains$5, countBy: () => countBy_default$2, create: () => create$3, debounce: () => debounce$3, default: () => _$3, defaults: () => defaults_default$2, defer: () => defer_default$2, delay: () => delay_default$2, detect: () => find$3, difference: () => difference_default$2, drop: () => rest$2, each: () => each$3, escape: () => escape_default$2, every: () => every$2, extend: () => extend_default$2, extendOwn: () => extendOwn_default$2, filter: () => filter$3, find: () => find$3, findIndex: () => findIndex_default$2, findKey: () => findKey$2, findLastIndex: () => findLastIndex_default$2, findWhere: () => findWhere$2, first: () => first$2, flatten: () => flatten$2$2, foldl: () => reduce_default$2, foldr: () => reduceRight_default$2, forEach: () => each$3, functions: () => functions$1$2, get: () => get$5, groupBy: () => groupBy_default$2, has: () => has$4, head: () => first$2, identity: () => identity$4, include: () => contains$5, includes: () => contains$5, indexBy: () => indexBy_default$2, indexOf: () => indexOf_default$2, initial: () => initial$2, inject: () => reduce_default$2, intersection: () => intersection$2, invert: () => invert$2, invoke: () => invoke_default$2, isArguments: () => isArguments_default$2, isArray: () => isArray_default$2, isArrayBuffer: () => isArrayBuffer_default$2, isBoolean: () => isBoolean$5, isDataView: () => isDataView_default$2, isDate: () => isDate_default$2, isElement: () => isElement$6, isEmpty: () => isEmpty$2, isEqual: () => isEqual$2, isError: () => isError_default$2, isFinite: () => isFinite$1$2, isFunction: () => isFunction_default$2, isMap: () => isMap_default$2, isMatch: () => isMatch$2, isNaN: () => isNaN$1$2, isNull: () => isNull$3, isNumber: () => isNumber_default$2, isObject: () => isObject$4, isRegExp: () => isRegExp_default$2, isSet: () => isSet_default$2, isString: () => isString_default$2, isSymbol: () => isSymbol_default$2, isTypedArray: () => isTypedArray_default$2, isUndefined: () => isUndefined$3, isWeakMap: () => isWeakMap_default$2, isWeakSet: () => isWeakSet_default$2, iteratee: () => iteratee$2, keys: () => keys$3, last: () => last$2, lastIndexOf: () => lastIndexOf_default$2, map: () => map$3, mapObject: () => mapObject$3, matcher: () => matcher$2, matches: () => matcher$2, max: () => max$4, memoize: () => memoize$3, methods: () => functions$1$2, min: () => min$4, mixin: () => mixin$3, negate: () => negate$2, noop: () => noop$6, now: () => now_default$2, object: () => object$2, omit: () => omit_default$2, once: () => once_default$2, pairs: () => pairs$2, partial: () => partial$2, partition: () => partition_default$2, pick: () => pick_default$2, pluck: () => pluck$2, property: () => property$2, propertyOf: () => propertyOf$2, random: () => random$3, range: () => range$2, reduce: () => reduce_default$2, reduceRight: () => reduceRight_default$2, reject: () => reject$2, rest: () => rest$2, restArguments: () => restArguments$2, result: () => result$2, sample: () => sample$2, select: () => filter$3, shuffle: () => shuffle$2, size: () => size$4, some: () => some$2, sortBy: () => sortBy$2, sortedIndex: () => sortedIndex$2, tail: () => rest$2, take: () => first$2, tap: () => tap$2, template: () => template$2, templateSettings: () => templateSettings_default$2, throttle: () => throttle$2, times: () => times$2, toArray: () => toArray$3, toPath: () => toPath$1$2, transpose: () => unzip$2, unescape: () => unescape_default$2, union: () => union_default$2, uniq: () => uniq$2, unique: () => uniq$2, uniqueId: () => uniqueId$2, unzip: () => unzip$2, values: () => values$2, where: () => where$2, without: () => without_default$2, wrap: () => wrap$5, zip: () => zip_default$2 }), init_index_all$2 = __esmMin$2((() => {
  init_index_default$2(), init_modules$2();
}));
init_index_all$2();
var nonTupleVectorOperators$2 = [`vector`, `altvector`];
function coerce_tuple_array_vectors$2({ operator1: t4, operator2: n2, operands1: r2, operands2: i2, coerce_tuples_arrays: a2, coerce_vectors: o2 }) {
  let s2 = t4 === n2;
  if (!s2) {
    if (a2) {
      if (t4 === `tuple`) {
        if (nonTupleVectorOperators$2.includes(n2)) t4 = n2, s2 = true;
        else if (n2 === `interval` && r2.length === 2) {
          let n3 = i2[1];
          n3[1] || n3[2] || (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, false, false]]);
        }
      } else if (n2 === `tuple`) {
        if (nonTupleVectorOperators$2.includes(t4)) n2 = t4, s2 = true;
        else if (t4 === `interval` && i2.length === 2) {
          let t5 = r2[1];
          t5[1] || t5[2] || (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, false, false]]);
        }
      }
      if (!s2) {
        if (t4 === `array` && r2.length === 2) {
          if (n2 === `interval`) {
            let n3 = i2[1];
            n3[1] && n3[2] && (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, true, true]]);
          }
        } else if (n2 === `array` && i2.length === 2 && t4 === `interval`) {
          let t5 = r2[1];
          t5[1] && t5[2] && (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, true, true]]);
        }
      }
    }
    !s2 && o2 && nonTupleVectorOperators$2.includes(t4) && nonTupleVectorOperators$2.includes(n2) && (s2 = true, t4 = n2 = `vector`);
  }
  return { operator1: t4, operator2: n2, operands1: r2, operands2: i2 };
}
function handleNaNInfinityStringify$2(t4, n2) {
  return n2 === n2 ? n2 === 1 / 0 ? `1/0` : n2 === -1 / 0 ? `-1/0` : n2 : `0/0`;
}
function handleNaNInfinityParse$2(t4, n2) {
  return n2 === `0/0` ? NaN : n2 === `1/0` ? 1 / 0 : n2 === `-1/0` ? -1 / 0 : n2;
}
function deepClone$2(t4) {
  return JSON.parse(JSON.stringify(t4, handleNaNInfinityStringify$2), handleNaNInfinityParse$2);
}
var equal$2 = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, coerce_tuples_arrays: o2 = true, coerce_vectors: s2 = true } = {}) {
  if (!(Array.isArray(t4) && Array.isArray(n2))) {
    if (typeof t4 != typeof n2) return false;
    if (typeof t4 == `number` && Number.isFinite(t4)) {
      let i3 = 1e-14, o3 = Math.min(Math.abs(t4), Math.abs(n2));
      return a2 ? (i3 *= o3, r2 > i3 && (i3 = r2)) : (r2 > i3 && (i3 = r2), i3 *= o3), Math.abs(t4 - n2) <= i3;
    }
    return t4 === n2;
  }
  var c2 = t4[0], l2 = t4.slice(1), u2 = n2[0], d2 = n2.slice(1);
  return c2 !== u2 && ({ operator1: c2, operator2: u2, operands1: l2, operands2: d2 } = coerce_tuple_array_vectors$2({ operator1: c2, operator2: u2, operands1: l2, operands2: d2, coerce_tuples_arrays: o2, coerce_vectors: s2 })), c2 !== u2 || l2.length !== d2.length ? false : r2 > 0 && !i2 && c2 === `^` ? equal$2(l2[0], d2[0], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 }) ? equal$2(l2[1], d2[1], { coerce_tuples_arrays: o2, coerce_vectors: s2 }) : false : _$3.every(_$3.zip(l2, d2), function(t5) {
    return equal$2(t5[0], t5[1], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 });
  });
}, match$1$2 = function(t4, n2, r2) {
  var i2 = false;
  r2 === void 0 ? r2 = {} : r2.allow_extended_match && (i2 = true, r2 = Object.assign({}, r2), delete r2.allow_extended_match);
  var a2 = r2.variables;
  if (a2 === void 0) {
    a2 = {};
    let t5 = variables$2(n2);
    for (let n3 = 0; n3 < t5.length; n3++) a2[t5[n3]] = true;
    r2 = Object.assign({}, r2), r2.variables = a2;
  }
  if (n2 in a2) {
    let r3 = a2[n2];
    if (r3 !== true) if (r3 instanceof RegExp) {
      if (typeof t4 == `string`) {
        if (!t4.match(r3)) return false;
      } else if (!JSON.stringify(t4).match(r3)) return false;
    } else if (typeof a2[n2] == `function`) {
      if (!a2[n2](t4)) return false;
    } else return false;
    let i3 = {};
    return i3[n2] = t4, i3;
  }
  if (r2.allow_permutations && (t4 = default_order$2(t4), n2 = default_order$2(n2)), !Array.isArray(n2)) return t4 === n2 ? {} : false;
  var o2 = allChildren$2(t4), s2 = n2[0], c2 = n2.slice(1);
  if (!Array.isArray(t4) || t4[0] !== s2 || o2.length < c2.length) {
    if (Array.isArray(r2.allow_implicit_identities)) {
      let i3 = matchImplicitIdentity$2(t4, n2, r2);
      if (i3) return i3;
    }
    if (s2 === `*` && Array.isArray(t4) && t4[0] === `-` && Array.isArray(t4[1]) && t4[1][0] === `*`) o2 = allChildren$2(t4[1]), o2[0] = [`-`, o2[0]];
    else return false;
  }
  return matchOperands$2(s2, o2, c2, r2, i2) || (Array.isArray(r2.allow_implicit_identities) ? matchImplicitIdentity$2([s2].concat(o2), n2, r2) : false);
};
function matchOperands$2(t4, n2, r2, i2, a2) {
  var o2 = r2.map((t5) => ({})), s2 = r2.length, c2 = false;
  i2.allow_permutations && (t4 === `*` ? c2 = ![...n2, ...r2].some((t5) => [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t5[0])) : (t4 === `+` || t4 === `=` || t4 === `and` || t4 === `or` || t4 === `ne` || t4 === `union` || t4 === `intersect`) && (c2 = true));
  function l2(u3, d3, p2) {
    let m2 = 1, h2 = 1;
    (is_associative$1$2[t4] || [`tuple`, `vector`, `altvector`].includes(t4)) && (m2 = u3.length - (s2 - d3 - 1), h2 = u3.length), i2.max_group !== void 0 && (m2 = i2.max_group < m2 ? i2.max_group : m2), i2.max_last_group !== void 0 && (h2 = i2.max_last_group < h2 ? i2.max_last_group : h2);
    let g2;
    if (!a2 && d3 === s2 - 1) if (u3.length <= h2) g2 = [u3];
    else return false;
    else if (c2) g2 = subsets$2(u3, m2);
    else {
      g2 = [];
      for (let t5 = 1; t5 <= m2; t5++) g2.push(u3.slice(0, t5));
    }
    for (let a3 of g2) {
      let c3 = o2[d3][a3];
      if (c3 === void 0) {
        let s3 = a3.reduce(function(t5, r3) {
          return t5.concat([n2[r3]]);
        }, []);
        s3 = s3.length > 1 ? [t4].concat(s3) : s3[0], c3 = match$1$2(s3, r2[d3], i2), o2[d3][a3] = c3;
      }
      if (!c3 || !_$3.every(_$3.intersection(Object.keys(p2), Object.keys(c3)), function(t5) {
        return equal$2(p2[t5], c3[t5]);
      })) continue;
      let m3 = Object.assign({}, c3);
      Object.assign(m3, p2);
      let h3 = u3.filter((t5) => !a3.includes(t5));
      if (d3 === s2 - 1) return { matches: m3, skipped: h3.reduce(function(t5, r3) {
        return t5.concat([n2[r3]]);
      }, []) };
      let g3 = l2(h3, d3 + 1, m3);
      if (g3) return g3;
    }
    return false;
  }
  var u2 = {}, d2 = [...Array(n2.length).keys()];
  if (c2) {
    let t5 = l2(d2, 0, {});
    return t5 ? (u2 = t5.matches, t5.skipped.length > 0 && (u2._skipped = t5.skipped), u2) : false;
  } else {
    let t5 = a2 ? n2.length - s2 : 0, r3 = [], i3;
    for (let a3 = 0; a3 <= t5 && (i3 = l2(d2, 0, {}), !i3); a3++) d2 = d2.slice(1), r3.push(n2[a3]);
    return i3 ? (u2 = i3.matches, i3.skipped.length > 0 && (u2._skipped = i3.skipped), r3.length > 0 && (u2._skipped_before = r3), u2) : false;
  }
}
function matchImplicitIdentity$2(t4, n2, r2) {
  var i2 = n2[0], a2 = n2.slice(1);
  if (!(i2 === `+` || i2 === `*` || i2 === `^`)) return false;
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) {
    let n3 = a2[t5];
    typeof n3 == `string` && r2.allow_implicit_identities.includes(n3) && o2.push(n3);
  }
  if (o2.length === 0) return false;
  for (let i3 of o2) {
    let a3 = match_one_implicit_identity$2(t4, n2, r2, i3);
    if (a3) return a3;
  }
  return false;
}
function match_one_implicit_identity$2(t4, n2, r2, i2) {
  var a2 = n2[0], o2 = n2.slice(1), s2 = {};
  a2 === `+` ? s2[i2] = 0 : s2[i2] = 1, a2 === `*` && o2.includes(i2) && Array.isArray(t4) && t4[0] === `-` && (s2[i2] = -1, t4 = t4[1]);
  var c2 = o2.indexOf(i2);
  if (o2.splice(c2, 1), a2 === `^` && c2 === 0) return false;
  n2 = o2.length === 1 ? o2[0] : [a2].concat(o2);
  var l2 = match$1$2(t4, n2, r2);
  if (l2) {
    if (i2 in l2 && !equal$2(l2[i2], s2[i2])) return false;
    Object.assign(s2, l2);
  } else return false;
  return s2;
}
var substitute$1$2 = function(t4, n2) {
  return typeof t4 == `number` || typeof t4 == `boolean` ? t4 : typeof t4 == `string` ? n2[t4] === void 0 ? t4 : deepClone$2(n2[t4]) : Array.isArray(t4) ? [t4[0]].concat(t4.slice(1).map(function(t5) {
    return substitute$1$2(t5, n2);
  })) : [];
}, transform$2 = function(t4, n2) {
  if (Array.isArray(t4)) {
    let r2 = [t4[0]];
    for (let i2 = 1; i2 < t4.length; i2++) r2.push(transform$2(t4[i2], n2));
    return n2(r2);
  }
  return n2(t4);
}, applyAllTransformations$2 = function(t4, n2, r2) {
  r2 === void 0 && (r2 = 5);
  for (var i2 = t4, a2; r2 > 0; r2--) {
    a2 = i2;
    for (let t5 = 0; t5 < n2.length; t5++) {
      let r3 = n2[t5][0], a3 = n2[t5][1], o2 = n2[t5][2];
      o2 === void 0 && (o2 = {}), i2 = transform$2(i2, function(t6) {
        let n3 = match$1$2(t6, r3, o2);
        if (n3) {
          let t7 = substitute$1$2(a3, n3), i3 = o2.assumptions ? substitute$1$2(o2.assumptions, n3) : void 0;
          o2.evaluate_numbers && (t7 = evaluate_numbers$2(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 }));
          let s2 = [], c2 = [];
          return n3._skipped && (s2 = n3._skipped), n3._skipped_before && (c2 = n3._skipped_before), (c2.length > 0 || s2.length > 0) && (Array.isArray(t7) && (t7 = t7[0] === r3[0] ? t7.slice(1) : [t7]), t7 = [r3[0]].concat(c2, t7, s2)), o2.evaluate_numbers && (t7 = evaluate_numbers$2(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 })), t7;
        } else return t6;
      });
    }
    if (equal$2(a2, i2)) return i2;
  }
  return i2;
}, math$2 = mathjs_default$2, operators$2$2 = { "+": function(t4) {
  return t4.length === 1 ? t4[0] : new math$2.OperatorNode(`+`, `add`, t4);
}, "*": function(t4) {
  return new math$2.OperatorNode(`*`, `multiply`, t4);
}, "/": function(t4) {
  return new math$2.OperatorNode(`/`, `divide`, t4);
}, "-": function(t4) {
  return new math$2.OperatorNode(`-`, `unaryMinus`, [t4[0]]);
}, "^": function(t4) {
  return new math$2.OperatorNode(`^`, `pow`, t4);
}, vector: function(t4) {
  return new math$2.ArrayNode(t4);
}, altvector: function(t4) {
  return new math$2.ArrayNode(t4);
}, and: function(t4) {
  return new math$2.OperatorNode(`and`, `and`, t4);
}, or: function(t4) {
  return new math$2.OperatorNode(`or`, `or`, t4);
}, not: function(t4) {
  return new math$2.OperatorNode(`not`, `not`, [t4[0]]);
}, "<": function(t4) {
  return new math$2.OperatorNode(`<`, `smaller`, t4);
}, ">": function(t4) {
  return new math$2.OperatorNode(`>`, `larger`, t4);
}, le: function(t4) {
  return new math$2.OperatorNode(`<=`, `smallerEq`, t4);
}, ge: function(t4) {
  return new math$2.OperatorNode(`>=`, `largerEq`, t4);
}, ne: function(t4) {
  return new math$2.OperatorNode(`!=`, `unequal`, t4);
}, binom: function(t4) {
  let n2 = new math$2.SymbolNode(`combinations`);
  return new math$2.FunctionNode(n2, t4);
} }, functionConversions$2 = { nCr: `combinations`, nPr: `permutations`, binom: `combinations` }, astToMathjs$2$2 = class astToMathjs$22 {
  constructor({ mathjs: t4 = null } = {}) {
    t4 && (math$2 = t4);
  }
  convert(t4) {
    if (typeof t4 == `number`) return Number.isFinite(t4) ? new math$2.ConstantNode(t4) : Number.isNaN(t4) ? new math$2.SymbolNode(`NaN`) : t4 < 0 ? operators$2$2[`-`]([new math$2.SymbolNode(`Infinity`)]) : new math$2.SymbolNode(`Infinity`);
    if (typeof t4 == `string`) return new math$2.SymbolNode(t4);
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to mathjs`);
      if (r2[0] === `factorial`) return new math$2.OperatorNode(`!`, `factorial`, [this.convert(r2[1])]);
      let t5 = functionConversions$2[r2[0]];
      t5 ||= r2[0];
      let n3 = new math$2.SymbolNode(t5), i2 = r2[1], a2;
      return a2 = i2[0] === `tuple` ? i2.slice(1).map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)) : [this.convert(i2)], r2[0] === `count` && (a2.length > 2 || !(a2[0] instanceof math$2.ArrayNode)) && (a2 = [new math$2.ArrayNode(a2)]), new math$2.FunctionNode(n3, a2);
    }
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = t5.slice(1).map((function(t6, n3) {
        return this.convert(t6);
      }).bind(this)), o2 = [];
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? o2.push(new math$2.OperatorNode(`<`, `smaller`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math$2.OperatorNode(`>`, `larger`, a2.slice(r3 - 1, r3 + 1))) : n2 === `lts` ? o2.push(new math$2.OperatorNode(`<=`, `smallerEq`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math$2.OperatorNode(`>=`, `largerEq`, a2.slice(r3 - 1, r3 + 1)));
      let s2 = new math$2.OperatorNode(`and`, `and`, o2.slice(0, 2));
      for (let t6 = 2; t6 < o2.length; t6++) s2 = new math$2.OperatorNode(`and`, `and`, [s2, o2[t6]]);
      return s2;
    }
    if (n2 === `=`) {
      let t5 = r2.map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)), n3 = [];
      for (let r3 = 1; r3 < t5.length; r3++) n3.push(new math$2.OperatorNode(`==`, `equal`, t5.slice(r3 - 1, r3 + 1)));
      if (n3.length === 1) return n3[0];
      let i2 = new math$2.OperatorNode(`and`, `and`, n3.slice(0, 2));
      for (let t6 = 2; t6 < n3.length; t6++) i2 = new math$2.OperatorNode(`and`, `and`, [i2, n3[t6]]);
      return i2;
    }
    if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
      let t5, i2;
      if (n2 === `in` || n2 === `notin` ? (t5 = r2[0], i2 = r2[1]) : (t5 = r2[1], i2 = r2[0]), typeof t5 != `number` && typeof t5 != `string`) throw Error(`Set membership non-string variables not implemented for conversion to mathjs`);
      if (t5 = this.convert(t5), i2[0] !== `interval`) throw Error(`Set membership in non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let s2 = this.convert(a2[1]), c2 = this.convert(a2[2]), l2 = [];
      o2[1] ? l2.push(new math$2.OperatorNode(`>=`, `largerEq`, [t5, s2])) : l2.push(new math$2.OperatorNode(`>`, `larger`, [t5, s2])), o2[2] ? l2.push(new math$2.OperatorNode(`<=`, `smallerEq`, [t5, c2])) : l2.push(new math$2.OperatorNode(`<`, `smaller`, [t5, c2]));
      let u2 = new math$2.OperatorNode(`and`, `and`, l2);
      return (n2 === `notin` || n2 === `notni`) && (u2 = new math$2.OperatorNode(`not`, `not`, [u2])), u2;
    }
    if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
      let t5, i2;
      if (n2 === `subset` || n2 === `notsubset` ? (i2 = r2[0], t5 = r2[1]) : (i2 = r2[1], t5 = r2[0]), i2[0] !== `interval` || t5[0] !== `interval`) throw Error(`Set containment of non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2], s2 = t5[1], c2 = t5[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple` || s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let l2 = this.convert(a2[1]), u2 = this.convert(a2[2]), d2 = this.convert(s2[1]), p2 = this.convert(s2[2]), m2 = [];
      o2[1] && !c2[1] ? m2.push(new math$2.OperatorNode(`>`, `larger`, [l2, d2])) : m2.push(new math$2.OperatorNode(`>=`, `largerEq`, [l2, d2])), o2[2] && !c2[2] ? m2.push(new math$2.OperatorNode(`<`, `smaller`, [u2, p2])) : m2.push(new math$2.OperatorNode(`<=`, `smallerEq`, [u2, p2]));
      let h2 = new math$2.OperatorNode(`and`, `and`, m2);
      return (n2 === `notsubset` || n2 === `notsuperset`) && (h2 = new math$2.OperatorNode(`not`, `not`, [h2])), h2;
    }
    if (n2 === `matrix`) {
      let t5 = r2[0], n3 = t5[1], i2 = t5[2], a2 = r2[1];
      if (!Number.isInteger(n3) || !Number.isInteger(i2)) throw Error(`Matrix must have integer dimensions`);
      let o2 = [];
      for (let t6 = 1; t6 <= n3; t6++) {
        let n4 = [];
        for (let r3 = 1; r3 <= i2; r3++) n4.push(this.convert(a2[t6][r3]));
        o2.push(new math$2.ArrayNode(n4));
      }
      return new math$2.ArrayNode(o2);
    }
    if (n2 === `array`) {
      let t5 = r2.map((t6) => this.convert(t6));
      return new math$2.ArrayNode(t5);
    }
    if (n2 in operators$2$2) return operators$2$2[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, require_sieve$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    for (var n3 = Array(t5), r2 = 0; r2 < t5; r2++) n3[r2] = true;
    for (var r2 = 2; r2 < Math.sqrt(t5); r2++) for (var i2 = r2 * r2; i2 < t5; i2 += r2) n3[i2] = false;
    for (var a2 = [], r2 = 2; r2 < t5; r2++) n3[r2] && a2.push(r2);
    return a2;
  };
})), require_factor$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_sieve$2(), i2 = r2(1e5);
  n2.exports = function(t5) {
    (!i2 || i2[i2.length - 1] < t5) && (i2 = r2(t5));
    for (var n3 = [], a2 = 0; a2 < i2.length && t5 > 1; a2++) {
      var o2 = i2[a2];
      if (t5 % o2 === 0) {
        for (var s2 = { prime: o2, power: 0 }; t5 % o2 === 0; ) s2.power++, t5 /= o2;
        n3.push(s2);
      }
    }
    return t5 > 1 && n3.push({ prime: t5, power: 1 }), n3;
  };
})), require_inc_mixed$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5, n3) {
    var r2 = t5.map(function(t6) {
      return t6;
    });
    r2[0]++;
    for (var i2 = 0; i2 < t5.length && !(r2[i2] <= n3[i2]); i2++) i2 === t5.length - 1 ? r2[i2] = 0 : (r2[i2] = 0, r2[i2 + 1]++);
    return r2;
  };
})), require_divisors$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_factor$2(), i2 = require_inc_mixed$2();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), a2 = n3.map(function(t6) {
      return 0;
    }), o2 = n3.map(function(t6) {
      return t6.power;
    }), s2 = [1]; ; ) {
      a2 = i2(a2, o2);
      var c2 = a2.map(function(t6, r3) {
        return n3[r3].prime ** +t6;
      }).reduce(function(t6, n4) {
        return t6 * n4;
      }, 1);
      if (c2 === 1) break;
      s2.push(c2);
    }
    return s2.sort(function(t6, n4) {
      return parseInt(t6) - parseInt(n4);
    }), s2;
  };
})), require_prime_factors$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_factor$2();
  n2.exports = function(t5) {
    return r2(t5).map(function(t6) {
      return t6.prime;
    });
  };
})), require_euler_phi$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_prime_factors$2();
  n2.exports = function(t5) {
    var n3 = function(t6) {
      return t6.reduce(function(t7, n4) {
        return t7 * n4;
      }, 1);
    }, i2 = r2(t5), a2 = n3(i2.map(function(t6) {
      return t6 - 1;
    })), o2 = n3(i2);
    return t5 * a2 / o2;
  };
})), require_gcd$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5, n3) {
    for (t5 < 0 && (t5 = -t5), n3 < 0 && (n3 = -n3); ; ) {
      if (n3 === 0) return t5;
      if (t5 %= n3, t5 === 0) return n3;
      n3 %= t5;
    }
  };
})), require_find_divisor$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_gcd$2();
  n2.exports = function(t5) {
    for (var n3 = 2 * Math.floor(Math.sqrt(Math.sqrt(t5))), i2 = 2, a2 = i2, o2, s2 = 1; s2 < n3; s2++) if (i2 = (i2 * i2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, o2 = r2(a2 - i2, t5), o2 != 1) return o2;
    return 1;
  };
})), require_inverse_mod$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5, n3) {
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0, i2 = 1, a2 = n3, o2 = t5; o2 !== 0; ) {
      var s2 = Math.floor(a2 / o2), c2 = r2;
      r2 = i2, i2 = c2 - s2 * i2;
      var l2 = a2;
      a2 = o2, o2 = l2 - s2 * o2;
    }
    return a2 > 1 ? NaN : r2 > 0 ? r2 : r2 + n3;
  };
})), require_is_abundant$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_divisors$2();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 < n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_deficient$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_divisors$2();
  n2.exports = function(t5) {
    if (t5 === 1) return true;
    var n3 = r2(t5);
    return n3.pop(), t5 > n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_heptagonal$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(40 * t5 + 9) + 3) / 10 % 1 == 0;
  };
})), require_is_hexagonal$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(8 * t5 + 1) + 1) / 4 % 1 == 0;
  };
})), require_is_octagonal$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(3 * t5 + 1) + 1) / 3 % 1 == 0;
  };
})), require_is_pentagonal$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(24 * t5 + 1) + 1) / 6 % 1 == 0;
  };
})), require_is_perfect$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_divisors$2();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 === n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_prime$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_factor$2();
  n2.exports = function(t5) {
    var n3 = r2(t5);
    return n3.length == 1 ? n3[0].power === 1 : false;
  };
})), require_multiply_mod$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5, n3, r2) {
    if (t5 < 94906265 && n3 < 94906265) return t5 * n3 % r2;
    var i2 = 0, a2 = r2 / 2;
    t5 >= r2 && (t5 %= r2), n3 >= r2 && (n3 %= r2);
    for (var o2 = 0; o2 < 53; o2++) i2 = i2 >= a2 ? 2 * i2 - r2 : 2 * i2, t5 >= 4503599627370496 && (i2 += n3, t5 -= 4503599627370495), i2 > r2 && (i2 -= r2), t5 *= 2;
    return i2;
  };
})), require_power_mod$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_multiply_mod$2(), i2 = require_inverse_mod$2();
  n2.exports = function t5(n3, a2, o2) {
    if (a2 < 0) return i2(t5(n3, -a2, o2), o2);
    var s2 = 1;
    for (n3 %= o2; a2 > 0; ) a2 % 2 == 1 && (s2 = r2(s2, n3, o2), --a2), a2 /= 2, n3 = r2(n3, n3, o2);
    return s2;
  };
})), require_miller$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_multiply_mod$2(), i2 = require_power_mod$2();
  n2.exports = function(t5) {
    if (t5 < 2) return false;
    if (t5 == 2 || t5 == 3) return true;
    if (!(t5 & 1) || t5 % 3 == 0) return false;
    for (var n3 = t5 - 1, a2 = 0; n3 % 2 == 0; ) n3 /= 2, a2 += 1;
    for (var o2 = t5 < 1373653 ? [2, 3] : t5 < 9080191 ? [31, 73] : t5 < 4759123141 ? [2, 7, 61] : t5 < 1122004669633 ? [2, 13, 23, 1662803] : t5 < 2152302898747 ? [2, 3, 5, 7, 11] : t5 < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17], s2 = 0; s2 < o2.length; s2++) {
      for (var c2 = o2[s2], l2 = i2(c2, n3, t5), u2 = 0, d2 = a2; d2 > 0; ) {
        if (u2 = r2(l2, l2, t5), u2 === 1 && l2 !== 1 && l2 !== t5 - 1) return false;
        l2 = u2, --d2;
      }
      if (u2 !== 1) return false;
    }
    return true;
  };
})), require_is_square$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(t5) % 1 == 0;
  };
})), require_is_triangular$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(8 * t5 + 1) % 1 == 0;
  };
})), require_jacobi_symbol$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = function(t5, n3) {
    if (n3 % 2 == 0 || n3 < 0) return NaN;
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0; ; ) {
      if (t5 %= n3, t5 === 0) return 0;
      for (; t5 % 2 == 0; ) r2 ^= (n3 % 8 * (n3 % 8) - 1) / 8, t5 /= 2;
      if (t5 == 1) return r2 & 1 ? -1 : 1;
      r2 ^= (t5 % 4 - 1) * (n3 % 4 - 1) / 4;
      var i2 = t5;
      t5 = n3, n3 = i2;
    }
    return NaN;
  };
})), require_log_mod$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_power_mod$2(), i2 = require_multiply_mod$2(), a2 = {};
  n2.exports = function(t5, n3, o2) {
    t5 = (t5 % o2 + o2) % o2;
    var s2 = Math.ceil(Math.sqrt(o2)), c2 = {};
    if (a2[o2] === void 0 && (a2[o2] = {}), a2[o2][n3] === void 0) {
      a2[o2][n3] = {}, c2 = a2[o2][n3];
      for (var l2 = 0; l2 < s2; l2++) c2[r2(n3, l2, o2)] = l2;
    } else c2 = a2[o2][n3];
    for (var u2 = r2(n3, -s2, o2), d2 = t5, p2 = 0; p2 < s2; p2++) if (c2[d2] !== void 0) return (i2(p2, s2, o2) + c2[d2]) % o2;
    else d2 = i2(d2, u2, o2);
    return NaN;
  };
})), require_primitive_root$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = (init_index_all$2(), __toCommonJS$2(index_all_exports$2)), i2 = require_euler_phi$2(), a2 = require_prime_factors$2(), o2 = require_power_mod$2();
  n2.exports = function(t5) {
    for (var n3 = i2(t5), s2 = a2(n3), c2 = 2; c2 < t5; c2++) if (r2.every(s2, function(r3) {
      return o2(c2, n3 / r3, t5) != 1;
    })) return c2;
    return NaN;
  };
})), require_quadratic_nonresidue$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_jacobi_symbol$2();
  n2.exports = function(t5) {
    for (var n3 = 2; n3 < t5; n3++) if (r2(n3, t5) == -1) return n3;
    return NaN;
  };
})), require_random_primitive_root$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_primitive_root$2(), i2 = require_euler_phi$2(), a2 = require_gcd$2(), o2 = require_power_mod$2();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), s2 = i2(t5), c2 = 0; c2 < 100; c2++) {
      var l2 = Math.floor(Math.random() * s2);
      if (a2(l2, s2) == 1) return o2(n3, l2, t5);
    }
    return n3;
  };
})), require_square_root_mod_prime$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_jacobi_symbol$2(), i2 = require_power_mod$2(), a2 = require_quadratic_nonresidue$2();
  n2.exports = function(t5, n3) {
    if (r2(t5, n3) != 1) return NaN;
    for (var o2 = n3 - 1, s2 = 0; o2 % 2 == 0; ) o2 /= 2, s2++;
    if (n3 % 4 == 3) return i2(t5, (n3 + 1) / 4, n3);
    for (var c2 = i2(a2(n3), o2, n3), l2 = i2(t5, (o2 + 1) / 2, n3), u2 = i2(t5, o2, n3), d2 = s2; ; ) {
      if (u2 % n3 == 1) return l2;
      for (var p2 = u2, m2 = 1; m2 < d2 && (p2 = p2 * p2 % n3, p2 != 1); m2++) ;
      var h2 = m2;
      m2++;
      for (var g2 = c2; m2 < d2; ) g2 = g2 * g2 % n3, m2++;
      d2 = h2, l2 = l2 * g2 % n3, u2 = u2 * g2 * g2 % n3, c2 = g2 * g2 % n3;
    }
    return NaN;
  };
})), require_square_root_mod$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = (init_index_all$2(), __toCommonJS$2(index_all_exports$2)), i2 = require_factor$2(), a2 = require_square_root_mod_prime$2(), o2 = require_jacobi_symbol$2(), s2 = require_inverse_mod$2(), c2 = require_multiply_mod$2();
  n2.exports = function(t5, n3) {
    var l2 = 1, u2 = [0];
    return i2(n3).forEach(function(n4) {
      var i3 = n4.prime, d2 = n4.power, p2 = a2(t5, i3), m2 = [];
      if (o2(t5, i3) != 1) return [];
      u2.forEach(function(t6) {
        m2.unshift(t6 * i3 * s2(i3, l2) + p2 * l2 * s2(l2, i3)), m2.unshift(t6 * i3 * s2(i3, l2) - p2 * l2 * s2(l2, i3));
      }), m2.sort(), u2 = r2.unique(m2), l2 *= i3;
      var h2 = 1;
      for (d2--; d2 > 0; ) {
        var g2 = i3 ** +Math.min(h2, d2);
        d2 -= Math.min(h2, d2), u2 = u2.map(function(n5) {
          var r3 = -((n5 * n5 - t5) / l2), i4 = s2(2 * n5, g2);
          return n5 + l2 * c2(r3, i4, g2);
        }), l2 *= g2;
      }
    }), u2.map(function(t6) {
      return (t6 % n3 + n3) % n3;
    });
  };
})), require_number_theory$2 = __commonJSMin$2(((t4, n2) => {
  n2.exports = { divisors: require_divisors$2(), eulerPhi: require_euler_phi$2(), factor: require_factor$2(), findDivisor: require_find_divisor$2(), gcd: require_gcd$2(), incMixed: require_inc_mixed$2(), inverseMod: require_inverse_mod$2(), isAbundant: require_is_abundant$2(), isDeficient: require_is_deficient$2(), isHeptagonal: require_is_heptagonal$2(), isHexagonal: require_is_hexagonal$2(), isOctagonal: require_is_octagonal$2(), isPentagonal: require_is_pentagonal$2(), isPerfect: require_is_perfect$2(), isPrime: require_is_prime$2(), isProbablyPrime: require_miller$2(), isSquare: require_is_square$2(), isTriangular: require_is_triangular$2(), jacobiSymbol: require_jacobi_symbol$2(), logMod: require_log_mod$2(), miller: require_miller$2(), multiplyMod: require_multiply_mod$2(), powerMod: require_power_mod$2(), primeFactors: require_prime_factors$2(), primitiveRoot: require_primitive_root$2(), quadraticNonresidue: require_quadratic_nonresidue$2(), randomPrimitiveRoot: require_random_primitive_root$2(), sieve: require_sieve$2(), squareRootMod: require_square_root_mod$2(), squareRootModPrime: require_square_root_mod_prime$2(), totient: require_euler_phi$2() };
})), import_number_theory$2 = __toESM$2(require_number_theory$2());
function gcd$5(t4, n2) {
  return Number.isNaN(t4) || Number.isNaN(n2) ? NaN : import_number_theory$2.default.gcd(t4, n2);
}
function flatten$1$2(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.concat(n2);
  }, []);
}
function positiveModulo$2(t4, n2) {
  return (t4 % n2 + n2) % n2;
}
var ZmodN$2 = class t2 {
  constructor(t4, n2, r2 = false) {
    this.values = t4.map(function(t5) {
      return positiveModulo$2(t5, n2);
    }), this.modulus = n2, this.approximate = r2;
  }
  apply(n2, r2, i2) {
    if (i2 == null || Number.isNaN(i2)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(n2.modulus)) return new t2([NaN], NaN, this.approximate || n2.approximate);
      i2 = gcd$5(this.modulus, n2.modulus);
    }
    return new t2(flatten$1$2(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        return Number.isNaN(t4) || Number.isNaN(n3) ? NaN : (i2 + r2(t4, n3)) % i2;
      });
    })), i2, this.approximate || n2.approximate);
  }
  add(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 + n2;
    });
  }
  power(n2) {
    var r2 = this.modulus;
    return n2.modulus == import_number_theory$2.default.eulerPhi(r2) ? this.apply(n2, function(t4, n3) {
      return import_number_theory$2.default.powerMod(t4, n3, r2);
    }, r2) : new t2([NaN], NaN, this.approximate || n2.approximate);
  }
  isNaN() {
    for (var t4 of this.values) if (isNaN(t4)) return true;
    return false;
  }
  subtract(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 - n2;
    });
  }
  multiply(t4) {
    var n2 = gcd$5(this.modulus, t4.modulus);
    return this.apply(t4, function(t5, r2) {
      return import_number_theory$2.default.multiplyMod(t5, r2, n2);
    });
  }
  inverse() {
    var n2 = this.modulus;
    return new t2(this.values.map(function(t4) {
      return import_number_theory$2.default.inverseMod(t4, n2);
    }), this.modulus, this.approximate);
  }
  negate() {
    var n2 = this.modulus;
    return new t2(this.values.map(function(t4) {
      return n2 - t4;
    }), this.modulus, this.approximate);
  }
  divide(n2) {
    var r2 = gcd$5(this.modulus, n2.modulus);
    return new t2(flatten$1$2(flatten$1$2(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        if (t4 % n3 == 0) return [t4 / n3];
        var i2 = gcd$5(n3, r2);
        if (t4 % i2 != 0) return [];
        var a2 = n3 / i2, o2 = t4 / i2, s2 = import_number_theory$2.default.multiplyMod(o2, import_number_theory$2.default.inverseMod(a2, r2), r2), c2 = [], l2;
        for (l2 = 0; l2 < i2; l2++) c2.unshift(s2 + import_number_theory$2.default.multiplyMod(l2, r2 / i2, r2));
        return c2;
      });
    }))), r2, this.approximate || n2.approximate);
  }
  sqrt() {
    var n2 = this.modulus;
    return new t2(flatten$1$2(this.values.map(function(t4) {
      return import_number_theory$2.default.squareRootMod(t4, n2);
    })), this.modulus, this.approximate);
  }
  toString = function() {
    return `{` + this.values.sort().toString() + `}/` + this.modulus.toString();
  };
  equals(t4) {
    return this.toString() == t4.toString();
  }
}, PRIME$2 = 10739999, levelFunctions$2 = { "+": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.add(n2);
  });
}, "*": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.multiply(n2);
  });
}, "/": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.divide(n2);
  });
}, "-": function(t4) {
  return t4[0].negate();
}, "~": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.subtract(n2);
  }, new ZmodN$2([0], t4[0].modulus));
}, factorial: function(t4) {
  return ZmodN$2([NaN], 1);
}, gamma: function(t4) {
  return ZmodN$2([NaN], 1);
} };
function rationalApproximation$2(t4, n2 = 1e15) {
  let r2 = [[1, 0], [0, 1]], i2;
  for (; r2[1][0] * (i2 = Math.floor(t4)) + r2[1][1] <= n2; ) {
    let n3;
    if (n3 = r2[0][0] * i2 + r2[0][1], r2[0][1] = r2[0][0], r2[0][0] = n3, n3 = r2[1][0] * i2 + r2[1][1], r2[1][1] = r2[1][0], r2[1][0] = n3, t4 == i2 || (t4 = 1 / (t4 - i2), t4 > 2147483647)) break;
  }
  let a2 = r2[1][0] * i2 + r2[1][1] > n2;
  return { numerator: r2[0][0], denominator: r2[1][0], approximate: a2 };
}
function finite_field_evaluate_ast$2(t4, n2, r2, i2) {
  if (typeof t4 == `string`) return t4 === `e` ? new ZmodN$2([import_number_theory$2.default.primitiveRoot(r2)], r2) : t4 === `pi` ? r2 % 2 == 0 ? new ZmodN$2([r2 / 2], r2) : new ZmodN$2([NaN], r2) : t4 === `i` ? new ZmodN$2([0], 1) : t4 in n2 ? new ZmodN$2([n2[t4]], r2) : t4;
  if (typeof t4 == `number`) {
    if (Number.isInteger(t4)) return new ZmodN$2([t4], r2);
    {
      let n3 = rationalApproximation$2(t4), i3 = new ZmodN$2([n3.numerator], r2, n3.approximate), a3 = new ZmodN$2([n3.denominator], r2, n3.approximate);
      return i3.divide(a3);
    }
  }
  var a2 = t4[0], o2 = t4.slice(1);
  if (a2 === `apply`) {
    if (typeof o2[0] != `string`) throw Error(`Non string functions not implemented for finite fields`);
    if (o2[0] === `exp`) {
      var s2 = finite_field_evaluate_ast$2(`e`, {}, r2), c2 = finite_field_evaluate_ast$2(o2[1], n2, import_number_theory$2.default.eulerPhi(r2));
      return s2.power(c2);
    }
    if (o2[0] === `sec`) return finite_field_evaluate_ast$2([`/`, 1, [`apply`, `cos`, o2[1]]], n2, r2);
    if (o2[0] === `csc`) return finite_field_evaluate_ast$2([`/`, 1, [`apply`, `sin`, o2[1]]], n2, r2);
    if (o2[0] === `cot`) return finite_field_evaluate_ast$2([`/`, 1, [`apply`, `tan`, o2[1]]], n2, r2);
    if (o2[0] === `tan`) {
      var l2 = import_number_theory$2.default.eulerPhi(r2);
      return finite_field_evaluate_ast$2([`/`, [`apply`, `sin`, o2[1]], [`apply`, `cos`, o2[1]]], n2, r2);
    }
    if (o2[0] === `sin`) {
      var u2 = import_number_theory$2.default.primitiveRoot(r2), d2 = new ZmodN$2([u2], r2), l2 = import_number_theory$2.default.eulerPhi(r2);
      if (l2 % 4 != 0) return new ZmodN$2([NaN], r2);
      var p2 = new ZmodN$2([import_number_theory$2.default.powerMod(u2, l2 / 4, r2)], r2), m2 = finite_field_evaluate_ast$2(o2[1], n2, l2);
      return d2.power(m2).subtract(d2.power(m2.negate())).divide(p2.add(p2));
    }
    if (o2[0] === `cos`) {
      var d2 = new ZmodN$2([import_number_theory$2.default.primitiveRoot(r2)], r2), m2 = finite_field_evaluate_ast$2(o2[1], n2, import_number_theory$2.default.eulerPhi(r2));
      return d2.power(m2).add(d2.power(m2.negate())).divide(new ZmodN$2([2], r2));
    }
    if (o2[0] === `log`) return new ZmodN$2([NaN], NaN);
    if (o2[0] === `sqrt`) return finite_field_evaluate_ast$2(o2[1], n2, r2).sqrt();
    if (o2[0] === `abs`) {
      let t5 = finite_field_evaluate_ast$2(o2[1], n2, r2);
      return t5.multiply(t5).sqrt();
    }
  }
  if (a2 == `^`) {
    var s2 = finite_field_evaluate_ast$2(o2[0], n2, r2), c2 = finite_field_evaluate_ast$2(o2[1], n2, import_number_theory$2.default.eulerPhi(r2));
    return s2.power(c2);
  }
  return a2 in levelFunctions$2 ? levelFunctions$2[a2](o2.map(function(t5, a3) {
    return finite_field_evaluate_ast$2(t5, n2, r2);
  })) : new ZmodN$2([NaN], r2);
}
var astToFiniteField$1$2 = class astToFiniteField$12 {
  constructor() {
  }
  convert(t4, n2, r2 = PRIME$2) {
    return finite_field_evaluate_ast$2(t4, n2, r2);
  }
}, evaluation_exports$2 = __exportAll$2({ evaluate: () => evaluate$3, evaluate_to_constant: () => evaluate_to_constant$2, f: () => f$3, finite_field_evaluate: () => finite_field_evaluate$2 }), astToMathjs$1$2 = new astToMathjs$2$2({ mathjs: mathjs_default$2 }), astToFiniteField$3 = new astToFiniteField$1$2(), f$3 = function(t4) {
  var n2 = get_tree$2(t4), r2 = factorial_to_gamma_function$2(astToMathjs$1$2.convert(log_subscript_to_two_arg_log$2(normalize_function_names$2(normalize_applied_functions$2(n2)))));
  return r2.evaluate.bind(r2);
}, evaluate$3 = function(t4, n2) {
  return f$3(t4)(n2);
}, finite_field_evaluate$2 = function(t4, n2, r2) {
  return astToFiniteField$3.convert(t4.tree, n2, r2);
}, evaluate_to_constant$2 = function(t4, { remove_units_first: n2 = true, scale_based_on_unit: r2 = true, nan_for_non_numeric: i2 = true } = {}) {
  var a2 = get_tree$2(t4);
  if (n2 && (a2 = remove_units$2(a2, r2)), typeof a2 == `number`) return a2;
  if (typeof a2 == `string`) return a2 === `pi` && mathjs_default$2.define_pi ? Math.PI : a2 === `e` && mathjs_default$2.define_e ? Math.E : a2 === `i` && mathjs_default$2.define_i ? { re: 0, im: 1 } : i2 ? NaN : null;
  if (!Array.isArray(a2)) return i2 ? NaN : null;
  var o2 = [];
  o2.push([[`^`, `x`, [`/`, `m`, `n`]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], `m`], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), o2.push([[`^`, `x`, [`-`, [`/`, `m`, `n`]]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], [`-`, `m`]], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), a2 = applyAllTransformations$2(a2, o2, 40);
  var s2 = i2 ? NaN : null;
  try {
    var c2 = f$3(a2);
    s2 = c2();
  } catch {
  }
  if (!Number.isNaN(s2) && (typeof s2 == `number` || typeof s2?.re == `number` && typeof s2?.im == `number`)) {
    if (s2.re === 1 / 0 || s2.re === -1 / 0 || s2.im === 1 / 0 || s2.im === -1 / 0) {
      let t5;
      if (typeof s2?.re == `number` && typeof s2?.im == `number`) if (s2.im === 0) t5 = s2.re;
      else {
        let n3;
        n3 = s2.im === 1 ? `i` : s2.im === -1 ? [`-`, `i`] : [`*`, s2.im, `i`], t5 = s2.re === 0 ? n3 : [`+`, s2.re, n3];
      }
      else t5 = s2;
      s2 = i2 ? NaN : null;
      try {
        var c2 = f$3(t5);
        s2 = c2();
      } catch {
      }
    } else s2.im === 0 && (s2 = s2.re);
    return s2;
  }
  return typeof s2 == `object` && (s2 = i2 ? NaN : null), s2;
};
function factorial_to_gamma_function$2(t4) {
  return t4.transform(function(t5, n2, r2) {
    if (t5.isOperatorNode && t5.op === `!` && t5.fn === `factorial`) {
      var i2 = [new mathjs_default$2.OperatorNode(`+`, `add`, [t5.args[0], new mathjs_default$2.ConstantNode(1)])];
      return new mathjs_default$2.FunctionNode(new mathjs_default$2.SymbolNode(`gamma`), i2);
    } else return t5;
  });
}
var functions$4 = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
functions$4.C.nonneg = [`abs`], functions$4.C.nonzero = [`exp`], functions$4.C.R = [`abs`, `arg`], functions$4.C.C = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`, `sqrt`, `log`, `ln`, `log10`], functions$4.R.pos = [`exp`], functions$4.R.nonneg = [`abs`, `exp`, `arg`], functions$4.R.R = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`], functions$4.R.Z = [`sign`], functions$4.nonzeroC.pos = [`abs`], functions$4.nonneg.nonneg = [`abs`, `exp`, `arg`, `sqrt`, `erf`], functions$4.nonzeroC.nonzero = [`abs`], functions$4.nonneg.R = [...new Set(functions$4.R.R.concat(functions$4.nonneg.nonneg))], functions$4.pos.pos = [`abs`, `exp`, `sqrt`, `erf`], functions$4.pos.nonneg = functions$4.pos.pos, functions$4.pos.nonzero = [`abs`, `exp`, `sqrt`, `erf`], functions$4.pos.R = functions$4.nonneg.R.concat([`log`, `ln`, `log10`]);
function negate_adjust$2(t4, n2) {
  if (t4) return !n2;
  if (t4 === false) return n2;
}
function narrow_assumptions$2(t4, n2) {
  if (!Array.isArray(n2)) return [];
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 !== `and`) return [];
  for (var a2 = [], o2 = 0; o2 < i2.length; o2++) equal$2(i2[o2], t4) || a2.push(i2[o2]);
  return a2.length === 0 ? [] : a2.legnth === 1 ? a2[0] : [r2].concat(a2);
}
function simple_assumption_combination$2(t4, n2, r2) {
  return t4 === `and` ? n2 === void 0 ? r2 : r2 === void 0 ? n2 : n2 || r2 : n2 === void 0 || r2 === void 0 || n2 !== r2 ? void 0 : n2;
}
function is_integer_ast$2(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isInteger(t4);
  var i2 = evaluate_to_constant$2(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return Number.isInteger(i2);
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust$2(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust$2(false, c2);
    if (c2 === false) {
      if (o2 === `notin` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `C`)) return false;
    } else if (o2 === `in` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `Z`)) return false;
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$2(a2, r2);
      if (s2[0] === t4) return is_integer_ast$2(s2[1], n3);
      if (s2[1] === t4) return is_integer_ast$2(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$2(i3), s2 = i3.slice(1));
    let l2 = is_integer_ast$2(t4, s2[0], r2), u2 = is_integer_ast$2(t4, s2[1], r2);
    return simple_assumption_combination$2(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$2(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_integer_ast$2(o2[0], i3, r2);
    if (a2 === `*`) return o2.every(function(t5) {
      return is_integer_ast$2(t5, i3, r2);
    }) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$2(o2[0], i3, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (is_positive_ast$2(o2[1], i3, true, r2)) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$2(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let n3 = is_integer_ast$2(o2[0], i3, r2), a3 = is_integer_ast$2(o2[1], i3, r2);
      return n3 && (a3 && is_positive_ast$2(o2[1], i3, false, r2) ? true : void 0);
    }
    if (a2 === `+`) {
      let t5 = 0;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_integer_ast$2(o2[n3], i3, r2);
        if (a3 === false) {
          if (t5 > 0) return;
          t5 += 1;
        }
        if (a3 === void 0) return;
      }
      return t5 === 0;
    }
    return a2 === `apply` ? functions$4.C.Z && functions$4.C.Z.includes(o2[0]) && is_complex_ast$2(o2[1], i3, r2) || functions$4.R.Z && functions$4.R.Z.includes(o2[0]) && is_real_ast$2(o2[1], i3, r2) || functions$4.nonzeroC.Z && functions$4.nonzeroC.Z.includes(o2[0]) && is_nonzero_ast$2(o2[1], i3, r2) && is_complex_ast$2(o2[1], i3, r2) || functions$4.nonneg.Z && functions$4.nonneg.Z.includes(o2[0]) && is_positive_ast$2(o2[1], i3, false, r2) || functions$4.pos.Z && functions$4.pos.Z.includes(o2[0]) && is_positive_ast$2(o2[1], i3, true, r2) ? true : void 0 : a2 === `/` || a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_real_ast$2(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant$2(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : false;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `R`) return negate_adjust$2(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `R`) return negate_adjust$2(false, c2);
    if (c2 === false) {
      if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return true;
    } else if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables$2(i3), r3 = functions$2$2(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$2(a2, r2);
      if (s2[0] === t4) return is_real_ast$2(s2[1], n3);
      if (s2[1] === t4) return is_real_ast$2(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$2(i3), s2 = i3.slice(1));
    let l2 = is_real_ast$2(t4, s2[0], r2), u2 = is_real_ast$2(t4, s2[1], r2);
    return simple_assumption_combination$2(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$2(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_real_ast$2(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight$2(t4), o2 = t4.slice(1)), a2 === `*` && (is_nonzero_ast$2(o2[0], i3, r2) === false || is_nonzero_ast$2(o2[1], i3, r2) === false)) return true;
      let n3 = is_real_ast$2(o2[0], i3, r2), s2 = is_real_ast$2(o2[1], i3, r2);
      return n3 && s2 ? true : n3 && s2 === false || s2 && n3 === false ? false : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$2(o2[0], i3, r2), n3 = is_positive_ast$2(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$2(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_real_ast$2(o2[0], i3, r2), s2 = is_real_ast$2(o2[1], i3, r2);
      return a3 && s2 ? is_positive_ast$2(o2[0], i3, false, r2) ? is_positive_ast$2(o2[0], i3, true, r2) || n3 ? true : void 0 : is_integer_ast$2(o2[1], i3, r2) ? true : void 0 : void 0;
    }
    return a2 === `/` ? is_nonzero_ast$2(o2[1], i3, r2) && (is_nonzero_ast$2(o2[0], i3, r2) === false || is_real_ast$2(o2[0], i3, r2) && is_real_ast$2(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions$4.C.R && functions$4.C.R.includes(o2[0]) && is_complex_ast$2(o2[1], i3, r2) || functions$4.R.R && functions$4.R.R.includes(o2[0]) && is_real_ast$2(o2[1], i3, r2) || functions$4.nonzeroC.R && functions$4.nonzeroC.R.includes(o2[0]) && is_nonzero_ast$2(o2[1], i3, r2) && is_complex_ast$2(o2[1], i3, r2) || functions$4.nonneg.R && functions$4.nonneg.R.includes(o2[0]) && is_positive_ast$2(o2[1], i3, false, r2) || functions$4.pos.R && functions$4.pos.R.includes(o2[0]) && is_positive_ast$2(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_complex_ast$2(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant$2(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : !!(i2.re !== void 0 && Number.isFinite(i2.re) && i2.im !== void 0 && Number.isFinite(i2.im));
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `C`) return negate_adjust$2(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `C`) return negate_adjust$2(false, c2);
    if (c2 === false) {
      if (o2 === `in` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    } else if (o2 === `notin` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables$2(i3), r3 = functions$2$2(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$2(a2, r2);
      if (s2[0] === t4) return is_complex_ast$2(s2[1], n3);
      if (s2[1] === t4) return is_complex_ast$2(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$2(i3), s2 = i3.slice(1));
    let l2 = is_complex_ast$2(t4, s2[0], r2), u2 = is_complex_ast$2(t4, s2[1], r2);
    return simple_assumption_combination$2(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$2(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_complex_ast$2(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) return a2 === `*` && !o2.every((t5) => is_nonzero_ast$2(t5, i3, r2) !== false) || o2.every((t5) => is_complex_ast$2(t5, i3, r2)) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$2(o2[0], i3, r2), n3 = is_positive_ast$2(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$2(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_complex_ast$2(o2[0], i3, r2), s2 = is_complex_ast$2(o2[1], i3, r2);
      return a3 && s2 ? true : void 0;
    }
    return a2 === `/` ? is_nonzero_ast$2(o2[1], i3, r2) && (is_nonzero_ast$2(o2[0], i3, r2) === false || is_complex_ast$2(o2[0], i3, r2) && is_complex_ast$2(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions$4.C.C && functions$4.C.C.includes(o2[0]) && is_complex_ast$2(o2[1], i3, r2) || functions$4.R.C && functions$4.R.C.includes(o2[0]) && is_real_ast$2(o2[1], i3, r2) || functions$4.nonzeroC.C && functions$4.nonzeroC.C.includes(o2[0]) && is_nonzero_ast$2(o2[1], i3, r2) && is_complex_ast$2(o2[1], i3, r2) || functions$4.nonneg.C && functions$4.nonneg.C.includes(o2[0]) && is_positive_ast$2(o2[1], i3, false, r2) || functions$4.pos.C && functions$4.pos.C.includes(o2[0]) && is_positive_ast$2(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_nonzero_ast$2(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4) ? t4 !== 0 : Number.isNaN(t4) ? void 0 : true;
  var i2 = evaluate_to_constant$2(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) ? i2 !== 0 : Number.isNaN(i2) ? void 0 : true : i2.re !== void 0 && i2.im !== void 0 && (i2.re !== 0 || i2.im !== 0) ? true : void 0;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    let l2 = narrow_assumptions$2(a2, r2);
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      if (s2[0] === t4) return is_nonzero_ast$2(s2[1], l2);
      if (s2[1] === t4) return is_nonzero_ast$2(s2[0], l2);
    }
    if ((o2 === `ne` && !c2 || o2 === `=` && c2) && (s2[0] === t4 && is_nonzero_ast$2(s2[1], l2) === false || s2[1] === t4 && is_nonzero_ast$2(s2[0], l2) === false)) return true;
    if (o2 === `<`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast$2(s2[1], l2, false) || s2[1] === t4 && is_positive_ast$2(s2[0], l2, false)) return true;
      } else if (s2[0] === t4 && is_positive_ast$2(s2[1], l2, true) || s2[1] === t4 && is_negative_ast$2(s2[0], l2, true)) return true;
    }
    if (o2 === `le`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast$2(s2[1], l2, true) || s2[1] === t4 && is_positive_ast$2(s2[0], l2, true)) return true;
      } else if (s2[0] === t4 && is_positive_ast$2(s2[1], l2, false) || s2[1] === t4 && is_negative_ast$2(s2[0], l2, false)) return true;
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$2(i3), s2 = i3.slice(1));
    let u2 = is_nonzero_ast$2(t4, s2[0], r2), d2 = is_nonzero_ast$2(t4, s2[1], r2);
    return simple_assumption_combination$2(o2, u2, d2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$2(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_nonzero_ast$2(o2[0], i3, r2);
    if (a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight$2(t4), o2 = t4.slice(1)), equal$2(o2[0], simplify$2([`-`, o2[1]], r2))) return false;
      let n3 = is_nonzero_ast$2(o2[0], i3, r2), a3 = is_nonzero_ast$2(o2[1], i3, r2);
      if (n3 === false) return a3;
      if (a3 === false) return n3;
      let s2 = is_real_ast$2(o2[0], i3, r2), c2 = is_real_ast$2(o2[1], i3, r2);
      if (!s2 || !c2) return s2 === true ? c2 === false ? true : void 0 : c2 === true && s2 === false ? true : void 0;
      let l2 = is_positive_ast$2(o2[0], i3, false, r2), u2 = is_positive_ast$2(o2[1], i3, false, r2), d2 = is_positive_ast$2(o2[0], i3, true, r2), p2 = is_positive_ast$2(o2[1], i3, true, r2);
      return l2 && p2 || d2 && u2 || l2 === false && p2 === false || d2 === false && u2 === false ? true : void 0;
    }
    if (a2 === `*`) {
      let t5 = true;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_nonzero_ast$2(o2[n3], i3, r2);
        if (a3 === false) return false;
        a3 === void 0 && (t5 = false);
      }
      return t5 ? true : void 0;
    }
    if (a2 === `/`) {
      let t5 = is_nonzero_ast$2(o2[0], i3, r2);
      return is_nonzero_ast$2(o2[1], i3, r2) ? t5 : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$2(o2[0], i3, r2);
      return t5 ? (o2[0] === 1 / 0 || o2[0] === -1 / 0) && is_nonzero_ast$2(o2[1], i3, r2) === false ? void 0 : true : is_positive_ast$2(o2[1], i3, true, r2) && t5 === false ? false : void 0;
    }
    return a2 === `apply` ? functions$4.C.nonzero && functions$4.C.nonzero.includes(o2[0]) && is_complex_ast$2(o2[1], i3, r2) || functions$4.R.nonzero && functions$4.R.nonzero.includes(o2[0]) && is_real_ast$2(o2[1], i3, r2) || functions$4.nonzeroC.nonzero && functions$4.nonzeroC.nonzero.includes(o2[0]) && is_nonzero_ast$2(o2[1], i3, r2) || functions$4.nonneg.nonzero && functions$4.nonneg.nonzero.includes(o2[0]) && is_positive_ast$2(o2[1], i3, false, r2) || functions$4.pos.nonzero && functions$4.pos.nonzero.includes(o2[0]) && is_positive_ast$2(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_positive_ast$2(t4, n2, r2, i2) {
  if (typeof n2 != `object` && (n2 = []), i2 === void 0 && (i2 = n2), r2 === void 0 && (r2 = true), typeof t4 == `number`) return Number.isFinite(t4) ? r2 ? t4 > 0 : t4 >= 0 : false;
  var a2 = is_real_ast$2(t4, n2, i2);
  if (!a2) return a2;
  var o2 = evaluate_to_constant$2(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (o2 !== null) return typeof o2 == `number` && Number.isFinite(o2) ? r2 ? o2 > 0 : o2 >= 0 : false;
  if (typeof t4 == `string`) {
    let a3;
    if (a3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(a3)) return;
    let o3 = a3, s2 = a3[0], c2 = a3.slice(1), l2 = false;
    for (; s2 === `not`; ) {
      if (l2 = !l2, a3 = c2[0], !Array.isArray(a3)) return;
      s2 = a3[0], c2 = a3.slice(1);
    }
    let u2 = narrow_assumptions$2(o3, i2);
    if (s2 === `=` && !l2 || s2 === `ne` && l2) {
      if (c2[0] === t4) return is_positive_ast$2(c2[1], u2, r2);
      if (c2[1] === t4) return is_positive_ast$2(c2[0], u2, r2);
    }
    if (s2 === `<`) if (l2) {
      if (c2[0] === t4 && is_positive_ast$2(c2[1], u2, r2)) return true;
      if (c2[1] === t4 && is_negative_ast$2(c2[0], u2, !r2)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast$2(c2[1], u2, false)) return false;
      if (c2[1] === t4 && is_positive_ast$2(c2[0], u2, false)) return true;
    }
    if (s2 === `le`) if (l2) {
      if (c2[0] === t4 && is_positive_ast$2(c2[1], u2, false)) return true;
      if (c2[1] === t4 && is_negative_ast$2(c2[0], u2, false)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast$2(c2[1], u2, !r2)) return false;
      if (c2[1] === t4 && is_positive_ast$2(c2[0], u2, r2)) return true;
    }
    if (s2 !== `and` && s2 !== `or` || l2) return;
    c2.length > 2 && (a3 = unflattenRight$2(a3), c2 = a3.slice(1));
    let d2 = is_positive_ast$2(t4, c2[0], r2, i2), p2 = is_positive_ast$2(t4, c2[1], r2, i2);
    return simple_assumption_combination$2(s2, d2, p2);
  }
  if (Array.isArray(t4)) {
    let a3;
    a3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$2(t4)]);
    let o3 = t4[0], s2 = t4.slice(1);
    if (o3 === `-`) return is_negative_ast$2(s2[0], a3, r2, i2);
    if (o3 === `+`) {
      s2.length > 2 && (t4 = unflattenRight$2(t4), s2 = t4.slice(1));
      let n3 = is_positive_ast$2(s2[0], a3, false, i2), o4 = is_positive_ast$2(s2[1], a3, false, i2), c2 = is_positive_ast$2(s2[0], a3, true, i2), l2 = is_positive_ast$2(s2[1], a3, true, i2);
      if (r2) {
        if (n3 && l2 || c2 && o4) return true;
      } else if (n3 && o4) return true;
      if (r2) {
        if (c2 === false && l2 === false) return false;
      } else if (n3 === false && l2 === false || c2 === false && o4 === false) return false;
      return;
    }
    if (o3 === `*`) {
      if (!s2.every((t5) => is_nonzero_ast$2(t5, a3, i2) !== false)) return !r2;
      s2.length > 2 && (t4 = unflattenRight$2(t4), s2 = t4.slice(1));
      let n3 = is_real_ast$2(s2[0], a3, i2), o4 = is_real_ast$2(s2[1], a3, i2);
      if (n3 === void 0 || o4 === void 0) return;
      if (n3 === false) return o4 === false ? void 0 : false;
      if (o4 === false) return false;
      let c2 = is_positive_ast$2(s2[0], a3, false, i2), l2 = is_positive_ast$2(s2[1], a3, false, i2), u2 = is_positive_ast$2(s2[0], a3, true, i2), d2 = is_positive_ast$2(s2[1], a3, true, i2);
      if (r2) {
        if (u2 && d2 || c2 === false && l2 === false) return true;
        if (u2 === false && l2 || c2 && d2 === false) return false;
      } else {
        if (c2 && l2 || u2 === false && d2 === false) return true;
        if (u2 && l2 === false || c2 === false && d2) return false;
      }
      return;
    }
    if (o3 === `/`) {
      if (!is_nonzero_ast$2(s2[1], a3, i2)) return;
      if (is_nonzero_ast$2(s2[0], a3, i2) === false) return !r2;
      let t5 = is_positive_ast$2(s2[1], a3, true, i2);
      if (t5 === void 0) return;
      let n3 = t5 ? r2 : !r2, o4 = is_positive_ast$2(s2[0], a3, n3, i2);
      return o4 === void 0 ? void 0 : o4 === true ? t5 === true : t5 !== true;
    }
    if (o3 === `^`) {
      let t5 = is_nonzero_ast$2(s2[0], a3, i2);
      if (!t5) if (is_positive_ast$2(s2[1], a3, true, i2)) {
        if (t5 === false) return !r2;
        if (r2) return;
      } else return;
      else if (is_nonzero_ast$2(s2[1], a3, i2) === false) return s2[0] === 1 / 0 || s2[0] === -1 / 0 ? void 0 : true;
      return is_real_ast$2(s2[0], a3, i2) === true ? is_positive_ast$2(s2[0], a3, r2, i2) ? is_real_ast$2(s2[1], a3, i2) ? true : void 0 : is_integer_ast$2(simplify$2([`/`, s2[1], 2], i2), a3, i2) ? true : void 0 : void 0;
    }
    return o3 === `apply` && !r2 ? functions$4.C.nonneg && functions$4.C.nonneg.includes(s2[0]) && is_complex_ast$2(s2[1], a3, i2) || functions$4.R.nonneg && functions$4.R.nonneg.includes(s2[0]) && is_real_ast$2(s2[1], a3, i2) || functions$4.nonzeroC.nonneg && functions$4.nonzeroC.nonneg.includes(s2[0]) && is_nonzero_ast$2(s2[1], a3, i2) && is_complex_ast$2(s2[1], a3, i2) || functions$4.nonneg.nonneg && functions$4.nonneg.nonneg.includes(s2[0]) && is_positive_ast$2(s2[1], a3, false, i2) || functions$4.pos.nonneg && functions$4.pos.nonneg.includes(s2[0]) && is_positive_ast$2(s2[1], a3, true, i2) ? true : void 0 : o3 === `apply` && r2 ? functions$4.C.pos && functions$4.C.pos.includes(s2[0]) && is_complex_ast$2(s2[1], a3, i2) || functions$4.R.pos && functions$4.R.pos.includes(s2[0]) && is_real_ast$2(s2[1], a3, i2) || functions$4.nonzeroC.pos && functions$4.nonzeroC.pos.includes(s2[0]) && is_nonzero_ast$2(s2[1], a3, i2) && is_complex_ast$2(s2[1], a3, i2) || functions$4.nonneg.pos && functions$4.nonneg.pos.includes(s2[0]) && is_positive_ast$2(s2[1], a3, false, i2) || functions$4.pos.pos && functions$4.pos.pos.includes(s2[0]) && is_positive_ast$2(s2[1], a3, true, i2) ? true : void 0 : o3 === `prime` ? void 0 : false;
  }
  return false;
}
function is_negative_ast$2(t4, n2, r2, i2) {
  r2 === void 0 && (r2 = true);
  var a2 = is_real_ast$2(t4, n2, i2);
  if (a2 === true) {
    let a3 = is_positive_ast$2(t4, n2, !r2, i2);
    return a3 === false ? true : a3 === true ? false : void 0;
  }
  return a2;
}
function ParseError$2(t4, n2) {
  this.name = `ParseError`, this.message = t4 || `Error parsing input`, this.stack = Error().stack, this.location = n2;
}
ParseError$2.prototype = Object.create(Error.prototype), ParseError$2.prototype.constructor = ParseError$2;
var lexer$2 = class lexer2 {
  constructor(t4, n2 = `\\s`) {
    this.input = ``, this.location = 0, this.token_rules = [], this.initial_whitespace = RegExp(`^(` + n2 + `)+`);
    for (let n3 of t4) this.token_rules.push([RegExp(`^` + n3[0])].concat(n3.slice(1)));
  }
  set_input(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.input = t4, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: t4 = null, location: n2 = 0 } = {}) {
    t4 !== null && (this.input = t4, this.location = n2);
  }
  advance({ remove_initial_space: t4 = true } = {}) {
    let n2 = this.initial_whitespace.exec(this.input);
    if (n2) {
      let r3 = n2[0].length;
      if (this.input = this.input.slice(r3), this.location += r3, !t4) return { token_type: `SPACE`, token_text: n2[0], original_text: n2[0] };
    }
    if (this.input.length === 0) return { token_type: `EOF`, token_text: ``, original_text: `` };
    n2 = null;
    for (var r2 of this.token_rules) if (n2 = r2[0].exec(this.input), n2) {
      let t5 = n2[0].length;
      this.input = this.input.slice(t5), this.location += t5;
      break;
    }
    return n2 === null ? { token_type: `INVALID`, token_text: this.input[0], original_text: this.input[0] } : r2.length > 2 ? { token_type: r2[1], token_text: r2[2], original_text: n2[0] } : { token_type: r2[1], token_text: n2[0], original_text: n2[0] };
  }
  unput(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.location -= t4.length, this.input = t4 + this.input;
  }
}, is_associative$3 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$8(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(function(t5, n3) {
    return flatten$8(t5);
  }), is_associative$3[n2]) {
    for (var i2 = [], a2 = 0; a2 < r2.length; a2++) Array.isArray(r2[a2]) && r2[a2][0] === n2 && r2[a2].length > 2 ? i2 = i2.concat(r2[a2].slice(1)) : i2.push(r2[a2]);
    r2 = i2;
  }
  return [n2].concat(r2);
}
var number_rules_sci$1$2 = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`]], number_rules_non_sci$1$2 = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_text_rules$2 = [[`\\*\\*`, `^`], [`\\*`, `*`], [`\\xB7`, `*`], [`·`, `*`], [`•`, `*`], [`⋅`, `*`], [`×`, `*`], [`/`, `/`], [`-`, `-`], [`֊`, `-`], [`־`, `-`], [`᠆`, `-`], [`‐`, `-`], [`‑`, `-`], [`‒`, `-`], [`–`, `-`], [`—`, `-`], [`―`, `-`], [`⁻`, `-`], [`₋`, `-`], [`−`, `-`], [`⸺`, `-`], [`⸻`, `-`], [`﹘`, `-`], [`﹣`, `-`], [`－`, `-`], [`\\+`, `+`], [`plusminus(?![a-zA-Z0-9])`, `PM`], [`±`, `PM`], [`\\^`, `^`], [`‸`, `^`], [`ʌ`, `^`], [`′`, `'`], [`\\|`, `|`], [`\\(`, `(`], [`\\)`, `)`], [`\\[`, `[`], [`\\]`, `]`], [`\\{`, `{`], [`\\}`, `}`], [`⟨`, `LANGLE`], [`⟩`, `RANGLE`], [`〈`, `LANGLE`], [`〉`, `RANGLE`], [`,`, `,`], [`:`, `:`], [`α`, `VARMULTICHAR`, `alpha`], [`β`, `VARMULTICHAR`, `beta`], [`ϐ`, `VARMULTICHAR`, `beta`], [`Γ`, `VARMULTICHAR`, `Gamma`], [`γ`, `VARMULTICHAR`, `gamma`], [`Δ`, `VARMULTICHAR`, `Delta`], [`δ`, `VARMULTICHAR`, `delta`], [`ε`, `VARMULTICHAR`, `epsilon`], [`ϵ`, `VARMULTICHAR`, `epsilon`], [`ζ`, `VARMULTICHAR`, `zeta`], [`η`, `VARMULTICHAR`, `eta`], [`Θ`, `VARMULTICHAR`, `Theta`], [`ϴ`, `VARMULTICHAR`, `Theta`], [`θ`, `VARMULTICHAR`, `theta`], [`ᶿ`, `VARMULTICHAR`, `theta`], [`ϑ`, `VARMULTICHAR`, `theta`], [`ι`, `VARMULTICHAR`, `iota`], [`κ`, `VARMULTICHAR`, `kappa`], [`Λ`, `VARMULTICHAR`, `Lambda`], [`λ`, `VARMULTICHAR`, `lambda`], [`μ`, `VARMULTICHAR`, `mu`], [`µ`, `VARMULTICHAR`, `mu`], [`ν`, `VARMULTICHAR`, `nu`], [`Ξ`, `VARMULTICHAR`, `Xi`], [`ξ`, `VARMULTICHAR`, `xi`], [`Π`, `VARMULTICHAR`, `Pi`], [`π`, `VARMULTICHAR`, `pi`], [`ϖ`, `VARMULTICHAR`, `pi`], [`ρ`, `VARMULTICHAR`, `rho`], [`ϱ`, `VARMULTICHAR`, `rho`], [`Σ`, `VARMULTICHAR`, `Sigma`], [`σ`, `VARMULTICHAR`, `sigma`], [`ς`, `VARMULTICHAR`, `sigma`], [`τ`, `VARMULTICHAR`, `tau`], [`Υ`, `VARMULTICHAR`, `Upsilon`], [`υ`, `VARMULTICHAR`, `upsilon`], [`Φ`, `VARMULTICHAR`, `Phi`], [`φ`, `VARMULTICHAR`, `phi`], [`ϕ`, `VARMULTICHAR`, `phi`], [`Ψ`, `VARMULTICHAR`, `Psi`], [`ψ`, `VARMULTICHAR`, `psi`], [`Ω`, `VARMULTICHAR`, `Omega`], [`ω`, `VARMULTICHAR`, `omega`], [`∅`, `VARMULTICHAR`, `emptyset`], [`oo(?![a-zA-Z0-9])`, `INFINITY`], [`OO(?![a-zA-Z0-9])`, `INFINITY`], [`infty(?![a-zA-Z0-9])`, `INFINITY`], [`infinity(?![a-zA-Z0-9])`, `INFINITY`], [`Infinity(?![a-zA-Z0-9])`, `INFINITY`], [`∞`, `INFINITY`], [`ℯ`, `VAR`, `e`], [`♠`, `VARMULTICHAR`, `spade`], [`♡`, `VARMULTICHAR`, `heart`], [`♢`, `VARMULTICHAR`, `diamond`], [`♣`, `VARMULTICHAR`, `club`], [`★`, `VARMULTICHAR`, `bigstar`], [`◯`, `VARMULTICHAR`, `bigcirc`], [`◊`, `VARMULTICHAR`, `lozenge`], [`△`, `VARMULTICHAR`, `bigtriangleup`], [`▽`, `VARMULTICHAR`, `bigtriangledown`], [`⧫`, `VARMULTICHAR`, `blacklozenge`], [`■`, `VARMULTICHAR`, `blacksquare`], [`▲`, `VARMULTICHAR`, `blacktriangle`], [`▼`, `VARMULTICHAR`, `blacktriangledown`], [`◀`, `VARMULTICHAR`, `blacktriangleleft`], [`▶`, `VARMULTICHAR`, `blacktriangleright`], [`□`, `VARMULTICHAR`, `Box`], [`∘`, `VARMULTICHAR`, `circ`], [`⋆`, `VARMULTICHAR`, `star`], [`and(?![a-zA-Z0-9])`, `AND`], [`\\&\\&?`, `AND`], [`∧`, `AND`], [`or(?![a-zA-Z0-9])`, `OR`], [`∨`, `OR`], [`not(?![a-zA-Z0-9])`, `NOT`], [`¬`, `NOT`], [`=`, `=`], [`᐀`, `=`], [`゠`, `=`], [`!=`, `NE`], [`≠`, `NE`], [`<=`, `LE`], [`≤`, `LE`], [`>=`, `GE`], [`≥`, `GE`], [`<`, `<`], [`>`, `>`], [`forall(?![a-zA-Z0-9])`, `FORALL`], [`∀`, `FORALL`], [`exists(?![a-zA-Z0-9])`, `EXISTS`], [`∃`, `EXISTS`], [`elementof(?![a-zA-Z0-9])`, `IN`], [`∈`, `IN`], [`notelementof(?![a-zA-Z0-9])`, `NOTIN`], [`∉`, `NOTIN`], [`containselement(?![a-zA-Z0-9])`, `NI`], [`∋`, `NI`], [`notcontainselement(?![a-zA-Z0-9])`, `NOTNI`], [`∌`, `NOTNI`], [`subset(?![a-zA-Z0-9])`, `SUBSET`], [`⊂`, `SUBSET`], [`subseteq(?![a-zA-Z0-9])`, `SUBSETEQ`], [`⊆`, `SUBSETEQ`], [`notsubset(?![a-zA-Z0-9])`, `NOTSUBSET`], [`⊄`, `NOTSUBSET`], [`notsubseteq(?![a-zA-Z0-9])`, `NOTSUBSETEQ`], [`⊈`, `NOTSUBSETEQ`], [`superset(?![a-zA-Z0-9])`, `SUPERSET`], [`⊃`, `SUPERSET`], [`superseteq(?![a-zA-Z0-9])`, `SUPERSETEQ`], [`⊇`, `SUPERSETEQ`], [`notsuperset(?![a-zA-Z0-9])`, `NOTSUPERSET`], [`⊅`, `NOTSUPERSET`], [`notsuperseteq(?![a-zA-Z0-9])`, `NOTSUPERSETEQ`], [`⊉`, `NOTSUPERSETEQ`], [`union(?![a-zA-Z0-9])`, `UNION`], [`∪`, `UNION`], [`intersect(?![a-zA-Z0-9])`, `INTERSECT`], [`∩`, `INTERSECT`], [`rightarrow(?![a-zA-Z0-9])`, `RIGHTARROW`], [`→`, `RIGHTARROW`], [`⟶`, `RIGHTARROW`], [`leftarrow(?![a-zA-Z0-9])`, `LEFTARROW`], [`←`, `LEFTARROW`], [`⟵`, `LEFTARROW`], [`leftrightarrow(?![a-zA-Z0-9])`, `LEFTRIGHTARROW`], [`↔`, `LEFTRIGHTARROW`], [`⟷`, `LEFTRIGHTARROW`], [`implies(?![a-zA-Z0-9])`, `IMPLIES`], [`⇒`, `IMPLIES`], [`⟹`, `IMPLIES`], [`impliedby(?![a-zA-Z0-9])`, `IMPLIEDBY`], [`⇐`, `IMPLIEDBY`], [`⟸`, `IMPLIEDBY`], [`iff(?![a-zA-Z0-9])`, `IFF`], [`⇔`, `IFF`], [`⟺`, `IFF`], [`perp(?![a-zA-Z0-9])`, `PERP`], [`⟂`, `PERP`], [`parallel(?![a-zA-Z0-9])`, `PARALLEL`], [`∥`, `PARALLEL`], [`angle(?![a-zA-Z0-9])`, `ANGLE`], [`∠`, `ANGLE`], [`int(?![a-zA-Z0-9])`, `INT`], [`∫`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`\\.\\.\\.`, `LDOTS`], [`[a-zA-Z∂][a-zA-Z∂0-9]*`, `VAR`], [`[＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault$1$2 = true, splitSymbolsDefault$2 = true, unsplitSymbolsDefault$2 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.angle.deg.emptyset`.split(`.`), appliedFunctionSymbolsDefault$1$2 = `abs.exp.log.ln.log10.sign.sqrt.cbrt.nthroot.mod.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.re.im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault$1$2 = [`f`, `g`], operatorSymbolsDefault$1$2 = [`binom`, `vec`, `linesegment`], unitsDefault$1$2 = get_all_units$2(), parseLeibnizNotationDefault$1$2 = true, textToAst$4$2 = class textToAst$42 {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault$1$2, splitSymbols: n2 = splitSymbolsDefault$2, unsplitSymbols: r2 = unsplitSymbolsDefault$2, appliedFunctionSymbols: i2 = appliedFunctionSymbolsDefault$1$2, functionSymbols: a2 = functionSymbolsDefault$1$2, operatorSymbols: o2 = operatorSymbolsDefault$1$2, units: s2 = unitsDefault$1$2, parseLeibnizNotation: c2 = parseLeibnizNotationDefault$1$2, parseScientificNotation: l2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.splitSymbols = n2, this.unsplitSymbols = r2, this.appliedFunctionSymbols = i2, this.functionSymbols = a2, this.operatorSymbols = o2, this.units = s2, this.parseLeibnizNotation = c2;
    let u2 = base_text_rules$2;
    u2 = l2 ? [...number_rules_sci$1$2, ...u2] : [...number_rules_non_sci$1$2, ...u2], this.lexer = new lexer$2(u2);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError$2(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError$2(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten$8(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      return this.token.token_type === `:` ? (this.advance(), [`:`, r2, this.statement_a()]) : r2;
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten$8(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let n3 = r2.length;
      for (let [t5, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && t5 < n3 - 1) {
            let o2;
            o2 = t5 === n3 - 2 ? r2[n3 - 1] : this.convert_units_in_term([`*`, ...r2.slice(t5 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return t5 === 0 ? c2 : [`*`, ...r2.slice(0, t5), c2];
          } else if (!a2.prefix && t5 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = t5 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, t5)], o2], t5 === n3 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(t5 + 1)]);
          }
        }
      }
      return t4;
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    return t4;
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n2 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n2 === false && (n2 = `＿`), n2;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`) if (a2 = this.token.token_text, this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
      let t5 = false;
      if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), this.advance(), this.token.token_type === `_`) {
        this.advance();
        let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
        a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
      }
      if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
      else {
        for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
        for (; this.token.token_type === `^`; ) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = [`^`, a2, t6];
        }
        if (this.token.token_type === `(`) {
          this.advance();
          let t6 = this.statement_list();
          if (this.token.token_type !== `)`) throw new ParseError$2(`Expecting )`, this.lexer.location);
          this.advance(), t6[0] === `list` && (t6[0] = `tuple`), a2 = [`apply`, a2, t6];
        } else if (t5) {
          if (!this.allowSimplifiedFunctionApplication) throw new ParseError$2(`Expecting ( after function`, this.lexer.location);
          let t6 = this.factor({ parse_absolute_value: n2 });
          t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
        }
      }
      return a2;
    } else if (this.operatorSymbols.includes(a2)) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError$2(`Expecting )`, this.lexer.location);
      this.advance(), a2 = t5[0] === `list` ? [a2, ...t5.slice(1)] : [a2, t5];
    } else {
      let t5 = this.factor({ parse_absolute_value: n2 });
      t5 === false && (t5 = `＿`), a2 = [a2, t5];
    }
    else {
      if (this.parseLeibnizNotation) {
        let t5 = this.return_state(), n3 = this.leibniz_notation();
        if (n3) return n3;
        this.set_state(t5);
      }
      let i3 = this.splitSymbols;
      if (i3 && (this.token.token_type === `VARMULTICHAR` || this.unsplitSymbols.includes(a2) || a2.length === 1 || a2.match(/[\d]/g)) && (i3 = false), i3) {
        for (let t5 = a2.length - 1; t5 >= 0; t5--) this.lexer.unput(` `), this.lexer.unput(a2[t5]);
        return this.advance(), this.baseFactor({ inside_absolute_value: t4, parse_absolute_value: n2, allow_absolute_value_closing: r2 });
      } else this.advance();
    }
    else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError$2(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError$2(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `{` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `{` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type === `|` && n2 && (t4 === 0 || !r2)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError$2(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError$2(`Expecting )`, this.lexer.location);
      this.advance(), t5[0] === `list` ? a2 = [`angle`, ...t5.slice(1)] : t5[0] === `*` && (a2 = [`angle`, t5]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten$8(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    var t4 = this.token.token_text;
    if (!(this.token.token_type === `VAR` && (t4[0] === `d` || t4[0] === `∂`) && (t4.length === 1 || t4.length === 2 && /[a-zA-Z]/.exec(t4[1])))) return false;
    let n2 = t4[0], r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (t4.length === 2) i2 = t4[1];
    else if (this.advance(), this.token.token_type === `VARMULTICHAR` || this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`)) i2 = this.token.token_text;
    else {
      if (this.token.token_type !== `^` || (this.advance(), this.token.token_type !== `NUMBER`) || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2))) return false;
      if (this.advance(), this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`) i2 = this.token.token_text;
      else return false;
    }
    if (this.advance(), this.token.token_type !== `/`) return false;
    let s2 = 0;
    for (this.advance(); ; ) {
      if (this.token.token_type !== `VAR` || this.token.token_text[0] !== n2) return false;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let c2 = this.token.token_text;
      if (c2.length === 2) if (/[a-zA-Z]/.exec(c2[1])) a2.push(c2[1]);
      else return false;
      else {
        if (this.advance(), !(this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`)) return false;
        a2.push(this.token.token_text);
      }
      let l2 = 1, u2 = false;
      if (this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance()), this.token.token_type === `^`) {
        if (this.advance(), this.token.token_type !== `NUMBER` || (l2 = parseFloat(this.token.token_text), !Number.isInteger(l2))) return false;
        u2 = false, this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance());
      }
      if (o2.push(l2), s2 += l2, s2 > r2) return false;
      if (s2 === r2) {
        if (!u2 && (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`)) return false;
        this.token.token_type === `SPACE` && this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, MAX_PM_COUNT$2 = 10, MAX_PM_EXPANSIONS$2 = 1 << MAX_PM_COUNT$2;
function contains_pm$2(t4) {
  if (!Array.isArray(t4)) return false;
  if (t4[0] === `pm`) return true;
  for (let n2 = 1; n2 < t4.length; n2++) if (contains_pm$2(t4[n2])) return true;
  return false;
}
function count_pm$2(t4) {
  if (!Array.isArray(t4)) return 0;
  let n2 = +(t4[0] === `pm`);
  for (let r2 = 1; r2 < t4.length; r2++) n2 += count_pm$2(t4[r2]);
  return n2;
}
function expand_pm_signs$2(t4) {
  let n2 = count_pm$2(t4);
  if (n2 === 0) return [t4];
  if (n2 > MAX_PM_COUNT$2) throw Error(`pm: cannot expand ${n2} plus-minus operators (limit is ${MAX_PM_COUNT$2} → ${MAX_PM_EXPANSIONS$2} combinations)`);
  let r2 = 1 << n2, i2 = [];
  for (let n3 = 0; n3 < r2; n3++) i2.push(replace_pm$2(t4, n3, { idx: 0 }));
  return i2;
}
function replace_pm$2(t4, n2, r2) {
  if (!Array.isArray(t4)) return t4;
  if (t4[0] === `pm`) {
    let i3 = n2 >> r2.idx & 1;
    r2.idx += 1;
    let a2 = replace_pm$2(t4[1], n2, r2);
    return i3 === 0 ? a2 : [`-`, a2];
  }
  let i2 = [t4[0]];
  for (let a2 = 1; a2 < t4.length; a2++) i2.push(replace_pm$2(t4[a2], n2, r2));
  return i2;
}
var transformation_exports$2 = __exportAll$2({ expand: () => expand$2, expand_relations: () => expand_relations$2, get_component: () => get_component$2, perform_matrix_multiplications: () => perform_matrix_multiplications$2, perform_matrix_scalar_multiplications: () => perform_matrix_scalar_multiplications$2, perform_vector_scalar_multiplications: () => perform_vector_scalar_multiplications$2, substitute: () => substitute$3, substitute_component: () => substitute_component$2 }), textToAst$3$2 = new textToAst$4$2();
function expand$2(t4, n2) {
  var r2 = get_tree$2(t4);
  r2 = perform_matrix_multiplications$2(r2), r2 = perform_vector_matrix_additions_scalar_multiplications$2(r2);
  let i2 = (t5) => !Array.isArray(t5) || ![`d`, `*`].includes(t5[0]) || t5[0] === `*` && t5.slice(1).every((t6) => !Array.isArray(t6) || t6[0] !== `d`), a2 = (t5) => i2(t5) && !contains_pm$2(t5), o2 = (t5) => !contains_pm$2(t5);
  var s2 = [];
  return s2.push([textToAst$3$2.convert(`a*(b+c)`), textToAst$3$2.convert(`a*b+a*c`), { variables: { a: a2, b: true, c: true }, allow_extended_match: true }]), s2.push([textToAst$3$2.convert(`(a+b)*c`), textToAst$3$2.convert(`a*c+b*c`), { variables: { a: true, b: true, c: a2 }, allow_extended_match: true }]), n2 || s2.push([textToAst$3$2.convert(`(a+b)/c`), textToAst$3$2.convert(`a/c+b/c`), { variables: { a: true, b: true, c: o2 } }]), s2.push([textToAst$3$2.convert(`-(a+b)`), textToAst$3$2.convert(`-a-b`)]), s2.push([textToAst$3$2.convert(`a(-b)`), textToAst$3$2.convert(`-ab`)]), s2.push([textToAst$3$2.convert(`(a+b)^2`), textToAst$3$2.convert(`a^2+2ab+b^2`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$2.convert(`(a+b)^3`), textToAst$3$2.convert(`a^3+3a^2b+3ab^2+b^3`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$2.convert(`(a+b)^4`), textToAst$3$2.convert(`a^4+4a^3b+6a^2b^2+4ab^3+b^4`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$2.convert(`a*(b+c)*d`), textToAst$3$2.convert(`(a*b+a*c)*d`), { variables: { a: o2, b: true, c: true, d: true } }]), r2 = applyAllTransformations$2(r2, s2, 20), r2 = flatten$5$2(r2), r2 = evaluate_numbers$2(r2), r2 = collect_like_terms_factors$2(r2), r2 = normalize_negatives$2(r2), r2;
}
function perform_matrix_multiplications$2(t4, n2 = true, r2 = true) {
  var i2 = get_tree$2(t4);
  function a2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = n3[1][2];
    if (n3[1][1] !== i3) return { success: false };
    let o3 = t5[2], s3 = n3[2], c3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let n4 = o3[t6 + 1].slice(1), r4 = [`tuple`];
      for (let t7 = 0; t7 < a3; t7++) {
        let a4 = s3.slice(1).map((n5) => n5[t7 + 1]);
        if (n4.length !== i3 || a4.length !== i3) return subtree;
        let o4 = [`+`, ...n4.map((t8, n5) => [`*`, t8, a4[n5]])];
        r4.push(o4);
      }
      c3.push(r4);
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, a3], c3] };
  }
  function o2(t5, n3) {
    if (!Number.isInteger(n3) || n3 < 1) return { success: false };
    if (n3 === 1) return { success: true, newMatrix: t5 };
    let r3 = t5[1][1];
    if (t5[1][2] !== r3) return { success: false };
    let i3 = t5[2], a3 = JSON.parse(JSON.stringify(i3));
    for (let t6 = 1; t6 < n3; t6++) {
      let t7 = a3;
      a3 = [`tuple`];
      for (let n4 = 0; n4 < r3; n4++) {
        let o3 = t7[n4 + 1].slice(1), s3 = [`tuple`];
        for (let t8 = 0; t8 < r3; t8++) {
          let n5 = i3.slice(1).map((n6) => n6[t8 + 1]);
          if (o3.length !== r3 || n5.length !== r3) return subtree;
          let a4 = [`+`, ...o3.map((t9, r4) => [`*`, t9, n5[r4]])];
          s3.push(a4);
        }
        a3.push(s3);
      }
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, r3], a3] };
  }
  function s2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = t5[2], o3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let r4 = [`tuple`], s3 = a3[t6 + 1];
      for (let t7 = 0; t7 < i3; t7++) r4.push([`*`, n3, s3[t7 + 1]]);
      o3.push(r4);
    }
    return [`matrix`, [`tuple`, r3, i3], o3];
  }
  function c2() {
    let t5 = [`^`, [`matrix`, `size`, `matrixData`], `p`], n3 = { variables: { p: (t6) => Number.isInteger(t6) && t6 > 0, size: true, matrixData: true } };
    i2 = transform$2(i2, function(r3) {
      let i3 = match$1$2(r3, t5, n3);
      if (i3) {
        let t6 = o2([`matrix`, i3.size, i3.matrixData], i3.p);
        return t6.success ? t6.newMatrix : r3;
      } else return r3;
    });
  }
  function l2() {
    let t5 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], n3 = { variables: { a: true, b: true, size: true, matrixData: true }, allow_implicit_identities: [`a`, `b`] };
    i2 = transform$2(i2, function(r3) {
      let i3 = match$1$2(r3, t5, n3);
      if (i3) {
        let t6 = [`matrix`, i3.size, i3.matrixData], n4 = [], r4 = [];
        Array.isArray(i3.a) && i3.a[0] === `*` ? n4.push(...i3.a.slice(1)) : n4.push(i3.a), Array.isArray(i3.b) && i3.b[0] === `*` ? r4.push(...i3.b.slice(1)) : r4.push(i3.b);
        let o3 = n4.length;
        for (let r5 = o3 - 1; r5 >= 0; r5--) {
          let i4 = n4[r5][0];
          if (i4 === `matrix`) {
            let i5 = a2(n4[r5], t6);
            if (i5.success) t6 = i5.newMatrix, n4.pop();
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(i4)) break;
          else n4[r5] !== 1 && (t6 = s2(t6, n4[r5])), n4.pop();
        }
        for (; r4.length > 0; ) {
          let n5 = r4[0][0];
          if (n5 === `matrix`) {
            let n6 = a2(t6, r4[0]);
            if (n6.success) t6 = n6.newMatrix, r4.splice(0, 1);
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(n5)) break;
          else r4[0] !== 1 && (t6 = s2(t6, r4[0])), r4.splice(0, 1);
        }
        return n4.length > 0 || r4.length > 0 ? [`*`, ...n4, t6, ...r4] : t6;
      } else return r3;
    });
  }
  function u2() {
    let t5 = [`*`, [`matrix`, [`tuple`, `m`, `n`], `matrixData`], `b`], a3 = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: true, b: true } };
    i2 = transform$2(i2, function(i3) {
      let o3 = match$1$2(i3, t5, a3);
      if (o3) {
        let t6 = o3.m, a4 = o3.n, s3 = o3.b, c3 = o3.matrixData, l3 = [];
        n2 && (l3.push(`vector`), l3.push(`altvector`)), r2 && l3.push(`tuple`);
        let u3, d2 = [];
        if (l3.includes(s3[0])) u3 = s3;
        else if (Array.isArray(s3) && s3[0] === `*` && l3.includes(s3[1][0])) u3 = s3[1], d2 = s3.slice(2);
        else return i3;
        let p2 = u3.slice(1);
        if (p2.length !== a4) return i3;
        let m2 = [u3[0]];
        for (let n3 = 0; n3 < t6; n3++) {
          let t7 = [`+`, ...c3[n3 + 1].slice(1).map((t8, n4) => [`*`, t8, p2[n4]])];
          m2.push(t7);
        }
        return d2.length > 0 ? [`*`, m2, ...d2] : m2;
      } else return i3;
    });
  }
  return c2(), l2(), (n2 || r2) && u2(), i2;
}
function perform_vector_scalar_multiplications$2(t4, n2 = true) {
  var r2 = get_tree$2(t4);
  let i2 = function(t5, n3) {
    let r3 = [`*`, `a`, [n3, `vectorData`], `b`], i3 = { allow_implicit_identities: [`a`, `b`] };
    return t5 = transform$2(t5, function(t6) {
      let a2 = match$1$2(t6, r3, i3);
      if (a2) {
        if (a2.a === 1 && a2.b === 1) return t6;
        let r4 = a2.vectorData;
        r4 = Array.isArray(r4) && r4[0] === n3 ? r4.slice(1) : [r4];
        let i4 = [], o2 = [];
        Array.isArray(a2.a) && a2.a[0] === `*` ? i4.push(...a2.a.slice(1)) : i4.push(a2.a), Array.isArray(a2.b) && a2.b[0] === `*` ? o2.push(...a2.b.slice(1)) : o2.push(a2.b);
        let s2 = i4.length;
        for (let t7 = s2 - 1; t7 >= 0; t7--) {
          let n4 = i4[t7][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
          i4[t7] !== 1 && (r4 = r4.map((n5) => [`*`, n5, i4[t7]])), i4.pop();
        }
        for (; o2.length > 0; ) {
          let t7 = o2[0][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t7)) break;
          o2[0] !== 1 && (r4 = r4.map((t8) => [`*`, t8, o2[0]])), o2.splice(0, 1);
        }
        let c2 = [n3, ...r4];
        return i4.length > 0 || o2.length > 0 ? [`*`, ...i4, c2, ...o2] : c2;
      } else return t6;
    }), t5;
  };
  return r2 = i2(r2, `vector`), r2 = i2(r2, `altvector`), n2 && (r2 = i2(r2, `tuple`)), r2;
}
function perform_matrix_scalar_multiplications$2(t4) {
  var n2 = get_tree$2(t4);
  let r2 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], i2 = { allow_implicit_identities: [`a`, `b`] };
  return n2 = transform$2(n2, function(t5) {
    let n3 = match$1$2(t5, r2, i2);
    if (n3) {
      if (n3.a === 1 && n3.b === 1) return t5;
      let r3 = n3.matrixData, i3 = [], a2 = [];
      Array.isArray(n3.a) && n3.a[0] === `*` ? i3.push(...n3.a.slice(1)) : i3.push(n3.a), Array.isArray(n3.b) && n3.b[0] === `*` ? a2.push(...n3.b.slice(1)) : a2.push(n3.b);
      let o2 = i3.length;
      for (let t6 = o2 - 1; t6 >= 0; t6--) {
        let n4 = i3[t6][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
        i3[t6] !== 1 && (r3 = r3.map((n5) => n5 === `tuple` ? n5 : n5.map((n6) => n6 === `tuple` ? n6 : [`*`, n6, i3[t6]]))), i3.pop();
      }
      for (; a2.length > 0; ) {
        let t6 = a2[0][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t6)) break;
        a2[0] !== 1 && (r3 = r3.map((t7) => t7 === `tuple` ? t7 : t7.map((t8) => t8 === `tuple` ? t8 : [`*`, t8, a2[0]]))), a2.splice(0, 1);
      }
      let s2 = [`matrix`, n3.size, r3];
      return i3.length > 0 || a2.length > 0 ? [`*`, ...i3, s2, ...a2] : s2;
    } else return t5;
  }), n2;
}
function expand_relations$2(t4) {
  return transform$2(get_tree$2(t4), expand_relations_transform$2);
}
function expand_relations_transform$2(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `=`) {
    if (r2.length <= 2) return t4;
    let n3 = [`and`];
    for (let t5 = 0; t5 < r2.length - 1; t5++) n3.push([`=`, r2[t5], r2[t5 + 1]]);
    return n3;
  }
  if (n2 === `gts` || n2 === `lts`) {
    let t5 = r2[0], i2 = r2[1];
    if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let a2 = [];
    for (let r3 = 1; r3 < t5.length - 1; r3++) {
      let o3;
      o3 = i2[r3] ? n2 === `lts` ? `<` : `>` : n2 === `lts` ? `le` : `ge`, a2.push([o3, t5[r3], t5[r3 + 1]]);
    }
    let o2 = [`and`, a2[0], a2[1]];
    for (let t6 = 2; t6 < a2.length; t6++) o2 = [`and`, o2, a2[t6]];
    return o2;
  }
  if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
    let i2 = false;
    (n2 === `notin` || n2 === `notni`) && (i2 = true);
    let a2, o2;
    if (n2 === `in` || n2 === `notin` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), o2 = to_intervals$2(o2), o2[0] !== `interval`) return t4;
    let s2 = o2[1], c2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let l2 = s2[1], u2 = s2[2], d2 = [];
    c2[1] ? i2 ? d2.push([`<`, a2, l2]) : d2.push([`ge`, a2, l2]) : i2 ? d2.push([`le`, a2, l2]) : d2.push([`>`, a2, l2]), c2[2] ? i2 ? d2.push([`>`, a2, u2]) : d2.push([`le`, a2, u2]) : i2 ? d2.push([`ge`, a2, u2]) : d2.push([`<`, a2, u2]);
    let p2;
    return p2 = i2 ? [`or`].concat(d2) : [`and`].concat(d2), p2;
  }
  if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
    let i2 = false;
    (n2 === `notsubset` || n2 === `notsuperset`) && (i2 = true);
    let a2, o2;
    if (n2 === `subset` || n2 === `notsubset` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), a2 = to_intervals$2(a2), o2 = to_intervals$2(o2), a2[0] !== `interval` || o2[0] !== `interval`) return t4;
    let s2 = a2[1], c2 = a2[2], l2 = o2[1], u2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple` || l2[0] !== `tuple` || u2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let d2 = s2[1], p2 = s2[2], m2 = l2[1], h2 = l2[2], g2 = [];
    c2[1] && !u2[1] ? i2 ? g2.push([`le`, d2, m2]) : g2.push([`>`, d2, m2]) : i2 ? g2.push([`<`, d2, m2]) : g2.push([`ge`, d2, m2]), c2[2] && !u2[2] ? i2 ? g2.push([`ge`, p2, h2]) : g2.push([`<`, p2, h2]) : i2 ? g2.push([`>`, p2, h2]) : g2.push([`le`, p2, h2]);
    let v2;
    return v2 = i2 ? [`or`].concat(g2) : [`and`].concat(g2), v2;
  }
  return t4;
}
function substitute$3(t4, n2) {
  var r2 = get_tree$2(t4), i2 = {};
  for (let t5 in n2) i2[t5] = get_tree$2(n2[t5]);
  return substitute$1$2(r2, i2);
}
function substitute_component$2(t4, n2, r2) {
  let i2 = get_tree$2(t4);
  get_tree$2(r2);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid substitute_component: ` + n2);
  let o2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return s2(i2, n2);
  function s2(t5, n3, i3) {
    if (n3.length === 0) return r2;
    if (!Array.isArray(t5)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let a2 = t5[0], c2 = t5.slice(1);
    if (!o2.includes(a2)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let l2 = n3[0];
    if (l2 < 0 || l2 > c2.length - 1) throw Error(`Invalid substitute_component: component out of range`);
    let u2 = n3.slice(1), d2 = s2(c2[l2], u2);
    return [a2, ...c2.slice(0, l2), d2, ...c2.slice(l2 + 1)];
  }
}
function get_component$2(t4, n2) {
  let r2 = get_tree$2(t4);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid get_component: ` + n2);
  let i2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return a2(r2, n2);
  function a2(t5, n3) {
    if (n3.length === 0) return t5;
    if (!Array.isArray(t5)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let r3 = t5[0], o2 = t5.slice(1);
    if (!i2.includes(r3)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let s2 = n3[0];
    if (s2 < 0 || s2 > o2.length - 1) throw Error(`Invalid get_component: component out of range`);
    let c2 = n3.slice(1);
    return a2(o2[s2], c2);
  }
}
function apply_root$2(t4, n2) {
  return n2 === 2 ? [`apply`, `sqrt`, t4] : n2 === 3 ? [`apply`, `cbrt`, t4] : [`apply`, `nthroot`, [`tuple`, t4, n2]];
}
function pull_number_outside_root$2(t4, n2 = 2) {
  let r2 = t4, i2 = 1, a2 = 2, o2 = mathjs_default$2.pow(a2, n2);
  for (; o2 <= Math.abs(r2); ) r2 % o2 === 0 ? (r2 /= o2, i2 *= a2) : (a2++, o2 = mathjs_default$2.pow(a2, n2));
  return { n_outside: i2, n_inside: r2 };
}
function make_power$2(t4, n2) {
  return n2 === 0 ? 1 : n2 === 1 ? t4 : [`^`, t4, n2];
}
function collect_radicand_factors$2(t4, n2) {
  let r2 = 1, i2 = (t5) => {
    if (Array.isArray(t5) && t5[0] === `*`) for (let n3 of t5.slice(1)) i2(n3);
    else Array.isArray(t5) && t5[0] === `-` ? (r2 = -r2, i2(t5[1])) : typeof t5 == `number` && t5 < 0 ? (r2 = -r2, n2.push(-t5)) : n2.push(t5);
  };
  return i2(t4), r2;
}
function combine_factors$2(t4, n2) {
  let r2 = 1, i2 = /* @__PURE__ */ new Map(), a2 = /* @__PURE__ */ new Map(), o2 = [], s2 = [];
  for (let c2 of t4) {
    if (typeof c2 == `number`) {
      r2 *= c2;
      continue;
    }
    let t5, l2;
    if (typeof c2 == `string`) t5 = c2, l2 = 1;
    else if (Array.isArray(c2) && c2[0] === `^` && typeof c2[1] == `string` && Number.isInteger(c2[2])) t5 = c2[1], l2 = c2[2];
    else {
      s2.push(c2);
      continue;
    }
    if (a2.has(t5) || a2.set(t5, is_nonzero_ast$2(t5, n2) === true), l2 < 1 && !a2.get(t5)) {
      s2.push(c2);
      continue;
    }
    i2.has(t5) ? i2.set(t5, i2.get(t5) + l2) : (o2.push(t5), i2.set(t5, l2));
  }
  return { numberFactor: r2, expByVar: i2, varOrder: o2, others: s2 };
}
function pull_factor_into_root$2(t4, n2, r2, i2, a2, o2) {
  let s2 = n2 >= 1 ? Math.floor(n2 / r2) : 0;
  if (s2 === 0) {
    o2.push(make_power$2(t4, n2));
    return;
  }
  let c2;
  if (is_positive_ast$2(t4, i2, false)) c2 = t4;
  else if (r2 % 2 == 1 && is_real_ast$2(t4, i2)) c2 = t4;
  else if (r2 % 2 == 0 && is_real_ast$2(t4, i2)) c2 = s2 % 2 == 0 ? t4 : [`apply`, `abs`, t4];
  else {
    o2.push(make_power$2(t4, n2));
    return;
  }
  a2.push(make_power$2(c2, s2)), o2.push(make_power$2(t4, n2 % r2));
}
function simplify_powers_in_roots$2(t4, n2) {
  if (!Array.isArray(t4)) return t4;
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `*`) {
    let t5 = [];
    for (let r4 of i2) {
      let i3 = simplify_powers_in_roots$2(r4, n2);
      Array.isArray(i3) && i3[0] === `*` ? t5.push(...i3.slice(1)) : t5.push(i3);
    }
    let { numberFactor: r3, expByVar: a2, varOrder: o2, others: s2 } = combine_factors$2(t5, n2), c2 = [];
    r3 !== 1 && c2.push(r3);
    for (let t6 of o2) {
      let n3 = make_power$2(t6, a2.get(t6));
      n3 !== 1 && c2.push(n3);
    }
    return c2.push(...s2), c2.length === 0 ? 1 : c2.length === 1 ? c2[0] : [`*`, ...c2];
  }
  if (r2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(i2[0])) {
    let t5 = i2[0], r3 = 2, a2 = i2[1];
    if (t5 === `cbrt`) r3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(i2[1]) && i2[1][0] === `tuple`) if (Number.isInteger(i2[1][2]) && i2[1][2] > 0) r3 = i2[1][2], a2 = i2[1][1];
    else return [`apply`, `nthroot`, ...i2.slice(1).map((t6) => simplify_powers_in_roots$2(t6, n2))];
    else r3 = 2;
    a2 = simplify_powers_in_roots$2(a2, n2);
    let o2 = [], s2 = collect_radicand_factors$2(a2, o2), { numberFactor: c2, expByVar: l2, varOrder: u2, others: d2 } = combine_factors$2(o2, n2);
    if (c2 === 0) return 0;
    let p2 = [], m2 = [];
    if (Number.isInteger(c2)) {
      let { n_outside: t6, n_inside: n3 } = pull_number_outside_root$2(c2, r3);
      t6 !== 1 && p2.push(t6), n3 !== 1 && m2.push(n3);
    } else c2 !== 1 && m2.push(c2);
    for (let t6 of u2) pull_factor_into_root$2(t6, l2.get(t6), r3, n2, p2, m2);
    for (let t6 of d2) Array.isArray(t6) && t6[0] === `^` && Number.isInteger(t6[2]) ? pull_factor_into_root$2(t6[1], t6[2], r3, n2, p2, m2) : m2.push(t6);
    let h2 = m2.filter((t6) => t6 !== 1), g2;
    if (h2.length === 0) g2 = s2 < 0 ? -1 : 1;
    else {
      let t6 = h2.length === 1 ? h2[0] : [`*`, ...h2];
      g2 = s2 < 0 ? [`-`, t6] : t6;
    }
    let v2 = p2.filter((t6) => t6 !== 1);
    return g2 !== 1 && v2.push(apply_root$2(g2, r3)), v2.length === 0 ? 1 : v2.length === 1 ? v2[0] : [`*`, ...v2];
  }
  return [r2, ...i2.map((t5) => simplify_powers_in_roots$2(t5, n2))];
}
var simplify_exports$2 = __exportAll$2({ add_unit: () => add_unit$2, clean: () => clean$4, collapse_unary_minus: () => collapse_unary_minus$2, collect_like_terms_factors: () => collect_like_terms_factors$2, default_order: () => default_order$2, evaluate_numbers: () => evaluate_numbers$2, perform_vector_matrix_additions_scalar_multiplications: () => perform_vector_matrix_additions_scalar_multiplications$2, remove_scaling_units: () => remove_scaling_units$2, remove_units: () => remove_units$2, set_small_zero: () => set_small_zero$2, simplify: () => simplify$2, simplify_logical: () => simplify_logical$2, simplify_ratios: () => simplify_ratios$2 });
function clean$4(t4) {
  return flatten$5$2(get_tree$2(t4));
}
function evalf$2(t4, n2) {
  return parseFloat(mathjs_default$2.format(t4, { notation: `exponential`, precision: n2 }));
}
function collapse_unary_minus$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map((t5) => collapse_unary_minus$2(t5)), r2 === `-`) {
    if (typeof i2[0] == `number`) return -i2[0];
    if (Array.isArray(i2[0]) && i2[0][0] === `*` && typeof i2[0][1] == `number`) return [`*`, -i2[0][1]].concat(i2[0].slice(2));
    if (Array.isArray(i2[0]) && i2[0][0] === `/`) {
      if (typeof i2[0][1] == `number`) return [`/`, -i2[0][1], i2[0][2]];
      if (Array.isArray(i2[0][1]) && i2[0][1][0] === `*` && typeof i2[0][1][1] == `number`) return [`/`, [`*`, -i2[0][1][1]].concat(i2[0][1].slice(2)), i2[0][2]];
    }
  }
  return [r2].concat(i2);
}
function simplify$2(t4, n2, r2) {
  var i2 = get_tree$2(t4);
  return contains_blank$2(i2) || (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2 = evaluate_numbers$2(i2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), !Array.isArray(i2)) ? i2 : (i2 = simplify_logical$2(i2, n2), i2 = perform_vector_matrix_additions_scalar_multiplications$2(i2), i2 = simplify_integers_in_roots$2(i2), i2 = collect_like_terms_factors$2(i2, n2, r2), i2);
}
function simplify_logical$2(t4, n2) {
  var r2 = get_tree$2(t4);
  if (contains_blank$2(r2)) return r2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), r2 = evaluate_numbers$2(r2, { assumptions: n2 }), r2 = unflattenRight$2(r2);
  var i2 = [];
  return i2.push([[`not`, [`not`, `a`]], `a`]), i2.push([[`not`, [`and`, `a`, `b`]], [`or`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`or`, `a`, `b`]], [`and`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`=`, `a`, `b`]], [`ne`, `a`, `b`]]), i2.push([[`not`, [`ne`, `a`, `b`]], [`=`, `a`, `b`]]), i2.push([[`not`, [`<`, `a`, `b`]], [`le`, `b`, `a`]]), i2.push([[`not`, [`le`, `a`, `b`]], [`not`, [`le`, `a`, `b`]]]), i2.push([[`not`, [`in`, `a`, `b`]], [`notin`, `a`, `b`]]), i2.push([[`not`, [`subset`, `a`, `b`]], [`notsubset`, `a`, `b`]]), r2 = applyAllTransformations$2(r2, i2, 20), r2 = flatten$5$2(r2), r2;
}
function simplify_integers_in_roots$2(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = 1, n3 = [];
    for (let i2 of r2) if (typeof i2 == `number`) t5 *= i2;
    else {
      let r3 = simplify_integers_in_roots$2(i2);
      Array.isArray(r3) && r3[0] === `*` ? typeof r3[1] == `number` ? (t5 *= r3[1], n3.push(...r3.slice(2))) : n3.push(...r3.slice(1)) : n3.push(r3);
    }
    return t5 !== 1 && n3.unshift(t5), [`*`, ...n3];
  }
  if (n2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(r2[0])) {
    let t5 = r2[0], n3 = 2, i2 = r2[1];
    if (t5 === `cbrt`) n3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(r2[1]) && r2[1][0] === `tuple`) if (Number.isInteger(r2[1][2]) && r2[1][2] > 0) n3 = r2[1][2], i2 = r2[1][1];
    else return [`apply`, `nthroot`, ...r2.slice(1).map(simplify_integers_in_roots$2)];
    else n3 = 2;
    if (i2 = simplify_integers_in_roots$2(i2), Number.isInteger(i2)) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root$2(i2, n3);
      if (t6 !== 1) return [`*`, t6, apply_root$2(r3, n3)];
    } else if (Array.isArray(i2) && i2[0] === `*` && typeof i2[1] == `number`) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root$2(i2[1], n3);
      if (t6 !== 1) return [`*`, t6, apply_root$2([`*`, r3, ...i2.slice(2)], n3)];
    }
    return apply_root$2(i2, n3);
  }
  return [n2, ...r2.map(simplify_integers_in_roots$2)];
}
function perform_vector_matrix_additions_scalar_multiplications$2(t4, n2 = true) {
  var r2 = get_tree$2(t4);
  r2 = perform_matrix_scalar_multiplications$2(r2), r2 = perform_vector_scalar_multiplications$2(r2, n2);
  let i2 = [`+`, `a`, `b`];
  return r2 = transform$2(r2, function(t5) {
    let r3 = match$1$2(t5, i2, { allow_permutations: true });
    if (r3) {
      let i3 = [`vector`, `altvector`];
      n2 && i3.push(`tuple`);
      let a2 = {}, o2 = {}, s2 = [];
      if (i3.includes(r3.a[0])) {
        let t6 = r3.a.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.a);
      } else if (r3.a[0] === `matrix`) {
        let t6 = r3.a[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.a);
      } else s2.push(r3.a);
      if (i3.includes(r3.b[0])) {
        let t6 = r3.b.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.b);
      } else if (r3.b[0] === `matrix`) {
        let t6 = r3.b[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.b);
      } else if (r3.b[0] === `+`) for (let t6 of r3.b.slice(1)) if (i3.includes(t6[0])) {
        let n3 = t6.length - 1;
        a2[n3] || (a2[n3] = []), a2[n3].push(t6);
      } else if (t6[0] === `matrix`) {
        let n3 = t6[1].slice(1).toString();
        o2[n3] || (o2[n3] = []), o2[n3].push(t6);
      } else s2.push(t6);
      else s2.push(r3.b);
      if (Object.values(a2).every((t6) => t6.length < 2) && Object.values(o2).every((t6) => t6.length < 2)) return t5;
      let c2 = s2;
      for (let t6 in a2) if (a2[t6].length < 2) c2.push(...a2[t6]);
      else {
        let n3 = a2[t6].some((t7) => t7[0] === `vector`), r4 = a2[t6].some((t7) => t7[0] === `tuple`), i4 = a2[t6].some((t7) => t7[0] === `altvector`), o3;
        o3 = n3 || r4 && i4 ? [`vector`] : i4 ? [`altvector`] : [`tuple`];
        for (let n4 = 0; n4 < t6; n4++) o3.push([`+`, ...a2[t6].map((t7) => t7[n4 + 1])]);
        c2.push(o3);
      }
      for (let t6 in o2) if (o2[t6].length < 2) c2.push(...o2[t6]);
      else {
        let [n3, r4] = t6.split(`,`).map(Number), i4 = [`tuple`];
        for (let a4 = 0; a4 < n3; a4++) {
          let n4 = [`tuple`];
          for (let i5 = 0; i5 < r4; i5++) n4.push([`+`, ...o2[t6].map((t7) => t7[2][a4 + 1][i5 + 1])]);
          i4.push(n4);
        }
        let a3 = [`matrix`, [`tuple`, n3, r4], i4];
        c2.push(a3);
      }
      return c2.length === 1 ? c2[0] : [`+`, ...c2];
    } else return t5;
  }), r2;
}
function contains_decimal_number$2(t4) {
  return typeof t4 == `string` ? false : typeof t4 == `number` ? !!(Number.isFinite(t4) && !Number.isInteger(t4)) : Array.isArray(t4) ? t4.slice(1).some((t5) => contains_decimal_number$2(t5)) : false;
}
function contains_only_numbers$2(t4, { include_number_symbols: n2 = false, evaluate_functions: r2 = false } = {}) {
  return typeof t4 == `string` ? !!(n2 && (t4 === `e` && mathjs_default$2.define_e || t4 === `pi` && mathjs_default$2.define_pi) || t4 === `i` && mathjs_default$2.define_i) : typeof t4 == `number` ? true : Array.isArray(t4) ? r2 && t4[0] === `apply` ? t4.slice(2).every((t5) => contains_only_numbers$2(t5, { include_number_symbols: n2 })) : t4.slice(1).every((t5) => contains_only_numbers$2(t5, { include_number_symbols: n2 })) : false;
}
function try_evaluate_sum_of_numbers$2(t4, n2, r2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) return n2;
    if (typeof n2 == `number`) return t4 + n2;
    if (Array.isArray(n2) && n2[0] === `+` && typeof n2[1] == `number`) return [`+`, t4 + n2[1], n2[2]];
    if (!r2 && Array.isArray(n2) && n2[0] === `+` && typeof n2[2] == `number`) return [`+`, t4 + n2[2], n2[1]];
  }
  return typeof n2 == `number` && n2 === 0 ? t4 : null;
}
function try_evaluate_negate_number$2(t4) {
  if (typeof t4 == `number`) return -t4;
  if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return [`*`, -t4[1]].concat(t4.slice(2));
  if (Array.isArray(t4) && t4[0] === `/`) {
    if (typeof t4[1] == `number`) return [`/`, -t4[1], t4[2]];
    if (Array.isArray(t4[1]) && t4[1][0] === `*` && typeof t4[1][1] == `number`) return [`/`, [`*`, -t4[1][1]].concat(t4[1].slice(2)), t4[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers$2(t4, n2) {
  if (typeof t4 == `number`) {
    if (isNaN(t4)) return NaN;
    if (typeof n2 == `number`) return t4 * n2;
    if (!isFinite(t4)) return t4 === 1 / 0 && is_negative_ast$2(n2) || t4 === -1 / 0 && is_positive_ast$2(n2) ? -1 / 0 : is_nonzero_ast$2(n2) === false ? NaN : 1 / 0;
    if (t4 === 0) return 0;
    if (t4 === 1) return n2;
    if (t4 === -1) return [`-`, n2];
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) return t4 *= n2[1], n2 = n2[2], t4 === 1 ? n2 : t4 === -1 ? [`-`, n2] : [`*`, t4, n2];
  }
  if (typeof n2 == `number`) {
    if (isNaN(n2)) return NaN;
    if (!isFinite(n2)) return n2 === 1 / 0 && is_negative_ast$2(t4) || n2 === -1 / 0 && is_positive_ast$2(t4) ? -1 / 0 : is_nonzero_ast$2(t4) === false ? NaN : 1 / 0;
    if (n2 === 0) return 0;
    if (n2 === 1) return t4;
    if (n2 === -1) return [`-`, t4];
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return n2 *= t4[1], t4 = t4[2], n2 === 1 ? t4 : n2 === -1 ? [`-`, t4] : [`*`, t4, n2];
  }
  if (mathjs_default$2.define_i && t4 === `i`) {
    if (n2 === `i`) return -1;
    if (Array.isArray(n2) && n2[0] === `*` && n2[1] === `i`) return [`-`, n2[2]];
  } else if (mathjs_default$2.define_i && n2 === `i` && Array.isArray(t4) && t4[0] === `*` && t4[1] === `i`) return [`-`, t4[2]];
  return null;
}
function try_evaluate_quotient_of_numbers$2(t4, n2, r2, i2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) {
      let t5 = is_nonzero_ast$2(n2, r2);
      if (t5) return 0;
      if (t5 === false) return NaN;
    }
    if (typeof n2 == `number`) {
      let r3 = t4 / n2;
      if (i2 === 1 / 0 || mathjs_default$2.round(r3, i2) === r3) return r3;
      if (n2 < 0) return [`/`, -t4, -n2];
    }
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) {
      let r3 = t4 / n2[1];
      if (i2 === 1 / 0 || mathjs_default$2.round(r3, i2) === r3) return [`/`, r3, n2[2]];
    }
  } else if (typeof n2 == `number`) {
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) {
      let r4 = t4[1] / n2;
      if (i2 === 1 / 0 || mathjs_default$2.round(r4, i2) === r4) return r4 === 1 ? t4[2] : [`*`, r4, t4[2]];
      if (n2 < 0) return [`/`, [`*`, -t4[1], t4[2]], -n2];
    }
    let r3 = 1 / n2;
    if (i2 === 1 / 0 || mathjs_default$2.round(r3, i2) === r3) return [`*`, r3, t4];
    if (n2 < 0) return Array.isArray(t4) && t4[0] === `-` ? [`/`, t4[1], -n2] : [`-`, [`/`, t4, -n2]];
  }
  return null;
}
function set_small_zero$2(t4, n2 = 1e-14) {
  var r2 = get_tree$2(t4);
  return typeof r2 == `number` ? mathjs_default$2.abs(r2) < n2 ? 0 : r2 : Array.isArray(r2) ? [r2[0], ...r2.slice(1).map((t5) => set_small_zero$2(t5, n2))] : r2;
}
function evaluate_numbers_sub$2(t4, n2, r2, i2, a2, o2) {
  if (t4 === void 0) return t4;
  if (typeof t4 == `number`) return o2 > 0 && mathjs_default$2.abs(t4) < o2 ? 0 : t4;
  if (contains_only_numbers$2(t4, { include_number_symbols: true, evaluate_functions: a2 })) {
    let n3 = function(n4) {
      if (o2 > 0 && mathjs_default$2.abs(n4) < o2) return 0;
      if (r2 === 1 / 0 || Number.isInteger(n4)) return n4;
      let i3 = evalf$2(n4, 14), s3 = evalf$2(n4, r2);
      if (r2 === 0 && (s3 = mathjs_default$2.round(n4)), s3 === i3 || contains_decimal_number$2(t4) && contains_only_numbers$2(t4, { include_number_symbols: true, evaluate_functions: a2 })) return n4;
      let c3 = mathjs_default$2.fraction(n4), l3 = { n: mathjs_default$2.number(c3.n), d: mathjs_default$2.number(c3.d), s: mathjs_default$2.number(c3.s) }, u2 = evalf$2(l3.d, 3);
      return (l3.n < 1e4 || u2 === l3.d) && evalf$2(l3.s * l3.n / l3.d, 14) === i3 ? l3.d === 1 ? l3.s * l3.n : [`/`, l3.s * l3.n, l3.d] : null;
    };
    var s2 = evaluate_to_constant$2(t4, { remove_units_first: false });
    if (!Number.isNaN(s2)) {
      if (typeof s2 == `number`) {
        if (Number.isFinite(s2)) {
          let t5 = n3(s2);
          if (t5 !== null) return t5;
        }
      } else if (s2 && Number.isFinite(s2.re) && Number.isFinite(s2.im)) {
        let t5 = n3(s2.re), r3 = n3(s2.im);
        if (t5 !== null && r3 !== null) {
          if (r3 === 0) return t5;
          {
            let n4;
            return n4 = r3 === 1 ? `i` : r3 === -1 ? [`-`, `i`] : [`*`, r3, `i`], t5 === 0 ? n4 : [`+`, t5, n4];
          }
        }
      }
    }
  }
  if (!Array.isArray(t4)) return t4;
  var c2 = t4[0], l2 = t4.slice(1).map((t5) => evaluate_numbers_sub$2(t5, n2, r2, i2, a2, o2));
  if (c2 === `+`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_sum_of_numbers$2(t5, n3, i2);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree$2(t5), a3 = get_unit_of_tree$2(n3);
      if (r4 && r4 === a3) {
        let a4 = try_evaluate_sum_of_numbers$2(remove_units$2(t5, false), remove_units$2(n3, false), i2);
        if (a4 !== null) return add_unit$2(a4, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `-`) {
    let t5 = try_evaluate_negate_number$2(l2[0]);
    if (t5 !== null) return t5;
    if (l2[0][0] === `unit`) {
      let t6 = get_unit_of_tree$2(l2[0]);
      if (t6) {
        let n3 = try_evaluate_negate_number$2(remove_units$2(l2[0], false));
        if (n3 !== null) return add_unit$2(n3, t6);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `*`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_product_of_numbers$2(t5, n3);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] !== `unit`) {
      let r4 = get_unit_of_tree$2(t5);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers$2(remove_units$2(t5, false), n3);
        if (i3 !== null) return add_unit$2(i3, r4);
      }
    }
    if (t5[0] !== `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree$2(n3);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers$2(t5, remove_units$2(n3, false));
        if (i3 !== null) return add_unit$2(i3, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `/`) {
    let t5 = l2[0], i3 = l2[1], a3 = try_evaluate_quotient_of_numbers$2(t5, i3, n2, r2);
    if (a3 !== null) return a3;
    if (t5[0] === `unit` && i3[0] !== `unit`) {
      let a4 = get_unit_of_tree$2(t5);
      if (a4) {
        let o3 = try_evaluate_quotient_of_numbers$2(remove_units$2(t5, false), i3, n2, r2);
        if (o3 !== null) return add_unit$2(o3, a4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `^`) {
    let t5 = l2[0], i3 = l2[1];
    if (typeof i3 == `number`) {
      if (i3 === 0) {
        if (!mathjs_default$2.pow_strict) return 1;
        let r3 = is_nonzero_ast$2(t5, n2);
        if (r3 && t5 !== 1 / 0 && t5 !== -1 / 0) return 1;
        if (r3 === false) return NaN;
      } else if (i3 === 1) return t5;
      else if (typeof t5 == `number`) {
        let n3 = mathjs_default$2.pow(t5, i3);
        if (r2 === 1 / 0 || mathjs_default$2.round(n3, r2) === n3) return n3;
      }
    } else if (t5 === 1) return 1;
    return [c2].concat(l2);
  }
  return [c2].concat(l2);
}
function evaluate_numbers$2(t4, { assumptions: n2, max_digits: r2, skip_ordering: i2 = false, evaluate_functions: a2 = false, set_small_zero: o2 = 0 } = {}) {
  (r2 === void 0 || !(Number.isInteger(r2) || r2 === 1 / 0)) && (r2 = 0), o2 === true && (o2 = 1e-14);
  var s2 = get_tree$2(t4);
  if (contains_blank$2(s2)) return s2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()]));
  var c2;
  return i2 ? (s2 = unflattenRight$2(flatten$5$2(s2)), c2 = evaluate_numbers_sub$2(s2, n2, r2, i2, a2, o2)) : (s2 = move_units_outside_products$2(s2), s2 = unflattenRight$2(default_order$2(flatten$5$2(s2))), c2 = default_order$2(evaluate_numbers_sub$2(s2, n2, r2, i2, a2, o2)), c2 = default_order$2(evaluate_numbers_sub$2(unflattenRight$2(c2), n2, r2, i2, a2, o2))), c2 = set_negative_zeros_to_zero$2(c2), flatten$5$2(c2);
}
function set_negative_zeros_to_zero$2(t4) {
  return t4 === 0 ? 0 : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map(set_negative_zeros_to_zero$2)] : t4;
}
function collect_like_terms_factors$2(t4, n2, r2) {
  function i2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  function a2(t5) {
    return !!(typeof t5 == `number` && t5 < 0 || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number` && t5 > 0);
  }
  function o2(t5) {
    if (typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`) return true;
    var n3 = evaluate_to_constant$2(t5, { remove_units_first: false });
    return !!Number.isFinite(n3);
  }
  let s2 = (t5) => !contains_pm$2(t5);
  var c2 = get_tree$2(t4);
  if (contains_blank$2(c2)) return c2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), c2 = evaluate_numbers$2(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true });
  var l2 = [];
  l2.push([[`/`, `x`, [`^`, `y`, `a`]], [`*`, `x`, [`^`, `y`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2 }]), l2.push([[`/`, `x`, [`apply`, `exp`, `a`]], [`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2, variables: { x: true, a: true } }]), l2.push([[`/`, `x`, `y`], [`*`, `x`, [`^`, `y`, [`-`, 1]]], { evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations$2(c2, l2, 40), l2 = [];
  for (let t5 in all_units$3) all_units$3[t5].prefix ? (l2.push([[`+`, [`unit`, t5, `x`], [`unit`, t5, `y`]], [`unit`, t5, [`+`, `x`, `y`]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, t5, `x`], [`-`, [`unit`, t5, `y`]]], [`unit`, t5, [`+`, `x`, [`-`, `y`]]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }])) : (l2.push([[`+`, [`unit`, `x`, t5], [`unit`, `y`, t5]], [`unit`, [`+`, `x`, `y`], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, `x`, t5], [`-`, [`unit`, `y`, t5]]], [`unit`, [`+`, `x`, [`-`, `y`]], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]));
  return l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: (t5) => is_nonzero_ast$2(t5, n2) && s2(t5), n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_positive_ast$2(t5, n2), m: (t5) => i2(t5) && is_positive_ast$2(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`-`, [`^`, `x`, `n`]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_negative_ast$2(t5, n2), m: (t5) => i2(t5) && is_negative_ast$2(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`apply`, `exp`, `n`], [`apply`, `exp`, `m`]], [`apply`, `exp`, [`+`, `n`, `m`]], { variables: { n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`*`, `m`, `x`]], [`*`, [`+`, `n`, `m`], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, `n1`, [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, `n1`, [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`-`, [`*`, `m`, `x`]]], [`*`, [`+`, `n`, [`-`, `m`]], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`-`, [`pm`, `x`]], [`pm`, `x`], { variables: { x: true } }]), l2.push([[`*`, `c`, [`pm`, `x`]], [`pm`, [`*`, `c`, `x`]], { variables: { c: (t5) => !contains_pm$2(t5), x: true }, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`*`, `x`, `y`], `a`], [`*`, [`^`, `x`, `a`], [`^`, `y`, `a`]], { allow_permutations: true }]), l2.push([[`^`, [`^`, `x`, `n`], `m`], [`^`, `x`, [`*`, `n`, `m`]], { variables: { x: true, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_permutations: true }]), l2.push([[`-`, [`+`, `a`, `b`]], [`+`, [`-`, `a`], [`-`, `b`]]]), l2.push([[`apply`, `cbrt`, [`*`, `a`, `x`]], [`-`, [`apply`, `cbrt`, [`-`, [`*`, `a`, `x`]]]], { variables: { a: (t5) => is_negative_ast$2(t5, n2), x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `cbrt`, [`-`, `x`]], [`-`, [`apply`, `cbrt`, `x`]], { variables: { x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`*`, `a`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, [`-`, [`*`, `a`, `x`]], `n`]]], { variables: { a: (t5) => is_negative_ast$2(t5, n2), x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`-`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, `x`, `n`]]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`^`, [`apply`, `abs`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`*`, `x`, `y`], [`*`, `x`, `y`], { variables: { x: o2, y: o2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations$2(c2, l2, 40), c2 = simplify_powers_in_roots$2(c2, n2), l2 = [], l2.push([[`*`, `x`, [`^`, `y`, [`-`, `a`]]], [`/`, `x`, [`^`, `y`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], [`/`, `x`, [`apply`, `exp`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1, variables: { x: true, a: true } }]), l2.push([[`*`, `x`, [`^`, `y`, `n`]], [`/`, `x`, [`^`, `y`, [`-`, `n`]]], { variables: { x: true, y: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, `n`]], [`/`, `x`, [`apply`, `exp`, [`-`, `n`]]], { variables: { x: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations$2(c2, l2, 40), l2 = [], l2.push([[`^`, `y`, `n`], [`/`, 1, [`^`, `y`, [`-`, `n`]]], { variables: { y: true, n: a2 }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`apply`, `exp`, `n`], [`/`, 1, [`apply`, `exp`, [`-`, `n`]]], { variables: { n: a2 }, evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations$2(c2, l2, 40), l2 = [], l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations$2(c2, l2, 40), l2 = [], l2.push([[`*`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `y`], `z`], { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations$2(c2, l2, 40), c2 = evaluate_numbers$2(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), c2;
}
function simplify_ratios$2(t4, n2) {
  function r2(t5) {
    var n3 = 1;
    return t5 = t5.map(function(t6) {
      if (typeof t6 == `number`) return t6 < 0 ? (n3 *= -1, -t6) : t6;
      if (!Array.isArray(t6)) return t6;
      if (t6[0] === `-`) return n3 *= -1, t6[1];
      if (t6[0] !== `+`) return t6;
      var r3 = false;
      if ((typeof t6[1] == `number` && t6[1] < 0 || Array.isArray(t6[1]) && t6[1][0] === `-` || Array.isArray(t6[1]) && t6[1][0] === `*` && Number(t6[1][1]) < 0) && (r3 = true), r3) {
        n3 *= -1;
        var i3 = t6.slice(1).map((t7) => [`-`, t7]);
        return evaluate_numbers$2([`+`].concat(i3));
      } else return t6;
    }), { factors: t5, sign_change: n3 };
  }
  function i2(t5, n3) {
    if (!Array.isArray(t5)) return n3 ? [`-`, t5] : t5;
    var a3 = t5[0];
    if (a3 === `-`) return i2(t5[1], n3 = true);
    var o2 = t5.slice(1).map((t6) => i2(t6));
    if (a3 !== `/`) return n3 ? [`-`, [a3, ...o2]] : [a3, ...o2];
    var s2 = o2[0], c2 = o2[1];
    s2 = default_order$2(s2, { ignore_negatives: true });
    var l2 = Array.isArray(s2) && s2[0] === `*` ? s2.slice(1) : [s2], u2 = r2(l2);
    l2 = u2.factors, n3 && (u2.sign_change *= -1), c2 = default_order$2(c2, { ignore_negatives: true });
    var d2 = Array.isArray(c2) && c2[0] === `*` ? c2.slice(1) : [c2], p2 = r2(d2);
    return d2 = p2.factors, u2.sign_change * p2.sign_change < 0 && (l2[0] = [`-`, l2[0]]), s2 = l2.length === 1 ? l2[0] : [`*`].concat(l2), c2 = d2.length === 1 ? d2[0] : [`*`].concat(d2), [`/`, s2, c2];
  }
  var a2 = get_tree$2(t4);
  return contains_blank$2(a2) ? a2 : (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2(a2));
}
function contains_blank$2(t4) {
  return t4 === `＿` ? true : Array.isArray(t4) ? t4.some(contains_blank$2) : false;
}
var all_units$3 = get_all_units$2();
function remove_units$2(t4, n2 = true) {
  var r2 = get_tree$2(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  if (i2 === `unit`) {
    let t5 = all_units$3[get_unit_of_tree$2(r2)];
    if (!t5) return r2;
    let i3 = remove_units$2(t5.prefix ? a2[1] : a2[0], n2);
    return n2 ? t5.scale(i3) : i3;
  } else return [i2, ...a2.map((t5) => remove_units$2(t5, n2))];
}
function remove_scaling_units$2(t4) {
  var n2 = get_tree$2(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `unit`) {
    let t5 = all_units$3[get_unit_of_tree$2(n2)];
    if (!(t5 && t5.only_scales)) return n2;
    let r3 = remove_scaling_units$2(t5.prefix ? i2[1] : i2[0]);
    return t5.scale(r3);
  } else return [r2, ...i2.map((t5) => remove_scaling_units$2(t5))];
}
function add_unit$2(t4, n2) {
  var r2 = get_tree$2(t4);
  let i2 = all_units$3[n2];
  return i2 ? i2.prefix ? [`unit`, n2, r2] : [`unit`, r2, n2] : r2;
}
function move_units_outside_products$2(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = [], n3 = [];
    for (let i3 of r2) {
      let r3 = get_unit_value_of_tree$2(i3);
      r3 ? (t5.push(r3[0]), n3.push(r3[1])) : n3.push(i3);
    }
    let i2 = [`*`, ...n3];
    for (let n4 of t5) i2 = add_unit$2(i2, n4);
    return i2;
  } else return [n2, ...r2.map(move_units_outside_products$2)];
}
var solve_exports$2 = __exportAll$2({ solve_linear: () => solve_linear$2 });
function solve_linear$2(t4, n2, r2) {
  if (typeof n2 == `string`) {
    r2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (r2 = t4.context.get_assumptions([t4.variables()]));
    var i2 = simplify$2(get_tree$2(t4), r2);
    if (Array.isArray(i2)) {
      var a2 = i2[0], o2 = i2.slice(1);
      if (a2 === `=` || a2 === `ne` || a2 === `<` || a2 === `le` || a2 === `>` || a2 === `ge`) {
        var s2 = simplify$2([`+`, o2[0], [`-`, o2[1]]], r2), c2 = (t5) => !variables$2(t5).includes(n2);
        if (s2 = simplify$2(applyAllTransformations$2(s2, [[[`+`, [`*`, `_a`, n2], [`*`, `_b`, n2]], [`*`, [`+`, `_a`, `_b`], n2], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_extended_match: true, allow_implicit_identities: [`_a`, `_b`], evaluate_numbers: true }]], 20)), variables$2(s2).includes(n2)) {
          var l2 = match$1$2(s2, [`+`, [`*`, `_a`, n2], `_b`], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_implicit_identities: [`_a`, `_b`] });
          if (l2) {
            var u2 = simplify$2(l2._a), d2 = simplify$2(l2._b);
            if (is_nonzero_ast$2(u2, r2)) {
              if (a2 === `=` || a2 === `ne` || is_positive_ast$2(u2, r2)) {
                let t5 = simplify$2([`/`, [`-`, d2], u2]);
                return [a2, n2, t5];
              }
              if (is_negative_ast$2(u2, r2)) {
                var p2 = simplify$2([`/`, [`-`, d2], u2]);
                return a2 = a2 === `<` ? `>` : a2 === `le` ? `ge` : a2 === `>` ? `<` : `le`, [a2, n2, p2];
              }
            }
          }
        }
      }
    }
  }
}
function clean_assumptions$2(t4, n2) {
  if (!Array.isArray(t4) || t4.length === 0) return t4;
  t4 = flatten$5$2(default_order$2(simplify_logical$2(expand_relations$2(t4))));
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `and` || r2 === `or`) {
    if (i2 = i2.reduce(function(t5, n3) {
      return t5.every(function(t6) {
        return !equal$2(t6, n3);
      }) && t5.push(n3), t5;
    }, []), r2 === `and` && n2 && Array.isArray(n2)) {
      let t5;
      t5 = n2[0] === `and` ? n2.slice(1) : [n2], i2 = i2.filter((n3) => t5.every((t6) => !equal$2(t6, n3)));
    }
    t4 = i2.length === 1 ? i2[0] : [r2].concat(i2);
  }
  if (r2 !== `and` && n2 && Array.isArray(n2)) {
    let r3;
    if (r3 = n2[0] === `and` ? n2.slice(1) : [n2], !r3.every((n3) => !equal$2(n3, t4))) return;
  }
  return t4;
}
function calculate_derived_assumptions$2(t4, n2) {
  if (n2 === void 0) {
    n2 = [];
    for (let r3 in t4.byvar) {
      let i3 = t4.byvar[r3];
      i3.length > 0 && n2.push(i3);
    }
    if (n2.length === 0) return {};
    n2 = n2.length === 1 ? n2[0] : [`and`].concat(n2), n2 = clean_assumptions$2(n2);
  }
  if (!Array.isArray(n2) || n2.length === 0) return {};
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `and` || r2 === `or`) {
    let n3 = i2.map(function(n4) {
      return calculate_derived_assumptions$2(t4, n4);
    }), a3 = [...new Set(n3.reduce((t5, n4) => [...t5, ...Object.keys(n4)], []))], o3 = {};
    for (let i3 of a3) {
      let a4 = n3.reduce(function(t5, n4) {
        return n4[i3] !== void 0 && t5.push(n4[i3]), t5;
      }, []);
      if (r2 === `and` || a4.length === n3.length) {
        let n4 = o3[i3];
        n4 = n4 === void 0 ? a4.length > 1 ? [r2].concat(a4) : a4[0] : a4.length > 1 ? [`and`, n4, [r2].concat(a4)] : [`and`, n4, a4[0]], o3[i3] = clean_assumptions$2(n4, get_assumptions$2(t4, i3, { omit_derived: true }));
      }
    }
    return o3;
  }
  let a2 = {};
  if (r2 === `=` || r2 === `ne` || r2 === `<` || r2 === `le` || r2 === `in` || r2 === `subset` || r2 === `notin` || r2 === `notsubset`) {
    var o2 = false;
    for (let n3 = 0; n3 < 2; n3++) {
      let c3 = i2[n3], l2 = i2[1 - n3], u2 = variables$2(l2);
      if (typeof c3 != `string` || u2.length === 0 || u2.includes(c3)) continue;
      o2 = true;
      var s2 = r2;
      n3 === 1 && (r2 === `<` ? s2 = `>` : r2 === `le` ? s2 = `ge` : r2 === `in` ? s2 = `ni` : r2 === `subset` ? s2 = `superset` : r2 === `notin` ? s2 = `notni` : r2 === `notsubset` && (s2 = `notsuperset`));
      let d2 = get_assumptions_for_expr$2(t4, l2, [c3]);
      if (d2 = combine_assumptions$2(c3, s2, l2, d2), d2 !== void 0) {
        let n4 = a2[c3];
        n4 = n4 === void 0 ? d2 : [`and`, n4, d2], a2[c3] = clean_assumptions$2(n4, get_assumptions$2(t4, c3, { omit_derived: true }));
      }
    }
    if (o2) return a2;
  }
  let c2 = [];
  for (let n3 of i2) {
    let r3 = get_assumptions_for_expr$2(t4, n3, []);
    r3 !== void 0 && c2.push(r3);
  }
  if (c2.length === 0) return {};
  c2 = c2.length === 1 ? c2[0] : [`and`].concat(c2);
  for (let r3 of variables$2(n2)) a2[r3] = clean_assumptions$2(c2, get_assumptions$2(t4, r3, { omit_derived: true }));
  return a2;
}
function get_assumptions_for_expr$2(t4, n2, r2) {
  let i2 = variables$2(n2);
  if (i2 = i2.filter((t5) => !r2.includes(t5)), i2.length === 0) return;
  function a2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  var o2 = [`_b`], s2 = [`_b`], c2 = { _b: a2 }, l2 = {};
  for (let t5 = 0; t5 < i2.length; t5++) {
    let n3 = `_a` + t5;
    l2[i2[t5]] = n3, o2.push([`*`, n3, i2[t5]]), s2.push(n3), c2[n3] = a2;
  }
  o2 = [`+`].concat(o2);
  var u2 = match$1$2(n2, o2, { variables: c2, allow_permutations: true, allow_extended_match: false, allow_implicit_identities: s2, max_group: 1 });
  if (!u2) {
    let i3 = [];
    for (let a3 of variables$2(n2)) {
      let n3 = get_assumptions_for_expr$2(t4, a3, r2);
      n3 !== void 0 && i3.push(n3);
    }
    return i3.length === 0 ? void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
  }
  for (let t5 of i2) l2[t5] = u2[l2[t5]];
  let d2 = false;
  u2._b === 0 && u2._a0 === 1 && i2.length === 1 && (d2 = true);
  var p2 = get_assumptions$2(t4, [i2], { exclude_variables: r2 });
  if (p2 === void 0) return;
  return clean_assumptions$2(m2(p2));
  function m2(a3) {
    if (!Array.isArray(a3)) return;
    var o3 = a3[0], s3 = a3.slice(1);
    if (o3 === `and` || o3 === `or`) {
      let t5 = s3.map(m2).filter((t6) => t6 !== void 0);
      return t5.length === 0 ? void 0 : o3 === `or` ? t5.length === s3.length ? [`or`].concat(t5) : void 0 : t5.length === 1 ? t5[0] : [`and`].concat(t5);
    }
    if (!([`=`, `ne`, `<`, `le`].includes(o3) || [`in`, `notin`, `subset`, `notsubset`].includes(o3) && d2)) {
      let i3 = r2.concat(variables$2(n2)), o4 = [];
      for (let n3 of variables$2(a3)) {
        if (i3.includes(n3)) continue;
        let r3 = get_assumptions_for_expr$2(t4, n3, i3);
        r3 !== void 0 && o4.push(r3);
      }
      return o4.length === 0 ? a3 : o4.length === 1 ? [`and`, a3, o4[0]] : [`and`, a3].concat(o4);
    }
    let c3 = [];
    for (let a4 = 0; a4 <= 1; a4++) {
      let d3 = s3[a4], m3 = s3[1 - a4];
      if (typeof d3 == `string` && i2.includes(d3)) {
        var u3 = {};
        u3[d3] = m3;
        var p3 = simplify$2(substitute$1$2(n2, u3)), h2 = false, g2 = o3;
        (a4 === 1 && l2[d3] > 0 || a4 === 0 && l2[d3] < 0) && (o3 === `<` ? (h2 = true, g2 = `>`) : o3 === `le` ? (h2 = true, g2 = `ge`) : o3 === `in` ? (h2 = true, g2 = `ni`) : o3 === `subset` ? (h2 = true, g2 = `superset`) : o3 === `notin` ? (h2 = true, g2 = `notni`) : o3 === `notsubset` && (h2 = true, g2 = `notsuperset`)), h2 ? c3.push([o3, p3, n2]) : c3.push([o3, n2, p3]);
        let i3 = get_assumptions_for_expr$2(t4, p3, r2.concat([d3]));
        i3 = combine_assumptions$2(n2, g2, p3, i3), i3 !== void 0 && c3.push(i3);
      }
    }
    if (c3.length === 1) return c3[0];
    if (c3.length > 1) return [`and`].concat(c3);
    let v2 = r2.concat(variables$2(n2));
    c3 = [];
    for (let n3 of variables$2(a3)) {
      if (v2.includes(n3)) continue;
      let r3 = get_assumptions_for_expr$2(t4, n3, v2);
      r3 !== void 0 && c3.push(r3);
    }
    return c3.length === 0 ? a3 : c3.length === 1 ? [`and`, a3, c3[0]] : [`and`, a3].concat(c3);
  }
}
function combine_assumptions$2(t4, n2, r2, i2) {
  if (![`=`, `ne`, `<`, `le`, `>`, `ge`, `in`, `notin`, `ni`, `notni`, `subset`, `notsubset`, `superset`, `notsuperset`].includes(n2)) return i2;
  if (Array.isArray(i2)) {
    var a2 = i2[0], o2 = i2.slice(1);
    if (a2 === `and` || a2 === `or`) {
      let i3 = o2.map((i4) => combine_assumptions$2(t4, n2, r2, i4)).filter((t5) => t5 !== void 0);
      return i3.length === 0 ? void 0 : a2 === `or` ? i3.length === o2.length ? [[`or`].concat(i3)] : void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
    }
    if (![`=`, `ne`, `<`, `le`, `in`, `notin`, `subset`, `notsubset`].includes(a2)) return i2;
    var s2 = a2, c2;
    if (equal$2(o2[0], r2)) c2 = o2[1];
    else if (equal$2(o2[1], r2)) c2 = o2[0], a2 === `<` ? s2 = `>` : a2 === `le` ? s2 = `ge` : a2 === `in` ? s2 = `ni` : a2 === `notin` ? s2 = `notni` : a2 === `subset` ? s2 = `superset` : a2 === `notsubset` && (s2 = `notsuperset`);
    else return i2;
    var l2;
    if (n2 === `=`) l2 = s2;
    else if (s2 === `=`) l2 = n2;
    else if (n2 === `<`) if (s2 === `<` || s2 === `le`) l2 = `<`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `le`) if (s2 === `<`) l2 = `<`;
    else if (s2 === `le`) l2 = `le`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `>`) if (s2 === `>` || s2 === `ge`) l2 = `>`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `ge`) if (s2 === `>`) l2 = `>`;
    else if (s2 === `ge`) l2 = `ge`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `in`) if (s2 === `subset`) l2 = `in`;
    else return;
    else if (n2 === `notin`) if (s2 === `superset`) l2 = `notin`;
    else return;
    else if (n2 === `ni`) if (s2 === `notin`) l2 = `notsubset`;
    else return;
    else if (n2 === `notni`) if (s2 === `in`) l2 = `notsuperset`;
    else return;
    else if (n2 === `subset`) if (s2 === `subset`) l2 = `subset`;
    else if (s2 === `notni`) l2 = `notni`;
    else if (s2 === `notsuperset`) l2 = `notsuperset`;
    else return;
    else if (n2 === `notsubset`) if (s2 === `superset`) l2 = `notsubset`;
    else return;
    else if (n2 === `superset`) if (s2 === `superset`) l2 = `superset`;
    else if (s2 === `ni`) l2 = `ni`;
    else if (s2 === `notsubset`) l2 = `notsubset`;
    else return;
    else if (n2 === `notsuperset`) if (s2 === `subset`) l2 = `notsuperset`;
    else return;
    else return;
    return l2 === `>` ? [`<`, c2, t4] : l2 === `ge` ? [`le`, c2, t4] : l2 === `ni` ? [`in`, c2, t4] : l2 === `notni` ? [`notin`, c2, t4] : l2 === `superset` ? [`subset`, c2, t4] : l2 === `notsuperset` ? [`notsubset`, c2, t4] : [l2, t4, c2];
  }
}
function filter_assumptions_from_tree$2(t4, n2) {
  if (!(!Array.isArray(t4) || t4.length === 0)) {
    Array.isArray(n2) || (n2 = [n2]);
    var r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `and`) {
      var a2 = i2.map(function(t5) {
        return filter_assumptions_from_tree$2(t5, n2);
      });
      return a2 = a2.filter((t5) => t5 !== void 0), a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : [`and`].concat(a2);
    }
    var o2 = variables$2(t4);
    if (!(n2.filter((t5) => o2.includes(t5)).length > 0)) return t4;
  }
}
function get_assumptions_sub$2(t4, n2, r2, i2) {
  Array.isArray(n2) || (n2 = [n2]);
  var a2 = [];
  if (n2.forEach(function(n3) {
    if (t4.byvar[n3] || t4.derived[n3]) {
      if (t4.byvar[n3] && t4.byvar[n3].length > 0) {
        var o2 = filter_assumptions_from_tree$2(t4.byvar[n3], r2);
        o2 !== void 0 && a2.push(o2);
      }
      if (t4.derived[n3] && t4.derived[n3].length > 0 && !i2) {
        var s2 = filter_assumptions_from_tree$2(t4.derived[n3], r2);
        s2 !== void 0 && a2.push(s2);
      }
    } else t4.generic.length > 0 && (n3 === `x` || !variables$2(t4.generic).includes(n3)) && a2.push(substitute$1$2(t4.generic, { x: n3 }));
  }), a2.length === 1 ? a2 = a2[0] : a2.length > 1 && (a2 = [`and`].concat(a2)), a2.length > 0) return clean_assumptions$2(a2);
}
function get_assumptions$2(t4, n2, r2) {
  r2 === void 0 && (r2 = {});
  var i2 = r2.exclude_variables;
  i2 === void 0 ? i2 = [] : Array.isArray(i2) || (i2 = [i2]);
  var a2, o2 = get_tree$2(n2);
  if (typeof o2 == `string`) a2 = [o2];
  else if (Array.isArray(o2)) Array.isArray(o2[0]) && (a2 = o2[0]);
  else return;
  return a2 ? get_assumptions_sub$2(t4, a2, i2, r2.omit_derived) : get_assumptions_for_expr$2(t4, o2, i2);
}
function add_assumption$2(t4, n2, r2) {
  var i2 = get_tree$2(n2);
  if (!Array.isArray(i2)) return 0;
  i2 = clean_assumptions$2(simplify$2(i2, t4));
  var a2 = add_assumption_sub$2(t4, i2, r2);
  return a2 && (t4.derived = calculate_derived_assumptions$2(t4)), a2;
}
function add_assumption_sub$2(t4, n2, r2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_assumption_sub$2(t4, n3, r2)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var i2 = variables$2(n2);
  if (i2.length === 0) return 0;
  let a2 = 0;
  !r2 && t4.generic.length > 0 && i2.forEach(function(n3) {
    t4.byvar[n3] === void 0 && (n3 === `x` || !variables$2(t4.generic).includes(n3)) && (add_assumption_sub$2(t4, substitute$1$2(t4.generic, { x: n3 }), true), a2 += 1);
  });
  for (let r3 of i2) {
    let i3 = solve_linear$2(n2, r3, t4), o2 = n2;
    i3 && (o2 = i3);
    let s2 = t4.byvar[r3];
    s2 !== void 0 && s2.length !== 0 && (o2 = [`and`, s2, o2]), o2 = clean_assumptions$2(o2), equal$2(o2, s2) || (t4.byvar[r3] = o2, a2 += 1);
  }
  return a2;
}
function add_generic_assumption$2(t4, n2) {
  var r2 = get_tree$2(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$2(simplify$2(r2, t4));
  var i2 = add_generic_assumption_sub$2(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$2(t4)), i2;
}
function add_generic_assumption_sub$2(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_generic_assumption_sub$2(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables$2(n2).includes(`x`)) return 0;
  let r2 = solve_linear$2(n2, `x`, t4), i2 = n2;
  r2 && (i2 = r2);
  let a2 = t4.generic;
  return a2.length !== 0 && (i2 = [`and`, a2, i2]), i2 = clean_assumptions$2(i2), equal$2(i2, a2) ? 0 : (t4.generic = i2, 1);
}
function remove_assumption$2(t4, n2) {
  var r2 = get_tree$2(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$2(simplify$2(r2, t4));
  var i2 = remove_assumption_sub$2(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$2(t4)), i2;
}
function remove_assumption_sub$2(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_assumption_sub$2(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var r2 = variables$2(n2);
  if (r2.length === 0) return 0;
  var i2 = 0;
  for (let a2 of r2) {
    let r3 = solve_linear$2(n2, a2, t4), o2 = t4.byvar[a2];
    if (!o2 || o2.length === 0) continue;
    let s2 = o2[0], c2 = o2.slice(1), l2 = c2.length, u2;
    if (s2 === `and`) if (c2 = c2.filter((t5) => !(equal$2(t5, n2) || equal$2(t5, r3))), c2.length === 0) u2 = [];
    else if (c2.length === 1) u2 = c2[0];
    else if (c2.length < l2) u2 = [s2].concat(c2);
    else continue;
    else if (equal$2(o2, n2) || equal$2(o2, r3)) u2 = [];
    else continue;
    i2 += 1, t4.byvar[a2] = u2;
  }
  return i2;
}
function remove_generic_assumption$2(t4, n2) {
  var r2 = get_tree$2(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$2(simplify$2(r2, t4));
  var i2 = remove_generic_assumption_sub$2(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$2(t4)), i2;
}
function remove_generic_assumption_sub$2(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_generic_assumption_sub$2(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables$2(n2).includes(`x`)) return 0;
  var r2 = t4.generic;
  if (r2.length === 0) return 0;
  let i2 = solve_linear$2(n2, `x`, t4);
  var a2 = r2[0], o2 = r2.slice(1), s2 = o2.length, c2;
  if (a2 === `and`) if (o2 = o2.filter((t5) => !(equal$2(t5, n2) || equal$2(t5, i2))), o2.length === 0) c2 = [];
  else if (o2.length === 1) c2 = o2[0];
  else if (o2.length < s2) c2 = [a2].concat(o2);
  else return 0;
  else if (equal$2(r2, n2) || equal$2(r2, i2)) c2 = [];
  else return 0;
  return t4.generic = c2, 1;
}
function initialize_assumptions$2() {
  var t4 = {};
  return t4.byvar = {}, t4.derived = {}, t4.generic = [], t4.not_commutative = [], t4.get_assumptions = function(n2, r2) {
    return get_assumptions$2(t4, n2, r2);
  }, t4.add_assumption = function(n2, r2) {
    return add_assumption$2(t4, n2, r2);
  }, t4.add_generic_assumption = function(n2) {
    return add_generic_assumption$2(t4, n2);
  }, t4.remove_assumption = function(n2) {
    return remove_assumption$2(t4, n2);
  }, t4.remove_generic_assumption = function(n2) {
    return remove_generic_assumption$2(t4, n2);
  }, t4;
}
var operators$1$2 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `\\pm ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return `\\frac{` + t4[0] + `}{` + t4[1] + `}`;
}, _: function(t4) {
  return t4[0] + `_{` + t4[1] + `}`;
}, "^": function(t4) {
  return t4[0] + `^{` + t4[1] + `}`;
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, array: function(t4) {
  return `\\left[ ` + t4.join(`, `) + ` \\right]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `\\left\\{ ` + t4.join(`, `) + ` \\right\\}`;
}, vector: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, altvector: function(t4) {
  return `\\left\\langle ` + t4.join(`, `) + ` \\right\\rangle`;
}, interval: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, matrix: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, and: function(t4) {
  return t4.join(` \\land `);
}, or: function(t4) {
  return t4.join(` \\lor `);
}, not: function(t4) {
  return `\\lnot ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` \\le `);
}, ge: function(t4) {
  return t4.join(` \\ge `);
}, ne: function(t4) {
  return t4.join(` \\ne `);
}, forall: function(t4) {
  return `\\forall ` + t4[0];
}, exists: function(t4) {
  return `\\exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` \\in ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` \\notin ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` \\ni ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` \\not\\ni ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` \\subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` \\subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` \\not\\subset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` \\not\\subseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` \\supset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` \\supseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` \\not\\supset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` \\not\\supseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` \\cup `);
}, intersect: function(t4) {
  return t4.join(` \\cap `);
}, implies: function(t4) {
  return t4.join(` \\implies `);
}, impliedby: function(t4) {
  return t4.join(` \\impliedby `);
}, iff: function(t4) {
  return t4.join(` \\iff `);
}, leftarrow: function(t4) {
  return t4.join(` \\leftarrow `);
}, rightarrow: function(t4) {
  return t4.join(` \\rightarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` \\leftrightarrow `);
}, perp: function(t4) {
  return t4.join(` \\perp `);
}, parallel: function(t4) {
  return t4.join(` \\parallel `);
}, derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, partial_derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, "|": function(t4) {
  return t4[0] + ` \\mid ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `\\binom{` + t4[0] + `}{` + t4[1] + `}`;
}, vec: function(t4) {
  return `\\vec{` + t4[0] + `}`;
}, linesegment: function(t4) {
  return `\\overline{` + t4.join(` `) + `}`;
}, angle: function(t4, n2) {
  return n2 ? `\\angle ` + t4.join(``) : `\\angle\\left( ` + t4.join(`, `) + ` \\right)`;
}, unit: function(t4) {
  return t4[1] === `\\circ` ? t4[0] + `^{\\circ}` : t4[0] + ` ` + t4[1];
} }, allowedLatexSymbolsDefault$1$2 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.cot.coth.csc.csch.sec.sech.sin.sinh.tan.tanh.arcsin.arccos.arctan.arccsc.arcsec.arccot.arg.Re.Im.det.angle.perp.circ.%.$.int.varnothing`.split(`.`), convertLatexSymbolsDefault$2 = { acos: `arccos`, acosh: `arccosh`, acot: `arccot`, acoth: `arccoth`, acsc: `arccsc`, acsch: `arccsch`, asec: `arcsec`, asech: `arcsech`, asin: `arcsin`, asinh: `arcsinh`, atan: `arctan`, atanh: `arctanh`, deg: `circ`, emptyset: `varnothing` }, matrixEnvironmentDefault$2 = `bmatrix`, astToLatex$1$2 = class astToLatex$12 {
  constructor({ allowedLatexSymbols: t4 = allowedLatexSymbolsDefault$1$2, convertLatexSymbols: n2 = convertLatexSymbolsDefault$2, matrixEnvironment: r2 = matrixEnvironmentDefault$2, padToDigits: i2 = null, padToDecimals: a2 = null, avoidScientificNotation: o2 = false, showBlanks: s2 = true } = {}) {
    this.allowedLatexSymbols = t4, this.convertLatexSymbols = n2, this.matrixEnvironment = r2, this.padToDigits = i2, this.padToDecimals = a2, this.avoidScientificNotation = o2, this.showBlanks = s2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions$2(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `\\ldots`;
    if (!(n2 in operators$1$2) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? operators$1$2[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? operators$1$2[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return operators$1$2[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return operators$1$2[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return operators$1$2[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? a2 += ` \\le ` : a2 += ` \\ge `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : operators$1$2[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? operators$1$2[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `-` || n2 === `pm` ? operators$1$2[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : n2 === `*` ? operators$1$2[n2](r2.map((function(t5, n3) {
      let i2;
      return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(t5), i2.match(/^[0-9]/) ? `\\cdot ` + i2 : t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2) : (i2 = this.factor(t5), t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2);
    }).bind(this))) : n2 === `/` || n2 === `unit` ? operators$1$2[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  simple_factor_or_function_or_parens(t4) {
    var n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` && ![`sqrt`, `cbrt`, `nthroot`].includes(t4[1]) || n2.match(/^\\left\(.*\\right\)$/) || n2.match(/^\\left\\langle.*\\right\\rangle$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  stringConvert(t4) {
    return t4.length > 1 ? (this.convertLatexSymbols[t4] && (t4 = this.convertLatexSymbols[t4]), this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : `\\operatorname{` + t4 + `}`) : this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : t4 === `＿` && !this.showBlanks ? `` : t4;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.stringConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return `\\infty`;
      if (t4 === -1 / 0) return `-\\infty`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation$2(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals$2(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (a2[0] === `+` && (a2 = a2.slice(1)), this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals$2(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals$2(i2, this.padToDigits, t5);
          }
        }
        return i2 + ` \\cdot 10^{` + a2 + `}`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) return r2[0] < 0 ? `\\left(` + r2[0].toString() + `\\right)^{` + r2[1].toString() + `}` : r2[0].toString() + `^{` + r2[1].toString() + `}`;
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      return this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `^{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `_`) {
      let t5 = this.factor(r2[0]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `_{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `\\left(` + i2 + `\\right)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `/`) return this.term(t4);
    else if (n2 === `-`) return operators$1$2[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return operators$1$2[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `\\left[ ` + i2 : `\\left( ` + i2, n3[2] ? i2 += ` \\right]` : i2 += ` \\right)`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `\\begin{` + this.matrixEnvironment + `} `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += ` & `);
        r3 < t5[1] - 1 && (i2 += ` \\\\ `);
      }
      return i2 = i2 + ` \\end{` + this.matrixEnvironment + `}`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `\\partial `);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 ? c2 = c2.trimRight() + `^{` + o2 + `}` + this.stringConvert(s2) : c2 += this.stringConvert(s2), c2 = `\\frac{ ` + c2 + ` }{ `;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.stringConvert(o3), i3 > 1 && (c2 = c2 + `^{` + i3 + `}`), c2 += ` `;
      }
      return c2 += `}`, c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `\\left|` + this.statement(r2[1]) + `\\right|`;
      if (r2[0] === `floor`) return `\\left\\lfloor ` + this.statement(r2[1]) + ` \\right\\rfloor`;
      if (r2[0] === `ceil`) return `\\left\\lceil ` + this.statement(r2[1]) + ` \\right\\rceil`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `\\left(` + t6 + `\\right)!`;
      } else if (r2[0] === `sqrt`) return `\\sqrt{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `cbrt`) return `\\sqrt[3]{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `nthroot`) return Array.isArray(r2[1]) && r2[1][0] === `tuple` && r2[1].length === 3 ? `\\sqrt[` + this.statement(r2[1][2]) + `]{` + this.statement(r2[1][1]) + `}` : `\\sqrt{` + this.statement(r2[1]) + `}`;
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3[i3.length - 1].match(/[a-zA-Z]/) && (i3 += `\\,`), i3 += t7.map((t8) => `d` + this.factor(t8[1])).join(`\\,`));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3;
      n3 = r2[0] === `log10` ? `\\log_{10}` : r2[0] === `re` ? `\\Re` : r2[0] === `im` ? `\\Im` : this.factor(r2[0]);
      let i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `\\left(` + i2 + `\\right)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return operators$1$2[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `\\left(` + this.statement(t4) + `\\right)`;
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) || t4[0] === `/` ? `\\left(` + n2 + `\\right)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    var n2 = this.term(t4);
    return n2.match(/^\\pm /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, operators$5 = { "+,add": function(t4) {
  return [`+`].concat(t4);
}, "*,multiply": function(t4) {
  return [`*`].concat(t4);
}, "/,divide": function(t4) {
  return [`/`, t4[0], t4[1]];
}, "-,unaryMinus": function(t4) {
  return [`-`, t4[0]];
}, "-,subtract": function(t4) {
  return [`+`, t4[0], [`-`, t4[1]]];
}, "^,pow": function(t4) {
  return [`^`, t4[0], t4[1]];
}, "and,and": function(t4) {
  return [`and`].concat(t4);
}, "or,or": function(t4) {
  return [`or`].concat(t4);
}, "not,not": function(t4) {
  return [`not`, t4[0]];
}, "==,equal": function(t4) {
  return [`=`].concat(t4);
}, "<,smaller": function(t4) {
  return [`<`, t4[0], t4[1]];
}, ">,larger": function(t4) {
  return [`>`, t4[0], t4[1]];
}, "<=,smallerEq": function(t4) {
  return [`le`, t4[0], t4[1]];
}, ">=,largerEq": function(t4) {
  return [`ge`, t4[0], t4[1]];
}, "!=,unequal": function(t4) {
  return [`ne`, t4[0], t4[1]];
}, "!,factorial": function(t4) {
  return [`apply`, `factorial`, t4[0]];
} }, mathjsToAst$1$2 = class mathjsToAst$12 {
  convert(t4) {
    if (t4.isConstantNode) return t4.value;
    if (t4.isSymbolNode) return t4.name;
    if (t4.isOperatorNode) {
      var n2 = [t4.op, t4.fn].join(`,`);
      if (n2 in operators$5) return operators$5[n2](t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
      throw Error(`Unsupported operator: ` + t4.op + `, ` + t4.fn);
    }
    if (t4.isFunctionNode) {
      var r2 = t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this));
      r2 = r2.length > 1 ? [`tuple`].concat(r2) : r2[0];
      var i2 = [`apply`, t4.name];
      return i2.push(r2), i2;
    }
    if (t4.isArrayNode) return [`vector`].concat(t4.args.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    if (t4.isParenthesisNode) return this.convert(t4.content);
    throw Error(`Unsupported node type: ` + t4.type);
  }
}, differentiation_exports$2 = __exportAll$2({ derivative: () => derivative$2, derivativeStory: () => derivativeStory$2, derivative_story: () => derivative_story$2, derivative_with_story: () => derivative_with_story$2 }), astToMathjs$4 = new astToMathjs$2$2({ mathjs: mathjs_default$2 }), mathjsToAst$3 = new mathjsToAst$1$2(), textToAst$2$2 = new textToAst$4$2(), astToLatex$3 = new astToLatex$1$2(), derivatives$2 = { sin: textToAst$2$2.convert(`cos x`), cos: textToAst$2$2.convert(`-(sin x)`), tan: textToAst$2$2.convert(`(sec x)^2`), cot: textToAst$2$2.convert(`-((csc x)^2)`), sec: textToAst$2$2.convert(`(sec x)*(tan x)`), csc: textToAst$2$2.convert(`-(csc x)*(cot x)`), sqrt: textToAst$2$2.convert(`1/(2*sqrt(x))`), cbrt: textToAst$2$2.convert(`1/(3*x^(2/3))`), log: textToAst$2$2.convert(`1/x`), ln: textToAst$2$2.convert(`1/x`), exp: textToAst$2$2.convert(`exp(x)`), arcsin: textToAst$2$2.convert(`1/sqrt(1 - x^2)`), arccos: textToAst$2$2.convert(`-1/sqrt(1 - x^2)`), arctan: textToAst$2$2.convert(`1/(1 + x^2)`), arccsc: textToAst$2$2.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), arcsec: textToAst$2$2.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), arccot: textToAst$2$2.convert(`-1/(1 + x^2)`), asin: textToAst$2$2.convert(`1/sqrt(1 - x^2)`), acos: textToAst$2$2.convert(`-1/sqrt(1 - x^2)`), atan: textToAst$2$2.convert(`1/(1 + x^2)`), acsc: textToAst$2$2.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), asec: textToAst$2$2.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), acot: textToAst$2$2.convert(`-1/(1 + x^2)`), abs: textToAst$2$2.convert(`abs(x)/x`) };
function derivative_with_story$2(t4, n2, r2 = []) {
  var i2 = get_tree$2(t4), a2 = `\\frac{d}{d` + n2 + `} `;
  if (typeof i2 == `number` || variables$2(i2).indexOf(n2) < 0) return r2.push(`The derivative of a constant is zero, that is, \\(` + a2 + astToLatex$3.convert(i2) + ` = 0\\).`), 0;
  if (typeof i2 == `string`) return n2 === i2 ? (r2.push(`We know the derivative of the identity function is one, that is, \\(` + a2 + astToLatex$3.convert(i2) + ` = 1\\).`), 1) : (r2.push(`As far as \\(` + astToLatex$3.convert(n2) + `\\) is concerned, \\(` + astToLatex$3.convert(i2) + `\\) is constant, so ` + a2 + astToLatex$3.convert(i2) + ` = 0\\).`), 0);
  if (!Array.isArray(i2)) return null;
  var o2 = i2[0], s2 = i2.slice(1);
  if (o2 === `apply` && s2[0] === `nthroot`) if (s2[1].length !== 3 || s2[1][0] !== `tuple`) s2[0] = `sqrt`;
  else {
    let t5 = s2[1][2];
    o2 = `^`, s2 = [s2[1][1], [`/`, 1, t5]];
  }
  if (o2 === `+` || o2 === `-` || o2 === `~`) {
    r2.push(`Using the sum rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return a2 + astToLatex$3.convert(t6);
    }).join(` + `) + `\\).`);
    let t5 = [o2].concat(s2.map(function(t6, i3) {
      return derivative_with_story$2(t6, n2, r2);
    }));
    return t5 = simplify$2(t5), r2.push(`So using the sum rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(t5) + `\\).`), t5;
  }
  if (o2 === `*`) {
    let t5 = [], o3 = [];
    for (let r3 = 0; r3 < s2.length; r3++) typeof s2[r3] == `number` || variables$2(s2[r3]).indexOf(n2) < 0 ? o3.push(s2[r3]) : t5.push(s2[r3]);
    if (o3.length > 0) {
      if (t5.length === 0) return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex$3.convert(i2) + ` = 0.\\)`), 0;
      let s3 = [`*`].concat(t5);
      if (t5.length === 1 && (s3 = t5[0]), s3 === n2) {
        r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + o3.map(function(t7, n3) {
          return astToLatex$3.convert(t7);
        }).join(` \\cdot `) + `\\).`);
        let t6 = [`*`].concat(o3);
        return t6 = simplify$2(t6), t6;
      }
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + o3.map(function(t6, n3) {
        return astToLatex$3.convert(t6);
      }).join(` \\cdot `) + ` \\cdot ` + a2 + `\\left(` + astToLatex$3.convert(s3) + `\\right)\\).`);
      let c3 = derivative_with_story$2(s3, n2, r2), l3 = [`*`].concat(o3.concat([c3]));
      return l3 = simplify$2(l3), r2.push(`And so \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(l3) + `\\).`), l3;
    }
    r2.push(`Using the product rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return s2.map(function(r3, i3) {
        return n3 === i3 ? a2 + `\\left(` + astToLatex$3.convert(t6) + `\\right)` : astToLatex$3.convert(r3);
      }).join(` \\cdot `);
    }).join(` + `) + `\\).`);
    let c2 = s2.slice(), l2 = [`+`].concat(s2.map(function(t6, i3) {
      return [`*`].concat(c2.map(function(t7, a3) {
        if (i3 === a3) {
          let i4 = derivative_with_story$2(t7, n2, r2);
          return i4 === 1 ? null : i4;
        } else return t7;
      }).filter(function(t7) {
        return t7 != null;
      }));
    }));
    return l2 = simplify$2(l2), r2.push(`So using the product rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(l2) + `\\).`), l2;
  }
  if (o2 === `/`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables$2(o3).indexOf(n2) < 0) {
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert([`/`, 1, o3]) + ` \\cdot ` + a2 + `\\left(` + astToLatex$3.convert(t5) + `\\right)\\).`);
      let s3 = derivative_with_story$2(t5, n2, r2), c3 = substitute$1$2(textToAst$2$2.convert(`(1/g)*d`), { d: s3, g: o3 });
      return c3 = simplify$2(c3), r2.push(`So \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(c3) + `\\).`), c3;
    }
    if (variables$2(t5).indexOf(n2) < 0) {
      t5 !== 1 && r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(t5) + ` \\cdot ` + a2 + `\\left(` + astToLatex$3.convert([`/`, 1, o3]) + `\\right)\\).`), r2.push(`Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(t5) + `\\cdot \\frac{-1}{ ` + astToLatex$3.convert(o3) + `^2} \\cdot ` + a2 + astToLatex$3.convert(o3) + `\\).`);
      let s3 = derivative_with_story$2(o3, n2, r2), c3 = substitute$1$2(textToAst$2$2.convert(`f * (-a/(g^2))`), { f: t5, a: s3, g: o3 });
      return c3 = simplify$2(c3), r2.push(`So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(c3) + `\\).`), c3;
    }
    r2.push(`Using the quotient rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = \\frac{` + a2 + `\\left(` + astToLatex$3.convert(t5) + `\\right) \\cdot ` + astToLatex$3.convert(o3) + ` - ` + astToLatex$3.convert(t5) + `\\cdot ` + a2 + `\\left(` + astToLatex$3.convert(o3) + `\\right)}{ \\left( ` + astToLatex$3.convert(o3) + ` \\right)^2} \\).`);
    let c2 = derivative_with_story$2(t5, n2, r2), l2 = derivative_with_story$2(o3, n2, r2), u2 = substitute$1$2(textToAst$2$2.convert(`(a * g - f * b)/(g^2)`), { a: c2, b: l2, f: t5, g: o3 });
    return u2 = simplify$2(u2), r2.push(`So using the quotient rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(u2) + `\\).`), u2;
  }
  if (o2 === `^`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables$2(o3).indexOf(n2) < 0) {
      if (typeof t5 == `string` && t5 === `x`) {
        if (typeof o3 == `number`) {
          let n4 = substitute$1$2(textToAst$2$2.convert(`n * (f^m)`), { n: o3, m: o3 - 1, f: t5 });
          return n4 = simplify$2(n4), r2.push(`By the power rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(o3) + ` \\cdot \\left(` + astToLatex$3.convert(t5) + `\\right)^{` + astToLatex$3.convert([`-`, o3, 1]) + `}\\).`), n4;
        }
        let n3 = substitute$1$2(textToAst$2$2.convert(`n * (f^(n-1))`), { n: o3, f: t5 });
        return n3 = simplify$2(n3), r2.push(`By the power rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(o3) + ` \\cdot \\left(` + astToLatex$3.convert(t5) + `\\right)^{` + astToLatex$3.convert([`-`, o3, 1]) + `}\\).`), n3;
      }
      o3 !== 1 && r2.push(`By the power rule and the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(o3) + ` \\cdot \\left(` + astToLatex$3.convert(t5) + `\\right)^{` + astToLatex$3.convert([`-`, o3, 1]) + `} \\cdot ` + a2 + astToLatex$3.convert(t5) + `\\).`);
      let s3 = derivative_with_story$2(t5, n2, r2);
      if (o3 === 1) return s3;
      if (typeof o3 == `number`) {
        let n3 = substitute$1$2(textToAst$2$2.convert(`n * (f^m) * a`), { n: o3, m: o3 - 1, f: t5, a: s3 });
        return n3 = simplify$2(n3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(n3) + `\\).`), n3;
      }
      let c3 = substitute$1$2(textToAst$2$2.convert(`n * (f^(n-1)) * a`), { n: o3, f: t5, a: s3 });
      return c3 = simplify$2(c3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(c3) + `\\).`), c3;
    }
    if (t5 === `e` && mathjs_default$2.define_e) {
      if (typeof o3 == `string` && o3 === n2) {
        let t7 = substitute$1$2(textToAst$2$2.convert(`e^(f)`), { f: o3 });
        return t7 = simplify$2(t7), r2.push(`The derivative of \\(e^` + astToLatex$3.convert(n2) + `\\) is itself, that is, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(i2) + `\\).`), t7;
      }
      r2.push(`Using the rule for \\(e^x\\) and the chain rule, we know \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(i2) + ` \\cdot ` + a2 + astToLatex$3.convert(o3) + `\\).`);
      let t6 = substitute$1$2(textToAst$2$2.convert(`e^(f)*d`), { f: o3, d: derivative_with_story$2(o3, n2, r2) });
      return t6 = simplify$2(t6), r2.push(`So using the rule for \\(e^x\\) and the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(t6) + `\\).`), t6;
    }
    if (typeof t5 == `number`) {
      if (typeof o3 == `string` && o3 === n2) {
        let s4 = substitute$1$2(textToAst$2$2.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
        return s4 = simplify$2(s4), r2.push(`The derivative of \\(a^` + astToLatex$3.convert(n2) + `\\) is \\(a^{` + astToLatex$3.convert(n2) + `} \\, \\log a\\), that is, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(s4) + `\\).`), s4;
      }
      let s3 = substitute$1$2(textToAst$2$2.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
      r2.push(`Using the rule for \\(a^x\\) and the chain rule, we know \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(s3) + ` \\cdot ` + a2 + astToLatex$3.convert(o3) + `\\).`);
      let c3 = substitute$1$2(textToAst$2$2.convert(`a^(b)*log(a)*d`), { a: t5, b: o3, d: derivative_with_story$2(o3, n2, r2) });
      return c3 = simplify$2(c3), r2.push(`So using the rule for \\(a^x\\) and the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(c3) + `\\).`), c3;
    }
    let c2 = t5, l2 = o3;
    r2.push(`Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = ` + astToLatex$3.convert(c2) + `\\) and \\(v(x) = ` + astToLatex$3.convert(l2) + `\\).`);
    let u2 = derivative_with_story$2(c2, n2, r2), d2 = derivative_with_story$2(l2, n2, r2), p2 = substitute$1$2(textToAst$2$2.convert(`(f^g)*(b * log(f) + (g * a)/f)`), { a: u2, b: d2, f: c2, g: l2 });
    return p2 = simplify$2(p2), r2.push(`So by the general rule for exponents, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(p2) + `\\).`), p2;
  }
  if (o2 === `apply` && !(s2[0] in derivatives$2)) {
    let t5 = s2[1];
    r2.push(`By the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(substitute$1$2([`apply`, s2[0] + `'`, `x`], { x: t5 })) + ` \\cdot ` + a2 + astToLatex$3.convert(t5) + `\\).`);
    let o3 = [`*`, substitute$1$2([`apply`, s2[0] + `'`, `x`], { x: t5 }), derivative_with_story$2(t5, n2, r2)];
    return o3 = simplify$2(o3), r2.push(`So by the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(o3) + `\\).`), o3;
  }
  if (o2 === `apply` && s2[0] in derivatives$2 || o2 in derivatives$2) {
    let t5 = false;
    o2 === `apply` && (o2 = s2[0], s2 = s2.slice(1), t5 = true);
    let c2 = s2[0];
    if (typeof c2 == `number`) {
      return r2.push(`The derivative of a constant is zero so \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(0) + `\\).`), 0;
    } else if (typeof c2 == `string` && c2 === n2) {
      let t6 = [`*`, substitute$1$2(derivatives$2[o2], { x: c2 })];
      return t6 = simplify$2(t6), r2.push(`It is the case that \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(t6) + `\\).`), t6;
    } else if (typeof c2 == `string` && c2 !== n2) {
      return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(0) + `\\).`), 0;
    } else {
      let s3 = [o2, `u`];
      t5 && (s3 = [`apply`].concat(s3)), r2.push(`Recall \\(\\frac{d}{du}` + astToLatex$3.convert(s3) + ` = ` + astToLatex$3.convert(derivative_with_story$2(s3, `u`, [])) + `\\).`), r2.push(`By the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(substitute$1$2(derivatives$2[o2], { x: c2 })) + ` \\cdot ` + a2 + astToLatex$3.convert(c2) + `\\).`);
      let l2 = [`*`, substitute$1$2(derivatives$2[o2], { x: c2 }), derivative_with_story$2(c2, n2, r2)];
      return l2 = simplify$2(l2), r2.push(`So by the chain rule, \\(` + a2 + astToLatex$3.convert(i2) + ` = ` + astToLatex$3.convert(l2) + `\\).`), l2;
    }
  }
  return 0;
}
function lowercaseFirstLetter$2(t4) {
  return t4.charAt(0).toLowerCase() + t4.slice(1);
}
function simplify_story$2(t4) {
  for (let n2 = t4.length - 1; n2 >= 1; n2--) t4[n2] === t4[n2 - 1] && t4.splice(n2, 1);
  for (let n2 = 0; n2 < t4.length; n2++) for (let r2 = n2 + 1; r2 < t4.length; r2++) t4[n2] === t4[r2] && (t4[r2] = `Again, ` + lowercaseFirstLetter$2(t4[r2]));
  return t4;
}
function derivative_story$2(t4, n2) {
  var r2 = [];
  return derivative_with_story$2(t4, n2, r2), r2 = simplify_story$2(r2), r2;
}
var derivativeStory$2 = derivative_story$2;
function derivative$2(t4, n2) {
  var r2 = get_tree$2(t4);
  let i2 = astToMathjs$4.convert(log_subscript_to_two_arg_log$2(normalize_function_names$2(normalize_applied_functions$2(r2)))), a2 = mathjs_default$2.derivative(i2, n2);
  return mathjsToAst$3.convert(a2);
}
function pm_equals_numerical$2({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, rng: p2 }) {
  let m2, h2, g2, v2, y2;
  try {
    ({ variables: m2, integer_variables: h2, functions: g2, expr: v2, other: y2 } = prepare_exprs_numerical_eval$2(t4, n2, i2, a2));
  } catch {
    return false;
  }
  let b2, x2;
  try {
    b2 = expand_pm_signs$2(v2.tree), x2 = expand_pm_signs$2(y2.tree);
  } catch {
    return false;
  }
  let S2, w2;
  try {
    S2 = b2.map((t5) => i2.fromAst(t5).f()), w2 = x2.map((t5) => a2.fromAst(t5).f());
  } catch {
    return false;
  }
  let E, D;
  if (l2 > 0 && b2.length > 0) try {
    let t5 = replace_numbers_with_parameters$2({ expr: v2, variables: m2, include_exponents: u2 });
    E = t5.parameters;
    let n3 = Object.keys(E);
    if (n3.length > 0) {
      let r3;
      try {
        r3 = expand_pm_signs$2(t5.expr_with_params);
      } catch {
        r3 = null;
      }
      r3 && r3.length === b2.length && (D = r3.map((t6) => {
        try {
          let r4 = i2.fromAst(t6), a3 = r4.derivative(n3[0]);
          d2 || (a3 = a3.multiply(E[n3[0]]));
          for (let t7 of n3.slice(1)) {
            let n4 = r4.derivative(t7);
            d2 || (n4 = n4.multiply(E[t7])), a3 = a3.add(n4);
          }
          return a3.multiply(l2).f();
        } catch {
          return;
        }
      }));
    }
  } catch {
  }
  let M2 = Number.MAX_VALUE * 1e-20, N2 = [10, 1, 100, 0.1, 1e3, 0.01], F = 0;
  for (let t5 = 0; t5 < 1e3; t5++) {
    let n3 = N2[Math.floor(t5 / 20) % N2.length], i3;
    try {
      i3 = r2(p2, m2, n3);
    } catch {
      continue;
    }
    for (let t6 = 0; t6 < h2.length; t6++) i3[h2[t6]] = generate_random_integer$2(-10, 10, p2);
    for (let t6 = 0; t6 < g2.length; t6++) i3[g2[t6]] = random_cubic$2(p2);
    let a3;
    if (D) {
      let t6 = Object.assign({}, i3, E);
      a3 = Array(D.length).fill(0);
      let n4 = false;
      for (let r3 = 0; r3 < D.length; r3++) {
        let i4 = D[r3];
        if (!i4) continue;
        let o3;
        try {
          o3 = mathjs_default$2.abs(i4(t6));
        } catch {
          n4 = true;
          break;
        }
        if (!Number.isFinite(o3)) {
          n4 = true;
          break;
        }
        a3[r3] = o3;
      }
      if (n4) continue;
    }
    let l3, u3;
    try {
      l3 = S2.map((t6) => t6(i3)), u3 = w2.map((t6) => t6(i3));
    } catch {
      continue;
    }
    if (!(!l3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default$2.abs(t6)) && mathjs_default$2.abs(t6) < M2) || !u3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default$2.abs(t6)) && mathjs_default$2.abs(t6) < M2))) {
      if (!value_multisets_match$2(l3, u3, o2, s2, c2, a3)) return false;
      if (F += 1, F >= 10) return true;
    }
  }
  return false;
}
function value_multisets_match$2(t4, n2, r2, i2, a2, o2) {
  let s2 = (t5) => o2 && o2[t5] !== void 0 ? o2[t5] : 0, c2 = (o3, c3) => values_close$2(t4[o3], n2[c3], r2, i2, a2, s2(o3));
  if (t4.length !== n2.length) return t4.every((t5, r3) => n2.some((t6, n3) => c2(r3, n3))) && n2.every((n3, r3) => t4.some((t5, n4) => c2(n4, r3)));
  let l2 = t4.length, u2 = Array(l2).fill(-1), d2 = (t5, n3) => {
    for (let r3 = 0; r3 < l2; r3++) if (!(n3[r3] || !c2(t5, r3)) && (n3[r3] = true, u2[r3] === -1 || d2(u2[r3], n3))) return u2[r3] = t5, true;
    return false;
  };
  for (let t5 = 0; t5 < l2; t5++) if (!d2(t5, Array(l2).fill(false))) return false;
  return true;
}
function values_close$2(t4, n2, r2, i2, a2, o2 = 0) {
  let s2 = mathjs_default$2.abs(t4), c2 = mathjs_default$2.abs(n2), l2 = Math.min(s2, c2), u2 = Math.max(s2, c2), d2 = o2;
  return d2 += l2 * r2, d2 = Math.min(d2, 0.1 * l2), d2 === 0 && (t4 === 0 || n2 === 0) ? d2 += a2 : d2 += i2, u2 === 0 || mathjs_default$2.abs(mathjs_default$2.subtract(t4, n2)) < d2;
}
var astToText$4 = new astToText$2$2();
function generate_random_integer$2(t4, n2, r2) {
  return t4 = mathjs_default$2.ceil(t4), n2 = mathjs_default$2.floor(n2), mathjs_default$2.floor(r2() * (n2 - t4 + 1)) + t4;
}
function random_cubic$2(t4) {
  let n2 = (t4() - 0.5) * 1, r2 = (t4() - 0.5) * 2, i2 = (t4() - 0.5) * 6, a2 = (t4() - 0.5) * 24;
  return function(t5) {
    return mathjs_default$2.add(mathjs_default$2.multiply(mathjs_default$2.add(mathjs_default$2.multiply(mathjs_default$2.add(mathjs_default$2.multiply(n2, t5), r2), t5), i2), t5), a2);
  };
}
var equals$6$2 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2 = 1e-12, absolute_tolerance: s2 = 0, tolerance_for_zero: c2 = 1e-15, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, coerce_tuples_arrays: p2 = true, coerce_vectors: m2 = true, rng: h2 }) {
  if (i2 ||= t4.context, a2 ||= n2.context, Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let g2 = t4.tree[0], v2 = t4.tree.slice(1), y2 = n2.tree[0], b2 = n2.tree.slice(1);
    if (g2 === `tuple` || g2 === `vector` || g2 === `altvector` || g2 === `list` || g2 === `array` || g2 === `matrix` || g2 === `interval`) {
      if (y2 !== g2 && ({ operator1: g2, operator2: y2, operands1: v2, operands2: b2 } = coerce_tuple_array_vectors$2({ operator1: g2, operator2: y2, operands1: v2, operands2: b2, coerce_tuples_arrays: p2, coerce_vectors: m2 })), y2 !== g2 || b2.length !== v2.length) return false;
      for (let t5 = 0; t5 < v2.length; t5++) if (!equals$6$2({ expr: i2.fromAst(v2[t5]), other: a2.fromAst(b2[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 })) return false;
      return true;
    }
    if (v2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(g2)) {
      if (b2.length !== 2 || (g2 === `>` ? (g2 = `<`, v2 = [v2[1], v2[0]]) : g2 === `ge` && (g2 = `le`, v2 = [v2[1], v2[0]]), y2 === `>` ? (y2 = `<`, b2 = [b2[1], b2[0]]) : y2 === `ge` && (y2 = `le`, b2 = [b2[1], b2[0]]), g2 !== y2)) return false;
      let t5 = [`+`, v2[0], [`-`, v2[1]]], n3 = [`+`, b2[0], [`-`, b2[1]]], x2 = g2 !== `=`;
      if (contains_pm$2(t5) || contains_pm$2(n3)) {
        if (g2 === `=`) {
          let g3 = (t6, n4) => {
            let r3 = expand_pm_signs$2(t6), i3 = [];
            for (let t7 of r3) {
              let r4 = n4.fromAst(t7).simplify().tree;
              i3.some((t8) => equal$2(t8, r4)) || i3.push(r4);
            }
            return i3.length === 1 ? i3[0] : [`*`, ...i3];
          }, v3, y3;
          try {
            v3 = g3(t5, i2), y3 = g3(n3, a2);
          } catch {
            return false;
          }
          return component_equals$1$2({ expr: i2.fromAst(v3), other: a2.fromAst(y3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: false, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
        }
        return pm_equals_numerical$2({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 });
      }
      return component_equals$1$2({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: x2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
    }
  }
  return contains_pm$2(t4.tree) || contains_pm$2(n2.tree) ? pm_equals_numerical$2({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 }) : component_equals$1$2({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
}, component_equals$1$2 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: o2 = false, require_positive_proportion: s2 = false, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 }) {
  var y2 = Number.MAX_VALUE * 1e-20, b2 = 0, x2 = 10, S2 = 100, w2, E, D;
  ({ variables: w2, integer_variables: E, functions: D, expr: t4, other: n2 } = prepare_exprs_numerical_eval$2(t4, n2, i2, a2));
  try {
    var O2 = t4.f(), j2 = n2.f();
  } catch {
    if (t4.equalsViaSyntax(n2, { allow_blanks: true, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2 })) return true;
    if (!(Array.isArray(t4.tree) && Array.isArray(n2.tree)) || t4.tree[0] !== n2.tree[0]) return false;
    let o3 = t4.tree.slice(1), s3 = n2.tree.slice(1);
    for (let t5 = 0; t5 < o3.length; t5++) if (!equals$6$2({ expr: i2.fromAst(o3[t5]), other: a2.fromAst(s3[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 })) return false;
    return true;
  }
  let M2, N2, F;
  if (d2 > 0) {
    let n3 = replace_numbers_with_parameters$2({ expr: t4, variables: w2, include_exponents: p2 });
    M2 = i2.fromAst(n3.expr_with_params), N2 = n3.parameters;
    let r3 = Object.keys(N2);
    if (r3.length > 0) {
      let t5 = M2.derivative(r3[0]);
      if (m2 || (t5 = t5.multiply(N2[r3[0]])), r3.length > 1) for (let n5 of r3.slice(1)) {
        let r4 = M2.derivative(n5);
        m2 || (r4 = r4.multiply(N2[n5])), t5 = t5.add(r4);
      }
      let n4 = t5.multiply(d2);
      try {
        F = n4.f();
      } catch {
      }
    }
  }
  var I2 = 1, L2 = [10, 1, 100, 0.1, 1e3, 0.01], R2 = 0;
  let z2 = 0, V2 = true, H2 = 0;
  for (let t5 = 0; t5 < 10 * S2; t5++) {
    try {
      var U2 = W2(L2[R2], v2);
    } catch {
      continue;
    }
    if (U2.always_zero === false && (V2 = false), !U2.equal && !U2.out_of_bounds && !U2.always_zero && U2.sufficient_finite_values !== false && (H2++, H2 > S2)) return false;
    if (U2.equal) if (U2.always_zero) {
      if (!V2) continue;
      if (z2 += 1, z2 > 5 && (R2 += 1, z2 = 0), R2 >= L2.length) return true;
      continue;
    } else return true;
  }
  return false;
  function W2(t5, n3) {
    var i3 = r2(n3, w2, t5);
    for (let t6 = 0; t6 < E.length; t6++) i3[E[t6]] = generate_random_integer$2(-10, 10, n3);
    for (let t6 = 0; t6 < D.length; t6++) i3[D[t6]] = random_cubic$2(n3);
    var a3;
    F && (a3 = Object.assign({}, i3, N2));
    var d3 = O2(i3), p3 = j2(i3);
    if (typeof d3 == `boolean` || typeof p3 == `boolean`) return { out_of_bounds: true, always_zero: false };
    var m3 = mathjs_default$2.abs(d3), h3 = mathjs_default$2.abs(p3);
    if (!(m3 < y2 && h3 < y2) || !((m3 === 0 || m3 > b2) && (h3 === 0 || h3 > b2))) return { out_of_bounds: true, always_zero: false };
    var g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), S3 = 1;
    let M3 = 0;
    if (F) {
      try {
        M3 = mathjs_default$2.abs(F(a3));
      } catch {
        return { equal_at_start: false, always_zero: false };
      }
      if (!Number.isFinite(M3)) return { equal_at_start: false, always_zero: false };
    }
    if (M3 += g3 * c2, M3 = Math.min(M3, 0.1 * g3), M3 === 0 && (d3 === 0 || p3 === 0) ? M3 += u2 : M3 += l2, !(v3 === 0 || mathjs_default$2.abs(mathjs_default$2.subtract(d3, p3)) < M3) && (!o2 || m3 === 0 || h3 === 0 || (S3 = mathjs_default$2.divide(d3, p3), s2 && !(S3 > 0)))) return { equal_at_start: false, always_zero: false };
    var L3 = v3 === 0, R3 = 0;
    for (let t6 = 0; t6 < 100; t6++) {
      var z3 = r2(n3, w2, I2 / 100, i3);
      for (let t7 = 0; t7 < E.length; t7++) z3[E[t7]] = generate_random_integer$2(-10, 10, n3);
      for (let t7 = 0; t7 < D.length; t7++) z3[D[t7]] = random_cubic$2(n3);
      var V3;
      F && (V3 = Object.assign({}, z3, N2));
      try {
        d3 = O2(z3), p3 = mathjs_default$2.multiply(j2(z3), S3);
      } catch {
        continue;
      }
      if (m3 = mathjs_default$2.abs(d3), h3 = mathjs_default$2.abs(p3), m3 < y2 && h3 < y2) {
        g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), R3++;
        let t7 = 0;
        if (F) {
          try {
            t7 = mathjs_default$2.abs(F(V3));
          } catch {
            continue;
          }
          if (!Number.isFinite(t7)) continue;
        }
        if (t7 += g3 * c2, t7 = Math.min(t7, 0.1 * g3), t7 === 0 && (d3 === 0 || p3 === 0) ? t7 += u2 : t7 += l2, !(v3 === 0 || mathjs_default$2.abs(mathjs_default$2.subtract(d3, p3)) < t7)) return { equality_in_middle: false, always_zero: false };
        if (L3 &&= v3 === 0, R3 >= x2) return { equal: true, always_zero: L3 };
      }
    }
    return { sufficient_finite_values: false, always_zero: L3 };
  }
};
function prepare_exprs_numerical_eval$2(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, { expr: t4, other: n2 } = normalize_for_equality_checking$2(t4, n2, r2, i2);
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  mathjs_default$2.define_pi && (a2 = a2.filter(function(t5) {
    return t5 !== `pi`;
  })), mathjs_default$2.define_i && (a2 = a2.filter(function(t5) {
    return t5 !== `i`;
  })), mathjs_default$2.define_e && (a2 = a2.filter(function(t5) {
    return t5 !== `e`;
  }));
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) (is_integer_ast$2(a2[t5], r2.assumptions) || is_integer_ast$2(a2[t5], i2.assumptions)) && o2.push(a2[t5]);
  var s2 = [.../* @__PURE__ */ new Set([...t4.functions(), ...n2.functions()])].filter((t5) => t5.length === 1 || t5.includes(`_`) || t5.includes(`^`)), c2 = s2.filter((t5) => a2.includes(t5));
  if (s2 = s2.filter((t5) => !a2.includes(t5)), c2.length > 0) {
    let o3 = t4.tree, l2 = n2.tree, u2 = `x1`;
    for (; [...s2, ...a2].includes(u2); ) u2 += `x1`;
    let d2 = `x2`;
    for (; [...s2, ...a2].includes(d2); ) d2 += `x2`;
    for (let t5 of c2) {
      let n3 = t5 + t5;
      for (; [...s2, ...a2].includes(n3); ) n3 += t5;
      let r3 = [[[`apply`, t5, u2], [`apply`, n3, u2], { variables: { [u2]: true } }]];
      o3 = applyAllTransformations$2(o3, r3), l2 = applyAllTransformations$2(l2, r3), s2.push(n3);
    }
    t4 = r2.fromAst(o3), n2 = i2.fromAst(l2);
  }
  return { variables: a2, integer_variables: o2, functions: s2, expr: t4, other: n2 };
}
function normalize_for_equality_checking$2(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, t4 = t4.normalize_function_names(), n2 = n2.normalize_function_names(), t4 = t4.log_subscript_to_two_arg_log(), n2 = n2.log_subscript_to_two_arg_log(), t4 = t4.subscripts_to_strings(), n2 = n2.subscripts_to_strings(), t4 = t4.normalize_applied_functions(), n2 = n2.normalize_applied_functions();
  let a2 = rename_functions_with_exponents$2(t4.tree), o2 = rename_functions_with_exponents$2(n2.tree);
  return t4 = r2.fromAst(rename_vecs$2(a2)), n2 = i2.fromAst(rename_vecs$2(o2)), { expr: t4, other: n2 };
}
function replace_numbers_with_parameters$2({ expr: t4, variables: n2, include_exponents: r2 = false }) {
  let i2 = {}, a2 = 0;
  function o2() {
    a2++;
    let t5 = `par` + a2;
    for (; n2.includes(t5); ) a2++, t5 = `par` + a2;
    return t5;
  }
  function s2(t5) {
    if (typeof t5 == `number`) {
      if (t5 === 0) return t5;
      {
        let n4 = o2();
        return i2[n4] = t5, n4;
      }
    }
    if (typeof t5 == `string`) {
      if (t5 === `pi`) {
        if (mathjs_default$2.define_pi) {
          let t6 = o2();
          return i2[t6] = mathjs_default$2.PI, t6;
        }
      } else if (t5 === `e` && mathjs_default$2.define_e) {
        let t6 = o2();
        return i2[t6] = mathjs_default$2.e, t6;
      }
      return t5;
    }
    if (!Array.isArray(t5)) return t5;
    let n3 = t5[0], a3 = t5.slice(1);
    return n3 === `^` && !r2 ? [n3, s2(a3[0]), a3[1]] : [n3, ...a3.map(s2)];
  }
  return t4 = t4.evaluate_numbers({ max_digits: 1 / 0 }), { expr_with_params: s2(t4.tree), parameters: i2 };
}
function rename_functions_with_exponents$2(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `apply`) {
    let t5 = r2[0];
    return Array.isArray(t5) && t5[0] === `^` && t5.slice(1).every((t6) => [`number`, `string`].includes(typeof t6)) && (t5 = astToText$4.convert(t5)), [`apply`, t5, r2[1]];
  }
  return [n2, ...r2.map(rename_functions_with_exponents$2)];
}
function rename_vecs$2(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  return n2 === `vec` && r2.length === 1 ? `__vec_` + astToText$4.convert(r2[0]) : [n2, ...r2.map(rename_vecs$2)];
}
function randomComplexBindings$2(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = mathjs_default$2.complex(t4() * 2 * r2 - r2, t4() * 2 * r2 - r2);
  }) : n2.forEach(function(n3) {
    a2[n3] = mathjs_default$2.complex(i2[n3].re + t4() * 2 * r2 - r2, i2[n3].im + t4() * 2 * r2 - r2);
  }), a2;
}
var equals$5$2 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = (0, import_seedrandom$2.default)(`complex_seed`);
  return t4 = t4.remove_scaling_units(), n2 = n2.remove_scaling_units(), equals$6$2({ expr: t4, other: n2, randomBindings: randomComplexBindings$2, expr_context: t4.context, other_context: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, coerce_tuples_arrays: u2, coerce_vectors: d2, rng: p2 });
};
function randomRealBindings$2(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = t4() * 2 * r2 - r2;
  }) : n2.forEach(function(n3) {
    a2[n3] = i2[n3] + t4() * 2 * r2 - r2;
  }), a2;
}
var equals$4$2 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false } = {}) {
  if (!t4.isAnalytic() || !n2.isAnalytic()) return false;
  let l2 = seedrandom(`real_seed`);
  return equals$6$2({ expr: t4, other: n2, randomBindings: randomRealBindings$2, expr_context: t4.context, other_content: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, rng: l2 });
}, equals$3$2 = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, allow_blanks: o2 = false, coerce_tuples_arrays: s2 = true, coerce_vectors: c2 = true } = {}) {
  if (!o2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let l2 = t4.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), u2 = n2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal$2(l2.tree, u2.tree, { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: s2, coerce_vectors: c2 });
};
function randomFiniteFieldBindings$2(t4, n2, r2) {
  var i2 = {};
  return n2.forEach(function(n3) {
    i2[n3] = Math.floor(t4() * r2);
  }), i2;
}
var equals$2$2 = function(t4, n2, { allow_blanks: r2 = false, coerce_tuples_arrays: i2 = true, coerce_vectors: a2 = true } = {}) {
  if (!r2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let o2 = (0, import_seedrandom$2.default)(`finite_field_seed`);
  if (Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let r3 = t4.tree[0], p2 = t4.tree.slice(1), m2 = n2.tree[0], h2 = n2.tree.slice(1);
    if (r3 === `tuple` || r3 === `vector` || r3 === `altvector` || r3 === `list` || r3 === `array` || r3 === `matrix` || r3 === `interval`) {
      if (m2 !== r3 && ({ operator1: r3, operator2: m2, operands1: p2, operands2: h2 } = coerce_tuple_array_vectors$2({ operator1: r3, operator2: m2, operands1: p2, operands2: h2, coerce_tuples_arrays: i2, coerce_vectors: a2 })), m2 !== r3 || h2.length !== p2.length) return false;
      for (let r4 = 0; r4 < p2.length; r4++) if (equals$2$2(t4.context.fromAst(p2[r4]), n2.context.fromAst(h2[r4]), o2) === false) return false;
      return;
    }
    if (p2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(r3)) {
      if (h2.length !== 2 || (r3 === `>` ? (r3 = `<`, p2 = [p2[1], p2[0]]) : r3 === `ge` && (r3 = `le`, p2 = [p2[1], p2[0]]), m2 === `>` ? (m2 = `<`, h2 = [h2[1], h2[0]]) : m2 === `ge` && (m2 = `le`, h2 = [h2[1], h2[0]]), r3 !== m2)) return false;
      let i3 = [`+`, p2[0], [`-`, p2[1]]], a3 = [`+`, h2[0], [`-`, h2[1]]], g2 = r3 !== `=`, v2 = t4.context.fromAst(i3), y2 = n2.context.fromAst(a3);
      try {
        let t5 = prepare_exprs_numerical_eval$2(v2, y2);
        if (t5.functions.length === 0) {
          var s2 = t5.expr.f(), c2 = t5.other.f();
          let r4 = Number.MAX_VALUE * 1e-20;
          for (let i4 = 0; i4 < 10; i4++) {
            var l2 = {};
            t5.variables.forEach(function(t6) {
              l2[t6] = o2() * 2 - 1;
            });
            for (let n3 = 0; n3 < t5.integer_variables.length; n3++) l2[t5.integer_variables[n3]] = mathjs_default$2.floor(o2() * 21) - 10;
            let i5 = s2(l2), p3 = c2(l2);
            var u2 = mathjs_default$2.abs(i5), d2 = mathjs_default$2.abs(p3);
            if (!(u2 < r4 && d2 < r4) || u2 == 0 || d2 === 0) continue;
            let m3 = mathjs_default$2.divide(i5, p3);
            if (g2 && !(m3 > 0)) return false;
            if (m3 !== 1) {
              let t6 = rationalApproximation$2(m3);
              y2 = n2.context.fromAst([`*`, [`/`, t6.numerator, t6.denominator], a3]);
            }
            break;
          }
        }
      } catch {
        return;
      }
      return component_equals$3(v2, y2, o2);
    }
  }
  return component_equals$3(t4, n2, o2);
}, component_equals$3 = function(t4, n2, r2) {
  ({ expr: t4, other: n2 } = normalize_for_equality_checking$2(t4, n2));
  let i2 = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  for (let o2 of i2) {
    let i3 = randomFiniteFieldBindings$2(r2, a2, o2);
    try {
      let r3 = t4.finite_field_evaluate(i3, o2), a3 = n2.finite_field_evaluate(i3, o2);
      if (!r3.approximate && !a3.approximate && !r3.isNaN() && !a3.isNaN() && r3.values.length > 0 && a3.values.length > 0 && !r3.equals(a3)) return false;
    } catch {
      return;
    }
  }
}, equals$1$2 = function(t4, n2, { min_elements_match: r2 = 3, match_partial: i2 = false } = {}) {
  if (!is_discrete_infinite_set$2(t4)) return false;
  if (is_discrete_infinite_set$2(n2)) {
    var a2 = [];
    let r3 = t4.context.get_assumptions(t4);
    if (r3 !== void 0 && a2.push(r3), r3 = n2.context.get_assumptions(n2), r3 !== void 0 && a2.push(r3), a2 = a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : clean_assumptions$2([`and`].concat(a2)), i2) {
      let r4 = contained_in$2(t4.tree, n2.tree, a2, i2);
      if (r4 === false) return 0;
      let o2 = contained_in$2(n2.tree, t4.tree, a2, i2);
      return o2 === false ? 0 : r4 === true ? o2 === true ? 1 : o2 : o2 === true ? r4 : Math.min(r4, o2);
    } else return contained_in$2(t4.tree, n2.tree, a2, i2) && contained_in$2(n2.tree, t4.tree, a2, i2);
  } else {
    let i3 = n2.tree;
    if (i3[0] !== `list`) return false;
    let a3 = i3.length - 2;
    if (i3[a3 + 1][0] !== `ldots` || a3 < r2) return false;
    let o2 = i3.slice(0, a3 + 1), s2 = sequence_from_discrete_infinite$2(t4, a3);
    return s2 ? (s2 = [`list`].concat(s2), equals$8(t4.context.from(s2), n2.context.from(o2))) : false;
  }
};
function is_discrete_infinite_set$2(t4) {
  var n2 = t4.tree;
  if (!Array.isArray(n2) || n2[0] !== `discrete_infinite_set`) return false;
  for (var r2 of n2.slice(1)) if (!Array.isArray(r2) || r2[0] !== `tuple` || r2.length !== 5) return false;
  return true;
}
function contained_in$2(t4, n2, r2, i2) {
  if (t4[0] === `discrete_infinite_set`) if (i2) {
    let a3 = 0;
    for (let o4 of t4.slice(1)) {
      let t5 = contained_in$2(o4, n2, r2, i2);
      t5 === true ? a3++ : t5 !== false && (a3 += t5);
    }
    let o3 = t4.length - 1;
    return a3 === o3 ? true : a3 === 0 ? false : a3 / o3;
  } else return t4.slice(1).every((t5) => contained_in$2(t5, n2, r2));
  var a2 = t4[1], o2 = t4[2], s2 = evaluate_numbers$2(t4[3], r2), c2 = t4[4];
  if (s2 !== -1 / 0 || c2 !== 1 / 0) return false;
  a2 = simplify$2([`/`, a2, o2], r2, 1 / 0);
  var l2 = n2.slice(1), u2 = [];
  for (let t5 = 0; t5 < l2.length; t5++) {
    let n3 = evaluate_numbers$2(l2[t5][3]), i3 = l2[t5][4];
    if (n3 !== -1 / 0 || i3 !== 1 / 0) return false;
    let a3 = simplify$2([`/`, l2[t5][1], o2], r2, 1 / 0), s3 = simplify$2([`/`, l2[t5][2], o2], r2, 1 / 0);
    if (typeof s3 != `number`) return false;
    let c3 = mathjs_default$2.fraction(s3), d3 = mathjs_default$2.number(c3.n), p3 = mathjs_default$2.number(c3.d);
    u2.push([d3, p3, a3, s3]);
  }
  for (u2.sort(); u2[0][0] === 1; ) {
    let t5 = u2[0][2], n3 = u2[0][3], i3 = simplify$2(expand$2([`+`, t5, [`-`, a2]]), r2, 1 / 0);
    if (Number.isFinite(i3) && Number.isFinite(n3) && (i3 = mathjs_default$2.mod(i3, n3), mathjs_default$2.min(i3, n3 - i3) < 1e-10 * n3)) return true;
    if (u2.splice(0, 1), u2.length === 0) return false;
  }
  var d2 = [...new Set(u2.map((t5) => t5[0]))];
  let p2 = 0;
  for (let t5 of d2) {
    let n3 = u2.map(function(n4, r3) {
      if (mathjs_default$2.mod(t5, n4[0]) === 0) {
        let i3 = t5 / n4[0];
        return [n4[0], i3, r3];
      } else return;
    }).filter((t6) => t6), o3 = [];
    for (let i3 of n3) {
      let n4 = i3[0], s3 = i3[1], c3 = i3[2], l3 = u2[c3][2], d3 = u2[c3][3];
      for (let i4 = 0; i4 < n4; i4++) {
        let c4 = simplify$2(expand$2([`+`, l3, [`-`, [`+`, a2, i4]]]), r2, 1 / 0);
        if (Number.isFinite(c4) && Number.isFinite(d3) && (c4 = mathjs_default$2.mod(c4, d3), mathjs_default$2.min(c4, d3 - c4) < 1e-10 * d3)) {
          for (let t6 = 0; t6 < s3; t6++) o3[i4 + t6 * n4] = true;
          let r3 = true;
          for (let n5 = 0; n5 < t5; n5++) if (!o3[n5]) {
            r3 = false;
            break;
          }
          if (r3) return true;
          break;
        }
      }
    }
    if (i2) {
      let n4 = 0;
      for (let r3 = 0; r3 < t5; r3++) o3[r3] && n4++;
      n4 /= t5, n4 > p2 && (p2 = n4);
    }
  }
  return i2 && p2 > 0 ? p2 : false;
}
function sequence_from_discrete_infinite$2(t4, n2) {
  var r2 = t4.tree.slice(1);
  if (r2.length > 1) return;
  let i2 = r2[0][1], a2 = r2[0][2], o2 = evaluate_numbers$2(r2[0][3]), s2 = r2[0][4];
  if (!Number.isInteger(o2) || s2 !== 1 / 0) return;
  let c2 = [];
  for (let t5 = 0; t5 < n2; t5++) c2.push(evaluate_numbers$2([`+`, [`*`, a2, o2 + t5], i2]));
  return c2;
}
var equality_exports$2 = __exportAll$2({ equals: () => equals$8, equalsDiscreteInfinite: () => equals$1$2, equalsViaComplex: () => equals$5$2, equalsViaFiniteField: () => equals$2$2, equalsViaReal: () => equals$4$2, equalsViaSyntax: () => equals$3$2 }), equals$8 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = t4.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), m2 = n2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return p2.equalsViaSyntax(m2, { allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : o2 === 0 && t4.equalsViaFiniteField(n2, { allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) == 0 ? false : t4.equalsViaComplex(n2, { relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : !!equals$1$2(t4, n2);
}, sign_error_exports$2 = __exportAll$2({ equalSpecifiedSignErrors: () => equalSpecifiedSignErrors$2, equalWithSignErrors: () => equalWithSignErrors$2 }), equalWithSignErrors$2 = function(t4, n2, { equalityFunction: r2 = equals$8, max_sign_errors: i2 = 1 } = {}) {
  if (r2(t4, n2)) return { matched: true, n_sign_errors: 0 };
  for (let a2 = 1; a2 <= i2; a2++) if (equalSpecifiedSignErrors$2(t4, n2, { equalityFunction: r2, n_sign_errors: a2 })) return { matched: true, n_sign_errors: a2 };
  return { matched: false };
}, equalSpecifiedSignErrors$2 = function(t4, n2, { equalityFunction: r2 = equals$8, n_sign_errors: i2 = 1 } = {}) {
  if (i2 === 0) return r2(t4, n2);
  if (!(Number.isInteger(i2) && i2 > 0)) throw Error(`Have not implemented equality check with ${i2} sign errors.`);
  if (i2 > 1) {
    let t5 = r2;
    r2 = function(n3, r3) {
      return equalSpecifiedSignErrors$2(n3, r3, { equalityFunction: t5, n_sign_errors: i2 - 1 });
    };
  }
  var a2 = t4.tree, o2 = [[a2]], s2 = 0, c2, l2;
  t4.tree = [`-`, a2];
  var u2 = r2(t4, n2);
  if (t4.tree = a2, u2) return true;
  for (; c2 = o2[s2++]; ) if (c2 = c2[0], Array.isArray(c2)) {
    for (l2 = 1; l2 < c2.length; l2++) if (o2.push([c2[l2]]), c2[l2] = [`-`, c2[l2]], u2 = r2(t4, n2), c2[l2] = c2[l2][1], u2) return true;
  }
  return false;
}, arithmetic_exports$2 = __exportAll$2({ add: () => add$4, copy: () => copy$2, divide: () => divide$3, mod: () => mod$5, multiply: () => multiply$2, pow: () => pow$3, subtract: () => subtract$2 });
function add$4(t4, n2) {
  return clean$4([`+`, get_tree$2(t4), get_tree$2(n2)]);
}
function subtract$2(t4, n2) {
  return clean$4([`+`, get_tree$2(t4), [`-`, get_tree$2(n2)]]);
}
function multiply$2(t4, n2) {
  return clean$4([`*`, get_tree$2(t4), get_tree$2(n2)]);
}
function divide$3(t4, n2) {
  return clean$4([`/`, get_tree$2(t4), get_tree$2(n2)]);
}
function pow$3(t4, n2) {
  return clean$4([`^`, get_tree$2(t4), get_tree$2(n2)]);
}
function mod$5(t4, n2) {
  return clean$4([`apply`, `mod`, [`tuple`, get_tree$2(t4), get_tree$2(n2)]]);
}
function copy$2(t4) {
  return get_tree$2(t4);
}
var analytic_exports$2 = __exportAll$2({ isAnalytic: () => isAnalytic$2 }), analytic_operators$2 = [`+`, `-`, `*`, `/`, `^`, `tuple`, `vector`, `altvector`, `list`, `array`, `matrix`, `interval`, `vec`], non_analytic_functions$2 = [`abs`, `sign`, `arg`], relation_operators$2 = [`=`, `le`, `ge`, `<`, `>`];
function isAnalytic$2(t4, { allow_abs: n2 = false, allow_arg: r2 = false, allow_relation: i2 = false } = {}) {
  var a2 = normalize_applied_functions$2(normalize_function_names$2(t4));
  a2 = subscripts_to_strings$2(a2);
  var o2 = operators$3$2(a2);
  for (let t5 = 0; t5 < o2.length; t5++) {
    let n3 = o2[t5];
    if (analytic_operators$2.indexOf(n3) === -1) if (i2) {
      if (relation_operators$2.indexOf(n3) === -1) return false;
    } else return false;
  }
  var s2 = functions$2$2(a2);
  for (let t5 = 0; t5 < s2.length; t5++) {
    let i3 = s2[t5];
    if (non_analytic_functions$2.includes(i3) && !(n2 && i3 == `abs` || r2 && i3 == `arg`)) return false;
  }
  return true;
}
var sets_exports$2 = __exportAll$2({ create_discrete_infinite_set: () => create_discrete_infinite_set$2 });
function create_discrete_infinite_set$2({ offsets: t4, periods: n2, min_index: r2 = [`-`, 1 / 0], max_index: i2 = 1 / 0 } = {}) {
  if (t4 = get_tree$2(t4), n2 = get_tree$2(n2), r2 = get_tree$2(r2), i2 = get_tree$2(i2), t4 === void 0 || n2 === void 0) return;
  let a2 = [];
  if (t4[0] === `list`) if (n2[0] === `list`) {
    if (t4.length !== n2.length || t4.length === 1) return;
    for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2[o2], r2, i2]);
  } else for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2, r2, i2]);
  else a2.push([`tuple`, t4, n2, r2, i2]);
  return [`discrete_infinite_set`].concat(a2);
}
var matrix_exports$2 = __exportAll$2({ cross_prod: () => cross_prod$2, dot_prod: () => dot_prod$2, matrix: () => matrix$2, scalar_mul: () => scalar_mul$2, vector_add: () => vector_add$2, vector_sub: () => vector_sub$2 });
function tuple$2(t4) {
  var n2 = [];
  n2.push(`tuple`);
  var r2 = t4.length;
  for (let i2 = 0; i2 < r2; i2++) n2.push(t4[i2]);
  return n2;
}
function matrix$2(t4) {
  var n2 = [];
  n2.push(`matrix`);
  var r2 = t4.length, i2 = t4[0].length;
  for (let n3 = 1; n3 < r2; n3++) if (t4[n3].length !== i2) throw Error(`Matrix dimensions mismatch`);
  n2.push(tuple$2([r2, i2]));
  let a2 = [];
  for (let n3 = 0; n3 < r2; n3++) a2.push(tuple$2(t4[n3].map(function(t5) {
    return t5.tree;
  })));
  return n2.push(tuple$2(a2)), n2;
}
function vector_add$2(t4, n2) {
  if (t4 = get_tree$2(t4), n2 = get_tree$2(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't add. Those aren't vectors, or the dimensions don't match`);
  var r2 = t4[0] === `altvector` && n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = t4.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`+`, t4[a2], n2[a2]]);
  return simplify$2(r2);
}
function scalar_mul$2(t4, n2) {
  if (n2 = get_tree$2(n2), n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't scalar multiply. Isn't a vector`);
  var r2 = n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = n2.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`*`, n2[a2], t4]);
  return simplify$2(r2);
}
function vector_sub$2(t4, n2) {
  return vector_add$2(t4, scalar_mul$2(-1, n2));
}
function dot_prod$2(t4, n2) {
  if (t4 = get_tree$2(t4), n2 = get_tree$2(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take dot product. Those aren't vectors, or the dimensions don't match`);
  var r2 = 0, i2 = 0, a2 = t4.length;
  for (let o2 = 1; o2 < a2; o2 += 1) i2 = [`*`, t4[o2], n2[o2]], r2 = [`+`, r2, i2];
  return simplify$2(r2);
}
function cross_prod$2(t4, n2) {
  if (t4 = get_tree$2(t4), n2 = get_tree$2(n2), t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take cross product. Those aren't vectors`);
  if (t4.length === 3 && n2.length === 3) return simplify$2([`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]]);
  if (t4.length === 4 && n2.length === 4) {
    var r2 = [`+`, [`*`, t4[2], n2[3]], [`-`, [`*`, t4[3], n2[2]]]], i2 = [`+`, [`*`, t4[3], n2[1]], [`-`, [`*`, t4[1], n2[3]]]], a2 = [`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]];
    return simplify$2([t4[0] === `altvector` && n2[0] === `altvector` ? `altvector` : `vector`, r2, i2, a2]);
  }
  throw Error(`Can't take cross product. The dimensions aren't both 2 or 3.`);
}
var astToGuppy$1$2 = class t3 {
  constructor() {
    this.operators = { "+": function(t4) {
      return t4.join(`<e>+</e>`);
    }, "-": function(t4) {
      return `<e>-` + t4.join(`-`) + `</e>`;
    }, "*": function(t4) {
      return t4.join(`<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>`);
    }, "/": function(n2) {
      return t3.dfrac(n2[0], n2[1]);
    }, "^": function(n2) {
      return t3.power(n2[0], n2[1]);
    }, sin: function(n2) {
      return t3.trig(`sin`, n2[0]);
    }, cos: function(n2) {
      return t3.trig(`cos`, n2[0]);
    }, tan: function(n2) {
      return t3.trig(`tan`, n2[0]);
    }, arcsin: function(n2) {
      return t3.trig(`arcsin`, n2[0]);
    }, arccos: function(n2) {
      return t3.trig(`arccos`, n2[0]);
    }, arctan: function(n2) {
      return t3.trig(`arctan`, n2[0]);
    }, arccsc: function(n2) {
      return t3.trig(`arccsc`, n2[0]);
    }, arcsec: function(n2) {
      return t3.trig(`arcsec`, n2[0]);
    }, arccot: function(n2) {
      return t3.trig(`arccot`, n2[0]);
    }, csc: function(n2) {
      return t3.trig(`csc`, n2[0]);
    }, sec: function(n2) {
      return t3.trig(`sec`, n2[0]);
    }, cot: function(n2) {
      return t3.trig(`cot`, n2[0]);
    }, log: function(n2) {
      return t3.trig(`log`, n2[0]);
    }, exp: function(n2) {
      return t3.trig(`exp`, n2[0]);
    }, ln: function(n2) {
      return t3.trig(`ln`, n2[0]);
    }, sqrt: function(n2) {
      return t3.sqrt(n2[0]);
    }, abs: function(n2) {
      return t3.abs(n2[0]);
    } };
  }
  static dfrac(t4, n2) {
    return `<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>` + t4 + `<e></e></c><c up="1" down="2" name="denominator"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static trig(t4, n2) {
    return `<f type="` + t4 + `" group="functions"><b p="latex">\\` + t4 + `\\left(<r ref="1"/>\\right)</b><b p="text"> ` + t4 + `(<r ref="1"/>)</b><c delete="1"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static sqrt(t4) {
    return `<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static power(t4, n2) {
    return `<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>` + t4 + `<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static abs(t4) {
    return `<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static paren(t4) {
    return `<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static isFunctionSymbol(t4) {
    return [`sin`, `cos`, `tan`, `csc`, `sec`, `cot`, `arcsin`, `arccos`, `arctan`, `arccsc`, `arcsec`, `arccot`, `log`, `ln`, `exp`, `sqrt`, `abs`, `this.factorial`].indexOf(t4) !== -1;
  }
  static isGreekLetterSymbol(t4) {
    return `pi.theta.theta.Theta.alpha.nu.beta.xi.Xi.gamma.Gamma.delta.Delta.pi.Pi.epsilon.epsilon.rho.rho.zeta.sigma.Sigma.eta.tau.upsilon.Upsilon.iota.phi.phi.Phi.kappa.chi.lambda.Lambda.psi.Psi.omega.Omega`.split(`.`).indexOf(t4) !== -1;
  }
  factorWithParenthesesIfNegated(n2) {
    var r2 = this.factor(n2);
    return r2.toString().match(/^<e>-/) ? t3.paren(r2.toString()) : r2;
  }
  factor(n2) {
    if (typeof n2 == `string`) return t3.isGreekLetterSymbol(n2) ? `<f type="` + n2 + `" group="greek" c="yes"><b p="latex">\\` + n2 + `</b><b p="text"> $` + n2 + `</b></f>` : `<e>` + n2 + `</e>`;
    if (typeof n2 == `number`) return `<e>` + n2 + `</e>`;
    if (!Array.isArray(n2)) return `<e></e>`;
    var r2 = n2[0], i2 = n2.slice(1);
    return r2 === `apply` && (r2 = n2[1], i2 = n2.slice(2)), r2 === `abs` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.expression(t4);
    }).bind(this))) : t3.isFunctionSymbol(r2) ? r2 === `this.factorial` && (i2[0].toString().length === 1 || i2[0].toString().match(/^[0-9]*$/)) ? this.operators[r2](i2) : this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : r2 === `^` || r2 === `~` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : t3.paren(this.expression(n2));
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `*` ? this.operators[n2](r2.map((function(t5, n3) {
      var r3 = this.factorWithParenthesesIfNegated(t5);
      return r3.toString().match(/^[0-9]/) && n3 > 0 ? ` * ` + r3 : r3;
    }).bind(this))) : n2 === `/` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this))) : this.factor(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` || n2 === `-` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factorWithParenthesesIfNegated(t5);
    }).bind(this))) : this.term(t4);
  }
  convert(t4) {
    return (`<m><e></e>` + this.expression(t4) + `<e></e></m>`).replace(/<\/e><e>/g, ``);
  }
}, glslOperators$2 = { "+": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `+` + t5;
  }), n2;
}, "-": function(t4) {
  var n2 = `-` + t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "~": function(t4) {
  var n2 = `vec2(0.0,0.0)`;
  return t4.forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "*": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cmul(` + n2 + `,` + t5 + `)`;
  }), n2;
}, "/": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cdiv(` + n2 + `,` + t5 + `)`;
  }), n2;
}, sin: function(t4) {
  return `csin(` + t4[0] + `)`;
}, cos: function(t4) {
  return `ccos(` + t4[0] + `)`;
}, tan: function(t4) {
  return `ctan(` + t4[0] + `)`;
}, sinh: function(t4) {
  return `csinh(` + t4[0] + `)`;
}, cosh: function(t4) {
  return `ccosh(` + t4[0] + `)`;
}, arcsin: function(t4) {
  return `carcsin(` + t4[0] + `)`;
}, arccos: function(t4) {
  return `carccos(` + t4[0] + `)`;
}, arctan: function(t4) {
  return `carctan(` + t4[0] + `)`;
}, arccsc: function(t4) {
  return `carcsin(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arcsec: function(t4) {
  return `carccos(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arccot: function(t4) {
  return `carctan(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, csc: function(t4) {
  return `ccsc(` + t4[0] + `)`;
}, sec: function(t4) {
  return `csec(` + t4[0] + `)`;
}, cot: function(t4) {
  return `ccot(` + t4[0] + `)`;
}, exp: function(t4) {
  return `cexp(` + t4[0] + `)`;
}, conj: function(t4) {
  return `conjugate(` + t4[0] + `)`;
}, sqrt: function(t4) {
  return `cpower(` + t4[0] + `,vec2(0.5,0.0))`;
}, log: function(t4) {
  return `clog(` + t4[0] + `)`;
}, ln: function(t4) {
  return `clog(` + t4[0] + `)`;
}, "^": function(t4) {
  return `cpower(` + t4[0] + `,` + t4[1] + `)`;
}, abs: function(t4) {
  return `cabs(` + t4[0] + `)`;
}, apply: function(t4) {
  return `vec2(NaN,NaN)`;
} }, astToGLSL$1$2 = class astToGLSL$12 {
  constructor() {
  }
  convert(t4) {
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (typeof t4 == `string`) return t4 === `e` ? `vec2(2.71828182845905,0.0)` : t4 === `pi` ? `vec2(3.14159265358979,0.0)` : t4 === `i` ? `vec2(0.0,1.0)` : String(t4);
    if (typeof t4 == `number`) return `vec2(` + String(t4) + `,0.0)`;
    if (`real` in t4 && `imaginary` in t4) return t4;
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to GLSL`);
      var n2 = r2[0], r2 = r2.slice(1);
      return glslOperators$2[n2](r2.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
    }
    if (n2 in glslOperators$2) return glslOperators$2[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, printing_exports$2 = __exportAll$2({ tex: () => tex$2, toGLSL: () => toGLSL$2, toLatex: () => toLatex$2, toString: () => toString$3, toXML: () => toXML$2 }), astToGuppy$3 = new astToGuppy$1$2(), astToGLSL$3 = new astToGLSL$1$2(), tex$2 = function(t4, n2) {
  return new astToLatex$1$2(n2).convert(t4.tree);
}, toLatex$2 = tex$2, toString$3 = function(t4, n2) {
  return new astToText$2$2(n2).convert(t4.tree);
}, toGLSL$2 = function(t4) {
  return astToGLSL$3.convert(t4.tree);
}, toXML$2 = function(t4) {
  return astToGuppy$3.convert(t4.tree);
}, integration_exports$2 = __exportAll$2({ integrateNumerically: () => integrateNumerically$2 }), integrateNumerically$2 = function(t4, n2, r2, i2) {
  for (var a2 = 100, o2 = 0, s2 = {}, c2 = 0; c2 < a2; c2++) s2[n2] = r2 + (i2 - r2) * (c2 + 0.5) / a2, o2 += t4.evaluate(s2);
  return o2 * (i2 - r2) / a2;
};
init_index_all$2(), init_index_all$2();
function expression_to_polynomial$2(t4) {
  var n2 = get_tree$2(t4);
  if (typeof n2 == `string`) return n2 === `pi` && mathjs_default$2.define_pi || n2 === `i` && mathjs_default$2.define_i || n2 === `e` && mathjs_default$2.define_e ? n2 : [`polynomial`, n2, [[1, 1]]];
  if (typeof n2 == `number`) return n2;
  var r2 = evaluate_to_constant$2(n2, { remove_units_first: false });
  if (Number.isFinite(r2)) return simplify$2(n2);
  if (!Array.isArray(n2) || !operators$3$2(n2).every((t5) => [`+`, `-`, `*`, `^`, `/`, `_`, `prime`].includes(t5))) return false;
  var i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `+`) {
    let t5 = a2.map(expression_to_polynomial$2);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_add$2(t6, n3)) : false;
  } else if (i2 === `-`) {
    let t5 = expression_to_polynomial$2(a2[0]);
    return t5 ? polynomial_neg$2(t5) : false;
  } else if (i2 === `*`) {
    let t5 = a2.map(expression_to_polynomial$2);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_mul$2(t6, n3)) : false;
  } else if (i2 === `^`) {
    let t5 = a2[0], r3 = expression_to_polynomial$2(t5);
    if (r3 === false) return false;
    let i3 = simplify$2(a2[1]);
    if (typeof i3 != `number` || i3 < 0 || !Number.isInteger(i3)) {
      let r4 = evaluate_to_constant$2(i3, { remove_units_first: false });
      if (Number.isFinite(r4)) {
        let n3 = mathjs_default$2.fraction(r4), i4 = { n: mathjs_default$2.number(n3.n), d: mathjs_default$2.number(n3.d), s: mathjs_default$2.number(n3.s) };
        if (i4.d <= 100) {
          t5 = i4.s < 0 ? [`^`, t5, [`/`, -1, i4.d]] : [`^`, t5, [`/`, 1, i4.d]];
          var o2 = [`polynomial`, simplify$2(t5), []];
          return o2[2].push([i4.n, 1]), o2;
        }
      }
      return [`polynomial`, n2, [[1, 1]]];
    }
    return i3 === 0 ? 1 : i3 === 1 ? r3 : polynomial_pow$2(r3, i3);
  } else if (i2 === `/`) {
    var s2 = a2[1], c2 = evaluate_to_constant$2(s2, { remove_units_first: false });
    return Number.isFinite(c2) ? polynomial_mul$2(expression_to_polynomial$2(a2[0]), [`/`, 1, c2]) : [`polynomial`, n2, [[1, 1]]];
  } else return [`polynomial`, n2, [[1, 1]]];
}
function polynomials_in_same_leading_variable$2(t4, n2) {
  return t4[1] !== n2[1] && (compare_function$2(t4[1], n2[1]) < 0 ? n2 = [`polynomial`, t4[1], [[0, n2]]] : t4 = [`polynomial`, n2[1], [[0, t4]]]), [t4, n2];
}
function polynomial_add$2(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify$2([`+`, t4, n2]);
    t4 = [`polynomial`, n2[1], [[0, t4]]];
  } else if (n2[0] !== `polynomial`) n2 = [`polynomial`, t4[1], [[0, n2]]];
  else {
    let r3 = polynomials_in_same_leading_variable$2(t4, n2);
    t4 = r3[0], n2 = r3[1];
  }
  let r2 = [`polynomial`, t4[1], []], i2 = t4[2], a2 = n2[2], o2 = r2[2], s2 = i2.length, c2 = a2.length, l2 = 0, u2 = 0;
  for (; l2 < s2 || u2 < c2; ) if (l2 === s2) a2[u2][1] && o2.push(a2[u2]), u2 += 1;
  else if (u2 === c2) i2[l2][1] && o2.push(i2[l2]), l2 += 1;
  else if (i2[l2][0] === a2[u2][0]) {
    let t5 = polynomial_add$2(i2[l2][1], a2[u2][1]);
    t5 && o2.push([i2[l2][0], t5]), l2 += 1, u2 += 1;
  } else i2[l2][0] < a2[u2][0] ? (i2[l2][1] && o2.push(i2[l2]), l2 += 1) : (a2[u2][1] && o2.push(a2[u2]), u2 += 1);
  return o2.length === 0 ? 0 : o2.length === 1 && o2[0][0] === 0 ? o2[0][1] : r2;
}
function polynomial_neg$2(t4) {
  if (t4[0] !== `polynomial`) return simplify$2([`-`, t4]);
  let n2 = [`polynomial`, t4[1], []], r2 = t4[2], i2 = n2[2], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2.push([r2[o2][0], polynomial_neg$2(r2[o2][1])]);
  return n2;
}
function polynomial_sub$2(t4, n2) {
  return polynomial_add$2(t4, polynomial_neg$2(n2));
}
function polynomial_mul$2(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify$2([`*`, t4, n2]);
    if (t4) {
      let r3 = [`polynomial`, n2[1], []], i3 = n2[2], a3 = r3[2];
      for (let n3 of i3) n3[1] && a3.push([n3[0], polynomial_mul$2(t4, n3[1])]);
      return r3;
    }
  } else if (n2 && n2[0] !== `polynomial`) {
    let r3 = [`polynomial`, t4[1], []], i3 = t4[2], a3 = r3[2];
    for (let t5 of i3) t5[1] && a3.push([t5[0], polynomial_mul$2(t5[1], n2)]);
    return r3;
  }
  let r2 = polynomials_in_same_leading_variable$2(t4, n2);
  t4 = r2[0], n2 = r2[1];
  let i2 = t4[2], a2 = n2[2], o2 = [`polynomial`, t4[1], []], s2 = o2[2], c2 = i2.length, l2 = a2.length, u2 = [];
  for (let t5 of i2) for (let n3 of a2) {
    let r3 = false, i3 = t5[0] + n3[0];
    for (let t6 of u2) if (i3 === t6) {
      r3 = true;
      break;
    }
    r3 || u2.push(i3);
  }
  u2.sort(function(t5, n3) {
    return t5 - n3;
  });
  for (let t5 of u2) {
    let n3 = 0, r3 = 0;
    for (; r3 < c2 && i2[r3][0] <= t5; ) {
      let o3 = 0;
      for (; o3 < l2 && a2[o3][0] <= t5; ) {
        if (i2[r3][0] + a2[o3][0] === t5) {
          n3 = polynomial_add$2(n3, polynomial_mul$2(i2[r3][1], a2[o3][1]));
          break;
        }
        o3 += 1;
      }
      r3 += 1;
    }
    n3 && s2.push([t5, n3]);
  }
  return o2;
}
function polynomial_pow$2(t4, n2) {
  if (isNaN(n2) || n2 < 0 || !Number.isInteger(n2)) return;
  let r2 = 1;
  for (; n2 > 0; ) n2 & 1 && (r2 = polynomial_mul$2(r2, t4)), t4 = polynomial_mul$2(t4, t4), n2 >>= 1;
  return r2;
}
function polynomial_to_expression$2(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = t4[1], r2 = t4[2], i2 = [], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) r2[o2][1] && (r2[o2][0] === 0 ? i2.push(polynomial_to_expression$2(r2[o2][1])) : r2[o2][0] === 1 ? i2.push([`*`, polynomial_to_expression$2(r2[o2][1]), n2]) : i2.push([`*`, polynomial_to_expression$2(r2[o2][1]), [`^`, n2, r2[o2][0]]]));
  return i2.length === 0 ? 0 : (i2.length === 1 ? i2 = i2[0] : i2.unshift(`+`), simplify$2(i2));
}
function initial_term$2(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = [];
  for (; Array.isArray(t4) && t4[0] === `polynomial`; ) {
    let r2 = t4[1], i2 = t4[2], a2 = i2[i2.length - 1][0];
    t4 = i2[i2.length - 1][1], n2.push([r2, a2]);
  }
  return [`monomial`, t4, n2];
}
function mono_less_than$2(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return false;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return true;
  let r2 = t4[2], i2 = n2[2], a2 = r2.length, o2 = i2.length;
  for (var s2 = a2 < o2 ? a2 : o2, c2 = 0; c2 < s2; c2++) {
    if (r2[c2][0] !== i2[c2][0]) return !(compare_function$2(r2[c2][0], i2[c2][0]) < 0);
    if (r2[c2][1] < i2[c2][1]) return true;
    if (r2[c2][1] > i2[c2][1]) return false;
  }
  return !(a2 === o2 || s2 === o2);
}
function mono_gcd$2(t4, n2) {
  if (!Array.isArray(t4) || !Array.isArray(n2) || t4[0] !== `monomial` || n2[0] !== `monomial`) return 1;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) r2[c2][0] === i2[l2][0] ? (r2[c2][1] < i2[l2][1] ? a2.push(r2[c2]) : a2.push(i2[l2]), c2 += 1, l2 += 1) : compare_function$2(r2[c2][0], i2[l2][0]) < 0 ? c2 += 1 : compare_function$2(i2[l2][0], r2[c2][0]) < 0 && (l2 += 1);
  return a2.length === 0 ? 1 : [`monomial`, 1, a2];
}
function mono_div$2(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return n2 === 1 ? t4 : !Array.isArray(t4) || t4[0] !== `monomial` ? evaluate_numbers$2([`/`, t4, n2]) : [t4[0], evaluate_numbers$2([`/`, t4[1], n2]), t4[2]];
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function$2(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function$2(i2[l2][0], r2[c2][0]) < 0) return;
  if (!(l2 < s2)) {
    for (; c2 < o2; ) a2.push(r2[c2]), c2 += 1;
    return a2.length === 0 ? n2[1] === 1 ? t4[1] : evaluate_numbers$2([`/`, t4[1], n2[1]]) : n2[1] === 1 ? [`monomial`, t4[1], a2] : [`monomial`, evaluate_numbers$2([`/`, t4[1], n2[1]]), a2];
  }
}
function mono_is_div$2(t4, n2) {
  if (n2 === 0) return false;
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return true;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return false;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return false;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function$2(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function$2(i2[l2][0], r2[c2][0]) < 0) return false;
  return !(l2 < s2);
}
function mono_to_poly$2(t4) {
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return t4;
  let n2 = t4[2].length - 1, r2 = t4[1];
  for (; n2 >= 0; ) {
    var i2 = [];
    i2.push([t4[2][n2][1], r2]), r2 = [`polynomial`, t4[2][n2][0], i2], --n2;
  }
  return r2;
}
function max_div_init$2(t4, n2) {
  if (t4 === 0) return 0;
  let r2 = t4, i2 = [];
  for (; Array.isArray(r2) && r2[0] === `polynomial`; ) {
    let t5 = r2[1], n3 = r2[2], a3 = n3[n3.length - 1][0];
    r2 = n3[n3.length - 1][1], i2.push([t5, a3]);
  }
  let a2 = [`monomial`, r2, i2], o2 = n2.length;
  for (var s2 = 0; s2 < o2; s2 += 1) if (mono_is_div$2(a2, n2[s2])) return [a2, s2];
  return max_div_init$2(polynomial_sub$2(t4, mono_to_poly$2(a2)), n2);
}
function poly_div$2(t4, n2) {
  let r2 = [], i2 = [], a2 = [], o2 = [], s2 = t4;
  for (var c2 of n2) r2.push(initial_term$2(c2));
  let l2 = max_div_init$2(s2, r2);
  for (; l2 !== 0; ) a2 = l2[1], o2 = mono_div$2(l2[0], r2[a2]), i2.push([a2, o2]), s2 = polynomial_sub$2(s2, polynomial_mul$2(mono_to_poly$2(o2), n2[a2])), l2 = max_div_init$2(s2, r2);
  return [i2, s2];
}
function prereduce$2(t4) {
  let n2 = t4.length, r2 = [];
  for (var i2 = 0; i2 < n2; i2++) {
    if (t4[i2] !== 0 && (!Array.isArray(t4[i2]) || t4[i2][0] !== `polynomial`)) return [1];
    t4[i2] !== 0 && r2.push(t4[i2]);
  }
  return r2.length === 0 ? [0] : r2;
}
function reduce_ith$2(t4, n2) {
  let r2 = [], a2 = [], o2 = [], s2 = n2[t4], c2 = n2.length;
  for (var l2 = 0; l2 < c2; l2 += 1) l2 === t4 ? r2.push(0) : r2.push(initial_term$2(n2[l2]));
  let u2 = max_div_init$2(s2, r2);
  for (; u2 !== 0; ) a2 = u2[1], o2 = mono_div$2(u2[0], r2[a2]), s2 = polynomial_sub$2(s2, polynomial_mul$2(mono_to_poly$2(o2), n2[a2])), u2 = max_div_init$2(s2, r2);
  return s2;
}
function reduce$3(t4) {
  let n2 = 0, r2 = [], i2 = prereduce$2(t4), a2 = i2.length;
  if (a2 === 1) return i2;
  let o2 = true;
  for (; o2; ) for (o2 = false, i2 = prereduce$2(i2), a2 = i2.length, n2 = 0; n2 < a2; ) r2 = reduce_ith$2(n2, i2), _$3.isEqual(r2, i2[n2]) || (i2[n2] = r2, o2 = true), n2 += 1;
  n2 = 0;
  let s2 = [], c2 = 0;
  for (; n2 < a2; ) s2 = initial_term$2(i2[n2]), !Array.isArray(s2) || s2[0] !== `monomial` ? i2[n2] = 1 : (c2 = s2[1], c2 !== 1 && (i2[n2] = polynomial_mul$2(i2[n2], [`/`, 1, c2]))), n2 += 1;
  return i2;
}
function hij$2(t4, n2, r2) {
  let i2 = initial_term$2(r2[t4]), a2 = initial_term$2(r2[n2]), o2 = mono_gcd$2(i2, a2), s2 = mono_to_poly$2(mono_div$2(i2, o2));
  return poly_div$2(polynomial_sub$2(polynomial_mul$2(mono_to_poly$2(mono_div$2(a2, o2)), r2[t4]), polynomial_mul$2(s2, r2[n2])), r2)[1];
}
function build_hij_table$2(t4, n2) {
  let r2 = n2.length, i2 = 0, a2 = 1, o2 = [];
  for (; a2 < r2; ) {
    for (; i2 < a2; ) t4[[i2, a2]] = hij$2(i2, a2, n2), t4[[i2, a2]] !== 0 && o2.push(t4[[i2, a2]]), i2 += 1;
    i2 = 0, a2 += 1;
  }
  return o2.length > 0 ? choice_lowest_degree$2(o2) : 0;
}
function update_hij_table$2(t4, n2, r2) {
  let i2 = n2.length;
  n2.push(r2);
  let a2 = 0, o2 = 1, s2 = [];
  for (; o2 < i2; ) {
    for (; a2 < o2; ) t4[[a2, o2]] !== 0 && (t4[[a2, o2]] = hij$2(a2, o2, n2), t4[[a2, o2]] !== 0 && s2.push(t4[[a2, o2]])), a2 += 1;
    a2 = 0, o2 += 1;
  }
  for (; a2 < i2; ) t4[[a2, i2]] = hij$2(a2, i2, n2), t4[[a2, i2]] !== 0 && s2.push(t4[[a2, i2]]), a2 += 1;
  return s2.length > 0 ? choice_lowest_degree$2(s2) : 0;
}
function choice_lowest_degree$2(t4) {
  let n2 = [], r2 = t4.length;
  for (a2 = 0; a2 < r2; a2 += 1) n2.push(initial_term$2(t4[a2]));
  let i2 = 0;
  for (var a2 = 1; a2 < r2; a2 += 1) {
    if (n2[a2] === 1) return 1;
    mono_less_than$2(n2[a2], n2[i2]) && (i2 = a2);
  }
  return t4[i2];
}
function reduced_grobner$2(t4) {
  let n2 = reduce$3(t4), r2 = {}, i2 = build_hij_table$2(r2, n2);
  for (; i2 !== 0; ) i2 = update_hij_table$2(r2, n2, i2);
  return n2 = reduce$3(n2), n2;
}
function poly_lcm$2(t4, n2) {
  let r2 = reduced_grobner$2([polynomial_mul$2([`polynomial`, `_t`, [[1, 1]]], t4), polynomial_mul$2([`polynomial`, `_t`, [[0, 1], [1, -1]]], n2)]), i2 = r2.length;
  for (var a2 = 0; a2 < i2; a2 += 1) {
    if (!Array.isArray(r2[a2]) || r2[a2][0] !== `polynomial`) return 1;
    if (r2[a2][1] !== `_t`) return r2[a2];
  }
}
function poly_gcd$2(t4, n2) {
  let r2 = poly_lcm$2(t4, n2), i2 = poly_div$2(polynomial_mul$2(t4, n2), [r2]), a2 = 0, o2 = i2[0].length;
  for (var s2 = 0; s2 < o2; s2 += 1) a2 = polynomial_add$2(a2, mono_to_poly$2(i2[0][s2][1]));
  let c2 = initial_term$2(a2);
  if (!Array.isArray(c2) || c2[0] !== `monomial`) a2 = 1;
  else {
    let t5 = c2[1];
    t5 !== 1 && (a2 = polynomial_mul$2(a2, [`/`, 1, t5]));
  }
  return a2;
}
function poly_by_divisor$2(t4, n2) {
  let r2 = poly_div$2(t4, [n2]), i2 = 0, a2 = r2[0].length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2 = polynomial_add$2(i2, mono_to_poly$2(r2[0][o2][1]));
  return i2;
}
function reduce_rational_expression$2(t4, n2) {
  let r2 = stringify_vars$2(t4), i2 = stringify_vars$2(n2);
  t4 = r2[0], n2 = i2[0];
  let a2 = poly_gcd$2(t4, n2), o2 = initial_term$2(n2)[1], s2 = polynomial_mul$2(a2, o2), c2 = poly_by_divisor$2(t4, s2), l2 = poly_by_divisor$2(n2, s2);
  return [destringify_vars$2(destringify_vars$2(c2, r2[1]), i2[1]), destringify_vars$2(destringify_vars$2(l2, r2[1]), i2[1])];
}
function stringify_vars$2(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return [t4, {}];
  let n2 = {}, r2 = `z` + JSON.stringify(t4[1]);
  n2[r2] = t4[1], t4[1] = r2;
  let i2 = t4[2], a2 = [];
  for (let t5 of i2) {
    a2 = stringify_vars$2(t5[1]), t5[1] = a2[0];
    for (let t6 in a2[1]) n2[t6] = a2[1][t6];
  }
  return [t4, n2];
}
function destringify_vars$2(t4, n2) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  n2[t4[1]] && (t4[1] = n2[t4[1]]);
  let r2 = t4[2];
  for (let t5 of r2) t5[1] = destringify_vars$2(t5[1], n2);
  return t4;
}
var rational_exports$2 = __exportAll$2({ common_denominator: () => common_denominator$2, reduce_rational: () => reduce_rational$2 }), textToAst$1$2 = new textToAst$4$2();
function common_denominator$2(t4, n2) {
  t4 = simplify$2(t4, n2);
  var r2 = [];
  return r2.push([textToAst$1$2.convert(`a/c+b/c`), textToAst$1$2.convert(`(a+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`a/c-b/c`), textToAst$1$2.convert(`(a-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`a+b/c`), textToAst$1$2.convert(`(ac+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`a-b/c`), textToAst$1$2.convert(`(ac-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`a/d+b/c`), textToAst$1$2.convert(`(ac+bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`a/d-b/c`), textToAst$1$2.convert(`(ac-bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`x*(y/z)`), textToAst$1$2.convert(`(x*y)/z`), { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$2.convert(`(x/y)/z`), textToAst$1$2.convert(`x/(y*z)`), { allow_extended_match: true, allow_permutations: true }]), r2.push([textToAst$1$2.convert(`x/(y/z)`), textToAst$1$2.convert(`xz/y`), { allow_extended_match: true, allow_permutations: true }]), t4 = applyAllTransformations$2(t4, r2, 40), t4 = expand$2(t4, true), t4;
}
function as_num_denom$2(t4) {
  var n2 = get_tree$2(t4);
  return n2 = common_denominator$2(n2), n2[0] === `/` ? [n2[1], n2[2]] : [n2, 1];
}
function reduce_rational$2(t4) {
  var n2 = get_tree$2(t4), r2 = as_num_denom$2(n2);
  if (r2[1] === 1) return n2;
  var i2 = reduce_rational_expression$2(expression_to_polynomial$2(r2[0]), expression_to_polynomial$2(r2[1])), a2 = polynomial_to_expression$2(i2[0]), o2 = polynomial_to_expression$2(i2[1]);
  return o2 === 1 ? a2 : [`/`, a2, o2];
}
var round_exports$2 = __exportAll$2({ round_numbers_to_decimals: () => round_numbers_to_decimals$2, round_numbers_to_precision: () => round_numbers_to_precision$2, round_numbers_to_precision_plus_decimals: () => round_numbers_to_precision_plus_decimals$2 });
function toFixed$4(t4, n2) {
  return mathjs_default$2.format(t4, { notation: `fixed`, precision: n2 });
}
function round_numbers_to_precision$2(t4, n2 = 14) {
  var r2 = get_tree$2(t4);
  if (n2 < 1) throw Error(`For round_numbers_to_precision, digits must be positive`);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_precision, digits must be a number`);
  return n2 > 15 ? r2 : (n2 = Math.round(n2), round_numbers_to_precision_sub$2(r2, n2));
}
var round_numbers_to_precision_sub$2 = function(t4, n2 = 14) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let r2 = n2 - mathjs_default$2.floor(mathjs_default$2.log10(mathjs_default$2.abs(t4))) - 1;
    return parseFloat(r2 < 0 ? toFixed$4(t4, r2) + `0`.repeat(mathjs_default$2.abs(r2)) : toFixed$4(t4, r2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_sub$2(t5, n2))] : t4;
};
function round_numbers_to_decimals$2(t4, n2 = 14) {
  var r2 = get_tree$2(t4);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_decimals, ndecimals must be a number`);
  return n2 = Math.round(n2), n2 = Math.max(-330, Math.min(330, n2)), round_numbers_to_decimals_sub$2(r2, n2);
}
var round_numbers_to_decimals_sub$2 = function(t4, n2 = 0) {
  return typeof t4 == `number` ? parseFloat(n2 < 0 ? toFixed$4(t4, n2) + `0`.repeat(mathjs_default$2.abs(n2)) : toFixed$4(t4, n2)) : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_decimals_sub$2(t5, n2))] : t4;
};
function round_numbers_to_precision_plus_decimals$2(t4, n2 = 4, r2 = 2) {
  var i2 = get_tree$2(t4);
  let a2 = true, o2 = true;
  if (n2 >= 1) {
    if (n2 = Math.round(n2), n2 > 15) return i2;
  } else a2 = false;
  return Number.isFinite(r2) ? (r2 = Math.round(r2), r2 = Math.max(-330, Math.min(330, r2))) : o2 = false, a2 ? o2 ? round_numbers_to_precision_plus_decimals_sub$2(i2, n2, r2) : round_numbers_to_precision_sub$2(i2, n2) : o2 ? round_numbers_to_decimals_sub$2(i2, r2) : i2;
}
var round_numbers_to_precision_plus_decimals_sub$2 = function(t4, n2 = 4, r2 = 2) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let i2 = mathjs_default$2.floor(mathjs_default$2.log10(mathjs_default$2.abs(t4))), a2 = Math.max(n2 - i2 - 1, r2);
    return parseFloat(a2 < 0 ? toFixed$4(t4, a2) + `0`.repeat(mathjs_default$2.abs(a2)) : toFixed$4(t4, a2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_plus_decimals_sub$2(t5, n2, r2))] : t4;
}, match_exports$2 = __exportAll$2({ match: () => match$3 }), match$3 = function(t4, n2, r2) {
  return match$1$2(get_tree$2(t4), get_tree$2(n2), r2);
}, expression_to_tree$1$2 = [simplify_exports$2, differentiation_exports$2, normalization_exports$2, arithmetic_exports$2, transformation_exports$2, solve_exports$2, sets_exports$2, matrix_exports$2, rational_exports$2, round_exports$2], expression_to_other$2 = [variables_exports$2, printing_exports$2, equality_exports$2, integration_exports$2, evaluation_exports$2, analytic_exports$2, sign_error_exports$2, match_exports$2], standard_exports$2 = __exportAll$2({ abs: () => abs$3, acos: () => acos$3, acosh: () => acosh$4, acot: () => acot$2, acoth: () => acoth$2, acsc: () => acsc$2, acsch: () => acsch$2, asec: () => asec$2, asech: () => asech$2, asin: () => asin$3, asinh: () => asinh$4, atan: () => atan$3, atan2: () => atan2$3, atanh: () => atanh$4, conj: () => conj$2, cos: () => cos$3, cosh: () => cosh$5, cot: () => cot$2, coth: () => coth$2, csc: () => csc$2, csch: () => csch$2, erf: () => erf$2, exp: () => exp$3, factorial: () => factorial$2, gamma: () => gamma$2, im: () => im$2, log: () => log$3, log10: () => log10$4, re: () => re$3, sec: () => sec$2, sech: () => sech$2, sign: () => sign$4, sin: () => sin$3, sinh: () => sinh$5, sqrt: () => sqrt$3, tan: () => tan$3, tanh: () => tanh$4 });
function abs$3(t4) {
  return [`apply`, `abs`, get_tree$2(t4)];
}
function exp$3(t4) {
  return [`apply`, `exp`, get_tree$2(t4)];
}
function log$3(t4) {
  return [`apply`, `log`, get_tree$2(t4)];
}
function log10$4(t4) {
  return [`apply`, `log10`, get_tree$2(t4)];
}
function sign$4(t4) {
  return [`apply`, `sign`, get_tree$2(t4)];
}
function sqrt$3(t4) {
  return [`apply`, `sqrt`, get_tree$2(t4)];
}
function conj$2(t4) {
  return [`apply`, `conj`, get_tree$2(t4)];
}
function im$2(t4) {
  return [`apply`, `im`, get_tree$2(t4)];
}
function re$3(t4) {
  return [`apply`, `re`, get_tree$2(t4)];
}
function factorial$2(t4) {
  return [`apply`, `factorial`, get_tree$2(t4)];
}
function gamma$2(t4) {
  return [`apply`, `gamma`, get_tree$2(t4)];
}
function erf$2(t4) {
  return [`apply`, `erf`, get_tree$2(t4)];
}
function acos$3(t4) {
  return [`apply`, `acos`, get_tree$2(t4)];
}
function acosh$4(t4) {
  return [`apply`, `acosh`, get_tree$2(t4)];
}
function acot$2(t4) {
  return [`apply`, `acot`, get_tree$2(t4)];
}
function acoth$2(t4) {
  return [`apply`, `acoth`, get_tree$2(t4)];
}
function acsc$2(t4) {
  return [`apply`, `acsc`, get_tree$2(t4)];
}
function acsch$2(t4) {
  return [`apply`, `acsch`, get_tree$2(t4)];
}
function asec$2(t4) {
  return [`apply`, `asec`, get_tree$2(t4)];
}
function asech$2(t4) {
  return [`apply`, `asech`, get_tree$2(t4)];
}
function asin$3(t4) {
  return [`apply`, `asin`, get_tree$2(t4)];
}
function asinh$4(t4) {
  return [`apply`, `asinh`, get_tree$2(t4)];
}
function atan$3(t4) {
  return [`apply`, `atan`, get_tree$2(t4)];
}
function atanh$4(t4) {
  return [`apply`, `atanh`, get_tree$2(t4)];
}
function cos$3(t4) {
  return [`apply`, `cos`, get_tree$2(t4)];
}
function cosh$5(t4) {
  return [`apply`, `cosh`, get_tree$2(t4)];
}
function cot$2(t4) {
  return [`apply`, `cot`, get_tree$2(t4)];
}
function coth$2(t4) {
  return [`apply`, `coth`, get_tree$2(t4)];
}
function csc$2(t4) {
  return [`apply`, `csc`, get_tree$2(t4)];
}
function csch$2(t4) {
  return [`apply`, `csch`, get_tree$2(t4)];
}
function sec$2(t4) {
  return [`apply`, `sec`, get_tree$2(t4)];
}
function sech$2(t4) {
  return [`apply`, `sech`, get_tree$2(t4)];
}
function sin$3(t4) {
  return [`apply`, `sin`, get_tree$2(t4)];
}
function sinh$5(t4) {
  return [`apply`, `sinh`, get_tree$2(t4)];
}
function tan$3(t4) {
  return [`apply`, `tan`, get_tree$2(t4)];
}
function tanh$4(t4) {
  return [`apply`, `tanh`, get_tree$2(t4)];
}
function atan2$3(t4, n2) {
  return [`apply`, `atan2`, [`tuple`, get_tree$2(t4), get_tree$2(n2)]];
}
var expression_to_tree$3 = [standard_exports$2], whitespace_rule$2 = `\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b`, number_rules_sci$3 = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`]], number_rules_non_sci$3 = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_latex_rules$2 = [[`\\*`, `*`], [`\\/`, `/`], [`-`, `-`], [`\\+`, `+`], [`\\\\pm(?![a-zA-Z])`, `PM`], [`\\^`, `^`], [`\\(`, `(`], [`\\\\left\\s*\\(`, `(`], [`\\\\bigl\\s*\\(`, `(`], [`\\\\Bigl\\s*\\(`, `(`], [`\\\\biggl\\s*\\(`, `(`], [`\\\\Biggl\\s*\\(`, `(`], [`\\)`, `)`], [`\\\\right\\s*\\)`, `)`], [`\\\\bigr\\s*\\)`, `)`], [`\\\\Bigr\\s*\\)`, `)`], [`\\\\biggr\\s*\\)`, `)`], [`\\\\Biggr\\s*\\)`, `)`], [`\\[`, `[`], [`\\\\left\\s*\\[`, `[`], [`\\\\bigl\\s*\\[`, `[`], [`\\\\Bigl\\s*\\[`, `[`], [`\\\\biggl\\s*\\[`, `[`], [`\\\\Biggl\\s*\\[`, `[`], [`\\]`, `]`], [`\\\\right\\s*\\]`, `]`], [`\\\\bigr\\s*\\]`, `]`], [`\\\\Bigr\\s*\\]`, `]`], [`\\\\biggr\\s*\\]`, `]`], [`\\\\Biggr\\s*\\]`, `]`], [`\\|`, `|`], [`\\\\left\\s*\\|`, `|L`], [`\\\\bigl\\s*\\|`, `|L`], [`\\\\Bigl\\s*\\|`, `|L`], [`\\\\biggl\\s*\\|`, `|L`], [`\\\\Biggl\\s*\\|`, `|L`], [`\\\\right\\s*\\|`, `|`], [`\\\\bigr\\s*\\|`, `|`], [`\\\\Bigr\\s*\\|`, `|`], [`\\\\biggr\\s*\\|`, `|`], [`\\\\Biggr\\s*\\|`, `|`], [`\\\\big\\s*\\|`, `|`], [`\\\\Big\\s*\\|`, `|`], [`\\\\bigg\\s*\\|`, `|`], [`\\\\Bigg\\s*\\|`, `|`], [`{`, `{`], [`}`, `}`], [`\\\\{`, `LBRACE`], [`\\\\left\\s*\\\\{`, `LBRACE`], [`\\\\bigl\\s*\\\\{`, `LBRACE`], [`\\\\Bigl\\s*\\\\{`, `LBRACE`], [`\\\\biggl\\s*\\\\{`, `LBRACE`], [`\\\\Biggl\\s*\\\\{`, `LBRACE`], [`\\\\}`, `RBRACE`], [`\\\\right\\s*\\\\}`, `RBRACE`], [`\\\\bigr\\s*\\\\}`, `RBRACE`], [`\\\\Bigr\\s*\\\\}`, `RBRACE`], [`\\\\biggr\\s*\\\\}`, `RBRACE`], [`\\\\Biggr\\s*\\\\}`, `RBRACE`], [`\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\left\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\right\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\left\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\right\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\left\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\right\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\cdot(?![a-zA-Z])`, `*`], [`\\\\div(?![a-zA-Z])`, `/`], [`\\\\times(?![a-zA-Z])`, `*`], [`,`, `,`], [`:`, `:`], [`\\\\mid(?![a-zA-Z])`, `MID`], [`\\\\varnothing(?![a-zA-Z])`, `LATEXCOMMAND`, `\\emptyset`], [`\\\\vartheta(?![a-zA-Z])`, `LATEXCOMMAND`, `\\theta`], [`\\\\varepsilon(?![a-zA-Z])`, `LATEXCOMMAND`, `\\epsilon`], [`\\\\varrho(?![a-zA-Z])`, `LATEXCOMMAND`, `\\rho`], [`\\\\varphi(?![a-zA-Z])`, `LATEXCOMMAND`, `\\phi`], [`\\\\infty(?![a-zA-Z])`, `INFINITY`], [`\\\\asin(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arcsin`], [`\\\\acos(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arccos`], [`\\\\atan(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arctan`], [`\\\\sqrt(?![a-zA-Z])`, `SQRT`], [`\\\\land(?![a-zA-Z])`, `AND`], [`\\\\wedge(?![a-zA-Z])`, `AND`], [`\\\\lor(?![a-zA-Z])`, `OR`], [`\\\\vee(?![a-zA-Z])`, `OR`], [`\\\\lnot(?![a-zA-Z])`, `NOT`], [`\\\\neg(?![a-zA-Z])`, `NOT`], [`=`, `=`], [`\\\\neq(?![a-zA-Z])`, `NE`], [`\\\\ne(?![a-zA-Z])`, `NE`], [`\\\\not\\s*=`, `NE`], [`\\\\leq(?![a-zA-Z])`, `LE`], [`\\\\le(?![a-zA-Z])`, `LE`], [`\\\\geq(?![a-zA-Z])`, `GE`], [`\\\\ge(?![a-zA-Z])`, `GE`], [`<`, `<`], [`\\\\lt(?![a-zA-Z])`, `<`], [`>`, `>`], [`\\\\gt(?![a-zA-Z])`, `>`], [`\\\\forall(?![a-zA-Z])`, `FORALL`], [`\\\\exists(?![a-zA-Z])`, `EXISTS`], [`\\\\in(?![a-zA-Z])`, `IN`], [`\\\\notin(?![a-zA-Z])`, `NOTIN`], [`\\\\not\\s*\\\\in(?![a-zA-Z])`, `NOTIN`], [`\\\\ni(?![a-zA-Z])`, `NI`], [`\\\\not\\s*\\\\ni(?![a-zA-Z])`, `NOTNI`], [`\\\\subset(?![a-zA-Z])`, `SUBSET`], [`\\\\subseteq(?![a-zA-Z])`, `SUBSETEQ`], [`\\\\not\\s*\\\\subset(?![a-zA-Z])`, `NOTSUBSET`], [`\\\\not\\s*\\\\subseteq(?![a-zA-Z])`, `NOTSUBSETEQ`], [`\\\\supset(?![a-zA-Z])`, `SUPERSET`], [`\\\\supseteq(?![a-zA-Z])`, `SUPERSETEQ`], [`\\\\not\\s*\\\\supset(?![a-zA-Z])`, `NOTSUPERSET`], [`\\\\not\\s*\\\\supseteq(?![a-zA-Z])`, `NOTSUPERSETEQ`], [`\\\\cup(?![a-zA-Z])`, `UNION`], [`\\\\cap(?![a-zA-Z])`, `INTERSECT`], [`\\\\to(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\rightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\longrightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\gets(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\longleftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\longleftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\implies(?![a-zA-Z])`, `IMPLIES`], [`\\\\Longrightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\Rightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\impliedby(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Longleftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Leftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\iff(?![a-zA-Z])`, `IFF`], [`\\\\Longleftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\Leftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\perp(?![a-zA-Z])`, `PERP`], [`\\\\bot(?![a-zA-Z])`, `PERP`], [`\\\\parallel(?![a-zA-Z])`, `PARALLEL`], [`\\\\\\|`, `PARALLEL`], [`\\\\angle(?![a-zA-Z])`, `ANGLE`], [`\\\\int(?![a-zA-Z])`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`&`, `&`], [`\\\\ldots(?![a-zA-Z])`, `LDOTS`], [`\\\\\\\\`, `LINEBREAK`], [`\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `BEGINENVIRONMENT`], [`\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `ENDENVIRONMENT`], [`\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}`, `VARMULTICHAR`], [`\\\\[a-zA-Z]+(?![a-zA-Z])`, `LATEXCOMMAND`], [`\\\\[$%]`, `LATEXCOMMAND`], [`[a-zA-Z＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault$3 = true, allowedLatexSymbolsDefault$3 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.angle.circ.%.$.emptyset`.split(`.`), appliedFunctionSymbolsDefault$3 = `abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.Re.Im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault$3 = [`f`, `g`], operatorSymbolsDefault$3 = { frac: { nargs: 2, substitute: `/` }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: `linesegment`, remove_products: true } }, unitsDefault$3 = get_all_units$2();
unitsDefault$3.circ = unitsDefault$3.deg, unitsDefault$3.circ.substitute = `deg`, unitsDefault$3.circ.isExponent = true, delete unitsDefault$3.deg;
var parseLeibnizNotationDefault$3 = true, latexToAst$1$2 = class latexToAst$12 {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault$3, allowedLatexSymbols: n2 = allowedLatexSymbolsDefault$3, appliedFunctionSymbols: r2 = appliedFunctionSymbolsDefault$3, functionSymbols: i2 = functionSymbolsDefault$3, operatorSymbols: a2 = operatorSymbolsDefault$3, units: o2 = unitsDefault$3, parseLeibnizNotation: s2 = parseLeibnizNotationDefault$3, parseScientificNotation: c2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.allowedLatexSymbols = n2, this.appliedFunctionSymbols = r2, this.functionSymbols = i2, this.operatorSymbols = a2, this.units = o2, this.parseLeibnizNotation = s2;
    let l2 = base_latex_rules$2;
    l2 = c2 ? [...number_rules_sci$3, ...l2] : [...number_rules_non_sci$3, ...l2], this.lexer = new lexer$2(l2, whitespace_rule$2);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError$2(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError$2(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten$8(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      if (this.token.token_type !== `:` && this.token.token_type !== `MID`) return r2;
      let i2 = this.token.token_type === `:` ? `:` : `|`;
      return this.advance(), [i2, r2, this.statement_a()];
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type[0] !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten$8(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let t5 = r2.length;
      for (let [n3, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && n3 < t5 - 1) {
            let o2;
            o2 = n3 === t5 - 2 ? r2[t5 - 1] : this.convert_units_in_term([`*`, ...r2.slice(n3 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return n3 === 0 ? c2 : [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this)), c2];
          } else if (!a2.prefix && n3 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = n3 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this))], o2], n3 === t5 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(n3 + 1)]);
          }
        }
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    else if (n2 === `^`) {
      let t5 = this.units[r2[1]];
      if (t5 && t5.isExponent) {
        let n3 = r2[1];
        return t5.substitute && (n3 = t5.substitute), [`unit`, r2[0], n3];
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    }
    return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_single_digit_as_number() {
    if (this.token.token_type === `NUMBER` && this.token.token_text[0] !== `.`) {
      let t4 = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), t4;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    let n2 = this.get_single_digit_as_number();
    if (n2 !== null) return n2;
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n3 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n3 === false && (n3 = `＿`), n3;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `BEGINENVIRONMENT`) {
      let t5 = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if ([`matrix`, `pmatrix`, `bmatrix`].includes(t5)) {
        let r3 = 0, i3 = 0, o2 = [], s2 = [], c2 = 0, l2 = this.token.token_type;
        for (this.advance(); this.token.token_type !== `ENDENVIRONMENT`; ) this.token.token_type === `&` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), l2 = this.token.token_type, this.advance()) : this.token.token_type === `LINEBREAK` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, c2 = 0, s2 = [], l2 = this.token.token_type, this.advance()) : (s2.push(this.statement({ parse_absolute_value: n2 })), c2 += 1, l2 = ` `);
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== t5) throw new ParseError$2(`Expecting \\end{` + t5 + `}`, this.lexer.location);
        l2 === `&` && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, this.advance(), a2 = [`matrix`, [`tuple`, r3, i3]];
        let u2 = [`tuple`];
        for (let t6 of o2) {
          let n3 = [`tuple`].concat(t6);
          for (let r4 = t6.length; r4 < i3; r4 += 1) n3.push(0);
          u2.push(n3);
        }
        return a2.push(u2), a2;
      } else throw new ParseError$2(`Unrecognized environment ` + t5, this.lexer.location);
    }
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `SQRT`) {
      this.advance();
      let t5 = 2;
      if (this.token.token_type === `[`) {
        this.advance();
        let r4 = this.statement({ parse_absolute_value: n2 });
        if (this.token.token_type !== `]`) throw new ParseError$2(`Expecting ]`, this.lexer.location);
        this.advance(), t5 = r4;
      }
      if (this.token.token_type !== `{`) throw new ParseError$2(`Expecting {`, this.lexer.location);
      this.advance();
      let r3 = this.statement({ parse_absolute_value: n2 });
      if (this.token.token_type !== `}`) throw new ParseError$2(`Expecting }`, this.lexer.location);
      this.advance(), a2 = t5 === 2 ? [`apply`, `sqrt`, r3] : t5 === 3 ? [`apply`, `cbrt`, r3] : [`apply`, `nthroot`, [`tuple`, r3, t5]];
    } else if (this.token.token_type === `VAR` || this.token.token_type === `LATEXCOMMAND` || this.token.token_type === `VARMULTICHAR`) {
      if (a2 = this.token.token_text, this.token.token_type === `LATEXCOMMAND`) {
        if (a2 = a2.slice(1), !(this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2) || this.allowedLatexSymbols.includes(a2) || a2 in this.operatorSymbols)) throw new ParseError$2(`Unrecognized latex command ` + this.token.original_text, this.lexer.location);
      } else this.token.token_type === `VARMULTICHAR` && (a2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(a2)[1]);
      if (this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
        let t5 = false;
        if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), [`Re`, `Im`].includes(a2) && (a2 = a2.toLowerCase()), this.advance(), this.token.token_type === `_`) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
        }
        if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
        else {
          for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
          for (; this.token.token_type === `^`; ) {
            this.advance();
            let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
            a2 = [`^`, a2, t6];
          }
          if (this.token.token_type === `{` || this.token.token_type === `(`) {
            let t6;
            t6 = this.token.token_type === `{` ? `}` : `)`, this.advance();
            let n3 = this.statement_list();
            if (this.token.token_type !== t6) throw new ParseError$2(`Expecting ` + t6, this.lexer.location);
            this.advance(), n3[0] === `list` && (n3[0] = `tuple`), a2 = [`apply`, a2, n3];
          } else if (t5) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError$2(`Expecting ( after function`, this.lexer.location);
            let t6 = this.factor({ parse_absolute_value: n2 });
            t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
          }
        }
        return a2;
      } else if (a2 in this.operatorSymbols) {
        if (this.advance(), a2 === `frac` && this.parseLeibnizNotation) {
          let t6 = this.return_state(), n3 = this.leibniz_notation();
          if (n3) return n3;
          this.set_state(t6);
        }
        let t5 = a2;
        this.operatorSymbols[a2].substitute && (t5 = this.operatorSymbols[a2].substitute);
        let r3 = this.operatorSymbols[a2].nargs, i3 = this.operatorSymbols[a2].remove_products, o2 = [];
        for (let t6 = 0; t6 < r3; t6++) if (this.token.token_type === `{`) {
          this.advance();
          let t7 = this.statement({ parse_absolute_value: n2 });
          if (i3 && Array.isArray(t7) && t7[0] === `*` ? o2.push(...t7.slice(1)) : o2.push(t7), this.token.token_type !== `}`) throw new ParseError$2(`Expecting }`, this.lexer.location);
          this.advance();
        } else {
          let t7 = this.get_single_digit_as_number();
          if (t7 === null) if (this.token.token_type === `VAR`) t7 = this.token.token_text, this.advance();
          else throw new ParseError$2(`Expecting {`, this.lexer.location);
          o2.push(t7);
        }
        a2 = [t5, ...o2];
      } else this.advance();
    } else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LBRACE` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : this.token.token_type === `LBRACE` ? (n3 = `RBRACE`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError$2(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError$2(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` || t5 === `{` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `LBRACE` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `LBRACE` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type[0] === `|` && n2 && (t4 === 0 || !r2 || this.token.token_type[1] === `L`)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError$2(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `LFLOOR` || this.token.token_type === `LCEIL`) {
      let t5, n3;
      if (this.token.token_type === `LFLOOR` ? (t5 = `RFLOOR`, n3 = `floor`) : this.token.token_type === `LCEIL` && (t5 = `RCEIL`, n3 = `ceil`), this.advance(), a2 = this.statement(), a2 = [`apply`, n3, a2], this.token.token_type !== t5) throw new ParseError$2(`Expecting ` + t5, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `{` || this.token.token_type === `(`) {
      let t5;
      t5 = this.token.token_type === `{` ? `}` : `)`, this.advance();
      let n3 = this.statement_list();
      if (this.token.token_type !== t5) throw new ParseError$2(`Expecting ` + t5, this.lexer.location);
      this.advance(), n3[0] === `list` ? a2 = [`angle`, ...n3.slice(1)] : n3[0] === `*` && (a2 = [`angle`, n3]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten$8(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    if (this.token.token_type !== `{`) return false;
    this.advance();
    var t4 = this.token.token_text;
    let n2 = ``, r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (this.token.token_type === `LATEXCOMMAND` && t4.slice(1) === `partial`) n2 = `∂`;
    else if (this.token.token_type === `VAR` && t4 === `d`) n2 = `d`;
    else return false;
    if (this.advance(), this.token.token_type === `^`) {
      this.advance();
      let t5 = false;
      if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
      this.advance();
    }
    if (this.token.token_type === `VAR`) i2 = this.token.token_text;
    else if (this.token.token_type === `VARMULTICHAR`) i2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if (this.token.token_type === `LATEXCOMMAND`) if (t4 = this.token.token_text.slice(1), this.allowedLatexSymbols.includes(t4)) i2 = t4;
    else return false;
    if (this.advance(), this.token.token_type !== `}` || (this.advance(), this.token.token_type !== `{`)) return false;
    this.advance();
    let s2 = 0;
    for (; ; ) {
      if (!(n2 === `d` && this.token.token_type === `VAR` && this.token.token_text === `d` || n2 === `∂` && this.token.token_type === `LATEXCOMMAND` && this.token.token_text.slice(1) === `partial`)) return false;
      if (this.advance(), this.token.token_type === `VAR`) a2.push(this.token.token_text);
      else if (this.token.token_type === `VARMULTICHAR`) a2.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else if (this.token.token_type === `LATEXCOMMAND`) {
        let t5 = this.token.token_text.slice(1);
        if (this.allowedLatexSymbols.includes(t5)) a2.push(t5);
        else return false;
      } else return false;
      let c2 = 1;
      if (this.advance(), this.token.token_type === `^`) {
        this.advance();
        let t5 = false;
        if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (c2 = parseFloat(this.token.token_text), !Number.isInteger(c2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
        this.advance();
      }
      if (o2.push(c2), s2 += c2, s2 > r2) return false;
      if (s2 === r2) {
        if (this.token.token_type !== `}`) return false;
        this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, latexToGuppy$2 = class latexToGuppy2 {
  constructor() {
    this.latexToAst = new latexToAst$1$2(), this.astToGuppy = new astToGuppy$1$2();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(t4));
  }
}, latexToMathjs$2 = class latexToMathjs2 {
  constructor() {
    this.latexToAst = new latexToAst$1$2(), this.astToMathjs = new astToMathjs$2$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(t4));
  }
}, latexToText$2 = class latexToText2 {
  constructor() {
    this.latexToAst = new latexToAst$1$2(), this.astToText = new astToText$2$2();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(t4));
  }
}, mathjsToGuppy$2 = class mathjsToGuppy2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$2(), this.astToGuppy = new astToGuppy$1$2();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToLatex$2 = class mathjsToLatex2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$2(), this.astToLatex = new astToLatex$1$2();
  }
  convert(t4) {
    return this.astToLatex.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToText$2 = class mathjsToText2 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$2(), this.astToText = new astToText$2$2();
  }
  convert(t4) {
    return this.astToText.convert(this.mathjsToAst.convert(t4));
  }
}, require_ms$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = 1e3, i2 = r2 * 60, a2 = i2 * 60, o2 = a2 * 24, s2 = o2 * 365.25;
  n2.exports = function(t5, n3) {
    n3 ||= {};
    var r3 = typeof t5;
    if (r3 === `string` && t5.length > 0) return c2(t5);
    if (r3 === `number` && isNaN(t5) === false) return n3.long ? u2(t5) : l2(t5);
    throw Error(`val is not a non-empty string or a valid number. val=` + JSON.stringify(t5));
  };
  function c2(t5) {
    if (t5 = String(t5), !(t5.length > 100)) {
      var n3 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t5);
      if (n3) {
        var c3 = parseFloat(n3[1]);
        switch ((n3[2] || `ms`).toLowerCase()) {
          case `years`:
          case `year`:
          case `yrs`:
          case `yr`:
          case `y`:
            return c3 * s2;
          case `days`:
          case `day`:
          case `d`:
            return c3 * o2;
          case `hours`:
          case `hour`:
          case `hrs`:
          case `hr`:
          case `h`:
            return c3 * a2;
          case `minutes`:
          case `minute`:
          case `mins`:
          case `min`:
          case `m`:
            return c3 * i2;
          case `seconds`:
          case `second`:
          case `secs`:
          case `sec`:
          case `s`:
            return c3 * r2;
          case `milliseconds`:
          case `millisecond`:
          case `msecs`:
          case `msec`:
          case `ms`:
            return c3;
          default:
            return;
        }
      }
    }
  }
  function l2(t5) {
    return t5 >= o2 ? Math.round(t5 / o2) + `d` : t5 >= a2 ? Math.round(t5 / a2) + `h` : t5 >= i2 ? Math.round(t5 / i2) + `m` : t5 >= r2 ? Math.round(t5 / r2) + `s` : t5 + `ms`;
  }
  function u2(t5) {
    return d2(t5, o2, `day`) || d2(t5, a2, `hour`) || d2(t5, i2, `minute`) || d2(t5, r2, `second`) || t5 + ` ms`;
  }
  function d2(t5, n3, r3) {
    if (!(t5 < n3)) return t5 < n3 * 1.5 ? Math.floor(t5 / n3) + ` ` + r3 : Math.ceil(t5 / n3) + ` ` + r3 + `s`;
  }
})), require_debug$2 = __commonJSMin$2(((t4, n2) => {
  t4 = n2.exports = a2.debug = a2.default = a2, t4.coerce = l2, t4.disable = s2, t4.enable = o2, t4.enabled = c2, t4.humanize = require_ms$2(), t4.names = [], t4.skips = [], t4.formatters = {};
  var r2;
  function i2(n3) {
    var r3 = 0, i3;
    for (i3 in n3) r3 = (r3 << 5) - r3 + n3.charCodeAt(i3), r3 |= 0;
    return t4.colors[Math.abs(r3) % t4.colors.length];
  }
  function a2(n3) {
    function a3() {
      if (a3.enabled) {
        var n4 = a3, i3 = +/* @__PURE__ */ new Date();
        n4.diff = i3 - (r2 || i3), n4.prev = r2, n4.curr = i3, r2 = i3;
        for (var o3 = Array(arguments.length), s3 = 0; s3 < o3.length; s3++) o3[s3] = arguments[s3];
        o3[0] = t4.coerce(o3[0]), typeof o3[0] != `string` && o3.unshift(`%O`);
        var c3 = 0;
        o3[0] = o3[0].replace(/%([a-zA-Z%])/g, function(r3, i4) {
          if (r3 === `%%`) return r3;
          c3++;
          var a4 = t4.formatters[i4];
          if (typeof a4 == `function`) {
            var s4 = o3[c3];
            r3 = a4.call(n4, s4), o3.splice(c3, 1), c3--;
          }
          return r3;
        }), t4.formatArgs.call(n4, o3), (a3.log || t4.log || console.log.bind(console)).apply(n4, o3);
      }
    }
    return a3.namespace = n3, a3.enabled = t4.enabled(n3), a3.useColors = t4.useColors(), a3.color = i2(n3), typeof t4.init == `function` && t4.init(a3), a3;
  }
  function o2(n3) {
    t4.save(n3), t4.names = [], t4.skips = [];
    for (var r3 = (typeof n3 == `string` ? n3 : ``).split(/[\s,]+/), i3 = r3.length, a3 = 0; a3 < i3; a3++) r3[a3] && (n3 = r3[a3].replace(/\*/g, `.*?`), n3[0] === `-` ? t4.skips.push(RegExp(`^` + n3.substr(1) + `$`)) : t4.names.push(RegExp(`^` + n3 + `$`)));
  }
  function s2() {
    t4.enable(``);
  }
  function c2(n3) {
    var r3, i3;
    for (r3 = 0, i3 = t4.skips.length; r3 < i3; r3++) if (t4.skips[r3].test(n3)) return false;
    for (r3 = 0, i3 = t4.names.length; r3 < i3; r3++) if (t4.names[r3].test(n3)) return true;
    return false;
  }
  function l2(t5) {
    return t5 instanceof Error ? t5.stack || t5.message : t5;
  }
})), require_browser$2 = __commonJSMin$2(((t4, n2) => {
  t4 = n2.exports = require_debug$2(), t4.log = a2, t4.formatArgs = i2, t4.save = o2, t4.load = s2, t4.useColors = r2, t4.storage = typeof chrome < `u` && chrome.storage !== void 0 ? chrome.storage.local : c2(), t4.colors = [`lightseagreen`, `forestgreen`, `goldenrod`, `dodgerblue`, `darkorchid`, `crimson`];
  function r2() {
    return typeof window < `u` && window.process && window.process.type === `renderer` ? true : typeof document < `u` && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < `u` && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  t4.formatters.j = function(t5) {
    try {
      return JSON.stringify(t5);
    } catch (t6) {
      return `[UnexpectedJSONParseError]: ` + t6.message;
    }
  };
  function i2(n3) {
    var r3 = this.useColors;
    if (n3[0] = (r3 ? `%c` : ``) + this.namespace + (r3 ? ` %c` : ` `) + n3[0] + (r3 ? `%c ` : ` `) + `+` + t4.humanize(this.diff), r3) {
      var i3 = `color: ` + this.color;
      n3.splice(1, 0, i3, `color: inherit`);
      var a3 = 0, o3 = 0;
      n3[0].replace(/%[a-zA-Z%]/g, function(t5) {
        t5 !== `%%` && (a3++, t5 === `%c` && (o3 = a3));
      }), n3.splice(o3, 0, i3);
    }
  }
  function a2() {
    return typeof console == `object` && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function o2(n3) {
    try {
      n3 == null ? t4.storage.removeItem(`debug`) : t4.storage.debug = n3;
    } catch {
    }
  }
  function s2() {
    var n3;
    try {
      n3 = t4.storage.debug;
    } catch {
    }
    return !n3 && typeof process < `u` && `env` in process && (n3 = process.env.DEBUG), n3;
  }
  t4.enable(s2());
  function c2() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})), require_xml_parser$2 = __commonJSMin$2(((t4, n2) => {
  var r2 = require_browser$2()(`xml-parser`);
  n2.exports = i2;
  function i2(t5) {
    return t5 = t5.trim(), t5 = t5.replace(/<!--[\s\S]*?-->/g, ``), n3();
    function n3() {
      return { declaration: i3(), root: a2() };
    }
    function i3() {
      if (l2(/^<\?xml\s*/)) {
        for (var t6 = { attributes: {} }; !(u2() || d2(`?>`)); ) {
          var n4 = s2();
          if (!n4) return t6;
          t6.attributes[n4.name] = n4.value;
        }
        return l2(/\?>\s*/), t6;
      }
    }
    function a2() {
      r2(`tag %j`, t5);
      var n4 = l2(/^<([\w-:.]+)\s*/);
      if (n4) {
        for (var i4 = { name: n4[1], attributes: {}, children: [] }; !(u2() || d2(`>`) || d2(`?>`) || d2(`/>`)); ) {
          var c3 = s2();
          if (!c3) return i4;
          i4.attributes[c3.name] = c3.value;
        }
        if (l2(/^\s*\/>\s*/)) return i4;
        l2(/\??>\s*/), i4.content = o2();
        for (var p2; p2 = a2(); ) i4.children.push(p2);
        return l2(/^<\/[\w-:.]+>\s*/), i4;
      }
    }
    function o2() {
      r2(`content %j`, t5);
      var n4 = l2(/^([^<]*)/);
      return n4 ? n4[1] : ``;
    }
    function s2() {
      r2(`attribute %j`, t5);
      var n4 = l2(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (n4) return { name: n4[1], value: c2(n4[2]) };
    }
    function c2(t6) {
      return t6.replace(/^['"]|['"]$/g, ``);
    }
    function l2(n4) {
      var r3 = t5.match(n4);
      if (r3) return t5 = t5.slice(r3[0].length), r3;
    }
    function u2() {
      return t5.length == 0;
    }
    function d2(n4) {
      return t5.indexOf(n4) == 0;
    }
  }
})), import_xml_parser$2 = __toESM$2(require_xml_parser$2()), entities$2 = { "&#913;": `\\Alpha`, "&Alpha;": `\\Alpha`, "&#x0391;": `\\Alpha`, "\\u0391;": `\\Alpha`, "&#914;": `\\Beta`, "&Beta;": `\\Beta`, "&#x0392;": `\\Beta`, "\\u0392;": `\\Beta`, "&#915;": `\\Gamma`, "&Gamma;": `\\Gamma`, "&#x0393;": `\\Gamma`, "\\u0393;": `\\Gamma`, "&#916;": `\\Delta`, "&Delta;": `\\Delta`, "&#x0394;": `\\Delta`, "\\u0394;": `\\Delta`, "&#917;": `\\Epsilon`, "&Epsilon;": `\\Epsilon`, "&#x0395;": `\\Epsilon`, "\\u0395;": `\\Epsilon`, "&#918;": `\\Zeta`, "&Zeta;": `\\Zeta`, "&#x0396;": `\\Zeta`, "\\u0396;": `\\Zeta`, "&#919;": `\\Eta`, "&Eta;": `\\Eta`, "&#x0397;": `\\Eta`, "\\u0397;": `\\Eta`, "&#920;": `\\Theta`, "&Theta;": `\\Theta`, "&#x0398;": `\\Theta`, "\\u0398;": `\\Theta`, "&#921;": `\\Iota`, "&Iota;": `\\Iota`, "&#x0399;": `\\Iota`, "\\u0399;": `\\Iota`, "&#922;": `\\Kappa`, "&Kappa;": `\\Kappa`, "&#x039A;": `\\Kappa`, "\\u039A;": `\\Kappa`, "&#923;": `\\Lambda`, "&Lambda;": `\\Lambda`, "&#x039B;": `\\Lambda`, "\\u039B;": `\\Lambda`, "&#924;": `\\Mu`, "&Mu;": `\\Mu`, "&#x039C;": `\\Mu`, "\\u039C;": `\\Mu`, "&#925;": `\\Nu`, "&Nu;": `\\Nu`, "&#x039D;": `\\Nu`, "\\u039D;": `\\Nu`, "&#926;": `\\Xi`, "&Xi;": `\\Xi`, "&#x039E;": `\\Xi`, "\\u039E;": `\\Xi`, "&#927;": `\\Omicron`, "&Omicron;": `\\Omicron`, "&#x039F;": `\\Omicron`, "\\u039F;": `\\Omicron`, "&#928;": `\\Pi`, "&Pi;": `\\Pi`, "&#x03A0;": `\\Pi`, "\\u03A0;": `\\Pi`, "&#929;": `\\Rho`, "&Rho;": `\\Rho`, "&#x03A1;": `\\Rho`, "\\u03A1;": `\\Rho`, "&#931;": `\\Sigma`, "&Sigma;": `\\Sigma`, "&#x03A3;": `\\Sigma`, "\\u03A3;": `\\Sigma`, "&#932;": `\\Tau`, "&Tau;": `\\Tau`, "&#x03A4;": `\\Tau`, "\\u03A4;": `\\Tau`, "&#933;": `\\Upsilon`, "&Upsilon;": `\\Upsilon`, "&#x03A5;": `\\Upsilon`, "\\u03A5;": `\\Upsilon`, "&#934;": `\\Phi`, "&Phi;": `\\Phi`, "&#x03A6;": `\\Phi`, "\\u03A6;": `\\Phi`, "&#935;": `\\Chi`, "&Chi;": `\\Chi`, "&#x03A7;": `\\Chi`, "\\u03A7;": `\\Chi`, "&#936;": `\\Psi`, "&Psi;": `\\Psi`, "&#x03A8;": `\\Psi`, "\\u03A8;": `\\Psi`, "&#937;": `\\Omega`, "&Omega;": `\\Omega`, "&#x03A9;": `\\Omega`, "\\u03A9;": `\\Omega`, "&#945;": `\\alpha`, "&alpha;": `\\alpha`, "&#x03B1;": `\\alpha`, "\\u03B1;": `\\alpha`, "&#946;": `\\beta`, "&beta;": `\\beta`, "&#x03B2;": `\\beta`, "\\u03B2;": `\\beta`, "&#947;": `\\gamma`, "&gamma;": `\\gamma`, "&#x03B3;": `\\gamma`, "\\u03B3;": `\\gamma`, "&#948;": `\\delta`, "&delta;": `\\delta`, "&#x03B4;": `\\delta`, "\\u03B4;": `\\delta`, "&#949;": `\\epsilon`, "&epsilon;": `\\epsilon`, "&#x03B5;": `\\epsilon`, "\\u03B5;": `\\epsilon`, "&#950;": `\\zeta`, "&zeta;": `\\zeta`, "&#x03B6;": `\\zeta`, "\\u03B6;": `\\zeta`, "&#951;": `\\eta`, "&eta;": `\\eta`, "&#x03B7;": `\\eta`, "\\u03B7;": `\\eta`, "&#952;": `\\theta`, "&theta;": `\\theta`, "&#x03B8;": `\\theta`, "\\u03B8;": `\\theta`, "&#953;": `\\iota`, "&iota;": `\\iota`, "&#x03B9;": `\\iota`, "\\u03B9;": `\\iota`, "&#954;": `\\kappa`, "&kappa;": `\\kappa`, "&#x03BA;": `\\kappa`, "\\u03BA;": `\\kappa`, "&#955;": `\\lambda`, "&lambda;": `\\lambda`, "&#x03BB;": `\\lambda`, "\\u03BB;": `\\lambda`, "&#956;": `\\mu`, "&mu;": `\\mu`, "&#x03BC;": `\\mu`, "\\u03BC;": `\\mu`, "&#957;": `\\nu`, "&nu;": `\\nu`, "&#x03BD;": `\\nu`, "\\u03BD;": `\\nu`, "&#958;": `\\xi`, "&xi;": `\\xi`, "&#x03BE;": `\\xi`, "\\u03BE;": `\\xi`, "&#959;": `\\omicron`, "&omicron;": `\\omicron`, "&#x03BF;": `\\omicron`, "\\u03BF;": `\\omicron`, "&#960;": `\\pi`, "&pi;": `\\pi`, "&#x03C0;": `\\pi`, "\\u03C0;": `\\pi`, "&#961;": `\\rho`, "&rho;": `\\rho`, "&#x03C1;": `\\rho`, "\\u03C1;": `\\rho`, "&#962;": `\\sigma`, ";": `\\sigma`, "&#x03C2;": `\\sigma`, "\\u03C2;": `\\sigma`, "&#963;": `\\sigma`, "&sigma;": `\\sigma`, "&#x03C3;": `\\sigma`, "\\u03C3;": `\\sigma`, "&#964;": `\\tau`, "&tau;": `\\tau`, "&#x03C4;": `\\tau`, "\\u03C4;": `\\tau`, "&#965;": `\\upsilon`, "&upsilon;": `\\upsilon`, "&#x03C5;": `\\upsilon`, "\\u03C5;": `\\upsilon`, "&#966;": `\\phi`, "&phi;": `\\phi`, "&#x03C6;": `\\phi`, "\\u03C6;": `\\phi`, "&#967;": `\\chi`, "&chi;": `\\chi`, "&#x03C7;": `\\chi`, "\\u03C7;": `\\chi`, "&#968;": `\\psi`, "&psi;": `\\psi`, "&#x03C8;": `\\psi`, "\\u03C8;": `\\psi`, "&#969;": `\\omega`, "&omega;": `\\omega`, "&#x03C9;": `\\omega`, "\\u03C9;": `\\omega`, "&#x2212;": `-`, "&minus;": `-`, "&#x221E;": `\\infty`, "&#8734;": `\\infty`, "&infin;": `\\infty`, "&sdot;": `\\cdot`, "&#x22C5;": `\\cdot`, "&#8901;": `\\cdot`, "&times;": `\\times`, "&#x00D7;": `\\times`, "&#215;": `\\times` }, mmlToLatex$2 = class mmlToLatex2 {
  parse(t4) {
    if (t4.name === `mi`) return entities$2[t4.content] ? entities$2[t4.content] : t4.content.length > 1 ? `\\` + t4.content : t4.content;
    if (t4.name === `mn`) return t4.content;
    if (t4.name === `msup`) return this.parse(t4.children[0]) + `^{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mroot`) return `\\sqrt[` + this.parse(t4.children[1]) + `]{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mfrac`) return `\\frac{` + this.parse(t4.children[0]) + `}{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `msqrt`) return `\\sqrt{` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `}`;
    if (t4.name === `mo`) return entities$2[t4.content] ? entities$2[t4.content] : t4.content === `&#x2061;` ? ` ` : t4.content;
    if (t4.name === `mrow` && t4.attributes.class === `MJX-TeXAtom-ORD`) return t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `);
    if (t4.name === `math` || t4.name === `mrow`) return `(` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `)`;
  }
  convert(t4) {
    return this.parse((0, import_xml_parser$2.default)(t4).root);
  }
}, mmlToAst$1$2 = class mmlToAst$12 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$2(), this.latexToAst = new latexToAst$1$2();
  }
  convert(t4) {
    return this.latexToAst.convert(this.mmlToLatex.convert(t4));
  }
}, mmlToGuppy$2 = class mmlToGuppy2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$2(), this.latexToAst = new latexToAst$1$2(), this.astToGuppy = new astToGuppy$1$2();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToMathjs$2 = class mmlToMathjs2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$2(), this.latexToAst = new latexToAst$1$2(), this.astToMathjs = new astToMathjs$2$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToText$2 = class mmlToText2 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$2(), this.latexToAst = new latexToAst$1$2(), this.astToText = new astToText$2$2();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, textToGuppy$2 = class textToGuppy2 {
  constructor() {
    this.textToAst = new textToAst$4$2(), this.astToGuppy = new astToGuppy$1$2();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.textToAst.convert(t4));
  }
}, textToLatex$2 = class textToLatex2 {
  constructor() {
    this.textToAst = new textToAst$4$2(), this.astToLatex = new astToLatex$1$2();
  }
  convert(t4) {
    return this.astToLatex.convert(this.textToAst.convert(t4));
  }
}, textToMathjs$2 = class textToMathjs2 {
  constructor() {
    this.textToAst = new textToAst$4$2(), this.astToMathjs = new astToMathjs$2$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.textToAst.convert(t4));
  }
}, converters_exports$2 = __exportAll$2({ astToFiniteFieldObj: () => astToFiniteField$1$2, astToGLSL: () => astToGLSL$1$2, astToGuppyObj: () => astToGuppy$1$2, astToLatexObj: () => astToLatex$1$2, astToMathjsObj: () => astToMathjs$2$2, astToTextObj: () => astToText$2$2, latexToAstObj: () => latexToAst$1$2, latexToGuppyObj: () => latexToGuppy$2, latexToMathjsObj: () => latexToMathjs$2, latexToTextObj: () => latexToText$2, mathjsToAstObj: () => mathjsToAst$1$2, mathjsToGuppyObj: () => mathjsToGuppy$2, mathjsToLatexObj: () => mathjsToLatex$2, mathjsToTextObj: () => mathjsToText$2, mmlToAstObj: () => mmlToAst$1$2, mmlToGuppyObj: () => mmlToGuppy$2, mmlToLatexObj: () => mmlToLatex$2, mmlToMathjsObj: () => mmlToMathjs$2, mmlToTextObj: () => mmlToText$2, textToAstObj: () => textToAst$4$2, textToGuppyObj: () => textToGuppy$2, textToLatexObj: () => textToLatex$2, textToMathjsObj: () => textToMathjs$2 }), textToAst$6 = new textToAst$4$2(), latexToAst$3 = new latexToAst$1$2(), mmlToAst$3 = new mmlToAst$1$2(), utils$3 = { match: match$1$2, flatten: flatten$5$2, unflattenLeft: unflattenLeft$2, unflattenRight: unflattenRight$2 };
function isTree(t4) {
  return typeof t4 == `number` || typeof t4 == `string` || typeof t4 == `boolean` ? true : Array.isArray(t4) && t4.length > 0 && typeof t4[0] == `string` ? t4.slice(1).every((t5) => isTree(t5)) : false;
}
function Expression$2(t4, n2) {
  this.tree = flatten$5$2(t4), this.context = n2, this.toJSON = function() {
    let t5 = { objectType: `math-expression`, tree: this.tree }, n3 = {};
    for (let t6 in this.context.assumptions) Object.keys(this.context.assumptions[t6]).length > 0 && (n3[t6] = this.context.assumptions[t6]);
    return Object.keys(n3).length > 0 && (t5.assumptions = n3), t5;
  };
}
function extend$5(t4, n2) {
  return flatten_array$2(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) n2 ? (function() {
      var n3 = i2;
      t4[n3] = function() {
        return this.fromAst(r2[n3].apply(null, arguments));
      };
    })() : t4[i2] = r2[i2];
  }), t4;
}
function extend_prototype$2(t4, n2) {
  return flatten_array$2(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) (function() {
      var a2 = i2;
      t4[a2] = function() {
        var t5 = [this].concat(Array.prototype.slice.call(arguments));
        return n2 ? this.context.fromAst(r2[a2].apply(null, t5)) : r2[a2].apply(null, t5);
      };
    })();
  }), t4;
}
function create_from_multiple$2(t4, n2) {
  if (Array.isArray(t4) || typeof t4 == `number`) return new Expression$2(t4, Context$2);
  if (typeof t4 == `string`) try {
    return new Expression$2(textToAst$6.convert(t4), Context$2);
  } catch (n3) {
    try {
      return new Expression$2(latexToAst$3.convert(t4), Context$2);
    } catch (r2) {
      try {
        return new Expression$2(mmlToAst$3.convert(t4), Context$2);
      } catch (i2) {
        throw t4.indexOf(`\\`) === -1 ? t4.indexOf(`</`) === -1 ? n3 : i2 : r2;
      }
    }
  }
}
function parseText$2(t4, n2) {
  return new Expression$2(textToAst$6.convert(t4), Context$2);
}
function parseLatex$2(t4, n2) {
  return new Expression$2(latexToAst$3.convert(t4), Context$2);
}
function parseMml$2(t4, n2) {
  return new Expression$2(mmlToAst$3.convert(t4), Context$2);
}
var Context$2 = { ZmodN: ZmodN$2, assumptions: initialize_assumptions$2(), parser_parameters: {}, from: create_from_multiple$2, fromText: parseText$2, parse: parseText$2, fromLaTeX: parseLatex$2, fromLatex: parseLatex$2, fromTeX: parseLatex$2, fromTex: parseLatex$2, fromMml: parseMml$2, parse_tex: parseLatex$2, converters: converters_exports$2, utils: utils$3, fromAst: function(t4) {
  return new Expression$2(t4, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions$2();
}, get_assumptions: function(t4, n2) {
  return get_assumptions$2(this.assumptions, t4, n2);
}, add_assumption: function(t4, n2) {
  return add_assumption$2(this.assumptions, t4, n2);
}, add_generic_assumption: function(t4) {
  return add_generic_assumption$2(this.assumptions, t4);
}, remove_assumption: function(t4) {
  return remove_assumption$2(this.assumptions, t4);
}, remove_generic_assumption: function(t4) {
  return remove_generic_assumption$2(this.assumptions, t4);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions$2();
}, math: mathjs_default$2, reviver: function(t4, n2) {
  if (n2 && n2.objectType === `math-expression` && n2.tree !== void 0) {
    let t5 = Context$2.fromAst(n2.tree);
    return n2.assumptions !== void 0 && (t5.assumptions = n2.assumptions), t5;
  }
  return n2;
}, class: Expression$2 };
Context$2.set_to_default(), extend$5(Context$2, true, expression_to_tree$1$2, expression_to_tree$3), extend$5(Context$2, false, expression_to_other$2), extend_prototype$2(Expression$2.prototype, true, expression_to_tree$1$2), extend_prototype$2(Expression$2.prototype, false, expression_to_other$2);
function flatten_array$2(t4, n2) {
  n2 = n2 === void 0 ? [] : n2;
  for (var r2 = 0; r2 < t4.length; r2++) Array.isArray(t4[r2]) ? flatten_array$2(t4[r2], n2) : n2.push(t4[r2]);
  return n2;
}
const DEFAULT_MATHJAX_SRC$1 = "https://cdn.jsdelivr.net/npm/mathjax@4.1.3/tex-mml-chtml.js";
const GLOBAL_PROMISE_KEY$1 = "__doenetMathJaxPromise";
const DOENET_MATHJAX_SCRIPT_ATTR$1 = "data-doenet-mathjax";
const MATHJAX_SRC_PATTERN$1 = /mathjax|tex-(chtml|mml|svg)|mml-chtml/i;
const DEFAULT_TIMEOUT_MS$1 = 3e4;
function isMathJaxEngine$1(candidate) {
  if (!candidate || typeof candidate !== "object") {
    return false;
  }
  const startup = candidate.startup;
  return !!startup && (typeof startup === "object" || typeof startup === "function") && typeof startup.promise?.then === "function";
}
function findMathJaxScript$1() {
  const scripts = document.querySelectorAll("script[src]");
  for (const script of scripts) {
    if (script.hasAttribute(DOENET_MATHJAX_SCRIPT_ATTR$1)) {
      continue;
    }
    if (MATHJAX_SRC_PATTERN$1.test(script.src)) {
      return script;
    }
  }
  return null;
}
function waitForExistingMathJax$1(timeoutMs) {
  return new Promise((resolve, reject2) => {
    const deadline = Date.now() + timeoutMs;
    function poll() {
      const mathJax = window.MathJax;
      if (isMathJaxEngine$1(mathJax)) {
        resolve(mathJax);
        return;
      }
      if (Date.now() > deadline) {
        reject2(
          new Error(
            "DoenetViewer: timed out waiting for a host-provided MathJax"
          )
        );
        return;
      }
      window.setTimeout(poll, 50);
    }
    poll();
  });
}
function injectMathJax$1(src, config2, { force = false } = {}) {
  return new Promise((resolve, reject2) => {
    if (config2 && (force || window.MathJax == null)) {
      window.MathJax = config2;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    script.setAttribute(DOENET_MATHJAX_SCRIPT_ATTR$1, "true");
    script.addEventListener("load", () => {
      resolve(window.MathJax);
    });
    script.addEventListener("error", () => {
      reject2(
        new Error(`DoenetViewer: failed to load MathJax from ${src}`)
      );
    });
    document.head.appendChild(script);
  });
}
function createMathJaxPromise$1(options2) {
  const {
    config: config2,
    src = DEFAULT_MATHJAX_SRC$1,
    useExistingMathJax = false,
    timeoutMs = DEFAULT_TIMEOUT_MS$1
  } = options2;
  if (isMathJaxEngine$1(window.MathJax)) {
    return Promise.resolve(window.MathJax);
  }
  if (useExistingMathJax || findMathJaxScript$1()) {
    return waitForExistingMathJax$1(timeoutMs).catch((reason) => {
      console.warn(
        "DoenetViewer: a host-provided MathJax did not become usable in time; falling back to loading Doenet's own copy.",
        reason
      );
      return injectMathJax$1(src, config2, { force: true });
    });
  }
  return injectMathJax$1(src, config2);
}
function loadMathJax$1(options2 = {}) {
  if (typeof window === "undefined") {
    return Promise.reject(
      new Error("MathJax can only be loaded in a browser environment")
    );
  }
  const cached = window[GLOBAL_PROMISE_KEY$1];
  if (cached) {
    return cached;
  }
  const promise = createMathJaxPromise$1(options2);
  window[GLOBAL_PROMISE_KEY$1] = promise;
  promise.catch(() => {
    const store2 = window;
    if (store2[GLOBAL_PROMISE_KEY$1] === promise) {
      delete store2[GLOBAL_PROMISE_KEY$1];
    }
  });
  return promise;
}
function isErrorRecord(diagnostic2) {
  return diagnostic2.type === "error";
}
function isWarningRecord(diagnostic2) {
  return diagnostic2.type === "warning";
}
function isAccessibilityRecord(diagnostic2) {
  return diagnostic2.type === "accessibility" && (diagnostic2.level === 1 || diagnostic2.level === 2);
}
function isMacPlatform() {
  const nav2 = globalThis.navigator;
  if (!nav2) {
    return false;
  }
  const platform2 = nav2.userAgentData?.platform ?? nav2.platform ?? "";
  return /mac|iphone|ipad|ipod|ios/i.test(platform2);
}
function isSaveShortcutKeydown(event) {
  const modifier = isMacPlatform() ? event.metaKey : event.ctrlKey;
  return modifier && !event.altKey && !event.shiftKey && event.code === "KeyS";
}
var base32$1$2 = { exports: {} };
var hasRequiredBase32$2;
function requireBase32$2() {
  if (hasRequiredBase32$2) return base32$1$2.exports;
  hasRequiredBase32$2 = 1;
  (function(module) {
    (function() {
      var root2 = typeof window === "object" ? window : {};
      var NODE_JS = !root2.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root2 = commonjsGlobal$2;
      }
      var COMMON_JS = !root2.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position2, partial2) {
        if (partial2.length > 10) {
          partial2 = "..." + partial2.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position2 + " bytes: " + partial2 + " <-");
        err.position = position2;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i3 = 0, followingChars = 0, b2, c2;
        while (i3 < length) {
          b2 = bytes[i3++];
          if (b2 <= 127) {
            str += String.fromCharCode(b2);
            continue;
          } else if (b2 > 191 && b2 <= 223) {
            c2 = b2 & 31;
            followingChars = 1;
          } else if (b2 <= 239) {
            c2 = b2 & 15;
            followingChars = 2;
          } else if (b2 <= 247) {
            c2 = b2 & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i3, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b2 = bytes[i3++];
            if (b2 < 128 || b2 > 191) {
              throwInvalidUtf8(i3, str);
            }
            c2 <<= 6;
            c2 += b2 & 63;
          }
          if (c2 >= 55296 && c2 <= 57343) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 > 1114111) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 <= 65535) {
            str += String.fromCharCode(c2);
          } else {
            c2 -= 65536;
            str += String.fromCharCode((c2 >> 10) + 55296);
            str += String.fromCharCode((c2 & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index2 = 0, length = base32Str.length;
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index2++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3++);
          v5 = str.charCodeAt(i3++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code2, end = false, base32Str = "", index2 = 0, i3, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i3 = start; index2 < length && i3 < 5; ++index2) {
            code2 = str.charCodeAt(index2);
            if (code2 < 128) {
              blocks[i3++] = code2;
            } else if (code2 < 2048) {
              blocks[i3++] = 192 | code2 >> 6;
              blocks[i3++] = 128 | code2 & 63;
            } else if (code2 < 55296 || code2 >= 57344) {
              blocks[i3++] = 224 | code2 >> 12;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            } else {
              code2 = 65536 + ((code2 & 1023) << 10 | str.charCodeAt(++index2) & 1023);
              blocks[i3++] = 240 | code2 >> 18;
              blocks[i3++] = 128 | code2 >> 12 & 63;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            }
          }
          start = i3 - 5;
          if (index2 === length) {
            ++index2;
          }
          if (index2 > length && i3 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i3 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i3 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i3 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i3 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3++];
          v5 = bytes[i3++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i3++];
          v2 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode2 = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports2 = {
        encode: encode2,
        decode
      };
      decode.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports2;
      } else {
        root2.base32 = exports2;
      }
    })();
  })(base32$1$2);
  return base32$1$2.exports;
}
var base32Exports = requireBase32$2();
const base32 = /* @__PURE__ */ getDefaultExportFromCjs$4(base32Exports);
async function cidFromText(text2) {
  let encoder = new TextEncoder();
  let data = encoder.encode(text2);
  return await cidFromArrayBuffer(data);
}
let digest = null;
async function cidFromArrayBuffer(data) {
  if (!digest) {
    try {
      await crypto.subtle.digest("SHA-256", new Uint8Array());
      digest = (data2) => crypto.subtle.digest("SHA-256", data2);
    } catch (e2) {
      const sha256 = (await import("./sha256-C0vj3HDn-BxaiuOaa.js").then((n2) => n2.s)).default;
      digest = (data2) => sha256(data2, {
        asBytes: true
      });
    }
  }
  let hashBuffer = await digest(data);
  let cidArray = new Uint8Array(36);
  cidArray.set([1, 85, 18, 32]);
  cidArray.set(new Uint8Array(hashBuffer), 4);
  let cid = "b" + base32.encode(cidArray).toLowerCase().replace(/=+/, "");
  return cid;
}
const textByCid = {};
function retrieveTextFileForCid(cid, ext = "doenet") {
  if (textByCid[cid] !== void 0) {
    return Promise.resolve(textByCid[cid]);
  }
  let resultServer = retrieveTextFileFromServer(cid, ext);
  return resultServer.promise.then((res) => {
    textByCid[cid] = res;
    return res;
  });
}
function retrieveTextFileFromServer(cid, ext) {
  let controller = new AbortController();
  let signal = controller.signal;
  let retrieveFromServer = async function() {
    try {
      let response = await fetch(`/media/${cid}.${ext}`, { signal });
      if (response.ok) {
        let doenetML = await response.text();
        let CidRetrieved = await cidFromText(doenetML);
        if (CidRetrieved === cid) {
          return doenetML;
        } else {
          console.warn(`cid mismatch, ${cid}, ${CidRetrieved}`);
          return Promise.reject(new Error("cid mismatch"));
        }
      } else {
        return Promise.reject(new Error(`cid not found: ${cid}`));
      }
    } catch (e2) {
      return Promise.reject(new Error(`cid not found: ${cid}`));
    }
  };
  let promise = retrieveFromServer();
  return { promise, controller };
}
const genericMethods = {
  union: function(A2, B2) {
    return A2.complement().intersect(B2.complement()).complement();
  },
  intersectWithOpenInterval: function(A2, B2) {
    return A2.intersect(B2);
  },
  setMinus: function(A2, B2) {
    return A2.intersect(B2.complement());
  },
  symmetricDifference: function(A2, B2) {
    return A2.setMinus(B2).union(B2.setMinus(A2));
  },
  containsSubset: function(A2, B2) {
    return A2.intersect(B2).equals(B2);
  },
  isSubsetOf: function(A2, B2) {
    return genericMethods.containsSubset(B2, A2);
  },
  equals: function(A2, B2) {
    return A2.symmetricDifference(B2).isEmpty();
  }
};
function subsetReviver(_key, value) {
  if (typeof value === "object" && value !== null && "objectType" in value && value.objectType === "subset" && "data" in value && typeof value.data === "object" && value.data !== null && "type" in value.data && value.data.type !== void 0) {
    if (value.data.type === "empty") {
      return EmptySet();
    } else if (value.data.type === "realLine") {
      return RealLine();
    } else if (value.data.type === "singleton") {
      if ("element" in value.data && typeof value.data.element === "number") {
        return Singleton(value.data.element);
      }
    } else if (value.data.type === "union") {
      if ("subsets" in value.data && Array.isArray(value.data.subsets) && value.data.subsets.every(
        (s2) => s2 instanceof Constructors.Singleton || s2 instanceof Constructors.OpenInterval
      )) {
        return Union(value.data.subsets);
      }
    } else if (value.data.type === "openInterval") {
      if ("left" in value.data && typeof value.data.left === "number" && "right" in value.data && typeof value.data.right === "number") {
        return OpenInterval(value.data.left, value.data.right);
      }
    }
  }
  return value;
}
const Constructors = {
  EmptySet: class {
    constructor() {
      this.type = "empty";
    }
    union(that) {
      return that;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    intersect() {
      return EmptySet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return RealLine();
    }
    isValid() {
      return true;
    }
    toString() {
      return "∅";
    }
    toMathExpression() {
      return Context$2.fromAst("emptyset");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "empty" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  InvalidSet: class {
    constructor() {
      this.type = "invalid";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    union() {
      return InvalidSet();
    }
    intersect() {
      return InvalidSet();
    }
    containsElement() {
      return false;
    }
    isEmpty() {
      return true;
    }
    complement() {
      return InvalidSet();
    }
    isValid() {
      return false;
    }
    toString() {
      return "＿";
    }
    toMathExpression() {
      return Context$2.fromAst("＿");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "invalid" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  RealLine: class {
    constructor() {
      this.type = "realLine";
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union() {
      return RealLine();
    }
    intersect(that) {
      return that;
    }
    containsElement() {
      return true;
    }
    complement() {
      return EmptySet();
    }
    isEmpty() {
      return false;
    }
    toString() {
      return "ℝ";
    }
    toMathExpression() {
      return Context$2.fromAst("R");
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "realLine" }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Singleton: class {
    constructor(element2) {
      this.type = "singleton";
      this.element = element2;
    }
    intersectWithOpenInterval(that) {
      return genericMethods.intersectWithOpenInterval(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    union(that) {
      if (that.containsElement(this.element)) {
        return that;
      } else {
        return Union([that, this]);
      }
    }
    intersect(subset) {
      if (subset.containsElement(this.element)) {
        return Singleton(this.element);
      } else {
        return EmptySet();
      }
    }
    isEmpty() {
      return false;
    }
    containsElement(element2) {
      return element2 === this.element;
    }
    complement() {
      return Union([
        OpenInterval(-Infinity, this.element),
        OpenInterval(this.element, Infinity)
      ]);
    }
    toString() {
      return `{${this.element}}`;
    }
    toMathExpression() {
      return Context$2.fromAst(["set", this.element]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: { type: "singleton", element: this.element }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  OpenInterval: class {
    constructor(left, right) {
      this.type = "openInterval";
      this.left = left;
      this.right = right;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersect(subset) {
      return subset.intersectWithOpenInterval(this);
    }
    intersectWithOpenInterval(that) {
      return OpenInterval(
        Math.max(this.left, that.left),
        Math.min(this.right, that.right)
      );
    }
    complement() {
      return Union([
        OpenClosedInterval(-Infinity, this.left),
        ClosedOpenInterval(this.right, Infinity)
      ]);
    }
    isEmpty() {
      return this.left >= this.right;
    }
    containsElement(element2) {
      return element2 > this.left && element2 < this.right;
    }
    toString() {
      return `(${this.left.toString()},${this.right.toString()})`;
    }
    toMathExpression() {
      return Context$2.fromAst([
        "interval",
        ["tuple", this.left, this.right],
        ["tuple", false, false]
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "openInterval",
          left: this.left,
          right: this.right
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  },
  Union: class {
    constructor(subsets2) {
      this.type = "union";
      this.subsets = subsets2;
    }
    union(that) {
      return genericMethods.union(this, that);
    }
    setMinus(that) {
      return genericMethods.setMinus(this, that);
    }
    symmetricDifference(that) {
      return genericMethods.symmetricDifference(this, that);
    }
    containsSubset(that) {
      return genericMethods.containsSubset(this, that);
    }
    isSubsetOf(that) {
      return genericMethods.isSubsetOf(this, that);
    }
    equals(that) {
      return genericMethods.equals(this, that);
    }
    isValid() {
      return true;
    }
    intersectWithOpenInterval(that) {
      return this.intersect(that);
    }
    containsElement(element2) {
      return this.subsets.some((s2) => s2.containsElement(element2));
    }
    isEmpty() {
      return this.subsets.every((s2) => s2.isEmpty());
    }
    complement() {
      return this.subsets.map((s2) => s2.complement()).reduce((a2, b2) => a2.intersect(b2));
    }
    intersect(subset) {
      return Union(this.subsets.map((s2) => subset.intersect(s2)));
    }
    toString() {
      return this.subsets.map((s2) => s2.toString()).join(" U ");
    }
    toMathExpression() {
      return Context$2.fromAst([
        "union",
        ...this.subsets.map((s2) => s2.toMathExpression().tree)
      ]);
    }
    toJSON() {
      return {
        objectType: "subset",
        data: {
          type: "union",
          subsets: this.subsets.map((s2) => s2.toJSON())
        }
      };
    }
    copy() {
      return subsetReviver(null, this.toJSON());
    }
  }
};
function EmptySet() {
  return new Constructors.EmptySet();
}
function InvalidSet() {
  return new Constructors.InvalidSet();
}
function RealLine() {
  return new Constructors.RealLine();
}
function Singleton(element2) {
  if (!Number.isFinite(element2)) {
    return new Constructors.EmptySet();
  }
  return new Constructors.Singleton(element2);
}
function OpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    return new Constructors.OpenInterval(left, right);
  }
}
function Union(subsets2) {
  if (subsets2.some((s2) => s2.type === "invalid")) {
    return new Constructors.InvalidSet();
  }
  const flattenedSubsets = subsets2.reduce(
    (acc, val) => val.type === "union" ? [...acc, ...val.subsets] : [...acc, val],
    []
  );
  const filtered = [];
  for (const sub2 of flattenedSubsets) {
    if (sub2.type === "realLine") {
      return new Constructors.RealLine();
    } else if (sub2.type !== "empty" && !sub2.isEmpty()) {
      filtered.push(sub2);
    }
  }
  if (filtered.length === 0) {
    return new Constructors.EmptySet();
  }
  const newSubsets = [];
  for (let ind1 = 0; ind1 < filtered.length; ind1++) {
    let sub1 = filtered[ind1];
    let addSub1 = true;
    if (sub1.type === "openInterval") {
      let left = sub1.left;
      let right = sub1.right;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (left < sub2.right && sub2.left < right) {
            left = Math.min(left, sub2.left);
            right = Math.max(right, sub2.right);
            filtered.splice(ind2, 1);
            ind2--;
            addSub1 = false;
            ind1--;
            break;
          } else if (left === sub2.right || right === sub2.left) {
            let gap = left === sub2.right ? left : right;
            let foundSingleton = false;
            for (let ind3 = 0; ind3 < newSubsets.length; ind3++) {
              let sub3 = newSubsets[ind3];
              if (sub3.type === "singleton" && sub3.element === gap) {
                newSubsets.splice(ind3, 1);
                foundSingleton = true;
                break;
              }
            }
            if (!foundSingleton) {
              for (let ind3 = ind1 + 1; ind3 < filtered.length; ind3++) {
                let sub3 = filtered[ind3];
                if (sub3.type === "singleton" && sub3.element === gap) {
                  filtered.splice(ind3, 1);
                  foundSingleton = true;
                  if (ind3 < ind2) {
                    ind2--;
                  }
                  break;
                }
              }
            }
            if (foundSingleton) {
              left = Math.min(left, sub2.left);
              right = Math.max(right, sub2.right);
              filtered.splice(ind2, 1);
              ind2--;
              addSub1 = false;
              ind1--;
              break;
            }
          }
        } else {
          if (sub2.element > left && sub2.element < right) {
            filtered.splice(ind2, 1);
            ind2--;
          }
        }
      }
      sub1.left = left;
      sub1.right = right;
      if (sub1.left === -Infinity && sub1.right === Infinity) {
        return new Constructors.RealLine();
      }
    } else {
      let val = sub1.element;
      for (let ind2 = ind1 + 1; ind2 < filtered.length; ind2++) {
        let sub2 = filtered[ind2];
        if (sub2.type === "openInterval") {
          if (val > sub2.left && val < sub2.right) {
            filtered.splice(ind1, 1);
            ind1--;
            addSub1 = false;
            break;
          }
        } else if (sub2.element === val) {
          filtered.splice(ind2, 1);
          ind2--;
        }
      }
    }
    if (addSub1) {
      newSubsets.push(sub1);
    }
  }
  if (newSubsets.length === 1) {
    return newSubsets[0];
  }
  return new Constructors.Union(newSubsets);
}
function OpenClosedInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(right)) {
      pieces.push(new Constructors.Singleton(right));
    }
    return Union(pieces);
  }
}
function ClosedOpenInterval(left, right) {
  if (!(left < right)) {
    return new Constructors.EmptySet();
  } else if (left === -Infinity && right === Infinity) {
    return new Constructors.RealLine();
  } else {
    const pieces = [
      new Constructors.OpenInterval(left, right)
    ];
    if (Number.isFinite(left)) {
      pieces.push(new Constructors.Singleton(left));
    }
    return Union(pieces);
  }
}
function deepCompare(a2, b2, BaseComponent) {
  let leftChain = [];
  let rightChain = [];
  function compare2Objects(x2, y2) {
    let p2;
    if (Number.isNaN(x2) && Number.isNaN(y2)) {
      return true;
    }
    if (x2 === y2) {
      return true;
    }
    if (x2 instanceof Context$2.class && y2 instanceof Context$2.class) {
      return compare2Objects(x2.tree, y2.tree);
    }
    if (typeof x2 === "function" && typeof y2 === "function" || x2 instanceof Date && y2 instanceof Date || x2 instanceof RegExp && y2 instanceof RegExp || x2 instanceof String && y2 instanceof String || x2 instanceof Number && y2 instanceof Number) {
      return x2.toString() === y2.toString();
    }
    if (!(x2 instanceof Object && y2 instanceof Object)) {
      return false;
    }
    if (x2.isPrototypeOf(y2) || y2.isPrototypeOf(x2)) {
      return false;
    }
    if (x2.constructor !== y2.constructor) {
      return false;
    }
    if (x2.prototype !== y2.prototype) {
      return false;
    }
    if (leftChain.indexOf(x2) > -1 || rightChain.indexOf(y2) > -1) {
      return false;
    }
    for (p2 in y2) {
      if (y2.hasOwnProperty(p2) !== x2.hasOwnProperty(p2)) {
        return false;
      } else if (typeof y2[p2] !== typeof x2[p2]) {
        return false;
      }
    }
    for (p2 in x2) {
      if (y2.hasOwnProperty(p2) !== x2.hasOwnProperty(p2)) {
        return false;
      } else if (typeof y2[p2] !== typeof x2[p2]) {
        return false;
      }
      switch (typeof x2[p2]) {
        case "object":
        case "function":
          leftChain.push(x2);
          rightChain.push(y2);
          if (!compare2Objects(x2[p2], y2[p2])) {
            return false;
          }
          leftChain.pop();
          rightChain.pop();
          break;
        default:
          if (x2[p2] !== y2[p2] && !(Number.isNaN(x2[p2]) && Number.isNaN(y2[p2]))) {
            return false;
          }
          break;
      }
    }
    return true;
  }
  return compare2Objects(a2, b2);
}
function serializedComponentsReplacer(key, value) {
  if (value !== value) {
    return { objectType: "special-numeric", stringValue: "NaN" };
  } else if (value === Infinity) {
    return { objectType: "special-numeric", stringValue: "Infinity" };
  } else if (value === -Infinity) {
    return { objectType: "special-numeric", stringValue: "-Infinity" };
  }
  return value;
}
function nanInfinityReviver(key, value) {
  if (value && value.objectType === "special-numeric") {
    if (value.stringValue === "NaN") {
      return NaN;
    } else if (value.stringValue === "Infinity") {
      return Infinity;
    } else if (value.stringValue === "-Infinity") {
      return -Infinity;
    }
  }
  return value;
}
function serializedComponentsReviver(key, value) {
  return Context$2.reviver(key, subsetReviver(key, nanInfinityReviver(key, value)));
}
function find_effective_domain({
  domain,
  truncateToFiniteDomain = false,
  xscale = 1
}) {
  let minx = -Infinity;
  let maxx = Infinity;
  let openMin = true, openMax = true;
  if (domain !== null) {
    let domain1 = domain[0];
    if (domain1 !== void 0) {
      minx = Context$2.fromAst(domain1.tree[1][1]).evaluate_to_constant();
      if (!Number.isFinite(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain1.tree[2][1];
      }
      maxx = Context$2.fromAst(domain1.tree[1][2]).evaluate_to_constant();
      if (!Number.isFinite(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain1.tree[2][2];
      }
    }
  }
  if (truncateToFiniteDomain) {
    if (minx === -Infinity) {
      if (maxx === Infinity) {
        minx = -100 * xscale;
        maxx = 100 * xscale;
      } else {
        minx = maxx - 200 * xscale;
      }
    } else if (maxx === Infinity) {
      maxx = minx + 200 * xscale;
    }
  } else {
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
  }
  return { minx, maxx, openMin, openMax };
}
const { gcd: gcd$4, lcm: lcm$2 } = Context$2.math;
function convertValueToMathExpression(value) {
  if (value instanceof Context$2.class) {
    return value;
  } else if (typeof value === "number" || typeof value === "string") {
    return Context$2.fromAst(value);
  } else if (isTree(value)) {
    return Context$2.fromAst(value);
  } else {
    return Context$2.fromAst("＿");
  }
}
const vectorOperators = ["vector", "altvector", "tuple"];
const { mod: mod$4 } = Context$2.math;
const { dopri: dopri$2 } = Context$2.math;
function createFunctionFromDefinition(fDefinition) {
  if (fDefinition.functionType === "formula") {
    return returnNumericalFunctionFromFormula({
      formula: Context$2.fromAst(fDefinition.formula),
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => Context$2.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$2.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "reevaluatedFormula") {
    let evaluateChildrenToReevaluate = {};
    for (let code2 in fDefinition.evaluateChildrenToReevaluate) {
      evaluateChildrenToReevaluate[code2] = {
        fReevaluate: createFunctionFromDefinition(
          fDefinition.evaluateChildrenToReevaluate[code2].fReevaluateDefinition
        ),
        inputMathFs: fDefinition.evaluateChildrenToReevaluate[code2].inputMaths.map(
          (x2) => Context$2.fromAst(x2).subscripts_to_strings().f()
        )
      };
    }
    return returnNumericalFunctionFromReevaluatedFormula({
      formulaExpressionWithCodes: Context$2.fromAst(
        fDefinition.formulaExpressionWithCodes
      ),
      evaluateChildrenToReevaluate,
      numInputs: fDefinition.numInputs,
      variables: fDefinition.variables.map((x2) => Context$2.fromAst(x2)),
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$2.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "numericForEvaluate") {
    return returnNumericFunctionForEvaluate({
      numInputs: fDefinition.numInputs,
      numericalfs: fDefinition.fDefinitions.map(
        (fdef) => createFunctionFromDefinition(fdef)
      )
    });
  } else if (fDefinition.functionType === "bezier") {
    return returnBezierFunctions({
      numThroughPoints: fDefinition.numThroughPoints,
      numericalThroughPoints: fDefinition.numericalThroughPoints,
      splineCoeffs: fDefinition.splineCoeffs,
      extrapolateForward: fDefinition.extrapolateForward,
      extrapolateForwardCoeffs: fDefinition.extrapolateForwardCoeffs,
      extrapolateBackward: fDefinition.extrapolateBackward,
      extrapolateBackwardCoeffs: fDefinition.extrapolateBackwardCoeffs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "interpolated") {
    return returnInterpolatedFunction({
      xs: fDefinition.xs,
      coeffs: fDefinition.coeffs,
      interpolationPoints: fDefinition.interpolationPoints,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$2.fromAst(x2)) : null
    });
  } else if (fDefinition.functionType === "functionOperator") {
    return returnFunctionOperatorFunction({
      componentType: fDefinition.componentType,
      functionOperatorArguments: fDefinition.functionOperatorArguments,
      operatorComposesWithOriginal: fDefinition.operatorComposesWithOriginal,
      originalFDefinition: fDefinition.originalFDefinition,
      numOutputs: fDefinition.numOutputs,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "ODESolution") {
    return returnODESolutionFunction({
      numDimensions: fDefinition.numDimensions,
      t0: fDefinition.t0,
      x0s: fDefinition.x0s,
      chunkSize: fDefinition.chunkSize,
      tolerance: fDefinition.tolerance,
      numericalRHSfDefinitions: fDefinition.numericalRHSfDefinitions,
      maxIterations: fDefinition.maxIterations,
      component: fDefinition.component
    });
  } else if (fDefinition.functionType === "piecewise") {
    return returnPiecewiseNumericalFunctionFromChildren({
      numericalFsOfChildren: fDefinition.fDefinitionsOfChildren.map(
        (fDef) => createFunctionFromDefinition(fDef)
      ),
      numericalDomainsOfChildren: fDefinition.numericalDomainsOfChildren,
      domain: fDefinition.domain ? fDefinition.domain.map((x2) => Context$2.fromAst(x2)) : null,
      component: fDefinition.component
    });
  } else {
    return () => NaN;
  }
}
function returnNumericalFunctionFromFormula({
  formula,
  numInputs,
  variables: variables2,
  domain = null,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formula.tree) && vectorOperators.includes(formula.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formula = formula.get_component(component);
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formula.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables2[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = Context$2.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = Context$2.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      try {
        return formula_f({ [varString]: x2 });
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables2[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = Context$2.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = Context$2.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i3];
        let [openMin, openMax] = domainOpens[i3];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i3]] = x2;
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnNumericalFunctionFromReevaluatedFormula({
  formulaExpressionWithCodes,
  evaluateChildrenToReevaluate,
  numInputs,
  variables: variables2,
  domain = null,
  component = 0
}) {
  component = Number(component);
  let formulaIsVectorValued = Array.isArray(formulaExpressionWithCodes.tree) && vectorOperators.includes(formulaExpressionWithCodes.tree[0]);
  if (formulaIsVectorValued) {
    try {
      formulaExpressionWithCodes = formulaExpressionWithCodes.get_component(Number(component));
    } catch (e2) {
      return () => NaN;
    }
  } else if (component !== 0) {
    return () => NaN;
  }
  let formula_f;
  try {
    formula_f = formulaExpressionWithCodes.subscripts_to_strings().f();
  } catch (e2) {
    return () => NaN;
  }
  if (numInputs === 1) {
    let varString = variables2[0].subscripts_to_strings().tree;
    let minx = -Infinity, maxx = Infinity;
    let openMin = false, openMax = false;
    if (domain !== null) {
      let domain0 = domain[0];
      if (domain0 !== void 0) {
        minx = Context$2.fromAst(domain0.tree[1][1]).evaluate_to_constant();
        if (typeof minx !== "number" || Number.isNaN(minx)) {
          minx = -Infinity;
        } else {
          openMin = !domain0.tree[2][1];
        }
        maxx = Context$2.fromAst(domain0.tree[1][2]).evaluate_to_constant();
        if (typeof maxx !== "number" || Number.isNaN(maxx)) {
          maxx = Infinity;
        } else {
          openMax = !domain0.tree[2][2];
        }
      }
    }
    if (minx === -Infinity) {
      openMin = false;
    }
    if (maxx === Infinity) {
      openMax = false;
    }
    return function(x2, overrideDomain = false) {
      if (overrideDomain) {
        if (isNaN(x2)) {
          return NaN;
        }
      } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
        return NaN;
      }
      let argsForInputs = { [varString]: x2 };
      let fArgs = { [varString]: x2 };
      for (let code2 in evaluateChildrenToReevaluate) {
        let childF = evaluateChildrenToReevaluate[code2].fReevaluate;
        let inputFs = evaluateChildrenToReevaluate[code2].inputMathFs;
        try {
          let input = inputFs.map(
            (f2) => Context$2.fromAst(f2(argsForInputs))
          );
          fArgs[code2] = childF(input).evaluate_to_constant();
        } catch (e2) {
          return NaN;
        }
      }
      try {
        return formula_f(fArgs);
      } catch (e2) {
        return NaN;
      }
    };
  }
  let varStrings = [];
  for (let i3 = 0; i3 < numInputs; i3++) {
    varStrings.push(variables2[i3].subscripts_to_strings().tree);
  }
  let haveDomain = false;
  let domainIntervals = [];
  let domainOpens = [];
  if (domain !== null) {
    haveDomain = true;
    for (let i3 = 0; i3 < numInputs; i3++) {
      let thisDomain = domain[i3];
      if (!thisDomain) {
        haveDomain = false;
        break;
      }
      let minx = -Infinity, maxx = Infinity;
      let openMin = false, openMax = false;
      minx = Context$2.fromAst(thisDomain.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !thisDomain.tree[2][1];
      }
      maxx = Context$2.fromAst(thisDomain.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !thisDomain.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
      domainIntervals.push([minx, maxx]);
      domainOpens.push([openMin, openMax]);
    }
  }
  return function(...xs) {
    let fArgs = {};
    for (let i3 = 0; i3 < numInputs; i3++) {
      let x2 = xs[i3];
      if (typeof x2 !== "number" || isNaN(x2)) {
        return NaN;
      } else if (haveDomain) {
        let [minx, maxx] = domainIntervals[i3];
        let [openMin, openMax] = domainOpens[i3];
        if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
          return NaN;
        }
      }
      fArgs[varStrings[i3]] = x2;
    }
    let argsForInputs = { ...fArgs };
    for (let code2 in evaluateChildrenToReevaluate) {
      let childF = evaluateChildrenToReevaluate[code2].fReevaluate;
      let inputFs = evaluateChildrenToReevaluate[code2].inputMathFs;
      try {
        let input = inputFs.map(
          (f2) => Context$2.fromAst(f2(argsForInputs))
        );
        fArgs[code2] = childF(input).evaluate_to_constant();
      } catch (e2) {
        return NaN;
      }
    }
    try {
      return formula_f(fArgs);
    } catch (e2) {
      return NaN;
    }
  };
}
function returnPiecewiseNumericalFunctionFromChildren({
  numericalFsOfChildren,
  numericalDomainsOfChildren,
  domain = null,
  component = 0
}) {
  component = Number(component);
  if (component !== 0) {
    return () => NaN;
  }
  let { minx, maxx, openMin, openMax } = find_effective_domain({
    domain: domain ?? null
  });
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    for (let [ind, childDomain] of numericalDomainsOfChildren.entries()) {
      let childMinX = childDomain[0][0];
      let childMaxX = childDomain[0][1];
      let childMinXClosed = childDomain[1][0];
      let childMaxXClosed = childDomain[1][1];
      if ((x2 > childMinX || childMinXClosed && x2 === childMinX) && (x2 < childMaxX || childMaxXClosed && x2 === childMaxX)) {
        return numericalFsOfChildren[ind](x2);
      }
    }
    return NaN;
  };
}
function returnNumericFunctionForEvaluate({
  numericalfs,
  numInputs
}) {
  return function(input) {
    if (input.length === 1) {
      let inputTree = input[0].tree;
      if (Array.isArray(inputTree) && vectorOperators.includes(inputTree[0])) {
        input = inputTree.slice(1).map((x2) => Context$2.fromAst(x2));
      }
    }
    if (input.length !== numInputs) {
      return Context$2.fromAst("＿");
    }
    let numericInput = input.map((x2) => x2.evaluate_to_constant());
    let components = numericalfs.map((f2) => f2(...numericInput));
    let value;
    if (components.length === 1) {
      value = Context$2.fromAst(components[0]);
    } else {
      value = Context$2.fromAst(["vector", ...components]);
    }
    return value;
  };
}
function returnBezierFunctions({
  numThroughPoints,
  numericalThroughPoints,
  splineCoeffs,
  extrapolateForward,
  extrapolateForwardCoeffs,
  extrapolateBackward,
  extrapolateBackwardCoeffs,
  component
}) {
  if (numThroughPoints < 1) {
    return () => NaN;
  }
  let len = numThroughPoints - 1;
  let lastPointX = numericalThroughPoints[len][component];
  let cs = splineCoeffs.map((x2) => x2[component]);
  let cB;
  if (extrapolateBackward) {
    cB = extrapolateBackwardCoeffs[component];
  }
  let cF;
  if (extrapolateForward) {
    cF = extrapolateForwardCoeffs[component];
  }
  return function(t24) {
    if (isNaN(t24)) {
      return NaN;
    }
    if (t24 < 0) {
      if (extrapolateBackward) {
        return (cB[2] * t24 + cB[1]) * t24 + cB[0];
      } else {
        return NaN;
      }
    }
    if (t24 >= len) {
      if (extrapolateForward) {
        t24 -= len;
        return (cF[2] * t24 + cF[1]) * t24 + cF[0];
      } else if (t24 === len) {
        return lastPointX;
      } else {
        return NaN;
      }
    }
    let z2 = Math.floor(t24);
    t24 -= z2;
    let c2 = cs[z2];
    return ((c2[3] * t24 + c2[2]) * t24 + c2[1]) * t24 + c2[0];
  };
}
function returnInterpolatedFunction({
  xs,
  coeffs,
  interpolationPoints,
  domain = null
}) {
  let interpolationPointYs = [];
  if (interpolationPoints) {
    interpolationPointYs = interpolationPoints.map((x2) => x2.y);
  }
  if (xs === null) {
    return () => NaN;
  }
  let minx = -Infinity, maxx = Infinity;
  let openMin = false, openMax = false;
  if (domain !== null) {
    let domain0 = domain[0];
    if (domain0 !== void 0) {
      minx = Context$2.fromAst(domain0.tree[1][1]).evaluate_to_constant();
      if (typeof minx !== "number" || Number.isNaN(minx)) {
        minx = -Infinity;
      } else {
        openMin = !domain0.tree[2][1];
      }
      maxx = Context$2.fromAst(domain0.tree[1][2]).evaluate_to_constant();
      if (typeof maxx !== "number" || Number.isNaN(maxx)) {
        maxx = Infinity;
      } else {
        openMax = !domain0.tree[2][2];
      }
      if (minx === -Infinity) {
        openMin = false;
      }
      if (maxx === Infinity) {
        openMax = false;
      }
    }
  }
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(x2, overrideDomain = false) {
    if (overrideDomain) {
      if (isNaN(x2)) {
        return NaN;
      }
    } else if (!(x2 >= minx) || !(x2 <= maxx) || openMin && x2 === minx || openMax && x2 === maxx) {
      return NaN;
    }
    if (x2 <= x0) {
      x2 -= x0;
      let c22 = coeffs[0];
      if (x2 === -Infinity) {
        if (c22[3] === 0) {
          if (c22[2] === 0) {
            if (c22[1] === 0) {
              return c22[0];
            } else {
              return -Math.sign(c22[1]) * Infinity;
            }
          } else {
            return Math.sign(c22[2]) * Infinity;
          }
        } else {
          return -Math.sign(c22[3]) * Infinity;
        }
      }
      return ((c22[3] * x2 + c22[2]) * x2 + c22[1]) * x2 + c22[0];
    }
    if (x2 >= xL) {
      let i22 = xs.length - 2;
      x2 -= xs[i22];
      let c22 = coeffs[i22];
      if (x2 === Infinity) {
        if (c22[3] === 0) {
          if (c22[2] === 0) {
            if (c22[1] === 0) {
              return c22[0];
            } else {
              return Math.sign(c22[1]) * Infinity;
            }
          } else {
            return Math.sign(c22[2]) * Infinity;
          }
        } else {
          return Math.sign(c22[3]) * Infinity;
        }
      }
      if (x2 === Infinity && c22[1] === 0 && c22[2] === 0 && c22[3] === 0) {
        return c22[0];
      }
      return ((c22[3] * x2 + c22[2]) * x2 + c22[1]) * x2 + c22[0];
    }
    let low = 0, mid, high = xs.length - 1;
    while (low <= high) {
      mid = Math.floor(0.5 * (low + high));
      let xHere = xs[mid];
      if (xHere < x2) {
        low = mid + 1;
      } else if (xHere > x2) {
        high = mid - 1;
      } else {
        return interpolationPointYs[mid];
      }
    }
    let i3 = Math.max(0, high);
    x2 -= xs[i3];
    let c2 = coeffs[i3];
    return ((c2[3] * x2 + c2[2]) * x2 + c2[1]) * x2 + c2[0];
  };
}
function returnReturnDerivativesOfInterpolatedFunction({
  xs,
  coeffs,
  variables: variables2
}) {
  if (!xs) {
    return () => () => NaN;
  }
  let variable1Trans = variables2[0].subscripts_to_strings().tree;
  let x0 = xs[0], xL = xs[xs.length - 1];
  return function(derivVariables) {
    let derivVariablesTrans = derivVariables.map(
      (x2) => x2.subscripts_to_strings().tree
    );
    let order2 = derivVariablesTrans.length;
    if (order2 > 3 || !derivVariablesTrans.every((x2) => x2 === variable1Trans) || derivVariablesTrans.includes("＿")) {
      return () => 0;
    }
    if (order2 === 0 || xs === null) {
      return () => NaN;
    }
    return function(x2) {
      if (isNaN(x2)) {
        return NaN;
      }
      if (x2 <= x0) {
        x2 -= x0;
        let c22 = coeffs[0];
        if (order2 === 1) {
          return (3 * c22[3] * x2 + 2 * c22[2]) * x2 + c22[1];
        } else if (order2 === 2) {
          return 6 * c22[3] * x2 + 2 * c22[2];
        } else {
          return 6 * c22[3];
        }
      }
      if (x2 >= xL) {
        let i22 = xs.length - 2;
        x2 -= xs[i22];
        let c22 = coeffs[i22];
        if (order2 === 1) {
          return (3 * c22[3] * x2 + 2 * c22[2]) * x2 + c22[1];
        } else if (order2 === 2) {
          return 6 * c22[3] * x2 + 2 * c22[2];
        } else {
          return 6 * c22[3];
        }
      }
      let low = 0, mid, high = xs.length - 1;
      while (low <= high) {
        mid = Math.floor(0.5 * (low + high));
        let xHere = xs[mid];
        if (xHere < x2) {
          low = mid + 1;
        } else if (xHere > x2) {
          high = mid - 1;
        } else {
          if (order2 === 1) {
            return coeffs[mid][1];
          } else if (order2 === 2) {
            return 2 * coeffs[mid][2];
          } else {
            return 6 * coeffs[mid][3];
          }
        }
      }
      let i3 = Math.max(0, high);
      x2 -= xs[i3];
      let c2 = coeffs[i3];
      if (order2 === 1) {
        return (3 * c2[3] * x2 + 2 * c2[2]) * x2 + c2[1];
      } else if (order2 === 2) {
        return 6 * c2[3] * x2 + 2 * c2[2];
      } else {
        return 6 * c2[3];
      }
    };
  };
}
function returnFunctionOperatorFunction({
  componentType,
  functionOperatorArguments,
  operatorComposesWithOriginal,
  originalFDefinition,
  numOutputs,
  component
}) {
  if (operatorComposesWithOriginal) {
    let childFs = [];
    for (let ind = 0; ind < numOutputs; ind++) {
      childFs.push(createFunctionFromDefinition(originalFDefinition));
    }
    let functionOperator = functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
    return (...xs) => functionOperator(...childFs.map((cf) => cf(...xs)));
  } else {
    return functionOperatorDefinitions[componentType](
      ...functionOperatorArguments
    );
  }
}
const functionOperatorDefinitions = {
  clampFunction: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      return Math.max(lowerValue, Math.min(upperValue, x2));
    };
  },
  wrapFunctionPeriodic: function(lowerValue, upperValue) {
    return function(x2) {
      if (!Number.isFinite(x2)) {
        return NaN;
      }
      let lower = lowerValue;
      let upper = upperValue;
      if (lower === upper) {
        return lower;
      }
      if (lower > upper) {
        [upper, lower] = [lower, upper];
      }
      return lower + mod$4(x2 - lower, upper - lower);
    };
  },
  derivative: function(derivDefinition, derivVariables) {
    if (derivDefinition.derivativeType === "interpolatedFunction") {
      let derivGenerator = returnReturnDerivativesOfInterpolatedFunction({
        xs: derivDefinition.xs,
        coeffs: derivDefinition.coeffs,
        variables: derivDefinition.variables.map(
          convertValueToMathExpression
        )
      });
      let vars = derivVariables.map(convertValueToMathExpression);
      if (derivDefinition.additionalDerivVariables) {
        let additionalVars = derivDefinition.additionalDerivVariables.map(
          convertValueToMathExpression
        );
        vars = [...additionalVars, ...vars];
      }
      if (derivDefinition.variableMappings) {
        for (let variableMapping of derivDefinition.variableMappings) {
          let mappedDerivVariables = [];
          for (let dVar of vars) {
            let mapped = variableMapping[dVar.subscripts_to_strings().tree];
            if (mapped) {
              mappedDerivVariables.push(
                convertValueToMathExpression(mapped)
              );
            } else {
              mappedDerivVariables.push(Context$2.fromAst("＿"));
            }
          }
          vars = mappedDerivVariables;
        }
      }
      let deriv = derivGenerator(vars);
      return deriv;
    } else {
      return () => NaN;
    }
  }
};
function returnODESolutionFunction({
  numDimensions,
  t0,
  x0s,
  chunkSize,
  tolerance,
  numericalRHSfDefinitions,
  maxIterations,
  component
}) {
  let workspace = {
    calculatedNumericSolutions: [],
    endingNumericalValues: [],
    maxPossibleTime: void 0
  };
  workspace.calculatedNumericSolutions = [];
  workspace.endingNumericalValues = [];
  workspace.maxPossibleTime = void 0;
  let numericalRHSfcomponents = numericalRHSfDefinitions.map(
    (x2) => createFunctionFromDefinition(x2)
  );
  let numericalRHSf = function(t24, x2) {
    let fargs = [t24];
    if (Array.isArray(x2)) {
      fargs.push(...x2);
    } else {
      fargs.push(x2);
    }
    try {
      return numericalRHSfcomponents.map((f2) => f2(...fargs));
    } catch (e2) {
      return [NaN];
    }
  };
  return function f2(t24) {
    if (!Number.isFinite(t24)) {
      return NaN;
    }
    if (t24 === t0) {
      return x0s[component];
    }
    let nChunksCalculated = workspace.calculatedNumericSolutions.length;
    let chunk2 = Math.ceil((t24 - t0) / chunkSize) - 1;
    if (chunk2 < 0) {
      return NaN;
    }
    if (workspace.maxPossibleTime === void 0 && chunk2 >= nChunksCalculated) {
      for (let tind = nChunksCalculated; tind <= chunk2; tind++) {
        let x0 = workspace.endingNumericalValues[tind - 1];
        if (x0 === void 0) {
          x0 = x0s;
        }
        let t0shifted = t0 + tind * chunkSize;
        let result2 = dopri$2(
          t0shifted,
          t0shifted + chunkSize,
          x0,
          numericalRHSf,
          tolerance,
          maxIterations
        );
        workspace.endingNumericalValues.push(
          result2.y[result2.y.length - 1]
        );
        workspace.calculatedNumericSolutions.push(
          result2.at.bind(result2)
        );
        let endingTime = result2.x[result2.x.length - 1];
        if (endingTime < (t0shifted + chunkSize) * (1 - 1e-6)) {
          workspace.maxPossibleTime = endingTime;
          break;
        }
      }
    }
    if (t24 > workspace.maxPossibleTime) {
      return NaN;
    }
    let value = workspace.calculatedNumericSolutions[chunk2](t24)[component];
    return value;
  };
}
const DEFAULT_MATH_INPUT_FUNCTION_NAMES = [
  "arg",
  "deg",
  "det",
  "dim",
  "exp",
  "gcd",
  "hom",
  "ker",
  "lg",
  "lim",
  "ln",
  "log",
  "max",
  "min",
  "Pr",
  "cos",
  "cosh",
  "acos",
  "acosh",
  "arccos",
  "arccosh",
  "cot",
  "coth",
  "acot",
  "acoth",
  "arccot",
  "arccoth",
  "csc",
  "csch",
  "acsc",
  "acsch",
  "arccsc",
  "arccsch",
  "sec",
  "sech",
  "asec",
  "asech",
  "arcsec",
  "arcsech",
  "sin",
  "sinh",
  "asin",
  "asinh",
  "arcsin",
  "arcsinh",
  "tan",
  "tanh",
  "atan",
  "atanh",
  "arctan",
  "arctanh",
  "nPr",
  "nCr"
];
const creativeCommonsVersions = [
  "1.0",
  "2.0",
  "2.5",
  "3.0",
  "4.0"
];
const defaultCreativeCommonsVersion$2 = "4.0";
function creativeCommonsLicense$2(code2, name2, urlSlug, description) {
  return {
    code: code2,
    name: `Creative Commons ${name2}`,
    description,
    kind: "creative-commons",
    url: (version2 = defaultCreativeCommonsVersion$2) => `https://creativecommons.org/licenses/${urlSlug}/${version2}/`
  };
}
function fixedUrlLicense$2(code2, name2, url, description, kind) {
  return {
    code: code2,
    name: name2,
    description,
    kind,
    url: () => url
  };
}
const mediaLicenses$2 = [
  creativeCommonsLicense$2(
    "CC-BY",
    "Attribution",
    "by",
    "Creative Commons Attribution: reuse with credit, including commercially."
  ),
  creativeCommonsLicense$2(
    "CC-BY-SA",
    "Attribution-ShareAlike",
    "by-sa",
    "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense$2(
    "CC-BY-ND",
    "Attribution-NoDerivatives",
    "by-nd",
    "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."
  ),
  creativeCommonsLicense$2(
    "CC-BY-NC",
    "Attribution-NonCommercial",
    "by-nc",
    "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."
  ),
  creativeCommonsLicense$2(
    "CC-BY-NC-SA",
    "Attribution-NonCommercial-ShareAlike",
    "by-nc-sa",
    "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense$2(
    "CC-BY-NC-ND",
    "Attribution-NonCommercial-NoDerivatives",
    "by-nc-nd",
    "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."
  ),
  fixedUrlLicense$2(
    "CC0",
    "CC0 1.0 Public Domain Dedication",
    "https://creativecommons.org/publicdomain/zero/1.0/",
    "Creative Commons Zero: the creator has dedicated the work to the public domain.",
    "public-domain"
  ),
  fixedUrlLicense$2(
    "PDM",
    "Public Domain Mark 1.0",
    "https://creativecommons.org/publicdomain/mark/1.0/",
    "Public Domain Mark: the work is free of known copyright restrictions.",
    "public-domain"
  ),
  fixedUrlLicense$2(
    "GFDL",
    "GNU Free Documentation License",
    "https://www.gnu.org/licenses/fdl-1.3.html",
    "GNU Free Documentation License: copyleft license common on Wikimedia.",
    "license"
  ),
  fixedUrlLicense$2(
    "FAL",
    "Free Art License 1.3",
    "https://artlibre.org/licence/lal/en/",
    "Free Art License: copyleft license for artistic works.",
    "license"
  ),
  fixedUrlLicense$2(
    "OGL",
    "Open Government Licence v3.0 (UK)",
    "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    "UK Open Government Licence: reuse government material with attribution.",
    "license"
  ),
  fixedUrlLicense$2(
    "MIT",
    "MIT License",
    "https://opensource.org/license/mit",
    "MIT License: permissive license common for icon and illustration sets.",
    "license"
  ),
  fixedUrlLicense$2(
    "APACHE-2.0",
    "Apache License 2.0",
    "https://www.apache.org/licenses/LICENSE-2.0",
    "Apache License 2.0: permissive license common for icon and illustration sets.",
    "license"
  )
];
const mediaLicensesByLowerCode = Object.fromEntries(
  mediaLicenses$2.map((info) => [info.code.toLowerCase(), info])
);
function getMediaLicenseInfo(code2) {
  return mediaLicensesByLowerCode[code2.toLowerCase()];
}
function getMediaLicenseDisplay(code2, version2) {
  const info = getMediaLicenseInfo(code2);
  if (!info) {
    return void 0;
  }
  const resolvedVersion = version2 ?? defaultCreativeCommonsVersion$2;
  const label2 = info.kind === "creative-commons" ? `${info.name} ${resolvedVersion}` : info.name;
  return { kind: info.kind, label: label2, url: info.url(resolvedVersion) };
}
const mathjaxConfig$1 = {
  tex: {
    tags: "ams",
    macros: {
      lt: "<",
      gt: ">",
      amp: "&",
      var: ["\\mathrm{#1}", 1],
      csch: "\\operatorname{csch}",
      sech: "\\operatorname{sech}",
      erf: "\\operatorname{erf}"
    },
    displayMath: [["\\[", "\\]"]]
  },
  output: {
    displayOverflow: "linebreak"
  }
};
function roundForDisplay({
  value,
  dependencyValues
}) {
  let rounded = Context$2.round_numbers_to_precision_plus_decimals(
    value,
    dependencyValues.displayDigits,
    dependencyValues.displayDecimals
  );
  if (dependencyValues.displayDigits > 0 && dependencyValues.displaySmallAsZero > 0) {
    rounded = Context$2.set_small_zero(
      rounded,
      dependencyValues.displaySmallAsZero
    );
  }
  return rounded;
}
const DARK_MODE_QUERY = "(prefers-color-scheme: dark)";
function getSystemTheme() {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return "light";
  }
  return window.matchMedia(DARK_MODE_QUERY).matches ? "dark" : "light";
}
function subscribeToSystemTheme(onChange) {
  if (typeof window === "undefined" || typeof window.matchMedia !== "function") {
    return () => {
    };
  }
  const mediaQuery = window.matchMedia(DARK_MODE_QUERY);
  if (typeof mediaQuery.addEventListener === "function") {
    mediaQuery.addEventListener("change", onChange);
    return () => mediaQuery.removeEventListener("change", onChange);
  }
  mediaQuery.addListener(onChange);
  return () => mediaQuery.removeListener(onChange);
}
var cssesc_1$2;
var hasRequiredCssesc$2;
function requireCssesc$2() {
  if (hasRequiredCssesc$2) return cssesc_1$2;
  hasRequiredCssesc$2 = 1;
  var object2 = {};
  var hasOwnProperty2 = object2.hasOwnProperty;
  var merge = function merge2(options2, defaults2) {
    if (!options2) {
      return defaults2;
    }
    var result2 = {};
    for (var key in defaults2) {
      result2[key] = hasOwnProperty2.call(options2, key) ? options2[key] : defaults2[key];
    }
    return result2;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string2, options2) {
    options2 = merge(options2, cssesc3.options);
    if (options2.quotes != "single" && options2.quotes != "double") {
      options2.quotes = "single";
    }
    var quote2 = options2.quotes == "double" ? '"' : "'";
    var isIdentifier = options2.isIdentifier;
    var firstChar = string2.charAt(0);
    var output = "";
    var counter2 = 0;
    var length = string2.length;
    while (counter2 < length) {
      var character = string2.charAt(counter2++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter2 < length) {
          var extra = string2.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter2--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options2.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote2 == character || character == "'" && quote2 == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options2.wrap) {
      return quote2 + output + quote2;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1$2 = cssesc2;
  return cssesc_1$2;
}
var cssescExports = requireCssesc$2();
const cssesc = /* @__PURE__ */ getDefaultExportFromCjs$4(cssescExports);
function cesc(s2) {
  s2 = cssesc(s2, { isIdentifier: true });
  if (s2.slice(0, 2) === "\\#") {
    s2 = s2.slice(1);
  }
  return s2;
}
const data_format_version = "0.7.0";
const proxyMarker = /* @__PURE__ */ Symbol("Comlink.proxy");
const createEndpoint = /* @__PURE__ */ Symbol("Comlink.endpoint");
const releaseProxy = /* @__PURE__ */ Symbol("Comlink.releaseProxy");
const finalizer = /* @__PURE__ */ Symbol("Comlink.finalizer");
const throwMarker = /* @__PURE__ */ Symbol("Comlink.thrown");
const isObject$3 = (val) => typeof val === "object" && val !== null || typeof val === "function";
const proxyTransferHandler = {
  canHandle: (val) => isObject$3(val) && val[proxyMarker],
  serialize(obj) {
    const { port1, port2 } = new MessageChannel();
    expose(obj, port1);
    return [port2, [port2]];
  },
  deserialize(port) {
    port.start();
    return wrap$4(port);
  }
};
const throwTransferHandler = {
  canHandle: (value) => isObject$3(value) && throwMarker in value,
  serialize({ value }) {
    let serialized;
    if (value instanceof Error) {
      serialized = {
        isError: true,
        value: {
          message: value.message,
          name: value.name,
          stack: value.stack
        }
      };
    } else {
      serialized = { isError: false, value };
    }
    return [serialized, []];
  },
  deserialize(serialized) {
    if (serialized.isError) {
      throw Object.assign(new Error(serialized.value.message), serialized.value);
    }
    throw serialized.value;
  }
};
const transferHandlers = /* @__PURE__ */ new Map([
  ["proxy", proxyTransferHandler],
  ["throw", throwTransferHandler]
]);
function isAllowedOrigin(allowedOrigins, origin) {
  for (const allowedOrigin of allowedOrigins) {
    if (origin === allowedOrigin || allowedOrigin === "*") {
      return true;
    }
    if (allowedOrigin instanceof RegExp && allowedOrigin.test(origin)) {
      return true;
    }
  }
  return false;
}
function expose(obj, ep = globalThis, allowedOrigins = ["*"]) {
  ep.addEventListener("message", function callback(ev) {
    if (!ev || !ev.data) {
      return;
    }
    if (!isAllowedOrigin(allowedOrigins, ev.origin)) {
      console.warn(`Invalid origin '${ev.origin}' for comlink proxy`);
      return;
    }
    const { id: id2, type, path } = Object.assign({ path: [] }, ev.data);
    const argumentList = (ev.data.argumentList || []).map(fromWireValue);
    let returnValue;
    try {
      const parent = path.slice(0, -1).reduce((obj2, prop) => obj2[prop], obj);
      const rawValue = path.reduce((obj2, prop) => obj2[prop], obj);
      switch (type) {
        case "GET":
          {
            returnValue = rawValue;
          }
          break;
        case "SET":
          {
            parent[path.slice(-1)[0]] = fromWireValue(ev.data.value);
            returnValue = true;
          }
          break;
        case "APPLY":
          {
            returnValue = rawValue.apply(parent, argumentList);
          }
          break;
        case "CONSTRUCT":
          {
            const value = new rawValue(...argumentList);
            returnValue = proxy(value);
          }
          break;
        case "ENDPOINT":
          {
            const { port1, port2 } = new MessageChannel();
            expose(obj, port2);
            returnValue = transfer(port1, [port1]);
          }
          break;
        case "RELEASE":
          {
            returnValue = void 0;
          }
          break;
        default:
          return;
      }
    } catch (value) {
      returnValue = { value, [throwMarker]: 0 };
    }
    Promise.resolve(returnValue).catch((value) => {
      return { value, [throwMarker]: 0 };
    }).then((returnValue2) => {
      const [wireValue, transferables] = toWireValue(returnValue2);
      ep.postMessage(Object.assign(Object.assign({}, wireValue), { id: id2 }), transferables);
      if (type === "RELEASE") {
        ep.removeEventListener("message", callback);
        closeEndPoint(ep);
        if (finalizer in obj && typeof obj[finalizer] === "function") {
          obj[finalizer]();
        }
      }
    }).catch((error) => {
      const [wireValue, transferables] = toWireValue({
        value: new TypeError("Unserializable return value"),
        [throwMarker]: 0
      });
      ep.postMessage(Object.assign(Object.assign({}, wireValue), { id: id2 }), transferables);
    });
  });
  if (ep.start) {
    ep.start();
  }
}
function isMessagePort(endpoint) {
  return endpoint.constructor.name === "MessagePort";
}
function closeEndPoint(endpoint) {
  if (isMessagePort(endpoint))
    endpoint.close();
}
function wrap$4(ep, target) {
  const pendingListeners = /* @__PURE__ */ new Map();
  ep.addEventListener("message", function handleMessage(ev) {
    const { data } = ev;
    if (!data || !data.id) {
      return;
    }
    const resolver2 = pendingListeners.get(data.id);
    if (!resolver2) {
      return;
    }
    try {
      resolver2(data);
    } finally {
      pendingListeners.delete(data.id);
    }
  });
  return createProxy$1(ep, pendingListeners, [], target);
}
function throwIfProxyReleased(isReleased) {
  if (isReleased) {
    throw new Error("Proxy has been released and is not useable");
  }
}
function releaseEndpoint(ep) {
  return requestResponseMessage(ep, /* @__PURE__ */ new Map(), {
    type: "RELEASE"
  }).then(() => {
    closeEndPoint(ep);
  });
}
const proxyCounter = /* @__PURE__ */ new WeakMap();
const proxyFinalizers = "FinalizationRegistry" in globalThis && new FinalizationRegistry((ep) => {
  const newCount = (proxyCounter.get(ep) || 0) - 1;
  proxyCounter.set(ep, newCount);
  if (newCount === 0) {
    releaseEndpoint(ep);
  }
});
function registerProxy(proxy2, ep) {
  const newCount = (proxyCounter.get(ep) || 0) + 1;
  proxyCounter.set(ep, newCount);
  if (proxyFinalizers) {
    proxyFinalizers.register(proxy2, ep, proxy2);
  }
}
function unregisterProxy(proxy2) {
  if (proxyFinalizers) {
    proxyFinalizers.unregister(proxy2);
  }
}
function createProxy$1(ep, pendingListeners, path = [], target = function() {
}) {
  let isProxyReleased = false;
  const proxy2 = new Proxy(target, {
    get(_target, prop) {
      throwIfProxyReleased(isProxyReleased);
      if (prop === releaseProxy) {
        return () => {
          unregisterProxy(proxy2);
          releaseEndpoint(ep);
          pendingListeners.clear();
          isProxyReleased = true;
        };
      }
      if (prop === "then") {
        if (path.length === 0) {
          return { then: () => proxy2 };
        }
        const r2 = requestResponseMessage(ep, pendingListeners, {
          type: "GET",
          path: path.map((p2) => p2.toString())
        }).then(fromWireValue);
        return r2.then.bind(r2);
      }
      return createProxy$1(ep, pendingListeners, [...path, prop]);
    },
    set(_target, prop, rawValue) {
      throwIfProxyReleased(isProxyReleased);
      const [value, transferables] = toWireValue(rawValue);
      return requestResponseMessage(ep, pendingListeners, {
        type: "SET",
        path: [...path, prop].map((p2) => p2.toString()),
        value
      }, transferables).then(fromWireValue);
    },
    apply(_target, _thisArg, rawArgumentList) {
      throwIfProxyReleased(isProxyReleased);
      const last2 = path[path.length - 1];
      if (last2 === createEndpoint) {
        return requestResponseMessage(ep, pendingListeners, {
          type: "ENDPOINT"
        }).then(fromWireValue);
      }
      if (last2 === "bind") {
        return createProxy$1(ep, pendingListeners, path.slice(0, -1));
      }
      const [argumentList, transferables] = processArguments(rawArgumentList);
      return requestResponseMessage(ep, pendingListeners, {
        type: "APPLY",
        path: path.map((p2) => p2.toString()),
        argumentList
      }, transferables).then(fromWireValue);
    },
    construct(_target, rawArgumentList) {
      throwIfProxyReleased(isProxyReleased);
      const [argumentList, transferables] = processArguments(rawArgumentList);
      return requestResponseMessage(ep, pendingListeners, {
        type: "CONSTRUCT",
        path: path.map((p2) => p2.toString()),
        argumentList
      }, transferables).then(fromWireValue);
    }
  });
  registerProxy(proxy2, ep);
  return proxy2;
}
function myFlat(arr) {
  return Array.prototype.concat.apply([], arr);
}
function processArguments(argumentList) {
  const processed = argumentList.map(toWireValue);
  return [processed.map((v2) => v2[0]), myFlat(processed.map((v2) => v2[1]))];
}
const transferCache = /* @__PURE__ */ new WeakMap();
function transfer(obj, transfers) {
  transferCache.set(obj, transfers);
  return obj;
}
function proxy(obj) {
  return Object.assign(obj, { [proxyMarker]: true });
}
function toWireValue(value) {
  for (const [name2, handler] of transferHandlers) {
    if (handler.canHandle(value)) {
      const [serializedValue, transferables] = handler.serialize(value);
      return [
        {
          type: "HANDLER",
          name: name2,
          value: serializedValue
        },
        transferables
      ];
    }
  }
  return [
    {
      type: "RAW",
      value
    },
    transferCache.get(value) || []
  ];
}
function fromWireValue(value) {
  switch (value.type) {
    case "HANDLER":
      return transferHandlers.get(value.name).deserialize(value.value);
    case "RAW":
      return value.value;
  }
}
function requestResponseMessage(ep, pendingListeners, msg, transfers) {
  return new Promise((resolve) => {
    const id2 = generateUUID();
    pendingListeners.set(id2, resolve);
    if (ep.start) {
      ep.start();
    }
    ep.postMessage(Object.assign({ id: id2 }, msg), transfers);
  });
}
function generateUUID() {
  return new Array(4).fill(0).map(() => Math.floor(Math.random() * Number.MAX_SAFE_INTEGER).toString(16)).join("-");
}
var DefaultContext$1 = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext$1 = React__default.createContext && /* @__PURE__ */ React__default.createContext(DefaultContext$1);
var _excluded$2 = ["attr", "size", "title"];
function _objectWithoutProperties$1(e2, t4) {
  if (null == e2) return {};
  var o2, r2, i2 = _objectWithoutPropertiesLoose$2(e2, t4);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e2);
    for (r2 = 0; r2 < n2.length; r2++) o2 = n2[r2], -1 === t4.indexOf(o2) && {}.propertyIsEnumerable.call(e2, o2) && (i2[o2] = e2[o2]);
  }
  return i2;
}
function _objectWithoutPropertiesLoose$2(r2, e2) {
  if (null == r2) return {};
  var t4 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e2.indexOf(n2)) continue;
    t4[n2] = r2[n2];
  }
  return t4;
}
function _extends$4() {
  return _extends$4 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t4 = arguments[e2];
      for (var r2 in t4) ({}).hasOwnProperty.call(t4, r2) && (n2[r2] = t4[r2]);
    }
    return n2;
  }, _extends$4.apply(null, arguments);
}
function ownKeys$6(e2, r2) {
  var t4 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e2);
    r2 && (o2 = o2.filter(function(r3) {
      return Object.getOwnPropertyDescriptor(e2, r3).enumerable;
    })), t4.push.apply(t4, o2);
  }
  return t4;
}
function _objectSpread$6(e2) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t4 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$6(Object(t4), true).forEach(function(r3) {
      _defineProperty$3(e2, r3, t4[r3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t4)) : ownKeys$6(Object(t4)).forEach(function(r3) {
      Object.defineProperty(e2, r3, Object.getOwnPropertyDescriptor(t4, r3));
    });
  }
  return e2;
}
function _defineProperty$3(e2, r2, t4) {
  return (r2 = _toPropertyKey$1(r2)) in e2 ? Object.defineProperty(e2, r2, { value: t4, enumerable: true, configurable: true, writable: true }) : e2[r2] = t4, e2;
}
function _toPropertyKey$1(t4) {
  var i2 = _toPrimitive$1(t4, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _toPrimitive$1(t4, r2) {
  if ("object" != typeof t4 || !t4) return t4;
  var e2 = t4[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t4, r2);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t4);
}
function Tree2Element$1(tree) {
  return tree && tree.map((node, i2) => /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread$6({
    key: i2
  }, node.attr), Tree2Element$1(node.child)));
}
function GenIcon$1(data) {
  return (props2) => /* @__PURE__ */ React__default.createElement(IconBase$1, _extends$4({
    attr: _objectSpread$6({}, data.attr)
  }, props2), Tree2Element$1(data.child));
}
function IconBase$1(props2) {
  var elem = (conf) => {
    var attr = props2.attr, size2 = props2.size, title = props2.title, svgProps = _objectWithoutProperties$1(props2, _excluded$2);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props2.className) className = (className ? className + " " : "") + props2.className;
    return /* @__PURE__ */ React__default.createElement("svg", _extends$4({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread$6(_objectSpread$6({
        color: props2.color || conf.color
      }, conf.style), props2.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ React__default.createElement("title", null, title), props2.children);
  };
  return IconContext$1 !== void 0 ? /* @__PURE__ */ React__default.createElement(IconContext$1.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext$1);
}
function MdError(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m1 15h-2v-2h2zm0-4h-2V7h2z" }, "child": [] }] })(props2);
}
function MdInfoOutline(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 24 24" }, "child": [{ "tag": "path", "attr": { "fill": "none", "d": "M0 0h24v24H0z" }, "child": [] }, { "tag": "path", "attr": { "d": "M11 7h2v2h-2zm0 4h2v6h-2zm1-9C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2m0 18c-4.41 0-8-3.59-8-8s3.59-8 8-8 8 3.59 8 8-3.59 8-8 8" }, "child": [] }] })(props2);
}
function promisifyRequest(request) {
  return new Promise((resolve, reject2) => {
    request.oncomplete = request.onsuccess = () => resolve(request.result);
    request.onabort = request.onerror = () => reject2(request.error);
  });
}
function createStore$4(dbName, storeName) {
  let dbp;
  const getDB = () => {
    if (dbp)
      return dbp;
    const request = indexedDB.open(dbName);
    request.onupgradeneeded = () => request.result.createObjectStore(storeName);
    dbp = promisifyRequest(request);
    dbp.then((db) => {
      db.onclose = () => dbp = void 0;
    }, () => {
    });
    return dbp;
  };
  return (txMode, callback) => getDB().then((db) => callback(db.transaction(storeName, txMode).objectStore(storeName)));
}
let defaultGetStoreFunc;
function defaultGetStore() {
  if (!defaultGetStoreFunc) {
    defaultGetStoreFunc = createStore$4("keyval-store", "keyval");
  }
  return defaultGetStoreFunc;
}
function get$4(key, customStore = defaultGetStore()) {
  return customStore("readonly", (store2) => promisifyRequest(store2.get(key)));
}
if (typeof window === "undefined") {
  globalThis.window = globalThis;
}
const doenetGlobalConfig = {
  doenetWorkerUrl: getWorkerUrl()
};
window.doenetGlobalConfig = doenetGlobalConfig;
function getWorkerUrl() {
  try {
    return new URL(
      "/doenetml-worker/index.js",
      window?.location?.href || "https://doenet.org"
    ).href;
  } catch (e2) {
    return "https://doenet.org/doenetml-worker/index.js";
  }
}
function ccount$1(value, character) {
  const source = String(value);
  if (typeof character !== "string") {
    throw new TypeError("Expected character");
  }
  let count = 0;
  let index2 = source.indexOf(character);
  while (index2 !== -1) {
    count++;
    index2 = source.indexOf(character, index2 + character.length);
  }
  return count;
}
const defaultSubsetRegex$1 = /["&'<>`]/g;
const surrogatePairsRegex$1 = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const controlCharactersRegex$1 = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
);
const regexEscapeRegex$1 = /[|\\{}()[\]^$+*?.]/g;
const subsetToRegexCache$1 = /* @__PURE__ */ new WeakMap();
function core$3(value, options2) {
  value = value.replace(
    options2.subset ? charactersToExpressionCached$1(options2.subset) : defaultSubsetRegex$1,
    basic
  );
  if (options2.subset || options2.escapeOnly) {
    return value;
  }
  return value.replace(surrogatePairsRegex$1, surrogate).replace(controlCharactersRegex$1, basic);
  function surrogate(pair2, index2, all2) {
    return options2.format(
      (pair2.charCodeAt(0) - 55296) * 1024 + pair2.charCodeAt(1) - 56320 + 65536,
      all2.charCodeAt(index2 + 2),
      options2
    );
  }
  function basic(character, index2, all2) {
    return options2.format(
      character.charCodeAt(0),
      all2.charCodeAt(index2 + 1),
      options2
    );
  }
}
function charactersToExpressionCached$1(subset) {
  let cached = subsetToRegexCache$1.get(subset);
  if (!cached) {
    cached = charactersToExpression$1(subset);
    subsetToRegexCache$1.set(subset, cached);
  }
  return cached;
}
function charactersToExpression$1(subset) {
  const groups = [];
  let index2 = -1;
  while (++index2 < subset.length) {
    groups.push(subset[index2].replace(regexEscapeRegex$1, "\\$&"));
  }
  return new RegExp("(?:" + groups.join("|") + ")", "g");
}
function formatBasic$1(code2) {
  return "&#x" + code2.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight$1(value, options2) {
  return core$3(value, Object.assign({ format: formatBasic$1 }, options2));
}
function escape$3(value, subset, unsafe) {
  const result2 = clean$3(value);
  return unsafe ? result2.replace(unsafe, encode2) : encode2(result2);
  function encode2(value2) {
    return stringifyEntitiesLight$1(value2, { subset }).replace(/&#x3C;/g, "&lt;").replace(/&#x26;/g, "&amp;");
  }
}
const nonCharacter$1 = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;
function clean$3(value) {
  return String(value || "").replace(nonCharacter$1, "");
}
function name$d(value) {
  const subset = ["	", "\n", " ", '"', "&", "'", "/", "<", "=", ">"];
  return escape$3(value, subset);
}
function mergeAdjacentTextInArray$1(nodes) {
  const needsMerging = nodes.some(
    (n2, i2) => n2.type === "text" && nodes[i2 + 1]?.type === "text"
  );
  if (!needsMerging) {
    return nodes;
  }
  const ret = [];
  for (let i2 = 0; i2 < nodes.length; i2++) {
    let node = nodes[i2];
    let nextNode = nodes[i2 + 1];
    if (!nextNode) {
      ret.push(node);
      continue;
    }
    if (node.type === "text" && nextNode.type === "text") {
      node = { ...node };
      ret.push(node);
      while (nextNode?.type === "text") {
        node.value += nextNode.value;
        if (node.position && nextNode.position) {
          node.position.end = nextNode.position.end;
        }
        i2++;
        nextNode = nodes[i2 + 1];
      }
    } else {
      ret.push(node);
    }
  }
  return ret;
}
function findNodesWithPositionInfo$1(nodes) {
  if (typeof nodes !== "object" || nodes === null) {
    return [];
  }
  if (Array.isArray(nodes)) {
    return nodes.flatMap(findNodesWithPositionInfo$1);
  }
  if (!("type" in nodes)) {
    return [];
  }
  const ret = "position" in nodes ? [nodes] : [];
  for (const value of Object.values(nodes)) {
    if (Array.isArray(value)) {
      ret.push(...findNodesWithPositionInfo$1(value));
    }
  }
  return ret;
}
function macroToString$1(node) {
  if (Array.isArray(node)) {
    return node.map((n2) => macroToString$1(n2)).join("");
  }
  switch (node.type) {
    case "macro": {
      const macro = unwrappedMacroToString$1$1(node);
      let start = "$";
      let end = "";
      if (macroNeedsParens$1$1(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      const macro = unwrappedMacroToString$1$1(node.macro);
      let start = "$$";
      let end = "";
      if (macroNeedsParens$1$1(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map(macroToString$1).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "text":
      return toXml$1(node);
    default:
      console.warn("Unhandled node type", node);
  }
  return "$ERROR";
}
function unwrappedMacroToString$1$1(nodes) {
  const path = macroPathToString$1$1(nodes.path);
  const attrs = Object.values(nodes.attributes || {}).map(attrToString$1$1).join(" ");
  let attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  let propAccess = "";
  if (nodes.accessedProp) {
    propAccess = "." + unwrappedMacroToString$1$1(nodes.accessedProp);
  }
  return path + attrsStr + propAccess;
}
function macroPathToString$1$1(path) {
  return path.map(macroPathPartToString$1$1).join("/");
}
function macroPathPartToString$1$1(pathPart) {
  return pathPart.name + pathPart.index.map((part) => `[${macroToString$1(part.value)}]`).join("");
}
function attrToString$1$1(attr) {
  const name2 = attr.name;
  if (attr.children.length === 0) {
    return name2;
  }
  const value = attr.children.map(macroToString$1).join("");
  return `${name2}=${quote$1(value)}`;
}
function macroNeedsParens$1$1(macro) {
  if (macro.type === "function") {
    return macroNeedsParens$1$1(macro.macro);
  }
  if (macro.path.length > 1) {
    return true;
  }
  return macro.path.some((part) => part.name.includes("-")) || macro.accessedProp != null && macroNeedsParens$1$1(macro.accessedProp);
}
function toXml$1(tree, options2) {
  options2 = options2 || {};
  if (!tree) {
    return "";
  }
  const node = Array.isArray(tree) ? { type: "root", children: tree } : tree;
  return nodesToXml$1(node, options2);
}
function nodesToXml$1(node, options2) {
  if (Array.isArray(node)) {
    if (!node.some((n2) => n2.type === "pathPart")) {
      return mergeAdjacentTextInArray$1(node).map((child) => nodesToXml$1(child, options2)).join("");
    } else {
      return node.map((part) => nodesToXml$1(part, options2)).join(".");
    }
  }
  const type = node && node.type;
  switch (node?.type) {
    case "root":
      return nodesToXml$1(node.children, options2);
    case "cdata": {
      const unsafe = /]]>/g;
      const subset = [">"];
      return "<![CDATA[" + escape$3(node.value, subset, unsafe) + "]]>";
    }
    case "comment":
      return "<!--" + escape$3(node.value, ["-"]) + "-->";
    case "doctype": {
      const nodeName = name$d(node.name);
      const pub = node.public;
      const sys = node.system;
      let result2 = "<!DOCTYPE";
      if (nodeName !== "") {
        result2 += " " + nodeName;
      }
      if (pub) {
        result2 += " PUBLIC " + quote$1(pub);
      } else if (sys) {
        result2 += " SYSTEM";
      }
      if (sys) {
        result2 += " " + quote$1(sys);
      }
      return result2 + ">";
    }
    case "attribute": {
      return attrToString$2(node, options2);
    }
    case "element": {
      const nodeName = name$d(node.name);
      const content2 = nodesToXml$1(node.children, options2);
      const attributes = node.attributes || [];
      const attrs = Object.values(attributes).map(
        (attr) => attrToString$2(attr, options2)
      );
      const printedAttrs = (attrs.length > 0 ? " " : "") + attrs.join(" ");
      if (node.children.length === 0 || !options2.inlineErrors && node.children.every((c2) => c2.type === "error")) {
        return `<${nodeName}${printedAttrs} />`;
      }
      return `<${nodeName}${printedAttrs}>${content2}</${nodeName}>`;
    }
    case "instruction": {
      const unsafe = /\?>/g;
      const subset = [">"];
      const nodeName = name$d(node.name);
      const result2 = escape$3(node.value, subset, unsafe);
      return "<?" + nodeName + (result2 ? " " + result2 : "") + "?>";
    }
    case "text": {
      let escapedText = escape$3(node.value, ["&", "<"]);
      if (options2.doenetSyntax) {
        escapedText = escapedText.replace(/&lt;(?=\s|=)/g, "<");
        escapedText = escapedText.replace(/&amp;(?!\S*;)/g, "&");
      }
      return escapedText;
    }
    case "error": {
      if (options2.inlineErrors) {
        const errorElement = {
          type: "element",
          name: "_error",
          attributes: {
            message: {
              type: "attribute",
              name: "message",
              children: [{ type: "text", value: node.message }]
            }
          },
          children: [{ type: "text", value: node.message }]
        };
        return nodesToXml$1(errorElement, options2);
      }
      return "";
    }
    case "macro": {
      if (node.version === "0.6") {
        return macroToString$1(node);
      }
      const macro = unwrappedMacroToString$2(node, options2);
      let start = "$";
      let end = "";
      if (macroNeedsParens$2(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      if (node.version === "0.6") {
        return macroToString$1(node);
      }
      const macro = unwrappedMacroToString$2(node, options2);
      let start = "$$";
      let end = "";
      if (macroNeedsParens$2(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map((a2) => nodesToXml$1(a2, options2)).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "pathPart": {
      return node.name + node.index.map((ind) => `[${nodesToXml$1(ind.value, options2)}]`).join("");
    }
  }
  if (!type) {
    throw new Error("Expected node, not `" + node + "`");
  }
  throw new Error("Cannot compile unknown node `" + type + "`");
}
function quote$1(value) {
  const result2 = String(value);
  let quoteMark = '"';
  const other = quoteMark === '"' ? "'" : '"';
  if (ccount$1(result2, quoteMark) > ccount$1(result2, other)) {
    quoteMark = other;
  }
  return quoteMark + escape$3(result2, ["<", quoteMark]) + quoteMark;
}
function unwrappedMacroToString$2(nodes, options2) {
  const path = macroPathToString$2(nodes.path, options2);
  let attrsStr = "";
  if (nodes.type === "macro") {
    const attrs = Object.values(nodes.attributes || {}).map((a2) => attrToString$2(a2, options2)).join(" ");
    attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  }
  let propAccess = "";
  return path + attrsStr + propAccess;
}
function macroPathToString$2(path, options2) {
  return path.map((part) => macroPathPartToString$2(part, options2)).join(".");
}
function macroPathPartToString$2(pathPart, options2) {
  return pathPart.name + pathPart.index.map((part) => `[${nodesToXml$1(part.value, options2)}]`).join("");
}
function attrToString$2(attr, options2) {
  if (attr.children.length === 0) {
    if (options2.doenetSyntax) {
      return name$d(attr.name);
    }
    return `${name$d(attr.name)}="true"`;
  }
  return `${name$d(attr.name)}=${quote$1(nodesToXml$1(attr.children, options2))}`;
}
function macroNeedsParens$2(macro) {
  return macro.path.some((part) => part.name.includes("-"));
}
const StartTag$1 = 1, StartCloseTag$1 = 2, MissingCloseTag$1 = 3, mismatchedStartCloseTag$1 = 4, incompleteStartCloseTag$1 = 5, commentContent$1$1 = 36, piContent$1$1 = 37, cdataContent$1$1 = 38, Text$2 = 7, Element$2 = 12, EndTag$1 = 13, OpenTag$1 = 14, TagName$F = 15, Attribute$1 = 16, AttributeValue$1 = 19, CloseTag$1 = 20, SelfCloseEndTag$1 = 21, SelfClosingTag$1 = 22, MismatchedCloseTag$1 = 25;
const DefaultBufferLength$2 = 1024;
let nextPropID$2 = 0;
let Range$5 = class Range2 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
};
let NodeProp$2 = class NodeProp2 {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID$2++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType$2.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
};
NodeProp$2.closedBy = new NodeProp$2({ deserialize: (str) => str.split(" ") });
NodeProp$2.openedBy = new NodeProp$2({ deserialize: (str) => str.split(" ") });
NodeProp$2.group = new NodeProp$2({ deserialize: (str) => str.split(" ") });
NodeProp$2.isolate = new NodeProp$2({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp$2.contextHash = new NodeProp$2({ perNode: true });
NodeProp$2.lookAhead = new NodeProp$2({ perNode: true });
NodeProp$2.mounted = new NodeProp$2({ perNode: true });
let MountedTree$2 = class MountedTree2 {
  constructor(tree, overlay, parser2, bracketed = false) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
    this.bracketed = bracketed;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp$2.mounted.id];
  }
};
const noProps$2 = /* @__PURE__ */ Object.create(null);
let NodeType$2 = class NodeType2 {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps$2;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType2(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp$2.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp$2.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
};
NodeType$2.none = new NodeType$2(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
let NodeSet$1 = class NodeSet2 {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(types2) {
    this.types = types2;
    for (let i2 = 0; i2 < types2.length; i2++)
      if (types2[i2].id != i2)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...props2) {
    let newTypes = [];
    for (let type of this.types) {
      let newProps = null;
      for (let source of props2) {
        let add2 = source(type);
        if (add2) {
          if (!newProps)
            newProps = Object.assign({}, type.props);
          let value = add2[1], prop = add2[0];
          if (prop.combine && prop.id in newProps)
            value = prop.combine(newProps[prop.id], value);
          newProps[prop.id] = value;
        }
      }
      newTypes.push(newProps ? new NodeType$2(type.name, newProps, type.id, type.flags) : type);
    }
    return new NodeSet2(newTypes);
  }
};
const CachedNode$2 = /* @__PURE__ */ new WeakMap(), CachedInnerNode$2 = /* @__PURE__ */ new WeakMap();
var IterMode$2;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
  IterMode2[IterMode2["EnterBracketed"] = 16] = "EnterBracketed";
})(IterMode$2 || (IterMode$2 = {}));
let Tree$2 = class Tree2 {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree$2.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor$2(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode$2.get(this) || this.topNode;
    let cursor2 = new TreeCursor$2(scope);
    cursor2.moveTo(pos, side);
    CachedNode$2.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode$2(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode$2(CachedNode$2.get(this) || this.topNode, pos, side, false);
    CachedNode$2.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode$2(CachedInnerNode$2.get(this) || this.topNode, pos, side, true);
    CachedInnerNode$2.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator$2(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode$2.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode$2.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange$2(NodeType$2.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree2(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree2(NodeType$2.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree$2(data);
  }
};
Tree$2.empty = new Tree$2(NodeType$2.none, [], [], 0);
let FlatBufferCursor$2 = class FlatBufferCursor2 {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor2(this.buffer, this.index);
  }
};
let TreeBuffer$2 = class TreeBuffer2 {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType$2.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick2 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide$2(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick2 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick2;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer2(copy2, len, this.set);
  }
};
function checkSide$2(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode$2(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode$2 && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode$2.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode$2 && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
let BaseNode$2 = class BaseNode2 {
  cursor(mode = 0) {
    return new TreeCursor$2(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r2 = getChildren$2(this, type, before2, after2);
    return r2.length ? r2[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren$2(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode$2(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode$2(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext$2(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
};
let TreeNode$2 = class TreeNode2 extends BaseNode$2 {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from, mounted;
        if (!(mode & IterMode$2.EnterBracketed && next instanceof Tree$2 && (mounted = MountedTree$2.get(next)) && !mounted.overlay && mounted.bracketed && pos >= start && pos <= start + next.length) && !checkSide$2(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer$2) {
          if (mode & IterMode$2.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode$2(new BufferContext$2(parent, next, i2, start), null, index2);
        } else if (mode & IterMode$2.IncludeAnonymous || (!next.type.isAnonymous || hasChild$2(next))) {
          let mounted2;
          if (!(mode & IterMode$2.IgnoreMounts) && (mounted2 = MountedTree$2.get(next)) && !mounted2.overlay)
            return new TreeNode2(mounted2.tree, start, i2, parent);
          let inner = new TreeNode2(next, start, i2, parent);
          return mode & IterMode$2.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side, mode);
        }
      }
      if (mode & IterMode$2.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode$2.IgnoreOverlays) && (mounted = MountedTree$2.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from, enterBracketed = mode & IterMode$2.EnterBracketed && mounted.bracketed;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 || enterBracketed ? from <= rPos : from < rPos) && (side < 0 || enterBracketed ? to2 >= rPos : to2 > rPos))
          return new TreeNode2(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
};
function getChildren$2(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext$2(node, context, i2 = context.length - 1) {
  for (let p2 = node; i2 >= 0; p2 = p2.parent) {
    if (!p2)
      return false;
    if (!p2.type.isAnonymous) {
      if (context[i2] && context[i2] != p2.name)
        return false;
      i2--;
    }
  }
  return true;
}
let BufferContext$2 = class BufferContext2 {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
};
let BufferNode$2 = class BufferNode2 extends BaseNode$2 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode2(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode$2.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode2(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode2(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode2(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree$2(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
};
function iterStack$2(heads) {
  if (!heads.length)
    return null;
  let pick2 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick2 = i2;
    }
  }
  let next = picked instanceof TreeNode$2 && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick2] = next;
  else
    newHeads.splice(pick2, 1);
  return new StackIterator$2(newHeads, picked);
}
let StackIterator$2 = class StackIterator2 {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack$2(this.heads);
  }
};
function stackIterator$2(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode$2 ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree$2.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode$2(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode$2(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack$2(layers) : inner;
}
let TreeCursor$2 = class TreeCursor2 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    this.mode = mode & ~IterMode$2.EnterBracketed;
    if (node instanceof TreeNode$2) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n2 = node._parent; n2; n2 = n2._parent)
        this.stack.unshift(n2.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode$2) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode$2.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode$2.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode$2.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d2 = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d2 < 0 ? 0 : this.stack[d2] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d2 < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d2] + 3]))
        return this.yieldBuf(after2);
    }
    return d2 < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode$2.IncludeAnonymous || child instanceof TreeBuffer$2 || !child.type.isAnonymous || hasChild$2(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d2 = this.stack.length; d2 >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d2 + 1;
            break scan;
          }
        index2 = this.stack[--d2];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode$2(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode$2(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext$2(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d2 = this.stack.length - 1; i2 >= 0; d2--) {
      if (d2 < 0)
        return matchNodeContext$2(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d2]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
};
function hasChild$2(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer$2 || !ch.type.isAnonymous || hasChild$2(ch));
}
function buildTree$2(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength$2, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor$2(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer$2(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange$2(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer$2(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree$2) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp$2.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp$2.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp$2.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree$2(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree$2(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache$2 = /* @__PURE__ */ new WeakMap();
function nodeSize$2(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer$2 || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache$2.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree$2)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize$2(balanceType, child);
    }
    nodeSizeCache$2.set(node, size2);
  }
  return size2;
}
function balanceRange$2(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize$2(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize$2(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize$2(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange$2(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
let Parser$2 = class Parser2 {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput$2(input);
    ranges = !ranges ? [new Range$5(0, input.length)] : ranges.length ? ranges.map((r2) => new Range$5(r2.from, r2.to)) : [new Range$5(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
};
let StringInput$2 = class StringInput2 {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
};
new NodeProp$2({ perNode: true });
let Stack$1 = class Stack2 {
  /**
  @internal
  */
  constructor(p2, stack, state, reducePos, pos, score2, buffer, bufferBase, curContext, lookAhead = 0, parent) {
    this.p = p2;
    this.stack = stack;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score2;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((_2, i2) => i2 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(p2, state, pos = 0) {
    let cx = p2.parser.context;
    return new Stack2(p2, [], state, pos, pos, 0, [], 0, cx ? new StackContext$1(cx, cx.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(state, start) {
    this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
    this.state = state;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(action) {
    var _a2;
    let depth = action >> 19, type = action & 65535;
    let { parser: parser2 } = this.p;
    let lookaheadRecord = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos);
    let dPrec = parser2.dynamicPrecedence(type);
    if (dPrec)
      this.score += dPrec;
    if (depth == 0) {
      if (type < parser2.minRepeatTerm && this.reducePos < this.pos)
        this.reducePos = this.pos;
      this.pushState(parser2.getGoto(this.state, type, true), this.reducePos);
      if (type < parser2.minRepeatTerm)
        this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
      this.reduceContext(type, this.reducePos);
      return;
    }
    let base2 = this.stack.length - (depth - 1) * 3 - (action & 262144 ? 6 : 0);
    let start = base2 ? this.stack[base2 - 2] : this.p.ranges[0].from;
    if (type < parser2.minRepeatTerm && start == this.reducePos && this.reducePos < this.pos)
      this.reducePos = this.pos;
    let size2 = this.reducePos - start;
    if (size2 >= 2e3 && !((_a2 = this.p.parser.nodeSet.types[type]) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
      if (start == this.p.lastBigReductionStart) {
        this.p.bigReductionCount++;
        this.p.lastBigReductionSize = size2;
      } else if (this.p.lastBigReductionSize < size2) {
        this.p.bigReductionCount = 1;
        this.p.lastBigReductionStart = start;
        this.p.lastBigReductionSize = size2;
      }
    }
    let bufferBase = base2 ? this.stack[base2 - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
    if (type < parser2.minRepeatTerm || action & 131072) {
      let pos = parser2.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(type, start, pos, count + 4, true);
    }
    if (action & 262144) {
      this.state = this.stack[base2];
    } else {
      let baseStateID = this.stack[base2 - 3];
      this.state = parser2.getGoto(baseStateID, type, true);
    }
    while (this.stack.length > base2)
      this.stack.pop();
    this.reduceContext(type, start);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(term, start, end, size2 = 4, mustSink = false) {
    if (term == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let top2 = this.buffer.length;
      if (top2 > 0 && this.buffer[top2 - 4] == 0 && this.buffer[top2 - 1] > -1) {
        if (start == end)
          return;
        if (this.buffer[top2 - 2] >= start) {
          this.buffer[top2 - 2] = end;
          return;
        }
      }
    }
    if (!mustSink || this.pos == end) {
      this.buffer.push(term, start, end, size2);
    } else {
      let index2 = this.buffer.length;
      if (index2 > 0 && (this.buffer[index2 - 4] != 0 || this.buffer[index2 - 1] < 0)) {
        let mustMove = false;
        for (let scan = index2; scan > 0 && this.buffer[scan - 2] > end; scan -= 4) {
          if (this.buffer[scan - 1] >= 0) {
            mustMove = true;
            break;
          }
        }
        if (mustMove)
          while (index2 > 0 && this.buffer[index2 - 2] > end) {
            this.buffer[index2] = this.buffer[index2 - 4];
            this.buffer[index2 + 1] = this.buffer[index2 - 3];
            this.buffer[index2 + 2] = this.buffer[index2 - 2];
            this.buffer[index2 + 3] = this.buffer[index2 - 1];
            index2 -= 4;
            if (size2 > 4)
              size2 -= 4;
          }
      }
      this.buffer[index2] = term;
      this.buffer[index2 + 1] = start;
      this.buffer[index2 + 2] = end;
      this.buffer[index2 + 3] = size2;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(action, type, start, end) {
    if (action & 131072) {
      this.pushState(action & 65535, this.pos);
    } else if ((action & 262144) == 0) {
      let nextState = action, { parser: parser2 } = this.p;
      this.pos = end;
      let skipped = parser2.stateFlag(
        nextState,
        1
        /* StateFlag.Skipped */
      );
      if (!skipped && (end > start || type <= parser2.maxNode))
        this.reducePos = end;
      this.pushState(nextState, skipped ? start : Math.min(start, this.reducePos));
      this.shiftContext(type, start);
      if (type <= parser2.maxNode)
        this.buffer.push(type, start, end, 4);
    } else {
      this.pos = end;
      this.shiftContext(type, start);
      if (type <= this.p.parser.maxNode)
        this.buffer.push(type, start, end, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(action, next, nextStart, nextEnd) {
    if (action & 65536)
      this.reduce(action);
    else
      this.shift(action, next, nextStart, nextEnd);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(value, next) {
    let index2 = this.p.reused.length - 1;
    if (index2 < 0 || this.p.reused[index2] != value) {
      this.p.reused.push(value);
      index2++;
    }
    let start = this.pos;
    this.reducePos = this.pos = start + value.length;
    this.pushState(next, start);
    this.buffer.push(
      index2,
      start,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    );
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let parent = this;
    let off = parent.buffer.length;
    if (off && parent.buffer[off - 4] == 0)
      off -= 4;
    while (off > 0 && parent.buffer[off - 2] > parent.reducePos)
      off -= 4;
    let buffer = parent.buffer.slice(off), base2 = parent.bufferBase + off;
    while (parent && base2 == parent.bufferBase)
      parent = parent.parent;
    return new Stack2(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base2, this.curContext, this.lookAhead, parent);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(next, nextEnd) {
    let isNode2 = next <= this.p.parser.maxNode;
    if (isNode2)
      this.storeNode(next, this.pos, nextEnd, 4);
    this.storeNode(0, this.pos, nextEnd, isNode2 ? 8 : 4);
    this.pos = this.reducePos = nextEnd;
    this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(term) {
    for (let sim = new SimulatedStack$1(this); ; ) {
      let action = this.p.parser.stateSlot(
        sim.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(sim.state, term);
      if (action == 0)
        return false;
      if ((action & 65536) == 0)
        return true;
      sim.reduce(action);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(next) {
    if (this.stack.length >= 300)
      return [];
    let nextStates = this.p.parser.nextStates(this.state);
    if (nextStates.length > 4 << 1 || this.stack.length >= 120) {
      let best = [];
      for (let i2 = 0, s2; i2 < nextStates.length; i2 += 2) {
        if ((s2 = nextStates[i2 + 1]) != this.state && this.p.parser.hasAction(s2, next))
          best.push(nextStates[i2], s2);
      }
      if (this.stack.length < 120)
        for (let i2 = 0; best.length < 4 << 1 && i2 < nextStates.length; i2 += 2) {
          let s2 = nextStates[i2 + 1];
          if (!best.some((v2, i22) => i22 & 1 && v2 == s2))
            best.push(nextStates[i2], s2);
        }
      nextStates = best;
    }
    let result2 = [];
    for (let i2 = 0; i2 < nextStates.length && result2.length < 4; i2 += 2) {
      let s2 = nextStates[i2 + 1];
      if (s2 == this.state)
        continue;
      let stack = this.split();
      stack.pushState(s2, this.pos);
      stack.storeNode(0, stack.pos, stack.pos, 4, true);
      stack.shiftContext(nextStates[i2], this.pos);
      stack.reducePos = this.pos;
      stack.score -= 200;
      result2.push(stack);
    }
    return result2;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: parser2 } = this.p;
    let reduce2 = parser2.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((reduce2 & 65536) == 0)
      return false;
    if (!parser2.validAction(this.state, reduce2)) {
      let depth = reduce2 >> 19, term = reduce2 & 65535;
      let target = this.stack.length - depth * 3;
      if (target < 0 || parser2.getGoto(this.stack[target], term, false) < 0) {
        let backup = this.findForcedReduction();
        if (backup == null)
          return false;
        reduce2 = backup;
      }
      this.storeNode(0, this.pos, this.pos, 4, true);
      this.score -= 100;
    }
    this.reducePos = this.pos;
    this.reduce(reduce2);
    return true;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: parser2 } = this.p, seen = [];
    let explore = (state, depth) => {
      if (seen.includes(state))
        return;
      seen.push(state);
      return parser2.allActions(state, (action) => {
        if (action & (262144 | 131072)) ;
        else if (action & 65536) {
          let rDepth = (action >> 19) - depth;
          if (rDepth > 1) {
            let term = action & 65535, target = this.stack.length - rDepth * 3;
            if (target >= 0 && parser2.getGoto(this.stack[target], term, false) >= 0)
              return rDepth << 19 | 65536 | term;
          }
        } else {
          let found = explore(action, depth + 1);
          if (found != null)
            return found;
        }
      });
    };
    return explore(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    while (!this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    )) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: parser2 } = this.p;
    return parser2.data[parser2.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !parser2.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, true);
    this.state = this.stack[0];
    this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(other) {
    if (this.state != other.state || this.stack.length != other.stack.length)
      return false;
    for (let i2 = 0; i2 < this.stack.length; i2 += 3)
      if (this.stack[i2] != other.stack[i2])
        return false;
    return true;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(dialectID) {
    return this.p.parser.dialect.flags[dialectID];
  }
  shiftContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  reduceContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  /**
  @internal
  */
  emitContext() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -3)
      this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -4)
      this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(context) {
    if (context != this.curContext.context) {
      let newCx = new StackContext$1(this.curContext.tracker, context);
      if (newCx.hash != this.curContext.hash)
        this.emitContext();
      this.curContext = newCx;
    }
  }
  /**
  @internal
  */
  setLookAhead(lookAhead) {
    if (lookAhead <= this.lookAhead)
      return false;
    this.emitLookAhead();
    this.lookAhead = lookAhead;
    return true;
  }
  /**
  @internal
  */
  close() {
    if (this.curContext && this.curContext.tracker.strict)
      this.emitContext();
    if (this.lookAhead > 0)
      this.emitLookAhead();
  }
};
let StackContext$1 = class StackContext2 {
  constructor(tracker, context) {
    this.tracker = tracker;
    this.context = context;
    this.hash = tracker.strict ? tracker.hash(context) : 0;
  }
};
let SimulatedStack$1 = class SimulatedStack2 {
  constructor(start) {
    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }
  reduce(action) {
    let term = action & 65535, depth = action >> 19;
    if (depth == 0) {
      if (this.stack == this.start.stack)
        this.stack = this.stack.slice();
      this.stack.push(this.state, 0, 0);
      this.base += 3;
    } else {
      this.base -= (depth - 1) * 3;
    }
    let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
    this.state = goto;
  }
};
let StackBufferCursor$1 = class StackBufferCursor2 {
  constructor(stack, pos, index2) {
    this.stack = stack;
    this.pos = pos;
    this.index = index2;
    this.buffer = stack.buffer;
    if (this.index == 0)
      this.maybeNext();
  }
  static create(stack, pos = stack.bufferBase + stack.buffer.length) {
    return new StackBufferCursor2(stack, pos, pos - stack.bufferBase);
  }
  maybeNext() {
    let next = this.stack.parent;
    if (next != null) {
      this.index = this.stack.bufferBase - next.bufferBase;
      this.stack = next;
      this.buffer = next.buffer;
    }
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4;
    this.pos -= 4;
    if (this.index == 0)
      this.maybeNext();
  }
  fork() {
    return new StackBufferCursor2(this.stack, this.pos, this.index);
  }
};
function decodeArray$1(input, Type = Uint16Array) {
  if (typeof input != "string")
    return input;
  let array = null;
  for (let pos = 0, out = 0; pos < input.length; ) {
    let value = 0;
    for (; ; ) {
      let next = input.charCodeAt(pos++), stop = false;
      if (next == 126) {
        value = 65535;
        break;
      }
      if (next >= 92)
        next--;
      if (next >= 34)
        next--;
      let digit = next - 32;
      if (digit >= 46) {
        digit -= 46;
        stop = true;
      }
      value += digit;
      if (stop)
        break;
      value *= 46;
    }
    if (array)
      array[out++] = value;
    else
      array = new Type(value);
  }
  return array;
}
let CachedToken$1 = class CachedToken2 {
  constructor() {
    this.start = -1;
    this.value = -1;
    this.end = -1;
    this.extended = -1;
    this.lookAhead = 0;
    this.mask = 0;
    this.context = 0;
  }
};
const nullToken$1 = new CachedToken$1();
let InputStream$1 = class InputStream2 {
  /**
  @internal
  */
  constructor(input, ranges) {
    this.input = input;
    this.ranges = ranges;
    this.chunk = "";
    this.chunkOff = 0;
    this.chunk2 = "";
    this.chunk2Pos = 0;
    this.next = -1;
    this.token = nullToken$1;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(offset2, assoc) {
    let range2 = this.range, index2 = this.rangeIndex;
    let pos = this.pos + offset2;
    while (pos < range2.from) {
      if (!index2)
        return null;
      let next = this.ranges[--index2];
      pos -= range2.from - next.to;
      range2 = next;
    }
    while (assoc < 0 ? pos > range2.to : pos >= range2.to) {
      if (index2 == this.ranges.length - 1)
        return null;
      let next = this.ranges[++index2];
      pos += next.from - range2.to;
      range2 = next;
    }
    return pos;
  }
  /**
  @internal
  */
  clipPos(pos) {
    if (pos >= this.range.from && pos < this.range.to)
      return pos;
    for (let range2 of this.ranges)
      if (range2.to > pos)
        return Math.max(pos, range2.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(offset2) {
    let idx = this.chunkOff + offset2, pos, result2;
    if (idx >= 0 && idx < this.chunk.length) {
      pos = this.pos + offset2;
      result2 = this.chunk.charCodeAt(idx);
    } else {
      let resolved = this.resolveOffset(offset2, 1);
      if (resolved == null)
        return -1;
      pos = resolved;
      if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
        result2 = this.chunk2.charCodeAt(pos - this.chunk2Pos);
      } else {
        let i2 = this.rangeIndex, range2 = this.range;
        while (range2.to <= pos)
          range2 = this.ranges[++i2];
        this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
        if (pos + this.chunk2.length > range2.to)
          this.chunk2 = this.chunk2.slice(0, range2.to - pos);
        result2 = this.chunk2.charCodeAt(0);
      }
    }
    if (pos >= this.token.lookAhead)
      this.token.lookAhead = pos + 1;
    return result2;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(token, endOffset = 0) {
    let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
    if (end == null || end < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = token;
    this.token.end = end;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(token, endPos) {
    this.token.value = token;
    this.token.end = endPos;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: chunk2, chunkPos } = this;
      this.chunk = this.chunk2;
      this.chunkPos = this.chunk2Pos;
      this.chunk2 = chunk2;
      this.chunk2Pos = chunkPos;
      this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk;
      this.chunk2Pos = this.chunkPos;
      let nextChunk = this.input.chunk(this.pos);
      let end = this.pos + nextChunk.length;
      this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
      this.chunkPos = this.pos;
      this.chunkOff = 0;
    }
  }
  readNext() {
    if (this.chunkOff >= this.chunk.length) {
      this.getChunk();
      if (this.chunkOff == this.chunk.length)
        return this.next = -1;
    }
    return this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(n2 = 1) {
    this.chunkOff += n2;
    while (this.pos + n2 >= this.range.to) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      n2 -= this.range.to - this.pos;
      this.range = this.ranges[++this.rangeIndex];
      this.pos = this.range.from;
    }
    this.pos += n2;
    if (this.pos >= this.token.lookAhead)
      this.token.lookAhead = this.pos + 1;
    return this.readNext();
  }
  setDone() {
    this.pos = this.chunkPos = this.end;
    this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
    this.chunk = "";
    return this.next = -1;
  }
  /**
  @internal
  */
  reset(pos, token) {
    if (token) {
      this.token = token;
      token.start = pos;
      token.lookAhead = pos + 1;
      token.value = token.extended = -1;
    } else {
      this.token = nullToken$1;
    }
    if (this.pos != pos) {
      this.pos = pos;
      if (pos == this.end) {
        this.setDone();
        return this;
      }
      while (pos < this.range.from)
        this.range = this.ranges[--this.rangeIndex];
      while (pos >= this.range.to)
        this.range = this.ranges[++this.rangeIndex];
      if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
        this.chunkOff = pos - this.chunkPos;
      } else {
        this.chunk = "";
        this.chunkOff = 0;
      }
      this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(from, to2) {
    if (from >= this.chunkPos && to2 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(from - this.chunkPos, to2 - this.chunkPos);
    if (from >= this.chunk2Pos && to2 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(from - this.chunk2Pos, to2 - this.chunk2Pos);
    if (from >= this.range.from && to2 <= this.range.to)
      return this.input.read(from, to2);
    let result2 = "";
    for (let r2 of this.ranges) {
      if (r2.from >= to2)
        break;
      if (r2.to > from)
        result2 += this.input.read(Math.max(r2.from, from), Math.min(r2.to, to2));
    }
    return result2;
  }
};
let TokenGroup$1 = class TokenGroup2 {
  constructor(data, id2) {
    this.data = data;
    this.id = id2;
  }
  token(input, stack) {
    let { parser: parser2 } = stack.p;
    readToken$1(this.data, input, stack, this.id, parser2.data, parser2.tokenPrecTable);
  }
};
TokenGroup$1.prototype.contextual = TokenGroup$1.prototype.fallback = TokenGroup$1.prototype.extend = false;
TokenGroup$1.prototype.fallback = TokenGroup$1.prototype.extend = false;
let ExternalTokenizer$1 = class ExternalTokenizer2 {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(token, options2 = {}) {
    this.token = token;
    this.contextual = !!options2.contextual;
    this.fallback = !!options2.fallback;
    this.extend = !!options2.extend;
  }
};
function readToken$1(data, input, stack, group2, precTable, precOffset) {
  let state = 0, groupMask = 1 << group2, { dialect } = stack.p.parser;
  scan: for (; ; ) {
    if ((groupMask & data[state]) == 0)
      break;
    let accEnd = data[state + 1];
    for (let i2 = state + 3; i2 < accEnd; i2 += 2)
      if ((data[i2 + 1] & groupMask) > 0) {
        let term = data[i2];
        if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides$1(term, input.token.value, precTable, precOffset))) {
          input.acceptToken(term);
          break;
        }
      }
    let next = input.next, low = 0, high = data[state + 2];
    if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535) {
      state = data[accEnd + high * 3 - 1];
      continue scan;
    }
    for (; low < high; ) {
      let mid = low + high >> 1;
      let index2 = accEnd + mid + (mid << 1);
      let from = data[index2], to2 = data[index2 + 1] || 65536;
      if (next < from)
        high = mid;
      else if (next >= to2)
        low = mid + 1;
      else {
        state = data[index2 + 2];
        input.advance();
        continue scan;
      }
    }
    break;
  }
}
function findOffset$1(data, start, term) {
  for (let i2 = start, next; (next = data[i2]) != 65535; i2++)
    if (next == term)
      return i2 - start;
  return -1;
}
function overrides$1(token, prev, tableData, tableOffset) {
  let iPrev = findOffset$1(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset$1(tableData, tableOffset, token) < iPrev;
}
const verbose$1 = typeof process != "undefined" && process.env && /\bparse\b/.test(process.env.LOG);
let stackIDs$1 = null;
function cutAt$1(tree, pos, side) {
  let cursor2 = tree.cursor(IterMode$2.IncludeAnonymous);
  cursor2.moveTo(pos);
  for (; ; ) {
    if (!(side < 0 ? cursor2.childBefore(pos) : cursor2.childAfter(pos)))
      for (; ; ) {
        if ((side < 0 ? cursor2.to < pos : cursor2.from > pos) && !cursor2.type.isError)
          return side < 0 ? Math.max(0, Math.min(
            cursor2.to - 1,
            pos - 25
            /* Lookahead.Margin */
          )) : Math.min(tree.length, Math.max(
            cursor2.from + 1,
            pos + 25
            /* Lookahead.Margin */
          ));
        if (side < 0 ? cursor2.prevSibling() : cursor2.nextSibling())
          break;
        if (!cursor2.parent())
          return side < 0 ? 0 : tree.length;
      }
  }
}
let FragmentCursor$1 = class FragmentCursor2 {
  constructor(fragments, nodeSet) {
    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }
  nextFragment() {
    let fr2 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (fr2) {
      this.safeFrom = fr2.openStart ? cutAt$1(fr2.tree, fr2.from + fr2.offset, 1) - fr2.offset : fr2.from;
      this.safeTo = fr2.openEnd ? cutAt$1(fr2.tree, fr2.to + fr2.offset, -1) - fr2.offset : fr2.to;
      while (this.trees.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
      }
      this.trees.push(fr2.tree);
      this.start.push(-fr2.offset);
      this.index.push(0);
      this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(pos) {
    if (pos < this.nextStart)
      return null;
    while (this.fragment && this.safeTo <= pos)
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let last2 = this.trees.length - 1;
      if (last2 < 0) {
        this.nextFragment();
        return null;
      }
      let top2 = this.trees[last2], index2 = this.index[last2];
      if (index2 == top2.children.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
        continue;
      }
      let next = top2.children[index2];
      let start = this.start[last2] + top2.positions[index2];
      if (start > pos) {
        this.nextStart = start;
        return null;
      }
      if (next instanceof Tree$2) {
        if (start == pos) {
          if (start < this.safeFrom)
            return null;
          let end = start + next.length;
          if (end <= this.safeTo) {
            let lookAhead = next.prop(NodeProp$2.lookAhead);
            if (!lookAhead || end + lookAhead < this.fragment.to)
              return next;
          }
        }
        this.index[last2]++;
        if (start + next.length >= Math.max(this.safeFrom, pos)) {
          this.trees.push(next);
          this.start.push(start);
          this.index.push(0);
        }
      } else {
        this.index[last2]++;
        this.nextStart = start + next.length;
      }
    }
  }
};
let TokenCache$1 = class TokenCache2 {
  constructor(parser2, stream) {
    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser2.tokenizers.map((_2) => new CachedToken$1());
  }
  getActions(stack) {
    let actionIndex = 0;
    let main2 = null;
    let { parser: parser2 } = stack.p, { tokenizers } = parser2;
    let mask = parser2.stateSlot(
      stack.state,
      3
      /* ParseState.TokenizerMask */
    );
    let context = stack.curContext ? stack.curContext.hash : 0;
    let lookAhead = 0;
    for (let i2 = 0; i2 < tokenizers.length; i2++) {
      if ((1 << i2 & mask) == 0)
        continue;
      let tokenizer = tokenizers[i2], token = this.tokens[i2];
      if (main2 && !tokenizer.fallback)
        continue;
      if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
        this.updateCachedToken(token, tokenizer, stack);
        token.mask = mask;
        token.context = context;
      }
      if (token.lookAhead > token.end + 25)
        lookAhead = Math.max(token.lookAhead, lookAhead);
      if (token.value != 0) {
        let startIndex = actionIndex;
        if (token.extended > -1)
          actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
        actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
        if (!tokenizer.extend) {
          main2 = token;
          if (actionIndex > startIndex)
            break;
        }
      }
    }
    while (this.actions.length > actionIndex)
      this.actions.pop();
    if (lookAhead)
      stack.setLookAhead(lookAhead);
    if (!main2 && stack.pos == this.stream.end) {
      main2 = new CachedToken$1();
      main2.value = stack.p.parser.eofTerm;
      main2.start = main2.end = stack.pos;
      actionIndex = this.addActions(stack, main2.value, main2.end, actionIndex);
    }
    this.mainToken = main2;
    return this.actions;
  }
  getMainToken(stack) {
    if (this.mainToken)
      return this.mainToken;
    let main2 = new CachedToken$1(), { pos, p: p2 } = stack;
    main2.start = pos;
    main2.end = Math.min(pos + 1, p2.stream.end);
    main2.value = pos == p2.stream.end ? p2.parser.eofTerm : 0;
    return main2;
  }
  updateCachedToken(token, tokenizer, stack) {
    let start = this.stream.clipPos(stack.pos);
    tokenizer.token(this.stream.reset(start, token), stack);
    if (token.value > -1) {
      let { parser: parser2 } = stack.p;
      for (let i2 = 0; i2 < parser2.specialized.length; i2++)
        if (parser2.specialized[i2] == token.value) {
          let result2 = parser2.specializers[i2](this.stream.read(token.start, token.end), stack);
          if (result2 >= 0 && stack.p.parser.dialect.allows(result2 >> 1)) {
            if ((result2 & 1) == 0)
              token.value = result2 >> 1;
            else
              token.extended = result2 >> 1;
            break;
          }
        }
    } else {
      token.value = 0;
      token.end = this.stream.clipPos(start + 1);
    }
  }
  putAction(action, token, end, index2) {
    for (let i2 = 0; i2 < index2; i2 += 3)
      if (this.actions[i2] == action)
        return index2;
    this.actions[index2++] = action;
    this.actions[index2++] = token;
    this.actions[index2++] = end;
    return index2;
  }
  addActions(stack, token, end, index2) {
    let { state } = stack, { parser: parser2 } = stack.p, { data } = parser2;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = parser2.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ); ; i2 += 3) {
        if (data[i2] == 65535) {
          if (data[i2 + 1] == 1) {
            i2 = pair$1(data, i2 + 2);
          } else {
            if (index2 == 0 && data[i2 + 1] == 2)
              index2 = this.putAction(pair$1(data, i2 + 2), token, end, index2);
            break;
          }
        }
        if (data[i2] == token)
          index2 = this.putAction(pair$1(data, i2 + 1), token, end, index2);
      }
    }
    return index2;
  }
};
let Parse$1 = class Parse2 {
  constructor(parser2, input, fragments, ranges) {
    this.parser = parser2;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 9812;
    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream$1(input, ranges);
    this.tokens = new TokenCache$1(parser2, this.stream);
    this.topTerm = parser2.top[1];
    let { from } = ranges[0];
    this.stacks = [Stack$1.start(this, parser2.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser2.bufferLength * 4 ? new FragmentCursor$1(fragments, parser2.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let stacks = this.stacks, pos = this.minStackPos;
    let newStacks = this.stacks = [];
    let stopped, stoppedTokens;
    if (this.bigReductionCount > 300 && stacks.length == 1) {
      let [s2] = stacks;
      while (s2.forceReduce() && s2.stack.length && s2.stack[s2.stack.length - 2] >= this.lastBigReductionStart) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2];
      for (; ; ) {
        this.tokens.mainToken = null;
        if (stack.pos > pos) {
          newStacks.push(stack);
        } else if (this.advanceStack(stack, newStacks, stacks)) {
          continue;
        } else {
          if (!stopped) {
            stopped = [];
            stoppedTokens = [];
          }
          stopped.push(stack);
          let tok = this.tokens.getMainToken(stack);
          stoppedTokens.push(tok.value, tok.end);
        }
        break;
      }
    }
    if (!newStacks.length) {
      let finished = stopped && findFinished$1(stopped);
      if (finished) {
        if (verbose$1)
          console.log("Finish with " + this.stackID(finished));
        return this.stackToTree(finished);
      }
      if (this.parser.strict) {
        if (verbose$1 && stopped)
          console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
        throw new SyntaxError("No parse at " + pos);
      }
      if (!this.recovering)
        this.recovering = 5;
    }
    if (this.recovering && stopped) {
      let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
      if (finished) {
        if (verbose$1)
          console.log("Force-finish " + this.stackID(finished));
        return this.stackToTree(finished.forceAll());
      }
    }
    if (this.recovering) {
      let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3;
      if (newStacks.length > maxRemaining) {
        newStacks.sort((a2, b2) => b2.score - a2.score);
        while (newStacks.length > maxRemaining)
          newStacks.pop();
      }
      if (newStacks.some((s2) => s2.reducePos > pos))
        this.recovering--;
    } else if (newStacks.length > 1) {
      outer: for (let i2 = 0; i2 < newStacks.length - 1; i2++) {
        let stack = newStacks[i2];
        for (let j2 = i2 + 1; j2 < newStacks.length; j2++) {
          let other = newStacks[j2];
          if (stack.sameState(other) || stack.buffer.length > 500 && other.buffer.length > 500) {
            if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) {
              newStacks.splice(j2--, 1);
            } else {
              newStacks.splice(i2--, 1);
              continue outer;
            }
          }
        }
      }
      if (newStacks.length > 12) {
        newStacks.sort((a2, b2) => b2.score - a2.score);
        newStacks.splice(
          12,
          newStacks.length - 12
          /* Rec.MaxStackCount */
        );
      }
    }
    this.minStackPos = newStacks[0].pos;
    for (let i2 = 1; i2 < newStacks.length; i2++)
      if (newStacks[i2].pos < this.minStackPos)
        this.minStackPos = newStacks[i2].pos;
    return null;
  }
  stopAt(pos) {
    if (this.stoppedAt != null && this.stoppedAt < pos)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = pos;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(stack, stacks, split) {
    let start = stack.pos, { parser: parser2 } = this;
    let base2 = verbose$1 ? this.stackID(stack) + " -> " : "";
    if (this.stoppedAt != null && start > this.stoppedAt)
      return stack.forceReduce() ? stack : null;
    if (this.fragments) {
      let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
      for (let cached = this.fragments.nodeAt(start); cached; ) {
        let match2 = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser2.getGoto(stack.state, cached.type.id) : -1;
        if (match2 > -1 && cached.length && (!strictCx || (cached.prop(NodeProp$2.contextHash) || 0) == cxHash)) {
          stack.useNode(cached, match2);
          if (verbose$1)
            console.log(base2 + this.stackID(stack) + ` (via reuse of ${parser2.getName(cached.type.id)})`);
          return true;
        }
        if (!(cached instanceof Tree$2) || cached.children.length == 0 || cached.positions[0] > 0)
          break;
        let inner = cached.children[0];
        if (inner instanceof Tree$2 && cached.positions[0] == 0)
          cached = inner;
        else
          break;
      }
    }
    let defaultReduce = parser2.stateSlot(
      stack.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (defaultReduce > 0) {
      stack.reduce(defaultReduce);
      if (verbose$1)
        console.log(base2 + this.stackID(stack) + ` (via always-reduce ${parser2.getName(
          defaultReduce & 65535
          /* Action.ValueMask */
        )})`);
      return true;
    }
    if (stack.stack.length >= 8400) {
      while (stack.stack.length > 6e3 && stack.forceReduce()) {
      }
    }
    let actions = this.tokens.getActions(stack);
    for (let i2 = 0; i2 < actions.length; ) {
      let action = actions[i2++], term = actions[i2++], end = actions[i2++];
      let last2 = i2 == actions.length || !split;
      let localStack = last2 ? stack : stack.split();
      let main2 = this.tokens.mainToken;
      localStack.apply(action, term, main2 ? main2.start : localStack.pos, end);
      if (verbose$1)
        console.log(base2 + this.stackID(localStack) + ` (via ${(action & 65536) == 0 ? "shift" : `reduce of ${parser2.getName(
          action & 65535
          /* Action.ValueMask */
        )}`} for ${parser2.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
      if (last2)
        return true;
      else if (localStack.pos > start)
        stacks.push(localStack);
      else
        split.push(localStack);
    }
    return false;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(stack, newStacks) {
    let pos = stack.pos;
    for (; ; ) {
      if (!this.advanceStack(stack, null, null))
        return false;
      if (stack.pos > pos) {
        pushStackDedup$1(stack, newStacks);
        return true;
      }
    }
  }
  runRecovery(stacks, tokens, newStacks) {
    let finished = null, restarted = false;
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2], token = tokens[i2 << 1], tokenEnd = tokens[(i2 << 1) + 1];
      let base2 = verbose$1 ? this.stackID(stack) + " -> " : "";
      if (stack.deadEnd) {
        if (restarted)
          continue;
        restarted = true;
        stack.restart();
        if (verbose$1)
          console.log(base2 + this.stackID(stack) + " (restarted)");
        let done = this.advanceFully(stack, newStacks);
        if (done)
          continue;
      }
      let force = stack.split(), forceBase = base2;
      for (let j2 = 0; j2 < 10 && force.forceReduce(); j2++) {
        if (verbose$1)
          console.log(forceBase + this.stackID(force) + " (via force-reduce)");
        let done = this.advanceFully(force, newStacks);
        if (done)
          break;
        if (verbose$1)
          forceBase = this.stackID(force) + " -> ";
      }
      for (let insert2 of stack.recoverByInsert(token)) {
        if (verbose$1)
          console.log(base2 + this.stackID(insert2) + " (via recover-insert)");
        this.advanceFully(insert2, newStacks);
      }
      if (this.stream.end > stack.pos) {
        if (tokenEnd == stack.pos) {
          tokenEnd++;
          token = 0;
        }
        stack.recoverByDelete(token, tokenEnd);
        if (verbose$1)
          console.log(base2 + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
        pushStackDedup$1(stack, newStacks);
      } else if (!finished || finished.score < force.score) {
        finished = force;
      }
    }
    return finished;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(stack) {
    stack.close();
    return Tree$2.build({
      buffer: StackBufferCursor$1.create(stack),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: stack.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(stack) {
    let id2 = (stackIDs$1 || (stackIDs$1 = /* @__PURE__ */ new WeakMap())).get(stack);
    if (!id2)
      stackIDs$1.set(stack, id2 = String.fromCodePoint(this.nextStackID++));
    return id2 + stack;
  }
};
function pushStackDedup$1(stack, newStacks) {
  for (let i2 = 0; i2 < newStacks.length; i2++) {
    let other = newStacks[i2];
    if (other.pos == stack.pos && other.sameState(stack)) {
      if (newStacks[i2].score < stack.score)
        newStacks[i2] = stack;
      return;
    }
  }
  newStacks.push(stack);
}
let Dialect$1 = class Dialect2 {
  constructor(source, flags, disabled) {
    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }
  allows(term) {
    return !this.disabled || this.disabled[term] == 0;
  }
};
const id$1 = (x2) => x2;
let ContextTracker$1 = class ContextTracker2 {
  /**
  Define a context tracker.
  */
  constructor(spec) {
    this.start = spec.start;
    this.shift = spec.shift || id$1;
    this.reduce = spec.reduce || id$1;
    this.reuse = spec.reuse || id$1;
    this.hash = spec.hash || (() => 0);
    this.strict = spec.strict !== false;
  }
};
let LRParser$1 = class LRParser2 extends Parser$2 {
  /**
  @internal
  */
  constructor(spec) {
    super();
    this.wrappers = [];
    if (spec.version != 14)
      throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14})`);
    let nodeNames = spec.nodeNames.split(" ");
    this.minRepeatTerm = nodeNames.length;
    for (let i2 = 0; i2 < spec.repeatNodeCount; i2++)
      nodeNames.push("");
    let topTerms = Object.keys(spec.topRules).map((r2) => spec.topRules[r2][1]);
    let nodeProps = [];
    for (let i2 = 0; i2 < nodeNames.length; i2++)
      nodeProps.push([]);
    function setProp(nodeID, prop, value) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value))]);
    }
    if (spec.nodeProps)
      for (let propSpec of spec.nodeProps) {
        let prop = propSpec[0];
        if (typeof prop == "string")
          prop = NodeProp$2[prop];
        for (let i2 = 1; i2 < propSpec.length; ) {
          let next = propSpec[i2++];
          if (next >= 0) {
            setProp(next, prop, propSpec[i2++]);
          } else {
            let value = propSpec[i2 + -next];
            for (let j2 = -next; j2 > 0; j2--)
              setProp(propSpec[i2++], prop, value);
            i2++;
          }
        }
      }
    this.nodeSet = new NodeSet$1(nodeNames.map((name2, i2) => NodeType$2.define({
      name: i2 >= this.minRepeatTerm ? void 0 : name2,
      id: i2,
      props: nodeProps[i2],
      top: topTerms.indexOf(i2) > -1,
      error: i2 == 0,
      skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i2) > -1
    })));
    if (spec.propSources)
      this.nodeSet = this.nodeSet.extend(...spec.propSources);
    this.strict = false;
    this.bufferLength = DefaultBufferLength$2;
    let tokenArray = decodeArray$1(spec.tokenData);
    this.context = spec.context;
    this.specializerSpecs = spec.specialized || [];
    this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let i2 = 0; i2 < this.specializerSpecs.length; i2++)
      this.specialized[i2] = this.specializerSpecs[i2].term;
    this.specializers = this.specializerSpecs.map(getSpecializer$1);
    this.states = decodeArray$1(spec.states, Uint32Array);
    this.data = decodeArray$1(spec.stateData);
    this.goto = decodeArray$1(spec.goto);
    this.maxTerm = spec.maxTerm;
    this.tokenizers = spec.tokenizers.map((value) => typeof value == "number" ? new TokenGroup$1(tokenArray, value) : value);
    this.topRules = spec.topRules;
    this.dialects = spec.dialects || {};
    this.dynamicPrecedences = spec.dynamicPrecedences || null;
    this.tokenPrecTable = spec.tokenPrec;
    this.termNames = spec.termNames || null;
    this.maxNode = this.nodeSet.types.length - 1;
    this.dialect = this.parseDialect();
    this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(input, fragments, ranges) {
    let parse2 = new Parse$1(this, input, fragments, ranges);
    for (let w2 of this.wrappers)
      parse2 = w2(parse2, input, fragments, ranges);
    return parse2;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(state, term, loose = false) {
    let table = this.goto;
    if (term >= table[0])
      return -1;
    for (let pos = table[term + 1]; ; ) {
      let groupTag = table[pos++], last2 = groupTag & 1;
      let target = table[pos++];
      if (last2 && loose)
        return target;
      for (let end = pos + (groupTag >> 1); pos < end; pos++)
        if (table[pos] == state)
          return target;
      if (last2)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(state, terminal) {
    let data = this.data;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = this.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ), next; ; i2 += 3) {
        if ((next = data[i2]) == 65535) {
          if (data[i2 + 1] == 1)
            next = data[i2 = pair$1(data, i2 + 2)];
          else if (data[i2 + 1] == 2)
            return pair$1(data, i2 + 2);
          else
            break;
        }
        if (next == terminal || next == 0)
          return pair$1(data, i2 + 1);
      }
    }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(state, slot) {
    return this.states[state * 6 + slot];
  }
  /**
  @internal
  */
  stateFlag(state, flag) {
    return (this.stateSlot(
      state,
      0
      /* ParseState.Flags */
    ) & flag) > 0;
  }
  /**
  @internal
  */
  validAction(state, action) {
    return !!this.allActions(state, (a2) => a2 == action ? true : null);
  }
  /**
  @internal
  */
  allActions(state, action) {
    let deflt = this.stateSlot(
      state,
      4
      /* ParseState.DefaultReduce */
    );
    let result2 = deflt ? action(deflt) : void 0;
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); result2 == null; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair$1(this.data, i2 + 2);
        else
          break;
      }
      result2 = action(pair$1(this.data, i2 + 1));
    }
    return result2;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(state) {
    let result2 = [];
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); ; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair$1(this.data, i2 + 2);
        else
          break;
      }
      if ((this.data[i2 + 2] & 65536 >> 16) == 0) {
        let value = this.data[i2 + 1];
        if (!result2.some((v2, i22) => i22 & 1 && v2 == value))
          result2.push(this.data[i2], value);
      }
    }
    return result2;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(config2) {
    let copy2 = Object.assign(Object.create(LRParser2.prototype), this);
    if (config2.props)
      copy2.nodeSet = this.nodeSet.extend(...config2.props);
    if (config2.top) {
      let info = this.topRules[config2.top];
      if (!info)
        throw new RangeError(`Invalid top rule name ${config2.top}`);
      copy2.top = info;
    }
    if (config2.tokenizers)
      copy2.tokenizers = this.tokenizers.map((t4) => {
        let found = config2.tokenizers.find((r2) => r2.from == t4);
        return found ? found.to : t4;
      });
    if (config2.specializers) {
      copy2.specializers = this.specializers.slice();
      copy2.specializerSpecs = this.specializerSpecs.map((s2, i2) => {
        let found = config2.specializers.find((r2) => r2.from == s2.external);
        if (!found)
          return s2;
        let spec = Object.assign(Object.assign({}, s2), { external: found.to });
        copy2.specializers[i2] = getSpecializer$1(spec);
        return spec;
      });
    }
    if (config2.contextTracker)
      copy2.context = config2.contextTracker;
    if (config2.dialect)
      copy2.dialect = this.parseDialect(config2.dialect);
    if (config2.strict != null)
      copy2.strict = config2.strict;
    if (config2.wrap)
      copy2.wrappers = copy2.wrappers.concat(config2.wrap);
    if (config2.bufferLength != null)
      copy2.bufferLength = config2.bufferLength;
    return copy2;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(term) {
    return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(term) {
    let prec2 = this.dynamicPrecedences;
    return prec2 == null ? 0 : prec2[term] || 0;
  }
  /**
  @internal
  */
  parseDialect(dialect) {
    let values2 = Object.keys(this.dialects), flags = values2.map(() => false);
    if (dialect)
      for (let part of dialect.split(" ")) {
        let id2 = values2.indexOf(part);
        if (id2 >= 0)
          flags[id2] = true;
      }
    let disabled = null;
    for (let i2 = 0; i2 < values2.length; i2++)
      if (!flags[i2]) {
        for (let j2 = this.dialects[values2[i2]], id2; (id2 = this.data[j2++]) != 65535; )
          (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id2] = 1;
      }
    return new Dialect$1(dialect, flags, disabled);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(spec) {
    return new LRParser2(spec);
  }
};
function pair$1(data, off) {
  return data[off] | data[off + 1] << 16;
}
function findFinished$1(stacks) {
  let best = null;
  for (let stack of stacks) {
    let stopped = stack.p.stoppedAt;
    if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(
      stack.state,
      2
      /* StateFlag.Accepting */
    ) && (!best || best.score < stack.score))
      best = stack;
  }
  return best;
}
function getSpecializer$1(spec) {
  if (spec.external) {
    let mask = spec.extend ? 1 : 0;
    return (value, stack) => spec.external(value, stack) << 1 | mask;
  }
  return spec.get;
}
function nameChar$1(ch) {
  return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isSpace$1(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let cachedName$1 = null, cachedInput$1 = null, cachedPos$1 = 0;
function tagNameAfter$1(input, offset2) {
  let pos = input.pos + offset2;
  if (cachedInput$1 == input && cachedPos$1 == pos) return cachedName$1;
  while (isSpace$1(input.peek(offset2))) offset2++;
  let name2 = "";
  for (; ; ) {
    let next = input.peek(offset2);
    if (!nameChar$1(next)) break;
    name2 += String.fromCharCode(next);
    offset2++;
  }
  cachedInput$1 = input;
  cachedPos$1 = pos;
  return cachedName$1 = name2 || null;
}
let ElementContext$1 = class ElementContext2 {
  constructor(name2, parent) {
    this.name = name2;
    this.parent = parent ?? null;
    this.hash = parent ? parent.hash : 0;
    for (let i2 = 0; i2 < name2.length; i2++) {
      this.hash += (this.hash << 4) + name2.charCodeAt(i2) + (name2.charCodeAt(i2) << 8);
    }
  }
};
const elementContext$1 = new ContextTracker$1({
  start: null,
  shift(context, term, stack, input) {
    return term == StartTag$1 ? new ElementContext$1(tagNameAfter$1(input, 1) || "", context) : context;
  },
  reduce(context, term) {
    return term == Element$2 && context ? context.parent : context;
  },
  reuse(context, node, _stack, input) {
    let type = node.type.id;
    return type == StartTag$1 || type == OpenTag$1 ? new ElementContext$1(tagNameAfter$1(input, 1) || "", context) : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
const startTag$1 = new ExternalTokenizer$1(
  (input, stack) => {
    if (input.next !== 60) {
      return;
    }
    const nextNext = input.peek(1);
    if (nextNext === 61) {
      return;
    }
    input.advance();
    if (input.next === 47) {
      input.advance();
      let name2 = tagNameAfter$1(input, 0);
      if (!name2) {
        return input.acceptToken(incompleteStartCloseTag$1);
      }
      if (stack.context && name2.toLowerCase() == stack.context.name.toLowerCase()) {
        return input.acceptToken(StartCloseTag$1);
      }
      for (let cx = stack.context; cx; cx = cx.parent) {
        if (cx.name === name2) {
          return input.acceptToken(MissingCloseTag$1, -2);
        }
      }
      input.acceptToken(mismatchedStartCloseTag$1);
    } else if (
      // @ts-ignore
      input.next !== 33 && // @ts-ignore
      input.next !== 63 && !isSpace$1(input.next)
    ) {
      return input.acceptToken(StartTag$1);
    }
  },
  { contextual: true }
);
const textLessThan$1 = new ExternalTokenizer$1((input) => {
  if (input.next !== 60) {
    return;
  }
  const nextNext = input.peek(1);
  if (nextNext === 60) {
    return input.acceptToken(Text$2, 1);
  }
});
function scanTo$1(type, end) {
  return new ExternalTokenizer$1((input) => {
    for (let endPos = 0, len = 0; ; len++) {
      if (input.next < 0) {
        if (len) {
          input.acceptToken(type);
        }
        break;
      }
      if (input.next == end.charCodeAt(endPos)) {
        endPos++;
        if (endPos == end.length) {
          if (len > end.length) {
            input.acceptToken(type, 1 - end.length);
          }
          break;
        }
      } else {
        endPos = 0;
      }
      input.advance();
    }
  });
}
const commentContent$2 = scanTo$1(commentContent$1$1, "-->");
const piContent$2 = scanTo$1(piContent$1$1, "?>");
const cdataContent$2 = scanTo$1(cdataContent$1$1, "]]>");
const parser$1 = LRParser$1.deserialize({
  version: 14,
  states: "(jOVOqOOOzO!jO'#CgO!SQ!bO'#CjO!|OqO'#ChOOOP'#Ch'#ChO#TO!dO'#CsO#]O!fO'#CtO#eQ!bO'#CuOOOP'#DW'#DWOOOP'#Cw'#CwQVOqOOOOOW'#Cx'#CxO#jO!jO,59ROOOP,59R,59RO#rQ#tO,59UOOOP'#C|'#C|O#}OqO,59SO$UQ!bO'#CpOOOP,59S,59SOOOQ'#C}'#C}O$ZO!dO,59_OOOP,59_,59_OOOS'#DO'#DOO$cO!fO,59`OOOP,59`,59`O$kQ!bO,59aOOOP-E6u-E6uOOOW-E6v-E6vOOOP1G.m1G.mO$pQ#tO'#ClOOQO'#Cy'#CyO%OQ#tO1G.pOOOP1G.p1G.pOOOP1G.x1G.xOOOP-E6z-E6zOOOP1G.n1G.nO%ZQ!bO,59[OOOQ-E6{-E6{OOOP1G.y1G.yOOOS-E6|-E6|OOOP1G.z1G.zOOOP1G.{1G.{O%`Q!bO,59WOOQO-E6w-E6wOOOP7+$[7+$[OOOP7+$d7+$dOOOP1G.v1G.vO%hO&jO'#CoO%yO,UO'#CoOOQO1G.r1G.rOOOO'#Cz'#CzO&[O&jO,59ZOOQO,59Z,59ZOOOO'#C{'#C{O&mO,UO,59ZOOOO-E6x-E6xOOQO1G.u1G.uOOOO-E6y-E6y",
  stateData: "'T~OyOS~OPQOSVOTWOVWOWWOXWOYWOjXO|PO!STO!UUO~OvZO{]O~O_^O~OPQOQaOSVOTWOVWOWWOXWOYWO|PO!STO!UUO~ORbO~P!XOtcO!ReO~OufO!ThO~O_iO~OvZO{lO~O]pOamOeqO~ORsO~P!XO_tO~OtcO!RvO~OufO!TxO~O]yO~ObzO]`Xa`Xe`X~O]|OamOe}O~O]!OO~O}!PO!P!QO~OW!SOX!SOY!SO}!UO!O!SO~OW!VOX!VOY!VO!P!UO!Q!VO~OW!SOX!SOY!SO}!YO!O!SO~OW!VOX!VOY!VO!P!YO!Q!VO~OXWYW~",
  goto: "#w{PPPPPPPPPPP||P!SP!YPP!^!aP!g|||P!m!s!y#P#V#]#c#iPPPPPPP#oXWORY`XRORY`Tn^oR!RzQbRRs`XSORY`QYORjYQ[PRk[Qo^R{oQ!T!PR!X!TQ!W!QR!Z!WQ`RRr`QdTRudQgURwgSXOYT_R`",
  nodeNames: "⚠ StartTag StartCloseTag MissingCloseTag StartCloseTag StartCloseTag Document Text EntityReference CharacterReference Ampersand Cdata Element EndTag OpenTag TagName Attribute AttributeName Is AttributeValue CloseTag SelfCloseEndTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl",
  maxTerm: 52,
  context: elementContext$1,
  nodeProps: [
    [
      "closedBy",
      1,
      "SelfCloseEndTag EndTag",
      14,
      "CloseTag MissingCloseTag"
    ],
    [
      "openedBy",
      13,
      "StartTag StartCloseTag",
      20,
      "OpenTag",
      21,
      "StartTag"
    ]
  ],
  skippedNodes: [0],
  repeatNodeCount: 8,
  tokenData: "!2c~R!YOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs2wsv$qvw3gwx7lx}$q}!O8_!O!P$q!P!Q:}!Q![$q![!]<q!]!^$q!^!_@X!_!`!,a!`!a!-X!a!b!.P!b!c$q!c!}<q!}#P$q#P#Q!/s#Q#R$q#R#S<q#S#T$q#T#o<q#o%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U$q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qi$zXVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qa%nVVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%gP&YUVPOv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP&oTXY'OYZ'O]^'Opq'O!_!`&TP'T]VPOX&TXY'OYZ'OZ]&T]^'O^p&Tpq'Oqv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP(PP;=`<%l&Ta(X]!Q`OX)QXY)iYZ)iZ])Q]^)i^p)Qpq)iqv)Qx!_)Q!_!`%g!`;'S)Q;'S;=`)c<%lO)Q`)VS!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)Q`)fP;=`<%l)Qa)p^VP!Q`OX%gXY)iYZ)iZ]%g]^)i^p%gpq)iqv%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%ga*oP;=`<%l%gX*yWVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX+h^!OWOX,dXY-OYZ-OZ],d]^-O^p,dpq-Oqr,dsv,dw!_,d!_!`*r!`;'S,d;'S;=`,x<%lO,dW,iT!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dW,{P;=`<%l,dX-V_VP!OWOX*rXY-OYZ-OZ]*r]^-O^p*rpq-Oqr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX.XP;=`<%l*ri.c`!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0Xqr/ers)Qsv/ewx,dx!_/e!_!`$q!`;'S/e;'S;=`0R<%lO/eh/lV!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eh0UP;=`<%l/ei0b`VP!OW!Q`OX$qXY0XYZ0XZ]$q]^0X^p$qpq0Xqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qi1gP;=`<%l$qo1u`VP!OW!Q`yUOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk3QV}YVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%g~3laY~st4q![!]5u!c!}5u#R#S5u#T#o5u%W%o5u%p&a5u&b1p5u4U4d5u4e$IS5u$I`$Ib5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~4tQ!Q![4z#l#m5Y~4}Q!Q![4z!]!^5T~5YOX~~5]R!Q![5f!c!i5f#T#Z5f~5iS!Q![5f!]!^5T!c!i5f#T#Z5f~5xg}!O5u!O!P5u!Q![5u![!]5u!]!^7a!c!}5u#R#S5u#T#o5u$}%O5u%W%o5u%p&a5u&b1p5u1p4U5u4U4d5u4e$IS5u$I`$Ib5u$Je$Jg5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~7fOW~~7iP;=`<%l5uk7uW!PbVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rk8hZVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O9Z!O!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk9dZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a:V!a;'S$q;'S;=`1d<%lO$qk:bX!RQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qm;WZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a;y!a;'S$q;'S;=`1d<%lO$qm<UXeSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo=O!PaS_QVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O<q!O!P<q!P!Q$q!Q![<q![!]<q!]!^$q!^!_.[!_!c$q!c!}<q!}#R$q#R#S<q#S#T$q#T#o<q#o$}$q$}%O<q%O%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U<q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Je$q$Je$Jg<q$Jg$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qo@UP;=`<%l<qi@`b!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0XqrAhrs)Qsv/ewx,dx!_/e!_!`$q!`!a/e!a!b!+q!b;'S/e;'S;=`0R<%lO/eiAo_!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OBn!O!f/e!f!gDQ!g!}/e!}#OMT#O#W/e#W#X!']#X;'S/e;'S;=`0R<%lO/eiBuX!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OCb!O;'S/e;'S;=`0R<%lO/eiCkV!SP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiDXX!OW!Q`Or/ers)Qsv/ewx,dx!q/e!q!rDt!r;'S/e;'S;=`0R<%lO/eiD{X!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fEh!f;'S/e;'S;=`0R<%lO/eiEoX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!wF[!w;'S/e;'S;=`0R<%lO/eiFcX!OW!Q`Or/ers)Qsv/ewx,dx!{/e!{!|GO!|;'S/e;'S;=`0R<%lO/eiGVX!OW!Q`Or/ers)Qsv/ewx,dx!r/e!r!sGr!s;'S/e;'S;=`0R<%lO/eiGyX!OW!Q`Or/ers)Qsv/ewx,dx!g/e!g!hHf!h;'S/e;'S;=`0R<%lO/eiHmY!OW!Q`OrHfrsI]svHfvwIwwxKPx!`Hf!`!aL_!a;'SHf;'S;=`L}<%lOHfaIbV!Q`OvI]vxIwx!`I]!`!aJf!a;'SI];'S;=`Jy<%lOI]PIzTO!`Iw!`!aJZ!a;'SIw;'S;=`J`<%lOIwPJ`OjPPJcP;=`<%lIwaJmSjP!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)QaJ|P;=`<%lI]XKUX!OWOrKPrsIwsvKPvwIww!`KP!`!aKq!a;'SKP;'S;=`LX<%lOKPXKxTjP!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dXL[P;=`<%lKPiLhVjP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiMQP;=`<%lHfiM[Z!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fM}!f#V/e#V#W!$_#W;'S/e;'S;=`0R<%lO/eiNUX!OW!Q`Or/ers)Qsv/ewx,dx!f/e!f!gNq!g;'S/e;'S;=`0R<%lO/eiNxX!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d! e!d;'S/e;'S;=`0R<%lO/ei! lX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!w!!X!w;'S/e;'S;=`0R<%lO/ei!!`X!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d!!{!d;'S/e;'S;=`0R<%lO/ei!#SX!OW!Q`Or/ers)Qsv/ewx,dx!}/e!}#O!#o#O;'S/e;'S;=`0R<%lO/ei!#xV|P!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/ei!$fX!OW!Q`Or/ers)Qsv/ewx,dx#W/e#W#X!%R#X;'S/e;'S;=`0R<%lO/ei!%YX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!%u#U;'S/e;'S;=`0R<%lO/ei!%|X!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!&i#i;'S/e;'S;=`0R<%lO/ei!&pX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!!{#U;'S/e;'S;=`0R<%lO/ei!'dX!OW!Q`Or/ers)Qsv/ewx,dx#c/e#c#d!(P#d;'S/e;'S;=`0R<%lO/ei!(WX!OW!Q`Or/ers)Qsv/ewx,dx#V/e#V#W!(s#W;'S/e;'S;=`0R<%lO/ei!(zX!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!)g#i;'S/e;'S;=`0R<%lO/ei!)nX!OW!Q`Or/ers)Qsv/ewx,dx#m/e#m#n!*Z#n;'S/e;'S;=`0R<%lO/ei!*bX!OW!Q`Or/ers)Qsv/ewx,dx#d/e#d#e!*}#e;'S/e;'S;=`0R<%lO/ei!+UX!OW!Q`Or/ers)Qsv/ewx,dx#X/e#X#YHf#Y;'S/e;'S;=`0R<%lO/ei!+zV!UP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/em!,lXbSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo!-dX]UVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!.YZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!.{!a;'S$q;'S;=`1d<%lO$qk!/WX!TQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!/|ZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_#P$q#P#Q!0o#Q;'S$q;'S;=`1d<%lO$qk!0xZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!1k!a;'S$q;'S;=`1d<%lO$qk!1vX{QVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$q",
  tokenizers: [
    startTag$1,
    commentContent$2,
    piContent$2,
    cdataContent$2,
    textLessThan$1,
    0,
    1,
    2,
    3,
    4
  ],
  topRules: { Document: [0, 6] },
  tokenPrec: 276
});
const _ENTITY_MAP$1 = { "AEli": "Æ", "AElig": "Æ", "AM": "&", "AMP": "&", "Aacut": "Á", "Aacute": "Á", "Abreve": "Ă", "Acir": "Â", "Acirc": "Â", "Acy": "А", "Afr": "𝔄", "Agrav": "À", "Agrave": "À", "Alpha": "Α", "Amacr": "Ā", "And": "⩓", "Aogon": "Ą", "Aopf": "𝔸", "ApplyFunction": "⁡", "Arin": "Å", "Aring": "Å", "Ascr": "𝒜", "Assign": "≔", "Atild": "Ã", "Atilde": "Ã", "Aum": "Ä", "Auml": "Ä", "Backslash": "∖", "Barv": "⫧", "Barwed": "⌆", "Bcy": "Б", "Because": "∵", "Bernoullis": "ℬ", "Beta": "Β", "Bfr": "𝔅", "Bopf": "𝔹", "Breve": "˘", "Bscr": "ℬ", "Bumpeq": "≎", "CHcy": "Ч", "COP": "©", "COPY": "©", "Cacute": "Ć", "Cap": "⋒", "CapitalDifferentialD": "ⅅ", "Cayleys": "ℭ", "Ccaron": "Č", "Ccedi": "Ç", "Ccedil": "Ç", "Ccirc": "Ĉ", "Cconint": "∰", "Cdot": "Ċ", "Cedilla": "¸", "CenterDot": "·", "Cfr": "ℭ", "Chi": "Χ", "CircleDot": "⊙", "CircleMinus": "⊖", "CirclePlus": "⊕", "CircleTimes": "⊗", "ClockwiseContourIntegral": "∲", "CloseCurlyDoubleQuote": "”", "CloseCurlyQuote": "’", "Colon": "∷", "Colone": "⩴", "Congruent": "≡", "Conint": "∯", "ContourIntegral": "∮", "Copf": "ℂ", "Coproduct": "∐", "CounterClockwiseContourIntegral": "∳", "Cross": "⨯", "Cscr": "𝒞", "Cup": "⋓", "CupCap": "≍", "DD": "ⅅ", "DDotrahd": "⤑", "DJcy": "Ђ", "DScy": "Ѕ", "DZcy": "Џ", "Dagger": "‡", "Darr": "↡", "Dashv": "⫤", "Dcaron": "Ď", "Dcy": "Д", "Del": "∇", "Delta": "Δ", "Dfr": "𝔇", "DiacriticalAcute": "´", "DiacriticalDot": "˙", "DiacriticalDoubleAcute": "˝", "DiacriticalGrave": "`", "DiacriticalTilde": "˜", "Diamond": "⋄", "DifferentialD": "ⅆ", "Dopf": "𝔻", "Dot": "¨", "DotDot": "⃜", "DotEqual": "≐", "DoubleContourIntegral": "∯", "DoubleDot": "¨", "DoubleDownArrow": "⇓", "DoubleLeftArrow": "⇐", "DoubleLeftRightArrow": "⇔", "DoubleLeftTee": "⫤", "DoubleLongLeftArrow": "⟸", "DoubleLongLeftRightArrow": "⟺", "DoubleLongRightArrow": "⟹", "DoubleRightArrow": "⇒", "DoubleRightTee": "⊨", "DoubleUpArrow": "⇑", "DoubleUpDownArrow": "⇕", "DoubleVerticalBar": "∥", "DownArrow": "↓", "DownArrowBar": "⤓", "DownArrowUpArrow": "⇵", "DownBreve": "̑", "DownLeftRightVector": "⥐", "DownLeftTeeVector": "⥞", "DownLeftVector": "↽", "DownLeftVectorBar": "⥖", "DownRightTeeVector": "⥟", "DownRightVector": "⇁", "DownRightVectorBar": "⥗", "DownTee": "⊤", "DownTeeArrow": "↧", "Downarrow": "⇓", "Dscr": "𝒟", "Dstrok": "Đ", "ENG": "Ŋ", "ET": "Ð", "ETH": "Ð", "Eacut": "É", "Eacute": "É", "Ecaron": "Ě", "Ecir": "Ê", "Ecirc": "Ê", "Ecy": "Э", "Edot": "Ė", "Efr": "𝔈", "Egrav": "È", "Egrave": "È", "Element": "∈", "Emacr": "Ē", "EmptySmallSquare": "◻", "EmptyVerySmallSquare": "▫", "Eogon": "Ę", "Eopf": "𝔼", "Epsilon": "Ε", "Equal": "⩵", "EqualTilde": "≂", "Equilibrium": "⇌", "Escr": "ℰ", "Esim": "⩳", "Eta": "Η", "Eum": "Ë", "Euml": "Ë", "Exists": "∃", "ExponentialE": "ⅇ", "Fcy": "Ф", "Ffr": "𝔉", "FilledSmallSquare": "◼", "FilledVerySmallSquare": "▪", "Fopf": "𝔽", "ForAll": "∀", "Fouriertrf": "ℱ", "Fscr": "ℱ", "GJcy": "Ѓ", "G": ">", "GT": ">", "Gamma": "Γ", "Gammad": "Ϝ", "Gbreve": "Ğ", "Gcedil": "Ģ", "Gcirc": "Ĝ", "Gcy": "Г", "Gdot": "Ġ", "Gfr": "𝔊", "Gg": "⋙", "Gopf": "𝔾", "GreaterEqual": "≥", "GreaterEqualLess": "⋛", "GreaterFullEqual": "≧", "GreaterGreater": "⪢", "GreaterLess": "≷", "GreaterSlantEqual": "⩾", "GreaterTilde": "≳", "Gscr": "𝒢", "Gt": "≫", "HARDcy": "Ъ", "Hacek": "ˇ", "Hat": "^", "Hcirc": "Ĥ", "Hfr": "ℌ", "HilbertSpace": "ℋ", "Hopf": "ℍ", "HorizontalLine": "─", "Hscr": "ℋ", "Hstrok": "Ħ", "HumpDownHump": "≎", "HumpEqual": "≏", "IEcy": "Е", "IJlig": "Ĳ", "IOcy": "Ё", "Iacut": "Í", "Iacute": "Í", "Icir": "Î", "Icirc": "Î", "Icy": "И", "Idot": "İ", "Ifr": "ℑ", "Igrav": "Ì", "Igrave": "Ì", "Im": "ℑ", "Imacr": "Ī", "ImaginaryI": "ⅈ", "Implies": "⇒", "Int": "∬", "Integral": "∫", "Intersection": "⋂", "InvisibleComma": "⁣", "InvisibleTimes": "⁢", "Iogon": "Į", "Iopf": "𝕀", "Iota": "Ι", "Iscr": "ℐ", "Itilde": "Ĩ", "Iukcy": "І", "Ium": "Ï", "Iuml": "Ï", "Jcirc": "Ĵ", "Jcy": "Й", "Jfr": "𝔍", "Jopf": "𝕁", "Jscr": "𝒥", "Jsercy": "Ј", "Jukcy": "Є", "KHcy": "Х", "KJcy": "Ќ", "Kappa": "Κ", "Kcedil": "Ķ", "Kcy": "К", "Kfr": "𝔎", "Kopf": "𝕂", "Kscr": "𝒦", "LJcy": "Љ", "L": "<", "LT": "<", "Lacute": "Ĺ", "Lambda": "Λ", "Lang": "⟪", "Laplacetrf": "ℒ", "Larr": "↞", "Lcaron": "Ľ", "Lcedil": "Ļ", "Lcy": "Л", "LeftAngleBracket": "⟨", "LeftArrow": "←", "LeftArrowBar": "⇤", "LeftArrowRightArrow": "⇆", "LeftCeiling": "⌈", "LeftDoubleBracket": "⟦", "LeftDownTeeVector": "⥡", "LeftDownVector": "⇃", "LeftDownVectorBar": "⥙", "LeftFloor": "⌊", "LeftRightArrow": "↔", "LeftRightVector": "⥎", "LeftTee": "⊣", "LeftTeeArrow": "↤", "LeftTeeVector": "⥚", "LeftTriangle": "⊲", "LeftTriangleBar": "⧏", "LeftTriangleEqual": "⊴", "LeftUpDownVector": "⥑", "LeftUpTeeVector": "⥠", "LeftUpVector": "↿", "LeftUpVectorBar": "⥘", "LeftVector": "↼", "LeftVectorBar": "⥒", "Leftarrow": "⇐", "Leftrightarrow": "⇔", "LessEqualGreater": "⋚", "LessFullEqual": "≦", "LessGreater": "≶", "LessLess": "⪡", "LessSlantEqual": "⩽", "LessTilde": "≲", "Lfr": "𝔏", "Ll": "⋘", "Lleftarrow": "⇚", "Lmidot": "Ŀ", "LongLeftArrow": "⟵", "LongLeftRightArrow": "⟷", "LongRightArrow": "⟶", "Longleftarrow": "⟸", "Longleftrightarrow": "⟺", "Longrightarrow": "⟹", "Lopf": "𝕃", "LowerLeftArrow": "↙", "LowerRightArrow": "↘", "Lscr": "ℒ", "Lsh": "↰", "Lstrok": "Ł", "Lt": "≪", "Map": "⤅", "Mcy": "М", "MediumSpace": " ", "Mellintrf": "ℳ", "Mfr": "𝔐", "MinusPlus": "∓", "Mopf": "𝕄", "Mscr": "ℳ", "Mu": "Μ", "NJcy": "Њ", "Nacute": "Ń", "Ncaron": "Ň", "Ncedil": "Ņ", "Ncy": "Н", "NegativeMediumSpace": "​", "NegativeThickSpace": "​", "NegativeThinSpace": "​", "NegativeVeryThinSpace": "​", "NestedGreaterGreater": "≫", "NestedLessLess": "≪", "NewLine": "\n", "Nfr": "𝔑", "NoBreak": "⁠", "NonBreakingSpace": " ", "Nopf": "ℕ", "Not": "⫬", "NotCongruent": "≢", "NotCupCap": "≭", "NotDoubleVerticalBar": "∦", "NotElement": "∉", "NotEqual": "≠", "NotEqualTilde": "≂̸", "NotExists": "∄", "NotGreater": "≯", "NotGreaterEqual": "≱", "NotGreaterFullEqual": "≧̸", "NotGreaterGreater": "≫̸", "NotGreaterLess": "≹", "NotGreaterSlantEqual": "⩾̸", "NotGreaterTilde": "≵", "NotHumpDownHump": "≎̸", "NotHumpEqual": "≏̸", "NotLeftTriangle": "⋪", "NotLeftTriangleBar": "⧏̸", "NotLeftTriangleEqual": "⋬", "NotLess": "≮", "NotLessEqual": "≰", "NotLessGreater": "≸", "NotLessLess": "≪̸", "NotLessSlantEqual": "⩽̸", "NotLessTilde": "≴", "NotNestedGreaterGreater": "⪢̸", "NotNestedLessLess": "⪡̸", "NotPrecedes": "⊀", "NotPrecedesEqual": "⪯̸", "NotPrecedesSlantEqual": "⋠", "NotReverseElement": "∌", "NotRightTriangle": "⋫", "NotRightTriangleBar": "⧐̸", "NotRightTriangleEqual": "⋭", "NotSquareSubset": "⊏̸", "NotSquareSubsetEqual": "⋢", "NotSquareSuperset": "⊐̸", "NotSquareSupersetEqual": "⋣", "NotSubset": "⊂⃒", "NotSubsetEqual": "⊈", "NotSucceeds": "⊁", "NotSucceedsEqual": "⪰̸", "NotSucceedsSlantEqual": "⋡", "NotSucceedsTilde": "≿̸", "NotSuperset": "⊃⃒", "NotSupersetEqual": "⊉", "NotTilde": "≁", "NotTildeEqual": "≄", "NotTildeFullEqual": "≇", "NotTildeTilde": "≉", "NotVerticalBar": "∤", "Nscr": "𝒩", "Ntild": "Ñ", "Ntilde": "Ñ", "Nu": "Ν", "OElig": "Œ", "Oacut": "Ó", "Oacute": "Ó", "Ocir": "Ô", "Ocirc": "Ô", "Ocy": "О", "Odblac": "Ő", "Ofr": "𝔒", "Ograv": "Ò", "Ograve": "Ò", "Omacr": "Ō", "Omega": "Ω", "Omicron": "Ο", "Oopf": "𝕆", "OpenCurlyDoubleQuote": "“", "OpenCurlyQuote": "‘", "Or": "⩔", "Oscr": "𝒪", "Oslas": "Ø", "Oslash": "Ø", "Otild": "Õ", "Otilde": "Õ", "Otimes": "⨷", "Oum": "Ö", "Ouml": "Ö", "OverBar": "‾", "OverBrace": "⏞", "OverBracket": "⎴", "OverParenthesis": "⏜", "PartialD": "∂", "Pcy": "П", "Pfr": "𝔓", "Phi": "Φ", "Pi": "Π", "PlusMinus": "±", "Poincareplane": "ℌ", "Popf": "ℙ", "Pr": "⪻", "Precedes": "≺", "PrecedesEqual": "⪯", "PrecedesSlantEqual": "≼", "PrecedesTilde": "≾", "Prime": "″", "Product": "∏", "Proportion": "∷", "Proportional": "∝", "Pscr": "𝒫", "Psi": "Ψ", "QUO": '"', "QUOT": '"', "Qfr": "𝔔", "Qopf": "ℚ", "Qscr": "𝒬", "RBarr": "⤐", "RE": "®", "REG": "®", "Racute": "Ŕ", "Rang": "⟫", "Rarr": "↠", "Rarrtl": "⤖", "Rcaron": "Ř", "Rcedil": "Ŗ", "Rcy": "Р", "Re": "ℜ", "ReverseElement": "∋", "ReverseEquilibrium": "⇋", "ReverseUpEquilibrium": "⥯", "Rfr": "ℜ", "Rho": "Ρ", "RightAngleBracket": "⟩", "RightArrow": "→", "RightArrowBar": "⇥", "RightArrowLeftArrow": "⇄", "RightCeiling": "⌉", "RightDoubleBracket": "⟧", "RightDownTeeVector": "⥝", "RightDownVector": "⇂", "RightDownVectorBar": "⥕", "RightFloor": "⌋", "RightTee": "⊢", "RightTeeArrow": "↦", "RightTeeVector": "⥛", "RightTriangle": "⊳", "RightTriangleBar": "⧐", "RightTriangleEqual": "⊵", "RightUpDownVector": "⥏", "RightUpTeeVector": "⥜", "RightUpVector": "↾", "RightUpVectorBar": "⥔", "RightVector": "⇀", "RightVectorBar": "⥓", "Rightarrow": "⇒", "Ropf": "ℝ", "RoundImplies": "⥰", "Rrightarrow": "⇛", "Rscr": "ℛ", "Rsh": "↱", "RuleDelayed": "⧴", "SHCHcy": "Щ", "SHcy": "Ш", "SOFTcy": "Ь", "Sacute": "Ś", "Sc": "⪼", "Scaron": "Š", "Scedil": "Ş", "Scirc": "Ŝ", "Scy": "С", "Sfr": "𝔖", "ShortDownArrow": "↓", "ShortLeftArrow": "←", "ShortRightArrow": "→", "ShortUpArrow": "↑", "Sigma": "Σ", "SmallCircle": "∘", "Sopf": "𝕊", "Sqrt": "√", "Square": "□", "SquareIntersection": "⊓", "SquareSubset": "⊏", "SquareSubsetEqual": "⊑", "SquareSuperset": "⊐", "SquareSupersetEqual": "⊒", "SquareUnion": "⊔", "Sscr": "𝒮", "Star": "⋆", "Sub": "⋐", "Subset": "⋐", "SubsetEqual": "⊆", "Succeeds": "≻", "SucceedsEqual": "⪰", "SucceedsSlantEqual": "≽", "SucceedsTilde": "≿", "SuchThat": "∋", "Sum": "∑", "Sup": "⋑", "Superset": "⊃", "SupersetEqual": "⊇", "Supset": "⋑", "THOR": "Þ", "THORN": "Þ", "TRADE": "™", "TSHcy": "Ћ", "TScy": "Ц", "Tab": "	", "Tau": "Τ", "Tcaron": "Ť", "Tcedil": "Ţ", "Tcy": "Т", "Tfr": "𝔗", "Therefore": "∴", "Theta": "Θ", "ThickSpace": "  ", "ThinSpace": " ", "Tilde": "∼", "TildeEqual": "≃", "TildeFullEqual": "≅", "TildeTilde": "≈", "Topf": "𝕋", "TripleDot": "⃛", "Tscr": "𝒯", "Tstrok": "Ŧ", "Uacut": "Ú", "Uacute": "Ú", "Uarr": "↟", "Uarrocir": "⥉", "Ubrcy": "Ў", "Ubreve": "Ŭ", "Ucir": "Û", "Ucirc": "Û", "Ucy": "У", "Udblac": "Ű", "Ufr": "𝔘", "Ugrav": "Ù", "Ugrave": "Ù", "Umacr": "Ū", "UnderBar": "_", "UnderBrace": "⏟", "UnderBracket": "⎵", "UnderParenthesis": "⏝", "Union": "⋃", "UnionPlus": "⊎", "Uogon": "Ų", "Uopf": "𝕌", "UpArrow": "↑", "UpArrowBar": "⤒", "UpArrowDownArrow": "⇅", "UpDownArrow": "↕", "UpEquilibrium": "⥮", "UpTee": "⊥", "UpTeeArrow": "↥", "Uparrow": "⇑", "Updownarrow": "⇕", "UpperLeftArrow": "↖", "UpperRightArrow": "↗", "Upsi": "ϒ", "Upsilon": "Υ", "Uring": "Ů", "Uscr": "𝒰", "Utilde": "Ũ", "Uum": "Ü", "Uuml": "Ü", "VDash": "⊫", "Vbar": "⫫", "Vcy": "В", "Vdash": "⊩", "Vdashl": "⫦", "Vee": "⋁", "Verbar": "‖", "Vert": "‖", "VerticalBar": "∣", "VerticalLine": "|", "VerticalSeparator": "❘", "VerticalTilde": "≀", "VeryThinSpace": " ", "Vfr": "𝔙", "Vopf": "𝕍", "Vscr": "𝒱", "Vvdash": "⊪", "Wcirc": "Ŵ", "Wedge": "⋀", "Wfr": "𝔚", "Wopf": "𝕎", "Wscr": "𝒲", "Xfr": "𝔛", "Xi": "Ξ", "Xopf": "𝕏", "Xscr": "𝒳", "YAcy": "Я", "YIcy": "Ї", "YUcy": "Ю", "Yacut": "Ý", "Yacute": "Ý", "Ycirc": "Ŷ", "Ycy": "Ы", "Yfr": "𝔜", "Yopf": "𝕐", "Yscr": "𝒴", "Yuml": "Ÿ", "ZHcy": "Ж", "Zacute": "Ź", "Zcaron": "Ž", "Zcy": "З", "Zdot": "Ż", "ZeroWidthSpace": "​", "Zeta": "Ζ", "Zfr": "ℨ", "Zopf": "ℤ", "Zscr": "𝒵", "aacut": "á", "aacute": "á", "abreve": "ă", "ac": "∾", "acE": "∾̳", "acd": "∿", "acir": "â", "acirc": "â", "acut": "´", "acute": "´", "acy": "а", "aeli": "æ", "aelig": "æ", "af": "⁡", "afr": "𝔞", "agrav": "à", "agrave": "à", "alefsym": "ℵ", "aleph": "ℵ", "alpha": "α", "amacr": "ā", "amalg": "⨿", "am": "&", "amp": "&", "and": "∧", "andand": "⩕", "andd": "⩜", "andslope": "⩘", "andv": "⩚", "ang": "∠", "ange": "⦤", "angle": "∠", "angmsd": "∡", "angmsdaa": "⦨", "angmsdab": "⦩", "angmsdac": "⦪", "angmsdad": "⦫", "angmsdae": "⦬", "angmsdaf": "⦭", "angmsdag": "⦮", "angmsdah": "⦯", "angrt": "∟", "angrtvb": "⊾", "angrtvbd": "⦝", "angsph": "∢", "angst": "Å", "angzarr": "⍼", "aogon": "ą", "aopf": "𝕒", "ap": "≈", "apE": "⩰", "apacir": "⩯", "ape": "≊", "apid": "≋", "apos": "'", "approx": "≈", "approxeq": "≊", "arin": "å", "aring": "å", "ascr": "𝒶", "ast": "*", "asymp": "≈", "asympeq": "≍", "atild": "ã", "atilde": "ã", "aum": "ä", "auml": "ä", "awconint": "∳", "awint": "⨑", "bNot": "⫭", "backcong": "≌", "backepsilon": "϶", "backprime": "‵", "backsim": "∽", "backsimeq": "⋍", "barvee": "⊽", "barwed": "⌅", "barwedge": "⌅", "bbrk": "⎵", "bbrktbrk": "⎶", "bcong": "≌", "bcy": "б", "bdquo": "„", "becaus": "∵", "because": "∵", "bemptyv": "⦰", "bepsi": "϶", "bernou": "ℬ", "beta": "β", "beth": "ℶ", "between": "≬", "bfr": "𝔟", "bigcap": "⋂", "bigcirc": "◯", "bigcup": "⋃", "bigodot": "⨀", "bigoplus": "⨁", "bigotimes": "⨂", "bigsqcup": "⨆", "bigstar": "★", "bigtriangledown": "▽", "bigtriangleup": "△", "biguplus": "⨄", "bigvee": "⋁", "bigwedge": "⋀", "bkarow": "⤍", "blacklozenge": "⧫", "blacksquare": "▪", "blacktriangle": "▴", "blacktriangledown": "▾", "blacktriangleleft": "◂", "blacktriangleright": "▸", "blank": "␣", "blk12": "▒", "blk14": "░", "blk34": "▓", "block": "█", "bne": "=⃥", "bnequiv": "≡⃥", "bnot": "⌐", "bopf": "𝕓", "bot": "⊥", "bottom": "⊥", "bowtie": "⋈", "boxDL": "╗", "boxDR": "╔", "boxDl": "╖", "boxDr": "╓", "boxH": "═", "boxHD": "╦", "boxHU": "╩", "boxHd": "╤", "boxHu": "╧", "boxUL": "╝", "boxUR": "╚", "boxUl": "╜", "boxUr": "╙", "boxV": "║", "boxVH": "╬", "boxVL": "╣", "boxVR": "╠", "boxVh": "╫", "boxVl": "╢", "boxVr": "╟", "boxbox": "⧉", "boxdL": "╕", "boxdR": "╒", "boxdl": "┐", "boxdr": "┌", "boxh": "─", "boxhD": "╥", "boxhU": "╨", "boxhd": "┬", "boxhu": "┴", "boxminus": "⊟", "boxplus": "⊞", "boxtimes": "⊠", "boxuL": "╛", "boxuR": "╘", "boxul": "┘", "boxur": "└", "boxv": "│", "boxvH": "╪", "boxvL": "╡", "boxvR": "╞", "boxvh": "┼", "boxvl": "┤", "boxvr": "├", "bprime": "‵", "breve": "˘", "brvba": "¦", "brvbar": "¦", "bscr": "𝒷", "bsemi": "⁏", "bsim": "∽", "bsime": "⋍", "bsol": "\\", "bsolb": "⧅", "bsolhsub": "⟈", "bull": "•", "bullet": "•", "bump": "≎", "bumpE": "⪮", "bumpe": "≏", "bumpeq": "≏", "cacute": "ć", "cap": "∩", "capand": "⩄", "capbrcup": "⩉", "capcap": "⩋", "capcup": "⩇", "capdot": "⩀", "caps": "∩︀", "caret": "⁁", "caron": "ˇ", "ccaps": "⩍", "ccaron": "č", "ccedi": "ç", "ccedil": "ç", "ccirc": "ĉ", "ccups": "⩌", "ccupssm": "⩐", "cdot": "ċ", "cedi": "¸", "cedil": "¸", "cemptyv": "⦲", "cen": "¢", "cent": "¢", "centerdot": "·", "cfr": "𝔠", "chcy": "ч", "check": "✓", "checkmark": "✓", "chi": "χ", "cir": "○", "cirE": "⧃", "circ": "ˆ", "circeq": "≗", "circlearrowleft": "↺", "circlearrowright": "↻", "circledR": "®", "circledS": "Ⓢ", "circledast": "⊛", "circledcirc": "⊚", "circleddash": "⊝", "cire": "≗", "cirfnint": "⨐", "cirmid": "⫯", "cirscir": "⧂", "clubs": "♣", "clubsuit": "♣", "colon": ":", "colone": "≔", "coloneq": "≔", "comma": ",", "commat": "@", "comp": "∁", "compfn": "∘", "complement": "∁", "complexes": "ℂ", "cong": "≅", "congdot": "⩭", "conint": "∮", "copf": "𝕔", "coprod": "∐", "cop": "©", "copy": "©", "copysr": "℗", "crarr": "↵", "cross": "✗", "cscr": "𝒸", "csub": "⫏", "csube": "⫑", "csup": "⫐", "csupe": "⫒", "ctdot": "⋯", "cudarrl": "⤸", "cudarrr": "⤵", "cuepr": "⋞", "cuesc": "⋟", "cularr": "↶", "cularrp": "⤽", "cup": "∪", "cupbrcap": "⩈", "cupcap": "⩆", "cupcup": "⩊", "cupdot": "⊍", "cupor": "⩅", "cups": "∪︀", "curarr": "↷", "curarrm": "⤼", "curlyeqprec": "⋞", "curlyeqsucc": "⋟", "curlyvee": "⋎", "curlywedge": "⋏", "curre": "¤", "curren": "¤", "curvearrowleft": "↶", "curvearrowright": "↷", "cuvee": "⋎", "cuwed": "⋏", "cwconint": "∲", "cwint": "∱", "cylcty": "⌭", "dArr": "⇓", "dHar": "⥥", "dagger": "†", "daleth": "ℸ", "darr": "↓", "dash": "‐", "dashv": "⊣", "dbkarow": "⤏", "dblac": "˝", "dcaron": "ď", "dcy": "д", "dd": "ⅆ", "ddagger": "‡", "ddarr": "⇊", "ddotseq": "⩷", "de": "°", "deg": "°", "delta": "δ", "demptyv": "⦱", "dfisht": "⥿", "dfr": "𝔡", "dharl": "⇃", "dharr": "⇂", "diam": "⋄", "diamond": "⋄", "diamondsuit": "♦", "diams": "♦", "die": "¨", "digamma": "ϝ", "disin": "⋲", "div": "÷", "divid": "÷", "divide": "÷", "divideontimes": "⋇", "divonx": "⋇", "djcy": "ђ", "dlcorn": "⌞", "dlcrop": "⌍", "dollar": "$", "dopf": "𝕕", "dot": "˙", "doteq": "≐", "doteqdot": "≑", "dotminus": "∸", "dotplus": "∔", "dotsquare": "⊡", "doublebarwedge": "⌆", "downarrow": "↓", "downdownarrows": "⇊", "downharpoonleft": "⇃", "downharpoonright": "⇂", "drbkarow": "⤐", "drcorn": "⌟", "drcrop": "⌌", "dscr": "𝒹", "dscy": "ѕ", "dsol": "⧶", "dstrok": "đ", "dtdot": "⋱", "dtri": "▿", "dtrif": "▾", "duarr": "⇵", "duhar": "⥯", "dwangle": "⦦", "dzcy": "џ", "dzigrarr": "⟿", "eDDot": "⩷", "eDot": "≑", "eacut": "é", "eacute": "é", "easter": "⩮", "ecaron": "ě", "ecir": "ê", "ecirc": "ê", "ecolon": "≕", "ecy": "э", "edot": "ė", "ee": "ⅇ", "efDot": "≒", "efr": "𝔢", "eg": "⪚", "egrav": "è", "egrave": "è", "egs": "⪖", "egsdot": "⪘", "el": "⪙", "elinters": "⏧", "ell": "ℓ", "els": "⪕", "elsdot": "⪗", "emacr": "ē", "empty": "∅", "emptyset": "∅", "emptyv": "∅", "emsp13": " ", "emsp14": " ", "emsp": " ", "eng": "ŋ", "ensp": " ", "eogon": "ę", "eopf": "𝕖", "epar": "⋕", "eparsl": "⧣", "eplus": "⩱", "epsi": "ε", "epsilon": "ε", "epsiv": "ϵ", "eqcirc": "≖", "eqcolon": "≕", "eqsim": "≂", "eqslantgtr": "⪖", "eqslantless": "⪕", "equals": "=", "equest": "≟", "equiv": "≡", "equivDD": "⩸", "eqvparsl": "⧥", "erDot": "≓", "erarr": "⥱", "escr": "ℯ", "esdot": "≐", "esim": "≂", "eta": "η", "et": "ð", "eth": "ð", "eum": "ë", "euml": "ë", "euro": "€", "excl": "!", "exist": "∃", "expectation": "ℰ", "exponentiale": "ⅇ", "fallingdotseq": "≒", "fcy": "ф", "female": "♀", "ffilig": "ﬃ", "fflig": "ﬀ", "ffllig": "ﬄ", "ffr": "𝔣", "filig": "ﬁ", "fjlig": "fj", "flat": "♭", "fllig": "ﬂ", "fltns": "▱", "fnof": "ƒ", "fopf": "𝕗", "forall": "∀", "fork": "⋔", "forkv": "⫙", "fpartint": "⨍", "frac1": "¼", "frac12": "½", "frac13": "⅓", "frac14": "¼", "frac15": "⅕", "frac16": "⅙", "frac18": "⅛", "frac23": "⅔", "frac25": "⅖", "frac3": "¾", "frac34": "¾", "frac35": "⅗", "frac38": "⅜", "frac45": "⅘", "frac56": "⅚", "frac58": "⅝", "frac78": "⅞", "frasl": "⁄", "frown": "⌢", "fscr": "𝒻", "gE": "≧", "gEl": "⪌", "gacute": "ǵ", "gamma": "γ", "gammad": "ϝ", "gap": "⪆", "gbreve": "ğ", "gcirc": "ĝ", "gcy": "г", "gdot": "ġ", "ge": "≥", "gel": "⋛", "geq": "≥", "geqq": "≧", "geqslant": "⩾", "ges": "⩾", "gescc": "⪩", "gesdot": "⪀", "gesdoto": "⪂", "gesdotol": "⪄", "gesl": "⋛︀", "gesles": "⪔", "gfr": "𝔤", "gg": "≫", "ggg": "⋙", "gimel": "ℷ", "gjcy": "ѓ", "gl": "≷", "glE": "⪒", "gla": "⪥", "glj": "⪤", "gnE": "≩", "gnap": "⪊", "gnapprox": "⪊", "gne": "⪈", "gneq": "⪈", "gneqq": "≩", "gnsim": "⋧", "gopf": "𝕘", "grave": "`", "gscr": "ℊ", "gsim": "≳", "gsime": "⪎", "gsiml": "⪐", "g": ">", "gt": ">", "gtcc": "⪧", "gtcir": "⩺", "gtdot": "⋗", "gtlPar": "⦕", "gtquest": "⩼", "gtrapprox": "⪆", "gtrarr": "⥸", "gtrdot": "⋗", "gtreqless": "⋛", "gtreqqless": "⪌", "gtrless": "≷", "gtrsim": "≳", "gvertneqq": "≩︀", "gvnE": "≩︀", "hArr": "⇔", "hairsp": " ", "half": "½", "hamilt": "ℋ", "hardcy": "ъ", "harr": "↔", "harrcir": "⥈", "harrw": "↭", "hbar": "ℏ", "hcirc": "ĥ", "hearts": "♥", "heartsuit": "♥", "hellip": "…", "hercon": "⊹", "hfr": "𝔥", "hksearow": "⤥", "hkswarow": "⤦", "hoarr": "⇿", "homtht": "∻", "hookleftarrow": "↩", "hookrightarrow": "↪", "hopf": "𝕙", "horbar": "―", "hscr": "𝒽", "hslash": "ℏ", "hstrok": "ħ", "hybull": "⁃", "hyphen": "‐", "iacut": "í", "iacute": "í", "ic": "⁣", "icir": "î", "icirc": "î", "icy": "и", "iecy": "е", "iexc": "¡", "iexcl": "¡", "iff": "⇔", "ifr": "𝔦", "igrav": "ì", "igrave": "ì", "ii": "ⅈ", "iiiint": "⨌", "iiint": "∭", "iinfin": "⧜", "iiota": "℩", "ijlig": "ĳ", "imacr": "ī", "image": "ℑ", "imagline": "ℐ", "imagpart": "ℑ", "imath": "ı", "imof": "⊷", "imped": "Ƶ", "in": "∈", "incare": "℅", "infin": "∞", "infintie": "⧝", "inodot": "ı", "int": "∫", "intcal": "⊺", "integers": "ℤ", "intercal": "⊺", "intlarhk": "⨗", "intprod": "⨼", "iocy": "ё", "iogon": "į", "iopf": "𝕚", "iota": "ι", "iprod": "⨼", "iques": "¿", "iquest": "¿", "iscr": "𝒾", "isin": "∈", "isinE": "⋹", "isindot": "⋵", "isins": "⋴", "isinsv": "⋳", "isinv": "∈", "it": "⁢", "itilde": "ĩ", "iukcy": "і", "ium": "ï", "iuml": "ï", "jcirc": "ĵ", "jcy": "й", "jfr": "𝔧", "jmath": "ȷ", "jopf": "𝕛", "jscr": "𝒿", "jsercy": "ј", "jukcy": "є", "kappa": "κ", "kappav": "ϰ", "kcedil": "ķ", "kcy": "к", "kfr": "𝔨", "kgreen": "ĸ", "khcy": "х", "kjcy": "ќ", "kopf": "𝕜", "kscr": "𝓀", "lAarr": "⇚", "lArr": "⇐", "lAtail": "⤛", "lBarr": "⤎", "lE": "≦", "lEg": "⪋", "lHar": "⥢", "lacute": "ĺ", "laemptyv": "⦴", "lagran": "ℒ", "lambda": "λ", "lang": "⟨", "langd": "⦑", "langle": "⟨", "lap": "⪅", "laqu": "«", "laquo": "«", "larr": "←", "larrb": "⇤", "larrbfs": "⤟", "larrfs": "⤝", "larrhk": "↩", "larrlp": "↫", "larrpl": "⤹", "larrsim": "⥳", "larrtl": "↢", "lat": "⪫", "latail": "⤙", "late": "⪭", "lates": "⪭︀", "lbarr": "⤌", "lbbrk": "❲", "lbrace": "{", "lbrack": "[", "lbrke": "⦋", "lbrksld": "⦏", "lbrkslu": "⦍", "lcaron": "ľ", "lcedil": "ļ", "lceil": "⌈", "lcub": "{", "lcy": "л", "ldca": "⤶", "ldquo": "“", "ldquor": "„", "ldrdhar": "⥧", "ldrushar": "⥋", "ldsh": "↲", "le": "≤", "leftarrow": "←", "leftarrowtail": "↢", "leftharpoondown": "↽", "leftharpoonup": "↼", "leftleftarrows": "⇇", "leftrightarrow": "↔", "leftrightarrows": "⇆", "leftrightharpoons": "⇋", "leftrightsquigarrow": "↭", "leftthreetimes": "⋋", "leg": "⋚", "leq": "≤", "leqq": "≦", "leqslant": "⩽", "les": "⩽", "lescc": "⪨", "lesdot": "⩿", "lesdoto": "⪁", "lesdotor": "⪃", "lesg": "⋚︀", "lesges": "⪓", "lessapprox": "⪅", "lessdot": "⋖", "lesseqgtr": "⋚", "lesseqqgtr": "⪋", "lessgtr": "≶", "lesssim": "≲", "lfisht": "⥼", "lfloor": "⌊", "lfr": "𝔩", "lg": "≶", "lgE": "⪑", "lhard": "↽", "lharu": "↼", "lharul": "⥪", "lhblk": "▄", "ljcy": "љ", "ll": "≪", "llarr": "⇇", "llcorner": "⌞", "llhard": "⥫", "lltri": "◺", "lmidot": "ŀ", "lmoust": "⎰", "lmoustache": "⎰", "lnE": "≨", "lnap": "⪉", "lnapprox": "⪉", "lne": "⪇", "lneq": "⪇", "lneqq": "≨", "lnsim": "⋦", "loang": "⟬", "loarr": "⇽", "lobrk": "⟦", "longleftarrow": "⟵", "longleftrightarrow": "⟷", "longmapsto": "⟼", "longrightarrow": "⟶", "looparrowleft": "↫", "looparrowright": "↬", "lopar": "⦅", "lopf": "𝕝", "loplus": "⨭", "lotimes": "⨴", "lowast": "∗", "lowbar": "_", "loz": "◊", "lozenge": "◊", "lozf": "⧫", "lpar": "(", "lparlt": "⦓", "lrarr": "⇆", "lrcorner": "⌟", "lrhar": "⇋", "lrhard": "⥭", "lrm": "‎", "lrtri": "⊿", "lsaquo": "‹", "lscr": "𝓁", "lsh": "↰", "lsim": "≲", "lsime": "⪍", "lsimg": "⪏", "lsqb": "[", "lsquo": "‘", "lsquor": "‚", "lstrok": "ł", "l": "<", "lt": "<", "ltcc": "⪦", "ltcir": "⩹", "ltdot": "⋖", "lthree": "⋋", "ltimes": "⋉", "ltlarr": "⥶", "ltquest": "⩻", "ltrPar": "⦖", "ltri": "◃", "ltrie": "⊴", "ltrif": "◂", "lurdshar": "⥊", "luruhar": "⥦", "lvertneqq": "≨︀", "lvnE": "≨︀", "mDDot": "∺", "mac": "¯", "macr": "¯", "male": "♂", "malt": "✠", "maltese": "✠", "map": "↦", "mapsto": "↦", "mapstodown": "↧", "mapstoleft": "↤", "mapstoup": "↥", "marker": "▮", "mcomma": "⨩", "mcy": "м", "mdash": "—", "measuredangle": "∡", "mfr": "𝔪", "mho": "℧", "micr": "µ", "micro": "µ", "mid": "∣", "midast": "*", "midcir": "⫰", "middo": "·", "middot": "·", "minus": "−", "minusb": "⊟", "minusd": "∸", "minusdu": "⨪", "mlcp": "⫛", "mldr": "…", "mnplus": "∓", "models": "⊧", "mopf": "𝕞", "mp": "∓", "mscr": "𝓂", "mstpos": "∾", "mu": "μ", "multimap": "⊸", "mumap": "⊸", "nGg": "⋙̸", "nGt": "≫⃒", "nGtv": "≫̸", "nLeftarrow": "⇍", "nLeftrightarrow": "⇎", "nLl": "⋘̸", "nLt": "≪⃒", "nLtv": "≪̸", "nRightarrow": "⇏", "nVDash": "⊯", "nVdash": "⊮", "nabla": "∇", "nacute": "ń", "nang": "∠⃒", "nap": "≉", "napE": "⩰̸", "napid": "≋̸", "napos": "ŉ", "napprox": "≉", "natur": "♮", "natural": "♮", "naturals": "ℕ", "nbs": " ", "nbsp": " ", "nbump": "≎̸", "nbumpe": "≏̸", "ncap": "⩃", "ncaron": "ň", "ncedil": "ņ", "ncong": "≇", "ncongdot": "⩭̸", "ncup": "⩂", "ncy": "н", "ndash": "–", "ne": "≠", "neArr": "⇗", "nearhk": "⤤", "nearr": "↗", "nearrow": "↗", "nedot": "≐̸", "nequiv": "≢", "nesear": "⤨", "nesim": "≂̸", "nexist": "∄", "nexists": "∄", "nfr": "𝔫", "ngE": "≧̸", "nge": "≱", "ngeq": "≱", "ngeqq": "≧̸", "ngeqslant": "⩾̸", "nges": "⩾̸", "ngsim": "≵", "ngt": "≯", "ngtr": "≯", "nhArr": "⇎", "nharr": "↮", "nhpar": "⫲", "ni": "∋", "nis": "⋼", "nisd": "⋺", "niv": "∋", "njcy": "њ", "nlArr": "⇍", "nlE": "≦̸", "nlarr": "↚", "nldr": "‥", "nle": "≰", "nleftarrow": "↚", "nleftrightarrow": "↮", "nleq": "≰", "nleqq": "≦̸", "nleqslant": "⩽̸", "nles": "⩽̸", "nless": "≮", "nlsim": "≴", "nlt": "≮", "nltri": "⋪", "nltrie": "⋬", "nmid": "∤", "nopf": "𝕟", "no": "¬", "not": "¬", "notin": "∉", "notinE": "⋹̸", "notindot": "⋵̸", "notinva": "∉", "notinvb": "⋷", "notinvc": "⋶", "notni": "∌", "notniva": "∌", "notnivb": "⋾", "notnivc": "⋽", "npar": "∦", "nparallel": "∦", "nparsl": "⫽⃥", "npart": "∂̸", "npolint": "⨔", "npr": "⊀", "nprcue": "⋠", "npre": "⪯̸", "nprec": "⊀", "npreceq": "⪯̸", "nrArr": "⇏", "nrarr": "↛", "nrarrc": "⤳̸", "nrarrw": "↝̸", "nrightarrow": "↛", "nrtri": "⋫", "nrtrie": "⋭", "nsc": "⊁", "nsccue": "⋡", "nsce": "⪰̸", "nscr": "𝓃", "nshortmid": "∤", "nshortparallel": "∦", "nsim": "≁", "nsime": "≄", "nsimeq": "≄", "nsmid": "∤", "nspar": "∦", "nsqsube": "⋢", "nsqsupe": "⋣", "nsub": "⊄", "nsubE": "⫅̸", "nsube": "⊈", "nsubset": "⊂⃒", "nsubseteq": "⊈", "nsubseteqq": "⫅̸", "nsucc": "⊁", "nsucceq": "⪰̸", "nsup": "⊅", "nsupE": "⫆̸", "nsupe": "⊉", "nsupset": "⊃⃒", "nsupseteq": "⊉", "nsupseteqq": "⫆̸", "ntgl": "≹", "ntild": "ñ", "ntilde": "ñ", "ntlg": "≸", "ntriangleleft": "⋪", "ntrianglelefteq": "⋬", "ntriangleright": "⋫", "ntrianglerighteq": "⋭", "nu": "ν", "num": "#", "numero": "№", "numsp": " ", "nvDash": "⊭", "nvHarr": "⤄", "nvap": "≍⃒", "nvdash": "⊬", "nvge": "≥⃒", "nvgt": ">⃒", "nvinfin": "⧞", "nvlArr": "⤂", "nvle": "≤⃒", "nvlt": "<⃒", "nvltrie": "⊴⃒", "nvrArr": "⤃", "nvrtrie": "⊵⃒", "nvsim": "∼⃒", "nwArr": "⇖", "nwarhk": "⤣", "nwarr": "↖", "nwarrow": "↖", "nwnear": "⤧", "oS": "Ⓢ", "oacut": "ó", "oacute": "ó", "oast": "⊛", "ocir": "ô", "ocirc": "ô", "ocy": "о", "odash": "⊝", "odblac": "ő", "odiv": "⨸", "odot": "⊙", "odsold": "⦼", "oelig": "œ", "ofcir": "⦿", "ofr": "𝔬", "ogon": "˛", "ograv": "ò", "ograve": "ò", "ogt": "⧁", "ohbar": "⦵", "ohm": "Ω", "oint": "∮", "olarr": "↺", "olcir": "⦾", "olcross": "⦻", "oline": "‾", "olt": "⧀", "omacr": "ō", "omega": "ω", "omicron": "ο", "omid": "⦶", "ominus": "⊖", "oopf": "𝕠", "opar": "⦷", "operp": "⦹", "oplus": "⊕", "or": "∨", "orarr": "↻", "ord": "º", "order": "ℴ", "orderof": "ℴ", "ordf": "ª", "ordm": "º", "origof": "⊶", "oror": "⩖", "orslope": "⩗", "orv": "⩛", "oscr": "ℴ", "oslas": "ø", "oslash": "ø", "osol": "⊘", "otild": "õ", "otilde": "õ", "otimes": "⊗", "otimesas": "⨶", "oum": "ö", "ouml": "ö", "ovbar": "⌽", "par": "¶", "para": "¶", "parallel": "∥", "parsim": "⫳", "parsl": "⫽", "part": "∂", "pcy": "п", "percnt": "%", "period": ".", "permil": "‰", "perp": "⊥", "pertenk": "‱", "pfr": "𝔭", "phi": "φ", "phiv": "ϕ", "phmmat": "ℳ", "phone": "☎", "pi": "π", "pitchfork": "⋔", "piv": "ϖ", "planck": "ℏ", "planckh": "ℎ", "plankv": "ℏ", "plus": "+", "plusacir": "⨣", "plusb": "⊞", "pluscir": "⨢", "plusdo": "∔", "plusdu": "⨥", "pluse": "⩲", "plusm": "±", "plusmn": "±", "plussim": "⨦", "plustwo": "⨧", "pm": "±", "pointint": "⨕", "popf": "𝕡", "poun": "£", "pound": "£", "pr": "≺", "prE": "⪳", "prap": "⪷", "prcue": "≼", "pre": "⪯", "prec": "≺", "precapprox": "⪷", "preccurlyeq": "≼", "preceq": "⪯", "precnapprox": "⪹", "precneqq": "⪵", "precnsim": "⋨", "precsim": "≾", "prime": "′", "primes": "ℙ", "prnE": "⪵", "prnap": "⪹", "prnsim": "⋨", "prod": "∏", "profalar": "⌮", "profline": "⌒", "profsurf": "⌓", "prop": "∝", "propto": "∝", "prsim": "≾", "prurel": "⊰", "pscr": "𝓅", "psi": "ψ", "puncsp": " ", "qfr": "𝔮", "qint": "⨌", "qopf": "𝕢", "qprime": "⁗", "qscr": "𝓆", "quaternions": "ℍ", "quatint": "⨖", "quest": "?", "questeq": "≟", "quo": '"', "quot": '"', "rAarr": "⇛", "rArr": "⇒", "rAtail": "⤜", "rBarr": "⤏", "rHar": "⥤", "race": "∽̱", "racute": "ŕ", "radic": "√", "raemptyv": "⦳", "rang": "⟩", "rangd": "⦒", "range": "⦥", "rangle": "⟩", "raqu": "»", "raquo": "»", "rarr": "→", "rarrap": "⥵", "rarrb": "⇥", "rarrbfs": "⤠", "rarrc": "⤳", "rarrfs": "⤞", "rarrhk": "↪", "rarrlp": "↬", "rarrpl": "⥅", "rarrsim": "⥴", "rarrtl": "↣", "rarrw": "↝", "ratail": "⤚", "ratio": "∶", "rationals": "ℚ", "rbarr": "⤍", "rbbrk": "❳", "rbrace": "}", "rbrack": "]", "rbrke": "⦌", "rbrksld": "⦎", "rbrkslu": "⦐", "rcaron": "ř", "rcedil": "ŗ", "rceil": "⌉", "rcub": "}", "rcy": "р", "rdca": "⤷", "rdldhar": "⥩", "rdquo": "”", "rdquor": "”", "rdsh": "↳", "real": "ℜ", "realine": "ℛ", "realpart": "ℜ", "reals": "ℝ", "rect": "▭", "re": "®", "reg": "®", "rfisht": "⥽", "rfloor": "⌋", "rfr": "𝔯", "rhard": "⇁", "rharu": "⇀", "rharul": "⥬", "rho": "ρ", "rhov": "ϱ", "rightarrow": "→", "rightarrowtail": "↣", "rightharpoondown": "⇁", "rightharpoonup": "⇀", "rightleftarrows": "⇄", "rightleftharpoons": "⇌", "rightrightarrows": "⇉", "rightsquigarrow": "↝", "rightthreetimes": "⋌", "ring": "˚", "risingdotseq": "≓", "rlarr": "⇄", "rlhar": "⇌", "rlm": "‏", "rmoust": "⎱", "rmoustache": "⎱", "rnmid": "⫮", "roang": "⟭", "roarr": "⇾", "robrk": "⟧", "ropar": "⦆", "ropf": "𝕣", "roplus": "⨮", "rotimes": "⨵", "rpar": ")", "rpargt": "⦔", "rppolint": "⨒", "rrarr": "⇉", "rsaquo": "›", "rscr": "𝓇", "rsh": "↱", "rsqb": "]", "rsquo": "’", "rsquor": "’", "rthree": "⋌", "rtimes": "⋊", "rtri": "▹", "rtrie": "⊵", "rtrif": "▸", "rtriltri": "⧎", "ruluhar": "⥨", "rx": "℞", "sacute": "ś", "sbquo": "‚", "sc": "≻", "scE": "⪴", "scap": "⪸", "scaron": "š", "sccue": "≽", "sce": "⪰", "scedil": "ş", "scirc": "ŝ", "scnE": "⪶", "scnap": "⪺", "scnsim": "⋩", "scpolint": "⨓", "scsim": "≿", "scy": "с", "sdot": "⋅", "sdotb": "⊡", "sdote": "⩦", "seArr": "⇘", "searhk": "⤥", "searr": "↘", "searrow": "↘", "sec": "§", "sect": "§", "semi": ";", "seswar": "⤩", "setminus": "∖", "setmn": "∖", "sext": "✶", "sfr": "𝔰", "sfrown": "⌢", "sharp": "♯", "shchcy": "щ", "shcy": "ш", "shortmid": "∣", "shortparallel": "∥", "sh": "­", "shy": "­", "sigma": "σ", "sigmaf": "ς", "sigmav": "ς", "sim": "∼", "simdot": "⩪", "sime": "≃", "simeq": "≃", "simg": "⪞", "simgE": "⪠", "siml": "⪝", "simlE": "⪟", "simne": "≆", "simplus": "⨤", "simrarr": "⥲", "slarr": "←", "smallsetminus": "∖", "smashp": "⨳", "smeparsl": "⧤", "smid": "∣", "smile": "⌣", "smt": "⪪", "smte": "⪬", "smtes": "⪬︀", "softcy": "ь", "sol": "/", "solb": "⧄", "solbar": "⌿", "sopf": "𝕤", "spades": "♠", "spadesuit": "♠", "spar": "∥", "sqcap": "⊓", "sqcaps": "⊓︀", "sqcup": "⊔", "sqcups": "⊔︀", "sqsub": "⊏", "sqsube": "⊑", "sqsubset": "⊏", "sqsubseteq": "⊑", "sqsup": "⊐", "sqsupe": "⊒", "sqsupset": "⊐", "sqsupseteq": "⊒", "squ": "□", "square": "□", "squarf": "▪", "squf": "▪", "srarr": "→", "sscr": "𝓈", "ssetmn": "∖", "ssmile": "⌣", "sstarf": "⋆", "star": "☆", "starf": "★", "straightepsilon": "ϵ", "straightphi": "ϕ", "strns": "¯", "sub": "⊂", "subE": "⫅", "subdot": "⪽", "sube": "⊆", "subedot": "⫃", "submult": "⫁", "subnE": "⫋", "subne": "⊊", "subplus": "⪿", "subrarr": "⥹", "subset": "⊂", "subseteq": "⊆", "subseteqq": "⫅", "subsetneq": "⊊", "subsetneqq": "⫋", "subsim": "⫇", "subsub": "⫕", "subsup": "⫓", "succ": "≻", "succapprox": "⪸", "succcurlyeq": "≽", "succeq": "⪰", "succnapprox": "⪺", "succneqq": "⪶", "succnsim": "⋩", "succsim": "≿", "sum": "∑", "sung": "♪", "sup": "⊃", "sup1": "¹", "sup2": "²", "sup3": "³", "supE": "⫆", "supdot": "⪾", "supdsub": "⫘", "supe": "⊇", "supedot": "⫄", "suphsol": "⟉", "suphsub": "⫗", "suplarr": "⥻", "supmult": "⫂", "supnE": "⫌", "supne": "⊋", "supplus": "⫀", "supset": "⊃", "supseteq": "⊇", "supseteqq": "⫆", "supsetneq": "⊋", "supsetneqq": "⫌", "supsim": "⫈", "supsub": "⫔", "supsup": "⫖", "swArr": "⇙", "swarhk": "⤦", "swarr": "↙", "swarrow": "↙", "swnwar": "⤪", "szli": "ß", "szlig": "ß", "target": "⌖", "tau": "τ", "tbrk": "⎴", "tcaron": "ť", "tcedil": "ţ", "tcy": "т", "tdot": "⃛", "telrec": "⌕", "tfr": "𝔱", "there4": "∴", "therefore": "∴", "theta": "θ", "thetasym": "ϑ", "thetav": "ϑ", "thickapprox": "≈", "thicksim": "∼", "thinsp": " ", "thkap": "≈", "thksim": "∼", "thor": "þ", "thorn": "þ", "tilde": "˜", "time": "×", "times": "×", "timesb": "⊠", "timesbar": "⨱", "timesd": "⨰", "tint": "∭", "toea": "⤨", "top": "⊤", "topbot": "⌶", "topcir": "⫱", "topf": "𝕥", "topfork": "⫚", "tosa": "⤩", "tprime": "‴", "trade": "™", "triangle": "▵", "triangledown": "▿", "triangleleft": "◃", "trianglelefteq": "⊴", "triangleq": "≜", "triangleright": "▹", "trianglerighteq": "⊵", "tridot": "◬", "trie": "≜", "triminus": "⨺", "triplus": "⨹", "trisb": "⧍", "tritime": "⨻", "trpezium": "⏢", "tscr": "𝓉", "tscy": "ц", "tshcy": "ћ", "tstrok": "ŧ", "twixt": "≬", "twoheadleftarrow": "↞", "twoheadrightarrow": "↠", "uArr": "⇑", "uHar": "⥣", "uacut": "ú", "uacute": "ú", "uarr": "↑", "ubrcy": "ў", "ubreve": "ŭ", "ucir": "û", "ucirc": "û", "ucy": "у", "udarr": "⇅", "udblac": "ű", "udhar": "⥮", "ufisht": "⥾", "ufr": "𝔲", "ugrav": "ù", "ugrave": "ù", "uharl": "↿", "uharr": "↾", "uhblk": "▀", "ulcorn": "⌜", "ulcorner": "⌜", "ulcrop": "⌏", "ultri": "◸", "umacr": "ū", "um": "¨", "uml": "¨", "uogon": "ų", "uopf": "𝕦", "uparrow": "↑", "updownarrow": "↕", "upharpoonleft": "↿", "upharpoonright": "↾", "uplus": "⊎", "upsi": "υ", "upsih": "ϒ", "upsilon": "υ", "upuparrows": "⇈", "urcorn": "⌝", "urcorner": "⌝", "urcrop": "⌎", "uring": "ů", "urtri": "◹", "uscr": "𝓊", "utdot": "⋰", "utilde": "ũ", "utri": "▵", "utrif": "▴", "uuarr": "⇈", "uum": "ü", "uuml": "ü", "uwangle": "⦧", "vArr": "⇕", "vBar": "⫨", "vBarv": "⫩", "vDash": "⊨", "vangrt": "⦜", "varepsilon": "ϵ", "varkappa": "ϰ", "varnothing": "∅", "varphi": "ϕ", "varpi": "ϖ", "varpropto": "∝", "varr": "↕", "varrho": "ϱ", "varsigma": "ς", "varsubsetneq": "⊊︀", "varsubsetneqq": "⫋︀", "varsupsetneq": "⊋︀", "varsupsetneqq": "⫌︀", "vartheta": "ϑ", "vartriangleleft": "⊲", "vartriangleright": "⊳", "vcy": "в", "vdash": "⊢", "vee": "∨", "veebar": "⊻", "veeeq": "≚", "vellip": "⋮", "verbar": "|", "vert": "|", "vfr": "𝔳", "vltri": "⊲", "vnsub": "⊂⃒", "vnsup": "⊃⃒", "vopf": "𝕧", "vprop": "∝", "vrtri": "⊳", "vscr": "𝓋", "vsubnE": "⫋︀", "vsubne": "⊊︀", "vsupnE": "⫌︀", "vsupne": "⊋︀", "vzigzag": "⦚", "wcirc": "ŵ", "wedbar": "⩟", "wedge": "∧", "wedgeq": "≙", "weierp": "℘", "wfr": "𝔴", "wopf": "𝕨", "wp": "℘", "wr": "≀", "wreath": "≀", "wscr": "𝓌", "xcap": "⋂", "xcirc": "◯", "xcup": "⋃", "xdtri": "▽", "xfr": "𝔵", "xhArr": "⟺", "xharr": "⟷", "xi": "ξ", "xlArr": "⟸", "xlarr": "⟵", "xmap": "⟼", "xnis": "⋻", "xodot": "⨀", "xopf": "𝕩", "xoplus": "⨁", "xotime": "⨂", "xrArr": "⟹", "xrarr": "⟶", "xscr": "𝓍", "xsqcup": "⨆", "xuplus": "⨄", "xutri": "△", "xvee": "⋁", "xwedge": "⋀", "yacut": "ý", "yacute": "ý", "yacy": "я", "ycirc": "ŷ", "ycy": "ы", "ye": "¥", "yen": "¥", "yfr": "𝔶", "yicy": "ї", "yopf": "𝕪", "yscr": "𝓎", "yucy": "ю", "yum": "ÿ", "yuml": "ÿ", "zacute": "ź", "zcaron": "ž", "zcy": "з", "zdot": "ż", "zeetrf": "ℨ", "zeta": "ζ", "zfr": "𝔷", "zhcy": "ж", "zigrarr": "⇝", "zopf": "𝕫", "zscr": "𝓏", "zwj": "‍", "zwnj": "‌" };
const ENTITY_MAP$1 = _ENTITY_MAP$1;
function entityStringToRawString$1(entityStr) {
  if (!entityStr.startsWith("&")) {
    entityStr = "&" + entityStr;
  }
  if (!entityStr.endsWith(";")) {
    entityStr += ";";
  }
  try {
    if (entityStr.charAt(1) === "#") {
      const val = entityStr.charAt(2) === "x" ? parseInt(entityStr.slice(3, entityStr.length - 1), 16) : parseInt(entityStr.slice(2, entityStr.length - 1), 10);
      return String.fromCharCode(val);
    }
    const trimmedEntityString = entityStr.slice(1, entityStr.length - 1);
    if (trimmedEntityString in ENTITY_MAP$1) {
      return ENTITY_MAP$1[trimmedEntityString];
    }
  } catch (e2) {
    console.warn(
      `Encountered error when converting entity "${entityStr}": ${e2.message}`
    );
  }
  console.warn(`Cannot convert XML entity "${entityStr}"`);
  return entityStr;
}
function entityToString$1(node, source) {
  switch (node.name) {
    case "CharacterReference":
    case "EntityReference": {
      const entity = extractContent$1(node, source);
      const converted = entityStringToRawString$1(entity);
      if (converted === "$" && /[a-zA-Z_]/.test(source.charAt(node.to))) {
        return converted + "​";
      }
      return converted;
    }
  }
  throw new Error(
    `Cannot use entityToString to convert a node of type ${node.name}`
  );
}
function removeQuotes$1(str) {
  if (str.startsWith("'") || str.startsWith('"')) {
    str = str.slice(1);
  }
  if (str.endsWith("'") || str.endsWith('"')) {
    str = str.slice(0, str.length - 1);
  }
  return str;
}
function unescapeEntities$1(node, source) {
  const rawValue = extractContent$1(node, source);
  const entities2 = node.getChildren("EntityReference");
  if (entities2.length === 0) {
    return rawValue;
  }
  let i2 = 0;
  let ret = "";
  for (const entity of entities2) {
    ret += rawValue.slice(i2, entity.from - node.from);
    ret += entityToString$1(entity, source);
    i2 = entity.to - node.from;
  }
  ret += rawValue.slice(i2);
  return ret;
}
function textNodeToText$1(node, source) {
  if (node.name !== "Text") {
    throw new Error(
      `Can only convert node of type "Text", not the passed-in type of "${node.name}"`
    );
  }
  return unescapeEntities$1(node, source);
}
function attributeValueText$1(node, source) {
  if (node.name !== "AttributeValue") {
    throw new Error(
      `Can only get the text of an "AttributeValue" type node, not "${node.name}"`
    );
  }
  return removeQuotes$1(unescapeEntities$1(node, source));
}
function lezerNodeToPosition$1(node, offsetToPositionMap, adjustForQuotes = false) {
  const { rowMap, columnMap } = offsetToPositionMap;
  let { from, to: to2 } = node;
  if (adjustForQuotes) {
    from += 1;
    to2 -= 1;
  }
  return {
    start: {
      line: rowMap[from] + 1,
      column: columnMap[from] + 1,
      offset: from
    },
    end: { line: rowMap[to2] + 1, column: columnMap[to2] + 1, offset: to2 }
  };
}
function extractContent$1(node, source) {
  return source.slice(node.from, node.to);
}
function createOffsetToPositionMap$2(source) {
  const rowMap = new Uint32Array(source.length + 1);
  const columnMap = new Uint32Array(source.length + 1);
  const len = source.length;
  let currentRow = 0;
  let currentColumn = 0;
  for (let i2 = 0; i2 < len; i2++) {
    rowMap[i2] = currentRow;
    columnMap[i2] = currentColumn;
    if (source.charAt(i2) === "\n") {
      currentRow += 1;
      currentColumn = 0;
    } else {
      currentColumn += 1;
    }
  }
  rowMap[len] = currentRow;
  columnMap[len] = currentColumn;
  return { rowMap, columnMap };
}
function extractDoctypeInfo$1(rawDoctype) {
  if (rawDoctype.startsWith("<!DOCTYPE")) {
    rawDoctype = rawDoctype.slice(10);
  }
  if (rawDoctype.endsWith(">")) {
    rawDoctype = rawDoctype.slice(0, rawDoctype.length - 1);
  }
  rawDoctype = rawDoctype.trim();
  const match2 = rawDoctype.match(/^[\w-]*/);
  const name2 = match2?.[0] || "";
  if (name2) {
    rawDoctype = rawDoctype.slice(name2.length).trim();
  }
  let _public = null;
  let system = null;
  if (rawDoctype.startsWith("PUBLIC")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22) {
      if (match22[0]) {
        _public = match22[0].slice(1, match22[0].length - 1);
      }
      if (match22[1]) {
        system = match22[1].slice(1, match22[1].length - 1);
      }
    }
  }
  if (rawDoctype.startsWith("SYSTEM")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22 && match22[0]) {
      system = match22[0].slice(1, match22[0].length - 1);
    }
  }
  return { name: name2, public: _public, system };
}
function findFirstErrorInChild$1(node) {
  if (node.type.name === "⚠") {
    return node;
  }
  let child = node.firstChild;
  while (child) {
    const error = findFirstErrorInChild$1(child);
    if (error) {
      return error;
    }
    child = child.nextSibling;
  }
  return null;
}
function getLezerChildren$1(node) {
  const ret = [];
  let child = node.firstChild;
  while (child) {
    ret.push(child);
    child = child.nextSibling;
  }
  return ret;
}
function updateNodePositionData$1(nodeToUpdate, referenceNode, offsetToPositionMap) {
  if (!nodeToUpdate.position || !referenceNode.position) {
    return;
  }
  const offset2 = referenceNode.position.start.offset;
  if (nodeToUpdate.position.start.offset != null && offset2 != null) {
    nodeToUpdate.position.start.offset += offset2;
  }
  if (nodeToUpdate.position.end.offset != null && offset2 != null) {
    nodeToUpdate.position.end.offset += offset2;
  }
  const startOffset = nodeToUpdate.position.start.offset;
  const endOffset = nodeToUpdate.position.end.offset;
  if (startOffset != null && endOffset != null) {
    nodeToUpdate.position.start.line = offsetToPositionMap.rowMap[startOffset] + 1;
    nodeToUpdate.position.start.column = offsetToPositionMap.columnMap[startOffset] + 1;
    nodeToUpdate.position.end.line = offsetToPositionMap.rowMap[endOffset] + 1;
    nodeToUpdate.position.end.column = offsetToPositionMap.columnMap[endOffset] + 1;
  }
}
function createErrorNode$1(node, source, offsetToPositionMap) {
  if (!node.type.isError && !node.type.is(MissingCloseTag$1)) {
    throw new Error("Function can only be called on a node of type error.");
  }
  function errorNode(message, options2) {
    const { startNode = node, endNode = node } = options2 ?? {};
    const startPos = lezerNodeToPosition$1(startNode, offsetToPositionMap);
    const endPos = startNode !== endNode ? lezerNodeToPosition$1(endNode, offsetToPositionMap) : startPos;
    return {
      type: "error",
      message,
      position: { start: startPos.start, end: endPos.end }
    };
  }
  const parent = node.parent;
  if (!parent) {
    const message = `Invalid DoenetML: ${extractContent$1(node, source)}`;
    return {
      type: "error",
      message,
      position: lezerNodeToPosition$1(node, offsetToPositionMap)
    };
  }
  switch (parent.type.id) {
    case Element$2: {
      const openTag = parent.getChild(OpenTag$1);
      const closeTag = parent.getChild(CloseTag$1);
      const tagNameTag = (openTag || parent.getChild(SelfClosingTag$1) || closeTag)?.getChild(TagName$F);
      const openTagName = tagNameTag ? extractContent$1(tagNameTag, source) : "";
      if (openTag && !closeTag) {
        const openTagName2 = tagNameTag ? extractContent$1(tagNameTag, source) : "";
        const message = `Invalid DoenetML: The tag \`${extractContent$1(
          openTag,
          source
        )}\` has no closing tag. Expected a self-closing tag or a \`</${openTagName2}>\` tag.`;
        return errorNode(message, {
          startNode: openTag,
          endNode: openTag
        });
      }
      return errorNode(
        `Invalid DoenetML: Error in tag \`<${openTagName}>\``
      );
    }
    case Attribute$1: {
      const value = extractContent$1(parent, source);
      const attributeNameNode = parent.getChild("AttributeName");
      const isNode2 = parent.getChild("Is");
      if (attributeNameNode && isNode2) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute \`${value}\` appears to be missing a value.`
        );
      }
      return errorNode(
        `Invalid DoenetML: Invalid attribute \`${value}\``
      );
    }
    case AttributeValue$1: {
      const attribute = parent.parent;
      const value = extractContent$1(parent, source);
      const openQuote = value[0];
      const closeQuote = value[value.length - 1];
      if (!attribute || openQuote === closeQuote) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute value \`${value}\``
        );
      }
      const correctQuote = openQuote.match(/['"]/) ? openQuote : closeQuote.match(/['"]/) ? closeQuote : '"';
      return errorNode(
        `Invalid DoenetML: Invalid attribute value \`${value}\`. The quote marks do not match. You appear to be missing a \`${correctQuote}\``
      );
    }
    case OpenTag$1: {
      const tagName = parent.getChild(TagName$F);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name, e.g. \`<\``
        );
      }
      const endTag = parent.getChild(EndTag$1);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent$1(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
    case SelfClosingTag$1: {
      const tagName = parent.getChild(TagName$F);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name \`<${extractContent$1(
            node,
            source
          )}>\``
        );
      }
      const endTag = parent.getChild(SelfCloseEndTag$1);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent$1(
            parent,
            source
          )}\` was not closed (\`/>\` appears to be missing).`
        );
      }
      return errorNode(
        `Invalid DoenetML: Tag \`${extractContent$1(
          parent,
          source
        )}\` is not valid. It may have incorrect attributes.`
      );
    }
    case MismatchedCloseTag$1:
    case CloseTag$1: {
      const tagName = parent.getChild(TagName$F);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a closing tag without a tag name, e.g. \`</\``
        );
      }
      const endTag = parent.getChild(EndTag$1);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent$1(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
  }
  return errorNode(`Could not convert node ${node} to Dast node.`);
}
function unquotedAttributeValueMessage$1(assignName, valueName) {
  return `Attribute values must be enclosed in quotes: \`${assignName}="${valueName}"\``;
}
function findBareAttributeValuePairs$1(attrs, source) {
  if (attrs.length < 2) {
    return [];
  }
  const sorted = attrs.filter(
    (a2) => a2.position?.start.offset != null && a2.position?.end.offset != null
  ).sort(
    (a2, b2) => (a2.position?.start.offset ?? 0) - (b2.position?.start.offset ?? 0)
  );
  const pairs2 = [];
  for (let i2 = 1; i2 < sorted.length; i2++) {
    const prev = sorted[i2 - 1];
    const curr = sorted[i2];
    if (prev.children.length !== 0 || curr.children.length !== 0) {
      continue;
    }
    const prevSrc = source.slice(
      prev.position?.start.offset ?? 0,
      prev.position?.end.offset ?? 0
    );
    if (!/=\s*$/.test(prevSrc)) {
      continue;
    }
    pairs2.push({ assignAttr: prev, valueAttr: curr });
  }
  return pairs2;
}
const _MacroParser$1 = (
  // @generated by Peggy 5.1.0.
  //
  // https://peggyjs.org/
  /* @__PURE__ */ (function() {
    class peg$SyntaxError extends SyntaxError {
      constructor(message, expected, found, location) {
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
      }
      format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
          let src = null;
          const st2 = sources.find((s22) => s22.source === this.location.source);
          if (st2) {
            src = st2.text.split(/\r\n|\n|\r/g);
          }
          const s2 = this.location.start;
          const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s2) : s2;
          const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
          if (src) {
            const e2 = this.location.end;
            const filler = "".padEnd(offset_s.line.toString().length, " ");
            const line2 = src[s2.line - 1];
            const last2 = s2.line === e2.line ? e2.column : line2.length + 1;
            const hatLen = last2 - s2.column || 1;
            str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line2 + "\n" + filler + " | " + "".padEnd(s2.column - 1, " ") + "".padEnd(hatLen, "^");
          } else {
            str += "\n at " + loc;
          }
        }
        return str;
      }
      static buildMessage(expected, found) {
        function hex(ch) {
          return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s2) {
          if (nonPrintable) {
            return s2.replace(nonPrintable, (ch) => "\\u{" + hex(ch) + "}");
          }
          return s2;
        }
        function literalEscape(s2) {
          return unicodeEscape(s2.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        function classEscape(s2) {
          return unicodeEscape(s2.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
          literal(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
          },
          class(expectation) {
            const escapedParts = expectation.parts.map(
              (part) => Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part)
            );
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
          },
          any() {
            return "any character";
          },
          end() {
            return "end of input";
          },
          other(expectation) {
            return expectation.description;
          }
        };
        function describeExpectation(expectation) {
          return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected2) {
          const descriptions = expected2.map(describeExpectation);
          descriptions.sort();
          if (descriptions.length > 0) {
            let j2 = 1;
            for (let i2 = 1; i2 < descriptions.length; i2++) {
              if (descriptions[i2 - 1] !== descriptions[i2]) {
                descriptions[j2] = descriptions[i2];
                j2++;
              }
            }
            descriptions.length = j2;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        }
        function describeFound(found2) {
          return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
      }
    }
    function peg$parse(input, options2) {
      options2 = options2 !== void 0 ? options2 : {};
      const peg$FAILED = {};
      const peg$source = options2.grammarSource;
      const peg$startRuleFunctions = {
        top: peg$parsetop
      };
      let peg$startRuleFunction = peg$parsetop;
      const peg$c0 = ".";
      const peg$c1 = "$";
      const peg$c2 = "(";
      const peg$c3 = ")";
      const peg$c4 = "$$";
      const peg$c5 = ",";
      const peg$c6 = "{";
      const peg$c7 = "}";
      const peg$c8 = "[";
      const peg$c9 = "]";
      const peg$c10 = "=";
      const peg$c11 = '"';
      const peg$c12 = "'";
      const peg$r0 = /^[a-zA-Z_]/;
      const peg$r1 = /^[a-zA-Z0-9_]/;
      const peg$r2 = /^[a-zA-Z0-9_\-]/;
      const peg$r3 = /^[a-zA-Z0-9_:\-]/;
      const peg$r4 = /^[^$]/;
      const peg$r5 = /^[^(),$]/;
      const peg$r6 = /^[^(),]/;
      const peg$r7 = /^[^()$]/;
      const peg$r8 = /^[^()]/;
      const peg$r9 = /^[^'$]/;
      const peg$r10 = /^[^']/;
      const peg$r11 = /^[^\]$]/;
      const peg$r12 = /^[^\]]/;
      const peg$r13 = /^[^"$]/;
      const peg$r14 = /^[^"]/;
      const peg$r15 = /^[ \t\r\n]/;
      const peg$e0 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false, false);
      const peg$e1 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false, false);
      const peg$e2 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", "-"], false, false, false);
      const peg$e3 = peg$literalExpectation(".", false);
      const peg$e4 = peg$literalExpectation("$", false);
      const peg$e5 = peg$literalExpectation("(", false);
      const peg$e6 = peg$literalExpectation(")", false);
      const peg$e7 = peg$literalExpectation("$$", false);
      const peg$e8 = peg$literalExpectation(",", false);
      const peg$e9 = peg$literalExpectation("{", false);
      const peg$e10 = peg$literalExpectation("}", false);
      const peg$e11 = peg$literalExpectation("[", false);
      const peg$e12 = peg$literalExpectation("]", false);
      const peg$e13 = peg$literalExpectation("=", false);
      const peg$e14 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", ":", "-"], false, false, false);
      const peg$e15 = peg$literalExpectation('"', false);
      const peg$e16 = peg$literalExpectation("'", false);
      const peg$e17 = peg$classExpectation(["$"], true, false, false);
      const peg$e18 = peg$anyExpectation();
      const peg$e19 = peg$classExpectation(["(", ")", ",", "$"], true, false, false);
      const peg$e20 = peg$classExpectation(["(", ")", ","], true, false, false);
      const peg$e21 = peg$classExpectation(["(", ")", "$"], true, false, false);
      const peg$e22 = peg$classExpectation(["(", ")"], true, false, false);
      const peg$e23 = peg$classExpectation(["'", "$"], true, false, false);
      const peg$e24 = peg$classExpectation(["'"], true, false, false);
      const peg$e25 = peg$classExpectation(["]", "$"], true, false, false);
      const peg$e26 = peg$classExpectation(["]"], true, false, false);
      const peg$e27 = peg$classExpectation(['"', "$"], true, false, false);
      const peg$e28 = peg$classExpectation(['"'], true, false, false);
      const peg$e29 = peg$classExpectation([" ", "	", "\r", "\n"], false, false, false);
      function peg$f0(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f1(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f2(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f3(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f4(macro) {
        return withPosition(macro);
      }
      function peg$f5(macro) {
        return withPosition(macro);
      }
      function peg$f6(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f7(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f8(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f9(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f10(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f11(a2, rest2, b2) {
        return [a2, ...rest2, b2];
      }
      function peg$f12(x2) {
        return x2.flat();
      }
      function peg$f13(a2, rest2, b2) {
        return [a2, ...rest2, b2];
      }
      function peg$f14(x2) {
        return x2.flat();
      }
      function peg$f15(attrs) {
        return Object.fromEntries(attrs.map((a2) => [a2.name, a2]));
      }
      function peg$f16(value) {
        return withPosition({ type: "index", value });
      }
      function peg$f17(name2, children) {
        return withPosition({ type: "attribute", name: name2, children });
      }
      function peg$f18(name2) {
        return withPosition({
          type: "attribute",
          name: name2,
          children: []
        });
      }
      function peg$f19(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f21() {
        return withPosition({ type: "text", value: "(" });
      }
      function peg$f22() {
        return withPosition({ type: "text", value: ")" });
      }
      function peg$f23(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f24(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f25(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f26(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f27(value) {
        return withPosition({ type: "text", value });
      }
      let peg$currPos = options2.peg$currPos | 0;
      let peg$savedPos = peg$currPos;
      const peg$posDetailsCache = [{ line: 1, column: 1 }];
      let peg$maxFailPos = peg$currPos;
      let peg$maxFailExpected = options2.peg$maxFailExpected || [];
      let peg$silentFails = options2.peg$silentFails | 0;
      let peg$result;
      if (options2.startRule) {
        if (!(options2.startRule in peg$startRuleFunctions)) {
          throw new Error(`Can't start parsing from rule "` + options2.startRule + '".');
        }
        peg$startRuleFunction = peg$startRuleFunctions[options2.startRule];
      }
      function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
      }
      function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === void 0) {
          return "";
        }
        return String.fromCodePoint(cp);
      }
      function peg$literalExpectation(text2, ignoreCase) {
        return { type: "literal", text: text2, ignoreCase };
      }
      function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return { type: "class", parts, inverted, ignoreCase, unicode };
      }
      function peg$anyExpectation() {
        return { type: "any" };
      }
      function peg$endExpectation() {
        return { type: "end" };
      }
      function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p2;
        if (details) {
          return details;
        } else {
          if (pos >= peg$posDetailsCache.length) {
            p2 = peg$posDetailsCache.length - 1;
          } else {
            p2 = pos;
            while (!peg$posDetailsCache[--p2]) {
            }
          }
          details = peg$posDetailsCache[p2];
          details = {
            line: details.line,
            column: details.column
          };
          while (p2 < pos) {
            if (input.charCodeAt(p2) === 10) {
              details.line++;
              details.column = 1;
            } else {
              details.column++;
            }
            p2++;
          }
          peg$posDetailsCache[pos] = details;
          return details;
        }
      }
      function peg$computeLocation(startPos, endPos, offset2) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
          source: peg$source,
          start: {
            offset: startPos,
            line: startPosDetails.line,
            column: startPosDetails.column
          },
          end: {
            offset: endPos,
            line: endPosDetails.line,
            column: endPosDetails.column
          }
        };
        return res;
      }
      function peg$fail(expected2) {
        if (peg$currPos < peg$maxFailPos) {
          return;
        }
        if (peg$currPos > peg$maxFailPos) {
          peg$maxFailPos = peg$currPos;
          peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected2);
      }
      function peg$buildStructuredError(expected2, found, location2) {
        return new peg$SyntaxError(
          peg$SyntaxError.buildMessage(expected2, found),
          expected2,
          found,
          location2
        );
      }
      function peg$parsetop() {
        let s0, s1;
        s0 = [];
        s1 = peg$parseMacro();
        if (s1 === peg$FAILED) {
          s1 = peg$parseFunctionMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseText();
          }
        }
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          s1 = peg$parseMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseFunctionMacro();
            if (s1 === peg$FAILED) {
              s1 = peg$parseText();
            }
          }
        }
        return s0;
      }
      function peg$parseSimpleIdent() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = input.charAt(peg$currPos);
        if (peg$r0.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e0);
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = input.charAt(peg$currPos);
          if (peg$r1.test(s4)) {
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e1);
            }
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = input.charAt(peg$currPos);
            if (peg$r1.test(s4)) {
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e1);
              }
            }
          }
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseIdent() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r2.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e2);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r2.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e2);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseSimplePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseSimpleIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f0(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f1(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseSimplePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseSimplePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseSimplePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSimplePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f2(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parsePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parsePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parsePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f3(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseMacro() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 36) {
          s1 = peg$c1;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e4);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseFullAddressMacro();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f4(s3);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 36) {
            s1 = peg$c1;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e4);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimpleAddressMacro();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f5(s2);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseSimpleAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseSimplePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f6(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFullAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f7(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionMacro() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c4) {
          s1 = peg$c4;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e7);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parsePath();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                s5 = peg$parseFunctionInput();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f8(s3, s5);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e7);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimplePath();
            if (s2 !== peg$FAILED) {
              s3 = peg$parseFunctionInput();
              if (s3 === peg$FAILED) {
                s3 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f9(s2, s3);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseFunctionInput() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = peg$parseFunctionArgumentList();
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 41) {
            s5 = peg$c3;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e6);
            }
          }
          if (s5 !== peg$FAILED) {
            s0 = s3;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionArgumentList() {
        let s0, s1, s2, s3, s5, s7;
        s0 = peg$currPos;
        s1 = peg$parseBalancedParenTextNoComma();
        s2 = [];
        s3 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 44) {
          s5 = peg$c5;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e8);
          }
        }
        if (s5 !== peg$FAILED) {
          peg$parse_();
          s7 = peg$parseBalancedParenTextNoComma();
          s3 = s7;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 44) {
            s5 = peg$c5;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e8);
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s7 = peg$parseBalancedParenTextNoComma();
            s3 = s7;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f10(s1, s2);
        return s0;
      }
      function peg$parseBalancedParenTextNoComma() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParenOrComma();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f11(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParenOrComma();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f11(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f12(s1);
        s0 = s1;
        return s0;
      }
      function peg$parseBalancedParenText() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParen();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f13(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParen();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f13(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f14(s1);
        s0 = s1;
        return s0;
      }
      function peg$parsePropAttrs() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
          s1 = peg$c6;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e9);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseAttr();
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseAttr();
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 125) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e10);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f15(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePropIndex() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 91) {
          s1 = peg$c8;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e11);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseFunctionMacro();
          if (s5 === peg$FAILED) {
            s5 = peg$parseMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseTextWithoutClosingSquareBrace();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseFunctionMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseMacro();
              if (s5 === peg$FAILED) {
                s5 = peg$parseTextWithoutClosingSquareBrace();
              }
            }
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 93) {
            s4 = peg$c9;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e12);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f16(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseAttr() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        s1 = peg$parseAttrName();
        if (s1 !== peg$FAILED) {
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 61) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e13);
            }
          }
          if (s3 !== peg$FAILED) {
            peg$parse_();
            s5 = peg$parseAttrValue();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f17(s1, s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseAttrName();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f18(s1);
          }
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrName() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r3.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e14);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r3.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e14);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrValue() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
          s1 = peg$c11;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e15);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parseMacro();
          if (s3 === peg$FAILED) {
            s3 = peg$parseFunctionMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseTextWithoutDoubleQuote();
            }
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutDoubleQuote();
              }
            }
          }
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c11;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e15);
            }
          }
          if (s3 !== peg$FAILED) {
            s0 = s2;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c12;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e16);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutQuote();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseFunctionMacro();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseTextWithoutQuote();
                }
              }
            }
            if (input.charCodeAt(peg$currPos) === 39) {
              s3 = peg$c12;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e16);
              }
            }
            if (s3 !== peg$FAILED) {
              s0 = s2;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseText() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r4.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e17);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r4.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e17);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          if (input.length > peg$currPos) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e18);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f19(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseOpenParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f21();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseCloseParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 41) {
          s1 = peg$c3;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e6);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f22();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParenOrComma() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r5.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e19);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r5.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e19);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r6.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e20);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f23(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParen() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r7.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e21);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r7.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e21);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r8.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e22);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f24(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r9.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e23);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r9.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e23);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r10.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e24);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f25(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutClosingSquareBrace() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r11.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e25);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r11.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e25);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r12.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e26);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f26(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutDoubleQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r13.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e27);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r13.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e27);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r14.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e28);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f27(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parse_() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r15.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e29);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r15.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e29);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function withPosition(node) {
        const { start, end } = location();
        return { ...node, position: { start, end } };
      }
      peg$result = peg$startRuleFunction();
      const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
      function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
          peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(
          peg$maxFailExpected,
          peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
          peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
        );
      }
      if (options2.peg$library) {
        return (
          /** @type {any} */
          {
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos,
            peg$success,
            peg$throw: peg$success ? void 0 : peg$throw
          }
        );
      }
      if (peg$success) {
        return peg$result;
      } else {
        peg$throw();
      }
    }
    return {
      StartRules: ["top"],
      SyntaxError: peg$SyntaxError,
      parse: peg$parse
    };
  })()
);
const MacroParser$1 = _MacroParser$1;
function parseMacros$1(str) {
  return MacroParser$1.parse(str);
}
function gobbleFunctionArguments$1(nodes) {
  if (!nodes.some((node) => node.type === "function" && node.input == null)) {
    return nodes;
  }
  nodes = nodes.map(
    (node) => node.type === "text" ? splitTextAtSpecialChars$1(node) : node
  ).flat();
  const ret = [];
  let functionNode = null;
  for (let i2 = 0; i2 < nodes.length; i2++) {
    const node = nodes[i2];
    if (node.type === "function" && node.input == null) {
      functionNode = node;
      ret.push(node);
      continue;
    }
    if (!functionNode) {
      ret.push(node);
      continue;
    }
    if (!(node.type === "text" && node.value === "(") || !hasClosingParen$1(nodes.slice(i2))) {
      functionNode = null;
      ret.push(node);
      continue;
    }
    let currentFunctionArg = [];
    functionNode.input = [];
    let parenDepth = 1;
    i2++;
    while (functionNode) {
      const nextNode = nodes[i2];
      if (!nextNode) {
        throw new Error(
          "Failed to find next node when search for function arguments"
        );
      }
      if (nextNode.type !== "text") {
        currentFunctionArg.push(nextNode);
        i2++;
        continue;
      }
      if (nextNode.value === "(") {
        parenDepth++;
      }
      if (nextNode.value === "," && parenDepth <= 1) {
        functionNode.input.push(
          trimWhitespace$1(currentFunctionArg)
        );
        currentFunctionArg = [];
        i2++;
        continue;
      }
      if (nextNode.value === ")") {
        parenDepth--;
        if (parenDepth === 0) {
          functionNode.input.push(
            trimWhitespace$1(
              gobbleFunctionArguments$1(
                currentFunctionArg
              )
            )
          );
          currentFunctionArg = [];
          if (nextNode.position) {
            functionNode.position.end = {
              ...nextNode.position.end
            };
          }
          functionNode = null;
          i2++;
          continue;
        }
      }
      i2++;
      currentFunctionArg.push(nextNode);
    }
    i2--;
  }
  return ret;
}
function splitTextAtSpecialChars$1(node) {
  const pos = node.value.search(/[\(\),]/);
  if (pos < 0) {
    return [node];
  }
  const [left, middle, right] = splitTextNodeAt$1(node, pos);
  const ret = [left, middle, ...splitTextAtSpecialChars$1(right)];
  return ret.filter((node2) => node2.value !== "");
}
const DEFAULT_POSITION$1 = {
  start: { offset: 0, line: 1, column: 1 },
  end: { offset: 0, line: 1, column: 1 }
};
function splitTextNodeAt$1(node, pos) {
  const { value, position: position2 = DEFAULT_POSITION$1 } = node;
  if (pos < 0 || pos > value.length) {
    throw new Error(
      `Cannot split a string at a value larger than its length (got pos:${pos} for text node "${value}")`
    );
  }
  const { rowMap, columnMap } = createOffsetToPositionMap$2(value);
  const leftValue = value.slice(0, pos);
  const left = {
    type: "text",
    value: leftValue,
    position: {
      start: { ...position2.start },
      end: {
        offset: (position2.start.offset || 0) + leftValue.length,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      }
    }
  };
  const middleValue = value.slice(pos, pos + 1);
  const middle = {
    type: "text",
    value: middleValue,
    position: {
      start: {
        offset: (position2.start.offset || 0) + pos,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      },
      end: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  const rightValue = value.slice(pos + 1);
  const right = {
    type: "text",
    value: rightValue,
    position: {
      end: { ...position2.end },
      start: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  return [left, middle, right];
}
function hasClosingParen$1(nodes) {
  return nodes.some(
    (node) => node.type === "text" && node.value.includes(")")
  );
}
function trimWhitespace$1(nodes) {
  const firstNode = nodes[0];
  const lastNode = nodes[nodes.length - 1];
  if (!firstNode || !lastNode) {
    return nodes;
  }
  if (firstNode.type === "text") {
    firstNode.value = firstNode.value.trimStart();
    if (firstNode.value === "") {
      nodes.shift();
    }
  }
  if (lastNode.type === "text") {
    lastNode.value = lastNode.value.trimEnd();
    if (lastNode.value === "") {
      nodes.pop();
    }
  }
  return nodes;
}
function lezerToDast$1(node, source) {
  if (typeof node === "string") {
    const tree = parser$1.parse(node);
    source = node;
    return _lezerToDast$1(tree.topNode, source);
  }
  if (source == null) {
    throw new Error(
      `If you provide a SyntaxNode, you must also provide the source string`
    );
  }
  return _lezerToDast$1(node, source);
}
function _lezerToDast$1(node, source) {
  const offsetMap = createOffsetToPositionMap$2(source);
  return {
    type: "root",
    children: gobbleFunctionArguments$1(lezerNodeToDastNode(node)),
    position: lezerNodeToPosition$1(node, offsetMap),
    sources: [source]
  };
  function lezerNodeToDastNode(node2) {
    if (!node2) {
      throw new Error(`Expecting node but got ${JSON.stringify(node2)}`);
    }
    const name2 = node2.type.name;
    switch (name2) {
      case "Document":
        return getLezerChildren$1(node2).flatMap(lezerNodeToDastNode);
      case "Element": {
        const openTag = node2.getChild("OpenTag") || node2.getChild("SelfClosingTag");
        if (!openTag) {
          console.warn(
            `Could not find open tag for element ${extractContent$1(
              node2,
              source
            )}`
          );
          return [];
        }
        let children = [];
        const openTagError = findFirstErrorInChild$1(openTag);
        if (openTagError && !isInsideAttribute$1(openTagError, openTag)) {
          const errorNode = createErrorNode$1(
            openTagError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        let elementError = node2.getChild("⚠") || node2.getChild(MissingCloseTag$1);
        if (openTag.type.name === "OpenTag" && !node2.getChild("CloseTag") && !openTagError && elementError) {
          const errorNode = createErrorNode$1(
            elementError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        const tag2 = openTag.getChild("TagName");
        const name22 = tag2 ? extractContent$1(tag2, source) : "";
        const attrEntries = [];
        for (const attrTag of openTag.getChildren("Attribute")) {
          const attrName = attrTag.getChild("AttributeName");
          const attrValue = attrTag.getChild("AttributeValue");
          if (!attrName) {
            const error = findFirstErrorInChild$1(attrTag);
            if (error) {
              children.push(
                createErrorNode$1(error, source, offsetMap)
              );
            }
            continue;
          }
          let attrChildren = attrValue ? [
            ...reprocessTextForMacros$1(
              {
                type: "text",
                value: attributeValueText$1(
                  attrValue,
                  source
                ),
                position: lezerNodeToPosition$1(
                  attrValue,
                  offsetMap,
                  true
                )
              },
              offsetMap
            )
          ] : [];
          attrEntries.push({
            attrTag,
            dastAttr: {
              type: "attribute",
              name: extractContent$1(attrName, source),
              children: attrChildren,
              position: lezerNodeToPosition$1(attrTag, offsetMap)
            }
          });
        }
        const bareValuePairs = findBareAttributeValuePairs$1(
          attrEntries.map((e2) => e2.dastAttr),
          source
        );
        const pairedAssignAttrs = new Set(
          bareValuePairs.map((p2) => p2.assignAttr)
        );
        const pairByValueAttr = new Map(
          bareValuePairs.map((p2) => [p2.valueAttr, p2])
        );
        const attributesList = [];
        for (const { attrTag, dastAttr } of attrEntries) {
          const pair2 = pairByValueAttr.get(dastAttr);
          if (pair2) {
            children.push({
              type: "error",
              message: unquotedAttributeValueMessage$1(
                pair2.assignAttr.name,
                pair2.valueAttr.name
              ),
              position: pair2.valueAttr.position
            });
            continue;
          }
          if (pairedAssignAttrs.has(dastAttr)) {
            continue;
          }
          const error = findFirstErrorInChild$1(attrTag);
          if (error) {
            const errorNode = createErrorNode$1(
              error,
              source,
              offsetMap
            );
            children.push(errorNode);
          }
          attributesList.push(dastAttr);
        }
        children.push(
          ...getLezerChildren$1(node2).flatMap(
            (n2) => lezerNodeToDastNode(n2)
          )
        );
        children = gobbleFunctionArguments$1(
          children
        );
        return [
          {
            type: "element",
            name: name22,
            attributes: Object.fromEntries(
              attributesList.map((a2) => [a2.name, a2])
            ),
            children,
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "Text": {
        const textNode = {
          type: "text",
          value: textNodeToText$1(node2, source),
          position: lezerNodeToPosition$1(node2, offsetMap)
        };
        return reprocessTextForMacros$1(textNode, offsetMap);
      }
      case "Ampersand":
        return [
          {
            type: "text",
            value: "&",
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      case "CharacterReference":
      case "EntityReference":
        return [
          {
            type: "text",
            value: entityToString$1(node2, source),
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      case "ProcessingInst": {
        const fullContent = extractContent$1(node2, source);
        let value = fullContent.slice(2, fullContent.length - 2);
        const match2 = value.match(/^[\w-]*/);
        const name22 = match2?.[0] || "";
        if (name22) {
          value = value.slice(name22.length).trim();
        }
        return [
          {
            type: "instruction",
            name: name22,
            value,
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "Comment": {
        const fullContent = extractContent$1(node2, source);
        return [
          {
            type: "comment",
            value: fullContent.slice(4, fullContent.length - 3),
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "Cdata": {
        const fullContent = extractContent$1(node2, source);
        return [
          {
            type: "cdata",
            value: fullContent.slice(9, fullContent.length - 3),
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "DoctypeDecl": {
        const fullContent = extractContent$1(node2, source);
        let value = fullContent.slice(10, fullContent.length - 1);
        const doctypeInfo = extractDoctypeInfo$1(value);
        return [
          {
            type: "doctype",
            ...doctypeInfo,
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "Attribute":
      case "AttributeName":
      case "AttributeValue":
      case "EndTag":
      case "Is":
      case "OpenTag":
      case "SelfCloseEndTag":
      case "SelfClosingTag":
      case "TagName":
      case "StartTag":
      case "StartCloseTag":
        return [];
      case "CloseTag": {
        const errorNode = findFirstErrorInChild$1(node2);
        if (errorNode) {
          return [createErrorNode$1(errorNode, source, offsetMap)];
        }
        return [];
      }
      case "MismatchedCloseTag": {
        const closeTagError = findFirstErrorInChild$1(node2);
        if (closeTagError) {
          return [createErrorNode$1(closeTagError, source, offsetMap)];
        }
        const parent = node2.parent;
        const openTag = parent?.getChild(OpenTag$1);
        const closeTag = parent?.getChild(CloseTag$1);
        if (!parent || !openTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent$1(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition$1(node2, offsetMap)
            }
          ];
        }
        if (closeTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent$1(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition$1(node2, offsetMap)
            }
          ];
        }
        const tagNameTag = openTag.getChild(TagName$F);
        const openTagName = tagNameTag ? extractContent$1(tagNameTag, source) : "";
        const message = `Invalid DoenetML: Mismatched closing tag. Expected \`</${openTagName}>\`. Found \`${extractContent$1(
          node2,
          source
        )}\``;
        return [
          {
            type: "error",
            message,
            position: lezerNodeToPosition$1(node2, offsetMap)
          }
        ];
      }
      case "MissingCloseTag":
      case "⚠":
        return [];
      default:
        const unhandledName = name2;
        console.log(
          `Encountered Lezer node of unknown type ${unhandledName}`
        );
    }
    return [];
  }
}
function isInsideAttribute$1(error, openTag) {
  let p2 = error.parent;
  while (p2 && p2 !== openTag) {
    if (p2.type.name === "Attribute" && p2.parent === openTag) {
      return true;
    }
    p2 = p2.parent;
  }
  return false;
}
function reprocessTextForMacros$1(textNode, offsetToPositionMap) {
  if (!textNode.value.includes("$")) {
    return [textNode];
  }
  const parsed = parseMacros$1(textNode.value);
  const nodesToProcess = findNodesWithPositionInfo$1(parsed);
  nodesToProcess.forEach((n2) => {
    updateNodePositionData$1(n2, textNode, offsetToPositionMap);
  });
  return parsed;
}
const CONTINUE$1 = /* @__PURE__ */ Symbol("continue");
const SKIP$1 = /* @__PURE__ */ Symbol("skip");
const EXIT$1 = /* @__PURE__ */ Symbol("exit");
const DEFAULT_CONTEXT$1 = {};
function visit$1(tree, visitor, options2) {
  const {
    startingContext = DEFAULT_CONTEXT$1,
    test = () => true,
    includeArrays = false
  } = {};
  let enter;
  let leave;
  if (typeof visitor === "function") {
    enter = visitor;
  } else if (visitor && typeof visitor === "object") {
    enter = visitor.enter;
    leave = visitor.leave;
  }
  walk(tree, {
    key: void 0,
    index: void 0,
    parents: [],
    containingArray: void 0,
    context: { ...startingContext }
  });
  function walk(node, { key, index: index2, parents, context, containingArray }) {
    const nodePassesTest = includeArrays ? test(node, { key, index: index2, parents, context, containingArray }) : !Array.isArray(node) && test(node, { key, index: index2, parents, context, containingArray });
    const result2 = enter && nodePassesTest ? toResult$1(
      enter(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : [CONTINUE$1];
    if (result2[0] === EXIT$1) {
      return result2;
    }
    if (result2[0] === SKIP$1) {
      return leave && nodePassesTest ? toResult$1(
        leave(node, {
          key,
          index: index2,
          parents,
          context,
          containingArray
        })
      ) : result2;
    }
    if (Array.isArray(node)) {
      for (let index22 = 0; index22 > -1 && index22 < node.length; index22++) {
        const item = node[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          containingArray: node
        });
        if (result22[0] === EXIT$1) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else if (node.type === "function" && node.input) {
      for (let index22 = 0; index22 > -1 && index22 < node.input.length; index22++) {
        const item = node.input[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          // `node.input` is an array of arrays; the containing array should be, for example, `node.input[0]` so we set it to `undefined` here.
          containingArray: void 0
        });
        if (result22[0] === EXIT$1) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else {
      const key2 = "children";
      if (key2 in node) {
        const grandparents = node.type === "root" ? parents : [node, ...parents];
        const result22 = walk(node.children, {
          key: key2,
          index: void 0,
          parents: grandparents,
          context,
          containingArray: void 0
        });
        if (result22[0] === EXIT$1) {
          return result22;
        }
      }
    }
    return leave && nodePassesTest ? toResult$1(
      leave(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : result2;
  }
}
function toResult$1(value) {
  if (value == null) {
    return [CONTINUE$1];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE$1, value];
  }
  return [value];
}
function replaceNode(ast, visitor) {
  visit$1(ast, {
    leave: (node, info) => {
      let replacement = visitor(node, info);
      if (typeof replacement === "undefined" || replacement === node) {
        return;
      }
      if (!info.containingArray || info.index == null) {
        throw new Error(
          "Trying to replace node, but cannot find containing array"
        );
      }
      if (replacement === null || Array.isArray(replacement) && replacement.length === 0) {
        info.containingArray.splice(info.index, 1);
        return info.index;
      }
      if (!Array.isArray(replacement)) {
        replacement = [replacement];
      }
      info.containingArray.splice(info.index, 1, ...replacement);
      return info.index + replacement.length;
    }
  });
}
function bail$1(error) {
  if (error) {
    throw error;
  }
}
function getDefaultExportFromCjs$3(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var extend$1$3;
var hasRequiredExtend$1;
function requireExtend$1() {
  if (hasRequiredExtend$1) return extend$1$3;
  hasRequiredExtend$1 = 1;
  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;
  var isArray2 = function isArray22(arr) {
    if (typeof Array.isArray === "function") {
      return Array.isArray(arr);
    }
    return toStr.call(arr) === "[object Array]";
  };
  var isPlainObject2 = function isPlainObject3(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") {
      return false;
    }
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
      return false;
    }
    var key;
    for (key in obj) {
    }
    return typeof key === "undefined" || hasOwn.call(obj, key);
  };
  var setProperty2 = function setProperty22(target, options2) {
    if (defineProperty && options2.name === "__proto__") {
      defineProperty(target, options2.name, {
        enumerable: true,
        configurable: true,
        value: options2.newValue,
        writable: true
      });
    } else {
      target[options2.name] = options2.newValue;
    }
  };
  var getProperty = function getProperty2(obj, name2) {
    if (name2 === "__proto__") {
      if (!hasOwn.call(obj, name2)) {
        return void 0;
      } else if (gOPD) {
        return gOPD(obj, name2).value;
      }
    }
    return obj[name2];
  };
  extend$1$3 = function extend2() {
    var options2, name2, src, copy2, copyIsArray, clone2;
    var target = arguments[0];
    var i2 = 1;
    var length = arguments.length;
    var deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      i2 = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    for (; i2 < length; ++i2) {
      options2 = arguments[i2];
      if (options2 != null) {
        for (name2 in options2) {
          src = getProperty(target, name2);
          copy2 = getProperty(options2, name2);
          if (target !== copy2) {
            if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone2 = src && isArray2(src) ? src : [];
              } else {
                clone2 = src && isPlainObject2(src) ? src : {};
              }
              setProperty2(target, { name: name2, newValue: extend2(deep, clone2, copy2) });
            } else if (typeof copy2 !== "undefined") {
              setProperty2(target, { name: name2, newValue: copy2 });
            }
          }
        }
      }
    }
    return target;
  };
  return extend$1$3;
}
var extendExports$1 = requireExtend$1();
const extend$4 = /* @__PURE__ */ getDefaultExportFromCjs$3(extendExports$1);
function isPlainObject$5(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough$1() {
  const fns = [];
  const pipeline = { run, use };
  return pipeline;
  function run(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next(null, ...values2);
    function next(error, ...output) {
      const fn2 = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn2) {
        wrap$3(fn2, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap$3(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result2;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result2 = middleware.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result2 && result2.then && typeof result2.then === "function") {
        result2.then(then, done);
      } else if (result2 instanceof Error) {
        done(result2);
      } else {
        then(result2);
      }
    }
  }
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
function stringifyPosition$1(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position$1(value.position);
  }
  if ("start" in value || "end" in value) {
    return position$1(value);
  }
  if ("line" in value || "column" in value) {
    return point$1(value);
  }
  return "";
}
function point$1(point2) {
  return index$1(point2 && point2.line) + ":" + index$1(point2 && point2.column);
}
function position$1(pos) {
  return point$1(pos && pos.start) + "-" + point$1(pos && pos.end);
}
function index$1(value) {
  return value && typeof value === "number" ? value : 1;
}
let VFileMessage$1 = class VFileMessage2 extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();
    if (typeof optionsOrParentOrPlace === "string") {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = void 0;
    }
    let reason = "";
    let options2 = {};
    let legacyCause = false;
    if (optionsOrParentOrPlace) {
      if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("type" in optionsOrParentOrPlace) {
        options2 = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      } else {
        options2 = { ...optionsOrParentOrPlace };
      }
    }
    if (typeof causeOrReason === "string") {
      reason = causeOrReason;
    } else if (!options2.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options2.cause = causeOrReason;
    }
    if (!options2.ruleId && !options2.source && typeof origin === "string") {
      const index2 = origin.indexOf(":");
      if (index2 === -1) {
        options2.ruleId = origin;
      } else {
        options2.source = origin.slice(0, index2);
        options2.ruleId = origin.slice(index2 + 1);
      }
    }
    if (!options2.place && options2.ancestors && options2.ancestors) {
      const parent = options2.ancestors[options2.ancestors.length - 1];
      if (parent) {
        options2.place = parent.position;
      }
    }
    const start = options2.place && "start" in options2.place ? options2.place.start : options2.place;
    this.ancestors = options2.ancestors || void 0;
    this.cause = options2.cause || void 0;
    this.column = start ? start.column : void 0;
    this.fatal = void 0;
    this.file = "";
    this.message = reason;
    this.line = start ? start.line : void 0;
    this.name = stringifyPosition$1(options2.place) || "1:1";
    this.place = options2.place || void 0;
    this.reason = this.message;
    this.ruleId = options2.ruleId || void 0;
    this.source = options2.source || void 0;
    this.stack = legacyCause && options2.cause && typeof options2.cause.stack === "string" ? options2.cause.stack : "";
    this.actual = void 0;
    this.expected = void 0;
    this.note = void 0;
    this.url = void 0;
  }
};
VFileMessage$1.prototype.file = "";
VFileMessage$1.prototype.name = "";
VFileMessage$1.prototype.reason = "";
VFileMessage$1.prototype.message = "";
VFileMessage$1.prototype.stack = "";
VFileMessage$1.prototype.column = void 0;
VFileMessage$1.prototype.line = void 0;
VFileMessage$1.prototype.ancestors = void 0;
VFileMessage$1.prototype.cause = void 0;
VFileMessage$1.prototype.fatal = void 0;
VFileMessage$1.prototype.place = void 0;
VFileMessage$1.prototype.ruleId = void 0;
VFileMessage$1.prototype.source = void 0;
const minpath$1 = { basename: basename$1, dirname: dirname$1, extname: extname$1, join: join$4, sep: "/" };
function basename$1(path, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1$1(path);
  let start = 0;
  let end = -1;
  let index2 = path.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path.length) {
    while (index2--) {
      if (path.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path.slice(start, end);
  }
  if (extname2 === path) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end = index2;
          }
        } else {
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }
  return path.slice(start, end);
}
function dirname$1(path) {
  assertPath$1$1(path);
  if (path.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path.length;
  let unmatchedSlash;
  while (--index2) {
    if (path.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path.codePointAt(0) === 47 ? "/" : "." : end === 1 && path.codePointAt(0) === 47 ? "//" : path.slice(0, end);
}
function extname$1(path) {
  assertPath$1$1(path);
  let index2 = path.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code2 = path.codePointAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path.slice(startDot, end);
}
function join$4(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$2(joined);
}
function normalize$2(path) {
  assertPath$1$1(path);
  const absolute = path.codePointAt(0) === 47;
  let value = normalizeString$2(path, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path.codePointAt(path.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString$2(path, allowAboveRoot) {
  let result2 = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code2;
  let lastSlashIndex;
  while (++index2 <= path.length) {
    if (index2 < path.length) {
      code2 = path.codePointAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result2.length < 2 || lastSegmentLength !== 2 || result2.codePointAt(result2.length - 1) !== 46 || result2.codePointAt(result2.length - 2) !== 46) {
          if (result2.length > 2) {
            lastSlashIndex = result2.lastIndexOf("/");
            if (lastSlashIndex !== result2.length - 1) {
              if (lastSlashIndex < 0) {
                result2 = "";
                lastSegmentLength = 0;
              } else {
                result2 = result2.slice(0, lastSlashIndex);
                lastSegmentLength = result2.length - 1 - result2.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result2.length > 0) {
            result2 = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result2 = result2.length > 0 ? result2 + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result2.length > 0) {
          result2 += "/" + path.slice(lastSlash + 1, index2);
        } else {
          result2 = path.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result2;
}
function assertPath$1$1(path) {
  if (typeof path !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path)
    );
  }
}
const minproc$1 = { cwd: cwd$1 };
function cwd$1() {
  return "/";
}
function isUrl$1(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}
function urlToPath$1(path) {
  if (typeof path === "string") {
    path = new URL(path);
  } else if (!isUrl$1(path)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path + "`"
    );
    error.code = "ERR_INVALID_ARG_TYPE";
    throw error;
  }
  if (path.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    error.code = "ERR_INVALID_URL_SCHEME";
    throw error;
  }
  return getPathFromURLPosix$1(path);
}
function getPathFromURLPosix$1(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = "ERR_INVALID_FILE_URL_HOST";
    throw error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error.code = "ERR_INVALID_FILE_URL_PATH";
        throw error;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order$1 = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
let VFile$1 = class VFile2 {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options2;
    if (!value) {
      options2 = {};
    } else if (isUrl$1(value)) {
      options2 = { path: value };
    } else if (typeof value === "string" || isUint8Array$1$1(value)) {
      options2 = { value };
    } else {
      options2 = value;
    }
    this.cwd = "cwd" in options2 ? "" : minproc$1.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order$1.length) {
      const field2 = order$1[index2];
      if (field2 in options2 && options2[field2] !== void 0 && options2[field2] !== null) {
        this[field2] = field2 === "history" ? [...options2[field2]] : options2[field2];
      }
    }
    let field;
    for (field in options2) {
      if (!order$1.includes(field)) {
        this[field] = options2[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath$1.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty$1(basename2, "basename");
    assertPart$1(basename2, "basename");
    this.path = minpath$1.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath$1.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath$2(this.basename, "dirname");
    this.path = minpath$1.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath$1.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart$1(extname2, "extname");
    assertPath$2(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath$1.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl$1(path)) {
      path = urlToPath$1(path);
    }
    assertNonEmpty$1(path, "path");
    if (this.path !== path) {
      this.history.push(path);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath$1.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty$1(stem, "stem");
    assertPart$1(stem, "stem");
    this.path = minpath$1.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = true;
    throw message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = void 0;
    return message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage$1(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
};
function assertPart$1(part, name2) {
  if (part && part.includes(minpath$1.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath$1.sep + "`"
    );
  }
}
function assertNonEmpty$1(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath$2(path, name2) {
  if (!path) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array$1$1(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const CallableInstance$1 = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(property2) {
    const self2 = this;
    const constr = self2.constructor;
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto[property2];
    const apply = function() {
      return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    return apply;
  })
);
const own$1 = {}.hasOwnProperty;
let Processor$1 = class Processor2 extends CallableInstance$1 {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough$1();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor2()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data(extend$4(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen$1("data", this.frozen);
        this.namespace[key] = value;
        return this;
      }
      return own$1.call(this.namespace, key) && this.namespace[key] || void 0;
    }
    if (key) {
      assertUnfrozen$1("data", this.frozen);
      this.namespace = key;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options2] = this.attachers[this.freezeIndex];
      if (options2[0] === false) {
        continue;
      }
      if (options2[0] === true) {
        options2[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options2);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile$1(file);
    const parser2 = this.parser || this.Parser;
    assertParser$1("parse", parser2);
    return parser2(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser$1("process", this.parser || this.Parser);
    assertCompiler$1("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile$1(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error, tree, file2) {
        if (error || !tree || !file2) {
          return realDone(error);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue$1(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error, file2) {
        if (error || !file2) {
          reject2(error);
        } else if (resolve) {
          resolve(file2);
        } else {
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result2;
    this.freeze();
    assertParser$1("processSync", this.parser || this.Parser);
    assertCompiler$1("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone$1("processSync", "process", complete);
    return result2;
    function realDone(error, file2) {
      complete = true;
      bail$1(error);
      result2 = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode$1(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile$1(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error) {
          reject2(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result2;
    this.run(tree, file, realDone);
    assertDone$1("runSync", "run", complete);
    return result2;
    function realDone(error, tree2) {
      bail$1(error);
      result2 = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile$1(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler$1("stringify", compiler);
    assertNode$1(tree);
    return compiler(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen$1("use", this.frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result2) {
      if (!("plugins" in result2) && !("settings" in result2)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result2.plugins);
      if (result2.settings) {
        namespace.settings = extend$4(true, namespace.settings, result2.settings);
      }
    }
    function addList(plugins2) {
      let index2 = -1;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (Array.isArray(plugins2)) {
        while (++index2 < plugins2.length) {
          const thing = plugins2[index2];
          add2(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest2] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject$5(currentPrimary) && isPlainObject$5(primary)) {
          primary = extend$4(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin, primary, ...rest2];
      }
    }
  }
};
const unified = new Processor$1().freeze();
function assertParser$1(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler$1(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen$1(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode$1(node) {
  if (!isPlainObject$5(node) || typeof node.type !== "string") {
    throw new TypeError("Expected node, got `" + node + "`");
  }
}
function assertDone$1(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile$1(value) {
  return looksLikeAVFile$1(value) ? value : new VFile$1(value);
}
function looksLikeAVFile$1(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue$1(value) {
  return typeof value === "string" || isUint8Array$2(value);
}
function isUint8Array$2(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const isDastElement = (rootContent) => rootContent && typeof rootContent === "object" && rootContent.type === "element";
const ELEMENT_EXPANSIONS = {
  chapter: {
    to: "division",
    attributes: {
      type: "chapter"
    }
  },
  part: {
    to: "division",
    attributes: {
      type: "part"
    }
  },
  section: {
    to: "division",
    attributes: {
      type: "section"
    }
  },
  subsection: {
    to: "division",
    attributes: {
      type: "subsection"
    }
  },
  subsubsection: {
    to: "division",
    attributes: {
      type: "subsubsection"
    }
  },
  paragraphs: {
    to: "division",
    attributes: {
      type: "paragraphs"
    }
  }
};
const pluginConvertPretextAttributes = () => {
  return (tree) => {
    visit$1(tree, (node) => {
      if (!isDastElement(node)) {
        return;
      }
      if (node.attributes["xml:id"]) {
        const attr = node.attributes["xml:id"];
        attr.name = "name";
        delete node.attributes["xml:id"];
        node.attributes.name = attr;
      }
      if (node.name === "xref") {
        const refAttr = node.attributes.ref;
        if (!refAttr) {
          return;
        }
        const hasMacroChild = refAttr.children.some(
          (child) => child.type === "macro"
        );
        const hasNonWhitespaceTextChild = refAttr.children.some(
          (child) => child.type === "text" && child.value.trim() !== ""
        );
        if (hasMacroChild || !hasNonWhitespaceTextChild) {
          return;
        }
        const refText = refAttr.children.map((child) => child.type === "text" ? child.value : "").join("");
        refAttr.position;
        let macro = {
          type: "macro",
          attributes: {},
          path: [
            {
              type: "pathPart",
              index: [],
              name: refText
            }
          ]
        };
        refAttr.children.length = 0;
        refAttr.children.push(macro);
      }
    });
  };
};
function groupTextAndReferencesBySpacesOutsideParens({
  children,
  componentType,
  wrapSingleNonTextNodes = true
}) {
  for (const child of children) {
    if (!["text", "macro", "function"].includes(child.type)) {
      return { success: false };
    }
  }
  const newChildren = [];
  let currentGroup = [];
  let nParens = 0;
  for (const child of children) {
    switch (child.type) {
      case "macro":
      case "function":
        currentGroup.push(child);
        continue;
      case "text":
        const splitNodes = splitAtParensOrSpace(child);
        let currentText = "";
        let currentTextStartPos = splitNodes[0]?.position?.start;
        for (const node of splitNodes) {
          if (node.value === "(") {
            currentText += node.value;
            nParens++;
          } else if (node.value === ")") {
            if (nParens === 0) {
              return { success: false };
            } else {
              currentText += node.value;
              nParens--;
            }
          } else if (nParens === 0 && node.value.match(/\s/)) {
            if (currentText.length > 0) {
              currentGroup.push(
                createNewTextNode(
                  currentText,
                  currentTextStartPos,
                  child.source_doc
                )
              );
            }
            if (currentGroup.length > 0) {
              newChildren.push(
                createElementFromChildren(
                  componentType,
                  currentGroup,
                  wrapSingleNonTextNodes,
                  child.source_doc
                )
              );
              currentGroup = [];
            }
            currentText = "";
            currentTextStartPos = node.position?.end;
          } else {
            currentText += node.value;
          }
        }
        if (currentText.length > 0) {
          currentGroup.push(
            createNewTextNode(
              currentText,
              currentTextStartPos,
              child.source_doc
            )
          );
        }
        break;
      default:
        throw Error("Unreachable");
    }
  }
  if (nParens > 0) {
    return { success: false };
  }
  if (currentGroup.length > 0) {
    newChildren.push(
      createElementFromChildren(
        componentType,
        currentGroup,
        wrapSingleNonTextNodes
      )
    );
  }
  return { success: true, newChildren };
}
function createElementFromChildren(name2, children, wrapSingleNonTextNodes, source_doc) {
  if (!wrapSingleNonTextNodes && children.length === 1 && children[0].type !== "text") {
    return children[0];
  }
  const newChild = {
    type: "element",
    name: name2,
    children,
    attributes: {},
    source_doc
  };
  const startPos = children[0].position?.start;
  const endPos = children[children.length - 1].position?.end;
  if (startPos && endPos) {
    newChild.position = {
      start: startPos,
      end: endPos
    };
  }
  return newChild;
}
function createNewTextNode(text2, startPos, source_doc) {
  const newNode = {
    type: "text",
    value: text2,
    source_doc
  };
  if (startPos) {
    newNode.position = {
      start: startPos,
      end: computeEndPosition(text2, startPos)
    };
  }
  return newNode;
}
function splitAtParensOrSpace(node) {
  let startPos = node.position.start;
  const splitText = [];
  for (const match2 of node.value.matchAll(/([()]|\s+|[^()\s]+)/g)) {
    const newNode = {
      type: "text",
      value: match2[0],
      source_doc: node.source_doc
    };
    if (startPos) {
      newNode.position = {
        start: startPos,
        end: computeEndPosition(match2[0], startPos)
      };
      startPos = newNode.position.end;
    }
    splitText.push(newNode);
  }
  return splitText;
}
function computeEndPosition(text2, startPos) {
  const byLines = text2.split("\n");
  const endPos = {
    line: startPos.line + byLines.length - 1,
    column: startPos.column + byLines[byLines.length - 1].length
  };
  if (startPos.offset != void 0) {
    endPos.offset = startPos.offset + text2.length;
  }
  return endPos;
}
function repeatSugar(node) {
  if (node.name !== "repeat" && node.name !== "repeatForSequence") {
    throw Error(
      "Repeat sugar can only be applied to a `<repeat>` or a `<repeatForSequence>`"
    );
  }
  let setupChildren = [];
  if (node.attributes.valueName) {
    const attrChildren = node.attributes.valueName.children;
    if (attrChildren.length === 1 && attrChildren[0].type === "text") {
      setupChildren.push({
        type: "element",
        name: "_placeholder",
        children: [],
        attributes: {
          name: {
            type: "attribute",
            name: "name",
            children: [
              { type: "text", value: attrChildren[0].value }
            ]
          }
        },
        source_doc: node.source_doc
      });
    }
  }
  if (node.attributes.indexName) {
    const attrChildren = node.attributes.indexName.children;
    if (attrChildren.length === 1 && attrChildren[0].type === "text") {
      setupChildren.push({
        type: "element",
        name: "integer",
        children: [],
        attributes: {
          name: {
            type: "attribute",
            name: "name",
            children: [
              { type: "text", value: attrChildren[0].value }
            ]
          }
        },
        source_doc: node.source_doc
      });
    }
  }
  if (setupChildren.length > 0) {
    node.children.push({
      type: "element",
      name: "_repeatSetup",
      children: setupChildren,
      attributes: {},
      source_doc: node.source_doc
    });
  }
  if (node.name === "repeat") {
    let type = "math";
    if (node.attributes.type) {
      const attrChildren = node.attributes.type.children;
      if (attrChildren.length === 1 && attrChildren[0].type === "text") {
        type = attrChildren[0].value;
        if (!["math", "text", "number", "boolean"].includes(type)) {
          type = "math";
        }
      }
    }
    if (node.attributes.for) {
      const attrChildren = node.attributes.for.children;
      const groupResult = groupTextAndReferencesBySpacesOutsideParens({
        children: attrChildren,
        componentType: type,
        wrapSingleNonTextNodes: false
      });
      if (groupResult.success) {
        node.attributes.for.children = groupResult.newChildren;
      }
    }
  }
}
function conditionalContentSugar(node) {
  if (node.name !== "conditionalContent") {
    throw Error(
      "Conditional content sugar can only be applied to a `<conditionalContent>`"
    );
  }
  let nCaseChildren = 0;
  for (const child of node.children) {
    if (!isDastElement(child)) {
      continue;
    }
    if (child.name === "case") {
      nCaseChildren++;
    } else if (child.name === "else") {
      child.name = "case";
      nCaseChildren++;
    }
  }
  if (nCaseChildren === 0) {
    const attributes = {};
    node.children = [
      {
        type: "element",
        name: "case",
        children: node.children,
        attributes,
        source_doc: node.source_doc
      }
    ];
    if (node.attributes.condition) {
      attributes.condition = node.attributes.condition;
      delete node.attributes.condition;
    }
  }
  for (const child of node.children) {
    if (!isDastElement(child)) {
      continue;
    }
    if (child.name === "case") {
      child.children = [
        {
          type: "element",
          name: "group",
          children: child.children,
          attributes: {},
          source_doc: child.source_doc
        }
      ];
    }
  }
}
function selectSugar(node) {
  if (node.name !== "select") {
    throw Error("Select sugar can only be applied to a `<select>`");
  }
  let insertType = "math";
  if (node.attributes.type) {
    const children = node.attributes.type.children;
    if (children.length === 1 && children[0].type === "text") {
      insertType = children[0].value;
      if (!["math", "text", "number", "boolean"].includes(insertType)) {
        insertType = "math";
      }
    }
  }
  const groupResult = groupTextAndReferencesBySpacesOutsideParens({
    children: node.children,
    componentType: insertType
  });
  if (groupResult.success) {
    let newChildren = groupResult.newChildren.map(
      (child) => ({
        type: "element",
        name: "option",
        children: [child],
        attributes: {},
        source_doc: child.source_doc
      })
    );
    node.children = newChildren;
  }
}
function postponeRenderSugar(node) {
  if (!["solution", "givenAnswer", "aside", "proof"].includes(node.name)) {
    throw Error(
      "Postpone render sugar can only be applied to a `<solution>`, `<aside>`, or `<proof>`"
    );
  }
  const titleChildren = [];
  const postponedChildren = [];
  for (const child of node.children) {
    if (child.type === "element" && child.name === "title") {
      titleChildren.push(child);
    } else {
      postponedChildren.push(child);
    }
  }
  node.children = [
    ...titleChildren,
    {
      type: "element",
      name: "_postponeRenderContainer",
      children: postponedChildren,
      attributes: {},
      source_doc: node.source_doc
    }
  ];
}
function startsWithNonLetter(str) {
  return typeof str === "string" && !str.charAt(0).match(/[a-zA-Z]/);
}
function containsInvalidNameCharacters(str) {
  return typeof str === "string" && !str.match(/^[a-zA-Z0-9-_]+$/);
}
const pluginEnforceValidNames = () => {
  return (tree) => {
    visit$1(tree, (node, info) => {
      if (!isDastElement(node)) {
        return;
      }
      if (startsWithNonLetter(node.name) && node.name !== "_error") {
        const name2 = node.name;
        const dastError = {
          type: "error",
          message: `Invalid component name "${name2}". Names must start with a letter.`,
          position: node.position
        };
        if (info.index !== void 0 && info.parents[0]) {
          info.parents[0].children.splice(info.index, 1, dastError);
        } else {
          console.warn(
            "No index found for error element, appending to root."
          );
          tree.children.push(dastError);
        }
      }
      if (node.attributes.name) {
        const name2 = toXml$1(node.attributes.name.children);
        const nonLetter = startsWithNonLetter(name2);
        const invalidChar = containsInvalidNameCharacters(name2);
        if (nonLetter || invalidChar) {
          const message = `Invalid attribute name='${name2}'. ${nonLetter ? "Names must start with a letter." : "Names can contain only letters, numbers, underscores or hyphens."}`;
          const dastError = {
            type: "error",
            message,
            position: node.attributes.name?.position
          };
          delete node.attributes.name;
          if (info.index !== void 0 && info.parents[0]) {
            info.parents[0].children.splice(
              info.index + 1,
              0,
              dastError
            );
          } else {
            console.warn(
              "No index found for error element, appending to root."
            );
            tree.children.push(dastError);
          }
        }
      }
    });
  };
};
function pretzelSugar(node) {
  if (node.name !== "pretzel") {
    throw Error("Pretzel sugar can only be applied to a `<pretzel>`");
  }
  for (const child of node.children) {
    if (child.type === "element" && child.name === "problem") {
      for (const grandChild of child.children) {
        if (grandChild.type === "element" && grandChild.name === "answer") {
          grandChild.name = "givenAnswer";
        }
      }
    }
  }
  node.children = [
    {
      type: "element",
      name: "_pretzelArranger",
      children: node.children,
      attributes: node.attributes.mode ? { mode: node.attributes.mode } : {},
      source_doc: node.source_doc,
      position: node.position
    }
  ];
}
function descriptionAttributeSugar(node) {
  if (![
    "image",
    "video",
    "graph",
    "answer",
    "mathInput",
    "textInput",
    "choiceInput",
    "booleanInput",
    "matrixInput",
    "fractionInput"
  ].includes(node.name)) {
    throw Error(
      "Description attribute sugar can only be applied to an `<image>`, `<video>`, `<graph>`, `<answer>` or `<*Input>`."
    );
  }
  const descriptionAttribute = node.attributes["description"];
  if (descriptionAttribute) {
    delete node.attributes["description"];
    const shortDescriptionChild = {
      type: "element",
      name: "shortDescription",
      children: descriptionAttribute.children,
      position: descriptionAttribute.position,
      source_doc: descriptionAttribute.source_doc,
      attributes: {}
    };
    node.children.splice(0, 0, shortDescriptionChild);
  }
}
function fractionInputSugar(node) {
  const makeInput = (part) => ({
    type: "element",
    name: "_fractionInputComponent",
    attributes: {
      part: {
        type: "attribute",
        name: "part",
        children: [{ type: "text", value: part }]
      }
    },
    children: [],
    position: node.position,
    source_doc: node.source_doc
  });
  node.children.splice(
    0,
    0,
    makeInput("numerator"),
    makeInput("denominator")
  );
}
const SECTIONING_COMPONENTS_WITH_DYNAMIC_CHILDREN = [
  "section",
  "subsection",
  "subsubsection",
  "paragraphs",
  "part",
  "task",
  "aside",
  "objectives",
  "problem",
  "exercise",
  "question",
  "activity",
  "example",
  "definition",
  "note",
  "theorem",
  "proof",
  "problems",
  "exercises"
];
const COMPONENTS_WITH_DYNAMIC_CHILDREN = /* @__PURE__ */ new Set([
  "graph",
  "stickyGroup",
  ...SECTIONING_COMPONENTS_WITH_DYNAMIC_CHILDREN
]);
function effectiveComponentType(node) {
  if (node.name === "division") {
    const typeAttr = node.attributes.type;
    const child = typeAttr?.children?.[0];
    if (child && child.type === "text") {
      return child.value;
    }
  }
  return node.name;
}
function nodeSupportsDynamicChildren(node) {
  return COMPONENTS_WITH_DYNAMIC_CHILDREN.has(effectiveComponentType(node));
}
function addDynamicChildrenSugar(node) {
  const deferUntilParentRendered = node.children.some(
    (child) => child.type === "element" && child.name === "_postponeRenderContainer"
  );
  node.children.push({
    type: "element",
    name: "_dynamicChildren",
    children: [],
    attributes: deferUntilParentRendered ? {
      deferUntilParentRendered: {
        type: "attribute",
        name: "deferUntilParentRendered",
        children: [{ type: "text", value: "true" }],
        source_doc: node.source_doc
      }
    } : {},
    source_doc: node.source_doc
  });
}
function answerSugar(node) {
  if (node.name !== "answer") {
    throw Error("answer sugar can only be applied to a `<answer>`");
  }
  const typeAttr = node.attributes.type;
  if (!typeAttr) {
    return;
  }
  const typeChildren = typeAttr.children;
  if (typeChildren.length === 1 && typeChildren[0].type === "text" && typeChildren[0].value.toLowerCase() === "videowatched") {
    if (node.children.find(
      (child) => child.type === "element" && child.name === "award"
    )) {
      return;
    }
    const videoAttr = node.attributes.video;
    if (!videoAttr) {
      const dastError = {
        type: "error",
        message: "Answer with type videoWatched must have a video attribute",
        position: node.position
      };
      node.children.unshift(dastError);
      return;
    }
    const videoChildren = videoAttr.children;
    if (videoChildren.length !== 1 || videoChildren[0].type !== "macro") {
      const dastError = {
        type: "error",
        message: "Answer with type videoWatched must have video attribute that is a reference",
        position: videoAttr.position
      };
      node.children.unshift(dastError);
      return;
    }
    const videoRef = JSON.parse(JSON.stringify(videoChildren[0]));
    const videoFractionWatchedRef = JSON.parse(JSON.stringify(videoRef));
    videoFractionWatchedRef.path.push({
      type: "pathPart",
      name: "fractionWatched",
      index: []
    });
    let videoCreditLabel;
    const videoCreditLabelAttr = node.attributes.videoCreditLabel;
    if (videoCreditLabelAttr) {
      videoCreditLabel = {
        type: "element",
        name: "text",
        attributes: {},
        children: [
          ...videoCreditLabelAttr.children,
          { type: "text", value: ": " }
        ],
        position: videoCreditLabelAttr.position,
        source_doc: videoCreditLabelAttr.source_doc
      };
    } else {
      videoCreditLabel = {
        type: "element",
        name: "text",
        attributes: {},
        children: [
          {
            type: "text",
            value: "Video credit achieved: "
          }
        ]
      };
    }
    let answerNameAttr = node.attributes.name;
    if (!answerNameAttr) {
      const ansName = `__answer${node.position?.start.offset || "unknown"}`;
      answerNameAttr = node.attributes.name = {
        type: "attribute",
        name: "name",
        children: [
          {
            type: "text",
            value: ansName
          }
        ]
      };
    }
    if (answerNameAttr.children.length !== 1 || answerNameAttr.children[0].type !== "text") {
      const dastError = {
        type: "error",
        message: "Answer name attribute must have a single text child",
        position: answerNameAttr.position
      };
      node.children.unshift(dastError);
      return;
    }
    node.attributes.hide = {
      type: "attribute",
      name: "hide",
      children: [
        {
          type: "text",
          value: "true"
        }
      ]
    };
    const answerName = answerNameAttr.children[0].value;
    node.children.push({
      type: "element",
      name: "award",
      attributes: {
        credit: {
          type: "attribute",
          name: "credit",
          children: [
            JSON.parse(JSON.stringify(videoFractionWatchedRef))
          ]
        }
      },
      children: [
        {
          type: "element",
          name: "when",
          attributes: {},
          children: [{ type: "text", value: "true" }]
        }
      ]
    });
    const videoCreditMessage = {
      type: "element",
      name: "span",
      attributes: {},
      children: [
        videoCreditLabel,
        {
          type: "element",
          name: "number",
          attributes: {
            displayDecimals: {
              type: "attribute",
              name: "displayDecimals",
              children: [
                {
                  type: "text",
                  value: "1"
                }
              ]
            }
          },
          children: [
            videoFractionWatchedRef,
            { type: "text", value: "*100" }
          ]
        },
        {
          type: "text",
          value: "%"
        }
      ]
    };
    const callActionElement = {
      type: "element",
      name: "callAction",
      children: [],
      attributes: {
        actionName: {
          type: "attribute",
          name: "actionName",
          children: [
            {
              type: "text",
              value: `submitAnswer`
            }
          ]
        },
        triggerWith: {
          type: "attribute",
          name: "triggerWith",
          children: [videoRef]
        },
        target: {
          type: "attribute",
          name: "target",
          children: [
            {
              type: "macro",
              path: [
                {
                  type: "pathPart",
                  name: answerName,
                  index: []
                }
              ],
              attributes: {}
            }
          ]
        },
        hide: {
          type: "attribute",
          name: "hide",
          children: [
            {
              type: "text",
              value: "true"
            }
          ]
        }
      }
    };
    const answerElement = {
      type: "element",
      name: "answer",
      attributes: node.attributes,
      children: node.children,
      position: node.position,
      source_doc: node.source_doc
    };
    node.name = "span";
    node.attributes = {};
    node.children = [answerElement, videoCreditMessage, callActionElement];
  }
}
const SCORED_SECTION_COMPONENT_TYPES$1 = [
  "document",
  "section",
  "subsection",
  "subsubsection",
  "paragraphs",
  "aside",
  "objectives",
  "problem",
  "exercise",
  "question",
  "activity",
  "example",
  "definition",
  "note",
  "theorem",
  "part",
  "task",
  "proof",
  "problems",
  "exercises",
  "standinForFutureLayoutTag",
  "externalContent",
  "cascade",
  "div",
  "span",
  "ol",
  "ul",
  "li",
  "p"
];
function renamedScoredSectionAttribute$1(oldName, newName) {
  const rule = {
    to: newName,
    warningMessage: `[deprecation] Attribute \`${oldName}\` is deprecated; use \`${newName}\` instead.`,
    conflictWarningMessage: `[deprecation] Attribute \`${oldName}\` is deprecated and ignored because \`${newName}\` is also specified.`
  };
  return Object.fromEntries(
    SCORED_SECTION_COMPONENT_TYPES$1.map((comp) => [
      comp,
      { [oldName]: rule }
    ])
  );
}
function ignoredAttributes$1(componentName, attributeNames) {
  return Object.fromEntries(
    attributeNames.map((attributeName) => [
      attributeName,
      {
        warningMessage: `[deprecation] Attribute \`${attributeName}\` on \`<${componentName}>\` is deprecated and ignored.`
      }
    ])
  );
}
const SCORED_SECTION_COLORING_RENAMES$1 = renamedScoredSectionAttribute$1(
  "forceIndividualAnswerColoring",
  "colorAnswersSeparately"
);
const DEPRECATION_REGISTRY$1 = {
  attributeRenames: {
    // Merge per-component rules, spreading scored-section rename rules
    // first so component-specific rules take precedence on conflict.
    ...SCORED_SECTION_COLORING_RENAMES$1,
    document: {
      // document already has a scored-section rename (spread above) plus
      // its own documentWideCheckWork rename.
      ...SCORED_SECTION_COLORING_RENAMES$1["document"],
      documentWideCheckWork: {
        to: "sectionWideCheckWork",
        warningMessage: "[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated; use `sectionWideCheckWork` instead.",
        conflictWarningMessage: "[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated and ignored because `sectionWideCheckWork` is also specified."
      }
    },
    selectFromSequence: {
      sortResults: {
        to: "sort",
        warningMessage: "[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated; use `sort` instead.",
        conflictWarningMessage: "[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated and ignored because `sort` is also specified."
      }
    },
    selectPrimeNumbers: {
      minValue: {
        to: "from",
        warningMessage: "[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated; use `from` instead.",
        conflictWarningMessage: "[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated and ignored because `from` is also specified."
      },
      maxValue: {
        to: "to",
        warningMessage: "[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated; use `to` instead.",
        conflictWarningMessage: "[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated and ignored because `to` is also specified."
      },
      sortResults: {
        to: "sort",
        warningMessage: "[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated; use `sort` instead.",
        conflictWarningMessage: "[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated and ignored because `sort` is also specified."
      }
    },
    samplePrimeNumbers: {
      minValue: {
        to: "from",
        warningMessage: "[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated; use `from` instead.",
        conflictWarningMessage: "[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated and ignored because `from` is also specified."
      },
      maxValue: {
        to: "to",
        warningMessage: "[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated; use `to` instead.",
        conflictWarningMessage: "[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated and ignored because `to` is also specified."
      }
    }
  },
  attributeRemovals: {
    // `description` and `shortDescription` previously inherited these
    // attributes from `Div` / `Text`, which are inappropriate parents for
    // them. The attributes never had a meaningful effect on these
    // components; they are dropped with a warning.
    description: ignoredAttributes$1("description", [
      "aggregateScores",
      "weight",
      "sectionWideCheckWork",
      "showCorrectness",
      "colorCorrectness",
      "forceIndividualAnswerColoring",
      "submitLabel",
      "submitLabelNoCorrectness",
      "displayDigitsForCreditAchieved"
    ]),
    shortDescription: ignoredAttributes$1("shortDescription", [
      "draggable",
      "layer",
      "isLatex",
      "anchor",
      "positionFromAnchor"
    ])
  },
  componentRenames: {}
};
function lowerKeys$1(o2) {
  return Object.fromEntries(
    Object.entries(o2).map(([k2, v2]) => [k2.toLowerCase(), v2])
  );
}
function buildDeprecationIndex$1(registry) {
  return {
    attributeRenames: Object.fromEntries(
      Object.entries(registry.attributeRenames).map(([comp, rules]) => [
        comp,
        lowerKeys$1(rules)
      ])
    ),
    attributeRemovals: Object.fromEntries(
      Object.entries(registry.attributeRemovals).map(([comp, rules]) => [
        comp,
        lowerKeys$1(rules)
      ])
    ),
    componentRenames: Object.fromEntries(
      Object.entries(registry.componentRenames).map(([comp, rule]) => [
        comp,
        rule.attributeRenames ? {
          ...rule,
          attributeRenames: lowerKeys$1(rule.attributeRenames)
        } : rule
      ])
    )
  };
}
const DEPRECATION_INDEX = buildDeprecationIndex$1(DEPRECATION_REGISTRY$1);
function findAttributeKey(node, lowerName) {
  return Object.keys(node.attributes).find(
    (k2) => k2.toLowerCase() === lowerName
  );
}
const pluginApplyDeprecations = () => {
  return (tree) => {
    const warnings = [];
    visit$1(tree, (node) => {
      if (!isDastElement(node)) {
        return;
      }
      const nodeWarnings = [];
      applyComponentRename(node, nodeWarnings);
      applyAttributeRenames(node, nodeWarnings);
      applyAttributeRemovals(node, nodeWarnings);
      warnings.push(...nodeWarnings);
    });
    if (warnings.length > 0) {
      const documentElement = tree.children.find(
        (child) => isDastElement(child) && child.name === "document"
      );
      if (documentElement) {
        documentElement.children.push(
          ...warnings.map(
            (warning2) => createWarningNode(
              warning2.message,
              warning2.position,
              warning2.source_doc
            )
          )
        );
      }
    }
  };
};
function applyComponentRename(node, warnings) {
  const renameRule = DEPRECATION_INDEX.componentRenames[node.name];
  if (!renameRule) {
    return;
  }
  node.name = renameRule.to;
  warnings.push(
    createWarning(
      renameRule.warningMessage,
      node.position,
      node.source_doc
    )
  );
  if (!renameRule.attributeRenames) {
    return;
  }
  applyRenames(node, renameRule.attributeRenames, warnings);
}
function applyAttributeRenames(node, warnings) {
  const renameRules = DEPRECATION_INDEX.attributeRenames[node.name];
  if (!renameRules) {
    return;
  }
  applyRenames(node, renameRules, warnings);
}
function applyAttributeRemovals(node, warnings) {
  const removalRules = DEPRECATION_INDEX.attributeRemovals[node.name];
  if (!removalRules) {
    return;
  }
  for (const [lowerName, removalRule] of Object.entries(removalRules)) {
    const actualKey = findAttributeKey(node, lowerName);
    if (!actualKey) {
      continue;
    }
    const attribute = node.attributes[actualKey];
    const position2 = attribute.position ?? node.position;
    const source_doc = attribute.source_doc ?? node.source_doc;
    delete node.attributes[actualKey];
    warnings.push(
      createWarning(removalRule.warningMessage, position2, source_doc)
    );
  }
}
function applyRenames(node, renameRules, warnings) {
  for (const [oldLowerName, renameRule] of Object.entries(renameRules)) {
    const oldActualKey = findAttributeKey(node, oldLowerName);
    if (!oldActualKey) {
      continue;
    }
    const oldAttribute = node.attributes[oldActualKey];
    const position2 = oldAttribute.position ?? node.position;
    const source_doc = oldAttribute.source_doc ?? node.source_doc;
    delete node.attributes[oldActualKey];
    const conflictKey = findAttributeKey(node, renameRule.to.toLowerCase());
    if (conflictKey) {
      warnings.push(
        createWarning(
          renameRule.conflictWarningMessage,
          position2,
          source_doc
        )
      );
    } else {
      node.attributes[renameRule.to] = {
        ...oldAttribute,
        name: renameRule.to
      };
      warnings.push(
        createWarning(renameRule.warningMessage, position2, source_doc)
      );
    }
  }
}
function createWarning(message, position2, source_doc) {
  return {
    type: "warning",
    message,
    position: position2,
    source_doc
  };
}
function createWarningNode(message, position2, source_doc) {
  return {
    type: "error",
    message,
    error_type: "warning",
    position: position2,
    source_doc
  };
}
function normalizeDocumentDast(dast, addCompatibilityNames = false) {
  let processor = unified().use(pluginRemoveCommentsInstructionsAndDocStrings).use(pluginChangeCdataToText).use(pluginEnsureDocumentElement).use(pluginConvertPretextAttributes).use(pluginEnforceValidNames).use(pluginExpandAliasedElements).use(pluginApplyDeprecations);
  if (addCompatibilityNames) {
    processor = processor.use(pluginAddCompatibilityNames);
  }
  processor = processor.use(pluginComponentSugar);
  return processor.runSync(dast);
}
const pluginChangeCdataToText = () => {
  return (tree) => {
    visit$1(tree, (node) => {
      if (node.type === "cdata") {
        node.type = "text";
      }
    });
  };
};
const pluginRemoveCommentsInstructionsAndDocStrings = () => {
  return (tree) => {
    visit$1(tree, (node) => {
      if (node.type === "element" || node.type === "root") {
        node.children = node.children.filter(
          (n2) => n2.type !== "comment" && n2.type !== "instruction" && n2.type !== "doctype"
        );
      }
    });
  };
};
const pluginEnsureDocumentElement = () => {
  return (tree) => {
    const existingDocument = tree.children.find(
      (n2) => n2.type === "element" && n2.name === "document"
    );
    if (existingDocument) {
      existingDocument.children = trimWhitespaceNodes(
        existingDocument.children
      );
      if (tree.children.length > 1) {
        tree.children = [existingDocument];
      }
    } else {
      const children = trimWhitespaceNodes(
        // This filtering may be redundant, but it should also be very fast.
        filterNonDoenetXml(tree.children)
      );
      tree.children = [
        {
          type: "element",
          name: "document",
          attributes: {},
          children
        }
      ];
    }
  };
};
const pluginExpandAliasedElements = () => {
  return (tree) => {
    visit$1(tree, (node) => {
      if (isDastElement(node)) {
        const expansion = ELEMENT_EXPANSIONS[node.name];
        if (expansion) {
          let newAttributes = Object.fromEntries(
            Object.entries(expansion.attributes || {}).map(
              ([key, value]) => {
                let newAttr = {
                  type: "attribute",
                  name: key,
                  children: [{ type: "text", value }]
                };
                return [key, newAttr];
              }
            )
          );
          node.name = expansion.to;
          node.attributes = {
            ...node.attributes,
            ...newAttributes
          };
        }
      }
    });
  };
};
const pluginAddCompatibilityNames = () => {
  const counts = {};
  return (tree) => {
    visit$1(tree, (node) => {
      if (isDastElement(node)) {
        const typeCount = counts[node.name] = (counts[node.name] ?? 0) + 1;
        if (!node.attributes.name) {
          const name2 = `_${node.name}${typeCount}`;
          node.attributes.name = {
            type: "attribute",
            name: "name",
            children: [{ type: "text", value: name2 }]
          };
        }
      }
    });
  };
};
const pluginComponentSugar = () => {
  return (tree) => {
    visit$1(tree, (node) => {
      if (!isDastElement(node)) {
        return;
      }
      switch (node.name) {
        case "repeat":
        case "repeatForSequence":
          repeatSugar(node);
          break;
        case "conditionalContent":
          conditionalContentSugar(node);
          break;
        case "select":
          selectSugar(node);
          break;
        case "solution":
        case "givenAnswer":
          postponeRenderSugar(node);
          break;
        case "aside":
        case "proof":
          if (node.attributes.postponeRendering) {
            const children = node.attributes.postponeRendering.children;
            if (children.length === 0 || children.length === 1 && children[0].type === "text" && children[0].value.toLowerCase() === "true") {
              postponeRenderSugar(node);
            }
          }
          break;
        case "pretzel":
          pretzelSugar(node);
          break;
        case "graph":
          descriptionAttributeSugar(node);
          break;
        case "answer":
          descriptionAttributeSugar(node);
          answerSugar(node);
          break;
        case "image":
        case "video":
        case "mathInput":
        case "textInput":
        case "booleanInput":
        case "choiceInput":
        case "matrixInput":
          descriptionAttributeSugar(node);
          break;
        case "fractionInput":
          descriptionAttributeSugar(node);
          fractionInputSugar(node);
          break;
      }
      if (nodeSupportsDynamicChildren(node)) {
        addDynamicChildrenSugar(node);
      }
    });
  };
};
function filterNonDoenetXml(nodes) {
  return nodes.filter(
    (n2) => n2.type !== "doctype" && n2.type !== "instruction"
  );
}
function trimWhitespaceNodes(nodes) {
  if (nodes.length === 0) {
    return nodes;
  }
  const firstNonWhitespaceIdx = nodes.findIndex(
    (n2) => n2.type !== "text" || /\S/.test(n2.value)
  );
  if (firstNonWhitespaceIdx === -1) {
    return [];
  }
  const lastNonWhitespaceIdx = findLastIndex(
    nodes,
    (n2) => n2.type !== "text" || /\S/.test(n2.value)
  );
  const trimmed = nodes.slice(
    firstNonWhitespaceIdx,
    lastNonWhitespaceIdx + 1
  );
  const first2 = trimmed[0];
  const last2 = trimmed[trimmed.length - 1];
  if (first2?.type === "text" && /^\s/.test(first2.value)) {
    trimmed[0] = {
      ...first2,
      value: first2.value.trimStart()
    };
  }
  if (last2?.type === "text" && /\s$/.test(last2.value)) {
    trimmed[trimmed.length - 1] = {
      ...last2,
      value: last2.value.trimEnd()
    };
  }
  return trimmed;
}
function findLastIndex(arr, predicate) {
  for (let i2 = arr.length - 1; i2 >= 0; i2--) {
    if (predicate(arr[i2])) {
      return i2;
    }
  }
  return -1;
}
async function expandExternalReferences(dast, fetchExternalDoenetML) {
  const pluginSubstituteExternalReferences = () => {
    return async (tree) => {
      const promiseStack = [];
      let maxRecursion = 10;
      let counter2 = 0;
      const findExternalReferenceAttribute = (node) => {
        if (!isDastElement(node)) {
          return;
        }
        const sourceAttributeName = Object.keys(node.attributes).find(
          (attrName) => ["extend", "copy"].includes(attrName.toLowerCase())
        );
        if (sourceAttributeName === void 0) {
          return;
        }
        const sourceAttribute = node.attributes[sourceAttributeName];
        const sourceUri = toXml$1(sourceAttribute.children);
        if (!sourceUri.startsWith("doenet:")) {
          return;
        }
        promiseStack.push({
          sourceUri,
          source: fetchExternalDoenetML(sourceUri),
          parent: node,
          sourceAttribute,
          recursionLevel: counter2
        });
      };
      visit$1(tree, findExternalReferenceAttribute);
      let unresolved;
      while (unresolved = promiseStack.pop()) {
        const parent = unresolved.parent;
        if (unresolved.recursionLevel > maxRecursion) {
          const dastError = {
            type: "error",
            message: `Unable to retrieve external DoenetML due to too many levels of recursion. Is there a circular reference?`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        let externalDoenetML;
        try {
          externalDoenetML = await unresolved.source;
        } catch (e2) {
          console.error(e2);
          const dastError = {
            type: "error",
            message: `Unable to retrieve DoenetML from ${unresolved.sourceAttribute.name}="${unresolved.sourceUri}"`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        const externalDast = lezerToDast$1(externalDoenetML);
        const matchResult = findMatchingChild(
          externalDast,
          parent.name
        );
        if (!matchResult.success) {
          const dastError = {
            type: "error",
            message: `Invalid DoenetML retrieved from ${unresolved.sourceAttribute.name}="${unresolved.sourceUri}": it did not match the component type "${parent.name}"`,
            position: unresolved.sourceAttribute.position
          };
          parent.children.unshift(dastError);
          continue;
        }
        const child = matchResult.child;
        if (!dast.sources) {
          dast.sources = [""];
        }
        const source_doc = dast.sources.length;
        dast.sources.push(externalDoenetML);
        for (const attrName in parent.attributes) {
          if (["extend", "copy"].includes(attrName.toLowerCase())) {
            delete parent.attributes[attrName];
          }
        }
        counter2 = unresolved.recursionLevel + 1;
        mergeExternalChildIntoParent(
          parent,
          child,
          source_doc,
          findExternalReferenceAttribute
        );
      }
    };
  };
  let processor = unified().use(pluginSubstituteExternalReferences);
  return await processor.run(dast);
}
function mergeExternalChildIntoParent(parent, child, source_doc, findExternalReferenceAttribute) {
  const addDocSource = (node) => {
    node.source_doc = source_doc;
    switch (node.type) {
      case "element":
        for (const attrName in node.attributes) {
          const attribute = node.attributes[attrName];
          attribute.source_doc = source_doc;
          for (const attrChild of attribute.children) {
            visit$1(attrChild, addDocSource);
          }
        }
        break;
      case "macro":
      case "function":
        for (const path of node.path) {
          path.source_doc = source_doc;
          for (const index2 of path.index) {
            index2.source_doc = source_doc;
            for (const value of index2.value) {
              visit$1(value, addDocSource);
            }
          }
        }
        break;
    }
  };
  visit$1(child, addDocSource);
  const parentAttributes = { ...child.attributes };
  if (parentAttributes.name) {
    const annotated_name = `source-${source_doc}:name`;
    parentAttributes[annotated_name] = parentAttributes.name;
    parentAttributes[annotated_name].name = annotated_name;
    delete parentAttributes.name;
  }
  Object.assign(parentAttributes, parent.attributes);
  parent.attributes = parentAttributes;
  if (!parent.attributes[`source:sequence`]) {
    parent.attributes[`source:sequence`] = {
      type: "attribute",
      name: "source:sequence",
      children: [
        {
          type: "text",
          value: parent.source_doc?.toString() ?? "0"
        }
      ]
    };
  }
  parent.attributes["source:sequence"].children.push({
    type: "text",
    value: source_doc.toString()
  });
  findExternalReferenceAttribute(parent);
  for (const newChild of child.children) {
    visit$1(newChild, findExternalReferenceAttribute);
  }
  parent.children.unshift(...child.children);
}
function findMatchingChild(dastRoot, elementName) {
  const rootChildren = dastRoot.children.filter(
    (node) => node.type !== "text" || node.value.trim() !== ""
  );
  if (rootChildren.length === 1 && isDastElement(rootChildren[0])) {
    let child = rootChildren[0];
    if (child.name === elementName) {
      return { success: true, child };
    }
    if (child.name === "document") {
      const documentChildren = child.children.filter(
        (node) => node.type !== "text" || node.value.trim() !== ""
      );
      if (documentChildren.length === 1 && isDastElement(documentChildren[0])) {
        child = documentChildren[0];
        if (child.name === elementName) {
          return { success: true, child };
        }
      }
    }
  }
  return { success: false };
}
const DEFAULT_SHARED_CORE_WORKER_MAX_CORES = 12;
const sharedHosts = [];
function quarantineSharedHost(host) {
  host.quarantined = true;
  if (host.liveCores <= 0) {
    try {
      host.worker.terminate();
    } catch {
    }
    const index2 = sharedHosts.indexOf(host);
    if (index2 !== -1) {
      sharedHosts.splice(index2, 1);
    }
  }
}
function createSharedWorkerCore() {
  const maxCores = doenetGlobalConfig.sharedCoreWorkerMaxCores ?? DEFAULT_SHARED_CORE_WORKER_MAX_CORES;
  let host = sharedHosts.find(
    (h2) => !h2.quarantined && h2.liveCores < maxCores
  );
  if (!host) {
    const worker = new Worker(doenetGlobalConfig.doenetWorkerUrl, {
      type: "classic"
    });
    const newHost = {
      worker,
      remote: wrap$4(worker),
      liveCores: 0,
      quarantined: false
    };
    worker.addEventListener("error", () => {
      quarantineSharedHost(newHost);
    });
    sharedHosts.push(newHost);
    host = newHost;
  }
  const channel = new MessageChannel();
  const coreIdPromise = host.remote.createCore(
    transfer(channel.port2, [channel.port2])
  );
  coreIdPromise.catch(() => {
  });
  const remote = wrap$4(channel.port1);
  host.liveCores++;
  let killed = false;
  const kill = (suspectWedge) => {
    if (killed) {
      return;
    }
    killed = true;
    host.liveCores--;
    channel.port1.close();
    coreIdPromise.then((id2) => host.remote.destroyCore(id2)).catch(() => {
    });
    if (suspectWedge || host.quarantined) {
      quarantineSharedHost(host);
    }
  };
  return { remote, kill };
}
function createCoreWorker() {
  const externalPortProvider = doenetGlobalConfig.createExternalCoreWorkerPort;
  if (externalPortProvider) {
    try {
      const external2 = externalPortProvider();
      if (external2) {
        const remote2 = wrap$4(
          external2.port
        );
        let killed = false;
        const kill = (suspectWedge) => {
          if (killed) {
            return;
          }
          killed = true;
          try {
            external2.port.close();
          } catch {
          }
          try {
            external2.destroy(suspectWedge);
          } catch {
          }
        };
        return { remote: remote2, kill };
      }
    } catch (e2) {
      console.warn(
        "External core worker port unavailable, falling back:",
        e2
      );
    }
  }
  if (doenetGlobalConfig.useSharedCoreWorker) {
    try {
      return createSharedWorkerCore();
    } catch (e2) {
      console.warn(
        "Shared core worker unavailable, falling back to a dedicated worker:",
        e2
      );
    }
  }
  const worker = new Worker(doenetGlobalConfig.doenetWorkerUrl, {
    type: "classic"
  });
  const remote = wrap$4(worker);
  return { remote, kill: () => worker.terminate() };
}
async function initializeCoreWorker({
  coreWorker,
  doenetML,
  flags,
  activityId,
  docId,
  requestedVariantIndex,
  attemptNumber,
  documentStructureCallback,
  fetchExternalDoenetML
}) {
  let dast = lezerToDast$1(doenetML);
  if (fetchExternalDoenetML) {
    dast = await expandExternalReferences(dast, fetchExternalDoenetML);
  }
  dast = normalizeDocumentDast(dast, true);
  await coreWorker.setCoreType("javascript");
  await coreWorker.setSource({ source: doenetML, dast });
  await coreWorker.setFlags({ flags });
  const result2 = await coreWorker.initializeJavascriptCore({
    activityId,
    docId,
    requestedVariantIndex,
    attemptNumber
  });
  documentStructureCallback?.({
    activityId,
    docId,
    args: {
      allPossibleVariants: result2.allPossibleVariants,
      baseComponentCounts: result2.baseComponentCounts
    }
  });
  return result2;
}
function formatProdErrorMessage$1(code2) {
  return `Minified Redux error #${code2}; visit https://redux.js.org/Errors?code=${code2} for the full message or use the non-minified dev environment for full errors. `;
}
var $$observable = /* @__PURE__ */ (() => typeof Symbol === "function" && Symbol.observable || "@@observable")();
var symbol_observable_default = $$observable;
var randomString = () => Math.random().toString(36).substring(7).split("").join(".");
var ActionTypes = {
  INIT: `@@redux/INIT${/* @__PURE__ */ randomString()}`,
  REPLACE: `@@redux/REPLACE${/* @__PURE__ */ randomString()}`,
  PROBE_UNKNOWN_ACTION: () => `@@redux/PROBE_UNKNOWN_ACTION${randomString()}`
};
var actionTypes_default = ActionTypes;
function isPlainObject$4(obj) {
  if (typeof obj !== "object" || obj === null)
    return false;
  let proto = obj;
  while (Object.getPrototypeOf(proto) !== null) {
    proto = Object.getPrototypeOf(proto);
  }
  return Object.getPrototypeOf(obj) === proto || Object.getPrototypeOf(obj) === null;
}
function miniKindOf(val) {
  if (val === void 0)
    return "undefined";
  if (val === null)
    return "null";
  const type = typeof val;
  switch (type) {
    case "boolean":
    case "string":
    case "number":
    case "symbol":
    case "function": {
      return type;
    }
  }
  if (Array.isArray(val))
    return "array";
  if (isDate$2(val))
    return "date";
  if (isError(val))
    return "error";
  const constructorName = ctorName(val);
  switch (constructorName) {
    case "Symbol":
    case "Promise":
    case "WeakMap":
    case "WeakSet":
    case "Map":
    case "Set":
      return constructorName;
  }
  return Object.prototype.toString.call(val).slice(8, -1).toLowerCase().replace(/\s/g, "");
}
function ctorName(val) {
  return typeof val.constructor === "function" ? val.constructor.name : null;
}
function isError(val) {
  return val instanceof Error || typeof val.message === "string" && val.constructor && typeof val.constructor.stackTraceLimit === "number";
}
function isDate$2(val) {
  if (val instanceof Date)
    return true;
  return typeof val.toDateString === "function" && typeof val.getDate === "function" && typeof val.setDate === "function";
}
function kindOf(val) {
  let typeOfVal = typeof val;
  if (process.env.NODE_ENV !== "production") {
    typeOfVal = miniKindOf(val);
  }
  return typeOfVal;
}
function createStore$3(reducer, preloadedState, enhancer) {
  if (typeof reducer !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(2) : `Expected the root reducer to be a function. Instead, received: '${kindOf(reducer)}'`);
  }
  if (typeof preloadedState === "function" && typeof enhancer === "function" || typeof enhancer === "function" && typeof arguments[3] === "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(0) : "It looks like you are passing several store enhancers to createStore(). This is not supported. Instead, compose them together to a single function. See https://redux.js.org/tutorials/fundamentals/part-4-store#creating-a-store-with-enhancers for an example.");
  }
  if (typeof preloadedState === "function" && typeof enhancer === "undefined") {
    enhancer = preloadedState;
    preloadedState = void 0;
  }
  if (typeof enhancer !== "undefined") {
    if (typeof enhancer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(1) : `Expected the enhancer to be a function. Instead, received: '${kindOf(enhancer)}'`);
    }
    return enhancer(createStore$3)(reducer, preloadedState);
  }
  let currentReducer = reducer;
  let currentState = preloadedState;
  let currentListeners = /* @__PURE__ */ new Map();
  let nextListeners = currentListeners;
  let listenerIdCounter = 0;
  let isDispatching = false;
  function ensureCanMutateNextListeners() {
    if (nextListeners === currentListeners) {
      nextListeners = /* @__PURE__ */ new Map();
      currentListeners.forEach((listener, key) => {
        nextListeners.set(key, listener);
      });
    }
  }
  function getState() {
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(3) : "You may not call store.getState() while the reducer is executing. The reducer has already received the state as an argument. Pass it down from the top reducer instead of reading it from the store.");
    }
    return currentState;
  }
  function subscribe2(listener) {
    if (typeof listener !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(4) : `Expected the listener to be a function. Instead, received: '${kindOf(listener)}'`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(5) : "You may not call store.subscribe() while the reducer is executing. If you would like to be notified after the store has been updated, subscribe from a component and invoke store.getState() in the callback to access the latest state. See https://redux.js.org/api/store#subscribelistener for more details.");
    }
    let isSubscribed = true;
    ensureCanMutateNextListeners();
    const listenerId = listenerIdCounter++;
    nextListeners.set(listenerId, listener);
    return function unsubscribe() {
      if (!isSubscribed) {
        return;
      }
      if (isDispatching) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(6) : "You may not unsubscribe from a store listener while the reducer is executing. See https://redux.js.org/api/store#subscribelistener for more details.");
      }
      isSubscribed = false;
      ensureCanMutateNextListeners();
      nextListeners.delete(listenerId);
      currentListeners = null;
    };
  }
  function dispatch(action) {
    if (!isPlainObject$4(action)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(7) : `Actions must be plain objects. Instead, the actual type was: '${kindOf(action)}'. You may need to add middleware to your store setup to handle dispatching other values, such as 'redux-thunk' to handle dispatching functions. See https://redux.js.org/tutorials/fundamentals/part-4-store#middleware and https://redux.js.org/tutorials/fundamentals/part-6-async-logic#using-the-redux-thunk-middleware for examples.`);
    }
    if (typeof action.type === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(8) : 'Actions may not have an undefined "type" property. You may have misspelled an action type string constant.');
    }
    if (typeof action.type !== "string") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(17) : `Action "type" property must be a string. Instead, the actual type was: '${kindOf(action.type)}'. Value was: '${action.type}' (stringified)`);
    }
    if (isDispatching) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(9) : "Reducers may not dispatch actions.");
    }
    try {
      isDispatching = true;
      currentState = currentReducer(currentState, action);
    } finally {
      isDispatching = false;
    }
    const listeners = currentListeners = nextListeners;
    listeners.forEach((listener) => {
      listener();
    });
    return action;
  }
  function replaceReducer(nextReducer) {
    if (typeof nextReducer !== "function") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(10) : `Expected the nextReducer to be a function. Instead, received: '${kindOf(nextReducer)}`);
    }
    currentReducer = nextReducer;
    dispatch({
      type: actionTypes_default.REPLACE
    });
  }
  function observable() {
    const outerSubscribe = subscribe2;
    return {
      /**
       * The minimal observable subscription method.
       * @param observer Any object that can be used as an observer.
       * The observer object should have a `next` method.
       * @returns An object with an `unsubscribe` method that can
       * be used to unsubscribe the observable from the store, and prevent further
       * emission of values from the observable.
       */
      subscribe(observer) {
        if (typeof observer !== "object" || observer === null) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(11) : `Expected the observer to be an object. Instead, received: '${kindOf(observer)}'`);
        }
        function observeState() {
          const observerAsObserver = observer;
          if (observerAsObserver.next) {
            observerAsObserver.next(getState());
          }
        }
        observeState();
        const unsubscribe = outerSubscribe(observeState);
        return {
          unsubscribe
        };
      },
      [symbol_observable_default]() {
        return this;
      }
    };
  }
  dispatch({
    type: actionTypes_default.INIT
  });
  const store2 = {
    dispatch,
    subscribe: subscribe2,
    getState,
    replaceReducer,
    [symbol_observable_default]: observable
  };
  return store2;
}
function warning(message) {
  if (typeof console !== "undefined" && typeof console.error === "function") {
    console.error(message);
  }
  try {
    throw new Error(message);
  } catch (e2) {
  }
}
function getUnexpectedStateShapeWarningMessage(inputState, reducers, action, unexpectedKeyCache) {
  const reducerKeys = Object.keys(reducers);
  const argumentName = action && action.type === actionTypes_default.INIT ? "preloadedState argument passed to createStore" : "previous state received by the reducer";
  if (reducerKeys.length === 0) {
    return "Store does not have a valid reducer. Make sure the argument passed to combineReducers is an object whose values are reducers.";
  }
  if (!isPlainObject$4(inputState)) {
    return `The ${argumentName} has unexpected type of "${kindOf(inputState)}". Expected argument to be an object with the following keys: "${reducerKeys.join('", "')}"`;
  }
  const unexpectedKeys = Object.keys(inputState).filter((key) => !reducers.hasOwnProperty(key) && !unexpectedKeyCache[key]);
  unexpectedKeys.forEach((key) => {
    unexpectedKeyCache[key] = true;
  });
  if (action && action.type === actionTypes_default.REPLACE)
    return;
  if (unexpectedKeys.length > 0) {
    return `Unexpected ${unexpectedKeys.length > 1 ? "keys" : "key"} "${unexpectedKeys.join('", "')}" found in ${argumentName}. Expected to find one of the known reducer keys instead: "${reducerKeys.join('", "')}". Unexpected keys will be ignored.`;
  }
}
function assertReducerShape(reducers) {
  Object.keys(reducers).forEach((key) => {
    const reducer = reducers[key];
    const initialState2 = reducer(void 0, {
      type: actionTypes_default.INIT
    });
    if (typeof initialState2 === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(12) : `The slice reducer for key "${key}" returned undefined during initialization. If the state passed to the reducer is undefined, you must explicitly return the initial state. The initial state may not be undefined. If you don't want to set a value for this reducer, you can use null instead of undefined.`);
    }
    if (typeof reducer(void 0, {
      type: actionTypes_default.PROBE_UNKNOWN_ACTION()
    }) === "undefined") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(13) : `The slice reducer for key "${key}" returned undefined when probed with a random type. Don't try to handle '${actionTypes_default.INIT}' or other actions in "redux/*" namespace. They are considered private. Instead, you must return the current state for any unknown actions, unless it is undefined, in which case you must return the initial state, regardless of the action type. The initial state may not be undefined, but can be null.`);
    }
  });
}
function combineReducers(reducers) {
  const reducerKeys = Object.keys(reducers);
  const finalReducers = {};
  for (let i2 = 0; i2 < reducerKeys.length; i2++) {
    const key = reducerKeys[i2];
    if (process.env.NODE_ENV !== "production") {
      if (typeof reducers[key] === "undefined") {
        warning(`No reducer provided for key "${key}"`);
      }
    }
    if (typeof reducers[key] === "function") {
      finalReducers[key] = reducers[key];
    }
  }
  const finalReducerKeys = Object.keys(finalReducers);
  let unexpectedKeyCache;
  if (process.env.NODE_ENV !== "production") {
    unexpectedKeyCache = {};
  }
  let shapeAssertionError;
  try {
    assertReducerShape(finalReducers);
  } catch (e2) {
    shapeAssertionError = e2;
  }
  return function combination(state = {}, action) {
    if (shapeAssertionError) {
      throw shapeAssertionError;
    }
    if (process.env.NODE_ENV !== "production") {
      const warningMessage = getUnexpectedStateShapeWarningMessage(state, finalReducers, action, unexpectedKeyCache);
      if (warningMessage) {
        warning(warningMessage);
      }
    }
    let hasChanged = false;
    const nextState = {};
    for (let i2 = 0; i2 < finalReducerKeys.length; i2++) {
      const key = finalReducerKeys[i2];
      const reducer = finalReducers[key];
      const previousStateForKey = state[key];
      const nextStateForKey = reducer(previousStateForKey, action);
      if (typeof nextStateForKey === "undefined") {
        const actionType = action && action.type;
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(14) : `When called with an action of type ${actionType ? `"${String(actionType)}"` : "(unknown type)"}, the slice reducer for key "${key}" returned undefined. To ignore an action, you must explicitly return the previous state. If you want this reducer to hold no value, you can return null instead of undefined.`);
      }
      nextState[key] = nextStateForKey;
      hasChanged = hasChanged || nextStateForKey !== previousStateForKey;
    }
    hasChanged = hasChanged || finalReducerKeys.length !== Object.keys(state).length;
    return hasChanged ? nextState : state;
  };
}
function compose$2(...funcs) {
  if (funcs.length === 0) {
    return (arg) => arg;
  }
  if (funcs.length === 1) {
    return funcs[0];
  }
  return funcs.reduce((a2, b2) => (...args) => a2(b2(...args)));
}
function applyMiddleware(...middlewares) {
  return (createStore2) => (reducer, preloadedState) => {
    const store2 = createStore2(reducer, preloadedState);
    let dispatch = () => {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage$1(15) : "Dispatching while constructing your middleware is not allowed. Other middleware would not be applied to this dispatch.");
    };
    const middlewareAPI = {
      getState: store2.getState,
      dispatch: (action, ...args) => dispatch(action, ...args)
    };
    const chain2 = middlewares.map((middleware) => middleware(middlewareAPI));
    dispatch = compose$2(...chain2)(store2.dispatch);
    return {
      ...store2,
      dispatch
    };
  };
}
function isAction(action) {
  return isPlainObject$4(action) && "type" in action && typeof action.type === "string";
}
var NOTHING = /* @__PURE__ */ Symbol.for("immer-nothing");
var DRAFTABLE = /* @__PURE__ */ Symbol.for("immer-draftable");
var DRAFT_STATE = /* @__PURE__ */ Symbol.for("immer-state");
var errors = process.env.NODE_ENV !== "production" ? [
  // All error codes, starting by 0:
  function(plugin) {
    return `The plugin for '${plugin}' has not been loaded into Immer. To enable the plugin, import and call \`enable${plugin}()\` when initializing your application.`;
  },
  function(thing) {
    return `produce can only be called on things that are draftable: plain objects, arrays, Map, Set or classes that are marked with '[immerable]: true'. Got '${thing}'`;
  },
  "This object has been frozen and should not be mutated",
  function(data) {
    return "Cannot use a proxy that has been revoked. Did you pass an object from inside an immer function to an async process? " + data;
  },
  "An immer producer returned a new value *and* modified its draft. Either return a new value *or* modify the draft.",
  "Immer forbids circular references",
  "The first or second argument to `produce` must be a function",
  "The third argument to `produce` must be a function or undefined",
  "First argument to `createDraft` must be a plain object, an array, or an immerable object",
  "First argument to `finishDraft` must be a draft returned by `createDraft`",
  function(thing) {
    return `'current' expects a draft, got: ${thing}`;
  },
  "Object.defineProperty() cannot be used on an Immer draft",
  "Object.setPrototypeOf() cannot be used on an Immer draft",
  "Immer only supports deleting array indices",
  "Immer only supports setting array indices and the 'length' property",
  function(thing) {
    return `'original' expects a draft, got: ${thing}`;
  }
  // Note: if more errors are added, the errorOffset in Patches.ts should be increased
  // See Patches.ts for additional errors
] : [];
function die(error, ...args) {
  if (process.env.NODE_ENV !== "production") {
    const e2 = errors[error];
    const msg = isFunction$3(e2) ? e2.apply(null, args) : e2;
    throw new Error(`[Immer] ${msg}`);
  }
  throw new Error(
    `[Immer] minified error nr: ${error}. Full error at: https://bit.ly/3cXEKWf`
  );
}
var O$1 = Object;
var getPrototypeOf = O$1.getPrototypeOf;
var CONSTRUCTOR = "constructor";
var PROTOTYPE = "prototype";
var CONFIGURABLE = "configurable";
var ENUMERABLE = "enumerable";
var WRITABLE = "writable";
var VALUE = "value";
var isDraft = (value) => !!value && !!value[DRAFT_STATE];
function isDraftable(value) {
  if (!value)
    return false;
  return isPlainObject$3(value) || isArray$2(value) || !!value[DRAFTABLE] || !!value[CONSTRUCTOR]?.[DRAFTABLE] || isMap$2(value) || isSet(value);
}
var objectCtorString = O$1[PROTOTYPE][CONSTRUCTOR].toString();
var cachedCtorStrings = /* @__PURE__ */ new WeakMap();
function isPlainObject$3(value) {
  if (!value || !isObjectish(value))
    return false;
  const proto = getPrototypeOf(value);
  if (proto === null || proto === O$1[PROTOTYPE])
    return true;
  const Ctor = O$1.hasOwnProperty.call(proto, CONSTRUCTOR) && proto[CONSTRUCTOR];
  if (Ctor === Object)
    return true;
  if (!isFunction$3(Ctor))
    return false;
  let ctorString = cachedCtorStrings.get(Ctor);
  if (ctorString === void 0) {
    ctorString = Function.toString.call(Ctor);
    cachedCtorStrings.set(Ctor, ctorString);
  }
  return ctorString === objectCtorString;
}
function each$2(obj, iter, strict = true) {
  if (getArchtype(obj) === 0) {
    const keys2 = strict ? Reflect.ownKeys(obj) : O$1.keys(obj);
    keys2.forEach((key) => {
      iter(key, obj[key], obj);
    });
  } else {
    obj.forEach((entry, index2) => iter(index2, entry, obj));
  }
}
function getArchtype(thing) {
  const state = thing[DRAFT_STATE];
  return state ? state.type_ : isArray$2(thing) ? 1 : isMap$2(thing) ? 2 : isSet(thing) ? 3 : 0;
}
var has$3 = (thing, prop, type = getArchtype(thing)) => type === 2 ? thing.has(prop) : O$1[PROTOTYPE].hasOwnProperty.call(thing, prop);
var get$3 = (thing, prop, type = getArchtype(thing)) => (
  // @ts-ignore
  type === 2 ? thing.get(prop) : thing[prop]
);
var set = (thing, propOrOldValue, value, type = getArchtype(thing)) => {
  if (type === 2)
    thing.set(propOrOldValue, value);
  else if (type === 3) {
    thing.add(value);
  } else
    thing[propOrOldValue] = value;
};
function is$4(x2, y2) {
  if (x2 === y2) {
    return x2 !== 0 || 1 / x2 === 1 / y2;
  } else {
    return x2 !== x2 && y2 !== y2;
  }
}
var isArray$2 = Array.isArray;
var isMap$2 = (target) => target instanceof Map;
var isSet = (target) => target instanceof Set;
var isObjectish = (target) => typeof target === "object";
var isFunction$3 = (target) => typeof target === "function";
var isBoolean$4 = (target) => typeof target === "boolean";
var latest = (state) => state.copy_ || state.base_;
var getFinalValue = (state) => state.modified_ ? state.copy_ : state.base_;
function shallowCopy(base2, strict) {
  if (isMap$2(base2)) {
    return new Map(base2);
  }
  if (isSet(base2)) {
    return new Set(base2);
  }
  if (isArray$2(base2))
    return Array[PROTOTYPE].slice.call(base2);
  const isPlain2 = isPlainObject$3(base2);
  if (strict === true || strict === "class_only" && !isPlain2) {
    const descriptors = O$1.getOwnPropertyDescriptors(base2);
    delete descriptors[DRAFT_STATE];
    let keys2 = Reflect.ownKeys(descriptors);
    for (let i2 = 0; i2 < keys2.length; i2++) {
      const key = keys2[i2];
      const desc = descriptors[key];
      if (desc[WRITABLE] === false) {
        desc[WRITABLE] = true;
        desc[CONFIGURABLE] = true;
      }
      if (desc.get || desc.set)
        descriptors[key] = {
          [CONFIGURABLE]: true,
          [WRITABLE]: true,
          // could live with !!desc.set as well here...
          [ENUMERABLE]: desc[ENUMERABLE],
          [VALUE]: base2[key]
        };
    }
    return O$1.create(getPrototypeOf(base2), descriptors);
  } else {
    const proto = getPrototypeOf(base2);
    if (proto !== null && isPlain2) {
      return { ...base2 };
    }
    const obj = O$1.create(proto);
    return O$1.assign(obj, base2);
  }
}
function freeze(obj, deep = false) {
  if (isFrozen(obj) || isDraft(obj))
    return obj;
  if (getArchtype(obj) > 1) {
    O$1.defineProperties(obj, {
      set: dontMutateMethodOverride,
      add: dontMutateMethodOverride,
      clear: dontMutateMethodOverride,
      delete: dontMutateMethodOverride
    });
  }
  O$1.freeze(obj);
  if (deep)
    each$2(
      obj,
      (_key, value) => {
        freeze(value, true);
      },
      false
    );
  return obj;
}
function dontMutateFrozenCollections() {
  die(2);
}
var dontMutateMethodOverride = {
  [VALUE]: dontMutateFrozenCollections
};
function isFrozen(obj) {
  if (obj === null || !isObjectish(obj))
    return true;
  return O$1.isFrozen(obj);
}
var PluginMapSet = "MapSet";
var PluginPatches = "Patches";
var plugins = {};
function getPlugin(pluginKey) {
  const plugin = plugins[pluginKey];
  if (!plugin) {
    die(0, pluginKey);
  }
  return plugin;
}
var isPluginLoaded = (pluginKey) => !!plugins[pluginKey];
var currentScope;
var getCurrentScope = () => currentScope;
var createScope = (parent_, immer_) => ({
  drafts_: [],
  parent_,
  immer_,
  // Whenever the modified draft contains a draft from another scope, we
  // need to prevent auto-freezing so the unowned draft can be finalized.
  canAutoFreeze_: true,
  unfinalizedDrafts_: 0,
  handledSet_: /* @__PURE__ */ new Set(),
  processedForPatches_: /* @__PURE__ */ new Set(),
  mapSetPlugin_: isPluginLoaded(PluginMapSet) ? getPlugin(PluginMapSet) : void 0
});
function usePatchesInScope(scope, patchListener) {
  if (patchListener) {
    scope.patchPlugin_ = getPlugin(PluginPatches);
    scope.patches_ = [];
    scope.inversePatches_ = [];
    scope.patchListener_ = patchListener;
  }
}
function revokeScope(scope) {
  leaveScope(scope);
  scope.drafts_.forEach(revokeDraft);
  scope.drafts_ = null;
}
function leaveScope(scope) {
  if (scope === currentScope) {
    currentScope = scope.parent_;
  }
}
var enterScope = (immer2) => currentScope = createScope(currentScope, immer2);
function revokeDraft(draft) {
  const state = draft[DRAFT_STATE];
  if (state.type_ === 0 || state.type_ === 1)
    state.revoke_();
  else
    state.revoked_ = true;
}
function processResult(result2, scope) {
  scope.unfinalizedDrafts_ = scope.drafts_.length;
  const baseDraft = scope.drafts_[0];
  const isReplaced = result2 !== void 0 && result2 !== baseDraft;
  if (isReplaced) {
    if (baseDraft[DRAFT_STATE].modified_) {
      revokeScope(scope);
      die(4);
    }
    if (isDraftable(result2)) {
      result2 = finalize(scope, result2);
    }
    const { patchPlugin_ } = scope;
    if (patchPlugin_) {
      patchPlugin_.generateReplacementPatches_(
        baseDraft[DRAFT_STATE].base_,
        result2,
        scope
      );
    }
  } else {
    result2 = finalize(scope, baseDraft);
  }
  maybeFreeze(scope, result2, true);
  revokeScope(scope);
  if (scope.patches_) {
    scope.patchListener_(scope.patches_, scope.inversePatches_);
  }
  return result2 !== NOTHING ? result2 : void 0;
}
function finalize(rootScope, value) {
  if (isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  if (!state) {
    const finalValue = handleValue(value, rootScope.handledSet_, rootScope);
    return finalValue;
  }
  if (!isSameScope(state, rootScope)) {
    return value;
  }
  if (!state.modified_) {
    return state.base_;
  }
  if (!state.finalized_) {
    const { callbacks_ } = state;
    if (callbacks_) {
      while (callbacks_.length > 0) {
        const callback = callbacks_.pop();
        callback(rootScope);
      }
    }
    generatePatchesAndFinalize(state, rootScope);
  }
  return state.copy_;
}
function maybeFreeze(scope, value, deep = false) {
  if (!scope.parent_ && scope.immer_.autoFreeze_ && scope.canAutoFreeze_) {
    freeze(value, deep);
  }
}
function markStateFinalized(state) {
  state.finalized_ = true;
  state.scope_.unfinalizedDrafts_--;
}
var isSameScope = (state, rootScope) => state.scope_ === rootScope;
var EMPTY_LOCATIONS_RESULT = [];
function updateDraftInParent(parent, draftValue, finalizedValue, originalKey) {
  const parentCopy = latest(parent);
  const parentType = parent.type_;
  if (originalKey !== void 0) {
    const currentValue = get$3(parentCopy, originalKey, parentType);
    if (currentValue === draftValue) {
      set(parentCopy, originalKey, finalizedValue, parentType);
      return;
    }
  }
  if (!parent.draftLocations_) {
    const draftLocations = parent.draftLocations_ = /* @__PURE__ */ new Map();
    each$2(parentCopy, (key, value) => {
      if (isDraft(value)) {
        const keys2 = draftLocations.get(value) || [];
        keys2.push(key);
        draftLocations.set(value, keys2);
      }
    });
  }
  const locations = parent.draftLocations_.get(draftValue) ?? EMPTY_LOCATIONS_RESULT;
  for (const location of locations) {
    set(parentCopy, location, finalizedValue, parentType);
  }
}
function registerChildFinalizationCallback(parent, child, key) {
  parent.callbacks_.push(function childCleanup(rootScope) {
    const state = child;
    if (!state || !isSameScope(state, rootScope)) {
      return;
    }
    rootScope.mapSetPlugin_?.fixSetContents(state);
    const finalizedValue = getFinalValue(state);
    updateDraftInParent(parent, state.draft_ ?? state, finalizedValue, key);
    generatePatchesAndFinalize(state, rootScope);
  });
}
function generatePatchesAndFinalize(state, rootScope) {
  const shouldFinalize = state.modified_ && !state.finalized_ && (state.type_ === 3 || (state.assigned_?.size ?? 0) > 0);
  if (shouldFinalize) {
    const { patchPlugin_ } = rootScope;
    if (patchPlugin_) {
      const basePath = patchPlugin_.getPath(state);
      if (basePath) {
        patchPlugin_.generatePatches_(state, basePath, rootScope);
      }
    }
    markStateFinalized(state);
  }
}
function handleCrossReference(target, key, value) {
  const { scope_ } = target;
  if (isDraft(value)) {
    const state = value[DRAFT_STATE];
    if (isSameScope(state, scope_)) {
      state.callbacks_.push(function crossReferenceCleanup() {
        prepareCopy(target);
        const finalizedValue = getFinalValue(state);
        updateDraftInParent(target, value, finalizedValue, key);
      });
    }
  } else if (isDraftable(value)) {
    target.callbacks_.push(function nestedDraftCleanup() {
      const targetCopy = latest(target);
      if (get$3(targetCopy, key, target.type_) === value) {
        if (scope_.drafts_.length > 1 && (target.assigned_.get(key) ?? false) === true && target.copy_) {
          handleValue(
            get$3(target.copy_, key, target.type_),
            scope_.handledSet_,
            scope_
          );
        }
      }
    });
  }
}
function handleValue(target, handledSet, rootScope) {
  if (!rootScope.immer_.autoFreeze_ && rootScope.unfinalizedDrafts_ < 1) {
    return target;
  }
  if (isDraft(target) || handledSet.has(target) || !isDraftable(target) || isFrozen(target)) {
    return target;
  }
  handledSet.add(target);
  each$2(target, (key, value) => {
    if (isDraft(value)) {
      const state = value[DRAFT_STATE];
      if (isSameScope(state, rootScope)) {
        const updatedValue = getFinalValue(state);
        set(target, key, updatedValue, target.type_);
        markStateFinalized(state);
      }
    } else if (isDraftable(value)) {
      handleValue(value, handledSet, rootScope);
    }
  });
  return target;
}
function createProxyProxy(base2, parent) {
  const baseIsArray = isArray$2(base2);
  const state = {
    type_: baseIsArray ? 1 : 0,
    // Track which produce call this is associated with.
    scope_: parent ? parent.scope_ : getCurrentScope(),
    // True for both shallow and deep changes.
    modified_: false,
    // Used during finalization.
    finalized_: false,
    // Track which properties have been assigned (true) or deleted (false).
    // actually instantiated in `prepareCopy()`
    assigned_: void 0,
    // The parent draft state.
    parent_: parent,
    // The base state.
    base_: base2,
    // The base proxy.
    draft_: null,
    // set below
    // The base copy with any updated values.
    copy_: null,
    // Called by the `produce` function.
    revoke_: null,
    isManual_: false,
    // `callbacks` actually gets assigned in `createProxy`
    callbacks_: void 0
  };
  let target = state;
  let traps = objectTraps;
  if (baseIsArray) {
    target = [state];
    traps = arrayTraps;
  }
  const { revoke, proxy: proxy2 } = Proxy.revocable(target, traps);
  state.draft_ = proxy2;
  state.revoke_ = revoke;
  return [proxy2, state];
}
var objectTraps = {
  get(state, prop) {
    if (prop === DRAFT_STATE)
      return state;
    const source = latest(state);
    if (!has$3(source, prop, state.type_)) {
      return readPropFromProto(state, source, prop);
    }
    const value = source[prop];
    if (state.finalized_ || !isDraftable(value)) {
      return value;
    }
    if (value === peek(state.base_, prop)) {
      prepareCopy(state);
      const childKey = state.type_ === 1 ? +prop : prop;
      const childDraft = createProxy(state.scope_, value, state, childKey);
      return state.copy_[childKey] = childDraft;
    }
    return value;
  },
  has(state, prop) {
    return prop in latest(state);
  },
  ownKeys(state) {
    return Reflect.ownKeys(latest(state));
  },
  set(state, prop, value) {
    const desc = getDescriptorFromProto(latest(state), prop);
    if (desc?.set) {
      desc.set.call(state.draft_, value);
      return true;
    }
    if (!state.modified_) {
      const current2 = peek(latest(state), prop);
      const currentState = current2?.[DRAFT_STATE];
      if (currentState && currentState.base_ === value) {
        state.copy_[prop] = value;
        state.assigned_.set(prop, false);
        return true;
      }
      if (is$4(value, current2) && (value !== void 0 || has$3(state.base_, prop, state.type_)))
        return true;
      prepareCopy(state);
      markChanged(state);
    }
    if (state.copy_[prop] === value && // special case: handle new props with value 'undefined'
    (value !== void 0 || prop in state.copy_) || // special case: NaN
    Number.isNaN(value) && Number.isNaN(state.copy_[prop]))
      return true;
    state.copy_[prop] = value;
    state.assigned_.set(prop, true);
    handleCrossReference(state, prop, value);
    return true;
  },
  deleteProperty(state, prop) {
    prepareCopy(state);
    if (peek(state.base_, prop) !== void 0 || prop in state.base_) {
      state.assigned_.set(prop, false);
      markChanged(state);
    } else {
      state.assigned_.delete(prop);
    }
    if (state.copy_) {
      delete state.copy_[prop];
    }
    return true;
  },
  // Note: We never coerce `desc.value` into an Immer draft, because we can't make
  // the same guarantee in ES5 mode.
  getOwnPropertyDescriptor(state, prop) {
    const owner = latest(state);
    const desc = Reflect.getOwnPropertyDescriptor(owner, prop);
    if (!desc)
      return desc;
    return {
      [WRITABLE]: true,
      [CONFIGURABLE]: state.type_ !== 1 || prop !== "length",
      [ENUMERABLE]: desc[ENUMERABLE],
      [VALUE]: owner[prop]
    };
  },
  defineProperty() {
    die(11);
  },
  getPrototypeOf(state) {
    return getPrototypeOf(state.base_);
  },
  setPrototypeOf() {
    die(12);
  }
};
var arrayTraps = {};
each$2(objectTraps, (key, fn2) => {
  arrayTraps[key] = function() {
    const args = arguments;
    args[0] = args[0][0];
    return fn2.apply(this, args);
  };
});
arrayTraps.deleteProperty = function(state, prop) {
  if (process.env.NODE_ENV !== "production" && isNaN(parseInt(prop)))
    die(13);
  return arrayTraps.set.call(this, state, prop, void 0);
};
arrayTraps.set = function(state, prop, value) {
  if (process.env.NODE_ENV !== "production" && prop !== "length" && isNaN(parseInt(prop)))
    die(14);
  return objectTraps.set.call(this, state[0], prop, value, state[0]);
};
function peek(draft, prop) {
  const state = draft[DRAFT_STATE];
  const source = state ? latest(state) : draft;
  return source[prop];
}
function readPropFromProto(state, source, prop) {
  const desc = getDescriptorFromProto(source, prop);
  return desc ? VALUE in desc ? desc[VALUE] : (
    // This is a very special case, if the prop is a getter defined by the
    // prototype, we should invoke it with the draft as context!
    desc.get?.call(state.draft_)
  ) : void 0;
}
function getDescriptorFromProto(source, prop) {
  if (!(prop in source))
    return void 0;
  let proto = getPrototypeOf(source);
  while (proto) {
    const desc = Object.getOwnPropertyDescriptor(proto, prop);
    if (desc)
      return desc;
    proto = getPrototypeOf(proto);
  }
  return void 0;
}
function markChanged(state) {
  if (!state.modified_) {
    state.modified_ = true;
    if (state.parent_) {
      markChanged(state.parent_);
    }
  }
}
function prepareCopy(state) {
  if (!state.copy_) {
    state.assigned_ = /* @__PURE__ */ new Map();
    state.copy_ = shallowCopy(
      state.base_,
      state.scope_.immer_.useStrictShallowCopy_
    );
  }
}
var Immer2 = class {
  constructor(config2) {
    this.autoFreeze_ = true;
    this.useStrictShallowCopy_ = false;
    this.useStrictIteration_ = false;
    this.produce = (base2, recipe, patchListener) => {
      if (isFunction$3(base2) && !isFunction$3(recipe)) {
        const defaultBase = recipe;
        recipe = base2;
        const self2 = this;
        return function curriedProduce(base22 = defaultBase, ...args) {
          return self2.produce(base22, (draft) => recipe.call(this, draft, ...args));
        };
      }
      if (!isFunction$3(recipe))
        die(6);
      if (patchListener !== void 0 && !isFunction$3(patchListener))
        die(7);
      let result2;
      if (isDraftable(base2)) {
        const scope = enterScope(this);
        const proxy2 = createProxy(scope, base2, void 0);
        let hasError = true;
        try {
          result2 = recipe(proxy2);
          hasError = false;
        } finally {
          if (hasError)
            revokeScope(scope);
          else
            leaveScope(scope);
        }
        usePatchesInScope(scope, patchListener);
        return processResult(result2, scope);
      } else if (!base2 || !isObjectish(base2)) {
        result2 = recipe(base2);
        if (result2 === void 0)
          result2 = base2;
        if (result2 === NOTHING)
          result2 = void 0;
        if (this.autoFreeze_)
          freeze(result2, true);
        if (patchListener) {
          const p2 = [];
          const ip = [];
          getPlugin(PluginPatches).generateReplacementPatches_(base2, result2, {
            patches_: p2,
            inversePatches_: ip
          });
          patchListener(p2, ip);
        }
        return result2;
      } else
        die(1, base2);
    };
    this.produceWithPatches = (base2, recipe) => {
      if (isFunction$3(base2)) {
        return (state, ...args) => this.produceWithPatches(state, (draft) => base2(draft, ...args));
      }
      let patches, inversePatches;
      const result2 = this.produce(base2, recipe, (p2, ip) => {
        patches = p2;
        inversePatches = ip;
      });
      return [result2, patches, inversePatches];
    };
    if (isBoolean$4(config2?.autoFreeze))
      this.setAutoFreeze(config2.autoFreeze);
    if (isBoolean$4(config2?.useStrictShallowCopy))
      this.setUseStrictShallowCopy(config2.useStrictShallowCopy);
    if (isBoolean$4(config2?.useStrictIteration))
      this.setUseStrictIteration(config2.useStrictIteration);
  }
  createDraft(base2) {
    if (!isDraftable(base2))
      die(8);
    if (isDraft(base2))
      base2 = current(base2);
    const scope = enterScope(this);
    const proxy2 = createProxy(scope, base2, void 0);
    proxy2[DRAFT_STATE].isManual_ = true;
    leaveScope(scope);
    return proxy2;
  }
  finishDraft(draft, patchListener) {
    const state = draft && draft[DRAFT_STATE];
    if (!state || !state.isManual_)
      die(9);
    const { scope_: scope } = state;
    usePatchesInScope(scope, patchListener);
    return processResult(void 0, scope);
  }
  /**
   * Pass true to automatically freeze all copies created by Immer.
   *
   * By default, auto-freezing is enabled.
   */
  setAutoFreeze(value) {
    this.autoFreeze_ = value;
  }
  /**
   * Pass true to enable strict shallow copy.
   *
   * By default, immer does not copy the object descriptors such as getter, setter and non-enumrable properties.
   */
  setUseStrictShallowCopy(value) {
    this.useStrictShallowCopy_ = value;
  }
  /**
   * Pass false to use faster iteration that skips non-enumerable properties
   * but still handles symbols for compatibility.
   *
   * By default, strict iteration is enabled (includes all own properties).
   */
  setUseStrictIteration(value) {
    this.useStrictIteration_ = value;
  }
  shouldUseStrictIteration() {
    return this.useStrictIteration_;
  }
  applyPatches(base2, patches) {
    let i2;
    for (i2 = patches.length - 1; i2 >= 0; i2--) {
      const patch = patches[i2];
      if (patch.path.length === 0 && patch.op === "replace") {
        base2 = patch.value;
        break;
      }
    }
    if (i2 > -1) {
      patches = patches.slice(i2 + 1);
    }
    const applyPatchesImpl = getPlugin(PluginPatches).applyPatches_;
    if (isDraft(base2)) {
      return applyPatchesImpl(base2, patches);
    }
    return this.produce(
      base2,
      (draft) => applyPatchesImpl(draft, patches)
    );
  }
};
function createProxy(rootScope, value, parent, key) {
  const [draft, state] = isMap$2(value) ? getPlugin(PluginMapSet).proxyMap_(value, parent) : isSet(value) ? getPlugin(PluginMapSet).proxySet_(value, parent) : createProxyProxy(value, parent);
  const scope = parent?.scope_ ?? getCurrentScope();
  scope.drafts_.push(draft);
  state.callbacks_ = parent?.callbacks_ ?? [];
  state.key_ = key;
  if (parent && key !== void 0) {
    registerChildFinalizationCallback(parent, state, key);
  } else {
    state.callbacks_.push(function rootDraftCleanup(rootScope2) {
      rootScope2.mapSetPlugin_?.fixSetContents(state);
      const { patchPlugin_ } = rootScope2;
      if (state.modified_ && patchPlugin_) {
        patchPlugin_.generatePatches_(state, [], rootScope2);
      }
    });
  }
  return draft;
}
function current(value) {
  if (!isDraft(value))
    die(10, value);
  return currentImpl(value);
}
function currentImpl(value) {
  if (!isDraftable(value) || isFrozen(value))
    return value;
  const state = value[DRAFT_STATE];
  let copy2;
  let strict = true;
  if (state) {
    if (!state.modified_)
      return state.base_;
    state.finalized_ = true;
    copy2 = shallowCopy(value, state.scope_.immer_.useStrictShallowCopy_);
    strict = state.scope_.immer_.shouldUseStrictIteration();
  } else {
    copy2 = shallowCopy(value, true);
  }
  each$2(
    copy2,
    (key, childValue) => {
      set(copy2, key, currentImpl(childValue));
    },
    strict
  );
  if (state) {
    state.finalized_ = false;
  }
  return copy2;
}
var immer = new Immer2();
var produce = immer.produce;
function createThunkMiddleware(extraArgument) {
  const middleware = ({ dispatch, getState }) => (next) => (action) => {
    if (typeof action === "function") {
      return action(dispatch, getState, extraArgument);
    }
    return next(action);
  };
  return middleware;
}
var thunk = createThunkMiddleware();
var withExtraArgument = createThunkMiddleware;
var composeWithDevTools = typeof window !== "undefined" && window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ ? window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__ : function() {
  if (arguments.length === 0) return void 0;
  if (typeof arguments[0] === "object") return compose$2;
  return compose$2.apply(null, arguments);
};
var hasMatchFunction = (v2) => {
  return v2 && typeof v2.match === "function";
};
function createAction(type, prepareAction) {
  function actionCreator(...args) {
    if (prepareAction) {
      let prepared = prepareAction(...args);
      if (!prepared) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(0) : "prepareAction did not return an object");
      }
      return {
        type,
        payload: prepared.payload,
        ..."meta" in prepared && {
          meta: prepared.meta
        },
        ..."error" in prepared && {
          error: prepared.error
        }
      };
    }
    return {
      type,
      payload: args[0]
    };
  }
  actionCreator.toString = () => `${type}`;
  actionCreator.type = type;
  actionCreator.match = (action) => isAction(action) && action.type === type;
  return actionCreator;
}
function isActionCreator(action) {
  return typeof action === "function" && "type" in action && // hasMatchFunction only wants Matchers but I don't see the point in rewriting it
  hasMatchFunction(action);
}
function getMessage(type) {
  const splitType = type ? `${type}`.split("/") : [];
  const actionName = splitType[splitType.length - 1] || "actionCreator";
  return `Detected an action creator with type "${type || "unknown"}" being dispatched.
Make sure you're calling the action creator before dispatching, i.e. \`dispatch(${actionName}())\` instead of \`dispatch(${actionName})\`. This is necessary even if the action has no payload.`;
}
function createActionCreatorInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  }
  const {
    isActionCreator: isActionCreator2 = isActionCreator
  } = options2;
  return () => (next) => (action) => {
    if (isActionCreator2(action)) {
      console.warn(getMessage(action.type));
    }
    return next(action);
  };
}
function getTimeMeasureUtils(maxDelay, fnName) {
  let elapsed = 0;
  return {
    measureTime(fn2) {
      const started = Date.now();
      try {
        return fn2();
      } finally {
        const finished = Date.now();
        elapsed += finished - started;
      }
    },
    warnIfExceeded() {
      if (elapsed > maxDelay) {
        console.warn(`${fnName} took ${elapsed}ms, which is more than the warning threshold of ${maxDelay}ms. 
If your state or actions are very large, you may want to disable the middleware as it might cause too much of a slowdown in development mode. See https://redux-toolkit.js.org/api/getDefaultMiddleware for instructions.
It is disabled in production builds, so you don't need to worry about that.`);
      }
    }
  };
}
var Tuple = class _Tuple extends Array {
  constructor(...items) {
    super(...items);
    Object.setPrototypeOf(this, _Tuple.prototype);
  }
  static get [Symbol.species]() {
    return _Tuple;
  }
  concat(...arr) {
    return super.concat.apply(this, arr);
  }
  prepend(...arr) {
    if (arr.length === 1 && Array.isArray(arr[0])) {
      return new _Tuple(...arr[0].concat(this));
    }
    return new _Tuple(...arr.concat(this));
  }
};
function freezeDraftable(val) {
  return isDraftable(val) ? produce(val, () => {
  }) : val;
}
function getOrInsertComputed$1(map2, key, compute) {
  if (map2.has(key)) return map2.get(key);
  return map2.set(key, compute(key)).get(key);
}
function isImmutableDefault(value) {
  return typeof value !== "object" || value == null || Object.isFrozen(value);
}
function trackForMutations(isImmutable, ignoredPaths, obj) {
  const trackedProperties = trackProperties(isImmutable, ignoredPaths, obj);
  return {
    detectMutations() {
      return detectMutations(isImmutable, ignoredPaths, trackedProperties, obj);
    }
  };
}
function trackProperties(isImmutable, ignoredPaths = [], obj, path = "", checkedObjects = /* @__PURE__ */ new Set()) {
  const tracked = {
    value: obj
  };
  if (!isImmutable(obj) && !checkedObjects.has(obj)) {
    checkedObjects.add(obj);
    tracked.children = {};
    const hasIgnoredPaths = ignoredPaths.length > 0;
    for (const key in obj) {
      const nestedPath = path ? path + "." + key : key;
      if (hasIgnoredPaths) {
        const hasMatches = ignoredPaths.some((ignored) => {
          if (ignored instanceof RegExp) {
            return ignored.test(nestedPath);
          }
          return nestedPath === ignored;
        });
        if (hasMatches) {
          continue;
        }
      }
      tracked.children[key] = trackProperties(isImmutable, ignoredPaths, obj[key], nestedPath);
    }
  }
  return tracked;
}
function detectMutations(isImmutable, ignoredPaths = [], trackedProperty, obj, sameParentRef = false, path = "") {
  const prevObj = trackedProperty ? trackedProperty.value : void 0;
  const sameRef = prevObj === obj;
  if (sameParentRef && !sameRef && !Number.isNaN(obj)) {
    return {
      wasMutated: true,
      path
    };
  }
  if (isImmutable(prevObj) || isImmutable(obj)) {
    return {
      wasMutated: false
    };
  }
  const keysToDetect = {};
  for (let key in trackedProperty.children) {
    keysToDetect[key] = true;
  }
  for (let key in obj) {
    keysToDetect[key] = true;
  }
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (let key in keysToDetect) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    const result2 = detectMutations(isImmutable, ignoredPaths, trackedProperty.children[key], obj[key], sameRef, nestedPath);
    if (result2.wasMutated) {
      return result2;
    }
  }
  return {
    wasMutated: false
  };
}
function createImmutableStateInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    let stringify2 = function(obj, serializer, indent2, decycler) {
      return JSON.stringify(obj, getSerialize2(serializer, decycler), indent2);
    }, getSerialize2 = function(serializer, decycler) {
      let stack = [], keys2 = [];
      if (!decycler) decycler = function(_2, value) {
        if (stack[0] === value) return "[Circular ~]";
        return "[Circular ~." + keys2.slice(0, stack.indexOf(value)).join(".") + "]";
      };
      return function(key, value) {
        if (stack.length > 0) {
          var thisPos = stack.indexOf(this);
          ~thisPos ? stack.splice(thisPos + 1) : stack.push(this);
          ~thisPos ? keys2.splice(thisPos, Infinity, key) : keys2.push(key);
          if (~stack.indexOf(value)) value = decycler.call(this, key, value);
        } else stack.push(value);
        return serializer == null ? value : serializer.call(this, key, value);
      };
    };
    let {
      isImmutable = isImmutableDefault,
      ignoredPaths,
      warnAfter = 32
    } = options2;
    const track = trackForMutations.bind(null, isImmutable, ignoredPaths);
    return ({
      getState
    }) => {
      let state = getState();
      let tracker = track(state);
      let result2;
      return (next) => (action) => {
        const measureUtils = getTimeMeasureUtils(warnAfter, "ImmutableStateInvariantMiddleware");
        measureUtils.measureTime(() => {
          state = getState();
          result2 = tracker.detectMutations();
          tracker = track(state);
          if (result2.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(19) : `A state mutation was detected between dispatches, in the path '${result2.path || ""}'.  This may cause incorrect behavior. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        const dispatchedAction = next(action);
        measureUtils.measureTime(() => {
          state = getState();
          result2 = tracker.detectMutations();
          tracker = track(state);
          if (result2.wasMutated) {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(20) : `A state mutation was detected inside a dispatch, in the path: ${result2.path || ""}. Take a look at the reducer(s) handling the action ${stringify2(action)}. (https://redux.js.org/style-guide/style-guide#do-not-mutate-state)`);
          }
        });
        measureUtils.warnIfExceeded();
        return dispatchedAction;
      };
    };
  }
}
function isPlain(val) {
  const type = typeof val;
  return val == null || type === "string" || type === "boolean" || type === "number" || Array.isArray(val) || isPlainObject$4(val);
}
function findNonSerializableValue(value, path = "", isSerializable = isPlain, getEntries, ignoredPaths = [], cache) {
  let foundNestedSerializable;
  if (!isSerializable(value)) {
    return {
      keyPath: path || "<root>",
      value
    };
  }
  if (typeof value !== "object" || value === null) {
    return false;
  }
  if (cache?.has(value)) return false;
  const entries = getEntries != null ? getEntries(value) : Object.entries(value);
  const hasIgnoredPaths = ignoredPaths.length > 0;
  for (const [key, nestedValue] of entries) {
    const nestedPath = path ? path + "." + key : key;
    if (hasIgnoredPaths) {
      const hasMatches = ignoredPaths.some((ignored) => {
        if (ignored instanceof RegExp) {
          return ignored.test(nestedPath);
        }
        return nestedPath === ignored;
      });
      if (hasMatches) {
        continue;
      }
    }
    if (!isSerializable(nestedValue)) {
      return {
        keyPath: nestedPath,
        value: nestedValue
      };
    }
    if (typeof nestedValue === "object") {
      foundNestedSerializable = findNonSerializableValue(nestedValue, nestedPath, isSerializable, getEntries, ignoredPaths, cache);
      if (foundNestedSerializable) {
        return foundNestedSerializable;
      }
    }
  }
  if (cache && isNestedFrozen(value)) cache.add(value);
  return false;
}
function isNestedFrozen(value) {
  if (!Object.isFrozen(value)) return false;
  for (const nestedValue of Object.values(value)) {
    if (typeof nestedValue !== "object" || nestedValue === null) continue;
    if (!isNestedFrozen(nestedValue)) return false;
  }
  return true;
}
function createSerializableStateInvariantMiddleware(options2 = {}) {
  if (process.env.NODE_ENV === "production") {
    return () => (next) => (action) => next(action);
  } else {
    const {
      isSerializable = isPlain,
      getEntries,
      ignoredActions = [],
      ignoredActionPaths = ["meta.arg", "meta.baseQueryMeta"],
      ignoredPaths = [],
      warnAfter = 32,
      ignoreState = false,
      ignoreActions = false,
      disableCache = false
    } = options2;
    const cache = !disableCache && WeakSet ? /* @__PURE__ */ new WeakSet() : void 0;
    return (storeAPI) => (next) => (action) => {
      if (!isAction(action)) {
        return next(action);
      }
      const result2 = next(action);
      const measureUtils = getTimeMeasureUtils(warnAfter, "SerializableStateInvariantMiddleware");
      if (!ignoreActions && !(ignoredActions.length && ignoredActions.indexOf(action.type) !== -1)) {
        measureUtils.measureTime(() => {
          const foundActionNonSerializableValue = findNonSerializableValue(action, "", isSerializable, getEntries, ignoredActionPaths, cache);
          if (foundActionNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundActionNonSerializableValue;
            console.error(`A non-serializable value was detected in an action, in the path: \`${keyPath}\`. Value:`, value, "\nTake a look at the logic that dispatched this action: ", action, "\n(See https://redux.js.org/faq/actions#why-should-type-be-a-string-or-at-least-serializable-why-should-my-action-types-be-constants)", "\n(To allow non-serializable values see: https://redux-toolkit.js.org/usage/usage-guide#working-with-non-serializable-data)");
          }
        });
      }
      if (!ignoreState) {
        measureUtils.measureTime(() => {
          const state = storeAPI.getState();
          const foundStateNonSerializableValue = findNonSerializableValue(state, "", isSerializable, getEntries, ignoredPaths, cache);
          if (foundStateNonSerializableValue) {
            const {
              keyPath,
              value
            } = foundStateNonSerializableValue;
            console.error(`A non-serializable value was detected in the state, in the path: \`${keyPath}\`. Value:`, value, `
Take a look at the reducer(s) handling this action type: ${action.type}.
(See https://redux.js.org/faq/organizing-state#can-i-put-functions-promises-or-other-non-serializable-items-in-my-store-state)`);
          }
        });
        measureUtils.warnIfExceeded();
      }
      return result2;
    };
  }
}
function isBoolean$3(x2) {
  return typeof x2 === "boolean";
}
var buildGetDefaultMiddleware = () => function getDefaultMiddleware(options2) {
  const {
    thunk: thunk$1 = true,
    immutableCheck = true,
    serializableCheck = true,
    actionCreatorCheck = true
  } = options2 ?? {};
  let middlewareArray = new Tuple();
  if (thunk$1) {
    if (isBoolean$3(thunk$1)) {
      middlewareArray.push(thunk);
    } else {
      middlewareArray.push(withExtraArgument(thunk$1.extraArgument));
    }
  }
  if (process.env.NODE_ENV !== "production") {
    if (immutableCheck) {
      let immutableOptions = {};
      if (!isBoolean$3(immutableCheck)) {
        immutableOptions = immutableCheck;
      }
      middlewareArray.unshift(createImmutableStateInvariantMiddleware(immutableOptions));
    }
    if (serializableCheck) {
      let serializableOptions = {};
      if (!isBoolean$3(serializableCheck)) {
        serializableOptions = serializableCheck;
      }
      middlewareArray.push(createSerializableStateInvariantMiddleware(serializableOptions));
    }
    if (actionCreatorCheck) {
      let actionCreatorOptions = {};
      if (!isBoolean$3(actionCreatorCheck)) {
        actionCreatorOptions = actionCreatorCheck;
      }
      middlewareArray.unshift(createActionCreatorInvariantMiddleware(actionCreatorOptions));
    }
  }
  return middlewareArray;
};
var SHOULD_AUTOBATCH = "RTK_autoBatch";
var createQueueWithTimer = (timeout) => {
  return (notify) => {
    setTimeout(notify, timeout);
  };
};
var createRafWithFallbackTimer = (raf, timeout) => {
  return (notify) => {
    let called = false;
    const callback = () => {
      if (called) return;
      called = true;
      cancelAnimationFrame(rafId);
      clearTimeout(timerId);
      notify();
    };
    const rafId = raf(callback);
    const timerId = setTimeout(callback, timeout);
  };
};
var autoBatchEnhancer = (options2 = {
  type: "raf"
}) => (next) => (...args) => {
  const store2 = next(...args);
  let notifying = true;
  let shouldNotifyAtEndOfTick = false;
  let notificationQueued = false;
  const listeners = /* @__PURE__ */ new Set();
  const queueCallback = options2.type === "tick" ? queueMicrotask : options2.type === "raf" ? (
    // requestAnimationFrame won't exist in SSR environments. Fall back to a vague approximation just to keep from erroring.
    typeof window !== "undefined" && window.requestAnimationFrame ? createRafWithFallbackTimer(window.requestAnimationFrame, 100) : createQueueWithTimer(10)
  ) : options2.type === "callback" ? options2.queueNotification : createQueueWithTimer(options2.timeout);
  const notifyListeners = () => {
    notificationQueued = false;
    if (shouldNotifyAtEndOfTick) {
      shouldNotifyAtEndOfTick = false;
      listeners.forEach((l2) => l2());
    }
  };
  return Object.assign({}, store2, {
    // Override the base `store.subscribe` method to keep original listeners
    // from running if we're delaying notifications
    subscribe(listener2) {
      const wrappedListener = () => notifying && listener2();
      const unsubscribe = store2.subscribe(wrappedListener);
      listeners.add(listener2);
      return () => {
        unsubscribe();
        listeners.delete(listener2);
      };
    },
    // Override the base `store.dispatch` method so that we can check actions
    // for the `shouldAutoBatch` flag and determine if batching is active
    dispatch(action) {
      try {
        notifying = !action?.meta?.[SHOULD_AUTOBATCH];
        shouldNotifyAtEndOfTick = !notifying;
        if (shouldNotifyAtEndOfTick) {
          if (!notificationQueued) {
            notificationQueued = true;
            queueCallback(notifyListeners);
          }
        }
        return store2.dispatch(action);
      } finally {
        notifying = true;
      }
    }
  });
};
var buildGetDefaultEnhancers = (middlewareEnhancer) => function getDefaultEnhancers(options2) {
  const {
    autoBatch = true
  } = options2 ?? {};
  let enhancerArray = new Tuple(middlewareEnhancer);
  if (autoBatch) {
    enhancerArray.push(autoBatchEnhancer(typeof autoBatch === "object" ? autoBatch : void 0));
  }
  return enhancerArray;
};
function configureStore(options2) {
  const getDefaultMiddleware = buildGetDefaultMiddleware();
  const {
    reducer = void 0,
    middleware,
    devTools = true,
    duplicateMiddlewareCheck = true,
    preloadedState = void 0,
    enhancers = void 0
  } = options2 || {};
  let rootReducer;
  if (typeof reducer === "function") {
    rootReducer = reducer;
  } else if (isPlainObject$4(reducer)) {
    rootReducer = combineReducers(reducer);
  } else {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(1) : "`reducer` is a required argument, and must be a function or an object of functions that can be passed to combineReducers");
  }
  if (process.env.NODE_ENV !== "production" && middleware && typeof middleware !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(2) : "`middleware` field must be a callback");
  }
  let finalMiddleware;
  if (typeof middleware === "function") {
    finalMiddleware = middleware(getDefaultMiddleware);
    if (process.env.NODE_ENV !== "production" && !Array.isArray(finalMiddleware)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(3) : "when using a middleware builder function, an array of middleware must be returned");
    }
  } else {
    finalMiddleware = getDefaultMiddleware();
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(4) : "each middleware provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && duplicateMiddlewareCheck) {
    let middlewareReferences = /* @__PURE__ */ new Set();
    finalMiddleware.forEach((middleware2) => {
      if (middlewareReferences.has(middleware2)) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(42) : "Duplicate middleware references found when creating the store. Ensure that each middleware is only included once.");
      }
      middlewareReferences.add(middleware2);
    });
  }
  let finalCompose = compose$2;
  if (devTools) {
    finalCompose = composeWithDevTools({
      // Enable capture of stack traces for dispatched Redux actions
      trace: process.env.NODE_ENV !== "production",
      ...typeof devTools === "object" && devTools
    });
  }
  const middlewareEnhancer = applyMiddleware(...finalMiddleware);
  const getDefaultEnhancers = buildGetDefaultEnhancers(middlewareEnhancer);
  if (process.env.NODE_ENV !== "production" && enhancers && typeof enhancers !== "function") {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(5) : "`enhancers` field must be a callback");
  }
  let storeEnhancers = typeof enhancers === "function" ? enhancers(getDefaultEnhancers) : getDefaultEnhancers();
  if (process.env.NODE_ENV !== "production" && !Array.isArray(storeEnhancers)) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(6) : "`enhancers` callback must return an array");
  }
  if (process.env.NODE_ENV !== "production" && storeEnhancers.some((item) => typeof item !== "function")) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(7) : "each enhancer provided to configureStore must be a function");
  }
  if (process.env.NODE_ENV !== "production" && finalMiddleware.length && !storeEnhancers.includes(middlewareEnhancer)) {
    console.error("middlewares were provided, but middleware enhancer was not included in final enhancers - make sure to call `getDefaultEnhancers`");
  }
  const composedEnhancer = finalCompose(...storeEnhancers);
  return createStore$3(rootReducer, preloadedState, composedEnhancer);
}
function executeReducerBuilderCallback(builderCallback) {
  const actionsMap = {};
  const actionMatchers = [];
  let defaultCaseReducer;
  const builder = {
    addCase(typeOrActionCreator, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (actionMatchers.length > 0) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(26) : "`builder.addCase` should only be called before calling `builder.addMatcher`");
        }
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(27) : "`builder.addCase` should only be called before calling `builder.addDefaultCase`");
        }
      }
      const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
      if (!type) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(28) : "`builder.addCase` cannot be called with an empty action type");
      }
      if (type in actionsMap) {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(29) : `\`builder.addCase\` cannot be called with two reducers for the same action type '${type}'`);
      }
      actionsMap[type] = reducer;
      return builder;
    },
    addAsyncThunk(asyncThunk, reducers) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(43) : "`builder.addAsyncThunk` should only be called before calling `builder.addDefaultCase`");
        }
      }
      if (reducers.pending) actionsMap[asyncThunk.pending.type] = reducers.pending;
      if (reducers.rejected) actionsMap[asyncThunk.rejected.type] = reducers.rejected;
      if (reducers.fulfilled) actionsMap[asyncThunk.fulfilled.type] = reducers.fulfilled;
      if (reducers.settled) actionMatchers.push({
        matcher: asyncThunk.settled,
        reducer: reducers.settled
      });
      return builder;
    },
    addMatcher(matcher2, reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(30) : "`builder.addMatcher` should only be called before calling `builder.addDefaultCase`");
        }
      }
      actionMatchers.push({
        matcher: matcher2,
        reducer
      });
      return builder;
    },
    addDefaultCase(reducer) {
      if (process.env.NODE_ENV !== "production") {
        if (defaultCaseReducer) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(31) : "`builder.addDefaultCase` can only be called once");
        }
      }
      defaultCaseReducer = reducer;
      return builder;
    }
  };
  builderCallback(builder);
  return [actionsMap, actionMatchers, defaultCaseReducer];
}
function isStateFunction(x2) {
  return typeof x2 === "function";
}
function createReducer(initialState2, mapOrBuilderCallback) {
  if (process.env.NODE_ENV !== "production") {
    if (typeof mapOrBuilderCallback === "object") {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(8) : "The object notation for `createReducer` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createReducer");
    }
  }
  let [actionsMap, finalActionMatchers, finalDefaultCaseReducer] = executeReducerBuilderCallback(mapOrBuilderCallback);
  let getInitialState;
  if (isStateFunction(initialState2)) {
    getInitialState = () => freezeDraftable(initialState2());
  } else {
    const frozenInitialState = freezeDraftable(initialState2);
    getInitialState = () => frozenInitialState;
  }
  function reducer(state = getInitialState(), action) {
    let caseReducers = [actionsMap[action.type], ...finalActionMatchers.filter(({
      matcher: matcher2
    }) => matcher2(action)).map(({
      reducer: reducer2
    }) => reducer2)];
    if (caseReducers.filter((cr2) => !!cr2).length === 0) {
      caseReducers = [finalDefaultCaseReducer];
    }
    return caseReducers.reduce((previousState, caseReducer) => {
      if (caseReducer) {
        if (isDraft(previousState)) {
          const draft = previousState;
          const result2 = caseReducer(draft, action);
          if (result2 === void 0) {
            return previousState;
          }
          return result2;
        } else if (!isDraftable(previousState)) {
          const result2 = caseReducer(previousState, action);
          if (result2 === void 0) {
            if (previousState === null) {
              return previousState;
            }
            throw Error("A case reducer on a non-draftable value must not return undefined");
          }
          return result2;
        } else {
          return produce(previousState, (draft) => {
            return caseReducer(draft, action);
          });
        }
      }
      return previousState;
    }, state);
  }
  reducer.getInitialState = getInitialState;
  return reducer;
}
var matches = (matcher2, action) => {
  if (hasMatchFunction(matcher2)) {
    return matcher2.match(action);
  } else {
    return matcher2(action);
  }
};
function isAnyOf(...matchers) {
  return (action) => {
    return matchers.some((matcher2) => matches(matcher2, action));
  };
}
var urlAlphabet = "ModuleSymbhasOwnPr-0123456789ABCDEFGHNRVfgctiUvz_KqYTJkLxpZXIjQW";
var nanoid = (size2 = 21) => {
  let id2 = "";
  let i2 = size2;
  while (i2--) {
    id2 += urlAlphabet[Math.random() * 64 | 0];
  }
  return id2;
};
var commonProperties = ["name", "message", "stack", "code"];
var RejectWithValue = class {
  constructor(payload, meta2) {
    this.payload = payload;
    this.meta = meta2;
  }
  payload;
  meta;
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var FulfillWithMeta = class {
  constructor(payload, meta2) {
    this.payload = payload;
    this.meta = meta2;
  }
  payload;
  meta;
  /*
  type-only property to distinguish between RejectWithValue and FulfillWithMeta
  does not exist at runtime
  */
  _type;
};
var miniSerializeError = (value) => {
  if (typeof value === "object" && value !== null) {
    const simpleError = {};
    for (const property2 of commonProperties) {
      if (typeof value[property2] === "string") {
        simpleError[property2] = value[property2];
      }
    }
    return simpleError;
  }
  return {
    message: String(value)
  };
};
var externalAbortMessage = "External signal was aborted";
var createAsyncThunk = /* @__PURE__ */ (() => {
  function createAsyncThunk2(typePrefix, payloadCreator, options2) {
    const fulfilled = createAction(typePrefix + "/fulfilled", (payload, requestId, arg, meta2) => ({
      payload,
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        requestStatus: "fulfilled"
      }
    }));
    const pending = createAction(typePrefix + "/pending", (requestId, arg, meta2) => ({
      payload: void 0,
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        requestStatus: "pending"
      }
    }));
    const rejected = createAction(typePrefix + "/rejected", (error, requestId, arg, payload, meta2) => ({
      payload,
      error: (options2 && options2.serializeError || miniSerializeError)(error || "Rejected"),
      meta: {
        ...meta2 || {},
        arg,
        requestId,
        rejectedWithValue: !!payload,
        requestStatus: "rejected",
        aborted: error?.name === "AbortError",
        condition: error?.name === "ConditionError"
      }
    }));
    function actionCreator(arg, {
      signal
    } = {}) {
      return (dispatch, getState, extra) => {
        const requestId = options2?.idGenerator ? options2.idGenerator(arg) : nanoid();
        const abortController = new AbortController();
        let abortHandler;
        let abortReason;
        function abort(reason) {
          abortReason = reason;
          abortController.abort();
        }
        if (signal) {
          if (signal.aborted) {
            abort(externalAbortMessage);
          } else {
            signal.addEventListener("abort", () => abort(externalAbortMessage), {
              once: true
            });
          }
        }
        const promise = (async function() {
          let finalAction;
          try {
            let conditionResult = options2?.condition?.(arg, {
              getState,
              extra
            });
            if (isThenable(conditionResult)) {
              conditionResult = await conditionResult;
            }
            if (conditionResult === false || abortController.signal.aborted) {
              throw {
                name: "ConditionError",
                message: "Aborted due to condition callback returning false."
              };
            }
            const abortedPromise = new Promise((_2, reject2) => {
              abortHandler = () => {
                reject2({
                  name: "AbortError",
                  message: abortReason || "Aborted"
                });
              };
              abortController.signal.addEventListener("abort", abortHandler, {
                once: true
              });
            });
            dispatch(pending(requestId, arg, options2?.getPendingMeta?.({
              requestId,
              arg
            }, {
              getState,
              extra
            })));
            finalAction = await Promise.race([abortedPromise, Promise.resolve(payloadCreator(arg, {
              dispatch,
              getState,
              extra,
              requestId,
              signal: abortController.signal,
              abort,
              rejectWithValue: ((value, meta2) => {
                return new RejectWithValue(value, meta2);
              }),
              fulfillWithValue: ((value, meta2) => {
                return new FulfillWithMeta(value, meta2);
              })
            })).then((result2) => {
              if (result2 instanceof RejectWithValue) {
                throw result2;
              }
              if (result2 instanceof FulfillWithMeta) {
                return fulfilled(result2.payload, requestId, arg, result2.meta);
              }
              return fulfilled(result2, requestId, arg);
            })]);
          } catch (err) {
            finalAction = err instanceof RejectWithValue ? rejected(null, requestId, arg, err.payload, err.meta) : rejected(err, requestId, arg);
          } finally {
            if (abortHandler) {
              abortController.signal.removeEventListener("abort", abortHandler);
            }
          }
          const skipDispatch = options2 && !options2.dispatchConditionRejection && rejected.match(finalAction) && finalAction.meta.condition;
          if (!skipDispatch) {
            dispatch(finalAction);
          }
          return finalAction;
        })();
        return Object.assign(promise, {
          abort,
          requestId,
          arg,
          unwrap() {
            return promise.then(unwrapResult);
          }
        });
      };
    }
    return Object.assign(actionCreator, {
      pending,
      rejected,
      fulfilled,
      settled: isAnyOf(rejected, fulfilled),
      typePrefix
    });
  }
  createAsyncThunk2.withTypes = () => createAsyncThunk2;
  return createAsyncThunk2;
})();
function unwrapResult(action) {
  if (action.meta && action.meta.rejectedWithValue) {
    throw action.payload;
  }
  if (action.error) {
    throw action.error;
  }
  return action.payload;
}
function isThenable(value) {
  return value !== null && typeof value === "object" && typeof value.then === "function";
}
var asyncThunkSymbol = /* @__PURE__ */ Symbol.for("rtk-slice-createasyncthunk");
function getType(slice2, actionKey) {
  return `${slice2}/${actionKey}`;
}
function buildCreateSlice({
  creators
} = {}) {
  const cAT = creators?.asyncThunk?.[asyncThunkSymbol];
  return function createSlice2(options2) {
    const {
      name: name2,
      reducerPath = name2
    } = options2;
    if (!name2) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(11) : "`name` is a required option for createSlice");
    }
    if (typeof process !== "undefined" && process.env.NODE_ENV === "development") {
      if (options2.initialState === void 0) {
        console.error("You must provide an `initialState` value that is not `undefined`. You may have misspelled `initialState`");
      }
    }
    const reducers = (typeof options2.reducers === "function" ? options2.reducers(buildReducerCreators()) : options2.reducers) || {};
    const reducerNames = Object.keys(reducers);
    const context = {
      sliceCaseReducersByName: {},
      sliceCaseReducersByType: {},
      actionCreators: {},
      sliceMatchers: []
    };
    const contextMethods = {
      addCase(typeOrActionCreator, reducer2) {
        const type = typeof typeOrActionCreator === "string" ? typeOrActionCreator : typeOrActionCreator.type;
        if (!type) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(12) : "`context.addCase` cannot be called with an empty action type");
        }
        if (type in context.sliceCaseReducersByType) {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(13) : "`context.addCase` cannot be called with two reducers for the same action type: " + type);
        }
        context.sliceCaseReducersByType[type] = reducer2;
        return contextMethods;
      },
      addMatcher(matcher2, reducer2) {
        context.sliceMatchers.push({
          matcher: matcher2,
          reducer: reducer2
        });
        return contextMethods;
      },
      exposeAction(name22, actionCreator) {
        context.actionCreators[name22] = actionCreator;
        return contextMethods;
      },
      exposeCaseReducer(name22, reducer2) {
        context.sliceCaseReducersByName[name22] = reducer2;
        return contextMethods;
      }
    };
    reducerNames.forEach((reducerName) => {
      const reducerDefinition = reducers[reducerName];
      const reducerDetails = {
        reducerName,
        type: getType(name2, reducerName),
        createNotation: typeof options2.reducers === "function"
      };
      if (isAsyncThunkSliceReducerDefinition(reducerDefinition)) {
        handleThunkCaseReducerDefinition(reducerDetails, reducerDefinition, contextMethods, cAT);
      } else {
        handleNormalReducerDefinition(reducerDetails, reducerDefinition, contextMethods);
      }
    });
    function buildReducer() {
      if (process.env.NODE_ENV !== "production") {
        if (typeof options2.extraReducers === "object") {
          throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(14) : "The object notation for `createSlice.extraReducers` has been removed. Please use the 'builder callback' notation instead: https://redux-toolkit.js.org/api/createSlice");
        }
      }
      const [extraReducers = {}, actionMatchers = [], defaultCaseReducer = void 0] = typeof options2.extraReducers === "function" ? executeReducerBuilderCallback(options2.extraReducers) : [options2.extraReducers];
      const finalCaseReducers = {
        ...extraReducers,
        ...context.sliceCaseReducersByType
      };
      return createReducer(options2.initialState, (builder) => {
        for (let key in finalCaseReducers) {
          builder.addCase(key, finalCaseReducers[key]);
        }
        for (let sM of context.sliceMatchers) {
          builder.addMatcher(sM.matcher, sM.reducer);
        }
        for (let m2 of actionMatchers) {
          builder.addMatcher(m2.matcher, m2.reducer);
        }
        if (defaultCaseReducer) {
          builder.addDefaultCase(defaultCaseReducer);
        }
      });
    }
    const selectSelf = (state) => state;
    const injectedSelectorCache = /* @__PURE__ */ new Map();
    const injectedStateCache = /* @__PURE__ */ new WeakMap();
    let _reducer;
    function reducer(state, action) {
      if (!_reducer) _reducer = buildReducer();
      return _reducer(state, action);
    }
    function getInitialState() {
      if (!_reducer) _reducer = buildReducer();
      return _reducer.getInitialState();
    }
    function makeSelectorProps(reducerPath2, injected = false) {
      function selectSlice(state) {
        let sliceState = state[reducerPath2];
        if (typeof sliceState === "undefined") {
          if (injected) {
            sliceState = getOrInsertComputed$1(injectedStateCache, selectSlice, getInitialState);
          } else if (process.env.NODE_ENV !== "production") {
            throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(15) : "selectSlice returned undefined for an uninjected slice reducer");
          }
        }
        return sliceState;
      }
      function getSelectors(selectState = selectSelf) {
        const selectorCache = getOrInsertComputed$1(injectedSelectorCache, injected, () => /* @__PURE__ */ new WeakMap());
        return getOrInsertComputed$1(selectorCache, selectState, () => {
          const map2 = {};
          for (const [name22, selector2] of Object.entries(options2.selectors ?? {})) {
            map2[name22] = wrapSelector(selector2, selectState, () => getOrInsertComputed$1(injectedStateCache, selectState, getInitialState), injected);
          }
          return map2;
        });
      }
      return {
        reducerPath: reducerPath2,
        getSelectors,
        get selectors() {
          return getSelectors(selectSlice);
        },
        selectSlice
      };
    }
    const slice2 = {
      name: name2,
      reducer,
      actions: context.actionCreators,
      caseReducers: context.sliceCaseReducersByName,
      getInitialState,
      ...makeSelectorProps(reducerPath),
      injectInto(injectable, {
        reducerPath: pathOpt,
        ...config2
      } = {}) {
        const newReducerPath = pathOpt ?? reducerPath;
        injectable.inject({
          reducerPath: newReducerPath,
          reducer
        }, config2);
        return {
          ...slice2,
          ...makeSelectorProps(newReducerPath, true)
        };
      }
    };
    return slice2;
  };
}
function wrapSelector(selector2, selectState, getInitialState, injected) {
  function wrapper(rootState, ...args) {
    let sliceState = selectState(rootState);
    if (typeof sliceState === "undefined") {
      if (injected) {
        sliceState = getInitialState();
      } else if (process.env.NODE_ENV !== "production") {
        throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(16) : "selectState returned undefined for an uninjected slice reducer");
      }
    }
    return selector2(sliceState, ...args);
  }
  wrapper.unwrapped = selector2;
  return wrapper;
}
var createSlice = /* @__PURE__ */ buildCreateSlice();
function buildReducerCreators() {
  function asyncThunk(payloadCreator, config2) {
    return {
      _reducerDefinitionType: "asyncThunk",
      payloadCreator,
      ...config2
    };
  }
  asyncThunk.withTypes = () => asyncThunk;
  return {
    reducer(caseReducer) {
      return Object.assign({
        // hack so the wrapping function has the same name as the original
        // we need to create a wrapper so the `reducerDefinitionType` is not assigned to the original
        [caseReducer.name](...args) {
          return caseReducer(...args);
        }
      }[caseReducer.name], {
        _reducerDefinitionType: "reducer"
        /* reducer */
      });
    },
    preparedReducer(prepare, reducer) {
      return {
        _reducerDefinitionType: "reducerWithPrepare",
        prepare,
        reducer
      };
    },
    asyncThunk
  };
}
function handleNormalReducerDefinition({
  type,
  reducerName,
  createNotation
}, maybeReducerWithPrepare, context) {
  let caseReducer;
  let prepareCallback;
  if ("reducer" in maybeReducerWithPrepare) {
    if (createNotation && !isCaseReducerWithPrepareDefinition(maybeReducerWithPrepare)) {
      throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(17) : "Please use the `create.preparedReducer` notation for prepared action creators with the `create` notation.");
    }
    caseReducer = maybeReducerWithPrepare.reducer;
    prepareCallback = maybeReducerWithPrepare.prepare;
  } else {
    caseReducer = maybeReducerWithPrepare;
  }
  context.addCase(type, caseReducer).exposeCaseReducer(reducerName, caseReducer).exposeAction(reducerName, prepareCallback ? createAction(type, prepareCallback) : createAction(type));
}
function isAsyncThunkSliceReducerDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "asyncThunk";
}
function isCaseReducerWithPrepareDefinition(reducerDefinition) {
  return reducerDefinition._reducerDefinitionType === "reducerWithPrepare";
}
function handleThunkCaseReducerDefinition({
  type,
  reducerName
}, reducerDefinition, context, cAT) {
  if (!cAT) {
    throw new Error(process.env.NODE_ENV === "production" ? formatProdErrorMessage(18) : "Cannot use `create.asyncThunk` in the built-in `createSlice`. Use `buildCreateSlice({ creators: { asyncThunk: asyncThunkCreator } })` to create a customised version of `createSlice`.");
  }
  const {
    payloadCreator,
    fulfilled,
    pending,
    rejected,
    settled,
    options: options2
  } = reducerDefinition;
  const thunk2 = cAT(type, payloadCreator, options2);
  context.exposeAction(reducerName, thunk2);
  if (fulfilled) {
    context.addCase(thunk2.fulfilled, fulfilled);
  }
  if (pending) {
    context.addCase(thunk2.pending, pending);
  }
  if (rejected) {
    context.addCase(thunk2.rejected, rejected);
  }
  if (settled) {
    context.addMatcher(thunk2.settled, settled);
  }
  context.exposeCaseReducer(reducerName, {
    fulfilled: fulfilled || noop$5,
    pending: pending || noop$5,
    rejected: rejected || noop$5,
    settled: settled || noop$5
  });
}
function noop$5() {
}
function formatProdErrorMessage(code2) {
  return `Minified Redux Toolkit error #${code2}; visit https://redux-toolkit.js.org/Errors?code=${code2} for the full message or use the non-minified dev environment for full errors. `;
}
var withSelector = { exports: {} };
var useSyncExternalStoreWithSelector_production = {};
var hasRequiredUseSyncExternalStoreWithSelector_production;
function requireUseSyncExternalStoreWithSelector_production() {
  if (hasRequiredUseSyncExternalStoreWithSelector_production) return useSyncExternalStoreWithSelector_production;
  hasRequiredUseSyncExternalStoreWithSelector_production = 1;
  var React2 = React__default;
  function is2(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
  useSyncExternalStoreWithSelector_production.useSyncExternalStoreWithSelector = function(subscribe2, getSnapshot, getServerSnapshot, selector2, isEqual2) {
    var instRef = useRef2(null);
    if (null === instRef.current) {
      var inst = { hasValue: false, value: null };
      instRef.current = inst;
    } else inst = instRef.current;
    instRef = useMemo2(
      function() {
        function memoizedSelector(nextSnapshot) {
          if (!hasMemo) {
            hasMemo = true;
            memoizedSnapshot = nextSnapshot;
            nextSnapshot = selector2(nextSnapshot);
            if (void 0 !== isEqual2 && inst.hasValue) {
              var currentSelection = inst.value;
              if (isEqual2(currentSelection, nextSnapshot))
                return memoizedSelection = currentSelection;
            }
            return memoizedSelection = nextSnapshot;
          }
          currentSelection = memoizedSelection;
          if (objectIs(memoizedSnapshot, nextSnapshot)) return currentSelection;
          var nextSelection = selector2(nextSnapshot);
          if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
            return memoizedSnapshot = nextSnapshot, currentSelection;
          memoizedSnapshot = nextSnapshot;
          return memoizedSelection = nextSelection;
        }
        var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
        return [
          function() {
            return memoizedSelector(getSnapshot());
          },
          null === maybeGetServerSnapshot ? void 0 : function() {
            return memoizedSelector(maybeGetServerSnapshot());
          }
        ];
      },
      [getSnapshot, getServerSnapshot, selector2, isEqual2]
    );
    var value = useSyncExternalStore2(subscribe2, instRef[0], instRef[1]);
    useEffect2(
      function() {
        inst.hasValue = true;
        inst.value = value;
      },
      [value]
    );
    useDebugValue(value);
    return value;
  };
  return useSyncExternalStoreWithSelector_production;
}
var useSyncExternalStoreWithSelector_development = {};
var hasRequiredUseSyncExternalStoreWithSelector_development;
function requireUseSyncExternalStoreWithSelector_development() {
  if (hasRequiredUseSyncExternalStoreWithSelector_development) return useSyncExternalStoreWithSelector_development;
  hasRequiredUseSyncExternalStoreWithSelector_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useSyncExternalStore2 = React2.useSyncExternalStore, useRef2 = React2.useRef, useEffect2 = React2.useEffect, useMemo2 = React2.useMemo, useDebugValue = React2.useDebugValue;
    useSyncExternalStoreWithSelector_development.useSyncExternalStoreWithSelector = function(subscribe2, getSnapshot, getServerSnapshot, selector2, isEqual2) {
      var instRef = useRef2(null);
      if (null === instRef.current) {
        var inst = { hasValue: false, value: null };
        instRef.current = inst;
      } else inst = instRef.current;
      instRef = useMemo2(
        function() {
          function memoizedSelector(nextSnapshot) {
            if (!hasMemo) {
              hasMemo = true;
              memoizedSnapshot = nextSnapshot;
              nextSnapshot = selector2(nextSnapshot);
              if (void 0 !== isEqual2 && inst.hasValue) {
                var currentSelection = inst.value;
                if (isEqual2(currentSelection, nextSnapshot))
                  return memoizedSelection = currentSelection;
              }
              return memoizedSelection = nextSnapshot;
            }
            currentSelection = memoizedSelection;
            if (objectIs(memoizedSnapshot, nextSnapshot))
              return currentSelection;
            var nextSelection = selector2(nextSnapshot);
            if (void 0 !== isEqual2 && isEqual2(currentSelection, nextSelection))
              return memoizedSnapshot = nextSnapshot, currentSelection;
            memoizedSnapshot = nextSnapshot;
            return memoizedSelection = nextSelection;
          }
          var hasMemo = false, memoizedSnapshot, memoizedSelection, maybeGetServerSnapshot = void 0 === getServerSnapshot ? null : getServerSnapshot;
          return [
            function() {
              return memoizedSelector(getSnapshot());
            },
            null === maybeGetServerSnapshot ? void 0 : function() {
              return memoizedSelector(maybeGetServerSnapshot());
            }
          ];
        },
        [getSnapshot, getServerSnapshot, selector2, isEqual2]
      );
      var value = useSyncExternalStore2(subscribe2, instRef[0], instRef[1]);
      useEffect2(
        function() {
          inst.hasValue = true;
          inst.value = value;
        },
        [value]
      );
      useDebugValue(value);
      return value;
    };
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreWithSelector_development;
}
var hasRequiredWithSelector;
function requireWithSelector() {
  if (hasRequiredWithSelector) return withSelector.exports;
  hasRequiredWithSelector = 1;
  if (process.env.NODE_ENV === "production") {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_production();
  } else {
    withSelector.exports = requireUseSyncExternalStoreWithSelector_development();
  }
  return withSelector.exports;
}
var withSelectorExports = requireWithSelector();
function defaultNoopBatch(callback) {
  callback();
}
function createListenerCollection() {
  let first2 = null;
  let last2 = null;
  return {
    clear() {
      first2 = null;
      last2 = null;
    },
    notify() {
      defaultNoopBatch(() => {
        let listener = first2;
        while (listener) {
          listener.callback();
          listener = listener.next;
        }
      });
    },
    get() {
      const listeners = [];
      let listener = first2;
      while (listener) {
        listeners.push(listener);
        listener = listener.next;
      }
      return listeners;
    },
    subscribe(callback) {
      let isSubscribed = true;
      const listener = last2 = {
        callback,
        next: null,
        prev: last2
      };
      if (listener.prev) {
        listener.prev.next = listener;
      } else {
        first2 = listener;
      }
      return function unsubscribe() {
        if (!isSubscribed || first2 === null) return;
        isSubscribed = false;
        if (listener.next) {
          listener.next.prev = listener.prev;
        } else {
          last2 = listener.prev;
        }
        if (listener.prev) {
          listener.prev.next = listener.next;
        } else {
          first2 = listener.next;
        }
      };
    }
  };
}
var nullListeners = {
  notify() {
  },
  get: () => []
};
function createSubscription(store2, parentSub) {
  let unsubscribe;
  let listeners = nullListeners;
  let subscriptionsAmount = 0;
  let selfSubscribed = false;
  function addNestedSub(listener) {
    trySubscribe();
    const cleanupListener = listeners.subscribe(listener);
    let removed = false;
    return () => {
      if (!removed) {
        removed = true;
        cleanupListener();
        tryUnsubscribe();
      }
    };
  }
  function notifyNestedSubs() {
    listeners.notify();
  }
  function handleChangeWrapper() {
    if (subscription.onStateChange) {
      subscription.onStateChange();
    }
  }
  function isSubscribed() {
    return selfSubscribed;
  }
  function trySubscribe() {
    subscriptionsAmount++;
    if (!unsubscribe) {
      unsubscribe = store2.subscribe(handleChangeWrapper);
      listeners = createListenerCollection();
    }
  }
  function tryUnsubscribe() {
    subscriptionsAmount--;
    if (unsubscribe && subscriptionsAmount === 0) {
      unsubscribe();
      unsubscribe = void 0;
      listeners.clear();
      listeners = nullListeners;
    }
  }
  function trySubscribeSelf() {
    if (!selfSubscribed) {
      selfSubscribed = true;
      trySubscribe();
    }
  }
  function tryUnsubscribeSelf() {
    if (selfSubscribed) {
      selfSubscribed = false;
      tryUnsubscribe();
    }
  }
  const subscription = {
    addNestedSub,
    notifyNestedSubs,
    handleChangeWrapper,
    isSubscribed,
    trySubscribe: trySubscribeSelf,
    tryUnsubscribe: tryUnsubscribeSelf,
    getListeners: () => listeners
  };
  return subscription;
}
var canUseDOM$3 = () => !!(typeof window !== "undefined" && typeof window.document !== "undefined" && typeof window.document.createElement !== "undefined");
var isDOM = /* @__PURE__ */ canUseDOM$3();
var isRunningInReactNative = () => typeof navigator !== "undefined" && navigator.product === "ReactNative";
var isReactNative = /* @__PURE__ */ isRunningInReactNative();
var getUseIsomorphicLayoutEffect = () => isDOM || isReactNative ? React.useLayoutEffect : React.useEffect;
var useIsomorphicLayoutEffect$1 = /* @__PURE__ */ getUseIsomorphicLayoutEffect();
var ContextKey = /* @__PURE__ */ Symbol.for(`react-redux-context`);
var gT = typeof globalThis !== "undefined" ? globalThis : (
  /* fall back to a per-module scope (pre-8.1 behaviour) if `globalThis` is not available */
  {}
);
function getContext() {
  if (!React.createContext) return {};
  const contextMap = gT[ContextKey] ??= /* @__PURE__ */ new Map();
  let realContext = contextMap.get(React.createContext);
  if (!realContext) {
    realContext = React.createContext(
      null
    );
    if (process.env.NODE_ENV !== "production") {
      realContext.displayName = "ReactRedux";
    }
    contextMap.set(React.createContext, realContext);
  }
  return realContext;
}
var ReactReduxContext = /* @__PURE__ */ getContext();
function Provider(providerProps) {
  const { children, context, serverState, store: store2 } = providerProps;
  const contextValue = React.useMemo(() => {
    const subscription = createSubscription(store2);
    const baseContextValue = {
      store: store2,
      subscription,
      getServerState: serverState ? () => serverState : void 0
    };
    if (process.env.NODE_ENV === "production") {
      return baseContextValue;
    } else {
      const { identityFunctionCheck = "once", stabilityCheck = "once" } = providerProps;
      return /* @__PURE__ */ Object.assign(baseContextValue, {
        stabilityCheck,
        identityFunctionCheck
      });
    }
  }, [store2, serverState]);
  const previousState = React.useMemo(() => store2.getState(), [store2]);
  useIsomorphicLayoutEffect$1(() => {
    const { subscription } = contextValue;
    subscription.onStateChange = subscription.notifyNestedSubs;
    subscription.trySubscribe();
    if (previousState !== store2.getState()) {
      subscription.notifyNestedSubs();
    }
    return () => {
      subscription.tryUnsubscribe();
      subscription.onStateChange = void 0;
    };
  }, [contextValue, previousState]);
  const Context2 = context || ReactReduxContext;
  return /* @__PURE__ */ React.createElement(Context2.Provider, { value: contextValue }, children);
}
var Provider_default = Provider;
function createReduxContextHook(context = ReactReduxContext) {
  return function useReduxContext2() {
    const contextValue = React.useContext(context);
    if (process.env.NODE_ENV !== "production" && !contextValue) {
      throw new Error(
        "could not find react-redux context value; please ensure the component is wrapped in a <Provider>"
      );
    }
    return contextValue;
  };
}
var useReduxContext = /* @__PURE__ */ createReduxContextHook();
function createStoreHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : (
    // @ts-ignore
    createReduxContextHook(context)
  );
  const useStore2 = () => {
    const { store: store2 } = useReduxContext2();
    return store2;
  };
  Object.assign(useStore2, {
    withTypes: () => useStore2
  });
  return useStore2;
}
var useStore$3 = /* @__PURE__ */ createStoreHook();
function createDispatchHook(context = ReactReduxContext) {
  const useStore2 = context === ReactReduxContext ? useStore$3 : createStoreHook(context);
  const useDispatch2 = () => {
    const store2 = useStore2();
    return store2.dispatch;
  };
  Object.assign(useDispatch2, {
    withTypes: () => useDispatch2
  });
  return useDispatch2;
}
var useDispatch = /* @__PURE__ */ createDispatchHook();
var refEquality = (a2, b2) => a2 === b2;
function createSelectorHook(context = ReactReduxContext) {
  const useReduxContext2 = context === ReactReduxContext ? useReduxContext : createReduxContextHook(context);
  const useSelector2 = (selector2, equalityFnOrOptions = {}) => {
    const { equalityFn = refEquality } = typeof equalityFnOrOptions === "function" ? { equalityFn: equalityFnOrOptions } : equalityFnOrOptions;
    if (process.env.NODE_ENV !== "production") {
      if (!selector2) {
        throw new Error(`You must pass a selector to useSelector`);
      }
      if (typeof selector2 !== "function") {
        throw new Error(`You must pass a function as a selector to useSelector`);
      }
      if (typeof equalityFn !== "function") {
        throw new Error(
          `You must pass a function as an equality function to useSelector`
        );
      }
    }
    const reduxContext = useReduxContext2();
    const { store: store2, subscription, getServerState } = reduxContext;
    const firstRun = React.useRef(true);
    const wrappedSelector = React.useCallback(
      {
        [selector2.name](state) {
          const selected = selector2(state);
          if (process.env.NODE_ENV !== "production") {
            const { devModeChecks = {} } = typeof equalityFnOrOptions === "function" ? {} : equalityFnOrOptions;
            const { identityFunctionCheck, stabilityCheck } = reduxContext;
            const {
              identityFunctionCheck: finalIdentityFunctionCheck,
              stabilityCheck: finalStabilityCheck
            } = {
              stabilityCheck,
              identityFunctionCheck,
              ...devModeChecks
            };
            if (finalStabilityCheck === "always" || finalStabilityCheck === "once" && firstRun.current) {
              const toCompare = selector2(state);
              if (!equalityFn(selected, toCompare)) {
                let stack = void 0;
                try {
                  throw new Error();
                } catch (e2) {
                  ({ stack } = e2);
                }
                console.warn(
                  "Selector " + (selector2.name || "unknown") + " returned a different result when called with the same parameters. This can lead to unnecessary rerenders.\nSelectors that return a new reference (such as an object or an array) should be memoized: https://redux.js.org/usage/deriving-data-selectors#optimizing-selectors-with-memoization",
                  {
                    state,
                    selected,
                    selected2: toCompare,
                    stack
                  }
                );
              }
            }
            if (finalIdentityFunctionCheck === "always" || finalIdentityFunctionCheck === "once" && firstRun.current) {
              if (selected === state) {
                let stack = void 0;
                try {
                  throw new Error();
                } catch (e2) {
                  ({ stack } = e2);
                }
                console.warn(
                  "Selector " + (selector2.name || "unknown") + " returned the root state when called. This can lead to unnecessary rerenders.\nSelectors that return the entire state are almost certainly a mistake, as they will cause a rerender whenever *anything* in state changes.",
                  { stack }
                );
              }
            }
            if (firstRun.current) firstRun.current = false;
          }
          return selected;
        }
      }[selector2.name],
      [selector2]
    );
    const selectedState = withSelectorExports.useSyncExternalStoreWithSelector(
      subscription.addNestedSub,
      store2.getState,
      getServerState || store2.getState,
      wrappedSelector,
      equalityFn
    );
    React.useDebugValue(selectedState);
    return selectedState;
  };
  Object.assign(useSelector2, {
    withTypes: () => useSelector2
  });
  return useSelector2;
}
var useSelector = /* @__PURE__ */ createSelectorHook();
const useAppDispatch = useDispatch.withTypes();
const useAppSelector = useSelector.withTypes();
const createLoggingAsyncThunk = (typePrefix, payloadCreator) => {
  const wrappedPayloadCreator = (async (...args) => {
    try {
      return await payloadCreator(...args);
    } catch (e2) {
      console.warn(e2);
      throw e2;
    }
  });
  return createAsyncThunk(typePrefix, wrappedPayloadCreator);
};
function actionIdentifier(actionId, componentIdx) {
  return `${actionId}|${componentIdx}`;
}
const initialState$1 = {
  componentInfo: {}
};
const mainSlice = createSlice({
  name: "main",
  // `createSlice` will infer the state type from the `initialState` argument
  initialState: initialState$1,
  reducers: {
    // Use the PayloadAction type to declare the contents of `action.payload`
    setComponentInfo: (state, action) => {
      let newVal = action.payload.componentInfo;
      state.componentInfo[action.payload.key] = newVal;
    }
  },
  selectors: {
    componentInfo: (state) => state.componentInfo
  }
});
const mainThunks = {
  /**
   * Updates the state variables for a specific component.
   */
  updateRendererSVs: createLoggingAsyncThunk(
    "main/updateRendererSVs",
    async ({
      coreId,
      componentIdx,
      stateValues,
      childrenInstructions,
      sourceOfUpdate,
      baseStateVariable,
      actionId,
      updatesToIgnoreRef,
      prefixForIds = ""
    }, { dispatch, getState }) => {
      let ignoreUpdate = false;
      let rendererName = coreId + componentIdx;
      if (baseStateVariable) {
        const updatesToIgnore = updatesToIgnoreRef.current;
        if (updatesToIgnore.size > 0) {
          let valueFromRenderer = updatesToIgnore.get(
            actionIdentifier(actionId || "", componentIdx)
          );
          let valueFromCore = stateValues[baseStateVariable];
          if (valueFromRenderer === valueFromCore || Array.isArray(valueFromRenderer) && Array.isArray(valueFromCore) && valueFromRenderer.length == valueFromCore.length && valueFromRenderer.every(
            (v2, i2) => valueFromCore[i2] === v2
          )) {
            ignoreUpdate = true;
            updatesToIgnore.delete(
              actionIdentifier(actionId || "", componentIdx)
            );
          } else {
            updatesToIgnore.clear();
          }
        }
      }
      let childrenInstructions2;
      if (childrenInstructions === void 0) {
        let previousRendererState = mainSlice.selectors.componentInfo(getState())[rendererName];
        childrenInstructions2 = previousRendererState?.childrenInstructions ?? null;
      } else {
        childrenInstructions2 = childrenInstructions;
      }
      let newRendererState = {
        stateValues,
        childrenInstructions: childrenInstructions2,
        sourceOfUpdate,
        ignoreUpdate,
        prefixForIds
      };
      dispatch(
        mainSlice.actions.setComponentInfo({
          key: rendererName,
          componentInfo: newRendererState
        })
      );
    }
  )
};
const initialState = {
  keyboardInput: []
};
const keyboardSlice = createSlice({
  name: "keyboard",
  initialState,
  reducers: {
    setKeyboardInput: (state, action) => {
      state.keyboardInput = action.payload;
    },
    clearKeyboardInput: (state) => {
      state.keyboardInput = [];
    }
  },
  selectors: {
    keyboardInput: (state) => state.keyboardInput
  }
});
const store = configureStore({
  reducer: {
    main: mainSlice.reducer,
    keyboard: keyboardSlice.reducer
  }
});
function isTransientDynamicImportError(error) {
  const message = error instanceof Error ? error.message : String(error);
  return /Failed to fetch dynamically imported module/i.test(message) || /Importing a module script failed/i.test(message) || /error loading dynamically imported module/i.test(message) || /dynamically imported module/i.test(message);
}
async function importRendererWithRetry(loader, name2, retries = 3, initialDelayMs = 100) {
  let remaining = retries;
  let delayMs = initialDelayMs;
  for (; ; ) {
    try {
      return await loader();
    } catch (error) {
      if (remaining === 0 || !isTransientDynamicImportError(error)) {
        throw error;
      }
      console.warn(
        `Transient failure loading renderer "${name2}" — retrying (${remaining} left).`,
        error
      );
      await new Promise((resolve) => setTimeout(resolve, delayMs));
      remaining -= 1;
      delayMs *= 2;
    }
  }
}
function RendererLoadFailed(props2) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    "div",
    {
      id: props2.componentInstructions?.id,
      role: "alert",
      style: {
        backgroundColor: "var(--lightRed)",
        color: "var(--canvasText)",
        borderWidth: 3,
        borderStyle: "solid",
        borderColor: "var(--mainRed)",
        padding: "0.5em",
        textAlign: "center"
      },
      children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("b", { children: "Error" }),
        ": a renderer failed to load. Please reload the page."
      ]
    }
  );
}
async function renderersLoadComponent(loaders, rendererClassNames) {
  const settled = await Promise.all(
    loaders.map((loader, index2) => {
      const name2 = rendererClassNames[index2];
      return importRendererWithRetry(loader, name2).then(
        (module) => ({ name: name2, component: module.default }),
        (error) => {
          console.error(
            `Failed to load renderer "${name2}" after retries:`,
            error
          );
          return { name: name2, component: RendererLoadFailed };
        }
      );
    })
  );
  const rendererClasses = {};
  const failedRenderers = [];
  for (const { name: name2, component } of settled) {
    rendererClasses[name2] = component;
    if (component === RendererLoadFailed) {
      failedRenderers.push(name2);
    }
  }
  return { rendererClasses, failedRenderers };
}
const DEFAULT_CORE_BOOT_MAX_ATTEMPTS = 3;
const DEFAULT_CORE_HANDSHAKE_WATCHDOG_MS = 15e3;
const CORE_BOOT_RETRY_DELAY_MS = 250;
const GRACEFUL_TERMINATE_TIMEOUT_MS = 2e3;
const CORE_START_FAILED_MESSAGE = "The document viewer could not be started. Please reload the page.";
function withTimeout(task, ms, label2) {
  return new Promise((resolve, reject2) => {
    let settled = false;
    const timer = setTimeout(() => {
      if (!settled) {
        settled = true;
        reject2(new Error(`${label2} timed out after ${ms}ms`));
      }
    }, ms);
    task().then(
      (value) => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          resolve(value);
        }
      },
      (err) => {
        if (!settled) {
          settled = true;
          clearTimeout(timer);
          reject2(err);
        }
      }
    );
  });
}
async function disposeCoreWorker(remote, kill, { graceful }) {
  let suspectWedge = !graceful;
  if (graceful && remote) {
    try {
      await withTimeout(
        () => remote.terminate(),
        GRACEFUL_TERMINATE_TIMEOUT_MS,
        "core worker graceful terminate"
      );
    } catch {
      suspectWedge = true;
    }
  }
  try {
    kill?.(suspectWedge);
  } catch {
  }
}
const DocContext = createContext({});
function DocViewer({
  doenetML,
  userId,
  activityId = "a",
  docId = "1",
  render = true,
  hidden = false,
  attemptNumber = 1,
  forceDisable = false,
  forceShowCorrectness = false,
  forceShowSolution = false,
  forceUnsuppressCheckWork = false,
  generatedVariantCallback,
  flags,
  requestedVariantIndex,
  initialState: initialState2,
  setDiagnosticsCallback,
  reportScoreAndStateCallback: specifiedReportScoreAndStateCallback,
  documentStructureCallback,
  initializedCallback,
  setIsInErrorState,
  prefixForIds = "",
  doenetViewerUrl,
  doenetImagesUrl,
  darkMode,
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  initializeCounters: prescribedInitializeCounters = {},
  fetchExternalDoenetML,
  requestScrollTo
}) {
  const updatesToIgnoreRef = useRef(
    /* @__PURE__ */ new Map()
  );
  const dispatch = useAppDispatch();
  const [errMsg, setErrMsg] = useState(null);
  const cid = useRef(null);
  const lastDoenetML = useRef(null);
  const lastActivityId = useRef(null);
  const lastDocId = useRef(null);
  const lastAttemptNumber = useRef(null);
  const lastRequestedVariantIndex = useRef(null);
  const [stage, setStage] = useState("initial");
  const [documentRenderer, setDocumentRenderer] = useState(null);
  const initialCoreData = useRef(null);
  const initializeCounters = useRef(
    prescribedInitializeCounters
  );
  useEffect(() => {
    initializeCounters.current = prescribedInitializeCounters;
  }, [prescribedInitializeCounters]);
  const rendererClasses = useRef({});
  const coreInfo = useRef(null);
  const loadedInitialRendererState = useRef(false);
  const coreCreated = useRef(false);
  const coreCreationInProgress = useRef(false);
  const coreId = useRef("");
  const diagnostics = useRef([]);
  const [hasInitialError, setHasInitialError] = useState(false);
  const actionsBeforeCoreCreated = useRef([]);
  const preventMoreAnimations = useRef(false);
  const animationInfo = useRef({});
  const onActionCallbacks = useRef(
    /* @__PURE__ */ new Map()
  );
  const lastSkippableAction = useRef(null);
  const messageIdFromGetState = useRef(null);
  const requestSolutionViewPromises = useRef({});
  const errorInitializingRenderers = useRef(false);
  const errorInsideRenderers = useRef(false);
  const [ignoreRendererError, setIgnoreRendererError] = useState(false);
  const coreWorker = useRef(null);
  const coreWorkerKill = useRef(
    null
  );
  function attachNewCoreWorker() {
    const { remote, kill } = createCoreWorker();
    coreWorker.current = remote;
    coreWorkerKill.current = kill;
    return remote;
  }
  function teardownCurrentCoreWorker({ graceful }) {
    const remote = coreWorker.current;
    const kill = coreWorkerKill.current;
    coreWorker.current = null;
    coreWorkerKill.current = null;
    return disposeCoreWorker(remote, kill, { graceful });
  }
  function clearDeferredCoreActions() {
    actionsBeforeCoreCreated.current = [];
  }
  function takeDeferredCoreActions() {
    const pendingActions = actionsBeforeCoreCreated.current;
    clearDeferredCoreActions();
    return pendingActions;
  }
  const contextForRenderers = {
    doenetViewerUrl,
    doenetImagesUrl,
    darkMode,
    showAnswerResponseButton,
    answerResponseCounts
  };
  useEffect(() => {
    return () => {
      teardownCurrentCoreWorker({ graceful: true }).catch((e2) => {
        console.warn("DocViewer: core worker teardown failed", e2);
      });
      coreCreated.current = false;
    };
  }, []);
  useEffect(() => {
    const listener = async function(e2) {
      if (e2.origin !== window.location.origin && e2.origin !== window.parent.location.origin) {
        return;
      }
      if (typeof e2.data !== "object") {
        return;
      }
      if (e2.data.subject === "SPLICE.getState.response") {
        if (messageIdFromGetState.current === e2.data.message_id) {
          if (e2.data.state && e2.data.state.cid === cid.current) {
            if (errMsg !== null) {
              setErrMsg(null);
              setIsInErrorState?.(false);
            }
            coreId.current = nanoid$1();
            initialCoreData.current = null;
            coreInfo.current = null;
            setDocumentRenderer(null);
            coreCreated.current = false;
            coreCreationInProgress.current = false;
            loadedInitialRendererState.current = false;
            processLoadedDocState(e2.data.state);
            if (render) {
              startCoreSafely();
            } else {
              setStage("readyToCreateCore");
            }
          }
        } else if (e2.data.error) {
          const error = e2.data.error;
          setIsInErrorState?.(true);
          if (typeof error === "object" && "code" in error && "message" in error) {
            console.log(
              `error ${error.code} getting state: ${error.message}`
            );
            setErrMsg(error.message);
          } else {
            setErrMsg("Invalid response to getState");
          }
        }
      } else if (e2.data.subject === "SPLICE.requestSolutionView.response") {
        let promiseInfo = requestSolutionViewPromises.current[e2.data.messageId];
        if (!promiseInfo) {
          return;
        }
        promiseInfo.resolve({ allowView: e2.data.allowView === true });
      } else if (e2.data.subject === "SPLICE.submitAllAnswers") {
        if (coreInfo.current) {
          const actionResult = await callAction({
            action: {
              actionName: "submitAllAnswers",
              componentIdx: coreInfo.current.documentToRender.componentIdx
            },
            args: {}
          });
          const message = {
            subject: "SPLICE.submitAllAnswers.response",
            success: actionResult
          };
          if (flags.messageParent && window.parent) {
            window.parent.postMessage(message);
          } else {
            window.postMessage(message);
          }
        }
      } else if (e2.data.subject === "SPLICE.flushState") {
        const message = {
          subject: "SPLICE.flushState.response",
          activity_id: activityId,
          doc_id: docId,
          message_id: e2.data.message_id,
          success: true,
          hadState: false
        };
        if (coreCreated.current && coreWorker.current) {
          try {
            message.hadState = await coreWorker.current.flushState();
          } catch (err) {
            console.warn("DocViewer: flushState failed", err);
            message.success = false;
          }
        }
        if (flags.messageParent && window.parent) {
          window.parent.postMessage(message);
        } else {
          window.postMessage(message);
        }
      }
    };
    window.addEventListener("message", listener);
    return () => {
      window.removeEventListener("message", listener);
    };
  }, []);
  useEffect(() => {
    if (!coreWorker.current) {
      return;
    }
    if (docId !== null) {
      const postfixForWindowFunctions = prefixForIds.replaceAll("::", "").replaceAll(":", "_").replaceAll(".", "_").replaceAll("-", "_") || "1";
      window["returnAllStateVariables" + postfixForWindowFunctions] = async function() {
        const allStateVariables = await coreWorker.current?.returnAllStateVariables(true);
        console.log(allStateVariables);
        return allStateVariables;
      };
      window["returnDiagnostics" + postfixForWindowFunctions] = function() {
        return diagnostics.current;
      };
      window["callAction" + postfixForWindowFunctions] = async function({
        actionName,
        componentIdx,
        args
      }) {
        return await callAction({
          action: { actionName, componentIdx },
          args
        });
      };
      window["resolvePath" + postfixForWindowFunctions] = async function(name2, origin = 0) {
        if (coreWorker.current) {
          return await coreWorker.current.resolvePathJavascript(
            name2,
            origin
          );
        } else {
          console.error("No core worker present");
          return -1;
        }
      };
    }
  }, [docId, coreWorker.current, prefixForIds]);
  useEffect(() => {
    return () => {
      preventMoreAnimations.current = true;
      for (let id2 in animationInfo.current) {
        cancelAnimationFrame2(id2);
      }
      animationInfo.current = {};
    };
  }, []);
  useEffect(() => {
    if (!coreWorker.current) {
      return;
    }
    function documentVisibilityListener() {
      coreWorker.current?.handleVisibilityChange(
        document.visibilityState === "visible"
      );
    }
    document.addEventListener(
      "visibilitychange",
      documentVisibilityListener
    );
    return () => {
      document.removeEventListener(
        "visibilitychange",
        documentVisibilityListener
      );
    };
  }, [coreWorker.current]);
  useEffect(() => {
    callAction({
      action: { actionName: "setTheme" },
      args: { theme: darkMode, doNotIgnore: true }
    });
  }, [darkMode]);
  async function reinitializeCoreAndTerminateAnimations() {
    if (coreWorker.current !== null) {
      preventMoreAnimations.current = true;
      await teardownCurrentCoreWorker({ graceful: true });
      clearDeferredCoreActions();
      for (let id2 in animationInfo.current) {
        cancelAnimationFrame2(id2);
      }
      animationInfo.current = {};
    }
    const remote = attachNewCoreWorker();
    coreCreated.current = false;
    coreCreationInProgress.current = false;
    await initializeCoreWorker({
      coreWorker: remote,
      doenetML,
      flags,
      activityId,
      docId,
      requestedVariantIndex,
      attemptNumber,
      documentStructureCallback,
      fetchExternalDoenetML
    });
    return remote;
  }
  function callAction({
    action,
    args,
    baseVariableValue,
    componentIdx,
    rendererType,
    promiseResolve
  }) {
    let ignoreActionsWithoutCore = rendererClasses.current[rendererType ?? ""]?.ignoreActionsWithoutCore || rendererClasses.current[rendererType ?? ""]?.type?.ignoreActionsWithoutCore;
    if (!coreCreated.current && (ignoreActionsWithoutCore?.(action.actionName) || !coreCreationInProgress.current) && !args?.doNotIgnore) {
      if (promiseResolve) {
        promiseResolve(false);
        return;
      } else {
        return Promise.resolve(false);
      }
    }
    if (lastSkippableAction.current) {
      lastSkippableAction.current.promiseResolve?.(false);
      lastSkippableAction.current = null;
    }
    if (args?.skippable) {
      if (onActionCallbacks.current.size > 0) {
        let newPromise;
        if (!promiseResolve) {
          newPromise = new Promise((resolve, reject2) => {
            promiseResolve = resolve;
          });
        }
        lastSkippableAction.current = {
          action,
          args,
          baseVariableValue,
          componentIdx,
          rendererType,
          promiseResolve
        };
        if (newPromise) {
          return newPromise;
        } else {
          return;
        }
      }
    }
    let actionId = nanoid$1();
    args = { ...args };
    args.actionId = actionId;
    if (baseVariableValue !== void 0 && componentIdx != null) {
      updatesToIgnoreRef.current.set(
        actionIdentifier(actionId, componentIdx),
        baseVariableValue
      );
    }
    let actionArgs = {
      actionName: action.actionName,
      componentIdx: action.componentIdx,
      args
    };
    executeAction(actionArgs).catch((e2) => {
      console.warn("DocViewer: executeAction failed", e2);
    });
    if (promiseResolve) {
      onActionCallbacks.current.set(actionId, promiseResolve);
      return;
    } else {
      return new Promise((resolve, reject2) => {
        onActionCallbacks.current.set(actionId, resolve);
      });
    }
  }
  async function executeAction(actionArgs) {
    if (!coreCreated.current) {
      actionsBeforeCoreCreated.current.push(actionArgs);
      return;
    }
    let actionResult;
    try {
      actionResult = await coreWorker.current?.dispatchActionJavascript(actionArgs);
    } catch (e2) {
      console.warn("DocViewer: dispatchActionJavascript failed", e2);
      resolveAction({
        actionId: actionArgs.args?.actionId,
        success: false
      });
      return;
    }
    if (actionResult) {
      resolveAction(actionResult);
    } else {
      resolveAction({
        actionId: actionArgs.args?.actionId,
        success: false
      });
    }
  }
  function forceRendererState({
    rendererState,
    forceDisable: forceDisable2,
    forceShowCorrectness: forceShowCorrectness2,
    forceShowSolution: forceShowSolution2,
    forceUnsuppressCheckWork: forceUnsuppressCheckWork2
  }) {
    for (let componentIdx in rendererState) {
      let stateValues = rendererState[componentIdx].stateValues;
      if (forceDisable2 && stateValues.disabled === false) {
        stateValues.disabled = true;
      }
      if (forceShowCorrectness2 && stateValues.showCorrectness === false) {
        stateValues.showCorrectness = true;
      }
      if (forceUnsuppressCheckWork2 && stateValues.suppressCheckWork === true) {
        stateValues.suppressCheckWork = false;
      }
      if (forceShowSolution2 && rendererState[componentIdx].childrenInstructions?.length > 0) {
        for (let childInst of rendererState[componentIdx].childrenInstructions) {
          if (childInst?.componentType === "solution") {
            let solComponentIdx = childInst.componentIdx;
            if (rendererState[solComponentIdx].stateValues.hidden) {
              rendererState[solComponentIdx].stateValues.hidden = false;
            }
          }
        }
      }
    }
  }
  function initializeRenderers(args) {
    if (args.rendererState) {
      if (forceDisable || forceShowCorrectness || forceShowSolution || forceUnsuppressCheckWork) {
        forceRendererState({
          rendererState: args.rendererState,
          forceDisable,
          forceShowCorrectness,
          forceShowSolution,
          forceUnsuppressCheckWork
        });
      }
      for (let componentIdx in args.rendererState) {
        dispatch(
          mainThunks.updateRendererSVs({
            coreId: coreId.current,
            componentIdx,
            stateValues: args.rendererState[componentIdx].stateValues,
            childrenInstructions: args.rendererState[componentIdx].childrenInstructions,
            updatesToIgnoreRef,
            prefixForIds
          })
        );
      }
    }
    coreInfo.current = args.coreInfo;
    if (!coreInfo.current) {
      return;
    }
    generatedVariantCallback?.({
      variantInfo: JSON.parse(
        coreInfo.current.generatedVariantString,
        serializedComponentsReviver
      ),
      allPossibleVariants: coreInfo.current.allPossibleVariants,
      activityId,
      docId
    });
    const rendererLoaders = [];
    const rendererClassNames = [];
    for (const rendererClassName of coreInfo.current.rendererTypesInDocument) {
      rendererClassNames.push(rendererClassName);
      rendererLoaders.push(
        () => __variableDynamicImportRuntimeHelper(/* @__PURE__ */ Object.assign({ "./renderers/GraphFrame.tsx": () => import("./GraphFrame-5R_Nnklj.js"), "./renderers/JSXGraphRenderer.tsx": () => import("./JSXGraphRenderer-BcR36ozd.js").then((n2) => n2.m), "./renderers/_error.tsx": () => import("./_error-l3ASAd_O.js"), "./renderers/alert.tsx": () => import("./alert-C31vQ1Zm.js"), "./renderers/angle.tsx": () => import("./angle-D5tPYJGy.js"), "./renderers/answer.tsx": () => import("./answer-DUvHSopX.js"), "./renderers/asList.tsx": () => import("./asList-17wIQSts.js"), "./renderers/blockQuote.tsx": () => import("./blockQuote-H67CPvh4.js"), "./renderers/boolean.tsx": () => import("./boolean-BrfbiVxM.js"), "./renderers/booleanInput.tsx": () => import("./booleanInput-1RzOSBmO.js"), "./renderers/br.tsx": () => import("./br-Y3u1HEpF.js"), "./renderers/button.tsx": () => import("./button-BuX0qERC.js"), "./renderers/c.tsx": () => import("./c-Y0FRTzwm.js"), "./renderers/cell.tsx": () => import("./cell-DXzGgLZC.js"), "./renderers/choiceInput.tsx": () => import("./choiceInput-QYG5RDnq.js"), "./renderers/circle.tsx": () => import("./circle-BcT8JW-2.js"), "./renderers/cobwebPolyline.tsx": () => import("./cobwebPolyline-Bk86qCZN.js"), "./renderers/codeEditor.tsx": () => import("./codeEditor-CSg_ERC_.js"), "./renderers/containerBlock.tsx": () => import("./containerBlock-BiLyDPdi.js"), "./renderers/containerInline.tsx": () => import("./containerInline-BHA-8I0O.js"), "./renderers/curve.tsx": () => import("./curve-CY8QmohO.js"), "./renderers/ellipsis.tsx": () => import("./ellipsis-DYESmUW7.js"), "./renderers/em.tsx": () => import("./em-kfmKy4PD.js"), "./renderers/embed.tsx": () => import("./embed-D1ZSN3di.js"), "./renderers/feedback.tsx": () => import("./feedback-CLHphyee.js"), "./renderers/figure.tsx": () => import("./figure-BrePmmQq.js"), "./renderers/footnote.tsx": () => import("./footnote-3FW1HY9k.js"), "./renderers/fractionInput.tsx": () => import("./fractionInput-BC8E81uj.js"), "./renderers/graph.tsx": () => import("./graph-uNmxqd5I.js"), "./renderers/hint.tsx": () => import("./hint-B_kdL21O.js"), "./renderers/hr.tsx": () => import("./hr-DZafn4SW.js"), "./renderers/image.tsx": () => import("./image-BGchg3Hp.js"), "./renderers/label.tsx": () => import("./label-BEZXfmM-.js"), "./renderers/legend.tsx": () => import("./legend-PTdKctOq.js"), "./renderers/line.tsx": () => import("./line-CRs9Kffi.js"), "./renderers/lineSegment.tsx": () => import("./lineSegment-CF6YCRAO.js"), "./renderers/list.tsx": () => import("./list-mBXCMvMp.js"), "./renderers/lq.tsx": () => import("./lq-DnFLilVI.js"), "./renderers/lsq.tsx": () => import("./lsq-HTRPVsTA.js"), "./renderers/math.tsx": () => import("./math-Diykw-Cl.js"), "./renderers/mathInput.tsx": () => import("./mathInput-BlFoiDUY.js"), "./renderers/matrixInput.tsx": () => import("./matrixInput-CxIgxmNb.js"), "./renderers/mdash.tsx": () => import("./mdash-CHe8idf5.js"), "./renderers/nbsp.tsx": () => import("./nbsp-DLhqASSt.js"), "./renderers/ndash.tsx": () => import("./ndash-Bk0U8LUk.js"), "./renderers/number.tsx": () => import("./number-B0eczUCk.js"), "./renderers/orbitalDiagram.tsx": () => import("./orbitalDiagram-ncpQ3XeY.js"), "./renderers/orbitalDiagramInput.tsx": () => import("./orbitalDiagramInput-D6_ENlYY.js"), "./renderers/p.tsx": () => import("./p-BWfkgup-.js"), "./renderers/paginatorControls.tsx": () => import("./paginatorControls-BpypxFCi.js"), "./renderers/pegboard.tsx": () => import("./pegboard-CS7dNQQS.js"), "./renderers/point.tsx": () => import("./point-B_tHcxBn.js"), "./renderers/polygon.tsx": () => import("./polygon-ChWHMbNG.js"), "./renderers/polyline.tsx": () => import("./polyline-ByVT3k6z.js"), "./renderers/pre.tsx": () => import("./pre-BEzb0br9.js"), "./renderers/prefigure.tsx": () => import("./prefigure-UIeHl-FK.js"), "./renderers/pretzel.tsx": () => import("./pretzel-RAGpWNd8.js"), "./renderers/q.tsx": () => import("./q-CWri8Bpx.js"), "./renderers/ray.tsx": () => import("./ray-Ca4Kymx-.js"), "./renderers/ref.tsx": () => import("./ref-Dq7yAQOX.js"), "./renderers/regionBetweenCurveXAxis.tsx": () => import("./regionBetweenCurveXAxis-B0BToHLL.js"), "./renderers/regionBetweenCurves.tsx": () => import("./regionBetweenCurves-BcClg3xK.js"), "./renderers/row.tsx": () => import("./row-Cr2G9qWM.js"), "./renderers/rq.tsx": () => import("./rq-Bzxr4ovA.js"), "./renderers/rsq.tsx": () => import("./rsq-D9Kkw4CU.js"), "./renderers/section.tsx": () => import("./section-DWjZ3izY.js"), "./renderers/sideBySide.tsx": () => import("./sideBySide-B3IH4vRy.js"), "./renderers/slider.tsx": () => import("./slider-D24sz9P1.js"), "./renderers/solution.tsx": () => import("./solution-D26PvuZ-.js"), "./renderers/spreadsheet.tsx": () => import("./spreadsheet-DNcPWkpY.js"), "./renderers/sq.tsx": () => import("./sq-BZq6nmRm.js"), "./renderers/subsetOfRealsInput.tsx": () => import("./subsetOfRealsInput-DlrNfBY6.js"), "./renderers/summaryStatistics.tsx": () => import("./summaryStatistics-BZWidOD_.js"), "./renderers/table.tsx": () => import("./table-C-dMRPmP.js"), "./renderers/tabular.tsx": () => import("./tabular-whrBBrNK.js"), "./renderers/tag.tsx": () => import("./tag-B59gIOhu.js"), "./renderers/text.tsx": () => import("./text-Be88xCNH.js"), "./renderers/textInput.tsx": () => import("./textInput-Cqrld3OV.js"), "./renderers/vector.tsx": () => import("./vector-BOzufZlV.js"), "./renderers/video.tsx": () => import("./video-bqqPRRHP.js") }), `./renderers/${rendererClassName}.tsx`, 3)
      );
    }
    const documentComponentInstructions = coreInfo.current.documentToRender;
    renderersLoadComponent(rendererLoaders, rendererClassNames).then(
      ({ rendererClasses: newRendererClasses, failedRenderers }) => {
        if (failedRenderers.length > 0) {
          errorInitializingRenderers.current = true;
        }
        rendererClasses.current = newRendererClasses;
        const documentRendererClass = newRendererClasses[documentComponentInstructions.rendererType];
        setDocumentRenderer(
          React__default.createElement(documentRendererClass, {
            key: coreId.current + documentComponentInstructions.componentIdx,
            componentInstructions: documentComponentInstructions,
            rendererClasses: newRendererClasses,
            flags,
            coreId: coreId.current,
            docId,
            activityId,
            callAction,
            doenetViewerUrl,
            fetchExternalDoenetML,
            requestScrollTo
          })
        );
      }
    ).catch((e2) => {
      errorInitializingRenderers.current = true;
    });
  }
  function updateRenderers({
    updateInstructions,
    actionId,
    diagnostics: newDiagnostics,
    init: init2 = false
  }) {
    if (newDiagnostics) {
      diagnostics.current = newDiagnostics;
      setDiagnosticsCallback?.(diagnostics.current, doenetML);
      if (init2 && newDiagnostics.some((diagnostic2) => diagnostic2.type === "error")) {
        setHasInitialError(true);
      }
    }
    if (init2 && loadedInitialRendererState.current && !errorInitializingRenderers.current && !errorInsideRenderers.current && !hidden) {
      return;
    }
    for (let instruction of updateInstructions) {
      if (instruction.instructionType === "updateRendererStates") {
        for (let {
          componentIdx,
          stateValues,
          rendererType,
          childrenInstructions
        } of instruction.rendererStatesToUpdate) {
          dispatch(
            mainThunks.updateRendererSVs({
              coreId: coreId.current,
              componentIdx,
              stateValues,
              childrenInstructions,
              sourceOfUpdate: instruction.sourceOfUpdate,
              // Note: the reason we check both the renderer class and .type
              // is that if the renderer was memoized, then the renderer class itself is on .type,
              // Otherwise, the renderer class is the value of the rendererClasses entry.
              baseStateVariable: rendererClasses.current[rendererType]?.baseStateVariable || rendererClasses.current[rendererType]?.type?.baseStateVariable,
              actionId,
              prefixForIds,
              updatesToIgnoreRef
            })
          );
        }
      }
    }
    resolveAction({ actionId });
  }
  function resolveAction({
    actionId,
    success = true
  }) {
    if (!actionId) {
      return;
    }
    const callback = onActionCallbacks.current.get(actionId);
    if (callback) {
      callback(success);
      onActionCallbacks.current.delete(actionId);
    }
    if (lastSkippableAction.current && onActionCallbacks.current.size === 0) {
      let actionToCall = lastSkippableAction.current;
      lastSkippableAction.current = null;
      callAction(actionToCall);
    }
  }
  function reportScoreAndStateCallback({
    score: score2,
    state
  }) {
    if (specifiedReportScoreAndStateCallback) {
      specifiedReportScoreAndStateCallback({
        score: score2,
        state,
        activityId,
        docId
      });
    } else {
      let messageId = nanoid$1();
      const message = {
        score: score2,
        state,
        subject: "SPLICE.reportScoreAndState",
        activity_id: activityId,
        doc_id: docId,
        message_id: messageId
      };
      if (flags.messageParent && window.parent) {
        window.parent.postMessage(message);
      } else {
        window.postMessage(message);
      }
    }
  }
  async function loadStateAndInitialize() {
    const coreIdWhenCalled = coreId.current;
    let loadedState = false;
    cid.current = await cidFromText(doenetML);
    if (flags.allowLocalState) {
      let localInfo;
      try {
        localInfo = await get$4(
          `${activityId}|${docId}|${attemptNumber}|${cid.current}`
        );
        if (localInfo.data_format_version !== data_format_version) {
          localInfo = void 0;
        }
      } catch (e2) {
      }
      if (localInfo) {
        const coreState = JSON.parse(
          localInfo.coreState,
          serializedComponentsReviver
        );
        const rendererState = localInfo.rendererState && JSON.parse(
          localInfo.rendererState,
          serializedComponentsReviver
        );
        const coreInfo2 = JSON.parse(
          localInfo.coreInfo,
          serializedComponentsReviver
        );
        loadedInitialRendererState.current = Boolean(rendererState);
        initializeRenderers({
          rendererState,
          coreInfo: coreInfo2
        });
        initialCoreData.current = {
          coreState,
          requestedVariant: JSON.parse(
            coreInfo2.generatedVariantString,
            serializedComponentsReviver
          )
        };
        loadedState = true;
      }
    }
    if (!loadedState) {
      if (flags.allowLoadState) {
        try {
          if (initialState2) {
            processLoadedDocState(initialState2);
          } else if (initialState2 === void 0) {
            requestStateViaSplice({
              cid: cid.current,
              activityId,
              docId,
              attemptNumber,
              userId
            });
          }
        } catch (e2) {
          setIsInErrorState?.(true);
          let message = "";
          if ("message" in e2) {
            message = e2.message;
          }
          setErrMsg(`Error loading doc state: ${message}`);
          return;
        }
      }
    }
    if (coreIdWhenCalled === coreId.current) {
      if (render) {
        startCoreSafely();
      } else {
        setStage("readyToCreateCore");
      }
    }
  }
  function requestStateViaSplice({
    cid: cid2,
    activityId: activityId2,
    docId: docId2,
    attemptNumber: attemptNumber2,
    userId: userId2
  }) {
    let messageId = nanoid$1();
    messageIdFromGetState.current = messageId;
    const message = {
      subject: "SPLICE.getState",
      message_id: messageId,
      cid: cid2,
      domain_id: "Doenet",
      activity_id: activityId2,
      doc_id: docId2,
      attempt_number: attemptNumber2,
      user_id: userId2
    };
    if (flags.messageParent && window.parent) {
      window.parent.postMessage(message);
    } else {
      window.postMessage(message);
    }
  }
  function processLoadedDocState(data) {
    let coreInfo2 = JSON.parse(data.coreInfo, serializedComponentsReviver);
    let rendererState = data.rendererState && JSON.parse(data.rendererState, serializedComponentsReviver);
    loadedInitialRendererState.current = Boolean(rendererState);
    initializeRenderers({
      rendererState,
      coreInfo: coreInfo2
    });
    initialCoreData.current = {
      coreState: JSON.parse(data.coreState, serializedComponentsReviver),
      requestedVariant: JSON.parse(
        coreInfo2.generatedVariantString,
        serializedComponentsReviver
      )
    };
    initializeCounters.current = data.initializeCounters;
  }
  function failCoreStart() {
    coreCreationInProgress.current = false;
    setIsInErrorState?.(true);
    setErrMsg(CORE_START_FAILED_MESSAGE);
    setHasInitialError(true);
  }
  async function handshakeCore(attempt) {
    let thisCoreWorker = coreWorker.current;
    if (attempt > 0 || coreCreated.current || !thisCoreWorker) {
      thisCoreWorker = await reinitializeCoreAndTerminateAnimations();
    } else {
      await initializeCoreWorker({
        coreWorker: thisCoreWorker,
        doenetML,
        flags,
        activityId,
        docId,
        requestedVariantIndex,
        attemptNumber,
        documentStructureCallback,
        fetchExternalDoenetML
      });
    }
    if (doenetGlobalConfig.__doenetTestCoreInitHook) {
      await doenetGlobalConfig.__doenetTestCoreInitHook(
        "handshake",
        attempt
      );
    }
    return thisCoreWorker;
  }
  async function startCore() {
    setHasInitialError(false);
    const maxAttempts = Math.max(
      1,
      doenetGlobalConfig.coreBootMaxAttempts ?? DEFAULT_CORE_BOOT_MAX_ATTEMPTS
    );
    const handshakeWatchdogMs = doenetGlobalConfig.coreHandshakeWatchdogMs ?? DEFAULT_CORE_HANDSHAKE_WATCHDOG_MS;
    let thisCoreWorker = null;
    let handshakeSucceeded = false;
    for (let attempt = 0; attempt < maxAttempts; attempt++) {
      try {
        thisCoreWorker = await withTimeout(
          () => handshakeCore(attempt),
          handshakeWatchdogMs,
          `core worker handshake (attempt ${attempt + 1}/${maxAttempts})`
        );
        handshakeSucceeded = true;
        break;
      } catch (err) {
        console.warn(
          `DocViewer: core worker handshake attempt ${attempt + 1} of ${maxAttempts} failed` + (attempt + 1 < maxAttempts ? "; retrying with a fresh worker." : "; giving up."),
          err
        );
        await teardownCurrentCoreWorker({ graceful: false });
        coreCreated.current = false;
        coreCreationInProgress.current = false;
        if (attempt + 1 < maxAttempts) {
          await new Promise(
            (resolve) => setTimeout(resolve, CORE_BOOT_RETRY_DELAY_MS)
          );
        }
      }
    }
    if (!handshakeSucceeded || thisCoreWorker === null) {
      failCoreStart();
      return;
    }
    onActionCallbacks.current.clear();
    coreCreationInProgress.current = true;
    let dastResult;
    try {
      if (doenetGlobalConfig.__doenetTestCoreInitHook) {
        await doenetGlobalConfig.__doenetTestCoreInitHook(
          "generate",
          0
        );
      }
      dastResult = await thisCoreWorker.generateJavascriptDast(
        {
          coreId: coreId.current,
          userId,
          cid: cid.current,
          theme: darkMode,
          requestedVariant: initialCoreData.current?.requestedVariant,
          stateVariableChanges: initialCoreData.current?.coreState ? JSON.stringify(
            initialCoreData.current.coreState,
            serializedComponentsReplacer
          ) : void 0,
          initializeCounters: initializeCounters.current
        },
        proxy(updateRenderers),
        proxy(reportScoreAndStateCallback),
        proxy(requestAnimationFrame2),
        proxy(cancelAnimationFrame2),
        proxy(copyToClipboard),
        proxy(sendEvent),
        proxy(requestSolutionView)
      );
    } catch (err) {
      console.warn("DocViewer: generateJavascriptDast failed", err);
      failCoreStart();
      return;
    }
    if (dastResult.success) {
      if (coreInfo.current && JSON.stringify(coreInfo.current) === JSON.stringify(dastResult.coreInfo) && !errorInitializingRenderers.current && !errorInsideRenderers.current) ;
      else {
        initializeRenderers({ coreInfo: dastResult.coreInfo });
        if (errorInsideRenderers.current) {
          setIgnoreRendererError(true);
          setIsInErrorState?.(false);
        }
      }
      if (dastResult.diagnostics) {
        diagnostics.current = dastResult.diagnostics;
        if (diagnostics.current.some(
          (diagnostic2) => diagnostic2.type === "error"
        )) {
          setHasInitialError(true);
        }
        setDiagnosticsCallback?.(diagnostics.current, doenetML);
      }
    } else {
      setIsInErrorState?.(true);
      setErrMsg(dastResult.errMsg);
      setHasInitialError(true);
    }
    coreCreated.current = true;
    coreCreationInProgress.current = false;
    preventMoreAnimations.current = false;
    const pendingActions = takeDeferredCoreActions();
    for (let actionArgs of pendingActions) {
      executeAction(actionArgs).catch((e2) => {
        console.warn("DocViewer: deferred executeAction failed", e2);
      });
    }
    setStage("coreCreated");
    initializedCallback?.({ activityId, docId });
  }
  function startCoreSafely() {
    startCore().catch((e2) => {
      console.warn("DocViewer: startCore failed unexpectedly", e2);
      failCoreStart();
    });
  }
  function requestAnimationFrame2({
    action,
    actionArgs,
    delay,
    animationId
  }) {
    if (!preventMoreAnimations.current) {
      if (delay) {
        let timeoutId = window.setTimeout(
          () => _requestAnimationFrame({
            action,
            actionArgs,
            animationId
          }),
          delay
        );
        animationInfo.current[animationId] = { timeoutId };
      } else {
        animationInfo.current[animationId] = {};
        _requestAnimationFrame({ action, actionArgs, animationId });
      }
    }
  }
  function _requestAnimationFrame({
    action,
    actionArgs,
    animationId
  }) {
    let animationFrameID = window.requestAnimationFrame(
      () => callAction({
        action,
        args: actionArgs
      })
    );
    let animationInfoObj = animationInfo.current[animationId];
    delete animationInfoObj.timeoutId;
    animationInfoObj.animationFrameID = animationFrameID;
  }
  async function cancelAnimationFrame2(animationId) {
    let animationInfoObj = animationInfo.current[animationId];
    let timeoutId = animationInfoObj?.timeoutId;
    if (timeoutId !== void 0) {
      window.clearTimeout(timeoutId);
    }
    let animationFrameID = animationInfoObj?.animationFrameID;
    if (animationFrameID !== void 0) {
      window.cancelAnimationFrame(animationFrameID);
    }
    delete animationInfo.current[animationId];
  }
  function sendEvent(data) {
    const message = {
      data,
      subject: "SPLICE.sendEvent",
      message_id: nanoid$1(),
      name: data.verb
    };
    if (flags.messageParent && window.parent) {
      window.parent.postMessage(message);
    } else {
      window.postMessage(message);
    }
  }
  function requestSolutionView(componentIdx) {
    let messageId = nanoid$1();
    let requestSolutionPromiseResolve, requestSolutionPromiseReject;
    const requestSolutionViewPromise = new Promise(
      (resolve, reject2) => {
        requestSolutionPromiseResolve = resolve;
        requestSolutionPromiseReject = reject2;
        const message = {
          subject: "SPLICE.requestSolutionView",
          message_id: messageId,
          activity_id: activityId,
          doc_id: docId,
          attempt_number: attemptNumber,
          user_id: userId,
          component_idx: componentIdx
        };
        console.log(message);
        if (flags.messageParent && window.parent) {
          window.parent.postMessage(message);
        } else {
          window.postMessage(message);
        }
      }
    );
    requestSolutionViewPromises.current[messageId] = {
      resolve: requestSolutionPromiseResolve,
      reject: requestSolutionPromiseReject
    };
    return requestSolutionViewPromise;
  }
  async function copyToClipboard({
    text: text2,
    actionId
  }) {
    if (typeof text2 === "string") {
      await navigator.clipboard.writeText(text2);
    }
    resolveAction({ actionId });
  }
  function errorHandler() {
    errorInsideRenderers.current = true;
    if (ignoreRendererError) {
      setIgnoreRendererError(false);
    }
  }
  let changedState = false;
  const initialPass = lastDoenetML.current === null;
  if (initialPass && !render) {
    const remote = attachNewCoreWorker();
    initializeCoreWorker({
      coreWorker: remote,
      doenetML,
      flags,
      activityId,
      docId,
      requestedVariantIndex,
      attemptNumber,
      documentStructureCallback,
      fetchExternalDoenetML
    }).catch((e2) => {
      console.warn(
        "DocViewer: core worker initialization (no-render path) failed",
        e2
      );
    });
    return null;
  }
  if (lastDoenetML.current !== doenetML) {
    lastDoenetML.current = doenetML;
    changedState = true;
  }
  if (lastDocId.current !== docId) {
    lastDocId.current = docId;
    changedState = true;
  }
  if (lastActivityId.current !== activityId) {
    lastActivityId.current = activityId;
    changedState = true;
  }
  if (lastAttemptNumber.current !== attemptNumber) {
    lastAttemptNumber.current = attemptNumber;
    changedState = true;
  }
  if (lastRequestedVariantIndex.current !== requestedVariantIndex) {
    lastRequestedVariantIndex.current = requestedVariantIndex;
    changedState = true;
  }
  if (changedState) {
    if (errMsg !== null) {
      setErrMsg(null);
      setIsInErrorState?.(false);
    }
    coreId.current = nanoid$1();
    initialCoreData.current = null;
    coreInfo.current = null;
    setDocumentRenderer(null);
    coreCreated.current = false;
    coreCreationInProgress.current = false;
    loadedInitialRendererState.current = false;
    setStage("wait");
    loadStateAndInitialize().catch((e2) => {
      console.warn("DocViewer: loadStateAndInitialize failed", e2);
      failCoreStart();
    });
    return null;
  }
  if (errMsg !== null) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
      "div",
      {
        style: {
          backgroundColor: "var(--lightRed)",
          color: "var(--canvasText)",
          borderWidth: 3,
          borderStyle: "solid",
          borderColor: "var(--mainRed)",
          fontSize: "1.3em",
          marginLeft: "20px",
          marginTop: "20px",
          padding: "0.5em"
        },
        children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(MdError, { color: "red", fontSize: "24pt" }),
          " ",
          errMsg
        ]
      }
    );
  }
  if (stage === "wait") {
    return null;
  }
  if (stage === "readyToCreateCore" && render) {
    startCoreSafely();
  } else if (stage === "waitingOnCore" && !render && !coreCreated.current) {
    reinitializeCoreAndTerminateAnimations();
    setStage("readyToCreateCore");
  }
  if (hidden || !render) {
    return null;
  }
  let noCoreWarning = null;
  let viewerStyle = {
    maxWidth: "850px",
    paddingLeft: "20px",
    paddingRight: "20px",
    backgroundColor: "var(--canvas)",
    containerType: "inline-size"
  };
  if (!coreCreated.current) {
    if (!documentRenderer) {
      noCoreWarning = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        "div",
        {
          style: {
            backgroundColor: "var(--canvas)",
            color: "var(--canvasText)"
          },
          children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { children: "Initializing...." })
        }
      );
    }
  }
  let errorOverview = null;
  if (documentRenderer && hasInitialError) {
    let errorStyle = {
      backgroundColor: "var(--lightRed)",
      color: "var(--canvasText)",
      textAlign: "center",
      borderWidth: 3,
      borderStyle: "solid",
      borderColor: "var(--mainRed)"
    };
    errorOverview = /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: errorStyle, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("b", { children: "This document contains errors!" }) });
  }
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    ErrorBoundary,
    {
      setIsInErrorState,
      errorHandler,
      ignoreError: ignoreRendererError,
      coreCreated: coreCreated.current,
      children: [
        noCoreWarning,
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { style: viewerStyle, className: "doenet-viewer", children: [
          errorOverview,
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(DocContext.Provider, { value: contextForRenderers, children: documentRenderer })
        ] })
      ]
    }
  );
}
class ErrorBoundary extends React__default.Component {
  constructor(props2) {
    super(props2);
    this.state = { hasError: false };
  }
  static getDerivedStateFromError(_2) {
    return { hasError: true };
  }
  componentDidCatch(error, errorInfo) {
    this.props.setIsInErrorState?.(true);
    this.props.errorHandler?.();
  }
  render() {
    if (this.state.hasError && !this.props.ignoreError) {
      if (!this.props.coreCreated) {
        return null;
      } else {
        return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          "div",
          {
            style: {
              backgroundColor: "var(--lightRed)",
              color: "var(--canvasText)",
              padding: "1em",
              textAlign: "center",
              borderWidth: 3,
              borderStyle: "solid",
              borderColor: "var(--mainRed)"
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx("b", { children: "Error" }),
              ": Something went wrong."
            ]
          }
        );
      }
    }
    return this.props.children;
  }
}
(function() {
  return (Object.assign || function(e2) {
    for (var t4, o2 = 1, n2 = arguments.length; o2 < n2; o2++) for (var i2 in t4 = arguments[o2]) Object.prototype.hasOwnProperty.call(t4, i2) && (e2[i2] = t4[i2]);
    return e2;
  }).apply(this, arguments);
});
var MathJaxBaseContext = createContext(void 0);
var __assign = function() {
  return (__assign = Object.assign || function(e2) {
    for (var t4, n2 = 1, r2 = arguments.length; n2 < r2; n2++) for (var i2 in t4 = arguments[n2]) Object.prototype.hasOwnProperty.call(t4, i2) && (e2[i2] = t4[i2]);
    return e2;
  }).apply(this, arguments);
}, __rest = function(e2, t4) {
  var n2 = {};
  for (i2 in e2) Object.prototype.hasOwnProperty.call(e2, i2) && t4.indexOf(i2) < 0 && (n2[i2] = e2[i2]);
  if (null != e2 && "function" == typeof Object.getOwnPropertySymbols) for (var r2 = 0, i2 = Object.getOwnPropertySymbols(e2); r2 < i2.length; r2++) t4.indexOf(i2[r2]) < 0 && Object.prototype.propertyIsEnumerable.call(e2, i2[r2]) && (n2[i2[r2]] = e2[i2[r2]]);
  return n2;
};
var typesettingFailed = function(e2) {
  return "Typesetting failed: ".concat(void 0 !== e2.message ? e2.message : JSON.stringify(e2));
}, MathJax = function(e2) {
  function r2() {
    var e3;
    "every" === h2 && m2 && "post" === v2 && null !== f2.current && (f2.current.style.visibility = null != (e3 = null == (e3 = p2.style) ? void 0 : e3.visibility) ? e3 : "visible"), _2.current || ("first" === h2 && null !== f2.current && (f2.current.style.visibility = "visible"), n2 && n2(), _2.current = true), o2 && o2(), b2.current = false;
  }
  var t4 = e2.inline, i2 = void 0 !== t4 && t4, t4 = e2.hideUntilTypeset, n2 = e2.onInitTypeset, o2 = e2.onTypeset, s2 = e2.text, u2 = e2.dynamic, a2 = e2.typesettingOptions, l2 = e2.renderMode, c2 = e2.children, p2 = __rest(e2, ["inline", "hideUntilTypeset", "onInitTypeset", "onTypeset", "text", "dynamic", "typesettingOptions", "renderMode", "children"]), y2 = useRef(""), f2 = useRef(null), d2 = useContext(MathJaxBaseContext), h2 = null != t4 ? t4 : null == d2 ? void 0 : d2.hideUntilTypeset, v2 = null != l2 ? l2 : null == d2 ? void 0 : d2.renderMode, g2 = null != a2 ? a2 : null == d2 ? void 0 : d2.typesettingOptions, m2 = false !== u2 && (u2 || "production" !== process.env.NODE_ENV), _2 = useRef(false), b2 = useRef(false);
  return !b2.current && null !== f2.current && m2 && "every" === h2 && "post" === v2 && (f2.current.style.visibility = "hidden"), ("undefined" != typeof window ? useLayoutEffect : useEffect)(function() {
    if ((m2 || !_2.current) && null !== f2.current) {
      if (!d2) throw Error("MathJax was not loaded, did you use the MathJax component outside of a MathJaxContext?");
      if ("pre" === v2) {
        if (!("string" == typeof (e3 = s2) && 0 < e3.length)) throw Error(`Render mode 'pre' requires text prop to be set and non-empty, which was currently "`.concat(s2, '"'));
        if (!g2 || !g2.fn) throw Error("Render mode 'pre' requires 'typesettingOptions' prop with 'fn' property to be set on MathJax element or in the MathJaxContext");
        if (2 === d2.version) throw Error("Render mode 'pre' only available with MathJax 3 and 4, and version 2 is currently in use");
      }
      "post" !== v2 && s2 === y2.current || b2.current || (b2.current = true, 3 === d2.version || 4 === d2.version ? d2.promise.then(function(t5) {
        var n3;
        "pre" === v2 ? (n3 = function(e4) {
          y2.current = s2, t5.startup.document.clear(), t5.startup.document.updateDocument(), null !== f2.current && (f2.current.innerHTML = e4.outerHTML), r2();
        }, g2.fn.endsWith("Promise") ? t5.startup.promise.then(function() {
          return t5[g2.fn](s2, __assign(__assign({}, (null == g2 ? void 0 : g2.options) || {}), { display: !i2 }));
        }).then(n3).catch(function(e4) {
          throw r2(), Error(typesettingFailed(e4));
        }) : t5.startup.promise.then(function() {
          var e4 = t5[g2.fn](s2, __assign(__assign({}, (null == g2 ? void 0 : g2.options) || {}), { display: !i2 }));
          n3(e4);
        }).catch(function(e4) {
          throw r2(), Error(typesettingFailed(e4));
        })) : t5.startup.promise.then(function() {
          return t5.typesetClear([f2.current]), t5.typesetPromise([f2.current]);
        }).then(r2).catch(function(e4) {
          throw r2(), Error(typesettingFailed(e4));
        });
      }).catch(function(e4) {
        throw r2(), Error(typesettingFailed(e4));
      }) : d2.promise.then(function(e4) {
        e4.Hub.Queue(["Typeset", e4.Hub, f2.current]), e4.Hub.Queue(r2);
      }).catch(function(e4) {
        throw r2(), Error(typesettingFailed(e4));
      }));
    }
    var e3;
  }), React__default.createElement("span", __assign({}, p2, { style: __assign(__assign({ display: i2 ? "inline" : "block" }, p2.style), { visibility: h2 ? "hidden" : null == (e2 = p2.style) ? void 0 : e2.visibility }), ref: f2 }), c2);
};
function MathJaxContext$1({
  config: config2,
  src,
  useExistingMathJax,
  timeoutMs,
  version: version2 = 4,
  children
}) {
  const value = useMemo(() => {
    const promise = loadMathJax$1({
      config: config2,
      src,
      useExistingMathJax,
      timeoutMs
    });
    return { version: version2, promise };
  }, [config2, src, useExistingMathJax, timeoutMs, version2]);
  return /* @__PURE__ */ React__default.createElement(MathJaxBaseContext.Provider, { value }, children);
}
var client = { exports: {} };
var reactDomClient_production = {};
var scheduler = { exports: {} };
var scheduler_production = {};
var hasRequiredScheduler_production;
function requireScheduler_production() {
  if (hasRequiredScheduler_production) return scheduler_production;
  hasRequiredScheduler_production = 1;
  (function(exports2) {
    function push2(heap, node) {
      var index2 = heap.length;
      heap.push(node);
      a: for (; 0 < index2; ) {
        var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
        if (0 < compare2(parent, node))
          heap[parentIndex] = node, heap[index2] = parent, index2 = parentIndex;
        else break a;
      }
    }
    function peek2(heap) {
      return 0 === heap.length ? null : heap[0];
    }
    function pop(heap) {
      if (0 === heap.length) return null;
      var first2 = heap[0], last2 = heap.pop();
      if (last2 !== first2) {
        heap[0] = last2;
        a: for (var index2 = 0, length = heap.length, halfLength = length >>> 1; index2 < halfLength; ) {
          var leftIndex = 2 * (index2 + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
          if (0 > compare2(left, last2))
            rightIndex < length && 0 > compare2(right, left) ? (heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex) : (heap[index2] = left, heap[leftIndex] = last2, index2 = leftIndex);
          else if (rightIndex < length && 0 > compare2(right, last2))
            heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex;
          else break a;
        }
      }
      return first2;
    }
    function compare2(a2, b2) {
      var diff = a2.sortIndex - b2.sortIndex;
      return 0 !== diff ? diff : a2.id - b2.id;
    }
    exports2.unstable_now = void 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      exports2.unstable_now = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date, initialTime = localDate.now();
      exports2.unstable_now = function() {
        return localDate.now() - initialTime;
      };
    }
    var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null;
    function advanceTimers(currentTime) {
      for (var timer = peek2(timerQueue); null !== timer; ) {
        if (null === timer.callback) pop(timerQueue);
        else if (timer.startTime <= currentTime)
          pop(timerQueue), timer.sortIndex = timer.expirationTime, push2(taskQueue, timer);
        else break;
        timer = peek2(timerQueue);
      }
    }
    function handleTimeout(currentTime) {
      isHostTimeoutScheduled = false;
      advanceTimers(currentTime);
      if (!isHostCallbackScheduled)
        if (null !== peek2(taskQueue))
          isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
        else {
          var firstTimer = peek2(timerQueue);
          null !== firstTimer && requestHostTimeout(handleTimeout, firstTimer.startTime - currentTime);
        }
    }
    var isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
    function shouldYieldToHost() {
      return needsPaint ? true : exports2.unstable_now() - startTime < frameInterval ? false : true;
    }
    function performWorkUntilDeadline() {
      needsPaint = false;
      if (isMessageLoopRunning) {
        var currentTime = exports2.unstable_now();
        startTime = currentTime;
        var hasMoreWork = true;
        try {
          a: {
            isHostCallbackScheduled = false;
            isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
            isPerformingWork = true;
            var previousPriorityLevel = currentPriorityLevel;
            try {
              b: {
                advanceTimers(currentTime);
                for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                  var callback = currentTask.callback;
                  if ("function" === typeof callback) {
                    currentTask.callback = null;
                    currentPriorityLevel = currentTask.priorityLevel;
                    var continuationCallback = callback(
                      currentTask.expirationTime <= currentTime
                    );
                    currentTime = exports2.unstable_now();
                    if ("function" === typeof continuationCallback) {
                      currentTask.callback = continuationCallback;
                      advanceTimers(currentTime);
                      hasMoreWork = true;
                      break b;
                    }
                    currentTask === peek2(taskQueue) && pop(taskQueue);
                    advanceTimers(currentTime);
                  } else pop(taskQueue);
                  currentTask = peek2(taskQueue);
                }
                if (null !== currentTask) hasMoreWork = true;
                else {
                  var firstTimer = peek2(timerQueue);
                  null !== firstTimer && requestHostTimeout(
                    handleTimeout,
                    firstTimer.startTime - currentTime
                  );
                  hasMoreWork = false;
                }
              }
              break a;
            } finally {
              currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
            }
            hasMoreWork = void 0;
          }
        } finally {
          hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
        }
      }
    }
    var schedulePerformWorkUntilDeadline;
    if ("function" === typeof localSetImmediate)
      schedulePerformWorkUntilDeadline = function() {
        localSetImmediate(performWorkUntilDeadline);
      };
    else if ("undefined" !== typeof MessageChannel) {
      var channel = new MessageChannel(), port = channel.port2;
      channel.port1.onmessage = performWorkUntilDeadline;
      schedulePerformWorkUntilDeadline = function() {
        port.postMessage(null);
      };
    } else
      schedulePerformWorkUntilDeadline = function() {
        localSetTimeout(performWorkUntilDeadline, 0);
      };
    function requestHostTimeout(callback, ms) {
      taskTimeoutID = localSetTimeout(function() {
        callback(exports2.unstable_now());
      }, ms);
    }
    exports2.unstable_IdlePriority = 5;
    exports2.unstable_ImmediatePriority = 1;
    exports2.unstable_LowPriority = 4;
    exports2.unstable_NormalPriority = 3;
    exports2.unstable_Profiling = null;
    exports2.unstable_UserBlockingPriority = 2;
    exports2.unstable_cancelCallback = function(task) {
      task.callback = null;
    };
    exports2.unstable_forceFrameRate = function(fps) {
      0 > fps || 125 < fps ? console.error(
        "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
      ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
    };
    exports2.unstable_getCurrentPriorityLevel = function() {
      return currentPriorityLevel;
    };
    exports2.unstable_next = function(eventHandler) {
      switch (currentPriorityLevel) {
        case 1:
        case 2:
        case 3:
          var priorityLevel = 3;
          break;
        default:
          priorityLevel = currentPriorityLevel;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports2.unstable_requestPaint = function() {
      needsPaint = true;
    };
    exports2.unstable_runWithPriority = function(priorityLevel, eventHandler) {
      switch (priorityLevel) {
        case 1:
        case 2:
        case 3:
        case 4:
        case 5:
          break;
        default:
          priorityLevel = 3;
      }
      var previousPriorityLevel = currentPriorityLevel;
      currentPriorityLevel = priorityLevel;
      try {
        return eventHandler();
      } finally {
        currentPriorityLevel = previousPriorityLevel;
      }
    };
    exports2.unstable_scheduleCallback = function(priorityLevel, callback, options2) {
      var currentTime = exports2.unstable_now();
      "object" === typeof options2 && null !== options2 ? (options2 = options2.delay, options2 = "number" === typeof options2 && 0 < options2 ? currentTime + options2 : currentTime) : options2 = currentTime;
      switch (priorityLevel) {
        case 1:
          var timeout = -1;
          break;
        case 2:
          timeout = 250;
          break;
        case 5:
          timeout = 1073741823;
          break;
        case 4:
          timeout = 1e4;
          break;
        default:
          timeout = 5e3;
      }
      timeout = options2 + timeout;
      priorityLevel = {
        id: taskIdCounter++,
        callback,
        priorityLevel,
        startTime: options2,
        expirationTime: timeout,
        sortIndex: -1
      };
      options2 > currentTime ? (priorityLevel.sortIndex = options2, push2(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options2 - currentTime))) : (priorityLevel.sortIndex = timeout, push2(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
      return priorityLevel;
    };
    exports2.unstable_shouldYield = shouldYieldToHost;
    exports2.unstable_wrapCallback = function(callback) {
      var parentPriorityLevel = currentPriorityLevel;
      return function() {
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = parentPriorityLevel;
        try {
          return callback.apply(this, arguments);
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
    };
  })(scheduler_production);
  return scheduler_production;
}
var scheduler_development = {};
var hasRequiredScheduler_development;
function requireScheduler_development() {
  if (hasRequiredScheduler_development) return scheduler_development;
  hasRequiredScheduler_development = 1;
  (function(exports2) {
    "production" !== process.env.NODE_ENV && (function() {
      function performWorkUntilDeadline() {
        needsPaint = false;
        if (isMessageLoopRunning) {
          var currentTime = exports2.unstable_now();
          startTime = currentTime;
          var hasMoreWork = true;
          try {
            a: {
              isHostCallbackScheduled = false;
              isHostTimeoutScheduled && (isHostTimeoutScheduled = false, localClearTimeout(taskTimeoutID), taskTimeoutID = -1);
              isPerformingWork = true;
              var previousPriorityLevel = currentPriorityLevel;
              try {
                b: {
                  advanceTimers(currentTime);
                  for (currentTask = peek2(taskQueue); null !== currentTask && !(currentTask.expirationTime > currentTime && shouldYieldToHost()); ) {
                    var callback = currentTask.callback;
                    if ("function" === typeof callback) {
                      currentTask.callback = null;
                      currentPriorityLevel = currentTask.priorityLevel;
                      var continuationCallback = callback(
                        currentTask.expirationTime <= currentTime
                      );
                      currentTime = exports2.unstable_now();
                      if ("function" === typeof continuationCallback) {
                        currentTask.callback = continuationCallback;
                        advanceTimers(currentTime);
                        hasMoreWork = true;
                        break b;
                      }
                      currentTask === peek2(taskQueue) && pop(taskQueue);
                      advanceTimers(currentTime);
                    } else pop(taskQueue);
                    currentTask = peek2(taskQueue);
                  }
                  if (null !== currentTask) hasMoreWork = true;
                  else {
                    var firstTimer = peek2(timerQueue);
                    null !== firstTimer && requestHostTimeout(
                      handleTimeout,
                      firstTimer.startTime - currentTime
                    );
                    hasMoreWork = false;
                  }
                }
                break a;
              } finally {
                currentTask = null, currentPriorityLevel = previousPriorityLevel, isPerformingWork = false;
              }
              hasMoreWork = void 0;
            }
          } finally {
            hasMoreWork ? schedulePerformWorkUntilDeadline() : isMessageLoopRunning = false;
          }
        }
      }
      function push2(heap, node) {
        var index2 = heap.length;
        heap.push(node);
        a: for (; 0 < index2; ) {
          var parentIndex = index2 - 1 >>> 1, parent = heap[parentIndex];
          if (0 < compare2(parent, node))
            heap[parentIndex] = node, heap[index2] = parent, index2 = parentIndex;
          else break a;
        }
      }
      function peek2(heap) {
        return 0 === heap.length ? null : heap[0];
      }
      function pop(heap) {
        if (0 === heap.length) return null;
        var first2 = heap[0], last2 = heap.pop();
        if (last2 !== first2) {
          heap[0] = last2;
          a: for (var index2 = 0, length = heap.length, halfLength = length >>> 1; index2 < halfLength; ) {
            var leftIndex = 2 * (index2 + 1) - 1, left = heap[leftIndex], rightIndex = leftIndex + 1, right = heap[rightIndex];
            if (0 > compare2(left, last2))
              rightIndex < length && 0 > compare2(right, left) ? (heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex) : (heap[index2] = left, heap[leftIndex] = last2, index2 = leftIndex);
            else if (rightIndex < length && 0 > compare2(right, last2))
              heap[index2] = right, heap[rightIndex] = last2, index2 = rightIndex;
            else break a;
          }
        }
        return first2;
      }
      function compare2(a2, b2) {
        var diff = a2.sortIndex - b2.sortIndex;
        return 0 !== diff ? diff : a2.id - b2.id;
      }
      function advanceTimers(currentTime) {
        for (var timer = peek2(timerQueue); null !== timer; ) {
          if (null === timer.callback) pop(timerQueue);
          else if (timer.startTime <= currentTime)
            pop(timerQueue), timer.sortIndex = timer.expirationTime, push2(taskQueue, timer);
          else break;
          timer = peek2(timerQueue);
        }
      }
      function handleTimeout(currentTime) {
        isHostTimeoutScheduled = false;
        advanceTimers(currentTime);
        if (!isHostCallbackScheduled)
          if (null !== peek2(taskQueue))
            isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline());
          else {
            var firstTimer = peek2(timerQueue);
            null !== firstTimer && requestHostTimeout(
              handleTimeout,
              firstTimer.startTime - currentTime
            );
          }
      }
      function shouldYieldToHost() {
        return needsPaint ? true : exports2.unstable_now() - startTime < frameInterval ? false : true;
      }
      function requestHostTimeout(callback, ms) {
        taskTimeoutID = localSetTimeout(function() {
          callback(exports2.unstable_now());
        }, ms);
      }
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
      exports2.unstable_now = void 0;
      if ("object" === typeof performance && "function" === typeof performance.now) {
        var localPerformance = performance;
        exports2.unstable_now = function() {
          return localPerformance.now();
        };
      } else {
        var localDate = Date, initialTime = localDate.now();
        exports2.unstable_now = function() {
          return localDate.now() - initialTime;
        };
      }
      var taskQueue = [], timerQueue = [], taskIdCounter = 1, currentTask = null, currentPriorityLevel = 3, isPerformingWork = false, isHostCallbackScheduled = false, isHostTimeoutScheduled = false, needsPaint = false, localSetTimeout = "function" === typeof setTimeout ? setTimeout : null, localClearTimeout = "function" === typeof clearTimeout ? clearTimeout : null, localSetImmediate = "undefined" !== typeof setImmediate ? setImmediate : null, isMessageLoopRunning = false, taskTimeoutID = -1, frameInterval = 5, startTime = -1;
      if ("function" === typeof localSetImmediate)
        var schedulePerformWorkUntilDeadline = function() {
          localSetImmediate(performWorkUntilDeadline);
        };
      else if ("undefined" !== typeof MessageChannel) {
        var channel = new MessageChannel(), port = channel.port2;
        channel.port1.onmessage = performWorkUntilDeadline;
        schedulePerformWorkUntilDeadline = function() {
          port.postMessage(null);
        };
      } else
        schedulePerformWorkUntilDeadline = function() {
          localSetTimeout(performWorkUntilDeadline, 0);
        };
      exports2.unstable_IdlePriority = 5;
      exports2.unstable_ImmediatePriority = 1;
      exports2.unstable_LowPriority = 4;
      exports2.unstable_NormalPriority = 3;
      exports2.unstable_Profiling = null;
      exports2.unstable_UserBlockingPriority = 2;
      exports2.unstable_cancelCallback = function(task) {
        task.callback = null;
      };
      exports2.unstable_forceFrameRate = function(fps) {
        0 > fps || 125 < fps ? console.error(
          "forceFrameRate takes a positive int between 0 and 125, forcing frame rates higher than 125 fps is not supported"
        ) : frameInterval = 0 < fps ? Math.floor(1e3 / fps) : 5;
      };
      exports2.unstable_getCurrentPriorityLevel = function() {
        return currentPriorityLevel;
      };
      exports2.unstable_next = function(eventHandler) {
        switch (currentPriorityLevel) {
          case 1:
          case 2:
          case 3:
            var priorityLevel = 3;
            break;
          default:
            priorityLevel = currentPriorityLevel;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports2.unstable_requestPaint = function() {
        needsPaint = true;
      };
      exports2.unstable_runWithPriority = function(priorityLevel, eventHandler) {
        switch (priorityLevel) {
          case 1:
          case 2:
          case 3:
          case 4:
          case 5:
            break;
          default:
            priorityLevel = 3;
        }
        var previousPriorityLevel = currentPriorityLevel;
        currentPriorityLevel = priorityLevel;
        try {
          return eventHandler();
        } finally {
          currentPriorityLevel = previousPriorityLevel;
        }
      };
      exports2.unstable_scheduleCallback = function(priorityLevel, callback, options2) {
        var currentTime = exports2.unstable_now();
        "object" === typeof options2 && null !== options2 ? (options2 = options2.delay, options2 = "number" === typeof options2 && 0 < options2 ? currentTime + options2 : currentTime) : options2 = currentTime;
        switch (priorityLevel) {
          case 1:
            var timeout = -1;
            break;
          case 2:
            timeout = 250;
            break;
          case 5:
            timeout = 1073741823;
            break;
          case 4:
            timeout = 1e4;
            break;
          default:
            timeout = 5e3;
        }
        timeout = options2 + timeout;
        priorityLevel = {
          id: taskIdCounter++,
          callback,
          priorityLevel,
          startTime: options2,
          expirationTime: timeout,
          sortIndex: -1
        };
        options2 > currentTime ? (priorityLevel.sortIndex = options2, push2(timerQueue, priorityLevel), null === peek2(taskQueue) && priorityLevel === peek2(timerQueue) && (isHostTimeoutScheduled ? (localClearTimeout(taskTimeoutID), taskTimeoutID = -1) : isHostTimeoutScheduled = true, requestHostTimeout(handleTimeout, options2 - currentTime))) : (priorityLevel.sortIndex = timeout, push2(taskQueue, priorityLevel), isHostCallbackScheduled || isPerformingWork || (isHostCallbackScheduled = true, isMessageLoopRunning || (isMessageLoopRunning = true, schedulePerformWorkUntilDeadline())));
        return priorityLevel;
      };
      exports2.unstable_shouldYield = shouldYieldToHost;
      exports2.unstable_wrapCallback = function(callback) {
        var parentPriorityLevel = currentPriorityLevel;
        return function() {
          var previousPriorityLevel = currentPriorityLevel;
          currentPriorityLevel = parentPriorityLevel;
          try {
            return callback.apply(this, arguments);
          } finally {
            currentPriorityLevel = previousPriorityLevel;
          }
        };
      };
      "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
    })();
  })(scheduler_development);
  return scheduler_development;
}
var hasRequiredScheduler;
function requireScheduler() {
  if (hasRequiredScheduler) return scheduler.exports;
  hasRequiredScheduler = 1;
  if (process.env.NODE_ENV === "production") {
    scheduler.exports = requireScheduler_production();
  } else {
    scheduler.exports = requireScheduler_development();
  }
  return scheduler.exports;
}
var hasRequiredReactDomClient_production;
function requireReactDomClient_production() {
  if (hasRequiredReactDomClient_production) return reactDomClient_production;
  hasRequiredReactDomClient_production = 1;
  var Scheduler2 = requireScheduler(), React2 = React__default, ReactDOM = require$$2;
  function formatProdErrorMessage2(code2) {
    var url = "https://react.dev/errors/" + code2;
    if (1 < arguments.length) {
      url += "?args[]=" + encodeURIComponent(arguments[1]);
      for (var i2 = 2; i2 < arguments.length; i2++)
        url += "&args[]=" + encodeURIComponent(arguments[i2]);
    }
    return "Minified React error #" + code2 + "; visit " + url + " for the full message or use the non-minified dev environment for full errors and additional helpful warnings.";
  }
  function isValidContainer(node) {
    return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
  }
  function getNearestMountedFiber(fiber) {
    var node = fiber, nearestMounted = fiber;
    if (fiber.alternate) for (; node.return; ) node = node.return;
    else {
      fiber = node;
      do
        node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
      while (fiber);
    }
    return 3 === node.tag ? nearestMounted : null;
  }
  function getSuspenseInstanceFromFiber(fiber) {
    if (13 === fiber.tag) {
      var suspenseState = fiber.memoizedState;
      null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
      if (null !== suspenseState) return suspenseState.dehydrated;
    }
    return null;
  }
  function getActivityInstanceFromFiber(fiber) {
    if (31 === fiber.tag) {
      var activityState = fiber.memoizedState;
      null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
      if (null !== activityState) return activityState.dehydrated;
    }
    return null;
  }
  function assertIsMounted(fiber) {
    if (getNearestMountedFiber(fiber) !== fiber)
      throw Error(formatProdErrorMessage2(188));
  }
  function findCurrentFiberUsingSlowPath(fiber) {
    var alternate = fiber.alternate;
    if (!alternate) {
      alternate = getNearestMountedFiber(fiber);
      if (null === alternate) throw Error(formatProdErrorMessage2(188));
      return alternate !== fiber ? null : fiber;
    }
    for (var a2 = fiber, b2 = alternate; ; ) {
      var parentA = a2.return;
      if (null === parentA) break;
      var parentB = parentA.alternate;
      if (null === parentB) {
        b2 = parentA.return;
        if (null !== b2) {
          a2 = b2;
          continue;
        }
        break;
      }
      if (parentA.child === parentB.child) {
        for (parentB = parentA.child; parentB; ) {
          if (parentB === a2) return assertIsMounted(parentA), fiber;
          if (parentB === b2) return assertIsMounted(parentA), alternate;
          parentB = parentB.sibling;
        }
        throw Error(formatProdErrorMessage2(188));
      }
      if (a2.return !== b2.return) a2 = parentA, b2 = parentB;
      else {
        for (var didFindChild = false, child$0 = parentA.child; child$0; ) {
          if (child$0 === a2) {
            didFindChild = true;
            a2 = parentA;
            b2 = parentB;
            break;
          }
          if (child$0 === b2) {
            didFindChild = true;
            b2 = parentA;
            a2 = parentB;
            break;
          }
          child$0 = child$0.sibling;
        }
        if (!didFindChild) {
          for (child$0 = parentB.child; child$0; ) {
            if (child$0 === a2) {
              didFindChild = true;
              a2 = parentB;
              b2 = parentA;
              break;
            }
            if (child$0 === b2) {
              didFindChild = true;
              b2 = parentB;
              a2 = parentA;
              break;
            }
            child$0 = child$0.sibling;
          }
          if (!didFindChild) throw Error(formatProdErrorMessage2(189));
        }
      }
      if (a2.alternate !== b2) throw Error(formatProdErrorMessage2(190));
    }
    if (3 !== a2.tag) throw Error(formatProdErrorMessage2(188));
    return a2.stateNode.current === a2 ? fiber : alternate;
  }
  function findCurrentHostFiberImpl(node) {
    var tag2 = node.tag;
    if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return node;
    for (node = node.child; null !== node; ) {
      tag2 = findCurrentHostFiberImpl(node);
      if (null !== tag2) return tag2;
      node = node.sibling;
    }
    return null;
  }
  var assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.element"), REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
  var REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity");
  var REACT_MEMO_CACHE_SENTINEL = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel");
  var MAYBE_ITERATOR_SYMBOL = Symbol.iterator;
  function getIteratorFn(maybeIterable) {
    if (null === maybeIterable || "object" !== typeof maybeIterable) return null;
    maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
    return "function" === typeof maybeIterable ? maybeIterable : null;
  }
  var REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference");
  function getComponentNameFromType(type) {
    if (null == type) return null;
    if ("function" === typeof type)
      return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
    if ("string" === typeof type) return type;
    switch (type) {
      case REACT_FRAGMENT_TYPE:
        return "Fragment";
      case REACT_PROFILER_TYPE:
        return "Profiler";
      case REACT_STRICT_MODE_TYPE:
        return "StrictMode";
      case REACT_SUSPENSE_TYPE:
        return "Suspense";
      case REACT_SUSPENSE_LIST_TYPE:
        return "SuspenseList";
      case REACT_ACTIVITY_TYPE:
        return "Activity";
    }
    if ("object" === typeof type)
      switch (type.$$typeof) {
        case REACT_PORTAL_TYPE:
          return "Portal";
        case REACT_CONTEXT_TYPE:
          return type.displayName || "Context";
        case REACT_CONSUMER_TYPE:
          return (type._context.displayName || "Context") + ".Consumer";
        case REACT_FORWARD_REF_TYPE:
          var innerType = type.render;
          type = type.displayName;
          type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
          return type;
        case REACT_MEMO_TYPE:
          return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
        case REACT_LAZY_TYPE:
          innerType = type._payload;
          type = type._init;
          try {
            return getComponentNameFromType(type(innerType));
          } catch (x2) {
          }
      }
    return null;
  }
  var isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, sharedNotPendingObject = {
    pending: false,
    data: null,
    method: null,
    action: null
  }, valueStack = [], index2 = -1;
  function createCursor(defaultValue2) {
    return { current: defaultValue2 };
  }
  function pop(cursor2) {
    0 > index2 || (cursor2.current = valueStack[index2], valueStack[index2] = null, index2--);
  }
  function push2(cursor2, value) {
    index2++;
    valueStack[index2] = cursor2.current;
    cursor2.current = value;
  }
  var contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null);
  function pushHostContainer(fiber, nextRootInstance) {
    push2(rootInstanceStackCursor, nextRootInstance);
    push2(contextFiberStackCursor, fiber);
    push2(contextStackCursor, null);
    switch (nextRootInstance.nodeType) {
      case 9:
      case 11:
        fiber = (fiber = nextRootInstance.documentElement) ? (fiber = fiber.namespaceURI) ? getOwnHostContext(fiber) : 0 : 0;
        break;
      default:
        if (fiber = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
          nextRootInstance = getOwnHostContext(nextRootInstance), fiber = getChildHostContextProd(nextRootInstance, fiber);
        else
          switch (fiber) {
            case "svg":
              fiber = 1;
              break;
            case "math":
              fiber = 2;
              break;
            default:
              fiber = 0;
          }
    }
    pop(contextStackCursor);
    push2(contextStackCursor, fiber);
  }
  function popHostContainer() {
    pop(contextStackCursor);
    pop(contextFiberStackCursor);
    pop(rootInstanceStackCursor);
  }
  function pushHostContext(fiber) {
    null !== fiber.memoizedState && push2(hostTransitionProviderCursor, fiber);
    var context = contextStackCursor.current;
    var JSCompiler_inline_result = getChildHostContextProd(context, fiber.type);
    context !== JSCompiler_inline_result && (push2(contextFiberStackCursor, fiber), push2(contextStackCursor, JSCompiler_inline_result));
  }
  function popHostContext(fiber) {
    contextFiberStackCursor.current === fiber && (pop(contextStackCursor), pop(contextFiberStackCursor));
    hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor), HostTransitionContext._currentValue = sharedNotPendingObject);
  }
  var prefix, suffix;
  function describeBuiltInComponentFrame(name2) {
    if (void 0 === prefix)
      try {
        throw Error();
      } catch (x2) {
        var match2 = x2.stack.trim().match(/\n( *(at )?)/);
        prefix = match2 && match2[1] || "";
        suffix = -1 < x2.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x2.stack.indexOf("@") ? "@unknown:0:0" : "";
      }
    return "\n" + prefix + name2 + suffix;
  }
  var reentry = false;
  function describeNativeComponentFrame(fn2, construct) {
    if (!fn2 || reentry) return "";
    reentry = true;
    var previousPrepareStackTrace = Error.prepareStackTrace;
    Error.prepareStackTrace = void 0;
    try {
      var RunInRootFrame = {
        DetermineComponentFrameRoot: function() {
          try {
            if (construct) {
              var Fake = function() {
                throw Error();
              };
              Object.defineProperty(Fake.prototype, "props", {
                set: function() {
                  throw Error();
                }
              });
              if ("object" === typeof Reflect && Reflect.construct) {
                try {
                  Reflect.construct(Fake, []);
                } catch (x2) {
                  var control = x2;
                }
                Reflect.construct(fn2, [], Fake);
              } else {
                try {
                  Fake.call();
                } catch (x$12) {
                  control = x$12;
                }
                fn2.call(Fake.prototype);
              }
            } else {
              try {
                throw Error();
              } catch (x$22) {
                control = x$22;
              }
              (Fake = fn2()) && "function" === typeof Fake.catch && Fake.catch(function() {
              });
            }
          } catch (sample2) {
            if (sample2 && control && "string" === typeof sample2.stack)
              return [sample2.stack, control.stack];
          }
          return [null, null];
        }
      };
      RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
      var namePropDescriptor = Object.getOwnPropertyDescriptor(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name"
      );
      namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
        RunInRootFrame.DetermineComponentFrameRoot,
        "name",
        { value: "DetermineComponentFrameRoot" }
      );
      var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
      if (sampleStack && controlStack) {
        var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
        for (namePropDescriptor = RunInRootFrame = 0; RunInRootFrame < sampleLines.length && !sampleLines[RunInRootFrame].includes("DetermineComponentFrameRoot"); )
          RunInRootFrame++;
        for (; namePropDescriptor < controlLines.length && !controlLines[namePropDescriptor].includes(
          "DetermineComponentFrameRoot"
        ); )
          namePropDescriptor++;
        if (RunInRootFrame === sampleLines.length || namePropDescriptor === controlLines.length)
          for (RunInRootFrame = sampleLines.length - 1, namePropDescriptor = controlLines.length - 1; 1 <= RunInRootFrame && 0 <= namePropDescriptor && sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]; )
            namePropDescriptor--;
        for (; 1 <= RunInRootFrame && 0 <= namePropDescriptor; RunInRootFrame--, namePropDescriptor--)
          if (sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
            if (1 !== RunInRootFrame || 1 !== namePropDescriptor) {
              do
                if (RunInRootFrame--, namePropDescriptor--, 0 > namePropDescriptor || sampleLines[RunInRootFrame] !== controlLines[namePropDescriptor]) {
                  var frame = "\n" + sampleLines[RunInRootFrame].replace(" at new ", " at ");
                  fn2.displayName && frame.includes("<anonymous>") && (frame = frame.replace("<anonymous>", fn2.displayName));
                  return frame;
                }
              while (1 <= RunInRootFrame && 0 <= namePropDescriptor);
            }
            break;
          }
      }
    } finally {
      reentry = false, Error.prepareStackTrace = previousPrepareStackTrace;
    }
    return (previousPrepareStackTrace = fn2 ? fn2.displayName || fn2.name : "") ? describeBuiltInComponentFrame(previousPrepareStackTrace) : "";
  }
  function describeFiber(fiber, childFiber) {
    switch (fiber.tag) {
      case 26:
      case 27:
      case 5:
        return describeBuiltInComponentFrame(fiber.type);
      case 16:
        return describeBuiltInComponentFrame("Lazy");
      case 13:
        return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
      case 19:
        return describeBuiltInComponentFrame("SuspenseList");
      case 0:
      case 15:
        return describeNativeComponentFrame(fiber.type, false);
      case 11:
        return describeNativeComponentFrame(fiber.type.render, false);
      case 1:
        return describeNativeComponentFrame(fiber.type, true);
      case 31:
        return describeBuiltInComponentFrame("Activity");
      default:
        return "";
    }
  }
  function getStackByFiberInDevAndProd(workInProgress2) {
    try {
      var info = "", previous2 = null;
      do
        info += describeFiber(workInProgress2, previous2), previous2 = workInProgress2, workInProgress2 = workInProgress2.return;
      while (workInProgress2);
      return info;
    } catch (x2) {
      return "\nError generating stack: " + x2.message + "\n" + x2.stack;
    }
  }
  var hasOwnProperty2 = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler2.unstable_scheduleCallback, cancelCallback$1 = Scheduler2.unstable_cancelCallback, shouldYield = Scheduler2.unstable_shouldYield, requestPaint = Scheduler2.unstable_requestPaint, now = Scheduler2.unstable_now, getCurrentPriorityLevel = Scheduler2.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler2.unstable_ImmediatePriority, UserBlockingPriority = Scheduler2.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler2.unstable_NormalPriority, LowPriority = Scheduler2.unstable_LowPriority, IdlePriority = Scheduler2.unstable_IdlePriority, log$12 = Scheduler2.log, unstable_setDisableYieldValue = Scheduler2.unstable_setDisableYieldValue, rendererID = null, injectedHook = null;
  function setIsStrictModeForDevtools(newIsStrictMode) {
    "function" === typeof log$12 && unstable_setDisableYieldValue(newIsStrictMode);
    if (injectedHook && "function" === typeof injectedHook.setStrictMode)
      try {
        injectedHook.setStrictMode(rendererID, newIsStrictMode);
      } catch (err) {
      }
  }
  var clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log3 = Math.log, LN2 = Math.LN2;
  function clz32Fallback(x2) {
    x2 >>>= 0;
    return 0 === x2 ? 32 : 31 - (log3(x2) / LN2 | 0) | 0;
  }
  var nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304;
  function getHighestPriorityLanes(lanes) {
    var pendingSyncLanes = lanes & 42;
    if (0 !== pendingSyncLanes) return pendingSyncLanes;
    switch (lanes & -lanes) {
      case 1:
        return 1;
      case 2:
        return 2;
      case 4:
        return 4;
      case 8:
        return 8;
      case 16:
        return 16;
      case 32:
        return 32;
      case 64:
        return 64;
      case 128:
        return 128;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
        return lanes & 261888;
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return lanes & 3932160;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return lanes & 62914560;
      case 67108864:
        return 67108864;
      case 134217728:
        return 134217728;
      case 268435456:
        return 268435456;
      case 536870912:
        return 536870912;
      case 1073741824:
        return 0;
      default:
        return lanes;
    }
  }
  function getNextLanes(root3, wipLanes, rootHasPendingCommit) {
    var pendingLanes = root3.pendingLanes;
    if (0 === pendingLanes) return 0;
    var nextLanes = 0, suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
    root3 = root3.warmLanes;
    var nonIdlePendingLanes = pendingLanes & 134217727;
    0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
    return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
  }
  function checkIfRootIsPrerendering(root3, renderLanes2) {
    return 0 === (root3.pendingLanes & ~(root3.suspendedLanes & ~root3.pingedLanes) & renderLanes2);
  }
  function computeExpirationTime(lane, currentTime) {
    switch (lane) {
      case 1:
      case 2:
      case 4:
      case 8:
      case 64:
        return currentTime + 250;
      case 16:
      case 32:
      case 128:
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
        return currentTime + 5e3;
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        return -1;
      case 67108864:
      case 134217728:
      case 268435456:
      case 536870912:
      case 1073741824:
        return -1;
      default:
        return -1;
    }
  }
  function claimNextRetryLane() {
    var lane = nextRetryLane;
    nextRetryLane <<= 1;
    0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
    return lane;
  }
  function createLaneMap(initial2) {
    for (var laneMap = [], i2 = 0; 31 > i2; i2++) laneMap.push(initial2);
    return laneMap;
  }
  function markRootUpdated$1(root3, updateLane) {
    root3.pendingLanes |= updateLane;
    268435456 !== updateLane && (root3.suspendedLanes = 0, root3.pingedLanes = 0, root3.warmLanes = 0);
  }
  function markRootFinished(root3, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
    var previouslyPendingLanes = root3.pendingLanes;
    root3.pendingLanes = remainingLanes;
    root3.suspendedLanes = 0;
    root3.pingedLanes = 0;
    root3.warmLanes = 0;
    root3.expiredLanes &= remainingLanes;
    root3.entangledLanes &= remainingLanes;
    root3.errorRecoveryDisabledLanes &= remainingLanes;
    root3.shellSuspendCounter = 0;
    var entanglements = root3.entanglements, expirationTimes = root3.expirationTimes, hiddenUpdates = root3.hiddenUpdates;
    for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
      var index$7 = 31 - clz32(remainingLanes), lane = 1 << index$7;
      entanglements[index$7] = 0;
      expirationTimes[index$7] = -1;
      var hiddenUpdatesForLane = hiddenUpdates[index$7];
      if (null !== hiddenUpdatesForLane)
        for (hiddenUpdates[index$7] = null, index$7 = 0; index$7 < hiddenUpdatesForLane.length; index$7++) {
          var update = hiddenUpdatesForLane[index$7];
          null !== update && (update.lane &= -536870913);
        }
      remainingLanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, 0);
    0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root3.tag && (root3.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
  }
  function markSpawnedDeferredLane(root3, spawnedLane, entangledLanes) {
    root3.pendingLanes |= spawnedLane;
    root3.suspendedLanes &= ~spawnedLane;
    var spawnedLaneIndex = 31 - clz32(spawnedLane);
    root3.entangledLanes |= spawnedLane;
    root3.entanglements[spawnedLaneIndex] = root3.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
  }
  function markRootEntangled(root3, entangledLanes) {
    var rootEntangledLanes = root3.entangledLanes |= entangledLanes;
    for (root3 = root3.entanglements; rootEntangledLanes; ) {
      var index$8 = 31 - clz32(rootEntangledLanes), lane = 1 << index$8;
      lane & entangledLanes | root3[index$8] & entangledLanes && (root3[index$8] |= entangledLanes);
      rootEntangledLanes &= ~lane;
    }
  }
  function getBumpedLaneForHydration(root3, renderLanes2) {
    var renderLane = renderLanes2 & -renderLanes2;
    renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
    return 0 !== (renderLane & (root3.suspendedLanes | renderLanes2)) ? 0 : renderLane;
  }
  function getBumpedLaneForHydrationByLane(lane) {
    switch (lane) {
      case 2:
        lane = 1;
        break;
      case 8:
        lane = 4;
        break;
      case 32:
        lane = 16;
        break;
      case 256:
      case 512:
      case 1024:
      case 2048:
      case 4096:
      case 8192:
      case 16384:
      case 32768:
      case 65536:
      case 131072:
      case 262144:
      case 524288:
      case 1048576:
      case 2097152:
      case 4194304:
      case 8388608:
      case 16777216:
      case 33554432:
        lane = 128;
        break;
      case 268435456:
        lane = 134217728;
        break;
      default:
        lane = 0;
    }
    return lane;
  }
  function lanesToEventPriority(lanes) {
    lanes &= -lanes;
    return 2 < lanes ? 8 < lanes ? 0 !== (lanes & 134217727) ? 32 : 268435456 : 8 : 2;
  }
  function resolveUpdatePriority() {
    var updatePriority = ReactDOMSharedInternals.p;
    if (0 !== updatePriority) return updatePriority;
    updatePriority = window.event;
    return void 0 === updatePriority ? 32 : getEventPriority(updatePriority.type);
  }
  function runWithPriority(priority, fn2) {
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      return ReactDOMSharedInternals.p = priority, fn2();
    } finally {
      ReactDOMSharedInternals.p = previousPriority;
    }
  }
  var randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey;
  function detachDeletedInstance(node) {
    delete node[internalInstanceKey];
    delete node[internalPropsKey];
    delete node[internalEventHandlersKey];
    delete node[internalEventHandlerListenersKey];
    delete node[internalEventHandlesSetKey];
  }
  function getClosestInstanceFromNode(targetNode) {
    var targetInst = targetNode[internalInstanceKey];
    if (targetInst) return targetInst;
    for (var parentNode = targetNode.parentNode; parentNode; ) {
      if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
        parentNode = targetInst.alternate;
        if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
          for (targetNode = getParentHydrationBoundary(targetNode); null !== targetNode; ) {
            if (parentNode = targetNode[internalInstanceKey]) return parentNode;
            targetNode = getParentHydrationBoundary(targetNode);
          }
        return targetInst;
      }
      targetNode = parentNode;
      parentNode = targetNode.parentNode;
    }
    return null;
  }
  function getInstanceFromNode(node) {
    if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2 || 13 === tag2 || 31 === tag2 || 26 === tag2 || 27 === tag2 || 3 === tag2)
        return node;
    }
    return null;
  }
  function getNodeFromInstance(inst) {
    var tag2 = inst.tag;
    if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return inst.stateNode;
    throw Error(formatProdErrorMessage2(33));
  }
  function getResourcesFromRoot(root3) {
    var resources = root3[internalRootNodeResourcesKey];
    resources || (resources = root3[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
    return resources;
  }
  function markNodeAsHoistable(node) {
    node[internalHoistableMarker] = true;
  }
  var allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {};
  function registerTwoPhaseEvent(registrationName, dependencies2) {
    registerDirectEvent(registrationName, dependencies2);
    registerDirectEvent(registrationName + "Capture", dependencies2);
  }
  function registerDirectEvent(registrationName, dependencies2) {
    registrationNameDependencies[registrationName] = dependencies2;
    for (registrationName = 0; registrationName < dependencies2.length; registrationName++)
      allNativeEvents.add(dependencies2[registrationName]);
  }
  var VALID_ATTRIBUTE_NAME_REGEX = RegExp(
    "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
  ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {};
  function isAttributeNameSafe(attributeName) {
    if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName))
      return true;
    if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName)) return false;
    if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
      return validatedAttributeNameCache[attributeName] = true;
    illegalAttributeNameCache[attributeName] = true;
    return false;
  }
  function setValueForAttribute(node, name2, value) {
    if (isAttributeNameSafe(name2))
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            node.removeAttribute(name2);
            return;
          case "boolean":
            var prefix$10 = name2.toLowerCase().slice(0, 5);
            if ("data-" !== prefix$10 && "aria-" !== prefix$10) {
              node.removeAttribute(name2);
              return;
            }
        }
        node.setAttribute(name2, "" + value);
      }
  }
  function setValueForKnownAttribute(node, name2, value) {
    if (null === value) node.removeAttribute(name2);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name2);
          return;
      }
      node.setAttribute(name2, "" + value);
    }
  }
  function setValueForNamespacedAttribute(node, namespace, name2, value) {
    if (null === value) node.removeAttribute(name2);
    else {
      switch (typeof value) {
        case "undefined":
        case "function":
        case "symbol":
        case "boolean":
          node.removeAttribute(name2);
          return;
      }
      node.setAttributeNS(namespace, name2, "" + value);
    }
  }
  function getToStringValue(value) {
    switch (typeof value) {
      case "bigint":
      case "boolean":
      case "number":
      case "string":
      case "undefined":
        return value;
      case "object":
        return value;
      default:
        return "";
    }
  }
  function isCheckable(elem) {
    var type = elem.type;
    return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
  }
  function trackValueOnNode(node, valueField, currentValue) {
    var descriptor = Object.getOwnPropertyDescriptor(
      node.constructor.prototype,
      valueField
    );
    if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
      var get2 = descriptor.get, set2 = descriptor.set;
      Object.defineProperty(node, valueField, {
        configurable: true,
        get: function() {
          return get2.call(this);
        },
        set: function(value) {
          currentValue = "" + value;
          set2.call(this, value);
        }
      });
      Object.defineProperty(node, valueField, {
        enumerable: descriptor.enumerable
      });
      return {
        getValue: function() {
          return currentValue;
        },
        setValue: function(value) {
          currentValue = "" + value;
        },
        stopTracking: function() {
          node._valueTracker = null;
          delete node[valueField];
        }
      };
    }
  }
  function track(node) {
    if (!node._valueTracker) {
      var valueField = isCheckable(node) ? "checked" : "value";
      node._valueTracker = trackValueOnNode(
        node,
        valueField,
        "" + node[valueField]
      );
    }
  }
  function updateValueIfChanged(node) {
    if (!node) return false;
    var tracker = node._valueTracker;
    if (!tracker) return true;
    var lastValue = tracker.getValue();
    var value = "";
    node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
    node = value;
    return node !== lastValue ? (tracker.setValue(node), true) : false;
  }
  function getActiveElement2(doc2) {
    doc2 = doc2 || ("undefined" !== typeof document ? document : void 0);
    if ("undefined" === typeof doc2) return null;
    try {
      return doc2.activeElement || doc2.body;
    } catch (e2) {
      return doc2.body;
    }
  }
  var escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g;
  function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
    return value.replace(
      escapeSelectorAttributeValueInsideDoubleQuotesRegex,
      function(ch) {
        return "\\" + ch.charCodeAt(0).toString(16) + " ";
      }
    );
  }
  function updateInput(element2, value, defaultValue2, lastDefaultValue, checked, defaultChecked, type, name2) {
    element2.name = "";
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? element2.type = type : element2.removeAttribute("type");
    if (null != value)
      if ("number" === type) {
        if (0 === value && "" === element2.value || element2.value != value)
          element2.value = "" + getToStringValue(value);
      } else
        element2.value !== "" + getToStringValue(value) && (element2.value = "" + getToStringValue(value));
    else
      "submit" !== type && "reset" !== type || element2.removeAttribute("value");
    null != value ? setDefaultValue(element2, type, getToStringValue(value)) : null != defaultValue2 ? setDefaultValue(element2, type, getToStringValue(defaultValue2)) : null != lastDefaultValue && element2.removeAttribute("value");
    null == checked && null != defaultChecked && (element2.defaultChecked = !!defaultChecked);
    null != checked && (element2.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
    null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 ? element2.name = "" + getToStringValue(name2) : element2.removeAttribute("name");
  }
  function initInput(element2, value, defaultValue2, checked, defaultChecked, type, name2, isHydrating2) {
    null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (element2.type = type);
    if (null != value || null != defaultValue2) {
      if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
        track(element2);
        return;
      }
      defaultValue2 = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
      value = null != value ? "" + getToStringValue(value) : defaultValue2;
      isHydrating2 || value === element2.value || (element2.value = value);
      element2.defaultValue = value;
    }
    checked = null != checked ? checked : defaultChecked;
    checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
    element2.checked = isHydrating2 ? element2.checked : !!checked;
    element2.defaultChecked = !!checked;
    null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 && (element2.name = name2);
    track(element2);
  }
  function setDefaultValue(node, type, value) {
    "number" === type && getActiveElement2(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
  }
  function updateOptions(node, multiple, propValue, setDefaultSelected) {
    node = node.options;
    if (multiple) {
      multiple = {};
      for (var i2 = 0; i2 < propValue.length; i2++)
        multiple["$" + propValue[i2]] = true;
      for (propValue = 0; propValue < node.length; propValue++)
        i2 = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i2 && (node[propValue].selected = i2), i2 && setDefaultSelected && (node[propValue].defaultSelected = true);
    } else {
      propValue = "" + getToStringValue(propValue);
      multiple = null;
      for (i2 = 0; i2 < node.length; i2++) {
        if (node[i2].value === propValue) {
          node[i2].selected = true;
          setDefaultSelected && (node[i2].defaultSelected = true);
          return;
        }
        null !== multiple || node[i2].disabled || (multiple = node[i2]);
      }
      null !== multiple && (multiple.selected = true);
    }
  }
  function updateTextarea(element2, value, defaultValue2) {
    if (null != value && (value = "" + getToStringValue(value), value !== element2.value && (element2.value = value), null == defaultValue2)) {
      element2.defaultValue !== value && (element2.defaultValue = value);
      return;
    }
    element2.defaultValue = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
  }
  function initTextarea(element2, value, defaultValue2, children) {
    if (null == value) {
      if (null != children) {
        if (null != defaultValue2) throw Error(formatProdErrorMessage2(92));
        if (isArrayImpl(children)) {
          if (1 < children.length) throw Error(formatProdErrorMessage2(93));
          children = children[0];
        }
        defaultValue2 = children;
      }
      null == defaultValue2 && (defaultValue2 = "");
      value = defaultValue2;
    }
    defaultValue2 = getToStringValue(value);
    element2.defaultValue = defaultValue2;
    children = element2.textContent;
    children === defaultValue2 && "" !== children && null !== children && (element2.value = children);
    track(element2);
  }
  function setTextContent(node, text2) {
    if (text2) {
      var firstChild = node.firstChild;
      if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
        firstChild.nodeValue = text2;
        return;
      }
    }
    node.textContent = text2;
  }
  var unitlessNumbers = new Set(
    "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
      " "
    )
  );
  function setValueForStyle(style2, styleName, value) {
    var isCustomProperty = 0 === styleName.indexOf("--");
    null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style2.setProperty(styleName, "") : "float" === styleName ? style2.cssFloat = "" : style2[styleName] = "" : isCustomProperty ? style2.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style2.cssFloat = value : style2[styleName] = ("" + value).trim() : style2[styleName] = value + "px";
  }
  function setValueForStyles(node, styles, prevStyles) {
    if (null != styles && "object" !== typeof styles)
      throw Error(formatProdErrorMessage2(62));
    node = node.style;
    if (null != prevStyles) {
      for (var styleName in prevStyles)
        !prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
      for (var styleName$16 in styles)
        styleName = styles[styleName$16], styles.hasOwnProperty(styleName$16) && prevStyles[styleName$16] !== styleName && setValueForStyle(node, styleName$16, styleName);
    } else
      for (var styleName$17 in styles)
        styles.hasOwnProperty(styleName$17) && setValueForStyle(node, styleName$17, styles[styleName$17]);
  }
  function isCustomElement(tagName) {
    if (-1 === tagName.indexOf("-")) return false;
    switch (tagName) {
      case "annotation-xml":
      case "color-profile":
      case "font-face":
      case "font-face-src":
      case "font-face-uri":
      case "font-face-format":
      case "font-face-name":
      case "missing-glyph":
        return false;
      default:
        return true;
    }
  }
  var aliases = /* @__PURE__ */ new Map([
    ["acceptCharset", "accept-charset"],
    ["htmlFor", "for"],
    ["httpEquiv", "http-equiv"],
    ["crossOrigin", "crossorigin"],
    ["accentHeight", "accent-height"],
    ["alignmentBaseline", "alignment-baseline"],
    ["arabicForm", "arabic-form"],
    ["baselineShift", "baseline-shift"],
    ["capHeight", "cap-height"],
    ["clipPath", "clip-path"],
    ["clipRule", "clip-rule"],
    ["colorInterpolation", "color-interpolation"],
    ["colorInterpolationFilters", "color-interpolation-filters"],
    ["colorProfile", "color-profile"],
    ["colorRendering", "color-rendering"],
    ["dominantBaseline", "dominant-baseline"],
    ["enableBackground", "enable-background"],
    ["fillOpacity", "fill-opacity"],
    ["fillRule", "fill-rule"],
    ["floodColor", "flood-color"],
    ["floodOpacity", "flood-opacity"],
    ["fontFamily", "font-family"],
    ["fontSize", "font-size"],
    ["fontSizeAdjust", "font-size-adjust"],
    ["fontStretch", "font-stretch"],
    ["fontStyle", "font-style"],
    ["fontVariant", "font-variant"],
    ["fontWeight", "font-weight"],
    ["glyphName", "glyph-name"],
    ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
    ["glyphOrientationVertical", "glyph-orientation-vertical"],
    ["horizAdvX", "horiz-adv-x"],
    ["horizOriginX", "horiz-origin-x"],
    ["imageRendering", "image-rendering"],
    ["letterSpacing", "letter-spacing"],
    ["lightingColor", "lighting-color"],
    ["markerEnd", "marker-end"],
    ["markerMid", "marker-mid"],
    ["markerStart", "marker-start"],
    ["overlinePosition", "overline-position"],
    ["overlineThickness", "overline-thickness"],
    ["paintOrder", "paint-order"],
    ["panose-1", "panose-1"],
    ["pointerEvents", "pointer-events"],
    ["renderingIntent", "rendering-intent"],
    ["shapeRendering", "shape-rendering"],
    ["stopColor", "stop-color"],
    ["stopOpacity", "stop-opacity"],
    ["strikethroughPosition", "strikethrough-position"],
    ["strikethroughThickness", "strikethrough-thickness"],
    ["strokeDasharray", "stroke-dasharray"],
    ["strokeDashoffset", "stroke-dashoffset"],
    ["strokeLinecap", "stroke-linecap"],
    ["strokeLinejoin", "stroke-linejoin"],
    ["strokeMiterlimit", "stroke-miterlimit"],
    ["strokeOpacity", "stroke-opacity"],
    ["strokeWidth", "stroke-width"],
    ["textAnchor", "text-anchor"],
    ["textDecoration", "text-decoration"],
    ["textRendering", "text-rendering"],
    ["transformOrigin", "transform-origin"],
    ["underlinePosition", "underline-position"],
    ["underlineThickness", "underline-thickness"],
    ["unicodeBidi", "unicode-bidi"],
    ["unicodeRange", "unicode-range"],
    ["unitsPerEm", "units-per-em"],
    ["vAlphabetic", "v-alphabetic"],
    ["vHanging", "v-hanging"],
    ["vIdeographic", "v-ideographic"],
    ["vMathematical", "v-mathematical"],
    ["vectorEffect", "vector-effect"],
    ["vertAdvY", "vert-adv-y"],
    ["vertOriginX", "vert-origin-x"],
    ["vertOriginY", "vert-origin-y"],
    ["wordSpacing", "word-spacing"],
    ["writingMode", "writing-mode"],
    ["xmlnsXlink", "xmlns:xlink"],
    ["xHeight", "x-height"]
  ]), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i;
  function sanitizeURL(url) {
    return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
  }
  function noop$12() {
  }
  var currentReplayingEvent = null;
  function getEventTarget(nativeEvent) {
    nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
    nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
    return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
  }
  var restoreTarget = null, restoreQueue = null;
  function restoreStateOfTarget(target) {
    var internalInstance = getInstanceFromNode(target);
    if (internalInstance && (target = internalInstance.stateNode)) {
      var props2 = target[internalPropsKey] || null;
      a: switch (target = internalInstance.stateNode, internalInstance.type) {
        case "input":
          updateInput(
            target,
            props2.value,
            props2.defaultValue,
            props2.defaultValue,
            props2.checked,
            props2.defaultChecked,
            props2.type,
            props2.name
          );
          internalInstance = props2.name;
          if ("radio" === props2.type && null != internalInstance) {
            for (props2 = target; props2.parentNode; ) props2 = props2.parentNode;
            props2 = props2.querySelectorAll(
              'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                "" + internalInstance
              ) + '"][type="radio"]'
            );
            for (internalInstance = 0; internalInstance < props2.length; internalInstance++) {
              var otherNode = props2[internalInstance];
              if (otherNode !== target && otherNode.form === target.form) {
                var otherProps = otherNode[internalPropsKey] || null;
                if (!otherProps) throw Error(formatProdErrorMessage2(90));
                updateInput(
                  otherNode,
                  otherProps.value,
                  otherProps.defaultValue,
                  otherProps.defaultValue,
                  otherProps.checked,
                  otherProps.defaultChecked,
                  otherProps.type,
                  otherProps.name
                );
              }
            }
            for (internalInstance = 0; internalInstance < props2.length; internalInstance++)
              otherNode = props2[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
          }
          break a;
        case "textarea":
          updateTextarea(target, props2.value, props2.defaultValue);
          break a;
        case "select":
          internalInstance = props2.value, null != internalInstance && updateOptions(target, !!props2.multiple, internalInstance, false);
      }
    }
  }
  var isInsideEventHandler = false;
  function batchedUpdates$1(fn2, a2, b2) {
    if (isInsideEventHandler) return fn2(a2, b2);
    isInsideEventHandler = true;
    try {
      var JSCompiler_inline_result = fn2(a2);
      return JSCompiler_inline_result;
    } finally {
      if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
        if (flushSyncWork$1(), restoreTarget && (a2 = restoreTarget, fn2 = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a2), fn2))
          for (a2 = 0; a2 < fn2.length; a2++) restoreStateOfTarget(fn2[a2]);
      }
    }
  }
  function getListener(inst, registrationName) {
    var stateNode = inst.stateNode;
    if (null === stateNode) return null;
    var props2 = stateNode[internalPropsKey] || null;
    if (null === props2) return null;
    stateNode = props2[registrationName];
    a: switch (registrationName) {
      case "onClick":
      case "onClickCapture":
      case "onDoubleClick":
      case "onDoubleClickCapture":
      case "onMouseDown":
      case "onMouseDownCapture":
      case "onMouseMove":
      case "onMouseMoveCapture":
      case "onMouseUp":
      case "onMouseUpCapture":
      case "onMouseEnter":
        (props2 = !props2.disabled) || (inst = inst.type, props2 = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
        inst = !props2;
        break a;
      default:
        inst = false;
    }
    if (inst) return null;
    if (stateNode && "function" !== typeof stateNode)
      throw Error(
        formatProdErrorMessage2(231, registrationName, typeof stateNode)
      );
    return stateNode;
  }
  var canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
  if (canUseDOM2)
    try {
      var options2 = {};
      Object.defineProperty(options2, "passive", {
        get: function() {
          passiveBrowserEventsSupported = true;
        }
      });
      window.addEventListener("test", options2, options2);
      window.removeEventListener("test", options2, options2);
    } catch (e2) {
      passiveBrowserEventsSupported = false;
    }
  var root2 = null, startText = null, fallbackText = null;
  function getData() {
    if (fallbackText) return fallbackText;
    var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root2 ? root2.value : root2.textContent, endLength = endValue.length;
    for (start = 0; start < startLength && startValue[start] === endValue[start]; start++) ;
    var minEnd = startLength - start;
    for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
    return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
  }
  function getEventCharCode(nativeEvent) {
    var keyCode = nativeEvent.keyCode;
    "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
    10 === nativeEvent && (nativeEvent = 13);
    return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
  }
  function functionThatReturnsTrue() {
    return true;
  }
  function functionThatReturnsFalse() {
    return false;
  }
  function createSyntheticEvent(Interface) {
    function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
      this._reactName = reactName;
      this._targetInst = targetInst;
      this.type = reactEventType;
      this.nativeEvent = nativeEvent;
      this.target = nativeEventTarget;
      this.currentTarget = null;
      for (var propName in Interface)
        Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
      this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
      this.isPropagationStopped = functionThatReturnsFalse;
      return this;
    }
    assign2(SyntheticBaseEvent.prototype, {
      preventDefault: function() {
        this.defaultPrevented = true;
        var event = this.nativeEvent;
        event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
      },
      stopPropagation: function() {
        var event = this.nativeEvent;
        event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
      },
      persist: function() {
      },
      isPersistent: functionThatReturnsTrue
    });
    return SyntheticBaseEvent;
  }
  var EventInterface = {
    eventPhase: 0,
    bubbles: 0,
    cancelable: 0,
    timeStamp: function(event) {
      return event.timeStamp || Date.now();
    },
    defaultPrevented: 0,
    isTrusted: 0
  }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
    screenX: 0,
    screenY: 0,
    clientX: 0,
    clientY: 0,
    pageX: 0,
    pageY: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    getModifierState: getEventModifierState,
    button: 0,
    buttons: 0,
    relatedTarget: function(event) {
      return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
    },
    movementX: function(event) {
      if ("movementX" in event) return event.movementX;
      event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
      return lastMovementX;
    },
    movementY: function(event) {
      return "movementY" in event ? event.movementY : lastMovementY;
    }
  }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
    animationName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
    clipboardData: function(event) {
      return "clipboardData" in event ? event.clipboardData : window.clipboardData;
    }
  }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(CompositionEventInterface), normalizeKey = {
    Esc: "Escape",
    Spacebar: " ",
    Left: "ArrowLeft",
    Up: "ArrowUp",
    Right: "ArrowRight",
    Down: "ArrowDown",
    Del: "Delete",
    Win: "OS",
    Menu: "ContextMenu",
    Apps: "ContextMenu",
    Scroll: "ScrollLock",
    MozPrintableKey: "Unidentified"
  }, translateToKey = {
    8: "Backspace",
    9: "Tab",
    12: "Clear",
    13: "Enter",
    16: "Shift",
    17: "Control",
    18: "Alt",
    19: "Pause",
    20: "CapsLock",
    27: "Escape",
    32: " ",
    33: "PageUp",
    34: "PageDown",
    35: "End",
    36: "Home",
    37: "ArrowLeft",
    38: "ArrowUp",
    39: "ArrowRight",
    40: "ArrowDown",
    45: "Insert",
    46: "Delete",
    112: "F1",
    113: "F2",
    114: "F3",
    115: "F4",
    116: "F5",
    117: "F6",
    118: "F7",
    119: "F8",
    120: "F9",
    121: "F10",
    122: "F11",
    123: "F12",
    144: "NumLock",
    145: "ScrollLock",
    224: "Meta"
  }, modifierKeyToProp = {
    Alt: "altKey",
    Control: "ctrlKey",
    Meta: "metaKey",
    Shift: "shiftKey"
  };
  function modifierStateGetter(keyArg) {
    var nativeEvent = this.nativeEvent;
    return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
  }
  function getEventModifierState() {
    return modifierStateGetter;
  }
  var KeyboardEventInterface = assign2({}, UIEventInterface, {
    key: function(nativeEvent) {
      if (nativeEvent.key) {
        var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
        if ("Unidentified" !== key) return key;
      }
      return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
    },
    code: 0,
    location: 0,
    ctrlKey: 0,
    shiftKey: 0,
    altKey: 0,
    metaKey: 0,
    repeat: 0,
    locale: 0,
    getModifierState: getEventModifierState,
    charCode: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : 0;
    },
    keyCode: function(event) {
      return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    },
    which: function(event) {
      return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
    }
  }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
    pointerId: 0,
    width: 0,
    height: 0,
    pressure: 0,
    tangentialPressure: 0,
    tiltX: 0,
    tiltY: 0,
    twist: 0,
    pointerType: 0,
    isPrimary: 0
  }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
    touches: 0,
    targetTouches: 0,
    changedTouches: 0,
    altKey: 0,
    metaKey: 0,
    ctrlKey: 0,
    shiftKey: 0,
    getModifierState: getEventModifierState
  }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
    propertyName: 0,
    elapsedTime: 0,
    pseudoElement: 0
  }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
    deltaX: function(event) {
      return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
    },
    deltaY: function(event) {
      return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
    },
    deltaZ: 0,
    deltaMode: 0
  }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
    newState: 0,
    oldState: 0
  }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
  canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
  var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CHAR = String.fromCharCode(32), hasSpaceKeypress = false;
  function isFallbackCompositionEnd(domEventName, nativeEvent) {
    switch (domEventName) {
      case "keyup":
        return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
      case "keydown":
        return 229 !== nativeEvent.keyCode;
      case "keypress":
      case "mousedown":
      case "focusout":
        return true;
      default:
        return false;
    }
  }
  function getDataFromCustomEvent(nativeEvent) {
    nativeEvent = nativeEvent.detail;
    return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
  }
  var isComposing = false;
  function getNativeBeforeInputChars(domEventName, nativeEvent) {
    switch (domEventName) {
      case "compositionend":
        return getDataFromCustomEvent(nativeEvent);
      case "keypress":
        if (32 !== nativeEvent.which) return null;
        hasSpaceKeypress = true;
        return SPACEBAR_CHAR;
      case "textInput":
        return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
      default:
        return null;
    }
  }
  function getFallbackBeforeInputChars(domEventName, nativeEvent) {
    if (isComposing)
      return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root2 = null, isComposing = false, domEventName) : null;
    switch (domEventName) {
      case "paste":
        return null;
      case "keypress":
        if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
          if (nativeEvent.char && 1 < nativeEvent.char.length)
            return nativeEvent.char;
          if (nativeEvent.which) return String.fromCharCode(nativeEvent.which);
        }
        return null;
      case "compositionend":
        return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
      default:
        return null;
    }
  }
  var supportedInputTypes = {
    color: true,
    date: true,
    datetime: true,
    "datetime-local": true,
    email: true,
    month: true,
    number: true,
    password: true,
    range: true,
    search: true,
    tel: true,
    text: true,
    time: true,
    url: true,
    week: true
  };
  function isTextInputElement(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
  }
  function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
    restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
    inst = accumulateTwoPhaseListeners(inst, "onChange");
    0 < inst.length && (nativeEvent = new SyntheticEvent(
      "onChange",
      "change",
      null,
      nativeEvent,
      target
    ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
  }
  var activeElement$1 = null, activeElementInst$1 = null;
  function runEventInBatch(dispatchQueue) {
    processDispatchQueue(dispatchQueue, 0);
  }
  function getInstIfValueChanged(targetInst) {
    var targetNode = getNodeFromInstance(targetInst);
    if (updateValueIfChanged(targetNode)) return targetInst;
  }
  function getTargetInstForChangeEvent(domEventName, targetInst) {
    if ("change" === domEventName) return targetInst;
  }
  var isInputEventSupported = false;
  if (canUseDOM2) {
    var JSCompiler_inline_result$jscomp$286;
    if (canUseDOM2) {
      var isSupported$jscomp$inline_427 = "oninput" in document;
      if (!isSupported$jscomp$inline_427) {
        var element$jscomp$inline_428 = document.createElement("div");
        element$jscomp$inline_428.setAttribute("oninput", "return;");
        isSupported$jscomp$inline_427 = "function" === typeof element$jscomp$inline_428.oninput;
      }
      JSCompiler_inline_result$jscomp$286 = isSupported$jscomp$inline_427;
    } else JSCompiler_inline_result$jscomp$286 = false;
    isInputEventSupported = JSCompiler_inline_result$jscomp$286 && (!document.documentMode || 9 < document.documentMode);
  }
  function stopWatchingForValueChange() {
    activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
  }
  function handlePropertyChange(nativeEvent) {
    if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
      var dispatchQueue = [];
      createAndAccumulateChangeEvent(
        dispatchQueue,
        activeElementInst$1,
        nativeEvent,
        getEventTarget(nativeEvent)
      );
      batchedUpdates$1(runEventInBatch, dispatchQueue);
    }
  }
  function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
    "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
  }
  function getTargetInstForInputEventPolyfill(domEventName) {
    if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
      return getInstIfValueChanged(activeElementInst$1);
  }
  function getTargetInstForClickEvent(domEventName, targetInst) {
    if ("click" === domEventName) return getInstIfValueChanged(targetInst);
  }
  function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
    if ("input" === domEventName || "change" === domEventName)
      return getInstIfValueChanged(targetInst);
  }
  function is2(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2;
  function shallowEqual(objA, objB) {
    if (objectIs(objA, objB)) return true;
    if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
      return false;
    var keysA = Object.keys(objA), keysB = Object.keys(objB);
    if (keysA.length !== keysB.length) return false;
    for (keysB = 0; keysB < keysA.length; keysB++) {
      var currentKey = keysA[keysB];
      if (!hasOwnProperty2.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
        return false;
    }
    return true;
  }
  function getLeafNode(node) {
    for (; node && node.firstChild; ) node = node.firstChild;
    return node;
  }
  function getNodeForCharacterOffset(root3, offset2) {
    var node = getLeafNode(root3);
    root3 = 0;
    for (var nodeEnd; node; ) {
      if (3 === node.nodeType) {
        nodeEnd = root3 + node.textContent.length;
        if (root3 <= offset2 && nodeEnd >= offset2)
          return { node, offset: offset2 - root3 };
        root3 = nodeEnd;
      }
      a: {
        for (; node; ) {
          if (node.nextSibling) {
            node = node.nextSibling;
            break a;
          }
          node = node.parentNode;
        }
        node = void 0;
      }
      node = getLeafNode(node);
    }
  }
  function containsNode(outerNode, innerNode) {
    return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
  }
  function getActiveElementDeep(containerInfo) {
    containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
    for (var element2 = getActiveElement2(containerInfo.document); element2 instanceof containerInfo.HTMLIFrameElement; ) {
      try {
        var JSCompiler_inline_result = "string" === typeof element2.contentWindow.location.href;
      } catch (err) {
        JSCompiler_inline_result = false;
      }
      if (JSCompiler_inline_result) containerInfo = element2.contentWindow;
      else break;
      element2 = getActiveElement2(containerInfo.document);
    }
    return element2;
  }
  function hasSelectionCapabilities(elem) {
    var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
    return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
  }
  var skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false;
  function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
    var doc2 = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
    mouseDown || null == activeElement || activeElement !== getActiveElement2(doc2) || (doc2 = activeElement, "selectionStart" in doc2 && hasSelectionCapabilities(doc2) ? doc2 = { start: doc2.selectionStart, end: doc2.selectionEnd } : (doc2 = (doc2.ownerDocument && doc2.ownerDocument.defaultView || window).getSelection(), doc2 = {
      anchorNode: doc2.anchorNode,
      anchorOffset: doc2.anchorOffset,
      focusNode: doc2.focusNode,
      focusOffset: doc2.focusOffset
    }), lastSelection && shallowEqual(lastSelection, doc2) || (lastSelection = doc2, doc2 = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc2.length && (nativeEvent = new SyntheticEvent(
      "onSelect",
      "select",
      null,
      nativeEvent,
      nativeEventTarget
    ), dispatchQueue.push({ event: nativeEvent, listeners: doc2 }), nativeEvent.target = activeElement)));
  }
  function makePrefixMap(styleProp, eventName) {
    var prefixes = {};
    prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
    prefixes["Webkit" + styleProp] = "webkit" + eventName;
    prefixes["Moz" + styleProp] = "moz" + eventName;
    return prefixes;
  }
  var vendorPrefixes = {
    animationend: makePrefixMap("Animation", "AnimationEnd"),
    animationiteration: makePrefixMap("Animation", "AnimationIteration"),
    animationstart: makePrefixMap("Animation", "AnimationStart"),
    transitionrun: makePrefixMap("Transition", "TransitionRun"),
    transitionstart: makePrefixMap("Transition", "TransitionStart"),
    transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
    transitionend: makePrefixMap("Transition", "TransitionEnd")
  }, prefixedEventNames = {}, style = {};
  canUseDOM2 && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
  function getVendorPrefixedEventName(eventName) {
    if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
    if (!vendorPrefixes[eventName]) return eventName;
    var prefixMap = vendorPrefixes[eventName], styleProp;
    for (styleProp in prefixMap)
      if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
        return prefixedEventNames[eventName] = prefixMap[styleProp];
    return eventName;
  }
  var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
    " "
  );
  simpleEventPluginEvents.push("scrollEnd");
  function registerSimpleEvent(domEventName, reactName) {
    topLevelEventsToReactNames.set(domEventName, reactName);
    registerTwoPhaseEvent(reactName, [domEventName]);
  }
  var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
    if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
      var event = new window.ErrorEvent("error", {
        bubbles: true,
        cancelable: true,
        message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
        error
      });
      if (!window.dispatchEvent(event)) return;
    } else if ("object" === typeof process && "function" === typeof process.emit) {
      process.emit("uncaughtException", error);
      return;
    }
    console.error(error);
  }, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0;
  function finishQueueingConcurrentUpdates() {
    for (var endIndex = concurrentQueuesIndex, i2 = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i2 < endIndex; ) {
      var fiber = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var queue = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var update = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      var lane = concurrentQueues[i2];
      concurrentQueues[i2++] = null;
      if (null !== queue && null !== update) {
        var pending = queue.pending;
        null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
        queue.pending = update;
      }
      0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
    }
  }
  function enqueueUpdate$1(fiber, queue, update, lane) {
    concurrentQueues[concurrentQueuesIndex++] = fiber;
    concurrentQueues[concurrentQueuesIndex++] = queue;
    concurrentQueues[concurrentQueuesIndex++] = update;
    concurrentQueues[concurrentQueuesIndex++] = lane;
    concurrentlyUpdatedLanes |= lane;
    fiber.lanes |= lane;
    fiber = fiber.alternate;
    null !== fiber && (fiber.lanes |= lane);
  }
  function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
    enqueueUpdate$1(fiber, queue, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function enqueueConcurrentRenderForLane(fiber, lane) {
    enqueueUpdate$1(fiber, null, null, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
    sourceFiber.lanes |= lane;
    var alternate = sourceFiber.alternate;
    null !== alternate && (alternate.lanes |= lane);
    for (var isHidden2 = false, parent = sourceFiber.return; null !== parent; )
      parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & 1 || (isHidden2 = true)), sourceFiber = parent, parent = parent.return;
    return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden2 && null !== update && (isHidden2 = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden2], null === alternate ? sourceFiber[isHidden2] = [update] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
  }
  function getRootForUpdatedFiber(sourceFiber) {
    if (50 < nestedUpdateCount)
      throw nestedUpdateCount = 0, rootWithNestedUpdates = null, Error(formatProdErrorMessage2(185));
    for (var parent = sourceFiber.return; null !== parent; )
      sourceFiber = parent, parent = sourceFiber.return;
    return 3 === sourceFiber.tag ? sourceFiber.stateNode : null;
  }
  var emptyContextObject = {};
  function FiberNode(tag2, pendingProps, key, mode) {
    this.tag = tag2;
    this.key = key;
    this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
    this.index = 0;
    this.refCleanup = this.ref = null;
    this.pendingProps = pendingProps;
    this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
    this.mode = mode;
    this.subtreeFlags = this.flags = 0;
    this.deletions = null;
    this.childLanes = this.lanes = 0;
    this.alternate = null;
  }
  function createFiberImplClass(tag2, pendingProps, key, mode) {
    return new FiberNode(tag2, pendingProps, key, mode);
  }
  function shouldConstruct(Component) {
    Component = Component.prototype;
    return !(!Component || !Component.isReactComponent);
  }
  function createWorkInProgress(current2, pendingProps) {
    var workInProgress2 = current2.alternate;
    null === workInProgress2 ? (workInProgress2 = createFiberImplClass(
      current2.tag,
      pendingProps,
      current2.key,
      current2.mode
    ), workInProgress2.elementType = current2.elementType, workInProgress2.type = current2.type, workInProgress2.stateNode = current2.stateNode, workInProgress2.alternate = current2, current2.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current2.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null);
    workInProgress2.flags = current2.flags & 65011712;
    workInProgress2.childLanes = current2.childLanes;
    workInProgress2.lanes = current2.lanes;
    workInProgress2.child = current2.child;
    workInProgress2.memoizedProps = current2.memoizedProps;
    workInProgress2.memoizedState = current2.memoizedState;
    workInProgress2.updateQueue = current2.updateQueue;
    pendingProps = current2.dependencies;
    workInProgress2.dependencies = null === pendingProps ? null : { lanes: pendingProps.lanes, firstContext: pendingProps.firstContext };
    workInProgress2.sibling = current2.sibling;
    workInProgress2.index = current2.index;
    workInProgress2.ref = current2.ref;
    workInProgress2.refCleanup = current2.refCleanup;
    return workInProgress2;
  }
  function resetWorkInProgress(workInProgress2, renderLanes2) {
    workInProgress2.flags &= 65011714;
    var current2 = workInProgress2.alternate;
    null === current2 ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null) : (workInProgress2.childLanes = current2.childLanes, workInProgress2.lanes = current2.lanes, workInProgress2.child = current2.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current2.memoizedProps, workInProgress2.memoizedState = current2.memoizedState, workInProgress2.updateQueue = current2.updateQueue, workInProgress2.type = current2.type, renderLanes2 = current2.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
      lanes: renderLanes2.lanes,
      firstContext: renderLanes2.firstContext
    });
    return workInProgress2;
  }
  function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
    var fiberTag = 0;
    owner = type;
    if ("function" === typeof type) shouldConstruct(type) && (fiberTag = 1);
    else if ("string" === typeof type)
      fiberTag = isHostHoistableType(
        type,
        pendingProps,
        contextStackCursor.current
      ) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
    else
      a: switch (type) {
        case REACT_ACTIVITY_TYPE:
          return type = createFiberImplClass(31, pendingProps, key, mode), type.elementType = REACT_ACTIVITY_TYPE, type.lanes = lanes, type;
        case REACT_FRAGMENT_TYPE:
          return createFiberFromFragment(pendingProps.children, mode, lanes, key);
        case REACT_STRICT_MODE_TYPE:
          fiberTag = 8;
          mode |= 24;
          break;
        case REACT_PROFILER_TYPE:
          return type = createFiberImplClass(12, pendingProps, key, mode | 2), type.elementType = REACT_PROFILER_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_TYPE:
          return type = createFiberImplClass(13, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_TYPE, type.lanes = lanes, type;
        case REACT_SUSPENSE_LIST_TYPE:
          return type = createFiberImplClass(19, pendingProps, key, mode), type.elementType = REACT_SUSPENSE_LIST_TYPE, type.lanes = lanes, type;
        default:
          if ("object" === typeof type && null !== type)
            switch (type.$$typeof) {
              case REACT_CONTEXT_TYPE:
                fiberTag = 10;
                break a;
              case REACT_CONSUMER_TYPE:
                fiberTag = 9;
                break a;
              case REACT_FORWARD_REF_TYPE:
                fiberTag = 11;
                break a;
              case REACT_MEMO_TYPE:
                fiberTag = 14;
                break a;
              case REACT_LAZY_TYPE:
                fiberTag = 16;
                owner = null;
                break a;
            }
          fiberTag = 29;
          pendingProps = Error(
            formatProdErrorMessage2(130, null === type ? "null" : typeof type, "")
          );
          owner = null;
      }
    key = createFiberImplClass(fiberTag, pendingProps, key, mode);
    key.elementType = type;
    key.type = owner;
    key.lanes = lanes;
    return key;
  }
  function createFiberFromFragment(elements2, mode, lanes, key) {
    elements2 = createFiberImplClass(7, elements2, key, mode);
    elements2.lanes = lanes;
    return elements2;
  }
  function createFiberFromText(content2, mode, lanes) {
    content2 = createFiberImplClass(6, content2, null, mode);
    content2.lanes = lanes;
    return content2;
  }
  function createFiberFromDehydratedFragment(dehydratedNode) {
    var fiber = createFiberImplClass(18, null, null, 0);
    fiber.stateNode = dehydratedNode;
    return fiber;
  }
  function createFiberFromPortal(portal, mode, lanes) {
    mode = createFiberImplClass(
      4,
      null !== portal.children ? portal.children : [],
      portal.key,
      mode
    );
    mode.lanes = lanes;
    mode.stateNode = {
      containerInfo: portal.containerInfo,
      pendingChildren: null,
      implementation: portal.implementation
    };
    return mode;
  }
  var CapturedStacks = /* @__PURE__ */ new WeakMap();
  function createCapturedValueAtFiber(value, source) {
    if ("object" === typeof value && null !== value) {
      var existing = CapturedStacks.get(value);
      if (void 0 !== existing) return existing;
      source = {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
      CapturedStacks.set(value, source);
      return source;
    }
    return {
      value,
      source,
      stack: getStackByFiberInDevAndProd(source)
    };
  }
  var forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "";
  function pushTreeFork(workInProgress2, totalChildren) {
    forkStack[forkStackIndex++] = treeForkCount;
    forkStack[forkStackIndex++] = treeForkProvider;
    treeForkProvider = workInProgress2;
    treeForkCount = totalChildren;
  }
  function pushTreeId(workInProgress2, totalChildren, index3) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextProvider = workInProgress2;
    var baseIdWithLeadingBit = treeContextId;
    workInProgress2 = treeContextOverflow;
    var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
    baseIdWithLeadingBit &= ~(1 << baseLength);
    index3 += 1;
    var length = 32 - clz32(totalChildren) + baseLength;
    if (30 < length) {
      var numberOfOverflowBits = baseLength - baseLength % 5;
      length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
      baseIdWithLeadingBit >>= numberOfOverflowBits;
      baseLength -= numberOfOverflowBits;
      treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index3 << baseLength | baseIdWithLeadingBit;
      treeContextOverflow = length + workInProgress2;
    } else
      treeContextId = 1 << length | index3 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
  }
  function pushMaterializedTreeId(workInProgress2) {
    null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
  }
  function popTreeContext(workInProgress2) {
    for (; workInProgress2 === treeForkProvider; )
      treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
    for (; workInProgress2 === treeContextProvider; )
      treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
  }
  function restoreSuspendedTreeContext(workInProgress2, suspendedContext) {
    idStack[idStackIndex++] = treeContextId;
    idStack[idStackIndex++] = treeContextOverflow;
    idStack[idStackIndex++] = treeContextProvider;
    treeContextId = suspendedContext.id;
    treeContextOverflow = suspendedContext.overflow;
    treeContextProvider = workInProgress2;
  }
  var hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(formatProdErrorMessage2(519));
  function throwOnHydrationMismatch(fiber) {
    var error = Error(
      formatProdErrorMessage2(
        418,
        1 < arguments.length && void 0 !== arguments[1] && arguments[1] ? "text" : "HTML",
        ""
      )
    );
    queueHydrationError(createCapturedValueAtFiber(error, fiber));
    throw HydrationMismatchException;
  }
  function prepareToHydrateHostInstance(fiber) {
    var instance = fiber.stateNode, type = fiber.type, props2 = fiber.memoizedProps;
    instance[internalInstanceKey] = fiber;
    instance[internalPropsKey] = props2;
    switch (type) {
      case "dialog":
        listenToNonDelegatedEvent("cancel", instance);
        listenToNonDelegatedEvent("close", instance);
        break;
      case "iframe":
      case "object":
      case "embed":
        listenToNonDelegatedEvent("load", instance);
        break;
      case "video":
      case "audio":
        for (type = 0; type < mediaEventTypes.length; type++)
          listenToNonDelegatedEvent(mediaEventTypes[type], instance);
        break;
      case "source":
        listenToNonDelegatedEvent("error", instance);
        break;
      case "img":
      case "image":
      case "link":
        listenToNonDelegatedEvent("error", instance);
        listenToNonDelegatedEvent("load", instance);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", instance);
        break;
      case "input":
        listenToNonDelegatedEvent("invalid", instance);
        initInput(
          instance,
          props2.value,
          props2.defaultValue,
          props2.checked,
          props2.defaultChecked,
          props2.type,
          props2.name,
          true
        );
        break;
      case "select":
        listenToNonDelegatedEvent("invalid", instance);
        break;
      case "textarea":
        listenToNonDelegatedEvent("invalid", instance), initTextarea(instance, props2.value, props2.defaultValue, props2.children);
    }
    type = props2.children;
    "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || instance.textContent === "" + type || true === props2.suppressHydrationWarning || checkForUnmatchedText(instance.textContent, type) ? (null != props2.popover && (listenToNonDelegatedEvent("beforetoggle", instance), listenToNonDelegatedEvent("toggle", instance)), null != props2.onScroll && listenToNonDelegatedEvent("scroll", instance), null != props2.onScrollEnd && listenToNonDelegatedEvent("scrollend", instance), null != props2.onClick && (instance.onclick = noop$12), instance = true) : instance = false;
    instance || throwOnHydrationMismatch(fiber, true);
  }
  function popToNextHostParent(fiber) {
    for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
      switch (hydrationParentFiber.tag) {
        case 5:
        case 31:
        case 13:
          rootOrSingletonContext = false;
          return;
        case 27:
        case 3:
          rootOrSingletonContext = true;
          return;
        default:
          hydrationParentFiber = hydrationParentFiber.return;
      }
  }
  function popHydrationState(fiber) {
    if (fiber !== hydrationParentFiber) return false;
    if (!isHydrating) return popToNextHostParent(fiber), isHydrating = true, false;
    var tag2 = fiber.tag, JSCompiler_temp;
    if (JSCompiler_temp = 3 !== tag2 && 27 !== tag2) {
      if (JSCompiler_temp = 5 === tag2)
        JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
      JSCompiler_temp = !JSCompiler_temp;
    }
    JSCompiler_temp && nextHydratableInstance && throwOnHydrationMismatch(fiber);
    popToNextHostParent(fiber);
    if (13 === tag2) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage2(317));
      nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else if (31 === tag2) {
      fiber = fiber.memoizedState;
      fiber = null !== fiber ? fiber.dehydrated : null;
      if (!fiber) throw Error(formatProdErrorMessage2(317));
      nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
    } else
      27 === tag2 ? (tag2 = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag2) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
    return true;
  }
  function resetHydrationState() {
    nextHydratableInstance = hydrationParentFiber = null;
    isHydrating = false;
  }
  function upgradeHydrationErrorsToRecoverable() {
    var queuedErrors = hydrationErrors;
    null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
      workInProgressRootRecoverableErrors,
      queuedErrors
    ), hydrationErrors = null);
    return queuedErrors;
  }
  function queueHydrationError(error) {
    null === hydrationErrors ? hydrationErrors = [error] : hydrationErrors.push(error);
  }
  var valueCursor = createCursor(null), currentlyRenderingFiber$1 = null, lastContextDependency = null;
  function pushProvider(providerFiber, context, nextValue) {
    push2(valueCursor, context._currentValue);
    context._currentValue = nextValue;
  }
  function popProvider(context) {
    context._currentValue = valueCursor.current;
    pop(valueCursor);
  }
  function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
    for (; null !== parent; ) {
      var alternate = parent.alternate;
      (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
      if (parent === propagationRoot) break;
      parent = parent.return;
    }
  }
  function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
    var fiber = workInProgress2.child;
    null !== fiber && (fiber.return = workInProgress2);
    for (; null !== fiber; ) {
      var list2 = fiber.dependencies;
      if (null !== list2) {
        var nextFiber = fiber.child;
        list2 = list2.firstContext;
        a: for (; null !== list2; ) {
          var dependency = list2;
          list2 = fiber;
          for (var i2 = 0; i2 < contexts.length; i2++)
            if (dependency.context === contexts[i2]) {
              list2.lanes |= renderLanes2;
              dependency = list2.alternate;
              null !== dependency && (dependency.lanes |= renderLanes2);
              scheduleContextWorkOnParentPath(
                list2.return,
                renderLanes2,
                workInProgress2
              );
              forcePropagateEntireTree || (nextFiber = null);
              break a;
            }
          list2 = dependency.next;
        }
      } else if (18 === fiber.tag) {
        nextFiber = fiber.return;
        if (null === nextFiber) throw Error(formatProdErrorMessage2(341));
        nextFiber.lanes |= renderLanes2;
        list2 = nextFiber.alternate;
        null !== list2 && (list2.lanes |= renderLanes2);
        scheduleContextWorkOnParentPath(nextFiber, renderLanes2, workInProgress2);
        nextFiber = null;
      } else nextFiber = fiber.child;
      if (null !== nextFiber) nextFiber.return = fiber;
      else
        for (nextFiber = fiber; null !== nextFiber; ) {
          if (nextFiber === workInProgress2) {
            nextFiber = null;
            break;
          }
          fiber = nextFiber.sibling;
          if (null !== fiber) {
            fiber.return = nextFiber.return;
            nextFiber = fiber;
            break;
          }
          nextFiber = nextFiber.return;
        }
      fiber = nextFiber;
    }
  }
  function propagateParentContextChanges(current2, workInProgress2, renderLanes2, forcePropagateEntireTree) {
    current2 = null;
    for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
      if (!isInsidePropagationBailout) {
        if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
        else if (0 !== (parent.flags & 262144)) break;
      }
      if (10 === parent.tag) {
        var currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage2(387));
        currentParent = currentParent.memoizedProps;
        if (null !== currentParent) {
          var context = parent.type;
          objectIs(parent.pendingProps.value, currentParent.value) || (null !== current2 ? current2.push(context) : current2 = [context]);
        }
      } else if (parent === hostTransitionProviderCursor.current) {
        currentParent = parent.alternate;
        if (null === currentParent) throw Error(formatProdErrorMessage2(387));
        currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current2 ? current2.push(HostTransitionContext) : current2 = [HostTransitionContext]);
      }
      parent = parent.return;
    }
    null !== current2 && propagateContextChanges(
      workInProgress2,
      current2,
      renderLanes2,
      forcePropagateEntireTree
    );
    workInProgress2.flags |= 262144;
  }
  function checkIfContextChanged(currentDependencies) {
    for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
      if (!objectIs(
        currentDependencies.context._currentValue,
        currentDependencies.memoizedValue
      ))
        return true;
      currentDependencies = currentDependencies.next;
    }
    return false;
  }
  function prepareToReadContext(workInProgress2) {
    currentlyRenderingFiber$1 = workInProgress2;
    lastContextDependency = null;
    workInProgress2 = workInProgress2.dependencies;
    null !== workInProgress2 && (workInProgress2.firstContext = null);
  }
  function readContext(context) {
    return readContextForConsumer(currentlyRenderingFiber$1, context);
  }
  function readContextDuringReconciliation(consumer, context) {
    null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
    return readContextForConsumer(consumer, context);
  }
  function readContextForConsumer(consumer, context) {
    var value = context._currentValue;
    context = { context, memoizedValue: value, next: null };
    if (null === lastContextDependency) {
      if (null === consumer) throw Error(formatProdErrorMessage2(308));
      lastContextDependency = context;
      consumer.dependencies = { lanes: 0, firstContext: context };
      consumer.flags |= 524288;
    } else lastContextDependency = lastContextDependency.next = context;
    return value;
  }
  var AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
    var listeners = [], signal = this.signal = {
      aborted: false,
      addEventListener: function(type, listener) {
        listeners.push(listener);
      }
    };
    this.abort = function() {
      signal.aborted = true;
      listeners.forEach(function(listener) {
        return listener();
      });
    };
  }, scheduleCallback$2 = Scheduler2.unstable_scheduleCallback, NormalPriority = Scheduler2.unstable_NormalPriority, CacheContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Consumer: null,
    Provider: null,
    _currentValue: null,
    _currentValue2: null,
    _threadCount: 0
  };
  function createCache() {
    return {
      controller: new AbortControllerLocal(),
      data: /* @__PURE__ */ new Map(),
      refCount: 0
    };
  }
  function releaseCache(cache) {
    cache.refCount--;
    0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
      cache.controller.abort();
    });
  }
  var currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null;
  function entangleAsyncAction(transition, thenable) {
    if (null === currentEntangledListeners) {
      var entangledListeners = currentEntangledListeners = [];
      currentEntangledPendingCount = 0;
      currentEntangledLane = requestTransitionLane();
      currentEntangledActionThenable = {
        status: "pending",
        value: void 0,
        then: function(resolve) {
          entangledListeners.push(resolve);
        }
      };
    }
    currentEntangledPendingCount++;
    thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
    return thenable;
  }
  function pingEngtangledActionScope() {
    if (0 === --currentEntangledPendingCount && null !== currentEntangledListeners) {
      null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
      var listeners = currentEntangledListeners;
      currentEntangledListeners = null;
      currentEntangledLane = 0;
      currentEntangledActionThenable = null;
      for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])();
    }
  }
  function chainThenableValue(thenable, result2) {
    var listeners = [], thenableWithOverride = {
      status: "pending",
      value: null,
      reason: null,
      then: function(resolve) {
        listeners.push(resolve);
      }
    };
    thenable.then(
      function() {
        thenableWithOverride.status = "fulfilled";
        thenableWithOverride.value = result2;
        for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])(result2);
      },
      function(error) {
        thenableWithOverride.status = "rejected";
        thenableWithOverride.reason = error;
        for (error = 0; error < listeners.length; error++)
          (0, listeners[error])(void 0);
      }
    );
    return thenableWithOverride;
  }
  var prevOnStartTransitionFinish = ReactSharedInternals.S;
  ReactSharedInternals.S = function(transition, returnValue) {
    globalMostRecentTransitionTime = now();
    "object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then && entangleAsyncAction(transition, returnValue);
    null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
  };
  var resumedCache = createCursor(null);
  function peekCacheFromPool() {
    var cacheResumedFromPreviousRender = resumedCache.current;
    return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
  }
  function pushTransition(offscreenWorkInProgress, prevCachePool) {
    null === prevCachePool ? push2(resumedCache, resumedCache.current) : push2(resumedCache, prevCachePool.pool);
  }
  function getSuspendedCache() {
    var cacheFromPool = peekCacheFromPool();
    return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
  }
  var SuspenseException = Error(formatProdErrorMessage2(460)), SuspenseyCommitException = Error(formatProdErrorMessage2(474)), SuspenseActionException = Error(formatProdErrorMessage2(542)), noopSuspenseyCommitThenable = { then: function() {
  } };
  function isThenableResolved(thenable) {
    thenable = thenable.status;
    return "fulfilled" === thenable || "rejected" === thenable;
  }
  function trackUsedThenable(thenableState2, thenable, index3) {
    index3 = thenableState2[index3];
    void 0 === index3 ? thenableState2.push(thenable) : index3 !== thenable && (thenable.then(noop$12, noop$12), thenable = index3);
    switch (thenable.status) {
      case "fulfilled":
        return thenable.value;
      case "rejected":
        throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
      default:
        if ("string" === typeof thenable.status) thenable.then(noop$12, noop$12);
        else {
          thenableState2 = workInProgressRoot;
          if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
            throw Error(formatProdErrorMessage2(482));
          thenableState2 = thenable;
          thenableState2.status = "pending";
          thenableState2.then(
            function(fulfilledValue) {
              if ("pending" === thenable.status) {
                var fulfilledThenable = thenable;
                fulfilledThenable.status = "fulfilled";
                fulfilledThenable.value = fulfilledValue;
              }
            },
            function(error) {
              if ("pending" === thenable.status) {
                var rejectedThenable = thenable;
                rejectedThenable.status = "rejected";
                rejectedThenable.reason = error;
              }
            }
          );
        }
        switch (thenable.status) {
          case "fulfilled":
            return thenable.value;
          case "rejected":
            throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        }
        suspendedThenable = thenable;
        throw SuspenseException;
    }
  }
  function resolveLazy(lazyType) {
    try {
      var init2 = lazyType._init;
      return init2(lazyType._payload);
    } catch (x2) {
      if (null !== x2 && "object" === typeof x2 && "function" === typeof x2.then)
        throw suspendedThenable = x2, SuspenseException;
      throw x2;
    }
  }
  var suspendedThenable = null;
  function getSuspendedThenable() {
    if (null === suspendedThenable) throw Error(formatProdErrorMessage2(459));
    var thenable = suspendedThenable;
    suspendedThenable = null;
    return thenable;
  }
  function checkIfUseWrappedInAsyncCatch(rejectedReason) {
    if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
      throw Error(formatProdErrorMessage2(483));
  }
  var thenableState$1 = null, thenableIndexCounter$1 = 0;
  function unwrapThenable(thenable) {
    var index3 = thenableIndexCounter$1;
    thenableIndexCounter$1 += 1;
    null === thenableState$1 && (thenableState$1 = []);
    return trackUsedThenable(thenableState$1, thenable, index3);
  }
  function coerceRef(workInProgress2, element2) {
    element2 = element2.props.ref;
    workInProgress2.ref = void 0 !== element2 ? element2 : null;
  }
  function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
    if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
      throw Error(formatProdErrorMessage2(525));
    returnFiber = Object.prototype.toString.call(newChild);
    throw Error(
      formatProdErrorMessage2(
        31,
        "[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber
      )
    );
  }
  function createChildReconciler(shouldTrackSideEffects) {
    function deleteChild(returnFiber, childToDelete) {
      if (shouldTrackSideEffects) {
        var deletions = returnFiber.deletions;
        null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
      }
    }
    function deleteRemainingChildren(returnFiber, currentFirstChild) {
      if (!shouldTrackSideEffects) return null;
      for (; null !== currentFirstChild; )
        deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return null;
    }
    function mapRemainingChildren(currentFirstChild) {
      for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
        null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
      return existingChildren;
    }
    function useFiber(fiber, pendingProps) {
      fiber = createWorkInProgress(fiber, pendingProps);
      fiber.index = 0;
      fiber.sibling = null;
      return fiber;
    }
    function placeChild(newFiber, lastPlacedIndex, newIndex) {
      newFiber.index = newIndex;
      if (!shouldTrackSideEffects)
        return newFiber.flags |= 1048576, lastPlacedIndex;
      newIndex = newFiber.alternate;
      if (null !== newIndex)
        return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
      newFiber.flags |= 67108866;
      return lastPlacedIndex;
    }
    function placeSingleChild(newFiber) {
      shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
      return newFiber;
    }
    function updateTextNode(returnFiber, current2, textContent, lanes) {
      if (null === current2 || 6 !== current2.tag)
        return current2 = createFiberFromText(textContent, returnFiber.mode, lanes), current2.return = returnFiber, current2;
      current2 = useFiber(current2, textContent);
      current2.return = returnFiber;
      return current2;
    }
    function updateElement(returnFiber, current2, element2, lanes) {
      var elementType = element2.type;
      if (elementType === REACT_FRAGMENT_TYPE)
        return updateFragment(
          returnFiber,
          current2,
          element2.props.children,
          lanes,
          element2.key
        );
      if (null !== current2 && (current2.elementType === elementType || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current2.type))
        return current2 = useFiber(current2, element2.props), coerceRef(current2, element2), current2.return = returnFiber, current2;
      current2 = createFiberFromTypeAndProps(
        element2.type,
        element2.key,
        element2.props,
        null,
        returnFiber.mode,
        lanes
      );
      coerceRef(current2, element2);
      current2.return = returnFiber;
      return current2;
    }
    function updatePortal(returnFiber, current2, portal, lanes) {
      if (null === current2 || 4 !== current2.tag || current2.stateNode.containerInfo !== portal.containerInfo || current2.stateNode.implementation !== portal.implementation)
        return current2 = createFiberFromPortal(portal, returnFiber.mode, lanes), current2.return = returnFiber, current2;
      current2 = useFiber(current2, portal.children || []);
      current2.return = returnFiber;
      return current2;
    }
    function updateFragment(returnFiber, current2, fragment, lanes, key) {
      if (null === current2 || 7 !== current2.tag)
        return current2 = createFiberFromFragment(
          fragment,
          returnFiber.mode,
          lanes,
          key
        ), current2.return = returnFiber, current2;
      current2 = useFiber(current2, fragment);
      current2.return = returnFiber;
      return current2;
    }
    function createChild(returnFiber, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return newChild = createFiberFromText(
          "" + newChild,
          returnFiber.mode,
          lanes
        ), newChild.return = returnFiber, newChild;
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return lanes = createFiberFromTypeAndProps(
              newChild.type,
              newChild.key,
              newChild.props,
              null,
              returnFiber.mode,
              lanes
            ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes;
          case REACT_PORTAL_TYPE:
            return newChild = createFiberFromPortal(
              newChild,
              returnFiber.mode,
              lanes
            ), newChild.return = returnFiber, newChild;
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), createChild(returnFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return newChild = createFiberFromFragment(
            newChild,
            returnFiber.mode,
            lanes,
            null
          ), newChild.return = returnFiber, newChild;
        if ("function" === typeof newChild.then)
          return createChild(returnFiber, unwrapThenable(newChild), lanes);
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return createChild(
            returnFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function updateSlot(returnFiber, oldFiber, newChild, lanes) {
      var key = null !== oldFiber ? oldFiber.key : null;
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return newChild.key === key ? updateElement(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_PORTAL_TYPE:
            return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), updateSlot(returnFiber, oldFiber, newChild, lanes);
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return null !== key ? null : updateFragment(returnFiber, oldFiber, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateSlot(
            returnFiber,
            oldFiber,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateSlot(
            returnFiber,
            oldFiber,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
      if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
        return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updateElement(returnFiber, existingChildren, newChild, lanes);
          case REACT_PORTAL_TYPE:
            return existingChildren = existingChildren.get(
              null === newChild.key ? newIdx : newChild.key
            ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild) || getIteratorFn(newChild))
          return existingChildren = existingChildren.get(newIdx) || null, updateFragment(returnFiber, existingChildren, newChild, lanes, null);
        if ("function" === typeof newChild.then)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return updateFromMap(
            existingChildren,
            returnFiber,
            newIdx,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return null;
    }
    function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(
          returnFiber,
          oldFiber,
          newChildren[newIdx],
          lanes
        );
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (newIdx === newChildren.length)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; newIdx < newChildren.length; newIdx++)
          oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (currentFirstChild = placeChild(
            oldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
        nextOldFiber = updateFromMap(
          oldFiber,
          returnFiber,
          newIdx,
          newChildren[newIdx],
          lanes
        ), null !== nextOldFiber && (shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
          null === nextOldFiber.key ? newIdx : nextOldFiber.key
        ), currentFirstChild = placeChild(
          nextOldFiber,
          currentFirstChild,
          newIdx
        ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
      if (null == newChildren) throw Error(formatProdErrorMessage2(151));
      for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
        oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
        var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
        if (null === newFiber) {
          null === oldFiber && (oldFiber = nextOldFiber);
          break;
        }
        shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
        currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
        null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
        previousNewFiber = newFiber;
        oldFiber = nextOldFiber;
      }
      if (step.done)
        return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
      if (null === oldFiber) {
        for (; !step.done; newIdx++, step = newChildren.next())
          step = createChild(returnFiber, step.value, lanes), null !== step && (currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
        step = updateFromMap(oldFiber, returnFiber, newIdx, step.value, lanes), null !== step && (shouldTrackSideEffects && null !== step.alternate && oldFiber.delete(null === step.key ? newIdx : step.key), currentFirstChild = placeChild(step, currentFirstChild, newIdx), null === previousNewFiber ? resultingFirstChild = step : previousNewFiber.sibling = step, previousNewFiber = step);
      shouldTrackSideEffects && oldFiber.forEach(function(child) {
        return deleteChild(returnFiber, child);
      });
      isHydrating && pushTreeFork(returnFiber, newIdx);
      return resultingFirstChild;
    }
    function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
      "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (newChild = newChild.props.children);
      if ("object" === typeof newChild && null !== newChild) {
        switch (newChild.$$typeof) {
          case REACT_ELEMENT_TYPE:
            a: {
              for (var key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key) {
                  key = newChild.type;
                  if (key === REACT_FRAGMENT_TYPE) {
                    if (7 === currentFirstChild.tag) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        newChild.props.children
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    }
                  } else if (currentFirstChild.elementType === key || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.props);
                    coerceRef(lanes, newChild);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  }
                  deleteRemainingChildren(returnFiber, currentFirstChild);
                  break;
                } else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(
                newChild.props.children,
                returnFiber.mode,
                lanes,
                newChild.key
              ), lanes.return = returnFiber, returnFiber = lanes) : (lanes = createFiberFromTypeAndProps(
                newChild.type,
                newChild.key,
                newChild.props,
                null,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = lanes);
            }
            return placeSingleChild(returnFiber);
          case REACT_PORTAL_TYPE:
            a: {
              for (key = newChild.key; null !== currentFirstChild; ) {
                if (currentFirstChild.key === key)
                  if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === newChild.containerInfo && currentFirstChild.stateNode.implementation === newChild.implementation) {
                    deleteRemainingChildren(
                      returnFiber,
                      currentFirstChild.sibling
                    );
                    lanes = useFiber(currentFirstChild, newChild.children || []);
                    lanes.return = returnFiber;
                    returnFiber = lanes;
                    break a;
                  } else {
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  }
                else deleteChild(returnFiber, currentFirstChild);
                currentFirstChild = currentFirstChild.sibling;
              }
              lanes = createFiberFromPortal(newChild, returnFiber.mode, lanes);
              lanes.return = returnFiber;
              returnFiber = lanes;
            }
            return placeSingleChild(returnFiber);
          case REACT_LAZY_TYPE:
            return newChild = resolveLazy(newChild), reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            );
        }
        if (isArrayImpl(newChild))
          return reconcileChildrenArray(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        if (getIteratorFn(newChild)) {
          key = getIteratorFn(newChild);
          if ("function" !== typeof key) throw Error(formatProdErrorMessage2(150));
          newChild = key.call(newChild);
          return reconcileChildrenIterator(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
        }
        if ("function" === typeof newChild.then)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            unwrapThenable(newChild),
            lanes
          );
        if (newChild.$$typeof === REACT_CONTEXT_TYPE)
          return reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            readContextDuringReconciliation(returnFiber, newChild),
            lanes
          );
        throwOnInvalidObjectTypeImpl(returnFiber, newChild);
      }
      return "string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild ? (newChild = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(returnFiber, currentFirstChild.sibling), lanes = useFiber(currentFirstChild, newChild), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(newChild, returnFiber.mode, lanes), lanes.return = returnFiber, returnFiber = lanes), placeSingleChild(returnFiber)) : deleteRemainingChildren(returnFiber, currentFirstChild);
    }
    return function(returnFiber, currentFirstChild, newChild, lanes) {
      try {
        thenableIndexCounter$1 = 0;
        var firstChildFiber = reconcileChildFibersImpl(
          returnFiber,
          currentFirstChild,
          newChild,
          lanes
        );
        thenableState$1 = null;
        return firstChildFiber;
      } catch (x2) {
        if (x2 === SuspenseException || x2 === SuspenseActionException) throw x2;
        var fiber = createFiberImplClass(29, x2, null, returnFiber.mode);
        fiber.lanes = lanes;
        fiber.return = returnFiber;
        return fiber;
      } finally {
      }
    };
  }
  var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), hasForceUpdate = false;
  function initializeUpdateQueue(fiber) {
    fiber.updateQueue = {
      baseState: fiber.memoizedState,
      firstBaseUpdate: null,
      lastBaseUpdate: null,
      shared: { pending: null, lanes: 0, hiddenCallbacks: null },
      callbacks: null
    };
  }
  function cloneUpdateQueue(current2, workInProgress2) {
    current2 = current2.updateQueue;
    workInProgress2.updateQueue === current2 && (workInProgress2.updateQueue = {
      baseState: current2.baseState,
      firstBaseUpdate: current2.firstBaseUpdate,
      lastBaseUpdate: current2.lastBaseUpdate,
      shared: current2.shared,
      callbacks: null
    });
  }
  function createUpdate(lane) {
    return { lane, tag: 0, payload: null, callback: null, next: null };
  }
  function enqueueUpdate(fiber, update, lane) {
    var updateQueue = fiber.updateQueue;
    if (null === updateQueue) return null;
    updateQueue = updateQueue.shared;
    if (0 !== (executionContext & 2)) {
      var pending = updateQueue.pending;
      null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
      updateQueue.pending = update;
      update = getRootForUpdatedFiber(fiber);
      markUpdateLaneFromFiberToRoot(fiber, null, lane);
      return update;
    }
    enqueueUpdate$1(fiber, updateQueue, update, lane);
    return getRootForUpdatedFiber(fiber);
  }
  function entangleTransitions(root3, fiber, lane) {
    fiber = fiber.updateQueue;
    if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
      var queueLanes = fiber.lanes;
      queueLanes &= root3.pendingLanes;
      lane |= queueLanes;
      fiber.lanes = lane;
      markRootEntangled(root3, lane);
    }
  }
  function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
    var queue = workInProgress2.updateQueue, current2 = workInProgress2.alternate;
    if (null !== current2 && (current2 = current2.updateQueue, queue === current2)) {
      var newFirst = null, newLast = null;
      queue = queue.firstBaseUpdate;
      if (null !== queue) {
        do {
          var clone2 = {
            lane: queue.lane,
            tag: queue.tag,
            payload: queue.payload,
            callback: null,
            next: null
          };
          null === newLast ? newFirst = newLast = clone2 : newLast = newLast.next = clone2;
          queue = queue.next;
        } while (null !== queue);
        null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
      } else newFirst = newLast = capturedUpdate;
      queue = {
        baseState: current2.baseState,
        firstBaseUpdate: newFirst,
        lastBaseUpdate: newLast,
        shared: current2.shared,
        callbacks: current2.callbacks
      };
      workInProgress2.updateQueue = queue;
      return;
    }
    workInProgress2 = queue.lastBaseUpdate;
    null === workInProgress2 ? queue.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
    queue.lastBaseUpdate = capturedUpdate;
  }
  var didReadFromEntangledAsyncAction = false;
  function suspendIfUpdateReadFromEntangledAsyncAction() {
    if (didReadFromEntangledAsyncAction) {
      var entangledActionThenable = currentEntangledActionThenable;
      if (null !== entangledActionThenable) throw entangledActionThenable;
    }
  }
  function processUpdateQueue(workInProgress$jscomp$0, props2, instance$jscomp$0, renderLanes2) {
    didReadFromEntangledAsyncAction = false;
    var queue = workInProgress$jscomp$0.updateQueue;
    hasForceUpdate = false;
    var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
    if (null !== pendingQueue) {
      queue.shared.pending = null;
      var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
      lastPendingUpdate.next = null;
      null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
      lastBaseUpdate = lastPendingUpdate;
      var current2 = workInProgress$jscomp$0.alternate;
      null !== current2 && (current2 = current2.updateQueue, pendingQueue = current2.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current2.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current2.lastBaseUpdate = lastPendingUpdate));
    }
    if (null !== firstBaseUpdate) {
      var newState = queue.baseState;
      lastBaseUpdate = 0;
      current2 = firstPendingUpdate = lastPendingUpdate = null;
      pendingQueue = firstBaseUpdate;
      do {
        var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
        if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
          0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
          null !== current2 && (current2 = current2.next = {
            lane: 0,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: null,
            next: null
          });
          a: {
            var workInProgress2 = workInProgress$jscomp$0, update = pendingQueue;
            updateLane = props2;
            var instance = instance$jscomp$0;
            switch (update.tag) {
              case 1:
                workInProgress2 = update.payload;
                if ("function" === typeof workInProgress2) {
                  newState = workInProgress2.call(instance, newState, updateLane);
                  break a;
                }
                newState = workInProgress2;
                break a;
              case 3:
                workInProgress2.flags = workInProgress2.flags & -65537 | 128;
              case 0:
                workInProgress2 = update.payload;
                updateLane = "function" === typeof workInProgress2 ? workInProgress2.call(instance, newState, updateLane) : workInProgress2;
                if (null === updateLane || void 0 === updateLane) break a;
                newState = assign2({}, newState, updateLane);
                break a;
              case 2:
                hasForceUpdate = true;
            }
          }
          updateLane = pendingQueue.callback;
          null !== updateLane && (workInProgress$jscomp$0.flags |= 64, isHiddenUpdate && (workInProgress$jscomp$0.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
        } else
          isHiddenUpdate = {
            lane: updateLane,
            tag: pendingQueue.tag,
            payload: pendingQueue.payload,
            callback: pendingQueue.callback,
            next: null
          }, null === current2 ? (firstPendingUpdate = current2 = isHiddenUpdate, lastPendingUpdate = newState) : current2 = current2.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
        pendingQueue = pendingQueue.next;
        if (null === pendingQueue)
          if (pendingQueue = queue.shared.pending, null === pendingQueue)
            break;
          else
            isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
      } while (1);
      null === current2 && (lastPendingUpdate = newState);
      queue.baseState = lastPendingUpdate;
      queue.firstBaseUpdate = firstPendingUpdate;
      queue.lastBaseUpdate = current2;
      null === firstBaseUpdate && (queue.shared.lanes = 0);
      workInProgressRootSkippedLanes |= lastBaseUpdate;
      workInProgress$jscomp$0.lanes = lastBaseUpdate;
      workInProgress$jscomp$0.memoizedState = newState;
    }
  }
  function callCallback(callback, context) {
    if ("function" !== typeof callback)
      throw Error(formatProdErrorMessage2(191, callback));
    callback.call(context);
  }
  function commitCallbacks(updateQueue, context) {
    var callbacks = updateQueue.callbacks;
    if (null !== callbacks)
      for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
        callCallback(callbacks[updateQueue], context);
  }
  var currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0);
  function pushHiddenContext(fiber, context) {
    fiber = entangledRenderLanes;
    push2(prevEntangledRenderLanesCursor, fiber);
    push2(currentTreeHiddenStackCursor, context);
    entangledRenderLanes = fiber | context.baseLanes;
  }
  function reuseHiddenContextOnStack() {
    push2(prevEntangledRenderLanesCursor, entangledRenderLanes);
    push2(currentTreeHiddenStackCursor, currentTreeHiddenStackCursor.current);
  }
  function popHiddenContext() {
    entangledRenderLanes = prevEntangledRenderLanesCursor.current;
    pop(currentTreeHiddenStackCursor);
    pop(prevEntangledRenderLanesCursor);
  }
  var suspenseHandlerStackCursor = createCursor(null), shellBoundary = null;
  function pushPrimaryTreeSuspenseHandler(handler) {
    var current2 = handler.alternate;
    push2(suspenseStackCursor, suspenseStackCursor.current & 1);
    push2(suspenseHandlerStackCursor, handler);
    null === shellBoundary && (null === current2 || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current2.memoizedState && (shellBoundary = handler));
  }
  function pushDehydratedActivitySuspenseHandler(fiber) {
    push2(suspenseStackCursor, suspenseStackCursor.current);
    push2(suspenseHandlerStackCursor, fiber);
    null === shellBoundary && (shellBoundary = fiber);
  }
  function pushOffscreenSuspenseHandler(fiber) {
    22 === fiber.tag ? (push2(suspenseStackCursor, suspenseStackCursor.current), push2(suspenseHandlerStackCursor, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack();
  }
  function reuseSuspenseHandlerOnStack() {
    push2(suspenseStackCursor, suspenseStackCursor.current);
    push2(suspenseHandlerStackCursor, suspenseHandlerStackCursor.current);
  }
  function popSuspenseHandler(fiber) {
    pop(suspenseHandlerStackCursor);
    shellBoundary === fiber && (shellBoundary = null);
    pop(suspenseStackCursor);
  }
  var suspenseStackCursor = createCursor(0);
  function findFirstSuspended(row) {
    for (var node = row; null !== node; ) {
      if (13 === node.tag) {
        var state = node.memoizedState;
        if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state)))
          return node;
      } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
        if (0 !== (node.flags & 128)) return node;
      } else if (null !== node.child) {
        node.child.return = node;
        node = node.child;
        continue;
      }
      if (node === row) break;
      for (; null === node.sibling; ) {
        if (null === node.return || node.return === row) return null;
        node = node.return;
      }
      node.sibling.return = node.return;
      node = node.sibling;
    }
    return null;
  }
  var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0;
  function throwInvalidHookError() {
    throw Error(formatProdErrorMessage2(321));
  }
  function areHookInputsEqual(nextDeps, prevDeps) {
    if (null === prevDeps) return false;
    for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++)
      if (!objectIs(nextDeps[i2], prevDeps[i2])) return false;
    return true;
  }
  function renderWithHooks(current2, workInProgress2, Component, props2, secondArg, nextRenderLanes) {
    renderLanes = nextRenderLanes;
    currentlyRenderingFiber = workInProgress2;
    workInProgress2.memoizedState = null;
    workInProgress2.updateQueue = null;
    workInProgress2.lanes = 0;
    ReactSharedInternals.H = null === current2 || null === current2.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate;
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    nextRenderLanes = Component(props2, secondArg);
    shouldDoubleInvokeUserFnsInHooksDEV = false;
    didScheduleRenderPhaseUpdateDuringThisPass && (nextRenderLanes = renderWithHooksAgain(
      workInProgress2,
      Component,
      props2,
      secondArg
    ));
    finishRenderingHooks(current2);
    return nextRenderLanes;
  }
  function finishRenderingHooks(current2) {
    ReactSharedInternals.H = ContextOnlyDispatcher;
    var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdate = false;
    thenableIndexCounter = 0;
    thenableState = null;
    if (didRenderTooFewHooks) throw Error(formatProdErrorMessage2(300));
    null === current2 || didReceiveUpdate || (current2 = current2.dependencies, null !== current2 && checkIfContextChanged(current2) && (didReceiveUpdate = true));
  }
  function renderWithHooksAgain(workInProgress2, Component, props2, secondArg) {
    currentlyRenderingFiber = workInProgress2;
    var numberOfReRenders = 0;
    do {
      didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
      thenableIndexCounter = 0;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      if (25 <= numberOfReRenders) throw Error(formatProdErrorMessage2(301));
      numberOfReRenders += 1;
      workInProgressHook = currentHook = null;
      if (null != workInProgress2.updateQueue) {
        var children = workInProgress2.updateQueue;
        children.lastEffect = null;
        children.events = null;
        children.stores = null;
        null != children.memoCache && (children.memoCache.index = 0);
      }
      ReactSharedInternals.H = HooksDispatcherOnRerender;
      children = Component(props2, secondArg);
    } while (didScheduleRenderPhaseUpdateDuringThisPass);
    return children;
  }
  function TransitionAwareHostComponent() {
    var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
    maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
    dispatcher = dispatcher.useState()[0];
    (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
    return maybeThenable;
  }
  function checkDidRenderIdHook() {
    var didRenderIdHook = 0 !== localIdCounter;
    localIdCounter = 0;
    return didRenderIdHook;
  }
  function bailoutHooks(current2, workInProgress2, lanes) {
    workInProgress2.updateQueue = current2.updateQueue;
    workInProgress2.flags &= -2053;
    current2.lanes &= ~lanes;
  }
  function resetHooksOnUnwind(workInProgress2) {
    if (didScheduleRenderPhaseUpdate) {
      for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
        var queue = workInProgress2.queue;
        null !== queue && (queue.pending = null);
        workInProgress2 = workInProgress2.next;
      }
      didScheduleRenderPhaseUpdate = false;
    }
    renderLanes = 0;
    workInProgressHook = currentHook = currentlyRenderingFiber = null;
    didScheduleRenderPhaseUpdateDuringThisPass = false;
    thenableIndexCounter = localIdCounter = 0;
    thenableState = null;
  }
  function mountWorkInProgressHook() {
    var hook = {
      memoizedState: null,
      baseState: null,
      baseQueue: null,
      queue: null,
      next: null
    };
    null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
    return workInProgressHook;
  }
  function updateWorkInProgressHook() {
    if (null === currentHook) {
      var nextCurrentHook = currentlyRenderingFiber.alternate;
      nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
    } else nextCurrentHook = currentHook.next;
    var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
    if (null !== nextWorkInProgressHook)
      workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
    else {
      if (null === nextCurrentHook) {
        if (null === currentlyRenderingFiber.alternate)
          throw Error(formatProdErrorMessage2(467));
        throw Error(formatProdErrorMessage2(310));
      }
      currentHook = nextCurrentHook;
      nextCurrentHook = {
        memoizedState: currentHook.memoizedState,
        baseState: currentHook.baseState,
        baseQueue: currentHook.baseQueue,
        queue: currentHook.queue,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
    }
    return workInProgressHook;
  }
  function createFunctionComponentUpdateQueue() {
    return { lastEffect: null, events: null, stores: null, memoCache: null };
  }
  function useThenable(thenable) {
    var index3 = thenableIndexCounter;
    thenableIndexCounter += 1;
    null === thenableState && (thenableState = []);
    thenable = trackUsedThenable(thenableState, thenable, index3);
    index3 = currentlyRenderingFiber;
    null === (null === workInProgressHook ? index3.memoizedState : workInProgressHook.next) && (index3 = index3.alternate, ReactSharedInternals.H = null === index3 || null === index3.memoizedState ? HooksDispatcherOnMount : HooksDispatcherOnUpdate);
    return thenable;
  }
  function use(usable) {
    if (null !== usable && "object" === typeof usable) {
      if ("function" === typeof usable.then) return useThenable(usable);
      if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
    }
    throw Error(formatProdErrorMessage2(438, String(usable)));
  }
  function useMemoCache(size2) {
    var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
    null !== updateQueue && (memoCache = updateQueue.memoCache);
    if (null == memoCache) {
      var current2 = currentlyRenderingFiber.alternate;
      null !== current2 && (current2 = current2.updateQueue, null !== current2 && (current2 = current2.memoCache, null != current2 && (memoCache = {
        data: current2.data.map(function(array) {
          return array.slice();
        }),
        index: 0
      })));
    }
    null == memoCache && (memoCache = { data: [], index: 0 });
    null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
    updateQueue.memoCache = memoCache;
    updateQueue = memoCache.data[memoCache.index];
    if (void 0 === updateQueue)
      for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current2 = 0; current2 < size2; current2++)
        updateQueue[current2] = REACT_MEMO_CACHE_SENTINEL;
    memoCache.index++;
    return updateQueue;
  }
  function basicStateReducer(state, action) {
    return "function" === typeof action ? action(state) : action;
  }
  function updateReducer(reducer) {
    var hook = updateWorkInProgressHook();
    return updateReducerImpl(hook, currentHook, reducer);
  }
  function updateReducerImpl(hook, current2, reducer) {
    var queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage2(311));
    queue.lastRenderedReducer = reducer;
    var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
    if (null !== pendingQueue) {
      if (null !== baseQueue) {
        var baseFirst = baseQueue.next;
        baseQueue.next = pendingQueue.next;
        pendingQueue.next = baseFirst;
      }
      current2.baseQueue = baseQueue = pendingQueue;
      queue.pending = null;
    }
    pendingQueue = hook.baseState;
    if (null === baseQueue) hook.memoizedState = pendingQueue;
    else {
      current2 = baseQueue.next;
      var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current2, didReadFromEntangledAsyncAction$60 = false;
      do {
        var updateLane = update.lane & -536870913;
        if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
          var revertLane = update.revertLane;
          if (0 === revertLane)
            null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
              lane: 0,
              revertLane: 0,
              gesture: null,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = true);
          else if ((renderLanes & revertLane) === revertLane) {
            update = update.next;
            revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction$60 = true);
            continue;
          } else
            updateLane = {
              lane: 0,
              revertLane: update.revertLane,
              gesture: null,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
          updateLane = update.action;
          shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
          pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
        } else
          revertLane = {
            lane: updateLane,
            revertLane: update.revertLane,
            gesture: update.gesture,
            action: update.action,
            hasEagerState: update.hasEagerState,
            eagerState: update.eagerState,
            next: null
          }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
        update = update.next;
      } while (null !== update && update !== current2);
      null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
      if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction$60 && (reducer = currentEntangledActionThenable, null !== reducer)))
        throw reducer;
      hook.memoizedState = pendingQueue;
      hook.baseState = baseFirst;
      hook.baseQueue = newBaseQueueLast;
      queue.lastRenderedState = pendingQueue;
    }
    null === baseQueue && (queue.lanes = 0);
    return [hook.memoizedState, queue.dispatch];
  }
  function rerenderReducer(reducer) {
    var hook = updateWorkInProgressHook(), queue = hook.queue;
    if (null === queue) throw Error(formatProdErrorMessage2(311));
    queue.lastRenderedReducer = reducer;
    var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
    if (null !== lastRenderPhaseUpdate) {
      queue.pending = null;
      var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
      do
        newState = reducer(newState, update.action), update = update.next;
      while (update !== lastRenderPhaseUpdate);
      objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
      hook.memoizedState = newState;
      null === hook.baseQueue && (hook.baseState = newState);
      queue.lastRenderedState = newState;
    }
    return [newState, dispatch];
  }
  function updateSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
    var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
    if (isHydrating$jscomp$0) {
      if (void 0 === getServerSnapshot) throw Error(formatProdErrorMessage2(407));
      getServerSnapshot = getServerSnapshot();
    } else getServerSnapshot = getSnapshot();
    var snapshotChanged = !objectIs(
      (currentHook || hook).memoizedState,
      getServerSnapshot
    );
    snapshotChanged && (hook.memoizedState = getServerSnapshot, didReceiveUpdate = true);
    hook = hook.queue;
    updateEffect(subscribeToStore.bind(null, fiber, hook, subscribe2), [
      subscribe2
    ]);
    if (hook.getSnapshot !== getSnapshot || snapshotChanged || null !== workInProgressHook && workInProgressHook.memoizedState.tag & 1) {
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          hook,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      if (null === workInProgressRoot) throw Error(formatProdErrorMessage2(349));
      isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
    }
    return getServerSnapshot;
  }
  function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
    fiber.flags |= 16384;
    fiber = { getSnapshot, value: renderedSnapshot };
    getSnapshot = currentlyRenderingFiber.updateQueue;
    null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
  }
  function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
    inst.value = nextSnapshot;
    inst.getSnapshot = getSnapshot;
    checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
  }
  function subscribeToStore(fiber, inst, subscribe2) {
    return subscribe2(function() {
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    });
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function forceStoreRerender(fiber) {
    var root3 = enqueueConcurrentRenderForLane(fiber, 2);
    null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
  }
  function mountStateImpl(initialState2) {
    var hook = mountWorkInProgressHook();
    if ("function" === typeof initialState2) {
      var initialStateInitializer = initialState2;
      initialState2 = initialStateInitializer();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          initialStateInitializer();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
    }
    hook.memoizedState = hook.baseState = initialState2;
    hook.queue = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: basicStateReducer,
      lastRenderedState: initialState2
    };
    return hook;
  }
  function updateOptimisticImpl(hook, current2, passthrough, reducer) {
    hook.baseState = passthrough;
    return updateReducerImpl(
      hook,
      currentHook,
      "function" === typeof reducer ? reducer : basicStateReducer
    );
  }
  function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
    if (isRenderPhaseUpdate(fiber)) throw Error(formatProdErrorMessage2(485));
    fiber = actionQueue.action;
    if (null !== fiber) {
      var actionNode = {
        payload,
        action: fiber,
        next: null,
        isTransition: true,
        status: "pending",
        value: null,
        reason: null,
        listeners: [],
        then: function(listener) {
          actionNode.listeners.push(listener);
        }
      };
      null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
      setState(actionNode);
      setPendingState = actionQueue.pending;
      null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
    }
  }
  function runActionStateAction(actionQueue, node) {
    var action = node.action, payload = node.payload, prevState = actionQueue.state;
    if (node.isTransition) {
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      ReactSharedInternals.T = currentTransition;
      try {
        var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        handleActionReturnValue(actionQueue, node, returnValue);
      } catch (error) {
        onActionError(actionQueue, node, error);
      } finally {
        null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
      }
    } else
      try {
        prevTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, prevTransition);
      } catch (error$66) {
        onActionError(actionQueue, node, error$66);
      }
  }
  function handleActionReturnValue(actionQueue, node, returnValue) {
    null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? returnValue.then(
      function(nextState) {
        onActionSuccess(actionQueue, node, nextState);
      },
      function(error) {
        return onActionError(actionQueue, node, error);
      }
    ) : onActionSuccess(actionQueue, node, returnValue);
  }
  function onActionSuccess(actionQueue, actionNode, nextState) {
    actionNode.status = "fulfilled";
    actionNode.value = nextState;
    notifyActionListeners(actionNode);
    actionQueue.state = nextState;
    actionNode = actionQueue.pending;
    null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
  }
  function onActionError(actionQueue, actionNode, error) {
    var last2 = actionQueue.pending;
    actionQueue.pending = null;
    if (null !== last2) {
      last2 = last2.next;
      do
        actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
      while (actionNode !== last2);
    }
    actionQueue.action = null;
  }
  function notifyActionListeners(actionNode) {
    actionNode = actionNode.listeners;
    for (var i2 = 0; i2 < actionNode.length; i2++) (0, actionNode[i2])();
  }
  function actionStateReducer(oldState, newState) {
    return newState;
  }
  function mountActionState(action, initialStateProp) {
    if (isHydrating) {
      var ssrFormState = workInProgressRoot.formState;
      if (null !== ssrFormState) {
        a: {
          var JSCompiler_inline_result = currentlyRenderingFiber;
          if (isHydrating) {
            if (nextHydratableInstance) {
              b: {
                var JSCompiler_inline_result$jscomp$0 = nextHydratableInstance;
                for (var inRootOrSingleton = rootOrSingletonContext; 8 !== JSCompiler_inline_result$jscomp$0.nodeType; ) {
                  if (!inRootOrSingleton) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                  JSCompiler_inline_result$jscomp$0 = getNextHydratable(
                    JSCompiler_inline_result$jscomp$0.nextSibling
                  );
                  if (null === JSCompiler_inline_result$jscomp$0) {
                    JSCompiler_inline_result$jscomp$0 = null;
                    break b;
                  }
                }
                inRootOrSingleton = JSCompiler_inline_result$jscomp$0.data;
                JSCompiler_inline_result$jscomp$0 = "F!" === inRootOrSingleton || "F" === inRootOrSingleton ? JSCompiler_inline_result$jscomp$0 : null;
              }
              if (JSCompiler_inline_result$jscomp$0) {
                nextHydratableInstance = getNextHydratable(
                  JSCompiler_inline_result$jscomp$0.nextSibling
                );
                JSCompiler_inline_result = "F!" === JSCompiler_inline_result$jscomp$0.data;
                break a;
              }
            }
            throwOnHydrationMismatch(JSCompiler_inline_result);
          }
          JSCompiler_inline_result = false;
        }
        JSCompiler_inline_result && (initialStateProp = ssrFormState[0]);
      }
    }
    ssrFormState = mountWorkInProgressHook();
    ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
    JSCompiler_inline_result = {
      pending: null,
      lanes: 0,
      dispatch: null,
      lastRenderedReducer: actionStateReducer,
      lastRenderedState: initialStateProp
    };
    ssrFormState.queue = JSCompiler_inline_result;
    ssrFormState = dispatchSetState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result
    );
    JSCompiler_inline_result.dispatch = ssrFormState;
    JSCompiler_inline_result = mountStateImpl(false);
    inRootOrSingleton = dispatchOptimisticSetState.bind(
      null,
      currentlyRenderingFiber,
      false,
      JSCompiler_inline_result.queue
    );
    JSCompiler_inline_result = mountWorkInProgressHook();
    JSCompiler_inline_result$jscomp$0 = {
      state: initialStateProp,
      dispatch: null,
      action,
      pending: null
    };
    JSCompiler_inline_result.queue = JSCompiler_inline_result$jscomp$0;
    ssrFormState = dispatchActionState.bind(
      null,
      currentlyRenderingFiber,
      JSCompiler_inline_result$jscomp$0,
      inRootOrSingleton,
      ssrFormState
    );
    JSCompiler_inline_result$jscomp$0.dispatch = ssrFormState;
    JSCompiler_inline_result.memoizedState = action;
    return [initialStateProp, ssrFormState, false];
  }
  function updateActionState(action) {
    var stateHook = updateWorkInProgressHook();
    return updateActionStateImpl(stateHook, currentHook, action);
  }
  function updateActionStateImpl(stateHook, currentStateHook, action) {
    currentStateHook = updateReducerImpl(
      stateHook,
      currentStateHook,
      actionStateReducer
    )[0];
    stateHook = updateReducer(basicStateReducer)[0];
    if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
      try {
        var state = useThenable(currentStateHook);
      } catch (x2) {
        if (x2 === SuspenseException) throw SuspenseActionException;
        throw x2;
      }
    else state = currentStateHook;
    currentStateHook = updateWorkInProgressHook();
    var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
    action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
      9,
      { destroy: void 0 },
      actionStateActionEffect.bind(null, actionQueue, action),
      null
    ));
    return [state, dispatch, stateHook];
  }
  function actionStateActionEffect(actionQueue, action) {
    actionQueue.action = action;
  }
  function rerenderActionState(action) {
    var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
    if (null !== currentStateHook)
      return updateActionStateImpl(stateHook, currentStateHook, action);
    updateWorkInProgressHook();
    stateHook = stateHook.memoizedState;
    currentStateHook = updateWorkInProgressHook();
    var dispatch = currentStateHook.queue.dispatch;
    currentStateHook.memoizedState = action;
    return [stateHook, dispatch, false];
  }
  function pushSimpleEffect(tag2, inst, create2, deps) {
    tag2 = { tag: tag2, create: create2, deps, inst, next: null };
    inst = currentlyRenderingFiber.updateQueue;
    null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
    create2 = inst.lastEffect;
    null === create2 ? inst.lastEffect = tag2.next = tag2 : (deps = create2.next, create2.next = tag2, tag2.next = deps, inst.lastEffect = tag2);
    return tag2;
  }
  function updateRef() {
    return updateWorkInProgressHook().memoizedState;
  }
  function mountEffectImpl(fiberFlags, hookFlags, create2, deps) {
    var hook = mountWorkInProgressHook();
    currentlyRenderingFiber.flags |= fiberFlags;
    hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      { destroy: void 0 },
      create2,
      void 0 === deps ? null : deps
    );
  }
  function updateEffectImpl(fiberFlags, hookFlags, create2, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var inst = hook.memoizedState.inst;
    null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create2, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
      1 | hookFlags,
      inst,
      create2,
      deps
    ));
  }
  function mountEffect(create2, deps) {
    mountEffectImpl(8390656, 8, create2, deps);
  }
  function updateEffect(create2, deps) {
    updateEffectImpl(2048, 8, create2, deps);
  }
  function useEffectEventImpl(payload) {
    currentlyRenderingFiber.flags |= 4;
    var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
    if (null === componentUpdateQueue)
      componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [payload];
    else {
      var events2 = componentUpdateQueue.events;
      null === events2 ? componentUpdateQueue.events = [payload] : events2.push(payload);
    }
  }
  function updateEvent(callback) {
    var ref = updateWorkInProgressHook().memoizedState;
    useEffectEventImpl({ ref, nextImpl: callback });
    return function() {
      if (0 !== (executionContext & 2)) throw Error(formatProdErrorMessage2(440));
      return ref.impl.apply(void 0, arguments);
    };
  }
  function updateInsertionEffect(create2, deps) {
    return updateEffectImpl(4, 2, create2, deps);
  }
  function updateLayoutEffect(create2, deps) {
    return updateEffectImpl(4, 4, create2, deps);
  }
  function imperativeHandleEffect(create2, ref) {
    if ("function" === typeof ref) {
      create2 = create2();
      var refCleanup = ref(create2);
      return function() {
        "function" === typeof refCleanup ? refCleanup() : ref(null);
      };
    }
    if (null !== ref && void 0 !== ref)
      return create2 = create2(), ref.current = create2, function() {
        ref.current = null;
      };
  }
  function updateImperativeHandle(ref, create2, deps) {
    deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
    updateEffectImpl(4, 4, imperativeHandleEffect.bind(null, create2, ref), deps);
  }
  function mountDebugValue() {
  }
  function updateCallback(callback, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    hook.memoizedState = [callback, deps];
    return callback;
  }
  function updateMemo(nextCreate, deps) {
    var hook = updateWorkInProgressHook();
    deps = void 0 === deps ? null : deps;
    var prevState = hook.memoizedState;
    if (null !== deps && areHookInputsEqual(deps, prevState[1]))
      return prevState[0];
    prevState = nextCreate();
    if (shouldDoubleInvokeUserFnsInHooksDEV) {
      setIsStrictModeForDevtools(true);
      try {
        nextCreate();
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    hook.memoizedState = [prevState, deps];
    return prevState;
  }
  function mountDeferredValueImpl(hook, value, initialValue) {
    if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
      return hook.memoizedState = value;
    hook.memoizedState = initialValue;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return initialValue;
  }
  function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
    if (objectIs(value, prevValue)) return value;
    if (null !== currentTreeHiddenStackCursor.current)
      return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
    if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
      return didReceiveUpdate = true, hook.memoizedState = value;
    hook = requestDeferredLane();
    currentlyRenderingFiber.lanes |= hook;
    workInProgressRootSkippedLanes |= hook;
    return prevValue;
  }
  function startTransition(fiber, queue, pendingState, finishedState, callback) {
    var previousPriority = ReactDOMSharedInternals.p;
    ReactDOMSharedInternals.p = 0 !== previousPriority && 8 > previousPriority ? previousPriority : 8;
    var prevTransition = ReactSharedInternals.T, currentTransition = {};
    ReactSharedInternals.T = currentTransition;
    dispatchOptimisticSetState(fiber, false, queue, pendingState);
    try {
      var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
      null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
      if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
        var thenableForFinishedState = chainThenableValue(
          returnValue,
          finishedState
        );
        dispatchSetStateInternal(
          fiber,
          queue,
          thenableForFinishedState,
          requestUpdateLane(fiber)
        );
      } else
        dispatchSetStateInternal(
          fiber,
          queue,
          finishedState,
          requestUpdateLane(fiber)
        );
    } catch (error) {
      dispatchSetStateInternal(
        fiber,
        queue,
        { then: function() {
        }, status: "rejected", reason: error },
        requestUpdateLane()
      );
    } finally {
      ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition;
    }
  }
  function noop2() {
  }
  function startHostTransition(formFiber, pendingState, action, formData) {
    if (5 !== formFiber.tag) throw Error(formatProdErrorMessage2(476));
    var queue = ensureFormComponentIsStateful(formFiber).queue;
    startTransition(
      formFiber,
      queue,
      pendingState,
      sharedNotPendingObject,
      null === action ? noop2 : function() {
        requestFormReset$1(formFiber);
        return action(formData);
      }
    );
  }
  function ensureFormComponentIsStateful(formFiber) {
    var existingStateHook = formFiber.memoizedState;
    if (null !== existingStateHook) return existingStateHook;
    existingStateHook = {
      memoizedState: sharedNotPendingObject,
      baseState: sharedNotPendingObject,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: sharedNotPendingObject
      },
      next: null
    };
    var initialResetState = {};
    existingStateHook.next = {
      memoizedState: initialResetState,
      baseState: initialResetState,
      baseQueue: null,
      queue: {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialResetState
      },
      next: null
    };
    formFiber.memoizedState = existingStateHook;
    formFiber = formFiber.alternate;
    null !== formFiber && (formFiber.memoizedState = existingStateHook);
    return existingStateHook;
  }
  function requestFormReset$1(formFiber) {
    var stateHook = ensureFormComponentIsStateful(formFiber);
    null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
    dispatchSetStateInternal(
      formFiber,
      stateHook.next.queue,
      {},
      requestUpdateLane()
    );
  }
  function useHostTransitionStatus() {
    return readContext(HostTransitionContext);
  }
  function updateId() {
    return updateWorkInProgressHook().memoizedState;
  }
  function updateRefresh() {
    return updateWorkInProgressHook().memoizedState;
  }
  function refreshCache(fiber) {
    for (var provider = fiber.return; null !== provider; ) {
      switch (provider.tag) {
        case 24:
        case 3:
          var lane = requestUpdateLane();
          fiber = createUpdate(lane);
          var root$69 = enqueueUpdate(provider, fiber, lane);
          null !== root$69 && (scheduleUpdateOnFiber(root$69, provider, lane), entangleTransitions(root$69, provider, lane));
          provider = { cache: createCache() };
          fiber.payload = provider;
          return;
      }
      provider = provider.return;
    }
  }
  function dispatchReducerAction(fiber, queue, action) {
    var lane = requestUpdateLane();
    action = {
      lane,
      revertLane: 0,
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, action) : (action = enqueueConcurrentHookUpdate(fiber, queue, action, lane), null !== action && (scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane)));
  }
  function dispatchSetState(fiber, queue, action) {
    var lane = requestUpdateLane();
    dispatchSetStateInternal(fiber, queue, action, lane);
  }
  function dispatchSetStateInternal(fiber, queue, action, lane) {
    var update = {
      lane,
      revertLane: 0,
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
    else {
      var alternate = fiber.alternate;
      if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate))
        try {
          var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
          update.hasEagerState = true;
          update.eagerState = eagerState;
          if (objectIs(eagerState, currentState))
            return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
        } catch (error) {
        } finally {
        }
      action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
      if (null !== action)
        return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), true;
    }
    return false;
  }
  function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
    action = {
      lane: 2,
      revertLane: requestTransitionLane(),
      gesture: null,
      action,
      hasEagerState: false,
      eagerState: null,
      next: null
    };
    if (isRenderPhaseUpdate(fiber)) {
      if (throwIfDuringRender) throw Error(formatProdErrorMessage2(479));
    } else
      throwIfDuringRender = enqueueConcurrentHookUpdate(
        fiber,
        queue,
        action,
        2
      ), null !== throwIfDuringRender && scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2);
  }
  function isRenderPhaseUpdate(fiber) {
    var alternate = fiber.alternate;
    return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
  }
  function enqueueRenderPhaseUpdate(queue, update) {
    didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
    var pending = queue.pending;
    null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
    queue.pending = update;
  }
  function entangleTransitionUpdate(root3, queue, lane) {
    if (0 !== (lane & 4194048)) {
      var queueLanes = queue.lanes;
      queueLanes &= root3.pendingLanes;
      lane |= queueLanes;
      queue.lanes = lane;
      markRootEntangled(root3, lane);
    }
  }
  var ContextOnlyDispatcher = {
    readContext,
    use,
    useCallback: throwInvalidHookError,
    useContext: throwInvalidHookError,
    useEffect: throwInvalidHookError,
    useImperativeHandle: throwInvalidHookError,
    useLayoutEffect: throwInvalidHookError,
    useInsertionEffect: throwInvalidHookError,
    useMemo: throwInvalidHookError,
    useReducer: throwInvalidHookError,
    useRef: throwInvalidHookError,
    useState: throwInvalidHookError,
    useDebugValue: throwInvalidHookError,
    useDeferredValue: throwInvalidHookError,
    useTransition: throwInvalidHookError,
    useSyncExternalStore: throwInvalidHookError,
    useId: throwInvalidHookError,
    useHostTransitionStatus: throwInvalidHookError,
    useFormState: throwInvalidHookError,
    useActionState: throwInvalidHookError,
    useOptimistic: throwInvalidHookError,
    useMemoCache: throwInvalidHookError,
    useCacheRefresh: throwInvalidHookError
  };
  ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
  var HooksDispatcherOnMount = {
    readContext,
    use,
    useCallback: function(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    },
    useContext: readContext,
    useEffect: mountEffect,
    useImperativeHandle: function(ref, create2, deps) {
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      mountEffectImpl(
        4194308,
        4,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    },
    useLayoutEffect: function(create2, deps) {
      return mountEffectImpl(4194308, 4, create2, deps);
    },
    useInsertionEffect: function(create2, deps) {
      mountEffectImpl(4, 2, create2, deps);
    },
    useMemo: function(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    },
    useReducer: function(reducer, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState2
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    },
    useRef: function(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    },
    useState: function(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    },
    useTransition: function() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    },
    useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(formatProdErrorMessage2(407));
        getServerSnapshot = getServerSnapshot();
      } else {
        getServerSnapshot = getSnapshot();
        if (null === workInProgressRoot)
          throw Error(formatProdErrorMessage2(349));
        0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      hook.memoizedState = getServerSnapshot;
      var inst = { value: getServerSnapshot, getSnapshot };
      hook.queue = inst;
      mountEffect(subscribeToStore.bind(null, fiber, inst, subscribe2), [
        subscribe2
      ]);
      fiber.flags |= 2048;
      pushSimpleEffect(
        9,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          inst,
          getServerSnapshot,
          getSnapshot
        ),
        null
      );
      return getServerSnapshot;
    },
    useId: function() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var JSCompiler_inline_result = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        JSCompiler_inline_result = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + JSCompiler_inline_result;
        identifierPrefix = "_" + identifierPrefix + "R_" + JSCompiler_inline_result;
        JSCompiler_inline_result = localIdCounter++;
        0 < JSCompiler_inline_result && (identifierPrefix += "H" + JSCompiler_inline_result.toString(32));
        identifierPrefix += "_";
      } else
        JSCompiler_inline_result = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + JSCompiler_inline_result.toString(32) + "_";
      return hook.memoizedState = identifierPrefix;
    },
    useHostTransitionStatus,
    useFormState: mountActionState,
    useActionState: mountActionState,
    useOptimistic: function(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    },
    useMemoCache,
    useCacheRefresh: function() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    },
    useEffectEvent: function(callback) {
      var hook = mountWorkInProgressHook(), ref = { impl: callback };
      hook.memoizedState = ref;
      return function() {
        if (0 !== (executionContext & 2))
          throw Error(formatProdErrorMessage2(440));
        return ref.impl.apply(void 0, arguments);
      };
    }
  }, HooksDispatcherOnUpdate = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: updateReducer,
    useRef: updateRef,
    useState: function() {
      return updateReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: updateActionState,
    useActionState: updateActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  };
  HooksDispatcherOnUpdate.useEffectEvent = updateEvent;
  var HooksDispatcherOnRerender = {
    readContext,
    use,
    useCallback: updateCallback,
    useContext: readContext,
    useEffect: updateEffect,
    useImperativeHandle: updateImperativeHandle,
    useInsertionEffect: updateInsertionEffect,
    useLayoutEffect: updateLayoutEffect,
    useMemo: updateMemo,
    useReducer: rerenderReducer,
    useRef: updateRef,
    useState: function() {
      return rerenderReducer(basicStateReducer);
    },
    useDebugValue: mountDebugValue,
    useDeferredValue: function(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    },
    useTransition: function() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    },
    useSyncExternalStore: updateSyncExternalStore,
    useId: updateId,
    useHostTransitionStatus,
    useFormState: rerenderActionState,
    useActionState: rerenderActionState,
    useOptimistic: function(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    },
    useMemoCache,
    useCacheRefresh: updateRefresh
  };
  HooksDispatcherOnRerender.useEffectEvent = updateEvent;
  function applyDerivedStateFromProps(workInProgress2, ctor2, getDerivedStateFromProps, nextProps) {
    ctor2 = workInProgress2.memoizedState;
    getDerivedStateFromProps = getDerivedStateFromProps(nextProps, ctor2);
    getDerivedStateFromProps = null === getDerivedStateFromProps || void 0 === getDerivedStateFromProps ? ctor2 : assign2({}, ctor2, getDerivedStateFromProps);
    workInProgress2.memoizedState = getDerivedStateFromProps;
    0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = getDerivedStateFromProps);
  }
  var classComponentUpdater = {
    enqueueSetState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueReplaceState: function(inst, payload, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 1;
      update.payload = payload;
      void 0 !== callback && null !== callback && (update.callback = callback);
      payload = enqueueUpdate(inst, update, lane);
      null !== payload && (scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
    },
    enqueueForceUpdate: function(inst, callback) {
      inst = inst._reactInternals;
      var lane = requestUpdateLane(), update = createUpdate(lane);
      update.tag = 2;
      void 0 !== callback && null !== callback && (update.callback = callback);
      callback = enqueueUpdate(inst, update, lane);
      null !== callback && (scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
    }
  };
  function checkShouldComponentUpdate(workInProgress2, ctor2, oldProps, newProps, oldState, newState, nextContext) {
    workInProgress2 = workInProgress2.stateNode;
    return "function" === typeof workInProgress2.shouldComponentUpdate ? workInProgress2.shouldComponentUpdate(newProps, newState, nextContext) : ctor2.prototype && ctor2.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : true;
  }
  function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
    workInProgress2 = instance.state;
    "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
    "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
    instance.state !== workInProgress2 && classComponentUpdater.enqueueReplaceState(instance, instance.state, null);
  }
  function resolveClassComponentProps(Component, baseProps) {
    var newProps = baseProps;
    if ("ref" in baseProps) {
      newProps = {};
      for (var propName in baseProps)
        "ref" !== propName && (newProps[propName] = baseProps[propName]);
    }
    if (Component = Component.defaultProps) {
      newProps === baseProps && (newProps = assign2({}, newProps));
      for (var propName$73 in Component)
        void 0 === newProps[propName$73] && (newProps[propName$73] = Component[propName$73]);
    }
    return newProps;
  }
  function defaultOnUncaughtError(error) {
    reportGlobalError(error);
  }
  function defaultOnCaughtError(error) {
    console.error(error);
  }
  function defaultOnRecoverableError(error) {
    reportGlobalError(error);
  }
  function logUncaughtError(root3, errorInfo) {
    try {
      var onUncaughtError = root3.onUncaughtError;
      onUncaughtError(errorInfo.value, { componentStack: errorInfo.stack });
    } catch (e$74) {
      setTimeout(function() {
        throw e$74;
      });
    }
  }
  function logCaughtError(root3, boundary, errorInfo) {
    try {
      var onCaughtError = root3.onCaughtError;
      onCaughtError(errorInfo.value, {
        componentStack: errorInfo.stack,
        errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
      });
    } catch (e$75) {
      setTimeout(function() {
        throw e$75;
      });
    }
  }
  function createRootErrorUpdate(root3, errorInfo, lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    lane.payload = { element: null };
    lane.callback = function() {
      logUncaughtError(root3, errorInfo);
    };
    return lane;
  }
  function createClassErrorUpdate(lane) {
    lane = createUpdate(lane);
    lane.tag = 3;
    return lane;
  }
  function initializeClassErrorUpdate(update, root3, fiber, errorInfo) {
    var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
    if ("function" === typeof getDerivedStateFromError) {
      var error = errorInfo.value;
      update.payload = function() {
        return getDerivedStateFromError(error);
      };
      update.callback = function() {
        logCaughtError(root3, fiber, errorInfo);
      };
    }
    var inst = fiber.stateNode;
    null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
      logCaughtError(root3, fiber, errorInfo);
      "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
      var stack = errorInfo.stack;
      this.componentDidCatch(errorInfo.value, {
        componentStack: null !== stack ? stack : ""
      });
    });
  }
  function throwException(root3, returnFiber, sourceFiber, value, rootRenderLanes) {
    sourceFiber.flags |= 32768;
    if (null !== value && "object" === typeof value && "function" === typeof value.then) {
      returnFiber = sourceFiber.alternate;
      null !== returnFiber && propagateParentContextChanges(
        returnFiber,
        sourceFiber,
        rootRenderLanes,
        true
      );
      sourceFiber = suspenseHandlerStackCursor.current;
      if (null !== sourceFiber) {
        switch (sourceFiber.tag) {
          case 31:
          case 13:
            return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && 0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 3), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root3, value, rootRenderLanes)), false;
          case 22:
            return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
              transitions: null,
              markerInstances: null,
              retryQueue: /* @__PURE__ */ new Set([value])
            }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root3, value, rootRenderLanes)), false;
        }
        throw Error(formatProdErrorMessage2(435, sourceFiber.tag));
      }
      attachPingListener(root3, value, rootRenderLanes);
      renderDidSuspendDelayIfPossible();
      return false;
    }
    if (isHydrating)
      return returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && (root3 = Error(formatProdErrorMessage2(422), { cause: value }), queueHydrationError(createCapturedValueAtFiber(root3, sourceFiber)))) : (value !== HydrationMismatchException && (returnFiber = Error(formatProdErrorMessage2(423), {
        cause: value
      }), queueHydrationError(
        createCapturedValueAtFiber(returnFiber, sourceFiber)
      )), root3 = root3.current.alternate, root3.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root3.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
        root3.stateNode,
        value,
        rootRenderLanes
      ), enqueueCapturedUpdate(root3, rootRenderLanes), 4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2)), false;
    var wrapperError = Error(formatProdErrorMessage2(520), { cause: value });
    wrapperError = createCapturedValueAtFiber(wrapperError, sourceFiber);
    null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [wrapperError] : workInProgressRootConcurrentErrors.push(wrapperError);
    4 !== workInProgressRootExitStatus && (workInProgressRootExitStatus = 2);
    if (null === returnFiber) return true;
    value = createCapturedValueAtFiber(value, sourceFiber);
    sourceFiber = returnFiber;
    do {
      switch (sourceFiber.tag) {
        case 3:
          return sourceFiber.flags |= 65536, root3 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root3, root3 = createRootErrorUpdate(sourceFiber.stateNode, value, root3), enqueueCapturedUpdate(sourceFiber, root3), false;
        case 1:
          if (returnFiber = sourceFiber.type, wrapperError = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== wrapperError && "function" === typeof wrapperError.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(wrapperError))))
            return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
              rootRenderLanes,
              root3,
              sourceFiber,
              value
            ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
      }
      sourceFiber = sourceFiber.return;
    } while (null !== sourceFiber);
    return false;
  }
  var SelectiveHydrationException = Error(formatProdErrorMessage2(461)), didReceiveUpdate = false;
  function reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2) {
    workInProgress2.child = null === current2 ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
      workInProgress2,
      current2.child,
      nextChildren,
      renderLanes2
    );
  }
  function updateForwardRef(current2, workInProgress2, Component, nextProps, renderLanes2) {
    Component = Component.render;
    var ref = workInProgress2.ref;
    if ("ref" in nextProps) {
      var propsWithoutRef = {};
      for (var key in nextProps)
        "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
    } else propsWithoutRef = nextProps;
    prepareToReadContext(workInProgress2);
    nextProps = renderWithHooks(
      current2,
      workInProgress2,
      Component,
      propsWithoutRef,
      ref,
      renderLanes2
    );
    key = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && key && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateMemoComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    if (null === current2) {
      var type = Component.type;
      if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare)
        return workInProgress2.tag = 15, workInProgress2.type = type, updateSimpleMemoComponent(
          current2,
          workInProgress2,
          type,
          nextProps,
          renderLanes2
        );
      current2 = createFiberFromTypeAndProps(
        Component.type,
        null,
        nextProps,
        workInProgress2,
        workInProgress2.mode,
        renderLanes2
      );
      current2.ref = workInProgress2.ref;
      current2.return = workInProgress2;
      return workInProgress2.child = current2;
    }
    type = current2.child;
    if (!checkScheduledUpdateOrContext(current2, renderLanes2)) {
      var prevProps = type.memoizedProps;
      Component = Component.compare;
      Component = null !== Component ? Component : shallowEqual;
      if (Component(prevProps, nextProps) && current2.ref === workInProgress2.ref)
        return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    }
    workInProgress2.flags |= 1;
    current2 = createWorkInProgress(type, nextProps);
    current2.ref = workInProgress2.ref;
    current2.return = workInProgress2;
    return workInProgress2.child = current2;
  }
  function updateSimpleMemoComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    if (null !== current2) {
      var prevProps = current2.memoizedProps;
      if (shallowEqual(prevProps, nextProps) && current2.ref === workInProgress2.ref)
        if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current2, renderLanes2))
          0 !== (current2.flags & 131072) && (didReceiveUpdate = true);
        else
          return workInProgress2.lanes = current2.lanes, bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    }
    return updateFunctionComponent(
      current2,
      workInProgress2,
      Component,
      nextProps,
      renderLanes2
    );
  }
  function updateOffscreenComponent(current2, workInProgress2, renderLanes2, nextProps) {
    var nextChildren = nextProps.children, prevState = null !== current2 ? current2.memoizedState : null;
    null === current2 && null === workInProgress2.stateNode && (workInProgress2.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    });
    if ("hidden" === nextProps.mode) {
      if (0 !== (workInProgress2.flags & 128)) {
        prevState = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
        if (null !== current2) {
          nextProps = workInProgress2.child = current2.child;
          for (nextChildren = 0; null !== nextProps; )
            nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
          nextProps = nextChildren & ~prevState;
        } else nextProps = 0, workInProgress2.child = null;
        return deferHiddenOffscreenComponent(
          current2,
          workInProgress2,
          prevState,
          renderLanes2,
          nextProps
        );
      }
      if (0 !== (renderLanes2 & 536870912))
        workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current2 && pushTransition(
          workInProgress2,
          null !== prevState ? prevState.cachePool : null
        ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(), pushOffscreenSuspenseHandler(workInProgress2);
      else
        return nextProps = workInProgress2.lanes = 536870912, deferHiddenOffscreenComponent(
          current2,
          workInProgress2,
          null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
          renderLanes2,
          nextProps
        );
    } else
      null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(), workInProgress2.memoizedState = null) : (null !== current2 && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(), reuseSuspenseHandlerOnStack());
    reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  function bailoutOffscreenComponent(current2, workInProgress2) {
    null !== current2 && 22 === current2.tag || null !== workInProgress2.stateNode || (workInProgress2.stateNode = {
      _visibility: 1,
      _pendingMarkers: null,
      _retryCache: null,
      _transitions: null
    });
    return workInProgress2.sibling;
  }
  function deferHiddenOffscreenComponent(current2, workInProgress2, nextBaseLanes, renderLanes2, remainingChildLanes) {
    var JSCompiler_inline_result = peekCacheFromPool();
    JSCompiler_inline_result = null === JSCompiler_inline_result ? null : { parent: CacheContext._currentValue, pool: JSCompiler_inline_result };
    workInProgress2.memoizedState = {
      baseLanes: nextBaseLanes,
      cachePool: JSCompiler_inline_result
    };
    null !== current2 && pushTransition(workInProgress2, null);
    reuseHiddenContextOnStack();
    pushOffscreenSuspenseHandler(workInProgress2);
    null !== current2 && propagateParentContextChanges(current2, workInProgress2, renderLanes2, true);
    workInProgress2.childLanes = remainingChildLanes;
    return null;
  }
  function mountActivityChildren(workInProgress2, nextProps) {
    nextProps = mountWorkInProgressOffscreenFiber(
      { mode: nextProps.mode, children: nextProps.children },
      workInProgress2.mode
    );
    nextProps.ref = workInProgress2.ref;
    workInProgress2.child = nextProps;
    nextProps.return = workInProgress2;
    return nextProps;
  }
  function retryActivityComponentWithoutHydrating(current2, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
    current2 = mountActivityChildren(workInProgress2, workInProgress2.pendingProps);
    current2.flags |= 2;
    popSuspenseHandler(workInProgress2);
    workInProgress2.memoizedState = null;
    return current2;
  }
  function updateActivityComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, didSuspend = 0 !== (workInProgress2.flags & 128);
    workInProgress2.flags &= -129;
    if (null === current2) {
      if (isHydrating) {
        if ("hidden" === nextProps.mode)
          return current2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.lanes = 536870912, bailoutOffscreenComponent(null, current2);
        pushDehydratedActivitySuspenseHandler(workInProgress2);
        (current2 = nextHydratableInstance) ? (current2 = canHydrateHydrationBoundary(
          current2,
          rootOrSingletonContext
        ), current2 = null !== current2 && "&" === current2.data ? current2 : null, null !== current2 && (workInProgress2.memoizedState = {
          dehydrated: current2,
          treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, renderLanes2 = createFiberFromDehydratedFragment(current2), renderLanes2.return = workInProgress2, workInProgress2.child = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : current2 = null;
        if (null === current2) throw throwOnHydrationMismatch(workInProgress2);
        workInProgress2.lanes = 536870912;
        return null;
      }
      return mountActivityChildren(workInProgress2, nextProps);
    }
    var prevState = current2.memoizedState;
    if (null !== prevState) {
      var dehydrated = prevState.dehydrated;
      pushDehydratedActivitySuspenseHandler(workInProgress2);
      if (didSuspend)
        if (workInProgress2.flags & 256)
          workInProgress2.flags &= -257, workInProgress2 = retryActivityComponentWithoutHydrating(
            current2,
            workInProgress2,
            renderLanes2
          );
        else if (null !== workInProgress2.memoizedState)
          workInProgress2.child = current2.child, workInProgress2.flags |= 128, workInProgress2 = null;
        else throw Error(formatProdErrorMessage2(558));
      else if (didReceiveUpdate || propagateParentContextChanges(current2, workInProgress2, renderLanes2, false), didSuspend = 0 !== (renderLanes2 & current2.childLanes), didReceiveUpdate || didSuspend) {
        nextProps = workInProgressRoot;
        if (null !== nextProps && (dehydrated = getBumpedLaneForHydration(nextProps, renderLanes2), 0 !== dehydrated && dehydrated !== prevState.retryLane))
          throw prevState.retryLane = dehydrated, enqueueConcurrentRenderForLane(current2, dehydrated), scheduleUpdateOnFiber(nextProps, current2, dehydrated), SelectiveHydrationException;
        renderDidSuspendDelayIfPossible();
        workInProgress2 = retryActivityComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else
        current2 = prevState.treeContext, nextHydratableInstance = getNextHydratable(dehydrated.nextSibling), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current2 && restoreSuspendedTreeContext(workInProgress2, current2), workInProgress2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.flags |= 4096;
      return workInProgress2;
    }
    current2 = createWorkInProgress(current2.child, {
      mode: nextProps.mode,
      children: nextProps.children
    });
    current2.ref = workInProgress2.ref;
    workInProgress2.child = current2;
    current2.return = workInProgress2;
    return current2;
  }
  function markRef(current2, workInProgress2) {
    var ref = workInProgress2.ref;
    if (null === ref)
      null !== current2 && null !== current2.ref && (workInProgress2.flags |= 4194816);
    else {
      if ("function" !== typeof ref && "object" !== typeof ref)
        throw Error(formatProdErrorMessage2(284));
      if (null === current2 || current2.ref !== ref)
        workInProgress2.flags |= 4194816;
    }
  }
  function updateFunctionComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    Component = renderWithHooks(
      current2,
      workInProgress2,
      Component,
      nextProps,
      void 0,
      renderLanes2
    );
    nextProps = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, Component, renderLanes2);
    return workInProgress2.child;
  }
  function replayFunctionComponent(current2, workInProgress2, nextProps, Component, secondArg, renderLanes2) {
    prepareToReadContext(workInProgress2);
    workInProgress2.updateQueue = null;
    nextProps = renderWithHooksAgain(
      workInProgress2,
      Component,
      nextProps,
      secondArg
    );
    finishRenderingHooks(current2);
    Component = checkDidRenderIdHook();
    if (null !== current2 && !didReceiveUpdate)
      return bailoutHooks(current2, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
    isHydrating && Component && pushMaterializedTreeId(workInProgress2);
    workInProgress2.flags |= 1;
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    return workInProgress2.child;
  }
  function updateClassComponent(current2, workInProgress2, Component, nextProps, renderLanes2) {
    prepareToReadContext(workInProgress2);
    if (null === workInProgress2.stateNode) {
      var context = emptyContextObject, contextType = Component.contextType;
      "object" === typeof contextType && null !== contextType && (context = readContext(contextType));
      context = new Component(nextProps, context);
      workInProgress2.memoizedState = null !== context.state && void 0 !== context.state ? context.state : null;
      context.updater = classComponentUpdater;
      workInProgress2.stateNode = context;
      context._reactInternals = workInProgress2;
      context = workInProgress2.stateNode;
      context.props = nextProps;
      context.state = workInProgress2.memoizedState;
      context.refs = {};
      initializeUpdateQueue(workInProgress2);
      contextType = Component.contextType;
      context.context = "object" === typeof contextType && null !== contextType ? readContext(contextType) : emptyContextObject;
      context.state = workInProgress2.memoizedState;
      contextType = Component.getDerivedStateFromProps;
      "function" === typeof contextType && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        contextType,
        nextProps
      ), context.state = workInProgress2.memoizedState);
      "function" === typeof Component.getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || (contextType = context.state, "function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount(), contextType !== context.state && classComponentUpdater.enqueueReplaceState(context, context.state, null), processUpdateQueue(workInProgress2, nextProps, context, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), context.state = workInProgress2.memoizedState);
      "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308);
      nextProps = true;
    } else if (null === current2) {
      context = workInProgress2.stateNode;
      var unresolvedOldProps = workInProgress2.memoizedProps, oldProps = resolveClassComponentProps(Component, unresolvedOldProps);
      context.props = oldProps;
      var oldContext = context.context, contextType$jscomp$0 = Component.contextType;
      contextType = emptyContextObject;
      "object" === typeof contextType$jscomp$0 && null !== contextType$jscomp$0 && (contextType = readContext(contextType$jscomp$0));
      var getDerivedStateFromProps = Component.getDerivedStateFromProps;
      contextType$jscomp$0 = "function" === typeof getDerivedStateFromProps || "function" === typeof context.getSnapshotBeforeUpdate;
      unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
      contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (unresolvedOldProps || oldContext !== contextType) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        contextType
      );
      hasForceUpdate = false;
      var oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      oldContext = workInProgress2.memoizedState;
      unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof getDerivedStateFromProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        getDerivedStateFromProps,
        nextProps
      ), oldContext = workInProgress2.memoizedState), (oldProps = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        oldProps,
        nextProps,
        oldState,
        oldContext,
        contextType
      )) ? (contextType$jscomp$0 || "function" !== typeof context.UNSAFE_componentWillMount && "function" !== typeof context.componentWillMount || ("function" === typeof context.componentWillMount && context.componentWillMount(), "function" === typeof context.UNSAFE_componentWillMount && context.UNSAFE_componentWillMount()), "function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308)) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), context.props = nextProps, context.state = oldContext, context.context = contextType, nextProps = oldProps) : ("function" === typeof context.componentDidMount && (workInProgress2.flags |= 4194308), nextProps = false);
    } else {
      context = workInProgress2.stateNode;
      cloneUpdateQueue(current2, workInProgress2);
      contextType = workInProgress2.memoizedProps;
      contextType$jscomp$0 = resolveClassComponentProps(Component, contextType);
      context.props = contextType$jscomp$0;
      getDerivedStateFromProps = workInProgress2.pendingProps;
      oldState = context.context;
      oldContext = Component.contextType;
      oldProps = emptyContextObject;
      "object" === typeof oldContext && null !== oldContext && (oldProps = readContext(oldContext));
      unresolvedOldProps = Component.getDerivedStateFromProps;
      (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof context.getSnapshotBeforeUpdate) || "function" !== typeof context.UNSAFE_componentWillReceiveProps && "function" !== typeof context.componentWillReceiveProps || (contextType !== getDerivedStateFromProps || oldState !== oldProps) && callComponentWillReceiveProps(
        workInProgress2,
        context,
        nextProps,
        oldProps
      );
      hasForceUpdate = false;
      oldState = workInProgress2.memoizedState;
      context.state = oldState;
      processUpdateQueue(workInProgress2, nextProps, context, renderLanes2);
      suspendIfUpdateReadFromEntangledAsyncAction();
      var newState = workInProgress2.memoizedState;
      contextType !== getDerivedStateFromProps || oldState !== newState || hasForceUpdate || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
        workInProgress2,
        Component,
        unresolvedOldProps,
        nextProps
      ), newState = workInProgress2.memoizedState), (contextType$jscomp$0 = hasForceUpdate || checkShouldComponentUpdate(
        workInProgress2,
        Component,
        contextType$jscomp$0,
        nextProps,
        oldState,
        newState,
        oldProps
      ) || null !== current2 && null !== current2.dependencies && checkIfContextChanged(current2.dependencies)) ? (oldContext || "function" !== typeof context.UNSAFE_componentWillUpdate && "function" !== typeof context.componentWillUpdate || ("function" === typeof context.componentWillUpdate && context.componentWillUpdate(nextProps, newState, oldProps), "function" === typeof context.UNSAFE_componentWillUpdate && context.UNSAFE_componentWillUpdate(
        nextProps,
        newState,
        oldProps
      )), "function" === typeof context.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof context.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof context.componentDidUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), context.props = nextProps, context.state = newState, context.context = oldProps, nextProps = contextType$jscomp$0) : ("function" !== typeof context.componentDidUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof context.getSnapshotBeforeUpdate || contextType === current2.memoizedProps && oldState === current2.memoizedState || (workInProgress2.flags |= 1024), nextProps = false);
    }
    context = nextProps;
    markRef(current2, workInProgress2);
    nextProps = 0 !== (workInProgress2.flags & 128);
    context || nextProps ? (context = workInProgress2.stateNode, Component = nextProps && "function" !== typeof Component.getDerivedStateFromError ? null : context.render(), workInProgress2.flags |= 1, null !== current2 && nextProps ? (workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      current2.child,
      null,
      renderLanes2
    ), workInProgress2.child = reconcileChildFibers(
      workInProgress2,
      null,
      Component,
      renderLanes2
    )) : reconcileChildren(current2, workInProgress2, Component, renderLanes2), workInProgress2.memoizedState = context.state, current2 = workInProgress2.child) : current2 = bailoutOnAlreadyFinishedWork(
      current2,
      workInProgress2,
      renderLanes2
    );
    return current2;
  }
  function mountHostRootWithoutHydrating(current2, workInProgress2, nextChildren, renderLanes2) {
    resetHydrationState();
    workInProgress2.flags |= 256;
    reconcileChildren(current2, workInProgress2, nextChildren, renderLanes2);
    return workInProgress2.child;
  }
  var SUSPENDED_MARKER = {
    dehydrated: null,
    treeContext: null,
    retryLane: 0,
    hydrationErrors: null
  };
  function mountSuspenseOffscreenState(renderLanes2) {
    return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
  }
  function getRemainingWorkInPrimaryTree(current2, primaryTreeDidDefer, renderLanes2) {
    current2 = null !== current2 ? current2.childLanes & ~renderLanes2 : 0;
    primaryTreeDidDefer && (current2 |= workInProgressDeferredLane);
    return current2;
  }
  function updateSuspenseComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, showFallback = false, didSuspend = 0 !== (workInProgress2.flags & 128), JSCompiler_temp;
    (JSCompiler_temp = didSuspend) || (JSCompiler_temp = null !== current2 && null === current2.memoizedState ? false : 0 !== (suspenseStackCursor.current & 2));
    JSCompiler_temp && (showFallback = true, workInProgress2.flags &= -129);
    JSCompiler_temp = 0 !== (workInProgress2.flags & 32);
    workInProgress2.flags &= -33;
    if (null === current2) {
      if (isHydrating) {
        showFallback ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack();
        (current2 = nextHydratableInstance) ? (current2 = canHydrateHydrationBoundary(
          current2,
          rootOrSingletonContext
        ), current2 = null !== current2 && "&" !== current2.data ? current2 : null, null !== current2 && (workInProgress2.memoizedState = {
          dehydrated: current2,
          treeContext: null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null,
          retryLane: 536870912,
          hydrationErrors: null
        }, renderLanes2 = createFiberFromDehydratedFragment(current2), renderLanes2.return = workInProgress2, workInProgress2.child = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : current2 = null;
        if (null === current2) throw throwOnHydrationMismatch(workInProgress2);
        isSuspenseInstanceFallback(current2) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912;
        return null;
      }
      var nextPrimaryChildren = nextProps.children;
      nextProps = nextProps.fallback;
      if (showFallback)
        return reuseSuspenseHandlerOnStack(), showFallback = workInProgress2.mode, nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
          { mode: "hidden", children: nextPrimaryChildren },
          showFallback
        ), nextProps = createFiberFromFragment(
          nextProps,
          showFallback,
          renderLanes2,
          null
        ), nextPrimaryChildren.return = workInProgress2, nextProps.return = workInProgress2, nextPrimaryChildren.sibling = nextProps, workInProgress2.child = nextPrimaryChildren, nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current2,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(null, nextProps);
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      return mountSuspensePrimaryChildren(workInProgress2, nextPrimaryChildren);
    }
    var prevState = current2.memoizedState;
    if (null !== prevState && (nextPrimaryChildren = prevState.dehydrated, null !== nextPrimaryChildren)) {
      if (didSuspend)
        workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(), workInProgress2.child = current2.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress2.mode, nextProps = mountWorkInProgressOffscreenFiber(
          { mode: "visible", children: nextProps.children },
          showFallback
        ), nextPrimaryChildren = createFiberFromFragment(
          nextPrimaryChildren,
          showFallback,
          renderLanes2,
          null
        ), nextPrimaryChildren.flags |= 2, nextProps.return = workInProgress2, nextPrimaryChildren.return = workInProgress2, nextProps.sibling = nextPrimaryChildren, workInProgress2.child = nextProps, reconcileChildFibers(
          workInProgress2,
          current2.child,
          null,
          renderLanes2
        ), nextProps = workInProgress2.child, nextProps.memoizedState = mountSuspenseOffscreenState(renderLanes2), nextProps.childLanes = getRemainingWorkInPrimaryTree(
          current2,
          JSCompiler_temp,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = bailoutOffscreenComponent(null, nextProps));
      else if (pushPrimaryTreeSuspenseHandler(workInProgress2), isSuspenseInstanceFallback(nextPrimaryChildren)) {
        JSCompiler_temp = nextPrimaryChildren.nextSibling && nextPrimaryChildren.nextSibling.dataset;
        if (JSCompiler_temp) var digest2 = JSCompiler_temp.dgst;
        JSCompiler_temp = digest2;
        nextProps = Error(formatProdErrorMessage2(419));
        nextProps.stack = "";
        nextProps.digest = JSCompiler_temp;
        queueHydrationError({ value: nextProps, source: null, stack: null });
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else if (didReceiveUpdate || propagateParentContextChanges(current2, workInProgress2, renderLanes2, false), JSCompiler_temp = 0 !== (renderLanes2 & current2.childLanes), didReceiveUpdate || JSCompiler_temp) {
        JSCompiler_temp = workInProgressRoot;
        if (null !== JSCompiler_temp && (nextProps = getBumpedLaneForHydration(JSCompiler_temp, renderLanes2), 0 !== nextProps && nextProps !== prevState.retryLane))
          throw prevState.retryLane = nextProps, enqueueConcurrentRenderForLane(current2, nextProps), scheduleUpdateOnFiber(JSCompiler_temp, current2, nextProps), SelectiveHydrationException;
        isSuspenseInstancePending(nextPrimaryChildren) || renderDidSuspendDelayIfPossible();
        workInProgress2 = retrySuspenseComponentWithoutHydrating(
          current2,
          workInProgress2,
          renderLanes2
        );
      } else
        isSuspenseInstancePending(nextPrimaryChildren) ? (workInProgress2.flags |= 192, workInProgress2.child = current2.child, workInProgress2 = null) : (current2 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
          nextPrimaryChildren.nextSibling
        ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, rootOrSingletonContext = false, null !== current2 && restoreSuspendedTreeContext(workInProgress2, current2), workInProgress2 = mountSuspensePrimaryChildren(
          workInProgress2,
          nextProps.children
        ), workInProgress2.flags |= 4096);
      return workInProgress2;
    }
    if (showFallback)
      return reuseSuspenseHandlerOnStack(), nextPrimaryChildren = nextProps.fallback, showFallback = workInProgress2.mode, prevState = current2.child, digest2 = prevState.sibling, nextProps = createWorkInProgress(prevState, {
        mode: "hidden",
        children: nextProps.children
      }), nextProps.subtreeFlags = prevState.subtreeFlags & 65011712, null !== digest2 ? nextPrimaryChildren = createWorkInProgress(
        digest2,
        nextPrimaryChildren
      ) : (nextPrimaryChildren = createFiberFromFragment(
        nextPrimaryChildren,
        showFallback,
        renderLanes2,
        null
      ), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress2, nextProps.return = workInProgress2, nextProps.sibling = nextPrimaryChildren, workInProgress2.child = nextProps, bailoutOffscreenComponent(null, nextProps), nextProps = workInProgress2.child, nextPrimaryChildren = current2.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes2) : (showFallback = nextPrimaryChildren.cachePool, null !== showFallback ? (prevState = CacheContext._currentValue, showFallback = showFallback.parent !== prevState ? { parent: prevState, pool: prevState } : showFallback) : showFallback = getSuspendedCache(), nextPrimaryChildren = {
        baseLanes: nextPrimaryChildren.baseLanes | renderLanes2,
        cachePool: showFallback
      }), nextProps.memoizedState = nextPrimaryChildren, nextProps.childLanes = getRemainingWorkInPrimaryTree(
        current2,
        JSCompiler_temp,
        renderLanes2
      ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(current2.child, nextProps);
    pushPrimaryTreeSuspenseHandler(workInProgress2);
    renderLanes2 = current2.child;
    current2 = renderLanes2.sibling;
    renderLanes2 = createWorkInProgress(renderLanes2, {
      mode: "visible",
      children: nextProps.children
    });
    renderLanes2.return = workInProgress2;
    renderLanes2.sibling = null;
    null !== current2 && (JSCompiler_temp = workInProgress2.deletions, null === JSCompiler_temp ? (workInProgress2.deletions = [current2], workInProgress2.flags |= 16) : JSCompiler_temp.push(current2));
    workInProgress2.child = renderLanes2;
    workInProgress2.memoizedState = null;
    return renderLanes2;
  }
  function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
    primaryChildren = mountWorkInProgressOffscreenFiber(
      { mode: "visible", children: primaryChildren },
      workInProgress2.mode
    );
    primaryChildren.return = workInProgress2;
    return workInProgress2.child = primaryChildren;
  }
  function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
    offscreenProps = createFiberImplClass(22, offscreenProps, null, mode);
    offscreenProps.lanes = 0;
    return offscreenProps;
  }
  function retrySuspenseComponentWithoutHydrating(current2, workInProgress2, renderLanes2) {
    reconcileChildFibers(workInProgress2, current2.child, null, renderLanes2);
    current2 = mountSuspensePrimaryChildren(
      workInProgress2,
      workInProgress2.pendingProps.children
    );
    current2.flags |= 2;
    workInProgress2.memoizedState = null;
    return current2;
  }
  function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
    fiber.lanes |= renderLanes2;
    var alternate = fiber.alternate;
    null !== alternate && (alternate.lanes |= renderLanes2);
    scheduleContextWorkOnParentPath(fiber.return, renderLanes2, propagationRoot);
  }
  function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, treeForkCount2) {
    var renderState = workInProgress2.memoizedState;
    null === renderState ? workInProgress2.memoizedState = {
      isBackwards,
      rendering: null,
      renderingStartTime: 0,
      last: lastContentRow,
      tail,
      tailMode,
      treeForkCount: treeForkCount2
    } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount2);
  }
  function updateSuspenseListComponent(current2, workInProgress2, renderLanes2) {
    var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail;
    nextProps = nextProps.children;
    var suspenseContext = suspenseStackCursor.current, shouldForceFallback = 0 !== (suspenseContext & 2);
    shouldForceFallback ? (suspenseContext = suspenseContext & 1 | 2, workInProgress2.flags |= 128) : suspenseContext &= 1;
    push2(suspenseStackCursor, suspenseContext);
    reconcileChildren(current2, workInProgress2, nextProps, renderLanes2);
    nextProps = isHydrating ? treeForkCount : 0;
    if (!shouldForceFallback && null !== current2 && 0 !== (current2.flags & 128))
      a: for (current2 = workInProgress2.child; null !== current2; ) {
        if (13 === current2.tag)
          null !== current2.memoizedState && scheduleSuspenseWorkOnFiber(current2, renderLanes2, workInProgress2);
        else if (19 === current2.tag)
          scheduleSuspenseWorkOnFiber(current2, renderLanes2, workInProgress2);
        else if (null !== current2.child) {
          current2.child.return = current2;
          current2 = current2.child;
          continue;
        }
        if (current2 === workInProgress2) break a;
        for (; null === current2.sibling; ) {
          if (null === current2.return || current2.return === workInProgress2)
            break a;
          current2 = current2.return;
        }
        current2.sibling.return = current2.return;
        current2 = current2.sibling;
      }
    switch (revealOrder) {
      case "forwards":
        renderLanes2 = workInProgress2.child;
        for (revealOrder = null; null !== renderLanes2; )
          current2 = renderLanes2.alternate, null !== current2 && null === findFirstSuspended(current2) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
        renderLanes2 = revealOrder;
        null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
        initSuspenseListRenderState(
          workInProgress2,
          false,
          revealOrder,
          renderLanes2,
          tailMode,
          nextProps
        );
        break;
      case "backwards":
      case "unstable_legacy-backwards":
        renderLanes2 = null;
        revealOrder = workInProgress2.child;
        for (workInProgress2.child = null; null !== revealOrder; ) {
          current2 = revealOrder.alternate;
          if (null !== current2 && null === findFirstSuspended(current2)) {
            workInProgress2.child = revealOrder;
            break;
          }
          current2 = revealOrder.sibling;
          revealOrder.sibling = renderLanes2;
          renderLanes2 = revealOrder;
          revealOrder = current2;
        }
        initSuspenseListRenderState(
          workInProgress2,
          true,
          renderLanes2,
          null,
          tailMode,
          nextProps
        );
        break;
      case "together":
        initSuspenseListRenderState(
          workInProgress2,
          false,
          null,
          null,
          void 0,
          nextProps
        );
        break;
      default:
        workInProgress2.memoizedState = null;
    }
    return workInProgress2.child;
  }
  function bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2) {
    null !== current2 && (workInProgress2.dependencies = current2.dependencies);
    workInProgressRootSkippedLanes |= workInProgress2.lanes;
    if (0 === (renderLanes2 & workInProgress2.childLanes))
      if (null !== current2) {
        if (propagateParentContextChanges(
          current2,
          workInProgress2,
          renderLanes2,
          false
        ), 0 === (renderLanes2 & workInProgress2.childLanes))
          return null;
      } else return null;
    if (null !== current2 && workInProgress2.child !== current2.child)
      throw Error(formatProdErrorMessage2(153));
    if (null !== workInProgress2.child) {
      current2 = workInProgress2.child;
      renderLanes2 = createWorkInProgress(current2, current2.pendingProps);
      workInProgress2.child = renderLanes2;
      for (renderLanes2.return = workInProgress2; null !== current2.sibling; )
        current2 = current2.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current2, current2.pendingProps), renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
    }
    return workInProgress2.child;
  }
  function checkScheduledUpdateOrContext(current2, renderLanes2) {
    if (0 !== (current2.lanes & renderLanes2)) return true;
    current2 = current2.dependencies;
    return null !== current2 && checkIfContextChanged(current2) ? true : false;
  }
  function attemptEarlyBailoutIfNoScheduledUpdate(current2, workInProgress2, renderLanes2) {
    switch (workInProgress2.tag) {
      case 3:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        pushProvider(workInProgress2, CacheContext, current2.memoizedState.cache);
        resetHydrationState();
        break;
      case 27:
      case 5:
        pushHostContext(workInProgress2);
        break;
      case 4:
        pushHostContainer(workInProgress2, workInProgress2.stateNode.containerInfo);
        break;
      case 10:
        pushProvider(
          workInProgress2,
          workInProgress2.type,
          workInProgress2.memoizedProps.value
        );
        break;
      case 31:
        if (null !== workInProgress2.memoizedState)
          return workInProgress2.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress2), null;
        break;
      case 13:
        var state$102 = workInProgress2.memoizedState;
        if (null !== state$102) {
          if (null !== state$102.dehydrated)
            return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
          if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
            return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          current2 = bailoutOnAlreadyFinishedWork(
            current2,
            workInProgress2,
            renderLanes2
          );
          return null !== current2 ? current2.sibling : null;
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        break;
      case 19:
        var didSuspendBefore = 0 !== (current2.flags & 128);
        state$102 = 0 !== (renderLanes2 & workInProgress2.childLanes);
        state$102 || (propagateParentContextChanges(
          current2,
          workInProgress2,
          renderLanes2,
          false
        ), state$102 = 0 !== (renderLanes2 & workInProgress2.childLanes));
        if (didSuspendBefore) {
          if (state$102)
            return updateSuspenseListComponent(
              current2,
              workInProgress2,
              renderLanes2
            );
          workInProgress2.flags |= 128;
        }
        didSuspendBefore = workInProgress2.memoizedState;
        null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
        push2(suspenseStackCursor, suspenseStackCursor.current);
        if (state$102) break;
        else return null;
      case 22:
        return workInProgress2.lanes = 0, updateOffscreenComponent(
          current2,
          workInProgress2,
          renderLanes2,
          workInProgress2.pendingProps
        );
      case 24:
        pushProvider(workInProgress2, CacheContext, current2.memoizedState.cache);
    }
    return bailoutOnAlreadyFinishedWork(current2, workInProgress2, renderLanes2);
  }
  function beginWork(current2, workInProgress2, renderLanes2) {
    if (null !== current2)
      if (current2.memoizedProps !== workInProgress2.pendingProps)
        didReceiveUpdate = true;
      else {
        if (!checkScheduledUpdateOrContext(current2, renderLanes2) && 0 === (workInProgress2.flags & 128))
          return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
            current2,
            workInProgress2,
            renderLanes2
          );
        didReceiveUpdate = 0 !== (current2.flags & 131072) ? true : false;
      }
    else
      didReceiveUpdate = false, isHydrating && 0 !== (workInProgress2.flags & 1048576) && pushTreeId(workInProgress2, treeForkCount, workInProgress2.index);
    workInProgress2.lanes = 0;
    switch (workInProgress2.tag) {
      case 16:
        a: {
          var props2 = workInProgress2.pendingProps;
          current2 = resolveLazy(workInProgress2.elementType);
          workInProgress2.type = current2;
          if ("function" === typeof current2)
            shouldConstruct(current2) ? (props2 = resolveClassComponentProps(current2, props2), workInProgress2.tag = 1, workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              current2,
              props2,
              renderLanes2
            )) : (workInProgress2.tag = 0, workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              current2,
              props2,
              renderLanes2
            ));
          else {
            if (void 0 !== current2 && null !== current2) {
              var $$typeof = current2.$$typeof;
              if ($$typeof === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  current2,
                  props2,
                  renderLanes2
                );
                break a;
              } else if ($$typeof === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  current2,
                  props2,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = getComponentNameFromType(current2) || current2;
            throw Error(formatProdErrorMessage2(306, workInProgress2, ""));
          }
        }
        return workInProgress2;
      case 0:
        return updateFunctionComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 1:
        return props2 = workInProgress2.type, $$typeof = resolveClassComponentProps(
          props2,
          workInProgress2.pendingProps
        ), updateClassComponent(
          current2,
          workInProgress2,
          props2,
          $$typeof,
          renderLanes2
        );
      case 3:
        a: {
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          if (null === current2) throw Error(formatProdErrorMessage2(387));
          props2 = workInProgress2.pendingProps;
          var prevState = workInProgress2.memoizedState;
          $$typeof = prevState.element;
          cloneUpdateQueue(current2, workInProgress2);
          processUpdateQueue(workInProgress2, props2, null, renderLanes2);
          var nextState = workInProgress2.memoizedState;
          props2 = nextState.cache;
          pushProvider(workInProgress2, CacheContext, props2);
          props2 !== prevState.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          );
          suspendIfUpdateReadFromEntangledAsyncAction();
          props2 = nextState.element;
          if (prevState.isDehydrated)
            if (prevState = {
              element: props2,
              isDehydrated: false,
              cache: nextState.cache
            }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
              workInProgress2 = mountHostRootWithoutHydrating(
                current2,
                workInProgress2,
                props2,
                renderLanes2
              );
              break a;
            } else if (props2 !== $$typeof) {
              $$typeof = createCapturedValueAtFiber(
                Error(formatProdErrorMessage2(424)),
                workInProgress2
              );
              queueHydrationError($$typeof);
              workInProgress2 = mountHostRootWithoutHydrating(
                current2,
                workInProgress2,
                props2,
                renderLanes2
              );
              break a;
            } else {
              current2 = workInProgress2.stateNode.containerInfo;
              switch (current2.nodeType) {
                case 9:
                  current2 = current2.body;
                  break;
                default:
                  current2 = "HTML" === current2.nodeName ? current2.ownerDocument.body : current2;
              }
              nextHydratableInstance = getNextHydratable(current2.firstChild);
              hydrationParentFiber = workInProgress2;
              isHydrating = true;
              hydrationErrors = null;
              rootOrSingletonContext = true;
              renderLanes2 = mountChildFibers(
                workInProgress2,
                null,
                props2,
                renderLanes2
              );
              for (workInProgress2.child = renderLanes2; renderLanes2; )
                renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
            }
          else {
            resetHydrationState();
            if (props2 === $$typeof) {
              workInProgress2 = bailoutOnAlreadyFinishedWork(
                current2,
                workInProgress2,
                renderLanes2
              );
              break a;
            }
            reconcileChildren(current2, workInProgress2, props2, renderLanes2);
          }
          workInProgress2 = workInProgress2.child;
        }
        return workInProgress2;
      case 26:
        return markRef(current2, workInProgress2), null === current2 ? (renderLanes2 = getResource(
          workInProgress2.type,
          null,
          workInProgress2.pendingProps,
          null
        )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current2 = workInProgress2.pendingProps, props2 = getOwnerDocumentFromRootContainer(
          rootInstanceStackCursor.current
        ).createElement(renderLanes2), props2[internalInstanceKey] = workInProgress2, props2[internalPropsKey] = current2, setInitialProperties(props2, renderLanes2, current2), markNodeAsHoistable(props2), workInProgress2.stateNode = props2) : workInProgress2.memoizedState = getResource(
          workInProgress2.type,
          current2.memoizedProps,
          workInProgress2.pendingProps,
          current2.memoizedState
        ), null;
      case 27:
        return pushHostContext(workInProgress2), null === current2 && isHydrating && (props2 = workInProgress2.stateNode = resolveSingletonInstance(
          workInProgress2.type,
          workInProgress2.pendingProps,
          rootInstanceStackCursor.current
        ), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, $$typeof = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = $$typeof, nextHydratableInstance = getNextHydratable(props2.firstChild)) : nextHydratableInstance = $$typeof), reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), markRef(current2, workInProgress2), null === current2 && (workInProgress2.flags |= 4194304), workInProgress2.child;
      case 5:
        if (null === current2 && isHydrating) {
          if ($$typeof = props2 = nextHydratableInstance)
            props2 = canHydrateInstance(
              props2,
              workInProgress2.type,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== props2 ? (workInProgress2.stateNode = props2, hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(props2.firstChild), rootOrSingletonContext = false, $$typeof = true) : $$typeof = false;
          $$typeof || throwOnHydrationMismatch(workInProgress2);
        }
        pushHostContext(workInProgress2);
        $$typeof = workInProgress2.type;
        prevState = workInProgress2.pendingProps;
        nextState = null !== current2 ? current2.memoizedProps : null;
        props2 = prevState.children;
        shouldSetTextContent($$typeof, prevState) ? props2 = null : null !== nextState && shouldSetTextContent($$typeof, nextState) && (workInProgress2.flags |= 32);
        null !== workInProgress2.memoizedState && ($$typeof = renderWithHooks(
          current2,
          workInProgress2,
          TransitionAwareHostComponent,
          null,
          null,
          renderLanes2
        ), HostTransitionContext._currentValue = $$typeof);
        markRef(current2, workInProgress2);
        reconcileChildren(current2, workInProgress2, props2, renderLanes2);
        return workInProgress2.child;
      case 6:
        if (null === current2 && isHydrating) {
          if (current2 = renderLanes2 = nextHydratableInstance)
            renderLanes2 = canHydrateTextInstance(
              renderLanes2,
              workInProgress2.pendingProps,
              rootOrSingletonContext
            ), null !== renderLanes2 ? (workInProgress2.stateNode = renderLanes2, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, current2 = true) : current2 = false;
          current2 || throwOnHydrationMismatch(workInProgress2);
        }
        return null;
      case 13:
        return updateSuspenseComponent(current2, workInProgress2, renderLanes2);
      case 4:
        return pushHostContainer(
          workInProgress2,
          workInProgress2.stateNode.containerInfo
        ), props2 = workInProgress2.pendingProps, null === current2 ? workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          props2,
          renderLanes2
        ) : reconcileChildren(current2, workInProgress2, props2, renderLanes2), workInProgress2.child;
      case 11:
        return updateForwardRef(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 7:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps,
          renderLanes2
        ), workInProgress2.child;
      case 8:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 12:
        return reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 10:
        return props2 = workInProgress2.pendingProps, pushProvider(workInProgress2, workInProgress2.type, props2.value), reconcileChildren(current2, workInProgress2, props2.children, renderLanes2), workInProgress2.child;
      case 9:
        return $$typeof = workInProgress2.type._context, props2 = workInProgress2.pendingProps.children, prepareToReadContext(workInProgress2), $$typeof = readContext($$typeof), props2 = props2($$typeof), workInProgress2.flags |= 1, reconcileChildren(current2, workInProgress2, props2, renderLanes2), workInProgress2.child;
      case 14:
        return updateMemoComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 15:
        return updateSimpleMemoComponent(
          current2,
          workInProgress2,
          workInProgress2.type,
          workInProgress2.pendingProps,
          renderLanes2
        );
      case 19:
        return updateSuspenseListComponent(current2, workInProgress2, renderLanes2);
      case 31:
        return updateActivityComponent(current2, workInProgress2, renderLanes2);
      case 22:
        return updateOffscreenComponent(
          current2,
          workInProgress2,
          renderLanes2,
          workInProgress2.pendingProps
        );
      case 24:
        return prepareToReadContext(workInProgress2), props2 = readContext(CacheContext), null === current2 ? ($$typeof = peekCacheFromPool(), null === $$typeof && ($$typeof = workInProgressRoot, prevState = createCache(), $$typeof.pooledCache = prevState, prevState.refCount++, null !== prevState && ($$typeof.pooledCacheLanes |= renderLanes2), $$typeof = prevState), workInProgress2.memoizedState = { parent: props2, cache: $$typeof }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, $$typeof)) : (0 !== (current2.lanes & renderLanes2) && (cloneUpdateQueue(current2, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), $$typeof = current2.memoizedState, prevState = workInProgress2.memoizedState, $$typeof.parent !== props2 ? ($$typeof = { parent: props2, cache: props2 }, workInProgress2.memoizedState = $$typeof, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = $$typeof), pushProvider(workInProgress2, CacheContext, props2)) : (props2 = prevState.cache, pushProvider(workInProgress2, CacheContext, props2), props2 !== $$typeof.cache && propagateContextChanges(
          workInProgress2,
          [CacheContext],
          renderLanes2,
          true
        ))), reconcileChildren(
          current2,
          workInProgress2,
          workInProgress2.pendingProps.children,
          renderLanes2
        ), workInProgress2.child;
      case 29:
        throw workInProgress2.pendingProps;
    }
    throw Error(formatProdErrorMessage2(156, workInProgress2.tag));
  }
  function markUpdate(workInProgress2) {
    workInProgress2.flags |= 4;
  }
  function preloadInstanceAndSuspendIfNeeded(workInProgress2, type, oldProps, newProps, renderLanes2) {
    if (type = 0 !== (workInProgress2.mode & 32)) type = false;
    if (type) {
      if (workInProgress2.flags |= 16777216, (renderLanes2 & 335544128) === renderLanes2)
        if (workInProgress2.stateNode.complete) workInProgress2.flags |= 8192;
        else if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
        else
          throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    } else workInProgress2.flags &= -16777217;
  }
  function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
    if ("stylesheet" !== resource.type || 0 !== (resource.state.loading & 4))
      workInProgress2.flags &= -16777217;
    else if (workInProgress2.flags |= 16777216, !preloadResource(resource))
      if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
      else
        throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
  }
  function scheduleRetryEffect(workInProgress2, retryQueue) {
    null !== retryQueue && (workInProgress2.flags |= 4);
    workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
  }
  function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
    if (!isHydrating)
      switch (renderState.tailMode) {
        case "hidden":
          hasRenderedATailFallback = renderState.tail;
          for (var lastTailNode = null; null !== hasRenderedATailFallback; )
            null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
          null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
          break;
        case "collapsed":
          lastTailNode = renderState.tail;
          for (var lastTailNode$106 = null; null !== lastTailNode; )
            null !== lastTailNode.alternate && (lastTailNode$106 = lastTailNode), lastTailNode = lastTailNode.sibling;
          null === lastTailNode$106 ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : lastTailNode$106.sibling = null;
      }
  }
  function bubbleProperties(completedWork) {
    var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
    if (didBailout)
      for (var child$107 = completedWork.child; null !== child$107; )
        newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags & 65011712, subtreeFlags |= child$107.flags & 65011712, child$107.return = completedWork, child$107 = child$107.sibling;
    else
      for (child$107 = completedWork.child; null !== child$107; )
        newChildLanes |= child$107.lanes | child$107.childLanes, subtreeFlags |= child$107.subtreeFlags, subtreeFlags |= child$107.flags, child$107.return = completedWork, child$107 = child$107.sibling;
    completedWork.subtreeFlags |= subtreeFlags;
    completedWork.childLanes = newChildLanes;
    return didBailout;
  }
  function completeWork(current2, workInProgress2, renderLanes2) {
    var newProps = workInProgress2.pendingProps;
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 16:
      case 15:
      case 0:
      case 11:
      case 7:
      case 8:
      case 12:
      case 9:
      case 14:
        return bubbleProperties(workInProgress2), null;
      case 1:
        return bubbleProperties(workInProgress2), null;
      case 3:
        renderLanes2 = workInProgress2.stateNode;
        newProps = null;
        null !== current2 && (newProps = current2.memoizedState.cache);
        workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
        popProvider(CacheContext);
        popHostContainer();
        renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
        if (null === current2 || null === current2.child)
          popHydrationState(workInProgress2) ? markUpdate(workInProgress2) : null === current2 || current2.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
        bubbleProperties(workInProgress2);
        return null;
      case 26:
        var type = workInProgress2.type, nextResource = workInProgress2.memoizedState;
        null === current2 ? (markUpdate(workInProgress2), null !== nextResource ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, nextResource)) : (bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          type,
          null,
          newProps,
          renderLanes2
        ))) : nextResource ? nextResource !== current2.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(workInProgress2, nextResource)) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current2 = current2.memoizedProps, current2 !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          type,
          current2,
          newProps,
          renderLanes2
        ));
        return null;
      case 27:
        popHostContext(workInProgress2);
        renderLanes2 = rootInstanceStackCursor.current;
        type = workInProgress2.type;
        if (null !== current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage2(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          current2 = contextStackCursor.current;
          popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current2 = resolveSingletonInstance(type, newProps, renderLanes2), workInProgress2.stateNode = current2, markUpdate(workInProgress2));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 5:
        popHostContext(workInProgress2);
        type = workInProgress2.type;
        if (null !== current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if (!newProps) {
            if (null === workInProgress2.stateNode)
              throw Error(formatProdErrorMessage2(166));
            bubbleProperties(workInProgress2);
            return null;
          }
          nextResource = contextStackCursor.current;
          if (popHydrationState(workInProgress2))
            prepareToHydrateHostInstance(workInProgress2);
          else {
            var ownerDocument = getOwnerDocumentFromRootContainer(
              rootInstanceStackCursor.current
            );
            switch (nextResource) {
              case 1:
                nextResource = ownerDocument.createElementNS(
                  "http://www.w3.org/2000/svg",
                  type
                );
                break;
              case 2:
                nextResource = ownerDocument.createElementNS(
                  "http://www.w3.org/1998/Math/MathML",
                  type
                );
                break;
              default:
                switch (type) {
                  case "svg":
                    nextResource = ownerDocument.createElementNS(
                      "http://www.w3.org/2000/svg",
                      type
                    );
                    break;
                  case "math":
                    nextResource = ownerDocument.createElementNS(
                      "http://www.w3.org/1998/Math/MathML",
                      type
                    );
                    break;
                  case "script":
                    nextResource = ownerDocument.createElement("div");
                    nextResource.innerHTML = "<script><\/script>";
                    nextResource = nextResource.removeChild(
                      nextResource.firstChild
                    );
                    break;
                  case "select":
                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement("select", {
                      is: newProps.is
                    }) : ownerDocument.createElement("select");
                    newProps.multiple ? nextResource.multiple = true : newProps.size && (nextResource.size = newProps.size);
                    break;
                  default:
                    nextResource = "string" === typeof newProps.is ? ownerDocument.createElement(type, { is: newProps.is }) : ownerDocument.createElement(type);
                }
            }
            nextResource[internalInstanceKey] = workInProgress2;
            nextResource[internalPropsKey] = newProps;
            a: for (ownerDocument = workInProgress2.child; null !== ownerDocument; ) {
              if (5 === ownerDocument.tag || 6 === ownerDocument.tag)
                nextResource.appendChild(ownerDocument.stateNode);
              else if (4 !== ownerDocument.tag && 27 !== ownerDocument.tag && null !== ownerDocument.child) {
                ownerDocument.child.return = ownerDocument;
                ownerDocument = ownerDocument.child;
                continue;
              }
              if (ownerDocument === workInProgress2) break a;
              for (; null === ownerDocument.sibling; ) {
                if (null === ownerDocument.return || ownerDocument.return === workInProgress2)
                  break a;
                ownerDocument = ownerDocument.return;
              }
              ownerDocument.sibling.return = ownerDocument.return;
              ownerDocument = ownerDocument.sibling;
            }
            workInProgress2.stateNode = nextResource;
            a: switch (setInitialProperties(nextResource, type, newProps), type) {
              case "button":
              case "input":
              case "select":
              case "textarea":
                newProps = !!newProps.autoFocus;
                break a;
              case "img":
                newProps = true;
                break a;
              default:
                newProps = false;
            }
            newProps && markUpdate(workInProgress2);
          }
        }
        bubbleProperties(workInProgress2);
        preloadInstanceAndSuspendIfNeeded(
          workInProgress2,
          workInProgress2.type,
          null === current2 ? null : current2.memoizedProps,
          workInProgress2.pendingProps,
          renderLanes2
        );
        return null;
      case 6:
        if (current2 && null != workInProgress2.stateNode)
          current2.memoizedProps !== newProps && markUpdate(workInProgress2);
        else {
          if ("string" !== typeof newProps && null === workInProgress2.stateNode)
            throw Error(formatProdErrorMessage2(166));
          current2 = rootInstanceStackCursor.current;
          if (popHydrationState(workInProgress2)) {
            current2 = workInProgress2.stateNode;
            renderLanes2 = workInProgress2.memoizedProps;
            newProps = null;
            type = hydrationParentFiber;
            if (null !== type)
              switch (type.tag) {
                case 27:
                case 5:
                  newProps = type.memoizedProps;
              }
            current2[internalInstanceKey] = workInProgress2;
            current2 = current2.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current2.nodeValue, renderLanes2) ? true : false;
            current2 || throwOnHydrationMismatch(workInProgress2, true);
          } else
            current2 = getOwnerDocumentFromRootContainer(current2).createTextNode(
              newProps
            ), current2[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current2;
        }
        bubbleProperties(workInProgress2);
        return null;
      case 31:
        renderLanes2 = workInProgress2.memoizedState;
        if (null === current2 || null !== current2.memoizedState) {
          newProps = popHydrationState(workInProgress2);
          if (null !== renderLanes2) {
            if (null === current2) {
              if (!newProps) throw Error(formatProdErrorMessage2(318));
              current2 = workInProgress2.memoizedState;
              current2 = null !== current2 ? current2.dehydrated : null;
              if (!current2) throw Error(formatProdErrorMessage2(557));
              current2[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            current2 = false;
          } else
            renderLanes2 = upgradeHydrationErrorsToRecoverable(), null !== current2 && null !== current2.memoizedState && (current2.memoizedState.hydrationErrors = renderLanes2), current2 = true;
          if (!current2) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
          if (0 !== (workInProgress2.flags & 128))
            throw Error(formatProdErrorMessage2(558));
        }
        bubbleProperties(workInProgress2);
        return null;
      case 13:
        newProps = workInProgress2.memoizedState;
        if (null === current2 || null !== current2.memoizedState && null !== current2.memoizedState.dehydrated) {
          type = popHydrationState(workInProgress2);
          if (null !== newProps && null !== newProps.dehydrated) {
            if (null === current2) {
              if (!type) throw Error(formatProdErrorMessage2(318));
              type = workInProgress2.memoizedState;
              type = null !== type ? type.dehydrated : null;
              if (!type) throw Error(formatProdErrorMessage2(317));
              type[internalInstanceKey] = workInProgress2;
            } else
              resetHydrationState(), 0 === (workInProgress2.flags & 128) && (workInProgress2.memoizedState = null), workInProgress2.flags |= 4;
            bubbleProperties(workInProgress2);
            type = false;
          } else
            type = upgradeHydrationErrorsToRecoverable(), null !== current2 && null !== current2.memoizedState && (current2.memoizedState.hydrationErrors = type), type = true;
          if (!type) {
            if (workInProgress2.flags & 256)
              return popSuspenseHandler(workInProgress2), workInProgress2;
            popSuspenseHandler(workInProgress2);
            return null;
          }
        }
        popSuspenseHandler(workInProgress2);
        if (0 !== (workInProgress2.flags & 128))
          return workInProgress2.lanes = renderLanes2, workInProgress2;
        renderLanes2 = null !== newProps;
        current2 = null !== current2 && null !== current2.memoizedState;
        renderLanes2 && (newProps = workInProgress2.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
        renderLanes2 !== current2 && renderLanes2 && (workInProgress2.child.flags |= 8192);
        scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
        bubbleProperties(workInProgress2);
        return null;
      case 4:
        return popHostContainer(), null === current2 && listenToAllSupportedEvents(workInProgress2.stateNode.containerInfo), bubbleProperties(workInProgress2), null;
      case 10:
        return popProvider(workInProgress2.type), bubbleProperties(workInProgress2), null;
      case 19:
        pop(suspenseStackCursor);
        newProps = workInProgress2.memoizedState;
        if (null === newProps) return bubbleProperties(workInProgress2), null;
        type = 0 !== (workInProgress2.flags & 128);
        nextResource = newProps.rendering;
        if (null === nextResource)
          if (type) cutOffTailIfNeeded(newProps, false);
          else {
            if (0 !== workInProgressRootExitStatus || null !== current2 && 0 !== (current2.flags & 128))
              for (current2 = workInProgress2.child; null !== current2; ) {
                nextResource = findFirstSuspended(current2);
                if (null !== nextResource) {
                  workInProgress2.flags |= 128;
                  cutOffTailIfNeeded(newProps, false);
                  current2 = nextResource.updateQueue;
                  workInProgress2.updateQueue = current2;
                  scheduleRetryEffect(workInProgress2, current2);
                  workInProgress2.subtreeFlags = 0;
                  current2 = renderLanes2;
                  for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                    resetWorkInProgress(renderLanes2, current2), renderLanes2 = renderLanes2.sibling;
                  push2(
                    suspenseStackCursor,
                    suspenseStackCursor.current & 1 | 2
                  );
                  isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount);
                  return workInProgress2.child;
                }
                current2 = current2.sibling;
              }
            null !== newProps.tail && now() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
          }
        else {
          if (!type)
            if (current2 = findFirstSuspended(nextResource), null !== current2) {
              if (workInProgress2.flags |= 128, type = true, current2 = current2.updateQueue, workInProgress2.updateQueue = current2, scheduleRetryEffect(workInProgress2, current2), cutOffTailIfNeeded(newProps, true), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating)
                return bubbleProperties(workInProgress2), null;
            } else
              2 * now() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
          newProps.isBackwards ? (nextResource.sibling = workInProgress2.child, workInProgress2.child = nextResource) : (current2 = newProps.last, null !== current2 ? current2.sibling = nextResource : workInProgress2.child = nextResource, newProps.last = nextResource);
        }
        if (null !== newProps.tail)
          return current2 = newProps.tail, newProps.rendering = current2, newProps.tail = current2.sibling, newProps.renderingStartTime = now(), current2.sibling = null, renderLanes2 = suspenseStackCursor.current, push2(
            suspenseStackCursor,
            type ? renderLanes2 & 1 | 2 : renderLanes2 & 1
          ), isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount), current2;
        bubbleProperties(workInProgress2);
        return null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), newProps = null !== workInProgress2.memoizedState, null !== current2 ? null !== current2.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (renderLanes2 = current2.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current2 && pop(resumedCache), null;
      case 24:
        return renderLanes2 = null, null !== current2 && (renderLanes2 = current2.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext), bubbleProperties(workInProgress2), null;
      case 25:
        return null;
      case 30:
        return null;
    }
    throw Error(formatProdErrorMessage2(156, workInProgress2.tag));
  }
  function unwindWork(current2, workInProgress2) {
    popTreeContext(workInProgress2);
    switch (workInProgress2.tag) {
      case 1:
        return current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 3:
        return popProvider(CacheContext), popHostContainer(), current2 = workInProgress2.flags, 0 !== (current2 & 65536) && 0 === (current2 & 128) ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 26:
      case 27:
      case 5:
        return popHostContext(workInProgress2), null;
      case 31:
        if (null !== workInProgress2.memoizedState) {
          popSuspenseHandler(workInProgress2);
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage2(340));
          resetHydrationState();
        }
        current2 = workInProgress2.flags;
        return current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 13:
        popSuspenseHandler(workInProgress2);
        current2 = workInProgress2.memoizedState;
        if (null !== current2 && null !== current2.dehydrated) {
          if (null === workInProgress2.alternate)
            throw Error(formatProdErrorMessage2(340));
          resetHydrationState();
        }
        current2 = workInProgress2.flags;
        return current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 19:
        return pop(suspenseStackCursor), null;
      case 4:
        return popHostContainer(), null;
      case 10:
        return popProvider(workInProgress2.type), null;
      case 22:
      case 23:
        return popSuspenseHandler(workInProgress2), popHiddenContext(), null !== current2 && pop(resumedCache), current2 = workInProgress2.flags, current2 & 65536 ? (workInProgress2.flags = current2 & -65537 | 128, workInProgress2) : null;
      case 24:
        return popProvider(CacheContext), null;
      case 25:
        return null;
      default:
        return null;
    }
  }
  function unwindInterruptedWork(current2, interruptedWork) {
    popTreeContext(interruptedWork);
    switch (interruptedWork.tag) {
      case 3:
        popProvider(CacheContext);
        popHostContainer();
        break;
      case 26:
      case 27:
      case 5:
        popHostContext(interruptedWork);
        break;
      case 4:
        popHostContainer();
        break;
      case 31:
        null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
        break;
      case 13:
        popSuspenseHandler(interruptedWork);
        break;
      case 19:
        pop(suspenseStackCursor);
        break;
      case 10:
        popProvider(interruptedWork.type);
        break;
      case 22:
      case 23:
        popSuspenseHandler(interruptedWork);
        popHiddenContext();
        null !== current2 && pop(resumedCache);
        break;
      case 24:
        popProvider(CacheContext);
    }
  }
  function commitHookEffectListMount(flags, finishedWork) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            lastEffect = void 0;
            var create2 = updateQueue.create, inst = updateQueue.inst;
            lastEffect = create2();
            inst.destroy = lastEffect;
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor$jscomp$0) {
    try {
      var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
      if (null !== lastEffect) {
        var firstEffect = lastEffect.next;
        updateQueue = firstEffect;
        do {
          if ((updateQueue.tag & flags) === flags) {
            var inst = updateQueue.inst, destroy = inst.destroy;
            if (void 0 !== destroy) {
              inst.destroy = void 0;
              lastEffect = finishedWork;
              var nearestMountedAncestor = nearestMountedAncestor$jscomp$0, destroy_ = destroy;
              try {
                destroy_();
              } catch (error) {
                captureCommitPhaseError(
                  lastEffect,
                  nearestMountedAncestor,
                  error
                );
              }
            }
          }
          updateQueue = updateQueue.next;
        } while (updateQueue !== firstEffect);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitClassCallbacks(finishedWork) {
    var updateQueue = finishedWork.updateQueue;
    if (null !== updateQueue) {
      var instance = finishedWork.stateNode;
      try {
        commitCallbacks(updateQueue, instance);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
  }
  function safelyCallComponentWillUnmount(current2, nearestMountedAncestor, instance) {
    instance.props = resolveClassComponentProps(
      current2.type,
      current2.memoizedProps
    );
    instance.state = current2.memoizedState;
    try {
      instance.componentWillUnmount();
    } catch (error) {
      captureCommitPhaseError(current2, nearestMountedAncestor, error);
    }
  }
  function safelyAttachRef(current2, nearestMountedAncestor) {
    try {
      var ref = current2.ref;
      if (null !== ref) {
        switch (current2.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = current2.stateNode;
            break;
          case 30:
            instanceToUse = current2.stateNode;
            break;
          default:
            instanceToUse = current2.stateNode;
        }
        "function" === typeof ref ? current2.refCleanup = ref(instanceToUse) : ref.current = instanceToUse;
      }
    } catch (error) {
      captureCommitPhaseError(current2, nearestMountedAncestor, error);
    }
  }
  function safelyDetachRef(current2, nearestMountedAncestor) {
    var ref = current2.ref, refCleanup = current2.refCleanup;
    if (null !== ref)
      if ("function" === typeof refCleanup)
        try {
          refCleanup();
        } catch (error) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error);
        } finally {
          current2.refCleanup = null, current2 = current2.alternate, null != current2 && (current2.refCleanup = null);
        }
      else if ("function" === typeof ref)
        try {
          ref(null);
        } catch (error$140) {
          captureCommitPhaseError(current2, nearestMountedAncestor, error$140);
        }
      else ref.current = null;
  }
  function commitHostMount(finishedWork) {
    var type = finishedWork.type, props2 = finishedWork.memoizedProps, instance = finishedWork.stateNode;
    try {
      a: switch (type) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          props2.autoFocus && instance.focus();
          break a;
        case "img":
          props2.src ? instance.src = props2.src : props2.srcSet && (instance.srcset = props2.srcSet);
      }
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function commitHostUpdate(finishedWork, newProps, oldProps) {
    try {
      var domElement = finishedWork.stateNode;
      updateProperties(domElement, finishedWork.type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  function isHostParent(fiber) {
    return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
  }
  function getHostSibling(fiber) {
    a: for (; ; ) {
      for (; null === fiber.sibling; ) {
        if (null === fiber.return || isHostParent(fiber.return)) return null;
        fiber = fiber.return;
      }
      fiber.sibling.return = fiber.return;
      for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
        if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
        if (fiber.flags & 2) continue a;
        if (null === fiber.child || 4 === fiber.tag) continue a;
        else fiber.child.return = fiber, fiber = fiber.child;
      }
      if (!(fiber.flags & 2)) return fiber.stateNode;
    }
  }
  function insertOrAppendPlacementNodeIntoContainer(node, before2, parent) {
    var tag2 = node.tag;
    if (5 === tag2 || 6 === tag2)
      node = node.stateNode, before2 ? (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before2) : (before2 = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before2.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before2.onclick || (before2.onclick = noop$12));
    else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode, before2 = null), node = node.child, null !== node))
      for (insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling;
  }
  function insertOrAppendPlacementNode(node, before2, parent) {
    var tag2 = node.tag;
    if (5 === tag2 || 6 === tag2)
      node = node.stateNode, before2 ? parent.insertBefore(node, before2) : parent.appendChild(node);
    else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node))
      for (insertOrAppendPlacementNode(node, before2, parent), node = node.sibling; null !== node; )
        insertOrAppendPlacementNode(node, before2, parent), node = node.sibling;
  }
  function commitHostSingletonAcquisition(finishedWork) {
    var singleton = finishedWork.stateNode, props2 = finishedWork.memoizedProps;
    try {
      for (var type = finishedWork.type, attributes = singleton.attributes; attributes.length; )
        singleton.removeAttributeNode(attributes[0]);
      setInitialProperties(singleton, type, props2);
      singleton[internalInstanceKey] = finishedWork;
      singleton[internalPropsKey] = props2;
    } catch (error) {
      captureCommitPhaseError(finishedWork, finishedWork.return, error);
    }
  }
  var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null;
  function commitBeforeMutationEffects(root3, firstChild) {
    root3 = root3.containerInfo;
    eventsEnabled = _enabled;
    root3 = getActiveElementDeep(root3);
    if (hasSelectionCapabilities(root3)) {
      if ("selectionStart" in root3)
        var JSCompiler_temp = {
          start: root3.selectionStart,
          end: root3.selectionEnd
        };
      else
        a: {
          JSCompiler_temp = (JSCompiler_temp = root3.ownerDocument) && JSCompiler_temp.defaultView || window;
          var selection2 = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
          if (selection2 && 0 !== selection2.rangeCount) {
            JSCompiler_temp = selection2.anchorNode;
            var anchorOffset = selection2.anchorOffset, focusNode = selection2.focusNode;
            selection2 = selection2.focusOffset;
            try {
              JSCompiler_temp.nodeType, focusNode.nodeType;
            } catch (e$20) {
              JSCompiler_temp = null;
              break a;
            }
            var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root3, parentNode = null;
            b: for (; ; ) {
              for (var next; ; ) {
                node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                node !== focusNode || 0 !== selection2 && 3 !== node.nodeType || (end = length + selection2);
                3 === node.nodeType && (length += node.nodeValue.length);
                if (null === (next = node.firstChild)) break;
                parentNode = node;
                node = next;
              }
              for (; ; ) {
                if (node === root3) break b;
                parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                parentNode === focusNode && ++indexWithinFocus === selection2 && (end = length);
                if (null !== (next = node.nextSibling)) break;
                node = parentNode;
                parentNode = node.parentNode;
              }
              node = next;
            }
            JSCompiler_temp = -1 === start || -1 === end ? null : { start, end };
          } else JSCompiler_temp = null;
        }
      JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
    } else JSCompiler_temp = null;
    selectionInformation = { focusedElem: root3, selectionRange: JSCompiler_temp };
    _enabled = false;
    for (nextEffect = firstChild; null !== nextEffect; )
      if (firstChild = nextEffect, root3 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root3)
        root3.return = firstChild, nextEffect = root3;
      else
        for (; null !== nextEffect; ) {
          firstChild = nextEffect;
          focusNode = firstChild.alternate;
          root3 = firstChild.flags;
          switch (firstChild.tag) {
            case 0:
              if (0 !== (root3 & 4) && (root3 = firstChild.updateQueue, root3 = null !== root3 ? root3.events : null, null !== root3))
                for (JSCompiler_temp = 0; JSCompiler_temp < root3.length; JSCompiler_temp++)
                  anchorOffset = root3[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
              break;
            case 11:
            case 15:
              break;
            case 1:
              if (0 !== (root3 & 1024) && null !== focusNode) {
                root3 = void 0;
                JSCompiler_temp = firstChild;
                anchorOffset = focusNode.memoizedProps;
                focusNode = focusNode.memoizedState;
                selection2 = JSCompiler_temp.stateNode;
                try {
                  var resolvedPrevProps = resolveClassComponentProps(
                    JSCompiler_temp.type,
                    anchorOffset
                  );
                  root3 = selection2.getSnapshotBeforeUpdate(
                    resolvedPrevProps,
                    focusNode
                  );
                  selection2.__reactInternalSnapshotBeforeUpdate = root3;
                } catch (error) {
                  captureCommitPhaseError(
                    JSCompiler_temp,
                    JSCompiler_temp.return,
                    error
                  );
                }
              }
              break;
            case 3:
              if (0 !== (root3 & 1024)) {
                if (root3 = firstChild.stateNode.containerInfo, JSCompiler_temp = root3.nodeType, 9 === JSCompiler_temp)
                  clearContainerSparingly(root3);
                else if (1 === JSCompiler_temp)
                  switch (root3.nodeName) {
                    case "HEAD":
                    case "HTML":
                    case "BODY":
                      clearContainerSparingly(root3);
                      break;
                    default:
                      root3.textContent = "";
                  }
              }
              break;
            case 5:
            case 26:
            case 27:
            case 6:
            case 4:
            case 17:
              break;
            default:
              if (0 !== (root3 & 1024)) throw Error(formatProdErrorMessage2(163));
          }
          root3 = firstChild.sibling;
          if (null !== root3) {
            root3.return = firstChild.return;
            nextEffect = root3;
            break;
          }
          nextEffect = firstChild.return;
        }
  }
  function commitLayoutEffectOnFiber(finishedRoot, current2, finishedWork) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitHookEffectListMount(5, finishedWork);
        break;
      case 1:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 4)
          if (finishedRoot = finishedWork.stateNode, null === current2)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          else {
            var prevProps = resolveClassComponentProps(
              finishedWork.type,
              current2.memoizedProps
            );
            current2 = current2.memoizedState;
            try {
              finishedRoot.componentDidUpdate(
                prevProps,
                current2,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            } catch (error$139) {
              captureCommitPhaseError(
                finishedWork,
                finishedWork.return,
                error$139
              );
            }
          }
        flags & 64 && commitClassCallbacks(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        if (flags & 64 && (finishedRoot = finishedWork.updateQueue, null !== finishedRoot)) {
          current2 = null;
          if (null !== finishedWork.child)
            switch (finishedWork.child.tag) {
              case 27:
              case 5:
                current2 = finishedWork.child.stateNode;
                break;
              case 1:
                current2 = finishedWork.child.stateNode;
            }
          try {
            commitCallbacks(finishedRoot, current2);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 27:
        null === current2 && flags & 4 && commitHostSingletonAcquisition(finishedWork);
      case 26:
      case 5:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        null === current2 && flags & 4 && commitHostMount(finishedWork);
        flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
        break;
      case 12:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        break;
      case 31:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
        break;
      case 13:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
        flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
        flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (finishedWork = retryDehydratedSuspenseBoundary.bind(
          null,
          finishedWork
        ), registerSuspenseInstanceRetry(finishedRoot, finishedWork))));
        break;
      case 22:
        flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
        if (!flags) {
          current2 = null !== current2 && null !== current2.memoizedState || offscreenSubtreeWasHidden;
          prevProps = offscreenSubtreeIsHidden;
          var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = flags;
          (offscreenSubtreeWasHidden = current2) && !prevOffscreenSubtreeWasHidden ? recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            0 !== (finishedWork.subtreeFlags & 8772)
          ) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          offscreenSubtreeIsHidden = prevProps;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        }
        break;
      case 30:
        break;
      default:
        recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
    }
  }
  function detachFiberAfterEffects(fiber) {
    var alternate = fiber.alternate;
    null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
    fiber.child = null;
    fiber.deletions = null;
    fiber.sibling = null;
    5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
    fiber.stateNode = null;
    fiber.return = null;
    fiber.dependencies = null;
    fiber.memoizedProps = null;
    fiber.memoizedState = null;
    fiber.pendingProps = null;
    fiber.stateNode = null;
    fiber.updateQueue = null;
  }
  var hostParent = null, hostParentIsContainer = false;
  function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
    for (parent = parent.child; null !== parent; )
      commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, parent), parent = parent.sibling;
  }
  function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
    if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
      try {
        injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
      } catch (err) {
      }
    switch (deletedFiber.tag) {
      case 26:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (deletedFiber = deletedFiber.stateNode, deletedFiber.parentNode.removeChild(deletedFiber));
        break;
      case 27:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
        isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        releaseSingletonInstance(deletedFiber.stateNode);
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 5:
        offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
      case 6:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = null;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        if (null !== hostParent)
          if (hostParentIsContainer)
            try {
              (9 === hostParent.nodeType ? hostParent.body : "HTML" === hostParent.nodeName ? hostParent.ownerDocument.body : hostParent).removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
          else
            try {
              hostParent.removeChild(deletedFiber.stateNode);
            } catch (error) {
              captureCommitPhaseError(
                deletedFiber,
                nearestMountedAncestor,
                error
              );
            }
        break;
      case 18:
        null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(
          9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
          deletedFiber.stateNode
        ), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
        break;
      case 4:
        prevHostParent = hostParent;
        prevHostParentIsContainer = hostParentIsContainer;
        hostParent = deletedFiber.stateNode.containerInfo;
        hostParentIsContainer = true;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        hostParent = prevHostParent;
        hostParentIsContainer = prevHostParentIsContainer;
        break;
      case 0:
      case 11:
      case 14:
      case 15:
        commitHookEffectListUnmount(2, deletedFiber, nearestMountedAncestor);
        offscreenSubtreeWasHidden || commitHookEffectListUnmount(4, deletedFiber, nearestMountedAncestor);
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 1:
        offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
          deletedFiber,
          nearestMountedAncestor,
          prevHostParent
        ));
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 21:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        break;
      case 22:
        offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
        offscreenSubtreeWasHidden = prevHostParent;
        break;
      default:
        recursivelyTraverseDeletionEffects(
          finishedRoot,
          nearestMountedAncestor,
          deletedFiber
        );
    }
  }
  function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
      finishedRoot = finishedRoot.dehydrated;
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
  }
  function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
    if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
      try {
        retryIfBlockedOn(finishedRoot);
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
  }
  function getRetryCache(finishedWork) {
    switch (finishedWork.tag) {
      case 31:
      case 13:
      case 19:
        var retryCache = finishedWork.stateNode;
        null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
        return retryCache;
      case 22:
        return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
      default:
        throw Error(formatProdErrorMessage2(435, finishedWork.tag));
    }
  }
  function attachSuspenseRetryListeners(finishedWork, wakeables) {
    var retryCache = getRetryCache(finishedWork);
    wakeables.forEach(function(wakeable) {
      if (!retryCache.has(wakeable)) {
        retryCache.add(wakeable);
        var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
        wakeable.then(retry, retry);
      }
    });
  }
  function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
    var deletions = parentFiber.deletions;
    if (null !== deletions)
      for (var i2 = 0; i2 < deletions.length; i2++) {
        var childToDelete = deletions[i2], root3 = root$jscomp$0, returnFiber = parentFiber, parent = returnFiber;
        a: for (; null !== parent; ) {
          switch (parent.tag) {
            case 27:
              if (isSingletonScope(parent.type)) {
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              }
              break;
            case 5:
              hostParent = parent.stateNode;
              hostParentIsContainer = false;
              break a;
            case 3:
            case 4:
              hostParent = parent.stateNode.containerInfo;
              hostParentIsContainer = true;
              break a;
          }
          parent = parent.return;
        }
        if (null === hostParent) throw Error(formatProdErrorMessage2(160));
        commitDeletionEffectsOnFiber(root3, returnFiber, childToDelete);
        hostParent = null;
        hostParentIsContainer = false;
        root3 = childToDelete.alternate;
        null !== root3 && (root3.return = null);
        childToDelete.return = null;
      }
    if (parentFiber.subtreeFlags & 13886)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
  }
  var currentHoistableRoot = null;
  function commitMutationEffectsOnFiber(finishedWork, root3) {
    var current2 = finishedWork.alternate, flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 14:
      case 15:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (commitHookEffectListUnmount(3, finishedWork, finishedWork.return), commitHookEffectListMount(3, finishedWork), commitHookEffectListUnmount(5, finishedWork, finishedWork.return));
        break;
      case 1:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        flags & 64 && offscreenSubtreeIsHidden && (finishedWork = finishedWork.updateQueue, null !== finishedWork && (flags = finishedWork.callbacks, null !== flags && (current2 = finishedWork.shared.hiddenCallbacks, finishedWork.shared.hiddenCallbacks = null === current2 ? flags : current2.concat(flags))));
        break;
      case 26:
        var hoistableRoot = currentHoistableRoot;
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        if (flags & 4) {
          var currentResource = null !== current2 ? current2.memoizedState : null;
          flags = finishedWork.memoizedState;
          if (null === current2)
            if (null === flags)
              if (null === finishedWork.stateNode) {
                a: {
                  flags = finishedWork.type;
                  current2 = finishedWork.memoizedProps;
                  hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
                  b: switch (flags) {
                    case "title":
                      currentResource = hoistableRoot.getElementsByTagName("title")[0];
                      if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || "http://www.w3.org/2000/svg" === currentResource.namespaceURI || currentResource.hasAttribute("itemprop"))
                        currentResource = hoistableRoot.createElement(flags), hoistableRoot.head.insertBefore(
                          currentResource,
                          hoistableRoot.querySelector("head > title")
                        );
                      setInitialProperties(currentResource, flags, current2);
                      currentResource[internalInstanceKey] = finishedWork;
                      markNodeAsHoistable(currentResource);
                      flags = currentResource;
                      break a;
                    case "link":
                      var maybeNodes = getHydratableHoistableCache(
                        "link",
                        "href",
                        hoistableRoot
                      ).get(flags + (current2.href || ""));
                      if (maybeNodes) {
                        for (var i2 = 0; i2 < maybeNodes.length; i2++)
                          if (currentResource = maybeNodes[i2], currentResource.getAttribute("href") === (null == current2.href || "" === current2.href ? null : current2.href) && currentResource.getAttribute("rel") === (null == current2.rel ? null : current2.rel) && currentResource.getAttribute("title") === (null == current2.title ? null : current2.title) && currentResource.getAttribute("crossorigin") === (null == current2.crossOrigin ? null : current2.crossOrigin)) {
                            maybeNodes.splice(i2, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current2);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    case "meta":
                      if (maybeNodes = getHydratableHoistableCache(
                        "meta",
                        "content",
                        hoistableRoot
                      ).get(flags + (current2.content || ""))) {
                        for (i2 = 0; i2 < maybeNodes.length; i2++)
                          if (currentResource = maybeNodes[i2], currentResource.getAttribute("content") === (null == current2.content ? null : "" + current2.content) && currentResource.getAttribute("name") === (null == current2.name ? null : current2.name) && currentResource.getAttribute("property") === (null == current2.property ? null : current2.property) && currentResource.getAttribute("http-equiv") === (null == current2.httpEquiv ? null : current2.httpEquiv) && currentResource.getAttribute("charset") === (null == current2.charSet ? null : current2.charSet)) {
                            maybeNodes.splice(i2, 1);
                            break b;
                          }
                      }
                      currentResource = hoistableRoot.createElement(flags);
                      setInitialProperties(currentResource, flags, current2);
                      hoistableRoot.head.appendChild(currentResource);
                      break;
                    default:
                      throw Error(formatProdErrorMessage2(468, flags));
                  }
                  currentResource[internalInstanceKey] = finishedWork;
                  markNodeAsHoistable(currentResource);
                  flags = currentResource;
                }
                finishedWork.stateNode = flags;
              } else
                mountHoistable(
                  hoistableRoot,
                  finishedWork.type,
                  finishedWork.stateNode
                );
            else
              finishedWork.stateNode = acquireResource(
                hoistableRoot,
                flags,
                finishedWork.memoizedProps
              );
          else
            currentResource !== flags ? (null === currentResource ? null !== current2.stateNode && (current2 = current2.stateNode, current2.parentNode.removeChild(current2)) : currentResource.count--, null === flags ? mountHoistable(
              hoistableRoot,
              finishedWork.type,
              finishedWork.stateNode
            ) : acquireResource(
              hoistableRoot,
              flags,
              finishedWork.memoizedProps
            )) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(
              finishedWork,
              finishedWork.memoizedProps,
              current2.memoizedProps
            );
        }
        break;
      case 27:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        null !== current2 && flags & 4 && commitHostUpdate(
          finishedWork,
          finishedWork.memoizedProps,
          current2.memoizedProps
        );
        break;
      case 5:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 512 && (offscreenSubtreeWasHidden || null === current2 || safelyDetachRef(current2, current2.return));
        if (finishedWork.flags & 32) {
          hoistableRoot = finishedWork.stateNode;
          try {
            setTextContent(hoistableRoot, "");
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        flags & 4 && null != finishedWork.stateNode && (hoistableRoot = finishedWork.memoizedProps, commitHostUpdate(
          finishedWork,
          hoistableRoot,
          null !== current2 ? current2.memoizedProps : hoistableRoot
        ));
        flags & 1024 && (needsFormReset = true);
        break;
      case 6:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        if (flags & 4) {
          if (null === finishedWork.stateNode)
            throw Error(formatProdErrorMessage2(162));
          flags = finishedWork.memoizedProps;
          current2 = finishedWork.stateNode;
          try {
            current2.nodeValue = flags;
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        }
        break;
      case 3:
        tagCaches = null;
        hoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(root3.containerInfo);
        recursivelyTraverseMutationEffects(root3, finishedWork);
        currentHoistableRoot = hoistableRoot;
        commitReconciliationEffects(finishedWork);
        if (flags & 4 && null !== current2 && current2.memoizedState.isDehydrated)
          try {
            retryIfBlockedOn(root3.containerInfo);
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
        break;
      case 4:
        flags = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(
          finishedWork.stateNode.containerInfo
        );
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        currentHoistableRoot = flags;
        break;
      case 12:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        break;
      case 31:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 13:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current2 && null !== current2.memoizedState) && (globalMostRecentFallbackTime = now());
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 22:
        hoistableRoot = null !== finishedWork.memoizedState;
        var wasHidden = null !== current2 && null !== current2.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || hoistableRoot;
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
        recursivelyTraverseMutationEffects(root3, finishedWork);
        offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
        offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
        commitReconciliationEffects(finishedWork);
        if (flags & 8192)
          a: for (root3 = finishedWork.stateNode, root3._visibility = hoistableRoot ? root3._visibility & -2 : root3._visibility | 1, hoistableRoot && (null === current2 || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || recursivelyTraverseDisappearLayoutEffects(finishedWork)), current2 = null, root3 = finishedWork; ; ) {
            if (5 === root3.tag || 26 === root3.tag) {
              if (null === current2) {
                wasHidden = current2 = root3;
                try {
                  if (currentResource = wasHidden.stateNode, hoistableRoot)
                    maybeNodes = currentResource.style, "function" === typeof maybeNodes.setProperty ? maybeNodes.setProperty("display", "none", "important") : maybeNodes.display = "none";
                  else {
                    i2 = wasHidden.stateNode;
                    var styleProp = wasHidden.memoizedProps.style, display = void 0 !== styleProp && null !== styleProp && styleProp.hasOwnProperty("display") ? styleProp.display : null;
                    i2.style.display = null == display || "boolean" === typeof display ? "" : ("" + display).trim();
                  }
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if (6 === root3.tag) {
              if (null === current2) {
                wasHidden = root3;
                try {
                  wasHidden.stateNode.nodeValue = hoistableRoot ? "" : wasHidden.memoizedProps;
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if (18 === root3.tag) {
              if (null === current2) {
                wasHidden = root3;
                try {
                  var instance = wasHidden.stateNode;
                  hoistableRoot ? hideOrUnhideDehydratedBoundary(instance, true) : hideOrUnhideDehydratedBoundary(wasHidden.stateNode, false);
                } catch (error) {
                  captureCommitPhaseError(wasHidden, wasHidden.return, error);
                }
              }
            } else if ((22 !== root3.tag && 23 !== root3.tag || null === root3.memoizedState || root3 === finishedWork) && null !== root3.child) {
              root3.child.return = root3;
              root3 = root3.child;
              continue;
            }
            if (root3 === finishedWork) break a;
            for (; null === root3.sibling; ) {
              if (null === root3.return || root3.return === finishedWork) break a;
              current2 === root3 && (current2 = null);
              root3 = root3.return;
            }
            current2 === root3 && (current2 = null);
            root3.sibling.return = root3.return;
            root3 = root3.sibling;
          }
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current2 = flags.retryQueue, null !== current2 && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current2))));
        break;
      case 19:
        recursivelyTraverseMutationEffects(root3, finishedWork);
        commitReconciliationEffects(finishedWork);
        flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
        break;
      case 30:
        break;
      case 21:
        break;
      default:
        recursivelyTraverseMutationEffects(root3, finishedWork), commitReconciliationEffects(finishedWork);
    }
  }
  function commitReconciliationEffects(finishedWork) {
    var flags = finishedWork.flags;
    if (flags & 2) {
      try {
        for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
          if (isHostParent(parentFiber)) {
            hostParentFiber = parentFiber;
            break;
          }
          parentFiber = parentFiber.return;
        }
        if (null == hostParentFiber) throw Error(formatProdErrorMessage2(160));
        switch (hostParentFiber.tag) {
          case 27:
            var parent = hostParentFiber.stateNode, before2 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before2, parent);
            break;
          case 5:
            var parent$141 = hostParentFiber.stateNode;
            hostParentFiber.flags & 32 && (setTextContent(parent$141, ""), hostParentFiber.flags &= -33);
            var before$142 = getHostSibling(finishedWork);
            insertOrAppendPlacementNode(finishedWork, before$142, parent$141);
            break;
          case 3:
          case 4:
            var parent$143 = hostParentFiber.stateNode.containerInfo, before$144 = getHostSibling(finishedWork);
            insertOrAppendPlacementNodeIntoContainer(
              finishedWork,
              before$144,
              parent$143
            );
            break;
          default:
            throw Error(formatProdErrorMessage2(161));
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
      finishedWork.flags &= -3;
    }
    flags & 4096 && (finishedWork.flags &= -4097);
  }
  function recursivelyResetForms(parentFiber) {
    if (parentFiber.subtreeFlags & 1024)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var fiber = parentFiber;
        recursivelyResetForms(fiber);
        5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
        parentFiber = parentFiber.sibling;
      }
  }
  function recursivelyTraverseLayoutEffects(root3, parentFiber) {
    if (parentFiber.subtreeFlags & 8772)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitLayoutEffectOnFiber(root3, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
  }
  function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedWork = parentFiber;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(4, finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          releaseSingletonInstance(finishedWork.stateNode);
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseReappearLayoutEffects(finishedRoot$jscomp$0, parentFiber, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var current2 = parentFiber.alternate, finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(4, finishedWork);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current2 = finishedWork;
          finishedRoot = current2.stateNode;
          if ("function" === typeof finishedRoot.componentDidMount)
            try {
              finishedRoot.componentDidMount();
            } catch (error) {
              captureCommitPhaseError(current2, current2.return, error);
            }
          current2 = finishedWork;
          finishedRoot = current2.updateQueue;
          if (null !== finishedRoot) {
            var instance = current2.stateNode;
            try {
              var hiddenCallbacks = finishedRoot.shared.hiddenCallbacks;
              if (null !== hiddenCallbacks)
                for (finishedRoot.shared.hiddenCallbacks = null, finishedRoot = 0; finishedRoot < hiddenCallbacks.length; finishedRoot++)
                  callCallback(hiddenCallbacks[finishedRoot], instance);
            } catch (error) {
              captureCommitPhaseError(current2, current2.return, error);
            }
          }
          includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current2 && flags & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          break;
        case 31:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitOffscreenPassiveMountEffects(current2, finishedWork) {
    var previousCache = null;
    null !== current2 && null !== current2.memoizedState && null !== current2.memoizedState.cachePool && (previousCache = current2.memoizedState.cachePool.pool);
    current2 = null;
    null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current2 = finishedWork.memoizedState.cachePool.pool);
    current2 !== previousCache && (null != current2 && current2.refCount++, null != previousCache && releaseCache(previousCache));
  }
  function commitCachePassiveMountEffect(current2, finishedWork) {
    current2 = null;
    null !== finishedWork.alternate && (current2 = finishedWork.alternate.memoizedState.cache);
    finishedWork = finishedWork.memoizedState.cache;
    finishedWork !== current2 && (finishedWork.refCount++, null != current2 && releaseCache(current2));
  }
  function recursivelyTraversePassiveMountEffects(root3, parentFiber, committedLanes, committedTransitions) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveMountOnFiber(
          root3,
          parentFiber,
          committedLanes,
          committedTransitions
        ), parentFiber = parentFiber.sibling;
  }
  function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions) {
    var flags = finishedWork.flags;
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitHookEffectListMount(9, finishedWork);
        break;
      case 1:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 3:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && (finishedRoot = null, null !== finishedWork.alternate && (finishedRoot = finishedWork.alternate.memoizedState.cache), finishedWork = finishedWork.memoizedState.cache, finishedWork !== finishedRoot && (finishedWork.refCount++, null != finishedRoot && releaseCache(finishedRoot)));
        break;
      case 12:
        if (flags & 2048) {
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
          finishedRoot = finishedWork.stateNode;
          try {
            var _finishedWork$memoize2 = finishedWork.memoizedProps, id2 = _finishedWork$memoize2.id, onPostCommit = _finishedWork$memoize2.onPostCommit;
            "function" === typeof onPostCommit && onPostCommit(
              id2,
              null === finishedWork.alternate ? "mount" : "update",
              finishedRoot.passiveEffectDuration,
              -0
            );
          } catch (error) {
            captureCommitPhaseError(finishedWork, finishedWork.return, error);
          }
        } else
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions
          );
        break;
      case 31:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 13:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        break;
      case 23:
        break;
      case 22:
        _finishedWork$memoize2 = finishedWork.stateNode;
        id2 = finishedWork.alternate;
        null !== finishedWork.memoizedState ? _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork) : _finishedWork$memoize2._visibility & 2 ? recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        ) : (_finishedWork$memoize2._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions,
          0 !== (finishedWork.subtreeFlags & 10256) || false
        ));
        flags & 2048 && commitOffscreenPassiveMountEffects(id2, finishedWork);
        break;
      case 24:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
        flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
        break;
      default:
        recursivelyTraversePassiveMountEffects(
          finishedRoot,
          finishedWork,
          committedLanes,
          committedTransitions
        );
    }
  }
  function recursivelyTraverseReconnectPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, includeWorkInProgressEffects) {
    includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || false);
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          commitHookEffectListMount(8, finishedWork);
          break;
        case 23:
          break;
        case 22:
          var instance = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? instance._visibility & 2 ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork
          ) : (instance._visibility |= 2, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          ));
          includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects
          );
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber) {
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var finishedRoot = finishedRoot$jscomp$0, finishedWork = parentFiber, flags = finishedWork.flags;
        switch (finishedWork.tag) {
          case 22:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitOffscreenPassiveMountEffects(
              finishedWork.alternate,
              finishedWork
            );
            break;
          case 24:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
            flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
            break;
          default:
            recursivelyTraverseAtomicPassiveEffects(finishedRoot, finishedWork);
        }
        parentFiber = parentFiber.sibling;
      }
  }
  var suspenseyCommitFlag = 8192;
  function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
    if (parentFiber.subtreeFlags & suspenseyCommitFlag)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        accumulateSuspenseyCommitOnFiber(
          parentFiber,
          committedLanes,
          suspendedState
        ), parentFiber = parentFiber.sibling;
  }
  function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
    switch (fiber.tag) {
      case 26:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
          suspendedState,
          currentHoistableRoot,
          fiber.memoizedState,
          fiber.memoizedProps
        );
        break;
      case 5:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        break;
      case 3:
      case 4:
        var previousHoistableRoot = currentHoistableRoot;
        currentHoistableRoot = getHoistableRoot(fiber.stateNode.containerInfo);
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
        currentHoistableRoot = previousHoistableRoot;
        break;
      case 22:
        null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        ), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        ));
        break;
      default:
        recursivelyAccumulateSuspenseyCommit(
          fiber,
          committedLanes,
          suspendedState
        );
    }
  }
  function detachAlternateSiblings(parentFiber) {
    var previousFiber = parentFiber.alternate;
    if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
      previousFiber.child = null;
      do
        previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
      while (null !== parentFiber);
    }
  }
  function recursivelyTraversePassiveUnmountEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var childToDelete = deletions[i2];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    if (parentFiber.subtreeFlags & 10256)
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
  }
  function commitPassiveUnmountOnFiber(finishedWork) {
    switch (finishedWork.tag) {
      case 0:
      case 11:
      case 15:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        finishedWork.flags & 2048 && commitHookEffectListUnmount(9, finishedWork, finishedWork.return);
        break;
      case 3:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 12:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      case 22:
        var instance = finishedWork.stateNode;
        null !== finishedWork.memoizedState && instance._visibility & 2 && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (instance._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(finishedWork)) : recursivelyTraversePassiveUnmountEffects(finishedWork);
        break;
      default:
        recursivelyTraversePassiveUnmountEffects(finishedWork);
    }
  }
  function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
    var deletions = parentFiber.deletions;
    if (0 !== (parentFiber.flags & 16)) {
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var childToDelete = deletions[i2];
          nextEffect = childToDelete;
          commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
            childToDelete,
            parentFiber
          );
        }
      detachAlternateSiblings(parentFiber);
    }
    for (parentFiber = parentFiber.child; null !== parentFiber; ) {
      deletions = parentFiber;
      switch (deletions.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, deletions, deletions.return);
          recursivelyTraverseDisconnectPassiveEffects(deletions);
          break;
        case 22:
          i2 = deletions.stateNode;
          i2._visibility & 2 && (i2._visibility &= -3, recursivelyTraverseDisconnectPassiveEffects(deletions));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(deletions);
      }
      parentFiber = parentFiber.sibling;
    }
  }
  function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor) {
    for (; null !== nextEffect; ) {
      var fiber = nextEffect;
      switch (fiber.tag) {
        case 0:
        case 11:
        case 15:
          commitHookEffectListUnmount(8, fiber, nearestMountedAncestor);
          break;
        case 23:
        case 22:
          if (null !== fiber.memoizedState && null !== fiber.memoizedState.cachePool) {
            var cache = fiber.memoizedState.cachePool.pool;
            null != cache && cache.refCount++;
          }
          break;
        case 24:
          releaseCache(fiber.memoizedState.cache);
      }
      cache = fiber.child;
      if (null !== cache) cache.return = fiber, nextEffect = cache;
      else
        a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
          cache = nextEffect;
          var sibling = cache.sibling, returnFiber = cache.return;
          detachFiberAfterEffects(cache);
          if (cache === fiber) {
            nextEffect = null;
            break a;
          }
          if (null !== sibling) {
            sibling.return = returnFiber;
            nextEffect = sibling;
            break a;
          }
          nextEffect = returnFiber;
        }
    }
  }
  var DefaultAsyncDispatcher = {
    getCacheForType: function(resourceType) {
      var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
      void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
      return cacheForType;
    },
    cacheSignal: function() {
      return readContext(CacheContext).controller.signal;
    }
  }, PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, executionContext = 0, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = 0, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, workInProgressRootRenderTargetTime = Infinity, workInProgressTransitions = null, legacyErrorBoundariesThatAlreadyFailed = null, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, nestedUpdateCount = 0, rootWithNestedUpdates = null;
  function requestUpdateLane() {
    return 0 !== (executionContext & 2) && 0 !== workInProgressRootRenderLanes ? workInProgressRootRenderLanes & -workInProgressRootRenderLanes : null !== ReactSharedInternals.T ? requestTransitionLane() : resolveUpdatePriority();
  }
  function requestDeferredLane() {
    if (0 === workInProgressDeferredLane)
      if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
        var lane = nextTransitionDeferredLane;
        nextTransitionDeferredLane <<= 1;
        0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
        workInProgressDeferredLane = lane;
      } else workInProgressDeferredLane = 536870912;
    lane = suspenseHandlerStackCursor.current;
    null !== lane && (lane.flags |= 32);
    return workInProgressDeferredLane;
  }
  function scheduleUpdateOnFiber(root3, fiber, lane) {
    if (root3 === workInProgressRoot && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root3.cancelPendingCommit)
      prepareFreshStack(root3, 0), markRootSuspended(
        root3,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    markRootUpdated$1(root3, lane);
    if (0 === (executionContext & 2) || root3 !== workInProgressRoot)
      root3 === workInProgressRoot && (0 === (executionContext & 2) && (workInProgressRootInterleavedUpdatedLanes |= lane), 4 === workInProgressRootExitStatus && markRootSuspended(
        root3,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      )), ensureRootIsScheduled(root3);
  }
  function performWorkOnRoot(root$jscomp$0, lanes, forceSync) {
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(327));
    var shouldTimeSlice = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root$jscomp$0.expiredLanes) || checkIfRootIsPrerendering(root$jscomp$0, lanes), exitStatus = shouldTimeSlice ? renderRootConcurrent(root$jscomp$0, lanes) : renderRootSync(root$jscomp$0, lanes, true), renderWasConcurrent = shouldTimeSlice;
    do {
      if (0 === exitStatus) {
        workInProgressRootIsPrerendering && !shouldTimeSlice && markRootSuspended(root$jscomp$0, lanes, 0, false);
        break;
      } else {
        forceSync = root$jscomp$0.current.alternate;
        if (renderWasConcurrent && !isRenderConsistentWithExternalStores(forceSync)) {
          exitStatus = renderRootSync(root$jscomp$0, lanes, false);
          renderWasConcurrent = false;
          continue;
        }
        if (2 === exitStatus) {
          renderWasConcurrent = lanes;
          if (root$jscomp$0.errorRecoveryDisabledLanes & renderWasConcurrent)
            var JSCompiler_inline_result = 0;
          else
            JSCompiler_inline_result = root$jscomp$0.pendingLanes & -536870913, JSCompiler_inline_result = 0 !== JSCompiler_inline_result ? JSCompiler_inline_result : JSCompiler_inline_result & 536870912 ? 536870912 : 0;
          if (0 !== JSCompiler_inline_result) {
            lanes = JSCompiler_inline_result;
            a: {
              var root3 = root$jscomp$0;
              exitStatus = workInProgressRootConcurrentErrors;
              var wasRootDehydrated = root3.current.memoizedState.isDehydrated;
              wasRootDehydrated && (prepareFreshStack(root3, JSCompiler_inline_result).flags |= 256);
              JSCompiler_inline_result = renderRootSync(
                root3,
                JSCompiler_inline_result,
                false
              );
              if (2 !== JSCompiler_inline_result) {
                if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                  root3.errorRecoveryDisabledLanes |= renderWasConcurrent;
                  workInProgressRootInterleavedUpdatedLanes |= renderWasConcurrent;
                  exitStatus = 4;
                  break a;
                }
                renderWasConcurrent = workInProgressRootRecoverableErrors;
                workInProgressRootRecoverableErrors = exitStatus;
                null !== renderWasConcurrent && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = renderWasConcurrent : workInProgressRootRecoverableErrors.push.apply(
                  workInProgressRootRecoverableErrors,
                  renderWasConcurrent
                ));
              }
              exitStatus = JSCompiler_inline_result;
            }
            renderWasConcurrent = false;
            if (2 !== exitStatus) continue;
          }
        }
        if (1 === exitStatus) {
          prepareFreshStack(root$jscomp$0, 0);
          markRootSuspended(root$jscomp$0, lanes, 0, true);
          break;
        }
        a: {
          shouldTimeSlice = root$jscomp$0;
          renderWasConcurrent = exitStatus;
          switch (renderWasConcurrent) {
            case 0:
            case 1:
              throw Error(formatProdErrorMessage2(345));
            case 4:
              if ((lanes & 4194048) !== lanes) break;
            case 6:
              markRootSuspended(
                shouldTimeSlice,
                lanes,
                workInProgressDeferredLane,
                !workInProgressRootDidSkipSuspendedSiblings
              );
              break a;
            case 2:
              workInProgressRootRecoverableErrors = null;
              break;
            case 3:
            case 5:
              break;
            default:
              throw Error(formatProdErrorMessage2(329));
          }
          if ((lanes & 62914560) === lanes && (exitStatus = globalMostRecentFallbackTime + 300 - now(), 10 < exitStatus)) {
            markRootSuspended(
              shouldTimeSlice,
              lanes,
              workInProgressDeferredLane,
              !workInProgressRootDidSkipSuspendedSiblings
            );
            if (0 !== getNextLanes(shouldTimeSlice, 0, true)) break a;
            pendingEffectsLanes = lanes;
            shouldTimeSlice.timeoutHandle = scheduleTimeout(
              commitRootWhenReady.bind(
                null,
                shouldTimeSlice,
                forceSync,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                renderWasConcurrent,
                "Throttled",
                -0,
                0
              ),
              exitStatus
            );
            break a;
          }
          commitRootWhenReady(
            shouldTimeSlice,
            forceSync,
            workInProgressRootRecoverableErrors,
            workInProgressTransitions,
            workInProgressRootDidIncludeRecursiveRenderUpdate,
            lanes,
            workInProgressDeferredLane,
            workInProgressRootInterleavedUpdatedLanes,
            workInProgressSuspendedRetryLanes,
            workInProgressRootDidSkipSuspendedSiblings,
            renderWasConcurrent,
            null,
            -0,
            0
          );
        }
      }
      break;
    } while (1);
    ensureRootIsScheduled(root$jscomp$0);
  }
  function commitRootWhenReady(root3, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
    root3.timeoutHandle = -1;
    suspendedCommitReason = finishedWork.subtreeFlags;
    if (suspendedCommitReason & 8192 || 16785408 === (suspendedCommitReason & 16785408)) {
      suspendedCommitReason = {
        stylesheets: null,
        count: 0,
        imgCount: 0,
        imgBytes: 0,
        suspenseyImages: [],
        waitingForImages: true,
        waitingForViewTransition: false,
        unsuspend: noop$12
      };
      accumulateSuspenseyCommitOnFiber(
        finishedWork,
        lanes,
        suspendedCommitReason
      );
      var timeoutOffset = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now() : 0;
      timeoutOffset = waitForCommitToBeReady(
        suspendedCommitReason,
        timeoutOffset
      );
      if (null !== timeoutOffset) {
        pendingEffectsLanes = lanes;
        root3.cancelPendingCommit = timeoutOffset(
          commitRoot.bind(
            null,
            root3,
            finishedWork,
            lanes,
            recoverableErrors,
            transitions,
            didIncludeRenderPhaseUpdate,
            spawnedLane,
            updatedLanes,
            suspendedRetryLanes,
            exitStatus,
            suspendedCommitReason,
            null,
            completedRenderStartTime,
            completedRenderEndTime
          )
        );
        markRootSuspended(root3, lanes, spawnedLane, !didSkipSuspendedSiblings);
        return;
      }
    }
    commitRoot(
      root3,
      finishedWork,
      lanes,
      recoverableErrors,
      transitions,
      didIncludeRenderPhaseUpdate,
      spawnedLane,
      updatedLanes,
      suspendedRetryLanes
    );
  }
  function isRenderConsistentWithExternalStores(finishedWork) {
    for (var node = finishedWork; ; ) {
      var tag2 = node.tag;
      if ((0 === tag2 || 11 === tag2 || 15 === tag2) && node.flags & 16384 && (tag2 = node.updateQueue, null !== tag2 && (tag2 = tag2.stores, null !== tag2)))
        for (var i2 = 0; i2 < tag2.length; i2++) {
          var check = tag2[i2], getSnapshot = check.getSnapshot;
          check = check.value;
          try {
            if (!objectIs(getSnapshot(), check)) return false;
          } catch (error) {
            return false;
          }
        }
      tag2 = node.child;
      if (node.subtreeFlags & 16384 && null !== tag2)
        tag2.return = node, node = tag2;
      else {
        if (node === finishedWork) break;
        for (; null === node.sibling; ) {
          if (null === node.return || node.return === finishedWork) return true;
          node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
      }
    }
    return true;
  }
  function markRootSuspended(root3, suspendedLanes, spawnedLane, didAttemptEntireTree) {
    suspendedLanes &= ~workInProgressRootPingedLanes;
    suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
    root3.suspendedLanes |= suspendedLanes;
    root3.pingedLanes &= ~suspendedLanes;
    didAttemptEntireTree && (root3.warmLanes |= suspendedLanes);
    didAttemptEntireTree = root3.expirationTimes;
    for (var lanes = suspendedLanes; 0 < lanes; ) {
      var index$6 = 31 - clz32(lanes), lane = 1 << index$6;
      didAttemptEntireTree[index$6] = -1;
      lanes &= ~lane;
    }
    0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, suspendedLanes);
  }
  function flushSyncWork$1() {
    return 0 === (executionContext & 6) ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
  }
  function resetWorkInProgressStack() {
    if (null !== workInProgress) {
      if (0 === workInProgressSuspendedReason)
        var interruptedWork = workInProgress.return;
      else
        interruptedWork = workInProgress, lastContextDependency = currentlyRenderingFiber$1 = null, resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
      for (; null !== interruptedWork; )
        unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
      workInProgress = null;
    }
  }
  function prepareFreshStack(root3, lanes) {
    var timeoutHandle = root3.timeoutHandle;
    -1 !== timeoutHandle && (root3.timeoutHandle = -1, cancelTimeout(timeoutHandle));
    timeoutHandle = root3.cancelPendingCommit;
    null !== timeoutHandle && (root3.cancelPendingCommit = null, timeoutHandle());
    pendingEffectsLanes = 0;
    resetWorkInProgressStack();
    workInProgressRoot = root3;
    workInProgress = timeoutHandle = createWorkInProgress(root3.current, null);
    workInProgressRootRenderLanes = lanes;
    workInProgressSuspendedReason = 0;
    workInProgressThrownValue = null;
    workInProgressRootDidSkipSuspendedSiblings = false;
    workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root3, lanes);
    workInProgressRootDidAttachPingListener = false;
    workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = workInProgressRootExitStatus = 0;
    workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
    workInProgressRootDidIncludeRecursiveRenderUpdate = false;
    0 !== (lanes & 8) && (lanes |= lanes & 32);
    var allEntangledLanes = root3.entangledLanes;
    if (0 !== allEntangledLanes)
      for (root3 = root3.entanglements, allEntangledLanes &= lanes; 0 < allEntangledLanes; ) {
        var index$4 = 31 - clz32(allEntangledLanes), lane = 1 << index$4;
        lanes |= root3[index$4];
        allEntangledLanes &= ~lane;
      }
    entangledRenderLanes = lanes;
    finishQueueingConcurrentUpdates();
    return timeoutHandle;
  }
  function handleThrow(root3, thrownValue) {
    currentlyRenderingFiber = null;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 3) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = 4) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? 8 : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? 6 : 1;
    workInProgressThrownValue = thrownValue;
    null === workInProgress && (workInProgressRootExitStatus = 1, logUncaughtError(
      root3,
      createCapturedValueAtFiber(thrownValue, root3.current)
    ));
  }
  function shouldRemainOnPreviousScreen() {
    var handler = suspenseHandlerStackCursor.current;
    return null === handler ? true : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? true : false : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : false;
  }
  function pushDispatcher() {
    var prevDispatcher = ReactSharedInternals.H;
    ReactSharedInternals.H = ContextOnlyDispatcher;
    return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
  }
  function pushAsyncDispatcher() {
    var prevAsyncDispatcher = ReactSharedInternals.A;
    ReactSharedInternals.A = DefaultAsyncDispatcher;
    return prevAsyncDispatcher;
  }
  function renderDidSuspendDelayIfPossible() {
    workInProgressRootExitStatus = 4;
    workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
    0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
      workInProgressRoot,
      workInProgressRootRenderLanes,
      workInProgressDeferredLane,
      false
    );
  }
  function renderRootSync(root3, lanes, shouldYieldForPrerendering) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes)
      workInProgressTransitions = null, prepareFreshStack(root3, lanes);
    lanes = false;
    var exitStatus = workInProgressRootExitStatus;
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
          switch (workInProgressSuspendedReason) {
            case 8:
              resetWorkInProgressStack();
              exitStatus = 6;
              break a;
            case 3:
            case 2:
            case 9:
            case 6:
              null === suspenseHandlerStackCursor.current && (lanes = true);
              var reason = workInProgressSuspendedReason;
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
              if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                exitStatus = 0;
                break a;
              }
              break;
            default:
              reason = workInProgressSuspendedReason, workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
          }
        }
        workLoopSync();
        exitStatus = workInProgressRootExitStatus;
        break;
      } catch (thrownValue$165) {
        handleThrow(root3, thrownValue$165);
      }
    while (1);
    lanes && root3.shellSuspendCounter++;
    lastContextDependency = currentlyRenderingFiber$1 = null;
    executionContext = prevExecutionContext;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
    return exitStatus;
  }
  function workLoopSync() {
    for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
  }
  function renderRootConcurrent(root3, lanes) {
    var prevExecutionContext = executionContext;
    executionContext |= 2;
    var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
    workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes ? (workInProgressTransitions = null, workInProgressRootRenderTargetTime = now() + 500, prepareFreshStack(root3, lanes)) : workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
      root3,
      lanes
    );
    a: do
      try {
        if (0 !== workInProgressSuspendedReason && null !== workInProgress) {
          lanes = workInProgress;
          var thrownValue = workInProgressThrownValue;
          b: switch (workInProgressSuspendedReason) {
            case 1:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 1);
              break;
            case 2:
            case 9:
              if (isThenableResolved(thrownValue)) {
                workInProgressSuspendedReason = 0;
                workInProgressThrownValue = null;
                replaySuspendedUnitOfWork(lanes);
                break;
              }
              lanes = function() {
                2 !== workInProgressSuspendedReason && 9 !== workInProgressSuspendedReason || workInProgressRoot !== root3 || (workInProgressSuspendedReason = 7);
                ensureRootIsScheduled(root3);
              };
              thrownValue.then(lanes, lanes);
              break a;
            case 3:
              workInProgressSuspendedReason = 7;
              break a;
            case 4:
              workInProgressSuspendedReason = 5;
              break a;
            case 7:
              isThenableResolved(thrownValue) ? (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = 0, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, lanes, thrownValue, 7));
              break;
            case 5:
              var resource = null;
              switch (workInProgress.tag) {
                case 26:
                  resource = workInProgress.memoizedState;
                case 5:
                case 27:
                  var hostFiber = workInProgress;
                  if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                    workInProgressSuspendedReason = 0;
                    workInProgressThrownValue = null;
                    var sibling = hostFiber.sibling;
                    if (null !== sibling) workInProgress = sibling;
                    else {
                      var returnFiber = hostFiber.return;
                      null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                    }
                    break b;
                  }
              }
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 5);
              break;
            case 6:
              workInProgressSuspendedReason = 0;
              workInProgressThrownValue = null;
              throwAndUnwindWorkLoop(root3, lanes, thrownValue, 6);
              break;
            case 8:
              resetWorkInProgressStack();
              workInProgressRootExitStatus = 6;
              break a;
            default:
              throw Error(formatProdErrorMessage2(462));
          }
        }
        workLoopConcurrentByScheduler();
        break;
      } catch (thrownValue$167) {
        handleThrow(root3, thrownValue$167);
      }
    while (1);
    lastContextDependency = currentlyRenderingFiber$1 = null;
    ReactSharedInternals.H = prevDispatcher;
    ReactSharedInternals.A = prevAsyncDispatcher;
    executionContext = prevExecutionContext;
    if (null !== workInProgress) return 0;
    workInProgressRoot = null;
    workInProgressRootRenderLanes = 0;
    finishQueueingConcurrentUpdates();
    return workInProgressRootExitStatus;
  }
  function workLoopConcurrentByScheduler() {
    for (; null !== workInProgress && !shouldYield(); )
      performUnitOfWork(workInProgress);
  }
  function performUnitOfWork(unitOfWork) {
    var next = beginWork(unitOfWork.alternate, unitOfWork, entangledRenderLanes);
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function replaySuspendedUnitOfWork(unitOfWork) {
    var next = unitOfWork;
    var current2 = next.alternate;
    switch (next.tag) {
      case 15:
      case 0:
        next = replayFunctionComponent(
          current2,
          next,
          next.pendingProps,
          next.type,
          void 0,
          workInProgressRootRenderLanes
        );
        break;
      case 11:
        next = replayFunctionComponent(
          current2,
          next,
          next.pendingProps,
          next.type.render,
          next.ref,
          workInProgressRootRenderLanes
        );
        break;
      case 5:
        resetHooksOnUnwind(next);
      default:
        unwindInterruptedWork(current2, next), next = workInProgress = resetWorkInProgress(next, entangledRenderLanes), next = beginWork(current2, next, entangledRenderLanes);
    }
    unitOfWork.memoizedProps = unitOfWork.pendingProps;
    null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
  }
  function throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, suspendedReason) {
    lastContextDependency = currentlyRenderingFiber$1 = null;
    resetHooksOnUnwind(unitOfWork);
    thenableState$1 = null;
    thenableIndexCounter$1 = 0;
    var returnFiber = unitOfWork.return;
    try {
      if (throwException(
        root3,
        returnFiber,
        unitOfWork,
        thrownValue,
        workInProgressRootRenderLanes
      )) {
        workInProgressRootExitStatus = 1;
        logUncaughtError(
          root3,
          createCapturedValueAtFiber(thrownValue, root3.current)
        );
        workInProgress = null;
        return;
      }
    } catch (error) {
      if (null !== returnFiber) throw workInProgress = returnFiber, error;
      workInProgressRootExitStatus = 1;
      logUncaughtError(
        root3,
        createCapturedValueAtFiber(thrownValue, root3.current)
      );
      workInProgress = null;
      return;
    }
    if (unitOfWork.flags & 32768) {
      if (isHydrating || 1 === suspendedReason) root3 = true;
      else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
        root3 = false;
      else if (workInProgressRootDidSkipSuspendedSiblings = root3 = true, 2 === suspendedReason || 9 === suspendedReason || 3 === suspendedReason || 6 === suspendedReason)
        suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
      unwindUnitOfWork(unitOfWork, root3);
    } else completeUnitOfWork(unitOfWork);
  }
  function completeUnitOfWork(unitOfWork) {
    var completedWork = unitOfWork;
    do {
      if (0 !== (completedWork.flags & 32768)) {
        unwindUnitOfWork(
          completedWork,
          workInProgressRootDidSkipSuspendedSiblings
        );
        return;
      }
      unitOfWork = completedWork.return;
      var next = completeWork(
        completedWork.alternate,
        completedWork,
        entangledRenderLanes
      );
      if (null !== next) {
        workInProgress = next;
        return;
      }
      completedWork = completedWork.sibling;
      if (null !== completedWork) {
        workInProgress = completedWork;
        return;
      }
      workInProgress = completedWork = unitOfWork;
    } while (null !== completedWork);
    0 === workInProgressRootExitStatus && (workInProgressRootExitStatus = 5);
  }
  function unwindUnitOfWork(unitOfWork, skipSiblings) {
    do {
      var next = unwindWork(unitOfWork.alternate, unitOfWork);
      if (null !== next) {
        next.flags &= 32767;
        workInProgress = next;
        return;
      }
      next = unitOfWork.return;
      null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
      if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
        workInProgress = unitOfWork;
        return;
      }
      workInProgress = unitOfWork = next;
    } while (null !== unitOfWork);
    workInProgressRootExitStatus = 6;
    workInProgress = null;
  }
  function commitRoot(root3, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes) {
    root3.cancelPendingCommit = null;
    do
      flushPendingEffects();
    while (0 !== pendingEffectsStatus);
    if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(327));
    if (null !== finishedWork) {
      if (finishedWork === root3.current) throw Error(formatProdErrorMessage2(177));
      didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
      didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
      markRootFinished(
        root3,
        lanes,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes
      );
      root3 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
      pendingFinishedWork = finishedWork;
      pendingEffectsRoot = root3;
      pendingEffectsLanes = lanes;
      pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
      pendingPassiveTransitions = transitions;
      pendingRecoverableErrors = recoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root3.callbackNode = null, root3.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
        flushPassiveEffects();
        return null;
      })) : (root3.callbackNode = null, root3.callbackPriority = 0);
      recoverableErrors = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
        recoverableErrors = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        transitions = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        spawnedLane = executionContext;
        executionContext |= 4;
        try {
          commitBeforeMutationEffects(root3, finishedWork, lanes);
        } finally {
          executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
        }
      }
      pendingEffectsStatus = 1;
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
    }
  }
  function flushMutationEffects() {
    if (1 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
      if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
        rootMutationHasEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitMutationEffectsOnFiber(finishedWork, root3);
          var priorSelectionInformation = selectionInformation, curFocusedElem = getActiveElementDeep(root3.containerInfo), priorFocusedElem = priorSelectionInformation.focusedElem, priorSelectionRange = priorSelectionInformation.selectionRange;
          if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
            priorFocusedElem.ownerDocument.documentElement,
            priorFocusedElem
          )) {
            if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
              var start = priorSelectionRange.start, end = priorSelectionRange.end;
              void 0 === end && (end = start);
              if ("selectionStart" in priorFocusedElem)
                priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(
                  end,
                  priorFocusedElem.value.length
                );
              else {
                var doc2 = priorFocusedElem.ownerDocument || document, win = doc2 && doc2.defaultView || window;
                if (win.getSelection) {
                  var selection2 = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(priorSelectionRange.start, length), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                  !selection2.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                  var startMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    start$jscomp$0
                  ), endMarker = getNodeForCharacterOffset(
                    priorFocusedElem,
                    end$jscomp$0
                  );
                  if (startMarker && endMarker && (1 !== selection2.rangeCount || selection2.anchorNode !== startMarker.node || selection2.anchorOffset !== startMarker.offset || selection2.focusNode !== endMarker.node || selection2.focusOffset !== endMarker.offset)) {
                    var range2 = doc2.createRange();
                    range2.setStart(startMarker.node, startMarker.offset);
                    selection2.removeAllRanges();
                    start$jscomp$0 > end$jscomp$0 ? (selection2.addRange(range2), selection2.extend(endMarker.node, endMarker.offset)) : (range2.setEnd(endMarker.node, endMarker.offset), selection2.addRange(range2));
                  }
                }
              }
            }
            doc2 = [];
            for (selection2 = priorFocusedElem; selection2 = selection2.parentNode; )
              1 === selection2.nodeType && doc2.push({
                element: selection2,
                left: selection2.scrollLeft,
                top: selection2.scrollTop
              });
            "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
            for (priorFocusedElem = 0; priorFocusedElem < doc2.length; priorFocusedElem++) {
              var info = doc2[priorFocusedElem];
              info.element.scrollLeft = info.left;
              info.element.scrollTop = info.top;
            }
          }
          _enabled = !!eventsEnabled;
          selectionInformation = eventsEnabled = null;
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
        }
      }
      root3.current = finishedWork;
      pendingEffectsStatus = 2;
    }
  }
  function flushLayoutEffects() {
    if (2 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, rootHasLayoutEffect = 0 !== (finishedWork.flags & 8772);
      if (0 !== (finishedWork.subtreeFlags & 8772) || rootHasLayoutEffect) {
        rootHasLayoutEffect = ReactSharedInternals.T;
        ReactSharedInternals.T = null;
        var previousPriority = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        var prevExecutionContext = executionContext;
        executionContext |= 4;
        try {
          commitLayoutEffectOnFiber(root3, finishedWork.alternate, finishedWork);
        } finally {
          executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
        }
      }
      pendingEffectsStatus = 3;
    }
  }
  function flushSpawnedWork() {
    if (4 === pendingEffectsStatus || 3 === pendingEffectsStatus) {
      pendingEffectsStatus = 0;
      requestPaint();
      var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, recoverableErrors = pendingRecoverableErrors;
      0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? pendingEffectsStatus = 5 : (pendingEffectsStatus = 0, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(root3, root3.pendingLanes));
      var remainingLanes = root3.pendingLanes;
      0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
      lanesToEventPriority(lanes);
      finishedWork = finishedWork.stateNode;
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
        try {
          injectedHook.onCommitFiberRoot(
            rendererID,
            finishedWork,
            void 0,
            128 === (finishedWork.current.flags & 128)
          );
        } catch (err) {
        }
      if (null !== recoverableErrors) {
        finishedWork = ReactSharedInternals.T;
        remainingLanes = ReactDOMSharedInternals.p;
        ReactDOMSharedInternals.p = 2;
        ReactSharedInternals.T = null;
        try {
          for (var onRecoverableError = root3.onRecoverableError, i2 = 0; i2 < recoverableErrors.length; i2++) {
            var recoverableError = recoverableErrors[i2];
            onRecoverableError(recoverableError.value, {
              componentStack: recoverableError.stack
            });
          }
        } finally {
          ReactSharedInternals.T = finishedWork, ReactDOMSharedInternals.p = remainingLanes;
        }
      }
      0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
      ensureRootIsScheduled(root3);
      remainingLanes = root3.pendingLanes;
      0 !== (lanes & 261930) && 0 !== (remainingLanes & 42) ? root3 === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = root3) : nestedUpdateCount = 0;
      flushSyncWorkAcrossRoots_impl(0);
    }
  }
  function releaseRootPooledCache(root3, remainingLanes) {
    0 === (root3.pooledCacheLanes &= remainingLanes) && (remainingLanes = root3.pooledCache, null != remainingLanes && (root3.pooledCache = null, releaseCache(remainingLanes)));
  }
  function flushPendingEffects() {
    flushMutationEffects();
    flushLayoutEffects();
    flushSpawnedWork();
    return flushPassiveEffects();
  }
  function flushPassiveEffects() {
    if (5 !== pendingEffectsStatus) return false;
    var root3 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
    pendingEffectsRemainingLanes = 0;
    var renderPriority = lanesToEventPriority(pendingEffectsLanes), prevTransition = ReactSharedInternals.T, previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 32 > renderPriority ? 32 : renderPriority;
      ReactSharedInternals.T = null;
      renderPriority = pendingPassiveTransitions;
      pendingPassiveTransitions = null;
      var root$jscomp$0 = pendingEffectsRoot, lanes = pendingEffectsLanes;
      pendingEffectsStatus = 0;
      pendingFinishedWork = pendingEffectsRoot = null;
      pendingEffectsLanes = 0;
      if (0 !== (executionContext & 6)) throw Error(formatProdErrorMessage2(331));
      var prevExecutionContext = executionContext;
      executionContext |= 4;
      commitPassiveUnmountOnFiber(root$jscomp$0.current);
      commitPassiveMountOnFiber(
        root$jscomp$0,
        root$jscomp$0.current,
        lanes,
        renderPriority
      );
      executionContext = prevExecutionContext;
      flushSyncWorkAcrossRoots_impl(0, false);
      if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
        try {
          injectedHook.onPostCommitFiberRoot(rendererID, root$jscomp$0);
        } catch (err) {
        }
      return true;
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition, releaseRootPooledCache(root3, remainingLanes);
    }
  }
  function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
    sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
    sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
    rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
    null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
  }
  function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
    if (3 === sourceFiber.tag)
      captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
    else
      for (; null !== nearestMountedAncestor; ) {
        if (3 === nearestMountedAncestor.tag) {
          captureCommitPhaseErrorOnRoot(
            nearestMountedAncestor,
            sourceFiber,
            error
          );
          break;
        } else if (1 === nearestMountedAncestor.tag) {
          var instance = nearestMountedAncestor.stateNode;
          if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
            sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
            error = createClassErrorUpdate(2);
            instance = enqueueUpdate(nearestMountedAncestor, error, 2);
            null !== instance && (initializeClassErrorUpdate(
              error,
              instance,
              nearestMountedAncestor,
              sourceFiber
            ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
            break;
          }
        }
        nearestMountedAncestor = nearestMountedAncestor.return;
      }
  }
  function attachPingListener(root3, wakeable, lanes) {
    var pingCache = root3.pingCache;
    if (null === pingCache) {
      pingCache = root3.pingCache = new PossiblyWeakMap();
      var threadIDs = /* @__PURE__ */ new Set();
      pingCache.set(wakeable, threadIDs);
    } else
      threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
    threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), root3 = pingSuspendedRoot.bind(null, root3, wakeable, lanes), wakeable.then(root3, root3));
  }
  function pingSuspendedRoot(root3, wakeable, pingedLanes) {
    var pingCache = root3.pingCache;
    null !== pingCache && pingCache.delete(wakeable);
    root3.pingedLanes |= root3.suspendedLanes & pingedLanes;
    root3.warmLanes &= ~pingedLanes;
    workInProgressRoot === root3 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (4 === workInProgressRootExitStatus || 3 === workInProgressRootExitStatus && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && 300 > now() - globalMostRecentFallbackTime ? 0 === (executionContext & 2) && prepareFreshStack(root3, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
    ensureRootIsScheduled(root3);
  }
  function retryTimedOutBoundary(boundaryFiber, retryLane) {
    0 === retryLane && (retryLane = claimNextRetryLane());
    boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
    null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
  }
  function retryDehydratedSuspenseBoundary(boundaryFiber) {
    var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
    null !== suspenseState && (retryLane = suspenseState.retryLane);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function resolveRetryWakeable(boundaryFiber, wakeable) {
    var retryLane = 0;
    switch (boundaryFiber.tag) {
      case 31:
      case 13:
        var retryCache = boundaryFiber.stateNode;
        var suspenseState = boundaryFiber.memoizedState;
        null !== suspenseState && (retryLane = suspenseState.retryLane);
        break;
      case 19:
        retryCache = boundaryFiber.stateNode;
        break;
      case 22:
        retryCache = boundaryFiber.stateNode._retryCache;
        break;
      default:
        throw Error(formatProdErrorMessage2(314));
    }
    null !== retryCache && retryCache.delete(wakeable);
    retryTimedOutBoundary(boundaryFiber, retryLane);
  }
  function scheduleCallback$1(priorityLevel, callback) {
    return scheduleCallback$3(priorityLevel, callback);
  }
  var firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0;
  function ensureRootIsScheduled(root3) {
    root3 !== lastScheduledRoot && null === root3.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root3 : lastScheduledRoot = lastScheduledRoot.next = root3);
    mightHavePendingSyncWork = true;
    didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
  }
  function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
    if (!isFlushingWork && mightHavePendingSyncWork) {
      isFlushingWork = true;
      do {
        var didPerformSomeWork = false;
        for (var root$170 = firstScheduledRoot; null !== root$170; ) {
          if (0 !== syncTransitionLanes) {
            var pendingLanes = root$170.pendingLanes;
            if (0 === pendingLanes) var JSCompiler_inline_result = 0;
            else {
              var suspendedLanes = root$170.suspendedLanes, pingedLanes = root$170.pingedLanes;
              JSCompiler_inline_result = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
              JSCompiler_inline_result &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
              JSCompiler_inline_result = JSCompiler_inline_result & 201326741 ? JSCompiler_inline_result & 201326741 | 1 : JSCompiler_inline_result ? JSCompiler_inline_result | 2 : 0;
            }
            0 !== JSCompiler_inline_result && (didPerformSomeWork = true, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
          } else
            JSCompiler_inline_result = workInProgressRootRenderLanes, JSCompiler_inline_result = getNextLanes(
              root$170,
              root$170 === workInProgressRoot ? JSCompiler_inline_result : 0,
              null !== root$170.cancelPendingCommit || -1 !== root$170.timeoutHandle
            ), 0 === (JSCompiler_inline_result & 3) || checkIfRootIsPrerendering(root$170, JSCompiler_inline_result) || (didPerformSomeWork = true, performSyncWorkOnRoot(root$170, JSCompiler_inline_result));
          root$170 = root$170.next;
        }
      } while (didPerformSomeWork);
      isFlushingWork = false;
    }
  }
  function processRootScheduleInImmediateTask() {
    processRootScheduleInMicrotask();
  }
  function processRootScheduleInMicrotask() {
    mightHavePendingSyncWork = didScheduleMicrotask = false;
    var syncTransitionLanes = 0;
    0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
    for (var currentTime = now(), prev = null, root3 = firstScheduledRoot; null !== root3; ) {
      var next = root3.next, nextLanes = scheduleTaskForRootDuringMicrotask(root3, currentTime);
      if (0 === nextLanes)
        root3.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
      else if (prev = root3, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
        mightHavePendingSyncWork = true;
      root3 = next;
    }
    0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus || flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
    0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
  }
  function scheduleTaskForRootDuringMicrotask(root3, currentTime) {
    for (var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes, expirationTimes = root3.expirationTimes, lanes = root3.pendingLanes & -62914561; 0 < lanes; ) {
      var index$5 = 31 - clz32(lanes), lane = 1 << index$5, expirationTime = expirationTimes[index$5];
      if (-1 === expirationTime) {
        if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
          expirationTimes[index$5] = computeExpirationTime(lane, currentTime);
      } else expirationTime <= currentTime && (root3.expiredLanes |= lane);
      lanes &= ~lane;
    }
    currentTime = workInProgressRoot;
    suspendedLanes = workInProgressRootRenderLanes;
    suspendedLanes = getNextLanes(
      root3,
      root3 === currentTime ? suspendedLanes : 0,
      null !== root3.cancelPendingCommit || -1 !== root3.timeoutHandle
    );
    pingedLanes = root3.callbackNode;
    if (0 === suspendedLanes || root3 === currentTime && (2 === workInProgressSuspendedReason || 9 === workInProgressSuspendedReason) || null !== root3.cancelPendingCommit)
      return null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes), root3.callbackNode = null, root3.callbackPriority = 0;
    if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root3, suspendedLanes)) {
      currentTime = suspendedLanes & -suspendedLanes;
      if (currentTime === root3.callbackPriority) return currentTime;
      null !== pingedLanes && cancelCallback$1(pingedLanes);
      switch (lanesToEventPriority(suspendedLanes)) {
        case 2:
        case 8:
          suspendedLanes = UserBlockingPriority;
          break;
        case 32:
          suspendedLanes = NormalPriority$1;
          break;
        case 268435456:
          suspendedLanes = IdlePriority;
          break;
        default:
          suspendedLanes = NormalPriority$1;
      }
      pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root3);
      suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
      root3.callbackPriority = currentTime;
      root3.callbackNode = suspendedLanes;
      return currentTime;
    }
    null !== pingedLanes && null !== pingedLanes && cancelCallback$1(pingedLanes);
    root3.callbackPriority = 2;
    root3.callbackNode = null;
    return 2;
  }
  function performWorkOnRootViaSchedulerTask(root3, didTimeout) {
    if (0 !== pendingEffectsStatus && 5 !== pendingEffectsStatus)
      return root3.callbackNode = null, root3.callbackPriority = 0, null;
    var originalCallbackNode = root3.callbackNode;
    if (flushPendingEffects() && root3.callbackNode !== originalCallbackNode)
      return null;
    var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
    workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
      root3,
      root3 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
      null !== root3.cancelPendingCommit || -1 !== root3.timeoutHandle
    );
    if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
    performWorkOnRoot(root3, workInProgressRootRenderLanes$jscomp$0, didTimeout);
    scheduleTaskForRootDuringMicrotask(root3, now());
    return null != root3.callbackNode && root3.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root3) : null;
  }
  function performSyncWorkOnRoot(root3, lanes) {
    if (flushPendingEffects()) return null;
    performWorkOnRoot(root3, lanes, true);
  }
  function scheduleImmediateRootScheduleTask() {
    scheduleMicrotask(function() {
      0 !== (executionContext & 6) ? scheduleCallback$3(
        ImmediatePriority,
        processRootScheduleInImmediateTask
      ) : processRootScheduleInMicrotask();
    });
  }
  function requestTransitionLane() {
    if (0 === currentEventTransitionLane) {
      var actionScopeLane = currentEntangledLane;
      0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
      currentEventTransitionLane = actionScopeLane;
    }
    return currentEventTransitionLane;
  }
  function coerceFormActionProp(actionProp) {
    return null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp ? null : "function" === typeof actionProp ? actionProp : sanitizeURL("" + actionProp);
  }
  function createFormDataWithSubmitter(form, submitter) {
    var temp = submitter.ownerDocument.createElement("input");
    temp.name = submitter.name;
    temp.value = submitter.value;
    form.id && temp.setAttribute("form", form.id);
    submitter.parentNode.insertBefore(temp, submitter);
    form = new FormData(form);
    temp.parentNode.removeChild(temp);
    return form;
  }
  function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
    if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
      var action = coerceFormActionProp(
        (nativeEventTarget[internalPropsKey] || null).action
      ), submitter = nativeEvent.submitter;
      submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
      var event = new SyntheticEvent(
        "action",
        "action",
        null,
        nativeEvent,
        nativeEventTarget
      );
      dispatchQueue.push({
        event,
        listeners: [
          {
            instance: null,
            listener: function() {
              if (nativeEvent.defaultPrevented) {
                if (0 !== currentEventTransitionLane) {
                  var formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget);
                  startHostTransition(
                    maybeTargetInst,
                    {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action
                    },
                    null,
                    formData
                  );
                }
              } else
                "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(nativeEventTarget, submitter) : new FormData(nativeEventTarget), startHostTransition(
                  maybeTargetInst,
                  {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action
                  },
                  action,
                  formData
                ));
            },
            currentTarget: nativeEventTarget
          }
        ]
      });
    }
  }
  for (var i$jscomp$inline_1577 = 0; i$jscomp$inline_1577 < simpleEventPluginEvents.length; i$jscomp$inline_1577++) {
    var eventName$jscomp$inline_1578 = simpleEventPluginEvents[i$jscomp$inline_1577], domEventName$jscomp$inline_1579 = eventName$jscomp$inline_1578.toLowerCase(), capitalizedEvent$jscomp$inline_1580 = eventName$jscomp$inline_1578[0].toUpperCase() + eventName$jscomp$inline_1578.slice(1);
    registerSimpleEvent(
      domEventName$jscomp$inline_1579,
      "on" + capitalizedEvent$jscomp$inline_1580
    );
  }
  registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
  registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
  registerSimpleEvent(ANIMATION_START, "onAnimationStart");
  registerSimpleEvent("dblclick", "onDoubleClick");
  registerSimpleEvent("focusin", "onFocus");
  registerSimpleEvent("focusout", "onBlur");
  registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
  registerSimpleEvent(TRANSITION_START, "onTransitionStart");
  registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
  registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
  registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
  registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
  registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
  registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
  registerTwoPhaseEvent(
    "onChange",
    "change click focusin focusout input keydown keyup selectionchange".split(" ")
  );
  registerTwoPhaseEvent(
    "onSelect",
    "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
      " "
    )
  );
  registerTwoPhaseEvent("onBeforeInput", [
    "compositionend",
    "keypress",
    "textInput",
    "paste"
  ]);
  registerTwoPhaseEvent(
    "onCompositionEnd",
    "compositionend focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionStart",
    "compositionstart focusout keydown keypress keyup mousedown".split(" ")
  );
  registerTwoPhaseEvent(
    "onCompositionUpdate",
    "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
  );
  var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
    " "
  ), nonDelegatedEvents = new Set(
    "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
  );
  function processDispatchQueue(dispatchQueue, eventSystemFlags) {
    eventSystemFlags = 0 !== (eventSystemFlags & 4);
    for (var i2 = 0; i2 < dispatchQueue.length; i2++) {
      var _dispatchQueue$i = dispatchQueue[i2], event = _dispatchQueue$i.event;
      _dispatchQueue$i = _dispatchQueue$i.listeners;
      a: {
        var previousInstance = void 0;
        if (eventSystemFlags)
          for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
            var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
        else
          for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
            _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
            instance = _dispatchListeners$i.instance;
            currentTarget = _dispatchListeners$i.currentTarget;
            _dispatchListeners$i = _dispatchListeners$i.listener;
            if (instance !== previousInstance && event.isPropagationStopped())
              break a;
            previousInstance = _dispatchListeners$i;
            event.currentTarget = currentTarget;
            try {
              previousInstance(event);
            } catch (error) {
              reportGlobalError(error);
            }
            event.currentTarget = null;
            previousInstance = instance;
          }
      }
    }
  }
  function listenToNonDelegatedEvent(domEventName, targetElement) {
    var JSCompiler_inline_result = targetElement[internalEventHandlersKey];
    void 0 === JSCompiler_inline_result && (JSCompiler_inline_result = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
    var listenerSetKey = domEventName + "__bubble";
    JSCompiler_inline_result.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), JSCompiler_inline_result.add(listenerSetKey));
  }
  function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
    var eventSystemFlags = 0;
    isCapturePhaseListener && (eventSystemFlags |= 4);
    addTrappedEventListener(
      target,
      domEventName,
      eventSystemFlags,
      isCapturePhaseListener
    );
  }
  var listeningMarker = "_reactListening" + Math.random().toString(36).slice(2);
  function listenToAllSupportedEvents(rootContainerElement) {
    if (!rootContainerElement[listeningMarker]) {
      rootContainerElement[listeningMarker] = true;
      allNativeEvents.forEach(function(domEventName) {
        "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
      });
      var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
      null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
    }
  }
  function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
    switch (getEventPriority(domEventName)) {
      case 2:
        var listenerWrapper = dispatchDiscreteEvent;
        break;
      case 8:
        listenerWrapper = dispatchContinuousEvent;
        break;
      default:
        listenerWrapper = dispatchEvent;
    }
    eventSystemFlags = listenerWrapper.bind(
      null,
      domEventName,
      eventSystemFlags,
      targetContainer
    );
    listenerWrapper = void 0;
    !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
    isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      capture: true,
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
      passive: listenerWrapper
    }) : targetContainer.addEventListener(domEventName, eventSystemFlags, false);
  }
  function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
    var ancestorInst = targetInst$jscomp$0;
    if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
      a: for (; ; ) {
        if (null === targetInst$jscomp$0) return;
        var nodeTag = targetInst$jscomp$0.tag;
        if (3 === nodeTag || 4 === nodeTag) {
          var container = targetInst$jscomp$0.stateNode.containerInfo;
          if (container === targetContainer) break;
          if (4 === nodeTag)
            for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
              var grandTag = nodeTag.tag;
              if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                return;
              nodeTag = nodeTag.return;
            }
          for (; null !== container; ) {
            nodeTag = getClosestInstanceFromNode(container);
            if (null === nodeTag) return;
            grandTag = nodeTag.tag;
            if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
              targetInst$jscomp$0 = ancestorInst = nodeTag;
              continue a;
            }
            container = container.parentNode;
          }
        }
        targetInst$jscomp$0 = targetInst$jscomp$0.return;
      }
    batchedUpdates$1(function() {
      var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
      a: {
        var reactName = topLevelEventsToReactNames.get(domEventName);
        if (void 0 !== reactName) {
          var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
          switch (domEventName) {
            case "keypress":
              if (0 === getEventCharCode(nativeEvent)) break a;
            case "keydown":
            case "keyup":
              SyntheticEventCtor = SyntheticKeyboardEvent;
              break;
            case "focusin":
              reactEventType = "focus";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "focusout":
              reactEventType = "blur";
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "beforeblur":
            case "afterblur":
              SyntheticEventCtor = SyntheticFocusEvent;
              break;
            case "click":
              if (2 === nativeEvent.button) break a;
            case "auxclick":
            case "dblclick":
            case "mousedown":
            case "mousemove":
            case "mouseup":
            case "mouseout":
            case "mouseover":
            case "contextmenu":
              SyntheticEventCtor = SyntheticMouseEvent;
              break;
            case "drag":
            case "dragend":
            case "dragenter":
            case "dragexit":
            case "dragleave":
            case "dragover":
            case "dragstart":
            case "drop":
              SyntheticEventCtor = SyntheticDragEvent;
              break;
            case "touchcancel":
            case "touchend":
            case "touchmove":
            case "touchstart":
              SyntheticEventCtor = SyntheticTouchEvent;
              break;
            case ANIMATION_END:
            case ANIMATION_ITERATION:
            case ANIMATION_START:
              SyntheticEventCtor = SyntheticAnimationEvent;
              break;
            case TRANSITION_END:
              SyntheticEventCtor = SyntheticTransitionEvent;
              break;
            case "scroll":
            case "scrollend":
              SyntheticEventCtor = SyntheticUIEvent;
              break;
            case "wheel":
              SyntheticEventCtor = SyntheticWheelEvent;
              break;
            case "copy":
            case "cut":
            case "paste":
              SyntheticEventCtor = SyntheticClipboardEvent;
              break;
            case "gotpointercapture":
            case "lostpointercapture":
            case "pointercancel":
            case "pointerdown":
            case "pointermove":
            case "pointerout":
            case "pointerover":
            case "pointerup":
              SyntheticEventCtor = SyntheticPointerEvent;
              break;
            case "toggle":
            case "beforetoggle":
              SyntheticEventCtor = SyntheticToggleEvent;
          }
          var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
          inCapturePhase = [];
          for (var instance = targetInst, lastHostComponent; null !== instance; ) {
            var _instance = instance;
            lastHostComponent = _instance.stateNode;
            _instance = _instance.tag;
            5 !== _instance && 26 !== _instance && 27 !== _instance || null === lastHostComponent || null === reactEventName || (_instance = getListener(instance, reactEventName), null != _instance && inCapturePhase.push(
              createDispatchListener(instance, _instance, lastHostComponent)
            ));
            if (accumulateTargetOnly) break;
            instance = instance.return;
          }
          0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
            reactName,
            reactEventType,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({ event: reactName, listeners: inCapturePhase }));
        }
      }
      if (0 === (eventSystemFlags & 7)) {
        a: {
          reactName = "mouseover" === domEventName || "pointerover" === domEventName;
          SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
          if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
            break a;
          if (SyntheticEventCtor || reactName) {
            reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
            if (SyntheticEventCtor) {
              if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                reactEventType = null;
            } else SyntheticEventCtor = null, reactEventType = targetInst;
            if (SyntheticEventCtor !== reactEventType) {
              inCapturePhase = SyntheticMouseEvent;
              _instance = "onMouseLeave";
              reactEventName = "onMouseEnter";
              instance = "mouse";
              if ("pointerout" === domEventName || "pointerover" === domEventName)
                inCapturePhase = SyntheticPointerEvent, _instance = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
              accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
              lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
              reactName = new inCapturePhase(
                _instance,
                instance + "leave",
                SyntheticEventCtor,
                nativeEvent,
                nativeEventTarget
              );
              reactName.target = accumulateTargetOnly;
              reactName.relatedTarget = lastHostComponent;
              _instance = null;
              getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                reactEventName,
                instance + "enter",
                reactEventType,
                nativeEvent,
                nativeEventTarget
              ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance = inCapturePhase);
              accumulateTargetOnly = _instance;
              if (SyntheticEventCtor && reactEventType)
                b: {
                  inCapturePhase = getParent;
                  reactEventName = SyntheticEventCtor;
                  instance = reactEventType;
                  lastHostComponent = 0;
                  for (_instance = reactEventName; _instance; _instance = inCapturePhase(_instance))
                    lastHostComponent++;
                  _instance = 0;
                  for (var tempB = instance; tempB; tempB = inCapturePhase(tempB))
                    _instance++;
                  for (; 0 < lastHostComponent - _instance; )
                    reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                  for (; 0 < _instance - lastHostComponent; )
                    instance = inCapturePhase(instance), _instance--;
                  for (; lastHostComponent--; ) {
                    if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                      inCapturePhase = reactEventName;
                      break b;
                    }
                    reactEventName = inCapturePhase(reactEventName);
                    instance = inCapturePhase(instance);
                  }
                  inCapturePhase = null;
                }
              else inCapturePhase = null;
              null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                reactName,
                SyntheticEventCtor,
                inCapturePhase,
                false
              );
              null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                dispatchQueue,
                accumulateTargetOnly,
                reactEventType,
                inCapturePhase,
                true
              );
            }
          }
        }
        a: {
          reactName = targetInst ? getNodeFromInstance(targetInst) : window;
          SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
          if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
            var getTargetInstFunc = getTargetInstForChangeEvent;
          else if (isTextInputElement(reactName))
            if (isInputEventSupported)
              getTargetInstFunc = getTargetInstForInputOrChangeEvent;
            else {
              getTargetInstFunc = getTargetInstForInputEventPolyfill;
              var handleEventFunc = handleEventsForInputEventPolyfill;
            }
          else
            SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
          if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
            createAndAccumulateChangeEvent(
              dispatchQueue,
              getTargetInstFunc,
              nativeEvent,
              nativeEventTarget
            );
            break a;
          }
          handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
          "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
        }
        handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
        switch (domEventName) {
          case "focusin":
            if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
              activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
            break;
          case "focusout":
            lastSelection = activeElementInst = activeElement = null;
            break;
          case "mousedown":
            mouseDown = true;
            break;
          case "contextmenu":
          case "mouseup":
          case "dragend":
            mouseDown = false;
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
            break;
          case "selectionchange":
            if (skipSelectionChangeEvent) break;
          case "keydown":
          case "keyup":
            constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget);
        }
        var fallbackData;
        if (canUseCompositionEvent)
          b: {
            switch (domEventName) {
              case "compositionstart":
                var eventType = "onCompositionStart";
                break b;
              case "compositionend":
                eventType = "onCompositionEnd";
                break b;
              case "compositionupdate":
                eventType = "onCompositionUpdate";
                break b;
            }
            eventType = void 0;
          }
        else
          isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && 229 === nativeEvent.keyCode && (eventType = "onCompositionStart");
        eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root2 = nativeEventTarget, startText = "value" in root2 ? root2.value : root2.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(targetInst, eventType), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
          eventType,
          domEventName,
          null,
          nativeEvent,
          nativeEventTarget
        ), dispatchQueue.push({ event: eventType, listeners: handleEventFunc }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
        if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
          eventType = accumulateTwoPhaseListeners(targetInst, "onBeforeInput"), 0 < eventType.length && (handleEventFunc = new SyntheticCompositionEvent(
            "onBeforeInput",
            "beforeinput",
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: handleEventFunc,
            listeners: eventType
          }), handleEventFunc.data = fallbackData);
        extractEvents$1(
          dispatchQueue,
          domEventName,
          targetInst,
          nativeEvent,
          nativeEventTarget
        );
      }
      processDispatchQueue(dispatchQueue, eventSystemFlags);
    });
  }
  function createDispatchListener(instance, listener, currentTarget) {
    return {
      instance,
      listener,
      currentTarget
    };
  }
  function accumulateTwoPhaseListeners(targetFiber, reactName) {
    for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
      var _instance2 = targetFiber, stateNode = _instance2.stateNode;
      _instance2 = _instance2.tag;
      5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === stateNode || (_instance2 = getListener(targetFiber, captureName), null != _instance2 && listeners.unshift(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ), _instance2 = getListener(targetFiber, reactName), null != _instance2 && listeners.push(
        createDispatchListener(targetFiber, _instance2, stateNode)
      ));
      if (3 === targetFiber.tag) return listeners;
      targetFiber = targetFiber.return;
    }
    return [];
  }
  function getParent(inst) {
    if (null === inst) return null;
    do
      inst = inst.return;
    while (inst && 5 !== inst.tag && 27 !== inst.tag);
    return inst ? inst : null;
  }
  function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
    for (var registrationName = event._reactName, listeners = []; null !== target && target !== common; ) {
      var _instance3 = target, alternate = _instance3.alternate, stateNode = _instance3.stateNode;
      _instance3 = _instance3.tag;
      if (null !== alternate && alternate === common) break;
      5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
        createDispatchListener(target, stateNode, alternate)
      )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
        createDispatchListener(target, stateNode, alternate)
      )));
      target = target.return;
    }
    0 !== listeners.length && dispatchQueue.push({ event, listeners });
  }
  var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g;
  function normalizeMarkupForTextOrAttribute(markup) {
    return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
  }
  function checkForUnmatchedText(serverText, clientText) {
    clientText = normalizeMarkupForTextOrAttribute(clientText);
    return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
  }
  function setProp(domElement, tag2, key, value, props2, prevValue) {
    switch (key) {
      case "children":
        "string" === typeof value ? "body" === tag2 || "textarea" === tag2 && "" === value || setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && "body" !== tag2 && setTextContent(domElement, "" + value);
        break;
      case "className":
        setValueForKnownAttribute(domElement, "class", value);
        break;
      case "tabIndex":
        setValueForKnownAttribute(domElement, "tabindex", value);
        break;
      case "dir":
      case "role":
      case "viewBox":
      case "width":
      case "height":
        setValueForKnownAttribute(domElement, key, value);
        break;
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "data":
        if ("object" !== tag2) {
          setValueForKnownAttribute(domElement, "data", value);
          break;
        }
      case "src":
      case "href":
        if ("" === value && ("a" !== tag2 || "href" !== key)) {
          domElement.removeAttribute(key);
          break;
        }
        if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "action":
      case "formAction":
        if ("function" === typeof value) {
          domElement.setAttribute(
            key,
            "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
          );
          break;
        } else
          "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag2 && setProp(domElement, tag2, "name", props2.name, props2, null), setProp(
            domElement,
            tag2,
            "formEncType",
            props2.formEncType,
            props2,
            null
          ), setProp(
            domElement,
            tag2,
            "formMethod",
            props2.formMethod,
            props2,
            null
          ), setProp(
            domElement,
            tag2,
            "formTarget",
            props2.formTarget,
            props2,
            null
          )) : (setProp(domElement, tag2, "encType", props2.encType, props2, null), setProp(domElement, tag2, "method", props2.method, props2, null), setProp(domElement, tag2, "target", props2.target, props2, null)));
        if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
          domElement.removeAttribute(key);
          break;
        }
        value = sanitizeURL("" + value);
        domElement.setAttribute(key, value);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage2(61));
          key = value.__html;
          if (null != key) {
            if (null != props2.children) throw Error(formatProdErrorMessage2(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "multiple":
        domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "muted":
        domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "defaultValue":
      case "defaultChecked":
      case "innerHTML":
      case "ref":
        break;
      case "autoFocus":
        break;
      case "xlinkHref":
        if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
          domElement.removeAttribute("xlink:href");
          break;
        }
        key = sanitizeURL("" + value);
        domElement.setAttributeNS(
          "http://www.w3.org/1999/xlink",
          "xlink:href",
          key
        );
        break;
      case "contentEditable":
      case "spellCheck":
      case "draggable":
      case "value":
      case "autoReverse":
      case "externalResourcesRequired":
      case "focusable":
      case "preserveAlpha":
        null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "" + value) : domElement.removeAttribute(key);
        break;
      case "inert":
      case "allowFullScreen":
      case "async":
      case "autoPlay":
      case "controls":
      case "default":
      case "defer":
      case "disabled":
      case "disablePictureInPicture":
      case "disableRemotePlayback":
      case "formNoValidate":
      case "hidden":
      case "loop":
      case "noModule":
      case "noValidate":
      case "open":
      case "playsInline":
      case "readOnly":
      case "required":
      case "reversed":
      case "scoped":
      case "seamless":
      case "itemScope":
        value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
        break;
      case "capture":
      case "download":
        true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "cols":
      case "rows":
      case "size":
      case "span":
        null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? domElement.setAttribute(key, value) : domElement.removeAttribute(key);
        break;
      case "rowSpan":
      case "start":
        null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : domElement.setAttribute(key, value);
        break;
      case "popover":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        setValueForAttribute(domElement, "popover", value);
        break;
      case "xlinkActuate":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:actuate",
          value
        );
        break;
      case "xlinkArcrole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:arcrole",
          value
        );
        break;
      case "xlinkRole":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:role",
          value
        );
        break;
      case "xlinkShow":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:show",
          value
        );
        break;
      case "xlinkTitle":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:title",
          value
        );
        break;
      case "xlinkType":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/1999/xlink",
          "xlink:type",
          value
        );
        break;
      case "xmlBase":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:base",
          value
        );
        break;
      case "xmlLang":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:lang",
          value
        );
        break;
      case "xmlSpace":
        setValueForNamespacedAttribute(
          domElement,
          "http://www.w3.org/XML/1998/namespace",
          "xml:space",
          value
        );
        break;
      case "is":
        setValueForAttribute(domElement, "is", value);
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1])
          key = aliases.get(key) || key, setValueForAttribute(domElement, key, value);
    }
  }
  function setPropOnCustomElement(domElement, tag2, key, value, props2, prevValue) {
    switch (key) {
      case "style":
        setValueForStyles(domElement, value, prevValue);
        break;
      case "dangerouslySetInnerHTML":
        if (null != value) {
          if ("object" !== typeof value || !("__html" in value))
            throw Error(formatProdErrorMessage2(61));
          key = value.__html;
          if (null != key) {
            if (null != props2.children) throw Error(formatProdErrorMessage2(60));
            domElement.innerHTML = key;
          }
        }
        break;
      case "children":
        "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
        break;
      case "onScroll":
        null != value && listenToNonDelegatedEvent("scroll", domElement);
        break;
      case "onScrollEnd":
        null != value && listenToNonDelegatedEvent("scrollend", domElement);
        break;
      case "onClick":
        null != value && (domElement.onclick = noop$12);
        break;
      case "suppressContentEditableWarning":
      case "suppressHydrationWarning":
      case "innerHTML":
      case "ref":
        break;
      case "innerText":
      case "textContent":
        break;
      default:
        if (!registrationNameDependencies.hasOwnProperty(key))
          a: {
            if ("o" === key[0] && "n" === key[1] && (props2 = key.endsWith("Capture"), tag2 = key.slice(2, props2 ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag2, prevValue, props2), "function" === typeof value)) {
              "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
              domElement.addEventListener(tag2, value, props2);
              break a;
            }
            key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
          }
    }
  }
  function setInitialProperties(domElement, tag2, props2) {
    switch (tag2) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "img":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        var hasSrc = false, hasSrcSet = false, propKey;
        for (propKey in props2)
          if (props2.hasOwnProperty(propKey)) {
            var propValue = props2[propKey];
            if (null != propValue)
              switch (propKey) {
                case "src":
                  hasSrc = true;
                  break;
                case "srcSet":
                  hasSrcSet = true;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(formatProdErrorMessage2(137, tag2));
                default:
                  setProp(domElement, tag2, propKey, propValue, props2, null);
              }
          }
        hasSrcSet && setProp(domElement, tag2, "srcSet", props2.srcSet, props2, null);
        hasSrc && setProp(domElement, tag2, "src", props2.src, props2, null);
        return;
      case "input":
        listenToNonDelegatedEvent("invalid", domElement);
        var defaultValue2 = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
        for (hasSrc in props2)
          if (props2.hasOwnProperty(hasSrc)) {
            var propValue$184 = props2[hasSrc];
            if (null != propValue$184)
              switch (hasSrc) {
                case "name":
                  hasSrcSet = propValue$184;
                  break;
                case "type":
                  propValue = propValue$184;
                  break;
                case "checked":
                  checked = propValue$184;
                  break;
                case "defaultChecked":
                  defaultChecked = propValue$184;
                  break;
                case "value":
                  propKey = propValue$184;
                  break;
                case "defaultValue":
                  defaultValue2 = propValue$184;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propValue$184)
                    throw Error(formatProdErrorMessage2(137, tag2));
                  break;
                default:
                  setProp(domElement, tag2, hasSrc, propValue$184, props2, null);
              }
          }
        initInput(
          domElement,
          propKey,
          defaultValue2,
          checked,
          defaultChecked,
          propValue,
          hasSrcSet,
          false
        );
        return;
      case "select":
        listenToNonDelegatedEvent("invalid", domElement);
        hasSrc = propValue = propKey = null;
        for (hasSrcSet in props2)
          if (props2.hasOwnProperty(hasSrcSet) && (defaultValue2 = props2[hasSrcSet], null != defaultValue2))
            switch (hasSrcSet) {
              case "value":
                propKey = defaultValue2;
                break;
              case "defaultValue":
                propValue = defaultValue2;
                break;
              case "multiple":
                hasSrc = defaultValue2;
              default:
                setProp(domElement, tag2, hasSrcSet, defaultValue2, props2, null);
            }
        tag2 = propKey;
        props2 = propValue;
        domElement.multiple = !!hasSrc;
        null != tag2 ? updateOptions(domElement, !!hasSrc, tag2, false) : null != props2 && updateOptions(domElement, !!hasSrc, props2, true);
        return;
      case "textarea":
        listenToNonDelegatedEvent("invalid", domElement);
        propKey = hasSrcSet = hasSrc = null;
        for (propValue in props2)
          if (props2.hasOwnProperty(propValue) && (defaultValue2 = props2[propValue], null != defaultValue2))
            switch (propValue) {
              case "value":
                hasSrc = defaultValue2;
                break;
              case "defaultValue":
                hasSrcSet = defaultValue2;
                break;
              case "children":
                propKey = defaultValue2;
                break;
              case "dangerouslySetInnerHTML":
                if (null != defaultValue2) throw Error(formatProdErrorMessage2(91));
                break;
              default:
                setProp(domElement, tag2, propValue, defaultValue2, props2, null);
            }
        initTextarea(domElement, hasSrc, hasSrcSet, propKey);
        return;
      case "option":
        for (checked in props2)
          if (props2.hasOwnProperty(checked) && (hasSrc = props2[checked], null != hasSrc))
            switch (checked) {
              case "selected":
                domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                break;
              default:
                setProp(domElement, tag2, checked, hasSrc, props2, null);
            }
        return;
      case "dialog":
        listenToNonDelegatedEvent("beforetoggle", domElement);
        listenToNonDelegatedEvent("toggle", domElement);
        listenToNonDelegatedEvent("cancel", domElement);
        listenToNonDelegatedEvent("close", domElement);
        break;
      case "iframe":
      case "object":
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "video":
      case "audio":
        for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
          listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
        break;
      case "image":
        listenToNonDelegatedEvent("error", domElement);
        listenToNonDelegatedEvent("load", domElement);
        break;
      case "details":
        listenToNonDelegatedEvent("toggle", domElement);
        break;
      case "embed":
      case "source":
      case "link":
        listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
      case "area":
      case "base":
      case "br":
      case "col":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "track":
      case "wbr":
      case "menuitem":
        for (defaultChecked in props2)
          if (props2.hasOwnProperty(defaultChecked) && (hasSrc = props2[defaultChecked], null != hasSrc))
            switch (defaultChecked) {
              case "children":
              case "dangerouslySetInnerHTML":
                throw Error(formatProdErrorMessage2(137, tag2));
              default:
                setProp(domElement, tag2, defaultChecked, hasSrc, props2, null);
            }
        return;
      default:
        if (isCustomElement(tag2)) {
          for (propValue$184 in props2)
            props2.hasOwnProperty(propValue$184) && (hasSrc = props2[propValue$184], void 0 !== hasSrc && setPropOnCustomElement(
              domElement,
              tag2,
              propValue$184,
              hasSrc,
              props2,
              void 0
            ));
          return;
        }
    }
    for (defaultValue2 in props2)
      props2.hasOwnProperty(defaultValue2) && (hasSrc = props2[defaultValue2], null != hasSrc && setProp(domElement, tag2, defaultValue2, hasSrc, props2, null));
  }
  function updateProperties(domElement, tag2, lastProps, nextProps) {
    switch (tag2) {
      case "div":
      case "span":
      case "svg":
      case "path":
      case "a":
      case "g":
      case "p":
      case "li":
        break;
      case "input":
        var name2 = null, type = null, value = null, defaultValue2 = null, lastDefaultValue = null, checked = null, defaultChecked = null;
        for (propKey in lastProps) {
          var lastProp = lastProps[propKey];
          if (lastProps.hasOwnProperty(propKey) && null != lastProp)
            switch (propKey) {
              case "checked":
                break;
              case "value":
                break;
              case "defaultValue":
                lastDefaultValue = lastProp;
              default:
                nextProps.hasOwnProperty(propKey) || setProp(domElement, tag2, propKey, null, nextProps, lastProp);
            }
        }
        for (var propKey$201 in nextProps) {
          var propKey = nextProps[propKey$201];
          lastProp = lastProps[propKey$201];
          if (nextProps.hasOwnProperty(propKey$201) && (null != propKey || null != lastProp))
            switch (propKey$201) {
              case "type":
                type = propKey;
                break;
              case "name":
                name2 = propKey;
                break;
              case "checked":
                checked = propKey;
                break;
              case "defaultChecked":
                defaultChecked = propKey;
                break;
              case "value":
                value = propKey;
                break;
              case "defaultValue":
                defaultValue2 = propKey;
                break;
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey)
                  throw Error(formatProdErrorMessage2(137, tag2));
                break;
              default:
                propKey !== lastProp && setProp(
                  domElement,
                  tag2,
                  propKey$201,
                  propKey,
                  nextProps,
                  lastProp
                );
            }
        }
        updateInput(
          domElement,
          value,
          defaultValue2,
          lastDefaultValue,
          checked,
          defaultChecked,
          type,
          name2
        );
        return;
      case "select":
        propKey = value = defaultValue2 = propKey$201 = null;
        for (type in lastProps)
          if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue)
            switch (type) {
              case "value":
                break;
              case "multiple":
                propKey = lastDefaultValue;
              default:
                nextProps.hasOwnProperty(type) || setProp(
                  domElement,
                  tag2,
                  type,
                  null,
                  nextProps,
                  lastDefaultValue
                );
            }
        for (name2 in nextProps)
          if (type = nextProps[name2], lastDefaultValue = lastProps[name2], nextProps.hasOwnProperty(name2) && (null != type || null != lastDefaultValue))
            switch (name2) {
              case "value":
                propKey$201 = type;
                break;
              case "defaultValue":
                defaultValue2 = type;
                break;
              case "multiple":
                value = type;
              default:
                type !== lastDefaultValue && setProp(
                  domElement,
                  tag2,
                  name2,
                  type,
                  nextProps,
                  lastDefaultValue
                );
            }
        tag2 = defaultValue2;
        lastProps = value;
        nextProps = propKey;
        null != propKey$201 ? updateOptions(domElement, !!lastProps, propKey$201, false) : !!nextProps !== !!lastProps && (null != tag2 ? updateOptions(domElement, !!lastProps, tag2, true) : updateOptions(domElement, !!lastProps, lastProps ? [] : "", false));
        return;
      case "textarea":
        propKey = propKey$201 = null;
        for (defaultValue2 in lastProps)
          if (name2 = lastProps[defaultValue2], lastProps.hasOwnProperty(defaultValue2) && null != name2 && !nextProps.hasOwnProperty(defaultValue2))
            switch (defaultValue2) {
              case "value":
                break;
              case "children":
                break;
              default:
                setProp(domElement, tag2, defaultValue2, null, nextProps, name2);
            }
        for (value in nextProps)
          if (name2 = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name2 || null != type))
            switch (value) {
              case "value":
                propKey$201 = name2;
                break;
              case "defaultValue":
                propKey = name2;
                break;
              case "children":
                break;
              case "dangerouslySetInnerHTML":
                if (null != name2) throw Error(formatProdErrorMessage2(91));
                break;
              default:
                name2 !== type && setProp(domElement, tag2, value, name2, nextProps, type);
            }
        updateTextarea(domElement, propKey$201, propKey);
        return;
      case "option":
        for (var propKey$217 in lastProps)
          if (propKey$201 = lastProps[propKey$217], lastProps.hasOwnProperty(propKey$217) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$217))
            switch (propKey$217) {
              case "selected":
                domElement.selected = false;
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  propKey$217,
                  null,
                  nextProps,
                  propKey$201
                );
            }
        for (lastDefaultValue in nextProps)
          if (propKey$201 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && propKey$201 !== propKey && (null != propKey$201 || null != propKey))
            switch (lastDefaultValue) {
              case "selected":
                domElement.selected = propKey$201 && "function" !== typeof propKey$201 && "symbol" !== typeof propKey$201;
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  lastDefaultValue,
                  propKey$201,
                  nextProps,
                  propKey
                );
            }
        return;
      case "img":
      case "link":
      case "area":
      case "base":
      case "br":
      case "col":
      case "embed":
      case "hr":
      case "keygen":
      case "meta":
      case "param":
      case "source":
      case "track":
      case "wbr":
      case "menuitem":
        for (var propKey$222 in lastProps)
          propKey$201 = lastProps[propKey$222], lastProps.hasOwnProperty(propKey$222) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$222) && setProp(domElement, tag2, propKey$222, null, nextProps, propKey$201);
        for (checked in nextProps)
          if (propKey$201 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && propKey$201 !== propKey && (null != propKey$201 || null != propKey))
            switch (checked) {
              case "children":
              case "dangerouslySetInnerHTML":
                if (null != propKey$201)
                  throw Error(formatProdErrorMessage2(137, tag2));
                break;
              default:
                setProp(
                  domElement,
                  tag2,
                  checked,
                  propKey$201,
                  nextProps,
                  propKey
                );
            }
        return;
      default:
        if (isCustomElement(tag2)) {
          for (var propKey$227 in lastProps)
            propKey$201 = lastProps[propKey$227], lastProps.hasOwnProperty(propKey$227) && void 0 !== propKey$201 && !nextProps.hasOwnProperty(propKey$227) && setPropOnCustomElement(
              domElement,
              tag2,
              propKey$227,
              void 0,
              nextProps,
              propKey$201
            );
          for (defaultChecked in nextProps)
            propKey$201 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || propKey$201 === propKey || void 0 === propKey$201 && void 0 === propKey || setPropOnCustomElement(
              domElement,
              tag2,
              defaultChecked,
              propKey$201,
              nextProps,
              propKey
            );
          return;
        }
    }
    for (var propKey$232 in lastProps)
      propKey$201 = lastProps[propKey$232], lastProps.hasOwnProperty(propKey$232) && null != propKey$201 && !nextProps.hasOwnProperty(propKey$232) && setProp(domElement, tag2, propKey$232, null, nextProps, propKey$201);
    for (lastProp in nextProps)
      propKey$201 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || propKey$201 === propKey || null == propKey$201 && null == propKey || setProp(domElement, tag2, lastProp, propKey$201, nextProps, propKey);
  }
  function isLikelyStaticResource(initiatorType) {
    switch (initiatorType) {
      case "css":
      case "script":
      case "font":
      case "img":
      case "image":
      case "input":
      case "link":
        return true;
      default:
        return false;
    }
  }
  function estimateBandwidth() {
    if ("function" === typeof performance.getEntriesByType) {
      for (var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i2 = 0; i2 < resourceEntries.length; i2++) {
        var entry = resourceEntries[i2], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
        if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
          initiatorType = 0;
          duration = entry.responseEnd;
          for (i2 += 1; i2 < resourceEntries.length; i2++) {
            var overlapEntry = resourceEntries[i2], overlapStartTime = overlapEntry.startTime;
            if (overlapStartTime > duration) break;
            var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
            overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
          }
          --i2;
          bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
          count++;
          if (10 < count) break;
        }
      }
      if (0 < count) return bits / count / 1e6;
    }
    return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
  }
  var eventsEnabled = null, selectionInformation = null;
  function getOwnerDocumentFromRootContainer(rootContainerElement) {
    return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
  }
  function getOwnHostContext(namespaceURI) {
    switch (namespaceURI) {
      case "http://www.w3.org/2000/svg":
        return 1;
      case "http://www.w3.org/1998/Math/MathML":
        return 2;
      default:
        return 0;
    }
  }
  function getChildHostContextProd(parentNamespace, type) {
    if (0 === parentNamespace)
      switch (type) {
        case "svg":
          return 1;
        case "math":
          return 2;
        default:
          return 0;
      }
    return 1 === parentNamespace && "foreignObject" === type ? 0 : parentNamespace;
  }
  function shouldSetTextContent(type, props2) {
    return "textarea" === type || "noscript" === type || "string" === typeof props2.children || "number" === typeof props2.children || "bigint" === typeof props2.children || "object" === typeof props2.dangerouslySetInnerHTML && null !== props2.dangerouslySetInnerHTML && null != props2.dangerouslySetInnerHTML.__html;
  }
  var currentPopstateTransitionEvent = null;
  function shouldAttemptEagerTransition() {
    var event = window.event;
    if (event && "popstate" === event.type) {
      if (event === currentPopstateTransitionEvent) return false;
      currentPopstateTransitionEvent = event;
      return true;
    }
    currentPopstateTransitionEvent = null;
    return false;
  }
  var scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
    return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
  } : scheduleTimeout;
  function handleErrorInNextTick(error) {
    setTimeout(function() {
      throw error;
    });
  }
  function isSingletonScope(type) {
    return "head" === type;
  }
  function clearHydrationBoundary(parentInstance, hydrationInstance) {
    var node = hydrationInstance, depth = 0;
    do {
      var nextNode = node.nextSibling;
      parentInstance.removeChild(node);
      if (nextNode && 8 === nextNode.nodeType)
        if (node = nextNode.data, "/$" === node || "/&" === node) {
          if (0 === depth) {
            parentInstance.removeChild(nextNode);
            retryIfBlockedOn(hydrationInstance);
            return;
          }
          depth--;
        } else if ("$" === node || "$?" === node || "$~" === node || "$!" === node || "&" === node)
          depth++;
        else if ("html" === node)
          releaseSingletonInstance(parentInstance.ownerDocument.documentElement);
        else if ("head" === node) {
          node = parentInstance.ownerDocument.head;
          releaseSingletonInstance(node);
          for (var node$jscomp$0 = node.firstChild; node$jscomp$0; ) {
            var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
            node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
            node$jscomp$0 = nextNode$jscomp$0;
          }
        } else
          "body" === node && releaseSingletonInstance(parentInstance.ownerDocument.body);
      node = nextNode;
    } while (node);
    retryIfBlockedOn(hydrationInstance);
  }
  function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden2) {
    var node = suspenseInstance;
    suspenseInstance = 0;
    do {
      var nextNode = node.nextSibling;
      1 === node.nodeType ? isHidden2 ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden2 ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
      if (nextNode && 8 === nextNode.nodeType)
        if (node = nextNode.data, "/$" === node)
          if (0 === suspenseInstance) break;
          else suspenseInstance--;
        else
          "$" !== node && "$?" !== node && "$~" !== node && "$!" !== node || suspenseInstance++;
      node = nextNode;
    } while (node);
  }
  function clearContainerSparingly(container) {
    var nextNode = container.firstChild;
    nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
    for (; nextNode; ) {
      var node = nextNode;
      nextNode = nextNode.nextSibling;
      switch (node.nodeName) {
        case "HTML":
        case "HEAD":
        case "BODY":
          clearContainerSparingly(node);
          detachDeletedInstance(node);
          continue;
        case "SCRIPT":
        case "STYLE":
          continue;
        case "LINK":
          if ("stylesheet" === node.rel.toLowerCase()) continue;
      }
      container.removeChild(node);
    }
  }
  function canHydrateInstance(instance, type, props2, inRootOrSingleton) {
    for (; 1 === instance.nodeType; ) {
      var anyProps = props2;
      if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
        if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
          break;
      } else if (!inRootOrSingleton)
        if ("input" === type && "hidden" === instance.type) {
          var name2 = null == anyProps.name ? null : "" + anyProps.name;
          if ("hidden" === anyProps.type && instance.getAttribute("name") === name2)
            return instance;
        } else return instance;
      else if (!instance[internalHoistableMarker])
        switch (type) {
          case "meta":
            if (!instance.hasAttribute("itemprop")) break;
            return instance;
          case "link":
            name2 = instance.getAttribute("rel");
            if ("stylesheet" === name2 && instance.hasAttribute("data-precedence"))
              break;
            else if (name2 !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
              break;
            return instance;
          case "style":
            if (instance.hasAttribute("data-precedence")) break;
            return instance;
          case "script":
            name2 = instance.getAttribute("src");
            if ((name2 !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name2 && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
              break;
            return instance;
          default:
            return instance;
        }
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) break;
    }
    return null;
  }
  function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
    if ("" === text2) return null;
    for (; 3 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
    for (; 8 !== instance.nodeType; ) {
      if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
        return null;
      instance = getNextHydratable(instance.nextSibling);
      if (null === instance) return null;
    }
    return instance;
  }
  function isSuspenseInstancePending(instance) {
    return "$?" === instance.data || "$~" === instance.data;
  }
  function isSuspenseInstanceFallback(instance) {
    return "$!" === instance.data || "$?" === instance.data && "loading" !== instance.ownerDocument.readyState;
  }
  function registerSuspenseInstanceRetry(instance, callback) {
    var ownerDocument = instance.ownerDocument;
    if ("$~" === instance.data) instance._reactRetry = callback;
    else if ("$?" !== instance.data || "loading" !== ownerDocument.readyState)
      callback();
    else {
      var listener = function() {
        callback();
        ownerDocument.removeEventListener("DOMContentLoaded", listener);
      };
      ownerDocument.addEventListener("DOMContentLoaded", listener);
      instance._reactRetry = listener;
    }
  }
  function getNextHydratable(node) {
    for (; null != node; node = node.nextSibling) {
      var nodeType = node.nodeType;
      if (1 === nodeType || 3 === nodeType) break;
      if (8 === nodeType) {
        nodeType = node.data;
        if ("$" === nodeType || "$!" === nodeType || "$?" === nodeType || "$~" === nodeType || "&" === nodeType || "F!" === nodeType || "F" === nodeType)
          break;
        if ("/$" === nodeType || "/&" === nodeType) return null;
      }
    }
    return node;
  }
  var previousHydratableOnEnteringScopedSingleton = null;
  function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
    hydrationInstance = hydrationInstance.nextSibling;
    for (var depth = 0; hydrationInstance; ) {
      if (8 === hydrationInstance.nodeType) {
        var data = hydrationInstance.data;
        if ("/$" === data || "/&" === data) {
          if (0 === depth)
            return getNextHydratable(hydrationInstance.nextSibling);
          depth--;
        } else
          "$" !== data && "$!" !== data && "$?" !== data && "$~" !== data && "&" !== data || depth++;
      }
      hydrationInstance = hydrationInstance.nextSibling;
    }
    return null;
  }
  function getParentHydrationBoundary(targetInstance) {
    targetInstance = targetInstance.previousSibling;
    for (var depth = 0; targetInstance; ) {
      if (8 === targetInstance.nodeType) {
        var data = targetInstance.data;
        if ("$" === data || "$!" === data || "$?" === data || "$~" === data || "&" === data) {
          if (0 === depth) return targetInstance;
          depth--;
        } else "/$" !== data && "/&" !== data || depth++;
      }
      targetInstance = targetInstance.previousSibling;
    }
    return null;
  }
  function resolveSingletonInstance(type, props2, rootContainerInstance) {
    props2 = getOwnerDocumentFromRootContainer(rootContainerInstance);
    switch (type) {
      case "html":
        type = props2.documentElement;
        if (!type) throw Error(formatProdErrorMessage2(452));
        return type;
      case "head":
        type = props2.head;
        if (!type) throw Error(formatProdErrorMessage2(453));
        return type;
      case "body":
        type = props2.body;
        if (!type) throw Error(formatProdErrorMessage2(454));
        return type;
      default:
        throw Error(formatProdErrorMessage2(451));
    }
  }
  function releaseSingletonInstance(instance) {
    for (var attributes = instance.attributes; attributes.length; )
      instance.removeAttributeNode(attributes[0]);
    detachDeletedInstance(instance);
  }
  var preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set();
  function getHoistableRoot(container) {
    return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
  }
  var previousDispatcher = ReactDOMSharedInternals.d;
  ReactDOMSharedInternals.d = {
    f: flushSyncWork,
    r: requestFormReset,
    D: prefetchDNS,
    C: preconnect,
    L: preload,
    m: preloadModule,
    X: preinitScript,
    S: preinitStyle,
    M: preinitModuleScript
  };
  function flushSyncWork() {
    var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
    return previousWasRendering || wasRendering;
  }
  function requestFormReset(form) {
    var formInst = getInstanceFromNode(form);
    null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
  }
  var globalDocument = "undefined" === typeof document ? null : document;
  function preconnectAs(rel, href, crossOrigin) {
    var ownerDocument = globalDocument;
    if (ownerDocument && "string" === typeof href && href) {
      var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
      limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
      "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
      preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
    }
  }
  function prefetchDNS(href) {
    previousDispatcher.D(href);
    preconnectAs("dns-prefetch", href, null);
  }
  function preconnect(href, crossOrigin) {
    previousDispatcher.C(href, crossOrigin);
    preconnectAs("preconnect", href, crossOrigin);
  }
  function preload(href, as, options3) {
    previousDispatcher.L(href, as, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href && as) {
      var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
      "image" === as ? options3 && options3.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options3.imageSrcSet
      ) + '"]', "string" === typeof options3.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
        options3.imageSizes
      ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
      var key = preloadSelector;
      switch (as) {
        case "style":
          key = getStyleKey(href);
          break;
        case "script":
          key = getScriptKey(href);
      }
      preloadPropsMap.has(key) || (href = assign2(
        {
          rel: "preload",
          href: "image" === as && options3 && options3.imageSrcSet ? void 0 : href,
          as
        },
        options3
      ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(getStylesheetSelectorFromKey(key)) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
    }
  }
  function preloadModule(href, options3) {
    previousDispatcher.m(href, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var as = options3 && "string" === typeof options3.as ? options3.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
      switch (as) {
        case "audioworklet":
        case "paintworklet":
        case "serviceworker":
        case "sharedworker":
        case "worker":
        case "script":
          key = getScriptKey(href);
      }
      if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options3), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
        switch (as) {
          case "audioworklet":
          case "paintworklet":
          case "serviceworker":
          case "sharedworker":
          case "worker":
          case "script":
            if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
              return;
        }
        as = ownerDocument.createElement("link");
        setInitialProperties(as, "link", href);
        markNodeAsHoistable(as);
        ownerDocument.head.appendChild(as);
      }
    }
  }
  function preinitStyle(href, precedence, options3) {
    previousDispatcher.S(href, precedence, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && href) {
      var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
      precedence = precedence || "default";
      var resource = styles.get(key);
      if (!resource) {
        var state = { loading: 0, preload: null };
        if (resource = ownerDocument.querySelector(
          getStylesheetSelectorFromKey(key)
        ))
          state.loading = 5;
        else {
          href = assign2(
            { rel: "stylesheet", href, "data-precedence": precedence },
            options3
          );
          (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options3);
          var link = resource = ownerDocument.createElement("link");
          markNodeAsHoistable(link);
          setInitialProperties(link, "link", href);
          link._p = new Promise(function(resolve, reject2) {
            link.onload = resolve;
            link.onerror = reject2;
          });
          link.addEventListener("load", function() {
            state.loading |= 1;
          });
          link.addEventListener("error", function() {
            state.loading |= 2;
          });
          state.loading |= 4;
          insertStylesheet(resource, precedence, ownerDocument);
        }
        resource = {
          type: "stylesheet",
          instance: resource,
          count: 1,
          state
        };
        styles.set(key, resource);
      }
    }
  }
  function preinitScript(src, options3) {
    previousDispatcher.X(src, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true }, options3), (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options3), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function preinitModuleScript(src, options3) {
    previousDispatcher.M(src, options3);
    var ownerDocument = globalDocument;
    if (ownerDocument && src) {
      var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
      resource || (resource = ownerDocument.querySelector(getScriptSelectorFromKey(key)), resource || (src = assign2({ src, async: true, type: "module" }, options3), (options3 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options3), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
        type: "script",
        instance: resource,
        count: 1,
        state: null
      }, scripts.set(key, resource));
    }
  }
  function getResource(type, currentProps, pendingProps, currentResource) {
    var JSCompiler_inline_result = (JSCompiler_inline_result = rootInstanceStackCursor.current) ? getHoistableRoot(JSCompiler_inline_result) : null;
    if (!JSCompiler_inline_result) throw Error(formatProdErrorMessage2(446));
    switch (type) {
      case "meta":
      case "title":
        return null;
      case "style":
        return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (currentProps = getStyleKey(pendingProps.href), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableStyles, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "style",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      case "link":
        if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
          type = getStyleKey(pendingProps.href);
          var styles$243 = getResourcesFromRoot(
            JSCompiler_inline_result
          ).hoistableStyles, resource$244 = styles$243.get(type);
          resource$244 || (JSCompiler_inline_result = JSCompiler_inline_result.ownerDocument || JSCompiler_inline_result, resource$244 = {
            type: "stylesheet",
            instance: null,
            count: 0,
            state: { loading: 0, preload: null }
          }, styles$243.set(type, resource$244), (styles$243 = JSCompiler_inline_result.querySelector(
            getStylesheetSelectorFromKey(type)
          )) && !styles$243._p && (resource$244.instance = styles$243, resource$244.state.loading = 5), preloadPropsMap.has(type) || (pendingProps = {
            rel: "preload",
            as: "style",
            href: pendingProps.href,
            crossOrigin: pendingProps.crossOrigin,
            integrity: pendingProps.integrity,
            media: pendingProps.media,
            hrefLang: pendingProps.hrefLang,
            referrerPolicy: pendingProps.referrerPolicy
          }, preloadPropsMap.set(type, pendingProps), styles$243 || preloadStylesheet(
            JSCompiler_inline_result,
            type,
            pendingProps,
            resource$244.state
          )));
          if (currentProps && null === currentResource)
            throw Error(formatProdErrorMessage2(528, ""));
          return resource$244;
        }
        if (currentProps && null !== currentResource)
          throw Error(formatProdErrorMessage2(529, ""));
        return null;
      case "script":
        return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (currentProps = getScriptKey(pendingProps), pendingProps = getResourcesFromRoot(
          JSCompiler_inline_result
        ).hoistableScripts, currentResource = pendingProps.get(currentProps), currentResource || (currentResource = {
          type: "script",
          instance: null,
          count: 0,
          state: null
        }, pendingProps.set(currentProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
      default:
        throw Error(formatProdErrorMessage2(444, type));
    }
  }
  function getStyleKey(href) {
    return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
  }
  function getStylesheetSelectorFromKey(key) {
    return 'link[rel="stylesheet"][' + key + "]";
  }
  function stylesheetPropsFromRawProps(rawProps) {
    return assign2({}, rawProps, {
      "data-precedence": rawProps.precedence,
      precedence: null
    });
  }
  function preloadStylesheet(ownerDocument, key, preloadProps, state) {
    ownerDocument.querySelector('link[rel="preload"][as="style"][' + key + "]") ? state.loading = 1 : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
      return state.loading |= 1;
    }), key.addEventListener("error", function() {
      return state.loading |= 2;
    }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
  }
  function getScriptKey(src) {
    return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
  }
  function getScriptSelectorFromKey(key) {
    return "script[async]" + key;
  }
  function acquireResource(hoistableRoot, resource, props2) {
    resource.count++;
    if (null === resource.instance)
      switch (resource.type) {
        case "style":
          var instance = hoistableRoot.querySelector(
            'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props2.href) + '"]'
          );
          if (instance)
            return resource.instance = instance, markNodeAsHoistable(instance), instance;
          var styleProps = assign2({}, props2, {
            "data-href": props2.href,
            "data-precedence": props2.precedence,
            href: null,
            precedence: null
          });
          instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement(
            "style"
          );
          markNodeAsHoistable(instance);
          setInitialProperties(instance, "style", styleProps);
          insertStylesheet(instance, props2.precedence, hoistableRoot);
          return resource.instance = instance;
        case "stylesheet":
          styleProps = getStyleKey(props2.href);
          var instance$249 = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(styleProps)
          );
          if (instance$249)
            return resource.state.loading |= 4, resource.instance = instance$249, markNodeAsHoistable(instance$249), instance$249;
          instance = stylesheetPropsFromRawProps(props2);
          (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
          instance$249 = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
          markNodeAsHoistable(instance$249);
          var linkInstance = instance$249;
          linkInstance._p = new Promise(function(resolve, reject2) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject2;
          });
          setInitialProperties(instance$249, "link", instance);
          resource.state.loading |= 4;
          insertStylesheet(instance$249, props2.precedence, hoistableRoot);
          return resource.instance = instance$249;
        case "script":
          instance$249 = getScriptKey(props2.src);
          if (styleProps = hoistableRoot.querySelector(
            getScriptSelectorFromKey(instance$249)
          ))
            return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
          instance = props2;
          if (styleProps = preloadPropsMap.get(instance$249))
            instance = assign2({}, props2), adoptPreloadPropsForScript(instance, styleProps);
          hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
          styleProps = hoistableRoot.createElement("script");
          markNodeAsHoistable(styleProps);
          setInitialProperties(styleProps, "link", instance);
          hoistableRoot.head.appendChild(styleProps);
          return resource.instance = styleProps;
        case "void":
          return null;
        default:
          throw Error(formatProdErrorMessage2(443, resource.type));
      }
    else
      "stylesheet" === resource.type && 0 === (resource.state.loading & 4) && (instance = resource.instance, resource.state.loading |= 4, insertStylesheet(instance, props2.precedence, hoistableRoot));
    return resource.instance;
  }
  function insertStylesheet(instance, precedence, root3) {
    for (var nodes = root3.querySelectorAll(
      'link[rel="stylesheet"][data-precedence],style[data-precedence]'
    ), last2 = nodes.length ? nodes[nodes.length - 1] : null, prior = last2, i2 = 0; i2 < nodes.length; i2++) {
      var node = nodes[i2];
      if (node.dataset.precedence === precedence) prior = node;
      else if (prior !== last2) break;
    }
    prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root3.nodeType ? root3.head : root3, precedence.insertBefore(instance, precedence.firstChild));
  }
  function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
    null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
    null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
    null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
  }
  function adoptPreloadPropsForScript(scriptProps, preloadProps) {
    null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
    null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
    null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
  }
  var tagCaches = null;
  function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
    if (null === tagCaches) {
      var cache = /* @__PURE__ */ new Map();
      var caches = tagCaches = /* @__PURE__ */ new Map();
      caches.set(ownerDocument, cache);
    } else
      caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache));
    if (cache.has(type)) return cache;
    cache.set(type, null);
    ownerDocument = ownerDocument.getElementsByTagName(type);
    for (caches = 0; caches < ownerDocument.length; caches++) {
      var node = ownerDocument[caches];
      if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && "http://www.w3.org/2000/svg" !== node.namespaceURI) {
        var nodeKey = node.getAttribute(keyAttribute) || "";
        nodeKey = type + nodeKey;
        var existing = cache.get(nodeKey);
        existing ? existing.push(node) : cache.set(nodeKey, [node]);
      }
    }
    return cache;
  }
  function mountHoistable(hoistableRoot, type, instance) {
    hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
    hoistableRoot.head.insertBefore(
      instance,
      "title" === type ? hoistableRoot.querySelector("head > title") : null
    );
  }
  function isHostHoistableType(type, props2, hostContext) {
    if (1 === hostContext || null != props2.itemProp) return false;
    switch (type) {
      case "meta":
      case "title":
        return true;
      case "style":
        if ("string" !== typeof props2.precedence || "string" !== typeof props2.href || "" === props2.href)
          break;
        return true;
      case "link":
        if ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href || props2.onLoad || props2.onError)
          break;
        switch (props2.rel) {
          case "stylesheet":
            return type = props2.disabled, "string" === typeof props2.precedence && null == type;
          default:
            return true;
        }
      case "script":
        if (props2.async && "function" !== typeof props2.async && "symbol" !== typeof props2.async && !props2.onLoad && !props2.onError && props2.src && "string" === typeof props2.src)
          return true;
    }
    return false;
  }
  function preloadResource(resource) {
    return "stylesheet" === resource.type && 0 === (resource.state.loading & 3) ? false : true;
  }
  function suspendResource(state, hoistableRoot, resource, props2) {
    if ("stylesheet" === resource.type && ("string" !== typeof props2.media || false !== matchMedia(props2.media).matches) && 0 === (resource.state.loading & 4)) {
      if (null === resource.instance) {
        var key = getStyleKey(props2.href), instance = hoistableRoot.querySelector(
          getStylesheetSelectorFromKey(key)
        );
        if (instance) {
          hoistableRoot = instance._p;
          null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
          resource.state.loading |= 4;
          resource.instance = instance;
          markNodeAsHoistable(instance);
          return;
        }
        instance = hoistableRoot.ownerDocument || hoistableRoot;
        props2 = stylesheetPropsFromRawProps(props2);
        (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props2, key);
        instance = instance.createElement("link");
        markNodeAsHoistable(instance);
        var linkInstance = instance;
        linkInstance._p = new Promise(function(resolve, reject2) {
          linkInstance.onload = resolve;
          linkInstance.onerror = reject2;
        });
        setInitialProperties(instance, "link", props2);
        resource.instance = instance;
      }
      null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
      state.stylesheets.set(resource, hoistableRoot);
      (hoistableRoot = resource.state.preload) && 0 === (resource.state.loading & 3) && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
    }
  }
  var estimatedBytesWithinLimit = 0;
  function waitForCommitToBeReady(state, timeoutOffset) {
    state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
    return 0 < state.count || 0 < state.imgCount ? function(commit) {
      var stylesheetTimer = setTimeout(function() {
        state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
        if (state.unsuspend) {
          var unsuspend = state.unsuspend;
          state.unsuspend = null;
          unsuspend();
        }
      }, 6e4 + timeoutOffset);
      0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 62500 * estimateBandwidth());
      var imgTimer = setTimeout(
        function() {
          state.waitingForImages = false;
          if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        },
        (state.imgBytes > estimatedBytesWithinLimit ? 50 : 800) + timeoutOffset
      );
      state.unsuspend = commit;
      return function() {
        state.unsuspend = null;
        clearTimeout(stylesheetTimer);
        clearTimeout(imgTimer);
      };
    } : null;
  }
  function onUnsuspend() {
    this.count--;
    if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
      if (this.stylesheets) insertSuspendedStylesheets(this, this.stylesheets);
      else if (this.unsuspend) {
        var unsuspend = this.unsuspend;
        this.unsuspend = null;
        unsuspend();
      }
    }
  }
  var precedencesByRoot = null;
  function insertSuspendedStylesheets(state, resources) {
    state.stylesheets = null;
    null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
  }
  function insertStylesheetIntoRoot(root3, resource) {
    if (!(resource.state.loading & 4)) {
      var precedences = precedencesByRoot.get(root3);
      if (precedences) var last2 = precedences.get(null);
      else {
        precedences = /* @__PURE__ */ new Map();
        precedencesByRoot.set(root3, precedences);
        for (var nodes = root3.querySelectorAll(
          "link[data-precedence],style[data-precedence]"
        ), i2 = 0; i2 < nodes.length; i2++) {
          var node = nodes[i2];
          if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media"))
            precedences.set(node.dataset.precedence, node), last2 = node;
        }
        last2 && precedences.set(null, last2);
      }
      nodes = resource.instance;
      node = nodes.getAttribute("data-precedence");
      i2 = precedences.get(node) || last2;
      i2 === last2 && precedences.set(null, nodes);
      precedences.set(node, nodes);
      this.count++;
      last2 = onUnsuspend.bind(this);
      nodes.addEventListener("load", last2);
      nodes.addEventListener("error", last2);
      i2 ? i2.parentNode.insertBefore(nodes, i2.nextSibling) : (root3 = 9 === root3.nodeType ? root3.head : root3, root3.insertBefore(nodes, root3.firstChild));
      resource.state.loading |= 4;
    }
  }
  var HostTransitionContext = {
    $$typeof: REACT_CONTEXT_TYPE,
    Provider: null,
    Consumer: null,
    _currentValue: sharedNotPendingObject,
    _currentValue2: sharedNotPendingObject,
    _threadCount: 0
  };
  function FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
    this.tag = 1;
    this.containerInfo = containerInfo;
    this.pingCache = this.current = this.pendingChildren = null;
    this.timeoutHandle = -1;
    this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
    this.callbackPriority = 0;
    this.expirationTimes = createLaneMap(-1);
    this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
    this.entanglements = createLaneMap(0);
    this.hiddenUpdates = createLaneMap(null);
    this.identifierPrefix = identifierPrefix;
    this.onUncaughtError = onUncaughtError;
    this.onCaughtError = onCaughtError;
    this.onRecoverableError = onRecoverableError;
    this.pooledCache = null;
    this.pooledCacheLanes = 0;
    this.formState = formState;
    this.incompleteTransitions = /* @__PURE__ */ new Map();
  }
  function createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
    containerInfo = new FiberRootNode(
      containerInfo,
      tag2,
      hydrate,
      identifierPrefix,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      onDefaultTransitionIndicator,
      formState
    );
    tag2 = 1;
    true === isStrictMode && (tag2 |= 24);
    isStrictMode = createFiberImplClass(3, null, null, tag2);
    containerInfo.current = isStrictMode;
    isStrictMode.stateNode = containerInfo;
    tag2 = createCache();
    tag2.refCount++;
    containerInfo.pooledCache = tag2;
    tag2.refCount++;
    isStrictMode.memoizedState = {
      element: initialChildren,
      isDehydrated: hydrate,
      cache: tag2
    };
    initializeUpdateQueue(isStrictMode);
    return containerInfo;
  }
  function getContextForSubtree(parentComponent) {
    if (!parentComponent) return emptyContextObject;
    parentComponent = emptyContextObject;
    return parentComponent;
  }
  function updateContainerImpl(rootFiber, lane, element2, container, parentComponent, callback) {
    parentComponent = getContextForSubtree(parentComponent);
    null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
    container = createUpdate(lane);
    container.payload = { element: element2 };
    callback = void 0 === callback ? null : callback;
    null !== callback && (container.callback = callback);
    element2 = enqueueUpdate(rootFiber, container, lane);
    null !== element2 && (scheduleUpdateOnFiber(element2, rootFiber, lane), entangleTransitions(element2, rootFiber, lane));
  }
  function markRetryLaneImpl(fiber, retryLane) {
    fiber = fiber.memoizedState;
    if (null !== fiber && null !== fiber.dehydrated) {
      var a2 = fiber.retryLane;
      fiber.retryLane = 0 !== a2 && a2 < retryLane ? a2 : retryLane;
    }
  }
  function markRetryLaneIfNotHydrated(fiber, retryLane) {
    markRetryLaneImpl(fiber, retryLane);
    (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
  }
  function attemptContinuousHydration(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 67108864);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 67108864);
      markRetryLaneIfNotHydrated(fiber, 67108864);
    }
  }
  function attemptHydrationAtCurrentPriority(fiber) {
    if (13 === fiber.tag || 31 === fiber.tag) {
      var lane = requestUpdateLane();
      lane = getBumpedLaneForHydrationByLane(lane);
      var root3 = enqueueConcurrentRenderForLane(fiber, lane);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
      markRetryLaneIfNotHydrated(fiber, lane);
    }
  }
  var _enabled = true;
  function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 2, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
    var prevTransition = ReactSharedInternals.T;
    ReactSharedInternals.T = null;
    var previousPriority = ReactDOMSharedInternals.p;
    try {
      ReactDOMSharedInternals.p = 8, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
    } finally {
      ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
    }
  }
  function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (_enabled) {
      var blockedOn = findInstanceBlockingEvent(nativeEvent);
      if (null === blockedOn)
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          return_targetInst,
          targetContainer
        ), clearIfContinuousEvent(domEventName, nativeEvent);
      else if (queueIfContinuousEvent(
        blockedOn,
        domEventName,
        eventSystemFlags,
        targetContainer,
        nativeEvent
      ))
        nativeEvent.stopPropagation();
      else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
        for (; null !== blockedOn; ) {
          var fiber = getInstanceFromNode(blockedOn);
          if (null !== fiber)
            switch (fiber.tag) {
              case 3:
                fiber = fiber.stateNode;
                if (fiber.current.memoizedState.isDehydrated) {
                  var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                  if (0 !== lanes) {
                    var root3 = fiber;
                    root3.pendingLanes |= 2;
                    for (root3.entangledLanes |= 2; lanes; ) {
                      var lane = 1 << 31 - clz32(lanes);
                      root3.entanglements[1] |= lane;
                      lanes &= ~lane;
                    }
                    ensureRootIsScheduled(fiber);
                    0 === (executionContext & 6) && (workInProgressRootRenderTargetTime = now() + 500, flushSyncWorkAcrossRoots_impl(0));
                  }
                }
                break;
              case 31:
              case 13:
                root3 = enqueueConcurrentRenderForLane(fiber, 2), null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
            }
          fiber = findInstanceBlockingEvent(nativeEvent);
          null === fiber && dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          );
          if (fiber === blockedOn) break;
          blockedOn = fiber;
        }
        null !== blockedOn && nativeEvent.stopPropagation();
      } else
        dispatchEventForPluginEventSystem(
          domEventName,
          eventSystemFlags,
          nativeEvent,
          null,
          targetContainer
        );
    }
  }
  function findInstanceBlockingEvent(nativeEvent) {
    nativeEvent = getEventTarget(nativeEvent);
    return findInstanceBlockingTarget(nativeEvent);
  }
  var return_targetInst = null;
  function findInstanceBlockingTarget(targetNode) {
    return_targetInst = null;
    targetNode = getClosestInstanceFromNode(targetNode);
    if (null !== targetNode) {
      var nearestMounted = getNearestMountedFiber(targetNode);
      if (null === nearestMounted) targetNode = null;
      else {
        var tag2 = nearestMounted.tag;
        if (13 === tag2) {
          targetNode = getSuspenseInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (31 === tag2) {
          targetNode = getActivityInstanceFromFiber(nearestMounted);
          if (null !== targetNode) return targetNode;
          targetNode = null;
        } else if (3 === tag2) {
          if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
            return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          targetNode = null;
        } else nearestMounted !== targetNode && (targetNode = null);
      }
    }
    return_targetInst = targetNode;
    return null;
  }
  function getEventPriority(domEventName) {
    switch (domEventName) {
      case "beforetoggle":
      case "cancel":
      case "click":
      case "close":
      case "contextmenu":
      case "copy":
      case "cut":
      case "auxclick":
      case "dblclick":
      case "dragend":
      case "dragstart":
      case "drop":
      case "focusin":
      case "focusout":
      case "input":
      case "invalid":
      case "keydown":
      case "keypress":
      case "keyup":
      case "mousedown":
      case "mouseup":
      case "paste":
      case "pause":
      case "play":
      case "pointercancel":
      case "pointerdown":
      case "pointerup":
      case "ratechange":
      case "reset":
      case "resize":
      case "seeked":
      case "submit":
      case "toggle":
      case "touchcancel":
      case "touchend":
      case "touchstart":
      case "volumechange":
      case "change":
      case "selectionchange":
      case "textInput":
      case "compositionstart":
      case "compositionend":
      case "compositionupdate":
      case "beforeblur":
      case "afterblur":
      case "beforeinput":
      case "blur":
      case "fullscreenchange":
      case "focus":
      case "hashchange":
      case "popstate":
      case "select":
      case "selectstart":
        return 2;
      case "drag":
      case "dragenter":
      case "dragexit":
      case "dragleave":
      case "dragover":
      case "mousemove":
      case "mouseout":
      case "mouseover":
      case "pointermove":
      case "pointerout":
      case "pointerover":
      case "scroll":
      case "touchmove":
      case "wheel":
      case "mouseenter":
      case "mouseleave":
      case "pointerenter":
      case "pointerleave":
        return 8;
      case "message":
        switch (getCurrentPriorityLevel()) {
          case ImmediatePriority:
            return 2;
          case UserBlockingPriority:
            return 8;
          case NormalPriority$1:
          case LowPriority:
            return 32;
          case IdlePriority:
            return 268435456;
          default:
            return 32;
        }
      default:
        return 32;
    }
  }
  var hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
    " "
  );
  function clearIfContinuousEvent(domEventName, nativeEvent) {
    switch (domEventName) {
      case "focusin":
      case "focusout":
        queuedFocus = null;
        break;
      case "dragenter":
      case "dragleave":
        queuedDrag = null;
        break;
      case "mouseover":
      case "mouseout":
        queuedMouse = null;
        break;
      case "pointerover":
      case "pointerout":
        queuedPointers.delete(nativeEvent.pointerId);
        break;
      case "gotpointercapture":
      case "lostpointercapture":
        queuedPointerCaptures.delete(nativeEvent.pointerId);
    }
  }
  function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
      return existingQueuedEvent = {
        blockedOn,
        domEventName,
        eventSystemFlags,
        nativeEvent,
        targetContainers: [targetContainer]
      }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
    existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
    blockedOn = existingQueuedEvent.targetContainers;
    null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
    return existingQueuedEvent;
  }
  function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
    switch (domEventName) {
      case "focusin":
        return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedFocus,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "dragenter":
        return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedDrag,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "mouseover":
        return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
          queuedMouse,
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ), true;
      case "pointerover":
        var pointerId = nativeEvent.pointerId;
        queuedPointers.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointers.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        );
        return true;
      case "gotpointercapture":
        return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
          pointerId,
          accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedPointerCaptures.get(pointerId) || null,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          )
        ), true;
    }
    return false;
  }
  function attemptExplicitHydrationTarget(queuedTarget) {
    var targetInst = getClosestInstanceFromNode(queuedTarget.target);
    if (null !== targetInst) {
      var nearestMounted = getNearestMountedFiber(targetInst);
      if (null !== nearestMounted) {
        if (targetInst = nearestMounted.tag, 13 === targetInst) {
          if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
            return;
          }
        } else if (31 === targetInst) {
          if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
            queuedTarget.blockedOn = targetInst;
            runWithPriority(queuedTarget.priority, function() {
              attemptHydrationAtCurrentPriority(nearestMounted);
            });
            return;
          }
        } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
          queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
          return;
        }
      }
    }
    queuedTarget.blockedOn = null;
  }
  function attemptReplayContinuousQueuedEvent(queuedEvent) {
    if (null !== queuedEvent.blockedOn) return false;
    for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
      var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
      if (null === nextBlockedOn) {
        nextBlockedOn = queuedEvent.nativeEvent;
        var nativeEventClone = new nextBlockedOn.constructor(
          nextBlockedOn.type,
          nextBlockedOn
        );
        currentReplayingEvent = nativeEventClone;
        nextBlockedOn.target.dispatchEvent(nativeEventClone);
        currentReplayingEvent = null;
      } else
        return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
      targetContainers.shift();
    }
    return true;
  }
  function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map2) {
    attemptReplayContinuousQueuedEvent(queuedEvent) && map2.delete(key);
  }
  function replayUnblockedEvents() {
    hasScheduledReplayAttempt = false;
    null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
    null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
    null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
    queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
    queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
  }
  function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
    queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler2.unstable_scheduleCallback(
      Scheduler2.unstable_NormalPriority,
      replayUnblockedEvents
    )));
  }
  var lastScheduledReplayQueue = null;
  function scheduleReplayQueueIfNeeded(formReplayingQueue) {
    lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler2.unstable_scheduleCallback(
      Scheduler2.unstable_NormalPriority,
      function() {
        lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
        for (var i2 = 0; i2 < formReplayingQueue.length; i2 += 3) {
          var form = formReplayingQueue[i2], submitterOrAction = formReplayingQueue[i2 + 1], formData = formReplayingQueue[i2 + 2];
          if ("function" !== typeof submitterOrAction)
            if (null === findInstanceBlockingTarget(submitterOrAction || form))
              continue;
            else break;
          var formInst = getInstanceFromNode(form);
          null !== formInst && (formReplayingQueue.splice(i2, 3), i2 -= 3, startHostTransition(
            formInst,
            {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            },
            submitterOrAction,
            formData
          ));
        }
      }
    ));
  }
  function retryIfBlockedOn(unblocked) {
    function unblock(queuedEvent) {
      return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
    }
    null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
    null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
    null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
    queuedPointers.forEach(unblock);
    queuedPointerCaptures.forEach(unblock);
    for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length; i2++) {
      var queuedTarget = queuedExplicitHydrationTargets[i2];
      queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
    }
    for (; 0 < queuedExplicitHydrationTargets.length && (i2 = queuedExplicitHydrationTargets[0], null === i2.blockedOn); )
      attemptExplicitHydrationTarget(i2), null === i2.blockedOn && queuedExplicitHydrationTargets.shift();
    i2 = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
    if (null != i2)
      for (queuedTarget = 0; queuedTarget < i2.length; queuedTarget += 3) {
        var form = i2[queuedTarget], submitterOrAction = i2[queuedTarget + 1], formProps = form[internalPropsKey] || null;
        if ("function" === typeof submitterOrAction)
          formProps || scheduleReplayQueueIfNeeded(i2);
        else if (formProps) {
          var action = null;
          if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
            if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
              action = formProps.formAction;
            else {
              if (null !== findInstanceBlockingTarget(form)) continue;
            }
          else action = formProps.action;
          "function" === typeof action ? i2[queuedTarget + 1] = action : (i2.splice(queuedTarget, 3), queuedTarget -= 3);
          scheduleReplayQueueIfNeeded(i2);
        }
      }
  }
  function defaultOnDefaultTransitionIndicator() {
    function handleNavigate(event) {
      event.canIntercept && "react-transition" === event.info && event.intercept({
        handler: function() {
          return new Promise(function(resolve) {
            return pendingResolve = resolve;
          });
        },
        focusReset: "manual",
        scroll: "manual"
      });
    }
    function handleNavigateComplete() {
      null !== pendingResolve && (pendingResolve(), pendingResolve = null);
      isCancelled || setTimeout(startFakeNavigation, 20);
    }
    function startFakeNavigation() {
      if (!isCancelled && !navigation.transition) {
        var currentEntry = navigation.currentEntry;
        currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
          state: currentEntry.getState(),
          info: "react-transition",
          history: "replace"
        });
      }
    }
    if ("object" === typeof navigation) {
      var isCancelled = false, pendingResolve = null;
      navigation.addEventListener("navigate", handleNavigate);
      navigation.addEventListener("navigatesuccess", handleNavigateComplete);
      navigation.addEventListener("navigateerror", handleNavigateComplete);
      setTimeout(startFakeNavigation, 100);
      return function() {
        isCancelled = true;
        navigation.removeEventListener("navigate", handleNavigate);
        navigation.removeEventListener("navigatesuccess", handleNavigateComplete);
        navigation.removeEventListener("navigateerror", handleNavigateComplete);
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
      };
    }
  }
  function ReactDOMRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
    var root3 = this._internalRoot;
    if (null === root3) throw Error(formatProdErrorMessage2(409));
    var current2 = root3.current, lane = requestUpdateLane();
    updateContainerImpl(current2, lane, children, root3, null, null);
  };
  ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
    var root3 = this._internalRoot;
    if (null !== root3) {
      this._internalRoot = null;
      var container = root3.containerInfo;
      updateContainerImpl(root3.current, 2, null, root3, null, null);
      flushSyncWork$1();
      container[internalContainerInstanceKey] = null;
    }
  };
  function ReactDOMHydrationRoot(internalRoot) {
    this._internalRoot = internalRoot;
  }
  ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
    if (target) {
      var updatePriority = resolveUpdatePriority();
      target = { blockedOn: null, target, priority: updatePriority };
      for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i2].priority; i2++) ;
      queuedExplicitHydrationTargets.splice(i2, 0, target);
      0 === i2 && attemptExplicitHydrationTarget(target);
    }
  };
  var isomorphicReactPackageVersion$jscomp$inline_1840 = React2.version;
  if ("19.2.7" !== isomorphicReactPackageVersion$jscomp$inline_1840)
    throw Error(
      formatProdErrorMessage2(
        527,
        isomorphicReactPackageVersion$jscomp$inline_1840,
        "19.2.7"
      )
    );
  ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
    var fiber = componentOrElement._reactInternals;
    if (void 0 === fiber) {
      if ("function" === typeof componentOrElement.render)
        throw Error(formatProdErrorMessage2(188));
      componentOrElement = Object.keys(componentOrElement).join(",");
      throw Error(formatProdErrorMessage2(268, componentOrElement));
    }
    componentOrElement = findCurrentFiberUsingSlowPath(fiber);
    componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
    componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
    return componentOrElement;
  };
  var internals$jscomp$inline_2347 = {
    bundleType: 0,
    version: "19.2.7",
    rendererPackageName: "react-dom",
    currentDispatcherRef: ReactSharedInternals,
    reconcilerVersion: "19.2.7"
  };
  if ("undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) {
    var hook$jscomp$inline_2348 = __REACT_DEVTOOLS_GLOBAL_HOOK__;
    if (!hook$jscomp$inline_2348.isDisabled && hook$jscomp$inline_2348.supportsFiber)
      try {
        rendererID = hook$jscomp$inline_2348.inject(
          internals$jscomp$inline_2347
        ), injectedHook = hook$jscomp$inline_2348;
      } catch (err) {
      }
  }
  reactDomClient_production.createRoot = function(container, options3) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage2(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
    null !== options3 && void 0 !== options3 && (true === options3.unstable_strictMode && (isStrictMode = true), void 0 !== options3.identifierPrefix && (identifierPrefix = options3.identifierPrefix), void 0 !== options3.onUncaughtError && (onUncaughtError = options3.onUncaughtError), void 0 !== options3.onCaughtError && (onCaughtError = options3.onCaughtError), void 0 !== options3.onRecoverableError && (onRecoverableError = options3.onRecoverableError));
    options3 = createFiberRoot(
      container,
      1,
      false,
      null,
      null,
      isStrictMode,
      identifierPrefix,
      null,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      defaultOnDefaultTransitionIndicator
    );
    container[internalContainerInstanceKey] = options3.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMRoot(options3);
  };
  reactDomClient_production.hydrateRoot = function(container, initialChildren, options3) {
    if (!isValidContainer(container)) throw Error(formatProdErrorMessage2(299));
    var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
    null !== options3 && void 0 !== options3 && (true === options3.unstable_strictMode && (isStrictMode = true), void 0 !== options3.identifierPrefix && (identifierPrefix = options3.identifierPrefix), void 0 !== options3.onUncaughtError && (onUncaughtError = options3.onUncaughtError), void 0 !== options3.onCaughtError && (onCaughtError = options3.onCaughtError), void 0 !== options3.onRecoverableError && (onRecoverableError = options3.onRecoverableError), void 0 !== options3.formState && (formState = options3.formState));
    initialChildren = createFiberRoot(
      container,
      1,
      true,
      initialChildren,
      null != options3 ? options3 : null,
      isStrictMode,
      identifierPrefix,
      formState,
      onUncaughtError,
      onCaughtError,
      onRecoverableError,
      defaultOnDefaultTransitionIndicator
    );
    initialChildren.context = getContextForSubtree(null);
    options3 = initialChildren.current;
    isStrictMode = requestUpdateLane();
    isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
    identifierPrefix = createUpdate(isStrictMode);
    identifierPrefix.callback = null;
    enqueueUpdate(options3, identifierPrefix, isStrictMode);
    options3 = isStrictMode;
    initialChildren.current.lanes = options3;
    markRootUpdated$1(initialChildren, options3);
    ensureRootIsScheduled(initialChildren);
    container[internalContainerInstanceKey] = initialChildren.current;
    listenToAllSupportedEvents(container);
    return new ReactDOMHydrationRoot(initialChildren);
  };
  reactDomClient_production.version = "19.2.7";
  return reactDomClient_production;
}
var reactDomClient_development = {};
var hasRequiredReactDomClient_development;
function requireReactDomClient_development() {
  if (hasRequiredReactDomClient_development) return reactDomClient_development;
  hasRequiredReactDomClient_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function findHook(fiber, id2) {
      for (fiber = fiber.memoizedState; null !== fiber && 0 < id2; )
        fiber = fiber.next, id2--;
      return fiber;
    }
    function copyWithSetImpl(obj, path, index2, value) {
      if (index2 >= path.length) return value;
      var key = path[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      updated[key] = copyWithSetImpl(obj[key], path, index2 + 1, value);
      return updated;
    }
    function copyWithRename(obj, oldPath, newPath) {
      if (oldPath.length !== newPath.length)
        console.warn("copyWithRename() expects paths of the same length");
      else {
        for (var i2 = 0; i2 < newPath.length - 1; i2++)
          if (oldPath[i2] !== newPath[i2]) {
            console.warn(
              "copyWithRename() expects paths to be the same except for the deepest key"
            );
            return;
          }
        return copyWithRenameImpl(obj, oldPath, newPath, 0);
      }
    }
    function copyWithRenameImpl(obj, oldPath, newPath, index2) {
      var oldKey = oldPath[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      index2 + 1 === oldPath.length ? (updated[newPath[index2]] = updated[oldKey], isArrayImpl(updated) ? updated.splice(oldKey, 1) : delete updated[oldKey]) : updated[oldKey] = copyWithRenameImpl(
        obj[oldKey],
        oldPath,
        newPath,
        index2 + 1
      );
      return updated;
    }
    function copyWithDeleteImpl(obj, path, index2) {
      var key = path[index2], updated = isArrayImpl(obj) ? obj.slice() : assign2({}, obj);
      if (index2 + 1 === path.length)
        return isArrayImpl(updated) ? updated.splice(key, 1) : delete updated[key], updated;
      updated[key] = copyWithDeleteImpl(obj[key], path, index2 + 1);
      return updated;
    }
    function shouldSuspendImpl() {
      return false;
    }
    function shouldErrorImpl() {
      return null;
    }
    function warnInvalidHookAccess() {
      console.error(
        "Do not call Hooks inside useEffect(...), useMemo(...), or other built-in Hooks. You can only call Hooks at the top level of your React function. For more information, see https://react.dev/link/rules-of-hooks"
      );
    }
    function warnInvalidContextAccess() {
      console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
    }
    function noop2() {
    }
    function warnForMissingKey() {
    }
    function setToSortedString(set2) {
      var array = [];
      set2.forEach(function(value) {
        array.push(value);
      });
      return array.sort().join(", ");
    }
    function createFiber(tag2, pendingProps, key, mode) {
      return new FiberNode(tag2, pendingProps, key, mode);
    }
    function scheduleRoot(root3, element2) {
      root3.context === emptyContextObject && (updateContainerImpl(root3.current, 2, element2, root3, null, null), flushSyncWork$1());
    }
    function scheduleRefresh(root3, update) {
      if (null !== resolveFamily) {
        var staleFamilies = update.staleFamilies;
        update = update.updatedFamilies;
        flushPendingEffects();
        scheduleFibersWithFamiliesRecursively(
          root3.current,
          update,
          staleFamilies
        );
        flushSyncWork$1();
      }
    }
    function setRefreshHandler(handler) {
      resolveFamily = handler;
    }
    function isValidContainer(node) {
      return !(!node || 1 !== node.nodeType && 9 !== node.nodeType && 11 !== node.nodeType);
    }
    function getNearestMountedFiber(fiber) {
      var node = fiber, nearestMounted = fiber;
      if (fiber.alternate) for (; node.return; ) node = node.return;
      else {
        fiber = node;
        do
          node = fiber, 0 !== (node.flags & 4098) && (nearestMounted = node.return), fiber = node.return;
        while (fiber);
      }
      return 3 === node.tag ? nearestMounted : null;
    }
    function getSuspenseInstanceFromFiber(fiber) {
      if (13 === fiber.tag) {
        var suspenseState = fiber.memoizedState;
        null === suspenseState && (fiber = fiber.alternate, null !== fiber && (suspenseState = fiber.memoizedState));
        if (null !== suspenseState) return suspenseState.dehydrated;
      }
      return null;
    }
    function getActivityInstanceFromFiber(fiber) {
      if (31 === fiber.tag) {
        var activityState = fiber.memoizedState;
        null === activityState && (fiber = fiber.alternate, null !== fiber && (activityState = fiber.memoizedState));
        if (null !== activityState) return activityState.dehydrated;
      }
      return null;
    }
    function assertIsMounted(fiber) {
      if (getNearestMountedFiber(fiber) !== fiber)
        throw Error("Unable to find node on an unmounted component.");
    }
    function findCurrentFiberUsingSlowPath(fiber) {
      var alternate = fiber.alternate;
      if (!alternate) {
        alternate = getNearestMountedFiber(fiber);
        if (null === alternate)
          throw Error("Unable to find node on an unmounted component.");
        return alternate !== fiber ? null : fiber;
      }
      for (var a2 = fiber, b2 = alternate; ; ) {
        var parentA = a2.return;
        if (null === parentA) break;
        var parentB = parentA.alternate;
        if (null === parentB) {
          b2 = parentA.return;
          if (null !== b2) {
            a2 = b2;
            continue;
          }
          break;
        }
        if (parentA.child === parentB.child) {
          for (parentB = parentA.child; parentB; ) {
            if (parentB === a2) return assertIsMounted(parentA), fiber;
            if (parentB === b2) return assertIsMounted(parentA), alternate;
            parentB = parentB.sibling;
          }
          throw Error("Unable to find node on an unmounted component.");
        }
        if (a2.return !== b2.return) a2 = parentA, b2 = parentB;
        else {
          for (var didFindChild = false, _child = parentA.child; _child; ) {
            if (_child === a2) {
              didFindChild = true;
              a2 = parentA;
              b2 = parentB;
              break;
            }
            if (_child === b2) {
              didFindChild = true;
              b2 = parentA;
              a2 = parentB;
              break;
            }
            _child = _child.sibling;
          }
          if (!didFindChild) {
            for (_child = parentB.child; _child; ) {
              if (_child === a2) {
                didFindChild = true;
                a2 = parentB;
                b2 = parentA;
                break;
              }
              if (_child === b2) {
                didFindChild = true;
                b2 = parentB;
                a2 = parentA;
                break;
              }
              _child = _child.sibling;
            }
            if (!didFindChild)
              throw Error(
                "Child was not found in either parent set. This indicates a bug in React related to the return pointer. Please file an issue."
              );
          }
        }
        if (a2.alternate !== b2)
          throw Error(
            "Return fibers should always be each others' alternates. This error is likely caused by a bug in React. Please file an issue."
          );
      }
      if (3 !== a2.tag)
        throw Error("Unable to find node on an unmounted component.");
      return a2.stateNode.current === a2 ? fiber : alternate;
    }
    function findCurrentHostFiberImpl(node) {
      var tag2 = node.tag;
      if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2) return node;
      for (node = node.child; null !== node; ) {
        tag2 = findCurrentHostFiberImpl(node);
        if (null !== tag2) return tag2;
        node = node.sibling;
      }
      return null;
    }
    function getIteratorFn(maybeIterable) {
      if (null === maybeIterable || "object" !== typeof maybeIterable)
        return null;
      maybeIterable = MAYBE_ITERATOR_SYMBOL && maybeIterable[MAYBE_ITERATOR_SYMBOL] || maybeIterable["@@iterator"];
      return "function" === typeof maybeIterable ? maybeIterable : null;
    }
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function getComponentNameFromOwner(owner) {
      return "number" === typeof owner.tag ? getComponentNameFromFiber(owner) : "string" === typeof owner.name ? owner.name : null;
    }
    function getComponentNameFromFiber(fiber) {
      var type = fiber.type;
      switch (fiber.tag) {
        case 31:
          return "Activity";
        case 24:
          return "Cache";
        case 9:
          return (type._context.displayName || "Context") + ".Consumer";
        case 10:
          return type.displayName || "Context";
        case 18:
          return "DehydratedFragment";
        case 11:
          return fiber = type.render, fiber = fiber.displayName || fiber.name || "", type.displayName || ("" !== fiber ? "ForwardRef(" + fiber + ")" : "ForwardRef");
        case 7:
          return "Fragment";
        case 26:
        case 27:
        case 5:
          return type;
        case 4:
          return "Portal";
        case 3:
          return "Root";
        case 6:
          return "Text";
        case 16:
          return getComponentNameFromType(type);
        case 8:
          return type === REACT_STRICT_MODE_TYPE ? "StrictMode" : "Mode";
        case 22:
          return "Offscreen";
        case 12:
          return "Profiler";
        case 21:
          return "Scope";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 25:
          return "TracingMarker";
        case 1:
        case 0:
        case 14:
        case 15:
          if ("function" === typeof type)
            return type.displayName || type.name || null;
          if ("string" === typeof type) return type;
          break;
        case 29:
          type = fiber._debugInfo;
          if (null != type) {
            for (var i2 = type.length - 1; 0 <= i2; i2--)
              if ("string" === typeof type[i2].name) return type[i2].name;
          }
          if (null !== fiber.return)
            return getComponentNameFromFiber(fiber.return);
      }
      return null;
    }
    function createCursor(defaultValue2) {
      return { current: defaultValue2 };
    }
    function pop(cursor2, fiber) {
      0 > index$jscomp$0 ? console.error("Unexpected pop.") : (fiber !== fiberStack[index$jscomp$0] && console.error("Unexpected Fiber popped."), cursor2.current = valueStack[index$jscomp$0], valueStack[index$jscomp$0] = null, fiberStack[index$jscomp$0] = null, index$jscomp$0--);
    }
    function push2(cursor2, value, fiber) {
      index$jscomp$0++;
      valueStack[index$jscomp$0] = cursor2.current;
      fiberStack[index$jscomp$0] = fiber;
      cursor2.current = value;
    }
    function requiredContext(c2) {
      null === c2 && console.error(
        "Expected host context to exist. This error is likely caused by a bug in React. Please file an issue."
      );
      return c2;
    }
    function pushHostContainer(fiber, nextRootInstance) {
      push2(rootInstanceStackCursor, nextRootInstance, fiber);
      push2(contextFiberStackCursor, fiber, fiber);
      push2(contextStackCursor, null, fiber);
      var nextRootContext = nextRootInstance.nodeType;
      switch (nextRootContext) {
        case 9:
        case 11:
          nextRootContext = 9 === nextRootContext ? "#document" : "#fragment";
          nextRootInstance = (nextRootInstance = nextRootInstance.documentElement) ? (nextRootInstance = nextRootInstance.namespaceURI) ? getOwnHostContext(nextRootInstance) : HostContextNamespaceNone : HostContextNamespaceNone;
          break;
        default:
          if (nextRootContext = nextRootInstance.tagName, nextRootInstance = nextRootInstance.namespaceURI)
            nextRootInstance = getOwnHostContext(nextRootInstance), nextRootInstance = getChildHostContextProd(
              nextRootInstance,
              nextRootContext
            );
          else
            switch (nextRootContext) {
              case "svg":
                nextRootInstance = HostContextNamespaceSvg;
                break;
              case "math":
                nextRootInstance = HostContextNamespaceMath;
                break;
              default:
                nextRootInstance = HostContextNamespaceNone;
            }
      }
      nextRootContext = nextRootContext.toLowerCase();
      nextRootContext = updatedAncestorInfoDev(null, nextRootContext);
      nextRootContext = {
        context: nextRootInstance,
        ancestorInfo: nextRootContext
      };
      pop(contextStackCursor, fiber);
      push2(contextStackCursor, nextRootContext, fiber);
    }
    function popHostContainer(fiber) {
      pop(contextStackCursor, fiber);
      pop(contextFiberStackCursor, fiber);
      pop(rootInstanceStackCursor, fiber);
    }
    function getHostContext() {
      return requiredContext(contextStackCursor.current);
    }
    function pushHostContext(fiber) {
      null !== fiber.memoizedState && push2(hostTransitionProviderCursor, fiber, fiber);
      var context = requiredContext(contextStackCursor.current);
      var type = fiber.type;
      var nextContext = getChildHostContextProd(context.context, type);
      type = updatedAncestorInfoDev(context.ancestorInfo, type);
      nextContext = { context: nextContext, ancestorInfo: type };
      context !== nextContext && (push2(contextFiberStackCursor, fiber, fiber), push2(contextStackCursor, nextContext, fiber));
    }
    function popHostContext(fiber) {
      contextFiberStackCursor.current === fiber && (pop(contextStackCursor, fiber), pop(contextFiberStackCursor, fiber));
      hostTransitionProviderCursor.current === fiber && (pop(hostTransitionProviderCursor, fiber), HostTransitionContext._currentValue = NotPendingTransition);
    }
    function disabledLog() {
    }
    function disableLogs() {
      if (0 === disabledDepth) {
        prevLog = console.log;
        prevInfo = console.info;
        prevWarn = console.warn;
        prevError = console.error;
        prevGroup = console.group;
        prevGroupCollapsed = console.groupCollapsed;
        prevGroupEnd = console.groupEnd;
        var props2 = {
          configurable: true,
          enumerable: true,
          value: disabledLog,
          writable: true
        };
        Object.defineProperties(console, {
          info: props2,
          log: props2,
          warn: props2,
          error: props2,
          group: props2,
          groupCollapsed: props2,
          groupEnd: props2
        });
      }
      disabledDepth++;
    }
    function reenableLogs() {
      disabledDepth--;
      if (0 === disabledDepth) {
        var props2 = { configurable: true, enumerable: true, writable: true };
        Object.defineProperties(console, {
          log: assign2({}, props2, { value: prevLog }),
          info: assign2({}, props2, { value: prevInfo }),
          warn: assign2({}, props2, { value: prevWarn }),
          error: assign2({}, props2, { value: prevError }),
          group: assign2({}, props2, { value: prevGroup }),
          groupCollapsed: assign2({}, props2, { value: prevGroupCollapsed }),
          groupEnd: assign2({}, props2, { value: prevGroupEnd })
        });
      }
      0 > disabledDepth && console.error(
        "disabledDepth fell below zero. This is a bug in React. Please file an issue."
      );
    }
    function formatOwnerStack(error) {
      var prevPrepareStackTrace = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      error = error.stack;
      Error.prepareStackTrace = prevPrepareStackTrace;
      error.startsWith("Error: react-stack-top-frame\n") && (error = error.slice(29));
      prevPrepareStackTrace = error.indexOf("\n");
      -1 !== prevPrepareStackTrace && (error = error.slice(prevPrepareStackTrace + 1));
      prevPrepareStackTrace = error.indexOf("react_stack_bottom_frame");
      -1 !== prevPrepareStackTrace && (prevPrepareStackTrace = error.lastIndexOf(
        "\n",
        prevPrepareStackTrace
      ));
      if (-1 !== prevPrepareStackTrace)
        error = error.slice(0, prevPrepareStackTrace);
      else return "";
      return error;
    }
    function describeBuiltInComponentFrame(name2) {
      if (void 0 === prefix)
        try {
          throw Error();
        } catch (x2) {
          var match2 = x2.stack.trim().match(/\n( *(at )?)/);
          prefix = match2 && match2[1] || "";
          suffix = -1 < x2.stack.indexOf("\n    at") ? " (<anonymous>)" : -1 < x2.stack.indexOf("@") ? "@unknown:0:0" : "";
        }
      return "\n" + prefix + name2 + suffix;
    }
    function describeNativeComponentFrame(fn2, construct) {
      if (!fn2 || reentry) return "";
      var frame = componentFrameCache.get(fn2);
      if (void 0 !== frame) return frame;
      reentry = true;
      frame = Error.prepareStackTrace;
      Error.prepareStackTrace = void 0;
      var previousDispatcher2 = null;
      previousDispatcher2 = ReactSharedInternals.H;
      ReactSharedInternals.H = null;
      disableLogs();
      try {
        var RunInRootFrame = {
          DetermineComponentFrameRoot: function() {
            try {
              if (construct) {
                var Fake = function() {
                  throw Error();
                };
                Object.defineProperty(Fake.prototype, "props", {
                  set: function() {
                    throw Error();
                  }
                });
                if ("object" === typeof Reflect && Reflect.construct) {
                  try {
                    Reflect.construct(Fake, []);
                  } catch (x2) {
                    var control = x2;
                  }
                  Reflect.construct(fn2, [], Fake);
                } else {
                  try {
                    Fake.call();
                  } catch (x$0) {
                    control = x$0;
                  }
                  fn2.call(Fake.prototype);
                }
              } else {
                try {
                  throw Error();
                } catch (x$12) {
                  control = x$12;
                }
                (Fake = fn2()) && "function" === typeof Fake.catch && Fake.catch(function() {
                });
              }
            } catch (sample2) {
              if (sample2 && control && "string" === typeof sample2.stack)
                return [sample2.stack, control.stack];
            }
            return [null, null];
          }
        };
        RunInRootFrame.DetermineComponentFrameRoot.displayName = "DetermineComponentFrameRoot";
        var namePropDescriptor = Object.getOwnPropertyDescriptor(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name"
        );
        namePropDescriptor && namePropDescriptor.configurable && Object.defineProperty(
          RunInRootFrame.DetermineComponentFrameRoot,
          "name",
          { value: "DetermineComponentFrameRoot" }
        );
        var _RunInRootFrame$Deter = RunInRootFrame.DetermineComponentFrameRoot(), sampleStack = _RunInRootFrame$Deter[0], controlStack = _RunInRootFrame$Deter[1];
        if (sampleStack && controlStack) {
          var sampleLines = sampleStack.split("\n"), controlLines = controlStack.split("\n");
          for (_RunInRootFrame$Deter = namePropDescriptor = 0; namePropDescriptor < sampleLines.length && !sampleLines[namePropDescriptor].includes(
            "DetermineComponentFrameRoot"
          ); )
            namePropDescriptor++;
          for (; _RunInRootFrame$Deter < controlLines.length && !controlLines[_RunInRootFrame$Deter].includes(
            "DetermineComponentFrameRoot"
          ); )
            _RunInRootFrame$Deter++;
          if (namePropDescriptor === sampleLines.length || _RunInRootFrame$Deter === controlLines.length)
            for (namePropDescriptor = sampleLines.length - 1, _RunInRootFrame$Deter = controlLines.length - 1; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter && sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]; )
              _RunInRootFrame$Deter--;
          for (; 1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter; namePropDescriptor--, _RunInRootFrame$Deter--)
            if (sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
              if (1 !== namePropDescriptor || 1 !== _RunInRootFrame$Deter) {
                do
                  if (namePropDescriptor--, _RunInRootFrame$Deter--, 0 > _RunInRootFrame$Deter || sampleLines[namePropDescriptor] !== controlLines[_RunInRootFrame$Deter]) {
                    var _frame = "\n" + sampleLines[namePropDescriptor].replace(
                      " at new ",
                      " at "
                    );
                    fn2.displayName && _frame.includes("<anonymous>") && (_frame = _frame.replace("<anonymous>", fn2.displayName));
                    "function" === typeof fn2 && componentFrameCache.set(fn2, _frame);
                    return _frame;
                  }
                while (1 <= namePropDescriptor && 0 <= _RunInRootFrame$Deter);
              }
              break;
            }
        }
      } finally {
        reentry = false, ReactSharedInternals.H = previousDispatcher2, reenableLogs(), Error.prepareStackTrace = frame;
      }
      sampleLines = (sampleLines = fn2 ? fn2.displayName || fn2.name : "") ? describeBuiltInComponentFrame(sampleLines) : "";
      "function" === typeof fn2 && componentFrameCache.set(fn2, sampleLines);
      return sampleLines;
    }
    function describeFiber(fiber, childFiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return describeBuiltInComponentFrame(fiber.type);
        case 16:
          return describeBuiltInComponentFrame("Lazy");
        case 13:
          return fiber.child !== childFiber && null !== childFiber ? describeBuiltInComponentFrame("Suspense Fallback") : describeBuiltInComponentFrame("Suspense");
        case 19:
          return describeBuiltInComponentFrame("SuspenseList");
        case 0:
        case 15:
          return describeNativeComponentFrame(fiber.type, false);
        case 11:
          return describeNativeComponentFrame(fiber.type.render, false);
        case 1:
          return describeNativeComponentFrame(fiber.type, true);
        case 31:
          return describeBuiltInComponentFrame("Activity");
        default:
          return "";
      }
    }
    function getStackByFiberInDevAndProd(workInProgress2) {
      try {
        var info = "", previous2 = null;
        do {
          info += describeFiber(workInProgress2, previous2);
          var debugInfo = workInProgress2._debugInfo;
          if (debugInfo)
            for (var i2 = debugInfo.length - 1; 0 <= i2; i2--) {
              var entry = debugInfo[i2];
              if ("string" === typeof entry.name) {
                var JSCompiler_temp_const = info;
                a: {
                  var name2 = entry.name, env = entry.env, location = entry.debugLocation;
                  if (null != location) {
                    var childStack = formatOwnerStack(location), idx = childStack.lastIndexOf("\n"), lastLine = -1 === idx ? childStack : childStack.slice(idx + 1);
                    if (-1 !== lastLine.indexOf(name2)) {
                      var JSCompiler_inline_result = "\n" + lastLine;
                      break a;
                    }
                  }
                  JSCompiler_inline_result = describeBuiltInComponentFrame(
                    name2 + (env ? " [" + env + "]" : "")
                  );
                }
                info = JSCompiler_temp_const + JSCompiler_inline_result;
              }
            }
          previous2 = workInProgress2;
          workInProgress2 = workInProgress2.return;
        } while (workInProgress2);
        return info;
      } catch (x2) {
        return "\nError generating stack: " + x2.message + "\n" + x2.stack;
      }
    }
    function describeFunctionComponentFrameWithoutLineNumber(fn2) {
      return (fn2 = fn2 ? fn2.displayName || fn2.name : "") ? describeBuiltInComponentFrame(fn2) : "";
    }
    function getCurrentFiberOwnerNameInDevOrNull() {
      if (null === current2) return null;
      var owner = current2._debugOwner;
      return null != owner ? getComponentNameFromOwner(owner) : null;
    }
    function getCurrentFiberStackInDev() {
      if (null === current2) return "";
      var workInProgress2 = current2;
      try {
        var info = "";
        6 === workInProgress2.tag && (workInProgress2 = workInProgress2.return);
        switch (workInProgress2.tag) {
          case 26:
          case 27:
          case 5:
            info += describeBuiltInComponentFrame(workInProgress2.type);
            break;
          case 13:
            info += describeBuiltInComponentFrame("Suspense");
            break;
          case 19:
            info += describeBuiltInComponentFrame("SuspenseList");
            break;
          case 31:
            info += describeBuiltInComponentFrame("Activity");
            break;
          case 30:
          case 0:
          case 15:
          case 1:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type
            ));
            break;
          case 11:
            workInProgress2._debugOwner || "" !== info || (info += describeFunctionComponentFrameWithoutLineNumber(
              workInProgress2.type.render
            ));
        }
        for (; workInProgress2; )
          if ("number" === typeof workInProgress2.tag) {
            var fiber = workInProgress2;
            workInProgress2 = fiber._debugOwner;
            var debugStack = fiber._debugStack;
            if (workInProgress2 && debugStack) {
              var formattedStack = formatOwnerStack(debugStack);
              "" !== formattedStack && (info += "\n" + formattedStack);
            }
          } else if (null != workInProgress2.debugStack) {
            var ownerStack = workInProgress2.debugStack;
            (workInProgress2 = workInProgress2.owner) && ownerStack && (info += "\n" + formatOwnerStack(ownerStack));
          } else break;
        var JSCompiler_inline_result = info;
      } catch (x2) {
        JSCompiler_inline_result = "\nError generating stack: " + x2.message + "\n" + x2.stack;
      }
      return JSCompiler_inline_result;
    }
    function runWithFiberInDEV(fiber, callback, arg0, arg1, arg2, arg3, arg4) {
      var previousFiber = current2;
      setCurrentFiber(fiber);
      try {
        return null !== fiber && fiber._debugTask ? fiber._debugTask.run(
          callback.bind(null, arg0, arg1, arg2, arg3, arg4)
        ) : callback(arg0, arg1, arg2, arg3, arg4);
      } finally {
        setCurrentFiber(previousFiber);
      }
      throw Error(
        "runWithFiberInDEV should never be called in production. This is a bug in React."
      );
    }
    function setCurrentFiber(fiber) {
      ReactSharedInternals.getCurrentStack = null === fiber ? null : getCurrentFiberStackInDev;
      isRendering = false;
      current2 = fiber;
    }
    function typeName2(value) {
      return "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
    }
    function willCoercionThrow(value) {
      try {
        return testStringCoercion(value), false;
      } catch (e2) {
        return true;
      }
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkAttributeStringCoercion(value, attributeName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` attribute is an unsupported type %s. This value must be coerced to a string before using it here.",
          attributeName,
          typeName2(value)
        ), testStringCoercion(value);
    }
    function checkCSSPropertyStringCoercion(value, propName) {
      if (willCoercionThrow(value))
        return console.error(
          "The provided `%s` CSS property is an unsupported type %s. This value must be coerced to a string before using it here.",
          propName,
          typeName2(value)
        ), testStringCoercion(value);
    }
    function checkFormFieldValueStringCoercion(value) {
      if (willCoercionThrow(value))
        return console.error(
          "Form field values (value, checked, defaultValue, or defaultChecked props) must be strings, not %s. This value must be coerced to a string before using it here.",
          typeName2(value)
        ), testStringCoercion(value);
    }
    function injectInternals(internals) {
      if ("undefined" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__) return false;
      var hook = __REACT_DEVTOOLS_GLOBAL_HOOK__;
      if (hook.isDisabled) return true;
      if (!hook.supportsFiber)
        return console.error(
          "The installed version of React DevTools is too old and will not work with the current version of React. Please update React DevTools. https://react.dev/link/react-devtools"
        ), true;
      try {
        rendererID = hook.inject(internals), injectedHook = hook;
      } catch (err) {
        console.error("React instrumentation encountered an error: %o.", err);
      }
      return hook.checkDCE ? true : false;
    }
    function setIsStrictModeForDevtools(newIsStrictMode) {
      "function" === typeof log$12 && unstable_setDisableYieldValue(newIsStrictMode);
      if (injectedHook && "function" === typeof injectedHook.setStrictMode)
        try {
          injectedHook.setStrictMode(rendererID, newIsStrictMode);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
    }
    function clz32Fallback(x2) {
      x2 >>>= 0;
      return 0 === x2 ? 32 : 31 - (log3(x2) / LN2 | 0) | 0;
    }
    function getHighestPriorityLanes(lanes) {
      var pendingSyncLanes = lanes & 42;
      if (0 !== pendingSyncLanes) return pendingSyncLanes;
      switch (lanes & -lanes) {
        case 1:
          return 1;
        case 2:
          return 2;
        case 4:
          return 4;
        case 8:
          return 8;
        case 16:
          return 16;
        case 32:
          return 32;
        case 64:
          return 64;
        case 128:
          return 128;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
          return lanes & 261888;
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return lanes & 3932160;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return lanes & 62914560;
        case 67108864:
          return 67108864;
        case 134217728:
          return 134217728;
        case 268435456:
          return 268435456;
        case 536870912:
          return 536870912;
        case 1073741824:
          return 0;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), lanes;
      }
    }
    function getNextLanes(root3, wipLanes, rootHasPendingCommit) {
      var pendingLanes = root3.pendingLanes;
      if (0 === pendingLanes) return 0;
      var nextLanes = 0, suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
      root3 = root3.warmLanes;
      var nonIdlePendingLanes = pendingLanes & 134217727;
      0 !== nonIdlePendingLanes ? (pendingLanes = nonIdlePendingLanes & ~suspendedLanes, 0 !== pendingLanes ? nextLanes = getHighestPriorityLanes(pendingLanes) : (pingedLanes &= nonIdlePendingLanes, 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = nonIdlePendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))))) : (nonIdlePendingLanes = pendingLanes & ~suspendedLanes, 0 !== nonIdlePendingLanes ? nextLanes = getHighestPriorityLanes(nonIdlePendingLanes) : 0 !== pingedLanes ? nextLanes = getHighestPriorityLanes(pingedLanes) : rootHasPendingCommit || (rootHasPendingCommit = pendingLanes & ~root3, 0 !== rootHasPendingCommit && (nextLanes = getHighestPriorityLanes(rootHasPendingCommit))));
      return 0 === nextLanes ? 0 : 0 !== wipLanes && wipLanes !== nextLanes && 0 === (wipLanes & suspendedLanes) && (suspendedLanes = nextLanes & -nextLanes, rootHasPendingCommit = wipLanes & -wipLanes, suspendedLanes >= rootHasPendingCommit || 32 === suspendedLanes && 0 !== (rootHasPendingCommit & 4194048)) ? wipLanes : nextLanes;
    }
    function checkIfRootIsPrerendering(root3, renderLanes2) {
      return 0 === (root3.pendingLanes & ~(root3.suspendedLanes & ~root3.pingedLanes) & renderLanes2);
    }
    function computeExpirationTime(lane, currentTime) {
      switch (lane) {
        case 1:
        case 2:
        case 4:
        case 8:
        case 64:
          return currentTime + 250;
        case 16:
        case 32:
        case 128:
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
          return currentTime + 5e3;
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          return -1;
        case 67108864:
        case 134217728:
        case 268435456:
        case 536870912:
        case 1073741824:
          return -1;
        default:
          return console.error(
            "Should have found matching lanes. This is a bug in React."
          ), -1;
      }
    }
    function claimNextRetryLane() {
      var lane = nextRetryLane;
      nextRetryLane <<= 1;
      0 === (nextRetryLane & 62914560) && (nextRetryLane = 4194304);
      return lane;
    }
    function createLaneMap(initial2) {
      for (var laneMap = [], i2 = 0; 31 > i2; i2++) laneMap.push(initial2);
      return laneMap;
    }
    function markRootUpdated$1(root3, updateLane) {
      root3.pendingLanes |= updateLane;
      268435456 !== updateLane && (root3.suspendedLanes = 0, root3.pingedLanes = 0, root3.warmLanes = 0);
    }
    function markRootFinished(root3, finishedLanes, remainingLanes, spawnedLane, updatedLanes, suspendedRetryLanes) {
      var previouslyPendingLanes = root3.pendingLanes;
      root3.pendingLanes = remainingLanes;
      root3.suspendedLanes = 0;
      root3.pingedLanes = 0;
      root3.warmLanes = 0;
      root3.expiredLanes &= remainingLanes;
      root3.entangledLanes &= remainingLanes;
      root3.errorRecoveryDisabledLanes &= remainingLanes;
      root3.shellSuspendCounter = 0;
      var entanglements = root3.entanglements, expirationTimes = root3.expirationTimes, hiddenUpdates = root3.hiddenUpdates;
      for (remainingLanes = previouslyPendingLanes & ~remainingLanes; 0 < remainingLanes; ) {
        var index2 = 31 - clz32(remainingLanes), lane = 1 << index2;
        entanglements[index2] = 0;
        expirationTimes[index2] = -1;
        var hiddenUpdatesForLane = hiddenUpdates[index2];
        if (null !== hiddenUpdatesForLane)
          for (hiddenUpdates[index2] = null, index2 = 0; index2 < hiddenUpdatesForLane.length; index2++) {
            var update = hiddenUpdatesForLane[index2];
            null !== update && (update.lane &= -536870913);
          }
        remainingLanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, 0);
      0 !== suspendedRetryLanes && 0 === updatedLanes && 0 !== root3.tag && (root3.suspendedLanes |= suspendedRetryLanes & ~(previouslyPendingLanes & ~finishedLanes));
    }
    function markSpawnedDeferredLane(root3, spawnedLane, entangledLanes) {
      root3.pendingLanes |= spawnedLane;
      root3.suspendedLanes &= ~spawnedLane;
      var spawnedLaneIndex = 31 - clz32(spawnedLane);
      root3.entangledLanes |= spawnedLane;
      root3.entanglements[spawnedLaneIndex] = root3.entanglements[spawnedLaneIndex] | 1073741824 | entangledLanes & 261930;
    }
    function markRootEntangled(root3, entangledLanes) {
      var rootEntangledLanes = root3.entangledLanes |= entangledLanes;
      for (root3 = root3.entanglements; rootEntangledLanes; ) {
        var index2 = 31 - clz32(rootEntangledLanes), lane = 1 << index2;
        lane & entangledLanes | root3[index2] & entangledLanes && (root3[index2] |= entangledLanes);
        rootEntangledLanes &= ~lane;
      }
    }
    function getBumpedLaneForHydration(root3, renderLanes2) {
      var renderLane = renderLanes2 & -renderLanes2;
      renderLane = 0 !== (renderLane & 42) ? 1 : getBumpedLaneForHydrationByLane(renderLane);
      return 0 !== (renderLane & (root3.suspendedLanes | renderLanes2)) ? 0 : renderLane;
    }
    function getBumpedLaneForHydrationByLane(lane) {
      switch (lane) {
        case 2:
          lane = 1;
          break;
        case 8:
          lane = 4;
          break;
        case 32:
          lane = 16;
          break;
        case 256:
        case 512:
        case 1024:
        case 2048:
        case 4096:
        case 8192:
        case 16384:
        case 32768:
        case 65536:
        case 131072:
        case 262144:
        case 524288:
        case 1048576:
        case 2097152:
        case 4194304:
        case 8388608:
        case 16777216:
        case 33554432:
          lane = 128;
          break;
        case 268435456:
          lane = 134217728;
          break;
        default:
          lane = 0;
      }
      return lane;
    }
    function addFiberToLanesMap(root3, fiber, lanes) {
      if (isDevToolsPresent)
        for (root3 = root3.pendingUpdatersLaneMap; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes), lane = 1 << index2;
          root3[index2].add(fiber);
          lanes &= ~lane;
        }
    }
    function movePendingFibersToMemoized(root3, lanes) {
      if (isDevToolsPresent)
        for (var pendingUpdatersLaneMap = root3.pendingUpdatersLaneMap, memoizedUpdaters = root3.memoizedUpdaters; 0 < lanes; ) {
          var index2 = 31 - clz32(lanes);
          root3 = 1 << index2;
          index2 = pendingUpdatersLaneMap[index2];
          0 < index2.size && (index2.forEach(function(fiber) {
            var alternate = fiber.alternate;
            null !== alternate && memoizedUpdaters.has(alternate) || memoizedUpdaters.add(fiber);
          }), index2.clear());
          lanes &= ~root3;
        }
    }
    function lanesToEventPriority(lanes) {
      lanes &= -lanes;
      return DiscreteEventPriority < lanes ? ContinuousEventPriority < lanes ? 0 !== (lanes & 134217727) ? DefaultEventPriority : IdleEventPriority : ContinuousEventPriority : DiscreteEventPriority;
    }
    function resolveUpdatePriority() {
      var updatePriority = ReactDOMSharedInternals.p;
      if (0 !== updatePriority) return updatePriority;
      updatePriority = window.event;
      return void 0 === updatePriority ? DefaultEventPriority : getEventPriority(updatePriority.type);
    }
    function runWithPriority(priority, fn2) {
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        return ReactDOMSharedInternals.p = priority, fn2();
      } finally {
        ReactDOMSharedInternals.p = previousPriority;
      }
    }
    function detachDeletedInstance(node) {
      delete node[internalInstanceKey];
      delete node[internalPropsKey];
      delete node[internalEventHandlersKey];
      delete node[internalEventHandlerListenersKey];
      delete node[internalEventHandlesSetKey];
    }
    function getClosestInstanceFromNode(targetNode) {
      var targetInst = targetNode[internalInstanceKey];
      if (targetInst) return targetInst;
      for (var parentNode = targetNode.parentNode; parentNode; ) {
        if (targetInst = parentNode[internalContainerInstanceKey] || parentNode[internalInstanceKey]) {
          parentNode = targetInst.alternate;
          if (null !== targetInst.child || null !== parentNode && null !== parentNode.child)
            for (targetNode = getParentHydrationBoundary(targetNode); null !== targetNode; ) {
              if (parentNode = targetNode[internalInstanceKey])
                return parentNode;
              targetNode = getParentHydrationBoundary(targetNode);
            }
          return targetInst;
        }
        targetNode = parentNode;
        parentNode = targetNode.parentNode;
      }
      return null;
    }
    function getInstanceFromNode(node) {
      if (node = node[internalInstanceKey] || node[internalContainerInstanceKey]) {
        var tag2 = node.tag;
        if (5 === tag2 || 6 === tag2 || 13 === tag2 || 31 === tag2 || 26 === tag2 || 27 === tag2 || 3 === tag2)
          return node;
      }
      return null;
    }
    function getNodeFromInstance(inst) {
      var tag2 = inst.tag;
      if (5 === tag2 || 26 === tag2 || 27 === tag2 || 6 === tag2)
        return inst.stateNode;
      throw Error("getNodeFromInstance: Invalid argument.");
    }
    function getResourcesFromRoot(root3) {
      var resources = root3[internalRootNodeResourcesKey];
      resources || (resources = root3[internalRootNodeResourcesKey] = { hoistableStyles: /* @__PURE__ */ new Map(), hoistableScripts: /* @__PURE__ */ new Map() });
      return resources;
    }
    function markNodeAsHoistable(node) {
      node[internalHoistableMarker] = true;
    }
    function registerTwoPhaseEvent(registrationName, dependencies2) {
      registerDirectEvent(registrationName, dependencies2);
      registerDirectEvent(registrationName + "Capture", dependencies2);
    }
    function registerDirectEvent(registrationName, dependencies2) {
      registrationNameDependencies[registrationName] && console.error(
        "EventRegistry: More than one plugin attempted to publish the same registration name, `%s`.",
        registrationName
      );
      registrationNameDependencies[registrationName] = dependencies2;
      var lowerCasedName = registrationName.toLowerCase();
      possibleRegistrationNames[lowerCasedName] = registrationName;
      "onDoubleClick" === registrationName && (possibleRegistrationNames.ondblclick = registrationName);
      for (registrationName = 0; registrationName < dependencies2.length; registrationName++)
        allNativeEvents.add(dependencies2[registrationName]);
    }
    function checkControlledValueProps(tagName, props2) {
      hasReadOnlyValue[props2.type] || props2.onChange || props2.onInput || props2.readOnly || props2.disabled || null == props2.value || ("select" === tagName ? console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set `onChange`."
      ) : console.error(
        "You provided a `value` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultValue`. Otherwise, set either `onChange` or `readOnly`."
      ));
      props2.onChange || props2.readOnly || props2.disabled || null == props2.checked || console.error(
        "You provided a `checked` prop to a form field without an `onChange` handler. This will render a read-only field. If the field should be mutable use `defaultChecked`. Otherwise, set either `onChange` or `readOnly`."
      );
    }
    function isAttributeNameSafe(attributeName) {
      if (hasOwnProperty2.call(validatedAttributeNameCache, attributeName))
        return true;
      if (hasOwnProperty2.call(illegalAttributeNameCache, attributeName))
        return false;
      if (VALID_ATTRIBUTE_NAME_REGEX.test(attributeName))
        return validatedAttributeNameCache[attributeName] = true;
      illegalAttributeNameCache[attributeName] = true;
      console.error("Invalid attribute name: `%s`", attributeName);
      return false;
    }
    function getValueForAttributeOnCustomComponent(node, name2, expected) {
      if (isAttributeNameSafe(name2)) {
        if (!node.hasAttribute(name2)) {
          switch (typeof expected) {
            case "symbol":
            case "object":
              return expected;
            case "function":
              return expected;
            case "boolean":
              if (false === expected) return expected;
          }
          return void 0 === expected ? void 0 : null;
        }
        node = node.getAttribute(name2);
        if ("" === node && true === expected) return true;
        checkAttributeStringCoercion(expected, name2);
        return node === "" + expected ? expected : node;
      }
    }
    function setValueForAttribute(node, name2, value) {
      if (isAttributeNameSafe(name2))
        if (null === value) node.removeAttribute(name2);
        else {
          switch (typeof value) {
            case "undefined":
            case "function":
            case "symbol":
              node.removeAttribute(name2);
              return;
            case "boolean":
              var prefix2 = name2.toLowerCase().slice(0, 5);
              if ("data-" !== prefix2 && "aria-" !== prefix2) {
                node.removeAttribute(name2);
                return;
              }
          }
          checkAttributeStringCoercion(value, name2);
          node.setAttribute(name2, "" + value);
        }
    }
    function setValueForKnownAttribute(node, name2, value) {
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node.removeAttribute(name2);
            return;
        }
        checkAttributeStringCoercion(value, name2);
        node.setAttribute(name2, "" + value);
      }
    }
    function setValueForNamespacedAttribute(node, namespace, name2, value) {
      if (null === value) node.removeAttribute(name2);
      else {
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            node.removeAttribute(name2);
            return;
        }
        checkAttributeStringCoercion(value, name2);
        node.setAttributeNS(namespace, name2, "" + value);
      }
    }
    function getToStringValue(value) {
      switch (typeof value) {
        case "bigint":
        case "boolean":
        case "number":
        case "string":
        case "undefined":
          return value;
        case "object":
          return checkFormFieldValueStringCoercion(value), value;
        default:
          return "";
      }
    }
    function isCheckable(elem) {
      var type = elem.type;
      return (elem = elem.nodeName) && "input" === elem.toLowerCase() && ("checkbox" === type || "radio" === type);
    }
    function trackValueOnNode(node, valueField, currentValue) {
      var descriptor = Object.getOwnPropertyDescriptor(
        node.constructor.prototype,
        valueField
      );
      if (!node.hasOwnProperty(valueField) && "undefined" !== typeof descriptor && "function" === typeof descriptor.get && "function" === typeof descriptor.set) {
        var get2 = descriptor.get, set2 = descriptor.set;
        Object.defineProperty(node, valueField, {
          configurable: true,
          get: function() {
            return get2.call(this);
          },
          set: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
            set2.call(this, value);
          }
        });
        Object.defineProperty(node, valueField, {
          enumerable: descriptor.enumerable
        });
        return {
          getValue: function() {
            return currentValue;
          },
          setValue: function(value) {
            checkFormFieldValueStringCoercion(value);
            currentValue = "" + value;
          },
          stopTracking: function() {
            node._valueTracker = null;
            delete node[valueField];
          }
        };
      }
    }
    function track(node) {
      if (!node._valueTracker) {
        var valueField = isCheckable(node) ? "checked" : "value";
        node._valueTracker = trackValueOnNode(
          node,
          valueField,
          "" + node[valueField]
        );
      }
    }
    function updateValueIfChanged(node) {
      if (!node) return false;
      var tracker = node._valueTracker;
      if (!tracker) return true;
      var lastValue = tracker.getValue();
      var value = "";
      node && (value = isCheckable(node) ? node.checked ? "true" : "false" : node.value);
      node = value;
      return node !== lastValue ? (tracker.setValue(node), true) : false;
    }
    function getActiveElement2(doc2) {
      doc2 = doc2 || ("undefined" !== typeof document ? document : void 0);
      if ("undefined" === typeof doc2) return null;
      try {
        return doc2.activeElement || doc2.body;
      } catch (e2) {
        return doc2.body;
      }
    }
    function escapeSelectorAttributeValueInsideDoubleQuotes(value) {
      return value.replace(
        escapeSelectorAttributeValueInsideDoubleQuotesRegex,
        function(ch) {
          return "\\" + ch.charCodeAt(0).toString(16) + " ";
        }
      );
    }
    function validateInputProps(element2, props2) {
      void 0 === props2.checked || void 0 === props2.defaultChecked || didWarnCheckedDefaultChecked || (console.error(
        "%s contains an input of type %s with both checked and defaultChecked props. Input elements must be either controlled or uncontrolled (specify either the checked prop, or the defaultChecked prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props2.type
      ), didWarnCheckedDefaultChecked = true);
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValueDefaultValue$1 || (console.error(
        "%s contains an input of type %s with both value and defaultValue props. Input elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled input element and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component",
        props2.type
      ), didWarnValueDefaultValue$1 = true);
    }
    function updateInput(element2, value, defaultValue2, lastDefaultValue, checked, defaultChecked, type, name2) {
      element2.name = "";
      null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type ? (checkAttributeStringCoercion(type, "type"), element2.type = type) : element2.removeAttribute("type");
      if (null != value)
        if ("number" === type) {
          if (0 === value && "" === element2.value || element2.value != value)
            element2.value = "" + getToStringValue(value);
        } else
          element2.value !== "" + getToStringValue(value) && (element2.value = "" + getToStringValue(value));
      else
        "submit" !== type && "reset" !== type || element2.removeAttribute("value");
      null != value ? setDefaultValue(element2, type, getToStringValue(value)) : null != defaultValue2 ? setDefaultValue(element2, type, getToStringValue(defaultValue2)) : null != lastDefaultValue && element2.removeAttribute("value");
      null == checked && null != defaultChecked && (element2.defaultChecked = !!defaultChecked);
      null != checked && (element2.checked = checked && "function" !== typeof checked && "symbol" !== typeof checked);
      null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 ? (checkAttributeStringCoercion(name2, "name"), element2.name = "" + getToStringValue(name2)) : element2.removeAttribute("name");
    }
    function initInput(element2, value, defaultValue2, checked, defaultChecked, type, name2, isHydrating2) {
      null != type && "function" !== typeof type && "symbol" !== typeof type && "boolean" !== typeof type && (checkAttributeStringCoercion(type, "type"), element2.type = type);
      if (null != value || null != defaultValue2) {
        if (!("submit" !== type && "reset" !== type || void 0 !== value && null !== value)) {
          track(element2);
          return;
        }
        defaultValue2 = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
        value = null != value ? "" + getToStringValue(value) : defaultValue2;
        isHydrating2 || value === element2.value || (element2.value = value);
        element2.defaultValue = value;
      }
      checked = null != checked ? checked : defaultChecked;
      checked = "function" !== typeof checked && "symbol" !== typeof checked && !!checked;
      element2.checked = isHydrating2 ? element2.checked : !!checked;
      element2.defaultChecked = !!checked;
      null != name2 && "function" !== typeof name2 && "symbol" !== typeof name2 && "boolean" !== typeof name2 && (checkAttributeStringCoercion(name2, "name"), element2.name = name2);
      track(element2);
    }
    function setDefaultValue(node, type, value) {
      "number" === type && getActiveElement2(node.ownerDocument) === node || node.defaultValue === "" + value || (node.defaultValue = "" + value);
    }
    function validateOptionProps(element2, props2) {
      null == props2.value && ("object" === typeof props2.children && null !== props2.children ? React2.Children.forEach(props2.children, function(child) {
        null == child || "string" === typeof child || "number" === typeof child || "bigint" === typeof child || didWarnInvalidChild || (didWarnInvalidChild = true, console.error(
          "Cannot infer the option value of complex children. Pass a `value` prop or use a plain string as children to <option>."
        ));
      }) : null == props2.dangerouslySetInnerHTML || didWarnInvalidInnerHTML || (didWarnInvalidInnerHTML = true, console.error(
        "Pass a `value` prop if you set dangerouslyInnerHTML so React knows which value should be selected."
      )));
      null == props2.selected || didWarnSelectedSetOnOption || (console.error(
        "Use the `defaultValue` or `value` props on <select> instead of setting `selected` on <option>."
      ), didWarnSelectedSetOnOption = true);
    }
    function getDeclarationErrorAddendum() {
      var ownerName = getCurrentFiberOwnerNameInDevOrNull();
      return ownerName ? "\n\nCheck the render method of `" + ownerName + "`." : "";
    }
    function updateOptions(node, multiple, propValue, setDefaultSelected) {
      node = node.options;
      if (multiple) {
        multiple = {};
        for (var i2 = 0; i2 < propValue.length; i2++)
          multiple["$" + propValue[i2]] = true;
        for (propValue = 0; propValue < node.length; propValue++)
          i2 = multiple.hasOwnProperty("$" + node[propValue].value), node[propValue].selected !== i2 && (node[propValue].selected = i2), i2 && setDefaultSelected && (node[propValue].defaultSelected = true);
      } else {
        propValue = "" + getToStringValue(propValue);
        multiple = null;
        for (i2 = 0; i2 < node.length; i2++) {
          if (node[i2].value === propValue) {
            node[i2].selected = true;
            setDefaultSelected && (node[i2].defaultSelected = true);
            return;
          }
          null !== multiple || node[i2].disabled || (multiple = node[i2]);
        }
        null !== multiple && (multiple.selected = true);
      }
    }
    function validateSelectProps(element2, props2) {
      for (element2 = 0; element2 < valuePropNames.length; element2++) {
        var propName = valuePropNames[element2];
        if (null != props2[propName]) {
          var propNameIsArray = isArrayImpl(props2[propName]);
          props2.multiple && !propNameIsArray ? console.error(
            "The `%s` prop supplied to <select> must be an array if `multiple` is true.%s",
            propName,
            getDeclarationErrorAddendum()
          ) : !props2.multiple && propNameIsArray && console.error(
            "The `%s` prop supplied to <select> must be a scalar value if `multiple` is false.%s",
            propName,
            getDeclarationErrorAddendum()
          );
        }
      }
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValueDefaultValue || (console.error(
        "Select elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled select element and remove one of these props. More info: https://react.dev/link/controlled-components"
      ), didWarnValueDefaultValue = true);
    }
    function validateTextareaProps(element2, props2) {
      void 0 === props2.value || void 0 === props2.defaultValue || didWarnValDefaultVal || (console.error(
        "%s contains a textarea with both value and defaultValue props. Textarea elements must be either controlled or uncontrolled (specify either the value prop, or the defaultValue prop, but not both). Decide between using a controlled or uncontrolled textarea and remove one of these props. More info: https://react.dev/link/controlled-components",
        getCurrentFiberOwnerNameInDevOrNull() || "A component"
      ), didWarnValDefaultVal = true);
      null != props2.children && null == props2.value && console.error(
        "Use the `defaultValue` or `value` props instead of setting children on <textarea>."
      );
    }
    function updateTextarea(element2, value, defaultValue2) {
      if (null != value && (value = "" + getToStringValue(value), value !== element2.value && (element2.value = value), null == defaultValue2)) {
        element2.defaultValue !== value && (element2.defaultValue = value);
        return;
      }
      element2.defaultValue = null != defaultValue2 ? "" + getToStringValue(defaultValue2) : "";
    }
    function initTextarea(element2, value, defaultValue2, children) {
      if (null == value) {
        if (null != children) {
          if (null != defaultValue2)
            throw Error(
              "If you supply `defaultValue` on a <textarea>, do not pass children."
            );
          if (isArrayImpl(children)) {
            if (1 < children.length)
              throw Error("<textarea> can only have at most one child.");
            children = children[0];
          }
          defaultValue2 = children;
        }
        null == defaultValue2 && (defaultValue2 = "");
        value = defaultValue2;
      }
      defaultValue2 = getToStringValue(value);
      element2.defaultValue = defaultValue2;
      children = element2.textContent;
      children === defaultValue2 && "" !== children && null !== children && (element2.value = children);
      track(element2);
    }
    function findNotableNode(node, indent2) {
      return void 0 === node.serverProps && 0 === node.serverTail.length && 1 === node.children.length && 3 < node.distanceFromLeaf && node.distanceFromLeaf > 15 - indent2 ? findNotableNode(node.children[0], indent2) : node;
    }
    function indentation(indent2) {
      return "  " + "  ".repeat(indent2);
    }
    function added(indent2) {
      return "+ " + "  ".repeat(indent2);
    }
    function removed(indent2) {
      return "- " + "  ".repeat(indent2);
    }
    function describeFiberType(fiber) {
      switch (fiber.tag) {
        case 26:
        case 27:
        case 5:
          return fiber.type;
        case 16:
          return "Lazy";
        case 31:
          return "Activity";
        case 13:
          return "Suspense";
        case 19:
          return "SuspenseList";
        case 0:
        case 15:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        case 11:
          return fiber = fiber.type.render, fiber.displayName || fiber.name || null;
        case 1:
          return fiber = fiber.type, fiber.displayName || fiber.name || null;
        default:
          return null;
      }
    }
    function describeTextNode(content2, maxLength) {
      return needsEscaping.test(content2) ? (content2 = JSON.stringify(content2), content2.length > maxLength - 2 ? 8 > maxLength ? '{"..."}' : "{" + content2.slice(0, maxLength - 7) + '..."}' : "{" + content2 + "}") : content2.length > maxLength ? 5 > maxLength ? '{"..."}' : content2.slice(0, maxLength - 3) + "..." : content2;
    }
    function describeTextDiff(clientText, serverProps, indent2) {
      var maxLength = 120 - 2 * indent2;
      if (null === serverProps)
        return added(indent2) + describeTextNode(clientText, maxLength) + "\n";
      if ("string" === typeof serverProps) {
        for (var firstDiff = 0; firstDiff < serverProps.length && firstDiff < clientText.length && serverProps.charCodeAt(firstDiff) === clientText.charCodeAt(firstDiff); firstDiff++) ;
        firstDiff > maxLength - 8 && 10 < firstDiff && (clientText = "..." + clientText.slice(firstDiff - 8), serverProps = "..." + serverProps.slice(firstDiff - 8));
        return added(indent2) + describeTextNode(clientText, maxLength) + "\n" + removed(indent2) + describeTextNode(serverProps, maxLength) + "\n";
      }
      return indentation(indent2) + describeTextNode(clientText, maxLength) + "\n";
    }
    function objectName(object2) {
      return Object.prototype.toString.call(object2).replace(/^\[object (.*)\]$/, function(m2, p0) {
        return p0;
      });
    }
    function describeValue(value, maxLength) {
      switch (typeof value) {
        case "string":
          return value = JSON.stringify(value), value.length > maxLength ? 5 > maxLength ? '"..."' : value.slice(0, maxLength - 4) + '..."' : value;
        case "object":
          if (null === value) return "null";
          if (isArrayImpl(value)) return "[...]";
          if (value.$$typeof === REACT_ELEMENT_TYPE)
            return (maxLength = getComponentNameFromType(value.type)) ? "<" + maxLength + ">" : "<...>";
          var name2 = objectName(value);
          if ("Object" === name2) {
            name2 = "";
            maxLength -= 2;
            for (var propName in value)
              if (value.hasOwnProperty(propName)) {
                var jsonPropName = JSON.stringify(propName);
                jsonPropName !== '"' + propName + '"' && (propName = jsonPropName);
                maxLength -= propName.length - 2;
                jsonPropName = describeValue(
                  value[propName],
                  15 > maxLength ? maxLength : 15
                );
                maxLength -= jsonPropName.length;
                if (0 > maxLength) {
                  name2 += "" === name2 ? "..." : ", ...";
                  break;
                }
                name2 += ("" === name2 ? "" : ",") + propName + ":" + jsonPropName;
              }
            return "{" + name2 + "}";
          }
          return name2;
        case "function":
          return (maxLength = value.displayName || value.name) ? "function " + maxLength : "function";
        default:
          return String(value);
      }
    }
    function describePropValue(value, maxLength) {
      return "string" !== typeof value || needsEscaping.test(value) ? "{" + describeValue(value, maxLength - 2) + "}" : value.length > maxLength - 2 ? 5 > maxLength ? '"..."' : '"' + value.slice(0, maxLength - 5) + '..."' : '"' + value + '"';
    }
    function describeExpandedElement(type, props2, rowPrefix) {
      var remainingRowLength = 120 - rowPrefix.length - type.length, properties2 = [], propName;
      for (propName in props2)
        if (props2.hasOwnProperty(propName) && "children" !== propName) {
          var propValue = describePropValue(
            props2[propName],
            120 - rowPrefix.length - propName.length - 1
          );
          remainingRowLength -= propName.length + propValue.length + 2;
          properties2.push(propName + "=" + propValue);
        }
      return 0 === properties2.length ? rowPrefix + "<" + type + ">\n" : 0 < remainingRowLength ? rowPrefix + "<" + type + " " + properties2.join(" ") + ">\n" : rowPrefix + "<" + type + "\n" + rowPrefix + "  " + properties2.join("\n" + rowPrefix + "  ") + "\n" + rowPrefix + ">\n";
    }
    function describePropertiesDiff(clientObject, serverObject, indent2) {
      var properties2 = "", remainingServerProperties = assign2({}, serverObject), propName;
      for (propName in clientObject)
        if (clientObject.hasOwnProperty(propName)) {
          delete remainingServerProperties[propName];
          var maxLength = 120 - 2 * indent2 - propName.length - 2, clientPropValue = describeValue(clientObject[propName], maxLength);
          serverObject.hasOwnProperty(propName) ? (maxLength = describeValue(serverObject[propName], maxLength), properties2 += added(indent2) + propName + ": " + clientPropValue + "\n", properties2 += removed(indent2) + propName + ": " + maxLength + "\n") : properties2 += added(indent2) + propName + ": " + clientPropValue + "\n";
        }
      for (var _propName in remainingServerProperties)
        remainingServerProperties.hasOwnProperty(_propName) && (clientObject = describeValue(
          remainingServerProperties[_propName],
          120 - 2 * indent2 - _propName.length - 2
        ), properties2 += removed(indent2) + _propName + ": " + clientObject + "\n");
      return properties2;
    }
    function describeElementDiff(type, clientProps, serverProps, indent2) {
      var content2 = "", serverPropNames = /* @__PURE__ */ new Map();
      for (propName$jscomp$0 in serverProps)
        serverProps.hasOwnProperty(propName$jscomp$0) && serverPropNames.set(
          propName$jscomp$0.toLowerCase(),
          propName$jscomp$0
        );
      if (1 === serverPropNames.size && serverPropNames.has("children"))
        content2 += describeExpandedElement(
          type,
          clientProps,
          indentation(indent2)
        );
      else {
        for (var _propName2 in clientProps)
          if (clientProps.hasOwnProperty(_propName2) && "children" !== _propName2) {
            var maxLength$jscomp$0 = 120 - 2 * (indent2 + 1) - _propName2.length - 1, serverPropName = serverPropNames.get(_propName2.toLowerCase());
            if (void 0 !== serverPropName) {
              serverPropNames.delete(_propName2.toLowerCase());
              var propName$jscomp$0 = clientProps[_propName2];
              serverPropName = serverProps[serverPropName];
              var clientPropValue = describePropValue(
                propName$jscomp$0,
                maxLength$jscomp$0
              );
              maxLength$jscomp$0 = describePropValue(
                serverPropName,
                maxLength$jscomp$0
              );
              "object" === typeof propName$jscomp$0 && null !== propName$jscomp$0 && "object" === typeof serverPropName && null !== serverPropName && "Object" === objectName(propName$jscomp$0) && "Object" === objectName(serverPropName) && (2 < Object.keys(propName$jscomp$0).length || 2 < Object.keys(serverPropName).length || -1 < clientPropValue.indexOf("...") || -1 < maxLength$jscomp$0.indexOf("...")) ? content2 += indentation(indent2 + 1) + _propName2 + "={{\n" + describePropertiesDiff(
                propName$jscomp$0,
                serverPropName,
                indent2 + 2
              ) + indentation(indent2 + 1) + "}}\n" : (content2 += added(indent2 + 1) + _propName2 + "=" + clientPropValue + "\n", content2 += removed(indent2 + 1) + _propName2 + "=" + maxLength$jscomp$0 + "\n");
            } else
              content2 += indentation(indent2 + 1) + _propName2 + "=" + describePropValue(clientProps[_propName2], maxLength$jscomp$0) + "\n";
          }
        serverPropNames.forEach(function(propName) {
          if ("children" !== propName) {
            var maxLength = 120 - 2 * (indent2 + 1) - propName.length - 1;
            content2 += removed(indent2 + 1) + propName + "=" + describePropValue(serverProps[propName], maxLength) + "\n";
          }
        });
        content2 = "" === content2 ? indentation(indent2) + "<" + type + ">\n" : indentation(indent2) + "<" + type + "\n" + content2 + indentation(indent2) + ">\n";
      }
      type = serverProps.children;
      clientProps = clientProps.children;
      if ("string" === typeof type || "number" === typeof type || "bigint" === typeof type) {
        serverPropNames = "";
        if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
          serverPropNames = "" + clientProps;
        content2 += describeTextDiff(serverPropNames, "" + type, indent2 + 1);
      } else if ("string" === typeof clientProps || "number" === typeof clientProps || "bigint" === typeof clientProps)
        content2 = null == type ? content2 + describeTextDiff("" + clientProps, null, indent2 + 1) : content2 + describeTextDiff("" + clientProps, void 0, indent2 + 1);
      return content2;
    }
    function describeSiblingFiber(fiber, indent2) {
      var type = describeFiberType(fiber);
      if (null === type) {
        type = "";
        for (fiber = fiber.child; fiber; )
          type += describeSiblingFiber(fiber, indent2), fiber = fiber.sibling;
        return type;
      }
      return indentation(indent2) + "<" + type + ">\n";
    }
    function describeNode(node, indent2) {
      var skipToNode = findNotableNode(node, indent2);
      if (skipToNode !== node && (1 !== node.children.length || node.children[0] !== skipToNode))
        return indentation(indent2) + "...\n" + describeNode(skipToNode, indent2 + 1);
      skipToNode = "";
      var debugInfo = node.fiber._debugInfo;
      if (debugInfo)
        for (var i2 = 0; i2 < debugInfo.length; i2++) {
          var serverComponentName = debugInfo[i2].name;
          "string" === typeof serverComponentName && (skipToNode += indentation(indent2) + "<" + serverComponentName + ">\n", indent2++);
        }
      debugInfo = "";
      i2 = node.fiber.pendingProps;
      if (6 === node.fiber.tag)
        debugInfo = describeTextDiff(i2, node.serverProps, indent2), indent2++;
      else if (serverComponentName = describeFiberType(node.fiber), null !== serverComponentName)
        if (void 0 === node.serverProps) {
          debugInfo = indent2;
          var maxLength = 120 - 2 * debugInfo - serverComponentName.length - 2, content2 = "";
          for (propName in i2)
            if (i2.hasOwnProperty(propName) && "children" !== propName) {
              var propValue = describePropValue(i2[propName], 15);
              maxLength -= propName.length + propValue.length + 2;
              if (0 > maxLength) {
                content2 += " ...";
                break;
              }
              content2 += " " + propName + "=" + propValue;
            }
          debugInfo = indentation(debugInfo) + "<" + serverComponentName + content2 + ">\n";
          indent2++;
        } else
          null === node.serverProps ? (debugInfo = describeExpandedElement(
            serverComponentName,
            i2,
            added(indent2)
          ), indent2++) : "string" === typeof node.serverProps ? console.error(
            "Should not have matched a non HostText fiber to a Text node. This is a bug in React."
          ) : (debugInfo = describeElementDiff(
            serverComponentName,
            i2,
            node.serverProps,
            indent2
          ), indent2++);
      var propName = "";
      i2 = node.fiber.child;
      for (serverComponentName = 0; i2 && serverComponentName < node.children.length; )
        maxLength = node.children[serverComponentName], maxLength.fiber === i2 ? (propName += describeNode(maxLength, indent2), serverComponentName++) : propName += describeSiblingFiber(i2, indent2), i2 = i2.sibling;
      i2 && 0 < node.children.length && (propName += indentation(indent2) + "...\n");
      i2 = node.serverTail;
      null === node.serverProps && indent2--;
      for (node = 0; node < i2.length; node++)
        serverComponentName = i2[node], propName = "string" === typeof serverComponentName ? propName + (removed(indent2) + describeTextNode(serverComponentName, 120 - 2 * indent2) + "\n") : propName + describeExpandedElement(
          serverComponentName.type,
          serverComponentName.props,
          removed(indent2)
        );
      return skipToNode + debugInfo + propName;
    }
    function describeDiff(rootNode) {
      try {
        return "\n\n" + describeNode(rootNode, 0);
      } catch (x2) {
        return "";
      }
    }
    function describeAncestors(ancestor, child, props2) {
      for (var fiber = child, node = null, distanceFromLeaf = 0; fiber; )
        fiber === ancestor && (distanceFromLeaf = 0), node = {
          fiber,
          children: null !== node ? [node] : [],
          serverProps: fiber === child ? props2 : fiber === ancestor ? null : void 0,
          serverTail: [],
          distanceFromLeaf
        }, distanceFromLeaf++, fiber = fiber.return;
      return null !== node ? describeDiff(node).replaceAll(/^[+-]/gm, ">") : "";
    }
    function updatedAncestorInfoDev(oldInfo, tag2) {
      var ancestorInfo = assign2({}, oldInfo || emptyAncestorInfoDev), info = { tag: tag2 };
      -1 !== inScopeTags.indexOf(tag2) && (ancestorInfo.aTagInScope = null, ancestorInfo.buttonTagInScope = null, ancestorInfo.nobrTagInScope = null);
      -1 !== buttonScopeTags.indexOf(tag2) && (ancestorInfo.pTagInButtonScope = null);
      -1 !== specialTags.indexOf(tag2) && "address" !== tag2 && "div" !== tag2 && "p" !== tag2 && (ancestorInfo.listItemTagAutoclosing = null, ancestorInfo.dlItemTagAutoclosing = null);
      ancestorInfo.current = info;
      "form" === tag2 && (ancestorInfo.formTag = info);
      "a" === tag2 && (ancestorInfo.aTagInScope = info);
      "button" === tag2 && (ancestorInfo.buttonTagInScope = info);
      "nobr" === tag2 && (ancestorInfo.nobrTagInScope = info);
      "p" === tag2 && (ancestorInfo.pTagInButtonScope = info);
      "li" === tag2 && (ancestorInfo.listItemTagAutoclosing = info);
      if ("dd" === tag2 || "dt" === tag2)
        ancestorInfo.dlItemTagAutoclosing = info;
      "#document" === tag2 || "html" === tag2 ? ancestorInfo.containerTagInScope = null : ancestorInfo.containerTagInScope || (ancestorInfo.containerTagInScope = info);
      null !== oldInfo || "#document" !== tag2 && "html" !== tag2 && "body" !== tag2 ? true === ancestorInfo.implicitRootScope && (ancestorInfo.implicitRootScope = false) : ancestorInfo.implicitRootScope = true;
      return ancestorInfo;
    }
    function isTagValidWithParent(tag2, parentTag, implicitRootScope) {
      switch (parentTag) {
        case "select":
          return "hr" === tag2 || "option" === tag2 || "optgroup" === tag2 || "script" === tag2 || "template" === tag2 || "#text" === tag2;
        case "optgroup":
          return "option" === tag2 || "#text" === tag2;
        case "option":
          return "#text" === tag2;
        case "tr":
          return "th" === tag2 || "td" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "tbody":
        case "thead":
        case "tfoot":
          return "tr" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "colgroup":
          return "col" === tag2 || "template" === tag2;
        case "table":
          return "caption" === tag2 || "colgroup" === tag2 || "tbody" === tag2 || "tfoot" === tag2 || "thead" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "head":
          return "base" === tag2 || "basefont" === tag2 || "bgsound" === tag2 || "link" === tag2 || "meta" === tag2 || "title" === tag2 || "noscript" === tag2 || "noframes" === tag2 || "style" === tag2 || "script" === tag2 || "template" === tag2;
        case "html":
          if (implicitRootScope) break;
          return "head" === tag2 || "body" === tag2 || "frameset" === tag2;
        case "frameset":
          return "frame" === tag2;
        case "#document":
          if (!implicitRootScope) return "html" === tag2;
      }
      switch (tag2) {
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return "h1" !== parentTag && "h2" !== parentTag && "h3" !== parentTag && "h4" !== parentTag && "h5" !== parentTag && "h6" !== parentTag;
        case "rp":
        case "rt":
          return -1 === impliedEndTags.indexOf(parentTag);
        case "caption":
        case "col":
        case "colgroup":
        case "frameset":
        case "frame":
        case "tbody":
        case "td":
        case "tfoot":
        case "th":
        case "thead":
        case "tr":
          return null == parentTag;
        case "head":
          return implicitRootScope || null === parentTag;
        case "html":
          return implicitRootScope && "#document" === parentTag || null === parentTag;
        case "body":
          return implicitRootScope && ("#document" === parentTag || "html" === parentTag) || null === parentTag;
      }
      return true;
    }
    function findInvalidAncestorForTag(tag2, ancestorInfo) {
      switch (tag2) {
        case "address":
        case "article":
        case "aside":
        case "blockquote":
        case "center":
        case "details":
        case "dialog":
        case "dir":
        case "div":
        case "dl":
        case "fieldset":
        case "figcaption":
        case "figure":
        case "footer":
        case "header":
        case "hgroup":
        case "main":
        case "menu":
        case "nav":
        case "ol":
        case "p":
        case "section":
        case "summary":
        case "ul":
        case "pre":
        case "listing":
        case "table":
        case "hr":
        case "xmp":
        case "h1":
        case "h2":
        case "h3":
        case "h4":
        case "h5":
        case "h6":
          return ancestorInfo.pTagInButtonScope;
        case "form":
          return ancestorInfo.formTag || ancestorInfo.pTagInButtonScope;
        case "li":
          return ancestorInfo.listItemTagAutoclosing;
        case "dd":
        case "dt":
          return ancestorInfo.dlItemTagAutoclosing;
        case "button":
          return ancestorInfo.buttonTagInScope;
        case "a":
          return ancestorInfo.aTagInScope;
        case "nobr":
          return ancestorInfo.nobrTagInScope;
      }
      return null;
    }
    function findAncestor(parent, tagName) {
      for (; parent; ) {
        switch (parent.tag) {
          case 5:
          case 26:
          case 27:
            if (parent.type === tagName) return parent;
        }
        parent = parent.return;
      }
      return null;
    }
    function validateDOMNesting(childTag, ancestorInfo) {
      ancestorInfo = ancestorInfo || emptyAncestorInfoDev;
      var parentInfo = ancestorInfo.current;
      ancestorInfo = (parentInfo = isTagValidWithParent(
        childTag,
        parentInfo && parentInfo.tag,
        ancestorInfo.implicitRootScope
      ) ? null : parentInfo) ? null : findInvalidAncestorForTag(childTag, ancestorInfo);
      ancestorInfo = parentInfo || ancestorInfo;
      if (!ancestorInfo) return true;
      var ancestorTag = ancestorInfo.tag;
      ancestorInfo = String(!!parentInfo) + "|" + childTag + "|" + ancestorTag;
      if (didWarn[ancestorInfo]) return false;
      didWarn[ancestorInfo] = true;
      var ancestor = (ancestorInfo = current2) ? findAncestor(ancestorInfo.return, ancestorTag) : null, ancestorDescription = null !== ancestorInfo && null !== ancestor ? describeAncestors(ancestor, ancestorInfo, null) : "", tagDisplayName = "<" + childTag + ">";
      parentInfo ? (parentInfo = "", "table" === ancestorTag && "tr" === childTag && (parentInfo += " Add a <tbody>, <thead> or <tfoot> to your code to match the DOM tree generated by the browser."), console.error(
        "In HTML, %s cannot be a child of <%s>.%s\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        parentInfo,
        ancestorDescription
      )) : console.error(
        "In HTML, %s cannot be a descendant of <%s>.\nThis will cause a hydration error.%s",
        tagDisplayName,
        ancestorTag,
        ancestorDescription
      );
      ancestorInfo && (childTag = ancestorInfo.return, null === ancestor || null === childTag || ancestor === childTag && childTag._debugOwner === ancestorInfo._debugOwner || runWithFiberInDEV(ancestor, function() {
        console.error(
          "<%s> cannot contain a nested %s.\nSee this log for the ancestor stack trace.",
          ancestorTag,
          tagDisplayName
        );
      }));
      return false;
    }
    function validateTextNesting(childText, parentTag, implicitRootScope) {
      if (implicitRootScope || isTagValidWithParent("#text", parentTag, false))
        return true;
      implicitRootScope = "#text|" + parentTag;
      if (didWarn[implicitRootScope]) return false;
      didWarn[implicitRootScope] = true;
      var ancestor = (implicitRootScope = current2) ? findAncestor(implicitRootScope, parentTag) : null;
      implicitRootScope = null !== implicitRootScope && null !== ancestor ? describeAncestors(
        ancestor,
        implicitRootScope,
        6 !== implicitRootScope.tag ? { children: null } : null
      ) : "";
      /\S/.test(childText) ? console.error(
        "In HTML, text nodes cannot be a child of <%s>.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      ) : console.error(
        "In HTML, whitespace text nodes cannot be a child of <%s>. Make sure you don't have any extra whitespace between tags on each line of your source code.\nThis will cause a hydration error.%s",
        parentTag,
        implicitRootScope
      );
      return false;
    }
    function setTextContent(node, text2) {
      if (text2) {
        var firstChild = node.firstChild;
        if (firstChild && firstChild === node.lastChild && 3 === firstChild.nodeType) {
          firstChild.nodeValue = text2;
          return;
        }
      }
      node.textContent = text2;
    }
    function camelize(string2) {
      return string2.replace(hyphenPattern, function(_2, character) {
        return character.toUpperCase();
      });
    }
    function setValueForStyle(style2, styleName, value) {
      var isCustomProperty = 0 === styleName.indexOf("--");
      isCustomProperty || (-1 < styleName.indexOf("-") ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported style property %s. Did you mean %s?",
        styleName,
        camelize(styleName.replace(msPattern, "ms-"))
      )) : badVendoredStyleNamePattern.test(styleName) ? warnedStyleNames.hasOwnProperty(styleName) && warnedStyleNames[styleName] || (warnedStyleNames[styleName] = true, console.error(
        "Unsupported vendor-prefixed style property %s. Did you mean %s?",
        styleName,
        styleName.charAt(0).toUpperCase() + styleName.slice(1)
      )) : !badStyleValueWithSemicolonPattern.test(value) || warnedStyleValues.hasOwnProperty(value) && warnedStyleValues[value] || (warnedStyleValues[value] = true, console.error(
        `Style property values shouldn't contain a semicolon. Try "%s: %s" instead.`,
        styleName,
        value.replace(badStyleValueWithSemicolonPattern, "")
      )), "number" === typeof value && (isNaN(value) ? warnedForNaNValue || (warnedForNaNValue = true, console.error(
        "`NaN` is an invalid value for the `%s` css style property.",
        styleName
      )) : isFinite(value) || warnedForInfinityValue || (warnedForInfinityValue = true, console.error(
        "`Infinity` is an invalid value for the `%s` css style property.",
        styleName
      ))));
      null == value || "boolean" === typeof value || "" === value ? isCustomProperty ? style2.setProperty(styleName, "") : "float" === styleName ? style2.cssFloat = "" : style2[styleName] = "" : isCustomProperty ? style2.setProperty(styleName, value) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? "float" === styleName ? style2.cssFloat = value : (checkCSSPropertyStringCoercion(value, styleName), style2[styleName] = ("" + value).trim()) : style2[styleName] = value + "px";
    }
    function setValueForStyles(node, styles, prevStyles) {
      if (null != styles && "object" !== typeof styles)
        throw Error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      styles && Object.freeze(styles);
      node = node.style;
      if (null != prevStyles) {
        if (styles) {
          var expandedUpdates = {};
          if (prevStyles) {
            for (var key in prevStyles)
              if (prevStyles.hasOwnProperty(key) && !styles.hasOwnProperty(key))
                for (var longhands = shorthandToLonghand[key] || [key], i2 = 0; i2 < longhands.length; i2++)
                  expandedUpdates[longhands[i2]] = key;
          }
          for (var _key in styles)
            if (styles.hasOwnProperty(_key) && (!prevStyles || prevStyles[_key] !== styles[_key]))
              for (key = shorthandToLonghand[_key] || [_key], longhands = 0; longhands < key.length; longhands++)
                expandedUpdates[key[longhands]] = _key;
          _key = {};
          for (var key$jscomp$0 in styles)
            for (key = shorthandToLonghand[key$jscomp$0] || [key$jscomp$0], longhands = 0; longhands < key.length; longhands++)
              _key[key[longhands]] = key$jscomp$0;
          key$jscomp$0 = {};
          for (var _key2 in expandedUpdates)
            if (key = expandedUpdates[_key2], (longhands = _key[_key2]) && key !== longhands && (i2 = key + "," + longhands, !key$jscomp$0[i2])) {
              key$jscomp$0[i2] = true;
              i2 = console;
              var value = styles[key];
              i2.error.call(
                i2,
                "%s a style property during rerender (%s) when a conflicting property is set (%s) can lead to styling bugs. To avoid this, don't mix shorthand and non-shorthand properties for the same value; instead, replace the shorthand with separate values.",
                null == value || "boolean" === typeof value || "" === value ? "Removing" : "Updating",
                key,
                longhands
              );
            }
        }
        for (var styleName in prevStyles)
          !prevStyles.hasOwnProperty(styleName) || null != styles && styles.hasOwnProperty(styleName) || (0 === styleName.indexOf("--") ? node.setProperty(styleName, "") : "float" === styleName ? node.cssFloat = "" : node[styleName] = "");
        for (var _styleName in styles)
          _key2 = styles[_styleName], styles.hasOwnProperty(_styleName) && prevStyles[_styleName] !== _key2 && setValueForStyle(node, _styleName, _key2);
      } else
        for (expandedUpdates in styles)
          styles.hasOwnProperty(expandedUpdates) && setValueForStyle(node, expandedUpdates, styles[expandedUpdates]);
    }
    function isCustomElement(tagName) {
      if (-1 === tagName.indexOf("-")) return false;
      switch (tagName) {
        case "annotation-xml":
        case "color-profile":
        case "font-face":
        case "font-face-src":
        case "font-face-uri":
        case "font-face-format":
        case "font-face-name":
        case "missing-glyph":
          return false;
        default:
          return true;
      }
    }
    function getAttributeAlias(name2) {
      return aliases.get(name2) || name2;
    }
    function validateProperty$1(tagName, name2) {
      if (hasOwnProperty2.call(warnedProperties$1, name2) && warnedProperties$1[name2])
        return true;
      if (rARIACamel$1.test(name2)) {
        tagName = "aria-" + name2.slice(4).toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. ARIA attributes follow the pattern aria-* and must be lowercase.",
            name2
          ), warnedProperties$1[name2] = true;
        if (name2 !== tagName)
          return console.error(
            "Invalid ARIA attribute `%s`. Did you mean `%s`?",
            name2,
            tagName
          ), warnedProperties$1[name2] = true;
      }
      if (rARIA$1.test(name2)) {
        tagName = name2.toLowerCase();
        tagName = ariaProperties.hasOwnProperty(tagName) ? tagName : null;
        if (null == tagName) return warnedProperties$1[name2] = true, false;
        name2 !== tagName && (console.error(
          "Unknown ARIA attribute `%s`. Did you mean `%s`?",
          name2,
          tagName
        ), warnedProperties$1[name2] = true);
      }
      return true;
    }
    function validateProperties$2(type, props2) {
      var invalidProps = [], key;
      for (key in props2)
        validateProperty$1(type, key) || invalidProps.push(key);
      props2 = invalidProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === invalidProps.length ? console.error(
        "Invalid aria prop %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props2,
        type
      ) : 1 < invalidProps.length && console.error(
        "Invalid aria props %s on <%s> tag. For details, see https://react.dev/link/invalid-aria-props",
        props2,
        type
      );
    }
    function validateProperty(tagName, name2, value, eventRegistry) {
      if (hasOwnProperty2.call(warnedProperties, name2) && warnedProperties[name2])
        return true;
      var lowerCasedName = name2.toLowerCase();
      if ("onfocusin" === lowerCasedName || "onfocusout" === lowerCasedName)
        return console.error(
          "React uses onFocus and onBlur instead of onFocusIn and onFocusOut. All React events are normalized to bubble, so onFocusIn and onFocusOut are not needed/supported by React."
        ), warnedProperties[name2] = true;
      if ("function" === typeof value && ("form" === tagName && "action" === name2 || "input" === tagName && "formAction" === name2 || "button" === tagName && "formAction" === name2))
        return true;
      if (null != eventRegistry) {
        tagName = eventRegistry.possibleRegistrationNames;
        if (eventRegistry.registrationNameDependencies.hasOwnProperty(name2))
          return true;
        eventRegistry = tagName.hasOwnProperty(lowerCasedName) ? tagName[lowerCasedName] : null;
        if (null != eventRegistry)
          return console.error(
            "Invalid event handler property `%s`. Did you mean `%s`?",
            name2,
            eventRegistry
          ), warnedProperties[name2] = true;
        if (EVENT_NAME_REGEX.test(name2))
          return console.error(
            "Unknown event handler property `%s`. It will be ignored.",
            name2
          ), warnedProperties[name2] = true;
      } else if (EVENT_NAME_REGEX.test(name2))
        return INVALID_EVENT_NAME_REGEX.test(name2) && console.error(
          "Invalid event handler property `%s`. React events use the camelCase naming convention, for example `onClick`.",
          name2
        ), warnedProperties[name2] = true;
      if (rARIA.test(name2) || rARIACamel.test(name2)) return true;
      if ("innerhtml" === lowerCasedName)
        return console.error(
          "Directly setting property `innerHTML` is not permitted. For more information, lookup documentation on `dangerouslySetInnerHTML`."
        ), warnedProperties[name2] = true;
      if ("aria" === lowerCasedName)
        return console.error(
          "The `aria` attribute is reserved for future use in React. Pass individual `aria-` attributes instead."
        ), warnedProperties[name2] = true;
      if ("is" === lowerCasedName && null !== value && void 0 !== value && "string" !== typeof value)
        return console.error(
          "Received a `%s` for a string attribute `is`. If this is expected, cast the value to a string.",
          typeof value
        ), warnedProperties[name2] = true;
      if ("number" === typeof value && isNaN(value))
        return console.error(
          "Received NaN for the `%s` attribute. If this is expected, cast the value to a string.",
          name2
        ), warnedProperties[name2] = true;
      if (possibleStandardNames.hasOwnProperty(lowerCasedName)) {
        if (lowerCasedName = possibleStandardNames[lowerCasedName], lowerCasedName !== name2)
          return console.error(
            "Invalid DOM property `%s`. Did you mean `%s`?",
            name2,
            lowerCasedName
          ), warnedProperties[name2] = true;
      } else if (name2 !== lowerCasedName)
        return console.error(
          "React does not recognize the `%s` prop on a DOM element. If you intentionally want it to appear in the DOM as a custom attribute, spell it as lowercase `%s` instead. If you accidentally passed it from a parent component, remove it from the DOM element.",
          name2,
          lowerCasedName
        ), warnedProperties[name2] = true;
      switch (name2) {
        case "dangerouslySetInnerHTML":
        case "children":
        case "style":
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          return true;
        case "innerText":
        case "textContent":
          return true;
      }
      switch (typeof value) {
        case "boolean":
          switch (name2) {
            case "autoFocus":
            case "checked":
            case "multiple":
            case "muted":
            case "selected":
            case "contentEditable":
            case "spellCheck":
            case "draggable":
            case "value":
            case "autoReverse":
            case "externalResourcesRequired":
            case "focusable":
            case "preserveAlpha":
            case "allowFullScreen":
            case "async":
            case "autoPlay":
            case "controls":
            case "default":
            case "defer":
            case "disabled":
            case "disablePictureInPicture":
            case "disableRemotePlayback":
            case "formNoValidate":
            case "hidden":
            case "loop":
            case "noModule":
            case "noValidate":
            case "open":
            case "playsInline":
            case "readOnly":
            case "required":
            case "reversed":
            case "scoped":
            case "seamless":
            case "itemScope":
            case "capture":
            case "download":
            case "inert":
              return true;
            default:
              lowerCasedName = name2.toLowerCase().slice(0, 5);
              if ("data-" === lowerCasedName || "aria-" === lowerCasedName)
                return true;
              value ? console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.',
                value,
                name2,
                name2,
                value,
                name2
              ) : console.error(
                'Received `%s` for a non-boolean attribute `%s`.\n\nIf you want to write it to the DOM, pass a string instead: %s="%s" or %s={value.toString()}.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.',
                value,
                name2,
                name2,
                value,
                name2,
                name2,
                name2
              );
              return warnedProperties[name2] = true;
          }
        case "function":
        case "symbol":
          return warnedProperties[name2] = true, false;
        case "string":
          if ("false" === value || "true" === value) {
            switch (name2) {
              case "checked":
              case "selected":
              case "multiple":
              case "muted":
              case "allowFullScreen":
              case "async":
              case "autoPlay":
              case "controls":
              case "default":
              case "defer":
              case "disabled":
              case "disablePictureInPicture":
              case "disableRemotePlayback":
              case "formNoValidate":
              case "hidden":
              case "loop":
              case "noModule":
              case "noValidate":
              case "open":
              case "playsInline":
              case "readOnly":
              case "required":
              case "reversed":
              case "scoped":
              case "seamless":
              case "itemScope":
              case "inert":
                break;
              default:
                return true;
            }
            console.error(
              "Received the string `%s` for the boolean attribute `%s`. %s Did you mean %s={%s}?",
              value,
              name2,
              "false" === value ? "The browser will interpret it as a truthy value." : 'Although this works, it will not work as expected if you pass the string "false".',
              name2,
              value
            );
            warnedProperties[name2] = true;
          }
      }
      return true;
    }
    function warnUnknownProperties(type, props2, eventRegistry) {
      var unknownProps = [], key;
      for (key in props2)
        validateProperty(type, key, props2[key], eventRegistry) || unknownProps.push(key);
      props2 = unknownProps.map(function(prop) {
        return "`" + prop + "`";
      }).join(", ");
      1 === unknownProps.length ? console.error(
        "Invalid value for prop %s on <%s> tag. Either remove it from the element, or pass a string or number value to keep it in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props2,
        type
      ) : 1 < unknownProps.length && console.error(
        "Invalid values for props %s on <%s> tag. Either remove them from the element, or pass a string or number value to keep them in the DOM. For details, see https://react.dev/link/attribute-behavior ",
        props2,
        type
      );
    }
    function sanitizeURL(url) {
      return isJavaScriptProtocol.test("" + url) ? "javascript:throw new Error('React has blocked a javascript: URL as a security precaution.')" : url;
    }
    function noop$12() {
    }
    function getEventTarget(nativeEvent) {
      nativeEvent = nativeEvent.target || nativeEvent.srcElement || window;
      nativeEvent.correspondingUseElement && (nativeEvent = nativeEvent.correspondingUseElement);
      return 3 === nativeEvent.nodeType ? nativeEvent.parentNode : nativeEvent;
    }
    function restoreStateOfTarget(target) {
      var internalInstance = getInstanceFromNode(target);
      if (internalInstance && (target = internalInstance.stateNode)) {
        var props2 = target[internalPropsKey] || null;
        a: switch (target = internalInstance.stateNode, internalInstance.type) {
          case "input":
            updateInput(
              target,
              props2.value,
              props2.defaultValue,
              props2.defaultValue,
              props2.checked,
              props2.defaultChecked,
              props2.type,
              props2.name
            );
            internalInstance = props2.name;
            if ("radio" === props2.type && null != internalInstance) {
              for (props2 = target; props2.parentNode; ) props2 = props2.parentNode;
              checkAttributeStringCoercion(internalInstance, "name");
              props2 = props2.querySelectorAll(
                'input[name="' + escapeSelectorAttributeValueInsideDoubleQuotes(
                  "" + internalInstance
                ) + '"][type="radio"]'
              );
              for (internalInstance = 0; internalInstance < props2.length; internalInstance++) {
                var otherNode = props2[internalInstance];
                if (otherNode !== target && otherNode.form === target.form) {
                  var otherProps = otherNode[internalPropsKey] || null;
                  if (!otherProps)
                    throw Error(
                      "ReactDOMInput: Mixing React and non-React radio inputs with the same `name` is not supported."
                    );
                  updateInput(
                    otherNode,
                    otherProps.value,
                    otherProps.defaultValue,
                    otherProps.defaultValue,
                    otherProps.checked,
                    otherProps.defaultChecked,
                    otherProps.type,
                    otherProps.name
                  );
                }
              }
              for (internalInstance = 0; internalInstance < props2.length; internalInstance++)
                otherNode = props2[internalInstance], otherNode.form === target.form && updateValueIfChanged(otherNode);
            }
            break a;
          case "textarea":
            updateTextarea(target, props2.value, props2.defaultValue);
            break a;
          case "select":
            internalInstance = props2.value, null != internalInstance && updateOptions(target, !!props2.multiple, internalInstance, false);
        }
      }
    }
    function batchedUpdates$1(fn2, a2, b2) {
      if (isInsideEventHandler) return fn2(a2, b2);
      isInsideEventHandler = true;
      try {
        var JSCompiler_inline_result = fn2(a2);
        return JSCompiler_inline_result;
      } finally {
        if (isInsideEventHandler = false, null !== restoreTarget || null !== restoreQueue) {
          if (flushSyncWork$1(), restoreTarget && (a2 = restoreTarget, fn2 = restoreQueue, restoreQueue = restoreTarget = null, restoreStateOfTarget(a2), fn2))
            for (a2 = 0; a2 < fn2.length; a2++) restoreStateOfTarget(fn2[a2]);
        }
      }
    }
    function getListener(inst, registrationName) {
      var stateNode = inst.stateNode;
      if (null === stateNode) return null;
      var props2 = stateNode[internalPropsKey] || null;
      if (null === props2) return null;
      stateNode = props2[registrationName];
      a: switch (registrationName) {
        case "onClick":
        case "onClickCapture":
        case "onDoubleClick":
        case "onDoubleClickCapture":
        case "onMouseDown":
        case "onMouseDownCapture":
        case "onMouseMove":
        case "onMouseMoveCapture":
        case "onMouseUp":
        case "onMouseUpCapture":
        case "onMouseEnter":
          (props2 = !props2.disabled) || (inst = inst.type, props2 = !("button" === inst || "input" === inst || "select" === inst || "textarea" === inst));
          inst = !props2;
          break a;
        default:
          inst = false;
      }
      if (inst) return null;
      if (stateNode && "function" !== typeof stateNode)
        throw Error(
          "Expected `" + registrationName + "` listener to be a function, instead got a value of `" + typeof stateNode + "` type."
        );
      return stateNode;
    }
    function getData() {
      if (fallbackText) return fallbackText;
      var start, startValue = startText, startLength = startValue.length, end, endValue = "value" in root2 ? root2.value : root2.textContent, endLength = endValue.length;
      for (start = 0; start < startLength && startValue[start] === endValue[start]; start++) ;
      var minEnd = startLength - start;
      for (end = 1; end <= minEnd && startValue[startLength - end] === endValue[endLength - end]; end++) ;
      return fallbackText = endValue.slice(start, 1 < end ? 1 - end : void 0);
    }
    function getEventCharCode(nativeEvent) {
      var keyCode = nativeEvent.keyCode;
      "charCode" in nativeEvent ? (nativeEvent = nativeEvent.charCode, 0 === nativeEvent && 13 === keyCode && (nativeEvent = 13)) : nativeEvent = keyCode;
      10 === nativeEvent && (nativeEvent = 13);
      return 32 <= nativeEvent || 13 === nativeEvent ? nativeEvent : 0;
    }
    function functionThatReturnsTrue() {
      return true;
    }
    function functionThatReturnsFalse() {
      return false;
    }
    function createSyntheticEvent(Interface) {
      function SyntheticBaseEvent(reactName, reactEventType, targetInst, nativeEvent, nativeEventTarget) {
        this._reactName = reactName;
        this._targetInst = targetInst;
        this.type = reactEventType;
        this.nativeEvent = nativeEvent;
        this.target = nativeEventTarget;
        this.currentTarget = null;
        for (var propName in Interface)
          Interface.hasOwnProperty(propName) && (reactName = Interface[propName], this[propName] = reactName ? reactName(nativeEvent) : nativeEvent[propName]);
        this.isDefaultPrevented = (null != nativeEvent.defaultPrevented ? nativeEvent.defaultPrevented : false === nativeEvent.returnValue) ? functionThatReturnsTrue : functionThatReturnsFalse;
        this.isPropagationStopped = functionThatReturnsFalse;
        return this;
      }
      assign2(SyntheticBaseEvent.prototype, {
        preventDefault: function() {
          this.defaultPrevented = true;
          var event = this.nativeEvent;
          event && (event.preventDefault ? event.preventDefault() : "unknown" !== typeof event.returnValue && (event.returnValue = false), this.isDefaultPrevented = functionThatReturnsTrue);
        },
        stopPropagation: function() {
          var event = this.nativeEvent;
          event && (event.stopPropagation ? event.stopPropagation() : "unknown" !== typeof event.cancelBubble && (event.cancelBubble = true), this.isPropagationStopped = functionThatReturnsTrue);
        },
        persist: function() {
        },
        isPersistent: functionThatReturnsTrue
      });
      return SyntheticBaseEvent;
    }
    function modifierStateGetter(keyArg) {
      var nativeEvent = this.nativeEvent;
      return nativeEvent.getModifierState ? nativeEvent.getModifierState(keyArg) : (keyArg = modifierKeyToProp[keyArg]) ? !!nativeEvent[keyArg] : false;
    }
    function getEventModifierState() {
      return modifierStateGetter;
    }
    function isFallbackCompositionEnd(domEventName, nativeEvent) {
      switch (domEventName) {
        case "keyup":
          return -1 !== END_KEYCODES.indexOf(nativeEvent.keyCode);
        case "keydown":
          return nativeEvent.keyCode !== START_KEYCODE;
        case "keypress":
        case "mousedown":
        case "focusout":
          return true;
        default:
          return false;
      }
    }
    function getDataFromCustomEvent(nativeEvent) {
      nativeEvent = nativeEvent.detail;
      return "object" === typeof nativeEvent && "data" in nativeEvent ? nativeEvent.data : null;
    }
    function getNativeBeforeInputChars(domEventName, nativeEvent) {
      switch (domEventName) {
        case "compositionend":
          return getDataFromCustomEvent(nativeEvent);
        case "keypress":
          if (nativeEvent.which !== SPACEBAR_CODE) return null;
          hasSpaceKeypress = true;
          return SPACEBAR_CHAR;
        case "textInput":
          return domEventName = nativeEvent.data, domEventName === SPACEBAR_CHAR && hasSpaceKeypress ? null : domEventName;
        default:
          return null;
      }
    }
    function getFallbackBeforeInputChars(domEventName, nativeEvent) {
      if (isComposing)
        return "compositionend" === domEventName || !canUseCompositionEvent && isFallbackCompositionEnd(domEventName, nativeEvent) ? (domEventName = getData(), fallbackText = startText = root2 = null, isComposing = false, domEventName) : null;
      switch (domEventName) {
        case "paste":
          return null;
        case "keypress":
          if (!(nativeEvent.ctrlKey || nativeEvent.altKey || nativeEvent.metaKey) || nativeEvent.ctrlKey && nativeEvent.altKey) {
            if (nativeEvent.char && 1 < nativeEvent.char.length)
              return nativeEvent.char;
            if (nativeEvent.which)
              return String.fromCharCode(nativeEvent.which);
          }
          return null;
        case "compositionend":
          return useFallbackCompositionData && "ko" !== nativeEvent.locale ? null : nativeEvent.data;
        default:
          return null;
      }
    }
    function isTextInputElement(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return "input" === nodeName ? !!supportedInputTypes[elem.type] : "textarea" === nodeName ? true : false;
    }
    function isEventSupported(eventNameSuffix) {
      if (!canUseDOM2) return false;
      eventNameSuffix = "on" + eventNameSuffix;
      var isSupported = eventNameSuffix in document;
      isSupported || (isSupported = document.createElement("div"), isSupported.setAttribute(eventNameSuffix, "return;"), isSupported = "function" === typeof isSupported[eventNameSuffix]);
      return isSupported;
    }
    function createAndAccumulateChangeEvent(dispatchQueue, inst, nativeEvent, target) {
      restoreTarget ? restoreQueue ? restoreQueue.push(target) : restoreQueue = [target] : restoreTarget = target;
      inst = accumulateTwoPhaseListeners(inst, "onChange");
      0 < inst.length && (nativeEvent = new SyntheticEvent(
        "onChange",
        "change",
        null,
        nativeEvent,
        target
      ), dispatchQueue.push({ event: nativeEvent, listeners: inst }));
    }
    function runEventInBatch(dispatchQueue) {
      processDispatchQueue(dispatchQueue, 0);
    }
    function getInstIfValueChanged(targetInst) {
      var targetNode = getNodeFromInstance(targetInst);
      if (updateValueIfChanged(targetNode)) return targetInst;
    }
    function getTargetInstForChangeEvent(domEventName, targetInst) {
      if ("change" === domEventName) return targetInst;
    }
    function stopWatchingForValueChange() {
      activeElement$1 && (activeElement$1.detachEvent("onpropertychange", handlePropertyChange), activeElementInst$1 = activeElement$1 = null);
    }
    function handlePropertyChange(nativeEvent) {
      if ("value" === nativeEvent.propertyName && getInstIfValueChanged(activeElementInst$1)) {
        var dispatchQueue = [];
        createAndAccumulateChangeEvent(
          dispatchQueue,
          activeElementInst$1,
          nativeEvent,
          getEventTarget(nativeEvent)
        );
        batchedUpdates$1(runEventInBatch, dispatchQueue);
      }
    }
    function handleEventsForInputEventPolyfill(domEventName, target, targetInst) {
      "focusin" === domEventName ? (stopWatchingForValueChange(), activeElement$1 = target, activeElementInst$1 = targetInst, activeElement$1.attachEvent("onpropertychange", handlePropertyChange)) : "focusout" === domEventName && stopWatchingForValueChange();
    }
    function getTargetInstForInputEventPolyfill(domEventName) {
      if ("selectionchange" === domEventName || "keyup" === domEventName || "keydown" === domEventName)
        return getInstIfValueChanged(activeElementInst$1);
    }
    function getTargetInstForClickEvent(domEventName, targetInst) {
      if ("click" === domEventName) return getInstIfValueChanged(targetInst);
    }
    function getTargetInstForInputOrChangeEvent(domEventName, targetInst) {
      if ("input" === domEventName || "change" === domEventName)
        return getInstIfValueChanged(targetInst);
    }
    function is2(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    function shallowEqual(objA, objB) {
      if (objectIs(objA, objB)) return true;
      if ("object" !== typeof objA || null === objA || "object" !== typeof objB || null === objB)
        return false;
      var keysA = Object.keys(objA), keysB = Object.keys(objB);
      if (keysA.length !== keysB.length) return false;
      for (keysB = 0; keysB < keysA.length; keysB++) {
        var currentKey = keysA[keysB];
        if (!hasOwnProperty2.call(objB, currentKey) || !objectIs(objA[currentKey], objB[currentKey]))
          return false;
      }
      return true;
    }
    function getLeafNode(node) {
      for (; node && node.firstChild; ) node = node.firstChild;
      return node;
    }
    function getNodeForCharacterOffset(root3, offset2) {
      var node = getLeafNode(root3);
      root3 = 0;
      for (var nodeEnd; node; ) {
        if (3 === node.nodeType) {
          nodeEnd = root3 + node.textContent.length;
          if (root3 <= offset2 && nodeEnd >= offset2)
            return { node, offset: offset2 - root3 };
          root3 = nodeEnd;
        }
        a: {
          for (; node; ) {
            if (node.nextSibling) {
              node = node.nextSibling;
              break a;
            }
            node = node.parentNode;
          }
          node = void 0;
        }
        node = getLeafNode(node);
      }
    }
    function containsNode(outerNode, innerNode) {
      return outerNode && innerNode ? outerNode === innerNode ? true : outerNode && 3 === outerNode.nodeType ? false : innerNode && 3 === innerNode.nodeType ? containsNode(outerNode, innerNode.parentNode) : "contains" in outerNode ? outerNode.contains(innerNode) : outerNode.compareDocumentPosition ? !!(outerNode.compareDocumentPosition(innerNode) & 16) : false : false;
    }
    function getActiveElementDeep(containerInfo) {
      containerInfo = null != containerInfo && null != containerInfo.ownerDocument && null != containerInfo.ownerDocument.defaultView ? containerInfo.ownerDocument.defaultView : window;
      for (var element2 = getActiveElement2(containerInfo.document); element2 instanceof containerInfo.HTMLIFrameElement; ) {
        try {
          var JSCompiler_inline_result = "string" === typeof element2.contentWindow.location.href;
        } catch (err) {
          JSCompiler_inline_result = false;
        }
        if (JSCompiler_inline_result) containerInfo = element2.contentWindow;
        else break;
        element2 = getActiveElement2(containerInfo.document);
      }
      return element2;
    }
    function hasSelectionCapabilities(elem) {
      var nodeName = elem && elem.nodeName && elem.nodeName.toLowerCase();
      return nodeName && ("input" === nodeName && ("text" === elem.type || "search" === elem.type || "tel" === elem.type || "url" === elem.type || "password" === elem.type) || "textarea" === nodeName || "true" === elem.contentEditable);
    }
    function constructSelectEvent(dispatchQueue, nativeEvent, nativeEventTarget) {
      var doc2 = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget.document : 9 === nativeEventTarget.nodeType ? nativeEventTarget : nativeEventTarget.ownerDocument;
      mouseDown || null == activeElement || activeElement !== getActiveElement2(doc2) || (doc2 = activeElement, "selectionStart" in doc2 && hasSelectionCapabilities(doc2) ? doc2 = { start: doc2.selectionStart, end: doc2.selectionEnd } : (doc2 = (doc2.ownerDocument && doc2.ownerDocument.defaultView || window).getSelection(), doc2 = {
        anchorNode: doc2.anchorNode,
        anchorOffset: doc2.anchorOffset,
        focusNode: doc2.focusNode,
        focusOffset: doc2.focusOffset
      }), lastSelection && shallowEqual(lastSelection, doc2) || (lastSelection = doc2, doc2 = accumulateTwoPhaseListeners(activeElementInst, "onSelect"), 0 < doc2.length && (nativeEvent = new SyntheticEvent(
        "onSelect",
        "select",
        null,
        nativeEvent,
        nativeEventTarget
      ), dispatchQueue.push({ event: nativeEvent, listeners: doc2 }), nativeEvent.target = activeElement)));
    }
    function makePrefixMap(styleProp, eventName) {
      var prefixes = {};
      prefixes[styleProp.toLowerCase()] = eventName.toLowerCase();
      prefixes["Webkit" + styleProp] = "webkit" + eventName;
      prefixes["Moz" + styleProp] = "moz" + eventName;
      return prefixes;
    }
    function getVendorPrefixedEventName(eventName) {
      if (prefixedEventNames[eventName]) return prefixedEventNames[eventName];
      if (!vendorPrefixes[eventName]) return eventName;
      var prefixMap = vendorPrefixes[eventName], styleProp;
      for (styleProp in prefixMap)
        if (prefixMap.hasOwnProperty(styleProp) && styleProp in style)
          return prefixedEventNames[eventName] = prefixMap[styleProp];
      return eventName;
    }
    function registerSimpleEvent(domEventName, reactName) {
      topLevelEventsToReactNames.set(domEventName, reactName);
      registerTwoPhaseEvent(reactName, [domEventName]);
    }
    function getArrayKind(array) {
      for (var kind = EMPTY_ARRAY, i2 = 0; i2 < array.length; i2++) {
        var value = array[i2];
        if ("object" === typeof value && null !== value)
          if (isArrayImpl(value) && 2 === value.length && "string" === typeof value[0]) {
            if (kind !== EMPTY_ARRAY && kind !== ENTRIES_ARRAY)
              return COMPLEX_ARRAY;
            kind = ENTRIES_ARRAY;
          } else return COMPLEX_ARRAY;
        else {
          if ("function" === typeof value || "string" === typeof value && 50 < value.length || kind !== EMPTY_ARRAY && kind !== PRIMITIVE_ARRAY)
            return COMPLEX_ARRAY;
          kind = PRIMITIVE_ARRAY;
        }
      }
      return kind;
    }
    function addObjectToProperties(object2, properties2, indent2, prefix2) {
      for (var key in object2)
        hasOwnProperty2.call(object2, key) && "_" !== key[0] && addValueToProperties(key, object2[key], properties2, indent2, prefix2);
    }
    function addValueToProperties(propertyName2, value, properties2, indent2, prefix2) {
      switch (typeof value) {
        case "object":
          if (null === value) {
            value = "null";
            break;
          } else {
            if (value.$$typeof === REACT_ELEMENT_TYPE) {
              var typeName3 = getComponentNameFromType(value.type) || "…", key = value.key;
              value = value.props;
              var propsKeys = Object.keys(value), propsLength = propsKeys.length;
              if (null == key && 0 === propsLength) {
                value = "<" + typeName3 + " />";
                break;
              }
              if (3 > indent2 || 1 === propsLength && "children" === propsKeys[0] && null == key) {
                value = "<" + typeName3 + " … />";
                break;
              }
              properties2.push([
                prefix2 + "  ".repeat(indent2) + propertyName2,
                "<" + typeName3
              ]);
              null !== key && addValueToProperties(
                "key",
                key,
                properties2,
                indent2 + 1,
                prefix2
              );
              propertyName2 = false;
              for (var propKey in value)
                "children" === propKey ? null != value.children && (!isArrayImpl(value.children) || 0 < value.children.length) && (propertyName2 = true) : hasOwnProperty2.call(value, propKey) && "_" !== propKey[0] && addValueToProperties(
                  propKey,
                  value[propKey],
                  properties2,
                  indent2 + 1,
                  prefix2
                );
              properties2.push([
                "",
                propertyName2 ? ">…</" + typeName3 + ">" : "/>"
              ]);
              return;
            }
            typeName3 = Object.prototype.toString.call(value);
            typeName3 = typeName3.slice(8, typeName3.length - 1);
            if ("Array" === typeName3) {
              if (propKey = getArrayKind(value), propKey === PRIMITIVE_ARRAY || propKey === EMPTY_ARRAY) {
                value = JSON.stringify(value);
                break;
              } else if (propKey === ENTRIES_ARRAY) {
                properties2.push([
                  prefix2 + "  ".repeat(indent2) + propertyName2,
                  ""
                ]);
                for (propertyName2 = 0; propertyName2 < value.length; propertyName2++)
                  typeName3 = value[propertyName2], addValueToProperties(
                    typeName3[0],
                    typeName3[1],
                    properties2,
                    indent2 + 1,
                    prefix2
                  );
                return;
              }
            }
            if ("Promise" === typeName3) {
              if ("fulfilled" === value.status) {
                if (typeName3 = properties2.length, addValueToProperties(
                  propertyName2,
                  value.value,
                  properties2,
                  indent2,
                  prefix2
                ), properties2.length > typeName3) {
                  properties2 = properties2[typeName3];
                  properties2[1] = "Promise<" + (properties2[1] || "Object") + ">";
                  return;
                }
              } else if ("rejected" === value.status && (typeName3 = properties2.length, addValueToProperties(
                propertyName2,
                value.reason,
                properties2,
                indent2,
                prefix2
              ), properties2.length > typeName3)) {
                properties2 = properties2[typeName3];
                properties2[1] = "Rejected Promise<" + properties2[1] + ">";
                return;
              }
              properties2.push([
                "  ".repeat(indent2) + propertyName2,
                "Promise"
              ]);
              return;
            }
            "Object" === typeName3 && (propKey = Object.getPrototypeOf(value)) && "function" === typeof propKey.constructor && (typeName3 = propKey.constructor.name);
            properties2.push([
              prefix2 + "  ".repeat(indent2) + propertyName2,
              "Object" === typeName3 ? 3 > indent2 ? "" : "…" : typeName3
            ]);
            3 > indent2 && addObjectToProperties(value, properties2, indent2 + 1, prefix2);
            return;
          }
        case "function":
          value = "" === value.name ? "() => {}" : value.name + "() {}";
          break;
        case "string":
          value = value === OMITTED_PROP_ERROR ? "…" : JSON.stringify(value);
          break;
        case "undefined":
          value = "undefined";
          break;
        case "boolean":
          value = value ? "true" : "false";
          break;
        default:
          value = String(value);
      }
      properties2.push([
        prefix2 + "  ".repeat(indent2) + propertyName2,
        value
      ]);
    }
    function addObjectDiffToProperties(prev, next, properties2, indent2) {
      var isDeeplyEqual = true;
      for (key in prev)
        key in next || (properties2.push([
          REMOVED + "  ".repeat(indent2) + key,
          "…"
        ]), isDeeplyEqual = false);
      for (var _key in next)
        if (_key in prev) {
          var key = prev[_key];
          var nextValue = next[_key];
          if (key !== nextValue) {
            if (0 === indent2 && "children" === _key)
              isDeeplyEqual = "  ".repeat(indent2) + _key, properties2.push(
                [REMOVED + isDeeplyEqual, "…"],
                [ADDED + isDeeplyEqual, "…"]
              );
            else {
              if (!(3 <= indent2)) {
                if ("object" === typeof key && "object" === typeof nextValue && null !== key && null !== nextValue && key.$$typeof === nextValue.$$typeof)
                  if (nextValue.$$typeof === REACT_ELEMENT_TYPE) {
                    if (key.type === nextValue.type && key.key === nextValue.key) {
                      key = getComponentNameFromType(nextValue.type) || "…";
                      isDeeplyEqual = "  ".repeat(indent2) + _key;
                      key = "<" + key + " … />";
                      properties2.push(
                        [REMOVED + isDeeplyEqual, key],
                        [ADDED + isDeeplyEqual, key]
                      );
                      isDeeplyEqual = false;
                      continue;
                    }
                  } else {
                    var prevKind = Object.prototype.toString.call(key), nextKind = Object.prototype.toString.call(nextValue);
                    if (prevKind === nextKind && ("[object Object]" === nextKind || "[object Array]" === nextKind)) {
                      prevKind = [
                        UNCHANGED + "  ".repeat(indent2) + _key,
                        "[object Array]" === nextKind ? "Array" : ""
                      ];
                      properties2.push(prevKind);
                      nextKind = properties2.length;
                      addObjectDiffToProperties(
                        key,
                        nextValue,
                        properties2,
                        indent2 + 1
                      ) ? nextKind === properties2.length && (prevKind[1] = "Referentially unequal but deeply equal objects. Consider memoization.") : isDeeplyEqual = false;
                      continue;
                    }
                  }
                else if ("function" === typeof key && "function" === typeof nextValue && key.name === nextValue.name && key.length === nextValue.length && (prevKind = Function.prototype.toString.call(key), nextKind = Function.prototype.toString.call(nextValue), prevKind === nextKind)) {
                  key = "" === nextValue.name ? "() => {}" : nextValue.name + "() {}";
                  properties2.push([
                    UNCHANGED + "  ".repeat(indent2) + _key,
                    key + " Referentially unequal function closure. Consider memoization."
                  ]);
                  continue;
                }
              }
              addValueToProperties(_key, key, properties2, indent2, REMOVED);
              addValueToProperties(_key, nextValue, properties2, indent2, ADDED);
            }
            isDeeplyEqual = false;
          }
        } else
          properties2.push([
            ADDED + "  ".repeat(indent2) + _key,
            "…"
          ]), isDeeplyEqual = false;
      return isDeeplyEqual;
    }
    function setCurrentTrackFromLanes(lanes) {
      currentTrack = lanes & 63 ? "Blocking" : lanes & 64 ? "Gesture" : lanes & 4194176 ? "Transition" : lanes & 62914560 ? "Suspense" : lanes & 2080374784 ? "Idle" : "Other";
    }
    function logComponentTrigger(fiber, startTime, endTime, trigger) {
      supportsUserTiming && (reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = trigger, reusableComponentDevToolDetails.properties = null, (fiber = fiber._debugTask) ? fiber.run(
        performance.measure.bind(
          performance,
          trigger,
          reusableComponentOptions
        )
      ) : performance.measure(trigger, reusableComponentOptions));
    }
    function logComponentReappeared(fiber, startTime, endTime) {
      logComponentTrigger(fiber, startTime, endTime, "Reconnect");
    }
    function logComponentRender(fiber, startTime, endTime, wasHydrated, committedLanes) {
      var name2 = getComponentNameFromFiber(fiber);
      if (null !== name2 && supportsUserTiming) {
        var alternate = fiber.alternate, selfTime = fiber.actualDuration;
        if (null === alternate || alternate.child !== fiber.child)
          for (var child = fiber.child; null !== child; child = child.sibling)
            selfTime -= child.actualDuration;
        wasHydrated = 0.5 > selfTime ? wasHydrated ? "tertiary-light" : "primary-light" : 10 > selfTime ? wasHydrated ? "tertiary" : "primary" : 100 > selfTime ? wasHydrated ? "tertiary-dark" : "primary-dark" : "error";
        var props2 = fiber.memoizedProps;
        selfTime = fiber._debugTask;
        null !== props2 && null !== alternate && alternate.memoizedProps !== props2 ? (child = [resuableChangedPropsEntry], props2 = addObjectDiffToProperties(
          alternate.memoizedProps,
          props2,
          child,
          0
        ), 1 < child.length && (props2 && !alreadyWarnedForDeepEquality && 0 === (alternate.lanes & committedLanes) && 100 < fiber.actualDuration ? (alreadyWarnedForDeepEquality = true, child[0] = reusableDeeplyEqualPropsEntry, reusableComponentDevToolDetails.color = "warning", reusableComponentDevToolDetails.tooltipText = DEEP_EQUALITY_WARNING) : (reusableComponentDevToolDetails.color = wasHydrated, reusableComponentDevToolDetails.tooltipText = name2), reusableComponentDevToolDetails.properties = child, reusableComponentOptions.start = startTime, reusableComponentOptions.end = endTime, null != selfTime ? selfTime.run(
          performance.measure.bind(
            performance,
            "​" + name2,
            reusableComponentOptions
          )
        ) : performance.measure(
          "​" + name2,
          reusableComponentOptions
        ))) : null != selfTime ? selfTime.run(
          console.timeStamp.bind(
            console,
            name2,
            startTime,
            endTime,
            COMPONENTS_TRACK,
            void 0,
            wasHydrated
          )
        ) : console.timeStamp(
          name2,
          startTime,
          endTime,
          COMPONENTS_TRACK,
          void 0,
          wasHydrated
        );
      }
    }
    function logComponentErrored(fiber, startTime, endTime, errors2) {
      if (supportsUserTiming) {
        var name2 = getComponentNameFromFiber(fiber);
        if (null !== name2) {
          for (var debugTask = null, properties2 = [], i2 = 0; i2 < errors2.length; i2++) {
            var capturedValue = errors2[i2];
            null == debugTask && null !== capturedValue.source && (debugTask = capturedValue.source._debugTask);
            capturedValue = capturedValue.value;
            properties2.push([
              "Error",
              "object" === typeof capturedValue && null !== capturedValue && "string" === typeof capturedValue.message ? String(capturedValue.message) : String(capturedValue)
            ]);
          }
          null !== fiber.key && addValueToProperties("key", fiber.key, properties2, 0, "");
          null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, properties2, 0, "");
          null == debugTask && (debugTask = fiber._debugTask);
          fiber = {
            start: startTime,
            end: endTime,
            detail: {
              devtools: {
                color: "error",
                track: COMPONENTS_TRACK,
                tooltipText: 13 === fiber.tag ? "Hydration failed" : "Error boundary caught an error",
                properties: properties2
              }
            }
          };
          debugTask ? debugTask.run(
            performance.measure.bind(performance, "​" + name2, fiber)
          ) : performance.measure("​" + name2, fiber);
        }
      }
    }
    function logComponentEffect(fiber, startTime, endTime, selfTime, errors2) {
      if (null !== errors2) {
        if (supportsUserTiming) {
          var name2 = getComponentNameFromFiber(fiber);
          if (null !== name2) {
            selfTime = [];
            for (var i2 = 0; i2 < errors2.length; i2++) {
              var error = errors2[i2].value;
              selfTime.push([
                "Error",
                "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
              ]);
            }
            null !== fiber.key && addValueToProperties("key", fiber.key, selfTime, 0, "");
            null !== fiber.memoizedProps && addObjectToProperties(fiber.memoizedProps, selfTime, 0, "");
            startTime = {
              start: startTime,
              end: endTime,
              detail: {
                devtools: {
                  color: "error",
                  track: COMPONENTS_TRACK,
                  tooltipText: "A lifecycle or effect errored",
                  properties: selfTime
                }
              }
            };
            (fiber = fiber._debugTask) ? fiber.run(
              performance.measure.bind(
                performance,
                "​" + name2,
                startTime
              )
            ) : performance.measure("​" + name2, startTime);
          }
        }
      } else
        name2 = getComponentNameFromFiber(fiber), null !== name2 && supportsUserTiming && (errors2 = 1 > selfTime ? "secondary-light" : 100 > selfTime ? "secondary" : 500 > selfTime ? "secondary-dark" : "error", (fiber = fiber._debugTask) ? fiber.run(
          console.timeStamp.bind(
            console,
            name2,
            startTime,
            endTime,
            COMPONENTS_TRACK,
            void 0,
            errors2
          )
        ) : console.timeStamp(
          name2,
          startTime,
          endTime,
          COMPONENTS_TRACK,
          void 0,
          errors2
        ));
    }
    function logRenderPhase(startTime, endTime, lanes, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime)) {
        var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark";
        lanes = (lanes & 536870912) === lanes ? "Prepared" : (lanes & 201326741) === lanes ? "Hydrated" : "Render";
        debugTask ? debugTask.run(
          console.timeStamp.bind(
            console,
            lanes,
            startTime,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            color
          )
        ) : console.timeStamp(
          lanes,
          startTime,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          color
        );
      }
    }
    function logSuspendedRenderPhase(startTime, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Prewarm",
          startTime,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          lanes
        )
      ) : console.timeStamp(
        "Prewarm",
        startTime,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        lanes
      ));
    }
    function logSuspendedWithDelayPhase(startTime, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime || (lanes = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Suspended",
          startTime,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          lanes
        )
      ) : console.timeStamp(
        "Suspended",
        startTime,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        lanes
      ));
    }
    function logRecoveredRenderPhase(startTime, endTime, lanes, recoverableErrors, hydrationFailed, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime)) {
        lanes = [];
        for (var i2 = 0; i2 < recoverableErrors.length; i2++) {
          var error = recoverableErrors[i2].value;
          lanes.push([
            "Recoverable Error",
            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
          ]);
        }
        startTime = {
          start: startTime,
          end: endTime,
          detail: {
            devtools: {
              color: "primary-dark",
              track: currentTrack,
              trackGroup: LANES_TRACK_GROUP,
              tooltipText: hydrationFailed ? "Hydration Failed" : "Recovered after Error",
              properties: lanes
            }
          }
        };
        debugTask ? debugTask.run(
          performance.measure.bind(performance, "Recovered", startTime)
        ) : performance.measure("Recovered", startTime);
      }
    }
    function logErroredRenderPhase(startTime, endTime, lanes, debugTask) {
      !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          "Errored",
          startTime,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "error"
        )
      ) : console.timeStamp(
        "Errored",
        startTime,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "error"
      ));
    }
    function logSuspendedCommitPhase(startTime, endTime, reason, debugTask) {
      !supportsUserTiming || endTime <= startTime || (debugTask ? debugTask.run(
        console.timeStamp.bind(
          console,
          reason,
          startTime,
          endTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "secondary-light"
        )
      ) : console.timeStamp(
        reason,
        startTime,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "secondary-light"
      ));
    }
    function logCommitErrored(startTime, endTime, errors2, passive, debugTask) {
      if (supportsUserTiming && !(endTime <= startTime)) {
        for (var properties2 = [], i2 = 0; i2 < errors2.length; i2++) {
          var error = errors2[i2].value;
          properties2.push([
            "Error",
            "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error)
          ]);
        }
        startTime = {
          start: startTime,
          end: endTime,
          detail: {
            devtools: {
              color: "error",
              track: currentTrack,
              trackGroup: LANES_TRACK_GROUP,
              tooltipText: passive ? "Remaining Effects Errored" : "Commit Errored",
              properties: properties2
            }
          }
        };
        debugTask ? debugTask.run(
          performance.measure.bind(performance, "Errored", startTime)
        ) : performance.measure("Errored", startTime);
      }
    }
    function logAnimatingPhase(startTime, endTime, debugTask) {
      !supportsUserTiming || endTime <= startTime || console.timeStamp(
        "Animating",
        startTime,
        endTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "secondary-dark"
      );
    }
    function finishQueueingConcurrentUpdates() {
      for (var endIndex = concurrentQueuesIndex, i2 = concurrentlyUpdatedLanes = concurrentQueuesIndex = 0; i2 < endIndex; ) {
        var fiber = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var queue = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var update = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        var lane = concurrentQueues[i2];
        concurrentQueues[i2++] = null;
        if (null !== queue && null !== update) {
          var pending = queue.pending;
          null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
          queue.pending = update;
        }
        0 !== lane && markUpdateLaneFromFiberToRoot(fiber, update, lane);
      }
    }
    function enqueueUpdate$1(fiber, queue, update, lane) {
      concurrentQueues[concurrentQueuesIndex++] = fiber;
      concurrentQueues[concurrentQueuesIndex++] = queue;
      concurrentQueues[concurrentQueuesIndex++] = update;
      concurrentQueues[concurrentQueuesIndex++] = lane;
      concurrentlyUpdatedLanes |= lane;
      fiber.lanes |= lane;
      fiber = fiber.alternate;
      null !== fiber && (fiber.lanes |= lane);
    }
    function enqueueConcurrentHookUpdate(fiber, queue, update, lane) {
      enqueueUpdate$1(fiber, queue, update, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function enqueueConcurrentRenderForLane(fiber, lane) {
      enqueueUpdate$1(fiber, null, null, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function markUpdateLaneFromFiberToRoot(sourceFiber, update, lane) {
      sourceFiber.lanes |= lane;
      var alternate = sourceFiber.alternate;
      null !== alternate && (alternate.lanes |= lane);
      for (var isHidden2 = false, parent = sourceFiber.return; null !== parent; )
        parent.childLanes |= lane, alternate = parent.alternate, null !== alternate && (alternate.childLanes |= lane), 22 === parent.tag && (sourceFiber = parent.stateNode, null === sourceFiber || sourceFiber._visibility & OffscreenVisible || (isHidden2 = true)), sourceFiber = parent, parent = parent.return;
      return 3 === sourceFiber.tag ? (parent = sourceFiber.stateNode, isHidden2 && null !== update && (isHidden2 = 31 - clz32(lane), sourceFiber = parent.hiddenUpdates, alternate = sourceFiber[isHidden2], null === alternate ? sourceFiber[isHidden2] = [update] : alternate.push(update), update.lane = lane | 536870912), parent) : null;
    }
    function getRootForUpdatedFiber(sourceFiber) {
      if (nestedUpdateCount > NESTED_UPDATE_LIMIT)
        throw nestedPassiveUpdateCount = nestedUpdateCount = 0, rootWithPassiveNestedUpdates = rootWithNestedUpdates = null, Error(
          "Maximum update depth exceeded. This can happen when a component repeatedly calls setState inside componentWillUpdate or componentDidUpdate. React limits the number of nested updates to prevent infinite loops."
        );
      nestedPassiveUpdateCount > NESTED_PASSIVE_UPDATE_LIMIT && (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, console.error(
        "Maximum update depth exceeded. This can happen when a component calls setState inside useEffect, but useEffect either doesn't have a dependency array, or one of the dependencies changes on every render."
      ));
      null === sourceFiber.alternate && 0 !== (sourceFiber.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber);
      for (var node = sourceFiber, parent = node.return; null !== parent; )
        null === node.alternate && 0 !== (node.flags & 4098) && warnAboutUpdateOnNotYetMountedFiberInDEV(sourceFiber), node = parent, parent = node.return;
      return 3 === node.tag ? node.stateNode : null;
    }
    function resolveFunctionForHotReloading(type) {
      if (null === resolveFamily) return type;
      var family = resolveFamily(type);
      return void 0 === family ? type : family.current;
    }
    function resolveForwardRefForHotReloading(type) {
      if (null === resolveFamily) return type;
      var family = resolveFamily(type);
      return void 0 === family ? null !== type && void 0 !== type && "function" === typeof type.render && (family = resolveFunctionForHotReloading(type.render), type.render !== family) ? (family = { $$typeof: REACT_FORWARD_REF_TYPE, render: family }, void 0 !== type.displayName && (family.displayName = type.displayName), family) : type : family.current;
    }
    function isCompatibleFamilyForHotReloading(fiber, element2) {
      if (null === resolveFamily) return false;
      var prevType = fiber.elementType;
      element2 = element2.type;
      var needsCompareFamilies = false, $$typeofNextType = "object" === typeof element2 && null !== element2 ? element2.$$typeof : null;
      switch (fiber.tag) {
        case 1:
          "function" === typeof element2 && (needsCompareFamilies = true);
          break;
        case 0:
          "function" === typeof element2 ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 11:
          $$typeofNextType === REACT_FORWARD_REF_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        case 14:
        case 15:
          $$typeofNextType === REACT_MEMO_TYPE ? needsCompareFamilies = true : $$typeofNextType === REACT_LAZY_TYPE && (needsCompareFamilies = true);
          break;
        default:
          return false;
      }
      return needsCompareFamilies && (fiber = resolveFamily(prevType), void 0 !== fiber && fiber === resolveFamily(element2)) ? true : false;
    }
    function markFailedErrorBoundaryForHotReloading(fiber) {
      null !== resolveFamily && "function" === typeof WeakSet && (null === failedBoundaries && (failedBoundaries = /* @__PURE__ */ new WeakSet()), failedBoundaries.add(fiber));
    }
    function scheduleFibersWithFamiliesRecursively(fiber, updatedFamilies, staleFamilies) {
      do {
        var _fiber = fiber, alternate = _fiber.alternate, child = _fiber.child, sibling = _fiber.sibling, tag2 = _fiber.tag;
        _fiber = _fiber.type;
        var candidateType = null;
        switch (tag2) {
          case 0:
          case 15:
          case 1:
            candidateType = _fiber;
            break;
          case 11:
            candidateType = _fiber.render;
        }
        if (null === resolveFamily)
          throw Error("Expected resolveFamily to be set during hot reload.");
        var needsRender = false;
        _fiber = false;
        null !== candidateType && (candidateType = resolveFamily(candidateType), void 0 !== candidateType && (staleFamilies.has(candidateType) ? _fiber = true : updatedFamilies.has(candidateType) && (1 === tag2 ? _fiber = true : needsRender = true)));
        null !== failedBoundaries && (failedBoundaries.has(fiber) || null !== alternate && failedBoundaries.has(alternate)) && (_fiber = true);
        _fiber && (fiber._debugNeedsRemount = true);
        if (_fiber || needsRender)
          alternate = enqueueConcurrentRenderForLane(fiber, 2), null !== alternate && scheduleUpdateOnFiber(alternate, fiber, 2);
        null === child || _fiber || scheduleFibersWithFamiliesRecursively(
          child,
          updatedFamilies,
          staleFamilies
        );
        if (null === sibling) break;
        fiber = sibling;
      } while (1);
    }
    function FiberNode(tag2, pendingProps, key, mode) {
      this.tag = tag2;
      this.key = key;
      this.sibling = this.child = this.return = this.stateNode = this.type = this.elementType = null;
      this.index = 0;
      this.refCleanup = this.ref = null;
      this.pendingProps = pendingProps;
      this.dependencies = this.memoizedState = this.updateQueue = this.memoizedProps = null;
      this.mode = mode;
      this.subtreeFlags = this.flags = 0;
      this.deletions = null;
      this.childLanes = this.lanes = 0;
      this.alternate = null;
      this.actualDuration = -0;
      this.actualStartTime = -1.1;
      this.treeBaseDuration = this.selfBaseDuration = -0;
      this._debugTask = this._debugStack = this._debugOwner = this._debugInfo = null;
      this._debugNeedsRemount = false;
      this._debugHookTypes = null;
      hasBadMapPolyfill || "function" !== typeof Object.preventExtensions || Object.preventExtensions(this);
    }
    function shouldConstruct(Component) {
      Component = Component.prototype;
      return !(!Component || !Component.isReactComponent);
    }
    function createWorkInProgress(current3, pendingProps) {
      var workInProgress2 = current3.alternate;
      null === workInProgress2 ? (workInProgress2 = createFiber(
        current3.tag,
        pendingProps,
        current3.key,
        current3.mode
      ), workInProgress2.elementType = current3.elementType, workInProgress2.type = current3.type, workInProgress2.stateNode = current3.stateNode, workInProgress2._debugOwner = current3._debugOwner, workInProgress2._debugStack = current3._debugStack, workInProgress2._debugTask = current3._debugTask, workInProgress2._debugHookTypes = current3._debugHookTypes, workInProgress2.alternate = current3, current3.alternate = workInProgress2) : (workInProgress2.pendingProps = pendingProps, workInProgress2.type = current3.type, workInProgress2.flags = 0, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.actualDuration = -0, workInProgress2.actualStartTime = -1.1);
      workInProgress2.flags = current3.flags & 65011712;
      workInProgress2.childLanes = current3.childLanes;
      workInProgress2.lanes = current3.lanes;
      workInProgress2.child = current3.child;
      workInProgress2.memoizedProps = current3.memoizedProps;
      workInProgress2.memoizedState = current3.memoizedState;
      workInProgress2.updateQueue = current3.updateQueue;
      pendingProps = current3.dependencies;
      workInProgress2.dependencies = null === pendingProps ? null : {
        lanes: pendingProps.lanes,
        firstContext: pendingProps.firstContext,
        _debugThenableState: pendingProps._debugThenableState
      };
      workInProgress2.sibling = current3.sibling;
      workInProgress2.index = current3.index;
      workInProgress2.ref = current3.ref;
      workInProgress2.refCleanup = current3.refCleanup;
      workInProgress2.selfBaseDuration = current3.selfBaseDuration;
      workInProgress2.treeBaseDuration = current3.treeBaseDuration;
      workInProgress2._debugInfo = current3._debugInfo;
      workInProgress2._debugNeedsRemount = current3._debugNeedsRemount;
      switch (workInProgress2.tag) {
        case 0:
        case 15:
          workInProgress2.type = resolveFunctionForHotReloading(current3.type);
          break;
        case 1:
          workInProgress2.type = resolveFunctionForHotReloading(current3.type);
          break;
        case 11:
          workInProgress2.type = resolveForwardRefForHotReloading(current3.type);
      }
      return workInProgress2;
    }
    function resetWorkInProgress(workInProgress2, renderLanes2) {
      workInProgress2.flags &= 65011714;
      var current3 = workInProgress2.alternate;
      null === current3 ? (workInProgress2.childLanes = 0, workInProgress2.lanes = renderLanes2, workInProgress2.child = null, workInProgress2.subtreeFlags = 0, workInProgress2.memoizedProps = null, workInProgress2.memoizedState = null, workInProgress2.updateQueue = null, workInProgress2.dependencies = null, workInProgress2.stateNode = null, workInProgress2.selfBaseDuration = 0, workInProgress2.treeBaseDuration = 0) : (workInProgress2.childLanes = current3.childLanes, workInProgress2.lanes = current3.lanes, workInProgress2.child = current3.child, workInProgress2.subtreeFlags = 0, workInProgress2.deletions = null, workInProgress2.memoizedProps = current3.memoizedProps, workInProgress2.memoizedState = current3.memoizedState, workInProgress2.updateQueue = current3.updateQueue, workInProgress2.type = current3.type, renderLanes2 = current3.dependencies, workInProgress2.dependencies = null === renderLanes2 ? null : {
        lanes: renderLanes2.lanes,
        firstContext: renderLanes2.firstContext,
        _debugThenableState: renderLanes2._debugThenableState
      }, workInProgress2.selfBaseDuration = current3.selfBaseDuration, workInProgress2.treeBaseDuration = current3.treeBaseDuration);
      return workInProgress2;
    }
    function createFiberFromTypeAndProps(type, key, pendingProps, owner, mode, lanes) {
      var fiberTag = 0, resolvedType = type;
      if ("function" === typeof type)
        shouldConstruct(type) && (fiberTag = 1), resolvedType = resolveFunctionForHotReloading(resolvedType);
      else if ("string" === typeof type)
        fiberTag = getHostContext(), fiberTag = isHostHoistableType(type, pendingProps, fiberTag) ? 26 : "html" === type || "head" === type || "body" === type ? 27 : 5;
      else
        a: switch (type) {
          case REACT_ACTIVITY_TYPE:
            return key = createFiber(31, pendingProps, key, mode), key.elementType = REACT_ACTIVITY_TYPE, key.lanes = lanes, key;
          case REACT_FRAGMENT_TYPE:
            return createFiberFromFragment(
              pendingProps.children,
              mode,
              lanes,
              key
            );
          case REACT_STRICT_MODE_TYPE:
            fiberTag = 8;
            mode |= StrictLegacyMode;
            mode |= StrictEffectsMode;
            break;
          case REACT_PROFILER_TYPE:
            return type = pendingProps, owner = mode, "string" !== typeof type.id && console.error(
              'Profiler must specify an "id" of type `string` as a prop. Received the type `%s` instead.',
              typeof type.id
            ), key = createFiber(12, type, key, owner | ProfileMode), key.elementType = REACT_PROFILER_TYPE, key.lanes = lanes, key.stateNode = { effectDuration: 0, passiveEffectDuration: 0 }, key;
          case REACT_SUSPENSE_TYPE:
            return key = createFiber(13, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_TYPE, key.lanes = lanes, key;
          case REACT_SUSPENSE_LIST_TYPE:
            return key = createFiber(19, pendingProps, key, mode), key.elementType = REACT_SUSPENSE_LIST_TYPE, key.lanes = lanes, key;
          default:
            if ("object" === typeof type && null !== type)
              switch (type.$$typeof) {
                case REACT_CONTEXT_TYPE:
                  fiberTag = 10;
                  break a;
                case REACT_CONSUMER_TYPE:
                  fiberTag = 9;
                  break a;
                case REACT_FORWARD_REF_TYPE:
                  fiberTag = 11;
                  resolvedType = resolveForwardRefForHotReloading(resolvedType);
                  break a;
                case REACT_MEMO_TYPE:
                  fiberTag = 14;
                  break a;
                case REACT_LAZY_TYPE:
                  fiberTag = 16;
                  resolvedType = null;
                  break a;
              }
            resolvedType = "";
            if (void 0 === type || "object" === typeof type && null !== type && 0 === Object.keys(type).length)
              resolvedType += " You likely forgot to export your component from the file it's defined in, or you might have mixed up default and named imports.";
            null === type ? pendingProps = "null" : isArrayImpl(type) ? pendingProps = "array" : void 0 !== type && type.$$typeof === REACT_ELEMENT_TYPE ? (pendingProps = "<" + (getComponentNameFromType(type.type) || "Unknown") + " />", resolvedType = " Did you accidentally export a JSX literal instead of a component?") : pendingProps = typeof type;
            (fiberTag = owner ? getComponentNameFromOwner(owner) : null) && (resolvedType += "\n\nCheck the render method of `" + fiberTag + "`.");
            fiberTag = 29;
            pendingProps = Error(
              "Element type is invalid: expected a string (for built-in components) or a class/function (for composite components) but got: " + (pendingProps + "." + resolvedType)
            );
            resolvedType = null;
        }
      key = createFiber(fiberTag, pendingProps, key, mode);
      key.elementType = type;
      key.type = resolvedType;
      key.lanes = lanes;
      key._debugOwner = owner;
      return key;
    }
    function createFiberFromElement(element2, mode, lanes) {
      mode = createFiberFromTypeAndProps(
        element2.type,
        element2.key,
        element2.props,
        element2._owner,
        mode,
        lanes
      );
      mode._debugOwner = element2._owner;
      mode._debugStack = element2._debugStack;
      mode._debugTask = element2._debugTask;
      return mode;
    }
    function createFiberFromFragment(elements2, mode, lanes, key) {
      elements2 = createFiber(7, elements2, key, mode);
      elements2.lanes = lanes;
      return elements2;
    }
    function createFiberFromText(content2, mode, lanes) {
      content2 = createFiber(6, content2, null, mode);
      content2.lanes = lanes;
      return content2;
    }
    function createFiberFromDehydratedFragment(dehydratedNode) {
      var fiber = createFiber(18, null, null, NoMode);
      fiber.stateNode = dehydratedNode;
      return fiber;
    }
    function createFiberFromPortal(portal, mode, lanes) {
      mode = createFiber(
        4,
        null !== portal.children ? portal.children : [],
        portal.key,
        mode
      );
      mode.lanes = lanes;
      mode.stateNode = {
        containerInfo: portal.containerInfo,
        pendingChildren: null,
        implementation: portal.implementation
      };
      return mode;
    }
    function createCapturedValueAtFiber(value, source) {
      if ("object" === typeof value && null !== value) {
        var existing = CapturedStacks.get(value);
        if (void 0 !== existing) return existing;
        source = {
          value,
          source,
          stack: getStackByFiberInDevAndProd(source)
        };
        CapturedStacks.set(value, source);
        return source;
      }
      return {
        value,
        source,
        stack: getStackByFiberInDevAndProd(source)
      };
    }
    function pushTreeFork(workInProgress2, totalChildren) {
      warnIfNotHydrating();
      forkStack[forkStackIndex++] = treeForkCount;
      forkStack[forkStackIndex++] = treeForkProvider;
      treeForkProvider = workInProgress2;
      treeForkCount = totalChildren;
    }
    function pushTreeId(workInProgress2, totalChildren, index2) {
      warnIfNotHydrating();
      idStack[idStackIndex++] = treeContextId;
      idStack[idStackIndex++] = treeContextOverflow;
      idStack[idStackIndex++] = treeContextProvider;
      treeContextProvider = workInProgress2;
      var baseIdWithLeadingBit = treeContextId;
      workInProgress2 = treeContextOverflow;
      var baseLength = 32 - clz32(baseIdWithLeadingBit) - 1;
      baseIdWithLeadingBit &= ~(1 << baseLength);
      index2 += 1;
      var length = 32 - clz32(totalChildren) + baseLength;
      if (30 < length) {
        var numberOfOverflowBits = baseLength - baseLength % 5;
        length = (baseIdWithLeadingBit & (1 << numberOfOverflowBits) - 1).toString(32);
        baseIdWithLeadingBit >>= numberOfOverflowBits;
        baseLength -= numberOfOverflowBits;
        treeContextId = 1 << 32 - clz32(totalChildren) + baseLength | index2 << baseLength | baseIdWithLeadingBit;
        treeContextOverflow = length + workInProgress2;
      } else
        treeContextId = 1 << length | index2 << baseLength | baseIdWithLeadingBit, treeContextOverflow = workInProgress2;
    }
    function pushMaterializedTreeId(workInProgress2) {
      warnIfNotHydrating();
      null !== workInProgress2.return && (pushTreeFork(workInProgress2, 1), pushTreeId(workInProgress2, 1, 0));
    }
    function popTreeContext(workInProgress2) {
      for (; workInProgress2 === treeForkProvider; )
        treeForkProvider = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null, treeForkCount = forkStack[--forkStackIndex], forkStack[forkStackIndex] = null;
      for (; workInProgress2 === treeContextProvider; )
        treeContextProvider = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextOverflow = idStack[--idStackIndex], idStack[idStackIndex] = null, treeContextId = idStack[--idStackIndex], idStack[idStackIndex] = null;
    }
    function getSuspendedTreeContext() {
      warnIfNotHydrating();
      return null !== treeContextProvider ? { id: treeContextId, overflow: treeContextOverflow } : null;
    }
    function restoreSuspendedTreeContext(workInProgress2, suspendedContext) {
      warnIfNotHydrating();
      idStack[idStackIndex++] = treeContextId;
      idStack[idStackIndex++] = treeContextOverflow;
      idStack[idStackIndex++] = treeContextProvider;
      treeContextId = suspendedContext.id;
      treeContextOverflow = suspendedContext.overflow;
      treeContextProvider = workInProgress2;
    }
    function warnIfNotHydrating() {
      isHydrating || console.error(
        "Expected to be hydrating. This is a bug in React. Please file an issue."
      );
    }
    function buildHydrationDiffNode(fiber, distanceFromLeaf) {
      if (null === fiber.return) {
        if (null === hydrationDiffRootDEV)
          hydrationDiffRootDEV = {
            fiber,
            children: [],
            serverProps: void 0,
            serverTail: [],
            distanceFromLeaf
          };
        else {
          if (hydrationDiffRootDEV.fiber !== fiber)
            throw Error(
              "Saw multiple hydration diff roots in a pass. This is a bug in React."
            );
          hydrationDiffRootDEV.distanceFromLeaf > distanceFromLeaf && (hydrationDiffRootDEV.distanceFromLeaf = distanceFromLeaf);
        }
        return hydrationDiffRootDEV;
      }
      var siblings = buildHydrationDiffNode(
        fiber.return,
        distanceFromLeaf + 1
      ).children;
      if (0 < siblings.length && siblings[siblings.length - 1].fiber === fiber)
        return siblings = siblings[siblings.length - 1], siblings.distanceFromLeaf > distanceFromLeaf && (siblings.distanceFromLeaf = distanceFromLeaf), siblings;
      distanceFromLeaf = {
        fiber,
        children: [],
        serverProps: void 0,
        serverTail: [],
        distanceFromLeaf
      };
      siblings.push(distanceFromLeaf);
      return distanceFromLeaf;
    }
    function warnIfHydrating() {
      isHydrating && console.error(
        "We should not be hydrating here. This is a bug in React. Please file a bug."
      );
    }
    function warnNonHydratedInstance(fiber, rejectedCandidate) {
      didSuspendOrErrorDEV || (fiber = buildHydrationDiffNode(fiber, 0), fiber.serverProps = null, null !== rejectedCandidate && (rejectedCandidate = describeHydratableInstanceForDevWarnings(rejectedCandidate), fiber.serverTail.push(rejectedCandidate)));
    }
    function throwOnHydrationMismatch(fiber) {
      var fromText = 1 < arguments.length && void 0 !== arguments[1] ? arguments[1] : false, diff = "", diffRoot = hydrationDiffRootDEV;
      null !== diffRoot && (hydrationDiffRootDEV = null, diff = describeDiff(diffRoot));
      queueHydrationError(
        createCapturedValueAtFiber(
          Error(
            "Hydration failed because the server rendered " + (fromText ? "text" : "HTML") + " didn't match the client. As a result this tree will be regenerated on the client. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\nhttps://react.dev/link/hydration-mismatch" + diff
          ),
          fiber
        )
      );
      throw HydrationMismatchException;
    }
    function prepareToHydrateHostInstance(fiber) {
      var didHydrate = fiber.stateNode;
      var type = fiber.type, props2 = fiber.memoizedProps;
      didHydrate[internalInstanceKey] = fiber;
      didHydrate[internalPropsKey] = props2;
      validatePropertiesInDevelopment(type, props2);
      switch (type) {
        case "dialog":
          listenToNonDelegatedEvent("cancel", didHydrate);
          listenToNonDelegatedEvent("close", didHydrate);
          break;
        case "iframe":
        case "object":
        case "embed":
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "video":
        case "audio":
          for (type = 0; type < mediaEventTypes.length; type++)
            listenToNonDelegatedEvent(mediaEventTypes[type], didHydrate);
          break;
        case "source":
          listenToNonDelegatedEvent("error", didHydrate);
          break;
        case "img":
        case "image":
        case "link":
          listenToNonDelegatedEvent("error", didHydrate);
          listenToNonDelegatedEvent("load", didHydrate);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", didHydrate);
          break;
        case "input":
          checkControlledValueProps("input", props2);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateInputProps(didHydrate, props2);
          initInput(
            didHydrate,
            props2.value,
            props2.defaultValue,
            props2.checked,
            props2.defaultChecked,
            props2.type,
            props2.name,
            true
          );
          break;
        case "option":
          validateOptionProps(didHydrate, props2);
          break;
        case "select":
          checkControlledValueProps("select", props2);
          listenToNonDelegatedEvent("invalid", didHydrate);
          validateSelectProps(didHydrate, props2);
          break;
        case "textarea":
          checkControlledValueProps("textarea", props2), listenToNonDelegatedEvent("invalid", didHydrate), validateTextareaProps(didHydrate, props2), initTextarea(
            didHydrate,
            props2.value,
            props2.defaultValue,
            props2.children
          );
      }
      type = props2.children;
      "string" !== typeof type && "number" !== typeof type && "bigint" !== typeof type || didHydrate.textContent === "" + type || true === props2.suppressHydrationWarning || checkForUnmatchedText(didHydrate.textContent, type) ? (null != props2.popover && (listenToNonDelegatedEvent("beforetoggle", didHydrate), listenToNonDelegatedEvent("toggle", didHydrate)), null != props2.onScroll && listenToNonDelegatedEvent("scroll", didHydrate), null != props2.onScrollEnd && listenToNonDelegatedEvent("scrollend", didHydrate), null != props2.onClick && (didHydrate.onclick = noop$12), didHydrate = true) : didHydrate = false;
      didHydrate || throwOnHydrationMismatch(fiber, true);
    }
    function popToNextHostParent(fiber) {
      for (hydrationParentFiber = fiber.return; hydrationParentFiber; )
        switch (hydrationParentFiber.tag) {
          case 5:
          case 31:
          case 13:
            rootOrSingletonContext = false;
            return;
          case 27:
          case 3:
            rootOrSingletonContext = true;
            return;
          default:
            hydrationParentFiber = hydrationParentFiber.return;
        }
    }
    function popHydrationState(fiber) {
      if (fiber !== hydrationParentFiber) return false;
      if (!isHydrating)
        return popToNextHostParent(fiber), isHydrating = true, false;
      var tag2 = fiber.tag, JSCompiler_temp;
      if (JSCompiler_temp = 3 !== tag2 && 27 !== tag2) {
        if (JSCompiler_temp = 5 === tag2)
          JSCompiler_temp = fiber.type, JSCompiler_temp = !("form" !== JSCompiler_temp && "button" !== JSCompiler_temp) || shouldSetTextContent(fiber.type, fiber.memoizedProps);
        JSCompiler_temp = !JSCompiler_temp;
      }
      if (JSCompiler_temp && nextHydratableInstance) {
        for (JSCompiler_temp = nextHydratableInstance; JSCompiler_temp; ) {
          var diffNode = buildHydrationDiffNode(fiber, 0), description = describeHydratableInstanceForDevWarnings(JSCompiler_temp);
          diffNode.serverTail.push(description);
          JSCompiler_temp = "Suspense" === description.type ? getNextHydratableInstanceAfterHydrationBoundary(JSCompiler_temp) : getNextHydratable(JSCompiler_temp.nextSibling);
        }
        throwOnHydrationMismatch(fiber);
      }
      popToNextHostParent(fiber);
      if (13 === tag2) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
      } else if (31 === tag2) {
        fiber = fiber.memoizedState;
        fiber = null !== fiber ? fiber.dehydrated : null;
        if (!fiber)
          throw Error(
            "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
          );
        nextHydratableInstance = getNextHydratableInstanceAfterHydrationBoundary(fiber);
      } else
        27 === tag2 ? (tag2 = nextHydratableInstance, isSingletonScope(fiber.type) ? (fiber = previousHydratableOnEnteringScopedSingleton, previousHydratableOnEnteringScopedSingleton = null, nextHydratableInstance = fiber) : nextHydratableInstance = tag2) : nextHydratableInstance = hydrationParentFiber ? getNextHydratable(fiber.stateNode.nextSibling) : null;
      return true;
    }
    function resetHydrationState() {
      nextHydratableInstance = hydrationParentFiber = null;
      didSuspendOrErrorDEV = isHydrating = false;
    }
    function upgradeHydrationErrorsToRecoverable() {
      var queuedErrors = hydrationErrors;
      null !== queuedErrors && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = queuedErrors : workInProgressRootRecoverableErrors.push.apply(
        workInProgressRootRecoverableErrors,
        queuedErrors
      ), hydrationErrors = null);
      return queuedErrors;
    }
    function queueHydrationError(error) {
      null === hydrationErrors ? hydrationErrors = [error] : hydrationErrors.push(error);
    }
    function emitPendingHydrationWarnings() {
      var diffRoot = hydrationDiffRootDEV;
      if (null !== diffRoot) {
        hydrationDiffRootDEV = null;
        for (var diff = describeDiff(diffRoot); 0 < diffRoot.children.length; )
          diffRoot = diffRoot.children[0];
        runWithFiberInDEV(diffRoot.fiber, function() {
          console.error(
            "A tree hydrated but some attributes of the server rendered HTML didn't match the client properties. This won't be patched up. This can happen if a SSR-ed Client Component used:\n\n- A server/client branch `if (typeof window !== 'undefined')`.\n- Variable input such as `Date.now()` or `Math.random()` which changes each time it's called.\n- Date formatting in a user's locale which doesn't match the server.\n- External changing data without sending a snapshot of it along with the HTML.\n- Invalid HTML tag nesting.\n\nIt can also happen if the client has a browser extension installed which messes with the HTML before React loaded.\n\n%s%s",
            "https://react.dev/link/hydration-mismatch",
            diff
          );
        });
      }
    }
    function resetContextDependencies() {
      lastContextDependency = currentlyRenderingFiber$1 = null;
      isDisallowedContextReadInDEV = false;
    }
    function pushProvider(providerFiber, context, nextValue) {
      push2(valueCursor, context._currentValue, providerFiber);
      context._currentValue = nextValue;
      push2(rendererCursorDEV, context._currentRenderer, providerFiber);
      void 0 !== context._currentRenderer && null !== context._currentRenderer && context._currentRenderer !== rendererSigil && console.error(
        "Detected multiple renderers concurrently rendering the same context provider. This is currently unsupported."
      );
      context._currentRenderer = rendererSigil;
    }
    function popProvider(context, providerFiber) {
      context._currentValue = valueCursor.current;
      var currentRenderer = rendererCursorDEV.current;
      pop(rendererCursorDEV, providerFiber);
      context._currentRenderer = currentRenderer;
      pop(valueCursor, providerFiber);
    }
    function scheduleContextWorkOnParentPath(parent, renderLanes2, propagationRoot) {
      for (; null !== parent; ) {
        var alternate = parent.alternate;
        (parent.childLanes & renderLanes2) !== renderLanes2 ? (parent.childLanes |= renderLanes2, null !== alternate && (alternate.childLanes |= renderLanes2)) : null !== alternate && (alternate.childLanes & renderLanes2) !== renderLanes2 && (alternate.childLanes |= renderLanes2);
        if (parent === propagationRoot) break;
        parent = parent.return;
      }
      parent !== propagationRoot && console.error(
        "Expected to find the propagation root when scheduling context work. This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function propagateContextChanges(workInProgress2, contexts, renderLanes2, forcePropagateEntireTree) {
      var fiber = workInProgress2.child;
      null !== fiber && (fiber.return = workInProgress2);
      for (; null !== fiber; ) {
        var list2 = fiber.dependencies;
        if (null !== list2) {
          var nextFiber = fiber.child;
          list2 = list2.firstContext;
          a: for (; null !== list2; ) {
            var dependency = list2;
            list2 = fiber;
            for (var i2 = 0; i2 < contexts.length; i2++)
              if (dependency.context === contexts[i2]) {
                list2.lanes |= renderLanes2;
                dependency = list2.alternate;
                null !== dependency && (dependency.lanes |= renderLanes2);
                scheduleContextWorkOnParentPath(
                  list2.return,
                  renderLanes2,
                  workInProgress2
                );
                forcePropagateEntireTree || (nextFiber = null);
                break a;
              }
            list2 = dependency.next;
          }
        } else if (18 === fiber.tag) {
          nextFiber = fiber.return;
          if (null === nextFiber)
            throw Error(
              "We just came from a parent so we must have had a parent. This is a bug in React."
            );
          nextFiber.lanes |= renderLanes2;
          list2 = nextFiber.alternate;
          null !== list2 && (list2.lanes |= renderLanes2);
          scheduleContextWorkOnParentPath(
            nextFiber,
            renderLanes2,
            workInProgress2
          );
          nextFiber = null;
        } else nextFiber = fiber.child;
        if (null !== nextFiber) nextFiber.return = fiber;
        else
          for (nextFiber = fiber; null !== nextFiber; ) {
            if (nextFiber === workInProgress2) {
              nextFiber = null;
              break;
            }
            fiber = nextFiber.sibling;
            if (null !== fiber) {
              fiber.return = nextFiber.return;
              nextFiber = fiber;
              break;
            }
            nextFiber = nextFiber.return;
          }
        fiber = nextFiber;
      }
    }
    function propagateParentContextChanges(current3, workInProgress2, renderLanes2, forcePropagateEntireTree) {
      current3 = null;
      for (var parent = workInProgress2, isInsidePropagationBailout = false; null !== parent; ) {
        if (!isInsidePropagationBailout) {
          if (0 !== (parent.flags & 524288)) isInsidePropagationBailout = true;
          else if (0 !== (parent.flags & 262144)) break;
        }
        if (10 === parent.tag) {
          var currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent = currentParent.memoizedProps;
          if (null !== currentParent) {
            var context = parent.type;
            objectIs(parent.pendingProps.value, currentParent.value) || (null !== current3 ? current3.push(context) : current3 = [context]);
          }
        } else if (parent === hostTransitionProviderCursor.current) {
          currentParent = parent.alternate;
          if (null === currentParent)
            throw Error("Should have a current fiber. This is a bug in React.");
          currentParent.memoizedState.memoizedState !== parent.memoizedState.memoizedState && (null !== current3 ? current3.push(HostTransitionContext) : current3 = [HostTransitionContext]);
        }
        parent = parent.return;
      }
      null !== current3 && propagateContextChanges(
        workInProgress2,
        current3,
        renderLanes2,
        forcePropagateEntireTree
      );
      workInProgress2.flags |= 262144;
    }
    function checkIfContextChanged(currentDependencies) {
      for (currentDependencies = currentDependencies.firstContext; null !== currentDependencies; ) {
        if (!objectIs(
          currentDependencies.context._currentValue,
          currentDependencies.memoizedValue
        ))
          return true;
        currentDependencies = currentDependencies.next;
      }
      return false;
    }
    function prepareToReadContext(workInProgress2) {
      currentlyRenderingFiber$1 = workInProgress2;
      lastContextDependency = null;
      workInProgress2 = workInProgress2.dependencies;
      null !== workInProgress2 && (workInProgress2.firstContext = null);
    }
    function readContext(context) {
      isDisallowedContextReadInDEV && console.error(
        "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
      );
      return readContextForConsumer(currentlyRenderingFiber$1, context);
    }
    function readContextDuringReconciliation(consumer, context) {
      null === currentlyRenderingFiber$1 && prepareToReadContext(consumer);
      return readContextForConsumer(consumer, context);
    }
    function readContextForConsumer(consumer, context) {
      var value = context._currentValue;
      context = { context, memoizedValue: value, next: null };
      if (null === lastContextDependency) {
        if (null === consumer)
          throw Error(
            "Context can only be read while React is rendering. In classes, you can read it in the render method or getDerivedStateFromProps. In function components, you can read it directly in the function body, but not inside Hooks like useReducer() or useMemo()."
          );
        lastContextDependency = context;
        consumer.dependencies = {
          lanes: 0,
          firstContext: context,
          _debugThenableState: null
        };
        consumer.flags |= 524288;
      } else lastContextDependency = lastContextDependency.next = context;
      return value;
    }
    function createCache() {
      return {
        controller: new AbortControllerLocal(),
        data: /* @__PURE__ */ new Map(),
        refCount: 0
      };
    }
    function retainCache(cache) {
      cache.controller.signal.aborted && console.warn(
        "A cache instance was retained after it was already freed. This likely indicates a bug in React."
      );
      cache.refCount++;
    }
    function releaseCache(cache) {
      cache.refCount--;
      0 > cache.refCount && console.warn(
        "A cache instance was released after it was already freed. This likely indicates a bug in React."
      );
      0 === cache.refCount && scheduleCallback$2(NormalPriority, function() {
        cache.controller.abort();
      });
    }
    function startUpdateTimerByLane(lane, method, fiber) {
      if (0 !== (lane & 127))
        0 > blockingUpdateTime && (blockingUpdateTime = now(), blockingUpdateTask = createTask(method), blockingUpdateMethodName = method, null != fiber && (blockingUpdateComponentName = getComponentNameFromFiber(fiber)), (executionContext & (RenderContext | CommitContext)) !== NoContext && (componentEffectSpawnedUpdate = true, blockingUpdateType = SPAWNED_UPDATE), lane = resolveEventTimeStamp(), method = resolveEventType(), lane !== blockingEventRepeatTime || method !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== method && (blockingUpdateType = SPAWNED_UPDATE), blockingEventTime = lane, blockingEventType = method);
      else if (0 !== (lane & 4194048) && 0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = createTask(method), transitionUpdateMethodName = method, null != fiber && (transitionUpdateComponentName = getComponentNameFromFiber(fiber)), 0 > transitionStartTime)) {
        lane = resolveEventTimeStamp();
        method = resolveEventType();
        if (lane !== transitionEventRepeatTime || method !== transitionEventType)
          transitionEventRepeatTime = -1.1;
        transitionEventTime = lane;
        transitionEventType = method;
      }
    }
    function startHostActionTimer(fiber) {
      if (0 > blockingUpdateTime) {
        blockingUpdateTime = now();
        blockingUpdateTask = null != fiber._debugTask ? fiber._debugTask : null;
        (executionContext & (RenderContext | CommitContext)) !== NoContext && (blockingUpdateType = SPAWNED_UPDATE);
        var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
        newEventTime !== blockingEventRepeatTime || newEventType !== blockingEventType ? blockingEventRepeatTime = -1.1 : null !== newEventType && (blockingUpdateType = SPAWNED_UPDATE);
        blockingEventTime = newEventTime;
        blockingEventType = newEventType;
      }
      if (0 > transitionUpdateTime && (transitionUpdateTime = now(), transitionUpdateTask = null != fiber._debugTask ? fiber._debugTask : null, 0 > transitionStartTime)) {
        fiber = resolveEventTimeStamp();
        newEventTime = resolveEventType();
        if (fiber !== transitionEventRepeatTime || newEventTime !== transitionEventType)
          transitionEventRepeatTime = -1.1;
        transitionEventTime = fiber;
        transitionEventType = newEventTime;
      }
    }
    function pushNestedEffectDurations() {
      var prevEffectDuration = profilerEffectDuration;
      profilerEffectDuration = 0;
      return prevEffectDuration;
    }
    function popNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration = prevEffectDuration;
      return elapsedTime;
    }
    function bubbleNestedEffectDurations(prevEffectDuration) {
      var elapsedTime = profilerEffectDuration;
      profilerEffectDuration += prevEffectDuration;
      return elapsedTime;
    }
    function resetComponentEffectTimers() {
      componentEffectEndTime = componentEffectStartTime = -1.1;
    }
    function pushComponentEffectStart() {
      var prevEffectStart = componentEffectStartTime;
      componentEffectStartTime = -1.1;
      return prevEffectStart;
    }
    function popComponentEffectStart(prevEffectStart) {
      0 <= prevEffectStart && (componentEffectStartTime = prevEffectStart);
    }
    function pushComponentEffectDuration() {
      var prevEffectDuration = componentEffectDuration;
      componentEffectDuration = -0;
      return prevEffectDuration;
    }
    function popComponentEffectDuration(prevEffectDuration) {
      0 <= prevEffectDuration && (componentEffectDuration = prevEffectDuration);
    }
    function pushComponentEffectErrors() {
      var prevErrors = componentEffectErrors;
      componentEffectErrors = null;
      return prevErrors;
    }
    function pushComponentEffectDidSpawnUpdate() {
      var prev = componentEffectSpawnedUpdate;
      componentEffectSpawnedUpdate = false;
      return prev;
    }
    function startProfilerTimer(fiber) {
      profilerStartTime = now();
      0 > fiber.actualStartTime && (fiber.actualStartTime = profilerStartTime);
    }
    function stopProfilerTimerIfRunningAndRecordDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        fiber.selfBaseDuration = elapsedTime;
        profilerStartTime = -1;
      }
    }
    function stopProfilerTimerIfRunningAndRecordIncompleteDuration(fiber) {
      if (0 <= profilerStartTime) {
        var elapsedTime = now() - profilerStartTime;
        fiber.actualDuration += elapsedTime;
        profilerStartTime = -1;
      }
    }
    function recordEffectDuration() {
      if (0 <= profilerStartTime) {
        var endTime = now(), elapsedTime = endTime - profilerStartTime;
        profilerStartTime = -1;
        profilerEffectDuration += elapsedTime;
        componentEffectDuration += elapsedTime;
        componentEffectEndTime = endTime;
      }
    }
    function recordEffectError(errorInfo) {
      null === componentEffectErrors && (componentEffectErrors = []);
      componentEffectErrors.push(errorInfo);
      null === commitErrors && (commitErrors = []);
      commitErrors.push(errorInfo);
    }
    function startEffectTimer() {
      profilerStartTime = now();
      0 > componentEffectStartTime && (componentEffectStartTime = profilerStartTime);
    }
    function transferActualDuration(fiber) {
      for (var child = fiber.child; child; )
        fiber.actualDuration += child.actualDuration, child = child.sibling;
    }
    function entangleAsyncAction(transition, thenable) {
      if (null === currentEntangledListeners) {
        var entangledListeners = currentEntangledListeners = [];
        currentEntangledPendingCount = 0;
        currentEntangledLane = requestTransitionLane();
        currentEntangledActionThenable = {
          status: "pending",
          value: void 0,
          then: function(resolve) {
            entangledListeners.push(resolve);
          }
        };
      }
      currentEntangledPendingCount++;
      thenable.then(pingEngtangledActionScope, pingEngtangledActionScope);
      return thenable;
    }
    function pingEngtangledActionScope() {
      if (0 === --currentEntangledPendingCount && (-1 < transitionUpdateTime || (transitionStartTime = -1.1), null !== currentEntangledListeners)) {
        null !== currentEntangledActionThenable && (currentEntangledActionThenable.status = "fulfilled");
        var listeners = currentEntangledListeners;
        currentEntangledListeners = null;
        currentEntangledLane = 0;
        currentEntangledActionThenable = null;
        for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])();
      }
    }
    function chainThenableValue(thenable, result2) {
      var listeners = [], thenableWithOverride = {
        status: "pending",
        value: null,
        reason: null,
        then: function(resolve) {
          listeners.push(resolve);
        }
      };
      thenable.then(
        function() {
          thenableWithOverride.status = "fulfilled";
          thenableWithOverride.value = result2;
          for (var i2 = 0; i2 < listeners.length; i2++) (0, listeners[i2])(result2);
        },
        function(error) {
          thenableWithOverride.status = "rejected";
          thenableWithOverride.reason = error;
          for (error = 0; error < listeners.length; error++)
            (0, listeners[error])(void 0);
        }
      );
      return thenableWithOverride;
    }
    function peekCacheFromPool() {
      var cacheResumedFromPreviousRender = resumedCache.current;
      return null !== cacheResumedFromPreviousRender ? cacheResumedFromPreviousRender : workInProgressRoot.pooledCache;
    }
    function pushTransition(offscreenWorkInProgress, prevCachePool) {
      null === prevCachePool ? push2(resumedCache, resumedCache.current, offscreenWorkInProgress) : push2(resumedCache, prevCachePool.pool, offscreenWorkInProgress);
    }
    function getSuspendedCache() {
      var cacheFromPool = peekCacheFromPool();
      return null === cacheFromPool ? null : { parent: CacheContext._currentValue, pool: cacheFromPool };
    }
    function createThenableState() {
      return { didWarnAboutUncachedPromise: false, thenables: [] };
    }
    function isThenableResolved(thenable) {
      thenable = thenable.status;
      return "fulfilled" === thenable || "rejected" === thenable;
    }
    function trackUsedThenable(thenableState2, thenable, index2) {
      null !== ReactSharedInternals.actQueue && (ReactSharedInternals.didUsePromise = true);
      var trackedThenables = thenableState2.thenables;
      index2 = trackedThenables[index2];
      void 0 === index2 ? trackedThenables.push(thenable) : index2 !== thenable && (thenableState2.didWarnAboutUncachedPromise || (thenableState2.didWarnAboutUncachedPromise = true, console.error(
        "A component was suspended by an uncached promise. Creating promises inside a Client Component or hook is not yet supported, except via a Suspense-compatible library or framework."
      )), thenable.then(noop$12, noop$12), thenable = index2);
      if (void 0 === thenable._debugInfo) {
        thenableState2 = performance.now();
        trackedThenables = thenable.displayName;
        var ioInfo = {
          name: "string" === typeof trackedThenables ? trackedThenables : "Promise",
          start: thenableState2,
          end: thenableState2,
          value: thenable
        };
        thenable._debugInfo = [{ awaited: ioInfo }];
        "fulfilled" !== thenable.status && "rejected" !== thenable.status && (thenableState2 = function() {
          ioInfo.end = performance.now();
        }, thenable.then(thenableState2, thenableState2));
      }
      switch (thenable.status) {
        case "fulfilled":
          return thenable.value;
        case "rejected":
          throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
        default:
          if ("string" === typeof thenable.status)
            thenable.then(noop$12, noop$12);
          else {
            thenableState2 = workInProgressRoot;
            if (null !== thenableState2 && 100 < thenableState2.shellSuspendCounter)
              throw Error(
                "An unknown Component is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
              );
            thenableState2 = thenable;
            thenableState2.status = "pending";
            thenableState2.then(
              function(fulfilledValue) {
                if ("pending" === thenable.status) {
                  var fulfilledThenable = thenable;
                  fulfilledThenable.status = "fulfilled";
                  fulfilledThenable.value = fulfilledValue;
                }
              },
              function(error) {
                if ("pending" === thenable.status) {
                  var rejectedThenable = thenable;
                  rejectedThenable.status = "rejected";
                  rejectedThenable.reason = error;
                }
              }
            );
          }
          switch (thenable.status) {
            case "fulfilled":
              return thenable.value;
            case "rejected":
              throw thenableState2 = thenable.reason, checkIfUseWrappedInAsyncCatch(thenableState2), thenableState2;
          }
          suspendedThenable = thenable;
          needsToResetSuspendedThenableDEV = true;
          throw SuspenseException;
      }
    }
    function resolveLazy(lazyType) {
      try {
        return callLazyInitInDEV(lazyType);
      } catch (x2) {
        if (null !== x2 && "object" === typeof x2 && "function" === typeof x2.then)
          throw suspendedThenable = x2, needsToResetSuspendedThenableDEV = true, SuspenseException;
        throw x2;
      }
    }
    function getSuspendedThenable() {
      if (null === suspendedThenable)
        throw Error(
          "Expected a suspended thenable. This is a bug in React. Please file an issue."
        );
      var thenable = suspendedThenable;
      suspendedThenable = null;
      needsToResetSuspendedThenableDEV = false;
      return thenable;
    }
    function checkIfUseWrappedInAsyncCatch(rejectedReason) {
      if (rejectedReason === SuspenseException || rejectedReason === SuspenseActionException)
        throw Error(
          "Hooks are not supported inside an async component. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server."
        );
    }
    function pushDebugInfo(debugInfo) {
      var previousDebugInfo = currentDebugInfo;
      null != debugInfo && (currentDebugInfo = null === previousDebugInfo ? debugInfo : previousDebugInfo.concat(debugInfo));
      return previousDebugInfo;
    }
    function getCurrentDebugTask() {
      var debugInfo = currentDebugInfo;
      if (null != debugInfo) {
        for (var i2 = debugInfo.length - 1; 0 <= i2; i2--)
          if (null != debugInfo[i2].name) {
            var debugTask = debugInfo[i2].debugTask;
            if (null != debugTask) return debugTask;
          }
      }
      return null;
    }
    function validateFragmentProps(element2, fiber, returnFiber) {
      for (var keys2 = Object.keys(element2.props), i2 = 0; i2 < keys2.length; i2++) {
        var key = keys2[i2];
        if ("children" !== key && "key" !== key) {
          null === fiber && (fiber = createFiberFromElement(element2, returnFiber.mode, 0), fiber._debugInfo = currentDebugInfo, fiber.return = returnFiber);
          runWithFiberInDEV(
            fiber,
            function(erroredKey) {
              console.error(
                "Invalid prop `%s` supplied to `React.Fragment`. React.Fragment can only have `key` and `children` props.",
                erroredKey
              );
            },
            key
          );
          break;
        }
      }
    }
    function unwrapThenable(thenable) {
      var index2 = thenableIndexCounter$1;
      thenableIndexCounter$1 += 1;
      null === thenableState$1 && (thenableState$1 = createThenableState());
      return trackUsedThenable(thenableState$1, thenable, index2);
    }
    function coerceRef(workInProgress2, element2) {
      element2 = element2.props.ref;
      workInProgress2.ref = void 0 !== element2 ? element2 : null;
    }
    function throwOnInvalidObjectTypeImpl(returnFiber, newChild) {
      if (newChild.$$typeof === REACT_LEGACY_ELEMENT_TYPE)
        throw Error(
          'A React Element from an older version of React was rendered. This is not supported. It can happen if:\n- Multiple copies of the "react" package is used.\n- A library pre-bundled an old copy of "react" or "react/jsx-runtime".\n- A compiler tries to "inline" JSX instead of using the runtime.'
        );
      returnFiber = Object.prototype.toString.call(newChild);
      throw Error(
        "Objects are not valid as a React child (found: " + ("[object Object]" === returnFiber ? "object with keys {" + Object.keys(newChild).join(", ") + "}" : returnFiber) + "). If you meant to render a collection of children, use an array instead."
      );
    }
    function throwOnInvalidObjectType(returnFiber, newChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        throwOnInvalidObjectTypeImpl.bind(null, returnFiber, newChild)
      ) : throwOnInvalidObjectTypeImpl(returnFiber, newChild);
    }
    function warnOnFunctionTypeImpl(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasFunctionTypeWarning[parentName] || (ownerHasFunctionTypeWarning[parentName] = true, invalidChild = invalidChild.displayName || invalidChild.name || "Component", 3 === returnFiber.tag ? console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  root.render(%s)",
        invalidChild,
        invalidChild,
        invalidChild
      ) : console.error(
        "Functions are not valid as a React child. This may happen if you return %s instead of <%s /> from render. Or maybe you meant to call this function rather than return it.\n  <%s>{%s}</%s>",
        invalidChild,
        invalidChild,
        parentName,
        invalidChild,
        parentName
      ));
    }
    function warnOnFunctionType(returnFiber, invalidChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        warnOnFunctionTypeImpl.bind(null, returnFiber, invalidChild)
      ) : warnOnFunctionTypeImpl(returnFiber, invalidChild);
    }
    function warnOnSymbolTypeImpl(returnFiber, invalidChild) {
      var parentName = getComponentNameFromFiber(returnFiber) || "Component";
      ownerHasSymbolTypeWarning[parentName] || (ownerHasSymbolTypeWarning[parentName] = true, invalidChild = String(invalidChild), 3 === returnFiber.tag ? console.error(
        "Symbols are not valid as a React child.\n  root.render(%s)",
        invalidChild
      ) : console.error(
        "Symbols are not valid as a React child.\n  <%s>%s</%s>",
        parentName,
        invalidChild,
        parentName
      ));
    }
    function warnOnSymbolType(returnFiber, invalidChild) {
      var debugTask = getCurrentDebugTask();
      null !== debugTask ? debugTask.run(
        warnOnSymbolTypeImpl.bind(null, returnFiber, invalidChild)
      ) : warnOnSymbolTypeImpl(returnFiber, invalidChild);
    }
    function createChildReconciler(shouldTrackSideEffects) {
      function deleteChild(returnFiber, childToDelete) {
        if (shouldTrackSideEffects) {
          var deletions = returnFiber.deletions;
          null === deletions ? (returnFiber.deletions = [childToDelete], returnFiber.flags |= 16) : deletions.push(childToDelete);
        }
      }
      function deleteRemainingChildren(returnFiber, currentFirstChild) {
        if (!shouldTrackSideEffects) return null;
        for (; null !== currentFirstChild; )
          deleteChild(returnFiber, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return null;
      }
      function mapRemainingChildren(currentFirstChild) {
        for (var existingChildren = /* @__PURE__ */ new Map(); null !== currentFirstChild; )
          null !== currentFirstChild.key ? existingChildren.set(currentFirstChild.key, currentFirstChild) : existingChildren.set(currentFirstChild.index, currentFirstChild), currentFirstChild = currentFirstChild.sibling;
        return existingChildren;
      }
      function useFiber(fiber, pendingProps) {
        fiber = createWorkInProgress(fiber, pendingProps);
        fiber.index = 0;
        fiber.sibling = null;
        return fiber;
      }
      function placeChild(newFiber, lastPlacedIndex, newIndex) {
        newFiber.index = newIndex;
        if (!shouldTrackSideEffects)
          return newFiber.flags |= 1048576, lastPlacedIndex;
        newIndex = newFiber.alternate;
        if (null !== newIndex)
          return newIndex = newIndex.index, newIndex < lastPlacedIndex ? (newFiber.flags |= 67108866, lastPlacedIndex) : newIndex;
        newFiber.flags |= 67108866;
        return lastPlacedIndex;
      }
      function placeSingleChild(newFiber) {
        shouldTrackSideEffects && null === newFiber.alternate && (newFiber.flags |= 67108866);
        return newFiber;
      }
      function updateTextNode(returnFiber, current3, textContent, lanes) {
        if (null === current3 || 6 !== current3.tag)
          return current3 = createFiberFromText(
            textContent,
            returnFiber.mode,
            lanes
          ), current3.return = returnFiber, current3._debugOwner = returnFiber, current3._debugTask = returnFiber._debugTask, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, textContent);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updateElement(returnFiber, current3, element2, lanes) {
        var elementType = element2.type;
        if (elementType === REACT_FRAGMENT_TYPE)
          return current3 = updateFragment(
            returnFiber,
            current3,
            element2.props.children,
            lanes,
            element2.key
          ), validateFragmentProps(element2, current3, returnFiber), current3;
        if (null !== current3 && (current3.elementType === elementType || isCompatibleFamilyForHotReloading(current3, element2) || "object" === typeof elementType && null !== elementType && elementType.$$typeof === REACT_LAZY_TYPE && resolveLazy(elementType) === current3.type))
          return current3 = useFiber(current3, element2.props), coerceRef(current3, element2), current3.return = returnFiber, current3._debugOwner = element2._owner, current3._debugInfo = currentDebugInfo, current3;
        current3 = createFiberFromElement(element2, returnFiber.mode, lanes);
        coerceRef(current3, element2);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updatePortal(returnFiber, current3, portal, lanes) {
        if (null === current3 || 4 !== current3.tag || current3.stateNode.containerInfo !== portal.containerInfo || current3.stateNode.implementation !== portal.implementation)
          return current3 = createFiberFromPortal(portal, returnFiber.mode, lanes), current3.return = returnFiber, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, portal.children || []);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function updateFragment(returnFiber, current3, fragment, lanes, key) {
        if (null === current3 || 7 !== current3.tag)
          return current3 = createFiberFromFragment(
            fragment,
            returnFiber.mode,
            lanes,
            key
          ), current3.return = returnFiber, current3._debugOwner = returnFiber, current3._debugTask = returnFiber._debugTask, current3._debugInfo = currentDebugInfo, current3;
        current3 = useFiber(current3, fragment);
        current3.return = returnFiber;
        current3._debugInfo = currentDebugInfo;
        return current3;
      }
      function createChild(returnFiber, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return newChild = createFiberFromText(
            "" + newChild,
            returnFiber.mode,
            lanes
          ), newChild.return = returnFiber, newChild._debugOwner = returnFiber, newChild._debugTask = returnFiber._debugTask, newChild._debugInfo = currentDebugInfo, newChild;
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return lanes = createFiberFromElement(
                newChild,
                returnFiber.mode,
                lanes
              ), coerceRef(lanes, newChild), lanes.return = returnFiber, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
            case REACT_PORTAL_TYPE:
              return newChild = createFiberFromPortal(
                newChild,
                returnFiber.mode,
                lanes
              ), newChild.return = returnFiber, newChild._debugInfo = currentDebugInfo, newChild;
            case REACT_LAZY_TYPE:
              var _prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              newChild = resolveLazy(newChild);
              returnFiber = createChild(returnFiber, newChild, lanes);
              currentDebugInfo = _prevDebugInfo;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return lanes = createFiberFromFragment(
              newChild,
              returnFiber.mode,
              lanes,
              null
            ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, returnFiber = pushDebugInfo(newChild._debugInfo), lanes._debugInfo = currentDebugInfo, currentDebugInfo = returnFiber, lanes;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = createChild(
              returnFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return createChild(
              returnFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateSlot(returnFiber, oldFiber, newChild, lanes) {
        var key = null !== oldFiber ? oldFiber.key : null;
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return null !== key ? null : updateTextNode(returnFiber, oldFiber, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newChild.key === key ? (key = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber) : null;
            case REACT_PORTAL_TYPE:
              return newChild.key === key ? updatePortal(returnFiber, oldFiber, newChild, lanes) : null;
            case REACT_LAZY_TYPE:
              return key = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = updateSlot(
                returnFiber,
                oldFiber,
                newChild,
                lanes
              ), currentDebugInfo = key, returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild)) {
            if (null !== key) return null;
            key = pushDebugInfo(newChild._debugInfo);
            returnFiber = updateFragment(
              returnFiber,
              oldFiber,
              newChild,
              lanes,
              null
            );
            currentDebugInfo = key;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return key = pushDebugInfo(newChild._debugInfo), returnFiber = updateSlot(
              returnFiber,
              oldFiber,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = key, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateSlot(
              returnFiber,
              oldFiber,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function updateFromMap(existingChildren, returnFiber, newIdx, newChild, lanes) {
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return existingChildren = existingChildren.get(newIdx) || null, updateTextNode(returnFiber, existingChildren, "" + newChild, lanes);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              return newIdx = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateElement(
                returnFiber,
                newIdx,
                newChild,
                lanes
              ), currentDebugInfo = existingChildren, returnFiber;
            case REACT_PORTAL_TYPE:
              return existingChildren = existingChildren.get(
                null === newChild.key ? newIdx : newChild.key
              ) || null, updatePortal(returnFiber, existingChildren, newChild, lanes);
            case REACT_LAZY_TYPE:
              var _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo);
              newChild = resolveLazy(newChild);
              returnFiber = updateFromMap(
                existingChildren,
                returnFiber,
                newIdx,
                newChild,
                lanes
              );
              currentDebugInfo = _prevDebugInfo7;
              return returnFiber;
          }
          if (isArrayImpl(newChild) || getIteratorFn(newChild))
            return newIdx = existingChildren.get(newIdx) || null, existingChildren = pushDebugInfo(newChild._debugInfo), returnFiber = updateFragment(
              returnFiber,
              newIdx,
              newChild,
              lanes,
              null
            ), currentDebugInfo = existingChildren, returnFiber;
          if ("function" === typeof newChild.then)
            return _prevDebugInfo7 = pushDebugInfo(newChild._debugInfo), returnFiber = updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = _prevDebugInfo7, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return updateFromMap(
              existingChildren,
              returnFiber,
              newIdx,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return null;
      }
      function warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys) {
        if ("object" !== typeof child || null === child) return knownKeys;
        switch (child.$$typeof) {
          case REACT_ELEMENT_TYPE:
          case REACT_PORTAL_TYPE:
            warnForMissingKey(returnFiber, workInProgress2, child);
            var key = child.key;
            if ("string" !== typeof key) break;
            if (null === knownKeys) {
              knownKeys = /* @__PURE__ */ new Set();
              knownKeys.add(key);
              break;
            }
            if (!knownKeys.has(key)) {
              knownKeys.add(key);
              break;
            }
            runWithFiberInDEV(workInProgress2, function() {
              console.error(
                "Encountered two children with the same key, `%s`. Keys should be unique so that components maintain their identity across updates. Non-unique keys may cause children to be duplicated and/or omitted — the behavior is unsupported and could change in a future version.",
                key
              );
            });
            break;
          case REACT_LAZY_TYPE:
            child = resolveLazy(child), warnOnInvalidKey(returnFiber, workInProgress2, child, knownKeys);
        }
        return knownKeys;
      }
      function reconcileChildrenArray(returnFiber, currentFirstChild, newChildren, lanes) {
        for (var knownKeys = null, resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null; null !== oldFiber && newIdx < newChildren.length; newIdx++) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(
            returnFiber,
            oldFiber,
            newChildren[newIdx],
            lanes
          );
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            newChildren[newIdx],
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (newIdx === newChildren.length)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; newIdx < newChildren.length; newIdx++)
            oldFiber = createChild(returnFiber, newChildren[newIdx], lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              newChildren[newIdx],
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); newIdx < newChildren.length; newIdx++)
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            newChildren[newIdx],
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            newChildren[newIdx],
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildrenIterator(returnFiber, currentFirstChild, newChildren, lanes) {
        if (null == newChildren)
          throw Error("An iterable object provided no iterator.");
        for (var resultingFirstChild = null, previousNewFiber = null, oldFiber = currentFirstChild, newIdx = currentFirstChild = 0, nextOldFiber = null, knownKeys = null, step = newChildren.next(); null !== oldFiber && !step.done; newIdx++, step = newChildren.next()) {
          oldFiber.index > newIdx ? (nextOldFiber = oldFiber, oldFiber = null) : nextOldFiber = oldFiber.sibling;
          var newFiber = updateSlot(returnFiber, oldFiber, step.value, lanes);
          if (null === newFiber) {
            null === oldFiber && (oldFiber = nextOldFiber);
            break;
          }
          knownKeys = warnOnInvalidKey(
            returnFiber,
            newFiber,
            step.value,
            knownKeys
          );
          shouldTrackSideEffects && oldFiber && null === newFiber.alternate && deleteChild(returnFiber, oldFiber);
          currentFirstChild = placeChild(newFiber, currentFirstChild, newIdx);
          null === previousNewFiber ? resultingFirstChild = newFiber : previousNewFiber.sibling = newFiber;
          previousNewFiber = newFiber;
          oldFiber = nextOldFiber;
        }
        if (step.done)
          return deleteRemainingChildren(returnFiber, oldFiber), isHydrating && pushTreeFork(returnFiber, newIdx), resultingFirstChild;
        if (null === oldFiber) {
          for (; !step.done; newIdx++, step = newChildren.next())
            oldFiber = createChild(returnFiber, step.value, lanes), null !== oldFiber && (knownKeys = warnOnInvalidKey(
              returnFiber,
              oldFiber,
              step.value,
              knownKeys
            ), currentFirstChild = placeChild(
              oldFiber,
              currentFirstChild,
              newIdx
            ), null === previousNewFiber ? resultingFirstChild = oldFiber : previousNewFiber.sibling = oldFiber, previousNewFiber = oldFiber);
          isHydrating && pushTreeFork(returnFiber, newIdx);
          return resultingFirstChild;
        }
        for (oldFiber = mapRemainingChildren(oldFiber); !step.done; newIdx++, step = newChildren.next())
          nextOldFiber = updateFromMap(
            oldFiber,
            returnFiber,
            newIdx,
            step.value,
            lanes
          ), null !== nextOldFiber && (knownKeys = warnOnInvalidKey(
            returnFiber,
            nextOldFiber,
            step.value,
            knownKeys
          ), shouldTrackSideEffects && null !== nextOldFiber.alternate && oldFiber.delete(
            null === nextOldFiber.key ? newIdx : nextOldFiber.key
          ), currentFirstChild = placeChild(
            nextOldFiber,
            currentFirstChild,
            newIdx
          ), null === previousNewFiber ? resultingFirstChild = nextOldFiber : previousNewFiber.sibling = nextOldFiber, previousNewFiber = nextOldFiber);
        shouldTrackSideEffects && oldFiber.forEach(function(child) {
          return deleteChild(returnFiber, child);
        });
        isHydrating && pushTreeFork(returnFiber, newIdx);
        return resultingFirstChild;
      }
      function reconcileChildFibersImpl(returnFiber, currentFirstChild, newChild, lanes) {
        "object" === typeof newChild && null !== newChild && newChild.type === REACT_FRAGMENT_TYPE && null === newChild.key && (validateFragmentProps(newChild, null, returnFiber), newChild = newChild.props.children);
        if ("object" === typeof newChild && null !== newChild) {
          switch (newChild.$$typeof) {
            case REACT_ELEMENT_TYPE:
              var prevDebugInfo = pushDebugInfo(newChild._debugInfo);
              a: {
                for (var key = newChild.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === key) {
                    key = newChild.type;
                    if (key === REACT_FRAGMENT_TYPE) {
                      if (7 === currentFirstChild.tag) {
                        deleteRemainingChildren(
                          returnFiber,
                          currentFirstChild.sibling
                        );
                        lanes = useFiber(
                          currentFirstChild,
                          newChild.props.children
                        );
                        lanes.return = returnFiber;
                        lanes._debugOwner = newChild._owner;
                        lanes._debugInfo = currentDebugInfo;
                        validateFragmentProps(newChild, lanes, returnFiber);
                        returnFiber = lanes;
                        break a;
                      }
                    } else if (currentFirstChild.elementType === key || isCompatibleFamilyForHotReloading(
                      currentFirstChild,
                      newChild
                    ) || "object" === typeof key && null !== key && key.$$typeof === REACT_LAZY_TYPE && resolveLazy(key) === currentFirstChild.type) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(currentFirstChild, newChild.props);
                      coerceRef(lanes, newChild);
                      lanes.return = returnFiber;
                      lanes._debugOwner = newChild._owner;
                      lanes._debugInfo = currentDebugInfo;
                      returnFiber = lanes;
                      break a;
                    }
                    deleteRemainingChildren(returnFiber, currentFirstChild);
                    break;
                  } else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                newChild.type === REACT_FRAGMENT_TYPE ? (lanes = createFiberFromFragment(
                  newChild.props.children,
                  returnFiber.mode,
                  lanes,
                  newChild.key
                ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, validateFragmentProps(newChild, lanes, returnFiber), returnFiber = lanes) : (lanes = createFiberFromElement(
                  newChild,
                  returnFiber.mode,
                  lanes
                ), coerceRef(lanes, newChild), lanes.return = returnFiber, lanes._debugInfo = currentDebugInfo, returnFiber = lanes);
              }
              returnFiber = placeSingleChild(returnFiber);
              currentDebugInfo = prevDebugInfo;
              return returnFiber;
            case REACT_PORTAL_TYPE:
              a: {
                prevDebugInfo = newChild;
                for (newChild = prevDebugInfo.key; null !== currentFirstChild; ) {
                  if (currentFirstChild.key === newChild)
                    if (4 === currentFirstChild.tag && currentFirstChild.stateNode.containerInfo === prevDebugInfo.containerInfo && currentFirstChild.stateNode.implementation === prevDebugInfo.implementation) {
                      deleteRemainingChildren(
                        returnFiber,
                        currentFirstChild.sibling
                      );
                      lanes = useFiber(
                        currentFirstChild,
                        prevDebugInfo.children || []
                      );
                      lanes.return = returnFiber;
                      returnFiber = lanes;
                      break a;
                    } else {
                      deleteRemainingChildren(returnFiber, currentFirstChild);
                      break;
                    }
                  else deleteChild(returnFiber, currentFirstChild);
                  currentFirstChild = currentFirstChild.sibling;
                }
                lanes = createFiberFromPortal(
                  prevDebugInfo,
                  returnFiber.mode,
                  lanes
                );
                lanes.return = returnFiber;
                returnFiber = lanes;
              }
              return placeSingleChild(returnFiber);
            case REACT_LAZY_TYPE:
              return prevDebugInfo = pushDebugInfo(newChild._debugInfo), newChild = resolveLazy(newChild), returnFiber = reconcileChildFibersImpl(
                returnFiber,
                currentFirstChild,
                newChild,
                lanes
              ), currentDebugInfo = prevDebugInfo, returnFiber;
          }
          if (isArrayImpl(newChild))
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildrenArray(
              returnFiber,
              currentFirstChild,
              newChild,
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (getIteratorFn(newChild)) {
            prevDebugInfo = pushDebugInfo(newChild._debugInfo);
            key = getIteratorFn(newChild);
            if ("function" !== typeof key)
              throw Error(
                "An object is not an iterable. This error is likely caused by a bug in React. Please file an issue."
              );
            var newChildren = key.call(newChild);
            if (newChildren === newChild) {
              if (0 !== returnFiber.tag || "[object GeneratorFunction]" !== Object.prototype.toString.call(returnFiber.type) || "[object Generator]" !== Object.prototype.toString.call(newChildren))
                didWarnAboutGenerators || console.error(
                  "Using Iterators as children is unsupported and will likely yield unexpected results because enumerating a generator mutates it. You may convert it to an array with `Array.from()` or the `[...spread]` operator before rendering. You can also use an Iterable that can iterate multiple times over the same items."
                ), didWarnAboutGenerators = true;
            } else
              newChild.entries !== key || didWarnAboutMaps || (console.error(
                "Using Maps as children is not supported. Use an array of keyed ReactElements instead."
              ), didWarnAboutMaps = true);
            returnFiber = reconcileChildrenIterator(
              returnFiber,
              currentFirstChild,
              newChildren,
              lanes
            );
            currentDebugInfo = prevDebugInfo;
            return returnFiber;
          }
          if ("function" === typeof newChild.then)
            return prevDebugInfo = pushDebugInfo(newChild._debugInfo), returnFiber = reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              unwrapThenable(newChild),
              lanes
            ), currentDebugInfo = prevDebugInfo, returnFiber;
          if (newChild.$$typeof === REACT_CONTEXT_TYPE)
            return reconcileChildFibersImpl(
              returnFiber,
              currentFirstChild,
              readContextDuringReconciliation(returnFiber, newChild),
              lanes
            );
          throwOnInvalidObjectType(returnFiber, newChild);
        }
        if ("string" === typeof newChild && "" !== newChild || "number" === typeof newChild || "bigint" === typeof newChild)
          return prevDebugInfo = "" + newChild, null !== currentFirstChild && 6 === currentFirstChild.tag ? (deleteRemainingChildren(
            returnFiber,
            currentFirstChild.sibling
          ), lanes = useFiber(currentFirstChild, prevDebugInfo), lanes.return = returnFiber, returnFiber = lanes) : (deleteRemainingChildren(returnFiber, currentFirstChild), lanes = createFiberFromText(
            prevDebugInfo,
            returnFiber.mode,
            lanes
          ), lanes.return = returnFiber, lanes._debugOwner = returnFiber, lanes._debugTask = returnFiber._debugTask, lanes._debugInfo = currentDebugInfo, returnFiber = lanes), placeSingleChild(returnFiber);
        "function" === typeof newChild && warnOnFunctionType(returnFiber, newChild);
        "symbol" === typeof newChild && warnOnSymbolType(returnFiber, newChild);
        return deleteRemainingChildren(returnFiber, currentFirstChild);
      }
      return function(returnFiber, currentFirstChild, newChild, lanes) {
        var prevDebugInfo = currentDebugInfo;
        currentDebugInfo = null;
        try {
          thenableIndexCounter$1 = 0;
          var firstChildFiber = reconcileChildFibersImpl(
            returnFiber,
            currentFirstChild,
            newChild,
            lanes
          );
          thenableState$1 = null;
          return firstChildFiber;
        } catch (x2) {
          if (x2 === SuspenseException || x2 === SuspenseActionException) throw x2;
          var fiber = createFiber(29, x2, null, returnFiber.mode);
          fiber.lanes = lanes;
          fiber.return = returnFiber;
          var debugInfo = fiber._debugInfo = currentDebugInfo;
          fiber._debugOwner = returnFiber._debugOwner;
          fiber._debugTask = returnFiber._debugTask;
          if (null != debugInfo) {
            for (var i2 = debugInfo.length - 1; 0 <= i2; i2--)
              if ("string" === typeof debugInfo[i2].stack) {
                fiber._debugOwner = debugInfo[i2];
                fiber._debugTask = debugInfo[i2].debugTask;
                break;
              }
          }
          return fiber;
        } finally {
          currentDebugInfo = prevDebugInfo;
        }
      };
    }
    function validateSuspenseListNestedChild(childSlot, index2) {
      var isAnArray = isArrayImpl(childSlot);
      childSlot = !isAnArray && "function" === typeof getIteratorFn(childSlot);
      return isAnArray || childSlot ? (isAnArray = isAnArray ? "array" : "iterable", console.error(
        "A nested %s was passed to row #%s in <SuspenseList />. Wrap it in an additional SuspenseList to configure its revealOrder: <SuspenseList revealOrder=...> ... <SuspenseList revealOrder=...>{%s}</SuspenseList> ... </SuspenseList>",
        isAnArray,
        index2,
        isAnArray
      ), false) : true;
    }
    function initializeUpdateQueue(fiber) {
      fiber.updateQueue = {
        baseState: fiber.memoizedState,
        firstBaseUpdate: null,
        lastBaseUpdate: null,
        shared: { pending: null, lanes: 0, hiddenCallbacks: null },
        callbacks: null
      };
    }
    function cloneUpdateQueue(current3, workInProgress2) {
      current3 = current3.updateQueue;
      workInProgress2.updateQueue === current3 && (workInProgress2.updateQueue = {
        baseState: current3.baseState,
        firstBaseUpdate: current3.firstBaseUpdate,
        lastBaseUpdate: current3.lastBaseUpdate,
        shared: current3.shared,
        callbacks: null
      });
    }
    function createUpdate(lane) {
      return {
        lane,
        tag: UpdateState,
        payload: null,
        callback: null,
        next: null
      };
    }
    function enqueueUpdate(fiber, update, lane) {
      var updateQueue = fiber.updateQueue;
      if (null === updateQueue) return null;
      updateQueue = updateQueue.shared;
      if (currentlyProcessingQueue === updateQueue && !didWarnUpdateInsideUpdate) {
        var componentName2 = getComponentNameFromFiber(fiber);
        console.error(
          "An update (setState, replaceState, or forceUpdate) was scheduled from inside an update function. Update functions should be pure, with zero side-effects. Consider using componentDidUpdate or a callback.\n\nPlease update the following component: %s",
          componentName2
        );
        didWarnUpdateInsideUpdate = true;
      }
      if ((executionContext & RenderContext) !== NoContext)
        return componentName2 = updateQueue.pending, null === componentName2 ? update.next = update : (update.next = componentName2.next, componentName2.next = update), updateQueue.pending = update, update = getRootForUpdatedFiber(fiber), markUpdateLaneFromFiberToRoot(fiber, null, lane), update;
      enqueueUpdate$1(fiber, updateQueue, update, lane);
      return getRootForUpdatedFiber(fiber);
    }
    function entangleTransitions(root3, fiber, lane) {
      fiber = fiber.updateQueue;
      if (null !== fiber && (fiber = fiber.shared, 0 !== (lane & 4194048))) {
        var queueLanes = fiber.lanes;
        queueLanes &= root3.pendingLanes;
        lane |= queueLanes;
        fiber.lanes = lane;
        markRootEntangled(root3, lane);
      }
    }
    function enqueueCapturedUpdate(workInProgress2, capturedUpdate) {
      var queue = workInProgress2.updateQueue, current3 = workInProgress2.alternate;
      if (null !== current3 && (current3 = current3.updateQueue, queue === current3)) {
        var newFirst = null, newLast = null;
        queue = queue.firstBaseUpdate;
        if (null !== queue) {
          do {
            var clone2 = {
              lane: queue.lane,
              tag: queue.tag,
              payload: queue.payload,
              callback: null,
              next: null
            };
            null === newLast ? newFirst = newLast = clone2 : newLast = newLast.next = clone2;
            queue = queue.next;
          } while (null !== queue);
          null === newLast ? newFirst = newLast = capturedUpdate : newLast = newLast.next = capturedUpdate;
        } else newFirst = newLast = capturedUpdate;
        queue = {
          baseState: current3.baseState,
          firstBaseUpdate: newFirst,
          lastBaseUpdate: newLast,
          shared: current3.shared,
          callbacks: current3.callbacks
        };
        workInProgress2.updateQueue = queue;
        return;
      }
      workInProgress2 = queue.lastBaseUpdate;
      null === workInProgress2 ? queue.firstBaseUpdate = capturedUpdate : workInProgress2.next = capturedUpdate;
      queue.lastBaseUpdate = capturedUpdate;
    }
    function suspendIfUpdateReadFromEntangledAsyncAction() {
      if (didReadFromEntangledAsyncAction) {
        var entangledActionThenable = currentEntangledActionThenable;
        if (null !== entangledActionThenable) throw entangledActionThenable;
      }
    }
    function processUpdateQueue(workInProgress2, props2, instance$jscomp$0, renderLanes2) {
      didReadFromEntangledAsyncAction = false;
      var queue = workInProgress2.updateQueue;
      hasForceUpdate = false;
      currentlyProcessingQueue = queue.shared;
      var firstBaseUpdate = queue.firstBaseUpdate, lastBaseUpdate = queue.lastBaseUpdate, pendingQueue = queue.shared.pending;
      if (null !== pendingQueue) {
        queue.shared.pending = null;
        var lastPendingUpdate = pendingQueue, firstPendingUpdate = lastPendingUpdate.next;
        lastPendingUpdate.next = null;
        null === lastBaseUpdate ? firstBaseUpdate = firstPendingUpdate : lastBaseUpdate.next = firstPendingUpdate;
        lastBaseUpdate = lastPendingUpdate;
        var current3 = workInProgress2.alternate;
        null !== current3 && (current3 = current3.updateQueue, pendingQueue = current3.lastBaseUpdate, pendingQueue !== lastBaseUpdate && (null === pendingQueue ? current3.firstBaseUpdate = firstPendingUpdate : pendingQueue.next = firstPendingUpdate, current3.lastBaseUpdate = lastPendingUpdate));
      }
      if (null !== firstBaseUpdate) {
        var newState = queue.baseState;
        lastBaseUpdate = 0;
        current3 = firstPendingUpdate = lastPendingUpdate = null;
        pendingQueue = firstBaseUpdate;
        do {
          var updateLane = pendingQueue.lane & -536870913, isHiddenUpdate = updateLane !== pendingQueue.lane;
          if (isHiddenUpdate ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes2 & updateLane) === updateLane) {
            0 !== updateLane && updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction = true);
            null !== current3 && (current3 = current3.next = {
              lane: 0,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: null,
              next: null
            });
            a: {
              updateLane = workInProgress2;
              var partialState = pendingQueue;
              var nextProps = props2, instance = instance$jscomp$0;
              switch (partialState.tag) {
                case ReplaceState:
                  partialState = partialState.payload;
                  if ("function" === typeof partialState) {
                    isDisallowedContextReadInDEV = true;
                    var nextState = partialState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        partialState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                    newState = nextState;
                    break a;
                  }
                  newState = partialState;
                  break a;
                case CaptureUpdate:
                  updateLane.flags = updateLane.flags & -65537 | 128;
                case UpdateState:
                  nextState = partialState.payload;
                  if ("function" === typeof nextState) {
                    isDisallowedContextReadInDEV = true;
                    partialState = nextState.call(
                      instance,
                      newState,
                      nextProps
                    );
                    if (updateLane.mode & StrictLegacyMode) {
                      setIsStrictModeForDevtools(true);
                      try {
                        nextState.call(instance, newState, nextProps);
                      } finally {
                        setIsStrictModeForDevtools(false);
                      }
                    }
                    isDisallowedContextReadInDEV = false;
                  } else partialState = nextState;
                  if (null === partialState || void 0 === partialState) break a;
                  newState = assign2({}, newState, partialState);
                  break a;
                case ForceUpdate:
                  hasForceUpdate = true;
              }
            }
            updateLane = pendingQueue.callback;
            null !== updateLane && (workInProgress2.flags |= 64, isHiddenUpdate && (workInProgress2.flags |= 8192), isHiddenUpdate = queue.callbacks, null === isHiddenUpdate ? queue.callbacks = [updateLane] : isHiddenUpdate.push(updateLane));
          } else
            isHiddenUpdate = {
              lane: updateLane,
              tag: pendingQueue.tag,
              payload: pendingQueue.payload,
              callback: pendingQueue.callback,
              next: null
            }, null === current3 ? (firstPendingUpdate = current3 = isHiddenUpdate, lastPendingUpdate = newState) : current3 = current3.next = isHiddenUpdate, lastBaseUpdate |= updateLane;
          pendingQueue = pendingQueue.next;
          if (null === pendingQueue)
            if (pendingQueue = queue.shared.pending, null === pendingQueue)
              break;
            else
              isHiddenUpdate = pendingQueue, pendingQueue = isHiddenUpdate.next, isHiddenUpdate.next = null, queue.lastBaseUpdate = isHiddenUpdate, queue.shared.pending = null;
        } while (1);
        null === current3 && (lastPendingUpdate = newState);
        queue.baseState = lastPendingUpdate;
        queue.firstBaseUpdate = firstPendingUpdate;
        queue.lastBaseUpdate = current3;
        null === firstBaseUpdate && (queue.shared.lanes = 0);
        workInProgressRootSkippedLanes |= lastBaseUpdate;
        workInProgress2.lanes = lastBaseUpdate;
        workInProgress2.memoizedState = newState;
      }
      currentlyProcessingQueue = null;
    }
    function callCallback(callback, context) {
      if ("function" !== typeof callback)
        throw Error(
          "Invalid argument passed as callback. Expected a function. Instead received: " + callback
        );
      callback.call(context);
    }
    function commitHiddenCallbacks(updateQueue, context) {
      var hiddenCallbacks = updateQueue.shared.hiddenCallbacks;
      if (null !== hiddenCallbacks)
        for (updateQueue.shared.hiddenCallbacks = null, updateQueue = 0; updateQueue < hiddenCallbacks.length; updateQueue++)
          callCallback(hiddenCallbacks[updateQueue], context);
    }
    function commitCallbacks(updateQueue, context) {
      var callbacks = updateQueue.callbacks;
      if (null !== callbacks)
        for (updateQueue.callbacks = null, updateQueue = 0; updateQueue < callbacks.length; updateQueue++)
          callCallback(callbacks[updateQueue], context);
    }
    function pushHiddenContext(fiber, context) {
      var prevEntangledRenderLanes = entangledRenderLanes;
      push2(prevEntangledRenderLanesCursor, prevEntangledRenderLanes, fiber);
      push2(currentTreeHiddenStackCursor, context, fiber);
      entangledRenderLanes = prevEntangledRenderLanes | context.baseLanes;
    }
    function reuseHiddenContextOnStack(fiber) {
      push2(prevEntangledRenderLanesCursor, entangledRenderLanes, fiber);
      push2(
        currentTreeHiddenStackCursor,
        currentTreeHiddenStackCursor.current,
        fiber
      );
    }
    function popHiddenContext(fiber) {
      entangledRenderLanes = prevEntangledRenderLanesCursor.current;
      pop(currentTreeHiddenStackCursor, fiber);
      pop(prevEntangledRenderLanesCursor, fiber);
    }
    function pushPrimaryTreeSuspenseHandler(handler) {
      var current3 = handler.alternate;
      push2(
        suspenseStackCursor,
        suspenseStackCursor.current & SubtreeSuspenseContextMask,
        handler
      );
      push2(suspenseHandlerStackCursor, handler, handler);
      null === shellBoundary && (null === current3 || null !== currentTreeHiddenStackCursor.current ? shellBoundary = handler : null !== current3.memoizedState && (shellBoundary = handler));
    }
    function pushDehydratedActivitySuspenseHandler(fiber) {
      push2(suspenseStackCursor, suspenseStackCursor.current, fiber);
      push2(suspenseHandlerStackCursor, fiber, fiber);
      null === shellBoundary && (shellBoundary = fiber);
    }
    function pushOffscreenSuspenseHandler(fiber) {
      22 === fiber.tag ? (push2(suspenseStackCursor, suspenseStackCursor.current, fiber), push2(suspenseHandlerStackCursor, fiber, fiber), null === shellBoundary && (shellBoundary = fiber)) : reuseSuspenseHandlerOnStack(fiber);
    }
    function reuseSuspenseHandlerOnStack(fiber) {
      push2(suspenseStackCursor, suspenseStackCursor.current, fiber);
      push2(
        suspenseHandlerStackCursor,
        suspenseHandlerStackCursor.current,
        fiber
      );
    }
    function popSuspenseHandler(fiber) {
      pop(suspenseHandlerStackCursor, fiber);
      shellBoundary === fiber && (shellBoundary = null);
      pop(suspenseStackCursor, fiber);
    }
    function findFirstSuspended(row) {
      for (var node = row; null !== node; ) {
        if (13 === node.tag) {
          var state = node.memoizedState;
          if (null !== state && (state = state.dehydrated, null === state || isSuspenseInstancePending(state) || isSuspenseInstanceFallback(state)))
            return node;
        } else if (19 === node.tag && ("forwards" === node.memoizedProps.revealOrder || "backwards" === node.memoizedProps.revealOrder || "unstable_legacy-backwards" === node.memoizedProps.revealOrder || "together" === node.memoizedProps.revealOrder)) {
          if (0 !== (node.flags & 128)) return node;
        } else if (null !== node.child) {
          node.child.return = node;
          node = node.child;
          continue;
        }
        if (node === row) break;
        for (; null === node.sibling; ) {
          if (null === node.return || node.return === row) return null;
          node = node.return;
        }
        node.sibling.return = node.return;
        node = node.sibling;
      }
      return null;
    }
    function mountHookTypesDev() {
      var hookName = currentHookNameInDev;
      null === hookTypesDev ? hookTypesDev = [hookName] : hookTypesDev.push(hookName);
    }
    function updateHookTypesDev() {
      var hookName = currentHookNameInDev;
      if (null !== hookTypesDev && (hookTypesUpdateIndexDev++, hookTypesDev[hookTypesUpdateIndexDev] !== hookName)) {
        var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
        if (!didWarnAboutMismatchedHooksForComponent.has(componentName2) && (didWarnAboutMismatchedHooksForComponent.add(componentName2), null !== hookTypesDev)) {
          for (var table = "", i2 = 0; i2 <= hookTypesUpdateIndexDev; i2++) {
            var oldHookName = hookTypesDev[i2], newHookName = i2 === hookTypesUpdateIndexDev ? hookName : oldHookName;
            for (oldHookName = i2 + 1 + ". " + oldHookName; 30 > oldHookName.length; )
              oldHookName += " ";
            oldHookName += newHookName + "\n";
            table += oldHookName;
          }
          console.error(
            "React has detected a change in the order of Hooks called by %s. This will lead to bugs and errors if not fixed. For more information, read the Rules of Hooks: https://react.dev/link/rules-of-hooks\n\n   Previous render            Next render\n   ------------------------------------------------------\n%s   ^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^^\n",
            componentName2,
            table
          );
        }
      }
    }
    function checkDepsAreArrayDev(deps) {
      void 0 === deps || null === deps || isArrayImpl(deps) || console.error(
        "%s received a final argument that is not an array (instead, received `%s`). When specified, the final argument must be an array.",
        currentHookNameInDev,
        typeof deps
      );
    }
    function warnOnUseFormStateInDev() {
      var componentName2 = getComponentNameFromFiber(currentlyRenderingFiber);
      didWarnAboutUseFormState.has(componentName2) || (didWarnAboutUseFormState.add(componentName2), console.error(
        "ReactDOM.useFormState has been renamed to React.useActionState. Please update %s to use React.useActionState.",
        componentName2
      ));
    }
    function throwInvalidHookError() {
      throw Error(
        "Invalid hook call. Hooks can only be called inside of the body of a function component. This could happen for one of the following reasons:\n1. You might have mismatching versions of React and the renderer (such as React DOM)\n2. You might be breaking the Rules of Hooks\n3. You might have more than one copy of React in the same app\nSee https://react.dev/link/invalid-hook-call for tips about how to debug and fix this problem."
      );
    }
    function areHookInputsEqual(nextDeps, prevDeps) {
      if (ignorePreviousDependencies) return false;
      if (null === prevDeps)
        return console.error(
          "%s received a final argument during this render, but not during the previous render. Even though the final argument is optional, its type cannot change between renders.",
          currentHookNameInDev
        ), false;
      nextDeps.length !== prevDeps.length && console.error(
        "The final argument passed to %s changed size between renders. The order and size of this array must remain constant.\n\nPrevious: %s\nIncoming: %s",
        currentHookNameInDev,
        "[" + prevDeps.join(", ") + "]",
        "[" + nextDeps.join(", ") + "]"
      );
      for (var i2 = 0; i2 < prevDeps.length && i2 < nextDeps.length; i2++)
        if (!objectIs(nextDeps[i2], prevDeps[i2])) return false;
      return true;
    }
    function renderWithHooks(current3, workInProgress2, Component, props2, secondArg, nextRenderLanes) {
      renderLanes = nextRenderLanes;
      currentlyRenderingFiber = workInProgress2;
      hookTypesDev = null !== current3 ? current3._debugHookTypes : null;
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current3 && current3.type !== workInProgress2.type;
      if ("[object AsyncFunction]" === Object.prototype.toString.call(Component) || "[object AsyncGeneratorFunction]" === Object.prototype.toString.call(Component))
        nextRenderLanes = getComponentNameFromFiber(currentlyRenderingFiber), didWarnAboutAsyncClientComponent.has(nextRenderLanes) || (didWarnAboutAsyncClientComponent.add(nextRenderLanes), console.error(
          "%s is an async Client Component. Only Server Components can be async at the moment. This error is often caused by accidentally adding `'use client'` to a module that was originally written for the server.",
          null === nextRenderLanes ? "An unknown Component" : "<" + nextRenderLanes + ">"
        ));
      workInProgress2.memoizedState = null;
      workInProgress2.updateQueue = null;
      workInProgress2.lanes = 0;
      ReactSharedInternals.H = null !== current3 && null !== current3.memoizedState ? HooksDispatcherOnUpdateInDEV : null !== hookTypesDev ? HooksDispatcherOnMountWithHookTypesInDEV : HooksDispatcherOnMountInDEV;
      shouldDoubleInvokeUserFnsInHooksDEV = nextRenderLanes = (workInProgress2.mode & StrictLegacyMode) !== NoMode;
      var children = callComponentInDEV(Component, props2, secondArg);
      shouldDoubleInvokeUserFnsInHooksDEV = false;
      didScheduleRenderPhaseUpdateDuringThisPass && (children = renderWithHooksAgain(
        workInProgress2,
        Component,
        props2,
        secondArg
      ));
      if (nextRenderLanes) {
        setIsStrictModeForDevtools(true);
        try {
          children = renderWithHooksAgain(
            workInProgress2,
            Component,
            props2,
            secondArg
          );
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      finishRenderingHooks(current3, workInProgress2);
      return children;
    }
    function finishRenderingHooks(current3, workInProgress2) {
      workInProgress2._debugHookTypes = hookTypesDev;
      null === workInProgress2.dependencies ? null !== thenableState && (workInProgress2.dependencies = {
        lanes: 0,
        firstContext: null,
        _debugThenableState: thenableState
      }) : workInProgress2.dependencies._debugThenableState = thenableState;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      var didRenderTooFewHooks = null !== currentHook && null !== currentHook.next;
      renderLanes = 0;
      hookTypesDev = currentHookNameInDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      null !== current3 && (current3.flags & 65011712) !== (workInProgress2.flags & 65011712) && console.error(
        "Internal React error: Expected static flag was missing. Please notify the React team."
      );
      didScheduleRenderPhaseUpdate = false;
      thenableIndexCounter = 0;
      thenableState = null;
      if (didRenderTooFewHooks)
        throw Error(
          "Rendered fewer hooks than expected. This may be caused by an accidental early return statement."
        );
      null === current3 || didReceiveUpdate || (current3 = current3.dependencies, null !== current3 && checkIfContextChanged(current3) && (didReceiveUpdate = true));
      needsToResetSuspendedThenableDEV ? (needsToResetSuspendedThenableDEV = false, current3 = true) : current3 = false;
      current3 && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Unknown", didWarnAboutUseWrappedInTryCatch.has(workInProgress2) || didWarnAboutAsyncClientComponent.has(workInProgress2) || (didWarnAboutUseWrappedInTryCatch.add(workInProgress2), console.error(
        "`use` was called from inside a try/catch block. This is not allowed and can lead to unexpected behavior. To handle errors triggered by `use`, wrap your component in a error boundary."
      )));
    }
    function renderWithHooksAgain(workInProgress2, Component, props2, secondArg) {
      currentlyRenderingFiber = workInProgress2;
      var numberOfReRenders = 0;
      do {
        didScheduleRenderPhaseUpdateDuringThisPass && (thenableState = null);
        thenableIndexCounter = 0;
        didScheduleRenderPhaseUpdateDuringThisPass = false;
        if (numberOfReRenders >= RE_RENDER_LIMIT)
          throw Error(
            "Too many re-renders. React limits the number of renders to prevent an infinite loop."
          );
        numberOfReRenders += 1;
        ignorePreviousDependencies = false;
        workInProgressHook = currentHook = null;
        if (null != workInProgress2.updateQueue) {
          var children = workInProgress2.updateQueue;
          children.lastEffect = null;
          children.events = null;
          children.stores = null;
          null != children.memoCache && (children.memoCache.index = 0);
        }
        hookTypesUpdateIndexDev = -1;
        ReactSharedInternals.H = HooksDispatcherOnRerenderInDEV;
        children = callComponentInDEV(Component, props2, secondArg);
      } while (didScheduleRenderPhaseUpdateDuringThisPass);
      return children;
    }
    function TransitionAwareHostComponent() {
      var dispatcher = ReactSharedInternals.H, maybeThenable = dispatcher.useState()[0];
      maybeThenable = "function" === typeof maybeThenable.then ? useThenable(maybeThenable) : maybeThenable;
      dispatcher = dispatcher.useState()[0];
      (null !== currentHook ? currentHook.memoizedState : null) !== dispatcher && (currentlyRenderingFiber.flags |= 1024);
      return maybeThenable;
    }
    function checkDidRenderIdHook() {
      var didRenderIdHook = 0 !== localIdCounter;
      localIdCounter = 0;
      return didRenderIdHook;
    }
    function bailoutHooks(current3, workInProgress2, lanes) {
      workInProgress2.updateQueue = current3.updateQueue;
      workInProgress2.flags = (workInProgress2.mode & StrictEffectsMode) !== NoMode ? workInProgress2.flags & -402655237 : workInProgress2.flags & -2053;
      current3.lanes &= ~lanes;
    }
    function resetHooksOnUnwind(workInProgress2) {
      if (didScheduleRenderPhaseUpdate) {
        for (workInProgress2 = workInProgress2.memoizedState; null !== workInProgress2; ) {
          var queue = workInProgress2.queue;
          null !== queue && (queue.pending = null);
          workInProgress2 = workInProgress2.next;
        }
        didScheduleRenderPhaseUpdate = false;
      }
      renderLanes = 0;
      hookTypesDev = workInProgressHook = currentHook = currentlyRenderingFiber = null;
      hookTypesUpdateIndexDev = -1;
      currentHookNameInDev = null;
      didScheduleRenderPhaseUpdateDuringThisPass = false;
      thenableIndexCounter = localIdCounter = 0;
      thenableState = null;
    }
    function mountWorkInProgressHook() {
      var hook = {
        memoizedState: null,
        baseState: null,
        baseQueue: null,
        queue: null,
        next: null
      };
      null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = hook : workInProgressHook = workInProgressHook.next = hook;
      return workInProgressHook;
    }
    function updateWorkInProgressHook() {
      if (null === currentHook) {
        var nextCurrentHook = currentlyRenderingFiber.alternate;
        nextCurrentHook = null !== nextCurrentHook ? nextCurrentHook.memoizedState : null;
      } else nextCurrentHook = currentHook.next;
      var nextWorkInProgressHook = null === workInProgressHook ? currentlyRenderingFiber.memoizedState : workInProgressHook.next;
      if (null !== nextWorkInProgressHook)
        workInProgressHook = nextWorkInProgressHook, currentHook = nextCurrentHook;
      else {
        if (null === nextCurrentHook) {
          if (null === currentlyRenderingFiber.alternate)
            throw Error(
              "Update hook called on initial render. This is likely a bug in React. Please file an issue."
            );
          throw Error("Rendered more hooks than during the previous render.");
        }
        currentHook = nextCurrentHook;
        nextCurrentHook = {
          memoizedState: currentHook.memoizedState,
          baseState: currentHook.baseState,
          baseQueue: currentHook.baseQueue,
          queue: currentHook.queue,
          next: null
        };
        null === workInProgressHook ? currentlyRenderingFiber.memoizedState = workInProgressHook = nextCurrentHook : workInProgressHook = workInProgressHook.next = nextCurrentHook;
      }
      return workInProgressHook;
    }
    function createFunctionComponentUpdateQueue() {
      return { lastEffect: null, events: null, stores: null, memoCache: null };
    }
    function useThenable(thenable) {
      var index2 = thenableIndexCounter;
      thenableIndexCounter += 1;
      null === thenableState && (thenableState = createThenableState());
      thenable = trackUsedThenable(thenableState, thenable, index2);
      index2 = currentlyRenderingFiber;
      null === (null === workInProgressHook ? index2.memoizedState : workInProgressHook.next) && (index2 = index2.alternate, ReactSharedInternals.H = null !== index2 && null !== index2.memoizedState ? HooksDispatcherOnUpdateInDEV : HooksDispatcherOnMountInDEV);
      return thenable;
    }
    function use(usable) {
      if (null !== usable && "object" === typeof usable) {
        if ("function" === typeof usable.then) return useThenable(usable);
        if (usable.$$typeof === REACT_CONTEXT_TYPE) return readContext(usable);
      }
      throw Error("An unsupported type was passed to use(): " + String(usable));
    }
    function useMemoCache(size2) {
      var memoCache = null, updateQueue = currentlyRenderingFiber.updateQueue;
      null !== updateQueue && (memoCache = updateQueue.memoCache);
      if (null == memoCache) {
        var current3 = currentlyRenderingFiber.alternate;
        null !== current3 && (current3 = current3.updateQueue, null !== current3 && (current3 = current3.memoCache, null != current3 && (memoCache = {
          data: current3.data.map(function(array) {
            return array.slice();
          }),
          index: 0
        })));
      }
      null == memoCache && (memoCache = { data: [], index: 0 });
      null === updateQueue && (updateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = updateQueue);
      updateQueue.memoCache = memoCache;
      updateQueue = memoCache.data[memoCache.index];
      if (void 0 === updateQueue || ignorePreviousDependencies)
        for (updateQueue = memoCache.data[memoCache.index] = Array(size2), current3 = 0; current3 < size2; current3++)
          updateQueue[current3] = REACT_MEMO_CACHE_SENTINEL;
      else
        updateQueue.length !== size2 && console.error(
          "Expected a constant size argument for each invocation of useMemoCache. The previous cache was allocated with size %s but size %s was requested.",
          updateQueue.length,
          size2
        );
      memoCache.index++;
      return updateQueue;
    }
    function basicStateReducer(state, action) {
      return "function" === typeof action ? action(state) : action;
    }
    function mountReducer(reducer, initialArg, init2) {
      var hook = mountWorkInProgressHook();
      if (void 0 !== init2) {
        var initialState2 = init2(initialArg);
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            init2(initialArg);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      } else initialState2 = initialArg;
      hook.memoizedState = hook.baseState = initialState2;
      reducer = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: reducer,
        lastRenderedState: initialState2
      };
      hook.queue = reducer;
      reducer = reducer.dispatch = dispatchReducerAction.bind(
        null,
        currentlyRenderingFiber,
        reducer
      );
      return [hook.memoizedState, reducer];
    }
    function updateReducer(reducer) {
      var hook = updateWorkInProgressHook();
      return updateReducerImpl(hook, currentHook, reducer);
    }
    function updateReducerImpl(hook, current3, reducer) {
      var queue = hook.queue;
      if (null === queue)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue.lastRenderedReducer = reducer;
      var baseQueue = hook.baseQueue, pendingQueue = queue.pending;
      if (null !== pendingQueue) {
        if (null !== baseQueue) {
          var baseFirst = baseQueue.next;
          baseQueue.next = pendingQueue.next;
          pendingQueue.next = baseFirst;
        }
        current3.baseQueue !== baseQueue && console.error(
          "Internal error: Expected work-in-progress queue to be a clone. This is a bug in React."
        );
        current3.baseQueue = baseQueue = pendingQueue;
        queue.pending = null;
      }
      pendingQueue = hook.baseState;
      if (null === baseQueue) hook.memoizedState = pendingQueue;
      else {
        current3 = baseQueue.next;
        var newBaseQueueFirst = baseFirst = null, newBaseQueueLast = null, update = current3, didReadFromEntangledAsyncAction2 = false;
        do {
          var updateLane = update.lane & -536870913;
          if (updateLane !== update.lane ? (workInProgressRootRenderLanes & updateLane) === updateLane : (renderLanes & updateLane) === updateLane) {
            var revertLane = update.revertLane;
            if (0 === revertLane)
              null !== newBaseQueueLast && (newBaseQueueLast = newBaseQueueLast.next = {
                lane: 0,
                revertLane: 0,
                gesture: null,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              }), updateLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
            else if ((renderLanes & revertLane) === revertLane) {
              update = update.next;
              revertLane === currentEntangledLane && (didReadFromEntangledAsyncAction2 = true);
              continue;
            } else
              updateLane = {
                lane: 0,
                revertLane: update.revertLane,
                gesture: null,
                action: update.action,
                hasEagerState: update.hasEagerState,
                eagerState: update.eagerState,
                next: null
              }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = updateLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = updateLane, currentlyRenderingFiber.lanes |= revertLane, workInProgressRootSkippedLanes |= revertLane;
            updateLane = update.action;
            shouldDoubleInvokeUserFnsInHooksDEV && reducer(pendingQueue, updateLane);
            pendingQueue = update.hasEagerState ? update.eagerState : reducer(pendingQueue, updateLane);
          } else
            revertLane = {
              lane: updateLane,
              revertLane: update.revertLane,
              gesture: update.gesture,
              action: update.action,
              hasEagerState: update.hasEagerState,
              eagerState: update.eagerState,
              next: null
            }, null === newBaseQueueLast ? (newBaseQueueFirst = newBaseQueueLast = revertLane, baseFirst = pendingQueue) : newBaseQueueLast = newBaseQueueLast.next = revertLane, currentlyRenderingFiber.lanes |= updateLane, workInProgressRootSkippedLanes |= updateLane;
          update = update.next;
        } while (null !== update && update !== current3);
        null === newBaseQueueLast ? baseFirst = pendingQueue : newBaseQueueLast.next = newBaseQueueFirst;
        if (!objectIs(pendingQueue, hook.memoizedState) && (didReceiveUpdate = true, didReadFromEntangledAsyncAction2 && (reducer = currentEntangledActionThenable, null !== reducer)))
          throw reducer;
        hook.memoizedState = pendingQueue;
        hook.baseState = baseFirst;
        hook.baseQueue = newBaseQueueLast;
        queue.lastRenderedState = pendingQueue;
      }
      null === baseQueue && (queue.lanes = 0);
      return [hook.memoizedState, queue.dispatch];
    }
    function rerenderReducer(reducer) {
      var hook = updateWorkInProgressHook(), queue = hook.queue;
      if (null === queue)
        throw Error(
          "Should have a queue. You are likely calling Hooks conditionally, which is not allowed. (https://react.dev/link/invalid-hook-call)"
        );
      queue.lastRenderedReducer = reducer;
      var dispatch = queue.dispatch, lastRenderPhaseUpdate = queue.pending, newState = hook.memoizedState;
      if (null !== lastRenderPhaseUpdate) {
        queue.pending = null;
        var update = lastRenderPhaseUpdate = lastRenderPhaseUpdate.next;
        do
          newState = reducer(newState, update.action), update = update.next;
        while (update !== lastRenderPhaseUpdate);
        objectIs(newState, hook.memoizedState) || (didReceiveUpdate = true);
        hook.memoizedState = newState;
        null === hook.baseQueue && (hook.baseState = newState);
        queue.lastRenderedState = newState;
      }
      return [newState, dispatch];
    }
    function mountSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = mountWorkInProgressHook();
      if (isHydrating) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        var nextSnapshot = getServerSnapshot();
        didWarnUncachedGetSnapshot || nextSnapshot === getServerSnapshot() || (console.error(
          "The result of getServerSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      } else {
        nextSnapshot = getSnapshot();
        didWarnUncachedGetSnapshot || (getServerSnapshot = getSnapshot(), objectIs(nextSnapshot, getServerSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true));
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        0 !== (workInProgressRootRenderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, nextSnapshot);
      }
      hook.memoizedState = nextSnapshot;
      getServerSnapshot = { value: nextSnapshot, getSnapshot };
      hook.queue = getServerSnapshot;
      mountEffect(
        subscribeToStore.bind(null, fiber, getServerSnapshot, subscribe2),
        [subscribe2]
      );
      fiber.flags |= 2048;
      pushSimpleEffect(
        HasEffect | Passive,
        { destroy: void 0 },
        updateStoreInstance.bind(
          null,
          fiber,
          getServerSnapshot,
          nextSnapshot,
          getSnapshot
        ),
        null
      );
      return nextSnapshot;
    }
    function updateSyncExternalStore(subscribe2, getSnapshot, getServerSnapshot) {
      var fiber = currentlyRenderingFiber, hook = updateWorkInProgressHook(), isHydrating$jscomp$0 = isHydrating;
      if (isHydrating$jscomp$0) {
        if (void 0 === getServerSnapshot)
          throw Error(
            "Missing getServerSnapshot, which is required for server-rendered content. Will revert to client rendering."
          );
        getServerSnapshot = getServerSnapshot();
      } else if (getServerSnapshot = getSnapshot(), !didWarnUncachedGetSnapshot) {
        var cachedSnapshot = getSnapshot();
        objectIs(getServerSnapshot, cachedSnapshot) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      if (cachedSnapshot = !objectIs(
        (currentHook || hook).memoizedState,
        getServerSnapshot
      ))
        hook.memoizedState = getServerSnapshot, didReceiveUpdate = true;
      hook = hook.queue;
      var create2 = subscribeToStore.bind(null, fiber, hook, subscribe2);
      updateEffectImpl(2048, Passive, create2, [subscribe2]);
      if (hook.getSnapshot !== getSnapshot || cachedSnapshot || null !== workInProgressHook && workInProgressHook.memoizedState.tag & HasEffect) {
        fiber.flags |= 2048;
        pushSimpleEffect(
          HasEffect | Passive,
          { destroy: void 0 },
          updateStoreInstance.bind(
            null,
            fiber,
            hook,
            getServerSnapshot,
            getSnapshot
          ),
          null
        );
        if (null === workInProgressRoot)
          throw Error(
            "Expected a work-in-progress root. This is a bug in React. Please file an issue."
          );
        isHydrating$jscomp$0 || 0 !== (renderLanes & 127) || pushStoreConsistencyCheck(fiber, getSnapshot, getServerSnapshot);
      }
      return getServerSnapshot;
    }
    function pushStoreConsistencyCheck(fiber, getSnapshot, renderedSnapshot) {
      fiber.flags |= 16384;
      fiber = { getSnapshot, value: renderedSnapshot };
      getSnapshot = currentlyRenderingFiber.updateQueue;
      null === getSnapshot ? (getSnapshot = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = getSnapshot, getSnapshot.stores = [fiber]) : (renderedSnapshot = getSnapshot.stores, null === renderedSnapshot ? getSnapshot.stores = [fiber] : renderedSnapshot.push(fiber));
    }
    function updateStoreInstance(fiber, inst, nextSnapshot, getSnapshot) {
      inst.value = nextSnapshot;
      inst.getSnapshot = getSnapshot;
      checkIfSnapshotChanged(inst) && forceStoreRerender(fiber);
    }
    function subscribeToStore(fiber, inst, subscribe2) {
      return subscribe2(function() {
        checkIfSnapshotChanged(inst) && (startUpdateTimerByLane(2, "updateSyncExternalStore()", fiber), forceStoreRerender(fiber));
      });
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function forceStoreRerender(fiber) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
    }
    function mountStateImpl(initialState2) {
      var hook = mountWorkInProgressHook();
      if ("function" === typeof initialState2) {
        var initialStateInitializer = initialState2;
        initialState2 = initialStateInitializer();
        if (shouldDoubleInvokeUserFnsInHooksDEV) {
          setIsStrictModeForDevtools(true);
          try {
            initialStateInitializer();
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
      }
      hook.memoizedState = hook.baseState = initialState2;
      hook.queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: basicStateReducer,
        lastRenderedState: initialState2
      };
      return hook;
    }
    function mountState(initialState2) {
      initialState2 = mountStateImpl(initialState2);
      var queue = initialState2.queue, dispatch = dispatchSetState.bind(null, currentlyRenderingFiber, queue);
      queue.dispatch = dispatch;
      return [initialState2.memoizedState, dispatch];
    }
    function mountOptimistic(passthrough) {
      var hook = mountWorkInProgressHook();
      hook.memoizedState = hook.baseState = passthrough;
      var queue = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: null,
        lastRenderedState: null
      };
      hook.queue = queue;
      hook = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        true,
        queue
      );
      queue.dispatch = hook;
      return [passthrough, hook];
    }
    function updateOptimistic(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
    }
    function updateOptimisticImpl(hook, current3, passthrough, reducer) {
      hook.baseState = passthrough;
      return updateReducerImpl(
        hook,
        currentHook,
        "function" === typeof reducer ? reducer : basicStateReducer
      );
    }
    function rerenderOptimistic(passthrough, reducer) {
      var hook = updateWorkInProgressHook();
      if (null !== currentHook)
        return updateOptimisticImpl(hook, currentHook, passthrough, reducer);
      hook.baseState = passthrough;
      return [passthrough, hook.queue.dispatch];
    }
    function dispatchActionState(fiber, actionQueue, setPendingState, setState, payload) {
      if (isRenderPhaseUpdate(fiber))
        throw Error("Cannot update form state while rendering.");
      fiber = actionQueue.action;
      if (null !== fiber) {
        var actionNode = {
          payload,
          action: fiber,
          next: null,
          isTransition: true,
          status: "pending",
          value: null,
          reason: null,
          listeners: [],
          then: function(listener) {
            actionNode.listeners.push(listener);
          }
        };
        null !== ReactSharedInternals.T ? setPendingState(true) : actionNode.isTransition = false;
        setState(actionNode);
        setPendingState = actionQueue.pending;
        null === setPendingState ? (actionNode.next = actionQueue.pending = actionNode, runActionStateAction(actionQueue, actionNode)) : (actionNode.next = setPendingState.next, actionQueue.pending = setPendingState.next = actionNode);
      }
    }
    function runActionStateAction(actionQueue, node) {
      var action = node.action, payload = node.payload, prevState = actionQueue.state;
      if (node.isTransition) {
        var prevTransition = ReactSharedInternals.T, currentTransition = {};
        currentTransition._updatedFibers = /* @__PURE__ */ new Set();
        ReactSharedInternals.T = currentTransition;
        try {
          var returnValue = action(prevState, payload), onStartTransitionFinish = ReactSharedInternals.S;
          null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
          handleActionReturnValue(actionQueue, node, returnValue);
        } catch (error) {
          onActionError(actionQueue, node, error);
        } finally {
          null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error(
            "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
          ), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (actionQueue = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < actionQueue && console.warn(
            "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
          ));
        }
      } else
        try {
          currentTransition = action(prevState, payload), handleActionReturnValue(actionQueue, node, currentTransition);
        } catch (error$4) {
          onActionError(actionQueue, node, error$4);
        }
    }
    function handleActionReturnValue(actionQueue, node, returnValue) {
      null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then ? (ReactSharedInternals.asyncTransitions++, returnValue.then(releaseAsyncTransition, releaseAsyncTransition), returnValue.then(
        function(nextState) {
          onActionSuccess(actionQueue, node, nextState);
        },
        function(error) {
          return onActionError(actionQueue, node, error);
        }
      ), node.isTransition || console.error(
        "An async function with useActionState was called outside of a transition. This is likely not what you intended (for example, isPending will not update correctly). Either call the returned function inside startTransition, or pass it to an `action` or `formAction` prop."
      )) : onActionSuccess(actionQueue, node, returnValue);
    }
    function onActionSuccess(actionQueue, actionNode, nextState) {
      actionNode.status = "fulfilled";
      actionNode.value = nextState;
      notifyActionListeners(actionNode);
      actionQueue.state = nextState;
      actionNode = actionQueue.pending;
      null !== actionNode && (nextState = actionNode.next, nextState === actionNode ? actionQueue.pending = null : (nextState = nextState.next, actionNode.next = nextState, runActionStateAction(actionQueue, nextState)));
    }
    function onActionError(actionQueue, actionNode, error) {
      var last2 = actionQueue.pending;
      actionQueue.pending = null;
      if (null !== last2) {
        last2 = last2.next;
        do
          actionNode.status = "rejected", actionNode.reason = error, notifyActionListeners(actionNode), actionNode = actionNode.next;
        while (actionNode !== last2);
      }
      actionQueue.action = null;
    }
    function notifyActionListeners(actionNode) {
      actionNode = actionNode.listeners;
      for (var i2 = 0; i2 < actionNode.length; i2++) (0, actionNode[i2])();
    }
    function actionStateReducer(oldState, newState) {
      return newState;
    }
    function mountActionState(action, initialStateProp) {
      if (isHydrating) {
        var ssrFormState = workInProgressRoot.formState;
        if (null !== ssrFormState) {
          a: {
            var isMatching = currentlyRenderingFiber;
            if (isHydrating) {
              if (nextHydratableInstance) {
                b: {
                  var markerInstance = nextHydratableInstance;
                  for (var inRootOrSingleton = rootOrSingletonContext; 8 !== markerInstance.nodeType; ) {
                    if (!inRootOrSingleton) {
                      markerInstance = null;
                      break b;
                    }
                    markerInstance = getNextHydratable(
                      markerInstance.nextSibling
                    );
                    if (null === markerInstance) {
                      markerInstance = null;
                      break b;
                    }
                  }
                  inRootOrSingleton = markerInstance.data;
                  markerInstance = inRootOrSingleton === FORM_STATE_IS_MATCHING || inRootOrSingleton === FORM_STATE_IS_NOT_MATCHING ? markerInstance : null;
                }
                if (markerInstance) {
                  nextHydratableInstance = getNextHydratable(
                    markerInstance.nextSibling
                  );
                  isMatching = markerInstance.data === FORM_STATE_IS_MATCHING;
                  break a;
                }
              }
              throwOnHydrationMismatch(isMatching);
            }
            isMatching = false;
          }
          isMatching && (initialStateProp = ssrFormState[0]);
        }
      }
      ssrFormState = mountWorkInProgressHook();
      ssrFormState.memoizedState = ssrFormState.baseState = initialStateProp;
      isMatching = {
        pending: null,
        lanes: 0,
        dispatch: null,
        lastRenderedReducer: actionStateReducer,
        lastRenderedState: initialStateProp
      };
      ssrFormState.queue = isMatching;
      ssrFormState = dispatchSetState.bind(
        null,
        currentlyRenderingFiber,
        isMatching
      );
      isMatching.dispatch = ssrFormState;
      isMatching = mountStateImpl(false);
      inRootOrSingleton = dispatchOptimisticSetState.bind(
        null,
        currentlyRenderingFiber,
        false,
        isMatching.queue
      );
      isMatching = mountWorkInProgressHook();
      markerInstance = {
        state: initialStateProp,
        dispatch: null,
        action,
        pending: null
      };
      isMatching.queue = markerInstance;
      ssrFormState = dispatchActionState.bind(
        null,
        currentlyRenderingFiber,
        markerInstance,
        inRootOrSingleton,
        ssrFormState
      );
      markerInstance.dispatch = ssrFormState;
      isMatching.memoizedState = action;
      return [initialStateProp, ssrFormState, false];
    }
    function updateActionState(action) {
      var stateHook = updateWorkInProgressHook();
      return updateActionStateImpl(stateHook, currentHook, action);
    }
    function updateActionStateImpl(stateHook, currentStateHook, action) {
      currentStateHook = updateReducerImpl(
        stateHook,
        currentStateHook,
        actionStateReducer
      )[0];
      stateHook = updateReducer(basicStateReducer)[0];
      if ("object" === typeof currentStateHook && null !== currentStateHook && "function" === typeof currentStateHook.then)
        try {
          var state = useThenable(currentStateHook);
        } catch (x2) {
          if (x2 === SuspenseException) throw SuspenseActionException;
          throw x2;
        }
      else state = currentStateHook;
      currentStateHook = updateWorkInProgressHook();
      var actionQueue = currentStateHook.queue, dispatch = actionQueue.dispatch;
      action !== currentStateHook.memoizedState && (currentlyRenderingFiber.flags |= 2048, pushSimpleEffect(
        HasEffect | Passive,
        { destroy: void 0 },
        actionStateActionEffect.bind(null, actionQueue, action),
        null
      ));
      return [state, dispatch, stateHook];
    }
    function actionStateActionEffect(actionQueue, action) {
      actionQueue.action = action;
    }
    function rerenderActionState(action) {
      var stateHook = updateWorkInProgressHook(), currentStateHook = currentHook;
      if (null !== currentStateHook)
        return updateActionStateImpl(stateHook, currentStateHook, action);
      updateWorkInProgressHook();
      stateHook = stateHook.memoizedState;
      currentStateHook = updateWorkInProgressHook();
      var dispatch = currentStateHook.queue.dispatch;
      currentStateHook.memoizedState = action;
      return [stateHook, dispatch, false];
    }
    function pushSimpleEffect(tag2, inst, create2, deps) {
      tag2 = { tag: tag2, create: create2, deps, inst, next: null };
      inst = currentlyRenderingFiber.updateQueue;
      null === inst && (inst = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = inst);
      create2 = inst.lastEffect;
      null === create2 ? inst.lastEffect = tag2.next = tag2 : (deps = create2.next, create2.next = tag2, tag2.next = deps, inst.lastEffect = tag2);
      return tag2;
    }
    function mountRef(initialValue) {
      var hook = mountWorkInProgressHook();
      initialValue = { current: initialValue };
      return hook.memoizedState = initialValue;
    }
    function mountEffectImpl(fiberFlags, hookFlags, create2, deps) {
      var hook = mountWorkInProgressHook();
      currentlyRenderingFiber.flags |= fiberFlags;
      hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        { destroy: void 0 },
        create2,
        void 0 === deps ? null : deps
      );
    }
    function updateEffectImpl(fiberFlags, hookFlags, create2, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var inst = hook.memoizedState.inst;
      null !== currentHook && null !== deps && areHookInputsEqual(deps, currentHook.memoizedState.deps) ? hook.memoizedState = pushSimpleEffect(hookFlags, inst, create2, deps) : (currentlyRenderingFiber.flags |= fiberFlags, hook.memoizedState = pushSimpleEffect(
        HasEffect | hookFlags,
        inst,
        create2,
        deps
      ));
    }
    function mountEffect(create2, deps) {
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode ? mountEffectImpl(276826112, Passive, create2, deps) : mountEffectImpl(8390656, Passive, create2, deps);
    }
    function useEffectEventImpl(payload) {
      currentlyRenderingFiber.flags |= 4;
      var componentUpdateQueue = currentlyRenderingFiber.updateQueue;
      if (null === componentUpdateQueue)
        componentUpdateQueue = createFunctionComponentUpdateQueue(), currentlyRenderingFiber.updateQueue = componentUpdateQueue, componentUpdateQueue.events = [payload];
      else {
        var events2 = componentUpdateQueue.events;
        null === events2 ? componentUpdateQueue.events = [payload] : events2.push(payload);
      }
    }
    function mountEvent(callback) {
      var hook = mountWorkInProgressHook(), ref = { impl: callback };
      hook.memoizedState = ref;
      return function() {
        if ((executionContext & RenderContext) !== NoContext)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return ref.impl.apply(void 0, arguments);
      };
    }
    function updateEvent(callback) {
      var ref = updateWorkInProgressHook().memoizedState;
      useEffectEventImpl({ ref, nextImpl: callback });
      return function() {
        if ((executionContext & RenderContext) !== NoContext)
          throw Error(
            "A function wrapped in useEffectEvent can't be called during rendering."
          );
        return ref.impl.apply(void 0, arguments);
      };
    }
    function mountLayoutEffect(create2, deps) {
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      return mountEffectImpl(fiberFlags, Layout, create2, deps);
    }
    function imperativeHandleEffect(create2, ref) {
      if ("function" === typeof ref) {
        create2 = create2();
        var refCleanup = ref(create2);
        return function() {
          "function" === typeof refCleanup ? refCleanup() : ref(null);
        };
      }
      if (null !== ref && void 0 !== ref)
        return ref.hasOwnProperty("current") || console.error(
          "Expected useImperativeHandle() first argument to either be a ref callback or React.createRef() object. Instead received: %s.",
          "an object with keys {" + Object.keys(ref).join(", ") + "}"
        ), create2 = create2(), ref.current = create2, function() {
          ref.current = null;
        };
    }
    function mountImperativeHandle(ref, create2, deps) {
      "function" !== typeof create2 && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create2 ? typeof create2 : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      var fiberFlags = 4194308;
      (currentlyRenderingFiber.mode & StrictEffectsMode) !== NoMode && (fiberFlags |= 134217728);
      mountEffectImpl(
        fiberFlags,
        Layout,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    }
    function updateImperativeHandle(ref, create2, deps) {
      "function" !== typeof create2 && console.error(
        "Expected useImperativeHandle() second argument to be a function that creates a handle. Instead received: %s.",
        null !== create2 ? typeof create2 : "null"
      );
      deps = null !== deps && void 0 !== deps ? deps.concat([ref]) : null;
      updateEffectImpl(
        4,
        Layout,
        imperativeHandleEffect.bind(null, create2, ref),
        deps
      );
    }
    function mountCallback(callback, deps) {
      mountWorkInProgressHook().memoizedState = [
        callback,
        void 0 === deps ? null : deps
      ];
      return callback;
    }
    function updateCallback(callback, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      hook.memoizedState = [callback, deps];
      return callback;
    }
    function mountMemo(nextCreate, deps) {
      var hook = mountWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var nextValue = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [nextValue, deps];
      return nextValue;
    }
    function updateMemo(nextCreate, deps) {
      var hook = updateWorkInProgressHook();
      deps = void 0 === deps ? null : deps;
      var prevState = hook.memoizedState;
      if (null !== deps && areHookInputsEqual(deps, prevState[1]))
        return prevState[0];
      prevState = nextCreate();
      if (shouldDoubleInvokeUserFnsInHooksDEV) {
        setIsStrictModeForDevtools(true);
        try {
          nextCreate();
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      hook.memoizedState = [prevState, deps];
      return prevState;
    }
    function mountDeferredValue(value, initialValue) {
      var hook = mountWorkInProgressHook();
      return mountDeferredValueImpl(hook, value, initialValue);
    }
    function updateDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function rerenderDeferredValue(value, initialValue) {
      var hook = updateWorkInProgressHook();
      return null === currentHook ? mountDeferredValueImpl(hook, value, initialValue) : updateDeferredValueImpl(
        hook,
        currentHook.memoizedState,
        value,
        initialValue
      );
    }
    function mountDeferredValueImpl(hook, value, initialValue) {
      if (void 0 === initialValue || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
        return hook.memoizedState = value;
      hook.memoizedState = initialValue;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return initialValue;
    }
    function updateDeferredValueImpl(hook, prevValue, value, initialValue) {
      if (objectIs(value, prevValue)) return value;
      if (null !== currentTreeHiddenStackCursor.current)
        return hook = mountDeferredValueImpl(hook, value, initialValue), objectIs(hook, prevValue) || (didReceiveUpdate = true), hook;
      if (0 === (renderLanes & 42) || 0 !== (renderLanes & 1073741824) && 0 === (workInProgressRootRenderLanes & 261930))
        return didReceiveUpdate = true, hook.memoizedState = value;
      hook = requestDeferredLane();
      currentlyRenderingFiber.lanes |= hook;
      workInProgressRootSkippedLanes |= hook;
      return prevValue;
    }
    function releaseAsyncTransition() {
      ReactSharedInternals.asyncTransitions--;
    }
    function startTransition(fiber, queue, pendingState, finishedState, callback) {
      var previousPriority = ReactDOMSharedInternals.p;
      ReactDOMSharedInternals.p = 0 !== previousPriority && previousPriority < ContinuousEventPriority ? previousPriority : ContinuousEventPriority;
      var prevTransition = ReactSharedInternals.T, currentTransition = {};
      currentTransition._updatedFibers = /* @__PURE__ */ new Set();
      ReactSharedInternals.T = currentTransition;
      dispatchOptimisticSetState(fiber, false, queue, pendingState);
      try {
        var returnValue = callback(), onStartTransitionFinish = ReactSharedInternals.S;
        null !== onStartTransitionFinish && onStartTransitionFinish(currentTransition, returnValue);
        if (null !== returnValue && "object" === typeof returnValue && "function" === typeof returnValue.then) {
          ReactSharedInternals.asyncTransitions++;
          returnValue.then(releaseAsyncTransition, releaseAsyncTransition);
          var thenableForFinishedState = chainThenableValue(
            returnValue,
            finishedState
          );
          dispatchSetStateInternal(
            fiber,
            queue,
            thenableForFinishedState,
            requestUpdateLane(fiber)
          );
        } else
          dispatchSetStateInternal(
            fiber,
            queue,
            finishedState,
            requestUpdateLane(fiber)
          );
      } catch (error) {
        dispatchSetStateInternal(
          fiber,
          queue,
          { then: function() {
          }, status: "rejected", reason: error },
          requestUpdateLane(fiber)
        );
      } finally {
        ReactDOMSharedInternals.p = previousPriority, null !== prevTransition && null !== currentTransition.types && (null !== prevTransition.types && prevTransition.types !== currentTransition.types && console.error(
          "We expected inner Transitions to have transferred the outer types set and that you cannot add to the outer Transition while inside the inner.This is a bug in React."
        ), prevTransition.types = currentTransition.types), ReactSharedInternals.T = prevTransition, null === prevTransition && currentTransition._updatedFibers && (fiber = currentTransition._updatedFibers.size, currentTransition._updatedFibers.clear(), 10 < fiber && console.warn(
          "Detected a large number of updates inside startTransition. If this is due to a subscription please re-write it to use React provided hooks. Otherwise concurrent mode guarantees are off the table."
        ));
      }
    }
    function startHostTransition(formFiber, pendingState, action, formData) {
      if (5 !== formFiber.tag)
        throw Error(
          "Expected the form instance to be a HostComponent. This is a bug in React."
        );
      var queue = ensureFormComponentIsStateful(formFiber).queue;
      startHostActionTimer(formFiber);
      startTransition(
        formFiber,
        queue,
        pendingState,
        NotPendingTransition,
        null === action ? noop2 : function() {
          requestFormReset$1(formFiber);
          return action(formData);
        }
      );
    }
    function ensureFormComponentIsStateful(formFiber) {
      var existingStateHook = formFiber.memoizedState;
      if (null !== existingStateHook) return existingStateHook;
      existingStateHook = {
        memoizedState: NotPendingTransition,
        baseState: NotPendingTransition,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: NotPendingTransition
        },
        next: null
      };
      var initialResetState = {};
      existingStateHook.next = {
        memoizedState: initialResetState,
        baseState: initialResetState,
        baseQueue: null,
        queue: {
          pending: null,
          lanes: 0,
          dispatch: null,
          lastRenderedReducer: basicStateReducer,
          lastRenderedState: initialResetState
        },
        next: null
      };
      formFiber.memoizedState = existingStateHook;
      formFiber = formFiber.alternate;
      null !== formFiber && (formFiber.memoizedState = existingStateHook);
      return existingStateHook;
    }
    function requestFormReset$1(formFiber) {
      null === ReactSharedInternals.T && console.error(
        "requestFormReset was called outside a transition or action. To fix, move to an action, or wrap with startTransition."
      );
      var stateHook = ensureFormComponentIsStateful(formFiber);
      null === stateHook.next && (stateHook = formFiber.alternate.memoizedState);
      dispatchSetStateInternal(
        formFiber,
        stateHook.next.queue,
        {},
        requestUpdateLane(formFiber)
      );
    }
    function mountTransition() {
      var stateHook = mountStateImpl(false);
      stateHook = startTransition.bind(
        null,
        currentlyRenderingFiber,
        stateHook.queue,
        true,
        false
      );
      mountWorkInProgressHook().memoizedState = stateHook;
      return [false, stateHook];
    }
    function updateTransition() {
      var booleanOrThenable = updateReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    }
    function rerenderTransition() {
      var booleanOrThenable = rerenderReducer(basicStateReducer)[0], start = updateWorkInProgressHook().memoizedState;
      return [
        "boolean" === typeof booleanOrThenable ? booleanOrThenable : useThenable(booleanOrThenable),
        start
      ];
    }
    function useHostTransitionStatus() {
      return readContext(HostTransitionContext);
    }
    function mountId() {
      var hook = mountWorkInProgressHook(), identifierPrefix = workInProgressRoot.identifierPrefix;
      if (isHydrating) {
        var treeId = treeContextOverflow;
        var idWithLeadingBit = treeContextId;
        treeId = (idWithLeadingBit & ~(1 << 32 - clz32(idWithLeadingBit) - 1)).toString(32) + treeId;
        identifierPrefix = "_" + identifierPrefix + "R_" + treeId;
        treeId = localIdCounter++;
        0 < treeId && (identifierPrefix += "H" + treeId.toString(32));
        identifierPrefix += "_";
      } else
        treeId = globalClientIdCounter++, identifierPrefix = "_" + identifierPrefix + "r_" + treeId.toString(32) + "_";
      return hook.memoizedState = identifierPrefix;
    }
    function mountRefresh() {
      return mountWorkInProgressHook().memoizedState = refreshCache.bind(
        null,
        currentlyRenderingFiber
      );
    }
    function refreshCache(fiber, seedKey) {
      for (var provider = fiber.return; null !== provider; ) {
        switch (provider.tag) {
          case 24:
          case 3:
            var lane = requestUpdateLane(provider), refreshUpdate = createUpdate(lane), root3 = enqueueUpdate(provider, refreshUpdate, lane);
            null !== root3 && (startUpdateTimerByLane(lane, "refresh()", fiber), scheduleUpdateOnFiber(root3, provider, lane), entangleTransitions(root3, provider, lane));
            fiber = createCache();
            null !== seedKey && void 0 !== seedKey && null !== root3 && console.error(
              "The seed argument is not enabled outside experimental channels."
            );
            refreshUpdate.payload = { cache: fiber };
            return;
        }
        provider = provider.return;
      }
    }
    function dispatchReducerAction(fiber, queue, action) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      var update = {
        lane: args,
        revertLane: 0,
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      isRenderPhaseUpdate(fiber) ? enqueueRenderPhaseUpdate(queue, update) : (update = enqueueConcurrentHookUpdate(fiber, queue, update, args), null !== update && (startUpdateTimerByLane(args, "dispatch()", fiber), scheduleUpdateOnFiber(update, fiber, args), entangleTransitionUpdate(update, queue, args)));
    }
    function dispatchSetState(fiber, queue, action) {
      var args = arguments;
      "function" === typeof args[3] && console.error(
        "State updates from the useState() and useReducer() Hooks don't support the second callback argument. To execute a side effect after rendering, declare it in the component body with useEffect()."
      );
      args = requestUpdateLane(fiber);
      dispatchSetStateInternal(fiber, queue, action, args) && startUpdateTimerByLane(args, "setState()", fiber);
    }
    function dispatchSetStateInternal(fiber, queue, action, lane) {
      var update = {
        lane,
        revertLane: 0,
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) enqueueRenderPhaseUpdate(queue, update);
      else {
        var alternate = fiber.alternate;
        if (0 === fiber.lanes && (null === alternate || 0 === alternate.lanes) && (alternate = queue.lastRenderedReducer, null !== alternate)) {
          var prevDispatcher = ReactSharedInternals.H;
          ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
          try {
            var currentState = queue.lastRenderedState, eagerState = alternate(currentState, action);
            update.hasEagerState = true;
            update.eagerState = eagerState;
            if (objectIs(eagerState, currentState))
              return enqueueUpdate$1(fiber, queue, update, 0), null === workInProgressRoot && finishQueueingConcurrentUpdates(), false;
          } catch (error) {
          } finally {
            ReactSharedInternals.H = prevDispatcher;
          }
        }
        action = enqueueConcurrentHookUpdate(fiber, queue, update, lane);
        if (null !== action)
          return scheduleUpdateOnFiber(action, fiber, lane), entangleTransitionUpdate(action, queue, lane), true;
      }
      return false;
    }
    function dispatchOptimisticSetState(fiber, throwIfDuringRender, queue, action) {
      null === ReactSharedInternals.T && 0 === currentEntangledLane && console.error(
        "An optimistic state update occurred outside a transition or action. To fix, move the update to an action, or wrap with startTransition."
      );
      action = {
        lane: 2,
        revertLane: requestTransitionLane(),
        gesture: null,
        action,
        hasEagerState: false,
        eagerState: null,
        next: null
      };
      if (isRenderPhaseUpdate(fiber)) {
        if (throwIfDuringRender)
          throw Error("Cannot update optimistic state while rendering.");
        console.error("Cannot call startTransition while rendering.");
      } else
        throwIfDuringRender = enqueueConcurrentHookUpdate(
          fiber,
          queue,
          action,
          2
        ), null !== throwIfDuringRender && (startUpdateTimerByLane(2, "setOptimistic()", fiber), scheduleUpdateOnFiber(throwIfDuringRender, fiber, 2));
    }
    function isRenderPhaseUpdate(fiber) {
      var alternate = fiber.alternate;
      return fiber === currentlyRenderingFiber || null !== alternate && alternate === currentlyRenderingFiber;
    }
    function enqueueRenderPhaseUpdate(queue, update) {
      didScheduleRenderPhaseUpdateDuringThisPass = didScheduleRenderPhaseUpdate = true;
      var pending = queue.pending;
      null === pending ? update.next = update : (update.next = pending.next, pending.next = update);
      queue.pending = update;
    }
    function entangleTransitionUpdate(root3, queue, lane) {
      if (0 !== (lane & 4194048)) {
        var queueLanes = queue.lanes;
        queueLanes &= root3.pendingLanes;
        lane |= queueLanes;
        queue.lanes = lane;
        markRootEntangled(root3, lane);
      }
    }
    function warnOnInvalidCallback(callback) {
      if (null !== callback && "function" !== typeof callback) {
        var key = String(callback);
        didWarnOnInvalidCallback.has(key) || (didWarnOnInvalidCallback.add(key), console.error(
          "Expected the last optional `callback` argument to be a function. Instead received: %s.",
          callback
        ));
      }
    }
    function applyDerivedStateFromProps(workInProgress2, ctor2, getDerivedStateFromProps, nextProps) {
      var prevState = workInProgress2.memoizedState, partialState = getDerivedStateFromProps(nextProps, prevState);
      if (workInProgress2.mode & StrictLegacyMode) {
        setIsStrictModeForDevtools(true);
        try {
          partialState = getDerivedStateFromProps(nextProps, prevState);
        } finally {
          setIsStrictModeForDevtools(false);
        }
      }
      void 0 === partialState && (ctor2 = getComponentNameFromType(ctor2) || "Component", didWarnAboutUndefinedDerivedState.has(ctor2) || (didWarnAboutUndefinedDerivedState.add(ctor2), console.error(
        "%s.getDerivedStateFromProps(): A valid state object (or null) must be returned. You have returned undefined.",
        ctor2
      )));
      prevState = null === partialState || void 0 === partialState ? prevState : assign2({}, prevState, partialState);
      workInProgress2.memoizedState = prevState;
      0 === workInProgress2.lanes && (workInProgress2.updateQueue.baseState = prevState);
    }
    function checkShouldComponentUpdate(workInProgress2, ctor2, oldProps, newProps, oldState, newState, nextContext) {
      var instance = workInProgress2.stateNode;
      if ("function" === typeof instance.shouldComponentUpdate) {
        oldProps = instance.shouldComponentUpdate(
          newProps,
          newState,
          nextContext
        );
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            oldProps = instance.shouldComponentUpdate(
              newProps,
              newState,
              nextContext
            );
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        void 0 === oldProps && console.error(
          "%s.shouldComponentUpdate(): Returned undefined instead of a boolean value. Make sure to return true or false.",
          getComponentNameFromType(ctor2) || "Component"
        );
        return oldProps;
      }
      return ctor2.prototype && ctor2.prototype.isPureReactComponent ? !shallowEqual(oldProps, newProps) || !shallowEqual(oldState, newState) : true;
    }
    function callComponentWillReceiveProps(workInProgress2, instance, newProps, nextContext) {
      var oldState = instance.state;
      "function" === typeof instance.componentWillReceiveProps && instance.componentWillReceiveProps(newProps, nextContext);
      "function" === typeof instance.UNSAFE_componentWillReceiveProps && instance.UNSAFE_componentWillReceiveProps(newProps, nextContext);
      instance.state !== oldState && (workInProgress2 = getComponentNameFromFiber(workInProgress2) || "Component", didWarnAboutStateAssignmentForComponent.has(workInProgress2) || (didWarnAboutStateAssignmentForComponent.add(workInProgress2), console.error(
        "%s.componentWillReceiveProps(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
        workInProgress2
      )), classComponentUpdater.enqueueReplaceState(
        instance,
        instance.state,
        null
      ));
    }
    function resolveClassComponentProps(Component, baseProps) {
      var newProps = baseProps;
      if ("ref" in baseProps) {
        newProps = {};
        for (var propName in baseProps)
          "ref" !== propName && (newProps[propName] = baseProps[propName]);
      }
      if (Component = Component.defaultProps) {
        newProps === baseProps && (newProps = assign2({}, newProps));
        for (var _propName in Component)
          void 0 === newProps[_propName] && (newProps[_propName] = Component[_propName]);
      }
      return newProps;
    }
    function defaultOnUncaughtError(error) {
      reportGlobalError(error);
      console.warn(
        "%s\n\n%s\n",
        componentName ? "An error occurred in the <" + componentName + "> component." : "An error occurred in one of your React components.",
        "Consider adding an error boundary to your tree to customize error handling behavior.\nVisit https://react.dev/link/error-boundaries to learn more about error boundaries."
      );
    }
    function defaultOnCaughtError(error) {
      var componentNameMessage = componentName ? "The above error occurred in the <" + componentName + "> component." : "The above error occurred in one of your React components.", recreateMessage = "React will try to recreate this component tree from scratch using the error boundary you provided, " + ((errorBoundaryName || "Anonymous") + ".");
      if ("object" === typeof error && null !== error && "string" === typeof error.environmentName) {
        var JSCompiler_inline_result = error.environmentName;
        error = [
          "%o\n\n%s\n\n%s\n",
          error,
          componentNameMessage,
          recreateMessage
        ].slice(0);
        "string" === typeof error[0] ? error.splice(
          0,
          1,
          badgeFormat + " " + error[0],
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        ) : error.splice(
          0,
          0,
          badgeFormat,
          badgeStyle,
          pad + JSCompiler_inline_result + pad,
          resetStyle
        );
        error.unshift(console);
        JSCompiler_inline_result = bind.apply(console.error, error);
        JSCompiler_inline_result();
      } else
        console.error(
          "%o\n\n%s\n\n%s\n",
          error,
          componentNameMessage,
          recreateMessage
        );
    }
    function defaultOnRecoverableError(error) {
      reportGlobalError(error);
    }
    function logUncaughtError(root3, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = null;
        var error = errorInfo.value;
        if (null !== ReactSharedInternals.actQueue)
          ReactSharedInternals.thrownErrors.push(error);
        else {
          var onUncaughtError = root3.onUncaughtError;
          onUncaughtError(error, { componentStack: errorInfo.stack });
        }
      } catch (e$5) {
        setTimeout(function() {
          throw e$5;
        });
      }
    }
    function logCaughtError(root3, boundary, errorInfo) {
      try {
        componentName = errorInfo.source ? getComponentNameFromFiber(errorInfo.source) : null;
        errorBoundaryName = getComponentNameFromFiber(boundary);
        var onCaughtError = root3.onCaughtError;
        onCaughtError(errorInfo.value, {
          componentStack: errorInfo.stack,
          errorBoundary: 1 === boundary.tag ? boundary.stateNode : null
        });
      } catch (e$6) {
        setTimeout(function() {
          throw e$6;
        });
      }
    }
    function createRootErrorUpdate(root3, errorInfo, lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      lane.payload = { element: null };
      lane.callback = function() {
        runWithFiberInDEV(errorInfo.source, logUncaughtError, root3, errorInfo);
      };
      return lane;
    }
    function createClassErrorUpdate(lane) {
      lane = createUpdate(lane);
      lane.tag = CaptureUpdate;
      return lane;
    }
    function initializeClassErrorUpdate(update, root3, fiber, errorInfo) {
      var getDerivedStateFromError = fiber.type.getDerivedStateFromError;
      if ("function" === typeof getDerivedStateFromError) {
        var error = errorInfo.value;
        update.payload = function() {
          return getDerivedStateFromError(error);
        };
        update.callback = function() {
          markFailedErrorBoundaryForHotReloading(fiber);
          runWithFiberInDEV(
            errorInfo.source,
            logCaughtError,
            root3,
            fiber,
            errorInfo
          );
        };
      }
      var inst = fiber.stateNode;
      null !== inst && "function" === typeof inst.componentDidCatch && (update.callback = function() {
        markFailedErrorBoundaryForHotReloading(fiber);
        runWithFiberInDEV(
          errorInfo.source,
          logCaughtError,
          root3,
          fiber,
          errorInfo
        );
        "function" !== typeof getDerivedStateFromError && (null === legacyErrorBoundariesThatAlreadyFailed ? legacyErrorBoundariesThatAlreadyFailed = /* @__PURE__ */ new Set([this]) : legacyErrorBoundariesThatAlreadyFailed.add(this));
        callComponentDidCatchInDEV(this, errorInfo);
        "function" === typeof getDerivedStateFromError || 0 === (fiber.lanes & 2) && console.error(
          "%s: Error boundaries should implement getDerivedStateFromError(). In that method, return a state update to display an error message or fallback UI.",
          getComponentNameFromFiber(fiber) || "Unknown"
        );
      });
    }
    function throwException(root3, returnFiber, sourceFiber, value, rootRenderLanes) {
      sourceFiber.flags |= 32768;
      isDevToolsPresent && restorePendingUpdaters(root3, rootRenderLanes);
      if (null !== value && "object" === typeof value && "function" === typeof value.then) {
        returnFiber = sourceFiber.alternate;
        null !== returnFiber && propagateParentContextChanges(
          returnFiber,
          sourceFiber,
          rootRenderLanes,
          true
        );
        isHydrating && (didSuspendOrErrorDEV = true);
        sourceFiber = suspenseHandlerStackCursor.current;
        if (null !== sourceFiber) {
          switch (sourceFiber.tag) {
            case 31:
            case 13:
              return null === shellBoundary ? renderDidSuspendDelayIfPossible() : null === sourceFiber.alternate && workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootSuspended), sourceFiber.flags &= -257, sourceFiber.flags |= 65536, sourceFiber.lanes = rootRenderLanes, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? sourceFiber.updateQueue = /* @__PURE__ */ new Set([value]) : returnFiber.add(value), attachPingListener(root3, value, rootRenderLanes)), false;
            case 22:
              return sourceFiber.flags |= 65536, value === noopSuspenseyCommitThenable ? sourceFiber.flags |= 16384 : (returnFiber = sourceFiber.updateQueue, null === returnFiber ? (returnFiber = {
                transitions: null,
                markerInstances: null,
                retryQueue: /* @__PURE__ */ new Set([value])
              }, sourceFiber.updateQueue = returnFiber) : (sourceFiber = returnFiber.retryQueue, null === sourceFiber ? returnFiber.retryQueue = /* @__PURE__ */ new Set([value]) : sourceFiber.add(value)), attachPingListener(root3, value, rootRenderLanes)), false;
          }
          throw Error(
            "Unexpected Suspense handler tag (" + sourceFiber.tag + "). This is a bug in React."
          );
        }
        attachPingListener(root3, value, rootRenderLanes);
        renderDidSuspendDelayIfPossible();
        return false;
      }
      if (isHydrating)
        return didSuspendOrErrorDEV = true, returnFiber = suspenseHandlerStackCursor.current, null !== returnFiber ? (0 === (returnFiber.flags & 65536) && (returnFiber.flags |= 256), returnFiber.flags |= 65536, returnFiber.lanes = rootRenderLanes, value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering from the nearest Suspense boundary.",
              { cause: value }
            ),
            sourceFiber
          )
        )) : (value !== HydrationMismatchException && queueHydrationError(
          createCapturedValueAtFiber(
            Error(
              "There was an error while hydrating but React was able to recover by instead client rendering the entire root.",
              { cause: value }
            ),
            sourceFiber
          )
        ), root3 = root3.current.alternate, root3.flags |= 65536, rootRenderLanes &= -rootRenderLanes, root3.lanes |= rootRenderLanes, value = createCapturedValueAtFiber(value, sourceFiber), rootRenderLanes = createRootErrorUpdate(
          root3.stateNode,
          value,
          rootRenderLanes
        ), enqueueCapturedUpdate(root3, rootRenderLanes), workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored)), false;
      var error = createCapturedValueAtFiber(
        Error(
          "There was an error during concurrent rendering but React was able to recover by instead synchronously rendering the entire root.",
          { cause: value }
        ),
        sourceFiber
      );
      null === workInProgressRootConcurrentErrors ? workInProgressRootConcurrentErrors = [error] : workInProgressRootConcurrentErrors.push(error);
      workInProgressRootExitStatus !== RootSuspendedWithDelay && (workInProgressRootExitStatus = RootErrored);
      if (null === returnFiber) return true;
      value = createCapturedValueAtFiber(value, sourceFiber);
      sourceFiber = returnFiber;
      do {
        switch (sourceFiber.tag) {
          case 3:
            return sourceFiber.flags |= 65536, root3 = rootRenderLanes & -rootRenderLanes, sourceFiber.lanes |= root3, root3 = createRootErrorUpdate(
              sourceFiber.stateNode,
              value,
              root3
            ), enqueueCapturedUpdate(sourceFiber, root3), false;
          case 1:
            if (returnFiber = sourceFiber.type, error = sourceFiber.stateNode, 0 === (sourceFiber.flags & 128) && ("function" === typeof returnFiber.getDerivedStateFromError || null !== error && "function" === typeof error.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(error))))
              return sourceFiber.flags |= 65536, rootRenderLanes &= -rootRenderLanes, sourceFiber.lanes |= rootRenderLanes, rootRenderLanes = createClassErrorUpdate(rootRenderLanes), initializeClassErrorUpdate(
                rootRenderLanes,
                root3,
                sourceFiber,
                value
              ), enqueueCapturedUpdate(sourceFiber, rootRenderLanes), false;
        }
        sourceFiber = sourceFiber.return;
      } while (null !== sourceFiber);
      return false;
    }
    function reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2) {
      workInProgress2.child = null === current3 ? mountChildFibers(workInProgress2, null, nextChildren, renderLanes2) : reconcileChildFibers(
        workInProgress2,
        current3.child,
        nextChildren,
        renderLanes2
      );
    }
    function updateForwardRef(current3, workInProgress2, Component, nextProps, renderLanes2) {
      Component = Component.render;
      var ref = workInProgress2.ref;
      if ("ref" in nextProps) {
        var propsWithoutRef = {};
        for (var key in nextProps)
          "ref" !== key && (propsWithoutRef[key] = nextProps[key]);
      } else propsWithoutRef = nextProps;
      prepareToReadContext(workInProgress2);
      nextProps = renderWithHooks(
        current3,
        workInProgress2,
        Component,
        propsWithoutRef,
        ref,
        renderLanes2
      );
      key = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && key && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateMemoComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (null === current3) {
        var type = Component.type;
        if ("function" === typeof type && !shouldConstruct(type) && void 0 === type.defaultProps && null === Component.compare)
          return Component = resolveFunctionForHotReloading(type), workInProgress2.tag = 15, workInProgress2.type = Component, validateFunctionComponentInDev(workInProgress2, type), updateSimpleMemoComponent(
            current3,
            workInProgress2,
            Component,
            nextProps,
            renderLanes2
          );
        current3 = createFiberFromTypeAndProps(
          Component.type,
          null,
          nextProps,
          workInProgress2,
          workInProgress2.mode,
          renderLanes2
        );
        current3.ref = workInProgress2.ref;
        current3.return = workInProgress2;
        return workInProgress2.child = current3;
      }
      type = current3.child;
      if (!checkScheduledUpdateOrContext(current3, renderLanes2)) {
        var prevProps = type.memoizedProps;
        Component = Component.compare;
        Component = null !== Component ? Component : shallowEqual;
        if (Component(prevProps, nextProps) && current3.ref === workInProgress2.ref)
          return bailoutOnAlreadyFinishedWork(
            current3,
            workInProgress2,
            renderLanes2
          );
      }
      workInProgress2.flags |= 1;
      current3 = createWorkInProgress(type, nextProps);
      current3.ref = workInProgress2.ref;
      current3.return = workInProgress2;
      return workInProgress2.child = current3;
    }
    function updateSimpleMemoComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (null !== current3) {
        var prevProps = current3.memoizedProps;
        if (shallowEqual(prevProps, nextProps) && current3.ref === workInProgress2.ref && workInProgress2.type === current3.type)
          if (didReceiveUpdate = false, workInProgress2.pendingProps = nextProps = prevProps, checkScheduledUpdateOrContext(current3, renderLanes2))
            0 !== (current3.flags & 131072) && (didReceiveUpdate = true);
          else
            return workInProgress2.lanes = current3.lanes, bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      }
      return updateFunctionComponent(
        current3,
        workInProgress2,
        Component,
        nextProps,
        renderLanes2
      );
    }
    function updateOffscreenComponent(current3, workInProgress2, renderLanes2, nextProps) {
      var nextChildren = nextProps.children, prevState = null !== current3 ? current3.memoizedState : null;
      null === current3 && null === workInProgress2.stateNode && (workInProgress2.stateNode = {
        _visibility: OffscreenVisible,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      });
      if ("hidden" === nextProps.mode) {
        if (0 !== (workInProgress2.flags & 128)) {
          prevState = null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2;
          if (null !== current3) {
            nextProps = workInProgress2.child = current3.child;
            for (nextChildren = 0; null !== nextProps; )
              nextChildren = nextChildren | nextProps.lanes | nextProps.childLanes, nextProps = nextProps.sibling;
            nextProps = nextChildren & ~prevState;
          } else nextProps = 0, workInProgress2.child = null;
          return deferHiddenOffscreenComponent(
            current3,
            workInProgress2,
            prevState,
            renderLanes2,
            nextProps
          );
        }
        if (0 !== (renderLanes2 & 536870912))
          workInProgress2.memoizedState = { baseLanes: 0, cachePool: null }, null !== current3 && pushTransition(
            workInProgress2,
            null !== prevState ? prevState.cachePool : null
          ), null !== prevState ? pushHiddenContext(workInProgress2, prevState) : reuseHiddenContextOnStack(workInProgress2), pushOffscreenSuspenseHandler(workInProgress2);
        else
          return nextProps = workInProgress2.lanes = 536870912, deferHiddenOffscreenComponent(
            current3,
            workInProgress2,
            null !== prevState ? prevState.baseLanes | renderLanes2 : renderLanes2,
            renderLanes2,
            nextProps
          );
      } else
        null !== prevState ? (pushTransition(workInProgress2, prevState.cachePool), pushHiddenContext(workInProgress2, prevState), reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.memoizedState = null) : (null !== current3 && pushTransition(workInProgress2, null), reuseHiddenContextOnStack(workInProgress2), reuseSuspenseHandlerOnStack(workInProgress2));
      reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function bailoutOffscreenComponent(current3, workInProgress2) {
      null !== current3 && 22 === current3.tag || null !== workInProgress2.stateNode || (workInProgress2.stateNode = {
        _visibility: OffscreenVisible,
        _pendingMarkers: null,
        _retryCache: null,
        _transitions: null
      });
      return workInProgress2.sibling;
    }
    function deferHiddenOffscreenComponent(current3, workInProgress2, nextBaseLanes, renderLanes2, remainingChildLanes) {
      var JSCompiler_inline_result = peekCacheFromPool();
      JSCompiler_inline_result = null === JSCompiler_inline_result ? null : {
        parent: CacheContext._currentValue,
        pool: JSCompiler_inline_result
      };
      workInProgress2.memoizedState = {
        baseLanes: nextBaseLanes,
        cachePool: JSCompiler_inline_result
      };
      null !== current3 && pushTransition(workInProgress2, null);
      reuseHiddenContextOnStack(workInProgress2);
      pushOffscreenSuspenseHandler(workInProgress2);
      null !== current3 && propagateParentContextChanges(current3, workInProgress2, renderLanes2, true);
      workInProgress2.childLanes = remainingChildLanes;
      return null;
    }
    function mountActivityChildren(workInProgress2, nextProps) {
      var hiddenProp = nextProps.hidden;
      void 0 !== hiddenProp && console.error(
        `<Activity> doesn't accept a hidden prop. Use mode="hidden" instead.
- <Activity %s>
+ <Activity %s>`,
        true === hiddenProp ? "hidden" : false === hiddenProp ? "hidden={false}" : "hidden={...}",
        hiddenProp ? 'mode="hidden"' : 'mode="visible"'
      );
      nextProps = mountWorkInProgressOffscreenFiber(
        { mode: nextProps.mode, children: nextProps.children },
        workInProgress2.mode
      );
      nextProps.ref = workInProgress2.ref;
      workInProgress2.child = nextProps;
      nextProps.return = workInProgress2;
      return nextProps;
    }
    function retryActivityComponentWithoutHydrating(current3, workInProgress2, renderLanes2) {
      reconcileChildFibers(workInProgress2, current3.child, null, renderLanes2);
      current3 = mountActivityChildren(
        workInProgress2,
        workInProgress2.pendingProps
      );
      current3.flags |= 2;
      popSuspenseHandler(workInProgress2);
      workInProgress2.memoizedState = null;
      return current3;
    }
    function updateActivityComponent(current3, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, didSuspend = 0 !== (workInProgress2.flags & 128);
      workInProgress2.flags &= -129;
      if (null === current3) {
        if (isHydrating) {
          if ("hidden" === nextProps.mode)
            return current3 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.lanes = 536870912, bailoutOffscreenComponent(null, current3);
          pushDehydratedActivitySuspenseHandler(workInProgress2);
          (current3 = nextHydratableInstance) ? (renderLanes2 = canHydrateHydrationBoundary(
            current3,
            rootOrSingletonContext
          ), renderLanes2 = null !== renderLanes2 && renderLanes2.data === ACTIVITY_START_DATA ? renderLanes2 : null, null !== renderLanes2 && (nextProps = {
            dehydrated: renderLanes2,
            treeContext: getSuspendedTreeContext(),
            retryLane: 536870912,
            hydrationErrors: null
          }, workInProgress2.memoizedState = nextProps, nextProps = createFiberFromDehydratedFragment(renderLanes2), nextProps.return = workInProgress2, workInProgress2.child = nextProps, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : renderLanes2 = null;
          if (null === renderLanes2)
            throw warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2);
          workInProgress2.lanes = 536870912;
          return null;
        }
        return mountActivityChildren(workInProgress2, nextProps);
      }
      var prevState = current3.memoizedState;
      if (null !== prevState) {
        var activityInstance = prevState.dehydrated;
        pushDehydratedActivitySuspenseHandler(workInProgress2);
        if (didSuspend)
          if (workInProgress2.flags & 256)
            workInProgress2.flags &= -257, workInProgress2 = retryActivityComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          else if (null !== workInProgress2.memoizedState)
            workInProgress2.child = current3.child, workInProgress2.flags |= 128, workInProgress2 = null;
          else
            throw Error(
              "Client rendering an Activity suspended it again. This is a bug in React."
            );
        else if (warnIfHydrating(), 0 !== (renderLanes2 & 536870912) && markRenderDerivedCause(workInProgress2), didReceiveUpdate || propagateParentContextChanges(
          current3,
          workInProgress2,
          renderLanes2,
          false
        ), didSuspend = 0 !== (renderLanes2 & current3.childLanes), didReceiveUpdate || didSuspend) {
          nextProps = workInProgressRoot;
          if (null !== nextProps && (activityInstance = getBumpedLaneForHydration(
            nextProps,
            renderLanes2
          ), 0 !== activityInstance && activityInstance !== prevState.retryLane))
            throw prevState.retryLane = activityInstance, enqueueConcurrentRenderForLane(current3, activityInstance), scheduleUpdateOnFiber(nextProps, current3, activityInstance), SelectiveHydrationException;
          renderDidSuspendDelayIfPossible();
          workInProgress2 = retryActivityComponentWithoutHydrating(
            current3,
            workInProgress2,
            renderLanes2
          );
        } else
          current3 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
            activityInstance.nextSibling
          ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, rootOrSingletonContext = false, null !== current3 && restoreSuspendedTreeContext(workInProgress2, current3), workInProgress2 = mountActivityChildren(workInProgress2, nextProps), workInProgress2.flags |= 4096;
        return workInProgress2;
      }
      prevState = current3.child;
      nextProps = { mode: nextProps.mode, children: nextProps.children };
      0 !== (renderLanes2 & 536870912) && 0 !== (renderLanes2 & current3.lanes) && markRenderDerivedCause(workInProgress2);
      current3 = createWorkInProgress(prevState, nextProps);
      current3.ref = workInProgress2.ref;
      workInProgress2.child = current3;
      current3.return = workInProgress2;
      return current3;
    }
    function markRef(current3, workInProgress2) {
      var ref = workInProgress2.ref;
      if (null === ref)
        null !== current3 && null !== current3.ref && (workInProgress2.flags |= 4194816);
      else {
        if ("function" !== typeof ref && "object" !== typeof ref)
          throw Error(
            "Expected ref to be a function, an object returned by React.createRef(), or undefined/null."
          );
        if (null === current3 || current3.ref !== ref)
          workInProgress2.flags |= 4194816;
      }
    }
    function updateFunctionComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      if (Component.prototype && "function" === typeof Component.prototype.render) {
        var componentName2 = getComponentNameFromType(Component) || "Unknown";
        didWarnAboutBadClass[componentName2] || (console.error(
          "The <%s /> component appears to have a render method, but doesn't extend React.Component. This is likely to cause errors. Change %s to extend React.Component instead.",
          componentName2,
          componentName2
        ), didWarnAboutBadClass[componentName2] = true);
      }
      workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
        workInProgress2,
        null
      );
      null === current3 && (validateFunctionComponentInDev(workInProgress2, workInProgress2.type), Component.contextTypes && (componentName2 = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypes[componentName2] || (didWarnAboutContextTypes[componentName2] = true, console.error(
        "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with React.useContext() instead. (https://react.dev/link/legacy-context)",
        componentName2
      ))));
      prepareToReadContext(workInProgress2);
      Component = renderWithHooks(
        current3,
        workInProgress2,
        Component,
        nextProps,
        void 0,
        renderLanes2
      );
      nextProps = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && nextProps && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, Component, renderLanes2);
      return workInProgress2.child;
    }
    function replayFunctionComponent(current3, workInProgress2, nextProps, Component, secondArg, renderLanes2) {
      prepareToReadContext(workInProgress2);
      hookTypesUpdateIndexDev = -1;
      ignorePreviousDependencies = null !== current3 && current3.type !== workInProgress2.type;
      workInProgress2.updateQueue = null;
      nextProps = renderWithHooksAgain(
        workInProgress2,
        Component,
        nextProps,
        secondArg
      );
      finishRenderingHooks(current3, workInProgress2);
      Component = checkDidRenderIdHook();
      if (null !== current3 && !didReceiveUpdate)
        return bailoutHooks(current3, workInProgress2, renderLanes2), bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
      isHydrating && Component && pushMaterializedTreeId(workInProgress2);
      workInProgress2.flags |= 1;
      reconcileChildren(current3, workInProgress2, nextProps, renderLanes2);
      return workInProgress2.child;
    }
    function updateClassComponent(current3, workInProgress2, Component, nextProps, renderLanes2) {
      switch (shouldErrorImpl(workInProgress2)) {
        case false:
          var _instance = workInProgress2.stateNode, state = new workInProgress2.type(
            workInProgress2.memoizedProps,
            _instance.context
          ).state;
          _instance.updater.enqueueSetState(_instance, state, null);
          break;
        case true:
          workInProgress2.flags |= 128;
          workInProgress2.flags |= 65536;
          _instance = Error("Simulated error coming from DevTools");
          var lane = renderLanes2 & -renderLanes2;
          workInProgress2.lanes |= lane;
          state = workInProgressRoot;
          if (null === state)
            throw Error(
              "Expected a work-in-progress root. This is a bug in React. Please file an issue."
            );
          lane = createClassErrorUpdate(lane);
          initializeClassErrorUpdate(
            lane,
            state,
            workInProgress2,
            createCapturedValueAtFiber(_instance, workInProgress2)
          );
          enqueueCapturedUpdate(workInProgress2, lane);
      }
      prepareToReadContext(workInProgress2);
      if (null === workInProgress2.stateNode) {
        state = emptyContextObject;
        _instance = Component.contextType;
        "contextType" in Component && null !== _instance && (void 0 === _instance || _instance.$$typeof !== REACT_CONTEXT_TYPE) && !didWarnAboutInvalidateContextType.has(Component) && (didWarnAboutInvalidateContextType.add(Component), lane = void 0 === _instance ? " However, it is set to undefined. This can be caused by a typo or by mixing up named and default imports. This can also happen due to a circular dependency, so try moving the createContext() call to a separate file." : "object" !== typeof _instance ? " However, it is set to a " + typeof _instance + "." : _instance.$$typeof === REACT_CONSUMER_TYPE ? " Did you accidentally pass the Context.Consumer instead?" : " However, it is set to an object with keys {" + Object.keys(_instance).join(", ") + "}.", console.error(
          "%s defines an invalid contextType. contextType should point to the Context object returned by React.createContext().%s",
          getComponentNameFromType(Component) || "Component",
          lane
        ));
        "object" === typeof _instance && null !== _instance && (state = readContext(_instance));
        _instance = new Component(nextProps, state);
        if (workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            _instance = new Component(nextProps, state);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        state = workInProgress2.memoizedState = null !== _instance.state && void 0 !== _instance.state ? _instance.state : null;
        _instance.updater = classComponentUpdater;
        workInProgress2.stateNode = _instance;
        _instance._reactInternals = workInProgress2;
        _instance._reactInternalInstance = fakeInternalInstance;
        "function" === typeof Component.getDerivedStateFromProps && null === state && (state = getComponentNameFromType(Component) || "Component", didWarnAboutUninitializedState.has(state) || (didWarnAboutUninitializedState.add(state), console.error(
          "`%s` uses `getDerivedStateFromProps` but its initial state is %s. This is not recommended. Instead, define the initial state by assigning an object to `this.state` in the constructor of `%s`. This ensures that `getDerivedStateFromProps` arguments have a consistent shape.",
          state,
          null === _instance.state ? "null" : "undefined",
          state
        )));
        if ("function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate) {
          var foundWillUpdateName = lane = state = null;
          "function" === typeof _instance.componentWillMount && true !== _instance.componentWillMount.__suppressDeprecationWarning ? state = "componentWillMount" : "function" === typeof _instance.UNSAFE_componentWillMount && (state = "UNSAFE_componentWillMount");
          "function" === typeof _instance.componentWillReceiveProps && true !== _instance.componentWillReceiveProps.__suppressDeprecationWarning ? lane = "componentWillReceiveProps" : "function" === typeof _instance.UNSAFE_componentWillReceiveProps && (lane = "UNSAFE_componentWillReceiveProps");
          "function" === typeof _instance.componentWillUpdate && true !== _instance.componentWillUpdate.__suppressDeprecationWarning ? foundWillUpdateName = "componentWillUpdate" : "function" === typeof _instance.UNSAFE_componentWillUpdate && (foundWillUpdateName = "UNSAFE_componentWillUpdate");
          if (null !== state || null !== lane || null !== foundWillUpdateName) {
            _instance = getComponentNameFromType(Component) || "Component";
            var newApiName = "function" === typeof Component.getDerivedStateFromProps ? "getDerivedStateFromProps()" : "getSnapshotBeforeUpdate()";
            didWarnAboutLegacyLifecyclesAndDerivedState.has(_instance) || (didWarnAboutLegacyLifecyclesAndDerivedState.add(_instance), console.error(
              "Unsafe legacy lifecycles will not be called for components using new component APIs.\n\n%s uses %s but also contains the following legacy lifecycles:%s%s%s\n\nThe above lifecycles should be removed. Learn more about this warning here:\nhttps://react.dev/link/unsafe-component-lifecycles",
              _instance,
              newApiName,
              null !== state ? "\n  " + state : "",
              null !== lane ? "\n  " + lane : "",
              null !== foundWillUpdateName ? "\n  " + foundWillUpdateName : ""
            ));
          }
        }
        _instance = workInProgress2.stateNode;
        state = getComponentNameFromType(Component) || "Component";
        _instance.render || (Component.prototype && "function" === typeof Component.prototype.render ? console.error(
          "No `render` method found on the %s instance: did you accidentally return an object from the constructor?",
          state
        ) : console.error(
          "No `render` method found on the %s instance: you may have forgotten to define `render`.",
          state
        ));
        !_instance.getInitialState || _instance.getInitialState.isReactClassApproved || _instance.state || console.error(
          "getInitialState was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Did you mean to define a state property instead?",
          state
        );
        _instance.getDefaultProps && !_instance.getDefaultProps.isReactClassApproved && console.error(
          "getDefaultProps was defined on %s, a plain JavaScript class. This is only supported for classes created using React.createClass. Use a static property to define defaultProps instead.",
          state
        );
        _instance.contextType && console.error(
          "contextType was defined as an instance property on %s. Use a static property to define contextType instead.",
          state
        );
        Component.childContextTypes && !didWarnAboutChildContextTypes.has(Component) && (didWarnAboutChildContextTypes.add(Component), console.error(
          "%s uses the legacy childContextTypes API which was removed in React 19. Use React.createContext() instead. (https://react.dev/link/legacy-context)",
          state
        ));
        Component.contextTypes && !didWarnAboutContextTypes$1.has(Component) && (didWarnAboutContextTypes$1.add(Component), console.error(
          "%s uses the legacy contextTypes API which was removed in React 19. Use React.createContext() with static contextType instead. (https://react.dev/link/legacy-context)",
          state
        ));
        "function" === typeof _instance.componentShouldUpdate && console.error(
          "%s has a method called componentShouldUpdate(). Did you mean shouldComponentUpdate()? The name is phrased as a question because the function is expected to return a value.",
          state
        );
        Component.prototype && Component.prototype.isPureReactComponent && "undefined" !== typeof _instance.shouldComponentUpdate && console.error(
          "%s has a method called shouldComponentUpdate(). shouldComponentUpdate should not be used when extending React.PureComponent. Please extend React.Component if shouldComponentUpdate is used.",
          getComponentNameFromType(Component) || "A pure component"
        );
        "function" === typeof _instance.componentDidUnmount && console.error(
          "%s has a method called componentDidUnmount(). But there is no such lifecycle method. Did you mean componentWillUnmount()?",
          state
        );
        "function" === typeof _instance.componentDidReceiveProps && console.error(
          "%s has a method called componentDidReceiveProps(). But there is no such lifecycle method. If you meant to update the state in response to changing props, use componentWillReceiveProps(). If you meant to fetch data or run side-effects or mutations after React has updated the UI, use componentDidUpdate().",
          state
        );
        "function" === typeof _instance.componentWillRecieveProps && console.error(
          "%s has a method called componentWillRecieveProps(). Did you mean componentWillReceiveProps()?",
          state
        );
        "function" === typeof _instance.UNSAFE_componentWillRecieveProps && console.error(
          "%s has a method called UNSAFE_componentWillRecieveProps(). Did you mean UNSAFE_componentWillReceiveProps()?",
          state
        );
        lane = _instance.props !== nextProps;
        void 0 !== _instance.props && lane && console.error(
          "When calling super() in `%s`, make sure to pass up the same props that your component's constructor was passed.",
          state
        );
        _instance.defaultProps && console.error(
          "Setting defaultProps as an instance property on %s is not supported and will be ignored. Instead, define defaultProps as a static property on %s.",
          state,
          state
        );
        "function" !== typeof _instance.getSnapshotBeforeUpdate || "function" === typeof _instance.componentDidUpdate || didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.has(Component) || (didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate.add(Component), console.error(
          "%s: getSnapshotBeforeUpdate() should be used with componentDidUpdate(). This component defines getSnapshotBeforeUpdate() only.",
          getComponentNameFromType(Component)
        ));
        "function" === typeof _instance.getDerivedStateFromProps && console.error(
          "%s: getDerivedStateFromProps() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof _instance.getDerivedStateFromError && console.error(
          "%s: getDerivedStateFromError() is defined as an instance method and will be ignored. Instead, declare it as a static method.",
          state
        );
        "function" === typeof Component.getSnapshotBeforeUpdate && console.error(
          "%s: getSnapshotBeforeUpdate() is defined as a static method and will be ignored. Instead, declare it as an instance method.",
          state
        );
        (lane = _instance.state) && ("object" !== typeof lane || isArrayImpl(lane)) && console.error("%s.state: must be set to an object or null", state);
        "function" === typeof _instance.getChildContext && "object" !== typeof Component.childContextTypes && console.error(
          "%s.getChildContext(): childContextTypes must be defined in order to use getChildContext().",
          state
        );
        _instance = workInProgress2.stateNode;
        _instance.props = nextProps;
        _instance.state = workInProgress2.memoizedState;
        _instance.refs = {};
        initializeUpdateQueue(workInProgress2);
        state = Component.contextType;
        _instance.context = "object" === typeof state && null !== state ? readContext(state) : emptyContextObject;
        _instance.state === nextProps && (state = getComponentNameFromType(Component) || "Component", didWarnAboutDirectlyAssigningPropsToState.has(state) || (didWarnAboutDirectlyAssigningPropsToState.add(state), console.error(
          "%s: It is not recommended to assign props directly to state because updates to props won't be reflected in state. In most cases, it is better to use props directly.",
          state
        )));
        workInProgress2.mode & StrictLegacyMode && ReactStrictModeWarnings.recordLegacyContextWarning(
          workInProgress2,
          _instance
        );
        ReactStrictModeWarnings.recordUnsafeLifecycleWarnings(
          workInProgress2,
          _instance
        );
        _instance.state = workInProgress2.memoizedState;
        state = Component.getDerivedStateFromProps;
        "function" === typeof state && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          state,
          nextProps
        ), _instance.state = workInProgress2.memoizedState);
        "function" === typeof Component.getDerivedStateFromProps || "function" === typeof _instance.getSnapshotBeforeUpdate || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || (state = _instance.state, "function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount(), state !== _instance.state && (console.error(
          "%s.componentWillMount(): Assigning directly to this.state is deprecated (except inside a component's constructor). Use setState instead.",
          getComponentNameFromFiber(workInProgress2) || "Component"
        ), classComponentUpdater.enqueueReplaceState(
          _instance,
          _instance.state,
          null
        )), processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction(), _instance.state = workInProgress2.memoizedState);
        "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308);
        (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728);
        _instance = true;
      } else if (null === current3) {
        _instance = workInProgress2.stateNode;
        var unresolvedOldProps = workInProgress2.memoizedProps;
        lane = resolveClassComponentProps(Component, unresolvedOldProps);
        _instance.props = lane;
        var oldContext = _instance.context;
        foundWillUpdateName = Component.contextType;
        state = emptyContextObject;
        "object" === typeof foundWillUpdateName && null !== foundWillUpdateName && (state = readContext(foundWillUpdateName));
        newApiName = Component.getDerivedStateFromProps;
        foundWillUpdateName = "function" === typeof newApiName || "function" === typeof _instance.getSnapshotBeforeUpdate;
        unresolvedOldProps = workInProgress2.pendingProps !== unresolvedOldProps;
        foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (unresolvedOldProps || oldContext !== state) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          state
        );
        hasForceUpdate = false;
        var oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        oldContext = workInProgress2.memoizedState;
        unresolvedOldProps || oldState !== oldContext || hasForceUpdate ? ("function" === typeof newApiName && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          newApiName,
          nextProps
        ), oldContext = workInProgress2.memoizedState), (lane = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component,
          lane,
          nextProps,
          oldState,
          oldContext,
          state
        )) ? (foundWillUpdateName || "function" !== typeof _instance.UNSAFE_componentWillMount && "function" !== typeof _instance.componentWillMount || ("function" === typeof _instance.componentWillMount && _instance.componentWillMount(), "function" === typeof _instance.UNSAFE_componentWillMount && _instance.UNSAFE_componentWillMount()), "function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728)) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = oldContext), _instance.props = nextProps, _instance.state = oldContext, _instance.context = state, _instance = lane) : ("function" === typeof _instance.componentDidMount && (workInProgress2.flags |= 4194308), (workInProgress2.mode & StrictEffectsMode) !== NoMode && (workInProgress2.flags |= 134217728), _instance = false);
      } else {
        _instance = workInProgress2.stateNode;
        cloneUpdateQueue(current3, workInProgress2);
        state = workInProgress2.memoizedProps;
        foundWillUpdateName = resolveClassComponentProps(Component, state);
        _instance.props = foundWillUpdateName;
        newApiName = workInProgress2.pendingProps;
        oldState = _instance.context;
        oldContext = Component.contextType;
        lane = emptyContextObject;
        "object" === typeof oldContext && null !== oldContext && (lane = readContext(oldContext));
        unresolvedOldProps = Component.getDerivedStateFromProps;
        (oldContext = "function" === typeof unresolvedOldProps || "function" === typeof _instance.getSnapshotBeforeUpdate) || "function" !== typeof _instance.UNSAFE_componentWillReceiveProps && "function" !== typeof _instance.componentWillReceiveProps || (state !== newApiName || oldState !== lane) && callComponentWillReceiveProps(
          workInProgress2,
          _instance,
          nextProps,
          lane
        );
        hasForceUpdate = false;
        oldState = workInProgress2.memoizedState;
        _instance.state = oldState;
        processUpdateQueue(workInProgress2, nextProps, _instance, renderLanes2);
        suspendIfUpdateReadFromEntangledAsyncAction();
        var newState = workInProgress2.memoizedState;
        state !== newApiName || oldState !== newState || hasForceUpdate || null !== current3 && null !== current3.dependencies && checkIfContextChanged(current3.dependencies) ? ("function" === typeof unresolvedOldProps && (applyDerivedStateFromProps(
          workInProgress2,
          Component,
          unresolvedOldProps,
          nextProps
        ), newState = workInProgress2.memoizedState), (foundWillUpdateName = hasForceUpdate || checkShouldComponentUpdate(
          workInProgress2,
          Component,
          foundWillUpdateName,
          nextProps,
          oldState,
          newState,
          lane
        ) || null !== current3 && null !== current3.dependencies && checkIfContextChanged(current3.dependencies)) ? (oldContext || "function" !== typeof _instance.UNSAFE_componentWillUpdate && "function" !== typeof _instance.componentWillUpdate || ("function" === typeof _instance.componentWillUpdate && _instance.componentWillUpdate(nextProps, newState, lane), "function" === typeof _instance.UNSAFE_componentWillUpdate && _instance.UNSAFE_componentWillUpdate(
          nextProps,
          newState,
          lane
        )), "function" === typeof _instance.componentDidUpdate && (workInProgress2.flags |= 4), "function" === typeof _instance.getSnapshotBeforeUpdate && (workInProgress2.flags |= 1024)) : ("function" !== typeof _instance.componentDidUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 1024), workInProgress2.memoizedProps = nextProps, workInProgress2.memoizedState = newState), _instance.props = nextProps, _instance.state = newState, _instance.context = lane, _instance = foundWillUpdateName) : ("function" !== typeof _instance.componentDidUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 4), "function" !== typeof _instance.getSnapshotBeforeUpdate || state === current3.memoizedProps && oldState === current3.memoizedState || (workInProgress2.flags |= 1024), _instance = false);
      }
      lane = _instance;
      markRef(current3, workInProgress2);
      state = 0 !== (workInProgress2.flags & 128);
      if (lane || state) {
        lane = workInProgress2.stateNode;
        setCurrentFiber(workInProgress2);
        if (state && "function" !== typeof Component.getDerivedStateFromError)
          Component = null, profilerStartTime = -1;
        else if (Component = callRenderInDEV(lane), workInProgress2.mode & StrictLegacyMode) {
          setIsStrictModeForDevtools(true);
          try {
            callRenderInDEV(lane);
          } finally {
            setIsStrictModeForDevtools(false);
          }
        }
        workInProgress2.flags |= 1;
        null !== current3 && state ? (workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          current3.child,
          null,
          renderLanes2
        ), workInProgress2.child = reconcileChildFibers(
          workInProgress2,
          null,
          Component,
          renderLanes2
        )) : reconcileChildren(current3, workInProgress2, Component, renderLanes2);
        workInProgress2.memoizedState = lane.state;
        current3 = workInProgress2.child;
      } else
        current3 = bailoutOnAlreadyFinishedWork(
          current3,
          workInProgress2,
          renderLanes2
        );
      renderLanes2 = workInProgress2.stateNode;
      _instance && renderLanes2.props !== nextProps && (didWarnAboutReassigningProps || console.error(
        "It looks like %s is reassigning its own `this.props` while rendering. This is not supported and can lead to confusing bugs.",
        getComponentNameFromFiber(workInProgress2) || "a component"
      ), didWarnAboutReassigningProps = true);
      return current3;
    }
    function mountHostRootWithoutHydrating(current3, workInProgress2, nextChildren, renderLanes2) {
      resetHydrationState();
      workInProgress2.flags |= 256;
      reconcileChildren(current3, workInProgress2, nextChildren, renderLanes2);
      return workInProgress2.child;
    }
    function validateFunctionComponentInDev(workInProgress2, Component) {
      Component && Component.childContextTypes && console.error(
        "childContextTypes cannot be defined on a function component.\n  %s.childContextTypes = ...",
        Component.displayName || Component.name || "Component"
      );
      "function" === typeof Component.getDerivedStateFromProps && (workInProgress2 = getComponentNameFromType(Component) || "Unknown", didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] || (console.error(
        "%s: Function components do not support getDerivedStateFromProps.",
        workInProgress2
      ), didWarnAboutGetDerivedStateOnFunctionComponent[workInProgress2] = true));
      "object" === typeof Component.contextType && null !== Component.contextType && (Component = getComponentNameFromType(Component) || "Unknown", didWarnAboutContextTypeOnFunctionComponent[Component] || (console.error(
        "%s: Function components do not support contextType.",
        Component
      ), didWarnAboutContextTypeOnFunctionComponent[Component] = true));
    }
    function mountSuspenseOffscreenState(renderLanes2) {
      return { baseLanes: renderLanes2, cachePool: getSuspendedCache() };
    }
    function getRemainingWorkInPrimaryTree(current3, primaryTreeDidDefer, renderLanes2) {
      current3 = null !== current3 ? current3.childLanes & ~renderLanes2 : 0;
      primaryTreeDidDefer && (current3 |= workInProgressDeferredLane);
      return current3;
    }
    function updateSuspenseComponent(current3, workInProgress2, renderLanes2) {
      var JSCompiler_object_inline_digest_2724;
      var JSCompiler_object_inline_stack_2725 = workInProgress2.pendingProps;
      shouldSuspendImpl(workInProgress2) && (workInProgress2.flags |= 128);
      var JSCompiler_object_inline_message_2723 = false;
      var didSuspend = 0 !== (workInProgress2.flags & 128);
      (JSCompiler_object_inline_digest_2724 = didSuspend) || (JSCompiler_object_inline_digest_2724 = null !== current3 && null === current3.memoizedState ? false : 0 !== (suspenseStackCursor.current & ForceSuspenseFallback));
      JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_message_2723 = true, workInProgress2.flags &= -129);
      JSCompiler_object_inline_digest_2724 = 0 !== (workInProgress2.flags & 32);
      workInProgress2.flags &= -33;
      if (null === current3) {
        if (isHydrating) {
          JSCompiler_object_inline_message_2723 ? pushPrimaryTreeSuspenseHandler(workInProgress2) : reuseSuspenseHandlerOnStack(workInProgress2);
          (current3 = nextHydratableInstance) ? (renderLanes2 = canHydrateHydrationBoundary(
            current3,
            rootOrSingletonContext
          ), renderLanes2 = null !== renderLanes2 && renderLanes2.data !== ACTIVITY_START_DATA ? renderLanes2 : null, null !== renderLanes2 && (JSCompiler_object_inline_digest_2724 = {
            dehydrated: renderLanes2,
            treeContext: getSuspendedTreeContext(),
            retryLane: 536870912,
            hydrationErrors: null
          }, workInProgress2.memoizedState = JSCompiler_object_inline_digest_2724, JSCompiler_object_inline_digest_2724 = createFiberFromDehydratedFragment(renderLanes2), JSCompiler_object_inline_digest_2724.return = workInProgress2, workInProgress2.child = JSCompiler_object_inline_digest_2724, hydrationParentFiber = workInProgress2, nextHydratableInstance = null)) : renderLanes2 = null;
          if (null === renderLanes2)
            throw warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2);
          isSuspenseInstanceFallback(renderLanes2) ? workInProgress2.lanes = 32 : workInProgress2.lanes = 536870912;
          return null;
        }
        var nextPrimaryChildren = JSCompiler_object_inline_stack_2725.children;
        JSCompiler_object_inline_stack_2725 = JSCompiler_object_inline_stack_2725.fallback;
        if (JSCompiler_object_inline_message_2723) {
          reuseSuspenseHandlerOnStack(workInProgress2);
          var mode = workInProgress2.mode;
          nextPrimaryChildren = mountWorkInProgressOffscreenFiber(
            { mode: "hidden", children: nextPrimaryChildren },
            mode
          );
          JSCompiler_object_inline_stack_2725 = createFiberFromFragment(
            JSCompiler_object_inline_stack_2725,
            mode,
            renderLanes2,
            null
          );
          nextPrimaryChildren.return = workInProgress2;
          JSCompiler_object_inline_stack_2725.return = workInProgress2;
          nextPrimaryChildren.sibling = JSCompiler_object_inline_stack_2725;
          workInProgress2.child = nextPrimaryChildren;
          JSCompiler_object_inline_stack_2725 = workInProgress2.child;
          JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes2);
          JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
            current3,
            JSCompiler_object_inline_digest_2724,
            renderLanes2
          );
          workInProgress2.memoizedState = SUSPENDED_MARKER;
          return bailoutOffscreenComponent(
            null,
            JSCompiler_object_inline_stack_2725
          );
        }
        pushPrimaryTreeSuspenseHandler(workInProgress2);
        return mountSuspensePrimaryChildren(
          workInProgress2,
          nextPrimaryChildren
        );
      }
      var prevState = current3.memoizedState;
      if (null !== prevState) {
        var JSCompiler_object_inline_componentStack_2726 = prevState.dehydrated;
        if (null !== JSCompiler_object_inline_componentStack_2726) {
          if (didSuspend)
            workInProgress2.flags & 256 ? (pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags &= -257, workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            )) : null !== workInProgress2.memoizedState ? (reuseSuspenseHandlerOnStack(workInProgress2), workInProgress2.child = current3.child, workInProgress2.flags |= 128, workInProgress2 = null) : (reuseSuspenseHandlerOnStack(workInProgress2), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress2.mode, JSCompiler_object_inline_stack_2725 = mountWorkInProgressOffscreenFiber(
              {
                mode: "visible",
                children: JSCompiler_object_inline_stack_2725.children
              },
              mode
            ), nextPrimaryChildren = createFiberFromFragment(
              nextPrimaryChildren,
              mode,
              renderLanes2,
              null
            ), nextPrimaryChildren.flags |= 2, JSCompiler_object_inline_stack_2725.return = workInProgress2, nextPrimaryChildren.return = workInProgress2, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress2.child = JSCompiler_object_inline_stack_2725, reconcileChildFibers(
              workInProgress2,
              current3.child,
              null,
              renderLanes2
            ), JSCompiler_object_inline_stack_2725 = workInProgress2.child, JSCompiler_object_inline_stack_2725.memoizedState = mountSuspenseOffscreenState(renderLanes2), JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
              current3,
              JSCompiler_object_inline_digest_2724,
              renderLanes2
            ), workInProgress2.memoizedState = SUSPENDED_MARKER, workInProgress2 = bailoutOffscreenComponent(
              null,
              JSCompiler_object_inline_stack_2725
            ));
          else if (pushPrimaryTreeSuspenseHandler(workInProgress2), warnIfHydrating(), 0 !== (renderLanes2 & 536870912) && markRenderDerivedCause(workInProgress2), isSuspenseInstanceFallback(
            JSCompiler_object_inline_componentStack_2726
          )) {
            JSCompiler_object_inline_digest_2724 = JSCompiler_object_inline_componentStack_2726.nextSibling && JSCompiler_object_inline_componentStack_2726.nextSibling.dataset;
            if (JSCompiler_object_inline_digest_2724) {
              nextPrimaryChildren = JSCompiler_object_inline_digest_2724.dgst;
              var message = JSCompiler_object_inline_digest_2724.msg;
              mode = JSCompiler_object_inline_digest_2724.stck;
              var componentStack = JSCompiler_object_inline_digest_2724.cstck;
            }
            JSCompiler_object_inline_message_2723 = message;
            JSCompiler_object_inline_digest_2724 = nextPrimaryChildren;
            JSCompiler_object_inline_stack_2725 = mode;
            JSCompiler_object_inline_componentStack_2726 = componentStack;
            nextPrimaryChildren = JSCompiler_object_inline_message_2723;
            mode = JSCompiler_object_inline_componentStack_2726;
            nextPrimaryChildren = nextPrimaryChildren ? Error(nextPrimaryChildren) : Error(
              "The server could not finish this Suspense boundary, likely due to an error during server rendering. Switched to client rendering."
            );
            nextPrimaryChildren.stack = JSCompiler_object_inline_stack_2725 || "";
            nextPrimaryChildren.digest = JSCompiler_object_inline_digest_2724;
            JSCompiler_object_inline_digest_2724 = void 0 === mode ? null : mode;
            JSCompiler_object_inline_stack_2725 = {
              value: nextPrimaryChildren,
              source: null,
              stack: JSCompiler_object_inline_digest_2724
            };
            "string" === typeof JSCompiler_object_inline_digest_2724 && CapturedStacks.set(
              nextPrimaryChildren,
              JSCompiler_object_inline_stack_2725
            );
            queueHydrationError(JSCompiler_object_inline_stack_2725);
            workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          } else if (didReceiveUpdate || propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), JSCompiler_object_inline_digest_2724 = 0 !== (renderLanes2 & current3.childLanes), didReceiveUpdate || JSCompiler_object_inline_digest_2724) {
            JSCompiler_object_inline_digest_2724 = workInProgressRoot;
            if (null !== JSCompiler_object_inline_digest_2724 && (JSCompiler_object_inline_stack_2725 = getBumpedLaneForHydration(
              JSCompiler_object_inline_digest_2724,
              renderLanes2
            ), 0 !== JSCompiler_object_inline_stack_2725 && JSCompiler_object_inline_stack_2725 !== prevState.retryLane))
              throw prevState.retryLane = JSCompiler_object_inline_stack_2725, enqueueConcurrentRenderForLane(
                current3,
                JSCompiler_object_inline_stack_2725
              ), scheduleUpdateOnFiber(
                JSCompiler_object_inline_digest_2724,
                current3,
                JSCompiler_object_inline_stack_2725
              ), SelectiveHydrationException;
            isSuspenseInstancePending(
              JSCompiler_object_inline_componentStack_2726
            ) || renderDidSuspendDelayIfPossible();
            workInProgress2 = retrySuspenseComponentWithoutHydrating(
              current3,
              workInProgress2,
              renderLanes2
            );
          } else
            isSuspenseInstancePending(
              JSCompiler_object_inline_componentStack_2726
            ) ? (workInProgress2.flags |= 192, workInProgress2.child = current3.child, workInProgress2 = null) : (current3 = prevState.treeContext, nextHydratableInstance = getNextHydratable(
              JSCompiler_object_inline_componentStack_2726.nextSibling
            ), hydrationParentFiber = workInProgress2, isHydrating = true, hydrationErrors = null, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, rootOrSingletonContext = false, null !== current3 && restoreSuspendedTreeContext(workInProgress2, current3), workInProgress2 = mountSuspensePrimaryChildren(
              workInProgress2,
              JSCompiler_object_inline_stack_2725.children
            ), workInProgress2.flags |= 4096);
          return workInProgress2;
        }
      }
      if (JSCompiler_object_inline_message_2723)
        return reuseSuspenseHandlerOnStack(workInProgress2), nextPrimaryChildren = JSCompiler_object_inline_stack_2725.fallback, mode = workInProgress2.mode, componentStack = current3.child, JSCompiler_object_inline_componentStack_2726 = componentStack.sibling, JSCompiler_object_inline_stack_2725 = createWorkInProgress(
          componentStack,
          {
            mode: "hidden",
            children: JSCompiler_object_inline_stack_2725.children
          }
        ), JSCompiler_object_inline_stack_2725.subtreeFlags = componentStack.subtreeFlags & 65011712, null !== JSCompiler_object_inline_componentStack_2726 ? nextPrimaryChildren = createWorkInProgress(
          JSCompiler_object_inline_componentStack_2726,
          nextPrimaryChildren
        ) : (nextPrimaryChildren = createFiberFromFragment(
          nextPrimaryChildren,
          mode,
          renderLanes2,
          null
        ), nextPrimaryChildren.flags |= 2), nextPrimaryChildren.return = workInProgress2, JSCompiler_object_inline_stack_2725.return = workInProgress2, JSCompiler_object_inline_stack_2725.sibling = nextPrimaryChildren, workInProgress2.child = JSCompiler_object_inline_stack_2725, bailoutOffscreenComponent(null, JSCompiler_object_inline_stack_2725), JSCompiler_object_inline_stack_2725 = workInProgress2.child, nextPrimaryChildren = current3.child.memoizedState, null === nextPrimaryChildren ? nextPrimaryChildren = mountSuspenseOffscreenState(renderLanes2) : (mode = nextPrimaryChildren.cachePool, null !== mode ? (componentStack = CacheContext._currentValue, mode = mode.parent !== componentStack ? { parent: componentStack, pool: componentStack } : mode) : mode = getSuspendedCache(), nextPrimaryChildren = {
          baseLanes: nextPrimaryChildren.baseLanes | renderLanes2,
          cachePool: mode
        }), JSCompiler_object_inline_stack_2725.memoizedState = nextPrimaryChildren, JSCompiler_object_inline_stack_2725.childLanes = getRemainingWorkInPrimaryTree(
          current3,
          JSCompiler_object_inline_digest_2724,
          renderLanes2
        ), workInProgress2.memoizedState = SUSPENDED_MARKER, bailoutOffscreenComponent(
          current3.child,
          JSCompiler_object_inline_stack_2725
        );
      null !== prevState && (renderLanes2 & 62914560) === renderLanes2 && 0 !== (renderLanes2 & current3.lanes) && markRenderDerivedCause(workInProgress2);
      pushPrimaryTreeSuspenseHandler(workInProgress2);
      renderLanes2 = current3.child;
      current3 = renderLanes2.sibling;
      renderLanes2 = createWorkInProgress(renderLanes2, {
        mode: "visible",
        children: JSCompiler_object_inline_stack_2725.children
      });
      renderLanes2.return = workInProgress2;
      renderLanes2.sibling = null;
      null !== current3 && (JSCompiler_object_inline_digest_2724 = workInProgress2.deletions, null === JSCompiler_object_inline_digest_2724 ? (workInProgress2.deletions = [current3], workInProgress2.flags |= 16) : JSCompiler_object_inline_digest_2724.push(current3));
      workInProgress2.child = renderLanes2;
      workInProgress2.memoizedState = null;
      return renderLanes2;
    }
    function mountSuspensePrimaryChildren(workInProgress2, primaryChildren) {
      primaryChildren = mountWorkInProgressOffscreenFiber(
        { mode: "visible", children: primaryChildren },
        workInProgress2.mode
      );
      primaryChildren.return = workInProgress2;
      return workInProgress2.child = primaryChildren;
    }
    function mountWorkInProgressOffscreenFiber(offscreenProps, mode) {
      offscreenProps = createFiber(22, offscreenProps, null, mode);
      offscreenProps.lanes = 0;
      return offscreenProps;
    }
    function retrySuspenseComponentWithoutHydrating(current3, workInProgress2, renderLanes2) {
      reconcileChildFibers(workInProgress2, current3.child, null, renderLanes2);
      current3 = mountSuspensePrimaryChildren(
        workInProgress2,
        workInProgress2.pendingProps.children
      );
      current3.flags |= 2;
      workInProgress2.memoizedState = null;
      return current3;
    }
    function scheduleSuspenseWorkOnFiber(fiber, renderLanes2, propagationRoot) {
      fiber.lanes |= renderLanes2;
      var alternate = fiber.alternate;
      null !== alternate && (alternate.lanes |= renderLanes2);
      scheduleContextWorkOnParentPath(
        fiber.return,
        renderLanes2,
        propagationRoot
      );
    }
    function initSuspenseListRenderState(workInProgress2, isBackwards, tail, lastContentRow, tailMode, treeForkCount2) {
      var renderState = workInProgress2.memoizedState;
      null === renderState ? workInProgress2.memoizedState = {
        isBackwards,
        rendering: null,
        renderingStartTime: 0,
        last: lastContentRow,
        tail,
        tailMode,
        treeForkCount: treeForkCount2
      } : (renderState.isBackwards = isBackwards, renderState.rendering = null, renderState.renderingStartTime = 0, renderState.last = lastContentRow, renderState.tail = tail, renderState.tailMode = tailMode, renderState.treeForkCount = treeForkCount2);
    }
    function updateSuspenseListComponent(current3, workInProgress2, renderLanes2) {
      var nextProps = workInProgress2.pendingProps, revealOrder = nextProps.revealOrder, tailMode = nextProps.tail, newChildren = nextProps.children, suspenseContext = suspenseStackCursor.current;
      (nextProps = 0 !== (suspenseContext & ForceSuspenseFallback)) ? (suspenseContext = suspenseContext & SubtreeSuspenseContextMask | ForceSuspenseFallback, workInProgress2.flags |= 128) : suspenseContext &= SubtreeSuspenseContextMask;
      push2(suspenseStackCursor, suspenseContext, workInProgress2);
      suspenseContext = null == revealOrder ? "null" : revealOrder;
      if ("forwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && "together" !== revealOrder && "independent" !== revealOrder && !didWarnAboutRevealOrder[suspenseContext])
        if (didWarnAboutRevealOrder[suspenseContext] = true, null == revealOrder)
          console.error(
            'The default for the <SuspenseList revealOrder="..."> prop is changing. To be future compatible you must explictly specify either "independent" (the current default), "together", "forwards" or "legacy_unstable-backwards".'
          );
        else if ("backwards" === revealOrder)
          console.error(
            'The rendering order of <SuspenseList revealOrder="backwards"> is changing. To be future compatible you must specify revealOrder="legacy_unstable-backwards" instead.'
          );
        else if ("string" === typeof revealOrder)
          switch (revealOrder.toLowerCase()) {
            case "together":
            case "forwards":
            case "backwards":
            case "independent":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. Use lowercase "%s" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            case "forward":
            case "backward":
              console.error(
                '"%s" is not a valid value for revealOrder on <SuspenseList />. React uses the -s suffix in the spelling. Use "%ss" instead.',
                revealOrder,
                revealOrder.toLowerCase()
              );
              break;
            default:
              console.error(
                '"%s" is not a supported revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
                revealOrder
              );
          }
        else
          console.error(
            '%s is not a supported value for revealOrder on <SuspenseList />. Did you mean "independent", "together", "forwards" or "backwards"?',
            revealOrder
          );
      suspenseContext = null == tailMode ? "null" : tailMode;
      if (!didWarnAboutTailOptions[suspenseContext])
        if (null == tailMode) {
          if ("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder)
            didWarnAboutTailOptions[suspenseContext] = true, console.error(
              'The default for the <SuspenseList tail="..."> prop is changing. To be future compatible you must explictly specify either "visible" (the current default), "collapsed" or "hidden".'
            );
        } else
          "visible" !== tailMode && "collapsed" !== tailMode && "hidden" !== tailMode ? (didWarnAboutTailOptions[suspenseContext] = true, console.error(
            '"%s" is not a supported value for tail on <SuspenseList />. Did you mean "visible", "collapsed" or "hidden"?',
            tailMode
          )) : "forwards" !== revealOrder && "backwards" !== revealOrder && "unstable_legacy-backwards" !== revealOrder && (didWarnAboutTailOptions[suspenseContext] = true, console.error(
            '<SuspenseList tail="%s" /> is only valid if revealOrder is "forwards" or "backwards". Did you mean to specify revealOrder="forwards"?',
            tailMode
          ));
      a: if (("forwards" === revealOrder || "backwards" === revealOrder || "unstable_legacy-backwards" === revealOrder) && void 0 !== newChildren && null !== newChildren && false !== newChildren)
        if (isArrayImpl(newChildren))
          for (suspenseContext = 0; suspenseContext < newChildren.length; suspenseContext++) {
            if (!validateSuspenseListNestedChild(
              newChildren[suspenseContext],
              suspenseContext
            ))
              break a;
          }
        else if (suspenseContext = getIteratorFn(newChildren), "function" === typeof suspenseContext) {
          if (suspenseContext = suspenseContext.call(newChildren))
            for (var step = suspenseContext.next(), _i2 = 0; !step.done; step = suspenseContext.next()) {
              if (!validateSuspenseListNestedChild(step.value, _i2)) break a;
              _i2++;
            }
        } else
          console.error(
            'A single row was passed to a <SuspenseList revealOrder="%s" />. This is not useful since it needs multiple rows. Did you mean to pass multiple children or an array?',
            revealOrder
          );
      reconcileChildren(current3, workInProgress2, newChildren, renderLanes2);
      isHydrating ? (warnIfNotHydrating(), newChildren = treeForkCount) : newChildren = 0;
      if (!nextProps && null !== current3 && 0 !== (current3.flags & 128))
        a: for (current3 = workInProgress2.child; null !== current3; ) {
          if (13 === current3.tag)
            null !== current3.memoizedState && scheduleSuspenseWorkOnFiber(current3, renderLanes2, workInProgress2);
          else if (19 === current3.tag)
            scheduleSuspenseWorkOnFiber(current3, renderLanes2, workInProgress2);
          else if (null !== current3.child) {
            current3.child.return = current3;
            current3 = current3.child;
            continue;
          }
          if (current3 === workInProgress2) break a;
          for (; null === current3.sibling; ) {
            if (null === current3.return || current3.return === workInProgress2)
              break a;
            current3 = current3.return;
          }
          current3.sibling.return = current3.return;
          current3 = current3.sibling;
        }
      switch (revealOrder) {
        case "forwards":
          renderLanes2 = workInProgress2.child;
          for (revealOrder = null; null !== renderLanes2; )
            current3 = renderLanes2.alternate, null !== current3 && null === findFirstSuspended(current3) && (revealOrder = renderLanes2), renderLanes2 = renderLanes2.sibling;
          renderLanes2 = revealOrder;
          null === renderLanes2 ? (revealOrder = workInProgress2.child, workInProgress2.child = null) : (revealOrder = renderLanes2.sibling, renderLanes2.sibling = null);
          initSuspenseListRenderState(
            workInProgress2,
            false,
            revealOrder,
            renderLanes2,
            tailMode,
            newChildren
          );
          break;
        case "backwards":
        case "unstable_legacy-backwards":
          renderLanes2 = null;
          revealOrder = workInProgress2.child;
          for (workInProgress2.child = null; null !== revealOrder; ) {
            current3 = revealOrder.alternate;
            if (null !== current3 && null === findFirstSuspended(current3)) {
              workInProgress2.child = revealOrder;
              break;
            }
            current3 = revealOrder.sibling;
            revealOrder.sibling = renderLanes2;
            renderLanes2 = revealOrder;
            revealOrder = current3;
          }
          initSuspenseListRenderState(
            workInProgress2,
            true,
            renderLanes2,
            null,
            tailMode,
            newChildren
          );
          break;
        case "together":
          initSuspenseListRenderState(
            workInProgress2,
            false,
            null,
            null,
            void 0,
            newChildren
          );
          break;
        default:
          workInProgress2.memoizedState = null;
      }
      return workInProgress2.child;
    }
    function bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2) {
      null !== current3 && (workInProgress2.dependencies = current3.dependencies);
      profilerStartTime = -1;
      workInProgressRootSkippedLanes |= workInProgress2.lanes;
      if (0 === (renderLanes2 & workInProgress2.childLanes))
        if (null !== current3) {
          if (propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), 0 === (renderLanes2 & workInProgress2.childLanes))
            return null;
        } else return null;
      if (null !== current3 && workInProgress2.child !== current3.child)
        throw Error("Resuming work not yet implemented.");
      if (null !== workInProgress2.child) {
        current3 = workInProgress2.child;
        renderLanes2 = createWorkInProgress(current3, current3.pendingProps);
        workInProgress2.child = renderLanes2;
        for (renderLanes2.return = workInProgress2; null !== current3.sibling; )
          current3 = current3.sibling, renderLanes2 = renderLanes2.sibling = createWorkInProgress(current3, current3.pendingProps), renderLanes2.return = workInProgress2;
        renderLanes2.sibling = null;
      }
      return workInProgress2.child;
    }
    function checkScheduledUpdateOrContext(current3, renderLanes2) {
      if (0 !== (current3.lanes & renderLanes2)) return true;
      current3 = current3.dependencies;
      return null !== current3 && checkIfContextChanged(current3) ? true : false;
    }
    function attemptEarlyBailoutIfNoScheduledUpdate(current3, workInProgress2, renderLanes2) {
      switch (workInProgress2.tag) {
        case 3:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          pushProvider(
            workInProgress2,
            CacheContext,
            current3.memoizedState.cache
          );
          resetHydrationState();
          break;
        case 27:
        case 5:
          pushHostContext(workInProgress2);
          break;
        case 4:
          pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          );
          break;
        case 10:
          pushProvider(
            workInProgress2,
            workInProgress2.type,
            workInProgress2.memoizedProps.value
          );
          break;
        case 12:
          0 !== (renderLanes2 & workInProgress2.childLanes) && (workInProgress2.flags |= 4);
          workInProgress2.flags |= 2048;
          var stateNode = workInProgress2.stateNode;
          stateNode.effectDuration = -0;
          stateNode.passiveEffectDuration = -0;
          break;
        case 31:
          if (null !== workInProgress2.memoizedState)
            return workInProgress2.flags |= 128, pushDehydratedActivitySuspenseHandler(workInProgress2), null;
          break;
        case 13:
          stateNode = workInProgress2.memoizedState;
          if (null !== stateNode) {
            if (null !== stateNode.dehydrated)
              return pushPrimaryTreeSuspenseHandler(workInProgress2), workInProgress2.flags |= 128, null;
            if (0 !== (renderLanes2 & workInProgress2.child.childLanes))
              return updateSuspenseComponent(
                current3,
                workInProgress2,
                renderLanes2
              );
            pushPrimaryTreeSuspenseHandler(workInProgress2);
            current3 = bailoutOnAlreadyFinishedWork(
              current3,
              workInProgress2,
              renderLanes2
            );
            return null !== current3 ? current3.sibling : null;
          }
          pushPrimaryTreeSuspenseHandler(workInProgress2);
          break;
        case 19:
          var didSuspendBefore = 0 !== (current3.flags & 128);
          stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes);
          stateNode || (propagateParentContextChanges(
            current3,
            workInProgress2,
            renderLanes2,
            false
          ), stateNode = 0 !== (renderLanes2 & workInProgress2.childLanes));
          if (didSuspendBefore) {
            if (stateNode)
              return updateSuspenseListComponent(
                current3,
                workInProgress2,
                renderLanes2
              );
            workInProgress2.flags |= 128;
          }
          didSuspendBefore = workInProgress2.memoizedState;
          null !== didSuspendBefore && (didSuspendBefore.rendering = null, didSuspendBefore.tail = null, didSuspendBefore.lastEffect = null);
          push2(
            suspenseStackCursor,
            suspenseStackCursor.current,
            workInProgress2
          );
          if (stateNode) break;
          else return null;
        case 22:
          return workInProgress2.lanes = 0, updateOffscreenComponent(
            current3,
            workInProgress2,
            renderLanes2,
            workInProgress2.pendingProps
          );
        case 24:
          pushProvider(
            workInProgress2,
            CacheContext,
            current3.memoizedState.cache
          );
      }
      return bailoutOnAlreadyFinishedWork(current3, workInProgress2, renderLanes2);
    }
    function beginWork(current3, workInProgress2, renderLanes2) {
      if (workInProgress2._debugNeedsRemount && null !== current3) {
        renderLanes2 = createFiberFromTypeAndProps(
          workInProgress2.type,
          workInProgress2.key,
          workInProgress2.pendingProps,
          workInProgress2._debugOwner || null,
          workInProgress2.mode,
          workInProgress2.lanes
        );
        renderLanes2._debugStack = workInProgress2._debugStack;
        renderLanes2._debugTask = workInProgress2._debugTask;
        var returnFiber = workInProgress2.return;
        if (null === returnFiber) throw Error("Cannot swap the root fiber.");
        current3.alternate = null;
        workInProgress2.alternate = null;
        renderLanes2.index = workInProgress2.index;
        renderLanes2.sibling = workInProgress2.sibling;
        renderLanes2.return = workInProgress2.return;
        renderLanes2.ref = workInProgress2.ref;
        renderLanes2._debugInfo = workInProgress2._debugInfo;
        if (workInProgress2 === returnFiber.child)
          returnFiber.child = renderLanes2;
        else {
          var prevSibling = returnFiber.child;
          if (null === prevSibling)
            throw Error("Expected parent to have a child.");
          for (; prevSibling.sibling !== workInProgress2; )
            if (prevSibling = prevSibling.sibling, null === prevSibling)
              throw Error("Expected to find the previous sibling.");
          prevSibling.sibling = renderLanes2;
        }
        workInProgress2 = returnFiber.deletions;
        null === workInProgress2 ? (returnFiber.deletions = [current3], returnFiber.flags |= 16) : workInProgress2.push(current3);
        renderLanes2.flags |= 2;
        return renderLanes2;
      }
      if (null !== current3)
        if (current3.memoizedProps !== workInProgress2.pendingProps || workInProgress2.type !== current3.type)
          didReceiveUpdate = true;
        else {
          if (!checkScheduledUpdateOrContext(current3, renderLanes2) && 0 === (workInProgress2.flags & 128))
            return didReceiveUpdate = false, attemptEarlyBailoutIfNoScheduledUpdate(
              current3,
              workInProgress2,
              renderLanes2
            );
          didReceiveUpdate = 0 !== (current3.flags & 131072) ? true : false;
        }
      else {
        didReceiveUpdate = false;
        if (returnFiber = isHydrating)
          warnIfNotHydrating(), returnFiber = 0 !== (workInProgress2.flags & 1048576);
        returnFiber && (returnFiber = workInProgress2.index, warnIfNotHydrating(), pushTreeId(workInProgress2, treeForkCount, returnFiber));
      }
      workInProgress2.lanes = 0;
      switch (workInProgress2.tag) {
        case 16:
          a: if (returnFiber = workInProgress2.pendingProps, current3 = resolveLazy(workInProgress2.elementType), workInProgress2.type = current3, "function" === typeof current3)
            shouldConstruct(current3) ? (returnFiber = resolveClassComponentProps(
              current3,
              returnFiber
            ), workInProgress2.tag = 1, workInProgress2.type = current3 = resolveFunctionForHotReloading(current3), workInProgress2 = updateClassComponent(
              null,
              workInProgress2,
              current3,
              returnFiber,
              renderLanes2
            )) : (workInProgress2.tag = 0, validateFunctionComponentInDev(workInProgress2, current3), workInProgress2.type = current3 = resolveFunctionForHotReloading(current3), workInProgress2 = updateFunctionComponent(
              null,
              workInProgress2,
              current3,
              returnFiber,
              renderLanes2
            ));
          else {
            if (void 0 !== current3 && null !== current3) {
              if (prevSibling = current3.$$typeof, prevSibling === REACT_FORWARD_REF_TYPE) {
                workInProgress2.tag = 11;
                workInProgress2.type = current3 = resolveForwardRefForHotReloading(current3);
                workInProgress2 = updateForwardRef(
                  null,
                  workInProgress2,
                  current3,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (prevSibling === REACT_MEMO_TYPE) {
                workInProgress2.tag = 14;
                workInProgress2 = updateMemoComponent(
                  null,
                  workInProgress2,
                  current3,
                  returnFiber,
                  renderLanes2
                );
                break a;
              }
            }
            workInProgress2 = "";
            null !== current3 && "object" === typeof current3 && current3.$$typeof === REACT_LAZY_TYPE && (workInProgress2 = " Did you wrap a component in React.lazy() more than once?");
            renderLanes2 = getComponentNameFromType(current3) || current3;
            throw Error(
              "Element type is invalid. Received a promise that resolves to: " + renderLanes2 + ". Lazy element type must resolve to a class or function." + workInProgress2
            );
          }
          return workInProgress2;
        case 0:
          return updateFunctionComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 1:
          return returnFiber = workInProgress2.type, prevSibling = resolveClassComponentProps(
            returnFiber,
            workInProgress2.pendingProps
          ), updateClassComponent(
            current3,
            workInProgress2,
            returnFiber,
            prevSibling,
            renderLanes2
          );
        case 3:
          a: {
            pushHostContainer(
              workInProgress2,
              workInProgress2.stateNode.containerInfo
            );
            if (null === current3)
              throw Error(
                "Should have a current fiber. This is a bug in React."
              );
            returnFiber = workInProgress2.pendingProps;
            var prevState = workInProgress2.memoizedState;
            prevSibling = prevState.element;
            cloneUpdateQueue(current3, workInProgress2);
            processUpdateQueue(workInProgress2, returnFiber, null, renderLanes2);
            var nextState = workInProgress2.memoizedState;
            returnFiber = nextState.cache;
            pushProvider(workInProgress2, CacheContext, returnFiber);
            returnFiber !== prevState.cache && propagateContextChanges(
              workInProgress2,
              [CacheContext],
              renderLanes2,
              true
            );
            suspendIfUpdateReadFromEntangledAsyncAction();
            returnFiber = nextState.element;
            if (prevState.isDehydrated)
              if (prevState = {
                element: returnFiber,
                isDehydrated: false,
                cache: nextState.cache
              }, workInProgress2.updateQueue.baseState = prevState, workInProgress2.memoizedState = prevState, workInProgress2.flags & 256) {
                workInProgress2 = mountHostRootWithoutHydrating(
                  current3,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else if (returnFiber !== prevSibling) {
                prevSibling = createCapturedValueAtFiber(
                  Error(
                    "This root received an early update, before anything was able hydrate. Switched the entire root to client rendering."
                  ),
                  workInProgress2
                );
                queueHydrationError(prevSibling);
                workInProgress2 = mountHostRootWithoutHydrating(
                  current3,
                  workInProgress2,
                  returnFiber,
                  renderLanes2
                );
                break a;
              } else {
                current3 = workInProgress2.stateNode.containerInfo;
                switch (current3.nodeType) {
                  case 9:
                    current3 = current3.body;
                    break;
                  default:
                    current3 = "HTML" === current3.nodeName ? current3.ownerDocument.body : current3;
                }
                nextHydratableInstance = getNextHydratable(current3.firstChild);
                hydrationParentFiber = workInProgress2;
                isHydrating = true;
                hydrationErrors = null;
                didSuspendOrErrorDEV = false;
                hydrationDiffRootDEV = null;
                rootOrSingletonContext = true;
                renderLanes2 = mountChildFibers(
                  workInProgress2,
                  null,
                  returnFiber,
                  renderLanes2
                );
                for (workInProgress2.child = renderLanes2; renderLanes2; )
                  renderLanes2.flags = renderLanes2.flags & -3 | 4096, renderLanes2 = renderLanes2.sibling;
              }
            else {
              resetHydrationState();
              if (returnFiber === prevSibling) {
                workInProgress2 = bailoutOnAlreadyFinishedWork(
                  current3,
                  workInProgress2,
                  renderLanes2
                );
                break a;
              }
              reconcileChildren(
                current3,
                workInProgress2,
                returnFiber,
                renderLanes2
              );
            }
            workInProgress2 = workInProgress2.child;
          }
          return workInProgress2;
        case 26:
          return markRef(current3, workInProgress2), null === current3 ? (renderLanes2 = getResource(
            workInProgress2.type,
            null,
            workInProgress2.pendingProps,
            null
          )) ? workInProgress2.memoizedState = renderLanes2 : isHydrating || (renderLanes2 = workInProgress2.type, current3 = workInProgress2.pendingProps, returnFiber = requiredContext(
            rootInstanceStackCursor.current
          ), returnFiber = getOwnerDocumentFromRootContainer(
            returnFiber
          ).createElement(renderLanes2), returnFiber[internalInstanceKey] = workInProgress2, returnFiber[internalPropsKey] = current3, setInitialProperties(returnFiber, renderLanes2, current3), markNodeAsHoistable(returnFiber), workInProgress2.stateNode = returnFiber) : workInProgress2.memoizedState = getResource(
            workInProgress2.type,
            current3.memoizedProps,
            workInProgress2.pendingProps,
            current3.memoizedState
          ), null;
        case 27:
          return pushHostContext(workInProgress2), null === current3 && isHydrating && (returnFiber = requiredContext(rootInstanceStackCursor.current), prevSibling = getHostContext(), returnFiber = workInProgress2.stateNode = resolveSingletonInstance(
            workInProgress2.type,
            workInProgress2.pendingProps,
            returnFiber,
            prevSibling,
            false
          ), didSuspendOrErrorDEV || (prevSibling = diffHydratedProperties(
            returnFiber,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevSibling
          ), null !== prevSibling && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevSibling)), hydrationParentFiber = workInProgress2, rootOrSingletonContext = true, prevSibling = nextHydratableInstance, isSingletonScope(workInProgress2.type) ? (previousHydratableOnEnteringScopedSingleton = prevSibling, nextHydratableInstance = getNextHydratable(
            returnFiber.firstChild
          )) : nextHydratableInstance = prevSibling), reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), markRef(current3, workInProgress2), null === current3 && (workInProgress2.flags |= 4194304), workInProgress2.child;
        case 5:
          return null === current3 && isHydrating && (prevState = getHostContext(), returnFiber = validateDOMNesting(
            workInProgress2.type,
            prevState.ancestorInfo
          ), prevSibling = nextHydratableInstance, (nextState = !prevSibling) || (nextState = canHydrateInstance(
            prevSibling,
            workInProgress2.type,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== nextState ? (workInProgress2.stateNode = nextState, didSuspendOrErrorDEV || (prevState = diffHydratedProperties(
            nextState,
            workInProgress2.type,
            workInProgress2.pendingProps,
            prevState
          ), null !== prevState && (buildHydrationDiffNode(workInProgress2, 0).serverProps = prevState)), hydrationParentFiber = workInProgress2, nextHydratableInstance = getNextHydratable(
            nextState.firstChild
          ), rootOrSingletonContext = false, prevState = true) : prevState = false, nextState = !prevState), nextState && (returnFiber && warnNonHydratedInstance(workInProgress2, prevSibling), throwOnHydrationMismatch(workInProgress2))), pushHostContext(workInProgress2), prevSibling = workInProgress2.type, prevState = workInProgress2.pendingProps, nextState = null !== current3 ? current3.memoizedProps : null, returnFiber = prevState.children, shouldSetTextContent(prevSibling, prevState) ? returnFiber = null : null !== nextState && shouldSetTextContent(prevSibling, nextState) && (workInProgress2.flags |= 32), null !== workInProgress2.memoizedState && (prevSibling = renderWithHooks(
            current3,
            workInProgress2,
            TransitionAwareHostComponent,
            null,
            null,
            renderLanes2
          ), HostTransitionContext._currentValue = prevSibling), markRef(current3, workInProgress2), reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 6:
          return null === current3 && isHydrating && (renderLanes2 = workInProgress2.pendingProps, current3 = getHostContext(), returnFiber = current3.ancestorInfo.current, renderLanes2 = null != returnFiber ? validateTextNesting(
            renderLanes2,
            returnFiber.tag,
            current3.ancestorInfo.implicitRootScope
          ) : true, current3 = nextHydratableInstance, (returnFiber = !current3) || (returnFiber = canHydrateTextInstance(
            current3,
            workInProgress2.pendingProps,
            rootOrSingletonContext
          ), null !== returnFiber ? (workInProgress2.stateNode = returnFiber, hydrationParentFiber = workInProgress2, nextHydratableInstance = null, returnFiber = true) : returnFiber = false, returnFiber = !returnFiber), returnFiber && (renderLanes2 && warnNonHydratedInstance(workInProgress2, current3), throwOnHydrationMismatch(workInProgress2))), null;
        case 13:
          return updateSuspenseComponent(current3, workInProgress2, renderLanes2);
        case 4:
          return pushHostContainer(
            workInProgress2,
            workInProgress2.stateNode.containerInfo
          ), returnFiber = workInProgress2.pendingProps, null === current3 ? workInProgress2.child = reconcileChildFibers(
            workInProgress2,
            null,
            returnFiber,
            renderLanes2
          ) : reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 11:
          return updateForwardRef(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 7:
          return reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps,
            renderLanes2
          ), workInProgress2.child;
        case 8:
          return reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 12:
          return workInProgress2.flags |= 4, workInProgress2.flags |= 2048, returnFiber = workInProgress2.stateNode, returnFiber.effectDuration = -0, returnFiber.passiveEffectDuration = -0, reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 10:
          return returnFiber = workInProgress2.type, prevSibling = workInProgress2.pendingProps, prevState = prevSibling.value, "value" in prevSibling || hasWarnedAboutUsingNoValuePropOnContextProvider || (hasWarnedAboutUsingNoValuePropOnContextProvider = true, console.error(
            "The `value` prop is required for the `<Context.Provider>`. Did you misspell it or forget to pass it?"
          )), pushProvider(workInProgress2, returnFiber, prevState), reconcileChildren(
            current3,
            workInProgress2,
            prevSibling.children,
            renderLanes2
          ), workInProgress2.child;
        case 9:
          return prevSibling = workInProgress2.type._context, returnFiber = workInProgress2.pendingProps.children, "function" !== typeof returnFiber && console.error(
            "A context consumer was rendered with multiple children, or a child that isn't a function. A context consumer expects a single child that is a function. If you did pass a function, make sure there is no trailing or leading whitespace around it."
          ), prepareToReadContext(workInProgress2), prevSibling = readContext(prevSibling), returnFiber = callComponentInDEV(
            returnFiber,
            prevSibling,
            void 0
          ), workInProgress2.flags |= 1, reconcileChildren(
            current3,
            workInProgress2,
            returnFiber,
            renderLanes2
          ), workInProgress2.child;
        case 14:
          return updateMemoComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 15:
          return updateSimpleMemoComponent(
            current3,
            workInProgress2,
            workInProgress2.type,
            workInProgress2.pendingProps,
            renderLanes2
          );
        case 19:
          return updateSuspenseListComponent(
            current3,
            workInProgress2,
            renderLanes2
          );
        case 31:
          return updateActivityComponent(current3, workInProgress2, renderLanes2);
        case 22:
          return updateOffscreenComponent(
            current3,
            workInProgress2,
            renderLanes2,
            workInProgress2.pendingProps
          );
        case 24:
          return prepareToReadContext(workInProgress2), returnFiber = readContext(CacheContext), null === current3 ? (prevSibling = peekCacheFromPool(), null === prevSibling && (prevSibling = workInProgressRoot, prevState = createCache(), prevSibling.pooledCache = prevState, retainCache(prevState), null !== prevState && (prevSibling.pooledCacheLanes |= renderLanes2), prevSibling = prevState), workInProgress2.memoizedState = {
            parent: returnFiber,
            cache: prevSibling
          }, initializeUpdateQueue(workInProgress2), pushProvider(workInProgress2, CacheContext, prevSibling)) : (0 !== (current3.lanes & renderLanes2) && (cloneUpdateQueue(current3, workInProgress2), processUpdateQueue(workInProgress2, null, null, renderLanes2), suspendIfUpdateReadFromEntangledAsyncAction()), prevSibling = current3.memoizedState, prevState = workInProgress2.memoizedState, prevSibling.parent !== returnFiber ? (prevSibling = {
            parent: returnFiber,
            cache: returnFiber
          }, workInProgress2.memoizedState = prevSibling, 0 === workInProgress2.lanes && (workInProgress2.memoizedState = workInProgress2.updateQueue.baseState = prevSibling), pushProvider(workInProgress2, CacheContext, returnFiber)) : (returnFiber = prevState.cache, pushProvider(workInProgress2, CacheContext, returnFiber), returnFiber !== prevSibling.cache && propagateContextChanges(
            workInProgress2,
            [CacheContext],
            renderLanes2,
            true
          ))), reconcileChildren(
            current3,
            workInProgress2,
            workInProgress2.pendingProps.children,
            renderLanes2
          ), workInProgress2.child;
        case 29:
          throw workInProgress2.pendingProps;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function markUpdate(workInProgress2) {
      workInProgress2.flags |= 4;
    }
    function preloadInstanceAndSuspendIfNeeded(workInProgress2, type, oldProps, newProps, renderLanes2) {
      if (type = (workInProgress2.mode & SuspenseyImagesMode) !== NoMode)
        type = false;
      if (type) {
        if (workInProgress2.flags |= 16777216, (renderLanes2 & 335544128) === renderLanes2)
          if (workInProgress2.stateNode.complete) workInProgress2.flags |= 8192;
          else if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
          else
            throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
      } else workInProgress2.flags &= -16777217;
    }
    function preloadResourceAndSuspendIfNeeded(workInProgress2, resource) {
      if ("stylesheet" !== resource.type || (resource.state.loading & Inserted) !== NotLoaded)
        workInProgress2.flags &= -16777217;
      else if (workInProgress2.flags |= 16777216, !preloadResource(resource))
        if (shouldRemainOnPreviousScreen()) workInProgress2.flags |= 8192;
        else
          throw suspendedThenable = noopSuspenseyCommitThenable, SuspenseyCommitException;
    }
    function scheduleRetryEffect(workInProgress2, retryQueue) {
      null !== retryQueue && (workInProgress2.flags |= 4);
      workInProgress2.flags & 16384 && (retryQueue = 22 !== workInProgress2.tag ? claimNextRetryLane() : 536870912, workInProgress2.lanes |= retryQueue, workInProgressSuspendedRetryLanes |= retryQueue);
    }
    function cutOffTailIfNeeded(renderState, hasRenderedATailFallback) {
      if (!isHydrating)
        switch (renderState.tailMode) {
          case "hidden":
            hasRenderedATailFallback = renderState.tail;
            for (var lastTailNode = null; null !== hasRenderedATailFallback; )
              null !== hasRenderedATailFallback.alternate && (lastTailNode = hasRenderedATailFallback), hasRenderedATailFallback = hasRenderedATailFallback.sibling;
            null === lastTailNode ? renderState.tail = null : lastTailNode.sibling = null;
            break;
          case "collapsed":
            lastTailNode = renderState.tail;
            for (var _lastTailNode = null; null !== lastTailNode; )
              null !== lastTailNode.alternate && (_lastTailNode = lastTailNode), lastTailNode = lastTailNode.sibling;
            null === _lastTailNode ? hasRenderedATailFallback || null === renderState.tail ? renderState.tail = null : renderState.tail.sibling = null : _lastTailNode.sibling = null;
        }
    }
    function bubbleProperties(completedWork) {
      var didBailout = null !== completedWork.alternate && completedWork.alternate.child === completedWork.child, newChildLanes = 0, subtreeFlags = 0;
      if (didBailout)
        if ((completedWork.mode & ProfileMode) !== NoMode) {
          for (var _treeBaseDuration = completedWork.selfBaseDuration, _child2 = completedWork.child; null !== _child2; )
            newChildLanes |= _child2.lanes | _child2.childLanes, subtreeFlags |= _child2.subtreeFlags & 65011712, subtreeFlags |= _child2.flags & 65011712, _treeBaseDuration += _child2.treeBaseDuration, _child2 = _child2.sibling;
          completedWork.treeBaseDuration = _treeBaseDuration;
        } else
          for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
            newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags & 65011712, subtreeFlags |= _treeBaseDuration.flags & 65011712, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      else if ((completedWork.mode & ProfileMode) !== NoMode) {
        _treeBaseDuration = completedWork.actualDuration;
        _child2 = completedWork.selfBaseDuration;
        for (var child = completedWork.child; null !== child; )
          newChildLanes |= child.lanes | child.childLanes, subtreeFlags |= child.subtreeFlags, subtreeFlags |= child.flags, _treeBaseDuration += child.actualDuration, _child2 += child.treeBaseDuration, child = child.sibling;
        completedWork.actualDuration = _treeBaseDuration;
        completedWork.treeBaseDuration = _child2;
      } else
        for (_treeBaseDuration = completedWork.child; null !== _treeBaseDuration; )
          newChildLanes |= _treeBaseDuration.lanes | _treeBaseDuration.childLanes, subtreeFlags |= _treeBaseDuration.subtreeFlags, subtreeFlags |= _treeBaseDuration.flags, _treeBaseDuration.return = completedWork, _treeBaseDuration = _treeBaseDuration.sibling;
      completedWork.subtreeFlags |= subtreeFlags;
      completedWork.childLanes = newChildLanes;
      return didBailout;
    }
    function completeWork(current3, workInProgress2, renderLanes2) {
      var newProps = workInProgress2.pendingProps;
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 16:
        case 15:
        case 0:
        case 11:
        case 7:
        case 8:
        case 12:
        case 9:
        case 14:
          return bubbleProperties(workInProgress2), null;
        case 1:
          return bubbleProperties(workInProgress2), null;
        case 3:
          renderLanes2 = workInProgress2.stateNode;
          newProps = null;
          null !== current3 && (newProps = current3.memoizedState.cache);
          workInProgress2.memoizedState.cache !== newProps && (workInProgress2.flags |= 2048);
          popProvider(CacheContext, workInProgress2);
          popHostContainer(workInProgress2);
          renderLanes2.pendingContext && (renderLanes2.context = renderLanes2.pendingContext, renderLanes2.pendingContext = null);
          if (null === current3 || null === current3.child)
            popHydrationState(workInProgress2) ? (emitPendingHydrationWarnings(), markUpdate(workInProgress2)) : null === current3 || current3.memoizedState.isDehydrated && 0 === (workInProgress2.flags & 256) || (workInProgress2.flags |= 1024, upgradeHydrationErrorsToRecoverable());
          bubbleProperties(workInProgress2);
          return null;
        case 26:
          var type = workInProgress2.type, nextResource = workInProgress2.memoizedState;
          null === current3 ? (markUpdate(workInProgress2), null !== nextResource ? (bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            nextResource
          )) : (bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            type,
            null,
            newProps,
            renderLanes2
          ))) : nextResource ? nextResource !== current3.memoizedState ? (markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadResourceAndSuspendIfNeeded(
            workInProgress2,
            nextResource
          )) : (bubbleProperties(workInProgress2), workInProgress2.flags &= -16777217) : (current3 = current3.memoizedProps, current3 !== newProps && markUpdate(workInProgress2), bubbleProperties(workInProgress2), preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            type,
            current3,
            newProps,
            renderLanes2
          ));
          return null;
        case 27:
          popHostContext(workInProgress2);
          renderLanes2 = requiredContext(rootInstanceStackCursor.current);
          type = workInProgress2.type;
          if (null !== current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            current3 = getHostContext();
            popHydrationState(workInProgress2) ? prepareToHydrateHostInstance(workInProgress2) : (current3 = resolveSingletonInstance(
              type,
              newProps,
              renderLanes2,
              current3,
              true
            ), workInProgress2.stateNode = current3, markUpdate(workInProgress2));
          }
          bubbleProperties(workInProgress2);
          return null;
        case 5:
          popHostContext(workInProgress2);
          type = workInProgress2.type;
          if (null !== current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if (!newProps) {
              if (null === workInProgress2.stateNode)
                throw Error(
                  "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
                );
              bubbleProperties(workInProgress2);
              return null;
            }
            var _currentHostContext = getHostContext();
            if (popHydrationState(workInProgress2))
              prepareToHydrateHostInstance(workInProgress2);
            else {
              nextResource = requiredContext(rootInstanceStackCursor.current);
              validateDOMNesting(type, _currentHostContext.ancestorInfo);
              _currentHostContext = _currentHostContext.context;
              nextResource = getOwnerDocumentFromRootContainer(nextResource);
              switch (_currentHostContext) {
                case HostContextNamespaceSvg:
                  nextResource = nextResource.createElementNS(
                    SVG_NAMESPACE,
                    type
                  );
                  break;
                case HostContextNamespaceMath:
                  nextResource = nextResource.createElementNS(
                    MATH_NAMESPACE,
                    type
                  );
                  break;
                default:
                  switch (type) {
                    case "svg":
                      nextResource = nextResource.createElementNS(
                        SVG_NAMESPACE,
                        type
                      );
                      break;
                    case "math":
                      nextResource = nextResource.createElementNS(
                        MATH_NAMESPACE,
                        type
                      );
                      break;
                    case "script":
                      nextResource = nextResource.createElement("div");
                      nextResource.innerHTML = "<script><\/script>";
                      nextResource = nextResource.removeChild(
                        nextResource.firstChild
                      );
                      break;
                    case "select":
                      nextResource = "string" === typeof newProps.is ? nextResource.createElement("select", {
                        is: newProps.is
                      }) : nextResource.createElement("select");
                      newProps.multiple ? nextResource.multiple = true : newProps.size && (nextResource.size = newProps.size);
                      break;
                    default:
                      nextResource = "string" === typeof newProps.is ? nextResource.createElement(type, {
                        is: newProps.is
                      }) : nextResource.createElement(type), -1 === type.indexOf("-") && (type !== type.toLowerCase() && console.error(
                        "<%s /> is using incorrect casing. Use PascalCase for React components, or lowercase for HTML elements.",
                        type
                      ), "[object HTMLUnknownElement]" !== Object.prototype.toString.call(nextResource) || hasOwnProperty2.call(warnedUnknownTags, type) || (warnedUnknownTags[type] = true, console.error(
                        "The tag <%s> is unrecognized in this browser. If you meant to render a React component, start its name with an uppercase letter.",
                        type
                      )));
                  }
              }
              nextResource[internalInstanceKey] = workInProgress2;
              nextResource[internalPropsKey] = newProps;
              a: for (_currentHostContext = workInProgress2.child; null !== _currentHostContext; ) {
                if (5 === _currentHostContext.tag || 6 === _currentHostContext.tag)
                  nextResource.appendChild(_currentHostContext.stateNode);
                else if (4 !== _currentHostContext.tag && 27 !== _currentHostContext.tag && null !== _currentHostContext.child) {
                  _currentHostContext.child.return = _currentHostContext;
                  _currentHostContext = _currentHostContext.child;
                  continue;
                }
                if (_currentHostContext === workInProgress2) break a;
                for (; null === _currentHostContext.sibling; ) {
                  if (null === _currentHostContext.return || _currentHostContext.return === workInProgress2)
                    break a;
                  _currentHostContext = _currentHostContext.return;
                }
                _currentHostContext.sibling.return = _currentHostContext.return;
                _currentHostContext = _currentHostContext.sibling;
              }
              workInProgress2.stateNode = nextResource;
              a: switch (setInitialProperties(nextResource, type, newProps), type) {
                case "button":
                case "input":
                case "select":
                case "textarea":
                  newProps = !!newProps.autoFocus;
                  break a;
                case "img":
                  newProps = true;
                  break a;
                default:
                  newProps = false;
              }
              newProps && markUpdate(workInProgress2);
            }
          }
          bubbleProperties(workInProgress2);
          preloadInstanceAndSuspendIfNeeded(
            workInProgress2,
            workInProgress2.type,
            null === current3 ? null : current3.memoizedProps,
            workInProgress2.pendingProps,
            renderLanes2
          );
          return null;
        case 6:
          if (current3 && null != workInProgress2.stateNode)
            current3.memoizedProps !== newProps && markUpdate(workInProgress2);
          else {
            if ("string" !== typeof newProps && null === workInProgress2.stateNode)
              throw Error(
                "We must have new props for new mounts. This error is likely caused by a bug in React. Please file an issue."
              );
            current3 = requiredContext(rootInstanceStackCursor.current);
            renderLanes2 = getHostContext();
            if (popHydrationState(workInProgress2)) {
              current3 = workInProgress2.stateNode;
              renderLanes2 = workInProgress2.memoizedProps;
              type = !didSuspendOrErrorDEV;
              newProps = null;
              nextResource = hydrationParentFiber;
              if (null !== nextResource)
                switch (nextResource.tag) {
                  case 3:
                    type && (type = diffHydratedTextForDevWarnings(
                      current3,
                      renderLanes2,
                      newProps
                    ), null !== type && (buildHydrationDiffNode(workInProgress2, 0).serverProps = type));
                    break;
                  case 27:
                  case 5:
                    newProps = nextResource.memoizedProps, type && (type = diffHydratedTextForDevWarnings(
                      current3,
                      renderLanes2,
                      newProps
                    ), null !== type && (buildHydrationDiffNode(
                      workInProgress2,
                      0
                    ).serverProps = type));
                }
              current3[internalInstanceKey] = workInProgress2;
              current3 = current3.nodeValue === renderLanes2 || null !== newProps && true === newProps.suppressHydrationWarning || checkForUnmatchedText(current3.nodeValue, renderLanes2) ? true : false;
              current3 || throwOnHydrationMismatch(workInProgress2, true);
            } else
              type = renderLanes2.ancestorInfo.current, null != type && validateTextNesting(
                newProps,
                type.tag,
                renderLanes2.ancestorInfo.implicitRootScope
              ), current3 = getOwnerDocumentFromRootContainer(current3).createTextNode(
                newProps
              ), current3[internalInstanceKey] = workInProgress2, workInProgress2.stateNode = current3;
          }
          bubbleProperties(workInProgress2);
          return null;
        case 31:
          renderLanes2 = workInProgress2.memoizedState;
          if (null === current3 || null !== current3.memoizedState) {
            newProps = popHydrationState(workInProgress2);
            if (null !== renderLanes2) {
              if (null === current3) {
                if (!newProps)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                current3 = workInProgress2.memoizedState;
                current3 = null !== current3 ? current3.dehydrated : null;
                if (!current3)
                  throw Error(
                    "Expected to have a hydrated activity instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                current3[internalInstanceKey] = workInProgress2;
                bubbleProperties(workInProgress2);
                (workInProgress2.mode & ProfileMode) !== NoMode && null !== renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
              } else
                emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress2.flags & 128) && (renderLanes2 = workInProgress2.memoizedState = null), workInProgress2.flags |= 4, bubbleProperties(workInProgress2), (workInProgress2.mode & ProfileMode) !== NoMode && null !== renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
              current3 = false;
            } else
              renderLanes2 = upgradeHydrationErrorsToRecoverable(), null !== current3 && null !== current3.memoizedState && (current3.memoizedState.hydrationErrors = renderLanes2), current3 = true;
            if (!current3) {
              if (workInProgress2.flags & 256)
                return popSuspenseHandler(workInProgress2), workInProgress2;
              popSuspenseHandler(workInProgress2);
              return null;
            }
            if (0 !== (workInProgress2.flags & 128))
              throw Error(
                "Client rendering an Activity suspended it again. This is a bug in React."
              );
          }
          bubbleProperties(workInProgress2);
          return null;
        case 13:
          newProps = workInProgress2.memoizedState;
          if (null === current3 || null !== current3.memoizedState && null !== current3.memoizedState.dehydrated) {
            type = newProps;
            nextResource = popHydrationState(workInProgress2);
            if (null !== type && null !== type.dehydrated) {
              if (null === current3) {
                if (!nextResource)
                  throw Error(
                    "A dehydrated suspense component was completed without a hydrated node. This is probably a bug in React."
                  );
                nextResource = workInProgress2.memoizedState;
                nextResource = null !== nextResource ? nextResource.dehydrated : null;
                if (!nextResource)
                  throw Error(
                    "Expected to have a hydrated suspense instance. This error is likely caused by a bug in React. Please file an issue."
                  );
                nextResource[internalInstanceKey] = workInProgress2;
                bubbleProperties(workInProgress2);
                (workInProgress2.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress2.child, null !== type && (workInProgress2.treeBaseDuration -= type.treeBaseDuration));
              } else
                emitPendingHydrationWarnings(), resetHydrationState(), 0 === (workInProgress2.flags & 128) && (type = workInProgress2.memoizedState = null), workInProgress2.flags |= 4, bubbleProperties(workInProgress2), (workInProgress2.mode & ProfileMode) !== NoMode && null !== type && (type = workInProgress2.child, null !== type && (workInProgress2.treeBaseDuration -= type.treeBaseDuration));
              type = false;
            } else
              type = upgradeHydrationErrorsToRecoverable(), null !== current3 && null !== current3.memoizedState && (current3.memoizedState.hydrationErrors = type), type = true;
            if (!type) {
              if (workInProgress2.flags & 256)
                return popSuspenseHandler(workInProgress2), workInProgress2;
              popSuspenseHandler(workInProgress2);
              return null;
            }
          }
          popSuspenseHandler(workInProgress2);
          if (0 !== (workInProgress2.flags & 128))
            return workInProgress2.lanes = renderLanes2, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2;
          renderLanes2 = null !== newProps;
          current3 = null !== current3 && null !== current3.memoizedState;
          renderLanes2 && (newProps = workInProgress2.child, type = null, null !== newProps.alternate && null !== newProps.alternate.memoizedState && null !== newProps.alternate.memoizedState.cachePool && (type = newProps.alternate.memoizedState.cachePool.pool), nextResource = null, null !== newProps.memoizedState && null !== newProps.memoizedState.cachePool && (nextResource = newProps.memoizedState.cachePool.pool), nextResource !== type && (newProps.flags |= 2048));
          renderLanes2 !== current3 && renderLanes2 && (workInProgress2.child.flags |= 8192);
          scheduleRetryEffect(workInProgress2, workInProgress2.updateQueue);
          bubbleProperties(workInProgress2);
          (workInProgress2.mode & ProfileMode) !== NoMode && renderLanes2 && (current3 = workInProgress2.child, null !== current3 && (workInProgress2.treeBaseDuration -= current3.treeBaseDuration));
          return null;
        case 4:
          return popHostContainer(workInProgress2), null === current3 && listenToAllSupportedEvents(
            workInProgress2.stateNode.containerInfo
          ), bubbleProperties(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), bubbleProperties(workInProgress2), null;
        case 19:
          pop(suspenseStackCursor, workInProgress2);
          newProps = workInProgress2.memoizedState;
          if (null === newProps) return bubbleProperties(workInProgress2), null;
          type = 0 !== (workInProgress2.flags & 128);
          nextResource = newProps.rendering;
          if (null === nextResource)
            if (type) cutOffTailIfNeeded(newProps, false);
            else {
              if (workInProgressRootExitStatus !== RootInProgress || null !== current3 && 0 !== (current3.flags & 128))
                for (current3 = workInProgress2.child; null !== current3; ) {
                  nextResource = findFirstSuspended(current3);
                  if (null !== nextResource) {
                    workInProgress2.flags |= 128;
                    cutOffTailIfNeeded(newProps, false);
                    current3 = nextResource.updateQueue;
                    workInProgress2.updateQueue = current3;
                    scheduleRetryEffect(workInProgress2, current3);
                    workInProgress2.subtreeFlags = 0;
                    current3 = renderLanes2;
                    for (renderLanes2 = workInProgress2.child; null !== renderLanes2; )
                      resetWorkInProgress(renderLanes2, current3), renderLanes2 = renderLanes2.sibling;
                    push2(
                      suspenseStackCursor,
                      suspenseStackCursor.current & SubtreeSuspenseContextMask | ForceSuspenseFallback,
                      workInProgress2
                    );
                    isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount);
                    return workInProgress2.child;
                  }
                  current3 = current3.sibling;
                }
              null !== newProps.tail && now$1() > workInProgressRootRenderTargetTime && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
            }
          else {
            if (!type)
              if (current3 = findFirstSuspended(nextResource), null !== current3) {
                if (workInProgress2.flags |= 128, type = true, current3 = current3.updateQueue, workInProgress2.updateQueue = current3, scheduleRetryEffect(workInProgress2, current3), cutOffTailIfNeeded(newProps, true), null === newProps.tail && "hidden" === newProps.tailMode && !nextResource.alternate && !isHydrating)
                  return bubbleProperties(workInProgress2), null;
              } else
                2 * now$1() - newProps.renderingStartTime > workInProgressRootRenderTargetTime && 536870912 !== renderLanes2 && (workInProgress2.flags |= 128, type = true, cutOffTailIfNeeded(newProps, false), workInProgress2.lanes = 4194304);
            newProps.isBackwards ? (nextResource.sibling = workInProgress2.child, workInProgress2.child = nextResource) : (current3 = newProps.last, null !== current3 ? current3.sibling = nextResource : workInProgress2.child = nextResource, newProps.last = nextResource);
          }
          if (null !== newProps.tail)
            return current3 = newProps.tail, newProps.rendering = current3, newProps.tail = current3.sibling, newProps.renderingStartTime = now$1(), current3.sibling = null, renderLanes2 = suspenseStackCursor.current, renderLanes2 = type ? renderLanes2 & SubtreeSuspenseContextMask | ForceSuspenseFallback : renderLanes2 & SubtreeSuspenseContextMask, push2(suspenseStackCursor, renderLanes2, workInProgress2), isHydrating && pushTreeFork(workInProgress2, newProps.treeForkCount), current3;
          bubbleProperties(workInProgress2);
          return null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), newProps = null !== workInProgress2.memoizedState, null !== current3 ? null !== current3.memoizedState !== newProps && (workInProgress2.flags |= 8192) : newProps && (workInProgress2.flags |= 8192), newProps ? 0 !== (renderLanes2 & 536870912) && 0 === (workInProgress2.flags & 128) && (bubbleProperties(workInProgress2), workInProgress2.subtreeFlags & 6 && (workInProgress2.flags |= 8192)) : bubbleProperties(workInProgress2), renderLanes2 = workInProgress2.updateQueue, null !== renderLanes2 && scheduleRetryEffect(workInProgress2, renderLanes2.retryQueue), renderLanes2 = null, null !== current3 && null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (renderLanes2 = current3.memoizedState.cachePool.pool), newProps = null, null !== workInProgress2.memoizedState && null !== workInProgress2.memoizedState.cachePool && (newProps = workInProgress2.memoizedState.cachePool.pool), newProps !== renderLanes2 && (workInProgress2.flags |= 2048), null !== current3 && pop(resumedCache, workInProgress2), null;
        case 24:
          return renderLanes2 = null, null !== current3 && (renderLanes2 = current3.memoizedState.cache), workInProgress2.memoizedState.cache !== renderLanes2 && (workInProgress2.flags |= 2048), popProvider(CacheContext, workInProgress2), bubbleProperties(workInProgress2), null;
        case 25:
          return null;
        case 30:
          return null;
      }
      throw Error(
        "Unknown unit of work tag (" + workInProgress2.tag + "). This error is likely caused by a bug in React. Please file an issue."
      );
    }
    function unwindWork(current3, workInProgress2) {
      popTreeContext(workInProgress2);
      switch (workInProgress2.tag) {
        case 1:
          return current3 = workInProgress2.flags, current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 3:
          return popProvider(CacheContext, workInProgress2), popHostContainer(workInProgress2), current3 = workInProgress2.flags, 0 !== (current3 & 65536) && 0 === (current3 & 128) ? (workInProgress2.flags = current3 & -65537 | 128, workInProgress2) : null;
        case 26:
        case 27:
        case 5:
          return popHostContext(workInProgress2), null;
        case 31:
          if (null !== workInProgress2.memoizedState) {
            popSuspenseHandler(workInProgress2);
            if (null === workInProgress2.alternate)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            resetHydrationState();
          }
          current3 = workInProgress2.flags;
          return current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 13:
          popSuspenseHandler(workInProgress2);
          current3 = workInProgress2.memoizedState;
          if (null !== current3 && null !== current3.dehydrated) {
            if (null === workInProgress2.alternate)
              throw Error(
                "Threw in newly mounted dehydrated component. This is likely a bug in React. Please file an issue."
              );
            resetHydrationState();
          }
          current3 = workInProgress2.flags;
          return current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 19:
          return pop(suspenseStackCursor, workInProgress2), null;
        case 4:
          return popHostContainer(workInProgress2), null;
        case 10:
          return popProvider(workInProgress2.type, workInProgress2), null;
        case 22:
        case 23:
          return popSuspenseHandler(workInProgress2), popHiddenContext(workInProgress2), null !== current3 && pop(resumedCache, workInProgress2), current3 = workInProgress2.flags, current3 & 65536 ? (workInProgress2.flags = current3 & -65537 | 128, (workInProgress2.mode & ProfileMode) !== NoMode && transferActualDuration(workInProgress2), workInProgress2) : null;
        case 24:
          return popProvider(CacheContext, workInProgress2), null;
        case 25:
          return null;
        default:
          return null;
      }
    }
    function unwindInterruptedWork(current3, interruptedWork) {
      popTreeContext(interruptedWork);
      switch (interruptedWork.tag) {
        case 3:
          popProvider(CacheContext, interruptedWork);
          popHostContainer(interruptedWork);
          break;
        case 26:
        case 27:
        case 5:
          popHostContext(interruptedWork);
          break;
        case 4:
          popHostContainer(interruptedWork);
          break;
        case 31:
          null !== interruptedWork.memoizedState && popSuspenseHandler(interruptedWork);
          break;
        case 13:
          popSuspenseHandler(interruptedWork);
          break;
        case 19:
          pop(suspenseStackCursor, interruptedWork);
          break;
        case 10:
          popProvider(interruptedWork.type, interruptedWork);
          break;
        case 22:
        case 23:
          popSuspenseHandler(interruptedWork);
          popHiddenContext(interruptedWork);
          null !== current3 && pop(resumedCache, interruptedWork);
          break;
        case 24:
          popProvider(CacheContext, interruptedWork);
      }
    }
    function shouldProfile(current3) {
      return (current3.mode & ProfileMode) !== NoMode;
    }
    function commitHookLayoutEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookLayoutUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitHookEffectListMount(flags, finishedWork) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags) === flags && (lastEffect = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = runWithFiberInDEV(
              finishedWork,
              callCreateInDEV,
              updateQueue
            ), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = false), void 0 !== lastEffect && "function" !== typeof lastEffect)) {
              var hookName = void 0;
              hookName = 0 !== (updateQueue.tag & Layout) ? "useLayoutEffect" : 0 !== (updateQueue.tag & Insertion) ? "useInsertionEffect" : "useEffect";
              var addendum = void 0;
              addendum = null === lastEffect ? " You returned null. If your effect does not require clean up, return undefined (or nothing)." : "function" === typeof lastEffect.then ? "\n\nIt looks like you wrote " + hookName + "(async () => ...) or returned a Promise. Instead, write the async function inside your effect and call it immediately:\n\n" + hookName + "(() => {\n  async function fetchData() {\n    // You can await here\n    const response = await MyAPI.getData(someId);\n    // ...\n  }\n  fetchData();\n}, [someId]); // Or [] if effect doesn't need props or state\n\nLearn more about data fetching with Hooks: https://react.dev/link/hooks-data-fetching" : " You returned: " + lastEffect;
              runWithFiberInDEV(
                finishedWork,
                function(n2, a2) {
                  console.error(
                    "%s must not return anything besides a function, which is used for clean-up.%s",
                    n2,
                    a2
                  );
                },
                hookName,
                addendum
              );
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHookEffectListUnmount(flags, finishedWork, nearestMountedAncestor) {
      try {
        var updateQueue = finishedWork.updateQueue, lastEffect = null !== updateQueue ? updateQueue.lastEffect : null;
        if (null !== lastEffect) {
          var firstEffect = lastEffect.next;
          updateQueue = firstEffect;
          do {
            if ((updateQueue.tag & flags) === flags) {
              var inst = updateQueue.inst, destroy = inst.destroy;
              void 0 !== destroy && (inst.destroy = void 0, (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = true), lastEffect = finishedWork, runWithFiberInDEV(
                lastEffect,
                callDestroyInDEV,
                lastEffect,
                nearestMountedAncestor,
                destroy
              ), (flags & Insertion) !== NoFlags && (isRunningInsertionEffect = false));
            }
            updateQueue = updateQueue.next;
          } while (updateQueue !== firstEffect);
        }
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHookPassiveMountEffects(finishedWork, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListMount(hookFlags, finishedWork), recordEffectDuration()) : commitHookEffectListMount(hookFlags, finishedWork);
    }
    function commitHookPassiveUnmountEffects(finishedWork, nearestMountedAncestor, hookFlags) {
      shouldProfile(finishedWork) ? (startEffectTimer(), commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      ), recordEffectDuration()) : commitHookEffectListUnmount(
        hookFlags,
        finishedWork,
        nearestMountedAncestor
      );
    }
    function commitClassCallbacks(finishedWork) {
      var updateQueue = finishedWork.updateQueue;
      if (null !== updateQueue) {
        var instance = finishedWork.stateNode;
        finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (instance.props !== finishedWork.memoizedProps && console.error(
          "Expected %s props to match memoized props before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ), instance.state !== finishedWork.memoizedState && console.error(
          "Expected %s state to match memoized state before processing the update queue. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
          getComponentNameFromFiber(finishedWork) || "instance"
        ));
        try {
          runWithFiberInDEV(
            finishedWork,
            commitCallbacks,
            updateQueue,
            instance
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }
    function callGetSnapshotBeforeUpdates(instance, prevProps, prevState) {
      return instance.getSnapshotBeforeUpdate(prevProps, prevState);
    }
    function commitClassSnapshot(finishedWork, current3) {
      var prevProps = current3.memoizedProps, prevState = current3.memoizedState;
      current3 = finishedWork.stateNode;
      finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (current3.props !== finishedWork.memoizedProps && console.error(
        "Expected %s props to match memoized props before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ), current3.state !== finishedWork.memoizedState && console.error(
        "Expected %s state to match memoized state before getSnapshotBeforeUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
        getComponentNameFromFiber(finishedWork) || "instance"
      ));
      try {
        var resolvedPrevProps = resolveClassComponentProps(
          finishedWork.type,
          prevProps
        );
        var snapshot = runWithFiberInDEV(
          finishedWork,
          callGetSnapshotBeforeUpdates,
          current3,
          resolvedPrevProps,
          prevState
        );
        prevProps = didWarnAboutUndefinedSnapshotBeforeUpdate;
        void 0 !== snapshot || prevProps.has(finishedWork.type) || (prevProps.add(finishedWork.type), runWithFiberInDEV(finishedWork, function() {
          console.error(
            "%s.getSnapshotBeforeUpdate(): A snapshot value (or null) must be returned. You have returned undefined.",
            getComponentNameFromFiber(finishedWork)
          );
        }));
        current3.__reactInternalSnapshotBeforeUpdate = snapshot;
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function safelyCallComponentWillUnmount(current3, nearestMountedAncestor, instance) {
      instance.props = resolveClassComponentProps(
        current3.type,
        current3.memoizedProps
      );
      instance.state = current3.memoizedState;
      shouldProfile(current3) ? (startEffectTimer(), runWithFiberInDEV(
        current3,
        callComponentWillUnmountInDEV,
        current3,
        nearestMountedAncestor,
        instance
      ), recordEffectDuration()) : runWithFiberInDEV(
        current3,
        callComponentWillUnmountInDEV,
        current3,
        nearestMountedAncestor,
        instance
      );
    }
    function commitAttachRef(finishedWork) {
      var ref = finishedWork.ref;
      if (null !== ref) {
        switch (finishedWork.tag) {
          case 26:
          case 27:
          case 5:
            var instanceToUse = finishedWork.stateNode;
            break;
          case 30:
            instanceToUse = finishedWork.stateNode;
            break;
          default:
            instanceToUse = finishedWork.stateNode;
        }
        if ("function" === typeof ref)
          if (shouldProfile(finishedWork))
            try {
              startEffectTimer(), finishedWork.refCleanup = ref(instanceToUse);
            } finally {
              recordEffectDuration();
            }
          else finishedWork.refCleanup = ref(instanceToUse);
        else
          "string" === typeof ref ? console.error("String refs are no longer supported.") : ref.hasOwnProperty("current") || console.error(
            "Unexpected ref object provided for %s. Use either a ref-setter function or React.createRef().",
            getComponentNameFromFiber(finishedWork)
          ), ref.current = instanceToUse;
      }
    }
    function safelyAttachRef(current3, nearestMountedAncestor) {
      try {
        runWithFiberInDEV(current3, commitAttachRef, current3);
      } catch (error) {
        captureCommitPhaseError(current3, nearestMountedAncestor, error);
      }
    }
    function safelyDetachRef(current3, nearestMountedAncestor) {
      var ref = current3.ref, refCleanup = current3.refCleanup;
      if (null !== ref)
        if ("function" === typeof refCleanup)
          try {
            if (shouldProfile(current3))
              try {
                startEffectTimer(), runWithFiberInDEV(current3, refCleanup);
              } finally {
                recordEffectDuration(current3);
              }
            else runWithFiberInDEV(current3, refCleanup);
          } catch (error) {
            captureCommitPhaseError(current3, nearestMountedAncestor, error);
          } finally {
            current3.refCleanup = null, current3 = current3.alternate, null != current3 && (current3.refCleanup = null);
          }
        else if ("function" === typeof ref)
          try {
            if (shouldProfile(current3))
              try {
                startEffectTimer(), runWithFiberInDEV(current3, ref, null);
              } finally {
                recordEffectDuration(current3);
              }
            else runWithFiberInDEV(current3, ref, null);
          } catch (error$7) {
            captureCommitPhaseError(current3, nearestMountedAncestor, error$7);
          }
        else ref.current = null;
    }
    function commitProfiler(finishedWork, current3, commitStartTime2, effectDuration) {
      var _finishedWork$memoize = finishedWork.memoizedProps, id2 = _finishedWork$memoize.id, onCommit = _finishedWork$memoize.onCommit;
      _finishedWork$memoize = _finishedWork$memoize.onRender;
      current3 = null === current3 ? "mount" : "update";
      currentUpdateIsNested && (current3 = "nested-update");
      "function" === typeof _finishedWork$memoize && _finishedWork$memoize(
        id2,
        current3,
        finishedWork.actualDuration,
        finishedWork.treeBaseDuration,
        finishedWork.actualStartTime,
        commitStartTime2
      );
      "function" === typeof onCommit && onCommit(id2, current3, effectDuration, commitStartTime2);
    }
    function commitProfilerPostCommitImpl(finishedWork, current3, commitStartTime2, passiveEffectDuration) {
      var _finishedWork$memoize2 = finishedWork.memoizedProps;
      finishedWork = _finishedWork$memoize2.id;
      _finishedWork$memoize2 = _finishedWork$memoize2.onPostCommit;
      current3 = null === current3 ? "mount" : "update";
      currentUpdateIsNested && (current3 = "nested-update");
      "function" === typeof _finishedWork$memoize2 && _finishedWork$memoize2(
        finishedWork,
        current3,
        passiveEffectDuration,
        commitStartTime2
      );
    }
    function commitHostMount(finishedWork) {
      var type = finishedWork.type, props2 = finishedWork.memoizedProps, instance = finishedWork.stateNode;
      try {
        runWithFiberInDEV(
          finishedWork,
          commitMount,
          instance,
          type,
          props2,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function commitHostUpdate(finishedWork, newProps, oldProps) {
      try {
        runWithFiberInDEV(
          finishedWork,
          commitUpdate,
          finishedWork.stateNode,
          finishedWork.type,
          oldProps,
          newProps,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function isHostParent(fiber) {
      return 5 === fiber.tag || 3 === fiber.tag || 26 === fiber.tag || 27 === fiber.tag && isSingletonScope(fiber.type) || 4 === fiber.tag;
    }
    function getHostSibling(fiber) {
      a: for (; ; ) {
        for (; null === fiber.sibling; ) {
          if (null === fiber.return || isHostParent(fiber.return)) return null;
          fiber = fiber.return;
        }
        fiber.sibling.return = fiber.return;
        for (fiber = fiber.sibling; 5 !== fiber.tag && 6 !== fiber.tag && 18 !== fiber.tag; ) {
          if (27 === fiber.tag && isSingletonScope(fiber.type)) continue a;
          if (fiber.flags & 2) continue a;
          if (null === fiber.child || 4 === fiber.tag) continue a;
          else fiber.child.return = fiber, fiber = fiber.child;
        }
        if (!(fiber.flags & 2)) return fiber.stateNode;
      }
    }
    function insertOrAppendPlacementNodeIntoContainer(node, before2, parent) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2)
        node = node.stateNode, before2 ? (warnForReactChildrenConflict(parent), (9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent).insertBefore(node, before2)) : (warnForReactChildrenConflict(parent), before2 = 9 === parent.nodeType ? parent.body : "HTML" === parent.nodeName ? parent.ownerDocument.body : parent, before2.appendChild(node), parent = parent._reactRootContainer, null !== parent && void 0 !== parent || null !== before2.onclick || (before2.onclick = noop$12));
      else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode, before2 = null), node = node.child, null !== node))
        for (insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling; null !== node; )
          insertOrAppendPlacementNodeIntoContainer(node, before2, parent), node = node.sibling;
    }
    function insertOrAppendPlacementNode(node, before2, parent) {
      var tag2 = node.tag;
      if (5 === tag2 || 6 === tag2)
        node = node.stateNode, before2 ? parent.insertBefore(node, before2) : parent.appendChild(node);
      else if (4 !== tag2 && (27 === tag2 && isSingletonScope(node.type) && (parent = node.stateNode), node = node.child, null !== node))
        for (insertOrAppendPlacementNode(node, before2, parent), node = node.sibling; null !== node; )
          insertOrAppendPlacementNode(node, before2, parent), node = node.sibling;
    }
    function commitPlacement(finishedWork) {
      for (var hostParentFiber, parentFiber = finishedWork.return; null !== parentFiber; ) {
        if (isHostParent(parentFiber)) {
          hostParentFiber = parentFiber;
          break;
        }
        parentFiber = parentFiber.return;
      }
      if (null == hostParentFiber)
        throw Error(
          "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
        );
      switch (hostParentFiber.tag) {
        case 27:
          hostParentFiber = hostParentFiber.stateNode;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        case 5:
          parentFiber = hostParentFiber.stateNode;
          hostParentFiber.flags & 32 && (resetTextContent(parentFiber), hostParentFiber.flags &= -33);
          hostParentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNode(
            finishedWork,
            hostParentFiber,
            parentFiber
          );
          break;
        case 3:
        case 4:
          hostParentFiber = hostParentFiber.stateNode.containerInfo;
          parentFiber = getHostSibling(finishedWork);
          insertOrAppendPlacementNodeIntoContainer(
            finishedWork,
            parentFiber,
            hostParentFiber
          );
          break;
        default:
          throw Error(
            "Invalid host parent fiber. This error is likely caused by a bug in React. Please file an issue."
          );
      }
    }
    function commitHostSingletonAcquisition(finishedWork) {
      var singleton = finishedWork.stateNode, props2 = finishedWork.memoizedProps;
      try {
        runWithFiberInDEV(
          finishedWork,
          acquireSingletonInstance,
          finishedWork.type,
          props2,
          singleton,
          finishedWork
        );
      } catch (error) {
        captureCommitPhaseError(finishedWork, finishedWork.return, error);
      }
    }
    function isHydratingParent(current3, finishedWork) {
      return 31 === finishedWork.tag ? (finishedWork = finishedWork.memoizedState, null !== current3.memoizedState && null === finishedWork) : 13 === finishedWork.tag ? (current3 = current3.memoizedState, finishedWork = finishedWork.memoizedState, null !== current3 && null !== current3.dehydrated && (null === finishedWork || null === finishedWork.dehydrated)) : 3 === finishedWork.tag ? current3.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256) : false;
    }
    function commitBeforeMutationEffects(root3, firstChild) {
      root3 = root3.containerInfo;
      eventsEnabled = _enabled;
      root3 = getActiveElementDeep(root3);
      if (hasSelectionCapabilities(root3)) {
        if ("selectionStart" in root3)
          var JSCompiler_temp = {
            start: root3.selectionStart,
            end: root3.selectionEnd
          };
        else
          a: {
            JSCompiler_temp = (JSCompiler_temp = root3.ownerDocument) && JSCompiler_temp.defaultView || window;
            var selection2 = JSCompiler_temp.getSelection && JSCompiler_temp.getSelection();
            if (selection2 && 0 !== selection2.rangeCount) {
              JSCompiler_temp = selection2.anchorNode;
              var anchorOffset = selection2.anchorOffset, focusNode = selection2.focusNode;
              selection2 = selection2.focusOffset;
              try {
                JSCompiler_temp.nodeType, focusNode.nodeType;
              } catch (e$22) {
                JSCompiler_temp = null;
                break a;
              }
              var length = 0, start = -1, end = -1, indexWithinAnchor = 0, indexWithinFocus = 0, node = root3, parentNode = null;
              b: for (; ; ) {
                for (var next; ; ) {
                  node !== JSCompiler_temp || 0 !== anchorOffset && 3 !== node.nodeType || (start = length + anchorOffset);
                  node !== focusNode || 0 !== selection2 && 3 !== node.nodeType || (end = length + selection2);
                  3 === node.nodeType && (length += node.nodeValue.length);
                  if (null === (next = node.firstChild)) break;
                  parentNode = node;
                  node = next;
                }
                for (; ; ) {
                  if (node === root3) break b;
                  parentNode === JSCompiler_temp && ++indexWithinAnchor === anchorOffset && (start = length);
                  parentNode === focusNode && ++indexWithinFocus === selection2 && (end = length);
                  if (null !== (next = node.nextSibling)) break;
                  node = parentNode;
                  parentNode = node.parentNode;
                }
                node = next;
              }
              JSCompiler_temp = -1 === start || -1 === end ? null : { start, end };
            } else JSCompiler_temp = null;
          }
        JSCompiler_temp = JSCompiler_temp || { start: 0, end: 0 };
      } else JSCompiler_temp = null;
      selectionInformation = {
        focusedElem: root3,
        selectionRange: JSCompiler_temp
      };
      _enabled = false;
      for (nextEffect = firstChild; null !== nextEffect; )
        if (firstChild = nextEffect, root3 = firstChild.child, 0 !== (firstChild.subtreeFlags & 1028) && null !== root3)
          root3.return = firstChild, nextEffect = root3;
        else
          for (; null !== nextEffect; ) {
            root3 = firstChild = nextEffect;
            JSCompiler_temp = root3.alternate;
            anchorOffset = root3.flags;
            switch (root3.tag) {
              case 0:
                if (0 !== (anchorOffset & 4) && (root3 = root3.updateQueue, root3 = null !== root3 ? root3.events : null, null !== root3))
                  for (JSCompiler_temp = 0; JSCompiler_temp < root3.length; JSCompiler_temp++)
                    anchorOffset = root3[JSCompiler_temp], anchorOffset.ref.impl = anchorOffset.nextImpl;
                break;
              case 11:
              case 15:
                break;
              case 1:
                0 !== (anchorOffset & 1024) && null !== JSCompiler_temp && commitClassSnapshot(root3, JSCompiler_temp);
                break;
              case 3:
                if (0 !== (anchorOffset & 1024)) {
                  if (root3 = root3.stateNode.containerInfo, JSCompiler_temp = root3.nodeType, 9 === JSCompiler_temp)
                    clearContainerSparingly(root3);
                  else if (1 === JSCompiler_temp)
                    switch (root3.nodeName) {
                      case "HEAD":
                      case "HTML":
                      case "BODY":
                        clearContainerSparingly(root3);
                        break;
                      default:
                        root3.textContent = "";
                    }
                }
                break;
              case 5:
              case 26:
              case 27:
              case 6:
              case 4:
              case 17:
                break;
              default:
                if (0 !== (anchorOffset & 1024))
                  throw Error(
                    "This unit of work tag should not have side-effects. This error is likely caused by a bug in React. Please file an issue."
                  );
            }
            root3 = firstChild.sibling;
            if (null !== root3) {
              root3.return = firstChild.return;
              nextEffect = root3;
              break;
            }
            nextEffect = firstChild.return;
          }
    }
    function commitLayoutEffectOnFiber(finishedRoot, current3, finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitHookLayoutEffects(finishedWork, Layout | HasEffect);
          break;
        case 1:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags & 4)
            if (finishedRoot = finishedWork.stateNode, null === current3)
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidMount. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              )), shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidMountInDEV,
                finishedWork,
                finishedRoot
              );
            else {
              var prevProps = resolveClassComponentProps(
                finishedWork.type,
                current3.memoizedProps
              );
              current3 = current3.memoizedState;
              finishedWork.type.defaultProps || "ref" in finishedWork.memoizedProps || didWarnAboutReassigningProps || (finishedRoot.props !== finishedWork.memoizedProps && console.error(
                "Expected %s props to match memoized props before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.props`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ), finishedRoot.state !== finishedWork.memoizedState && console.error(
                "Expected %s state to match memoized state before componentDidUpdate. This might either be because of a bug in React, or because a component reassigns its own `this.state`. Please file an issue.",
                getComponentNameFromFiber(finishedWork) || "instance"
              ));
              shouldProfile(finishedWork) ? (startEffectTimer(), runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current3,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              ), recordEffectDuration()) : runWithFiberInDEV(
                finishedWork,
                callComponentDidUpdateInDEV,
                finishedWork,
                finishedRoot,
                prevProps,
                current3,
                finishedRoot.__reactInternalSnapshotBeforeUpdate
              );
            }
          flags & 64 && commitClassCallbacks(finishedWork);
          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 3:
          current3 = pushNestedEffectDurations();
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (flags & 64 && (flags = finishedWork.updateQueue, null !== flags)) {
            prevProps = null;
            if (null !== finishedWork.child)
              switch (finishedWork.child.tag) {
                case 27:
                case 5:
                  prevProps = finishedWork.child.stateNode;
                  break;
                case 1:
                  prevProps = finishedWork.child.stateNode;
              }
            try {
              runWithFiberInDEV(
                finishedWork,
                commitCallbacks,
                flags,
                prevProps
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          finishedRoot.effectDuration += popNestedEffectDurations(current3);
          break;
        case 27:
          null === current3 && flags & 4 && commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          if (null === current3) {
            if (flags & 4) commitHostMount(finishedWork);
            else if (flags & 64) {
              finishedRoot = finishedWork.type;
              current3 = finishedWork.memoizedProps;
              prevProps = finishedWork.stateNode;
              try {
                runWithFiberInDEV(
                  finishedWork,
                  commitHydratedInstance,
                  prevProps,
                  finishedRoot,
                  current3,
                  finishedWork
                );
              } catch (error) {
                captureCommitPhaseError(
                  finishedWork,
                  finishedWork.return,
                  error
                );
              }
            }
          }
          flags & 512 && safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (flags & 4) {
            flags = pushNestedEffectDurations();
            recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            finishedRoot = finishedWork.stateNode;
            finishedRoot.effectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current3,
                commitStartTime,
                finishedRoot.effectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          break;
        case 31:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
          flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          flags & 64 && (finishedRoot = finishedWork.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot && (flags = retryDehydratedSuspenseBoundary.bind(
            null,
            finishedWork
          ), registerSuspenseInstanceRetry(finishedRoot, flags))));
          break;
        case 22:
          flags = null !== finishedWork.memoizedState || offscreenSubtreeIsHidden;
          if (!flags) {
            current3 = null !== current3 && null !== current3.memoizedState || offscreenSubtreeWasHidden;
            prevProps = offscreenSubtreeIsHidden;
            var prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
            offscreenSubtreeIsHidden = flags;
            (offscreenSubtreeWasHidden = current3) && !prevOffscreenSubtreeWasHidden ? (recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              0 !== (finishedWork.subtreeFlags & 8772)
            ), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
              finishedWork,
              componentEffectStartTime,
              componentEffectEndTime
            )) : recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
            offscreenSubtreeIsHidden = prevProps;
            offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          }
          break;
        case 30:
          break;
        default:
          recursivelyTraverseLayoutEffects(finishedRoot, finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      ), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(
        finishedWork.return.alternate,
        finishedWork.return
      ) || logComponentTrigger(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        "Mount"
      )));
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function detachFiberAfterEffects(fiber) {
      var alternate = fiber.alternate;
      null !== alternate && (fiber.alternate = null, detachFiberAfterEffects(alternate));
      fiber.child = null;
      fiber.deletions = null;
      fiber.sibling = null;
      5 === fiber.tag && (alternate = fiber.stateNode, null !== alternate && detachDeletedInstance(alternate));
      fiber.stateNode = null;
      fiber._debugOwner = null;
      fiber.return = null;
      fiber.dependencies = null;
      fiber.memoizedProps = null;
      fiber.memoizedState = null;
      fiber.pendingProps = null;
      fiber.stateNode = null;
      fiber.updateQueue = null;
    }
    function recursivelyTraverseDeletionEffects(finishedRoot, nearestMountedAncestor, parent) {
      for (parent = parent.child; null !== parent; )
        commitDeletionEffectsOnFiber(
          finishedRoot,
          nearestMountedAncestor,
          parent
        ), parent = parent.sibling;
    }
    function commitDeletionEffectsOnFiber(finishedRoot, nearestMountedAncestor, deletedFiber) {
      if (injectedHook && "function" === typeof injectedHook.onCommitFiberUnmount)
        try {
          injectedHook.onCommitFiberUnmount(rendererID, deletedFiber);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (deletedFiber.tag) {
        case 26:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          deletedFiber.memoizedState ? deletedFiber.memoizedState.count-- : deletedFiber.stateNode && (finishedRoot = deletedFiber.stateNode, finishedRoot.parentNode.removeChild(finishedRoot));
          break;
        case 27:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
          var prevHostParent = hostParent, prevHostParentIsContainer = hostParentIsContainer;
          isSingletonScope(deletedFiber.type) && (hostParent = deletedFiber.stateNode, hostParentIsContainer = false);
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          runWithFiberInDEV(
            deletedFiber,
            releaseSingletonInstance,
            deletedFiber.stateNode
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 5:
          offscreenSubtreeWasHidden || safelyDetachRef(deletedFiber, nearestMountedAncestor);
        case 6:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = null;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          if (null !== hostParent)
            if (hostParentIsContainer)
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChildFromContainer,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error
                );
              }
            else
              try {
                runWithFiberInDEV(
                  deletedFiber,
                  removeChild,
                  hostParent,
                  deletedFiber.stateNode
                );
              } catch (error) {
                captureCommitPhaseError(
                  deletedFiber,
                  nearestMountedAncestor,
                  error
                );
              }
          break;
        case 18:
          null !== hostParent && (hostParentIsContainer ? (finishedRoot = hostParent, clearHydrationBoundary(
            9 === finishedRoot.nodeType ? finishedRoot.body : "HTML" === finishedRoot.nodeName ? finishedRoot.ownerDocument.body : finishedRoot,
            deletedFiber.stateNode
          ), retryIfBlockedOn(finishedRoot)) : clearHydrationBoundary(hostParent, deletedFiber.stateNode));
          break;
        case 4:
          prevHostParent = hostParent;
          prevHostParentIsContainer = hostParentIsContainer;
          hostParent = deletedFiber.stateNode.containerInfo;
          hostParentIsContainer = true;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          hostParent = prevHostParent;
          hostParentIsContainer = prevHostParentIsContainer;
          break;
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookEffectListUnmount(
            Insertion,
            deletedFiber,
            nearestMountedAncestor
          );
          offscreenSubtreeWasHidden || commitHookLayoutUnmountEffects(
            deletedFiber,
            nearestMountedAncestor,
            Layout
          );
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 1:
          offscreenSubtreeWasHidden || (safelyDetachRef(deletedFiber, nearestMountedAncestor), prevHostParent = deletedFiber.stateNode, "function" === typeof prevHostParent.componentWillUnmount && safelyCallComponentWillUnmount(
            deletedFiber,
            nearestMountedAncestor,
            prevHostParent
          ));
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 21:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          break;
        case 22:
          offscreenSubtreeWasHidden = (prevHostParent = offscreenSubtreeWasHidden) || null !== deletedFiber.memoizedState;
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
          offscreenSubtreeWasHidden = prevHostParent;
          break;
        default:
          recursivelyTraverseDeletionEffects(
            finishedRoot,
            nearestMountedAncestor,
            deletedFiber
          );
      }
      (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        deletedFiber,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitActivityHydrationCallbacks(finishedRoot, finishedWork) {
      if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot))) {
        finishedRoot = finishedRoot.dehydrated;
        try {
          runWithFiberInDEV(
            finishedWork,
            commitHydratedActivityInstance,
            finishedRoot
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }
    function commitSuspenseHydrationCallbacks(finishedRoot, finishedWork) {
      if (null === finishedWork.memoizedState && (finishedRoot = finishedWork.alternate, null !== finishedRoot && (finishedRoot = finishedRoot.memoizedState, null !== finishedRoot && (finishedRoot = finishedRoot.dehydrated, null !== finishedRoot))))
        try {
          runWithFiberInDEV(
            finishedWork,
            commitHydratedSuspenseInstance,
            finishedRoot
          );
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
    }
    function getRetryCache(finishedWork) {
      switch (finishedWork.tag) {
        case 31:
        case 13:
        case 19:
          var retryCache = finishedWork.stateNode;
          null === retryCache && (retryCache = finishedWork.stateNode = new PossiblyWeakSet());
          return retryCache;
        case 22:
          return finishedWork = finishedWork.stateNode, retryCache = finishedWork._retryCache, null === retryCache && (retryCache = finishedWork._retryCache = new PossiblyWeakSet()), retryCache;
        default:
          throw Error(
            "Unexpected Suspense handler tag (" + finishedWork.tag + "). This is a bug in React."
          );
      }
    }
    function attachSuspenseRetryListeners(finishedWork, wakeables) {
      var retryCache = getRetryCache(finishedWork);
      wakeables.forEach(function(wakeable) {
        if (!retryCache.has(wakeable)) {
          retryCache.add(wakeable);
          if (isDevToolsPresent)
            if (null !== inProgressLanes && null !== inProgressRoot)
              restorePendingUpdaters(inProgressRoot, inProgressLanes);
            else
              throw Error(
                "Expected finished root and lanes to be set. This is a bug in React."
              );
          var retry = resolveRetryWakeable.bind(null, finishedWork, wakeable);
          wakeable.then(retry, retry);
        }
      });
    }
    function recursivelyTraverseMutationEffects(root$jscomp$0, parentFiber) {
      var deletions = parentFiber.deletions;
      if (null !== deletions)
        for (var i2 = 0; i2 < deletions.length; i2++) {
          var root3 = root$jscomp$0, returnFiber = parentFiber, deletedFiber = deletions[i2], prevEffectStart = pushComponentEffectStart(), parent = returnFiber;
          a: for (; null !== parent; ) {
            switch (parent.tag) {
              case 27:
                if (isSingletonScope(parent.type)) {
                  hostParent = parent.stateNode;
                  hostParentIsContainer = false;
                  break a;
                }
                break;
              case 5:
                hostParent = parent.stateNode;
                hostParentIsContainer = false;
                break a;
              case 3:
              case 4:
                hostParent = parent.stateNode.containerInfo;
                hostParentIsContainer = true;
                break a;
            }
            parent = parent.return;
          }
          if (null === hostParent)
            throw Error(
              "Expected to find a host parent. This error is likely caused by a bug in React. Please file an issue."
            );
          commitDeletionEffectsOnFiber(root3, returnFiber, deletedFiber);
          hostParent = null;
          hostParentIsContainer = false;
          (deletedFiber.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
            deletedFiber,
            componentEffectStartTime,
            componentEffectEndTime,
            "Unmount"
          );
          popComponentEffectStart(prevEffectStart);
          root3 = deletedFiber;
          returnFiber = root3.alternate;
          null !== returnFiber && (returnFiber.return = null);
          root3.return = null;
        }
      if (parentFiber.subtreeFlags & 13886)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitMutationEffectsOnFiber(parentFiber, root$jscomp$0), parentFiber = parentFiber.sibling;
    }
    function commitMutationEffectsOnFiber(finishedWork, root3) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), current3 = finishedWork.alternate, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (commitHookEffectListUnmount(
            Insertion | HasEffect,
            finishedWork,
            finishedWork.return
          ), commitHookEffectListMount(Insertion | HasEffect, finishedWork), commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout | HasEffect
          ));
          break;
        case 1:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (flags & 64 && offscreenSubtreeIsHidden && (flags = finishedWork.updateQueue, null !== flags && (current3 = flags.callbacks, null !== current3))) {
            var existingHiddenCallbacks = flags.shared.hiddenCallbacks;
            flags.shared.hiddenCallbacks = null === existingHiddenCallbacks ? current3 : existingHiddenCallbacks.concat(current3);
          }
          break;
        case 26:
          existingHiddenCallbacks = currentHoistableRoot;
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (flags & 4) {
            var currentResource = null !== current3 ? current3.memoizedState : null;
            flags = finishedWork.memoizedState;
            if (null === current3)
              if (null === flags)
                if (null === finishedWork.stateNode) {
                  a: {
                    flags = finishedWork.type;
                    current3 = finishedWork.memoizedProps;
                    existingHiddenCallbacks = existingHiddenCallbacks.ownerDocument || existingHiddenCallbacks;
                    b: switch (flags) {
                      case "title":
                        currentResource = existingHiddenCallbacks.getElementsByTagName(
                          "title"
                        )[0];
                        if (!currentResource || currentResource[internalHoistableMarker] || currentResource[internalInstanceKey] || currentResource.namespaceURI === SVG_NAMESPACE || currentResource.hasAttribute("itemprop"))
                          currentResource = existingHiddenCallbacks.createElement(flags), existingHiddenCallbacks.head.insertBefore(
                            currentResource,
                            existingHiddenCallbacks.querySelector(
                              "head > title"
                            )
                          );
                        setInitialProperties(currentResource, flags, current3);
                        currentResource[internalInstanceKey] = finishedWork;
                        markNodeAsHoistable(currentResource);
                        flags = currentResource;
                        break a;
                      case "link":
                        var maybeNodes = getHydratableHoistableCache(
                          "link",
                          "href",
                          existingHiddenCallbacks
                        ).get(flags + (current3.href || ""));
                        if (maybeNodes) {
                          for (var i2 = 0; i2 < maybeNodes.length; i2++)
                            if (currentResource = maybeNodes[i2], currentResource.getAttribute("href") === (null == current3.href || "" === current3.href ? null : current3.href) && currentResource.getAttribute("rel") === (null == current3.rel ? null : current3.rel) && currentResource.getAttribute("title") === (null == current3.title ? null : current3.title) && currentResource.getAttribute("crossorigin") === (null == current3.crossOrigin ? null : current3.crossOrigin)) {
                              maybeNodes.splice(i2, 1);
                              break b;
                            }
                        }
                        currentResource = existingHiddenCallbacks.createElement(flags);
                        setInitialProperties(currentResource, flags, current3);
                        existingHiddenCallbacks.head.appendChild(
                          currentResource
                        );
                        break;
                      case "meta":
                        if (maybeNodes = getHydratableHoistableCache(
                          "meta",
                          "content",
                          existingHiddenCallbacks
                        ).get(flags + (current3.content || ""))) {
                          for (i2 = 0; i2 < maybeNodes.length; i2++)
                            if (currentResource = maybeNodes[i2], checkAttributeStringCoercion(
                              current3.content,
                              "content"
                            ), currentResource.getAttribute("content") === (null == current3.content ? null : "" + current3.content) && currentResource.getAttribute("name") === (null == current3.name ? null : current3.name) && currentResource.getAttribute("property") === (null == current3.property ? null : current3.property) && currentResource.getAttribute("http-equiv") === (null == current3.httpEquiv ? null : current3.httpEquiv) && currentResource.getAttribute("charset") === (null == current3.charSet ? null : current3.charSet)) {
                              maybeNodes.splice(i2, 1);
                              break b;
                            }
                        }
                        currentResource = existingHiddenCallbacks.createElement(flags);
                        setInitialProperties(currentResource, flags, current3);
                        existingHiddenCallbacks.head.appendChild(
                          currentResource
                        );
                        break;
                      default:
                        throw Error(
                          'getNodesForType encountered a type it did not expect: "' + flags + '". This is a bug in React.'
                        );
                    }
                    currentResource[internalInstanceKey] = finishedWork;
                    markNodeAsHoistable(currentResource);
                    flags = currentResource;
                  }
                  finishedWork.stateNode = flags;
                } else
                  mountHoistable(
                    existingHiddenCallbacks,
                    finishedWork.type,
                    finishedWork.stateNode
                  );
              else
                finishedWork.stateNode = acquireResource(
                  existingHiddenCallbacks,
                  flags,
                  finishedWork.memoizedProps
                );
            else
              currentResource !== flags ? (null === currentResource ? null !== current3.stateNode && (current3 = current3.stateNode, current3.parentNode.removeChild(current3)) : currentResource.count--, null === flags ? mountHoistable(
                existingHiddenCallbacks,
                finishedWork.type,
                finishedWork.stateNode
              ) : acquireResource(
                existingHiddenCallbacks,
                flags,
                finishedWork.memoizedProps
              )) : null === flags && null !== finishedWork.stateNode && commitHostUpdate(
                finishedWork,
                finishedWork.memoizedProps,
                current3.memoizedProps
              );
          }
          break;
        case 27:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          null !== current3 && flags & 4 && commitHostUpdate(
            finishedWork,
            finishedWork.memoizedProps,
            current3.memoizedProps
          );
          break;
        case 5:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 512 && (offscreenSubtreeWasHidden || null === current3 || safelyDetachRef(current3, current3.return));
          if (finishedWork.flags & 32) {
            existingHiddenCallbacks = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                resetTextContent,
                existingHiddenCallbacks
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          flags & 4 && null != finishedWork.stateNode && (existingHiddenCallbacks = finishedWork.memoizedProps, commitHostUpdate(
            finishedWork,
            existingHiddenCallbacks,
            null !== current3 ? current3.memoizedProps : existingHiddenCallbacks
          ));
          flags & 1024 && (needsFormReset = true, "form" !== finishedWork.type && console.error(
            "Unexpected host component type. Expected a form. This is a bug in React."
          ));
          break;
        case 6:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          if (flags & 4) {
            if (null === finishedWork.stateNode)
              throw Error(
                "This should have a text node initialized. This error is likely caused by a bug in React. Please file an issue."
              );
            flags = finishedWork.memoizedProps;
            current3 = null !== current3 ? current3.memoizedProps : flags;
            existingHiddenCallbacks = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitTextUpdate,
                existingHiddenCallbacks,
                current3,
                flags
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          break;
        case 3:
          existingHiddenCallbacks = pushNestedEffectDurations();
          tagCaches = null;
          currentResource = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(root3.containerInfo);
          recursivelyTraverseMutationEffects(root3, finishedWork);
          currentHoistableRoot = currentResource;
          commitReconciliationEffects(finishedWork);
          if (flags & 4 && null !== current3 && current3.memoizedState.isDehydrated)
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHydratedContainer,
                root3.containerInfo
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          needsFormReset && (needsFormReset = false, recursivelyResetForms(finishedWork));
          root3.effectDuration += popNestedEffectDurations(
            existingHiddenCallbacks
          );
          break;
        case 4:
          flags = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            finishedWork.stateNode.containerInfo
          );
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          currentHoistableRoot = flags;
          break;
        case 12:
          flags = pushNestedEffectDurations();
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.stateNode.effectDuration += bubbleNestedEffectDurations(flags);
          break;
        case 31:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 13:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          finishedWork.child.flags & 8192 && null !== finishedWork.memoizedState !== (null !== current3 && null !== current3.memoizedState) && (globalMostRecentFallbackTime = now$1());
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 22:
          existingHiddenCallbacks = null !== finishedWork.memoizedState;
          var wasHidden = null !== current3 && null !== current3.memoizedState, prevOffscreenSubtreeIsHidden = offscreenSubtreeIsHidden, prevOffscreenSubtreeWasHidden = offscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden || existingHiddenCallbacks;
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden || wasHidden;
          recursivelyTraverseMutationEffects(root3, finishedWork);
          offscreenSubtreeWasHidden = prevOffscreenSubtreeWasHidden;
          offscreenSubtreeIsHidden = prevOffscreenSubtreeIsHidden;
          wasHidden && !existingHiddenCallbacks && !prevOffscreenSubtreeIsHidden && !prevOffscreenSubtreeWasHidden && (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime
          );
          commitReconciliationEffects(finishedWork);
          if (flags & 8192)
            a: for (root3 = finishedWork.stateNode, root3._visibility = existingHiddenCallbacks ? root3._visibility & ~OffscreenVisible : root3._visibility | OffscreenVisible, !existingHiddenCallbacks || null === current3 || wasHidden || offscreenSubtreeIsHidden || offscreenSubtreeWasHidden || (recursivelyTraverseDisappearLayoutEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              finishedWork,
              componentEffectStartTime,
              componentEffectEndTime,
              "Disconnect"
            )), current3 = null, root3 = finishedWork; ; ) {
              if (5 === root3.tag || 26 === root3.tag) {
                if (null === current3) {
                  wasHidden = current3 = root3;
                  try {
                    currentResource = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideInstance,
                      currentResource
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideInstance,
                      wasHidden.stateNode,
                      wasHidden.memoizedProps
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if (6 === root3.tag) {
                if (null === current3) {
                  wasHidden = root3;
                  try {
                    maybeNodes = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideTextInstance,
                      maybeNodes
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideTextInstance,
                      maybeNodes,
                      wasHidden.memoizedProps
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if (18 === root3.tag) {
                if (null === current3) {
                  wasHidden = root3;
                  try {
                    i2 = wasHidden.stateNode, existingHiddenCallbacks ? runWithFiberInDEV(
                      wasHidden,
                      hideDehydratedBoundary,
                      i2
                    ) : runWithFiberInDEV(
                      wasHidden,
                      unhideDehydratedBoundary,
                      wasHidden.stateNode
                    );
                  } catch (error) {
                    captureCommitPhaseError(wasHidden, wasHidden.return, error);
                  }
                }
              } else if ((22 !== root3.tag && 23 !== root3.tag || null === root3.memoizedState || root3 === finishedWork) && null !== root3.child) {
                root3.child.return = root3;
                root3 = root3.child;
                continue;
              }
              if (root3 === finishedWork) break a;
              for (; null === root3.sibling; ) {
                if (null === root3.return || root3.return === finishedWork)
                  break a;
                current3 === root3 && (current3 = null);
                root3 = root3.return;
              }
              current3 === root3 && (current3 = null);
              root3.sibling.return = root3.return;
              root3 = root3.sibling;
            }
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (current3 = flags.retryQueue, null !== current3 && (flags.retryQueue = null, attachSuspenseRetryListeners(finishedWork, current3))));
          break;
        case 19:
          recursivelyTraverseMutationEffects(root3, finishedWork);
          commitReconciliationEffects(finishedWork);
          flags & 4 && (flags = finishedWork.updateQueue, null !== flags && (finishedWork.updateQueue = null, attachSuspenseRetryListeners(finishedWork, flags)));
          break;
        case 30:
          break;
        case 21:
          break;
        default:
          recursivelyTraverseMutationEffects(root3, finishedWork), commitReconciliationEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      ), null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate && 0.05 < componentEffectEndTime - componentEffectStartTime && (isHydratingParent(
        finishedWork.return.alternate,
        finishedWork.return
      ) || logComponentTrigger(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        "Mount"
      )));
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function commitReconciliationEffects(finishedWork) {
      var flags = finishedWork.flags;
      if (flags & 2) {
        try {
          runWithFiberInDEV(finishedWork, commitPlacement, finishedWork);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
        finishedWork.flags &= -3;
      }
      flags & 4096 && (finishedWork.flags &= -4097);
    }
    function recursivelyResetForms(parentFiber) {
      if (parentFiber.subtreeFlags & 1024)
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var fiber = parentFiber;
          recursivelyResetForms(fiber);
          5 === fiber.tag && fiber.flags & 1024 && fiber.stateNode.reset();
          parentFiber = parentFiber.sibling;
        }
    }
    function recursivelyTraverseLayoutEffects(root3, parentFiber) {
      if (parentFiber.subtreeFlags & 8772)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitLayoutEffectOnFiber(root3, parentFiber.alternate, parentFiber), parentFiber = parentFiber.sibling;
    }
    function disappearLayoutEffects(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 14:
        case 15:
          commitHookLayoutUnmountEffects(
            finishedWork,
            finishedWork.return,
            Layout
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 1:
          safelyDetachRef(finishedWork, finishedWork.return);
          var instance = finishedWork.stateNode;
          "function" === typeof instance.componentWillUnmount && safelyCallComponentWillUnmount(
            finishedWork,
            finishedWork.return,
            instance
          );
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 27:
          runWithFiberInDEV(
            finishedWork,
            releaseSingletonInstance,
            finishedWork.stateNode
          );
        case 26:
        case 5:
          safelyDetachRef(finishedWork, finishedWork.return);
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        case 30:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
          break;
        default:
          recursivelyTraverseDisappearLayoutEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseDisappearLayoutEffects(parentFiber) {
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disappearLayoutEffects(parentFiber), parentFiber = parentFiber.sibling;
    }
    function reappearLayoutEffects(finishedRoot, current3, finishedWork, includeWorkInProgressEffects) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          commitHookLayoutEffects(finishedWork, Layout);
          break;
        case 1:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          current3 = finishedWork.stateNode;
          "function" === typeof current3.componentDidMount && runWithFiberInDEV(
            finishedWork,
            callComponentDidMountInDEV,
            finishedWork,
            current3
          );
          current3 = finishedWork.updateQueue;
          if (null !== current3) {
            finishedRoot = finishedWork.stateNode;
            try {
              runWithFiberInDEV(
                finishedWork,
                commitHiddenCallbacks,
                current3,
                finishedRoot
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          }
          includeWorkInProgressEffects && flags & 64 && commitClassCallbacks(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 27:
          commitHostSingletonAcquisition(finishedWork);
        case 26:
        case 5:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && null === current3 && flags & 4 && commitHostMount(finishedWork);
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 12:
          if (includeWorkInProgressEffects && flags & 4) {
            flags = pushNestedEffectDurations();
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
            includeWorkInProgressEffects = finishedWork.stateNode;
            includeWorkInProgressEffects.effectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfiler,
                finishedWork,
                current3,
                commitStartTime,
                includeWorkInProgressEffects.effectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else
            recursivelyTraverseReappearLayoutEffects(
              finishedRoot,
              finishedWork,
              includeWorkInProgressEffects
            );
          break;
        case 31:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitActivityHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 13:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          includeWorkInProgressEffects && flags & 4 && commitSuspenseHydrationCallbacks(finishedRoot, finishedWork);
          break;
        case 22:
          null === finishedWork.memoizedState && recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
          safelyAttachRef(finishedWork, finishedWork.return);
          break;
        case 30:
          break;
        default:
          recursivelyTraverseReappearLayoutEffects(
            finishedRoot,
            finishedWork,
            includeWorkInProgressEffects
          );
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
    }
    function recursivelyTraverseReappearLayoutEffects(finishedRoot, parentFiber, includeWorkInProgressEffects) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && 0 !== (parentFiber.subtreeFlags & 8772);
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        reappearLayoutEffects(
          finishedRoot,
          parentFiber.alternate,
          parentFiber,
          includeWorkInProgressEffects
        ), parentFiber = parentFiber.sibling;
    }
    function commitOffscreenPassiveMountEffects(current3, finishedWork) {
      var previousCache = null;
      null !== current3 && null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (previousCache = current3.memoizedState.cachePool.pool);
      current3 = null;
      null !== finishedWork.memoizedState && null !== finishedWork.memoizedState.cachePool && (current3 = finishedWork.memoizedState.cachePool.pool);
      current3 !== previousCache && (null != current3 && retainCache(current3), null != previousCache && releaseCache(previousCache));
    }
    function commitCachePassiveMountEffect(current3, finishedWork) {
      current3 = null;
      null !== finishedWork.alternate && (current3 = finishedWork.alternate.memoizedState.cache);
      finishedWork = finishedWork.memoizedState.cache;
      finishedWork !== current3 && (retainCache(finishedWork), null != current3 && releaseCache(current3));
    }
    function recursivelyTraversePassiveMountEffects(root3, parentFiber, committedLanes, committedTransitions, endTime) {
      if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child))
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var nextSibling = parentFiber.sibling;
          commitPassiveMountOnFiber(
            root3,
            parentFiber,
            committedLanes,
            committedTransitions,
            null !== nextSibling ? nextSibling.actualStartTime : endTime
          );
          parentFiber = nextSibling;
        }
    }
    function commitPassiveMountOnFiber(finishedRoot, finishedWork, committedLanes, committedTransitions, endTime) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality, flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          );
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          flags & 2048 && commitHookPassiveMountEffects(finishedWork, Passive | HasEffect);
          break;
        case 1:
          (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && (0 !== (finishedWork.flags & 128) ? logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            []
          ) : 0 !== (finishedWork.flags & 1) && logComponentRender(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          ));
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          break;
        case 3:
          var prevProfilerEffectDuration = pushNestedEffectDurations(), wasInHydratedSubtree = inHydratedSubtree;
          inHydratedSubtree = null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 === (finishedWork.flags & 256);
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = wasInHydratedSubtree;
          flags & 2048 && (committedLanes = null, null !== finishedWork.alternate && (committedLanes = finishedWork.alternate.memoizedState.cache), committedTransitions = finishedWork.memoizedState.cache, committedTransitions !== committedLanes && (retainCache(committedTransitions), null != committedLanes && releaseCache(committedLanes)));
          finishedRoot.passiveEffectDuration += popNestedEffectDurations(
            prevProfilerEffectDuration
          );
          break;
        case 12:
          if (flags & 2048) {
            flags = pushNestedEffectDurations();
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              endTime
            );
            finishedRoot = finishedWork.stateNode;
            finishedRoot.passiveEffectDuration += bubbleNestedEffectDurations(flags);
            try {
              runWithFiberInDEV(
                finishedWork,
                commitProfilerPostCommitImpl,
                finishedWork,
                finishedWork.alternate,
                commitStartTime,
                finishedRoot.passiveEffectDuration
              );
            } catch (error) {
              captureCommitPhaseError(finishedWork, finishedWork.return, error);
            }
          } else
            recursivelyTraversePassiveMountEffects(
              finishedRoot,
              finishedWork,
              committedLanes,
              committedTransitions,
              endTime
            );
          break;
        case 31:
          flags = inHydratedSubtree;
          prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
          wasInHydratedSubtree = finishedWork.memoizedState;
          null !== prevProfilerEffectDuration && null === wasInHydratedSubtree ? (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = false, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            prevProfilerEffectDuration
          )) : inHydratedSubtree = true) : inHydratedSubtree = false;
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = flags;
          break;
        case 13:
          flags = inHydratedSubtree;
          prevProfilerEffectDuration = null !== finishedWork.alternate ? finishedWork.alternate.memoizedState : null;
          wasInHydratedSubtree = finishedWork.memoizedState;
          null === prevProfilerEffectDuration || null === prevProfilerEffectDuration.dehydrated || null !== wasInHydratedSubtree && null !== wasInHydratedSubtree.dehydrated ? inHydratedSubtree = false : (wasInHydratedSubtree = finishedWork.deletions, null !== wasInHydratedSubtree && 0 < wasInHydratedSubtree.length && 18 === wasInHydratedSubtree[0].tag ? (inHydratedSubtree = false, prevProfilerEffectDuration = prevProfilerEffectDuration.hydrationErrors, null !== prevProfilerEffectDuration && logComponentErrored(
            finishedWork,
            finishedWork.actualStartTime,
            endTime,
            prevProfilerEffectDuration
          )) : inHydratedSubtree = true);
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          inHydratedSubtree = flags;
          break;
        case 23:
          break;
        case 22:
          wasInHydratedSubtree = finishedWork.stateNode;
          prevProfilerEffectDuration = finishedWork.alternate;
          null !== finishedWork.memoizedState ? wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : wasInHydratedSubtree._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : (wasInHydratedSubtree._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            0 !== (finishedWork.subtreeFlags & 10256) || 0 !== finishedWork.actualDuration && (null === finishedWork.alternate || finishedWork.alternate.child !== finishedWork.child),
            endTime
          ), (finishedWork.mode & ProfileMode) === NoMode || inHydratedSubtree || (finishedRoot = finishedWork.actualStartTime, 0 <= finishedRoot && 0.05 < endTime - finishedRoot && logComponentReappeared(finishedWork, finishedRoot, endTime), 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentReappeared(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime
          )));
          flags & 2048 && commitOffscreenPassiveMountEffects(
            prevProfilerEffectDuration,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
          flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraversePassiveMountEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          );
      }
      if ((finishedWork.mode & ProfileMode) !== NoMode) {
        if (finishedRoot = !inHydratedSubtree && null === finishedWork.alternate && null !== finishedWork.return && null !== finishedWork.return.alternate)
          committedLanes = finishedWork.actualStartTime, 0 <= committedLanes && 0.05 < endTime - committedLanes && logComponentTrigger(
            finishedWork,
            committedLanes,
            endTime,
            "Mount"
          );
        0 <= componentEffectStartTime && 0 <= componentEffectEndTime && ((componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
          finishedWork,
          componentEffectStartTime,
          componentEffectEndTime,
          componentEffectDuration,
          componentEffectErrors
        ), finishedRoot && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
          finishedWork,
          componentEffectStartTime,
          componentEffectEndTime,
          "Mount"
        ));
      }
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseReconnectPassiveEffects(finishedRoot, parentFiber, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
      includeWorkInProgressEffects = includeWorkInProgressEffects && (0 !== (parentFiber.subtreeFlags & 10256) || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child));
      for (parentFiber = parentFiber.child; null !== parentFiber; ) {
        var nextSibling = parentFiber.sibling;
        reconnectPassiveEffects(
          finishedRoot,
          parentFiber,
          committedLanes,
          committedTransitions,
          includeWorkInProgressEffects,
          null !== nextSibling ? nextSibling.actualStartTime : endTime
        );
        parentFiber = nextSibling;
      }
    }
    function reconnectPassiveEffects(finishedRoot, finishedWork, committedLanes, committedTransitions, includeWorkInProgressEffects, endTime) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate(), prevDeepEquality = alreadyWarnedForDeepEquality;
      includeWorkInProgressEffects && (finishedWork.mode & ProfileMode) !== NoMode && 0 < finishedWork.actualStartTime && 0 !== (finishedWork.flags & 1) && logComponentRender(
        finishedWork,
        finishedWork.actualStartTime,
        endTime,
        inHydratedSubtree,
        committedLanes
      );
      var flags = finishedWork.flags;
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
          commitHookPassiveMountEffects(finishedWork, Passive);
          break;
        case 23:
          break;
        case 22:
          var _instance2 = finishedWork.stateNode;
          null !== finishedWork.memoizedState ? _instance2._visibility & OffscreenPassiveEffectsConnected ? recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          ) : recursivelyTraverseAtomicPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            endTime
          ) : (_instance2._visibility |= OffscreenPassiveEffectsConnected, recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          ));
          includeWorkInProgressEffects && flags & 2048 && commitOffscreenPassiveMountEffects(
            finishedWork.alternate,
            finishedWork
          );
          break;
        case 24:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
          includeWorkInProgressEffects && flags & 2048 && commitCachePassiveMountEffect(finishedWork.alternate, finishedWork);
          break;
        default:
          recursivelyTraverseReconnectPassiveEffects(
            finishedRoot,
            finishedWork,
            committedLanes,
            committedTransitions,
            includeWorkInProgressEffects,
            endTime
          );
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectErrors = prevEffectErrors;
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      alreadyWarnedForDeepEquality = prevDeepEquality;
    }
    function recursivelyTraverseAtomicPassiveEffects(finishedRoot$jscomp$0, parentFiber, committedLanes$jscomp$0, committedTransitions$jscomp$0, endTime$jscomp$0) {
      if (parentFiber.subtreeFlags & 10256 || 0 !== parentFiber.actualDuration && (null === parentFiber.alternate || parentFiber.alternate.child !== parentFiber.child))
        for (var child = parentFiber.child; null !== child; ) {
          parentFiber = child.sibling;
          var finishedRoot = finishedRoot$jscomp$0, committedLanes = committedLanes$jscomp$0, committedTransitions = committedTransitions$jscomp$0, endTime = null !== parentFiber ? parentFiber.actualStartTime : endTime$jscomp$0, prevDeepEquality = alreadyWarnedForDeepEquality;
          (child.mode & ProfileMode) !== NoMode && 0 < child.actualStartTime && 0 !== (child.flags & 1) && logComponentRender(
            child,
            child.actualStartTime,
            endTime,
            inHydratedSubtree,
            committedLanes
          );
          var flags = child.flags;
          switch (child.tag) {
            case 22:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
              flags & 2048 && commitOffscreenPassiveMountEffects(child.alternate, child);
              break;
            case 24:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
              flags & 2048 && commitCachePassiveMountEffect(child.alternate, child);
              break;
            default:
              recursivelyTraverseAtomicPassiveEffects(
                finishedRoot,
                child,
                committedLanes,
                committedTransitions,
                endTime
              );
          }
          alreadyWarnedForDeepEquality = prevDeepEquality;
          child = parentFiber;
        }
    }
    function recursivelyAccumulateSuspenseyCommit(parentFiber, committedLanes, suspendedState) {
      if (parentFiber.subtreeFlags & suspenseyCommitFlag)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          accumulateSuspenseyCommitOnFiber(
            parentFiber,
            committedLanes,
            suspendedState
          ), parentFiber = parentFiber.sibling;
    }
    function accumulateSuspenseyCommitOnFiber(fiber, committedLanes, suspendedState) {
      switch (fiber.tag) {
        case 26:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          fiber.flags & suspenseyCommitFlag && null !== fiber.memoizedState && suspendResource(
            suspendedState,
            currentHoistableRoot,
            fiber.memoizedState,
            fiber.memoizedProps
          );
          break;
        case 5:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          break;
        case 3:
        case 4:
          var previousHoistableRoot = currentHoistableRoot;
          currentHoistableRoot = getHoistableRoot(
            fiber.stateNode.containerInfo
          );
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
          currentHoistableRoot = previousHoistableRoot;
          break;
        case 22:
          null === fiber.memoizedState && (previousHoistableRoot = fiber.alternate, null !== previousHoistableRoot && null !== previousHoistableRoot.memoizedState ? (previousHoistableRoot = suspenseyCommitFlag, suspenseyCommitFlag = 16777216, recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          ), suspenseyCommitFlag = previousHoistableRoot) : recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          ));
          break;
        default:
          recursivelyAccumulateSuspenseyCommit(
            fiber,
            committedLanes,
            suspendedState
          );
      }
    }
    function detachAlternateSiblings(parentFiber) {
      var previousFiber = parentFiber.alternate;
      if (null !== previousFiber && (parentFiber = previousFiber.child, null !== parentFiber)) {
        previousFiber.child = null;
        do
          previousFiber = parentFiber.sibling, parentFiber.sibling = null, parentFiber = previousFiber;
        while (null !== parentFiber);
      }
    }
    function recursivelyTraversePassiveUnmountEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i2 = 0; i2 < deletions.length; i2++) {
            var childToDelete = deletions[i2], prevEffectStart = pushComponentEffectStart();
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
            (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              childToDelete,
              componentEffectStartTime,
              componentEffectEndTime,
              "Unmount"
            );
            popComponentEffectStart(prevEffectStart);
          }
        detachAlternateSiblings(parentFiber);
      }
      if (parentFiber.subtreeFlags & 10256)
        for (parentFiber = parentFiber.child; null !== parentFiber; )
          commitPassiveUnmountOnFiber(parentFiber), parentFiber = parentFiber.sibling;
    }
    function commitPassiveUnmountOnFiber(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.flags & 2048 && commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive | HasEffect
          );
          break;
        case 3:
          var prevProfilerEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += popNestedEffectDurations(prevProfilerEffectDuration);
          break;
        case 12:
          prevProfilerEffectDuration = pushNestedEffectDurations();
          recursivelyTraversePassiveUnmountEffects(finishedWork);
          finishedWork.stateNode.passiveEffectDuration += bubbleNestedEffectDurations(prevProfilerEffectDuration);
          break;
        case 22:
          prevProfilerEffectDuration = finishedWork.stateNode;
          null !== finishedWork.memoizedState && prevProfilerEffectDuration._visibility & OffscreenPassiveEffectsConnected && (null === finishedWork.return || 13 !== finishedWork.return.tag) ? (prevProfilerEffectDuration._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork), (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
            finishedWork,
            componentEffectStartTime,
            componentEffectEndTime,
            "Disconnect"
          )) : recursivelyTraversePassiveUnmountEffects(finishedWork);
          break;
        default:
          recursivelyTraversePassiveUnmountEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      componentEffectErrors = prevEffectErrors;
    }
    function recursivelyTraverseDisconnectPassiveEffects(parentFiber) {
      var deletions = parentFiber.deletions;
      if (0 !== (parentFiber.flags & 16)) {
        if (null !== deletions)
          for (var i2 = 0; i2 < deletions.length; i2++) {
            var childToDelete = deletions[i2], prevEffectStart = pushComponentEffectStart();
            nextEffect = childToDelete;
            commitPassiveUnmountEffectsInsideOfDeletedTree_begin(
              childToDelete,
              parentFiber
            );
            (childToDelete.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && 0.05 < componentEffectEndTime - componentEffectStartTime && logComponentTrigger(
              childToDelete,
              componentEffectStartTime,
              componentEffectEndTime,
              "Unmount"
            );
            popComponentEffectStart(prevEffectStart);
          }
        detachAlternateSiblings(parentFiber);
      }
      for (parentFiber = parentFiber.child; null !== parentFiber; )
        disconnectPassiveEffect(parentFiber), parentFiber = parentFiber.sibling;
    }
    function disconnectPassiveEffect(finishedWork) {
      var prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
      switch (finishedWork.tag) {
        case 0:
        case 11:
        case 15:
          commitHookPassiveUnmountEffects(
            finishedWork,
            finishedWork.return,
            Passive
          );
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
          break;
        case 22:
          var instance = finishedWork.stateNode;
          instance._visibility & OffscreenPassiveEffectsConnected && (instance._visibility &= ~OffscreenPassiveEffectsConnected, recursivelyTraverseDisconnectPassiveEffects(finishedWork));
          break;
        default:
          recursivelyTraverseDisconnectPassiveEffects(finishedWork);
      }
      (finishedWork.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
        finishedWork,
        componentEffectStartTime,
        componentEffectEndTime,
        componentEffectDuration,
        componentEffectErrors
      );
      popComponentEffectStart(prevEffectStart);
      popComponentEffectDuration(prevEffectDuration);
      componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
      componentEffectErrors = prevEffectErrors;
    }
    function commitPassiveUnmountEffectsInsideOfDeletedTree_begin(deletedSubtreeRoot, nearestMountedAncestor$jscomp$0) {
      for (; null !== nextEffect; ) {
        var fiber = nextEffect, current3 = fiber, nearestMountedAncestor = nearestMountedAncestor$jscomp$0, prevEffectStart = pushComponentEffectStart(), prevEffectDuration = pushComponentEffectDuration(), prevEffectErrors = pushComponentEffectErrors(), prevEffectDidSpawnUpdate = pushComponentEffectDidSpawnUpdate();
        switch (current3.tag) {
          case 0:
          case 11:
          case 15:
            commitHookPassiveUnmountEffects(
              current3,
              nearestMountedAncestor,
              Passive
            );
            break;
          case 23:
          case 22:
            null !== current3.memoizedState && null !== current3.memoizedState.cachePool && (nearestMountedAncestor = current3.memoizedState.cachePool.pool, null != nearestMountedAncestor && retainCache(nearestMountedAncestor));
            break;
          case 24:
            releaseCache(current3.memoizedState.cache);
        }
        (current3.mode & ProfileMode) !== NoMode && 0 <= componentEffectStartTime && 0 <= componentEffectEndTime && (componentEffectSpawnedUpdate || 0.05 < componentEffectDuration) && logComponentEffect(
          current3,
          componentEffectStartTime,
          componentEffectEndTime,
          componentEffectDuration,
          componentEffectErrors
        );
        popComponentEffectStart(prevEffectStart);
        popComponentEffectDuration(prevEffectDuration);
        componentEffectSpawnedUpdate = prevEffectDidSpawnUpdate;
        componentEffectErrors = prevEffectErrors;
        current3 = fiber.child;
        if (null !== current3) current3.return = fiber, nextEffect = current3;
        else
          a: for (fiber = deletedSubtreeRoot; null !== nextEffect; ) {
            current3 = nextEffect;
            prevEffectStart = current3.sibling;
            prevEffectDuration = current3.return;
            detachFiberAfterEffects(current3);
            if (current3 === fiber) {
              nextEffect = null;
              break a;
            }
            if (null !== prevEffectStart) {
              prevEffectStart.return = prevEffectDuration;
              nextEffect = prevEffectStart;
              break a;
            }
            nextEffect = prevEffectDuration;
          }
      }
    }
    function onCommitRoot() {
      commitHooks.forEach(function(commitHook) {
        return commitHook();
      });
    }
    function isConcurrentActEnvironment() {
      var isReactActEnvironmentGlobal = "undefined" !== typeof IS_REACT_ACT_ENVIRONMENT ? IS_REACT_ACT_ENVIRONMENT : void 0;
      isReactActEnvironmentGlobal || null === ReactSharedInternals.actQueue || console.error(
        "The current testing environment is not configured to support act(...)"
      );
      return isReactActEnvironmentGlobal;
    }
    function requestUpdateLane(fiber) {
      if ((executionContext & RenderContext) !== NoContext && 0 !== workInProgressRootRenderLanes)
        return workInProgressRootRenderLanes & -workInProgressRootRenderLanes;
      var transition = ReactSharedInternals.T;
      return null !== transition ? (transition._updatedFibers || (transition._updatedFibers = /* @__PURE__ */ new Set()), transition._updatedFibers.add(fiber), requestTransitionLane()) : resolveUpdatePriority();
    }
    function requestDeferredLane() {
      if (0 === workInProgressDeferredLane)
        if (0 === (workInProgressRootRenderLanes & 536870912) || isHydrating) {
          var lane = nextTransitionDeferredLane;
          nextTransitionDeferredLane <<= 1;
          0 === (nextTransitionDeferredLane & 3932160) && (nextTransitionDeferredLane = 262144);
          workInProgressDeferredLane = lane;
        } else workInProgressDeferredLane = 536870912;
      lane = suspenseHandlerStackCursor.current;
      null !== lane && (lane.flags |= 32);
      return workInProgressDeferredLane;
    }
    function scheduleUpdateOnFiber(root3, fiber, lane) {
      isRunningInsertionEffect && console.error("useInsertionEffect must not schedule updates.");
      isFlushingPassiveEffects && (didScheduleUpdateDuringPassiveEffects = true);
      if (root3 === workInProgressRoot && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root3.cancelPendingCommit)
        prepareFreshStack(root3, 0), markRootSuspended(
          root3,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        );
      markRootUpdated$1(root3, lane);
      if ((executionContext & RenderContext) !== NoContext && root3 === workInProgressRoot) {
        if (isRendering)
          switch (fiber.tag) {
            case 0:
            case 11:
            case 15:
              root3 = workInProgress && getComponentNameFromFiber(workInProgress) || "Unknown";
              didWarnAboutUpdateInRenderForAnotherComponent.has(root3) || (didWarnAboutUpdateInRenderForAnotherComponent.add(root3), fiber = getComponentNameFromFiber(fiber) || "Unknown", console.error(
                "Cannot update a component (`%s`) while rendering a different component (`%s`). To locate the bad setState() call inside `%s`, follow the stack trace as described in https://react.dev/link/setstate-in-render",
                fiber,
                root3,
                root3
              ));
              break;
            case 1:
              didWarnAboutUpdateInRender || (console.error(
                "Cannot update during an existing state transition (such as within `render`). Render methods should be a pure function of props and state."
              ), didWarnAboutUpdateInRender = true);
          }
      } else
        isDevToolsPresent && addFiberToLanesMap(root3, fiber, lane), warnIfUpdatesNotWrappedWithActDEV(fiber), root3 === workInProgressRoot && ((executionContext & RenderContext) === NoContext && (workInProgressRootInterleavedUpdatedLanes |= lane), workInProgressRootExitStatus === RootSuspendedWithDelay && markRootSuspended(
          root3,
          workInProgressRootRenderLanes,
          workInProgressDeferredLane,
          false
        )), ensureRootIsScheduled(root3);
    }
    function performWorkOnRoot(root3, lanes, forceSync) {
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      if (0 !== workInProgressRootRenderLanes && null !== workInProgress) {
        var yieldedFiber = workInProgress, yieldEndTime = now$1();
        switch (yieldReason) {
          case SuspendedOnImmediate:
          case SuspendedOnData:
            var startTime = yieldStartTime;
            supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(
              console.timeStamp.bind(
                console,
                "Suspended",
                startTime,
                yieldEndTime,
                COMPONENTS_TRACK,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Suspended",
              startTime,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              "primary-light"
            ));
            break;
          case SuspendedOnAction:
            startTime = yieldStartTime;
            supportsUserTiming && ((yieldedFiber = yieldedFiber._debugTask) ? yieldedFiber.run(
              console.timeStamp.bind(
                console,
                "Action",
                startTime,
                yieldEndTime,
                COMPONENTS_TRACK,
                void 0,
                "primary-light"
              )
            ) : console.timeStamp(
              "Action",
              startTime,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              "primary-light"
            ));
            break;
          default:
            supportsUserTiming && (yieldedFiber = yieldEndTime - yieldStartTime, 3 > yieldedFiber || console.timeStamp(
              "Blocked",
              yieldStartTime,
              yieldEndTime,
              COMPONENTS_TRACK,
              void 0,
              5 > yieldedFiber ? "primary-light" : 10 > yieldedFiber ? "primary" : 100 > yieldedFiber ? "primary-dark" : "error"
            ));
        }
      }
      startTime = (forceSync = !forceSync && 0 === (lanes & 127) && 0 === (lanes & root3.expiredLanes) || checkIfRootIsPrerendering(root3, lanes)) ? renderRootConcurrent(root3, lanes) : renderRootSync(root3, lanes, true);
      var renderWasConcurrent = forceSync;
      do {
        if (startTime === RootInProgress) {
          workInProgressRootIsPrerendering && !forceSync && markRootSuspended(root3, lanes, 0, false);
          lanes = workInProgressSuspendedReason;
          yieldStartTime = now();
          yieldReason = lanes;
          break;
        } else {
          yieldedFiber = now$1();
          yieldEndTime = root3.current.alternate;
          if (renderWasConcurrent && !isRenderConsistentWithExternalStores(yieldEndTime)) {
            setCurrentTrackFromLanes(lanes);
            yieldEndTime = renderStartTime;
            startTime = yieldedFiber;
            !supportsUserTiming || startTime <= yieldEndTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(
              console.timeStamp.bind(
                console,
                "Teared Render",
                yieldEndTime,
                startTime,
                currentTrack,
                LANES_TRACK_GROUP,
                "error"
              )
            ) : console.timeStamp(
              "Teared Render",
              yieldEndTime,
              startTime,
              currentTrack,
              LANES_TRACK_GROUP,
              "error"
            ));
            finalizeRender(lanes, yieldedFiber);
            startTime = renderRootSync(root3, lanes, false);
            renderWasConcurrent = false;
            continue;
          }
          if (startTime === RootErrored) {
            renderWasConcurrent = lanes;
            if (root3.errorRecoveryDisabledLanes & renderWasConcurrent)
              var errorRetryLanes = 0;
            else
              errorRetryLanes = root3.pendingLanes & -536870913, errorRetryLanes = 0 !== errorRetryLanes ? errorRetryLanes : errorRetryLanes & 536870912 ? 536870912 : 0;
            if (0 !== errorRetryLanes) {
              setCurrentTrackFromLanes(lanes);
              logErroredRenderPhase(
                renderStartTime,
                yieldedFiber,
                lanes,
                workInProgressUpdateTask
              );
              finalizeRender(lanes, yieldedFiber);
              lanes = errorRetryLanes;
              a: {
                yieldedFiber = root3;
                startTime = renderWasConcurrent;
                renderWasConcurrent = workInProgressRootConcurrentErrors;
                var wasRootDehydrated = yieldedFiber.current.memoizedState.isDehydrated;
                wasRootDehydrated && (prepareFreshStack(yieldedFiber, errorRetryLanes).flags |= 256);
                errorRetryLanes = renderRootSync(
                  yieldedFiber,
                  errorRetryLanes,
                  false
                );
                if (errorRetryLanes !== RootErrored) {
                  if (workInProgressRootDidAttachPingListener && !wasRootDehydrated) {
                    yieldedFiber.errorRecoveryDisabledLanes |= startTime;
                    workInProgressRootInterleavedUpdatedLanes |= startTime;
                    startTime = RootSuspendedWithDelay;
                    break a;
                  }
                  yieldedFiber = workInProgressRootRecoverableErrors;
                  workInProgressRootRecoverableErrors = renderWasConcurrent;
                  null !== yieldedFiber && (null === workInProgressRootRecoverableErrors ? workInProgressRootRecoverableErrors = yieldedFiber : workInProgressRootRecoverableErrors.push.apply(
                    workInProgressRootRecoverableErrors,
                    yieldedFiber
                  ));
                }
                startTime = errorRetryLanes;
              }
              renderWasConcurrent = false;
              if (startTime !== RootErrored) continue;
              else yieldedFiber = now$1();
            }
          }
          if (startTime === RootFatalErrored) {
            setCurrentTrackFromLanes(lanes);
            logErroredRenderPhase(
              renderStartTime,
              yieldedFiber,
              lanes,
              workInProgressUpdateTask
            );
            finalizeRender(lanes, yieldedFiber);
            prepareFreshStack(root3, 0);
            markRootSuspended(root3, lanes, 0, true);
            break;
          }
          a: {
            forceSync = root3;
            switch (startTime) {
              case RootInProgress:
              case RootFatalErrored:
                throw Error("Root did not complete. This is a bug in React.");
              case RootSuspendedWithDelay:
                if ((lanes & 4194048) !== lanes) break;
              case RootSuspendedAtTheShell:
                setCurrentTrackFromLanes(lanes);
                logSuspendedRenderPhase(
                  renderStartTime,
                  yieldedFiber,
                  lanes,
                  workInProgressUpdateTask
                );
                finalizeRender(lanes, yieldedFiber);
                yieldEndTime = lanes;
                0 !== (yieldEndTime & 127) ? blockingSuspendedTime = yieldedFiber : 0 !== (yieldEndTime & 4194048) && (transitionSuspendedTime = yieldedFiber);
                markRootSuspended(
                  forceSync,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                break a;
              case RootErrored:
                workInProgressRootRecoverableErrors = null;
                break;
              case RootSuspended:
              case RootCompleted:
                break;
              default:
                throw Error("Unknown root exit status.");
            }
            if (null !== ReactSharedInternals.actQueue)
              commitRoot(
                forceSync,
                yieldEndTime,
                lanes,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                startTime,
                null,
                null,
                renderStartTime,
                yieldedFiber
              );
            else {
              if ((lanes & 62914560) === lanes && (renderWasConcurrent = globalMostRecentFallbackTime + FALLBACK_THROTTLE_MS - now$1(), 10 < renderWasConcurrent)) {
                markRootSuspended(
                  forceSync,
                  lanes,
                  workInProgressDeferredLane,
                  !workInProgressRootDidSkipSuspendedSiblings
                );
                if (0 !== getNextLanes(forceSync, 0, true)) break a;
                pendingEffectsLanes = lanes;
                forceSync.timeoutHandle = scheduleTimeout(
                  commitRootWhenReady.bind(
                    null,
                    forceSync,
                    yieldEndTime,
                    workInProgressRootRecoverableErrors,
                    workInProgressTransitions,
                    workInProgressRootDidIncludeRecursiveRenderUpdate,
                    lanes,
                    workInProgressDeferredLane,
                    workInProgressRootInterleavedUpdatedLanes,
                    workInProgressSuspendedRetryLanes,
                    workInProgressRootDidSkipSuspendedSiblings,
                    startTime,
                    "Throttled",
                    renderStartTime,
                    yieldedFiber
                  ),
                  renderWasConcurrent
                );
                break a;
              }
              commitRootWhenReady(
                forceSync,
                yieldEndTime,
                workInProgressRootRecoverableErrors,
                workInProgressTransitions,
                workInProgressRootDidIncludeRecursiveRenderUpdate,
                lanes,
                workInProgressDeferredLane,
                workInProgressRootInterleavedUpdatedLanes,
                workInProgressSuspendedRetryLanes,
                workInProgressRootDidSkipSuspendedSiblings,
                startTime,
                null,
                renderStartTime,
                yieldedFiber
              );
            }
          }
        }
        break;
      } while (1);
      ensureRootIsScheduled(root3);
    }
    function commitRootWhenReady(root3, finishedWork, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, lanes, spawnedLane, updatedLanes, suspendedRetryLanes, didSkipSuspendedSiblings, exitStatus, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
      root3.timeoutHandle = noTimeout;
      var subtreeFlags = finishedWork.subtreeFlags, suspendedState = null;
      if (subtreeFlags & 8192 || 16785408 === (subtreeFlags & 16785408)) {
        if (suspendedState = {
          stylesheets: null,
          count: 0,
          imgCount: 0,
          imgBytes: 0,
          suspenseyImages: [],
          waitingForImages: true,
          waitingForViewTransition: false,
          unsuspend: noop$12
        }, accumulateSuspenseyCommitOnFiber(finishedWork, lanes, suspendedState), subtreeFlags = (lanes & 62914560) === lanes ? globalMostRecentFallbackTime - now$1() : (lanes & 4194048) === lanes ? globalMostRecentTransitionTime - now$1() : 0, subtreeFlags = waitForCommitToBeReady(suspendedState, subtreeFlags), null !== subtreeFlags) {
          pendingEffectsLanes = lanes;
          root3.cancelPendingCommit = subtreeFlags(
            commitRoot.bind(
              null,
              root3,
              finishedWork,
              lanes,
              recoverableErrors,
              transitions,
              didIncludeRenderPhaseUpdate,
              spawnedLane,
              updatedLanes,
              suspendedRetryLanes,
              exitStatus,
              suspendedState,
              suspendedState.waitingForViewTransition ? "Waiting for the previous Animation" : 0 < suspendedState.count ? 0 < suspendedState.imgCount ? "Suspended on CSS and Images" : "Suspended on CSS" : 1 === suspendedState.imgCount ? "Suspended on an Image" : 0 < suspendedState.imgCount ? "Suspended on Images" : null,
              completedRenderStartTime,
              completedRenderEndTime
            )
          );
          markRootSuspended(
            root3,
            lanes,
            spawnedLane,
            !didSkipSuspendedSiblings
          );
          return;
        }
      }
      commitRoot(
        root3,
        finishedWork,
        lanes,
        recoverableErrors,
        transitions,
        didIncludeRenderPhaseUpdate,
        spawnedLane,
        updatedLanes,
        suspendedRetryLanes,
        exitStatus,
        suspendedState,
        suspendedCommitReason,
        completedRenderStartTime,
        completedRenderEndTime
      );
    }
    function isRenderConsistentWithExternalStores(finishedWork) {
      for (var node = finishedWork; ; ) {
        var tag2 = node.tag;
        if ((0 === tag2 || 11 === tag2 || 15 === tag2) && node.flags & 16384 && (tag2 = node.updateQueue, null !== tag2 && (tag2 = tag2.stores, null !== tag2)))
          for (var i2 = 0; i2 < tag2.length; i2++) {
            var check = tag2[i2], getSnapshot = check.getSnapshot;
            check = check.value;
            try {
              if (!objectIs(getSnapshot(), check)) return false;
            } catch (error) {
              return false;
            }
          }
        tag2 = node.child;
        if (node.subtreeFlags & 16384 && null !== tag2)
          tag2.return = node, node = tag2;
        else {
          if (node === finishedWork) break;
          for (; null === node.sibling; ) {
            if (null === node.return || node.return === finishedWork) return true;
            node = node.return;
          }
          node.sibling.return = node.return;
          node = node.sibling;
        }
      }
      return true;
    }
    function markRootSuspended(root3, suspendedLanes, spawnedLane, didAttemptEntireTree) {
      suspendedLanes &= ~workInProgressRootPingedLanes;
      suspendedLanes &= ~workInProgressRootInterleavedUpdatedLanes;
      root3.suspendedLanes |= suspendedLanes;
      root3.pingedLanes &= ~suspendedLanes;
      didAttemptEntireTree && (root3.warmLanes |= suspendedLanes);
      didAttemptEntireTree = root3.expirationTimes;
      for (var lanes = suspendedLanes; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2;
        didAttemptEntireTree[index2] = -1;
        lanes &= ~lane;
      }
      0 !== spawnedLane && markSpawnedDeferredLane(root3, spawnedLane, suspendedLanes);
    }
    function flushSyncWork$1() {
      return (executionContext & (RenderContext | CommitContext)) === NoContext ? (flushSyncWorkAcrossRoots_impl(0), false) : true;
    }
    function resetWorkInProgressStack() {
      if (null !== workInProgress) {
        if (workInProgressSuspendedReason === NotSuspended)
          var interruptedWork = workInProgress.return;
        else
          interruptedWork = workInProgress, resetContextDependencies(), resetHooksOnUnwind(interruptedWork), thenableState$1 = null, thenableIndexCounter$1 = 0, interruptedWork = workInProgress;
        for (; null !== interruptedWork; )
          unwindInterruptedWork(interruptedWork.alternate, interruptedWork), interruptedWork = interruptedWork.return;
        workInProgress = null;
      }
    }
    function finalizeRender(lanes, finalizationTime) {
      0 !== (lanes & 127) && (blockingClampTime = finalizationTime);
      0 !== (lanes & 4194048) && (transitionClampTime = finalizationTime);
      0 !== (lanes & 62914560) && (retryClampTime = finalizationTime);
      0 !== (lanes & 2080374784) && (idleClampTime = finalizationTime);
    }
    function prepareFreshStack(root3, lanes) {
      supportsUserTiming && (console.timeStamp(
        "Blocking Track",
        3e-3,
        3e-3,
        "Blocking",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Transition Track",
        3e-3,
        3e-3,
        "Transition",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Suspense Track",
        3e-3,
        3e-3,
        "Suspense",
        LANES_TRACK_GROUP,
        "primary-light"
      ), console.timeStamp(
        "Idle Track",
        3e-3,
        3e-3,
        "Idle",
        LANES_TRACK_GROUP,
        "primary-light"
      ));
      var previousRenderStartTime = renderStartTime;
      renderStartTime = now();
      if (0 !== workInProgressRootRenderLanes && 0 < previousRenderStartTime) {
        setCurrentTrackFromLanes(workInProgressRootRenderLanes);
        if (workInProgressRootExitStatus === RootSuspended || workInProgressRootExitStatus === RootSuspendedWithDelay)
          logSuspendedRenderPhase(
            previousRenderStartTime,
            renderStartTime,
            lanes,
            workInProgressUpdateTask
          );
        else {
          var endTime = renderStartTime, debugTask = workInProgressUpdateTask;
          if (supportsUserTiming && !(endTime <= previousRenderStartTime)) {
            var color = (lanes & 738197653) === lanes ? "tertiary-dark" : "primary-dark", label2 = (lanes & 536870912) === lanes ? "Prewarm" : (lanes & 201326741) === lanes ? "Interrupted Hydration" : "Interrupted Render";
            debugTask ? debugTask.run(
              console.timeStamp.bind(
                console,
                label2,
                previousRenderStartTime,
                endTime,
                currentTrack,
                LANES_TRACK_GROUP,
                color
              )
            ) : console.timeStamp(
              label2,
              previousRenderStartTime,
              endTime,
              currentTrack,
              LANES_TRACK_GROUP,
              color
            );
          }
        }
        finalizeRender(workInProgressRootRenderLanes, renderStartTime);
      }
      previousRenderStartTime = workInProgressUpdateTask;
      workInProgressUpdateTask = null;
      if (0 !== (lanes & 127)) {
        workInProgressUpdateTask = blockingUpdateTask;
        debugTask = 0 <= blockingUpdateTime && blockingUpdateTime < blockingClampTime ? blockingClampTime : blockingUpdateTime;
        endTime = 0 <= blockingEventTime && blockingEventTime < blockingClampTime ? blockingClampTime : blockingEventTime;
        color = 0 <= endTime ? endTime : 0 <= debugTask ? debugTask : renderStartTime;
        0 <= blockingSuspendedTime ? (setCurrentTrackFromLanes(2), logSuspendedWithDelayPhase(
          blockingSuspendedTime,
          color,
          lanes,
          previousRenderStartTime
        )) : 0 !== (animatingLanes & 127);
        previousRenderStartTime = debugTask;
        var eventTime = endTime, eventType = blockingEventType, eventIsRepeat = 0 < blockingEventRepeatTime, isSpawnedUpdate = blockingUpdateType === SPAWNED_UPDATE, isPingedUpdate = blockingUpdateType === PINGED_UPDATE;
        debugTask = renderStartTime;
        endTime = blockingUpdateTask;
        color = blockingUpdateMethodName;
        label2 = blockingUpdateComponentName;
        if (supportsUserTiming) {
          currentTrack = "Blocking";
          0 < previousRenderStartTime ? previousRenderStartTime > debugTask && (previousRenderStartTime = debugTask) : previousRenderStartTime = debugTask;
          0 < eventTime ? eventTime > previousRenderStartTime && (eventTime = previousRenderStartTime) : eventTime = previousRenderStartTime;
          if (null !== eventType && previousRenderStartTime > eventTime) {
            var color$jscomp$0 = eventIsRepeat ? "secondary-light" : "warning";
            endTime ? endTime.run(
              console.timeStamp.bind(
                console,
                eventIsRepeat ? "Consecutive" : "Event: " + eventType,
                eventTime,
                previousRenderStartTime,
                currentTrack,
                LANES_TRACK_GROUP,
                color$jscomp$0
              )
            ) : console.timeStamp(
              eventIsRepeat ? "Consecutive" : "Event: " + eventType,
              eventTime,
              previousRenderStartTime,
              currentTrack,
              LANES_TRACK_GROUP,
              color$jscomp$0
            );
          }
          debugTask > previousRenderStartTime && (eventTime = isSpawnedUpdate ? "error" : (lanes & 738197653) === lanes ? "tertiary-light" : "primary-light", isSpawnedUpdate = isPingedUpdate ? "Promise Resolved" : isSpawnedUpdate ? "Cascading Update" : 5 < debugTask - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != label2 && isPingedUpdate.push(["Component name", label2]), null != color && isPingedUpdate.push(["Method name", color]), previousRenderStartTime = {
            start: previousRenderStartTime,
            end: debugTask,
            detail: {
              devtools: {
                properties: isPingedUpdate,
                track: currentTrack,
                trackGroup: LANES_TRACK_GROUP,
                color: eventTime
              }
            }
          }, endTime ? endTime.run(
            performance.measure.bind(
              performance,
              isSpawnedUpdate,
              previousRenderStartTime
            )
          ) : performance.measure(isSpawnedUpdate, previousRenderStartTime));
        }
        blockingUpdateTime = -1.1;
        blockingUpdateType = 0;
        blockingUpdateComponentName = blockingUpdateMethodName = null;
        blockingSuspendedTime = -1.1;
        blockingEventRepeatTime = blockingEventTime;
        blockingEventTime = -1.1;
        blockingClampTime = now();
      }
      0 !== (lanes & 4194048) && (workInProgressUpdateTask = transitionUpdateTask, debugTask = 0 <= transitionStartTime && transitionStartTime < transitionClampTime ? transitionClampTime : transitionStartTime, previousRenderStartTime = 0 <= transitionUpdateTime && transitionUpdateTime < transitionClampTime ? transitionClampTime : transitionUpdateTime, endTime = 0 <= transitionEventTime && transitionEventTime < transitionClampTime ? transitionClampTime : transitionEventTime, color = 0 <= endTime ? endTime : 0 <= previousRenderStartTime ? previousRenderStartTime : renderStartTime, 0 <= transitionSuspendedTime ? (setCurrentTrackFromLanes(256), logSuspendedWithDelayPhase(
        transitionSuspendedTime,
        color,
        lanes,
        workInProgressUpdateTask
      )) : 0 !== (animatingLanes & 4194048), isPingedUpdate = endTime, eventTime = transitionEventType, eventType = 0 < transitionEventRepeatTime, eventIsRepeat = transitionUpdateType === PINGED_UPDATE, color = renderStartTime, endTime = transitionUpdateTask, label2 = transitionUpdateMethodName, isSpawnedUpdate = transitionUpdateComponentName, supportsUserTiming && (currentTrack = "Transition", 0 < previousRenderStartTime ? previousRenderStartTime > color && (previousRenderStartTime = color) : previousRenderStartTime = color, 0 < debugTask ? debugTask > previousRenderStartTime && (debugTask = previousRenderStartTime) : debugTask = previousRenderStartTime, 0 < isPingedUpdate ? isPingedUpdate > debugTask && (isPingedUpdate = debugTask) : isPingedUpdate = debugTask, debugTask > isPingedUpdate && null !== eventTime && (color$jscomp$0 = eventType ? "secondary-light" : "warning", endTime ? endTime.run(
        console.timeStamp.bind(
          console,
          eventType ? "Consecutive" : "Event: " + eventTime,
          isPingedUpdate,
          debugTask,
          currentTrack,
          LANES_TRACK_GROUP,
          color$jscomp$0
        )
      ) : console.timeStamp(
        eventType ? "Consecutive" : "Event: " + eventTime,
        isPingedUpdate,
        debugTask,
        currentTrack,
        LANES_TRACK_GROUP,
        color$jscomp$0
      )), previousRenderStartTime > debugTask && (endTime ? endTime.run(
        console.timeStamp.bind(
          console,
          "Action",
          debugTask,
          previousRenderStartTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "primary-dark"
        )
      ) : console.timeStamp(
        "Action",
        debugTask,
        previousRenderStartTime,
        currentTrack,
        LANES_TRACK_GROUP,
        "primary-dark"
      )), color > previousRenderStartTime && (debugTask = eventIsRepeat ? "Promise Resolved" : 5 < color - previousRenderStartTime ? "Update Blocked" : "Update", isPingedUpdate = [], null != isSpawnedUpdate && isPingedUpdate.push(["Component name", isSpawnedUpdate]), null != label2 && isPingedUpdate.push(["Method name", label2]), previousRenderStartTime = {
        start: previousRenderStartTime,
        end: color,
        detail: {
          devtools: {
            properties: isPingedUpdate,
            track: currentTrack,
            trackGroup: LANES_TRACK_GROUP,
            color: "primary-light"
          }
        }
      }, endTime ? endTime.run(
        performance.measure.bind(
          performance,
          debugTask,
          previousRenderStartTime
        )
      ) : performance.measure(debugTask, previousRenderStartTime))), transitionUpdateTime = transitionStartTime = -1.1, transitionUpdateType = 0, transitionSuspendedTime = -1.1, transitionEventRepeatTime = transitionEventTime, transitionEventTime = -1.1, transitionClampTime = now());
      0 !== (lanes & 62914560) && 0 !== (animatingLanes & 62914560) && (setCurrentTrackFromLanes(4194304), logAnimatingPhase(retryClampTime, renderStartTime));
      0 !== (lanes & 2080374784) && 0 !== (animatingLanes & 2080374784) && (setCurrentTrackFromLanes(268435456), logAnimatingPhase(idleClampTime, renderStartTime));
      previousRenderStartTime = root3.timeoutHandle;
      previousRenderStartTime !== noTimeout && (root3.timeoutHandle = noTimeout, cancelTimeout(previousRenderStartTime));
      previousRenderStartTime = root3.cancelPendingCommit;
      null !== previousRenderStartTime && (root3.cancelPendingCommit = null, previousRenderStartTime());
      pendingEffectsLanes = 0;
      resetWorkInProgressStack();
      workInProgressRoot = root3;
      workInProgress = previousRenderStartTime = createWorkInProgress(
        root3.current,
        null
      );
      workInProgressRootRenderLanes = lanes;
      workInProgressSuspendedReason = NotSuspended;
      workInProgressThrownValue = null;
      workInProgressRootDidSkipSuspendedSiblings = false;
      workInProgressRootIsPrerendering = checkIfRootIsPrerendering(root3, lanes);
      workInProgressRootDidAttachPingListener = false;
      workInProgressRootExitStatus = RootInProgress;
      workInProgressSuspendedRetryLanes = workInProgressDeferredLane = workInProgressRootPingedLanes = workInProgressRootInterleavedUpdatedLanes = workInProgressRootSkippedLanes = 0;
      workInProgressRootRecoverableErrors = workInProgressRootConcurrentErrors = null;
      workInProgressRootDidIncludeRecursiveRenderUpdate = false;
      0 !== (lanes & 8) && (lanes |= lanes & 32);
      endTime = root3.entangledLanes;
      if (0 !== endTime)
        for (root3 = root3.entanglements, endTime &= lanes; 0 < endTime; )
          debugTask = 31 - clz32(endTime), color = 1 << debugTask, lanes |= root3[debugTask], endTime &= ~color;
      entangledRenderLanes = lanes;
      finishQueueingConcurrentUpdates();
      root3 = getCurrentTime();
      1e3 < root3 - lastResetTime && (ReactSharedInternals.recentlyCreatedOwnerStacks = 0, lastResetTime = root3);
      ReactStrictModeWarnings.discardPendingWarnings();
      return previousRenderStartTime;
    }
    function handleThrow(root3, thrownValue) {
      currentlyRenderingFiber = null;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      ReactSharedInternals.getCurrentStack = null;
      isRendering = false;
      current2 = null;
      thrownValue === SuspenseException || thrownValue === SuspenseActionException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnImmediate) : thrownValue === SuspenseyCommitException ? (thrownValue = getSuspendedThenable(), workInProgressSuspendedReason = SuspendedOnInstance) : workInProgressSuspendedReason = thrownValue === SelectiveHydrationException ? SuspendedOnHydration : null !== thrownValue && "object" === typeof thrownValue && "function" === typeof thrownValue.then ? SuspendedOnDeprecatedThrowPromise : SuspendedOnError;
      workInProgressThrownValue = thrownValue;
      var erroredWork = workInProgress;
      null === erroredWork ? (workInProgressRootExitStatus = RootFatalErrored, logUncaughtError(
        root3,
        createCapturedValueAtFiber(thrownValue, root3.current)
      )) : erroredWork.mode & ProfileMode && stopProfilerTimerIfRunningAndRecordDuration(erroredWork);
    }
    function shouldRemainOnPreviousScreen() {
      var handler = suspenseHandlerStackCursor.current;
      return null === handler ? true : (workInProgressRootRenderLanes & 4194048) === workInProgressRootRenderLanes ? null === shellBoundary ? true : false : (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes || 0 !== (workInProgressRootRenderLanes & 536870912) ? handler === shellBoundary : false;
    }
    function pushDispatcher() {
      var prevDispatcher = ReactSharedInternals.H;
      ReactSharedInternals.H = ContextOnlyDispatcher;
      return null === prevDispatcher ? ContextOnlyDispatcher : prevDispatcher;
    }
    function pushAsyncDispatcher() {
      var prevAsyncDispatcher = ReactSharedInternals.A;
      ReactSharedInternals.A = DefaultAsyncDispatcher;
      return prevAsyncDispatcher;
    }
    function markRenderDerivedCause(fiber) {
      null === workInProgressUpdateTask && (workInProgressUpdateTask = null == fiber._debugTask ? null : fiber._debugTask);
    }
    function renderDidSuspendDelayIfPossible() {
      workInProgressRootExitStatus = RootSuspendedWithDelay;
      workInProgressRootDidSkipSuspendedSiblings || (workInProgressRootRenderLanes & 4194048) !== workInProgressRootRenderLanes && null !== suspenseHandlerStackCursor.current || (workInProgressRootIsPrerendering = true);
      0 === (workInProgressRootSkippedLanes & 134217727) && 0 === (workInProgressRootInterleavedUpdatedLanes & 134217727) || null === workInProgressRoot || markRootSuspended(
        workInProgressRoot,
        workInProgressRootRenderLanes,
        workInProgressDeferredLane,
        false
      );
    }
    function renderRootSync(root3, lanes, shouldYieldForPrerendering) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root3.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root3, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root3, lanes);
        }
        workInProgressTransitions = null;
        prepareFreshStack(root3, lanes);
      }
      lanes = false;
      memoizedUpdaters = workInProgressRootExitStatus;
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress) {
            var unitOfWork = workInProgress, thrownValue = workInProgressThrownValue;
            switch (workInProgressSuspendedReason) {
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                memoizedUpdaters = RootSuspendedAtTheShell;
                break a;
              case SuspendedOnImmediate:
              case SuspendedOnData:
              case SuspendedOnAction:
              case SuspendedOnDeprecatedThrowPromise:
                null === suspenseHandlerStackCursor.current && (lanes = true);
                var reason = workInProgressSuspendedReason;
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
                if (shouldYieldForPrerendering && workInProgressRootIsPrerendering) {
                  memoizedUpdaters = RootInProgress;
                  break a;
                }
                break;
              default:
                reason = workInProgressSuspendedReason, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, reason);
            }
          }
          workLoopSync();
          memoizedUpdaters = workInProgressRootExitStatus;
          break;
        } catch (thrownValue$8) {
          handleThrow(root3, thrownValue$8);
        }
      while (1);
      lanes && root3.shellSuspendCounter++;
      resetContextDependencies();
      executionContext = prevExecutionContext;
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      null === workInProgress && (workInProgressRoot = null, workInProgressRootRenderLanes = 0, finishQueueingConcurrentUpdates());
      return memoizedUpdaters;
    }
    function workLoopSync() {
      for (; null !== workInProgress; ) performUnitOfWork(workInProgress);
    }
    function renderRootConcurrent(root3, lanes) {
      var prevExecutionContext = executionContext;
      executionContext |= RenderContext;
      var prevDispatcher = pushDispatcher(), prevAsyncDispatcher = pushAsyncDispatcher();
      if (workInProgressRoot !== root3 || workInProgressRootRenderLanes !== lanes) {
        if (isDevToolsPresent) {
          var memoizedUpdaters = root3.memoizedUpdaters;
          0 < memoizedUpdaters.size && (restorePendingUpdaters(root3, workInProgressRootRenderLanes), memoizedUpdaters.clear());
          movePendingFibersToMemoized(root3, lanes);
        }
        workInProgressTransitions = null;
        workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS;
        prepareFreshStack(root3, lanes);
      } else
        workInProgressRootIsPrerendering = checkIfRootIsPrerendering(
          root3,
          lanes
        );
      a: do
        try {
          if (workInProgressSuspendedReason !== NotSuspended && null !== workInProgress)
            b: switch (lanes = workInProgress, memoizedUpdaters = workInProgressThrownValue, workInProgressSuspendedReason) {
              case SuspendedOnError:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnError
                );
                break;
              case SuspendedOnData:
              case SuspendedOnAction:
                if (isThenableResolved(memoizedUpdaters)) {
                  workInProgressSuspendedReason = NotSuspended;
                  workInProgressThrownValue = null;
                  replaySuspendedUnitOfWork(lanes);
                  break;
                }
                lanes = function() {
                  workInProgressSuspendedReason !== SuspendedOnData && workInProgressSuspendedReason !== SuspendedOnAction || workInProgressRoot !== root3 || (workInProgressSuspendedReason = SuspendedAndReadyToContinue);
                  ensureRootIsScheduled(root3);
                };
                memoizedUpdaters.then(lanes, lanes);
                break a;
              case SuspendedOnImmediate:
                workInProgressSuspendedReason = SuspendedAndReadyToContinue;
                break a;
              case SuspendedOnInstance:
                workInProgressSuspendedReason = SuspendedOnInstanceAndReadyToContinue;
                break a;
              case SuspendedAndReadyToContinue:
                isThenableResolved(memoizedUpdaters) ? (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, replaySuspendedUnitOfWork(lanes)) : (workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedAndReadyToContinue
                ));
                break;
              case SuspendedOnInstanceAndReadyToContinue:
                var resource = null;
                switch (workInProgress.tag) {
                  case 26:
                    resource = workInProgress.memoizedState;
                  case 5:
                  case 27:
                    var hostFiber = workInProgress;
                    if (resource ? preloadResource(resource) : hostFiber.stateNode.complete) {
                      workInProgressSuspendedReason = NotSuspended;
                      workInProgressThrownValue = null;
                      var sibling = hostFiber.sibling;
                      if (null !== sibling) workInProgress = sibling;
                      else {
                        var returnFiber = hostFiber.return;
                        null !== returnFiber ? (workInProgress = returnFiber, completeUnitOfWork(returnFiber)) : workInProgress = null;
                      }
                      break b;
                    }
                    break;
                  default:
                    console.error(
                      "Unexpected type of fiber triggered a suspensey commit. This is a bug in React."
                    );
                }
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnInstanceAndReadyToContinue
                );
                break;
              case SuspendedOnDeprecatedThrowPromise:
                workInProgressSuspendedReason = NotSuspended;
                workInProgressThrownValue = null;
                throwAndUnwindWorkLoop(
                  root3,
                  lanes,
                  memoizedUpdaters,
                  SuspendedOnDeprecatedThrowPromise
                );
                break;
              case SuspendedOnHydration:
                resetWorkInProgressStack();
                workInProgressRootExitStatus = RootSuspendedAtTheShell;
                break a;
              default:
                throw Error(
                  "Unexpected SuspendedReason. This is a bug in React."
                );
            }
          null !== ReactSharedInternals.actQueue ? workLoopSync() : workLoopConcurrentByScheduler();
          break;
        } catch (thrownValue$9) {
          handleThrow(root3, thrownValue$9);
        }
      while (1);
      resetContextDependencies();
      ReactSharedInternals.H = prevDispatcher;
      ReactSharedInternals.A = prevAsyncDispatcher;
      executionContext = prevExecutionContext;
      if (null !== workInProgress) return RootInProgress;
      workInProgressRoot = null;
      workInProgressRootRenderLanes = 0;
      finishQueueingConcurrentUpdates();
      return workInProgressRootExitStatus;
    }
    function workLoopConcurrentByScheduler() {
      for (; null !== workInProgress && !shouldYield(); )
        performUnitOfWork(workInProgress);
    }
    function performUnitOfWork(unitOfWork) {
      var current3 = unitOfWork.alternate;
      (unitOfWork.mode & ProfileMode) !== NoMode ? (startProfilerTimer(unitOfWork), current3 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current3,
        unitOfWork,
        entangledRenderLanes
      ), stopProfilerTimerIfRunningAndRecordDuration(unitOfWork)) : current3 = runWithFiberInDEV(
        unitOfWork,
        beginWork,
        current3,
        unitOfWork,
        entangledRenderLanes
      );
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === current3 ? completeUnitOfWork(unitOfWork) : workInProgress = current3;
    }
    function replaySuspendedUnitOfWork(unitOfWork) {
      var next = runWithFiberInDEV(unitOfWork, replayBeginWork, unitOfWork);
      unitOfWork.memoizedProps = unitOfWork.pendingProps;
      null === next ? completeUnitOfWork(unitOfWork) : workInProgress = next;
    }
    function replayBeginWork(unitOfWork) {
      var current3 = unitOfWork.alternate, isProfilingMode = (unitOfWork.mode & ProfileMode) !== NoMode;
      isProfilingMode && startProfilerTimer(unitOfWork);
      switch (unitOfWork.tag) {
        case 15:
        case 0:
          current3 = replayFunctionComponent(
            current3,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type,
            void 0,
            workInProgressRootRenderLanes
          );
          break;
        case 11:
          current3 = replayFunctionComponent(
            current3,
            unitOfWork,
            unitOfWork.pendingProps,
            unitOfWork.type.render,
            unitOfWork.ref,
            workInProgressRootRenderLanes
          );
          break;
        case 5:
          resetHooksOnUnwind(unitOfWork);
        default:
          unwindInterruptedWork(current3, unitOfWork), unitOfWork = workInProgress = resetWorkInProgress(unitOfWork, entangledRenderLanes), current3 = beginWork(current3, unitOfWork, entangledRenderLanes);
      }
      isProfilingMode && stopProfilerTimerIfRunningAndRecordDuration(unitOfWork);
      return current3;
    }
    function throwAndUnwindWorkLoop(root3, unitOfWork, thrownValue, suspendedReason) {
      resetContextDependencies();
      resetHooksOnUnwind(unitOfWork);
      thenableState$1 = null;
      thenableIndexCounter$1 = 0;
      var returnFiber = unitOfWork.return;
      try {
        if (throwException(
          root3,
          returnFiber,
          unitOfWork,
          thrownValue,
          workInProgressRootRenderLanes
        )) {
          workInProgressRootExitStatus = RootFatalErrored;
          logUncaughtError(
            root3,
            createCapturedValueAtFiber(thrownValue, root3.current)
          );
          workInProgress = null;
          return;
        }
      } catch (error) {
        if (null !== returnFiber) throw workInProgress = returnFiber, error;
        workInProgressRootExitStatus = RootFatalErrored;
        logUncaughtError(
          root3,
          createCapturedValueAtFiber(thrownValue, root3.current)
        );
        workInProgress = null;
        return;
      }
      if (unitOfWork.flags & 32768) {
        if (isHydrating || suspendedReason === SuspendedOnError) root3 = true;
        else if (workInProgressRootIsPrerendering || 0 !== (workInProgressRootRenderLanes & 536870912))
          root3 = false;
        else if (workInProgressRootDidSkipSuspendedSiblings = root3 = true, suspendedReason === SuspendedOnData || suspendedReason === SuspendedOnAction || suspendedReason === SuspendedOnImmediate || suspendedReason === SuspendedOnDeprecatedThrowPromise)
          suspendedReason = suspenseHandlerStackCursor.current, null !== suspendedReason && 13 === suspendedReason.tag && (suspendedReason.flags |= 16384);
        unwindUnitOfWork(unitOfWork, root3);
      } else completeUnitOfWork(unitOfWork);
    }
    function completeUnitOfWork(unitOfWork) {
      var completedWork = unitOfWork;
      do {
        if (0 !== (completedWork.flags & 32768)) {
          unwindUnitOfWork(
            completedWork,
            workInProgressRootDidSkipSuspendedSiblings
          );
          return;
        }
        var current3 = completedWork.alternate;
        unitOfWork = completedWork.return;
        startProfilerTimer(completedWork);
        current3 = runWithFiberInDEV(
          completedWork,
          completeWork,
          current3,
          completedWork,
          entangledRenderLanes
        );
        (completedWork.mode & ProfileMode) !== NoMode && stopProfilerTimerIfRunningAndRecordIncompleteDuration(completedWork);
        if (null !== current3) {
          workInProgress = current3;
          return;
        }
        completedWork = completedWork.sibling;
        if (null !== completedWork) {
          workInProgress = completedWork;
          return;
        }
        workInProgress = completedWork = unitOfWork;
      } while (null !== completedWork);
      workInProgressRootExitStatus === RootInProgress && (workInProgressRootExitStatus = RootCompleted);
    }
    function unwindUnitOfWork(unitOfWork, skipSiblings) {
      do {
        var next = unwindWork(unitOfWork.alternate, unitOfWork);
        if (null !== next) {
          next.flags &= 32767;
          workInProgress = next;
          return;
        }
        if ((unitOfWork.mode & ProfileMode) !== NoMode) {
          stopProfilerTimerIfRunningAndRecordIncompleteDuration(unitOfWork);
          next = unitOfWork.actualDuration;
          for (var child = unitOfWork.child; null !== child; )
            next += child.actualDuration, child = child.sibling;
          unitOfWork.actualDuration = next;
        }
        next = unitOfWork.return;
        null !== next && (next.flags |= 32768, next.subtreeFlags = 0, next.deletions = null);
        if (!skipSiblings && (unitOfWork = unitOfWork.sibling, null !== unitOfWork)) {
          workInProgress = unitOfWork;
          return;
        }
        workInProgress = unitOfWork = next;
      } while (null !== unitOfWork);
      workInProgressRootExitStatus = RootSuspendedAtTheShell;
      workInProgress = null;
    }
    function commitRoot(root3, finishedWork, lanes, recoverableErrors, transitions, didIncludeRenderPhaseUpdate, spawnedLane, updatedLanes, suspendedRetryLanes, exitStatus, suspendedState, suspendedCommitReason, completedRenderStartTime, completedRenderEndTime) {
      root3.cancelPendingCommit = null;
      do
        flushPendingEffects();
      while (pendingEffectsStatus !== NO_PENDING_EFFECTS);
      ReactStrictModeWarnings.flushLegacyContextWarning();
      ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings();
      if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
        throw Error("Should not already be working.");
      setCurrentTrackFromLanes(lanes);
      exitStatus === RootErrored ? logErroredRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        workInProgressUpdateTask
      ) : null !== recoverableErrors ? logRecoveredRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        recoverableErrors,
        null !== finishedWork && null !== finishedWork.alternate && finishedWork.alternate.memoizedState.isDehydrated && 0 !== (finishedWork.flags & 256),
        workInProgressUpdateTask
      ) : logRenderPhase(
        completedRenderStartTime,
        completedRenderEndTime,
        lanes,
        workInProgressUpdateTask
      );
      if (null !== finishedWork) {
        0 === lanes && console.error(
          "finishedLanes should not be empty during a commit. This is a bug in React."
        );
        if (finishedWork === root3.current)
          throw Error(
            "Cannot commit the same tree as before. This error is likely caused by a bug in React. Please file an issue."
          );
        didIncludeRenderPhaseUpdate = finishedWork.lanes | finishedWork.childLanes;
        didIncludeRenderPhaseUpdate |= concurrentlyUpdatedLanes;
        markRootFinished(
          root3,
          lanes,
          didIncludeRenderPhaseUpdate,
          spawnedLane,
          updatedLanes,
          suspendedRetryLanes
        );
        root3 === workInProgressRoot && (workInProgress = workInProgressRoot = null, workInProgressRootRenderLanes = 0);
        pendingFinishedWork = finishedWork;
        pendingEffectsRoot = root3;
        pendingEffectsLanes = lanes;
        pendingEffectsRemainingLanes = didIncludeRenderPhaseUpdate;
        pendingPassiveTransitions = transitions;
        pendingRecoverableErrors = recoverableErrors;
        pendingEffectsRenderEndTime = completedRenderEndTime;
        pendingSuspendedCommitReason = suspendedCommitReason;
        pendingDelayedCommitReason = IMMEDIATE_COMMIT;
        pendingSuspendedViewTransitionReason = null;
        0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256) ? (root3.callbackNode = null, root3.callbackPriority = 0, scheduleCallback$1(NormalPriority$1, function() {
          schedulerEvent = window.event;
          pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
          flushPassiveEffects();
          return null;
        })) : (root3.callbackNode = null, root3.callbackPriority = 0);
        commitErrors = null;
        commitStartTime = now();
        null !== suspendedCommitReason && logSuspendedCommitPhase(
          completedRenderEndTime,
          commitStartTime,
          suspendedCommitReason,
          workInProgressUpdateTask
        );
        recoverableErrors = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || recoverableErrors) {
          recoverableErrors = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          transitions = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          spawnedLane = executionContext;
          executionContext |= CommitContext;
          try {
            commitBeforeMutationEffects(root3, finishedWork, lanes);
          } finally {
            executionContext = spawnedLane, ReactDOMSharedInternals.p = transitions, ReactSharedInternals.T = recoverableErrors;
          }
        }
        pendingEffectsStatus = PENDING_MUTATION_PHASE;
        flushMutationEffects();
        flushLayoutEffects();
        flushSpawnedWork();
      }
    }
    function flushMutationEffects() {
      if (pendingEffectsStatus === PENDING_MUTATION_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var root3 = pendingEffectsRoot, finishedWork = pendingFinishedWork, lanes = pendingEffectsLanes, rootMutationHasEffect = 0 !== (finishedWork.flags & 13878);
        if (0 !== (finishedWork.subtreeFlags & 13878) || rootMutationHasEffect) {
          rootMutationHasEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            inProgressLanes = lanes;
            inProgressRoot = root3;
            resetComponentEffectTimers();
            commitMutationEffectsOnFiber(finishedWork, root3);
            inProgressRoot = inProgressLanes = null;
            lanes = selectionInformation;
            var curFocusedElem = getActiveElementDeep(root3.containerInfo), priorFocusedElem = lanes.focusedElem, priorSelectionRange = lanes.selectionRange;
            if (curFocusedElem !== priorFocusedElem && priorFocusedElem && priorFocusedElem.ownerDocument && containsNode(
              priorFocusedElem.ownerDocument.documentElement,
              priorFocusedElem
            )) {
              if (null !== priorSelectionRange && hasSelectionCapabilities(priorFocusedElem)) {
                var start = priorSelectionRange.start, end = priorSelectionRange.end;
                void 0 === end && (end = start);
                if ("selectionStart" in priorFocusedElem)
                  priorFocusedElem.selectionStart = start, priorFocusedElem.selectionEnd = Math.min(
                    end,
                    priorFocusedElem.value.length
                  );
                else {
                  var doc2 = priorFocusedElem.ownerDocument || document, win = doc2 && doc2.defaultView || window;
                  if (win.getSelection) {
                    var selection2 = win.getSelection(), length = priorFocusedElem.textContent.length, start$jscomp$0 = Math.min(
                      priorSelectionRange.start,
                      length
                    ), end$jscomp$0 = void 0 === priorSelectionRange.end ? start$jscomp$0 : Math.min(priorSelectionRange.end, length);
                    !selection2.extend && start$jscomp$0 > end$jscomp$0 && (curFocusedElem = end$jscomp$0, end$jscomp$0 = start$jscomp$0, start$jscomp$0 = curFocusedElem);
                    var startMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      start$jscomp$0
                    ), endMarker = getNodeForCharacterOffset(
                      priorFocusedElem,
                      end$jscomp$0
                    );
                    if (startMarker && endMarker && (1 !== selection2.rangeCount || selection2.anchorNode !== startMarker.node || selection2.anchorOffset !== startMarker.offset || selection2.focusNode !== endMarker.node || selection2.focusOffset !== endMarker.offset)) {
                      var range2 = doc2.createRange();
                      range2.setStart(startMarker.node, startMarker.offset);
                      selection2.removeAllRanges();
                      start$jscomp$0 > end$jscomp$0 ? (selection2.addRange(range2), selection2.extend(endMarker.node, endMarker.offset)) : (range2.setEnd(endMarker.node, endMarker.offset), selection2.addRange(range2));
                    }
                  }
                }
              }
              doc2 = [];
              for (selection2 = priorFocusedElem; selection2 = selection2.parentNode; )
                1 === selection2.nodeType && doc2.push({
                  element: selection2,
                  left: selection2.scrollLeft,
                  top: selection2.scrollTop
                });
              "function" === typeof priorFocusedElem.focus && priorFocusedElem.focus();
              for (priorFocusedElem = 0; priorFocusedElem < doc2.length; priorFocusedElem++) {
                var info = doc2[priorFocusedElem];
                info.element.scrollLeft = info.left;
                info.element.scrollTop = info.top;
              }
            }
            _enabled = !!eventsEnabled;
            selectionInformation = eventsEnabled = null;
          } finally {
            executionContext = prevExecutionContext, ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = rootMutationHasEffect;
          }
        }
        root3.current = finishedWork;
        pendingEffectsStatus = PENDING_LAYOUT_PHASE;
      }
    }
    function flushLayoutEffects() {
      if (pendingEffectsStatus === PENDING_LAYOUT_PHASE) {
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        var suspendedViewTransitionReason = pendingSuspendedViewTransitionReason;
        if (null !== suspendedViewTransitionReason) {
          commitStartTime = now();
          var startTime = commitEndTime, endTime = commitStartTime;
          !supportsUserTiming || endTime <= startTime || console.timeStamp(
            suspendedViewTransitionReason,
            startTime,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-light"
          );
        }
        suspendedViewTransitionReason = pendingEffectsRoot;
        startTime = pendingFinishedWork;
        endTime = pendingEffectsLanes;
        var rootHasLayoutEffect = 0 !== (startTime.flags & 8772);
        if (0 !== (startTime.subtreeFlags & 8772) || rootHasLayoutEffect) {
          rootHasLayoutEffect = ReactSharedInternals.T;
          ReactSharedInternals.T = null;
          var _previousPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          var _prevExecutionContext = executionContext;
          executionContext |= CommitContext;
          try {
            inProgressLanes = endTime, inProgressRoot = suspendedViewTransitionReason, resetComponentEffectTimers(), commitLayoutEffectOnFiber(
              suspendedViewTransitionReason,
              startTime.alternate,
              startTime
            ), inProgressRoot = inProgressLanes = null;
          } finally {
            executionContext = _prevExecutionContext, ReactDOMSharedInternals.p = _previousPriority, ReactSharedInternals.T = rootHasLayoutEffect;
          }
        }
        suspendedViewTransitionReason = pendingEffectsRenderEndTime;
        startTime = pendingSuspendedCommitReason;
        commitEndTime = now();
        suspendedViewTransitionReason = null === startTime ? suspendedViewTransitionReason : commitStartTime;
        startTime = commitEndTime;
        endTime = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
        rootHasLayoutEffect = workInProgressUpdateTask;
        null !== commitErrors ? logCommitErrored(
          suspendedViewTransitionReason,
          startTime,
          commitErrors,
          false,
          rootHasLayoutEffect
        ) : !supportsUserTiming || startTime <= suspendedViewTransitionReason || (rootHasLayoutEffect ? rootHasLayoutEffect.run(
          console.timeStamp.bind(
            console,
            endTime ? "Commit Interrupted View Transition" : "Commit",
            suspendedViewTransitionReason,
            startTime,
            currentTrack,
            LANES_TRACK_GROUP,
            endTime ? "error" : "secondary-dark"
          )
        ) : console.timeStamp(
          endTime ? "Commit Interrupted View Transition" : "Commit",
          suspendedViewTransitionReason,
          startTime,
          currentTrack,
          LANES_TRACK_GROUP,
          endTime ? "error" : "secondary-dark"
        ));
        pendingEffectsStatus = PENDING_AFTER_MUTATION_PHASE;
      }
    }
    function flushSpawnedWork() {
      if (pendingEffectsStatus === PENDING_SPAWNED_WORK || pendingEffectsStatus === PENDING_AFTER_MUTATION_PHASE) {
        if (pendingEffectsStatus === PENDING_SPAWNED_WORK) {
          var startViewTransitionStartTime = commitEndTime;
          commitEndTime = now();
          var endTime = commitEndTime, abortedViewTransition = pendingDelayedCommitReason === ABORTED_VIEW_TRANSITION_COMMIT;
          !supportsUserTiming || endTime <= startViewTransitionStartTime || console.timeStamp(
            abortedViewTransition ? "Interrupted View Transition" : "Starting Animation",
            startViewTransitionStartTime,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            abortedViewTransition ? " error" : "secondary-light"
          );
          pendingDelayedCommitReason !== ABORTED_VIEW_TRANSITION_COMMIT && (pendingDelayedCommitReason = ANIMATION_STARTED_COMMIT);
        }
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        requestPaint();
        startViewTransitionStartTime = pendingEffectsRoot;
        var finishedWork = pendingFinishedWork;
        endTime = pendingEffectsLanes;
        abortedViewTransition = pendingRecoverableErrors;
        var rootDidHavePassiveEffects = 0 !== finishedWork.actualDuration || 0 !== (finishedWork.subtreeFlags & 10256) || 0 !== (finishedWork.flags & 10256);
        rootDidHavePassiveEffects ? pendingEffectsStatus = PENDING_PASSIVE_PHASE : (pendingEffectsStatus = NO_PENDING_EFFECTS, pendingFinishedWork = pendingEffectsRoot = null, releaseRootPooledCache(
          startViewTransitionStartTime,
          startViewTransitionStartTime.pendingLanes
        ), nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null);
        var remainingLanes = startViewTransitionStartTime.pendingLanes;
        0 === remainingLanes && (legacyErrorBoundariesThatAlreadyFailed = null);
        rootDidHavePassiveEffects || commitDoubleInvokeEffectsInDEV(startViewTransitionStartTime);
        remainingLanes = lanesToEventPriority(endTime);
        finishedWork = finishedWork.stateNode;
        if (injectedHook && "function" === typeof injectedHook.onCommitFiberRoot)
          try {
            var didError = 128 === (finishedWork.current.flags & 128);
            switch (remainingLanes) {
              case DiscreteEventPriority:
                var schedulerPriority = ImmediatePriority;
                break;
              case ContinuousEventPriority:
                schedulerPriority = UserBlockingPriority;
                break;
              case DefaultEventPriority:
                schedulerPriority = NormalPriority$1;
                break;
              case IdleEventPriority:
                schedulerPriority = IdlePriority;
                break;
              default:
                schedulerPriority = NormalPriority$1;
            }
            injectedHook.onCommitFiberRoot(
              rendererID,
              finishedWork,
              schedulerPriority,
              didError
            );
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %o",
              err
            ));
          }
        isDevToolsPresent && startViewTransitionStartTime.memoizedUpdaters.clear();
        onCommitRoot();
        if (null !== abortedViewTransition) {
          didError = ReactSharedInternals.T;
          schedulerPriority = ReactDOMSharedInternals.p;
          ReactDOMSharedInternals.p = DiscreteEventPriority;
          ReactSharedInternals.T = null;
          try {
            var onRecoverableError = startViewTransitionStartTime.onRecoverableError;
            for (finishedWork = 0; finishedWork < abortedViewTransition.length; finishedWork++) {
              var recoverableError = abortedViewTransition[finishedWork], errorInfo = makeErrorInfo(recoverableError.stack);
              runWithFiberInDEV(
                recoverableError.source,
                onRecoverableError,
                recoverableError.value,
                errorInfo
              );
            }
          } finally {
            ReactSharedInternals.T = didError, ReactDOMSharedInternals.p = schedulerPriority;
          }
        }
        0 !== (pendingEffectsLanes & 3) && flushPendingEffects();
        ensureRootIsScheduled(startViewTransitionStartTime);
        remainingLanes = startViewTransitionStartTime.pendingLanes;
        0 !== (endTime & 261930) && 0 !== (remainingLanes & 42) ? (nestedUpdateScheduled = true, startViewTransitionStartTime === rootWithNestedUpdates ? nestedUpdateCount++ : (nestedUpdateCount = 0, rootWithNestedUpdates = startViewTransitionStartTime)) : nestedUpdateCount = 0;
        rootDidHavePassiveEffects || finalizeRender(endTime, commitEndTime);
        flushSyncWorkAcrossRoots_impl(0);
      }
    }
    function makeErrorInfo(componentStack) {
      componentStack = { componentStack };
      Object.defineProperty(componentStack, "digest", {
        get: function() {
          console.error(
            'You are accessing "digest" from the errorInfo object passed to onRecoverableError. This property is no longer provided as part of errorInfo but can be accessed as a property of the Error instance itself.'
          );
        }
      });
      return componentStack;
    }
    function releaseRootPooledCache(root3, remainingLanes) {
      0 === (root3.pooledCacheLanes &= remainingLanes) && (remainingLanes = root3.pooledCache, null != remainingLanes && (root3.pooledCache = null, releaseCache(remainingLanes)));
    }
    function flushPendingEffects() {
      flushMutationEffects();
      flushLayoutEffects();
      flushSpawnedWork();
      return flushPassiveEffects();
    }
    function flushPassiveEffects() {
      if (pendingEffectsStatus !== PENDING_PASSIVE_PHASE) return false;
      var root3 = pendingEffectsRoot, remainingLanes = pendingEffectsRemainingLanes;
      pendingEffectsRemainingLanes = 0;
      var renderPriority = lanesToEventPriority(pendingEffectsLanes), priority = DefaultEventPriority > renderPriority ? DefaultEventPriority : renderPriority;
      renderPriority = ReactSharedInternals.T;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = priority;
        ReactSharedInternals.T = null;
        var transitions = pendingPassiveTransitions;
        pendingPassiveTransitions = null;
        priority = pendingEffectsRoot;
        var lanes = pendingEffectsLanes;
        pendingEffectsStatus = NO_PENDING_EFFECTS;
        pendingFinishedWork = pendingEffectsRoot = null;
        pendingEffectsLanes = 0;
        if ((executionContext & (RenderContext | CommitContext)) !== NoContext)
          throw Error("Cannot flush passive effects while already rendering.");
        setCurrentTrackFromLanes(lanes);
        isFlushingPassiveEffects = true;
        didScheduleUpdateDuringPassiveEffects = false;
        var passiveEffectStartTime = 0;
        commitErrors = null;
        passiveEffectStartTime = now$1();
        if (pendingDelayedCommitReason === ANIMATION_STARTED_COMMIT)
          logAnimatingPhase(
            commitEndTime,
            passiveEffectStartTime,
            animatingTask
          );
        else {
          var startTime = commitEndTime, endTime = passiveEffectStartTime, delayedUntilPaint = pendingDelayedCommitReason === DELAYED_PASSIVE_COMMIT;
          !supportsUserTiming || endTime <= startTime || (workInProgressUpdateTask ? workInProgressUpdateTask.run(
            console.timeStamp.bind(
              console,
              delayedUntilPaint ? "Waiting for Paint" : "Waiting",
              startTime,
              endTime,
              currentTrack,
              LANES_TRACK_GROUP,
              "secondary-light"
            )
          ) : console.timeStamp(
            delayedUntilPaint ? "Waiting for Paint" : "Waiting",
            startTime,
            endTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-light"
          ));
        }
        startTime = executionContext;
        executionContext |= CommitContext;
        var finishedWork = priority.current;
        resetComponentEffectTimers();
        commitPassiveUnmountOnFiber(finishedWork);
        var finishedWork$jscomp$0 = priority.current;
        finishedWork = pendingEffectsRenderEndTime;
        resetComponentEffectTimers();
        commitPassiveMountOnFiber(
          priority,
          finishedWork$jscomp$0,
          lanes,
          transitions,
          finishedWork
        );
        commitDoubleInvokeEffectsInDEV(priority);
        executionContext = startTime;
        var passiveEffectsEndTime = now$1();
        finishedWork$jscomp$0 = passiveEffectStartTime;
        finishedWork = workInProgressUpdateTask;
        null !== commitErrors ? logCommitErrored(
          finishedWork$jscomp$0,
          passiveEffectsEndTime,
          commitErrors,
          true,
          finishedWork
        ) : !supportsUserTiming || passiveEffectsEndTime <= finishedWork$jscomp$0 || (finishedWork ? finishedWork.run(
          console.timeStamp.bind(
            console,
            "Remaining Effects",
            finishedWork$jscomp$0,
            passiveEffectsEndTime,
            currentTrack,
            LANES_TRACK_GROUP,
            "secondary-dark"
          )
        ) : console.timeStamp(
          "Remaining Effects",
          finishedWork$jscomp$0,
          passiveEffectsEndTime,
          currentTrack,
          LANES_TRACK_GROUP,
          "secondary-dark"
        ));
        finalizeRender(lanes, passiveEffectsEndTime);
        flushSyncWorkAcrossRoots_impl(0, false);
        didScheduleUpdateDuringPassiveEffects ? priority === rootWithPassiveNestedUpdates ? nestedPassiveUpdateCount++ : (nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = priority) : nestedPassiveUpdateCount = 0;
        didScheduleUpdateDuringPassiveEffects = isFlushingPassiveEffects = false;
        if (injectedHook && "function" === typeof injectedHook.onPostCommitFiberRoot)
          try {
            injectedHook.onPostCommitFiberRoot(rendererID, priority);
          } catch (err) {
            hasLoggedError || (hasLoggedError = true, console.error(
              "React instrumentation encountered an error: %o",
              err
            ));
          }
        var stateNode = priority.current.stateNode;
        stateNode.effectDuration = 0;
        stateNode.passiveEffectDuration = 0;
        return true;
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = renderPriority, releaseRootPooledCache(root3, remainingLanes);
      }
    }
    function captureCommitPhaseErrorOnRoot(rootFiber, sourceFiber, error) {
      sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
      recordEffectError(sourceFiber);
      sourceFiber = createRootErrorUpdate(rootFiber.stateNode, sourceFiber, 2);
      rootFiber = enqueueUpdate(rootFiber, sourceFiber, 2);
      null !== rootFiber && (markRootUpdated$1(rootFiber, 2), ensureRootIsScheduled(rootFiber));
    }
    function captureCommitPhaseError(sourceFiber, nearestMountedAncestor, error) {
      isRunningInsertionEffect = false;
      if (3 === sourceFiber.tag)
        captureCommitPhaseErrorOnRoot(sourceFiber, sourceFiber, error);
      else {
        for (; null !== nearestMountedAncestor; ) {
          if (3 === nearestMountedAncestor.tag) {
            captureCommitPhaseErrorOnRoot(
              nearestMountedAncestor,
              sourceFiber,
              error
            );
            return;
          }
          if (1 === nearestMountedAncestor.tag) {
            var instance = nearestMountedAncestor.stateNode;
            if ("function" === typeof nearestMountedAncestor.type.getDerivedStateFromError || "function" === typeof instance.componentDidCatch && (null === legacyErrorBoundariesThatAlreadyFailed || !legacyErrorBoundariesThatAlreadyFailed.has(instance))) {
              sourceFiber = createCapturedValueAtFiber(error, sourceFiber);
              recordEffectError(sourceFiber);
              error = createClassErrorUpdate(2);
              instance = enqueueUpdate(nearestMountedAncestor, error, 2);
              null !== instance && (initializeClassErrorUpdate(
                error,
                instance,
                nearestMountedAncestor,
                sourceFiber
              ), markRootUpdated$1(instance, 2), ensureRootIsScheduled(instance));
              return;
            }
          }
          nearestMountedAncestor = nearestMountedAncestor.return;
        }
        console.error(
          "Internal React error: Attempted to capture a commit phase error inside a detached tree. This indicates a bug in React. Potential causes include deleting the same fiber more than once, committing an already-finished tree, or an inconsistent return pointer.\n\nError message:\n\n%s",
          error
        );
      }
    }
    function attachPingListener(root3, wakeable, lanes) {
      var pingCache = root3.pingCache;
      if (null === pingCache) {
        pingCache = root3.pingCache = new PossiblyWeakMap();
        var threadIDs = /* @__PURE__ */ new Set();
        pingCache.set(wakeable, threadIDs);
      } else
        threadIDs = pingCache.get(wakeable), void 0 === threadIDs && (threadIDs = /* @__PURE__ */ new Set(), pingCache.set(wakeable, threadIDs));
      threadIDs.has(lanes) || (workInProgressRootDidAttachPingListener = true, threadIDs.add(lanes), pingCache = pingSuspendedRoot.bind(null, root3, wakeable, lanes), isDevToolsPresent && restorePendingUpdaters(root3, lanes), wakeable.then(pingCache, pingCache));
    }
    function pingSuspendedRoot(root3, wakeable, pingedLanes) {
      var pingCache = root3.pingCache;
      null !== pingCache && pingCache.delete(wakeable);
      root3.pingedLanes |= root3.suspendedLanes & pingedLanes;
      root3.warmLanes &= ~pingedLanes;
      0 !== (pingedLanes & 127) ? 0 > blockingUpdateTime && (blockingClampTime = blockingUpdateTime = now(), blockingUpdateTask = createTask("Promise Resolved"), blockingUpdateType = PINGED_UPDATE) : 0 !== (pingedLanes & 4194048) && 0 > transitionUpdateTime && (transitionClampTime = transitionUpdateTime = now(), transitionUpdateTask = createTask("Promise Resolved"), transitionUpdateType = PINGED_UPDATE);
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && console.error(
        "A suspended resource finished loading inside a test, but the event was not wrapped in act(...).\n\nWhen testing, code that resolves suspended data should be wrapped into act(...):\n\nact(() => {\n  /* finish loading suspended data */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act"
      );
      workInProgressRoot === root3 && (workInProgressRootRenderLanes & pingedLanes) === pingedLanes && (workInProgressRootExitStatus === RootSuspendedWithDelay || workInProgressRootExitStatus === RootSuspended && (workInProgressRootRenderLanes & 62914560) === workInProgressRootRenderLanes && now$1() - globalMostRecentFallbackTime < FALLBACK_THROTTLE_MS ? (executionContext & RenderContext) === NoContext && prepareFreshStack(root3, 0) : workInProgressRootPingedLanes |= pingedLanes, workInProgressSuspendedRetryLanes === workInProgressRootRenderLanes && (workInProgressSuspendedRetryLanes = 0));
      ensureRootIsScheduled(root3);
    }
    function retryTimedOutBoundary(boundaryFiber, retryLane) {
      0 === retryLane && (retryLane = claimNextRetryLane());
      boundaryFiber = enqueueConcurrentRenderForLane(boundaryFiber, retryLane);
      null !== boundaryFiber && (markRootUpdated$1(boundaryFiber, retryLane), ensureRootIsScheduled(boundaryFiber));
    }
    function retryDehydratedSuspenseBoundary(boundaryFiber) {
      var suspenseState = boundaryFiber.memoizedState, retryLane = 0;
      null !== suspenseState && (retryLane = suspenseState.retryLane);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function resolveRetryWakeable(boundaryFiber, wakeable) {
      var retryLane = 0;
      switch (boundaryFiber.tag) {
        case 31:
        case 13:
          var retryCache = boundaryFiber.stateNode;
          var suspenseState = boundaryFiber.memoizedState;
          null !== suspenseState && (retryLane = suspenseState.retryLane);
          break;
        case 19:
          retryCache = boundaryFiber.stateNode;
          break;
        case 22:
          retryCache = boundaryFiber.stateNode._retryCache;
          break;
        default:
          throw Error(
            "Pinged unknown suspense boundary type. This is probably a bug in React."
          );
      }
      null !== retryCache && retryCache.delete(wakeable);
      retryTimedOutBoundary(boundaryFiber, retryLane);
    }
    function recursivelyTraverseAndDoubleInvokeEffectsInDEV(root$jscomp$0, parentFiber, isInStrictMode) {
      if (0 !== (parentFiber.subtreeFlags & 67117056))
        for (parentFiber = parentFiber.child; null !== parentFiber; ) {
          var root3 = root$jscomp$0, fiber = parentFiber, isStrictModeFiber = fiber.type === REACT_STRICT_MODE_TYPE;
          isStrictModeFiber = isInStrictMode || isStrictModeFiber;
          22 !== fiber.tag ? fiber.flags & 67108864 ? isStrictModeFiber && runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root3,
            fiber
          ) : recursivelyTraverseAndDoubleInvokeEffectsInDEV(
            root3,
            fiber,
            isStrictModeFiber
          ) : null === fiber.memoizedState && (isStrictModeFiber && fiber.flags & 8192 ? runWithFiberInDEV(
            fiber,
            doubleInvokeEffectsOnFiber,
            root3,
            fiber
          ) : fiber.subtreeFlags & 67108864 && runWithFiberInDEV(
            fiber,
            recursivelyTraverseAndDoubleInvokeEffectsInDEV,
            root3,
            fiber,
            isStrictModeFiber
          ));
          parentFiber = parentFiber.sibling;
        }
    }
    function doubleInvokeEffectsOnFiber(root3, fiber) {
      setIsStrictModeForDevtools(true);
      try {
        disappearLayoutEffects(fiber), disconnectPassiveEffect(fiber), reappearLayoutEffects(root3, fiber.alternate, fiber, false), reconnectPassiveEffects(root3, fiber, 0, null, false, 0);
      } finally {
        setIsStrictModeForDevtools(false);
      }
    }
    function commitDoubleInvokeEffectsInDEV(root3) {
      var doubleInvokeEffects = true;
      root3.current.mode & (StrictLegacyMode | StrictEffectsMode) || (doubleInvokeEffects = false);
      recursivelyTraverseAndDoubleInvokeEffectsInDEV(
        root3,
        root3.current,
        doubleInvokeEffects
      );
    }
    function warnAboutUpdateOnNotYetMountedFiberInDEV(fiber) {
      if ((executionContext & RenderContext) === NoContext) {
        var tag2 = fiber.tag;
        if (3 === tag2 || 1 === tag2 || 0 === tag2 || 11 === tag2 || 14 === tag2 || 15 === tag2) {
          tag2 = getComponentNameFromFiber(fiber) || "ReactComponent";
          if (null !== didWarnStateUpdateForNotYetMountedComponent) {
            if (didWarnStateUpdateForNotYetMountedComponent.has(tag2)) return;
            didWarnStateUpdateForNotYetMountedComponent.add(tag2);
          } else didWarnStateUpdateForNotYetMountedComponent = /* @__PURE__ */ new Set([tag2]);
          runWithFiberInDEV(fiber, function() {
            console.error(
              "Can't perform a React state update on a component that hasn't mounted yet. This indicates that you have a side-effect in your render function that asynchronously tries to update the component. Move this work to useEffect instead."
            );
          });
        }
      }
    }
    function restorePendingUpdaters(root3, lanes) {
      isDevToolsPresent && root3.memoizedUpdaters.forEach(function(schedulingFiber) {
        addFiberToLanesMap(root3, schedulingFiber, lanes);
      });
    }
    function scheduleCallback$1(priorityLevel, callback) {
      var actQueue = ReactSharedInternals.actQueue;
      return null !== actQueue ? (actQueue.push(callback), fakeActCallbackNode$1) : scheduleCallback$3(priorityLevel, callback);
    }
    function warnIfUpdatesNotWrappedWithActDEV(fiber) {
      isConcurrentActEnvironment() && null === ReactSharedInternals.actQueue && runWithFiberInDEV(fiber, function() {
        console.error(
          "An update to %s inside a test was not wrapped in act(...).\n\nWhen testing, code that causes React state updates should be wrapped into act(...):\n\nact(() => {\n  /* fire events that update state */\n});\n/* assert on the output */\n\nThis ensures that you're testing the behavior the user would see in the browser. Learn more at https://react.dev/link/wrap-tests-with-act",
          getComponentNameFromFiber(fiber)
        );
      });
    }
    function ensureRootIsScheduled(root3) {
      root3 !== lastScheduledRoot && null === root3.next && (null === lastScheduledRoot ? firstScheduledRoot = lastScheduledRoot = root3 : lastScheduledRoot = lastScheduledRoot.next = root3);
      mightHavePendingSyncWork = true;
      null !== ReactSharedInternals.actQueue ? didScheduleMicrotask_act || (didScheduleMicrotask_act = true, scheduleImmediateRootScheduleTask()) : didScheduleMicrotask || (didScheduleMicrotask = true, scheduleImmediateRootScheduleTask());
    }
    function flushSyncWorkAcrossRoots_impl(syncTransitionLanes, onlyLegacy) {
      if (!isFlushingWork && mightHavePendingSyncWork) {
        isFlushingWork = true;
        do {
          var didPerformSomeWork = false;
          for (var root3 = firstScheduledRoot; null !== root3; ) {
            if (0 !== syncTransitionLanes) {
              var pendingLanes = root3.pendingLanes;
              if (0 === pendingLanes) var nextLanes = 0;
              else {
                var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes;
                nextLanes = (1 << 31 - clz32(42 | syncTransitionLanes) + 1) - 1;
                nextLanes &= pendingLanes & ~(suspendedLanes & ~pingedLanes);
                nextLanes = nextLanes & 201326741 ? nextLanes & 201326741 | 1 : nextLanes ? nextLanes | 2 : 0;
              }
              0 !== nextLanes && (didPerformSomeWork = true, performSyncWorkOnRoot(root3, nextLanes));
            } else
              nextLanes = workInProgressRootRenderLanes, nextLanes = getNextLanes(
                root3,
                root3 === workInProgressRoot ? nextLanes : 0,
                null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
              ), 0 === (nextLanes & 3) || checkIfRootIsPrerendering(root3, nextLanes) || (didPerformSomeWork = true, performSyncWorkOnRoot(root3, nextLanes));
            root3 = root3.next;
          }
        } while (didPerformSomeWork);
        isFlushingWork = false;
      }
    }
    function processRootScheduleInImmediateTask() {
      schedulerEvent = window.event;
      processRootScheduleInMicrotask();
    }
    function processRootScheduleInMicrotask() {
      mightHavePendingSyncWork = didScheduleMicrotask_act = didScheduleMicrotask = false;
      var syncTransitionLanes = 0;
      0 !== currentEventTransitionLane && shouldAttemptEagerTransition() && (syncTransitionLanes = currentEventTransitionLane);
      for (var currentTime = now$1(), prev = null, root3 = firstScheduledRoot; null !== root3; ) {
        var next = root3.next, nextLanes = scheduleTaskForRootDuringMicrotask(root3, currentTime);
        if (0 === nextLanes)
          root3.next = null, null === prev ? firstScheduledRoot = next : prev.next = next, null === next && (lastScheduledRoot = prev);
        else if (prev = root3, 0 !== syncTransitionLanes || 0 !== (nextLanes & 3))
          mightHavePendingSyncWork = true;
        root3 = next;
      }
      pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE || flushSyncWorkAcrossRoots_impl(syncTransitionLanes);
      0 !== currentEventTransitionLane && (currentEventTransitionLane = 0);
    }
    function scheduleTaskForRootDuringMicrotask(root3, currentTime) {
      for (var suspendedLanes = root3.suspendedLanes, pingedLanes = root3.pingedLanes, expirationTimes = root3.expirationTimes, lanes = root3.pendingLanes & -62914561; 0 < lanes; ) {
        var index2 = 31 - clz32(lanes), lane = 1 << index2, expirationTime = expirationTimes[index2];
        if (-1 === expirationTime) {
          if (0 === (lane & suspendedLanes) || 0 !== (lane & pingedLanes))
            expirationTimes[index2] = computeExpirationTime(lane, currentTime);
        } else expirationTime <= currentTime && (root3.expiredLanes |= lane);
        lanes &= ~lane;
      }
      currentTime = workInProgressRoot;
      suspendedLanes = workInProgressRootRenderLanes;
      suspendedLanes = getNextLanes(
        root3,
        root3 === currentTime ? suspendedLanes : 0,
        null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
      );
      pingedLanes = root3.callbackNode;
      if (0 === suspendedLanes || root3 === currentTime && (workInProgressSuspendedReason === SuspendedOnData || workInProgressSuspendedReason === SuspendedOnAction) || null !== root3.cancelPendingCommit)
        return null !== pingedLanes && cancelCallback(pingedLanes), root3.callbackNode = null, root3.callbackPriority = 0;
      if (0 === (suspendedLanes & 3) || checkIfRootIsPrerendering(root3, suspendedLanes)) {
        currentTime = suspendedLanes & -suspendedLanes;
        if (currentTime !== root3.callbackPriority || null !== ReactSharedInternals.actQueue && pingedLanes !== fakeActCallbackNode)
          cancelCallback(pingedLanes);
        else return currentTime;
        switch (lanesToEventPriority(suspendedLanes)) {
          case DiscreteEventPriority:
          case ContinuousEventPriority:
            suspendedLanes = UserBlockingPriority;
            break;
          case DefaultEventPriority:
            suspendedLanes = NormalPriority$1;
            break;
          case IdleEventPriority:
            suspendedLanes = IdlePriority;
            break;
          default:
            suspendedLanes = NormalPriority$1;
        }
        pingedLanes = performWorkOnRootViaSchedulerTask.bind(null, root3);
        null !== ReactSharedInternals.actQueue ? (ReactSharedInternals.actQueue.push(pingedLanes), suspendedLanes = fakeActCallbackNode) : suspendedLanes = scheduleCallback$3(suspendedLanes, pingedLanes);
        root3.callbackPriority = currentTime;
        root3.callbackNode = suspendedLanes;
        return currentTime;
      }
      null !== pingedLanes && cancelCallback(pingedLanes);
      root3.callbackPriority = 2;
      root3.callbackNode = null;
      return 2;
    }
    function performWorkOnRootViaSchedulerTask(root3, didTimeout) {
      nestedUpdateScheduled = currentUpdateIsNested = false;
      schedulerEvent = window.event;
      if (pendingEffectsStatus !== NO_PENDING_EFFECTS && pendingEffectsStatus !== PENDING_PASSIVE_PHASE)
        return root3.callbackNode = null, root3.callbackPriority = 0, null;
      var originalCallbackNode = root3.callbackNode;
      pendingDelayedCommitReason === IMMEDIATE_COMMIT && (pendingDelayedCommitReason = DELAYED_PASSIVE_COMMIT);
      if (flushPendingEffects() && root3.callbackNode !== originalCallbackNode)
        return null;
      var workInProgressRootRenderLanes$jscomp$0 = workInProgressRootRenderLanes;
      workInProgressRootRenderLanes$jscomp$0 = getNextLanes(
        root3,
        root3 === workInProgressRoot ? workInProgressRootRenderLanes$jscomp$0 : 0,
        null !== root3.cancelPendingCommit || root3.timeoutHandle !== noTimeout
      );
      if (0 === workInProgressRootRenderLanes$jscomp$0) return null;
      performWorkOnRoot(
        root3,
        workInProgressRootRenderLanes$jscomp$0,
        didTimeout
      );
      scheduleTaskForRootDuringMicrotask(root3, now$1());
      return null != root3.callbackNode && root3.callbackNode === originalCallbackNode ? performWorkOnRootViaSchedulerTask.bind(null, root3) : null;
    }
    function performSyncWorkOnRoot(root3, lanes) {
      if (flushPendingEffects()) return null;
      currentUpdateIsNested = nestedUpdateScheduled;
      nestedUpdateScheduled = false;
      performWorkOnRoot(root3, lanes, true);
    }
    function cancelCallback(callbackNode) {
      callbackNode !== fakeActCallbackNode && null !== callbackNode && cancelCallback$1(callbackNode);
    }
    function scheduleImmediateRootScheduleTask() {
      null !== ReactSharedInternals.actQueue && ReactSharedInternals.actQueue.push(function() {
        processRootScheduleInMicrotask();
        return null;
      });
      scheduleMicrotask(function() {
        (executionContext & (RenderContext | CommitContext)) !== NoContext ? scheduleCallback$3(
          ImmediatePriority,
          processRootScheduleInImmediateTask
        ) : processRootScheduleInMicrotask();
      });
    }
    function requestTransitionLane() {
      if (0 === currentEventTransitionLane) {
        var actionScopeLane = currentEntangledLane;
        0 === actionScopeLane && (actionScopeLane = nextTransitionUpdateLane, nextTransitionUpdateLane <<= 1, 0 === (nextTransitionUpdateLane & 261888) && (nextTransitionUpdateLane = 256));
        currentEventTransitionLane = actionScopeLane;
      }
      return currentEventTransitionLane;
    }
    function coerceFormActionProp(actionProp) {
      if (null == actionProp || "symbol" === typeof actionProp || "boolean" === typeof actionProp)
        return null;
      if ("function" === typeof actionProp) return actionProp;
      checkAttributeStringCoercion(actionProp, "action");
      return sanitizeURL("" + actionProp);
    }
    function createFormDataWithSubmitter(form, submitter) {
      var temp = submitter.ownerDocument.createElement("input");
      temp.name = submitter.name;
      temp.value = submitter.value;
      form.id && temp.setAttribute("form", form.id);
      submitter.parentNode.insertBefore(temp, submitter);
      form = new FormData(form);
      temp.parentNode.removeChild(temp);
      return form;
    }
    function extractEvents$1(dispatchQueue, domEventName, maybeTargetInst, nativeEvent, nativeEventTarget) {
      if ("submit" === domEventName && maybeTargetInst && maybeTargetInst.stateNode === nativeEventTarget) {
        var action = coerceFormActionProp(
          (nativeEventTarget[internalPropsKey] || null).action
        ), submitter = nativeEvent.submitter;
        submitter && (domEventName = (domEventName = submitter[internalPropsKey] || null) ? coerceFormActionProp(domEventName.formAction) : submitter.getAttribute("formAction"), null !== domEventName && (action = domEventName, submitter = null));
        var event = new SyntheticEvent(
          "action",
          "action",
          null,
          nativeEvent,
          nativeEventTarget
        );
        dispatchQueue.push({
          event,
          listeners: [
            {
              instance: null,
              listener: function() {
                if (nativeEvent.defaultPrevented) {
                  if (0 !== currentEventTransitionLane) {
                    var formData = submitter ? createFormDataWithSubmitter(
                      nativeEventTarget,
                      submitter
                    ) : new FormData(nativeEventTarget), pendingState = {
                      pending: true,
                      data: formData,
                      method: nativeEventTarget.method,
                      action
                    };
                    Object.freeze(pendingState);
                    startHostTransition(
                      maybeTargetInst,
                      pendingState,
                      null,
                      formData
                    );
                  }
                } else
                  "function" === typeof action && (event.preventDefault(), formData = submitter ? createFormDataWithSubmitter(
                    nativeEventTarget,
                    submitter
                  ) : new FormData(nativeEventTarget), pendingState = {
                    pending: true,
                    data: formData,
                    method: nativeEventTarget.method,
                    action
                  }, Object.freeze(pendingState), startHostTransition(
                    maybeTargetInst,
                    pendingState,
                    action,
                    formData
                  ));
              },
              currentTarget: nativeEventTarget
            }
          ]
        });
      }
    }
    function executeDispatch(event, listener, currentTarget) {
      event.currentTarget = currentTarget;
      try {
        listener(event);
      } catch (error) {
        reportGlobalError(error);
      }
      event.currentTarget = null;
    }
    function processDispatchQueue(dispatchQueue, eventSystemFlags) {
      eventSystemFlags = 0 !== (eventSystemFlags & 4);
      for (var i2 = 0; i2 < dispatchQueue.length; i2++) {
        var _dispatchQueue$i = dispatchQueue[i2];
        a: {
          var previousInstance = void 0, event = _dispatchQueue$i.event;
          _dispatchQueue$i = _dispatchQueue$i.listeners;
          if (eventSystemFlags)
            for (var i$jscomp$0 = _dispatchQueue$i.length - 1; 0 <= i$jscomp$0; i$jscomp$0--) {
              var _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0], instance = _dispatchListeners$i.instance, currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
          else
            for (i$jscomp$0 = 0; i$jscomp$0 < _dispatchQueue$i.length; i$jscomp$0++) {
              _dispatchListeners$i = _dispatchQueue$i[i$jscomp$0];
              instance = _dispatchListeners$i.instance;
              currentTarget = _dispatchListeners$i.currentTarget;
              _dispatchListeners$i = _dispatchListeners$i.listener;
              if (instance !== previousInstance && event.isPropagationStopped())
                break a;
              null !== instance ? runWithFiberInDEV(
                instance,
                executeDispatch,
                event,
                _dispatchListeners$i,
                currentTarget
              ) : executeDispatch(event, _dispatchListeners$i, currentTarget);
              previousInstance = instance;
            }
        }
      }
    }
    function listenToNonDelegatedEvent(domEventName, targetElement) {
      nonDelegatedEvents.has(domEventName) || console.error(
        'Did not expect a listenToNonDelegatedEvent() call for "%s". This is a bug in React. Please file an issue.',
        domEventName
      );
      var listenerSet = targetElement[internalEventHandlersKey];
      void 0 === listenerSet && (listenerSet = targetElement[internalEventHandlersKey] = /* @__PURE__ */ new Set());
      var listenerSetKey = domEventName + "__bubble";
      listenerSet.has(listenerSetKey) || (addTrappedEventListener(targetElement, domEventName, 2, false), listenerSet.add(listenerSetKey));
    }
    function listenToNativeEvent(domEventName, isCapturePhaseListener, target) {
      nonDelegatedEvents.has(domEventName) && !isCapturePhaseListener && console.error(
        'Did not expect a listenToNativeEvent() call for "%s" in the bubble phase. This is a bug in React. Please file an issue.',
        domEventName
      );
      var eventSystemFlags = 0;
      isCapturePhaseListener && (eventSystemFlags |= 4);
      addTrappedEventListener(
        target,
        domEventName,
        eventSystemFlags,
        isCapturePhaseListener
      );
    }
    function listenToAllSupportedEvents(rootContainerElement) {
      if (!rootContainerElement[listeningMarker]) {
        rootContainerElement[listeningMarker] = true;
        allNativeEvents.forEach(function(domEventName) {
          "selectionchange" !== domEventName && (nonDelegatedEvents.has(domEventName) || listenToNativeEvent(domEventName, false, rootContainerElement), listenToNativeEvent(domEventName, true, rootContainerElement));
        });
        var ownerDocument = 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
        null === ownerDocument || ownerDocument[listeningMarker] || (ownerDocument[listeningMarker] = true, listenToNativeEvent("selectionchange", false, ownerDocument));
      }
    }
    function addTrappedEventListener(targetContainer, domEventName, eventSystemFlags, isCapturePhaseListener) {
      switch (getEventPriority(domEventName)) {
        case DiscreteEventPriority:
          var listenerWrapper = dispatchDiscreteEvent;
          break;
        case ContinuousEventPriority:
          listenerWrapper = dispatchContinuousEvent;
          break;
        default:
          listenerWrapper = dispatchEvent;
      }
      eventSystemFlags = listenerWrapper.bind(
        null,
        domEventName,
        eventSystemFlags,
        targetContainer
      );
      listenerWrapper = void 0;
      !passiveBrowserEventsSupported || "touchstart" !== domEventName && "touchmove" !== domEventName && "wheel" !== domEventName || (listenerWrapper = true);
      isCapturePhaseListener ? void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        capture: true,
        passive: listenerWrapper
      }) : targetContainer.addEventListener(domEventName, eventSystemFlags, true) : void 0 !== listenerWrapper ? targetContainer.addEventListener(domEventName, eventSystemFlags, {
        passive: listenerWrapper
      }) : targetContainer.addEventListener(
        domEventName,
        eventSystemFlags,
        false
      );
    }
    function dispatchEventForPluginEventSystem(domEventName, eventSystemFlags, nativeEvent, targetInst$jscomp$0, targetContainer) {
      var ancestorInst = targetInst$jscomp$0;
      if (0 === (eventSystemFlags & 1) && 0 === (eventSystemFlags & 2) && null !== targetInst$jscomp$0)
        a: for (; ; ) {
          if (null === targetInst$jscomp$0) return;
          var nodeTag = targetInst$jscomp$0.tag;
          if (3 === nodeTag || 4 === nodeTag) {
            var container = targetInst$jscomp$0.stateNode.containerInfo;
            if (container === targetContainer) break;
            if (4 === nodeTag)
              for (nodeTag = targetInst$jscomp$0.return; null !== nodeTag; ) {
                var grandTag = nodeTag.tag;
                if ((3 === grandTag || 4 === grandTag) && nodeTag.stateNode.containerInfo === targetContainer)
                  return;
                nodeTag = nodeTag.return;
              }
            for (; null !== container; ) {
              nodeTag = getClosestInstanceFromNode(container);
              if (null === nodeTag) return;
              grandTag = nodeTag.tag;
              if (5 === grandTag || 6 === grandTag || 26 === grandTag || 27 === grandTag) {
                targetInst$jscomp$0 = ancestorInst = nodeTag;
                continue a;
              }
              container = container.parentNode;
            }
          }
          targetInst$jscomp$0 = targetInst$jscomp$0.return;
        }
      batchedUpdates$1(function() {
        var targetInst = ancestorInst, nativeEventTarget = getEventTarget(nativeEvent), dispatchQueue = [];
        a: {
          var reactName = topLevelEventsToReactNames.get(domEventName);
          if (void 0 !== reactName) {
            var SyntheticEventCtor = SyntheticEvent, reactEventType = domEventName;
            switch (domEventName) {
              case "keypress":
                if (0 === getEventCharCode(nativeEvent)) break a;
              case "keydown":
              case "keyup":
                SyntheticEventCtor = SyntheticKeyboardEvent;
                break;
              case "focusin":
                reactEventType = "focus";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "focusout":
                reactEventType = "blur";
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "beforeblur":
              case "afterblur":
                SyntheticEventCtor = SyntheticFocusEvent;
                break;
              case "click":
                if (2 === nativeEvent.button) break a;
              case "auxclick":
              case "dblclick":
              case "mousedown":
              case "mousemove":
              case "mouseup":
              case "mouseout":
              case "mouseover":
              case "contextmenu":
                SyntheticEventCtor = SyntheticMouseEvent;
                break;
              case "drag":
              case "dragend":
              case "dragenter":
              case "dragexit":
              case "dragleave":
              case "dragover":
              case "dragstart":
              case "drop":
                SyntheticEventCtor = SyntheticDragEvent;
                break;
              case "touchcancel":
              case "touchend":
              case "touchmove":
              case "touchstart":
                SyntheticEventCtor = SyntheticTouchEvent;
                break;
              case ANIMATION_END:
              case ANIMATION_ITERATION:
              case ANIMATION_START:
                SyntheticEventCtor = SyntheticAnimationEvent;
                break;
              case TRANSITION_END:
                SyntheticEventCtor = SyntheticTransitionEvent;
                break;
              case "scroll":
              case "scrollend":
                SyntheticEventCtor = SyntheticUIEvent;
                break;
              case "wheel":
                SyntheticEventCtor = SyntheticWheelEvent;
                break;
              case "copy":
              case "cut":
              case "paste":
                SyntheticEventCtor = SyntheticClipboardEvent;
                break;
              case "gotpointercapture":
              case "lostpointercapture":
              case "pointercancel":
              case "pointerdown":
              case "pointermove":
              case "pointerout":
              case "pointerover":
              case "pointerup":
                SyntheticEventCtor = SyntheticPointerEvent;
                break;
              case "toggle":
              case "beforetoggle":
                SyntheticEventCtor = SyntheticToggleEvent;
            }
            var inCapturePhase = 0 !== (eventSystemFlags & 4), accumulateTargetOnly = !inCapturePhase && ("scroll" === domEventName || "scrollend" === domEventName), reactEventName = inCapturePhase ? null !== reactName ? reactName + "Capture" : null : reactName;
            inCapturePhase = [];
            for (var instance = targetInst, lastHostComponent; null !== instance; ) {
              var _instance2 = instance;
              lastHostComponent = _instance2.stateNode;
              _instance2 = _instance2.tag;
              5 !== _instance2 && 26 !== _instance2 && 27 !== _instance2 || null === lastHostComponent || null === reactEventName || (_instance2 = getListener(instance, reactEventName), null != _instance2 && inCapturePhase.push(
                createDispatchListener(
                  instance,
                  _instance2,
                  lastHostComponent
                )
              ));
              if (accumulateTargetOnly) break;
              instance = instance.return;
            }
            0 < inCapturePhase.length && (reactName = new SyntheticEventCtor(
              reactName,
              reactEventType,
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: reactName,
              listeners: inCapturePhase
            }));
          }
        }
        if (0 === (eventSystemFlags & 7)) {
          a: {
            reactName = "mouseover" === domEventName || "pointerover" === domEventName;
            SyntheticEventCtor = "mouseout" === domEventName || "pointerout" === domEventName;
            if (reactName && nativeEvent !== currentReplayingEvent && (reactEventType = nativeEvent.relatedTarget || nativeEvent.fromElement) && (getClosestInstanceFromNode(reactEventType) || reactEventType[internalContainerInstanceKey]))
              break a;
            if (SyntheticEventCtor || reactName) {
              reactName = nativeEventTarget.window === nativeEventTarget ? nativeEventTarget : (reactName = nativeEventTarget.ownerDocument) ? reactName.defaultView || reactName.parentWindow : window;
              if (SyntheticEventCtor) {
                if (reactEventType = nativeEvent.relatedTarget || nativeEvent.toElement, SyntheticEventCtor = targetInst, reactEventType = reactEventType ? getClosestInstanceFromNode(reactEventType) : null, null !== reactEventType && (accumulateTargetOnly = getNearestMountedFiber(reactEventType), inCapturePhase = reactEventType.tag, reactEventType !== accumulateTargetOnly || 5 !== inCapturePhase && 27 !== inCapturePhase && 6 !== inCapturePhase))
                  reactEventType = null;
              } else SyntheticEventCtor = null, reactEventType = targetInst;
              if (SyntheticEventCtor !== reactEventType) {
                inCapturePhase = SyntheticMouseEvent;
                _instance2 = "onMouseLeave";
                reactEventName = "onMouseEnter";
                instance = "mouse";
                if ("pointerout" === domEventName || "pointerover" === domEventName)
                  inCapturePhase = SyntheticPointerEvent, _instance2 = "onPointerLeave", reactEventName = "onPointerEnter", instance = "pointer";
                accumulateTargetOnly = null == SyntheticEventCtor ? reactName : getNodeFromInstance(SyntheticEventCtor);
                lastHostComponent = null == reactEventType ? reactName : getNodeFromInstance(reactEventType);
                reactName = new inCapturePhase(
                  _instance2,
                  instance + "leave",
                  SyntheticEventCtor,
                  nativeEvent,
                  nativeEventTarget
                );
                reactName.target = accumulateTargetOnly;
                reactName.relatedTarget = lastHostComponent;
                _instance2 = null;
                getClosestInstanceFromNode(nativeEventTarget) === targetInst && (inCapturePhase = new inCapturePhase(
                  reactEventName,
                  instance + "enter",
                  reactEventType,
                  nativeEvent,
                  nativeEventTarget
                ), inCapturePhase.target = lastHostComponent, inCapturePhase.relatedTarget = accumulateTargetOnly, _instance2 = inCapturePhase);
                accumulateTargetOnly = _instance2;
                if (SyntheticEventCtor && reactEventType)
                  b: {
                    inCapturePhase = getParent;
                    reactEventName = SyntheticEventCtor;
                    instance = reactEventType;
                    lastHostComponent = 0;
                    for (_instance2 = reactEventName; _instance2; _instance2 = inCapturePhase(_instance2))
                      lastHostComponent++;
                    _instance2 = 0;
                    for (var tempB = instance; tempB; tempB = inCapturePhase(tempB))
                      _instance2++;
                    for (; 0 < lastHostComponent - _instance2; )
                      reactEventName = inCapturePhase(reactEventName), lastHostComponent--;
                    for (; 0 < _instance2 - lastHostComponent; )
                      instance = inCapturePhase(instance), _instance2--;
                    for (; lastHostComponent--; ) {
                      if (reactEventName === instance || null !== instance && reactEventName === instance.alternate) {
                        inCapturePhase = reactEventName;
                        break b;
                      }
                      reactEventName = inCapturePhase(reactEventName);
                      instance = inCapturePhase(instance);
                    }
                    inCapturePhase = null;
                  }
                else inCapturePhase = null;
                null !== SyntheticEventCtor && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  reactName,
                  SyntheticEventCtor,
                  inCapturePhase,
                  false
                );
                null !== reactEventType && null !== accumulateTargetOnly && accumulateEnterLeaveListenersForEvent(
                  dispatchQueue,
                  accumulateTargetOnly,
                  reactEventType,
                  inCapturePhase,
                  true
                );
              }
            }
          }
          a: {
            reactName = targetInst ? getNodeFromInstance(targetInst) : window;
            SyntheticEventCtor = reactName.nodeName && reactName.nodeName.toLowerCase();
            if ("select" === SyntheticEventCtor || "input" === SyntheticEventCtor && "file" === reactName.type)
              var getTargetInstFunc = getTargetInstForChangeEvent;
            else if (isTextInputElement(reactName))
              if (isInputEventSupported)
                getTargetInstFunc = getTargetInstForInputOrChangeEvent;
              else {
                getTargetInstFunc = getTargetInstForInputEventPolyfill;
                var handleEventFunc = handleEventsForInputEventPolyfill;
              }
            else
              SyntheticEventCtor = reactName.nodeName, !SyntheticEventCtor || "input" !== SyntheticEventCtor.toLowerCase() || "checkbox" !== reactName.type && "radio" !== reactName.type ? targetInst && isCustomElement(targetInst.elementType) && (getTargetInstFunc = getTargetInstForChangeEvent) : getTargetInstFunc = getTargetInstForClickEvent;
            if (getTargetInstFunc && (getTargetInstFunc = getTargetInstFunc(domEventName, targetInst))) {
              createAndAccumulateChangeEvent(
                dispatchQueue,
                getTargetInstFunc,
                nativeEvent,
                nativeEventTarget
              );
              break a;
            }
            handleEventFunc && handleEventFunc(domEventName, reactName, targetInst);
            "focusout" === domEventName && targetInst && "number" === reactName.type && null != targetInst.memoizedProps.value && setDefaultValue(reactName, "number", reactName.value);
          }
          handleEventFunc = targetInst ? getNodeFromInstance(targetInst) : window;
          switch (domEventName) {
            case "focusin":
              if (isTextInputElement(handleEventFunc) || "true" === handleEventFunc.contentEditable)
                activeElement = handleEventFunc, activeElementInst = targetInst, lastSelection = null;
              break;
            case "focusout":
              lastSelection = activeElementInst = activeElement = null;
              break;
            case "mousedown":
              mouseDown = true;
              break;
            case "contextmenu":
            case "mouseup":
            case "dragend":
              mouseDown = false;
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
              break;
            case "selectionchange":
              if (skipSelectionChangeEvent) break;
            case "keydown":
            case "keyup":
              constructSelectEvent(
                dispatchQueue,
                nativeEvent,
                nativeEventTarget
              );
          }
          var fallbackData;
          if (canUseCompositionEvent)
            b: {
              switch (domEventName) {
                case "compositionstart":
                  var eventType = "onCompositionStart";
                  break b;
                case "compositionend":
                  eventType = "onCompositionEnd";
                  break b;
                case "compositionupdate":
                  eventType = "onCompositionUpdate";
                  break b;
              }
              eventType = void 0;
            }
          else
            isComposing ? isFallbackCompositionEnd(domEventName, nativeEvent) && (eventType = "onCompositionEnd") : "keydown" === domEventName && nativeEvent.keyCode === START_KEYCODE && (eventType = "onCompositionStart");
          eventType && (useFallbackCompositionData && "ko" !== nativeEvent.locale && (isComposing || "onCompositionStart" !== eventType ? "onCompositionEnd" === eventType && isComposing && (fallbackData = getData()) : (root2 = nativeEventTarget, startText = "value" in root2 ? root2.value : root2.textContent, isComposing = true)), handleEventFunc = accumulateTwoPhaseListeners(
            targetInst,
            eventType
          ), 0 < handleEventFunc.length && (eventType = new SyntheticCompositionEvent(
            eventType,
            domEventName,
            null,
            nativeEvent,
            nativeEventTarget
          ), dispatchQueue.push({
            event: eventType,
            listeners: handleEventFunc
          }), fallbackData ? eventType.data = fallbackData : (fallbackData = getDataFromCustomEvent(nativeEvent), null !== fallbackData && (eventType.data = fallbackData))));
          if (fallbackData = canUseTextInputEvent ? getNativeBeforeInputChars(domEventName, nativeEvent) : getFallbackBeforeInputChars(domEventName, nativeEvent))
            eventType = accumulateTwoPhaseListeners(
              targetInst,
              "onBeforeInput"
            ), 0 < eventType.length && (handleEventFunc = new SyntheticInputEvent(
              "onBeforeInput",
              "beforeinput",
              null,
              nativeEvent,
              nativeEventTarget
            ), dispatchQueue.push({
              event: handleEventFunc,
              listeners: eventType
            }), handleEventFunc.data = fallbackData);
          extractEvents$1(
            dispatchQueue,
            domEventName,
            targetInst,
            nativeEvent,
            nativeEventTarget
          );
        }
        processDispatchQueue(dispatchQueue, eventSystemFlags);
      });
    }
    function createDispatchListener(instance, listener, currentTarget) {
      return {
        instance,
        listener,
        currentTarget
      };
    }
    function accumulateTwoPhaseListeners(targetFiber, reactName) {
      for (var captureName = reactName + "Capture", listeners = []; null !== targetFiber; ) {
        var _instance3 = targetFiber, stateNode = _instance3.stateNode;
        _instance3 = _instance3.tag;
        5 !== _instance3 && 26 !== _instance3 && 27 !== _instance3 || null === stateNode || (_instance3 = getListener(targetFiber, captureName), null != _instance3 && listeners.unshift(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ), _instance3 = getListener(targetFiber, reactName), null != _instance3 && listeners.push(
          createDispatchListener(targetFiber, _instance3, stateNode)
        ));
        if (3 === targetFiber.tag) return listeners;
        targetFiber = targetFiber.return;
      }
      return [];
    }
    function getParent(inst) {
      if (null === inst) return null;
      do
        inst = inst.return;
      while (inst && 5 !== inst.tag && 27 !== inst.tag);
      return inst ? inst : null;
    }
    function accumulateEnterLeaveListenersForEvent(dispatchQueue, event, target, common, inCapturePhase) {
      for (var registrationName = event._reactName, listeners = []; null !== target && target !== common; ) {
        var _instance4 = target, alternate = _instance4.alternate, stateNode = _instance4.stateNode;
        _instance4 = _instance4.tag;
        if (null !== alternate && alternate === common) break;
        5 !== _instance4 && 26 !== _instance4 && 27 !== _instance4 || null === stateNode || (alternate = stateNode, inCapturePhase ? (stateNode = getListener(target, registrationName), null != stateNode && listeners.unshift(
          createDispatchListener(target, stateNode, alternate)
        )) : inCapturePhase || (stateNode = getListener(target, registrationName), null != stateNode && listeners.push(
          createDispatchListener(target, stateNode, alternate)
        )));
        target = target.return;
      }
      0 !== listeners.length && dispatchQueue.push({ event, listeners });
    }
    function validatePropertiesInDevelopment(type, props2) {
      validateProperties$2(type, props2);
      "input" !== type && "textarea" !== type && "select" !== type || null == props2 || null !== props2.value || didWarnValueNull || (didWarnValueNull = true, "select" === type && props2.multiple ? console.error(
        "`value` prop on `%s` should not be null. Consider using an empty array when `multiple` is set to `true` to clear the component or `undefined` for uncontrolled components.",
        type
      ) : console.error(
        "`value` prop on `%s` should not be null. Consider using an empty string to clear the component or `undefined` for uncontrolled components.",
        type
      ));
      var eventRegistry = {
        registrationNameDependencies,
        possibleRegistrationNames
      };
      isCustomElement(type) || "string" === typeof props2.is || warnUnknownProperties(type, props2, eventRegistry);
      props2.contentEditable && !props2.suppressContentEditableWarning && null != props2.children && console.error(
        "A component is `contentEditable` and contains `children` managed by React. It is now your responsibility to guarantee that none of those nodes are unexpectedly modified or duplicated. This is probably not intentional."
      );
    }
    function warnForPropDifference(propName, serverValue, clientValue, serverDifferences) {
      serverValue !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(serverValue) !== clientValue && (serverDifferences[propName] = serverValue));
    }
    function warnForExtraAttributes(domElement, attributeNames, serverDifferences) {
      attributeNames.forEach(function(attributeName) {
        serverDifferences[getPropNameFromAttributeName(attributeName)] = "style" === attributeName ? getStylesObjectFromElement(domElement) : domElement.getAttribute(attributeName);
      });
    }
    function warnForInvalidEventListener(registrationName, listener) {
      false === listener ? console.error(
        "Expected `%s` listener to be a function, instead got `false`.\n\nIf you used to conditionally omit it with %s={condition && value}, pass %s={condition ? value : undefined} instead.",
        registrationName,
        registrationName,
        registrationName
      ) : console.error(
        "Expected `%s` listener to be a function, instead got a value of `%s` type.",
        registrationName,
        typeof listener
      );
    }
    function normalizeHTML(parent, html) {
      parent = parent.namespaceURI === MATH_NAMESPACE || parent.namespaceURI === SVG_NAMESPACE ? parent.ownerDocument.createElementNS(
        parent.namespaceURI,
        parent.tagName
      ) : parent.ownerDocument.createElement(parent.tagName);
      parent.innerHTML = html;
      return parent.innerHTML;
    }
    function normalizeMarkupForTextOrAttribute(markup) {
      willCoercionThrow(markup) && (console.error(
        "The provided HTML markup uses a value of unsupported type %s. This value must be coerced to a string before using it here.",
        typeName2(markup)
      ), testStringCoercion(markup));
      return ("string" === typeof markup ? markup : "" + markup).replace(NORMALIZE_NEWLINES_REGEX, "\n").replace(NORMALIZE_NULL_AND_REPLACEMENT_REGEX, "");
    }
    function checkForUnmatchedText(serverText, clientText) {
      clientText = normalizeMarkupForTextOrAttribute(clientText);
      return normalizeMarkupForTextOrAttribute(serverText) === clientText ? true : false;
    }
    function setProp(domElement, tag2, key, value, props2, prevValue) {
      switch (key) {
        case "children":
          if ("string" === typeof value)
            validateTextNesting(value, tag2, false), "body" === tag2 || "textarea" === tag2 && "" === value || setTextContent(domElement, value);
          else if ("number" === typeof value || "bigint" === typeof value)
            validateTextNesting("" + value, tag2, false), "body" !== tag2 && setTextContent(domElement, "" + value);
          break;
        case "className":
          setValueForKnownAttribute(domElement, "class", value);
          break;
        case "tabIndex":
          setValueForKnownAttribute(domElement, "tabindex", value);
          break;
        case "dir":
        case "role":
        case "viewBox":
        case "width":
        case "height":
          setValueForKnownAttribute(domElement, key, value);
          break;
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "data":
          if ("object" !== tag2) {
            setValueForKnownAttribute(domElement, "data", value);
            break;
          }
        case "src":
        case "href":
          if ("" === value && ("a" !== tag2 || "href" !== key)) {
            "src" === key ? console.error(
              'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            ) : console.error(
              'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
              key,
              key
            );
            domElement.removeAttribute(key);
            break;
          }
          if (null == value || "function" === typeof value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "action":
        case "formAction":
          null != value && ("form" === tag2 ? "formAction" === key ? console.error(
            "You can only pass the formAction prop to <input> or <button>. Use the action prop on <form>."
          ) : "function" === typeof value && (null == props2.encType && null == props2.method || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a encType or method for a form that specifies a function as the action. React provides those automatically. They will get overridden."
          )), null == props2.target || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a target for a form that specifies a function as the action. The function will always be executed in the same window."
          ))) : "input" === tag2 || "button" === tag2 ? "action" === key ? console.error(
            "You can only pass the action prop to <form>. Use the formAction prop on <input> or <button>."
          ) : "input" !== tag2 || "submit" === props2.type || "image" === props2.type || didWarnFormActionType ? "button" !== tag2 || null == props2.type || "submit" === props2.type || didWarnFormActionType ? "function" === typeof value && (null == props2.name || didWarnFormActionName || (didWarnFormActionName = true, console.error(
            'Cannot specify a "name" prop for a button that specifies a function as a formAction. React needs it to encode which action should be invoked. It will get overridden.'
          )), null == props2.formEncType && null == props2.formMethod || didWarnFormActionMethod || (didWarnFormActionMethod = true, console.error(
            "Cannot specify a formEncType or formMethod for a button that specifies a function as a formAction. React provides those automatically. They will get overridden."
          )), null == props2.formTarget || didWarnFormActionTarget || (didWarnFormActionTarget = true, console.error(
            "Cannot specify a formTarget for a button that specifies a function as a formAction. The function will always be executed in the same window."
          ))) : (didWarnFormActionType = true, console.error(
            'A button can only specify a formAction along with type="submit" or no type.'
          )) : (didWarnFormActionType = true, console.error(
            'An input can only specify a formAction along with type="submit" or type="image".'
          )) : "action" === key ? console.error(
            "You can only pass the action prop to <form>."
          ) : console.error(
            "You can only pass the formAction prop to <input> or <button>."
          ));
          if ("function" === typeof value) {
            domElement.setAttribute(
              key,
              "javascript:throw new Error('A React form was unexpectedly submitted. If you called form.submit() manually, consider using form.requestSubmit() instead. If you\\'re trying to use event.stopPropagation() in a submit event handler, consider also calling event.preventDefault().')"
            );
            break;
          } else
            "function" === typeof prevValue && ("formAction" === key ? ("input" !== tag2 && setProp(domElement, tag2, "name", props2.name, props2, null), setProp(
              domElement,
              tag2,
              "formEncType",
              props2.formEncType,
              props2,
              null
            ), setProp(
              domElement,
              tag2,
              "formMethod",
              props2.formMethod,
              props2,
              null
            ), setProp(
              domElement,
              tag2,
              "formTarget",
              props2.formTarget,
              props2,
              null
            )) : (setProp(
              domElement,
              tag2,
              "encType",
              props2.encType,
              props2,
              null
            ), setProp(domElement, tag2, "method", props2.method, props2, null), setProp(
              domElement,
              tag2,
              "target",
              props2.target,
              props2,
              null
            )));
          if (null == value || "symbol" === typeof value || "boolean" === typeof value) {
            domElement.removeAttribute(key);
            break;
          }
          checkAttributeStringCoercion(value, key);
          value = sanitizeURL("" + value);
          domElement.setAttribute(key, value);
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props2.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "multiple":
          domElement.multiple = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "muted":
          domElement.muted = value && "function" !== typeof value && "symbol" !== typeof value;
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "defaultValue":
        case "defaultChecked":
        case "innerHTML":
        case "ref":
          break;
        case "autoFocus":
          break;
        case "xlinkHref":
          if (null == value || "function" === typeof value || "boolean" === typeof value || "symbol" === typeof value) {
            domElement.removeAttribute("xlink:href");
            break;
          }
          checkAttributeStringCoercion(value, key);
          key = sanitizeURL("" + value);
          domElement.setAttributeNS(xlinkNamespace, "xlink:href", key);
          break;
        case "contentEditable":
        case "spellCheck":
        case "draggable":
        case "value":
        case "autoReverse":
        case "externalResourcesRequired":
        case "focusable":
        case "preserveAlpha":
          null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, "" + value)) : domElement.removeAttribute(key);
          break;
        case "inert":
          "" !== value || didWarnForNewBooleanPropsWithEmptyValue[key] || (didWarnForNewBooleanPropsWithEmptyValue[key] = true, console.error(
            "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
            key
          ));
        case "allowFullScreen":
        case "async":
        case "autoPlay":
        case "controls":
        case "default":
        case "defer":
        case "disabled":
        case "disablePictureInPicture":
        case "disableRemotePlayback":
        case "formNoValidate":
        case "hidden":
        case "loop":
        case "noModule":
        case "noValidate":
        case "open":
        case "playsInline":
        case "readOnly":
        case "required":
        case "reversed":
        case "scoped":
        case "seamless":
        case "itemScope":
          value && "function" !== typeof value && "symbol" !== typeof value ? domElement.setAttribute(key, "") : domElement.removeAttribute(key);
          break;
        case "capture":
        case "download":
          true === value ? domElement.setAttribute(key, "") : false !== value && null != value && "function" !== typeof value && "symbol" !== typeof value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "cols":
        case "rows":
        case "size":
        case "span":
          null != value && "function" !== typeof value && "symbol" !== typeof value && !isNaN(value) && 1 <= value ? (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value)) : domElement.removeAttribute(key);
          break;
        case "rowSpan":
        case "start":
          null == value || "function" === typeof value || "symbol" === typeof value || isNaN(value) ? domElement.removeAttribute(key) : (checkAttributeStringCoercion(value, key), domElement.setAttribute(key, value));
          break;
        case "popover":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          setValueForAttribute(domElement, "popover", value);
          break;
        case "xlinkActuate":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:actuate",
            value
          );
          break;
        case "xlinkArcrole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:arcrole",
            value
          );
          break;
        case "xlinkRole":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:role",
            value
          );
          break;
        case "xlinkShow":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:show",
            value
          );
          break;
        case "xlinkTitle":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:title",
            value
          );
          break;
        case "xlinkType":
          setValueForNamespacedAttribute(
            domElement,
            xlinkNamespace,
            "xlink:type",
            value
          );
          break;
        case "xmlBase":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:base",
            value
          );
          break;
        case "xmlLang":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:lang",
            value
          );
          break;
        case "xmlSpace":
          setValueForNamespacedAttribute(
            domElement,
            xmlNamespace,
            "xml:space",
            value
          );
          break;
        case "is":
          null != prevValue && console.error(
            'Cannot update the "is" prop after it has been initialized.'
          );
          setValueForAttribute(domElement, "is", value);
          break;
        case "innerText":
        case "textContent":
          break;
        case "popoverTarget":
          didWarnPopoverTargetObject || null == value || "object" !== typeof value || (didWarnPopoverTargetObject = true, console.error(
            "The `popoverTarget` prop expects the ID of an Element as a string. Received %s instead.",
            value
          ));
        default:
          !(2 < key.length) || "o" !== key[0] && "O" !== key[0] || "n" !== key[1] && "N" !== key[1] ? (key = getAttributeAlias(key), setValueForAttribute(domElement, key, value)) : registrationNameDependencies.hasOwnProperty(key) && null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
      }
    }
    function setPropOnCustomElement(domElement, tag2, key, value, props2, prevValue) {
      switch (key) {
        case "style":
          setValueForStyles(domElement, value, prevValue);
          break;
        case "dangerouslySetInnerHTML":
          if (null != value) {
            if ("object" !== typeof value || !("__html" in value))
              throw Error(
                "`props.dangerouslySetInnerHTML` must be in the form `{__html: ...}`. Please visit https://react.dev/link/dangerously-set-inner-html for more information."
              );
            key = value.__html;
            if (null != key) {
              if (null != props2.children)
                throw Error(
                  "Can only set one of `children` or `props.dangerouslySetInnerHTML`."
                );
              domElement.innerHTML = key;
            }
          }
          break;
        case "children":
          "string" === typeof value ? setTextContent(domElement, value) : ("number" === typeof value || "bigint" === typeof value) && setTextContent(domElement, "" + value);
          break;
        case "onScroll":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scroll", domElement));
          break;
        case "onScrollEnd":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), listenToNonDelegatedEvent("scrollend", domElement));
          break;
        case "onClick":
          null != value && ("function" !== typeof value && warnForInvalidEventListener(key, value), domElement.onclick = noop$12);
          break;
        case "suppressContentEditableWarning":
        case "suppressHydrationWarning":
        case "innerHTML":
        case "ref":
          break;
        case "innerText":
        case "textContent":
          break;
        default:
          if (registrationNameDependencies.hasOwnProperty(key))
            null != value && "function" !== typeof value && warnForInvalidEventListener(key, value);
          else
            a: {
              if ("o" === key[0] && "n" === key[1] && (props2 = key.endsWith("Capture"), tag2 = key.slice(2, props2 ? key.length - 7 : void 0), prevValue = domElement[internalPropsKey] || null, prevValue = null != prevValue ? prevValue[key] : null, "function" === typeof prevValue && domElement.removeEventListener(tag2, prevValue, props2), "function" === typeof value)) {
                "function" !== typeof prevValue && null !== prevValue && (key in domElement ? domElement[key] = null : domElement.hasAttribute(key) && domElement.removeAttribute(key));
                domElement.addEventListener(tag2, value, props2);
                break a;
              }
              key in domElement ? domElement[key] = value : true === value ? domElement.setAttribute(key, "") : setValueForAttribute(domElement, key, value);
            }
      }
    }
    function setInitialProperties(domElement, tag2, props2) {
      validatePropertiesInDevelopment(tag2, props2);
      switch (tag2) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "img":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          var hasSrc = false, hasSrcSet = false, propKey;
          for (propKey in props2)
            if (props2.hasOwnProperty(propKey)) {
              var propValue = props2[propKey];
              if (null != propValue)
                switch (propKey) {
                  case "src":
                    hasSrc = true;
                    break;
                  case "srcSet":
                    hasSrcSet = true;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  default:
                    setProp(domElement, tag2, propKey, propValue, props2, null);
                }
            }
          hasSrcSet && setProp(domElement, tag2, "srcSet", props2.srcSet, props2, null);
          hasSrc && setProp(domElement, tag2, "src", props2.src, props2, null);
          return;
        case "input":
          checkControlledValueProps("input", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          var defaultValue2 = propKey = propValue = hasSrcSet = null, checked = null, defaultChecked = null;
          for (hasSrc in props2)
            if (props2.hasOwnProperty(hasSrc)) {
              var _propValue = props2[hasSrc];
              if (null != _propValue)
                switch (hasSrc) {
                  case "name":
                    hasSrcSet = _propValue;
                    break;
                  case "type":
                    propValue = _propValue;
                    break;
                  case "checked":
                    checked = _propValue;
                    break;
                  case "defaultChecked":
                    defaultChecked = _propValue;
                    break;
                  case "value":
                    propKey = _propValue;
                    break;
                  case "defaultValue":
                    defaultValue2 = _propValue;
                    break;
                  case "children":
                  case "dangerouslySetInnerHTML":
                    if (null != _propValue)
                      throw Error(
                        tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                      );
                    break;
                  default:
                    setProp(domElement, tag2, hasSrc, _propValue, props2, null);
                }
            }
          validateInputProps(domElement, props2);
          initInput(
            domElement,
            propKey,
            defaultValue2,
            checked,
            defaultChecked,
            propValue,
            hasSrcSet,
            false
          );
          return;
        case "select":
          checkControlledValueProps("select", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          hasSrc = propValue = propKey = null;
          for (hasSrcSet in props2)
            if (props2.hasOwnProperty(hasSrcSet) && (defaultValue2 = props2[hasSrcSet], null != defaultValue2))
              switch (hasSrcSet) {
                case "value":
                  propKey = defaultValue2;
                  break;
                case "defaultValue":
                  propValue = defaultValue2;
                  break;
                case "multiple":
                  hasSrc = defaultValue2;
                default:
                  setProp(
                    domElement,
                    tag2,
                    hasSrcSet,
                    defaultValue2,
                    props2,
                    null
                  );
              }
          validateSelectProps(domElement, props2);
          tag2 = propKey;
          props2 = propValue;
          domElement.multiple = !!hasSrc;
          null != tag2 ? updateOptions(domElement, !!hasSrc, tag2, false) : null != props2 && updateOptions(domElement, !!hasSrc, props2, true);
          return;
        case "textarea":
          checkControlledValueProps("textarea", props2);
          listenToNonDelegatedEvent("invalid", domElement);
          propKey = hasSrcSet = hasSrc = null;
          for (propValue in props2)
            if (props2.hasOwnProperty(propValue) && (defaultValue2 = props2[propValue], null != defaultValue2))
              switch (propValue) {
                case "value":
                  hasSrc = defaultValue2;
                  break;
                case "defaultValue":
                  hasSrcSet = defaultValue2;
                  break;
                case "children":
                  propKey = defaultValue2;
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != defaultValue2)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    propValue,
                    defaultValue2,
                    props2,
                    null
                  );
              }
          validateTextareaProps(domElement, props2);
          initTextarea(domElement, hasSrc, hasSrcSet, propKey);
          return;
        case "option":
          validateOptionProps(domElement, props2);
          for (checked in props2)
            if (props2.hasOwnProperty(checked) && (hasSrc = props2[checked], null != hasSrc))
              switch (checked) {
                case "selected":
                  domElement.selected = hasSrc && "function" !== typeof hasSrc && "symbol" !== typeof hasSrc;
                  break;
                default:
                  setProp(domElement, tag2, checked, hasSrc, props2, null);
              }
          return;
        case "dialog":
          listenToNonDelegatedEvent("beforetoggle", domElement);
          listenToNonDelegatedEvent("toggle", domElement);
          listenToNonDelegatedEvent("cancel", domElement);
          listenToNonDelegatedEvent("close", domElement);
          break;
        case "iframe":
        case "object":
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "video":
        case "audio":
          for (hasSrc = 0; hasSrc < mediaEventTypes.length; hasSrc++)
            listenToNonDelegatedEvent(mediaEventTypes[hasSrc], domElement);
          break;
        case "image":
          listenToNonDelegatedEvent("error", domElement);
          listenToNonDelegatedEvent("load", domElement);
          break;
        case "details":
          listenToNonDelegatedEvent("toggle", domElement);
          break;
        case "embed":
        case "source":
        case "link":
          listenToNonDelegatedEvent("error", domElement), listenToNonDelegatedEvent("load", domElement);
        case "area":
        case "base":
        case "br":
        case "col":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "track":
        case "wbr":
        case "menuitem":
          for (defaultChecked in props2)
            if (props2.hasOwnProperty(defaultChecked) && (hasSrc = props2[defaultChecked], null != hasSrc))
              switch (defaultChecked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  throw Error(
                    tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                  );
                default:
                  setProp(domElement, tag2, defaultChecked, hasSrc, props2, null);
              }
          return;
        default:
          if (isCustomElement(tag2)) {
            for (_propValue in props2)
              props2.hasOwnProperty(_propValue) && (hasSrc = props2[_propValue], void 0 !== hasSrc && setPropOnCustomElement(
                domElement,
                tag2,
                _propValue,
                hasSrc,
                props2,
                void 0
              ));
            return;
          }
      }
      for (defaultValue2 in props2)
        props2.hasOwnProperty(defaultValue2) && (hasSrc = props2[defaultValue2], null != hasSrc && setProp(domElement, tag2, defaultValue2, hasSrc, props2, null));
    }
    function updateProperties(domElement, tag2, lastProps, nextProps) {
      validatePropertiesInDevelopment(tag2, nextProps);
      switch (tag2) {
        case "div":
        case "span":
        case "svg":
        case "path":
        case "a":
        case "g":
        case "p":
        case "li":
          break;
        case "input":
          var name2 = null, type = null, value = null, defaultValue2 = null, lastDefaultValue = null, checked = null, defaultChecked = null;
          for (propKey in lastProps) {
            var lastProp = lastProps[propKey];
            if (lastProps.hasOwnProperty(propKey) && null != lastProp)
              switch (propKey) {
                case "checked":
                  break;
                case "value":
                  break;
                case "defaultValue":
                  lastDefaultValue = lastProp;
                default:
                  nextProps.hasOwnProperty(propKey) || setProp(
                    domElement,
                    tag2,
                    propKey,
                    null,
                    nextProps,
                    lastProp
                  );
              }
          }
          for (var _propKey8 in nextProps) {
            var propKey = nextProps[_propKey8];
            lastProp = lastProps[_propKey8];
            if (nextProps.hasOwnProperty(_propKey8) && (null != propKey || null != lastProp))
              switch (_propKey8) {
                case "type":
                  type = propKey;
                  break;
                case "name":
                  name2 = propKey;
                  break;
                case "checked":
                  checked = propKey;
                  break;
                case "defaultChecked":
                  defaultChecked = propKey;
                  break;
                case "value":
                  value = propKey;
                  break;
                case "defaultValue":
                  defaultValue2 = propKey;
                  break;
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != propKey)
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  propKey !== lastProp && setProp(
                    domElement,
                    tag2,
                    _propKey8,
                    propKey,
                    nextProps,
                    lastProp
                  );
              }
          }
          tag2 = "checkbox" === lastProps.type || "radio" === lastProps.type ? null != lastProps.checked : null != lastProps.value;
          nextProps = "checkbox" === nextProps.type || "radio" === nextProps.type ? null != nextProps.checked : null != nextProps.value;
          tag2 || !nextProps || didWarnUncontrolledToControlled || (console.error(
            "A component is changing an uncontrolled input to be controlled. This is likely caused by the value changing from undefined to a defined value, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnUncontrolledToControlled = true);
          !tag2 || nextProps || didWarnControlledToUncontrolled || (console.error(
            "A component is changing a controlled input to be uncontrolled. This is likely caused by the value changing from a defined to undefined, which should not happen. Decide between using a controlled or uncontrolled input element for the lifetime of the component. More info: https://react.dev/link/controlled-components"
          ), didWarnControlledToUncontrolled = true);
          updateInput(
            domElement,
            value,
            defaultValue2,
            lastDefaultValue,
            checked,
            defaultChecked,
            type,
            name2
          );
          return;
        case "select":
          propKey = value = defaultValue2 = _propKey8 = null;
          for (type in lastProps)
            if (lastDefaultValue = lastProps[type], lastProps.hasOwnProperty(type) && null != lastDefaultValue)
              switch (type) {
                case "value":
                  break;
                case "multiple":
                  propKey = lastDefaultValue;
                default:
                  nextProps.hasOwnProperty(type) || setProp(
                    domElement,
                    tag2,
                    type,
                    null,
                    nextProps,
                    lastDefaultValue
                  );
              }
          for (name2 in nextProps)
            if (type = nextProps[name2], lastDefaultValue = lastProps[name2], nextProps.hasOwnProperty(name2) && (null != type || null != lastDefaultValue))
              switch (name2) {
                case "value":
                  _propKey8 = type;
                  break;
                case "defaultValue":
                  defaultValue2 = type;
                  break;
                case "multiple":
                  value = type;
                default:
                  type !== lastDefaultValue && setProp(
                    domElement,
                    tag2,
                    name2,
                    type,
                    nextProps,
                    lastDefaultValue
                  );
              }
          nextProps = defaultValue2;
          tag2 = value;
          lastProps = propKey;
          null != _propKey8 ? updateOptions(domElement, !!tag2, _propKey8, false) : !!lastProps !== !!tag2 && (null != nextProps ? updateOptions(domElement, !!tag2, nextProps, true) : updateOptions(domElement, !!tag2, tag2 ? [] : "", false));
          return;
        case "textarea":
          propKey = _propKey8 = null;
          for (defaultValue2 in lastProps)
            if (name2 = lastProps[defaultValue2], lastProps.hasOwnProperty(defaultValue2) && null != name2 && !nextProps.hasOwnProperty(defaultValue2))
              switch (defaultValue2) {
                case "value":
                  break;
                case "children":
                  break;
                default:
                  setProp(domElement, tag2, defaultValue2, null, nextProps, name2);
              }
          for (value in nextProps)
            if (name2 = nextProps[value], type = lastProps[value], nextProps.hasOwnProperty(value) && (null != name2 || null != type))
              switch (value) {
                case "value":
                  _propKey8 = name2;
                  break;
                case "defaultValue":
                  propKey = name2;
                  break;
                case "children":
                  break;
                case "dangerouslySetInnerHTML":
                  if (null != name2)
                    throw Error(
                      "`dangerouslySetInnerHTML` does not make sense on <textarea>."
                    );
                  break;
                default:
                  name2 !== type && setProp(domElement, tag2, value, name2, nextProps, type);
              }
          updateTextarea(domElement, _propKey8, propKey);
          return;
        case "option":
          for (var _propKey13 in lastProps)
            if (_propKey8 = lastProps[_propKey13], lastProps.hasOwnProperty(_propKey13) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey13))
              switch (_propKey13) {
                case "selected":
                  domElement.selected = false;
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    _propKey13,
                    null,
                    nextProps,
                    _propKey8
                  );
              }
          for (lastDefaultValue in nextProps)
            if (_propKey8 = nextProps[lastDefaultValue], propKey = lastProps[lastDefaultValue], nextProps.hasOwnProperty(lastDefaultValue) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (lastDefaultValue) {
                case "selected":
                  domElement.selected = _propKey8 && "function" !== typeof _propKey8 && "symbol" !== typeof _propKey8;
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    lastDefaultValue,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        case "img":
        case "link":
        case "area":
        case "base":
        case "br":
        case "col":
        case "embed":
        case "hr":
        case "keygen":
        case "meta":
        case "param":
        case "source":
        case "track":
        case "wbr":
        case "menuitem":
          for (var _propKey15 in lastProps)
            _propKey8 = lastProps[_propKey15], lastProps.hasOwnProperty(_propKey15) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey15) && setProp(
              domElement,
              tag2,
              _propKey15,
              null,
              nextProps,
              _propKey8
            );
          for (checked in nextProps)
            if (_propKey8 = nextProps[checked], propKey = lastProps[checked], nextProps.hasOwnProperty(checked) && _propKey8 !== propKey && (null != _propKey8 || null != propKey))
              switch (checked) {
                case "children":
                case "dangerouslySetInnerHTML":
                  if (null != _propKey8)
                    throw Error(
                      tag2 + " is a void element tag and must neither have `children` nor use `dangerouslySetInnerHTML`."
                    );
                  break;
                default:
                  setProp(
                    domElement,
                    tag2,
                    checked,
                    _propKey8,
                    nextProps,
                    propKey
                  );
              }
          return;
        default:
          if (isCustomElement(tag2)) {
            for (var _propKey17 in lastProps)
              _propKey8 = lastProps[_propKey17], lastProps.hasOwnProperty(_propKey17) && void 0 !== _propKey8 && !nextProps.hasOwnProperty(_propKey17) && setPropOnCustomElement(
                domElement,
                tag2,
                _propKey17,
                void 0,
                nextProps,
                _propKey8
              );
            for (defaultChecked in nextProps)
              _propKey8 = nextProps[defaultChecked], propKey = lastProps[defaultChecked], !nextProps.hasOwnProperty(defaultChecked) || _propKey8 === propKey || void 0 === _propKey8 && void 0 === propKey || setPropOnCustomElement(
                domElement,
                tag2,
                defaultChecked,
                _propKey8,
                nextProps,
                propKey
              );
            return;
          }
      }
      for (var _propKey19 in lastProps)
        _propKey8 = lastProps[_propKey19], lastProps.hasOwnProperty(_propKey19) && null != _propKey8 && !nextProps.hasOwnProperty(_propKey19) && setProp(domElement, tag2, _propKey19, null, nextProps, _propKey8);
      for (lastProp in nextProps)
        _propKey8 = nextProps[lastProp], propKey = lastProps[lastProp], !nextProps.hasOwnProperty(lastProp) || _propKey8 === propKey || null == _propKey8 && null == propKey || setProp(domElement, tag2, lastProp, _propKey8, nextProps, propKey);
    }
    function getPropNameFromAttributeName(attrName) {
      switch (attrName) {
        case "class":
          return "className";
        case "for":
          return "htmlFor";
        default:
          return attrName;
      }
    }
    function getStylesObjectFromElement(domElement) {
      var serverValueInObjectForm = {};
      domElement = domElement.style;
      for (var i2 = 0; i2 < domElement.length; i2++) {
        var styleName = domElement[i2];
        serverValueInObjectForm[styleName] = domElement.getPropertyValue(styleName);
      }
      return serverValueInObjectForm;
    }
    function diffHydratedStyles(domElement, value$jscomp$0, serverDifferences) {
      if (null != value$jscomp$0 && "object" !== typeof value$jscomp$0)
        console.error(
          "The `style` prop expects a mapping from style properties to values, not a string. For example, style={{marginRight: spacing + 'em'}} when using JSX."
        );
      else {
        var clientValue;
        var delimiter = clientValue = "", styleName;
        for (styleName in value$jscomp$0)
          if (value$jscomp$0.hasOwnProperty(styleName)) {
            var value = value$jscomp$0[styleName];
            null != value && "boolean" !== typeof value && "" !== value && (0 === styleName.indexOf("--") ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName + ":" + ("" + value).trim()) : "number" !== typeof value || 0 === value || unitlessNumbers.has(styleName) ? (checkCSSPropertyStringCoercion(value, styleName), clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + ("" + value).trim()) : clientValue += delimiter + styleName.replace(uppercasePattern, "-$1").toLowerCase().replace(msPattern$1, "-ms-") + ":" + value + "px", delimiter = ";");
          }
        clientValue = clientValue || null;
        value$jscomp$0 = domElement.getAttribute("style");
        value$jscomp$0 !== clientValue && (clientValue = normalizeMarkupForTextOrAttribute(clientValue), normalizeMarkupForTextOrAttribute(value$jscomp$0) !== clientValue && (serverDifferences.style = getStylesObjectFromElement(domElement)));
      }
    }
    function hydrateAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement) {
        switch (typeof value) {
          case "function":
          case "symbol":
            return;
        }
        if (!value) return;
      } else
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (value) return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateBooleanishAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
            break;
          default:
            if (checkAttributeStringCoercion(value, attributeName), domElement === "" + value)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateNumericAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
          default:
            if (isNaN(value)) return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (!isNaN(value) && (checkAttributeStringCoercion(value, propKey), domElement === "" + value))
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function hydrateSanitizedAttribute(domElement, propKey, attributeName, value, extraAttributes, serverDifferences) {
      extraAttributes.delete(attributeName);
      domElement = domElement.getAttribute(attributeName);
      if (null === domElement)
        switch (typeof value) {
          case "undefined":
          case "function":
          case "symbol":
          case "boolean":
            return;
        }
      else if (null != value)
        switch (typeof value) {
          case "function":
          case "symbol":
          case "boolean":
            break;
          default:
            if (checkAttributeStringCoercion(value, propKey), attributeName = sanitizeURL("" + value), domElement === attributeName)
              return;
        }
      warnForPropDifference(propKey, domElement, value, serverDifferences);
    }
    function diffHydratedProperties(domElement, tag2, props2, hostContext) {
      for (var serverDifferences = {}, extraAttributes = /* @__PURE__ */ new Set(), attributes = domElement.attributes, i2 = 0; i2 < attributes.length; i2++)
        switch (attributes[i2].name.toLowerCase()) {
          case "value":
            break;
          case "checked":
            break;
          case "selected":
            break;
          default:
            extraAttributes.add(attributes[i2].name);
        }
      if (isCustomElement(tag2))
        for (var propKey in props2) {
          if (props2.hasOwnProperty(propKey)) {
            var value = props2[propKey];
            if (null != value) {
              if (registrationNameDependencies.hasOwnProperty(propKey))
                "function" !== typeof value && warnForInvalidEventListener(propKey, value);
              else if (true !== props2.suppressHydrationWarning)
                switch (propKey) {
                  case "children":
                    "string" !== typeof value && "number" !== typeof value || warnForPropDifference(
                      "children",
                      domElement.textContent,
                      value,
                      serverDifferences
                    );
                    continue;
                  case "suppressContentEditableWarning":
                  case "suppressHydrationWarning":
                  case "defaultValue":
                  case "defaultChecked":
                  case "innerHTML":
                  case "ref":
                    continue;
                  case "dangerouslySetInnerHTML":
                    attributes = domElement.innerHTML;
                    value = value ? value.__html : void 0;
                    null != value && (value = normalizeHTML(domElement, value), warnForPropDifference(
                      propKey,
                      attributes,
                      value,
                      serverDifferences
                    ));
                    continue;
                  case "style":
                    extraAttributes.delete(propKey);
                    diffHydratedStyles(domElement, value, serverDifferences);
                    continue;
                  case "offsetParent":
                  case "offsetTop":
                  case "offsetLeft":
                  case "offsetWidth":
                  case "offsetHeight":
                  case "isContentEditable":
                  case "outerText":
                  case "outerHTML":
                    extraAttributes.delete(propKey.toLowerCase());
                    console.error(
                      "Assignment to read-only property will result in a no-op: `%s`",
                      propKey
                    );
                    continue;
                  case "className":
                    extraAttributes.delete("class");
                    attributes = getValueForAttributeOnCustomComponent(
                      domElement,
                      "class",
                      value
                    );
                    warnForPropDifference(
                      "className",
                      attributes,
                      value,
                      serverDifferences
                    );
                    continue;
                  default:
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag2 && "math" !== tag2 ? extraAttributes.delete(propKey.toLowerCase()) : extraAttributes.delete(propKey), attributes = getValueForAttributeOnCustomComponent(
                      domElement,
                      propKey,
                      value
                    ), warnForPropDifference(
                      propKey,
                      attributes,
                      value,
                      serverDifferences
                    );
                }
            }
          }
        }
      else
        for (value in props2)
          if (props2.hasOwnProperty(value) && (propKey = props2[value], null != propKey)) {
            if (registrationNameDependencies.hasOwnProperty(value))
              "function" !== typeof propKey && warnForInvalidEventListener(value, propKey);
            else if (true !== props2.suppressHydrationWarning)
              switch (value) {
                case "children":
                  "string" !== typeof propKey && "number" !== typeof propKey || warnForPropDifference(
                    "children",
                    domElement.textContent,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "suppressContentEditableWarning":
                case "suppressHydrationWarning":
                case "value":
                case "checked":
                case "selected":
                case "defaultValue":
                case "defaultChecked":
                case "innerHTML":
                case "ref":
                  continue;
                case "dangerouslySetInnerHTML":
                  attributes = domElement.innerHTML;
                  propKey = propKey ? propKey.__html : void 0;
                  null != propKey && (propKey = normalizeHTML(domElement, propKey), attributes !== propKey && (serverDifferences[value] = { __html: attributes }));
                  continue;
                case "className":
                  hydrateAttribute(
                    domElement,
                    value,
                    "class",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "tabIndex":
                  hydrateAttribute(
                    domElement,
                    value,
                    "tabindex",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "style":
                  extraAttributes.delete(value);
                  diffHydratedStyles(domElement, propKey, serverDifferences);
                  continue;
                case "multiple":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.multiple,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "muted":
                  extraAttributes.delete(value);
                  warnForPropDifference(
                    value,
                    domElement.muted,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "autoFocus":
                  extraAttributes.delete("autofocus");
                  warnForPropDifference(
                    value,
                    domElement.autofocus,
                    propKey,
                    serverDifferences
                  );
                  continue;
                case "data":
                  if ("object" !== tag2) {
                    extraAttributes.delete(value);
                    attributes = domElement.getAttribute("data");
                    warnForPropDifference(
                      value,
                      attributes,
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                case "src":
                case "href":
                  if (!("" !== propKey || "a" === tag2 && "href" === value || "object" === tag2 && "data" === value)) {
                    "src" === value ? console.error(
                      'An empty string ("") was passed to the %s attribute. This may cause the browser to download the whole page again over the network. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    ) : console.error(
                      'An empty string ("") was passed to the %s attribute. To fix this, either do not render the element at all or pass null to %s instead of an empty string.',
                      value,
                      value
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "action":
                case "formAction":
                  attributes = domElement.getAttribute(value);
                  if ("function" === typeof propKey) {
                    extraAttributes.delete(value.toLowerCase());
                    "formAction" === value ? (extraAttributes.delete("name"), extraAttributes.delete("formenctype"), extraAttributes.delete("formmethod"), extraAttributes.delete("formtarget")) : (extraAttributes.delete("enctype"), extraAttributes.delete("method"), extraAttributes.delete("target"));
                    continue;
                  } else if (attributes === EXPECTED_FORM_ACTION_URL) {
                    extraAttributes.delete(value.toLowerCase());
                    warnForPropDifference(
                      value,
                      "function",
                      propKey,
                      serverDifferences
                    );
                    continue;
                  }
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkHref":
                  hydrateSanitizedAttribute(
                    domElement,
                    value,
                    "xlink:href",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "contentEditable":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "contenteditable",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "spellCheck":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    "spellcheck",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "draggable":
                case "autoReverse":
                case "externalResourcesRequired":
                case "focusable":
                case "preserveAlpha":
                  hydrateBooleanishAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "allowFullScreen":
                case "async":
                case "autoPlay":
                case "controls":
                case "default":
                case "defer":
                case "disabled":
                case "disablePictureInPicture":
                case "disableRemotePlayback":
                case "formNoValidate":
                case "hidden":
                case "loop":
                case "noModule":
                case "noValidate":
                case "open":
                case "playsInline":
                case "readOnly":
                case "required":
                case "reversed":
                case "scoped":
                case "seamless":
                case "itemScope":
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value.toLowerCase(),
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "capture":
                case "download":
                  a: {
                    i2 = domElement;
                    var attributeName = attributes = value, serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i2 = i2.getAttribute(attributeName);
                    if (null === i2)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                          break a;
                        default:
                          if (false === propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                          break;
                        case "boolean":
                          if (true === propKey && "" === i2) break a;
                          break;
                        default:
                          if (checkAttributeStringCoercion(propKey, attributes), i2 === "" + propKey)
                            break a;
                      }
                    warnForPropDifference(
                      attributes,
                      i2,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "cols":
                case "rows":
                case "size":
                case "span":
                  a: {
                    i2 = domElement;
                    attributeName = attributes = value;
                    serverDifferences$jscomp$0 = serverDifferences;
                    extraAttributes.delete(attributeName);
                    i2 = i2.getAttribute(attributeName);
                    if (null === i2)
                      switch (typeof propKey) {
                        case "undefined":
                        case "function":
                        case "symbol":
                        case "boolean":
                          break a;
                        default:
                          if (isNaN(propKey) || 1 > propKey) break a;
                      }
                    else if (null != propKey)
                      switch (typeof propKey) {
                        case "function":
                        case "symbol":
                        case "boolean":
                          break;
                        default:
                          if (!(isNaN(propKey) || 1 > propKey) && (checkAttributeStringCoercion(propKey, attributes), i2 === "" + propKey))
                            break a;
                      }
                    warnForPropDifference(
                      attributes,
                      i2,
                      propKey,
                      serverDifferences$jscomp$0
                    );
                  }
                  continue;
                case "rowSpan":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    "rowspan",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "start":
                  hydrateNumericAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xHeight":
                  hydrateAttribute(
                    domElement,
                    value,
                    "x-height",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkActuate":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:actuate",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkArcrole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:arcrole",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkRole":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:role",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkShow":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:show",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkTitle":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:title",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xlinkType":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xlink:type",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlBase":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:base",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlLang":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:lang",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "xmlSpace":
                  hydrateAttribute(
                    domElement,
                    value,
                    "xml:space",
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                case "inert":
                  "" !== propKey || didWarnForNewBooleanPropsWithEmptyValue[value] || (didWarnForNewBooleanPropsWithEmptyValue[value] = true, console.error(
                    "Received an empty string for a boolean attribute `%s`. This will treat the attribute as if it were false. Either pass `false` to silence this warning, or pass `true` if you used an empty string in earlier versions of React to indicate this attribute is true.",
                    value
                  ));
                  hydrateBooleanAttribute(
                    domElement,
                    value,
                    value,
                    propKey,
                    extraAttributes,
                    serverDifferences
                  );
                  continue;
                default:
                  if (!(2 < value.length) || "o" !== value[0] && "O" !== value[0] || "n" !== value[1] && "N" !== value[1]) {
                    i2 = getAttributeAlias(value);
                    attributes = false;
                    hostContext.context === HostContextNamespaceNone && "svg" !== tag2 && "math" !== tag2 ? extraAttributes.delete(i2.toLowerCase()) : (attributeName = value.toLowerCase(), attributeName = possibleStandardNames.hasOwnProperty(
                      attributeName
                    ) ? possibleStandardNames[attributeName] || null : null, null !== attributeName && attributeName !== value && (attributes = true, extraAttributes.delete(attributeName)), extraAttributes.delete(i2));
                    a: if (attributeName = domElement, serverDifferences$jscomp$0 = i2, i2 = propKey, isAttributeNameSafe(serverDifferences$jscomp$0))
                      if (attributeName.hasAttribute(serverDifferences$jscomp$0))
                        attributeName = attributeName.getAttribute(
                          serverDifferences$jscomp$0
                        ), checkAttributeStringCoercion(
                          i2,
                          serverDifferences$jscomp$0
                        ), i2 = attributeName === "" + i2 ? i2 : attributeName;
                      else {
                        switch (typeof i2) {
                          case "function":
                          case "symbol":
                            break a;
                          case "boolean":
                            if (attributeName = serverDifferences$jscomp$0.toLowerCase().slice(0, 5), "data-" !== attributeName && "aria-" !== attributeName)
                              break a;
                        }
                        i2 = void 0 === i2 ? void 0 : null;
                      }
                    else i2 = void 0;
                    attributes || warnForPropDifference(
                      value,
                      i2,
                      propKey,
                      serverDifferences
                    );
                  }
              }
          }
      0 < extraAttributes.size && true !== props2.suppressHydrationWarning && warnForExtraAttributes(domElement, extraAttributes, serverDifferences);
      return 0 === Object.keys(serverDifferences).length ? null : serverDifferences;
    }
    function propNamesListJoin(list2, combinator) {
      switch (list2.length) {
        case 0:
          return "";
        case 1:
          return list2[0];
        case 2:
          return list2[0] + " " + combinator + " " + list2[1];
        default:
          return list2.slice(0, -1).join(", ") + ", " + combinator + " " + list2[list2.length - 1];
      }
    }
    function isLikelyStaticResource(initiatorType) {
      switch (initiatorType) {
        case "css":
        case "script":
        case "font":
        case "img":
        case "image":
        case "input":
        case "link":
          return true;
        default:
          return false;
      }
    }
    function estimateBandwidth() {
      if ("function" === typeof performance.getEntriesByType) {
        for (var count = 0, bits = 0, resourceEntries = performance.getEntriesByType("resource"), i2 = 0; i2 < resourceEntries.length; i2++) {
          var entry = resourceEntries[i2], transferSize = entry.transferSize, initiatorType = entry.initiatorType, duration = entry.duration;
          if (transferSize && duration && isLikelyStaticResource(initiatorType)) {
            initiatorType = 0;
            duration = entry.responseEnd;
            for (i2 += 1; i2 < resourceEntries.length; i2++) {
              var overlapEntry = resourceEntries[i2], overlapStartTime = overlapEntry.startTime;
              if (overlapStartTime > duration) break;
              var overlapTransferSize = overlapEntry.transferSize, overlapInitiatorType = overlapEntry.initiatorType;
              overlapTransferSize && isLikelyStaticResource(overlapInitiatorType) && (overlapEntry = overlapEntry.responseEnd, initiatorType += overlapTransferSize * (overlapEntry < duration ? 1 : (duration - overlapStartTime) / (overlapEntry - overlapStartTime)));
            }
            --i2;
            bits += 8 * (transferSize + initiatorType) / (entry.duration / 1e3);
            count++;
            if (10 < count) break;
          }
        }
        if (0 < count) return bits / count / 1e6;
      }
      return navigator.connection && (count = navigator.connection.downlink, "number" === typeof count) ? count : 5;
    }
    function getOwnerDocumentFromRootContainer(rootContainerElement) {
      return 9 === rootContainerElement.nodeType ? rootContainerElement : rootContainerElement.ownerDocument;
    }
    function getOwnHostContext(namespaceURI) {
      switch (namespaceURI) {
        case SVG_NAMESPACE:
          return HostContextNamespaceSvg;
        case MATH_NAMESPACE:
          return HostContextNamespaceMath;
        default:
          return HostContextNamespaceNone;
      }
    }
    function getChildHostContextProd(parentNamespace, type) {
      if (parentNamespace === HostContextNamespaceNone)
        switch (type) {
          case "svg":
            return HostContextNamespaceSvg;
          case "math":
            return HostContextNamespaceMath;
          default:
            return HostContextNamespaceNone;
        }
      return parentNamespace === HostContextNamespaceSvg && "foreignObject" === type ? HostContextNamespaceNone : parentNamespace;
    }
    function shouldSetTextContent(type, props2) {
      return "textarea" === type || "noscript" === type || "string" === typeof props2.children || "number" === typeof props2.children || "bigint" === typeof props2.children || "object" === typeof props2.dangerouslySetInnerHTML && null !== props2.dangerouslySetInnerHTML && null != props2.dangerouslySetInnerHTML.__html;
    }
    function shouldAttemptEagerTransition() {
      var event = window.event;
      if (event && "popstate" === event.type) {
        if (event === currentPopstateTransitionEvent) return false;
        currentPopstateTransitionEvent = event;
        return true;
      }
      currentPopstateTransitionEvent = null;
      return false;
    }
    function resolveEventType() {
      var event = window.event;
      return event && event !== schedulerEvent ? event.type : null;
    }
    function resolveEventTimeStamp() {
      var event = window.event;
      return event && event !== schedulerEvent ? event.timeStamp : -1.1;
    }
    function handleErrorInNextTick(error) {
      setTimeout(function() {
        throw error;
      });
    }
    function commitMount(domElement, type, newProps) {
      switch (type) {
        case "button":
        case "input":
        case "select":
        case "textarea":
          newProps.autoFocus && domElement.focus();
          break;
        case "img":
          newProps.src ? domElement.src = newProps.src : newProps.srcSet && (domElement.srcset = newProps.srcSet);
      }
    }
    function commitHydratedInstance() {
    }
    function commitUpdate(domElement, type, oldProps, newProps) {
      updateProperties(domElement, type, oldProps, newProps);
      domElement[internalPropsKey] = newProps;
    }
    function resetTextContent(domElement) {
      setTextContent(domElement, "");
    }
    function commitTextUpdate(textInstance, oldText, newText) {
      textInstance.nodeValue = newText;
    }
    function warnForReactChildrenConflict(container) {
      if (!container.__reactWarnedAboutChildrenConflict) {
        var props2 = container[internalPropsKey] || null;
        if (null !== props2) {
          var fiber = getInstanceFromNode(container);
          null !== fiber && ("string" === typeof props2.children || "number" === typeof props2.children ? (container.__reactWarnedAboutChildrenConflict = true, runWithFiberInDEV(fiber, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "children" text content using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })) : null != props2.dangerouslySetInnerHTML && (container.__reactWarnedAboutChildrenConflict = true, runWithFiberInDEV(fiber, function() {
            console.error(
              'Cannot use a ref on a React element as a container to `createRoot` or `createPortal` if that element also sets "dangerouslySetInnerHTML" using React. It should be a leaf with no children. Otherwise it\'s ambiguous which children should be used.'
            );
          })));
        }
      }
    }
    function isSingletonScope(type) {
      return "head" === type;
    }
    function removeChild(parentInstance, child) {
      parentInstance.removeChild(child);
    }
    function removeChildFromContainer(container, child) {
      (9 === container.nodeType ? container.body : "HTML" === container.nodeName ? container.ownerDocument.body : container).removeChild(child);
    }
    function clearHydrationBoundary(parentInstance, hydrationInstance) {
      var node = hydrationInstance, depth = 0;
      do {
        var nextNode = node.nextSibling;
        parentInstance.removeChild(node);
        if (nextNode && 8 === nextNode.nodeType)
          if (node = nextNode.data, node === SUSPENSE_END_DATA || node === ACTIVITY_END_DATA) {
            if (0 === depth) {
              parentInstance.removeChild(nextNode);
              retryIfBlockedOn(hydrationInstance);
              return;
            }
            depth--;
          } else if (node === SUSPENSE_START_DATA || node === SUSPENSE_PENDING_START_DATA || node === SUSPENSE_QUEUED_START_DATA || node === SUSPENSE_FALLBACK_START_DATA || node === ACTIVITY_START_DATA)
            depth++;
          else if (node === PREAMBLE_CONTRIBUTION_HTML)
            releaseSingletonInstance(
              parentInstance.ownerDocument.documentElement
            );
          else if (node === PREAMBLE_CONTRIBUTION_HEAD) {
            node = parentInstance.ownerDocument.head;
            releaseSingletonInstance(node);
            for (var node$jscomp$0 = node.firstChild; node$jscomp$0; ) {
              var nextNode$jscomp$0 = node$jscomp$0.nextSibling, nodeName = node$jscomp$0.nodeName;
              node$jscomp$0[internalHoistableMarker] || "SCRIPT" === nodeName || "STYLE" === nodeName || "LINK" === nodeName && "stylesheet" === node$jscomp$0.rel.toLowerCase() || node.removeChild(node$jscomp$0);
              node$jscomp$0 = nextNode$jscomp$0;
            }
          } else
            node === PREAMBLE_CONTRIBUTION_BODY && releaseSingletonInstance(parentInstance.ownerDocument.body);
        node = nextNode;
      } while (node);
      retryIfBlockedOn(hydrationInstance);
    }
    function hideOrUnhideDehydratedBoundary(suspenseInstance, isHidden2) {
      var node = suspenseInstance;
      suspenseInstance = 0;
      do {
        var nextNode = node.nextSibling;
        1 === node.nodeType ? isHidden2 ? (node._stashedDisplay = node.style.display, node.style.display = "none") : (node.style.display = node._stashedDisplay || "", "" === node.getAttribute("style") && node.removeAttribute("style")) : 3 === node.nodeType && (isHidden2 ? (node._stashedText = node.nodeValue, node.nodeValue = "") : node.nodeValue = node._stashedText || "");
        if (nextNode && 8 === nextNode.nodeType)
          if (node = nextNode.data, node === SUSPENSE_END_DATA)
            if (0 === suspenseInstance) break;
            else suspenseInstance--;
          else
            node !== SUSPENSE_START_DATA && node !== SUSPENSE_PENDING_START_DATA && node !== SUSPENSE_QUEUED_START_DATA && node !== SUSPENSE_FALLBACK_START_DATA || suspenseInstance++;
        node = nextNode;
      } while (node);
    }
    function hideDehydratedBoundary(suspenseInstance) {
      hideOrUnhideDehydratedBoundary(suspenseInstance, true);
    }
    function hideInstance(instance) {
      instance = instance.style;
      "function" === typeof instance.setProperty ? instance.setProperty("display", "none", "important") : instance.display = "none";
    }
    function hideTextInstance(textInstance) {
      textInstance.nodeValue = "";
    }
    function unhideDehydratedBoundary(dehydratedInstance) {
      hideOrUnhideDehydratedBoundary(dehydratedInstance, false);
    }
    function unhideInstance(instance, props2) {
      props2 = props2[STYLE];
      props2 = void 0 !== props2 && null !== props2 && props2.hasOwnProperty("display") ? props2.display : null;
      instance.style.display = null == props2 || "boolean" === typeof props2 ? "" : ("" + props2).trim();
    }
    function unhideTextInstance(textInstance, text2) {
      textInstance.nodeValue = text2;
    }
    function clearContainerSparingly(container) {
      var nextNode = container.firstChild;
      nextNode && 10 === nextNode.nodeType && (nextNode = nextNode.nextSibling);
      for (; nextNode; ) {
        var node = nextNode;
        nextNode = nextNode.nextSibling;
        switch (node.nodeName) {
          case "HTML":
          case "HEAD":
          case "BODY":
            clearContainerSparingly(node);
            detachDeletedInstance(node);
            continue;
          case "SCRIPT":
          case "STYLE":
            continue;
          case "LINK":
            if ("stylesheet" === node.rel.toLowerCase()) continue;
        }
        container.removeChild(node);
      }
    }
    function canHydrateInstance(instance, type, props2, inRootOrSingleton) {
      for (; 1 === instance.nodeType; ) {
        var anyProps = props2;
        if (instance.nodeName.toLowerCase() !== type.toLowerCase()) {
          if (!inRootOrSingleton && ("INPUT" !== instance.nodeName || "hidden" !== instance.type))
            break;
        } else if (!inRootOrSingleton)
          if ("input" === type && "hidden" === instance.type) {
            checkAttributeStringCoercion(anyProps.name, "name");
            var name2 = null == anyProps.name ? null : "" + anyProps.name;
            if ("hidden" === anyProps.type && instance.getAttribute("name") === name2)
              return instance;
          } else return instance;
        else if (!instance[internalHoistableMarker])
          switch (type) {
            case "meta":
              if (!instance.hasAttribute("itemprop")) break;
              return instance;
            case "link":
              name2 = instance.getAttribute("rel");
              if ("stylesheet" === name2 && instance.hasAttribute("data-precedence"))
                break;
              else if (name2 !== anyProps.rel || instance.getAttribute("href") !== (null == anyProps.href || "" === anyProps.href ? null : anyProps.href) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin) || instance.getAttribute("title") !== (null == anyProps.title ? null : anyProps.title))
                break;
              return instance;
            case "style":
              if (instance.hasAttribute("data-precedence")) break;
              return instance;
            case "script":
              name2 = instance.getAttribute("src");
              if ((name2 !== (null == anyProps.src ? null : anyProps.src) || instance.getAttribute("type") !== (null == anyProps.type ? null : anyProps.type) || instance.getAttribute("crossorigin") !== (null == anyProps.crossOrigin ? null : anyProps.crossOrigin)) && name2 && instance.hasAttribute("async") && !instance.hasAttribute("itemprop"))
                break;
              return instance;
            default:
              return instance;
          }
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) break;
      }
      return null;
    }
    function canHydrateTextInstance(instance, text2, inRootOrSingleton) {
      if ("" === text2) return null;
      for (; 3 !== instance.nodeType; ) {
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
          return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
      }
      return instance;
    }
    function canHydrateHydrationBoundary(instance, inRootOrSingleton) {
      for (; 8 !== instance.nodeType; ) {
        if ((1 !== instance.nodeType || "INPUT" !== instance.nodeName || "hidden" !== instance.type) && !inRootOrSingleton)
          return null;
        instance = getNextHydratable(instance.nextSibling);
        if (null === instance) return null;
      }
      return instance;
    }
    function isSuspenseInstancePending(instance) {
      return instance.data === SUSPENSE_PENDING_START_DATA || instance.data === SUSPENSE_QUEUED_START_DATA;
    }
    function isSuspenseInstanceFallback(instance) {
      return instance.data === SUSPENSE_FALLBACK_START_DATA || instance.data === SUSPENSE_PENDING_START_DATA && instance.ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING;
    }
    function registerSuspenseInstanceRetry(instance, callback) {
      var ownerDocument = instance.ownerDocument;
      if (instance.data === SUSPENSE_QUEUED_START_DATA)
        instance._reactRetry = callback;
      else if (instance.data !== SUSPENSE_PENDING_START_DATA || ownerDocument.readyState !== DOCUMENT_READY_STATE_LOADING)
        callback();
      else {
        var listener = function() {
          callback();
          ownerDocument.removeEventListener("DOMContentLoaded", listener);
        };
        ownerDocument.addEventListener("DOMContentLoaded", listener);
        instance._reactRetry = listener;
      }
    }
    function getNextHydratable(node) {
      for (; null != node; node = node.nextSibling) {
        var nodeType = node.nodeType;
        if (1 === nodeType || 3 === nodeType) break;
        if (8 === nodeType) {
          nodeType = node.data;
          if (nodeType === SUSPENSE_START_DATA || nodeType === SUSPENSE_FALLBACK_START_DATA || nodeType === SUSPENSE_PENDING_START_DATA || nodeType === SUSPENSE_QUEUED_START_DATA || nodeType === ACTIVITY_START_DATA || nodeType === FORM_STATE_IS_MATCHING || nodeType === FORM_STATE_IS_NOT_MATCHING)
            break;
          if (nodeType === SUSPENSE_END_DATA || nodeType === ACTIVITY_END_DATA)
            return null;
        }
      }
      return node;
    }
    function describeHydratableInstanceForDevWarnings(instance) {
      if (1 === instance.nodeType) {
        for (var JSCompiler_temp_const = instance.nodeName.toLowerCase(), serverDifferences = {}, attributes = instance.attributes, i2 = 0; i2 < attributes.length; i2++) {
          var attr = attributes[i2];
          serverDifferences[getPropNameFromAttributeName(attr.name)] = "style" === attr.name.toLowerCase() ? getStylesObjectFromElement(instance) : attr.value;
        }
        return { type: JSCompiler_temp_const, props: serverDifferences };
      }
      return 8 === instance.nodeType ? instance.data === ACTIVITY_START_DATA ? { type: "Activity", props: {} } : { type: "Suspense", props: {} } : instance.nodeValue;
    }
    function diffHydratedTextForDevWarnings(textInstance, text2, parentProps) {
      return null === parentProps || true !== parentProps[SUPPRESS_HYDRATION_WARNING] ? (textInstance.nodeValue === text2 ? textInstance = null : (text2 = normalizeMarkupForTextOrAttribute(text2), textInstance = normalizeMarkupForTextOrAttribute(textInstance.nodeValue) === text2 ? null : textInstance.nodeValue), textInstance) : null;
    }
    function getNextHydratableInstanceAfterHydrationBoundary(hydrationInstance) {
      hydrationInstance = hydrationInstance.nextSibling;
      for (var depth = 0; hydrationInstance; ) {
        if (8 === hydrationInstance.nodeType) {
          var data = hydrationInstance.data;
          if (data === SUSPENSE_END_DATA || data === ACTIVITY_END_DATA) {
            if (0 === depth)
              return getNextHydratable(hydrationInstance.nextSibling);
            depth--;
          } else
            data !== SUSPENSE_START_DATA && data !== SUSPENSE_FALLBACK_START_DATA && data !== SUSPENSE_PENDING_START_DATA && data !== SUSPENSE_QUEUED_START_DATA && data !== ACTIVITY_START_DATA || depth++;
        }
        hydrationInstance = hydrationInstance.nextSibling;
      }
      return null;
    }
    function getParentHydrationBoundary(targetInstance) {
      targetInstance = targetInstance.previousSibling;
      for (var depth = 0; targetInstance; ) {
        if (8 === targetInstance.nodeType) {
          var data = targetInstance.data;
          if (data === SUSPENSE_START_DATA || data === SUSPENSE_FALLBACK_START_DATA || data === SUSPENSE_PENDING_START_DATA || data === SUSPENSE_QUEUED_START_DATA || data === ACTIVITY_START_DATA) {
            if (0 === depth) return targetInstance;
            depth--;
          } else
            data !== SUSPENSE_END_DATA && data !== ACTIVITY_END_DATA || depth++;
        }
        targetInstance = targetInstance.previousSibling;
      }
      return null;
    }
    function commitHydratedContainer(container) {
      retryIfBlockedOn(container);
    }
    function commitHydratedActivityInstance(activityInstance) {
      retryIfBlockedOn(activityInstance);
    }
    function commitHydratedSuspenseInstance(suspenseInstance) {
      retryIfBlockedOn(suspenseInstance);
    }
    function resolveSingletonInstance(type, props2, rootContainerInstance, hostContext, validateDOMNestingDev) {
      validateDOMNestingDev && validateDOMNesting(type, hostContext.ancestorInfo);
      props2 = getOwnerDocumentFromRootContainer(rootContainerInstance);
      switch (type) {
        case "html":
          type = props2.documentElement;
          if (!type)
            throw Error(
              "React expected an <html> element (document.documentElement) to exist in the Document but one was not found. React never removes the documentElement for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        case "head":
          type = props2.head;
          if (!type)
            throw Error(
              "React expected a <head> element (document.head) to exist in the Document but one was not found. React never removes the head for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        case "body":
          type = props2.body;
          if (!type)
            throw Error(
              "React expected a <body> element (document.body) to exist in the Document but one was not found. React never removes the body for any Document it renders into so the cause is likely in some other script running on this page."
            );
          return type;
        default:
          throw Error(
            "resolveSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
    }
    function acquireSingletonInstance(type, props2, instance, internalInstanceHandle) {
      if (!instance[internalContainerInstanceKey] && getInstanceFromNode(instance)) {
        var tagName = instance.tagName.toLowerCase();
        console.error(
          "You are mounting a new %s component when a previous one has not first unmounted. It is an error to render more than one %s component at a time and attributes and children of these components will likely fail in unpredictable ways. Please only render a single instance of <%s> and if you need to mount a new one, ensure any previous ones have unmounted first.",
          tagName,
          tagName,
          tagName
        );
      }
      switch (type) {
        case "html":
        case "head":
        case "body":
          break;
        default:
          console.error(
            "acquireSingletonInstance was called with an element type that is not supported. This is a bug in React."
          );
      }
      for (tagName = instance.attributes; tagName.length; )
        instance.removeAttributeNode(tagName[0]);
      setInitialProperties(instance, type, props2);
      instance[internalInstanceKey] = internalInstanceHandle;
      instance[internalPropsKey] = props2;
    }
    function releaseSingletonInstance(instance) {
      for (var attributes = instance.attributes; attributes.length; )
        instance.removeAttributeNode(attributes[0]);
      detachDeletedInstance(instance);
    }
    function getHoistableRoot(container) {
      return "function" === typeof container.getRootNode ? container.getRootNode() : 9 === container.nodeType ? container : container.ownerDocument;
    }
    function preconnectAs(rel, href, crossOrigin) {
      var ownerDocument = globalDocument;
      if (ownerDocument && "string" === typeof href && href) {
        var limitedEscapedHref = escapeSelectorAttributeValueInsideDoubleQuotes(href);
        limitedEscapedHref = 'link[rel="' + rel + '"][href="' + limitedEscapedHref + '"]';
        "string" === typeof crossOrigin && (limitedEscapedHref += '[crossorigin="' + crossOrigin + '"]');
        preconnectsSet.has(limitedEscapedHref) || (preconnectsSet.add(limitedEscapedHref), rel = { rel, crossOrigin, href }, null === ownerDocument.querySelector(limitedEscapedHref) && (href = ownerDocument.createElement("link"), setInitialProperties(href, "link", rel), markNodeAsHoistable(href), ownerDocument.head.appendChild(href)));
      }
    }
    function getResource(type, currentProps, pendingProps, currentResource) {
      var resourceRoot = (resourceRoot = rootInstanceStackCursor.current) ? getHoistableRoot(resourceRoot) : null;
      if (!resourceRoot)
        throw Error(
          '"resourceRoot" was expected to exist. This is a bug in React.'
        );
      switch (type) {
        case "meta":
        case "title":
          return null;
        case "style":
          return "string" === typeof pendingProps.precedence && "string" === typeof pendingProps.href ? (pendingProps = getStyleKey(pendingProps.href), currentProps = getResourcesFromRoot(resourceRoot).hoistableStyles, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "style",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        case "link":
          if ("stylesheet" === pendingProps.rel && "string" === typeof pendingProps.href && "string" === typeof pendingProps.precedence) {
            type = getStyleKey(pendingProps.href);
            var _styles = getResourcesFromRoot(resourceRoot).hoistableStyles, _resource = _styles.get(type);
            if (!_resource && (resourceRoot = resourceRoot.ownerDocument || resourceRoot, _resource = {
              type: "stylesheet",
              instance: null,
              count: 0,
              state: { loading: NotLoaded, preload: null }
            }, _styles.set(type, _resource), (_styles = resourceRoot.querySelector(
              getStylesheetSelectorFromKey(type)
            )) && !_styles._p && (_resource.instance = _styles, _resource.state.loading = Loaded | Inserted), !preloadPropsMap.has(type))) {
              var preloadProps = {
                rel: "preload",
                as: "style",
                href: pendingProps.href,
                crossOrigin: pendingProps.crossOrigin,
                integrity: pendingProps.integrity,
                media: pendingProps.media,
                hrefLang: pendingProps.hrefLang,
                referrerPolicy: pendingProps.referrerPolicy
              };
              preloadPropsMap.set(type, preloadProps);
              _styles || preloadStylesheet(
                resourceRoot,
                type,
                preloadProps,
                _resource.state
              );
            }
            if (currentProps && null === currentResource)
              throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
                "Expected <link> not to update to be updated to a stylesheet with precedence. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
              );
            return _resource;
          }
          if (currentProps && null !== currentResource)
            throw pendingProps = "\n\n  - " + describeLinkForResourceErrorDEV(currentProps) + "\n  + " + describeLinkForResourceErrorDEV(pendingProps), Error(
              "Expected stylesheet with precedence to not be updated to a different kind of <link>. Check the `rel`, `href`, and `precedence` props of this component. Alternatively, check whether two different <link> components render in the same slot or share the same key." + pendingProps
            );
          return null;
        case "script":
          return currentProps = pendingProps.async, pendingProps = pendingProps.src, "string" === typeof pendingProps && currentProps && "function" !== typeof currentProps && "symbol" !== typeof currentProps ? (pendingProps = getScriptKey(pendingProps), currentProps = getResourcesFromRoot(resourceRoot).hoistableScripts, currentResource = currentProps.get(pendingProps), currentResource || (currentResource = {
            type: "script",
            instance: null,
            count: 0,
            state: null
          }, currentProps.set(pendingProps, currentResource)), currentResource) : { type: "void", instance: null, count: 0, state: null };
        default:
          throw Error(
            'getResource encountered a type it did not expect: "' + type + '". this is a bug in React.'
          );
      }
    }
    function describeLinkForResourceErrorDEV(props2) {
      var describedProps = 0, description = "<link";
      "string" === typeof props2.rel ? (describedProps++, description += ' rel="' + props2.rel + '"') : hasOwnProperty2.call(props2, "rel") && (describedProps++, description += ' rel="' + (null === props2.rel ? "null" : "invalid type " + typeof props2.rel) + '"');
      "string" === typeof props2.href ? (describedProps++, description += ' href="' + props2.href + '"') : hasOwnProperty2.call(props2, "href") && (describedProps++, description += ' href="' + (null === props2.href ? "null" : "invalid type " + typeof props2.href) + '"');
      "string" === typeof props2.precedence ? (describedProps++, description += ' precedence="' + props2.precedence + '"') : hasOwnProperty2.call(props2, "precedence") && (describedProps++, description += " precedence={" + (null === props2.precedence ? "null" : "invalid type " + typeof props2.precedence) + "}");
      Object.getOwnPropertyNames(props2).length > describedProps && (description += " ...");
      return description + " />";
    }
    function getStyleKey(href) {
      return 'href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"';
    }
    function getStylesheetSelectorFromKey(key) {
      return 'link[rel="stylesheet"][' + key + "]";
    }
    function stylesheetPropsFromRawProps(rawProps) {
      return assign2({}, rawProps, {
        "data-precedence": rawProps.precedence,
        precedence: null
      });
    }
    function preloadStylesheet(ownerDocument, key, preloadProps, state) {
      ownerDocument.querySelector(
        'link[rel="preload"][as="style"][' + key + "]"
      ) ? state.loading = Loaded : (key = ownerDocument.createElement("link"), state.preload = key, key.addEventListener("load", function() {
        return state.loading |= Loaded;
      }), key.addEventListener("error", function() {
        return state.loading |= Errored;
      }), setInitialProperties(key, "link", preloadProps), markNodeAsHoistable(key), ownerDocument.head.appendChild(key));
    }
    function getScriptKey(src) {
      return '[src="' + escapeSelectorAttributeValueInsideDoubleQuotes(src) + '"]';
    }
    function getScriptSelectorFromKey(key) {
      return "script[async]" + key;
    }
    function acquireResource(hoistableRoot, resource, props2) {
      resource.count++;
      if (null === resource.instance)
        switch (resource.type) {
          case "style":
            var instance = hoistableRoot.querySelector(
              'style[data-href~="' + escapeSelectorAttributeValueInsideDoubleQuotes(props2.href) + '"]'
            );
            if (instance)
              return resource.instance = instance, markNodeAsHoistable(instance), instance;
            var styleProps = assign2({}, props2, {
              "data-href": props2.href,
              "data-precedence": props2.precedence,
              href: null,
              precedence: null
            });
            instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("style");
            markNodeAsHoistable(instance);
            setInitialProperties(instance, "style", styleProps);
            insertStylesheet(instance, props2.precedence, hoistableRoot);
            return resource.instance = instance;
          case "stylesheet":
            styleProps = getStyleKey(props2.href);
            var _instance = hoistableRoot.querySelector(
              getStylesheetSelectorFromKey(styleProps)
            );
            if (_instance)
              return resource.state.loading |= Inserted, resource.instance = _instance, markNodeAsHoistable(_instance), _instance;
            instance = stylesheetPropsFromRawProps(props2);
            (styleProps = preloadPropsMap.get(styleProps)) && adoptPreloadPropsForStylesheet(instance, styleProps);
            _instance = (hoistableRoot.ownerDocument || hoistableRoot).createElement("link");
            markNodeAsHoistable(_instance);
            var linkInstance = _instance;
            linkInstance._p = new Promise(function(resolve, reject2) {
              linkInstance.onload = resolve;
              linkInstance.onerror = reject2;
            });
            setInitialProperties(_instance, "link", instance);
            resource.state.loading |= Inserted;
            insertStylesheet(_instance, props2.precedence, hoistableRoot);
            return resource.instance = _instance;
          case "script":
            _instance = getScriptKey(props2.src);
            if (styleProps = hoistableRoot.querySelector(
              getScriptSelectorFromKey(_instance)
            ))
              return resource.instance = styleProps, markNodeAsHoistable(styleProps), styleProps;
            instance = props2;
            if (styleProps = preloadPropsMap.get(_instance))
              instance = assign2({}, props2), adoptPreloadPropsForScript(instance, styleProps);
            hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
            styleProps = hoistableRoot.createElement("script");
            markNodeAsHoistable(styleProps);
            setInitialProperties(styleProps, "link", instance);
            hoistableRoot.head.appendChild(styleProps);
            return resource.instance = styleProps;
          case "void":
            return null;
          default:
            throw Error(
              'acquireResource encountered a resource type it did not expect: "' + resource.type + '". this is a bug in React.'
            );
        }
      else
        "stylesheet" === resource.type && (resource.state.loading & Inserted) === NotLoaded && (instance = resource.instance, resource.state.loading |= Inserted, insertStylesheet(instance, props2.precedence, hoistableRoot));
      return resource.instance;
    }
    function insertStylesheet(instance, precedence, root3) {
      for (var nodes = root3.querySelectorAll(
        'link[rel="stylesheet"][data-precedence],style[data-precedence]'
      ), last2 = nodes.length ? nodes[nodes.length - 1] : null, prior = last2, i2 = 0; i2 < nodes.length; i2++) {
        var node = nodes[i2];
        if (node.dataset.precedence === precedence) prior = node;
        else if (prior !== last2) break;
      }
      prior ? prior.parentNode.insertBefore(instance, prior.nextSibling) : (precedence = 9 === root3.nodeType ? root3.head : root3, precedence.insertBefore(instance, precedence.firstChild));
    }
    function adoptPreloadPropsForStylesheet(stylesheetProps, preloadProps) {
      null == stylesheetProps.crossOrigin && (stylesheetProps.crossOrigin = preloadProps.crossOrigin);
      null == stylesheetProps.referrerPolicy && (stylesheetProps.referrerPolicy = preloadProps.referrerPolicy);
      null == stylesheetProps.title && (stylesheetProps.title = preloadProps.title);
    }
    function adoptPreloadPropsForScript(scriptProps, preloadProps) {
      null == scriptProps.crossOrigin && (scriptProps.crossOrigin = preloadProps.crossOrigin);
      null == scriptProps.referrerPolicy && (scriptProps.referrerPolicy = preloadProps.referrerPolicy);
      null == scriptProps.integrity && (scriptProps.integrity = preloadProps.integrity);
    }
    function getHydratableHoistableCache(type, keyAttribute, ownerDocument) {
      if (null === tagCaches) {
        var cache = /* @__PURE__ */ new Map();
        var caches = tagCaches = /* @__PURE__ */ new Map();
        caches.set(ownerDocument, cache);
      } else
        caches = tagCaches, cache = caches.get(ownerDocument), cache || (cache = /* @__PURE__ */ new Map(), caches.set(ownerDocument, cache));
      if (cache.has(type)) return cache;
      cache.set(type, null);
      ownerDocument = ownerDocument.getElementsByTagName(type);
      for (caches = 0; caches < ownerDocument.length; caches++) {
        var node = ownerDocument[caches];
        if (!(node[internalHoistableMarker] || node[internalInstanceKey] || "link" === type && "stylesheet" === node.getAttribute("rel")) && node.namespaceURI !== SVG_NAMESPACE) {
          var nodeKey = node.getAttribute(keyAttribute) || "";
          nodeKey = type + nodeKey;
          var existing = cache.get(nodeKey);
          existing ? existing.push(node) : cache.set(nodeKey, [node]);
        }
      }
      return cache;
    }
    function mountHoistable(hoistableRoot, type, instance) {
      hoistableRoot = hoistableRoot.ownerDocument || hoistableRoot;
      hoistableRoot.head.insertBefore(
        instance,
        "title" === type ? hoistableRoot.querySelector("head > title") : null
      );
    }
    function isHostHoistableType(type, props2, hostContext) {
      var outsideHostContainerContext = !hostContext.ancestorInfo.containerTagInScope;
      if (hostContext.context === HostContextNamespaceSvg || null != props2.itemProp)
        return !outsideHostContainerContext || null == props2.itemProp || "meta" !== type && "title" !== type && "style" !== type && "link" !== type && "script" !== type || console.error(
          "Cannot render a <%s> outside the main document if it has an `itemProp` prop. `itemProp` suggests the tag belongs to an `itemScope` which can appear anywhere in the DOM. If you were intending for React to hoist this <%s> remove the `itemProp` prop. Otherwise, try moving this tag into the <head> or <body> of the Document.",
          type,
          type
        ), false;
      switch (type) {
        case "meta":
        case "title":
          return true;
        case "style":
          if ("string" !== typeof props2.precedence || "string" !== typeof props2.href || "" === props2.href) {
            outsideHostContainerContext && console.error(
              'Cannot render a <style> outside the main document without knowing its precedence and a unique href key. React can hoist and deduplicate <style> tags if you provide a `precedence` prop along with an `href` prop that does not conflict with the `href` values used in any other hoisted <style> or <link rel="stylesheet" ...> tags.  Note that hoisting <style> tags is considered an advanced feature that most will not use directly. Consider moving the <style> tag to the <head> or consider adding a `precedence="default"` and `href="some unique resource identifier"`.'
            );
            break;
          }
          return true;
        case "link":
          if ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href || props2.onLoad || props2.onError) {
            if ("stylesheet" === props2.rel && "string" === typeof props2.precedence) {
              type = props2.href;
              var onError = props2.onError, disabled = props2.disabled;
              hostContext = [];
              props2.onLoad && hostContext.push("`onLoad`");
              onError && hostContext.push("`onError`");
              null != disabled && hostContext.push("`disabled`");
              onError = propNamesListJoin(hostContext, "and");
              onError += 1 === hostContext.length ? " prop" : " props";
              disabled = 1 === hostContext.length ? "an " + onError : "the " + onError;
              hostContext.length && console.error(
                'React encountered a <link rel="stylesheet" href="%s" ... /> with a `precedence` prop that also included %s. The presence of loading and error handlers indicates an intent to manage the stylesheet loading state from your from your Component code and React will not hoist or deduplicate this stylesheet. If your intent was to have React hoist and deduplciate this stylesheet using the `precedence` prop remove the %s, otherwise remove the `precedence` prop.',
                type,
                disabled,
                onError
              );
            }
            outsideHostContainerContext && ("string" !== typeof props2.rel || "string" !== typeof props2.href || "" === props2.href ? console.error(
              "Cannot render a <link> outside the main document without a `rel` and `href` prop. Try adding a `rel` and/or `href` prop to this <link> or moving the link into the <head> tag"
            ) : (props2.onError || props2.onLoad) && console.error(
              "Cannot render a <link> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ));
            break;
          }
          switch (props2.rel) {
            case "stylesheet":
              return type = props2.precedence, props2 = props2.disabled, "string" !== typeof type && outsideHostContainerContext && console.error(
                'Cannot render a <link rel="stylesheet" /> outside the main document without knowing its precedence. Consider adding precedence="default" or moving it into the root <head> tag.'
              ), "string" === typeof type && null == props2;
            default:
              return true;
          }
        case "script":
          type = props2.async && "function" !== typeof props2.async && "symbol" !== typeof props2.async;
          if (!type || props2.onLoad || props2.onError || !props2.src || "string" !== typeof props2.src) {
            outsideHostContainerContext && (type ? props2.onLoad || props2.onError ? console.error(
              "Cannot render a <script> with onLoad or onError listeners outside the main document. Try removing onLoad={...} and onError={...} or moving it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              "Cannot render a <script> outside the main document without `async={true}` and a non-empty `src` prop. Ensure there is a valid `src` and either make the script async or move it into the root <head> tag or somewhere in the <body>."
            ) : console.error(
              'Cannot render a sync or defer <script> outside the main document without knowing its order. Try adding async="" or moving it into the root <head> tag.'
            ));
            break;
          }
          return true;
        case "noscript":
        case "template":
          outsideHostContainerContext && console.error(
            "Cannot render <%s> outside the main document. Try moving it into the root <head> tag.",
            type
          );
      }
      return false;
    }
    function preloadResource(resource) {
      return "stylesheet" === resource.type && (resource.state.loading & Settled) === NotLoaded ? false : true;
    }
    function suspendResource(state, hoistableRoot, resource, props2) {
      if ("stylesheet" === resource.type && ("string" !== typeof props2.media || false !== matchMedia(props2.media).matches) && (resource.state.loading & Inserted) === NotLoaded) {
        if (null === resource.instance) {
          var key = getStyleKey(props2.href), instance = hoistableRoot.querySelector(
            getStylesheetSelectorFromKey(key)
          );
          if (instance) {
            hoistableRoot = instance._p;
            null !== hoistableRoot && "object" === typeof hoistableRoot && "function" === typeof hoistableRoot.then && (state.count++, state = onUnsuspend.bind(state), hoistableRoot.then(state, state));
            resource.state.loading |= Inserted;
            resource.instance = instance;
            markNodeAsHoistable(instance);
            return;
          }
          instance = hoistableRoot.ownerDocument || hoistableRoot;
          props2 = stylesheetPropsFromRawProps(props2);
          (key = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(props2, key);
          instance = instance.createElement("link");
          markNodeAsHoistable(instance);
          var linkInstance = instance;
          linkInstance._p = new Promise(function(resolve, reject2) {
            linkInstance.onload = resolve;
            linkInstance.onerror = reject2;
          });
          setInitialProperties(instance, "link", props2);
          resource.instance = instance;
        }
        null === state.stylesheets && (state.stylesheets = /* @__PURE__ */ new Map());
        state.stylesheets.set(resource, hoistableRoot);
        (hoistableRoot = resource.state.preload) && (resource.state.loading & Settled) === NotLoaded && (state.count++, resource = onUnsuspend.bind(state), hoistableRoot.addEventListener("load", resource), hoistableRoot.addEventListener("error", resource));
      }
    }
    function waitForCommitToBeReady(state, timeoutOffset) {
      state.stylesheets && 0 === state.count && insertSuspendedStylesheets(state, state.stylesheets);
      return 0 < state.count || 0 < state.imgCount ? function(commit) {
        var stylesheetTimer = setTimeout(function() {
          state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets);
          if (state.unsuspend) {
            var unsuspend = state.unsuspend;
            state.unsuspend = null;
            unsuspend();
          }
        }, SUSPENSEY_STYLESHEET_TIMEOUT + timeoutOffset);
        0 < state.imgBytes && 0 === estimatedBytesWithinLimit && (estimatedBytesWithinLimit = 125 * estimateBandwidth() * SUSPENSEY_IMAGE_TIME_ESTIMATE);
        var imgTimer = setTimeout(
          function() {
            state.waitingForImages = false;
            if (0 === state.count && (state.stylesheets && insertSuspendedStylesheets(state, state.stylesheets), state.unsuspend)) {
              var unsuspend = state.unsuspend;
              state.unsuspend = null;
              unsuspend();
            }
          },
          (state.imgBytes > estimatedBytesWithinLimit ? 50 : SUSPENSEY_IMAGE_TIMEOUT) + timeoutOffset
        );
        state.unsuspend = commit;
        return function() {
          state.unsuspend = null;
          clearTimeout(stylesheetTimer);
          clearTimeout(imgTimer);
        };
      } : null;
    }
    function onUnsuspend() {
      this.count--;
      if (0 === this.count && (0 === this.imgCount || !this.waitingForImages)) {
        if (this.stylesheets)
          insertSuspendedStylesheets(this, this.stylesheets);
        else if (this.unsuspend) {
          var unsuspend = this.unsuspend;
          this.unsuspend = null;
          unsuspend();
        }
      }
    }
    function insertSuspendedStylesheets(state, resources) {
      state.stylesheets = null;
      null !== state.unsuspend && (state.count++, precedencesByRoot = /* @__PURE__ */ new Map(), resources.forEach(insertStylesheetIntoRoot, state), precedencesByRoot = null, onUnsuspend.call(state));
    }
    function insertStylesheetIntoRoot(root3, resource) {
      if (!(resource.state.loading & Inserted)) {
        var precedences = precedencesByRoot.get(root3);
        if (precedences) var last2 = precedences.get(LAST_PRECEDENCE);
        else {
          precedences = /* @__PURE__ */ new Map();
          precedencesByRoot.set(root3, precedences);
          for (var nodes = root3.querySelectorAll(
            "link[data-precedence],style[data-precedence]"
          ), i2 = 0; i2 < nodes.length; i2++) {
            var node = nodes[i2];
            if ("LINK" === node.nodeName || "not all" !== node.getAttribute("media"))
              precedences.set(node.dataset.precedence, node), last2 = node;
          }
          last2 && precedences.set(LAST_PRECEDENCE, last2);
        }
        nodes = resource.instance;
        node = nodes.getAttribute("data-precedence");
        i2 = precedences.get(node) || last2;
        i2 === last2 && precedences.set(LAST_PRECEDENCE, nodes);
        precedences.set(node, nodes);
        this.count++;
        last2 = onUnsuspend.bind(this);
        nodes.addEventListener("load", last2);
        nodes.addEventListener("error", last2);
        i2 ? i2.parentNode.insertBefore(nodes, i2.nextSibling) : (root3 = 9 === root3.nodeType ? root3.head : root3, root3.insertBefore(nodes, root3.firstChild));
        resource.state.loading |= Inserted;
      }
    }
    function FiberRootNode(containerInfo, tag2, hydrate, identifierPrefix, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator, formState) {
      this.tag = 1;
      this.containerInfo = containerInfo;
      this.pingCache = this.current = this.pendingChildren = null;
      this.timeoutHandle = noTimeout;
      this.callbackNode = this.next = this.pendingContext = this.context = this.cancelPendingCommit = null;
      this.callbackPriority = 0;
      this.expirationTimes = createLaneMap(-1);
      this.entangledLanes = this.shellSuspendCounter = this.errorRecoveryDisabledLanes = this.expiredLanes = this.warmLanes = this.pingedLanes = this.suspendedLanes = this.pendingLanes = 0;
      this.entanglements = createLaneMap(0);
      this.hiddenUpdates = createLaneMap(null);
      this.identifierPrefix = identifierPrefix;
      this.onUncaughtError = onUncaughtError;
      this.onCaughtError = onCaughtError;
      this.onRecoverableError = onRecoverableError;
      this.pooledCache = null;
      this.pooledCacheLanes = 0;
      this.formState = formState;
      this.incompleteTransitions = /* @__PURE__ */ new Map();
      this.passiveEffectDuration = this.effectDuration = -0;
      this.memoizedUpdaters = /* @__PURE__ */ new Set();
      containerInfo = this.pendingUpdatersLaneMap = [];
      for (tag2 = 0; 31 > tag2; tag2++) containerInfo.push(/* @__PURE__ */ new Set());
      this._debugRootType = hydrate ? "hydrateRoot()" : "createRoot()";
    }
    function createFiberRoot(containerInfo, tag2, hydrate, initialChildren, hydrationCallbacks, isStrictMode, identifierPrefix, formState, onUncaughtError, onCaughtError, onRecoverableError, onDefaultTransitionIndicator) {
      containerInfo = new FiberRootNode(
        containerInfo,
        tag2,
        hydrate,
        identifierPrefix,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        onDefaultTransitionIndicator,
        formState
      );
      tag2 = ConcurrentMode;
      true === isStrictMode && (tag2 |= StrictLegacyMode | StrictEffectsMode);
      tag2 |= ProfileMode;
      isStrictMode = createFiber(3, null, null, tag2);
      containerInfo.current = isStrictMode;
      isStrictMode.stateNode = containerInfo;
      tag2 = createCache();
      retainCache(tag2);
      containerInfo.pooledCache = tag2;
      retainCache(tag2);
      isStrictMode.memoizedState = {
        element: initialChildren,
        isDehydrated: hydrate,
        cache: tag2
      };
      initializeUpdateQueue(isStrictMode);
      return containerInfo;
    }
    function getContextForSubtree(parentComponent) {
      if (!parentComponent) return emptyContextObject;
      parentComponent = emptyContextObject;
      return parentComponent;
    }
    function updateContainerImpl(rootFiber, lane, element2, container, parentComponent, callback) {
      if (injectedHook && "function" === typeof injectedHook.onScheduleFiberRoot)
        try {
          injectedHook.onScheduleFiberRoot(rendererID, container, element2);
        } catch (err) {
          hasLoggedError || (hasLoggedError = true, console.error(
            "React instrumentation encountered an error: %o",
            err
          ));
        }
      parentComponent = getContextForSubtree(parentComponent);
      null === container.context ? container.context = parentComponent : container.pendingContext = parentComponent;
      isRendering && null !== current2 && !didWarnAboutNestedUpdates && (didWarnAboutNestedUpdates = true, console.error(
        "Render methods should be a pure function of props and state; triggering nested component updates from render is not allowed. If necessary, trigger nested updates in componentDidUpdate.\n\nCheck the render method of %s.",
        getComponentNameFromFiber(current2) || "Unknown"
      ));
      container = createUpdate(lane);
      container.payload = { element: element2 };
      callback = void 0 === callback ? null : callback;
      null !== callback && ("function" !== typeof callback && console.error(
        "Expected the last optional `callback` argument to be a function. Instead received: %s.",
        callback
      ), container.callback = callback);
      element2 = enqueueUpdate(rootFiber, container, lane);
      null !== element2 && (startUpdateTimerByLane(lane, "root.render()", null), scheduleUpdateOnFiber(element2, rootFiber, lane), entangleTransitions(element2, rootFiber, lane));
    }
    function markRetryLaneImpl(fiber, retryLane) {
      fiber = fiber.memoizedState;
      if (null !== fiber && null !== fiber.dehydrated) {
        var a2 = fiber.retryLane;
        fiber.retryLane = 0 !== a2 && a2 < retryLane ? a2 : retryLane;
      }
    }
    function markRetryLaneIfNotHydrated(fiber, retryLane) {
      markRetryLaneImpl(fiber, retryLane);
      (fiber = fiber.alternate) && markRetryLaneImpl(fiber, retryLane);
    }
    function attemptContinuousHydration(fiber) {
      if (13 === fiber.tag || 31 === fiber.tag) {
        var root3 = enqueueConcurrentRenderForLane(fiber, 67108864);
        null !== root3 && scheduleUpdateOnFiber(root3, fiber, 67108864);
        markRetryLaneIfNotHydrated(fiber, 67108864);
      }
    }
    function attemptHydrationAtCurrentPriority(fiber) {
      if (13 === fiber.tag || 31 === fiber.tag) {
        var lane = requestUpdateLane(fiber);
        lane = getBumpedLaneForHydrationByLane(lane);
        var root3 = enqueueConcurrentRenderForLane(fiber, lane);
        null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
        markRetryLaneIfNotHydrated(fiber, lane);
      }
    }
    function getCurrentFiberForDevTools() {
      return current2;
    }
    function dispatchDiscreteEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = DiscreteEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchContinuousEvent(domEventName, eventSystemFlags, container, nativeEvent) {
      var prevTransition = ReactSharedInternals.T;
      ReactSharedInternals.T = null;
      var previousPriority = ReactDOMSharedInternals.p;
      try {
        ReactDOMSharedInternals.p = ContinuousEventPriority, dispatchEvent(domEventName, eventSystemFlags, container, nativeEvent);
      } finally {
        ReactDOMSharedInternals.p = previousPriority, ReactSharedInternals.T = prevTransition;
      }
    }
    function dispatchEvent(domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (_enabled) {
        var blockedOn = findInstanceBlockingEvent(nativeEvent);
        if (null === blockedOn)
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            return_targetInst,
            targetContainer
          ), clearIfContinuousEvent(domEventName, nativeEvent);
        else if (queueIfContinuousEvent(
          blockedOn,
          domEventName,
          eventSystemFlags,
          targetContainer,
          nativeEvent
        ))
          nativeEvent.stopPropagation();
        else if (clearIfContinuousEvent(domEventName, nativeEvent), eventSystemFlags & 4 && -1 < discreteReplayableEvents.indexOf(domEventName)) {
          for (; null !== blockedOn; ) {
            var fiber = getInstanceFromNode(blockedOn);
            if (null !== fiber)
              switch (fiber.tag) {
                case 3:
                  fiber = fiber.stateNode;
                  if (fiber.current.memoizedState.isDehydrated) {
                    var lanes = getHighestPriorityLanes(fiber.pendingLanes);
                    if (0 !== lanes) {
                      var root3 = fiber;
                      root3.pendingLanes |= 2;
                      for (root3.entangledLanes |= 2; lanes; ) {
                        var lane = 1 << 31 - clz32(lanes);
                        root3.entanglements[1] |= lane;
                        lanes &= ~lane;
                      }
                      ensureRootIsScheduled(fiber);
                      (executionContext & (RenderContext | CommitContext)) === NoContext && (workInProgressRootRenderTargetTime = now$1() + RENDER_TIMEOUT_MS, flushSyncWorkAcrossRoots_impl(0));
                    }
                  }
                  break;
                case 31:
                case 13:
                  root3 = enqueueConcurrentRenderForLane(fiber, 2), null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2), flushSyncWork$1(), markRetryLaneIfNotHydrated(fiber, 2);
              }
            fiber = findInstanceBlockingEvent(nativeEvent);
            null === fiber && dispatchEventForPluginEventSystem(
              domEventName,
              eventSystemFlags,
              nativeEvent,
              return_targetInst,
              targetContainer
            );
            if (fiber === blockedOn) break;
            blockedOn = fiber;
          }
          null !== blockedOn && nativeEvent.stopPropagation();
        } else
          dispatchEventForPluginEventSystem(
            domEventName,
            eventSystemFlags,
            nativeEvent,
            null,
            targetContainer
          );
      }
    }
    function findInstanceBlockingEvent(nativeEvent) {
      nativeEvent = getEventTarget(nativeEvent);
      return findInstanceBlockingTarget(nativeEvent);
    }
    function findInstanceBlockingTarget(targetNode) {
      return_targetInst = null;
      targetNode = getClosestInstanceFromNode(targetNode);
      if (null !== targetNode) {
        var nearestMounted = getNearestMountedFiber(targetNode);
        if (null === nearestMounted) targetNode = null;
        else {
          var tag2 = nearestMounted.tag;
          if (13 === tag2) {
            targetNode = getSuspenseInstanceFromFiber(nearestMounted);
            if (null !== targetNode) return targetNode;
            targetNode = null;
          } else if (31 === tag2) {
            targetNode = getActivityInstanceFromFiber(nearestMounted);
            if (null !== targetNode) return targetNode;
            targetNode = null;
          } else if (3 === tag2) {
            if (nearestMounted.stateNode.current.memoizedState.isDehydrated)
              return 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            targetNode = null;
          } else nearestMounted !== targetNode && (targetNode = null);
        }
      }
      return_targetInst = targetNode;
      return null;
    }
    function getEventPriority(domEventName) {
      switch (domEventName) {
        case "beforetoggle":
        case "cancel":
        case "click":
        case "close":
        case "contextmenu":
        case "copy":
        case "cut":
        case "auxclick":
        case "dblclick":
        case "dragend":
        case "dragstart":
        case "drop":
        case "focusin":
        case "focusout":
        case "input":
        case "invalid":
        case "keydown":
        case "keypress":
        case "keyup":
        case "mousedown":
        case "mouseup":
        case "paste":
        case "pause":
        case "play":
        case "pointercancel":
        case "pointerdown":
        case "pointerup":
        case "ratechange":
        case "reset":
        case "resize":
        case "seeked":
        case "submit":
        case "toggle":
        case "touchcancel":
        case "touchend":
        case "touchstart":
        case "volumechange":
        case "change":
        case "selectionchange":
        case "textInput":
        case "compositionstart":
        case "compositionend":
        case "compositionupdate":
        case "beforeblur":
        case "afterblur":
        case "beforeinput":
        case "blur":
        case "fullscreenchange":
        case "focus":
        case "hashchange":
        case "popstate":
        case "select":
        case "selectstart":
          return DiscreteEventPriority;
        case "drag":
        case "dragenter":
        case "dragexit":
        case "dragleave":
        case "dragover":
        case "mousemove":
        case "mouseout":
        case "mouseover":
        case "pointermove":
        case "pointerout":
        case "pointerover":
        case "scroll":
        case "touchmove":
        case "wheel":
        case "mouseenter":
        case "mouseleave":
        case "pointerenter":
        case "pointerleave":
          return ContinuousEventPriority;
        case "message":
          switch (getCurrentPriorityLevel()) {
            case ImmediatePriority:
              return DiscreteEventPriority;
            case UserBlockingPriority:
              return ContinuousEventPriority;
            case NormalPriority$1:
            case LowPriority:
              return DefaultEventPriority;
            case IdlePriority:
              return IdleEventPriority;
            default:
              return DefaultEventPriority;
          }
        default:
          return DefaultEventPriority;
      }
    }
    function clearIfContinuousEvent(domEventName, nativeEvent) {
      switch (domEventName) {
        case "focusin":
        case "focusout":
          queuedFocus = null;
          break;
        case "dragenter":
        case "dragleave":
          queuedDrag = null;
          break;
        case "mouseover":
        case "mouseout":
          queuedMouse = null;
          break;
        case "pointerover":
        case "pointerout":
          queuedPointers.delete(nativeEvent.pointerId);
          break;
        case "gotpointercapture":
        case "lostpointercapture":
          queuedPointerCaptures.delete(nativeEvent.pointerId);
      }
    }
    function accumulateOrCreateContinuousQueuedReplayableEvent(existingQueuedEvent, blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      if (null === existingQueuedEvent || existingQueuedEvent.nativeEvent !== nativeEvent)
        return existingQueuedEvent = {
          blockedOn,
          domEventName,
          eventSystemFlags,
          nativeEvent,
          targetContainers: [targetContainer]
        }, null !== blockedOn && (blockedOn = getInstanceFromNode(blockedOn), null !== blockedOn && attemptContinuousHydration(blockedOn)), existingQueuedEvent;
      existingQueuedEvent.eventSystemFlags |= eventSystemFlags;
      blockedOn = existingQueuedEvent.targetContainers;
      null !== targetContainer && -1 === blockedOn.indexOf(targetContainer) && blockedOn.push(targetContainer);
      return existingQueuedEvent;
    }
    function queueIfContinuousEvent(blockedOn, domEventName, eventSystemFlags, targetContainer, nativeEvent) {
      switch (domEventName) {
        case "focusin":
          return queuedFocus = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedFocus,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "dragenter":
          return queuedDrag = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedDrag,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "mouseover":
          return queuedMouse = accumulateOrCreateContinuousQueuedReplayableEvent(
            queuedMouse,
            blockedOn,
            domEventName,
            eventSystemFlags,
            targetContainer,
            nativeEvent
          ), true;
        case "pointerover":
          var pointerId = nativeEvent.pointerId;
          queuedPointers.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointers.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          );
          return true;
        case "gotpointercapture":
          return pointerId = nativeEvent.pointerId, queuedPointerCaptures.set(
            pointerId,
            accumulateOrCreateContinuousQueuedReplayableEvent(
              queuedPointerCaptures.get(pointerId) || null,
              blockedOn,
              domEventName,
              eventSystemFlags,
              targetContainer,
              nativeEvent
            )
          ), true;
      }
      return false;
    }
    function attemptExplicitHydrationTarget(queuedTarget) {
      var targetInst = getClosestInstanceFromNode(queuedTarget.target);
      if (null !== targetInst) {
        var nearestMounted = getNearestMountedFiber(targetInst);
        if (null !== nearestMounted) {
          if (targetInst = nearestMounted.tag, 13 === targetInst) {
            if (targetInst = getSuspenseInstanceFromFiber(nearestMounted), null !== targetInst) {
              queuedTarget.blockedOn = targetInst;
              runWithPriority(queuedTarget.priority, function() {
                attemptHydrationAtCurrentPriority(nearestMounted);
              });
              return;
            }
          } else if (31 === targetInst) {
            if (targetInst = getActivityInstanceFromFiber(nearestMounted), null !== targetInst) {
              queuedTarget.blockedOn = targetInst;
              runWithPriority(queuedTarget.priority, function() {
                attemptHydrationAtCurrentPriority(nearestMounted);
              });
              return;
            }
          } else if (3 === targetInst && nearestMounted.stateNode.current.memoizedState.isDehydrated) {
            queuedTarget.blockedOn = 3 === nearestMounted.tag ? nearestMounted.stateNode.containerInfo : null;
            return;
          }
        }
      }
      queuedTarget.blockedOn = null;
    }
    function attemptReplayContinuousQueuedEvent(queuedEvent) {
      if (null !== queuedEvent.blockedOn) return false;
      for (var targetContainers = queuedEvent.targetContainers; 0 < targetContainers.length; ) {
        var nextBlockedOn = findInstanceBlockingEvent(queuedEvent.nativeEvent);
        if (null === nextBlockedOn) {
          nextBlockedOn = queuedEvent.nativeEvent;
          var nativeEventClone = new nextBlockedOn.constructor(
            nextBlockedOn.type,
            nextBlockedOn
          ), event = nativeEventClone;
          null !== currentReplayingEvent && console.error(
            "Expected currently replaying event to be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = event;
          nextBlockedOn.target.dispatchEvent(nativeEventClone);
          null === currentReplayingEvent && console.error(
            "Expected currently replaying event to not be null. This error is likely caused by a bug in React. Please file an issue."
          );
          currentReplayingEvent = null;
        } else
          return targetContainers = getInstanceFromNode(nextBlockedOn), null !== targetContainers && attemptContinuousHydration(targetContainers), queuedEvent.blockedOn = nextBlockedOn, false;
        targetContainers.shift();
      }
      return true;
    }
    function attemptReplayContinuousQueuedEventInMap(queuedEvent, key, map2) {
      attemptReplayContinuousQueuedEvent(queuedEvent) && map2.delete(key);
    }
    function replayUnblockedEvents() {
      hasScheduledReplayAttempt = false;
      null !== queuedFocus && attemptReplayContinuousQueuedEvent(queuedFocus) && (queuedFocus = null);
      null !== queuedDrag && attemptReplayContinuousQueuedEvent(queuedDrag) && (queuedDrag = null);
      null !== queuedMouse && attemptReplayContinuousQueuedEvent(queuedMouse) && (queuedMouse = null);
      queuedPointers.forEach(attemptReplayContinuousQueuedEventInMap);
      queuedPointerCaptures.forEach(attemptReplayContinuousQueuedEventInMap);
    }
    function scheduleCallbackIfUnblocked(queuedEvent, unblocked) {
      queuedEvent.blockedOn === unblocked && (queuedEvent.blockedOn = null, hasScheduledReplayAttempt || (hasScheduledReplayAttempt = true, Scheduler2.unstable_scheduleCallback(
        Scheduler2.unstable_NormalPriority,
        replayUnblockedEvents
      )));
    }
    function scheduleReplayQueueIfNeeded(formReplayingQueue) {
      lastScheduledReplayQueue !== formReplayingQueue && (lastScheduledReplayQueue = formReplayingQueue, Scheduler2.unstable_scheduleCallback(
        Scheduler2.unstable_NormalPriority,
        function() {
          lastScheduledReplayQueue === formReplayingQueue && (lastScheduledReplayQueue = null);
          for (var i2 = 0; i2 < formReplayingQueue.length; i2 += 3) {
            var form = formReplayingQueue[i2], submitterOrAction = formReplayingQueue[i2 + 1], formData = formReplayingQueue[i2 + 2];
            if ("function" !== typeof submitterOrAction)
              if (null === findInstanceBlockingTarget(submitterOrAction || form))
                continue;
              else break;
            var formInst = getInstanceFromNode(form);
            null !== formInst && (formReplayingQueue.splice(i2, 3), i2 -= 3, form = {
              pending: true,
              data: formData,
              method: form.method,
              action: submitterOrAction
            }, Object.freeze(form), startHostTransition(
              formInst,
              form,
              submitterOrAction,
              formData
            ));
          }
        }
      ));
    }
    function retryIfBlockedOn(unblocked) {
      function unblock(queuedEvent) {
        return scheduleCallbackIfUnblocked(queuedEvent, unblocked);
      }
      null !== queuedFocus && scheduleCallbackIfUnblocked(queuedFocus, unblocked);
      null !== queuedDrag && scheduleCallbackIfUnblocked(queuedDrag, unblocked);
      null !== queuedMouse && scheduleCallbackIfUnblocked(queuedMouse, unblocked);
      queuedPointers.forEach(unblock);
      queuedPointerCaptures.forEach(unblock);
      for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length; i2++) {
        var queuedTarget = queuedExplicitHydrationTargets[i2];
        queuedTarget.blockedOn === unblocked && (queuedTarget.blockedOn = null);
      }
      for (; 0 < queuedExplicitHydrationTargets.length && (i2 = queuedExplicitHydrationTargets[0], null === i2.blockedOn); )
        attemptExplicitHydrationTarget(i2), null === i2.blockedOn && queuedExplicitHydrationTargets.shift();
      i2 = (unblocked.ownerDocument || unblocked).$$reactFormReplay;
      if (null != i2)
        for (queuedTarget = 0; queuedTarget < i2.length; queuedTarget += 3) {
          var form = i2[queuedTarget], submitterOrAction = i2[queuedTarget + 1], formProps = form[internalPropsKey] || null;
          if ("function" === typeof submitterOrAction)
            formProps || scheduleReplayQueueIfNeeded(i2);
          else if (formProps) {
            var action = null;
            if (submitterOrAction && submitterOrAction.hasAttribute("formAction"))
              if (form = submitterOrAction, formProps = submitterOrAction[internalPropsKey] || null)
                action = formProps.formAction;
              else {
                if (null !== findInstanceBlockingTarget(form)) continue;
              }
            else action = formProps.action;
            "function" === typeof action ? i2[queuedTarget + 1] = action : (i2.splice(queuedTarget, 3), queuedTarget -= 3);
            scheduleReplayQueueIfNeeded(i2);
          }
        }
    }
    function defaultOnDefaultTransitionIndicator() {
      function handleNavigate(event) {
        event.canIntercept && "react-transition" === event.info && event.intercept({
          handler: function() {
            return new Promise(function(resolve) {
              return pendingResolve = resolve;
            });
          },
          focusReset: "manual",
          scroll: "manual"
        });
      }
      function handleNavigateComplete() {
        null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        isCancelled || setTimeout(startFakeNavigation, 20);
      }
      function startFakeNavigation() {
        if (!isCancelled && !navigation.transition) {
          var currentEntry = navigation.currentEntry;
          currentEntry && null != currentEntry.url && navigation.navigate(currentEntry.url, {
            state: currentEntry.getState(),
            info: "react-transition",
            history: "replace"
          });
        }
      }
      if ("object" === typeof navigation) {
        var isCancelled = false, pendingResolve = null;
        navigation.addEventListener("navigate", handleNavigate);
        navigation.addEventListener("navigatesuccess", handleNavigateComplete);
        navigation.addEventListener("navigateerror", handleNavigateComplete);
        setTimeout(startFakeNavigation, 100);
        return function() {
          isCancelled = true;
          navigation.removeEventListener("navigate", handleNavigate);
          navigation.removeEventListener(
            "navigatesuccess",
            handleNavigateComplete
          );
          navigation.removeEventListener(
            "navigateerror",
            handleNavigateComplete
          );
          null !== pendingResolve && (pendingResolve(), pendingResolve = null);
        };
      }
    }
    function ReactDOMRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function ReactDOMHydrationRoot(internalRoot) {
      this._internalRoot = internalRoot;
    }
    function warnIfReactDOMContainerInDEV(container) {
      container[internalContainerInstanceKey] && (container._reactRootContainer ? console.error(
        "You are calling ReactDOMClient.createRoot() on a container that was previously passed to ReactDOM.render(). This is not supported."
      ) : console.error(
        "You are calling ReactDOMClient.createRoot() on a container that has already been passed to createRoot() before. Instead, call root.render() on the existing root instead if you want to update it."
      ));
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var Scheduler2 = requireScheduler(), React2 = React__default, ReactDOM = require$$2, assign2 = Object.assign, REACT_LEGACY_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.element"), REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy");
    var REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity");
    var REACT_MEMO_CACHE_SENTINEL = /* @__PURE__ */ Symbol.for("react.memo_cache_sentinel");
    var MAYBE_ITERATOR_SYMBOL = Symbol.iterator, REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), isArrayImpl = Array.isArray, ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, ReactDOMSharedInternals = ReactDOM.__DOM_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, NotPending = Object.freeze({
      pending: false,
      data: null,
      method: null,
      action: null
    }), valueStack = [];
    var fiberStack = [];
    var index$jscomp$0 = -1, contextStackCursor = createCursor(null), contextFiberStackCursor = createCursor(null), rootInstanceStackCursor = createCursor(null), hostTransitionProviderCursor = createCursor(null), disabledDepth = 0, prevLog, prevInfo, prevWarn, prevError, prevGroup, prevGroupCollapsed, prevGroupEnd;
    disabledLog.__reactDisabledLog = true;
    var prefix, suffix, reentry = false;
    var componentFrameCache = new ("function" === typeof WeakMap ? WeakMap : Map)();
    var current2 = null, isRendering = false, hasOwnProperty2 = Object.prototype.hasOwnProperty, scheduleCallback$3 = Scheduler2.unstable_scheduleCallback, cancelCallback$1 = Scheduler2.unstable_cancelCallback, shouldYield = Scheduler2.unstable_shouldYield, requestPaint = Scheduler2.unstable_requestPaint, now$1 = Scheduler2.unstable_now, getCurrentPriorityLevel = Scheduler2.unstable_getCurrentPriorityLevel, ImmediatePriority = Scheduler2.unstable_ImmediatePriority, UserBlockingPriority = Scheduler2.unstable_UserBlockingPriority, NormalPriority$1 = Scheduler2.unstable_NormalPriority, LowPriority = Scheduler2.unstable_LowPriority, IdlePriority = Scheduler2.unstable_IdlePriority, log$12 = Scheduler2.log, unstable_setDisableYieldValue = Scheduler2.unstable_setDisableYieldValue, rendererID = null, injectedHook = null, hasLoggedError = false, isDevToolsPresent = "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__, clz32 = Math.clz32 ? Math.clz32 : clz32Fallback, log3 = Math.log, LN2 = Math.LN2, nextTransitionUpdateLane = 256, nextTransitionDeferredLane = 262144, nextRetryLane = 4194304, DiscreteEventPriority = 2, ContinuousEventPriority = 8, DefaultEventPriority = 32, IdleEventPriority = 268435456, randomKey = Math.random().toString(36).slice(2), internalInstanceKey = "__reactFiber$" + randomKey, internalPropsKey = "__reactProps$" + randomKey, internalContainerInstanceKey = "__reactContainer$" + randomKey, internalEventHandlersKey = "__reactEvents$" + randomKey, internalEventHandlerListenersKey = "__reactListeners$" + randomKey, internalEventHandlesSetKey = "__reactHandles$" + randomKey, internalRootNodeResourcesKey = "__reactResources$" + randomKey, internalHoistableMarker = "__reactMarker$" + randomKey, allNativeEvents = /* @__PURE__ */ new Set(), registrationNameDependencies = {}, possibleRegistrationNames = {}, hasReadOnlyValue = {
      button: true,
      checkbox: true,
      image: true,
      hidden: true,
      radio: true,
      reset: true,
      submit: true
    }, VALID_ATTRIBUTE_NAME_REGEX = RegExp(
      "^[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), illegalAttributeNameCache = {}, validatedAttributeNameCache = {}, escapeSelectorAttributeValueInsideDoubleQuotesRegex = /[\n"\\]/g, didWarnValueDefaultValue$1 = false, didWarnCheckedDefaultChecked = false, didWarnSelectedSetOnOption = false, didWarnInvalidChild = false, didWarnInvalidInnerHTML = false;
    var didWarnValueDefaultValue = false;
    var valuePropNames = ["value", "defaultValue"], didWarnValDefaultVal = false, needsEscaping = /["'&<>\n\t]|^\s|\s$/, specialTags = "address applet area article aside base basefont bgsound blockquote body br button caption center col colgroup dd details dir div dl dt embed fieldset figcaption figure footer form frame frameset h1 h2 h3 h4 h5 h6 head header hgroup hr html iframe img input isindex li link listing main marquee menu menuitem meta nav noembed noframes noscript object ol p param plaintext pre script section select source style summary table tbody td template textarea tfoot th thead title tr track ul wbr xmp".split(
      " "
    ), inScopeTags = "applet caption html table td th marquee object template foreignObject desc title".split(
      " "
    ), buttonScopeTags = inScopeTags.concat(["button"]), impliedEndTags = "dd dt li option optgroup p rp rt".split(" "), emptyAncestorInfoDev = {
      current: null,
      formTag: null,
      aTagInScope: null,
      buttonTagInScope: null,
      nobrTagInScope: null,
      pTagInButtonScope: null,
      listItemTagAutoclosing: null,
      dlItemTagAutoclosing: null,
      containerTagInScope: null,
      implicitRootScope: false
    }, didWarn = {}, shorthandToLonghand = {
      animation: "animationDelay animationDirection animationDuration animationFillMode animationIterationCount animationName animationPlayState animationTimingFunction".split(
        " "
      ),
      background: "backgroundAttachment backgroundClip backgroundColor backgroundImage backgroundOrigin backgroundPositionX backgroundPositionY backgroundRepeat backgroundSize".split(
        " "
      ),
      backgroundPosition: ["backgroundPositionX", "backgroundPositionY"],
      border: "borderBottomColor borderBottomStyle borderBottomWidth borderImageOutset borderImageRepeat borderImageSlice borderImageSource borderImageWidth borderLeftColor borderLeftStyle borderLeftWidth borderRightColor borderRightStyle borderRightWidth borderTopColor borderTopStyle borderTopWidth".split(
        " "
      ),
      borderBlockEnd: [
        "borderBlockEndColor",
        "borderBlockEndStyle",
        "borderBlockEndWidth"
      ],
      borderBlockStart: [
        "borderBlockStartColor",
        "borderBlockStartStyle",
        "borderBlockStartWidth"
      ],
      borderBottom: [
        "borderBottomColor",
        "borderBottomStyle",
        "borderBottomWidth"
      ],
      borderColor: [
        "borderBottomColor",
        "borderLeftColor",
        "borderRightColor",
        "borderTopColor"
      ],
      borderImage: [
        "borderImageOutset",
        "borderImageRepeat",
        "borderImageSlice",
        "borderImageSource",
        "borderImageWidth"
      ],
      borderInlineEnd: [
        "borderInlineEndColor",
        "borderInlineEndStyle",
        "borderInlineEndWidth"
      ],
      borderInlineStart: [
        "borderInlineStartColor",
        "borderInlineStartStyle",
        "borderInlineStartWidth"
      ],
      borderLeft: ["borderLeftColor", "borderLeftStyle", "borderLeftWidth"],
      borderRadius: [
        "borderBottomLeftRadius",
        "borderBottomRightRadius",
        "borderTopLeftRadius",
        "borderTopRightRadius"
      ],
      borderRight: [
        "borderRightColor",
        "borderRightStyle",
        "borderRightWidth"
      ],
      borderStyle: [
        "borderBottomStyle",
        "borderLeftStyle",
        "borderRightStyle",
        "borderTopStyle"
      ],
      borderTop: ["borderTopColor", "borderTopStyle", "borderTopWidth"],
      borderWidth: [
        "borderBottomWidth",
        "borderLeftWidth",
        "borderRightWidth",
        "borderTopWidth"
      ],
      columnRule: ["columnRuleColor", "columnRuleStyle", "columnRuleWidth"],
      columns: ["columnCount", "columnWidth"],
      flex: ["flexBasis", "flexGrow", "flexShrink"],
      flexFlow: ["flexDirection", "flexWrap"],
      font: "fontFamily fontFeatureSettings fontKerning fontLanguageOverride fontSize fontSizeAdjust fontStretch fontStyle fontVariant fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition fontWeight lineHeight".split(
        " "
      ),
      fontVariant: "fontVariantAlternates fontVariantCaps fontVariantEastAsian fontVariantLigatures fontVariantNumeric fontVariantPosition".split(
        " "
      ),
      gap: ["columnGap", "rowGap"],
      grid: "gridAutoColumns gridAutoFlow gridAutoRows gridTemplateAreas gridTemplateColumns gridTemplateRows".split(
        " "
      ),
      gridArea: [
        "gridColumnEnd",
        "gridColumnStart",
        "gridRowEnd",
        "gridRowStart"
      ],
      gridColumn: ["gridColumnEnd", "gridColumnStart"],
      gridColumnGap: ["columnGap"],
      gridGap: ["columnGap", "rowGap"],
      gridRow: ["gridRowEnd", "gridRowStart"],
      gridRowGap: ["rowGap"],
      gridTemplate: [
        "gridTemplateAreas",
        "gridTemplateColumns",
        "gridTemplateRows"
      ],
      listStyle: ["listStyleImage", "listStylePosition", "listStyleType"],
      margin: ["marginBottom", "marginLeft", "marginRight", "marginTop"],
      marker: ["markerEnd", "markerMid", "markerStart"],
      mask: "maskClip maskComposite maskImage maskMode maskOrigin maskPositionX maskPositionY maskRepeat maskSize".split(
        " "
      ),
      maskPosition: ["maskPositionX", "maskPositionY"],
      outline: ["outlineColor", "outlineStyle", "outlineWidth"],
      overflow: ["overflowX", "overflowY"],
      padding: ["paddingBottom", "paddingLeft", "paddingRight", "paddingTop"],
      placeContent: ["alignContent", "justifyContent"],
      placeItems: ["alignItems", "justifyItems"],
      placeSelf: ["alignSelf", "justifySelf"],
      textDecoration: [
        "textDecorationColor",
        "textDecorationLine",
        "textDecorationStyle"
      ],
      textEmphasis: ["textEmphasisColor", "textEmphasisStyle"],
      transition: [
        "transitionDelay",
        "transitionDuration",
        "transitionProperty",
        "transitionTimingFunction"
      ],
      wordWrap: ["overflowWrap"]
    }, uppercasePattern = /([A-Z])/g, msPattern$1 = /^ms-/, badVendoredStyleNamePattern = /^(?:webkit|moz|o)[A-Z]/, msPattern = /^-ms-/, hyphenPattern = /-(.)/g, badStyleValueWithSemicolonPattern = /;\s*$/, warnedStyleNames = {}, warnedStyleValues = {}, warnedForNaNValue = false, warnedForInfinityValue = false, unitlessNumbers = new Set(
      "animationIterationCount aspectRatio borderImageOutset borderImageSlice borderImageWidth boxFlex boxFlexGroup boxOrdinalGroup columnCount columns flex flexGrow flexPositive flexShrink flexNegative flexOrder gridArea gridRow gridRowEnd gridRowSpan gridRowStart gridColumn gridColumnEnd gridColumnSpan gridColumnStart fontWeight lineClamp lineHeight opacity order orphans scale tabSize widows zIndex zoom fillOpacity floodOpacity stopOpacity strokeDasharray strokeDashoffset strokeMiterlimit strokeOpacity strokeWidth MozAnimationIterationCount MozBoxFlex MozBoxFlexGroup MozLineClamp msAnimationIterationCount msFlex msZoom msFlexGrow msFlexNegative msFlexOrder msFlexPositive msFlexShrink msGridColumn msGridColumnSpan msGridRow msGridRowSpan WebkitAnimationIterationCount WebkitBoxFlex WebKitBoxFlexGroup WebkitBoxOrdinalGroup WebkitColumnCount WebkitColumns WebkitFlex WebkitFlexGrow WebkitFlexPositive WebkitFlexShrink WebkitLineClamp".split(
        " "
      )
    ), MATH_NAMESPACE = "http://www.w3.org/1998/Math/MathML", SVG_NAMESPACE = "http://www.w3.org/2000/svg", aliases = /* @__PURE__ */ new Map([
      ["acceptCharset", "accept-charset"],
      ["htmlFor", "for"],
      ["httpEquiv", "http-equiv"],
      ["crossOrigin", "crossorigin"],
      ["accentHeight", "accent-height"],
      ["alignmentBaseline", "alignment-baseline"],
      ["arabicForm", "arabic-form"],
      ["baselineShift", "baseline-shift"],
      ["capHeight", "cap-height"],
      ["clipPath", "clip-path"],
      ["clipRule", "clip-rule"],
      ["colorInterpolation", "color-interpolation"],
      ["colorInterpolationFilters", "color-interpolation-filters"],
      ["colorProfile", "color-profile"],
      ["colorRendering", "color-rendering"],
      ["dominantBaseline", "dominant-baseline"],
      ["enableBackground", "enable-background"],
      ["fillOpacity", "fill-opacity"],
      ["fillRule", "fill-rule"],
      ["floodColor", "flood-color"],
      ["floodOpacity", "flood-opacity"],
      ["fontFamily", "font-family"],
      ["fontSize", "font-size"],
      ["fontSizeAdjust", "font-size-adjust"],
      ["fontStretch", "font-stretch"],
      ["fontStyle", "font-style"],
      ["fontVariant", "font-variant"],
      ["fontWeight", "font-weight"],
      ["glyphName", "glyph-name"],
      ["glyphOrientationHorizontal", "glyph-orientation-horizontal"],
      ["glyphOrientationVertical", "glyph-orientation-vertical"],
      ["horizAdvX", "horiz-adv-x"],
      ["horizOriginX", "horiz-origin-x"],
      ["imageRendering", "image-rendering"],
      ["letterSpacing", "letter-spacing"],
      ["lightingColor", "lighting-color"],
      ["markerEnd", "marker-end"],
      ["markerMid", "marker-mid"],
      ["markerStart", "marker-start"],
      ["overlinePosition", "overline-position"],
      ["overlineThickness", "overline-thickness"],
      ["paintOrder", "paint-order"],
      ["panose-1", "panose-1"],
      ["pointerEvents", "pointer-events"],
      ["renderingIntent", "rendering-intent"],
      ["shapeRendering", "shape-rendering"],
      ["stopColor", "stop-color"],
      ["stopOpacity", "stop-opacity"],
      ["strikethroughPosition", "strikethrough-position"],
      ["strikethroughThickness", "strikethrough-thickness"],
      ["strokeDasharray", "stroke-dasharray"],
      ["strokeDashoffset", "stroke-dashoffset"],
      ["strokeLinecap", "stroke-linecap"],
      ["strokeLinejoin", "stroke-linejoin"],
      ["strokeMiterlimit", "stroke-miterlimit"],
      ["strokeOpacity", "stroke-opacity"],
      ["strokeWidth", "stroke-width"],
      ["textAnchor", "text-anchor"],
      ["textDecoration", "text-decoration"],
      ["textRendering", "text-rendering"],
      ["transformOrigin", "transform-origin"],
      ["underlinePosition", "underline-position"],
      ["underlineThickness", "underline-thickness"],
      ["unicodeBidi", "unicode-bidi"],
      ["unicodeRange", "unicode-range"],
      ["unitsPerEm", "units-per-em"],
      ["vAlphabetic", "v-alphabetic"],
      ["vHanging", "v-hanging"],
      ["vIdeographic", "v-ideographic"],
      ["vMathematical", "v-mathematical"],
      ["vectorEffect", "vector-effect"],
      ["vertAdvY", "vert-adv-y"],
      ["vertOriginX", "vert-origin-x"],
      ["vertOriginY", "vert-origin-y"],
      ["wordSpacing", "word-spacing"],
      ["writingMode", "writing-mode"],
      ["xmlnsXlink", "xmlns:xlink"],
      ["xHeight", "x-height"]
    ]), possibleStandardNames = {
      accept: "accept",
      acceptcharset: "acceptCharset",
      "accept-charset": "acceptCharset",
      accesskey: "accessKey",
      action: "action",
      allowfullscreen: "allowFullScreen",
      alt: "alt",
      as: "as",
      async: "async",
      autocapitalize: "autoCapitalize",
      autocomplete: "autoComplete",
      autocorrect: "autoCorrect",
      autofocus: "autoFocus",
      autoplay: "autoPlay",
      autosave: "autoSave",
      capture: "capture",
      cellpadding: "cellPadding",
      cellspacing: "cellSpacing",
      challenge: "challenge",
      charset: "charSet",
      checked: "checked",
      children: "children",
      cite: "cite",
      class: "className",
      classid: "classID",
      classname: "className",
      cols: "cols",
      colspan: "colSpan",
      content: "content",
      contenteditable: "contentEditable",
      contextmenu: "contextMenu",
      controls: "controls",
      controlslist: "controlsList",
      coords: "coords",
      crossorigin: "crossOrigin",
      dangerouslysetinnerhtml: "dangerouslySetInnerHTML",
      data: "data",
      datetime: "dateTime",
      default: "default",
      defaultchecked: "defaultChecked",
      defaultvalue: "defaultValue",
      defer: "defer",
      dir: "dir",
      disabled: "disabled",
      disablepictureinpicture: "disablePictureInPicture",
      disableremoteplayback: "disableRemotePlayback",
      download: "download",
      draggable: "draggable",
      enctype: "encType",
      enterkeyhint: "enterKeyHint",
      fetchpriority: "fetchPriority",
      for: "htmlFor",
      form: "form",
      formmethod: "formMethod",
      formaction: "formAction",
      formenctype: "formEncType",
      formnovalidate: "formNoValidate",
      formtarget: "formTarget",
      frameborder: "frameBorder",
      headers: "headers",
      height: "height",
      hidden: "hidden",
      high: "high",
      href: "href",
      hreflang: "hrefLang",
      htmlfor: "htmlFor",
      httpequiv: "httpEquiv",
      "http-equiv": "httpEquiv",
      icon: "icon",
      id: "id",
      imagesizes: "imageSizes",
      imagesrcset: "imageSrcSet",
      inert: "inert",
      innerhtml: "innerHTML",
      inputmode: "inputMode",
      integrity: "integrity",
      is: "is",
      itemid: "itemID",
      itemprop: "itemProp",
      itemref: "itemRef",
      itemscope: "itemScope",
      itemtype: "itemType",
      keyparams: "keyParams",
      keytype: "keyType",
      kind: "kind",
      label: "label",
      lang: "lang",
      list: "list",
      loop: "loop",
      low: "low",
      manifest: "manifest",
      marginwidth: "marginWidth",
      marginheight: "marginHeight",
      max: "max",
      maxlength: "maxLength",
      media: "media",
      mediagroup: "mediaGroup",
      method: "method",
      min: "min",
      minlength: "minLength",
      multiple: "multiple",
      muted: "muted",
      name: "name",
      nomodule: "noModule",
      nonce: "nonce",
      novalidate: "noValidate",
      open: "open",
      optimum: "optimum",
      pattern: "pattern",
      placeholder: "placeholder",
      playsinline: "playsInline",
      poster: "poster",
      preload: "preload",
      profile: "profile",
      radiogroup: "radioGroup",
      readonly: "readOnly",
      referrerpolicy: "referrerPolicy",
      rel: "rel",
      required: "required",
      reversed: "reversed",
      role: "role",
      rows: "rows",
      rowspan: "rowSpan",
      sandbox: "sandbox",
      scope: "scope",
      scoped: "scoped",
      scrolling: "scrolling",
      seamless: "seamless",
      selected: "selected",
      shape: "shape",
      size: "size",
      sizes: "sizes",
      span: "span",
      spellcheck: "spellCheck",
      src: "src",
      srcdoc: "srcDoc",
      srclang: "srcLang",
      srcset: "srcSet",
      start: "start",
      step: "step",
      style: "style",
      summary: "summary",
      tabindex: "tabIndex",
      target: "target",
      title: "title",
      type: "type",
      usemap: "useMap",
      value: "value",
      width: "width",
      wmode: "wmode",
      wrap: "wrap",
      about: "about",
      accentheight: "accentHeight",
      "accent-height": "accentHeight",
      accumulate: "accumulate",
      additive: "additive",
      alignmentbaseline: "alignmentBaseline",
      "alignment-baseline": "alignmentBaseline",
      allowreorder: "allowReorder",
      alphabetic: "alphabetic",
      amplitude: "amplitude",
      arabicform: "arabicForm",
      "arabic-form": "arabicForm",
      ascent: "ascent",
      attributename: "attributeName",
      attributetype: "attributeType",
      autoreverse: "autoReverse",
      azimuth: "azimuth",
      basefrequency: "baseFrequency",
      baselineshift: "baselineShift",
      "baseline-shift": "baselineShift",
      baseprofile: "baseProfile",
      bbox: "bbox",
      begin: "begin",
      bias: "bias",
      by: "by",
      calcmode: "calcMode",
      capheight: "capHeight",
      "cap-height": "capHeight",
      clip: "clip",
      clippath: "clipPath",
      "clip-path": "clipPath",
      clippathunits: "clipPathUnits",
      cliprule: "clipRule",
      "clip-rule": "clipRule",
      color: "color",
      colorinterpolation: "colorInterpolation",
      "color-interpolation": "colorInterpolation",
      colorinterpolationfilters: "colorInterpolationFilters",
      "color-interpolation-filters": "colorInterpolationFilters",
      colorprofile: "colorProfile",
      "color-profile": "colorProfile",
      colorrendering: "colorRendering",
      "color-rendering": "colorRendering",
      contentscripttype: "contentScriptType",
      contentstyletype: "contentStyleType",
      cursor: "cursor",
      cx: "cx",
      cy: "cy",
      d: "d",
      datatype: "datatype",
      decelerate: "decelerate",
      descent: "descent",
      diffuseconstant: "diffuseConstant",
      direction: "direction",
      display: "display",
      divisor: "divisor",
      dominantbaseline: "dominantBaseline",
      "dominant-baseline": "dominantBaseline",
      dur: "dur",
      dx: "dx",
      dy: "dy",
      edgemode: "edgeMode",
      elevation: "elevation",
      enablebackground: "enableBackground",
      "enable-background": "enableBackground",
      end: "end",
      exponent: "exponent",
      externalresourcesrequired: "externalResourcesRequired",
      fill: "fill",
      fillopacity: "fillOpacity",
      "fill-opacity": "fillOpacity",
      fillrule: "fillRule",
      "fill-rule": "fillRule",
      filter: "filter",
      filterres: "filterRes",
      filterunits: "filterUnits",
      floodopacity: "floodOpacity",
      "flood-opacity": "floodOpacity",
      floodcolor: "floodColor",
      "flood-color": "floodColor",
      focusable: "focusable",
      fontfamily: "fontFamily",
      "font-family": "fontFamily",
      fontsize: "fontSize",
      "font-size": "fontSize",
      fontsizeadjust: "fontSizeAdjust",
      "font-size-adjust": "fontSizeAdjust",
      fontstretch: "fontStretch",
      "font-stretch": "fontStretch",
      fontstyle: "fontStyle",
      "font-style": "fontStyle",
      fontvariant: "fontVariant",
      "font-variant": "fontVariant",
      fontweight: "fontWeight",
      "font-weight": "fontWeight",
      format: "format",
      from: "from",
      fx: "fx",
      fy: "fy",
      g1: "g1",
      g2: "g2",
      glyphname: "glyphName",
      "glyph-name": "glyphName",
      glyphorientationhorizontal: "glyphOrientationHorizontal",
      "glyph-orientation-horizontal": "glyphOrientationHorizontal",
      glyphorientationvertical: "glyphOrientationVertical",
      "glyph-orientation-vertical": "glyphOrientationVertical",
      glyphref: "glyphRef",
      gradienttransform: "gradientTransform",
      gradientunits: "gradientUnits",
      hanging: "hanging",
      horizadvx: "horizAdvX",
      "horiz-adv-x": "horizAdvX",
      horizoriginx: "horizOriginX",
      "horiz-origin-x": "horizOriginX",
      ideographic: "ideographic",
      imagerendering: "imageRendering",
      "image-rendering": "imageRendering",
      in2: "in2",
      in: "in",
      inlist: "inlist",
      intercept: "intercept",
      k1: "k1",
      k2: "k2",
      k3: "k3",
      k4: "k4",
      k: "k",
      kernelmatrix: "kernelMatrix",
      kernelunitlength: "kernelUnitLength",
      kerning: "kerning",
      keypoints: "keyPoints",
      keysplines: "keySplines",
      keytimes: "keyTimes",
      lengthadjust: "lengthAdjust",
      letterspacing: "letterSpacing",
      "letter-spacing": "letterSpacing",
      lightingcolor: "lightingColor",
      "lighting-color": "lightingColor",
      limitingconeangle: "limitingConeAngle",
      local: "local",
      markerend: "markerEnd",
      "marker-end": "markerEnd",
      markerheight: "markerHeight",
      markermid: "markerMid",
      "marker-mid": "markerMid",
      markerstart: "markerStart",
      "marker-start": "markerStart",
      markerunits: "markerUnits",
      markerwidth: "markerWidth",
      mask: "mask",
      maskcontentunits: "maskContentUnits",
      maskunits: "maskUnits",
      mathematical: "mathematical",
      mode: "mode",
      numoctaves: "numOctaves",
      offset: "offset",
      opacity: "opacity",
      operator: "operator",
      order: "order",
      orient: "orient",
      orientation: "orientation",
      origin: "origin",
      overflow: "overflow",
      overlineposition: "overlinePosition",
      "overline-position": "overlinePosition",
      overlinethickness: "overlineThickness",
      "overline-thickness": "overlineThickness",
      paintorder: "paintOrder",
      "paint-order": "paintOrder",
      panose1: "panose1",
      "panose-1": "panose1",
      pathlength: "pathLength",
      patterncontentunits: "patternContentUnits",
      patterntransform: "patternTransform",
      patternunits: "patternUnits",
      pointerevents: "pointerEvents",
      "pointer-events": "pointerEvents",
      points: "points",
      pointsatx: "pointsAtX",
      pointsaty: "pointsAtY",
      pointsatz: "pointsAtZ",
      popover: "popover",
      popovertarget: "popoverTarget",
      popovertargetaction: "popoverTargetAction",
      prefix: "prefix",
      preservealpha: "preserveAlpha",
      preserveaspectratio: "preserveAspectRatio",
      primitiveunits: "primitiveUnits",
      property: "property",
      r: "r",
      radius: "radius",
      refx: "refX",
      refy: "refY",
      renderingintent: "renderingIntent",
      "rendering-intent": "renderingIntent",
      repeatcount: "repeatCount",
      repeatdur: "repeatDur",
      requiredextensions: "requiredExtensions",
      requiredfeatures: "requiredFeatures",
      resource: "resource",
      restart: "restart",
      result: "result",
      results: "results",
      rotate: "rotate",
      rx: "rx",
      ry: "ry",
      scale: "scale",
      security: "security",
      seed: "seed",
      shaperendering: "shapeRendering",
      "shape-rendering": "shapeRendering",
      slope: "slope",
      spacing: "spacing",
      specularconstant: "specularConstant",
      specularexponent: "specularExponent",
      speed: "speed",
      spreadmethod: "spreadMethod",
      startoffset: "startOffset",
      stddeviation: "stdDeviation",
      stemh: "stemh",
      stemv: "stemv",
      stitchtiles: "stitchTiles",
      stopcolor: "stopColor",
      "stop-color": "stopColor",
      stopopacity: "stopOpacity",
      "stop-opacity": "stopOpacity",
      strikethroughposition: "strikethroughPosition",
      "strikethrough-position": "strikethroughPosition",
      strikethroughthickness: "strikethroughThickness",
      "strikethrough-thickness": "strikethroughThickness",
      string: "string",
      stroke: "stroke",
      strokedasharray: "strokeDasharray",
      "stroke-dasharray": "strokeDasharray",
      strokedashoffset: "strokeDashoffset",
      "stroke-dashoffset": "strokeDashoffset",
      strokelinecap: "strokeLinecap",
      "stroke-linecap": "strokeLinecap",
      strokelinejoin: "strokeLinejoin",
      "stroke-linejoin": "strokeLinejoin",
      strokemiterlimit: "strokeMiterlimit",
      "stroke-miterlimit": "strokeMiterlimit",
      strokewidth: "strokeWidth",
      "stroke-width": "strokeWidth",
      strokeopacity: "strokeOpacity",
      "stroke-opacity": "strokeOpacity",
      suppresscontenteditablewarning: "suppressContentEditableWarning",
      suppresshydrationwarning: "suppressHydrationWarning",
      surfacescale: "surfaceScale",
      systemlanguage: "systemLanguage",
      tablevalues: "tableValues",
      targetx: "targetX",
      targety: "targetY",
      textanchor: "textAnchor",
      "text-anchor": "textAnchor",
      textdecoration: "textDecoration",
      "text-decoration": "textDecoration",
      textlength: "textLength",
      textrendering: "textRendering",
      "text-rendering": "textRendering",
      to: "to",
      transform: "transform",
      transformorigin: "transformOrigin",
      "transform-origin": "transformOrigin",
      typeof: "typeof",
      u1: "u1",
      u2: "u2",
      underlineposition: "underlinePosition",
      "underline-position": "underlinePosition",
      underlinethickness: "underlineThickness",
      "underline-thickness": "underlineThickness",
      unicode: "unicode",
      unicodebidi: "unicodeBidi",
      "unicode-bidi": "unicodeBidi",
      unicoderange: "unicodeRange",
      "unicode-range": "unicodeRange",
      unitsperem: "unitsPerEm",
      "units-per-em": "unitsPerEm",
      unselectable: "unselectable",
      valphabetic: "vAlphabetic",
      "v-alphabetic": "vAlphabetic",
      values: "values",
      vectoreffect: "vectorEffect",
      "vector-effect": "vectorEffect",
      version: "version",
      vertadvy: "vertAdvY",
      "vert-adv-y": "vertAdvY",
      vertoriginx: "vertOriginX",
      "vert-origin-x": "vertOriginX",
      vertoriginy: "vertOriginY",
      "vert-origin-y": "vertOriginY",
      vhanging: "vHanging",
      "v-hanging": "vHanging",
      videographic: "vIdeographic",
      "v-ideographic": "vIdeographic",
      viewbox: "viewBox",
      viewtarget: "viewTarget",
      visibility: "visibility",
      vmathematical: "vMathematical",
      "v-mathematical": "vMathematical",
      vocab: "vocab",
      widths: "widths",
      wordspacing: "wordSpacing",
      "word-spacing": "wordSpacing",
      writingmode: "writingMode",
      "writing-mode": "writingMode",
      x1: "x1",
      x2: "x2",
      x: "x",
      xchannelselector: "xChannelSelector",
      xheight: "xHeight",
      "x-height": "xHeight",
      xlinkactuate: "xlinkActuate",
      "xlink:actuate": "xlinkActuate",
      xlinkarcrole: "xlinkArcrole",
      "xlink:arcrole": "xlinkArcrole",
      xlinkhref: "xlinkHref",
      "xlink:href": "xlinkHref",
      xlinkrole: "xlinkRole",
      "xlink:role": "xlinkRole",
      xlinkshow: "xlinkShow",
      "xlink:show": "xlinkShow",
      xlinktitle: "xlinkTitle",
      "xlink:title": "xlinkTitle",
      xlinktype: "xlinkType",
      "xlink:type": "xlinkType",
      xmlbase: "xmlBase",
      "xml:base": "xmlBase",
      xmllang: "xmlLang",
      "xml:lang": "xmlLang",
      xmlns: "xmlns",
      "xml:space": "xmlSpace",
      xmlnsxlink: "xmlnsXlink",
      "xmlns:xlink": "xmlnsXlink",
      xmlspace: "xmlSpace",
      y1: "y1",
      y2: "y2",
      y: "y",
      ychannelselector: "yChannelSelector",
      z: "z",
      zoomandpan: "zoomAndPan"
    }, ariaProperties = {
      "aria-current": 0,
      "aria-description": 0,
      "aria-details": 0,
      "aria-disabled": 0,
      "aria-hidden": 0,
      "aria-invalid": 0,
      "aria-keyshortcuts": 0,
      "aria-label": 0,
      "aria-roledescription": 0,
      "aria-autocomplete": 0,
      "aria-checked": 0,
      "aria-expanded": 0,
      "aria-haspopup": 0,
      "aria-level": 0,
      "aria-modal": 0,
      "aria-multiline": 0,
      "aria-multiselectable": 0,
      "aria-orientation": 0,
      "aria-placeholder": 0,
      "aria-pressed": 0,
      "aria-readonly": 0,
      "aria-required": 0,
      "aria-selected": 0,
      "aria-sort": 0,
      "aria-valuemax": 0,
      "aria-valuemin": 0,
      "aria-valuenow": 0,
      "aria-valuetext": 0,
      "aria-atomic": 0,
      "aria-busy": 0,
      "aria-live": 0,
      "aria-relevant": 0,
      "aria-dropeffect": 0,
      "aria-grabbed": 0,
      "aria-activedescendant": 0,
      "aria-colcount": 0,
      "aria-colindex": 0,
      "aria-colspan": 0,
      "aria-controls": 0,
      "aria-describedby": 0,
      "aria-errormessage": 0,
      "aria-flowto": 0,
      "aria-labelledby": 0,
      "aria-owns": 0,
      "aria-posinset": 0,
      "aria-rowcount": 0,
      "aria-rowindex": 0,
      "aria-rowspan": 0,
      "aria-setsize": 0,
      "aria-braillelabel": 0,
      "aria-brailleroledescription": 0,
      "aria-colindextext": 0,
      "aria-rowindextext": 0
    }, warnedProperties$1 = {}, rARIA$1 = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel$1 = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), didWarnValueNull = false, warnedProperties = {}, EVENT_NAME_REGEX = /^on./, INVALID_EVENT_NAME_REGEX = /^on[^A-Z]/, rARIA = RegExp(
      "^(aria)-[:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), rARIACamel = RegExp(
      "^(aria)[A-Z][:A-Z_a-z\\u00C0-\\u00D6\\u00D8-\\u00F6\\u00F8-\\u02FF\\u0370-\\u037D\\u037F-\\u1FFF\\u200C-\\u200D\\u2070-\\u218F\\u2C00-\\u2FEF\\u3001-\\uD7FF\\uF900-\\uFDCF\\uFDF0-\\uFFFD\\-.0-9\\u00B7\\u0300-\\u036F\\u203F-\\u2040]*$"
    ), isJavaScriptProtocol = /^[\u0000-\u001F ]*j[\r\n\t]*a[\r\n\t]*v[\r\n\t]*a[\r\n\t]*s[\r\n\t]*c[\r\n\t]*r[\r\n\t]*i[\r\n\t]*p[\r\n\t]*t[\r\n\t]*:/i, currentReplayingEvent = null, restoreTarget = null, restoreQueue = null, isInsideEventHandler = false, canUseDOM2 = !("undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement), passiveBrowserEventsSupported = false;
    if (canUseDOM2)
      try {
        var options$jscomp$0 = {};
        Object.defineProperty(options$jscomp$0, "passive", {
          get: function() {
            passiveBrowserEventsSupported = true;
          }
        });
        window.addEventListener("test", options$jscomp$0, options$jscomp$0);
        window.removeEventListener("test", options$jscomp$0, options$jscomp$0);
      } catch (e2) {
        passiveBrowserEventsSupported = false;
      }
    var root2 = null, startText = null, fallbackText = null, EventInterface = {
      eventPhase: 0,
      bubbles: 0,
      cancelable: 0,
      timeStamp: function(event) {
        return event.timeStamp || Date.now();
      },
      defaultPrevented: 0,
      isTrusted: 0
    }, SyntheticEvent = createSyntheticEvent(EventInterface), UIEventInterface = assign2({}, EventInterface, { view: 0, detail: 0 }), SyntheticUIEvent = createSyntheticEvent(UIEventInterface), lastMovementX, lastMovementY, lastMouseEvent, MouseEventInterface = assign2({}, UIEventInterface, {
      screenX: 0,
      screenY: 0,
      clientX: 0,
      clientY: 0,
      pageX: 0,
      pageY: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      getModifierState: getEventModifierState,
      button: 0,
      buttons: 0,
      relatedTarget: function(event) {
        return void 0 === event.relatedTarget ? event.fromElement === event.srcElement ? event.toElement : event.fromElement : event.relatedTarget;
      },
      movementX: function(event) {
        if ("movementX" in event) return event.movementX;
        event !== lastMouseEvent && (lastMouseEvent && "mousemove" === event.type ? (lastMovementX = event.screenX - lastMouseEvent.screenX, lastMovementY = event.screenY - lastMouseEvent.screenY) : lastMovementY = lastMovementX = 0, lastMouseEvent = event);
        return lastMovementX;
      },
      movementY: function(event) {
        return "movementY" in event ? event.movementY : lastMovementY;
      }
    }), SyntheticMouseEvent = createSyntheticEvent(MouseEventInterface), DragEventInterface = assign2({}, MouseEventInterface, { dataTransfer: 0 }), SyntheticDragEvent = createSyntheticEvent(DragEventInterface), FocusEventInterface = assign2({}, UIEventInterface, { relatedTarget: 0 }), SyntheticFocusEvent = createSyntheticEvent(FocusEventInterface), AnimationEventInterface = assign2({}, EventInterface, {
      animationName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticAnimationEvent = createSyntheticEvent(AnimationEventInterface), ClipboardEventInterface = assign2({}, EventInterface, {
      clipboardData: function(event) {
        return "clipboardData" in event ? event.clipboardData : window.clipboardData;
      }
    }), SyntheticClipboardEvent = createSyntheticEvent(ClipboardEventInterface), CompositionEventInterface = assign2({}, EventInterface, { data: 0 }), SyntheticCompositionEvent = createSyntheticEvent(
      CompositionEventInterface
    ), SyntheticInputEvent = SyntheticCompositionEvent, normalizeKey = {
      Esc: "Escape",
      Spacebar: " ",
      Left: "ArrowLeft",
      Up: "ArrowUp",
      Right: "ArrowRight",
      Down: "ArrowDown",
      Del: "Delete",
      Win: "OS",
      Menu: "ContextMenu",
      Apps: "ContextMenu",
      Scroll: "ScrollLock",
      MozPrintableKey: "Unidentified"
    }, translateToKey = {
      8: "Backspace",
      9: "Tab",
      12: "Clear",
      13: "Enter",
      16: "Shift",
      17: "Control",
      18: "Alt",
      19: "Pause",
      20: "CapsLock",
      27: "Escape",
      32: " ",
      33: "PageUp",
      34: "PageDown",
      35: "End",
      36: "Home",
      37: "ArrowLeft",
      38: "ArrowUp",
      39: "ArrowRight",
      40: "ArrowDown",
      45: "Insert",
      46: "Delete",
      112: "F1",
      113: "F2",
      114: "F3",
      115: "F4",
      116: "F5",
      117: "F6",
      118: "F7",
      119: "F8",
      120: "F9",
      121: "F10",
      122: "F11",
      123: "F12",
      144: "NumLock",
      145: "ScrollLock",
      224: "Meta"
    }, modifierKeyToProp = {
      Alt: "altKey",
      Control: "ctrlKey",
      Meta: "metaKey",
      Shift: "shiftKey"
    }, KeyboardEventInterface = assign2({}, UIEventInterface, {
      key: function(nativeEvent) {
        if (nativeEvent.key) {
          var key = normalizeKey[nativeEvent.key] || nativeEvent.key;
          if ("Unidentified" !== key) return key;
        }
        return "keypress" === nativeEvent.type ? (nativeEvent = getEventCharCode(nativeEvent), 13 === nativeEvent ? "Enter" : String.fromCharCode(nativeEvent)) : "keydown" === nativeEvent.type || "keyup" === nativeEvent.type ? translateToKey[nativeEvent.keyCode] || "Unidentified" : "";
      },
      code: 0,
      location: 0,
      ctrlKey: 0,
      shiftKey: 0,
      altKey: 0,
      metaKey: 0,
      repeat: 0,
      locale: 0,
      getModifierState: getEventModifierState,
      charCode: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : 0;
      },
      keyCode: function(event) {
        return "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      },
      which: function(event) {
        return "keypress" === event.type ? getEventCharCode(event) : "keydown" === event.type || "keyup" === event.type ? event.keyCode : 0;
      }
    }), SyntheticKeyboardEvent = createSyntheticEvent(KeyboardEventInterface), PointerEventInterface = assign2({}, MouseEventInterface, {
      pointerId: 0,
      width: 0,
      height: 0,
      pressure: 0,
      tangentialPressure: 0,
      tiltX: 0,
      tiltY: 0,
      twist: 0,
      pointerType: 0,
      isPrimary: 0
    }), SyntheticPointerEvent = createSyntheticEvent(PointerEventInterface), TouchEventInterface = assign2({}, UIEventInterface, {
      touches: 0,
      targetTouches: 0,
      changedTouches: 0,
      altKey: 0,
      metaKey: 0,
      ctrlKey: 0,
      shiftKey: 0,
      getModifierState: getEventModifierState
    }), SyntheticTouchEvent = createSyntheticEvent(TouchEventInterface), TransitionEventInterface = assign2({}, EventInterface, {
      propertyName: 0,
      elapsedTime: 0,
      pseudoElement: 0
    }), SyntheticTransitionEvent = createSyntheticEvent(TransitionEventInterface), WheelEventInterface = assign2({}, MouseEventInterface, {
      deltaX: function(event) {
        return "deltaX" in event ? event.deltaX : "wheelDeltaX" in event ? -event.wheelDeltaX : 0;
      },
      deltaY: function(event) {
        return "deltaY" in event ? event.deltaY : "wheelDeltaY" in event ? -event.wheelDeltaY : "wheelDelta" in event ? -event.wheelDelta : 0;
      },
      deltaZ: 0,
      deltaMode: 0
    }), SyntheticWheelEvent = createSyntheticEvent(WheelEventInterface), ToggleEventInterface = assign2({}, EventInterface, {
      newState: 0,
      oldState: 0
    }), SyntheticToggleEvent = createSyntheticEvent(ToggleEventInterface), END_KEYCODES = [9, 13, 27, 32], START_KEYCODE = 229, canUseCompositionEvent = canUseDOM2 && "CompositionEvent" in window, documentMode = null;
    canUseDOM2 && "documentMode" in document && (documentMode = document.documentMode);
    var canUseTextInputEvent = canUseDOM2 && "TextEvent" in window && !documentMode, useFallbackCompositionData = canUseDOM2 && (!canUseCompositionEvent || documentMode && 8 < documentMode && 11 >= documentMode), SPACEBAR_CODE = 32, SPACEBAR_CHAR = String.fromCharCode(SPACEBAR_CODE), hasSpaceKeypress = false, isComposing = false, supportedInputTypes = {
      color: true,
      date: true,
      datetime: true,
      "datetime-local": true,
      email: true,
      month: true,
      number: true,
      password: true,
      range: true,
      search: true,
      tel: true,
      text: true,
      time: true,
      url: true,
      week: true
    }, activeElement$1 = null, activeElementInst$1 = null, isInputEventSupported = false;
    canUseDOM2 && (isInputEventSupported = isEventSupported("input") && (!document.documentMode || 9 < document.documentMode));
    var objectIs = "function" === typeof Object.is ? Object.is : is2, skipSelectionChangeEvent = canUseDOM2 && "documentMode" in document && 11 >= document.documentMode, activeElement = null, activeElementInst = null, lastSelection = null, mouseDown = false, vendorPrefixes = {
      animationend: makePrefixMap("Animation", "AnimationEnd"),
      animationiteration: makePrefixMap("Animation", "AnimationIteration"),
      animationstart: makePrefixMap("Animation", "AnimationStart"),
      transitionrun: makePrefixMap("Transition", "TransitionRun"),
      transitionstart: makePrefixMap("Transition", "TransitionStart"),
      transitioncancel: makePrefixMap("Transition", "TransitionCancel"),
      transitionend: makePrefixMap("Transition", "TransitionEnd")
    }, prefixedEventNames = {}, style = {};
    canUseDOM2 && (style = document.createElement("div").style, "AnimationEvent" in window || (delete vendorPrefixes.animationend.animation, delete vendorPrefixes.animationiteration.animation, delete vendorPrefixes.animationstart.animation), "TransitionEvent" in window || delete vendorPrefixes.transitionend.transition);
    var ANIMATION_END = getVendorPrefixedEventName("animationend"), ANIMATION_ITERATION = getVendorPrefixedEventName("animationiteration"), ANIMATION_START = getVendorPrefixedEventName("animationstart"), TRANSITION_RUN = getVendorPrefixedEventName("transitionrun"), TRANSITION_START = getVendorPrefixedEventName("transitionstart"), TRANSITION_CANCEL = getVendorPrefixedEventName("transitioncancel"), TRANSITION_END = getVendorPrefixedEventName("transitionend"), topLevelEventsToReactNames = /* @__PURE__ */ new Map(), simpleEventPluginEvents = "abort auxClick beforeToggle cancel canPlay canPlayThrough click close contextMenu copy cut drag dragEnd dragEnter dragExit dragLeave dragOver dragStart drop durationChange emptied encrypted ended error gotPointerCapture input invalid keyDown keyPress keyUp load loadedData loadedMetadata loadStart lostPointerCapture mouseDown mouseMove mouseOut mouseOver mouseUp paste pause play playing pointerCancel pointerDown pointerMove pointerOut pointerOver pointerUp progress rateChange reset resize seeked seeking stalled submit suspend timeUpdate touchCancel touchEnd touchStart volumeChange scroll toggle touchMove waiting wheel".split(
      " "
    );
    simpleEventPluginEvents.push("scrollEnd");
    var lastResetTime = 0;
    if ("object" === typeof performance && "function" === typeof performance.now) {
      var localPerformance = performance;
      var getCurrentTime = function() {
        return localPerformance.now();
      };
    } else {
      var localDate = Date;
      getCurrentTime = function() {
        return localDate.now();
      };
    }
    var reportGlobalError = "function" === typeof reportError ? reportError : function(error) {
      if ("object" === typeof window && "function" === typeof window.ErrorEvent) {
        var event = new window.ErrorEvent("error", {
          bubbles: true,
          cancelable: true,
          message: "object" === typeof error && null !== error && "string" === typeof error.message ? String(error.message) : String(error),
          error
        });
        if (!window.dispatchEvent(event)) return;
      } else if ("object" === typeof process && "function" === typeof process.emit) {
        process.emit("uncaughtException", error);
        return;
      }
      console.error(error);
    }, OMITTED_PROP_ERROR = "This object has been omitted by React in the console log to avoid sending too much data from the server. Try logging smaller or more specific objects.", EMPTY_ARRAY = 0, COMPLEX_ARRAY = 1, PRIMITIVE_ARRAY = 2, ENTRIES_ARRAY = 3, REMOVED = "– ", ADDED = "+ ", UNCHANGED = "  ", supportsUserTiming = "undefined" !== typeof console && "function" === typeof console.timeStamp && "undefined" !== typeof performance && "function" === typeof performance.measure, COMPONENTS_TRACK = "Components ⚛", LANES_TRACK_GROUP = "Scheduler ⚛", currentTrack = "Blocking", alreadyWarnedForDeepEquality = false, reusableComponentDevToolDetails = {
      color: "primary",
      properties: null,
      tooltipText: "",
      track: COMPONENTS_TRACK
    }, reusableComponentOptions = {
      start: -0,
      end: -0,
      detail: { devtools: reusableComponentDevToolDetails }
    }, resuableChangedPropsEntry = ["Changed Props", ""], DEEP_EQUALITY_WARNING = "This component received deeply equal props. It might benefit from useMemo or the React Compiler in its owner.", reusableDeeplyEqualPropsEntry = ["Changed Props", DEEP_EQUALITY_WARNING], OffscreenVisible = 1, OffscreenPassiveEffectsConnected = 2, concurrentQueues = [], concurrentQueuesIndex = 0, concurrentlyUpdatedLanes = 0, emptyContextObject = {};
    Object.freeze(emptyContextObject);
    var resolveFamily = null, failedBoundaries = null, NoMode = 0, ConcurrentMode = 1, ProfileMode = 2, StrictLegacyMode = 8, StrictEffectsMode = 16, SuspenseyImagesMode = 32;
    var hasBadMapPolyfill = false;
    try {
      var nonExtensibleObject = Object.preventExtensions({});
      /* @__PURE__ */ new Map([[nonExtensibleObject, null]]);
      /* @__PURE__ */ new Set([nonExtensibleObject]);
    } catch (e$32) {
      hasBadMapPolyfill = true;
    }
    var CapturedStacks = /* @__PURE__ */ new WeakMap(), forkStack = [], forkStackIndex = 0, treeForkProvider = null, treeForkCount = 0, idStack = [], idStackIndex = 0, treeContextProvider = null, treeContextId = 1, treeContextOverflow = "", hydrationParentFiber = null, nextHydratableInstance = null, isHydrating = false, didSuspendOrErrorDEV = false, hydrationDiffRootDEV = null, hydrationErrors = null, rootOrSingletonContext = false, HydrationMismatchException = Error(
      "Hydration Mismatch Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), valueCursor = createCursor(null);
    var rendererCursorDEV = createCursor(null);
    var rendererSigil = {};
    var currentlyRenderingFiber$1 = null, lastContextDependency = null, isDisallowedContextReadInDEV = false, AbortControllerLocal = "undefined" !== typeof AbortController ? AbortController : function() {
      var listeners = [], signal = this.signal = {
        aborted: false,
        addEventListener: function(type, listener) {
          listeners.push(listener);
        }
      };
      this.abort = function() {
        signal.aborted = true;
        listeners.forEach(function(listener) {
          return listener();
        });
      };
    }, scheduleCallback$2 = Scheduler2.unstable_scheduleCallback, NormalPriority = Scheduler2.unstable_NormalPriority, CacheContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Consumer: null,
      Provider: null,
      _currentValue: null,
      _currentValue2: null,
      _threadCount: 0,
      _currentRenderer: null,
      _currentRenderer2: null
    }, now = Scheduler2.unstable_now, createTask = console.createTask ? console.createTask : function() {
      return null;
    }, SPAWNED_UPDATE = 1, PINGED_UPDATE = 2, renderStartTime = -0, commitStartTime = -0, commitEndTime = -0, commitErrors = null, profilerStartTime = -1.1, profilerEffectDuration = -0, componentEffectDuration = -0, componentEffectStartTime = -1.1, componentEffectEndTime = -1.1, componentEffectErrors = null, componentEffectSpawnedUpdate = false, blockingClampTime = -0, blockingUpdateTime = -1.1, blockingUpdateTask = null, blockingUpdateType = 0, blockingUpdateMethodName = null, blockingUpdateComponentName = null, blockingEventTime = -1.1, blockingEventType = null, blockingEventRepeatTime = -1.1, blockingSuspendedTime = -1.1, transitionClampTime = -0, transitionStartTime = -1.1, transitionUpdateTime = -1.1, transitionUpdateType = 0, transitionUpdateTask = null, transitionUpdateMethodName = null, transitionUpdateComponentName = null, transitionEventTime = -1.1, transitionEventType = null, transitionEventRepeatTime = -1.1, transitionSuspendedTime = -1.1, retryClampTime = -0, idleClampTime = -0, animatingLanes = 0, animatingTask = null, yieldReason = 0, yieldStartTime = -1.1, currentUpdateIsNested = false, nestedUpdateScheduled = false, currentEntangledListeners = null, currentEntangledPendingCount = 0, currentEntangledLane = 0, currentEntangledActionThenable = null, prevOnStartTransitionFinish = ReactSharedInternals.S;
    ReactSharedInternals.S = function(transition, returnValue) {
      globalMostRecentTransitionTime = now$1();
      if ("object" === typeof returnValue && null !== returnValue && "function" === typeof returnValue.then) {
        if (0 > transitionStartTime && 0 > transitionUpdateTime) {
          transitionStartTime = now();
          var newEventTime = resolveEventTimeStamp(), newEventType = resolveEventType();
          if (newEventTime !== transitionEventRepeatTime || newEventType !== transitionEventType)
            transitionEventRepeatTime = -1.1;
          transitionEventTime = newEventTime;
          transitionEventType = newEventType;
        }
        entangleAsyncAction(transition, returnValue);
      }
      null !== prevOnStartTransitionFinish && prevOnStartTransitionFinish(transition, returnValue);
    };
    var resumedCache = createCursor(null), ReactStrictModeWarnings = {
      recordUnsafeLifecycleWarnings: function() {
      },
      flushPendingUnsafeLifecycleWarnings: function() {
      },
      recordLegacyContextWarning: function() {
      },
      flushLegacyContextWarning: function() {
      },
      discardPendingWarnings: function() {
      }
    }, pendingComponentWillMountWarnings = [], pendingUNSAFE_ComponentWillMountWarnings = [], pendingComponentWillReceivePropsWarnings = [], pendingUNSAFE_ComponentWillReceivePropsWarnings = [], pendingComponentWillUpdateWarnings = [], pendingUNSAFE_ComponentWillUpdateWarnings = [], didWarnAboutUnsafeLifecycles = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordUnsafeLifecycleWarnings = function(fiber, instance) {
      didWarnAboutUnsafeLifecycles.has(fiber.type) || ("function" === typeof instance.componentWillMount && true !== instance.componentWillMount.__suppressDeprecationWarning && pendingComponentWillMountWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillMount && pendingUNSAFE_ComponentWillMountWarnings.push(fiber), "function" === typeof instance.componentWillReceiveProps && true !== instance.componentWillReceiveProps.__suppressDeprecationWarning && pendingComponentWillReceivePropsWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillReceiveProps && pendingUNSAFE_ComponentWillReceivePropsWarnings.push(fiber), "function" === typeof instance.componentWillUpdate && true !== instance.componentWillUpdate.__suppressDeprecationWarning && pendingComponentWillUpdateWarnings.push(fiber), fiber.mode & StrictLegacyMode && "function" === typeof instance.UNSAFE_componentWillUpdate && pendingUNSAFE_ComponentWillUpdateWarnings.push(fiber));
    };
    ReactStrictModeWarnings.flushPendingUnsafeLifecycleWarnings = function() {
      var componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillMountWarnings.length && (pendingComponentWillMountWarnings.forEach(function(fiber) {
        componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillMountWarnings = []);
      var UNSAFE_componentWillMountUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillMountWarnings.length && (pendingUNSAFE_ComponentWillMountWarnings.forEach(function(fiber) {
        UNSAFE_componentWillMountUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillMountWarnings = []);
      var componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillReceivePropsWarnings.length && (pendingComponentWillReceivePropsWarnings.forEach(function(fiber) {
        componentWillReceivePropsUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillReceivePropsWarnings = []);
      var UNSAFE_componentWillReceivePropsUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillReceivePropsWarnings.length && (pendingUNSAFE_ComponentWillReceivePropsWarnings.forEach(
        function(fiber) {
          UNSAFE_componentWillReceivePropsUniqueNames.add(
            getComponentNameFromFiber(fiber) || "Component"
          );
          didWarnAboutUnsafeLifecycles.add(fiber.type);
        }
      ), pendingUNSAFE_ComponentWillReceivePropsWarnings = []);
      var componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingComponentWillUpdateWarnings.length && (pendingComponentWillUpdateWarnings.forEach(function(fiber) {
        componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingComponentWillUpdateWarnings = []);
      var UNSAFE_componentWillUpdateUniqueNames = /* @__PURE__ */ new Set();
      0 < pendingUNSAFE_ComponentWillUpdateWarnings.length && (pendingUNSAFE_ComponentWillUpdateWarnings.forEach(function(fiber) {
        UNSAFE_componentWillUpdateUniqueNames.add(
          getComponentNameFromFiber(fiber) || "Component"
        );
        didWarnAboutUnsafeLifecycles.add(fiber.type);
      }), pendingUNSAFE_ComponentWillUpdateWarnings = []);
      if (0 < UNSAFE_componentWillMountUniqueNames.size) {
        var sortedNames = setToSortedString(
          UNSAFE_componentWillMountUniqueNames
        );
        console.error(
          "Using UNSAFE_componentWillMount in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n\nPlease update the following components: %s",
          sortedNames
        );
      }
      0 < UNSAFE_componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillReceivePropsUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillReceiveProps in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < UNSAFE_componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(
        UNSAFE_componentWillUpdateUniqueNames
      ), console.error(
        "Using UNSAFE_componentWillUpdate in strict mode is not recommended and may indicate bugs in your code. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillMountUniqueNames.size && (sortedNames = setToSortedString(componentWillMountUniqueNames), console.warn(
        "componentWillMount has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move code with side effects to componentDidMount, and set initial state in the constructor.\n* Rename componentWillMount to UNSAFE_componentWillMount to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillReceivePropsUniqueNames.size && (sortedNames = setToSortedString(
        componentWillReceivePropsUniqueNames
      ), console.warn(
        "componentWillReceiveProps has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* If you're updating state whenever props change, refactor your code to use memoization techniques or move it to static getDerivedStateFromProps. Learn more at: https://react.dev/link/derived-state\n* Rename componentWillReceiveProps to UNSAFE_componentWillReceiveProps to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
      0 < componentWillUpdateUniqueNames.size && (sortedNames = setToSortedString(componentWillUpdateUniqueNames), console.warn(
        "componentWillUpdate has been renamed, and is not recommended for use. See https://react.dev/link/unsafe-component-lifecycles for details.\n\n* Move data fetching code or side effects to componentDidUpdate.\n* Rename componentWillUpdate to UNSAFE_componentWillUpdate to suppress this warning in non-strict mode. In React 18.x, only the UNSAFE_ name will work. To rename all deprecated lifecycles to their new names, you can run `npx react-codemod rename-unsafe-lifecycles` in your project source folder.\n\nPlease update the following components: %s",
        sortedNames
      ));
    };
    var pendingLegacyContextWarning = /* @__PURE__ */ new Map(), didWarnAboutLegacyContext = /* @__PURE__ */ new Set();
    ReactStrictModeWarnings.recordLegacyContextWarning = function(fiber, instance) {
      var strictRoot = null;
      for (var node = fiber; null !== node; )
        node.mode & StrictLegacyMode && (strictRoot = node), node = node.return;
      null === strictRoot ? console.error(
        "Expected to find a StrictMode component in a strict mode tree. This error is likely caused by a bug in React. Please file an issue."
      ) : !didWarnAboutLegacyContext.has(fiber.type) && (node = pendingLegacyContextWarning.get(strictRoot), null != fiber.type.contextTypes || null != fiber.type.childContextTypes || null !== instance && "function" === typeof instance.getChildContext) && (void 0 === node && (node = [], pendingLegacyContextWarning.set(strictRoot, node)), node.push(fiber));
    };
    ReactStrictModeWarnings.flushLegacyContextWarning = function() {
      pendingLegacyContextWarning.forEach(function(fiberArray) {
        if (0 !== fiberArray.length) {
          var firstFiber = fiberArray[0], uniqueNames = /* @__PURE__ */ new Set();
          fiberArray.forEach(function(fiber) {
            uniqueNames.add(getComponentNameFromFiber(fiber) || "Component");
            didWarnAboutLegacyContext.add(fiber.type);
          });
          var sortedNames = setToSortedString(uniqueNames);
          runWithFiberInDEV(firstFiber, function() {
            console.error(
              "Legacy context API has been detected within a strict-mode tree.\n\nThe old API will be supported in all 16.x releases, but applications using it should migrate to the new version.\n\nPlease update the following components: %s\n\nLearn more about this warning here: https://react.dev/link/legacy-context",
              sortedNames
            );
          });
        }
      });
    };
    ReactStrictModeWarnings.discardPendingWarnings = function() {
      pendingComponentWillMountWarnings = [];
      pendingUNSAFE_ComponentWillMountWarnings = [];
      pendingComponentWillReceivePropsWarnings = [];
      pendingUNSAFE_ComponentWillReceivePropsWarnings = [];
      pendingComponentWillUpdateWarnings = [];
      pendingUNSAFE_ComponentWillUpdateWarnings = [];
      pendingLegacyContextWarning = /* @__PURE__ */ new Map();
    };
    var callComponent = {
      react_stack_bottom_frame: function(Component, props2, secondArg) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return Component(props2, secondArg);
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callComponentInDEV = callComponent.react_stack_bottom_frame.bind(callComponent), callRender = {
      react_stack_bottom_frame: function(instance) {
        var wasRendering = isRendering;
        isRendering = true;
        try {
          return instance.render();
        } finally {
          isRendering = wasRendering;
        }
      }
    }, callRenderInDEV = callRender.react_stack_bottom_frame.bind(callRender), callComponentDidMount = {
      react_stack_bottom_frame: function(finishedWork, instance) {
        try {
          instance.componentDidMount();
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }, callComponentDidMountInDEV = callComponentDidMount.react_stack_bottom_frame.bind(
      callComponentDidMount
    ), callComponentDidUpdate = {
      react_stack_bottom_frame: function(finishedWork, instance, prevProps, prevState, snapshot) {
        try {
          instance.componentDidUpdate(prevProps, prevState, snapshot);
        } catch (error) {
          captureCommitPhaseError(finishedWork, finishedWork.return, error);
        }
      }
    }, callComponentDidUpdateInDEV = callComponentDidUpdate.react_stack_bottom_frame.bind(
      callComponentDidUpdate
    ), callComponentDidCatch = {
      react_stack_bottom_frame: function(instance, errorInfo) {
        var stack = errorInfo.stack;
        instance.componentDidCatch(errorInfo.value, {
          componentStack: null !== stack ? stack : ""
        });
      }
    }, callComponentDidCatchInDEV = callComponentDidCatch.react_stack_bottom_frame.bind(
      callComponentDidCatch
    ), callComponentWillUnmount = {
      react_stack_bottom_frame: function(current3, nearestMountedAncestor, instance) {
        try {
          instance.componentWillUnmount();
        } catch (error) {
          captureCommitPhaseError(current3, nearestMountedAncestor, error);
        }
      }
    }, callComponentWillUnmountInDEV = callComponentWillUnmount.react_stack_bottom_frame.bind(
      callComponentWillUnmount
    ), callCreate = {
      react_stack_bottom_frame: function(effect) {
        var create2 = effect.create;
        effect = effect.inst;
        create2 = create2();
        return effect.destroy = create2;
      }
    }, callCreateInDEV = callCreate.react_stack_bottom_frame.bind(callCreate), callDestroy = {
      react_stack_bottom_frame: function(current3, nearestMountedAncestor, destroy) {
        try {
          destroy();
        } catch (error) {
          captureCommitPhaseError(current3, nearestMountedAncestor, error);
        }
      }
    }, callDestroyInDEV = callDestroy.react_stack_bottom_frame.bind(callDestroy), callLazyInit = {
      react_stack_bottom_frame: function(lazy2) {
        var init2 = lazy2._init;
        return init2(lazy2._payload);
      }
    }, callLazyInitInDEV = callLazyInit.react_stack_bottom_frame.bind(callLazyInit), SuspenseException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `use` to interrupt the current render. You must either rethrow it immediately, or move the `use` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary, or call the promise's `.catch` method and pass the result to `use`."
    ), SuspenseyCommitException = Error(
      "Suspense Exception: This is not a real error, and should not leak into userspace. If you're seeing this, it's likely a bug in React."
    ), SuspenseActionException = Error(
      "Suspense Exception: This is not a real error! It's an implementation detail of `useActionState` to interrupt the current render. You must either rethrow it immediately, or move the `useActionState` call outside of the `try/catch` block. Capturing without rethrowing will lead to unexpected behavior.\n\nTo handle async errors, wrap your component in an error boundary."
    ), noopSuspenseyCommitThenable = {
      then: function() {
        console.error(
          'Internal React error: A listener was unexpectedly attached to a "noop" thenable. This is a bug in React. Please file an issue.'
        );
      }
    }, suspendedThenable = null, needsToResetSuspendedThenableDEV = false, thenableState$1 = null, thenableIndexCounter$1 = 0, currentDebugInfo = null, didWarnAboutMaps;
    var didWarnAboutGenerators = didWarnAboutMaps = false;
    var ownerHasKeyUseWarning = {};
    var ownerHasFunctionTypeWarning = {};
    var ownerHasSymbolTypeWarning = {};
    warnForMissingKey = function(returnFiber, workInProgress2, child) {
      if (null !== child && "object" === typeof child && child._store && (!child._store.validated && null == child.key || 2 === child._store.validated)) {
        if ("object" !== typeof child._store)
          throw Error(
            "React Component in warnForMissingKey should have a _store. This error is likely caused by a bug in React. Please file an issue."
          );
        child._store.validated = 1;
        var componentName2 = getComponentNameFromFiber(returnFiber), componentKey = componentName2 || "null";
        if (!ownerHasKeyUseWarning[componentKey]) {
          ownerHasKeyUseWarning[componentKey] = true;
          child = child._owner;
          returnFiber = returnFiber._debugOwner;
          var currentComponentErrorInfo = "";
          returnFiber && "number" === typeof returnFiber.tag && (componentKey = getComponentNameFromFiber(returnFiber)) && (currentComponentErrorInfo = "\n\nCheck the render method of `" + componentKey + "`.");
          currentComponentErrorInfo || componentName2 && (currentComponentErrorInfo = "\n\nCheck the top-level render call using <" + componentName2 + ">.");
          var childOwnerAppendix = "";
          null != child && returnFiber !== child && (componentName2 = null, "number" === typeof child.tag ? componentName2 = getComponentNameFromFiber(child) : "string" === typeof child.name && (componentName2 = child.name), componentName2 && (childOwnerAppendix = " It was passed a child from " + componentName2 + "."));
          runWithFiberInDEV(workInProgress2, function() {
            console.error(
              'Each child in a list should have a unique "key" prop.%s%s See https://react.dev/link/warning-keys for more information.',
              currentComponentErrorInfo,
              childOwnerAppendix
            );
          });
        }
      }
    };
    var reconcileChildFibers = createChildReconciler(true), mountChildFibers = createChildReconciler(false), UpdateState = 0, ReplaceState = 1, ForceUpdate = 2, CaptureUpdate = 3, hasForceUpdate = false;
    var didWarnUpdateInsideUpdate = false;
    var currentlyProcessingQueue = null;
    var didReadFromEntangledAsyncAction = false, currentTreeHiddenStackCursor = createCursor(null), prevEntangledRenderLanesCursor = createCursor(0), suspenseHandlerStackCursor = createCursor(null), shellBoundary = null, SubtreeSuspenseContextMask = 1, ForceSuspenseFallback = 2, suspenseStackCursor = createCursor(0), NoFlags = 0, HasEffect = 1, Insertion = 2, Layout = 4, Passive = 8, didWarnUncachedGetSnapshot;
    var didWarnAboutMismatchedHooksForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseWrappedInTryCatch = /* @__PURE__ */ new Set();
    var didWarnAboutAsyncClientComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUseFormState = /* @__PURE__ */ new Set();
    var renderLanes = 0, currentlyRenderingFiber = null, currentHook = null, workInProgressHook = null, didScheduleRenderPhaseUpdate = false, didScheduleRenderPhaseUpdateDuringThisPass = false, shouldDoubleInvokeUserFnsInHooksDEV = false, localIdCounter = 0, thenableIndexCounter = 0, thenableState = null, globalClientIdCounter = 0, RE_RENDER_LIMIT = 25, currentHookNameInDev = null, hookTypesDev = null, hookTypesUpdateIndexDev = -1, ignorePreviousDependencies = false, ContextOnlyDispatcher = {
      readContext,
      use,
      useCallback: throwInvalidHookError,
      useContext: throwInvalidHookError,
      useEffect: throwInvalidHookError,
      useImperativeHandle: throwInvalidHookError,
      useLayoutEffect: throwInvalidHookError,
      useInsertionEffect: throwInvalidHookError,
      useMemo: throwInvalidHookError,
      useReducer: throwInvalidHookError,
      useRef: throwInvalidHookError,
      useState: throwInvalidHookError,
      useDebugValue: throwInvalidHookError,
      useDeferredValue: throwInvalidHookError,
      useTransition: throwInvalidHookError,
      useSyncExternalStore: throwInvalidHookError,
      useId: throwInvalidHookError,
      useHostTransitionStatus: throwInvalidHookError,
      useFormState: throwInvalidHookError,
      useActionState: throwInvalidHookError,
      useOptimistic: throwInvalidHookError,
      useMemoCache: throwInvalidHookError,
      useCacheRefresh: throwInvalidHookError
    };
    ContextOnlyDispatcher.useEffectEvent = throwInvalidHookError;
    var HooksDispatcherOnMountInDEV = null, HooksDispatcherOnMountWithHookTypesInDEV = null, HooksDispatcherOnUpdateInDEV = null, HooksDispatcherOnRerenderInDEV = null, InvalidNestedHooksDispatcherOnMountInDEV = null, InvalidNestedHooksDispatcherOnUpdateInDEV = null, InvalidNestedHooksDispatcherOnRerenderInDEV = null;
    HooksDispatcherOnMountInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        mountHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        mountHookTypesDev();
        checkDepsAreArrayDev(deps);
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        mountHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action, initialState2);
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        mountHookTypesDev();
        return mountEvent(callback);
      }
    };
    HooksDispatcherOnMountWithHookTypesInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return mountId();
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return mountEvent(callback);
      }
    };
    HooksDispatcherOnUpdateInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return updateActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return updateActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    HooksDispatcherOnRerenderInDEV = {
      readContext: function(context) {
        return readContext(context);
      },
      use,
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnRerenderInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        updateHookTypesDev();
        warnOnUseFormStateInDev();
        return rerenderActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer);
      },
      useHostTransitionStatus,
      useMemoCache,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnMountInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountEffect(create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        mountEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountLayoutEffect(create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function(initialValue) {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountRef(initialValue);
      },
      useState: function(initialState2) {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnMountInDEV;
        try {
          return mountState(initialState2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountId();
      },
      useFormState: function(action, initialState2) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useActionState: function(action, initialState2) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountActionState(action, initialState2);
      },
      useOptimistic: function(passthrough) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountOptimistic(passthrough);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        mountHookTypesDev();
        return mountRefresh();
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        mountHookTypesDev();
        return mountEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnUpdateInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateOptimistic(passthrough, reducer);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    InvalidNestedHooksDispatcherOnRerenderInDEV = {
      readContext: function(context) {
        warnInvalidContextAccess();
        return readContext(context);
      },
      use: function(usable) {
        warnInvalidHookAccess();
        return use(usable);
      },
      useCallback: function(callback, deps) {
        currentHookNameInDev = "useCallback";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateCallback(callback, deps);
      },
      useContext: function(context) {
        currentHookNameInDev = "useContext";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return readContext(context);
      },
      useEffect: function(create2, deps) {
        currentHookNameInDev = "useEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        updateEffectImpl(2048, Passive, create2, deps);
      },
      useImperativeHandle: function(ref, create2, deps) {
        currentHookNameInDev = "useImperativeHandle";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateImperativeHandle(ref, create2, deps);
      },
      useInsertionEffect: function(create2, deps) {
        currentHookNameInDev = "useInsertionEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Insertion, create2, deps);
      },
      useLayoutEffect: function(create2, deps) {
        currentHookNameInDev = "useLayoutEffect";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEffectImpl(4, Layout, create2, deps);
      },
      useMemo: function(create2, deps) {
        currentHookNameInDev = "useMemo";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return updateMemo(create2, deps);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useReducer: function(reducer, initialArg, init2) {
        currentHookNameInDev = "useReducer";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(reducer, initialArg, init2);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useRef: function() {
        currentHookNameInDev = "useRef";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useState: function() {
        currentHookNameInDev = "useState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        var prevDispatcher = ReactSharedInternals.H;
        ReactSharedInternals.H = InvalidNestedHooksDispatcherOnUpdateInDEV;
        try {
          return rerenderReducer(basicStateReducer);
        } finally {
          ReactSharedInternals.H = prevDispatcher;
        }
      },
      useDebugValue: function() {
        currentHookNameInDev = "useDebugValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
      },
      useDeferredValue: function(value, initialValue) {
        currentHookNameInDev = "useDeferredValue";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderDeferredValue(value, initialValue);
      },
      useTransition: function() {
        currentHookNameInDev = "useTransition";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderTransition();
      },
      useSyncExternalStore: function(subscribe2, getSnapshot, getServerSnapshot) {
        currentHookNameInDev = "useSyncExternalStore";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateSyncExternalStore(
          subscribe2,
          getSnapshot,
          getServerSnapshot
        );
      },
      useId: function() {
        currentHookNameInDev = "useId";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useFormState: function(action) {
        currentHookNameInDev = "useFormState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useActionState: function(action) {
        currentHookNameInDev = "useActionState";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderActionState(action);
      },
      useOptimistic: function(passthrough, reducer) {
        currentHookNameInDev = "useOptimistic";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return rerenderOptimistic(passthrough, reducer);
      },
      useMemoCache: function(size2) {
        warnInvalidHookAccess();
        return useMemoCache(size2);
      },
      useHostTransitionStatus,
      useCacheRefresh: function() {
        currentHookNameInDev = "useCacheRefresh";
        updateHookTypesDev();
        return updateWorkInProgressHook().memoizedState;
      },
      useEffectEvent: function(callback) {
        currentHookNameInDev = "useEffectEvent";
        warnInvalidHookAccess();
        updateHookTypesDev();
        return updateEvent(callback);
      }
    };
    var fakeInternalInstance = {};
    var didWarnAboutStateAssignmentForComponent = /* @__PURE__ */ new Set();
    var didWarnAboutUninitializedState = /* @__PURE__ */ new Set();
    var didWarnAboutGetSnapshotBeforeUpdateWithoutDidUpdate = /* @__PURE__ */ new Set();
    var didWarnAboutLegacyLifecyclesAndDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutDirectlyAssigningPropsToState = /* @__PURE__ */ new Set();
    var didWarnAboutUndefinedDerivedState = /* @__PURE__ */ new Set();
    var didWarnAboutContextTypes$1 = /* @__PURE__ */ new Set();
    var didWarnAboutChildContextTypes = /* @__PURE__ */ new Set();
    var didWarnAboutInvalidateContextType = /* @__PURE__ */ new Set();
    var didWarnOnInvalidCallback = /* @__PURE__ */ new Set();
    Object.freeze(fakeInternalInstance);
    var classComponentUpdater = {
      enqueueSetState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (startUpdateTimerByLane(lane, "this.setState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
      },
      enqueueReplaceState: function(inst, payload, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.tag = ReplaceState;
        update.payload = payload;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        payload = enqueueUpdate(inst, update, lane);
        null !== payload && (startUpdateTimerByLane(lane, "this.replaceState()", inst), scheduleUpdateOnFiber(payload, inst, lane), entangleTransitions(payload, inst, lane));
      },
      enqueueForceUpdate: function(inst, callback) {
        inst = inst._reactInternals;
        var lane = requestUpdateLane(inst), update = createUpdate(lane);
        update.tag = ForceUpdate;
        void 0 !== callback && null !== callback && (warnOnInvalidCallback(callback), update.callback = callback);
        callback = enqueueUpdate(inst, update, lane);
        null !== callback && (startUpdateTimerByLane(lane, "this.forceUpdate()", inst), scheduleUpdateOnFiber(callback, inst, lane), entangleTransitions(callback, inst, lane));
      }
    }, componentName = null, errorBoundaryName = null, SelectiveHydrationException = Error(
      "This is not a real error. It's an implementation detail of React's selective hydration feature. If this leaks into userspace, it's a bug in React. Please file an issue."
    ), didReceiveUpdate = false;
    var didWarnAboutBadClass = {};
    var didWarnAboutContextTypeOnFunctionComponent = {};
    var didWarnAboutContextTypes = {};
    var didWarnAboutGetDerivedStateOnFunctionComponent = {};
    var didWarnAboutReassigningProps = false;
    var didWarnAboutRevealOrder = {};
    var didWarnAboutTailOptions = {};
    var SUSPENDED_MARKER = {
      dehydrated: null,
      treeContext: null,
      retryLane: 0,
      hydrationErrors: null
    }, hasWarnedAboutUsingNoValuePropOnContextProvider = false, didWarnAboutUndefinedSnapshotBeforeUpdate = null;
    didWarnAboutUndefinedSnapshotBeforeUpdate = /* @__PURE__ */ new Set();
    var offscreenSubtreeIsHidden = false, offscreenSubtreeWasHidden = false, needsFormReset = false, PossiblyWeakSet = "function" === typeof WeakSet ? WeakSet : Set, nextEffect = null, inProgressLanes = null, inProgressRoot = null, hostParent = null, hostParentIsContainer = false, currentHoistableRoot = null, inHydratedSubtree = false, suspenseyCommitFlag = 8192, DefaultAsyncDispatcher = {
      getCacheForType: function(resourceType) {
        var cache = readContext(CacheContext), cacheForType = cache.data.get(resourceType);
        void 0 === cacheForType && (cacheForType = resourceType(), cache.data.set(resourceType, cacheForType));
        return cacheForType;
      },
      cacheSignal: function() {
        return readContext(CacheContext).controller.signal;
      },
      getOwner: function() {
        return current2;
      }
    };
    if ("function" === typeof Symbol && Symbol.for) {
      var symbolFor = Symbol.for;
      symbolFor("selector.component");
      symbolFor("selector.has_pseudo_class");
      symbolFor("selector.role");
      symbolFor("selector.test_id");
      symbolFor("selector.text");
    }
    var commitHooks = [], PossiblyWeakMap = "function" === typeof WeakMap ? WeakMap : Map, NoContext = 0, RenderContext = 2, CommitContext = 4, RootInProgress = 0, RootFatalErrored = 1, RootErrored = 2, RootSuspended = 3, RootSuspendedWithDelay = 4, RootSuspendedAtTheShell = 6, RootCompleted = 5, executionContext = NoContext, workInProgressRoot = null, workInProgress = null, workInProgressRootRenderLanes = 0, NotSuspended = 0, SuspendedOnError = 1, SuspendedOnData = 2, SuspendedOnImmediate = 3, SuspendedOnInstance = 4, SuspendedOnInstanceAndReadyToContinue = 5, SuspendedOnDeprecatedThrowPromise = 6, SuspendedAndReadyToContinue = 7, SuspendedOnHydration = 8, SuspendedOnAction = 9, workInProgressSuspendedReason = NotSuspended, workInProgressThrownValue = null, workInProgressRootDidSkipSuspendedSiblings = false, workInProgressRootIsPrerendering = false, workInProgressRootDidAttachPingListener = false, entangledRenderLanes = 0, workInProgressRootExitStatus = RootInProgress, workInProgressRootSkippedLanes = 0, workInProgressRootInterleavedUpdatedLanes = 0, workInProgressRootPingedLanes = 0, workInProgressDeferredLane = 0, workInProgressSuspendedRetryLanes = 0, workInProgressRootConcurrentErrors = null, workInProgressRootRecoverableErrors = null, workInProgressRootDidIncludeRecursiveRenderUpdate = false, globalMostRecentFallbackTime = 0, globalMostRecentTransitionTime = 0, FALLBACK_THROTTLE_MS = 300, workInProgressRootRenderTargetTime = Infinity, RENDER_TIMEOUT_MS = 500, workInProgressTransitions = null, workInProgressUpdateTask = null, legacyErrorBoundariesThatAlreadyFailed = null, IMMEDIATE_COMMIT = 0, ABORTED_VIEW_TRANSITION_COMMIT = 1, DELAYED_PASSIVE_COMMIT = 2, ANIMATION_STARTED_COMMIT = 3, NO_PENDING_EFFECTS = 0, PENDING_MUTATION_PHASE = 1, PENDING_LAYOUT_PHASE = 2, PENDING_AFTER_MUTATION_PHASE = 3, PENDING_SPAWNED_WORK = 4, PENDING_PASSIVE_PHASE = 5, pendingEffectsStatus = 0, pendingEffectsRoot = null, pendingFinishedWork = null, pendingEffectsLanes = 0, pendingEffectsRemainingLanes = 0, pendingEffectsRenderEndTime = -0, pendingPassiveTransitions = null, pendingRecoverableErrors = null, pendingSuspendedCommitReason = null, pendingDelayedCommitReason = IMMEDIATE_COMMIT, pendingSuspendedViewTransitionReason = null, NESTED_UPDATE_LIMIT = 50, nestedUpdateCount = 0, rootWithNestedUpdates = null, isFlushingPassiveEffects = false, didScheduleUpdateDuringPassiveEffects = false, NESTED_PASSIVE_UPDATE_LIMIT = 50, nestedPassiveUpdateCount = 0, rootWithPassiveNestedUpdates = null, isRunningInsertionEffect = false, didWarnStateUpdateForNotYetMountedComponent = null, didWarnAboutUpdateInRender = false;
    var didWarnAboutUpdateInRenderForAnotherComponent = /* @__PURE__ */ new Set();
    var fakeActCallbackNode$1 = {}, firstScheduledRoot = null, lastScheduledRoot = null, didScheduleMicrotask = false, didScheduleMicrotask_act = false, mightHavePendingSyncWork = false, isFlushingWork = false, currentEventTransitionLane = 0, fakeActCallbackNode = {};
    (function() {
      for (var i2 = 0; i2 < simpleEventPluginEvents.length; i2++) {
        var eventName = simpleEventPluginEvents[i2], domEventName = eventName.toLowerCase();
        eventName = eventName[0].toUpperCase() + eventName.slice(1);
        registerSimpleEvent(domEventName, "on" + eventName);
      }
      registerSimpleEvent(ANIMATION_END, "onAnimationEnd");
      registerSimpleEvent(ANIMATION_ITERATION, "onAnimationIteration");
      registerSimpleEvent(ANIMATION_START, "onAnimationStart");
      registerSimpleEvent("dblclick", "onDoubleClick");
      registerSimpleEvent("focusin", "onFocus");
      registerSimpleEvent("focusout", "onBlur");
      registerSimpleEvent(TRANSITION_RUN, "onTransitionRun");
      registerSimpleEvent(TRANSITION_START, "onTransitionStart");
      registerSimpleEvent(TRANSITION_CANCEL, "onTransitionCancel");
      registerSimpleEvent(TRANSITION_END, "onTransitionEnd");
    })();
    registerDirectEvent("onMouseEnter", ["mouseout", "mouseover"]);
    registerDirectEvent("onMouseLeave", ["mouseout", "mouseover"]);
    registerDirectEvent("onPointerEnter", ["pointerout", "pointerover"]);
    registerDirectEvent("onPointerLeave", ["pointerout", "pointerover"]);
    registerTwoPhaseEvent(
      "onChange",
      "change click focusin focusout input keydown keyup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent(
      "onSelect",
      "focusout contextmenu dragend focusin keydown keyup mousedown mouseup selectionchange".split(
        " "
      )
    );
    registerTwoPhaseEvent("onBeforeInput", [
      "compositionend",
      "keypress",
      "textInput",
      "paste"
    ]);
    registerTwoPhaseEvent(
      "onCompositionEnd",
      "compositionend focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionStart",
      "compositionstart focusout keydown keypress keyup mousedown".split(" ")
    );
    registerTwoPhaseEvent(
      "onCompositionUpdate",
      "compositionupdate focusout keydown keypress keyup mousedown".split(" ")
    );
    var mediaEventTypes = "abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange resize seeked seeking stalled suspend timeupdate volumechange waiting".split(
      " "
    ), nonDelegatedEvents = new Set(
      "beforetoggle cancel close invalid load scroll scrollend toggle".split(" ").concat(mediaEventTypes)
    ), listeningMarker = "_reactListening" + Math.random().toString(36).slice(2), didWarnControlledToUncontrolled = false, didWarnUncontrolledToControlled = false, didWarnFormActionType = false, didWarnFormActionName = false, didWarnFormActionTarget = false, didWarnFormActionMethod = false, didWarnPopoverTargetObject = false;
    var didWarnForNewBooleanPropsWithEmptyValue = {};
    var NORMALIZE_NEWLINES_REGEX = /\r\n?/g, NORMALIZE_NULL_AND_REPLACEMENT_REGEX = /\u0000|\uFFFD/g, xlinkNamespace = "http://www.w3.org/1999/xlink", xmlNamespace = "http://www.w3.org/XML/1998/namespace", EXPECTED_FORM_ACTION_URL = "javascript:throw new Error('React form unexpectedly submitted.')", SUPPRESS_HYDRATION_WARNING = "suppressHydrationWarning", ACTIVITY_START_DATA = "&", ACTIVITY_END_DATA = "/&", SUSPENSE_START_DATA = "$", SUSPENSE_END_DATA = "/$", SUSPENSE_PENDING_START_DATA = "$?", SUSPENSE_QUEUED_START_DATA = "$~", SUSPENSE_FALLBACK_START_DATA = "$!", PREAMBLE_CONTRIBUTION_HTML = "html", PREAMBLE_CONTRIBUTION_BODY = "body", PREAMBLE_CONTRIBUTION_HEAD = "head", FORM_STATE_IS_MATCHING = "F!", FORM_STATE_IS_NOT_MATCHING = "F", DOCUMENT_READY_STATE_LOADING = "loading", STYLE = "style", HostContextNamespaceNone = 0, HostContextNamespaceSvg = 1, HostContextNamespaceMath = 2, eventsEnabled = null, selectionInformation = null, warnedUnknownTags = { dialog: true, webview: true }, currentPopstateTransitionEvent = null, schedulerEvent = void 0, scheduleTimeout = "function" === typeof setTimeout ? setTimeout : void 0, cancelTimeout = "function" === typeof clearTimeout ? clearTimeout : void 0, noTimeout = -1, localPromise = "function" === typeof Promise ? Promise : void 0, scheduleMicrotask = "function" === typeof queueMicrotask ? queueMicrotask : "undefined" !== typeof localPromise ? function(callback) {
      return localPromise.resolve(null).then(callback).catch(handleErrorInNextTick);
    } : scheduleTimeout, previousHydratableOnEnteringScopedSingleton = null, NotLoaded = 0, Loaded = 1, Errored = 2, Settled = 3, Inserted = 4, preloadPropsMap = /* @__PURE__ */ new Map(), preconnectsSet = /* @__PURE__ */ new Set(), previousDispatcher = ReactDOMSharedInternals.d;
    ReactDOMSharedInternals.d = {
      f: function() {
        var previousWasRendering = previousDispatcher.f(), wasRendering = flushSyncWork$1();
        return previousWasRendering || wasRendering;
      },
      r: function(form) {
        var formInst = getInstanceFromNode(form);
        null !== formInst && 5 === formInst.tag && "form" === formInst.type ? requestFormReset$1(formInst) : previousDispatcher.r(form);
      },
      D: function(href) {
        previousDispatcher.D(href);
        preconnectAs("dns-prefetch", href, null);
      },
      C: function(href, crossOrigin) {
        previousDispatcher.C(href, crossOrigin);
        preconnectAs("preconnect", href, crossOrigin);
      },
      L: function(href, as, options2) {
        previousDispatcher.L(href, as, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href && as) {
          var preloadSelector = 'link[rel="preload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"]';
          "image" === as ? options2 && options2.imageSrcSet ? (preloadSelector += '[imagesrcset="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options2.imageSrcSet
          ) + '"]', "string" === typeof options2.imageSizes && (preloadSelector += '[imagesizes="' + escapeSelectorAttributeValueInsideDoubleQuotes(
            options2.imageSizes
          ) + '"]')) : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]' : preloadSelector += '[href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]';
          var key = preloadSelector;
          switch (as) {
            case "style":
              key = getStyleKey(href);
              break;
            case "script":
              key = getScriptKey(href);
          }
          preloadPropsMap.has(key) || (href = assign2(
            {
              rel: "preload",
              href: "image" === as && options2 && options2.imageSrcSet ? void 0 : href,
              as
            },
            options2
          ), preloadPropsMap.set(key, href), null !== ownerDocument.querySelector(preloadSelector) || "style" === as && ownerDocument.querySelector(
            getStylesheetSelectorFromKey(key)
          ) || "script" === as && ownerDocument.querySelector(getScriptSelectorFromKey(key)) || (as = ownerDocument.createElement("link"), setInitialProperties(as, "link", href), markNodeAsHoistable(as), ownerDocument.head.appendChild(as)));
        }
      },
      m: function(href, options2) {
        previousDispatcher.m(href, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var as = options2 && "string" === typeof options2.as ? options2.as : "script", preloadSelector = 'link[rel="modulepreload"][as="' + escapeSelectorAttributeValueInsideDoubleQuotes(as) + '"][href="' + escapeSelectorAttributeValueInsideDoubleQuotes(href) + '"]', key = preloadSelector;
          switch (as) {
            case "audioworklet":
            case "paintworklet":
            case "serviceworker":
            case "sharedworker":
            case "worker":
            case "script":
              key = getScriptKey(href);
          }
          if (!preloadPropsMap.has(key) && (href = assign2({ rel: "modulepreload", href }, options2), preloadPropsMap.set(key, href), null === ownerDocument.querySelector(preloadSelector))) {
            switch (as) {
              case "audioworklet":
              case "paintworklet":
              case "serviceworker":
              case "sharedworker":
              case "worker":
              case "script":
                if (ownerDocument.querySelector(getScriptSelectorFromKey(key)))
                  return;
            }
            as = ownerDocument.createElement("link");
            setInitialProperties(as, "link", href);
            markNodeAsHoistable(as);
            ownerDocument.head.appendChild(as);
          }
        }
      },
      X: function(src, options2) {
        previousDispatcher.X(src, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      },
      S: function(href, precedence, options2) {
        previousDispatcher.S(href, precedence, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && href) {
          var styles = getResourcesFromRoot(ownerDocument).hoistableStyles, key = getStyleKey(href);
          precedence = precedence || "default";
          var resource = styles.get(key);
          if (!resource) {
            var state = { loading: NotLoaded, preload: null };
            if (resource = ownerDocument.querySelector(
              getStylesheetSelectorFromKey(key)
            ))
              state.loading = Loaded | Inserted;
            else {
              href = assign2(
                {
                  rel: "stylesheet",
                  href,
                  "data-precedence": precedence
                },
                options2
              );
              (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForStylesheet(href, options2);
              var link = resource = ownerDocument.createElement("link");
              markNodeAsHoistable(link);
              setInitialProperties(link, "link", href);
              link._p = new Promise(function(resolve, reject2) {
                link.onload = resolve;
                link.onerror = reject2;
              });
              link.addEventListener("load", function() {
                state.loading |= Loaded;
              });
              link.addEventListener("error", function() {
                state.loading |= Errored;
              });
              state.loading |= Inserted;
              insertStylesheet(resource, precedence, ownerDocument);
            }
            resource = {
              type: "stylesheet",
              instance: resource,
              count: 1,
              state
            };
            styles.set(key, resource);
          }
        }
      },
      M: function(src, options2) {
        previousDispatcher.M(src, options2);
        var ownerDocument = globalDocument;
        if (ownerDocument && src) {
          var scripts = getResourcesFromRoot(ownerDocument).hoistableScripts, key = getScriptKey(src), resource = scripts.get(key);
          resource || (resource = ownerDocument.querySelector(
            getScriptSelectorFromKey(key)
          ), resource || (src = assign2({ src, async: true, type: "module" }, options2), (options2 = preloadPropsMap.get(key)) && adoptPreloadPropsForScript(src, options2), resource = ownerDocument.createElement("script"), markNodeAsHoistable(resource), setInitialProperties(resource, "link", src), ownerDocument.head.appendChild(resource)), resource = {
            type: "script",
            instance: resource,
            count: 1,
            state: null
          }, scripts.set(key, resource));
        }
      }
    };
    var globalDocument = "undefined" === typeof document ? null : document, tagCaches = null, SUSPENSEY_STYLESHEET_TIMEOUT = 6e4, SUSPENSEY_IMAGE_TIMEOUT = 800, SUSPENSEY_IMAGE_TIME_ESTIMATE = 500, estimatedBytesWithinLimit = 0, LAST_PRECEDENCE = null, precedencesByRoot = null, NotPendingTransition = NotPending, HostTransitionContext = {
      $$typeof: REACT_CONTEXT_TYPE,
      Provider: null,
      Consumer: null,
      _currentValue: NotPendingTransition,
      _currentValue2: NotPendingTransition,
      _threadCount: 0
    }, badgeFormat = "%c%s%c", badgeStyle = "background: #e6e6e6;background: light-dark(rgba(0,0,0,0.1), rgba(255,255,255,0.25));color: #000000;color: light-dark(#000000, #ffffff);border-radius: 2px", resetStyle = "", pad = " ", bind = Function.prototype.bind;
    var didWarnAboutNestedUpdates = false;
    var overrideHookState = null, overrideHookStateDeletePath = null, overrideHookStateRenamePath = null, overrideProps = null, overridePropsDeletePath = null, overridePropsRenamePath = null, scheduleUpdate = null, scheduleRetry = null, setErrorHandler = null, setSuspenseHandler = null;
    overrideHookState = function(fiber, id2, path, value) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path = copyWithSetImpl(id2.memoizedState, path, 0, value), id2.memoizedState = path, id2.baseState = path, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateDeletePath = function(fiber, id2, path) {
      id2 = findHook(fiber, id2);
      null !== id2 && (path = copyWithDeleteImpl(id2.memoizedState, path, 0), id2.memoizedState = path, id2.baseState = path, fiber.memoizedProps = assign2({}, fiber.memoizedProps), path = enqueueConcurrentRenderForLane(fiber, 2), null !== path && scheduleUpdateOnFiber(path, fiber, 2));
    };
    overrideHookStateRenamePath = function(fiber, id2, oldPath, newPath) {
      id2 = findHook(fiber, id2);
      null !== id2 && (oldPath = copyWithRename(id2.memoizedState, oldPath, newPath), id2.memoizedState = oldPath, id2.baseState = oldPath, fiber.memoizedProps = assign2({}, fiber.memoizedProps), oldPath = enqueueConcurrentRenderForLane(fiber, 2), null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2));
    };
    overrideProps = function(fiber, path, value) {
      fiber.pendingProps = copyWithSetImpl(fiber.memoizedProps, path, 0, value);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsDeletePath = function(fiber, path) {
      fiber.pendingProps = copyWithDeleteImpl(fiber.memoizedProps, path, 0);
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      path = enqueueConcurrentRenderForLane(fiber, 2);
      null !== path && scheduleUpdateOnFiber(path, fiber, 2);
    };
    overridePropsRenamePath = function(fiber, oldPath, newPath) {
      fiber.pendingProps = copyWithRename(
        fiber.memoizedProps,
        oldPath,
        newPath
      );
      fiber.alternate && (fiber.alternate.pendingProps = fiber.pendingProps);
      oldPath = enqueueConcurrentRenderForLane(fiber, 2);
      null !== oldPath && scheduleUpdateOnFiber(oldPath, fiber, 2);
    };
    scheduleUpdate = function(fiber) {
      var root3 = enqueueConcurrentRenderForLane(fiber, 2);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, 2);
    };
    scheduleRetry = function(fiber) {
      var lane = claimNextRetryLane(), root3 = enqueueConcurrentRenderForLane(fiber, lane);
      null !== root3 && scheduleUpdateOnFiber(root3, fiber, lane);
    };
    setErrorHandler = function(newShouldErrorImpl) {
      shouldErrorImpl = newShouldErrorImpl;
    };
    setSuspenseHandler = function(newShouldSuspendImpl) {
      shouldSuspendImpl = newShouldSuspendImpl;
    };
    var _enabled = true, return_targetInst = null, hasScheduledReplayAttempt = false, queuedFocus = null, queuedDrag = null, queuedMouse = null, queuedPointers = /* @__PURE__ */ new Map(), queuedPointerCaptures = /* @__PURE__ */ new Map(), queuedExplicitHydrationTargets = [], discreteReplayableEvents = "mousedown mouseup touchcancel touchend touchstart auxclick dblclick pointercancel pointerdown pointerup dragend dragstart drop compositionend compositionstart keydown keypress keyup input textInput copy cut paste click change contextmenu reset".split(
      " "
    ), lastScheduledReplayQueue = null;
    ReactDOMHydrationRoot.prototype.render = ReactDOMRoot.prototype.render = function(children) {
      var root3 = this._internalRoot;
      if (null === root3) throw Error("Cannot update an unmounted root.");
      var args = arguments;
      "function" === typeof args[1] ? console.error(
        "does not support the second callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      ) : isValidContainer(args[1]) ? console.error(
        "You passed a container to the second argument of root.render(...). You don't need to pass it again since you already passed it to create the root."
      ) : "undefined" !== typeof args[1] && console.error(
        "You passed a second argument to root.render(...) but it only accepts one argument."
      );
      args = children;
      var current3 = root3.current, lane = requestUpdateLane(current3);
      updateContainerImpl(current3, lane, args, root3, null, null);
    };
    ReactDOMHydrationRoot.prototype.unmount = ReactDOMRoot.prototype.unmount = function() {
      var args = arguments;
      "function" === typeof args[0] && console.error(
        "does not support a callback argument. To execute a side effect after rendering, declare it in a component body with useEffect()."
      );
      args = this._internalRoot;
      if (null !== args) {
        this._internalRoot = null;
        var container = args.containerInfo;
        (executionContext & (RenderContext | CommitContext)) !== NoContext && console.error(
          "Attempted to synchronously unmount a root while React was already rendering. React cannot finish unmounting the root until the current render has completed, which may lead to a race condition."
        );
        updateContainerImpl(args.current, 2, null, args, null, null);
        flushSyncWork$1();
        container[internalContainerInstanceKey] = null;
      }
    };
    ReactDOMHydrationRoot.prototype.unstable_scheduleHydration = function(target) {
      if (target) {
        var updatePriority = resolveUpdatePriority();
        target = { blockedOn: null, target, priority: updatePriority };
        for (var i2 = 0; i2 < queuedExplicitHydrationTargets.length && 0 !== updatePriority && updatePriority < queuedExplicitHydrationTargets[i2].priority; i2++) ;
        queuedExplicitHydrationTargets.splice(i2, 0, target);
        0 === i2 && attemptExplicitHydrationTarget(target);
      }
    };
    (function() {
      var isomorphicReactPackageVersion = React2.version;
      if ("19.2.7" !== isomorphicReactPackageVersion)
        throw Error(
          'Incompatible React versions: The "react" and "react-dom" packages must have the exact same version. Instead got:\n  - react:      ' + (isomorphicReactPackageVersion + "\n  - react-dom:  19.2.7\nLearn more: https://react.dev/warnings/version-mismatch")
        );
    })();
    "function" === typeof Map && null != Map.prototype && "function" === typeof Map.prototype.forEach && "function" === typeof Set && null != Set.prototype && "function" === typeof Set.prototype.clear && "function" === typeof Set.prototype.forEach || console.error(
      "React depends on Map and Set built-in types. Make sure that you load a polyfill in older browsers. https://react.dev/link/react-polyfills"
    );
    ReactDOMSharedInternals.findDOMNode = function(componentOrElement) {
      var fiber = componentOrElement._reactInternals;
      if (void 0 === fiber) {
        if ("function" === typeof componentOrElement.render)
          throw Error("Unable to find node on an unmounted component.");
        componentOrElement = Object.keys(componentOrElement).join(",");
        throw Error(
          "Argument appears to not be a ReactComponent. Keys: " + componentOrElement
        );
      }
      componentOrElement = findCurrentFiberUsingSlowPath(fiber);
      componentOrElement = null !== componentOrElement ? findCurrentHostFiberImpl(componentOrElement) : null;
      componentOrElement = null === componentOrElement ? null : componentOrElement.stateNode;
      return componentOrElement;
    };
    if (!(function() {
      var internals = {
        bundleType: 1,
        version: "19.2.7",
        rendererPackageName: "react-dom",
        currentDispatcherRef: ReactSharedInternals,
        reconcilerVersion: "19.2.7"
      };
      internals.overrideHookState = overrideHookState;
      internals.overrideHookStateDeletePath = overrideHookStateDeletePath;
      internals.overrideHookStateRenamePath = overrideHookStateRenamePath;
      internals.overrideProps = overrideProps;
      internals.overridePropsDeletePath = overridePropsDeletePath;
      internals.overridePropsRenamePath = overridePropsRenamePath;
      internals.scheduleUpdate = scheduleUpdate;
      internals.scheduleRetry = scheduleRetry;
      internals.setErrorHandler = setErrorHandler;
      internals.setSuspenseHandler = setSuspenseHandler;
      internals.scheduleRefresh = scheduleRefresh;
      internals.scheduleRoot = scheduleRoot;
      internals.setRefreshHandler = setRefreshHandler;
      internals.getCurrentFiber = getCurrentFiberForDevTools;
      return injectInternals(internals);
    })() && canUseDOM2 && window.top === window.self && (-1 < navigator.userAgent.indexOf("Chrome") && -1 === navigator.userAgent.indexOf("Edge") || -1 < navigator.userAgent.indexOf("Firefox"))) {
      var protocol2 = window.location.protocol;
      /^(https?|file):$/.test(protocol2) && console.info(
        "%cDownload the React DevTools for a better development experience: https://react.dev/link/react-devtools" + ("file:" === protocol2 ? "\nYou might need to use a local HTTP server (instead of file://): https://react.dev/link/react-devtools-faq" : ""),
        "font-weight:bold"
      );
    }
    reactDomClient_development.createRoot = function(container, options2) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError;
      null !== options2 && void 0 !== options2 && (options2.hydrate ? console.warn(
        "hydrate through createRoot is deprecated. Use ReactDOMClient.hydrateRoot(container, <App />) instead."
      ) : "object" === typeof options2 && null !== options2 && options2.$$typeof === REACT_ELEMENT_TYPE && console.error(
        "You passed a JSX element to createRoot. You probably meant to call root.render instead. Example usage:\n\n  let root = createRoot(domContainer);\n  root.render(<App />);"
      ), true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError));
      options2 = createFiberRoot(
        container,
        1,
        false,
        null,
        null,
        isStrictMode,
        identifierPrefix,
        null,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        defaultOnDefaultTransitionIndicator
      );
      container[internalContainerInstanceKey] = options2.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMRoot(options2);
    };
    reactDomClient_development.hydrateRoot = function(container, initialChildren, options2) {
      if (!isValidContainer(container))
        throw Error("Target container is not a DOM element.");
      warnIfReactDOMContainerInDEV(container);
      void 0 === initialChildren && console.error(
        "Must provide initial children as second argument to hydrateRoot. Example usage: hydrateRoot(domContainer, <App />)"
      );
      var isStrictMode = false, identifierPrefix = "", onUncaughtError = defaultOnUncaughtError, onCaughtError = defaultOnCaughtError, onRecoverableError = defaultOnRecoverableError, formState = null;
      null !== options2 && void 0 !== options2 && (true === options2.unstable_strictMode && (isStrictMode = true), void 0 !== options2.identifierPrefix && (identifierPrefix = options2.identifierPrefix), void 0 !== options2.onUncaughtError && (onUncaughtError = options2.onUncaughtError), void 0 !== options2.onCaughtError && (onCaughtError = options2.onCaughtError), void 0 !== options2.onRecoverableError && (onRecoverableError = options2.onRecoverableError), void 0 !== options2.formState && (formState = options2.formState));
      initialChildren = createFiberRoot(
        container,
        1,
        true,
        initialChildren,
        null != options2 ? options2 : null,
        isStrictMode,
        identifierPrefix,
        formState,
        onUncaughtError,
        onCaughtError,
        onRecoverableError,
        defaultOnDefaultTransitionIndicator
      );
      initialChildren.context = getContextForSubtree(null);
      options2 = initialChildren.current;
      isStrictMode = requestUpdateLane(options2);
      isStrictMode = getBumpedLaneForHydrationByLane(isStrictMode);
      identifierPrefix = createUpdate(isStrictMode);
      identifierPrefix.callback = null;
      enqueueUpdate(options2, identifierPrefix, isStrictMode);
      startUpdateTimerByLane(isStrictMode, "hydrateRoot()", null);
      options2 = isStrictMode;
      initialChildren.current.lanes = options2;
      markRootUpdated$1(initialChildren, options2);
      ensureRootIsScheduled(initialChildren);
      container[internalContainerInstanceKey] = initialChildren.current;
      listenToAllSupportedEvents(container);
      return new ReactDOMHydrationRoot(initialChildren);
    };
    reactDomClient_development.version = "19.2.7";
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return reactDomClient_development;
}
var hasRequiredClient;
function requireClient() {
  if (hasRequiredClient) return client.exports;
  hasRequiredClient = 1;
  function checkDCE() {
    if (typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === "undefined" || typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== "function") {
      return;
    }
    if (process.env.NODE_ENV !== "production") {
      throw new Error("^_^");
    }
    try {
      __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
    } catch (err) {
      console.error(err);
    }
  }
  if (process.env.NODE_ENV === "production") {
    checkDCE();
    client.exports = requireReactDomClient_production();
  } else {
    client.exports = requireReactDomClient_development();
  }
  return client.exports;
}
var clientExports = requireClient();
const TEX_NAMES_LOWER = [
  "phi",
  "varsigma",
  "epsilon",
  "rho",
  "tau",
  "upsilon",
  "theta",
  "iota",
  null,
  "pi",
  "alpha",
  "sigma",
  "delta",
  "varphi",
  "gamma",
  "eta",
  "xi",
  "kappa",
  "lambda",
  "zeta",
  "chi",
  "psi",
  "omega",
  "beta",
  "nu",
  "mu"
];
const TEX_NAMES_UPPER = [
  "Phi",
  "Sigma",
  null,
  null,
  null,
  null,
  "Theta",
  null,
  null,
  "Pi",
  null,
  "Sigma",
  "Delta",
  "Phi",
  "Gamma",
  null,
  "Xi",
  null,
  "Lambda",
  null,
  null,
  "Psi",
  "Omega",
  null,
  null,
  null
];
const KEYS = {
  alpha_lower: "qwertyuiopasdfghjklzxcvbnm,'".split("").map((c2) => ({
    displayName: c2,
    name: c2,
    commands: [{ type: "write", command: c2 }]
  })),
  alpha_upper: "QWERTYUIOPASDFGHJKLZXCVBNM,'".split("").map((c2) => ({
    displayName: c2,
    name: c2,
    commands: [{ type: "write", command: c2 }]
  })),
  numeric: "1234567890.".split("").map((c2) => ({
    displayName: c2,
    name: c2 === "." ? "dot" : c2,
    commands: [{ type: "write", command: c2 }]
  })),
  // lower-case greek letters in QWERTY order
  // Use `...` rather than `.split` to properly handle unicode characters
  greek_lower: [..."ϕ𝜍ερτυθιοπασδφγηξκλζχψωβνμ,'"].map((c2, i2) => ({
    displayName: c2,
    name: c2,
    commands: [
      {
        type: "write",
        command: TEX_NAMES_LOWER[i2] ? `\\${TEX_NAMES_LOWER[i2]}` : c2
      }
    ]
  })),
  // upper-case greek letters in QWERTY order
  greek_upper: [..."ΦΣΕΡΤΥΘΙΟΠΑΣΔΦΓΗΞΚΛΖΧΨΩΒΝΜ,'"].map((c2, i2) => ({
    displayName: c2,
    name: c2,
    commands: [
      {
        type: "write",
        command: TEX_NAMES_UPPER[i2] ? `\\${TEX_NAMES_UPPER[i2]}` : c2
      }
    ]
  }))
  // var-sigma greek letter
  //greek_lower: "",
};
const SPECIAL_KEYS = {
  shift: {
    displayName: "⇧",
    name: "shift",
    commands: [{ type: "cmd", command: "Shift" }]
  },
  backspace: {
    displayName: "⌫",
    name: "backspace",
    commands: [{ type: "keystroke", command: "Backspace" }]
  },
  space: {
    displayName: "␣",
    name: "space",
    commands: [{ type: "write", command: "\\ " }]
  },
  left: {
    displayName: "←",
    name: "left",
    commands: [{ type: "keystroke", command: "Left" }]
  },
  right: {
    displayName: "→",
    name: "right",
    commands: [{ type: "keystroke", command: "Right" }]
  },
  enter: {
    displayName: "Enter",
    name: "enter",
    commands: [{ type: "keystroke", command: "Enter" }]
  }
};
const OPERATOR_KEYS = {
  times: {
    displayName: "×",
    name: "times",
    commands: [{ type: "write", command: "\\times" }]
  },
  divide: {
    displayName: "÷",
    name: "divide",
    commands: [{ type: "cmd", command: "/" }]
  },
  plus: {
    displayName: "+",
    name: "plus",
    commands: [{ type: "write", command: "+" }]
  },
  minus: {
    displayName: "−",
    name: "minus",
    commands: [{ type: "write", command: "-" }]
  },
  equals: {
    displayName: "=",
    name: "equals",
    commands: [{ type: "write", command: "=" }]
  }
};
const VAR_KEYS = {
  x: {
    // displayName: "x",
    displayName: " x",
    name: "x",
    commands: [{ type: "write", command: "x" }]
  },
  y: {
    // displayName: "y",
    displayName: " y",
    name: "y",
    commands: [{ type: "write", command: "y" }]
  },
  pi: {
    // displayName: "π",
    displayName: "\\pi",
    name: "pi",
    commands: [{ type: "write", command: "\\pi" }]
  },
  e: {
    // displayName: "e",
    displayName: " e",
    name: "e",
    commands: [{ type: "write", command: "e" }]
  },
  square: {
    // displayName: "a²",
    displayName: "a^2",
    name: "square",
    commands: [
      { type: "type", command: "^2" },
      { type: "keystroke", command: "Right" }
    ]
  },
  exponent: {
    // displayName: "aᵇ",
    displayName: "b^a",
    name: "exponent",
    commands: [{ type: "cmd", command: "^" }]
  },
  sqrt: {
    // displayName: "√a",
    displayName: "\\sqrt{a}",
    name: "sqrt",
    commands: [{ type: "type", command: "sqrt" }]
  },
  abs: {
    displayName: "|a|",
    name: "abs",
    commands: [
      { type: "cmd", command: "|" },
      { type: "cmd", command: "|" },
      { type: "keystroke", command: "Left" }
    ]
  },
  lt: {
    displayName: "<",
    name: "lt",
    commands: [{ type: "write", command: "<" }]
  },
  gt: {
    displayName: ">",
    name: "gt",
    commands: [{ type: "write", command: ">" }]
  },
  leq: {
    displayName: "≤",
    name: "leq",
    commands: [{ type: "type", command: "<=" }]
  },
  geq: {
    displayName: "≥",
    name: "geq",
    commands: [{ type: "type", command: ">=" }]
  },
  comma: {
    displayName: ",",
    name: "comma",
    commands: [{ type: "write", command: "," }]
  },
  leftParen: {
    displayName: "(",
    name: "leftParen",
    commands: [{ type: "cmd", command: "(" }]
  },
  rightParen: {
    displayName: ")",
    name: "rightParen",
    commands: [{ type: "cmd", command: ")" }]
  }
};
const SYMBOL_KEYS = {
  openBrace: {
    displayName: "\\{",
    name: "openBrace",
    commands: [{ type: "cmd", command: "{" }]
  },
  closeBrace: {
    displayName: "\\}",
    name: "closeBrace",
    commands: [{ type: "cmd", command: "}" }]
  },
  comma: {
    displayName: ",",
    name: "comma",
    commands: [{ type: "write", command: "," }]
  },
  colon: {
    displayName: ":",
    name: "colon",
    commands: [{ type: "write", command: ":" }]
  },
  vert: {
    displayName: "|",
    name: "vert",
    commands: [{ type: "write", command: "\\vert" }]
  },
  subset: {
    displayName: "⊂",
    name: "subset",
    commands: [{ type: "write", command: "\\subset" }]
  },
  subseteq: {
    displayName: "⊆",
    name: "subseteq",
    commands: [{ type: "write", command: "\\subseteq" }]
  },
  neq: {
    displayName: "≠",
    name: "neq",
    commands: [{ type: "write", command: "\\neq" }]
  },
  elementOf: {
    displayName: "∈",
    name: "elementOf",
    commands: [{ type: "write", command: "\\in" }]
  },
  infty: {
    displayName: "∞",
    name: "infinity",
    commands: [{ type: "write", command: "\\infty" }]
  },
  openParen: {
    displayName: "(",
    name: "openParen",
    commands: [{ type: "cmd", command: "(" }]
  },
  closeParen: {
    displayName: ")",
    name: "closeParen",
    commands: [{ type: "cmd", command: ")" }]
  },
  openSquareBracket: {
    displayName: "[",
    name: "openSquareBracket",
    commands: [{ type: "cmd", command: "[" }]
  },
  closeSquareBracket: {
    displayName: "]",
    name: "closeSquareBracket",
    commands: [{ type: "cmd", command: "]" }]
  },
  emptySet: {
    displayName: "∅",
    name: "emptySet",
    commands: [{ type: "write", command: "\\emptyset" }]
  }
};
const OTHER_SYMBOLS = {
  vec: {
    displayName: "a⃗",
    name: "vec",
    commands: [
      { type: "write", command: "\\vec{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  langle: {
    displayName: "⟨",
    name: "langle",
    commands: [{ type: "cmd", command: "\\langle" }]
  },
  rangle: {
    displayName: "⟩",
    name: "rangle",
    commands: [{ type: "cmd", command: "\\rangle" }]
  },
  cdot: {
    displayName: "⋅",
    name: "cdot",
    commands: [{ type: "write", command: "\\cdot" }]
  },
  times: {
    displayName: "×",
    name: "times",
    commands: [{ type: "write", command: "\\times" }]
  },
  conj: {
    displayName: "ā",
    name: "conj",
    commands: [{ type: "cmd", command: "\\overline" }]
  },
  perp: {
    displayName: "⊥",
    name: "perp",
    commands: [{ type: "write", command: "\\perp" }]
  },
  parallel: {
    displayName: "∥",
    name: "parallel",
    commands: [{ type: "write", command: "\\parallel" }]
  },
  angle: {
    displayName: "∠",
    name: "angle",
    commands: [{ type: "write", command: "\\angle" }]
  },
  degree: {
    displayName: "a°",
    name: "degree",
    commands: [{ type: "write", command: "\\degree" }]
  },
  exists: {
    displayName: "∃",
    name: "exists",
    commands: [{ type: "write", command: "\\exists" }]
  },
  forall: {
    displayName: "∀",
    name: "forall",
    commands: [{ type: "write", command: "\\forall" }]
  },
  percent: {
    displayName: "\\%",
    name: "percent",
    commands: [{ type: "write", command: "%" }]
  },
  dollar: {
    displayName: "$",
    name: "dollar",
    commands: [{ type: "write", command: "$" }]
  },
  subscript: {
    displayName: "bₐ",
    name: "subscript",
    commands: [{ type: "cmd", command: "_" }]
  }
};
const TRIG_KEYS = {
  sin: {
    // displayName: "sin",
    displayName: "\\sin",
    name: "sin",
    commands: [{ type: "type", command: "sin(" }]
  },
  cos: {
    // displayName: "cos",
    displayName: "\\cos",
    name: "cos",
    commands: [{ type: "type", command: "cos(" }]
  },
  tan: {
    // displayName: "tan",
    displayName: "\\tan",
    name: "tan",
    commands: [{ type: "type", command: "tan(" }]
  },
  arcsin: {
    // displayName: "sin⁻¹",
    displayName: "\\sin^{-1}",
    name: "arcsin",
    commands: [
      { type: "write", command: "sin^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  arccos: {
    // displayName: "cos⁻¹",
    displayName: "\\cos^{-1}",
    name: "arccos",
    commands: [
      { type: "write", command: "cos^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  arctan: {
    // displayName: "tan⁻¹",
    displayName: "\\tan^{-1}",
    name: "arctan",
    commands: [
      { type: "write", command: "tan^{-1}" },
      { type: "type", command: "(" }
    ]
  },
  ln: {
    // displayName: "ln",
    displayName: "\\ln",
    name: "ln",
    commands: [{ type: "type", command: "ln(" }]
  },
  logBaseA: {
    // displayName: "logₐ",
    displayName: "\\log_{b}",
    name: "logBaseA",
    commands: [
      { type: "write", command: "log_{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  lg: {
    // displayName: "log",
    displayName: "\\log",
    name: "lg",
    commands: [{ type: "write", command: "log_{10}" }]
  },
  exp: {
    // displayName: "eᵃ",
    displayName: "e^a",
    name: "exp",
    commands: [
      { type: "write", command: "e^{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  tenToTheA: {
    // displayName: "10ᵃ",
    displayName: "10^a",
    name: "tenToTheA",
    commands: [
      { type: "write", command: "10^{}" },
      { type: "keystroke", command: "Left" }
    ]
  },
  athRootOfB: {
    // displayName: "ᵃ√b",
    displayName: "\\sqrt[a]{b}",
    name: "athRootOfB",
    commands: [
      { type: "write", command: "\\sqrt[]{}" },
      { type: "keystroke", command: "Left" },
      { type: "keystroke", command: "Left" }
    ]
  }
};
const FUNCTION_KEYS = {
  deriv: {
    // displayName: "d/dx",
    displayName: "\\frac{d}{dx}",
    name: "deriv",
    commands: [{ type: "write", command: "\\frac{d}{dx}" }]
  },
  int: {
    // displayName: "∫",
    displayName: "\\int_a^b",
    name: "int",
    commands: [
      { type: "write", command: "\\int_{}^{}" },
      { type: "keystroke", command: "Left" },
      { type: "keystroke", command: "Left" }
    ]
  },
  nPr: {
    displayName: "nPr",
    name: "nPr",
    commands: [{ type: "type", command: "nPr(" }]
  },
  nCr: {
    displayName: "nCr",
    name: "nCr",
    commands: [{ type: "type", command: "nCr(" }]
  },
  factorial: {
    displayName: "n!",
    name: "factorial",
    commands: [{ type: "write", command: "!" }]
  },
  floor: {
    displayName: "⌊a⌋",
    name: "floor",
    commands: [
      { type: "write", command: "\\lfloor" },
      { type: "write", command: "\\rfloor" },
      { type: "keystroke", command: "Left" }
    ]
  },
  ceil: {
    displayName: "⌈a⌉",
    name: "ceil",
    commands: [
      { type: "write", command: "\\lceil" },
      { type: "write", command: "\\rceil" },
      { type: "keystroke", command: "Left" }
    ]
  }
};
for (const key of [
  ...Object.values(SYMBOL_KEYS),
  ...Object.values(OTHER_SYMBOLS),
  ...Object.values(FUNCTION_KEYS),
  ...Object.values(TRIG_KEYS),
  ...Object.values(OPERATOR_KEYS),
  ...Object.values(VAR_KEYS)
]) {
  key.isMath = true;
}
const BackspaceIcon = /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    "aria-hidden": "true",
    focusable: "false",
    "data-prefix": "fas",
    "data-icon": "delete-left",
    className: "svg-inline--fa fa-delete-left ",
    role: "img",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 576 512"
  },
  /* @__PURE__ */ React__default.createElement(
    "path",
    {
      fill: "currentColor",
      d: "M576 128c0-35.3-28.7-64-64-64H205.3c-17 0-33.3 6.7-45.3 18.7L9.4 233.4c-6 6-9.4 14.1-9.4 22.6s3.4 16.6 9.4 22.6L160 429.3c12 12 28.3 18.7 45.3 18.7H512c35.3 0 64-28.7 64-64V128zM271 175c9.4-9.4 24.6-9.4 33.9 0l47 47 47-47c9.4-9.4 24.6-9.4 33.9 0s9.4 24.6 0 33.9l-47 47 47 47c9.4 9.4 9.4 24.6 0 33.9s-24.6 9.4-33.9 0l-47-47-47 47c-9.4 9.4-24.6 9.4-33.9 0s-9.4-24.6 0-33.9l47-47-47-47c-9.4-9.4-9.4-24.6 0-33.9z"
    }
  )
);
function Keyboard({
  style,
  onClick
}) {
  switch (style) {
    case "alpha_lower":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard alpha" }, /* @__PURE__ */ React__default.createElement(Qwerty, { type: "lower", onClick }));
    case "alpha_upper":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard alpha" }, /* @__PURE__ */ React__default.createElement(Qwerty, { type: "upper", onClick }));
    case "numeric":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard numeric" }, /* @__PURE__ */ React__default.createElement(Numeric, { onClick }));
    case "greek_lower":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard greek" }, /* @__PURE__ */ React__default.createElement(Greek, { type: "lower", onClick }));
    case "greek_upper":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard greek" }, /* @__PURE__ */ React__default.createElement(Greek, { type: "upper", onClick }));
    case "symbol":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard symbol" }, /* @__PURE__ */ React__default.createElement(Symbol$1, { onClick }));
    case "function":
      return /* @__PURE__ */ React__default.createElement("div", { className: "virtual-keyboard composite" }, /* @__PURE__ */ React__default.createElement(Composite, { onClick }));
  }
}
function Key({
  keyInfo,
  onClick
}) {
  let content2 = keyInfo.displayName;
  if (keyInfo.isMath) {
    content2 = /* @__PURE__ */ React__default.createElement("div", { style: { pointerEvents: "none" } }, /* @__PURE__ */ React__default.createElement(MathJax, null, "\\(" + content2 + "\\)"));
  }
  if (keyInfo.name === "backspace") {
    content2 = BackspaceIcon;
  }
  return /* @__PURE__ */ React__default.createElement(
    "button",
    {
      className: `key key-${keyInfo.name} ${keyInfo.isMath ? "math" : ""}`,
      onClick: (e2) => {
        e2.stopPropagation();
        onClick(keyInfo.commands);
      },
      title: `Type ${keyInfo.name}`
    },
    content2
  );
}
function Qwerty({
  type,
  onClick
}) {
  const keys2 = type === "upper" ? KEYS.alpha_upper : KEYS.alpha_lower;
  const row1 = keys2.slice(0, 10);
  const row2 = keys2.slice(10, 19);
  const row3 = [
    SPECIAL_KEYS.shift,
    ...keys2.slice(19, 26),
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...keys2.slice(26, 29),
    SPECIAL_KEYS.space,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })))));
}
function Numeric({ onClick }) {
  const row1 = [
    ...KEYS.numeric.slice(0, 3),
    OPERATOR_KEYS.times,
    OPERATOR_KEYS.divide
  ];
  const row2 = [
    ...KEYS.numeric.slice(3, 6),
    OPERATOR_KEYS.plus,
    OPERATOR_KEYS.minus
  ];
  const row3 = [
    ...KEYS.numeric.slice(6, 9),
    OPERATOR_KEYS.equals,
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...KEYS.numeric.slice(9),
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(VAR_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "sub-keyboard" }, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(
    Key,
    {
      keyInfo: key,
      onClick,
      key: key.name
    }
  ))))));
}
function Symbol$1({ onClick }) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(SYMBOL_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(OTHER_SYMBOLS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })), [
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.backspace,
    SPECIAL_KEYS.enter
  ].map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))));
}
function Greek({
  type,
  onClick
}) {
  const keys2 = type === "upper" ? KEYS.greek_upper : KEYS.greek_lower;
  const row1 = keys2.slice(0, 10);
  const row2 = keys2.slice(10, 19);
  const row3 = [
    SPECIAL_KEYS.shift,
    ...keys2.slice(19, 26),
    SPECIAL_KEYS.backspace
  ];
  const row4 = [
    ...keys2.slice(26, 29),
    SPECIAL_KEYS.space,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ];
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, [row1, row2, row3, row4].map((row, i2) => /* @__PURE__ */ React__default.createElement("div", { key: i2, className: "row" }, row.map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })))));
}
function Composite({ onClick }) {
  return /* @__PURE__ */ React__default.createElement(React__default.Fragment, null, /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(TRIG_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))), /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-region" }, Object.values(FUNCTION_KEYS).map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name })), [
    SPECIAL_KEYS.backspace,
    SPECIAL_KEYS.left,
    SPECIAL_KEYS.right,
    SPECIAL_KEYS.enter
  ].map((key) => /* @__PURE__ */ React__default.createElement(Key, { keyInfo: key, onClick, key: key.name }))));
}
const FocusableContext$2 = createContext(true);
function flatten2DArray$2(array) {
  const flattened2 = [];
  for (const row of array) flattened2.push(...row);
  return flattened2;
}
function reverseArray$2(array) {
  return array.slice().reverse();
}
function noop$1$1(..._2) {
}
function hasOwnProperty$2$2(object2, prop) {
  if (typeof Object.hasOwn === "function") return Object.hasOwn(object2, prop);
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain$1$1(...fns) {
  return (...args) => {
    for (const fn2 of fns) if (typeof fn2 === "function") fn2(...args);
  };
}
function omit$1$1(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) if (hasOwnProperty$2$2(result2, key)) delete result2[key];
  return result2;
}
function pick$3(object2, paths) {
  const result2 = {};
  for (const key of paths) if (hasOwnProperty$2$2(object2, key)) result2[key] = object2[key];
  return result2;
}
function identity$1$1(value) {
  return value;
}
function invariant$2(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys$2(obj) {
  return Object.keys(obj);
}
function disabledFromProps$2(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function removeUndefinedValues$2(obj) {
  const result2 = {};
  for (const key in obj) if (obj[key] !== void 0) result2[key] = obj[key];
  return result2;
}
function defaultValue$2(...values2) {
  for (const value of values2) if (value !== void 0) return value;
}
const canUseDOM$2 = checkIsBrowser$2();
function checkIsBrowser$2() {
  return typeof window !== "undefined" && !!window.document?.createElement;
}
function getDocument$2(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getActiveElement$2(node, activeDescendant = false) {
  const { activeElement } = getDocument$2(node);
  if (!activeElement?.nodeName) return null;
  if (isFrame$2(activeElement) && activeElement.contentDocument?.body) return getActiveElement$2(activeElement.contentDocument.body, activeDescendant);
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument$2(activeElement).getElementById(id2);
      if (element2) return element2;
    }
  }
  return activeElement;
}
function contains$1$1(parent, child) {
  return parent === child || parent.contains(child);
}
function isElement$1$1(target) {
  return target?.nodeType === 1;
}
function isNode$1$1(target) {
  return typeof target?.nodeType === "number";
}
function isFrame$2(element2) {
  return element2.tagName === "IFRAME";
}
function isButton$2(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) return buttonInputTypes$2.indexOf(element2.type) !== -1;
  return false;
}
const buttonInputTypes$2 = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible$2(element2) {
  if (typeof element2.checkVisibility === "function") return element2.checkVisibility();
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField$2(element2) {
  try {
    if (element2.tagName === "TEXTAREA") return true;
    if (element2.tagName !== "INPUT") return false;
    return element2.selectionStart !== null;
  } catch (_error) {
    return false;
  }
}
function isTextbox$2(element2) {
  return element2.isContentEditable || isTextField$2(element2);
}
function getTextboxValue$2(element2) {
  if (isTextField$2(element2)) return element2.value;
  if (element2.isContentEditable) {
    const range2 = getDocument$2(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection$2(element2) {
  let start = 0;
  let end = 0;
  if (isTextField$2(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$2(element2).getSelection();
    if (selection2?.rangeCount && selection2.anchorNode && contains$1$1(element2, selection2.anchorNode) && selection2.focusNode && contains$1$1(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return {
    start,
    end
  };
}
function getScrollingElement$2(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  const doc2 = getDocument$2(element2);
  return getScrollingElement$2(element2.parentElement) || doc2.scrollingElement || doc2.body;
}
function sortBasedOnDOMPosition$2(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a2], [indexB, b2]) => {
    const elementA = getElement(a2);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding$2(elementA, elementB)) {
      if (indexA > indexB) isOrderDifferent = true;
      return -1;
    }
    if (indexA < indexB) isOrderDifferent = true;
    return 1;
  });
  if (isOrderDifferent) return pairs2.map(([_2, item]) => item);
  return items;
}
function isElementPreceding$2(a2, b2) {
  return Boolean(b2.compareDocumentPosition(a2) & Node.DOCUMENT_POSITION_PRECEDING);
}
function isApple$2() {
  if (!canUseDOM$2) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari$2() {
  return canUseDOM$2 && isApple$2() && /apple/i.test(navigator.vendor);
}
function isFirefox$2() {
  return canUseDOM$2 && /firefox\//i.test(navigator.userAgent);
}
function isPortalEvent$2(event) {
  const { currentTarget, target } = event;
  if (!currentTarget) return false;
  if (!isNode$1$1(target)) return true;
  return !contains$1$1(currentTarget, target);
}
function isSelfTarget$2(event) {
  return event.target === event.currentTarget;
}
function fireBlurEvent$2(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = {
    ...eventInit,
    bubbles: true
  };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent$2(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent$2(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside$2(event, container) {
  const containerElement = event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !isNode$1$1(relatedTarget) || !contains$1$1(containerElement, relatedTarget);
}
function queueBeforeEvent$2(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, {
    once: true,
    capture: true
  });
  return () => {
    cancelTimer();
    element2.removeEventListener(type, callSync, true);
  };
}
function addGlobalEventListener$2(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) children.push(addGlobalEventListener$2(type, listener, options2, frame));
  } catch {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch {
    }
    for (const remove2 of children) remove2();
  };
  return removeEventListener2;
}
const selector$2 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function isFocusable$2(element2) {
  if (!element2.matches(selector$2)) return false;
  if (!isVisible$2(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function hasFocus$2(element2) {
  const activeElement = getActiveElement$2(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function focusIntoView$2(element2, options2) {
  if (!("scrollIntoView" in element2)) element2.focus();
  else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      ...options2
    });
  }
}
function createUndoCallback$2(callback) {
  return async () => {
    const redo2 = await callback?.();
    return createUndoCallback$2(async () => {
      await redo2?.();
      return callback;
    });
  };
}
createUndoManager$2();
function createUndoManager$2({ limit = 100 } = {}) {
  const undoStack = [];
  let redoStack = [];
  let currentGroup = null;
  const canUndo = () => undoStack.length > 0;
  const canRedo = () => redoStack.length > 0;
  const undo2 = async () => {
    if (!canUndo()) return;
    currentGroup = null;
    redoStack.push(await undoStack.pop()?.());
  };
  const redo2 = async () => {
    if (!canRedo()) return;
    currentGroup = null;
    undoStack.push(await redoStack.pop()?.());
  };
  const execute = async (callback, group2) => {
    if (!callback) return;
    const sameGroup = group2 === currentGroup;
    currentGroup = group2 ?? null;
    const nextIndex = sameGroup ? Math.max(0, undoStack.length - 1) : undoStack.length;
    const undoCallback = await callback();
    if (!undoCallback) return;
    redoStack = [];
    const currentUndo = undoStack[nextIndex];
    undoStack[nextIndex] = createUndoCallback$2(async () => {
      await undoCallback?.();
      const currentRedo = await currentUndo?.();
      return async () => {
        await currentRedo?.();
        await callback?.();
      };
    });
    while (undoStack.length > limit) undoStack.shift();
  };
  return {
    canUndo,
    canRedo,
    undo: undo2,
    redo: redo2,
    execute
  };
}
function getDefaultExportFromCjs$1$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var jsxRuntime$2 = { exports: {} };
var reactJsxRuntime_production$2 = {};
var hasRequiredReactJsxRuntime_production$2;
function requireReactJsxRuntime_production$2() {
  if (hasRequiredReactJsxRuntime_production$2) return reactJsxRuntime_production$2;
  hasRequiredReactJsxRuntime_production$2 = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$2.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$2.jsx = jsxProd;
  reactJsxRuntime_production$2.jsxs = jsxProd;
  return reactJsxRuntime_production$2;
}
var reactJsxRuntime_development$2 = {};
var hasRequiredReactJsxRuntime_development$2;
function requireReactJsxRuntime_development$2() {
  if (hasRequiredReactJsxRuntime_development$2) return reactJsxRuntime_development$2;
  hasRequiredReactJsxRuntime_development$2 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$2.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$2.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$2.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$2;
}
var hasRequiredJsxRuntime$2;
function requireJsxRuntime$2() {
  if (hasRequiredJsxRuntime$2) return jsxRuntime$2.exports;
  hasRequiredJsxRuntime$2 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$2.exports = requireReactJsxRuntime_production$2();
  } else {
    jsxRuntime$2.exports = requireReactJsxRuntime_development$2();
  }
  return jsxRuntime$2.exports;
}
var jsxRuntimeExports$2 = requireJsxRuntime$2();
function setRef$2(ref, value) {
  if (typeof ref === "function") {
    const cleanup = ref(value);
    if (typeof cleanup === "function") return cleanup;
  } else if (ref) ref.current = value;
}
function isValidElementWithRef$2(element2) {
  if (!element2) return false;
  if (!isValidElement(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty$2(element2) {
  if (!isValidElementWithRef$2(element2)) return null;
  return { ...element2.props }.ref || element2.ref;
}
function mergeProps$2(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$2$2(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      const baseClass = base2[prop];
      const overrideClass = overrides2[prop];
      if (baseClass && overrideClass) props2[prop] = `${baseClass} ${overrideClass}`;
      else props2[prop] = overrideClass || baseClass;
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? {
        ...base2[prop],
        ...overrides2[prop]
      } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (key.startsWith("on")) {
      if (typeof overrideValue !== "function") continue;
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
const _React$2 = { ...React };
const useReactId$2 = _React$2.useId;
const useReactInsertionEffect$2 = _React$2.useInsertionEffect;
const useSafeLayoutEffect$2 = canUseDOM$2 ? useLayoutEffect : useEffect;
function useLiveRef$2(value) {
  const ref = useRef(value);
  useSafeLayoutEffect$2(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent$2(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect$2) useReactInsertionEffect$2(() => {
    ref.current = callback;
  });
  else ref.current = callback;
  return useCallback((...args) => ref.current?.(...args), []);
}
function useTransactionState$2(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect$2(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs$2(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      const refEffects = [];
      for (const ref of refs) {
        if (!ref) continue;
        const cleanup = setRef$2(ref, value);
        refEffects.push({
          ref,
          cleanup: typeof cleanup === "function" ? cleanup : void 0
        });
      }
      if (!refEffects.some((effect) => effect.cleanup)) return;
      return () => {
        for (const { ref, cleanup } of refEffects) if (cleanup) cleanup();
        else setRef$2(ref, null);
      };
    };
  }, refs);
}
function useId$3(defaultId) {
  if (useReactId$2) {
    const reactId = useReactId$2();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect$2(() => {
    if (defaultId || id2) return;
    setId(`id-${Math.random().toString(36).slice(2, 8)}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName$2(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    return;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined());
  useSafeLayoutEffect$2(() => {
    setTagName((refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement)?.tagName.toLowerCase() || stringOrUndefined());
  }, [refOrElement, type]);
  return tagName;
}
function useUpdateEffect$2(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) return effect();
    mounted.current = true;
  }, deps);
  useEffect(() => () => {
    mounted.current = false;
  }, []);
}
function useBooleanEvent$2(booleanOrCallback) {
  return useEvent$2(typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback);
}
function useWrapElement$2(props2, callback, deps = []) {
  const wrapElement = useCallback((element2) => {
    if (props2.wrapElement) element2 = props2.wrapElement(element2);
    return callback(element2);
  }, [...deps, props2.wrapElement]);
  return {
    ...props2,
    wrapElement
  };
}
function useMetadataProps$2(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, parent, ...value !== void 0 ? [{ [key]: value }] : []);
  }, [
    parent,
    key,
    value
  ]);
  return [parent?.[key], { onLoadedMetadataCapture }];
}
function forwardRef$2(render) {
  const Role3 = React.forwardRef((props2, ref) => render({
    ...props2,
    ref
  }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo$2(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement$2(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs$2(props2.ref, getRefProperty$2(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = {
      ...render.props,
      ref: mergedRef
    };
    element2 = React.cloneElement(render, mergeProps$2(rest2, renderProps));
  } else if (render) element2 = render(rest2);
  else element2 = /* @__PURE__ */ jsxRuntimeExports$2.jsx(Type, { ...rest2 });
  if (wrapElement) return wrapElement(element2);
  return element2;
}
function createHook$2(useProps) {
  const useRole2 = (props2 = {}) => {
    return useProps(props2);
  };
  useRole2.displayName = useProps.name;
  return useRole2;
}
function createStoreContext$2(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(Provider2, {
      ...props2,
      children
    }), /* @__PURE__ */ jsxRuntimeExports$2.jsx(context.Provider, { ...props2 }));
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$2.jsx(ContextProvider, {
      ...props2,
      children: scopedProviders.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(Provider2, {
        ...props2,
        children
      }), /* @__PURE__ */ jsxRuntimeExports$2.jsx(scopedContext.Provider, { ...props2 }))
    });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
const TagName$6$2 = "div";
const accessibleWhenDisabledSymbol$2 = /* @__PURE__ */ Symbol("accessibleWhenDisabled");
const isSafariBrowser$3 = isSafari$2();
const alwaysFocusVisibleInputTypes$2 = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function isAlwaysFocusVisible$2(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) return alwaysFocusVisibleInputTypes$2.includes(type);
  if (element2.isContentEditable) return true;
  if (element2.getAttribute("role") === "combobox" && element2.dataset.name) return true;
  return false;
}
function isNativeTabbable$2(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute$2(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function isNativeSubmitControl$2(element2) {
  if (element2.tagName === "BUTTON") {
    const { type } = element2;
    return type === "submit";
  }
  if (element2.tagName === "INPUT") {
    const { type } = element2;
    return type === "submit" || type === "image";
  }
  return false;
}
function getTabIndex$2({ focusable, trulyDisabled, nativeTabbable, supportsDisabled, safariTabIndex, tabIndexProp }) {
  if (!focusable) return tabIndexProp;
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) return -1;
    return;
  }
  if (nativeTabbable) {
    if (safariTabIndex && tabIndexProp == null) return 0;
    return tabIndexProp;
  }
  return tabIndexProp ?? 0;
}
function useDisableEvent$2(onEvent, disabled) {
  return useEvent$2((event) => {
    onEvent?.(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
let hasInstalledGlobalEventListeners$3 = false;
let isKeyboardModality$2 = true;
function onGlobalMouseDown$2(event) {
  const target = event.target;
  if (isElement$1$1(target) && !target.hasAttribute("data-focus-visible")) isKeyboardModality$2 = false;
}
function onGlobalKeyDown$2(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality$2 = true;
}
const useFocusable$2 = createHook$2(function useFocusable2({ focusable = true, accessibleWhenDisabled, autoFocus, onFocusVisible, ...props2 }) {
  const ref = useRef(null);
  const [parentAccessibleWhenDisabled, metadataProps] = useMetadataProps$2(props2, accessibleWhenDisabledSymbol$2, accessibleWhenDisabled);
  accessibleWhenDisabled ??= parentAccessibleWhenDisabled;
  useEffect(() => {
    if (!focusable) return;
    if (hasInstalledGlobalEventListeners$3) return;
    addGlobalEventListener$2("mousedown", onGlobalMouseDown$2, true);
    addGlobalEventListener$2("keydown", onGlobalKeyDown$2, true);
    hasInstalledGlobalEventListeners$3 = true;
  }, [focusable]);
  const disabled = focusable && disabledFromProps$2(props2);
  const trulyDisabled = disabled && !accessibleWhenDisabled;
  const [focusVisible, setFocusVisible] = useState(false);
  const focusVisibleRef = useRef(false);
  const nativeSubmitObserverCleanupRef = useRef(null);
  const cleanupFocusVisible = useEvent$2((element2) => {
    nativeSubmitObserverCleanupRef.current?.();
    nativeSubmitObserverCleanupRef.current = null;
    focusVisibleRef.current = false;
    element2?.removeAttribute("data-focus-visible");
  });
  useEffect(() => {
    if (!focusable) return;
    if (!trulyDisabled) return;
    cleanupFocusVisible(ref.current);
    if (focusVisible) setFocusVisible(false);
  }, [
    focusable,
    trulyDisabled,
    focusVisible,
    cleanupFocusVisible
  ]);
  useEffect(() => {
    if (!focusable) return;
    if (!focusVisible) return;
    const element2 = ref.current;
    if (!element2) return;
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(() => {
      if (!isFocusable$2(element2)) {
        focusVisibleRef.current = false;
        setFocusVisible(false);
      }
    });
    observer.observe(element2);
    return () => observer.disconnect();
  }, [focusable, focusVisible]);
  useEffect(() => {
    return () => nativeSubmitObserverCleanupRef.current?.();
  }, []);
  const onKeyPressCapture = useDisableEvent$2(props2.onKeyPressCapture, disabled);
  const onMouseDownCapture = useDisableEvent$2(props2.onMouseDownCapture, disabled);
  const onClickCapture = useDisableEvent$2(props2.onClickCapture, disabled);
  const handleFocusVisible = (event, currentTarget) => {
    if (currentTarget) event.currentTarget = currentTarget;
    if (!focusable) return;
    const element2 = event.currentTarget;
    if (!element2) return;
    if (!hasFocus$2(element2)) return;
    onFocusVisible?.(event);
    if (event.defaultPrevented) return;
    element2.dataset.focusVisible = "true";
    focusVisibleRef.current = true;
    if (isNativeSubmitControl$2(element2)) {
      nativeSubmitObserverCleanupRef.current?.();
      nativeSubmitObserverCleanupRef.current = null;
      if (typeof IntersectionObserver !== "undefined") {
        const observer = new IntersectionObserver(() => {
          if (isFocusable$2(element2)) return;
          cleanupFocusVisible(element2);
        });
        observer.observe(element2);
        nativeSubmitObserverCleanupRef.current = () => observer.disconnect();
      }
      return;
    }
    setFocusVisible(true);
  };
  const onKeyDownCaptureProp = props2.onKeyDownCapture;
  const onKeyDownCapture = useEvent$2((event) => {
    onKeyDownCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (focusVisible) return;
    if (focusVisibleRef.current) return;
    if (event.metaKey) return;
    if (event.altKey) return;
    if (event.ctrlKey) return;
    if (!isSelfTarget$2(event)) return;
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    queueBeforeEvent$2(element2, "focusout", applyFocusVisible);
  });
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent$2((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (!isSelfTarget$2(event)) {
      setFocusVisible(false);
      return;
    }
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    if (isKeyboardModality$2 || isAlwaysFocusVisible$2(event.target)) queueBeforeEvent$2(event.target, "focusout", applyFocusVisible);
    else setFocusVisible(false);
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent$2((event) => {
    onBlurProp?.(event);
    if (!focusable) return;
    if (!isFocusEventOutside$2(event)) return;
    cleanupFocusVisible(event.currentTarget);
    setFocusVisible(false);
  });
  const autoFocusOnShow = useContext(FocusableContext$2);
  const autoFocusRef = useEvent$2((element2) => {
    if (!focusable) return;
    if (!autoFocus) return;
    if (!element2) return;
    if (!autoFocusOnShow) return;
    queueMicrotask(() => {
      if (hasFocus$2(element2)) return;
      if (!isFocusable$2(element2)) return;
      element2.focus();
    });
  });
  const tagName = useTagName$2(ref);
  const nativeTabbable = focusable && isNativeTabbable$2(tagName);
  const supportsDisabled = focusable && supportsDisabledAttribute$2(tagName);
  const [safariTabIndex, setSafariTabIndex] = useState(false);
  if (isSafariBrowser$3) useEffect(() => {
    if (!focusable) return;
    const element2 = ref.current;
    if (!element2) return;
    const { type } = element2;
    const isNativeCheckboxOrRadio = element2.tagName === "INPUT" && (type === "checkbox" || type === "radio");
    setSafariTabIndex(isButton$2(element2) || isNativeCheckboxOrRadio);
  }, [focusable]);
  const styleProp = props2.style;
  const style = useMemo(() => {
    if (trulyDisabled) return {
      pointerEvents: "none",
      ...styleProp
    };
    return styleProp;
  }, [trulyDisabled, styleProp]);
  props2 = {
    "data-focus-visible": focusable && focusVisible || void 0,
    "data-autofocus": autoFocus || void 0,
    "aria-disabled": disabled || void 0,
    ...props2,
    ...metadataProps,
    ref: useMergeRefs$2(ref, autoFocusRef, props2.ref),
    style,
    tabIndex: getTabIndex$2({
      focusable,
      trulyDisabled,
      nativeTabbable,
      supportsDisabled,
      safariTabIndex,
      tabIndexProp: props2.tabIndex
    }),
    disabled: supportsDisabled && trulyDisabled ? true : void 0,
    contentEditable: disabled ? void 0 : props2.contentEditable,
    onKeyPressCapture,
    onClickCapture,
    onMouseDownCapture,
    onKeyDownCapture,
    onFocusCapture,
    onBlur
  };
  return removeUndefinedValues$2(props2);
});
forwardRef$2(function Focusable(props2) {
  return createElement$2(TagName$6$2, useFocusable$2(props2));
});
const TagName$5$2 = "button";
function isNativeClick$2(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") return isButton$2(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  if (event.key === " ") return isButton$2(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  return false;
}
const symbol$4 = /* @__PURE__ */ Symbol("command");
const useCommand$2 = createHook$2(function useCommand2({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
  const ref = useRef(null);
  const [isNativeButton, setIsNativeButton] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    setIsNativeButton(isButton$2(ref.current));
  }, []);
  const [active, setActive] = useState(false);
  const activeRef = useRef(false);
  const disabled = disabledFromProps$2(props2);
  const [isDuplicate, metadataProps] = useMetadataProps$2(props2, symbol$4, true);
  useSafeLayoutEffect$2(() => {
    if (!disabled) return;
    activeRef.current = false;
    setActive(false);
  }, [disabled]);
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent$2((event) => {
    onKeyDownProp?.(event);
    const element2 = event.currentTarget;
    if (event.defaultPrevented) return;
    if (isDuplicate) return;
    if (disabled) return;
    if (!isSelfTarget$2(event)) return;
    if (isTextField$2(element2)) return;
    if (element2.isContentEditable) return;
    const isEnter = clickOnEnter && event.key === "Enter";
    const isSpace2 = clickOnSpace && event.key === " ";
    const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
    const shouldPreventSpace = event.key === " " && !clickOnSpace;
    if (shouldPreventEnter || shouldPreventSpace) {
      event.preventDefault();
      return;
    }
    if (isEnter || isSpace2) {
      const nativeClick = isNativeClick$2(event);
      if (isEnter) {
        if (!nativeClick) {
          event.preventDefault();
          const { view, ...eventInit } = event;
          const click = () => fireClickEvent$2(element2, eventInit);
          if (isFirefox$2()) queueBeforeEvent$2(element2, "keyup", click);
          else queueMicrotask(click);
        }
      } else if (isSpace2) {
        activeRef.current = true;
        if (!nativeClick) {
          event.preventDefault();
          setActive(true);
        }
      }
    }
  });
  const onKeyUpProp = props2.onKeyUp;
  const onKeyUp = useEvent$2((event) => {
    onKeyUpProp?.(event);
    if (isDuplicate) return;
    const isSpace2 = clickOnSpace && event.key === " ";
    if (!activeRef.current || !isSpace2) return;
    const nativeClick = isNativeClick$2(event);
    activeRef.current = false;
    if (!nativeClick) setActive(false);
    if (event.defaultPrevented) return;
    if (!isSelfTarget$2(event)) return;
    if (disabled) return;
    if (event.metaKey) return;
    if (nativeClick) return;
    event.preventDefault();
    const element2 = event.currentTarget;
    const { view, ...eventInit } = event;
    queueMicrotask(() => fireClickEvent$2(element2, eventInit));
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent$2((event) => {
    onBlurProp?.(event);
    if (!activeRef.current) return;
    activeRef.current = false;
    setActive(false);
  });
  props2 = {
    "data-active": active || void 0,
    type: isNativeButton ? "button" : void 0,
    ...metadataProps,
    ...props2,
    ref: useMergeRefs$2(ref, props2.ref),
    onKeyDown,
    onKeyUp,
    onBlur
  };
  props2 = useFocusable$2(props2);
  return props2;
});
forwardRef$2(function Command2(props2) {
  return createElement$2(TagName$5$2, useCommand$2(props2));
});
const ctx$7$1 = createStoreContext$2();
const useCollectionContext$2 = ctx$7$1.useContext;
const CollectionContextProvider$2 = ctx$7$1.ContextProvider;
const CollectionScopedContextProvider$2 = ctx$7$1.ScopedContextProvider;
const TagName$4$2 = "div";
const useCollectionItem$2 = createHook$2(function useCollectionItem2({ store: store2, shouldRegisterItem = true, getItem = identity$1$1, element: element2, ...props2 }) {
  const context = useCollectionContext$2();
  store2 = store2 || context;
  const id2 = useId$3(props2.id);
  const ref = useRef(element2);
  useEffect(() => {
    const element22 = ref.current;
    if (!id2) return;
    if (!element22) return;
    if (!shouldRegisterItem) return;
    const item = getItem({
      id: id2,
      element: element22
    });
    return store2?.renderItem(item);
  }, [
    id2,
    shouldRegisterItem,
    getItem,
    store2
  ]);
  props2 = {
    ...props2,
    ref: useMergeRefs$2(ref, props2.ref)
  };
  return removeUndefinedValues$2(props2);
});
forwardRef$2(function CollectionItem(props2) {
  return createElement$2(TagName$4$2, useCollectionItem$2(props2));
});
const ctx$6$1 = createStoreContext$2([CollectionContextProvider$2], [CollectionScopedContextProvider$2]);
const useCompositeScopedContext$2 = ctx$6$1.useScopedContext;
const useCompositeProviderContext$2 = ctx$6$1.useProviderContext;
const CompositeContextProvider$2 = ctx$6$1.ContextProvider;
const CompositeScopedContextProvider$2 = ctx$6$1.ScopedContextProvider;
const CompositeItemContext$2 = createContext(void 0);
const CompositeRowContext$2 = createContext(void 0);
function getInternal$2(store2, key) {
  const internals = store2.__unstableInternals;
  invariant$2(internals, "Invalid store");
  return internals[key];
}
function hasUpdatedKey$2(keys2, updatedKey) {
  if (!keys2) return true;
  for (const currentKey of keys2) if (updatedKey instanceof Set) {
    if (updatedKey.has(currentKey)) return true;
  } else if (currentKey === updatedKey) return true;
  return false;
}
function isSameValue$2(value, other) {
  return value === other || value !== value && other !== other;
}
function getCleanupPrevState$2(prevState, state, stateBeforeCleanup, updatedKey) {
  let cleanupPrevState;
  for (const key of getKeys$2(state)) {
    if (isSameValue$2(state[key], stateBeforeCleanup[key])) continue;
    if (updatedKey !== void 0 && hasUpdatedKey$2([key], updatedKey)) continue;
    cleanupPrevState ??= { ...prevState };
    cleanupPrevState[key] = state[key];
  }
  return cleanupPrevState;
}
const MAX_REPAIR_PASSES$2 = 100;
function addKeyedListener$2(map2, keys2, listener) {
  if (!keys2) return;
  for (const key of keys2) {
    let listeners = map2.get(key);
    if (!listeners) {
      listeners = /* @__PURE__ */ new Set();
      map2.set(key, listeners);
    }
    listeners.add(listener);
  }
}
function deleteKeyedListener$2(map2, keys2, listener) {
  if (!map2) return;
  if (!keys2) return;
  for (const key of keys2) {
    const listeners = map2.get(key);
    if (!listeners) continue;
    listeners.delete(listener);
    if (!listeners.size) map2.delete(key);
  }
}
function getFastPathNotifiedListeners$2(frame) {
  const notifiedListeners = /* @__PURE__ */ new Set();
  const currentListener = frame.currentListener;
  if (!currentListener) return notifiedListeners;
  for (const listener of frame.keyedListeners) {
    notifiedListeners.add(listener);
    if (listener === currentListener) return notifiedListeners;
  }
  notifiedListeners.clear();
  notifiedListeners.add(currentListener);
  return notifiedListeners;
}
function preserveFastPathNotifiedListeners$2(frame) {
  frame.notifiedListeners ??= getFastPathNotifiedListeners$2(frame);
}
function hasFastPathPassedListener$2(frame, listener) {
  if (!frame.currentListener) return false;
  let foundCurrentKeyedListener = false;
  for (const currentListener of frame.keyedListeners) {
    if (currentListener === frame.currentListener) {
      foundCurrentKeyedListener = true;
      continue;
    }
    if (!foundCurrentKeyedListener) continue;
    if (currentListener === listener) return false;
  }
  let foundListener = false;
  for (const currentListener of frame.group.listeners) {
    if (currentListener === frame.currentListener) return foundListener;
    if (currentListener === listener) foundListener = true;
  }
  return false;
}
function preserveFastPathFrames$2(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (listener && !frame.keyedListeners.has(listener)) continue;
    preserveFastPathNotifiedListeners$2(frame);
    for (const currentListener of frame.group.listeners) {
      if (currentListener === frame.currentListener) break;
      if (!hasFastPathPassedListener$2(frame, currentListener)) continue;
      frame.notifiedListeners?.add(currentListener);
    }
  }
}
function preserveFastPathPassedListeners$2(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!hasFastPathPassedListener$2(frame, listener)) continue;
    preserveFastPathNotifiedListeners$2(frame);
    frame.notifiedListeners?.add(listener);
  }
}
function preserveFastPathPassedKeyedListeners$2({ fastPathFrames, group: group2, keys: keys2, listener }) {
  const wasRegistered = group2.listeners.has(listener);
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    if (hasFastPathPassedListener$2(frame, listener)) {
      preserveFastPathNotifiedListeners$2(frame);
      frame.notifiedListeners?.add(listener);
    } else if (wasRegistered) {
      preserveFastPathNotifiedListeners$2(frame);
      frame.recoverToLive = true;
    }
  }
}
function clearFastPathNotifiedListener$2(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    frame.notifiedListeners?.delete(listener);
  }
}
function addFastPathKeyedListener$2({ fastPathFrames, group: group2, keys: keys2, listener }) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    frame.keyedListeners.add(listener);
  }
}
function runPendingCleanup$2(group2, listener) {
  if (!group2.disposables.size) return;
  const cleanup = group2.disposables.get(listener);
  if (!cleanup) return;
  group2.disposables.delete(listener);
  cleanup();
}
function setListenerCleanup$2(group2, listener, cleanup) {
  const currentCleanup = group2.disposables.get(listener);
  if (!currentCleanup) {
    group2.disposables.set(listener, cleanup);
    return;
  }
  group2.disposables.set(listener, () => {
    currentCleanup();
    cleanup();
  });
}
function notifyStoreListener$2(group2, listener, state, prevState, getState, updatedKey) {
  if (group2.suspendCounts?.has(listener)) return;
  const { disposables } = group2;
  const cleanup = disposables.size ? disposables.get(listener) : void 0;
  if (cleanup) {
    disposables.delete(listener);
    const stateBeforeCleanup = state;
    cleanup();
    state = getState?.() ?? state;
    if (state !== stateBeforeCleanup) prevState = getCleanupPrevState$2(prevState, state, stateBeforeCleanup, updatedKey) ?? prevState;
  }
  const result2 = listener(state, prevState);
  if (result2) setListenerCleanup$2(group2, listener, result2);
}
function runLiveListeners$2({ group: group2, getState, prevState, updatedKey, notifiedListeners }) {
  const allKeysListeners = group2.allKeysListeners;
  for (const listener of group2.listeners) {
    if (notifiedListeners?.has(listener)) continue;
    if (!allKeysListeners?.has(listener)) {
      if (!hasUpdatedKey$2(group2.listenerKeys.get(listener), updatedKey)) continue;
    }
    notifiedListeners?.add(listener);
    notifyStoreListener$2(group2, listener, getState(), prevState, getState, updatedKey);
  }
}
function createStore$2(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let destroy = noop$1$1;
  let batchPending = false;
  let inDispatch = false;
  let updatedKeys = /* @__PURE__ */ new Set();
  const instances = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const syncListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const batchListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initializedInstances = instances.size;
    const instance = /* @__PURE__ */ Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      if (!instances.delete(instance)) return;
      if (instances.size) return;
      destroy();
    };
    if (initializedInstances) return maybeDestroy;
    const stateKeys = getKeys$2(state);
    const desyncs = [];
    for (const store2 of stores) {
      const storeState = store2?.getState?.();
      if (!storeState) continue;
      const keys2 = stateKeys.filter((key) => hasOwnProperty$2$2(storeState, key));
      if (!keys2.length) continue;
      if (stores.length === 1 || keys2.length === stateKeys.length) {
        for (const key of keys2) desyncs.push(sync$2(store2, [key], (state2) => {
          setState(key, state2[key], true);
        }));
        continue;
      }
      desyncs.push(subscribe$2(store2, keys2, (state2, prevState) => {
        for (const key of keys2) {
          if (state2[key] === prevState[key]) continue;
          setState(key, state2[key], true);
        }
      }));
      for (const key of keys2) {
        const liveState = store2?.getState?.();
        if (!liveState) continue;
        setState(key, liveState[key], true);
      }
    }
    const teardowns = [];
    for (const setup2 of setups) teardowns.push(setup2());
    const cleanups2 = stores.map(init$2);
    destroy = chain$1$1(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const deleteListenerIndexes = (group2, listener, keys2) => {
    if (keys2 === void 0) return;
    if (keys2) deleteKeyedListener$2(group2.listenersByKey, keys2, listener);
    else group2.allKeysListeners?.delete(listener);
  };
  const fastPathFrames = [];
  const registerListener = (keys2, listener, group2 = syncListenerGroup) => {
    const listenerKeysValue = keys2 ? [...keys2] : null;
    const wasRegistered = group2.listeners.has(listener);
    if (!wasRegistered) clearFastPathNotifiedListener$2(fastPathFrames, group2, listener);
    if (!listenerKeysValue) {
      if (wasRegistered) preserveFastPathFrames$2(fastPathFrames, group2);
      preserveFastPathPassedListeners$2(fastPathFrames, group2, listener);
    } else preserveFastPathPassedKeyedListeners$2({
      fastPathFrames,
      group: group2,
      keys: listenerKeysValue,
      listener
    });
    if (wasRegistered) {
      preserveFastPathFrames$2(fastPathFrames, group2, listener);
      deleteListenerIndexes(group2, listener, group2.listenerKeys.get(listener));
    }
    group2.listeners.add(listener);
    if (listenerKeysValue) {
      group2.listenersByKey ??= /* @__PURE__ */ new Map();
      addKeyedListener$2(group2.listenersByKey, listenerKeysValue, listener);
      addFastPathKeyedListener$2({
        fastPathFrames,
        group: group2,
        keys: listenerKeysValue,
        listener
      });
    } else {
      group2.allKeysListeners ??= /* @__PURE__ */ new Set();
      group2.allKeysListeners.add(listener);
    }
    group2.listenerKeys.set(listener, listenerKeysValue);
    return () => {
      const cleanup = group2.disposables.get(listener);
      group2.disposables.delete(listener);
      preserveFastPathFrames$2(fastPathFrames, group2, listener);
      const currentKeys = group2.listenerKeys.get(listener);
      deleteListenerIndexes(group2, listener, listenerKeysValue);
      if (currentKeys !== listenerKeysValue) deleteListenerIndexes(group2, listener, currentKeys);
      group2.listenerKeys.delete(listener);
      group2.listeners.delete(listener);
      cleanup?.();
    };
  };
  const storeSubscribe = (keys2, listener) => registerListener(keys2, listener);
  const runInitialListener = (group2, listener, prevState) => {
    const shouldSuspend = group2.listeners.has(listener);
    if (shouldSuspend) {
      group2.suspendCounts ??= /* @__PURE__ */ new Map();
      const count = group2.suspendCounts.get(listener) ?? 0;
      group2.suspendCounts.set(listener, count + 1);
    }
    let cleanupPrevState;
    try {
      const stateBeforeCleanups = state;
      runPendingCleanup$2(group2, listener);
      if (state !== stateBeforeCleanups) cleanupPrevState = getCleanupPrevState$2(prevState, state, stateBeforeCleanups);
      const cleanup = listener(state, cleanupPrevState ?? prevState);
      if (cleanup) setListenerCleanup$2(group2, listener, cleanup);
    } finally {
      if (shouldSuspend) {
        const suspendCounts = group2.suspendCounts;
        const count = suspendCounts?.get(listener);
        if (count && count > 1) suspendCounts?.set(listener, count - 1);
        else suspendCounts?.delete(listener);
        if (!suspendCounts?.size) delete group2.suspendCounts;
      }
    }
  };
  const storeSync = (keys2, listener) => {
    runInitialListener(syncListenerGroup, listener, state);
    return registerListener(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    if (!batchListenerGroup.listeners.size && !inDispatch) prevStateBatch = state;
    runInitialListener(batchListenerGroup, listener, prevStateBatch);
    return registerListener(keys2, listener, batchListenerGroup);
  };
  const storePick = (keys2) => createStore$2(pick$3(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore$2(omit$1$1(state, keys2), finalStore);
  const getState = () => state;
  const runListeners = (group2, prevState, updatedKey) => {
    if (!(updatedKey instanceof Set) && !group2.allKeysListeners?.size) {
      const keyedListeners = group2.listenersByKey?.get(updatedKey);
      if (!keyedListeners) return;
      const frame = {
        group: group2,
        keyedListeners,
        updatedKey,
        currentListener: null
      };
      fastPathFrames.push(frame);
      try {
        for (const listener of keyedListeners) {
          if (frame.notifiedListeners?.has(listener)) continue;
          frame.currentListener = listener;
          frame.notifiedListeners?.add(listener);
          notifyStoreListener$2(group2, listener, state, prevState, getState, updatedKey);
          if (!group2.allKeysListeners?.size && !frame.recoverToLive) continue;
          const notifiedListeners = frame.notifiedListeners ?? getFastPathNotifiedListeners$2(frame);
          frame.notifiedListeners = notifiedListeners;
          frame.recovering = true;
          runLiveListeners$2({
            group: group2,
            getState,
            prevState,
            updatedKey,
            notifiedListeners
          });
          return;
        }
      } finally {
        fastPathFrames.pop();
      }
      return;
    }
    runLiveListeners$2({
      group: group2,
      getState,
      prevState,
      updatedKey
    });
  };
  const setState = (key, value, fromStores = false) => {
    if (!hasOwnProperty$2$2(state, key)) return;
    const currentValue = state[key];
    const nextValue = typeof value === "function" ? value(currentValue) : value;
    if (isSameValue$2(nextValue, currentValue)) return;
    const wasInDispatch = inDispatch;
    inDispatch = true;
    const prevState = state;
    const nextState = {
      ...state,
      [key]: nextValue
    };
    state = nextState;
    let superseded = false;
    try {
      if (!fromStores && stores.length) {
        for (const store2 of stores) {
          store2?.setState?.(key, nextValue);
          if (isSameValue$2(state[key], nextValue)) continue;
          superseded = true;
          break;
        }
        if (superseded) {
          let pass = 0;
          for (; pass < MAX_REPAIR_PASSES$2; pass += 1) {
            let changed = false;
            for (const store2 of stores) {
              const previousValue = state[key];
              store2?.setState?.(key, previousValue);
              if (!isSameValue$2(state[key], previousValue)) changed = true;
            }
            if (!changed) break;
          }
          if (process.env.NODE_ENV !== "production" && pass === MAX_REPAIR_PASSES$2) console.warn("Parent stores did not converge after a superseded fan-out; a parent listener may be rewriting this key in a cycle.");
        }
      }
      if (!superseded) runListeners(syncListenerGroup, state === nextState ? prevState : {
        ...state,
        [key]: prevState[key]
      }, key);
    } finally {
      inDispatch = wasInDispatch;
    }
    if (!batchListenerGroup.listeners.size) {
      if (!inDispatch) prevStateBatch = state;
      return;
    }
    updatedKeys.add(key);
    if (batchPending) return;
    batchPending = true;
    queueMicrotask(() => {
      batchPending = false;
      const snapshot = state;
      const updatedKeysSnapshot = updatedKeys;
      updatedKeys = /* @__PURE__ */ new Set();
      const prevStateBatchBefore = prevStateBatch;
      runListeners(batchListenerGroup, prevStateBatchBefore, updatedKeysSnapshot);
      if (prevStateBatch === prevStateBatchBefore) prevStateBatch = snapshot;
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "setup")(...args);
}
function init$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "init")(...args);
}
function subscribe$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "subscribe")(...args);
}
function sync$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "sync")(...args);
}
function batch$2(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "batch")(...args);
}
function omit$3(store2, ...args) {
  if (!store2) return;
  return getInternal$2(store2, "omit")(...args);
}
function mergeStore$1(...stores) {
  const initialState2 = {};
  for (const store22 of stores) {
    const nextState = store22?.getState?.();
    if (nextState) Object.assign(initialState2, nextState);
  }
  const store2 = createStore$2(initialState2, ...stores);
  return Object.assign({}, ...stores, store2);
}
function throwOnConflictingProps$2(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    const stateKey = key.replace("default", "");
    return `${stateKey[0]?.toLowerCase() || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  if (!defaultKeys.filter((key) => hasOwnProperty$2$2(storeState, key)).length) return;
  throw new Error(`Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`);
}
function getCommonParent$2(items) {
  const firstItem = items.find((item) => !!item.element);
  const lastElement = [...items].reverse().find((item) => !!item.element)?.element;
  let parentElement = firstItem?.element?.parentElement;
  if (!lastElement) return getDocument$2(parentElement).body;
  while (parentElement) {
    if (parentElement.contains(lastElement)) return parentElement;
    parentElement = parentElement.parentElement;
  }
  return getDocument$2(parentElement).body;
}
function getPrivateStore$2(store2) {
  return store2?.__unstablePrivateStore;
}
function createCollectionStore$2(props2 = {}) {
  throwOnConflictingProps$2(props2, props2.store);
  const syncState = props2.store?.getState();
  const items = defaultValue$2(props2.items, syncState?.items, props2.defaultItems, []);
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue$2(syncState?.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore$2(props2.store);
  const privateStore = createStore$2({
    items,
    renderedItems: initialState2.renderedItems
  }, syncPrivateStore);
  const collection = createStore$2(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition$2(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup$2(collection, () => init$2(privateStore));
  setup$2(privateStore, () => {
    return batch$2(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup$2(privateStore, () => {
    return batch$2(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") return () => cancelAnimationFrame(raf);
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent$2(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = {
          ...prevItem,
          ...item
        };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) itemsMap.delete(item.id);
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(item, (getItems) => privateStore.setState("items", getItems), true);
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain$1$1(registerItem(item), mergeItem(item, (getItems) => privateStore.setState("renderedItems", getItems))),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) itemsMap.set(id2, item);
      }
      return item || null;
    },
    __unstablePrivateStore: privateStore
  };
}
const NULL_ITEM$2 = { id: null };
function findFirstEnabledItem$1$2(items, excludeId) {
  return items.find((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getEnabledItems$3(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getItemsInRow$2(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function findEnabledItemId$2({ items, fromIndex, step, rowId, excludeId }) {
  for (let i2 = fromIndex; i2 >= 0 && i2 < items.length; i2 += step) {
    const item = items[i2];
    if (!item) continue;
    if (item.rowId !== rowId) continue;
    if (item.disabled) continue;
    if (excludeId != null && item.id === excludeId) continue;
    return item.id;
  }
}
function flipItems$3(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM$2] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows$1$2(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => currentRow[0]?.rowId === item.rowId);
    if (row) row.push(item);
    else rows.push([item]);
  }
  return rows;
}
function getMaxRowLength$2(array) {
  let maxLength = 0;
  for (const { length } of array) if (length > maxLength) maxLength = length;
  return maxLength;
}
function createEmptyItem$2(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows$2(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength$2(rows);
  for (const row of rows) for (let i2 = 0; i2 < maxLength; i2 += 1) {
    const item = row[i2];
    if (!item || focusShift && item.disabled) {
      const previousItem = i2 === 0 && focusShift ? findFirstEnabledItem$1$2(row) : row[i2 - 1];
      row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem$2(previousItem?.rowId);
    }
  }
  return rows;
}
function verticalizeItems$2(items) {
  const rows = groupItemsByRows$1$2(items);
  const maxLength = getMaxRowLength$2(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) for (const row of rows) {
    const item = row[i2];
    if (item) verticalized.push({
      ...item,
      rowId: item.rowId ? `${i2}` : void 0
    });
  }
  return verticalized;
}
function createCompositeStore$2(props2 = {}) {
  const syncState = props2.store?.getState();
  const collection = createCollectionStore$2(props2);
  const activeId = defaultValue$2(props2.activeId, syncState?.activeId, props2.defaultActiveId);
  const composite = createStore$2({
    ...collection.getState(),
    id: defaultValue$2(props2.id, syncState?.id) ?? `id-${Math.random().toString(36).slice(2, 8)}`,
    activeId,
    baseElement: defaultValue$2(syncState?.baseElement, null),
    includesBaseElement: defaultValue$2(props2.includesBaseElement, syncState?.includesBaseElement, activeId === null),
    moves: defaultValue$2(syncState?.moves, 0),
    orientation: defaultValue$2(props2.orientation, syncState?.orientation, "both"),
    rtl: defaultValue$2(props2.rtl, syncState?.rtl, false),
    virtualFocus: defaultValue$2(props2.virtualFocus, syncState?.virtualFocus, false),
    focusLoop: defaultValue$2(props2.focusLoop, syncState?.focusLoop, false),
    focusWrap: defaultValue$2(props2.focusWrap, syncState?.focusWrap, false),
    focusShift: defaultValue$2(props2.focusShift, syncState?.focusShift, false)
  }, collection, props2.store);
  setup$2(composite, () => sync$2(composite, ["renderedItems", "activeId"], (state) => {
    composite.setState("activeId", (activeId2) => {
      if (activeId2 !== void 0) return activeId2;
      return findFirstEnabledItem$1$2(state.renderedItems)?.id;
    });
  }));
  const getNextId = (direction = "next", options2 = {}) => {
    const defaultState = composite.getState();
    const { skip = 0, activeId: activeId2 = defaultState.activeId, focusShift = defaultState.focusShift, focusLoop = defaultState.focusLoop, focusWrap = defaultState.focusWrap, includesBaseElement = defaultState.includesBaseElement, renderedItems = defaultState.renderedItems, rtl = defaultState.rtl } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    if (!skip && !focusWrap && !includesBaseElement && activeId2 != null) {
      if (!isVerticalDirection ? true : !canShift && !renderedItems.some((item) => item.rowId != null)) {
        const activeIndex2 = renderedItems.findIndex((item) => item.id === activeId2);
        const activeItem2 = renderedItems[activeIndex2];
        if (activeItem2) {
          const step = canReverse ? -1 : 1;
          const nextId = findEnabledItemId$2({
            items: renderedItems,
            fromIndex: activeIndex2 + step,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
          if (nextId !== void 0) return nextId;
          if (!(focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical"))) return void 0;
          return findEnabledItemId$2({
            items: renderedItems,
            fromIndex: step === 1 ? 0 : renderedItems.length - 1,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
        }
      }
    }
    let items = !isVerticalDirection ? renderedItems : flatten2DArray$2(normalizeRows$2(groupItemsByRows$1$2(renderedItems), activeId2, canShift));
    items = canReverse ? reverseArray$2(items) : items;
    items = isVerticalDirection ? verticalizeItems$2(items) : items;
    if (activeId2 == null) return findFirstEnabledItem$1$2(items)?.id;
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) return findFirstEnabledItem$1$2(items)?.id;
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow$2(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$3(nextItemsInRow, activeId2);
      return (nextEnabledItemsInRow.slice(skip)[0] || nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1])?.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) return findFirstEnabledItem$1$2(flipItems$3(canWrap && !hasNullItem ? items : getItemsInRow$2(items, activeItem.rowId), activeId2, hasNullItem), activeId2)?.id;
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem$1$2(hasNullItem ? nextItemsInRow : nextItems, activeId2);
      return hasNullItem ? nextItem2?.id || null : nextItem2?.id;
    }
    const nextItem = findFirstEnabledItem$1$2(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) return null;
    return nextItem?.id;
  };
  const getNextIdFromOptions = (direction, options2) => {
    if (typeof options2 === "number") return getNextId(direction, { skip: options2 });
    return getNextId(direction, options2);
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => findFirstEnabledItem$1$2(composite.getState().renderedItems)?.id,
    last: () => findFirstEnabledItem$1$2(reverseArray$2(composite.getState().renderedItems))?.id,
    next: (options2) => getNextIdFromOptions("next", options2),
    previous: (options2) => getNextIdFromOptions("previous", options2),
    down: (options2) => getNextIdFromOptions("down", options2),
    up: (options2) => getNextIdFromOptions("up", options2)
  };
}
const findFirstEnabledItem$3 = findFirstEnabledItem$1$2;
const groupItemsByRows$3 = groupItemsByRows$1$2;
function getEnabledItem$2(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function selectTextField$2(element2, collapseToEnd = false) {
  if (isTextField$2(element2)) element2.setSelectionRange(collapseToEnd ? element2.value.length : 0, element2.value.length);
  else if (element2.isContentEditable) {
    const selection2 = getDocument$2(element2).getSelection();
    selection2?.selectAllChildren(element2);
    if (collapseToEnd) selection2?.collapseToEnd();
  }
}
const FOCUS_SILENTLY$2 = /* @__PURE__ */ Symbol("FOCUS_SILENTLY");
function focusSilently$2(element2) {
  element2[FOCUS_SILENTLY$2] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused$2(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY$2];
  delete element2[FOCUS_SILENTLY$2];
  return isSilentlyFocused;
}
function isItem$2(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var shim$2 = { exports: {} };
var useSyncExternalStoreShim_production$2 = {};
var hasRequiredUseSyncExternalStoreShim_production$2;
function requireUseSyncExternalStoreShim_production$2() {
  if (hasRequiredUseSyncExternalStoreShim_production$2) return useSyncExternalStoreShim_production$2;
  hasRequiredUseSyncExternalStoreShim_production$2 = 1;
  var React2 = React__default;
  function is2(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$2(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$1(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
  useSyncExternalStoreShim_production$2.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production$2;
}
var useSyncExternalStoreShim_development$2 = {};
var hasRequiredUseSyncExternalStoreShim_development$2;
function requireUseSyncExternalStoreShim_development$2() {
  if (hasRequiredUseSyncExternalStoreShim_development$2) return useSyncExternalStoreShim_development$2;
  hasRequiredUseSyncExternalStoreShim_development$2 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    function useSyncExternalStore$2(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$1(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    useSyncExternalStoreShim_development$2.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development$2;
}
var hasRequiredShim$2;
function requireShim$2() {
  if (hasRequiredShim$2) return shim$2.exports;
  hasRequiredShim$2 = 1;
  if (process.env.NODE_ENV === "production") {
    shim$2.exports = requireUseSyncExternalStoreShim_production$2();
  } else {
    shim$2.exports = requireUseSyncExternalStoreShim_development$2();
  }
  return shim$2.exports;
}
var shimExports$2 = requireShim$2();
const noopSubscribe$2 = () => () => {
};
function useStoreState$2(store2, keyOrSelector = identity$1$1) {
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe$2();
    return subscribe$2(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2?.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$2$2(state, key)) return;
    return state[key];
  };
  return shimExports$2.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject$2(store2, object2) {
  const objRef = React.useRef({});
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe$2();
    return subscribe$2(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const state = store2?.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$2$2(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) objRef.current = { ...obj };
    return objRef.current;
  };
  return shimExports$2.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps$2(store2, props2, key, setKey) {
  const value = hasOwnProperty$2$2(props2, key) ? props2[key] : void 0;
  const propsRef = useLiveRef$2({
    value,
    setValue: setKey ? props2[setKey] : void 0
  });
  useSafeLayoutEffect$2(() => {
    return sync$2(store2, [key], (state, prev) => {
      const { value: value2, setValue } = propsRef.current;
      if (!setValue) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect$2(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch$2(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore$2(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect$2(() => init$2(store2), [store2]);
  const useState2 = React.useCallback((keyOrSelector) => useStoreState$2(store2, keyOrSelector), [store2]);
  return [React.useMemo(() => ({
    ...store2,
    useState: useState2
  }), [store2, useState2]), useEvent$2(() => {
    setStore((store22) => createStore2({
      ...props2,
      ...store22.getState()
    }));
  })];
}
const TagName$3$2 = "button";
function isEditableElement$2(element2) {
  if (isTextbox$2(element2)) return true;
  return element2.tagName === "INPUT" && !isButton$2(element2);
}
function getNextPageOffset$2(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") return pageOffset + scrollingElement.scrollTop;
  return pageOffset;
}
function getItemOffset$2(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) return top2 + itemElement.clientHeight;
  return top2;
}
function findNextPageItemId$2(element2, store2, next, pageUp = false) {
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement$2(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset$2(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = getEnabledItem$2(store2, id2)?.element;
    if (!itemElement) continue;
    const difference = getItemOffset$2(itemElement, pageUp) - nextPageOffset;
    const absDifference = Math.abs(difference);
    if (pageUp && difference <= 0 || !pageUp && difference >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) id2 = previousId;
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem$2(event, store2) {
  if (isSelfTarget$2(event)) return false;
  return isItem$2(store2, event.target);
}
const useCompositeItem$2 = createHook$2(function useCompositeItem2({ store: store2, rowId: rowIdProp, preventScrollOnKeyDown = false, moveOnKeyPress = true, tabbable = false, getItem: getItemProp, "aria-setsize": ariaSetSizeProp, "aria-posinset": ariaPosInSetProp, ...props2 }) {
  const context = useCompositeScopedContext$2();
  store2 = store2 || context;
  const id2 = useId$3(props2.id);
  const ref = useRef(null);
  const row = useContext(CompositeRowContext$2);
  const trulyDisabled = disabledFromProps$2(props2) && !props2.accessibleWhenDisabled;
  const shouldRegisterItem = props2.shouldRegisterItem;
  const getRowId = (state) => {
    if (rowIdProp) return rowIdProp;
    if (!state) return;
    if (!row?.baseElement) return;
    if (row.baseElement !== state.baseElement) return;
    return row.id;
  };
  const { rowId, baseElement, isActiveItem, ariaSetSize, ariaPosInSet, isTabbable: isTabbable2 } = useStoreStateObject$2(store2, {
    rowId: getRowId,
    baseElement(state) {
      return state?.baseElement || void 0;
    },
    isActiveItem(state) {
      return !!state && state.activeId === id2;
    },
    ariaSetSize(state) {
      if (ariaSetSizeProp != null) return ariaSetSizeProp;
      if (!state) return;
      if (!row?.ariaSetSize) return;
      if (row.baseElement !== state.baseElement) return;
      return row.ariaSetSize;
    },
    ariaPosInSet(state) {
      if (ariaPosInSetProp != null) return ariaPosInSetProp;
      if (!state) return;
      if (!row?.ariaPosInSet) return;
      if (row.baseElement !== state.baseElement) return;
      const rowId2 = getRowId(state);
      const itemsInRow = state.renderedItems.filter((item) => item.rowId === rowId2);
      return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
    },
    isTabbable(state) {
      if (!state?.renderedItems.length) return true;
      if (state.virtualFocus) return false;
      if (tabbable) return true;
      if (state.activeId === null) return false;
      const item = store2?.item(state.activeId);
      if (item?.disabled) return true;
      if (!item?.element) return true;
      return state.activeId === id2;
    }
  });
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      id: id2 || item.id,
      rowId,
      disabled: trulyDisabled,
      children: item.element?.textContent
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [
    id2,
    rowId,
    trulyDisabled,
    getItemProp
  ]);
  const onFocusProp = props2.onFocus;
  const hasFocusedComposite = useRef(false);
  const cancelScheduledFocusRedirectRef = useRef(null);
  const onFocus = useEvent$2((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (isPortalEvent$2(event)) return;
    if (!id2) return;
    if (!store2) return;
    if (targetIsAnotherItem$2(event, store2)) return;
    const { virtualFocus, baseElement: baseElement2 } = store2.getState();
    store2.setActiveId(id2);
    if (isTextbox$2(event.currentTarget)) selectTextField$2(event.currentTarget);
    if (!virtualFocus) return;
    if (!isSelfTarget$2(event)) return;
    if (isEditableElement$2(event.currentTarget)) return;
    const redirectFocusToBaseElement = (currentTarget2, relatedTarget2, baseElement3) => {
      if (isSafari$2() && currentTarget2.hasAttribute("data-autofocus")) currentTarget2.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
      hasFocusedComposite.current = true;
      if (relatedTarget2 === baseElement3 || isItem$2(store2, relatedTarget2)) focusSilently$2(baseElement3);
      else baseElement3.focus();
    };
    if (baseElement2?.isConnected) {
      redirectFocusToBaseElement(event.currentTarget, event.relatedTarget, baseElement2);
      return;
    }
    if (shouldRegisterItem === false) return;
    const { currentTarget, relatedTarget } = event;
    const cancelScheduledFocusRedirect = () => {
      cancelScheduledFocusRedirectRef.current?.();
      cancelScheduledFocusRedirectRef.current = null;
    };
    cancelScheduledFocusRedirect();
    cancelScheduledFocusRedirectRef.current = subscribe$2(store2, null, () => {
      if (getActiveElement$2(currentTarget) !== currentTarget) {
        cancelScheduledFocusRedirect();
        return;
      }
      const state = store2.getState();
      const nextBaseElement = state.baseElement;
      if (!nextBaseElement?.isConnected) return;
      cancelScheduledFocusRedirect();
      if (!state.virtualFocus) return;
      redirectFocusToBaseElement(currentTarget, relatedTarget, nextBaseElement);
    });
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent$2((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (store2?.getState()?.virtualFocus && hasFocusedComposite.current) {
      hasFocusedComposite.current = false;
      event.preventDefault();
      event.stopPropagation();
    }
  });
  const onKeyDownProp = props2.onKeyDown;
  const preventScrollOnKeyDownProp = useBooleanEvent$2(preventScrollOnKeyDown);
  const moveOnKeyPressProp = useBooleanEvent$2(moveOnKeyPress);
  const onKeyDown = useEvent$2((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (!isSelfTarget$2(event)) return;
    if (!store2) return;
    const { currentTarget } = event;
    const state = store2.getState();
    const isGrid2 = !!store2.item(id2)?.rowId;
    const isVertical = state.orientation !== "horizontal";
    const isHorizontal = state.orientation !== "vertical";
    const canHomeEnd = () => {
      if (isGrid2) return true;
      if (isHorizontal) return true;
      if (!state.baseElement) return true;
      if (!isTextField$2(state.baseElement)) return true;
      return false;
    };
    const action = {
      ArrowUp: (isGrid2 || isVertical) && store2.up,
      ArrowRight: (isGrid2 || isHorizontal) && store2.next,
      ArrowDown: (isGrid2 || isVertical) && store2.down,
      ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
      Home: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.first();
        return store2?.previous(-1);
      },
      End: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.last();
        return store2?.next(-1);
      },
      PageUp: () => {
        return findNextPageItemId$2(currentTarget, store2, store2?.up, true);
      },
      PageDown: () => {
        return findNextPageItemId$2(currentTarget, store2, store2?.down);
      }
    }[event.key];
    if (action) {
      if (isTextbox$2(currentTarget)) {
        const selection2 = getTextboxSelection$2(currentTarget);
        const isLeft = isHorizontal && event.key === "ArrowLeft";
        const isRight = isHorizontal && event.key === "ArrowRight";
        const isUp = isVertical && event.key === "ArrowUp";
        const isDown = isVertical && event.key === "ArrowDown";
        if (isRight || isDown) {
          const { length: valueLength } = getTextboxValue$2(currentTarget);
          if (selection2.end !== valueLength) return;
        } else if ((isLeft || isUp) && selection2.start !== 0) return;
      }
      const nextId = action();
      if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(nextId);
      }
    }
  });
  const providerValue = useMemo(() => ({
    id: id2,
    baseElement
  }), [id2, baseElement]);
  props2 = useWrapElement$2(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeItemContext$2.Provider, {
    value: providerValue,
    children: element2
  }), [providerValue]);
  props2 = {
    "data-active-item": isActiveItem || void 0,
    ...props2,
    id: id2,
    ref: useMergeRefs$2(ref, props2.ref),
    tabIndex: isTabbable2 ? props2.tabIndex : -1,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useCommand$2(props2);
  props2 = useCollectionItem$2({
    store: store2,
    ...props2,
    getItem,
    shouldRegisterItem: id2 ? shouldRegisterItem : false
  });
  return removeUndefinedValues$2({
    ...props2,
    "aria-setsize": ariaSetSize,
    "aria-posinset": ariaPosInSet
  });
});
const CompositeItem$1 = memo$2(forwardRef$2(function CompositeItem2(props2) {
  return createElement$2(TagName$3$2, useCompositeItem$2(props2));
}));
const ctx$5$1 = createStoreContext$2([CompositeContextProvider$2], [CompositeScopedContextProvider$2]);
const useTabScopedContext$1 = ctx$5$1.useScopedContext;
const useTabProviderContext$1 = ctx$5$1.useProviderContext;
const TabContextProvider$1 = ctx$5$1.ContextProvider;
const TabScopedContextProvider$1 = ctx$5$1.ScopedContextProvider;
const TagName$2$2 = "button";
const useTab$1 = createHook$2(function useTab2({ store: store2, getItem: getItemProp, ...props2 }) {
  const context = useTabScopedContext$1();
  store2 = store2 || context;
  invariant$2(store2, process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component.");
  const defaultId = useId$3();
  const id2 = props2.id || defaultId;
  const dimmed = disabledFromProps$2(props2);
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      dimmed
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [dimmed, getItemProp]);
  const onClickProp = props2.onClick;
  const onClick = useEvent$2((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    store2?.setSelectedId(id2);
  });
  const panelId = useStoreState$2(store2.panels, () => store2.panel(id2)?.id);
  const shouldRegisterItem = defaultId ? props2.shouldRegisterItem : false;
  const isActive = useStoreState$2(store2, (state) => !!id2 && state.activeId === id2);
  const selected = useStoreState$2(store2, (state) => !!id2 && state.selectedId === id2);
  const hasActiveItem2 = useStoreState$2(store2, (state) => !!store2.item(state.activeId));
  const canRegisterComposedItem = isActive || selected && !hasActiveItem2;
  const accessibleWhenDisabled = selected || (props2.accessibleWhenDisabled ?? true);
  if (useStoreState$2(store2.combobox || store2.composite, "virtualFocus")) props2 = {
    ...props2,
    tabIndex: -1
  };
  props2 = {
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0,
    ...props2,
    id: id2,
    onClick
  };
  if (store2.composite) {
    const defaultProps = {
      id: id2,
      accessibleWhenDisabled,
      store: store2.composite,
      shouldRegisterItem: canRegisterComposedItem && shouldRegisterItem,
      rowId: props2.rowId,
      render: props2.render
    };
    props2 = {
      ...props2,
      render: /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeItem$1, {
        ...defaultProps,
        render: store2.combobox && store2.composite !== store2.combobox ? /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeItem$1, {
          ...defaultProps,
          store: store2.combobox
        }) : defaultProps.render
      })
    };
  }
  props2 = useCompositeItem$2({
    store: store2,
    ...props2,
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem
  });
  return props2;
});
const Tab$1 = memo$2(forwardRef$2(function Tab2(props2) {
  return createElement$2(TagName$2$2, useTab$1(props2));
}));
const TagName$1$2 = "div";
function isGrid$2(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey$2(event) {
  const target = event.target;
  if (target && !isTextField$2(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey$2(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy$2(store2, onKeyboardEvent, previousElementRef) {
  return useEvent$2((event) => {
    onKeyboardEvent?.(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget$2(event)) return;
    if (isModifierKey$2(event)) return;
    if (isPrintableKey$2(event)) return;
    const activeElement = getEnabledItem$2(store2, store2.getState().activeId)?.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    if (activeElement !== previousElementRef?.current) activeElement.focus();
    if (!fireKeyboardEvent$2(activeElement, event.type, eventInit)) event.preventDefault();
    if (event.currentTarget.contains(activeElement)) event.stopPropagation();
  });
}
function findFirstEnabledItemInTheLastRow$2(items) {
  return findFirstEnabledItem$3(flatten2DArray$2(reverseArray$2(groupItemsByRows$3(items))));
}
function withBaseScrollPreserved$2(store2, callback) {
  const { virtualFocus, baseElement } = store2.getState();
  if (!virtualFocus || !baseElement || !isTextField$2(baseElement)) {
    callback();
    return;
  }
  const savedScrollLeft = baseElement.scrollLeft;
  const savedScrollTop = baseElement.scrollTop;
  callback();
  baseElement.scrollLeft = savedScrollLeft;
  baseElement.scrollTop = savedScrollTop;
}
function useScheduleFocus$2(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = useStoreState$2(store2, (state) => scheduled ? getEnabledItem$2(store2, state.activeId) : null);
  useEffect(() => {
    const activeElement = activeItem?.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    withBaseScrollPreserved$2(store2, () => {
      activeElement.focus({ preventScroll: true });
    });
  }, [
    store2,
    activeItem,
    scheduled
  ]);
  return schedule;
}
const CompositeFocusOnMove$2 = memo$2(function CompositeFocusOnMove2({ store: store2, focusOnMove, previousElementRef }) {
  const moves = useStoreState$2(store2, "moves");
  const baseElement = useStoreState$2(store2, "baseElement");
  useEffect(() => {
    if (!moves) return;
    if (!focusOnMove) return;
    const { activeId } = store2.getState();
    const itemElement = getEnabledItem$2(store2, activeId)?.element;
    if (!itemElement) return;
    withBaseScrollPreserved$2(store2, () => focusIntoView$2(itemElement));
  }, [
    store2,
    moves,
    focusOnMove
  ]);
  useSafeLayoutEffect$2(() => {
    if (!moves) return;
    if (!baseElement) return;
    const { activeId } = store2.getState();
    if (!(activeId === null)) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (previousElement) fireBlurEvent$2(previousElement, { relatedTarget: baseElement });
    if (!hasFocus$2(baseElement)) baseElement.focus();
  }, [
    store2,
    moves,
    baseElement
  ]);
  return null;
});
const useComposite$2 = createHook$2(function useComposite2({ store: store2, composite = true, focusOnMove = composite, moveOnKeyPress = true, ...props2 }) {
  const context = useCompositeProviderContext$2();
  store2 = store2 || context;
  invariant$2(store2, process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component.");
  const ref = useRef(null);
  const previousElementRef = useRef(null);
  const scheduleFocus = useScheduleFocus$2(store2);
  const [, setBaseElement] = useTransactionState$2(composite ? store2.setBaseElement : null);
  const virtualFocus = useStoreState$2(store2, "virtualFocus");
  const activeId = useStoreState$2(store2, (state) => state.virtualFocus ? state.activeId : null);
  useSafeLayoutEffect$2(() => {
    if (!store2) return;
    if (!composite) return;
    if (!virtualFocus) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (!previousElement) return;
    const relatedTarget = getEnabledItem$2(store2, activeId)?.element || getActiveElement$2(previousElement);
    if (relatedTarget === previousElement) return;
    fireBlurEvent$2(previousElement, { relatedTarget });
  }, [
    store2,
    activeId,
    virtualFocus,
    composite
  ]);
  const onKeyDownCapture = useKeyboardEventProxy$2(store2, props2.onKeyDownCapture, previousElementRef);
  const onKeyUpCapture = useKeyboardEventProxy$2(store2, props2.onKeyUpCapture, previousElementRef);
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent$2((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (!virtualFocus2) return;
    const previousActiveElement = event.relatedTarget;
    const isSilentlyFocused = silentlyFocused$2(event.currentTarget);
    if (isSelfTarget$2(event) && isSilentlyFocused) {
      event.stopPropagation();
      previousElementRef.current = previousActiveElement;
    }
  });
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent$2((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (!composite) return;
    if (!store2) return;
    const { relatedTarget } = event;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (virtualFocus2) {
      if (isSelfTarget$2(event) && !isItem$2(store2, relatedTarget)) queueMicrotask(scheduleFocus);
    } else if (isSelfTarget$2(event)) store2.setActiveId(null);
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent$2((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
    if (!virtualFocus2) return;
    const activeElement = getEnabledItem$2(store2, activeId2)?.element;
    const nextActiveElement = event.relatedTarget;
    const nextActiveElementIsItem = isItem$2(store2, nextActiveElement);
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (isSelfTarget$2(event) && nextActiveElementIsItem) {
      if (nextActiveElement === activeElement) {
        if (previousElement && previousElement !== nextActiveElement) fireBlurEvent$2(previousElement, event);
      } else if (activeElement) fireBlurEvent$2(activeElement, event);
      else if (previousElement) fireBlurEvent$2(previousElement, event);
      event.stopPropagation();
    } else if (!isItem$2(store2, event.target) && activeElement) fireBlurEvent$2(activeElement, event);
  });
  const onKeyDownProp = props2.onKeyDown;
  const moveOnKeyPressProp = useBooleanEvent$2(moveOnKeyPress);
  const onKeyDown = useEvent$2((event) => {
    onKeyDownProp?.(event);
    if (event.nativeEvent.isComposing) return;
    if (event.defaultPrevented) return;
    if (!store2) return;
    if (!isSelfTarget$2(event)) return;
    const { orientation, renderedItems, activeId: activeId2, rtl } = store2.getState();
    if (getEnabledItem$2(store2, activeId2)?.element?.isConnected) return;
    const isVertical = orientation !== "horizontal";
    const isHorizontal = orientation !== "vertical";
    const grid = isGrid$2(renderedItems);
    if ((event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End") && isTextField$2(event.currentTarget)) return;
    const up = () => {
      if (grid) return findFirstEnabledItemInTheLastRow$2(renderedItems)?.id;
      return store2?.last();
    };
    const action = {
      ArrowUp: (grid || isVertical) && up,
      ArrowRight: (grid || isHorizontal) && (rtl ? store2.last : store2.first),
      ArrowDown: (grid || isVertical) && store2.first,
      ArrowLeft: (grid || isHorizontal) && (rtl ? store2.first : store2.last),
      Home: store2.first,
      End: store2.last,
      PageUp: store2.first,
      PageDown: store2.last
    }[event.key];
    if (action) {
      const id2 = action();
      if (id2 !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(id2);
      }
    }
  });
  props2 = useWrapElement$2(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsxs(CompositeScopedContextProvider$2, {
    value: store2,
    children: [element2, composite && /* @__PURE__ */ jsxRuntimeExports$2.jsx(CompositeFocusOnMove$2, {
      store: store2,
      focusOnMove,
      previousElementRef
    })]
  }), [
    store2,
    composite,
    focusOnMove
  ]);
  props2 = {
    "aria-activedescendant": useStoreState$2(store2, (state) => {
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return getEnabledItem$2(store2, state.activeId)?.id;
    }),
    ...props2,
    ref: useMergeRefs$2(ref, setBaseElement, props2.ref),
    onKeyDownCapture,
    onKeyUpCapture,
    onFocusCapture,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useFocusable$2({
    focusable: useStoreState$2(store2, (state) => composite && (state.virtualFocus || state.activeId === null)),
    ...props2
  });
  return props2;
});
forwardRef$2(function Composite2(props2) {
  return createElement$2(TagName$1$2, useComposite$2(props2));
});
const TagName$E = "div";
const useTabList$1 = createHook$2(function useTabList2({ store: store2, ...props2 }) {
  const context = useTabProviderContext$1();
  store2 = store2 || context;
  invariant$2(store2, process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component.");
  const orientation = useStoreState$2(store2, (state) => state.orientation === "both" ? void 0 : state.orientation);
  props2 = useWrapElement$2(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$2.jsx(TabScopedContextProvider$1, {
    value: store2,
    children: element2
  }), [store2]);
  if (store2.composite) props2 = {
    focusable: false,
    ...props2
  };
  props2 = {
    role: "tablist",
    "aria-orientation": orientation,
    ...props2
  };
  props2 = useComposite$2({
    store: store2,
    ...props2
  });
  return props2;
});
const TabList$1 = forwardRef$2(function TabList2(props2) {
  return createElement$2(TagName$E, useTabList$1(props2));
});
const ctx$4$1 = createStoreContext$2();
const DisclosureContextProvider$1 = ctx$4$1.ContextProvider;
const DisclosureScopedContextProvider$1 = ctx$4$1.ScopedContextProvider;
const ctx$3$2 = createStoreContext$2([DisclosureContextProvider$1], [DisclosureScopedContextProvider$1]);
const DialogContextProvider$1 = ctx$3$2.ContextProvider;
const DialogScopedContextProvider$1 = ctx$3$2.ScopedContextProvider;
createContext(void 0);
createContext(void 0);
const ctx$2$2 = createStoreContext$2([DialogContextProvider$1], [DialogScopedContextProvider$1]);
const PopoverContextProvider$1 = ctx$2$2.ContextProvider;
const PopoverScopedContextProvider$1 = ctx$2$2.ScopedContextProvider;
createContext(void 0);
const ctx$1$2 = createStoreContext$2([PopoverContextProvider$1, CompositeContextProvider$2], [PopoverScopedContextProvider$1, CompositeScopedContextProvider$2]);
const useComboboxContext$1 = ctx$1$2.useContext;
createContext(void 0);
createContext(false);
function useCollectionStoreProps$2(store2, update, props2) {
  useUpdateEffect$2(update, [props2.store]);
  useStoreProps$2(store2, props2, "items", "setItems");
  return store2;
}
function useCompositeStoreProps$2(store2, update, props2) {
  store2 = useCollectionStoreProps$2(store2, update, props2);
  useStoreProps$2(store2, props2, "activeId", "setActiveId");
  useStoreProps$2(store2, props2, "includesBaseElement");
  useStoreProps$2(store2, props2, "virtualFocus");
  useStoreProps$2(store2, props2, "orientation");
  useStoreProps$2(store2, props2, "rtl");
  useStoreProps$2(store2, props2, "focusLoop");
  useStoreProps$2(store2, props2, "focusWrap");
  useStoreProps$2(store2, props2, "focusShift");
  return store2;
}
const ctx$b = createStoreContext$2([PopoverContextProvider$1, CompositeContextProvider$2], [PopoverScopedContextProvider$1, CompositeScopedContextProvider$2]);
const useSelectContext$1 = ctx$b.useContext;
createContext(false);
createContext(null);
function getFocusedTab$1(items) {
  const activeElement = items[0]?.element?.ownerDocument.activeElement;
  if (!activeElement) return;
  return items.find((item) => item.element === activeElement);
}
function getTabById$1(items, id2) {
  if (id2 == null) return;
  return items.find((item) => item.id === id2);
}
function isEnabledTab$1(item) {
  if (!item) return false;
  if (item.disabled) return false;
  if (item.dimmed) return false;
  return true;
}
function createPanelsStore$1() {
  const panels = createCollectionStore$2();
  const panelsByTabId = /* @__PURE__ */ new Map();
  sync$2(panels, ["items"], (state) => {
    panelsByTabId.clear();
    for (const panel of state.items) {
      const { tabId } = panel;
      if (tabId == null) continue;
      if (panelsByTabId.has(tabId)) continue;
      panelsByTabId.set(tabId, panel);
    }
  });
  return {
    panels,
    panel: (tabId) => {
      if (tabId == null) return null;
      return panelsByTabId.get(tabId) || null;
    }
  };
}
function createTabStore$1({ composite: parentComposite, combobox, ...props2 } = {}) {
  const independentKeys = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "virtualFocus",
    "includesBaseElement",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ];
  const store2 = mergeStore$1(props2.store, omit$3(parentComposite, independentKeys), omit$3(combobox, independentKeys));
  const syncState = store2?.getState();
  const composite = createCompositeStore$2({
    ...props2,
    store: store2,
    includesBaseElement: defaultValue$2(props2.includesBaseElement, syncState?.includesBaseElement, false),
    orientation: defaultValue$2(props2.orientation, syncState?.orientation, "horizontal"),
    focusLoop: defaultValue$2(props2.focusLoop, syncState?.focusLoop, true)
  });
  const { panels, panel } = createPanelsStore$1();
  const tab2 = createStore$2({
    ...composite.getState(),
    selectedId: defaultValue$2(props2.selectedId, syncState?.selectedId, props2.defaultSelectedId),
    selectOnMove: defaultValue$2(props2.selectOnMove, syncState?.selectOnMove, true)
  }, composite, store2);
  setup$2(tab2, () => sync$2(tab2, ["moves"], () => {
    const { activeId, selectOnMove } = tab2.getState();
    if (!selectOnMove) return;
    if (!activeId) return;
    const tabItem = composite.item(activeId);
    if (!isEnabledTab$1(tabItem)) return;
    tab2.setState("selectedId", tabItem.id);
  }));
  let pendingRestore = false;
  let restoredSelectedId;
  setup$2(tab2, () => {
    pendingRestore = false;
    return batch$2(tab2, ["selectedId"], (state, prev) => {
      if (pendingRestore) {
        pendingRestore = false;
        if (state.selectedId === restoredSelectedId) return;
      }
      if (parentComposite && state.selectedId === prev.selectedId) return;
      const { activeId, renderedItems } = tab2.getState();
      const focusedTab = getFocusedTab$1(renderedItems);
      const selectedTab = getTabById$1(renderedItems, state.selectedId);
      if (focusedTab && isEnabledTab$1(selectedTab) && activeId !== selectedTab.id) {
        composite.move(selectedTab.id);
        return;
      }
      tab2.setState("activeId", state.selectedId);
    });
  });
  setup$2(tab2, () => sync$2(tab2, ["selectedId", "renderedItems"], (state) => {
    if (state.selectedId !== void 0) return;
    const { activeId, renderedItems } = tab2.getState();
    const tabItem = composite.item(activeId);
    if (isEnabledTab$1(tabItem)) tab2.setState("selectedId", tabItem.id);
    else {
      const tabItem2 = renderedItems.find(isEnabledTab$1);
      tab2.setState("selectedId", tabItem2?.id);
    }
  }));
  setup$2(tab2, () => sync$2(tab2, ["renderedItems"], (state) => {
    const tabs = state.renderedItems;
    if (!tabs.length) return;
    return sync$2(panels, ["renderedItems"], (state2) => {
      const items = state2.renderedItems;
      if (!items.some((panel2) => !panel2.tabId)) return;
      items.forEach((panel2, i2) => {
        if (panel2.tabId) return;
        const tabItem = tabs[i2];
        if (!tabItem) return;
        panels.renderItem({
          ...panel2,
          tabId: tabItem.id
        });
      });
    });
  }));
  let selectedIdFromSelectedValue = null;
  setup$2(tab2, () => {
    const backupSelectedId = () => {
      selectedIdFromSelectedValue = tab2.getState().selectedId;
    };
    const restoreSelectedId = () => {
      const { selectedId } = tab2.getState();
      if (selectedId === selectedIdFromSelectedValue) return;
      pendingRestore = true;
      restoredSelectedId = selectedIdFromSelectedValue;
      tab2.setState("selectedId", selectedIdFromSelectedValue);
    };
    if (parentComposite && "setSelectElement" in parentComposite) return chain$1$1(sync$2(parentComposite, ["value"], backupSelectedId), sync$2(parentComposite, ["mounted"], restoreSelectedId));
    if (!combobox) return;
    return chain$1$1(sync$2(combobox, ["selectedValue"], backupSelectedId), sync$2(combobox, ["mounted"], restoreSelectedId));
  });
  return {
    ...composite,
    ...tab2,
    panels,
    panel,
    setSelectedId: (id2) => tab2.setState("selectedId", id2),
    select: (id2) => {
      tab2.setState("selectedId", id2);
      composite.move(id2);
    }
  };
}
function useTabStoreProps$1(store2, update, props2) {
  useUpdateEffect$2(update, [props2.composite, props2.combobox]);
  store2 = useCompositeStoreProps$2(store2, update, props2);
  useStoreProps$2(store2, props2, "selectedId", "setSelectedId");
  useStoreProps$2(store2, props2, "selectOnMove");
  const [panels, updatePanels] = useStore$2(() => store2.panels, {});
  useUpdateEffect$2(updatePanels, [store2, updatePanels]);
  return Object.assign(useMemo(() => ({
    ...store2,
    panels
  }), [store2, panels]), {
    composite: props2.composite,
    combobox: props2.combobox
  });
}
function useTabStore$1(props2 = {}) {
  const combobox = useComboboxContext$1();
  const composite = useSelectContext$1() || combobox;
  props2 = {
    ...props2,
    composite: props2.composite !== void 0 ? props2.composite : composite,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  const [store2, update] = useStore$2(createTabStore$1, props2);
  return useTabStoreProps$1(store2, update, props2);
}
function TabProvider$1(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$2.jsx(TabContextProvider$1, {
    value: useTabStore$1(props2),
    children: props2.children
  });
}
function ManagedKeyboard({ onClick }) {
  const [style, setStyle] = React__default.useState("numeric");
  const store2 = useTabStore$1();
  const storeState = store2.useState();
  React__default.useEffect(() => {
    if (!storeState.activeId) {
      return;
    }
    if (style !== storeState.activeId) {
      if (["alpha_lower", "alpha_upper"].includes(storeState.activeId) && ["alpha_lower", "alpha_upper"].includes(style)) {
        return;
      }
      if (["greek_lower", "greek_upper"].includes(storeState.activeId) && ["greek_lower", "greek_upper"].includes(style)) {
        return;
      }
      setStyle(storeState.activeId);
    }
  }, [storeState, style]);
  const wrappedOnClick = React__default.useCallback(
    (e2) => {
      const firstPress = e2[0];
      if (!firstPress) {
        return;
      }
      if (firstPress.type === "cmd" && firstPress.command === "Shift") {
        switch (style) {
          case "alpha_lower":
            setStyle("alpha_upper");
            break;
          case "alpha_upper":
            setStyle("alpha_lower");
            break;
          case "greek_lower":
            setStyle("greek_upper");
            break;
          case "greek_upper":
            setStyle("greek_lower");
            break;
        }
        return;
      }
      onClick(e2);
    },
    [style]
  );
  return /* @__PURE__ */ React__default.createElement(TabProvider$1, null, /* @__PURE__ */ React__default.createElement(TabList$1, { className: "virtual-keyboard-tab-list" }, /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "numeric" }, "123"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "function" }, "f(x)"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "alpha_lower" }, "ABC"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "greek_lower" }, "αβγ"), /* @__PURE__ */ React__default.createElement(Tab$1, { store: store2, id: "symbol" }, "$%∞")), /* @__PURE__ */ React__default.createElement(Keyboard, { style, onClick: wrappedOnClick }));
}
var classnames$1 = { exports: {} };
var hasRequiredClassnames$1;
function requireClassnames$1() {
  if (hasRequiredClassnames$1) return classnames$1.exports;
  hasRequiredClassnames$1 = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames$1);
  return classnames$1.exports;
}
var classnamesExports$1 = requireClassnames$1();
const classNames$1 = /* @__PURE__ */ getDefaultExportFromCjs$1$1(classnamesExports$1);
const KeyboardIcon = () => /* @__PURE__ */ React__default.createElement(
  "svg",
  {
    stroke: "currentColor",
    fill: "currentColor",
    strokeWidth: "0",
    viewBox: "0 0 576 512",
    "aria-hidden": "true",
    focusable: "false",
    height: "1em",
    width: "1em",
    xmlns: "http://www.w3.org/2000/svg"
  },
  /* @__PURE__ */ React__default.createElement("path", { d: "M528 448H48c-26.51 0-48-21.49-48-48V112c0-26.51 21.49-48 48-48h480c26.51 0 48 21.49 48 48v288c0 26.51-21.49 48-48 48zM128 180v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm-336 96v-40c0-6.627-5.373-12-12-12H76c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12zm288 0v-40c0-6.627-5.373-12-12-12H172c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h232c6.627 0 12-5.373 12-12zm96 0v-40c0-6.627-5.373-12-12-12h-40c-6.627 0-12 5.373-12 12v40c0 6.627 5.373 12 12 12h40c6.627 0 12-5.373 12-12z" })
);
function KeyboardTray({
  onClick,
  theme: theme2
}) {
  const [open, setOpen] = React__default.useState(false);
  return createPortal(
    /* @__PURE__ */ React__default.createElement(
      "div",
      {
        id: "virtual-keyboard-tray",
        "data-theme": theme2,
        className: classNames$1({ open }),
        onMouseDown: () => {
          onClick([
            { type: "accessed", command: "", timestamp: +/* @__PURE__ */ new Date() }
          ]);
        },
        onClick: () => {
          onClick([
            { type: "accessed", command: "", timestamp: +/* @__PURE__ */ new Date() }
          ]);
        }
      },
      /* @__PURE__ */ React__default.createElement(
        "button",
        {
          className: "open-keyboard-button",
          onClick: () => setOpen((old) => !old),
          title: open ? "Close Keyboard" : "Open Keyboard",
          "aria-label": open ? "Close Keyboard" : "Open Keyboard"
        },
        /* @__PURE__ */ React__default.createElement(KeyboardIcon, null)
      ),
      /* @__PURE__ */ React__default.createElement("div", { className: "keyboard-container" }, /* @__PURE__ */ React__default.createElement(
        "button",
        {
          className: "close-keyboard-button",
          onClick: () => setOpen(false),
          title: "Close Keyboard",
          "aria-label": "Close Keyboard"
        },
        "×"
      ), /* @__PURE__ */ React__default.createElement(ManagedKeyboard, { onClick }))
    ),
    document.body
  );
}
const DEFAULT_MATHJAX_SRC = "https://cdn.jsdelivr.net/npm/mathjax@4.1.3/tex-mml-chtml.js";
const GLOBAL_PROMISE_KEY = "__doenetMathJaxPromise";
const DOENET_MATHJAX_SCRIPT_ATTR = "data-doenet-mathjax";
const MATHJAX_SRC_PATTERN = /mathjax|tex-(chtml|mml|svg)|mml-chtml/i;
const DEFAULT_TIMEOUT_MS = 3e4;
function isMathJaxEngine(candidate) {
  if (!candidate || typeof candidate !== "object") {
    return false;
  }
  const startup = candidate.startup;
  return !!startup && (typeof startup === "object" || typeof startup === "function") && typeof startup.promise?.then === "function";
}
function findMathJaxScript() {
  const scripts = document.querySelectorAll("script[src]");
  for (const script of scripts) {
    if (script.hasAttribute(DOENET_MATHJAX_SCRIPT_ATTR)) {
      continue;
    }
    if (MATHJAX_SRC_PATTERN.test(script.src)) {
      return script;
    }
  }
  return null;
}
function waitForExistingMathJax(timeoutMs) {
  return new Promise((resolve, reject2) => {
    const deadline = Date.now() + timeoutMs;
    function poll() {
      const mathJax = window.MathJax;
      if (isMathJaxEngine(mathJax)) {
        resolve(mathJax);
        return;
      }
      if (Date.now() > deadline) {
        reject2(
          new Error(
            "DoenetViewer: timed out waiting for a host-provided MathJax"
          )
        );
        return;
      }
      window.setTimeout(poll, 50);
    }
    poll();
  });
}
function injectMathJax(src, config2, { force = false } = {}) {
  return new Promise((resolve, reject2) => {
    if (config2 && (force || window.MathJax == null)) {
      window.MathJax = config2;
    }
    const script = document.createElement("script");
    script.type = "text/javascript";
    script.src = src;
    script.async = true;
    script.setAttribute(DOENET_MATHJAX_SCRIPT_ATTR, "true");
    script.addEventListener("load", () => {
      resolve(window.MathJax);
    });
    script.addEventListener("error", () => {
      reject2(
        new Error(`DoenetViewer: failed to load MathJax from ${src}`)
      );
    });
    document.head.appendChild(script);
  });
}
function createMathJaxPromise(options2) {
  const {
    config: config2,
    src = DEFAULT_MATHJAX_SRC,
    useExistingMathJax = false,
    timeoutMs = DEFAULT_TIMEOUT_MS
  } = options2;
  if (isMathJaxEngine(window.MathJax)) {
    return Promise.resolve(window.MathJax);
  }
  if (useExistingMathJax || findMathJaxScript()) {
    return waitForExistingMathJax(timeoutMs).catch((reason) => {
      console.warn(
        "DoenetViewer: a host-provided MathJax did not become usable in time; falling back to loading Doenet's own copy.",
        reason
      );
      return injectMathJax(src, config2, { force: true });
    });
  }
  return injectMathJax(src, config2);
}
function loadMathJax(options2 = {}) {
  if (typeof window === "undefined") {
    return Promise.reject(
      new Error("MathJax can only be loaded in a browser environment")
    );
  }
  const cached = window[GLOBAL_PROMISE_KEY];
  if (cached) {
    return cached;
  }
  const promise = createMathJaxPromise(options2);
  window[GLOBAL_PROMISE_KEY] = promise;
  promise.catch(() => {
    const store2 = window;
    if (store2[GLOBAL_PROMISE_KEY] === promise) {
      delete store2[GLOBAL_PROMISE_KEY];
    }
  });
  return promise;
}
function MathJaxContext({
  config: config2,
  src,
  useExistingMathJax,
  timeoutMs,
  version: version2 = 4,
  children
}) {
  const value = useMemo(() => {
    const promise = loadMathJax({
      config: config2,
      src,
      useExistingMathJax,
      timeoutMs
    });
    return { version: version2, promise };
  }, [config2, src, useExistingMathJax, timeoutMs, version2]);
  return /* @__PURE__ */ React__default.createElement(MathJaxBaseContext.Provider, { value }, children);
}
var commonjsGlobal$1 = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs$2(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var colorName$1$1;
var hasRequiredColorName$1;
function requireColorName$1() {
  if (hasRequiredColorName$1) return colorName$1$1;
  hasRequiredColorName$1 = 1;
  colorName$1$1 = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  return colorName$1$1;
}
var colorNameExports$1 = requireColorName$1();
const colorName$2 = /* @__PURE__ */ getDefaultExportFromCjs$2(colorNameExports$1);
var nearestColor$2$1 = { exports: {} };
var nearestColor$1$1 = nearestColor$2$1.exports;
var hasRequiredNearestColor$1;
function requireNearestColor$1() {
  if (hasRequiredNearestColor$1) return nearestColor$2$1.exports;
  hasRequiredNearestColor$1 = 1;
  (function(module) {
    (function(context) {
      function nearestColor2(needle, colors) {
        needle = parseColor(needle);
        if (!needle) {
          return null;
        }
        var distanceSq, minDistanceSq = Infinity, rgb, value;
        colors || (colors = nearestColor2.DEFAULT_COLORS);
        for (var i2 = 0; i2 < colors.length; ++i2) {
          rgb = colors[i2].rgb;
          distanceSq = Math.pow(needle.r - rgb.r, 2) + Math.pow(needle.g - rgb.g, 2) + Math.pow(needle.b - rgb.b, 2);
          if (distanceSq < minDistanceSq) {
            minDistanceSq = distanceSq;
            value = colors[i2];
          }
        }
        if (value.name) {
          return {
            name: value.name,
            value: value.source,
            rgb: value.rgb,
            distance: Math.sqrt(minDistanceSq)
          };
        }
        return value.source;
      }
      nearestColor2.from = function from(availableColors) {
        var colors = mapColors(availableColors), nearestColorBase = nearestColor2;
        var matcher2 = function nearestColor3(hex) {
          return nearestColorBase(hex, colors);
        };
        matcher2.from = from;
        matcher2.or = function or2(alternateColors) {
          var extendedColors = colors.concat(mapColors(alternateColors));
          return nearestColor2.from(extendedColors);
        };
        return matcher2;
      };
      function mapColors(colors) {
        if (colors instanceof Array) {
          return colors.map(function(color) {
            return createColorSpec(color);
          });
        }
        return Object.keys(colors).map(function(name2) {
          return createColorSpec(colors[name2], name2);
        });
      }
      function parseColor(source) {
        var red, green, blue;
        if (typeof source === "object") {
          return source;
        }
        if (source in nearestColor2.STANDARD_COLORS) {
          return parseColor(nearestColor2.STANDARD_COLORS[source]);
        }
        var hexMatch = source.match(/^#?((?:[0-9a-f]{3}){1,2})$/i);
        if (hexMatch) {
          hexMatch = hexMatch[1];
          if (hexMatch.length === 3) {
            hexMatch = [
              hexMatch.charAt(0) + hexMatch.charAt(0),
              hexMatch.charAt(1) + hexMatch.charAt(1),
              hexMatch.charAt(2) + hexMatch.charAt(2)
            ];
          } else {
            hexMatch = [
              hexMatch.substring(0, 2),
              hexMatch.substring(2, 4),
              hexMatch.substring(4, 6)
            ];
          }
          red = parseInt(hexMatch[0], 16);
          green = parseInt(hexMatch[1], 16);
          blue = parseInt(hexMatch[2], 16);
          return { r: red, g: green, b: blue };
        }
        var rgbMatch = source.match(/^rgb\(\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\s*\)$/i);
        if (rgbMatch) {
          red = parseComponentValue(rgbMatch[1]);
          green = parseComponentValue(rgbMatch[2]);
          blue = parseComponentValue(rgbMatch[3]);
          return { r: red, g: green, b: blue };
        }
        throw Error('"' + source + '" is not a valid color');
      }
      function createColorSpec(input, name2) {
        var color = {};
        if (name2) {
          color.name = name2;
        }
        if (typeof input === "string") {
          color.source = input;
          color.rgb = parseColor(input);
        } else if (typeof input === "object") {
          if (input.source) {
            return createColorSpec(input.source, input.name);
          }
          color.rgb = input;
          color.source = rgbToHex(input);
        }
        return color;
      }
      function parseComponentValue(string2) {
        if (string2.charAt(string2.length - 1) === "%") {
          return Math.round(parseInt(string2, 10) * 255 / 100);
        }
        return Number(string2);
      }
      function rgbToHex(rgb) {
        return "#" + leadingZero(rgb.r.toString(16)) + leadingZero(rgb.g.toString(16)) + leadingZero(rgb.b.toString(16));
      }
      function leadingZero(value) {
        if (value.length === 1) {
          value = "0" + value;
        }
        return value;
      }
      nearestColor2.STANDARD_COLORS = {
        aqua: "#0ff",
        black: "#000",
        blue: "#00f",
        fuchsia: "#f0f",
        gray: "#808080",
        green: "#008000",
        lime: "#0f0",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        purple: "#800080",
        red: "#f00",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#fff",
        yellow: "#ff0"
      };
      nearestColor2.DEFAULT_COLORS = mapColors([
        "#f00",
        // r
        "#f80",
        // o
        "#ff0",
        // y
        "#0f0",
        // g
        "#00f",
        // b
        "#008",
        // i
        "#808"
        // v
      ]);
      nearestColor2.VERSION = "0.4.4";
      if (module && module.exports) {
        module.exports = nearestColor2;
      } else {
        context.nearestColor = nearestColor2;
      }
    })(nearestColor$1$1);
  })(nearestColor$2$1);
  return nearestColor$2$1.exports;
}
var nearestColorExports$1 = requireNearestColor$1();
const nearestColor$3 = /* @__PURE__ */ getDefaultExportFromCjs$2(nearestColorExports$1);
const canonicalColorHexByKey$1 = {
  black: "#000000",
  white: "#ffffff",
  gray: "#808080",
  red: "#ff0000",
  orange: "#ffa500",
  yellow: "#ffff00",
  green: "#008000",
  cyan: "#00ffff",
  blue: "#0000ff",
  purple: "#800080",
  pink: "#ffc0cb",
  brown: "#a52a2a"
};
const canonicalAnchorDefinitions$1 = Object.fromEntries(
  Object.entries(canonicalColorHexByKey$1).map(([canonical, hex]) => [
    canonical,
    { hex, canonical }
  ])
);
const extraAnchorDefinitions$1 = {
  silver: { hex: "#c0c0c0", canonical: "gray" },
  grayDark: { hex: "#4d4d4d", canonical: "gray" },
  grayCustom: { hex: "#757575", canonical: "gray" },
  grayLight: { hex: "#c8c8c8", canonical: "gray" },
  grayLighter: { hex: "#dcdcdc", canonical: "gray" },
  maroon: { hex: "#800000", canonical: "red" },
  redLight: { hex: "#f08080", canonical: "red" },
  redCustom: { hex: "#D4042D", canonical: "red" },
  redDark: { hex: "#8b0000", canonical: "red" },
  orangeLight: { hex: "#ffa07a", canonical: "orange" },
  orangeCustom: { hex: "#F19143", canonical: "orange" },
  orangePresetAccessible: { hex: "#a6510c", canonical: "orange" },
  orangeDark: { hex: "#ff8c00", canonical: "orange" },
  yellowLight: { hex: "#ffffe0", canonical: "yellow" },
  yellowDark: { hex: "#bdb76b", canonical: "yellow" },
  yellowgreen: { hex: "#9acd32", canonical: "green" },
  olive: { hex: "#808000", canonical: "green" },
  lime: { hex: "#00ff00", canonical: "green" },
  greenLight: { hex: "#90ee90", canonical: "green" },
  greenCustom: { hex: "#2ca02c", canonical: "green" },
  greenDark: { hex: "#006400", canonical: "green" },
  teal: { hex: "#008080", canonical: "green" },
  aqua: { hex: "#00ffff", canonical: "cyan" },
  cyanLight: { hex: "#e0ffff", canonical: "cyan" },
  cyanDark: { hex: "#008b8b", canonical: "cyan" },
  navy: { hex: "#000080", canonical: "blue" },
  blueCustom: { hex: "#648FFF", canonical: "blue" },
  bluePresetAccessible: { hex: "#1f5dff", canonical: "blue" },
  blueLight: { hex: "#add8e6", canonical: "blue" },
  blueDark: { hex: "#00008b", canonical: "blue" },
  fuchsia: { hex: "#ff00ff", canonical: "purple" },
  purpleCustom: { hex: "#644CD6", canonical: "purple" },
  purpleLight: { hex: "#dda0dd", canonical: "purple" },
  purpleDark: { hex: "#8b008b", canonical: "purple" },
  hotpink: { hex: "#ff69b4", canonical: "pink" },
  pinkDark: { hex: "#ff1493", canonical: "pink" },
  brownLight: { hex: "#deb887", canonical: "brown" },
  brownDark: { hex: "#8b4513", canonical: "brown" }
};
const anchorDefinitions$1 = {
  ...canonicalAnchorDefinitions$1,
  ...extraAnchorDefinitions$1
};
const matchColorHexByName$1 = Object.fromEntries(
  Object.entries(anchorDefinitions$1).map(([name2, definition2]) => [
    name2,
    definition2.hex
  ])
);
Object.fromEntries(
  Object.entries(anchorDefinitions$1).map(([name2, definition2]) => [
    name2,
    definition2.canonical
  ])
);
nearestColor$3.from(matchColorHexByName$1);
/* @__PURE__ */ new Set([
  ...Object.keys(colorName$2),
  "transparent",
  "currentcolor"
]);
var r$1 = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$1$1 = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, n$1 = function(r2, t222, n2) {
  return void 0 === t222 && (t222 = 0), void 0 === n2 && (n2 = Math.pow(10, t222)), Math.round(n2 * r2) / n2 + 0;
}, e$1$1 = function(r2, t222, n2) {
  return void 0 === t222 && (t222 = 0), void 0 === n2 && (n2 = 1), r2 > n2 ? n2 : r2 > t222 ? r2 : t222;
}, u$1 = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
}, a$1 = function(r2) {
  return { r: e$1$1(r2.r, 0, 255), g: e$1$1(r2.g, 0, 255), b: e$1$1(r2.b, 0, 255), a: e$1$1(r2.a) };
}, o$1$1 = function(r2) {
  return { r: n$1(r2.r), g: n$1(r2.g), b: n$1(r2.b), a: n$1(r2.a, 3) };
}, i$2 = /^#([0-9a-f]{3,8})$/i, s$1 = function(r2) {
  var t222 = r2.toString(16);
  return t222.length < 2 ? "0" + t222 : t222;
}, h$1 = function(r2) {
  var t222 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a2 = Math.max(t222, n2, e2), o2 = a2 - Math.min(t222, n2, e2), i2 = o2 ? a2 === t222 ? (n2 - e2) / o2 : a2 === n2 ? 2 + (e2 - t222) / o2 : 4 + (t222 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a2 ? o2 / a2 * 100 : 0, v: a2 / 255 * 100, a: u2 };
}, b$2 = function(r2) {
  var t222 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t222 = t222 / 360 * 6, n2 /= 100, e2 /= 100;
  var a2 = Math.floor(t222), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t222 - a2) * n2), s2 = e2 * (1 - (1 - t222 + a2) * n2), h2 = a2 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
}, g$2 = function(r2) {
  return { h: u$1(r2.h), s: e$1$1(r2.s, 0, 100), l: e$1$1(r2.l, 0, 100), a: e$1$1(r2.a) };
}, d$1 = function(r2) {
  return { h: n$1(r2.h), s: n$1(r2.s), l: n$1(r2.l), a: n$1(r2.a, 3) };
}, f$1$1 = function(r2) {
  return b$2((n2 = (t222 = r2).s, { h: t222.h, s: (n2 *= ((e2 = t222.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t222.a }));
  var t222, n2, e2;
}, c$1 = function(r2) {
  return { h: (t222 = h$1(r2)).h, s: (u2 = (200 - (n2 = t222.s)) * (e2 = t222.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t222.a };
  var t222, n2, e2, u2;
}, l$1 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p$1 = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$2 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y$2 = { string: [[function(r2) {
  var t222 = i$2.exec(r2);
  return t222 ? (r2 = t222[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: 4 === r2.length ? n$1(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : 6 === r2.length || 8 === r2.length ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: 8 === r2.length ? n$1(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t222 = v$2.exec(r2) || m$1.exec(r2);
  return t222 ? t222[2] !== t222[4] || t222[4] !== t222[6] ? null : a$1({ r: Number(t222[1]) / (t222[2] ? 100 / 255 : 1), g: Number(t222[3]) / (t222[4] ? 100 / 255 : 1), b: Number(t222[5]) / (t222[6] ? 100 / 255 : 1), a: void 0 === t222[7] ? 1 : Number(t222[7]) / (t222[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t222) {
  var n2 = l$1.exec(t222) || p$1.exec(t222);
  if (!n2) return null;
  var e2, u2, a2 = g$2({ h: (e2 = n2[1], u2 = n2[2], void 0 === u2 && (u2 = "deg"), Number(e2) * (r$1[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: void 0 === n2[5] ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f$1$1(a2);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = void 0 === o2 ? 1 : o2;
  return t$1$1(n2) && t$1$1(e2) && t$1$1(u2) ? a$1({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a2 = r2.a, o2 = void 0 === a2 ? 1 : a2;
  if (!t$1$1(n2) || !t$1$1(e2) || !t$1$1(u2)) return null;
  var i2 = g$2({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f$1$1(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a2 = r2.s, o2 = r2.v, i2 = r2.a, s2 = void 0 === i2 ? 1 : i2;
  if (!t$1$1(n2) || !t$1$1(a2) || !t$1$1(o2)) return null;
  var h2 = (function(r3) {
    return { h: u$1(r3.h), s: e$1$1(r3.s, 0, 100), v: e$1$1(r3.v, 0, 100), a: e$1$1(r3.a) };
  })({ h: Number(n2), s: Number(a2), v: Number(o2), a: Number(s2) });
  return b$2(h2);
}, "hsv"]] }, N$2 = function(r2, t222) {
  for (var n2 = 0; n2 < t222.length; n2++) {
    var e2 = t222[n2][0](r2);
    if (e2) return [e2, t222[n2][1]];
  }
  return [null, void 0];
}, x$2 = function(r2) {
  return "string" == typeof r2 ? N$2(r2.trim(), y$2.string) : "object" == typeof r2 && null !== r2 ? N$2(r2, y$2.object) : [null, void 0];
}, M$2 = function(r2, t222) {
  var n2 = c$1(r2);
  return { h: n2.h, s: e$1$1(n2.s + 100 * t222, 0, 100), l: n2.l, a: n2.a };
}, H$2 = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
}, $$2 = function(r2, t222) {
  var n2 = c$1(r2);
  return { h: n2.h, s: n2.s, l: e$1$1(n2.l + 100 * t222, 0, 100), a: n2.a };
}, j$2 = (function() {
  function r2(r3) {
    this.parsed = x$2(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return null !== this.parsed;
  }, r2.prototype.brightness = function() {
    return n$1(H$2(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H$2(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H$2(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o$1$1(this.rgba), t222 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a2 = r3.a) < 1 ? s$1(n$1(255 * a2)) : "", "#" + s$1(t222) + s$1(e2) + s$1(u2) + i2;
    var r3, t222, e2, u2, a2, i2;
  }, r2.prototype.toRgb = function() {
    return o$1$1(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o$1$1(this.rgba), t222 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t222 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t222 + ", " + n2 + ", " + e2 + ")";
    var r3, t222, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d$1(c$1(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d$1(c$1(this.rgba)), t222 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t222 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t222 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t222, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h$1(this.rgba), { h: n$1(r3.h), s: n$1(r3.s), v: n$1(r3.v), a: n$1(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w$1({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1(M$2(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1(M$2(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w$1(M$2(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1($$2(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w$1($$2(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return void 0 === r3 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return "number" == typeof r3 ? w$1({ r: (t222 = this.rgba).r, g: t222.g, b: t222.b, a: r3 }) : n$1(this.rgba.a, 3);
    var t222;
  }, r2.prototype.hue = function(r3) {
    var t222 = c$1(this.rgba);
    return "number" == typeof r3 ? w$1({ h: r3, s: t222.s, l: t222.l, a: t222.a }) : n$1(t222.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w$1(r3).toHex();
  }, r2;
})(), w$1 = function(r2) {
  return r2 instanceof j$2 ? r2 : new j$2(r2);
}, S$2 = [], k$2 = function(r2) {
  r2.forEach(function(r3) {
    S$2.indexOf(r3) < 0 && (r3(j$2, y$2), S$2.push(r3));
  });
};
var o$2 = function(o2) {
  var t222 = o2 / 255;
  return t222 < 0.04045 ? t222 / 12.92 : Math.pow((t222 + 0.055) / 1.055, 2.4);
}, t$3 = function(t222) {
  return 0.2126 * o$2(t222.r) + 0.7152 * o$2(t222.g) + 0.0722 * o$2(t222.b);
};
function a11yPlugin$1(o2) {
  o2.prototype.luminance = function() {
    return o3 = t$3(this.rgba), void 0 === (r2 = 2) && (r2 = 0), void 0 === n2 && (n2 = Math.pow(10, r2)), Math.round(n2 * o3) / n2 + 0;
    var o3, r2, n2;
  }, o2.prototype.contrast = function(r2) {
    void 0 === r2 && (r2 = "#FFF");
    var n2, a2, i2, e2, v2, u2, d2, c2 = r2 instanceof o2 ? r2 : new o2(r2);
    return e2 = this.rgba, v2 = c2.toRgb(), u2 = t$3(e2), d2 = t$3(v2), n2 = u2 > d2 ? (u2 + 0.05) / (d2 + 0.05) : (d2 + 0.05) / (u2 + 0.05), void 0 === (a2 = 2) && (a2 = 0), void 0 === i2 && (i2 = Math.pow(10, a2)), Math.floor(i2 * n2) / i2 + 0;
  }, o2.prototype.isReadable = function(o3, t222) {
    return void 0 === o3 && (o3 = "#FFF"), void 0 === t222 && (t222 = {}), this.contrast(o3) >= (e2 = void 0 === (i2 = (r2 = t222).size) ? "normal" : i2, "AAA" === (a2 = void 0 === (n2 = r2.level) ? "AA" : n2) && "normal" === e2 ? 7 : "AA" === a2 && "large" === e2 ? 3 : 4.5);
    var r2, n2, a2, i2, e2;
  };
}
function namesPlugin$1(e2, f2) {
  var a2 = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r2 = {};
  for (var d2 in a2) r2[a2[d2]] = d2;
  var l2 = {};
  e2.prototype.toName = function(f3) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var d3, i2, n2 = r2[this.toHex()];
    if (n2) return n2;
    if (null == f3 ? void 0 : f3.closest) {
      var o2 = this.toRgb(), t222 = 1 / 0, b2 = "black";
      if (!l2.length) for (var c2 in a2) l2[c2] = new e2(a2[c2]).toRgb();
      for (var g2 in a2) {
        var u2 = (d3 = o2, i2 = l2[g2], Math.pow(d3.r - i2.r, 2) + Math.pow(d3.g - i2.g, 2) + Math.pow(d3.b - i2.b, 2));
        u2 < t222 && (t222 = u2, b2 = g2);
      }
      return b2;
    }
  };
  f2.string.push([function(f3) {
    var r3 = f3.toLowerCase(), d3 = "transparent" === r3 ? "#0000" : a2[r3];
    return d3 ? new e2(d3).toRgb() : null;
  }, "name"]);
}
k$2([a11yPlugin$1, namesPlugin$1]);
let styleAttributes$1 = {
  lineColor: {
    componentType: "text",
    description: "Color used for line strokes (light mode)."
  },
  lineColorWord: {
    componentType: "text",
    description: "Human-readable name of the line color (light mode)."
  },
  lineColorDarkMode: {
    componentType: "text",
    description: "Color used for line strokes (dark mode)."
  },
  lineColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the line color (dark mode)."
  },
  lineOpacity: {
    componentType: "number",
    description: "Opacity of line strokes, 0 to 1."
  },
  lineWidth: {
    componentType: "number",
    description: "Stroke width for lines, in pixels."
  },
  lineWidthWord: {
    componentType: "text",
    description: "Human-readable name of the line width."
  },
  lineStyle: {
    componentType: "text",
    description: "Stroke style for lines.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Continuous, unbroken stroke." },
      {
        value: "dashed",
        description: "Stroke composed of evenly-spaced dashes."
      },
      {
        value: "dotted",
        description: "Stroke composed of evenly-spaced dots."
      }
    ]
  },
  lineStyleWord: {
    componentType: "text",
    description: "Human-readable name of the line style."
  },
  markerColor: {
    componentType: "text",
    description: "Color used for markers/points (light mode)."
  },
  markerColorWord: {
    componentType: "text",
    description: "Human-readable name of the marker color (light mode)."
  },
  markerColorDarkMode: {
    componentType: "text",
    description: "Color used for markers/points (dark mode)."
  },
  markerColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the marker color (dark mode)."
  },
  markerOpacity: {
    componentType: "number",
    description: "Opacity of markers/points, 0 to 1."
  },
  markerStyle: {
    componentType: "text",
    description: "Marker shape.",
    toLowerCase: true,
    validValues: [
      { value: "circle", description: "Circular marker." },
      { value: "square", description: "Square marker." },
      {
        value: "triangle",
        description: 'Triangular marker pointing up (alias for "triangleUp").'
      },
      {
        value: "triangleUp",
        description: "Triangular marker pointing up."
      },
      {
        value: "triangleDown",
        description: "Triangular marker pointing down."
      },
      {
        value: "triangleLeft",
        description: "Triangular marker pointing left."
      },
      {
        value: "triangleRight",
        description: "Triangular marker pointing right."
      },
      { value: "diamond", description: "Diamond-shaped marker." },
      { value: "cross", description: "Cross-shaped marker (×)." },
      { value: "plus", description: "Plus-shaped marker (+)." }
    ]
  },
  markerStyleWord: {
    componentType: "text",
    description: "Human-readable name of the marker style."
  },
  markerSize: {
    componentType: "number",
    description: "Marker size in pixels."
  },
  markerFilled: {
    componentType: "boolean",
    description: "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."
  },
  fillColor: {
    componentType: "text",
    description: "Fill color used inside closed shapes (light mode)."
  },
  fillColorWord: {
    componentType: "text",
    description: "Human-readable name of the fill color (light mode)."
  },
  fillColorDarkMode: {
    componentType: "text",
    description: "Fill color used inside closed shapes (dark mode)."
  },
  fillColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the fill color (dark mode)."
  },
  fillOpacity: {
    componentType: "number",
    description: "Opacity of solid fills, 0 to 1."
  },
  fillPatternOpacity: {
    componentType: "number",
    description: "Opacity of pattern fills (non-solid fillStyle), 0 to 1."
  },
  fillStyle: {
    componentType: "text",
    description: "Fill pattern used inside closed shapes.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Solid fill." },
      {
        value: "horizontal",
        description: "Horizontal line pattern."
      },
      {
        value: "vertical",
        description: "Vertical line pattern."
      },
      {
        value: "diagonal",
        description: "Diagonal line pattern (/)."
      },
      {
        value: "backDiagonal",
        description: "Back-diagonal line pattern (\\)."
      },
      {
        value: "dots",
        description: "Dots pattern."
      },
      {
        value: "diamonds",
        description: "Filled diamonds pattern."
      }
    ]
  },
  fillStyleWord: {
    componentType: "text",
    description: "Human-readable name of the fill style."
  },
  textColor: {
    componentType: "text",
    description: "Text color (light mode)."
  },
  textColorWord: {
    componentType: "text",
    description: "Human-readable name of the text color (light mode)."
  },
  textColorDarkMode: {
    componentType: "text",
    description: "Text color (dark mode)."
  },
  textColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the text color (dark mode)."
  },
  highContrastColor: {
    componentType: "text",
    description: "High-contrast accent color (light mode)."
  },
  highContrastColorWord: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (light mode)."
  },
  highContrastColorDarkMode: {
    componentType: "text",
    description: "High-contrast accent color (dark mode)."
  },
  highContrastColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (dark mode)."
  },
  backgroundColor: {
    componentType: "text",
    description: "Background color (light mode)."
  },
  backgroundColorWord: {
    componentType: "text",
    description: "Human-readable name of the background color (light mode)."
  },
  backgroundColorDarkMode: {
    componentType: "text",
    description: "Background color (dark mode)."
  },
  backgroundColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the background color (dark mode)."
  }
};
styleAttributes$1.markerStyle.validValues.filter(
  (entry) => entry.value !== "cross" && entry.value !== "plus"
);
const MARKER_OVERRIDE_KEYS$1 = [
  "markerStyle",
  "markerSize",
  "markerFilled"
];
const LINE_OVERRIDE_KEYS$1 = [
  "lineStyle",
  "lineWidth"
];
const FILL_OVERRIDE_KEYS$1 = [
  "fillOpacity",
  "fillPatternOpacity",
  "fillStyle"
];
const markerOverrideAttributes$1 = Object.fromEntries(
  MARKER_OVERRIDE_KEYS$1.map((key) => [key, styleAttributes$1[key]])
);
const lineOverrideAttributes$1 = Object.fromEntries(
  LINE_OVERRIDE_KEYS$1.map((key) => [key, styleAttributes$1[key]])
);
const fillOverrideAttributes$1 = Object.fromEntries(
  FILL_OVERRIDE_KEYS$1.map((key) => [key, styleAttributes$1[key]])
);
({
  ...markerOverrideAttributes$1,
  ...lineOverrideAttributes$1,
  ...fillOverrideAttributes$1
});
const STYLE_OVERRIDE_CATEGORIES$1 = {
  marker: markerOverrideAttributes$1,
  line: lineOverrideAttributes$1,
  fill: fillOverrideAttributes$1
};
for (const [category, group2] of Object.entries(STYLE_OVERRIDE_CATEGORIES$1)) {
  for (const [key, spec] of Object.entries(group2)) {
    if (key.toLowerCase().includes("color")) {
      throw new Error(
        `Style override category "${category}" contains color-related key "${key}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`
      );
    }
    if (key.endsWith("Opacity") && key !== "fillOpacity" && key !== "fillPatternOpacity") {
      throw new Error(
        `Style override category "${category}" contains contrast-feeding opacity key "${key}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`
      );
    }
    if (spec.componentType === "text" && !spec.toLowerCase) {
      throw new Error(
        `Style override key "${key}" in category "${category}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`
      );
    }
  }
}
var __create$1 = Object.create, __defProp$2 = Object.defineProperty, __getOwnPropDesc$1 = Object.getOwnPropertyDescriptor, __getOwnPropNames$1 = Object.getOwnPropertyNames, __getProtoOf$1 = Object.getPrototypeOf, __hasOwnProp$1 = Object.prototype.hasOwnProperty, __esmMin$1 = (t4, n2) => () => (t4 && (n2 = t4(t4 = 0)), n2), __commonJSMin$1 = (t4, n2) => () => (n2 || (t4((n2 = { exports: {} }).exports, n2), t4 = null), n2.exports), __exportAll$1 = (t4, n2) => {
  let r2 = {};
  for (var i2 in t4) __defProp$2(r2, i2, { get: t4[i2], enumerable: true });
  return __defProp$2(r2, Symbol.toStringTag, { value: `Module` }), r2;
}, __copyProps$1 = (t4, n2, r2, i2) => {
  if (n2 && typeof n2 == `object` || typeof n2 == `function`) for (var a2 = __getOwnPropNames$1(n2), o2 = 0, s2 = a2.length, c2; o2 < s2; o2++) c2 = a2[o2], !__hasOwnProp$1.call(t4, c2) && c2 !== r2 && __defProp$2(t4, c2, { get: ((t5) => n2[t5]).bind(null, c2), enumerable: !(i2 = __getOwnPropDesc$1(n2, c2)) || i2.enumerable });
  return t4;
}, __toESM$1 = (t4, n2, r2) => (r2 = t4 == null ? {} : __create$1(__getProtoOf$1(t4)), __copyProps$1(__defProp$2(r2, `default`, { value: t4, enumerable: true }), t4)), __toCommonJS$1 = (t4) => __hasOwnProp$1.call(t4, `module.exports`) ? t4[`module.exports`] : __copyProps$1(__defProp$2({}, `__esModule`, { value: true }), t4), get_tree$1 = function(t4) {
  if (t4 != null) return t4.tree === void 0 ? t4 : t4.tree;
};
function* subsets$1(t4, n2) {
  var r2 = t4.length;
  if (n2 === void 0 && (n2 = r2), n2 !== 0) {
    for (let n3 = 0; n3 < r2; n3++) yield [t4[n3]];
    if (n2 !== 1) for (let i2 = 0; i2 < r2; i2++) {
      let r3 = subsets$1(t4.slice(i2 + 1), n2 - 1);
      for (let n3 of r3) yield [t4[i2]].concat(n3);
    }
  }
}
var is_associative$1$1 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$5$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return flatten$5$1(t5);
  }), is_associative$1$1[r2]) {
    for (var a2 = [], o2 = 0; o2 < i2.length; o2++) Array.isArray(i2[o2]) && i2[o2][0] === r2 && i2[o2].length > 2 ? a2 = a2.concat(i2[o2].slice(1)) : a2.push(i2[o2]);
    i2 = a2;
  }
  return [r2].concat(i2);
}
var unflattenRight$1 = function(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenRight$1(t5);
  }), i2.length > 2 && is_associative$1$1[r2]) {
    for (var a2 = [r2, i2[0], void 0], o2 = a2, s2 = 1; s2 < i2.length - 1; s2++) o2[2] = [r2, i2[s2], void 0], o2 = o2[2];
    return o2[2] = i2[i2.length - 1], a2;
  }
  return [r2].concat(i2);
}, unflattenLeft$1 = function(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenLeft$1(t5);
  }), i2.length > 2 && is_associative$1$1[r2]) {
    for (var a2 = [r2, void 0, i2[i2.length - 1]], o2 = a2, s2 = i2.length - 2; s2 > 0; s2--) o2[1] = [r2, void 0, i2[s2]], o2 = o2[1];
    return o2[1] = i2[0], a2;
  }
  return [r2].concat(i2);
}, allChildren$1 = function(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return is_associative$1$1[n2] ? r2.reduce(function(t5, r3) {
    return Array.isArray(r3) && r3[0] === n2 ? t5.concat(allChildren$1(r3)) : t5.concat([r3]);
  }, []) : r2;
};
function _extends$3() {
  return _extends$3 = Object.assign ? Object.assign.bind() : function(t4) {
    for (var n2 = 1; n2 < arguments.length; n2++) {
      var r2 = arguments[n2];
      for (var i2 in r2) ({}).hasOwnProperty.call(r2, i2) && (t4[i2] = r2[i2]);
    }
    return t4;
  }, _extends$3.apply(null, arguments);
}
var DEFAULT_CONFIG$1 = { relTol: 1e-12, absTol: 1e-15, matrix: `Matrix`, number: `number`, numberFallback: `number`, precision: 64, predictable: false, randomSeed: null, legacySubset: false };
function getSafeProperty$1(t4, n2) {
  if (isSafeObjectProperty$1(t4, n2) || isSafeArrayProperty$1(t4, n2)) return t4[n2];
  throw isSafeMethod$1(t4, n2) ? Error(`Cannot access method "${n2}" as a property`) : t4 == null ? TypeError(`Cannot access property "${n2}": object is ${t4}`) : Error(`No access to property "` + n2 + `"`);
}
function setSafeProperty$1(t4, n2, r2) {
  if (isSafeObjectProperty$1(t4, n2) || isSafeArrayProperty$1(t4, n2)) return t4[n2] = r2, r2;
  throw Error(`No access to property "${n2}"`);
}
function isSafeObjectProperty$1(t4, n2) {
  return isPlainObject$2(t4) ? !(n2 in Object.prototype) : false;
}
function isSafeArrayProperty$1(t4, n2) {
  return Array.isArray(t4) ? typeof n2 == `number` || typeof n2 == `string` && isInteger$1$1(n2) || n2 === `length` : false;
}
function isInteger$1$1(t4) {
  return /^\d+$/.test(t4);
}
function getSafeMethod$1(t4, n2) {
  if (!isSafeMethod$1(t4, n2)) throw Error(`No access to method "` + n2 + `"`);
  return t4[n2];
}
function isSafeMethod$1(t4, n2) {
  return t4 == null || typeof t4[n2] != `function` || hasOwnProperty$1$3(t4, n2) && Object.getPrototypeOf && n2 in Object.getPrototypeOf(t4) ? false : safeNativeMethods$1.has(n2) ? true : !(n2 in Object.prototype || n2 in Function.prototype);
}
function isPlainObject$2(t4) {
  return typeof t4 == `object` && t4 && t4.constructor === Object;
}
var safeNativeMethods$1 = /* @__PURE__ */ new Set([`toString`, `valueOf`, `toLocaleString`]), ObjectWrappingMap$1 = class ObjectWrappingMap3 {
  constructor(t4) {
    this.wrappedObject = t4, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((t4) => this.has(t4)).values();
  }
  get(t4) {
    return getSafeProperty$1(this.wrappedObject, t4);
  }
  set(t4, n2) {
    return setSafeProperty$1(this.wrappedObject, t4, n2), this;
  }
  has(t4) {
    return isSafeObjectProperty$1(this.wrappedObject, t4) && t4 in this.wrappedObject;
  }
  entries() {
    return mapIterator$1(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    isSafeObjectProperty$1(this.wrappedObject, t4) && delete this.wrappedObject[t4];
  }
  clear() {
    for (var t4 of this.keys()) this.delete(t4);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}, PartitionedMap$1 = class PartitionedMap3 {
  constructor(t4, n2, r2) {
    this.a = t4, this.b = n2, this.bKeys = r2, this[Symbol.iterator] = this.entries;
  }
  get(t4) {
    return this.bKeys.has(t4) ? this.b.get(t4) : this.a.get(t4);
  }
  set(t4, n2) {
    return this.bKeys.has(t4) ? this.b.set(t4, n2) : this.a.set(t4, n2), this;
  }
  has(t4) {
    return this.b.has(t4) || this.a.has(t4);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator$1(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    return this.bKeys.has(t4) ? this.b.delete(t4) : this.a.delete(t4);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
};
function mapIterator$1(t4, n2) {
  return { next: () => {
    var r2 = t4.next();
    return r2.done ? r2 : { value: n2(r2.value), done: false };
  } };
}
function createEmptyMap$1() {
  return /* @__PURE__ */ new Map();
}
function createMap$1$1(t4) {
  if (!t4) return createEmptyMap$1();
  if (isMap$1(t4)) return t4;
  if (isObject$1$1(t4)) return new ObjectWrappingMap$1(t4);
  throw Error(`createMap can create maps from objects or Maps`);
}
function toObject$1(t4) {
  if (t4 instanceof ObjectWrappingMap$1) return t4.wrappedObject;
  var n2 = {};
  for (var r2 of t4.keys()) setSafeProperty$1(n2, r2, t4.get(r2));
  return n2;
}
function isNumber$1(t4) {
  return typeof t4 == `number`;
}
function isBigNumber$1(t4) {
  return !t4 || typeof t4 != `object` || typeof t4.constructor != `function` ? false : t4.isBigNumber === true && typeof t4.constructor.prototype == `object` && t4.constructor.prototype.isBigNumber === true || typeof t4.constructor.isDecimal == `function` && t4.constructor.isDecimal(t4) === true;
}
function isBigInt$1(t4) {
  return typeof t4 == `bigint`;
}
function isComplex$1(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isComplex === true || false;
}
function isFraction$1(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isFraction === true || false;
}
function isUnit$1(t4) {
  return t4 && t4.constructor.prototype.isUnit === true || false;
}
function isString$1(t4) {
  return typeof t4 == `string`;
}
var isArray$1 = Array.isArray;
function isMatrix$1(t4) {
  return t4 && t4.constructor.prototype.isMatrix === true || false;
}
function isCollection$1(t4) {
  return Array.isArray(t4) || isMatrix$1(t4);
}
function isDenseMatrix$1(t4) {
  return t4 && t4.isDenseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isSparseMatrix$1(t4) {
  return t4 && t4.isSparseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isRange$1(t4) {
  return t4 && t4.constructor.prototype.isRange === true || false;
}
function isIndex$1(t4) {
  return t4 && t4.constructor.prototype.isIndex === true || false;
}
function isBoolean$1$1(t4) {
  return typeof t4 == `boolean`;
}
function isResultSet$1(t4) {
  return t4 && t4.constructor.prototype.isResultSet === true || false;
}
function isHelp$1(t4) {
  return t4 && t4.constructor.prototype.isHelp === true || false;
}
function isFunction$1$1(t4) {
  return typeof t4 == `function`;
}
function isDate$1(t4) {
  return t4 instanceof Date;
}
function isRegExp$1(t4) {
  return t4 instanceof RegExp;
}
function isObject$1$1(t4) {
  return !!(t4 && typeof t4 == `object` && t4.constructor === Object && !isComplex$1(t4) && !isFraction$1(t4));
}
function isMap$1(t4) {
  return t4 ? t4 instanceof Map || t4 instanceof ObjectWrappingMap$1 || typeof t4.set == `function` && typeof t4.get == `function` && typeof t4.keys == `function` && typeof t4.has == `function` : false;
}
function isPartitionedMap$1(t4) {
  return isMap$1(t4) && isMap$1(t4.a) && isMap$1(t4.b);
}
function isObjectWrappingMap$1(t4) {
  return isMap$1(t4) && isObject$1$1(t4.wrappedObject);
}
function isNull$1$1(t4) {
  return t4 === null;
}
function isUndefined$1$1(t4) {
  return t4 === void 0;
}
function isAccessorNode$1(t4) {
  return t4 && t4.isAccessorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isArrayNode$1(t4) {
  return t4 && t4.isArrayNode === true && t4.constructor.prototype.isNode === true || false;
}
function isAssignmentNode$1(t4) {
  return t4 && t4.isAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isBlockNode$1(t4) {
  return t4 && t4.isBlockNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConditionalNode$1(t4) {
  return t4 && t4.isConditionalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConstantNode$1(t4) {
  return t4 && t4.isConstantNode === true && t4.constructor.prototype.isNode === true || false;
}
function rule2Node$1(t4) {
  return isConstantNode$1(t4) || isOperatorNode$1(t4) && t4.args.length === 1 && isConstantNode$1(t4.args[0]) && `-+~`.includes(t4.op);
}
function isFunctionAssignmentNode$1(t4) {
  return t4 && t4.isFunctionAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isFunctionNode$1(t4) {
  return t4 && t4.isFunctionNode === true && t4.constructor.prototype.isNode === true || false;
}
function isIndexNode$1(t4) {
  return t4 && t4.isIndexNode === true && t4.constructor.prototype.isNode === true || false;
}
function isNode$4(t4) {
  return t4 && t4.isNode === true && t4.constructor.prototype.isNode === true || false;
}
function isObjectNode$1(t4) {
  return t4 && t4.isObjectNode === true && t4.constructor.prototype.isNode === true || false;
}
function isOperatorNode$1(t4) {
  return t4 && t4.isOperatorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isParenthesisNode$1(t4) {
  return t4 && t4.isParenthesisNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRangeNode$1(t4) {
  return t4 && t4.isRangeNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRelationalNode$1(t4) {
  return t4 && t4.isRelationalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isSymbolNode$1(t4) {
  return t4 && t4.isSymbolNode === true && t4.constructor.prototype.isNode === true || false;
}
function isChain$1(t4) {
  return t4 && t4.constructor.prototype.isChain === true || false;
}
function typeOf$1(t4) {
  var n2 = typeof t4;
  return n2 === `object` ? t4 === null ? `null` : isBigNumber$1(t4) ? `BigNumber` : t4.constructor && t4.constructor.name ? t4.constructor.name : `Object` : n2;
}
function clone$3$1(t4) {
  var n2 = typeof t4;
  if (n2 === `number` || n2 === `bigint` || n2 === `string` || n2 === `boolean` || t4 == null) return t4;
  if (typeof t4.clone == `function`) return t4.clone();
  if (Array.isArray(t4)) return t4.map(function(t5) {
    return clone$3$1(t5);
  });
  if (t4 instanceof Date) return new Date(t4.valueOf());
  if (isBigNumber$1(t4)) return t4;
  if (isObject$1$1(t4)) return mapObject$1$1(t4, clone$3$1);
  if (n2 === `function`) return t4;
  throw TypeError(`Cannot clone: unknown type of value (value: ${t4})`);
}
function mapObject$1$1(t4, n2) {
  var r2 = {};
  for (var i2 in t4) hasOwnProperty$1$3(t4, i2) && (r2[i2] = n2(t4[i2]));
  return r2;
}
function extend$1$2(t4, n2) {
  for (var r2 in n2) hasOwnProperty$1$3(n2, r2) && (t4[r2] = n2[r2]);
  return t4;
}
function deepExtend$1(t4, n2) {
  if (Array.isArray(n2)) throw TypeError(`Arrays are not supported by deepExtend`);
  for (var r2 in n2) if (hasOwnProperty$1$3(n2, r2) && !(r2 in Object.prototype) && !(r2 in Function.prototype)) if (n2[r2] && n2[r2].constructor === Object) t4[r2] === void 0 && (t4[r2] = {}), t4[r2] && t4[r2].constructor === Object ? deepExtend$1(t4[r2], n2[r2]) : t4[r2] = n2[r2];
  else if (Array.isArray(n2[r2])) throw TypeError(`Arrays are not supported by deepExtend`);
  else t4[r2] = n2[r2];
  return t4;
}
function deepStrictEqual$1(t4, n2) {
  var r2, i2, a2;
  if (Array.isArray(t4)) {
    if (!Array.isArray(n2) || t4.length !== n2.length) return false;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) if (!deepStrictEqual$1(t4[i2], n2[i2])) return false;
    return true;
  } else if (typeof t4 == `function`) return t4 === n2;
  else if (t4 instanceof Object) {
    if (Array.isArray(n2) || !(n2 instanceof Object)) return false;
    for (r2 in t4) if (!(r2 in n2) || !deepStrictEqual$1(t4[r2], n2[r2])) return false;
    for (r2 in n2) if (!(r2 in t4)) return false;
    return true;
  } else return t4 === n2;
}
function deepFlatten$1(t4) {
  var n2 = {};
  return _deepFlatten$1(t4, n2), n2;
}
function _deepFlatten$1(t4, n2) {
  for (var r2 in t4) if (hasOwnProperty$1$3(t4, r2)) {
    var i2 = t4[r2];
    typeof i2 == `object` && i2 ? _deepFlatten$1(i2, n2) : n2[r2] = i2;
  }
}
function lazy$1(t4, n2, r2) {
  var i2 = true, a2;
  Object.defineProperty(t4, n2, { get: function() {
    return i2 &&= (a2 = r2(), false), a2;
  }, set: function(t5) {
    a2 = t5, i2 = false;
  }, configurable: true, enumerable: true });
}
function hasOwnProperty$1$3(t4, n2) {
  return t4 && Object.hasOwnProperty.call(t4, n2);
}
function isLegacyFactory$1(t4) {
  return t4 && typeof t4.factory == `function`;
}
function pickShallow$1(t4, n2) {
  for (var r2 = {}, i2 = 0; i2 < n2.length; i2++) {
    var a2 = n2[i2], o2 = t4[a2];
    o2 !== void 0 && (r2[a2] = o2);
  }
  return r2;
}
var MATRIX_OPTIONS$1 = [`Matrix`, `Array`], NUMBER_OPTIONS$1 = [`number`, `BigNumber`, `bigint`, `Fraction`];
function configFactory$1(t4, n2) {
  function r2(i2) {
    if (i2) {
      if (i2.epsilon !== void 0) {
        console.warn(`Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.`);
        var a2 = clone$3$1(i2);
        return a2.relTol = i2.epsilon, a2.absTol = i2.epsilon * 1e-3, delete a2.epsilon, r2(a2);
      }
      i2.legacySubset === true && console.warn(`Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.`);
      var o2 = clone$3$1(t4);
      validateOption$1(i2, `matrix`, MATRIX_OPTIONS$1), validateOption$1(i2, `number`, NUMBER_OPTIONS$1), deepExtend$1(t4, i2);
      var s2 = clone$3$1(t4);
      return n2(`config`, s2, o2, clone$3$1(i2)), s2;
    } else return clone$3$1(t4);
  }
  return r2.MATRIX_OPTIONS = MATRIX_OPTIONS$1, r2.NUMBER_OPTIONS = NUMBER_OPTIONS$1, Object.keys(DEFAULT_CONFIG$1).forEach((n3) => {
    Object.defineProperty(r2, n3, { get: () => t4[n3], enumerable: true, configurable: true });
  }), r2;
}
function validateOption$1(t4, n2, r2) {
  t4[n2] !== void 0 && !r2.includes(t4[n2]) && console.warn(`Warning: Unknown value "` + t4[n2] + `" for configuration option "` + n2 + `". Available options: ` + r2.map((t5) => JSON.stringify(t5)).join(`, `) + `.`);
}
var require_typed_function$1 = __commonJSMin$1(((t4, n2) => {
  (function(r2, i2) {
    typeof t4 == `object` && n2 !== void 0 ? n2.exports = i2() : typeof define == `function` && define.amd ? define(i2) : (r2 = typeof globalThis < `u` ? globalThis : r2 || self, r2[`'typed'`] = i2());
  })(t4, (function() {
    function t5() {
      return true;
    }
    function n3() {
      return false;
    }
    function r2() {
    }
    let i2 = `Argument is not a typed-function.`;
    function a2() {
      function o2(t6) {
        return typeof t6 == `object` && !!t6 && t6.constructor === Object;
      }
      let s2 = [{ name: `number`, test: function(t6) {
        return typeof t6 == `number`;
      } }, { name: `string`, test: function(t6) {
        return typeof t6 == `string`;
      } }, { name: `boolean`, test: function(t6) {
        return typeof t6 == `boolean`;
      } }, { name: `Function`, test: function(t6) {
        return typeof t6 == `function`;
      } }, { name: `Array`, test: Array.isArray }, { name: `Date`, test: function(t6) {
        return t6 instanceof Date;
      } }, { name: `RegExp`, test: function(t6) {
        return t6 instanceof RegExp;
      } }, { name: `Object`, test: o2 }, { name: `null`, test: function(t6) {
        return t6 === null;
      } }, { name: `undefined`, test: function(t6) {
        return t6 === void 0;
      } }], c2 = { name: `any`, test: t5, isAny: true }, l2, u2, d2 = 0, p2 = { createCount: 0 };
      function m2(t6) {
        let n4 = l2.get(t6);
        if (n4) return n4;
        let r3 = `Unknown type "` + t6 + `"`, i3 = t6.toLowerCase(), a3;
        for (a3 of u2) if (a3.toLowerCase() === i3) {
          r3 += `. Did you mean "` + a3 + `" ?`;
          break;
        }
        throw TypeError(r3);
      }
      function h2(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `any`, r3 = n4 ? m2(n4).index : u2.length, i3 = [];
        for (let n5 = 0; n5 < t6.length; ++n5) {
          if (!t6[n5] || typeof t6[n5].name != `string` || typeof t6[n5].test != `function`) throw TypeError(`Object with properties {name: string, test: function} expected`);
          let a4 = t6[n5].name;
          if (l2.has(a4)) throw TypeError(`Duplicate type name "` + a4 + `"`);
          i3.push(a4), l2.set(a4, { name: a4, test: t6[n5].test, isAny: t6[n5].isAny, index: r3 + n5, conversionsTo: [] });
        }
        let a3 = u2.slice(r3);
        u2 = u2.slice(0, r3).concat(i3).concat(a3);
        for (let t7 = r3 + i3.length; t7 < u2.length; ++t7) l2.get(u2[t7]).index = t7;
      }
      function g2() {
        l2 = /* @__PURE__ */ new Map(), u2 = [], d2 = 0, h2([c2], false);
      }
      g2(), h2(s2);
      function v2() {
        let t6;
        for (t6 of u2) l2.get(t6).conversionsTo = [];
        d2 = 0;
      }
      function y2(t6) {
        let n4 = u2.filter((n5) => {
          let r3 = l2.get(n5);
          return !r3.isAny && r3.test(t6);
        });
        return n4.length ? n4 : [`any`];
      }
      function b2(t6) {
        return t6 && typeof t6 == `function` && `_typedFunctionData` in t6;
      }
      function x2(t6, n4, r3) {
        if (!b2(t6)) throw TypeError(i2);
        let a3 = r3 && r3.exact, o3 = M2(Array.isArray(n4) ? n4.join(`,`) : n4), s3 = E(o3);
        if (!a3 || s3 in t6.signatures) {
          let n5 = t6._typedFunctionData.signatureMap.get(s3);
          if (n5) return n5;
        }
        let c3 = o3.length, l3;
        if (a3) {
          l3 = [];
          let n5;
          for (n5 in t6.signatures) l3.push(t6._typedFunctionData.signatureMap.get(n5));
        } else l3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < c3; ++t7) {
          let n5 = o3[t7], r4 = [], i3;
          for (i3 of l3) {
            let a4 = L2(i3.params, t7);
            if (!(!a4 || n5.restParam && !a4.restParam)) {
              if (!a4.hasAny) {
                let t8 = j2(a4);
                if (n5.types.some((n6) => !t8.has(n6.name))) continue;
              }
              r4.push(i3);
            }
          }
          if (l3 = r4, l3.length === 0) break;
        }
        let u3;
        for (u3 of l3) if (u3.params.length <= c3) return u3;
        throw TypeError(`Signature not found (signature: ` + (t6.name || `unnamed`) + `(` + E(o3, `, `) + `))`);
      }
      function S2(t6, n4, r3) {
        return x2(t6, n4, r3).implementation;
      }
      function w2(t6, n4) {
        let r3 = m2(n4);
        if (r3.test(t6)) return t6;
        let i3 = r3.conversionsTo;
        if (i3.length === 0) throw Error(`There are no conversions to ` + n4 + ` defined.`);
        for (let n5 = 0; n5 < i3.length; n5++) if (m2(i3[n5].from).test(t6)) return i3[n5].convert(t6);
        throw Error(`Cannot convert ` + t6 + ` to ` + n4);
      }
      function E(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `,`;
        return t6.map((t7) => t7.name).join(n4);
      }
      function D(t6) {
        let n4 = t6.indexOf(`...`) === 0, r3 = (n4 ? t6.length > 3 ? t6.slice(3) : `any` : t6).split(`|`).map((t7) => m2(t7.trim())), i3 = false, a3 = n4 ? `...` : ``;
        return { types: r3.map(function(t7) {
          return i3 = t7.isAny || i3, a3 += t7.name + `|`, { name: t7.name, typeIndex: t7.index, test: t7.test, isAny: t7.isAny, conversion: null, conversionIndex: -1 };
        }), name: a3.slice(0, -1), hasAny: i3, hasConversion: false, restParam: n4 };
      }
      function O2(t6) {
        let n4 = q2(t6.types.map((t7) => t7.name)), r3 = t6.hasAny, i3 = t6.name, a3 = n4.map(function(t7) {
          let n5 = m2(t7.from);
          return r3 = n5.isAny || r3, i3 += `|` + t7.from, { name: t7.from, typeIndex: n5.index, test: n5.test, isAny: n5.isAny, conversion: t7, conversionIndex: t7.index };
        });
        return { types: t6.types.concat(a3), name: i3, hasAny: r3, hasConversion: a3.length > 0, restParam: t6.restParam };
      }
      function j2(t6) {
        return t6.typeSet || (t6.typeSet = /* @__PURE__ */ new Set(), t6.types.forEach((n4) => t6.typeSet.add(n4.name))), t6.typeSet;
      }
      function M2(t6) {
        let n4 = [];
        if (typeof t6 != `string`) throw TypeError(`Signatures must be strings`);
        let r3 = t6.trim();
        if (r3 === ``) return n4;
        let i3 = r3.split(`,`);
        for (let t7 = 0; t7 < i3.length; ++t7) {
          let r4 = D(i3[t7].trim());
          if (r4.restParam && t7 !== i3.length - 1) throw SyntaxError(`Unexpected rest parameter "` + i3[t7] + `": only allowed for the last parameter`);
          if (r4.types.length === 0) return null;
          n4.push(r4);
        }
        return n4;
      }
      function N2(t6) {
        let n4 = se2(t6);
        return n4 ? n4.restParam : false;
      }
      function F(n4) {
        if (!n4 || n4.types.length === 0) return t5;
        if (n4.types.length === 1) return m2(n4.types[0].name).test;
        if (n4.types.length === 2) {
          let t6 = m2(n4.types[0].name).test, r3 = m2(n4.types[1].name).test;
          return function(n5) {
            return t6(n5) || r3(n5);
          };
        } else {
          let t6 = n4.types.map(function(t7) {
            return m2(t7.name).test;
          });
          return function(n5) {
            for (let r3 = 0; r3 < t6.length; r3++) if (t6[r3](n5)) return true;
            return false;
          };
        }
      }
      function I2(t6) {
        let n4, r3, i3;
        if (N2(t6)) {
          n4 = $2(t6).map(F);
          let r4 = n4.length, i4 = F(se2(t6)), a3 = function(t7) {
            for (let n5 = r4; n5 < t7.length; n5++) if (!i4(t7[n5])) return false;
            return true;
          };
          return function(t7) {
            for (let r5 = 0; r5 < n4.length; r5++) if (!n4[r5](t7[r5])) return false;
            return a3(t7) && t7.length >= r4 + 1;
          };
        } else if (t6.length === 0) return function(t7) {
          return t7.length === 0;
        };
        else if (t6.length === 1) return r3 = F(t6[0]), function(t7) {
          return r3(t7[0]) && t7.length === 1;
        };
        else if (t6.length === 2) return r3 = F(t6[0]), i3 = F(t6[1]), function(t7) {
          return r3(t7[0]) && i3(t7[1]) && t7.length === 2;
        };
        else return n4 = t6.map(F), function(t7) {
          for (let r4 = 0; r4 < n4.length; r4++) if (!n4[r4](t7[r4])) return false;
          return t7.length === n4.length;
        };
      }
      function L2(t6, n4) {
        return n4 < t6.length ? t6[n4] : N2(t6) ? se2(t6) : null;
      }
      function R2(t6, n4) {
        let r3 = L2(t6, n4);
        return r3 ? j2(r3) : /* @__PURE__ */ new Set();
      }
      function z2(t6) {
        return t6.conversion === null || t6.conversion === void 0;
      }
      function V2(t6, n4) {
        let r3 = /* @__PURE__ */ new Set();
        return t6.forEach((t7) => {
          let i3 = R2(t7.params, n4), a3;
          for (a3 of i3) r3.add(a3);
        }), r3.has(`any`) ? [`any`] : Array.from(r3);
      }
      function H2(t6, n4, r3) {
        let i3, a3, o3 = t6 || `unnamed`, s3 = r3, c3;
        for (c3 = 0; c3 < n4.length; c3++) {
          let t7 = [];
          if (s3.forEach((r4) => {
            let i4 = F(L2(r4.params, c3));
            (c3 < r4.params.length || N2(r4.params)) && i4(n4[c3]) && t7.push(r4);
          }), t7.length === 0) {
            if (a3 = V2(s3, c3), a3.length > 0) {
              let t8 = y2(n4[c3]);
              return i3 = TypeError(`Unexpected type of argument in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, actual: ` + t8.join(` | `) + `, index: ` + c3 + `)`), i3.data = { category: `wrongType`, fn: o3, index: c3, actual: t8, expected: a3 }, i3;
            }
          } else s3 = t7;
        }
        let l3 = s3.map(function(t7) {
          return N2(t7.params) ? 1 / 0 : t7.params.length;
        });
        if (n4.length < Math.min.apply(null, l3)) return a3 = V2(s3, c3), i3 = TypeError(`Too few arguments in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, index: ` + n4.length + `)`), i3.data = { category: `tooFewArgs`, fn: o3, index: n4.length, expected: a3 }, i3;
        let u3 = Math.max.apply(null, l3);
        if (n4.length > u3) return i3 = TypeError(`Too many arguments in function ` + o3 + ` (expected: ` + u3 + `, actual: ` + n4.length + `)`), i3.data = { category: `tooManyArgs`, fn: o3, index: n4.length, expectedLength: u3 }, i3;
        let d3 = [];
        for (let t7 = 0; t7 < n4.length; ++t7) d3.push(y2(n4[t7]).join(`|`));
        return i3 = TypeError(`Arguments of type "` + d3.join(`, `) + `" do not match any of the defined signatures of function ` + o3 + `.`), i3.data = { category: `mismatch`, actual: d3 }, i3;
      }
      function U2(t6) {
        let n4 = u2.length + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) && (n4 = Math.min(n4, t6.types[r3].typeIndex));
        return n4;
      }
      function W2(t6) {
        let n4 = d2 + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) || (n4 = Math.min(n4, t6.types[r3].conversionIndex));
        return n4;
      }
      function G2(t6, n4) {
        if (t6.hasAny) {
          if (!n4.hasAny) return 1;
        } else if (n4.hasAny) return -1;
        if (t6.restParam) {
          if (!n4.restParam) return 1;
        } else if (n4.restParam) return -1;
        if (t6.hasConversion) {
          if (!n4.hasConversion) return 1;
        } else if (n4.hasConversion) return -1;
        let r3 = U2(t6) - U2(n4);
        if (r3 < 0) return -1;
        if (r3 > 0) return 1;
        let i3 = W2(t6) - W2(n4);
        return i3 < 0 ? -1 : +(i3 > 0);
      }
      function K2(t6, n4) {
        let r3 = t6.params, i3 = n4.params, a3 = se2(r3), o3 = se2(i3), s3 = N2(r3), c3 = N2(i3);
        if (s3 && a3.hasAny) {
          if (!c3 || !o3.hasAny) return 1;
        } else if (c3 && o3.hasAny) return -1;
        let l3 = 0, u3 = 0, d3;
        for (d3 of r3) d3.hasAny && ++l3, d3.hasConversion && ++u3;
        let p3 = 0, m3 = 0;
        for (d3 of i3) d3.hasAny && ++p3, d3.hasConversion && ++m3;
        if (l3 !== p3) return l3 - p3;
        if (s3 && a3.hasConversion) {
          if (!c3 || !o3.hasConversion) return 1;
        } else if (c3 && o3.hasConversion) return -1;
        if (u3 !== m3) return u3 - m3;
        if (s3) {
          if (!c3) return 1;
        } else if (c3) return -1;
        let h3 = (r3.length - i3.length) * (s3 ? -1 : 1);
        if (h3 !== 0) return h3;
        let g3 = [], v3 = 0;
        for (let t7 = 0; t7 < r3.length; ++t7) {
          let n5 = G2(r3[t7], i3[t7]);
          g3.push(n5), v3 += n5;
        }
        if (v3 !== 0) return v3;
        let y3;
        for (y3 of g3) if (y3 !== 0) return y3;
        return 0;
      }
      function q2(t6) {
        if (t6.length === 0) return [];
        let n4 = t6.map(m2);
        t6.length > 1 && n4.sort((t7, n5) => t7.index - n5.index);
        let r3 = n4[0].conversionsTo;
        if (t6.length === 1) return r3;
        r3 = r3.concat([]);
        let i3 = new Set(t6);
        for (let t7 = 1; t7 < n4.length; ++t7) {
          let a3;
          for (a3 of n4[t7].conversionsTo) i3.has(a3.from) || (r3.push(a3), i3.add(a3.from));
        }
        return r3;
      }
      function J(t6, n4) {
        let r3 = n4;
        if (t6.some((t7) => t7.hasConversion)) {
          let i4 = N2(t6), a3 = t6.map(ee2);
          r3 = function() {
            let t7 = [], r4 = i4 ? arguments.length - 1 : arguments.length;
            for (let n5 = 0; n5 < r4; n5++) t7[n5] = a3[n5](arguments[n5]);
            return i4 && (t7[r4] = arguments[r4].map(a3[r4])), n4.apply(this, t7);
          };
        }
        let i3 = r3;
        if (N2(t6)) {
          let n5 = t6.length - 1;
          i3 = function() {
            return r3.apply(this, ce2(arguments, 0, n5).concat([ce2(arguments, n5)]));
          };
        }
        return i3;
      }
      function ee2(t6) {
        let n4, r3, i3, a3, o3 = [], s3 = [];
        switch (t6.types.forEach(function(t7) {
          t7.conversion && (o3.push(m2(t7.conversion.from).test), s3.push(t7.conversion.convert));
        }), s3.length) {
          case 0:
            return function(t7) {
              return t7;
            };
          case 1:
            return n4 = o3[0], i3 = s3[0], function(t7) {
              return n4(t7) ? i3(t7) : t7;
            };
          case 2:
            return n4 = o3[0], r3 = o3[1], i3 = s3[0], a3 = s3[1], function(t7) {
              return n4(t7) ? i3(t7) : r3(t7) ? a3(t7) : t7;
            };
          default:
            return function(t7) {
              for (let n5 = 0; n5 < s3.length; n5++) if (o3[n5](t7)) return s3[n5](t7);
              return t7;
            };
        }
      }
      function Y2(t6) {
        function n4(t7, r3, i3) {
          if (r3 < t7.length) {
            let a3 = t7[r3], o3 = [];
            if (a3.restParam) {
              let t8 = a3.types.filter(z2);
              t8.length < a3.types.length && o3.push({ types: t8, name: `...` + t8.map((t9) => t9.name).join(`|`), hasAny: t8.some((t9) => t9.isAny), hasConversion: false, restParam: true }), o3.push(a3);
            } else o3 = a3.types.map(function(t8) {
              return { types: [t8], name: t8.name, hasAny: t8.isAny, hasConversion: t8.conversion, restParam: false };
            });
            return ue2(o3, function(a4) {
              return n4(t7, r3 + 1, i3.concat([a4]));
            });
          } else return [i3];
        }
        return n4(t6, 0, []);
      }
      function te2(t6, n4) {
        let r3 = Math.max(t6.length, n4.length);
        for (let i4 = 0; i4 < r3; i4++) {
          let r4 = R2(t6, i4), a4 = R2(n4, i4), o4 = false, s4;
          for (s4 of a4) if (r4.has(s4)) {
            o4 = true;
            break;
          }
          if (!o4) return false;
        }
        let i3 = t6.length, a3 = n4.length, o3 = N2(t6), s3 = N2(n4);
        return o3 ? s3 ? i3 === a3 : a3 >= i3 : s3 ? i3 >= a3 : i3 === a3;
      }
      function ne2(t6) {
        return t6.map((t7) => he2(t7) ? pe2(t7.referToSelf.callback) : me2(t7) ? fe2(t7.referTo.references, t7.referTo.callback) : t7);
      }
      function X2(t6, n4, r3) {
        let i3 = [], a3;
        for (a3 of t6) {
          let t7 = r3[a3];
          if (typeof t7 != `number`) throw TypeError(`No definition for referenced signature "` + a3 + `"`);
          if (t7 = n4[t7], typeof t7 != `function`) return false;
          i3.push(t7);
        }
        return i3;
      }
      function ie2(t6, n4, r3) {
        let i3 = ne2(t6), a3 = Array(i3.length).fill(false), o3 = true;
        for (; o3; ) {
          o3 = false;
          let t7 = true;
          for (let s3 = 0; s3 < i3.length; ++s3) {
            if (a3[s3]) continue;
            let c3 = i3[s3];
            if (he2(c3)) i3[s3] = c3.referToSelf.callback(r3), i3[s3].referToSelf = c3.referToSelf, a3[s3] = true, t7 = false;
            else if (me2(c3)) {
              let r4 = X2(c3.referTo.references, i3, n4);
              r4 ? (i3[s3] = c3.referTo.callback.apply(this, r4), i3[s3].referTo = c3.referTo, a3[s3] = true, t7 = false) : o3 = true;
            }
          }
          if (t7 && o3) throw SyntaxError(`Circular reference detected in resolving typed.referTo`);
        }
        return i3;
      }
      function ae2(t6) {
        let n4 = /\bthis(\(|\.signatures\b)/;
        Object.keys(t6).forEach((r3) => {
          let i3 = t6[r3];
          if (n4.test(i3.toString())) throw SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        });
      }
      function Z2(t6, i3) {
        if (p2.createCount++, Object.keys(i3).length === 0) throw SyntaxError(`No signatures provided`);
        p2.warnAgainstDeprecatedThis && ae2(i3);
        let a3 = [], o3 = [], s3 = {}, c3 = [], l3;
        for (l3 in i3) {
          if (!Object.prototype.hasOwnProperty.call(i3, l3)) continue;
          let t7 = M2(l3);
          if (!t7) continue;
          a3.forEach(function(n5) {
            if (te2(n5, t7)) throw TypeError(`Conflicting signatures "` + E(n5) + `" and "` + E(t7) + `".`);
          }), a3.push(t7);
          let n4 = o3.length;
          o3.push(i3[l3]);
          let r3 = t7.map(O2), u4;
          for (u4 of Y2(r3)) {
            let t8 = E(u4);
            c3.push({ params: u4, name: t8, fn: n4 }), u4.every((t9) => !t9.hasConversion) && (s3[t8] = n4);
          }
        }
        c3.sort(K2);
        let u3 = ie2(o3, s3, ye22), d3;
        for (d3 in s3) Object.prototype.hasOwnProperty.call(s3, d3) && (s3[d3] = u3[s3[d3]]);
        let m3 = [], h3 = /* @__PURE__ */ new Map();
        for (d3 of c3) h3.has(d3.name) || (d3.fn = u3[d3.fn], m3.push(d3), h3.set(d3.name, d3));
        let g3 = m3[0] && m3[0].params.length <= 2 && !N2(m3[0].params), v3 = m3[1] && m3[1].params.length <= 2 && !N2(m3[1].params), y3 = m3[2] && m3[2].params.length <= 2 && !N2(m3[2].params), b3 = m3[3] && m3[3].params.length <= 2 && !N2(m3[3].params), x3 = m3[4] && m3[4].params.length <= 2 && !N2(m3[4].params), S3 = m3[5] && m3[5].params.length <= 2 && !N2(m3[5].params), w3 = g3 && v3 && y3 && b3 && x3 && S3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].test = I2(m3[t7].params);
        let D2 = g3 ? F(m3[0].params[0]) : n3, j3 = v3 ? F(m3[1].params[0]) : n3, L22 = y3 ? F(m3[2].params[0]) : n3, R22 = b3 ? F(m3[3].params[0]) : n3, z22 = x3 ? F(m3[4].params[0]) : n3, V22 = S3 ? F(m3[5].params[0]) : n3, H3 = g3 ? F(m3[0].params[1]) : n3, U22 = v3 ? F(m3[1].params[1]) : n3, W22 = y3 ? F(m3[2].params[1]) : n3, G22 = b3 ? F(m3[3].params[1]) : n3, q22 = x3 ? F(m3[4].params[1]) : n3, ee22 = S3 ? F(m3[5].params[1]) : n3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].implementation = J(m3[t7].params, m3[t7].fn);
        let ne22 = g3 ? m3[0].implementation : r2, X22 = v3 ? m3[1].implementation : r2, Z22 = y3 ? m3[2].implementation : r2, oe22 = b3 ? m3[3].implementation : r2, $3 = x3 ? m3[4].implementation : r2, se22 = S3 ? m3[5].implementation : r2, ce22 = g3 ? m3[0].params.length : -1, le22 = v3 ? m3[1].params.length : -1, ue22 = y3 ? m3[2].params.length : -1, de22 = b3 ? m3[3].params.length : -1, fe22 = x3 ? m3[4].params.length : -1, pe22 = S3 ? m3[5].params.length : -1, me22 = w3 ? 6 : 0, he22 = m3.length, ge22 = m3.map((t7) => t7.test), _e22 = m3.map((t7) => t7.implementation), ve22 = function() {
          for (let t7 = me22; t7 < he22; t7++) if (ge22[t7](arguments)) return _e22[t7].apply(this, arguments);
          return p2.onMismatch(t6, arguments, m3);
        };
        function ye22(t7, n4) {
          return arguments.length === ce22 && D2(t7) && H3(n4) ? ne22.apply(this, arguments) : arguments.length === le22 && j3(t7) && U22(n4) ? X22.apply(this, arguments) : arguments.length === ue22 && L22(t7) && W22(n4) ? Z22.apply(this, arguments) : arguments.length === de22 && R22(t7) && G22(n4) ? oe22.apply(this, arguments) : arguments.length === fe22 && z22(t7) && q22(n4) ? $3.apply(this, arguments) : arguments.length === pe22 && V22(t7) && ee22(n4) ? se22.apply(this, arguments) : ve22.apply(this, arguments);
        }
        try {
          Object.defineProperty(ye22, "name", { value: t6 });
        } catch {
        }
        return ye22.signatures = s3, ye22._typedFunctionData = { signatures: m3, signatureMap: h3 }, ye22;
      }
      function oe2(t6, n4, r3) {
        throw H2(t6, n4, r3);
      }
      function $2(t6) {
        return ce2(t6, 0, t6.length - 1);
      }
      function se2(t6) {
        return t6[t6.length - 1];
      }
      function ce2(t6, n4, r3) {
        return Array.prototype.slice.call(t6, n4, r3);
      }
      function le2(t6, n4) {
        for (let r3 = 0; r3 < t6.length; r3++) if (n4(t6[r3])) return t6[r3];
      }
      function ue2(t6, n4) {
        return Array.prototype.concat.apply([], t6.map(n4));
      }
      function de2() {
        let t6 = $2(arguments).map((t7) => E(M2(t7))), n4 = se2(arguments);
        if (typeof n4 != `function`) throw TypeError(`Callback function expected as last argument`);
        return fe2(t6, n4);
      }
      function fe2(t6, n4) {
        return { referTo: { references: t6, callback: n4 } };
      }
      function pe2(t6) {
        if (typeof t6 != `function`) throw TypeError(`Callback function expected as first argument`);
        return { referToSelf: { callback: t6 } };
      }
      function me2(t6) {
        return t6 && typeof t6.referTo == `object` && Array.isArray(t6.referTo.references) && typeof t6.referTo.callback == `function`;
      }
      function he2(t6) {
        return t6 && typeof t6.referToSelf == `object` && typeof t6.referToSelf.callback == `function`;
      }
      function ge2(t6, n4) {
        if (!t6) return n4;
        if (n4 && n4 !== t6) {
          let r3 = Error(`Function names do not match (expected: ` + t6 + `, actual: ` + n4 + `)`);
          throw r3.data = { actual: n4, expected: t6 }, r3;
        }
        return t6;
      }
      function _e2(t6) {
        let n4;
        for (let r3 in t6) Object.prototype.hasOwnProperty.call(t6, r3) && (b2(t6[r3]) || typeof t6[r3].signature == `string`) && (n4 = ge2(n4, t6[r3].name));
        return n4;
      }
      function ve2(t6, n4) {
        let r3;
        for (r3 in n4) if (Object.prototype.hasOwnProperty.call(n4, r3)) {
          if (r3 in t6 && n4[r3] !== t6[r3]) {
            let i3 = Error(`Signature "` + r3 + `" is defined twice`);
            throw i3.data = { signature: r3, sourceFunction: n4[r3], destFunction: t6[r3] }, i3;
          }
          t6[r3] = n4[r3];
        }
      }
      let ye2 = p2;
      p2 = function(t6) {
        let n4 = typeof t6 == `string`, r3 = +!!n4, i3 = n4 ? t6 : ``, a3 = {};
        for (let t7 = r3; t7 < arguments.length; ++t7) {
          let r4 = arguments[t7], s3 = {}, c3;
          if (typeof r4 == `function` ? (c3 = r4.name, typeof r4.signature == `string` ? s3[r4.signature] = r4 : b2(r4) && (s3 = r4.signatures)) : o2(r4) && (s3 = r4, n4 || (c3 = _e2(r4))), Object.keys(s3).length === 0) {
            let n5 = TypeError(`Argument to 'typed' at index ` + t7 + ` is not a (typed) function, nor an object with signatures as keys and functions as values.`);
            throw n5.data = { index: t7, argument: r4 }, n5;
          }
          n4 || (i3 = ge2(i3, c3)), ve2(a3, s3);
        }
        return Z2(i3 || ``, a3);
      }, p2.create = a2, p2.createCount = ye2.createCount, p2.onMismatch = oe2, p2.throwMismatchError = oe2, p2.createError = H2, p2.clear = g2, p2.clearConversions = v2, p2.addTypes = h2, p2._findType = m2, p2.referTo = de2, p2.referToSelf = pe2, p2.convert = w2, p2.findSignature = x2, p2.find = S2, p2.isTypedFunction = b2, p2.warnAgainstDeprecatedThis = true, p2.addType = function(t6, n4) {
        let r3 = `any`;
        n4 !== false && l2.has(`Object`) && (r3 = `Object`), p2.addTypes([t6], r3);
      };
      function be2(t6) {
        if (!t6 || typeof t6.from != `string` || typeof t6.to != `string` || typeof t6.convert != `function`) throw TypeError(`Object with properties {from: string, to: string, convert: function} expected`);
        if (t6.to === t6.from) throw SyntaxError(`Illegal to define conversion from "` + t6.from + `" to itself.`);
      }
      return p2.addConversion = function(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { override: false };
        be2(t6);
        let r3 = m2(t6.to), i3 = r3.conversionsTo.find((n5) => n5.from === t6.from);
        if (i3) if (n4 && n4.override) p2.removeConversion({ from: i3.from, to: t6.to, convert: i3.convert });
        else throw Error(`There is already a conversion from "` + t6.from + `" to "` + r3.name + `"`);
        r3.conversionsTo.push({ from: t6.from, convert: t6.convert, index: d2++ });
      }, p2.addConversions = function(t6, n4) {
        t6.forEach((t7) => p2.addConversion(t7, n4));
      }, p2.removeConversion = function(t6) {
        be2(t6);
        let n4 = m2(t6.to), r3 = le2(n4.conversionsTo, (n5) => n5.from === t6.from);
        if (!r3) throw Error(`Attempt to remove nonexistent conversion from ` + t6.from + ` to ` + t6.to);
        if (r3.convert !== t6.convert) throw Error(`Conversion to remove does not match existing conversion`);
        let i3 = n4.conversionsTo.indexOf(r3);
        n4.conversionsTo.splice(i3, 1);
      }, p2.resolve = function(t6, n4) {
        if (!b2(t6)) throw TypeError(i2);
        let r3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < r3.length; ++t7) if (r3[t7].test(n4)) return r3[t7];
        return null;
      }, p2;
    }
    return a2();
  }));
}));
function factory$1(t4, n2, r2, i2) {
  function a2(i3) {
    var a3 = pickShallow$1(i3, n2.map(stripOptionalNotation$1));
    return assertDependencies$1(t4, n2, i3), r2(a3);
  }
  return a2.isFactory = true, a2.fn = t4, a2.dependencies = n2.slice().sort(), i2 && (a2.meta = i2), a2;
}
function isFactory$1(t4) {
  return typeof t4 == `function` && typeof t4.fn == `string` && Array.isArray(t4.dependencies);
}
function assertDependencies$1(t4, n2, r2) {
  if (!n2.filter((t5) => !isOptionalDependency$1(t5)).every((t5) => r2[t5] !== void 0)) {
    var i2 = n2.filter((t5) => r2[t5] === void 0);
    throw Error(`Cannot create function "${t4}", some dependencies are missing: ${i2.map((t5) => `"${t5}"`).join(`, `)}.`);
  }
}
function isOptionalDependency$1(t4) {
  return t4 && t4[0] === `?`;
}
function stripOptionalNotation$1(t4) {
  return t4 && t4[0] === `?` ? t4.slice(1) : t4;
}
function isInteger$2(t4) {
  return typeof t4 == `boolean` ? true : Number.isFinite(t4) ? t4 === Math.round(t4) : false;
}
function safeNumberType$1(t4, n2) {
  if (n2.number === `bigint`) try {
    BigInt(t4);
  } catch {
    return n2.numberFallback;
  }
  return n2.number;
}
var sign$2$1 = Math.sign || function(t4) {
  return t4 > 0 ? 1 : t4 < 0 ? -1 : 0;
}, log2$1$1 = Math.log2 || function(t4) {
  return Math.log(t4) / Math.LN2;
}, log10$2$1 = Math.log10 || function(t4) {
  return Math.log(t4) / Math.LN10;
}, log1p$1 = Math.log1p || function(t4) {
  return Math.log(t4 + 1);
}, cbrt$1$1 = Math.cbrt || function(t4) {
  if (t4 === 0) return t4;
  var n2 = t4 < 0, r2;
  return n2 && (t4 = -t4), Number.isFinite(t4) ? (r2 = Math.exp(Math.log(t4) / 3), r2 = (t4 / (r2 * r2) + 2 * r2) / 3) : r2 = t4, n2 ? -r2 : r2;
}, expm1$1 = Math.expm1 || function(t4) {
  return t4 >= 2e-4 || t4 <= -2e-4 ? Math.exp(t4) - 1 : t4 + t4 * t4 / 2 + t4 * t4 * t4 / 6;
};
function formatNumberToBase$1(t4, n2, r2) {
  var i2 = { 2: `0b`, 8: `0o`, 16: `0x` }[n2], a2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger$2(r2)) throw Error(`size must be an integer`);
    if (t4 > 2 ** (r2 - 1) - 1 || t4 < -(2 ** (r2 - 1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!isInteger$2(t4)) throw Error(`Value must be an integer`);
    t4 < 0 && (t4 += 2 ** r2), a2 = `i${r2}`;
  }
  var o2 = ``;
  return t4 < 0 && (t4 = -t4, o2 = `-`), `${o2}${i2}${t4.toString(n2)}${a2}`;
}
function format$2$1(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (t4 === 1 / 0) return `Infinity`;
  if (t4 === -1 / 0) return `-Infinity`;
  if (isNaN(t4)) return `NaN`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions$1(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$2$1(t4, i2);
    case `exponential`:
      return toExponential$1$1(t4, i2);
    case `engineering`:
      return toEngineering$1$1(t4, i2);
    case `bin`:
      return formatNumberToBase$1(t4, 2, a2);
    case `oct`:
      return formatNumberToBase$1(t4, 8, a2);
    case `hex`:
      return formatNumberToBase$1(t4, 16, a2);
    case `auto`:
      return toPrecision$1(t4, i2, n2).replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function normalizeFormatOptions$1(t4) {
  var n2 = `auto`, r2, i2;
  if (t4 !== void 0) if (isNumber$1(t4)) r2 = t4;
  else if (isBigNumber$1(t4)) r2 = t4.toNumber();
  else if (isObject$1$1(t4)) t4.precision !== void 0 && (r2 = _toNumberOrThrow$1(t4.precision, () => {
    throw Error(`Option "precision" must be a number or BigNumber`);
  })), t4.wordSize !== void 0 && (i2 = _toNumberOrThrow$1(t4.wordSize, () => {
    throw Error(`Option "wordSize" must be a number or BigNumber`);
  })), t4.notation && (n2 = t4.notation);
  else throw Error(`Unsupported type of options, number, BigNumber, or object expected`);
  return { notation: n2, precision: r2, wordSize: i2 };
}
function splitNumber$1(t4) {
  var n2 = String(t4).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!n2) throw SyntaxError(`Invalid number ` + t4);
  var r2 = n2[1], i2 = n2[2], a2 = parseFloat(n2[4] || `0`), o2 = i2.indexOf(`.`);
  a2 += o2 === -1 ? i2.length - 1 : o2 - 1;
  var s2 = i2.replace(`.`, ``).replace(/^0*/, function(t5) {
    return a2 -= t5.length, ``;
  }).replace(/0*$/, ``).split(``).map(function(t5) {
    return parseInt(t5);
  });
  return s2.length === 0 && (s2.push(0), a2++), { sign: r2, coefficients: s2, exponent: a2 };
}
function toEngineering$1$1(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = roundDigits$1(splitNumber$1(t4), n2), i2 = r2.exponent, a2 = r2.coefficients, o2 = i2 % 3 == 0 ? i2 : i2 < 0 ? i2 - 3 - i2 % 3 : i2 - i2 % 3;
  if (isNumber$1(n2)) for (; n2 > a2.length || i2 - o2 + 1 > a2.length; ) a2.push(0);
  else for (var s2 = Math.abs(i2 - o2) - (a2.length - 1), c2 = 0; c2 < s2; c2++) a2.push(0);
  for (var l2 = Math.abs(i2 - o2), u2 = 1; l2 > 0; ) u2++, l2--;
  var d2 = a2.slice(u2).join(``), p2 = isNumber$1(n2) && d2.length || d2.match(/[1-9]/) ? `.` + d2 : ``, m2 = a2.slice(0, u2).join(``) + p2 + `e` + (i2 >= 0 ? `+` : ``) + o2.toString();
  return r2.sign + m2;
}
function toFixed$2$1(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = splitNumber$1(t4), i2 = typeof n2 == `number` ? roundDigits$1(r2, r2.exponent + 1 + n2) : r2, a2 = i2.coefficients, o2 = i2.exponent + 1, s2 = o2 + (n2 || 0);
  return a2.length < s2 && (a2 = a2.concat(zeros$1(s2 - a2.length))), o2 < 0 && (a2 = zeros$1(-o2 + 1).concat(a2), o2 = 1), o2 < a2.length && a2.splice(o2, 0, o2 === 0 ? `0.` : `.`), i2.sign + a2.join(``);
}
function toExponential$1$1(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(Number(t4))) return String(t4);
  var r2 = splitNumber$1(t4), i2 = n2 ? roundDigits$1(r2, n2) : r2, a2 = i2.coefficients, o2 = i2.exponent;
  a2.length < n2 && (a2 = a2.concat(zeros$1(n2 - a2.length)));
  var s2 = a2.shift();
  return i2.sign + s2 + (a2.length > 0 ? `.` + a2.join(``) : ``) + `e` + (o2 >= 0 ? `+` : ``) + o2;
}
function toPrecision$1(t4, n2, r2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var i2 = _toNumberOrDefault$1$1(r2?.lowerExp, -3), a2 = _toNumberOrDefault$1$1(r2?.upperExp, 5), o2 = splitNumber$1(t4), s2 = n2 ? roundDigits$1(o2, n2) : o2;
  if (s2.exponent < i2 || s2.exponent >= a2) return toExponential$1$1(t4, n2);
  var c2 = s2.coefficients, l2 = s2.exponent;
  c2.length < n2 && (c2 = c2.concat(zeros$1(n2 - c2.length))), c2 = c2.concat(zeros$1(l2 - c2.length + 1 + (c2.length < n2 ? n2 - c2.length : 0))), c2 = zeros$1(-l2).concat(c2);
  var u2 = l2 > 0 ? l2 : 0;
  return u2 < c2.length - 1 && c2.splice(u2 + 1, 0, `.`), s2.sign + c2.join(``);
}
function roundDigits$1(t4, n2) {
  for (var r2 = { sign: t4.sign, coefficients: t4.coefficients, exponent: t4.exponent }, i2 = r2.coefficients; n2 <= 0; ) i2.unshift(0), r2.exponent++, n2++;
  if (i2.length > n2 && i2.splice(n2, i2.length - n2)[0] >= 5) {
    var a2 = n2 - 1;
    for (i2[a2]++; i2[a2] === 10; ) i2.pop(), a2 === 0 && (i2.unshift(0), r2.exponent++, a2++), a2--, i2[a2]++;
  }
  return r2;
}
function zeros$1(t4) {
  for (var n2 = [], r2 = 0; r2 < t4; r2++) n2.push(0);
  return n2;
}
function digits$1(t4) {
  return t4.toExponential().replace(/e.*$/, ``).replace(/^0\.?0*|\./, ``).length;
}
function nearlyEqual$1$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return isNaN(t4) || isNaN(n2) ? false : !Number.isFinite(t4) || !Number.isFinite(n2) ? t4 === n2 : t4 === n2 ? true : Math.abs(t4 - n2) <= Math.max(r2 * Math.max(Math.abs(t4), Math.abs(n2)), i2);
}
var acosh$2$1 = Math.acosh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 - 1) + t4);
}, asinh$2$1 = Math.asinh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 + 1) + t4);
}, atanh$2$1 = Math.atanh || function(t4) {
  return Math.log((1 + t4) / (1 - t4)) / 2;
}, cosh$3$1 = Math.cosh || function(t4) {
  return (Math.exp(t4) + Math.exp(-t4)) / 2;
}, sinh$3$1 = Math.sinh || function(t4) {
  return (Math.exp(t4) - Math.exp(-t4)) / 2;
}, tanh$2$1 = Math.tanh || function(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 - 1) / (n2 + 1);
};
function copysign$1(t4, n2) {
  return true ^ (n2 > 0 ? true : n2 < 0 ? false : 1 / n2 == 1 / 0) ? -t4 : t4;
}
function _toNumberOrThrow$1(t4, n2) {
  if (isNumber$1(t4)) return t4;
  if (isBigNumber$1(t4)) return t4.toNumber();
  n2();
}
function _toNumberOrDefault$1$1(t4, n2) {
  return isNumber$1(t4) ? t4 : isBigNumber$1(t4) ? t4.toNumber() : n2;
}
var import_typed_function$1 = __toESM$1(require_typed_function$1()), _createTyped2$1 = function() {
  return _createTyped2$1 = import_typed_function$1.default.create, import_typed_function$1.default;
}, dependencies$322$1 = [`?BigNumber`, `?Complex`, `?DenseMatrix`, `?Fraction`], createTyped$1 = factory$1(`typed`, dependencies$322$1, function(t4) {
  var { BigNumber: n2, Complex: r2, DenseMatrix: i2, Fraction: a2 } = t4, o2 = _createTyped2$1();
  return o2.clear(), o2.addTypes([{ name: `number`, test: isNumber$1 }, { name: `Complex`, test: isComplex$1 }, { name: `BigNumber`, test: isBigNumber$1 }, { name: `bigint`, test: isBigInt$1 }, { name: `Fraction`, test: isFraction$1 }, { name: `Unit`, test: isUnit$1 }, { name: `identifier`, test: (t5) => isString$1 && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])*$/.test(t5) }, { name: `string`, test: isString$1 }, { name: `Chain`, test: isChain$1 }, { name: `Array`, test: isArray$1 }, { name: `Matrix`, test: isMatrix$1 }, { name: `DenseMatrix`, test: isDenseMatrix$1 }, { name: `SparseMatrix`, test: isSparseMatrix$1 }, { name: `Range`, test: isRange$1 }, { name: `Index`, test: isIndex$1 }, { name: `boolean`, test: isBoolean$1$1 }, { name: `ResultSet`, test: isResultSet$1 }, { name: `Help`, test: isHelp$1 }, { name: `function`, test: isFunction$1$1 }, { name: `Date`, test: isDate$1 }, { name: `RegExp`, test: isRegExp$1 }, { name: `null`, test: isNull$1$1 }, { name: `undefined`, test: isUndefined$1$1 }, { name: `AccessorNode`, test: isAccessorNode$1 }, { name: `ArrayNode`, test: isArrayNode$1 }, { name: `AssignmentNode`, test: isAssignmentNode$1 }, { name: `BlockNode`, test: isBlockNode$1 }, { name: `ConditionalNode`, test: isConditionalNode$1 }, { name: `ConstantNode`, test: isConstantNode$1 }, { name: `FunctionNode`, test: isFunctionNode$1 }, { name: `FunctionAssignmentNode`, test: isFunctionAssignmentNode$1 }, { name: `IndexNode`, test: isIndexNode$1 }, { name: `Node`, test: isNode$4 }, { name: `ObjectNode`, test: isObjectNode$1 }, { name: `OperatorNode`, test: isOperatorNode$1 }, { name: `ParenthesisNode`, test: isParenthesisNode$1 }, { name: `RangeNode`, test: isRangeNode$1 }, { name: `RelationalNode`, test: isRelationalNode$1 }, { name: `SymbolNode`, test: isSymbolNode$1 }, { name: `Map`, test: isMap$1 }, { name: `Object`, test: isObject$1$1 }]), o2.addConversions([{ from: `number`, to: `BigNumber`, convert: function(t5) {
    if (n2 || throwNoBignumber$1(t5), digits$1(t5) > 15) throw TypeError(`Cannot implicitly convert a number with >15 significant digits to BigNumber (value: ` + t5 + `). Use function bignumber(x) to convert to BigNumber.`);
    return new n2(t5);
  } }, { from: `number`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$1(t5), new r2(t5, 0);
  } }, { from: `BigNumber`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$1(t5), new r2(t5.toNumber(), 0);
  } }, { from: `bigint`, to: `number`, convert: function(t5) {
    if (t5 > 2 ** 53 - 1) throw TypeError(`Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: ` + t5 + `)`);
    return Number(t5);
  } }, { from: `bigint`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber$1(t5), new n2(t5.toString());
  } }, { from: `bigint`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction$1(t5), new a2(t5);
  } }, { from: `Fraction`, to: `BigNumber`, convert: function(t5) {
    throw TypeError(`Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.`);
  } }, { from: `Fraction`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex$1(t5), new r2(t5.valueOf(), 0);
  } }, { from: `number`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction$1(t5);
    var n3 = new a2(t5);
    if (n3.valueOf() !== t5) throw TypeError(`Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: ` + t5 + `). Use function fraction(x) to convert to Fraction.`);
    return n3;
  } }, { from: `string`, to: `number`, convert: function(t5) {
    var n3 = Number(t5);
    if (isNaN(n3)) throw Error(`Cannot convert "` + t5 + `" to a number`);
    return n3;
  } }, { from: `string`, to: `BigNumber`, convert: function(t5) {
    n2 || throwNoBignumber$1(t5);
    try {
      return new n2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigNumber`);
    }
  } }, { from: `string`, to: `bigint`, convert: function(t5) {
    try {
      return BigInt(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigInt`);
    }
  } }, { from: `string`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction$1(t5);
    try {
      return new a2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Fraction`);
    }
  } }, { from: `string`, to: `Complex`, convert: function(t5) {
    r2 || throwNoComplex$1(t5);
    try {
      return new r2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Complex`);
    }
  } }, { from: `boolean`, to: `number`, convert: function(t5) {
    return +t5;
  } }, { from: `boolean`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber$1(t5), new n2(+t5);
  } }, { from: `boolean`, to: `bigint`, convert: function(t5) {
    return BigInt(+t5);
  } }, { from: `boolean`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction$1(t5), new a2(+t5);
  } }, { from: `boolean`, to: `string`, convert: function(t5) {
    return String(t5);
  } }, { from: `Array`, to: `Matrix`, convert: function(t5) {
    return i2 || throwNoMatrix$1(), new i2(t5);
  } }, { from: `Matrix`, to: `Array`, convert: function(t5) {
    return t5.valueOf();
  } }]), o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection$1(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection$1(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2;
});
function throwNoBignumber$1(t4) {
  throw Error(`Cannot convert value ${t4} into a BigNumber: no class 'BigNumber' provided`);
}
function throwNoComplex$1(t4) {
  throw Error(`Cannot convert value ${t4} into a Complex number: no class 'Complex' provided`);
}
function throwNoMatrix$1() {
  throw Error(`Cannot convert array into a Matrix: no class 'DenseMatrix' provided`);
}
function throwNoFraction$1(t4) {
  throw Error(`Cannot convert value ${t4} into a Fraction, no class 'Fraction' provided.`);
}
var name$321$1 = `ResultSet`, dependencies$321$1 = [], createResultSet$1 = factory$1(name$321$1, dependencies$321$1, () => {
  function t4(n2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    this.entries = n2 || [];
  }
  return t4.prototype.type = `ResultSet`, t4.prototype.isResultSet = true, t4.prototype.valueOf = function() {
    return this.entries;
  }, t4.prototype.toString = function() {
    return `[` + this.entries.map(String).join(`, `) + `]`;
  }, t4.prototype.toJSON = function() {
    return { mathjs: `ResultSet`, entries: this.entries };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.entries);
  }, t4;
}, { isClass: true }), EXP_LIMIT$1 = 9e15, MAX_DIGITS$1 = 1e9, NUMERALS$1 = `0123456789abcdef`, LN10$1 = `2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058`, PI$1 = `3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789`, DEFAULTS$1 = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT$1, maxE: EXP_LIMIT$1, crypto: false }, inexact$1, quadrant$1, external$1 = true, decimalError$1 = `[DecimalError] `, invalidArgument$1 = decimalError$1 + `Invalid argument: `, precisionLimitExceeded$1 = decimalError$1 + `Precision limit exceeded`, cryptoUnavailable$1 = decimalError$1 + `crypto unavailable`, tag$1 = `[object Decimal]`, mathfloor$1 = Math.floor, mathpow$1 = Math.pow, isBinary$1 = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex$1 = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal$1 = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal$1 = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE$1 = 1e7, LOG_BASE$1 = 7, MAX_SAFE_INTEGER$1 = 9007199254740991, LN10_PRECISION$1 = LN10$1.length - 1, PI_PRECISION$1 = PI$1.length - 1, P$3$1 = { toStringTag: tag$1 };
P$3$1.absoluteValue = P$3$1.abs = function() {
  var t4 = new this.constructor(this);
  return t4.s < 0 && (t4.s = 1), finalise$1(t4);
}, P$3$1.ceil = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 2);
}, P$3$1.clampedTo = P$3$1.clamp = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  if (t4 = new a2(t4), n2 = new a2(n2), !t4.s || !n2.s) return new a2(NaN);
  if (t4.gt(n2)) throw Error(invalidArgument$1 + n2);
  return r2 = i2.cmp(t4), r2 < 0 ? t4 : i2.cmp(n2) > 0 ? n2 : new a2(i2);
}, P$3$1.comparedTo = P$3$1.cmp = function(t4) {
  var n2, r2, i2, a2, o2 = this, s2 = o2.d, c2 = (t4 = new o2.constructor(t4)).d, l2 = o2.s, u2 = t4.s;
  if (!s2 || !c2) return !l2 || !u2 ? NaN : l2 === u2 ? s2 === c2 ? 0 : !s2 ^ l2 < 0 ? 1 : -1 : l2;
  if (!s2[0] || !c2[0]) return s2[0] ? l2 : c2[0] ? -u2 : 0;
  if (l2 !== u2) return l2;
  if (o2.e !== t4.e) return o2.e > t4.e ^ l2 < 0 ? 1 : -1;
  for (i2 = s2.length, a2 = c2.length, n2 = 0, r2 = i2 < a2 ? i2 : a2; n2 < r2; ++n2) if (s2[n2] !== c2[n2]) return s2[n2] > c2[n2] ^ l2 < 0 ? 1 : -1;
  return i2 === a2 ? 0 : i2 > a2 ^ l2 < 0 ? 1 : -1;
}, P$3$1.cosine = P$3$1.cos = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.d ? r2.d[0] ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE$1, i2.rounding = 1, r2 = cosine$1(i2, toLessThanHalfPi$1(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise$1(quadrant$1 == 2 || quadrant$1 == 3 ? r2.neg() : r2, t4, n2, true)) : new i2(1) : new i2(NaN);
}, P$3$1.cubeRoot = P$3$1.cbrt = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor;
  if (!d2.isFinite() || d2.isZero()) return new p2(d2);
  for (external$1 = false, o2 = d2.s * mathpow$1(d2.s * d2, 1 / 3), !o2 || Math.abs(o2) == 1 / 0 ? (r2 = digitsToString$1(d2.d), t4 = d2.e, (o2 = (t4 - r2.length + 1) % 3) && (r2 += o2 == 1 || o2 == -2 ? `0` : `00`), o2 = mathpow$1(r2, 1 / 3), t4 = mathfloor$1((t4 + 1) / 3) - (t4 % 3 == (t4 < 0 ? -1 : 2)), o2 == 1 / 0 ? r2 = `5e` + t4 : (r2 = o2.toExponential(), r2 = r2.slice(0, r2.indexOf(`e`) + 1) + t4), i2 = new p2(r2), i2.s = d2.s) : i2 = new p2(o2.toString()), s2 = (t4 = p2.precision) + 3; ; ) if (c2 = i2, l2 = c2.times(c2).times(c2), u2 = l2.plus(d2), i2 = divide$1$1(u2.plus(d2).times(c2), u2.plus(l2), s2 + 2, 1), digitsToString$1(c2.d).slice(0, s2) === (r2 = digitsToString$1(i2.d)).slice(0, s2)) if (r2 = r2.slice(s2 - 3, s2 + 1), r2 == `9999` || !a2 && r2 == `4999`) {
    if (!a2 && (finalise$1(c2, t4 + 1, 0), c2.times(c2).times(c2).eq(d2))) {
      i2 = c2;
      break;
    }
    s2 += 4, a2 = 1;
  } else {
    (!+r2 || !+r2.slice(1) && r2.charAt(0) == `5`) && (finalise$1(i2, t4 + 1, 1), n2 = !i2.times(i2).times(i2).eq(d2));
    break;
  }
  return external$1 = true, finalise$1(i2, t4, p2.rounding, n2);
}, P$3$1.decimalPlaces = P$3$1.dp = function() {
  var t4, n2 = this.d, r2 = NaN;
  if (n2) {
    if (t4 = n2.length - 1, r2 = (t4 - mathfloor$1(this.e / LOG_BASE$1)) * LOG_BASE$1, t4 = n2[t4], t4) for (; t4 % 10 == 0; t4 /= 10) r2--;
    r2 < 0 && (r2 = 0);
  }
  return r2;
}, P$3$1.dividedBy = P$3$1.div = function(t4) {
  return divide$1$1(this, new this.constructor(t4));
}, P$3$1.dividedToIntegerBy = P$3$1.divToInt = function(t4) {
  var n2 = this, r2 = n2.constructor;
  return finalise$1(divide$1$1(n2, new r2(t4), 0, 1, 1), r2.precision, r2.rounding);
}, P$3$1.equals = P$3$1.eq = function(t4) {
  return this.cmp(t4) === 0;
}, P$3$1.floor = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 3);
}, P$3$1.greaterThan = P$3$1.gt = function(t4) {
  return this.cmp(t4) > 0;
}, P$3$1.greaterThanOrEqualTo = P$3$1.gte = function(t4) {
  var n2 = this.cmp(t4);
  return n2 == 1 || n2 === 0;
}, P$3$1.hyperbolicCosine = P$3$1.cosh = function() {
  var t4, n2, r2, i2, a2, o2 = this, s2 = o2.constructor, c2 = new s2(1);
  if (!o2.isFinite()) return new s2(o2.s ? 1 / 0 : NaN);
  if (o2.isZero()) return c2;
  r2 = s2.precision, i2 = s2.rounding, s2.precision = r2 + Math.max(o2.e, o2.sd()) + 4, s2.rounding = 1, a2 = o2.d.length, a2 < 32 ? (t4 = Math.ceil(a2 / 3), n2 = (1 / tinyPow$1(4, t4)).toString()) : (t4 = 16, n2 = `2.3283064365386962890625e-10`), o2 = taylorSeries$1(s2, 1, o2.times(n2), new s2(1), true);
  for (var l2, u2 = t4, d2 = new s2(8); u2--; ) l2 = o2.times(o2), o2 = c2.minus(l2.times(d2.minus(l2.times(d2))));
  return finalise$1(o2, s2.precision = r2, s2.rounding = i2, true);
}, P$3$1.hyperbolicSine = P$3$1.sinh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  if (!a2.isFinite() || a2.isZero()) return new o2(a2);
  if (n2 = o2.precision, r2 = o2.rounding, o2.precision = n2 + Math.max(a2.e, a2.sd()) + 4, o2.rounding = 1, i2 = a2.d.length, i2 < 3) a2 = taylorSeries$1(o2, 2, a2, a2, true);
  else {
    t4 = 1.4 * Math.sqrt(i2), t4 = t4 > 16 ? 16 : t4 | 0, a2 = a2.times(1 / tinyPow$1(5, t4)), a2 = taylorSeries$1(o2, 2, a2, a2, true);
    for (var s2, c2 = new o2(5), l2 = new o2(16), u2 = new o2(20); t4--; ) s2 = a2.times(a2), a2 = a2.times(c2.plus(s2.times(l2.times(s2).plus(u2))));
  }
  return o2.precision = n2, o2.rounding = r2, finalise$1(a2, n2, r2, true);
}, P$3$1.hyperbolicTangent = P$3$1.tanh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 7, i2.rounding = 1, divide$1$1(r2.sinh(), r2.cosh(), i2.precision = t4, i2.rounding = n2)) : new i2(r2.s);
}, P$3$1.inverseCosine = P$3$1.acos = function() {
  var t4, n2 = this, r2 = n2.constructor, i2 = n2.abs().cmp(1), a2 = r2.precision, o2 = r2.rounding;
  return i2 === -1 ? n2.isZero() ? getPi$1(r2, a2 + 4, o2).times(0.5) : (r2.precision = a2 + 6, r2.rounding = 1, n2 = n2.asin(), t4 = getPi$1(r2, a2 + 4, o2).times(0.5), r2.precision = a2, r2.rounding = o2, t4.minus(n2)) : i2 === 0 ? n2.isNeg() ? getPi$1(r2, a2, o2) : new r2(0) : new r2(NaN);
}, P$3$1.inverseHyperbolicCosine = P$3$1.acosh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.lte(1) ? new i2(r2.eq(1) ? 0 : NaN) : r2.isFinite() ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(Math.abs(r2.e), r2.sd()) + 4, i2.rounding = 1, external$1 = false, r2 = r2.times(r2).minus(1).sqrt().plus(r2), external$1 = true, i2.precision = t4, i2.rounding = n2, r2.ln()) : new i2(r2);
}, P$3$1.inverseHyperbolicSine = P$3$1.asinh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return !r2.isFinite() || r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 2 * Math.max(Math.abs(r2.e), r2.sd()) + 6, i2.rounding = 1, external$1 = false, r2 = r2.times(r2).plus(1).sqrt().plus(r2), external$1 = true, i2.precision = t4, i2.rounding = n2, r2.ln());
}, P$3$1.inverseHyperbolicTangent = P$3$1.atanh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isFinite() ? a2.e >= 0 ? new o2(a2.abs().eq(1) ? a2.s / 0 : a2.isZero() ? a2 : NaN) : (t4 = o2.precision, n2 = o2.rounding, i2 = a2.sd(), Math.max(i2, t4) < 2 * -a2.e - 1 ? finalise$1(new o2(a2), t4, n2, true) : (o2.precision = r2 = i2 - a2.e, a2 = divide$1$1(a2.plus(1), new o2(1).minus(a2), r2 + t4, 1), o2.precision = t4 + 4, o2.rounding = 1, a2 = a2.ln(), o2.precision = t4, o2.rounding = n2, a2.times(0.5))) : new o2(NaN);
}, P$3$1.inverseSine = P$3$1.asin = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isZero() ? new o2(a2) : (n2 = a2.abs().cmp(1), r2 = o2.precision, i2 = o2.rounding, n2 === -1 ? (o2.precision = r2 + 6, o2.rounding = 1, a2 = a2.div(new o2(1).minus(a2.times(a2)).sqrt().plus(1)).atan(), o2.precision = r2, o2.rounding = i2, a2.times(2)) : n2 === 0 ? (t4 = getPi$1(o2, r2 + 4, i2).times(0.5), t4.s = a2.s, t4) : new o2(NaN));
}, P$3$1.inverseTangent = P$3$1.atan = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding;
  if (!u2.isFinite()) {
    if (!u2.s) return new d2(NaN);
    if (p2 + 4 <= PI_PRECISION$1) return s2 = getPi$1(d2, p2 + 4, m2).times(0.5), s2.s = u2.s, s2;
  } else if (u2.isZero()) return new d2(u2);
  else if (u2.abs().eq(1) && p2 + 4 <= PI_PRECISION$1) return s2 = getPi$1(d2, p2 + 4, m2).times(0.25), s2.s = u2.s, s2;
  for (d2.precision = c2 = p2 + 10, d2.rounding = 1, r2 = Math.min(28, c2 / LOG_BASE$1 + 2 | 0), t4 = r2; t4; --t4) u2 = u2.div(u2.times(u2).plus(1).sqrt().plus(1));
  for (external$1 = false, n2 = Math.ceil(c2 / LOG_BASE$1), i2 = 1, l2 = u2.times(u2), s2 = new d2(u2), a2 = u2; t4 !== -1; ) if (a2 = a2.times(l2), o2 = s2.minus(a2.div(i2 += 2)), a2 = a2.times(l2), s2 = o2.plus(a2.div(i2 += 2)), s2.d[n2] !== void 0) for (t4 = n2; s2.d[t4] === o2.d[t4] && t4--; ) ;
  return r2 && (s2 = s2.times(2 << r2 - 1)), external$1 = true, finalise$1(s2, d2.precision = p2, d2.rounding = m2, true);
}, P$3$1.isFinite = function() {
  return !!this.d;
}, P$3$1.isInteger = P$3$1.isInt = function() {
  return !!this.d && mathfloor$1(this.e / LOG_BASE$1) > this.d.length - 2;
}, P$3$1.isNaN = function() {
  return !this.s;
}, P$3$1.isNegative = P$3$1.isNeg = function() {
  return this.s < 0;
}, P$3$1.isPositive = P$3$1.isPos = function() {
  return this.s > 0;
}, P$3$1.isZero = function() {
  return !!this.d && this.d[0] === 0;
}, P$3$1.lessThan = P$3$1.lt = function(t4) {
  return this.cmp(t4) < 0;
}, P$3$1.lessThanOrEqualTo = P$3$1.lte = function(t4) {
  return this.cmp(t4) < 1;
}, P$3$1.logarithm = P$3$1.log = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding, h2 = 5;
  if (t4 == null) t4 = new d2(10), n2 = true;
  else {
    if (t4 = new d2(t4), r2 = t4.d, t4.s < 0 || !r2 || !r2[0] || t4.eq(1)) return new d2(NaN);
    n2 = t4.eq(10);
  }
  if (r2 = u2.d, u2.s < 0 || !r2 || !r2[0] || u2.eq(1)) return new d2(r2 && !r2[0] ? -1 / 0 : u2.s == 1 ? r2 ? 0 : 1 / 0 : NaN);
  if (n2) if (r2.length > 1) o2 = true;
  else {
    for (a2 = r2[0]; a2 % 10 == 0; ) a2 /= 10;
    o2 = a2 !== 1;
  }
  if (external$1 = false, c2 = p2 + h2, s2 = naturalLogarithm$1(u2, c2), i2 = n2 ? getLn10$1(d2, c2 + 10) : naturalLogarithm$1(t4, c2), l2 = divide$1$1(s2, i2, c2, 1), checkRoundingDigits$1(l2.d, a2 = p2, m2)) do
    if (c2 += 10, s2 = naturalLogarithm$1(u2, c2), i2 = n2 ? getLn10$1(d2, c2 + 10) : naturalLogarithm$1(t4, c2), l2 = divide$1$1(s2, i2, c2, 1), !o2) {
      +digitsToString$1(l2.d).slice(a2 + 1, a2 + 15) + 1 == 1e14 && (l2 = finalise$1(l2, p2 + 1, 0));
      break;
    }
  while (checkRoundingDigits$1(l2.d, a2 += 10, m2));
  return external$1 = true, finalise$1(l2, p2, m2);
}, P$3$1.minus = P$3$1.sub = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.constructor;
  if (t4 = new g2(t4), !h2.d || !t4.d) return !h2.s || !t4.s ? t4 = new g2(NaN) : h2.d ? t4.s = -t4.s : t4 = new g2(t4.d || h2.s !== t4.s ? h2 : NaN), t4;
  if (h2.s != t4.s) return t4.s = -t4.s, h2.plus(t4);
  if (u2 = h2.d, m2 = t4.d, c2 = g2.precision, l2 = g2.rounding, !u2[0] || !m2[0]) {
    if (m2[0]) t4.s = -t4.s;
    else if (u2[0]) t4 = new g2(h2);
    else return new g2(l2 === 3 ? -0 : 0);
    return external$1 ? finalise$1(t4, c2, l2) : t4;
  }
  if (r2 = mathfloor$1(t4.e / LOG_BASE$1), d2 = mathfloor$1(h2.e / LOG_BASE$1), u2 = u2.slice(), o2 = d2 - r2, o2) {
    for (p2 = o2 < 0, p2 ? (n2 = u2, o2 = -o2, s2 = m2.length) : (n2 = m2, r2 = d2, s2 = u2.length), i2 = Math.max(Math.ceil(c2 / LOG_BASE$1), s2) + 2, o2 > i2 && (o2 = i2, n2.length = 1), n2.reverse(), i2 = o2; i2--; ) n2.push(0);
    n2.reverse();
  } else {
    for (i2 = u2.length, s2 = m2.length, p2 = i2 < s2, p2 && (s2 = i2), i2 = 0; i2 < s2; i2++) if (u2[i2] != m2[i2]) {
      p2 = u2[i2] < m2[i2];
      break;
    }
    o2 = 0;
  }
  for (p2 && (n2 = u2, u2 = m2, m2 = n2, t4.s = -t4.s), s2 = u2.length, i2 = m2.length - s2; i2 > 0; --i2) u2[s2++] = 0;
  for (i2 = m2.length; i2 > o2; ) {
    if (u2[--i2] < m2[i2]) {
      for (a2 = i2; a2 && u2[--a2] === 0; ) u2[a2] = BASE$1 - 1;
      --u2[a2], u2[i2] += BASE$1;
    }
    u2[i2] -= m2[i2];
  }
  for (; u2[--s2] === 0; ) u2.pop();
  for (; u2[0] === 0; u2.shift()) --r2;
  return u2[0] ? (t4.d = u2, t4.e = getBase10Exponent$1(u2, r2), external$1 ? finalise$1(t4, c2, l2) : t4) : new g2(l2 === 3 ? -0 : 0);
}, P$3$1.modulo = P$3$1.mod = function(t4) {
  var n2, r2 = this, i2 = r2.constructor;
  return t4 = new i2(t4), !r2.d || !t4.s || t4.d && !t4.d[0] ? new i2(NaN) : !t4.d || r2.d && !r2.d[0] ? finalise$1(new i2(r2), i2.precision, i2.rounding) : (external$1 = false, i2.modulo == 9 ? (n2 = divide$1$1(r2, t4.abs(), 0, 3, 1), n2.s *= t4.s) : n2 = divide$1$1(r2, t4, 0, i2.modulo, 1), n2 = n2.times(t4), external$1 = true, r2.minus(n2));
}, P$3$1.naturalExponential = P$3$1.exp = function() {
  return naturalExponential$1(this);
}, P$3$1.naturalLogarithm = P$3$1.ln = function() {
  return naturalLogarithm$1(this);
}, P$3$1.negated = P$3$1.neg = function() {
  var t4 = new this.constructor(this);
  return t4.s = -t4.s, finalise$1(t4);
}, P$3$1.plus = P$3$1.add = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2 = this, m2 = p2.constructor;
  if (t4 = new m2(t4), !p2.d || !t4.d) return !p2.s || !t4.s ? t4 = new m2(NaN) : p2.d || (t4 = new m2(t4.d || p2.s === t4.s ? p2 : NaN)), t4;
  if (p2.s != t4.s) return t4.s = -t4.s, p2.minus(t4);
  if (u2 = p2.d, d2 = t4.d, c2 = m2.precision, l2 = m2.rounding, !u2[0] || !d2[0]) return d2[0] || (t4 = new m2(p2)), external$1 ? finalise$1(t4, c2, l2) : t4;
  if (o2 = mathfloor$1(p2.e / LOG_BASE$1), i2 = mathfloor$1(t4.e / LOG_BASE$1), u2 = u2.slice(), a2 = o2 - i2, a2) {
    for (a2 < 0 ? (r2 = u2, a2 = -a2, s2 = d2.length) : (r2 = d2, i2 = o2, s2 = u2.length), o2 = Math.ceil(c2 / LOG_BASE$1), s2 = o2 > s2 ? o2 + 1 : s2 + 1, a2 > s2 && (a2 = s2, r2.length = 1), r2.reverse(); a2--; ) r2.push(0);
    r2.reverse();
  }
  for (s2 = u2.length, a2 = d2.length, s2 - a2 < 0 && (a2 = s2, r2 = d2, d2 = u2, u2 = r2), n2 = 0; a2; ) n2 = (u2[--a2] = u2[a2] + d2[a2] + n2) / BASE$1 | 0, u2[a2] %= BASE$1;
  for (n2 && (u2.unshift(n2), ++i2), s2 = u2.length; u2[--s2] == 0; ) u2.pop();
  return t4.d = u2, t4.e = getBase10Exponent$1(u2, i2), external$1 ? finalise$1(t4, c2, l2) : t4;
}, P$3$1.precision = P$3$1.sd = function(t4) {
  var n2, r2 = this;
  if (t4 !== void 0 && t4 !== !!t4 && t4 !== 1 && t4 !== 0) throw Error(invalidArgument$1 + t4);
  return r2.d ? (n2 = getPrecision$1(r2.d), t4 && r2.e + 1 > n2 && (n2 = r2.e + 1)) : n2 = NaN, n2;
}, P$3$1.round = function() {
  var t4 = this, n2 = t4.constructor;
  return finalise$1(new n2(t4), t4.e + 1, n2.rounding);
}, P$3$1.sine = P$3$1.sin = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE$1, i2.rounding = 1, r2 = sine$1(i2, toLessThanHalfPi$1(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise$1(quadrant$1 > 2 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3$1.squareRoot = P$3$1.sqrt = function() {
  var t4, n2, r2, i2, a2, o2, s2 = this, c2 = s2.d, l2 = s2.e, u2 = s2.s, d2 = s2.constructor;
  if (u2 !== 1 || !c2 || !c2[0]) return new d2(!u2 || u2 < 0 && (!c2 || c2[0]) ? NaN : c2 ? s2 : 1 / 0);
  for (external$1 = false, u2 = Math.sqrt(+s2), u2 == 0 || u2 == 1 / 0 ? (n2 = digitsToString$1(c2), (n2.length + l2) % 2 == 0 && (n2 += `0`), u2 = Math.sqrt(n2), l2 = mathfloor$1((l2 + 1) / 2) - (l2 < 0 || l2 % 2), u2 == 1 / 0 ? n2 = `5e` + l2 : (n2 = u2.toExponential(), n2 = n2.slice(0, n2.indexOf(`e`) + 1) + l2), i2 = new d2(n2)) : i2 = new d2(u2.toString()), r2 = (l2 = d2.precision) + 3; ; ) if (o2 = i2, i2 = o2.plus(divide$1$1(s2, o2, r2 + 2, 1)).times(0.5), digitsToString$1(o2.d).slice(0, r2) === (n2 = digitsToString$1(i2.d)).slice(0, r2)) if (n2 = n2.slice(r2 - 3, r2 + 1), n2 == `9999` || !a2 && n2 == `4999`) {
    if (!a2 && (finalise$1(o2, l2 + 1, 0), o2.times(o2).eq(s2))) {
      i2 = o2;
      break;
    }
    r2 += 4, a2 = 1;
  } else {
    (!+n2 || !+n2.slice(1) && n2.charAt(0) == `5`) && (finalise$1(i2, l2 + 1, 1), t4 = !i2.times(i2).eq(s2));
    break;
  }
  return external$1 = true, finalise$1(i2, l2, d2.rounding, t4);
}, P$3$1.tangent = P$3$1.tan = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 10, i2.rounding = 1, r2 = r2.sin(), r2.s = 1, r2 = divide$1$1(r2, new i2(1).minus(r2.times(r2)).sqrt(), t4 + 10, 0), i2.precision = t4, i2.rounding = n2, finalise$1(quadrant$1 == 2 || quadrant$1 == 4 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3$1.times = P$3$1.mul = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor, m2 = d2.d, h2 = (t4 = new p2(t4)).d;
  if (t4.s *= d2.s, !m2 || !m2[0] || !h2 || !h2[0]) return new p2(!t4.s || m2 && !m2[0] && !h2 || h2 && !h2[0] && !m2 ? NaN : !m2 || !h2 ? t4.s / 0 : t4.s * 0);
  for (r2 = mathfloor$1(d2.e / LOG_BASE$1) + mathfloor$1(t4.e / LOG_BASE$1), l2 = m2.length, u2 = h2.length, l2 < u2 && (o2 = m2, m2 = h2, h2 = o2, s2 = l2, l2 = u2, u2 = s2), o2 = [], s2 = l2 + u2, i2 = s2; i2--; ) o2.push(0);
  for (i2 = u2; --i2 >= 0; ) {
    for (n2 = 0, a2 = l2 + i2; a2 > i2; ) c2 = o2[a2] + h2[i2] * m2[a2 - i2 - 1] + n2, o2[a2--] = c2 % BASE$1 | 0, n2 = c2 / BASE$1 | 0;
    o2[a2] = (o2[a2] + n2) % BASE$1 | 0;
  }
  for (; !o2[--s2]; ) o2.pop();
  return n2 ? ++r2 : o2.shift(), t4.d = o2, t4.e = getBase10Exponent$1(o2, r2), external$1 ? finalise$1(t4, p2.precision, p2.rounding) : t4;
}, P$3$1.toBinary = function(t4, n2) {
  return toStringBinary$1(this, 2, t4, n2);
}, P$3$1.toDecimalPlaces = P$3$1.toDP = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return r2 = new i2(r2), t4 === void 0 ? r2 : (checkInt32$1(t4, 0, MAX_DIGITS$1), n2 === void 0 ? n2 = i2.rounding : checkInt32$1(n2, 0, 8), finalise$1(r2, t4 + r2.e + 1, n2));
}, P$3$1.toExponential = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString$1(i2, true) : (checkInt32$1(t4, 0, MAX_DIGITS$1), n2 === void 0 ? n2 = a2.rounding : checkInt32$1(n2, 0, 8), i2 = finalise$1(new a2(i2), t4 + 1, n2), r2 = finiteToString$1(i2, true, t4 + 1)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3$1.toFixed = function(t4, n2) {
  var r2, i2, a2 = this, o2 = a2.constructor;
  return t4 === void 0 ? r2 = finiteToString$1(a2) : (checkInt32$1(t4, 0, MAX_DIGITS$1), n2 === void 0 ? n2 = o2.rounding : checkInt32$1(n2, 0, 8), i2 = finalise$1(new o2(a2), t4 + a2.e + 1, n2), r2 = finiteToString$1(i2, false, t4 + i2.e + 1)), a2.isNeg() && !a2.isZero() ? `-` + r2 : r2;
}, P$3$1.toFraction = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.d, v2 = h2.constructor;
  if (!g2) return new v2(h2);
  if (u2 = r2 = new v2(1), i2 = l2 = new v2(0), n2 = new v2(i2), o2 = n2.e = getPrecision$1(g2) - h2.e - 1, s2 = o2 % LOG_BASE$1, n2.d[0] = mathpow$1(10, s2 < 0 ? LOG_BASE$1 + s2 : s2), t4 == null) t4 = o2 > 0 ? n2 : u2;
  else {
    if (c2 = new v2(t4), !c2.isInt() || c2.lt(u2)) throw Error(invalidArgument$1 + c2);
    t4 = c2.gt(n2) ? o2 > 0 ? n2 : u2 : c2;
  }
  for (external$1 = false, c2 = new v2(digitsToString$1(g2)), d2 = v2.precision, v2.precision = o2 = g2.length * LOG_BASE$1 * 2; p2 = divide$1$1(c2, n2, 0, 1, 1), a2 = r2.plus(p2.times(i2)), a2.cmp(t4) != 1; ) r2 = i2, i2 = a2, a2 = u2, u2 = l2.plus(p2.times(a2)), l2 = a2, a2 = n2, n2 = c2.minus(p2.times(a2)), c2 = a2;
  return a2 = divide$1$1(t4.minus(r2), i2, 0, 1, 1), l2 = l2.plus(a2.times(u2)), r2 = r2.plus(a2.times(i2)), l2.s = u2.s = h2.s, m2 = divide$1$1(u2, i2, o2, 1).minus(h2).abs().cmp(divide$1$1(l2, r2, o2, 1).minus(h2).abs()) < 1 ? [u2, i2] : [l2, r2], v2.precision = d2, external$1 = true, m2;
}, P$3$1.toHexadecimal = P$3$1.toHex = function(t4, n2) {
  return toStringBinary$1(this, 16, t4, n2);
}, P$3$1.toNearest = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  if (r2 = new i2(r2), t4 == null) {
    if (!r2.d) return r2;
    t4 = new i2(1), n2 = i2.rounding;
  } else {
    if (t4 = new i2(t4), n2 === void 0 ? n2 = i2.rounding : checkInt32$1(n2, 0, 8), !r2.d) return t4.s ? r2 : t4;
    if (!t4.d) return t4.s &&= r2.s, t4;
  }
  return t4.d[0] ? (external$1 = false, r2 = divide$1$1(r2, t4, 0, n2, 1).times(t4), external$1 = true, finalise$1(r2)) : (t4.s = r2.s, r2 = t4), r2;
}, P$3$1.toNumber = function() {
  return +this;
}, P$3$1.toOctal = function(t4, n2) {
  return toStringBinary$1(this, 8, t4, n2);
}, P$3$1.toPower = P$3$1.pow = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2 = this, l2 = c2.constructor, u2 = +(t4 = new l2(t4));
  if (!c2.d || !t4.d || !c2.d[0] || !t4.d[0]) return new l2(mathpow$1(+c2, u2));
  if (c2 = new l2(c2), c2.eq(1)) return c2;
  if (i2 = l2.precision, o2 = l2.rounding, t4.eq(1)) return finalise$1(c2, i2, o2);
  if (n2 = mathfloor$1(t4.e / LOG_BASE$1), n2 >= t4.d.length - 1 && (r2 = u2 < 0 ? -u2 : u2) <= MAX_SAFE_INTEGER$1) return a2 = intPow$1(l2, c2, r2, i2), t4.s < 0 ? new l2(1).div(a2) : finalise$1(a2, i2, o2);
  if (s2 = c2.s, s2 < 0) {
    if (n2 < t4.d.length - 1) return new l2(NaN);
    if (t4.d[n2] & 1 || (s2 = 1), c2.e == 0 && c2.d[0] == 1 && c2.d.length == 1) return c2.s = s2, c2;
  }
  return r2 = mathpow$1(+c2, u2), n2 = r2 == 0 || !isFinite(r2) ? mathfloor$1(u2 * (Math.log(`0.` + digitsToString$1(c2.d)) / Math.LN10 + c2.e + 1)) : new l2(r2 + ``).e, n2 > l2.maxE + 1 || n2 < l2.minE - 1 ? new l2(n2 > 0 ? s2 / 0 : 0) : (external$1 = false, l2.rounding = c2.s = 1, r2 = Math.min(12, (n2 + ``).length), a2 = naturalExponential$1(t4.times(naturalLogarithm$1(c2, i2 + r2)), i2), a2.d && (a2 = finalise$1(a2, i2 + 5, 1), checkRoundingDigits$1(a2.d, i2, o2) && (n2 = i2 + 10, a2 = finalise$1(naturalExponential$1(t4.times(naturalLogarithm$1(c2, n2 + r2)), n2), n2 + 5, 1), +digitsToString$1(a2.d).slice(i2 + 1, i2 + 15) + 1 == 1e14 && (a2 = finalise$1(a2, i2 + 1, 0)))), a2.s = s2, external$1 = true, l2.rounding = o2, finalise$1(a2, i2, o2));
}, P$3$1.toPrecision = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString$1(i2, i2.e <= a2.toExpNeg || i2.e >= a2.toExpPos) : (checkInt32$1(t4, 1, MAX_DIGITS$1), n2 === void 0 ? n2 = a2.rounding : checkInt32$1(n2, 0, 8), i2 = finalise$1(new a2(i2), t4, n2), r2 = finiteToString$1(i2, t4 <= i2.e || i2.e <= a2.toExpNeg, t4)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3$1.toSignificantDigits = P$3$1.toSD = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return t4 === void 0 ? (t4 = i2.precision, n2 = i2.rounding) : (checkInt32$1(t4, 1, MAX_DIGITS$1), n2 === void 0 ? n2 = i2.rounding : checkInt32$1(n2, 0, 8)), finalise$1(new i2(r2), t4, n2);
}, P$3$1.toString = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString$1(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() && !t4.isZero() ? `-` + r2 : r2;
}, P$3$1.truncated = P$3$1.trunc = function() {
  return finalise$1(new this.constructor(this), this.e + 1, 1);
}, P$3$1.valueOf = P$3$1.toJSON = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString$1(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() ? `-` + r2 : r2;
};
function digitsToString$1(t4) {
  var n2, r2, i2, a2 = t4.length - 1, o2 = ``, s2 = t4[0];
  if (a2 > 0) {
    for (o2 += s2, n2 = 1; n2 < a2; n2++) i2 = t4[n2] + ``, r2 = LOG_BASE$1 - i2.length, r2 && (o2 += getZeroString$1(r2)), o2 += i2;
    s2 = t4[n2], i2 = s2 + ``, r2 = LOG_BASE$1 - i2.length, r2 && (o2 += getZeroString$1(r2));
  } else if (s2 === 0) return `0`;
  for (; s2 % 10 == 0; ) s2 /= 10;
  return o2 + s2;
}
function checkInt32$1(t4, n2, r2) {
  if (t4 !== ~~t4 || t4 < n2 || t4 > r2) throw Error(invalidArgument$1 + t4);
}
function checkRoundingDigits$1(t4, n2, r2, i2) {
  var a2, o2, s2, c2;
  for (o2 = t4[0]; o2 >= 10; o2 /= 10) --n2;
  return --n2 < 0 ? (n2 += LOG_BASE$1, a2 = 0) : (a2 = Math.ceil((n2 + 1) / LOG_BASE$1), n2 %= LOG_BASE$1), o2 = mathpow$1(10, LOG_BASE$1 - n2), c2 = t4[a2] % o2 | 0, i2 == null ? n2 < 3 ? (n2 == 0 ? c2 = c2 / 100 | 0 : n2 == 1 && (c2 = c2 / 10 | 0), s2 = r2 < 4 && c2 == 99999 || r2 > 3 && c2 == 49999 || c2 == 5e4 || c2 == 0) : s2 = (r2 < 4 && c2 + 1 == o2 || r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 100 | 0) == mathpow$1(10, n2 - 2) - 1 || (c2 == o2 / 2 || c2 == 0) && (t4[a2 + 1] / o2 / 100 | 0) == 0 : n2 < 4 ? (n2 == 0 ? c2 = c2 / 1e3 | 0 : n2 == 1 ? c2 = c2 / 100 | 0 : n2 == 2 && (c2 = c2 / 10 | 0), s2 = (i2 || r2 < 4) && c2 == 9999 || !i2 && r2 > 3 && c2 == 4999) : s2 = ((i2 || r2 < 4) && c2 + 1 == o2 || !i2 && r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 1e3 | 0) == mathpow$1(10, n2 - 3) - 1, s2;
}
function convertBase$1(t4, n2, r2) {
  for (var i2, a2 = [0], o2, s2 = 0, c2 = t4.length; s2 < c2; ) {
    for (o2 = a2.length; o2--; ) a2[o2] *= n2;
    for (a2[0] += NUMERALS$1.indexOf(t4.charAt(s2++)), i2 = 0; i2 < a2.length; i2++) a2[i2] > r2 - 1 && (a2[i2 + 1] === void 0 && (a2[i2 + 1] = 0), a2[i2 + 1] += a2[i2] / r2 | 0, a2[i2] %= r2);
  }
  return a2.reverse();
}
function cosine$1(t4, n2) {
  var r2, i2, a2;
  if (n2.isZero()) return n2;
  i2 = n2.d.length, i2 < 32 ? (r2 = Math.ceil(i2 / 3), a2 = (1 / tinyPow$1(4, r2)).toString()) : (r2 = 16, a2 = `2.3283064365386962890625e-10`), t4.precision += r2, n2 = taylorSeries$1(t4, 1, n2.times(a2), new t4(1));
  for (var o2 = r2; o2--; ) {
    var s2 = n2.times(n2);
    n2 = s2.times(s2).minus(s2).times(8).plus(1);
  }
  return t4.precision -= r2, n2;
}
var divide$1$1 = /* @__PURE__ */ (function() {
  function t4(t5, n3, r3) {
    var i2, a2 = 0, o2 = t5.length;
    for (t5 = t5.slice(); o2--; ) i2 = t5[o2] * n3 + a2, t5[o2] = i2 % r3 | 0, a2 = i2 / r3 | 0;
    return a2 && t5.unshift(a2), t5;
  }
  function n2(t5, n3, r3, i2) {
    var a2, o2;
    if (r3 != i2) o2 = r3 > i2 ? 1 : -1;
    else for (a2 = o2 = 0; a2 < r3; a2++) if (t5[a2] != n3[a2]) {
      o2 = t5[a2] > n3[a2] ? 1 : -1;
      break;
    }
    return o2;
  }
  function r2(t5, n3, r3, i2) {
    for (var a2 = 0; r3--; ) t5[r3] -= a2, a2 = +(t5[r3] < n3[r3]), t5[r3] = a2 * i2 + t5[r3] - n3[r3];
    for (; !t5[0] && t5.length > 1; ) t5.shift();
  }
  return function(i2, a2, o2, s2, c2, l2) {
    var u2, d2, p2, m2, h2, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2, L2 = i2.constructor, R2 = i2.s == a2.s ? 1 : -1, z2 = i2.d, V2 = a2.d;
    if (!z2 || !z2[0] || !V2 || !V2[0]) return new L2(!i2.s || !a2.s || (z2 ? V2 && z2[0] == V2[0] : !V2) ? NaN : z2 && z2[0] == 0 || !V2 ? R2 * 0 : R2 / 0);
    for (l2 ? (h2 = 1, d2 = i2.e - a2.e) : (l2 = BASE$1, h2 = LOG_BASE$1, d2 = mathfloor$1(i2.e / h2) - mathfloor$1(a2.e / h2)), F = V2.length, M2 = z2.length, b2 = new L2(R2), x2 = b2.d = [], p2 = 0; V2[p2] == (z2[p2] || 0); p2++) ;
    if (V2[p2] > (z2[p2] || 0) && d2--, o2 == null ? (D = o2 = L2.precision, s2 = L2.rounding) : D = c2 ? o2 + (i2.e - a2.e) + 1 : o2, D < 0) x2.push(1), g2 = true;
    else {
      if (D = D / h2 + 2 | 0, p2 = 0, F == 1) {
        for (m2 = 0, V2 = V2[0], D++; (p2 < M2 || m2) && D--; p2++) O2 = m2 * l2 + (z2[p2] || 0), x2[p2] = O2 / V2 | 0, m2 = O2 % V2 | 0;
        g2 = m2 || p2 < M2;
      } else {
        for (m2 = l2 / (V2[0] + 1) | 0, m2 > 1 && (V2 = t4(V2, m2, l2), z2 = t4(z2, m2, l2), F = V2.length, M2 = z2.length), j2 = F, S2 = z2.slice(0, F), w2 = S2.length; w2 < F; ) S2[w2++] = 0;
        I2 = V2.slice(), I2.unshift(0), N2 = V2[0], V2[1] >= l2 / 2 && ++N2;
        do
          m2 = 0, u2 = n2(V2, S2, F, w2), u2 < 0 ? (E = S2[0], F != w2 && (E = E * l2 + (S2[1] || 0)), m2 = E / N2 | 0, m2 > 1 ? (m2 >= l2 && (m2 = l2 - 1), v2 = t4(V2, m2, l2), y2 = v2.length, w2 = S2.length, u2 = n2(v2, S2, y2, w2), u2 == 1 && (m2--, r2(v2, F < y2 ? I2 : V2, y2, l2))) : (m2 == 0 && (u2 = m2 = 1), v2 = V2.slice()), y2 = v2.length, y2 < w2 && v2.unshift(0), r2(S2, v2, w2, l2), u2 == -1 && (w2 = S2.length, u2 = n2(V2, S2, F, w2), u2 < 1 && (m2++, r2(S2, F < w2 ? I2 : V2, w2, l2))), w2 = S2.length) : u2 === 0 && (m2++, S2 = [0]), x2[p2++] = m2, u2 && S2[0] ? S2[w2++] = z2[j2] || 0 : (S2 = [z2[j2]], w2 = 1);
        while ((j2++ < M2 || S2[0] !== void 0) && D--);
        g2 = S2[0] !== void 0;
      }
      x2[0] || x2.shift();
    }
    if (h2 == 1) b2.e = d2, inexact$1 = g2;
    else {
      for (p2 = 1, m2 = x2[0]; m2 >= 10; m2 /= 10) p2++;
      b2.e = p2 + d2 * h2 - 1, finalise$1(b2, c2 ? o2 + b2.e + 1 : o2, s2, g2);
    }
    return b2;
  };
})();
function finalise$1(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor;
  out: if (n2 != null) {
    if (p2 = t4.d, !p2) return t4;
    for (a2 = 1, c2 = p2[0]; c2 >= 10; c2 /= 10) a2++;
    if (o2 = n2 - a2, o2 < 0) o2 += LOG_BASE$1, s2 = n2, d2 = p2[m2 = 0], l2 = d2 / mathpow$1(10, a2 - s2 - 1) % 10 | 0;
    else if (m2 = Math.ceil((o2 + 1) / LOG_BASE$1), c2 = p2.length, m2 >= c2) if (i2) {
      for (; c2++ <= m2; ) p2.push(0);
      d2 = l2 = 0, a2 = 1, o2 %= LOG_BASE$1, s2 = o2 - LOG_BASE$1 + 1;
    } else break out;
    else {
      for (d2 = c2 = p2[m2], a2 = 1; c2 >= 10; c2 /= 10) a2++;
      o2 %= LOG_BASE$1, s2 = o2 - LOG_BASE$1 + a2, l2 = s2 < 0 ? 0 : d2 / mathpow$1(10, a2 - s2 - 1) % 10 | 0;
    }
    if (i2 = i2 || n2 < 0 || p2[m2 + 1] !== void 0 || (s2 < 0 ? d2 : d2 % mathpow$1(10, a2 - s2 - 1)), u2 = r2 < 4 ? (l2 || i2) && (r2 == 0 || r2 == (t4.s < 0 ? 3 : 2)) : l2 > 5 || l2 == 5 && (r2 == 4 || i2 || r2 == 6 && (o2 > 0 ? s2 > 0 ? d2 / mathpow$1(10, a2 - s2) : 0 : p2[m2 - 1]) % 10 & 1 || r2 == (t4.s < 0 ? 8 : 7)), n2 < 1 || !p2[0]) return p2.length = 0, u2 ? (n2 -= t4.e + 1, p2[0] = mathpow$1(10, (LOG_BASE$1 - n2 % LOG_BASE$1) % LOG_BASE$1), t4.e = -n2 || 0) : p2[0] = t4.e = 0, t4;
    if (o2 == 0 ? (p2.length = m2, c2 = 1, m2--) : (p2.length = m2 + 1, c2 = mathpow$1(10, LOG_BASE$1 - o2), p2[m2] = s2 > 0 ? (d2 / mathpow$1(10, a2 - s2) % mathpow$1(10, s2) | 0) * c2 : 0), u2) for (; ; ) if (m2 == 0) {
      for (o2 = 1, s2 = p2[0]; s2 >= 10; s2 /= 10) o2++;
      for (s2 = p2[0] += c2, c2 = 1; s2 >= 10; s2 /= 10) c2++;
      o2 != c2 && (t4.e++, p2[0] == BASE$1 && (p2[0] = 1));
      break;
    } else {
      if (p2[m2] += c2, p2[m2] != BASE$1) break;
      p2[m2--] = 0, c2 = 1;
    }
    for (o2 = p2.length; p2[--o2] === 0; ) p2.pop();
  }
  return external$1 && (t4.e > h2.maxE ? (t4.d = null, t4.e = NaN) : t4.e < h2.minE && (t4.e = 0, t4.d = [0])), t4;
}
function finiteToString$1(t4, n2, r2) {
  if (!t4.isFinite()) return nonFiniteToString$1(t4);
  var i2, a2 = t4.e, o2 = digitsToString$1(t4.d), s2 = o2.length;
  return n2 ? (r2 && (i2 = r2 - s2) > 0 ? o2 = o2.charAt(0) + `.` + o2.slice(1) + getZeroString$1(i2) : s2 > 1 && (o2 = o2.charAt(0) + `.` + o2.slice(1)), o2 = o2 + (t4.e < 0 ? `e` : `e+`) + t4.e) : a2 < 0 ? (o2 = `0.` + getZeroString$1(-a2 - 1) + o2, r2 && (i2 = r2 - s2) > 0 && (o2 += getZeroString$1(i2))) : a2 >= s2 ? (o2 += getZeroString$1(a2 + 1 - s2), r2 && (i2 = r2 - a2 - 1) > 0 && (o2 = o2 + `.` + getZeroString$1(i2))) : ((i2 = a2 + 1) < s2 && (o2 = o2.slice(0, i2) + `.` + o2.slice(i2)), r2 && (i2 = r2 - s2) > 0 && (a2 + 1 === s2 && (o2 += `.`), o2 += getZeroString$1(i2))), o2;
}
function getBase10Exponent$1(t4, n2) {
  var r2 = t4[0];
  for (n2 *= LOG_BASE$1; r2 >= 10; r2 /= 10) n2++;
  return n2;
}
function getLn10$1(t4, n2, r2) {
  if (n2 > LN10_PRECISION$1) throw external$1 = true, r2 && (t4.precision = r2), Error(precisionLimitExceeded$1);
  return finalise$1(new t4(LN10$1), n2, 1, true);
}
function getPi$1(t4, n2, r2) {
  if (n2 > PI_PRECISION$1) throw Error(precisionLimitExceeded$1);
  return finalise$1(new t4(PI$1), n2, r2, true);
}
function getPrecision$1(t4) {
  var n2 = t4.length - 1, r2 = n2 * LOG_BASE$1 + 1;
  if (n2 = t4[n2], n2) {
    for (; n2 % 10 == 0; n2 /= 10) r2--;
    for (n2 = t4[0]; n2 >= 10; n2 /= 10) r2++;
  }
  return r2;
}
function getZeroString$1(t4) {
  for (var n2 = ``; t4--; ) n2 += `0`;
  return n2;
}
function intPow$1(t4, n2, r2, i2) {
  var a2, o2 = new t4(1), s2 = Math.ceil(i2 / LOG_BASE$1 + 4);
  for (external$1 = false; ; ) {
    if (r2 % 2 && (o2 = o2.times(n2), truncate$1(o2.d, s2) && (a2 = true)), r2 = mathfloor$1(r2 / 2), r2 === 0) {
      r2 = o2.d.length - 1, a2 && o2.d[r2] === 0 && ++o2.d[r2];
      break;
    }
    n2 = n2.times(n2), truncate$1(n2.d, s2);
  }
  return external$1 = true, o2;
}
function isOdd$1(t4) {
  return t4.d[t4.d.length - 1] & 1;
}
function maxOrMin$1(t4, n2, r2) {
  for (var i2, a2 = new t4(n2[0]), o2 = 0; ++o2 < n2.length; ) if (i2 = new t4(n2[o2]), i2.s) a2[r2](i2) && (a2 = i2);
  else {
    a2 = i2;
    break;
  }
  return a2;
}
function naturalExponential$1(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2 = 0, d2 = 0, p2 = 0, m2 = t4.constructor, h2 = m2.rounding, g2 = m2.precision;
  if (!t4.d || !t4.d[0] || t4.e > 17) return new m2(t4.d ? t4.d[0] ? t4.s < 0 ? 0 : 1 / 0 : 1 : t4.s ? t4.s < 0 ? 0 : t4 : NaN);
  for (n2 == null ? (external$1 = false, l2 = g2) : l2 = n2, c2 = new m2(0.03125); t4.e > -2; ) t4 = t4.times(c2), p2 += 5;
  for (i2 = Math.log(mathpow$1(2, p2)) / Math.LN10 * 2 + 5 | 0, l2 += i2, r2 = o2 = s2 = new m2(1), m2.precision = l2; ; ) {
    if (o2 = finalise$1(o2.times(t4), l2, 1), r2 = r2.times(++d2), c2 = s2.plus(divide$1$1(o2, r2, l2, 1)), digitsToString$1(c2.d).slice(0, l2) === digitsToString$1(s2.d).slice(0, l2)) {
      for (a2 = p2; a2--; ) s2 = finalise$1(s2.times(s2), l2, 1);
      if (n2 == null) if (u2 < 3 && checkRoundingDigits$1(s2.d, l2 - i2, h2, u2)) m2.precision = l2 += 10, r2 = o2 = c2 = new m2(1), d2 = 0, u2++;
      else return finalise$1(s2, m2.precision = g2, h2, external$1 = true);
      else return m2.precision = g2, s2;
    }
    s2 = c2;
  }
}
function naturalLogarithm$1(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = 1, g2 = 10, v2 = t4, y2 = v2.d, b2 = v2.constructor, x2 = b2.rounding, S2 = b2.precision;
  if (v2.s < 0 || !y2 || !y2[0] || !v2.e && y2[0] == 1 && y2.length == 1) return new b2(y2 && !y2[0] ? -1 / 0 : v2.s == 1 ? y2 ? 0 : v2 : NaN);
  if (n2 == null ? (external$1 = false, d2 = S2) : d2 = n2, b2.precision = d2 += g2, r2 = digitsToString$1(y2), i2 = r2.charAt(0), Math.abs(o2 = v2.e) < 15e14) {
    for (; i2 < 7 && i2 != 1 || i2 == 1 && r2.charAt(1) > 3; ) v2 = v2.times(t4), r2 = digitsToString$1(v2.d), i2 = r2.charAt(0), h2++;
    o2 = v2.e, i2 > 1 ? (v2 = new b2(`0.` + r2), o2++) : v2 = new b2(i2 + `.` + r2.slice(1));
  } else return u2 = getLn10$1(b2, d2 + 2, S2).times(o2 + ``), v2 = naturalLogarithm$1(new b2(i2 + `.` + r2.slice(1)), d2 - g2).plus(u2), b2.precision = S2, n2 == null ? finalise$1(v2, S2, x2, external$1 = true) : v2;
  for (p2 = v2, l2 = s2 = v2 = divide$1$1(v2.minus(1), v2.plus(1), d2, 1), m2 = finalise$1(v2.times(v2), d2, 1), a2 = 3; ; ) {
    if (s2 = finalise$1(s2.times(m2), d2, 1), u2 = l2.plus(divide$1$1(s2, new b2(a2), d2, 1)), digitsToString$1(u2.d).slice(0, d2) === digitsToString$1(l2.d).slice(0, d2)) if (l2 = l2.times(2), o2 !== 0 && (l2 = l2.plus(getLn10$1(b2, d2 + 2, S2).times(o2 + ``))), l2 = divide$1$1(l2, new b2(h2), d2, 1), n2 == null) if (checkRoundingDigits$1(l2.d, d2 - g2, x2, c2)) b2.precision = d2 += g2, u2 = s2 = v2 = divide$1$1(p2.minus(1), p2.plus(1), d2, 1), m2 = finalise$1(v2.times(v2), d2, 1), a2 = c2 = 1;
    else return finalise$1(l2, b2.precision = S2, x2, external$1 = true);
    else return b2.precision = S2, l2;
    l2 = u2, a2 += 2;
  }
}
function nonFiniteToString$1(t4) {
  return String(t4.s * t4.s / 0);
}
function parseDecimal$1(t4, n2) {
  var r2, i2, a2;
  for ((r2 = n2.indexOf(`.`)) > -1 && (n2 = n2.replace(`.`, ``)), (i2 = n2.search(/e/i)) > 0 ? (r2 < 0 && (r2 = i2), r2 += +n2.slice(i2 + 1), n2 = n2.substring(0, i2)) : r2 < 0 && (r2 = n2.length), i2 = 0; n2.charCodeAt(i2) === 48; i2++) ;
  for (a2 = n2.length; n2.charCodeAt(a2 - 1) === 48; --a2) ;
  if (n2 = n2.slice(i2, a2), n2) {
    if (a2 -= i2, t4.e = r2 = r2 - i2 - 1, t4.d = [], i2 = (r2 + 1) % LOG_BASE$1, r2 < 0 && (i2 += LOG_BASE$1), i2 < a2) {
      for (i2 && t4.d.push(+n2.slice(0, i2)), a2 -= LOG_BASE$1; i2 < a2; ) t4.d.push(+n2.slice(i2, i2 += LOG_BASE$1));
      n2 = n2.slice(i2), i2 = LOG_BASE$1 - n2.length;
    } else i2 -= a2;
    for (; i2--; ) n2 += `0`;
    t4.d.push(+n2), external$1 && (t4.e > t4.constructor.maxE ? (t4.d = null, t4.e = NaN) : t4.e < t4.constructor.minE && (t4.e = 0, t4.d = [0]));
  } else t4.e = 0, t4.d = [0];
  return t4;
}
function parseOther$1(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2;
  if (n2.indexOf(`_`) > -1) {
    if (n2 = n2.replace(/(\d)_(?=\d)/g, `$1`), isDecimal$1.test(n2)) return parseDecimal$1(t4, n2);
  } else if (n2 === `Infinity` || n2 === `NaN`) return +n2 || (t4.s = NaN), t4.e = NaN, t4.d = null, t4;
  if (isHex$1.test(n2)) r2 = 16, n2 = n2.toLowerCase();
  else if (isBinary$1.test(n2)) r2 = 2;
  else if (isOctal$1.test(n2)) r2 = 8;
  else throw Error(invalidArgument$1 + n2);
  for (o2 = n2.search(/p/i), o2 > 0 ? (l2 = +n2.slice(o2 + 1), n2 = n2.substring(2, o2)) : n2 = n2.slice(2), o2 = n2.indexOf(`.`), s2 = o2 >= 0, i2 = t4.constructor, s2 && (n2 = n2.replace(`.`, ``), c2 = n2.length, o2 = c2 - o2, a2 = intPow$1(i2, new i2(r2), o2, o2 * 2)), u2 = convertBase$1(n2, r2, BASE$1), d2 = u2.length - 1, o2 = d2; u2[o2] === 0; --o2) u2.pop();
  return o2 < 0 ? new i2(t4.s * 0) : (t4.e = getBase10Exponent$1(u2, d2), t4.d = u2, external$1 = false, s2 && (t4 = divide$1$1(t4, a2, c2 * 4)), l2 && (t4 = t4.times(Math.abs(l2) < 54 ? mathpow$1(2, l2) : Decimal$1.pow(2, l2))), external$1 = true, t4);
}
function sine$1(t4, n2) {
  var r2, i2 = n2.d.length;
  if (i2 < 3) return n2.isZero() ? n2 : taylorSeries$1(t4, 2, n2, n2);
  r2 = 1.4 * Math.sqrt(i2), r2 = r2 > 16 ? 16 : r2 | 0, n2 = n2.times(1 / tinyPow$1(5, r2)), n2 = taylorSeries$1(t4, 2, n2, n2);
  for (var a2, o2 = new t4(5), s2 = new t4(16), c2 = new t4(20); r2--; ) a2 = n2.times(n2), n2 = n2.times(o2.plus(a2.times(s2.times(a2).minus(c2))));
  return n2;
}
function taylorSeries$1(t4, n2, r2, i2, a2) {
  var o2, s2, c2, l2, d2 = t4.precision, p2 = Math.ceil(d2 / LOG_BASE$1);
  for (external$1 = false, l2 = r2.times(r2), c2 = new t4(i2); ; ) {
    if (s2 = divide$1$1(c2.times(l2), new t4(n2++ * n2++), d2, 1), c2 = a2 ? i2.plus(s2) : i2.minus(s2), i2 = divide$1$1(s2.times(l2), new t4(n2++ * n2++), d2, 1), s2 = c2.plus(i2), s2.d[p2] !== void 0) {
      for (o2 = p2; s2.d[o2] === c2.d[o2] && o2--; ) ;
      if (o2 == -1) break;
    }
    o2 = c2, c2 = i2, i2 = s2, s2 = o2;
  }
  return external$1 = true, s2.d.length = p2 + 1, s2;
}
function tinyPow$1(t4, n2) {
  for (var r2 = t4; --n2; ) r2 *= t4;
  return r2;
}
function toLessThanHalfPi$1(t4, n2) {
  var r2, i2 = n2.s < 0, a2 = getPi$1(t4, t4.precision, 1), o2 = a2.times(0.5);
  if (n2 = n2.abs(), n2.lte(o2)) return quadrant$1 = i2 ? 4 : 1, n2;
  if (r2 = n2.divToInt(a2), r2.isZero()) quadrant$1 = i2 ? 3 : 2;
  else {
    if (n2 = n2.minus(r2.times(a2)), n2.lte(o2)) return quadrant$1 = isOdd$1(r2) ? i2 ? 2 : 3 : i2 ? 4 : 1, n2;
    quadrant$1 = isOdd$1(r2) ? i2 ? 1 : 4 : i2 ? 3 : 2;
  }
  return n2.minus(a2).abs();
}
function toStringBinary$1(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor, g2 = r2 !== void 0;
  if (g2 ? (checkInt32$1(r2, 1, MAX_DIGITS$1), i2 === void 0 ? i2 = h2.rounding : checkInt32$1(i2, 0, 8)) : (r2 = h2.precision, i2 = h2.rounding), !t4.isFinite()) d2 = nonFiniteToString$1(t4);
  else {
    for (d2 = finiteToString$1(t4), s2 = d2.indexOf(`.`), g2 ? (a2 = 2, n2 == 16 ? r2 = r2 * 4 - 3 : n2 == 8 && (r2 = r2 * 3 - 2)) : a2 = n2, s2 >= 0 && (d2 = d2.replace(`.`, ``), m2 = new h2(1), m2.e = d2.length - s2, m2.d = convertBase$1(finiteToString$1(m2), 10, a2), m2.e = m2.d.length), p2 = convertBase$1(d2, 10, a2), o2 = l2 = p2.length; p2[--l2] == 0; ) p2.pop();
    if (!p2[0]) d2 = g2 ? `0p+0` : `0`;
    else {
      if (s2 < 0 ? o2-- : (t4 = new h2(t4), t4.d = p2, t4.e = o2, t4 = divide$1$1(t4, m2, r2, i2, 0, a2), p2 = t4.d, o2 = t4.e, u2 = inexact$1), s2 = p2[r2], c2 = a2 / 2, u2 ||= p2[r2 + 1] !== void 0, u2 = i2 < 4 ? (s2 !== void 0 || u2) && (i2 === 0 || i2 === (t4.s < 0 ? 3 : 2)) : s2 > c2 || s2 === c2 && (i2 === 4 || u2 || i2 === 6 && p2[r2 - 1] & 1 || i2 === (t4.s < 0 ? 8 : 7)), p2.length = r2, u2) for (; ++p2[--r2] > a2 - 1; ) p2[r2] = 0, r2 || (++o2, p2.unshift(1));
      for (l2 = p2.length; !p2[l2 - 1]; --l2) ;
      for (s2 = 0, d2 = ``; s2 < l2; s2++) d2 += NUMERALS$1.charAt(p2[s2]);
      if (g2) {
        if (l2 > 1) if (n2 == 16 || n2 == 8) {
          for (s2 = n2 == 16 ? 4 : 3, --l2; l2 % s2; l2++) d2 += `0`;
          for (p2 = convertBase$1(d2, a2, n2), l2 = p2.length; !p2[l2 - 1]; --l2) ;
          for (s2 = 1, d2 = `1.`; s2 < l2; s2++) d2 += NUMERALS$1.charAt(p2[s2]);
        } else d2 = d2.charAt(0) + `.` + d2.slice(1);
        d2 = d2 + (o2 < 0 ? `p` : `p+`) + o2;
      } else if (o2 < 0) {
        for (; ++o2; ) d2 = `0` + d2;
        d2 = `0.` + d2;
      } else if (++o2 > l2) for (o2 -= l2; o2--; ) d2 += `0`;
      else o2 < l2 && (d2 = d2.slice(0, o2) + `.` + d2.slice(o2));
    }
    d2 = (n2 == 16 ? `0x` : n2 == 2 ? `0b` : n2 == 8 ? `0o` : ``) + d2;
  }
  return t4.s < 0 ? `-` + d2 : d2;
}
function truncate$1(t4, n2) {
  if (t4.length > n2) return t4.length = n2, true;
}
function abs$1$1(t4) {
  return new this(t4).abs();
}
function acos$1$1(t4) {
  return new this(t4).acos();
}
function acosh$1$1(t4) {
  return new this(t4).acosh();
}
function add$1$1(t4, n2) {
  return new this(t4).plus(n2);
}
function asin$1$1(t4) {
  return new this(t4).asin();
}
function asinh$1$1(t4) {
  return new this(t4).asinh();
}
function atan$1$1(t4) {
  return new this(t4).atan();
}
function atanh$1$1(t4) {
  return new this(t4).atanh();
}
function atan2$1$1(t4, n2) {
  t4 = new this(t4), n2 = new this(n2);
  var r2, i2 = this.precision, a2 = this.rounding, o2 = i2 + 4;
  return !t4.s || !n2.s ? r2 = new this(NaN) : !t4.d && !n2.d ? (r2 = getPi$1(this, o2, 1).times(n2.s > 0 ? 0.25 : 0.75), r2.s = t4.s) : !n2.d || t4.isZero() ? (r2 = n2.s < 0 ? getPi$1(this, i2, a2) : new this(0), r2.s = t4.s) : !t4.d || n2.isZero() ? (r2 = getPi$1(this, o2, 1).times(0.5), r2.s = t4.s) : n2.s < 0 ? (this.precision = o2, this.rounding = 1, r2 = this.atan(divide$1$1(t4, n2, o2, 1)), n2 = getPi$1(this, o2, 1), this.precision = i2, this.rounding = a2, r2 = t4.s < 0 ? r2.minus(n2) : r2.plus(n2)) : r2 = this.atan(divide$1$1(t4, n2, o2, 1)), r2;
}
function cbrt$2(t4) {
  return new this(t4).cbrt();
}
function ceil$1(t4) {
  return finalise$1(t4 = new this(t4), t4.e + 1, 2);
}
function clamp$2(t4, n2, r2) {
  return new this(t4).clamp(n2, r2);
}
function config$4(t4) {
  if (!t4 || typeof t4 != `object`) throw Error(decimalError$1 + `Object expected`);
  var n2, r2, i2, a2 = t4.defaults === true, o2 = [`precision`, 1, MAX_DIGITS$1, `rounding`, 0, 8, `toExpNeg`, -EXP_LIMIT$1, 0, `toExpPos`, 0, EXP_LIMIT$1, `maxE`, 0, EXP_LIMIT$1, `minE`, -EXP_LIMIT$1, 0, `modulo`, 0, 9];
  for (n2 = 0; n2 < o2.length; n2 += 3) if (r2 = o2[n2], a2 && (this[r2] = DEFAULTS$1[r2]), (i2 = t4[r2]) !== void 0) if (mathfloor$1(i2) === i2 && i2 >= o2[n2 + 1] && i2 <= o2[n2 + 2]) this[r2] = i2;
  else throw Error(invalidArgument$1 + r2 + `: ` + i2);
  if (r2 = `crypto`, a2 && (this[r2] = DEFAULTS$1[r2]), (i2 = t4[r2]) !== void 0) if (i2 === true || i2 === false || i2 === 0 || i2 === 1) if (i2) if (typeof crypto < `u` && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[r2] = true;
  else throw Error(cryptoUnavailable$1);
  else this[r2] = false;
  else throw Error(invalidArgument$1 + r2 + `: ` + i2);
  return this;
}
function cos$1$1(t4) {
  return new this(t4).cos();
}
function cosh$2$1(t4) {
  return new this(t4).cosh();
}
function clone$2$1(t4) {
  var n2, r2, i2;
  function a2(t5) {
    var n3, r3, i3, o2 = this;
    if (!(o2 instanceof a2)) return new a2(t5);
    if (o2.constructor = a2, isDecimalInstance$1(t5)) {
      o2.s = t5.s, external$1 ? !t5.d || t5.e > a2.maxE ? (o2.e = NaN, o2.d = null) : t5.e < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = t5.e, o2.d = t5.d.slice()) : (o2.e = t5.e, o2.d = t5.d ? t5.d.slice() : t5.d);
      return;
    }
    if (i3 = typeof t5, i3 === `number`) {
      if (t5 === 0) {
        o2.s = 1 / t5 < 0 ? -1 : 1, o2.e = 0, o2.d = [0];
        return;
      }
      if (t5 < 0 ? (t5 = -t5, o2.s = -1) : o2.s = 1, t5 === ~~t5 && t5 < 1e7) {
        for (n3 = 0, r3 = t5; r3 >= 10; r3 /= 10) n3++;
        external$1 ? n3 > a2.maxE ? (o2.e = NaN, o2.d = null) : n3 < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = n3, o2.d = [t5]) : (o2.e = n3, o2.d = [t5]);
        return;
      } else if (t5 * 0 != 0) {
        t5 || (o2.s = NaN), o2.e = NaN, o2.d = null;
        return;
      }
      return parseDecimal$1(o2, t5.toString());
    } else if (i3 !== `string`) throw Error(invalidArgument$1 + t5);
    return (r3 = t5.charCodeAt(0)) === 45 ? (t5 = t5.slice(1), o2.s = -1) : (r3 === 43 && (t5 = t5.slice(1)), o2.s = 1), isDecimal$1.test(t5) ? parseDecimal$1(o2, t5) : parseOther$1(o2, t5);
  }
  if (a2.prototype = P$3$1, a2.ROUND_UP = 0, a2.ROUND_DOWN = 1, a2.ROUND_CEIL = 2, a2.ROUND_FLOOR = 3, a2.ROUND_HALF_UP = 4, a2.ROUND_HALF_DOWN = 5, a2.ROUND_HALF_EVEN = 6, a2.ROUND_HALF_CEIL = 7, a2.ROUND_HALF_FLOOR = 8, a2.EUCLID = 9, a2.config = a2.set = config$4, a2.clone = clone$2$1, a2.isDecimal = isDecimalInstance$1, a2.abs = abs$1$1, a2.acos = acos$1$1, a2.acosh = acosh$1$1, a2.add = add$1$1, a2.asin = asin$1$1, a2.asinh = asinh$1$1, a2.atan = atan$1$1, a2.atanh = atanh$1$1, a2.atan2 = atan2$1$1, a2.cbrt = cbrt$2, a2.ceil = ceil$1, a2.clamp = clamp$2, a2.cos = cos$1$1, a2.cosh = cosh$2$1, a2.div = div$1, a2.exp = exp$1$1, a2.floor = floor$2, a2.hypot = hypot$1$1, a2.ln = ln$2, a2.log = log$1$1, a2.log10 = log10$1$1, a2.log2 = log2$2, a2.max = max$1$1, a2.min = min$1$1, a2.mod = mod$1$1, a2.mul = mul$1, a2.pow = pow$1$1, a2.random = random$1$1, a2.round = round$2, a2.sign = sign$1$1, a2.sin = sin$1$1, a2.sinh = sinh$2$1, a2.sqrt = sqrt$1$1, a2.sub = sub$1, a2.sum = sum$1, a2.tan = tan$1$1, a2.tanh = tanh$1$1, a2.trunc = trunc$1$1, t4 === void 0 && (t4 = {}), t4 && t4.defaults !== true) for (i2 = [`precision`, `rounding`, `toExpNeg`, `toExpPos`, `maxE`, `minE`, `modulo`, `crypto`], n2 = 0; n2 < i2.length; ) t4.hasOwnProperty(r2 = i2[n2++]) || (t4[r2] = this[r2]);
  return a2.config(t4), a2;
}
function div$1(t4, n2) {
  return new this(t4).div(n2);
}
function exp$1$1(t4) {
  return new this(t4).exp();
}
function floor$2(t4) {
  return finalise$1(t4 = new this(t4), t4.e + 1, 3);
}
function hypot$1$1() {
  var t4, n2, r2 = new this(0);
  for (external$1 = false, t4 = 0; t4 < arguments.length; ) if (n2 = new this(arguments[t4++]), n2.d) r2.d && (r2 = r2.plus(n2.times(n2)));
  else {
    if (n2.s) return external$1 = true, new this(1 / 0);
    r2 = n2;
  }
  return external$1 = true, r2.sqrt();
}
function isDecimalInstance$1(t4) {
  return t4 instanceof Decimal$1 || t4 && t4.toStringTag === tag$1 || false;
}
function ln$2(t4) {
  return new this(t4).ln();
}
function log$1$1(t4, n2) {
  return new this(t4).log(n2);
}
function log2$2(t4) {
  return new this(t4).log(2);
}
function log10$1$1(t4) {
  return new this(t4).log(10);
}
function max$1$1() {
  return maxOrMin$1(this, arguments, `lt`);
}
function min$1$1() {
  return maxOrMin$1(this, arguments, `gt`);
}
function mod$1$1(t4, n2) {
  return new this(t4).mod(n2);
}
function mul$1(t4, n2) {
  return new this(t4).mul(n2);
}
function pow$1$1(t4, n2) {
  return new this(t4).pow(n2);
}
function random$1$1(t4) {
  var n2, r2, i2, a2, o2 = 0, s2 = new this(1), c2 = [];
  if (t4 === void 0 ? t4 = this.precision : checkInt32$1(t4, 1, MAX_DIGITS$1), i2 = Math.ceil(t4 / LOG_BASE$1), !this.crypto) for (; o2 < i2; ) c2[o2++] = Math.random() * 1e7 | 0;
  else if (crypto.getRandomValues) for (n2 = crypto.getRandomValues(new Uint32Array(i2)); o2 < i2; ) a2 = n2[o2], a2 >= 429e7 ? n2[o2] = crypto.getRandomValues(new Uint32Array(1))[0] : c2[o2++] = a2 % 1e7;
  else if (crypto.randomBytes) {
    for (n2 = crypto.randomBytes(i2 *= 4); o2 < i2; ) a2 = n2[o2] + (n2[o2 + 1] << 8) + (n2[o2 + 2] << 16) + ((n2[o2 + 3] & 127) << 24), a2 >= 214e7 ? crypto.randomBytes(4).copy(n2, o2) : (c2.push(a2 % 1e7), o2 += 4);
    o2 = i2 / 4;
  } else throw Error(cryptoUnavailable$1);
  for (i2 = c2[--o2], t4 %= LOG_BASE$1, i2 && t4 && (a2 = mathpow$1(10, LOG_BASE$1 - t4), c2[o2] = (i2 / a2 | 0) * a2); c2[o2] === 0; o2--) c2.pop();
  if (o2 < 0) r2 = 0, c2 = [0];
  else {
    for (r2 = -1; c2[0] === 0; r2 -= LOG_BASE$1) c2.shift();
    for (i2 = 1, a2 = c2[0]; a2 >= 10; a2 /= 10) i2++;
    i2 < LOG_BASE$1 && (r2 -= LOG_BASE$1 - i2);
  }
  return s2.e = r2, s2.d = c2, s2;
}
function round$2(t4) {
  return finalise$1(t4 = new this(t4), t4.e + 1, this.rounding);
}
function sign$1$1(t4) {
  return t4 = new this(t4), t4.d ? t4.d[0] ? t4.s : 0 * t4.s : t4.s || NaN;
}
function sin$1$1(t4) {
  return new this(t4).sin();
}
function sinh$2$1(t4) {
  return new this(t4).sinh();
}
function sqrt$1$1(t4) {
  return new this(t4).sqrt();
}
function sub$1(t4, n2) {
  return new this(t4).sub(n2);
}
function sum$1() {
  var t4 = 0, n2 = arguments, r2 = new this(n2[t4]);
  for (external$1 = false; r2.s && ++t4 < n2.length; ) r2 = r2.plus(n2[t4]);
  return external$1 = true, finalise$1(r2, this.precision, this.rounding);
}
function tan$1$1(t4) {
  return new this(t4).tan();
}
function tanh$1$1(t4) {
  return new this(t4).tanh();
}
function trunc$1$1(t4) {
  return finalise$1(t4 = new this(t4), t4.e + 1, 1);
}
P$3$1[/* @__PURE__ */ Symbol.for(`nodejs.util.inspect.custom`)] = P$3$1.toString, P$3$1[Symbol.toStringTag] = `Decimal`;
var Decimal$1 = P$3$1.constructor = clone$2$1(DEFAULTS$1);
LN10$1 = new Decimal$1(LN10$1), PI$1 = new Decimal$1(PI$1);
var name$320$1 = `BigNumber`, dependencies$320$1 = [`?on`, `config`], createBigNumberClass$1 = factory$1(name$320$1, dependencies$320$1, (t4) => {
  var { on: n2, config: r2 } = t4, i2 = Decimal$1.clone({ precision: r2.precision, modulo: Decimal$1.EUCLID });
  return i2.prototype = Object.create(i2.prototype), i2.prototype.type = `BigNumber`, i2.prototype.isBigNumber = true, i2.prototype.toJSON = function() {
    return { mathjs: `BigNumber`, value: this.toString() };
  }, i2.fromJSON = function(t5) {
    return new i2(t5.value);
  }, n2 && n2(`config`, function(t5, n3) {
    t5.precision !== n3.precision && i2.config({ precision: t5.precision });
  }), i2;
}, { isClass: true }), cosh$1$1 = Math.cosh || function(t4) {
  return Math.abs(t4) < 1e-9 ? 1 - t4 : (Math.exp(t4) + Math.exp(-t4)) * 0.5;
}, sinh$1$1 = Math.sinh || function(t4) {
  return Math.abs(t4) < 1e-9 ? t4 : (Math.exp(t4) - Math.exp(-t4)) * 0.5;
}, cosm1$1 = function(t4) {
  let n2 = Math.PI / 4;
  if (-n2 > t4 || t4 > n2) return Math.cos(t4) - 1;
  let r2 = t4 * t4;
  return r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, hypot$2 = function(t4, n2) {
  return t4 = Math.abs(t4), n2 = Math.abs(n2), t4 < n2 && ([t4, n2] = [n2, t4]), t4 < 1e8 ? Math.sqrt(t4 * t4 + n2 * n2) : (n2 /= t4, t4 * Math.sqrt(1 + n2 * n2));
}, parser_exit$1 = function() {
  throw SyntaxError(`Invalid Param`);
};
function logHypot$1(t4, n2) {
  let r2 = Math.abs(t4), i2 = Math.abs(n2);
  return t4 === 0 ? Math.log(i2) : n2 === 0 ? Math.log(r2) : r2 < 3e3 && i2 < 3e3 ? Math.log(t4 * t4 + n2 * n2) * 0.5 : (t4 *= 0.5, n2 *= 0.5, 0.5 * Math.log(t4 * t4 + n2 * n2) + Math.LN2);
}
var P$2$1 = { re: 0, im: 0 }, parse$1$1 = function(t4, n2) {
  let r2 = P$2$1;
  if (t4 == null) r2.re = r2.im = 0;
  else if (n2 !== void 0) r2.re = t4, r2.im = n2;
  else switch (typeof t4) {
    case `object`:
      if (`im` in t4 && `re` in t4) r2.re = t4.re, r2.im = t4.im;
      else if (`abs` in t4 && `arg` in t4) {
        if (!isFinite(t4.abs) && isFinite(t4.arg)) return Complex$1.INFINITY;
        r2.re = t4.abs * Math.cos(t4.arg), r2.im = t4.abs * Math.sin(t4.arg);
      } else if (`r` in t4 && `phi` in t4) {
        if (!isFinite(t4.r) && isFinite(t4.phi)) return Complex$1.INFINITY;
        r2.re = t4.r * Math.cos(t4.phi), r2.im = t4.r * Math.sin(t4.phi);
      } else t4.length === 2 ? (r2.re = t4[0], r2.im = t4[1]) : parser_exit$1();
      break;
    case `string`:
      r2.im = r2.re = 0;
      let n3 = t4.replace(/_/g, ``).match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i2 = 1, a2 = 0;
      n3 === null && parser_exit$1();
      for (let t5 = 0; t5 < n3.length; t5++) {
        let o2 = n3[t5];
        o2 === ` ` || o2 === `	` || o2 === `
` || (o2 === `+` ? i2++ : o2 === `-` ? a2++ : o2 === `i` || o2 === `I` ? (i2 + a2 === 0 && parser_exit$1(), n3[t5 + 1] !== ` ` && !isNaN(n3[t5 + 1]) ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + n3[t5 + 1]), t5++) : r2.im += parseFloat((a2 % 2 ? `-` : ``) + `1`), i2 = a2 = 0) : ((i2 + a2 === 0 || isNaN(o2)) && parser_exit$1(), n3[t5 + 1] === `i` || n3[t5 + 1] === `I` ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + o2), t5++) : r2.re += parseFloat((a2 % 2 ? `-` : ``) + o2), i2 = a2 = 0));
      }
      i2 + a2 > 0 && parser_exit$1();
      break;
    case `number`:
      r2.im = 0, r2.re = t4;
      break;
    default:
      parser_exit$1();
  }
  return isNaN(r2.re) || isNaN(r2.im), r2;
};
function Complex$1(t4, n2) {
  if (!(this instanceof Complex$1)) return new Complex$1(t4, n2);
  let r2 = parse$1$1(t4, n2);
  this.re = r2.re, this.im = r2.im;
}
Complex$1.prototype = { re: 0, im: 0, sign: function() {
  let t4 = hypot$2(this.re, this.im);
  return new Complex$1(this.re / t4, this.im / t4);
}, add: function(t4, n2) {
  let r2 = parse$1$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(this.re + r2.re, this.im + r2.im);
}, sub: function(t4, n2) {
  let r2 = parse$1$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex$1.NAN : Complex$1.INFINITY : new Complex$1(this.re - r2.re, this.im - r2.im);
}, mul: function(t4, n2) {
  let r2 = parse$1$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  return i2 && s2 || a2 && o2 ? Complex$1.NAN : i2 || a2 ? Complex$1.INFINITY : r2.im === 0 && this.im === 0 ? new Complex$1(this.re * r2.re, 0) : new Complex$1(this.re * r2.re - this.im * r2.im, this.re * r2.im + this.im * r2.re);
}, div: function(t4, n2) {
  let r2 = parse$1$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  if (o2 && s2 || i2 && a2) return Complex$1.NAN;
  if (s2 || i2) return Complex$1.INFINITY;
  if (o2 || a2) return Complex$1.ZERO;
  if (r2.im === 0) return new Complex$1(this.re / r2.re, this.im / r2.re);
  if (Math.abs(r2.re) < Math.abs(r2.im)) {
    let t5 = r2.re / r2.im, n3 = r2.re * t5 + r2.im;
    return new Complex$1((this.re * t5 + this.im) / n3, (this.im * t5 - this.re) / n3);
  } else {
    let t5 = r2.im / r2.re, n3 = r2.im * t5 + r2.re;
    return new Complex$1((this.re + this.im * t5) / n3, (this.im - this.re * t5) / n3);
  }
}, pow: function(t4, n2) {
  let r2 = parse$1$1(t4, n2), i2 = this.re === 0 && this.im === 0;
  if (r2.re === 0 && r2.im === 0) return Complex$1.ONE;
  if (r2.im === 0) {
    if (this.im === 0 && this.re > 0) return new Complex$1(this.re ** +r2.re, 0);
    if (this.re === 0) switch ((r2.re % 4 + 4) % 4) {
      case 0:
        return new Complex$1(this.im ** +r2.re, 0);
      case 1:
        return new Complex$1(0, this.im ** +r2.re);
      case 2:
        return new Complex$1(-(this.im ** +r2.re), 0);
      case 3:
        return new Complex$1(0, -(this.im ** +r2.re));
    }
  }
  if (i2 && r2.re > 0) return Complex$1.ZERO;
  let a2 = Math.atan2(this.im, this.re), o2 = logHypot$1(this.re, this.im), s2 = Math.exp(r2.re * o2 - r2.im * a2), c2 = r2.im * o2 + r2.re * a2;
  return new Complex$1(s2 * Math.cos(c2), s2 * Math.sin(c2));
}, sqrt: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return t4 >= 0 ? new Complex$1(Math.sqrt(t4), 0) : new Complex$1(0, Math.sqrt(-t4));
  let r2 = hypot$2(t4, n2), i2 = Math.sqrt(0.5 * (r2 + Math.abs(t4))), a2 = Math.abs(n2) / (2 * i2);
  return t4 >= 0 ? new Complex$1(i2, n2 < 0 ? -a2 : a2) : new Complex$1(a2, n2 < 0 ? -i2 : i2);
}, exp: function() {
  let t4 = Math.exp(this.re);
  return this.im === 0 ? new Complex$1(t4, 0) : new Complex$1(t4 * Math.cos(this.im), t4 * Math.sin(this.im));
}, expm1: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$1(Math.expm1(t4) * Math.cos(n2) + cosm1$1(n2), Math.exp(t4) * Math.sin(n2));
}, log: function() {
  let t4 = this.re, n2 = this.im;
  return n2 === 0 && t4 > 0 ? new Complex$1(Math.log(t4), 0) : new Complex$1(logHypot$1(t4, n2), Math.atan2(n2, t4));
}, abs: function() {
  return hypot$2(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$1(Math.sin(t4) * cosh$1$1(n2), Math.cos(t4) * sinh$1$1(n2));
}, cos: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$1(Math.cos(t4) * cosh$1$1(n2), -Math.sin(t4) * sinh$1$1(n2));
}, tan: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) + cosh$1$1(n2);
  return new Complex$1(Math.sin(t4) / r2, sinh$1$1(n2) / r2);
}, cot: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) - cosh$1$1(n2);
  return new Complex$1(-Math.sin(t4) / r2, sinh$1$1(n2) / r2);
}, sec: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1$1(2 * n2) + 0.5 * Math.cos(2 * t4);
  return new Complex$1(Math.cos(t4) * cosh$1$1(n2) / r2, Math.sin(t4) * sinh$1$1(n2) / r2);
}, csc: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1$1(2 * n2) - 0.5 * Math.cos(2 * t4);
  return new Complex$1(Math.sin(t4) * cosh$1$1(n2) / r2, -Math.cos(t4) * sinh$1$1(n2) / r2);
}, asin: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex$1(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex$1(r2.re - n2, r2.im + t4).log();
  return new Complex$1(i2.im, -i2.re);
}, acos: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex$1(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex$1(r2.re - n2, r2.im + t4).log();
  return new Complex$1(Math.PI / 2 - i2.im, i2.re);
}, atan: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0) {
    if (n2 === 1) return new Complex$1(0, 1 / 0);
    if (n2 === -1) return new Complex$1(0, -1 / 0);
  }
  let r2 = t4 * t4 + (1 - n2) * (1 - n2), i2 = new Complex$1((1 - n2 * n2 - t4 * t4) / r2, -2 * t4 / r2).log();
  return new Complex$1(-0.5 * i2.im, 0.5 * i2.re);
}, acot: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex$1(Math.atan2(1, t4), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atan() : new Complex$1(t4 / r2, -n2 / r2).atan();
}, asec: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$1(0, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acos() : new Complex$1(t4 / r2, -n2 / r2).acos();
}, acsc: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$1(Math.PI / 2, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asin() : new Complex$1(t4 / r2, -n2 / r2).asin();
}, sinh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$1(sinh$1$1(t4) * Math.cos(n2), cosh$1$1(t4) * Math.sin(n2));
}, cosh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex$1(cosh$1$1(t4) * Math.cos(n2), sinh$1$1(t4) * Math.sin(n2));
}, tanh: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1$1(t4) + Math.cos(n2);
  return new Complex$1(sinh$1$1(t4) / r2, Math.sin(n2) / r2);
}, coth: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1$1(t4) - Math.cos(n2);
  return new Complex$1(sinh$1$1(t4) / r2, -Math.sin(n2) / r2);
}, csch: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) - cosh$1$1(2 * t4);
  return new Complex$1(-2 * sinh$1$1(t4) * Math.cos(n2) / r2, 2 * cosh$1$1(t4) * Math.sin(n2) / r2);
}, sech: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) + cosh$1$1(2 * t4);
  return new Complex$1(2 * cosh$1$1(t4) * Math.cos(n2) / r2, -2 * sinh$1$1(t4) * Math.sin(n2) / r2);
}, asinh: function() {
  let t4 = this.im;
  this.im = -this.re, this.re = t4;
  let n2 = this.asin();
  return this.re = -this.im, this.im = t4, t4 = n2.re, n2.re = -n2.im, n2.im = t4, n2;
}, acosh: function() {
  let t4 = this.acos();
  if (t4.im <= 0) {
    let n2 = t4.re;
    t4.re = -t4.im, t4.im = n2;
  } else {
    let n2 = t4.im;
    t4.im = -t4.re, t4.re = n2;
  }
  return t4;
}, atanh: function() {
  let t4 = this.re, n2 = this.im, r2 = t4 > 1 && n2 === 0, i2 = 1 - t4, a2 = 1 + t4, o2 = i2 * i2 + n2 * n2, s2 = o2 === 0 ? new Complex$1(t4 === -1 ? 0 : t4 / 0, n2 === 0 ? 0 : n2 / 0) : new Complex$1((a2 * i2 - n2 * n2) / o2, (n2 * i2 + a2 * n2) / o2), c2 = s2.re;
  return s2.re = logHypot$1(s2.re, s2.im) / 2, s2.im = Math.atan2(s2.im, c2) / 2, r2 && (s2.im = -s2.im), s2;
}, acoth: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex$1(0, Math.PI / 2);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atanh() : new Complex$1(t4 / r2, -n2 / r2).atanh();
}, acsch: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex$1(t4 === 0 ? 1 / 0 : Math.log(t4 + Math.sqrt(t4 * t4 + 1)), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asinh() : new Complex$1(t4 / r2, -n2 / r2).asinh();
}, asech: function() {
  let t4 = this.re, n2 = this.im;
  if (this.isZero()) return Complex$1.INFINITY;
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex$1(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acosh() : new Complex$1(t4 / r2, -n2 / r2).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex$1.INFINITY;
  if (this.isInfinite()) return Complex$1.ZERO;
  let t4 = this.re, n2 = this.im, r2 = t4 * t4 + n2 * n2;
  return new Complex$1(t4 / r2, -n2 / r2);
}, conjugate: function() {
  return new Complex$1(this.re, -this.im);
}, neg: function() {
  return new Complex$1(-this.re, -this.im);
}, ceil: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$1(Math.ceil(this.re * t4) / t4, Math.ceil(this.im * t4) / t4);
}, floor: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$1(Math.floor(this.re * t4) / t4, Math.floor(this.im * t4) / t4);
}, round: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex$1(Math.round(this.re * t4) / t4, Math.round(this.im * t4) / t4);
}, equals: function(t4, n2) {
  let r2 = parse$1$1(t4, n2);
  return Math.abs(r2.re - this.re) <= Complex$1.EPSILON && Math.abs(r2.im - this.im) <= Complex$1.EPSILON;
}, clone: function() {
  return new Complex$1(this.re, this.im);
}, toString: function() {
  let t4 = this.re, n2 = this.im, r2 = ``;
  return this.isNaN() ? `NaN` : this.isInfinite() ? `Infinity` : (Math.abs(t4) < Complex$1.EPSILON && (t4 = 0), Math.abs(n2) < Complex$1.EPSILON && (n2 = 0), n2 === 0 ? r2 + t4 : (t4 === 0 ? n2 < 0 && (n2 = -n2, r2 += `-`) : (r2 += t4, r2 += ` `, n2 < 0 ? (n2 = -n2, r2 += `-`) : r2 += `+`, r2 += ` `), n2 !== 1 && (r2 += n2), r2 + `i`));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return this.im === 0 ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return this.im === 0 && this.re === 0;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex$1.ZERO = new Complex$1(0, 0), Complex$1.ONE = new Complex$1(1, 0), Complex$1.I = new Complex$1(0, 1), Complex$1.PI = new Complex$1(Math.PI, 0), Complex$1.E = new Complex$1(Math.E, 0), Complex$1.INFINITY = new Complex$1(1 / 0, 1 / 0), Complex$1.NAN = new Complex$1(NaN, NaN), Complex$1.EPSILON = 1e-15;
var name$319$1 = `Complex`, dependencies$319$1 = [], createComplexClass$1 = factory$1(name$319$1, dependencies$319$1, () => (Object.defineProperty(Complex$1, "name", { value: `Complex` }), Complex$1.prototype.constructor = Complex$1, Complex$1.prototype.type = `Complex`, Complex$1.prototype.isComplex = true, Complex$1.prototype.toJSON = function() {
  return { mathjs: `Complex`, re: this.re, im: this.im };
}, Complex$1.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex$1.prototype.format = function(t4) {
  var n2 = ``, r2 = this.im, i2 = this.re, a2 = format$2$1(this.re, t4), o2 = format$2$1(this.im, t4), s2 = isNumber$1(t4) ? t4 : t4 ? t4.precision : null;
  if (s2 !== null) {
    var c2 = 10 ** -s2;
    Math.abs(i2 / r2) < c2 && (i2 = 0), Math.abs(r2 / i2) < c2 && (r2 = 0);
  }
  return n2 = r2 === 0 ? a2 : i2 === 0 ? r2 === 1 ? `i` : r2 === -1 ? `-i` : o2 + `i` : r2 < 0 ? r2 === -1 ? a2 + ` - i` : a2 + ` - ` + o2.substring(1) + `i` : r2 === 1 ? a2 + ` + i` : a2 + ` + ` + o2 + `i`, n2;
}, Complex$1.fromPolar = function(t4) {
  switch (arguments.length) {
    case 1:
      var n2 = arguments[0];
      if (typeof n2 == `object`) return Complex$1(n2);
      throw TypeError(`Input has to be an object with r and phi keys.`);
    case 2:
      var r2 = arguments[0], i2 = arguments[1];
      if (isNumber$1(r2)) {
        if (isUnit$1(i2) && i2.hasBase(`ANGLE`) && (i2 = i2.toNumber(`rad`)), isNumber$1(i2)) return new Complex$1({ r: r2, phi: i2 });
        throw TypeError(`Phi is not a number nor an angle unit.`);
      } else throw TypeError(`Radius r is not a number.`);
    default:
      throw SyntaxError(`Wrong number of arguments in function fromPolar`);
  }
}, Complex$1.prototype.valueOf = Complex$1.prototype.toString, Complex$1.fromJSON = function(t4) {
  return new Complex$1(t4);
}, Complex$1.compare = function(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}, Complex$1), { isClass: true });
typeof BigInt > `u` && (BigInt = function(t4) {
  if (isNaN(t4)) throw Error(``);
  return t4;
});
var C_ZERO$1 = BigInt(0), C_ONE$1 = BigInt(1), C_TWO$1 = BigInt(2), C_FIVE$1 = BigInt(5), C_TEN$1 = BigInt(10), MAX_CYCLE_LEN$1 = 2e3, P$1$1 = { s: C_ONE$1, n: C_ZERO$1, d: C_ONE$1 };
function assign$1(t4, n2) {
  try {
    t4 = BigInt(t4);
  } catch {
    throw InvalidParameter$1();
  }
  return t4 * n2;
}
function trunc$2(t4) {
  return typeof t4 == `bigint` ? t4 : Math.floor(t4);
}
function newFraction$1(t4, n2) {
  if (n2 === C_ZERO$1) throw DivisionByZero$1();
  let r2 = Object.create(Fraction$1.prototype);
  r2.s = t4 < C_ZERO$1 ? -C_ONE$1 : C_ONE$1, t4 = t4 < C_ZERO$1 ? -t4 : t4;
  let i2 = gcd$1$1(t4, n2);
  return r2.n = t4 / i2, r2.d = n2 / i2, r2;
}
function factorize$1(t4) {
  let n2 = {}, r2 = t4, i2 = C_TWO$1, a2 = C_FIVE$1 - C_ONE$1;
  for (; a2 <= r2; ) {
    for (; r2 % i2 === C_ZERO$1; ) r2 /= i2, n2[i2] = (n2[i2] || C_ZERO$1) + C_ONE$1;
    a2 += C_ONE$1 + C_TWO$1 * i2++;
  }
  return r2 === t4 ? n2[t4] = (n2[t4] || C_ZERO$1) + C_ONE$1 : r2 > 1 && (n2[r2] = (n2[r2] || C_ZERO$1) + C_ONE$1), n2;
}
var parse$4 = function(t4, n2) {
  let r2 = C_ZERO$1, i2 = C_ONE$1, a2 = C_ONE$1;
  if (t4 != null) if (n2 !== void 0) {
    if (typeof t4 == `bigint`) r2 = t4;
    else if (isNaN(t4)) throw InvalidParameter$1();
    else if (t4 % 1 != 0) throw NonIntegerParameter$1();
    else r2 = BigInt(t4);
    if (typeof n2 == `bigint`) i2 = n2;
    else if (isNaN(n2)) throw InvalidParameter$1();
    else if (n2 % 1 != 0) throw NonIntegerParameter$1();
    else i2 = BigInt(n2);
    a2 = r2 * i2;
  } else if (typeof t4 == `object`) {
    if (`d` in t4 && `n` in t4) r2 = BigInt(t4.n), i2 = BigInt(t4.d), `s` in t4 && (r2 *= BigInt(t4.s));
    else if (0 in t4) r2 = BigInt(t4[0]), 1 in t4 && (i2 = BigInt(t4[1]));
    else if (typeof t4 == `bigint`) r2 = t4;
    else throw InvalidParameter$1();
    a2 = r2 * i2;
  } else if (typeof t4 == `number`) {
    if (isNaN(t4)) throw InvalidParameter$1();
    if (t4 < 0 && (a2 = -C_ONE$1, t4 = -t4), t4 % 1 == 0) r2 = BigInt(t4);
    else {
      let n3 = 1, a3 = 0, o2 = 1, s2 = 1, c2 = 1, l2 = 1e7;
      for (t4 >= 1 && (n3 = 10 ** Math.floor(1 + Math.log10(t4)), t4 /= n3); o2 <= l2 && c2 <= l2; ) {
        let n4 = (a3 + s2) / (o2 + c2);
        if (t4 === n4) {
          o2 + c2 <= l2 ? (r2 = a3 + s2, i2 = o2 + c2) : c2 > o2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
          break;
        } else t4 > n4 ? (a3 += s2, o2 += c2) : (s2 += a3, c2 += o2), o2 > l2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
      }
      r2 = BigInt(r2) * BigInt(n3), i2 = BigInt(i2);
    }
  } else if (typeof t4 == `string`) {
    let n3 = 0, o2 = C_ZERO$1, s2 = C_ZERO$1, c2 = C_ZERO$1, l2 = C_ONE$1, u2 = C_ONE$1, d2 = t4.replace(/_/g, ``).match(/\d+|./g);
    if (d2 === null) throw InvalidParameter$1();
    if (d2[n3] === `-` ? (a2 = -C_ONE$1, n3++) : d2[n3] === `+` && n3++, d2.length === n3 + 1 ? s2 = assign$1(d2[n3++], a2) : d2[n3 + 1] === `.` || d2[n3] === `.` ? (d2[n3] !== `.` && (o2 = assign$1(d2[n3++], a2)), n3++, (n3 + 1 === d2.length || d2[n3 + 1] === `(` && d2[n3 + 3] === `)` || d2[n3 + 1] === `'` && d2[n3 + 3] === `'`) && (s2 = assign$1(d2[n3], a2), l2 = C_TEN$1 ** BigInt(d2[n3].length), n3++), (d2[n3] === `(` && d2[n3 + 2] === `)` || d2[n3] === `'` && d2[n3 + 2] === `'`) && (c2 = assign$1(d2[n3 + 1], a2), u2 = C_TEN$1 ** BigInt(d2[n3 + 1].length) - C_ONE$1, n3 += 3)) : d2[n3 + 1] === `/` || d2[n3 + 1] === `:` ? (s2 = assign$1(d2[n3], a2), l2 = assign$1(d2[n3 + 2], C_ONE$1), n3 += 3) : d2[n3 + 3] === `/` && d2[n3 + 1] === ` ` && (o2 = assign$1(d2[n3], a2), s2 = assign$1(d2[n3 + 2], a2), l2 = assign$1(d2[n3 + 4], C_ONE$1), n3 += 5), d2.length <= n3) i2 = l2 * u2, a2 = r2 = c2 + i2 * o2 + u2 * s2;
    else throw InvalidParameter$1();
  } else if (typeof t4 == `bigint`) r2 = t4, a2 = t4, i2 = C_ONE$1;
  else throw InvalidParameter$1();
  if (i2 === C_ZERO$1) throw DivisionByZero$1();
  P$1$1.s = a2 < C_ZERO$1 ? -C_ONE$1 : C_ONE$1, P$1$1.n = r2 < C_ZERO$1 ? -r2 : r2, P$1$1.d = i2 < C_ZERO$1 ? -i2 : i2;
};
function modpow$1(t4, n2, r2) {
  let i2 = C_ONE$1;
  for (; n2 > C_ZERO$1; t4 = t4 * t4 % r2, n2 >>= C_ONE$1) n2 & C_ONE$1 && (i2 = i2 * t4 % r2);
  return i2;
}
function cycleLen$1(t4, n2) {
  for (; n2 % C_TWO$1 === C_ZERO$1; n2 /= C_TWO$1) ;
  for (; n2 % C_FIVE$1 === C_ZERO$1; n2 /= C_FIVE$1) ;
  if (n2 === C_ONE$1) return C_ZERO$1;
  let r2 = C_TEN$1 % n2, i2 = 1;
  for (; r2 !== C_ONE$1; i2++) if (r2 = r2 * C_TEN$1 % n2, i2 > MAX_CYCLE_LEN$1) return C_ZERO$1;
  return BigInt(i2);
}
function cycleStart$1(t4, n2, r2) {
  let i2 = C_ONE$1, a2 = modpow$1(C_TEN$1, r2, n2);
  for (let t5 = 0; t5 < 300; t5++) {
    if (i2 === a2) return BigInt(t5);
    i2 = i2 * C_TEN$1 % n2, a2 = a2 * C_TEN$1 % n2;
  }
  return 0;
}
function gcd$1$1(t4, n2) {
  if (!t4) return n2;
  if (!n2) return t4;
  for (; ; ) {
    if (t4 %= n2, !t4) return n2;
    if (n2 %= t4, !n2) return t4;
  }
}
function Fraction$1(t4, n2) {
  if (parse$4(t4, n2), this instanceof Fraction$1) t4 = gcd$1$1(P$1$1.d, P$1$1.n), this.s = P$1$1.s, this.n = P$1$1.n / t4, this.d = P$1$1.d / t4;
  else return newFraction$1(P$1$1.s * P$1$1.n, P$1$1.d);
}
var DivisionByZero$1 = function() {
  return Error(`Division by Zero`);
}, InvalidParameter$1 = function() {
  return Error(`Invalid argument`);
}, NonIntegerParameter$1 = function() {
  return Error(`Parameters must be integer`);
};
Fraction$1.prototype = { s: C_ONE$1, n: C_ZERO$1, d: C_ONE$1, abs: function() {
  return newFraction$1(this.n, this.d);
}, neg: function() {
  return newFraction$1(-this.s * this.n, this.d);
}, add: function(t4, n2) {
  return parse$4(t4, n2), newFraction$1(this.s * this.n * P$1$1.d + P$1$1.s * this.d * P$1$1.n, this.d * P$1$1.d);
}, sub: function(t4, n2) {
  return parse$4(t4, n2), newFraction$1(this.s * this.n * P$1$1.d - P$1$1.s * this.d * P$1$1.n, this.d * P$1$1.d);
}, mul: function(t4, n2) {
  return parse$4(t4, n2), newFraction$1(this.s * P$1$1.s * this.n * P$1$1.n, this.d * P$1$1.d);
}, div: function(t4, n2) {
  return parse$4(t4, n2), newFraction$1(this.s * P$1$1.s * this.n * P$1$1.d, this.d * P$1$1.n);
}, clone: function() {
  return newFraction$1(this.s * this.n, this.d);
}, mod: function(t4, n2) {
  if (t4 === void 0) return newFraction$1(this.s * this.n % this.d, C_ONE$1);
  if (parse$4(t4, n2), C_ZERO$1 === P$1$1.n * this.d) throw DivisionByZero$1();
  return newFraction$1(this.s * (P$1$1.d * this.n) % (P$1$1.n * this.d), P$1$1.d * this.d);
}, gcd: function(t4, n2) {
  return parse$4(t4, n2), newFraction$1(gcd$1$1(P$1$1.n, this.n) * gcd$1$1(P$1$1.d, this.d), P$1$1.d * this.d);
}, lcm: function(t4, n2) {
  return parse$4(t4, n2), P$1$1.n === C_ZERO$1 && this.n === C_ZERO$1 ? newFraction$1(C_ZERO$1, C_ONE$1) : newFraction$1(P$1$1.n * this.n, gcd$1$1(P$1$1.n, this.n) * gcd$1$1(P$1$1.d, this.d));
}, inverse: function() {
  return newFraction$1(this.s * this.d, this.n);
}, pow: function(t4, n2) {
  if (parse$4(t4, n2), P$1$1.d === C_ONE$1) return P$1$1.s < C_ZERO$1 ? newFraction$1((this.s * this.d) ** P$1$1.n, this.n ** P$1$1.n) : newFraction$1((this.s * this.n) ** P$1$1.n, this.d ** P$1$1.n);
  if (this.s < C_ZERO$1) return null;
  let r2 = factorize$1(this.n), i2 = factorize$1(this.d), a2 = C_ONE$1, o2 = C_ONE$1;
  for (let t5 in r2) if (t5 !== `1`) {
    if (t5 === `0`) {
      a2 = C_ZERO$1;
      break;
    }
    if (r2[t5] *= P$1$1.n, r2[t5] % P$1$1.d === C_ZERO$1) r2[t5] /= P$1$1.d;
    else return null;
    a2 *= BigInt(t5) ** r2[t5];
  }
  for (let t5 in i2) if (t5 !== `1`) {
    if (i2[t5] *= P$1$1.n, i2[t5] % P$1$1.d === C_ZERO$1) i2[t5] /= P$1$1.d;
    else return null;
    o2 *= BigInt(t5) ** i2[t5];
  }
  return P$1$1.s < C_ZERO$1 ? newFraction$1(o2, a2) : newFraction$1(a2, o2);
}, log: function(t4, n2) {
  if (parse$4(t4, n2), this.s <= C_ZERO$1 || P$1$1.s <= C_ZERO$1) return null;
  let r2 = {}, i2 = factorize$1(P$1$1.n), a2 = factorize$1(P$1$1.d), o2 = factorize$1(this.n), s2 = factorize$1(this.d);
  for (let t5 in a2) i2[t5] = (i2[t5] || C_ZERO$1) - a2[t5];
  for (let t5 in s2) o2[t5] = (o2[t5] || C_ZERO$1) - s2[t5];
  for (let t5 in i2) t5 !== `1` && (r2[t5] = true);
  for (let t5 in o2) t5 !== `1` && (r2[t5] = true);
  let c2 = null, l2 = null;
  for (let t5 in r2) {
    let n3 = i2[t5] || C_ZERO$1, r3 = o2[t5] || C_ZERO$1;
    if (n3 === C_ZERO$1) {
      if (r3 !== C_ZERO$1) return null;
      continue;
    }
    let a3 = r3, s3 = n3, u2 = gcd$1$1(a3, s3);
    if (a3 /= u2, s3 /= u2, c2 === null && l2 === null) c2 = a3, l2 = s3;
    else if (a3 * l2 !== c2 * s3) return null;
  }
  return c2 !== null && l2 !== null ? newFraction$1(c2, l2) : null;
}, equals: function(t4, n2) {
  return parse$4(t4, n2), this.s * this.n * P$1$1.d === P$1$1.s * P$1$1.n * this.d;
}, lt: function(t4, n2) {
  return parse$4(t4, n2), this.s * this.n * P$1$1.d < P$1$1.s * P$1$1.n * this.d;
}, lte: function(t4, n2) {
  return parse$4(t4, n2), this.s * this.n * P$1$1.d <= P$1$1.s * P$1$1.n * this.d;
}, gt: function(t4, n2) {
  return parse$4(t4, n2), this.s * this.n * P$1$1.d > P$1$1.s * P$1$1.n * this.d;
}, gte: function(t4, n2) {
  return parse$4(t4, n2), this.s * this.n * P$1$1.d >= P$1$1.s * P$1$1.n * this.d;
}, compare: function(t4, n2) {
  parse$4(t4, n2);
  let r2 = this.s * this.n * P$1$1.d - P$1$1.s * P$1$1.n * this.d;
  return (C_ZERO$1 < r2) - (r2 < C_ZERO$1);
}, ceil: function(t4) {
  return t4 = C_TEN$1 ** BigInt(t4 || 0), newFraction$1(trunc$2(this.s * t4 * this.n / this.d) + (t4 * this.n % this.d > C_ZERO$1 && this.s >= C_ZERO$1 ? C_ONE$1 : C_ZERO$1), t4);
}, floor: function(t4) {
  return t4 = C_TEN$1 ** BigInt(t4 || 0), newFraction$1(trunc$2(this.s * t4 * this.n / this.d) - (t4 * this.n % this.d > C_ZERO$1 && this.s < C_ZERO$1 ? C_ONE$1 : C_ZERO$1), t4);
}, round: function(t4) {
  return t4 = C_TEN$1 ** BigInt(t4 || 0), newFraction$1(trunc$2(this.s * t4 * this.n / this.d) + this.s * ((this.s >= C_ZERO$1 ? C_ONE$1 : C_ZERO$1) + C_TWO$1 * (t4 * this.n % this.d) > this.d ? C_ONE$1 : C_ZERO$1), t4);
}, roundTo: function(t4, n2) {
  parse$4(t4, n2);
  let r2 = this.n * P$1$1.d, i2 = this.d * P$1$1.n, a2 = r2 % i2, o2 = trunc$2(r2 / i2);
  return a2 + a2 >= i2 && o2++, newFraction$1(this.s * o2 * P$1$1.n, P$1$1.d);
}, divisible: function(t4, n2) {
  return parse$4(t4, n2), !(!(P$1$1.n * this.d) || this.n * P$1$1.d % (P$1$1.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(t4) {
  let n2 = this.n, r2 = this.d;
  t4 ||= 15;
  let i2 = cycleLen$1(n2, r2), a2 = cycleStart$1(n2, r2, i2), o2 = this.s < C_ZERO$1 ? `-` : ``;
  if (o2 += trunc$2(n2 / r2), n2 %= r2, n2 *= C_TEN$1, n2 && (o2 += `.`), i2) {
    for (let t5 = a2; t5--; ) o2 += trunc$2(n2 / r2), n2 %= r2, n2 *= C_TEN$1;
    o2 += `(`;
    for (let t5 = i2; t5--; ) o2 += trunc$2(n2 / r2), n2 %= r2, n2 *= C_TEN$1;
    o2 += `)`;
  } else for (let i3 = t4; n2 && i3--; ) o2 += trunc$2(n2 / r2), n2 %= r2, n2 *= C_TEN$1;
  return o2;
}, toFraction: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO$1 ? `-` : ``;
  if (r2 === C_ONE$1) i2 += n2;
  else {
    let a2 = trunc$2(n2 / r2);
    t4 && a2 > C_ZERO$1 && (i2 += a2, i2 += ` `, n2 %= r2), i2 += n2, i2 += `/`, i2 += r2;
  }
  return i2;
}, toLatex: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO$1 ? `-` : ``;
  if (r2 === C_ONE$1) i2 += n2;
  else {
    let a2 = trunc$2(n2 / r2);
    t4 && a2 > C_ZERO$1 && (i2 += a2, n2 %= r2), i2 += `\\frac{`, i2 += n2, i2 += `}{`, i2 += r2, i2 += `}`;
  }
  return i2;
}, toContinued: function() {
  let t4 = this.n, n2 = this.d, r2 = [];
  do {
    r2.push(trunc$2(t4 / n2));
    let i2 = t4 % n2;
    t4 = n2, n2 = i2;
  } while (t4 !== C_ONE$1);
  return r2;
}, simplify: function(t4) {
  let n2 = BigInt(1 / (t4 || 1e-3) | 0), r2 = this.abs(), i2 = r2.toContinued();
  for (let t5 = 1; t5 < i2.length; t5++) {
    let a2 = newFraction$1(i2[t5 - 1], C_ONE$1);
    for (let n3 = t5 - 2; n3 >= 0; n3--) a2 = a2.inverse().add(i2[n3]);
    let o2 = a2.sub(r2);
    if (o2.n * n2 < o2.d) return a2.mul(this.s);
  }
  return this;
} };
var name$318$1 = `Fraction`, dependencies$318$1 = [], createFractionClass$1 = factory$1(name$318$1, dependencies$318$1, () => (Object.defineProperty(Fraction$1, "name", { value: `Fraction` }), Fraction$1.prototype.constructor = Fraction$1, Fraction$1.prototype.type = `Fraction`, Fraction$1.prototype.isFraction = true, Fraction$1.prototype.toJSON = function() {
  return { mathjs: `Fraction`, n: String(this.s * this.n), d: String(this.d) };
}, Fraction$1.fromJSON = function(t4) {
  return new Fraction$1(t4);
}, Fraction$1), { isClass: true }), name$317$1 = `Range`, dependencies$317$1 = [], createRangeClass$1 = factory$1(name$317$1, dependencies$317$1, () => {
  function t4(n2, r2, i2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    var a2 = n2 != null, o2 = r2 != null, s2 = i2 != null;
    if (a2) {
      if (isBigNumber$1(n2)) n2 = n2.toNumber();
      else if (typeof n2 != `number` && !isBigInt$1(n2)) throw TypeError(`Parameter start must be a number or bigint`);
    }
    if (o2) {
      if (isBigNumber$1(r2)) r2 = r2.toNumber();
      else if (typeof r2 != `number` && !isBigInt$1(r2)) throw TypeError(`Parameter end must be a number or bigint`);
    }
    if (s2) {
      if (isBigNumber$1(i2)) i2 = i2.toNumber();
      else if (typeof i2 != `number` && !isBigInt$1(i2)) throw TypeError(`Parameter step must be a number or bigint`);
    }
    if (this.start = a2 ? parseFloat(n2) : 0, this.end = o2 ? parseFloat(r2) : 0, this.step = s2 ? parseFloat(i2) : 1, s2 && nearlyEqual$1$1(this.step, 0)) throw Error(`Step must not be zero`);
  }
  return t4.prototype.type = `Range`, t4.prototype.isRange = true, t4.parse = function(n2) {
    if (typeof n2 != `string`) return null;
    var r2 = n2.split(`:`).map(function(t5) {
      return parseFloat(t5);
    });
    if (r2.some(function(t5) {
      return isNaN(t5);
    })) return null;
    switch (r2.length) {
      case 2:
        return new t4(r2[0], r2[1]);
      case 3:
        return new t4(r2[0], r2[2], r2[1]);
      default:
        return null;
    }
  }, t4.prototype.clone = function() {
    return new t4(this.start, this.end, this.step);
  }, t4.prototype.size = function() {
    var t5 = 0, n2 = this.start, r2 = this.step, i2 = this.end - n2;
    return sign$2$1(r2) === sign$2$1(i2) ? t5 = Math.ceil(i2 / r2) : i2 === 0 && (t5 = 0), isNaN(t5) && (t5 = 0), [t5];
  }, t4.prototype.min = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start : this.start + (t5 - 1) * this.step;
  }, t4.prototype.max = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start + (t5 - 1) * this.step : this.start;
  }, t4.prototype.forEach = function(t5) {
    var n2 = this.start, r2 = this.step, i2 = this.end, a2 = 0;
    if (r2 > 0) for (; n2 < i2; ) t5(n2, [a2], this), n2 += r2, a2++;
    else if (r2 < 0) for (; n2 > i2; ) t5(n2, [a2], this), n2 += r2, a2++;
  }, t4.prototype.map = function(t5) {
    var n2 = [];
    return this.forEach(function(r2, i2, a2) {
      n2[i2[0]] = t5(r2, i2, a2);
    }), n2;
  }, t4.prototype.toArray = function() {
    var t5 = [];
    return this.forEach(function(n2, r2) {
      t5[r2[0]] = n2;
    }), t5;
  }, t4.prototype.valueOf = function() {
    return this.toArray();
  }, t4.prototype.format = function(t5) {
    var n2 = format$2$1(this.start, t5);
    return this.step !== 1 && (n2 += `:` + format$2$1(this.step, t5)), n2 += `:` + format$2$1(this.end, t5), n2;
  }, t4.prototype.toString = function() {
    return this.format();
  }, t4.prototype.toJSON = function() {
    return { mathjs: `Range`, start: this.start, end: this.end, step: this.step };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.start, n2.end, n2.step);
  }, t4;
}, { isClass: true }), name$316$1 = `Matrix`, dependencies$316$1 = [], createMatrixClass$1 = factory$1(name$316$1, dependencies$316$1, () => {
  function t4() {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
  }
  return t4.prototype.type = `Matrix`, t4.prototype.isMatrix = true, t4.prototype.storage = function() {
    throw Error(`Cannot invoke storage on a Matrix interface`);
  }, t4.prototype.datatype = function() {
    throw Error(`Cannot invoke datatype on a Matrix interface`);
  }, t4.prototype.create = function(t5, n2) {
    throw Error(`Cannot invoke create on a Matrix interface`);
  }, t4.prototype.subset = function(t5, n2, r2) {
    throw Error(`Cannot invoke subset on a Matrix interface`);
  }, t4.prototype.get = function(t5) {
    throw Error(`Cannot invoke get on a Matrix interface`);
  }, t4.prototype.set = function(t5, n2, r2) {
    throw Error(`Cannot invoke set on a Matrix interface`);
  }, t4.prototype.resize = function(t5, n2) {
    throw Error(`Cannot invoke resize on a Matrix interface`);
  }, t4.prototype.reshape = function(t5, n2) {
    throw Error(`Cannot invoke reshape on a Matrix interface`);
  }, t4.prototype.clone = function() {
    throw Error(`Cannot invoke clone on a Matrix interface`);
  }, t4.prototype.size = function() {
    throw Error(`Cannot invoke size on a Matrix interface`);
  }, t4.prototype.map = function(t5, n2) {
    throw Error(`Cannot invoke map on a Matrix interface`);
  }, t4.prototype.forEach = function(t5) {
    throw Error(`Cannot invoke forEach on a Matrix interface`);
  }, t4.prototype[Symbol.iterator] = function() {
    throw Error(`Cannot iterate a Matrix interface`);
  }, t4.prototype.toArray = function() {
    throw Error(`Cannot invoke toArray on a Matrix interface`);
  }, t4.prototype.valueOf = function() {
    throw Error(`Cannot invoke valueOf on a Matrix interface`);
  }, t4.prototype.format = function(t5) {
    throw Error(`Cannot invoke format on a Matrix interface`);
  }, t4.prototype.toString = function() {
    throw Error(`Cannot invoke toString on a Matrix interface`);
  }, t4;
}, { isClass: true });
function formatBigNumberToBase$1(t4, n2, r2) {
  var i2 = t4.constructor, a2 = new i2(2), o2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger$2(r2)) throw Error(`size must be an integer`);
    if (t4.greaterThan(a2.pow(r2 - 1).sub(1)) || t4.lessThan(a2.pow(r2 - 1).mul(-1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!t4.isInteger()) throw Error(`Value must be an integer`);
    t4.lessThan(0) && (t4 = t4.add(a2.pow(r2))), o2 = `i${r2}`;
  }
  switch (n2) {
    case 2:
      return `${t4.toBinary()}${o2}`;
    case 8:
      return `${t4.toOctal()}${o2}`;
    case 16:
      return `${t4.toHexadecimal()}${o2}`;
    default:
      throw Error(`Base ${n2} not supported `);
  }
}
function format$1$1(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (!t4.isFinite()) return t4.isNaN() ? `NaN` : t4.gt(0) ? `Infinity` : `-Infinity`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions$1(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$1$1(t4, i2);
    case `exponential`:
      return toExponential$2(t4, i2);
    case `engineering`:
      return toEngineering$2(t4, i2);
    case `bin`:
      return formatBigNumberToBase$1(t4, 2, a2);
    case `oct`:
      return formatBigNumberToBase$1(t4, 8, a2);
    case `hex`:
      return formatBigNumberToBase$1(t4, 16, a2);
    case `auto`:
      var o2 = _toNumberOrDefault$2(n2?.lowerExp, -3), s2 = _toNumberOrDefault$2(n2?.upperExp, 5);
      if (t4.isZero()) return `0`;
      var c2, l2 = t4.toSignificantDigits(i2), u2 = l2.e;
      return c2 = u2 >= o2 && u2 < s2 ? l2.toFixed() : toExponential$2(t4, i2), c2.replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function toEngineering$2(t4, n2) {
  var r2 = t4.e, i2 = r2 % 3 == 0 ? r2 : r2 < 0 ? r2 - 3 - r2 % 3 : r2 - r2 % 3, a2 = t4.mul(10 ** -i2).toPrecision(n2);
  if (a2.includes(`e`)) {
    var o2 = t4.constructor;
    a2 = new o2(a2).toFixed();
  }
  return a2 + `e` + (r2 >= 0 ? `+` : ``) + i2.toString();
}
function toExponential$2(t4, n2) {
  return n2 === void 0 ? t4.toExponential() : t4.toExponential(n2 - 1);
}
function toFixed$1$1(t4, n2) {
  return t4.toFixed(n2);
}
function _toNumberOrDefault$2(t4, n2) {
  return isNumber$1(t4) ? t4 : isBigNumber$1(t4) ? t4.toNumber() : n2;
}
function endsWith$1(t4, n2) {
  var r2 = t4.length - n2.length, i2 = t4.length;
  return t4.substring(r2, i2) === n2;
}
function format$3(t4, n2) {
  var r2 = _format$1(t4, n2);
  return n2 && typeof n2 == `object` && `truncate` in n2 && r2.length > n2.truncate ? r2.substring(0, n2.truncate - 3) + `...` : r2;
}
function _format$1(t4, n2) {
  return typeof t4 == `number` ? format$2$1(t4, n2) : isBigNumber$1(t4) ? format$1$1(t4, n2) : looksLikeFraction$1(t4) ? !n2 || n2.fraction !== `decimal` ? `${t4.s * t4.n}/${t4.d}` : t4.toString() : Array.isArray(t4) ? formatArray$1(t4, n2) : isString$1(t4) ? stringify$1(t4) : typeof t4 == `function` ? t4.syntax ? String(t4.syntax) : `function` : t4 && typeof t4 == `object` ? typeof t4.format == `function` ? t4.format(n2) : t4 && t4.toString(n2) !== {}.toString() ? t4.toString(n2) : `{` + Object.keys(t4).map((r2) => stringify$1(r2) + `: ` + format$3(t4[r2], n2)).join(`, `) + `}` : String(t4);
}
function stringify$1(t4) {
  for (var n2 = String(t4), r2 = ``, i2 = 0; i2 < n2.length; ) {
    var a2 = n2.charAt(i2);
    r2 += a2 in controlCharacters$1 ? controlCharacters$1[a2] : a2, i2++;
  }
  return `"` + r2 + `"`;
}
var controlCharacters$1 = { '"': `\\"`, "\\": `\\\\`, "\b": `\\b`, "\f": `\\f`, "\n": `\\n`, "\r": `\\r`, "	": `\\t` };
function escape$2(t4) {
  var n2 = String(t4);
  return n2 = n2.replace(/&/g, `&amp;`).replace(/"/g, `&quot;`).replace(/'/g, `&#39;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`), n2;
}
function formatArray$1(t4, n2) {
  if (Array.isArray(t4)) {
    for (var r2 = `[`, i2 = t4.length, a2 = 0; a2 < i2; a2++) a2 !== 0 && (r2 += `, `), r2 += formatArray$1(t4[a2], n2);
    return r2 += `]`, r2;
  } else return format$3(t4, n2);
}
function looksLikeFraction$1(t4) {
  return t4 && typeof t4 == `object` && typeof t4.s == `bigint` && typeof t4.n == `bigint` && typeof t4.d == `bigint` || false;
}
function compareText$1(t4, n2) {
  if (!isString$1(t4)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf$1(t4) + `, index: 0)`);
  if (!isString$1(n2)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf$1(n2) + `, index: 1)`);
  return t4 === n2 ? 0 : t4 > n2 ? 1 : -1;
}
function DimensionError$1(t4, n2, r2) {
  if (!(this instanceof DimensionError$1)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.actual = t4, this.expected = n2, this.relation = r2, this.message = `Dimension mismatch (` + (Array.isArray(t4) ? `[` + t4.join(`, `) + `]` : t4) + ` ` + (this.relation || `!=`) + ` ` + (Array.isArray(n2) ? `[` + n2.join(`, `) + `]` : n2) + `)`, this.stack = Error().stack;
}
DimensionError$1.prototype = RangeError(), DimensionError$1.prototype.constructor = RangeError, DimensionError$1.prototype.name = `DimensionError`, DimensionError$1.prototype.isDimensionError = true;
function IndexError$1(t4, n2, r2) {
  if (!(this instanceof IndexError$1)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.index = t4, arguments.length < 3 ? (this.min = 0, this.max = n2) : (this.min = n2, this.max = r2), this.min !== void 0 && this.index < this.min ? this.message = `Index out of range (` + this.index + ` < ` + this.min + `)` : this.max !== void 0 && this.index >= this.max ? this.message = `Index out of range (` + this.index + ` > ` + (this.max - 1) + `)` : this.message = `Index out of range (` + this.index + `)`, this.stack = Error().stack;
}
IndexError$1.prototype = RangeError(), IndexError$1.prototype.constructor = RangeError, IndexError$1.prototype.name = `IndexError`, IndexError$1.prototype.isIndexError = true;
function arraySize$1(t4) {
  for (var n2 = []; Array.isArray(t4); ) n2.push(t4.length), t4 = t4[0];
  return n2;
}
function _validate$1(t4, n2, r2) {
  var i2, a2 = t4.length;
  if (a2 !== n2[r2]) throw new DimensionError$1(a2, n2[r2]);
  if (r2 < n2.length - 1) {
    var o2 = r2 + 1;
    for (i2 = 0; i2 < a2; i2++) {
      var s2 = t4[i2];
      if (!Array.isArray(s2)) throw new DimensionError$1(n2.length - 1, n2.length, `<`);
      _validate$1(t4[i2], n2, o2);
    }
  } else for (i2 = 0; i2 < a2; i2++) if (Array.isArray(t4[i2])) throw new DimensionError$1(n2.length + 1, n2.length, `>`);
}
function validate$1(t4, n2) {
  if (n2.length === 0) {
    if (Array.isArray(t4)) throw new DimensionError$1(t4.length, 0);
  } else _validate$1(t4, n2, 0);
}
function validateIndexSourceSize$1(t4, n2) {
  var r2 = t4.isMatrix ? t4._size : arraySize$1(t4);
  n2._sourceSize.forEach((t5, n3) => {
    if (t5 !== null && t5 !== r2[n3]) throw new DimensionError$1(t5, r2[n3]);
  });
}
function validateIndex$1(t4, n2) {
  if (t4 !== void 0) {
    if (!isNumber$1(t4) || !isInteger$2(t4)) throw TypeError(`Index must be an integer (value: ` + t4 + `)`);
    if (t4 < 0 || typeof n2 == `number` && t4 >= n2) throw new IndexError$1(t4, n2);
  }
}
function isEmptyIndex$1(t4) {
  for (var n2 = 0; n2 < t4._dimensions.length; ++n2) {
    var r2 = t4._dimensions[n2];
    if (r2._data && isArray$1(r2._data)) {
      if (r2._size[0] === 0) return true;
    } else if (r2.isRange) {
      if (r2.start === r2.end) return true;
    } else if (isString$1(r2) && r2.length === 0) return true;
  }
  return false;
}
function resize$1(t4, n2, r2) {
  if (!Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw Error(`Resizing to scalar is not supported`);
  return n2.forEach(function(t5) {
    if (!isNumber$1(t5) || !isInteger$2(t5) || t5 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$3(n2) + `)`);
  }), (isNumber$1(t4) || isBigNumber$1(t4)) && (t4 = [t4]), _resize$1(t4, n2, 0, r2 === void 0 ? 0 : r2), t4;
}
function _resize$1(t4, n2, r2, i2) {
  var a2, o2, s2 = t4.length, c2 = n2[r2], l2 = Math.min(s2, c2);
  if (t4.length = c2, r2 < n2.length - 1) {
    var u2 = r2 + 1;
    for (a2 = 0; a2 < l2; a2++) o2 = t4[a2], Array.isArray(o2) || (o2 = [o2], t4[a2] = o2), _resize$1(o2, n2, u2, i2);
    for (a2 = l2; a2 < c2; a2++) o2 = [], t4[a2] = o2, _resize$1(o2, n2, u2, i2);
  } else {
    for (a2 = 0; a2 < l2; a2++) for (; Array.isArray(t4[a2]); ) t4[a2] = t4[a2][0];
    for (a2 = l2; a2 < c2; a2++) t4[a2] = i2;
  }
}
function reshape$1(t4, n2) {
  var r2 = flatten$4$1(t4, true), i2 = r2.length;
  if (!Array.isArray(t4) || !Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw new DimensionError$1(0, i2, `!=`);
  n2 = processSizesWildcard$1(n2, i2);
  var a2 = product$1$1(n2);
  if (i2 !== a2) throw new DimensionError$1(a2, i2, `!=`);
  try {
    return _reshape$1(r2, n2);
  } catch (t5) {
    throw t5 instanceof DimensionError$1 ? new DimensionError$1(a2, i2, `!=`) : t5;
  }
}
function processSizesWildcard$1(t4, n2) {
  var r2 = product$1$1(t4), i2 = t4.slice(), a2 = -1, o2 = t4.indexOf(a2);
  if (t4.indexOf(a2, o2 + 1) >= 0) throw Error(`More than one wildcard in sizes`);
  var s2 = o2 >= 0, c2 = n2 % r2 === 0;
  if (s2) if (c2) i2[o2] = -n2 / r2;
  else throw Error(`Could not replace wildcard, since ` + n2 + ` is no multiple of ` + -r2);
  return i2;
}
function product$1$1(t4) {
  return t4.reduce((t5, n2) => t5 * n2, 1);
}
function _reshape$1(t4, n2) {
  for (var r2 = t4, i2, a2 = n2.length - 1; a2 > 0; a2--) {
    var o2 = n2[a2];
    i2 = [];
    for (var s2 = r2.length / o2, c2 = 0; c2 < s2; c2++) i2.push(r2.slice(c2 * o2, (c2 + 1) * o2));
    r2 = i2;
  }
  return r2;
}
function squeeze$1(t4, n2) {
  for (var r2 = arraySize$1(t4); Array.isArray(t4) && t4.length === 1; ) t4 = t4[0], r2.shift();
  for (var i2 = r2.length; r2[i2 - 1] === 1; ) i2--;
  return i2 < r2.length && (t4 = _squeeze$1(t4, i2, 0), r2.length = i2), t4;
}
function _squeeze$1(t4, n2, r2) {
  var i2, a2;
  if (r2 < n2) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _squeeze$1(t4[i2], n2, o2);
  } else for (; Array.isArray(t4); ) t4 = t4[0];
  return t4;
}
function unsqueeze$1(t4, n2, r2, i2) {
  var a2 = i2 || arraySize$1(t4);
  if (r2) for (var o2 = 0; o2 < r2; o2++) t4 = [t4], a2.unshift(1);
  for (t4 = _unsqueeze$1(t4, n2, 0); a2.length < n2; ) a2.push(1);
  return t4;
}
function _unsqueeze$1(t4, n2, r2) {
  var i2, a2;
  if (Array.isArray(t4)) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _unsqueeze$1(t4[i2], n2, o2);
  } else for (var s2 = r2; s2 < n2; s2++) t4 = [t4];
  return t4;
}
function flatten$4$1(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (!Array.isArray(t4)) return t4;
  if (typeof n2 != `boolean`) throw TypeError(`Boolean expected for second argument of flatten`);
  var r2 = [];
  return n2 ? a2(t4) : i2(t4), r2;
  function i2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      var a3 = t5[n3];
      Array.isArray(a3) ? i2(a3) : r2.push(a3);
    }
  }
  function a2(t5) {
    if (Array.isArray(t5[0])) for (var n3 = 0; n3 < t5.length; n3++) a2(t5[n3]);
    else for (var i3 = 0; i3 < t5.length; i3++) r2.push(t5[i3]);
  }
}
function map$1$1(t4, n2) {
  return Array.prototype.map.call(t4, n2);
}
function forEach$1(t4, n2) {
  Array.prototype.forEach.call(t4, n2);
}
function filter$1$1(t4, n2) {
  if (arraySize$1(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, n2);
}
function filterRegExp$1(t4, n2) {
  if (arraySize$1(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, (t5) => n2.test(t5));
}
function join$3(t4, n2) {
  return Array.prototype.join.call(t4, n2);
}
function identify$1(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  var n2 = [], r2 = 0;
  n2[0] = { value: t4[0], identifier: 0 };
  for (var i2 = 1; i2 < t4.length; i2++) t4[i2] === t4[i2 - 1] ? r2++ : r2 = 0, n2.push({ value: t4[i2], identifier: r2 });
  return n2;
}
function generalize$1(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  for (var n2 = [], r2 = 0; r2 < t4.length; r2++) n2.push(t4[r2].value);
  return n2;
}
function getArrayDataType$1(t4, n2) {
  for (var r2, i2 = 0, a2 = 0; a2 < t4.length; a2++) {
    var o2 = t4[a2], s2 = Array.isArray(o2);
    if (a2 === 0 && s2 && (i2 = o2.length), s2 && o2.length !== i2) return;
    var c2 = s2 ? getArrayDataType$1(o2, n2) : n2(o2);
    if (r2 === void 0) r2 = c2;
    else if (r2 !== c2) return `mixed`;
  }
  return r2;
}
function concatRecursive$1(t4, n2, r2, i2) {
  if (i2 < r2) {
    if (t4.length !== n2.length) throw new DimensionError$1(t4.length, n2.length);
    for (var a2 = [], o2 = 0; o2 < t4.length; o2++) a2[o2] = concatRecursive$1(t4[o2], n2[o2], r2, i2 + 1);
    return a2;
  } else return t4.concat(n2);
}
function concat$1() {
  var t4 = Array.prototype.slice.call(arguments, 0, -1), n2 = Array.prototype.slice.call(arguments, -1);
  if (t4.length === 1) return t4[0];
  if (t4.length > 1) return t4.slice(1).reduce(function(t5, r2) {
    return concatRecursive$1(t5, r2, n2, 0);
  }, t4[0]);
  throw Error(`Wrong number of arguments in function concat`);
}
function broadcastSizes$1() {
  for (var t4 = [...arguments], n2 = t4.map((t5) => t5.length), r2 = Math.max(...n2), i2 = Array(r2).fill(null), a2 = 0; a2 < t4.length; a2++) for (var o2 = t4[a2], s2 = n2[a2], c2 = 0; c2 < s2; c2++) {
    var l2 = r2 - s2 + c2;
    o2[c2] > i2[l2] && (i2[l2] = o2[c2]);
  }
  for (var u2 = 0; u2 < t4.length; u2++) checkBroadcastingRules$1(t4[u2], i2);
  return i2;
}
function checkBroadcastingRules$1(t4, n2) {
  for (var r2 = n2.length, i2 = t4.length, a2 = 0; a2 < i2; a2++) {
    var o2 = r2 - i2 + a2;
    if (t4[a2] < n2[o2] && t4[a2] > 1 || t4[a2] > n2[o2]) throw Error(`shape mismatch: mismatch is found in arg with shape (${t4}) not possible to broadcast dimension ${i2} with size ${t4[a2]} to size ${n2[o2]}`);
  }
}
function broadcastTo$1(t4, n2) {
  var r2 = arraySize$1(t4);
  if (deepStrictEqual$1(r2, n2)) return t4;
  checkBroadcastingRules$1(r2, n2);
  var i2 = broadcastSizes$1(r2, n2), a2 = i2.length, o2 = [...Array(a2 - r2.length).fill(1), ...r2], s2 = clone$1$1(t4);
  r2.length < a2 && (s2 = reshape$1(s2, o2), r2 = arraySize$1(s2));
  for (var c2 = 0; c2 < a2; c2++) r2[c2] < i2[c2] && (s2 = stretch$1(s2, i2[c2], c2), r2 = arraySize$1(s2));
  return s2;
}
function stretch$1(t4, n2, r2) {
  return concat$1(...Array(n2).fill(t4), r2);
}
function get$1$1(t4, n2) {
  if (!Array.isArray(t4)) throw Error(`Array expected`);
  if (!Array.isArray(n2)) throw Error(`Array expected for index`);
  var r2 = arraySize$1(t4);
  if (n2.length !== r2.length) throw new DimensionError$1(n2.length, r2.length);
  for (var i2 = 0; i2 < n2.length; i2++) validateIndex$1(n2[i2], r2[i2]);
  return n2.reduce((t5, n3) => t5[n3], t4);
}
function deepMap$1$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return [];
  if (r2) return o2(t4);
  var i2 = [];
  return a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) {
      for (var s2 = r3.length, c2 = Array(s2), l2 = 0; l2 < s2; l2++) i2[o3] = l2, c2[l2] = a2(r3[l2], o3 + 1);
      return c2;
    } else return n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) {
      for (var r3 = t5.length, i3 = Array(r3), a3 = 0; a3 < r3; a3++) i3[a3] = o2(t5[a3]);
      return i3;
    } else return n2(t5);
  }
}
function deepForEach$1$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return;
  if (r2) {
    o2(t4);
    return;
  }
  var i2 = [];
  a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) for (var s2 = r3.length, c2 = 0; c2 < s2; c2++) i2[o3] = c2, a2(r3[c2], o3 + 1);
    else n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) for (var r3 = t5.length, i3 = 0; i3 < r3; i3++) o2(t5[i3]);
    else n2(t5);
  }
}
function clone$1$1(t4) {
  return _extends$3([], t4);
}
function optimizeCallback$1(t4, n2, r2, i2) {
  if (import_typed_function$1.default.isTypedFunction(t4)) {
    var a2;
    if (i2) a2 = 1;
    else {
      var o2 = n2.isMatrix ? n2.size() : arraySize$1(n2);
      if (!o2.length || o2[o2.length - 1] === 0) return { isUnary: i2, fn: t4 };
      var s2 = o2.map(() => 0);
      a2 = _findNumberOfArgumentsTyped$1(t4, n2.isMatrix ? n2.get(s2) : get$1$1(n2, s2), s2, n2);
    }
    var c2;
    if (n2.isMatrix && n2.dataType !== `mixed` && n2.dataType !== void 0) {
      var l2 = _findSingleSignatureWithArity$1(t4, a2);
      c2 = l2 === void 0 ? t4 : l2;
    } else c2 = t4;
    return a2 >= 1 && a2 <= 3 ? { isUnary: a2 === 1, fn: function() {
      return _tryFunctionWithArgs$1(c2, [...arguments].slice(0, a2), r2, t4.name);
    } } : { isUnary: false, fn: function() {
      return _tryFunctionWithArgs$1(c2, [...arguments], r2, t4.name);
    } };
  }
  return i2 === void 0 ? { isUnary: _findIfCallbackIsUnary$1(t4), fn: t4 } : { isUnary: i2, fn: t4 };
}
function _findSingleSignatureWithArity$1(t4, n2) {
  var r2 = [];
  if (Object.entries(t4.signatures).forEach((t5) => {
    var [i2, a2] = t5;
    i2.split(`,`).length === n2 && r2.push(a2);
  }), r2.length === 1) return r2[0];
}
function _findIfCallbackIsUnary$1(t4) {
  if (t4.length !== 1) return false;
  var n2 = t4.toString();
  if (/arguments/.test(n2)) return false;
  var r2 = n2.match(/\(.*?\)/);
  return !/\.\.\./.test(r2);
}
function _findNumberOfArgumentsTyped$1(t4, n2, r2, i2) {
  for (var a2 = [n2, r2, i2], o2 = 3; o2 > 0; o2--) {
    var s2 = a2.slice(0, o2);
    if (import_typed_function$1.default.resolve(t4, s2) !== null) return o2;
  }
}
function _tryFunctionWithArgs$1(t4, n2, r2, i2) {
  try {
    return t4(...n2);
  } catch (t5) {
    _createCallbackError$1(t5, n2, r2, i2);
  }
}
function _createCallbackError$1(t4, n2, r2, i2) {
  if (t4 instanceof TypeError && t4.data?.category === `wrongType`) {
    var o2 = [];
    throw o2.push(`value: ${typeOf$1(n2[0])}`), n2.length >= 2 && o2.push(`index: ${typeOf$1(n2[1])}`), n2.length >= 3 && o2.push(`array: ${typeOf$1(n2[2])}`), TypeError(`Function ${r2} cannot apply callback arguments ${i2}(${o2.join(`, `)}) at index ${JSON.stringify(n2[1])}`);
  } else throw TypeError(`Function ${r2} cannot apply callback arguments to function ${i2}: ${t4.message}`);
}
var name$315$1 = `DenseMatrix`, dependencies$315$1 = [`Matrix`, `config`], createDenseMatrixClass$1 = factory$1(name$315$1, dependencies$315$1, (t4) => {
  var { Matrix: n2, config: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$1(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$1(t5)) t5.type === `DenseMatrix` ? (this._data = clone$3$1(t5._data), this._size = clone$3$1(t5._size), this._datatype = n3 || t5._datatype) : (this._data = t5.toArray(), this._size = t5.size(), this._datatype = n3 || t5._datatype);
    else if (t5 && isArray$1(t5.data) && isArray$1(t5.size)) this._data = t5.data, this._size = t5.size, validate$1(this._data, this._size), this._datatype = n3 || t5.datatype;
    else if (isArray$1(t5)) this._data = d2(t5), this._size = arraySize$1(this._data), validate$1(this._data, this._size), this._datatype = n3;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$1(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3;
  }
  i2.prototype = new n2(), i2.prototype.createDenseMatrix = function(t5, n3) {
    return new i2(t5, n3);
  }, Object.defineProperty(i2, "name", { value: `DenseMatrix` }), i2.prototype.constructor = i2, i2.prototype.type = `DenseMatrix`, i2.prototype.isDenseMatrix = true, i2.prototype.getDataType = function() {
    return getArrayDataType$1(this._data, typeOf$1);
  }, i2.prototype.storage = function() {
    return `dense`;
  }, i2.prototype.datatype = function() {
    return this._datatype;
  }, i2.prototype.create = function(t5, n3) {
    return new i2(t5, n3);
  }, i2.prototype.subset = function(t5, n3, r3) {
    switch (arguments.length) {
      case 1:
        return a2(this, t5);
      case 2:
      case 3:
        return s2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.get = function(t5) {
    return get$1$1(this._data, t5);
  }, i2.prototype.set = function(t5, n3, r3) {
    if (!isArray$1(t5)) throw TypeError(`Array expected`);
    if (t5.length < this._size.length) throw new DimensionError$1(t5.length, this._size.length, `<`);
    var i3, a3, o3, s3 = t5.map(function(t6) {
      return t6 + 1;
    });
    u2(this, s3, r3);
    var c3 = this._data;
    for (i3 = 0, a3 = t5.length - 1; i3 < a3; i3++) o3 = t5[i3], validateIndex$1(o3, c3.length), c3 = c3[o3];
    return o3 = t5[t5.length - 1], validateIndex$1(o3, c3.length), c3[o3] = n3, this;
  };
  function a2(t5, n3) {
    if (!isIndex$1(n3)) throw TypeError(`Invalid index`);
    if (r2.legacySubset ? n3.size().every((t6) => t6 === 1) : n3.isScalar()) return t5.get(n3.min());
    var a3 = n3.size();
    if (a3.length !== t5._size.length) throw new DimensionError$1(a3.length, t5._size.length);
    for (var s3 = n3.min(), c3 = n3.max(), l3 = 0, u3 = t5._size.length; l3 < u3; l3++) validateIndex$1(s3[l3], t5._size[l3]), validateIndex$1(c3[l3], t5._size[l3]);
    var d3 = new i2(), p2 = o2(t5._data, n3);
    return d3._size = p2.size, d3._datatype = t5._datatype, d3._data = p2.data, r2.legacySubset ? d3.reshape(n3.size()) : d3;
  }
  function o2(t5, n3) {
    var r3 = n3.size().length - 1, i3 = Array(r3);
    return { data: a3(t5), size: i3.filter((t6) => t6 !== null) };
    function a3(t6) {
      var o3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s3 = n3.dimension(o3);
      function c3(t7, n4) {
        return isNumber$1(t7) ? n4(t7) : t7.map(n4).valueOf();
      }
      return isNumber$1(s3) ? i3[o3] = null : i3[o3] = s3.size()[0], o3 < r3 ? c3(s3, (n4) => (validateIndex$1(n4, t6.length), a3(t6[n4], o3 + 1))) : c3(s3, (n4) => (validateIndex$1(n4, t6.length), t6[n4]));
    }
  }
  function s2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix$1(r3) ? (s3 = r3.size(), r3 = r3.valueOf()) : s3 = arraySize$1(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (!deepStrictEqual$1(s3, a3)) {
        if (s3.length === 0) r3 = broadcastTo$1([r3], a3);
        else try {
          r3 = broadcastTo$1(r3, a3);
        } catch {
        }
        s3 = arraySize$1(r3);
      }
      if (a3.length < t5._size.length) throw new DimensionError$1(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var l3 = 0, d3 = 0; a3[l3] === 1 && s3[l3] === 1; ) l3++;
        for (; a3[l3] === 1; ) d3++, l3++;
        r3 = unsqueeze$1(r3, a3.length, d3, s3);
      }
      if (!deepStrictEqual$1(a3, s3)) throw new DimensionError$1(a3, s3, `>`);
      u2(t5, n3.max().map(function(t6) {
        return t6 + 1;
      }), i3), c2(t5._data, n3, r3);
    }
    return t5;
  }
  function c2(t5, n3, r3) {
    var i3 = n3.size().length - 1;
    a3(t5, r3);
    function a3(t6, r4) {
      var o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s3 = n3.dimension(o3), c3 = (n4, i4) => {
        validateIndex$1(n4, t6.length), a3(t6[n4], r4[i4[0]], o3 + 1);
      }, l3 = (n4, i4) => {
        validateIndex$1(n4, t6.length), t6[n4] = r4[i4[0]];
      };
      o3 < i3 ? isNumber$1(s3) ? c3(s3, [0]) : s3.forEach(c3) : isNumber$1(s3) ? l3(s3, [0]) : s3.forEach(l3);
    }
  }
  i2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection$1(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    return l2(r3 ? this.clone() : this, i3, n3);
  };
  function l2(t5, n3, r3) {
    if (n3.length === 0) {
      for (var i3 = t5._data; isArray$1(i3); ) i3 = i3[0];
      return i3;
    }
    return t5._size = n3.slice(0), t5._data = resize$1(t5._data, t5._size, r3), t5;
  }
  i2.prototype.reshape = function(t5, n3) {
    var r3 = n3 ? this.clone() : this;
    return r3._data = reshape$1(r3._data, t5), r3._size = processSizesWildcard$1(t5, r3._size.reduce((t6, n4) => t6 * n4)), r3;
  };
  function u2(t5, n3, r3) {
    for (var i3 = t5._size.slice(0), a3 = false; i3.length < n3.length; ) i3.push(0), a3 = true;
    for (var o3 = 0, s3 = n3.length; o3 < s3; o3++) n3[o3] > i3[o3] && (i3[o3] = n3[o3], a3 = true);
    a3 && l2(t5, i3, r3);
  }
  i2.prototype.clone = function() {
    return new i2({ data: clone$3$1(this._data), size: clone$3$1(this._size), datatype: this._datatype });
  }, i2.prototype.size = function() {
    return this._size.slice(0);
  }, i2.prototype.map = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return r3.clone();
    var a3 = optimizeCallback$1(t5, r3, `map`, n3), o3 = a3.fn, s3 = r3.create(void 0, r3._datatype);
    if (s3._size = r3._size, n3 || a3.isUnary) return s3._data = m2(r3._data), s3;
    if (i3 === 0) {
      for (var c3 = r3.valueOf(), l3 = Array(c3.length), u3 = 0; u3 < c3.length; u3++) l3[u3] = o3(c3[u3], [u3], r3);
      return s3._data = l3, s3;
    }
    var d3 = [];
    return s3._data = p2(r3._data), s3;
    function p2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a4 = Array(t6.length);
      if (n4 < i3) for (var s4 = 0; s4 < t6.length; s4++) d3[n4] = s4, a4[s4] = p2(t6[s4], n4 + 1);
      else for (var c4 = 0; c4 < t6.length; c4++) d3[n4] = c4, a4[c4] = o3(t6[c4], d3.slice(), r3);
      return a4;
    }
    function m2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r4 = Array(t6.length);
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) r4[a4] = m2(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) r4[s4] = o3(t6[s4]);
      return r4;
    }
  }, i2.prototype.forEach = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return;
    var a3 = optimizeCallback$1(t5, r3, `map`, n3), o3 = a3.fn;
    if (n3 || a3.isUnary) {
      u3(r3._data);
      return;
    }
    if (i3 === 0) {
      for (var s3 = 0; s3 < r3._data.length; s3++) o3(r3._data[s3], [s3], r3);
      return;
    }
    var c3 = [];
    l3(r3._data);
    function l3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) c3[n4] = a4, l3(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) c3[n4] = s4, o3(t6[s4], c3.slice(), r3);
    }
    function u3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var r4 = 0; r4 < t6.length; r4++) u3(t6[r4], n4 + 1);
      else for (var a4 = 0; a4 < t6.length; a4++) o3(t6[a4]);
    }
  }, i2.prototype[Symbol.iterator] = function* () {
    var t5 = this._size.length - 1;
    if (!(t5 < 0)) {
      if (t5 === 0) {
        for (var n3 = 0; n3 < this._data.length; n3++) yield { value: this._data[n3], index: [n3] };
        return;
      }
      for (var r3 = Array(t5 + 1).fill(0), i3 = this._size.reduce((t6, n4) => t6 * n4, 1), a3 = 0; a3 < i3; a3++) {
        for (var o3 = this._data, s3 = 0; s3 < t5; s3++) o3 = o3[r3[s3]];
        yield { value: o3[r3[t5]], index: r3.slice() };
        for (var c3 = t5; c3 >= 0 && (r3[c3]++, !(r3[c3] < this._size[c3])); c3--) r3[c3] = 0;
      }
    }
  }, i2.prototype.rows = function() {
    var t5 = [];
    if (this.size().length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var n3 of this._data) t5.push(new i2([n3], this._datatype));
    return t5;
  }, i2.prototype.columns = function() {
    var t5 = this, n3 = [], r3 = this.size();
    if (r3.length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var a3 = this._data, o3 = function(r4) {
      var o4 = a3.map((t6) => [t6[r4]]);
      n3.push(new i2(o4, t5._datatype));
    }, s3 = 0; s3 < r3[1]; s3++) o3(s3);
    return n3;
  }, i2.prototype.toArray = function() {
    return clone$3$1(this._data);
  }, i2.prototype.valueOf = function() {
    return this._data;
  }, i2.prototype.format = function(t5) {
    return format$3(this._data, t5);
  }, i2.prototype.toString = function() {
    return format$3(this._data);
  }, i2.prototype.toJSON = function() {
    return { mathjs: `DenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber$1(t5) && (t5 = t5.toNumber()), !isNumber$1(t5) || !isInteger$2(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    for (var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, a3 = this._size[0], o3 = this._size[1], s3 = Math.min(a3 - r3, o3 - n3), c3 = [], l3 = 0; l3 < s3; l3++) c3[l3] = this._data[l3 + r3][l3 + n3];
    return new i2({ data: c3, size: [s3], datatype: this._datatype });
  }, i2.diagonal = function(t5, n3, r3, a3) {
    if (!isArray$1(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber$1(t6) && (t6 = t6.toNumber()), !isNumber$1(t6) || !isInteger$2(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), r3) {
      if (isBigNumber$1(r3) && (r3 = r3.toNumber()), !isNumber$1(r3) || !isInteger$2(r3)) throw TypeError(`The parameter k must be an integer number`);
    } else r3 = 0;
    var o3 = r3 > 0 ? r3 : 0, s3 = r3 < 0 ? -r3 : 0, c3 = t5[0], l3 = t5[1], u3 = Math.min(c3 - s3, l3 - o3), d3;
    if (isArray$1(n3)) {
      if (n3.length !== u3) throw Error(`Invalid value array length`);
      d3 = function(t6) {
        return n3[t6];
      };
    } else if (isMatrix$1(n3)) {
      var p2 = n3.size();
      if (p2.length !== 1 || p2[0] !== u3) throw Error(`Invalid matrix length`);
      d3 = function(t6) {
        return n3.get([t6]);
      };
    } else d3 = function() {
      return n3;
    };
    a3 ||= isBigNumber$1(d3(0)) ? d3(0).mul(0) : 0;
    var m2 = [];
    if (t5.length > 0) {
      m2 = resize$1(m2, t5, a3);
      for (var h2 = 0; h2 < u3; h2++) m2[h2 + s3][h2 + o3] = d3(h2);
    }
    return new i2({ data: m2, size: [c3, l3] });
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function(t5, n3) {
    if (!isNumber$1(t5) || !isInteger$2(t5) || !isNumber$1(n3) || !isInteger$2(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex$1(t5, this._size[0]), validateIndex$1(n3, this._size[0]), i2._swapRows(t5, n3, this._data), this;
  }, i2._swapRows = function(t5, n3, r3) {
    var i3 = r3[t5];
    r3[t5] = r3[n3], r3[n3] = i3;
  };
  function d2(t5) {
    return isMatrix$1(t5) ? d2(t5.valueOf()) : isArray$1(t5) ? t5.map(d2) : t5;
  }
  return i2;
}, { isClass: true }), name$314$1 = `clone`, dependencies$314$1 = [`typed`], createClone$1 = factory$1(name$314$1, dependencies$314$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$314$1, { any: clone$3$1 });
});
function _switch$1$1(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
function containsCollections$1(t4) {
  for (var n2 = 0; n2 < t4.length; n2++) if (isCollection$1(t4[n2])) return true;
  return false;
}
function deepForEach$2(t4, n2) {
  isMatrix$1(t4) ? t4.forEach((t5) => n2(t5), false, true) : deepForEach$1$1(t4, n2, true);
}
function deepMap$2(t4, n2, r2) {
  if (!r2) return isMatrix$1(t4) ? t4.map((t5) => n2(t5), false, true) : deepMap$1$1(t4, n2, true);
  var i2 = (t5) => t5 === 0 ? t5 : n2(t5);
  return isMatrix$1(t4) ? t4.map((t5) => i2(t5), false, true) : deepMap$1$1(t4, i2, true);
}
function reduce$1$1(t4, n2, r2) {
  var i2 = Array.isArray(t4) ? arraySize$1(t4) : t4.size();
  if (n2 < 0 || n2 >= i2.length) throw new IndexError$1(n2, i2.length);
  return isMatrix$1(t4) ? t4.create(_reduce$1(t4.valueOf(), n2, r2), t4.datatype()) : _reduce$1(t4, n2, r2);
}
function _reduce$1(t4, n2, r2) {
  var i2, a2, o2, s2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (s2 = _switch$1$1(t4), a2 = [], i2 = 0; i2 < s2.length; i2++) a2[i2] = _reduce$1(s2[i2], n2 - 1, r2);
    return a2;
  } else {
    for (o2 = t4[0], i2 = 1; i2 < t4.length; i2++) o2 = r2(o2, t4[i2]);
    return o2;
  }
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _reduce$1(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function scatter$1(t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2) {
  var p2 = t4._values, m2 = t4._index, h2 = t4._ptr, g2, v2, y2, b2;
  if (i2) for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? (i2[b2] = c2(i2[b2], p2[g2]), a2[b2] = o2) : (r2[b2] = o2, s2.push(b2), i2[b2] = p2[g2]);
  else for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? a2[b2] = o2 : (r2[b2] = o2, s2.push(b2));
}
var name$313$1 = `isInteger`, dependencies$313$1 = [`typed`, `equal`], createIsInteger$1 = factory$1(name$313$1, dependencies$313$1, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$313$1, { number: (t5) => Number.isFinite(t5) ? r2(t5, Math.round(t5)) : false, BigNumber: (t5) => t5.isFinite() ? r2(t5.round(), t5) : false, bigint: (t5) => true, Fraction: (t5) => t5.d === 1n, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), n1$4$1 = `number`, n2$3$1 = `number, number`;
function absNumber$1(t4) {
  return Math.abs(t4);
}
absNumber$1.signature = n1$4$1;
function addNumber$1(t4, n2) {
  return t4 + n2;
}
addNumber$1.signature = n2$3$1;
function subtractNumber$1(t4, n2) {
  return t4 - n2;
}
subtractNumber$1.signature = n2$3$1;
function multiplyNumber$1(t4, n2) {
  return t4 * n2;
}
multiplyNumber$1.signature = n2$3$1;
function unaryMinusNumber$1(t4) {
  return -t4;
}
unaryMinusNumber$1.signature = n1$4$1;
function unaryPlusNumber$1(t4) {
  return t4;
}
unaryPlusNumber$1.signature = n1$4$1;
function cbrtNumber$1(t4) {
  return cbrt$1$1(t4);
}
cbrtNumber$1.signature = n1$4$1;
function cubeNumber$1(t4) {
  return t4 * t4 * t4;
}
cubeNumber$1.signature = n1$4$1;
function expNumber$1(t4) {
  return Math.exp(t4);
}
expNumber$1.signature = n1$4$1;
function expm1Number$1(t4) {
  return expm1$1(t4);
}
expm1Number$1.signature = n1$4$1;
function lcmNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Parameters in function lcm must be integer numbers`);
  if (t4 === 0 || n2 === 0) return 0;
  for (var r2, i2 = t4 * n2; n2 !== 0; ) r2 = n2, n2 = t4 % r2, t4 = r2;
  return Math.abs(i2 / t4);
}
lcmNumber$1.signature = n2$3$1;
function logNumber$1(t4, n2) {
  return n2 ? Math.log(t4) / Math.log(n2) : Math.log(t4);
}
function log10Number$1(t4) {
  return log10$2$1(t4);
}
log10Number$1.signature = n1$4$1;
function log2Number$1(t4) {
  return log2$1$1(t4);
}
log2Number$1.signature = n1$4$1;
function nthRootNumber$1(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, r2 = n2 < 0;
  if (r2 && (n2 = -n2), n2 === 0) throw Error(`Root must be non-zero`);
  if (t4 < 0 && Math.abs(n2) % 2 != 1) throw Error(`Root must be odd when a is negative.`);
  if (t4 === 0) return r2 ? 1 / 0 : 0;
  if (!isFinite(t4)) return r2 ? 0 : t4;
  var i2 = Math.abs(t4) ** (1 / n2);
  return i2 = t4 < 0 ? -i2 : i2, r2 ? 1 / i2 : i2;
}
function signNumber$1(t4) {
  return sign$2$1(t4);
}
signNumber$1.signature = n1$4$1;
function squareNumber$1(t4) {
  return t4 * t4;
}
squareNumber$1.signature = n1$4$1;
function xgcdNumber$1(t4, n2) {
  var r2, i2, a2, o2 = 0, s2 = 1, c2 = 1, l2 = 0;
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Parameters in function xgcd must be integer numbers`);
  for (; n2; ) i2 = Math.floor(t4 / n2), a2 = t4 - i2 * n2, r2 = o2, o2 = s2 - i2 * o2, s2 = r2, r2 = c2, c2 = l2 - i2 * c2, l2 = r2, t4 = n2, n2 = a2;
  return t4 < 0 ? [-t4, -s2, -l2] : [t4, t4 ? s2 : 0, l2];
}
xgcdNumber$1.signature = n2$3$1;
function powNumber$1(t4, n2) {
  return t4 * t4 < 1 && n2 === 1 / 0 || t4 * t4 > 1 && n2 === -1 / 0 ? 0 : t4 ** +n2;
}
powNumber$1.signature = n2$3$1;
function roundNumber$1(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!isInteger$2(n2) || n2 < 0 || n2 > 15) throw Error(`Number of decimals in function round must be an integer from 0 to 15 inclusive`);
  return parseFloat(toFixed$2$1(t4, n2));
}
var n1$3$1 = `number`, n2$2$1 = `number, number`;
function bitAndNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function bitAnd`);
  return t4 & n2;
}
bitAndNumber$1.signature = n2$2$1;
function bitNotNumber$1(t4) {
  if (!isInteger$2(t4)) throw Error(`Integer expected in function bitNot`);
  return ~t4;
}
bitNotNumber$1.signature = n1$3$1;
function bitOrNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function bitOr`);
  return t4 | n2;
}
bitOrNumber$1.signature = n2$2$1;
function bitXorNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function bitXor`);
  return t4 ^ n2;
}
bitXorNumber$1.signature = n2$2$1;
function leftShiftNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function leftShift`);
  return t4 << n2;
}
leftShiftNumber$1.signature = n2$2$1;
function rightArithShiftNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function rightArithShift`);
  return t4 >> n2;
}
rightArithShiftNumber$1.signature = n2$2$1;
function rightLogShiftNumber$1(t4, n2) {
  if (!isInteger$2(t4) || !isInteger$2(n2)) throw Error(`Integers expected in function rightLogShift`);
  return t4 >>> n2;
}
rightLogShiftNumber$1.signature = n2$2$1;
function product$2(t4, n2) {
  if (n2 < t4) return 1;
  if (n2 === t4) return n2;
  var r2 = n2 + t4 >> 1;
  return product$2(t4, r2) * product$2(r2 + 1, n2);
}
function combinationsNumber$1(t4, n2) {
  if (!isInteger$2(t4) || t4 < 0 || !isInteger$2(n2) || n2 < 0) throw TypeError(`Positive integer value expected in function combinations`);
  if (n2 > t4) throw TypeError(`k must be less than or equal to n`);
  for (var r2 = t4 - n2, i2 = 1, a2 = n2 < r2 ? r2 + 1 : n2 + 1, o2 = 2, s2 = n2 < r2 ? n2 : r2, c2 = a2; c2 <= t4; ++c2) for (i2 *= c2; o2 <= s2 && i2 % o2 === 0; ) i2 /= o2, ++o2;
  return o2 <= s2 && (i2 /= product$2(o2, s2)), i2;
}
combinationsNumber$1.signature = `number, number`;
var pi$2 = Math.PI, tau$1 = 2 * Math.PI, e$2 = Math.E, phi$1 = 1.618033988749895, n1$2$1 = `number`, n2$1$1 = `number, number`;
function notNumber$1(t4) {
  return !t4;
}
notNumber$1.signature = n1$2$1;
function orNumber$1(t4, n2) {
  return !!(t4 || n2);
}
orNumber$1.signature = n2$1$1;
function xorNumber$1(t4, n2) {
  return !!t4 != !!n2;
}
xorNumber$1.signature = n2$1$1;
function andNumber$1(t4, n2) {
  return !!(t4 && n2);
}
andNumber$1.signature = n2$1$1;
function gammaNumber$1(t4) {
  var n2;
  if (isInteger$2(t4)) return t4 <= 0 ? Number.isFinite(t4) ? 1 / 0 : NaN : t4 > 171 ? 1 / 0 : product$2(1, t4 - 1);
  if (t4 < 0.5) return Math.PI / (Math.sin(Math.PI * t4) * gammaNumber$1(1 - t4));
  if (t4 >= 171.35) return 1 / 0;
  if (t4 > 85) {
    var r2 = t4 * t4, i2 = r2 * t4, a2 = i2 * t4, o2 = a2 * t4;
    return Math.sqrt(2 * Math.PI / t4) * (t4 / Math.E) ** +t4 * (1 + 1 / (12 * t4) + 1 / (288 * r2) - 139 / (51840 * i2) - 571 / (2488320 * a2) + 163879 / (209018880 * o2) + 5246819 / (75246796800 * o2 * t4));
  }
  --t4, n2 = gammaP$1[0];
  for (var s2 = 1; s2 < gammaP$1.length; ++s2) n2 += gammaP$1[s2] / (t4 + s2);
  var c2 = t4 + gammaG$1 + 0.5;
  return Math.sqrt(2 * Math.PI) * c2 ** +(t4 + 0.5) * Math.exp(-c2) * n2;
}
gammaNumber$1.signature = `number`;
var gammaG$1 = 4.7421875, gammaP$1 = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI$1 = 0.9189385332046728, lgammaSeries$1 = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber$1(t4) {
  if (t4 < 0) return NaN;
  if (t4 === 0) return 1 / 0;
  if (!Number.isFinite(t4)) return t4;
  if (t4 < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * t4)) - lgammaNumber$1(1 - t4);
  --t4;
  for (var n2 = t4 + 5 + 0.5, r2 = lgammaSeries$1[0], i2 = 6; i2 >= 1; i2--) r2 += lgammaSeries$1[i2] / (t4 + i2);
  return lnSqrt2PI$1 + (t4 + 0.5) * Math.log(n2) - n2 + Math.log(r2);
}
lgammaNumber$1.signature = `number`;
var n1$1$1 = `number`;
function acoshNumber$1(t4) {
  return acosh$2$1(t4);
}
acoshNumber$1.signature = n1$1$1;
function acotNumber$1(t4) {
  return Math.atan(1 / t4);
}
acotNumber$1.signature = n1$1$1;
function acothNumber$1(t4) {
  return Number.isFinite(t4) ? (Math.log((t4 + 1) / t4) + Math.log(t4 / (t4 - 1))) / 2 : 0;
}
acothNumber$1.signature = n1$1$1;
function acscNumber$1(t4) {
  return Math.asin(1 / t4);
}
acscNumber$1.signature = n1$1$1;
function acschNumber$1(t4) {
  var n2 = 1 / t4;
  return Math.log(n2 + Math.sqrt(n2 * n2 + 1));
}
acschNumber$1.signature = n1$1$1;
function asecNumber$1(t4) {
  return Math.acos(1 / t4);
}
asecNumber$1.signature = n1$1$1;
function asechNumber$1(t4) {
  var n2 = 1 / t4, r2 = Math.sqrt(n2 * n2 - 1);
  return Math.log(r2 + n2);
}
asechNumber$1.signature = n1$1$1;
function asinhNumber$1(t4) {
  return asinh$2$1(t4);
}
asinhNumber$1.signature = n1$1$1;
function atanhNumber$1(t4) {
  return atanh$2$1(t4);
}
atanhNumber$1.signature = n1$1$1;
function cotNumber$1(t4) {
  return 1 / Math.tan(t4);
}
cotNumber$1.signature = n1$1$1;
function cothNumber$1(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 + 1) / (n2 - 1);
}
cothNumber$1.signature = n1$1$1;
function cscNumber$1(t4) {
  return 1 / Math.sin(t4);
}
cscNumber$1.signature = n1$1$1;
function cschNumber$1(t4) {
  return t4 === 0 ? 1 / 0 : Math.abs(2 / (Math.exp(t4) - Math.exp(-t4))) * sign$2$1(t4);
}
cschNumber$1.signature = n1$1$1;
function secNumber$1(t4) {
  return 1 / Math.cos(t4);
}
secNumber$1.signature = n1$1$1;
function sechNumber$1(t4) {
  return 2 / (Math.exp(t4) + Math.exp(-t4));
}
sechNumber$1.signature = n1$1$1;
function sinhNumber$1(t4) {
  return sinh$3$1(t4);
}
sinhNumber$1.signature = n1$1$1;
var n1$5 = `number`;
function isNegativeNumber$1(t4) {
  return t4 < 0;
}
isNegativeNumber$1.signature = n1$5;
function isPositiveNumber$1(t4) {
  return t4 > 0;
}
isPositiveNumber$1.signature = n1$5;
function isNaNNumber$1(t4) {
  return Number.isNaN(t4);
}
isNaNNumber$1.signature = n1$5;
function nearlyEqual$2(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return t4.isNaN() || n2.isNaN() ? false : !t4.isFinite() || !n2.isFinite() ? t4.eq(n2) : t4.eq(n2) ? true : t4.minus(n2).abs().lte(t4.constructor.max(t4.constructor.max(t4.abs(), n2.abs()).mul(r2), i2));
}
var name$312$1 = `isNegative`, dependencies$312$1 = [`typed`, `config`], createIsNegative$1 = factory$1(name$312$1, dependencies$312$1, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$312$1, { number: (t5) => nearlyEqual$1$1(t5, 0, r2.relTol, r2.absTol) ? false : isNegativeNumber$1(t5), BigNumber: (t5) => nearlyEqual$2(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 < 0n, Fraction: (t5) => t5.s < 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$311$1 = `isNumeric`, dependencies$311$1 = [`typed`], createIsNumeric$1 = factory$1(name$311$1, dependencies$311$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$311$1, { "number | BigNumber | bigint | Fraction | boolean": () => true, "Complex | Unit | string | null | undefined | Node": () => false, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$310$1 = `hasNumericValue`, dependencies$310$1 = [`typed`, `isNumeric`], createHasNumericValue$1 = factory$1(name$310$1, dependencies$310$1, (t4) => {
  var { typed: n2, isNumeric: r2 } = t4;
  return n2(name$310$1, { boolean: () => true, string: function(t5) {
    return t5.trim().length > 0 && !isNaN(Number(t5));
  }, any: function(t5) {
    return r2(t5);
  } });
}), name$309$1 = `isPositive`, dependencies$309$1 = [`typed`, `config`], createIsPositive$1 = factory$1(name$309$1, dependencies$309$1, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$309$1, { number: (t5) => nearlyEqual$1$1(t5, 0, r2.relTol, r2.absTol) ? false : isPositiveNumber$1(t5), BigNumber: (t5) => nearlyEqual$2(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : !t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 > 0n, Fraction: (t5) => t5.s > 0n && t5.n > 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$308$1 = `isZero`, dependencies$308$1 = [`typed`, `equalScalar`], createIsZero$1 = factory$1(name$308$1, dependencies$308$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$308$1, { "number | BigNumber | Complex | Fraction": (t5) => r2(t5, 0), bigint: (t5) => t5 === 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$307$1 = `isNaN`, dependencies$307$1 = [`typed`], createIsNaN$1 = factory$1(name$307$1, dependencies$307$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$307$1, { number: isNaNNumber$1, BigNumber: function(t5) {
    return t5.isNaN();
  }, bigint: function(t5) {
    return false;
  }, Fraction: function(t5) {
    return false;
  }, Complex: function(t5) {
    return t5.isNaN();
  }, Unit: function(t5) {
    return Number.isNaN(t5.value);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$306$1 = `isBounded`, dependencies$306$1 = [`typed`], createIsBounded$1 = factory$1(name$306$1, dependencies$306$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$306$1, { number: (t5) => Number.isFinite(t5), "BigNumber | Complex": (t5) => t5.isFinite(), "bigint | Fraction": () => true, "null | undefined": () => false, Unit: n2.referToSelf((t5) => (n3) => t5(n3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => (Array.isArray(n3) || (n3 = n3.valueOf()), n3.every((n4) => t5(n4)))) });
}), name$305$1 = `isFinite`, dependencies$305$1 = [`typed`, `isBounded`, `map`], createIsFinite$1 = factory$1(name$305$1, dependencies$305$1, (t4) => {
  var { typed: n2, isBounded: r2, map: i2 } = t4;
  return n2(name$305$1, { "Array | Matrix": (t5) => i2(t5, r2), any: (t5) => r2(t5) });
}), name$304$1 = `typeOf`, dependencies$304$1 = [`typed`], createTypeOf$1 = factory$1(name$304$1, dependencies$304$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$304$1, { any: typeOf$1 });
});
function complexEquals$1(t4, n2, r2, i2) {
  return nearlyEqual$1$1(t4.re, n2.re, r2, i2) && nearlyEqual$1$1(t4.im, n2.im, r2, i2);
}
var createCompareUnits$1 = factory$1(`compareUnits`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (!r2.equalBase(i2)) throw Error(`Cannot compare units with different base`);
    return n2.find(t5, [r2.valueType(), i2.valueType()])(r2.value, i2.value);
  }) };
}), name$303$1 = `equalScalar`, dependencies$303$1 = [`typed`, `config`], createEqualScalar$1 = factory$1(name$303$1, dependencies$303$1, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303$1, { "boolean, boolean": function(t5, n3) {
    return t5 === n3;
  }, "number, number": function(t5, n3) {
    return nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.eq(n3) || nearlyEqual$2(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.equals(n3);
  }, "Complex, Complex": function(t5, n3) {
    return complexEquals$1(t5, n3, r2.relTol, r2.absTol);
  } }, createCompareUnits$1({ typed: n2 }));
});
factory$1(name$303$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303$1, { "number, number": function(t5, n3) {
    return nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  } });
});
var name$302$1 = `SparseMatrix`, dependencies$302$1 = [`typed`, `equalScalar`, `Matrix`], createSparseMatrixClass$1 = factory$1(name$302$1, dependencies$302$1, (t4) => {
  var { typed: n2, equalScalar: r2, Matrix: i2 } = t4;
  function a2(t5, n3) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$1(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$1(t5)) o2(this, t5, n3);
    else if (t5 && isArray$1(t5.index) && isArray$1(t5.ptr) && isArray$1(t5.size)) this._values = t5.values, this._index = t5.index, this._ptr = t5.ptr, this._size = t5.size, this._datatype = n3 || t5.datatype;
    else if (isArray$1(t5)) s2(this, t5, n3);
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$1(t5) + `)`);
    else this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = n3;
  }
  function o2(t5, n3, r3) {
    n3.type === `SparseMatrix` ? (t5._values = n3._values ? clone$3$1(n3._values) : void 0, t5._index = clone$3$1(n3._index), t5._ptr = clone$3$1(n3._ptr), t5._size = clone$3$1(n3._size), t5._datatype = r3 || n3._datatype) : s2(t5, n3.valueOf(), r3 || n3._datatype);
  }
  function s2(t5, i3, a3) {
    t5._values = [], t5._index = [], t5._ptr = [], t5._datatype = a3;
    var o3 = i3.length, s3 = 0, c3 = r2, l3 = 0;
    if (isString$1(a3) && (c3 = n2.find(r2, [a3, a3]) || r2, l3 = n2.convert(0, a3)), o3 > 0) {
      var u3 = 0;
      do {
        t5._ptr.push(t5._index.length);
        for (var d3 = 0; d3 < o3; d3++) {
          var p3 = i3[d3];
          if (isArray$1(p3)) {
            if (u3 === 0 && s3 < p3.length && (s3 = p3.length), u3 < p3.length) {
              var m3 = p3[u3];
              c3(m3, l3) || (t5._values.push(m3), t5._index.push(d3));
            }
          } else u3 === 0 && s3 < 1 && (s3 = 1), c3(p3, l3) || (t5._values.push(p3), t5._index.push(d3));
        }
        u3++;
      } while (u3 < s3);
    }
    for (; t5._ptr.length <= s3; ) t5._ptr.push(t5._index.length);
    t5._size = [o3, s3];
  }
  a2.prototype = new i2(), a2.prototype.createSparseMatrix = function(t5, n3) {
    return new a2(t5, n3);
  }, Object.defineProperty(a2, "name", { value: `SparseMatrix` }), a2.prototype.constructor = a2, a2.prototype.type = `SparseMatrix`, a2.prototype.isSparseMatrix = true, a2.prototype.getDataType = function() {
    return getArrayDataType$1(this._values, typeOf$1);
  }, a2.prototype.storage = function() {
    return `sparse`;
  }, a2.prototype.datatype = function() {
    return this._datatype;
  }, a2.prototype.create = function(t5, n3) {
    return new a2(t5, n3);
  }, a2.prototype.density = function() {
    var t5 = this._size[0], n3 = this._size[1];
    return t5 !== 0 && n3 !== 0 ? this._index.length / (t5 * n3) : 0;
  }, a2.prototype.subset = function(t5, n3, r3) {
    if (!this._values) throw Error(`Cannot invoke subset on a Pattern only matrix`);
    switch (arguments.length) {
      case 1:
        return c2(this, t5);
      case 2:
      case 3:
        return l2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  };
  function c2(t5, n3) {
    if (!isIndex$1(n3)) throw TypeError(`Invalid index`);
    if (n3.isScalar()) return t5.get(n3.min());
    var r3 = n3.size();
    if (r3.length !== t5._size.length) throw new DimensionError$1(r3.length, t5._size.length);
    var i3, o3, s3, c3, l3 = n3.min(), u3 = n3.max();
    for (i3 = 0, o3 = t5._size.length; i3 < o3; i3++) validateIndex$1(l3[i3], t5._size[i3]), validateIndex$1(u3[i3], t5._size[i3]);
    var d3 = t5._values, p3 = t5._index, m3 = t5._ptr, h3 = n3.dimension(0), g3 = n3.dimension(1), v2 = [], y2 = [];
    function b2(t6, n4) {
      y2[t6] = n4[0], v2[t6] = true;
    }
    Number.isInteger(h3) ? b2(h3, [0]) : h3.forEach(b2);
    var x2 = d3 ? [] : void 0, S2 = [], w2 = [];
    function E(t6) {
      for (w2.push(S2.length), s3 = m3[t6], c3 = m3[t6 + 1]; s3 < c3; s3++) i3 = p3[s3], v2[i3] === true && (S2.push(y2[i3]), x2 && x2.push(d3[s3]));
    }
    return Number.isInteger(g3) ? E(g3) : g3.forEach(E), w2.push(S2.length), new a2({ values: x2, index: S2, ptr: w2, size: r3, datatype: t5._datatype });
  }
  function l2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix$1(r3) ? (s3 = r3.size(), r3 = r3.toArray()) : s3 = arraySize$1(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (a3.length !== 1 && a3.length !== 2) throw new DimensionError$1(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var c3 = 0, l3 = 0; a3[c3] === 1 && s3[c3] === 1; ) c3++;
        for (; a3[c3] === 1; ) l3++, c3++;
        r3 = unsqueeze$1(r3, a3.length, l3, s3);
      }
      if (!deepStrictEqual$1(a3, s3)) throw new DimensionError$1(a3, s3, `>`);
      if (a3.length === 1) p3(n3.dimension(0), (n4, a4) => {
        validateIndex$1(n4), t5.set([n4, 0], r3[a4[0]], i3);
      });
      else {
        var u3 = n3.dimension(0), d3 = n3.dimension(1);
        p3(u3, (n4, a4) => {
          validateIndex$1(n4), p3(d3, (o4, s4) => {
            validateIndex$1(o4), t5.set([n4, o4], r3[a4[0]][s4[0]], i3);
          });
        });
      }
    }
    return t5;
    function p3(t6, n4) {
      isNumber$1(t6) ? n4(t6, [0]) : t6.forEach(n4);
    }
  }
  a2.prototype.get = function(t5) {
    if (!isArray$1(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError$1(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke get on a Pattern only matrix`);
    var n3 = t5[0], r3 = t5[1];
    validateIndex$1(n3, this._size[0]), validateIndex$1(r3, this._size[1]);
    var i3 = u2(n3, this._ptr[r3], this._ptr[r3 + 1], this._index);
    return i3 < this._ptr[r3 + 1] && this._index[i3] === n3 ? this._values[i3] : 0;
  }, a2.prototype.set = function(t5, i3, a3) {
    if (!isArray$1(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError$1(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke set on a Pattern only matrix`);
    var o3 = t5[0], s3 = t5[1], c3 = this._size[0], l3 = this._size[1], h3 = r2, g3 = 0;
    isString$1(this._datatype) && (h3 = n2.find(r2, [this._datatype, this._datatype]) || r2, g3 = n2.convert(0, this._datatype)), (o3 > c3 - 1 || s3 > l3 - 1) && (m2(this, Math.max(o3 + 1, c3), Math.max(s3 + 1, l3), a3), c3 = this._size[0], l3 = this._size[1]), validateIndex$1(o3, c3), validateIndex$1(s3, l3);
    var v2 = u2(o3, this._ptr[s3], this._ptr[s3 + 1], this._index);
    return v2 < this._ptr[s3 + 1] && this._index[v2] === o3 ? h3(i3, g3) ? d2(v2, s3, this._values, this._index, this._ptr) : this._values[v2] = i3 : h3(i3, g3) || p2(v2, o3, s3, i3, this._values, this._index, this._ptr), this;
  };
  function u2(t5, n3, r3, i3) {
    if (r3 - n3 === 0) return r3;
    for (var a3 = n3; a3 < r3; a3++) if (i3[a3] === t5) return a3;
    return n3;
  }
  function d2(t5, n3, r3, i3, a3) {
    r3.splice(t5, 1), i3.splice(t5, 1);
    for (var o3 = n3 + 1; o3 < a3.length; o3++) a3[o3]--;
  }
  function p2(t5, n3, r3, i3, a3, o3, s3) {
    a3.splice(t5, 0, i3), o3.splice(t5, 0, n3);
    for (var c3 = r3 + 1; c3 < s3.length; c3++) s3[c3]++;
  }
  a2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection$1(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    if (i3.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    return i3.forEach(function(t6) {
      if (!isNumber$1(t6) || !isInteger$2(t6) || t6 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$3(i3) + `)`);
    }), m2(r3 ? this.clone() : this, i3[0], i3[1], n3);
  };
  function m2(t5, i3, a3, o3) {
    var s3 = o3 || 0, c3 = r2, l3 = 0;
    isString$1(t5._datatype) && (c3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, l3 = n2.convert(0, t5._datatype), s3 = n2.convert(s3, t5._datatype));
    var u3 = !c3(s3, l3), d3 = t5._size[0], p3 = t5._size[1], m3, h3, g3;
    if (a3 > p3) {
      for (h3 = p3; h3 < a3; h3++) if (t5._ptr[h3] = t5._values.length, u3) for (m3 = 0; m3 < d3; m3++) t5._values.push(s3), t5._index.push(m3);
      t5._ptr[a3] = t5._values.length;
    } else a3 < p3 && (t5._ptr.splice(a3 + 1, p3 - a3), t5._values.splice(t5._ptr[a3], t5._values.length), t5._index.splice(t5._ptr[a3], t5._index.length));
    if (p3 = a3, i3 > d3) {
      if (u3) {
        var v2 = 0;
        for (h3 = 0; h3 < p3; h3++) {
          t5._ptr[h3] = t5._ptr[h3] + v2, g3 = t5._ptr[h3 + 1] + v2;
          var y2 = 0;
          for (m3 = d3; m3 < i3; m3++, y2++) t5._values.splice(g3 + y2, 0, s3), t5._index.splice(g3 + y2, 0, m3), v2++;
        }
        t5._ptr[p3] = t5._values.length;
      }
    } else if (i3 < d3) {
      var b2 = 0;
      for (h3 = 0; h3 < p3; h3++) {
        t5._ptr[h3] = t5._ptr[h3] - b2;
        var x2 = t5._ptr[h3], S2 = t5._ptr[h3 + 1] - b2;
        for (g3 = x2; g3 < S2; g3++) m3 = t5._index[g3], m3 > i3 - 1 && (t5._values.splice(g3, 1), t5._index.splice(g3, 1), b2++);
      }
      t5._ptr[h3] = t5._values.length;
    }
    return t5._size[0] = i3, t5._size[1] = a3, t5;
  }
  a2.prototype.reshape = function(t5, n3) {
    if (!isArray$1(t5)) throw TypeError(`Array expected`);
    if (t5.length !== 2) throw Error(`Sparse matrices can only be reshaped in two dimensions`);
    t5.forEach(function(n4) {
      if (!isNumber$1(n4) || !isInteger$2(n4) || n4 <= -2 || n4 === 0) throw TypeError(`Invalid size, must contain positive integers or -1 (size: ` + format$3(t5) + `)`);
    });
    var r3 = this._size[0] * this._size[1];
    if (t5 = processSizesWildcard$1(t5, r3), r3 !== t5[0] * t5[1]) throw Error(`Reshaping sparse matrix will result in the wrong number of elements`);
    var i3 = n3 ? this.clone() : this;
    if (this._size[0] === t5[0] && this._size[1] === t5[1]) return i3;
    for (var a3 = [], o3 = 0; o3 < i3._ptr.length; o3++) for (var s3 = 0; s3 < i3._ptr[o3 + 1] - i3._ptr[o3]; s3++) a3.push(o3);
    for (var c3 = i3._values.slice(), l3 = i3._index.slice(), d3 = 0; d3 < i3._index.length; d3++) {
      var m3 = l3[d3], h3 = a3[d3], g3 = m3 * i3._size[1] + h3;
      a3[d3] = g3 % t5[1], l3[d3] = Math.floor(g3 / t5[1]);
    }
    i3._values.length = 0, i3._index.length = 0, i3._ptr.length = t5[1] + 1, i3._size = t5.slice();
    for (var v2 = 0; v2 < i3._ptr.length; v2++) i3._ptr[v2] = 0;
    for (var y2 = 0; y2 < c3.length; y2++) {
      var b2 = l3[y2], x2 = a3[y2], S2 = c3[y2];
      p2(u2(b2, i3._ptr[x2], i3._ptr[x2 + 1], i3._index), b2, x2, S2, i3._values, i3._index, i3._ptr);
    }
    return i3;
  }, a2.prototype.clone = function() {
    return new a2({ values: this._values ? clone$3$1(this._values) : void 0, index: clone$3$1(this._index), ptr: clone$3$1(this._ptr), size: clone$3$1(this._size), datatype: this._datatype });
  }, a2.prototype.size = function() {
    return this._size.slice(0);
  }, a2.prototype.map = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke map on a Pattern only matrix`);
    var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback$1(t5, r3, `map`);
    return h2(this, 0, i3 - 1, 0, a3 - 1, function(t6, n4, i4) {
      return o3.fn(t6, [n4, i4], r3);
    }, n3);
  };
  function h2(t5, i3, o3, s3, c3, l3, u3) {
    var d3 = [], p3 = [], m3 = [], h3 = r2, g3 = 0;
    isString$1(t5._datatype) && (h3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, g3 = n2.convert(0, t5._datatype));
    for (var v2 = function(t6, n3, r3) {
      var i4 = l3(t6, n3, r3);
      h3(i4, g3) || (d3.push(i4), p3.push(n3));
    }, y2 = s3; y2 <= c3; y2++) {
      m3.push(d3.length);
      var b2 = t5._ptr[y2], x2 = t5._ptr[y2 + 1];
      if (u3) for (var S2 = b2; S2 < x2; S2++) {
        var w2 = t5._index[S2];
        w2 >= i3 && w2 <= o3 && v2(t5._values[S2], w2 - i3, y2 - s3);
      }
      else {
        for (var E = {}, D = b2; D < x2; D++) {
          var O2 = t5._index[D];
          E[O2] = t5._values[D];
        }
        for (var j2 = i3; j2 <= o3; j2++) v2(j2 in E ? E[j2] : 0, j2 - i3, y2 - s3);
      }
    }
    return m3.push(d3.length), new a2({ values: d3, index: p3, ptr: m3, size: [o3 - i3 + 1, c3 - s3 + 1] });
  }
  a2.prototype.forEach = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke forEach on a Pattern only matrix`);
    for (var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback$1(t5, r3, `forEach`), s3 = 0; s3 < a3; s3++) {
      var c3 = this._ptr[s3], l3 = this._ptr[s3 + 1];
      if (n3) for (var u3 = c3; u3 < l3; u3++) {
        var d3 = this._index[u3];
        o3.fn(this._values[u3], [d3, s3], r3);
      }
      else {
        for (var p3 = {}, m3 = c3; m3 < l3; m3++) {
          var h3 = this._index[m3];
          p3[h3] = this._values[m3];
        }
        for (var g3 = 0; g3 < i3; g3++) {
          var v2 = g3 in p3 ? p3[g3] : 0;
          o3.fn(v2, [g3, s3], r3);
        }
      }
    }
  }, a2.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw Error(`Cannot iterate a Pattern only matrix`);
    for (var t5 = this._size[1], n3 = 0; n3 < t5; n3++) for (var r3 = this._ptr[n3], i3 = this._ptr[n3 + 1], a3 = r3; a3 < i3; a3++) {
      var o3 = this._index[a3];
      yield { value: this._values[a3], index: [o3, n3] };
    }
  }, a2.prototype.toArray = function() {
    return g2(this._values, this._index, this._ptr, this._size, true);
  }, a2.prototype.valueOf = function() {
    return g2(this._values, this._index, this._ptr, this._size, false);
  };
  function g2(t5, n3, r3, i3, a3) {
    var o3 = i3[0], s3 = i3[1], c3 = [], l3, u3;
    for (l3 = 0; l3 < o3; l3++) for (c3[l3] = [], u3 = 0; u3 < s3; u3++) c3[l3][u3] = 0;
    for (u3 = 0; u3 < s3; u3++) for (var d3 = r3[u3], p3 = r3[u3 + 1], m3 = d3; m3 < p3; m3++) l3 = n3[m3], c3[l3][u3] = t5 ? a3 ? clone$3$1(t5[m3]) : t5[m3] : 1;
    return c3;
  }
  return a2.prototype.format = function(t5) {
    for (var n3 = this._size[0], r3 = this._size[1], i3 = this.density(), a3 = `Sparse Matrix [` + format$3(n3, t5) + ` x ` + format$3(r3, t5) + `] density: ` + format$3(i3, t5) + `
`, o3 = 0; o3 < r3; o3++) for (var s3 = this._ptr[o3], c3 = this._ptr[o3 + 1], l3 = s3; l3 < c3; l3++) {
      var u3 = this._index[l3];
      a3 += `
    (` + format$3(u3, t5) + `, ` + format$3(o3, t5) + `) ==> ` + (this._values ? format$3(this._values[l3], t5) : `X`);
    }
    return a3;
  }, a2.prototype.toString = function() {
    return format$3(this.toArray());
  }, a2.prototype.toJSON = function() {
    return { mathjs: `SparseMatrix`, values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, a2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber$1(t5) && (t5 = t5.toNumber()), !isNumber$1(t5) || !isInteger$2(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, i3 = this._size[0], o3 = this._size[1], s3 = Math.min(i3 - r3, o3 - n3), c3 = [], l3 = [], u3 = [];
    u3[0] = 0;
    for (var d3 = n3; d3 < o3 && c3.length < s3; d3++) for (var p3 = this._ptr[d3], m3 = this._ptr[d3 + 1], h3 = p3; h3 < m3; h3++) {
      var g3 = this._index[h3];
      if (g3 === d3 - n3 + r3) {
        c3.push(this._values[h3]), l3[c3.length - 1] = g3 - r3;
        break;
      }
    }
    return u3.push(c3.length), new a2({ values: c3, index: l3, ptr: u3, size: [s3, 1] });
  }, a2.fromJSON = function(t5) {
    return new a2(t5);
  }, a2.diagonal = function(t5, i3, o3, s3, c3) {
    if (!isArray$1(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber$1(t6) && (t6 = t6.toNumber()), !isNumber$1(t6) || !isInteger$2(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), o3) {
      if (isBigNumber$1(o3) && (o3 = o3.toNumber()), !isNumber$1(o3) || !isInteger$2(o3)) throw TypeError(`The parameter k must be an integer number`);
    } else o3 = 0;
    var l3 = r2, u3 = 0;
    isString$1(c3) && (l3 = n2.find(r2, [c3, c3]) || r2, u3 = n2.convert(0, c3));
    var d3 = o3 > 0 ? o3 : 0, p3 = o3 < 0 ? -o3 : 0, m3 = t5[0], h3 = t5[1], g3 = Math.min(m3 - p3, h3 - d3), v2;
    if (isArray$1(i3)) {
      if (i3.length !== g3) throw Error(`Invalid value array length`);
      v2 = function(t6) {
        return i3[t6];
      };
    } else if (isMatrix$1(i3)) {
      var y2 = i3.size();
      if (y2.length !== 1 || y2[0] !== g3) throw Error(`Invalid matrix length`);
      v2 = function(t6) {
        return i3.get([t6]);
      };
    } else v2 = function() {
      return i3;
    };
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < h3; w2++) {
      S2.push(b2.length);
      var E = w2 - d3;
      if (E >= 0 && E < g3) {
        var D = v2(E);
        l3(D, u3) || (x2.push(E + p3), b2.push(D));
      }
    }
    return S2.push(b2.length), new a2({ values: b2, index: x2, ptr: S2, size: [m3, h3] });
  }, a2.prototype.swapRows = function(t5, n3) {
    if (!isNumber$1(t5) || !isInteger$2(t5) || !isNumber$1(n3) || !isInteger$2(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex$1(t5, this._size[0]), validateIndex$1(n3, this._size[0]), a2._swapRows(t5, n3, this._size[1], this._values, this._index, this._ptr), this;
  }, a2._forEachRow = function(t5, n3, r3, i3, a3) {
    for (var o3 = i3[t5], s3 = i3[t5 + 1], c3 = o3; c3 < s3; c3++) a3(r3[c3], n3[c3]);
  }, a2._swapRows = function(t5, n3, r3, i3, a3, o3) {
    for (var s3 = 0; s3 < r3; s3++) {
      var c3 = o3[s3], l3 = o3[s3 + 1], d3 = u2(t5, c3, l3, a3), p3 = u2(n3, c3, l3, a3);
      if (d3 < l3 && p3 < l3 && a3[d3] === t5 && a3[p3] === n3) {
        if (i3) {
          var m3 = i3[d3];
          i3[d3] = i3[p3], i3[p3] = m3;
        }
        continue;
      }
      if (d3 < l3 && a3[d3] === t5 && (p3 >= l3 || a3[p3] !== n3)) {
        var h3 = i3 ? i3[d3] : void 0;
        a3.splice(p3, 0, n3), i3 && i3.splice(p3, 0, h3), a3.splice(p3 <= d3 ? d3 + 1 : d3, 1), i3 && i3.splice(p3 <= d3 ? d3 + 1 : d3, 1);
        continue;
      }
      if (p3 < l3 && a3[p3] === n3 && (d3 >= l3 || a3[d3] !== t5)) {
        var g3 = i3 ? i3[p3] : void 0;
        a3.splice(d3, 0, t5), i3 && i3.splice(d3, 0, g3), a3.splice(d3 <= p3 ? p3 + 1 : p3, 1), i3 && i3.splice(d3 <= p3 ? p3 + 1 : p3, 1);
      }
    }
  }, a2;
}, { isClass: true }), name$301$1 = `number`, dependencies$301$1 = [`typed`];
function getNonDecimalNumberParts$1(t4) {
  var n2 = t4.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return n2 ? { input: t4, radix: { "0b": 2, "0o": 8, "0x": 16 }[n2[1]], integerPart: n2[2], fractionalPart: n2[3] } : null;
}
function makeNumberFromNonDecimalParts$1(t4) {
  for (var n2 = parseInt(t4.integerPart, t4.radix), r2 = 0, i2 = 0; i2 < t4.fractionalPart.length; i2++) {
    var a2 = parseInt(t4.fractionalPart[i2], t4.radix);
    r2 += a2 / t4.radix ** +(i2 + 1);
  }
  var o2 = n2 + r2;
  if (isNaN(o2)) throw SyntaxError(`String "` + t4.input + `" is not a valid number`);
  return o2;
}
var createNumber$1 = factory$1(name$301$1, dependencies$301$1, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`number`, { "": function() {
    return 0;
  }, number: function(t5) {
    return t5;
  }, string: function(t5) {
    if (t5 === `NaN`) return NaN;
    var n3 = getNonDecimalNumberParts$1(t5);
    if (n3) return makeNumberFromNonDecimalParts$1(n3);
    var r3 = 0, i2 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    i2 && (r3 = Number(i2[2]), t5 = i2[1]);
    var a2 = Number(t5);
    if (isNaN(a2)) throw SyntaxError(`String "` + t5 + `" is not a valid number`);
    if (i2) {
      if (a2 > 2 ** r3 - 1) throw SyntaxError(`String "${t5}" is out of range`);
      a2 >= 2 ** (r3 - 1) && (a2 -= 2 ** r3);
    }
    return a2;
  }, BigNumber: function(t5) {
    return t5.toNumber();
  }, bigint: function(t5) {
    return Number(t5);
  }, Fraction: function(t5) {
    return t5.valueOf();
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), null: function(t5) {
    return 0;
  }, "Unit, string | Unit": function(t5, n3) {
    return t5.toNumber(n3);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return parseFloat(t5.value);
  }, r2;
}), name$300$1 = `bigint`, dependencies$300$1 = [`typed`], createBigint$1 = factory$1(name$300$1, dependencies$300$1, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`bigint`, { "": function() {
    return 0n;
  }, bigint: function(t5) {
    return t5;
  }, number: function(t5) {
    return BigInt(t5.toFixed());
  }, BigNumber: function(t5) {
    return BigInt(t5.round().toString());
  }, Fraction: function(t5) {
    return BigInt(t5.valueOf().toFixed());
  }, "string | boolean": function(t5) {
    return BigInt(t5);
  }, null: function(t5) {
    return 0n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return BigInt(t5.value);
  }, r2;
}), name$299$1 = `string`, dependencies$299$1 = [`typed`], createString$1 = factory$1(name$299$1, dependencies$299$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$299$1, { "": function() {
    return ``;
  }, number: format$2$1, null: function(t5) {
    return `null`;
  }, boolean: function(t5) {
    return t5 + ``;
  }, string: function(t5) {
    return t5;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)), any: function(t5) {
    return String(t5);
  } });
}), name$298$1 = `boolean`, dependencies$298$1 = [`typed`], createBoolean$1 = factory$1(name$298$1, dependencies$298$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$298$1, { "": function() {
    return false;
  }, boolean: function(t5) {
    return t5;
  }, number: function(t5) {
    return !!t5;
  }, null: function(t5) {
    return false;
  }, BigNumber: function(t5) {
    return !t5.isZero();
  }, string: function(t5) {
    var n3 = t5.toLowerCase();
    if (n3 === `true`) return true;
    if (n3 === `false`) return false;
    var r2 = Number(t5);
    if (t5 !== `` && !isNaN(r2)) return !!r2;
    throw Error(`Cannot convert "` + t5 + `" to a boolean`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$297$1 = `bignumber`, dependencies$297$1 = [`typed`, `BigNumber`], createBignumber$1 = factory$1(name$297$1, dependencies$297$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(`bignumber`, { "": function() {
    return new r2(0);
  }, number: function(t5) {
    return new r2(t5 + ``);
  }, string: function(t5) {
    var n3 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (n3) {
      var i2 = n3[2], a2 = r2(n3[1]), o2 = new r2(2).pow(Number(i2));
      if (a2.gt(o2.sub(1))) throw SyntaxError(`String "${t5}" is out of range`);
      var s2 = new r2(2).pow(Number(i2) - 1);
      return a2.gte(s2) ? a2.sub(o2) : a2;
    }
    return new r2(t5);
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Fraction: function(t5) {
    return new r2(String(t5.n)).div(String(t5.d)).times(String(t5.s));
  }, null: function(t5) {
    return new r2(0);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$296$1 = `complex`, dependencies$296$1 = [`typed`, `Complex`], createComplex$1 = factory$1(name$296$1, dependencies$296$1, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(`complex`, { "": function() {
    return r2.ZERO;
  }, number: function(t5) {
    return new r2(t5, 0);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return new r2(t5.toNumber(), n3.toNumber());
  }, Fraction: function(t5) {
    return new r2(t5.valueOf(), 0);
  }, Complex: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2(t5);
  }, null: function(t5) {
    return r2(0);
  }, Object: function(t5) {
    if (`re` in t5 && `im` in t5) return new r2(t5.re, t5.im);
    if (`r` in t5 && `phi` in t5 || `abs` in t5 && `arg` in t5) return new r2(t5);
    throw Error(`Expected object with properties (re and im) or (r and phi) or (abs and arg)`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$295$1 = `fraction`, dependencies$295$1 = [`typed`, `Fraction`], createFraction$1 = factory$1(name$295$1, dependencies$295$1, (t4) => {
  var { typed: n2, Fraction: r2 } = t4;
  return n2(`fraction`, { number: function(t5) {
    if (!Number.isFinite(t5) || isNaN(t5)) throw Error(t5 + ` cannot be represented as a fraction`);
    return new r2(t5);
  }, string: function(t5) {
    return new r2(t5);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "bigint, bigint": function(t5, n3) {
    return new r2(t5, n3);
  }, null: function(t5) {
    return new r2(0);
  }, BigNumber: function(t5) {
    return new r2(t5.toString());
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Fraction: function(t5) {
    return t5;
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Object: function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$294$1 = `matrix`, dependencies$294$1 = [`typed`, `Matrix`, `DenseMatrix`, `SparseMatrix`], createMatrix$1 = factory$1(name$294$1, dependencies$294$1, (t4) => {
  var { typed: n2, Matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$294$1, { "": function() {
    return o2([]);
  }, string: function(t5) {
    return o2([], t5);
  }, "string, string": function(t5, n3) {
    return o2([], t5, n3);
  }, Array: function(t5) {
    return o2(t5);
  }, Matrix: function(t5) {
    return o2(t5, t5.storage());
  }, "Array | Matrix, string": o2, "Array | Matrix, string, string": o2 });
  function o2(t5, n3, r3) {
    if (n3 === `dense` || n3 === "default" || n3 === void 0) return new i2(t5, r3);
    if (n3 === `sparse`) return new a2(t5, r3);
    throw TypeError(`Unknown matrix type ` + JSON.stringify(n3) + `.`);
  }
}), name$293$1 = `matrixFromFunction`, dependencies$293$1 = [`typed`, `matrix`, `isZero`], createMatrixFromFunction$1 = factory$1(name$293$1, dependencies$293$1, (t4) => {
  var { typed: n2, matrix: r2, isZero: i2 } = t4;
  return n2(name$293$1, { "Array | Matrix, function, string, string": function(t5, n3, r3, i3) {
    return a2(t5, n3, r3, i3);
  }, "Array | Matrix, function, string": function(t5, n3, r3) {
    return a2(t5, n3, r3);
  }, "Matrix, function": function(t5, n3) {
    return a2(t5, n3, `dense`);
  }, "Array, function": function(t5, n3) {
    return a2(t5, n3, `dense`).toArray();
  }, "Array | Matrix, string, function": function(t5, n3, r3) {
    return a2(t5, r3, n3);
  }, "Array | Matrix, string, string, function": function(t5, n3, r3, i3) {
    return a2(t5, i3, n3, r3);
  } });
  function a2(t5, n3, a3, o2) {
    var s2 = o2 === void 0 ? r2(a3) : r2(a3, o2);
    return s2.resize(t5), s2.forEach(function(t6, r3) {
      var a4 = n3(r3);
      i2(a4) || s2.set(r3, a4);
    }), s2;
  }
}), name$292$1 = `matrixFromRows`, dependencies$292$1 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromRows$1 = factory$1(name$292$1, dependencies$292$1, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$292$1, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one row is needed to construct a matrix.`);
    var n3 = s2(t5[0]), r3 = [];
    for (var a3 of t5) {
      var o3 = s2(a3);
      if (o3 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (o3 | 0));
      r3.push(i2(a3));
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$291$1 = `matrixFromColumns`, dependencies$291$1 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromColumns$1 = factory$1(name$291$1, dependencies$291$1, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$291$1, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one column is needed to construct a matrix.`);
    for (var n3 = s2(t5[0]), r3 = [], a3 = 0; a3 < n3; a3++) r3[a3] = [];
    for (var o3 of t5) {
      var c2 = s2(o3);
      if (c2 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (c2 | 0));
      for (var l2 = i2(o3), u2 = 0; u2 < n3; u2++) r3[u2].push(l2[u2]);
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$290$1 = `splitUnit`, dependencies$290$1 = [`typed`], createSplitUnit$1 = factory$1(name$290$1, dependencies$290$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$290$1, { "Unit, Array": function(t5, n3) {
    return t5.splitUnit(n3);
  } });
}), name$289$1 = `unaryMinus`, dependencies$289$1 = [`typed`], createUnaryMinus$1 = factory$1(name$289$1, dependencies$289$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$289$1, { number: unaryMinusNumber$1, "Complex | BigNumber | Fraction": (t5) => t5.neg(), bigint: (t5) => -t5, Unit: n2.referToSelf((t5) => (r2) => {
    var i2 = r2.clone();
    return i2.value = n2.find(t5, i2.valueType())(r2.value), i2;
  }), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)) });
}), name$288$1 = `unaryPlus`, dependencies$288$1 = [`typed`, `config`, `numeric`], createUnaryPlus$1 = factory$1(name$288$1, dependencies$288$1, (t4) => {
  var { typed: n2, config: r2, numeric: i2 } = t4;
  return n2(name$288$1, { number: unaryPlusNumber$1, Complex: function(t5) {
    return t5;
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return t5;
  }, Fraction: function(t5) {
    return t5;
  }, Unit: function(t5) {
    return t5.clone();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), boolean: function(t5) {
    return i2(+!!t5, r2.number);
  }, string: function(t5) {
    return i2(t5, safeNumberType$1(t5, r2));
  } });
}), name$287$1 = `abs`, dependencies$287$1 = [`typed`], createAbs$1 = factory$1(name$287$1, dependencies$287$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$287$1, { number: absNumber$1, "Complex | BigNumber | Fraction | Unit": (t5) => t5.abs(), bigint: (t5) => t5 < 0n ? -t5 : t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)) });
}), name$286$1 = `mapSlices`, dependencies$286$1 = [`typed`, `isInteger`], createMapSlices$1 = factory$1(name$286$1, dependencies$286$1, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$286$1, { "Array | Matrix, number | BigNumber, function": function(t5, n3, i2) {
    if (!r2(n3)) throw TypeError(`Integer number expected for dimension`);
    var a2 = Array.isArray(t5) ? arraySize$1(t5) : t5.size();
    if (n3 < 0 || n3 >= a2.length) throw new IndexError$1(n3, a2.length);
    return isMatrix$1(t5) ? t5.create(_mapSlices$1(t5.valueOf(), n3, i2), t5.datatype()) : _mapSlices$1(t5, n3, i2);
  } });
}, { formerly: `apply` });
function _mapSlices$1(t4, n2, r2) {
  var i2, a2, o2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (o2 = _switch$2(t4), a2 = [], i2 = 0; i2 < o2.length; i2++) a2[i2] = _mapSlices$1(o2[i2], n2 - 1, r2);
    return a2;
  } else return r2(t4);
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _mapSlices$1(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function _switch$2(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
var name$285$1 = `addScalar`, dependencies$285$1 = [`typed`], createAddScalar$1 = factory$1(name$285$1, dependencies$285$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$285$1, { "number, number": addNumber$1, "Complex, Complex": function(t5, n3) {
    return t5.add(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.plus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 + n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.add(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$284$1 = `subtractScalar`, dependencies$284$1 = [`typed`], createSubtractScalar$1 = factory$1(name$284$1, dependencies$284$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$284$1, { "number, number": subtractNumber$1, "Complex, Complex": function(t5, n3) {
    return t5.sub(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.minus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 - n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.sub(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$283$1 = `cbrt`, dependencies$283$1 = [`config`, `typed`, `isNegative`, `unaryMinus`, `matrix`, `Complex`, `BigNumber`, `Fraction`], createCbrt$1 = factory$1(name$283$1, dependencies$283$1, (t4) => {
  var { config: n2, typed: r2, isNegative: i2, unaryMinus: a2, matrix: o2, Complex: s2, BigNumber: c2, Fraction: l2 } = t4;
  return r2(name$283$1, { number: cbrtNumber$1, Complex: u2, "Complex, boolean": u2, BigNumber: function(t5) {
    return t5.cbrt();
  }, Unit: d2 });
  function u2(t5, r3) {
    var i3 = t5.arg() / 3, a3 = t5.abs(), c3 = new s2(cbrtNumber$1(a3), 0).mul(new s2(0, i3).exp());
    if (r3) {
      var l3 = [c3, new s2(cbrtNumber$1(a3), 0).mul(new s2(0, i3 + Math.PI * 2 / 3).exp()), new s2(cbrtNumber$1(a3), 0).mul(new s2(0, i3 - Math.PI * 2 / 3).exp())];
      return n2.matrix === `Array` ? l3 : o2(l3);
    } else return c3;
  }
  function d2(t5) {
    if (t5.value && isComplex$1(t5.value)) {
      var n3 = t5.clone();
      return n3.value = 1, n3 = n3.pow(1 / 3), n3.value = u2(t5.value), n3;
    } else {
      var r3 = i2(t5.value);
      r3 && (t5.value = a2(t5.value));
      var o3 = isBigNumber$1(t5.value) ? new c2(1).div(3) : isFraction$1(t5.value) ? new l2(1, 3) : 1 / 3, s3 = t5.pow(o3);
      return r3 && (s3.value = a2(s3.value)), s3;
    }
  }
}), name$282$1 = `matAlgo11xS0s`, dependencies$282$1 = [`typed`, `equalScalar`], createMatAlgo11xS0s$1 = factory$1(name$282$1, dependencies$282$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof d2 == `string` && (h2 = d2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), i2 = n2.convert(i2, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < m2; w2++) {
      S2[w2] = x2.length;
      for (var E = l2[w2], D = l2[w2 + 1], O2 = E; O2 < D; O2++) {
        var j2 = c2[O2], M2 = o2 ? y2(i2, s2[O2]) : y2(s2[O2], i2);
        g2(M2, v2) || (x2.push(j2), b2.push(M2));
      }
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: h2 });
  };
}), name$281$1 = `matAlgo12xSfs`, dependencies$281$1 = [`typed`, `DenseMatrix`], createMatAlgo12xSfs$1 = factory$1(name$281$1, dependencies$281$1, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = o2 ? g2(i2, 0) : g2(0, i2);
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
}), name$280$1 = `matAlgo14xDs`, dependencies$280$1 = [`typed`], createMatAlgo14xDs$1 = factory$1(name$280$1, dependencies$280$1, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype, u2, d2 = a2;
    typeof l2 == `string` && (u2 = l2, i2 = n2.convert(i2, u2), d2 = n2.find(a2, [u2, u2]));
    var p2 = c2.length > 0 ? r2(d2, 0, c2, c2[0], s2, i2, o2) : [];
    return t5.createDenseMatrix({ data: p2, size: clone$3$1(c2), datatype: u2 });
  };
  function r2(t5, n3, i2, a2, o2, s2, c2) {
    var l2 = [];
    if (n3 === i2.length - 1) for (var u2 = 0; u2 < a2; u2++) l2[u2] = c2 ? t5(s2, o2[u2]) : t5(o2[u2], s2);
    else for (var d2 = 0; d2 < a2; d2++) l2[d2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[d2], s2, c2);
    return l2;
  }
}), name$279$1 = `ceil`, dependencies$279$1 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen$1$1 = new Decimal$1(10), createCeilNumber$1 = factory$1(name$279$1, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.ceil(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1$1(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$279$1, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger$2(n3)) throw RangeError(`number of decimals in function ceil must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in ceil number must be in range 0-15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createCeil$1 = factory$1(name$279$1, dependencies$279$1, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$1({ typed: n2 }), p2 = createCeilNumber$1({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual$2(t6, n4, r2.relTol, r2.absTol), a3 = t5.ceil(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`ceil`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.ceil();
  }, "Complex, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen$1$1.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.ceil();
  }, "Fraction, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$2(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$2(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$278$1 = `cube`, dependencies$278$1 = [`typed`], createCube$1 = factory$1(name$278$1, dependencies$278$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$278$1, { number: cubeNumber$1, Complex: function(t5) {
    return t5.mul(t5).mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5).times(t5);
  }, bigint: function(t5) {
    return t5 * t5 * t5;
  }, Fraction: function(t5) {
    return t5.pow(3);
  }, Unit: function(t5) {
    return t5.pow(3);
  } });
}), name$277$1 = `exp`, dependencies$277$1 = [`typed`], createExp$1 = factory$1(name$277$1, dependencies$277$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$277$1, { number: expNumber$1, Complex: function(t5) {
    return t5.exp();
  }, BigNumber: function(t5) {
    return t5.exp();
  } });
}), name$276$1 = `expm1`, dependencies$276$1 = [`typed`, `Complex`], createExpm1$1 = factory$1(name$276$1, dependencies$276$1, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(name$276$1, { number: expm1Number$1, Complex: function(t5) {
    var n3 = Math.exp(t5.re);
    return new r2(n3 * Math.cos(t5.im) - 1, n3 * Math.sin(t5.im));
  }, BigNumber: function(t5) {
    return t5.exp().minus(1);
  } });
}), name$275$1 = `fix`, dependencies$275$1 = [`typed`, `Complex`, `matrix`, `ceil`, `floor`, `equalScalar`, `zeros`, `DenseMatrix`], createFixNumber$1 = factory$1(name$275$1, [`typed`, `ceil`, `floor`], (t4) => {
  var { typed: n2, ceil: r2, floor: i2 } = t4;
  return n2(name$275$1, { number: function(t5) {
    return t5 > 0 ? i2(t5) : r2(t5);
  }, "number, number": function(t5, n3) {
    return t5 > 0 ? i2(t5, n3) : r2(t5, n3);
  } });
}), createFix$1 = factory$1(name$275$1, dependencies$275$1, (t4) => {
  var { typed: n2, Complex: r2, matrix: i2, ceil: a2, floor: o2, equalScalar: s2, zeros: c2, DenseMatrix: l2 } = t4, u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: l2 }), d2 = createMatAlgo14xDs$1({ typed: n2 }), p2 = createFixNumber$1({ typed: n2, ceil: a2, floor: o2 });
  return n2(`fix`, { number: p2.signatures.number, "number, number | BigNumber": p2.signatures[`number,number`], Complex: function(t5) {
    return new r2(t5.re > 0 ? Math.floor(t5.re) : Math.ceil(t5.re), t5.im > 0 ? Math.floor(t5.im) : Math.ceil(t5.im));
  }, "Complex, number": function(t5, n3) {
    return new r2(t5.re > 0 ? o2(t5.re, n3) : a2(t5.re, n3), t5.im > 0 ? o2(t5.im, n3) : a2(t5.im, n3));
  }, "Complex, BigNumber": function(t5, n3) {
    var i3 = n3.toNumber();
    return new r2(t5.re > 0 ? o2(t5.re, i3) : a2(t5.re, i3), t5.im > 0 ? o2(t5.im, i3) : a2(t5.im, i3));
  }, BigNumber: function(t5) {
    return t5.isNegative() ? a2(t5) : o2(t5);
  }, "BigNumber, number | BigNumber": function(t5, n3) {
    return t5.isNegative() ? a2(t5, n3) : o2(t5, n3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.s < 0n ? t5.ceil() : t5.floor();
  }, "Fraction, number | BigNumber": function(t5, n3) {
    return t5.s < 0n ? a2(t5, n3) : o2(t5, n3);
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$2(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), "Array | Matrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$2(n3, (n4) => t5(n4, r3), true)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, 0) ? c2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$274$1 = `floor`, dependencies$274$1 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen$2 = new Decimal$1(10), createFloorNumber$1 = factory$1(name$274$1, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.floor(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1$1(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$274$1, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger$2(n3)) throw RangeError(`number of decimals in function floor must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in floor number must be in range 0 - 15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createFloor$1 = factory$1(name$274$1, dependencies$274$1, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$1({ typed: n2 }), p2 = createFloorNumber$1({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual$2(t6, n4, r2.relTol, r2.absTol), a3 = t5.floor(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`floor`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.floor();
  }, "Complex, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen$2.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.floor();
  }, "Fraction, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$2(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap$2(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$273$1 = `matAlgo02xDS0`, dependencies$273$1 = [`typed`, `equalScalar`], createMatAlgo02xDS0$1 = factory$1(name$273$1, dependencies$273$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype || t5.getDataType(), u2 = i2._values, d2 = i2._index, p2 = i2._ptr, m2 = i2._size, h2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (c2.length !== m2.length) throw new DimensionError$1(c2.length, m2.length);
    if (c2[0] !== m2[0] || c2[1] !== m2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + c2 + `) must match Matrix B (` + m2 + `)`);
    if (!u2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var g2 = c2[0], v2 = c2[1], y2, b2 = r2, x2 = 0, S2 = a2;
    typeof l2 == `string` && l2 === h2 && l2 !== `mixed` && (y2 = l2, b2 = n2.find(r2, [y2, y2]), x2 = n2.convert(0, y2), S2 = n2.find(a2, [y2, y2]));
    for (var w2 = [], E = [], D = [], O2 = 0; O2 < v2; O2++) {
      D[O2] = E.length;
      for (var j2 = p2[O2], M2 = p2[O2 + 1], N2 = j2; N2 < M2; N2++) {
        var F = d2[N2], I2 = o2 ? S2(u2[N2], s2[F][O2]) : S2(s2[F][O2], u2[N2]);
        b2(I2, x2) || (E.push(F), w2.push(I2));
      }
    }
    return D[v2] = E.length, i2.createSparseMatrix({ values: w2, index: E, ptr: D, size: [g2, v2], datatype: l2 === t5._datatype && h2 === i2._datatype ? y2 : void 0 });
  };
}), name$272$1 = `matAlgo03xDSf`, dependencies$272$1 = [`typed`], createMatAlgo03xDSf$1 = factory$1(name$272$1, dependencies$272$1, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError$1(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2, y2 = 0, b2 = i2;
    typeof c2 == `string` && c2 === m2 && c2 !== `mixed` && (v2 = c2, y2 = n2.convert(0, v2), b2 = n2.find(i2, [v2, v2]));
    for (var x2 = [], S2 = 0; S2 < h2; S2++) x2[S2] = [];
    for (var w2 = [], E = [], D = 0; D < g2; D++) {
      for (var O2 = D + 1, j2 = d2[D], M2 = d2[D + 1], N2 = j2; N2 < M2; N2++) {
        var F = u2[N2];
        w2[F] = a2 ? b2(l2[N2], o2[F][D]) : b2(o2[F][D], l2[N2]), E[F] = O2;
      }
      for (var I2 = 0; I2 < h2; I2++) E[I2] === O2 ? x2[I2][D] = w2[I2] : x2[I2][D] = a2 ? b2(y2, o2[I2][D]) : b2(o2[I2][D], y2);
    }
    return t5.createDenseMatrix({ data: x2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$271$1 = `matAlgo05xSfSf`, dependencies$271$1 = [`typed`, `equalScalar`], createMatAlgo05xSfSf$1 = factory$1(name$271$1, dependencies$271$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$1(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = E ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var V2 = L2 + 1;
      for (R2 = c2[L2], z2 = c2[L2 + 1]; R2 < z2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = V2, j2 && (j2[I2] = o2[R2]);
      for (R2 = m2[L2], z2 = m2[L2 + 1]; R2 < z2; R2++) I2 = p2[R2], N2[I2] !== V2 && D.push(I2), F[I2] = V2, M2 && (M2[I2] = d2[R2]);
      if (E) for (R2 = O2[L2]; R2 < D.length; ) {
        I2 = D[R2];
        var H2 = N2[I2], U2 = F[I2];
        if (H2 === V2 || U2 === V2) {
          var W2 = H2 === V2 ? j2[I2] : S2, G2 = U2 === V2 ? M2[I2] : S2, K2 = w2(W2, G2);
          x2(K2, S2) ? D.splice(R2, 1) : (E.push(K2), R2++);
        }
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$270$1 = `matAlgo13xDD`, dependencies$270$1 = [`typed`], createMatAlgo13xDD$1 = factory$1(name$270$1, dependencies$270$1, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype, l2 = i2._data, u2 = i2._size, d2 = i2._datatype, p2 = [];
    if (s2.length !== u2.length) throw new DimensionError$1(s2.length, u2.length);
    for (var m2 = 0; m2 < s2.length; m2++) {
      if (s2[m2] !== u2[m2]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
      p2[m2] = s2[m2];
    }
    var h2, g2 = a2;
    typeof c2 == `string` && c2 === d2 && (h2 = c2, g2 = n2.find(a2, [h2, h2]));
    var v2 = p2.length > 0 ? r2(g2, 0, p2, p2[0], o2, l2) : [];
    return t5.createDenseMatrix({ data: v2, size: p2, datatype: h2 });
  };
  function r2(t5, n3, i2, a2, o2, s2) {
    var c2 = [];
    if (n3 === i2.length - 1) for (var l2 = 0; l2 < a2; l2++) c2[l2] = t5(o2[l2], s2[l2]);
    else for (var u2 = 0; u2 < a2; u2++) c2[u2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[u2], s2[u2]);
    return c2;
  }
});
function broadcast$1(t4, n2) {
  if (deepStrictEqual$1(t4.size(), n2.size())) return [t4, n2];
  var r2 = broadcastSizes$1(t4.size(), n2.size());
  return [t4, n2].map((t5) => _broadcastTo$1(t5, r2));
}
function _broadcastTo$1(t4, n2) {
  return deepStrictEqual$1(t4.size(), n2) ? t4 : t4.create(broadcastTo$1(t4.valueOf(), n2), t4.datatype());
}
var name$269$1 = `matrixAlgorithmSuite`, dependencies$269$1 = [`typed`, `matrix`], createMatrixAlgorithmSuite$1 = factory$1(name$269$1, dependencies$269$1, (t4) => {
  var { typed: n2, matrix: r2 } = t4, i2 = createMatAlgo13xDD$1({ typed: n2 }), a2 = createMatAlgo14xDs$1({ typed: n2 });
  return function(t5) {
    var o2 = t5.elop, s2 = t5.SD || t5.DS, c2;
    o2 ? (c2 = { "DenseMatrix, DenseMatrix": (t6, n3) => i2(...broadcast$1(t6, n3), o2), "Array, Array": (t6, n3) => i2(...broadcast$1(r2(t6), r2(n3)), o2).valueOf(), "Array, DenseMatrix": (t6, n3) => i2(...broadcast$1(r2(t6), n3), o2), "DenseMatrix, Array": (t6, n3) => i2(...broadcast$1(t6, r2(n3)), o2) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = (n3, r3) => t5.SS(...broadcast$1(n3, r3), o2, false)), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = (n3, r3) => t5.DS(...broadcast$1(n3, r3), o2, false), c2[`Array, SparseMatrix`] = (n3, i3) => t5.DS(...broadcast$1(r2(n3), i3), o2, false)), s2 && (c2[`SparseMatrix, DenseMatrix`] = (t6, n3) => s2(...broadcast$1(n3, t6), o2, true), c2[`SparseMatrix, Array`] = (t6, n3) => s2(...broadcast$1(r2(n3), t6), o2, true))) : (c2 = { "DenseMatrix, DenseMatrix": n2.referToSelf((t6) => (n3, r3) => i2(...broadcast$1(n3, r3), t6)), "Array, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$1(r2(n3), r2(a3)), t6).valueOf()), "Array, DenseMatrix": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$1(r2(n3), a3), t6)), "DenseMatrix, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast$1(n3, r2(a3)), t6)) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.SS(...broadcast$1(r3, i3), n3, false))), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.DS(...broadcast$1(r3, i3), n3, false)), c2[`Array, SparseMatrix`] = n2.referToSelf((n3) => (i3, a3) => t5.DS(...broadcast$1(r2(i3), a3), n3, false))), s2 && (c2[`SparseMatrix, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => s2(...broadcast$1(r3, n3), t6, true)), c2[`SparseMatrix, Array`] = n2.referToSelf((t6) => (n3, i3) => s2(...broadcast$1(r2(i3), n3), t6, true))));
    var l2 = t5.scalar || `any`;
    (t5.Ds || t5.Ss) && (o2 ? (c2[`DenseMatrix,` + l2] = (t6, n3) => a2(t6, n3, o2, false), c2[l2 + `, DenseMatrix`] = (t6, n3) => a2(n3, t6, o2, true), c2[`Array,` + l2] = (t6, n3) => a2(r2(t6), n3, o2, false).valueOf(), c2[l2 + `, Array`] = (t6, n3) => a2(r2(n3), t6, o2, true).valueOf()) : (c2[`DenseMatrix,` + l2] = n2.referToSelf((t6) => (n3, r3) => a2(n3, r3, t6, false)), c2[l2 + `, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => a2(r3, n3, t6, true)), c2[`Array,` + l2] = n2.referToSelf((t6) => (n3, i3) => a2(r2(n3), i3, t6, false).valueOf()), c2[l2 + `, Array`] = n2.referToSelf((t6) => (n3, i3) => a2(r2(i3), n3, t6, true).valueOf())));
    var u2 = t5.sS === void 0 ? t5.Ss : t5.sS;
    return o2 ? (t5.Ss && (c2[`SparseMatrix,` + l2] = (n3, r3) => t5.Ss(n3, r3, o2, false)), u2 && (c2[l2 + `, SparseMatrix`] = (t6, n3) => u2(n3, t6, o2, true))) : (t5.Ss && (c2[`SparseMatrix,` + l2] = n2.referToSelf((n3) => (r3, i3) => t5.Ss(r3, i3, n3, false))), u2 && (c2[l2 + `, SparseMatrix`] = n2.referToSelf((t6) => (n3, r3) => u2(r3, n3, t6, true)))), o2 && o2.signatures && extend$1$2(c2, o2.signatures), c2;
  };
}), name$268$1 = `mod`, dependencies$268$1 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createMod$1 = factory$1(name$268$1, dependencies$268$1, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createFloor$1({ typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 }), d2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: o2 }), p2 = createMatAlgo03xDSf$1({ typed: n2 }), m2 = createMatAlgo05xSfSf$1({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: o2 }), g2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: c2 }), v2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: a2, concat: l2 });
  return n2(name$268$1, { "number, number": y2, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isZero() ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  }, "bigint, bigint": function(t5, n3) {
    if (n3 === 0n) return t5;
    if (t5 < 0) {
      var r3 = t5 % n3;
      return r3 === 0n ? r3 : r3 + n3;
    }
    return t5 % n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return n3.equals(0) ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  } }, v2({ SS: m2, DS: p2, SD: d2, Ss: h2, sS: g2 }));
  function y2(t5, n3) {
    return n3 === 0 ? t5 : t5 - n3 * u2(t5 / n3);
  }
}), name$267$1 = `matAlgo01xDSid`, dependencies$267$1 = [`typed`], createMatAlgo01xDSid$1 = factory$1(name$267$1, dependencies$267$1, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError$1(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2 = typeof c2 == `string` && c2 !== `mixed` && c2 === m2 ? c2 : void 0, y2 = v2 ? n2.find(i2, [v2, v2]) : i2, b2, x2, S2 = [];
    for (b2 = 0; b2 < h2; b2++) S2[b2] = [];
    var w2 = [], E = [];
    for (x2 = 0; x2 < g2; x2++) {
      for (var D = x2 + 1, O2 = d2[x2], j2 = d2[x2 + 1], M2 = O2; M2 < j2; M2++) b2 = u2[M2], w2[b2] = a2 ? y2(l2[M2], o2[b2][x2]) : y2(o2[b2][x2], l2[M2]), E[b2] = D;
      for (b2 = 0; b2 < h2; b2++) E[b2] === D ? S2[b2][x2] = w2[b2] : S2[b2][x2] = o2[b2][x2];
    }
    return t5.createDenseMatrix({ data: S2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$266$1 = `matAlgo04xSidSid`, dependencies$266$1 = [`typed`, `equalScalar`], createMatAlgo04xSidSid$1 = factory$1(name$266$1, dependencies$266$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$1(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = o2 && d2 ? [] : void 0, M2 = o2 && d2 ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2, V2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var H2 = L2 + 1;
      for (z2 = c2[L2], V2 = c2[L2 + 1], R2 = z2; R2 < V2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = H2, j2 && (j2[I2] = o2[R2]);
      for (z2 = m2[L2], V2 = m2[L2 + 1], R2 = z2; R2 < V2; R2++) if (I2 = p2[R2], N2[I2] === H2) {
        if (j2) {
          var U2 = w2(j2[I2], d2[R2]);
          x2(U2, S2) ? N2[I2] = null : j2[I2] = U2;
        }
      } else D.push(I2), F[I2] = H2, M2 && (M2[I2] = d2[R2]);
      if (j2 && M2) for (R2 = O2[L2]; R2 < D.length; ) I2 = D[R2], N2[I2] === H2 ? (E[R2] = j2[I2], R2++) : F[I2] === H2 ? (E[R2] = M2[I2], R2++) : D.splice(R2, 1);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$265$1 = `matAlgo10xSids`, dependencies$265$1 = [`typed`, `DenseMatrix`], createMatAlgo10xSids$1 = factory$1(name$265$1, dependencies$265$1, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = i2;
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
});
function ArgumentsError$1(t4, n2, r2, i2) {
  if (!(this instanceof ArgumentsError$1)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.fn = t4, this.count = n2, this.min = r2, this.max = i2, this.message = `Wrong number of arguments in function ` + t4 + ` (` + n2 + ` provided, ` + r2 + (i2 == null ? `` : `-` + i2) + ` expected)`, this.stack = Error().stack;
}
ArgumentsError$1.prototype = Error(), ArgumentsError$1.prototype.constructor = Error, ArgumentsError$1.prototype.name = `ArgumentsError`, ArgumentsError$1.prototype.isArgumentsError = true;
var name$264$1 = `gcd`, dependencies$264$1 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`, `concat`], gcdTypes$1 = `number | BigNumber | Fraction | Matrix | Array`, gcdManyTypesSignature$1 = `${gcdTypes$1}, ${gcdTypes$1}, ...${gcdTypes$1}`;
function is1d$1(t4) {
  return !t4.some((t5) => Array.isArray(t5));
}
var createGcd$1 = factory$1(name$264$1, dependencies$264$1, (t4) => {
  var { typed: n2, matrix: r2, config: i2, round: a2, equalScalar: o2, zeros: s2, BigNumber: c2, DenseMatrix: l2, concat: u2 } = t4, d2 = createMod$1({ typed: n2, config: i2, round: a2, matrix: r2, equalScalar: o2, zeros: s2, DenseMatrix: l2, concat: u2 }), p2 = createMatAlgo01xDSid$1({ typed: n2 }), m2 = createMatAlgo04xSidSid$1({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: l2 }), g2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: u2 });
  return n2(name$264$1, { "number, number": v2, "BigNumber, BigNumber": y2, "Fraction, Fraction": (t5, n3) => t5.gcd(n3) }, g2({ SS: m2, DS: p2, Ss: h2 }), { [gcdManyTypesSignature$1]: n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), Array: n2.referToSelf((t5) => (n3) => {
    if (n3.length === 1 && Array.isArray(n3[0]) && is1d$1(n3[0])) return t5(...n3[0]);
    if (is1d$1(n3)) return t5(...n3);
    throw new ArgumentsError$1(`gcd() supports only 1d matrices!`);
  }), Matrix: n2.referToSelf((t5) => (n3) => t5(n3.toArray())) });
  function v2(t5, n3) {
    if (!isInteger$2(t5) || !isInteger$2(n3)) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3; n3 !== 0; ) r3 = d2(t5, n3), t5 = n3, n3 = r3;
    return t5 < 0 ? -t5 : t5;
  }
  function y2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3 = new c2(0); !n3.isZero(); ) {
      var i3 = d2(t5, n3);
      t5 = n3, n3 = i3;
    }
    return t5.lt(r3) ? t5.neg() : t5;
  }
}), name$263$1 = `matAlgo06xS0S0`, dependencies$263$1 = [`typed`, `equalScalar`], createMatAlgo06xS0S0$1 = factory$1(name$263$1, dependencies$263$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = i2._values, u2 = i2._size, d2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (s2.length !== u2.length) throw new DimensionError$1(s2.length, u2.length);
    if (s2[0] !== u2[0] || s2[1] !== u2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
    var p2 = s2[0], m2 = s2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof c2 == `string` && c2 === d2 && c2 !== `mixed` && (h2 = c2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = o2 && l2 ? [] : void 0, x2 = [], S2 = [], w2 = b2 ? [] : void 0, E = [], D = [], O2 = 0; O2 < m2; O2++) {
      S2[O2] = x2.length;
      var j2 = O2 + 1;
      if (scatter$1(t5, O2, E, w2, D, j2, x2, y2), scatter$1(i2, O2, E, w2, D, j2, x2, y2), w2) for (var M2 = S2[O2]; M2 < x2.length; ) {
        var N2 = x2[M2];
        if (D[N2] === j2) {
          var F = w2[N2];
          g2(F, v2) ? x2.splice(M2, 1) : (b2.push(F), M2++);
        } else x2.splice(M2, 1);
      }
      else for (var I2 = S2[O2]; I2 < x2.length; ) D[x2[I2]] === j2 ? I2++ : x2.splice(I2, 1);
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: c2 === t5._datatype && d2 === i2._datatype ? h2 : void 0 });
  };
}), name$262$1 = `lcm`, dependencies$262$1 = [`typed`, `matrix`, `equalScalar`, `concat`], createLcm$1 = factory$1(name$262$1, dependencies$262$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0$1({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: a2 }), u2 = `number | BigNumber | Fraction | Matrix | Array`, d2 = {};
  return d2[`${u2}, ${u2}, ...${u2}`] = n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), n2(name$262$1, { "number, number": lcmNumber$1, "BigNumber, BigNumber": p2, "Fraction, Fraction": (t5, n3) => t5.lcm(n3) }, l2({ SS: s2, DS: o2, Ss: c2 }), d2);
  function p2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function lcm must be integer numbers`);
    if (t5.isZero()) return t5;
    if (n3.isZero()) return n3;
    for (var r3 = t5.times(n3); !n3.isZero(); ) {
      var i3 = n3;
      n3 = t5.mod(i3), t5 = i3;
    }
    return r3.div(t5).abs();
  }
});
function promoteLogarithm$1(t4, n2, r2, i2) {
  return function(a2) {
    if (a2 > 0 || r2.predictable) {
      if (a2 <= 0) return NaN;
      var o2 = a2.toString(16), s2 = o2.substring(0, 15);
      return t4 * (o2.length - s2.length) + n2(Number(`0x` + s2));
    }
    return i2(a2.toNumber());
  };
}
var name$261$1 = `log10`, dependencies$261$1 = [`typed`, `config`, `Complex`], log16$1 = log10Number$1(16), createLog10$1 = factory$1(name$261$1, dependencies$261$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return t5.log().div(Math.LN10);
  }
  function o2(t5) {
    return a2(new i2(t5, 0));
  }
  return n2(name$261$1, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log10Number$1(t5) : o2(t5);
  }, bigint: promoteLogarithm$1(log16$1, log10Number$1, r2, o2), Complex: a2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log() : o2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$260$1 = `log2`, dependencies$260$1 = [`typed`, `config`, `Complex`], createLog2$1 = factory$1(name$260$1, dependencies$260$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return o2(new i2(t5, 0));
  }
  return n2(name$260$1, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log2Number$1(t5) : a2(t5);
  }, bigint: promoteLogarithm$1(4, log2Number$1, r2, a2), Complex: o2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log(2) : a2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
  function o2(t5) {
    var n3 = Math.sqrt(t5.re * t5.re + t5.im * t5.im);
    return new i2(Math.log2 ? Math.log2(n3) : Math.log(n3) / Math.LN2, Math.atan2(t5.im, t5.re) / Math.LN2);
  }
}), name$259$1 = `multiplyScalar`, dependencies$259$1 = [`typed`], createMultiplyScalar$1 = factory$1(name$259$1, dependencies$259$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`multiplyScalar`, { "number, number": multiplyNumber$1, "Complex, Complex": function(t5, n3) {
    return t5.mul(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.times(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 * n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.mul(n3);
  }, "number | Fraction | BigNumber | Complex, Unit": (t5, n3) => n3.multiply(t5), "Unit, number | Fraction | BigNumber | Complex | Unit": (t5, n3) => t5.multiply(n3) });
}), name$258$1 = `multiply`, dependencies$258$1 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `equalScalar`, `dot`], createMultiply$1 = factory$1(name$258$1, dependencies$258$1, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, equalScalar: o2, dot: s2 } = t4, c2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: o2 }), l2 = createMatAlgo14xDs$1({ typed: n2 });
  function u2(t5, n3) {
    switch (t5.length) {
      case 1:
        switch (n3.length) {
          case 1:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vectors must have the same length`);
            break;
          case 2:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vector length (` + t5[0] + `) must match Matrix rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      case 2:
        switch (n3.length) {
          case 1:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix columns (` + t5[1] + `) must match Vector length (` + n3[0] + `)`);
            break;
          case 2:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix A columns (` + t5[1] + `) must match Matrix B rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      default:
        throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix A has ` + t5.length + ` dimensions)`);
    }
  }
  function d2(t5, n3, r3) {
    if (r3 === 0) throw Error(`Cannot multiply two empty vectors`);
    return s2(t5, n3);
  }
  function p2(t5, n3) {
    if (n3.storage() !== `dense`) throw Error(`Support for SparseMatrix not implemented`);
    return m2(t5, n3);
  }
  function m2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = u3[1], h3, g3 = i2, v3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && (h3 = c3, g3 = n2.find(i2, [h3, h3]), v3 = n2.find(a2, [h3, h3]));
    for (var y3 = [], b3 = 0; b3 < m3; b3++) {
      for (var x3 = v3(o3[0], l3[0][b3]), S3 = 1; S3 < p3; S3++) x3 = g3(x3, v3(o3[S3], l3[S3][b3]));
      y3[b3] = x3;
    }
    return t5.createDenseMatrix({ data: y3, size: [m3], datatype: c3 === t5._datatype && d3 === r3._datatype ? h3 : void 0 });
  }
  var h2 = n2(`_multiplyMatrixVector`, { "DenseMatrix, any": v2, "SparseMatrix, any": x2 }), g2 = n2(`_multiplyMatrixMatrix`, { "DenseMatrix, DenseMatrix": y2, "DenseMatrix, SparseMatrix": b2, "SparseMatrix, DenseMatrix": S2, "SparseMatrix, SparseMatrix": w2 });
  function v2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._datatype || r3.getDataType(), d3 = s3[0], p3 = s3[1], m3, h3 = i2, g3 = a2;
    c3 && u3 && c3 === u3 && typeof c3 == `string` && c3 !== `mixed` && (m3 = c3, h3 = n2.find(i2, [m3, m3]), g3 = n2.find(a2, [m3, m3]));
    for (var v3 = [], y3 = 0; y3 < d3; y3++) {
      for (var b3 = o3[y3], x3 = g3(b3[0], l3[0]), S3 = 1; S3 < p3; S3++) x3 = h3(x3, g3(b3[S3], l3[S3]));
      v3[y3] = x3;
    }
    return t5.createDenseMatrix({ data: v3, size: [d3], datatype: c3 === t5._datatype && u3 === r3._datatype ? m3 : void 0 });
  }
  function y2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = s3[1], h3 = u3[1], g3, v3 = i2, y3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && c3 !== `mixed` && (g3 = c3, v3 = n2.find(i2, [g3, g3]), y3 = n2.find(a2, [g3, g3]));
    for (var b3 = [], x3 = 0; x3 < p3; x3++) {
      var S3 = o3[x3];
      b3[x3] = [];
      for (var w3 = 0; w3 < h3; w3++) {
        for (var E = y3(S3[0], l3[0][w3]), D = 1; D < m3; D++) E = v3(E, y3(S3[D], l3[D][w3]));
        b3[x3][w3] = E;
      }
    }
    return t5.createDenseMatrix({ data: b3, size: [p3, h3], datatype: c3 === t5._datatype && d3 === r3._datatype ? g3 : void 0 });
  }
  function b2(t5, r3) {
    var s3 = t5._data, c3 = t5._size, l3 = t5._datatype || t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._size, h3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType();
    if (!u3) throw Error(`Cannot multiply Dense Matrix times Pattern only Matrix`);
    var g3 = c3[0], v3 = m3[1], y3, b3 = i2, x3 = a2, S3 = o2, w3 = 0;
    l3 && h3 && l3 === h3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]), S3 = n2.find(o2, [y3, y3]), w3 = n2.convert(0, y3));
    for (var E = [], D = [], O2 = [], j2 = r3.createSparseMatrix({ values: E, index: D, ptr: O2, size: [g3, v3], datatype: l3 === t5._datatype && h3 === r3._datatype ? y3 : void 0 }), M2 = 0; M2 < v3; M2++) {
      O2[M2] = D.length;
      var N2 = p3[M2], F = p3[M2 + 1];
      if (F > N2) for (var I2 = 0, L2 = 0; L2 < g3; L2++) {
        for (var R2 = L2 + 1, z2 = void 0, V2 = N2; V2 < F; V2++) {
          var H2 = d3[V2];
          I2 === R2 ? z2 = b3(z2, x3(s3[L2][H2], u3[V2])) : (z2 = x3(s3[L2][H2], u3[V2]), I2 = R2);
        }
        I2 === R2 && !S3(z2, w3) && (D.push(L2), E.push(z2));
      }
    }
    return O2[v3] = D.length, j2;
  }
  function x2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = [], v3 = [], y3 = [], b3, x3 = i2, S3 = a2, w3 = o2, E = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (b3 = u3, x3 = n2.find(i2, [b3, b3]), S3 = n2.find(a2, [b3, b3]), w3 = n2.find(o2, [b3, b3]), E = n2.convert(0, b3));
    var D = [], O2 = [];
    y3[0] = 0;
    for (var j2 = 0; j2 < h3; j2++) {
      var M2 = d3[j2];
      if (!w3(M2, E)) for (var N2 = l3[j2], F = l3[j2 + 1], I2 = N2; I2 < F; I2++) {
        var L2 = c3[I2];
        O2[L2] ? D[L2] = x3(D[L2], S3(M2, s3[I2])) : (O2[L2] = true, v3.push(L2), D[L2] = S3(M2, s3[I2]));
      }
    }
    for (var R2 = v3.length, z2 = 0; z2 < R2; z2++) g3[z2] = D[v3[z2]];
    return y3[1] = v3.length, t5.createSparseMatrix({ values: g3, index: v3, ptr: y3, size: [m3, 1], datatype: u3 === t5._datatype && p3 === r3._datatype ? b3 : void 0 });
  }
  function S2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = r3._size[1], v3, y3 = i2, b3 = a2, x3 = o2, S3 = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (v3 = u3, y3 = n2.find(i2, [v3, v3]), b3 = n2.find(a2, [v3, v3]), x3 = n2.find(o2, [v3, v3]), S3 = n2.convert(0, v3));
    for (var w3 = [], E = [], D = [], O2 = t5.createSparseMatrix({ values: w3, index: E, ptr: D, size: [m3, g3], datatype: u3 === t5._datatype && p3 === r3._datatype ? v3 : void 0 }), j2 = [], M2 = [], N2 = 0; N2 < g3; N2++) {
      D[N2] = E.length;
      for (var F = N2 + 1, I2 = 0; I2 < h3; I2++) {
        var L2 = d3[I2][N2];
        if (!x3(L2, S3)) for (var R2 = l3[I2], z2 = l3[I2 + 1], V2 = R2; V2 < z2; V2++) {
          var H2 = c3[V2];
          M2[H2] === F ? j2[H2] = y3(j2[H2], b3(L2, s3[V2])) : (M2[H2] = F, E.push(H2), j2[H2] = b3(L2, s3[V2]));
        }
      }
      for (var U2 = D[N2], W2 = E.length, G2 = U2; G2 < W2; G2++) w3[G2] = j2[E[G2]];
    }
    return D[g3] = E.length, O2;
  }
  function w2(t5, r3) {
    var o3 = t5._values, s3 = t5._index, c3 = t5._ptr, l3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType(), h3 = t5._size[0], g3 = r3._size[1], v3 = o3 && u3, y3, b3 = i2, x3 = a2;
    l3 && m3 && l3 === m3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]));
    for (var S3 = v3 ? [] : void 0, w3 = [], E = [], D = t5.createSparseMatrix({ values: S3, index: w3, ptr: E, size: [h3, g3], datatype: l3 === t5._datatype && m3 === r3._datatype ? y3 : void 0 }), O2 = v3 ? [] : void 0, j2 = [], M2, N2, F, I2, L2, R2, z2, V2, H2 = 0; H2 < g3; H2++) {
      E[H2] = w3.length;
      var U2 = H2 + 1;
      for (L2 = p3[H2], R2 = p3[H2 + 1], I2 = L2; I2 < R2; I2++) if (V2 = d3[I2], v3) for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] === U2 ? O2[z2] = b3(O2[z2], x3(u3[I2], o3[M2])) : (j2[z2] = U2, w3.push(z2), O2[z2] = x3(u3[I2], o3[M2]));
      else for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] !== U2 && (j2[z2] = U2, w3.push(z2));
      if (v3) for (var W2 = E[H2], G2 = w3.length, K2 = W2; K2 < G2; K2++) S3[K2] = O2[w3[K2]];
    }
    return E[g3] = w3.length, D;
  }
  return n2(name$258$1, a2, { "Array, Array": n2.referTo(`Matrix, Matrix`, (t5) => (n3, i3) => {
    u2(arraySize$1(n3), arraySize$1(i3));
    var a3 = t5(r2(n3), r2(i3));
    return isMatrix$1(a3) ? a3.valueOf() : a3;
  }), "Matrix, Matrix": function(t5, n3) {
    var r3 = t5.size(), i3 = n3.size();
    return u2(r3, i3), r3.length === 1 ? i3.length === 1 ? d2(t5, n3, r3[0]) : p2(t5, n3) : i3.length === 1 ? h2(t5, n3) : g2(t5, n3);
  }, "Matrix, Array": n2.referTo(`Matrix,Matrix`, (t5) => (n3, i3) => t5(n3, r2(i3))), "Array, Matrix": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3, i3.storage()), i3)), "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, a2, false);
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, a2, false);
  }, "any, SparseMatrix": function(t5, n3) {
    return c2(n3, t5, a2, true);
  }, "any, DenseMatrix": function(t5, n3) {
    return l2(n3, t5, a2, true);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, a2, false).valueOf();
  }, "any, Array": function(t5, n3) {
    return l2(r2(n3), t5, a2, true).valueOf();
  }, "any, any": a2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) });
}), name$257$1 = `nthRoot`, dependencies$257$1 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `concat`], createNthRoot$1 = factory$1(name$257$1, dependencies$257$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid$1({ typed: n2 }), c2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), d2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: o2 });
  function p2() {
    throw Error(`Complex number not supported in function nthRoot. Use nthRoots instead.`);
  }
  return n2(name$257$1, { number: nthRootNumber$1, "number, number": nthRootNumber$1, BigNumber: (t5) => m2(t5, new a2(2)), "BigNumber, BigNumber": m2, Complex: p2, "Complex, number": p2, Array: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(r2(n3), 2).valueOf()), DenseMatrix: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(n3, 2)), SparseMatrix: n2.referTo(`SparseMatrix,number`, (t5) => (n3) => t5(n3, 2)), "SparseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return l2(n3, r3, t5);
    throw Error(`Root must be non-zero`);
  }), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return s2(n3, r3, t5, false);
    throw Error(`Root must be non-zero`);
  }), "Array, SparseMatrix": n2.referTo(`DenseMatrix,SparseMatrix`, (t5) => (n3, i3) => t5(r2(n3), i3)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return u2(r3, n3, t5, true);
    throw Error(`Root must be non-zero`);
  }) }, d2({ scalar: `number | BigNumber`, SD: c2, Ss: u2, sS: false }));
  function m2(t5, n3) {
    var r3 = a2.precision, i3 = a2.clone({ precision: r3 + 2 }), o3 = new a2(0), s3 = new i3(1), c3 = n3.isNegative();
    if (c3 && (n3 = n3.neg()), n3.isZero()) throw Error(`Root must be non-zero`);
    if (t5.isNegative() && !n3.abs().mod(2).equals(1)) throw Error(`Root must be odd when a is negative.`);
    if (t5.isZero()) return c3 ? new i3(1 / 0) : 0;
    if (!t5.isFinite()) return c3 ? o3 : t5;
    var l3 = t5.abs().pow(s3.div(n3));
    return l3 = t5.isNeg() ? l3.neg() : l3, new a2((c3 ? s3.div(l3) : l3).toPrecision(r3));
  }
}), name$256$1 = `sign`, dependencies$256$1 = [`typed`, `BigNumber`, `Fraction`, `complex`], createSign$1 = factory$1(name$256$1, dependencies$256$1, (t4) => {
  var { typed: n2, BigNumber: r2, complex: i2, Fraction: a2 } = t4;
  return n2(name$256$1, { number: signNumber$1, Complex: function(t5) {
    return t5.im === 0 ? i2(signNumber$1(t5.re)) : t5.sign();
  }, BigNumber: function(t5) {
    return new r2(t5.cmp(0));
  }, bigint: function(t5) {
    return t5 > 0n ? 1n : t5 < 0n ? -1n : 0n;
  }, Fraction: function(t5) {
    return t5.n === 0n ? new a2(0) : new a2(t5.s);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), Unit: n2.referToSelf((t5) => (r3) => {
    if (!r3._isDerived() && r3.units[0].unit.offset !== 0) throw TypeError(`sign is ambiguous for units with offset`);
    return n2.find(t5, r3.valueType())(r3.value);
  }) });
}), name$255$1 = `sqrt`, dependencies$255$1 = [`config`, `typed`, `Complex`], createSqrt$1 = factory$1(name$255$1, dependencies$255$1, (t4) => {
  var { config: n2, typed: r2, Complex: i2 } = t4;
  return r2(`sqrt`, { number: a2, Complex: function(t5) {
    return t5.sqrt();
  }, BigNumber: function(t5) {
    return !t5.isNegative() || n2.predictable ? t5.sqrt() : a2(t5.toNumber());
  }, Unit: function(t5) {
    return t5.pow(0.5);
  } });
  function a2(t5) {
    return isNaN(t5) ? NaN : t5 >= 0 || n2.predictable ? Math.sqrt(t5) : new i2(t5, 0).sqrt();
  }
}), name$254$1 = `square`, dependencies$254$1 = [`typed`], createSquare$1 = factory$1(name$254$1, dependencies$254$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$254$1, { number: squareNumber$1, Complex: function(t5) {
    return t5.mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5);
  }, bigint: function(t5) {
    return t5 * t5;
  }, Fraction: function(t5) {
    return t5.mul(t5);
  }, Unit: function(t5) {
    return t5.pow(2);
  } });
}), name$253$1 = `subtract`, dependencies$253$1 = [`typed`, `matrix`, `equalScalar`, `subtractScalar`, `unaryMinus`, `DenseMatrix`, `concat`], createSubtract$1 = factory$1(name$253$1, dependencies$253$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, subtractScalar: a2, unaryMinus: o2, DenseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid$1({ typed: n2 }), u2 = createMatAlgo03xDSf$1({ typed: n2 }), d2 = createMatAlgo05xSfSf$1({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: s2 }), m2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: s2 }), h2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$253$1, { "any, any": a2 }, h2({ elop: a2, SS: d2, DS: l2, SD: u2, Ss: m2, sS: p2 }));
}), name$252$1 = `xgcd`, dependencies$252$1 = [`typed`, `config`, `matrix`, `BigNumber`], createXgcd$1 = factory$1(name$252$1, dependencies$252$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$252$1, { "number, number": function(t5, n3) {
    var a3 = xgcdNumber$1(t5, n3);
    return r2.matrix === `Array` ? a3 : i2(a3);
  }, "BigNumber, BigNumber": o2 });
  function o2(t5, n3) {
    var o3, s2, c2, l2 = new a2(0), u2 = new a2(1), d2 = l2, p2 = u2, m2 = u2, h2 = l2;
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function xgcd must be integer numbers`);
    for (; !n3.isZero(); ) s2 = t5.div(n3).floor(), c2 = t5.mod(n3), o3 = d2, d2 = p2.minus(s2.times(d2)), p2 = o3, o3 = m2, m2 = h2.minus(s2.times(m2)), h2 = o3, t5 = n3, n3 = c2;
    var g2 = t5.lt(l2) ? [t5.neg(), p2.neg(), h2.neg()] : [t5, t5.isZero() ? 0 : p2, h2];
    return r2.matrix === `Array` ? g2 : i2(g2);
  }
}), name$251$1 = `invmod`, dependencies$251$1 = [`typed`, `config`, `BigNumber`, `xgcd`, `equal`, `smaller`, `mod`, `add`, `isInteger`], createInvmod$1 = factory$1(name$251$1, dependencies$251$1, (t4) => {
  var { typed: n2, config: r2, BigNumber: i2, xgcd: a2, equal: o2, smaller: s2, mod: c2, add: l2, isInteger: u2 } = t4;
  return n2(name$251$1, { "number, number": d2, "BigNumber, BigNumber": d2 });
  function d2(t5, n3) {
    if (!u2(t5) || !u2(n3)) throw Error(`Parameters in function invmod must be integer numbers`);
    if (t5 = c2(t5, n3), o2(n3, 0)) throw Error(`Divisor must be non zero`);
    var r3 = a2(t5, n3);
    r3 = r3.valueOf();
    var [d3, p2] = r3;
    return o2(d3, i2(1)) ? (p2 = c2(p2, n3), s2(p2, i2(0)) && (p2 = l2(p2, n3)), p2) : NaN;
  }
}), name$250$1 = `matAlgo09xS0Sf`, dependencies$250$1 = [`typed`, `equalScalar`], createMatAlgo09xS0Sf$1 = factory$1(name$250$1, dependencies$250$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$1(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = [], N2, F, I2, L2, R2;
    for (F = 0; F < y2; F++) {
      O2[F] = D.length;
      var z2 = F + 1;
      if (j2) for (L2 = m2[F], R2 = m2[F + 1], I2 = L2; I2 < R2; I2++) N2 = p2[I2], M2[N2] = z2, j2[N2] = d2[I2];
      for (L2 = c2[F], R2 = c2[F + 1], I2 = L2; I2 < R2; I2++) if (N2 = s2[I2], j2) {
        var V2 = M2[N2] === z2 ? j2[N2] : S2, H2 = w2(o2[I2], V2);
        x2(H2, S2) || (D.push(N2), E.push(H2));
      } else D.push(N2);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$249$1 = `dotMultiply`, dependencies$249$1 = [`typed`, `matrix`, `equalScalar`, `multiplyScalar`, `concat`], createDotMultiply$1 = factory$1(name$249$1, dependencies$249$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, multiplyScalar: a2, concat: o2 } = t4, s2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo09xS0Sf$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 });
  return n2(name$249$1, createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: o2 })({ elop: a2, SS: c2, DS: s2, Ss: l2 }));
});
function bitAndBigNumber$1(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitAnd`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero() || n2.eq(-1) || t4.eq(n2)) return t4;
  if (n2.isZero() || t4.eq(-1)) return n2;
  if (!t4.isFinite() || !n2.isFinite()) {
    if (!t4.isFinite() && !n2.isFinite()) return t4.isNegative() === n2.isNegative() ? t4 : new r2(0);
    if (!t4.isFinite()) return n2.isNegative() ? t4 : t4.isNegative() ? new r2(0) : n2;
    if (!n2.isFinite()) return t4.isNegative() ? n2 : n2.isNegative() ? new r2(0) : t4;
  }
  return bitwise$1(t4, n2, function(t5, n3) {
    return t5 & n3;
  });
}
function bitNotBigNumber$1(t4) {
  if (t4.isFinite() && !t4.isInteger()) throw Error(`Integer expected in function bitNot`);
  var n2 = t4.constructor, r2 = n2.precision;
  n2.config({ precision: 1e9 });
  var i2 = t4.plus(new n2(1));
  return i2.s = -i2.s || null, n2.config({ precision: r2 }), i2;
}
function bitOrBigNumber$1(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitOr`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  var i2 = new r2(-1);
  return t4.isZero() || n2.eq(i2) || t4.eq(n2) ? n2 : n2.isZero() || t4.eq(i2) ? t4 : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !t4.isNegative() && n2.isNegative() || t4.isNegative() && !n2.isNegative() && !n2.isFinite() ? i2 : t4.isNegative() && n2.isNegative() ? t4.isFinite() ? t4 : n2 : t4.isFinite() ? n2 : t4 : bitwise$1(t4, n2, function(t5, n3) {
    return t5 | n3;
  });
}
function bitwise$1(t4, n2, r2) {
  var i2 = t4.constructor, a2, o2, s2 = +(t4.s < 0), c2 = +(n2.s < 0);
  if (s2) {
    a2 = decCoefficientToBinaryString$1(bitNotBigNumber$1(t4));
    for (var l2 = 0; l2 < a2.length; ++l2) a2[l2] ^= 1;
  } else a2 = decCoefficientToBinaryString$1(t4);
  if (c2) {
    o2 = decCoefficientToBinaryString$1(bitNotBigNumber$1(n2));
    for (var u2 = 0; u2 < o2.length; ++u2) o2[u2] ^= 1;
  } else o2 = decCoefficientToBinaryString$1(n2);
  var d2, p2, m2;
  a2.length <= o2.length ? (d2 = a2, p2 = o2, m2 = s2) : (d2 = o2, p2 = a2, m2 = c2);
  var h2 = d2.length, g2 = p2.length, v2 = r2(s2, c2) ^ 1, y2 = new i2(v2 ^ 1), b2 = new i2(1), x2 = new i2(2), S2 = i2.precision;
  for (i2.config({ precision: 1e9 }); h2 > 0; ) r2(d2[--h2], p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  for (; g2 > 0; ) r2(m2, p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  return i2.config({ precision: S2 }), v2 === 0 && (y2.s = -y2.s), y2;
}
function decCoefficientToBinaryString$1(t4) {
  for (var n2 = t4.d, r2 = n2[0] + ``, i2 = 1; i2 < n2.length; ++i2) {
    for (var a2 = n2[i2] + ``, o2 = 7 - a2.length; o2--; ) a2 = `0` + a2;
    r2 += a2;
  }
  for (var s2 = r2.length; r2.charAt(s2) === `0`; ) s2--;
  var c2 = t4.e, l2 = r2.slice(0, s2 + 1 || 1), u2 = l2.length;
  if (c2 > 0) if (++c2 > u2) for (c2 -= u2; c2--; ) l2 += `0`;
  else c2 < u2 && (l2 = l2.slice(0, c2) + `.` + l2.slice(c2));
  for (var d2 = [0], p2 = 0; p2 < l2.length; ) {
    for (var m2 = d2.length; m2--; ) d2[m2] *= 10;
    d2[0] += parseInt(l2.charAt(p2++));
    for (var h2 = 0; h2 < d2.length; ++h2) d2[h2] > 1 && ((d2[h2 + 1] === null || d2[h2 + 1] === void 0) && (d2[h2 + 1] = 0), d2[h2 + 1] += d2[h2] >> 1, d2[h2] &= 1);
  }
  return d2.reverse();
}
function bitXor$1(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitXor`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero()) return n2;
  if (n2.isZero()) return t4;
  if (t4.eq(n2)) return new r2(0);
  var i2 = new r2(-1);
  return t4.eq(i2) ? bitNotBigNumber$1(n2) : n2.eq(i2) ? bitNotBigNumber$1(t4) : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !n2.isFinite() ? i2 : new r2(t4.isNegative() === n2.isNegative() ? 1 / 0 : -1 / 0) : bitwise$1(t4, n2, function(t5, n3) {
    return t5 ^ n3;
  });
}
function leftShiftBigNumber$1(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function leftShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : !t4.isFinite() && !n2.isFinite() ? new r2(NaN) : n2.lt(55) ? t4.times(2 ** n2.toNumber() + ``) : t4.times(new r2(2).pow(n2));
}
function rightArithShiftBigNumber$1(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function rightArithShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : n2.isFinite() ? n2.lt(55) ? t4.div(2 ** n2.toNumber() + ``).floor() : t4.div(new r2(2).pow(n2)).floor() : t4.isNegative() ? new r2(-1) : t4.isFinite() ? new r2(0) : new r2(NaN);
}
var name$248$1 = `bitAnd`, dependencies$248$1 = [`typed`, `matrix`, `equalScalar`, `concat`], createBitAnd$1 = factory$1(name$248$1, dependencies$248$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0$1({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$248$1, { "number, number": bitAndNumber$1, "BigNumber, BigNumber": bitAndBigNumber$1, "bigint, bigint": (t5, n3) => t5 & n3 }, l2({ SS: s2, DS: o2, Ss: c2 }));
}), name$247$1 = `bitNot`, dependencies$247$1 = [`typed`], createBitNot$1 = factory$1(name$247$1, dependencies$247$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$247$1, { number: bitNotNumber$1, BigNumber: bitNotBigNumber$1, bigint: (t5) => ~t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$246$1 = `bitOr`, dependencies$246$1 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOr$1 = factory$1(name$246$1, dependencies$246$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid$1({ typed: n2 }), c2 = createMatAlgo04xSidSid$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$246$1, { "number, number": bitOrNumber$1, "BigNumber, BigNumber": bitOrBigNumber$1, "bigint, bigint": (t5, n3) => t5 | n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$245$1 = `matAlgo07xSSf`, dependencies$245$1 = [`typed`, `SparseMatrix`], createMatAlgo07xSSf$1 = factory$1(name$245$1, dependencies$245$1, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return function(t5, a2, o2) {
    var s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = a2._size, u2 = a2._datatype || a2._data === void 0 ? a2._datatype : a2.getDataType();
    if (s2.length !== l2.length) throw new DimensionError$1(s2.length, l2.length);
    if (s2[0] !== l2[0] || s2[1] !== l2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + l2 + `)`);
    var d2 = s2[0], p2 = s2[1], m2, h2 = 0, g2 = o2;
    typeof c2 == `string` && c2 === u2 && c2 !== `mixed` && (m2 = c2, h2 = n2.convert(0, m2), g2 = n2.find(o2, [m2, m2]));
    for (var v2 = [], y2 = [], b2 = Array(p2 + 1).fill(0), x2 = [], S2 = [], w2 = [], E = [], D = 0; D < p2; D++) {
      var O2 = D + 1, j2 = 0;
      i2(t5, D, w2, x2, O2), i2(a2, D, E, S2, O2);
      for (var M2 = 0; M2 < d2; M2++) {
        var N2 = w2[M2] === O2 ? x2[M2] : h2, F = E[M2] === O2 ? S2[M2] : h2, I2 = g2(N2, F);
        I2 !== 0 && I2 !== false && (y2.push(M2), v2.push(I2), j2++);
      }
      b2[D + 1] = b2[D] + j2;
    }
    return new r2({ values: v2, index: y2, ptr: b2, size: [d2, p2], datatype: c2 === t5._datatype && u2 === a2._datatype ? m2 : void 0 });
  };
  function i2(t5, n3, r3, i3, a2) {
    for (var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = c2[n3], u2 = c2[n3 + 1]; l2 < u2; l2++) {
      var d2 = s2[l2];
      r3[d2] = a2, i3[d2] = o2[l2];
    }
  }
}), name$244$1 = `bitXor`, dependencies$244$1 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createBitXor$1 = factory$1(name$244$1, dependencies$244$1, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf$1({ typed: n2 }), c2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$244$1, { "number, number": bitXorNumber$1, "BigNumber, BigNumber": bitXor$1, "bigint, bigint": (t5, n3) => t5 ^ n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$243$1 = `arg`, dependencies$243$1 = [`typed`], createArg$1 = factory$1(name$243$1, dependencies$243$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$243$1, { number: function(t5) {
    return Math.atan2(0, t5);
  }, BigNumber: function(t5) {
    return t5.constructor.atan2(0, t5);
  }, Complex: function(t5) {
    return t5.arg();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$242$1 = `conj`, dependencies$242$1 = [`typed`], createConj$1 = factory$1(name$242$1, dependencies$242$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$242$1, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.conjugate(), Unit: n2.referToSelf((t5) => (n3) => new n3.constructor(t5(n3.toNumeric()), n3.formatUnits())), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$241$1 = `im`, dependencies$241$1 = [`typed`], createIm$1 = factory$1(name$241$1, dependencies$241$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$241$1, { number: () => 0, "BigNumber | Fraction": (t5) => t5.mul(0), Complex: (t5) => t5.im, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$240$1 = `re`, dependencies$240$1 = [`typed`], createRe$1 = factory$1(name$240$1, dependencies$240$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$240$1, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.re, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$239$1 = `not`, dependencies$239$1 = [`typed`], createNot$1 = factory$1(name$239$1, dependencies$239$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$239$1, { "null | undefined": () => true, number: notNumber$1, Complex: function(t5) {
    return t5.re === 0 && t5.im === 0;
  }, BigNumber: function(t5) {
    return t5.isZero() || t5.isNaN();
  }, bigint: (t5) => !t5, Unit: n2.referToSelf((t5) => (r2) => n2.find(t5, r2.valueType())(r2.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$238$1 = `nullish`, dependencies$238$1 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullish$1 = factory$1(name$238$1, dependencies$238$1, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createMatAlgo03xDSf$1({ typed: n2 }), c2 = createMatAlgo14xDs$1({ typed: n2 }), l2 = createMatAlgo13xDD$1({ typed: n2 });
  return n2(name$238$1, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (t5, n3) => t5, "null, any": (t5, n3) => n3, "undefined, any": (t5, n3) => n3, "SparseMatrix, Array | Matrix": (t5, n3) => {
    var r3 = i2(t5), a3 = i2(n3);
    if (o2(r3, a3)) return t5;
    throw new DimensionError$1(r3, a3);
  }, "DenseMatrix, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5)), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, r3, t5, false)), "DenseMatrix, Array": n2.referToSelf((t5) => (n3, i3) => l2(n3, r2(i3), t5)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => c2(n3, r3, t5, false)), "Array, Array": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), r2(i3), t5).valueOf()), "Array, DenseMatrix": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), i3, t5)), "Array, SparseMatrix": n2.referToSelf((t5) => (n3, i3) => s2(r2(n3), i3, t5, false)), "Array, any": n2.referToSelf((t5) => (n3, i3) => c2(r2(n3), i3, t5, false).valueOf()) });
}), name$237$1 = `or`, dependencies$237$1 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOr$1 = factory$1(name$237$1, dependencies$237$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo03xDSf$1({ typed: n2 }), c2 = createMatAlgo05xSfSf$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$237$1, { "number, number": orNumber$1, "Complex, Complex": function(t5, n3) {
    return t5.re !== 0 || t5.im !== 0 || n3.re !== 0 || n3.im !== 0;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !t5.isNaN() || !n3.isZero() && !n3.isNaN();
  }, "bigint, bigint": orNumber$1, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$236$1 = `xor`, dependencies$236$1 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createXor$1 = factory$1(name$236$1, dependencies$236$1, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf$1({ typed: n2 }), c2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$236$1, { "number, number": xorNumber$1, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) != (n3.re !== 0 || n3.im !== 0);
  }, "bigint, bigint": xorNumber$1, "BigNumber, BigNumber": function(t5, n3) {
    return (!t5.isZero() && !t5.isNaN()) != (!n3.isZero() && !n3.isNaN());
  }, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$235$1 = `concat`, dependencies$235$1 = [`typed`, `matrix`, `isInteger`], createConcat$1 = factory$1(name$235$1, dependencies$235$1, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4;
  return n2(name$235$1, { "...Array | Matrix | number | BigNumber": function(t5) {
    var n3, a2 = t5.length, o2 = -1, s2, c2 = false, l2 = [];
    for (n3 = 0; n3 < a2; n3++) {
      var u2 = t5[n3];
      if (isMatrix$1(u2) && (c2 = true), isNumber$1(u2) || isBigNumber$1(u2)) {
        if (n3 !== a2 - 1) throw Error(`Dimension must be specified as last argument`);
        if (s2 = o2, o2 = u2.valueOf(), !i2(o2)) throw TypeError(`Integer number expected for dimension`);
        if (o2 < 0 || n3 > 0 && o2 > s2) throw new IndexError$1(o2, s2 + 1);
      } else {
        var d2 = clone$3$1(u2).valueOf(), p2 = arraySize$1(d2);
        if (l2[n3] = d2, s2 = o2, o2 = p2.length - 1, n3 > 0 && o2 !== s2) throw new DimensionError$1(s2 + 1, o2 + 1);
      }
    }
    if (l2.length === 0) throw SyntaxError(`At least one matrix expected`);
    for (var m2 = l2.shift(); l2.length; ) m2 = concat$1(m2, l2.shift(), o2);
    return c2 ? r2(m2) : m2;
  }, "...string": function(t5) {
    return t5.join(``);
  } });
}), name$234$1 = `column`, dependencies$234$1 = [`typed`, `Index`, `matrix`, `range`], createColumn$1 = factory$1(name$234$1, dependencies$234$1, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$234$1, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3$1(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex$1(n3, t5.size()[1]);
    var o3 = new r2(a2(0, t5.size()[0]), [n3]), s2 = t5.subset(o3);
    return isMatrix$1(s2) ? s2 : i2([[s2]]);
  }
}), name$233$1 = `count`, dependencies$233$1 = [`typed`, `size`, `prod`], createCount$1 = factory$1(name$233$1, dependencies$233$1, (t4) => {
  var { typed: n2, size: r2, prod: i2 } = t4;
  return n2(name$233$1, { string: function(t5) {
    return t5.length;
  }, "Matrix | Array": function(t5) {
    return i2(r2(t5));
  } });
}), name$232$1 = `cross`, dependencies$232$1 = [`typed`, `matrix`, `subtract`, `multiply`], createCross$1 = factory$1(name$232$1, dependencies$232$1, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, multiply: a2 } = t4;
  return n2(name$232$1, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function o2(t5, n3) {
    var r3 = Math.max(arraySize$1(t5).length, arraySize$1(n3).length);
    t5 = squeeze$1(t5), n3 = squeeze$1(n3);
    var o3 = arraySize$1(t5), s2 = arraySize$1(n3);
    if (o3.length !== 1 || s2.length !== 1 || o3[0] !== 3 || s2[0] !== 3) throw RangeError(`Vectors with length 3 expected (Size A = [` + o3.join(`, `) + `], B = [` + s2.join(`, `) + `])`);
    var c2 = [i2(a2(t5[1], n3[2]), a2(t5[2], n3[1])), i2(a2(t5[2], n3[0]), a2(t5[0], n3[2])), i2(a2(t5[0], n3[1]), a2(t5[1], n3[0]))];
    return r3 > 1 ? [c2] : c2;
  }
}), name$231$1 = `diag`, dependencies$231$1 = [`typed`, `matrix`, `DenseMatrix`, `SparseMatrix`], createDiag$1 = factory$1(name$231$1, dependencies$231$1, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$231$1, { Array: function(t5) {
    return o2(t5, 0, arraySize$1(t5), null);
  }, "Array, number": function(t5, n3) {
    return o2(t5, n3, arraySize$1(t5), null);
  }, "Array, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), arraySize$1(t5), null);
  }, "Array, string": function(t5, n3) {
    return o2(t5, 0, arraySize$1(t5), n3);
  }, "Array, number, string": function(t5, n3, r3) {
    return o2(t5, n3, arraySize$1(t5), r3);
  }, "Array, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), arraySize$1(t5), r3);
  }, Matrix: function(t5) {
    return o2(t5, 0, t5.size(), t5.storage());
  }, "Matrix, number": function(t5, n3) {
    return o2(t5, n3, t5.size(), t5.storage());
  }, "Matrix, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), t5.size(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return o2(t5, 0, t5.size(), n3);
  }, "Matrix, number, string": function(t5, n3, r3) {
    return o2(t5, n3, t5.size(), r3);
  }, "Matrix, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), t5.size(), r3);
  } });
  function o2(t5, n3, r3, i3) {
    if (!isInteger$2(n3)) throw TypeError(`Second parameter in function diag must be an integer`);
    var a3 = n3 > 0 ? n3 : 0, o3 = n3 < 0 ? -n3 : 0;
    switch (r3.length) {
      case 1:
        return s2(t5, n3, i3, r3[0], o3, a3);
      case 2:
        return c2(t5, n3, i3, r3, o3, a3);
    }
    throw RangeError(`Matrix for function diag must be 2 dimensional`);
  }
  function s2(t5, n3, r3, o3, s3, c3) {
    var l2 = [o3 + s3, o3 + c3];
    if (r3 && r3 !== `sparse` && r3 !== `dense`) throw TypeError(`Unknown matrix type ${r3}"`);
    var u2 = r3 === `sparse` ? a2.diagonal(l2, t5, n3) : i2.diagonal(l2, t5, n3);
    return r3 === null ? u2.valueOf() : u2;
  }
  function c2(t5, n3, i3, a3, o3, s3) {
    if (isMatrix$1(t5)) {
      var c3 = t5.diagonal(n3);
      return i3 === null ? c3.valueOf() : i3 === c3.storage() ? c3 : r2(c3, i3);
    }
    for (var l2 = Math.min(a3[0] - o3, a3[1] - s3), u2 = [], d2 = 0; d2 < l2; d2++) u2[d2] = t5[d2 + o3][d2 + s3];
    return i3 === null ? u2 : r2(u2);
  }
}), name$230$1 = `filter`, dependencies$230$1 = [`typed`], createFilter$1 = factory$1(name$230$1, dependencies$230$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`filter`, { "Array, function": _filterCallback$1, "Matrix, function": function(t5, n3) {
    return t5.create(_filterCallback$1(t5.valueOf(), n3), t5.datatype());
  }, "Array, RegExp": filterRegExp$1, "Matrix, RegExp": function(t5, n3) {
    return t5.create(filterRegExp$1(t5.valueOf(), n3), t5.datatype());
  } });
});
function _filterCallback$1(t4, n2) {
  var r2 = optimizeCallback$1(n2, t4, `filter`);
  return r2.isUnary ? filter$1$1(t4, r2.fn) : filter$1$1(t4, function(t5, n3, i2) {
    return r2.fn(t5, [n3], i2);
  });
}
var name$229$1 = `flatten`, dependencies$229$1 = [`typed`], createFlatten$1 = factory$1(name$229$1, dependencies$229$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$229$1, { Array: function(t5) {
    return flatten$4$1(t5);
  }, DenseMatrix: function(t5) {
    return t5.create(flatten$4$1(t5.valueOf(), true), t5.datatype());
  }, SparseMatrix: function(t5) {
    throw TypeError(`SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())`);
  } });
}), name$228$1 = `forEach`, dependencies$228$1 = [`typed`], createForEach$1 = factory$1(name$228$1, dependencies$228$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$228$1, { "Array, function": _forEach$1, "Matrix, function": function(t5, n3) {
    t5.forEach(n3);
  } });
});
function _forEach$1(t4, n2) {
  var r2 = optimizeCallback$1(n2, t4, name$228$1);
  deepForEach$1$1(t4, r2.fn, r2.isUnary);
}
var name$227$1 = `getMatrixDataType`, dependencies$227$1 = [`typed`], createGetMatrixDataType$1 = factory$1(name$227$1, dependencies$227$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$227$1, { Array: function(t5) {
    return getArrayDataType$1(t5, typeOf$1);
  }, Matrix: function(t5) {
    return t5.getDataType();
  } });
}), name$226$1 = `identity`, dependencies$226$1 = [`typed`, `config`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`], createIdentity$1 = factory$1(name$226$1, dependencies$226$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2, DenseMatrix: o2, SparseMatrix: s2 } = t4;
  return n2(name$226$1, { "": function() {
    return r2.matrix === `Matrix` ? i2([]) : [];
  }, string: function(t5) {
    return i2(t5);
  }, "number | BigNumber": function(t5) {
    return l2(t5, t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, string": function(t5, n3) {
    return l2(t5, t5, n3);
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return l2(t5, n3, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(t5, n3, r3) {
    return l2(t5, n3, r3);
  }, Array: function(t5) {
    return c2(t5);
  }, "Array, string": function(t5, n3) {
    return c2(t5, n3);
  }, Matrix: function(t5) {
    return c2(t5.valueOf(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return c2(t5.valueOf(), n3);
  } });
  function c2(t5, n3) {
    switch (t5.length) {
      case 0:
        return n3 ? i2(n3) : [];
      case 1:
        return l2(t5[0], t5[0], n3);
      case 2:
        return l2(t5[0], t5[1], n3);
      default:
        throw Error(`Vector containing two values expected`);
    }
  }
  function l2(t5, n3, r3) {
    var i3 = isBigNumber$1(t5) || isBigNumber$1(n3) ? a2 : null;
    if (isBigNumber$1(t5) && (t5 = t5.toNumber()), isBigNumber$1(n3) && (n3 = n3.toNumber()), !isInteger$2(t5) || t5 < 1 || !isInteger$2(n3) || n3 < 1) throw Error(`Parameters in function identity must be positive integers`);
    var c3 = i3 ? new a2(1) : 1, l3 = i3 ? new i3(0) : 0, u2 = [t5, n3];
    if (r3) {
      if (r3 === `sparse`) return s2.diagonal(u2, c3, 0, l3);
      if (r3 === `dense`) return o2.diagonal(u2, c3, 0, l3);
      throw TypeError(`Unknown matrix type "${r3}"`);
    }
    for (var d2 = resize$1([], u2, l3), p2 = t5 < n3 ? t5 : n3, m2 = 0; m2 < p2; m2++) d2[m2][m2] = c3;
    return d2;
  }
}), name$225$1 = `kron`, dependencies$225$1 = [`typed`, `matrix`, `multiplyScalar`], createKron$1 = factory$1(name$225$1, dependencies$225$1, (t4) => {
  var { typed: n2, matrix: r2, multiplyScalar: i2 } = t4;
  return n2(name$225$1, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function a2(t5, n3) {
    return t5.flatMap((t6) => n3.map((n4) => i2(t6, n4)));
  }
  function o2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (r3 < 0) {
      var i3 = arraySize$1(t5).length, s2 = arraySize$1(n3).length;
      for (r3 = Math.max(i3, s2); i3++ < r3; ) t5 = [t5];
      for (; s2++ < r3; ) n3 = [n3];
    }
    return r3 === 1 ? a2(t5, n3) : t5.flatMap((t6) => n3.map((n4) => o2(t6, n4, r3 - 1)));
  }
}), name$224$1 = `map`, dependencies$224$1 = [`typed`], createMap$2 = factory$1(name$224$1, dependencies$224$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$224$1, { "Array, function": c2, "Matrix, function": function(t5, n3) {
    return t5.map(n3);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (t5, n3, i3) => r2([t5, n3, ...i3.slice(0, i3.length - 1)], i3[i3.length - 1]) });
  function r2(t5, r3) {
    if (typeof r3 != `function`) throw Error(`Last argument must be a callback function`);
    var l2 = t5[0].isMatrix, u2 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize$1(t6)), d2 = broadcastSizes$1(...u2), p2 = t5.length, m2 = l2 ? (t6, n3) => t6.get(n3) : get$1$1, h2 = t5.map((t6, n3) => {
      var r4 = u2[n3].map(() => 0);
      return t6.isMatrix ? t6.get(r4) : get$1$1(t6, r4);
    }), g2 = n2.isTypedFunction(r3) ? s2(r3, h2, d2.map(() => 0), t5) : o2(r3, p2);
    if (g2 < 2) return i2(t5, a2(g2, r3, null));
    var v2 = l2 ? t5.map((n3) => n3.isMatrix ? n3.create(broadcastTo$1(n3.toArray(), d2), n3.datatype()) : t5[0].create(broadcastTo$1(n3.valueOf(), d2))) : t5.map((t6) => t6.isMatrix ? broadcastTo$1(t6.toArray(), d2) : broadcastTo$1(t6, d2)), y2 = a2(g2, r3, v2), b2 = (t6, n3) => y2([t6, ...v2.slice(1).map((t7) => m2(t7, n3))], n3);
    return l2 ? v2[0].map(b2) : c2(v2[0], b2);
  }
  function i2(t5, n3) {
    var r3 = t5[0], i3 = t5.map((t6) => t6.isMatrix ? t6.valueOf() : t6), a3 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize$1(t6)), o3 = broadcastSizes$1(...a3), s3 = a3.map((t6) => o3.length - t6.length), c3 = o3.length - 1, l2 = n3.length > 1 ? [] : null, u2 = p2(i3, 0);
    if (r3.isMatrix) {
      var d2 = r3.create();
      return d2._data = u2, d2._size = o3, d2;
    } else return u2;
    function p2(t6) {
      var r4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i4 = o3[r4], a4 = Array(i4);
      if (r4 < c3) for (var u3 = function(n4) {
        l2 && (l2[r4] = n4), a4[n4] = p2(t6.map((t7, i5) => s3[i5] > r4 ? t7 : t7.length === 1 ? t7[0] : t7[n4]), r4 + 1);
      }, d3 = 0; d3 < i4; d3++) u3(d3);
      else for (var m2 = function(i5) {
        l2 && (l2[r4] = i5), a4[i5] = n3(t6.map((t7) => t7.length === 1 ? t7[0] : t7[i5]), l2 ? l2.slice() : void 0);
      }, h2 = 0; h2 < i4; h2++) m2(h2);
      return a4;
    }
  }
  function a2(t5, n3, r3) {
    switch (t5) {
      case 0:
        return (t6) => n3(...t6);
      case 1:
        return (t6, r4) => n3(...t6, r4);
      case 2:
        return (t6, i3) => n3(...t6, i3, ...r3);
    }
  }
  function o2(t5, n3) {
    var r3 = t5.toString();
    if (/arguments/.test(r3)) return 2;
    var i3 = r3.match(/\(.*?\)/);
    return /\.\.\./.test(i3) || t5.length > n3 + 1 ? 2 : +(t5.length === n3 + 1);
  }
  function s2(t5, r3, i3, a3) {
    return n2.resolve(t5, [...r3, i3, ...a3]) === null ? n2.resolve(t5, [...r3, i3]) === null ? (n2.resolve(t5, r3), 0) : 1 : 2;
  }
  function c2(t5, n3) {
    var r3 = optimizeCallback$1(n3, t5, name$224$1);
    return deepMap$1$1(t5, r3.fn, r3.isUnary);
  }
}), name$223$1 = `diff`, dependencies$223$1 = [`typed`, `matrix`, `subtract`, `number`], createDiff$1 = factory$1(name$223$1, dependencies$223$1, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2 } = t4;
  return n2(name$223$1, { "Array | Matrix": function(t5) {
    return isMatrix$1(t5) ? r2(s2(t5.toArray())) : s2(t5);
  }, "Array | Matrix, number": function(t5, n3) {
    if (!isInteger$2(n3)) throw RangeError(`Dimension must be a whole number`);
    return isMatrix$1(t5) ? r2(o2(t5.toArray(), n3)) : o2(t5, n3);
  }, "Array, BigNumber": n2.referTo(`Array,number`, (t5) => (n3, r3) => t5(n3, a2(r3))), "Matrix, BigNumber": n2.referTo(`Matrix,number`, (t5) => (n3, r3) => t5(n3, a2(r3))) });
  function o2(t5, n3) {
    if (isMatrix$1(t5) && (t5 = t5.toArray()), !Array.isArray(t5)) throw RangeError(`Array/Matrix does not have that many dimensions`);
    if (n3 > 0) {
      var r3 = [];
      return t5.forEach((t6) => {
        r3.push(o2(t6, n3 - 1));
      }), r3;
    } else if (n3 === 0) return s2(t5);
    else throw RangeError(`Cannot have negative dimension`);
  }
  function s2(t5) {
    for (var n3 = [], r3 = t5.length, i3 = 1; i3 < r3; i3++) n3.push(c2(t5[i3 - 1], t5[i3]));
    return n3;
  }
  function c2(t5, n3) {
    isMatrix$1(t5) && (t5 = t5.toArray()), isMatrix$1(n3) && (n3 = n3.toArray());
    var r3 = Array.isArray(t5), a3 = Array.isArray(n3);
    if (r3 && a3) return l2(t5, n3);
    if (!r3 && !a3) return i2(n3, t5);
    throw TypeError(`Cannot calculate difference between 1 array and 1 non-array`);
  }
  function l2(t5, n3) {
    if (t5.length !== n3.length) throw RangeError(`Not all sub-arrays have the same length`);
    for (var r3 = [], i3 = t5.length, a3 = 0; a3 < i3; a3++) r3.push(c2(t5[a3], n3[a3]));
    return r3;
  }
}), name$222$1 = `ones`, dependencies$222$1 = [`typed`, `config`, `matrix`, `BigNumber`], createOnes$1 = factory$1(name$222$1, dependencies$222$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(`ones`, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(1) : 1;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize$1(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber$1(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger$2(t6) || t6 < 0) throw Error(`Parameters in function ones must be positive integers`);
    });
  }
});
function noBignumber$1() {
  throw Error(`No "bignumber" implementation available`);
}
function noFraction$1() {
  throw Error(`No "fraction" implementation available`);
}
function noMatrix$1() {
  throw Error(`No "matrix" implementation available`);
}
var name$221$1 = `range`, dependencies$221$1 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRange$1 = factory$1(name$221$1, dependencies$221$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, smaller: o2, smallerEq: s2, larger: c2, largerEq: l2, add: u2, isZero: d2, isPositive: p2 } = t4;
  return n2(name$221$1, { string: h2, "string, boolean": h2, number: function(t5) {
    throw TypeError(`Too few arguments to function range(): ${t5}`);
  }, boolean: function(t5) {
    throw TypeError(`Unexpected type of argument 1 to function range(): ${t5}, number|bigint|BigNumber|Fraction`);
  }, "number, number": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "number, number, number": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "number, number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "number, number, number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "bigint, bigint|number": function(t5, n3) {
    return m2(g2(t5, n3, 1n, false));
  }, "number, bigint": function(t5, n3) {
    return m2(g2(BigInt(t5), n3, 1n, false));
  }, "bigint, bigint|number, bigint|number": function(t5, n3, r3) {
    return m2(g2(t5, n3, BigInt(r3), false));
  }, "number, bigint, bigint|number": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), false));
  }, "bigint, bigint|number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1n, r3));
  }, "number, bigint, boolean": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, 1n, r3));
  }, "bigint, bigint|number, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, BigInt(r3), i3));
  }, "number, bigint, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), i3));
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = t5.constructor;
    return m2(g2(t5, n3, new r3(1), false));
  }, "BigNumber, BigNumber, BigNumber": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "BigNumber, BigNumber, boolean": function(t5, n3, r3) {
    var i3 = t5.constructor;
    return m2(g2(t5, n3, new i3(1), r3));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Fraction, Fraction": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "Fraction, Fraction, Fraction": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Fraction, Fraction, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "Fraction, Fraction, Fraction, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Unit, Unit, Unit": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Unit, Unit, Unit, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  } });
  function m2(t5) {
    return r2.matrix === `Matrix` ? i2 ? i2(t5) : noMatrix$1() : t5;
  }
  function h2(t5, n3) {
    var i3 = v2(t5);
    if (!i3) throw SyntaxError(`String "` + t5 + `" is no valid range`);
    return r2.number === `BigNumber` ? (a2 === void 0 && noBignumber$1(), m2(g2(a2(i3.start), a2(i3.end), a2(i3.step)))) : m2(g2(i3.start, i3.end, i3.step, n3));
  }
  function g2(t5, n3, r3, i3) {
    var a3 = [];
    if (d2(r3)) throw Error(`Step must be non-zero`);
    for (var m3 = p2(r3) ? i3 ? s2 : o2 : i3 ? l2 : c2, h3 = t5; m3(h3, n3); ) a3.push(h3), h3 = u2(h3, r3);
    return a3;
  }
  function v2(t5) {
    var n3 = t5.split(`:`).map(function(t6) {
      return Number(t6);
    });
    if (n3.some(function(t6) {
      return isNaN(t6);
    })) return null;
    switch (n3.length) {
      case 2:
        return { start: n3[0], end: n3[1], step: 1 };
      case 3:
        return { start: n3[0], end: n3[2], step: n3[1] };
      default:
        return null;
    }
  }
}), name$220$1 = `reshape`, dependencies$220$1 = [`typed`, `isInteger`, `matrix`], createReshape$1 = factory$1(name$220$1, dependencies$220$1, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$220$1, { "Matrix, Array": function(t5, n3) {
    return t5.reshape(n3, true);
  }, "Array, Array": function(t5, n3) {
    return n3.forEach(function(t6) {
      if (!r2(t6)) throw TypeError(`Invalid size for dimension: ` + t6);
    }), reshape$1(t5, n3);
  } });
}), name$219$1 = `resize`, dependencies$219$1 = [`config`, `matrix`], createResize$1 = factory$1(name$219$1, dependencies$219$1, (t4) => {
  var { config: n2, matrix: r2 } = t4;
  return function(t5, a2, o2) {
    if (arguments.length !== 2 && arguments.length !== 3) throw new ArgumentsError$1(`resize`, arguments.length, 2, 3);
    if (isMatrix$1(a2) && (a2 = a2.valueOf()), isBigNumber$1(a2[0]) && (a2 = a2.map(function(t6) {
      return isBigNumber$1(t6) ? t6.toNumber() : t6;
    })), isMatrix$1(t5)) return t5.resize(a2, o2, true);
    if (typeof t5 == `string`) return i2(t5, a2, o2);
    var s2 = Array.isArray(t5) ? false : n2.matrix !== `Array`;
    if (a2.length === 0) {
      for (; Array.isArray(t5); ) t5 = t5[0];
      return clone$3$1(t5);
    } else {
      Array.isArray(t5) || (t5 = [t5]), t5 = clone$3$1(t5);
      var c2 = resize$1(t5, a2, o2);
      return s2 ? r2(c2) : c2;
    }
  };
  function i2(t5, n3, r3) {
    if (r3 !== void 0) {
      if (typeof r3 != `string` || r3.length !== 1) throw TypeError(`Single character expected as defaultValue`);
    } else r3 = ` `;
    if (n3.length !== 1) throw new DimensionError$1(n3.length, 1);
    var i3 = n3[0];
    if (typeof i3 != `number` || !isInteger$2(i3)) throw TypeError(`Invalid size, must contain positive integers (size: ` + format$3(n3) + `)`);
    if (t5.length > i3) return t5.substring(0, i3);
    if (t5.length < i3) {
      for (var a2 = t5, o2 = 0, s2 = i3 - t5.length; o2 < s2; o2++) a2 += r3;
      return a2;
    } else return t5;
  }
}), name$218$1 = `rotate`, dependencies$218$1 = [`typed`, `multiply`, `rotationMatrix`], createRotate$1 = factory$1(name$218$1, dependencies$218$1, (t4) => {
  var { typed: n2, multiply: r2, rotationMatrix: i2 } = t4;
  return n2(name$218$1, { "Array , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  } });
  function a2(t5, n3) {
    var r3 = Array.isArray(t5) ? arraySize$1(t5) : t5.size();
    if (r3.length > 2 || r3.length === 2 && r3[1] !== 1 || r3[0] !== n3) throw RangeError(`Vector must be of dimensions 1x${n3}`);
  }
}), name$217$1 = `rotationMatrix`, dependencies$217$1 = [`typed`, `config`, `multiplyScalar`, `addScalar`, `unaryMinus`, `norm`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`, `cos`, `sin`], createRotationMatrix$1 = factory$1(name$217$1, dependencies$217$1, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, addScalar: a2, unaryMinus: o2, norm: s2, BigNumber: c2, matrix: l2, DenseMatrix: u2, SparseMatrix: d2, cos: p2, sin: m2 } = t4;
  return n2(name$217$1, { "": function() {
    return r2.matrix === `Matrix` ? l2([]) : [];
  }, string: function(t5) {
    return l2(t5);
  }, "number | BigNumber | Complex | Unit": function(t5) {
    return h2(t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(t5, n3) {
    return h2(t5, n3);
  }, "number | BigNumber | Complex | Unit, Array": function(t5, n3) {
    var r3 = l2(n3);
    return g2(r3), b2(t5, r3, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(t5, n3) {
    return g2(n3), b2(t5, n3, n3.storage() || (r2.matrix === `Matrix` ? `dense` : void 0));
  }, "number | BigNumber | Complex | Unit, Array, string": function(t5, n3, r3) {
    var i3 = l2(n3);
    return g2(i3), b2(t5, i3, r3);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(t5, n3, r3) {
    return g2(n3), b2(t5, n3, r3);
  } });
  function h2(t5, n3) {
    var r3 = isBigNumber$1(t5) ? new c2(-1) : -1, a3 = p2(t5), o3 = m2(t5);
    return y2([[a3, i2(r3, o3)], [o3, a3]], n3);
  }
  function g2(t5) {
    var n3 = t5.size();
    if (n3.length < 1 || n3[0] !== 3) throw RangeError(`Vector must be of dimensions 1x3`);
  }
  function v2(t5) {
    return t5.reduce((t6, n3) => i2(t6, n3));
  }
  function y2(t5, n3) {
    if (n3) {
      if (n3 === `sparse`) return new d2(t5);
      if (n3 === `dense`) return new u2(t5);
      throw TypeError(`Unknown matrix type "${n3}"`);
    }
    return t5;
  }
  function b2(t5, n3, r3) {
    var i3 = s2(n3);
    if (i3 === 0) throw RangeError(`Rotation around zero vector`);
    var l3 = isBigNumber$1(t5) ? c2 : null, u3 = l3 ? new l3(1) : 1, d3 = l3 ? new l3(-1) : -1, h3 = l3 ? new l3(n3.get([0]) / i3) : n3.get([0]) / i3, g3 = l3 ? new l3(n3.get([1]) / i3) : n3.get([1]) / i3, b3 = l3 ? new l3(n3.get([2]) / i3) : n3.get([2]) / i3, x2 = p2(t5), S2 = a2(u3, o2(x2)), w2 = m2(t5), E = a2(x2, v2([h3, h3, S2])), D = a2(v2([h3, g3, S2]), v2([d3, b3, w2])), O2 = a2(v2([h3, b3, S2]), v2([g3, w2])), j2 = a2(v2([h3, g3, S2]), v2([b3, w2])), M2 = a2(x2, v2([g3, g3, S2])), N2 = a2(v2([g3, b3, S2]), v2([d3, h3, w2])), F = a2(v2([h3, b3, S2]), v2([d3, g3, w2])), I2 = a2(v2([g3, b3, S2]), v2([h3, w2])), L2 = a2(x2, v2([b3, b3, S2]));
    return y2([[E, D, O2], [j2, M2, N2], [F, I2, L2]], r3);
  }
}), name$216$1 = `row`, dependencies$216$1 = [`typed`, `Index`, `matrix`, `range`], createRow$1 = factory$1(name$216$1, dependencies$216$1, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$216$1, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3$1(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex$1(n3, t5.size()[0]);
    var o3 = a2(0, t5.size()[1]), s2 = new r2([n3], o3), c2 = t5.subset(s2);
    return isMatrix$1(c2) ? c2 : i2([[c2]]);
  }
}), name$215$1 = `size`, dependencies$215$1 = [`typed`], createSize$1 = factory$1(name$215$1, dependencies$215$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$215$1, { Matrix: (t5) => t5.size(), Array: arraySize$1, string: (t5) => [t5.length], "number | Complex | BigNumber | Unit | boolean | null": (t5) => [] });
}), name$214$1 = `squeeze`, dependencies$214$1 = [`typed`], createSqueeze$1 = factory$1(name$214$1, dependencies$214$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$214$1, { Array: function(t5) {
    return squeeze$1(clone$3$1(t5));
  }, Matrix: function(t5) {
    var n3 = squeeze$1(t5.toArray());
    return Array.isArray(n3) ? t5.create(n3, t5.datatype()) : n3;
  }, any: function(t5) {
    return clone$3$1(t5);
  } });
}), name$213$1 = `subset`, dependencies$213$1 = [`typed`, `matrix`, `zeros`, `add`], createSubset$1 = factory$1(name$213$1, dependencies$213$1, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4;
  return n2(name$213$1, { "Matrix, Index": function(t5, n3) {
    return isEmptyIndex$1(n3) ? r2() : (validateIndexSourceSize$1(t5, n3), t5.subset(n3));
  }, "Array, Index": n2.referTo(`Matrix, Index`, function(t5) {
    return function(n3, i3) {
      var a3 = t5(r2(n3), i3);
      return i3.isScalar() ? a3 : a3.valueOf();
    };
  }), "Object, Index": _getObjectProperty$1, "string, Index": _getSubstring$1, "Matrix, Index, any, any": function(t5, n3, r3, i3) {
    return isEmptyIndex$1(n3) ? t5 : (validateIndexSourceSize$1(t5, n3), t5.clone().subset(n3, o2(r3, n3), i3));
  }, "Array, Index, any, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3, o3) {
      var s2 = t5(r2(n3), i3, a3, o3);
      return s2.isMatrix ? s2.valueOf() : s2;
    };
  }), "Array, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3) {
      return t5(r2(n3), i3, a3, void 0).valueOf();
    };
  }), "Matrix, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, r3, i3) {
      return t5(n3, r3, i3, void 0);
    };
  }), "string, Index, string": _setSubstring$1, "string, Index, string, string": _setSubstring$1, "Object, Index, any": _setObjectProperty$1 });
  function o2(t5, n3) {
    if (typeof t5 == `string`) throw Error(`can't boradcast a string`);
    if (n3.isScalar()) return t5;
    var r3 = n3.size();
    if (r3.every((t6) => t6 > 0)) try {
      return a2(t5, i2(r3));
    } catch {
      return t5;
    }
    else return t5;
  }
});
function _getSubstring$1(t4, n2) {
  if (!isIndex$1(n2)) throw TypeError(`Index expected`);
  if (isEmptyIndex$1(n2)) return ``;
  if (validateIndexSourceSize$1(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError$1(n2.size().length, 1);
  var r2 = t4.length;
  validateIndex$1(n2.min()[0], r2), validateIndex$1(n2.max()[0], r2);
  var i2 = n2.dimension(0), a2 = ``;
  function o2(n3) {
    a2 += t4.charAt(n3);
  }
  return Number.isInteger(i2) ? o2(i2) : i2.forEach(o2), a2;
}
function _setSubstring$1(t4, n2, r2, i2) {
  if (!n2 || n2.isIndex !== true) throw TypeError(`Index expected`);
  if (isEmptyIndex$1(n2)) return t4;
  if (validateIndexSourceSize$1(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError$1(n2.size().length, 1);
  if (i2 !== void 0) {
    if (typeof i2 != `string` || i2.length !== 1) throw TypeError(`Single character expected as defaultValue`);
  } else i2 = ` `;
  var a2 = n2.dimension(0);
  if ((Number.isInteger(a2) ? 1 : a2.size()[0]) !== r2.length) throw new DimensionError$1(a2.size()[0], r2.length);
  var o2 = t4.length;
  validateIndex$1(n2.min()[0]), validateIndex$1(n2.max()[0]);
  for (var s2 = [], c2 = 0; c2 < o2; c2++) s2[c2] = t4.charAt(c2);
  function l2(t5, n3) {
    s2[t5] = r2.charAt(n3[0]);
  }
  if (Number.isInteger(a2) ? l2(a2, [0]) : a2.forEach(l2), s2.length > o2) for (var u2 = o2 - 1, d2 = s2.length; u2 < d2; u2++) s2[u2] || (s2[u2] = i2);
  return s2.join(``);
}
function _getObjectProperty$1(t4, n2) {
  if (!isEmptyIndex$1(n2)) {
    if (n2.size().length !== 1) throw new DimensionError$1(n2.size(), 1);
    var r2 = n2.dimension(0);
    if (typeof r2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
    return getSafeProperty$1(t4, r2);
  }
}
function _setObjectProperty$1(t4, n2, r2) {
  if (isEmptyIndex$1(n2)) return t4;
  if (n2.size().length !== 1) throw new DimensionError$1(n2.size(), 1);
  var i2 = n2.dimension(0);
  if (typeof i2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
  var a2 = clone$3$1(t4);
  return setSafeProperty$1(a2, i2, r2), a2;
}
var name$212$1 = `transpose`, dependencies$212$1 = [`typed`, `matrix`], createTranspose$1 = factory$1(name$212$1, dependencies$212$1, (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return n2(name$212$1, { Array: (t5) => i2(r2(t5)).valueOf(), Matrix: i2, any: clone$3$1 });
  function i2(t5) {
    var n3 = t5.size(), r3;
    switch (n3.length) {
      case 1:
        r3 = t5.clone();
        break;
      case 2:
        var i3 = n3[0], s2 = n3[1];
        if (s2 === 0) throw RangeError(`Cannot transpose a 2D matrix with no columns (size: ` + format$3(n3) + `)`);
        switch (t5.storage()) {
          case `dense`:
            r3 = a2(t5, i3, s2);
            break;
          case `sparse`:
            r3 = o2(t5, i3, s2);
            break;
        }
        break;
      default:
        throw RangeError(`Matrix must be a vector or two dimensional (size: ` + format$3(n3) + `)`);
    }
    return r3;
  }
  function a2(t5, n3, r3) {
    for (var i3 = t5._data, a3 = [], o3, s2 = 0; s2 < r3; s2++) {
      o3 = a3[s2] = [];
      for (var c2 = 0; c2 < n3; c2++) o3[c2] = clone$3$1(i3[c2][s2]);
    }
    return t5.createDenseMatrix({ data: a3, size: [r3, n3], datatype: t5._datatype });
  }
  function o2(t5, n3, r3) {
    for (var i3 = t5._values, a3 = t5._index, o3 = t5._ptr, s2 = i3 ? [] : void 0, c2 = [], l2 = [], u2 = [], d2 = 0; d2 < n3; d2++) u2[d2] = 0;
    var p2, m2, h2;
    for (p2 = 0, m2 = a3.length; p2 < m2; p2++) u2[a3[p2]]++;
    for (var g2 = 0, v2 = 0; v2 < n3; v2++) l2.push(g2), g2 += u2[v2], u2[v2] = l2[v2];
    for (l2.push(g2), h2 = 0; h2 < r3; h2++) for (var y2 = o3[h2], b2 = o3[h2 + 1], x2 = y2; x2 < b2; x2++) {
      var S2 = u2[a3[x2]]++;
      c2[S2] = h2, i3 && (s2[S2] = clone$3$1(i3[x2]));
    }
    return t5.createSparseMatrix({ values: s2, index: c2, ptr: l2, size: [r3, n3], datatype: t5._datatype });
  }
}), name$211$1 = `ctranspose`, dependencies$211$1 = [`typed`, `transpose`, `conj`], createCtranspose$1 = factory$1(name$211$1, dependencies$211$1, (t4) => {
  var { typed: n2, transpose: r2, conj: i2 } = t4;
  return n2(name$211$1, { any: function(t5) {
    return i2(r2(t5));
  } });
}), name$210$1 = `zeros`, dependencies$210$1 = [`typed`, `config`, `matrix`, `BigNumber`], createZeros$1 = factory$1(name$210$1, dependencies$210$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$210$1, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(0) : 0;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize$1(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber$1(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger$2(t6) || t6 < 0) throw Error(`Parameters in function zeros must be positive integers`);
    });
  }
}), name$209$1 = `fft`, dependencies$209$1 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `divideScalar`, `exp`, `tau`, `i`, `dotDivide`, `conj`, `pow`, `ceil`, `log2`], createFft$1 = factory$1(name$209$1, dependencies$209$1, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, divideScalar: o2, exp: s2, tau: c2, i: l2, dotDivide: u2, conj: d2, pow: p2, ceil: m2, log2: h2 } = t4;
  return n2(name$209$1, { Array: g2, Matrix: function(t5) {
    return t5.create(g2(t5.valueOf()), t5.datatype());
  } });
  function g2(t5) {
    var n3 = arraySize$1(t5);
    return n3.length === 1 ? b2(t5, n3[0]) : v2(t5.map((t6) => g2(t6, n3.slice(1))), 0);
  }
  function v2(t5, n3) {
    var r3 = arraySize$1(t5);
    if (n3 !== 0) return Array(r3[0]).fill(0).map((r4, i4) => v2(t5[i4], n3 - 1));
    if (r3.length === 1) return b2(t5);
    function i3(t6) {
      var n4 = arraySize$1(t6);
      return Array(n4[1]).fill(0).map((r4, i4) => Array(n4[0]).fill(0).map((n5, r5) => t6[r5][i4]));
    }
    return i3(v2(i3(t5), 1));
  }
  function y2(t5) {
    for (var n3 = t5.length, r3 = s2(o2(a2(-1, a2(l2, c2)), n3)), i3 = [], v3 = 1 - n3; v3 < n3; v3++) i3.push(p2(r3, o2(p2(v3, 2), 2)));
    for (var y3 = p2(2, m2(h2(n3 + n3 - 1))), x2 = [...Array(n3).fill(0).map((r4, o3) => a2(t5[o3], i3[n3 - 1 + o3])), ...Array(y3 - n3).fill(0)], S2 = [...Array(n3 + n3 - 1).fill(0).map((t6, n4) => o2(1, i3[n4])), ...Array(y3 - (n3 + n3 - 1)).fill(0)], w2 = b2(x2), E = b2(S2), D = u2(d2(g2(d2(Array(y3).fill(0).map((t6, n4) => a2(w2[n4], E[n4]))))), y3), O2 = [], j2 = n3 - 1; j2 < n3 + n3 - 1; j2++) O2.push(a2(D[j2], i3[j2]));
    return O2;
  }
  function b2(t5) {
    var n3 = t5.length;
    if (n3 === 1) return [t5[0]];
    if (n3 % 2 == 0) {
      for (var r3 = [...b2(t5.filter((t6, n4) => n4 % 2 == 0)), ...b2(t5.filter((t6, n4) => n4 % 2 == 1))], u3 = 0; u3 < n3 / 2; u3++) {
        var d3 = r3[u3], p3 = a2(r3[u3 + n3 / 2], s2(a2(a2(c2, l2), o2(-u3, n3))));
        r3[u3] = i2(d3, p3), r3[u3 + n3 / 2] = i2(d3, a2(-1, p3));
      }
      return r3;
    } else return y2(t5);
  }
}), name$208$1 = `ifft`, dependencies$208$1 = [`typed`, `fft`, `dotDivide`, `conj`], createIfft$1 = factory$1(name$208$1, dependencies$208$1, (t4) => {
  var { typed: n2, fft: r2, dotDivide: i2, conj: a2 } = t4;
  return n2(name$208$1, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$1(t5) ? t5.size() : arraySize$1(t5);
    return i2(a2(r2(a2(t5))), n3.reduce((t6, n4) => t6 * n4, 1));
  } });
});
function _typeof$1(t4) {
  "@babel/helpers - typeof";
  return _typeof$1 = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(t5) {
    return typeof t5;
  } : function(t5) {
    return t5 && typeof Symbol == `function` && t5.constructor === Symbol && t5 !== Symbol.prototype ? `symbol` : typeof t5;
  }, _typeof$1(t4);
}
function toPrimitive$1(t4, n2) {
  if (_typeof$1(t4) != `object` || !t4) return t4;
  var r2 = t4[Symbol.toPrimitive];
  if (r2 !== void 0) {
    var i2 = r2.call(t4, n2);
    if (_typeof$1(i2) != `object`) return i2;
    throw TypeError(`@@toPrimitive must return a primitive value.`);
  }
  return (n2 === `string` ? String : Number)(t4);
}
function toPropertyKey$1(t4) {
  var n2 = toPrimitive$1(t4, `string`);
  return _typeof$1(n2) == `symbol` ? n2 : n2 + ``;
}
function _defineProperty$2(t4, n2, r2) {
  return (n2 = toPropertyKey$1(n2)) in t4 ? Object.defineProperty(t4, n2, { value: r2, enumerable: true, configurable: true, writable: true }) : t4[n2] = r2, t4;
}
function ownKeys$3$1(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$3$1(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$3$1(Object(r2), true).forEach(function(n3) {
      _defineProperty$2(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$3$1(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$207$1 = `solveODE`, dependencies$207$1 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `max`, `map`, `abs`, `isPositive`, `isNegative`, `larger`, `smaller`, `matrix`, `bignumber`, `unaryMinus`], createSolveODE$1 = factory$1(name$207$1, dependencies$207$1, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, max: s2, map: c2, abs: l2, isPositive: u2, isNegative: d2, larger: p2, smaller: m2, matrix: h2, bignumber: g2, unaryMinus: v2 } = t4;
  function y2(t5) {
    return function(n3, h3, y3, b3) {
      if (!(h3.length === 2 && (h3.every(D) || h3.every(isUnit$1)))) throw Error(`"tspan" must be an Array of two numeric values or two units [tStart, tEnd]`);
      var x3 = h3[0], S3 = h3[1], O22 = p2(S3, x3), j2 = b3.firstStep;
      if (j2 !== void 0 && !u2(j2)) throw Error(`"firstStep" must be positive`);
      var M2 = b3.maxStep;
      if (M2 !== void 0 && !u2(M2)) throw Error(`"maxStep" must be positive`);
      var N2 = b3.minStep;
      if (N2 && d2(N2)) throw Error(`"minStep" must be positive or zero`);
      var F = [x3, S3, j2, N2, M2].filter((t6) => t6 !== void 0);
      if (!(F.every(D) || F.every(isUnit$1))) throw Error(`Inconsistent type of "t" dependant variables`);
      for (var I2 = 1, L2 = b3.tol ? b3.tol : 1e-4, R2 = b3.minDelta ? b3.minDelta : 0.2, z2 = b3.maxDelta ? b3.maxDelta : 5, V2 = b3.maxIter ? b3.maxIter : 1e4, H2 = [x3, S3, ...y3, M2, N2].some(isBigNumber$1), [U2, W2, G2, K2] = H2 ? [g2(t5.a), g2(t5.c), g2(t5.b), g2(t5.bp)] : [t5.a, t5.c, t5.b, t5.bp], q2 = j2 ? O22 ? j2 : v2(j2) : o2(i2(S3, x3), I2), J = [x3], ee2 = [y3], Y2 = i2(G2, K2), te2 = 0, ne2 = 0, X2 = w2(O22), ie2 = E(O22); X2(J[te2], S3); ) {
        var ae2 = [];
        q2 = ie2(J[te2], S3, q2), ae2.push(n3(J[te2], ee2[te2]));
        for (var Z2 = 1; Z2 < W2.length; ++Z2) ae2.push(n3(r2(J[te2], a2(W2[Z2], q2)), r2(ee2[te2], a2(q2, U2[Z2], ae2))));
        var oe2 = s2(l2(c2(a2(Y2, ae2), (t6) => isUnit$1(t6) ? t6.value : t6)));
        oe2 < L2 && L2 / oe2 > 1 / 4 && (J.push(r2(J[te2], q2)), ee2.push(r2(ee2[te2], a2(q2, G2, ae2))), te2++);
        var $2 = 0.84 * (L2 / oe2) ** (1 / 5);
        if (m2($2, R2) ? $2 = R2 : p2($2, z2) && ($2 = z2), $2 = H2 ? g2($2) : $2, q2 = a2(q2, $2), M2 && p2(l2(q2), M2) ? q2 = O22 ? M2 : v2(M2) : N2 && m2(l2(q2), N2) && (q2 = O22 ? N2 : v2(N2)), ne2++, ne2 > V2) throw Error(`Maximum number of iterations reached, try changing options`);
      }
      return { t: J, y: ee2 };
    };
  }
  function b2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 2], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 1 / 2, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(t5, n3, r3, i3);
  }
  function x2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 5], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(t5, n3, r3, i3);
  }
  function S2(t5, n3, r3, i3) {
    var a3 = i3.method ? i3.method : `RK45`, o3 = { RK23: b2, RK45: x2 };
    if (a3.toUpperCase() in o3) {
      var s3 = _objectSpread$3$1({}, i3);
      return delete s3.method, o3[a3.toUpperCase()](t5, n3, r3, s3);
    } else {
      var c3 = Object.keys(o3).map((t6) => `"${t6}"`), l3 = `${c3.slice(0, -1).join(`, `)} and ${c3.slice(-1)}`;
      throw Error(`Unavailable method "${a3}". Available methods are ${l3}`);
    }
  }
  function w2(t5) {
    return t5 ? m2 : p2;
  }
  function E(t5) {
    var n3 = t5 ? p2 : m2;
    return function(t6, a3, o3) {
      return n3(r2(t6, o3), a3) ? i2(a3, t6) : o3;
    };
  }
  function D(t5) {
    return isBigNumber$1(t5) || isNumber$1(t5);
  }
  function O2(t5, n3, r3, i3) {
    var a3 = S2(t5, n3.toArray(), r3.toArray(), i3);
    return { t: h2(a3.t), y: h2(a3.y) };
  }
  return n2(`solveODE`, { "function, Array, Array, Object": S2, "function, Matrix, Matrix, Object": O2, "function, Array, Array": (t5, n3, r3) => S2(t5, n3, r3, {}), "function, Matrix, Matrix": (t5, n3, r3) => O2(t5, n3, r3, {}), "function, Array, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3, [r3], {});
    return { t: i3.t, y: i3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3.toArray(), [r3], {});
    return { t: h2(i3.t), y: h2(i3.y.map((t6) => t6[0])) };
  }, "function, Array, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3, [r3], i3);
    return { t: a3.t, y: a3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3.toArray(), [r3], i3);
    return { t: h2(a3.t), y: h2(a3.y.map((t6) => t6[0])) };
  } });
}), name$206$1 = `erf`, dependencies$206$1 = [`typed`], createErf$1 = factory$1(name$206$1, dependencies$206$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`name`, { number: function(t5) {
    var n3 = Math.abs(t5);
    return n3 >= MAX_NUM$1 ? sign$2$1(t5) : n3 <= THRESH$1 ? sign$2$1(t5) * r2(n3) : n3 <= 4 ? sign$2$1(t5) * (1 - i2(n3)) : sign$2$1(t5) * (1 - a2(n3));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
  function r2(t5) {
    var n3 = t5 * t5, r3 = P$4[0][4] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 3; a3 += 1) r3 = (r3 + P$4[0][a3]) * n3, i3 = (i3 + Q$2[0][a3]) * n3;
    return t5 * (r3 + P$4[0][3]) / (i3 + Q$2[0][3]);
  }
  function i2(t5) {
    var n3 = P$4[1][8] * t5, r3 = t5, i3;
    for (i3 = 0; i3 < 7; i3 += 1) n3 = (n3 + P$4[1][i3]) * t5, r3 = (r3 + Q$2[1][i3]) * t5;
    var a3 = (n3 + P$4[1][7]) / (r3 + Q$2[1][7]), o2 = parseInt(t5 * 16) / 16, s2 = (t5 - o2) * (t5 + o2);
    return Math.exp(-o2 * o2) * Math.exp(-s2) * a3;
  }
  function a2(t5) {
    var n3 = 1 / (t5 * t5), r3 = P$4[2][5] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 4; a3 += 1) r3 = (r3 + P$4[2][a3]) * n3, i3 = (i3 + Q$2[2][a3]) * n3;
    var o2 = n3 * (r3 + P$4[2][4]) / (i3 + Q$2[2][4]);
    o2 = (SQRPI$1 - o2) / t5, n3 = parseInt(t5 * 16) / 16;
    var s2 = (t5 - n3) * (t5 + n3);
    return Math.exp(-n3 * n3) * Math.exp(-s2) * o2;
  }
}), THRESH$1 = 0.46875, SQRPI$1 = 0.5641895835477563, P$4 = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q$2 = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM$1 = 2 ** 53, name$205$1 = `zeta`, dependencies$205$1 = [`typed`, `config`, `multiply`, `pow`, `divide`, `factorial`, `equal`, `smallerEq`, `isBounded`, `isNegative`, `gamma`, `sin`, `subtract`, `add`, `?Complex`, `?BigNumber`, `pi`], createZeta$1 = factory$1(name$205$1, dependencies$205$1, (t4) => {
  var { typed: n2, config: r2, multiply: i2, pow: a2, divide: o2, factorial: s2, equal: c2, smallerEq: l2, isBounded: u2, isNegative: d2, gamma: p2, sin: m2, subtract: h2, add: g2, Complex: v2, BigNumber: y2, pi: b2 } = t4;
  return n2(name$205$1, { number: (t5) => x2(t5, (t6) => t6, () => 20), BigNumber: (t5) => x2(t5, (t6) => new y2(t6), () => Math.abs(Math.log10(r2.relTol))), Complex: S2 });
  function x2(t5, n3, r3) {
    return c2(t5, 0) ? n3(-0.5) : c2(t5, 1) ? n3(NaN) : u2(t5) ? w2(t5, n3, r3, (t6) => t6) : d2(t5) ? n3(NaN) : n3(1);
  }
  function S2(t5) {
    return t5.re === 0 && t5.im === 0 ? new v2(-0.5) : t5.re === 1 ? new v2(NaN, NaN) : t5.re === 1 / 0 && t5.im === 0 ? new v2(1) : t5.im === 1 / 0 || t5.re === -1 / 0 ? new v2(NaN, NaN) : w2(t5, (t6) => t6, (t6) => Math.round(1.3 * 15 + 0.9 * Math.abs(t6.im)), (t6) => t6.re);
  }
  function w2(t5, n3, r3, s3) {
    var c3 = r3(t5);
    if (s3(t5) > -(c3 - 1) / 2) return D(t5, n3(c3), n3);
    var l3 = i2(a2(2, t5), a2(n3(b2), h2(t5, 1)));
    return l3 = i2(l3, m2(i2(o2(n3(b2), 2), t5))), l3 = i2(l3, p2(h2(1, t5))), i2(l3, w2(h2(1, t5), n3, r3, s3));
  }
  function E(t5, n3) {
    for (var r3 = t5, c3 = t5; l2(c3, n3); c3 = g2(c3, 1)) {
      var u3 = o2(i2(s2(g2(n3, h2(c3, 1))), a2(4, c3)), i2(s2(h2(n3, c3)), s2(i2(2, c3))));
      r3 = g2(r3, u3);
    }
    return i2(n3, r3);
  }
  function D(t5, n3, r3) {
    for (var s3 = o2(1, i2(E(r3(0), n3), h2(1, a2(2, h2(1, t5))))), c3 = r3(0), u3 = r3(1); l2(u3, n3); u3 = g2(u3, 1)) c3 = g2(c3, o2(i2((-1) ** (u3 - 1), E(u3, n3)), a2(u3, t5)));
    return i2(s3, c3);
  }
}), name$204$1 = `mode`, dependencies$204$1 = [`typed`, `isNaN`, `isNumeric`], createMode$1 = factory$1(name$204$1, dependencies$204$1, (t4) => {
  var { typed: n2, isNaN: r2, isNumeric: i2 } = t4;
  return n2(name$204$1, { "Array | Matrix": a2, "...": function(t5) {
    return a2(t5);
  } });
  function a2(t5) {
    if (t5 = flatten$4$1(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate mode of an empty array`);
    for (var n3 = {}, a3 = [], o2 = 0, s2 = 0; s2 < t5.length; s2++) {
      var c2 = t5[s2];
      if (i2(c2) && r2(c2)) throw Error(`Cannot calculate mode of an array containing NaN values`);
      c2 in n3 || (n3[c2] = 0), n3[c2]++, n3[c2] === o2 ? a3.push(c2) : n3[c2] > o2 && (o2 = n3[c2], a3 = [c2]);
    }
    return a3;
  }
});
function improveErrorMessage$1(t4, n2, r2) {
  var i2;
  return String(t4).includes(`Unexpected type`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf$1(r2) + `, value: ` + JSON.stringify(r2) + `)` : ` (type: ` + t4.data.actual + `)`, TypeError(`Cannot calculate ` + n2 + `, unexpected type of argument` + i2)) : String(t4).includes(`complex numbers`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf$1(r2) + `, value: ` + JSON.stringify(r2) + `)` : ``, TypeError(`Cannot calculate ` + n2 + `, no ordering relation is defined for complex numbers` + i2)) : t4;
}
var name$203$1 = `prod`, dependencies$203$1 = [`typed`, `config`, `multiplyScalar`, `numeric`], createProd$1 = factory$1(name$203$1, dependencies$203$1, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, numeric: a2 } = t4;
  return n2(name$203$1, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`prod(A, dim) is not yet supported`);
  }, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    if (deepForEach$2(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage$1(n4, `prod`, t6);
      }
    }), typeof n3 == `string` && (n3 = a2(n3, safeNumberType$1(n3, r2))), n3 === void 0) throw Error(`Cannot calculate prod of an empty array`);
    return n3;
  }
}), name$202$1 = `format`, dependencies$202$1 = [`typed`], createFormat$1 = factory$1(name$202$1, dependencies$202$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$202$1, { any: format$3, "any, Object | function | number | BigNumber": format$3 });
}), name$201$1 = `bin`, dependencies$201$1 = [`typed`, `format`], createBin$1 = factory$1(name$201$1, dependencies$201$1, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$201$1, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `bin` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `bin`, wordSize: n3 });
  } });
}), name$200$1 = `oct`, dependencies$200$1 = [`typed`, `format`], createOct$1 = factory$1(name$200$1, dependencies$200$1, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$200$1, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `oct` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `oct`, wordSize: n3 });
  } });
}), name$199$1 = `hex`, dependencies$199$1 = [`typed`, `format`], createHex$1 = factory$1(name$199$1, dependencies$199$1, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$199$1, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `hex` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `hex`, wordSize: n3 });
  } });
}), printTemplate$1 = /\$([\w.]+)/g, name$198$1 = `print`, dependencies$198$1 = [`typed`], createPrint$1 = factory$1(name$198$1, dependencies$198$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$198$1, { "string, Object | Array": _print$1, "string, Object | Array, number | Object": _print$1 });
});
function _print$1(t4, n2, r2) {
  return t4.replace(printTemplate$1, function(t5, i2) {
    var a2 = i2.split(`.`), o2 = n2[a2.shift()];
    for (o2 !== void 0 && o2.isMatrix && (o2 = o2.toArray()); a2.length && o2 !== void 0; ) {
      var s2 = a2.shift();
      o2 = s2 ? o2[s2] : o2 + `.`;
    }
    return o2 === void 0 ? t5 : isString$1(o2) ? o2 : format$3(o2, r2);
  });
}
var name$197$1 = `to`, dependencies$197$1 = [`typed`, `matrix`, `concat`], createTo$1 = factory$1(name$197$1, dependencies$197$1, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$197$1, { "Unit, Unit | string": (t5, n3) => t5.to(n3) }, createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: i2 })({ Ds: true }));
}), name$196$1 = `toBest`, dependencies$196$1 = [`typed`], createToBest$1 = factory$1(name$196$1, dependencies$196$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$196$1, { Unit: (t5) => t5.toBest(), "Unit, string": (t5, n3) => t5.toBest(n3.split(`,`)), "Unit, string, Object": (t5, n3, r2) => t5.toBest(n3.split(`,`), r2), "Unit, Array": (t5, n3) => t5.toBest(n3), "Unit, Array, Object": (t5, n3, r2) => t5.toBest(n3, r2) });
}), name$195$1 = `isPrime`, dependencies$195$1 = [`typed`], createIsPrime$1 = factory$1(name$195$1, dependencies$195$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$195$1, { number: function(t5) {
    if (t5 <= 3) return t5 > 1;
    if (t5 % 2 == 0 || t5 % 3 == 0) return false;
    for (var n3 = 5; n3 * n3 <= t5; n3 += 6) if (t5 % n3 === 0 || t5 % (n3 + 2) === 0) return false;
    return true;
  }, bigint: function(t5) {
    if (t5 <= 3n) return t5 > 1n;
    if (t5 % 2n == 0n || t5 % 3n == 0n) return false;
    for (var n3 = 5n; n3 * n3 <= t5; n3 += 6n) if (t5 % n3 === 0n || t5 % (n3 + 2n) === 0n) return false;
    return true;
  }, BigNumber: function(t5) {
    if (t5.lte(3)) return t5.gt(1);
    if (t5.mod(2).eq(0) || t5.mod(3).eq(0)) return false;
    if (t5.lt(2 ** 32)) {
      for (var n3 = t5.toNumber(), r2 = 5; r2 * r2 <= n3; r2 += 6) if (n3 % r2 === 0 || n3 % (r2 + 2) === 0) return false;
      return true;
    }
    function i2(t6, n4, r3) {
      for (var i3 = 1; !n4.eq(0); ) n4.mod(2).eq(0) ? (n4 = n4.div(2), t6 = t6.mul(t6).mod(r3)) : (n4 = n4.sub(1), i3 = t6.mul(i3).mod(r3));
      return i3;
    }
    t5 = new (t5.constructor.clone({ precision: t5.toFixed(0).length * 2 }))(t5);
    for (var a2 = 0, o2 = t5.sub(1); o2.mod(2).eq(0); ) o2 = o2.div(2), a2 += 1;
    var s2 = null;
    if (t5.lt(`3317044064679887385961981`)) s2 = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((n4) => n4 < t5);
    else {
      var c2 = Math.min(t5.toNumber() - 2, Math.floor(2 * (t5.toFixed(0).length * Math.log(10)) ** 2));
      s2 = [];
      for (var l2 = 2; l2 <= c2; l2 += 1) s2.push(c2);
    }
    for (var u2 = 0; u2 < s2.length; u2 += 1) {
      var d2 = s2[u2], p2 = i2(t5.sub(t5).add(d2), o2, t5);
      if (!p2.eq(1)) {
        for (var m2 = 0, h2 = p2; !h2.eq(t5.sub(1)); m2 += 1, h2 = h2.mul(h2).mod(t5)) if (m2 === a2 - 1) return false;
      }
    }
    return true;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$194$1 = `numeric`, dependencies$194$1 = [`number`, `?bignumber`, `?fraction`], createNumeric$1 = factory$1(name$194$1, dependencies$194$1, (t4) => {
  var { number: n2, bignumber: r2, fraction: i2 } = t4, a2 = { string: true, number: true, BigNumber: true, Fraction: true }, o2 = { number: (t5) => n2(t5), BigNumber: r2 ? (t5) => r2(t5) : noBignumber$1, bigint: (t5) => BigInt(t5), Fraction: i2 ? (t5) => i2(t5) : noFraction$1 };
  return function(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `number`;
    if ((arguments.length > 2 ? arguments[2] : void 0) !== void 0) throw SyntaxError(`numeric() takes one or two arguments`);
    var r3 = typeOf$1(t5);
    if (!(r3 in a2)) throw TypeError(`Cannot convert ` + t5 + ` of type "` + r3 + `"; valid input types are ` + Object.keys(a2).join(`, `));
    if (!(n3 in o2)) throw TypeError(`Cannot convert ` + t5 + ` to type "` + n3 + `"; valid output types are ` + Object.keys(o2).join(`, `));
    return n3 === r3 ? t5 : o2[n3](t5);
  };
}), name$193$1 = `divideScalar`, dependencies$193$1 = [`typed`, `numeric`], createDivideScalar$1 = factory$1(name$193$1, dependencies$193$1, (t4) => {
  var { typed: n2, numeric: r2 } = t4;
  return n2(name$193$1, { "number, number": function(t5, n3) {
    return t5 / n3;
  }, "Complex, Complex": function(t5, n3) {
    return t5.div(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.div(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 / n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.div(n3);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (t5, n3) => t5.divide(n3), "number | Fraction | Complex | BigNumber, Unit": (t5, n3) => n3.divideInto(t5) });
}), name$192$1 = `pow`, dependencies$192$1 = [`typed`, `config`, `identity`, `multiply`, `matrix`, `inv`, `fraction`, `number`, `Complex`], createPow$1 = factory$1(name$192$1, dependencies$192$1, (t4) => {
  var { typed: n2, config: r2, identity: i2, multiply: a2, matrix: o2, inv: s2, number: c2, fraction: l2, Complex: u2 } = t4;
  return n2(name$192$1, { "number, number": d2, "Complex, Complex": function(t5, n3) {
    return t5.pow(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isInteger() || t5 >= 0 || r2.predictable ? t5.pow(n3) : new u2(t5.toNumber(), 0).pow(n3.toNumber(), 0);
  }, "bigint, bigint": (t5, n3) => t5 ** n3, "Fraction, Fraction": function(t5, n3) {
    var i3 = t5.pow(n3);
    if (i3 != null) return i3;
    if (r2.predictable) throw Error(`Result of pow is non-rational and cannot be expressed as a fraction`);
    return d2(t5.valueOf(), n3.valueOf());
  }, "Array, number": p2, "Array, BigNumber": function(t5, n3) {
    return p2(t5, n3.toNumber());
  }, "Matrix, number": m2, "Matrix, BigNumber": function(t5, n3) {
    return m2(t5, n3.toNumber());
  }, "Unit, number | BigNumber": function(t5, n3) {
    return t5.pow(n3);
  } });
  function d2(t5, n3) {
    if (r2.predictable && !isInteger$2(n3) && t5 < 0) try {
      var i3 = l2(n3), a3 = c2(i3);
      if ((n3 === a3 || Math.abs((n3 - a3) / n3) < 1e-14) && i3.d % 2n == 1n) return (i3.n % 2n == 0n ? 1 : -1) * (-t5) ** +n3;
    } catch {
    }
    return r2.predictable && (t5 < -1 && n3 === 1 / 0 || t5 > -1 && t5 < 0 && n3 === -1 / 0) ? NaN : isInteger$2(n3) || t5 >= 0 || r2.predictable ? powNumber$1(t5, n3) : t5 * t5 < 1 && n3 === 1 / 0 || t5 * t5 > 1 && n3 === -1 / 0 ? 0 : new u2(t5, 0).pow(n3, 0);
  }
  function p2(t5, n3) {
    if (!isInteger$2(n3)) throw TypeError(`For A^b, b must be an integer (value is ` + n3 + `)`);
    var r3 = arraySize$1(t5);
    if (r3.length !== 2) throw Error(`For A^b, A must be 2 dimensional (A has ` + r3.length + ` dimensions)`);
    if (r3[0] !== r3[1]) throw Error(`For A^b, A must be square (size is ` + r3[0] + `x` + r3[1] + `)`);
    if (n3 < 0) try {
      return p2(s2(t5), -n3);
    } catch (t6) {
      throw t6.message === `Cannot calculate inverse, determinant is zero` ? TypeError(`For A^b, when A is not invertible, b must be a positive integer (value is ` + n3 + `)`) : t6;
    }
    for (var o3 = i2(r3[0]).valueOf(), c3 = t5; n3 >= 1; ) (n3 & 1) == 1 && (o3 = a2(c3, o3)), n3 >>= 1, c3 = a2(c3, c3);
    return o3;
  }
  function m2(t5, n3) {
    return o2(p2(t5.valueOf(), n3));
  }
}), NO_INT$1 = `Number of decimals in function round must be an integer`, name$191$1 = `round`, dependencies$191$1 = [`typed`, `config`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`], createRound$1 = factory$1(name$191$1, dependencies$191$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, equalScalar: a2, zeros: o2, BigNumber: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: a2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs$1({ typed: n2 });
  function p2(t5) {
    return Math.abs(splitNumber$1(t5).exponent);
  }
  return n2(name$191$1, { number: function(t5) {
    var n3 = roundNumber$1(t5, p2(r2.relTol));
    return roundNumber$1(nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol) ? n3 : t5);
  }, "number, number": function(t5, n3) {
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return roundNumber$1(t5, n3);
    var a3 = roundNumber$1(t5, i3);
    return roundNumber$1(nearlyEqual$1$1(t5, a3, r2.relTol, r2.absTol) ? a3 : t5, n3);
  }, "number, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$1);
    return new s2(t5).toDecimalPlaces(n3.toNumber());
  }, Complex: function(t5) {
    return t5.round();
  }, "Complex, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT$1);
    return t5.round(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$1);
    var r3 = n3.toNumber();
    return t5.round(r3);
  }, BigNumber: function(t5) {
    var n3 = new s2(t5).toDecimalPlaces(p2(r2.relTol));
    return (nearlyEqual$2(t5, n3, r2.relTol, r2.absTol) ? n3 : t5).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$1);
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return t5.toDecimalPlaces(n3.toNumber());
    var a3 = t5.toDecimalPlaces(i3);
    return (nearlyEqual$2(t5, a3, r2.relTol, r2.absTol) ? a3 : t5).toDecimalPlaces(n3.toNumber());
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.round();
  }, "Fraction, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT$1);
    return t5.round(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT$1);
    return t5.round(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap$2(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5, true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(i2(n3), r3, t5, false).valueOf()), "number | Complex | BigNumber | Fraction, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : u2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()) });
}), name$190$1 = `log`, dependencies$190$1 = [`config`, `typed`, `typeOf`, `divideScalar`, `Complex`], nlg16$1 = Math.log(16), createLog$1 = factory$1(name$190$1, dependencies$190$1, (t4) => {
  var { typed: n2, typeOf: r2, config: i2, divideScalar: a2, Complex: o2 } = t4;
  function s2(t5) {
    return t5.log();
  }
  function c2(t5) {
    return s2(new o2(t5, 0));
  }
  return n2(name$190$1, { number: function(t5) {
    return t5 >= 0 || i2.predictable ? logNumber$1(t5) : c2(t5);
  }, bigint: promoteLogarithm$1(nlg16$1, logNumber$1, i2, c2), Complex: s2, BigNumber: function(t5) {
    return !t5.isNegative() || i2.predictable ? t5.ln() : c2(t5.toNumber());
  }, "any, any": n2.referToSelf((t5) => (n3, i3) => {
    if (r2(n3) === `Fraction` && r2(i3) === `Fraction`) {
      var o3 = n3.log(i3);
      if (o3 !== null) return o3;
    }
    return a2(t5(n3), t5(i3));
  }) });
}), name$189$1 = `log1p`, dependencies$189$1 = [`typed`, `config`, `divideScalar`, `log`, `Complex`], createLog1p$1 = factory$1(name$189$1, dependencies$189$1, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, log: a2, Complex: o2 } = t4;
  return n2(name$189$1, { number: function(t5) {
    return t5 >= -1 || r2.predictable ? log1p$1(t5) : s2(new o2(t5, 0));
  }, Complex: s2, BigNumber: function(t5) {
    var n3 = t5.plus(1);
    return !n3.isNegative() || r2.predictable ? n3.ln() : s2(new o2(t5.toNumber(), 0));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)), "any, any": n2.referToSelf((t5) => (n3, r3) => i2(t5(n3), a2(r3))) });
  function s2(t5) {
    var n3 = t5.re + 1;
    return new o2(Math.log(Math.sqrt(n3 * n3 + t5.im * t5.im)), Math.atan2(t5.im, n3));
  }
}), name$188$1 = `nthRoots`, dependencies$188$1 = [`config`, `typed`, `divideScalar`, `Complex`], createNthRoots$1 = factory$1(name$188$1, dependencies$188$1, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, Complex: a2 } = t4, o2 = [function(t5) {
    return new a2(t5, 0);
  }, function(t5) {
    return new a2(0, t5);
  }, function(t5) {
    return new a2(-t5, 0);
  }, function(t5) {
    return new a2(0, -t5);
  }];
  function s2(t5, n3) {
    if (n3 < 0) throw Error(`Root must be greater than zero`);
    if (n3 === 0) throw Error(`Root must be non-zero`);
    if (n3 % 1 != 0) throw Error(`Root must be an integer`);
    if (t5 === 0 || t5.abs() === 0) return [new a2(0, 0)];
    var r3 = typeof t5 == `number`, i3;
    (r3 || t5.re === 0 || t5.im === 0) && (i3 = r3 ? 2 * (t5 < 0) : t5.im === 0 ? 2 * (t5.re < 0) : 2 * (t5.im < 0) + 1);
    for (var s3 = t5.arg(), c2 = t5.abs(), l2 = [], u2 = c2 ** (1 / n3), d2 = 0; d2 < n3; d2++) {
      var p2 = (i3 + 4 * d2) / n3;
      if (p2 === Math.round(p2)) {
        l2.push(o2[p2 % 4](u2));
        continue;
      }
      l2.push(new a2({ r: u2, phi: (s3 + 2 * Math.PI * d2) / n3 }));
    }
    return l2;
  }
  return n2(name$188$1, { Complex: function(t5) {
    return s2(t5, 2);
  }, "Complex, number": s2 });
}), name$187$1 = `dotPow`, dependencies$187$1 = [`typed`, `equalScalar`, `matrix`, `pow`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotPow$1 = factory$1(name$187$1, dependencies$187$1, (t4) => {
  var { typed: n2, equalScalar: r2, matrix: i2, pow: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$1({ typed: n2 }), u2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: r2 }), p2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: i2, concat: s2 }), h2 = {};
  for (var g2 in a2.signatures) Object.prototype.hasOwnProperty.call(a2.signatures, g2) && !g2.includes(`Matrix`) && !g2.includes(`Array`) && (h2[g2] = a2.signatures[g2]);
  return n2(name$187$1, m2({ elop: n2(h2), SS: u2, DS: l2, Ss: d2, sS: p2 }));
}), name$186$1 = `dotDivide`, dependencies$186$1 = [`typed`, `matrix`, `equalScalar`, `divideScalar`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotDivide$1 = factory$1(name$186$1, dependencies$186$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, divideScalar: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo03xDSf$1({ typed: n2 }), d2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: c2 }), p2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 });
  return n2(name$186$1, createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 })({ elop: a2, SS: d2, DS: u2, SD: l2, Ss: p2, sS: m2 }));
});
function createSolveValidation$1(t4) {
  var { DenseMatrix: n2 } = t4;
  return function(t5, r2, i2) {
    var a2 = t5.size();
    if (a2.length !== 2) throw RangeError(`Matrix must be two dimensional (size: ` + format$3(a2) + `)`);
    var o2 = a2[0];
    if (o2 !== a2[1]) throw RangeError(`Matrix must be square (size: ` + format$3(a2) + `)`);
    var s2 = [];
    if (isMatrix$1(r2)) {
      var c2 = r2.size(), l2 = r2._data;
      if (c2.length === 1) {
        if (c2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var u2 = 0; u2 < o2; u2++) s2[u2] = [l2[u2]];
        return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
      }
      if (c2.length === 2) {
        if (c2[0] !== o2 || c2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        if (isDenseMatrix$1(r2)) {
          if (i2) {
            s2 = [];
            for (var d2 = 0; d2 < o2; d2++) s2[d2] = [l2[d2][0]];
            return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
          }
          return r2;
        }
        if (isSparseMatrix$1(r2)) {
          for (var p2 = 0; p2 < o2; p2++) s2[p2] = [0];
          for (var m2 = r2._values, h2 = r2._index, g2 = r2._ptr, v2 = g2[1], y2 = g2[0]; y2 < v2; y2++) {
            var b2 = h2[y2];
            s2[b2][0] = m2[y2];
          }
          return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
        }
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
    if (isArray$1(r2)) {
      var x2 = arraySize$1(r2);
      if (x2.length === 1) {
        if (x2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var S2 = 0; S2 < o2; S2++) s2[S2] = [r2[S2]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      if (x2.length === 2) {
        if (x2[0] !== o2 || x2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var w2 = 0; w2 < o2; w2++) s2[w2] = [r2[w2][0]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
  };
}
var name$185$1 = `lsolve`, dependencies$185$1 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolve$1 = factory$1(name$185$1, dependencies$185$1, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$1({ DenseMatrix: c2 });
  return n2(name$185$1, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = 0; h2 < d3; h2++) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 + 1; b2 < u3; b2++) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = 0; v2 < d3; v2++) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1], D = w2; D < E; D++) {
          var O2 = m2[D];
          O2 === v2 ? b2 = p2[D] : O2 > v2 && (x2.push(p2[D]), S2.push(O2));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var j2 = i2(y2, b2), M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          r3[F] = [o2(r3[F][0] || 0, a2(j2, x2[M2]))];
        }
        g2[v2] = [j2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$184$1 = `usolve`, dependencies$184$1 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolve$1 = factory$1(name$184$1, dependencies$184$1, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$1({ DenseMatrix: c2 });
  return n2(name$184$1, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = d3 - 1; h2 >= 0; h2--) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 - 1; b2 >= 0; b2--) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = d3 - 1; v2 >= 0; v2--) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1] - 1; E >= w2; E--) {
          var D = m2[E];
          D === v2 ? b2 = p2[E] : D < v2 && (x2.push(p2[E]), S2.push(D));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var O2 = i2(y2, b2), j2 = 0, M2 = S2.length; j2 < M2; j2++) {
          var N2 = S2[j2];
          r3[N2] = [o2(r3[N2][0], a2(O2, x2[j2]))];
        }
        g2[v2] = [O2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$183$1 = `lsolveAll`, dependencies$183$1 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolveAll$1 = factory$1(name$183$1, dependencies$183$1, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$1({ DenseMatrix: c2 });
  return n2(name$183$1, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1], m2 = 0; m2 < p2; m2++) for (var h2 = r3.length, g2 = 0; g2 < h2; g2++) {
      var v2 = r3[g2];
      if (!s2(u3[m2][m2], 0)) {
        v2[m2] = i2(v2[m2], u3[m2][m2]);
        for (var y2 = m2 + 1; y2 < p2; y2++) v2[y2] = o2(v2[y2], a2(v2[m2], u3[y2][m2]));
      } else if (!s2(v2[m2], 0)) {
        if (g2 === 0) return [];
        r3.splice(g2, 1), --g2, --h2;
      } else if (g2 === 0) {
        var b2 = [...v2];
        b2[m2] = 1;
        for (var x2 = m2 + 1; x2 < p2; x2++) b2[x2] = o2(b2[x2], u3[x2][m2]);
        r3.push(b2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = 0; g2 < d3; g2++) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = w2; O2 < E; O2++) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 > g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$182$1 = `usolveAll`, dependencies$182$1 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolveAll$1 = factory$1(name$182$1, dependencies$182$1, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$1({ DenseMatrix: c2 });
  return n2(name$182$1, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1] - 1; p2 >= 0; p2--) for (var m2 = r3.length, h2 = 0; h2 < m2; h2++) {
      var g2 = r3[h2];
      if (!s2(u3[p2][p2], 0)) {
        g2[p2] = i2(g2[p2], u3[p2][p2]);
        for (var v2 = p2 - 1; v2 >= 0; v2--) g2[v2] = o2(g2[v2], a2(g2[p2], u3[v2][p2]));
      } else if (!s2(g2[p2], 0)) {
        if (h2 === 0) return [];
        r3.splice(h2, 1), --h2, --m2;
      } else if (h2 === 0) {
        var y2 = [...g2];
        y2[p2] = 1;
        for (var b2 = p2 - 1; b2 >= 0; b2--) y2[b2] = o2(y2[b2], u3[b2][p2]);
        r3.push(y2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = d3 - 1; g2 >= 0; g2--) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = E - 1; O2 >= w2; O2--) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 < g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$181$1 = `matAlgo08xS0Sid`, dependencies$181$1 = [`typed`, `equalScalar`], createMatAlgo08xS0Sid$1 = factory$1(name$181$1, dependencies$181$1, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError$1(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    if (!o2 || !d2) throw Error(`Cannot perform operation on Pattern Sparse Matrices`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    for (var E = [], D = [], O2 = [], j2 = [], M2 = [], N2, F, I2, L2, R2 = 0; R2 < y2; R2++) {
      O2[R2] = D.length;
      var z2 = R2 + 1;
      for (F = c2[R2], I2 = c2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = s2[N2], M2[L2] = z2, j2[L2] = o2[N2], D.push(L2);
      for (F = m2[R2], I2 = m2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = p2[N2], M2[L2] === z2 && (j2[L2] = w2(j2[L2], d2[N2]));
      for (N2 = O2[R2]; N2 < D.length; ) {
        L2 = D[N2];
        var V2 = j2[L2];
        x2(V2, S2) ? D.splice(N2, 1) : (E.push(V2), N2++);
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), createUseMatrixForArrayScalar$1 = factory$1(`useMatrixForArrayScalar`, [`typed`, `matrix`], (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return { "Array, number": n2.referTo(`DenseMatrix, number`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "Array, BigNumber": n2.referTo(`DenseMatrix, BigNumber`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "number, Array": n2.referTo(`number, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()), "BigNumber, Array": n2.referTo(`BigNumber, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()) };
}), name$180$1 = `leftShift`, dependencies$180$1 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createLeftShift$1 = factory$1(name$180$1, dependencies$180$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$1({ typed: n2 }), l2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$1({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$1({ typed: n2 }), h2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$1({ typed: n2, matrix: r2 });
  return n2(name$180$1, { "number, number": leftShiftNumber$1, "BigNumber, BigNumber": leftShiftBigNumber$1, "bigint, bigint": (t5, n3) => t5 << n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$179$1 = `rightArithShift`, dependencies$179$1 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightArithShift$1 = factory$1(name$179$1, dependencies$179$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$1({ typed: n2 }), l2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$1({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$1({ typed: n2 }), h2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$1({ typed: n2, matrix: r2 });
  return n2(name$179$1, { "number, number": rightArithShiftNumber$1, "BigNumber, BigNumber": rightArithShiftBigNumber$1, "bigint, bigint": (t5, n3) => t5 >> n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$178$1 = `rightLogShift`, dependencies$178$1 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightLogShift$1 = factory$1(name$178$1, dependencies$178$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid$1({ typed: n2 }), l2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid$1({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs$1({ typed: n2 }), h2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar$1({ typed: n2, matrix: r2 });
  return n2(name$178$1, { "number, number": rightLogShiftNumber$1, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$177$1 = `and`, dependencies$177$1 = [`typed`, `matrix`, `equalScalar`, `zeros`, `not`, `concat`], createAnd$1 = factory$1(name$177$1, dependencies$177$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0$1({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo14xDs$1({ typed: n2 }), p2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$177$1, { "number, number": andNumber$1, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) && (n3.re !== 0 || n3.im !== 0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !n3.isZero() && !t5.isNaN() && !n3.isNaN();
  }, "bigint, bigint": andNumber$1, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)), "SparseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : u2(n3, r3, t5, false)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : d2(n3, r3, t5, false)), "any, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : u2(r3, n3, t5, true)), "any, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : d2(r3, n3, t5, true)), "Array, any": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3), i3).valueOf()), "any, Array": n2.referToSelf((t5) => (n3, i3) => t5(n3, r2(i3)).valueOf()) }, p2({ SS: l2, DS: c2 }));
}), name$176$1 = `compare`, dependencies$176$1 = [`typed`, `config`, `matrix`, `equalScalar`, `BigNumber`, `Fraction`, `DenseMatrix`, `concat`], createCompare$1 = factory$1(name$176$1, dependencies$176$1, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, BigNumber: o2, Fraction: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createMatAlgo03xDSf$1({ typed: n2 }), d2 = createMatAlgo05xSfSf$1({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: c2 }), m2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: a2, concat: l2 }), h2 = createCompareUnits$1({ typed: n2 });
  return n2(name$176$1, createCompareNumber$1({ typed: n2, config: r2 }), { "boolean, boolean": function(t5, n3) {
    return t5 === n3 ? 0 : t5 > n3 ? 1 : -1;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return nearlyEqual$2(t5, n3, r2.relTol, r2.absTol) ? new o2(0) : new o2(t5.cmp(n3));
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3 ? 0n : t5 > n3 ? 1n : -1n;
  }, "Fraction, Fraction": function(t5, n3) {
    return new s2(t5.compare(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, h2, m2({ SS: d2, DS: u2, Ss: p2 }));
}), createCompareNumber$1 = factory$1(name$176$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$176$1, { "number, number": function(t5, n3) {
    return nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol) ? 0 : t5 > n3 ? 1 : -1;
  } });
}), require_naturalSort$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function t5(n3, r2) {
    var i2 = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a2 = /(^[ ]*|[ ]*$)/g, o2 = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s2 = /^0x[0-9a-f]+$/i, c2 = /^0/, l2 = function(n4) {
      return t5.insensitive && (`` + n4).toLowerCase() || `` + n4;
    }, u2 = l2(n3).replace(a2, ``) || ``, d2 = l2(r2).replace(a2, ``) || ``, p2 = u2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), m2 = d2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), h2 = parseInt(u2.match(s2), 16) || p2.length !== 1 && u2.match(o2) && Date.parse(u2), g2 = parseInt(d2.match(s2), 16) || h2 && d2.match(o2) && Date.parse(d2) || null, v2, y2;
    if (g2) {
      if (h2 < g2) return -1;
      if (h2 > g2) return 1;
    }
    for (var b2 = 0, x2 = Math.max(p2.length, m2.length); b2 < x2; b2++) {
      if (v2 = !(p2[b2] || ``).match(c2) && parseFloat(p2[b2]) || p2[b2] || 0, y2 = !(m2[b2] || ``).match(c2) && parseFloat(m2[b2]) || m2[b2] || 0, isNaN(v2) !== isNaN(y2)) return isNaN(v2) ? 1 : -1;
      if (typeof v2 != typeof y2 && (v2 += ``, y2 += ``), v2 < y2) return -1;
      if (v2 > y2) return 1;
    }
    return 0;
  };
})), import_naturalSort$1 = __toESM$1(require_naturalSort$1()), name$175$1 = `compareNatural`, dependencies$175$1 = [`typed`, `compare`], createCompareNatural$1 = factory$1(name$175$1, dependencies$175$1, (t4) => {
  var { typed: n2, compare: r2 } = t4, i2 = r2.signatures[`boolean,boolean`];
  return n2(name$175$1, { "any, any": a2 });
  function a2(t5, n3) {
    var l2 = typeOf$1(t5), u2 = typeOf$1(n3), d2;
    if ((l2 === `number` || l2 === `BigNumber` || l2 === `Fraction` || l2 === `bigint`) && (u2 === `number` || u2 === `BigNumber` || u2 === `Fraction` || u2 === `bigint`)) return d2 = r2(t5, n3), d2.toString() === `0` ? (0, import_naturalSort$1.default)(l2, u2) : d2 > 0 ? 1 : -1;
    var p2 = [`Array`, `DenseMatrix`, `SparseMatrix`];
    if (p2.includes(l2) || p2.includes(u2)) return d2 = o2(a2, t5, n3), d2 === 0 ? (0, import_naturalSort$1.default)(l2, u2) : d2;
    if (l2 !== u2) return (0, import_naturalSort$1.default)(l2, u2);
    if (l2 === `Complex`) return compareComplexNumbers$1(t5, n3);
    if (l2 === `Unit`) return t5.equalBase(n3) ? a2(t5.value, n3.value) : s2(a2, t5.formatUnits(), n3.formatUnits());
    if (l2 === `boolean`) return i2(t5, n3);
    if (l2 === `string`) return (0, import_naturalSort$1.default)(t5, n3);
    if (l2 === `Object`) return c2(a2, t5, n3);
    if (l2 === `null` || l2 === `undefined`) return 0;
    throw TypeError(`Unsupported type of value "` + l2 + `"`);
  }
  function o2(t5, n3, r3) {
    return isSparseMatrix$1(n3) && isSparseMatrix$1(r3) ? s2(t5, n3.toJSON().values, r3.toJSON().values) : isSparseMatrix$1(n3) ? o2(t5, n3.toArray(), r3) : isSparseMatrix$1(r3) ? o2(t5, n3, r3.toArray()) : isDenseMatrix$1(n3) ? o2(t5, n3.toJSON().data, r3) : isDenseMatrix$1(r3) ? o2(t5, n3, r3.toJSON().data) : Array.isArray(n3) ? Array.isArray(r3) ? s2(t5, n3, r3) : o2(t5, n3, [r3]) : o2(t5, [n3], r3);
  }
  function s2(t5, n3, r3) {
    for (var i3 = 0, a3 = Math.min(n3.length, r3.length); i3 < a3; i3++) {
      var o3 = t5(n3[i3], r3[i3]);
      if (o3 !== 0) return o3;
    }
    return n3.length > r3.length ? 1 : n3.length < r3.length ? -1 : 0;
  }
  function c2(t5, n3, r3) {
    var i3 = Object.keys(n3), a3 = Object.keys(r3);
    i3.sort(import_naturalSort$1.default), a3.sort(import_naturalSort$1.default);
    var o3 = s2(t5, i3, a3);
    if (o3 !== 0) return o3;
    for (var c3 = 0; c3 < i3.length; c3++) {
      var l2 = t5(n3[i3[c3]], r3[a3[c3]]);
      if (l2 !== 0) return l2;
    }
    return 0;
  }
});
function compareComplexNumbers$1(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}
var name$174$1 = `compareText`, dependencies$174$1 = [`typed`, `matrix`, `concat`];
compareText$1.signature = `any, any`;
var createCompareText$1 = factory$1(name$174$1, dependencies$174$1, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$174$1, compareText$1, createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: i2 })({ elop: compareText$1, Ds: true }));
}), name$173$1 = `equal`, dependencies$173$1 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `SparseMatrix`], createEqual$1 = factory$1(name$173$1, dependencies$173$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$1({ typed: n2 }), l2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2 });
  return n2(name$173$1, createEqualNumber$1({ typed: n2, equalScalar: i2 }), d2({ elop: i2, SS: l2, DS: c2, Ss: u2 }));
}), createEqualNumber$1 = factory$1(name$173$1, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$173$1, { "any, any": function(t5, n3) {
    return t5 === null ? n3 === null : n3 === null ? t5 === null : t5 === void 0 ? n3 === void 0 : n3 === void 0 ? t5 === void 0 : r2(t5, n3);
  } });
}), name$172$1 = `equalText`, dependencies$172$1 = [`typed`, `compareText`, `isZero`], createEqualText$1 = factory$1(name$172$1, dependencies$172$1, (t4) => {
  var { typed: n2, compareText: r2, isZero: i2 } = t4;
  return n2(name$172$1, { "any, any": function(t5, n3) {
    return i2(r2(t5, n3));
  } });
}), name$171$1 = `smaller`, dependencies$171$1 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmaller$1 = factory$1(name$171$1, dependencies$171$1, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$1({ typed: n2 }), u2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits$1({ typed: n2 });
  function h2(t5, n3) {
    return t5.lt(n3) && !nearlyEqual$2(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$171$1, createSmallerNumber$1({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 < n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 < n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === -1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function(t5, n3) {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createSmallerNumber$1 = factory$1(name$171$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$171$1, { "number, number": function(t5, n3) {
    return t5 < n3 && !nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$170$1 = `smallerEq`, dependencies$170$1 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmallerEq$1 = factory$1(name$170$1, dependencies$170$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$1({ typed: n2 }), l2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits$1({ typed: n2 });
  return n2(name$170$1, createSmallerEqNumber$1({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 <= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.lte(n3) || nearlyEqual$2(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": (t5, n3) => t5 <= n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== 1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createSmallerEqNumber$1 = factory$1(name$170$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$170$1, { "number, number": function(t5, n3) {
    return t5 <= n3 || nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$169$1 = `larger`, dependencies$169$1 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLarger$1 = factory$1(name$169$1, dependencies$169$1, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$1({ typed: n2 }), u2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits$1({ typed: n2 });
  function h2(t5, n3) {
    return t5.gt(n3) && !nearlyEqual$2(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$169$1, createLargerNumber$1({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 > n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 > n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === 1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createLargerNumber$1 = factory$1(name$169$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$169$1, { "number, number": function(t5, n3) {
    return t5 > n3 && !nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$168$1 = `largerEq`, dependencies$168$1 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLargerEq$1 = factory$1(name$168$1, dependencies$168$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf$1({ typed: n2 }), l2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits$1({ typed: n2 });
  return n2(name$168$1, createLargerEqNumber$1({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 >= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.gte(n3) || nearlyEqual$2(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 >= n3;
  }, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== -1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createLargerEqNumber$1 = factory$1(name$168$1, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$168$1, { "number, number": function(t5, n3) {
    return t5 >= n3 || nearlyEqual$1$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$167$1 = `deepEqual`, dependencies$167$1 = [`typed`, `equal`], createDeepEqual$1 = factory$1(name$167$1, dependencies$167$1, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$167$1, { "any, any": function(t5, n3) {
    return i2(t5.valueOf(), n3.valueOf());
  } });
  function i2(t5, n3) {
    if (Array.isArray(t5)) if (Array.isArray(n3)) {
      var a2 = t5.length;
      if (a2 !== n3.length) return false;
      for (var o2 = 0; o2 < a2; o2++) if (!i2(t5[o2], n3[o2])) return false;
      return true;
    } else return false;
    else if (Array.isArray(n3)) return false;
    else return r2(t5, n3);
  }
}), name$166$1 = `unequal`, dependencies$166$1 = [`typed`, `config`, `equalScalar`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createUnequal$1 = factory$1(name$166$1, dependencies$166$1, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf$1({ typed: n2 }), u2 = createMatAlgo07xSSf$1({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: a2, concat: s2 });
  return n2(name$166$1, createUnequalNumber$1({ typed: n2, equalScalar: i2 }), p2({ elop: m2, SS: u2, DS: l2, Ss: d2 }));
  function m2(t5, n3) {
    return !i2(t5, n3);
  }
}), createUnequalNumber$1 = factory$1(name$166$1, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$166$1, { "any, any": function(t5, n3) {
    return t5 === null ? n3 !== null : n3 === null ? t5 !== null : t5 === void 0 ? n3 !== void 0 : n3 === void 0 ? t5 !== void 0 : !r2(t5, n3);
  } });
}), name$165$1 = `partitionSelect`, dependencies$165$1 = [`typed`, `isNumeric`, `isNaN`, `compare`], createPartitionSelect$1 = factory$1(name$165$1, dependencies$165$1, (t4) => {
  var { typed: n2, isNumeric: r2, isNaN: i2, compare: a2 } = t4, o2 = a2, s2 = (t5, n3) => -a2(t5, n3);
  return n2(name$165$1, { "Array | Matrix, number": function(t5, n3) {
    return c2(t5, n3, o2);
  }, "Array | Matrix, number, string": function(t5, n3, r3) {
    if (r3 === `asc`) return c2(t5, n3, o2);
    if (r3 === `desc`) return c2(t5, n3, s2);
    throw Error(`Compare string must be "asc" or "desc"`);
  }, "Array | Matrix, number, function": c2 });
  function c2(t5, n3, r3) {
    if (!isInteger$2(n3) || n3 < 0) throw Error(`k must be a non-negative integer`);
    if (isMatrix$1(t5)) {
      if (t5.size().length > 1) throw Error(`Only one dimensional matrices supported`);
      return l2(t5.valueOf(), n3, r3);
    }
    if (Array.isArray(t5)) return l2(t5, n3, r3);
  }
  function l2(t5, n3, a3) {
    if (n3 >= t5.length) throw Error(`k out of bounds`);
    for (var o3 = 0; o3 < t5.length; o3++) if (r2(t5[o3]) && i2(t5[o3])) return t5[o3];
    for (var s3 = 0, c3 = t5.length - 1; s3 < c3; ) {
      for (var l3 = s3, u2 = c3, d2 = t5[Math.floor(Math.random() * (c3 - s3 + 1)) + s3]; l3 < u2; ) if (a3(t5[l3], d2) >= 0) {
        var p2 = t5[u2];
        t5[u2] = t5[l3], t5[l3] = p2, --u2;
      } else ++l3;
      a3(t5[l3], d2) > 0 && --l3, n3 <= l3 ? c3 = l3 : s3 = l3 + 1;
    }
    return t5[n3];
  }
}), name$164$1 = `sort`, dependencies$164$1 = [`typed`, `matrix`, `compare`, `compareNatural`], createSort$1 = factory$1(name$164$1, dependencies$164$1, (t4) => {
  var { typed: n2, matrix: r2, compare: i2, compareNatural: a2 } = t4, o2 = i2, s2 = (t5, n3) => -i2(t5, n3);
  return n2(name$164$1, { Array: function(t5) {
    return l2(t5), t5.sort(o2);
  }, Matrix: function(t5) {
    return u2(t5), r2(t5.toArray().sort(o2), t5.storage());
  }, "Array, function": function(t5, n3) {
    return l2(t5), t5.sort(n3);
  }, "Matrix, function": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(n3), t5.storage());
  }, "Array, string": function(t5, n3) {
    return l2(t5), t5.sort(c2(n3));
  }, "Matrix, string": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(c2(n3)), t5.storage());
  } });
  function c2(t5) {
    if (t5 === `asc`) return o2;
    if (t5 === `desc`) return s2;
    if (t5 === `natural`) return a2;
    throw Error(`String "asc", "desc", or "natural" expected`);
  }
  function l2(t5) {
    if (arraySize$1(t5).length !== 1) throw Error(`One dimensional array expected`);
  }
  function u2(t5) {
    if (t5.size().length !== 1) throw Error(`One dimensional matrix expected`);
  }
}), name$163$1 = `max`, dependencies$163$1 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMax$1 = factory$1(name$163$1, dependencies$163$1, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4;
  return n2(name$163$1, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1$1(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`Scalar values expected in function max`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage$1(t6, `max`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach$2(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage$1(n4, `max`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate max of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType$1(n3, r2))), n3;
  }
}), name$162$1 = `min`, dependencies$162$1 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMin$1 = factory$1(name$162$1, dependencies$162$1, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4;
  return n2(name$162$1, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1$1(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`Scalar values expected in function min`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage$1(t6, `min`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach$2(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage$1(n4, `min`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate min of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType$1(n3, r2))), n3;
  }
}), name$161$1 = `ImmutableDenseMatrix`, dependencies$161$1 = [`smaller`, `DenseMatrix`], createImmutableDenseMatrixClass$1 = factory$1(name$161$1, dependencies$161$1, (t4) => {
  var { smaller: n2, DenseMatrix: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString$1(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix$1(t5) || isArray$1(t5)) {
      var a2 = new r2(t5, n3);
      this._data = a2._data, this._size = a2._size, this._datatype = a2._datatype, this._min = null, this._max = null;
    } else if (t5 && isArray$1(t5.data) && isArray$1(t5.size)) this._data = t5.data, this._size = t5.size, this._datatype = t5.datatype, this._min = t5.min === void 0 ? null : t5.min, this._max = t5.max === void 0 ? null : t5.max;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf$1(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3, this._min = null, this._max = null;
  }
  return i2.prototype = new r2(), i2.prototype.type = `ImmutableDenseMatrix`, i2.prototype.isImmutableDenseMatrix = true, i2.prototype.subset = function(t5) {
    switch (arguments.length) {
      case 1:
        var n3 = r2.prototype.subset.call(this, t5);
        return isMatrix$1(n3) ? new i2({ data: n3._data, size: n3._size, datatype: n3._datatype }) : n3;
      case 2:
      case 3:
        throw Error(`Cannot invoke set subset on an Immutable Matrix instance`);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.set = function() {
    throw Error(`Cannot invoke set on an Immutable Matrix instance`);
  }, i2.prototype.resize = function() {
    throw Error(`Cannot invoke resize on an Immutable Matrix instance`);
  }, i2.prototype.reshape = function() {
    throw Error(`Cannot invoke reshape on an Immutable Matrix instance`);
  }, i2.prototype.clone = function() {
    return new i2({ data: clone$3$1(this._data), size: clone$3$1(this._size), datatype: this._datatype });
  }, i2.prototype.toJSON = function() {
    return { mathjs: `ImmutableDenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function() {
    throw Error(`Cannot invoke swapRows on an Immutable Matrix instance`);
  }, i2.prototype.min = function() {
    if (this._min === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(r3, t5)) && (t5 = r3);
      }), this._min = t5 === null ? void 0 : t5;
    }
    return this._min;
  }, i2.prototype.max = function() {
    if (this._max === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(t5, r3)) && (t5 = r3);
      }), this._max = t5 === null ? void 0 : t5;
    }
    return this._max;
  }, i2;
}, { isClass: true }), name$160$1 = `Index`, dependencies$160$1 = [`ImmutableDenseMatrix`, `getMatrixDataType`], createIndexClass$1 = factory$1(name$160$1, dependencies$160$1, (t4) => {
  var { ImmutableDenseMatrix: n2, getMatrixDataType: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._dimensions = [], this._sourceSize = [], this._isScalar = true;
    for (var t5 = 0, n3 = arguments.length; t5 < n3; t5++) {
      var o2 = t5 < 0 || arguments.length <= t5 ? void 0 : arguments[t5], s2 = isArray$1(o2), c2 = isMatrix$1(o2), l2 = typeof o2, u2 = null;
      if (isRange$1(o2)) this._dimensions.push(o2), this._isScalar = false;
      else if (s2 || c2) {
        var d2 = void 0;
        this._isScalar = false, r2(o2) === `boolean` ? (s2 && (d2 = a2(_booleansArrayToNumbersForIndex$1(o2).valueOf())), c2 && (d2 = a2(_booleansArrayToNumbersForIndex$1(o2._data).valueOf())), u2 = o2.valueOf().length) : d2 = a2(o2.valueOf()), this._dimensions.push(d2);
      } else if (l2 === `number`) this._dimensions.push(o2);
      else if (l2 === `bigint`) this._dimensions.push(Number(o2));
      else if (l2 === `string`) this._dimensions.push(o2);
      else throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      this._sourceSize.push(u2);
    }
  }
  i2.prototype.type = `Index`, i2.prototype.isIndex = true;
  function a2(t5) {
    for (var r3 = 0, i3 = t5.length; r3 < i3; r3++) if (!isNumber$1(t5[r3]) || !isInteger$2(t5[r3])) throw TypeError(`Index parameters must be positive integer numbers`);
    var a3 = new n2();
    return a3._data = t5, a3._size = [t5.length], a3;
  }
  return i2.prototype.clone = function() {
    var t5 = new i2();
    return t5._dimensions = clone$3$1(this._dimensions), t5._isScalar = this._isScalar, t5._sourceSize = this._sourceSize, t5;
  }, i2.create = function(t5) {
    var n3 = new i2();
    return i2.apply(n3, t5), n3;
  }, i2.prototype.size = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$1(i3) || isNumber$1(i3) ? 1 : i3.size()[0];
    }
    return t5;
  }, i2.prototype.max = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$1(i3) || isNumber$1(i3) ? i3 : i3.max();
    }
    return t5;
  }, i2.prototype.min = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString$1(i3) || isNumber$1(i3) ? i3 : i3.min();
    }
    return t5;
  }, i2.prototype.forEach = function(t5) {
    for (var n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) t5(this._dimensions[n3], n3, this);
  }, i2.prototype.dimension = function(t5) {
    return isNumber$1(t5) ? this._dimensions[t5] ?? null : null;
  }, i2.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && isString$1(this._dimensions[0]);
  }, i2.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, i2.prototype.isScalar = function() {
    return this._isScalar;
  }, i2.prototype.toArray = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5.push(isString$1(i3) || isNumber$1(i3) ? i3 : i3.toArray());
    }
    return t5;
  }, i2.prototype.valueOf = i2.prototype.toArray, i2.prototype.toString = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      isString$1(i3) ? t5.push(JSON.stringify(i3)) : t5.push(i3.toString());
    }
    return `[` + t5.join(`, `) + `]`;
  }, i2.prototype.toJSON = function() {
    return { mathjs: `Index`, dimensions: this._dimensions };
  }, i2.fromJSON = function(t5) {
    return i2.create(t5.dimensions);
  }, i2;
}, { isClass: true });
function _booleansArrayToNumbersForIndex$1(t4) {
  var n2 = [];
  return t4.forEach((t5, r2) => {
    t5 && n2.push(r2);
  }), n2;
}
var name$159$1 = `FibonacciHeap`, dependencies$159$1 = [`smaller`, `larger`], createFibonacciHeapClass$1 = factory$1(name$159$1, dependencies$159$1, (t4) => {
  var { smaller: n2, larger: r2 } = t4, i2 = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._minimum = null, this._size = 0;
  }
  a2.prototype.type = `FibonacciHeap`, a2.prototype.isFibonacciHeap = true, a2.prototype.insert = function(t5, r3) {
    var i3 = { key: t5, value: r3, degree: 0 };
    if (this._minimum) {
      var a3 = this._minimum;
      i3.left = a3, i3.right = a3.right, a3.right = i3, i3.right.left = i3, n2(t5, a3.key) && (this._minimum = i3);
    } else i3.left = i3, i3.right = i3, this._minimum = i3;
    return this._size++, i3;
  }, a2.prototype.size = function() {
    return this._size;
  }, a2.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, a2.prototype.isEmpty = function() {
    return this._size === 0;
  }, a2.prototype.extractMinimum = function() {
    var t5 = this._minimum;
    if (t5 === null) return t5;
    for (var n3 = this._minimum, r3 = t5.degree, i3 = t5.child; r3 > 0; ) {
      var a3 = i3.right;
      i3.left.right = i3.right, i3.right.left = i3.left, i3.left = n3, i3.right = n3.right, n3.right = i3, i3.right.left = i3, i3.parent = null, i3 = a3, r3--;
    }
    return t5.left.right = t5.right, t5.right.left = t5.left, t5 === t5.right ? n3 = null : (n3 = t5.right, n3 = u2(n3, this._size)), this._size--, this._minimum = n3, t5;
  }, a2.prototype.remove = function(t5) {
    this._minimum = o2(this._minimum, t5, -1), this.extractMinimum();
  };
  function o2(t5, r3, i3) {
    r3.key = i3;
    var a3 = r3.parent;
    return a3 && n2(r3.key, a3.key) && (s2(t5, r3, a3), c2(t5, a3)), n2(r3.key, t5.key) && (t5 = r3), t5;
  }
  function s2(t5, n3, r3) {
    n3.left.right = n3.right, n3.right.left = n3.left, r3.degree--, r3.child === n3 && (r3.child = n3.right), r3.degree === 0 && (r3.child = null), n3.left = t5, n3.right = t5.right, t5.right = n3, n3.right.left = n3, n3.parent = null, n3.mark = false;
  }
  function c2(t5, n3) {
    var r3 = n3.parent;
    r3 && (n3.mark ? (s2(t5, n3, r3), c2(r3)) : n3.mark = true);
  }
  var l2 = function(t5, n3) {
    t5.left.right = t5.right, t5.right.left = t5.left, t5.parent = n3, n3.child ? (t5.left = n3.child, t5.right = n3.child.right, n3.child.right = t5, t5.right.left = t5) : (n3.child = t5, t5.right = t5, t5.left = t5), n3.degree++, t5.mark = false;
  };
  function u2(t5, a3) {
    var o3 = Math.floor(Math.log(a3) * i2) + 1, s3 = Array(o3), c3 = 0, u3 = t5;
    if (u3) for (c3++, u3 = u3.right; u3 !== t5; ) c3++, u3 = u3.right;
    for (var d2; c3 > 0; ) {
      for (var p2 = u3.degree, m2 = u3.right; d2 = s3[p2], d2; ) {
        if (r2(u3.key, d2.key)) {
          var h2 = d2;
          d2 = u3, u3 = h2;
        }
        l2(d2, u3), s3[p2] = null, p2++;
      }
      s3[p2] = u3, u3 = m2, c3--;
    }
    t5 = null;
    for (var g2 = 0; g2 < o3; g2++) d2 = s3[g2], d2 && (t5 ? (d2.left.right = d2.right, d2.right.left = d2.left, d2.left = t5, d2.right = t5.right, t5.right = d2, d2.right.left = d2, n2(d2.key, t5.key) && (t5 = d2)) : t5 = d2);
    return t5;
  }
  return a2;
}, { isClass: true }), name$158$1 = `Spa`, dependencies$158$1 = [`addScalar`, `equalScalar`, `FibonacciHeap`], createSpaClass$1 = factory$1(name$158$1, dependencies$158$1, (t4) => {
  var { addScalar: n2, equalScalar: r2, FibonacciHeap: i2 } = t4;
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._values = [], this._heap = new i2();
  }
  return a2.prototype.type = `Spa`, a2.prototype.isSpa = true, a2.prototype.set = function(t5, n3) {
    if (this._values[t5]) this._values[t5].value = n3;
    else {
      var r3 = this._heap.insert(t5, n3);
      this._values[t5] = r3;
    }
  }, a2.prototype.get = function(t5) {
    var n3 = this._values[t5];
    return n3 ? n3.value : 0;
  }, a2.prototype.accumulate = function(t5, r3) {
    var i3 = this._values[t5];
    i3 ? i3.value = n2(i3.value, r3) : (i3 = this._heap.insert(t5, r3), this._values[t5] = i3);
  }, a2.prototype.forEach = function(t5, n3, i3) {
    var a3 = this._heap, o2 = this._values, s2 = [], c2 = a3.extractMinimum();
    for (c2 && s2.push(c2); c2 && c2.key <= n3; ) c2.key >= t5 && (r2(c2.value, 0) || i3(c2.key, c2.value, this)), c2 = a3.extractMinimum(), c2 && s2.push(c2);
    for (var l2 = 0; l2 < s2.length; l2++) {
      var u2 = s2[l2];
      c2 = a3.insert(u2.key, u2.value), o2[c2.key] = c2;
    }
  }, a2.prototype.swap = function(t5, n3) {
    var r3 = this._values[t5], i3 = this._values[n3];
    if (!r3 && i3) r3 = this._heap.insert(t5, i3.value), this._heap.remove(i3), this._values[t5] = r3, this._values[n3] = void 0;
    else if (r3 && !i3) i3 = this._heap.insert(n3, r3.value), this._heap.remove(r3), this._values[n3] = i3, this._values[t5] = void 0;
    else if (r3 && i3) {
      var a3 = r3.value;
      r3.value = i3.value, i3.value = a3;
    }
  }, a2;
}, { isClass: true });
function lruQueue$1(t4) {
  var n2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null), o2 = 0, s2 = function(t5) {
    var s3 = a2[t5];
    if (s3 && (delete i2[s3], delete a2[t5], --n2, r2 === s3)) {
      if (!n2) {
        o2 = 0, r2 = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
    }
  };
  return t4 = Math.abs(t4), { hit: function(c2) {
    var l2 = a2[c2], u2 = ++o2;
    if (i2[u2] = c2, a2[c2] = u2, !l2) return ++n2, n2 <= t4 ? void 0 : (c2 = i2[r2], s2(c2), c2);
    if (delete i2[l2], r2 === l2) for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
  }, delete: s2, clear: function() {
    n2 = o2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1$1(t4) {
  var { hasher: n2, limit: r2 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return r2 ??= 1 / 0, n2 ??= JSON.stringify, function i2() {
    typeof i2.cache != `object` && (i2.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue$1(r2 || 1 / 0) });
    var a2 = [...arguments], o2 = n2(a2);
    if (i2.cache.values.has(o2)) return i2.cache.lru.hit(o2), i2.cache.values.get(o2);
    var s2 = t4.apply(t4, a2);
    return i2.cache.values.set(o2, s2), i2.cache.values.delete(i2.cache.lru.hit(o2)), s2;
  };
}
var createBigNumberE$1 = memoize$1$1(function(t4) {
  return new t4(1).exp();
}, { hasher: hasher$1 }), createBigNumberPhi$1 = memoize$1$1(function(t4) {
  return new t4(1).plus(new t4(5).sqrt()).div(2);
}, { hasher: hasher$1 }), createBigNumberPi$1 = memoize$1$1(function(t4) {
  return t4.acos(-1);
}, { hasher: hasher$1 }), createBigNumberTau$1 = memoize$1$1(function(t4) {
  return createBigNumberPi$1(t4).times(2);
}, { hasher: hasher$1 });
function hasher$1(t4) {
  return t4[0].precision;
}
function ownKeys$2$1(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$2$1(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$2$1(Object(r2), true).forEach(function(n3) {
      _defineProperty$2(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$2$1(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$157$1 = `Unit`, dependencies$157$1 = [`?on`, `config`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `abs`, `fix`, `round`, `equal`, `isNumeric`, `format`, `number`, `Complex`, `BigNumber`, `Fraction`], createUnitClass$1 = factory$1(name$157$1, dependencies$157$1, (t4) => {
  var { on: n2, config: r2, addScalar: i2, subtractScalar: a2, multiplyScalar: o2, divideScalar: s2, pow: c2, abs: l2, fix: u2, round: d2, equal: p2, isNumeric: m2, format: h2, number: g2, Complex: v2, BigNumber: y2, Fraction: b2 } = t4, x2 = g2, S2 = false, w2 = true;
  function E(t5, n3) {
    if (!(this instanceof E)) throw Error(`Constructor must be called with the new operator`);
    if (!(t5 == null || m2(t5) || isComplex$1(t5))) throw TypeError(`First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined`);
    if (this.fixPrefix = S2, this.skipAutomaticSimplification = w2, n3 === void 0) this.units = [], this.dimensions = ee2.map((t6) => 0);
    else if (typeof n3 == `string`) {
      var r3 = E.parse(n3);
      this.units = r3.units, this.dimensions = r3.dimensions;
    } else if (isUnit$1(n3) && n3.value === null) this.fixPrefix = n3.fixPrefix, this.skipAutomaticSimplification = n3.skipAutomaticSimplification, this.dimensions = n3.dimensions.slice(0), this.units = n3.units.map((t6) => _extends$3({}, t6));
    else throw TypeError(`Second parameter in Unit constructor must be a string or valueless Unit`);
    this.value = this._normalize(t5);
  }
  Object.defineProperty(E, "name", { value: `Unit` }), E.prototype.constructor = E, E.prototype.type = `Unit`, E.prototype.isUnit = true;
  var D, O2, j2;
  function M2() {
    for (; j2 === ` ` || j2 === `	`; ) I2();
  }
  function N2(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }
  function F(t5) {
    return t5 >= `0` && t5 <= `9`;
  }
  function I2() {
    O2++, j2 = D.charAt(O2);
  }
  function L2(t5) {
    O2 = t5, j2 = D.charAt(O2);
  }
  function R2() {
    var t5 = ``, n3 = O2;
    if (j2 === `+` ? I2() : j2 === `-` && (t5 += j2, I2()), !N2(j2)) return L2(n3), null;
    if (j2 === `.`) {
      if (t5 += j2, I2(), !F(j2)) return L2(n3), null;
    } else {
      for (; F(j2); ) t5 += j2, I2();
      j2 === `.` && (t5 += j2, I2());
    }
    for (; F(j2); ) t5 += j2, I2();
    if (j2 === `E` || j2 === `e`) {
      var r3 = ``, i3 = O2;
      if (r3 += j2, I2(), (j2 === `+` || j2 === `-`) && (r3 += j2, I2()), !F(j2)) return L2(i3), t5;
      for (t5 += r3; F(j2); ) t5 += j2, I2();
    }
    return t5;
  }
  function z2() {
    for (var t5 = ``; F(j2) || E.isValidAlpha(j2); ) t5 += j2, I2();
    var n3 = t5.charAt(0);
    return E.isValidAlpha(n3) ? t5 : null;
  }
  function V2(t5) {
    return j2 === t5 ? (I2(), t5) : null;
  }
  E.parse = function(t5, n3) {
    if (n3 ||= {}, D = t5, O2 = -1, j2 = ``, typeof D != `string`) throw TypeError(`Invalid argument in Unit.parse, string expected`);
    var i3 = new E();
    i3.units = [];
    var a3 = 1, o3 = false;
    I2(), M2();
    var s3 = R2(), c3 = null;
    if (s3) {
      if (r2.number === `BigNumber`) c3 = new y2(s3);
      else if (r2.number === `Fraction`) try {
        c3 = new b2(s3);
      } catch {
        c3 = parseFloat(s3);
      }
      else c3 = parseFloat(s3);
      M2(), V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) && (a3 = -1, o3 = true);
    }
    for (var l3 = [], u3 = 1; ; ) {
      for (M2(); j2 === `(`; ) l3.push(a3), u3 *= a3, a3 = 1, I2(), M2();
      var d3 = void 0;
      if (j2) {
        var p3 = j2;
        if (d3 = z2(), d3 === null) throw SyntaxError(`Unexpected "` + p3 + `" in "` + D + `" at index ` + O2.toString());
      } else break;
      var m3 = H2(d3);
      if (m3 === null) throw SyntaxError(`Unit "` + d3 + `" not found.`);
      var h3 = a3 * u3;
      if (M2(), V2(`^`)) {
        M2();
        var g3 = R2();
        if (g3 === null) throw SyntaxError(`In "` + t5 + `", "^" must be followed by a floating-point number`);
        h3 *= g3;
      }
      i3.units.push({ unit: m3.unit, prefix: m3.prefix, power: h3 });
      for (var v3 = 0; v3 < ee2.length; v3++) i3.dimensions[v3] += (m3.unit.dimensions[v3] || 0) * h3;
      for (M2(); j2 === `)`; ) {
        if (l3.length === 0) throw SyntaxError(`Unmatched ")" in "` + D + `" at index ` + O2.toString());
        u3 /= l3.pop(), I2(), M2();
      }
      if (o3 = false, V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) ? (a3 = -1, o3 = true) : a3 = 1, m3.unit.base) {
        var x3 = m3.unit.base.key;
        Z2.auto[x3] = { unit: m3.unit, prefix: m3.prefix };
      }
    }
    if (M2(), j2) throw SyntaxError(`Could not parse: "` + t5 + `"`);
    if (o3) throw SyntaxError(`Trailing characters: "` + t5 + `"`);
    if (l3.length !== 0) throw SyntaxError(`Unmatched "(" in "` + D + `"`);
    if (i3.units.length === 0 && !n3.allowNoUnits) throw SyntaxError(`"` + t5 + `" contains no units`);
    return i3.value = c3 === void 0 ? null : i3._normalize(c3), i3;
  }, E.prototype.clone = function() {
    var t5 = new E();
    t5.fixPrefix = this.fixPrefix, t5.skipAutomaticSimplification = this.skipAutomaticSimplification, t5.value = clone$3$1(this.value), t5.dimensions = this.dimensions.slice(0), t5.units = [];
    for (var n3 = 0; n3 < this.units.length; n3++) for (var r3 in t5.units[n3] = {}, this.units[n3]) hasOwnProperty$1$3(this.units[n3], r3) && (t5.units[n3][r3] = this.units[n3][r3]);
    return t5;
  }, E.prototype.valueType = function() {
    return typeOf$1(this.value);
  }, E.prototype._isDerived = function() {
    return this.units.length === 0 ? false : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, E.prototype._normalize = function(t5) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var n3 = t5, r3 = E._getNumberConverter(typeOf$1(t5)), i3 = 0; i3 < this.units.length; i3++) {
      var a3 = r3(this.units[i3].unit.value), s3 = r3(this.units[i3].prefix.value), l3 = r3(this.units[i3].power);
      n3 = o2(n3, c2(o2(a3, s3), l3));
    }
    return n3;
  }, E.prototype._denormalize = function(t5, n3) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var r3 = t5, i3 = E._getNumberConverter(typeOf$1(t5)), a3 = 0; a3 < this.units.length; a3++) {
      var l3 = i3(this.units[a3].unit.value), u3 = i3(this.units[a3].prefix.value), d3 = i3(this.units[a3].power);
      r3 = s2(r3, c2(o2(l3, u3), d3));
    }
    return r3;
  };
  var H2 = memoize$1$1((t5) => {
    if (hasOwnProperty$1$3(X2, t5)) {
      var n3 = X2[t5];
      return { unit: n3, prefix: n3.prefixes[``] };
    }
    for (var r3 in X2) if (hasOwnProperty$1$3(X2, r3) && endsWith$1(t5, r3)) {
      var i3 = X2[r3], a3 = t5.length - r3.length, o3 = t5.substring(0, a3), s3 = hasOwnProperty$1$3(i3.prefixes, o3) ? i3.prefixes[o3] : void 0;
      if (s3 !== void 0) return { unit: i3, prefix: s3 };
    }
    return null;
  }, { hasher: (t5) => t5[0], limit: 100 });
  E.isValuelessUnit = function(t5) {
    return H2(t5) !== null;
  }, E.prototype.hasBase = function(t5) {
    if (typeof t5 == `string` && (t5 = Y2[t5]), !t5) return false;
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equalBase = function(t5) {
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equals = function(t5) {
    return this.equalBase(t5) && p2(this.value, t5.value);
  }, E.prototype.multiply = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit$1(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) + (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var s3 = _objectSpread$2$1({}, r3.units[a3]);
      n3.units.push(s3);
    }
    return this.value !== null || r3.value !== null ? n3.value = o2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit$1(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.divideInto = function(t5) {
    return new E(t5).divide(this);
  }, E.prototype.divide = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit$1(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) - (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var o3 = _objectSpread$2$1(_objectSpread$2$1({}, r3.units[a3]), {}, { power: -r3.units[a3].power });
      n3.units.push(o3);
    }
    return this.value !== null || r3.value !== null ? n3.value = s2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit$1(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.pow = function(t5) {
    for (var n3 = this.clone(), r3 = 0; r3 < ee2.length; r3++) n3.dimensions[r3] = (this.dimensions[r3] || 0) * t5;
    for (var i3 = 0; i3 < n3.units.length; i3++) n3.units[i3].power *= t5;
    return n3.value === null ? n3.value = null : n3.value = c2(n3.value, t5), n3.skipAutomaticSimplification = false, U2(n3);
  };
  function U2(t5) {
    return t5.equalBase(Y2.NONE) && t5.value !== null && !r2.predictable ? t5.value : t5;
  }
  function W2(t5) {
    return E._getNumberConverter(typeOf$1(t5))(1);
  }
  E.prototype.abs = function() {
    var t5 = this.clone();
    if (t5.value !== null) if (t5._isDerived() || t5.units.length === 0 || t5.units[0].unit.offset === 0) t5.value = l2(t5.value);
    else {
      var n3 = t5._numberConverter(), r3 = o2(n3(t5.units[0].unit.value), n3(t5.units[0].unit.offset));
      t5.value = a2(l2(i2(t5.value, r3)), r3);
    }
    for (var s3 in t5.units) (t5.units[s3].unit.name === `VA` || t5.units[s3].unit.name === `VAR`) && (t5.units[s3].unit = X2.W);
    return t5;
  }, E.prototype.to = function(t5) {
    var n3 = this.value === null ? this._normalize(1) : this.value, r3;
    if (typeof t5 == `string`) r3 = E.parse(t5);
    else if (isUnit$1(t5)) r3 = t5.clone();
    else throw Error(`String or Unit expected as parameter`);
    if (!this.equalBase(r3)) throw Error(`Units do not match ('${r3.toString()}' != '${this.toString()}')`);
    if (r3.value !== null) throw Error(`Cannot convert to a unit with a value`);
    if (this.value === null || this._isDerived() || this.units.length === 0 || r3.units.length === 0 || this.units[0].unit.offset === r3.units[0].unit.offset) r3.value = clone$3$1(n3);
    else {
      var s3 = E._getNumberConverter(typeOf$1(n3)), c3 = this.units[0].unit.value, l3 = this.units[0].unit.offset, u3 = o2(c3, l3), d3 = r3.units[0].unit.value, p3 = r3.units[0].unit.offset, m3 = o2(d3, p3);
      r3.value = i2(n3, s3(a2(u3, m3)));
    }
    return r3.fixPrefix = true, r3.skipAutomaticSimplification = true, r3;
  }, E.prototype.toNumber = function(t5) {
    return x2(this.toNumeric(t5));
  }, E.prototype.toNumeric = function(t5) {
    var n3 = t5 ? this.to(t5) : this.clone();
    return n3._isDerived() || n3.units.length === 0 ? n3._denormalize(n3.value) : n3._denormalize(n3.value, n3.units[0].prefix.value);
  }, E.prototype.toString = function() {
    return this.format();
  }, E.prototype.toJSON = function() {
    return { mathjs: `Unit`, value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, E.fromJSON = function(t5) {
    var a3 = new E(t5.value, t5.unit ?? void 0);
    return a3.fixPrefix = t5.fixPrefix ?? S2, a3.skipAutomaticSimplification = t5.skipSimp ?? w2, a3;
  }, E.prototype.valueOf = E.prototype.toString, E.prototype.simplify = function() {
    var t5 = this.clone(), n3 = [], r3;
    for (var i3 in oe2) if (hasOwnProperty$1$3(oe2, i3) && t5.hasBase(Y2[i3])) {
      r3 = i3;
      break;
    }
    if (r3 === `NONE`) t5.units = [];
    else {
      var a3;
      if (r3 && hasOwnProperty$1$3(oe2, r3) && (a3 = oe2[r3]), a3) t5.units = [{ unit: a3.unit, prefix: a3.prefix, power: 1 }];
      else {
        for (var o3 = false, s3 = 0; s3 < ee2.length; s3++) {
          var c3 = ee2[s3];
          Math.abs(t5.dimensions[s3] || 0) > 1e-12 && (hasOwnProperty$1$3(oe2, c3) ? n3.push({ unit: oe2[c3].unit, prefix: oe2[c3].prefix, power: t5.dimensions[s3] || 0 }) : o3 = true);
        }
        n3.length < t5.units.length && !o3 && (t5.units = n3);
      }
    }
    return t5;
  }, E.prototype.toSI = function() {
    for (var t5 = this.clone(), n3 = [], r3 = 0; r3 < ee2.length; r3++) {
      var i3 = ee2[r3];
      if (Math.abs(t5.dimensions[r3] || 0) > 1e-12) if (hasOwnProperty$1$3(Z2.si, i3)) n3.push({ unit: Z2.si[i3].unit, prefix: Z2.si[i3].prefix, power: t5.dimensions[r3] || 0 });
      else throw Error(`Cannot express custom unit ` + i3 + ` in SI units`);
    }
    return t5.units = n3, t5.fixPrefix = true, t5.skipAutomaticSimplification = true, this.value === null ? t5 : (t5.value = null, this.to(t5));
  }, E.prototype.formatUnits = function() {
    for (var t5 = ``, n3 = ``, r3 = 0, i3 = 0, a3 = 0; a3 < this.units.length; a3++) this.units[a3].power > 0 ? (r3++, t5 += ` ` + this.units[a3].prefix.name + this.units[a3].unit.name, Math.abs(this.units[a3].power - 1) > 1e-15 && (t5 += `^` + this.units[a3].power)) : this.units[a3].power < 0 && i3++;
    if (i3 > 0) for (var o3 = 0; o3 < this.units.length; o3++) this.units[o3].power < 0 && (r3 > 0 ? (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, Math.abs(this.units[o3].power + 1) > 1e-15 && (n3 += `^` + -this.units[o3].power)) : (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, n3 += `^` + this.units[o3].power));
    t5 = t5.substr(1), n3 = n3.substr(1), r3 > 1 && i3 > 0 && (t5 = `(` + t5 + `)`), i3 > 1 && r3 > 0 && (n3 = `(` + n3 + `)`);
    var s3 = t5;
    return r3 > 0 && i3 > 0 && (s3 += ` / `), s3 += n3, s3;
  }, E.prototype.toBest = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t5 && !Array.isArray(t5)) throw Error(`Invalid unit type. Expected string or Unit.`);
    var r3 = this.units[0].unit.prefixes;
    if (t5 && t5.length > 0) {
      var i3 = t5.map((t6) => {
        var n4 = null;
        if (typeof t6 == `string`) {
          if (n4 = E.parse(t6), !n4) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        } else if (!isUnit$1(t6)) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        n4 === null && (n4 = t6.clone());
        try {
          return this.to(n4.formatUnits()), n4;
        } catch {
          throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        }
      }).map((t6) => t6.units[0].prefix);
      this.units[0].unit.prefixes = i3.reduce((t6, n4) => (t6[n4.name] = n4, t6), {}), this.units[0].prefix = i3[0];
    }
    var a3 = G2(this, n3).simp;
    return this.units[0].unit.prefixes = r3, a3.fixPrefix = true, a3;
  }, E.prototype.format = function(t5) {
    var { simp: n3, valueStr: r3, unitStr: i3 } = G2(this, t5), a3 = r3;
    return n3.value && isComplex$1(n3.value) && (a3 = `(` + a3 + `)`), i3.length > 0 && a3.length > 0 && (a3 += ` `), a3 += i3, a3;
  };
  function G2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = t5.skipAutomaticSimplification || t5.value === null ? t5.clone() : t5.simplify();
    K2(r3), q2(r3, n3.offset);
    var i3 = r3._denormalize(r3.value);
    return { simp: r3, valueStr: r3.value === null ? `` : h2(i3, n3 || {}), unitStr: r3.formatUnits() };
  }
  function K2(t5) {
    var n3 = false;
    for (var r3 in t5.value !== void 0 && t5.value !== null && isComplex$1(t5.value) && (n3 = Math.abs(t5.value.re) < 1e-14), t5.units) hasOwnProperty$1$3(t5.units, r3) && t5.units[r3].unit && (t5.units[r3].unit.name === `VA` && n3 ? t5.units[r3].unit = X2.VAR : t5.units[r3].unit.name === `VAR` && !n3 && (t5.units[r3].unit = X2.VA));
  }
  function q2(t5, n3) {
    t5.units.length === 1 && !t5.fixPrefix && Math.abs(t5.units[0].power - Math.round(t5.units[0].power)) < 1e-14 && (t5.units[0].prefix = t5._bestPrefix(n3));
  }
  E.prototype._bestPrefix = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1.2;
    if (this.units.length !== 1 || Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw Error(`Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!`);
    var n3 = this.value === null ? 0 : l2(this.value), r3 = l2(this.units[0].unit.value), i3 = this.units[0].prefix;
    if (n3 === 0) return i3;
    var a3 = this.units[0].power, o3 = Math.log(n3 / (i3.value * r3) ** +a3) / Math.LN10 - t5;
    if (o3 > -2.200001 && o3 < 1.800001) return i3;
    o3 = Math.abs(o3);
    var s3 = this.units[0].unit.prefixes;
    for (var c3 in s3) if (hasOwnProperty$1$3(s3, c3)) {
      var u3 = s3[c3];
      if (u3.scientific) {
        var d3 = Math.abs(Math.log(n3 / (u3.value * r3) ** +a3) / Math.LN10 - t5);
        (d3 < o3 || d3 === o3 && u3.name.length < i3.name.length) && (i3 = u3, o3 = d3);
      }
    }
    return i3;
  }, E.prototype.splitUnit = function(t5) {
    for (var n3 = this.clone(), r3 = [], o3 = 0; o3 < t5.length && (n3 = n3.to(t5[o3]), o3 !== t5.length - 1); o3++) {
      var s3 = n3.toNumeric(), c3 = d2(s3), l3 = void 0;
      l3 = p2(c3, s3) ? c3 : u2(n3.toNumeric());
      var m3 = new E(l3, t5[o3].toString());
      r3.push(m3), n3 = a2(n3, m3);
    }
    for (var h3 = 0, g3 = 0; g3 < r3.length; g3++) h3 = i2(h3, r3[g3].value);
    return p2(h3, this.value) && (n3.value = 0), r3.push(n3), r3;
  };
  var J = { NONE: { "": { name: ``, value: 1, scientific: true } }, SHORT: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 10, scientific: false }, h: { name: `h`, value: 100, scientific: false }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true }, R: { name: `R`, value: 1e27, scientific: true }, Q: { name: `Q`, value: 1e30, scientific: true }, d: { name: `d`, value: 0.1, scientific: false }, c: { name: `c`, value: 0.01, scientific: false }, m: { name: `m`, value: 1e-3, scientific: true }, u: { name: `u`, value: 1e-6, scientific: true }, n: { name: `n`, value: 1e-9, scientific: true }, p: { name: `p`, value: 1e-12, scientific: true }, f: { name: `f`, value: 1e-15, scientific: true }, a: { name: `a`, value: 1e-18, scientific: true }, z: { name: `z`, value: 1e-21, scientific: true }, y: { name: `y`, value: 1e-24, scientific: true }, r: { name: `r`, value: 1e-27, scientific: true }, q: { name: `q`, value: 1e-30, scientific: true } }, LONG: { "": { name: ``, value: 1, scientific: true }, deca: { name: `deca`, value: 10, scientific: false }, hecto: { name: `hecto`, value: 100, scientific: false }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true }, ronna: { name: `ronna`, value: 1e27, scientific: true }, quetta: { name: `quetta`, value: 1e30, scientific: true }, deci: { name: `deci`, value: 0.1, scientific: false }, centi: { name: `centi`, value: 0.01, scientific: false }, milli: { name: `milli`, value: 1e-3, scientific: true }, micro: { name: `micro`, value: 1e-6, scientific: true }, nano: { name: `nano`, value: 1e-9, scientific: true }, pico: { name: `pico`, value: 1e-12, scientific: true }, femto: { name: `femto`, value: 1e-15, scientific: true }, atto: { name: `atto`, value: 1e-18, scientific: true }, zepto: { name: `zepto`, value: 1e-21, scientific: true }, yocto: { name: `yocto`, value: 1e-24, scientific: true }, ronto: { name: `ronto`, value: 1e-27, scientific: true }, quecto: { name: `quecto`, value: 1e-30, scientific: true } }, SQUARED: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 100, scientific: false }, h: { name: `h`, value: 1e4, scientific: false }, k: { name: `k`, value: 1e6, scientific: true }, M: { name: `M`, value: 1e12, scientific: true }, G: { name: `G`, value: 1e18, scientific: true }, T: { name: `T`, value: 1e24, scientific: true }, P: { name: `P`, value: 1e30, scientific: true }, E: { name: `E`, value: 1e36, scientific: true }, Z: { name: `Z`, value: 1e42, scientific: true }, Y: { name: `Y`, value: 1e48, scientific: true }, R: { name: `R`, value: 1e54, scientific: true }, Q: { name: `Q`, value: 1e60, scientific: true }, d: { name: `d`, value: 0.01, scientific: false }, c: { name: `c`, value: 1e-4, scientific: false }, m: { name: `m`, value: 1e-6, scientific: true }, u: { name: `u`, value: 1e-12, scientific: true }, n: { name: `n`, value: 1e-18, scientific: true }, p: { name: `p`, value: 1e-24, scientific: true }, f: { name: `f`, value: 1e-30, scientific: true }, a: { name: `a`, value: 1e-36, scientific: true }, z: { name: `z`, value: 1e-42, scientific: true }, y: { name: `y`, value: 1e-48, scientific: true }, r: { name: `r`, value: 1e-54, scientific: true }, q: { name: `q`, value: 1e-60, scientific: true } }, CUBIC: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 1e3, scientific: false }, h: { name: `h`, value: 1e6, scientific: false }, k: { name: `k`, value: 1e9, scientific: true }, M: { name: `M`, value: 1e18, scientific: true }, G: { name: `G`, value: 1e27, scientific: true }, T: { name: `T`, value: 1e36, scientific: true }, P: { name: `P`, value: 1e45, scientific: true }, E: { name: `E`, value: 1e54, scientific: true }, Z: { name: `Z`, value: 1e63, scientific: true }, Y: { name: `Y`, value: 1e72, scientific: true }, R: { name: `R`, value: 1e81, scientific: true }, Q: { name: `Q`, value: 1e90, scientific: true }, d: { name: `d`, value: 1e-3, scientific: false }, c: { name: `c`, value: 1e-6, scientific: false }, m: { name: `m`, value: 1e-9, scientific: true }, u: { name: `u`, value: 1e-18, scientific: true }, n: { name: `n`, value: 1e-27, scientific: true }, p: { name: `p`, value: 1e-36, scientific: true }, f: { name: `f`, value: 1e-45, scientific: true }, a: { name: `a`, value: 1e-54, scientific: true }, z: { name: `z`, value: 1e-63, scientific: true }, y: { name: `y`, value: 1e-72, scientific: true }, r: { name: `r`, value: 1e-81, scientific: true }, q: { name: `q`, value: 1e-90, scientific: true } }, BINARY_SHORT_SI: { "": { name: ``, value: 1, scientific: true }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true } }, BINARY_SHORT_IEC: { "": { name: ``, value: 1, scientific: true }, Ki: { name: `Ki`, value: 1024, scientific: true }, Mi: { name: `Mi`, value: 1024 ** 2, scientific: true }, Gi: { name: `Gi`, value: 1024 ** 3, scientific: true }, Ti: { name: `Ti`, value: 1024 ** 4, scientific: true }, Pi: { name: `Pi`, value: 1024 ** 5, scientific: true }, Ei: { name: `Ei`, value: 1024 ** 6, scientific: true }, Zi: { name: `Zi`, value: 1024 ** 7, scientific: true }, Yi: { name: `Yi`, value: 1024 ** 8, scientific: true } }, BINARY_LONG_SI: { "": { name: ``, value: 1, scientific: true }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true } }, BINARY_LONG_IEC: { "": { name: ``, value: 1, scientific: true }, kibi: { name: `kibi`, value: 1024, scientific: true }, mebi: { name: `mebi`, value: 1024 ** 2, scientific: true }, gibi: { name: `gibi`, value: 1024 ** 3, scientific: true }, tebi: { name: `tebi`, value: 1024 ** 4, scientific: true }, pebi: { name: `pebi`, value: 1024 ** 5, scientific: true }, exi: { name: `exi`, value: 1024 ** 6, scientific: true }, zebi: { name: `zebi`, value: 1024 ** 7, scientific: true }, yobi: { name: `yobi`, value: 1024 ** 8, scientific: true } }, BTU: { "": { name: ``, value: 1, scientific: true }, MM: { name: `MM`, value: 1e6, scientific: true } } };
  J.SHORTLONG = _extends$3({}, J.SHORT, J.LONG), J.BINARY_SHORT = _extends$3({}, J.BINARY_SHORT_SI, J.BINARY_SHORT_IEC), J.BINARY_LONG = _extends$3({}, J.BINARY_LONG_SI, J.BINARY_LONG_IEC);
  var ee2 = [`MASS`, `LENGTH`, `TIME`, `CURRENT`, `TEMPERATURE`, `LUMINOUS_INTENSITY`, `AMOUNT_OF_SUBSTANCE`, `ANGLE`, `BIT`], Y2 = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var te2 in Y2) hasOwnProperty$1$3(Y2, te2) && (Y2[te2].key = te2);
  var ne2 = { name: ``, base: {}, value: 1, offset: 0, dimensions: ee2.map((t5) => 0) }, X2 = { meter: { name: `meter`, base: Y2.LENGTH, prefixes: J.LONG, value: 1, offset: 0 }, inch: { name: `inch`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, foot: { name: `foot`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yard: { name: `yard`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mile: { name: `mile`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, link: { name: `link`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rod: { name: `rod`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.0292, offset: 0 }, chain: { name: `chain`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, angstrom: { name: `angstrom`, base: Y2.LENGTH, prefixes: J.NONE, value: 1e-10, offset: 0 }, m: { name: `m`, base: Y2.LENGTH, prefixes: J.SHORT, value: 1, offset: 0 }, in: { name: `in`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, ft: { name: `ft`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yd: { name: `yd`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mi: { name: `mi`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, li: { name: `li`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rd: { name: `rd`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.02921, offset: 0 }, ch: { name: `ch`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, mil: { name: `mil`, base: Y2.LENGTH, prefixes: J.NONE, value: 254e-7, offset: 0 }, m2: { name: `m2`, base: Y2.SURFACE, prefixes: J.SQUARED, value: 1, offset: 0 }, sqin: { name: `sqin`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-8, offset: 0 }, sqft: { name: `sqft`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: `sqyd`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: `sqmi`, base: Y2.SURFACE, prefixes: J.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: `sqrd`, base: Y2.SURFACE, prefixes: J.NONE, value: 25.29295, offset: 0 }, sqch: { name: `sqch`, base: Y2.SURFACE, prefixes: J.NONE, value: 404.6873, offset: 0 }, sqmil: { name: `sqmil`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-14, offset: 0 }, acre: { name: `acre`, base: Y2.SURFACE, prefixes: J.NONE, value: 4046.86, offset: 0 }, hectare: { name: `hectare`, base: Y2.SURFACE, prefixes: J.NONE, value: 1e4, offset: 0 }, m3: { name: `m3`, base: Y2.VOLUME, prefixes: J.CUBIC, value: 1, offset: 0 }, L: { name: `L`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, l: { name: `l`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, litre: { name: `litre`, base: Y2.VOLUME, prefixes: J.LONG, value: 1e-3, offset: 0 }, cuin: { name: `cuin`, base: Y2.VOLUME, prefixes: J.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: `cuft`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: `cuyd`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: `teaspoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: `tablespoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 15e-6, offset: 0 }, drop: { name: `drop`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, gtt: { name: `gtt`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, minim: { name: `minim`, base: Y2.VOLUME, prefixes: J.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: `fluiddram`, base: Y2.VOLUME, prefixes: J.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: `fluidounce`, base: Y2.VOLUME, prefixes: J.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: `gill`, base: Y2.VOLUME, prefixes: J.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: `cc`, base: Y2.VOLUME, prefixes: J.NONE, value: 1e-6, offset: 0 }, cup: { name: `cup`, base: Y2.VOLUME, prefixes: J.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: `pint`, base: Y2.VOLUME, prefixes: J.NONE, value: 473176473e-12, offset: 0 }, quart: { name: `quart`, base: Y2.VOLUME, prefixes: J.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: `gallon`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: `beerbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: `oilbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: `hogshead`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.238480942392, offset: 0 }, g: { name: `g`, base: Y2.MASS, prefixes: J.SHORT, value: 1e-3, offset: 0 }, gram: { name: `gram`, base: Y2.MASS, prefixes: J.LONG, value: 1e-3, offset: 0 }, ton: { name: `ton`, base: Y2.MASS, prefixes: J.SHORT, value: 907.18474, offset: 0 }, t: { name: `t`, base: Y2.MASS, prefixes: J.SHORT, value: 1e3, offset: 0 }, tonne: { name: `tonne`, base: Y2.MASS, prefixes: J.LONG, value: 1e3, offset: 0 }, grain: { name: `grain`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dram: { name: `dram`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: `ounce`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: `poundmass`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: `hundredweight`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, stick: { name: `stick`, base: Y2.MASS, prefixes: J.NONE, value: 0.115, offset: 0 }, stone: { name: `stone`, base: Y2.MASS, prefixes: J.NONE, value: 6.35029318, offset: 0 }, gr: { name: `gr`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dr: { name: `dr`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: `oz`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: `lbm`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, cwt: { name: `cwt`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, s: { name: `s`, base: Y2.TIME, prefixes: J.SHORT, value: 1, offset: 0 }, min: { name: `min`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, h: { name: `h`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, second: { name: `second`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, sec: { name: `sec`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, minute: { name: `minute`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, hour: { name: `hour`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, day: { name: `day`, base: Y2.TIME, prefixes: J.NONE, value: 86400, offset: 0 }, week: { name: `week`, base: Y2.TIME, prefixes: J.NONE, value: 7 * 86400, offset: 0 }, month: { name: `month`, base: Y2.TIME, prefixes: J.NONE, value: 2629800, offset: 0 }, year: { name: `year`, base: Y2.TIME, prefixes: J.NONE, value: 31557600, offset: 0 }, decade: { name: `decade`, base: Y2.TIME, prefixes: J.NONE, value: 315576e3, offset: 0 }, century: { name: `century`, base: Y2.TIME, prefixes: J.NONE, value: 315576e4, offset: 0 }, millennium: { name: `millennium`, base: Y2.TIME, prefixes: J.NONE, value: 315576e5, offset: 0 }, hertz: { name: `Hertz`, base: Y2.FREQUENCY, prefixes: J.LONG, value: 1, offset: 0, reciprocal: true }, Hz: { name: `Hz`, base: Y2.FREQUENCY, prefixes: J.SHORT, value: 1, offset: 0, reciprocal: true }, rad: { name: `rad`, base: Y2.ANGLE, prefixes: J.SHORT, value: 1, offset: 0 }, radian: { name: `radian`, base: Y2.ANGLE, prefixes: J.LONG, value: 1, offset: 0 }, deg: { name: `deg`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, degree: { name: `degree`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, grad: { name: `grad`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, gradian: { name: `gradian`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, cycle: { name: `cycle`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcsec: { name: `arcsec`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcmin: { name: `arcmin`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, A: { name: `A`, base: Y2.CURRENT, prefixes: J.SHORT, value: 1, offset: 0 }, ampere: { name: `ampere`, base: Y2.CURRENT, prefixes: J.LONG, value: 1, offset: 0 }, K: { name: `K`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 0 }, degC: { name: `degC`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 273.15 }, degF: { name: `degF`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 459.67 }, degR: { name: `degR`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 0 }, kelvin: { name: `kelvin`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 0 }, celsius: { name: `celsius`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: `fahrenheit`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 459.67 }, rankine: { name: `rankine`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 0 }, mol: { name: `mol`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, mole: { name: `mole`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.LONG, value: 1, offset: 0 }, cd: { name: `cd`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, candela: { name: `candela`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.LONG, value: 1, offset: 0 }, N: { name: `N`, base: Y2.FORCE, prefixes: J.SHORT, value: 1, offset: 0 }, newton: { name: `newton`, base: Y2.FORCE, prefixes: J.LONG, value: 1, offset: 0 }, dyn: { name: `dyn`, base: Y2.FORCE, prefixes: J.SHORT, value: 1e-5, offset: 0 }, dyne: { name: `dyne`, base: Y2.FORCE, prefixes: J.LONG, value: 1e-5, offset: 0 }, lbf: { name: `lbf`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: `poundforce`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: `kip`, base: Y2.FORCE, prefixes: J.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: `kilogramforce`, base: Y2.FORCE, prefixes: J.NONE, value: 9.80665, offset: 0 }, J: { name: `J`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1, offset: 0 }, joule: { name: `joule`, base: Y2.ENERGY, prefixes: J.LONG, value: 1, offset: 0 }, erg: { name: `erg`, base: Y2.ENERGY, prefixes: J.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: `Wh`, base: Y2.ENERGY, prefixes: J.SHORT, value: 3600, offset: 0 }, BTU: { name: `BTU`, base: Y2.ENERGY, prefixes: J.BTU, value: 1055.05585262, offset: 0 }, eV: { name: `eV`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: `electronvolt`, base: Y2.ENERGY, prefixes: J.LONG, value: 1602176565e-28, offset: 0 }, W: { name: `W`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, watt: { name: `watt`, base: Y2.POWER, prefixes: J.LONG, value: 1, offset: 0 }, hp: { name: `hp`, base: Y2.POWER, prefixes: J.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: `VAR`, base: Y2.POWER, prefixes: J.SHORT, value: v2.I, offset: 0 }, VA: { name: `VA`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, Pa: { name: `Pa`, base: Y2.PRESSURE, prefixes: J.SHORT, value: 1, offset: 0 }, psi: { name: `psi`, base: Y2.PRESSURE, prefixes: J.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: `atm`, base: Y2.PRESSURE, prefixes: J.NONE, value: 101325, offset: 0 }, bar: { name: `bar`, base: Y2.PRESSURE, prefixes: J.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: `torr`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmHg: { name: `mmHg`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmH2O: { name: `mmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: `cmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 98.0665, offset: 0 }, coulomb: { name: `coulomb`, base: Y2.ELECTRIC_CHARGE, prefixes: J.LONG, value: 1, offset: 0 }, C: { name: `C`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 1, offset: 0 }, Ah: { name: `Ah`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 3600, offset: 0 }, farad: { name: `farad`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.LONG, value: 1, offset: 0 }, F: { name: `F`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.SHORT, value: 1, offset: 0 }, volt: { name: `volt`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.LONG, value: 1, offset: 0 }, V: { name: `V`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.SHORT, value: 1, offset: 0 }, ohm: { name: `ohm`, base: Y2.ELECTRIC_RESISTANCE, prefixes: J.SHORTLONG, value: 1, offset: 0 }, henry: { name: `henry`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, H: { name: `H`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, siemens: { name: `siemens`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, S: { name: `S`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, weber: { name: `weber`, base: Y2.MAGNETIC_FLUX, prefixes: J.LONG, value: 1, offset: 0 }, Wb: { name: `Wb`, base: Y2.MAGNETIC_FLUX, prefixes: J.SHORT, value: 1, offset: 0 }, tesla: { name: `tesla`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.LONG, value: 1, offset: 0 }, T: { name: `T`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, b: { name: `b`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: `bits`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 1, offset: 0 }, B: { name: `B`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: `bytes`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 8, offset: 0 } }, ie2 = { meters: `meter`, inches: `inch`, feet: `foot`, yards: `yard`, miles: `mile`, links: `link`, rods: `rod`, chains: `chain`, angstroms: `angstrom`, lt: `l`, litres: `litre`, liter: `litre`, liters: `litre`, teaspoons: `teaspoon`, tablespoons: `tablespoon`, minims: `minim`, fldr: `fluiddram`, fluiddrams: `fluiddram`, floz: `fluidounce`, fluidounces: `fluidounce`, gi: `gill`, gills: `gill`, cp: `cup`, cups: `cup`, pt: `pint`, pints: `pint`, qt: `quart`, quarts: `quart`, gal: `gallon`, gallons: `gallon`, bbl: `beerbarrel`, beerbarrels: `beerbarrel`, obl: `oilbarrel`, oilbarrels: `oilbarrel`, hogsheads: `hogshead`, gtts: `gtt`, grams: `gram`, tons: `ton`, tonnes: `tonne`, grains: `grain`, drams: `dram`, ounces: `ounce`, poundmasses: `poundmass`, hundredweights: `hundredweight`, sticks: `stick`, lb: `lbm`, lbs: `lbm`, kips: `kip`, kgf: `kilogramforce`, acres: `acre`, hectares: `hectare`, sqfeet: `sqft`, sqyard: `sqyd`, sqmile: `sqmi`, sqmiles: `sqmi`, mmhg: `mmHg`, mmh2o: `mmH2O`, cmh2o: `cmH2O`, seconds: `second`, secs: `second`, minutes: `minute`, mins: `minute`, hours: `hour`, hr: `hour`, hrs: `hour`, days: `day`, weeks: `week`, months: `month`, years: `year`, decades: `decade`, centuries: `century`, millennia: `millennium`, hertz: `hertz`, radians: `radian`, degrees: `degree`, gradians: `gradian`, cycles: `cycle`, arcsecond: `arcsec`, arcseconds: `arcsec`, arcminute: `arcmin`, arcminutes: `arcmin`, BTUs: `BTU`, watts: `watt`, joules: `joule`, amperes: `ampere`, amps: `ampere`, amp: `ampere`, coulombs: `coulomb`, volts: `volt`, ohms: `ohm`, farads: `farad`, webers: `weber`, teslas: `tesla`, electronvolts: `electronvolt`, moles: `mole`, bit: `bits`, byte: `bytes` };
  function ae2(t5) {
    if (t5.number === `BigNumber`) {
      var n3 = createBigNumberPi$1(y2);
      X2.rad.value = new y2(1), X2.deg.value = n3.div(180), X2.grad.value = n3.div(200), X2.cycle.value = n3.times(2), X2.arcsec.value = n3.div(648e3), X2.arcmin.value = n3.div(10800);
    } else X2.rad.value = 1, X2.deg.value = Math.PI / 180, X2.grad.value = Math.PI / 200, X2.cycle.value = Math.PI * 2, X2.arcsec.value = Math.PI / 648e3, X2.arcmin.value = Math.PI / 10800;
    X2.radian.value = X2.rad.value, X2.degree.value = X2.deg.value, X2.gradian.value = X2.grad.value;
  }
  ae2(r2), n2 && n2(`config`, function(t5, n3) {
    t5.number !== n3.number && ae2(t5);
  });
  var Z2 = { si: { NONE: { unit: ne2, prefix: J.NONE[``] }, LENGTH: { unit: X2.m, prefix: J.SHORT[``] }, MASS: { unit: X2.g, prefix: J.SHORT.k }, TIME: { unit: X2.s, prefix: J.SHORT[``] }, CURRENT: { unit: X2.A, prefix: J.SHORT[``] }, TEMPERATURE: { unit: X2.K, prefix: J.SHORT[``] }, LUMINOUS_INTENSITY: { unit: X2.cd, prefix: J.SHORT[``] }, AMOUNT_OF_SUBSTANCE: { unit: X2.mol, prefix: J.SHORT[``] }, ANGLE: { unit: X2.rad, prefix: J.SHORT[``] }, BIT: { unit: X2.bits, prefix: J.SHORT[``] }, FORCE: { unit: X2.N, prefix: J.SHORT[``] }, ENERGY: { unit: X2.J, prefix: J.SHORT[``] }, POWER: { unit: X2.W, prefix: J.SHORT[``] }, PRESSURE: { unit: X2.Pa, prefix: J.SHORT[``] }, ELECTRIC_CHARGE: { unit: X2.C, prefix: J.SHORT[``] }, ELECTRIC_CAPACITANCE: { unit: X2.F, prefix: J.SHORT[``] }, ELECTRIC_POTENTIAL: { unit: X2.V, prefix: J.SHORT[``] }, ELECTRIC_RESISTANCE: { unit: X2.ohm, prefix: J.SHORT[``] }, ELECTRIC_INDUCTANCE: { unit: X2.H, prefix: J.SHORT[``] }, ELECTRIC_CONDUCTANCE: { unit: X2.S, prefix: J.SHORT[``] }, MAGNETIC_FLUX: { unit: X2.Wb, prefix: J.SHORT[``] }, MAGNETIC_FLUX_DENSITY: { unit: X2.T, prefix: J.SHORT[``] }, FREQUENCY: { unit: X2.Hz, prefix: J.SHORT[``] } } };
  Z2.cgs = JSON.parse(JSON.stringify(Z2.si)), Z2.cgs.LENGTH = { unit: X2.m, prefix: J.SHORT.c }, Z2.cgs.MASS = { unit: X2.g, prefix: J.SHORT[``] }, Z2.cgs.FORCE = { unit: X2.dyn, prefix: J.SHORT[``] }, Z2.cgs.ENERGY = { unit: X2.erg, prefix: J.NONE[``] }, Z2.us = JSON.parse(JSON.stringify(Z2.si)), Z2.us.LENGTH = { unit: X2.ft, prefix: J.NONE[``] }, Z2.us.MASS = { unit: X2.lbm, prefix: J.NONE[``] }, Z2.us.TEMPERATURE = { unit: X2.degF, prefix: J.NONE[``] }, Z2.us.FORCE = { unit: X2.lbf, prefix: J.NONE[``] }, Z2.us.ENERGY = { unit: X2.BTU, prefix: J.BTU[``] }, Z2.us.POWER = { unit: X2.hp, prefix: J.NONE[``] }, Z2.us.PRESSURE = { unit: X2.psi, prefix: J.NONE[``] }, Z2.auto = JSON.parse(JSON.stringify(Z2.si));
  var oe2 = Z2.auto;
  for (var $2 in E.setUnitSystem = function(t5) {
    if (hasOwnProperty$1$3(Z2, t5)) oe2 = Z2[t5];
    else throw Error(`Unit system ` + t5 + ` does not exist. Choices are: ` + Object.keys(Z2).join(`, `));
  }, E.getUnitSystem = function() {
    for (var t5 in Z2) if (hasOwnProperty$1$3(Z2, t5) && Z2[t5] === oe2) return t5;
  }, E.typeConverters = { BigNumber: function(t5) {
    return t5 != null && t5.isFraction ? new y2(String(t5.n)).div(String(t5.d)).times(String(t5.s)) : new y2(t5 + ``);
  }, Fraction: function(t5) {
    return new b2(t5);
  }, Complex: function(t5) {
    return t5;
  }, number: function(t5) {
    return t5 != null && t5.isFraction ? g2(t5) : t5;
  } }, E.prototype._numberConverter = function() {
    var t5 = E.typeConverters[this.valueType()];
    if (t5) return t5;
    throw TypeError(`Unsupported Unit value type "` + this.valueType() + `"`);
  }, E._getNumberConverter = function(t5) {
    if (!E.typeConverters[t5]) throw TypeError(`Unsupported type "` + t5 + `"`);
    return E.typeConverters[t5];
  }, X2) if (hasOwnProperty$1$3(X2, $2)) {
    var se2 = X2[$2];
    se2.dimensions = se2.base.dimensions;
  }
  for (var ce2 in ie2) if (hasOwnProperty$1$3(ie2, ce2)) {
    var le2 = X2[ie2[ce2]], ue2 = {};
    for (var de2 in le2) hasOwnProperty$1$3(le2, de2) && (ue2[de2] = le2[de2]);
    ue2.name = ce2, X2[ce2] = ue2;
  }
  E.isValidAlpha = function(t5) {
    return /^[a-zA-Z]$/.test(t5);
  };
  function fe2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      if (j2 = t5.charAt(n3), n3 === 0 && !E.isValidAlpha(j2)) throw Error(`Invalid unit name (must begin with alpha character): "` + t5 + `"`);
      if (n3 > 0 && !(E.isValidAlpha(j2) || F(j2))) throw Error(`Invalid unit name (only alphanumeric characters are allowed): "` + t5 + `"`);
    }
  }
  return E.createUnit = function(t5, n3) {
    if (typeof t5 != `object`) throw TypeError(`createUnit expects first parameter to be of type 'Object'`);
    if (n3 && n3.override) {
      for (var r3 in t5) if (hasOwnProperty$1$3(t5, r3) && E.deleteUnit(r3), t5[r3].aliases) for (var i3 = 0; i3 < t5[r3].aliases.length; i3++) E.deleteUnit(t5[r3].aliases[i3]);
    }
    var a3;
    for (var o3 in t5) hasOwnProperty$1$3(t5, o3) && (a3 = E.createUnitSingle(o3, t5[o3]));
    return a3;
  }, E.createUnitSingle = function(t5, n3) {
    if (n3 ??= {}, typeof t5 != `string`) throw TypeError(`createUnitSingle expects first parameter to be of type 'string'`);
    if (hasOwnProperty$1$3(X2, t5)) throw Error(`Cannot create unit "` + t5 + `": a unit with that name already exists`);
    fe2(t5);
    var r3 = null, i3 = [], a3 = 0, o3, s3, c3;
    if (n3 && n3.type === `Unit`) r3 = n3.clone();
    else if (typeof n3 == `string`) n3 !== `` && (o3 = n3);
    else if (typeof n3 == `object`) o3 = n3.definition, s3 = n3.prefixes, a3 = n3.offset, c3 = n3.baseName, n3.aliases && (i3 = n3.aliases.valueOf());
    else throw TypeError(`Cannot create unit "` + t5 + `" from "` + n3.toString() + `": expecting "string" or "Unit" or "Object"`);
    if (i3) {
      for (var l3 = 0; l3 < i3.length; l3++) if (hasOwnProperty$1$3(X2, i3[l3])) throw Error(`Cannot create alias "` + i3[l3] + `": a unit with that name already exists`);
    }
    if (o3 && typeof o3 == `string` && !r3) try {
      r3 = E.parse(o3, { allowNoUnits: true });
    } catch (n4) {
      throw n4.message = `Could not create unit "` + t5 + `" from "` + o3 + `": ` + n4.message, n4;
    }
    else o3 && o3.type === `Unit` && (r3 = o3.clone());
    i3 ||= [], a3 ||= 0, s3 = s3 && s3.toUpperCase && J[s3.toUpperCase()] || J.NONE;
    var u3 = {};
    if (r3) {
      u3 = { name: t5, value: r3.value, dimensions: r3.dimensions.slice(0), prefixes: s3, offset: a3 };
      var d3 = false;
      for (var p3 in Y2) if (hasOwnProperty$1$3(Y2, p3)) {
        for (var m3 = true, h3 = 0; h3 < ee2.length; h3++) if (Math.abs((u3.dimensions[h3] || 0) - (Y2[p3].dimensions[h3] || 0)) > 1e-12) {
          m3 = false;
          break;
        }
        if (m3) {
          d3 = true, u3.base = Y2[p3];
          break;
        }
      }
      if (!d3) {
        c3 ||= t5 + `_STUFF`;
        var g3 = { dimensions: r3.dimensions.slice(0) };
        g3.key = c3, Y2[c3] = g3, oe2[c3] = { unit: u3, prefix: J.NONE[``] }, u3.base = Y2[c3];
      }
    } else {
      if (c3 ||= t5 + `_STUFF`, ee2.indexOf(c3) >= 0) throw Error(`Cannot create new base unit "` + t5 + `": a base unit with that name already exists (and cannot be overridden)`);
      for (var v3 in ee2.push(c3), Y2) hasOwnProperty$1$3(Y2, v3) && (Y2[v3].dimensions[ee2.length - 1] = 0);
      for (var y3 = { dimensions: [] }, b3 = 0; b3 < ee2.length; b3++) y3.dimensions[b3] = 0;
      y3.dimensions[ee2.length - 1] = 1, y3.key = c3, Y2[c3] = y3, u3 = { name: t5, value: 1, dimensions: Y2[c3].dimensions.slice(0), prefixes: s3, offset: a3, base: Y2[c3] }, oe2[c3] = { unit: u3, prefix: J.NONE[``] };
    }
    E.UNITS[t5] = u3;
    for (var x3 = 0; x3 < i3.length; x3++) {
      var S3 = i3[x3], w3 = {};
      for (var D2 in u3) hasOwnProperty$1$3(u3, D2) && (w3[D2] = u3[D2]);
      w3.name = S3, E.UNITS[S3] = w3;
    }
    return delete H2.cache, new E(null, t5);
  }, E.deleteUnit = function(t5) {
    delete E.UNITS[t5], delete H2.cache;
  }, E.PREFIXES = J, E.BASE_DIMENSIONS = ee2, E.BASE_UNITS = Y2, E.UNIT_SYSTEMS = Z2, E.UNITS = X2, E;
}, { isClass: true }), name$156$1 = `unit`, dependencies$156$1 = [`typed`, `Unit`], createUnitFunction$1 = factory$1(name$156$1, dependencies$156$1, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$156$1, { Unit: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2.isValuelessUnit(t5) ? new r2(null, t5) : r2.parse(t5, { allowNoUnits: true });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(t5, n3) {
    return new r2(t5, n3);
  }, "number | BigNumber | Fraction": function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$155$1 = `sparse`, dependencies$155$1 = [`typed`, `SparseMatrix`], createSparse$1 = factory$1(name$155$1, dependencies$155$1, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return n2(name$155$1, { "": function() {
    return new r2([]);
  }, string: function(t5) {
    return new r2([], t5);
  }, "Array | Matrix": function(t5) {
    return new r2(t5);
  }, "Array | Matrix, string": function(t5, n3) {
    return new r2(t5, n3);
  } });
}), name$154$1 = `createUnit`, dependencies$154$1 = [`typed`, `Unit`], createCreateUnit$1 = factory$1(name$154$1, dependencies$154$1, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$154$1, { "Object, Object": function(t5, n3) {
    return r2.createUnit(t5, n3);
  }, Object: function(t5) {
    return r2.createUnit(t5, {});
  }, "string, Unit | string | Object, Object": function(t5, n3, i2) {
    var a2 = {};
    return a2[t5] = n3, r2.createUnit(a2, i2);
  }, "string, Unit | string | Object": function(t5, n3) {
    var i2 = {};
    return i2[t5] = n3, r2.createUnit(i2, {});
  }, string: function(t5) {
    var n3 = {};
    return n3[t5] = {}, r2.createUnit(n3, {});
  } });
}), name$153$1 = `acos`, dependencies$153$1 = [`typed`, `config`, `Complex`], createAcos$1 = factory$1(name$153$1, dependencies$153$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$153$1, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.acos(t5) : new i2(t5, 0).acos();
  }, Complex: function(t5) {
    return t5.acos();
  }, BigNumber: function(t5) {
    return t5.acos();
  } });
}), name$152$1 = `acosh`, dependencies$152$1 = [`typed`, `config`, `Complex`], createAcosh$1 = factory$1(name$152$1, dependencies$152$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$152$1, { number: function(t5) {
    return t5 >= 1 || r2.predictable ? acoshNumber$1(t5) : t5 <= -1 ? new i2(Math.log(Math.sqrt(t5 * t5 - 1) - t5), Math.PI) : new i2(t5, 0).acosh();
  }, Complex: function(t5) {
    return t5.acosh();
  }, BigNumber: function(t5) {
    return t5.acosh();
  } });
}), name$151$1 = `acot`, dependencies$151$1 = [`typed`, `BigNumber`], createAcot$1 = factory$1(name$151$1, dependencies$151$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$151$1, { number: acotNumber$1, Complex: function(t5) {
    return t5.acot();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).atan();
  } });
}), name$150$1 = `acoth`, dependencies$150$1 = [`typed`, `config`, `Complex`, `BigNumber`], createAcoth$1 = factory$1(name$150$1, dependencies$150$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$150$1, { number: function(t5) {
    return t5 >= 1 || t5 <= -1 || r2.predictable ? acothNumber$1(t5) : new i2(t5, 0).acoth();
  }, Complex: function(t5) {
    return t5.acoth();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).atanh();
  } });
}), name$149$1 = `acsc`, dependencies$149$1 = [`typed`, `config`, `Complex`, `BigNumber`], createAcsc$1 = factory$1(name$149$1, dependencies$149$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$149$1, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? acscNumber$1(t5) : new i2(t5, 0).acsc();
  }, Complex: function(t5) {
    return t5.acsc();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).asin();
  } });
}), name$148$1 = `acsch`, dependencies$148$1 = [`typed`, `BigNumber`], createAcsch$1 = factory$1(name$148$1, dependencies$148$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$148$1, { number: acschNumber$1, Complex: function(t5) {
    return t5.acsch();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).asinh();
  } });
}), name$147$1 = `asec`, dependencies$147$1 = [`typed`, `config`, `Complex`, `BigNumber`], createAsec$1 = factory$1(name$147$1, dependencies$147$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$147$1, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? asecNumber$1(t5) : new i2(t5, 0).asec();
  }, Complex: function(t5) {
    return t5.asec();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acos();
  } });
}), name$146$1 = `asech`, dependencies$146$1 = [`typed`, `config`, `Complex`, `BigNumber`], createAsech$1 = factory$1(name$146$1, dependencies$146$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$146$1, { number: function(t5) {
    if (t5 <= 1 && t5 >= -1 || r2.predictable) {
      var n3 = 1 / t5;
      if (n3 > 0 || r2.predictable) return asechNumber$1(t5);
      var a3 = Math.sqrt(n3 * n3 - 1);
      return new i2(Math.log(a3 - n3), Math.PI);
    }
    return new i2(t5, 0).asech();
  }, Complex: function(t5) {
    return t5.asech();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acosh();
  } });
}), name$145$1 = `asin`, dependencies$145$1 = [`typed`, `config`, `Complex`], createAsin$1 = factory$1(name$145$1, dependencies$145$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$145$1, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.asin(t5) : new i2(t5, 0).asin();
  }, Complex: function(t5) {
    return t5.asin();
  }, BigNumber: function(t5) {
    return t5.asin();
  } });
}), name$144$1 = `asinh`, dependencies$144$1 = [`typed`], createAsinh$1 = factory$1(name$144$1, dependencies$144$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`asinh`, { number: asinhNumber$1, Complex: function(t5) {
    return t5.asinh();
  }, BigNumber: function(t5) {
    return t5.asinh();
  } });
}), name$143$1 = `atan`, dependencies$143$1 = [`typed`], createAtan$1 = factory$1(name$143$1, dependencies$143$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`atan`, { number: function(t5) {
    return Math.atan(t5);
  }, Complex: function(t5) {
    return t5.atan();
  }, BigNumber: function(t5) {
    return t5.atan();
  } });
}), name$142$1 = `atan2`, dependencies$142$1 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `DenseMatrix`, `concat`], createAtan2$1 = factory$1(name$142$1, dependencies$142$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0$1({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo03xDSf$1({ typed: n2 }), u2 = createMatAlgo09xS0Sf$1({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs$1({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$142$1, { "number, number": Math.atan2, "BigNumber, BigNumber": (t5, n3) => a2.atan2(t5, n3) }, m2({ scalar: `number | BigNumber`, SS: u2, DS: l2, SD: c2, Ss: d2, sS: p2 }));
}), name$141$1 = `atanh`, dependencies$141$1 = [`typed`, `config`, `Complex`], createAtanh$1 = factory$1(name$141$1, dependencies$141$1, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$141$1, { number: function(t5) {
    return t5 <= 1 && t5 >= -1 || r2.predictable ? atanhNumber$1(t5) : new i2(t5, 0).atanh();
  }, Complex: function(t5) {
    return t5.atanh();
  }, BigNumber: function(t5) {
    return t5.atanh();
  } });
}), createTrigUnit$1 = factory$1(`trigUnit`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { Unit: n2.referToSelf((t5) => (r2) => {
    if (!r2.hasBase(r2.constructor.BASE_UNITS.ANGLE)) throw TypeError(`Unit in function cot is no angle`);
    return n2.find(t5, r2.valueType())(r2.value);
  }) };
}), name$140$1 = `cos`, dependencies$140$1 = [`typed`], createCos$1 = factory$1(name$140$1, dependencies$140$1, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$1({ typed: n2 });
  return n2(name$140$1, { number: Math.cos, "Complex | BigNumber": (t5) => t5.cos() }, r2);
}), name$139$1 = `cosh`, dependencies$139$1 = [`typed`], createCosh$1 = factory$1(name$139$1, dependencies$139$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$139$1, { number: cosh$3$1, "Complex | BigNumber": (t5) => t5.cosh() });
}), name$138$1 = `cot`, dependencies$138$1 = [`typed`, `BigNumber`], createCot$1 = factory$1(name$138$1, dependencies$138$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$1({ typed: n2 });
  return n2(name$138$1, { number: cotNumber$1, Complex: (t5) => t5.cot(), BigNumber: (t5) => new r2(1).div(t5.tan()) }, i2);
}), name$137$1 = `coth`, dependencies$137$1 = [`typed`, `BigNumber`], createCoth$1 = factory$1(name$137$1, dependencies$137$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$137$1, { number: cothNumber$1, Complex: (t5) => t5.coth(), BigNumber: (t5) => new r2(1).div(t5.tanh()) });
}), name$136$1 = `csc`, dependencies$136$1 = [`typed`, `BigNumber`], createCsc$1 = factory$1(name$136$1, dependencies$136$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$1({ typed: n2 });
  return n2(name$136$1, { number: cscNumber$1, Complex: (t5) => t5.csc(), BigNumber: (t5) => new r2(1).div(t5.sin()) }, i2);
}), name$135$1 = `csch`, dependencies$135$1 = [`typed`, `BigNumber`], createCsch$1 = factory$1(name$135$1, dependencies$135$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$135$1, { number: cschNumber$1, Complex: (t5) => t5.csch(), BigNumber: (t5) => new r2(1).div(t5.sinh()) });
}), name$134$1 = `sec`, dependencies$134$1 = [`typed`, `BigNumber`], createSec$1 = factory$1(name$134$1, dependencies$134$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit$1({ typed: n2 });
  return n2(name$134$1, { number: secNumber$1, Complex: (t5) => t5.sec(), BigNumber: (t5) => new r2(1).div(t5.cos()) }, i2);
}), name$133$1 = `sech`, dependencies$133$1 = [`typed`, `BigNumber`], createSech$1 = factory$1(name$133$1, dependencies$133$1, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$133$1, { number: sechNumber$1, Complex: (t5) => t5.sech(), BigNumber: (t5) => new r2(1).div(t5.cosh()) });
}), name$132$1 = `sin`, dependencies$132$1 = [`typed`], createSin$1 = factory$1(name$132$1, dependencies$132$1, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$1({ typed: n2 });
  return n2(name$132$1, { number: Math.sin, "Complex | BigNumber": (t5) => t5.sin() }, r2);
}), name$131$1 = `sinh`, dependencies$131$1 = [`typed`], createSinh$1 = factory$1(name$131$1, dependencies$131$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$131$1, { number: sinhNumber$1, "Complex | BigNumber": (t5) => t5.sinh() });
}), name$130$1 = `tan`, dependencies$130$1 = [`typed`], createTan$1 = factory$1(name$130$1, dependencies$130$1, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit$1({ typed: n2 });
  return n2(name$130$1, { number: Math.tan, "Complex | BigNumber": (t5) => t5.tan() }, r2);
}), name$129$1 = `tanh`, dependencies$129$1 = [`typed`], createTanh$1 = factory$1(name$129$1, dependencies$129$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(`tanh`, { number: tanh$2$1, "Complex | BigNumber": (t5) => t5.tanh() });
}), name$128$1 = `setCartesian`, dependencies$128$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetCartesian$1 = factory$1(name$128$1, dependencies$128$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$128$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2 = [];
    if (i2(r2(t5), new o2(0)) !== 0 && i2(r2(n3), new o2(0)) !== 0) {
      var l2 = flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), u2 = flatten$4$1(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2);
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) c2.push([l2[d2], u2[p2]]);
    }
    return Array.isArray(t5) && Array.isArray(n3) ? c2 : new s2(c2);
  } });
}), name$127$1 = `setDifference`, dependencies$127$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDifference$1 = factory$1(name$127$1, dependencies$127$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$127$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0) c2 = [];
    else if (i2(r2(n3), new o2(0)) === 0) return flatten$4$1(t5.toArray());
    else {
      var l2 = identify$1(flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify$1(flatten$4$1(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2, p2 = 0; p2 < l2.length; p2++) {
        d2 = false;
        for (var m2 = 0; m2 < u2.length; m2++) if (a2(l2[p2].value, u2[m2].value) === 0 && l2[p2].identifier === u2[m2].identifier) {
          d2 = true;
          break;
        }
        d2 || c2.push(l2[p2]);
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize$1(c2) : new s2(generalize$1(c2));
  } });
}), name$126$1 = `setDistinct`, dependencies$126$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDistinct$1 = factory$1(name$126$1, dependencies$126$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$126$1, { "Array | Matrix": function(t5) {
    var n3;
    if (i2(r2(t5), new o2(0)) === 0) n3 = [];
    else {
      var c2 = flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2);
      n3 = [], n3.push(c2[0]);
      for (var l2 = 1; l2 < c2.length; l2++) a2(c2[l2], c2[l2 - 1]) !== 0 && n3.push(c2[l2]);
    }
    return Array.isArray(t5) ? n3 : new s2(n3);
  } });
}), name$125$1 = `setIntersect`, dependencies$125$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetIntersect$1 = factory$1(name$125$1, dependencies$125$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$125$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0 || i2(r2(n3), new o2(0)) === 0) c2 = [];
    else {
      var l2 = identify$1(flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify$1(flatten$4$1(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) if (a2(l2[d2].value, u2[p2].value) === 0 && l2[d2].identifier === u2[p2].identifier) {
        c2.push(l2[d2]);
        break;
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize$1(c2) : new s2(generalize$1(c2));
  } });
}), name$124$1 = `setIsSubset`, dependencies$124$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetIsSubset$1 = factory$1(name$124$1, dependencies$124$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$124$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (i2(r2(t5), new o2(0)) === 0) return true;
    if (i2(r2(n3), new o2(0)) === 0) return false;
    for (var s2 = identify$1(flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), c2 = identify$1(flatten$4$1(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2)), l2, u2 = 0; u2 < s2.length; u2++) {
      l2 = false;
      for (var d2 = 0; d2 < c2.length; d2++) if (a2(s2[u2].value, c2[d2].value) === 0 && s2[u2].identifier === c2[d2].identifier) {
        l2 = true;
        break;
      }
      if (l2 === false) return false;
    }
    return true;
  } });
}), name$123$1 = `setMultiplicity`, dependencies$123$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetMultiplicity$1 = factory$1(name$123$1, dependencies$123$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$123$1, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(t5, n3) {
    if (i2(r2(n3), new o2(0)) === 0) return 0;
    for (var s2 = flatten$4$1(Array.isArray(n3) ? n3 : n3.toArray()), c2 = 0, l2 = 0; l2 < s2.length; l2++) a2(s2[l2], t5) === 0 && c2++;
    return c2;
  } });
}), name$122$1 = `setPowerset`, dependencies$122$1 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetPowerset$1 = factory$1(name$122$1, dependencies$122$1, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$122$1, { "Array | Matrix": function(t5) {
    if (i2(r2(t5), new o2(0)) === 0) return [];
    for (var n3 = flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), l2 = [], u2 = 0; u2.toString(2).length <= n3.length; ) l2.push(s2(n3, u2.toString(2).split(``).reverse())), u2++;
    return c2(l2);
  } });
  function s2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3.length; i3++) n3[i3] === `1` && r3.push(t5[i3]);
    return r3;
  }
  function c2(t5) {
    for (var n3 = [], r3 = t5.length - 1; r3 > 0; r3--) for (var i3 = 0; i3 < r3; i3++) t5[i3].length > t5[i3 + 1].length && (n3 = t5[i3], t5[i3] = t5[i3 + 1], t5[i3 + 1] = n3);
    return t5;
  }
}), name$121$1 = `setSize`, dependencies$121$1 = [`typed`, `compareNatural`], createSetSize$1 = factory$1(name$121$1, dependencies$121$1, (t4) => {
  var { typed: n2, compareNatural: r2 } = t4;
  return n2(name$121$1, { "Array | Matrix": function(t5) {
    return Array.isArray(t5) ? flatten$4$1(t5).length : flatten$4$1(t5.toArray()).length;
  }, "Array | Matrix, boolean": function(t5, n3) {
    if (n3 === false || t5.length === 0) return Array.isArray(t5) ? flatten$4$1(t5).length : flatten$4$1(t5.toArray()).length;
    for (var i2 = flatten$4$1(Array.isArray(t5) ? t5 : t5.toArray()).sort(r2), a2 = 1, o2 = 1; o2 < i2.length; o2++) r2(i2[o2], i2[o2 - 1]) !== 0 && a2++;
    return a2;
  } });
}), name$120$1 = `setSymDifference`, dependencies$120$1 = [`typed`, `size`, `concat`, `subset`, `setDifference`, `Index`], createSetSymDifference$1 = factory$1(name$120$1, dependencies$120$1, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setDifference: o2, Index: s2 } = t4;
  return n2(name$120$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new s2(0)) === 0) return flatten$4$1(n3);
    if (a2(r2(n3), new s2(0)) === 0) return flatten$4$1(t5);
    var c2 = flatten$4$1(t5), l2 = flatten$4$1(n3);
    return i2(o2(c2, l2), o2(l2, c2));
  } });
}), name$119$1 = `setUnion`, dependencies$119$1 = [`typed`, `size`, `concat`, `subset`, `setIntersect`, `setSymDifference`, `Index`], createSetUnion$1 = factory$1(name$119$1, dependencies$119$1, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setIntersect: o2, setSymDifference: s2, Index: c2 } = t4;
  return n2(name$119$1, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new c2(0)) === 0) return flatten$4$1(n3);
    if (a2(r2(n3), new c2(0)) === 0) return flatten$4$1(t5);
    var l2 = flatten$4$1(t5), u2 = flatten$4$1(n3);
    return i2(s2(l2, u2), o2(l2, u2));
  } });
}), name$118$1 = `add`, dependencies$118$1 = [`typed`, `matrix`, `addScalar`, `equalScalar`, `DenseMatrix`, `SparseMatrix`, `concat`], createAdd$1 = factory$1(name$118$1, dependencies$118$1, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, equalScalar: a2, DenseMatrix: o2, SparseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid$1({ typed: n2 }), u2 = createMatAlgo04xSidSid$1({ typed: n2, equalScalar: a2 }), d2 = createMatAlgo10xSids$1({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite$1({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$118$1, { "any, any": i2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) }, p2({ elop: i2, DS: l2, SS: u2, Ss: d2 }));
}), name$117$1 = `hypot`, dependencies$117$1 = [`typed`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `sqrt`, `smaller`, `isPositive`], createHypot$1 = factory$1(name$117$1, dependencies$117$1, (t4) => {
  var { typed: n2, abs: r2, addScalar: i2, divideScalar: a2, multiplyScalar: o2, sqrt: s2, smaller: c2, isPositive: l2 } = t4;
  return n2(name$117$1, { "... number | BigNumber": u2, Array: u2, Matrix: (t5) => u2(flatten$4$1(t5.toArray(), true)) });
  function u2(t5) {
    for (var n3 = 0, u3 = 0, d2 = 0; d2 < t5.length; d2++) {
      if (isComplex$1(t5[d2])) throw TypeError(`Unexpected type of argument to hypot`);
      var p2 = r2(t5[d2]);
      c2(u3, p2) ? (n3 = o2(n3, o2(a2(u3, p2), a2(u3, p2))), n3 = i2(n3, 1), u3 = p2) : n3 = i2(n3, l2(p2) ? o2(a2(p2, u3), a2(p2, u3)) : p2);
    }
    return o2(u3, s2(n3));
  }
}), name$116$1 = `norm`, dependencies$116$1 = [`typed`, `abs`, `add`, `pow`, `conj`, `sqrt`, `multiply`, `equalScalar`, `larger`, `smaller`, `matrix`, `ctranspose`, `eigs`], createNorm$1 = factory$1(name$116$1, dependencies$116$1, (t4) => {
  var { typed: n2, abs: r2, add: i2, pow: a2, conj: o2, sqrt: s2, multiply: c2, equalScalar: l2, larger: u2, smaller: d2, matrix: p2, ctranspose: m2, eigs: h2 } = t4;
  return n2(name$116$1, { number: Math.abs, Complex: function(t5) {
    return t5.abs();
  }, BigNumber: function(t5) {
    return t5.abs();
  }, boolean: function(t5) {
    return Math.abs(t5);
  }, Array: function(t5) {
    return D(p2(t5), 2);
  }, Matrix: function(t5) {
    return D(t5, 2);
  }, "Array, number | BigNumber | string": function(t5, n3) {
    return D(p2(t5), n3);
  }, "Matrix, number | BigNumber | string": function(t5, n3) {
    return D(t5, n3);
  } });
  function g2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      u2(i3, n3) && (n3 = i3);
    }, true), n3;
  }
  function v2(t5) {
    var n3;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      (!n3 || d2(i3, n3)) && (n3 = i3);
    }, true), n3 || 0;
  }
  function y2(t5, n3) {
    if (n3 === 1 / 0 || n3 === `inf`) return g2(t5);
    if (n3 === -1 / 0 || n3 === `-inf`) return v2(t5);
    if (n3 === `fro`) return D(t5, 2);
    if (typeof n3 == `number` && !isNaN(n3)) {
      if (!l2(n3, 0)) {
        var o3 = 0;
        return t5.forEach(function(t6) {
          o3 = i2(a2(r2(t6), n3), o3);
        }, true), a2(o3, 1 / n3);
      }
      return 1 / 0;
    }
    throw Error(`Unsupported parameter value`);
  }
  function b2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6, r3) {
      n3 = i2(n3, c2(t6, o2(t6)));
    }), r2(s2(n3));
  }
  function x2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[1], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function S2(t5) {
    var n3 = t5.size();
    if (n3[0] !== n3[1]) throw RangeError(`Invalid matrix dimensions`);
    var i3 = h2(c2(m2(t5), t5)).values.toArray(), a3 = i3[i3.length - 1];
    return r2(s2(a3));
  }
  function w2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[0], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function E(t5, n3) {
    if (n3 === 1) return x2(t5);
    if (n3 === 1 / 0 || n3 === `inf`) return w2(t5);
    if (n3 === `fro`) return b2(t5);
    if (n3 === 2) return S2(t5);
    throw Error(`Unsupported parameter value ` + n3);
  }
  function D(t5, n3) {
    var r3 = t5.size();
    if (r3.length === 1) return y2(t5, n3);
    if (r3.length === 2) {
      if (r3[0] && r3[1]) return E(t5, n3);
      throw RangeError(`Invalid matrix dimensions`);
    }
  }
}), name$115$1 = `dot`, dependencies$115$1 = [`typed`, `addScalar`, `multiplyScalar`, `conj`, `size`], createDot$1 = factory$1(name$115$1, dependencies$115$1, (t4) => {
  var { typed: n2, addScalar: r2, multiplyScalar: i2, conj: a2, size: o2 } = t4;
  return n2(name$115$1, { "Array | DenseMatrix, Array | DenseMatrix": c2, "SparseMatrix, SparseMatrix": l2 });
  function s2(t5, n3) {
    var r3 = o2(t5), i3 = o2(n3), a3, s3;
    if (r3.length === 1) a3 = r3[0];
    else if (r3.length === 2 && r3[1] === 1) a3 = r3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + r3.join(`, `) + `)`);
    if (i3.length === 1) s3 = i3[0];
    else if (i3.length === 2 && i3[1] === 1) s3 = i3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + i3.join(`, `) + `)`);
    if (a3 !== s3) throw RangeError(`Vectors must have equal length (` + a3 + ` != ` + s3 + `)`);
    if (a3 === 0) throw RangeError(`Cannot calculate the dot product of empty vectors`);
    return a3;
  }
  function c2(t5, c3) {
    var l3 = s2(t5, c3), u2 = isMatrix$1(t5) ? t5._data : t5, d2 = isMatrix$1(t5) ? t5._datatype || t5.getDataType() : void 0, p2 = isMatrix$1(c3) ? c3._data : c3, m2 = isMatrix$1(c3) ? c3._datatype || c3.getDataType() : void 0, h2 = o2(t5).length === 2, g2 = o2(c3).length === 2, v2 = r2, y2 = i2;
    if (d2 && m2 && d2 === m2 && typeof d2 == `string` && d2 !== `mixed`) {
      var b2 = d2;
      v2 = n2.find(r2, [b2, b2]), y2 = n2.find(i2, [b2, b2]);
    }
    if (!h2 && !g2) {
      for (var x2 = y2(a2(u2[0]), p2[0]), S2 = 1; S2 < l3; S2++) x2 = v2(x2, y2(a2(u2[S2]), p2[S2]));
      return x2;
    }
    if (!h2 && g2) {
      for (var w2 = y2(a2(u2[0]), p2[0][0]), E = 1; E < l3; E++) w2 = v2(w2, y2(a2(u2[E]), p2[E][0]));
      return w2;
    }
    if (h2 && !g2) {
      for (var D = y2(a2(u2[0][0]), p2[0]), O2 = 1; O2 < l3; O2++) D = v2(D, y2(a2(u2[O2][0]), p2[O2]));
      return D;
    }
    if (h2 && g2) {
      for (var j2 = y2(a2(u2[0][0]), p2[0][0]), M2 = 1; M2 < l3; M2++) j2 = v2(j2, y2(a2(u2[M2][0]), p2[M2][0]));
      return j2;
    }
  }
  function l2(t5, n3) {
    s2(t5, n3);
    for (var a3 = t5._index, o3 = t5._values, c3 = n3._index, l3 = n3._values, u2 = 0, d2 = r2, p2 = i2, m2 = 0, h2 = 0; m2 < a3.length && h2 < c3.length; ) {
      var g2 = a3[m2], v2 = c3[h2];
      if (g2 < v2) {
        m2++;
        continue;
      }
      if (g2 > v2) {
        h2++;
        continue;
      }
      g2 === v2 && (u2 = d2(u2, p2(o3[m2], l3[h2])), m2++, h2++);
    }
    return u2;
  }
}), name$114$1 = `trace`, dependencies$114$1 = [`typed`, `matrix`, `add`], createTrace$1 = factory$1(name$114$1, dependencies$114$1, (t4) => {
  var { typed: n2, matrix: r2, add: i2 } = t4;
  return n2(`trace`, { Array: function(t5) {
    return a2(r2(t5));
  }, SparseMatrix: o2, DenseMatrix: a2, any: clone$3$1 });
  function a2(t5) {
    var n3 = t5._size, r3 = t5._data;
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return clone$3$1(r3[0]);
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      case 2:
        var a3 = n3[0];
        if (a3 === n3[1]) {
          for (var o3 = 0, s2 = 0; s2 < a3; s2++) o3 = i2(o3, r3[s2][s2]);
          return o3;
        } else throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$3(n3) + `)`);
    }
  }
  function o2(t5) {
    var n3 = t5._values, r3 = t5._index, a3 = t5._ptr, o3 = t5._size, s2 = o3[0], c2 = o3[1];
    if (s2 === c2) {
      var l2 = 0;
      if (n3.length > 0) for (var u2 = 0; u2 < c2; u2++) for (var d2 = a3[u2], p2 = a3[u2 + 1], m2 = d2; m2 < p2; m2++) {
        var h2 = r3[m2];
        if (h2 === u2) {
          l2 = i2(l2, n3[m2]);
          break;
        }
        if (h2 > u2) break;
      }
      return l2;
    }
    throw RangeError(`Matrix must be square (size: ` + format$3(o3) + `)`);
  }
}), name$113$1 = `index`, dependencies$113$1 = [`typed`, `Index`], createIndex$1 = factory$1(name$113$1, dependencies$113$1, (t4) => {
  var { typed: n2, Index: r2 } = t4;
  return n2(name$113$1, { "...number | string | BigNumber | Range | Array | Matrix": function(t5) {
    var n3 = t5.map(function(t6) {
      return isBigNumber$1(t6) ? t6.toNumber() : isArray$1(t6) || isMatrix$1(t6) ? t6.map(function(t7) {
        return isBigNumber$1(t7) ? t7.toNumber() : t7;
      }) : t6;
    }), i2 = new r2();
    return r2.apply(i2, n3), i2;
  } });
}), keywords$1 = /* @__PURE__ */ new Set([`end`]), name$112$1 = `Node`, dependencies$112$1 = [`mathWithTransform`], createNode$1 = factory$1(name$112$1, dependencies$112$1, (t4) => {
  var { mathWithTransform: n2 } = t4;
  function r2(t5) {
    for (var n3 of [...keywords$1]) if (t5.has(n3)) throw Error(`Scope contains an illegal symbol, "` + n3 + `" is a reserved keyword`);
  }
  class i2 {
    get type() {
      return `Node`;
    }
    get isNode() {
      return true;
    }
    evaluate(t5) {
      return this.compile().evaluate(t5);
    }
    compile() {
      var t5 = this._compile(n2, {}), i3 = {}, a2 = null;
      function o2(n3) {
        var o3 = createMap$1$1(n3);
        return r2(o3), t5(o3, i3, a2);
      }
      return { evaluate: o2 };
    }
    _compile(t5, n3) {
      throw Error(`Method _compile must be implemented by type ` + this.type);
    }
    forEach(t5) {
      throw Error(`Cannot run forEach on a Node interface`);
    }
    map(t5) {
      throw Error(`Cannot run map on a Node interface`);
    }
    _ifNode(t5) {
      if (!isNode$4(t5)) throw TypeError(`Callback function must return a Node`);
      return t5;
    }
    traverse(t5) {
      t5(this, null, null);
      function n3(t6, r3) {
        t6.forEach(function(t7, i3, a2) {
          r3(t7, i3, a2), n3(t7, r3);
        });
      }
      n3(this, t5);
    }
    transform(t5) {
      function n3(r3, i3, a2) {
        var o2 = t5(r3, i3, a2);
        return o2 === r3 ? r3.map(n3) : o2;
      }
      return n3(this, null, null);
    }
    filter(t5) {
      var n3 = [];
      return this.traverse(function(r3, i3, a2) {
        t5(r3, i3, a2) && n3.push(r3);
      }), n3;
    }
    clone() {
      throw Error(`Cannot clone a Node interface`);
    }
    cloneDeep() {
      return this.map(function(t5) {
        return t5.cloneDeep();
      });
    }
    equals(t5) {
      return t5 ? this.type === t5.type && deepStrictEqual$1(this, t5) : false;
    }
    toString(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toString(t5) : n3;
    }
    _toString() {
      throw Error(`_toString not implemented for ` + this.type);
    }
    toJSON() {
      throw Error(`Cannot serialize object: toJSON not implemented by ` + this.type);
    }
    toHTML(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toHTML(t5) : n3;
    }
    _toHTML() {
      throw Error(`_toHTML not implemented for ` + this.type);
    }
    toTex(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toTex(t5) : n3;
    }
    _toTex(t5) {
      throw Error(`_toTex not implemented for ` + this.type);
    }
    _getCustomString(t5) {
      if (t5 && typeof t5 == `object`) switch (typeof t5.handler) {
        case `object`:
        case `undefined`:
          return;
        case `function`:
          return t5.handler(this, t5);
        default:
          throw TypeError(`Object or function expected as callback`);
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  }
  return i2;
}, { isClass: true, isNode: true });
function errorTransform$1(t4) {
  return t4 && t4.isIndexError ? new IndexError$1(t4.index + 1, t4.min + 1, t4.max === void 0 ? void 0 : t4.max + 1) : t4;
}
function accessFactory$1(t4) {
  var { subset: n2 } = t4;
  return function(t5, r2) {
    try {
      if (Array.isArray(t5)) return n2(t5, r2);
      if (t5 && typeof t5.subset == `function`) return t5.subset(r2);
      if (typeof t5 == `string`) return n2(t5, r2);
      if (typeof t5 == `object`) {
        if (!r2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return getSafeProperty$1(t5, r2.getObjectProperty());
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  };
}
var name$111$1 = `AccessorNode`, dependencies$111$1 = [`subset`, `Node`], createAccessorNode$1 = factory$1(name$111$1, dependencies$111$1, (t4) => {
  var { subset: n2, Node: r2 } = t4, i2 = accessFactory$1({ subset: n2 });
  function a2(t5) {
    return !(isAccessorNode$1(t5) || isArrayNode$1(t5) || isConstantNode$1(t5) || isFunctionNode$1(t5) || isObjectNode$1(t5) || isParenthesisNode$1(t5) || isSymbolNode$1(t5));
  }
  class o2 extends r2 {
    constructor(t5, n3) {
      var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      if (super(), !isNode$4(t5)) throw TypeError(`Node expected for parameter "object"`);
      if (!isIndexNode$1(n3)) throw TypeError(`IndexNode expected for parameter "index"`);
      this.object = t5, this.index = n3, this.optionalChaining = r3;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$111$1;
    }
    get isAccessorNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), a3 = this.index._compile(t5, n3), o3 = this.optionalChaining, s2 = isAccessorNode$1(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var c2 = this.index.getObjectProperty();
        return function(t6, n4, i3) {
          var a4 = i3 || {}, l2 = r3(t6, n4, a4);
          if (o3 && l2 == null) {
            a4.optionalShortCircuit = true;
            return;
          }
          if (!(s2 && a4 != null && a4.optionalShortCircuit)) return getSafeProperty$1(l2, c2);
        };
      } else return function(t6, n4, c3) {
        var l2 = c3 || {}, u2 = r3(t6, n4, l2);
        if (o3 && u2 == null) {
          l2.optionalShortCircuit = true;
          return;
        }
        if (!(s2 && l2 != null && l2.optionalShortCircuit)) return i2(u2, a3(t6, n4, u2));
      };
    }
    forEach(t5) {
      t5(this.object, `object`, this), t5(this.index, `index`, this);
    }
    map(t5) {
      return new o2(this._ifNode(t5(this.object, `object`, this)), this._ifNode(t5(this.index, `index`, this)), this.optionalChaining);
    }
    clone() {
      return new o2(this.object, this.index, this.optionalChaining);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5);
      a2(this.object) && (n3 = `(` + n3 + `)`);
      var r3 = this.optionalChaining ? this.index.dotNotation ? `?` : `?.` : ``;
      return n3 + r3 + this.index.toString(t5);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5);
      return a2(this.object) && (n3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n3 + this.index.toHTML(t5);
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5);
      return a2(this.object) && (n3 = `\\left(' + object + '\\right)`), n3 + this.index.toTex(t5);
    }
    toJSON() {
      return { mathjs: name$111$1, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(t5) {
      return new o2(t5.object, t5.index, t5.optionalChaining);
    }
  }
  return _defineProperty$2(o2, `name`, name$111$1), o2;
}, { isClass: true, isNode: true }), name$110$1 = `ArrayNode`, dependencies$110$1 = [`Node`], createArrayNode$1 = factory$1(name$110$1, dependencies$110$1, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.items = t5 || [], !Array.isArray(this.items) || !this.items.every(isNode$4)) throw TypeError(`Array containing Nodes expected`);
    }
    get type() {
      return name$110$1;
    }
    get isArrayNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = map$1$1(this.items, function(r4) {
        return r4._compile(t5, n3);
      });
      if (t5.config.matrix !== `Array`) {
        var i2 = t5.matrix;
        return function(t6, n4, a2) {
          return i2(map$1$1(r3, function(r4) {
            return r4(t6, n4, a2);
          }));
        };
      } else return function(t6, n4, i3) {
        return map$1$1(r3, function(r4) {
          return r4(t6, n4, i3);
        });
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.items.length; n3++) {
        var r3 = this.items[n3];
        t5(r3, `items[` + n3 + `]`, this);
      }
    }
    map(t5) {
      for (var n3 = [], i2 = 0; i2 < this.items.length; i2++) n3[i2] = this._ifNode(t5(this.items[i2], `items[` + i2 + `]`, this));
      return new r2(n3);
    }
    clone() {
      return new r2(this.items.slice(0));
    }
    _toString(t5) {
      return `[` + this.items.map(function(n3) {
        return n3.toString(t5);
      }).join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$110$1, items: this.items };
    }
    static fromJSON(t5) {
      return new r2(t5.items);
    }
    _toHTML(t5) {
      return `<span class="math-parenthesis math-square-parenthesis">[</span>` + this.items.map(function(n3) {
        return n3.toHTML(t5);
      }).join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      function n3(r3, i2) {
        var a2 = r3.some(isArrayNode$1) && !r3.every(isArrayNode$1), o2 = i2 || a2, s2 = o2 ? `&` : `\\\\`, c2 = r3.map(function(r4) {
          return r4.items ? n3(r4.items, !i2) : r4.toTex(t5);
        }).join(s2);
        return a2 || !o2 || o2 && !i2 ? `\\begin{bmatrix}` + c2 + `\\end{bmatrix}` : c2;
      }
      return n3(this.items, false);
    }
  }
  return _defineProperty$2(r2, `name`, name$110$1), r2;
}, { isClass: true, isNode: true });
function assignFactory$1(t4) {
  var { subset: n2, matrix: r2 } = t4;
  return function(t5, i2, a2) {
    try {
      if (Array.isArray(t5)) return r2(t5).subset(i2, a2).valueOf().forEach((n3, r3) => {
        t5[r3] = n3;
      }), t5;
      if (t5 && typeof t5.subset == `function`) return t5.subset(i2, a2);
      if (typeof t5 == `string`) return n2(t5, i2, a2);
      if (typeof t5 == `object`) {
        if (!i2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return setSafeProperty$1(t5, i2.getObjectProperty(), a2), t5;
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  };
}
var properties$1 = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: false, latexRightParens: false, latexParens: false } }, { "OperatorNode:or": { op: `or`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:xor": { op: `xor`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:and": { op: `and`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitOr": { op: `|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitXor": { op: `^|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitAnd": { op: `&`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:equal": { op: `==`, associativity: `left`, associativeWith: [] }, "OperatorNode:unequal": { op: `!=`, associativity: `left`, associativeWith: [] }, "OperatorNode:smaller": { op: `<`, associativity: `left`, associativeWith: [] }, "OperatorNode:larger": { op: `>`, associativity: `left`, associativeWith: [] }, "OperatorNode:smallerEq": { op: `<=`, associativity: `left`, associativeWith: [] }, "OperatorNode:largerEq": { op: `>=`, associativity: `left`, associativeWith: [] }, RelationalNode: { associativity: `left`, associativeWith: [] } }, { "OperatorNode:leftShift": { op: `<<`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightArithShift": { op: `>>`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightLogShift": { op: `>>>`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:to": { op: `to`, associativity: `left`, associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: `+`, associativity: `left`, associativeWith: [`OperatorNode:add`, `OperatorNode:subtract`] }, "OperatorNode:subtract": { op: `-`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { op: `*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] }, "OperatorNode:divide": { op: `/`, associativity: `left`, associativeWith: [], latexLeftParens: false, latexRightParens: false, latexParens: false }, "OperatorNode:dotMultiply": { op: `.*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `OperatorNode:dotMultiply`, `OperatorNode:doDivide`] }, "OperatorNode:dotDivide": { op: `./`, associativity: `left`, associativeWith: [] }, "OperatorNode:mod": { op: `mod`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] } }, { "OperatorNode:unaryPlus": { op: `+`, associativity: `right` }, "OperatorNode:unaryMinus": { op: `-`, associativity: `right` }, "OperatorNode:bitNot": { op: `~`, associativity: `right` }, "OperatorNode:not": { op: `not`, associativity: `right` } }, { "OperatorNode:pow": { op: `^`, associativity: `right`, associativeWith: [], latexRightParens: false }, "OperatorNode:dotPow": { op: `.^`, associativity: `right`, associativeWith: [] } }, { "OperatorNode:nullish": { op: `??`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:factorial": { op: `!`, associativity: `left` } }, { "OperatorNode:ctranspose": { op: `'`, associativity: `left` } }];
function unwrapParen$1(t4, n2) {
  if (!n2 || n2 !== `auto`) return t4;
  for (var r2 = t4; isParenthesisNode$1(r2); ) r2 = r2.content;
  return r2;
}
function getPrecedence$1(t4, n2, r2, i2) {
  var a2 = t4;
  n2 !== `keep` && (a2 = t4.getContent());
  for (var o2 = a2.getIdentifier(), s2 = null, c2 = 0; c2 < properties$1.length; c2++) if (o2 in properties$1[c2]) {
    s2 = c2;
    break;
  }
  if (o2 === `OperatorNode:multiply` && a2.implicit && r2 !== `show`) {
    var l2 = unwrapParen$1(a2.args[0], n2);
    !(isConstantNode$1(l2) && i2 && i2.getIdentifier() === `OperatorNode:divide` && rule2Node$1(unwrapParen$1(i2.args[0], n2))) && !(l2.getIdentifier() === `OperatorNode:divide` && rule2Node$1(unwrapParen$1(l2.args[0], n2)) && isConstantNode$1(unwrapParen$1(l2.args[1]))) && (s2 += 1);
  }
  return s2;
}
function getAssociativity$1(t4, n2) {
  var r2 = t4;
  n2 !== `keep` && (r2 = t4.getContent());
  var i2 = r2.getIdentifier(), a2 = getPrecedence$1(r2, n2);
  if (a2 === null) return null;
  var o2 = properties$1[a2][i2];
  if (hasOwnProperty$1$3(o2, `associativity`)) {
    if (o2.associativity === `left`) return `left`;
    if (o2.associativity === `right`) return `right`;
    throw Error(`'` + i2 + `' has the invalid associativity '` + o2.associativity + `'.`);
  }
  return null;
}
function isAssociativeWith$1(t4, n2, r2) {
  var i2 = r2 === `keep` ? t4 : t4.getContent(), a2 = r2 === `keep` ? n2 : t4.getContent(), o2 = i2.getIdentifier(), s2 = a2.getIdentifier(), c2 = getPrecedence$1(i2, r2);
  if (c2 === null) return null;
  var l2 = properties$1[c2][o2];
  if (hasOwnProperty$1$3(l2, `associativeWith`) && l2.associativeWith instanceof Array) {
    for (var u2 = 0; u2 < l2.associativeWith.length; u2++) if (l2.associativeWith[u2] === s2) return true;
    return false;
  }
  return null;
}
function getOperator$1(t4) {
  var n2 = `OperatorNode:` + t4;
  for (var r2 of properties$1) if (n2 in r2) return r2[n2].op;
  return null;
}
var name$109$1 = `AssignmentNode`, dependencies$109$1 = [`subset`, `?matrix`, `Node`], createAssignmentNode$1 = factory$1(name$109$1, dependencies$109$1, (t4) => {
  var { subset: n2, matrix: r2, Node: i2 } = t4, a2 = accessFactory$1({ subset: n2 }), o2 = assignFactory$1({ subset: n2, matrix: r2 });
  function s2(t5, n3, r3) {
    n3 ||= `keep`;
    var i3 = getPrecedence$1(t5, n3, r3), a3 = getPrecedence$1(t5.value, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), this.object = t5, this.index = r3 ? n3 : null, this.value = r3 || n3, !isSymbolNode$1(t5) && !isAccessorNode$1(t5)) throw TypeError(`SymbolNode or AccessorNode expected as "object"`);
      if (isSymbolNode$1(t5) && t5.name === `end`) throw Error(`Cannot assign to symbol "end"`);
      if (this.index && !isIndexNode$1(this.index)) throw TypeError(`IndexNode expected as "index"`);
      if (!isNode$4(this.value)) throw TypeError(`Node expected as "value"`);
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$109$1;
    }
    get isAssignmentNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), i3 = this.index ? this.index._compile(t5, n3) : null, s3 = this.value._compile(t5, n3), c3 = this.object.name;
      if (!this.index) {
        if (!isSymbolNode$1(this.object)) throw TypeError(`SymbolNode expected as object`);
        return function(t6, n4, r4) {
          var i4 = s3(t6, n4, r4);
          return t6.set(c3, i4), i4;
        };
      } else if (this.index.isObjectProperty()) {
        var l2 = this.index.getObjectProperty();
        return function(t6, n4, i4) {
          var a3 = r3(t6, n4, i4), o3 = s3(t6, n4, i4);
          return setSafeProperty$1(a3, l2, o3), o3;
        };
      } else if (isSymbolNode$1(this.object)) return function(t6, n4, a3) {
        var l3 = r3(t6, n4, a3), u3 = s3(t6, n4, a3), d3 = i3(t6, n4, l3);
        return t6.set(c3, o2(l3, d3, u3)), u3;
      };
      else {
        var u2 = this.object.object._compile(t5, n3);
        if (this.object.index.isObjectProperty()) {
          var d2 = this.object.index.getObjectProperty();
          return function(t6, n4, r4) {
            var a3 = u2(t6, n4, r4), c4 = getSafeProperty$1(a3, d2), l3 = i3(t6, n4, c4), p3 = s3(t6, n4, r4);
            return setSafeProperty$1(a3, d2, o2(c4, l3, p3)), p3;
          };
        } else {
          var p2 = this.object.index._compile(t5, n3);
          return function(t6, n4, r4) {
            var c4 = u2(t6, n4, r4), l3 = p2(t6, n4, c4), d3 = a2(c4, l3), m2 = i3(t6, n4, d3), h2 = s3(t6, n4, r4);
            return o2(c4, l3, o2(d3, m2, h2)), h2;
          };
        }
      }
    }
    forEach(t5) {
      t5(this.object, `object`, this), this.index && t5(this.index, `index`, this), t5(this.value, `value`, this);
    }
    map(t5) {
      return new c2(this._ifNode(t5(this.object, `object`, this)), this.index ? this._ifNode(t5(this.index, `index`, this)) : null, this._ifNode(t5(this.value, `value`, this)));
    }
    clone() {
      return new c2(this.object, this.index, this.value);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5), r3 = this.index ? this.index.toString(t5) : ``, i3 = this.value.toString(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `(` + i3 + `)`), n3 + r3 + ` = ` + i3;
    }
    toJSON() {
      return { mathjs: name$109$1, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(t5) {
      return new c2(t5.object, t5.index, t5.value);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5), r3 = this.index ? this.index.toHTML(t5) : ``, i3 = this.value.toHTML(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `<span class="math-paranthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-paranthesis math-round-parenthesis">)</span>`), n3 + r3 + `<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + i3;
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5), r3 = this.index ? this.index.toTex(t5) : ``, i3 = this.value.toTex(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `\\left(${i3}\\right)`), n3 + r3 + `=` + i3;
    }
  }
  return _defineProperty$2(c2, `name`, name$109$1), c2;
}, { isClass: true, isNode: true }), name$108$1 = `BlockNode`, dependencies$108$1 = [`ResultSet`, `Node`], createBlockNode$1 = factory$1(name$108$1, dependencies$108$1, (t4) => {
  var { ResultSet: n2, Node: r2 } = t4;
  class i2 extends r2 {
    constructor(t5) {
      if (super(), !Array.isArray(t5)) throw Error(`Array expected`);
      this.blocks = t5.map(function(t6) {
        var n3 = t6 && t6.node, r3 = t6 && t6.visible !== void 0 ? t6.visible : true;
        if (!isNode$4(n3)) throw TypeError(`Property "node" must be a Node`);
        if (typeof r3 != `boolean`) throw TypeError(`Property "visible" must be a boolean`);
        return { node: n3, visible: r3 };
      });
    }
    get type() {
      return name$108$1;
    }
    get isBlockNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = map$1$1(this.blocks, function(n3) {
        return { evaluate: n3.node._compile(t5, r3), visible: n3.visible };
      });
      return function(t6, r4, a2) {
        var o2 = [];
        return forEach$1(i3, function(n3) {
          var i4 = n3.evaluate(t6, r4, a2);
          n3.visible && o2.push(i4);
        }), new n2(o2);
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.blocks.length; n3++) t5(this.blocks[n3].node, `blocks[` + n3 + `].node`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.blocks.length; r3++) {
        var a2 = this.blocks[r3];
        n3[r3] = { node: this._ifNode(t5(a2.node, `blocks[` + r3 + `].node`, this)), visible: a2.visible };
      }
      return new i2(n3);
    }
    clone() {
      return new i2(this.blocks.map(function(t5) {
        return { node: t5.node, visible: t5.visible };
      }));
    }
    _toString(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toString(t5) + (n3.visible ? `` : `;`);
      }).join(`
`);
    }
    toJSON() {
      return { mathjs: name$108$1, blocks: this.blocks };
    }
    static fromJSON(t5) {
      return new i2(t5.blocks);
    }
    _toHTML(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toHTML(t5) + (n3.visible ? `` : `<span class="math-separator">;</span>`);
      }).join(`<span class="math-separator"><br /></span>`);
    }
    _toTex(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toTex(t5) + (n3.visible ? `` : `;`);
      }).join(`\\;\\;
`);
    }
  }
  return _defineProperty$2(i2, `name`, name$108$1), i2;
}, { isClass: true, isNode: true }), name$107$1 = `ConditionalNode`, dependencies$107$1 = [`Node`], createConditionalNode$1 = factory$1(name$107$1, dependencies$107$1, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5) {
    if (typeof t5 == `number` || typeof t5 == `boolean` || typeof t5 == `string`) return !!t5;
    if (t5) {
      if (isBigNumber$1(t5)) return !t5.isZero();
      if (isComplex$1(t5)) return !!(t5.re || t5.im);
      if (isUnit$1(t5)) return !!t5.value;
    }
    if (t5 == null) return false;
    throw TypeError(`Unsupported type of condition "` + typeOf$1(t5) + `"`);
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$4(t5)) throw TypeError(`Parameter condition must be a Node`);
      if (!isNode$4(n3)) throw TypeError(`Parameter trueExpr must be a Node`);
      if (!isNode$4(r3)) throw TypeError(`Parameter falseExpr must be a Node`);
      this.condition = t5, this.trueExpr = n3, this.falseExpr = r3;
    }
    get type() {
      return name$107$1;
    }
    get isConditionalNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.condition._compile(t5, n3), a2 = this.trueExpr._compile(t5, n3), o2 = this.falseExpr._compile(t5, n3);
      return function(t6, n4, s2) {
        return r2(i3(t6, n4, s2)) ? a2(t6, n4, s2) : o2(t6, n4, s2);
      };
    }
    forEach(t5) {
      t5(this.condition, `condition`, this), t5(this.trueExpr, `trueExpr`, this), t5(this.falseExpr, `falseExpr`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.condition, `condition`, this)), this._ifNode(t5(this.trueExpr, `trueExpr`, this)), this._ifNode(t5(this.falseExpr, `falseExpr`, this)));
    }
    clone() {
      return new i2(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$1(this, n3, t5 && t5.implicit), i3 = this.condition.toString(t5), a2 = getPrecedence$1(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `(` + i3 + `)`);
      var o2 = this.trueExpr.toString(t5), s2 = getPrecedence$1(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `(` + o2 + `)`);
      var c2 = this.falseExpr.toString(t5), l2 = getPrecedence$1(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `(` + c2 + `)`), i3 + ` ? ` + o2 + ` : ` + c2;
    }
    toJSON() {
      return { mathjs: name$107$1, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(t5) {
      return new i2(t5.condition, t5.trueExpr, t5.falseExpr);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$1(this, n3, t5 && t5.implicit), i3 = this.condition.toHTML(t5), a2 = getPrecedence$1(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var o2 = this.trueExpr.toHTML(t5), s2 = getPrecedence$1(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var c2 = this.falseExpr.toHTML(t5), l2 = getPrecedence$1(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), i3 + `<span class="math-operator math-conditional-operator">?</span>` + o2 + `<span class="math-operator math-conditional-operator">:</span>` + c2;
    }
    _toTex(t5) {
      return `\\begin{cases} {` + this.trueExpr.toTex(t5) + `}, &\\quad{\\text{if }\\;` + this.condition.toTex(t5) + `}\\\\{` + this.falseExpr.toTex(t5) + `}, &\\quad{\\text{otherwise}}\\end{cases}`;
    }
  }
  return _defineProperty$2(i2, `name`, name$107$1), i2;
}, { isClass: true, isNode: true }), require_dist$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = Object.assign || function(t5) {
    for (var n3 = 1; n3 < arguments.length; n3++) {
      var r3 = arguments[n3];
      for (var i3 in r3) Object.prototype.hasOwnProperty.call(r3, i3) && (t5[i3] = r3[i3]);
    }
    return t5;
  }, i2 = { "{": `\\{`, "}": `\\}`, "\\": `\\textbackslash{}`, "#": `\\#`, $: `\\$`, "%": `\\%`, "&": `\\&`, "^": `\\textasciicircum{}`, _: `\\_`, "~": `\\textasciitilde{}` }, a2 = { "–": `\\--`, "—": `\\---`, " ": `~`, "	": `\\qquad{}`, "\r\n": `\\newline{}`, "\n": `\\newline{}` }, o2 = function(t5, n3) {
    return r2({}, t5, n3);
  };
  n2.exports = function(t5) {
    for (var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s2 = n3.preserveFormatting, c2 = s2 === void 0 ? false : s2, l2 = n3.escapeMapFn, u2 = l2 === void 0 ? o2 : l2, d2 = String(t5), p2 = ``, m2 = u2(r2({}, i2), c2 ? r2({}, a2) : {}), h2 = Object.keys(m2), g2 = function() {
      var t6 = false;
      h2.forEach(function(n4, r3) {
        t6 || d2.length >= n4.length && d2.slice(0, n4.length) === n4 && (p2 += m2[h2[r3]], d2 = d2.slice(n4.length, d2.length), t6 = true);
      }), t6 || (p2 += d2.slice(0, 1), d2 = d2.slice(1, d2.length));
    }; d2; ) g2();
    return p2;
  };
})), import_dist$1 = __toESM$1(require_dist$1()), latexSymbols$1 = { Alpha: `A`, alpha: `\\alpha`, Beta: `B`, beta: `\\beta`, Gamma: `\\Gamma`, gamma: `\\gamma`, Delta: `\\Delta`, delta: `\\delta`, Epsilon: `E`, epsilon: `\\epsilon`, varepsilon: `\\varepsilon`, Zeta: `Z`, zeta: `\\zeta`, Eta: `H`, eta: `\\eta`, Theta: `\\Theta`, theta: `\\theta`, vartheta: `\\vartheta`, Iota: `I`, iota: `\\iota`, Kappa: `K`, kappa: `\\kappa`, varkappa: `\\varkappa`, Lambda: `\\Lambda`, lambda: `\\lambda`, Mu: `M`, mu: `\\mu`, Nu: `N`, nu: `\\nu`, Xi: `\\Xi`, xi: `\\xi`, Omicron: `O`, omicron: `o`, Pi: `\\Pi`, pi: `\\pi`, varpi: `\\varpi`, Rho: `P`, rho: `\\rho`, varrho: `\\varrho`, Sigma: `\\Sigma`, sigma: `\\sigma`, varsigma: `\\varsigma`, Tau: `T`, tau: `\\tau`, Upsilon: `\\Upsilon`, upsilon: `\\upsilon`, Phi: `\\Phi`, phi: `\\phi`, varphi: `\\varphi`, Chi: `X`, chi: `\\chi`, Psi: `\\Psi`, psi: `\\psi`, Omega: `\\Omega`, omega: `\\omega`, true: `\\mathrm{True}`, false: `\\mathrm{False}`, i: `i`, inf: `\\infty`, Inf: `\\infty`, infinity: `\\infty`, Infinity: `\\infty`, oo: `\\infty`, lim: `\\lim`, undefined: `\\mathbf{?}` }, latexOperators$1 = { transpose: `^\\top`, ctranspose: `^H`, factorial: `!`, pow: `^`, dotPow: `.^\\wedge`, unaryPlus: `+`, unaryMinus: `-`, bitNot: `\\~`, not: `\\neg`, multiply: `\\cdot`, divide: `\\frac`, dotMultiply: `.\\cdot`, dotDivide: `.:`, mod: `\\mod`, add: `+`, subtract: `-`, to: `\\rightarrow`, leftShift: `<<`, rightArithShift: `>>`, rightLogShift: `>>>`, equal: `=`, unequal: `\\neq`, smaller: `<`, larger: `>`, smallerEq: `\\leq`, largerEq: `\\geq`, bitAnd: `\\&`, bitXor: `\\underline{|}`, bitOr: `|`, and: `\\wedge`, xor: `\\veebar`, or: `\\vee` }, latexFunctions$1 = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: `\\left(\${args[0]}${latexOperators$1.add}\${args[1]}\\right)` }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: `\\left(\${args[0]}${latexOperators$1.dotDivide}\${args[1]}\\right)` }, dotMultiply: { 2: `\\left(\${args[0]}${latexOperators$1.dotMultiply}\${args[1]}\\right)` }, dotPow: { 2: `\\left(\${args[0]}${latexOperators$1.dotPow}\${args[1]}\\right)` }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: `\\left(e${latexOperators$1.pow}{\${args[0]}}-1\\right)`, fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: `\\left(\${args[0]}${latexOperators$1.mod}\${args[1]}\\right)` }, multiply: { 2: `\\left(\${args[0]}${latexOperators$1.multiply}\${args[1]}\\right)` }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: `\\left(\${args[0]}\\right)${latexOperators$1.pow}{\${args[1]}}` }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: `\\left(\${args[0]}${latexOperators$1.subtract}\${args[1]}\\right)` }, unaryMinus: { 1: `${latexOperators$1.unaryMinus}\\left(\${args[0]}\\right)` }, unaryPlus: { 1: `${latexOperators$1.unaryPlus}\\left(\${args[0]}\\right)` }, bitAnd: { 2: `\\left(\${args[0]}${latexOperators$1.bitAnd}\${args[1]}\\right)` }, bitNot: { 1: latexOperators$1.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: `\\left(\${args[0]}${latexOperators$1.bitOr}\${args[1]}\\right)` }, bitXor: { 2: `\\left(\${args[0]}${latexOperators$1.bitXor}\${args[1]}\\right)` }, leftShift: { 2: `\\left(\${args[0]}${latexOperators$1.leftShift}\${args[1]}\\right)` }, rightArithShift: { 2: `\\left(\${args[0]}${latexOperators$1.rightArithShift}\${args[1]}\\right)` }, rightLogShift: { 2: `\\left(\${args[0]}${latexOperators$1.rightLogShift}\${args[1]}\\right)` }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: `\\left(\${args[0]}${latexOperators$1.and}\${args[1]}\\right)` }, not: { 1: latexOperators$1.not + "\\left(${args[0]}\\right)" }, or: { 2: `\\left(\${args[0]}${latexOperators$1.or}\${args[1]}\\right)` }, xor: { 2: `\\left(\${args[0]}${latexOperators$1.xor}\${args[1]}\\right)` }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: `\\left(\${args[0]}\\right)${latexOperators$1.ctranspose}` }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: `{\${args[0]}}${latexOperators$1.pow}{\\frac{1}{2}}` }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: `\\left(\${args[0]}\\right)${latexOperators$1.transpose}` }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: `\\left(\${args[0]}\\right)${latexOperators$1.factorial}` }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: `\\left(\${args[0]}${latexOperators$1.equal}\${args[1]}\\right)` }, larger: { 2: `\\left(\${args[0]}${latexOperators$1.larger}\${args[1]}\\right)` }, largerEq: { 2: `\\left(\${args[0]}${latexOperators$1.largerEq}\${args[1]}\\right)` }, smaller: { 2: `\\left(\${args[0]}${latexOperators$1.smaller}\${args[1]}\\right)` }, smallerEq: { 2: `\\left(\${args[0]}${latexOperators$1.smallerEq}\${args[1]}\\right)` }, unequal: { 2: `\\left(\${args[0]}${latexOperators$1.unequal}\${args[1]}\\right)` }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: `\\left(\${args[0]}${latexOperators$1.to}\${args[1]}\\right)` }, numeric: function(t4, n2) {
  return t4.args[0].toTex();
}, number: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: `\\mathtt{""}`, 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, bigint: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, complex: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: `\\left(\\left(\${args[0]}\\right)+${latexSymbols$1.i}\\cdot\\left(\${args[1]}\\right)\\right)` }, matrix: { 0: `\\begin{bmatrix}\\end{bmatrix}`, 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: `\\begin{bsparse}\\end{bsparse}`, 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate$1 = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits$1 = { deg: `^\\circ` };
function escapeLatex$1(t4) {
  return (0, import_dist$1.default)(t4, { preserveFormatting: true });
}
function toSymbol$1(t4, n2) {
  return n2 = n2 === void 0 ? false : n2, n2 ? hasOwnProperty$1$3(latexUnits$1, t4) ? latexUnits$1[t4] : `\\mathrm{` + escapeLatex$1(t4) + `}` : hasOwnProperty$1$3(latexSymbols$1, t4) ? latexSymbols$1[t4] : escapeLatex$1(t4);
}
var name$106$1 = `ConstantNode`, dependencies$106$1 = [`Node`, `isBounded`], createConstantNode$1 = factory$1(name$106$1, dependencies$106$1, (t4) => {
  var { Node: n2, isBounded: r2 } = t4;
  class i2 extends n2 {
    constructor(t5) {
      super(), this.value = t5;
    }
    get type() {
      return name$106$1;
    }
    get isConstantNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.value;
      return function() {
        return r3;
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    clone() {
      return new i2(this.value);
    }
    _toString(t5) {
      return format$3(this.value, t5);
    }
    _toHTML(t5) {
      var n3 = this._toString(t5);
      switch (typeOf$1(this.value)) {
        case `number`:
        case `bigint`:
        case `BigNumber`:
        case `Fraction`:
          return `<span class="math-number">` + n3 + `</span>`;
        case `string`:
          return `<span class="math-string">` + n3 + `</span>`;
        case `boolean`:
          return `<span class="math-boolean">` + n3 + `</span>`;
        case `null`:
          return `<span class="math-null-symbol">` + n3 + `</span>`;
        case `undefined`:
          return `<span class="math-undefined">` + n3 + `</span>`;
        default:
          return `<span class="math-symbol">` + n3 + `</span>`;
      }
    }
    toJSON() {
      return { mathjs: name$106$1, value: this.value };
    }
    static fromJSON(t5) {
      return new i2(t5.value);
    }
    _toTex(t5) {
      var n3 = this._toString(t5);
      switch (typeOf$1(this.value)) {
        case `string`:
          return `\\mathtt{` + escapeLatex$1(n3) + `}`;
        case `number`:
        case `BigNumber`:
          if (!r2(this.value)) return this.value.valueOf() < 0 ? `-\\infty` : `\\infty`;
          var i3 = n3.toLowerCase().indexOf(`e`);
          return i3 === -1 ? n3 : n3.substring(0, i3) + `\\cdot10^{` + n3.substring(i3 + 1) + `}`;
        case `bigint`:
          return n3.toString();
        case `Fraction`:
          return this.value.toLatex();
        default:
          return n3;
      }
    }
  }
  return _defineProperty$2(i2, `name`, name$106$1), i2;
}, { isClass: true, isNode: true }), name$105$1 = `FunctionAssignmentNode`, dependencies$105$1 = [`typed`, `Node`], createFunctionAssignmentNode$1 = factory$1(name$105$1, dependencies$105$1, (t4) => {
  var { typed: n2, Node: r2 } = t4;
  function i2(t5, n3, r3) {
    var i3 = getPrecedence$1(t5, n3, r3), a3 = getPrecedence$1(t5.expr, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class a2 extends r2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      if (!Array.isArray(n3)) throw TypeError(`Array containing strings or objects expected for parameter "params"`);
      if (!isNode$4(r3)) throw TypeError(`Node expected for parameter "expr"`);
      if (keywords$1.has(t5)) throw Error(`Illegal function name, "` + t5 + `" is a reserved keyword`);
      var i3 = /* @__PURE__ */ new Set();
      for (var a3 of n3) {
        var o2 = typeof a3 == `string` ? a3 : a3.name;
        if (i3.has(o2)) throw Error(`Duplicate parameter name "${o2}"`);
        i3.add(o2);
      }
      this.name = t5, this.params = n3.map(function(t6) {
        return t6 && t6.name || t6;
      }), this.types = n3.map(function(t6) {
        return t6 && t6.type || `any`;
      }), this.expr = r3;
    }
    get type() {
      return name$105$1;
    }
    get isFunctionAssignmentNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = Object.create(r3);
      forEach$1(this.params, function(t6) {
        i3[t6] = true;
      });
      var a3 = this.expr, o2 = a3._compile(t5, i3), s2 = this.name, c2 = this.params, l2 = join$3(this.types, `,`), u2 = s2 + `(` + join$3(this.params, `, `) + `)`;
      return function(t6, r4, i4) {
        var d2 = {};
        d2[l2] = function() {
          for (var n3 = Object.create(r4), a4 = 0; a4 < c2.length; a4++) n3[c2[a4]] = arguments[a4];
          return o2(t6, n3, i4);
        };
        var p2 = n2(s2, d2);
        return p2.syntax = u2, p2.expr = a3.toString(), t6.set(s2, p2), p2;
      };
    }
    forEach(t5) {
      t5(this.expr, `expr`, this);
    }
    map(t5) {
      var n3 = this._ifNode(t5(this.expr, `expr`, this));
      return new a2(this.name, this.params.slice(0), n3);
    }
    clone() {
      return new a2(this.name, this.params.slice(0), this.expr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toString(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `(` + r3 + `)`), this.name + `(` + this.params.join(`, `) + `) = ` + r3;
    }
    toJSON() {
      var t5 = this.types;
      return { mathjs: name$105$1, name: this.name, params: this.params.map(function(n3, r3) {
        return { name: n3, type: t5[r3] };
      }), expr: this.expr };
    }
    static fromJSON(t5) {
      return new a2(t5.name, t5.params, t5.expr);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = [], a3 = 0; a3 < this.params.length; a3++) r3.push(`<span class="math-symbol math-parameter">` + escape$2(this.params[a3]) + `</span>`);
      var o2 = this.expr.toHTML(t5);
      return i2(this, n3, t5 && t5.implicit) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), `<span class="math-function">` + escape$2(this.name) + `</span><span class="math-parenthesis math-round-parenthesis">(</span>` + r3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + o2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toTex(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `\\left(${r3}\\right)`), `\\mathrm{` + this.name + `}\\left(` + this.params.map(toSymbol$1).join(`,`) + `\\right)=` + r3;
    }
  }
  return _defineProperty$2(a2, `name`, name$105$1), a2;
}, { isClass: true, isNode: true }), name$104$1 = `IndexNode`, dependencies$104$1 = [`Node`, `size`], createIndexNode$1 = factory$1(name$104$1, dependencies$104$1, (t4) => {
  var { Node: n2, size: r2 } = t4;
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), this.dimensions = t5, this.dotNotation = n3 || false, !Array.isArray(t5) || !t5.every(isNode$4)) throw TypeError(`Array containing Nodes expected for parameter "dimensions"`);
      if (this.dotNotation && !this.isObjectProperty()) throw Error(`dotNotation only applicable for object properties`);
    }
    get type() {
      return name$104$1;
    }
    get isIndexNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = map$1$1(this.dimensions, function(i4, a3) {
        if (i4.filter((t6) => t6.isSymbolNode && t6.name === `end`).length > 0) {
          var o2 = Object.create(n3);
          o2.end = true;
          var s2 = i4._compile(t5, o2);
          return function(t6, n4, i5) {
            if (!isMatrix$1(i5) && !isArray$1(i5) && !isString$1(i5)) throw TypeError(`Cannot resolve "end": context must be a Matrix, Array, or string but is ` + typeOf$1(i5));
            var o3 = r2(i5), c2 = Object.create(n4);
            return c2.end = o3[a3], s2(t6, c2, i5);
          };
        } else return i4._compile(t5, n3);
      }), a2 = getSafeProperty$1(t5, `index`);
      return function(t6, n4, r3) {
        return a2(...map$1$1(i3, function(i4) {
          return i4(t6, n4, r3);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.dimensions.length; n3++) t5(this.dimensions[n3], `dimensions[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this._ifNode(t5(this.dimensions[r3], `dimensions[` + r3 + `]`, this));
      return new i2(n3, this.dotNotation);
    }
    clone() {
      return new i2(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return this.dimensions.length === 1 && isConstantNode$1(this.dimensions[0]) && typeof this.dimensions[0].value == `string`;
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(t5) {
      return this.dotNotation ? `.` + this.getObjectProperty() : `[` + this.dimensions.join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$104$1, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(t5) {
      return new i2(t5.dimensions, t5.dotNotation);
    }
    _toHTML(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this.dimensions[r3].toHTML();
      return this.dotNotation ? `<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">` + escape$2(this.getObjectProperty()) + `</span>` : `<span class="math-parenthesis math-square-parenthesis">[</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      var n3 = this.dimensions.map(function(n4) {
        return n4.toTex(t5);
      });
      return this.dotNotation ? `.` + this.getObjectProperty() : `_{` + n3.join(`,`) + `}`;
    }
  }
  return _defineProperty$2(i2, `name`, name$104$1), i2;
}, { isClass: true, isNode: true }), name$103$1 = `ObjectNode`, dependencies$103$1 = [`Node`], createObjectNode$1 = factory$1(name$103$1, dependencies$103$1, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.properties = t5 || {}, t5 && (typeof t5 != `object` || !Object.keys(t5).every(function(n3) {
        return isNode$4(t5[n3]);
      }))) throw TypeError(`Object containing Nodes expected`);
    }
    get type() {
      return name$103$1;
    }
    get isObjectNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = {};
      for (var i2 in this.properties) if (hasOwnProperty$1$3(this.properties, i2)) {
        var a2 = stringify$1(i2), o2 = JSON.parse(a2);
        r3[o2] = getSafeProperty$1(this.properties, i2)._compile(t5, n3);
      }
      return function(t6, n4, i3) {
        var a3 = {};
        for (var o3 in r3) hasOwnProperty$1$3(r3, o3) && (a3[o3] = r3[o3](t6, n4, i3));
        return a3;
      };
    }
    forEach(t5) {
      for (var n3 in this.properties) hasOwnProperty$1$3(this.properties, n3) && t5(this.properties[n3], `properties[` + stringify$1(n3) + `]`, this);
    }
    map(t5) {
      var n3 = {};
      for (var i2 in this.properties) hasOwnProperty$1$3(this.properties, i2) && (n3[i2] = this._ifNode(t5(this.properties[i2], `properties[` + stringify$1(i2) + `]`, this)));
      return new r2(n3);
    }
    clone() {
      var t5 = {};
      for (var n3 in this.properties) hasOwnProperty$1$3(this.properties, n3) && (t5[n3] = this.properties[n3]);
      return new r2(t5);
    }
    _toString(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$3(this.properties, r3) && n3.push(stringify$1(r3) + `: ` + this.properties[r3].toString(t5));
      return `{` + n3.join(`, `) + `}`;
    }
    toJSON() {
      return { mathjs: name$103$1, properties: this.properties };
    }
    static fromJSON(t5) {
      return new r2(t5.properties);
    }
    _toHTML(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$3(this.properties, r3) && n3.push(`<span class="math-symbol math-property">` + escape$2(r3) + `</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>` + this.properties[r3].toHTML(t5));
      return `<span class="math-parenthesis math-curly-parenthesis">{</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-curly-parenthesis">}</span>`;
    }
    _toTex(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$3(this.properties, r3) && n3.push(`\\mathbf{` + r3 + `:} & ` + this.properties[r3].toTex(t5) + `\\\\`);
      return `\\left\\{\\begin{array}{ll}` + n3.join(`
`) + `\\end{array}\\right\\}`;
    }
  }
  return _defineProperty$2(r2, `name`, name$103$1), r2;
}, { isClass: true, isNode: true });
function createSubScope$1(t4, n2) {
  return new PartitionedMap$1(t4, new ObjectWrappingMap$1(n2), new Set(Object.keys(n2)));
}
var name$102$1 = `OperatorNode`, dependencies$102$1 = [`Node`], createOperatorNode$1 = factory$1(name$102$1, dependencies$102$1, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3) {
    var i3 = t5;
    if (n3 === `auto`) for (; isParenthesisNode$1(i3); ) i3 = i3.content;
    return isConstantNode$1(i3) ? true : isOperatorNode$1(i3) ? r2(i3.args[0], n3) : false;
  }
  function i2(t5, n3, i3, a3, o2) {
    var s2 = getPrecedence$1(t5, n3, i3), c2 = getAssociativity$1(t5, n3);
    if (n3 === `all` || a3.length > 2 && t5.getIdentifier() !== `OperatorNode:add` && t5.getIdentifier() !== `OperatorNode:multiply`) return a3.map(function(t6) {
      switch (t6.getContent().type) {
        case `ArrayNode`:
        case `ConstantNode`:
        case `SymbolNode`:
        case `ParenthesisNode`:
          return false;
        default:
          return true;
      }
    });
    var l2;
    switch (a3.length) {
      case 0:
        l2 = [];
        break;
      case 1:
        var u2 = getPrecedence$1(a3[0], n3, i3, t5);
        if (o2 && u2 !== null) {
          var d2, p2;
          if (n3 === `keep` ? (d2 = a3[0].getIdentifier(), p2 = t5.getIdentifier()) : (d2 = a3[0].getContent().getIdentifier(), p2 = t5.getContent().getIdentifier()), properties$1[s2][p2].latexLeftParens === false) {
            l2 = [false];
            break;
          }
          if (properties$1[u2][d2].latexParens === false) {
            l2 = [false];
            break;
          }
        }
        if (u2 === null) {
          l2 = [false];
          break;
        }
        if (u2 <= s2) {
          l2 = [true];
          break;
        }
        l2 = [false];
        break;
      case 2:
        var m2, h2 = getPrecedence$1(a3[0], n3, i3, t5), g2 = isAssociativeWith$1(t5, a3[0], n3);
        m2 = h2 === null ? false : h2 === s2 && c2 === `right` && !g2 ? true : h2 < s2;
        var v2, y2 = getPrecedence$1(a3[1], n3, i3, t5), b2 = isAssociativeWith$1(t5, a3[1], n3);
        if (v2 = y2 === null ? false : y2 === s2 && c2 === `left` && !b2 ? true : y2 < s2, o2) {
          var x2, S2, w2;
          n3 === `keep` ? (x2 = t5.getIdentifier(), S2 = t5.args[0].getIdentifier(), w2 = t5.args[1].getIdentifier()) : (x2 = t5.getContent().getIdentifier(), S2 = t5.args[0].getContent().getIdentifier(), w2 = t5.args[1].getContent().getIdentifier()), h2 !== null && (properties$1[s2][x2].latexLeftParens === false && (m2 = false), properties$1[h2][S2].latexParens === false && (m2 = false)), y2 !== null && (properties$1[s2][x2].latexRightParens === false && (v2 = false), properties$1[y2][w2].latexParens === false && (v2 = false));
        }
        l2 = [m2, v2];
        break;
      default:
        (t5.getIdentifier() === `OperatorNode:add` || t5.getIdentifier() === `OperatorNode:multiply`) && (l2 = a3.map(function(r3) {
          var a4 = getPrecedence$1(r3, n3, i3, t5), o3 = isAssociativeWith$1(t5, r3, n3), l3 = getAssociativity$1(r3, n3);
          return a4 === null ? false : s2 === a4 && c2 === l3 && !o3 ? true : a4 < s2;
        }));
        break;
    }
    if (a3.length >= 2 && t5.getIdentifier() === `OperatorNode:multiply` && t5.implicit && n3 !== `all` && i3 === `hide`) for (var E = 1; E < l2.length; ++E) r2(a3[E], n3) && !l2[E - 1] && (n3 !== `keep` || !isParenthesisNode$1(a3[E - 1])) && (l2[E] = true);
    return l2;
  }
  class a2 extends n2 {
    constructor(t5, n3, r3, i3, a3) {
      if (super(), typeof t5 != `string`) throw TypeError(`string expected for parameter "op"`);
      if (typeof n3 != `string`) throw TypeError(`string expected for parameter "fn"`);
      if (!Array.isArray(r3) || !r3.every(isNode$4)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      this.implicit = i3 === true, this.isPercentage = a3 === true, this.op = t5, this.fn = n3, this.args = r3 || [];
    }
    get type() {
      return name$102$1;
    }
    get isOperatorNode() {
      return true;
    }
    _compile(t5, n3) {
      if (typeof this.fn != `string` || !isSafeMethod$1(t5, this.fn)) throw t5[this.fn] ? Error(`No access to function "` + this.fn + `"`) : Error(`Function ` + this.fn + ` missing in provided namespace "math"`);
      var r3 = getSafeProperty$1(t5, this.fn), i3 = map$1$1(this.args, function(r4) {
        return r4._compile(t5, n3);
      });
      if (typeof r3 == `function` && r3.rawArgs === true) {
        var a3 = this.args;
        return function(n4, i4, o3) {
          return r3(a3, t5, createSubScope$1(n4, i4));
        };
      } else if (i3.length === 1) {
        var o2 = i3[0];
        return function(t6, n4, i4) {
          return r3(o2(t6, n4, i4));
        };
      } else if (i3.length === 2) {
        var s2 = i3[0], c2 = i3[1];
        return function(t6, n4, i4) {
          return r3(s2(t6, n4, i4), c2(t6, n4, i4));
        };
      } else return function(t6, n4, a4) {
        return r3.apply(null, map$1$1(i3, function(r4) {
          return r4(t6, n4, a4);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.args.length; r3++) n3[r3] = this._ifNode(t5(this.args[r3], `args[` + r3 + `]`, this));
      return new a2(this.op, this.fn, n3, this.implicit, this.isPercentage);
    }
    clone() {
      return new a2(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return this.args.length === 1;
    }
    isBinary() {
      return this.args.length === 2;
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity$1(this, n3), c2 = a3[0].toString(t5);
        o2[0] && (c2 = `(` + c2 + `)`);
        var l2 = /[a-zA-Z]+/.test(this.op);
        return s2 === `right` ? this.op + (l2 ? ` ` : ``) + c2 : s2 === `left` ? c2 + (l2 ? ` ` : ``) + this.op : c2 + this.op;
      } else if (a3.length === 2) {
        var u2 = a3[0].toString(t5), d2 = a3[1].toString(t5);
        return o2[0] && (u2 = `(` + u2 + `)`), o2[1] && (d2 = `(` + d2 + `)`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? u2 + ` ` + d2 : u2 + ` ` + this.op + ` ` + d2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var p2 = a3.map(function(n4, r4) {
          return n4 = n4.toString(t5), o2[r4] && (n4 = `(` + n4 + `)`), n4;
        });
        return this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? p2.join(` `) : p2.join(` ` + this.op + ` `);
      } else return this.fn + `(` + this.args.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$102$1, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(t5) {
      return new a2(t5.op, t5.fn, t5.args, t5.implicit, t5.isPercentage);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity$1(this, n3), c2 = a3[0].toHTML(t5);
        return o2[0] && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), s2 === `right` ? `<span class="math-operator math-unary-operator math-lefthand-unary-operator">` + escape$2(this.op) + `</span>` + c2 : c2 + `<span class="math-operator math-unary-operator math-righthand-unary-operator">` + escape$2(this.op) + `</span>`;
      } else if (a3.length === 2) {
        var l2 = a3[0].toHTML(t5), u2 = a3[1].toHTML(t5);
        return o2[0] && (l2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + l2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), o2[1] && (u2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + u2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? l2 + `<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>` + u2 : l2 + `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$2(this.op) + `</span>` + u2;
      } else {
        var d2 = a3.map(function(n4, r4) {
          return n4 = n4.toHTML(t5), o2[r4] && (n4 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n4 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n4;
        });
        return a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`) ? this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? d2.join(`<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>`) : d2.join(`<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$2(this.op) + `</span>`) : `<span class="math-function">` + escape$2(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + d2.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
      }
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, true), s2 = latexOperators$1[this.fn];
      if (s2 = s2 === void 0 ? this.op : s2, a3.length === 1) {
        var c2 = getAssociativity$1(this, n3), l2 = a3[0].toTex(t5);
        return o2[0] && (l2 = `\\left(${l2}\\right)`), c2 === `right` ? s2 + l2 : l2 + s2;
      } else if (a3.length === 2) {
        var u2 = a3[0], d2 = u2.toTex(t5);
        o2[0] && (d2 = `\\left(${d2}\\right)`);
        var p2 = a3[1].toTex(t5);
        o2[1] && (p2 = `\\left(${p2}\\right)`);
        var m2 = n3 === `keep` ? u2.getIdentifier() : u2.getContent().getIdentifier();
        switch (this.getIdentifier()) {
          case `OperatorNode:divide`:
            return s2 + `{` + d2 + `}{` + p2 + `}`;
          case `OperatorNode:pow`:
            switch (d2 = `{` + d2 + `}`, p2 = `{` + p2 + `}`, m2) {
              case `ConditionalNode`:
              case `OperatorNode:divide`:
                d2 = `\\left(${d2}\\right)`;
            }
            break;
          case `OperatorNode:multiply`:
            if (this.implicit && r3 === `hide`) return d2 + `~` + p2;
        }
        return d2 + s2 + p2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var h2 = a3.map(function(n4, r4) {
          return n4 = n4.toTex(t5), o2[r4] && (n4 = `\\left(${n4}\\right)`), n4;
        });
        return this.getIdentifier() === `OperatorNode:multiply` && this.implicit && r3 === `hide` ? h2.join(`~`) : h2.join(s2);
      } else return `\\mathrm{` + this.fn + `}\\left(` + a3.map(function(n4) {
        return n4.toTex(t5);
      }).join(`,`) + `\\right)`;
    }
    getIdentifier() {
      return this.type + `:` + this.fn;
    }
  }
  return _defineProperty$2(a2, `name`, name$102$1), a2;
}, { isClass: true, isNode: true }), name$101$1 = `ParenthesisNode`, dependencies$101$1 = [`Node`], createParenthesisNode$1 = factory$1(name$101$1, dependencies$101$1, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), !isNode$4(t5)) throw TypeError(`Node expected for parameter "content"`);
      this.content = t5;
    }
    get type() {
      return name$101$1;
    }
    get isParenthesisNode() {
      return true;
    }
    _compile(t5, n3) {
      return this.content._compile(t5, n3);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(t5) {
      t5(this.content, `content`, this);
    }
    map(t5) {
      return new r2(t5(this.content, `content`, this));
    }
    clone() {
      return new r2(this.content);
    }
    _toString(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `(` + this.content.toString(t5) + `)` : this.content.toString(t5);
    }
    toJSON() {
      return { mathjs: name$101$1, content: this.content };
    }
    static fromJSON(t5) {
      return new r2(t5.content);
    }
    _toHTML(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + this.content.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : this.content.toHTML(t5);
    }
    _toTex(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `\\left(${this.content.toTex(t5)}\\right)` : this.content.toTex(t5);
    }
  }
  return _defineProperty$2(r2, `name`, name$101$1), r2;
}, { isClass: true, isNode: true }), name$100$1 = `RangeNode`, dependencies$100$1 = [`Node`], createRangeNode$1 = factory$1(name$100$1, dependencies$100$1, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3, r3) {
    var i3 = getPrecedence$1(t5, n3, r3), a2 = {}, o2 = getPrecedence$1(t5.start, n3, r3);
    if (a2.start = o2 !== null && o2 <= i3 || n3 === `all`, t5.step) {
      var s2 = getPrecedence$1(t5.step, n3, r3);
      a2.step = s2 !== null && s2 <= i3 || n3 === `all`;
    }
    var c2 = getPrecedence$1(t5.end, n3, r3);
    return a2.end = c2 !== null && c2 <= i3 || n3 === `all`, a2;
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$4(t5) || !isNode$4(n3) || r3 && !isNode$4(r3)) throw TypeError(`Node expected`);
      if (arguments.length > 3) throw Error(`Too many arguments`);
      this.start = t5, this.end = n3, this.step = r3 || null;
    }
    get type() {
      return name$100$1;
    }
    get isRangeNode() {
      return true;
    }
    needsEnd() {
      return this.filter(function(t5) {
        return isSymbolNode$1(t5) && t5.name === `end`;
      }).length > 0;
    }
    _compile(t5, n3) {
      var r3 = t5.range, i3 = this.start._compile(t5, n3), a2 = this.end._compile(t5, n3);
      if (this.step) {
        var o2 = this.step._compile(t5, n3);
        return function(t6, n4, s2) {
          return r3(i3(t6, n4, s2), a2(t6, n4, s2), o2(t6, n4, s2));
        };
      } else return function(t6, n4, o3) {
        return r3(i3(t6, n4, o3), a2(t6, n4, o3));
      };
    }
    forEach(t5) {
      t5(this.start, `start`, this), t5(this.end, `end`, this), this.step && t5(this.step, `step`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.start, `start`, this)), this._ifNode(t5(this.end, `end`, this)), this.step && this._ifNode(t5(this.step, `step`, this)));
    }
    clone() {
      return new i2(this.start, this.end, this.step && this.step);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toString(t5);
      if (i3.start && (o2 = `(` + o2 + `)`), a2 = o2, this.step) {
        var s2 = this.step.toString(t5);
        i3.step && (s2 = `(` + s2 + `)`), a2 += `:` + s2;
      }
      var c2 = this.end.toString(t5);
      return i3.end && (c2 = `(` + c2 + `)`), a2 += `:` + c2, a2;
    }
    toJSON() {
      return { mathjs: name$100$1, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(t5) {
      return new i2(t5.start, t5.end, t5.step);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toHTML(t5);
      if (i3.start && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 = o2, this.step) {
        var s2 = this.step.toHTML(t5);
        i3.step && (s2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + s2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + s2;
      }
      var c2 = this.end.toHTML(t5);
      return i3.end && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + c2, a2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2 = this.start.toTex(t5);
      if (i3.start && (a2 = `\\left(${a2}\\right)`), this.step) {
        var o2 = this.step.toTex(t5);
        i3.step && (o2 = `\\left(${o2}\\right)`), a2 += `:` + o2;
      }
      var s2 = this.end.toTex(t5);
      return i3.end && (s2 = `\\left(${s2}\\right)`), a2 += `:` + s2, a2;
    }
  }
  return _defineProperty$2(i2, `name`, name$100$1), i2;
}, { isClass: true, isNode: true }), name$99$1 = `RelationalNode`, dependencies$99$1 = [`Node`], createRelationalNode$1 = factory$1(name$99$1, dependencies$99$1, (t4) => {
  var { Node: n2 } = t4, r2 = { equal: `==`, unequal: `!=`, smaller: `<`, larger: `>`, smallerEq: `<=`, largerEq: `>=` };
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), !Array.isArray(t5)) throw TypeError(`Parameter conditionals must be an array`);
      if (!Array.isArray(n3)) throw TypeError(`Parameter params must be an array`);
      if (t5.length !== n3.length - 1) throw TypeError(`Parameter params must contain exactly one more element than parameter conditionals`);
      this.conditionals = t5, this.params = n3;
    }
    get type() {
      return name$99$1;
    }
    get isRelationalNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this, i3 = this.params.map((r4) => r4._compile(t5, n3));
      return function(n4, a2, o2) {
        for (var s2, c2 = i3[0](n4, a2, o2), l2 = 0; l2 < r3.conditionals.length; l2++) if (s2 = c2, c2 = i3[l2 + 1](n4, a2, o2), !getSafeProperty$1(t5, r3.conditionals[l2])(s2, c2)) return false;
        return true;
      };
    }
    forEach(t5) {
      this.params.forEach((n3, r3) => t5(n3, `params[` + r3 + `]`, this), this);
    }
    map(t5) {
      return new i2(this.conditionals.slice(), this.params.map((n3, r3) => this._ifNode(t5(n3, `params[` + r3 + `]`, this)), this));
    }
    clone() {
      return new i2(this.conditionals, this.params);
    }
    _toString(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence$1(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence$1(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `(` + r3.toString(t5) + `)` : r3.toString(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += ` ` + r2[this.conditionals[s2]], o2 += ` ` + a2[s2 + 1];
      return o2;
    }
    toJSON() {
      return { mathjs: name$99$1, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(t5) {
      return new i2(t5.conditionals, t5.params);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence$1(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence$1(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + r3.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : r3.toHTML(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape$2(r2[this.conditionals[s2]]) + `</span>` + a2[s2 + 1];
      return o2;
    }
    _toTex(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence$1(this, n3, t5 && t5.implicit), i3 = this.params.map(function(i4, a3) {
        var o3 = getPrecedence$1(i4, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= r3 ? `\\left(` + i4.toTex(t5) + `\right)` : i4.toTex(t5);
      }), a2 = i3[0], o2 = 0; o2 < this.conditionals.length; o2++) a2 += latexOperators$1[this.conditionals[o2]] + i3[o2 + 1];
      return a2;
    }
  }
  return _defineProperty$2(i2, `name`, name$99$1), i2;
}, { isClass: true, isNode: true }), name$98$1 = `SymbolNode`, dependencies$98$1 = [`math`, `?Unit`, `Node`], createSymbolNode$1 = factory$1(name$98$1, dependencies$98$1, (t4) => {
  var { math: n2, Unit: r2, Node: i2 } = t4;
  function a2(t5) {
    return r2 ? r2.isValuelessUnit(t5) : false;
  }
  class o2 extends i2 {
    constructor(t5) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      this.name = t5;
    }
    get type() {
      return `SymbolNode`;
    }
    get isSymbolNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.name;
      if (n3[i3] === true) return function(t6, n4, r3) {
        return getSafeProperty$1(n4, i3);
      };
      if (i3 in t5) return function(n4, r3, a3) {
        return n4.has(i3) ? n4.get(i3) : getSafeProperty$1(t5, i3);
      };
      var s2 = a2(i3);
      return function(t6, n4, a3) {
        return t6.has(i3) ? t6.get(i3) : s2 ? new r2(null, i3) : o2.onUndefinedSymbol(i3);
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    static onUndefinedSymbol(t5) {
      throw Error(`Undefined symbol ` + t5);
    }
    clone() {
      return new o2(this.name);
    }
    _toString(t5) {
      return this.name;
    }
    _toHTML(t5) {
      var n3 = escape$2(this.name);
      return n3 === `true` || n3 === `false` ? `<span class="math-symbol math-boolean">` + n3 + `</span>` : n3 === `i` ? `<span class="math-symbol math-imaginary-symbol">` + n3 + `</span>` : n3 === `Infinity` ? `<span class="math-symbol math-infinity-symbol">` + n3 + `</span>` : n3 === `NaN` ? `<span class="math-symbol math-nan-symbol">` + n3 + `</span>` : n3 === `null` ? `<span class="math-symbol math-null-symbol">` + n3 + `</span>` : n3 === `undefined` ? `<span class="math-symbol math-undefined-symbol">` + n3 + `</span>` : `<span class="math-symbol">` + n3 + `</span>`;
    }
    toJSON() {
      return { mathjs: `SymbolNode`, name: this.name };
    }
    static fromJSON(t5) {
      return new o2(t5.name);
    }
    _toTex(t5) {
      var r3 = false;
      n2[this.name] === void 0 && a2(this.name) && (r3 = true);
      var i3 = toSymbol$1(this.name, r3);
      return i3[0] === `\\` ? i3 : ` ` + i3;
    }
  }
  return o2;
}, { isClass: true, isNode: true }), name$97$1 = `FunctionNode`, dependencies$97$1 = [`math`, `Node`, `SymbolNode`], createFunctionNode$1 = factory$1(name$97$1, dependencies$97$1, (t4) => {
  var n2, { math: r2, Node: i2, SymbolNode: a2 } = t4, o2 = (t5) => format$3(t5, { truncate: 78 });
  function s2(t5, n3, r3) {
    for (var i3 = ``, a3 = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, o3 = 0, s3; (s3 = a3.exec(t5)) !== null; ) if (i3 += t5.substring(o3, s3.index), o3 = s3.index, s3[0] === `$$`) i3 += `$`, o3++;
    else {
      o3 += s3[0].length;
      var c3 = n3[s3[1]];
      if (!c3) throw ReferenceError(`Template: Property ` + s3[1] + ` does not exist.`);
      if (s3[2] === void 0) switch (typeof c3) {
        case `string`:
          i3 += c3;
          break;
        case `object`:
          if (isNode$4(c3)) i3 += c3.toTex(r3);
          else if (Array.isArray(c3)) i3 += c3.map(function(t6, n4) {
            if (isNode$4(t6)) return t6.toTex(r3);
            throw TypeError(`Template: ` + s3[1] + `[` + n4 + `] is not a Node.`);
          }).join(`,`);
          else throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
          break;
        default:
          throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
      }
      else if (isNode$4(c3[s3[2]] && c3[s3[2]])) i3 += c3[s3[2]].toTex(r3);
      else throw TypeError(`Template: ` + s3[1] + `[` + s3[2] + `] is not a Node.`);
    }
    return i3 += t5.slice(o3), i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 == `string` && (t5 = new a2(t5)), !isNode$4(t5)) throw TypeError(`Node expected as parameter "fn"`);
      if (!Array.isArray(n3) || !n3.every(isNode$4)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      var i3 = typeof r3;
      if (!(i3 === `undefined` || i3 === `boolean`)) throw TypeError(`optional flag, if specified, must be boolean`);
      this.fn = t5, this.args = n3 || [], this.optional = !!r3;
    }
    get name() {
      return this.fn.name || ``;
    }
    get type() {
      return name$97$1;
    }
    get isFunctionNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.args.map((r4) => r4._compile(t5, n3)), i3 = this.optional || isAccessorNode$1(this.fn) && this.fn.optionalChaining;
      if (isSymbolNode$1(this.fn)) {
        var a3 = this.fn.name;
        if (n3[a3]) {
          var s3 = this.args;
          return function(n4, c3, l3) {
            var u3 = getSafeProperty$1(c3, a3);
            if (!(i3 && u3 === void 0)) {
              if (typeof u3 != `function`) throw TypeError(`Argument '${a3}' was not a function; received: ${o2(u3)}`);
              if (u3.rawArgs) return u3(s3, t5, createSubScope$1(n4, c3));
              var d3 = r3.map((t6) => t6(n4, c3, l3));
              return u3.apply(u3, d3);
            }
          };
        } else {
          var l2 = a3 in t5 ? getSafeProperty$1(t5, a3) : void 0, u2 = typeof l2 == `function` && l2.rawArgs === true, d2 = (n4) => {
            var r4;
            if (n4.has(a3)) r4 = n4.get(a3);
            else if (a3 in t5) r4 = getSafeProperty$1(t5, a3);
            else if (i3) r4 = void 0;
            else return c2.onUndefinedFunction(a3);
            if (typeof r4 == `function` || i3 && r4 === void 0) return r4;
            throw TypeError(`'${a3}' is not a function; its value is:
  ${o2(r4)}`);
          };
          if (u2) {
            var p2 = this.args;
            return function(n4, i4, a4) {
              var o3 = d2(n4);
              return o3.rawArgs === true ? o3(p2, t5, createSubScope$1(n4, i4)) : o3(...r3.map((t6) => t6(n4, i4, a4)));
            };
          } else switch (r3.length) {
            case 0:
              return function(t6, n4, r4) {
                var a4 = d2(t6);
                if (!(i3 && a4 === void 0)) return a4();
              };
            case 1:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0];
                  return o3(s4(t6, n4, a4));
                }
              };
            case 2:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0], c3 = r3[1];
                  return o3(s4(t6, n4, a4), c3(t6, n4, a4));
                }
              };
            default:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) return o3(...r3.map((r4) => r4(t6, n4, a4)));
              };
          }
        }
      } else if (isAccessorNode$1(this.fn) && isIndexNode$1(this.fn.index) && this.fn.index.isObjectProperty()) {
        var m2 = this.fn.object._compile(t5, n3), h2 = this.fn.index.getObjectProperty(), g2 = this.args;
        return function(n4, a4, o3) {
          var s4 = m2(n4, a4, o3);
          if (!(i3 && (s4 == null || s4[h2] === void 0))) {
            var c3 = getSafeMethod$1(s4, h2);
            if (c3 != null && c3.rawArgs) return c3(g2, t5, createSubScope$1(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, o3));
            return c3.apply(s4, l3);
          }
        };
      } else {
        var v2 = this.fn.toString(), y2 = this.fn._compile(t5, n3), b2 = this.args;
        return function(n4, a4, s4) {
          var c3 = y2(n4, a4, s4);
          if (!(i3 && c3 === void 0)) {
            if (typeof c3 != `function`) throw TypeError(`Expression '${v2}' did not evaluate to a function; value is:
  ${o2(c3)}`);
            if (c3.rawArgs) return c3(b2, t5, createSubScope$1(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, s4));
            return c3.apply(c3, l3);
          }
        };
      }
    }
    forEach(t5) {
      t5(this.fn, `fn`, this);
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = this._ifNode(t5(this.fn, `fn`, this)), r3 = [], i3 = 0; i3 < this.args.length; i3++) r3[i3] = this._ifNode(t5(this.args[i3], `args[` + i3 + `]`, this));
      return new c2(n3, r3);
    }
    clone() {
      return new c2(this.fn, this.args.slice(0));
    }
    toString(t5) {
      var n3, r3 = this.fn.toString(t5);
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$3(t5.handler, r3) && (n3 = t5.handler[r3](this, t5)), n3 === void 0 ? super.toString(t5) : n3;
    }
    _toString(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toString(t5);
      });
      return (isFunctionAssignmentNode$1(this.fn) ? `(` + this.fn.toString(t5) + `)` : this.fn.toString(t5)) + `(` + n3.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$97$1, fn: this.fn, args: this.args };
    }
    _toHTML(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toHTML(t5);
      });
      return `<span class="math-function">` + escape$2(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
    }
    toTex(t5) {
      var n3;
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$3(t5.handler, this.name) && (n3 = t5.handler[this.name](this, t5)), n3 === void 0 ? super.toTex(t5) : n3;
    }
    _toTex(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toTex(t5);
      }), i3;
      latexFunctions$1[this.name] && (i3 = latexFunctions$1[this.name]), r2[this.name] && (typeof r2[this.name].toTex == `function` || typeof r2[this.name].toTex == `object` || typeof r2[this.name].toTex == `string`) && (i3 = r2[this.name].toTex);
      var a3;
      switch (typeof i3) {
        case `function`:
          a3 = i3(this, t5);
          break;
        case `string`:
          a3 = s2(i3, this, t5);
          break;
        case `object`:
          switch (typeof i3[n3.length]) {
            case `function`:
              a3 = i3[n3.length](this, t5);
              break;
            case `string`:
              a3 = s2(i3[n3.length], this, t5);
              break;
          }
      }
      return a3 === void 0 ? s2(defaultTemplate$1, this, t5) : a3;
    }
    getIdentifier() {
      return this.type + `:` + this.name;
    }
  }
  return n2 = c2, _defineProperty$2(c2, `name`, name$97$1), _defineProperty$2(c2, `onUndefinedFunction`, function(t5) {
    throw Error(`Undefined function ` + t5);
  }), _defineProperty$2(c2, `fromJSON`, function(t5) {
    return new n2(t5.fn, t5.args);
  }), c2;
}, { isClass: true, isNode: true }), name$96$1 = `parse`, dependencies$96$1 = [`typed`, `numeric`, `config`, `AccessorNode`, `ArrayNode`, `AssignmentNode`, `BlockNode`, `ConditionalNode`, `ConstantNode`, `FunctionAssignmentNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `RangeNode`, `RelationalNode`, `SymbolNode`], createParse$1 = factory$1(name$96$1, dependencies$96$1, (t4) => {
  var { typed: n2, numeric: r2, config: i2, AccessorNode: a2, ArrayNode: o2, AssignmentNode: s2, BlockNode: c2, ConditionalNode: l2, ConstantNode: u2, FunctionAssignmentNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, ParenthesisNode: v2, RangeNode: y2, RelationalNode: b2, SymbolNode: x2 } = t4, S2 = n2(name$96$1, { string: function(t5) {
    return K2(t5, {});
  }, "Array | Matrix": function(t5) {
    return w2(t5, {});
  }, "string, Object": function(t5, n3) {
    return K2(t5, n3.nodes === void 0 ? {} : n3.nodes);
  }, "Array | Matrix, Object": w2 });
  function w2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3.nodes === void 0 ? {} : n3.nodes;
    return deepMap$2(t5, function(t6) {
      if (typeof t6 != `string`) throw TypeError(`String expected`);
      return K2(t6, r3);
    });
  }
  var E = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, D = { ",": true, "(": true, ")": true, "[": true, "]": true, "{": true, "}": true, '"': true, "'": true, ";": true, "+": true, "-": true, "*": true, ".*": true, "/": true, "./": true, "%": true, "^": true, ".^": true, "~": true, "!": true, "&": true, "|": true, "^|": true, "=": true, ":": true, "?": true, "?.": true, "??": true, "==": true, "!=": true, "<": true, ">": true, "<=": true, ">=": true, "<<": true, ">>": true, ">>>": true }, O2 = { mod: true, to: true, in: true, and: true, xor: true, or: true, not: true }, j2 = { true: true, false: false, null: null, undefined: void 0 }, M2 = [`NaN`, `Infinity`], N2 = { '"': `"`, "'": `'`, "\\": `\\`, "/": `/`, b: `\b`, f: `\f`, n: `
`, r: `\r`, t: `	` };
  function F() {
    return { extraNodes: {}, expression: ``, comment: ``, index: 0, token: ``, tokenType: E.NULL, nestingLevel: 0, conditionalLevel: null };
  }
  function I2(t5, n3) {
    return t5.expression.substr(t5.index, n3);
  }
  function L2(t5) {
    return I2(t5, 1);
  }
  function R2(t5) {
    t5.index++;
  }
  function z2(t5) {
    return t5.expression.charAt(t5.index - 1);
  }
  function V2(t5) {
    return t5.expression.charAt(t5.index + 1);
  }
  function H2(t5) {
    for (t5.tokenType = E.NULL, t5.token = ``, t5.comment = ``; ; ) {
      if (L2(t5) === `#`) for (; L2(t5) !== `
` && L2(t5) !== ``; ) t5.comment += L2(t5), R2(t5);
      if (S2.isWhitespace(L2(t5), t5.nestingLevel)) R2(t5);
      else break;
    }
    if (L2(t5) === ``) {
      t5.tokenType = E.DELIMITER;
      return;
    }
    if (L2(t5) === `
` && !t5.nestingLevel) {
      t5.tokenType = E.DELIMITER, t5.token = L2(t5), R2(t5);
      return;
    }
    var n3 = L2(t5), r3 = I2(t5, 2), i3 = I2(t5, 3);
    if (i3.length === 3 && D[i3]) {
      t5.tokenType = E.DELIMITER, t5.token = i3, R2(t5), R2(t5), R2(t5);
      return;
    }
    if (r3.length === 2 && D[r3] && (r3 !== `?.` || !S2.isDigit(t5.expression.charAt(t5.index + 2)))) {
      t5.tokenType = E.DELIMITER, t5.token = r3, R2(t5), R2(t5);
      return;
    }
    if (D[n3]) {
      t5.tokenType = E.DELIMITER, t5.token = n3, R2(t5);
      return;
    }
    if (S2.isDigitDot(n3)) {
      t5.tokenType = E.NUMBER;
      var a3 = I2(t5, 2);
      if (a3 === `0b` || a3 === `0o` || a3 === `0x`) {
        for (t5.token += L2(t5), R2(t5), t5.token += L2(t5), R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        if (L2(t5) === `.`) for (t5.token += `.`, R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        else if (L2(t5) === `i`) for (t5.token += `i`, R2(t5); S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        return;
      }
      if (L2(t5) === `.`) {
        if (t5.token += L2(t5), R2(t5), !S2.isDigit(L2(t5))) {
          t5.tokenType = E.DELIMITER;
          return;
        }
      } else {
        for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        S2.isDecimalMark(L2(t5), V2(t5)) && (t5.token += L2(t5), R2(t5));
      }
      for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      if (L2(t5) === `E` || L2(t5) === `e`) {
        if (S2.isDigit(V2(t5)) || V2(t5) === `-` || V2(t5) === `+`) {
          if (t5.token += L2(t5), R2(t5), (L2(t5) === `+` || L2(t5) === `-`) && (t5.token += L2(t5), R2(t5)), !S2.isDigit(L2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
          for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
          if (S2.isDecimalMark(L2(t5), V2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
        } else if (S2.isDecimalMark(V2(t5), t5.expression.charAt(t5.index + 2))) throw R2(t5), ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
      }
      return;
    }
    if (S2.isAlpha(L2(t5), z2(t5), V2(t5))) {
      for (; S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      hasOwnProperty$1$3(O2, t5.token) ? t5.tokenType = E.DELIMITER : t5.tokenType = E.SYMBOL;
      return;
    }
    for (t5.tokenType = E.UNKNOWN; L2(t5) !== ``; ) t5.token += L2(t5), R2(t5);
    throw ke2(t5, `Syntax error in part "` + t5.token + `"`);
  }
  function U2(t5) {
    do
      H2(t5);
    while (t5.token === `
`);
  }
  function W2(t5) {
    t5.nestingLevel++;
  }
  function G2(t5) {
    t5.nestingLevel--;
  }
  S2.isAlpha = function(t5, n3, r3) {
    return S2.isValidLatinOrGreek(t5) || S2.isValidMathSymbol(t5, r3) || S2.isValidMathSymbol(n3, t5);
  }, S2.isValidLatinOrGreek = function(t5) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(t5);
  }, S2.isValidMathSymbol = function(t5, n3) {
    return /^[\uD835]$/.test(t5) && /^[\uDC00-\uDFFF]$/.test(n3) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(n3);
  }, S2.isWhitespace = function(t5, n3) {
    return t5 === ` ` || t5 === `	` || t5 === ` ` || t5 === `
` && n3 > 0;
  }, S2.isDecimalMark = function(t5, n3) {
    return t5 === `.` && n3 !== `/` && n3 !== `*` && n3 !== `^`;
  }, S2.isDigitDot = function(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }, S2.isDigit = function(t5) {
    return t5 >= `0` && t5 <= `9`;
  };
  function K2(t5, n3) {
    var r3 = F();
    _extends$3(r3, { expression: t5, extraNodes: n3 }), H2(r3);
    var i3 = q2(r3);
    if (r3.token !== ``) throw r3.tokenType === E.DELIMITER ? Ae2(r3, `Unexpected operator ` + r3.token) : ke2(r3, `Unexpected part "` + r3.token + `"`);
    return i3;
  }
  function q2(t5) {
    var n3, r3 = [], i3;
    for (t5.token !== `` && t5.token !== `
` && t5.token !== `;` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment)); t5.token === `
` || t5.token === `;`; ) r3.length === 0 && n3 && (i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 })), H2(t5), t5.token !== `
` && t5.token !== `;` && t5.token !== `` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment), i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 }));
    return r3.length > 0 ? new c2(r3) : (n3 || (n3 = new u2(void 0), t5.comment && (n3.comment = t5.comment)), n3);
  }
  function J(t5) {
    var n3, r3, i3, a3, o3 = ee2(t5);
    if (t5.token === `=`) {
      if (isSymbolNode$1(o3)) return n3 = o3.name, U2(t5), i3 = J(t5), new s2(new x2(n3), i3);
      if (isAccessorNode$1(o3)) {
        if (o3.optionalChaining) throw ke2(t5, `Cannot assign to optional chain`);
        return U2(t5), i3 = J(t5), new s2(o3.object, o3.index, i3);
      } else if (isFunctionNode$1(o3) && isSymbolNode$1(o3.fn) && (a3 = true, r3 = [], n3 = o3.name, o3.args.forEach(function(t6, n4) {
        isSymbolNode$1(t6) ? r3[n4] = t6.name : a3 = false;
      }), a3)) return U2(t5), i3 = J(t5), new d2(n3, r3, i3);
      throw ke2(t5, `Invalid left hand side of assignment operator =`);
    }
    return o3;
  }
  function ee2(t5) {
    for (var n3 = Y2(t5); t5.token === `?`; ) {
      var r3 = t5.conditionalLevel;
      t5.conditionalLevel = t5.nestingLevel, U2(t5);
      var i3 = n3, a3 = J(t5);
      if (t5.token !== `:`) throw ke2(t5, `False part of conditional expression expected`);
      t5.conditionalLevel = null, U2(t5), n3 = new l2(i3, a3, J(t5)), t5.conditionalLevel = r3;
    }
    return n3;
  }
  function Y2(t5) {
    for (var n3 = te2(t5); t5.token === `or`; ) U2(t5), n3 = new g2(`or`, `or`, [n3, te2(t5)]);
    return n3;
  }
  function te2(t5) {
    for (var n3 = ne2(t5); t5.token === `xor`; ) U2(t5), n3 = new g2(`xor`, `xor`, [n3, ne2(t5)]);
    return n3;
  }
  function ne2(t5) {
    for (var n3 = X2(t5); t5.token === `and`; ) U2(t5), n3 = new g2(`and`, `and`, [n3, X2(t5)]);
    return n3;
  }
  function X2(t5) {
    for (var n3 = ie2(t5); t5.token === `|`; ) U2(t5), n3 = new g2(`|`, `bitOr`, [n3, ie2(t5)]);
    return n3;
  }
  function ie2(t5) {
    for (var n3 = ae2(t5); t5.token === `^|`; ) U2(t5), n3 = new g2(`^|`, `bitXor`, [n3, ae2(t5)]);
    return n3;
  }
  function ae2(t5) {
    for (var n3 = Z2(t5); t5.token === `&`; ) U2(t5), n3 = new g2(`&`, `bitAnd`, [n3, Z2(t5)]);
    return n3;
  }
  function Z2(t5) {
    for (var n3 = [oe2(t5)], r3 = [], i3 = { "==": `equal`, "!=": `unequal`, "<": `smaller`, ">": `larger`, "<=": `smallerEq`, ">=": `largerEq` }; hasOwnProperty$1$3(i3, t5.token); ) {
      var a3 = { name: t5.token, fn: i3[t5.token] };
      r3.push(a3), U2(t5), n3.push(oe2(t5));
    }
    return n3.length === 1 ? n3[0] : n3.length === 2 ? new g2(r3[0].name, r3[0].fn, n3) : new b2(r3.map((t6) => t6.fn), n3);
  }
  function oe2(t5) {
    for (var n3 = $2(t5), r3, i3, a3, o3 = { "<<": `leftShift`, ">>": `rightArithShift`, ">>>": `rightLogShift` }; hasOwnProperty$1$3(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), a3 = [n3, $2(t5)], n3 = new g2(r3, i3, a3);
    return n3;
  }
  function $2(t5) {
    for (var n3 = se2(t5), r3, i3, a3, o3 = { to: `to`, in: `to` }; hasOwnProperty$1$3(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), r3 === `in` && `])},;`.includes(t5.token) ? n3 = new g2(`*`, `multiply`, [n3, new x2(`in`)], true) : (a3 = [n3, se2(t5)], n3 = new g2(r3, i3, a3));
    return n3;
  }
  function se2(t5) {
    var n3, r3 = [];
    if (t5.token === `:`) {
      if (t5.conditionalLevel === t5.nestingLevel) throw ke2(t5, `The true-expression of a conditional operator may not be empty`);
      n3 = new u2(1);
    } else n3 = ce2(t5);
    if (t5.token === `:` && t5.conditionalLevel !== t5.nestingLevel) {
      for (r3.push(n3); t5.token === `:` && r3.length < 3; ) U2(t5), t5.token === `)` || t5.token === `]` || t5.token === `,` || t5.token === `` ? r3.push(new x2(`end`)) : r3.push(ce2(t5));
      n3 = r3.length === 3 ? new y2(r3[0], r3[2], r3[1]) : new y2(r3[0], r3[1]);
    }
    return n3;
  }
  function ce2(t5) {
    for (var n3 = le2(t5), r3, i3, a3, o3 = { "+": `add`, "-": `subtract` }; hasOwnProperty$1$3(o3, t5.token); ) {
      r3 = t5.token, i3 = o3[r3], U2(t5);
      var s3 = le2(t5);
      a3 = s3.isPercentage ? [n3, new g2(`*`, `multiply`, [n3, s3])] : [n3, s3], n3 = new g2(r3, i3, a3);
    }
    return n3;
  }
  function le2(t5) {
    for (var n3 = ue2(t5), r3 = n3, i3, a3, o3 = { "*": `multiply`, ".*": `dotMultiply`, "/": `divide`, "./": `dotDivide`, "%": `mod`, mod: `mod` }; hasOwnProperty$1$3(o3, t5.token); ) i3 = t5.token, a3 = o3[i3], U2(t5), r3 = ue2(t5), n3 = new g2(i3, a3, [n3, r3]);
    return n3;
  }
  function ue2(t5) {
    for (var n3 = de2(t5), r3 = n3; t5.tokenType === E.SYMBOL || t5.token === `in` && isConstantNode$1(n3) || t5.token === `in` && isOperatorNode$1(n3) && n3.fn === `unaryMinus` && isConstantNode$1(n3.args[0]) || t5.tokenType === E.NUMBER && !isConstantNode$1(r3) && (!isOperatorNode$1(r3) || r3.op === `!`) || t5.token === `(`; ) r3 = de2(t5), n3 = new g2(`*`, `multiply`, [n3, r3], true);
    return n3;
  }
  function de2(t5) {
    for (var n3 = fe2(t5), r3 = n3, i3 = []; t5.token === `/` && rule2Node$1(r3); ) if (i3.push(_extends$3({}, t5)), U2(t5), t5.tokenType === E.NUMBER) if (i3.push(_extends$3({}, t5)), U2(t5), t5.tokenType === E.SYMBOL || t5.token === `(` || t5.token === `in`) _extends$3(t5, i3.pop()), i3.pop(), r3 = fe2(t5), n3 = new g2(`/`, `divide`, [n3, r3]);
    else {
      i3.pop(), _extends$3(t5, i3.pop());
      break;
    }
    else {
      _extends$3(t5, i3.pop());
      break;
    }
    return n3;
  }
  function fe2(t5) {
    var n3 = pe2(t5);
    if (t5.token === `%`) {
      var r3 = _extends$3({}, t5);
      U2(t5);
      try {
        pe2(t5), _extends$3(t5, r3);
      } catch {
        n3 = new g2(`/`, `divide`, [n3, new u2(100)], false, true);
      }
    }
    return n3;
  }
  function pe2(t5) {
    var n3, r3, i3, a3 = { "-": `unaryMinus`, "+": `unaryPlus`, "~": `bitNot`, not: `not` };
    return hasOwnProperty$1$3(a3, t5.token) ? (i3 = a3[t5.token], n3 = t5.token, U2(t5), r3 = [pe2(t5)], new g2(n3, i3, r3)) : me2(t5);
  }
  function me2(t5) {
    var n3 = he2(t5), r3, i3, a3;
    return (t5.token === `^` || t5.token === `.^`) && (r3 = t5.token, i3 = r3 === `^` ? `pow` : `dotPow`, U2(t5), a3 = [n3, pe2(t5)], n3 = new g2(r3, i3, a3)), n3;
  }
  function he2(t5) {
    for (var n3 = ge2(t5); t5.token === `??`; ) U2(t5), n3 = new g2(`??`, `nullish`, [n3, ge2(t5)]);
    return n3;
  }
  function ge2(t5) {
    for (var n3 = _e2(t5), r3, i3, a3, o3 = { "!": `factorial`, "'": `ctranspose` }; hasOwnProperty$1$3(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], H2(t5), a3 = [n3], n3 = new g2(r3, i3, a3), n3 = ye2(t5, n3);
    return n3;
  }
  function _e2(t5) {
    var n3 = [];
    if (t5.tokenType === E.SYMBOL && hasOwnProperty$1$3(t5.extraNodes, t5.token)) {
      var r3 = t5.extraNodes[t5.token];
      if (H2(t5), t5.token === `(`) {
        if (n3 = [], W2(t5), H2(t5), t5.token !== `)`) for (n3.push(J(t5)); t5.token === `,`; ) H2(t5), n3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5);
      }
      return new r3(n3);
    }
    return ve2(t5);
  }
  function ve2(t5) {
    var n3, i3;
    return t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2 ? (i3 = t5.token, H2(t5), n3 = hasOwnProperty$1$3(j2, i3) ? new u2(j2[i3]) : M2.includes(i3) ? new u2(r2(i3, `number`)) : new x2(i3), n3 = ye2(t5, n3), n3) : be2(t5);
  }
  function ye2(t5, n3, r3) {
    for (var i3; ; ) {
      var o3 = false;
      t5.token === `?.` && (o3 = true, H2(t5));
      var s3 = (t5.token === `(` || t5.token === `[` || t5.token === `.`) && true;
      if (!(o3 || s3)) break;
      if (i3 = [], t5.token === `(`) if (o3 || isSymbolNode$1(n3) || isAccessorNode$1(n3)) {
        if (W2(t5), H2(t5), t5.token !== `)`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5), n3 = new p2(n3, i3, o3);
      } else return n3;
      else if (t5.token === `[`) {
        if (W2(t5), H2(t5), t5.token !== `]`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `]`) throw ke2(t5, `Parenthesis ] expected`);
        G2(t5), H2(t5), n3 = new a2(n3, new m2(i3), o3);
      } else {
        if (o3 || H2(t5), !(t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2)) {
          var c3 = `Property name expected after `;
          throw c3 += o3 ? `optional chain` : `dot`, ke2(t5, c3);
        }
        i3.push(new u2(t5.token)), H2(t5), n3 = new a2(n3, new m2(i3, true), o3);
      }
    }
    return n3;
  }
  function be2(t5) {
    var n3, r3;
    return t5.token === `"` || t5.token === `'` ? (r3 = xe2(t5, t5.token), n3 = new u2(r3), n3 = ye2(t5, n3), n3) : Se2(t5);
  }
  function xe2(t5, n3) {
    for (var r3 = ``; L2(t5) !== `` && L2(t5) !== n3; ) if (L2(t5) === `\\`) {
      R2(t5);
      var i3 = L2(t5), a3 = N2[i3];
      if (a3 !== void 0) r3 += a3, t5.index += 1;
      else if (i3 === `u`) {
        var o3 = t5.expression.slice(t5.index + 1, t5.index + 5);
        if (/^[0-9A-Fa-f]{4}$/.test(o3)) r3 += String.fromCharCode(parseInt(o3, 16)), t5.index += 5;
        else throw ke2(t5, `Invalid unicode character \\u${o3}`);
      } else throw ke2(t5, `Bad escape character \\${i3}`);
    } else r3 += L2(t5), R2(t5);
    if (H2(t5), t5.token !== n3) throw ke2(t5, `End of string ${n3} expected`);
    return H2(t5), r3;
  }
  function Se2(t5) {
    var n3, r3, i3, a3;
    if (t5.token === `[`) {
      if (W2(t5), H2(t5), t5.token !== `]`) {
        var s3 = Ce2(t5);
        if (t5.token === `;`) {
          for (i3 = 1, r3 = [s3]; t5.token === `;`; ) H2(t5), t5.token !== `]` && (r3[i3] = Ce2(t5), i3++);
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), a3 = r3[0].items.length;
          for (var c3 = 1; c3 < i3; c3++) if (r3[c3].items.length !== a3) throw Ae2(t5, `Column dimensions mismatch (` + r3[c3].items.length + ` !== ` + a3 + `)`);
          n3 = new o2(r3);
        } else {
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), n3 = s3;
        }
      } else G2(t5), H2(t5), n3 = new o2([]);
      return ye2(t5, n3);
    }
    return we2(t5);
  }
  function Ce2(t5) {
    for (var n3 = [J(t5)], r3 = 1; t5.token === `,`; ) H2(t5), t5.token !== `]` && t5.token !== `;` && (n3[r3] = J(t5), r3++);
    return new o2(n3);
  }
  function we2(t5) {
    if (t5.token === `{`) {
      W2(t5);
      var n3, r3 = {};
      do
        if (H2(t5), t5.token !== `}`) {
          if (t5.token === `"` || t5.token === `'`) n3 = xe2(t5, t5.token);
          else if (t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2) n3 = t5.token, H2(t5);
          else throw ke2(t5, `Symbol or string expected as object key`);
          if (t5.token !== `:`) throw ke2(t5, `Colon : expected after object key`);
          H2(t5), r3[n3] = J(t5);
        }
      while (t5.token === `,`);
      if (t5.token !== `}`) throw ke2(t5, `Comma , or bracket } expected after object value`);
      G2(t5), H2(t5);
      var i3 = new h2(r3);
      return i3 = ye2(t5, i3), i3;
    }
    return Te2(t5);
  }
  function Te2(t5) {
    var n3;
    if (t5.tokenType === E.NUMBER) {
      n3 = t5.token, H2(t5);
      var a3 = safeNumberType$1(n3, i2);
      return new u2(r2(n3, a3));
    }
    return Ee2(t5);
  }
  function Ee2(t5) {
    var n3;
    if (t5.token === `(`) {
      if (W2(t5), H2(t5), n3 = J(t5), t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
      return G2(t5), H2(t5), n3 = new v2(n3), n3 = ye2(t5, n3), n3;
    }
    return De2(t5);
  }
  function De2(t5) {
    throw t5.token === `` ? ke2(t5, `Unexpected end of expression`) : ke2(t5, `Value expected`);
  }
  function Oe2(t5) {
    return t5.index - t5.token.length + 1;
  }
  function ke2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  function Ae2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  return n2.addConversion({ from: `string`, to: `Node`, convert: S2 }), S2;
}), name$95$1 = `compile`, dependencies$95$1 = [`typed`, `parse`], createCompile$1 = factory$1(name$95$1, dependencies$95$1, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$95$1, { string: function(t5) {
    return r2(t5).compile();
  }, "Array | Matrix": function(t5) {
    return deepMap$2(t5, function(t6) {
      return r2(t6).compile();
    });
  } });
}), name$94$1 = `evaluate`, dependencies$94$1 = [`typed`, `parse`], createEvaluate$1 = factory$1(name$94$1, dependencies$94$1, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$94$1, { string: function(t5) {
    var n3 = createEmptyMap$1();
    return r2(t5).compile().evaluate(n3);
  }, "string, Map | Object": function(t5, n3) {
    return r2(t5).compile().evaluate(n3);
  }, "Array | Matrix": function(t5) {
    var n3 = createEmptyMap$1();
    return deepMap$2(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  }, "Array | Matrix, Map | Object": function(t5, n3) {
    return deepMap$2(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  } });
}), name$93$1 = `Parser`, dependencies$93$1 = [`evaluate`, `parse`], createParserClass$1 = factory$1(name$93$1, dependencies$93$1, (t4) => {
  var { evaluate: n2, parse: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    Object.defineProperty(this, "scope", { value: createEmptyMap$1(), writable: false });
  }
  i2.prototype.type = `Parser`, i2.prototype.isParser = true, i2.prototype.evaluate = function(t5) {
    return n2(t5, this.scope);
  }, i2.prototype.get = function(t5) {
    if (this.scope.has(t5)) return this.scope.get(t5);
  }, i2.prototype.getAll = function() {
    return toObject$1(this.scope);
  }, i2.prototype.getAllAsMap = function() {
    return this.scope;
  };
  function a2(t5) {
    if (t5.length === 0) return false;
    for (var n3 = 0; n3 < t5.length; n3++) {
      var i3 = t5.charAt(n3 - 1), a3 = t5.charAt(n3), o2 = t5.charAt(n3 + 1);
      if (!(r2.isAlpha(a3, i3, o2) || n3 > 0 && r2.isDigit(a3))) return false;
    }
    return true;
  }
  return i2.prototype.set = function(t5, n3) {
    if (!a2(t5)) throw Error(`Invalid variable name: '${t5}'. Variable names must follow the specified rules.`);
    return this.scope.set(t5, n3), n3;
  }, i2.prototype.remove = function(t5) {
    this.scope.delete(t5);
  }, i2.prototype.clear = function() {
    this.scope.clear();
  }, i2.prototype.toJSON = function() {
    var t5 = { mathjs: `Parser`, variables: {}, functions: {} };
    for (var [n3, r3] of this.scope) if (isFunction$1$1(r3)) {
      if (!isExpressionFunction$1(r3)) throw Error(`Cannot serialize external function ${n3}`);
      t5.functions[n3] = `${r3.syntax} = ${r3.expr}`;
    } else t5.variables[n3] = r3;
    return t5;
  }, i2.fromJSON = function(t5) {
    var n3 = new i2();
    return Object.entries(t5.variables).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.set(r3, i3);
    }), Object.entries(t5.functions).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.evaluate(i3);
    }), n3;
  }, i2;
}, { isClass: true });
function isExpressionFunction$1(t4) {
  return typeof t4 == `function` && typeof t4.syntax == `string` && typeof t4.expr == `string`;
}
var name$92$1 = `parser`, dependencies$92$1 = [`typed`, `Parser`], createParser$1 = factory$1(name$92$1, dependencies$92$1, (t4) => {
  var { typed: n2, Parser: r2 } = t4;
  return n2(name$92$1, { "": function() {
    return new r2();
  } });
}), name$91$1 = `lup`, dependencies$91$1 = [`typed`, `matrix`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `larger`, `equalScalar`, `unaryMinus`, `DenseMatrix`, `SparseMatrix`, `Spa`], createLup$1 = factory$1(name$91$1, dependencies$91$1, (t4) => {
  var { typed: n2, matrix: r2, abs: i2, addScalar: a2, divideScalar: o2, multiplyScalar: s2, subtractScalar: c2, larger: l2, equalScalar: u2, unaryMinus: d2, DenseMatrix: p2, SparseMatrix: m2, Spa: h2 } = t4;
  return n2(name$91$1, { DenseMatrix: function(t5) {
    return g2(t5);
  }, SparseMatrix: function(t5) {
    return v2(t5);
  }, Array: function(t5) {
    var n3 = g2(r2(t5));
    return { L: n3.L.valueOf(), U: n3.U.valueOf(), p: n3.p };
  } });
  function g2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], d3 = Math.min(n3, r3), m3 = clone$3$1(t5._data), h3 = [], g3 = [n3, d3], v3 = [], y2 = [d3, r3], b2, x2, S2, w2 = [];
    for (b2 = 0; b2 < n3; b2++) w2[b2] = b2;
    for (x2 = 0; x2 < r3; x2++) {
      if (x2 > 0) for (b2 = 0; b2 < n3; b2++) {
        var E = Math.min(b2, x2), D = 0;
        for (S2 = 0; S2 < E; S2++) D = a2(D, s2(m3[b2][S2], m3[S2][x2]));
        m3[b2][x2] = c2(m3[b2][x2], D);
      }
      var O2 = x2, j2 = 0, M2 = 0;
      for (b2 = x2; b2 < n3; b2++) {
        var N2 = m3[b2][x2], F = i2(N2);
        l2(F, j2) && (O2 = b2, j2 = F, M2 = N2);
      }
      if (x2 !== O2 && (w2[x2] = [w2[O2], w2[O2] = w2[x2]][0], p2._swapRows(x2, O2, m3)), x2 < n3) for (b2 = x2 + 1; b2 < n3; b2++) {
        var I2 = m3[b2][x2];
        u2(I2, 0) || (m3[b2][x2] = o2(m3[b2][x2], M2));
      }
    }
    for (x2 = 0; x2 < r3; x2++) for (b2 = 0; b2 < n3; b2++) {
      if (x2 === 0 && (b2 < r3 && (v3[b2] = []), h3[b2] = []), b2 < x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 0);
        continue;
      }
      if (b2 === x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 1);
        continue;
      }
      b2 < r3 && (v3[b2][x2] = 0), x2 < n3 && (h3[b2][x2] = m3[b2][x2]);
    }
    var L2 = new p2({ data: h3, size: g3 }), R2 = new p2({ data: v3, size: y2 }), z2 = [];
    for (b2 = 0, d3 = w2.length; b2 < d3; b2++) z2[w2[b2]] = b2;
    return { L: L2, U: R2, p: z2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
  function v2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], a3 = Math.min(n3, r3), c3 = t5._values, p3 = t5._index, g3 = t5._ptr, v3 = [], y2 = [], b2 = [], x2 = [n3, a3], S2 = [], w2 = [], E = [], D = [a3, r3], O2, j2, M2, N2 = [], F = [];
    for (O2 = 0; O2 < n3; O2++) N2[O2] = O2, F[O2] = O2;
    var I2 = function(t6, n4) {
      var r4 = F[t6], i3 = F[n4];
      N2[r4] = n4, N2[i3] = t6, F[t6] = i3, F[n4] = r4;
    }, L2 = function() {
      var t6 = new h2();
      j2 < n3 && (b2.push(v3.length), v3.push(1), y2.push(j2)), E.push(S2.length);
      var r4 = g3[j2], a4 = g3[j2 + 1];
      for (M2 = r4; M2 < a4; M2++) O2 = p3[M2], t6.set(N2[O2], c3[M2]);
      j2 > 0 && t6.forEach(0, j2 - 1, function(n4, r5) {
        m2._forEachRow(n4, v3, y2, b2, function(i3, a5) {
          i3 > n4 && t6.accumulate(i3, d2(s2(a5, r5)));
        });
      });
      var F2 = j2, L22 = t6.get(j2), R2 = i2(L22);
      t6.forEach(j2 + 1, n3 - 1, function(t7, n4) {
        var r5 = i2(n4);
        l2(r5, R2) && (F2 = t7, R2 = r5, L22 = n4);
      }), j2 !== F2 && (m2._swapRows(j2, F2, x2[1], v3, y2, b2), m2._swapRows(j2, F2, D[1], S2, w2, E), t6.swap(j2, F2), I2(j2, F2)), t6.forEach(0, n3 - 1, function(t7, n4) {
        t7 <= j2 ? (S2.push(n4), w2.push(t7)) : (n4 = o2(n4, L22), u2(n4, 0) || (v3.push(n4), y2.push(t7)));
      });
    };
    for (j2 = 0; j2 < r3; j2++) L2();
    return E.push(S2.length), b2.push(v3.length), { L: new m2({ values: v3, index: y2, ptr: b2, size: x2 }), U: new m2({ values: S2, index: w2, ptr: E, size: D }), p: N2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
}), name$90$1 = `qr`, dependencies$90$1 = [`typed`, `matrix`, `zeros`, `identity`, `isZero`, `equal`, `sign`, `sqrt`, `conj`, `unaryMinus`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `complex`], createQr$1 = factory$1(name$90$1, dependencies$90$1, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, identity: a2, isZero: o2, equal: s2, sign: c2, sqrt: l2, conj: u2, unaryMinus: d2, addScalar: p2, divideScalar: m2, multiplyScalar: h2, subtractScalar: g2, complex: v2 } = t4;
  return _extends$3(n2(name$90$1, { DenseMatrix: function(t5) {
    return b2(t5);
  }, SparseMatrix: function(t5) {
    return x2();
  }, Array: function(t5) {
    var n3 = b2(r2(t5));
    return { Q: n3.Q.valueOf(), R: n3.R.valueOf() };
  } }), { _denseQRimpl: y2 });
  function y2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], v3 = a2([n3], `dense`), y3 = v3._data, b3 = t5.clone(), x3 = b3._data, S2, w2, E, D = i2([n3], ``);
    for (E = 0; E < Math.min(r3, n3); ++E) {
      var O2 = x3[E][E], j2 = d2(s2(O2, 0) ? 1 : c2(O2)), M2 = u2(j2), N2 = 0;
      for (S2 = E; S2 < n3; S2++) N2 = p2(N2, h2(x3[S2][E], u2(x3[S2][E])));
      var F = h2(j2, l2(N2));
      if (!o2(F)) {
        var I2 = g2(O2, F);
        for (D[E] = 1, S2 = E + 1; S2 < n3; S2++) D[S2] = m2(x3[S2][E], I2);
        var L2 = d2(u2(m2(I2, F))), R2 = void 0;
        for (w2 = E; w2 < r3; w2++) {
          for (R2 = 0, S2 = E; S2 < n3; S2++) R2 = p2(R2, h2(u2(D[S2]), x3[S2][w2]));
          for (R2 = h2(R2, L2), S2 = E; S2 < n3; S2++) x3[S2][w2] = h2(g2(x3[S2][w2], h2(D[S2], R2)), M2);
        }
        for (S2 = 0; S2 < n3; S2++) {
          for (R2 = 0, w2 = E; w2 < n3; w2++) R2 = p2(R2, h2(y3[S2][w2], D[w2]));
          for (R2 = h2(R2, L2), w2 = E; w2 < n3; ++w2) y3[S2][w2] = m2(g2(y3[S2][w2], h2(R2, u2(D[w2]))), M2);
        }
      }
    }
    return { Q: v3, R: b3, toString: function() {
      return `Q: ` + this.Q.toString() + `
R: ` + this.R.toString();
    } };
  }
  function b2(t5) {
    var n3 = y2(t5), r3 = n3.R._data;
    if (t5._data.length > 0) for (var i3 = r3[0][0].type === `Complex` ? v2(0) : 0, a3 = 0; a3 < r3.length; ++a3) for (var o3 = 0; o3 < a3 && o3 < (r3[0] || []).length; ++o3) r3[a3][o3] = i3;
    return n3;
  }
  function x2(t5) {
    throw Error(`qr not implemented for sparse matrices yet`);
  }
});
function csPermute$1(t4, n2, r2, i2) {
  for (var a2 = t4._values, o2 = t4._index, s2 = t4._ptr, c2 = t4._size, l2 = t4._datatype, u2 = c2[0], d2 = c2[1], p2 = null, m2 = [], h2 = [], g2 = 0, v2 = 0; v2 < d2; v2++) {
    h2[v2] = g2;
    for (var y2 = r2 ? r2[v2] : v2, b2 = s2[y2], x2 = s2[y2 + 1], S2 = b2; S2 < x2; S2++) m2[g2] = o2[S2], p2 && (p2[g2] = a2[S2]), g2++;
  }
  return h2[d2] = g2, t4.createSparseMatrix({ values: p2, index: m2, ptr: h2, size: [u2, d2], datatype: l2 });
}
function csTdfs$1(t4, n2, r2, i2, a2, o2, s2) {
  var c2 = 0;
  for (r2[s2] = t4; c2 >= 0; ) {
    var l2 = r2[s2 + c2], u2 = r2[i2 + l2];
    u2 === -1 ? (c2--, o2[n2++] = l2) : (r2[i2 + l2] = r2[a2 + u2], ++c2, r2[s2 + c2] = u2);
  }
  return n2;
}
function csPost$1(t4, n2) {
  if (!t4) return null;
  var r2 = 0, i2, a2 = [], o2 = [], s2 = 0, c2 = n2, l2 = 2 * n2;
  for (i2 = 0; i2 < n2; i2++) o2[s2 + i2] = -1;
  for (i2 = n2 - 1; i2 >= 0; i2--) t4[i2] !== -1 && (o2[c2 + i2] = o2[s2 + t4[i2]], o2[s2 + t4[i2]] = i2);
  for (i2 = 0; i2 < n2; i2++) t4[i2] === -1 && (r2 = csTdfs$1(i2, r2, o2, s2, c2, a2, l2));
  return a2;
}
function csEtree$1(t4, n2) {
  if (!t4) return null;
  var r2 = t4._index, i2 = t4._ptr, a2 = t4._size, o2 = a2[0], s2 = a2[1], c2 = [], l2 = [], u2 = 0, d2 = s2, p2, m2;
  for (p2 = 0; p2 < o2; p2++) l2[d2 + p2] = -1;
  for (var h2 = 0; h2 < s2; h2++) {
    c2[h2] = -1, l2[u2 + h2] = -1;
    for (var g2 = i2[h2], v2 = i2[h2 + 1], y2 = g2; y2 < v2; y2++) {
      var b2 = r2[y2];
      for (p2 = l2[d2 + b2]; p2 !== -1 && p2 < h2; p2 = m2) m2 = l2[u2 + p2], l2[u2 + p2] = h2, m2 === -1 && (c2[p2] = h2);
      l2[d2 + b2] = h2;
    }
  }
  return c2;
}
function csFkeep$1(t4, n2, r2) {
  for (var i2 = t4._values, a2 = t4._index, o2 = t4._ptr, s2 = t4._size[1], c2 = 0, l2 = 0; l2 < s2; l2++) {
    var u2 = o2[l2];
    for (o2[l2] = c2; u2 < o2[l2 + 1]; u2++) n2(a2[u2], l2, i2 ? i2[u2] : 1, r2) && (a2[c2] = a2[u2], i2 && (i2[c2] = i2[u2]), c2++);
  }
  return o2[s2] = c2, a2.splice(c2, a2.length - c2), i2 && i2.splice(c2, i2.length - c2), c2;
}
function csFlip$1(t4) {
  return -t4 - 2;
}
var name$89$1 = `csAmd`, dependencies$89$1 = [`add`, `multiply`, `transpose`], createCsAmd$1 = factory$1(name$89$1, dependencies$89$1, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4;
  return function(t5, n3) {
    if (!n3 || t5 <= 0 || t5 > 3) return null;
    var r3 = n3._size, i3 = r3[0], u2 = r3[1], d2 = 0, p2 = Math.max(16, 10 * Math.sqrt(u2));
    p2 = Math.min(u2 - 2, p2);
    var m2 = a2(t5, n3, i3, u2, p2);
    csFkeep$1(m2, l2, null);
    for (var h2 = m2._index, g2 = m2._ptr, v2 = g2[u2], y2 = [], b2 = [], x2 = 0, S2 = u2 + 1, w2 = 2 * (u2 + 1), E = 3 * (u2 + 1), D = 4 * (u2 + 1), O2 = 5 * (u2 + 1), j2 = 6 * (u2 + 1), M2 = 7 * (u2 + 1), N2 = y2, F = o2(u2, g2, b2, x2, E, N2, w2, M2, S2, j2, D, O2), I2 = s2(u2, g2, b2, O2, D, j2, p2, S2, E, N2, w2), L2 = 0, R2, z2, V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2; I2 < u2; ) {
      for (V2 = -1; L2 < u2 && (V2 = b2[E + L2]) === -1; L2++) ;
      b2[w2 + V2] !== -1 && (N2[b2[w2 + V2]] = -1), b2[E + L2] = b2[w2 + V2];
      var ae2 = b2[D + V2], Z2 = b2[S2 + V2];
      I2 += Z2;
      var oe2 = 0;
      b2[S2 + V2] = -Z2;
      var $2 = g2[V2], se2 = ae2 === 0 ? $2 : v2, ce2 = se2;
      for (H2 = 1; H2 <= ae2 + 1; H2++) {
        for (H2 > ae2 ? (W2 = V2, G2 = $2, K2 = b2[x2 + V2] - ae2) : (W2 = h2[$2++], G2 = g2[W2], K2 = b2[x2 + W2]), U2 = 1; U2 <= K2; U2++) R2 = h2[G2++], !((q2 = b2[S2 + R2]) <= 0) && (oe2 += q2, b2[S2 + R2] = -q2, h2[ce2++] = R2, b2[w2 + R2] !== -1 && (N2[b2[w2 + R2]] = N2[R2]), N2[R2] === -1 ? b2[E + b2[O2 + R2]] = b2[w2 + R2] : b2[w2 + N2[R2]] = b2[w2 + R2]);
        W2 !== V2 && (g2[W2] = csFlip$1(V2), b2[j2 + W2] = 0);
      }
      for (ae2 !== 0 && (v2 = ce2), b2[O2 + V2] = oe2, g2[V2] = se2, b2[x2 + V2] = ce2 - se2, b2[D + V2] = -2, F = c2(F, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !((ee2 = b2[D + R2]) <= 0)) {
        q2 = -b2[S2 + R2];
        var le2 = F - q2;
        for ($2 = g2[R2], Y2 = g2[R2] + ee2 - 1; $2 <= Y2; $2++) W2 = h2[$2], b2[j2 + W2] >= F ? b2[j2 + W2] -= q2 : b2[j2 + W2] !== 0 && (b2[j2 + W2] = b2[O2 + W2] + le2);
      }
      for (J = se2; J < ce2; J++) {
        for (R2 = h2[J], Y2 = g2[R2], te2 = Y2 + b2[D + R2] - 1, ne2 = Y2, X2 = 0, ie2 = 0, $2 = Y2; $2 <= te2; $2++) if (W2 = h2[$2], b2[j2 + W2] !== 0) {
          var ue2 = b2[j2 + W2] - F;
          ue2 > 0 ? (ie2 += ue2, h2[ne2++] = W2, X2 += W2) : (g2[W2] = csFlip$1(V2), b2[j2 + W2] = 0);
        }
        b2[D + R2] = ne2 - Y2 + 1;
        var de2 = ne2, fe2 = Y2 + b2[x2 + R2];
        for ($2 = te2 + 1; $2 < fe2; $2++) {
          z2 = h2[$2];
          var pe2 = b2[S2 + z2];
          pe2 <= 0 || (ie2 += pe2, h2[ne2++] = z2, X2 += z2);
        }
        ie2 === 0 ? (g2[R2] = csFlip$1(V2), q2 = -b2[S2 + R2], oe2 -= q2, Z2 += q2, I2 += q2, b2[S2 + R2] = 0, b2[D + R2] = -1) : (b2[O2 + R2] = Math.min(b2[O2 + R2], ie2), h2[ne2] = h2[de2], h2[de2] = h2[Y2], h2[Y2] = V2, b2[x2 + R2] = ne2 - Y2 + 1, X2 = (X2 < 0 ? -X2 : X2) % u2, b2[w2 + R2] = b2[M2 + X2], b2[M2 + X2] = R2, N2[R2] = X2);
      }
      for (b2[O2 + V2] = oe2, d2 = Math.max(d2, oe2), F = c2(F + d2, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !(b2[S2 + R2] >= 0)) for (X2 = N2[R2], R2 = b2[M2 + X2], b2[M2 + X2] = -1; R2 !== -1 && b2[w2 + R2] !== -1; R2 = b2[w2 + R2], F++) {
        for (K2 = b2[x2 + R2], ee2 = b2[D + R2], $2 = g2[R2] + 1; $2 <= g2[R2] + K2 - 1; $2++) b2[j2 + h2[$2]] = F;
        var me2 = R2;
        for (z2 = b2[w2 + R2]; z2 !== -1; ) {
          var he2 = b2[x2 + z2] === K2 && b2[D + z2] === ee2;
          for ($2 = g2[z2] + 1; he2 && $2 <= g2[z2] + K2 - 1; $2++) b2[j2 + h2[$2]] !== F && (he2 = 0);
          he2 ? (g2[z2] = csFlip$1(R2), b2[S2 + R2] += b2[S2 + z2], b2[S2 + z2] = 0, b2[D + z2] = -1, z2 = b2[w2 + z2], b2[w2 + me2] = z2) : (me2 = z2, z2 = b2[w2 + z2]);
        }
      }
      for ($2 = se2, J = se2; J < ce2; J++) R2 = h2[J], !((q2 = -b2[S2 + R2]) <= 0) && (b2[S2 + R2] = q2, ie2 = b2[O2 + R2] + oe2 - q2, ie2 = Math.min(ie2, u2 - I2 - q2), b2[E + ie2] !== -1 && (N2[b2[E + ie2]] = R2), b2[w2 + R2] = b2[E + ie2], N2[R2] = -1, b2[E + ie2] = R2, L2 = Math.min(L2, ie2), b2[O2 + R2] = ie2, h2[$2++] = R2);
      b2[S2 + V2] = Z2, (b2[x2 + V2] = $2 - se2) === 0 && (g2[V2] = -1, b2[j2 + V2] = 0), ae2 !== 0 && (v2 = $2);
    }
    for (R2 = 0; R2 < u2; R2++) g2[R2] = csFlip$1(g2[R2]);
    for (z2 = 0; z2 <= u2; z2++) b2[E + z2] = -1;
    for (z2 = u2; z2 >= 0; z2--) b2[S2 + z2] > 0 || (b2[w2 + z2] = b2[E + g2[z2]], b2[E + g2[z2]] = z2);
    for (W2 = u2; W2 >= 0; W2--) b2[S2 + W2] <= 0 || g2[W2] !== -1 && (b2[w2 + W2] = b2[E + g2[W2]], b2[E + g2[W2]] = W2);
    for (V2 = 0, R2 = 0; R2 <= u2; R2++) g2[R2] === -1 && (V2 = csTdfs$1(R2, V2, b2, E, w2, y2, j2));
    return y2.splice(y2.length - 1, 1), y2;
  };
  function a2(t5, a3, o3, s3, c3) {
    var l3 = i2(a3);
    if (t5 === 1 && s3 === o3) return n2(a3, l3);
    if (t5 === 2) {
      for (var u2 = l3._index, d2 = l3._ptr, p2 = 0, m2 = 0; m2 < o3; m2++) {
        var h2 = d2[m2];
        if (d2[m2] = p2, !(d2[m2 + 1] - h2 > c3)) for (var g2 = d2[m2 + 1]; h2 < g2; h2++) u2[p2++] = u2[h2];
      }
      return d2[o3] = p2, a3 = i2(l3), r2(l3, a3);
    }
    return r2(l3, a3);
  }
  function o2(t5, n3, r3, i3, a3, o3, s3, l3, u2, d2, p2, m2) {
    for (var h2 = 0; h2 < t5; h2++) r3[i3 + h2] = n3[h2 + 1] - n3[h2];
    r3[i3 + t5] = 0;
    for (var g2 = 0; g2 <= t5; g2++) r3[a3 + g2] = -1, o3[g2] = -1, r3[s3 + g2] = -1, r3[l3 + g2] = -1, r3[u2 + g2] = 1, r3[d2 + g2] = 1, r3[p2 + g2] = 0, r3[m2 + g2] = r3[i3 + g2];
    var v2 = c2(0, 0, r3, d2, t5);
    return r3[p2 + t5] = -2, n3[t5] = -1, r3[d2 + t5] = 0, v2;
  }
  function s2(t5, n3, r3, i3, a3, o3, s3, c3, l3, u2, d2) {
    for (var p2 = 0, m2 = 0; m2 < t5; m2++) {
      var h2 = r3[i3 + m2];
      if (h2 === 0) r3[a3 + m2] = -2, p2++, n3[m2] = -1, r3[o3 + m2] = 0;
      else if (h2 > s3) r3[c3 + m2] = 0, r3[a3 + m2] = -1, p2++, n3[m2] = csFlip$1(t5), r3[c3 + t5]++;
      else {
        var g2 = r3[l3 + h2];
        g2 !== -1 && (u2[g2] = m2), r3[d2 + m2] = r3[l3 + h2], r3[l3 + h2] = m2;
      }
    }
    return p2;
  }
  function c2(t5, n3, r3, i3, a3) {
    if (t5 < 2 || t5 + n3 < 0) {
      for (var o3 = 0; o3 < a3; o3++) r3[i3 + o3] !== 0 && (r3[i3 + o3] = 1);
      t5 = 2;
    }
    return t5;
  }
  function l2(t5, n3) {
    return t5 !== n3;
  }
});
function csLeaf$1(t4, n2, r2, i2, a2, o2, s2) {
  var c2, l2, u2 = 0, d2;
  if (t4 <= n2 || r2[i2 + n2] <= r2[a2 + t4]) return -1;
  r2[a2 + t4] = r2[i2 + n2];
  var p2 = r2[o2 + t4];
  if (r2[o2 + t4] = n2, p2 === -1) u2 = 1, d2 = t4;
  else {
    for (u2 = 2, d2 = p2; d2 !== r2[s2 + d2]; d2 = r2[s2 + d2]) ;
    for (c2 = p2; c2 !== d2; c2 = l2) l2 = r2[s2 + c2], r2[s2 + c2] = d2;
  }
  return { jleaf: u2, q: d2 };
}
var name$88$1 = `csCounts`, dependencies$88$1 = [`transpose`], createCsCounts$1 = factory$1(name$88$1, dependencies$88$1, (t4) => {
  var { transpose: n2 } = t4;
  return function(t5, r2, i2, a2) {
    if (!t5 || !r2 || !i2) return null;
    var o2 = t5._size, s2 = o2[0], c2 = o2[1], l2, u2, d2, p2, m2, h2, g2, v2 = 4 * c2 + (a2 ? c2 + s2 + 1 : 0), y2 = [], b2 = 0, x2 = c2, S2 = 2 * c2, w2 = 3 * c2, E = 4 * c2, D = 5 * c2 + 1;
    for (d2 = 0; d2 < v2; d2++) y2[d2] = -1;
    var O2 = [], j2 = n2(t5), M2 = j2._index, N2 = j2._ptr;
    for (d2 = 0; d2 < c2; d2++) for (u2 = i2[d2], O2[u2] = +(y2[w2 + u2] === -1); u2 !== -1 && y2[w2 + u2] === -1; u2 = r2[u2]) y2[w2 + u2] = d2;
    if (a2) {
      for (d2 = 0; d2 < c2; d2++) y2[i2[d2]] = d2;
      for (l2 = 0; l2 < s2; l2++) {
        for (d2 = c2, h2 = N2[l2], g2 = N2[l2 + 1], m2 = h2; m2 < g2; m2++) d2 = Math.min(d2, y2[M2[m2]]);
        y2[D + l2] = y2[E + d2], y2[E + d2] = l2;
      }
    }
    for (l2 = 0; l2 < c2; l2++) y2[b2 + l2] = l2;
    for (d2 = 0; d2 < c2; d2++) {
      for (u2 = i2[d2], r2[u2] !== -1 && O2[r2[u2]]--, p2 = a2 ? y2[E + d2] : u2; p2 !== -1; p2 = a2 ? y2[D + p2] : -1) for (m2 = N2[p2]; m2 < N2[p2 + 1]; m2++) {
        l2 = M2[m2];
        var F = csLeaf$1(l2, u2, y2, w2, x2, S2, b2);
        F.jleaf >= 1 && O2[u2]++, F.jleaf === 2 && O2[F.q]--;
      }
      r2[u2] !== -1 && (y2[b2 + u2] = r2[u2]);
    }
    for (u2 = 0; u2 < c2; u2++) r2[u2] !== -1 && (O2[r2[u2]] += O2[u2]);
    return O2;
  };
}), name$87$1 = `csSqr`, dependencies$87$1 = [`add`, `multiply`, `transpose`], createCsSqr$1 = factory$1(name$87$1, dependencies$87$1, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4, a2 = createCsAmd$1({ add: n2, multiply: r2, transpose: i2 }), o2 = createCsCounts$1({ transpose: i2 });
  return function(t5, n3, r3) {
    var i3 = n3._ptr, c2 = n3._size[1], l2, u2 = {};
    if (u2.q = a2(t5, n3), t5 && !u2.q) return null;
    if (r3) {
      var d2 = t5 ? csPermute$1(n3, null, u2.q) : n3;
      u2.parent = csEtree$1(d2);
      var p2 = csPost$1(u2.parent, c2);
      if (u2.cp = o2(d2, u2.parent, p2, 1), d2 && u2.parent && u2.cp && s2(d2, u2)) for (u2.unz = 0, l2 = 0; l2 < c2; l2++) u2.unz += u2.cp[l2];
    } else u2.unz = 4 * i3[c2] + c2, u2.lnz = u2.unz;
    return u2;
  };
  function s2(t5, n3) {
    var r3 = t5._ptr, i3 = t5._index, a3 = t5._size, o3 = a3[0], s3 = a3[1];
    n3.pinv = [], n3.leftmost = [];
    var c2 = n3.parent, l2 = n3.pinv, u2 = n3.leftmost, d2 = [], p2 = 0, m2 = o3, h2 = o3 + s3, g2 = o3 + 2 * s3, v2, y2, b2, x2, S2;
    for (y2 = 0; y2 < s3; y2++) d2[m2 + y2] = -1, d2[h2 + y2] = -1, d2[g2 + y2] = 0;
    for (v2 = 0; v2 < o3; v2++) u2[v2] = -1;
    for (y2 = s3 - 1; y2 >= 0; y2--) for (x2 = r3[y2], S2 = r3[y2 + 1], b2 = x2; b2 < S2; b2++) u2[i3[b2]] = y2;
    for (v2 = o3 - 1; v2 >= 0; v2--) l2[v2] = -1, y2 = u2[v2], y2 !== -1 && (d2[g2 + y2]++ === 0 && (d2[h2 + y2] = v2), d2[p2 + v2] = d2[m2 + y2], d2[m2 + y2] = v2);
    for (n3.lnz = 0, n3.m2 = o3, y2 = 0; y2 < s3; y2++) if (v2 = d2[m2 + y2], n3.lnz++, v2 < 0 && (v2 = n3.m2++), l2[v2] = y2, !(--g2[y2] <= 0)) {
      n3.lnz += d2[g2 + y2];
      var w2 = c2[y2];
      w2 !== -1 && (d2[g2 + w2] === 0 && (d2[h2 + w2] = d2[h2 + y2]), d2[p2 + d2[h2 + y2]] = d2[m2 + w2], d2[m2 + w2] = d2[p2 + v2], d2[g2 + w2] += d2[g2 + y2]);
    }
    for (v2 = 0; v2 < o3; v2++) l2[v2] < 0 && (l2[v2] = y2++);
    return true;
  }
});
function csMarked$1(t4, n2) {
  return t4[n2] < 0;
}
function csMark$1(t4, n2) {
  t4[n2] = csFlip$1(t4[n2]);
}
function csUnflip$1(t4) {
  return t4 < 0 ? csFlip$1(t4) : t4;
}
function csDfs$1(t4, n2, r2, i2, a2) {
  var o2 = n2._index, s2 = n2._ptr, c2 = n2._size[1], l2, u2, d2, p2 = 0;
  for (i2[0] = t4; p2 >= 0; ) {
    t4 = i2[p2];
    var m2 = a2 ? a2[t4] : t4;
    csMarked$1(s2, t4) || (csMark$1(s2, t4), i2[c2 + p2] = m2 < 0 ? 0 : csUnflip$1(s2[m2]));
    var h2 = 1;
    for (u2 = i2[c2 + p2], d2 = m2 < 0 ? 0 : csUnflip$1(s2[m2 + 1]); u2 < d2; u2++) if (l2 = o2[u2], !csMarked$1(s2, l2)) {
      i2[c2 + p2] = u2, i2[++p2] = l2, h2 = 0;
      break;
    }
    h2 && (p2--, i2[--r2] = t4);
  }
  return r2;
}
function csReach$1(t4, n2, r2, i2, a2) {
  var o2 = t4._ptr, s2 = t4._size, c2 = n2._index, l2 = n2._ptr, u2 = s2[1], d2, p2, m2, h2 = u2;
  for (p2 = l2[r2], m2 = l2[r2 + 1], d2 = p2; d2 < m2; d2++) {
    var g2 = c2[d2];
    csMarked$1(o2, g2) || (h2 = csDfs$1(g2, t4, h2, i2, a2));
  }
  for (d2 = h2; d2 < u2; d2++) csMark$1(o2, i2[d2]);
  return h2;
}
var name$86$1 = `csSpsolve`, dependencies$86$1 = [`divideScalar`, `multiply`, `subtract`], createCsSpsolve$1 = factory$1(name$86$1, dependencies$86$1, (t4) => {
  var { divideScalar: n2, multiply: r2, subtract: i2 } = t4;
  return function(t5, a2, o2, s2, c2, l2, u2) {
    var d2 = t5._values, p2 = t5._index, m2 = t5._ptr, h2 = t5._size[1], g2 = a2._values, v2 = a2._index, y2 = a2._ptr, b2, x2, S2, w2, E = csReach$1(t5, a2, o2, s2, l2);
    for (b2 = E; b2 < h2; b2++) c2[s2[b2]] = 0;
    for (x2 = y2[o2], S2 = y2[o2 + 1], b2 = x2; b2 < S2; b2++) c2[v2[b2]] = g2[b2];
    for (var D = E; D < h2; D++) {
      var O2 = s2[D], j2 = l2 ? l2[O2] : O2;
      if (!(j2 < 0)) for (x2 = m2[j2], S2 = m2[j2 + 1], c2[O2] = n2(c2[O2], d2[u2 ? x2 : S2 - 1]), b2 = u2 ? x2 + 1 : x2, w2 = u2 ? S2 : S2 - 1; b2 < w2; b2++) {
        var M2 = p2[b2];
        c2[M2] = i2(c2[M2], r2(d2[b2], c2[O2]));
      }
    }
    return E;
  };
}), name$85$1 = `csLu`, dependencies$85$1 = [`abs`, `divideScalar`, `multiply`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createCsLu$1 = factory$1(name$85$1, dependencies$85$1, (t4) => {
  var { abs: n2, divideScalar: r2, multiply: i2, subtract: a2, larger: o2, largerEq: s2, SparseMatrix: c2 } = t4, l2 = createCsSpsolve$1({ divideScalar: r2, multiply: i2, subtract: a2 });
  return function(t5, a3, u2) {
    if (!t5) return null;
    var d2 = t5._size[1], p2, m2 = 100, h2 = 100;
    a3 && (p2 = a3.q, m2 = a3.lnz || m2, h2 = a3.unz || h2);
    var g2 = [], v2 = [], y2 = [], b2 = new c2({ values: g2, index: v2, ptr: y2, size: [d2, d2] }), x2 = [], S2 = [], w2 = [], E = new c2({ values: x2, index: S2, ptr: w2, size: [d2, d2] }), D = [], O2, j2, M2 = [], N2 = [];
    for (O2 = 0; O2 < d2; O2++) M2[O2] = 0, D[O2] = -1, y2[O2 + 1] = 0;
    m2 = 0, h2 = 0;
    for (var F = 0; F < d2; F++) {
      y2[F] = m2, w2[F] = h2;
      var I2 = p2 ? p2[F] : F, L2 = l2(b2, t5, I2, N2, M2, D, 1), R2 = -1, z2 = -1;
      for (j2 = L2; j2 < d2; j2++) if (O2 = N2[j2], D[O2] < 0) {
        var V2 = n2(M2[O2]);
        o2(V2, z2) && (z2 = V2, R2 = O2);
      } else S2[h2] = D[O2], x2[h2++] = M2[O2];
      if (R2 === -1 || z2 <= 0) return null;
      D[I2] < 0 && s2(n2(M2[I2]), i2(z2, u2)) && (R2 = I2);
      var H2 = M2[R2];
      for (S2[h2] = F, x2[h2++] = H2, D[R2] = F, v2[m2] = R2, g2[m2++] = 1, j2 = L2; j2 < d2; j2++) O2 = N2[j2], D[O2] < 0 && (v2[m2] = O2, g2[m2++] = r2(M2[O2], H2)), M2[O2] = 0;
    }
    for (y2[d2] = m2, w2[d2] = h2, j2 = 0; j2 < m2; j2++) v2[j2] = D[v2[j2]];
    return g2.splice(m2, g2.length - m2), v2.splice(m2, v2.length - m2), x2.splice(h2, x2.length - h2), S2.splice(h2, S2.length - h2), { L: b2, U: E, pinv: D };
  };
}), name$84$1 = `slu`, dependencies$84$1 = [`typed`, `abs`, `add`, `multiply`, `transpose`, `divideScalar`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createSlu$1 = factory$1(name$84$1, dependencies$84$1, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, transpose: o2, divideScalar: s2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 } = t4, p2 = createCsSqr$1({ add: i2, multiply: a2, transpose: o2 }), m2 = createCsLu$1({ abs: r2, divideScalar: s2, multiply: a2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 });
  return n2(name$84$1, { "SparseMatrix, number, number": function(t5, n3, r3) {
    if (!isInteger$2(n3) || n3 < 0 || n3 > 3) throw Error(`Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]`);
    if (r3 < 0 || r3 > 1) throw Error(`Partial pivoting threshold must be a number from 0 to 1`);
    var i3 = p2(n3, t5, false), a3 = m2(t5, i3, r3);
    return { L: a3.L, U: a3.U, p: a3.pinv, q: i3.q, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : ``) + `
`;
    } };
  } });
});
function csIpvec$1(t4, n2) {
  var r2, i2 = n2.length, a2 = [];
  if (t4) for (r2 = 0; r2 < i2; r2++) a2[t4[r2]] = n2[r2];
  else for (r2 = 0; r2 < i2; r2++) a2[r2] = n2[r2];
  return a2;
}
var name$83$1 = `lusolve`, dependencies$83$1 = [`typed`, `matrix`, `lup`, `slu`, `usolve`, `lsolve`, `DenseMatrix`], createLusolve$1 = factory$1(name$83$1, dependencies$83$1, (t4) => {
  var { typed: n2, matrix: r2, lup: i2, slu: a2, usolve: o2, lsolve: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation$1({ DenseMatrix: c2 });
  return n2(name$83$1, { "Array, Array | Matrix": function(t5, n3) {
    t5 = r2(t5);
    var a3 = i2(t5);
    return d2(a3.L, a3.U, a3.p, null, n3).valueOf();
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix, number, number": function(t5, n3, r3, i3) {
    var o3 = a2(t5, r3, i3);
    return d2(o3.L, o3.U, o3.p, o3.q, n3);
  }, "Object, Array | Matrix": function(t5, n3) {
    return d2(t5.L, t5.U, t5.p, t5.q, n3);
  } });
  function u2(t5) {
    if (isMatrix$1(t5)) return t5;
    if (isArray$1(t5)) return r2(t5);
    throw TypeError(`Invalid Matrix LU decomposition`);
  }
  function d2(t5, n3, r3, i3, a3) {
    t5 = u2(t5), n3 = u2(n3), r3 && (a3 = l2(t5, a3, true), a3._data = csIpvec$1(r3, a3._data));
    var c3 = s2(t5, a3), d3 = o2(n3, c3);
    return i3 && (d3._data = csIpvec$1(i3, d3._data)), d3;
  }
}), name$82$1 = `polynomialRoot`, dependencies$82$1 = [`typed`, `isZero`, `equalScalar`, `add`, `subtract`, `multiply`, `divide`, `sqrt`, `unaryMinus`, `cbrt`, `typeOf`, `im`, `re`], createPolynomialRoot$1 = factory$1(name$82$1, dependencies$82$1, (t4) => {
  var { typed: n2, isZero: r2, equalScalar: i2, add: a2, subtract: o2, multiply: s2, divide: c2, sqrt: l2, unaryMinus: u2, cbrt: d2, typeOf: p2, im: m2, re: h2 } = t4;
  return n2(name$82$1, { "number|Complex, ...number|Complex": (t5, n3) => {
    for (var g2 = [t5, ...n3]; g2.length > 0 && r2(g2[g2.length - 1]); ) g2.pop();
    if (g2.length < 2) throw RangeError(`Polynomial [${t5}, ${n3}] must have a non-zero non-constant coefficient`);
    switch (g2.length) {
      case 2:
        return [u2(c2(g2[0], g2[1]))];
      case 3:
        var [v2, y2, b2] = g2, x2 = s2(2, b2), S2 = s2(y2, y2), w2 = s2(4, b2, v2);
        if (i2(S2, w2)) return [c2(u2(y2), x2)];
        var E = l2(o2(S2, w2));
        return [c2(o2(E, y2), x2), c2(o2(u2(E), y2), x2)];
      case 4:
        var [D, O2, j2, M2] = g2, N2 = u2(s2(3, M2)), F = s2(j2, j2), I2 = s2(3, M2, O2), L2 = a2(s2(2, j2, j2, j2), s2(27, M2, M2, D)), R2 = s2(9, M2, j2, O2);
        if (i2(F, I2) && i2(L2, R2)) return [c2(j2, N2)];
        var z2 = o2(F, I2), V2 = o2(L2, R2);
        return i2(a2(s2(18, M2, j2, O2, D), s2(j2, j2, O2, O2)), a2(s2(4, j2, j2, j2, D), s2(4, M2, O2, O2, O2), s2(27, M2, M2, D, D))) ? [c2(o2(s2(4, M2, j2, O2), a2(s2(9, M2, M2, D), s2(j2, j2, j2))), s2(M2, z2)), c2(o2(s2(9, M2, D), s2(j2, O2)), s2(2, z2))] : d2(i2(F, I2) ? V2 : c2(a2(V2, l2(o2(s2(V2, V2), s2(4, z2, z2, z2)))), 2), true).toArray().map((t6) => c2(a2(j2, t6, c2(z2, t6)), N2)).map((t6) => p2(t6) === `Complex` && i2(h2(t6), h2(t6) + m2(t6)) ? h2(t6) : t6);
      default:
        throw RangeError(`only implemented for cubic or lower-order polynomials, not ${g2}`);
    }
  } });
}), name$81$1 = `Help`, dependencies$81$1 = [`evaluate`], createHelpClass$1 = factory$1(name$81$1, dependencies$81$1, (t4) => {
  var { evaluate: n2 } = t4;
  function r2(t5) {
    if (!(this instanceof r2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (!t5) throw Error(`Argument "doc" missing`);
    this.doc = t5;
  }
  return r2.prototype.type = `Help`, r2.prototype.isHelp = true, r2.prototype.toString = function() {
    var t5 = this.doc || {}, r3 = `
`;
    if (t5.name && (r3 += `Name: ` + t5.name + `

`), t5.category && (r3 += `Category: ` + t5.category + `

`), t5.description && (r3 += `Description:
    ` + t5.description + `

`), t5.syntax && (r3 += `Syntax:
    ` + t5.syntax.join(`
    `) + `

`), t5.examples) {
      r3 += `Examples:
`;
      for (var i2 = false, a2 = n2(`config()`), o2 = { config: (t6) => (i2 = true, n2(`config(newConfig)`, { newConfig: t6 })) }, s2 = 0; s2 < t5.examples.length; s2++) {
        var c2 = t5.examples[s2];
        r3 += `    ` + c2 + `
`;
        var l2 = void 0;
        try {
          l2 = n2(c2, o2);
        } catch (t6) {
          l2 = t6;
        }
        l2 !== void 0 && !isHelp$1(l2) && (r3 += `        ` + format$3(l2, { precision: 14 }) + `
`);
      }
      r3 += `
`, i2 && n2(`config(originalConfig)`, { originalConfig: a2 });
    }
    return t5.mayThrow && t5.mayThrow.length && (r3 += `Throws: ` + t5.mayThrow.join(`, `) + `

`), t5.seealso && t5.seealso.length && (r3 += `See also: ` + t5.seealso.join(`, `) + `
`), r3;
  }, r2.prototype.toJSON = function() {
    var t5 = clone$3$1(this.doc);
    return t5.mathjs = `Help`, t5;
  }, r2.fromJSON = function(t5) {
    var n3 = {};
    return Object.keys(t5).filter((t6) => t6 !== `mathjs`).forEach((r3) => {
      n3[r3] = t5[r3];
    }), new r2(n3);
  }, r2.prototype.valueOf = r2.prototype.toString, r2;
}, { isClass: true }), name$80$1 = `Chain`, dependencies$80$1 = [`?on`, `math`, `typed`], createChainClass$1 = factory$1(name$80$1, dependencies$80$1, (t4) => {
  var { on: n2, math: r2, typed: i2 } = t4;
  function a2(t5) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    isChain$1(t5) ? this.value = t5.value : this.value = t5;
  }
  a2.prototype.type = `Chain`, a2.prototype.isChain = true, a2.prototype.done = function() {
    return this.value;
  }, a2.prototype.valueOf = function() {
    return this.value;
  }, a2.prototype.toString = function() {
    return format$3(this.value);
  }, a2.prototype.toJSON = function() {
    return { mathjs: `Chain`, value: this.value };
  }, a2.fromJSON = function(t5) {
    return new a2(t5.value);
  };
  function o2(t5, n3) {
    typeof n3 == `function` && (a2.prototype[t5] = c2(n3));
  }
  function s2(t5, n3) {
    lazy$1(a2.prototype, t5, function() {
      var t6 = n3();
      if (typeof t6 == `function`) return c2(t6);
    });
  }
  function c2(t5) {
    return function() {
      if (arguments.length === 0) return new a2(t5(this.value));
      for (var n3 = [this.value], r3 = 0; r3 < arguments.length; r3++) n3[r3 + 1] = arguments[r3];
      if (i2.isTypedFunction(t5)) {
        var o3 = i2.resolve(t5, n3);
        if (o3.params.length === 1) throw Error(`chain function ` + t5.name + ` cannot match rest parameter between chain value and additional arguments.`);
        return new a2(o3.implementation.apply(t5, n3));
      }
      return new a2(t5.apply(t5, n3));
    };
  }
  a2.createProxy = function(t5, n3) {
    if (typeof t5 == `string`) o2(t5, n3);
    else {
      var r3 = function(n4) {
        hasOwnProperty$1$3(t5, n4) && l2[n4] === void 0 && s2(n4, () => t5[n4]);
      };
      for (var i3 in t5) r3(i3);
    }
  };
  var l2 = { expression: true, docs: true, type: true, classes: true, json: true, error: true, isChain: true };
  return a2.createProxy(r2), n2 && n2(`import`, function(t5, n3, r3) {
    r3 || s2(t5, n3);
  }), a2;
}, { isClass: true }), eDocs$1 = { name: `e`, category: `Constants`, syntax: [`e`], description: `Euler's number, the base of the natural logarithm. Approximately equal to 2.71828`, examples: [`e`, `e ^ 2`, `exp(2)`, `log(e)`], seealso: [`exp`] }, falseDocs$1 = { name: `false`, category: `Constants`, syntax: [`false`], description: `Boolean value false`, examples: [`false`], seealso: [`true`] }, iDocs$1 = { name: `i`, category: `Constants`, syntax: [`i`], description: `Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.`, examples: [`i`, `i * i`, `sqrt(-1)`], seealso: [] }, InfinityDocs$1 = { name: `Infinity`, category: `Constants`, syntax: [`Infinity`], description: `Infinity, a number which is larger than the maximum number that can be handled by a floating point number.`, examples: [`Infinity`, `1 / 0`], seealso: [] }, LN10Docs$1 = { name: `LN10`, category: `Constants`, syntax: [`LN10`], description: `Returns the natural logarithm of 10, approximately equal to 2.302`, examples: [`LN10`, `log(10)`], seealso: [] }, LN2Docs$1 = { name: `LN2`, category: `Constants`, syntax: [`LN2`], description: `Returns the natural logarithm of 2, approximately equal to 0.693`, examples: [`LN2`, `log(2)`], seealso: [] }, LOG10EDocs$1 = { name: `LOG10E`, category: `Constants`, syntax: [`LOG10E`], description: `Returns the base-10 logarithm of E, approximately equal to 0.434`, examples: [`LOG10E`, `log(e, 10)`], seealso: [] }, LOG2EDocs$1 = { name: `LOG2E`, category: `Constants`, syntax: [`LOG2E`], description: `Returns the base-2 logarithm of E, approximately equal to 1.442`, examples: [`LOG2E`, `log(e, 2)`], seealso: [] }, NaNDocs$1 = { name: `NaN`, category: `Constants`, syntax: [`NaN`], description: `Not a number`, examples: [`NaN`, `0 / 0`], seealso: [] }, nullDocs$1 = { name: `null`, category: `Constants`, syntax: [`null`], description: `Value null`, examples: [`null`], seealso: [`true`, `false`] }, phiDocs$1 = { name: `phi`, category: `Constants`, syntax: [`phi`], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: [`phi`], seealso: [] }, piDocs$1 = { name: `pi`, category: `Constants`, syntax: [`pi`], description: `The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159`, examples: [`pi`, `sin(pi/2)`], seealso: [`tau`] }, SQRT12Docs$1 = { name: `SQRT1_2`, category: `Constants`, syntax: [`SQRT1_2`], description: `Returns the square root of 1/2, approximately equal to 0.707`, examples: [`SQRT1_2`, `sqrt(1/2)`], seealso: [] }, SQRT2Docs$1 = { name: `SQRT2`, category: `Constants`, syntax: [`SQRT2`], description: `Returns the square root of 2, approximately equal to 1.414`, examples: [`SQRT2`, `sqrt(2)`], seealso: [] }, tauDocs$1 = { name: `tau`, category: `Constants`, syntax: [`tau`], description: `Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.`, examples: [`tau`, `2 * pi`], seealso: [`pi`] }, trueDocs$1 = { name: `true`, category: `Constants`, syntax: [`true`], description: `Boolean value true`, examples: [`true`], seealso: [`false`] }, versionDocs$1 = { name: `version`, category: `Constants`, syntax: [`version`], description: `A string with the version number of math.js`, examples: [`version`], seealso: [] }, bignumberDocs$1 = { name: `bignumber`, category: `Construction`, syntax: [`bignumber(x)`], description: `Create a big number from a number or string.`, examples: [`0.1 + 0.2`, `bignumber(0.1) + bignumber(0.2)`, `bignumber("7.2")`, `bignumber("7.2e500")`, `bignumber([0.1, 0.2, 0.3])`], seealso: [`boolean`, `bigint`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, bigintDocs$1 = { name: `bigint`, category: `Construction`, syntax: [`bigint(x)`], description: `Create a bigint, an integer with an arbitrary number of digits, from a number or string.`, examples: [`123123123123123123 # a large number will lose digits`, `bigint("123123123123123123")`, `bignumber(["1", "3", "5"])`], seealso: [`boolean`, `bignumber`, `number`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, booleanDocs$1 = { name: `boolean`, category: `Construction`, syntax: [`x`, `boolean(x)`], description: `Convert a string or number into a boolean.`, examples: [`boolean(0)`, `boolean(1)`, `boolean(3)`, `boolean("true")`, `boolean("false")`, `boolean([1, 0, 1, 1])`], seealso: [`bignumber`, `complex`, `index`, `matrix`, `number`, `string`, `unit`] }, complexDocs$1 = { name: `complex`, category: `Construction`, syntax: [`complex()`, `complex(re, im)`, `complex(string)`], description: `Create a complex number.`, examples: [`complex()`, `complex(2, 3)`, `complex("7 - 2i")`], seealso: [`bignumber`, `boolean`, `index`, `matrix`, `number`, `string`, `unit`] }, createUnitDocs$1 = { name: `createUnit`, category: `Construction`, syntax: [`createUnit(definitions)`, `createUnit(name, definition)`], description: `Create a user-defined unit and register it with the Unit type.`, examples: [`createUnit("foo")`, `createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})`, `createUnit("mph", "1 mile/hour")`], seealso: [`unit`, `splitUnit`] }, fractionDocs$1 = { name: `fraction`, category: `Construction`, syntax: [`fraction(num)`, `fraction(matrix)`, `fraction(num,den)`, `fraction({n: num, d: den})`], description: `Create a fraction from a number or from integer numerator and denominator.`, examples: [`fraction(0.125)`, `fraction(1, 3) + fraction(2, 5)`, `fraction({n: 333, d: 53})`, `fraction([sqrt(9), sqrt(10), sqrt(11)])`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `string`, `unit`] }, indexDocs$1 = { name: `index`, category: `Construction`, syntax: [`[start]`, `[start:end]`, `[start:step:end]`, `[start1, start 2, ...]`, `[start1:end1, start2:end2, ...]`, `[start1:step1:end1, start2:step2:end2, ...]`], description: `Create an index to get or replace a subset of a matrix`, examples: [`A = [1, 2, 3; 4, 5, 6]`, `A[1, :]`, `A[1, 2] = 50`, `A[1:2, 1:2] = 1`, `B = [1, 2, 3]`, `B[B>1 and B<3]`], seealso: [`bignumber`, `boolean`, `complex`, `matrix`, `number`, `range`, `string`, `unit`] }, matrixDocs$1 = { name: `matrix`, category: `Construction`, syntax: [`[]`, `[a1, b1, ...; a2, b2, ...]`, `matrix()`, `matrix("dense")`, `matrix([...])`], description: `Create a matrix.`, examples: [`[]`, `[1, 2, 3]`, `[1, 2, 3; 4, 5, 6]`, `matrix()`, `matrix([3, 4])`, `matrix([3, 4; 5, 6], "sparse")`, `matrix([3, 4; 5, 6], "sparse", "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `sparse`] }, numberDocs$1 = { name: `number`, category: `Construction`, syntax: [`x`, `number(x)`, `number(unit, valuelessUnit)`], description: `Create a number or convert a string or boolean into a number.`, examples: [`2`, `2e3`, `4.05`, `number(2)`, `number("7.2")`, `number(true)`, `number([true, false, true, true])`, `number(unit("52cm"), "m")`], seealso: [`bignumber`, `bigint`, `boolean`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, sparseDocs$1 = { name: `sparse`, category: `Construction`, syntax: [`sparse()`, `sparse([a1, b1, ...; a1, b2, ...])`, `sparse([a1, b1, ...; a1, b2, ...], "number")`], description: `Create a sparse matrix.`, examples: [`sparse()`, `sparse([3, 4; 5, 6])`, `sparse([3, 0; 5, 0], "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `matrix`] }, splitUnitDocs$1 = { name: `splitUnit`, category: `Construction`, syntax: [`splitUnit(unit: Unit, parts: Unit[])`], description: `Split a unit in an array of units whose sum is equal to the original unit.`, examples: [`splitUnit(1 m, ["feet", "inch"])`], seealso: [`unit`, `createUnit`] }, stringDocs$1 = { name: `string`, category: `Construction`, syntax: [`"text"`, `string(x)`], description: `Create a string or convert a value to a string`, examples: [`"Hello World!"`, `string(4.2)`, `string(3 + 2i)`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `unit`] }, unitDocs$1 = { name: `unit`, category: `Construction`, syntax: [`value unit`, `unit(value, unit)`, `unit(string)`], description: `Create a unit.`, examples: [`5.5 mm`, `3 inch`, `unit(7.1, "kilogram")`, `unit("23 deg")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `string`] }, configDocs$1 = { name: `config`, category: `Core`, syntax: [`config()`, `config(options)`], description: `Get configuration or change configuration.`, examples: [`config()`, `1/3 + 1/4`, `config({number: "Fraction"})`, `1/3 + 1/4`], seealso: [] }, importDocs$1 = { name: `import`, category: `Core`, syntax: [`import(functions)`, `import(functions, options)`], description: `Import functions or constants from an object.`, examples: [`import({myFn: f(x)=x^2, myConstant: 32 })`, `myFn(2)`, `myConstant`], seealso: [] }, typedDocs$1 = { name: `typed`, category: `Core`, syntax: [`typed(signatures)`, `typed(name, signatures)`], description: `Create a typed function.`, examples: [`double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })`, `double(2)`, `double("hello")`], seealso: [] }, derivativeDocs$1 = { name: `derivative`, category: `Algebra`, syntax: [`derivative(expr, variable)`, `derivative(expr, variable, {simplify: boolean})`], description: `Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.`, examples: [`derivative("2x^3", "x")`, `derivative("2x^3", "x", {simplify: false})`, `derivative("2x^2 + 3x + 4", "x")`, `derivative("sin(2x)", "x")`, `f = parse("x^2 + x")`, `x = parse("x")`, `df = derivative(f, x)`, `df.evaluate({x: 3})`], seealso: [`simplify`, `parse`, `evaluate`] }, leafCountDocs$1 = { name: `leafCount`, category: `Algebra`, syntax: [`leafCount(expr)`], description: `Computes the number of leaves in the parse tree of the given expression`, examples: [`leafCount("e^(i*pi)-1")`, `leafCount(parse("{a: 22/7, b: 10^(1/2)}"))`], seealso: [`simplify`] }, lsolveDocs$1 = { name: `lsolve`, category: `Algebra`, syntax: [`x=lsolve(L, b)`], description: `Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolveAll`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lsolveAllDocs$1 = { name: `lsolveAll`, category: `Algebra`, syntax: [`x=lsolveAll(L, b)`], description: `Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolve`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lupDocs$1 = { name: `lup`, category: `Algebra`, syntax: [`lup(m)`], description: `Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U`, examples: [`lup([[2, 1], [1, 4]])`, `lup(matrix([[2, 1], [1, 4]]))`, `lup(sparse([[2, 1], [1, 4]]))`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `slu`, `qr`] }, lusolveDocs$1 = { name: `lusolve`, category: `Algebra`, syntax: [`x=lusolve(A, b)`, `x=lusolve(lu, b)`], description: `Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lusolve(a, b)`], seealso: [`lup`, `slu`, `lsolve`, `usolve`, `matrix`, `sparse`] }, polynomialRootDocs$1 = { name: `polynomialRoot`, category: `Algebra`, syntax: [`x=polynomialRoot(-6, 3)`, `x=polynomialRoot(4, -4, 1)`, `x=polynomialRoot(-8, 12, -6, 1)`], description: `Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.`, examples: [`a = polynomialRoot(-6, 11, -6, 1)`], seealso: [`cbrt`, `sqrt`] }, qrDocs$1 = { name: `qr`, category: `Algebra`, syntax: [`qr(A)`], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: [`qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])`], seealso: [`lup`, `slu`, `matrix`] }, rationalizeDocs$1 = { name: `rationalize`, category: `Algebra`, syntax: [`rationalize(expr)`, `rationalize(expr, scope)`, `rationalize(expr, scope, detailed)`], description: `Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.`, examples: [`rationalize("2x/y - y/(x+1)")`, `rationalize("2x/y - y/(x+1)", true)`], seealso: [`simplify`] }, resolveDocs$1 = { name: `resolve`, category: `Algebra`, syntax: [`resolve(node, scope)`], description: `Recursively substitute variables in an expression tree.`, examples: [`resolve(parse("1 + x"), { x: 7 })`, `resolve(parse("size(text)"), { text: "Hello World" })`, `resolve(parse("x + y"), { x: parse("3z") })`, `resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })`], seealso: [`simplify`, `evaluate`], mayThrow: [`ReferenceError`] }, simplifyDocs$1 = { name: `simplify`, category: `Algebra`, syntax: [`simplify(expr)`, `simplify(expr, rules)`], description: `Simplify an expression tree.`, examples: [`simplify("3 + 2 / 4")`, `simplify("2x + x")`, `f = parse("x * (x + 2 + x)")`, `simplified = simplify(f)`, `simplified.evaluate({x: 2})`], seealso: [`simplifyCore`, `derivative`, `evaluate`, `parse`, `rationalize`, `resolve`] }, simplifyConstantDocs$1 = { name: `simplifyConstant`, category: `Algebra`, syntax: [`simplifyConstant(expr)`, `simplifyConstant(expr, options)`], description: `Replace constant subexpressions of node with their values.`, examples: [`simplifyConstant("(3-3)*x")`, `simplifyConstant(parse("z-cos(tau/8)"))`], seealso: [`simplify`, `simplifyCore`, `evaluate`] }, simplifyCoreDocs$1 = { name: `simplifyCore`, category: `Algebra`, syntax: [`simplifyCore(node)`], description: `Perform simple one-pass simplifications on an expression tree.`, examples: [`simplifyCore(parse("0*x"))`, `simplifyCore(parse("(x+0)*2"))`], seealso: [`simplify`, `simplifyConstant`, `evaluate`] }, sluDocs$1 = { name: `slu`, category: `Algebra`, syntax: [`slu(A, order, threshold)`], description: `Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U`, examples: [`slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `lup`, `qr`] }, symbolicEqualDocs$1 = { name: `symbolicEqual`, category: `Algebra`, syntax: [`symbolicEqual(expr1, expr2)`, `symbolicEqual(expr1, expr2, options)`], description: `Returns true if the difference of the expressions simplifies to 0`, examples: [`symbolicEqual("x*y","y*x")`, `symbolicEqual("abs(x^2)", "x^2")`, `symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})`], seealso: [`simplify`, `evaluate`] }, usolveDocs$1 = { name: `usolve`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolveAll`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, usolveAllDocs$1 = { name: `usolveAll`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolve`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, absDocs$1 = { name: `abs`, category: `Arithmetic`, syntax: [`abs(x)`], description: `Compute the absolute value.`, examples: [`abs(3.5)`, `abs(-4.2)`], seealso: [`sign`] }, addDocs$1 = { name: `add`, category: `Operators`, syntax: [`x + y`, `add(x, y)`], description: `Add two values.`, examples: [`a = 2.1 + 3.6`, `a - 3.6`, `3 + 2i`, `3 cm + 2 inch`, `"2.3" + "4"`], seealso: [`subtract`] }, cbrtDocs$1 = { name: `cbrt`, category: `Arithmetic`, syntax: [`cbrt(x)`, `cbrt(x, allRoots)`], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: [`cbrt(64)`, `cube(4)`, `cbrt(-8)`, `cbrt(2 + 3i)`, `cbrt(8i)`, `cbrt(8i, true)`, `cbrt(27 m^3)`], seealso: [`square`, `sqrt`, `cube`, `multiply`] }, ceilDocs$1 = { name: `ceil`, category: `Arithmetic`, syntax: [`ceil(x)`, `ceil(x, n)`, `ceil(unit, valuelessUnit)`, `ceil(unit, n, valuelessUnit)`], description: `Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.`, examples: [`ceil(3.2)`, `ceil(3.8)`, `ceil(-4.2)`, `ceil(3.241cm, cm)`, `ceil(3.241cm, 2, cm)`], seealso: [`floor`, `fix`, `round`] }, cubeDocs$1 = { name: `cube`, category: `Arithmetic`, syntax: [`cube(x)`], description: `Compute the cube of a value. The cube of x is x * x * x.`, examples: [`cube(2)`, `2^3`, `2 * 2 * 2`], seealso: [`multiply`, `square`, `pow`] }, divideDocs$1 = { name: `divide`, category: `Operators`, syntax: [`x / y`, `divide(x, y)`], description: `Divide two values.`, examples: [`a = 2 / 3`, `a * 3`, `4.5 / 2`, `3 + 4 / 2`, `(3 + 4) / 2`, `18 km / 4.5`], seealso: [`multiply`] }, dotDivideDocs$1 = { name: `dotDivide`, category: `Operators`, syntax: [`x ./ y`, `dotDivide(x, y)`], description: `Divide two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a ./ b`], seealso: [`multiply`, `dotMultiply`, `divide`] }, dotMultiplyDocs$1 = { name: `dotMultiply`, category: `Operators`, syntax: [`x .* y`, `dotMultiply(x, y)`], description: `Multiply two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a .* b`], seealso: [`multiply`, `divide`, `dotDivide`] }, dotPowDocs$1 = { name: `dotPow`, category: `Operators`, syntax: [`x .^ y`, `dotPow(x, y)`], description: `Calculates the power of x to y element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a .^ 2`], seealso: [`pow`] }, expDocs$1 = { name: `exp`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Calculate the exponent of a value.`, examples: [`exp(1.3)`, `e ^ 1.3`, `log(exp(1.3))`, `x = 2.4`, `(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula`], seealso: [`expm`, `expm1`, `pow`, `log`] }, expmDocs$1 = { name: `expm`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.`, examples: [`expm([[0,2],[0,0]])`], seealso: [`exp`] }, expm1Docs$1 = { name: `expm1`, category: `Arithmetic`, syntax: [`expm1(x)`], description: `Calculate the value of subtracting 1 from the exponential value.`, examples: [`expm1(2)`, `pow(e, 2) - 1`, `log(expm1(2) + 1)`], seealso: [`exp`, `pow`, `log`] }, fixDocs$1 = { name: `fix`, category: `Arithmetic`, syntax: [`fix(x)`, `fix(x, n)`, `fix(unit, valuelessUnit)`, `fix(unit, n, valuelessUnit)`], description: `Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.`, examples: [`fix(3.2)`, `fix(3.8)`, `fix(-4.2)`, `fix(-4.8)`, `fix(3.241cm, cm)`, `fix(3.241cm, 2, cm)`], seealso: [`ceil`, `floor`, `round`] }, floorDocs$1 = { name: `floor`, category: `Arithmetic`, syntax: [`floor(x)`, `floor(x, n)`, `floor(unit, valuelessUnit)`, `floor(unit, n, valuelessUnit)`], description: `Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.`, examples: [`floor(3.2)`, `floor(3.8)`, `floor(-4.2)`, `floor(3.241cm, cm)`, `floor(3.241cm, 2, cm)`], seealso: [`ceil`, `fix`, `round`] }, gcdDocs$1 = { name: `gcd`, category: `Arithmetic`, syntax: [`gcd(a, b)`, `gcd(a, b, c, ...)`], description: `Compute the greatest common divisor.`, examples: [`gcd(8, 12)`, `gcd(-4, 6)`, `gcd(25, 15, -10)`], seealso: [`lcm`, `xgcd`] }, hypotDocs$1 = { name: `hypot`, category: `Arithmetic`, syntax: [`hypot(a, b, c, ...)`, `hypot([a, b, c, ...])`], description: `Calculate the hypotenuse of a list with values.`, examples: [`hypot(3, 4)`, `sqrt(3^2 + 4^2)`, `hypot(-2)`, `hypot([3, 4, 5])`], seealso: [`abs`, `norm`] }, invmodDocs$1 = { name: `invmod`, category: `Arithmetic`, syntax: [`invmod(a, b)`], description: `Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)`, examples: [`invmod(8, 12)`, `invmod(7, 13)`, `invmod(15151, 15122)`], seealso: [`gcd`, `xgcd`] }, lcmDocs$1 = { name: `lcm`, category: `Arithmetic`, syntax: [`lcm(x, y)`], description: `Compute the least common multiple.`, examples: [`lcm(4, 6)`, `lcm(6, 21)`, `lcm(6, 21, 5)`], seealso: [`gcd`] }, logDocs$1 = { name: `log`, category: `Arithmetic`, syntax: [`log(x)`, `log(x, base)`], description: `Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).`, examples: [`log(3.5)`, `a = log(2.4)`, `exp(a)`, `10 ^ 4`, `log(10000, 10)`, `log(10000) / log(10)`, `b = log(1024, 2)`, `2 ^ b`], seealso: [`exp`, `log1p`, `log2`, `log10`] }, log10Docs$1 = { name: `log10`, category: `Arithmetic`, syntax: [`log10(x)`], description: `Compute the 10-base logarithm of a value.`, examples: [`log10(0.00001)`, `log10(10000)`, `10 ^ 4`, `log(10000) / log(10)`, `log(10000, 10)`], seealso: [`exp`, `log`] }, log1pDocs$1 = { name: `log1p`, category: `Arithmetic`, syntax: [`log1p(x)`, `log1p(x, base)`], description: "Calculate the logarithm of a `value+1`", examples: [`log1p(2.5)`, `exp(log1p(1.4))`, `pow(10, 4)`, `log1p(9999, 10)`, `log1p(9999) / log(10)`], seealso: [`exp`, `log`, `log2`, `log10`] }, log2Docs$1 = { name: `log2`, category: `Arithmetic`, syntax: [`log2(x)`], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: [`log2(0.03125)`, `log2(16)`, `log2(16) / log2(2)`, `pow(2, 4)`], seealso: [`exp`, `log1p`, `log`, `log10`] }, modDocs$1 = { name: `mod`, category: `Operators`, syntax: [`x % y`, `x mod y`, `mod(x, y)`], description: `Calculates the modulus, the remainder of an integer division.`, examples: [`7 % 3`, `11 % 2`, `10 mod 4`, `isOdd(x) = x % 2`, `isOdd(2)`, `isOdd(3)`], seealso: [`divide`] }, multiplyDocs$1 = { name: `multiply`, category: `Operators`, syntax: [`x * y`, `multiply(x, y)`], description: `multiply two values.`, examples: [`a = 2.1 * 3.4`, `a / 3.4`, `2 * 3 + 4`, `2 * (3 + 4)`, `3 * 2.1 km`], seealso: [`divide`] }, normDocs$1 = { name: `norm`, category: `Arithmetic`, syntax: [`norm(x)`, `norm(x, p)`], description: `Calculate the norm of a number, vector or matrix.`, examples: [`abs(-3.5)`, `norm(-3.5)`, `norm(3 - 4i)`, `norm([1, 2, -3], Infinity)`, `norm([1, 2, -3], -Infinity)`, `norm([3, 4], 2)`, `norm([[1, 2], [3, 4]], 1)`, `norm([[1, 2], [3, 4]], "inf")`, `norm([[1, 2], [3, 4]], "fro")`] }, nthRootDocs$1 = { name: `nthRoot`, category: `Arithmetic`, syntax: [`nthRoot(a)`, `nthRoot(a, root)`], description: `Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".`, examples: [`4 ^ 3`, `nthRoot(64, 3)`, `nthRoot(9, 2)`, `sqrt(9)`], seealso: [`nthRoots`, `pow`, `sqrt`] }, nthRootsDocs$1 = { name: `nthRoots`, category: `Arithmetic`, syntax: [`nthRoots(A)`, `nthRoots(A, root)`], description: `Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.`, examples: [`nthRoots(1)`, `nthRoots(1, 3)`], seealso: [`sqrt`, `pow`, `nthRoot`] }, powDocs$1 = { name: `pow`, category: `Operators`, syntax: [`x ^ y`, `pow(x, y)`], description: `Calculates the power of x to y, x^y.`, examples: [`2^3`, `2*2*2`, `1 + e ^ (pi * i)`, `pow([[1, 2], [4, 3]], 2)`, `pow([[1, 2], [4, 3]], -1)`], seealso: [`multiply`, `nthRoot`, `nthRoots`, `sqrt`] }, roundDocs$1 = { name: `round`, category: `Arithmetic`, syntax: [`round(x)`, `round(x, n)`, `round(unit, valuelessUnit)`, `round(unit, n, valuelessUnit)`], description: `round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.`, examples: [`round(3.2)`, `round(3.8)`, `round(-4.2)`, `round(-4.8)`, `round(pi, 3)`, `round(123.45678, 2)`, `round(3.241cm, 2, cm)`, `round([3.2, 3.8, -4.7])`], seealso: [`ceil`, `floor`, `fix`] }, signDocs$1 = { name: `sign`, category: `Arithmetic`, syntax: [`sign(x)`], description: `Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.`, examples: [`sign(3.5)`, `sign(-4.2)`, `sign(0)`], seealso: [`abs`] }, sqrtDocs$1 = { name: `sqrt`, category: `Arithmetic`, syntax: [`sqrt(x)`], description: `Compute the square root value. If x = y * y, then y is the square root of x.`, examples: [`sqrt(25)`, `5 * 5`, `sqrt(-1)`], seealso: [`square`, `sqrtm`, `multiply`, `nthRoot`, `nthRoots`, `pow`] }, sqrtmDocs$1 = { name: `sqrtm`, category: `Arithmetic`, syntax: [`sqrtm(x)`], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: [`sqrtm([[33, 24], [48, 57]])`], seealso: [`sqrt`, `abs`, `square`, `multiply`] }, sylvesterDocs$1 = { name: `sylvester`, category: `Algebra`, syntax: [`sylvester(A,B,C)`], description: `Solves the real-valued Sylvester equation AX+XB=C for X`, examples: [`sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])`, `A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]`, `sylvester(A, B, C)`], seealso: [`schur`, `lyap`] }, schurDocs$1 = { name: `schur`, category: `Algebra`, syntax: [`schur(A)`], description: `Performs a real Schur decomposition of the real matrix A = UTU'`, examples: [`schur([[1, 0], [-4, 3]])`, `A = [[1, 0], [-4, 3]]`, `schur(A)`], seealso: [`lyap`, `sylvester`] }, lyapDocs$1 = { name: `lyap`, category: `Algebra`, syntax: [`lyap(A,Q)`], description: `Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P`, examples: [`lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])`, `A = [[-2, 0], [1, -4]]`, `Q = [[3, 1], [1, 3]]`, `lyap(A,Q)`], seealso: [`schur`, `sylvester`] }, squareDocs$1 = { name: `square`, category: `Arithmetic`, syntax: [`square(x)`], description: `Compute the square of a value. The square of x is x * x.`, examples: [`square(3)`, `sqrt(9)`, `3^2`, `3 * 3`], seealso: [`multiply`, `pow`, `sqrt`, `cube`] }, subtractDocs$1 = { name: `subtract`, category: `Operators`, syntax: [`x - y`, `subtract(x, y)`], description: `subtract two values.`, examples: [`a = 5.3 - 2`, `a + 2`, `2/3 - 1/6`, `2 * 3 - 3`, `2.1 km - 500m`], seealso: [`add`] }, unaryMinusDocs$1 = { name: `unaryMinus`, category: `Operators`, syntax: [`-x`, `unaryMinus(x)`], description: `Inverse the sign of a value. Converts booleans and strings to numbers.`, examples: [`-4.5`, `-(-5.6)`, `-"22"`], seealso: [`add`, `subtract`, `unaryPlus`] }, unaryPlusDocs$1 = { name: `unaryPlus`, category: `Operators`, syntax: [`+x`, `unaryPlus(x)`], description: `Converts booleans and strings to numbers.`, examples: [`+true`, `+"2"`], seealso: [`add`, `subtract`, `unaryMinus`] }, xgcdDocs$1 = { name: `xgcd`, category: `Arithmetic`, syntax: [`xgcd(a, b)`], description: `Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.`, examples: [`xgcd(8, 12)`, `gcd(8, 12)`, `xgcd(36163, 21199)`], seealso: [`gcd`, `lcm`] }, numDocs$1 = { name: `num`, category: `Fraction`, syntax: [`num(x)`], description: `Get the numerator of a fraction.`, examples: [`num(fraction(2, 3))`, `num(fraction(5, 8))`], seealso: [`den`, `fraction`] }, denDocs$1 = { name: `den`, category: `Fraction`, syntax: [`den(x)`], description: `Get the denominator of a fraction.`, examples: [`den(fraction(2, 3))`, `den(fraction(5, 8))`], seealso: [`num`, `fraction`] }, bitAndDocs$1 = { name: `bitAnd`, category: `Bitwise`, syntax: [`x & y`, `bitAnd(x, y)`], description: `Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0`, examples: [`5 & 3`, `bitAnd(53, 131)`, `[1, 12, 31] & 42`], seealso: [`bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitNotDocs$1 = { name: `bitNot`, category: `Bitwise`, syntax: [`~x`, `bitNot(x)`], description: `Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.`, examples: [`~1`, `~2`, `bitNot([2, -3, 4])`], seealso: [`bitAnd`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitOrDocs$1 = { name: `bitOr`, category: `Bitwise`, syntax: [`x | y`, `bitOr(x, y)`], description: `Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.`, examples: [`5 | 3`, `bitOr([1, 2, 3], 4)`], seealso: [`bitAnd`, `bitNot`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitXorDocs$1 = { name: `bitXor`, category: `Bitwise`, syntax: [`bitXor(x, y)`], description: `Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.`, examples: [`bitOr(1, 2)`, `bitXor([2, 3, 4], 4)`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `leftShift`, `rightArithShift`, `rightLogShift`] }, leftShiftDocs$1 = { name: `leftShift`, category: `Bitwise`, syntax: [`x << y`, `leftShift(x, y)`], description: `Bitwise left logical shift of a value x by y number of bits.`, examples: [`4 << 1`, `8 >> 1`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `rightArithShift`, `rightLogShift`] }, rightArithShiftDocs$1 = { name: `rightArithShift`, category: `Bitwise`, syntax: [`x >> y`, `rightArithShift(x, y)`], description: `Bitwise right arithmetic shift of a value x by y number of bits.`, examples: [`8 >> 1`, `4 << 1`, `-12 >> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightLogShift`] }, rightLogShiftDocs$1 = { name: `rightLogShift`, category: `Bitwise`, syntax: [`x >>> y`, `rightLogShift(x, y)`], description: `Bitwise right logical shift of a value x by y number of bits.`, examples: [`8 >>> 1`, `4 << 1`, `-12 >>> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`] }, bellNumbersDocs$1 = { name: `bellNumbers`, category: `Combinatorics`, syntax: [`bellNumbers(n)`], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: [`bellNumbers(3)`, `bellNumbers(8)`], seealso: [`stirlingS2`] }, catalanDocs$1 = { name: `catalan`, category: `Combinatorics`, syntax: [`catalan(n)`], description: `The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.`, examples: [`catalan(3)`, `catalan(8)`], seealso: [`bellNumbers`] }, compositionDocs$1 = { name: `composition`, category: `Combinatorics`, syntax: [`composition(n, k)`], description: `The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.`, examples: [`composition(5, 3)`], seealso: [`combinations`] }, stirlingS2Docs$1 = { name: `stirlingS2`, category: `Combinatorics`, syntax: [`stirlingS2(n, k)`], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: [`stirlingS2(5, 3)`], seealso: [`bellNumbers`, `bernoulli`] }, argDocs$1 = { name: `arg`, category: `Complex`, syntax: [`arg(x)`], description: `Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).`, examples: [`arg(2 + 2i)`, `atan2(3, 2)`, `arg(2 + 3i)`], seealso: [`re`, `im`, `conj`, `abs`] }, conjDocs$1 = { name: `conj`, category: `Complex`, syntax: [`conj(x)`], description: `Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.`, examples: [`conj(2 + 3i)`, `conj(2 - 3i)`, `conj(-5.2i)`], seealso: [`re`, `im`, `abs`, `arg`] }, imDocs$1 = { name: `im`, category: `Complex`, syntax: [`im(x)`], description: `Get the imaginary part of a complex number.`, examples: [`im(2 + 3i)`, `re(2 + 3i)`, `im(-5.2i)`, `im(2.4)`], seealso: [`re`, `conj`, `abs`, `arg`] }, reDocs$1 = { name: `re`, category: `Complex`, syntax: [`re(x)`], description: `Get the real part of a complex number.`, examples: [`re(2 + 3i)`, `im(2 + 3i)`, `re(-5.2i)`, `re(2.4)`], seealso: [`im`, `conj`, `abs`, `arg`] }, evaluateDocs$1 = { name: `evaluate`, category: `Expression`, syntax: [`evaluate(expression)`, `evaluate(expression, scope)`, `evaluate([expr1, expr2, expr3, ...])`, `evaluate([expr1, expr2, expr3, ...], scope)`], description: `Evaluate an expression or an array with expressions.`, examples: [`evaluate("2 + 3")`, `evaluate("sqrt(16)")`, `evaluate("2 inch to cm")`, `evaluate("sin(x * pi)", { "x": 1/2 })`, `evaluate(["width=2", "height=4","width*height"])`], seealso: [`parser`, `parse`, `compile`] }, parserDocs$1 = { name: `parser`, category: `Expression`, syntax: [`parser()`], description: `Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.`, examples: [`myParser = parser()`, `myParser.evaluate("sqrt(3^2 + 4^2)")`, `myParser.set("x", 3)`, `myParser.evaluate("y = x + 3")`, `myParser.evaluate(["y = x + 3", "y = y + 1"])`, `myParser.get("y")`], seealso: [`evaluate`, `parse`, `compile`] }, parseDocs$1 = { name: `parse`, category: `Expression`, syntax: [`parse(expr)`, `parse(expr, options)`, `parse([expr1, expr2, expr3, ...])`, `parse([expr1, expr2, expr3, ...], options)`], description: `Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().`, examples: [`node1 = parse("sqrt(3^2 + 4^2)")`, `node1.evaluate()`, `code1 = node1.compile()`, `code1.evaluate()`, `scope = {a: 3, b: 4}`, `node2 = parse("a * b")`, `node2.evaluate(scope)`, `code2 = node2.compile()`, `code2.evaluate(scope)`], seealso: [`parser`, `evaluate`, `compile`] }, compileDocs$1 = { name: `compile`, category: `Expression`, syntax: [`compile(expr) `, `compile([expr1, expr2, expr3, ...])`], description: `Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.`, examples: [`code1 = compile("sqrt(3^2 + 4^2)")`, `code1.evaluate() `, `code2 = compile("a * b")`, `code2.evaluate({a: 3, b: 4})`], seealso: [`parser`, `parse`, `evaluate`] }, helpDocs$1 = { name: `help`, category: `Expression`, syntax: [`help(object)`, `help(string)`], description: `Display documentation on a function or data type.`, examples: [`help(sqrt)`, `help("complex")`], seealso: [] }, distanceDocs$1 = { name: `distance`, category: `Geometry`, syntax: [`distance([x1, y1], [x2, y2])`, `distance([[x1, y1], [x2, y2]])`], description: `Calculates the Euclidean distance between two points.`, examples: [`distance([0,0], [4,4])`, `distance([[0,0], [4,4]])`], seealso: [] }, intersectDocs$1 = { name: `intersect`, category: `Geometry`, syntax: [`intersect(expr1, expr2, expr3, expr4)`, `intersect(expr1, expr2, expr3)`], description: `Computes the intersection point of lines and/or planes.`, examples: [`intersect([0, 0], [10, 10], [10, 0], [0, 10])`, `intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])`], seealso: [] }, andDocs$1 = { name: `and`, category: `Logical`, syntax: [`x and y`, `and(x, y)`], description: `Logical and. Test whether two values are both defined with a nonzero/nonempty value.`, examples: [`true and false`, `true and true`, `2 and 4`], seealso: [`not`, `or`, `xor`] }, notDocs$1 = { name: `not`, category: `Logical`, syntax: [`not x`, `not(x)`], description: `Logical not. Flips the boolean value of given argument.`, examples: [`not true`, `not false`, `not 2`, `not 0`], seealso: [`and`, `or`, `xor`] }, nullishDocs$1 = { name: `nullish`, category: `Logical`, syntax: [`x ?? y`, `nullish(x, y)`], description: `Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.`, examples: [`null ?? 42`, `undefined ?? 42`, `0 ?? 42`, `false ?? 42`, `null ?? undefined ?? 42`], seealso: [`and`, `or`, `not`] }, orDocs$1 = { name: `or`, category: `Logical`, syntax: [`x or y`, `or(x, y)`], description: `Logical or. Test if at least one value is defined with a nonzero/nonempty value.`, examples: [`true or false`, `false or false`, `0 or 4`], seealso: [`not`, `and`, `xor`] }, xorDocs$1 = { name: `xor`, category: `Logical`, syntax: [`x xor y`, `xor(x, y)`], description: `Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.`, examples: [`true xor false`, `false xor false`, `true xor true`, `0 xor 4`], seealso: [`not`, `and`, `or`] }, mapSlicesDocs$1 = { name: `mapSlices`, category: `Matrix`, syntax: [`mapSlices(A, dim, callback)`], description: `Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.`, examples: [`A = [[1, 2], [3, 4]]`, `mapSlices(A, 1, sum)`, `mapSlices(A, 2, prod)`], seealso: [`map`, `forEach`] }, columnDocs$1 = { name: `column`, category: `Matrix`, syntax: [`column(x, index)`], description: `Return a column from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `column(A, 1)`, `column(A, 2)`], seealso: [`row`, `matrixFromColumns`] }, concatDocs$1 = { name: `concat`, category: `Matrix`, syntax: [`concat(A, B, C, ...)`, `concat(A, B, C, ..., dim)`], description: `Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.`, examples: [`A = [1, 2; 5, 6]`, `B = [3, 4; 7, 8]`, `concat(A, B)`, `concat(A, B, 1)`, `concat(A, B, 2)`], seealso: [`det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, countDocs$1 = { name: `count`, category: `Matrix`, syntax: [`count(x)`], description: `Count the number of elements of a matrix, array or string.`, examples: [`a = [1, 2; 3, 4; 5, 6]`, `count(a)`, `size(a)`, `count("hello world")`], seealso: [`size`] }, crossDocs$1 = { name: `cross`, category: `Matrix`, syntax: [`cross(A, B)`], description: `Calculate the cross product for two vectors in three dimensional space.`, examples: [`cross([1, 1, 0],  [0, 1, 1])`, `cross([3, -3, 1], [4, 9, 2])`, `cross([2, 3, 4],  [5, 6, 7])`], seealso: [`multiply`, `dot`] }, ctransposeDocs$1 = { name: `ctranspose`, category: `Matrix`, syntax: [`x'`, `ctranspose(x)`], description: `Complex Conjugate and Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `ctranspose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, detDocs$1 = { name: `det`, category: `Matrix`, syntax: [`det(x)`], description: `Calculate the determinant of a matrix`, examples: [`det([1, 2; 3, 4])`, `det([-2, 2, 3; -1, 1, 3; 2, 0, -1])`], seealso: [`concat`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diagDocs$1 = { name: `diag`, category: `Matrix`, syntax: [`diag(x)`, `diag(x, k)`], description: `Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.`, examples: [`diag(1:3)`, `diag(1:3, 1)`, `a = [1, 2, 3; 4, 5, 6; 7, 8, 9]`, `diag(a)`], seealso: [`concat`, `det`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diffDocs$1 = { name: `diff`, category: `Matrix`, syntax: [`diff(arr)`, `diff(arr, dim)`], description: [`Create a new matrix or array with the difference of the passed matrix or array.`, `Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference`, `If no dimension parameter is passed it is assumed as dimension 0`, `Dimension is zero-based in javascript and one-based in the parser`, `Arrays must be 'rectangular' meaning arrays like [1, 2]`, `If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays`], examples: [`A = [1, 2, 4, 7, 0]`, `diff(A)`, `diff(A, 1)`, `B = [[1, 2], [3, 4]]`, `diff(B)`, `diff(B, 1)`, `diff(B, 2)`, `diff(B, bignumber(2))`, `diff([[1, 2], matrix([3, 4])], 2)`], seealso: [`subtract`, `partitionSelect`] }, dotDocs$1 = { name: `dot`, category: `Matrix`, syntax: [`dot(A, B)`, `A * B`], description: `Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn`, examples: [`dot([2, 4, 1], [2, 2, 3])`, `[2, 4, 1] * [2, 2, 3]`], seealso: [`multiply`, `cross`] }, eigsDocs$1 = { name: `eigs`, category: `Matrix`, syntax: [`eigs(x)`], description: `Calculate the eigenvalues and optionally eigenvectors of a square matrix`, examples: [`eigs([[5, 2.3], [2.3, 1]])`, `eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })`], seealso: [`inv`] }, filterDocs$1 = { name: `filter`, category: `Matrix`, syntax: [`filter(x, test)`], description: `Filter items in a matrix.`, examples: [`isPositive(x) = x > 0`, `filter([6, -2, -1, 4, 3], isPositive)`, `filter([6, -2, 0, 1, 0], x != 0)`], seealso: [`sort`, `map`, `forEach`] }, flattenDocs$1 = { name: `flatten`, category: `Matrix`, syntax: [`flatten(x)`], description: `Flatten a multi dimensional matrix into a single dimensional matrix.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `size(a)`, `b = flatten(a)`, `size(b)`], seealso: [`concat`, `resize`, `size`, `squeeze`] }, forEachDocs$1 = { name: `forEach`, category: `Matrix`, syntax: [`forEach(x, callback)`], description: `Iterates over all elements of a matrix/array, and executes the given callback function.`, examples: [`numberOfPets = {}`, `addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;`, `forEach(["Dog","Cat","Cat"], addPet)`, `numberOfPets`], seealso: [`map`, `sort`, `filter`] }, getMatrixDataTypeDocs$1 = { name: `getMatrixDataType`, category: `Matrix`, syntax: [`getMatrixDataType(x)`], description: `Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".`, examples: [`getMatrixDataType([1, 2, 3])`, `getMatrixDataType([[5 cm], [2 inch]])`, `getMatrixDataType([1, "text"])`, `getMatrixDataType([1, bignumber(4)])`], seealso: [`matrix`, `sparse`, `typeOf`] }, identityDocs$1 = { name: `identity`, category: `Matrix`, syntax: [`identity(n)`, `identity(m, n)`, `identity([m, n])`], description: `Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.`, examples: [`identity(3)`, `identity(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `identity(size(a))`], seealso: [`concat`, `det`, `diag`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, invDocs$1 = { name: `inv`, category: `Matrix`, syntax: [`inv(x)`], description: `Calculate the inverse of a matrix`, examples: [`inv([1, 2; 3, 4])`, `inv(4)`, `1 / 4`], seealso: [`concat`, `det`, `diag`, `identity`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, pinvDocs$1 = { name: `pinv`, category: `Matrix`, syntax: [`pinv(x)`], description: `Calculate the Moore–Penrose inverse of a matrix`, examples: [`pinv([1, 2; 3, 4])`, `pinv([[1, 0], [0, 1], [0, 1]])`, `pinv(4)`], seealso: [`inv`] }, kronDocs$1 = { name: `kron`, category: `Matrix`, syntax: [`kron(x, y)`], description: `Calculates the Kronecker product of 2 matrices or vectors.`, examples: [`kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])`, `kron([1,1], [2,3,4])`], seealso: [`multiply`, `dot`, `cross`] }, mapDocs$1 = { name: `map`, category: `Matrix`, syntax: [`map(x, callback)`, `map(x, y, ..., callback)`], description: `Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.`, examples: [`map([1, 2, 3], square)`, `map([1, 2], [3, 4], f(a,b) = a + b)`], seealso: [`filter`, `forEach`] }, matrixFromColumnsDocs$1 = { name: `matrixFromColumns`, category: `Matrix`, syntax: [`matrixFromColumns(...arr)`, `matrixFromColumns(row1, row2)`, `matrixFromColumns(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual columns.`, examples: [`matrixFromColumns([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromRows`, `matrixFromFunction`, `zeros`] }, matrixFromFunctionDocs$1 = { name: `matrixFromFunction`, category: `Matrix`, syntax: [`matrixFromFunction(size, fn)`, `matrixFromFunction(size, fn, format)`, `matrixFromFunction(size, fn, format, datatype)`, `matrixFromFunction(size, format, fn)`, `matrixFromFunction(size, format, datatype, fn)`], description: `Create a matrix by evaluating a generating function at each index.`, examples: [`f(I) = I[1] - I[2]`, `matrixFromFunction([3,3], f)`, `g(I) = I[1] - I[2] == 1 ? 4 : 0`, `matrixFromFunction([100, 100], "sparse", g)`, `matrixFromFunction([5], random)`], seealso: [`matrix`, `matrixFromRows`, `matrixFromColumns`, `zeros`] }, matrixFromRowsDocs$1 = { name: `matrixFromRows`, category: `Matrix`, syntax: [`matrixFromRows(...arr)`, `matrixFromRows(row1, row2)`, `matrixFromRows(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual rows.`, examples: [`matrixFromRows([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromColumns`, `matrixFromFunction`, `zeros`] }, onesDocs$1 = { name: `ones`, category: `Matrix`, syntax: [`ones(m)`, `ones(m, n)`, `ones(m, n, p, ...)`, `ones([m])`, `ones([m, n])`, `ones([m, n, p, ...])`], description: `Create a matrix containing ones.`, examples: [`ones(3)`, `ones(3, 5)`, `ones([2,3]) * 4.5`, `a = [1, 2, 3; 4, 5, 6]`, `ones(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, partitionSelectDocs$1 = { name: `partitionSelect`, category: `Matrix`, syntax: [`partitionSelect(x, k)`, `partitionSelect(x, k, compare)`], description: `Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.`, examples: [`partitionSelect([5, 10, 1], 2)`, `partitionSelect(["C", "B", "A", "D"], 1, compareText)`, `arr = [5, 2, 1]`, `partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]`, `arr`, `partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]`, `arr`], seealso: [`sort`] }, rangeDocs$1 = { name: `range`, category: `Type`, syntax: [`start:end`, `start:step:end`, `range(start, end)`, `range(start, end, step)`, `range(string)`], description: `Create a range. Lower bound of the range is included, upper bound is excluded.`, examples: [`1:5`, `3:-1:-3`, `range(3, 7)`, `range(0, 12, 2)`, `range("4:10")`, `range(1m, 1m, 3m)`, `a = [1, 2, 3, 4; 5, 6, 7, 8]`, `a[1:2, 1:2]`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, reshapeDocs$1 = { name: `reshape`, category: `Matrix`, syntax: [`reshape(x, sizes)`], description: `Reshape a multi dimensional array to fit the specified dimensions.`, examples: [`reshape([1, 2, 3, 4, 5, 6], [2, 3])`, `reshape([[1, 2], [3, 4]], [1, 4])`, `reshape([[1, 2], [3, 4]], [4])`, `reshape([1, 2, 3, 4], [-1, 2])`], seealso: [`size`, `squeeze`, `resize`] }, resizeDocs$1 = { name: `resize`, category: `Matrix`, syntax: [`resize(x, size)`, `resize(x, size, defaultValue)`], description: `Resize a matrix.`, examples: [`resize([1,2,3,4,5], [3])`, `resize([1,2,3], [5])`, `resize([1,2,3], [5], -1)`, `resize(2, [2, 3])`, `resize("hello", [8], "!")`], seealso: [`size`, `subset`, `squeeze`, `reshape`] }, rotateDocs$1 = { name: `rotate`, category: `Matrix`, syntax: [`rotate(w, theta)`, `rotate(w, theta, v)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotate([1, 0], pi / 2)`, `rotate(matrix([1, 0]), unit("35deg"))`, `rotate([1, 0, 0], unit("90deg"), [0, 0, 1])`, `rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))`], seealso: [`matrix`, `rotationMatrix`] }, rotationMatrixDocs$1 = { name: `rotationMatrix`, category: `Matrix`, syntax: [`rotationMatrix(theta)`, `rotationMatrix(theta, v)`, `rotationMatrix(theta, v, format)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotationMatrix(pi / 2)`, `rotationMatrix(unit("45deg"), [0, 0, 1])`, `rotationMatrix(1, matrix([0, 0, 1]), "sparse")`], seealso: [`cos`, `sin`] }, rowDocs$1 = { name: `row`, category: `Matrix`, syntax: [`row(x, index)`], description: `Return a row from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `row(A, 1)`, `row(A, 2)`], seealso: [`column`, `matrixFromRows`] }, sizeDocs$1 = { name: `size`, category: `Matrix`, syntax: [`size(x)`], description: `Calculate the size of a matrix.`, examples: [`size(2.3)`, `size("hello world")`, `a = [1, 2; 3, 4; 5, 6]`, `size(a)`, `size(1:6)`], seealso: [`concat`, `count`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, sortDocs$1 = { name: `sort`, category: `Matrix`, syntax: [`sort(x)`, `sort(x, compare)`], description: `Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.`, examples: [`sort([5, 10, 1])`, `sort(["C", "B", "A", "D"], "natural")`, `sortByLength(a, b) = size(a)[1] - size(b)[1]`, `sort(["Langdon", "Tom", "Sara"], sortByLength)`, `sort(["10", "1", "2"], "natural")`], seealso: [`map`, `filter`, `forEach`] }, squeezeDocs$1 = { name: `squeeze`, category: `Matrix`, syntax: [`squeeze(x)`], description: `Remove inner and outer singleton dimensions from a matrix.`, examples: [`a = zeros(3,2,1)`, `size(squeeze(a))`, `b = zeros(1,1,3)`, `size(squeeze(b))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `subset`, `trace`, `transpose`, `zeros`] }, subsetDocs$1 = { name: `subset`, category: `Matrix`, syntax: [`value(index)`, `value(index) = replacement`, `subset(value, [index])`, `subset(value, [index], replacement)`], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: [`d = [1, 2; 3, 4]`, `e = []`, `e[1, 1:2] = [5, 6]`, `e[2, :] = [7, 8]`, `f = d * e`, `f[2, 1]`, `f[:, 1]`, `f[[1,2], [1,3]] = [9, 10; 11, 12]`, `f`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `trace`, `transpose`, `zeros`] }, traceDocs$1 = { name: `trace`, category: `Matrix`, syntax: [`trace(A)`], description: `Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.`, examples: [`A = [1, 2, 3; -1, 2, 3; 2, 0, 3]`, `trace(A)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `transpose`, `zeros`] }, transposeDocs$1 = { name: `transpose`, category: `Matrix`, syntax: [`x'`, `transpose(x)`], description: `Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `transpose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, zerosDocs$1 = { name: `zeros`, category: `Matrix`, syntax: [`zeros(m)`, `zeros(m, n)`, `zeros(m, n, p, ...)`, `zeros([m])`, `zeros([m, n])`, `zeros([m, n, p, ...])`], description: `Create a matrix containing zeros.`, examples: [`zeros(3)`, `zeros(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `zeros(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`] }, fftDocs$1 = { name: `fft`, category: `Matrix`, syntax: [`fft(x)`], description: `Calculate N-dimensional Fourier transform`, examples: [`fft([[1, 0], [1, 0]])`], seealso: [`ifft`] }, ifftDocs$1 = { name: `ifft`, category: `Matrix`, syntax: [`ifft(x)`], description: `Calculate N-dimensional inverse Fourier transform`, examples: [`ifft([[2, 2], [0, 0]])`], seealso: [`fft`] }, bernoulliDocs$1 = { name: `bernoulli`, category: `Probability`, syntax: [`bernoulli(n)`], description: `The nth Bernoulli number`, examples: [`bernoulli(4)`, `bernoulli(fraction(12))`], seealso: [`combinations`, `gamma`, `stirlingS2`] }, combinationsDocs$1 = { name: `combinations`, category: `Probability`, syntax: [`combinations(n, k)`], description: `Compute the number of combinations of n items taken k at a time`, examples: [`combinations(7, 5)`], seealso: [`combinationsWithRep`, `permutations`, `factorial`] }, combinationsWithRepDocs$1 = { name: `combinationsWithRep`, category: `Probability`, syntax: [`combinationsWithRep(n, k)`], description: `Compute the number of combinations of n items taken k at a time with replacements.`, examples: [`combinationsWithRep(7, 5)`], seealso: [`combinations`, `permutations`, `factorial`] }, factorialDocs$1 = { name: `factorial`, category: `Probability`, syntax: [`n!`, `factorial(n)`], description: `Compute the factorial of a value`, examples: [`5!`, `5 * 4 * 3 * 2 * 1`, `3!`], seealso: [`combinations`, `combinationsWithRep`, `permutations`, `gamma`] }, gammaDocs$1 = { name: `gamma`, category: `Probability`, syntax: [`gamma(n)`], description: `Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.`, examples: [`gamma(4)`, `3!`, `gamma(1/2)`, `sqrt(pi)`], seealso: [`factorial`] }, lgammaDocs$1 = { name: `lgamma`, category: `Probability`, syntax: [`lgamma(n)`], description: `Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.`, examples: [`lgamma(4)`, `lgamma(1/2)`, `lgamma(i)`, `lgamma(complex(1.1, 2))`], seealso: [`gamma`] }, kldivergenceDocs$1 = { name: `kldivergence`, category: `Probability`, syntax: [`kldivergence(x, y)`], description: `Calculate the Kullback-Leibler (KL) divergence  between two distributions.`, examples: [`kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])`], seealso: [] }, multinomialDocs$1 = { name: `multinomial`, category: `Probability`, syntax: [`multinomial(A)`], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: [`multinomial([1, 2, 1])`], seealso: [`combinations`, `factorial`] }, permutationsDocs$1 = { name: `permutations`, category: `Probability`, syntax: [`permutations(n)`, `permutations(n, k)`], description: `Compute the number of permutations of n items taken k at a time`, examples: [`permutations(5)`, `permutations(5, 3)`], seealso: [`combinations`, `combinationsWithRep`, `factorial`] }, pickRandomDocs$1 = { name: `pickRandom`, category: `Probability`, syntax: [`pickRandom(array)`, `pickRandom(array, number)`, `pickRandom(array, weights)`, `pickRandom(array, number, weights)`, `pickRandom(array, weights, number)`], description: `Pick a random entry from a given array.`, examples: [`pickRandom(0:10)`, `pickRandom([1, 3, 1, 6])`, `pickRandom([1, 3, 1, 6], 2)`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)`], seealso: [`random`, `randomInt`] }, randomDocs$1 = { name: `random`, category: `Probability`, syntax: [`random()`, `random(max)`, `random(min, max)`, `random(size)`, `random(size, max)`, `random(size, min, max)`], description: `Return a random number.`, examples: [`random()`, `random(10, 20)`, `random([2, 3])`], seealso: [`pickRandom`, `randomInt`] }, randomIntDocs$1 = { name: `randomInt`, category: `Probability`, syntax: [`randomInt(max)`, `randomInt(min, max)`, `randomInt(size)`, `randomInt(size, max)`, `randomInt(size, min, max)`], description: `Return a random integer number`, examples: [`randomInt(10, 20)`, `randomInt([2, 3], 10)`], seealso: [`pickRandom`, `random`] }, compareDocs$1 = { name: `compare`, category: `Relational`, syntax: [`compare(x, y)`], description: `Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compare(2, 3)`, `compare(3, 2)`, `compare(2, 2)`, `compare(5cm, 40mm)`, `compare(2, [1, 2, 3])`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compareNatural`, `compareText`] }, compareNaturalDocs$1 = { name: `compareNatural`, category: `Relational`, syntax: [`compareNatural(x, y)`], description: `Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareNatural(2, 3)`, `compareNatural(3, 2)`, `compareNatural(2, 2)`, `compareNatural(5cm, 40mm)`, `compareNatural("2", "10")`, `compareNatural(2 + 3i, 2 + 4i)`, `compareNatural([1, 2, 4], [1, 2, 3])`, `compareNatural([1, 5], [1, 2, 3])`, `compareNatural([1, 2], [1, 2])`, `compareNatural({a: 2}, {a: 4})`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`, `compareText`] }, compareTextDocs$1 = { name: `compareText`, category: `Relational`, syntax: [`compareText(x, y)`], description: `Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareText("B", "A")`, `compareText("A", "B")`, `compareText("A", "A")`, `compareText("2", "10")`, `compare("2", "10")`, `compare(2, 10)`, `compareNatural("2", "10")`, `compareText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`] }, deepEqualDocs$1 = { name: `deepEqual`, category: `Relational`, syntax: [`deepEqual(x, y)`], description: `Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.`, examples: [`deepEqual([1,3,4], [1,3,4])`, `deepEqual([1,3,4], [1,3])`], seealso: [`equal`, `unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`] }, equalDocs$1 = { name: `equal`, category: `Relational`, syntax: [`x == y`, `equal(x, y)`], description: `Check equality of two values. Returns true if the values are equal, and false if not.`, examples: [`2+2 == 3`, `2+2 == 4`, `a = 3.2`, `b = 6-2.8`, `a == b`, `50cm == 0.5m`], seealso: [`unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`, `equalText`] }, equalTextDocs$1 = { name: `equalText`, category: `Relational`, syntax: [`equalText(x, y)`], description: `Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.`, examples: [`equalText("Hello", "Hello")`, `equalText("a", "A")`, `equal("2e3", "2000")`, `equalText("2e3", "2000")`, `equalText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`, `compareText`, `equal`] }, largerDocs$1 = { name: `larger`, category: `Relational`, syntax: [`x > y`, `larger(x, y)`], description: `Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 > 3`, `5 > 2*2`, `a = 3.3`, `b = 6-2.8`, `(a > b)`, `(b < a)`, `5 cm > 2 inch`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`] }, largerEqDocs$1 = { name: `largerEq`, category: `Relational`, syntax: [`x >= y`, `largerEq(x, y)`], description: `Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.`, examples: [`2 >= 1+1`, `2 > 1+1`, `a = 3.2`, `b = 6-2.8`, `(a >= b)`], seealso: [`equal`, `unequal`, `smallerEq`, `smaller`, `compare`] }, smallerDocs$1 = { name: `smaller`, category: `Relational`, syntax: [`x < y`, `smaller(x, y)`], description: `Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 < 3`, `5 < 2*2`, `a = 3.3`, `b = 6-2.8`, `(a < b)`, `5 cm < 2 inch`], seealso: [`equal`, `unequal`, `larger`, `smallerEq`, `largerEq`, `compare`] }, smallerEqDocs$1 = { name: `smallerEq`, category: `Relational`, syntax: [`x <= y`, `smallerEq(x, y)`], description: `Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.`, examples: [`2 <= 1+1`, `2 < 1+1`, `a = 3.2`, `b = 6-2.8`, `(a <= b)`], seealso: [`equal`, `unequal`, `larger`, `smaller`, `largerEq`, `compare`] }, unequalDocs$1 = { name: `unequal`, category: `Relational`, syntax: [`x != y`, `unequal(x, y)`], description: `Check unequality of two values. Returns true if the values are unequal, and false if they are equal.`, examples: [`2+2 != 3`, `2+2 != 4`, `a = 3.2`, `b = 6-2.8`, `a != b`, `50cm != 0.5m`, `5 cm != 2 inch`], seealso: [`equal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`] }, setCartesianDocs$1 = { name: `setCartesian`, category: `Set`, syntax: [`setCartesian(set1, set2)`], description: `Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.`, examples: [`setCartesian([1, 2], [3, 4])`], seealso: [`setUnion`, `setIntersect`, `setDifference`, `setPowerset`] }, setDifferenceDocs$1 = { name: `setDifference`, category: `Set`, syntax: [`setDifference(set1, set2)`], description: `Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setSymDifference`] }, setDistinctDocs$1 = { name: `setDistinct`, category: `Set`, syntax: [`setDistinct(set)`], description: `Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setDistinct([1, 1, 1, 2, 2, 3])`], seealso: [`setMultiplicity`] }, setIntersectDocs$1 = { name: `setIntersect`, category: `Set`, syntax: [`setIntersect(set1, set2)`], description: `Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIntersect([1, 2, 3, 4], [3, 4, 5, 6])`, `setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setDifference`] }, setIsSubsetDocs$1 = { name: `setIsSubset`, category: `Set`, syntax: [`setIsSubset(set1, set2)`], description: `Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIsSubset([1, 2], [3, 4, 5, 6])`, `setIsSubset([3, 4], [3, 4, 5, 6])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setMultiplicityDocs$1 = { name: `setMultiplicity`, category: `Set`, syntax: [`setMultiplicity(element, set)`], description: `Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setMultiplicity(1, [1, 2, 2, 4])`, `setMultiplicity(2, [1, 2, 2, 4])`], seealso: [`setDistinct`, `setSize`] }, setPowersetDocs$1 = { name: `setPowerset`, category: `Set`, syntax: [`setPowerset(set)`], description: `Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setPowerset([1, 2, 3])`], seealso: [`setCartesian`] }, setSizeDocs$1 = { name: `setSize`, category: `Set`, syntax: [`setSize(set)`, `setSize(set, unique)`], description: `Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setSize([1, 2, 2, 4])`, `setSize([1, 2, 2, 4], true)`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setSymDifferenceDocs$1 = { name: `setSymDifference`, category: `Set`, syntax: [`setSymDifference(set1, set2)`], description: `Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setUnionDocs$1 = { name: `setUnion`, category: `Set`, syntax: [`setUnion(set1, set2)`], description: `Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setUnion([1, 2, 3, 4], [3, 4, 5, 6])`, `setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setIntersect`, `setDifference`] }, zpk2tfDocs$1 = { name: `zpk2tf`, category: `Signal`, syntax: [`zpk2tf(z, p, k)`], description: `Compute the transfer function of a zero-pole-gain model.`, examples: [`zpk2tf([1, 2], [-1, -2], 1)`, `zpk2tf([1, 2], [-1, -2])`, `zpk2tf([1 - 3i, 2 + 2i], [-1, -2])`], seealso: [] }, freqzDocs$1 = { name: `freqz`, category: `Signal`, syntax: [`freqz(b, a)`, `freqz(b, a, w)`], description: `Calculates the frequency response of a filter given its numerator and denominator coefficients.`, examples: [`freqz([1, 2], [1, 2, 3])`, `freqz([1, 2], [1, 2, 3], [0, 1])`, `freqz([1, 2], [1, 2, 3], 512)`], seealso: [] }, erfDocs$1 = { name: `erf`, category: `Special`, syntax: [`erf(x)`], description: `Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x`, examples: [`erf(0.2)`, `erf(-0.5)`, `erf(4)`], seealso: [] }, zetaDocs$1 = { name: `zeta`, category: `Special`, syntax: [`zeta(s)`], description: `Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane`, examples: [`zeta(0.2)`, `zeta(-0.5)`, `zeta(4)`], seealso: [] }, madDocs$1 = { name: `mad`, category: `Statistics`, syntax: [`mad(a, b, c, ...)`, `mad(A)`], description: `Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.`, examples: [`mad(10, 20, 30)`, `mad([1, 2, 3])`], seealso: [`mean`, `median`, `std`, `abs`] }, maxDocs$1 = { name: `max`, category: `Statistics`, syntax: [`max(a, b, c, ...)`, `max(A)`, `max(A, dimension)`], description: `Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`max(2, 3, 4, 1)`, `max([2, 3, 4, 1])`, `max([2, 5; 4, 3])`, `max([2, 5; 4, 3], 1)`, `max([2, 5; 4, 3], 2)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, meanDocs$1 = { name: `mean`, category: `Statistics`, syntax: [`mean(a, b, c, ...)`, `mean(A)`, `mean(A, dimension)`], description: `Compute the arithmetic mean of a list of values.`, examples: [`mean(2, 3, 4, 1)`, `mean([2, 3, 4, 1])`, `mean([2, 5; 4, 3])`, `mean([2, 5; 4, 3], 1)`, `mean([2, 5; 4, 3], 2)`, `mean([1.0, 2.7, 3.2, 4.0])`], seealso: [`max`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, medianDocs$1 = { name: `median`, category: `Statistics`, syntax: [`median(a, b, c, ...)`, `median(A)`], description: `Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.`, examples: [`median(5, 2, 7)`, `median([3, -1, 5, 7])`], seealso: [`max`, `mean`, `min`, `prod`, `std`, `sum`, `variance`, `quantileSeq`] }, minDocs$1 = { name: `min`, category: `Statistics`, syntax: [`min(a, b, c, ...)`, `min(A)`, `min(A, dimension)`], description: `Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`min(2, 3, 4, 1)`, `min([2, 3, 4, 1])`, `min([2, 5; 4, 3])`, `min([2, 5; 4, 3], 1)`, `min([2, 5; 4, 3], 2)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`max`, `mean`, `median`, `prod`, `std`, `sum`, `variance`] }, modeDocs$1 = { name: `mode`, category: `Statistics`, syntax: [`mode(a, b, c, ...)`, `mode(A)`, `mode(A, a, b, B, c, ...)`], description: `Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.`, examples: [`mode(2, 1, 4, 3, 1)`, `mode([1, 2.7, 3.2, 4, 2.7])`, `mode(1, 4, 6, 1, 6)`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `std`, `sum`, `variance`] }, prodDocs$1 = { name: `prod`, category: `Statistics`, syntax: [`prod(a, b, c, ...)`, `prod(A)`], description: `Compute the product of all values.`, examples: [`prod(2, 3, 4)`, `prod([2, 3, 4])`, `prod([2, 5; 4, 3])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `std`, `sum`, `variance`] }, quantileSeqDocs$1 = { name: `quantileSeq`, category: `Statistics`, syntax: [`quantileSeq(A, prob[, sorted])`, `quantileSeq(A, [prob1, prob2, ...][, sorted])`, `quantileSeq(A, N[, sorted])`], description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`, examples: [`quantileSeq([3, -1, 5, 7], 0.5)`, `quantileSeq([3, -1, 5, 7], [1/3, 2/3])`, `quantileSeq([3, -1, 5, 7], 2)`, `quantileSeq([-1, 3, 5, 7], 0.5, true)`], seealso: [`mean`, `median`, `min`, `max`, `prod`, `std`, `sum`, `variance`] }, stdDocs$1 = { name: `std`, category: `Statistics`, syntax: [`std(a, b, c, ...)`, `std(A)`, `std(A, dimension)`, `std(A, normalization)`, `std(A, dimension, normalization)`], description: `Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`std(2, 4, 6)`, `std([2, 4, 6, 8])`, `std([2, 4, 6, 8], "uncorrected")`, `std([2, 4, 6, 8], "biased")`, `std([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `sum`, `variance`] }, cumSumDocs$1 = { name: `cumsum`, category: `Statistics`, syntax: [`cumsum(a, b, c, ...)`, `cumsum(A)`], description: `Compute the cumulative sum of all values.`, examples: [`cumsum(2, 3, 4, 1)`, `cumsum([2, 3, 4, 1])`, `cumsum([1, 2; 3, 4])`, `cumsum([1, 2; 3, 4], 1)`, `cumsum([1, 2; 3, 4], 2)`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, sumDocs$1 = { name: `sum`, category: `Statistics`, syntax: [`sum(a, b, c, ...)`, `sum(A)`, `sum(A, dimension)`], description: `Compute the sum of all values.`, examples: [`sum(2, 3, 4, 1)`, `sum([2, 3, 4, 1])`, `sum([2, 5; 4, 3])`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `variance`] }, varianceDocs$1 = { name: `variance`, category: `Statistics`, syntax: [`variance(a, b, c, ...)`, `variance(A)`, `variance(A, dimension)`, `variance(A, normalization)`, `variance(A, dimension, normalization)`], description: `Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`variance(2, 4, 6)`, `variance([2, 4, 6, 8])`, `variance([2, 4, 6, 8], "uncorrected")`, `variance([2, 4, 6, 8], "biased")`, `variance([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, corrDocs$1 = { name: `corr`, category: `Statistics`, syntax: [`corr(A,B)`], description: `Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.`, examples: [`corr([2, 4, 6, 8],[1, 2, 3, 6])`, `corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, acosDocs$1 = { name: `acos`, category: `Trigonometry`, syntax: [`acos(x)`], description: `Compute the inverse cosine of a value in radians.`, examples: [`acos(0.5)`, `acos(cos(2.3))`], seealso: [`cos`, `atan`, `asin`] }, acoshDocs$1 = { name: `acosh`, category: `Trigonometry`, syntax: [`acosh(x)`], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: [`acosh(1.5)`], seealso: [`cosh`, `asinh`, `atanh`] }, acotDocs$1 = { name: `acot`, category: `Trigonometry`, syntax: [`acot(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acot(0.5)`, `acot(cot(0.5))`, `acot(2)`], seealso: [`cot`, `atan`] }, acothDocs$1 = { name: `acoth`, category: `Trigonometry`, syntax: [`acoth(x)`], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: [`acoth(2)`, `acoth(0.5)`], seealso: [`acsch`, `asech`] }, acscDocs$1 = { name: `acsc`, category: `Trigonometry`, syntax: [`acsc(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acsc(2)`, `acsc(csc(0.5))`, `acsc(0.5)`], seealso: [`csc`, `asin`, `asec`] }, acschDocs$1 = { name: `acsch`, category: `Trigonometry`, syntax: [`acsch(x)`], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: [`acsch(0.5)`], seealso: [`asech`, `acoth`] }, asecDocs$1 = { name: `asec`, category: `Trigonometry`, syntax: [`asec(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asec(0.5)`, `asec(sec(0.5))`, `asec(2)`], seealso: [`acos`, `acot`, `acsc`] }, asechDocs$1 = { name: `asech`, category: `Trigonometry`, syntax: [`asech(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asech(0.5)`], seealso: [`acsch`, `acoth`] }, asinDocs$1 = { name: `asin`, category: `Trigonometry`, syntax: [`asin(x)`], description: `Compute the inverse sine of a value in radians.`, examples: [`asin(0.5)`, `asin(sin(0.5))`], seealso: [`sin`, `acos`, `atan`] }, asinhDocs$1 = { name: `asinh`, category: `Trigonometry`, syntax: [`asinh(x)`], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: [`asinh(0.5)`], seealso: [`acosh`, `atanh`] }, atanDocs$1 = { name: `atan`, category: `Trigonometry`, syntax: [`atan(x)`], description: `Compute the inverse tangent of a value in radians.`, examples: [`atan(0.5)`, `atan(tan(0.5))`], seealso: [`tan`, `acos`, `asin`] }, atan2Docs$1 = { name: `atan2`, category: `Trigonometry`, syntax: [`atan2(y, x)`], description: `Computes the principal value of the arc tangent of y/x in radians.`, examples: [`atan2(2, 2) / pi`, `angle = 60 deg in rad`, `x = cos(angle)`, `y = sin(angle)`, `atan2(y, x)`], seealso: [`sin`, `cos`, `tan`] }, atanhDocs$1 = { name: `atanh`, category: `Trigonometry`, syntax: [`atanh(x)`], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: [`atanh(0.5)`], seealso: [`acosh`, `asinh`] }, cosDocs$1 = { name: `cos`, category: `Trigonometry`, syntax: [`cos(x)`], description: `Compute the cosine of x in radians.`, examples: [`cos(2)`, `cos(pi / 4) ^ 2`, `cos(180 deg)`, `cos(60 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`acos`, `sin`, `tan`] }, coshDocs$1 = { name: `cosh`, category: `Trigonometry`, syntax: [`cosh(x)`], description: `Compute the hyperbolic cosine of x in radians.`, examples: [`cosh(0.5)`], seealso: [`sinh`, `tanh`, `coth`] }, cotDocs$1 = { name: `cot`, category: `Trigonometry`, syntax: [`cot(x)`], description: `Compute the cotangent of x in radians. Defined as 1/tan(x)`, examples: [`cot(2)`, `1 / tan(2)`], seealso: [`sec`, `csc`, `tan`] }, cothDocs$1 = { name: `coth`, category: `Trigonometry`, syntax: [`coth(x)`], description: `Compute the hyperbolic cotangent of x in radians.`, examples: [`coth(2)`, `1 / tanh(2)`], seealso: [`sech`, `csch`, `tanh`] }, cscDocs$1 = { name: `csc`, category: `Trigonometry`, syntax: [`csc(x)`], description: `Compute the cosecant of x in radians. Defined as 1/sin(x)`, examples: [`csc(2)`, `1 / sin(2)`], seealso: [`sec`, `cot`, `sin`] }, cschDocs$1 = { name: `csch`, category: `Trigonometry`, syntax: [`csch(x)`], description: `Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)`, examples: [`csch(2)`, `1 / sinh(2)`], seealso: [`sech`, `coth`, `sinh`] }, secDocs$1 = { name: `sec`, category: `Trigonometry`, syntax: [`sec(x)`], description: `Compute the secant of x in radians. Defined as 1/cos(x)`, examples: [`sec(2)`, `1 / cos(2)`], seealso: [`cot`, `csc`, `cos`] }, sechDocs$1 = { name: `sech`, category: `Trigonometry`, syntax: [`sech(x)`], description: `Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)`, examples: [`sech(2)`, `1 / cosh(2)`], seealso: [`coth`, `csch`, `cosh`] }, sinDocs$1 = { name: `sin`, category: `Trigonometry`, syntax: [`sin(x)`], description: `Compute the sine of x in radians.`, examples: [`sin(2)`, `sin(pi / 4) ^ 2`, `sin(90 deg)`, `sin(30 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`asin`, `cos`, `tan`] }, sinhDocs$1 = { name: `sinh`, category: `Trigonometry`, syntax: [`sinh(x)`], description: `Compute the hyperbolic sine of x in radians.`, examples: [`sinh(0.5)`], seealso: [`cosh`, `tanh`] }, tanDocs$1 = { name: `tan`, category: `Trigonometry`, syntax: [`tan(x)`], description: `Compute the tangent of x in radians.`, examples: [`tan(0.5)`, `sin(0.5) / cos(0.5)`, `tan(pi / 4)`, `tan(45 deg)`], seealso: [`atan`, `sin`, `cos`] }, tanhDocs$1 = { name: `tanh`, category: `Trigonometry`, syntax: [`tanh(x)`], description: `Compute the hyperbolic tangent of x in radians.`, examples: [`tanh(0.5)`, `sinh(0.5) / cosh(0.5)`], seealso: [`sinh`, `cosh`] }, toDocs$1 = { name: `to`, category: `Units`, syntax: [`x to unit`, `to(x, unit)`], description: `Change the unit of a value.`, examples: [`5 inch to cm`, `3.2kg to g`, `16 bytes in bits`], seealso: [] }, toBestDocs$1 = { name: `toBest`, category: `Units`, syntax: [`toBest(x)`, `toBest(x, unitList)`, `toBest(x, unitList, options)`], description: `Converts to the most appropriate display unit.`, examples: [`toBest(unit(5000, "m"))`, `toBest(unit(3500000, "W"))`, `toBest(unit(0.000000123, "A"))`, `toBest(unit(10, "m"), "cm")`, `toBest(unit(10, "m"), "mm,km", {offset: 1.5})`], seealso: [] }, binDocs$1 = { name: `bin`, category: `Utils`, syntax: [`bin(value)`], description: `Format a number as binary`, examples: [`bin(2)`], seealso: [`oct`, `hex`] }, cloneDocs$1 = { name: `clone`, category: `Utils`, syntax: [`clone(x)`], description: `Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices`, examples: [`clone(3.5)`, `clone(2 - 4i)`, `clone(45 deg)`, `clone([1, 2; 3, 4])`, `clone("hello world")`], seealso: [] }, formatDocs$1 = { name: `format`, category: `Utils`, syntax: [`format(value)`, `format(value, precision)`], description: `Format a value of any type as string.`, examples: [`format(2.3)`, `format(3 - 4i)`, `format([])`, `format(pi, 3)`], seealso: [`print`] }, hasNumericValueDocs$1 = { name: `hasNumericValue`, category: `Utils`, syntax: [`hasNumericValue(x)`], description: `Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.`, examples: [`hasNumericValue(2)`, `hasNumericValue("2")`, `isNumeric("2")`, `hasNumericValue(0)`, `hasNumericValue(bignumber(500))`, `hasNumericValue(fraction(0.125))`, `hasNumericValue(2 + 3i)`, `hasNumericValue([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `isNumeric`] }, hexDocs$1 = { name: `hex`, category: `Utils`, syntax: [`hex(value)`], description: `Format a number as hexadecimal`, examples: [`hex(240)`], seealso: [`bin`, `oct`] }, isIntegerDocs$1 = { name: `isInteger`, category: `Utils`, syntax: [`isInteger(x)`], description: `Test whether a value is an integer number.`, examples: [`isInteger(2)`, `isInteger(3.5)`, `isInteger([3, 0.5, -2])`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`] }, isNaNDocs$1 = { name: `isNaN`, category: `Utils`, syntax: [`isNaN(x)`], description: `Test whether a value is NaN (not a number)`, examples: [`isNaN(2)`, `isNaN(0 / 0)`, `isNaN(NaN)`, `isNaN(Infinity)`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`, `isFinite`, `isBounded`] }, isBoundedDocs$1 = { name: `isBounded`, category: `Utils`, syntax: [`isBounded(x)`], description: `Test whether a value or its entries are bounded.`, examples: [`isBounded(Infinity)`, `isBounded(bigint(3))`, `isBounded([3, -Infinity, -3])`], seealso: [`isFinite`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isFiniteDocs$1 = { name: `isFinite`, category: `Utils`, syntax: [`isFinite(x)`], description: `Test whether a value is finite, elementwise on collections.`, examples: [`isFinite(Infinity)`, `isFinite(bigint(3))`, `isFinite([3, -Infinity, -3])`], seealso: [`isBounded`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isNegativeDocs$1 = { name: `isNegative`, category: `Utils`, syntax: [`isNegative(x)`], description: `Test whether a value is negative: smaller than zero.`, examples: [`isNegative(2)`, `isNegative(0)`, `isNegative(-4)`, `isNegative([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isPositive`, `isZero`] }, isNumericDocs$1 = { name: `isNumeric`, category: `Utils`, syntax: [`isNumeric(x)`], description: `Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.`, examples: [`isNumeric(2)`, `isNumeric("2")`, `hasNumericValue("2")`, `isNumeric(0)`, `isNumeric(bignumber(500))`, `isNumeric(fraction(0.125))`, `isNumeric(2 + 3i)`, `isNumeric([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `hasNumericValue`, `isFinite`, `isBounded`] }, isPositiveDocs$1 = { name: `isPositive`, category: `Utils`, syntax: [`isPositive(x)`], description: `Test whether a value is positive: larger than zero.`, examples: [`isPositive(2)`, `isPositive(0)`, `isPositive(-4)`, `isPositive([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isPrimeDocs$1 = { name: `isPrime`, category: `Utils`, syntax: [`isPrime(x)`], description: `Test whether a value is prime: has no divisors other than itself and one.`, examples: [`isPrime(3)`, `isPrime(-2)`, `isPrime([2, 17, 100])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isZeroDocs$1 = { name: `isZero`, category: `Utils`, syntax: [`isZero(x)`], description: `Test whether a value is zero.`, examples: [`isZero(2)`, `isZero(0)`, `isZero(-4)`, `isZero([3, 0, -2, 0])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isPositive`] }, numericDocs$1 = { name: `numeric`, category: `Utils`, syntax: [`numeric(x)`], description: `Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.`, examples: [`numeric("4")`, `numeric("4", "number")`, `numeric("4", "bigint")`, `numeric("4", "BigNumber")`, `numeric("4", "Fraction")`, `numeric(4, "Fraction")`, `numeric(fraction(2, 5), "number")`], seealso: [`number`, `bigint`, `fraction`, `bignumber`, `string`, `format`] }, octDocs$1 = { name: `oct`, category: `Utils`, syntax: [`oct(value)`], description: `Format a number as octal`, examples: [`oct(56)`], seealso: [`bin`, `hex`] }, printDocs$1 = { name: `print`, category: `Utils`, syntax: [`print(template, values)`, `print(template, values, precision)`], description: `Interpolate values into a string template.`, examples: [`print("Lucy is $age years old", {age: 5})`, `print("The value of pi is $pi", {pi: pi}, 3)`, `print("Hello, $user.name!", {user: {name: "John"}})`, `print("Values: $1, $2, $3", [6, 9, 4])`], seealso: [`format`] }, typeOfDocs$1 = { name: `typeOf`, category: `Utils`, syntax: [`typeOf(x)`], description: `Get the type of a variable.`, examples: [`typeOf(3.5)`, `typeOf(2 - 4i)`, `typeOf(45 deg)`, `typeOf("hello world")`], seealso: [`getMatrixDataType`] }, solveODEDocs$1 = { name: `solveODE`, category: `Numeric`, syntax: [`solveODE(func, tspan, y0)`, `solveODE(func, tspan, y0, options)`], description: `Numerical Integration of Ordinary Differential Equations.`, examples: [`f(t,y) = y`, `tspan = [0, 4]`, `solveODE(f, tspan, 1)`, `solveODE(f, tspan, [1, 2])`, `solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })`], seealso: [`derivative`, `simplifyCore`] }, embeddedDocs$1 = { bignumber: bignumberDocs$1, bigint: bigintDocs$1, boolean: booleanDocs$1, complex: complexDocs$1, createUnit: createUnitDocs$1, fraction: fractionDocs$1, index: indexDocs$1, matrix: matrixDocs$1, number: numberDocs$1, sparse: sparseDocs$1, splitUnit: splitUnitDocs$1, string: stringDocs$1, unit: unitDocs$1, e: eDocs$1, E: eDocs$1, false: falseDocs$1, i: iDocs$1, Infinity: InfinityDocs$1, LN2: LN2Docs$1, LN10: LN10Docs$1, LOG2E: LOG2EDocs$1, LOG10E: LOG10EDocs$1, NaN: NaNDocs$1, null: nullDocs$1, pi: piDocs$1, PI: piDocs$1, phi: phiDocs$1, SQRT1_2: SQRT12Docs$1, SQRT2: SQRT2Docs$1, tau: tauDocs$1, true: trueDocs$1, version: versionDocs$1, speedOfLight: { description: `Speed of light in vacuum`, examples: [`speedOfLight`] }, gravitationConstant: { description: `Newtonian constant of gravitation`, examples: [`gravitationConstant`] }, planckConstant: { description: `Planck constant`, examples: [`planckConstant`] }, reducedPlanckConstant: { description: `Reduced Planck constant`, examples: [`reducedPlanckConstant`] }, magneticConstant: { description: `Magnetic constant (vacuum permeability)`, examples: [`magneticConstant`] }, electricConstant: { description: `Electric constant (vacuum permeability)`, examples: [`electricConstant`] }, vacuumImpedance: { description: `Characteristic impedance of vacuum`, examples: [`vacuumImpedance`] }, coulomb: { description: `Coulomb's constant. Deprecated in favor of coulombConstant`, examples: [`coulombConstant`] }, coulombConstant: { description: `Coulomb's constant`, examples: [`coulombConstant`] }, elementaryCharge: { description: `Elementary charge`, examples: [`elementaryCharge`] }, bohrMagneton: { description: `Bohr magneton`, examples: [`bohrMagneton`] }, conductanceQuantum: { description: `Conductance quantum`, examples: [`conductanceQuantum`] }, inverseConductanceQuantum: { description: `Inverse conductance quantum`, examples: [`inverseConductanceQuantum`] }, magneticFluxQuantum: { description: `Magnetic flux quantum`, examples: [`magneticFluxQuantum`] }, nuclearMagneton: { description: `Nuclear magneton`, examples: [`nuclearMagneton`] }, klitzing: { description: `Von Klitzing constant`, examples: [`klitzing`] }, bohrRadius: { description: `Bohr radius`, examples: [`bohrRadius`] }, classicalElectronRadius: { description: `Classical electron radius`, examples: [`classicalElectronRadius`] }, electronMass: { description: `Electron mass`, examples: [`electronMass`] }, fermiCoupling: { description: `Fermi coupling constant`, examples: [`fermiCoupling`] }, fineStructure: { description: `Fine-structure constant`, examples: [`fineStructure`] }, hartreeEnergy: { description: `Hartree energy`, examples: [`hartreeEnergy`] }, protonMass: { description: `Proton mass`, examples: [`protonMass`] }, deuteronMass: { description: `Deuteron Mass`, examples: [`deuteronMass`] }, neutronMass: { description: `Neutron mass`, examples: [`neutronMass`] }, quantumOfCirculation: { description: `Quantum of circulation`, examples: [`quantumOfCirculation`] }, rydberg: { description: `Rydberg constant`, examples: [`rydberg`] }, thomsonCrossSection: { description: `Thomson cross section`, examples: [`thomsonCrossSection`] }, weakMixingAngle: { description: `Weak mixing angle`, examples: [`weakMixingAngle`] }, efimovFactor: { description: `Efimov factor`, examples: [`efimovFactor`] }, atomicMass: { description: `Atomic mass constant`, examples: [`atomicMass`] }, avogadro: { description: `Avogadro's number`, examples: [`avogadro`] }, boltzmann: { description: `Boltzmann constant`, examples: [`boltzmann`] }, faraday: { description: `Faraday constant`, examples: [`faraday`] }, firstRadiation: { description: `First radiation constant`, examples: [`firstRadiation`] }, loschmidt: { description: `Loschmidt constant at T=273.15 K and p=101.325 kPa`, examples: [`loschmidt`] }, gasConstant: { description: `Gas constant`, examples: [`gasConstant`] }, molarPlanckConstant: { description: `Molar Planck constant`, examples: [`molarPlanckConstant`] }, molarVolume: { description: `Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa`, examples: [`molarVolume`] }, sackurTetrode: { description: `Sackur-Tetrode constant at T=1 K and p=101.325 kPa`, examples: [`sackurTetrode`] }, secondRadiation: { description: `Second radiation constant`, examples: [`secondRadiation`] }, stefanBoltzmann: { description: `Stefan-Boltzmann constant`, examples: [`stefanBoltzmann`] }, wienDisplacement: { description: `Wien displacement law constant`, examples: [`wienDisplacement`] }, molarMass: { description: `Molar mass constant`, examples: [`molarMass`] }, molarMassC12: { description: `Molar mass constant of carbon-12`, examples: [`molarMassC12`] }, gravity: { description: `Standard acceleration of gravity (standard acceleration of free-fall on Earth)`, examples: [`gravity`] }, planckLength: { description: `Planck length`, examples: [`planckLength`] }, planckMass: { description: `Planck mass`, examples: [`planckMass`] }, planckTime: { description: `Planck time`, examples: [`planckTime`] }, planckCharge: { description: `Planck charge`, examples: [`planckCharge`] }, planckTemperature: { description: `Planck temperature`, examples: [`planckTemperature`] }, derivative: derivativeDocs$1, lsolve: lsolveDocs$1, lsolveAll: lsolveAllDocs$1, lup: lupDocs$1, lusolve: lusolveDocs$1, leafCount: leafCountDocs$1, polynomialRoot: polynomialRootDocs$1, resolve: resolveDocs$1, simplify: simplifyDocs$1, simplifyConstant: simplifyConstantDocs$1, simplifyCore: simplifyCoreDocs$1, symbolicEqual: symbolicEqualDocs$1, rationalize: rationalizeDocs$1, slu: sluDocs$1, usolve: usolveDocs$1, usolveAll: usolveAllDocs$1, qr: qrDocs$1, abs: absDocs$1, add: addDocs$1, cbrt: cbrtDocs$1, ceil: ceilDocs$1, cube: cubeDocs$1, divide: divideDocs$1, dotDivide: dotDivideDocs$1, dotMultiply: dotMultiplyDocs$1, dotPow: dotPowDocs$1, exp: expDocs$1, expm: expmDocs$1, expm1: expm1Docs$1, fix: fixDocs$1, floor: floorDocs$1, gcd: gcdDocs$1, hypot: hypotDocs$1, lcm: lcmDocs$1, log: logDocs$1, log2: log2Docs$1, log1p: log1pDocs$1, log10: log10Docs$1, mod: modDocs$1, multiply: multiplyDocs$1, norm: normDocs$1, nthRoot: nthRootDocs$1, nthRoots: nthRootsDocs$1, pow: powDocs$1, round: roundDocs$1, sign: signDocs$1, sqrt: sqrtDocs$1, sqrtm: sqrtmDocs$1, square: squareDocs$1, subtract: subtractDocs$1, unaryMinus: unaryMinusDocs$1, unaryPlus: unaryPlusDocs$1, xgcd: xgcdDocs$1, invmod: invmodDocs$1, num: numDocs$1, den: denDocs$1, bitAnd: bitAndDocs$1, bitNot: bitNotDocs$1, bitOr: bitOrDocs$1, bitXor: bitXorDocs$1, leftShift: leftShiftDocs$1, rightArithShift: rightArithShiftDocs$1, rightLogShift: rightLogShiftDocs$1, bellNumbers: bellNumbersDocs$1, catalan: catalanDocs$1, composition: compositionDocs$1, stirlingS2: stirlingS2Docs$1, config: configDocs$1, import: importDocs$1, typed: typedDocs$1, arg: argDocs$1, conj: conjDocs$1, re: reDocs$1, im: imDocs$1, evaluate: evaluateDocs$1, help: helpDocs$1, parse: parseDocs$1, parser: parserDocs$1, compile: compileDocs$1, distance: distanceDocs$1, intersect: intersectDocs$1, and: andDocs$1, not: notDocs$1, nullish: nullishDocs$1, or: orDocs$1, xor: xorDocs$1, mapSlices: mapSlicesDocs$1, concat: concatDocs$1, count: countDocs$1, cross: crossDocs$1, column: columnDocs$1, ctranspose: ctransposeDocs$1, det: detDocs$1, diag: diagDocs$1, diff: diffDocs$1, dot: dotDocs$1, getMatrixDataType: getMatrixDataTypeDocs$1, identity: identityDocs$1, filter: filterDocs$1, flatten: flattenDocs$1, forEach: forEachDocs$1, inv: invDocs$1, pinv: pinvDocs$1, eigs: eigsDocs$1, kron: kronDocs$1, matrixFromFunction: matrixFromFunctionDocs$1, matrixFromRows: matrixFromRowsDocs$1, matrixFromColumns: matrixFromColumnsDocs$1, map: mapDocs$1, ones: onesDocs$1, partitionSelect: partitionSelectDocs$1, range: rangeDocs$1, resize: resizeDocs$1, reshape: reshapeDocs$1, rotate: rotateDocs$1, rotationMatrix: rotationMatrixDocs$1, row: rowDocs$1, size: sizeDocs$1, sort: sortDocs$1, squeeze: squeezeDocs$1, subset: subsetDocs$1, trace: traceDocs$1, transpose: transposeDocs$1, zeros: zerosDocs$1, fft: fftDocs$1, ifft: ifftDocs$1, sylvester: sylvesterDocs$1, schur: schurDocs$1, lyap: lyapDocs$1, solveODE: solveODEDocs$1, bernoulli: bernoulliDocs$1, combinations: combinationsDocs$1, combinationsWithRep: combinationsWithRepDocs$1, factorial: factorialDocs$1, gamma: gammaDocs$1, kldivergence: kldivergenceDocs$1, lgamma: lgammaDocs$1, multinomial: multinomialDocs$1, permutations: permutationsDocs$1, pickRandom: pickRandomDocs$1, random: randomDocs$1, randomInt: randomIntDocs$1, compare: compareDocs$1, compareNatural: compareNaturalDocs$1, compareText: compareTextDocs$1, deepEqual: deepEqualDocs$1, equal: equalDocs$1, equalText: equalTextDocs$1, larger: largerDocs$1, largerEq: largerEqDocs$1, smaller: smallerDocs$1, smallerEq: smallerEqDocs$1, unequal: unequalDocs$1, setCartesian: setCartesianDocs$1, setDifference: setDifferenceDocs$1, setDistinct: setDistinctDocs$1, setIntersect: setIntersectDocs$1, setIsSubset: setIsSubsetDocs$1, setMultiplicity: setMultiplicityDocs$1, setPowerset: setPowersetDocs$1, setSize: setSizeDocs$1, setSymDifference: setSymDifferenceDocs$1, setUnion: setUnionDocs$1, zpk2tf: zpk2tfDocs$1, freqz: freqzDocs$1, erf: erfDocs$1, zeta: zetaDocs$1, cumsum: cumSumDocs$1, mad: madDocs$1, max: maxDocs$1, mean: meanDocs$1, median: medianDocs$1, min: minDocs$1, mode: modeDocs$1, prod: prodDocs$1, quantileSeq: quantileSeqDocs$1, std: stdDocs$1, sum: sumDocs$1, variance: varianceDocs$1, corr: corrDocs$1, acos: acosDocs$1, acosh: acoshDocs$1, acot: acotDocs$1, acoth: acothDocs$1, acsc: acscDocs$1, acsch: acschDocs$1, asec: asecDocs$1, asech: asechDocs$1, asin: asinDocs$1, asinh: asinhDocs$1, atan: atanDocs$1, atanh: atanhDocs$1, atan2: atan2Docs$1, cos: cosDocs$1, cosh: coshDocs$1, cot: cotDocs$1, coth: cothDocs$1, csc: cscDocs$1, csch: cschDocs$1, sec: secDocs$1, sech: sechDocs$1, sin: sinDocs$1, sinh: sinhDocs$1, tan: tanDocs$1, tanh: tanhDocs$1, to: toDocs$1, toBest: toBestDocs$1, clone: cloneDocs$1, format: formatDocs$1, bin: binDocs$1, oct: octDocs$1, hex: hexDocs$1, isNaN: isNaNDocs$1, isBounded: isBoundedDocs$1, isFinite: isFiniteDocs$1, isInteger: isIntegerDocs$1, isNegative: isNegativeDocs$1, isNumeric: isNumericDocs$1, hasNumericValue: hasNumericValueDocs$1, isPositive: isPositiveDocs$1, isPrime: isPrimeDocs$1, isZero: isZeroDocs$1, print: printDocs$1, typeOf: typeOfDocs$1, numeric: numericDocs$1 }, name$79$1 = `help`, dependencies$79$1 = [`typed`, `mathWithTransform`, `Help`], createHelp$1 = factory$1(name$79$1, dependencies$79$1, (t4) => {
  var { typed: n2, mathWithTransform: r2, Help: i2 } = t4;
  return n2(name$79$1, { any: function(t5) {
    var n3, a2 = t5;
    if (typeof t5 != `string`) {
      for (n3 in r2) if (hasOwnProperty$1$3(r2, n3) && t5 === r2[n3]) {
        a2 = n3;
        break;
      }
    }
    var o2 = getSafeProperty$1(embeddedDocs$1, a2);
    if (!o2) {
      var s2 = typeof a2 == `function` ? a2.name : a2;
      throw Error(`No documentation found on "` + s2 + `"`);
    }
    return new i2(o2);
  } });
}), name$78$1 = `chain`, dependencies$78$1 = [`typed`, `Chain`], createChain$1 = factory$1(name$78$1, dependencies$78$1, (t4) => {
  var { typed: n2, Chain: r2 } = t4;
  return n2(name$78$1, { "": function() {
    return new r2();
  }, any: function(t5) {
    return new r2(t5);
  } });
}), name$77$1 = `det`, dependencies$77$1 = [`typed`, `matrix`, `subtractScalar`, `multiply`, `divideScalar`, `isZero`, `unaryMinus`], createDet$1 = factory$1(name$77$1, dependencies$77$1, (t4) => {
  var { typed: n2, matrix: r2, subtractScalar: i2, multiply: a2, divideScalar: o2, isZero: s2, unaryMinus: c2 } = t4;
  return n2(name$77$1, { any: function(t5) {
    return clone$3$1(t5);
  }, "Array | Matrix": function(t5) {
    var n3;
    switch (isMatrix$1(t5) ? n3 = t5.size() : Array.isArray(t5) ? (t5 = r2(t5), n3 = t5.size()) : n3 = [], n3.length) {
      case 0:
        return clone$3$1(t5);
      case 1:
        if (n3[0] === 1) return clone$3$1(t5.valueOf()[0]);
        if (n3[0] === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      case 2:
        var i3 = n3[0], a3 = n3[1];
        if (i3 === a3) return l2(t5.clone().valueOf(), i3);
        if (a3 === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$3(n3) + `)`);
    }
  } });
  function l2(t5, n3, r3) {
    if (n3 === 1) return clone$3$1(t5[0][0]);
    if (n3 === 2) return i2(a2(t5[0][0], t5[1][1]), a2(t5[1][0], t5[0][1]));
    for (var l3 = false, u2 = Array(n3).fill(0).map((t6, n4) => n4), d2 = 0; d2 < n3; d2++) {
      var p2 = u2[d2];
      if (s2(t5[p2][d2])) {
        var m2 = void 0;
        for (m2 = d2 + 1; m2 < n3; m2++) if (!s2(t5[u2[m2]][d2])) {
          p2 = u2[m2], u2[m2] = u2[d2], u2[d2] = p2, l3 = !l3;
          break;
        }
        if (m2 === n3) return t5[p2][d2];
      }
      for (var h2 = t5[p2][d2], g2 = d2 === 0 ? 1 : t5[u2[d2 - 1]][d2 - 1], v2 = d2 + 1; v2 < n3; v2++) for (var y2 = u2[v2], b2 = d2 + 1; b2 < n3; b2++) t5[y2][b2] = o2(i2(a2(t5[y2][b2], h2), a2(t5[y2][d2], t5[p2][b2])), g2);
    }
    var x2 = t5[u2[n3 - 1]][n3 - 1];
    return l3 ? c2(x2) : x2;
  }
}), name$76$1 = `inv`, dependencies$76$1 = [`typed`, `matrix`, `divideScalar`, `addScalar`, `multiply`, `unaryMinus`, `det`, `identity`, `abs`], createInv$1 = factory$1(name$76$1, dependencies$76$1, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, addScalar: a2, multiply: o2, unaryMinus: s2, det: c2, identity: l2, abs: u2 } = t4;
  return n2(name$76$1, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$1(t5) ? t5.size() : arraySize$1(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return isMatrix$1(t5) ? r2([i2(1, t5.valueOf()[0])]) : [i2(1, t5[0])];
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      case 2:
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) return isMatrix$1(t5) ? r2(d2(t5.valueOf(), a3, o3), t5.storage()) : d2(t5, a3, o3);
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$3(n3) + `)`);
    }
  }, any: function(t5) {
    return i2(1, t5);
  } });
  function d2(t5, n3, r3) {
    var d3, p2, m2, h2, g2;
    if (n3 === 1) {
      if (h2 = t5[0][0], h2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(1, h2)]];
    } else if (n3 === 2) {
      var v2 = c2(t5);
      if (v2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(t5[1][1], v2), i2(s2(t5[0][1]), v2)], [i2(s2(t5[1][0]), v2), i2(t5[0][0], v2)]];
    } else {
      var y2 = t5.concat();
      for (d3 = 0; d3 < n3; d3++) y2[d3] = y2[d3].concat();
      for (var b2 = l2(n3).valueOf(), x2 = 0; x2 < r3; x2++) {
        var S2 = u2(y2[x2][x2]), w2 = x2;
        for (d3 = x2 + 1; d3 < n3; ) u2(y2[d3][x2]) > S2 && (S2 = u2(y2[d3][x2]), w2 = d3), d3++;
        if (S2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
        d3 = w2, d3 !== x2 && (g2 = y2[x2], y2[x2] = y2[d3], y2[d3] = g2, g2 = b2[x2], b2[x2] = b2[d3], b2[d3] = g2);
        var E = y2[x2], D = b2[x2];
        for (d3 = 0; d3 < n3; d3++) {
          var O2 = y2[d3], j2 = b2[d3];
          if (d3 !== x2) {
            if (O2[x2] !== 0) {
              for (m2 = i2(s2(O2[x2]), E[x2]), p2 = x2; p2 < r3; p2++) O2[p2] = a2(O2[p2], o2(m2, E[p2]));
              for (p2 = 0; p2 < r3; p2++) j2[p2] = a2(j2[p2], o2(m2, D[p2]));
            }
          } else {
            for (m2 = E[x2], p2 = x2; p2 < r3; p2++) O2[p2] = i2(O2[p2], m2);
            for (p2 = 0; p2 < r3; p2++) j2[p2] = i2(j2[p2], m2);
          }
        }
      }
      return b2;
    }
  }
}), name$75$1 = `pinv`, dependencies$75$1 = [`typed`, `matrix`, `inv`, `deepEqual`, `equal`, `dotDivide`, `dot`, `ctranspose`, `divideScalar`, `multiply`, `add`, `Complex`], createPinv$1 = factory$1(name$75$1, dependencies$75$1, (t4) => {
  var { typed: n2, matrix: r2, inv: i2, deepEqual: a2, equal: o2, dotDivide: s2, dot: c2, ctranspose: l2, divideScalar: u2, multiply: d2, add: p2, Complex: m2 } = t4;
  return n2(name$75$1, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$1(t5) ? t5.size() : arraySize$1(t5);
    switch (n3.length) {
      case 1:
        return b2(t5) ? l2(t5) : n3[0] === 1 ? i2(t5) : s2(l2(t5), c2(t5, t5));
      case 2:
        if (b2(t5)) return l2(t5);
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) try {
          return i2(t5);
        } catch (t6) {
          if (!(t6 instanceof Error && t6.message.match(/Cannot calculate inverse, determinant is zero/))) throw t6;
        }
        return isMatrix$1(t5) ? r2(h2(t5.valueOf(), a3, o3), t5.storage()) : h2(t5, a3, o3);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format$3(n3) + `)`);
    }
  }, any: function(t5) {
    return o2(t5, 0) ? clone$3$1(t5) : u2(1, t5);
  } });
  function h2(t5, n3, r3) {
    var { C: a3, F: o3 } = v2(t5, n3, r3), s3 = d2(i2(d2(l2(a3), a3)), l2(a3));
    return d2(d2(l2(o3), i2(d2(o3, l2(o3)))), s3);
  }
  function g2(t5, n3, r3) {
    for (var i3 = clone$3$1(t5), a3 = 0, o3 = 0; o3 < n3; o3++) {
      if (r3 <= a3) return i3;
      for (var c3 = o3; y2(i3[c3][a3]); ) if (c3++, n3 === c3 && (c3 = o3, a3++, r3 === a3)) return i3;
      [i3[c3], i3[o3]] = [i3[o3], i3[c3]];
      for (var l3 = i3[o3][a3], u3 = 0; u3 < r3; u3++) i3[o3][u3] = s2(i3[o3][u3], l3);
      for (var m3 = 0; m3 < n3; m3++) if (m3 !== o3) {
        l3 = i3[m3][a3];
        for (var h3 = 0; h3 < r3; h3++) i3[m3][h3] = p2(i3[m3][h3], d2(-1, d2(l3, i3[o3][h3])));
      }
      a3++;
    }
    return i3;
  }
  function v2(t5, n3, r3) {
    var i3 = g2(t5, n3, r3);
    return { C: t5.map((t6, r4) => t6.filter((t7, r5) => r5 < n3 && !y2(c2(i3[r5], i3[r5])))), F: i3.filter((t6, n4) => !y2(c2(i3[n4], i3[n4]))) };
  }
  function y2(t5) {
    return o2(p2(t5, m2(1, 1)), p2(0, m2(1, 1)));
  }
  function b2(t5) {
    return a2(p2(t5, m2(1, 1)), p2(d2(t5, 0), m2(1, 1)));
  }
});
function createComplexEigs$1(t4) {
  var { addScalar: n2, subtract: r2, flatten: i2, multiply: a2, multiplyScalar: o2, divideScalar: s2, sqrt: c2, abs: l2, bignumber: u2, diag: d2, size: p2, reshape: m2, inv: h2, qr: g2, usolve: v2, usolveAll: y2, equal: b2, complex: x2, larger: S2, smaller: w2, matrixFromColumns: E, dot: D } = t4;
  function O2(t5, n3, r3, i3) {
    var a3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, o3 = j2(t5, n3, r3, i3, a3);
    M2(t5, n3, r3, i3, a3, o3);
    var { values: s3, C: c3 } = N2(t5, n3, r3, i3, a3);
    return a3 ? { values: s3, eigenvectors: F(t5, n3, c3, o3, s3, r3, i3) } : { values: s3 };
  }
  function j2(t5, r3, i3, a3, c3) {
    var p3 = a3 === `BigNumber`, m3 = a3 === `Complex`, h3 = p3 ? u2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1, v3 = p3 ? u2(1) : 1, y3 = p3 ? u2(10) : 2, E2 = o2(y3, y3), D2;
    c3 && (D2 = Array(r3).fill(g3));
    for (var O22 = false; !O22; ) {
      O22 = true;
      for (var j3 = 0; j3 < r3; j3++) {
        for (var M3 = h3, N3 = h3, F2 = 0; F2 < r3; F2++) j3 !== F2 && (M3 = n2(M3, l2(t5[F2][j3])), N3 = n2(N3, l2(t5[j3][F2])));
        if (!b2(M3, 0) && !b2(N3, 0)) {
          for (var I22 = v3, L22 = M3, R22 = s2(N3, y3), z22 = o2(N3, y3); w2(L22, R22); ) L22 = o2(L22, E2), I22 = o2(I22, y3);
          for (; S2(L22, z22); ) L22 = s2(L22, E2), I22 = s2(I22, y3);
          if (w2(s2(n2(L22, N3), I22), o2(n2(M3, N3), 0.95))) {
            O22 = false;
            for (var V22 = s2(1, I22), H3 = 0; H3 < r3; H3++) j3 !== H3 && (t5[j3][H3] = o2(t5[j3][H3], V22), t5[H3][j3] = o2(t5[H3][j3], I22));
            c3 && (D2[j3] = o2(D2[j3], V22));
          }
        }
      }
    }
    return c3 ? d2(D2) : null;
  }
  function M2(t5, i3, a3, c3, d3, p3) {
    var m3 = c3 === `BigNumber`, h3 = m3 ? u2(0) : c3 === `Complex` ? x2(0) : 0;
    m3 && (a3 = u2(a3));
    for (var g3 = 0; g3 < i3 - 2; g3++) {
      for (var v3 = 0, y3 = h3, b3 = g3 + 1; b3 < i3; b3++) {
        var S3 = t5[b3][g3];
        w2(l2(y3), l2(S3)) && (y3 = S3, v3 = b3);
      }
      if (!w2(l2(y3), a3)) {
        if (v3 !== g3 + 1) {
          var E2 = t5[v3];
          t5[v3] = t5[g3 + 1], t5[g3 + 1] = E2;
          for (var D2 = 0; D2 < i3; D2++) {
            var O22 = t5[D2][v3];
            t5[D2][v3] = t5[D2][g3 + 1], t5[D2][g3 + 1] = O22;
          }
          if (d3) {
            var j3 = p3[v3];
            p3[v3] = p3[g3 + 1], p3[g3 + 1] = j3;
          }
        }
        for (var M3 = g3 + 2; M3 < i3; M3++) {
          var N3 = s2(t5[M3][g3], y3);
          if (N3 !== 0) {
            for (var F2 = 0; F2 < i3; F2++) t5[M3][F2] = r2(t5[M3][F2], o2(N3, t5[g3 + 1][F2]));
            for (var I22 = 0; I22 < i3; I22++) t5[I22][g3 + 1] = n2(t5[I22][g3 + 1], o2(N3, t5[I22][M3]));
            if (d3) for (var L22 = 0; L22 < i3; L22++) p3[M3][L22] = r2(p3[M3][L22], o2(N3, p3[g3 + 1][L22]));
          }
        }
      }
    }
    return p3;
  }
  function N2(t5, i3, o3, s3, c3) {
    var p3 = s3 === `BigNumber`, m3 = p3 ? u2(1) : s3 === `Complex` ? x2(1) : 1;
    p3 && (o3 = u2(o3));
    for (var h3 = clone$3$1(t5), v3 = [], y3 = i3, b3 = [], S3 = c3 ? d2(Array(i3).fill(m3)) : void 0, E2 = c3 ? d2(Array(y3).fill(m3)) : void 0, D2 = 0; D2 <= 100; ) {
      D2 += 1;
      for (var O22 = h3[y3 - 1][y3 - 1], j3 = 0; j3 < y3; j3++) h3[j3][j3] = r2(h3[j3][j3], O22);
      var { Q: M3, R: N3 } = g2(h3);
      h3 = a2(N3, M3);
      for (var F2 = 0; F2 < y3; F2++) h3[F2][F2] = n2(h3[F2][F2], O22);
      if (c3 && (E2 = a2(E2, M3)), y3 === 1 || w2(l2(h3[y3 - 1][y3 - 2]), o3)) {
        D2 = 0, v3.push(h3[y3 - 1][y3 - 1]), c3 && (b3.unshift([[1]]), R2(E2, i3), S3 = a2(S3, E2), y3 > 1 && (E2 = d2(Array(y3 - 1).fill(m3)))), --y3, h3.pop();
        for (var V22 = 0; V22 < y3; V22++) h3[V22].pop();
      } else if (y3 === 2 || w2(l2(h3[y3 - 2][y3 - 3]), o3)) {
        D2 = 0;
        var H3 = I2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1]);
        v3.push(...H3), c3 && (b3.unshift(L2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1], H3[0], H3[1], o3, s3)), R2(E2, i3), S3 = a2(S3, E2), y3 > 2 && (E2 = d2(Array(y3 - 2).fill(m3)))), y3 -= 2, h3.pop(), h3.pop();
        for (var U22 = 0; U22 < y3; U22++) h3[U22].pop(), h3[U22].pop();
      }
      if (y3 === 0) break;
    }
    if (v3.sort((t6, n3) => +r2(l2(t6), l2(n3))), D2 > 100) {
      var W22 = Error(`The eigenvalues failed to converge. Only found these eigenvalues: ` + v3.join(`, `));
      throw W22.values = v3, W22.vectors = [], W22;
    }
    return { values: v3, C: c3 ? a2(S3, z2(b3, i3)) : void 0 };
  }
  function F(t5, n3, o3, s3, c3, l3, p3) {
    var m3 = a2(h2(o3), t5, o3), g3 = p3 === `BigNumber`, v3 = p3 === `Complex`, S3 = g3 ? u2(0) : v3 ? x2(0) : 0, w3 = g3 ? u2(1) : v3 ? x2(1) : 1, E2 = [], D2 = [];
    for (var O22 of c3) {
      var j3 = V2(E2, O22, b2);
      j3 === -1 ? (E2.push(O22), D2.push(1)) : D2[j3] += 1;
    }
    for (var M3 = [], N3 = E2.length, F2 = Array(n3).fill(S3), I22 = d2(Array(n3).fill(w3)), L22 = function() {
      var t6 = E2[R22], c4 = r2(m3, a2(t6, I22)), u3 = y2(c4, F2);
      for (u3.shift(); u3.length < D2[R22]; ) {
        var d3 = H2(c4, n3, u3, l3, p3);
        if (d3 === null) break;
        u3.push(d3);
      }
      var g4 = a2(h2(s3), o3);
      u3 = u3.map((t7) => a2(g4, t7)), M3.push(...u3.map((n4) => ({ value: t6, vector: i2(n4) })));
    }, R22 = 0; R22 < N3; R22++) L22();
    return M3;
  }
  function I2(t5, i3, a3, s3) {
    var l3 = n2(t5, s3), u3 = r2(o2(t5, s3), o2(i3, a3)), d3 = o2(l3, 0.5), p3 = o2(c2(r2(o2(l3, l3), o2(4, u3))), 0.5);
    return [n2(d3, p3), r2(d3, p3)];
  }
  function L2(t5, n3, i3, a3, o3, s3, c3, d3) {
    var p3 = d3 === `BigNumber`, m3 = d3 === `Complex`, h3 = p3 ? u2(0) : m3 ? x2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1;
    if (w2(l2(i3), c3)) return [[g3, h3], [h3, g3]];
    if (S2(l2(r2(o3, s3)), c3)) return [[r2(o3, a3), r2(s3, a3)], [i3, i3]];
    var v3 = r2(t5, o3), y3 = r2(a3, o3);
    return w2(l2(n3), c3) && w2(l2(y3), c3) ? [[v3, g3], [i3, h3]] : [[n3, h3], [y3, g3]];
  }
  function R2(t5, n3) {
    for (var r3 = 0; r3 < t5.length; r3++) t5[r3].push(...Array(n3 - t5[r3].length).fill(0));
    for (var i3 = t5.length; i3 < n3; i3++) t5.push(Array(n3).fill(0)), t5[i3][i3] = 1;
    return t5;
  }
  function z2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3; i3++) r3[i3] = Array(n3).fill(0);
    var a3 = 0;
    for (var o3 of t5) {
      for (var s3 = o3.length, c3 = 0; c3 < s3; c3++) for (var l3 = 0; l3 < s3; l3++) r3[a3 + c3][a3 + l3] = o3[c3][l3];
      a3 += s3;
    }
    return r3;
  }
  function V2(t5, n3, r3) {
    for (var i3 = 0; i3 < t5.length; i3++) if (r3(t5[i3], n3)) return i3;
    return -1;
  }
  function H2(t5, n3, r3, i3, a3) {
    for (var o3 = a3 === `BigNumber` ? u2(1e3) : 1e3, s3, c3 = 0; c3 < 5; ++c3) {
      s3 = U2(n3, r3, a3);
      try {
        s3 = v2(t5, s3);
      } catch {
        continue;
      }
      if (S2(G2(s3), o3)) break;
    }
    if (c3 >= 5) return null;
    for (c3 = 0; ; ) {
      var l3 = v2(t5, s3);
      if (w2(G2(W2(s3, [l3])), i3)) break;
      if (++c3 >= 10) return null;
      s3 = K2(l3);
    }
    return s3;
  }
  function U2(t5, n3, r3) {
    var i3 = r3 === `BigNumber`, a3 = r3 === `Complex`, o3 = Array(t5).fill(0).map((t6) => 2 * Math.random() - 1);
    return i3 && (o3 = o3.map((t6) => u2(t6))), a3 && (o3 = o3.map((t6) => x2(t6))), o3 = W2(o3, n3), K2(o3, r3);
  }
  function W2(t5, n3) {
    var i3 = p2(t5);
    for (var o3 of n3) o3 = m2(o3, i3), t5 = r2(t5, a2(s2(D(o3, t5), D(o3, o3)), o3));
    return t5;
  }
  function G2(t5) {
    return l2(c2(D(t5, t5)));
  }
  function K2(t5, n3) {
    return a2(s2(n3 === `BigNumber` ? u2(1) : n3 === `Complex` ? x2(1) : 1, G2(t5)), t5);
  }
  return O2;
}
function createRealSymmetric$1(t4) {
  var { config: n2, addScalar: r2, subtract: i2, abs: a2, atan: o2, cos: s2, sin: c2, multiplyScalar: l2, inv: u2, bignumber: d2, multiply: p2, add: m2 } = t4;
  function h2(t5, r3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n2.relTol, a3 = arguments.length > 3 ? arguments[3] : void 0, o3 = arguments.length > 4 ? arguments[4] : void 0;
    if (a3 === `number`) return g2(t5, i3, o3);
    if (a3 === `BigNumber`) return v2(t5, i3, o3);
    throw TypeError(`Unsupported data type: ` + a3);
  }
  function g2(t5, n3, r3) {
    var i3 = t5.length, a3 = Math.abs(n3 / i3), o3, s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3).fill(0), s3[c3][c3] = 1;
    }
    for (var l3 = D(t5); Math.abs(l3[1]) >= Math.abs(a3); ) {
      var u3 = l3[0][0], d3 = l3[0][1];
      o3 = y2(t5[u3][u3], t5[d3][d3], t5[u3][d3]), t5 = E(t5, o3, u3, d3), r3 && (s3 = x2(s3, o3, u3, d3)), l3 = D(t5);
    }
    for (var p3 = Array(i3).fill(0), m3 = 0; m3 < i3; m3++) p3[m3] = t5[m3][m3];
    return j2(clone$3$1(p3), s3, r3);
  }
  function v2(t5, n3, r3) {
    var i3 = t5.length, o3 = a2(n3 / i3), s3, c3;
    if (r3) {
      c3 = Array(i3);
      for (var l3 = 0; l3 < i3; l3++) c3[l3] = Array(i3).fill(0), c3[l3][l3] = 1;
    }
    for (var u3 = O2(t5); a2(u3[1]) >= a2(o3); ) {
      var d3 = u3[0][0], p3 = u3[0][1];
      s3 = b2(t5[d3][d3], t5[p3][p3], t5[d3][p3]), t5 = w2(t5, s3, d3, p3), r3 && (c3 = S2(c3, s3, d3, p3)), u3 = O2(t5);
    }
    for (var m3 = Array(i3).fill(0), h3 = 0; h3 < i3; h3++) m3[h3] = t5[h3][h3];
    return j2(clone$3$1(m3), c3, r3);
  }
  function y2(t5, r3, i3) {
    var a3 = r3 - t5;
    return Math.abs(a3) <= n2.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * i3 / (r3 - t5));
  }
  function b2(t5, r3, s3) {
    var c3 = i2(r3, t5);
    return a2(c3) <= n2.relTol ? d2(-1).acos().div(4) : l2(0.5, o2(p2(2, s3, u2(c3))));
  }
  function x2(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = Array(a3).fill(0), l3 = Array(a3).fill(0), u3 = 0; u3 < a3; u3++) c3[u3] = o3 * t5[u3][r3] - s3 * t5[u3][i3], l3[u3] = s3 * t5[u3][r3] + o3 * t5[u3][i3];
    for (var d3 = 0; d3 < a3; d3++) t5[d3][r3] = c3[d3], t5[d3][i3] = l3[d3];
    return t5;
  }
  function S2(t5, n3, a3, o3) {
    for (var u3 = t5.length, p3 = s2(n3), m3 = c2(n3), h3 = Array(u3).fill(d2(0)), g3 = Array(u3).fill(d2(0)), v3 = 0; v3 < u3; v3++) h3[v3] = i2(l2(p3, t5[v3][a3]), l2(m3, t5[v3][o3])), g3[v3] = r2(l2(m3, t5[v3][a3]), l2(p3, t5[v3][o3]));
    for (var y3 = 0; y3 < u3; y3++) t5[y3][a3] = h3[y3], t5[y3][o3] = g3[y3];
    return t5;
  }
  function w2(t5, n3, a3, o3) {
    for (var u3 = t5.length, h3 = d2(s2(n3)), g3 = d2(c2(n3)), v3 = l2(h3, h3), y3 = l2(g3, g3), b3 = Array(u3).fill(d2(0)), x3 = Array(u3).fill(d2(0)), S3 = p2(d2(2), h3, g3, t5[a3][o3]), w3 = r2(i2(l2(v3, t5[a3][a3]), S3), l2(y3, t5[o3][o3])), E2 = m2(l2(y3, t5[a3][a3]), S3, l2(v3, t5[o3][o3])), D2 = 0; D2 < u3; D2++) b3[D2] = i2(l2(h3, t5[a3][D2]), l2(g3, t5[o3][D2])), x3[D2] = r2(l2(g3, t5[a3][D2]), l2(h3, t5[o3][D2]));
    t5[a3][a3] = w3, t5[o3][o3] = E2, t5[a3][o3] = d2(0), t5[o3][a3] = d2(0);
    for (var O22 = 0; O22 < u3; O22++) O22 !== a3 && O22 !== o3 && (t5[a3][O22] = b3[O22], t5[O22][a3] = b3[O22], t5[o3][O22] = x3[O22], t5[O22][o3] = x3[O22]);
    return t5;
  }
  function E(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = o3 * o3, l3 = s3 * s3, u3 = Array(a3).fill(0), d3 = Array(a3).fill(0), p3 = c3 * t5[r3][r3] - 2 * o3 * s3 * t5[r3][i3] + l3 * t5[i3][i3], m3 = l3 * t5[r3][r3] + 2 * o3 * s3 * t5[r3][i3] + c3 * t5[i3][i3], h3 = 0; h3 < a3; h3++) u3[h3] = o3 * t5[r3][h3] - s3 * t5[i3][h3], d3[h3] = s3 * t5[r3][h3] + o3 * t5[i3][h3];
    t5[r3][r3] = p3, t5[i3][i3] = m3, t5[r3][i3] = 0, t5[i3][r3] = 0;
    for (var g3 = 0; g3 < a3; g3++) g3 !== r3 && g3 !== i3 && (t5[r3][g3] = u3[g3], t5[g3][r3] = u3[g3], t5[i3][g3] = d3[g3], t5[g3][i3] = d3[g3]);
    return t5;
  }
  function D(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], a3 = 0; a3 < n3; a3++) for (var o3 = a3 + 1; o3 < n3; o3++) Math.abs(r3) < Math.abs(t5[a3][o3]) && (r3 = Math.abs(t5[a3][o3]), i3 = [a3, o3]);
    return [i3, r3];
  }
  function O2(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], o3 = 0; o3 < n3; o3++) for (var s3 = o3 + 1; s3 < n3; s3++) a2(r3) < a2(t5[o3][s3]) && (r3 = a2(t5[o3][s3]), i3 = [o3, s3]);
    return [i3, r3];
  }
  function j2(t5, n3, r3) {
    var i3 = t5.length, o3 = Array(i3), s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3);
    }
    for (var l3 = 0; l3 < i3; l3++) {
      for (var u3 = 0, d3 = t5[0], p3 = 0; p3 < t5.length; p3++) a2(t5[p3]) < a2(d3) && (u3 = p3, d3 = t5[u3]);
      if (o3[l3] = t5.splice(u3, 1)[0], r3) for (var m3 = 0; m3 < i3; m3++) s3[l3][m3] = n3[m3][u3], n3[m3].splice(u3, 1);
    }
    return r3 ? { values: o3, eigenvectors: s3.map((t6, n4) => ({ value: o3[n4], vector: t6 })) } : { values: o3 };
  }
  return h2;
}
var name$74$1 = `eigs`, dependencies$74$1 = `config.typed.matrix.addScalar.equal.subtract.abs.atan.cos.sin.multiplyScalar.divideScalar.inv.bignumber.multiply.add.larger.column.flatten.number.complex.sqrt.diag.size.reshape.qr.usolve.usolveAll.im.re.smaller.matrixFromColumns.dot`.split(`.`), createEigs$1 = factory$1(name$74$1, dependencies$74$1, (t4) => {
  var { config: n2, typed: r2, matrix: i2, addScalar: a2, subtract: o2, equal: s2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, divideScalar: m2, inv: h2, bignumber: g2, multiply: v2, add: y2, larger: b2, column: x2, flatten: S2, number: w2, complex: E, sqrt: D, diag: O2, size: j2, reshape: M2, qr: N2, usolve: F, usolveAll: I2, im: L2, re: R2, smaller: z2, matrixFromColumns: V2, dot: H2 } = t4, U2 = createRealSymmetric$1({ config: n2, addScalar: a2, subtract: o2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, inv: h2, bignumber: g2, multiply: v2, add: y2 }), W2 = createComplexEigs$1({ addScalar: a2, subtract: o2, multiply: v2, multiplyScalar: p2, flatten: S2, divideScalar: m2, sqrt: D, abs: c2, bignumber: g2, diag: O2, size: j2, reshape: M2, qr: N2, inv: h2, usolve: F, usolveAll: I2, equal: s2, complex: E, larger: b2, smaller: z2, matrixFromColumns: V2, dot: H2 });
  return r2(`eigs`, { Array: function(t5) {
    return G2(i2(t5));
  }, "Array, number|BigNumber": function(t5, n3) {
    return G2(i2(t5), { precision: n3 });
  }, "Array, Object"(t5, n3) {
    return G2(i2(t5), n3);
  }, Matrix: function(t5) {
    return G2(t5, { matricize: true });
  }, "Matrix, number|BigNumber": function(t5, n3) {
    return G2(t5, { precision: n3, matricize: true });
  }, "Matrix, Object": function(t5, n3) {
    var r3 = { matricize: true };
    return _extends$3(r3, n3), G2(t5, r3);
  } });
  function G2(t5) {
    var a3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o3 = `eigenvectors` in a3 ? a3.eigenvectors : true, s3 = K2(t5, a3.precision ?? n2.relTol, o3);
    return a3.matricize && (s3.values = i2(s3.values), o3 && (s3.eigenvectors = s3.eigenvectors.map((t6) => {
      var { value: n3, vector: r3 } = t6;
      return { value: n3, vector: i2(r3) };
    }))), o3 && Object.defineProperty(s3, "vectors", { enumerable: false, get: () => {
      throw Error(`eigs(M).vectors replaced with eigs(M).eigenvectors`);
    } }), s3;
  }
  function K2(t5, n3, r3) {
    var i3 = t5.toArray(), a3 = t5.size();
    if (a3.length !== 2 || a3[0] !== a3[1]) throw RangeError(`Matrix must be square (size: ${format$3(a3)})`);
    var o3 = a3[0];
    return J(i3, o3, n3) && (ee2(i3, o3), q2(i3, o3, n3)) ? U2(i3, o3, n3, Y2(t5, i3, o3), r3) : W2(i3, o3, n3, Y2(t5, i3, o3), r3);
  }
  function q2(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = i3; a3 < n3; a3++) if (b2(g2(c2(o2(t5[i3][a3], t5[a3][i3]))), r3)) return false;
    return true;
  }
  function J(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = 0; a3 < n3; a3++) if (b2(g2(c2(L2(t5[i3][a3]))), r3)) return false;
    return true;
  }
  function ee2(t5, n3) {
    for (var r3 = 0; r3 < n3; r3++) for (var i3 = 0; i3 < n3; i3++) t5[r3][i3] = R2(t5[r3][i3]);
  }
  function Y2(t5, n3, r3) {
    var i3 = t5.datatype();
    if (i3 === `number` || i3 === `BigNumber` || i3 === `Complex`) return i3;
    for (var a3 = false, o3 = false, s3 = false, c3 = 0; c3 < r3; c3++) for (var l3 = 0; l3 < r3; l3++) {
      var u3 = n3[c3][l3];
      if (isNumber$1(u3) || isFraction$1(u3)) a3 = true;
      else if (isBigNumber$1(u3)) o3 = true;
      else if (isComplex$1(u3)) s3 = true;
      else throw TypeError(`Unsupported type in Matrix: ` + typeOf$1(u3));
    }
    if (o3 && s3 && console.warn(`Complex BigNumbers not supported, this operation will lose precission.`), s3) {
      for (var d3 = 0; d3 < r3; d3++) for (var p3 = 0; p3 < r3; p3++) n3[d3][p3] = E(n3[d3][p3]);
      return `Complex`;
    }
    if (o3) {
      for (var m3 = 0; m3 < r3; m3++) for (var h3 = 0; h3 < r3; h3++) n3[m3][h3] = g2(n3[m3][h3]);
      return `BigNumber`;
    }
    if (a3) {
      for (var v3 = 0; v3 < r3; v3++) for (var y3 = 0; y3 < r3; y3++) n3[v3][y3] = w2(n3[v3][y3]);
      return `number`;
    } else throw TypeError(`Matrix contains unsupported types only.`);
  }
}), name$73$1 = `expm`, dependencies$73$1 = [`typed`, `abs`, `add`, `identity`, `inv`, `multiply`], createExpm$1 = factory$1(name$73$1, dependencies$73$1, (t4) => {
  var { typed: n2, abs: r2, add: i2, identity: a2, inv: o2, multiply: s2 } = t4;
  return n2(name$73$1, { Matrix: function(t5) {
    var n3 = t5.size();
    if (n3.length !== 2 || n3[0] !== n3[1]) throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
    for (var r3 = n3[0], u3 = l2(c2(t5), 1e-15), d2 = u3.q, p2 = u3.j, m2 = s2(t5, 2 ** -p2), h2 = a2(r3), g2 = a2(r3), v2 = 1, y2 = m2, b2 = -1, x2 = 1; x2 <= d2; x2++) x2 > 1 && (y2 = s2(y2, m2), b2 = -b2), v2 = v2 * (d2 - x2 + 1) / ((2 * d2 - x2 + 1) * x2), h2 = i2(h2, s2(v2, y2)), g2 = i2(g2, s2(v2 * b2, y2));
    for (var S2 = s2(o2(g2), h2), w2 = 0; w2 < p2; w2++) S2 = s2(S2, S2);
    return isSparseMatrix$1(t5) ? t5.createSparseMatrix(S2) : S2;
  } });
  function c2(t5) {
    for (var n3 = t5.size()[0], i3 = 0, a3 = 0; a3 < n3; a3++) {
      for (var o3 = 0, s3 = 0; s3 < n3; s3++) o3 += r2(t5.get([a3, s3]));
      i3 = Math.max(o3, i3);
    }
    return i3;
  }
  function l2(t5, n3) {
    for (var r3 = 30, i3 = 0; i3 < r3; i3++) for (var a3 = 0; a3 <= i3; a3++) {
      var o3 = i3 - a3;
      if (u2(t5, a3, o3) < n3) return { q: a3, j: o3 };
    }
    throw Error(`Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)`);
  }
  function u2(t5, n3, r3) {
    for (var i3 = 1, a3 = 2; a3 <= n3; a3++) i3 *= a3;
    for (var o3 = i3, s3 = n3 + 1; s3 <= 2 * n3; s3++) o3 *= s3;
    var c3 = o3 * (2 * n3 + 1);
    return 8 * (t5 / 2 ** r3) ** (2 * n3) * i3 * i3 / (o3 * c3);
  }
}), name$72$1 = `sqrtm`, dependencies$72$1 = [`typed`, `abs`, `add`, `multiply`, `map`, `sqrt`, `subtract`, `inv`, `size`, `max`, `identity`], createSqrtm$1 = factory$1(name$72$1, dependencies$72$1, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, map: o2, sqrt: s2, subtract: c2, inv: l2, size: u2, max: d2, identity: p2 } = t4, m2 = 1e3, h2 = 1e-6;
  function g2(t5) {
    var n3, o3 = 0, s3 = t5, g3 = p2(u2(t5));
    do {
      var v2 = s3;
      if (s3 = a2(0.5, i2(v2, l2(g3))), g3 = a2(0.5, i2(g3, l2(v2))), n3 = d2(r2(c2(s3, v2))), n3 > h2 && ++o3 > m2) throw Error(`computing square root of matrix: iterative method could not converge`);
    } while (n3 > h2);
    return s3;
  }
  return n2(name$72$1, { "Array | Matrix": function(t5) {
    var n3 = isMatrix$1(t5) ? t5.size() : arraySize$1(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return o2(t5, s2);
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      case 2:
        if (n3[0] === n3[1]) return g2(t5);
        throw RangeError(`Matrix must be square (size: ` + format$3(n3) + `)`);
      default:
        throw RangeError(`Matrix must be at most two dimensional (size: ` + format$3(n3) + `)`);
    }
  } });
}), name$71$1 = `sylvester`, dependencies$71$1 = [`typed`, `schur`, `matrixFromColumns`, `matrix`, `multiply`, `range`, `concat`, `transpose`, `index`, `subset`, `add`, `subtract`, `identity`, `lusolve`, `abs`], createSylvester$1 = factory$1(name$71$1, dependencies$71$1, (t4) => {
  var { typed: n2, schur: r2, matrixFromColumns: i2, matrix: a2, multiply: o2, range: s2, concat: c2, transpose: l2, index: u2, subset: d2, add: p2, subtract: m2, identity: h2, lusolve: g2, abs: v2, config: y2 } = t4;
  return n2(name$71$1, { "Matrix, Matrix, Matrix": b2, "Array, Matrix, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), n3, r3);
  }, "Array, Array, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), r3);
  }, "Array, Matrix, Array": function(t5, n3, r3) {
    return b2(a2(t5), n3, a2(r3));
  }, "Matrix, Array, Matrix": function(t5, n3, r3) {
    return b2(t5, a2(n3), r3);
  }, "Matrix, Array, Array": function(t5, n3, r3) {
    return b2(t5, a2(n3), a2(r3));
  }, "Matrix, Matrix, Array": function(t5, n3, r3) {
    return b2(t5, n3, a2(r3));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), a2(r3)).toArray();
  } });
  function b2(t5, n3, y3) {
    for (var b3 = n3.size()[0], x2 = t5.size()[0], S2 = r2(t5), w2 = S2.T, E = S2.U, D = r2(o2(-1, n3)), O2 = D.T, j2 = D.U, M2 = o2(o2(l2(E), y3), j2), N2 = s2(0, x2), F = [], I2 = (t6, n4) => c2(t6, n4, 1), L2 = (t6, n4) => c2(t6, n4, 0), R2 = 0; R2 < b3; R2++) if (R2 < b3 - 1 && v2(d2(O2, u2(R2 + 1, R2))) > 1e-5) {
      for (var z2 = L2(d2(M2, u2(N2, [R2])), d2(M2, u2(N2, [R2 + 1]))), V2 = 0; V2 < R2; V2++) z2 = p2(z2, L2(o2(F[V2], d2(O2, u2(V2, R2))), o2(F[V2], d2(O2, u2(V2, R2 + 1)))));
      var H2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2)))), U2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2)))), W2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2 + 1)))), G2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2 + 1)))), K2 = g2(L2(I2(p2(w2, H2), U2), I2(W2, p2(w2, G2))), z2);
      F[R2] = K2.subset(u2(s2(0, x2), [0])), F[R2 + 1] = K2.subset(u2(s2(x2, 2 * x2), [0])), R2++;
    } else {
      for (var q2 = d2(M2, u2(N2, [R2])), J = 0; J < R2; J++) q2 = p2(q2, o2(F[J], d2(O2, u2(J, R2))));
      F[R2] = g2(m2(w2, o2(d2(O2, u2(R2, R2)), h2(x2))), q2);
    }
    return o2(E, o2(a2(i2(...F)), l2(j2)));
  }
}), name$70$1 = `schur`, dependencies$70$1 = [`typed`, `matrix`, `identity`, `multiply`, `qr`, `norm`, `subtract`], createSchur$1 = factory$1(name$70$1, dependencies$70$1, (t4) => {
  var { typed: n2, matrix: r2, identity: i2, multiply: a2, qr: o2, norm: s2, subtract: c2 } = t4;
  return n2(name$70$1, { Array: function(t5) {
    var n3 = l2(r2(t5));
    return { U: n3.U.valueOf(), T: n3.T.valueOf() };
  }, Matrix: function(t5) {
    return l2(t5);
  } });
  function l2(t5) {
    var n3 = t5.size()[0], r3 = t5, l3 = i2(n3), u2 = 0, d2;
    do {
      d2 = r3;
      var p2 = o2(r3), m2 = p2.Q, h2 = p2.R;
      if (r3 = a2(h2, m2), l3 = a2(l3, m2), u2++ > 100) break;
    } while (s2(c2(r3, d2)) > 1e-4);
    return { U: l3, T: r3 };
  }
}), name$69$1 = `lyap`, dependencies$69$1 = [`typed`, `matrix`, `sylvester`, `multiply`, `transpose`], createLyap$1 = factory$1(name$69$1, dependencies$69$1, (t4) => {
  var { typed: n2, matrix: r2, sylvester: i2, multiply: a2, transpose: o2 } = t4;
  return n2(name$69$1, { "Matrix, Matrix": function(t5, n3) {
    return i2(t5, o2(t5), a2(-1, n3));
  }, "Array, Matrix": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), a2(-1, n3));
  }, "Matrix, Array": function(t5, n3) {
    return i2(t5, o2(r2(t5)), r2(a2(-1, n3)));
  }, "Array, Array": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), r2(a2(-1, n3))).toArray();
  } });
}), name$68$1 = `divide`, dependencies$68$1 = [`typed`, `matrix`, `multiply`, `equalScalar`, `divideScalar`, `inv`], createDivide$1 = factory$1(name$68$1, dependencies$68$1, (t4) => {
  var { typed: n2, matrix: r2, multiply: i2, equalScalar: a2, divideScalar: o2, inv: s2 } = t4, c2 = createMatAlgo11xS0s$1({ typed: n2, equalScalar: a2 }), l2 = createMatAlgo14xDs$1({ typed: n2 });
  return n2(`divide`, extend$1$2({ "Array | Matrix, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, o2, false);
  }, "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, o2, false);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, o2, false).valueOf();
  }, "any, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  } }, o2.signatures));
}), name$67$1 = `distance`, dependencies$67$1 = [`typed`, `addScalar`, `subtractScalar`, `divideScalar`, `multiplyScalar`, `deepEqual`, `sqrt`, `abs`], createDistance$1 = factory$1(name$67$1, dependencies$67$1, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, deepEqual: s2, sqrt: c2, abs: l2 } = t4;
  return n2(name$67$1, { "Array, Array, Array": function(t5, n3, r3) {
    if (t5.length === 2 && n3.length === 2 && r3.length === 2) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!d2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!d2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (s2(n3, r3)) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      var o3 = i2(r3[1], n3[1]), c3 = i2(n3[0], r3[0]), l3 = i2(a2(r3[0], n3[1]), a2(n3[0], r3[1]));
      return y2(t5[0], t5[1], o3, c3, l3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object, Object": function(t5, n3, r3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2 && Object.keys(r3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers`);
      if (!d2(r3)) throw TypeError(`Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers`);
      if (s2(g2(n3), g2(r3))) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      if (`pointX` in t5 && `pointY` in t5 && `lineOnePtX` in n3 && `lineOnePtY` in n3 && `lineTwoPtX` in r3 && `lineTwoPtY` in r3) {
        var o3 = i2(r3.lineTwoPtY, n3.lineOnePtY), c3 = i2(n3.lineOnePtX, r3.lineTwoPtX), l3 = i2(a2(r3.lineTwoPtX, n3.lineOnePtY), a2(n3.lineOnePtX, r3.lineTwoPtY));
        return y2(t5.pointX, t5.pointY, o3, c3, l3);
      } else throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Array, Array": function(t5, n3) {
    if (t5.length === 2 && n3.length === 3) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!p2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      return y2(t5[0], t5[1], n3[0], n3[1], n3[2]);
    } else if (t5.length === 3 && n3.length === 6) {
      if (!p2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!h2(n3)) throw TypeError(`Array with 6 numbers or BigNumbers expected for second argument`);
      return b2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], n3[3], n3[4], n3[5]);
    } else if (t5.length === n3.length && t5.length > 0) {
      if (!m2(t5) || !m2(n3)) throw TypeError(`All values of an array should be numbers or BigNumbers`);
      return x2(t5, n3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object": function(t5, n3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 3) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `xCoeffLine` in n3 && `yCoeffLine` in n3 && `constant` in n3) return y2(t5.pointX, t5.pointY, n3.xCoeffLine, n3.yCoeffLine, n3.constant);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 6) {
      if (!p2(t5)) throw TypeError(`Values of pointX, pointY and pointZ should be numbers or BigNumbers`);
      if (!h2(n3)) throw TypeError(`Values of x0, y0, z0, a, b and c should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `x0` in n3 && `y0` in n3 && `z0` in n3 && `a` in n3 && `b` in n3 && `c` in n3) return b2(t5.pointX, t5.pointY, t5.pointZ, n3.x0, n3.y0, n3.z0, n3.a, n3.b, n3.c);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointOneX and pointOneY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of pointTwoX and pointTwoY should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3) return x2([t5.pointOneX, t5.pointOneY], [n3.pointTwoX, n3.pointTwoY]);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 3) {
      if (!p2(t5)) throw TypeError(`Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointOneZ` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3 && `pointTwoZ` in n3) return x2([t5.pointOneX, t5.pointOneY, t5.pointOneZ], [n3.pointTwoX, n3.pointTwoY, n3.pointTwoZ]);
      throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, Array: function(t5) {
    if (!v2(t5)) throw TypeError(`Incorrect array format entered for pairwise distance calculation`);
    return S2(t5);
  } });
  function u2(t5) {
    return typeof t5 == `number` || isBigNumber$1(t5);
  }
  function d2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]);
  }
  function p2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]);
  }
  function m2(t5) {
    return Array.isArray(t5) || (t5 = g2(t5)), t5.every(u2);
  }
  function h2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]) && u2(t5[3]) && u2(t5[4]) && u2(t5[5]);
  }
  function g2(t5) {
    for (var n3 = Object.keys(t5), r3 = [], i3 = 0; i3 < n3.length; i3++) r3.push(t5[n3[i3]]);
    return r3;
  }
  function v2(t5) {
    if (t5[0].length === 2 && u2(t5[0][0]) && u2(t5[0][1])) {
      if (t5.some((t6) => t6.length !== 2 || !u2(t6[0]) || !u2(t6[1]))) return false;
    } else if (t5[0].length === 3 && u2(t5[0][0]) && u2(t5[0][1]) && u2(t5[0][2])) {
      if (t5.some((t6) => t6.length !== 3 || !u2(t6[0]) || !u2(t6[1]) || !u2(t6[2]))) return false;
    } else return false;
    return true;
  }
  function y2(t5, n3, i3, s3, u3) {
    return o2(l2(r2(r2(a2(i3, t5), a2(s3, n3)), u3)), c2(r2(a2(i3, i3), a2(s3, s3))));
  }
  function b2(t5, n3, s3, l3, u3, d3, p3, m3, h3) {
    var g3 = [i2(a2(i2(u3, n3), h3), a2(i2(d3, s3), m3)), i2(a2(i2(d3, s3), p3), a2(i2(l3, t5), h3)), i2(a2(i2(l3, t5), m3), a2(i2(u3, n3), p3))];
    g3 = c2(r2(r2(a2(g3[0], g3[0]), a2(g3[1], g3[1])), a2(g3[2], g3[2])));
    var v3 = c2(r2(r2(a2(p3, p3), a2(m3, m3)), a2(h3, h3)));
    return o2(g3, v3);
  }
  function x2(t5, n3) {
    for (var o3 = t5.length, s3 = 0, l3 = 0, u3 = 0; u3 < o3; u3++) l3 = i2(t5[u3], n3[u3]), s3 = r2(a2(l3, l3), s3);
    return c2(s3);
  }
  function S2(t5) {
    for (var n3 = [], r3 = [], i3 = [], a3 = 0; a3 < t5.length - 1; a3++) for (var o3 = a3 + 1; o3 < t5.length; o3++) t5[0].length === 2 ? (r3 = [t5[a3][0], t5[a3][1]], i3 = [t5[o3][0], t5[o3][1]]) : t5[0].length === 3 && (r3 = [t5[a3][0], t5[a3][1], t5[a3][2]], i3 = [t5[o3][0], t5[o3][1], t5[o3][2]]), n3.push(x2(r3, i3));
    return n3;
  }
}), name$66$1 = `intersect`, dependencies$66$1 = [`typed`, `config`, `abs`, `add`, `addScalar`, `matrix`, `multiply`, `multiplyScalar`, `divideScalar`, `subtract`, `smaller`, `equalScalar`, `flatten`, `isZero`, `isNumeric`], createIntersect$1 = factory$1(name$66$1, dependencies$66$1, (t4) => {
  var { typed: n2, config: r2, abs: i2, add: a2, addScalar: o2, matrix: s2, multiply: c2, multiplyScalar: l2, divideScalar: u2, subtract: d2, smaller: p2, equalScalar: m2, flatten: h2, isZero: g2, isNumeric: v2 } = t4;
  return n2(`intersect`, { "Array, Array, Array": y2, "Array, Array, Array, Array": b2, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var i3 = y2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return i3 === null ? null : s2(i3);
  }, "Matrix, Matrix, Matrix, Matrix": function(t5, n3, r3, i3) {
    var a3 = b2(t5.valueOf(), n3.valueOf(), r3.valueOf(), i3.valueOf());
    return a3 === null ? null : s2(a3);
  } });
  function y2(t5, n3, r3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), !w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
    if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
    if (!E(r3)) throw TypeError(`Array with 4 numbers expected as third argument`);
    return M2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], r3[3]);
  }
  function b2(t5, n3, r3, i3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), i3 = x2(i3), t5.length === 2) {
      if (!S2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!S2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!S2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (!S2(i3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for fourth argument`);
      return D(t5, n3, r3, i3);
    } else if (t5.length === 3) {
      if (!w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      if (!w2(r3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for third argument`);
      if (!w2(i3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for fourth argument`);
      return j2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], i3[0], i3[1], i3[2]);
    } else throw TypeError(`Arrays with two or thee dimensional points expected`);
  }
  function x2(t5) {
    return t5.length === 1 ? t5[0] : t5.length > 1 && Array.isArray(t5[0]) && t5.every((t6) => Array.isArray(t6) && t6.length === 1) ? h2(t5) : t5;
  }
  function S2(t5) {
    return t5.length === 2 && v2(t5[0]) && v2(t5[1]);
  }
  function w2(t5) {
    return t5.length === 3 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]);
  }
  function E(t5) {
    return t5.length === 4 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]) && v2(t5[3]);
  }
  function D(t5, n3, s3, m3) {
    var h3 = t5, v3 = s3, y3 = d2(h3, n3), b3 = d2(v3, m3), x3 = d2(l2(y3[0], b3[1]), l2(b3[0], y3[1]));
    if (g2(x3) || p2(i2(x3), r2.relTol)) return null;
    var S3 = l2(b3[0], h3[1]), w3 = l2(b3[1], h3[0]), E2 = l2(b3[0], v3[1]), D2 = l2(b3[1], v3[0]);
    return a2(c2(y3, u2(o2(d2(d2(S3, w3), E2), D2), x3)), h3);
  }
  function O2(t5, n3, r3, i3, a3, s3, c3, u3, p3, m3, h3, g3) {
    var v3 = l2(d2(t5, n3), d2(r3, i3)), y3 = l2(d2(a3, s3), d2(c3, u3)), b3 = l2(d2(p3, m3), d2(h3, g3));
    return o2(o2(v3, y3), b3);
  }
  function j2(t5, n3, r3, i3, a3, s3, c3, p3, h3, v3, y3, b3) {
    var x3 = O2(t5, c3, v3, c3, n3, p3, y3, p3, r3, h3, b3, h3), S3 = O2(v3, c3, i3, t5, y3, p3, a3, n3, b3, h3, s3, r3), w3 = O2(t5, c3, i3, t5, n3, p3, a3, n3, r3, h3, s3, r3), E2 = O2(v3, c3, v3, c3, y3, p3, y3, p3, b3, h3, b3, h3), D2 = O2(i3, t5, i3, t5, a3, n3, a3, n3, s3, r3, s3, r3), j3 = d2(l2(x3, S3), l2(w3, E2)), M3 = d2(l2(D2, E2), l2(S3, S3));
    if (g2(M3)) return null;
    var N2 = u2(j3, M3), F = u2(o2(x3, l2(N2, S3)), E2), I2 = o2(t5, l2(N2, d2(i3, t5))), L2 = o2(n3, l2(N2, d2(a3, n3))), R2 = o2(r3, l2(N2, d2(s3, r3))), z2 = o2(c3, l2(F, d2(v3, c3))), V2 = o2(p3, l2(F, d2(y3, p3))), H2 = o2(h3, l2(F, d2(b3, h3)));
    return m2(I2, z2) && m2(L2, V2) && m2(R2, H2) ? [I2, L2, R2] : null;
  }
  function M2(t5, n3, r3, i3, a3, s3, c3, p3, m3, h3) {
    var g3 = l2(t5, c3), v3 = l2(i3, c3), y3 = l2(n3, p3), b3 = l2(a3, p3), x3 = l2(r3, m3), S3 = l2(s3, m3), w3 = u2(d2(d2(d2(h3, g3), y3), x3), d2(d2(d2(o2(o2(v3, b3), S3), g3), y3), x3));
    return [o2(t5, l2(w3, d2(i3, t5))), o2(n3, l2(w3, d2(a3, n3))), o2(r3, l2(w3, d2(s3, r3)))];
  }
}), name$65$1 = `sum`, dependencies$65$1 = [`typed`, `config`, `add`, `numeric`], createSum$1 = factory$1(name$65$1, dependencies$65$1, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4;
  return n2(name$65$1, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": s2, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`Scalar values expected in function sum`);
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    return deepForEach$2(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage$1(n4, `sum`, t6);
      }
    }), n3 === void 0 && (n3 = a2(0, r2.number)), typeof n3 == `string` && (n3 = a2(n3, safeNumberType$1(n3, r2))), n3;
  }
  function s2(t5, n3) {
    try {
      return reduce$1$1(t5, n3, i2);
    } catch (t6) {
      throw improveErrorMessage$1(t6, `sum`);
    }
  }
}), name$64$1 = `cumsum`, dependencies$64$1 = [`typed`, `add`, `unaryPlus`], createCumSum$1 = factory$1(name$64$1, dependencies$64$1, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4;
  return n2(name$64$1, { Array: a2, Matrix: function(t5) {
    return t5.create(a2(t5.valueOf(), t5.datatype()));
  }, "Array, number | BigNumber": s2, "Matrix, number | BigNumber": function(t5, n3) {
    return t5.create(s2(t5.valueOf(), n3), t5.datatype());
  }, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`All values expected to be scalar in function cumsum`);
    return a2(t5);
  } });
  function a2(t5) {
    try {
      return o2(t5);
    } catch (t6) {
      throw improveErrorMessage$1(t6, name$64$1);
    }
  }
  function o2(t5) {
    if (t5.length === 0) return [];
    for (var n3 = [i2(t5[0])], a3 = 1; a3 < t5.length; ++a3) n3.push(r2(n3[a3 - 1], t5[a3]));
    return n3;
  }
  function s2(t5, n3) {
    var r3 = arraySize$1(t5);
    if (n3 < 0 || n3 >= r3.length) throw new IndexError$1(n3, r3.length);
    try {
      return c2(t5, n3);
    } catch (t6) {
      throw improveErrorMessage$1(t6, name$64$1);
    }
  }
  function c2(t5, n3) {
    var r3, i3, a3;
    if (n3 <= 0) {
      var s3 = t5[0][0];
      if (Array.isArray(s3)) {
        for (a3 = _switch$1$1(t5), i3 = [], r3 = 0; r3 < a3.length; r3++) i3[r3] = c2(a3[r3], n3 - 1);
        return i3;
      } else return o2(t5);
    } else {
      for (i3 = [], r3 = 0; r3 < t5.length; r3++) i3[r3] = c2(t5[r3], n3 - 1);
      return i3;
    }
  }
}), name$63$1 = `mean`, dependencies$63$1 = [`typed`, `add`, `divide`], createMean$1 = factory$1(name$63$1, dependencies$63$1, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4;
  return n2(name$63$1, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": a2, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`Scalar values expected in function mean`);
    return o2(t5);
  } });
  function a2(t5, n3) {
    try {
      return i2(reduce$1$1(t5, n3, r2), (Array.isArray(t5) ? arraySize$1(t5) : t5.size())[n3]);
    } catch (t6) {
      throw improveErrorMessage$1(t6, `mean`);
    }
  }
  function o2(t5) {
    var n3, a3 = 0;
    if (deepForEach$2(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : r2(n3, t6), a3++;
      } catch (n4) {
        throw improveErrorMessage$1(n4, `mean`, t6);
      }
    }), a3 === 0) throw Error(`Cannot calculate the mean of an empty array`);
    return i2(n3, a3);
  }
}), name$62$1 = `median`, dependencies$62$1 = [`typed`, `add`, `divide`, `compare`, `partitionSelect`], createMedian$1 = factory$1(name$62$1, dependencies$62$1, (t4) => {
  var { typed: n2, add: r2, divide: i2, compare: a2, partitionSelect: o2 } = t4;
  function s2(t5) {
    try {
      t5 = flatten$4$1(t5.valueOf());
      var n3 = t5.length;
      if (n3 === 0) throw Error(`Cannot calculate median of an empty array`);
      if (n3 % 2 == 0) {
        for (var r3 = n3 / 2 - 1, i3 = o2(t5, r3 + 1), s3 = t5[r3], u2 = 0; u2 < r3; ++u2) a2(t5[u2], s3) > 0 && (s3 = t5[u2]);
        return l2(s3, i3);
      } else return c2(o2(t5, (n3 - 1) / 2));
    } catch (t6) {
      throw improveErrorMessage$1(t6, `median`);
    }
  }
  var c2 = n2({ "number | BigNumber | Complex | Unit": function(t5) {
    return t5;
  } }), l2 = n2({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(t5, n3) {
    return i2(r2(t5, n3), 2);
  } });
  return n2(name$62$1, { "Array | Matrix": s2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`median(A, dim) is not yet supported`);
  }, "...": function(t5) {
    if (containsCollections$1(t5)) throw TypeError(`Scalar values expected in function median`);
    return s2(t5);
  } });
}), name$61$1 = `mad`, dependencies$61$1 = [`typed`, `abs`, `map`, `median`, `subtract`], createMad$1 = factory$1(name$61$1, dependencies$61$1, (t4) => {
  var { typed: n2, abs: r2, map: i2, median: a2, subtract: o2 } = t4;
  return n2(name$61$1, { "Array | Matrix": s2, "...": function(t5) {
    return s2(t5);
  } });
  function s2(t5) {
    if (t5 = flatten$4$1(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate median absolute deviation (mad) of an empty array`);
    try {
      var n3 = a2(t5);
      return a2(i2(t5, function(t6) {
        return r2(o2(t6, n3));
      }));
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(`median`) ? TypeError(t6.message.replace(`median`, `mad`)) : improveErrorMessage$1(t6, `mad`);
    }
  }
}), DEFAULT_NORMALIZATION$1 = `unbiased`, name$60$1 = `variance`, dependencies$60$1 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVariance$1 = factory$1(name$60$1, dependencies$60$1, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4;
  return n2(name$60$1, { "Array | Matrix": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION$1);
  }, "Array | Matrix, string": l2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return u2(t5, n3, DEFAULT_NORMALIZATION$1);
  }, "Array | Matrix, number | BigNumber, string": u2, "...": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION$1);
  } });
  function l2(t5, n3) {
    var s3, l3 = 0;
    if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
    if (deepForEach$2(t5, function(t6) {
      try {
        s3 = s3 === void 0 ? t6 : r2(s3, t6), l3++;
      } catch (n4) {
        throw improveErrorMessage$1(n4, `variance`, t6);
      }
    }), l3 === 0) throw Error(`Cannot calculate variance of an empty array`);
    var u3 = o2(s3, l3);
    if (s3 = void 0, deepForEach$2(t5, function(t6) {
      var n4 = i2(t6, u3);
      s3 = s3 === void 0 ? a2(n4, n4) : r2(s3, a2(n4, n4));
    }), c2(s3)) return s3;
    switch (n3) {
      case `uncorrected`:
        return o2(s3, l3);
      case `biased`:
        return o2(s3, l3 + 1);
      case `unbiased`:
        var d2 = isBigNumber$1(s3) ? s3.mul(0) : 0;
        return l3 === 1 ? d2 : o2(s3, l3 - 1);
      default:
        throw Error(`Unknown normalization "` + n3 + `". Choose "unbiased" (default), "uncorrected", or "biased".`);
    }
  }
  function u2(t5, n3, r3) {
    try {
      if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
      return s2(t5, n3, (t6) => l2(t6, r3));
    } catch (t6) {
      throw improveErrorMessage$1(t6, `variance`);
    }
  }
}), name$59$1 = `quantileSeq`, dependencies$59$1 = [`typed`, `?bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeq$1 = factory$1(name$59$1, dependencies$59$1, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4;
  return n2(name$59$1, { "Array | Matrix, number | BigNumber": (t5, n3) => v2(t5, n3, false), "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, false, r3, v2), "Array | Matrix, number | BigNumber, boolean": v2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, v2), "Array | Matrix, Array | Matrix": (t5, n3) => y2(t5, n3, false), "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, false, r3, y2), "Array | Matrix, Array | Matrix, boolean": y2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, y2) });
  function g2(t5, n3, r3, i3, a3) {
    return h2(t5, i3, (t6) => a3(t6, n3, r3));
  }
  function v2(t5, n3, a3) {
    var s3, c3 = t5.valueOf();
    if (d2(n3, 0)) throw Error(`N/prob must be non-negative`);
    if (p2(n3, 1)) return isNumber$1(n3) ? b2(c3, n3, a3) : r2(b2(c3, n3, a3));
    if (m2(n3, 1)) {
      if (!u2(n3)) throw Error(`N must be a positive integer`);
      if (m2(n3, 4294967295)) throw Error(`N must be less than or equal to 2^32-1, as that is the maximum length of an Array`);
      var l3 = i2(n3, 1);
      s3 = [];
      for (var h3 = 0; d2(h3, n3); h3++) {
        var g3 = o2(h3 + 1, l3);
        s3.push(b2(c3, g3, a3));
      }
      return isNumber$1(n3) ? s3 : r2(s3);
    }
  }
  function y2(t5, n3, r3) {
    for (var i3 = t5.valueOf(), a3 = n3.valueOf(), o3 = [], s3 = 0; s3 < a3.length; ++s3) o3.push(b2(i3, a3[s3], r3));
    return o3;
  }
  function b2(t5, n3, r3) {
    var o3 = flatten$4$1(t5), d3 = o3.length;
    if (d3 === 0) throw Error(`Cannot calculate quantile of an empty sequence`);
    var p3 = isNumber$1(n3) ? n3 * (d3 - 1) : n3.times(d3 - 1), m3 = isNumber$1(n3) ? Math.floor(p3) : p3.floor().toNumber(), h3 = isNumber$1(n3) ? p3 % 1 : p3.minus(m3);
    if (u2(p3)) return r3 ? o3[p3] : c2(o3, isNumber$1(n3) ? p3 : p3.valueOf());
    var g3, v3;
    if (r3) g3 = o3[m3], v3 = o3[m3 + 1];
    else {
      v3 = c2(o3, m3 + 1), g3 = o3[m3];
      for (var y3 = 0; y3 < m3; ++y3) l2(o3[y3], g3) > 0 && (g3 = o3[y3]);
    }
    return i2(s2(g3, a2(1, h3)), s2(v3, h3));
  }
}), name$58$1 = `std`, dependencies$58$1 = [`typed`, `map`, `sqrt`, `variance`], createStd$1 = factory$1(name$58$1, dependencies$58$1, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4;
  return n2(name$58$1, { "Array | Matrix": o2, "Array | Matrix, string": o2, "Array | Matrix, number | BigNumber": o2, "Array | Matrix, number | BigNumber, string": o2, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5, n3) {
    if (t5.length === 0) throw SyntaxError(`Function std requires one or more parameters (0 provided)`);
    try {
      var o3 = a2.apply(null, arguments);
      return isCollection$1(o3) ? r2(o3, i2) : i2(o3);
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(` variance`) ? TypeError(t6.message.replace(` variance`, ` std`)) : t6;
    }
  }
}), name$57$1 = `corr`, dependencies$57$1 = [`typed`, `matrix`, `mean`, `sqrt`, `sum`, `add`, `subtract`, `multiply`, `pow`, `divide`], createCorr$1 = factory$1(name$57$1, dependencies$57$1, (t4) => {
  var { typed: n2, matrix: r2, sqrt: i2, sum: a2, add: o2, subtract: s2, multiply: c2, pow: l2, divide: u2 } = t4;
  return n2(name$57$1, { "Array, Array": function(t5, n3) {
    return d2(t5, n3);
  }, "Matrix, Matrix": function(t5, n3) {
    var i3 = d2(t5.toArray(), n3.toArray());
    return Array.isArray(i3) ? r2(i3) : i3;
  } });
  function d2(t5, n3) {
    var r3 = [];
    if (Array.isArray(t5[0]) && Array.isArray(n3[0])) {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same length.`);
      for (var i3 = 0; i3 < t5.length; i3++) {
        if (t5[i3].length !== n3[i3].length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
        r3.push(p2(t5[i3], n3[i3]));
      }
      return r3;
    } else {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
      return p2(t5, n3);
    }
  }
  function p2(t5, n3) {
    var r3 = t5.length, d3 = a2(t5), p3 = a2(n3), m2 = t5.reduce((t6, r4, i3) => o2(t6, c2(r4, n3[i3])), 0), h2 = a2(t5.map((t6) => l2(t6, 2))), g2 = a2(n3.map((t6) => l2(t6, 2)));
    return u2(s2(c2(r3, m2), c2(d3, p3)), i2(c2(s2(c2(r3, h2), l2(d3, 2)), s2(c2(r3, g2), l2(p3, 2)))));
  }
}), name$56$1 = `bernoulli`, dependencies$56$1 = [`typed`, `config`, `isInteger`, `number`, `?BigNumber`, `?Fraction`], createBernoulli$1 = factory$1(name$56$1, dependencies$56$1, (t4) => {
  var { typed: n2, config: r2, number: i2, BigNumber: a2, Fraction: o2 } = t4, s2 = [void 0], c2 = [void 0], l2 = [void 0], u2 = 50;
  return n2(name$56$1, { number: (t5) => _bernoulli$1(t5, (t6) => t6, s2, (t6, n3) => t6 + n3, (t6, n3) => t6 * n3, (t6, n3) => t6 / n3), "bigint | Fraction": (t5) => _bernoulli$1(i2(t5), (t6) => new o2(t6), c2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3)), BigNumber: (t5) => (r2.precision !== u2 && (l2 = [void 0], u2 = r2.precision), _bernoulli$1(i2(t5), (t6) => new a2(t6), l2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3))) });
});
function _bernoulli$1(t4, n2, r2, i2, a2, o2) {
  if (t4 < 0 || !isInteger$2(t4)) throw RangeError(`Bernoulli index must be nonnegative integer`);
  if (t4 === 0) return n2(1);
  if (t4 === 1) return o2(n2(-1), n2(2));
  if (t4 % 2 == 1) return n2(0);
  var s2 = n2(1);
  r2.length === 1 && r2.push([o2(s2, n2(-3)), o2(s2, n2(-2)), o2(s2, n2(6))]);
  for (var c2 = t4 / 2, l2 = n2(0), u2 = n2(2); r2.length <= c2; ) {
    for (var d2 = r2.length, p2 = Math.floor((d2 + 1) / 2), m2 = l2, h2 = 1; h2 < p2; ++h2) m2 = i2(m2, a2(r2[h2][0], r2[d2 - h2][0]));
    m2 = a2(m2, u2), d2 % 2 == 0 && (m2 = i2(m2, a2(r2[p2][0], r2[p2][0]))), m2 = o2(m2, n2(-(2 * d2 + 1)));
    var g2 = o2(a2(r2[d2 - 1][1], n2(-d2 * (2 * d2 - 1))), u2);
    r2.push([m2, g2, a2(g2, m2)]);
  }
  return r2[c2][2];
}
var name$55$1 = `combinations`, dependencies$55$1 = [`typed`], createCombinations$1 = factory$1(name$55$1, dependencies$55$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$55$1, { "number, number": combinationsNumber$1, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = t5.minus(n3), s2 = new r2(1);
    if (!isPositiveInteger$2$1(t5) || !isPositiveInteger$2$1(n3)) throw TypeError(`Positive integer value expected in function combinations`);
    if (n3.gt(t5)) throw TypeError(`k must be less than n in function combinations`);
    if (i2 = s2, n3.lt(o2)) for (a2 = s2; a2.lte(o2); a2 = a2.plus(s2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = s2; a2.lte(n3); a2 = a2.plus(s2)) i2 = i2.times(o2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$2$1(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$54$1 = `combinationsWithRep`, dependencies$54$1 = [`typed`], createCombinationsWithRep$1 = factory$1(name$54$1, dependencies$54$1, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$54$1, { "number, number": function(t5, n3) {
    if (!isInteger$2(t5) || t5 < 0 || !isInteger$2(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5 < 1) throw TypeError(`k must be less than or equal to n + k - 1`);
    return n3 < t5 - 1 ? product$2(t5, t5 + n3 - 1) / product$2(1, n3) : product$2(n3 + 1, t5 + n3 - 1) / product$2(1, t5 - 1);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = new r2(1), s2 = t5.minus(o2);
    if (!isPositiveInteger$1$1(t5) || !isPositiveInteger$1$1(n3)) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5.lt(o2)) throw TypeError(`k must be less than or equal to n + k - 1 in function combinationsWithRep`);
    if (i2 = o2, n3.lt(s2)) for (a2 = o2; a2.lte(s2); a2 = a2.plus(o2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = o2; a2.lte(n3); a2 = a2.plus(o2)) i2 = i2.times(s2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$1$1(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$53$1 = `gamma`, dependencies$53$1 = [`typed`, `config`, `multiplyScalar`, `pow`, `BigNumber`, `Complex`], createGamma$1 = factory$1(name$53$1, dependencies$53$1, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, pow: a2, BigNumber: o2, Complex: s2 } = t4;
  function c2(t5) {
    if (t5.im === 0) return gammaNumber$1(t5.re);
    if (t5.re < 0.5) {
      var n3 = new s2(1 - t5.re, -t5.im), r3 = new s2(Math.PI * t5.re, Math.PI * t5.im);
      return new s2(Math.PI).div(r3.sin()).div(c2(n3));
    }
    t5 = new s2(t5.re - 1, t5.im);
    for (var i3 = new s2(gammaP$1[0], 0), a3 = 1; a3 < gammaP$1.length; ++a3) {
      var o3 = new s2(gammaP$1[a3], 0);
      i3 = i3.add(o3.div(t5.add(a3)));
    }
    var l3 = new s2(t5.re + gammaG$1 + 0.5, t5.im), u2 = Math.sqrt(2 * Math.PI), d2 = l3.pow(t5.add(0.5)), p2 = l3.neg().exp();
    return i3.mul(u2).mul(d2).mul(p2);
  }
  return n2(name$53$1, { number: gammaNumber$1, Complex: c2, BigNumber: function(t5) {
    if (t5.isInteger()) return t5.isNegative() || t5.isZero() ? new o2(1 / 0) : l2(t5.minus(1));
    if (!t5.isFinite()) return new o2(t5.isNegative() ? NaN : 1 / 0);
    throw Error(`Integer BigNumber expected`);
  } });
  function l2(t5) {
    if (t5 < 8) return new o2([1, 1, 2, 6, 24, 120, 720, 5040][t5]);
    var n3 = r2.precision + (Math.log(t5.toNumber()) | 0), i3 = o2.clone({ precision: n3 });
    if (t5 % 2 == 1) return t5.times(l2(new o2(t5 - 1)));
    for (var a3 = t5, s3 = new i3(t5), c3 = t5.toNumber(); a3 > 2; ) a3 -= 2, c3 += a3, s3 = s3.times(c3);
    return new o2(s3.toPrecision(o2.precision));
  }
}), name$52$1 = `lgamma`, dependencies$52$1 = [`Complex`, `typed`], createLgamma$1 = factory$1(name$52$1, dependencies$52$1, (t4) => {
  var { Complex: n2, typed: r2 } = t4, i2 = 7, a2 = 7, o2 = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return r2(name$52$1, { number: lgammaNumber$1, Complex: s2, BigNumber: function() {
    throw Error(`mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber`);
  } });
  function s2(t5) {
    var r3 = 6.283185307179586, o3 = 1.1447298858494002, u2 = 0.1;
    if (t5.isNaN()) return new n2(NaN, NaN);
    if (t5.im === 0) return new n2(lgammaNumber$1(t5.re), 0);
    if (t5.re >= i2 || Math.abs(t5.im) >= a2) return c2(t5);
    if (t5.re <= u2) {
      var d2 = copysign$1(r3, t5.im) * Math.floor(0.5 * t5.re + 0.25), p2 = t5.mul(Math.PI).sin().log(), m2 = s2(new n2(1 - t5.re, -t5.im));
      return new n2(o3, d2).sub(p2).sub(m2);
    } else if (t5.im >= 0) return l2(t5);
    else return l2(t5.conjugate()).conjugate();
  }
  function c2(t5) {
    for (var r3 = t5.sub(0.5).mul(t5.log()).sub(t5).add(lnSqrt2PI$1), i3 = new n2(1, 0).div(t5), a3 = i3.div(t5), s3 = o2[0], c3 = o2[1], l3 = 2 * a3.re, u2 = a3.re * a3.re + a3.im * a3.im, d2 = 2; d2 < 8; d2++) {
      var p2 = c3;
      c3 = -u2 * s3 + o2[d2], s3 = l3 * s3 + p2;
    }
    var m2 = i3.mul(a3.mul(s3).add(c3));
    return r3.add(m2);
  }
  function l2(t5) {
    var r3 = 0, a3 = 0, o3 = t5;
    for (t5 = t5.add(1); t5.re <= i2; ) {
      o3 = o3.mul(t5);
      var s3 = +(o3.im < 0);
      s3 !== 0 && a3 === 0 && r3++, a3 = s3, t5 = t5.add(1);
    }
    return c2(t5).sub(o3.log()).sub(new n2(0, r3 * 2 * Math.PI * 1));
  }
}), name$51$1 = `factorial`, dependencies$51$1 = [`typed`, `gamma`], createFactorial$1 = factory$1(name$51$1, dependencies$51$1, (t4) => {
  var { typed: n2, gamma: r2 } = t4;
  return n2(name$51$1, { number: function(t5) {
    if (t5 < 0) throw Error(`Value must be non-negative`);
    return r2(t5 + 1);
  }, BigNumber: function(t5) {
    if (t5.isNegative()) throw Error(`Value must be non-negative`);
    return r2(t5.plus(1));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$50$1 = `kldivergence`, dependencies$50$1 = [`typed`, `matrix`, `divide`, `sum`, `multiply`, `map`, `dotDivide`, `log`, `isNumeric`], createKldivergence$1 = factory$1(name$50$1, dependencies$50$1, (t4) => {
  var { typed: n2, matrix: r2, divide: i2, sum: a2, multiply: o2, map: s2, dotDivide: c2, log: l2, isNumeric: u2 } = t4;
  return n2(name$50$1, { "Array, Array": function(t5, n3) {
    return d2(r2(t5), r2(n3));
  }, "Matrix, Array": function(t5, n3) {
    return d2(t5, r2(n3));
  }, "Array, Matrix": function(t5, n3) {
    return d2(r2(t5), n3);
  }, "Matrix, Matrix": function(t5, n3) {
    return d2(t5, n3);
  } });
  function d2(t5, n3) {
    var r3 = n3.size().length, d3 = t5.size().length;
    if (r3 > 1) throw Error(`first object must be one dimensional`);
    if (d3 > 1) throw Error(`second object must be one dimensional`);
    if (r3 !== d3) throw Error(`Length of two vectors must be equal`);
    if (a2(t5) === 0) throw Error(`Sum of elements in first object must be non zero`);
    if (a2(n3) === 0) throw Error(`Sum of elements in second object must be non zero`);
    var p2 = i2(t5, a2(t5)), m2 = a2(o2(p2, s2(c2(p2, i2(n3, a2(n3))), (t6) => l2(t6))));
    return u2(m2) ? m2 : NaN;
  }
}), name$49$1 = `multinomial`, dependencies$49$1 = [`typed`, `add`, `divide`, `multiply`, `factorial`, `isInteger`, `isPositive`], createMultinomial$1 = factory$1(name$49$1, dependencies$49$1, (t4) => {
  var { typed: n2, add: r2, divide: i2, multiply: a2, factorial: o2, isInteger: s2, isPositive: c2 } = t4;
  return n2(name$49$1, { "Array | Matrix": function(t5) {
    var n3 = 0, l2 = 1;
    return deepForEach$2(t5, function(t6) {
      if (!s2(t6) || !c2(t6)) throw TypeError(`Positive integer value expected in function multinomial`);
      n3 = r2(n3, t6), l2 = a2(l2, o2(t6));
    }), i2(o2(n3), l2);
  } });
}), name$48$1 = `permutations`, dependencies$48$1 = [`typed`, `factorial`], createPermutations$1 = factory$1(name$48$1, dependencies$48$1, (t4) => {
  var { typed: n2, factorial: r2 } = t4;
  return n2(name$48$1, { "number | BigNumber": r2, "number, number": function(t5, n3) {
    if (!isInteger$2(t5) || t5 < 0 || !isInteger$2(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3 > t5) throw TypeError(`second argument k must be less than or equal to first argument n`);
    return product$2(t5 - n3 + 1, t5);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3, i2;
    if (!isPositiveInteger$3(t5) || !isPositiveInteger$3(n3)) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3.gt(t5)) throw TypeError(`second argument k must be less than or equal to first argument n`);
    for (r3 = t5.mul(0).add(1), i2 = t5.minus(n3).plus(1); i2.lte(t5); i2 = i2.plus(1)) r3 = r3.times(i2);
    return r3;
  } });
});
function isPositiveInteger$3(t4) {
  return t4.isInteger() && t4.gte(0);
}
var require_alea$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = s2();
      n4.next = function() {
        var t7 = 2091639 * n4.s0 + n4.c * 23283064365386963e-26;
        return n4.s0 = n4.s1, n4.s1 = n4.s2, n4.s2 = t7 - (n4.c = t7 | 0);
      }, n4.c = 1, n4.s0 = r3(` `), n4.s1 = r3(` `), n4.s2 = r3(` `), n4.s0 -= r3(t6), n4.s0 < 0 && (n4.s0 += 1), n4.s1 -= r3(t6), n4.s1 < 0 && (n4.s1 += 1), n4.s2 -= r3(t6), n4.s2 < 0 && (n4.s2 += 1), r3 = null;
    }
    function a2(t6, n4) {
      return n4.c = t6.c, n4.s0 = t6.s0, n4.s1 = t6.s1, n4.s2 = t6.s2, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s3 = r3.next;
      return s3.int32 = function() {
        return r3.next() * 4294967296 | 0;
      }, s3.double = function() {
        return s3() + (s3() * 2097152 | 0) * 11102230246251565e-32;
      }, s3.quick = s3, o3 && (typeof o3 == `object` && a2(o3, r3), s3.state = function() {
        return a2(r3, {});
      }), s3;
    }
    function s2() {
      var t6 = 4022871197;
      return function(n4) {
        n4 = String(n4);
        for (var r3 = 0; r3 < n4.length; r3++) {
          t6 += n4.charCodeAt(r3);
          var i3 = 0.02519603282416938 * t6;
          t6 = i3 >>> 0, i3 -= t6, i3 *= t6, t6 = i3 >>> 0, i3 -= t6, t6 += i3 * 4294967296;
        }
        return (t6 >>> 0) * 23283064365386963e-26;
      };
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.alea = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor128$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.next = function() {
        var t7 = n4.x ^ n4.x << 11;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w ^= n4.w >>> 19 ^ t7 ^ t7 >>> 8;
      }, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor128 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorwow$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.x ^ n4.x >>> 2;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w = n4.v, (n4.d = n4.d + 362437 | 0) + (n4.v = n4.v ^ n4.v << 4 ^ (t7 ^ t7 << 1)) | 0;
      }, n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.v = 0, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, i3 == r3.length && (n4.d = n4.x << 10 ^ n4.x >>> 4), n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4.v = t6.v, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorwow = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorshift7$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.x, r4 = n4.i, i3 = t7[r4], a3;
        return i3 ^= i3 >>> 7, a3 = i3 ^ i3 << 24, i3 = t7[r4 + 1 & 7], a3 ^= i3 ^ i3 >>> 10, i3 = t7[r4 + 3 & 7], a3 ^= i3 ^ i3 >>> 3, i3 = t7[r4 + 4 & 7], a3 ^= i3 ^ i3 << 7, i3 = t7[r4 + 7 & 7], i3 ^= i3 << 13, a3 ^= i3 ^ i3 << 9, t7[r4] = a3, n4.i = r4 + 1 & 7, a3;
      };
      function r3(t7, n5) {
        var r4, i3 = [];
        if (n5 === (n5 | 0)) i3[0] = n5;
        else for (n5 = `` + n5, r4 = 0; r4 < n5.length; ++r4) i3[r4 & 7] = i3[r4 & 7] << 15 ^ n5.charCodeAt(r4) + i3[r4 + 1 & 7] << 13;
        for (; i3.length < 8; ) i3.push(0);
        for (r4 = 0; r4 < 8 && i3[r4] === 0; ++r4) ;
        for (r4 == 8 ? i3[7] = -1 : i3[r4], t7.x = i3, t7.i = 0, r4 = 256; r4 > 0; --r4) t7.next();
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.x = t6.x.slice(), n4.i = t6.i, n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.x && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorshift7 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor4096$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.w, r4 = n4.X, i3 = n4.i, a3, o3;
        return n4.w = t7 = t7 + 1640531527 | 0, o3 = r4[i3 + 34 & 127], a3 = r4[i3 = i3 + 1 & 127], o3 ^= o3 << 13, a3 ^= a3 << 17, o3 ^= o3 >>> 15, a3 ^= a3 >>> 12, o3 = r4[i3] = o3 ^ a3, n4.i = i3, o3 + (t7 ^ t7 >>> 16) | 0;
      };
      function r3(t7, n5) {
        var r4, i3, a3, o3, s2, c2 = [], l2 = 128;
        for (n5 === (n5 | 0) ? (i3 = n5, n5 = null) : (n5 += `\0`, i3 = 0, l2 = Math.max(l2, n5.length)), a3 = 0, o3 = -32; o3 < l2; ++o3) n5 && (i3 ^= n5.charCodeAt((o3 + 32) % n5.length)), o3 === 0 && (s2 = i3), i3 ^= i3 << 10, i3 ^= i3 >>> 15, i3 ^= i3 << 4, i3 ^= i3 >>> 13, o3 >= 0 && (s2 = s2 + 1640531527 | 0, r4 = c2[o3 & 127] ^= i3 + s2, a3 = r4 == 0 ? a3 + 1 : 0);
        for (a3 >= 128 && (c2[(n5 && n5.length || 0) & 127] = -1), a3 = 127, o3 = 512; o3 > 0; --o3) i3 = c2[a3 + 34 & 127], r4 = c2[a3 = a3 + 1 & 127], i3 ^= i3 << 13, r4 ^= r4 << 17, i3 ^= i3 >>> 15, r4 ^= r4 >>> 12, c2[a3] = i3 ^ r4;
        t7.w = s2, t7.X = c2, t7.i = a3;
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.i = t6.i, n4.w = t6.w, n4.X = t6.X.slice(), n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.X && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor4096 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_tychei$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.b, r4 = n4.c, i4 = n4.d, a3 = n4.a;
        return t7 = t7 << 25 ^ t7 >>> 7 ^ r4, r4 = r4 - i4 | 0, i4 = i4 << 24 ^ i4 >>> 8 ^ a3, a3 = a3 - t7 | 0, n4.b = t7 = t7 << 20 ^ t7 >>> 12 ^ r4, n4.c = r4 = r4 - i4 | 0, n4.d = i4 << 16 ^ r4 >>> 16 ^ a3, n4.a = a3 - t7 | 0;
      }, n4.a = 0, n4.b = 0, n4.c = -1640531527, n4.d = 1367130551, t6 === Math.floor(t6) ? (n4.a = t6 / 4294967296 | 0, n4.b = t6 | 0) : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 20; i3++) n4.b ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.a = t6.a, n4.b = t6.b, n4.c = t6.c, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.tychei = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require___vite_browser_external$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = {};
})), require_seedrandom$1$1 = __commonJSMin$1(((t4, n2) => {
  (function(t5, r2, i2) {
    var a2 = 256, o2 = 6, s2 = 52, c2 = `random`, l2 = i2.pow(a2, o2), u2 = i2.pow(2, s2), d2 = u2 * 2, p2 = a2 - 1, m2;
    function h2(t6, n3, s3) {
      var p3 = [];
      n3 = n3 == 1 ? { entropy: true } : n3 || {};
      var m3 = b2(y2(n3.entropy ? [t6, S2(r2)] : t6 ?? x2(), 3), p3), h3 = new g2(p3), w2 = function() {
        for (var t7 = h3.g(o2), n4 = l2, r3 = 0; t7 < u2; ) t7 = (t7 + r3) * a2, n4 *= a2, r3 = h3.g(1);
        for (; t7 >= d2; ) t7 /= 2, n4 /= 2, r3 >>>= 1;
        return (t7 + r3) / n4;
      };
      return w2.int32 = function() {
        return h3.g(4) | 0;
      }, w2.quick = function() {
        return h3.g(4) / 4294967296;
      }, w2.double = w2, b2(S2(h3.S), r2), (n3.pass || s3 || function(t7, n4, r3, a3) {
        return a3 && (a3.S && v2(a3, h3), t7.state = function() {
          return v2(h3, {});
        }), r3 ? (i2[c2] = t7, n4) : t7;
      })(w2, m3, `global` in n3 ? n3.global : this == i2, n3.state);
    }
    function g2(t6) {
      var n3, r3 = t6.length, i3 = this, o3 = 0, s3 = i3.i = i3.j = 0, c3 = i3.S = [];
      for (r3 || (t6 = [r3++]); o3 < a2; ) c3[o3] = o3++;
      for (o3 = 0; o3 < a2; o3++) c3[o3] = c3[s3 = p2 & s3 + t6[o3 % r3] + (n3 = c3[o3])], c3[s3] = n3;
      (i3.g = function(t7) {
        for (var n4, r4 = 0, o4 = i3.i, s4 = i3.j, c4 = i3.S; t7--; ) n4 = c4[o4 = p2 & o4 + 1], r4 = r4 * a2 + c4[p2 & (c4[o4] = c4[s4 = p2 & s4 + n4]) + (c4[s4] = n4)];
        return i3.i = o4, i3.j = s4, r4;
      })(a2);
    }
    function v2(t6, n3) {
      return n3.i = t6.i, n3.j = t6.j, n3.S = t6.S.slice(), n3;
    }
    function y2(t6, n3) {
      var r3 = [], i3 = typeof t6, a3;
      if (n3 && i3 == `object`) for (a3 in t6) try {
        r3.push(y2(t6[a3], n3 - 1));
      } catch {
      }
      return r3.length ? r3 : i3 == `string` ? t6 : t6 + `\0`;
    }
    function b2(t6, n3) {
      for (var r3 = t6 + ``, i3, a3 = 0; a3 < r3.length; ) n3[p2 & a3] = p2 & (i3 ^= n3[p2 & a3] * 19) + r3.charCodeAt(a3++);
      return S2(n3);
    }
    function x2() {
      try {
        var n3;
        return m2 && (n3 = m2.randomBytes) ? n3 = n3(a2) : (n3 = new Uint8Array(a2), (t5.crypto || t5.msCrypto).getRandomValues(n3)), S2(n3);
      } catch {
        var i3 = t5.navigator, o3 = i3 && i3.plugins;
        return [+/* @__PURE__ */ new Date(), t5, o3, t5.screen, S2(r2)];
      }
    }
    function S2(t6) {
      return String.fromCharCode.apply(0, t6);
    }
    if (b2(i2.random(), r2), typeof n2 == `object` && n2.exports) {
      n2.exports = h2;
      try {
        m2 = require___vite_browser_external$1();
      } catch {
      }
    } else typeof define == `function` && define.amd ? define(function() {
      return h2;
    }) : i2[`seed` + c2] = h2;
  })(typeof self < `u` ? self : t4, [], Math);
})), require_seedrandom$2 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_alea$1(), i2 = require_xor128$1(), a2 = require_xorwow$1(), o2 = require_xorshift7$1(), s2 = require_xor4096$1(), c2 = require_tychei$1(), l2 = require_seedrandom$1$1();
  l2.alea = r2, l2.xor128 = i2, l2.xorwow = a2, l2.xorshift7 = o2, l2.xor4096 = s2, l2.tychei = c2, n2.exports = l2;
})), import_seedrandom$1 = __toESM$1(require_seedrandom$2()), singletonRandom$1 = (0, import_seedrandom$1.default)(Date.now());
function createRng$1(t4) {
  var n2;
  function r2(t5) {
    n2 = t5 === null ? singletonRandom$1 : (0, import_seedrandom$1.default)(String(t5));
  }
  r2(t4);
  function i2() {
    return n2();
  }
  return i2;
}
var name$47$1 = `pickRandom`, dependencies$47$1 = [`typed`, `config`, `?on`], createPickRandom$1 = factory$1(name$47$1, dependencies$47$1, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng$1(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng$1(t5.randomSeed));
  }), n2(name$47$1, { "Array | Matrix": function(t5) {
    return o2(t5, {});
  }, "Array | Matrix, Object": function(t5, n3) {
    return o2(t5, n3);
  }, "Array | Matrix, number": function(t5, n3) {
    return o2(t5, { number: n3 });
  }, "Array | Matrix, Array | Matrix": function(t5, n3) {
    return o2(t5, { weights: n3 });
  }, "Array | Matrix, Array | Matrix, number": function(t5, n3, r3) {
    return o2(t5, { number: r3, weights: n3 });
  }, "Array | Matrix, number, Array | Matrix": function(t5, n3, r3) {
    return o2(t5, { number: n3, weights: r3 });
  } });
  function o2(t5, n3) {
    var { number: r3, weights: i3, elementWise: o3 = true } = n3, s2 = r3 === void 0;
    s2 && (r3 = 1);
    var c2 = isMatrix$1(t5) ? t5.create : isMatrix$1(i3) ? i3.create : null;
    t5 = t5.valueOf(), i3 &&= i3.valueOf(), o3 === true && (t5 = flatten$4$1(t5), i3 = flatten$4$1(i3));
    var l2 = 0;
    if (i3 !== void 0) {
      if (i3.length !== t5.length) throw Error(`Weights must have the same length as possibles`);
      for (var u2 = 0, d2 = i3.length; u2 < d2; u2++) {
        if (!isNumber$1(i3[u2]) || i3[u2] < 0) throw Error(`Weights must be an array of positive numbers`);
        l2 += i3[u2];
      }
    }
    for (var p2 = t5.length, m2 = [], h2; m2.length < r3; ) {
      if (i3 === void 0) h2 = t5[Math.floor(a2() * p2)];
      else for (var g2 = a2() * l2, v2 = 0, y2 = t5.length; v2 < y2; v2++) if (g2 -= i3[v2], g2 < 0) {
        h2 = t5[v2];
        break;
      }
      m2.push(h2);
    }
    return s2 ? m2[0] : c2 ? c2(m2) : m2;
  }
});
function randomMatrix$1(t4, n2) {
  var r2 = [];
  if (t4 = t4.slice(0), t4.length > 1) for (var i2 = 0, a2 = t4.shift(); i2 < a2; i2++) r2.push(randomMatrix$1(t4, n2));
  else for (var o2 = 0, s2 = t4.shift(); o2 < s2; o2++) r2.push(n2());
  return r2;
}
var name$46$1 = `random`, dependencies$46$1 = [`typed`, `config`, `?on`], createRandom$1 = factory$1(name$46$1, dependencies$46$1, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng$1(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng$1(t5.randomSeed));
  }), n2(name$46$1, { "": () => s2(0, 1), number: (t5) => s2(0, t5), "number, number": (t5, n3) => s2(t5, n3), "Array | Matrix": (t5) => o2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => o2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => o2(t5, n3, r3) });
  function o2(t5, n3, r3) {
    var i3 = randomMatrix$1(t5.valueOf(), () => s2(n3, r3));
    return isMatrix$1(t5) ? t5.create(i3, `number`) : i3;
  }
  function s2(t5, n3) {
    return t5 + a2() * (n3 - t5);
  }
}), name$45$1 = `randomInt`, dependencies$45$1 = [`typed`, `config`, `log2`, `?on`], createRandomInt$1 = factory$1(name$45$1, dependencies$45$1, (t4) => {
  var { typed: n2, config: r2, log2: i2, on: a2 } = t4, o2 = createRng$1(r2.randomSeed);
  return a2 && a2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (o2 = createRng$1(t5.randomSeed));
  }), n2(name$45$1, { "": () => c2(0, 2), number: (t5) => c2(0, t5), "number, number": (t5, n3) => c2(t5, n3), bigint: (t5) => l2(0n, t5), "bigint, bigint": l2, "Array | Matrix": (t5) => s2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => s2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => s2(t5, n3, r3) });
  function s2(t5, n3, r3) {
    var i3 = randomMatrix$1(t5.valueOf(), () => c2(n3, r3));
    return isMatrix$1(t5) ? t5.create(i3, `number`) : i3;
  }
  function c2(t5, n3) {
    return Math.floor(t5 + o2() * (n3 - t5));
  }
  function l2(t5, n3) {
    var r3 = 2n ** 30n, a3 = n3 - t5;
    if (a3 <= r3) return t5 + BigInt(c2(0, Number(a3)));
    for (var s3 = i2(a3), l3 = a3; l3 >= a3; ) {
      l3 = 0n;
      for (var u2 = 0; u2 < s3; ++u2) l3 = 2n * l3 + (o2() < 0.5 ? 0n : 1n);
    }
    return t5 + l3;
  }
}), name$44$1 = `stirlingS2`, dependencies$44$1 = [`typed`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `factorial`, `combinations`, `isNegative`, `isInteger`, `number`, `?bignumber`, `larger`], createStirlingS2$1 = factory$1(name$44$1, dependencies$44$1, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, pow: s2, factorial: c2, combinations: l2, isNegative: u2, isInteger: d2, number: p2, bignumber: m2, larger: h2 } = t4, g2 = [], v2 = [];
  return n2(name$44$1, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!d2(t5) || u2(t5) || !d2(n3) || u2(n3)) throw TypeError(`Non-negative integer value expected in function stirlingS2`);
    if (h2(n3, t5)) throw TypeError(`k must be less than or equal to n in function stirlingS2`);
    var i3 = !(isNumber$1(t5) && isNumber$1(n3)), o3 = i3 ? v2 : g2, s3 = i3 ? m2 : p2, c3 = p2(t5), l3 = p2(n3);
    if (o3[c3] && o3[c3].length > l3) return o3[c3][l3];
    for (var y2 = 0; y2 <= c3; ++y2) if (o3[y2] || (o3[y2] = [s3(+(y2 === 0))]), y2 !== 0) for (var b2 = o3[y2], x2 = o3[y2 - 1], S2 = b2.length; S2 <= y2 && S2 <= l3; ++S2) S2 === y2 ? b2[S2] = 1 : b2[S2] = r2(a2(s3(S2), x2[S2]), x2[S2 - 1]);
    return o3[c3][l3];
  } });
}), name$43$1 = `bellNumbers`, dependencies$43$1 = [`typed`, `addScalar`, `isNegative`, `isInteger`, `stirlingS2`], createBellNumbers$1 = factory$1(name$43$1, dependencies$43$1, (t4) => {
  var { typed: n2, addScalar: r2, isNegative: i2, isInteger: a2, stirlingS2: o2 } = t4;
  return n2(name$43$1, { "number | BigNumber": function(t5) {
    if (!a2(t5) || i2(t5)) throw TypeError(`Non-negative integer value expected in function bellNumbers`);
    for (var n3 = 0, s2 = 0; s2 <= t5; s2++) n3 = r2(n3, o2(t5, s2));
    return n3;
  } });
}), name$42$1 = `catalan`, dependencies$42$1 = [`typed`, `addScalar`, `divideScalar`, `multiplyScalar`, `combinations`, `isNegative`, `isInteger`], createCatalan$1 = factory$1(name$42$1, dependencies$42$1, (t4) => {
  var { typed: n2, addScalar: r2, divideScalar: i2, multiplyScalar: a2, combinations: o2, isNegative: s2, isInteger: c2 } = t4;
  return n2(name$42$1, { "number | BigNumber": function(t5) {
    if (!c2(t5) || s2(t5)) throw TypeError(`Non-negative integer value expected in function catalan`);
    return i2(o2(a2(t5, 2), t5), r2(t5, 1));
  } });
}), name$41$1 = `composition`, dependencies$41$1 = [`typed`, `addScalar`, `combinations`, `isNegative`, `isPositive`, `isInteger`, `larger`], createComposition$1 = factory$1(name$41$1, dependencies$41$1, (t4) => {
  var { typed: n2, addScalar: r2, combinations: i2, isPositive: a2, isNegative: o2, isInteger: s2, larger: c2 } = t4;
  return n2(name$41$1, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!s2(t5) || !a2(t5) || !s2(n3) || !a2(n3)) throw TypeError(`Positive integer value expected in function composition`);
    if (c2(n3, t5)) throw TypeError(`k must be less than or equal to n in function composition`);
    return i2(r2(t5, -1), r2(n3, -1));
  } });
}), name$40$1 = `leafCount`, dependencies$40$1 = [`parse`, `typed`], createLeafCount$1 = factory$1(name$40$1, dependencies$40$1, (t4) => {
  var { parse: n2, typed: r2 } = t4;
  function i2(t5) {
    var n3 = 0;
    return t5.forEach((t6) => {
      n3 += i2(t6);
    }), n3 || 1;
  }
  return r2(name$40$1, { Node: function(t5) {
    return i2(t5);
  } });
});
function isNumericNode$1(t4) {
  return isConstantNode$1(t4) || isOperatorNode$1(t4) && t4.isUnary() && isConstantNode$1(t4.args[0]);
}
function isConstantExpression$1(t4) {
  return !!(isConstantNode$1(t4) || (isFunctionNode$1(t4) || isOperatorNode$1(t4)) && t4.args.every(isConstantExpression$1) || isParenthesisNode$1(t4) && isConstantExpression$1(t4.content));
}
function ownKeys$1$1(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$1$1(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$1$1(Object(r2), true).forEach(function(n3) {
      _defineProperty$2(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$1$1(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$39$1 = `simplifyUtil`, dependencies$39$1 = [`FunctionNode`, `OperatorNode`, `SymbolNode`], createUtil$1 = factory$1(name$39$1, dependencies$39$1, (t4) => {
  var { FunctionNode: n2, OperatorNode: r2, SymbolNode: i2 } = t4, a2 = true, o2 = false, s2 = `defaultF`, c2 = { add: { trivial: a2, total: a2, commutative: a2, associative: a2 }, unaryPlus: { trivial: a2, total: a2, commutative: a2, associative: a2 }, subtract: { trivial: o2, total: a2, commutative: o2, associative: o2 }, multiply: { trivial: a2, total: a2, commutative: a2, associative: a2 }, divide: { trivial: o2, total: a2, commutative: o2, associative: o2 }, paren: { trivial: a2, total: a2, commutative: a2, associative: o2 }, defaultF: { trivial: o2, total: a2, commutative: o2, associative: o2 } }, l2 = { divide: { total: o2 }, log: { total: o2 } }, u2 = { subtract: { total: o2 }, abs: { trivial: a2 }, log: { total: a2 } };
  function d2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : c2, i3 = s2;
    if (typeof t5 == `string` ? i3 = t5 : isOperatorNode$1(t5) ? i3 = t5.fn.toString() : isFunctionNode$1(t5) ? i3 = t5.name : isParenthesisNode$1(t5) && (i3 = `paren`), hasOwnProperty$1$3(r3, i3)) {
      var a3 = r3[i3];
      if (hasOwnProperty$1$3(a3, n3)) return a3[n3];
      if (hasOwnProperty$1$3(c2, i3)) return c2[i3][n3];
    }
    if (hasOwnProperty$1$3(r3, s2)) {
      var o3 = r3[s2];
      return hasOwnProperty$1$3(o3, n3) ? o3[n3] : c2[s2][n3];
    }
    if (hasOwnProperty$1$3(c2, i3)) {
      var l3 = c2[i3];
      if (hasOwnProperty$1$3(l3, n3)) return l3[n3];
    }
    return c2[s2][n3];
  }
  function p2(t5) {
    return d2(t5, `commutative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function m2(t5) {
    return d2(t5, `associative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function h2(t5, n3) {
    var r3 = _objectSpread$1$1({}, t5);
    for (var i3 in n3) hasOwnProperty$1$3(t5, i3) ? r3[i3] = _objectSpread$1$1(_objectSpread$1$1({}, n3[i3]), t5[i3]) : r3[i3] = n3[i3];
    return r3;
  }
  function g2(t5, n3) {
    if (!t5.args || t5.args.length === 0) return t5;
    t5.args = v2(t5, n3);
    for (var r3 = 0; r3 < t5.args.length; r3++) g2(t5.args[r3], n3);
  }
  function v2(t5, n3) {
    var r3, i3 = [], a3 = function(t6) {
      for (var n4 = 0; n4 < t6.args.length; n4++) {
        var o3 = t6.args[n4];
        isOperatorNode$1(o3) && r3 === o3.op ? a3(o3) : i3.push(o3);
      }
    };
    return m2(t5, n3) ? (r3 = t5.op, a3(t5), i3) : t5.args;
  }
  function y2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) y2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.pop(); t5.args.length > 0; ) o3 = r3([t5.args.pop(), o3]);
        t5.args = o3.args;
      }
    }
  }
  function b2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) b2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.shift(); t5.args.length > 0; ) o3 = r3([o3, t5.args.shift()]);
        t5.args = o3.args;
      }
    }
  }
  function x2(t5) {
    return isOperatorNode$1(t5) ? function(n3) {
      try {
        return new r2(t5.op, t5.fn, n3, t5.implicit);
      } catch (t6) {
        return console.error(t6), [];
      }
    } : function(r3) {
      return new n2(new i2(t5.name), r3);
    };
  }
  return { createMakeNodeFunction: x2, hasProperty: d2, isCommutative: p2, isAssociative: m2, mergeContext: h2, flatten: g2, allChildren: v2, unflattenr: y2, unflattenl: b2, defaultContext: c2, realContext: l2, positiveContext: u2 };
}), name$38$1 = `simplify`, dependencies$38$1 = [`typed`, `parse`, `equal`, `resolve`, `simplifyConstant`, `simplifyCore`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`, `replacer`], createSimplify$1 = factory$1(name$38$1, dependencies$38$1, (t4) => {
  var { typed: n2, parse: r2, equal: i2, resolve: a2, simplifyConstant: o2, simplifyCore: s2, AccessorNode: c2, ArrayNode: l2, ConstantNode: u2, FunctionNode: d2, IndexNode: p2, ObjectNode: m2, OperatorNode: h2, ParenthesisNode: g2, SymbolNode: v2, replacer: y2 } = t4, { hasProperty: b2, isCommutative: x2, isAssociative: S2, mergeContext: w2, flatten: E, unflattenr: D, unflattenl: O2, createMakeNodeFunction: j2, defaultContext: M2, realContext: N2, positiveContext: F } = createUtil$1({ FunctionNode: d2, OperatorNode: h2, SymbolNode: v2 });
  n2.addConversion({ from: `Object`, to: `Map`, convert: createMap$1$1 });
  var I2 = n2(`simplify`, { Node: W2, "Node, Map": (t5, n3) => W2(t5, false, n3), "Node, Map, Object": (t5, n3, r3) => W2(t5, false, n3, r3), "Node, Array": W2, "Node, Array, Map": W2, "Node, Array, Map, Object": W2 });
  n2.removeConversion({ from: `Object`, to: `Map`, convert: createMap$1$1 }), I2.defaultContext = M2, I2.realContext = N2, I2.positiveContext = F;
  function L2(t5) {
    return t5.transform(function(t6) {
      return isParenthesisNode$1(t6) ? L2(t6.content) : t6;
    });
  }
  var R2 = { true: true, false: true, e: true, i: true, Infinity: true, LN2: true, LN10: true, LOG2E: true, LOG10E: true, NaN: true, phi: true, pi: true, SQRT1_2: true, SQRT2: true, tau: true };
  I2.rules = [s2, { l: `log(e)`, r: `1` }, { s: `n-n1 -> n+-n1`, assuming: { subtract: { total: true } } }, { s: `n-n -> 0`, assuming: { subtract: { total: false } } }, { s: `-(cl*v) -> v * (-cl)`, assuming: { multiply: { commutative: true }, subtract: { total: true } } }, { s: `-(cl*v) -> (-cl) * v`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { s: `-(v*cl) -> v * (-cl)`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { l: `-(n1/n2)`, r: `-n1/n2` }, { l: `-v`, r: `v * (-1)` }, { l: `(n1 + n2)*(-1)`, r: `n1*(-1) + n2*(-1)`, repeat: true }, { l: `n/n1^n2`, r: `n*n1^-n2` }, { l: `n/n1`, r: `n*n1^-1` }, { s: `(n1*n2)^n3 -> n1^n3 * n2^n3`, assuming: { multiply: { commutative: true } } }, { s: `(n1*n2)^(-1) -> n2^(-1) * n1^(-1)`, assuming: { multiply: { commutative: false } } }, { s: `(n ^ n1) ^ n2 -> n ^ (n1 * n2)`, assuming: { divide: { total: true } } }, { l: ` vd   * ( vd   * n1 + n2)`, r: `vd^2       * n1 +  vd   * n2` }, { s: ` vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { l: `n*n`, r: `n^2` }, { s: `n * n^n1 -> n^(n1+1)`, assuming: { divide: { total: true } } }, { s: `n^n1 * n^n2 -> n^(n1+n2)`, assuming: { divide: { total: true } } }, o2, { s: `n+n -> 2*n`, assuming: { add: { total: true } } }, { l: `n+-n`, r: `0` }, { l: `vd*n + vd`, r: `vd*(n+1)` }, { l: `n3*n1 + n3*n2`, r: `n3*(n1+n2)` }, { l: `n3^(-n4)*n1 +   n3  * n2`, r: `n3^(-n4)*(n1 + n3^(n4+1) *n2)` }, { l: `n3^(-n4)*n1 + n3^n5 * n2`, r: `n3^(-n4)*(n1 + n3^(n4+n5)*n2)` }, { s: `n*vd + vd -> (n+1)*vd`, assuming: { multiply: { commutative: false } } }, { s: `vd + n*vd -> (1+n)*vd`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3 + n2*n3 -> (n1+n2)*n3`, assuming: { multiply: { commutative: false } } }, { s: `n^n1 * n -> n^(n1+1)`, assuming: { divide: { total: true }, multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { l: `n*cd + cd`, r: `(n+1)*cd` }, { s: `cd*n + cd -> cd*(n+1)`, assuming: { multiply: { commutative: false } } }, { s: `cd + cd*n -> cd*(1+n)`, assuming: { multiply: { commutative: false } } }, o2, { s: `(-n)*n1 -> -(n*n1)`, assuming: { subtract: { total: true } } }, { s: `n1*(-n) -> -(n1*n)`, assuming: { subtract: { total: true }, multiply: { commutative: false } } }, { s: `ce+ve -> ve+ce`, assuming: { add: { commutative: true } }, imposeContext: { add: { commutative: false } } }, { s: `vd*cd -> cd*vd`, assuming: { multiply: { commutative: true } }, imposeContext: { multiply: { commutative: false } } }, { l: `n+-n1`, r: `n-n1` }, { l: `n+-(n1)`, r: `n-(n1)` }, { s: `n*(n1^-1) -> n/n1`, assuming: { multiply: { commutative: true } } }, { s: `n*n1^-n2 -> n/n1^n2`, assuming: { multiply: { commutative: true } } }, { s: `n^-1 -> 1/n`, assuming: { multiply: { commutative: true } } }, { l: `n^1`, r: `n` }, { s: `n*(n1/n2) -> (n*n1)/n2`, assuming: { multiply: { associative: true } } }, { s: `n-(n1+n2) -> n-n1-n2`, assuming: { addition: { associative: true, commutative: true } } }, { l: `1*n`, r: `n`, imposeContext: { multiply: { commutative: true } } }, { s: `n1/(n2/n3) -> (n1*n3)/n2`, assuming: { multiply: { associative: true } } }, { l: `n1/(-n2)`, r: `-n1/n2` }];
  function z2(t5, n3) {
    var i3 = {};
    if (t5.s) {
      var a3 = t5.s.split(`->`);
      if (a3.length === 2) i3.l = a3[0], i3.r = a3[1];
      else throw SyntaxError(`Could not parse rule: ` + t5.s);
    } else i3.l = t5.l, i3.r = t5.r;
    i3.l = L2(r2(i3.l)), i3.r = L2(r2(i3.r));
    for (var o3 of [`imposeContext`, `repeat`, `assuming`]) o3 in t5 && (i3[o3] = t5[o3]);
    if (t5.evaluate && (i3.evaluate = r2(t5.evaluate)), S2(i3.l, n3)) {
      var s3 = !x2(i3.l, n3), c3;
      s3 && (c3 = U2());
      var l3 = j2(i3.l), u3 = U2();
      i3.expanded = {}, i3.expanded.l = l3([i3.l, u3]), E(i3.expanded.l, n3), D(i3.expanded.l, n3), i3.expanded.r = l3([i3.r, u3]), s3 && (i3.expandedNC1 = {}, i3.expandedNC1.l = l3([c3, i3.l]), i3.expandedNC1.r = l3([c3, i3.r]), i3.expandedNC2 = {}, i3.expandedNC2.l = l3([c3, i3.expanded.l]), i3.expandedNC2.r = l3([c3, i3.expanded.r]));
    }
    return i3;
  }
  function V2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < t5.length; i3++) {
      var a3 = t5[i3], o3 = void 0, s3 = typeof a3;
      switch (s3) {
        case `string`:
          a3 = { s: a3 };
        case `object`:
          o3 = z2(a3, n3);
          break;
        case `function`:
          o3 = a3;
          break;
        default:
          throw TypeError(`Unsupported type of rule: ` + s3);
      }
      r3.push(o3);
    }
    return r3;
  }
  var H2 = 0;
  function U2() {
    return new v2(`_p` + H2++);
  }
  function W2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : createEmptyMap$1(), i3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o3 = i3.consoleDebug;
    n3 = V2(n3 || I2.rules, i3.context);
    var s3 = a2(t5, r3);
    s3 = L2(s3);
    for (var c3 = {}, l3 = s3.toString({ parenthesis: `all` }); !c3[l3]; ) {
      c3[l3] = true, H2 = 0;
      var u3 = l3;
      o3 && console.log(`Working on: `, l3);
      for (var d3 = 0; d3 < n3.length; d3++) {
        var p3 = ``;
        if (typeof n3[d3] == `function` ? (s3 = n3[d3](s3, i3), o3 && (p3 = n3[d3].name)) : (E(s3, i3.context), s3 = K2(s3, n3[d3], i3.context), o3 && (p3 = `${n3[d3].l.toString()} -> ${n3[d3].r.toString()}`)), o3) {
          var m3 = s3.toString({ parenthesis: `all` });
          m3 !== u3 && (console.log(`Applying`, p3, `produced`, m3), u3 = m3);
        }
        O2(s3, i3.context);
      }
      l3 = s3.toString({ parenthesis: `all` });
    }
    return s3;
  }
  function G2(t5, n3, r3) {
    var i3 = t5;
    if (t5) for (var a3 = 0; a3 < t5.length; ++a3) {
      var o3 = K2(t5[a3], n3, r3);
      o3 !== t5[a3] && (i3 === t5 && (i3 = t5.slice()), i3[a3] = o3);
    }
    return i3;
  }
  function K2(t5, n3, r3) {
    if (n3.assuming) {
      for (var i3 in n3.assuming) for (var a3 in n3.assuming[i3]) if (b2(i3, a3, r3) !== n3.assuming[i3][a3]) return t5;
    }
    var o3 = w2(n3.imposeContext, r3), s3 = t5;
    if (s3 instanceof h2 || s3 instanceof d2) {
      var u3 = G2(s3.args, n3, r3);
      u3 !== s3.args && (s3 = s3.clone(), s3.args = u3);
    } else if (s3 instanceof g2) {
      if (s3.content) {
        var v3 = K2(s3.content, n3, r3);
        v3 !== s3.content && (s3 = new g2(v3));
      }
    } else if (s3 instanceof l2) {
      var y3 = G2(s3.items, n3, r3);
      y3 !== s3.items && (s3 = new l2(y3));
    } else if (s3 instanceof c2) {
      var x3 = s3.object;
      s3.object && (x3 = K2(s3.object, n3, r3));
      var S3 = s3.index;
      s3.index && (S3 = K2(s3.index, n3, r3)), (x3 !== s3.object || S3 !== s3.index) && (s3 = new c2(x3, S3));
    } else if (s3 instanceof p2) {
      var E2 = G2(s3.dimensions, n3, r3);
      E2 !== s3.dimensions && (s3 = new p2(E2));
    } else if (s3 instanceof m2) {
      var D2 = false, O22 = {};
      for (var j3 in s3.properties) O22[j3] = K2(s3.properties[j3], n3, r3), O22[j3] !== s3.properties[j3] && (D2 = true);
      D2 && (s3 = new m2(O22));
    }
    var M3 = n3.r, N3 = te2(n3.l, s3, o3)[0];
    if (!N3 && n3.expanded && (M3 = n3.expanded.r, N3 = te2(n3.expanded.l, s3, o3)[0]), !N3 && n3.expandedNC1 && (M3 = n3.expandedNC1.r, N3 = te2(n3.expandedNC1.l, s3, o3)[0], N3 ||= (M3 = n3.expandedNC2.r, te2(n3.expandedNC2.l, s3, o3)[0])), N3) {
      var F2 = s3.implicit;
      s3 = M3.clone(), F2 && `implicit` in M3 && (s3.implicit = true), s3 = s3.transform(function(t6) {
        return t6.isSymbolNode && hasOwnProperty$1$3(N3.placeholders, t6.name) ? N3.placeholders[t6.name].clone() : t6;
      });
    }
    return n3.repeat && s3 !== t5 && (s3 = K2(s3, n3, r3)), s3;
  }
  function q2(t5, n3) {
    var r3 = [], i3, a3, o3 = j2(t5);
    if (x2(t5, n3)) for (var s3 = 0; s3 < t5.args.length; s3++) a3 = t5.args.slice(0), a3.splice(s3, 1), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([t5.args[s3], i3]));
    else for (var c3 = 1; c3 < t5.args.length; c3++) {
      var l3 = t5.args[0];
      c3 > 1 && (l3 = o3(t5.args.slice(0, c3))), a3 = t5.args.slice(c3), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([l3, i3]));
    }
    return r3;
  }
  function J(t5, n3) {
    var r3 = { placeholders: {} };
    if (!t5.placeholders && !n3.placeholders) return r3;
    if (!t5.placeholders) return n3;
    if (!n3.placeholders) return t5;
    for (var i3 in t5.placeholders) if (hasOwnProperty$1$3(t5.placeholders, i3) && (r3.placeholders[i3] = t5.placeholders[i3], hasOwnProperty$1$3(n3.placeholders, i3) && !ne2(t5.placeholders[i3], n3.placeholders[i3]))) return null;
    for (var a3 in n3.placeholders) hasOwnProperty$1$3(n3.placeholders, a3) && (r3.placeholders[a3] = n3.placeholders[a3]);
    return r3;
  }
  function ee2(t5, n3) {
    var r3 = [];
    if (t5.length === 0 || n3.length === 0) return r3;
    for (var i3, a3 = 0; a3 < t5.length; a3++) for (var o3 = 0; o3 < n3.length; o3++) i3 = J(t5[a3], n3[o3]), i3 && r3.push(i3);
    return r3;
  }
  function Y2(t5) {
    if (t5.length === 0) return t5;
    for (var n3 = t5.reduce(ee2), r3 = [], i3 = {}, a3 = 0; a3 < n3.length; a3++) {
      var o3 = JSON.stringify(n3[a3], y2);
      i3[o3] || (i3[o3] = true, r3.push(n3[a3]));
    }
    return r3;
  }
  function te2(t5, n3, r3, a3) {
    var o3 = [{ placeholders: {} }];
    if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return [];
      } else if (t5 instanceof d2 && t5.name !== n3.name) return [];
      if (n3.args.length === 1 && t5.args.length === 1 || !S2(n3, r3) && n3.args.length === t5.args.length || a3) {
        for (var s3 = [], c3 = 0; c3 < t5.args.length; c3++) {
          var l3 = te2(t5.args[c3], n3.args[c3], r3);
          if (l3.length === 0) break;
          s3.push(l3);
        }
        if (s3.length !== t5.args.length) {
          if (!x2(n3, r3) || t5.args.length === 1) return [];
          if (t5.args.length > 2) throw Error(`permuting >2 commutative non-associative rule arguments not yet implemented`);
          var p3 = te2(t5.args[0], n3.args[1], r3);
          if (p3.length === 0) return [];
          var m3 = te2(t5.args[1], n3.args[0], r3);
          if (m3.length === 0) return [];
          s3 = [p3, m3];
        }
        o3 = Y2(s3);
      } else if (n3.args.length >= 2 && t5.args.length === 2) {
        for (var g3 = q2(n3, r3), y3 = [], b3 = 0; b3 < g3.length; b3++) {
          var w3 = te2(t5, g3[b3], r3, true);
          y3 = y3.concat(w3);
        }
        return y3;
      } else if (t5.args.length > 2) throw Error(`Unexpected non-binary associative function: ` + t5.toString());
      else return [];
    } else if (t5 instanceof v2) {
      if (t5.name.length === 0) throw Error(`Symbol in rule has 0 length...!?`);
      if (R2[t5.name]) {
        if (t5.name !== n3.name) return [];
      } else switch (t5.name[1] >= `a` && t5.name[1] <= `z` ? t5.name.substring(0, 2) : t5.name[0]) {
        case `n`:
        case `_p`:
          o3[0].placeholders[t5.name] = n3;
          break;
        case `c`:
        case `cl`:
          if (isConstantNode$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `v`:
          if (!isConstantNode$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vl`:
          if (isSymbolNode$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `cd`:
          if (isNumericNode$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vd`:
          if (!isNumericNode$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ce`:
          if (isConstantExpression$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ve`:
          if (!isConstantExpression$1(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        default:
          throw Error(`Invalid symbol in rule: ` + t5.name);
      }
    } else if (t5 instanceof u2) {
      if (!i2(t5.value, n3.value)) return [];
    } else return [];
    return o3;
  }
  function ne2(t5, n3) {
    if (t5 instanceof u2 && n3 instanceof u2) {
      if (!i2(t5.value, n3.value)) return false;
    } else if (t5 instanceof v2 && n3 instanceof v2) {
      if (t5.name !== n3.name) return false;
    } else if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return false;
      } else if (t5 instanceof d2 && t5.name !== n3.name) return false;
      if (t5.args.length !== n3.args.length) return false;
      for (var r3 = 0; r3 < t5.args.length; r3++) if (!ne2(t5.args[r3], n3.args[r3])) return false;
    } else return false;
    return true;
  }
  return I2;
}), name$37$1 = `simplifyConstant`, dependencies$37$1 = [`typed`, `config`, `mathWithTransform`, `matrix`, `isBounded`, `?fraction`, `?bignumber`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `SymbolNode`], createSimplifyConstant$1 = factory$1(name$37$1, dependencies$37$1, (t4) => {
  var { typed: n2, config: r2, mathWithTransform: i2, matrix: a2, isBounded: o2, fraction: s2, bignumber: c2, AccessorNode: l2, ArrayNode: u2, ConstantNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, SymbolNode: v2 } = t4, { isCommutative: y2, isAssociative: b2, allChildren: x2, createMakeNodeFunction: S2 } = createUtil$1({ FunctionNode: p2, OperatorNode: g2, SymbolNode: v2 }), w2 = n2(`simplifyConstant`, { Node: (t5) => j2(z2(t5, {})), "Node, Object": function(t5, n3) {
    return j2(z2(t5, n3));
  } });
  function E(t5) {
    return isFraction$1(t5) ? t5.valueOf() : t5 instanceof Array ? t5.map(E) : isMatrix$1(t5) ? a2(E(t5.valueOf())) : t5;
  }
  function D(t5, n3, r3) {
    try {
      return i2[t5].apply(null, n3);
    } catch {
      return n3 = n3.map(E), N2(i2[t5].apply(null, n3), r3);
    }
  }
  var O2 = n2({ Fraction: I2, number: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, BigNumber: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, bigint: function(t5) {
    return t5 < 0n ? F(new d2(-t5)) : new d2(t5);
  }, Complex: function(t5) {
    throw Error(`Cannot convert Complex number to Node`);
  }, string: function(t5) {
    return new d2(t5);
  }, Matrix: function(t5) {
    return new u2(t5.valueOf().map((t6) => O2(t6)));
  } });
  function j2(t5) {
    return isNode$4(t5) ? t5 : O2(t5);
  }
  function M2(t5, n3) {
    if (n3 && n3.exactFractions !== false && o2(t5) && s2) {
      var r3 = s2(t5), i3 = n3 && typeof n3.fractionsLimit == `number` ? n3.fractionsLimit : 1 / 0;
      if (r3.valueOf() === t5 && r3.n < i3 && r3.d < i3) return r3;
    }
    return t5;
  }
  var N2 = n2({ "string, Object": function(t5, n3) {
    var i3 = safeNumberType$1(t5, r2);
    return i3 === `BigNumber` ? (c2 === void 0 && noBignumber$1(), c2(t5)) : i3 === `bigint` ? BigInt(t5) : i3 === `Fraction` ? (s2 === void 0 && noFraction$1(), s2(t5)) : M2(parseFloat(t5), n3);
  }, "Fraction, Object": function(t5, n3) {
    return t5;
  }, "BigNumber, Object": function(t5, n3) {
    return t5;
  }, "number, Object": function(t5, n3) {
    return M2(t5, n3);
  }, "bigint, Object": function(t5, n3) {
    return t5;
  }, "Complex, Object": function(t5, n3) {
    return t5.im === 0 ? M2(t5.re, n3) : t5;
  }, "Matrix, Object": function(t5, n3) {
    return a2(M2(t5.valueOf()));
  }, "Array, Object": function(t5, n3) {
    return t5.map(M2);
  } });
  function F(t5) {
    return new g2(`-`, `unaryMinus`, [t5]);
  }
  function I2(t5) {
    var n3 = (t6) => r2.number === `BigNumber` && c2 ? c2(t6) : Number(t6), i3 = t5.s * t5.n, a3 = i3 < 0n ? new g2(`-`, `unaryMinus`, [new d2(-n3(i3))]) : new d2(n3(i3));
    return t5.d === 1n ? a3 : new g2(`/`, `divide`, [a3, new d2(n3(t5.d))]);
  }
  function L2(t5, n3, r3) {
    if (!isIndexNode$1(n3)) return new l2(j2(t5), j2(n3));
    if (isArrayNode$1(t5) || isMatrix$1(t5)) {
      for (var i3 = Array.from(n3.dimensions); i3.length > 0; ) if (isConstantNode$1(i3[0]) && typeof i3[0].value != `string`) {
        var o3 = N2(i3.shift().value, r3);
        isArrayNode$1(t5) ? t5 = t5.items[o3 - 1] : (t5 = t5.valueOf()[o3 - 1], t5 instanceof Array && (t5 = a2(t5)));
      } else if (i3.length > 1 && isConstantNode$1(i3[1]) && typeof i3[1].value != `string`) {
        var s3 = N2(i3[1].value, r3), c3 = [], p3 = isArrayNode$1(t5) ? t5.items : t5.valueOf();
        for (var h3 of p3) if (isArrayNode$1(h3)) c3.push(h3.items[s3 - 1]);
        else if (isMatrix$1(t5)) c3.push(h3[s3 - 1]);
        else break;
        if (c3.length === p3.length) t5 = isArrayNode$1(t5) ? new u2(c3) : a2(c3), i3.splice(1, 1);
        else break;
      } else break;
      return i3.length === n3.dimensions.length ? new l2(j2(t5), n3) : i3.length > 0 ? (n3 = new m2(i3), new l2(j2(t5), n3)) : t5;
    }
    if (isObjectNode$1(t5) && n3.dimensions.length === 1 && isConstantNode$1(n3.dimensions[0])) {
      var g3 = n3.dimensions[0].value;
      return g3 in t5.properties ? t5.properties[g3] : new d2();
    }
    return new l2(j2(t5), n3);
  }
  function R2(t5, n3, r3, i3) {
    var a3 = n3.shift(), o3 = n3.reduce((n4, a4) => {
      if (!isNode$4(a4)) {
        var o4 = n4.pop();
        if (isNode$4(o4)) return [o4, a4];
        try {
          return n4.push(D(t5, [o4, a4], i3)), n4;
        } catch {
          n4.push(o4);
        }
      }
      return n4.push(j2(n4.pop())), [r3([n4.length === 1 ? n4[0] : r3(n4), j2(a4)])];
    }, [a3]);
    return o3.length === 1 ? o3[0] : r3([o3[0], O2(o3[1])]);
  }
  function z2(t5, n3) {
    switch (t5.type) {
      case `SymbolNode`:
        return t5;
      case `ConstantNode`:
        switch (typeof t5.value) {
          case `number`:
            return N2(t5.value, n3);
          case `bigint`:
            return N2(t5.value, n3);
          case `string`:
            return t5.value;
          default:
            if (!isNaN(t5.value)) return N2(t5.value, n3);
        }
        return t5;
      case `FunctionNode`:
        if (i2[t5.name] && i2[t5.name].rawArgs) return t5;
        if (![`add`, `multiply`].includes(t5.name)) {
          var r3 = t5.args.map((t6) => z2(t6, n3));
          if (!r3.some(isNode$4)) try {
            return D(t5.name, r3, n3);
          } catch {
          }
          if (t5.name === `size` && r3.length === 1 && isArrayNode$1(r3[0])) {
            for (var o3 = [], s3 = r3[0]; isArrayNode$1(s3); ) o3.push(s3.items.length), s3 = s3.items[0];
            return a2(o3);
          }
          return new p2(t5.name, r3.map(j2));
        }
      case `OperatorNode`:
        var c3 = t5.fn.toString(), l3, d3, g3 = S2(t5);
        if (isOperatorNode$1(t5) && t5.isUnary()) l3 = [z2(t5.args[0], n3)], d3 = isNode$4(l3[0]) ? g3(l3) : D(c3, l3, n3);
        else if (b2(t5, n3.context)) if (l3 = x2(t5, n3.context), l3 = l3.map((t6) => z2(t6, n3)), y2(c3, n3.context)) {
          for (var v3 = [], E2 = [], O22 = 0; O22 < l3.length; O22++) isNode$4(l3[O22]) ? E2.push(l3[O22]) : v3.push(l3[O22]);
          v3.length > 1 ? (d3 = R2(c3, v3, g3, n3), E2.unshift(d3), d3 = R2(c3, E2, g3, n3)) : d3 = R2(c3, l3, g3, n3);
        } else d3 = R2(c3, l3, g3, n3);
        else l3 = t5.args.map((t6) => z2(t6, n3)), d3 = R2(c3, l3, g3, n3);
        return d3;
      case `ParenthesisNode`:
        return z2(t5.content, n3);
      case `AccessorNode`:
        return L2(z2(t5.object, n3), z2(t5.index, n3), n3);
      case `ArrayNode`:
        var M3 = t5.items.map((t6) => z2(t6, n3));
        return M3.some(isNode$4) ? new u2(M3.map(j2)) : a2(M3);
      case `IndexNode`:
        return new m2(t5.dimensions.map((t6) => w2(t6, n3)));
      case `ObjectNode`:
        var F2 = {};
        for (var I22 in t5.properties) F2[I22] = w2(t5.properties[I22], n3);
        return new h2(F2);
      default:
        throw Error(`Unimplemented node type in simplifyConstant: ${t5.type}`);
    }
  }
  return w2;
}), name$36$1 = `simplifyCore`, dependencies$36$1 = [`typed`, `parse`, `equal`, `isZero`, `add`, `subtract`, `multiply`, `divide`, `pow`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createSimplifyCore$1 = factory$1(name$36$1, dependencies$36$1, (t4) => {
  var { typed: n2, parse: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, AccessorNode: d2, ArrayNode: p2, ConstantNode: m2, FunctionNode: h2, IndexNode: g2, ObjectNode: v2, OperatorNode: y2, ParenthesisNode: b2, SymbolNode: x2 } = t4, S2 = new m2(0), w2 = new m2(1), E = new m2(true), D = new m2(false);
  function O2(t5) {
    return isOperatorNode$1(t5) && [`and`, `not`, `or`].includes(t5.op);
  }
  var { hasProperty: j2, isCommutative: M2 } = createUtil$1({ FunctionNode: h2, OperatorNode: y2, SymbolNode: x2 });
  function N2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3 ? n3.context : void 0;
    if (j2(t5, `trivial`, r3)) {
      if (isFunctionNode$1(t5) && t5.args.length === 1) return N2(t5.args[0], n3);
      var o3 = false, s3 = 0;
      if (t5.forEach((t6) => {
        ++s3, s3 === 1 && (o3 = N2(t6, n3));
      }), s3 === 1) return o3;
    }
    var c3 = t5;
    if (isFunctionNode$1(c3)) {
      var l3 = getOperator$1(c3.name);
      if (l3) {
        if (c3.args.length > 2 && j2(c3, `associative`, r3)) for (; c3.args.length > 2; ) {
          var u3 = c3.args.pop(), m3 = c3.args.pop();
          c3.args.push(new y2(l3, c3.name, [u3, m3]));
        }
        c3 = new y2(l3, c3.name, c3.args);
      } else return new h2(N2(c3.fn), c3.args.map((t6) => N2(t6, n3)));
    }
    if (isOperatorNode$1(c3) && c3.isUnary()) {
      var b3 = N2(c3.args[0], n3);
      if (c3.op === `~` && isOperatorNode$1(b3) && b3.isUnary() && b3.op === `~` || c3.op === `not` && isOperatorNode$1(b3) && b3.isUnary() && b3.op === `not` && O2(b3.args[0])) return b3.args[0];
      var x3 = true;
      if (c3.op === `-` && isOperatorNode$1(b3) && (b3.isBinary() && b3.fn === `subtract` && (c3 = new y2(`-`, `subtract`, [b3.args[1], b3.args[0]]), x3 = false), b3.isUnary() && b3.op === `-`)) return b3.args[0];
      if (x3) return new y2(c3.op, c3.fn, [b3]);
    }
    if (isOperatorNode$1(c3) && c3.isBinary()) {
      var F = N2(c3.args[0], n3), I2 = N2(c3.args[1], n3);
      if (c3.op === `+`) {
        if (isConstantNode$1(F) && a2(F.value)) return I2;
        if (isConstantNode$1(I2) && a2(I2.value)) return F;
        isOperatorNode$1(I2) && I2.isUnary() && I2.op === `-` && (I2 = I2.args[0], c3 = new y2(`-`, `subtract`, [F, I2]));
      }
      if (c3.op === `-`) return isOperatorNode$1(I2) && I2.isUnary() && I2.op === `-` ? N2(new y2(`+`, `add`, [F, I2.args[0]]), n3) : isConstantNode$1(F) && a2(F.value) ? N2(new y2(`-`, `unaryMinus`, [I2])) : isConstantNode$1(I2) && a2(I2.value) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `*`) {
        if (isConstantNode$1(F)) {
          if (a2(F.value)) return S2;
          if (i2(F.value, 1)) return I2;
        }
        if (isConstantNode$1(I2)) {
          if (a2(I2.value)) return S2;
          if (i2(I2.value, 1)) return F;
          if (M2(c3, r3)) return new y2(c3.op, c3.fn, [I2, F], c3.implicit);
        }
        return new y2(c3.op, c3.fn, [F, I2], c3.implicit);
      }
      if (c3.op === `/`) return isConstantNode$1(F) && a2(F.value) ? S2 : isConstantNode$1(I2) && i2(I2.value, 1) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `^` && isConstantNode$1(I2)) {
        if (a2(I2.value)) return w2;
        if (i2(I2.value, 1)) return F;
      }
      if (c3.op === `and`) {
        if (isConstantNode$1(F)) if (F.value) {
          if (O2(I2)) return I2;
          if (isConstantNode$1(I2)) return I2.value ? E : D;
        } else return D;
        if (isConstantNode$1(I2)) if (I2.value) {
          if (O2(F)) return F;
        } else return D;
      }
      if (c3.op === `or`) {
        if (isConstantNode$1(F)) {
          if (F.value) return E;
          if (O2(I2)) return I2;
        }
        if (isConstantNode$1(I2)) {
          if (I2.value) return E;
          if (O2(F)) return F;
        }
      }
      return new y2(c3.op, c3.fn, [F, I2]);
    }
    if (isOperatorNode$1(c3)) return new y2(c3.op, c3.fn, c3.args.map((t6) => N2(t6, n3)));
    if (isArrayNode$1(c3)) return new p2(c3.items.map((t6) => N2(t6, n3)));
    if (isAccessorNode$1(c3)) return new d2(N2(c3.object, n3), N2(c3.index, n3));
    if (isIndexNode$1(c3)) return new g2(c3.dimensions.map((t6) => N2(t6, n3)));
    if (isObjectNode$1(c3)) {
      var L2 = {};
      for (var R2 in c3.properties) L2[R2] = N2(c3.properties[R2], n3);
      return new v2(L2);
    }
    return c3;
  }
  return n2(name$36$1, { Node: N2, "Node,Object": N2 });
}), name$35$1 = `resolve`, dependencies$35$1 = [`typed`, `parse`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`], createResolve$1 = factory$1(name$35$1, dependencies$35$1, (t4) => {
  var { typed: n2, parse: r2, ConstantNode: i2, FunctionNode: a2, OperatorNode: o2, ParenthesisNode: s2 } = t4;
  function c2(t5, n3) {
    var l2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!n3) return t5;
    if (isSymbolNode$1(t5)) {
      if (l2.has(t5.name)) {
        var u2 = Array.from(l2).join(`, `);
        throw ReferenceError(`recursive loop of variable definitions among {${u2}}`);
      }
      var d2 = n3.get(t5.name);
      if (isNode$4(d2)) {
        var p2 = new Set(l2);
        return p2.add(t5.name), c2(d2, n3, p2);
      } else if (typeof d2 == `number`) return r2(String(d2));
      else if (d2 !== void 0) return new i2(d2);
      else return t5;
    } else if (isOperatorNode$1(t5)) {
      var m2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new o2(t5.op, t5.fn, m2, t5.implicit);
    } else if (isParenthesisNode$1(t5)) return new s2(c2(t5.content, n3, l2));
    else if (isFunctionNode$1(t5)) {
      var h2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new a2(t5.name, h2);
    }
    return t5.map((t6) => c2(t6, n3, l2));
  }
  return n2(`resolve`, { Node: c2, "Node, Map | null | undefined": c2, "Node, Object": (t5, n3) => c2(t5, createMap$1$1(n3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array | Matrix, null | undefined": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array, Object": n2.referTo(`Array,Map`, (t5) => (n3, r3) => t5(n3, createMap$1$1(r3))), "Matrix, Object": n2.referTo(`Matrix,Map`, (t5) => (n3, r3) => t5(n3, createMap$1$1(r3))), "Array | Matrix, Map": n2.referToSelf((t5) => (n3, r3) => n3.map((n4) => t5(n4, r3))) });
}), name$34$1 = `symbolicEqual`, dependencies$34$1 = [`parse`, `simplify`, `typed`, `OperatorNode`], createSymbolicEqual$1 = factory$1(name$34$1, dependencies$34$1, (t4) => {
  var { parse: n2, simplify: r2, typed: i2, OperatorNode: a2 } = t4;
  function o2(t5, n3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o3 = r2(new a2(`-`, `subtract`, [t5, n3]), {}, i3);
    return isConstantNode$1(o3) && !o3.value;
  }
  return i2(name$34$1, { "Node, Node": o2, "Node, Node, Object": o2 });
}), name$33$1 = `derivative`, dependencies$33$1 = [`typed`, `config`, `parse`, `simplify`, `equal`, `isZero`, `numeric`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createDerivative$1 = factory$1(name$33$1, dependencies$33$1, (t4) => {
  var { typed: n2, config: r2, parse: i2, simplify: a2, equal: o2, isZero: s2, numeric: c2, ConstantNode: l2, FunctionNode: u2, OperatorNode: d2, ParenthesisNode: p2, SymbolNode: m2 } = t4;
  function h2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { simplify: true }, i3 = /* @__PURE__ */ new Map(), o3 = n3.name;
    function s3(t6) {
      var n4 = i3.get(t6);
      if (n4 !== void 0) return n4;
      var r4 = b2(s3, t6, o3);
      return i3.set(t6, r4), r4;
    }
    var c3 = x2(t5, s3);
    return r3.simplify ? a2(c3) : c3;
  }
  function g2(t5) {
    var n3 = i2(t5);
    if (!n3.isSymbolNode) throw TypeError(`Invalid variable. Cannot parse ${JSON.stringify(t5)} into a variable in function derivative`);
    return n3;
  }
  var v2 = n2(name$33$1, { "Node, SymbolNode": h2, "Node, SymbolNode, Object": h2, "Node, string": (t5, n3) => h2(t5, g2(n3)), "Node, string, Object": (t5, n3, r3) => h2(t5, g2(n3), r3) });
  v2._simplify = true, v2.toTex = function(t5) {
    return y2.apply(null, t5.args);
  };
  var y2 = n2(`_derivTex`, { "Node, SymbolNode": function(t5, n3) {
    return isConstantNode$1(t5) && typeOf$1(t5.value) === `string` ? y2(i2(t5.value).toString(), n3.toString(), 1) : y2(t5.toTex(), n3.toString(), 1);
  }, "Node, ConstantNode": function(t5, n3) {
    if (typeOf$1(n3.value) === `string`) return y2(t5, i2(n3.value));
    throw Error(`The second parameter to 'derivative' is a non-string constant`);
  }, "Node, SymbolNode, ConstantNode": function(t5, n3, r3) {
    return y2(t5.toString(), n3.name, r3.value);
  }, "string, string, number": function(t5, n3, r3) {
    return (r3 === 1 ? `{d\\over d` + n3 + `}` : `{d^{` + r3 + `}\\over d` + n3 + `^{` + r3 + `}}`) + `\\left[${t5}\\right]`;
  } }), b2 = n2(`_isConst`, { "function, ConstantNode, string": function() {
    return true;
  }, "function, SymbolNode, string": function(t5, n3, r3) {
    return n3.name !== r3;
  }, "function, ParenthesisNode, string": function(t5, n3, r3) {
    return t5(n3.content, r3);
  }, "function, FunctionAssignmentNode, string": function(t5, n3, r3) {
    return n3.params.includes(r3) ? t5(n3.expr, r3) : true;
  }, "function, FunctionNode | OperatorNode, string": function(t5, n3, r3) {
    return n3.args.every((n4) => t5(n4, r3));
  } }), x2 = n2(`_derivative`, { "ConstantNode, function": function() {
    return S2(0);
  }, "SymbolNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : S2(1);
  }, "ParenthesisNode, function": function(t5, n3) {
    return new p2(x2(t5.content, n3));
  }, "FunctionAssignmentNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : x2(t5.expr, n3);
  }, "FunctionNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    var r3 = t5.args[0], i3, a3 = false, o3 = false, s3;
    switch (t5.name) {
      case `cbrt`:
        a3 = true, s3 = new d2(`*`, `multiply`, [S2(3), new d2(`^`, `pow`, [r3, new d2(`/`, `divide`, [S2(2), S2(3)])])]);
        break;
      case `sqrt`:
      case `nthRoot`:
        if (t5.args.length === 1) a3 = true, s3 = new d2(`*`, `multiply`, [S2(2), new u2(`sqrt`, [r3])]);
        else if (t5.args.length === 2) return i3 = new d2(`/`, `divide`, [S2(1), t5.args[1]]), x2(new d2(`^`, `pow`, [r3, i3]), n3);
        break;
      case `log10`:
        i3 = S2(10);
      case `log`:
        if (!i3 && t5.args.length === 1) s3 = r3.clone(), a3 = true;
        else if (t5.args.length === 1 && i3 || t5.args.length === 2 && n3(t5.args[1])) s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`log`, [i3 || t5.args[1]])]), a3 = true;
        else if (t5.args.length === 2) return x2(new d2(`/`, `divide`, [new u2(`log`, [r3]), new u2(`log`, [t5.args[1]])]), n3);
        break;
      case `pow`:
        if (t5.args.length === 2) return x2(new d2(`^`, `pow`, [r3, t5.args[1]]), n3);
        break;
      case `exp`:
        s3 = new u2(`exp`, [r3.clone()]);
        break;
      case `sin`:
        s3 = new u2(`cos`, [r3.clone()]);
        break;
      case `cos`:
        s3 = new d2(`-`, `unaryMinus`, [new u2(`sin`, [r3.clone()])]);
        break;
      case `tan`:
        s3 = new d2(`^`, `pow`, [new u2(`sec`, [r3.clone()]), S2(2)]);
        break;
      case `sec`:
        s3 = new d2(`*`, `multiply`, [t5, new u2(`tan`, [r3.clone()])]);
        break;
      case `csc`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`cot`, [r3.clone()])]);
        break;
      case `cot`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csc`, [r3.clone()]), S2(2)]);
        break;
      case `asin`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `acos`:
        a3 = true, o3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `atan`:
        a3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `asec`:
        a3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acsc`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acot`:
        a3 = true, o3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `sinh`:
        s3 = new u2(`cosh`, [r3.clone()]);
        break;
      case `cosh`:
        s3 = new u2(`sinh`, [r3.clone()]);
        break;
      case `tanh`:
        s3 = new d2(`^`, `pow`, [new u2(`sech`, [r3.clone()]), S2(2)]);
        break;
      case `sech`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`tanh`, [r3.clone()])]);
        break;
      case `csch`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`coth`, [r3.clone()])]);
        break;
      case `coth`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csch`, [r3.clone()]), S2(2)]);
        break;
      case `asinh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `acosh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `atanh`:
        a3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `asech`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])])]);
        break;
      case `acsch`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acoth`:
        a3 = true, o3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `abs`:
        s3 = new d2(`/`, `divide`, [new u2(new m2(`abs`), [r3.clone()]), r3.clone()]);
        break;
      default:
        throw Error(`Cannot process function "` + t5.name + `" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported`);
    }
    var c3, l3;
    a3 ? (c3 = `/`, l3 = `divide`) : (c3 = `*`, l3 = `multiply`);
    var p3 = x2(r3, n3);
    return o3 && (p3 = new d2(`-`, `unaryMinus`, [p3])), new d2(c3, l3, [p3, s3]);
  }, "OperatorNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    if (t5.op === `+`) return new d2(t5.op, t5.fn, t5.args.map(function(t6) {
      return x2(t6, n3);
    }));
    if (t5.op === `-`) {
      if (t5.isUnary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3)]);
      if (t5.isBinary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3), x2(t5.args[1], n3)]);
    }
    if (t5.op === `*`) {
      var r3 = t5.args.filter(function(t6) {
        return n3(t6);
      });
      if (r3.length > 0) {
        var i3 = t5.args.filter(function(t6) {
          return !n3(t6);
        }), a3 = i3.length === 1 ? i3[0] : new d2(`*`, `multiply`, i3);
        return new d2(`*`, `multiply`, r3.concat(x2(a3, n3)));
      }
      return new d2(`+`, `add`, t5.args.map(function(r4) {
        return new d2(`*`, `multiply`, t5.args.map(function(t6) {
          return t6 === r4 ? x2(t6, n3) : t6.clone();
        }));
      }));
    }
    if (t5.op === `/` && t5.isBinary()) {
      var c3 = t5.args[0], l3 = t5.args[1];
      return n3(l3) ? new d2(`/`, `divide`, [x2(c3, n3), l3]) : n3(c3) ? new d2(`*`, `multiply`, [new d2(`-`, `unaryMinus`, [c3]), new d2(`/`, `divide`, [x2(l3, n3), new d2(`^`, `pow`, [l3.clone(), S2(2)])])]) : new d2(`/`, `divide`, [new d2(`-`, `subtract`, [new d2(`*`, `multiply`, [x2(c3, n3), l3.clone()]), new d2(`*`, `multiply`, [c3.clone(), x2(l3, n3)])]), new d2(`^`, `pow`, [l3.clone(), S2(2)])]);
    }
    if (t5.op === `^` && t5.isBinary()) {
      var p3 = t5.args[0], m3 = t5.args[1];
      if (n3(p3)) return isConstantNode$1(p3) && (s2(p3.value) || o2(p3.value, 1)) ? S2(0) : new d2(`*`, `multiply`, [t5, new d2(`*`, `multiply`, [new u2(`log`, [p3.clone()]), x2(m3.clone(), n3)])]);
      if (n3(m3)) {
        if (isConstantNode$1(m3)) {
          if (s2(m3.value)) return S2(0);
          if (o2(m3.value, 1)) return x2(p3, n3);
        }
        var h3 = new d2(`^`, `pow`, [p3.clone(), new d2(`-`, `subtract`, [m3, S2(1)])]);
        return new d2(`*`, `multiply`, [m3.clone(), new d2(`*`, `multiply`, [x2(p3, n3), h3])]);
      }
      return new d2(`*`, `multiply`, [new d2(`^`, `pow`, [p3.clone(), m3.clone()]), new d2(`+`, `add`, [new d2(`*`, `multiply`, [x2(p3, n3), new d2(`/`, `divide`, [m3.clone(), p3.clone()])]), new d2(`*`, `multiply`, [x2(m3, n3), new u2(`log`, [p3.clone()])])])]);
    }
    throw Error(`Cannot process operator "` + t5.op + `" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported`);
  } });
  function S2(t5, n3) {
    return new l2(c2(t5, safeNumberType$1(String(t5), r2)));
  }
  return v2;
}), name$32$1 = `rationalize`, dependencies$32$1 = `config.typed.equal.isZero.add.subtract.multiply.divide.pow.parse.simplifyConstant.simplifyCore.simplify.?bignumber.?fraction.mathWithTransform.matrix.AccessorNode.ArrayNode.ConstantNode.FunctionNode.IndexNode.ObjectNode.OperatorNode.SymbolNode.ParenthesisNode`.split(`.`), createRationalize$1 = factory$1(name$32$1, dependencies$32$1, (t4) => {
  var { config: n2, typed: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, parse: d2, simplifyConstant: p2, simplifyCore: m2, simplify: h2, fraction: g2, bignumber: v2, mathWithTransform: y2, matrix: b2, AccessorNode: x2, ArrayNode: S2, ConstantNode: w2, FunctionNode: E, IndexNode: D, ObjectNode: O2, OperatorNode: j2, SymbolNode: M2, ParenthesisNode: N2 } = t4;
  function F(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, i3 = L2(), a3 = I2(t5, n3, true, i3.firstRules), o3 = a3.variables.length, s3 = { exactFractions: false }, c3 = { exactFractions: true };
    if (t5 = a3.expression, o3 >= 1) {
      t5 = R2(t5);
      var l3, u3, d3 = true, p3 = false;
      t5 = h2(t5, i3.firstRules, {}, s3);
      for (var m3; u3 = d3 ? i3.distrDivRules : i3.sucDivRules, t5 = h2(t5, u3, {}, c3), d3 = !d3, m3 = t5.toString(), m3 !== l3; ) p3 = true, l3 = m3;
      p3 && (t5 = h2(t5, i3.firstRulesAgain, {}, s3)), t5 = h2(t5, i3.finalRules, {}, s3);
    }
    var g3 = [], v3 = {};
    return t5.type === `OperatorNode` && t5.isBinary() && t5.op === `/` ? (o3 === 1 && (t5.args[0] = z2(t5.args[0], g3), t5.args[1] = z2(t5.args[1])), r3 && (v3.numerator = t5.args[0], v3.denominator = t5.args[1])) : (o3 === 1 && (t5 = z2(t5, g3)), r3 && (v3.numerator = t5, v3.denominator = null)), r3 ? (v3.coefficients = g3, v3.variables = a3.variables, v3.expression = t5, v3) : t5;
  }
  return r2(name$32$1, { Node: F, "Node, boolean": (t5, n3) => F(t5, {}, n3), "Node, Object": F, "Node, Object, boolean": F });
  function I2(t5, n3, r3, i3) {
    var a3 = [], o3 = h2(t5, i3, n3, { exactFractions: false });
    r3 = !!r3;
    var s3 = `+-*` + (r3 ? `/` : ``);
    l3(o3);
    var c3 = {};
    return c3.expression = o3, c3.variables = a3, c3;
    function l3(t6) {
      var n4 = t6.type;
      if (n4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (n4 === `OperatorNode`) if (t6.op === `^`) {
        if (t6.args[1].type !== `ConstantNode` || !isInteger$2(parseFloat(t6.args[1].value))) throw Error(`There is a non-integer exponent`);
        l3(t6.args[0]);
      } else {
        if (!s3.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid in polynomial expression`);
        for (var r4 = 0; r4 < t6.args.length; r4++) l3(t6.args[r4]);
      }
      else if (n4 === `SymbolNode`) {
        var i4 = t6.name;
        a3.indexOf(i4) === -1 && a3.push(i4);
      } else if (n4 === `ParenthesisNode`) l3(t6.content);
      else if (n4 !== `ConstantNode`) throw Error(`type ` + n4 + ` is not allowed in polynomial expression`);
    }
  }
  function L2() {
    var t5 = [m2, { l: `n+n`, r: `2*n` }, { l: `n+-n`, r: `0` }, p2, { l: `n*(n1^-1)`, r: `n/n1` }, { l: `n*n1^-n2`, r: `n/n1^n2` }, { l: `n1^-1`, r: `1/n1` }, { l: `n*(n1/n2)`, r: `(n*n1)/n2` }, { l: `1*n`, r: `n` }], n3 = [{ l: `(-n1)/(-n2)`, r: `n1/n2` }, { l: `(-n1)*(-n2)`, r: `n1*n2` }, { l: `n1--n2`, r: `n1+n2` }, { l: `n1-n2`, r: `n1+(-n2)` }, { l: `(n1+n2)*n3`, r: `(n1*n3 + n2*n3)` }, { l: `n1*(n2+n3)`, r: `(n1*n2+n1*n3)` }, { l: `c1*n + c2*n`, r: `(c1+c2)*n` }, { l: `c1*n + n`, r: `(c1+1)*n` }, { l: `c1*n - c2*n`, r: `(c1-c2)*n` }, { l: `c1*n - n`, r: `(c1-1)*n` }, { l: `v/c`, r: `(1/c)*v` }, { l: `v/-c`, r: `-(1/c)*v` }, { l: `-v*-c`, r: `c*v` }, { l: `-v*c`, r: `-c*v` }, { l: `v*-c`, r: `-c*v` }, { l: `v*c`, r: `c*v` }, { l: `-(-n1*n2)`, r: `(n1*n2)` }, { l: `-(n1*n2)`, r: `(-n1*n2)` }, { l: `-(-n1+n2)`, r: `(n1-n2)` }, { l: `-(n1+n2)`, r: `(-n1-n2)` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }, { l: `-(-n1/n2)`, r: `(n1/n2)` }, { l: `-(n1/n2)`, r: `(-n1/n2)` }], r3 = [{ l: `(n1/n2 + n3/n4)`, r: `((n1*n4 + n3*n2)/(n2*n4))` }, { l: `(n1/n2 + n3)`, r: `((n1 + n3*n2)/n2)` }, { l: `(n1 + n2/n3)`, r: `((n1*n3 + n2)/n3)` }], i3 = [{ l: `(n1/(n2/n3))`, r: `((n1*n3)/n2)` }, { l: `(n1/n2/n3)`, r: `(n1/(n2*n3))` }], a3 = {};
    return a3.firstRules = t5.concat(n3, i3), a3.distrDivRules = r3, a3.sucDivRules = i3, a3.firstRulesAgain = t5.concat(n3), a3.finalRules = [m2, { l: `n*-n`, r: `-n^2` }, { l: `n*n`, r: `n^2` }, p2, { l: `n*-n^n1`, r: `-n^(n1+1)` }, { l: `n*n^n1`, r: `n^(n1+1)` }, { l: `n^n1*-n^n2`, r: `-n^(n1+n2)` }, { l: `n^n1*n^n2`, r: `n^(n1+n2)` }, { l: `n^n1*-n`, r: `-n^(n1+1)` }, { l: `n^n1*n`, r: `n^(n1+1)` }, { l: `n^n1/-n`, r: `-n^(n1-1)` }, { l: `n^n1/n`, r: `n^(n1-1)` }, { l: `n/-n^n1`, r: `-n^(1-n1)` }, { l: `n/n^n1`, r: `n^(1-n1)` }, { l: `n^n1/-n^n2`, r: `n^(n1-n2)` }, { l: `n^n1/n^n2`, r: `n^(n1-n2)` }, { l: `n1+(-n2*n3)`, r: `n1-n2*n3` }, { l: `v*(-c)`, r: `-c*v` }, { l: `n1+-n2`, r: `n1-n2` }, { l: `v*c`, r: `c*v` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }], a3;
  }
  function R2(t5, n3, r3) {
    var i3 = t5.type, a3 = arguments.length > 1;
    if (i3 === `OperatorNode` && t5.isBinary()) {
      var o3 = false, s3;
      if (t5.op === `^` && (t5.args[0].type === `ParenthesisNode` || t5.args[0].type === `OperatorNode`) && t5.args[1].type === `ConstantNode` && (s3 = parseFloat(t5.args[1].value), o3 = s3 >= 2 && isInteger$2(s3)), o3) {
        if (s3 > 2) {
          var c3 = t5.args[0];
          t5 = new j2(`*`, `multiply`, [c3, new j2(`^`, `pow`, [t5.args[0].cloneDeep(), new w2(s3 - 1)])]);
        } else t5 = new j2(`*`, `multiply`, [t5.args[0], t5.args[0].cloneDeep()]);
        a3 && (r3 === `content` ? n3.content = t5 : n3.args[r3] = t5);
      }
    }
    if (i3 === `ParenthesisNode`) R2(t5.content, t5, `content`);
    else if (i3 !== `ConstantNode` && i3 !== `SymbolNode`) for (var l3 = 0; l3 < t5.args.length; l3++) R2(t5.args[l3], t5, l3);
    if (!a3) return t5;
  }
  function z2(t5, n3) {
    n3 === void 0 && (n3 = []), n3[0] = 0;
    var r3 = {};
    r3.cte = 1, r3.oper = `+`, r3.fire = ``;
    var i3 = 0, a3 = ``;
    m3(t5, null, r3), i3 = n3.length - 1;
    for (var o3 = true, s3, c3 = i3; c3 >= 0; c3--) if (n3[c3] !== 0) {
      var l3 = new w2(o3 ? n3[c3] : Math.abs(n3[c3])), u3 = n3[c3] < 0 ? `-` : `+`;
      if (c3 > 0) {
        var d3 = new M2(a3);
        if (c3 > 1) {
          var p3 = new w2(c3);
          d3 = new j2(`^`, `pow`, [d3, p3]);
        }
        l3 = n3[c3] === -1 && o3 ? new j2(`-`, `unaryMinus`, [d3]) : Math.abs(n3[c3]) === 1 ? d3 : new j2(`*`, `multiply`, [l3, d3]);
      }
      s3 = o3 ? l3 : u3 === `+` ? new j2(`+`, `add`, [s3, l3]) : new j2(`-`, `subtract`, [s3, l3]), o3 = false;
    }
    if (o3) return new w2(0);
    return s3;
    function m3(t6, r4, o4) {
      var s4 = t6.type;
      if (s4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (s4 === `OperatorNode`) {
        if (!`+-*^`.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid`);
        if (r4 !== null && ((t6.fn === `unaryMinus` || t6.fn === `pow`) && r4.fn !== `add` && r4.fn !== `subtract` && r4.fn !== `multiply` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `multiply`) && r4.fn !== `add` && r4.fn !== `subtract` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `unaryMinus`) && o4.noFil !== 0)) throw Error(`Invalid ` + t6.op + ` placing`);
        (t6.op === `^` || t6.op === `*`) && (o4.fire = t6.op);
        for (var c4 = 0; c4 < t6.args.length; c4++) t6.fn === `unaryMinus` && (o4.oper = `-`), (t6.op === `+` || t6.fn === `subtract`) && (o4.fire = ``, o4.cte = 1, o4.oper = c4 === 0 ? `+` : t6.op), o4.noFil = c4, m3(t6.args[c4], t6, o4);
      } else if (s4 === `SymbolNode`) {
        if (t6.name !== a3 && a3 !== ``) throw Error(`There is more than one variable`);
        if (a3 = t6.name, r4 === null) {
          n3[1] = 1;
          return;
        }
        if (r4.op === `^` && o4.noFil !== 0) throw Error(`In power the variable should be the first parameter`);
        if (r4.op === `*` && o4.noFil !== 1) throw Error(`In multiply the variable should be the second parameter`);
        (o4.fire === `` || o4.fire === `*`) && (i3 < 1 && (n3[1] = 0), n3[1] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(1, i3));
      } else if (s4 === `ConstantNode`) {
        var l4 = parseFloat(t6.value);
        if (r4 === null) {
          n3[0] = l4;
          return;
        }
        if (r4.op === `^`) {
          if (o4.noFil !== 1) throw Error(`Constant cannot be powered`);
          if (!isInteger$2(l4) || l4 <= 0) throw Error(`Non-integer exponent is not allowed`);
          for (var u4 = i3 + 1; u4 < l4; u4++) n3[u4] = 0;
          l4 > i3 && (n3[l4] = 0), n3[l4] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(l4, i3);
          return;
        }
        o4.cte = l4, o4.fire === `` && (n3[0] += o4.cte * (o4.oper === `+` ? 1 : -1));
      } else throw Error(`Type ` + s4 + ` is not allowed`);
    }
  }
}), name$31$1 = `zpk2tf`, dependencies$31$1 = [`typed`, `add`, `multiply`, `Complex`, `number`], createZpk2tf$1 = factory$1(name$31$1, dependencies$31$1, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, number: o2 } = t4;
  return n2(name$31$1, { "Array,Array,number": function(t5, n3, r3) {
    return s2(t5, n3, r3);
  }, "Array,Array": function(t5, n3) {
    return s2(t5, n3, 1);
  }, "Matrix,Matrix,number": function(t5, n3, r3) {
    return s2(t5.valueOf(), n3.valueOf(), r3);
  }, "Matrix,Matrix": function(t5, n3) {
    return s2(t5.valueOf(), n3.valueOf(), 1);
  } });
  function s2(t5, n3, r3) {
    t5.some((t6) => t6.type === `BigNumber`) && (t5 = t5.map((t6) => o2(t6))), n3.some((t6) => t6.type === `BigNumber`) && (n3 = n3.map((t6) => o2(t6)));
    for (var s3 = [a2(1, 0)], l2 = [a2(1, 0)], u2 = 0; u2 < t5.length; u2++) {
      var d2 = t5[u2];
      typeof d2 == `number` && (d2 = a2(d2, 0)), s3 = c2(s3, [a2(1, 0), a2(-d2.re, -d2.im)]);
    }
    for (var p2 = 0; p2 < n3.length; p2++) {
      var m2 = n3[p2];
      typeof m2 == `number` && (m2 = a2(m2, 0)), l2 = c2(l2, [a2(1, 0), a2(-m2.re, -m2.im)]);
    }
    for (var h2 = 0; h2 < s3.length; h2++) s3[h2] = i2(s3[h2], r3);
    return [s3, l2];
  }
  function c2(t5, n3) {
    for (var o3 = [], s3 = 0; s3 < t5.length + n3.length - 1; s3++) {
      o3[s3] = a2(0, 0);
      for (var c3 = 0; c3 < t5.length; c3++) s3 - c3 >= 0 && s3 - c3 < n3.length && (o3[s3] = r2(o3[s3], i2(t5[c3], n3[s3 - c3])));
    }
    return o3;
  }
}), name$30$1 = `freqz`, dependencies$30$1 = [`typed`, `add`, `multiply`, `Complex`, `divide`, `matrix`], createFreqz$1 = factory$1(name$30$1, dependencies$30$1, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, divide: o2, matrix: s2 } = t4;
  return n2(name$30$1, { "Array, Array": function(t5, n3) {
    return c2(t5, n3, l2(512));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return c2(t5, n3, r3);
  }, "Array, Array, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    return c2(t5, n3, l2(r3));
  }, "Matrix, Matrix": function(t5, n3) {
    var r3 = l2(512), { w: i3, h: a3 } = c2(t5.valueOf(), n3.valueOf(), r3);
    return { w: s2(i3), h: s2(a3) };
  }, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var { h: i3 } = c2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return { h: s2(i3), w: s2(r3) };
  }, "Matrix, Matrix, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    var i3 = l2(r3), { h: a3 } = c2(t5.valueOf(), n3.valueOf(), i3);
    return { h: s2(a3), w: s2(i3) };
  } });
  function c2(t5, n3, s3) {
    for (var c3 = [], l3 = [], u2 = 0; u2 < s3.length; u2++) {
      for (var d2 = a2(0, 0), p2 = a2(0, 0), m2 = 0; m2 < t5.length; m2++) d2 = r2(d2, i2(t5[m2], a2(Math.cos(-m2 * s3[u2]), Math.sin(-m2 * s3[u2]))));
      for (var h2 = 0; h2 < n3.length; h2++) p2 = r2(p2, i2(n3[h2], a2(Math.cos(-h2 * s3[u2]), Math.sin(-h2 * s3[u2]))));
      c3.push(d2), l3.push(p2);
    }
    for (var g2 = [], v2 = 0; v2 < c3.length; v2++) g2.push(o2(c3[v2], l3[v2]));
    return { h: g2, w: s3 };
  }
  function l2(t5) {
    for (var n3 = [], r3 = 0; r3 < t5; r3++) n3.push(r3 / t5 * Math.PI);
    return n3;
  }
}), name$29$1 = `reviver`, dependencies$29$1 = [`classes`], createReviver$1 = factory$1(name$29$1, dependencies$29$1, (t4) => {
  var { classes: n2 } = t4;
  return function(t5, r2) {
    var i2 = n2[r2 && r2.mathjs];
    return i2 && typeof i2.fromJSON == `function` ? i2.fromJSON(r2) : r2;
  };
}), name$28$1 = `replacer`, dependencies$28$1 = [], createReplacer$1 = factory$1(name$28$1, dependencies$28$1, () => function(t4, n2) {
  return typeof n2 == `number` && (!Number.isFinite(n2) || isNaN(n2)) ? { mathjs: `number`, value: String(n2) } : typeof n2 == `bigint` ? { mathjs: `bigint`, value: String(n2) } : n2;
}), version$1 = `15.2.0`, createTrue$1 = factory$1(`true`, [], () => true), createFalse$1 = factory$1(`false`, [], () => false), createNull$1 = factory$1(`null`, [], () => null), createInfinity$1 = recreateFactory$1(`Infinity`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1 / 0) : 1 / 0;
}), createNaN$1 = recreateFactory$1(`NaN`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(NaN) : NaN;
}), createPi$1 = recreateFactory$1(`pi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPi$1(r2) : pi$2;
}), createTau$1 = recreateFactory$1(`tau`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberTau$1(r2) : tau$1;
}), createE$1 = recreateFactory$1(`e`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberE$1(r2) : e$2;
}), createPhi$1 = recreateFactory$1(`phi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPhi$1(r2) : phi$1;
}), createLN2$1 = recreateFactory$1(`LN2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).ln() : Math.LN2;
}), createLN10$1 = recreateFactory$1(`LN10`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(10).ln() : Math.LN10;
}), createLOG2E$1 = recreateFactory$1(`LOG2E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(2).ln()) : Math.LOG2E;
}), createLOG10E$1 = recreateFactory$1(`LOG10E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(10).ln()) : Math.LOG10E;
}), createSQRT1_2$1 = recreateFactory$1(`SQRT1_2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(`0.5`).sqrt() : Math.SQRT1_2;
}), createSQRT2$1 = recreateFactory$1(`SQRT2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).sqrt() : Math.SQRT2;
}), createI$1 = recreateFactory$1(`i`, [`Complex`], (t4) => {
  var { Complex: n2 } = t4;
  return n2.I;
}), createUppercasePi$1 = factory$1(`PI`, [`pi`], (t4) => {
  var { pi: n2 } = t4;
  return n2;
}), createUppercaseE$1 = factory$1(`E`, [`e`], (t4) => {
  var { e: n2 } = t4;
  return n2;
}), createVersion$1 = factory$1(`version`, [], () => version$1);
function recreateFactory$1(t4, n2, r2) {
  return factory$1(t4, n2, r2, { recreateOnConfigChange: true });
}
var createSpeedOfLight$1 = unitFactory$1(`speedOfLight`, `299792458`, `m s^-1`), createGravitationConstant$1 = unitFactory$1(`gravitationConstant`, `6.67430e-11`, `m^3 kg^-1 s^-2`), createPlanckConstant$1 = unitFactory$1(`planckConstant`, `6.62607015e-34`, `J s`), createReducedPlanckConstant$1 = unitFactory$1(`reducedPlanckConstant`, `1.0545718176461565e-34`, `J s`), createMagneticConstant$1 = unitFactory$1(`magneticConstant`, `1.25663706212e-6`, `N A^-2`), createElectricConstant$1 = unitFactory$1(`electricConstant`, `8.8541878128e-12`, `F m^-1`), createVacuumImpedance$1 = unitFactory$1(`vacuumImpedance`, `376.730313667`, `ohm`), createCoulomb$1 = unitFactory$1(`coulomb`, `8.987551792261171e9`, `N m^2 C^-2`), createCoulombConstant$1 = unitFactory$1(`coulombConstant`, `8.987551792261171e9`, `N m^2 C^-2`), createElementaryCharge$1 = unitFactory$1(`elementaryCharge`, `1.602176634e-19`, `C`), createBohrMagneton$1 = unitFactory$1(`bohrMagneton`, `9.2740100783e-24`, `J T^-1`), createConductanceQuantum$1 = unitFactory$1(`conductanceQuantum`, `7.748091729863649e-5`, `S`), createInverseConductanceQuantum$1 = unitFactory$1(`inverseConductanceQuantum`, `12906.403729652257`, `ohm`), createMagneticFluxQuantum$1 = unitFactory$1(`magneticFluxQuantum`, `2.0678338484619295e-15`, `Wb`), createNuclearMagneton$1 = unitFactory$1(`nuclearMagneton`, `5.0507837461e-27`, `J T^-1`), createKlitzing$1 = unitFactory$1(`klitzing`, `25812.807459304513`, `ohm`), createBohrRadius$1 = unitFactory$1(`bohrRadius`, `5.29177210903e-11`, `m`), createClassicalElectronRadius$1 = unitFactory$1(`classicalElectronRadius`, `2.8179403262e-15`, `m`), createElectronMass$1 = unitFactory$1(`electronMass`, `9.1093837015e-31`, `kg`), createFermiCoupling$1 = unitFactory$1(`fermiCoupling`, `1.1663787e-5`, `GeV^-2`), createFineStructure$1 = numberFactory$1(`fineStructure`, 0.0072973525693), createHartreeEnergy$1 = unitFactory$1(`hartreeEnergy`, `4.3597447222071e-18`, `J`), createProtonMass$1 = unitFactory$1(`protonMass`, `1.67262192369e-27`, `kg`), createDeuteronMass$1 = unitFactory$1(`deuteronMass`, `3.3435830926e-27`, `kg`), createNeutronMass$1 = unitFactory$1(`neutronMass`, `1.6749271613e-27`, `kg`), createQuantumOfCirculation$1 = unitFactory$1(`quantumOfCirculation`, `3.6369475516e-4`, `m^2 s^-1`), createRydberg$1 = unitFactory$1(`rydberg`, `10973731.568160`, `m^-1`), createThomsonCrossSection$1 = unitFactory$1(`thomsonCrossSection`, `6.6524587321e-29`, `m^2`), createWeakMixingAngle$1 = numberFactory$1(`weakMixingAngle`, 0.2229), createEfimovFactor$1 = numberFactory$1(`efimovFactor`, 22.7), createAtomicMass$1 = unitFactory$1(`atomicMass`, `1.66053906660e-27`, `kg`), createAvogadro$1 = unitFactory$1(`avogadro`, `6.02214076e23`, `mol^-1`), createBoltzmann$1 = unitFactory$1(`boltzmann`, `1.380649e-23`, `J K^-1`), createFaraday$1 = unitFactory$1(`faraday`, `96485.33212331001`, `C mol^-1`), createFirstRadiation$1 = unitFactory$1(`firstRadiation`, `3.7417718521927573e-16`, `W m^2`), createLoschmidt$1 = unitFactory$1(`loschmidt`, `2.686780111798444e25`, `m^-3`), createGasConstant$1 = unitFactory$1(`gasConstant`, `8.31446261815324`, `J K^-1 mol^-1`), createMolarPlanckConstant$1 = unitFactory$1(`molarPlanckConstant`, `3.990312712893431e-10`, `J s mol^-1`), createMolarVolume$1 = unitFactory$1(`molarVolume`, `0.022413969545014137`, `m^3 mol^-1`), createSackurTetrode$1 = numberFactory$1(`sackurTetrode`, -1.16487052358), createSecondRadiation$1 = unitFactory$1(`secondRadiation`, `0.014387768775039337`, `m K`), createStefanBoltzmann$1 = unitFactory$1(`stefanBoltzmann`, `5.67037441918443e-8`, `W m^-2 K^-4`), createWienDisplacement$1 = unitFactory$1(`wienDisplacement`, `2.897771955e-3`, `m K`), createMolarMass$1 = unitFactory$1(`molarMass`, `0.99999999965e-3`, `kg mol^-1`), createMolarMassC12$1 = unitFactory$1(`molarMassC12`, `11.9999999958e-3`, `kg mol^-1`), createGravity$1 = unitFactory$1(`gravity`, `9.80665`, `m s^-2`), createPlanckLength$1 = unitFactory$1(`planckLength`, `1.616255e-35`, `m`), createPlanckMass$1 = unitFactory$1(`planckMass`, `2.176435e-8`, `kg`), createPlanckTime$1 = unitFactory$1(`planckTime`, `5.391245e-44`, `s`), createPlanckCharge$1 = unitFactory$1(`planckCharge`, `1.87554603778e-18`, `C`), createPlanckTemperature$1 = unitFactory$1(`planckTemperature`, `1.416785e+32`, `K`);
function unitFactory$1(t4, n2, r2) {
  return factory$1(t4, [`config`, `Unit`, `BigNumber`], (t5) => {
    var { config: i2, Unit: a2, BigNumber: o2 } = t5, s2 = new a2(i2.number === `BigNumber` ? new o2(n2) : parseFloat(n2), r2);
    return s2.fixPrefix = true, s2;
  });
}
function numberFactory$1(t4, n2) {
  return factory$1(t4, [`config`, `BigNumber`], (t5) => {
    var { config: r2, BigNumber: i2 } = t5;
    return r2.number === `BigNumber` ? new i2(n2) : n2;
  });
}
function ownKeys$5(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$5(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$5(Object(r2), true).forEach(function(n3) {
      _defineProperty$2(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$5(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$27$1 = `mapSlices`, dependencies$27$1 = [`typed`, `isInteger`], createMapSlicesTransform$1 = factory$1(name$27$1, dependencies$27$1, (t4) => {
  var { typed: n2, isInteger: r2 } = t4, i2 = createMapSlices$1({ typed: n2, isInteger: r2 });
  return n2(`mapSlices`, { "...any": function(t5) {
    var n3 = t5[1];
    isNumber$1(n3) ? t5[1] = n3 - 1 : isBigNumber$1(n3) && (t5[1] = n3.minus(1));
    try {
      return i2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, _objectSpread$5({ isTransformFunction: true }, createMapSlices$1.meta)), name$26$1 = `column`, dependencies$26$1 = [`typed`, `Index`, `matrix`, `range`], createColumnTransform$1 = factory$1(name$26$1, dependencies$26$1, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createColumn$1({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`column`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$1(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true });
function compileInlineExpression$1(t4, n2, r2) {
  var i2 = t4.filter(function(t5) {
    return isSymbolNode$1(t5) && !(t5.name in n2) && !r2.has(t5.name);
  })[0];
  if (!i2) throw Error(`No undefined variable found in inline expression "` + t4 + `"`);
  var a2 = i2.name, o2 = /* @__PURE__ */ new Map(), s2 = new PartitionedMap$1(r2, o2, /* @__PURE__ */ new Set([a2])), c2 = t4.compile();
  return function(t5) {
    return o2.set(a2, t5), c2.evaluate(s2);
  };
}
var name$25$1 = `transformCallback`, dependencies$25$1 = [`typed`], createTransformCallback$1 = factory$1(name$25$1, dependencies$25$1, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2) {
    return n2.isTypedFunction(t5) ? r2(t5, i2) : _transformCallbackFunction$1(t5, t5.length, i2);
  };
  function r2(t5, i2) {
    var a2 = Object.fromEntries(Object.entries(t5.signatures).map((t6) => {
      var [a3, o2] = t6, s2 = a3.split(`,`).length;
      return n2.isTypedFunction(o2) ? [a3, r2(o2, i2)] : [a3, _transformCallbackFunction$1(o2, s2, i2)];
    }));
    return typeof t5.name == `string` ? n2(t5.name, a2) : n2(a2);
  }
});
function _transformCallbackFunction$1(t4, n2, r2) {
  return n2 === r2 ? t4 : n2 === r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims$1(n3[r2]);
    return t4(...i2, a2);
  } : n2 > r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims$1(n3[r2]), o2 = n3.slice(r2 + 1);
    return t4(...i2, a2, ...o2);
  } : t4;
}
function _transformDims$1(t4) {
  return t4.map((t5) => t5 + 1);
}
var name$24$1 = `filter`, dependencies$24$1 = [`typed`], createFilterTransform$1 = factory$1(name$24$1, dependencies$24$1, (t4) => {
  var { typed: n2 } = t4;
  function r2(t5, r3, a2) {
    var o2 = createFilter$1({ typed: n2 }), s2 = createTransformCallback$1({ typed: n2 });
    if (t5.length === 0) return o2();
    var c2 = t5[0];
    if (t5.length === 1) return o2(c2);
    var l2 = t5.length - 1, u2 = t5[l2];
    return c2 &&= i2(c2, a2), u2 &&= isSymbolNode$1(u2) || isFunctionAssignmentNode$1(u2) ? i2(u2, a2) : compileInlineExpression$1(u2, r3, a2), o2(c2, s2(u2, l2));
  }
  r2.rawArgs = true;
  function i2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return r2;
}, { isTransformFunction: true }), name$23$1 = `forEach`, dependencies$23$1 = [`typed`], createForEachTransform$1 = factory$1(name$23$1, dependencies$23$1, (t4) => {
  var { typed: n2 } = t4, r2 = createForEach$1({ typed: n2 }), i2 = createTransformCallback$1({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    var s2 = t5[0];
    if (t5.length === 1) return r2(s2);
    var c2 = t5.length - 1, l2 = t5[c2];
    return s2 &&= o2(s2, a3), l2 &&= isSymbolNode$1(l2) || isFunctionAssignmentNode$1(l2) ? o2(l2, a3) : compileInlineExpression$1(l2, n3, a3), r2(s2, i2(l2, c2));
  }
  a2.rawArgs = true;
  function o2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return a2;
}, { isTransformFunction: true }), name$22$1 = `index`, dependencies$22$1 = [`Index`, `getMatrixDataType`], createIndexTransform$1 = factory$1(name$22$1, dependencies$22$1, (t4) => {
  var { Index: n2, getMatrixDataType: r2 } = t4;
  return function() {
    for (var t5 = [], i2 = 0, a2 = arguments.length; i2 < a2; i2++) {
      var o2 = arguments[i2];
      if (isRange$1(o2)) o2.start--, o2.end -= o2.step > 0 ? 0 : 2;
      else if (o2 && o2.isSet === true) o2 = o2.map(function(t6) {
        return t6 - 1;
      });
      else if (isArray$1(o2) || isMatrix$1(o2)) r2(o2) !== `boolean` && (o2 = o2.map(function(t6) {
        return t6 - 1;
      }));
      else if (isNumber$1(o2) || isBigInt$1(o2)) o2--;
      else if (isBigNumber$1(o2)) o2 = o2.toNumber() - 1;
      else if (typeof o2 != `string`) throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      t5[i2] = o2;
    }
    var s2 = new n2();
    return n2.apply(s2, t5), s2;
  };
}, { isTransformFunction: true }), name$21$1 = `map`, dependencies$21$1 = [`typed`], createMapTransform$1 = factory$1(name$21$1, dependencies$21$1, (t4) => {
  var { typed: n2 } = t4, r2 = createMap$2({ typed: n2 }), i2 = createTransformCallback$1({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    if (t5.length === 1) return r2(t5[0]);
    var o2 = t5.length - 1, s2 = t5.slice(0, o2), c2 = t5[o2];
    return s2 = s2.map((t6) => l2(t6, a3)), c2 &&= isSymbolNode$1(c2) || isFunctionAssignmentNode$1(c2) ? l2(c2, a3) : compileInlineExpression$1(c2, n3, a3), r2(...s2, i2(c2, o2));
    function l2(t6, n4) {
      return t6.compile().evaluate(n4);
    }
  }
  return a2.rawArgs = true, a2;
}, { isTransformFunction: true });
function dimToZeroBase$1(t4) {
  return isNumber$1(t4) ? t4 - 1 : isBigNumber$1(t4) ? t4.minus(1) : t4;
}
function isNumberOrBigNumber$1(t4) {
  return isNumber$1(t4) || isBigNumber$1(t4);
}
function lastDimToZeroBase$1(t4) {
  if (t4.length === 2 && isCollection$1(t4[0])) {
    t4 = t4.slice();
    var n2 = t4[1];
    isNumberOrBigNumber$1(n2) && (t4[1] = dimToZeroBase$1(n2));
  }
  return t4;
}
var name$20$1 = `max`, dependencies$20$1 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMaxTransform$1 = factory$1(name$20$1, dependencies$20$1, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4, s2 = createMax$1({ typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 });
  return n2(`max`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$19$1 = `mean`, dependencies$19$1 = [`typed`, `add`, `divide`], createMeanTransform$1 = factory$1(name$19$1, dependencies$19$1, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4, a2 = createMean$1({ typed: n2, add: r2, divide: i2 });
  return n2(`mean`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$18$1 = `min`, dependencies$18$1 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMinTransform$1 = factory$1(name$18$1, dependencies$18$1, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4, s2 = createMin$1({ typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 });
  return n2(`min`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$17$1 = `range`, dependencies$17$1 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRangeTransform$1 = factory$1(name$17$1, dependencies$17$1, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 } = t4, h2 = createRange$1({ typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 });
  return n2(`range`, { "...any": function(t5) {
    return typeof t5[t5.length - 1] != `boolean` && t5.push(true), h2.apply(null, t5);
  } });
}, { isTransformFunction: true }), name$16$1 = `row`, dependencies$16$1 = [`typed`, `Index`, `matrix`, `range`], createRowTransform$1 = factory$1(name$16$1, dependencies$16$1, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createRow$1({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`row`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$1(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$15$1 = `subset`, dependencies$15$1 = [`typed`, `matrix`, `zeros`, `add`], createSubsetTransform$1 = factory$1(name$15$1, dependencies$15$1, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createSubset$1({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(`subset`, { "...any": function(t5) {
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$14$1 = `concat`, dependencies$14$1 = [`typed`, `matrix`, `isInteger`], createConcatTransform$1 = factory$1(name$14$1, dependencies$14$1, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4, a2 = createConcat$1({ typed: n2, matrix: r2, isInteger: i2 });
  return n2(`concat`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber$1(r3) ? t5[n3] = r3 - 1 : isBigNumber$1(r3) && (t5[n3] = r3.minus(1));
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$13$1 = `diff`, dependencies$13$1 = [`typed`, `matrix`, `subtract`, `number`, `bignumber`], createDiffTransform$1 = factory$1(name$13$1, dependencies$13$1, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 } = t4, s2 = createDiff$1({ typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 });
  return n2(name$13$1, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$12$1 = `std`, dependencies$12$1 = [`typed`, `map`, `sqrt`, `variance`], createStdTransform$1 = factory$1(name$12$1, dependencies$12$1, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4, o2 = createStd$1({ typed: n2, map: r2, sqrt: i2, variance: a2 });
  return n2(`std`, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$11$1 = `sum`, dependencies$11$1 = [`typed`, `config`, `add`, `numeric`], createSumTransform$1 = factory$1(name$11$1, dependencies$11$1, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4, o2 = createSum$1({ typed: n2, config: r2, add: i2, numeric: a2 });
  return n2(name$11$1, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$10$1 = `quantileSeq`, dependencies$10$1 = [`typed`, `bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeqTransform$1 = factory$1(name$10$1, dependencies$10$1, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4, g2 = createQuantileSeq$1({ typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 });
  return n2(`quantileSeq`, { "Array | Matrix, number | BigNumber": g2, "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, number | BigNumber, boolean": g2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)), "Array | Matrix, Array | Matrix": g2, "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, Array | Matrix, boolean": g2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)) });
  function v2(t5) {
    return lastDimToZeroBase$1([[], t5])[1];
  }
}, { isTransformFunction: true }), name$9$1 = `cumsum`, dependencies$9$1 = [`typed`, `add`, `unaryPlus`], createCumSumTransform$1 = factory$1(name$9$1, dependencies$9$1, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4, a2 = createCumSum$1({ typed: n2, add: r2, unaryPlus: i2 });
  return n2(name$9$1, { "...any": function(t5) {
    if (t5.length === 2 && isCollection$1(t5[0])) {
      var n3 = t5[1];
      isNumber$1(n3) ? t5[1] = n3 - 1 : isBigNumber$1(n3) && (t5[1] = n3.minus(1));
    }
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$8$1 = `variance`, dependencies$8$1 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVarianceTransform$1 = factory$1(name$8$1, dependencies$8$1, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4, l2 = createVariance$1({ typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 });
  return n2(name$8$1, { "...any": function(t5) {
    t5 = lastDimToZeroBase$1(t5);
    try {
      return l2.apply(null, t5);
    } catch (t6) {
      throw errorTransform$1(t6);
    }
  } });
}, { isTransformFunction: true }), name$7$1 = `print`, dependencies$7$1 = [`typed`, `matrix`, `zeros`, `add`], createPrintTransform$1 = factory$1(name$7$1, dependencies$7$1, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createPrint$1({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(name$7$1, { "string, Object | Array": function(t5, n3) {
    return o2(s2(t5), n3);
  }, "string, Object | Array, number | Object": function(t5, n3, r3) {
    return o2(s2(t5), n3, r3);
  } });
  function s2(t5) {
    return t5.replace(printTemplate$1, (t6) => `$` + t6.slice(1).split(`.`).map(function(t7) {
      return !isNaN(t7) && t7.length > 0 ? parseInt(t7) - 1 : t7;
    }).join(`.`));
  }
}, { isTransformFunction: true }), name$6$1 = `and`, dependencies$6$1 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createAndTransform$1 = factory$1(name$6$1, dependencies$6$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createAnd$1({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$1(i3) && !c2(i3, true) ? false : c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$5$1 = `or`, dependencies$5$1 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOrTransform$1 = factory$1(name$5$1, dependencies$5$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createOr$1({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$1(i3) && s2(i3, false) ? true : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$4$1 = `nullish`, dependencies$4$1 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullishTransform$1 = factory$1(name$4$1, dependencies$4$1, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createNullish$1({ typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection$1(i3) && i3 != null && i3 !== void 0 ? i3 : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$3$1 = `bitAnd`, dependencies$3$1 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createBitAndTransform$1 = factory$1(name$3$1, dependencies$3$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createBitAnd$1({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection$1(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === 0 || i3 === false) return 0;
    }
    return c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$2$1 = `bitOr`, dependencies$2$1 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOrTransform$1 = factory$1(name$2$1, dependencies$2$1, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createBitOr$1({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection$1(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === -1) return -1;
      if (i3 === true) return 1;
    }
    return s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$1$1 = `num`, dependencies$1$1 = [`typed`, `fraction`], createNum$1 = factory$1(name$1$1, dependencies$1$1, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name$1$1, { Fraction: (t5) => t5.s * t5.n, BigNumber: (t5) => {
    var n3 = r2(t5);
    return n3.s * n3.n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), name$c = `den`, dependencies$a = [`typed`, `fraction`], createDen$1 = factory$1(name$c, dependencies$a, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name$c, { Fraction: (t5) => t5.d, BigNumber: (t5) => r2(t5).d, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap$2(n3, t5)) });
}), factoriesAny_exports$1 = __exportAll$1({ createAbs: () => createAbs$1, createAccessorNode: () => createAccessorNode$1, createAcos: () => createAcos$1, createAcosh: () => createAcosh$1, createAcot: () => createAcot$1, createAcoth: () => createAcoth$1, createAcsc: () => createAcsc$1, createAcsch: () => createAcsch$1, createAdd: () => createAdd$1, createAddScalar: () => createAddScalar$1, createAnd: () => createAnd$1, createAndTransform: () => createAndTransform$1, createArg: () => createArg$1, createArrayNode: () => createArrayNode$1, createAsec: () => createAsec$1, createAsech: () => createAsech$1, createAsin: () => createAsin$1, createAsinh: () => createAsinh$1, createAssignmentNode: () => createAssignmentNode$1, createAtan: () => createAtan$1, createAtan2: () => createAtan2$1, createAtanh: () => createAtanh$1, createAtomicMass: () => createAtomicMass$1, createAvogadro: () => createAvogadro$1, createBellNumbers: () => createBellNumbers$1, createBernoulli: () => createBernoulli$1, createBigNumberClass: () => createBigNumberClass$1, createBigint: () => createBigint$1, createBignumber: () => createBignumber$1, createBin: () => createBin$1, createBitAnd: () => createBitAnd$1, createBitAndTransform: () => createBitAndTransform$1, createBitNot: () => createBitNot$1, createBitOr: () => createBitOr$1, createBitOrTransform: () => createBitOrTransform$1, createBitXor: () => createBitXor$1, createBlockNode: () => createBlockNode$1, createBohrMagneton: () => createBohrMagneton$1, createBohrRadius: () => createBohrRadius$1, createBoltzmann: () => createBoltzmann$1, createBoolean: () => createBoolean$1, createCatalan: () => createCatalan$1, createCbrt: () => createCbrt$1, createCeil: () => createCeil$1, createChain: () => createChain$1, createChainClass: () => createChainClass$1, createClassicalElectronRadius: () => createClassicalElectronRadius$1, createClone: () => createClone$1, createColumn: () => createColumn$1, createColumnTransform: () => createColumnTransform$1, createCombinations: () => createCombinations$1, createCombinationsWithRep: () => createCombinationsWithRep$1, createCompare: () => createCompare$1, createCompareNatural: () => createCompareNatural$1, createCompareText: () => createCompareText$1, createCompile: () => createCompile$1, createComplex: () => createComplex$1, createComplexClass: () => createComplexClass$1, createComposition: () => createComposition$1, createConcat: () => createConcat$1, createConcatTransform: () => createConcatTransform$1, createConditionalNode: () => createConditionalNode$1, createConductanceQuantum: () => createConductanceQuantum$1, createConj: () => createConj$1, createConstantNode: () => createConstantNode$1, createCorr: () => createCorr$1, createCos: () => createCos$1, createCosh: () => createCosh$1, createCot: () => createCot$1, createCoth: () => createCoth$1, createCoulomb: () => createCoulomb$1, createCoulombConstant: () => createCoulombConstant$1, createCount: () => createCount$1, createCreateUnit: () => createCreateUnit$1, createCross: () => createCross$1, createCsc: () => createCsc$1, createCsch: () => createCsch$1, createCtranspose: () => createCtranspose$1, createCube: () => createCube$1, createCumSum: () => createCumSum$1, createCumSumTransform: () => createCumSumTransform$1, createDeepEqual: () => createDeepEqual$1, createDen: () => createDen$1, createDenseMatrixClass: () => createDenseMatrixClass$1, createDerivative: () => createDerivative$1, createDet: () => createDet$1, createDeuteronMass: () => createDeuteronMass$1, createDiag: () => createDiag$1, createDiff: () => createDiff$1, createDiffTransform: () => createDiffTransform$1, createDistance: () => createDistance$1, createDivide: () => createDivide$1, createDivideScalar: () => createDivideScalar$1, createDot: () => createDot$1, createDotDivide: () => createDotDivide$1, createDotMultiply: () => createDotMultiply$1, createDotPow: () => createDotPow$1, createE: () => createE$1, createEfimovFactor: () => createEfimovFactor$1, createEigs: () => createEigs$1, createElectricConstant: () => createElectricConstant$1, createElectronMass: () => createElectronMass$1, createElementaryCharge: () => createElementaryCharge$1, createEqual: () => createEqual$1, createEqualScalar: () => createEqualScalar$1, createEqualText: () => createEqualText$1, createErf: () => createErf$1, createEvaluate: () => createEvaluate$1, createExp: () => createExp$1, createExpm: () => createExpm$1, createExpm1: () => createExpm1$1, createFactorial: () => createFactorial$1, createFalse: () => createFalse$1, createFaraday: () => createFaraday$1, createFermiCoupling: () => createFermiCoupling$1, createFft: () => createFft$1, createFibonacciHeapClass: () => createFibonacciHeapClass$1, createFilter: () => createFilter$1, createFilterTransform: () => createFilterTransform$1, createFineStructure: () => createFineStructure$1, createFirstRadiation: () => createFirstRadiation$1, createFix: () => createFix$1, createFlatten: () => createFlatten$1, createFloor: () => createFloor$1, createForEach: () => createForEach$1, createForEachTransform: () => createForEachTransform$1, createFormat: () => createFormat$1, createFraction: () => createFraction$1, createFractionClass: () => createFractionClass$1, createFreqz: () => createFreqz$1, createFunctionAssignmentNode: () => createFunctionAssignmentNode$1, createFunctionNode: () => createFunctionNode$1, createGamma: () => createGamma$1, createGasConstant: () => createGasConstant$1, createGcd: () => createGcd$1, createGetMatrixDataType: () => createGetMatrixDataType$1, createGravitationConstant: () => createGravitationConstant$1, createGravity: () => createGravity$1, createHartreeEnergy: () => createHartreeEnergy$1, createHasNumericValue: () => createHasNumericValue$1, createHelp: () => createHelp$1, createHelpClass: () => createHelpClass$1, createHex: () => createHex$1, createHypot: () => createHypot$1, createI: () => createI$1, createIdentity: () => createIdentity$1, createIfft: () => createIfft$1, createIm: () => createIm$1, createImmutableDenseMatrixClass: () => createImmutableDenseMatrixClass$1, createIndex: () => createIndex$1, createIndexClass: () => createIndexClass$1, createIndexNode: () => createIndexNode$1, createIndexTransform: () => createIndexTransform$1, createInfinity: () => createInfinity$1, createIntersect: () => createIntersect$1, createInv: () => createInv$1, createInverseConductanceQuantum: () => createInverseConductanceQuantum$1, createInvmod: () => createInvmod$1, createIsBounded: () => createIsBounded$1, createIsFinite: () => createIsFinite$1, createIsInteger: () => createIsInteger$1, createIsNaN: () => createIsNaN$1, createIsNegative: () => createIsNegative$1, createIsNumeric: () => createIsNumeric$1, createIsPositive: () => createIsPositive$1, createIsPrime: () => createIsPrime$1, createIsZero: () => createIsZero$1, createKldivergence: () => createKldivergence$1, createKlitzing: () => createKlitzing$1, createKron: () => createKron$1, createLN10: () => createLN10$1, createLN2: () => createLN2$1, createLOG10E: () => createLOG10E$1, createLOG2E: () => createLOG2E$1, createLarger: () => createLarger$1, createLargerEq: () => createLargerEq$1, createLcm: () => createLcm$1, createLeafCount: () => createLeafCount$1, createLeftShift: () => createLeftShift$1, createLgamma: () => createLgamma$1, createLog: () => createLog$1, createLog10: () => createLog10$1, createLog1p: () => createLog1p$1, createLog2: () => createLog2$1, createLoschmidt: () => createLoschmidt$1, createLsolve: () => createLsolve$1, createLsolveAll: () => createLsolveAll$1, createLup: () => createLup$1, createLusolve: () => createLusolve$1, createLyap: () => createLyap$1, createMad: () => createMad$1, createMagneticConstant: () => createMagneticConstant$1, createMagneticFluxQuantum: () => createMagneticFluxQuantum$1, createMap: () => createMap$2, createMapSlices: () => createMapSlices$1, createMapSlicesTransform: () => createMapSlicesTransform$1, createMapTransform: () => createMapTransform$1, createMatrix: () => createMatrix$1, createMatrixClass: () => createMatrixClass$1, createMatrixFromColumns: () => createMatrixFromColumns$1, createMatrixFromFunction: () => createMatrixFromFunction$1, createMatrixFromRows: () => createMatrixFromRows$1, createMax: () => createMax$1, createMaxTransform: () => createMaxTransform$1, createMean: () => createMean$1, createMeanTransform: () => createMeanTransform$1, createMedian: () => createMedian$1, createMin: () => createMin$1, createMinTransform: () => createMinTransform$1, createMod: () => createMod$1, createMode: () => createMode$1, createMolarMass: () => createMolarMass$1, createMolarMassC12: () => createMolarMassC12$1, createMolarPlanckConstant: () => createMolarPlanckConstant$1, createMolarVolume: () => createMolarVolume$1, createMultinomial: () => createMultinomial$1, createMultiply: () => createMultiply$1, createMultiplyScalar: () => createMultiplyScalar$1, createNaN: () => createNaN$1, createNeutronMass: () => createNeutronMass$1, createNode: () => createNode$1, createNorm: () => createNorm$1, createNot: () => createNot$1, createNthRoot: () => createNthRoot$1, createNthRoots: () => createNthRoots$1, createNuclearMagneton: () => createNuclearMagneton$1, createNull: () => createNull$1, createNullish: () => createNullish$1, createNullishTransform: () => createNullishTransform$1, createNum: () => createNum$1, createNumber: () => createNumber$1, createNumeric: () => createNumeric$1, createObjectNode: () => createObjectNode$1, createOct: () => createOct$1, createOnes: () => createOnes$1, createOperatorNode: () => createOperatorNode$1, createOr: () => createOr$1, createOrTransform: () => createOrTransform$1, createParenthesisNode: () => createParenthesisNode$1, createParse: () => createParse$1, createParser: () => createParser$1, createParserClass: () => createParserClass$1, createPartitionSelect: () => createPartitionSelect$1, createPermutations: () => createPermutations$1, createPhi: () => createPhi$1, createPi: () => createPi$1, createPickRandom: () => createPickRandom$1, createPinv: () => createPinv$1, createPlanckCharge: () => createPlanckCharge$1, createPlanckConstant: () => createPlanckConstant$1, createPlanckLength: () => createPlanckLength$1, createPlanckMass: () => createPlanckMass$1, createPlanckTemperature: () => createPlanckTemperature$1, createPlanckTime: () => createPlanckTime$1, createPolynomialRoot: () => createPolynomialRoot$1, createPow: () => createPow$1, createPrint: () => createPrint$1, createPrintTransform: () => createPrintTransform$1, createProd: () => createProd$1, createProtonMass: () => createProtonMass$1, createQr: () => createQr$1, createQuantileSeq: () => createQuantileSeq$1, createQuantileSeqTransform: () => createQuantileSeqTransform$1, createQuantumOfCirculation: () => createQuantumOfCirculation$1, createRandom: () => createRandom$1, createRandomInt: () => createRandomInt$1, createRange: () => createRange$1, createRangeClass: () => createRangeClass$1, createRangeNode: () => createRangeNode$1, createRangeTransform: () => createRangeTransform$1, createRationalize: () => createRationalize$1, createRe: () => createRe$1, createReducedPlanckConstant: () => createReducedPlanckConstant$1, createRelationalNode: () => createRelationalNode$1, createReplacer: () => createReplacer$1, createReshape: () => createReshape$1, createResize: () => createResize$1, createResolve: () => createResolve$1, createResultSet: () => createResultSet$1, createReviver: () => createReviver$1, createRightArithShift: () => createRightArithShift$1, createRightLogShift: () => createRightLogShift$1, createRotate: () => createRotate$1, createRotationMatrix: () => createRotationMatrix$1, createRound: () => createRound$1, createRow: () => createRow$1, createRowTransform: () => createRowTransform$1, createRydberg: () => createRydberg$1, createSQRT1_2: () => createSQRT1_2$1, createSQRT2: () => createSQRT2$1, createSackurTetrode: () => createSackurTetrode$1, createSchur: () => createSchur$1, createSec: () => createSec$1, createSech: () => createSech$1, createSecondRadiation: () => createSecondRadiation$1, createSetCartesian: () => createSetCartesian$1, createSetDifference: () => createSetDifference$1, createSetDistinct: () => createSetDistinct$1, createSetIntersect: () => createSetIntersect$1, createSetIsSubset: () => createSetIsSubset$1, createSetMultiplicity: () => createSetMultiplicity$1, createSetPowerset: () => createSetPowerset$1, createSetSize: () => createSetSize$1, createSetSymDifference: () => createSetSymDifference$1, createSetUnion: () => createSetUnion$1, createSign: () => createSign$1, createSimplify: () => createSimplify$1, createSimplifyConstant: () => createSimplifyConstant$1, createSimplifyCore: () => createSimplifyCore$1, createSin: () => createSin$1, createSinh: () => createSinh$1, createSize: () => createSize$1, createSlu: () => createSlu$1, createSmaller: () => createSmaller$1, createSmallerEq: () => createSmallerEq$1, createSolveODE: () => createSolveODE$1, createSort: () => createSort$1, createSpaClass: () => createSpaClass$1, createSparse: () => createSparse$1, createSparseMatrixClass: () => createSparseMatrixClass$1, createSpeedOfLight: () => createSpeedOfLight$1, createSplitUnit: () => createSplitUnit$1, createSqrt: () => createSqrt$1, createSqrtm: () => createSqrtm$1, createSquare: () => createSquare$1, createSqueeze: () => createSqueeze$1, createStd: () => createStd$1, createStdTransform: () => createStdTransform$1, createStefanBoltzmann: () => createStefanBoltzmann$1, createStirlingS2: () => createStirlingS2$1, createString: () => createString$1, createSubset: () => createSubset$1, createSubsetTransform: () => createSubsetTransform$1, createSubtract: () => createSubtract$1, createSubtractScalar: () => createSubtractScalar$1, createSum: () => createSum$1, createSumTransform: () => createSumTransform$1, createSylvester: () => createSylvester$1, createSymbolNode: () => createSymbolNode$1, createSymbolicEqual: () => createSymbolicEqual$1, createTan: () => createTan$1, createTanh: () => createTanh$1, createTau: () => createTau$1, createThomsonCrossSection: () => createThomsonCrossSection$1, createTo: () => createTo$1, createToBest: () => createToBest$1, createTrace: () => createTrace$1, createTranspose: () => createTranspose$1, createTrue: () => createTrue$1, createTypeOf: () => createTypeOf$1, createTyped: () => createTyped$1, createUnaryMinus: () => createUnaryMinus$1, createUnaryPlus: () => createUnaryPlus$1, createUnequal: () => createUnequal$1, createUnitClass: () => createUnitClass$1, createUnitFunction: () => createUnitFunction$1, createUppercaseE: () => createUppercaseE$1, createUppercasePi: () => createUppercasePi$1, createUsolve: () => createUsolve$1, createUsolveAll: () => createUsolveAll$1, createVacuumImpedance: () => createVacuumImpedance$1, createVariance: () => createVariance$1, createVarianceTransform: () => createVarianceTransform$1, createVersion: () => createVersion$1, createWeakMixingAngle: () => createWeakMixingAngle$1, createWienDisplacement: () => createWienDisplacement$1, createXgcd: () => createXgcd$1, createXor: () => createXor$1, createZeros: () => createZeros$1, createZeta: () => createZeta$1, createZpk2tf: () => createZpk2tf$1 }), all$1 = factoriesAny_exports$1, require_tiny_emitter$1 = __commonJSMin$1(((t4, n2) => {
  function r2() {
  }
  r2.prototype = { on: function(t5, n3, r3) {
    var i2 = this.e ||= {};
    return (i2[t5] || (i2[t5] = [])).push({ fn: n3, ctx: r3 }), this;
  }, once: function(t5, n3, r3) {
    var i2 = this;
    function a2() {
      i2.off(t5, a2), n3.apply(r3, arguments);
    }
    return a2._ = n3, this.on(t5, a2, r3);
  }, emit: function(t5) {
    for (var n3 = [].slice.call(arguments, 1), r3 = ((this.e ||= {})[t5] || []).slice(), i2 = 0, a2 = r3.length; i2 < a2; i2++) r3[i2].fn.apply(r3[i2].ctx, n3);
    return this;
  }, off: function(t5, n3) {
    var r3 = this.e ||= {}, i2 = r3[t5], a2 = [];
    if (i2 && n3) for (var o2 = 0, s2 = i2.length; o2 < s2; o2++) i2[o2].fn !== n3 && i2[o2].fn._ !== n3 && a2.push(i2[o2]);
    return a2.length ? r3[t5] = a2 : delete r3[t5], this;
  } }, n2.exports = r2, n2.exports.TinyEmitter = r2;
})), import_tiny_emitter$1 = __toESM$1(require_tiny_emitter$1());
function mixin$1$1(t4) {
  var n2 = new import_tiny_emitter$1.default();
  return t4.on = n2.on.bind(n2), t4.off = n2.off.bind(n2), t4.once = n2.once.bind(n2), t4.emit = n2.emit.bind(n2), t4;
}
function importFactory$1(t4, n2, r2, i2) {
  function a2(t5, n3) {
    var r3 = arguments.length;
    if (r3 !== 1 && r3 !== 2) throw new ArgumentsError$1(`import`, r3, 1, 2);
    n3 ||= {};
    function i3(t6, r4, a4) {
      if (Array.isArray(r4)) r4.forEach((n4) => i3(t6, n4));
      else if (isObject$1$1(r4) || p2(r4)) for (var o3 in r4) hasOwnProperty$1$3(r4, o3) && i3(t6, r4[o3], o3);
      else if (isFactory$1(r4) || a4 !== void 0) {
        var s4 = isFactory$1(r4) ? v2(r4) ? r4.fn + `.transform` : r4.fn : a4;
        if (hasOwnProperty$1$3(t6, s4) && t6[s4] !== r4 && !n3.silent) throw Error(`Cannot import "` + s4 + `" twice`);
        t6[s4] = r4;
      } else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
    var a3 = {};
    for (var s3 in i3(a3, t5), a3) if (hasOwnProperty$1$3(a3, s3)) {
      var c3 = a3[s3];
      if (isFactory$1(c3)) u2(c3, n3);
      else if (d2(c3)) o2(s3, c3, n3);
      else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
  }
  function o2(n3, a3, o3) {
    if (o3.wrap && typeof a3 == `function` && (a3 = l2(a3)), m2(a3) && (a3 = t4(n3, { [a3.signature]: a3 })), t4.isTypedFunction(r2[n3]) && t4.isTypedFunction(a3)) {
      a3 = o3.override ? t4(n3, a3.signatures) : t4(r2[n3], a3), r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    var u3 = r2[n3] !== void 0, d3 = r2.Unit?.isValuelessUnit(n3);
    if (!u3 && !d3 || o3.override) {
      r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    if (!o3.silent) throw Error(`Cannot import "` + n3 + `": already exists`);
  }
  function s2(t5, n3) {
    n3 && typeof n3.transform == `function` ? (r2.expression.transform[t5] = n3.transform, h2(t5) && (r2.expression.mathWithTransform[t5] = n3.transform)) : (delete r2.expression.transform[t5], h2(t5) && (r2.expression.mathWithTransform[t5] = n3));
  }
  function c2(t5) {
    delete r2.expression.transform[t5], h2(t5) ? r2.expression.mathWithTransform[t5] = r2[t5] : delete r2.expression.mathWithTransform[t5];
  }
  function l2(t5) {
    var n3 = function() {
      for (var n4 = [], i3 = 0, a3 = arguments.length; i3 < a3; i3++) {
        var o3 = arguments[i3];
        n4[i3] = o3 && o3.valueOf();
      }
      return t5.apply(r2, n4);
    };
    return t5.transform && (n3.transform = t5.transform), n3;
  }
  function u2(n3, a3) {
    var l3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n3.fn;
    if (l3.includes(`.`)) throw Error(`Factory name should not contain a nested path. Name: ` + JSON.stringify(l3));
    var u3 = v2(n3) ? r2.expression.transform : r2, d3 = l3 in r2.expression.transform, p3 = hasOwnProperty$1$3(u3, l3) ? u3[l3] : void 0, m3 = function() {
      var i3 = {};
      n3.dependencies.map(stripOptionalNotation$1).forEach((t5) => {
        if (t5.includes(`.`)) throw Error(`Factory dependency should not contain a nested path. Name: ` + JSON.stringify(t5));
        t5 === `math` ? i3.math = r2 : t5 === `mathWithTransform` ? i3.mathWithTransform = r2.expression.mathWithTransform : t5 === `classes` ? i3.classes = r2 : i3[t5] = r2[t5];
      });
      var o3 = n3(i3);
      if (o3 && typeof o3.transform == `function`) throw Error(`Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"`);
      if (p3 === void 0 || a3.override) return o3;
      if (t4.isTypedFunction(p3) && t4.isTypedFunction(o3)) return t4(p3, o3);
      if (a3.silent) return p3;
      throw Error(`Cannot import "` + l3 + `": already exists`);
    }, h3 = n3.meta?.formerly ?? ``, y3 = v2(n3) || g2(n3), b2 = r2.expression.mathWithTransform;
    !n3.meta || n3.meta.lazy !== false ? (lazy$1(u3, l3, m3), h3 && lazy$1(u3, h3, m3), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy$1(b2, l3, () => u3[l3]), h3 && lazy$1(b2, h3, () => u3[l3]))) : (u3[l3] = m3(), h3 && (u3[h3] = u3[l3]), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy$1(b2, l3, () => u3[l3]), h3 && lazy$1(b2, h3, () => u3[l3]))), i2[l3] = n3, r2.emit(`import`, l3, m3);
  }
  function d2(t5) {
    return typeof t5 == `function` || typeof t5 == `number` || typeof t5 == `string` || typeof t5 == `boolean` || t5 === null || isUnit$1(t5) || isComplex$1(t5) || isBigNumber$1(t5) || isFraction$1(t5) || isMatrix$1(t5) || Array.isArray(t5);
  }
  function p2(t5) {
    return typeof t5 == `object` && t5[Symbol.toStringTag] === `Module`;
  }
  function m2(t5) {
    return typeof t5 == `function` && typeof t5.signature == `string`;
  }
  function h2(t5) {
    return !hasOwnProperty$1$3(y2, t5);
  }
  function g2(t5) {
    return !t5.fn.includes(`.`) && !hasOwnProperty$1$3(y2, t5.fn) && (!t5.meta || !t5.meta.isClass);
  }
  function v2(t5) {
    return t5 !== void 0 && t5.meta !== void 0 && t5.meta.isTransformFunction === true || false;
  }
  var y2 = { expression: true, type: true, docs: true, error: true, json: true, chain: true };
  return a2;
}
function create$1$1(t4, n2) {
  var r2 = _extends$3({}, DEFAULT_CONFIG$1, n2);
  if (typeof Object.create != `function`) throw Error(`ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.`);
  var i2 = mixin$1$1({ isNumber: isNumber$1, isComplex: isComplex$1, isBigNumber: isBigNumber$1, isBigInt: isBigInt$1, isFraction: isFraction$1, isUnit: isUnit$1, isString: isString$1, isArray: isArray$1, isMatrix: isMatrix$1, isCollection: isCollection$1, isDenseMatrix: isDenseMatrix$1, isSparseMatrix: isSparseMatrix$1, isRange: isRange$1, isIndex: isIndex$1, isBoolean: isBoolean$1$1, isResultSet: isResultSet$1, isHelp: isHelp$1, isFunction: isFunction$1$1, isDate: isDate$1, isRegExp: isRegExp$1, isObject: isObject$1$1, isMap: isMap$1, isPartitionedMap: isPartitionedMap$1, isObjectWrappingMap: isObjectWrappingMap$1, isNull: isNull$1$1, isUndefined: isUndefined$1$1, isAccessorNode: isAccessorNode$1, isArrayNode: isArrayNode$1, isAssignmentNode: isAssignmentNode$1, isBlockNode: isBlockNode$1, isConditionalNode: isConditionalNode$1, isConstantNode: isConstantNode$1, isFunctionAssignmentNode: isFunctionAssignmentNode$1, isFunctionNode: isFunctionNode$1, isIndexNode: isIndexNode$1, isNode: isNode$4, isObjectNode: isObjectNode$1, isOperatorNode: isOperatorNode$1, isParenthesisNode: isParenthesisNode$1, isRangeNode: isRangeNode$1, isRelationalNode: isRelationalNode$1, isSymbolNode: isSymbolNode$1, isChain: isChain$1 });
  i2.config = configFactory$1(r2, i2.emit), i2.expression = { transform: {}, mathWithTransform: { config: i2.config } };
  var a2 = [], o2 = [];
  function s2(t5) {
    if (isFactory$1(t5)) return t5(i2);
    var n3 = t5[Object.keys(t5)[0]];
    if (isFactory$1(n3)) return n3(i2);
    if (!isLegacyFactory$1(t5)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", t5), Error("Factory object with properties `type`, `name`, and `factory` expected");
    var c3 = a2.indexOf(t5), l3;
    return c3 === -1 ? (l3 = t5.math === true ? t5.factory(i2.type, r2, s2, i2.typed, i2) : t5.factory(i2.type, r2, s2, i2.typed), a2.push(t5), o2.push(l3)) : l3 = o2[c3], l3;
  }
  var c2 = {};
  function l2() {
    var t5 = [...arguments];
    return i2.typed.apply(i2.typed, t5);
  }
  l2.isTypedFunction = import_typed_function$1.default.isTypedFunction;
  var u2 = importFactory$1(l2, s2, i2, c2);
  return i2.import = u2, i2.on(`config`, () => {
    Object.values(c2).forEach((t5) => {
      t5 && t5.meta && t5.meta.recreateOnConfigChange && u2(t5, { override: true });
    });
  }), i2.create = create$1$1.bind(null, t4), i2.factory = factory$1, i2.import(Object.values(deepFlatten$1(t4))), i2.ArgumentsError = ArgumentsError$1, i2.DimensionError = DimensionError$1, i2.IndexError = IndexError$1, i2;
}
var require_numeric_1_2_6$1 = __commonJSMin$1(((exports) => {
  var numeric = exports === void 0 ? (function() {
  }) : exports;
  typeof global < `u` && (global.numeric = numeric), numeric.version = `1.2.6`, numeric.bench = function(t4, n2) {
    var r2, i2, a2, o2;
    for (n2 === void 0 && (n2 = 15), a2 = 0.5, r2 = /* @__PURE__ */ new Date(); ; ) {
      for (a2 *= 2, o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
      for (; o2 > 0; ) t4(), o2--;
      if (i2 = /* @__PURE__ */ new Date(), i2 - r2 > n2) break;
    }
    for (o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
    for (; o2 > 0; ) t4(), o2--;
    return i2 = /* @__PURE__ */ new Date(), 1e3 * (3 * a2 - 1) / (i2 - r2);
  }, numeric._myIndexOf = (function(t4) {
    var n2 = this.length, r2;
    for (r2 = 0; r2 < n2; ++r2) if (this[r2] === t4) return r2;
    return -1;
  }), numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(t4) {
    function n2(t5) {
      if (t5 === 0) return `0`;
      if (isNaN(t5)) return `NaN`;
      if (t5 < 0) return `-` + n2(-t5);
      if (isFinite(t5)) {
        var r3 = Math.floor(Math.log(t5) / Math.log(10)), i3 = t5 / 10 ** r3, a2 = i3.toPrecision(numeric.precision);
        return parseFloat(a2) === 10 && (r3++, i3 = 1, a2 = i3.toPrecision(numeric.precision)), parseFloat(a2).toString() + `e` + r3.toString();
      }
      return `Infinity`;
    }
    var r2 = [];
    function i2(t5) {
      var a2;
      if (t5 === void 0) return r2.push(Array(numeric.precision + 8).join(` `)), false;
      if (typeof t5 == `string`) return r2.push(`"` + t5 + `"`), false;
      if (typeof t5 == `boolean`) return r2.push(t5.toString()), false;
      if (typeof t5 == `number`) {
        var o2 = n2(t5), s2 = t5.toPrecision(numeric.precision), c2 = parseFloat(t5.toString()).toString(), l2 = [o2, s2, c2, parseFloat(s2).toString(), parseFloat(c2).toString()];
        for (a2 = 1; a2 < l2.length; a2++) l2[a2].length < o2.length && (o2 = l2[a2]);
        return r2.push(Array(numeric.precision + 8 - o2.length).join(` `) + o2), false;
      }
      if (t5 === null) return r2.push(`null`), false;
      if (typeof t5 == `function`) {
        r2.push(t5.toString());
        var u2 = false;
        for (a2 in t5) t5.hasOwnProperty(a2) && (u2 ? r2.push(`,
`) : r2.push(`
{`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
        return u2 && r2.push(`}
`), true;
      }
      if (t5 instanceof Array) {
        if (t5.length > numeric.largeArray) return r2.push(`...Large Array...`), true;
        var u2 = false;
        for (r2.push(`[`), a2 = 0; a2 < t5.length; a2++) a2 > 0 && (r2.push(`,`), u2 && r2.push(`
 `)), u2 = i2(t5[a2]);
        return r2.push(`]`), true;
      }
      r2.push(`{`);
      var u2 = false;
      for (a2 in t5) t5.hasOwnProperty(a2) && (u2 && r2.push(`,
`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
      return r2.push(`}`), true;
    }
    return i2(t4), r2.join(``);
  }, numeric.parseDate = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return Date.parse(t5.replace(/-/g, `/`));
      if (!(t5 instanceof Array)) throw Error(`parseDate: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseFloat = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return parseFloat(t5);
      if (!(t5 instanceof Array)) throw Error(`parseFloat: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseCSV = function(t4) {
    var n2 = t4.split(`
`), r2, i2, a2 = [], o2 = /(([^'",]*)|('[^']*')|("[^"]*")),/g, s2 = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, c2 = function(t5) {
      return t5.substr(0, t5.length - 1);
    }, l2 = 0;
    for (i2 = 0; i2 < n2.length; i2++) {
      var u2 = (n2[i2] + `,`).match(o2), d2;
      if (u2.length > 0) {
        for (a2[l2] = [], r2 = 0; r2 < u2.length; r2++) d2 = c2(u2[r2]), s2.test(d2) ? a2[l2][r2] = parseFloat(d2) : a2[l2][r2] = d2;
        l2++;
      }
    }
    return a2;
  }, numeric.toCSV = function(t4) {
    var n2 = numeric.dim(t4), r2, i2, a2 = n2[0], s2, c2;
    for (n2[1], c2 = [], r2 = 0; r2 < a2; r2++) {
      for (s2 = [], i2 = 0; i2 < a2; i2++) s2[i2] = t4[r2][i2].toString();
      c2[r2] = s2.join(`, `);
    }
    return c2.join(`
`) + `
`;
  }, numeric.getURL = function(t4) {
    var n2 = new XMLHttpRequest();
    return n2.open(`GET`, t4, false), n2.send(), n2;
  }, numeric.imageURL = function(t4) {
    function n2(t5) {
      var n3 = t5.length, r3, i3, a3, o3, s3, c2, l3, u3, d3 = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=`, p3 = ``;
      for (r3 = 0; r3 < n3; r3 += 3) i3 = t5[r3], a3 = t5[r3 + 1], o3 = t5[r3 + 2], s3 = i3 >> 2, c2 = ((i3 & 3) << 4) + (a3 >> 4), l3 = ((a3 & 15) << 2) + (o3 >> 6), u3 = o3 & 63, r3 + 1 >= n3 ? l3 = u3 = 64 : r3 + 2 >= n3 && (u3 = 64), p3 += d3.charAt(s3) + d3.charAt(c2) + d3.charAt(l3) + d3.charAt(u3);
      return p3;
    }
    function r2(t5, n3, r3) {
      n3 === void 0 && (n3 = 0), r3 === void 0 && (r3 = t5.length);
      var i3 = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], a3 = -1, o3 = 0;
      t5.length;
      var c2;
      for (c2 = n3; c2 < r3; c2++) o3 = (a3 ^ t5[c2]) & 255, a3 = a3 >>> 8 ^ i3[o3];
      return a3 ^ -1;
    }
    var i2 = t4[0].length, a2 = t4[0][0].length, o2, s2, l2, u2, d2, p2, m2, h2, g2, v2, y2 = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, a2 >> 24 & 255, a2 >> 16 & 255, a2 >> 8 & 255, a2 & 255, i2 >> 24 & 255, i2 >> 16 & 255, i2 >> 8 & 255, i2 & 255, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
    for (v2 = r2(y2, 12, 29), y2[29] = v2 >> 24 & 255, y2[30] = v2 >> 16 & 255, y2[31] = v2 >> 8 & 255, y2[32] = v2 & 255, o2 = 1, s2 = 0, m2 = 0; m2 < i2; m2++) {
      for (m2 < i2 - 1 ? y2.push(0) : y2.push(1), d2 = 3 * a2 + 1 + (m2 === 0) & 255, p2 = 3 * a2 + 1 + (m2 === 0) >> 8 & 255, y2.push(d2), y2.push(p2), y2.push(~d2 & 255), y2.push(~p2 & 255), m2 === 0 && y2.push(0), h2 = 0; h2 < a2; h2++) for (l2 = 0; l2 < 3; l2++) d2 = t4[l2][m2][h2], d2 = d2 > 255 ? 255 : d2 < 0 ? 0 : Math.round(d2), o2 = (o2 + d2) % 65521, s2 = (s2 + o2) % 65521, y2.push(d2);
      y2.push(0);
    }
    return g2 = (s2 << 16) + o2, y2.push(g2 >> 24 & 255), y2.push(g2 >> 16 & 255), y2.push(g2 >> 8 & 255), y2.push(g2 & 255), u2 = y2.length - 41, y2[33] = u2 >> 24 & 255, y2[34] = u2 >> 16 & 255, y2[35] = u2 >> 8 & 255, y2[36] = u2 & 255, v2 = r2(y2, 37), y2.push(v2 >> 24 & 255), y2.push(v2 >> 16 & 255), y2.push(v2 >> 8 & 255), y2.push(v2 & 255), y2.push(0), y2.push(0), y2.push(0), y2.push(0), y2.push(73), y2.push(69), y2.push(78), y2.push(68), y2.push(174), y2.push(66), y2.push(96), y2.push(130), `data:image/png;base64,` + n2(y2);
  }, numeric._dim = function(t4) {
    for (var n2 = []; typeof t4 == `object`; ) n2.push(t4.length), t4 = t4[0];
    return n2;
  }, numeric.dim = function(t4) {
    var n2, r2;
    return typeof t4 == `object` ? (n2 = t4[0], typeof n2 == `object` ? (r2 = n2[0], typeof r2 == `object` ? numeric._dim(t4) : [t4.length, n2.length]) : [t4.length]) : [];
  }, numeric.mapreduce = function(t4, n2) {
    return Function(`x`, `accum`, `_s`, `_k`, `if(typeof accum === "undefined") accum = ` + n2 + `;
if(typeof x === "number") { var xi = x; ` + t4 + `; return accum; }
if(typeof _s === "undefined") _s = numeric.dim(x);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i,xi;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) {
        accum = arguments.callee(x[i],accum,_s,_k+1);
    }    return accum;
}
for(i=_n-1;i>=1;i-=2) { 
    xi = x[i];
    ` + t4 + `;
    xi = x[i-1];
    ` + t4 + `;
}
if(i === 0) {
    xi = x[i];
    ` + t4 + `
}
return accum;`);
  }, numeric.mapreduce2 = function(t4, n2) {
    return Function(`x`, `var n = x.length;
var i,xi;
` + n2 + `;
for(i=n-1;i!==-1;--i) { 
    xi = x[i];
    ` + t4 + `;
}
return accum;`);
  }, numeric.same = function t4(n2, r2) {
    var i2, a2;
    if (!(n2 instanceof Array) || !(r2 instanceof Array) || (a2 = n2.length, a2 !== r2.length)) return false;
    for (i2 = 0; i2 < a2; i2++) if (n2[i2] !== r2[i2]) if (typeof n2[i2] == `object`) {
      if (!t4(n2[i2], r2[i2])) return false;
    } else return false;
    return true;
  }, numeric.rep = function(t4, n2, r2) {
    r2 === void 0 && (r2 = 0);
    var i2 = t4[r2], a2 = Array(i2), o2;
    if (r2 === t4.length - 1) {
      for (o2 = i2 - 2; o2 >= 0; o2 -= 2) a2[o2 + 1] = n2, a2[o2] = n2;
      return o2 === -1 && (a2[0] = n2), a2;
    }
    for (o2 = i2 - 1; o2 >= 0; o2--) a2[o2] = numeric.rep(t4, n2, r2 + 1);
    return a2;
  }, numeric.dotMMsmall = function(t4, n2) {
    var r2, i2, a2, o2 = t4.length, s2 = n2.length, c2 = n2[0].length, l2 = Array(o2), u2, d2, p2, m2;
    for (r2 = o2 - 1; r2 >= 0; r2--) {
      for (u2 = Array(c2), d2 = t4[r2], a2 = c2 - 1; a2 >= 0; a2--) {
        for (p2 = d2[s2 - 1] * n2[s2 - 1][a2], i2 = s2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += d2[i2] * n2[i2][a2] + d2[m2] * n2[m2][a2];
        i2 === 0 && (p2 += d2[0] * n2[0][a2]), u2[a2] = p2;
      }
      l2[r2] = u2;
    }
    return l2;
  }, numeric._getCol = function(t4, n2, r2) {
    var i2 = t4.length, a2;
    for (a2 = i2 - 1; a2 > 0; --a2) r2[a2] = t4[a2][n2], --a2, r2[a2] = t4[a2][n2];
    a2 === 0 && (r2[0] = t4[0][n2]);
  }, numeric.dotMMbig = function(t4, n2) {
    var r2 = numeric._getCol, i2 = n2.length, a2 = Array(i2), o2 = t4.length, s2 = n2[0].length, c2 = Array(o2), l2, u2 = numeric.dotVV, d2, p2;
    for (--i2, --o2, d2 = o2; d2 !== -1; --d2) c2[d2] = Array(s2);
    for (--s2, d2 = s2; d2 !== -1; --d2) for (r2(n2, d2, a2), p2 = o2; p2 !== -1; --p2) l2 = t4[p2], c2[p2][d2] = u2(l2, a2);
    return c2;
  }, numeric.dotMV = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2, o2 = Array(r2), s2 = numeric.dotVV;
    for (a2 = r2 - 1; a2 >= 0; a2--) o2[a2] = s2(t4[a2], n2);
    return o2;
  }, numeric.dotVM = function(t4, n2) {
    var i2, a2, o2 = t4.length, s2 = n2[0].length, l2 = Array(s2), p2, m2;
    for (a2 = s2 - 1; a2 >= 0; a2--) {
      for (p2 = t4[o2 - 1] * n2[o2 - 1][a2], i2 = o2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += t4[i2] * n2[i2][a2] + t4[m2] * n2[m2][a2];
      i2 === 0 && (p2 += t4[0] * n2[0][a2]), l2[a2] = p2;
    }
    return l2;
  }, numeric.dotVV = function(t4, n2) {
    var r2, i2 = t4.length, a2, o2 = t4[i2 - 1] * n2[i2 - 1];
    for (r2 = i2 - 2; r2 >= 1; r2 -= 2) a2 = r2 - 1, o2 += t4[r2] * n2[r2] + t4[a2] * n2[a2];
    return r2 === 0 && (o2 += t4[0] * n2[0]), o2;
  }, numeric.dot = function(t4, n2) {
    var r2 = numeric.dim;
    switch (r2(t4).length * 1e3 + r2(n2).length) {
      case 2002:
        return n2.length < 10 ? numeric.dotMMsmall(t4, n2) : numeric.dotMMbig(t4, n2);
      case 2001:
        return numeric.dotMV(t4, n2);
      case 1002:
        return numeric.dotVM(t4, n2);
      case 1001:
        return numeric.dotVV(t4, n2);
      case 1e3:
        return numeric.mulVS(t4, n2);
      case 1:
        return numeric.mulSV(t4, n2);
      case 0:
        return t4 * n2;
      default:
        throw Error(`numeric.dot only works on vectors and matrices`);
    }
  }, numeric.diag = function(t4) {
    var n2, r2, i2, a2 = t4.length, o2 = Array(a2), s2;
    for (n2 = a2 - 1; n2 >= 0; n2--) {
      for (s2 = Array(a2), r2 = n2 + 2, i2 = a2 - 1; i2 >= r2; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      for (i2 > n2 && (s2[i2] = 0), s2[n2] = t4[n2], i2 = n2 - 1; i2 >= 1; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      i2 === 0 && (s2[0] = 0), o2[n2] = s2;
    }
    return o2;
  }, numeric.getDiag = function(t4) {
    var n2 = Math.min(t4.length, t4[0].length), r2, i2 = Array(n2);
    for (r2 = n2 - 1; r2 >= 1; --r2) i2[r2] = t4[r2][r2], --r2, i2[r2] = t4[r2][r2];
    return r2 === 0 && (i2[0] = t4[0][0]), i2;
  }, numeric.identity = function(t4) {
    return numeric.diag(numeric.rep([t4], 1));
  }, numeric.pointwise = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `_s`, i2[t4.length + 1] = `_k`, i2[t4.length + 2] = `if(typeof _s === "undefined") _s = numeric.dim(` + c2 + `);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(` + t4.join(`,`) + `,_s,_k+1);
    return ret;
}
` + r2 + `
for(i=_n-1;i!==-1;--i) {
    ` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric.pointwise2 = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `var _n = ` + c2 + `.length;
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
` + r2 + `
for(i=_n-1;i!==-1;--i) {
` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric._biforeach = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) {
      o2(n2, r2);
      return;
    }
    var s2;
    for (s2 = i2[a2] - 1; s2 >= 0; s2--) t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
  }), numeric._biforeach2 = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) return o2(n2, r2);
    var s2, c2 = i2[a2], l2 = Array(c2);
    for (s2 = c2 - 1; s2 >= 0; --s2) l2[s2] = t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
    return l2;
  }), numeric._foreach = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) {
      a2(n2);
      return;
    }
    var o2;
    for (o2 = r2[i2] - 1; o2 >= 0; o2--) t4(n2[o2], r2, i2 + 1, a2);
  }), numeric._foreach2 = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) return a2(n2);
    var o2, s2 = r2[i2], c2 = Array(s2);
    for (o2 = s2 - 1; o2 >= 0; o2--) c2[o2] = t4(n2[o2], r2, i2 + 1, a2);
    return c2;
  }), numeric.ops2 = { add: `+`, sub: `-`, mul: `*`, div: `/`, mod: `%`, and: `&&`, or: `||`, eq: `===`, neq: `!==`, lt: `<`, gt: `>`, leq: `<=`, geq: `>=`, band: `&`, bor: `|`, bxor: `^`, lshift: `<<`, rshift: `>>`, rrshift: `>>>` }, numeric.opseq = { addeq: `+=`, subeq: `-=`, muleq: `*=`, diveq: `/=`, modeq: `%=`, lshifteq: `<<=`, rshifteq: `>>=`, rrshifteq: `>>>=`, bandeq: `&=`, boreq: `|=`, bxoreq: `^=` }, numeric.mathfuns = [`abs`, `acos`, `asin`, `atan`, `ceil`, `cos`, `exp`, `floor`, `log`, `round`, `sin`, `sqrt`, `tan`, `isNaN`, `isFinite`], numeric.mathfuns2 = [`atan2`, `pow`, `max`, `min`], numeric.ops1 = { neg: `-`, not: `!`, bnot: `~`, clone: `` }, numeric.mapreducers = { any: [`if(xi) return true;`, `var accum = false;`], all: [`if(!xi) return false;`, `var accum = true;`], sum: [`accum += xi;`, `var accum = 0;`], prod: [`accum *= xi;`, `var accum = 1;`], norm2Squared: [`accum += xi*xi;`, `var accum = 0;`], norminf: [`accum = max(accum,abs(xi));`, `var accum = 0, max = Math.max, abs = Math.abs;`], norm1: [`accum += abs(xi)`, `var accum = 0, abs = Math.abs;`], sup: [`accum = max(accum,xi);`, `var accum = -Infinity, max = Math.max;`], inf: [`accum = min(accum,xi);`, `var accum = Infinity, min = Math.min;`] }, (function() {
    var t4, n2;
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], numeric.ops2[n2] = n2;
    for (t4 in numeric.ops2) if (numeric.ops2.hasOwnProperty(t4)) {
      n2 = numeric.ops2[t4];
      var r2, i2, a2 = ``;
      numeric.myIndexOf.call(numeric.mathfuns2, t4) === -1 ? (r2 = function(t5, r3, i3) {
        return t5 + ` = ` + r3 + ` ` + n2 + ` ` + i3;
      }, i2 = numeric.opseq.hasOwnProperty(t4 + `eq`) ? function(t5, r3) {
        return t5 + ` ` + n2 + `= ` + r3;
      } : function(t5, r3) {
        return t5 + ` = ` + t5 + ` ` + n2 + ` ` + r3;
      }) : (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`, r2 = function(t5, r3, i3) {
        return t5 + ` = ` + n2 + `(` + r3 + `,` + i3 + `)`;
      }, i2 = function(t5, r3) {
        return t5 + ` = ` + n2 + `(` + t5 + `,` + r3 + `)`;
      }), numeric[t4 + `VV`] = numeric.pointwise2([`x[i]`, `y[i]`], r2(`ret[i]`, `x[i]`, `y[i]`), a2), numeric[t4 + `SV`] = numeric.pointwise2([`x`, `y[i]`], r2(`ret[i]`, `x`, `y[i]`), a2), numeric[t4 + `VS`] = numeric.pointwise2([`x[i]`, `y`], r2(`ret[i]`, `x[i]`, `y`), a2), numeric[t4] = Function(`var n = arguments.length, i, x = arguments[0], y;
var VV = numeric.` + t4 + `VV, VS = numeric.` + t4 + `VS, SV = numeric.` + t4 + `SV;
var dim = numeric.dim;
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof x === "object") {
      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);
      else x = numeric._biforeach2(x,y,dim(x),0,VS);
  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);
  else ` + i2(`x`, `y`) + `
}
return x;
`), numeric[n2] = numeric[t4], numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`, `x[i]`], i2(`ret[i]`, `x[i]`), a2), numeric[t4 + `eqS`] = numeric.pointwise2([`ret[i]`, `x`], i2(`ret[i]`, `x`), a2), numeric[t4 + `eq`] = Function(`var n = arguments.length, i, x = arguments[0], y;
var V = numeric.` + t4 + `eqV, S = numeric.` + t4 + `eqS
var s = numeric.dim(x);
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);
  else numeric._biforeach(x,y,s,0,S);
}
return x;
`);
    }
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], delete numeric.ops2[n2];
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], numeric.ops1[n2] = n2;
    for (t4 in numeric.ops1) numeric.ops1.hasOwnProperty(t4) && (a2 = ``, n2 = numeric.ops1[t4], numeric.myIndexOf.call(numeric.mathfuns, t4) !== -1 && Math.hasOwnProperty(n2) && (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`), numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`], `ret[i] = ` + n2 + `(ret[i]);`, a2), numeric[t4 + `eq`] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `x
var i;
var V = numeric.` + t4 + `eqV;
var s = numeric.dim(x);
numeric._foreach(x,s,0,V);
return x;
`), numeric[t4 + `V`] = numeric.pointwise2([`x[i]`], `ret[i] = ` + n2 + `(x[i]);`, a2), numeric[t4] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `(x)
var i;
var V = numeric.` + t4 + `V;
var s = numeric.dim(x);
return numeric._foreach2(x,s,0,V);
`));
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], delete numeric.ops1[n2];
    for (t4 in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(t4) && (n2 = numeric.mapreducers[t4], numeric[t4 + `V`] = numeric.mapreduce2(n2[0], n2[1]), numeric[t4] = Function(`x`, `s`, `k`, n2[1] + `if(typeof x !== "object") {    xi = x;
` + n2[0] + `;
    return accum;
}if(typeof s === "undefined") s = numeric.dim(x);
if(typeof k === "undefined") k = 0;
if(k === s.length-1) return numeric.` + t4 + `V(x);
var xi;
var n = x.length, i;
for(i=n-1;i!==-1;--i) {
   xi = arguments.callee(x[i]);
` + n2[0] + `;
}
return accum;
`));
  })(), numeric.truncVV = numeric.pointwise([`x[i]`, `y[i]`], `ret[i] = round(x[i]/y[i])*y[i];`, `var round = Math.round;`), numeric.truncVS = numeric.pointwise([`x[i]`, `y`], `ret[i] = round(x[i]/y)*y;`, `var round = Math.round;`), numeric.truncSV = numeric.pointwise([`x`, `y[i]`], `ret[i] = round(x/y[i])*y[i];`, `var round = Math.round;`), numeric.trunc = function(t4, n2) {
    return typeof t4 == `object` ? typeof n2 == `object` ? numeric.truncVV(t4, n2) : numeric.truncVS(t4, n2) : typeof n2 == `object` ? numeric.truncSV(t4, n2) : Math.round(t4 / n2) * n2;
  }, numeric.inv = function(t4) {
    var n2 = numeric.dim(t4), r2 = Math.abs, i2 = n2[0], a2 = n2[1], o2 = numeric.clone(t4), s2, c2, l2 = numeric.identity(i2), u2, d2, p2, m2, h2, t4;
    for (m2 = 0; m2 < a2; ++m2) {
      var g2 = -1, v2 = -1;
      for (p2 = m2; p2 !== i2; ++p2) h2 = r2(o2[p2][m2]), h2 > v2 && (g2 = p2, v2 = h2);
      for (c2 = o2[g2], o2[g2] = o2[m2], o2[m2] = c2, d2 = l2[g2], l2[g2] = l2[m2], l2[m2] = d2, t4 = c2[m2], h2 = m2; h2 !== a2; ++h2) c2[h2] /= t4;
      for (h2 = a2 - 1; h2 !== -1; --h2) d2[h2] /= t4;
      for (p2 = i2 - 1; p2 !== -1; --p2) if (p2 !== m2) {
        for (s2 = o2[p2], u2 = l2[p2], t4 = s2[m2], h2 = m2 + 1; h2 !== a2; ++h2) s2[h2] -= c2[h2] * t4;
        for (h2 = a2 - 1; h2 > 0; --h2) u2[h2] -= d2[h2] * t4, --h2, u2[h2] -= d2[h2] * t4;
        h2 === 0 && (u2[0] -= d2[0] * t4);
      }
    }
    return l2;
  }, numeric.det = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: det() only works on square matrices`);
    var r2 = n2[0], i2 = 1, a2, o2, s2, c2 = numeric.clone(t4), l2, u2, d2, p2, m2;
    for (o2 = 0; o2 < r2 - 1; o2++) {
      for (s2 = o2, a2 = o2 + 1; a2 < r2; a2++) Math.abs(c2[a2][o2]) > Math.abs(c2[s2][o2]) && (s2 = a2);
      for (s2 !== o2 && (p2 = c2[s2], c2[s2] = c2[o2], c2[o2] = p2, i2 *= -1), l2 = c2[o2], a2 = o2 + 1; a2 < r2; a2++) {
        for (u2 = c2[a2], d2 = u2[o2] / l2[o2], s2 = o2 + 1; s2 < r2 - 1; s2 += 2) m2 = s2 + 1, u2[s2] -= l2[s2] * d2, u2[m2] -= l2[m2] * d2;
        s2 !== r2 && (u2[s2] -= l2[s2] * d2);
      }
      if (l2[o2] === 0) return 0;
      i2 *= l2[o2];
    }
    return i2 * c2[o2][o2];
  }, numeric.transpose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2], --r2, l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = c2[0], l2[n2 - 1] = s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = s2[r2], --r2, o2[r2][0] = s2[r2];
      r2 === 0 && (o2[0][0] = s2[0]);
    }
    return o2;
  }, numeric.negtranspose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2], --r2, l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = -c2[0], l2[n2 - 1] = -s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = -s2[r2], --r2, o2[r2][0] = -s2[r2];
      r2 === 0 && (o2[0][0] = -s2[0]);
    }
    return o2;
  }, numeric._random = function t4(n2, r2) {
    var i2, a2 = n2[r2], o2 = Array(a2), s2;
    if (r2 === n2.length - 1) {
      for (s2 = Math.random, i2 = a2 - 1; i2 >= 1; i2 -= 2) o2[i2] = s2(), o2[i2 - 1] = s2();
      return i2 === 0 && (o2[0] = s2()), o2;
    }
    for (i2 = a2 - 1; i2 >= 0; i2--) o2[i2] = t4(n2, r2 + 1);
    return o2;
  }, numeric.random = function(t4) {
    return numeric._random(t4, 0);
  }, numeric.norm2 = function(t4) {
    return Math.sqrt(numeric.norm2Squared(t4));
  }, numeric.linspace = function(t4, n2, r2) {
    if (r2 === void 0 && (r2 = Math.max(Math.round(n2 - t4) + 1, 1)), r2 < 2) return r2 === 1 ? [t4] : [];
    var i2, a2 = Array(r2);
    for (r2--, i2 = r2; i2 >= 0; i2--) a2[i2] = (i2 * n2 + (r2 - i2) * t4) / r2;
    return a2;
  }, numeric.getBlock = function(t4, n2, r2) {
    var i2 = numeric.dim(t4);
    function a2(t5, o2) {
      var s2, c2 = n2[o2], l2 = r2[o2] - c2, u2 = Array(l2);
      if (o2 === i2.length - 1) {
        for (s2 = l2; s2 >= 0; s2--) u2[s2] = t5[s2 + c2];
        return u2;
      }
      for (s2 = l2; s2 >= 0; s2--) u2[s2] = a2(t5[s2 + c2], o2 + 1);
      return u2;
    }
    return a2(t4, 0);
  }, numeric.setBlock = function(t4, n2, r2, i2) {
    var a2 = numeric.dim(t4);
    function o2(t5, i3, s2) {
      var c2, l2 = n2[s2], u2 = r2[s2] - l2;
      if (s2 === a2.length - 1) for (c2 = u2; c2 >= 0; c2--) t5[c2 + l2] = i3[c2];
      for (c2 = u2; c2 >= 0; c2--) o2(t5[c2 + l2], i3[c2], s2 + 1);
    }
    return o2(t4, i2, 0), t4;
  }, numeric.getRange = function(t4, n2, r2) {
    var i2 = n2.length, a2 = r2.length, o2, s2, c2 = Array(i2), l2, u2;
    for (o2 = i2 - 1; o2 !== -1; --o2) for (c2[o2] = Array(a2), l2 = c2[o2], u2 = t4[n2[o2]], s2 = a2 - 1; s2 !== -1; --s2) l2[s2] = u2[r2[s2]];
    return c2;
  }, numeric.blockMatrix = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length < 4) return numeric.blockMatrix([t4]);
    var r2 = n2[0], i2 = n2[1], a2 = 0, o2 = 0, s2, c2, l2;
    for (s2 = 0; s2 < r2; ++s2) a2 += t4[s2][0].length;
    for (c2 = 0; c2 < i2; ++c2) o2 += t4[0][c2][0].length;
    var u2 = Array(a2);
    for (s2 = 0; s2 < a2; ++s2) u2[s2] = Array(o2);
    var d2 = 0, p2, m2, h2, g2, v2;
    for (s2 = 0; s2 < r2; ++s2) {
      for (p2 = o2, c2 = i2 - 1; c2 !== -1; --c2) for (l2 = t4[s2][c2], p2 -= l2[0].length, h2 = l2.length - 1; h2 !== -1; --h2) for (v2 = l2[h2], m2 = u2[d2 + h2], g2 = v2.length - 1; g2 !== -1; --g2) m2[p2 + g2] = v2[g2];
      d2 += t4[s2][0].length;
    }
    return u2;
  }, numeric.tensor = function(t4, n2) {
    if (typeof t4 == `number` || typeof n2 == `number`) return numeric.mul(t4, n2);
    var r2 = numeric.dim(t4), i2 = numeric.dim(n2);
    if (r2.length !== 1 || i2.length !== 1) throw Error(`numeric: tensor product is only defined for vectors`);
    var a2 = r2[0], o2 = i2[0], s2 = Array(a2), c2, l2, u2, d2;
    for (l2 = a2 - 1; l2 >= 0; l2--) {
      for (c2 = Array(o2), d2 = t4[l2], u2 = o2 - 1; u2 >= 3; --u2) c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2];
      for (; u2 >= 0; ) c2[u2] = d2 * n2[u2], --u2;
      s2[l2] = c2;
    }
    return s2;
  }, numeric.T = function(t4, n2) {
    this.x = t4, this.y = n2;
  }, numeric.t = function(t4, n2) {
    return new numeric.T(t4, n2);
  }, numeric.Tbinop = function(t4, n2, r2, i2, a2) {
    numeric.indexOf;
    if (typeof a2 != `string`) for (var s2 in a2 = ``, numeric) numeric.hasOwnProperty(s2) && (t4.indexOf(s2) >= 0 || n2.indexOf(s2) >= 0 || r2.indexOf(s2) >= 0 || i2.indexOf(s2) >= 0) && s2.length > 1 && (a2 += `var ` + s2 + ` = numeric.` + s2 + `;
`);
    return Function([`y`], `var x = this;
if(!(y instanceof numeric.T)) { y = new numeric.T(y); }
` + a2 + `
if(x.y) {  if(y.y) {    return new numeric.T(` + i2 + `);
  }
  return new numeric.T(` + r2 + `);
}
if(y.y) {
  return new numeric.T(` + n2 + `);
}
return new numeric.T(` + t4 + `);
`);
  }, numeric.T.prototype.add = numeric.Tbinop(`add(x.x,y.x)`, `add(x.x,y.x),y.y`, `add(x.x,y.x),x.y`, `add(x.x,y.x),add(x.y,y.y)`), numeric.T.prototype.sub = numeric.Tbinop(`sub(x.x,y.x)`, `sub(x.x,y.x),neg(y.y)`, `sub(x.x,y.x),x.y`, `sub(x.x,y.x),sub(x.y,y.y)`), numeric.T.prototype.mul = numeric.Tbinop(`mul(x.x,y.x)`, `mul(x.x,y.x),mul(x.x,y.y)`, `mul(x.x,y.x),mul(x.y,y.x)`, `sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))`), numeric.T.prototype.reciprocal = function() {
    var t4 = numeric.mul, n2 = numeric.div;
    if (this.y) {
      var r2 = numeric.add(t4(this.x, this.x), t4(this.y, this.y));
      return new numeric.T(n2(this.x, r2), n2(numeric.neg(this.y), r2));
    }
    return new T(n2(1, this.x));
  }, numeric.T.prototype.div = function(t4) {
    if (t4 instanceof numeric.T || (t4 = new numeric.T(t4)), t4.y) return this.mul(t4.reciprocal());
    var n2 = numeric.div;
    return this.y ? new numeric.T(n2(this.x, t4.x), n2(this.y, t4.x)) : new numeric.T(n2(this.x, t4.x));
  }, numeric.T.prototype.dot = numeric.Tbinop(`dot(x.x,y.x)`, `dot(x.x,y.x),dot(x.x,y.y)`, `dot(x.x,y.x),dot(x.y,y.x)`, `sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))`), numeric.T.prototype.transpose = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), t4(r2)) : new numeric.T(t4(n2));
  }, numeric.T.prototype.transjugate = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), numeric.negtranspose(r2)) : new numeric.T(t4(n2));
  }, numeric.Tunop = function(t4, n2, r2) {
    return typeof r2 != `string` && (r2 = ``), Function(`var x = this;
` + r2 + `
if(x.y) {  ` + n2 + `;
}
` + t4 + `;
`);
  }, numeric.T.prototype.exp = numeric.Tunop(`return new numeric.T(ex)`, `return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))`, `var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;`), numeric.T.prototype.conj = numeric.Tunop(`return new numeric.T(x.x);`, `return new numeric.T(x.x,numeric.neg(x.y));`), numeric.T.prototype.neg = numeric.Tunop(`return new numeric.T(neg(x.x));`, `return new numeric.T(neg(x.x),neg(x.y));`, `var neg = numeric.neg;`), numeric.T.prototype.sin = numeric.Tunop(`return new numeric.T(numeric.sin(x.x))`, `return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));`), numeric.T.prototype.cos = numeric.Tunop(`return new numeric.T(numeric.cos(x.x))`, `return x.exp().add(x.neg().exp()).div(2);`), numeric.T.prototype.abs = numeric.Tunop(`return new numeric.T(numeric.abs(x.x));`, `return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));`, `var mul = numeric.mul;`), numeric.T.prototype.log = numeric.Tunop(`return new numeric.T(numeric.log(x.x));`, `var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();
return new numeric.T(numeric.log(r.x),theta.x);`), numeric.T.prototype.norm2 = numeric.Tunop(`return numeric.norm2(x.x);`, `var f = numeric.norm2Squared;
return Math.sqrt(f(x.x)+f(x.y));`), numeric.T.prototype.inv = function() {
    var t4 = this;
    if (t4.y === void 0) return new numeric.T(numeric.inv(t4.x));
    var n2 = t4.x.length, r2, i2, a2, o2 = numeric.identity(n2), s2 = numeric.rep([n2, n2], 0), c2 = numeric.clone(t4.x), l2 = numeric.clone(t4.y), u2, d2, p2, m2, h2, g2, v2, y2, r2, i2, a2, b2, x2, S2, w2, E, D, O2;
    for (r2 = 0; r2 < n2; r2++) {
      for (S2 = c2[r2][r2], w2 = l2[r2][r2], b2 = S2 * S2 + w2 * w2, a2 = r2, i2 = r2 + 1; i2 < n2; i2++) S2 = c2[i2][r2], w2 = l2[i2][r2], x2 = S2 * S2 + w2 * w2, x2 > b2 && (a2 = i2, b2 = x2);
      for (a2 !== r2 && (O2 = c2[r2], c2[r2] = c2[a2], c2[a2] = O2, O2 = l2[r2], l2[r2] = l2[a2], l2[a2] = O2, O2 = o2[r2], o2[r2] = o2[a2], o2[a2] = O2, O2 = s2[r2], s2[r2] = s2[a2], s2[a2] = O2), u2 = c2[r2], d2 = l2[r2], h2 = o2[r2], g2 = s2[r2], S2 = u2[r2], w2 = d2[r2], i2 = r2 + 1; i2 < n2; i2++) E = u2[i2], D = d2[i2], u2[i2] = (E * S2 + D * w2) / b2, d2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = 0; i2 < n2; i2++) E = h2[i2], D = g2[i2], h2[i2] = (E * S2 + D * w2) / b2, g2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = r2 + 1; i2 < n2; i2++) {
        for (p2 = c2[i2], m2 = l2[i2], v2 = o2[i2], y2 = s2[i2], S2 = p2[r2], w2 = m2[r2], a2 = r2 + 1; a2 < n2; a2++) E = u2[a2], D = d2[a2], p2[a2] -= E * S2 - D * w2, m2[a2] -= D * S2 + E * w2;
        for (a2 = 0; a2 < n2; a2++) E = h2[a2], D = g2[a2], v2[a2] -= E * S2 - D * w2, y2[a2] -= D * S2 + E * w2;
      }
    }
    for (r2 = n2 - 1; r2 > 0; r2--) for (h2 = o2[r2], g2 = s2[r2], i2 = r2 - 1; i2 >= 0; i2--) for (v2 = o2[i2], y2 = s2[i2], S2 = c2[i2][r2], w2 = l2[i2][r2], a2 = n2 - 1; a2 >= 0; a2--) E = h2[a2], D = g2[a2], v2[a2] -= S2 * E - w2 * D, y2[a2] -= S2 * D + w2 * E;
    return new numeric.T(o2, s2);
  }, numeric.T.prototype.get = function(t4) {
    var n2 = this.x, r2 = this.y, i2 = 0, a2, o2 = t4.length;
    if (r2) {
      for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], r2 = r2[a2], i2++;
      return new numeric.T(n2, r2);
    }
    for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], i2++;
    return new numeric.T(n2);
  }, numeric.T.prototype.set = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = 0, o2, s2 = t4.length, c2 = n2.x, l2 = n2.y;
    if (s2 === 0) return l2 ? this.y = l2 : i2 && (this.y = void 0), this.x = r2, this;
    if (l2) {
      for (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2); a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, i2[o2] = l2, this;
    }
    if (i2) {
      for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, c2 instanceof Array ? i2[o2] = numeric.rep(numeric.dim(c2), 0) : i2[o2] = 0, this;
    }
    for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], a2++;
    return o2 = t4[a2], r2[o2] = c2, this;
  }, numeric.T.prototype.getRows = function(t4, n2) {
    var r2 = n2 - t4 + 1, i2, a2 = Array(r2), o2, s2 = this.x, c2 = this.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2 - t4] = s2[i2];
    if (c2) {
      for (o2 = Array(r2), i2 = t4; i2 <= n2; i2++) o2[i2 - t4] = c2[i2];
      return new numeric.T(a2, o2);
    }
    return new numeric.T(a2);
  }, numeric.T.prototype.setRows = function(t4, n2, r2) {
    var i2, a2 = this.x, o2 = this.y, s2 = r2.x, c2 = r2.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2] = s2[i2 - t4];
    if (c2) for (o2 || (o2 = numeric.rep(numeric.dim(a2), 0), this.y = o2), i2 = t4; i2 <= n2; i2++) o2[i2] = c2[i2 - t4];
    else if (o2) for (i2 = t4; i2 <= n2; i2++) o2[i2] = numeric.rep([s2[i2 - t4].length], 0);
    return this;
  }, numeric.T.prototype.getRow = function(t4) {
    var n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(n2[t4], r2[t4]) : new numeric.T(n2[t4]);
  }, numeric.T.prototype.setRow = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = n2.x, o2 = n2.y;
    return r2[t4] = a2, o2 ? (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2), i2[t4] = o2) : i2 &&= numeric.rep([a2.length], 0), this;
  }, numeric.T.prototype.getBlock = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = numeric.getBlock;
    return i2 ? new numeric.T(a2(r2, t4, n2), a2(i2, t4, n2)) : new numeric.T(a2(r2, t4, n2));
  }, numeric.T.prototype.setBlock = function(t4, n2, r2) {
    r2 instanceof numeric.T || (r2 = new numeric.T(r2));
    var i2 = this.x, a2 = this.y, o2 = numeric.setBlock, s2 = r2.x, c2 = r2.y;
    if (c2) return a2 ||= (this.y = numeric.rep(numeric.dim(this), 0), this.y), o2(i2, t4, n2, s2), o2(a2, t4, n2, c2), this;
    o2(i2, t4, n2, s2), a2 && o2(a2, t4, n2, numeric.rep(numeric.dim(s2), 0));
  }, numeric.T.rep = function(t4, n2) {
    var r2 = numeric.T;
    n2 instanceof r2 || (n2 = new r2(n2));
    var i2 = n2.x, a2 = n2.y, o2 = numeric.rep;
    return a2 ? new r2(o2(t4, i2), o2(t4, a2)) : new r2(o2(t4, i2));
  }, numeric.T.diag = function(t4) {
    t4 instanceof numeric.T || (t4 = new numeric.T(t4));
    var n2 = t4.x, r2 = t4.y, i2 = numeric.diag;
    return r2 ? new numeric.T(i2(n2), i2(r2)) : new numeric.T(i2(n2));
  }, numeric.T.eig = function() {
    if (this.y) throw Error(`eig: not implemented for complex matrices.`);
    return numeric.eig(this.x);
  }, numeric.T.identity = function(t4) {
    return new numeric.T(numeric.identity(t4));
  }, numeric.T.prototype.getDiag = function() {
    var t4 = numeric, n2 = this.x, r2 = this.y;
    return r2 ? new t4.T(t4.getDiag(n2), t4.getDiag(r2)) : new t4.T(t4.getDiag(n2));
  }, numeric.house = function(t4) {
    var n2 = numeric.clone(t4), r2 = (t4[0] >= 0 ? 1 : -1) * numeric.norm2(t4);
    n2[0] += r2;
    var i2 = numeric.norm2(n2);
    if (i2 === 0) throw Error(`eig: internal error`);
    return numeric.div(n2, i2);
  }, numeric.toUpperHessenberg = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: toUpperHessenberg() only works on square matrices`);
    var r2 = n2[0], i2, a2, o2, s2, c2, l2 = numeric.clone(t4), u2, d2, p2, m2, h2 = numeric.identity(r2), g2;
    for (a2 = 0; a2 < r2 - 2; a2++) {
      for (s2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) s2[i2 - a2 - 1] = l2[i2][a2];
      if (numeric.norm2(s2) > 0) {
        for (c2 = numeric.house(s2), u2 = numeric.getBlock(l2, [a2 + 1, a2], [r2 - 1, r2 - 1]), d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2 - a2 - 1], o2 = a2; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2];
        for (u2 = numeric.getBlock(l2, [0, a2 + 1], [r2 - 1, r2 - 1]), d2 = numeric.tensor(numeric.dot(u2, c2), c2), i2 = 0; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2], o2 = a2 + 1; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2 - 1];
        for (u2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) u2[i2 - a2 - 1] = h2[i2];
        for (d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (g2 = h2[i2], m2 = d2[i2 - a2 - 1], o2 = 0; o2 < r2; o2++) g2[o2] -= 2 * m2[o2];
      }
    }
    return { H: l2, Q: h2 };
  }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(t4, n2) {
    n2 === void 0 && (n2 = 1e4), t4 = numeric.clone(t4);
    numeric.clone(t4);
    var i2 = numeric.dim(t4)[0], a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = numeric.identity(i2), g2, v2, y2, b2, x2, S2, w2, E, D;
    if (i2 < 3) return { Q: h2, B: [[0, i2 - 1]] };
    var O2 = numeric.epsilon;
    for (D = 0; D < n2; D++) {
      for (w2 = 0; w2 < i2 - 1; w2++) if (Math.abs(t4[w2 + 1][w2]) < O2 * (Math.abs(t4[w2][w2]) + Math.abs(t4[w2 + 1][w2 + 1]))) {
        var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [w2, w2]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [w2 + 1, w2 + 1], [i2 - 1, i2 - 1]), n2);
        for (y2 = Array(w2 + 1), S2 = 0; S2 <= w2; S2++) y2[S2] = h2[S2];
        for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= w2; S2++) h2[S2] = b2[S2];
        for (y2 = Array(i2 - w2 - 1), S2 = w2 + 1; S2 < i2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.dot(M2.Q, y2), S2 = w2 + 1; S2 < i2; S2++) h2[S2] = b2[S2 - w2 - 1];
        return { Q: h2, B: j2.B.concat(numeric.add(M2.B, w2 + 1)) };
      }
      if (s2 = t4[i2 - 2][i2 - 2], c2 = t4[i2 - 2][i2 - 1], l2 = t4[i2 - 1][i2 - 2], u2 = t4[i2 - 1][i2 - 1], p2 = s2 + u2, d2 = s2 * u2 - c2 * l2, m2 = numeric.getBlock(t4, [0, 0], [2, 2]), p2 * p2 >= 4 * d2) {
        var N2 = 0.5 * (p2 + Math.sqrt(p2 * p2 - 4 * d2)), F = 0.5 * (p2 - Math.sqrt(p2 * p2 - 4 * d2));
        m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, N2 + F)), numeric.diag(numeric.rep([3], N2 * F)));
      } else m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, p2)), numeric.diag(numeric.rep([3], d2)));
      for (a2 = [m2[0][0], m2[1][0], m2[2][0]], o2 = numeric.house(a2), y2 = [t4[0], t4[1], t4[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < i2; E++) v2[E] -= 2 * x2[E];
      for (y2 = numeric.getBlock(t4, [0, 0], [i2 - 1, 2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < 3; E++) v2[E] -= 2 * x2[E];
      for (y2 = [h2[0], h2[1], h2[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (g2 = h2[S2], x2 = b2[S2], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      var I2;
      for (w2 = 0; w2 < i2 - 2; w2++) {
        for (E = w2; E <= w2 + 1; E++) if (Math.abs(t4[E + 1][E]) < O2 * (Math.abs(t4[E][E]) + Math.abs(t4[E + 1][E + 1]))) {
          var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [E, E]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [E + 1, E + 1], [i2 - 1, i2 - 1]), n2);
          for (y2 = Array(E + 1), S2 = 0; S2 <= E; S2++) y2[S2] = h2[S2];
          for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= E; S2++) h2[S2] = b2[S2];
          for (y2 = Array(i2 - E - 1), S2 = E + 1; S2 < i2; S2++) y2[S2 - E - 1] = h2[S2];
          for (b2 = numeric.dot(M2.Q, y2), S2 = E + 1; S2 < i2; S2++) h2[S2] = b2[S2 - E - 1];
          return { Q: h2, B: j2.B.concat(numeric.add(M2.B, E + 1)) };
        }
        for (I2 = Math.min(i2 - 1, w2 + 3), a2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) a2[S2 - w2 - 1] = t4[S2][w2];
        for (o2 = numeric.house(a2), y2 = numeric.getBlock(t4, [w2 + 1, w2], [I2, i2 - 1]), b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (v2 = t4[S2], x2 = b2[S2 - w2 - 1], E = w2; E < i2; E++) v2[E] -= 2 * x2[E - w2];
        for (y2 = numeric.getBlock(t4, [0, w2 + 1], [i2 - 1, I2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = w2 + 1; E <= I2; E++) v2[E] -= 2 * x2[E - w2 - 1];
        for (y2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (g2 = h2[S2], x2 = b2[S2 - w2 - 1], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      }
    }
    throw Error(`numeric: eigenvalue iteration does not converge -- increase maxiter?`);
  }, numeric.eig = function(t4, n2) {
    var r2 = numeric.toUpperHessenberg(t4), i2 = numeric.QRFrancis(r2.H, n2), a2 = numeric.T, o2 = t4.length, s2, c2, u2 = i2.B, d2 = numeric.dot(i2.Q, numeric.dot(r2.H, numeric.transpose(i2.Q))), p2 = new a2(numeric.dot(i2.Q, r2.Q)), m2, h2 = u2.length, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2 = Math.sqrt;
    for (c2 = 0; c2 < h2; c2++) if (s2 = u2[c2][0], s2 !== u2[c2][1]) {
      if (g2 = s2 + 1, v2 = d2[s2][s2], y2 = d2[s2][g2], b2 = d2[g2][s2], x2 = d2[g2][g2], y2 === 0 && b2 === 0) continue;
      S2 = -v2 - x2, w2 = v2 * x2 - y2 * b2, E = S2 * S2 - 4 * w2, E >= 0 ? (D = S2 < 0 ? -0.5 * (S2 - I2(E)) : -0.5 * (S2 + I2(E)), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2), j2 = (v2 - D) / N2, M2 = y2 / N2) : (F = I2(F), j2 = b2 / F, M2 = (x2 - D) / F), m2 = new a2([[M2, -j2], [j2, M2]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2)))) : (D = -0.5 * S2, O2 = 0.5 * I2(-E), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2 + O2 * O2), j2 = (v2 - D) / N2, M2 = y2 / N2, D = 0, O2 /= N2) : (F = I2(F + O2 * O2), j2 = b2 / F, M2 = (x2 - D) / F, D = O2 / F, O2 = 0), m2 = new a2([[M2, -j2], [j2, M2]], [[D, O2], [O2, -D]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2))));
    }
    var L2 = p2.dot(t4).dot(p2.transjugate()), o2 = t4.length, R2 = numeric.T.identity(o2);
    for (g2 = 0; g2 < o2; g2++) if (g2 > 0) for (c2 = g2 - 1; c2 >= 0; c2--) {
      var z2 = L2.get([c2, c2]), V2 = L2.get([g2, g2]);
      if (numeric.neq(z2.x, V2.x) || numeric.neq(z2.y, V2.y)) D = L2.getRow(c2).getBlock([c2], [g2 - 1]), O2 = R2.getRow(g2).getBlock([c2], [g2 - 1]), R2.set([g2, c2], L2.get([c2, g2]).neg().sub(D.dot(O2)).div(z2.sub(V2)));
      else {
        R2.setRow(g2, R2.getRow(c2));
        continue;
      }
    }
    for (g2 = 0; g2 < o2; g2++) D = R2.getRow(g2), R2.setRow(g2, D.div(D.norm2()));
    return R2 = R2.transpose(), R2 = p2.transjugate().dot(R2), { lambda: L2.getDiag(), E: R2 };
  }, numeric.ccsSparse = function(t4) {
    var n2 = t4.length, r2, i2, a2, o2, s2 = [];
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) {
      for (o2 = parseInt(o2); o2 >= s2.length; ) s2[s2.length] = 0;
      i2[o2] !== 0 && s2[o2]++;
    }
    var r2 = s2.length, c2 = Array(r2 + 1);
    for (c2[0] = 0, a2 = 0; a2 < r2; ++a2) c2[a2 + 1] = c2[a2] + s2[a2];
    var l2 = Array(c2[r2]), u2 = Array(c2[r2]);
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) i2[o2] !== 0 && (s2[o2]--, l2[c2[o2] + s2[o2]] = a2, u2[c2[o2] + s2[o2]] = i2[o2]);
    return [c2, l2, u2];
  }, numeric.ccsFull = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.ccsDim(t4), o2 = a2[0], s2 = a2[1], c2, l2, u2, d2, m2 = numeric.rep([o2, s2], 0);
    for (c2 = 0; c2 < s2; c2++) for (u2 = n2[c2], d2 = n2[c2 + 1], l2 = u2; l2 < d2; ++l2) m2[r2[l2]][c2] = i2[l2];
    return m2;
  }, numeric.ccsTSolve = function(t4, n2, r2, i2, a2) {
    var o2 = t4[0], s2 = t4[1], c2 = t4[2], l2 = o2.length - 1, u2 = Math.max, d2 = 0;
    i2 === void 0 && (r2 = numeric.rep([l2], 0)), i2 === void 0 && (i2 = numeric.linspace(0, r2.length - 1)), a2 === void 0 && (a2 = []);
    function p2(t5) {
      var n3;
      if (r2[t5] === 0) {
        for (r2[t5] = 1, n3 = o2[t5]; n3 < o2[t5 + 1]; ++n3) p2(s2[n3]);
        a2[d2] = t5, ++d2;
      }
    }
    var m2, h2, g2, v2, y2, b2, w2;
    for (m2 = i2.length - 1; m2 !== -1; --m2) p2(i2[m2]);
    for (a2.length = d2, m2 = a2.length - 1; m2 !== -1; --m2) r2[a2[m2]] = 0;
    for (m2 = i2.length - 1; m2 !== -1; --m2) h2 = i2[m2], r2[h2] = n2[h2];
    for (m2 = a2.length - 1; m2 !== -1; --m2) {
      for (h2 = a2[m2], g2 = o2[h2], v2 = u2(o2[h2 + 1], g2), y2 = g2; y2 !== v2; ++y2) if (s2[y2] === h2) {
        r2[h2] /= c2[y2];
        break;
      }
      for (w2 = r2[h2], y2 = g2; y2 !== v2; ++y2) b2 = s2[y2], b2 !== h2 && (r2[b2] -= w2 * c2[y2]);
    }
    return r2;
  }, numeric.ccsDFS = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS.prototype.dfs = function(t4, n2, r2, i2, a2, o2) {
    var s2 = 0, c2, l2 = a2.length, u2 = this.k, d2 = this.k1, p2 = this.j, m2, h2;
    if (i2[t4] === 0) for (i2[t4] = 1, p2[0] = t4, u2[0] = m2 = n2[t4], d2[0] = h2 = n2[t4 + 1]; ; ) if (m2 >= h2) {
      if (a2[l2] = p2[s2], s2 === 0) return;
      ++l2, --s2, m2 = u2[s2], h2 = d2[s2];
    } else c2 = o2[r2[m2]], i2[c2] === 0 ? (i2[c2] = 1, u2[s2] = m2, ++s2, p2[s2] = c2, m2 = n2[c2], d2[s2] = h2 = n2[c2 + 1]) : ++m2;
  }, numeric.ccsLPSolve = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = t4[0], l2 = t4[1], u2 = t4[2];
    c2.length - 1;
    var m2 = n2[0], h2 = n2[1], g2 = n2[2], v2, y2 = m2[a2], b2 = m2[a2 + 1], x2, w2, E, D, O2, N2;
    for (i2.length = 0, v2 = y2; v2 < b2; ++v2) s2.dfs(o2[h2[v2]], c2, l2, r2, i2, o2);
    for (v2 = i2.length - 1; v2 !== -1; --v2) r2[i2[v2]] = 0;
    for (v2 = y2; v2 !== b2; ++v2) x2 = o2[h2[v2]], r2[x2] = g2[v2];
    for (v2 = i2.length - 1; v2 !== -1; --v2) {
      for (x2 = i2[v2], w2 = c2[x2], E = c2[x2 + 1], D = w2; D < E; ++D) if (o2[l2[D]] === x2) {
        r2[x2] /= u2[D];
        break;
      }
      for (N2 = r2[x2], D = w2; D < E; ++D) O2 = o2[l2[D]], O2 !== x2 && (r2[O2] -= N2 * u2[D]);
    }
    return r2;
  }, numeric.ccsLUP1 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[v2]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[h2]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2, x2 = p2[h2], p2[h2] = p2[S2], p2[S2] = x2), x2 = o2[h2], S2 = l2[h2], E = p2[h2], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[v2], m2[g2] = 0, p2[v2] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsDFS0 = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS0.prototype.dfs = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = 0, l2, u2 = a2.length, d2 = this.k, p2 = this.k1, m2 = this.j, h2, g2;
    if (i2[t4] === 0) for (i2[t4] = 1, m2[0] = t4, d2[0] = h2 = n2[o2[t4]], p2[0] = g2 = n2[o2[t4] + 1]; ; ) {
      if (isNaN(h2)) throw Error(`Ow!`);
      if (h2 >= g2) {
        if (a2[u2] = o2[m2[c2]], c2 === 0) return;
        ++u2, --c2, h2 = d2[c2], g2 = p2[c2];
      } else l2 = r2[h2], i2[l2] === 0 ? (i2[l2] = 1, d2[c2] = h2, ++c2, m2[c2] = l2, l2 = o2[l2], h2 = n2[l2], p2[c2] = g2 = n2[l2 + 1]) : ++h2;
    }
  }, numeric.ccsLPSolve0 = function(t4, n2, r2, i2, a2, o2, s2, c2) {
    var l2 = t4[0], u2 = t4[1], d2 = t4[2];
    l2.length - 1;
    var h2 = n2[0], g2 = n2[1], v2 = n2[2], y2, b2 = h2[a2], x2 = h2[a2 + 1], S2, E, D, O2, j2, F;
    for (i2.length = 0, y2 = b2; y2 < x2; ++y2) c2.dfs(g2[y2], l2, u2, r2, i2, o2, s2);
    for (y2 = i2.length - 1; y2 !== -1; --y2) S2 = i2[y2], r2[s2[S2]] = 0;
    for (y2 = b2; y2 !== x2; ++y2) S2 = g2[y2], r2[S2] = v2[y2];
    for (y2 = i2.length - 1; y2 !== -1; --y2) {
      for (S2 = i2[y2], j2 = s2[S2], E = l2[S2], D = l2[S2 + 1], O2 = E; O2 < D; ++O2) if (u2[O2] === j2) {
        r2[j2] /= d2[O2];
        break;
      }
      for (F = r2[j2], O2 = E; O2 < D; ++O2) r2[u2[O2]] -= F * d2[O2];
      r2[j2] = F;
    }
  }, numeric.ccsLUP0 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve0, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS0(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, N2, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[N2[v2]]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[N2[h2]]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2), x2 = o2[h2], S2 = l2[h2], E = p2[N2[h2]], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[N2[v2]], m2[g2] = 0, p2[N2[v2]] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(t4) {
    return [numeric.sup(t4[1]) + 1, t4[0].length - 1];
  }, numeric.ccsGetBlock = function(t4, n2, r2) {
    var i2 = numeric.ccsDim(t4), a2 = i2[0], o2 = i2[1];
    n2 === void 0 ? n2 = numeric.linspace(0, a2 - 1) : typeof n2 == `number` && (n2 = [n2]), r2 === void 0 ? r2 = numeric.linspace(0, o2 - 1) : typeof r2 == `number` && (r2 = [r2]);
    var s2, u2 = n2.length, d2, p2 = r2.length, m2, h2, g2, v2 = numeric.rep([o2], 0), y2 = [], b2 = [], x2 = [v2, y2, b2], S2 = t4[0], w2 = t4[1], E = t4[2], D = numeric.rep([a2], 0), O2 = 0, j2 = numeric.rep([a2], 0);
    for (d2 = 0; d2 < p2; ++d2) {
      h2 = r2[d2];
      var M2 = S2[h2], N2 = S2[h2 + 1];
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 1, D[m2] = E[s2];
      for (s2 = 0; s2 < u2; ++s2) g2 = n2[s2], j2[g2] && (y2[O2] = s2, b2[O2] = D[n2[s2]], ++O2);
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 0;
      v2[d2 + 1] = O2;
    }
    return x2;
  }, numeric.ccsDot = function(t4, n2) {
    var r2 = t4[0], i2 = t4[1], a2 = t4[2], o2 = n2[0], s2 = n2[1], c2 = n2[2], l2 = numeric.ccsDim(t4), u2 = numeric.ccsDim(n2), d2 = l2[0];
    l2[1];
    var m2 = u2[1], h2 = numeric.rep([d2], 0), g2 = numeric.rep([d2], 0), v2 = Array(d2), y2 = numeric.rep([m2], 0), b2 = [], x2 = [], S2 = [y2, b2, x2], w2, E, D, O2, j2, M2, N2, F, I2, L2, R2;
    for (D = 0; D !== m2; ++D) {
      for (O2 = o2[D], j2 = o2[D + 1], I2 = 0, E = O2; E < j2; ++E) for (L2 = s2[E], R2 = c2[E], M2 = r2[L2], N2 = r2[L2 + 1], w2 = M2; w2 < N2; ++w2) F = i2[w2], g2[F] === 0 && (v2[I2] = F, g2[F] = 1, I2 += 1), h2[F] = h2[F] + a2[w2] * R2;
      for (O2 = y2[D], j2 = O2 + I2, y2[D + 1] = j2, E = I2 - 1; E !== -1; --E) R2 = O2 + E, w2 = v2[E], b2[R2] = w2, x2[R2] = h2[w2], g2[w2] = 0, h2[w2] = 0;
      y2[D + 1] = y2[D] + I2;
    }
    return S2;
  }, numeric.ccsLUPSolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U;
    t4.P;
    var o2 = n2[0], s2 = false;
    typeof o2 != `object` && (n2 = [[0, n2.length], numeric.linspace(0, n2.length - 1), n2], o2 = n2[0], s2 = true);
    var c2 = n2[1], l2 = n2[2], u2 = r2[0].length - 1, d2 = o2.length - 1, p2 = numeric.rep([u2], 0), m2 = Array(u2), h2 = numeric.rep([u2], 0), g2 = Array(u2), v2 = numeric.rep([d2 + 1], 0), y2 = [], b2 = [], x2 = numeric.ccsTSolve, S2, w2, E, D, O2, j2, M2 = 0;
    for (S2 = 0; S2 < d2; ++S2) {
      for (O2 = 0, E = o2[S2], D = o2[S2 + 1], w2 = E; w2 < D; ++w2) j2 = t4.Pinv[c2[w2]], g2[O2] = j2, h2[j2] = l2[w2], ++O2;
      for (g2.length = O2, x2(r2, h2, p2, g2, m2), w2 = g2.length - 1; w2 !== -1; --w2) h2[g2[w2]] = 0;
      if (x2(i2, p2, h2, m2, g2), s2) return h2;
      for (w2 = m2.length - 1; w2 !== -1; --w2) p2[m2[w2]] = 0;
      for (w2 = g2.length - 1; w2 !== -1; --w2) j2 = g2[w2], y2[M2] = j2, b2[M2] = h2[j2], h2[j2] = 0, ++M2;
      v2[S2 + 1] = M2;
    }
    return [v2, y2, b2];
  }, numeric.ccsbinop = function(t4, n2) {
    return n2 === void 0 && (n2 = ``), Function(`X`, `Y`, `var Xi = X[0], Xj = X[1], Xv = X[2];
var Yi = Y[0], Yj = Y[1], Yv = Y[2];
var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;
var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];
var x = numeric.rep([m],0),y = numeric.rep([m],0);
var xk,yk,zk;
var i,j,j0,j1,k,p=0;
` + n2 + `for(i=0;i<n;++i) {
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Xj[j];
    x[k] = 1;
    Zj[p] = k;
    ++p;
  }
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Yj[j];
    y[k] = Yv[j];
    if(x[k] === 0) {
      Zj[p] = k;
      ++p;
    }
  }
  Zi[i+1] = p;
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];
  j0 = Zi[i]; j1 = Zi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Zj[j];
    xk = x[k];
    yk = y[k];
` + t4 + `
    Zv[j] = zk;
  }
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;
}
return [Zi,Zj,Zv];`);
  }, (function() {
    var k, A, B, C;
    for (k in numeric.ops2) A = isFinite(eval(`1` + numeric.ops2[k] + `0`)) ? `[Y[0],Y[1],numeric.` + k + `(X,Y[2])]` : `NaN`, B = isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `[X[0],X[1],numeric.` + k + `(X[2],Y)]` : `NaN`, C = isFinite(eval(`1` + numeric.ops2[k] + `0`)) && isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `numeric.ccs` + k + `MM(X,Y)` : `NaN`, numeric[`ccs` + k + `MM`] = numeric.ccsbinop(`zk = xk ` + numeric.ops2[k] + `yk;`), numeric[`ccs` + k] = Function(`X`, `Y`, `if(typeof X === "number") return ` + A + `;
if(typeof Y === "number") return ` + B + `;
return ` + C + `;
`);
  })(), numeric.ccsScatter = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.sup(r2) + 1, o2 = n2.length, s2 = numeric.rep([a2], 0), c2 = Array(o2), l2 = Array(o2), u2 = numeric.rep([a2], 0), d2;
    for (d2 = 0; d2 < o2; ++d2) u2[r2[d2]]++;
    for (d2 = 0; d2 < a2; ++d2) s2[d2 + 1] = s2[d2] + u2[d2];
    var p2 = s2.slice(0), m2, h2;
    for (d2 = 0; d2 < o2; ++d2) h2 = r2[d2], m2 = p2[h2], c2[m2] = n2[d2], l2[m2] = i2[d2], p2[h2] = p2[h2] + 1;
    return [s2, c2, l2];
  }, numeric.ccsGather = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length - 1, o2 = r2.length, s2 = Array(o2), c2 = Array(o2), l2 = Array(o2), u2, d2, p2, m2, h2 = 0;
    for (u2 = 0; u2 < a2; ++u2) for (p2 = n2[u2], m2 = n2[u2 + 1], d2 = p2; d2 !== m2; ++d2) c2[h2] = u2, s2[h2] = r2[d2], l2[h2] = i2[d2], ++h2;
    return [s2, c2, l2];
  }, numeric.sdim = function t4(n2, r2, i2) {
    if (r2 === void 0 && (r2 = []), typeof n2 != `object`) return r2;
    for (var a2 in i2 === void 0 && (i2 = 0), i2 in r2 || (r2[i2] = 0), n2.length > r2[i2] && (r2[i2] = n2.length), n2) n2.hasOwnProperty(a2) && t4(n2[a2], r2, i2 + 1);
    return r2;
  }, numeric.sclone = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = 0), i2 === void 0 && (i2 = numeric.sdim(n2).length);
    var a2, o2 = Array(n2.length);
    if (r2 === i2 - 1) {
      for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = n2[a2]);
      return o2;
    }
    for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = t4(n2[a2], r2 + 1, i2));
    return o2;
  }, numeric.sdiag = function(t4) {
    var n2 = t4.length, r2, i2 = Array(n2), a2;
    for (r2 = n2 - 1; r2 >= 1; r2 -= 2) a2 = r2 - 1, i2[r2] = [], i2[r2][r2] = t4[r2], i2[a2] = [], i2[a2][a2] = t4[a2];
    return r2 === 0 && (i2[0] = [], i2[0][0] = t4[r2]), i2;
  }, numeric.sidentity = function(t4) {
    return numeric.sdiag(numeric.rep([t4], 1));
  }, numeric.stranspose = function(t4) {
    var n2 = [];
    t4.length;
    var i2, a2, o2;
    for (i2 in t4) if (t4.hasOwnProperty(i2)) for (a2 in o2 = t4[i2], o2) o2.hasOwnProperty(a2) && (typeof n2[a2] != `object` && (n2[a2] = []), n2[a2][i2] = o2[a2]);
    return n2;
  }, numeric.sLUP = function(t4, n2) {
    throw Error(`The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.`);
  }, numeric.sdotMM = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2 = numeric.stranspose(n2), o2 = a2.length, s2, c2, l2, u2, d2, p2, m2 = Array(r2), h2;
    for (l2 = r2 - 1; l2 >= 0; l2--) {
      for (h2 = [], s2 = t4[l2], d2 = o2 - 1; d2 >= 0; d2--) {
        for (u2 in p2 = 0, c2 = a2[d2], s2) s2.hasOwnProperty(u2) && u2 in c2 && (p2 += s2[u2] * c2[u2]);
        p2 && (h2[d2] = p2);
      }
      m2[l2] = h2;
    }
    return m2;
  }, numeric.sdotMV = function(t4, n2) {
    var r2 = t4.length, i2, a2, o2, s2 = Array(r2), c2;
    for (a2 = r2 - 1; a2 >= 0; a2--) {
      for (o2 in i2 = t4[a2], c2 = 0, i2) i2.hasOwnProperty(o2) && n2[o2] && (c2 += i2[o2] * n2[o2]);
      c2 && (s2[a2] = c2);
    }
    return s2;
  }, numeric.sdotVM = function(t4, n2) {
    var r2, i2, a2, o2, s2 = [];
    for (r2 in t4) if (t4.hasOwnProperty(r2)) for (i2 in a2 = n2[r2], o2 = t4[r2], a2) a2.hasOwnProperty(i2) && (s2[i2] || (s2[i2] = 0), s2[i2] += o2 * a2[i2]);
    return s2;
  }, numeric.sdotVV = function(t4, n2) {
    var r2, i2 = 0;
    for (r2 in t4) t4[r2] && n2[r2] && (i2 += t4[r2] * n2[r2]);
    return i2;
  }, numeric.sdot = function(t4, n2) {
    var r2 = numeric.sdim(t4).length, i2 = numeric.sdim(n2).length;
    switch (r2 * 1e3 + i2) {
      case 0:
        return t4 * n2;
      case 1001:
        return numeric.sdotVV(t4, n2);
      case 2001:
        return numeric.sdotMV(t4, n2);
      case 1002:
        return numeric.sdotVM(t4, n2);
      case 2002:
        return numeric.sdotMM(t4, n2);
      default:
        throw Error(`numeric.sdot not implemented for tensors of order ` + r2 + ` and ` + i2);
    }
  }, numeric.sscatter = function(t4) {
    var n2 = t4[0].length, r2, i2, a2, o2 = t4.length, s2 = [], c2;
    for (i2 = n2 - 1; i2 >= 0; --i2) if (t4[o2 - 1][i2]) {
      for (c2 = s2, a2 = 0; a2 < o2 - 2; a2++) r2 = t4[a2][i2], c2[r2] || (c2[r2] = []), c2 = c2[r2];
      c2[t4[a2][i2]] = t4[a2 + 1][i2];
    }
    return s2;
  }, numeric.sgather = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = []), i2 === void 0 && (i2 = []);
    var a2 = i2.length, o2, s2;
    for (o2 in n2) if (n2.hasOwnProperty(o2)) if (i2[a2] = parseInt(o2), s2 = n2[o2], typeof s2 == `number`) {
      if (s2) {
        if (r2.length === 0) for (o2 = a2 + 1; o2 >= 0; --o2) r2[o2] = [];
        for (o2 = a2; o2 >= 0; --o2) r2[o2].push(i2[o2]);
        r2[a2 + 1].push(s2);
      }
    } else t4(s2, r2, i2);
    return i2.length > a2 && i2.pop(), r2;
  }, numeric.cLU = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length, o2 = 0, s2, c2, l2, u2, d2, p2;
    for (s2 = 0; s2 < a2; s2++) n2[s2] > o2 && (o2 = n2[s2]);
    o2++;
    var m2 = Array(o2), h2 = Array(o2), g2 = numeric.rep([o2], 1 / 0), v2 = numeric.rep([o2], -1 / 0), y2, b2, x2;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], c2 = r2[l2], c2 < g2[s2] && (g2[s2] = c2), c2 > v2[s2] && (v2[s2] = c2);
    for (s2 = 0; s2 < o2 - 1; s2++) v2[s2] > v2[s2 + 1] && (v2[s2 + 1] = v2[s2]);
    for (s2 = o2 - 1; s2 >= 1; s2--) g2[s2] < g2[s2 - 1] && (g2[s2 - 1] = g2[s2]);
    var S2 = 0, w2 = 0;
    for (s2 = 0; s2 < o2; s2++) h2[s2] = numeric.rep([v2[s2] - g2[s2] + 1], 0), m2[s2] = numeric.rep([s2 - g2[s2]], 0), S2 += s2 - g2[s2] + 1, w2 += v2[s2] - s2 + 1;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], h2[s2][r2[l2] - g2[s2]] = i2[l2];
    for (s2 = 0; s2 < o2 - 1; s2++) for (u2 = s2 - g2[s2], y2 = h2[s2], c2 = s2 + 1; g2[c2] <= s2 && c2 < o2; c2++) if (d2 = s2 - g2[c2], p2 = v2[s2] - s2, b2 = h2[c2], x2 = b2[d2] / y2[u2], x2) {
      for (l2 = 1; l2 <= p2; l2++) b2[l2 + d2] -= x2 * y2[l2 + u2];
      m2[c2][s2 - g2[c2]] = x2;
    }
    var y2 = [], b2 = [], E = [], D = [], O2 = [], j2 = [], a2 = 0, M2 = 0, N2;
    for (s2 = 0; s2 < o2; s2++) {
      for (u2 = g2[s2], d2 = v2[s2], N2 = h2[s2], c2 = s2; c2 <= d2; c2++) N2[c2 - u2] && (y2[a2] = s2, b2[a2] = c2, E[a2] = N2[c2 - u2], a2++);
      for (N2 = m2[s2], c2 = u2; c2 < s2; c2++) N2[c2 - u2] && (D[M2] = s2, O2[M2] = c2, j2[M2] = N2[c2 - u2], M2++);
      D[M2] = s2, O2[M2] = s2, j2[M2] = 1, M2++;
    }
    return { U: [y2, b2, E], L: [D, O2, j2] };
  }, numeric.cLUsolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U, a2 = numeric.clone(n2), o2 = r2[0], s2 = r2[1], c2 = r2[2], l2 = i2[0], u2 = i2[1], d2 = i2[2], p2 = l2.length;
    o2.length;
    var h2 = a2.length, g2, y2 = 0;
    for (g2 = 0; g2 < h2; g2++) {
      for (; s2[y2] < g2; ) a2[g2] -= c2[y2] * a2[s2[y2]], y2++;
      y2++;
    }
    for (y2 = p2 - 1, g2 = h2 - 1; g2 >= 0; g2--) {
      for (; u2[y2] > g2; ) a2[g2] -= d2[y2] * a2[u2[y2]], y2--;
      a2[g2] /= d2[y2], y2--;
    }
    return a2;
  }, numeric.cgrid = function(t4, n2) {
    typeof t4 == `number` && (t4 = [t4, t4]);
    var r2 = numeric.rep(t4, -1), i2, a2, o2;
    if (typeof n2 != `function`) switch (n2) {
      case `L`:
        n2 = function(n3, r3) {
          return n3 >= t4[0] / 2 || r3 < t4[1] / 2;
        };
        break;
      default:
        n2 = function(t5, n3) {
          return true;
        };
        break;
    }
    for (o2 = 0, i2 = 1; i2 < t4[0] - 1; i2++) for (a2 = 1; a2 < t4[1] - 1; a2++) n2(i2, a2) && (r2[i2][a2] = o2, o2++);
    return r2;
  }, numeric.cdelsq = function(t4) {
    var n2 = [[-1, 0], [0, -1], [0, 1], [1, 0]], r2 = numeric.dim(t4), i2 = r2[0], a2 = r2[1], o2, s2, c2, l2, u2, d2 = [], p2 = [], m2 = [];
    for (o2 = 1; o2 < i2 - 1; o2++) for (s2 = 1; s2 < a2 - 1; s2++) if (!(t4[o2][s2] < 0)) {
      for (c2 = 0; c2 < 4; c2++) l2 = o2 + n2[c2][0], u2 = s2 + n2[c2][1], !(t4[l2][u2] < 0) && (d2.push(t4[o2][s2]), p2.push(t4[l2][u2]), m2.push(-1));
      d2.push(t4[o2][s2]), p2.push(t4[o2][s2]), m2.push(4);
    }
    return [d2, p2, m2];
  }, numeric.cdotMV = function(t4, n2) {
    var r2, i2 = t4[0], a2 = t4[1], o2 = t4[2], s2, c2 = i2.length, l2 = 0;
    for (s2 = 0; s2 < c2; s2++) i2[s2] > l2 && (l2 = i2[s2]);
    for (l2++, r2 = numeric.rep([l2], 0), s2 = 0; s2 < c2; s2++) r2[i2[s2]] += o2[s2] * n2[a2[s2]];
    return r2;
  }, numeric.Spline = function(t4, n2, r2, i2, a2) {
    this.x = t4, this.yl = n2, this.yr = r2, this.kl = i2, this.kr = a2;
  }, numeric.Spline.prototype._at = function(t4, n2) {
    var r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr, t4, c2, l2, u2, d2 = numeric.add, p2 = numeric.sub, m2 = numeric.mul;
    c2 = p2(m2(o2[n2], r2[n2 + 1] - r2[n2]), p2(a2[n2 + 1], i2[n2])), l2 = d2(m2(s2[n2 + 1], r2[n2] - r2[n2 + 1]), p2(a2[n2 + 1], i2[n2])), u2 = (t4 - r2[n2]) / (r2[n2 + 1] - r2[n2]);
    var h2 = u2 * (1 - u2);
    return d2(d2(d2(m2(1 - u2, i2[n2]), m2(u2, a2[n2 + 1])), m2(c2, h2 * (1 - u2))), m2(l2, h2 * u2));
  }, numeric.Spline.prototype.at = function(t4) {
    if (typeof t4 == `number`) {
      var n2 = this.x, r2 = n2.length, i2, a2, o2, s2 = Math.floor;
      for (i2 = 0, a2 = r2 - 1; a2 - i2 > 1; ) o2 = s2((i2 + a2) / 2), n2[o2] <= t4 ? i2 = o2 : a2 = o2;
      return this._at(t4, i2);
    }
    var r2 = t4.length, d2, p2 = Array(r2);
    for (d2 = r2 - 1; d2 !== -1; --d2) p2[d2] = this.at(t4[d2]);
    return p2;
  }, numeric.Spline.prototype.diff = function() {
    var t4 = this.x, n2 = this.yl, r2 = this.yr, i2 = this.kl, a2 = this.kr, o2 = n2.length, s2, c2, l2, u2 = i2, d2 = a2, p2 = Array(o2), m2 = Array(o2), h2 = numeric.add, g2 = numeric.mul, v2 = numeric.div, y2 = numeric.sub;
    for (s2 = o2 - 1; s2 !== -1; --s2) c2 = t4[s2 + 1] - t4[s2], l2 = y2(r2[s2 + 1], n2[s2]), p2[s2] = v2(h2(g2(l2, 6), g2(i2[s2], -4 * c2), g2(a2[s2 + 1], -2 * c2)), c2 * c2), m2[s2 + 1] = v2(h2(g2(l2, -6), g2(i2[s2], 2 * c2), g2(a2[s2 + 1], 4 * c2)), c2 * c2);
    return new numeric.Spline(t4, u2, d2, p2, m2);
  }, numeric.Spline.prototype.roots = function() {
    function t4(t5) {
      return t5 * t5;
    }
    var n2 = [], r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr;
    typeof i2[0] == `number` && (i2 = [i2], a2 = [a2], o2 = [o2], s2 = [s2]);
    var c2 = i2.length, l2 = r2.length - 1, u2, d2, p2, v2, y2, b2, x2, n2 = Array(c2), S2, w2, E, D, O2, j2, M2, N2, F, L2, R2, z2, V2, H2, U2, W2, G2 = Math.sqrt;
    for (u2 = 0; u2 !== c2; ++u2) {
      for (v2 = i2[u2], y2 = a2[u2], b2 = o2[u2], x2 = s2[u2], S2 = [], d2 = 0; d2 !== l2; d2++) {
        for (d2 > 0 && y2[d2] * v2[d2] < 0 && S2.push(r2[d2]), F = r2[d2 + 1] - r2[d2], r2[d2], D = v2[d2], O2 = y2[d2 + 1], w2 = b2[d2] / F, E = x2[d2 + 1] / F, N2 = t4(w2 - E + 3 * (D - O2)) + 12 * E * D, j2 = E + 3 * D + 2 * w2 - 3 * O2, M2 = 3 * (E + w2 + 2 * (D - O2)), N2 <= 0 ? (R2 = j2 / M2, L2 = R2 > r2[d2] && R2 < r2[d2 + 1] ? [r2[d2], R2, r2[d2 + 1]] : [r2[d2], r2[d2 + 1]]) : (R2 = (j2 - G2(N2)) / M2, z2 = (j2 + G2(N2)) / M2, L2 = [r2[d2]], R2 > r2[d2] && R2 < r2[d2 + 1] && L2.push(R2), z2 > r2[d2] && z2 < r2[d2 + 1] && L2.push(z2), L2.push(r2[d2 + 1])), H2 = L2[0], R2 = this._at(H2, d2), p2 = 0; p2 < L2.length - 1; p2++) {
          if (U2 = L2[p2 + 1], z2 = this._at(U2, d2), R2 === 0) {
            S2.push(H2), H2 = U2, R2 = z2;
            continue;
          }
          if (z2 === 0 || R2 * z2 > 0) {
            H2 = U2, R2 = z2;
            continue;
          }
          for (var K2 = 0; W2 = (R2 * U2 - z2 * H2) / (R2 - z2), !(W2 <= H2 || W2 >= U2); ) if (V2 = this._at(W2, d2), V2 * z2 > 0) U2 = W2, z2 = V2, K2 === -1 && (R2 *= 0.5), K2 = -1;
          else if (V2 * R2 > 0) H2 = W2, R2 = V2, K2 === 1 && (z2 *= 0.5), K2 = 1;
          else break;
          S2.push(W2), H2 = L2[p2 + 1], R2 = this._at(H2, d2);
        }
        z2 === 0 && S2.push(U2);
      }
      n2[u2] = S2;
    }
    return typeof this.yl[0] == `number` ? n2[0] : n2;
  }, numeric.spline = function(t4, n2, r2, i2) {
    var a2 = t4.length, o2 = [], s2 = [], c2 = [], l2, u2 = numeric.sub, d2 = numeric.mul, p2 = numeric.add;
    for (l2 = a2 - 2; l2 >= 0; l2--) s2[l2] = t4[l2 + 1] - t4[l2], c2[l2] = u2(n2[l2 + 1], n2[l2]);
    (typeof r2 == `string` || typeof i2 == `string`) && (r2 = i2 = `periodic`);
    var m2 = [[], [], []];
    switch (typeof r2) {
      case `undefined`:
        o2[0] = d2(3 / (s2[0] * s2[0]), c2[0]), m2[0].push(0, 0), m2[1].push(0, 1), m2[2].push(2 / s2[0], 1 / s2[0]);
        break;
      case `string`:
        o2[0] = p2(d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), d2(3 / (s2[0] * s2[0]), c2[0])), m2[0].push(0, 0, 0), m2[1].push(a2 - 2, 0, 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2] + 2 / s2[0], 1 / s2[0]);
        break;
      default:
        o2[0] = r2, m2[0].push(0), m2[1].push(0), m2[2].push(1);
        break;
    }
    for (l2 = 1; l2 < a2 - 1; l2++) o2[l2] = p2(d2(3 / (s2[l2 - 1] * s2[l2 - 1]), c2[l2 - 1]), d2(3 / (s2[l2] * s2[l2]), c2[l2])), m2[0].push(l2, l2, l2), m2[1].push(l2 - 1, l2, l2 + 1), m2[2].push(1 / s2[l2 - 1], 2 / s2[l2 - 1] + 2 / s2[l2], 1 / s2[l2]);
    switch (typeof i2) {
      case `undefined`:
        o2[a2 - 1] = d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), m2[0].push(a2 - 1, a2 - 1), m2[1].push(a2 - 2, a2 - 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2]);
        break;
      case `string`:
        m2[1][m2[1].length - 1] = 0;
        break;
      default:
        o2[a2 - 1] = i2, m2[0].push(a2 - 1), m2[1].push(a2 - 1), m2[2].push(1);
        break;
    }
    o2 = typeof o2[0] == `number` ? [o2] : numeric.transpose(o2);
    var h2 = Array(o2.length);
    if (typeof r2 == `string`) for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(m2)), o2[l2]), h2[l2][a2 - 1] = h2[l2][0];
    else for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.cLUsolve(numeric.cLU(m2), o2[l2]);
    return h2 = typeof n2[0] == `number` ? h2[0] : numeric.transpose(h2), new numeric.Spline(t4, n2, n2, h2, h2);
  }, numeric.fftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = -6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric._ifftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = 6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric.ifftpow2 = function(t4, n2) {
    numeric._ifftpow2(t4, n2), numeric.diveq(t4, t4.length), numeric.diveq(n2, n2.length);
  }, numeric.convpow2 = function(t4, n2, r2, i2) {
    numeric.fftpow2(t4, n2), numeric.fftpow2(r2, i2);
    var a2, o2 = t4.length, s2, c2, l2, u2;
    for (a2 = o2 - 1; a2 !== -1; --a2) s2 = t4[a2], l2 = n2[a2], c2 = r2[a2], u2 = i2[a2], t4[a2] = s2 * c2 - l2 * u2, n2[a2] = s2 * u2 + l2 * c2;
    numeric.ifftpow2(t4, n2);
  }, numeric.T.prototype.fft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = -3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2;
  }, numeric.T.prototype.ifft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = 3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2.div(r2);
  }, numeric.gradient = function(t4, n2) {
    var r2 = n2.length, i2 = t4(n2);
    if (isNaN(i2)) throw Error(`gradient: f(x) is a NaN!`);
    var a2 = Math.max, o2, s2 = numeric.clone(n2), c2, l2, u2 = Array(r2);
    numeric.div;
    numeric.sub;
    var m2, a2 = Math.max, g2 = 1e-3, v2 = Math.abs, y2 = Math.min, b2, x2, S2, w2 = 0, E, D, O2;
    for (o2 = 0; o2 < r2; o2++) for (var j2 = a2(1e-6 * i2, 1e-8); ; ) {
      if (++w2, w2 > 20) throw Error(`Numerical gradient fails`);
      if (s2[o2] = n2[o2] + j2, c2 = t4(s2), s2[o2] = n2[o2] - j2, l2 = t4(s2), s2[o2] = n2[o2], isNaN(c2) || isNaN(l2)) {
        j2 /= 16;
        continue;
      }
      if (u2[o2] = (c2 - l2) / (2 * j2), b2 = n2[o2] - j2, x2 = n2[o2], S2 = n2[o2] + j2, E = (c2 - i2) / j2, D = (i2 - l2) / j2, O2 = a2(v2(u2[o2]), v2(i2), v2(c2), v2(l2), v2(b2), v2(x2), v2(S2), 1e-8), m2 = y2(a2(v2(E - u2[o2]), v2(D - u2[o2]), v2(E - D)) / O2, j2 / O2), m2 > g2) j2 /= 16;
      else break;
    }
    return u2;
  }, numeric.uncmin = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.gradient;
    s2 === void 0 && (s2 = {}), r2 === void 0 && (r2 = 1e-8), i2 === void 0 && (i2 = function(n3) {
      return c2(t4, n3);
    }), a2 === void 0 && (a2 = 1e3), n2 = numeric.clone(n2);
    var l2 = n2.length, u2 = t4(n2), d2, p2;
    if (isNaN(u2)) throw Error(`uncmin: f(x0) is a NaN!`);
    var m2 = Math.max, h2 = numeric.norm2;
    r2 = m2(r2, numeric.epsilon);
    var g2, v2, y2, b2 = s2.Hinv || numeric.identity(l2), x2 = numeric.dot;
    numeric.inv;
    var w2 = numeric.sub, E = numeric.add, D = numeric.tensor, O2 = numeric.div, j2 = numeric.mul, M2 = numeric.all, N2 = numeric.isFinite, F = numeric.neg, I2 = 0, R2, z2, V2, H2, W2, K2, q2, Y2 = ``;
    for (v2 = i2(n2); I2 < a2; ) {
      if (typeof o2 == `function` && o2(I2, n2, u2, v2, b2)) {
        Y2 = `Callback returned true`;
        break;
      }
      if (!M2(N2(v2))) {
        Y2 = `Gradient has Infinity or NaN`;
        break;
      }
      if (g2 = F(x2(b2, v2)), !M2(N2(g2))) {
        Y2 = `Search direction has Infinity or NaN`;
        break;
      }
      if (q2 = h2(g2), q2 < r2) {
        Y2 = `Newton step smaller than tol`;
        break;
      }
      for (K2 = 1, p2 = x2(v2, g2), z2 = n2; I2 < a2 && !(K2 * q2 < r2); ) {
        if (R2 = j2(g2, K2), z2 = E(n2, R2), d2 = t4(z2), d2 - u2 >= 0.1 * K2 * p2 || isNaN(d2)) {
          K2 *= 0.5, ++I2;
          continue;
        }
        break;
      }
      if (K2 * q2 < r2) {
        Y2 = `Line search step size smaller than tol`;
        break;
      }
      if (I2 === a2) {
        Y2 = `maxit reached during line search`;
        break;
      }
      y2 = i2(z2), V2 = w2(y2, v2), W2 = x2(V2, R2), H2 = x2(b2, V2), b2 = w2(E(b2, j2((W2 + x2(V2, H2)) / (W2 * W2), D(R2, R2))), O2(E(D(H2, R2), D(R2, H2)), W2)), n2 = z2, u2 = d2, v2 = y2, ++I2;
    }
    return { solution: n2, f: u2, gradient: v2, invHessian: b2, iterations: I2, message: Y2 };
  }, numeric.Dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    this.x = t4, this.y = n2, this.f = r2, this.ymid = i2, this.iterations = a2, this.events = s2, this.message = o2;
  }, numeric.Dopri.prototype._at = function(t4, n2) {
    function r2(t5) {
      return t5 * t5;
    }
    var i2 = this, a2 = i2.x, o2 = i2.y, s2 = i2.f, c2 = i2.ymid;
    a2.length;
    var u2, d2, p2, m2, h2, g2, t4, y2, b2 = 0.5, x2 = numeric.add, S2 = numeric.mul, w2 = numeric.sub, E, D, O2;
    return u2 = a2[n2], d2 = a2[n2 + 1], m2 = o2[n2], h2 = o2[n2 + 1], y2 = d2 - u2, p2 = u2 + b2 * y2, g2 = c2[n2], E = w2(s2[n2], S2(m2, 1 / (u2 - p2) + 2 / (u2 - d2))), D = w2(s2[n2 + 1], S2(h2, 1 / (d2 - p2) + 2 / (d2 - u2))), O2 = [r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), r2(t4 - u2) * r2(t4 - d2) / r2(u2 - p2) / r2(d2 - p2), r2(t4 - u2) * (t4 - p2) / r2(d2 - u2) / (d2 - p2), (t4 - u2) * r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), (t4 - d2) * r2(t4 - u2) * (t4 - p2) / r2(u2 - d2) / (d2 - p2)], x2(x2(x2(x2(S2(m2, O2[0]), S2(g2, O2[1])), S2(h2, O2[2])), S2(E, O2[3])), S2(D, O2[4]));
  }, numeric.Dopri.prototype.at = function(t4) {
    var n2, r2, i2, a2 = Math.floor;
    if (typeof t4 != `number`) {
      var o2 = t4.length, s2 = Array(o2);
      for (n2 = o2 - 1; n2 !== -1; --n2) s2[n2] = this.at(t4[n2]);
      return s2;
    }
    var c2 = this.x;
    for (n2 = 0, r2 = c2.length - 1; r2 - n2 > 1; ) i2 = a2(0.5 * (n2 + r2)), c2[i2] <= t4 ? n2 = i2 : r2 = i2;
    return this._at(t4, n2);
  }, numeric.dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    a2 === void 0 && (a2 = 1e-6), o2 === void 0 && (o2 = 1e3);
    var c2 = [t4], l2 = [r2], u2 = [i2(t4, r2)], d2, p2, m2, h2, g2, v2, y2 = [], b2 = 1 / 5, x2 = [3 / 40, 9 / 40], S2 = [44 / 45, -56 / 15, 32 / 9], w2 = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], E = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], D = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], O2 = [0.5 * 6025192743 / 30085553152, 0, 0.5 * 51252292925 / 65400821598, 0.5 * -2691868925 / 45128329728, 0.5 * 187940372067 / 1594534317056, 0.5 * -1776094331 / 19743644256, 0.5 * 11237099 / 235043384], j2 = [1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], M2 = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], N2 = 0, F, I2, L2 = (n2 - t4) / 10, R2 = 0, z2 = numeric.add, V2 = numeric.mul, H2, U2, G2 = Math.min, K2 = Math.abs, q2 = numeric.norminf, J = Math.pow, ee2 = numeric.any, Y2 = numeric.lt, te2 = numeric.and;
    numeric.sub;
    var X2, ie2, ae2, Z2 = new numeric.Dopri(c2, l2, u2, y2, -1, ``);
    for (typeof s2 == `function` && (X2 = s2(t4, r2)); t4 < n2 && R2 < o2; ) {
      if (++R2, t4 + L2 > n2 && (L2 = n2 - t4), d2 = i2(t4 + j2[0] * L2, z2(r2, V2(b2 * L2, u2[N2]))), p2 = i2(t4 + j2[1] * L2, z2(z2(r2, V2(x2[0] * L2, u2[N2])), V2(x2[1] * L2, d2))), m2 = i2(t4 + j2[2] * L2, z2(z2(z2(r2, V2(S2[0] * L2, u2[N2])), V2(S2[1] * L2, d2)), V2(S2[2] * L2, p2))), h2 = i2(t4 + j2[3] * L2, z2(z2(z2(z2(r2, V2(w2[0] * L2, u2[N2])), V2(w2[1] * L2, d2)), V2(w2[2] * L2, p2)), V2(w2[3] * L2, m2))), g2 = i2(t4 + j2[4] * L2, z2(z2(z2(z2(z2(r2, V2(E[0] * L2, u2[N2])), V2(E[1] * L2, d2)), V2(E[2] * L2, p2)), V2(E[3] * L2, m2)), V2(E[4] * L2, h2))), H2 = z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * D[0])), V2(p2, L2 * D[2])), V2(m2, L2 * D[3])), V2(h2, L2 * D[4])), V2(g2, L2 * D[5])), v2 = i2(t4 + L2, H2), F = z2(z2(z2(z2(z2(V2(u2[N2], L2 * M2[0]), V2(p2, L2 * M2[2])), V2(m2, L2 * M2[3])), V2(h2, L2 * M2[4])), V2(g2, L2 * M2[5])), V2(v2, L2 * M2[6])), U2 = typeof F == `number` ? K2(F) : q2(F), U2 > a2) {
        if (L2 = 0.2 * L2 * J(a2 / U2, 0.25), t4 + L2 === t4) {
          Z2.msg = `Step size became too small`;
          break;
        }
        continue;
      }
      if (y2[N2] = z2(z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * O2[0])), V2(p2, L2 * O2[2])), V2(m2, L2 * O2[3])), V2(h2, L2 * O2[4])), V2(g2, L2 * O2[5])), V2(v2, L2 * O2[6])), ++N2, c2[N2] = t4 + L2, l2[N2] = H2, u2[N2] = v2, typeof s2 == `function`) {
        var oe2, $2 = t4, se2 = t4 + 0.5 * L2, ce2;
        if (ie2 = s2(se2, y2[N2 - 1]), ae2 = te2(Y2(X2, 0), Y2(0, ie2)), ee2(ae2) || ($2 = se2, se2 = t4 + L2, X2 = ie2, ie2 = s2(se2, H2), ae2 = te2(Y2(X2, 0), Y2(0, ie2))), ee2(ae2)) {
          for (var le2, ue2, de2, fe2, pe2 = 0, me2 = 1, he2 = 1; ; ) {
            if (typeof X2 == `number`) ce2 = (he2 * ie2 * $2 - me2 * X2 * se2) / (he2 * ie2 - me2 * X2);
            else for (ce2 = se2, I2 = X2.length - 1; I2 !== -1; --I2) X2[I2] < 0 && ie2[I2] > 0 && (ce2 = G2(ce2, (he2 * ie2[I2] * $2 - me2 * X2[I2] * se2) / (he2 * ie2[I2] - me2 * X2[I2])));
            if (ce2 <= $2 || ce2 >= se2) break;
            oe2 = Z2._at(ce2, N2 - 1), fe2 = s2(ce2, oe2), de2 = te2(Y2(X2, 0), Y2(0, fe2)), ee2(de2) ? (se2 = ce2, ie2 = fe2, ae2 = de2, he2 = 1, pe2 === -1 ? me2 *= 0.5 : me2 = 1, pe2 = -1) : ($2 = ce2, X2 = fe2, me2 = 1, pe2 === 1 ? he2 *= 0.5 : he2 = 1, pe2 = 1);
          }
          return H2 = Z2._at(0.5 * (t4 + ce2), N2 - 1), Z2.f[N2] = i2(ce2, oe2), Z2.x[N2] = ce2, Z2.y[N2] = oe2, Z2.ymid[N2 - 1] = H2, Z2.events = ae2, Z2.iterations = R2, Z2;
        }
      }
      t4 += L2, r2 = H2, X2 = ie2, L2 = G2(0.8 * L2 * J(a2 / U2, 0.25), 4 * L2);
    }
    return Z2.iterations = R2, Z2;
  }, numeric.LU = function(t4, n2) {
    n2 ||= false;
    var r2 = Math.abs, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2 = t4.length, h2 = m2 - 1, g2 = Array(m2);
    for (n2 || (t4 = numeric.clone(t4)), o2 = 0; o2 < m2; ++o2) {
      for (u2 = o2, l2 = t4[o2], p2 = r2(l2[o2]), a2 = o2 + 1; a2 < m2; ++a2) s2 = r2(t4[a2][o2]), p2 < s2 && (p2 = s2, u2 = a2);
      for (g2[o2] = u2, u2 != o2 && (t4[o2] = t4[u2], t4[u2] = l2, l2 = t4[o2]), c2 = l2[o2], i2 = o2 + 1; i2 < m2; ++i2) t4[i2][o2] /= c2;
      for (i2 = o2 + 1; i2 < m2; ++i2) {
        for (d2 = t4[i2], a2 = o2 + 1; a2 < h2; ++a2) d2[a2] -= d2[o2] * l2[a2], ++a2, d2[a2] -= d2[o2] * l2[a2];
        a2 === h2 && (d2[a2] -= d2[o2] * l2[a2]);
      }
    }
    return { LU: t4, P: g2 };
  }, numeric.LUsolve = function(t4, n2) {
    var r2, i2, a2 = t4.LU, o2 = a2.length, s2 = numeric.clone(n2), c2 = t4.P, l2, u2, p2;
    for (r2 = o2 - 1; r2 !== -1; --r2) s2[r2] = n2[r2];
    for (r2 = 0; r2 < o2; ++r2) for (l2 = c2[r2], c2[r2] !== r2 && (p2 = s2[r2], s2[r2] = s2[l2], s2[l2] = p2), u2 = a2[r2], i2 = 0; i2 < r2; ++i2) s2[r2] -= s2[i2] * u2[i2];
    for (r2 = o2 - 1; r2 >= 0; --r2) {
      for (u2 = a2[r2], i2 = r2 + 1; i2 < o2; ++i2) s2[r2] -= s2[i2] * u2[i2];
      s2[r2] /= u2[r2];
    }
    return s2;
  }, numeric.solve = function(t4, n2, r2) {
    return numeric.LUsolve(numeric.LU(t4, r2), n2);
  }, numeric.echelonize = function(t4) {
    var n2 = numeric.dim(t4), r2 = n2[0], i2 = n2[1], a2 = numeric.identity(r2), o2 = Array(r2), s2, c2, l2, u2, d2, p2, m2, h2, g2 = Math.abs, v2 = numeric.diveq;
    for (t4 = numeric.clone(t4), s2 = 0; s2 < r2; ++s2) {
      for (l2 = 0, d2 = t4[s2], p2 = a2[s2], c2 = 1; c2 < i2; ++c2) g2(d2[l2]) < g2(d2[c2]) && (l2 = c2);
      for (o2[s2] = l2, v2(p2, d2[l2]), v2(d2, d2[l2]), c2 = 0; c2 < r2; ++c2) if (c2 !== s2) {
        for (m2 = t4[c2], h2 = m2[l2], u2 = i2 - 1; u2 !== -1; --u2) m2[u2] -= d2[u2] * h2;
        for (m2 = a2[c2], u2 = r2 - 1; u2 !== -1; --u2) m2[u2] -= p2[u2] * h2;
      }
    }
    return { I: a2, A: t4, P: o2 };
  }, numeric.__solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.sum;
    numeric.log;
    var u2 = numeric.mul, d2 = numeric.sub, p2 = numeric.dot, m2 = numeric.div, h2 = numeric.add, g2 = t4.length, v2 = r2.length, y2, b2 = false, S2 = 0, w2 = 1;
    numeric.transpose(n2);
    numeric.svd;
    var M2 = numeric.transpose;
    numeric.leq;
    var F = Math.sqrt, I2 = Math.abs;
    numeric.muleq;
    numeric.norminf;
    numeric.any;
    var V2 = Math.min, H2 = numeric.all, U2 = numeric.gt, W2 = Array(g2), G2 = Array(v2);
    numeric.rep([v2], 1);
    var q2, J = numeric.solve, ee2 = d2(r2, p2(n2, o2)), Y2, te2 = p2(t4, t4), ne2;
    for (Y2 = S2; Y2 < a2; ++Y2) {
      var X2, ae2;
      for (X2 = v2 - 1; X2 !== -1; --X2) G2[X2] = m2(n2[X2], ee2[X2]);
      var Z2 = M2(G2);
      for (X2 = g2 - 1; X2 !== -1; --X2) W2[X2] = c2(Z2[X2]);
      w2 = 0.25 * I2(te2 / p2(t4, W2));
      var oe2 = 100 * F(te2 / p2(W2, W2));
      for ((!isFinite(w2) || w2 > oe2) && (w2 = oe2), ne2 = h2(t4, u2(w2, W2)), q2 = p2(Z2, G2), X2 = g2 - 1; X2 !== -1; --X2) q2[X2][X2] += 1;
      ae2 = J(q2, m2(ne2, w2), true);
      var $2 = m2(ee2, p2(n2, ae2)), se2 = 1;
      for (X2 = v2 - 1; X2 !== -1; --X2) $2[X2] < 0 && (se2 = V2(se2, -0.999 * $2[X2]));
      if (y2 = d2(o2, u2(ae2, se2)), ee2 = d2(r2, p2(n2, y2)), !H2(U2(ee2, 0))) return { solution: o2, message: ``, iterations: Y2 };
      if (o2 = y2, w2 < i2) return { solution: y2, message: ``, iterations: Y2 };
      if (s2) {
        var ce2 = p2(t4, ne2), le2 = p2(n2, ne2);
        for (b2 = true, X2 = v2 - 1; X2 !== -1; --X2) if (ce2 * le2[X2] < 0) {
          b2 = false;
          break;
        }
      } else b2 = !(o2[g2 - 1] >= 0);
      if (b2) return { solution: y2, message: `Unbounded`, iterations: Y2 };
    }
    return { solution: o2, message: `maximum iteration count exceeded`, iterations: Y2 };
  }, numeric._solveLP = function(t4, n2, r2, i2, a2) {
    var o2 = t4.length, s2 = r2.length, c2;
    numeric.sum;
    numeric.log;
    numeric.mul;
    var p2 = numeric.sub, m2 = numeric.dot;
    numeric.div;
    numeric.add;
    var v2 = numeric.rep([o2], 0).concat([1]), y2 = numeric.rep([s2, 1], -1), b2 = numeric.blockMatrix([[n2, y2]]), x2 = r2, c2 = numeric.rep([o2], 0).concat(Math.max(0, numeric.sup(numeric.neg(r2))) + 1), S2 = numeric.__solveLP(v2, b2, x2, i2, a2, c2, false), w2 = numeric.clone(S2.solution);
    if (w2.length = o2, numeric.inf(p2(r2, m2(n2, w2))) < 0) return { solution: NaN, message: `Infeasible`, iterations: S2.iterations };
    var E = numeric.__solveLP(t4, n2, r2, i2, a2 - S2.iterations, w2, true);
    return E.iterations += S2.iterations, E;
  }, numeric.solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    if (s2 === void 0 && (s2 = 1e3), o2 === void 0 && (o2 = numeric.epsilon), i2 === void 0) return numeric._solveLP(t4, n2, r2, o2, s2);
    var c2 = i2.length, l2 = i2[0].length, u2 = n2.length, d2 = numeric.echelonize(i2), p2 = numeric.rep([l2], 0), m2 = d2.P, h2 = [], g2;
    for (g2 = m2.length - 1; g2 !== -1; --g2) p2[m2[g2]] = 1;
    for (g2 = l2 - 1; g2 !== -1; --g2) p2[g2] === 0 && h2.push(g2);
    var v2 = numeric.getRange, y2 = numeric.linspace(0, c2 - 1), b2 = numeric.linspace(0, u2 - 1), x2 = v2(i2, y2, h2), S2 = v2(n2, b2, m2), w2 = v2(n2, b2, h2), E = numeric.dot, D = numeric.sub, O2 = E(S2, d2.I), j2 = D(w2, E(O2, x2)), M2 = D(r2, E(O2, a2)), N2 = Array(m2.length), F = Array(h2.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) N2[g2] = t4[m2[g2]];
    for (g2 = h2.length - 1; g2 !== -1; --g2) F[g2] = t4[h2[g2]];
    var I2 = D(F, E(N2, E(d2.I, x2))), L2 = numeric._solveLP(I2, j2, M2, o2, s2), R2 = L2.solution;
    if (R2 !== R2) return L2;
    var z2 = E(d2.I, D(a2, E(x2, R2))), V2 = Array(t4.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) V2[m2[g2]] = z2[g2];
    for (g2 = h2.length - 1; g2 !== -1; --g2) V2[h2[g2]] = R2[g2];
    return { solution: V2, message: L2.message, iterations: L2.iterations };
  }, numeric.MPStoLP = function(t4) {
    t4 instanceof String && t4.split(`
`);
    var n2 = 0, r2 = [`Initial state`, `NAME`, `ROWS`, `COLUMNS`, `RHS`, `BOUNDS`, `ENDATA`], i2 = t4.length, a2, o2, s2, c2 = 0, l2 = {}, u2 = [], d2 = 0, p2 = {}, m2 = 0, h2, g2 = [], v2 = [], y2 = [];
    function b2(i3) {
      throw Error(`MPStoLP: ` + i3 + `
Line ` + a2 + `: ` + t4[a2] + `
Current state: ` + r2[n2] + `
`);
    }
    for (a2 = 0; a2 < i2; ++a2) {
      s2 = t4[a2];
      var x2 = s2.match(/\S*/g), S2 = [];
      for (o2 = 0; o2 < x2.length; ++o2) x2[o2] !== `` && S2.push(x2[o2]);
      if (S2.length !== 0) {
        for (o2 = 0; o2 < r2.length && s2.substr(0, r2[o2].length) !== r2[o2]; ++o2) ;
        if (o2 < r2.length) {
          if (n2 = o2, o2 === 1 && (h2 = S2[1]), o2 === 6) return { name: h2, c: g2, A: numeric.transpose(v2), b: y2, rows: l2, vars: p2 };
          continue;
        }
        switch (n2) {
          case 0:
          case 1:
            b2(`Unexpected line`);
          case 2:
            switch (S2[0]) {
              case `N`:
                c2 === 0 ? c2 = S2[1] : b2(`Two or more N rows`);
                break;
              case `L`:
                l2[S2[1]] = d2, u2[d2] = 1, y2[d2] = 0, ++d2;
                break;
              case `G`:
                l2[S2[1]] = d2, u2[d2] = -1, y2[d2] = 0, ++d2;
                break;
              case `E`:
                l2[S2[1]] = d2, u2[d2] = 0, y2[d2] = 0, ++d2;
                break;
              default:
                b2(`Parse error ` + numeric.prettyPrint(S2));
            }
            break;
          case 3:
            p2.hasOwnProperty(S2[0]) || (p2[S2[0]] = m2, g2[m2] = 0, v2[m2] = numeric.rep([d2], 0), ++m2);
            var w2 = p2[S2[0]];
            for (o2 = 1; o2 < S2.length; o2 += 2) {
              if (S2[o2] === c2) {
                g2[w2] = parseFloat(S2[o2 + 1]);
                continue;
              }
              var E = l2[S2[o2]];
              v2[w2][E] = (u2[E] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            }
            break;
          case 4:
            for (o2 = 1; o2 < S2.length; o2 += 2) y2[l2[S2[o2]]] = (u2[l2[S2[o2]]] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            break;
          case 5:
            break;
          case 6:
            b2(`Internal error`);
        }
      }
    }
    b2(`Reached end of file without ENDATA`);
  }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(t4, n2, r2, i2, a2, o2, s2) {
    n2.seedrandom = function(d3, p2) {
      var m2 = [], h2;
      return d3 = u2(l2(p2 ? [d3, t4] : arguments.length ? d3 : [(/* @__PURE__ */ new Date()).getTime(), t4, window], 3), m2), h2 = new c2(m2), u2(h2.S, t4), n2.random = function() {
        for (var t5 = h2.g(i2), n3 = s2, c3 = 0; t5 < a2; ) t5 = (t5 + c3) * r2, n3 *= r2, c3 = h2.g(1);
        for (; t5 >= o2; ) t5 /= 2, n3 /= 2, c3 >>>= 1;
        return (t5 + c3) / n3;
      }, d3;
    };
    function c2(t5) {
      var n3, i3, a3 = this, o3 = t5.length, s3 = 0, c3 = a3.i = a3.j = a3.m = 0;
      for (a3.S = [], a3.c = [], o3 || (t5 = [o3++]); s3 < r2; ) a3.S[s3] = s3++;
      for (s3 = 0; s3 < r2; s3++) n3 = a3.S[s3], c3 = d2(c3 + n3 + t5[s3 % o3]), i3 = a3.S[c3], a3.S[s3] = i3, a3.S[c3] = n3;
      a3.g = function(t6) {
        var n4 = a3.S, i4 = d2(a3.i + 1), o4 = n4[i4], s4 = d2(a3.j + o4), c4 = n4[s4];
        n4[i4] = c4, n4[s4] = o4;
        for (var l3 = n4[d2(o4 + c4)]; --t6; ) i4 = d2(i4 + 1), o4 = n4[i4], s4 = d2(s4 + o4), c4 = n4[s4], n4[i4] = c4, n4[s4] = o4, l3 = l3 * r2 + n4[d2(o4 + c4)];
        return a3.i = i4, a3.j = s4, l3;
      }, a3.g(r2);
    }
    function l2(t5, n3, r3, i3, a3) {
      if (r3 = [], a3 = typeof t5, n3 && a3 == `object`) {
        for (i3 in t5) if (i3.indexOf(`S`) < 5) try {
          r3.push(l2(t5[i3], n3 - 1));
        } catch {
        }
      }
      return r3.length ? r3 : t5 + (a3 == `string` ? `` : `\0`);
    }
    function u2(t5, n3, r3, i3) {
      for (t5 += ``, r3 = 0, i3 = 0; i3 < t5.length; i3++) n3[d2(i3)] = d2((r3 ^= n3[d2(i3)] * 19) + t5.charCodeAt(i3));
      for (i3 in t5 = ``, n3) t5 += String.fromCharCode(n3[i3]);
      return t5;
    }
    function d2(t5) {
      return t5 & r2 - 1;
    }
    s2 = n2.pow(r2, i2), a2 = n2.pow(2, a2), o2 = a2 * 2, u2(n2.random(), t4);
  })([], numeric.seedrandom, 256, 6, 52), (function(t4) {
    function n2(t5) {
      if (typeof t5 != `object`) return t5;
      var r3 = [], i3, a3 = t5.length;
      for (i3 = 0; i3 < a3; i3++) r3[i3 + 1] = n2(t5[i3]);
      return r3;
    }
    function r2(t5) {
      if (typeof t5 != `object`) return t5;
      var n3 = [], i3, a3 = t5.length;
      for (i3 = 1; i3 < a3; i3++) n3[i3 - 1] = r2(t5[i3]);
      return n3;
    }
    function i2(t5, n3, r3) {
      var i3, a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (t5[o3][o3] = 1 / t5[o3][o3], c3 = -t5[o3][o3], i3 = 1; i3 < o3; i3 += 1) t5[i3][o3] = c3 * t5[i3][o3];
        if (s3 = o3 + 1, r3 < s3) break;
        for (a3 = s3; a3 <= r3; a3 += 1) for (c3 = t5[o3][a3], t5[o3][a3] = 0, i3 = 1; i3 <= o3; i3 += 1) t5[i3][a3] = t5[i3][a3] + c3 * t5[i3][o3];
      }
    }
    function a2(t5, n3, r3, i3) {
      var a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (c3 = 0, a3 = 1; a3 < o3; a3 += 1) c3 += t5[a3][o3] * i3[a3];
        i3[o3] = (i3[o3] - c3) / t5[o3][o3];
      }
      for (s3 = 1; s3 <= r3; s3 += 1) for (o3 = r3 + 1 - s3, i3[o3] = i3[o3] / t5[o3][o3], c3 = -i3[o3], a3 = 1; a3 < o3; a3 += 1) i3[a3] = i3[a3] + c3 * t5[a3][o3];
    }
    function o2(t5, n3, r3, i3) {
      var a3, o3, s3, c3, l2, u2;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        if (i3[1] = o3, u2 = 0, s3 = o3 - 1, s3 < 1) {
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        } else {
          for (c3 = 1; c3 <= s3; c3 += 1) {
            for (l2 = t5[c3][o3], a3 = 1; a3 < c3; a3 += 1) l2 -= t5[a3][o3] * t5[a3][c3];
            l2 /= t5[c3][c3], t5[c3][o3] = l2, u2 += l2 * l2;
          }
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        }
        i3[1] = 0;
      }
    }
    function s2(t5, n3, r3, s3, c3, l2, u2, d2, p2, m2, h2, g2, v2, y2, b2, x2) {
      var S2, w2, E, D, O2, j2, M2, N2, F, I2, L2, R2, z2 = Math.min(s3, m2), V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2;
      E = 2 * s3 + z2 * (z2 + 5) / 2 + 2 * m2 + 1, te2 = 1e-60;
      do
        te2 += te2, ne2 = 1 + 0.1 * te2, X2 = 1 + 0.2 * te2;
      while (ne2 <= 1 || X2 <= 1);
      for (S2 = 1; S2 <= s3; S2 += 1) b2[S2] = n3[S2];
      for (S2 = s3 + 1; S2 <= E; S2 += 1) b2[S2] = 0;
      for (S2 = 1; S2 <= m2; S2 += 1) g2[S2] = 0;
      if (O2 = [], x2[1] === 0) {
        if (o2(t5, r3, s3, O2), O2[1] !== 0) {
          x2[1] = 2;
          return;
        }
        a2(t5, r3, s3, n3), i2(t5, r3, s3);
      } else {
        for (w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = 0, S2 = 1; S2 <= w2; S2 += 1) c3[w2] = c3[w2] + t5[S2][w2] * n3[S2];
        for (w2 = 1; w2 <= s3; w2 += 1) for (n3[w2] = 0, S2 = w2; S2 <= s3; S2 += 1) n3[w2] = n3[w2] + t5[w2][S2] * c3[S2];
      }
      for (l2[1] = 0, w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = n3[w2], l2[1] += b2[w2] * c3[w2], b2[w2] = 0, S2 = w2 + 1; S2 <= s3; S2 += 1) t5[S2][w2] = 0;
      for (l2[1] = -l2[1] / 2, x2[1] = 0, M2 = s3, N2 = M2 + s3, L2 = N2 + z2, F = L2 + z2 + 1, I2 = F + z2 * (z2 + 1) / 2, V2 = I2 + m2, S2 = 1; S2 <= m2; S2 += 1) {
        for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * u2[w2][S2];
        b2[V2 + S2] = Math.sqrt(U2);
      }
      v2 = 0, y2[1] = 0, y2[2] = 0;
      function ae2() {
        for (y2[1] += 1, E = I2, S2 = 1; S2 <= m2; S2 += 1) {
          for (E += 1, U2 = -d2[S2], w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * c3[w2];
          if (Math.abs(U2) < te2 && (U2 = 0), S2 > h2) b2[E] = U2;
          else if (b2[E] = -Math.abs(U2), U2 > 0) {
            for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][S2] = -u2[w2][S2];
            d2[S2] = -d2[S2];
          }
        }
        for (S2 = 1; S2 <= v2; S2 += 1) b2[I2 + g2[S2]] = 0;
        for (R2 = 0, H2 = 0, S2 = 1; S2 <= m2; S2 += 1) b2[I2 + S2] < H2 * b2[V2 + S2] && (R2 = S2, H2 = b2[I2 + S2] / b2[V2 + S2]);
        return R2 === 0 ? 999 : 0;
      }
      function Z2() {
        for (S2 = 1; S2 <= s3; S2 += 1) {
          for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += t5[w2][S2] * u2[w2][R2];
          b2[S2] = U2;
        }
        for (D = M2, S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = 0;
        for (w2 = v2 + 1; w2 <= s3; w2 += 1) for (S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = b2[D + S2] + t5[S2][w2] * b2[w2];
        for (ee2 = true, S2 = v2; S2 >= 1; --S2) {
          for (U2 = b2[S2], E = F + S2 * (S2 + 3) / 2, D = E - S2, w2 = S2 + 1; w2 <= v2; w2 += 1) U2 -= b2[E] * b2[N2 + w2], E += w2;
          if (U2 /= b2[D], b2[N2 + S2] = U2, g2[S2] < h2 || U2 < 0) break;
          ee2 = false, j2 = S2;
        }
        if (!ee2) for (W2 = b2[L2 + j2] / b2[N2 + j2], S2 = 1; S2 <= v2 && !(g2[S2] < h2 || b2[N2 + S2] < 0); S2 += 1) H2 = b2[L2 + S2] / b2[N2 + S2], H2 < W2 && (W2 = H2, j2 = S2);
        for (U2 = 0, S2 = M2 + 1; S2 <= M2 + s3; S2 += 1) U2 += b2[S2] * b2[S2];
        if (Math.abs(U2) <= te2) {
          if (ee2) return x2[1] = 1, 999;
          for (S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - W2 * b2[N2 + S2];
          return b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + W2, 700;
        } else {
          for (U2 = 0, S2 = 1; S2 <= s3; S2 += 1) U2 += b2[M2 + S2] * u2[S2][R2];
          for (G2 = -b2[I2 + R2] / U2, Y2 = true, ee2 || W2 < G2 && (G2 = W2, Y2 = false), S2 = 1; S2 <= s3; S2 += 1) c3[S2] = c3[S2] + G2 * b2[M2 + S2], Math.abs(c3[S2]) < te2 && (c3[S2] = 0);
          for (l2[1] += G2 * U2 * (G2 / 2 + b2[L2 + v2 + 1]), S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - G2 * b2[N2 + S2];
          if (b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + G2, Y2) {
            for (v2 += 1, g2[v2] = R2, E = F + (v2 - 1) * v2 / 2 + 1, S2 = 1; S2 <= v2 - 1; S2 += 1) b2[E] = b2[S2], E += 1;
            if (v2 === s3) b2[E] = b2[s3];
            else {
              for (S2 = s3; S2 >= v2 + 1 && !(b2[S2] === 0 || (K2 = Math.max(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), q2 = Math.min(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), H2 = b2[S2 - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[S2 - 1] / H2, q2 = b2[S2] / H2, K2 === 1)); --S2) if (K2 === 0) for (b2[S2 - 1] = q2 * H2, w2 = 1; w2 <= s3; w2 += 1) H2 = t5[w2][S2 - 1], t5[w2][S2 - 1] = t5[w2][S2], t5[w2][S2] = H2;
              else for (b2[S2 - 1] = H2, J = q2 / (1 + K2), w2 = 1; w2 <= s3; w2 += 1) H2 = K2 * t5[w2][S2 - 1] + q2 * t5[w2][S2], t5[w2][S2] = J * (t5[w2][S2 - 1] + H2) - t5[w2][S2], t5[w2][S2 - 1] = H2;
              b2[E] = b2[v2];
            }
          } else {
            for (U2 = -d2[R2], w2 = 1; w2 <= s3; w2 += 1) U2 += c3[w2] * u2[w2][R2];
            if (R2 > h2) b2[I2 + R2] = U2;
            else if (b2[I2 + R2] = -Math.abs(U2), U2 > 0) {
              for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][R2] = -u2[w2][R2];
              d2[R2] = -d2[R2];
            }
            return 700;
          }
        }
        return 0;
      }
      function oe2() {
        if (E = F + j2 * (j2 + 1) / 2 + 1, D = E + j2, b2[D] === 0 || (K2 = Math.max(Math.abs(b2[D - 1]), Math.abs(b2[D])), q2 = Math.min(Math.abs(b2[D - 1]), Math.abs(b2[D])), H2 = b2[D - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[D - 1] / H2, q2 = b2[D] / H2, K2 === 1)) return 798;
        if (K2 === 0) {
          for (S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = b2[D - 1], b2[D - 1] = b2[D], b2[D] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = t5[S2][j2], t5[S2][j2] = t5[S2][j2 + 1], t5[S2][j2 + 1] = H2;
        } else {
          for (J = q2 / (1 + K2), S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = K2 * b2[D - 1] + q2 * b2[D], b2[D] = J * (b2[D - 1] + H2) - b2[D], b2[D - 1] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = K2 * t5[S2][j2] + q2 * t5[S2][j2 + 1], t5[S2][j2 + 1] = J * (t5[S2][j2] + H2) - t5[S2][j2 + 1], t5[S2][j2] = H2;
        }
        return 0;
      }
      function $2() {
        for (D = E - j2, S2 = 1; S2 <= j2; S2 += 1) b2[D] = b2[E], E += 1, D += 1;
        return b2[L2 + j2] = b2[L2 + j2 + 1], g2[j2] = g2[j2 + 1], j2 += 1, j2 < v2 ? 797 : 0;
      }
      function se2() {
        return b2[L2 + v2] = b2[L2 + v2 + 1], b2[L2 + v2 + 1] = 0, g2[v2] = 0, --v2, y2[2] += 1, 0;
      }
      for (ie2 = 0; ; ) {
        if (ie2 = ae2(), ie2 === 999) return;
        for (; ie2 = Z2(), ie2 !== 0; ) {
          if (ie2 === 999) return;
          if (ie2 === 700) if (j2 === v2) se2();
          else {
            for (; oe2(), ie2 = $2(), ie2 === 797; ) ;
            se2();
          }
        }
      }
    }
    function c2(t5, i3, a3, o3, c3, l2) {
      t5 = n2(t5), i3 = n2(i3), a3 = n2(a3);
      var u2, d2, p2, m2, h2, g2 = [], v2 = [], y2 = [], b2 = [], x2 = [], S2;
      if (c3 ||= 0, l2 = l2 ? n2(l2) : [void 0, 0], o3 = o3 ? n2(o3) : [], d2 = t5.length - 1, p2 = a3[1].length - 1, !o3) for (u2 = 1; u2 <= p2; u2 += 1) o3[u2] = 0;
      for (u2 = 1; u2 <= p2; u2 += 1) v2[u2] = 0;
      for (m2 = 0, h2 = Math.min(d2, p2), u2 = 1; u2 <= d2; u2 += 1) y2[u2] = 0;
      for (g2[1] = 0, u2 = 1; u2 <= 2 * d2 + h2 * (h2 + 5) / 2 + 2 * p2 + 1; u2 += 1) b2[u2] = 0;
      for (u2 = 1; u2 <= 2; u2 += 1) x2[u2] = 0;
      return s2(t5, i3, d2, d2, y2, g2, a3, o3, d2, p2, c3, v2, m2, x2, b2, l2), S2 = ``, l2[1] === 1 && (S2 = `constraints are inconsistent, no solution!`), l2[1] === 2 && (S2 = `matrix D in quadratic function is not positive definite!`), { solution: r2(y2), value: r2(g2), unconstrained_solution: r2(i3), iterations: r2(x2), iact: r2(v2), message: S2 };
    }
    t4.solveQP = c2;
  })(numeric), numeric.svd = function(t4) {
    var n2, r2 = numeric.epsilon, i2 = 1e-64 / r2, a2 = 50, o2 = 0, s2 = 0, c2 = 0, l2 = 0, u2 = 0, d2 = numeric.clone(t4), p2 = d2.length, m2 = d2[0].length;
    if (p2 < m2) throw `Need more rows than columns`;
    var h2 = Array(m2), g2 = Array(m2);
    for (s2 = 0; s2 < m2; s2++) h2[s2] = g2[s2] = 0;
    var v2 = numeric.rep([m2, m2], 0);
    function y2(t5, n3) {
      return t5 = Math.abs(t5), n3 = Math.abs(n3), t5 > n3 ? t5 * Math.sqrt(1 + n3 * n3 / t5 / t5) : n3 == 0 ? t5 : n3 * Math.sqrt(1 + t5 * t5 / n3 / n3);
    }
    var b2 = 0, x2 = 0, S2 = 0, w2 = 0, E = 0, D = 0, O2 = 0;
    for (s2 = 0; s2 < m2; s2++) {
      for (h2[s2] = x2, O2 = 0, u2 = s2 + 1, c2 = s2; c2 < p2; c2++) O2 += d2[c2][s2] * d2[c2][s2];
      if (O2 <= i2) x2 = 0;
      else for (b2 = d2[s2][s2], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2] = b2 - x2, c2 = u2; c2 < m2; c2++) {
        for (O2 = 0, l2 = s2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
        for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
      }
      for (g2[s2] = x2, O2 = 0, c2 = u2; c2 < m2; c2++) O2 += d2[s2][c2] * d2[s2][c2];
      if (O2 <= i2) x2 = 0;
      else {
        for (b2 = d2[s2][s2 + 1], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2 + 1] = b2 - x2, c2 = u2; c2 < m2; c2++) h2[c2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < p2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[c2][l2] * d2[s2][l2];
          for (l2 = u2; l2 < m2; l2++) d2[c2][l2] += O2 * h2[l2];
        }
      }
      E = Math.abs(g2[s2]) + Math.abs(h2[s2]), E > w2 && (w2 = E);
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      if (x2 != 0) {
        for (S2 = x2 * d2[s2][s2 + 1], c2 = u2; c2 < m2; c2++) v2[c2][s2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[s2][l2] * v2[l2][c2];
          for (l2 = u2; l2 < m2; l2++) v2[l2][c2] += O2 * v2[l2][s2];
        }
      }
      for (c2 = u2; c2 < m2; c2++) v2[s2][c2] = 0, v2[c2][s2] = 0;
      v2[s2][s2] = 1, x2 = h2[s2], u2 = s2;
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      for (u2 = s2 + 1, x2 = g2[s2], c2 = u2; c2 < m2; c2++) d2[s2][c2] = 0;
      if (x2 != 0) {
        for (S2 = d2[s2][s2] * x2, c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
          for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
        }
        for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = d2[c2][s2] / x2;
      } else for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = 0;
      d2[s2][s2] += 1;
    }
    for (r2 *= w2, l2 = m2 - 1; l2 != -1; l2 += -1) for (var j2 = 0; j2 < a2; j2++) {
      var M2 = false;
      for (u2 = l2; u2 != -1; u2 += -1) {
        if (Math.abs(h2[u2]) <= r2) {
          M2 = true;
          break;
        }
        if (Math.abs(g2[u2 - 1]) <= r2) break;
      }
      if (!M2) {
        o2 = 0, O2 = 1;
        var N2 = u2 - 1;
        for (s2 = u2; s2 < l2 + 1 && (b2 = O2 * h2[s2], h2[s2] = o2 * h2[s2], !(Math.abs(b2) <= r2)); s2++) for (x2 = g2[s2], S2 = y2(b2, x2), g2[s2] = S2, o2 = x2 / S2, O2 = -b2 / S2, c2 = 0; c2 < p2; c2++) E = d2[c2][N2], D = d2[c2][s2], d2[c2][N2] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      if (D = g2[l2], u2 == l2) {
        if (D < 0) for (g2[l2] = -D, c2 = 0; c2 < m2; c2++) v2[c2][l2] = -v2[c2][l2];
        break;
      }
      if (j2 >= a2 - 1) throw `Error: no convergence.`;
      for (w2 = g2[u2], E = g2[l2 - 1], x2 = h2[l2 - 1], S2 = h2[l2], b2 = ((E - D) * (E + D) + (x2 - S2) * (x2 + S2)) / (2 * S2 * E), x2 = y2(b2, 1), b2 = b2 < 0 ? ((w2 - D) * (w2 + D) + S2 * (E / (b2 - x2) - S2)) / w2 : ((w2 - D) * (w2 + D) + S2 * (E / (b2 + x2) - S2)) / w2, o2 = 1, O2 = 1, s2 = u2 + 1; s2 < l2 + 1; s2++) {
        for (x2 = h2[s2], E = g2[s2], S2 = O2 * x2, x2 = o2 * x2, D = y2(b2, S2), h2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = w2 * o2 + x2 * O2, x2 = -w2 * O2 + x2 * o2, S2 = E * O2, E *= o2, c2 = 0; c2 < m2; c2++) w2 = v2[c2][s2 - 1], D = v2[c2][s2], v2[c2][s2 - 1] = w2 * o2 + D * O2, v2[c2][s2] = -w2 * O2 + D * o2;
        for (D = y2(b2, S2), g2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = o2 * x2 + O2 * E, w2 = -O2 * x2 + o2 * E, c2 = 0; c2 < p2; c2++) E = d2[c2][s2 - 1], D = d2[c2][s2], d2[c2][s2 - 1] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      h2[u2] = 0, h2[l2] = b2, g2[l2] = w2;
    }
    for (s2 = 0; s2 < g2.length; s2++) g2[s2] < r2 && (g2[s2] = 0);
    for (s2 = 0; s2 < m2; s2++) for (c2 = s2 - 1; c2 >= 0; c2--) if (g2[c2] < g2[s2]) {
      for (o2 = g2[c2], g2[c2] = g2[s2], g2[s2] = o2, l2 = 0; l2 < d2.length; l2++) n2 = d2[l2][s2], d2[l2][s2] = d2[l2][c2], d2[l2][c2] = n2;
      for (l2 = 0; l2 < v2.length; l2++) n2 = v2[l2][s2], v2[l2][s2] = v2[l2][c2], v2[l2][c2] = n2;
      s2 = c2;
    }
    return { U: d2, S: g2, V: v2 };
  };
})), import_numeric_1_2_6$1 = __toESM$1(require_numeric_1_2_6$1());
function createInstance$1({ define_e: t4 = true, define_pi: n2 = true, define_i: r2 = true, pow_strict: i2 = true } = {}) {
  let a2 = { ...all$1 };
  delete a2.createTau, delete a2.createPhi, t4 || delete a2.createE, n2 || delete a2.createPi, r2 || delete a2.createI;
  let o2 = create$1$1(a2);
  o2.import(import_numeric_1_2_6$1.default, { wrap: true, silent: true });
  var s2 = o2.pow;
  function c2(t5, n3) {
    return n3 === 0 && typeof t5 == `number` && (t5 === 0 || !Number.isFinite(t5)) ? NaN : s2(t5, n3);
  }
  return i2 ? o2.import({ pow: c2 }, { override: true }) : o2.import({ pow: s2 }, { override: true }), o2.define_e = t4, o2.define_pi = n2, o2.define_i = r2, o2.pow_strict = i2, o2;
}
var mathjs_default$1 = createInstance$1(), function_normalizations$1 = { ln: `log`, arccos: `acos`, arccosh: `acosh`, arcsin: `asin`, arcsinh: `asinh`, arctan: `atan`, arctanh: `atanh`, arcsec: `asec`, arcsech: `asech`, arccsc: `acsc`, arccsch: `acsch`, arccot: `acot`, arccoth: `acoth`, cosec: `csc` }, create_trig_inverses_for$1 = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`], move_exponents_outside_for$1 = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`, `log`, `ln`];
function normalize_function_names$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    if (i2[0] === `sqrt`) return [`^`, normalize_function_names$1(i2[1]), 0.5];
    if (i2[0] === `cbrt`) return [`^`, normalize_function_names$1(i2[1]), [`/`, 1, 3]];
    if (i2[0] === `nthroot`) return i2.length !== 2 || i2[1][0] !== `tuple` || i2[1].length !== 3 ? [`^`, normalize_function_names$1(i2[1]), 0.5] : [`^`, normalize_function_names$1(i2[1][1]), [`/`, 1, normalize_function_names$1(i2[1][2])]];
    var a2 = normalize_function_names_sub$1(i2[0]);
    a2 = [`apply`, a2];
    var o2 = i2.slice(1).map(function(t5) {
      return normalize_function_names$1(t5);
    });
    return o2 = o2.length > 1 ? [`tuple`].concat(o2) : o2[0], a2.push(o2), a2;
  }
  return r2 === `^` && i2[0] === `e` && mathjs_default$1.define_e ? [`apply`, `exp`, normalize_function_names$1(i2[1])] : r2 === `binom` ? [`apply`, `nCr`, [`tuple`, normalize_function_names$1(i2[0]), normalize_function_names$1(i2[1])]] : [r2].concat(i2.map(function(t5) {
    return normalize_function_names$1(t5);
  }));
}
function normalize_function_names_sub$1(t4) {
  if (typeof t4 == `string`) return t4 in function_normalizations$1 ? function_normalizations$1[t4] : t4;
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `^` && r2.length === 2 && r2[1] === -1) {
    let t5 = normalize_function_names_sub$1(r2[0]);
    if (create_trig_inverses_for$1.includes(t5)) return `a` + t5;
  }
  return [n2].concat(r2.map(function(t5) {
    return normalize_function_names_sub$1(t5);
  }));
}
function normalize_applied_functions$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    let t5 = i2[0];
    if (t5[0] === `^`) {
      let n4 = t5[1], r4 = t5[2];
      return r4 !== -1 && move_exponents_outside_for$1.includes(n4) ? [`^`, [`apply`, n4, normalize_applied_functions$1(i2[1])], r4] : [`apply`, t5, normalize_applied_functions$1(i2[1])];
    }
    let n3 = 0;
    for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
    let r3 = [`apply`, t5, normalize_applied_functions$1(i2[1])];
    for (let t6 = 0; t6 < n3; t6++) r3 = [`prime`, r3];
    return r3;
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return normalize_applied_functions$1(t5);
  }));
}
function log_subscript_to_two_arg_log$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply` && i2.length === 2) {
    let t5 = i2[0];
    if (Array.isArray(t5) && t5.length === 3 && t5[0] === `_` && t5[1] === `log`) return [`apply`, `log`, [`tuple`, i2[1], t5[2]]];
  }
  return [r2, ...i2.map(log_subscript_to_two_arg_log$1)];
}
function substitute_abs$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `apply` && i2[0] === `abs` ? [`^`, [`^`, substitute_abs$1(i2[1]), 2], 0.5] : [r2].concat(i2.map(function(t5) {
    return substitute_abs$1(t5);
  }));
}
function constants_to_floats$1(t4) {
  var n2 = get_tree$1(t4);
  if (!(mathjs_default$1.define_e || mathjs_default$1.define_pi)) return n2;
  if (typeof n2 == `string`) {
    if (n2 === `e`) {
      if (mathjs_default$1.define_e) return mathjs_default$1.e;
    } else if (n2 === `pi` && mathjs_default$1.define_pi) return mathjs_default$1.pi;
    return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `^` && i2[0] === `e` ? [`^`, `e`, constants_to_floats$1(i2[1])] : [r2, ...i2.map(constants_to_floats$1)];
}
function normalize_angle_linesegment_arg_order$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `angle` && i2.length === 3 && compare_function$1(i2[0], i2[2]) === 1 || r2 === `linesegment` && i2.length === 2 && compare_function$1(i2[0], i2[1]) === 1 ? (i2.reverse(), [r2, ...i2]) : [r2, ...i2.map(normalize_angle_linesegment_arg_order$1)];
}
function normalize_negative_numbers$1(t4) {
  var n2 = get_tree$1(t4);
  function r2(t5) {
    if (typeof t5 == `number` && t5 >= 0) return [-t5, true];
    if (!Array.isArray(t5)) return [t5, false];
    if (t5[0] === `*` && typeof t5[1] == `number` && t5[1] >= 0) return [[`*`, -t5[1], ...t5.slice(2).map(normalize_negative_numbers$1)], true];
    if (t5[0] === `/` && t5.length === 3) {
      let [n3, i3] = r2(t5[1]);
      if (i3) return [[`/`, n3, normalize_negative_numbers$1(t5[2])], true];
    }
    return [t5, false];
  }
  if (!Array.isArray(n2)) return n2;
  let i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `-` && a2.length === 1) {
    if (typeof a2[0] == `number` && a2[0] >= 0) return -a2[0];
    if (Array.isArray(a2[0]) && a2[0][0] === `*`) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`*`, t5, ...a2[0].slice(2).map(normalize_negative_numbers$1)];
    }
    if (Array.isArray(a2[0]) && a2[0][0] === `/` && a2[0].length === 3) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`/`, t5, normalize_negative_numbers$1(a2[0][2])];
    }
  }
  return [i2, ...a2.map(normalize_negative_numbers$1)];
}
function tuples_to_vectors$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple`) return [`vector`].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors$1(t5);
  }));
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = tuples_to_vectors$1(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return tuples_to_vectors$1(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return tuples_to_vectors$1(t6);
    })), n3];
  } else if (r2 === `matrix`) {
    let t5 = i2[0], n3 = i2[1];
    return t5 = [`tuple`].concat(t5.slice(1).map(tuples_to_vectors$1)), n3 = [`tuple`].concat(n3.slice(1).map((t6) => [`tuple`].concat(t6.slice(1).map(tuples_to_vectors$1)))), [`matrix`, t5, n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors$1(t5);
  }));
}
function to_intervals$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals$1(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, false, false]], t5;
  }
  if (r2 === `array` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals$1(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, true, true]], t5;
  }
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = to_intervals$1(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return to_intervals$1(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return to_intervals$1(t6);
    })), n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return to_intervals$1(t5);
  }));
}
function altvectors_to_vectors$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `altvector` ? [`vector`].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors$1(t5);
  })) : [r2].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors$1(t5);
  }));
}
function padNumberStringToDigits$1(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) {
    if (t4.includes(`.`)) {
      if (t4[0] === `0` ? r2 += t4.match(/^0\.0*/)[0].length : r2++, t4.length < r2) {
        let n3 = r2 - t4.length;
        t4 += `0`.repeat(n3);
      }
    } else if (t4.length < r2) {
      let n3 = r2 - t4.length;
      t4 += `.` + `0`.repeat(n3);
    }
  }
  return t4;
}
function padNumberStringToDecimals$1(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) if (t4.includes(`.`)) {
    let n3 = t4.match(/\.\d*$/)[0].length - 1;
    if (n3 < r2) {
      let i2 = r2 - n3;
      t4 += `0`.repeat(i2);
    }
  } else t4 += `.` + `0`.repeat(r2);
  return t4;
}
function padNumberStringToDigitsAndDecimals$1(t4, n2, r2) {
  let i2 = Math.floor(n2);
  if (!(i2 > 0)) return padNumberStringToDecimals$1(t4, r2);
  let a2 = Math.floor(r2);
  if (!(a2 > 0)) return padNumberStringToDigits$1(t4, n2);
  if (t4.includes(`.`)) {
    t4[0] === `0` ? i2 += t4.match(/^0\.0*/)[0].length : i2++;
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length);
    let r3 = t4.match(/\.\d*$/)[0].length - 1;
    r3 < a2 && (n3 = Math.max(n3, a2 - r3)), n3 > 0 && (t4 += `0`.repeat(n3));
  } else {
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length), n3 = Math.max(n3, a2), t4 += `.` + `0`.repeat(n3);
  }
  return t4;
}
function remove_leading_negative_factor$1(t4) {
  if (typeof t4 == `number` && t4 < 0) return [-t4, true];
  if (!Array.isArray(t4)) return [t4, false];
  if (t4[0] === `-` && t4.length === 2) return [t4[1], true];
  if (t4[0] === `*` && t4.length >= 2) {
    let n2 = t4[1];
    if (typeof n2 == `number` && n2 < 0) return [[`*`, -n2, ...t4.slice(2)], true];
    if (Array.isArray(n2) && n2[0] === `-` && n2.length === 2) return [[`*`, n2[1], ...t4.slice(2)], true];
  }
  return [t4, false];
}
function normalize_display_negative_fractions_sub$1(t4, { inside_unary_minus: n2 = false } = {}) {
  if (!Array.isArray(t4)) return t4;
  let r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `-` && i2.length === 1) return [`-`, normalize_display_negative_fractions_sub$1(i2[0], { inside_unary_minus: true })];
  if (r2 === `+`) return [`+`, ...i2.map((t5) => normalize_display_negative_fractions_sub$1(t5, { inside_unary_minus: false }))];
  if (r2 === `*`) {
    if (i2.length === 0) return t4;
    let n3 = [normalize_display_negative_fractions_sub$1(i2[0], { inside_unary_minus: false })];
    for (let t5 = 1; t5 < i2.length; t5 += 1) n3.push(normalize_display_negative_fractions_sub$1(i2[t5], { inside_unary_minus: false }));
    return [`*`, ...n3];
  }
  if (r2 === `/` && i2.length === 2) {
    let t5 = i2[0], r3 = i2[1];
    if (!n2) {
      let [n3, i3] = remove_leading_negative_factor$1(t5);
      if (i3) return [`-`, [`/`, normalize_display_negative_fractions_sub$1(n3, { inside_unary_minus: false }), normalize_display_negative_fractions_sub$1(r3, { inside_unary_minus: false })]];
    }
    return [`/`, normalize_display_negative_fractions_sub$1(t5, { inside_unary_minus: false }), normalize_display_negative_fractions_sub$1(r3, { inside_unary_minus: false })];
  }
  return [r2, ...i2.map((t5) => normalize_display_negative_fractions_sub$1(t5, { inside_unary_minus: false }))];
}
function normalize_display_negative_fractions$1(t4) {
  return normalize_display_negative_fractions_sub$1(t4, { inside_unary_minus: false });
}
function expandScientificNotation$1(t4) {
  let n2 = t4.indexOf(`e`);
  if (n2 === -1) return t4;
  let r2 = t4.substring(0, n2), i2 = Number(t4.substring(n2 + 1)), a2 = ``;
  (r2[0] === `-` || r2[0] === `+`) && (a2 = r2[0] === `-` ? `-` : ``, r2 = r2.substring(1));
  let o2 = r2.indexOf(`.`);
  o2 === -1 && (o2 = r2.length);
  let s2 = r2.replace(`.`, ``), c2 = o2 + i2;
  return c2 <= 0 ? a2 + `0.` + `0`.repeat(-c2) + s2 : c2 >= s2.length ? a2 + s2 + `0`.repeat(c2 - s2.length) : a2 + s2.substring(0, c2) + `.` + s2.substring(c2);
}
var unicode_operators$1 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `± ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `⟨ ` + t4.join(`, `) + ` ⟩`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` ≤ `);
}, ge: function(t4) {
  return t4.join(` ≥ `);
}, ne: function(t4) {
  return t4.join(` ≠ `);
}, forall: function(t4) {
  return `∀ ` + t4[0];
}, exists: function(t4) {
  return `∃ ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` ∈ ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` ∉ ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` ∋ ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` ∌ ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` ⊂ ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` ⊆ ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` ⊄ ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` ⊈ ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` ⊃ ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` ⊇ ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` ⊅ ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` ⊉ ` + t4[1];
}, union: function(t4) {
  return t4.join(` ∪ `);
}, intersect: function(t4) {
  return t4.join(` ∩ `);
}, rightarrow: function(t4) {
  return t4.join(` → `);
}, leftarrow: function(t4) {
  return t4.join(` ← `);
}, leftrightarrow: function(t4) {
  return t4.join(` ↔ `);
}, implies: function(t4) {
  return t4.join(` ⟹ `);
}, impliedby: function(t4) {
  return t4.join(` ⟸ `);
}, iff: function(t4) {
  return t4.join(` ⟺ `);
}, perp: function(t4) {
  return t4.join(` ⟂ `);
}, parallel: function(t4) {
  return t4.join(` ∥ `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `∠` + t4.join(``) : `∠( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, nonunicode_operators$1 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `plusminus ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` <= `);
}, ge: function(t4) {
  return t4.join(` >= `);
}, ne: function(t4) {
  return t4.join(` ne `);
}, forall: function(t4) {
  return `forall ` + t4[0];
}, exists: function(t4) {
  return `exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` elementof ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` notelementof ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` containselement ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` notcontainselement ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` notsubset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` notsubseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` superset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` superseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` notsuperset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` notsuperseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` union `);
}, intersect: function(t4) {
  return t4.join(` intersect `);
}, rightarrow: function(t4) {
  return t4.join(` rightarrow `);
}, leftarrow: function(t4) {
  return t4.join(` leftarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` leftrightarrow `);
}, implies: function(t4) {
  return t4.join(` implies `);
}, impliedby: function(t4) {
  return t4.join(` impliedby `);
}, iff: function(t4) {
  return t4.join(` iff `);
}, perp: function(t4) {
  return t4.join(` perp `);
}, parallel: function(t4) {
  return t4.join(` parallel `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `angle ` + t4.join(``) : `angle( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, output_unicodeDefault$1 = true, astToText$2$1 = class astToText$23 {
  constructor({ output_unicode: t4 = output_unicodeDefault$1, padToDigits: n2 = null, padToDecimals: r2 = null, avoidScientificNotation: i2 = false, showBlanks: a2 = true, explicitMultiplicationSymbols: o2 = false } = {}) {
    this.output_unicode = t4, this.operators = unicode_operators$1, t4 || (this.operators = nonunicode_operators$1), this.padToDigits = n2, this.padToDecimals = r2, this.avoidScientificNotation = i2, this.showBlanks = a2, this.explicitMultiplicationSymbols = o2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions$1(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `...`;
    if (!(n2 in this.operators) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? this.operators[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return this.operators[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? this.output_unicode ? a2 += ` ≤ ` : a2 += ` <= ` : this.output_unicode ? a2 += ` ≥ ` : a2 += ` >= `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : this.operators[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `-` || n2 === `pm`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    if (n2 === `*`) {
      let t5 = r2.map((function(t6, n3) {
        let i2;
        return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedOrExplicitPlus(t6), !this.explicitMultiplicationSymbols && i2.match(/^[0-9]/) ? `* ` + i2 : t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2) : (i2 = this.factor(t6), t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2);
      }).bind(this));
      return this.explicitMultiplicationSymbols ? t5.join(`*`) : this.operators[n2](t5);
    }
    if (n2 === `/`) {
      let t5 = this.factor(r2[0]), i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `(` + t5 + `)`), this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2 + `)`), this.operators[n2]([t5, i2]);
    }
    return n2 === `unit` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  symbolConvert(t4) {
    let n2 = { alpha: `α`, beta: `β`, Gamma: `Γ`, gamma: `γ`, Delta: `Δ`, delta: `δ`, epsilon: `ε`, zeta: `ζ`, eta: `η`, Theta: `ϴ`, theta: `θ`, iota: `ι`, kappa: `κ`, Lambda: `Λ`, lambda: `λ`, mu: `μ`, nu: `ν`, Xi: `Ξ`, xi: `ξ`, Pi: `Π`, pi: `π`, rho: `ρ`, Sigma: `Σ`, sigma: `σ`, tau: `τ`, Upsilon: `Υ`, upsilon: `υ`, Phi: `Φ`, phi: `ϕ`, Psi: `Ψ`, psi: `ψ`, Omega: `Ω`, omega: `ω`, perp: `⟂`, int: `∫`, emptyset: `∅` };
    return this.output_unicode && t4 in n2 ? n2[t4] : !this.showBlanks && t4 === `＿` ? `` : t4;
  }
  simple_factor_or_function_or_parens(t4) {
    let n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` || n2.match(/^\(.*\)$/) || n2.match(/^⟨.*⟩$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.symbolConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return this.output_unicode ? `∞` : `infinity`;
      if (t4 === -1 / 0) return this.output_unicode ? `-∞` : `-infinity`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation$1(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals$1(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals$1(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals$1(i2, this.padToDigits, t5);
          }
        }
        return a2[0] === `+` ? i2 + ` * 10^` + a2.substring(1) : i2 + ` * 10^(` + a2 + `)`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) {
        let t6;
        return t6 = r2[0] < 0 ? `(` + r2[0].toString() + `)` : r2[0].toString(), r2[1] < 0 ? t6 + `^(` + r2[1].toString() + `)` : t6 + `^` + r2[1].toString();
      }
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `(` + t5.toString() + `)`);
      let i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2.toString() + `)`), t5 + `^` + i2;
    } else if (n2 === `_`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.factor(t5);
      return this.simple_factor_or_function_or_parens(t5) ? r3 : `(` + r3 + `)`;
    }).bind(this)));
    else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `(` + i2 + `)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `-`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `[ ` + i2 : `( ` + i2, n3[2] ? i2 += ` ]` : i2 += ` )`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `[ `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        i2 += `[ `;
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += `,`), i2 += ` `;
        i2 += `]`, r3 < t5[1] - 1 && (i2 += `,`), i2 += ` `;
      }
      return i2 += `]`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `∂`);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 && (c2 = c2 + `^` + o2), c2 = c2 + this.symbolConvert(s2) + `/`;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.symbolConvert(o3), i3 > 1 && (c2 = c2 + `^` + i3);
      }
      return c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `|` + this.statement(r2[1]) + `|`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `(` + t6 + `)!`;
      }
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3 += ` ` + t7.map((t8) => `d` + this.factor(t8[1])).join(` `));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3 = this.factor(r2[0]), i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `(` + i2 + `)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return this.operators[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `(` + this.statement(t4) + `)`;
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) ? `(` + n2 + `)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    let n2 = this.term(t4);
    return n2.match(/^± /) || n2.match(/^plusminus /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, astToText$1$1 = new astToText$2$1();
function subscripts_to_strings$1(t4, n2 = false) {
  var r2 = get_tree$1(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  return i2 === `_` && (n2 || a2.every((t5) => [`number`, `string`].includes(typeof t5))) ? astToText$1$1.convert(r2) : [i2].concat(a2.map((t5) => subscripts_to_strings$1(t5, n2)));
}
function strings_to_subscripts$1(t4) {
  var n2 = get_tree$1(t4);
  if (typeof n2 == `string`) {
    let t5 = n2.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (t5) {
      let n3 = Number(t5[1]);
      isNaN(n3) && (n3 = t5[1]);
      let r3 = Number(t5[2]);
      return isNaN(r3) && (r3 = t5[2]), [`_`, n3, r3];
    } else return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return [r2].concat(i2.map(strings_to_subscripts$1));
}
var normalization_exports$1 = __exportAll$1({ altvectors_to_vectors: () => altvectors_to_vectors$1, constants_to_floats: () => constants_to_floats$1, default_order: () => default_order$1, log_subscript_to_two_arg_log: () => log_subscript_to_two_arg_log$1, normalize_angle_linesegment_arg_order: () => normalize_angle_linesegment_arg_order$1, normalize_applied_functions: () => normalize_applied_functions$1, normalize_function_names: () => normalize_function_names$1, normalize_negative_numbers: () => normalize_negative_numbers$1, strings_to_subscripts: () => strings_to_subscripts$1, subscripts_to_strings: () => subscripts_to_strings$1, substitute_abs: () => substitute_abs$1, to_intervals: () => to_intervals$1, tuples_to_vectors: () => tuples_to_vectors$1 });
function get_all_units$1() {
  return { "%": { scale: (t4) => [`/`, t4, 100], only_scales: true }, $: { prefix: true, scale: (t4) => t4 }, deg: { scale: (t4) => [`/`, [`*`, t4, `pi`], 180], only_scales: true } };
}
var all_units$1$1 = get_all_units$1();
function get_unit_of_tree$1(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1$1) if (all_units$1$1[n2].prefix) {
      if (t4[1] === n2) return n2;
    } else if (t4[2] === n2) return n2;
  }
  return null;
}
function get_unit_value_of_tree$1(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1$1) if (all_units$1$1[n2].prefix) {
      if (t4[1] === n2) return [n2, t4[2]];
    } else if (t4[2] === n2) return [n2, t4[1]];
  }
  return null;
}
function remove_duplicate_negatives$1(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `-` && Array.isArray(r2[0]) && r2[0][0] === `-` ? remove_duplicate_negatives$1(r2[0][1]) : n2 === `-` && typeof r2[0] == `number` && r2[0] < 0 ? -r2[0] : (r2 = r2.map(remove_duplicate_negatives$1), [n2].concat(r2));
}
function normalize_negatives_in_factors$1(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(normalize_negatives_in_factors$1), n2 !== `*` && n2 !== `/`) return [n2].concat(r2);
  for (var i2 = 1, a2 = [], o2 = 0; o2 < r2.length; o2++) Array.isArray(r2[o2]) && r2[o2][0] === `-` ? (i2 *= -1, a2.push(r2[o2][1])) : typeof r2[o2] == `number` && r2[o2] < 0 ? (i2 *= -1, a2.push(-r2[o2])) : a2.push(r2[o2]);
  var s2 = [n2].concat(a2);
  return i2 === -1 && (s2 = [`-`, s2]), s2;
}
function normalize_negatives$1(t4) {
  var n2 = get_tree$1(t4);
  return n2 = remove_duplicate_negatives$1(n2), n2 = normalize_negatives_in_factors$1(n2), n2 = remove_duplicate_negatives$1(n2), n2 = normalize_negative_numbers$1(n2), n2;
}
function sort_key$1(t4, n2 = {}) {
  if (typeof t4 == `number`) return n2.ignore_negatives ? [0, `number`, Math.abs(t4)] : [0, `number`, t4];
  if (typeof t4 == `string`) return t4 === `-` || t4 === `+` ? [8, `plus_minus_string`, t4] : [1, `symbol`, t4];
  if (typeof t4 == `boolean`) return [1, `boolean`, t4];
  if (!Array.isArray(t4)) return [-1, `unknown`, t4];
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `^` && i2.length === 2) return [...sort_key$1(i2[0], n2), `power`, ...sort_key$1(i2[1], n2)];
  if (r2 === `apply`) {
    var a2 = [2, `function`, i2[0]];
    (i2[0] === `sqrt` || i2[0] === `cbrt` || i2[0] === `nthroot`) && (a2 = [5, `root`, i2[0] === `sqrt` ? 2 : i2[0] === `cbrt` ? 3 : i2[1][2] ?? 2]);
    var o2 = i2[1], s2 = 1, c2 = [];
    return Array.isArray(o2) ? (o2 = o2.slice(1), s2 = o2.length, c2 = o2.map((t5) => sort_key$1(t5, n2))) : c2 = [sort_key$1(o2, n2)], a2.push([s2, c2]), a2;
  } else if (r2 === `unit`) {
    let [r3, i3] = get_unit_value_of_tree$1(t4);
    if (r3) {
      let t5 = sort_key$1(i3, n2);
      return t5[1] += `_` + r3, t5;
    }
  }
  var l2 = i2.length, u2 = i2.map(sort_key$1, n2);
  return r2 === `*` ? [4, `product`, l2, u2] : r2 === `/` ? [4, `quotient`, l2, u2] : r2 === `+` ? [5, `sum`, l2, u2] : r2 === `-` ? n2.ignore_negatives ? u2[0] : [6, `minus`, l2, u2] : r2 === `pm` ? n2.ignore_negatives ? u2[0] : [6, `pm`, l2, u2] : [`tuple`, `vector`, `altvector`].includes(r2) ? [7, l2, u2] : r2 === `interval` ? i2[1][1] === false ? i2[1][2] === false ? [7, ...u2[0].slice(1)] : [8, l2, u2] : i2[1][2] === false ? [8, l2, u2] : [9, ...u2[0].slice(1)] : r2 === `array` ? [9, l2, u2] : [10, r2, l2, u2];
}
function arrayCompare$1(t4, n2) {
  if (Array.isArray(t4)) if (Array.isArray(n2)) {
    let r2 = Math.min(t4.length, n2.length);
    for (let i2 = 0; i2 < r2; i2++) {
      let r3 = arrayCompare$1(t4[i2], n2[i2]);
      if (r3 !== 0) return r3;
    }
    return t4.length < n2.length ? -1 : +(t4.length > n2.length);
  } else return 1;
  else if (Array.isArray(n2)) return -1;
  else return t4 < n2 ? -1 : +(t4 > n2);
}
function compare_function$1(t4, n2, r2 = {}) {
  return arrayCompare$1(sort_key$1(t4, r2), sort_key$1(n2, r2));
}
function coeff_factors_from_term$1(t4, n2) {
  if (typeof t4 == `string`) {
    let r2 = n2.indexOf(t4);
    r2 === -1 && (n2.push(t4), r2 = n2.length - 1);
    let i2 = [];
    return i2[r2] = 1, { factor_contains: i2, coeff: 1 };
  } else if (Array.isArray(t4)) {
    let r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `*`) {
      let t5 = [], r3 = [];
      for (let a2 of i2) {
        if (typeof a2 == `string`) {
          let t6 = n2.indexOf(a2);
          t6 === -1 && (n2.push(a2), t6 = n2.length - 1), r3[t6] === void 0 && (r3[t6] = 0), r3[t6]++;
          continue;
        } else if (Array.isArray(a2) && (a2[0] === `^` || a2[0] === `-`)) {
          let i3 = coeff_factors_from_term$1(a2, n2);
          for (let t6 in i3.factor_contains) r3[t6] === void 0 && (r3[t6] = 0), r3[t6] += i3.factor_contains[t6];
          i3.coeff !== 1 && t5.push(i3.coeff);
          continue;
        }
        t5.push(a2);
      }
      return t5 = t5.length === 0 ? 1 : t5.length === 1 ? t5[0] : [`*`, ...t5], { factor_contains: r3, coeff: t5 };
    } else if (r2 === `^`) {
      let t5 = i2[0], r3 = i2[1], a2 = [];
      if (typeof t5 == `string` && Number.isFinite(r3)) {
        let i3 = n2.indexOf(t5);
        return i3 === -1 && (n2.push(t5), i3 = n2.length - 1), a2[i3] = r3, { factor_contains: a2, coeff: 1 };
      }
    } else if (r2 === `-`) {
      let t5 = coeff_factors_from_term$1(i2[0], n2), r3 = -1;
      return typeof t5.coeff == `number` ? r3 *= t5.coeff : r3 = [`-`, t5.coeff], { factor_contains: t5.factor_contains, coeff: r3 };
    } else if (r2 === `/`) {
      let t5 = coeff_factors_from_term$1(i2[0], n2), r3 = [`/`, t5.coeff, i2[1]];
      return { factor_contains: t5.factor_contains, coeff: r3 };
    }
  }
  return { factor_contains: [], coeff: t4 };
}
function default_order$1(t4, n2) {
  n2 === void 0 && (n2 = {});
  var r2 = get_tree$1(t4);
  r2 = flatten$5$1(r2), r2 = normalize_negatives$1(r2);
  function i2(t5) {
    if (!Array.isArray(t5)) return t5;
    var r3 = t5[0], a2 = t5.slice(1);
    if (a2 = a2.map(i2), r3 === `+`) {
      let t6 = [], r4 = [], i3 = [];
      for (let n3 of a2) {
        let a3 = coeff_factors_from_term$1(n3, t6);
        r4.push(a3.factor_contains), i3.push(a3.coeff);
      }
      let o3 = [];
      for (let [n3, i4] of t6.entries()) {
        let t7 = { varname: i4, exponents_in_term: [] };
        for (let i5 = 0; i5 < r4.length; i5++) t7.exponents_in_term.push(r4[i5][n3] || 0);
        o3.push(t7);
      }
      o3.sort((t7, n3) => t7.varname < n3.varname ? -1 : 1);
      let s3 = [];
      for (let t7 = 0; t7 < i3.length; t7++) {
        let r5 = o3.reduce((n3, r6) => [...n3, -r6.exponents_in_term[t7]], []);
        r5.push(sort_key$1(i3[t7], n2)), s3.push(r5);
      }
      let c2 = [];
      for (let [t7, n3] of a2.entries()) c2.push({ term: n3, sort_key: s3[t7] });
      c2.sort((t7, n3) => arrayCompare$1(t7.sort_key, n3.sort_key)), a2 = c2.map((t7) => t7.term);
    } else if (r3 === `*`) {
      let t6 = [], r4 = [];
      for (let n3 of a2) [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n3[0]) ? r4.push(n3) : t6.push(n3);
      t6.sort((t7, r5) => compare_function$1(t7, r5, n2)), a2 = [...t6, ...r4];
    } else if (r3 === `=` || r3 === `and` || r3 === `or` || r3 === `ne` || r3 === `union` || r3 === `intersect`) a2.sort((t6, r4) => compare_function$1(t6, r4, n2));
    else if (r3 === `>` || r3 === `ge`) a2 = a2.reverse(), r3 = r3 === `>` ? `<` : `le`;
    else if (r3 === `gts`) {
      var o2 = a2[0], s2 = a2[1];
      if (o2[0] !== `tuple` || s2[0] !== `tuple`) throw Error(`Badly formed ast`);
      o2 = [`tuple`].concat(o2.slice(1).reverse()), s2 = [`tuple`].concat(s2.slice(1).reverse()), r3 = `lts`, a2 = [o2, s2];
    } else if (r3 === `ni` || r3 === `notni` || r3 === `superset` || r3 === `notsuperset` || r3 === `superseteq` || r3 === `notsuperseteq`) a2 = a2.reverse(), r3 === `ni` ? r3 = `in` : r3 === `notni` ? r3 = `notin` : r3 === `superset` ? r3 = `subset` : r3 === `notsuperset` ? r3 = `notsubset` : r3 === `superseteq` ? r3 = `subseteq` : r3 === `notsuperseteq` && (r3 = `notsubseteq`);
    else if (r3 === `-` && a2[0][0] === `*`) return a2[0][1] = [`-`, a2[0][1]], a2[0];
    return [r3].concat(a2);
  }
  return normalize_negatives$1(i2(r2));
}
var variables_exports$1 = __exportAll$1({ functions: () => functions$2$1, operators: () => operators$3$1, variables: () => variables$1 });
function leaves$1(t4, n2) {
  if (!Array.isArray(t4)) return [t4];
  var r2 = t4[0], i2 = t4.slice(1);
  return n2 && r2 === `_` && typeof i2[0] == `string` && (typeof i2[1] == `string` || typeof i2[1] == `number`) ? [i2[0] + `_` + i2[1]] : (r2 === `apply` && (i2 = t4.slice(2)), i2.length === 0 ? [] : i2.map(function(t5, r3) {
    return leaves$1(t5, n2);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function variables$1(t4, n2 = false) {
  var r2 = leaves$1(get_tree$1(t4), n2);
  return r2 = r2.filter(function(t5, n3) {
    return typeof t5 == `string` && (mathjs_default$1.define_e || t5 !== `e`) && (mathjs_default$1.define_pi || t5 !== `pi`) && (mathjs_default$1.define_i || t5 !== `i`);
  }), r2 = r2.filter(function(t5, n3, i2) {
    return n3 === r2.indexOf(t5);
  }), r2;
}
function operators_list$1(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `apply` && (r2 = t4.slice(2)), r2.length === 0 ? [n2] : [n2].concat(r2.map(function(t5, n3) {
    return operators_list$1(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function operators$3$1(t4) {
  var n2 = operators_list$1(get_tree$1(t4));
  return n2 = n2.filter(function(t5, n3) {
    return t5 !== `apply`;
  }), n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
function functions_list$1(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1), i2 = [];
  return n2 === `apply` && (i2 = [r2[0]], r2 = t4.slice(2)), i2.concat(r2.map(function(t5, n3) {
    return functions_list$1(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }, []));
}
function functions$2$1(t4) {
  var n2 = functions_list$1(get_tree$1(t4));
  return n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
var VERSION$1, root$1, ArrayProto$1, ObjProto$1, SymbolProto$1, push$3, slice$1, toString$1$1, hasOwnProperty$5, supportsArrayBuffer$1, supportsDataView$1, nativeIsArray$1, nativeKeys$1, nativeCreate$1, nativeIsView$1, _isNaN$1, _isFinite$1, hasEnumBug$1, nonEnumerableProps$1, MAX_ARRAY_INDEX$1, init__setup$1 = __esmMin$1((() => {
  VERSION$1 = `1.13.6`, root$1 = typeof self == `object` && self.self === self && self || typeof global == `object` && global.global === global && global || Function(`return this`)() || {}, ArrayProto$1 = Array.prototype, ObjProto$1 = Object.prototype, SymbolProto$1 = typeof Symbol < `u` ? Symbol.prototype : null, push$3 = ArrayProto$1.push, slice$1 = ArrayProto$1.slice, toString$1$1 = ObjProto$1.toString, hasOwnProperty$5 = ObjProto$1.hasOwnProperty, supportsArrayBuffer$1 = typeof ArrayBuffer < `u`, supportsDataView$1 = typeof DataView < `u`, nativeIsArray$1 = Array.isArray, nativeKeys$1 = Object.keys, nativeCreate$1 = Object.create, nativeIsView$1 = supportsArrayBuffer$1 && ArrayBuffer.isView, _isNaN$1 = isNaN, _isFinite$1 = isFinite, hasEnumBug$1 = !{ toString: null }.propertyIsEnumerable(`toString`), nonEnumerableProps$1 = [`valueOf`, `isPrototypeOf`, `toString`, `propertyIsEnumerable`, `hasOwnProperty`, `toLocaleString`], MAX_ARRAY_INDEX$1 = 2 ** 53 - 1;
}));
function restArguments$1(t4, n2) {
  return n2 = n2 == null ? t4.length - 1 : +n2, function() {
    for (var r2 = Math.max(arguments.length - n2, 0), i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = arguments[a2 + n2];
    switch (n2) {
      case 0:
        return t4.call(this, i2);
      case 1:
        return t4.call(this, arguments[0], i2);
      case 2:
        return t4.call(this, arguments[0], arguments[1], i2);
    }
    var o2 = Array(n2 + 1);
    for (a2 = 0; a2 < n2; a2++) o2[a2] = arguments[a2];
    return o2[n2] = i2, t4.apply(this, o2);
  };
}
var init_restArguments$1 = __esmMin$1((() => {
}));
function isObject$2(t4) {
  var n2 = typeof t4;
  return n2 === `function` || n2 === `object` && !!t4;
}
var init_isObject$1 = __esmMin$1((() => {
}));
function isNull$2(t4) {
  return t4 === null;
}
var init_isNull$1 = __esmMin$1((() => {
}));
function isUndefined$2(t4) {
  return t4 === void 0;
}
var init_isUndefined$1 = __esmMin$1((() => {
}));
function isBoolean$2(t4) {
  return t4 === true || t4 === false || toString$1$1.call(t4) === `[object Boolean]`;
}
var init_isBoolean$1 = __esmMin$1((() => {
  init__setup$1();
}));
function isElement$5(t4) {
  return !!(t4 && t4.nodeType === 1);
}
var init_isElement$1 = __esmMin$1((() => {
}));
function tagTester$1(t4) {
  var n2 = `[object ` + t4 + `]`;
  return function(t5) {
    return toString$1$1.call(t5) === n2;
  };
}
var init__tagTester$1 = __esmMin$1((() => {
  init__setup$1();
})), isString_default$1, init_isString$1 = __esmMin$1((() => {
  init__tagTester$1(), isString_default$1 = tagTester$1(`String`);
})), isNumber_default$1, init_isNumber$1 = __esmMin$1((() => {
  init__tagTester$1(), isNumber_default$1 = tagTester$1(`Number`);
})), isDate_default$1, init_isDate$1 = __esmMin$1((() => {
  init__tagTester$1(), isDate_default$1 = tagTester$1(`Date`);
})), isRegExp_default$1, init_isRegExp$1 = __esmMin$1((() => {
  init__tagTester$1(), isRegExp_default$1 = tagTester$1(`RegExp`);
})), isError_default$1, init_isError$1 = __esmMin$1((() => {
  init__tagTester$1(), isError_default$1 = tagTester$1(`Error`);
})), isSymbol_default$1, init_isSymbol$1 = __esmMin$1((() => {
  init__tagTester$1(), isSymbol_default$1 = tagTester$1(`Symbol`);
})), isArrayBuffer_default$1, init_isArrayBuffer$1 = __esmMin$1((() => {
  init__tagTester$1(), isArrayBuffer_default$1 = tagTester$1(`ArrayBuffer`);
})), isFunction$2, nodelist$1, isFunction_default$1, init_isFunction$1 = __esmMin$1((() => {
  init__tagTester$1(), init__setup$1(), isFunction$2 = tagTester$1(`Function`), nodelist$1 = root$1.document && root$1.document.childNodes, typeof /./ != `function` && typeof Int8Array != `object` && typeof nodelist$1 != `function` && (isFunction$2 = function(t4) {
    return typeof t4 == `function` || false;
  }), isFunction_default$1 = isFunction$2;
})), _hasObjectTag_default$1, init__hasObjectTag$1 = __esmMin$1((() => {
  init__tagTester$1(), _hasObjectTag_default$1 = tagTester$1(`Object`);
})), hasStringTagBug$1, isIE11$1, init__stringTagBug$1 = __esmMin$1((() => {
  init__setup$1(), init__hasObjectTag$1(), hasStringTagBug$1 = supportsDataView$1 && _hasObjectTag_default$1(new DataView(new ArrayBuffer(8))), isIE11$1 = typeof Map < `u` && _hasObjectTag_default$1(/* @__PURE__ */ new Map());
}));
function ie10IsDataView$1(t4) {
  return t4 != null && isFunction_default$1(t4.getInt8) && isArrayBuffer_default$1(t4.buffer);
}
var isDataView$1, isDataView_default$1, init_isDataView$1 = __esmMin$1((() => {
  init__tagTester$1(), init_isFunction$1(), init_isArrayBuffer$1(), init__stringTagBug$1(), isDataView$1 = tagTester$1(`DataView`), isDataView_default$1 = hasStringTagBug$1 ? ie10IsDataView$1 : isDataView$1;
})), isArray_default$1, init_isArray$1 = __esmMin$1((() => {
  init__setup$1(), init__tagTester$1(), isArray_default$1 = nativeIsArray$1 || tagTester$1(`Array`);
}));
function has$1$1(t4, n2) {
  return t4 != null && hasOwnProperty$5.call(t4, n2);
}
var init__has$1 = __esmMin$1((() => {
  init__setup$1();
})), isArguments$1, isArguments_default$1, init_isArguments$1 = __esmMin$1((() => {
  init__tagTester$1(), init__has$1(), isArguments$1 = tagTester$1(`Arguments`), (function() {
    isArguments$1(arguments) || (isArguments$1 = function(t4) {
      return has$1$1(t4, `callee`);
    });
  })(), isArguments_default$1 = isArguments$1;
}));
function isFinite$1$1(t4) {
  return !isSymbol_default$1(t4) && _isFinite$1(t4) && !isNaN(parseFloat(t4));
}
var init_isFinite$1 = __esmMin$1((() => {
  init__setup$1(), init_isSymbol$1();
}));
function isNaN$1$1(t4) {
  return isNumber_default$1(t4) && _isNaN$1(t4);
}
var init_isNaN$1 = __esmMin$1((() => {
  init__setup$1(), init_isNumber$1();
}));
function constant$1(t4) {
  return function() {
    return t4;
  };
}
var init_constant$1 = __esmMin$1((() => {
}));
function createSizePropertyCheck$1(t4) {
  return function(n2) {
    var r2 = t4(n2);
    return typeof r2 == `number` && r2 >= 0 && r2 <= MAX_ARRAY_INDEX$1;
  };
}
var init__createSizePropertyCheck$1 = __esmMin$1((() => {
  init__setup$1();
}));
function shallowProperty$1(t4) {
  return function(n2) {
    return n2?.[t4];
  };
}
var init__shallowProperty$1 = __esmMin$1((() => {
})), _getByteLength_default$1, init__getByteLength$1 = __esmMin$1((() => {
  init__shallowProperty$1(), _getByteLength_default$1 = shallowProperty$1(`byteLength`);
})), _isBufferLike_default$1, init__isBufferLike$1 = __esmMin$1((() => {
  init__createSizePropertyCheck$1(), init__getByteLength$1(), _isBufferLike_default$1 = createSizePropertyCheck$1(_getByteLength_default$1);
}));
function isTypedArray$1(t4) {
  return nativeIsView$1 ? nativeIsView$1(t4) && !isDataView_default$1(t4) : _isBufferLike_default$1(t4) && typedArrayPattern$1.test(toString$1$1.call(t4));
}
var typedArrayPattern$1, isTypedArray_default$1, init_isTypedArray$1 = __esmMin$1((() => {
  init__setup$1(), init_isDataView$1(), init_constant$1(), init__isBufferLike$1(), typedArrayPattern$1 = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/, isTypedArray_default$1 = supportsArrayBuffer$1 ? isTypedArray$1 : constant$1(false);
})), _getLength_default$1, init__getLength$1 = __esmMin$1((() => {
  init__shallowProperty$1(), _getLength_default$1 = shallowProperty$1(`length`);
}));
function emulatedSet$1(t4) {
  for (var n2 = {}, r2 = t4.length, i2 = 0; i2 < r2; ++i2) n2[t4[i2]] = true;
  return { contains: function(t5) {
    return n2[t5] === true;
  }, push: function(r3) {
    return n2[r3] = true, t4.push(r3);
  } };
}
function collectNonEnumProps$1(t4, n2) {
  n2 = emulatedSet$1(n2);
  var r2 = nonEnumerableProps$1.length, i2 = t4.constructor, a2 = isFunction_default$1(i2) && i2.prototype || ObjProto$1, o2 = `constructor`;
  for (has$1$1(t4, o2) && !n2.contains(o2) && n2.push(o2); r2--; ) o2 = nonEnumerableProps$1[r2], o2 in t4 && t4[o2] !== a2[o2] && !n2.contains(o2) && n2.push(o2);
}
var init__collectNonEnumProps$1 = __esmMin$1((() => {
  init__setup$1(), init_isFunction$1(), init__has$1();
}));
function keys$2(t4) {
  if (!isObject$2(t4)) return [];
  if (nativeKeys$1) return nativeKeys$1(t4);
  var n2 = [];
  for (var r2 in t4) has$1$1(t4, r2) && n2.push(r2);
  return hasEnumBug$1 && collectNonEnumProps$1(t4, n2), n2;
}
var init_keys$1 = __esmMin$1((() => {
  init_isObject$1(), init__setup$1(), init__has$1(), init__collectNonEnumProps$1();
}));
function isEmpty$1(t4) {
  if (t4 == null) return true;
  var n2 = _getLength_default$1(t4);
  return typeof n2 == `number` && (isArray_default$1(t4) || isString_default$1(t4) || isArguments_default$1(t4)) ? n2 === 0 : _getLength_default$1(keys$2(t4)) === 0;
}
var init_isEmpty$1 = __esmMin$1((() => {
  init__getLength$1(), init_isArray$1(), init_isString$1(), init_isArguments$1(), init_keys$1();
}));
function isMatch$1(t4, n2) {
  var r2 = keys$2(n2), i2 = r2.length;
  if (t4 == null) return !i2;
  for (var a2 = Object(t4), o2 = 0; o2 < i2; o2++) {
    var s2 = r2[o2];
    if (n2[s2] !== a2[s2] || !(s2 in a2)) return false;
  }
  return true;
}
var init_isMatch$1 = __esmMin$1((() => {
  init_keys$1();
}));
function _$1$1(t4) {
  if (t4 instanceof _$1$1) return t4;
  if (!(this instanceof _$1$1)) return new _$1$1(t4);
  this._wrapped = t4;
}
var init_underscore$1 = __esmMin$1((() => {
  init__setup$1(), _$1$1.VERSION = VERSION$1, _$1$1.prototype.value = function() {
    return this._wrapped;
  }, _$1$1.prototype.valueOf = _$1$1.prototype.toJSON = _$1$1.prototype.value, _$1$1.prototype.toString = function() {
    return String(this._wrapped);
  };
}));
function toBufferView$1(t4) {
  return new Uint8Array(t4.buffer || t4, t4.byteOffset || 0, _getByteLength_default$1(t4));
}
var init__toBufferView$1 = __esmMin$1((() => {
  init__getByteLength$1();
}));
function eq$1(t4, n2, r2, i2) {
  if (t4 === n2) return t4 !== 0 || 1 / t4 == 1 / n2;
  if (t4 == null || n2 == null) return false;
  if (t4 !== t4) return n2 !== n2;
  var a2 = typeof t4;
  return a2 !== `function` && a2 !== `object` && typeof n2 != `object` ? false : deepEq$1(t4, n2, r2, i2);
}
function deepEq$1(t4, n2, r2, i2) {
  t4 instanceof _$1$1 && (t4 = t4._wrapped), n2 instanceof _$1$1 && (n2 = n2._wrapped);
  var a2 = toString$1$1.call(t4);
  if (a2 !== toString$1$1.call(n2)) return false;
  if (hasStringTagBug$1 && a2 == `[object Object]` && isDataView_default$1(t4)) {
    if (!isDataView_default$1(n2)) return false;
    a2 = tagDataView$1;
  }
  switch (a2) {
    case `[object RegExp]`:
    case `[object String]`:
      return `` + t4 == `` + n2;
    case `[object Number]`:
      return +t4 == +t4 ? +t4 == 0 ? 1 / t4 == 1 / n2 : +t4 == +n2 : +n2 != +n2;
    case `[object Date]`:
    case `[object Boolean]`:
      return +t4 == +n2;
    case `[object Symbol]`:
      return SymbolProto$1.valueOf.call(t4) === SymbolProto$1.valueOf.call(n2);
    case `[object ArrayBuffer]`:
    case tagDataView$1:
      return deepEq$1(toBufferView$1(t4), toBufferView$1(n2), r2, i2);
  }
  var o2 = a2 === `[object Array]`;
  if (!o2 && isTypedArray_default$1(t4)) {
    if (_getByteLength_default$1(t4) !== _getByteLength_default$1(n2)) return false;
    if (t4.buffer === n2.buffer && t4.byteOffset === n2.byteOffset) return true;
    o2 = true;
  }
  if (!o2) {
    if (typeof t4 != `object` || typeof n2 != `object`) return false;
    var s2 = t4.constructor, c2 = n2.constructor;
    if (s2 !== c2 && !(isFunction_default$1(s2) && s2 instanceof s2 && isFunction_default$1(c2) && c2 instanceof c2) && `constructor` in t4 && `constructor` in n2) return false;
  }
  r2 ||= [], i2 ||= [];
  for (var l2 = r2.length; l2--; ) if (r2[l2] === t4) return i2[l2] === n2;
  if (r2.push(t4), i2.push(n2), o2) {
    if (l2 = t4.length, l2 !== n2.length) return false;
    for (; l2--; ) if (!eq$1(t4[l2], n2[l2], r2, i2)) return false;
  } else {
    var u2 = keys$2(t4), d2;
    if (l2 = u2.length, keys$2(n2).length !== l2) return false;
    for (; l2--; ) if (d2 = u2[l2], !(has$1$1(n2, d2) && eq$1(t4[d2], n2[d2], r2, i2))) return false;
  }
  return r2.pop(), i2.pop(), true;
}
function isEqual$1(t4, n2) {
  return eq$1(t4, n2);
}
var tagDataView$1, init_isEqual$1 = __esmMin$1((() => {
  init_underscore$1(), init__setup$1(), init__getByteLength$1(), init_isTypedArray$1(), init_isFunction$1(), init__stringTagBug$1(), init_isDataView$1(), init_keys$1(), init__has$1(), init__toBufferView$1(), tagDataView$1 = `[object DataView]`;
}));
function allKeys$1(t4) {
  if (!isObject$2(t4)) return [];
  var n2 = [];
  for (var r2 in t4) n2.push(r2);
  return hasEnumBug$1 && collectNonEnumProps$1(t4, n2), n2;
}
var init_allKeys$1 = __esmMin$1((() => {
  init_isObject$1(), init__setup$1(), init__collectNonEnumProps$1();
}));
function ie11fingerprint$1(t4) {
  var n2 = _getLength_default$1(t4);
  return function(r2) {
    if (r2 == null || _getLength_default$1(allKeys$1(r2))) return false;
    for (var i2 = 0; i2 < n2; i2++) if (!isFunction_default$1(r2[t4[i2]])) return false;
    return t4 !== weakMapMethods$1 || !isFunction_default$1(r2[forEachName$1]);
  };
}
var forEachName$1, hasName$1, commonInit$1, mapTail$1, mapMethods$1, weakMapMethods$1, setMethods$1, init__methodFingerprint$1 = __esmMin$1((() => {
  init__getLength$1(), init_isFunction$1(), init_allKeys$1(), forEachName$1 = `forEach`, hasName$1 = `has`, commonInit$1 = [`clear`, `delete`], mapTail$1 = [`get`, hasName$1, `set`], mapMethods$1 = commonInit$1.concat(forEachName$1, mapTail$1), weakMapMethods$1 = commonInit$1.concat(mapTail$1), setMethods$1 = [`add`].concat(commonInit$1, forEachName$1, hasName$1);
})), isMap_default$1, init_isMap$1 = __esmMin$1((() => {
  init__tagTester$1(), init__stringTagBug$1(), init__methodFingerprint$1(), isMap_default$1 = isIE11$1 ? ie11fingerprint$1(mapMethods$1) : tagTester$1(`Map`);
})), isWeakMap_default$1, init_isWeakMap$1 = __esmMin$1((() => {
  init__tagTester$1(), init__stringTagBug$1(), init__methodFingerprint$1(), isWeakMap_default$1 = isIE11$1 ? ie11fingerprint$1(weakMapMethods$1) : tagTester$1(`WeakMap`);
})), isSet_default$1, init_isSet$1 = __esmMin$1((() => {
  init__tagTester$1(), init__stringTagBug$1(), init__methodFingerprint$1(), isSet_default$1 = isIE11$1 ? ie11fingerprint$1(setMethods$1) : tagTester$1(`Set`);
})), isWeakSet_default$1, init_isWeakSet$1 = __esmMin$1((() => {
  init__tagTester$1(), isWeakSet_default$1 = tagTester$1(`WeakSet`);
}));
function values$1(t4) {
  for (var n2 = keys$2(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = t4[n2[a2]];
  return i2;
}
var init_values$1 = __esmMin$1((() => {
  init_keys$1();
}));
function pairs$1(t4) {
  for (var n2 = keys$2(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = [n2[a2], t4[n2[a2]]];
  return i2;
}
var init_pairs$1 = __esmMin$1((() => {
  init_keys$1();
}));
function invert$1(t4) {
  for (var n2 = {}, r2 = keys$2(t4), i2 = 0, a2 = r2.length; i2 < a2; i2++) n2[t4[r2[i2]]] = r2[i2];
  return n2;
}
var init_invert$1 = __esmMin$1((() => {
  init_keys$1();
}));
function functions$1$1(t4) {
  var n2 = [];
  for (var r2 in t4) isFunction_default$1(t4[r2]) && n2.push(r2);
  return n2.sort();
}
var init_functions$1 = __esmMin$1((() => {
  init_isFunction$1();
}));
function createAssigner$1(t4, n2) {
  return function(r2) {
    var i2 = arguments.length;
    if (n2 && (r2 = Object(r2)), i2 < 2 || r2 == null) return r2;
    for (var a2 = 1; a2 < i2; a2++) for (var o2 = arguments[a2], s2 = t4(o2), c2 = s2.length, l2 = 0; l2 < c2; l2++) {
      var u2 = s2[l2];
      (!n2 || r2[u2] === void 0) && (r2[u2] = o2[u2]);
    }
    return r2;
  };
}
var init__createAssigner$1 = __esmMin$1((() => {
})), extend_default$1, init_extend$1 = __esmMin$1((() => {
  init__createAssigner$1(), init_allKeys$1(), extend_default$1 = createAssigner$1(allKeys$1);
})), extendOwn_default$1, init_extendOwn$1 = __esmMin$1((() => {
  init__createAssigner$1(), init_keys$1(), extendOwn_default$1 = createAssigner$1(keys$2);
})), defaults_default$1, init_defaults$1 = __esmMin$1((() => {
  init__createAssigner$1(), init_allKeys$1(), defaults_default$1 = createAssigner$1(allKeys$1, true);
}));
function ctor$1() {
  return function() {
  };
}
function baseCreate$1(t4) {
  if (!isObject$2(t4)) return {};
  if (nativeCreate$1) return nativeCreate$1(t4);
  var n2 = ctor$1();
  n2.prototype = t4;
  var r2 = new n2();
  return n2.prototype = null, r2;
}
var init__baseCreate$1 = __esmMin$1((() => {
  init_isObject$1(), init__setup$1();
}));
function create$2(t4, n2) {
  var r2 = baseCreate$1(t4);
  return n2 && extendOwn_default$1(r2, n2), r2;
}
var init_create$1 = __esmMin$1((() => {
  init__baseCreate$1(), init_extendOwn$1();
}));
function clone$4(t4) {
  return isObject$2(t4) ? isArray_default$1(t4) ? t4.slice() : extend_default$1({}, t4) : t4;
}
var init_clone$1 = __esmMin$1((() => {
  init_isObject$1(), init_isArray$1(), init_extend$1();
}));
function tap$1(t4, n2) {
  return n2(t4), t4;
}
var init_tap$1 = __esmMin$1((() => {
}));
function toPath$1$1(t4) {
  return isArray_default$1(t4) ? t4 : [t4];
}
var init_toPath$1 = __esmMin$1((() => {
  init_underscore$1(), init_isArray$1(), _$1$1.toPath = toPath$1$1;
}));
function toPath$2(t4) {
  return _$1$1.toPath(t4);
}
var init__toPath$1 = __esmMin$1((() => {
  init_underscore$1(), init_toPath$1();
}));
function deepGet$1(t4, n2) {
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    if (t4 == null) return;
    t4 = t4[n2[i2]];
  }
  return r2 ? t4 : void 0;
}
var init__deepGet$1 = __esmMin$1((() => {
}));
function get$2(t4, n2, r2) {
  var i2 = deepGet$1(t4, toPath$2(n2));
  return isUndefined$2(i2) ? r2 : i2;
}
var init_get$1 = __esmMin$1((() => {
  init__toPath$1(), init__deepGet$1(), init_isUndefined$1();
}));
function has$2(t4, n2) {
  n2 = toPath$2(n2);
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    var a2 = n2[i2];
    if (!has$1$1(t4, a2)) return false;
    t4 = t4[a2];
  }
  return !!r2;
}
var init_has$1 = __esmMin$1((() => {
  init__has$1(), init__toPath$1();
}));
function identity$3(t4) {
  return t4;
}
var init_identity$1 = __esmMin$1((() => {
}));
function matcher$1(t4) {
  return t4 = extendOwn_default$1({}, t4), function(n2) {
    return isMatch$1(n2, t4);
  };
}
var init_matcher$1 = __esmMin$1((() => {
  init_extendOwn$1(), init_isMatch$1();
}));
function property$1(t4) {
  return t4 = toPath$2(t4), function(n2) {
    return deepGet$1(n2, t4);
  };
}
var init_property$1 = __esmMin$1((() => {
  init__deepGet$1(), init__toPath$1();
}));
function optimizeCb$1(t4, n2, r2) {
  if (n2 === void 0) return t4;
  switch (r2 ?? 3) {
    case 1:
      return function(r3) {
        return t4.call(n2, r3);
      };
    case 3:
      return function(r3, i2, a2) {
        return t4.call(n2, r3, i2, a2);
      };
    case 4:
      return function(r3, i2, a2, o2) {
        return t4.call(n2, r3, i2, a2, o2);
      };
  }
  return function() {
    return t4.apply(n2, arguments);
  };
}
var init__optimizeCb$1 = __esmMin$1((() => {
}));
function baseIteratee$1(t4, n2, r2) {
  return t4 == null ? identity$3 : isFunction_default$1(t4) ? optimizeCb$1(t4, n2, r2) : isObject$2(t4) && !isArray_default$1(t4) ? matcher$1(t4) : property$1(t4);
}
var init__baseIteratee$1 = __esmMin$1((() => {
  init_identity$1(), init_isFunction$1(), init_isObject$1(), init_isArray$1(), init_matcher$1(), init_property$1(), init__optimizeCb$1();
}));
function iteratee$1(t4, n2) {
  return baseIteratee$1(t4, n2, 1 / 0);
}
var init_iteratee$1 = __esmMin$1((() => {
  init_underscore$1(), init__baseIteratee$1(), _$1$1.iteratee = iteratee$1;
}));
function cb$1(t4, n2, r2) {
  return _$1$1.iteratee === iteratee$1 ? baseIteratee$1(t4, n2, r2) : _$1$1.iteratee(t4, n2);
}
var init__cb$1 = __esmMin$1((() => {
  init_underscore$1(), init__baseIteratee$1(), init_iteratee$1();
}));
function mapObject$2(t4, n2, r2) {
  n2 = cb$1(n2, r2);
  for (var i2 = keys$2(t4), a2 = i2.length, o2 = {}, s2 = 0; s2 < a2; s2++) {
    var c2 = i2[s2];
    o2[c2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_mapObject$1 = __esmMin$1((() => {
  init__cb$1(), init_keys$1();
}));
function noop$4() {
}
var init_noop$1 = __esmMin$1((() => {
}));
function propertyOf$1(t4) {
  return t4 == null ? noop$4 : function(n2) {
    return get$2(t4, n2);
  };
}
var init_propertyOf$1 = __esmMin$1((() => {
  init_noop$1(), init_get$1();
}));
function times$1(t4, n2, r2) {
  var i2 = Array(Math.max(0, t4));
  n2 = optimizeCb$1(n2, r2, 1);
  for (var a2 = 0; a2 < t4; a2++) i2[a2] = n2(a2);
  return i2;
}
var init_times$1 = __esmMin$1((() => {
  init__optimizeCb$1();
}));
function random$2(t4, n2) {
  return n2 ?? (n2 = t4, t4 = 0), t4 + Math.floor(Math.random() * (n2 - t4 + 1));
}
var init_random$1 = __esmMin$1((() => {
})), now_default$1, init_now$1 = __esmMin$1((() => {
  now_default$1 = Date.now || function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}));
function createEscaper$1(t4) {
  var n2 = function(n3) {
    return t4[n3];
  }, r2 = `(?:` + keys$2(t4).join(`|`) + `)`, i2 = RegExp(r2), a2 = RegExp(r2, `g`);
  return function(t5) {
    return t5 = t5 == null ? `` : `` + t5, i2.test(t5) ? t5.replace(a2, n2) : t5;
  };
}
var init__createEscaper$1 = __esmMin$1((() => {
  init_keys$1();
})), _escapeMap_default$1, init__escapeMap$1 = __esmMin$1((() => {
  _escapeMap_default$1 = { "&": `&amp;`, "<": `&lt;`, ">": `&gt;`, '"': `&quot;`, "'": `&#x27;`, "`": `&#x60;` };
})), escape_default$1, init_escape$1 = __esmMin$1((() => {
  init__createEscaper$1(), init__escapeMap$1(), escape_default$1 = createEscaper$1(_escapeMap_default$1);
})), _unescapeMap_default$1, init__unescapeMap$1 = __esmMin$1((() => {
  init_invert$1(), init__escapeMap$1(), _unescapeMap_default$1 = invert$1(_escapeMap_default$1);
})), unescape_default$1, init_unescape$1 = __esmMin$1((() => {
  init__createEscaper$1(), init__unescapeMap$1(), unescape_default$1 = createEscaper$1(_unescapeMap_default$1);
})), templateSettings_default$1, init_templateSettings$1 = __esmMin$1((() => {
  init_underscore$1(), templateSettings_default$1 = _$1$1.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g };
}));
function escapeChar$1(t4) {
  return `\\` + escapes$1[t4];
}
function template$1(t4, n2, r2) {
  !n2 && r2 && (n2 = r2), n2 = defaults_default$1({}, n2, _$1$1.templateSettings);
  var i2 = RegExp([(n2.escape || noMatch$1).source, (n2.interpolate || noMatch$1).source, (n2.evaluate || noMatch$1).source].join(`|`) + `|$`, `g`), a2 = 0, o2 = `__p+='`;
  t4.replace(i2, function(n3, r3, i3, s3, c3) {
    return o2 += t4.slice(a2, c3).replace(escapeRegExp$1, escapeChar$1), a2 = c3 + n3.length, r3 ? o2 += `'+
((__t=(` + r3 + `))==null?'':_.escape(__t))+
'` : i3 ? o2 += `'+
((__t=(` + i3 + `))==null?'':__t)+
'` : s3 && (o2 += `';
` + s3 + `
__p+='`), n3;
  }), o2 += `';
`;
  var s2 = n2.variable;
  if (s2) {
    if (!bareIdentifier$1.test(s2)) throw Error(`variable is not a bare identifier: ` + s2);
  } else o2 = `with(obj||{}){
` + o2 + `}
`, s2 = `obj`;
  o2 = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + o2 + `return __p;
`;
  var c2;
  try {
    c2 = Function(s2, `_`, o2);
  } catch (t5) {
    throw t5.source = o2, t5;
  }
  var l2 = function(t5) {
    return c2.call(this, t5, _$1$1);
  };
  return l2.source = `function(` + s2 + `){
` + o2 + `}`, l2;
}
var noMatch$1, escapes$1, escapeRegExp$1, bareIdentifier$1, init_template$1 = __esmMin$1((() => {
  init_defaults$1(), init_underscore$1(), init_templateSettings$1(), noMatch$1 = /(.)^/, escapes$1 = { "'": `'`, "\\": `\\`, "\r": `r`, "\n": `n`, "\u2028": `u2028`, "\u2029": `u2029` }, escapeRegExp$1 = /\\|'|\r|\n|\u2028|\u2029/g, bareIdentifier$1 = /^\s*(\w|\$)+\s*$/;
}));
function result$1(t4, n2, r2) {
  n2 = toPath$2(n2);
  var i2 = n2.length;
  if (!i2) return isFunction_default$1(r2) ? r2.call(t4) : r2;
  for (var a2 = 0; a2 < i2; a2++) {
    var o2 = t4?.[n2[a2]];
    o2 === void 0 && (o2 = r2, a2 = i2), t4 = isFunction_default$1(o2) ? o2.call(t4) : o2;
  }
  return t4;
}
var init_result$1 = __esmMin$1((() => {
  init_isFunction$1(), init__toPath$1();
}));
function uniqueId$1(t4) {
  var n2 = ++idCounter$1 + ``;
  return t4 ? t4 + n2 : n2;
}
var idCounter$1, init_uniqueId$1 = __esmMin$1((() => {
  idCounter$1 = 0;
}));
function chain$3(t4) {
  var n2 = _$1$1(t4);
  return n2._chain = true, n2;
}
var init_chain$1 = __esmMin$1((() => {
  init_underscore$1();
}));
function executeBound$1(t4, n2, r2, i2, a2) {
  if (!(i2 instanceof n2)) return t4.apply(r2, a2);
  var o2 = baseCreate$1(t4.prototype), s2 = t4.apply(o2, a2);
  return isObject$2(s2) ? s2 : o2;
}
var init__executeBound$1 = __esmMin$1((() => {
  init__baseCreate$1(), init_isObject$1();
})), partial$1, init_partial$1 = __esmMin$1((() => {
  init_restArguments$1(), init__executeBound$1(), init_underscore$1(), partial$1 = restArguments$1(function(t4, n2) {
    var r2 = partial$1.placeholder, i2 = function() {
      for (var a2 = 0, o2 = n2.length, s2 = Array(o2), c2 = 0; c2 < o2; c2++) s2[c2] = n2[c2] === r2 ? arguments[a2++] : n2[c2];
      for (; a2 < arguments.length; ) s2.push(arguments[a2++]);
      return executeBound$1(t4, i2, this, this, s2);
    };
    return i2;
  }), partial$1.placeholder = _$1$1;
})), bind_default$1, init_bind$1 = __esmMin$1((() => {
  init_restArguments$1(), init_isFunction$1(), init__executeBound$1(), bind_default$1 = restArguments$1(function(t4, n2, r2) {
    if (!isFunction_default$1(t4)) throw TypeError(`Bind must be called on a function`);
    var i2 = restArguments$1(function(a2) {
      return executeBound$1(t4, i2, n2, this, r2.concat(a2));
    });
    return i2;
  });
})), _isArrayLike_default$1, init__isArrayLike$1 = __esmMin$1((() => {
  init__createSizePropertyCheck$1(), init__getLength$1(), _isArrayLike_default$1 = createSizePropertyCheck$1(_getLength_default$1);
}));
function flatten$3$1(t4, n2, r2, i2) {
  if (i2 ||= [], !n2 && n2 !== 0) n2 = 1 / 0;
  else if (n2 <= 0) return i2.concat(t4);
  for (var a2 = i2.length, o2 = 0, s2 = _getLength_default$1(t4); o2 < s2; o2++) {
    var c2 = t4[o2];
    if (_isArrayLike_default$1(c2) && (isArray_default$1(c2) || isArguments_default$1(c2))) if (n2 > 1) flatten$3$1(c2, n2 - 1, r2, i2), a2 = i2.length;
    else for (var l2 = 0, u2 = c2.length; l2 < u2; ) i2[a2++] = c2[l2++];
    else r2 || (i2[a2++] = c2);
  }
  return i2;
}
var init__flatten$1 = __esmMin$1((() => {
  init__getLength$1(), init__isArrayLike$1(), init_isArray$1(), init_isArguments$1();
})), bindAll_default$1, init_bindAll$1 = __esmMin$1((() => {
  init_restArguments$1(), init__flatten$1(), init_bind$1(), bindAll_default$1 = restArguments$1(function(t4, n2) {
    n2 = flatten$3$1(n2, false, false);
    var r2 = n2.length;
    if (r2 < 1) throw Error(`bindAll must be passed function names`);
    for (; r2--; ) {
      var i2 = n2[r2];
      t4[i2] = bind_default$1(t4[i2], t4);
    }
    return t4;
  });
}));
function memoize$2(t4, n2) {
  var r2 = function(i2) {
    var a2 = r2.cache, o2 = `` + (n2 ? n2.apply(this, arguments) : i2);
    return has$1$1(a2, o2) || (a2[o2] = t4.apply(this, arguments)), a2[o2];
  };
  return r2.cache = {}, r2;
}
var init_memoize$1 = __esmMin$1((() => {
  init__has$1();
})), delay_default$1, init_delay$1 = __esmMin$1((() => {
  init_restArguments$1(), delay_default$1 = restArguments$1(function(t4, n2, r2) {
    return setTimeout(function() {
      return t4.apply(null, r2);
    }, n2);
  });
})), defer_default$1, init_defer$1 = __esmMin$1((() => {
  init_partial$1(), init_delay$1(), init_underscore$1(), defer_default$1 = partial$1(delay_default$1, _$1$1, 1);
}));
function throttle$1(t4, n2, r2) {
  var i2, a2, o2, s2, c2 = 0;
  r2 ||= {};
  var l2 = function() {
    c2 = r2.leading === false ? 0 : now_default$1(), i2 = null, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null);
  }, u2 = function() {
    var u3 = now_default$1();
    !c2 && r2.leading === false && (c2 = u3);
    var d2 = n2 - (u3 - c2);
    return a2 = this, o2 = arguments, d2 <= 0 || d2 > n2 ? (i2 &&= (clearTimeout(i2), null), c2 = u3, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null)) : !i2 && r2.trailing !== false && (i2 = setTimeout(l2, d2)), s2;
  };
  return u2.cancel = function() {
    clearTimeout(i2), c2 = 0, i2 = a2 = o2 = null;
  }, u2;
}
var init_throttle$1 = __esmMin$1((() => {
  init_now$1();
}));
function debounce$2(t4, n2, r2) {
  var i2, a2, o2, s2, c2, l2 = function() {
    var u3 = now_default$1() - a2;
    n2 > u3 ? i2 = setTimeout(l2, n2 - u3) : (i2 = null, r2 || (s2 = t4.apply(c2, o2)), i2 || (o2 = c2 = null));
  }, u2 = restArguments$1(function(u3) {
    return c2 = this, o2 = u3, a2 = now_default$1(), i2 || (i2 = setTimeout(l2, n2), r2 && (s2 = t4.apply(c2, o2))), s2;
  });
  return u2.cancel = function() {
    clearTimeout(i2), i2 = o2 = c2 = null;
  }, u2;
}
var init_debounce$1 = __esmMin$1((() => {
  init_restArguments$1(), init_now$1();
}));
function wrap$2(t4, n2) {
  return partial$1(n2, t4);
}
var init_wrap$1 = __esmMin$1((() => {
  init_partial$1();
}));
function negate$1(t4) {
  return function() {
    return !t4.apply(this, arguments);
  };
}
var init_negate$1 = __esmMin$1((() => {
}));
function compose$1() {
  var t4 = arguments, n2 = t4.length - 1;
  return function() {
    for (var r2 = n2, i2 = t4[n2].apply(this, arguments); r2--; ) i2 = t4[r2].call(this, i2);
    return i2;
  };
}
var init_compose$1 = __esmMin$1((() => {
}));
function after$1(t4, n2) {
  return function() {
    if (--t4 < 1) return n2.apply(this, arguments);
  };
}
var init_after$1 = __esmMin$1((() => {
}));
function before$1(t4, n2) {
  var r2;
  return function() {
    return --t4 > 0 && (r2 = n2.apply(this, arguments)), t4 <= 1 && (n2 = null), r2;
  };
}
var init_before$1 = __esmMin$1((() => {
})), once_default$1, init_once$1 = __esmMin$1((() => {
  init_partial$1(), init_before$1(), once_default$1 = partial$1(before$1, 2);
}));
function findKey$1(t4, n2, r2) {
  n2 = cb$1(n2, r2);
  for (var i2 = keys$2(t4), a2, o2 = 0, s2 = i2.length; o2 < s2; o2++) if (a2 = i2[o2], n2(t4[a2], a2, t4)) return a2;
}
var init_findKey$1 = __esmMin$1((() => {
  init__cb$1(), init_keys$1();
}));
function createPredicateIndexFinder$1(t4) {
  return function(n2, r2, i2) {
    r2 = cb$1(r2, i2);
    for (var a2 = _getLength_default$1(n2), o2 = t4 > 0 ? 0 : a2 - 1; o2 >= 0 && o2 < a2; o2 += t4) if (r2(n2[o2], o2, n2)) return o2;
    return -1;
  };
}
var init__createPredicateIndexFinder$1 = __esmMin$1((() => {
  init__cb$1(), init__getLength$1();
})), findIndex_default$1, init_findIndex$1 = __esmMin$1((() => {
  init__createPredicateIndexFinder$1(), findIndex_default$1 = createPredicateIndexFinder$1(1);
})), findLastIndex_default$1, init_findLastIndex$1 = __esmMin$1((() => {
  init__createPredicateIndexFinder$1(), findLastIndex_default$1 = createPredicateIndexFinder$1(-1);
}));
function sortedIndex$1(t4, n2, r2, i2) {
  r2 = cb$1(r2, i2, 1);
  for (var a2 = r2(n2), o2 = 0, s2 = _getLength_default$1(t4); o2 < s2; ) {
    var c2 = Math.floor((o2 + s2) / 2);
    r2(t4[c2]) < a2 ? o2 = c2 + 1 : s2 = c2;
  }
  return o2;
}
var init_sortedIndex$1 = __esmMin$1((() => {
  init__cb$1(), init__getLength$1();
}));
function createIndexFinder$1(t4, n2, r2) {
  return function(i2, a2, o2) {
    var s2 = 0, c2 = _getLength_default$1(i2);
    if (typeof o2 == `number`) t4 > 0 ? s2 = o2 >= 0 ? o2 : Math.max(o2 + c2, s2) : c2 = o2 >= 0 ? Math.min(o2 + 1, c2) : o2 + c2 + 1;
    else if (r2 && o2 && c2) return o2 = r2(i2, a2), i2[o2] === a2 ? o2 : -1;
    if (a2 !== a2) return o2 = n2(slice$1.call(i2, s2, c2), isNaN$1$1), o2 >= 0 ? o2 + s2 : -1;
    for (o2 = t4 > 0 ? s2 : c2 - 1; o2 >= 0 && o2 < c2; o2 += t4) if (i2[o2] === a2) return o2;
    return -1;
  };
}
var init__createIndexFinder$1 = __esmMin$1((() => {
  init__getLength$1(), init__setup$1(), init_isNaN$1();
})), indexOf_default$1, init_indexOf$1 = __esmMin$1((() => {
  init_sortedIndex$1(), init_findIndex$1(), init__createIndexFinder$1(), indexOf_default$1 = createIndexFinder$1(1, findIndex_default$1, sortedIndex$1);
})), lastIndexOf_default$1, init_lastIndexOf$1 = __esmMin$1((() => {
  init_findLastIndex$1(), init__createIndexFinder$1(), lastIndexOf_default$1 = createIndexFinder$1(-1, findLastIndex_default$1);
}));
function find$2(t4, n2, r2) {
  var i2 = (_isArrayLike_default$1(t4) ? findIndex_default$1 : findKey$1)(t4, n2, r2);
  if (i2 !== void 0 && i2 !== -1) return t4[i2];
}
var init_find$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_findIndex$1(), init_findKey$1();
}));
function findWhere$1(t4, n2) {
  return find$2(t4, matcher$1(n2));
}
var init_findWhere$1 = __esmMin$1((() => {
  init_find$1(), init_matcher$1();
}));
function each$1(t4, n2, r2) {
  n2 = optimizeCb$1(n2, r2);
  var i2, a2;
  if (_isArrayLike_default$1(t4)) for (i2 = 0, a2 = t4.length; i2 < a2; i2++) n2(t4[i2], i2, t4);
  else {
    var o2 = keys$2(t4);
    for (i2 = 0, a2 = o2.length; i2 < a2; i2++) n2(t4[o2[i2]], o2[i2], t4);
  }
  return t4;
}
var init_each$1 = __esmMin$1((() => {
  init__optimizeCb$1(), init__isArrayLike$1(), init_keys$1();
}));
function map$2(t4, n2, r2) {
  n2 = cb$1(n2, r2);
  for (var i2 = !_isArrayLike_default$1(t4) && keys$2(t4), a2 = (i2 || t4).length, o2 = Array(a2), s2 = 0; s2 < a2; s2++) {
    var c2 = i2 ? i2[s2] : s2;
    o2[s2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_map$1 = __esmMin$1((() => {
  init__cb$1(), init__isArrayLike$1(), init_keys$1();
}));
function createReduce$1(t4) {
  var n2 = function(n3, r2, i2, a2) {
    var o2 = !_isArrayLike_default$1(n3) && keys$2(n3), s2 = (o2 || n3).length, c2 = t4 > 0 ? 0 : s2 - 1;
    for (a2 || (i2 = n3[o2 ? o2[c2] : c2], c2 += t4); c2 >= 0 && c2 < s2; c2 += t4) {
      var l2 = o2 ? o2[c2] : c2;
      i2 = r2(i2, n3[l2], l2, n3);
    }
    return i2;
  };
  return function(t5, r2, i2, a2) {
    var o2 = arguments.length >= 3;
    return n2(t5, optimizeCb$1(r2, a2, 4), i2, o2);
  };
}
var init__createReduce$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_keys$1(), init__optimizeCb$1();
})), reduce_default$1, init_reduce$1 = __esmMin$1((() => {
  init__createReduce$1(), reduce_default$1 = createReduce$1(1);
})), reduceRight_default$1, init_reduceRight$1 = __esmMin$1((() => {
  init__createReduce$1(), reduceRight_default$1 = createReduce$1(-1);
}));
function filter$2(t4, n2, r2) {
  var i2 = [];
  return n2 = cb$1(n2, r2), each$1(t4, function(t5, r3, a2) {
    n2(t5, r3, a2) && i2.push(t5);
  }), i2;
}
var init_filter$1 = __esmMin$1((() => {
  init__cb$1(), init_each$1();
}));
function reject$1(t4, n2, r2) {
  return filter$2(t4, negate$1(cb$1(n2)), r2);
}
var init_reject$1 = __esmMin$1((() => {
  init_filter$1(), init_negate$1(), init__cb$1();
}));
function every$1(t4, n2, r2) {
  n2 = cb$1(n2, r2);
  for (var i2 = !_isArrayLike_default$1(t4) && keys$2(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (!n2(t4[s2], s2, t4)) return false;
  }
  return true;
}
var init_every$1 = __esmMin$1((() => {
  init__cb$1(), init__isArrayLike$1(), init_keys$1();
}));
function some$1(t4, n2, r2) {
  n2 = cb$1(n2, r2);
  for (var i2 = !_isArrayLike_default$1(t4) && keys$2(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (n2(t4[s2], s2, t4)) return true;
  }
  return false;
}
var init_some$1 = __esmMin$1((() => {
  init__cb$1(), init__isArrayLike$1(), init_keys$1();
}));
function contains$4(t4, n2, r2, i2) {
  return _isArrayLike_default$1(t4) || (t4 = values$1(t4)), (typeof r2 != `number` || i2) && (r2 = 0), indexOf_default$1(t4, n2, r2) >= 0;
}
var init_contains$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_values$1(), init_indexOf$1();
})), invoke_default$1, init_invoke$1 = __esmMin$1((() => {
  init_restArguments$1(), init_isFunction$1(), init_map$1(), init__deepGet$1(), init__toPath$1(), invoke_default$1 = restArguments$1(function(t4, n2, r2) {
    var i2, a2;
    return isFunction_default$1(n2) ? a2 = n2 : (n2 = toPath$2(n2), i2 = n2.slice(0, -1), n2 = n2[n2.length - 1]), map$2(t4, function(t5) {
      var o2 = a2;
      if (!o2) {
        if (i2 && i2.length && (t5 = deepGet$1(t5, i2)), t5 == null) return;
        o2 = t5[n2];
      }
      return o2 == null ? o2 : o2.apply(t5, r2);
    });
  });
}));
function pluck$1(t4, n2) {
  return map$2(t4, property$1(n2));
}
var init_pluck$1 = __esmMin$1((() => {
  init_map$1(), init_property$1();
}));
function where$1(t4, n2) {
  return filter$2(t4, matcher$1(n2));
}
var init_where$1 = __esmMin$1((() => {
  init_filter$1(), init_matcher$1();
}));
function max$3(t4, n2, r2) {
  var i2 = -1 / 0, a2 = -1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default$1(t4) ? t4 : values$1(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 > i2 && (i2 = o2);
  } else n2 = cb$1(n2, r2), each$1(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 > a2 || s2 === -1 / 0 && i2 === -1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_max$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_values$1(), init__cb$1(), init_each$1();
}));
function min$3(t4, n2, r2) {
  var i2 = 1 / 0, a2 = 1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default$1(t4) ? t4 : values$1(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 < i2 && (i2 = o2);
  } else n2 = cb$1(n2, r2), each$1(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 < a2 || s2 === 1 / 0 && i2 === 1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_min$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_values$1(), init__cb$1(), init_each$1();
}));
function toArray$2(t4) {
  return t4 ? isArray_default$1(t4) ? slice$1.call(t4) : isString_default$1(t4) ? t4.match(reStrSymbol$1) : _isArrayLike_default$1(t4) ? map$2(t4, identity$3) : values$1(t4) : [];
}
var reStrSymbol$1, init_toArray$1 = __esmMin$1((() => {
  init_isArray$1(), init__setup$1(), init_isString$1(), init__isArrayLike$1(), init_map$1(), init_identity$1(), init_values$1(), reStrSymbol$1 = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
}));
function sample$1(t4, n2, r2) {
  if (n2 == null || r2) return _isArrayLike_default$1(t4) || (t4 = values$1(t4)), t4[random$2(t4.length - 1)];
  var i2 = toArray$2(t4), a2 = _getLength_default$1(i2);
  n2 = Math.max(Math.min(n2, a2), 0);
  for (var o2 = a2 - 1, s2 = 0; s2 < n2; s2++) {
    var c2 = random$2(s2, o2), l2 = i2[s2];
    i2[s2] = i2[c2], i2[c2] = l2;
  }
  return i2.slice(0, n2);
}
var init_sample$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_values$1(), init__getLength$1(), init_random$1(), init_toArray$1();
}));
function shuffle$1(t4) {
  return sample$1(t4, 1 / 0);
}
var init_shuffle$1 = __esmMin$1((() => {
  init_sample$1();
}));
function sortBy$1(t4, n2, r2) {
  var i2 = 0;
  return n2 = cb$1(n2, r2), pluck$1(map$2(t4, function(t5, r3, a2) {
    return { value: t5, index: i2++, criteria: n2(t5, r3, a2) };
  }).sort(function(t5, n3) {
    var r3 = t5.criteria, i3 = n3.criteria;
    if (r3 !== i3) {
      if (r3 > i3 || r3 === void 0) return 1;
      if (r3 < i3 || i3 === void 0) return -1;
    }
    return t5.index - n3.index;
  }), `value`);
}
var init_sortBy$1 = __esmMin$1((() => {
  init__cb$1(), init_pluck$1(), init_map$1();
}));
function group$3(t4, n2) {
  return function(r2, i2, a2) {
    var o2 = n2 ? [[], []] : {};
    return i2 = cb$1(i2, a2), each$1(r2, function(n3, a3) {
      t4(o2, n3, i2(n3, a3, r2));
    }), o2;
  };
}
var init__group$1 = __esmMin$1((() => {
  init__cb$1(), init_each$1();
})), groupBy_default$1, init_groupBy$1 = __esmMin$1((() => {
  init__group$1(), init__has$1(), groupBy_default$1 = group$3(function(t4, n2, r2) {
    has$1$1(t4, r2) ? t4[r2].push(n2) : t4[r2] = [n2];
  });
})), indexBy_default$1, init_indexBy$1 = __esmMin$1((() => {
  init__group$1(), indexBy_default$1 = group$3(function(t4, n2, r2) {
    t4[r2] = n2;
  });
})), countBy_default$1, init_countBy$1 = __esmMin$1((() => {
  init__group$1(), init__has$1(), countBy_default$1 = group$3(function(t4, n2, r2) {
    has$1$1(t4, r2) ? t4[r2]++ : t4[r2] = 1;
  });
})), partition_default$1, init_partition$1 = __esmMin$1((() => {
  init__group$1(), partition_default$1 = group$3(function(t4, n2, r2) {
    t4[+!r2].push(n2);
  }, true);
}));
function size$3(t4) {
  return t4 == null ? 0 : _isArrayLike_default$1(t4) ? t4.length : keys$2(t4).length;
}
var init_size$1 = __esmMin$1((() => {
  init__isArrayLike$1(), init_keys$1();
}));
function keyInObj$1(t4, n2, r2) {
  return n2 in r2;
}
var init__keyInObj$1 = __esmMin$1((() => {
})), pick_default$1, init_pick$1 = __esmMin$1((() => {
  init_restArguments$1(), init_isFunction$1(), init__optimizeCb$1(), init_allKeys$1(), init__keyInObj$1(), init__flatten$1(), pick_default$1 = restArguments$1(function(t4, n2) {
    var r2 = {}, i2 = n2[0];
    if (t4 == null) return r2;
    isFunction_default$1(i2) ? (n2.length > 1 && (i2 = optimizeCb$1(i2, n2[1])), n2 = allKeys$1(t4)) : (i2 = keyInObj$1, n2 = flatten$3$1(n2, false, false), t4 = Object(t4));
    for (var a2 = 0, o2 = n2.length; a2 < o2; a2++) {
      var s2 = n2[a2], c2 = t4[s2];
      i2(c2, s2, t4) && (r2[s2] = c2);
    }
    return r2;
  });
})), omit_default$1, init_omit$1 = __esmMin$1((() => {
  init_restArguments$1(), init_isFunction$1(), init_negate$1(), init_map$1(), init__flatten$1(), init_contains$1(), init_pick$1(), omit_default$1 = restArguments$1(function(t4, n2) {
    var r2 = n2[0], i2;
    return isFunction_default$1(r2) ? (r2 = negate$1(r2), n2.length > 1 && (i2 = n2[1])) : (n2 = map$2(flatten$3$1(n2, false, false), String), r2 = function(t5, r3) {
      return !contains$4(n2, r3);
    }), pick_default$1(t4, r2, i2);
  });
}));
function initial$1(t4, n2, r2) {
  return slice$1.call(t4, 0, Math.max(0, t4.length - (n2 == null || r2 ? 1 : n2)));
}
var init_initial$1 = __esmMin$1((() => {
  init__setup$1();
}));
function first$1(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[0] : initial$1(t4, t4.length - n2);
}
var init_first$1 = __esmMin$1((() => {
  init_initial$1();
}));
function rest$1(t4, n2, r2) {
  return slice$1.call(t4, n2 == null || r2 ? 1 : n2);
}
var init_rest$1 = __esmMin$1((() => {
  init__setup$1();
}));
function last$1(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[t4.length - 1] : rest$1(t4, Math.max(0, t4.length - n2));
}
var init_last$1 = __esmMin$1((() => {
  init_rest$1();
}));
function compact$1(t4) {
  return filter$2(t4, Boolean);
}
var init_compact$1 = __esmMin$1((() => {
  init_filter$1();
}));
function flatten$2$1(t4, n2) {
  return flatten$3$1(t4, n2, false);
}
var init_flatten$1 = __esmMin$1((() => {
  init__flatten$1();
})), difference_default$1, init_difference$1 = __esmMin$1((() => {
  init_restArguments$1(), init__flatten$1(), init_filter$1(), init_contains$1(), difference_default$1 = restArguments$1(function(t4, n2) {
    return n2 = flatten$3$1(n2, true, true), filter$2(t4, function(t5) {
      return !contains$4(n2, t5);
    });
  });
})), without_default$1, init_without$1 = __esmMin$1((() => {
  init_restArguments$1(), init_difference$1(), without_default$1 = restArguments$1(function(t4, n2) {
    return difference_default$1(t4, n2);
  });
}));
function uniq$1(t4, n2, r2, i2) {
  isBoolean$2(n2) || (i2 = r2, r2 = n2, n2 = false), r2 != null && (r2 = cb$1(r2, i2));
  for (var a2 = [], o2 = [], s2 = 0, c2 = _getLength_default$1(t4); s2 < c2; s2++) {
    var l2 = t4[s2], u2 = r2 ? r2(l2, s2, t4) : l2;
    n2 && !r2 ? ((!s2 || o2 !== u2) && a2.push(l2), o2 = u2) : r2 ? contains$4(o2, u2) || (o2.push(u2), a2.push(l2)) : contains$4(a2, l2) || a2.push(l2);
  }
  return a2;
}
var init_uniq$1 = __esmMin$1((() => {
  init_isBoolean$1(), init__cb$1(), init__getLength$1(), init_contains$1();
})), union_default$1, init_union$1 = __esmMin$1((() => {
  init_restArguments$1(), init_uniq$1(), init__flatten$1(), union_default$1 = restArguments$1(function(t4) {
    return uniq$1(flatten$3$1(t4, true, true));
  });
}));
function intersection$1(t4) {
  for (var n2 = [], r2 = arguments.length, i2 = 0, a2 = _getLength_default$1(t4); i2 < a2; i2++) {
    var o2 = t4[i2];
    if (!contains$4(n2, o2)) {
      var s2;
      for (s2 = 1; s2 < r2 && contains$4(arguments[s2], o2); s2++) ;
      s2 === r2 && n2.push(o2);
    }
  }
  return n2;
}
var init_intersection$1 = __esmMin$1((() => {
  init__getLength$1(), init_contains$1();
}));
function unzip$1(t4) {
  for (var n2 = t4 && max$3(t4, _getLength_default$1).length || 0, r2 = Array(n2), i2 = 0; i2 < n2; i2++) r2[i2] = pluck$1(t4, i2);
  return r2;
}
var init_unzip$1 = __esmMin$1((() => {
  init_max$1(), init__getLength$1(), init_pluck$1();
})), zip_default$1, init_zip$1 = __esmMin$1((() => {
  init_restArguments$1(), init_unzip$1(), zip_default$1 = restArguments$1(unzip$1);
}));
function object$1(t4, n2) {
  for (var r2 = {}, i2 = 0, a2 = _getLength_default$1(t4); i2 < a2; i2++) n2 ? r2[t4[i2]] = n2[i2] : r2[t4[i2][0]] = t4[i2][1];
  return r2;
}
var init_object$1 = __esmMin$1((() => {
  init__getLength$1();
}));
function range$1(t4, n2, r2) {
  n2 ?? (n2 = t4 || 0, t4 = 0), r2 ||= n2 < t4 ? -1 : 1;
  for (var i2 = Math.max(Math.ceil((n2 - t4) / r2), 0), a2 = Array(i2), o2 = 0; o2 < i2; o2++, t4 += r2) a2[o2] = t4;
  return a2;
}
var init_range$1 = __esmMin$1((() => {
}));
function chunk$1(t4, n2) {
  if (n2 == null || n2 < 1) return [];
  for (var r2 = [], i2 = 0, a2 = t4.length; i2 < a2; ) r2.push(slice$1.call(t4, i2, i2 += n2));
  return r2;
}
var init_chunk$1 = __esmMin$1((() => {
  init__setup$1();
}));
function chainResult$1(t4, n2) {
  return t4._chain ? _$1$1(n2).chain() : n2;
}
var init__chainResult$1 = __esmMin$1((() => {
  init_underscore$1();
}));
function mixin$2(t4) {
  return each$1(functions$1$1(t4), function(n2) {
    var r2 = _$1$1[n2] = t4[n2];
    _$1$1.prototype[n2] = function() {
      var t5 = [this._wrapped];
      return push$3.apply(t5, arguments), chainResult$1(this, r2.apply(_$1$1, t5));
    };
  }), _$1$1;
}
var init_mixin$1 = __esmMin$1((() => {
  init_underscore$1(), init_each$1(), init_functions$1(), init__setup$1(), init__chainResult$1();
})), underscore_array_methods_default$1, init_underscore_array_methods$1 = __esmMin$1((() => {
  init_underscore$1(), init_each$1(), init__setup$1(), init__chainResult$1(), each$1([`pop`, `push`, `reverse`, `shift`, `sort`, `splice`, `unshift`], function(t4) {
    var n2 = ArrayProto$1[t4];
    _$1$1.prototype[t4] = function() {
      var r2 = this._wrapped;
      return r2 != null && (n2.apply(r2, arguments), (t4 === `shift` || t4 === `splice`) && r2.length === 0 && delete r2[0]), chainResult$1(this, r2);
    };
  }), each$1([`concat`, `join`, `slice`], function(t4) {
    var n2 = ArrayProto$1[t4];
    _$1$1.prototype[t4] = function() {
      var t5 = this._wrapped;
      return t5 != null && (t5 = n2.apply(t5, arguments)), chainResult$1(this, t5);
    };
  }), underscore_array_methods_default$1 = _$1$1;
})), modules_exports$1 = __exportAll$1({ VERSION: () => VERSION$1, after: () => after$1, all: () => every$1, allKeys: () => allKeys$1, any: () => some$1, assign: () => extendOwn_default$1, before: () => before$1, bind: () => bind_default$1, bindAll: () => bindAll_default$1, chain: () => chain$3, chunk: () => chunk$1, clone: () => clone$4, collect: () => map$2, compact: () => compact$1, compose: () => compose$1, constant: () => constant$1, contains: () => contains$4, countBy: () => countBy_default$1, create: () => create$2, debounce: () => debounce$2, default: () => underscore_array_methods_default$1, defaults: () => defaults_default$1, defer: () => defer_default$1, delay: () => delay_default$1, detect: () => find$2, difference: () => difference_default$1, drop: () => rest$1, each: () => each$1, escape: () => escape_default$1, every: () => every$1, extend: () => extend_default$1, extendOwn: () => extendOwn_default$1, filter: () => filter$2, find: () => find$2, findIndex: () => findIndex_default$1, findKey: () => findKey$1, findLastIndex: () => findLastIndex_default$1, findWhere: () => findWhere$1, first: () => first$1, flatten: () => flatten$2$1, foldl: () => reduce_default$1, foldr: () => reduceRight_default$1, forEach: () => each$1, functions: () => functions$1$1, get: () => get$2, groupBy: () => groupBy_default$1, has: () => has$2, head: () => first$1, identity: () => identity$3, include: () => contains$4, includes: () => contains$4, indexBy: () => indexBy_default$1, indexOf: () => indexOf_default$1, initial: () => initial$1, inject: () => reduce_default$1, intersection: () => intersection$1, invert: () => invert$1, invoke: () => invoke_default$1, isArguments: () => isArguments_default$1, isArray: () => isArray_default$1, isArrayBuffer: () => isArrayBuffer_default$1, isBoolean: () => isBoolean$2, isDataView: () => isDataView_default$1, isDate: () => isDate_default$1, isElement: () => isElement$5, isEmpty: () => isEmpty$1, isEqual: () => isEqual$1, isError: () => isError_default$1, isFinite: () => isFinite$1$1, isFunction: () => isFunction_default$1, isMap: () => isMap_default$1, isMatch: () => isMatch$1, isNaN: () => isNaN$1$1, isNull: () => isNull$2, isNumber: () => isNumber_default$1, isObject: () => isObject$2, isRegExp: () => isRegExp_default$1, isSet: () => isSet_default$1, isString: () => isString_default$1, isSymbol: () => isSymbol_default$1, isTypedArray: () => isTypedArray_default$1, isUndefined: () => isUndefined$2, isWeakMap: () => isWeakMap_default$1, isWeakSet: () => isWeakSet_default$1, iteratee: () => iteratee$1, keys: () => keys$2, last: () => last$1, lastIndexOf: () => lastIndexOf_default$1, map: () => map$2, mapObject: () => mapObject$2, matcher: () => matcher$1, matches: () => matcher$1, max: () => max$3, memoize: () => memoize$2, methods: () => functions$1$1, min: () => min$3, mixin: () => mixin$2, negate: () => negate$1, noop: () => noop$4, now: () => now_default$1, object: () => object$1, omit: () => omit_default$1, once: () => once_default$1, pairs: () => pairs$1, partial: () => partial$1, partition: () => partition_default$1, pick: () => pick_default$1, pluck: () => pluck$1, property: () => property$1, propertyOf: () => propertyOf$1, random: () => random$2, range: () => range$1, reduce: () => reduce_default$1, reduceRight: () => reduceRight_default$1, reject: () => reject$1, rest: () => rest$1, restArguments: () => restArguments$1, result: () => result$1, sample: () => sample$1, select: () => filter$2, shuffle: () => shuffle$1, size: () => size$3, some: () => some$1, sortBy: () => sortBy$1, sortedIndex: () => sortedIndex$1, tail: () => rest$1, take: () => first$1, tap: () => tap$1, template: () => template$1, templateSettings: () => templateSettings_default$1, throttle: () => throttle$1, times: () => times$1, toArray: () => toArray$2, toPath: () => toPath$1$1, transpose: () => unzip$1, unescape: () => unescape_default$1, union: () => union_default$1, uniq: () => uniq$1, unique: () => uniq$1, uniqueId: () => uniqueId$1, unzip: () => unzip$1, values: () => values$1, where: () => where$1, without: () => without_default$1, wrap: () => wrap$2, zip: () => zip_default$1 }), init_modules$1 = __esmMin$1((() => {
  init__setup$1(), init_restArguments$1(), init_isObject$1(), init_isNull$1(), init_isUndefined$1(), init_isBoolean$1(), init_isElement$1(), init_isString$1(), init_isNumber$1(), init_isDate$1(), init_isRegExp$1(), init_isError$1(), init_isSymbol$1(), init_isArrayBuffer$1(), init_isDataView$1(), init_isArray$1(), init_isFunction$1(), init_isArguments$1(), init_isFinite$1(), init_isNaN$1(), init_isTypedArray$1(), init_isEmpty$1(), init_isMatch$1(), init_isEqual$1(), init_isMap$1(), init_isWeakMap$1(), init_isSet$1(), init_isWeakSet$1(), init_keys$1(), init_allKeys$1(), init_values$1(), init_pairs$1(), init_invert$1(), init_functions$1(), init_extend$1(), init_extendOwn$1(), init_defaults$1(), init_create$1(), init_clone$1(), init_tap$1(), init_get$1(), init_has$1(), init_mapObject$1(), init_identity$1(), init_constant$1(), init_noop$1(), init_toPath$1(), init_property$1(), init_propertyOf$1(), init_matcher$1(), init_times$1(), init_random$1(), init_now$1(), init_escape$1(), init_unescape$1(), init_templateSettings$1(), init_template$1(), init_result$1(), init_uniqueId$1(), init_chain$1(), init_iteratee$1(), init_partial$1(), init_bind$1(), init_bindAll$1(), init_memoize$1(), init_delay$1(), init_defer$1(), init_throttle$1(), init_debounce$1(), init_wrap$1(), init_negate$1(), init_compose$1(), init_after$1(), init_before$1(), init_once$1(), init_findKey$1(), init_findIndex$1(), init_findLastIndex$1(), init_sortedIndex$1(), init_indexOf$1(), init_lastIndexOf$1(), init_find$1(), init_findWhere$1(), init_each$1(), init_map$1(), init_reduce$1(), init_reduceRight$1(), init_filter$1(), init_reject$1(), init_every$1(), init_some$1(), init_contains$1(), init_invoke$1(), init_pluck$1(), init_where$1(), init_max$1(), init_min$1(), init_shuffle$1(), init_sample$1(), init_sortBy$1(), init_groupBy$1(), init_indexBy$1(), init_countBy$1(), init_partition$1(), init_toArray$1(), init_size$1(), init_pick$1(), init_omit$1(), init_first$1(), init_initial$1(), init_last$1(), init_rest$1(), init_compact$1(), init_flatten$1(), init_without$1(), init_uniq$1(), init_union$1(), init_intersection$1(), init_difference$1(), init_unzip$1(), init_zip$1(), init_object$1(), init_range$1(), init_chunk$1(), init_mixin$1(), init_underscore_array_methods$1();
})), _$2, init_index_default$1 = __esmMin$1((() => {
  init_modules$1(), _$2 = mixin$2(modules_exports$1), _$2._ = _$2;
})), index_all_exports$1 = __exportAll$1({ VERSION: () => VERSION$1, after: () => after$1, all: () => every$1, allKeys: () => allKeys$1, any: () => some$1, assign: () => extendOwn_default$1, before: () => before$1, bind: () => bind_default$1, bindAll: () => bindAll_default$1, chain: () => chain$3, chunk: () => chunk$1, clone: () => clone$4, collect: () => map$2, compact: () => compact$1, compose: () => compose$1, constant: () => constant$1, contains: () => contains$4, countBy: () => countBy_default$1, create: () => create$2, debounce: () => debounce$2, default: () => _$2, defaults: () => defaults_default$1, defer: () => defer_default$1, delay: () => delay_default$1, detect: () => find$2, difference: () => difference_default$1, drop: () => rest$1, each: () => each$1, escape: () => escape_default$1, every: () => every$1, extend: () => extend_default$1, extendOwn: () => extendOwn_default$1, filter: () => filter$2, find: () => find$2, findIndex: () => findIndex_default$1, findKey: () => findKey$1, findLastIndex: () => findLastIndex_default$1, findWhere: () => findWhere$1, first: () => first$1, flatten: () => flatten$2$1, foldl: () => reduce_default$1, foldr: () => reduceRight_default$1, forEach: () => each$1, functions: () => functions$1$1, get: () => get$2, groupBy: () => groupBy_default$1, has: () => has$2, head: () => first$1, identity: () => identity$3, include: () => contains$4, includes: () => contains$4, indexBy: () => indexBy_default$1, indexOf: () => indexOf_default$1, initial: () => initial$1, inject: () => reduce_default$1, intersection: () => intersection$1, invert: () => invert$1, invoke: () => invoke_default$1, isArguments: () => isArguments_default$1, isArray: () => isArray_default$1, isArrayBuffer: () => isArrayBuffer_default$1, isBoolean: () => isBoolean$2, isDataView: () => isDataView_default$1, isDate: () => isDate_default$1, isElement: () => isElement$5, isEmpty: () => isEmpty$1, isEqual: () => isEqual$1, isError: () => isError_default$1, isFinite: () => isFinite$1$1, isFunction: () => isFunction_default$1, isMap: () => isMap_default$1, isMatch: () => isMatch$1, isNaN: () => isNaN$1$1, isNull: () => isNull$2, isNumber: () => isNumber_default$1, isObject: () => isObject$2, isRegExp: () => isRegExp_default$1, isSet: () => isSet_default$1, isString: () => isString_default$1, isSymbol: () => isSymbol_default$1, isTypedArray: () => isTypedArray_default$1, isUndefined: () => isUndefined$2, isWeakMap: () => isWeakMap_default$1, isWeakSet: () => isWeakSet_default$1, iteratee: () => iteratee$1, keys: () => keys$2, last: () => last$1, lastIndexOf: () => lastIndexOf_default$1, map: () => map$2, mapObject: () => mapObject$2, matcher: () => matcher$1, matches: () => matcher$1, max: () => max$3, memoize: () => memoize$2, methods: () => functions$1$1, min: () => min$3, mixin: () => mixin$2, negate: () => negate$1, noop: () => noop$4, now: () => now_default$1, object: () => object$1, omit: () => omit_default$1, once: () => once_default$1, pairs: () => pairs$1, partial: () => partial$1, partition: () => partition_default$1, pick: () => pick_default$1, pluck: () => pluck$1, property: () => property$1, propertyOf: () => propertyOf$1, random: () => random$2, range: () => range$1, reduce: () => reduce_default$1, reduceRight: () => reduceRight_default$1, reject: () => reject$1, rest: () => rest$1, restArguments: () => restArguments$1, result: () => result$1, sample: () => sample$1, select: () => filter$2, shuffle: () => shuffle$1, size: () => size$3, some: () => some$1, sortBy: () => sortBy$1, sortedIndex: () => sortedIndex$1, tail: () => rest$1, take: () => first$1, tap: () => tap$1, template: () => template$1, templateSettings: () => templateSettings_default$1, throttle: () => throttle$1, times: () => times$1, toArray: () => toArray$2, toPath: () => toPath$1$1, transpose: () => unzip$1, unescape: () => unescape_default$1, union: () => union_default$1, uniq: () => uniq$1, unique: () => uniq$1, uniqueId: () => uniqueId$1, unzip: () => unzip$1, values: () => values$1, where: () => where$1, without: () => without_default$1, wrap: () => wrap$2, zip: () => zip_default$1 }), init_index_all$1 = __esmMin$1((() => {
  init_index_default$1(), init_modules$1();
}));
init_index_all$1();
var nonTupleVectorOperators$1 = [`vector`, `altvector`];
function coerce_tuple_array_vectors$1({ operator1: t4, operator2: n2, operands1: r2, operands2: i2, coerce_tuples_arrays: a2, coerce_vectors: o2 }) {
  let s2 = t4 === n2;
  if (!s2) {
    if (a2) {
      if (t4 === `tuple`) {
        if (nonTupleVectorOperators$1.includes(n2)) t4 = n2, s2 = true;
        else if (n2 === `interval` && r2.length === 2) {
          let n3 = i2[1];
          n3[1] || n3[2] || (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, false, false]]);
        }
      } else if (n2 === `tuple`) {
        if (nonTupleVectorOperators$1.includes(t4)) n2 = t4, s2 = true;
        else if (t4 === `interval` && i2.length === 2) {
          let t5 = r2[1];
          t5[1] || t5[2] || (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, false, false]]);
        }
      }
      if (!s2) {
        if (t4 === `array` && r2.length === 2) {
          if (n2 === `interval`) {
            let n3 = i2[1];
            n3[1] && n3[2] && (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, true, true]]);
          }
        } else if (n2 === `array` && i2.length === 2 && t4 === `interval`) {
          let t5 = r2[1];
          t5[1] && t5[2] && (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, true, true]]);
        }
      }
    }
    !s2 && o2 && nonTupleVectorOperators$1.includes(t4) && nonTupleVectorOperators$1.includes(n2) && (s2 = true, t4 = n2 = `vector`);
  }
  return { operator1: t4, operator2: n2, operands1: r2, operands2: i2 };
}
function handleNaNInfinityStringify$1(t4, n2) {
  return n2 === n2 ? n2 === 1 / 0 ? `1/0` : n2 === -1 / 0 ? `-1/0` : n2 : `0/0`;
}
function handleNaNInfinityParse$1(t4, n2) {
  return n2 === `0/0` ? NaN : n2 === `1/0` ? 1 / 0 : n2 === `-1/0` ? -1 / 0 : n2;
}
function deepClone$1(t4) {
  return JSON.parse(JSON.stringify(t4, handleNaNInfinityStringify$1), handleNaNInfinityParse$1);
}
var equal$1 = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, coerce_tuples_arrays: o2 = true, coerce_vectors: s2 = true } = {}) {
  if (!(Array.isArray(t4) && Array.isArray(n2))) {
    if (typeof t4 != typeof n2) return false;
    if (typeof t4 == `number` && Number.isFinite(t4)) {
      let i3 = 1e-14, o3 = Math.min(Math.abs(t4), Math.abs(n2));
      return a2 ? (i3 *= o3, r2 > i3 && (i3 = r2)) : (r2 > i3 && (i3 = r2), i3 *= o3), Math.abs(t4 - n2) <= i3;
    }
    return t4 === n2;
  }
  var c2 = t4[0], l2 = t4.slice(1), u2 = n2[0], d2 = n2.slice(1);
  return c2 !== u2 && ({ operator1: c2, operator2: u2, operands1: l2, operands2: d2 } = coerce_tuple_array_vectors$1({ operator1: c2, operator2: u2, operands1: l2, operands2: d2, coerce_tuples_arrays: o2, coerce_vectors: s2 })), c2 !== u2 || l2.length !== d2.length ? false : r2 > 0 && !i2 && c2 === `^` ? equal$1(l2[0], d2[0], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 }) ? equal$1(l2[1], d2[1], { coerce_tuples_arrays: o2, coerce_vectors: s2 }) : false : _$2.every(_$2.zip(l2, d2), function(t5) {
    return equal$1(t5[0], t5[1], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 });
  });
}, match$1$1 = function(t4, n2, r2) {
  var i2 = false;
  r2 === void 0 ? r2 = {} : r2.allow_extended_match && (i2 = true, r2 = Object.assign({}, r2), delete r2.allow_extended_match);
  var a2 = r2.variables;
  if (a2 === void 0) {
    a2 = {};
    let t5 = variables$1(n2);
    for (let n3 = 0; n3 < t5.length; n3++) a2[t5[n3]] = true;
    r2 = Object.assign({}, r2), r2.variables = a2;
  }
  if (n2 in a2) {
    let r3 = a2[n2];
    if (r3 !== true) if (r3 instanceof RegExp) {
      if (typeof t4 == `string`) {
        if (!t4.match(r3)) return false;
      } else if (!JSON.stringify(t4).match(r3)) return false;
    } else if (typeof a2[n2] == `function`) {
      if (!a2[n2](t4)) return false;
    } else return false;
    let i3 = {};
    return i3[n2] = t4, i3;
  }
  if (r2.allow_permutations && (t4 = default_order$1(t4), n2 = default_order$1(n2)), !Array.isArray(n2)) return t4 === n2 ? {} : false;
  var o2 = allChildren$1(t4), s2 = n2[0], c2 = n2.slice(1);
  if (!Array.isArray(t4) || t4[0] !== s2 || o2.length < c2.length) {
    if (Array.isArray(r2.allow_implicit_identities)) {
      let i3 = matchImplicitIdentity$1(t4, n2, r2);
      if (i3) return i3;
    }
    if (s2 === `*` && Array.isArray(t4) && t4[0] === `-` && Array.isArray(t4[1]) && t4[1][0] === `*`) o2 = allChildren$1(t4[1]), o2[0] = [`-`, o2[0]];
    else return false;
  }
  return matchOperands$1(s2, o2, c2, r2, i2) || (Array.isArray(r2.allow_implicit_identities) ? matchImplicitIdentity$1([s2].concat(o2), n2, r2) : false);
};
function matchOperands$1(t4, n2, r2, i2, a2) {
  var o2 = r2.map((t5) => ({})), s2 = r2.length, c2 = false;
  i2.allow_permutations && (t4 === `*` ? c2 = ![...n2, ...r2].some((t5) => [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t5[0])) : (t4 === `+` || t4 === `=` || t4 === `and` || t4 === `or` || t4 === `ne` || t4 === `union` || t4 === `intersect`) && (c2 = true));
  function l2(u3, d3, p2) {
    let m2 = 1, h2 = 1;
    (is_associative$1$1[t4] || [`tuple`, `vector`, `altvector`].includes(t4)) && (m2 = u3.length - (s2 - d3 - 1), h2 = u3.length), i2.max_group !== void 0 && (m2 = i2.max_group < m2 ? i2.max_group : m2), i2.max_last_group !== void 0 && (h2 = i2.max_last_group < h2 ? i2.max_last_group : h2);
    let g2;
    if (!a2 && d3 === s2 - 1) if (u3.length <= h2) g2 = [u3];
    else return false;
    else if (c2) g2 = subsets$1(u3, m2);
    else {
      g2 = [];
      for (let t5 = 1; t5 <= m2; t5++) g2.push(u3.slice(0, t5));
    }
    for (let a3 of g2) {
      let c3 = o2[d3][a3];
      if (c3 === void 0) {
        let s3 = a3.reduce(function(t5, r3) {
          return t5.concat([n2[r3]]);
        }, []);
        s3 = s3.length > 1 ? [t4].concat(s3) : s3[0], c3 = match$1$1(s3, r2[d3], i2), o2[d3][a3] = c3;
      }
      if (!c3 || !_$2.every(_$2.intersection(Object.keys(p2), Object.keys(c3)), function(t5) {
        return equal$1(p2[t5], c3[t5]);
      })) continue;
      let m3 = Object.assign({}, c3);
      Object.assign(m3, p2);
      let h3 = u3.filter((t5) => !a3.includes(t5));
      if (d3 === s2 - 1) return { matches: m3, skipped: h3.reduce(function(t5, r3) {
        return t5.concat([n2[r3]]);
      }, []) };
      let g3 = l2(h3, d3 + 1, m3);
      if (g3) return g3;
    }
    return false;
  }
  var u2 = {}, d2 = [...Array(n2.length).keys()];
  if (c2) {
    let t5 = l2(d2, 0, {});
    return t5 ? (u2 = t5.matches, t5.skipped.length > 0 && (u2._skipped = t5.skipped), u2) : false;
  } else {
    let t5 = a2 ? n2.length - s2 : 0, r3 = [], i3;
    for (let a3 = 0; a3 <= t5 && (i3 = l2(d2, 0, {}), !i3); a3++) d2 = d2.slice(1), r3.push(n2[a3]);
    return i3 ? (u2 = i3.matches, i3.skipped.length > 0 && (u2._skipped = i3.skipped), r3.length > 0 && (u2._skipped_before = r3), u2) : false;
  }
}
function matchImplicitIdentity$1(t4, n2, r2) {
  var i2 = n2[0], a2 = n2.slice(1);
  if (!(i2 === `+` || i2 === `*` || i2 === `^`)) return false;
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) {
    let n3 = a2[t5];
    typeof n3 == `string` && r2.allow_implicit_identities.includes(n3) && o2.push(n3);
  }
  if (o2.length === 0) return false;
  for (let i3 of o2) {
    let a3 = match_one_implicit_identity$1(t4, n2, r2, i3);
    if (a3) return a3;
  }
  return false;
}
function match_one_implicit_identity$1(t4, n2, r2, i2) {
  var a2 = n2[0], o2 = n2.slice(1), s2 = {};
  a2 === `+` ? s2[i2] = 0 : s2[i2] = 1, a2 === `*` && o2.includes(i2) && Array.isArray(t4) && t4[0] === `-` && (s2[i2] = -1, t4 = t4[1]);
  var c2 = o2.indexOf(i2);
  if (o2.splice(c2, 1), a2 === `^` && c2 === 0) return false;
  n2 = o2.length === 1 ? o2[0] : [a2].concat(o2);
  var l2 = match$1$1(t4, n2, r2);
  if (l2) {
    if (i2 in l2 && !equal$1(l2[i2], s2[i2])) return false;
    Object.assign(s2, l2);
  } else return false;
  return s2;
}
var substitute$1$1 = function(t4, n2) {
  return typeof t4 == `number` || typeof t4 == `boolean` ? t4 : typeof t4 == `string` ? n2[t4] === void 0 ? t4 : deepClone$1(n2[t4]) : Array.isArray(t4) ? [t4[0]].concat(t4.slice(1).map(function(t5) {
    return substitute$1$1(t5, n2);
  })) : [];
}, transform$1 = function(t4, n2) {
  if (Array.isArray(t4)) {
    let r2 = [t4[0]];
    for (let i2 = 1; i2 < t4.length; i2++) r2.push(transform$1(t4[i2], n2));
    return n2(r2);
  }
  return n2(t4);
}, applyAllTransformations$1 = function(t4, n2, r2) {
  r2 === void 0 && (r2 = 5);
  for (var i2 = t4, a2; r2 > 0; r2--) {
    a2 = i2;
    for (let t5 = 0; t5 < n2.length; t5++) {
      let r3 = n2[t5][0], a3 = n2[t5][1], o2 = n2[t5][2];
      o2 === void 0 && (o2 = {}), i2 = transform$1(i2, function(t6) {
        let n3 = match$1$1(t6, r3, o2);
        if (n3) {
          let t7 = substitute$1$1(a3, n3), i3 = o2.assumptions ? substitute$1$1(o2.assumptions, n3) : void 0;
          o2.evaluate_numbers && (t7 = evaluate_numbers$1(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 }));
          let s2 = [], c2 = [];
          return n3._skipped && (s2 = n3._skipped), n3._skipped_before && (c2 = n3._skipped_before), (c2.length > 0 || s2.length > 0) && (Array.isArray(t7) && (t7 = t7[0] === r3[0] ? t7.slice(1) : [t7]), t7 = [r3[0]].concat(c2, t7, s2)), o2.evaluate_numbers && (t7 = evaluate_numbers$1(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 })), t7;
        } else return t6;
      });
    }
    if (equal$1(a2, i2)) return i2;
  }
  return i2;
}, math$1 = mathjs_default$1, operators$2$1 = { "+": function(t4) {
  return t4.length === 1 ? t4[0] : new math$1.OperatorNode(`+`, `add`, t4);
}, "*": function(t4) {
  return new math$1.OperatorNode(`*`, `multiply`, t4);
}, "/": function(t4) {
  return new math$1.OperatorNode(`/`, `divide`, t4);
}, "-": function(t4) {
  return new math$1.OperatorNode(`-`, `unaryMinus`, [t4[0]]);
}, "^": function(t4) {
  return new math$1.OperatorNode(`^`, `pow`, t4);
}, vector: function(t4) {
  return new math$1.ArrayNode(t4);
}, altvector: function(t4) {
  return new math$1.ArrayNode(t4);
}, and: function(t4) {
  return new math$1.OperatorNode(`and`, `and`, t4);
}, or: function(t4) {
  return new math$1.OperatorNode(`or`, `or`, t4);
}, not: function(t4) {
  return new math$1.OperatorNode(`not`, `not`, [t4[0]]);
}, "<": function(t4) {
  return new math$1.OperatorNode(`<`, `smaller`, t4);
}, ">": function(t4) {
  return new math$1.OperatorNode(`>`, `larger`, t4);
}, le: function(t4) {
  return new math$1.OperatorNode(`<=`, `smallerEq`, t4);
}, ge: function(t4) {
  return new math$1.OperatorNode(`>=`, `largerEq`, t4);
}, ne: function(t4) {
  return new math$1.OperatorNode(`!=`, `unequal`, t4);
}, binom: function(t4) {
  let n2 = new math$1.SymbolNode(`combinations`);
  return new math$1.FunctionNode(n2, t4);
} }, functionConversions$1 = { nCr: `combinations`, nPr: `permutations`, binom: `combinations` }, astToMathjs$2$1 = class astToMathjs$23 {
  constructor({ mathjs: t4 = null } = {}) {
    t4 && (math$1 = t4);
  }
  convert(t4) {
    if (typeof t4 == `number`) return Number.isFinite(t4) ? new math$1.ConstantNode(t4) : Number.isNaN(t4) ? new math$1.SymbolNode(`NaN`) : t4 < 0 ? operators$2$1[`-`]([new math$1.SymbolNode(`Infinity`)]) : new math$1.SymbolNode(`Infinity`);
    if (typeof t4 == `string`) return new math$1.SymbolNode(t4);
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to mathjs`);
      if (r2[0] === `factorial`) return new math$1.OperatorNode(`!`, `factorial`, [this.convert(r2[1])]);
      let t5 = functionConversions$1[r2[0]];
      t5 ||= r2[0];
      let n3 = new math$1.SymbolNode(t5), i2 = r2[1], a2;
      return a2 = i2[0] === `tuple` ? i2.slice(1).map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)) : [this.convert(i2)], r2[0] === `count` && (a2.length > 2 || !(a2[0] instanceof math$1.ArrayNode)) && (a2 = [new math$1.ArrayNode(a2)]), new math$1.FunctionNode(n3, a2);
    }
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = t5.slice(1).map((function(t6, n3) {
        return this.convert(t6);
      }).bind(this)), o2 = [];
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? o2.push(new math$1.OperatorNode(`<`, `smaller`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math$1.OperatorNode(`>`, `larger`, a2.slice(r3 - 1, r3 + 1))) : n2 === `lts` ? o2.push(new math$1.OperatorNode(`<=`, `smallerEq`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math$1.OperatorNode(`>=`, `largerEq`, a2.slice(r3 - 1, r3 + 1)));
      let s2 = new math$1.OperatorNode(`and`, `and`, o2.slice(0, 2));
      for (let t6 = 2; t6 < o2.length; t6++) s2 = new math$1.OperatorNode(`and`, `and`, [s2, o2[t6]]);
      return s2;
    }
    if (n2 === `=`) {
      let t5 = r2.map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)), n3 = [];
      for (let r3 = 1; r3 < t5.length; r3++) n3.push(new math$1.OperatorNode(`==`, `equal`, t5.slice(r3 - 1, r3 + 1)));
      if (n3.length === 1) return n3[0];
      let i2 = new math$1.OperatorNode(`and`, `and`, n3.slice(0, 2));
      for (let t6 = 2; t6 < n3.length; t6++) i2 = new math$1.OperatorNode(`and`, `and`, [i2, n3[t6]]);
      return i2;
    }
    if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
      let t5, i2;
      if (n2 === `in` || n2 === `notin` ? (t5 = r2[0], i2 = r2[1]) : (t5 = r2[1], i2 = r2[0]), typeof t5 != `number` && typeof t5 != `string`) throw Error(`Set membership non-string variables not implemented for conversion to mathjs`);
      if (t5 = this.convert(t5), i2[0] !== `interval`) throw Error(`Set membership in non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let s2 = this.convert(a2[1]), c2 = this.convert(a2[2]), l2 = [];
      o2[1] ? l2.push(new math$1.OperatorNode(`>=`, `largerEq`, [t5, s2])) : l2.push(new math$1.OperatorNode(`>`, `larger`, [t5, s2])), o2[2] ? l2.push(new math$1.OperatorNode(`<=`, `smallerEq`, [t5, c2])) : l2.push(new math$1.OperatorNode(`<`, `smaller`, [t5, c2]));
      let u2 = new math$1.OperatorNode(`and`, `and`, l2);
      return (n2 === `notin` || n2 === `notni`) && (u2 = new math$1.OperatorNode(`not`, `not`, [u2])), u2;
    }
    if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
      let t5, i2;
      if (n2 === `subset` || n2 === `notsubset` ? (i2 = r2[0], t5 = r2[1]) : (i2 = r2[1], t5 = r2[0]), i2[0] !== `interval` || t5[0] !== `interval`) throw Error(`Set containment of non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2], s2 = t5[1], c2 = t5[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple` || s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let l2 = this.convert(a2[1]), u2 = this.convert(a2[2]), d2 = this.convert(s2[1]), p2 = this.convert(s2[2]), m2 = [];
      o2[1] && !c2[1] ? m2.push(new math$1.OperatorNode(`>`, `larger`, [l2, d2])) : m2.push(new math$1.OperatorNode(`>=`, `largerEq`, [l2, d2])), o2[2] && !c2[2] ? m2.push(new math$1.OperatorNode(`<`, `smaller`, [u2, p2])) : m2.push(new math$1.OperatorNode(`<=`, `smallerEq`, [u2, p2]));
      let h2 = new math$1.OperatorNode(`and`, `and`, m2);
      return (n2 === `notsubset` || n2 === `notsuperset`) && (h2 = new math$1.OperatorNode(`not`, `not`, [h2])), h2;
    }
    if (n2 === `matrix`) {
      let t5 = r2[0], n3 = t5[1], i2 = t5[2], a2 = r2[1];
      if (!Number.isInteger(n3) || !Number.isInteger(i2)) throw Error(`Matrix must have integer dimensions`);
      let o2 = [];
      for (let t6 = 1; t6 <= n3; t6++) {
        let n4 = [];
        for (let r3 = 1; r3 <= i2; r3++) n4.push(this.convert(a2[t6][r3]));
        o2.push(new math$1.ArrayNode(n4));
      }
      return new math$1.ArrayNode(o2);
    }
    if (n2 === `array`) {
      let t5 = r2.map((t6) => this.convert(t6));
      return new math$1.ArrayNode(t5);
    }
    if (n2 in operators$2$1) return operators$2$1[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, require_sieve$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    for (var n3 = Array(t5), r2 = 0; r2 < t5; r2++) n3[r2] = true;
    for (var r2 = 2; r2 < Math.sqrt(t5); r2++) for (var i2 = r2 * r2; i2 < t5; i2 += r2) n3[i2] = false;
    for (var a2 = [], r2 = 2; r2 < t5; r2++) n3[r2] && a2.push(r2);
    return a2;
  };
})), require_factor$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_sieve$1(), i2 = r2(1e5);
  n2.exports = function(t5) {
    (!i2 || i2[i2.length - 1] < t5) && (i2 = r2(t5));
    for (var n3 = [], a2 = 0; a2 < i2.length && t5 > 1; a2++) {
      var o2 = i2[a2];
      if (t5 % o2 === 0) {
        for (var s2 = { prime: o2, power: 0 }; t5 % o2 === 0; ) s2.power++, t5 /= o2;
        n3.push(s2);
      }
    }
    return t5 > 1 && n3.push({ prime: t5, power: 1 }), n3;
  };
})), require_inc_mixed$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5, n3) {
    var r2 = t5.map(function(t6) {
      return t6;
    });
    r2[0]++;
    for (var i2 = 0; i2 < t5.length && !(r2[i2] <= n3[i2]); i2++) i2 === t5.length - 1 ? r2[i2] = 0 : (r2[i2] = 0, r2[i2 + 1]++);
    return r2;
  };
})), require_divisors$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_factor$1(), i2 = require_inc_mixed$1();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), a2 = n3.map(function(t6) {
      return 0;
    }), o2 = n3.map(function(t6) {
      return t6.power;
    }), s2 = [1]; ; ) {
      a2 = i2(a2, o2);
      var c2 = a2.map(function(t6, r3) {
        return n3[r3].prime ** +t6;
      }).reduce(function(t6, n4) {
        return t6 * n4;
      }, 1);
      if (c2 === 1) break;
      s2.push(c2);
    }
    return s2.sort(function(t6, n4) {
      return parseInt(t6) - parseInt(n4);
    }), s2;
  };
})), require_prime_factors$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_factor$1();
  n2.exports = function(t5) {
    return r2(t5).map(function(t6) {
      return t6.prime;
    });
  };
})), require_euler_phi$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_prime_factors$1();
  n2.exports = function(t5) {
    var n3 = function(t6) {
      return t6.reduce(function(t7, n4) {
        return t7 * n4;
      }, 1);
    }, i2 = r2(t5), a2 = n3(i2.map(function(t6) {
      return t6 - 1;
    })), o2 = n3(i2);
    return t5 * a2 / o2;
  };
})), require_gcd$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5, n3) {
    for (t5 < 0 && (t5 = -t5), n3 < 0 && (n3 = -n3); ; ) {
      if (n3 === 0) return t5;
      if (t5 %= n3, t5 === 0) return n3;
      n3 %= t5;
    }
  };
})), require_find_divisor$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_gcd$1();
  n2.exports = function(t5) {
    for (var n3 = 2 * Math.floor(Math.sqrt(Math.sqrt(t5))), i2 = 2, a2 = i2, o2, s2 = 1; s2 < n3; s2++) if (i2 = (i2 * i2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, o2 = r2(a2 - i2, t5), o2 != 1) return o2;
    return 1;
  };
})), require_inverse_mod$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5, n3) {
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0, i2 = 1, a2 = n3, o2 = t5; o2 !== 0; ) {
      var s2 = Math.floor(a2 / o2), c2 = r2;
      r2 = i2, i2 = c2 - s2 * i2;
      var l2 = a2;
      a2 = o2, o2 = l2 - s2 * o2;
    }
    return a2 > 1 ? NaN : r2 > 0 ? r2 : r2 + n3;
  };
})), require_is_abundant$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_divisors$1();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 < n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_deficient$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_divisors$1();
  n2.exports = function(t5) {
    if (t5 === 1) return true;
    var n3 = r2(t5);
    return n3.pop(), t5 > n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_heptagonal$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(40 * t5 + 9) + 3) / 10 % 1 == 0;
  };
})), require_is_hexagonal$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(8 * t5 + 1) + 1) / 4 % 1 == 0;
  };
})), require_is_octagonal$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(3 * t5 + 1) + 1) / 3 % 1 == 0;
  };
})), require_is_pentagonal$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(24 * t5 + 1) + 1) / 6 % 1 == 0;
  };
})), require_is_perfect$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_divisors$1();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 === n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_prime$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_factor$1();
  n2.exports = function(t5) {
    var n3 = r2(t5);
    return n3.length == 1 ? n3[0].power === 1 : false;
  };
})), require_multiply_mod$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5, n3, r2) {
    if (t5 < 94906265 && n3 < 94906265) return t5 * n3 % r2;
    var i2 = 0, a2 = r2 / 2;
    t5 >= r2 && (t5 %= r2), n3 >= r2 && (n3 %= r2);
    for (var o2 = 0; o2 < 53; o2++) i2 = i2 >= a2 ? 2 * i2 - r2 : 2 * i2, t5 >= 4503599627370496 && (i2 += n3, t5 -= 4503599627370495), i2 > r2 && (i2 -= r2), t5 *= 2;
    return i2;
  };
})), require_power_mod$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_multiply_mod$1(), i2 = require_inverse_mod$1();
  n2.exports = function t5(n3, a2, o2) {
    if (a2 < 0) return i2(t5(n3, -a2, o2), o2);
    var s2 = 1;
    for (n3 %= o2; a2 > 0; ) a2 % 2 == 1 && (s2 = r2(s2, n3, o2), --a2), a2 /= 2, n3 = r2(n3, n3, o2);
    return s2;
  };
})), require_miller$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_multiply_mod$1(), i2 = require_power_mod$1();
  n2.exports = function(t5) {
    if (t5 < 2) return false;
    if (t5 == 2 || t5 == 3) return true;
    if (!(t5 & 1) || t5 % 3 == 0) return false;
    for (var n3 = t5 - 1, a2 = 0; n3 % 2 == 0; ) n3 /= 2, a2 += 1;
    for (var o2 = t5 < 1373653 ? [2, 3] : t5 < 9080191 ? [31, 73] : t5 < 4759123141 ? [2, 7, 61] : t5 < 1122004669633 ? [2, 13, 23, 1662803] : t5 < 2152302898747 ? [2, 3, 5, 7, 11] : t5 < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17], s2 = 0; s2 < o2.length; s2++) {
      for (var c2 = o2[s2], l2 = i2(c2, n3, t5), u2 = 0, d2 = a2; d2 > 0; ) {
        if (u2 = r2(l2, l2, t5), u2 === 1 && l2 !== 1 && l2 !== t5 - 1) return false;
        l2 = u2, --d2;
      }
      if (u2 !== 1) return false;
    }
    return true;
  };
})), require_is_square$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(t5) % 1 == 0;
  };
})), require_is_triangular$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(8 * t5 + 1) % 1 == 0;
  };
})), require_jacobi_symbol$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = function(t5, n3) {
    if (n3 % 2 == 0 || n3 < 0) return NaN;
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0; ; ) {
      if (t5 %= n3, t5 === 0) return 0;
      for (; t5 % 2 == 0; ) r2 ^= (n3 % 8 * (n3 % 8) - 1) / 8, t5 /= 2;
      if (t5 == 1) return r2 & 1 ? -1 : 1;
      r2 ^= (t5 % 4 - 1) * (n3 % 4 - 1) / 4;
      var i2 = t5;
      t5 = n3, n3 = i2;
    }
    return NaN;
  };
})), require_log_mod$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_power_mod$1(), i2 = require_multiply_mod$1(), a2 = {};
  n2.exports = function(t5, n3, o2) {
    t5 = (t5 % o2 + o2) % o2;
    var s2 = Math.ceil(Math.sqrt(o2)), c2 = {};
    if (a2[o2] === void 0 && (a2[o2] = {}), a2[o2][n3] === void 0) {
      a2[o2][n3] = {}, c2 = a2[o2][n3];
      for (var l2 = 0; l2 < s2; l2++) c2[r2(n3, l2, o2)] = l2;
    } else c2 = a2[o2][n3];
    for (var u2 = r2(n3, -s2, o2), d2 = t5, p2 = 0; p2 < s2; p2++) if (c2[d2] !== void 0) return (i2(p2, s2, o2) + c2[d2]) % o2;
    else d2 = i2(d2, u2, o2);
    return NaN;
  };
})), require_primitive_root$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = (init_index_all$1(), __toCommonJS$1(index_all_exports$1)), i2 = require_euler_phi$1(), a2 = require_prime_factors$1(), o2 = require_power_mod$1();
  n2.exports = function(t5) {
    for (var n3 = i2(t5), s2 = a2(n3), c2 = 2; c2 < t5; c2++) if (r2.every(s2, function(r3) {
      return o2(c2, n3 / r3, t5) != 1;
    })) return c2;
    return NaN;
  };
})), require_quadratic_nonresidue$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_jacobi_symbol$1();
  n2.exports = function(t5) {
    for (var n3 = 2; n3 < t5; n3++) if (r2(n3, t5) == -1) return n3;
    return NaN;
  };
})), require_random_primitive_root$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_primitive_root$1(), i2 = require_euler_phi$1(), a2 = require_gcd$1(), o2 = require_power_mod$1();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), s2 = i2(t5), c2 = 0; c2 < 100; c2++) {
      var l2 = Math.floor(Math.random() * s2);
      if (a2(l2, s2) == 1) return o2(n3, l2, t5);
    }
    return n3;
  };
})), require_square_root_mod_prime$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_jacobi_symbol$1(), i2 = require_power_mod$1(), a2 = require_quadratic_nonresidue$1();
  n2.exports = function(t5, n3) {
    if (r2(t5, n3) != 1) return NaN;
    for (var o2 = n3 - 1, s2 = 0; o2 % 2 == 0; ) o2 /= 2, s2++;
    if (n3 % 4 == 3) return i2(t5, (n3 + 1) / 4, n3);
    for (var c2 = i2(a2(n3), o2, n3), l2 = i2(t5, (o2 + 1) / 2, n3), u2 = i2(t5, o2, n3), d2 = s2; ; ) {
      if (u2 % n3 == 1) return l2;
      for (var p2 = u2, m2 = 1; m2 < d2 && (p2 = p2 * p2 % n3, p2 != 1); m2++) ;
      var h2 = m2;
      m2++;
      for (var g2 = c2; m2 < d2; ) g2 = g2 * g2 % n3, m2++;
      d2 = h2, l2 = l2 * g2 % n3, u2 = u2 * g2 * g2 % n3, c2 = g2 * g2 % n3;
    }
    return NaN;
  };
})), require_square_root_mod$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = (init_index_all$1(), __toCommonJS$1(index_all_exports$1)), i2 = require_factor$1(), a2 = require_square_root_mod_prime$1(), o2 = require_jacobi_symbol$1(), s2 = require_inverse_mod$1(), c2 = require_multiply_mod$1();
  n2.exports = function(t5, n3) {
    var l2 = 1, u2 = [0];
    return i2(n3).forEach(function(n4) {
      var i3 = n4.prime, d2 = n4.power, p2 = a2(t5, i3), m2 = [];
      if (o2(t5, i3) != 1) return [];
      u2.forEach(function(t6) {
        m2.unshift(t6 * i3 * s2(i3, l2) + p2 * l2 * s2(l2, i3)), m2.unshift(t6 * i3 * s2(i3, l2) - p2 * l2 * s2(l2, i3));
      }), m2.sort(), u2 = r2.unique(m2), l2 *= i3;
      var h2 = 1;
      for (d2--; d2 > 0; ) {
        var g2 = i3 ** +Math.min(h2, d2);
        d2 -= Math.min(h2, d2), u2 = u2.map(function(n5) {
          var r3 = -((n5 * n5 - t5) / l2), i4 = s2(2 * n5, g2);
          return n5 + l2 * c2(r3, i4, g2);
        }), l2 *= g2;
      }
    }), u2.map(function(t6) {
      return (t6 % n3 + n3) % n3;
    });
  };
})), require_number_theory$1 = __commonJSMin$1(((t4, n2) => {
  n2.exports = { divisors: require_divisors$1(), eulerPhi: require_euler_phi$1(), factor: require_factor$1(), findDivisor: require_find_divisor$1(), gcd: require_gcd$1(), incMixed: require_inc_mixed$1(), inverseMod: require_inverse_mod$1(), isAbundant: require_is_abundant$1(), isDeficient: require_is_deficient$1(), isHeptagonal: require_is_heptagonal$1(), isHexagonal: require_is_hexagonal$1(), isOctagonal: require_is_octagonal$1(), isPentagonal: require_is_pentagonal$1(), isPerfect: require_is_perfect$1(), isPrime: require_is_prime$1(), isProbablyPrime: require_miller$1(), isSquare: require_is_square$1(), isTriangular: require_is_triangular$1(), jacobiSymbol: require_jacobi_symbol$1(), logMod: require_log_mod$1(), miller: require_miller$1(), multiplyMod: require_multiply_mod$1(), powerMod: require_power_mod$1(), primeFactors: require_prime_factors$1(), primitiveRoot: require_primitive_root$1(), quadraticNonresidue: require_quadratic_nonresidue$1(), randomPrimitiveRoot: require_random_primitive_root$1(), sieve: require_sieve$1(), squareRootMod: require_square_root_mod$1(), squareRootModPrime: require_square_root_mod_prime$1(), totient: require_euler_phi$1() };
})), import_number_theory$1 = __toESM$1(require_number_theory$1());
function gcd$2$1(t4, n2) {
  return Number.isNaN(t4) || Number.isNaN(n2) ? NaN : import_number_theory$1.default.gcd(t4, n2);
}
function flatten$1$1(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.concat(n2);
  }, []);
}
function positiveModulo$1(t4, n2) {
  return (t4 % n2 + n2) % n2;
}
var ZmodN$1 = class t22 {
  constructor(t4, n2, r2 = false) {
    this.values = t4.map(function(t5) {
      return positiveModulo$1(t5, n2);
    }), this.modulus = n2, this.approximate = r2;
  }
  apply(n2, r2, i2) {
    if (i2 == null || Number.isNaN(i2)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(n2.modulus)) return new t22([NaN], NaN, this.approximate || n2.approximate);
      i2 = gcd$2$1(this.modulus, n2.modulus);
    }
    return new t22(flatten$1$1(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        return Number.isNaN(t4) || Number.isNaN(n3) ? NaN : (i2 + r2(t4, n3)) % i2;
      });
    })), i2, this.approximate || n2.approximate);
  }
  add(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 + n2;
    });
  }
  power(n2) {
    var r2 = this.modulus;
    return n2.modulus == import_number_theory$1.default.eulerPhi(r2) ? this.apply(n2, function(t4, n3) {
      return import_number_theory$1.default.powerMod(t4, n3, r2);
    }, r2) : new t22([NaN], NaN, this.approximate || n2.approximate);
  }
  isNaN() {
    for (var t4 of this.values) if (isNaN(t4)) return true;
    return false;
  }
  subtract(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 - n2;
    });
  }
  multiply(t4) {
    var n2 = gcd$2$1(this.modulus, t4.modulus);
    return this.apply(t4, function(t5, r2) {
      return import_number_theory$1.default.multiplyMod(t5, r2, n2);
    });
  }
  inverse() {
    var n2 = this.modulus;
    return new t22(this.values.map(function(t4) {
      return import_number_theory$1.default.inverseMod(t4, n2);
    }), this.modulus, this.approximate);
  }
  negate() {
    var n2 = this.modulus;
    return new t22(this.values.map(function(t4) {
      return n2 - t4;
    }), this.modulus, this.approximate);
  }
  divide(n2) {
    var r2 = gcd$2$1(this.modulus, n2.modulus);
    return new t22(flatten$1$1(flatten$1$1(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        if (t4 % n3 == 0) return [t4 / n3];
        var i2 = gcd$2$1(n3, r2);
        if (t4 % i2 != 0) return [];
        var a2 = n3 / i2, o2 = t4 / i2, s2 = import_number_theory$1.default.multiplyMod(o2, import_number_theory$1.default.inverseMod(a2, r2), r2), c2 = [], l2;
        for (l2 = 0; l2 < i2; l2++) c2.unshift(s2 + import_number_theory$1.default.multiplyMod(l2, r2 / i2, r2));
        return c2;
      });
    }))), r2, this.approximate || n2.approximate);
  }
  sqrt() {
    var n2 = this.modulus;
    return new t22(flatten$1$1(this.values.map(function(t4) {
      return import_number_theory$1.default.squareRootMod(t4, n2);
    })), this.modulus, this.approximate);
  }
  toString = function() {
    return `{` + this.values.sort().toString() + `}/` + this.modulus.toString();
  };
  equals(t4) {
    return this.toString() == t4.toString();
  }
}, PRIME$1 = 10739999, levelFunctions$1 = { "+": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.add(n2);
  });
}, "*": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.multiply(n2);
  });
}, "/": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.divide(n2);
  });
}, "-": function(t4) {
  return t4[0].negate();
}, "~": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.subtract(n2);
  }, new ZmodN$1([0], t4[0].modulus));
}, factorial: function(t4) {
  return ZmodN$1([NaN], 1);
}, gamma: function(t4) {
  return ZmodN$1([NaN], 1);
} };
function rationalApproximation$1(t4, n2 = 1e15) {
  let r2 = [[1, 0], [0, 1]], i2;
  for (; r2[1][0] * (i2 = Math.floor(t4)) + r2[1][1] <= n2; ) {
    let n3;
    if (n3 = r2[0][0] * i2 + r2[0][1], r2[0][1] = r2[0][0], r2[0][0] = n3, n3 = r2[1][0] * i2 + r2[1][1], r2[1][1] = r2[1][0], r2[1][0] = n3, t4 == i2 || (t4 = 1 / (t4 - i2), t4 > 2147483647)) break;
  }
  let a2 = r2[1][0] * i2 + r2[1][1] > n2;
  return { numerator: r2[0][0], denominator: r2[1][0], approximate: a2 };
}
function finite_field_evaluate_ast$1(t4, n2, r2, i2) {
  if (typeof t4 == `string`) return t4 === `e` ? new ZmodN$1([import_number_theory$1.default.primitiveRoot(r2)], r2) : t4 === `pi` ? r2 % 2 == 0 ? new ZmodN$1([r2 / 2], r2) : new ZmodN$1([NaN], r2) : t4 === `i` ? new ZmodN$1([0], 1) : t4 in n2 ? new ZmodN$1([n2[t4]], r2) : t4;
  if (typeof t4 == `number`) {
    if (Number.isInteger(t4)) return new ZmodN$1([t4], r2);
    {
      let n3 = rationalApproximation$1(t4), i3 = new ZmodN$1([n3.numerator], r2, n3.approximate), a3 = new ZmodN$1([n3.denominator], r2, n3.approximate);
      return i3.divide(a3);
    }
  }
  var a2 = t4[0], o2 = t4.slice(1);
  if (a2 === `apply`) {
    if (typeof o2[0] != `string`) throw Error(`Non string functions not implemented for finite fields`);
    if (o2[0] === `exp`) {
      var s2 = finite_field_evaluate_ast$1(`e`, {}, r2), c2 = finite_field_evaluate_ast$1(o2[1], n2, import_number_theory$1.default.eulerPhi(r2));
      return s2.power(c2);
    }
    if (o2[0] === `sec`) return finite_field_evaluate_ast$1([`/`, 1, [`apply`, `cos`, o2[1]]], n2, r2);
    if (o2[0] === `csc`) return finite_field_evaluate_ast$1([`/`, 1, [`apply`, `sin`, o2[1]]], n2, r2);
    if (o2[0] === `cot`) return finite_field_evaluate_ast$1([`/`, 1, [`apply`, `tan`, o2[1]]], n2, r2);
    if (o2[0] === `tan`) {
      var l2 = import_number_theory$1.default.eulerPhi(r2);
      return finite_field_evaluate_ast$1([`/`, [`apply`, `sin`, o2[1]], [`apply`, `cos`, o2[1]]], n2, r2);
    }
    if (o2[0] === `sin`) {
      var u2 = import_number_theory$1.default.primitiveRoot(r2), d2 = new ZmodN$1([u2], r2), l2 = import_number_theory$1.default.eulerPhi(r2);
      if (l2 % 4 != 0) return new ZmodN$1([NaN], r2);
      var p2 = new ZmodN$1([import_number_theory$1.default.powerMod(u2, l2 / 4, r2)], r2), m2 = finite_field_evaluate_ast$1(o2[1], n2, l2);
      return d2.power(m2).subtract(d2.power(m2.negate())).divide(p2.add(p2));
    }
    if (o2[0] === `cos`) {
      var d2 = new ZmodN$1([import_number_theory$1.default.primitiveRoot(r2)], r2), m2 = finite_field_evaluate_ast$1(o2[1], n2, import_number_theory$1.default.eulerPhi(r2));
      return d2.power(m2).add(d2.power(m2.negate())).divide(new ZmodN$1([2], r2));
    }
    if (o2[0] === `log`) return new ZmodN$1([NaN], NaN);
    if (o2[0] === `sqrt`) return finite_field_evaluate_ast$1(o2[1], n2, r2).sqrt();
    if (o2[0] === `abs`) {
      let t5 = finite_field_evaluate_ast$1(o2[1], n2, r2);
      return t5.multiply(t5).sqrt();
    }
  }
  if (a2 == `^`) {
    var s2 = finite_field_evaluate_ast$1(o2[0], n2, r2), c2 = finite_field_evaluate_ast$1(o2[1], n2, import_number_theory$1.default.eulerPhi(r2));
    return s2.power(c2);
  }
  return a2 in levelFunctions$1 ? levelFunctions$1[a2](o2.map(function(t5, a3) {
    return finite_field_evaluate_ast$1(t5, n2, r2);
  })) : new ZmodN$1([NaN], r2);
}
var astToFiniteField$1$1 = class astToFiniteField$13 {
  constructor() {
  }
  convert(t4, n2, r2 = PRIME$1) {
    return finite_field_evaluate_ast$1(t4, n2, r2);
  }
}, evaluation_exports$1 = __exportAll$1({ evaluate: () => evaluate$2, evaluate_to_constant: () => evaluate_to_constant$1, f: () => f$2, finite_field_evaluate: () => finite_field_evaluate$1 }), astToMathjs$1$1 = new astToMathjs$2$1({ mathjs: mathjs_default$1 }), astToFiniteField$2 = new astToFiniteField$1$1(), f$2 = function(t4) {
  var n2 = get_tree$1(t4), r2 = factorial_to_gamma_function$1(astToMathjs$1$1.convert(log_subscript_to_two_arg_log$1(normalize_function_names$1(normalize_applied_functions$1(n2)))));
  return r2.evaluate.bind(r2);
}, evaluate$2 = function(t4, n2) {
  return f$2(t4)(n2);
}, finite_field_evaluate$1 = function(t4, n2, r2) {
  return astToFiniteField$2.convert(t4.tree, n2, r2);
}, evaluate_to_constant$1 = function(t4, { remove_units_first: n2 = true, scale_based_on_unit: r2 = true, nan_for_non_numeric: i2 = true } = {}) {
  var a2 = get_tree$1(t4);
  if (n2 && (a2 = remove_units$1(a2, r2)), typeof a2 == `number`) return a2;
  if (typeof a2 == `string`) return a2 === `pi` && mathjs_default$1.define_pi ? Math.PI : a2 === `e` && mathjs_default$1.define_e ? Math.E : a2 === `i` && mathjs_default$1.define_i ? { re: 0, im: 1 } : i2 ? NaN : null;
  if (!Array.isArray(a2)) return i2 ? NaN : null;
  var o2 = [];
  o2.push([[`^`, `x`, [`/`, `m`, `n`]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], `m`], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), o2.push([[`^`, `x`, [`-`, [`/`, `m`, `n`]]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], [`-`, `m`]], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), a2 = applyAllTransformations$1(a2, o2, 40);
  var s2 = i2 ? NaN : null;
  try {
    var c2 = f$2(a2);
    s2 = c2();
  } catch {
  }
  if (!Number.isNaN(s2) && (typeof s2 == `number` || typeof s2?.re == `number` && typeof s2?.im == `number`)) {
    if (s2.re === 1 / 0 || s2.re === -1 / 0 || s2.im === 1 / 0 || s2.im === -1 / 0) {
      let t5;
      if (typeof s2?.re == `number` && typeof s2?.im == `number`) if (s2.im === 0) t5 = s2.re;
      else {
        let n3;
        n3 = s2.im === 1 ? `i` : s2.im === -1 ? [`-`, `i`] : [`*`, s2.im, `i`], t5 = s2.re === 0 ? n3 : [`+`, s2.re, n3];
      }
      else t5 = s2;
      s2 = i2 ? NaN : null;
      try {
        var c2 = f$2(t5);
        s2 = c2();
      } catch {
      }
    } else s2.im === 0 && (s2 = s2.re);
    return s2;
  }
  return typeof s2 == `object` && (s2 = i2 ? NaN : null), s2;
};
function factorial_to_gamma_function$1(t4) {
  return t4.transform(function(t5, n2, r2) {
    if (t5.isOperatorNode && t5.op === `!` && t5.fn === `factorial`) {
      var i2 = [new mathjs_default$1.OperatorNode(`+`, `add`, [t5.args[0], new mathjs_default$1.ConstantNode(1)])];
      return new mathjs_default$1.FunctionNode(new mathjs_default$1.SymbolNode(`gamma`), i2);
    } else return t5;
  });
}
var functions$3 = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
functions$3.C.nonneg = [`abs`], functions$3.C.nonzero = [`exp`], functions$3.C.R = [`abs`, `arg`], functions$3.C.C = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`, `sqrt`, `log`, `ln`, `log10`], functions$3.R.pos = [`exp`], functions$3.R.nonneg = [`abs`, `exp`, `arg`], functions$3.R.R = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`], functions$3.R.Z = [`sign`], functions$3.nonzeroC.pos = [`abs`], functions$3.nonneg.nonneg = [`abs`, `exp`, `arg`, `sqrt`, `erf`], functions$3.nonzeroC.nonzero = [`abs`], functions$3.nonneg.R = [...new Set(functions$3.R.R.concat(functions$3.nonneg.nonneg))], functions$3.pos.pos = [`abs`, `exp`, `sqrt`, `erf`], functions$3.pos.nonneg = functions$3.pos.pos, functions$3.pos.nonzero = [`abs`, `exp`, `sqrt`, `erf`], functions$3.pos.R = functions$3.nonneg.R.concat([`log`, `ln`, `log10`]);
function negate_adjust$1(t4, n2) {
  if (t4) return !n2;
  if (t4 === false) return n2;
}
function narrow_assumptions$1(t4, n2) {
  if (!Array.isArray(n2)) return [];
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 !== `and`) return [];
  for (var a2 = [], o2 = 0; o2 < i2.length; o2++) equal$1(i2[o2], t4) || a2.push(i2[o2]);
  return a2.length === 0 ? [] : a2.legnth === 1 ? a2[0] : [r2].concat(a2);
}
function simple_assumption_combination$1(t4, n2, r2) {
  return t4 === `and` ? n2 === void 0 ? r2 : r2 === void 0 ? n2 : n2 || r2 : n2 === void 0 || r2 === void 0 || n2 !== r2 ? void 0 : n2;
}
function is_integer_ast$1(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isInteger(t4);
  var i2 = evaluate_to_constant$1(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return Number.isInteger(i2);
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust$1(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust$1(false, c2);
    if (c2 === false) {
      if (o2 === `notin` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `C`)) return false;
    } else if (o2 === `in` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `Z`)) return false;
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$1(a2, r2);
      if (s2[0] === t4) return is_integer_ast$1(s2[1], n3);
      if (s2[1] === t4) return is_integer_ast$1(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$1(i3), s2 = i3.slice(1));
    let l2 = is_integer_ast$1(t4, s2[0], r2), u2 = is_integer_ast$1(t4, s2[1], r2);
    return simple_assumption_combination$1(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$1(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_integer_ast$1(o2[0], i3, r2);
    if (a2 === `*`) return o2.every(function(t5) {
      return is_integer_ast$1(t5, i3, r2);
    }) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$1(o2[0], i3, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (is_positive_ast$1(o2[1], i3, true, r2)) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$1(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let n3 = is_integer_ast$1(o2[0], i3, r2), a3 = is_integer_ast$1(o2[1], i3, r2);
      return n3 && (a3 && is_positive_ast$1(o2[1], i3, false, r2) ? true : void 0);
    }
    if (a2 === `+`) {
      let t5 = 0;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_integer_ast$1(o2[n3], i3, r2);
        if (a3 === false) {
          if (t5 > 0) return;
          t5 += 1;
        }
        if (a3 === void 0) return;
      }
      return t5 === 0;
    }
    return a2 === `apply` ? functions$3.C.Z && functions$3.C.Z.includes(o2[0]) && is_complex_ast$1(o2[1], i3, r2) || functions$3.R.Z && functions$3.R.Z.includes(o2[0]) && is_real_ast$1(o2[1], i3, r2) || functions$3.nonzeroC.Z && functions$3.nonzeroC.Z.includes(o2[0]) && is_nonzero_ast$1(o2[1], i3, r2) && is_complex_ast$1(o2[1], i3, r2) || functions$3.nonneg.Z && functions$3.nonneg.Z.includes(o2[0]) && is_positive_ast$1(o2[1], i3, false, r2) || functions$3.pos.Z && functions$3.pos.Z.includes(o2[0]) && is_positive_ast$1(o2[1], i3, true, r2) ? true : void 0 : a2 === `/` || a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_real_ast$1(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant$1(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : false;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `R`) return negate_adjust$1(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `R`) return negate_adjust$1(false, c2);
    if (c2 === false) {
      if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return true;
    } else if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables$1(i3), r3 = functions$2$1(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$1(a2, r2);
      if (s2[0] === t4) return is_real_ast$1(s2[1], n3);
      if (s2[1] === t4) return is_real_ast$1(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$1(i3), s2 = i3.slice(1));
    let l2 = is_real_ast$1(t4, s2[0], r2), u2 = is_real_ast$1(t4, s2[1], r2);
    return simple_assumption_combination$1(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$1(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_real_ast$1(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight$1(t4), o2 = t4.slice(1)), a2 === `*` && (is_nonzero_ast$1(o2[0], i3, r2) === false || is_nonzero_ast$1(o2[1], i3, r2) === false)) return true;
      let n3 = is_real_ast$1(o2[0], i3, r2), s2 = is_real_ast$1(o2[1], i3, r2);
      return n3 && s2 ? true : n3 && s2 === false || s2 && n3 === false ? false : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$1(o2[0], i3, r2), n3 = is_positive_ast$1(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$1(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_real_ast$1(o2[0], i3, r2), s2 = is_real_ast$1(o2[1], i3, r2);
      return a3 && s2 ? is_positive_ast$1(o2[0], i3, false, r2) ? is_positive_ast$1(o2[0], i3, true, r2) || n3 ? true : void 0 : is_integer_ast$1(o2[1], i3, r2) ? true : void 0 : void 0;
    }
    return a2 === `/` ? is_nonzero_ast$1(o2[1], i3, r2) && (is_nonzero_ast$1(o2[0], i3, r2) === false || is_real_ast$1(o2[0], i3, r2) && is_real_ast$1(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions$3.C.R && functions$3.C.R.includes(o2[0]) && is_complex_ast$1(o2[1], i3, r2) || functions$3.R.R && functions$3.R.R.includes(o2[0]) && is_real_ast$1(o2[1], i3, r2) || functions$3.nonzeroC.R && functions$3.nonzeroC.R.includes(o2[0]) && is_nonzero_ast$1(o2[1], i3, r2) && is_complex_ast$1(o2[1], i3, r2) || functions$3.nonneg.R && functions$3.nonneg.R.includes(o2[0]) && is_positive_ast$1(o2[1], i3, false, r2) || functions$3.pos.R && functions$3.pos.R.includes(o2[0]) && is_positive_ast$1(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_complex_ast$1(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant$1(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : !!(i2.re !== void 0 && Number.isFinite(i2.re) && i2.im !== void 0 && Number.isFinite(i2.im));
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `C`) return negate_adjust$1(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `C`) return negate_adjust$1(false, c2);
    if (c2 === false) {
      if (o2 === `in` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    } else if (o2 === `notin` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables$1(i3), r3 = functions$2$1(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions$1(a2, r2);
      if (s2[0] === t4) return is_complex_ast$1(s2[1], n3);
      if (s2[1] === t4) return is_complex_ast$1(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$1(i3), s2 = i3.slice(1));
    let l2 = is_complex_ast$1(t4, s2[0], r2), u2 = is_complex_ast$1(t4, s2[1], r2);
    return simple_assumption_combination$1(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$1(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_complex_ast$1(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) return a2 === `*` && !o2.every((t5) => is_nonzero_ast$1(t5, i3, r2) !== false) || o2.every((t5) => is_complex_ast$1(t5, i3, r2)) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$1(o2[0], i3, r2), n3 = is_positive_ast$1(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast$1(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_complex_ast$1(o2[0], i3, r2), s2 = is_complex_ast$1(o2[1], i3, r2);
      return a3 && s2 ? true : void 0;
    }
    return a2 === `/` ? is_nonzero_ast$1(o2[1], i3, r2) && (is_nonzero_ast$1(o2[0], i3, r2) === false || is_complex_ast$1(o2[0], i3, r2) && is_complex_ast$1(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions$3.C.C && functions$3.C.C.includes(o2[0]) && is_complex_ast$1(o2[1], i3, r2) || functions$3.R.C && functions$3.R.C.includes(o2[0]) && is_real_ast$1(o2[1], i3, r2) || functions$3.nonzeroC.C && functions$3.nonzeroC.C.includes(o2[0]) && is_nonzero_ast$1(o2[1], i3, r2) && is_complex_ast$1(o2[1], i3, r2) || functions$3.nonneg.C && functions$3.nonneg.C.includes(o2[0]) && is_positive_ast$1(o2[1], i3, false, r2) || functions$3.pos.C && functions$3.pos.C.includes(o2[0]) && is_positive_ast$1(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_nonzero_ast$1(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4) ? t4 !== 0 : Number.isNaN(t4) ? void 0 : true;
  var i2 = evaluate_to_constant$1(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) ? i2 !== 0 : Number.isNaN(i2) ? void 0 : true : i2.re !== void 0 && i2.im !== void 0 && (i2.re !== 0 || i2.im !== 0) ? true : void 0;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    let l2 = narrow_assumptions$1(a2, r2);
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      if (s2[0] === t4) return is_nonzero_ast$1(s2[1], l2);
      if (s2[1] === t4) return is_nonzero_ast$1(s2[0], l2);
    }
    if ((o2 === `ne` && !c2 || o2 === `=` && c2) && (s2[0] === t4 && is_nonzero_ast$1(s2[1], l2) === false || s2[1] === t4 && is_nonzero_ast$1(s2[0], l2) === false)) return true;
    if (o2 === `<`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast$1(s2[1], l2, false) || s2[1] === t4 && is_positive_ast$1(s2[0], l2, false)) return true;
      } else if (s2[0] === t4 && is_positive_ast$1(s2[1], l2, true) || s2[1] === t4 && is_negative_ast$1(s2[0], l2, true)) return true;
    }
    if (o2 === `le`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast$1(s2[1], l2, true) || s2[1] === t4 && is_positive_ast$1(s2[0], l2, true)) return true;
      } else if (s2[0] === t4 && is_positive_ast$1(s2[1], l2, false) || s2[1] === t4 && is_negative_ast$1(s2[0], l2, false)) return true;
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight$1(i3), s2 = i3.slice(1));
    let u2 = is_nonzero_ast$1(t4, s2[0], r2), d2 = is_nonzero_ast$1(t4, s2[1], r2);
    return simple_assumption_combination$1(o2, u2, d2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$1(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_nonzero_ast$1(o2[0], i3, r2);
    if (a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight$1(t4), o2 = t4.slice(1)), equal$1(o2[0], simplify$1([`-`, o2[1]], r2))) return false;
      let n3 = is_nonzero_ast$1(o2[0], i3, r2), a3 = is_nonzero_ast$1(o2[1], i3, r2);
      if (n3 === false) return a3;
      if (a3 === false) return n3;
      let s2 = is_real_ast$1(o2[0], i3, r2), c2 = is_real_ast$1(o2[1], i3, r2);
      if (!s2 || !c2) return s2 === true ? c2 === false ? true : void 0 : c2 === true && s2 === false ? true : void 0;
      let l2 = is_positive_ast$1(o2[0], i3, false, r2), u2 = is_positive_ast$1(o2[1], i3, false, r2), d2 = is_positive_ast$1(o2[0], i3, true, r2), p2 = is_positive_ast$1(o2[1], i3, true, r2);
      return l2 && p2 || d2 && u2 || l2 === false && p2 === false || d2 === false && u2 === false ? true : void 0;
    }
    if (a2 === `*`) {
      let t5 = true;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_nonzero_ast$1(o2[n3], i3, r2);
        if (a3 === false) return false;
        a3 === void 0 && (t5 = false);
      }
      return t5 ? true : void 0;
    }
    if (a2 === `/`) {
      let t5 = is_nonzero_ast$1(o2[0], i3, r2);
      return is_nonzero_ast$1(o2[1], i3, r2) ? t5 : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast$1(o2[0], i3, r2);
      return t5 ? (o2[0] === 1 / 0 || o2[0] === -1 / 0) && is_nonzero_ast$1(o2[1], i3, r2) === false ? void 0 : true : is_positive_ast$1(o2[1], i3, true, r2) && t5 === false ? false : void 0;
    }
    return a2 === `apply` ? functions$3.C.nonzero && functions$3.C.nonzero.includes(o2[0]) && is_complex_ast$1(o2[1], i3, r2) || functions$3.R.nonzero && functions$3.R.nonzero.includes(o2[0]) && is_real_ast$1(o2[1], i3, r2) || functions$3.nonzeroC.nonzero && functions$3.nonzeroC.nonzero.includes(o2[0]) && is_nonzero_ast$1(o2[1], i3, r2) || functions$3.nonneg.nonzero && functions$3.nonneg.nonzero.includes(o2[0]) && is_positive_ast$1(o2[1], i3, false, r2) || functions$3.pos.nonzero && functions$3.pos.nonzero.includes(o2[0]) && is_positive_ast$1(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_positive_ast$1(t4, n2, r2, i2) {
  if (typeof n2 != `object` && (n2 = []), i2 === void 0 && (i2 = n2), r2 === void 0 && (r2 = true), typeof t4 == `number`) return Number.isFinite(t4) ? r2 ? t4 > 0 : t4 >= 0 : false;
  var a2 = is_real_ast$1(t4, n2, i2);
  if (!a2) return a2;
  var o2 = evaluate_to_constant$1(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (o2 !== null) return typeof o2 == `number` && Number.isFinite(o2) ? r2 ? o2 > 0 : o2 >= 0 : false;
  if (typeof t4 == `string`) {
    let a3;
    if (a3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(a3)) return;
    let o3 = a3, s2 = a3[0], c2 = a3.slice(1), l2 = false;
    for (; s2 === `not`; ) {
      if (l2 = !l2, a3 = c2[0], !Array.isArray(a3)) return;
      s2 = a3[0], c2 = a3.slice(1);
    }
    let u2 = narrow_assumptions$1(o3, i2);
    if (s2 === `=` && !l2 || s2 === `ne` && l2) {
      if (c2[0] === t4) return is_positive_ast$1(c2[1], u2, r2);
      if (c2[1] === t4) return is_positive_ast$1(c2[0], u2, r2);
    }
    if (s2 === `<`) if (l2) {
      if (c2[0] === t4 && is_positive_ast$1(c2[1], u2, r2)) return true;
      if (c2[1] === t4 && is_negative_ast$1(c2[0], u2, !r2)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast$1(c2[1], u2, false)) return false;
      if (c2[1] === t4 && is_positive_ast$1(c2[0], u2, false)) return true;
    }
    if (s2 === `le`) if (l2) {
      if (c2[0] === t4 && is_positive_ast$1(c2[1], u2, false)) return true;
      if (c2[1] === t4 && is_negative_ast$1(c2[0], u2, false)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast$1(c2[1], u2, !r2)) return false;
      if (c2[1] === t4 && is_positive_ast$1(c2[0], u2, r2)) return true;
    }
    if (s2 !== `and` && s2 !== `or` || l2) return;
    c2.length > 2 && (a3 = unflattenRight$1(a3), c2 = a3.slice(1));
    let d2 = is_positive_ast$1(t4, c2[0], r2, i2), p2 = is_positive_ast$1(t4, c2[1], r2, i2);
    return simple_assumption_combination$1(s2, d2, p2);
  }
  if (Array.isArray(t4)) {
    let a3;
    a3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables$1(t4)]);
    let o3 = t4[0], s2 = t4.slice(1);
    if (o3 === `-`) return is_negative_ast$1(s2[0], a3, r2, i2);
    if (o3 === `+`) {
      s2.length > 2 && (t4 = unflattenRight$1(t4), s2 = t4.slice(1));
      let n3 = is_positive_ast$1(s2[0], a3, false, i2), o4 = is_positive_ast$1(s2[1], a3, false, i2), c2 = is_positive_ast$1(s2[0], a3, true, i2), l2 = is_positive_ast$1(s2[1], a3, true, i2);
      if (r2) {
        if (n3 && l2 || c2 && o4) return true;
      } else if (n3 && o4) return true;
      if (r2) {
        if (c2 === false && l2 === false) return false;
      } else if (n3 === false && l2 === false || c2 === false && o4 === false) return false;
      return;
    }
    if (o3 === `*`) {
      if (!s2.every((t5) => is_nonzero_ast$1(t5, a3, i2) !== false)) return !r2;
      s2.length > 2 && (t4 = unflattenRight$1(t4), s2 = t4.slice(1));
      let n3 = is_real_ast$1(s2[0], a3, i2), o4 = is_real_ast$1(s2[1], a3, i2);
      if (n3 === void 0 || o4 === void 0) return;
      if (n3 === false) return o4 === false ? void 0 : false;
      if (o4 === false) return false;
      let c2 = is_positive_ast$1(s2[0], a3, false, i2), l2 = is_positive_ast$1(s2[1], a3, false, i2), u2 = is_positive_ast$1(s2[0], a3, true, i2), d2 = is_positive_ast$1(s2[1], a3, true, i2);
      if (r2) {
        if (u2 && d2 || c2 === false && l2 === false) return true;
        if (u2 === false && l2 || c2 && d2 === false) return false;
      } else {
        if (c2 && l2 || u2 === false && d2 === false) return true;
        if (u2 && l2 === false || c2 === false && d2) return false;
      }
      return;
    }
    if (o3 === `/`) {
      if (!is_nonzero_ast$1(s2[1], a3, i2)) return;
      if (is_nonzero_ast$1(s2[0], a3, i2) === false) return !r2;
      let t5 = is_positive_ast$1(s2[1], a3, true, i2);
      if (t5 === void 0) return;
      let n3 = t5 ? r2 : !r2, o4 = is_positive_ast$1(s2[0], a3, n3, i2);
      return o4 === void 0 ? void 0 : o4 === true ? t5 === true : t5 !== true;
    }
    if (o3 === `^`) {
      let t5 = is_nonzero_ast$1(s2[0], a3, i2);
      if (!t5) if (is_positive_ast$1(s2[1], a3, true, i2)) {
        if (t5 === false) return !r2;
        if (r2) return;
      } else return;
      else if (is_nonzero_ast$1(s2[1], a3, i2) === false) return s2[0] === 1 / 0 || s2[0] === -1 / 0 ? void 0 : true;
      return is_real_ast$1(s2[0], a3, i2) === true ? is_positive_ast$1(s2[0], a3, r2, i2) ? is_real_ast$1(s2[1], a3, i2) ? true : void 0 : is_integer_ast$1(simplify$1([`/`, s2[1], 2], i2), a3, i2) ? true : void 0 : void 0;
    }
    return o3 === `apply` && !r2 ? functions$3.C.nonneg && functions$3.C.nonneg.includes(s2[0]) && is_complex_ast$1(s2[1], a3, i2) || functions$3.R.nonneg && functions$3.R.nonneg.includes(s2[0]) && is_real_ast$1(s2[1], a3, i2) || functions$3.nonzeroC.nonneg && functions$3.nonzeroC.nonneg.includes(s2[0]) && is_nonzero_ast$1(s2[1], a3, i2) && is_complex_ast$1(s2[1], a3, i2) || functions$3.nonneg.nonneg && functions$3.nonneg.nonneg.includes(s2[0]) && is_positive_ast$1(s2[1], a3, false, i2) || functions$3.pos.nonneg && functions$3.pos.nonneg.includes(s2[0]) && is_positive_ast$1(s2[1], a3, true, i2) ? true : void 0 : o3 === `apply` && r2 ? functions$3.C.pos && functions$3.C.pos.includes(s2[0]) && is_complex_ast$1(s2[1], a3, i2) || functions$3.R.pos && functions$3.R.pos.includes(s2[0]) && is_real_ast$1(s2[1], a3, i2) || functions$3.nonzeroC.pos && functions$3.nonzeroC.pos.includes(s2[0]) && is_nonzero_ast$1(s2[1], a3, i2) && is_complex_ast$1(s2[1], a3, i2) || functions$3.nonneg.pos && functions$3.nonneg.pos.includes(s2[0]) && is_positive_ast$1(s2[1], a3, false, i2) || functions$3.pos.pos && functions$3.pos.pos.includes(s2[0]) && is_positive_ast$1(s2[1], a3, true, i2) ? true : void 0 : o3 === `prime` ? void 0 : false;
  }
  return false;
}
function is_negative_ast$1(t4, n2, r2, i2) {
  r2 === void 0 && (r2 = true);
  var a2 = is_real_ast$1(t4, n2, i2);
  if (a2 === true) {
    let a3 = is_positive_ast$1(t4, n2, !r2, i2);
    return a3 === false ? true : a3 === true ? false : void 0;
  }
  return a2;
}
function ParseError$1(t4, n2) {
  this.name = `ParseError`, this.message = t4 || `Error parsing input`, this.stack = Error().stack, this.location = n2;
}
ParseError$1.prototype = Object.create(Error.prototype), ParseError$1.prototype.constructor = ParseError$1;
var lexer$1 = class lexer3 {
  constructor(t4, n2 = `\\s`) {
    this.input = ``, this.location = 0, this.token_rules = [], this.initial_whitespace = RegExp(`^(` + n2 + `)+`);
    for (let n3 of t4) this.token_rules.push([RegExp(`^` + n3[0])].concat(n3.slice(1)));
  }
  set_input(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.input = t4, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: t4 = null, location: n2 = 0 } = {}) {
    t4 !== null && (this.input = t4, this.location = n2);
  }
  advance({ remove_initial_space: t4 = true } = {}) {
    let n2 = this.initial_whitespace.exec(this.input);
    if (n2) {
      let r3 = n2[0].length;
      if (this.input = this.input.slice(r3), this.location += r3, !t4) return { token_type: `SPACE`, token_text: n2[0], original_text: n2[0] };
    }
    if (this.input.length === 0) return { token_type: `EOF`, token_text: ``, original_text: `` };
    n2 = null;
    for (var r2 of this.token_rules) if (n2 = r2[0].exec(this.input), n2) {
      let t5 = n2[0].length;
      this.input = this.input.slice(t5), this.location += t5;
      break;
    }
    return n2 === null ? { token_type: `INVALID`, token_text: this.input[0], original_text: this.input[0] } : r2.length > 2 ? { token_type: r2[1], token_text: r2[2], original_text: n2[0] } : { token_type: r2[1], token_text: n2[0], original_text: n2[0] };
  }
  unput(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.location -= t4.length, this.input = t4 + this.input;
  }
}, is_associative$2 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$7(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(function(t5, n3) {
    return flatten$7(t5);
  }), is_associative$2[n2]) {
    for (var i2 = [], a2 = 0; a2 < r2.length; a2++) Array.isArray(r2[a2]) && r2[a2][0] === n2 && r2[a2].length > 2 ? i2 = i2.concat(r2[a2].slice(1)) : i2.push(r2[a2]);
    r2 = i2;
  }
  return [n2].concat(r2);
}
var number_rules_sci$1$1 = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`]], number_rules_non_sci$1$1 = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_text_rules$1 = [[`\\*\\*`, `^`], [`\\*`, `*`], [`\\xB7`, `*`], [`·`, `*`], [`•`, `*`], [`⋅`, `*`], [`×`, `*`], [`/`, `/`], [`-`, `-`], [`֊`, `-`], [`־`, `-`], [`᠆`, `-`], [`‐`, `-`], [`‑`, `-`], [`‒`, `-`], [`–`, `-`], [`—`, `-`], [`―`, `-`], [`⁻`, `-`], [`₋`, `-`], [`−`, `-`], [`⸺`, `-`], [`⸻`, `-`], [`﹘`, `-`], [`﹣`, `-`], [`－`, `-`], [`\\+`, `+`], [`plusminus(?![a-zA-Z0-9])`, `PM`], [`±`, `PM`], [`\\^`, `^`], [`‸`, `^`], [`ʌ`, `^`], [`′`, `'`], [`\\|`, `|`], [`\\(`, `(`], [`\\)`, `)`], [`\\[`, `[`], [`\\]`, `]`], [`\\{`, `{`], [`\\}`, `}`], [`⟨`, `LANGLE`], [`⟩`, `RANGLE`], [`〈`, `LANGLE`], [`〉`, `RANGLE`], [`,`, `,`], [`:`, `:`], [`α`, `VARMULTICHAR`, `alpha`], [`β`, `VARMULTICHAR`, `beta`], [`ϐ`, `VARMULTICHAR`, `beta`], [`Γ`, `VARMULTICHAR`, `Gamma`], [`γ`, `VARMULTICHAR`, `gamma`], [`Δ`, `VARMULTICHAR`, `Delta`], [`δ`, `VARMULTICHAR`, `delta`], [`ε`, `VARMULTICHAR`, `epsilon`], [`ϵ`, `VARMULTICHAR`, `epsilon`], [`ζ`, `VARMULTICHAR`, `zeta`], [`η`, `VARMULTICHAR`, `eta`], [`Θ`, `VARMULTICHAR`, `Theta`], [`ϴ`, `VARMULTICHAR`, `Theta`], [`θ`, `VARMULTICHAR`, `theta`], [`ᶿ`, `VARMULTICHAR`, `theta`], [`ϑ`, `VARMULTICHAR`, `theta`], [`ι`, `VARMULTICHAR`, `iota`], [`κ`, `VARMULTICHAR`, `kappa`], [`Λ`, `VARMULTICHAR`, `Lambda`], [`λ`, `VARMULTICHAR`, `lambda`], [`μ`, `VARMULTICHAR`, `mu`], [`µ`, `VARMULTICHAR`, `mu`], [`ν`, `VARMULTICHAR`, `nu`], [`Ξ`, `VARMULTICHAR`, `Xi`], [`ξ`, `VARMULTICHAR`, `xi`], [`Π`, `VARMULTICHAR`, `Pi`], [`π`, `VARMULTICHAR`, `pi`], [`ϖ`, `VARMULTICHAR`, `pi`], [`ρ`, `VARMULTICHAR`, `rho`], [`ϱ`, `VARMULTICHAR`, `rho`], [`Σ`, `VARMULTICHAR`, `Sigma`], [`σ`, `VARMULTICHAR`, `sigma`], [`ς`, `VARMULTICHAR`, `sigma`], [`τ`, `VARMULTICHAR`, `tau`], [`Υ`, `VARMULTICHAR`, `Upsilon`], [`υ`, `VARMULTICHAR`, `upsilon`], [`Φ`, `VARMULTICHAR`, `Phi`], [`φ`, `VARMULTICHAR`, `phi`], [`ϕ`, `VARMULTICHAR`, `phi`], [`Ψ`, `VARMULTICHAR`, `Psi`], [`ψ`, `VARMULTICHAR`, `psi`], [`Ω`, `VARMULTICHAR`, `Omega`], [`ω`, `VARMULTICHAR`, `omega`], [`∅`, `VARMULTICHAR`, `emptyset`], [`oo(?![a-zA-Z0-9])`, `INFINITY`], [`OO(?![a-zA-Z0-9])`, `INFINITY`], [`infty(?![a-zA-Z0-9])`, `INFINITY`], [`infinity(?![a-zA-Z0-9])`, `INFINITY`], [`Infinity(?![a-zA-Z0-9])`, `INFINITY`], [`∞`, `INFINITY`], [`ℯ`, `VAR`, `e`], [`♠`, `VARMULTICHAR`, `spade`], [`♡`, `VARMULTICHAR`, `heart`], [`♢`, `VARMULTICHAR`, `diamond`], [`♣`, `VARMULTICHAR`, `club`], [`★`, `VARMULTICHAR`, `bigstar`], [`◯`, `VARMULTICHAR`, `bigcirc`], [`◊`, `VARMULTICHAR`, `lozenge`], [`△`, `VARMULTICHAR`, `bigtriangleup`], [`▽`, `VARMULTICHAR`, `bigtriangledown`], [`⧫`, `VARMULTICHAR`, `blacklozenge`], [`■`, `VARMULTICHAR`, `blacksquare`], [`▲`, `VARMULTICHAR`, `blacktriangle`], [`▼`, `VARMULTICHAR`, `blacktriangledown`], [`◀`, `VARMULTICHAR`, `blacktriangleleft`], [`▶`, `VARMULTICHAR`, `blacktriangleright`], [`□`, `VARMULTICHAR`, `Box`], [`∘`, `VARMULTICHAR`, `circ`], [`⋆`, `VARMULTICHAR`, `star`], [`and(?![a-zA-Z0-9])`, `AND`], [`\\&\\&?`, `AND`], [`∧`, `AND`], [`or(?![a-zA-Z0-9])`, `OR`], [`∨`, `OR`], [`not(?![a-zA-Z0-9])`, `NOT`], [`¬`, `NOT`], [`=`, `=`], [`᐀`, `=`], [`゠`, `=`], [`!=`, `NE`], [`≠`, `NE`], [`<=`, `LE`], [`≤`, `LE`], [`>=`, `GE`], [`≥`, `GE`], [`<`, `<`], [`>`, `>`], [`forall(?![a-zA-Z0-9])`, `FORALL`], [`∀`, `FORALL`], [`exists(?![a-zA-Z0-9])`, `EXISTS`], [`∃`, `EXISTS`], [`elementof(?![a-zA-Z0-9])`, `IN`], [`∈`, `IN`], [`notelementof(?![a-zA-Z0-9])`, `NOTIN`], [`∉`, `NOTIN`], [`containselement(?![a-zA-Z0-9])`, `NI`], [`∋`, `NI`], [`notcontainselement(?![a-zA-Z0-9])`, `NOTNI`], [`∌`, `NOTNI`], [`subset(?![a-zA-Z0-9])`, `SUBSET`], [`⊂`, `SUBSET`], [`subseteq(?![a-zA-Z0-9])`, `SUBSETEQ`], [`⊆`, `SUBSETEQ`], [`notsubset(?![a-zA-Z0-9])`, `NOTSUBSET`], [`⊄`, `NOTSUBSET`], [`notsubseteq(?![a-zA-Z0-9])`, `NOTSUBSETEQ`], [`⊈`, `NOTSUBSETEQ`], [`superset(?![a-zA-Z0-9])`, `SUPERSET`], [`⊃`, `SUPERSET`], [`superseteq(?![a-zA-Z0-9])`, `SUPERSETEQ`], [`⊇`, `SUPERSETEQ`], [`notsuperset(?![a-zA-Z0-9])`, `NOTSUPERSET`], [`⊅`, `NOTSUPERSET`], [`notsuperseteq(?![a-zA-Z0-9])`, `NOTSUPERSETEQ`], [`⊉`, `NOTSUPERSETEQ`], [`union(?![a-zA-Z0-9])`, `UNION`], [`∪`, `UNION`], [`intersect(?![a-zA-Z0-9])`, `INTERSECT`], [`∩`, `INTERSECT`], [`rightarrow(?![a-zA-Z0-9])`, `RIGHTARROW`], [`→`, `RIGHTARROW`], [`⟶`, `RIGHTARROW`], [`leftarrow(?![a-zA-Z0-9])`, `LEFTARROW`], [`←`, `LEFTARROW`], [`⟵`, `LEFTARROW`], [`leftrightarrow(?![a-zA-Z0-9])`, `LEFTRIGHTARROW`], [`↔`, `LEFTRIGHTARROW`], [`⟷`, `LEFTRIGHTARROW`], [`implies(?![a-zA-Z0-9])`, `IMPLIES`], [`⇒`, `IMPLIES`], [`⟹`, `IMPLIES`], [`impliedby(?![a-zA-Z0-9])`, `IMPLIEDBY`], [`⇐`, `IMPLIEDBY`], [`⟸`, `IMPLIEDBY`], [`iff(?![a-zA-Z0-9])`, `IFF`], [`⇔`, `IFF`], [`⟺`, `IFF`], [`perp(?![a-zA-Z0-9])`, `PERP`], [`⟂`, `PERP`], [`parallel(?![a-zA-Z0-9])`, `PARALLEL`], [`∥`, `PARALLEL`], [`angle(?![a-zA-Z0-9])`, `ANGLE`], [`∠`, `ANGLE`], [`int(?![a-zA-Z0-9])`, `INT`], [`∫`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`\\.\\.\\.`, `LDOTS`], [`[a-zA-Z∂][a-zA-Z∂0-9]*`, `VAR`], [`[＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault$1$1 = true, splitSymbolsDefault$1 = true, unsplitSymbolsDefault$1 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.angle.deg.emptyset`.split(`.`), appliedFunctionSymbolsDefault$1$1 = `abs.exp.log.ln.log10.sign.sqrt.cbrt.nthroot.mod.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.re.im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault$1$1 = [`f`, `g`], operatorSymbolsDefault$1$1 = [`binom`, `vec`, `linesegment`], unitsDefault$1$1 = get_all_units$1(), parseLeibnizNotationDefault$1$1 = true, textToAst$4$1 = class textToAst$43 {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault$1$1, splitSymbols: n2 = splitSymbolsDefault$1, unsplitSymbols: r2 = unsplitSymbolsDefault$1, appliedFunctionSymbols: i2 = appliedFunctionSymbolsDefault$1$1, functionSymbols: a2 = functionSymbolsDefault$1$1, operatorSymbols: o2 = operatorSymbolsDefault$1$1, units: s2 = unitsDefault$1$1, parseLeibnizNotation: c2 = parseLeibnizNotationDefault$1$1, parseScientificNotation: l2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.splitSymbols = n2, this.unsplitSymbols = r2, this.appliedFunctionSymbols = i2, this.functionSymbols = a2, this.operatorSymbols = o2, this.units = s2, this.parseLeibnizNotation = c2;
    let u2 = base_text_rules$1;
    u2 = l2 ? [...number_rules_sci$1$1, ...u2] : [...number_rules_non_sci$1$1, ...u2], this.lexer = new lexer$1(u2);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError$1(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError$1(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten$7(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      return this.token.token_type === `:` ? (this.advance(), [`:`, r2, this.statement_a()]) : r2;
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten$7(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let n3 = r2.length;
      for (let [t5, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && t5 < n3 - 1) {
            let o2;
            o2 = t5 === n3 - 2 ? r2[n3 - 1] : this.convert_units_in_term([`*`, ...r2.slice(t5 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return t5 === 0 ? c2 : [`*`, ...r2.slice(0, t5), c2];
          } else if (!a2.prefix && t5 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = t5 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, t5)], o2], t5 === n3 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(t5 + 1)]);
          }
        }
      }
      return t4;
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    return t4;
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n2 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n2 === false && (n2 = `＿`), n2;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`) if (a2 = this.token.token_text, this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
      let t5 = false;
      if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), this.advance(), this.token.token_type === `_`) {
        this.advance();
        let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
        a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
      }
      if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
      else {
        for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
        for (; this.token.token_type === `^`; ) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = [`^`, a2, t6];
        }
        if (this.token.token_type === `(`) {
          this.advance();
          let t6 = this.statement_list();
          if (this.token.token_type !== `)`) throw new ParseError$1(`Expecting )`, this.lexer.location);
          this.advance(), t6[0] === `list` && (t6[0] = `tuple`), a2 = [`apply`, a2, t6];
        } else if (t5) {
          if (!this.allowSimplifiedFunctionApplication) throw new ParseError$1(`Expecting ( after function`, this.lexer.location);
          let t6 = this.factor({ parse_absolute_value: n2 });
          t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
        }
      }
      return a2;
    } else if (this.operatorSymbols.includes(a2)) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError$1(`Expecting )`, this.lexer.location);
      this.advance(), a2 = t5[0] === `list` ? [a2, ...t5.slice(1)] : [a2, t5];
    } else {
      let t5 = this.factor({ parse_absolute_value: n2 });
      t5 === false && (t5 = `＿`), a2 = [a2, t5];
    }
    else {
      if (this.parseLeibnizNotation) {
        let t5 = this.return_state(), n3 = this.leibniz_notation();
        if (n3) return n3;
        this.set_state(t5);
      }
      let i3 = this.splitSymbols;
      if (i3 && (this.token.token_type === `VARMULTICHAR` || this.unsplitSymbols.includes(a2) || a2.length === 1 || a2.match(/[\d]/g)) && (i3 = false), i3) {
        for (let t5 = a2.length - 1; t5 >= 0; t5--) this.lexer.unput(` `), this.lexer.unput(a2[t5]);
        return this.advance(), this.baseFactor({ inside_absolute_value: t4, parse_absolute_value: n2, allow_absolute_value_closing: r2 });
      } else this.advance();
    }
    else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError$1(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError$1(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `{` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `{` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type === `|` && n2 && (t4 === 0 || !r2)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError$1(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError$1(`Expecting )`, this.lexer.location);
      this.advance(), t5[0] === `list` ? a2 = [`angle`, ...t5.slice(1)] : t5[0] === `*` && (a2 = [`angle`, t5]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten$7(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    var t4 = this.token.token_text;
    if (!(this.token.token_type === `VAR` && (t4[0] === `d` || t4[0] === `∂`) && (t4.length === 1 || t4.length === 2 && /[a-zA-Z]/.exec(t4[1])))) return false;
    let n2 = t4[0], r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (t4.length === 2) i2 = t4[1];
    else if (this.advance(), this.token.token_type === `VARMULTICHAR` || this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`)) i2 = this.token.token_text;
    else {
      if (this.token.token_type !== `^` || (this.advance(), this.token.token_type !== `NUMBER`) || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2))) return false;
      if (this.advance(), this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`) i2 = this.token.token_text;
      else return false;
    }
    if (this.advance(), this.token.token_type !== `/`) return false;
    let s2 = 0;
    for (this.advance(); ; ) {
      if (this.token.token_type !== `VAR` || this.token.token_text[0] !== n2) return false;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let c2 = this.token.token_text;
      if (c2.length === 2) if (/[a-zA-Z]/.exec(c2[1])) a2.push(c2[1]);
      else return false;
      else {
        if (this.advance(), !(this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`)) return false;
        a2.push(this.token.token_text);
      }
      let l2 = 1, u2 = false;
      if (this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance()), this.token.token_type === `^`) {
        if (this.advance(), this.token.token_type !== `NUMBER` || (l2 = parseFloat(this.token.token_text), !Number.isInteger(l2))) return false;
        u2 = false, this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance());
      }
      if (o2.push(l2), s2 += l2, s2 > r2) return false;
      if (s2 === r2) {
        if (!u2 && (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`)) return false;
        this.token.token_type === `SPACE` && this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, MAX_PM_COUNT$1 = 10, MAX_PM_EXPANSIONS$1 = 1 << MAX_PM_COUNT$1;
function contains_pm$1(t4) {
  if (!Array.isArray(t4)) return false;
  if (t4[0] === `pm`) return true;
  for (let n2 = 1; n2 < t4.length; n2++) if (contains_pm$1(t4[n2])) return true;
  return false;
}
function count_pm$1(t4) {
  if (!Array.isArray(t4)) return 0;
  let n2 = +(t4[0] === `pm`);
  for (let r2 = 1; r2 < t4.length; r2++) n2 += count_pm$1(t4[r2]);
  return n2;
}
function expand_pm_signs$1(t4) {
  let n2 = count_pm$1(t4);
  if (n2 === 0) return [t4];
  if (n2 > MAX_PM_COUNT$1) throw Error(`pm: cannot expand ${n2} plus-minus operators (limit is ${MAX_PM_COUNT$1} → ${MAX_PM_EXPANSIONS$1} combinations)`);
  let r2 = 1 << n2, i2 = [];
  for (let n3 = 0; n3 < r2; n3++) i2.push(replace_pm$1(t4, n3, { idx: 0 }));
  return i2;
}
function replace_pm$1(t4, n2, r2) {
  if (!Array.isArray(t4)) return t4;
  if (t4[0] === `pm`) {
    let i3 = n2 >> r2.idx & 1;
    r2.idx += 1;
    let a2 = replace_pm$1(t4[1], n2, r2);
    return i3 === 0 ? a2 : [`-`, a2];
  }
  let i2 = [t4[0]];
  for (let a2 = 1; a2 < t4.length; a2++) i2.push(replace_pm$1(t4[a2], n2, r2));
  return i2;
}
var transformation_exports$1 = __exportAll$1({ expand: () => expand$1, expand_relations: () => expand_relations$1, get_component: () => get_component$1, perform_matrix_multiplications: () => perform_matrix_multiplications$1, perform_matrix_scalar_multiplications: () => perform_matrix_scalar_multiplications$1, perform_vector_scalar_multiplications: () => perform_vector_scalar_multiplications$1, substitute: () => substitute$2, substitute_component: () => substitute_component$1 }), textToAst$3$1 = new textToAst$4$1();
function expand$1(t4, n2) {
  var r2 = get_tree$1(t4);
  r2 = perform_matrix_multiplications$1(r2), r2 = perform_vector_matrix_additions_scalar_multiplications$1(r2);
  let i2 = (t5) => !Array.isArray(t5) || ![`d`, `*`].includes(t5[0]) || t5[0] === `*` && t5.slice(1).every((t6) => !Array.isArray(t6) || t6[0] !== `d`), a2 = (t5) => i2(t5) && !contains_pm$1(t5), o2 = (t5) => !contains_pm$1(t5);
  var s2 = [];
  return s2.push([textToAst$3$1.convert(`a*(b+c)`), textToAst$3$1.convert(`a*b+a*c`), { variables: { a: a2, b: true, c: true }, allow_extended_match: true }]), s2.push([textToAst$3$1.convert(`(a+b)*c`), textToAst$3$1.convert(`a*c+b*c`), { variables: { a: true, b: true, c: a2 }, allow_extended_match: true }]), n2 || s2.push([textToAst$3$1.convert(`(a+b)/c`), textToAst$3$1.convert(`a/c+b/c`), { variables: { a: true, b: true, c: o2 } }]), s2.push([textToAst$3$1.convert(`-(a+b)`), textToAst$3$1.convert(`-a-b`)]), s2.push([textToAst$3$1.convert(`a(-b)`), textToAst$3$1.convert(`-ab`)]), s2.push([textToAst$3$1.convert(`(a+b)^2`), textToAst$3$1.convert(`a^2+2ab+b^2`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$1.convert(`(a+b)^3`), textToAst$3$1.convert(`a^3+3a^2b+3ab^2+b^3`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$1.convert(`(a+b)^4`), textToAst$3$1.convert(`a^4+4a^3b+6a^2b^2+4ab^3+b^4`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3$1.convert(`a*(b+c)*d`), textToAst$3$1.convert(`(a*b+a*c)*d`), { variables: { a: o2, b: true, c: true, d: true } }]), r2 = applyAllTransformations$1(r2, s2, 20), r2 = flatten$5$1(r2), r2 = evaluate_numbers$1(r2), r2 = collect_like_terms_factors$1(r2), r2 = normalize_negatives$1(r2), r2;
}
function perform_matrix_multiplications$1(t4, n2 = true, r2 = true) {
  var i2 = get_tree$1(t4);
  function a2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = n3[1][2];
    if (n3[1][1] !== i3) return { success: false };
    let o3 = t5[2], s3 = n3[2], c3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let n4 = o3[t6 + 1].slice(1), r4 = [`tuple`];
      for (let t7 = 0; t7 < a3; t7++) {
        let a4 = s3.slice(1).map((n5) => n5[t7 + 1]);
        if (n4.length !== i3 || a4.length !== i3) return subtree;
        let o4 = [`+`, ...n4.map((t8, n5) => [`*`, t8, a4[n5]])];
        r4.push(o4);
      }
      c3.push(r4);
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, a3], c3] };
  }
  function o2(t5, n3) {
    if (!Number.isInteger(n3) || n3 < 1) return { success: false };
    if (n3 === 1) return { success: true, newMatrix: t5 };
    let r3 = t5[1][1];
    if (t5[1][2] !== r3) return { success: false };
    let i3 = t5[2], a3 = JSON.parse(JSON.stringify(i3));
    for (let t6 = 1; t6 < n3; t6++) {
      let t7 = a3;
      a3 = [`tuple`];
      for (let n4 = 0; n4 < r3; n4++) {
        let o3 = t7[n4 + 1].slice(1), s3 = [`tuple`];
        for (let t8 = 0; t8 < r3; t8++) {
          let n5 = i3.slice(1).map((n6) => n6[t8 + 1]);
          if (o3.length !== r3 || n5.length !== r3) return subtree;
          let a4 = [`+`, ...o3.map((t9, r4) => [`*`, t9, n5[r4]])];
          s3.push(a4);
        }
        a3.push(s3);
      }
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, r3], a3] };
  }
  function s2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = t5[2], o3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let r4 = [`tuple`], s3 = a3[t6 + 1];
      for (let t7 = 0; t7 < i3; t7++) r4.push([`*`, n3, s3[t7 + 1]]);
      o3.push(r4);
    }
    return [`matrix`, [`tuple`, r3, i3], o3];
  }
  function c2() {
    let t5 = [`^`, [`matrix`, `size`, `matrixData`], `p`], n3 = { variables: { p: (t6) => Number.isInteger(t6) && t6 > 0, size: true, matrixData: true } };
    i2 = transform$1(i2, function(r3) {
      let i3 = match$1$1(r3, t5, n3);
      if (i3) {
        let t6 = o2([`matrix`, i3.size, i3.matrixData], i3.p);
        return t6.success ? t6.newMatrix : r3;
      } else return r3;
    });
  }
  function l2() {
    let t5 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], n3 = { variables: { a: true, b: true, size: true, matrixData: true }, allow_implicit_identities: [`a`, `b`] };
    i2 = transform$1(i2, function(r3) {
      let i3 = match$1$1(r3, t5, n3);
      if (i3) {
        let t6 = [`matrix`, i3.size, i3.matrixData], n4 = [], r4 = [];
        Array.isArray(i3.a) && i3.a[0] === `*` ? n4.push(...i3.a.slice(1)) : n4.push(i3.a), Array.isArray(i3.b) && i3.b[0] === `*` ? r4.push(...i3.b.slice(1)) : r4.push(i3.b);
        let o3 = n4.length;
        for (let r5 = o3 - 1; r5 >= 0; r5--) {
          let i4 = n4[r5][0];
          if (i4 === `matrix`) {
            let i5 = a2(n4[r5], t6);
            if (i5.success) t6 = i5.newMatrix, n4.pop();
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(i4)) break;
          else n4[r5] !== 1 && (t6 = s2(t6, n4[r5])), n4.pop();
        }
        for (; r4.length > 0; ) {
          let n5 = r4[0][0];
          if (n5 === `matrix`) {
            let n6 = a2(t6, r4[0]);
            if (n6.success) t6 = n6.newMatrix, r4.splice(0, 1);
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(n5)) break;
          else r4[0] !== 1 && (t6 = s2(t6, r4[0])), r4.splice(0, 1);
        }
        return n4.length > 0 || r4.length > 0 ? [`*`, ...n4, t6, ...r4] : t6;
      } else return r3;
    });
  }
  function u2() {
    let t5 = [`*`, [`matrix`, [`tuple`, `m`, `n`], `matrixData`], `b`], a3 = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: true, b: true } };
    i2 = transform$1(i2, function(i3) {
      let o3 = match$1$1(i3, t5, a3);
      if (o3) {
        let t6 = o3.m, a4 = o3.n, s3 = o3.b, c3 = o3.matrixData, l3 = [];
        n2 && (l3.push(`vector`), l3.push(`altvector`)), r2 && l3.push(`tuple`);
        let u3, d2 = [];
        if (l3.includes(s3[0])) u3 = s3;
        else if (Array.isArray(s3) && s3[0] === `*` && l3.includes(s3[1][0])) u3 = s3[1], d2 = s3.slice(2);
        else return i3;
        let p2 = u3.slice(1);
        if (p2.length !== a4) return i3;
        let m2 = [u3[0]];
        for (let n3 = 0; n3 < t6; n3++) {
          let t7 = [`+`, ...c3[n3 + 1].slice(1).map((t8, n4) => [`*`, t8, p2[n4]])];
          m2.push(t7);
        }
        return d2.length > 0 ? [`*`, m2, ...d2] : m2;
      } else return i3;
    });
  }
  return c2(), l2(), (n2 || r2) && u2(), i2;
}
function perform_vector_scalar_multiplications$1(t4, n2 = true) {
  var r2 = get_tree$1(t4);
  let i2 = function(t5, n3) {
    let r3 = [`*`, `a`, [n3, `vectorData`], `b`], i3 = { allow_implicit_identities: [`a`, `b`] };
    return t5 = transform$1(t5, function(t6) {
      let a2 = match$1$1(t6, r3, i3);
      if (a2) {
        if (a2.a === 1 && a2.b === 1) return t6;
        let r4 = a2.vectorData;
        r4 = Array.isArray(r4) && r4[0] === n3 ? r4.slice(1) : [r4];
        let i4 = [], o2 = [];
        Array.isArray(a2.a) && a2.a[0] === `*` ? i4.push(...a2.a.slice(1)) : i4.push(a2.a), Array.isArray(a2.b) && a2.b[0] === `*` ? o2.push(...a2.b.slice(1)) : o2.push(a2.b);
        let s2 = i4.length;
        for (let t7 = s2 - 1; t7 >= 0; t7--) {
          let n4 = i4[t7][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
          i4[t7] !== 1 && (r4 = r4.map((n5) => [`*`, n5, i4[t7]])), i4.pop();
        }
        for (; o2.length > 0; ) {
          let t7 = o2[0][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t7)) break;
          o2[0] !== 1 && (r4 = r4.map((t8) => [`*`, t8, o2[0]])), o2.splice(0, 1);
        }
        let c2 = [n3, ...r4];
        return i4.length > 0 || o2.length > 0 ? [`*`, ...i4, c2, ...o2] : c2;
      } else return t6;
    }), t5;
  };
  return r2 = i2(r2, `vector`), r2 = i2(r2, `altvector`), n2 && (r2 = i2(r2, `tuple`)), r2;
}
function perform_matrix_scalar_multiplications$1(t4) {
  var n2 = get_tree$1(t4);
  let r2 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], i2 = { allow_implicit_identities: [`a`, `b`] };
  return n2 = transform$1(n2, function(t5) {
    let n3 = match$1$1(t5, r2, i2);
    if (n3) {
      if (n3.a === 1 && n3.b === 1) return t5;
      let r3 = n3.matrixData, i3 = [], a2 = [];
      Array.isArray(n3.a) && n3.a[0] === `*` ? i3.push(...n3.a.slice(1)) : i3.push(n3.a), Array.isArray(n3.b) && n3.b[0] === `*` ? a2.push(...n3.b.slice(1)) : a2.push(n3.b);
      let o2 = i3.length;
      for (let t6 = o2 - 1; t6 >= 0; t6--) {
        let n4 = i3[t6][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
        i3[t6] !== 1 && (r3 = r3.map((n5) => n5 === `tuple` ? n5 : n5.map((n6) => n6 === `tuple` ? n6 : [`*`, n6, i3[t6]]))), i3.pop();
      }
      for (; a2.length > 0; ) {
        let t6 = a2[0][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t6)) break;
        a2[0] !== 1 && (r3 = r3.map((t7) => t7 === `tuple` ? t7 : t7.map((t8) => t8 === `tuple` ? t8 : [`*`, t8, a2[0]]))), a2.splice(0, 1);
      }
      let s2 = [`matrix`, n3.size, r3];
      return i3.length > 0 || a2.length > 0 ? [`*`, ...i3, s2, ...a2] : s2;
    } else return t5;
  }), n2;
}
function expand_relations$1(t4) {
  return transform$1(get_tree$1(t4), expand_relations_transform$1);
}
function expand_relations_transform$1(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `=`) {
    if (r2.length <= 2) return t4;
    let n3 = [`and`];
    for (let t5 = 0; t5 < r2.length - 1; t5++) n3.push([`=`, r2[t5], r2[t5 + 1]]);
    return n3;
  }
  if (n2 === `gts` || n2 === `lts`) {
    let t5 = r2[0], i2 = r2[1];
    if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let a2 = [];
    for (let r3 = 1; r3 < t5.length - 1; r3++) {
      let o3;
      o3 = i2[r3] ? n2 === `lts` ? `<` : `>` : n2 === `lts` ? `le` : `ge`, a2.push([o3, t5[r3], t5[r3 + 1]]);
    }
    let o2 = [`and`, a2[0], a2[1]];
    for (let t6 = 2; t6 < a2.length; t6++) o2 = [`and`, o2, a2[t6]];
    return o2;
  }
  if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
    let i2 = false;
    (n2 === `notin` || n2 === `notni`) && (i2 = true);
    let a2, o2;
    if (n2 === `in` || n2 === `notin` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), o2 = to_intervals$1(o2), o2[0] !== `interval`) return t4;
    let s2 = o2[1], c2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let l2 = s2[1], u2 = s2[2], d2 = [];
    c2[1] ? i2 ? d2.push([`<`, a2, l2]) : d2.push([`ge`, a2, l2]) : i2 ? d2.push([`le`, a2, l2]) : d2.push([`>`, a2, l2]), c2[2] ? i2 ? d2.push([`>`, a2, u2]) : d2.push([`le`, a2, u2]) : i2 ? d2.push([`ge`, a2, u2]) : d2.push([`<`, a2, u2]);
    let p2;
    return p2 = i2 ? [`or`].concat(d2) : [`and`].concat(d2), p2;
  }
  if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
    let i2 = false;
    (n2 === `notsubset` || n2 === `notsuperset`) && (i2 = true);
    let a2, o2;
    if (n2 === `subset` || n2 === `notsubset` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), a2 = to_intervals$1(a2), o2 = to_intervals$1(o2), a2[0] !== `interval` || o2[0] !== `interval`) return t4;
    let s2 = a2[1], c2 = a2[2], l2 = o2[1], u2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple` || l2[0] !== `tuple` || u2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let d2 = s2[1], p2 = s2[2], m2 = l2[1], h2 = l2[2], g2 = [];
    c2[1] && !u2[1] ? i2 ? g2.push([`le`, d2, m2]) : g2.push([`>`, d2, m2]) : i2 ? g2.push([`<`, d2, m2]) : g2.push([`ge`, d2, m2]), c2[2] && !u2[2] ? i2 ? g2.push([`ge`, p2, h2]) : g2.push([`<`, p2, h2]) : i2 ? g2.push([`>`, p2, h2]) : g2.push([`le`, p2, h2]);
    let v2;
    return v2 = i2 ? [`or`].concat(g2) : [`and`].concat(g2), v2;
  }
  return t4;
}
function substitute$2(t4, n2) {
  var r2 = get_tree$1(t4), i2 = {};
  for (let t5 in n2) i2[t5] = get_tree$1(n2[t5]);
  return substitute$1$1(r2, i2);
}
function substitute_component$1(t4, n2, r2) {
  let i2 = get_tree$1(t4);
  get_tree$1(r2);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid substitute_component: ` + n2);
  let o2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return s2(i2, n2);
  function s2(t5, n3, i3) {
    if (n3.length === 0) return r2;
    if (!Array.isArray(t5)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let a2 = t5[0], c2 = t5.slice(1);
    if (!o2.includes(a2)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let l2 = n3[0];
    if (l2 < 0 || l2 > c2.length - 1) throw Error(`Invalid substitute_component: component out of range`);
    let u2 = n3.slice(1), d2 = s2(c2[l2], u2);
    return [a2, ...c2.slice(0, l2), d2, ...c2.slice(l2 + 1)];
  }
}
function get_component$1(t4, n2) {
  let r2 = get_tree$1(t4);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid get_component: ` + n2);
  let i2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return a2(r2, n2);
  function a2(t5, n3) {
    if (n3.length === 0) return t5;
    if (!Array.isArray(t5)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let r3 = t5[0], o2 = t5.slice(1);
    if (!i2.includes(r3)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let s2 = n3[0];
    if (s2 < 0 || s2 > o2.length - 1) throw Error(`Invalid get_component: component out of range`);
    let c2 = n3.slice(1);
    return a2(o2[s2], c2);
  }
}
function apply_root$1(t4, n2) {
  return n2 === 2 ? [`apply`, `sqrt`, t4] : n2 === 3 ? [`apply`, `cbrt`, t4] : [`apply`, `nthroot`, [`tuple`, t4, n2]];
}
function pull_number_outside_root$1(t4, n2 = 2) {
  let r2 = t4, i2 = 1, a2 = 2, o2 = mathjs_default$1.pow(a2, n2);
  for (; o2 <= Math.abs(r2); ) r2 % o2 === 0 ? (r2 /= o2, i2 *= a2) : (a2++, o2 = mathjs_default$1.pow(a2, n2));
  return { n_outside: i2, n_inside: r2 };
}
function make_power$1(t4, n2) {
  return n2 === 0 ? 1 : n2 === 1 ? t4 : [`^`, t4, n2];
}
function collect_radicand_factors$1(t4, n2) {
  let r2 = 1, i2 = (t5) => {
    if (Array.isArray(t5) && t5[0] === `*`) for (let n3 of t5.slice(1)) i2(n3);
    else Array.isArray(t5) && t5[0] === `-` ? (r2 = -r2, i2(t5[1])) : typeof t5 == `number` && t5 < 0 ? (r2 = -r2, n2.push(-t5)) : n2.push(t5);
  };
  return i2(t4), r2;
}
function combine_factors$1(t4, n2) {
  let r2 = 1, i2 = /* @__PURE__ */ new Map(), a2 = /* @__PURE__ */ new Map(), o2 = [], s2 = [];
  for (let c2 of t4) {
    if (typeof c2 == `number`) {
      r2 *= c2;
      continue;
    }
    let t5, l2;
    if (typeof c2 == `string`) t5 = c2, l2 = 1;
    else if (Array.isArray(c2) && c2[0] === `^` && typeof c2[1] == `string` && Number.isInteger(c2[2])) t5 = c2[1], l2 = c2[2];
    else {
      s2.push(c2);
      continue;
    }
    if (a2.has(t5) || a2.set(t5, is_nonzero_ast$1(t5, n2) === true), l2 < 1 && !a2.get(t5)) {
      s2.push(c2);
      continue;
    }
    i2.has(t5) ? i2.set(t5, i2.get(t5) + l2) : (o2.push(t5), i2.set(t5, l2));
  }
  return { numberFactor: r2, expByVar: i2, varOrder: o2, others: s2 };
}
function pull_factor_into_root$1(t4, n2, r2, i2, a2, o2) {
  let s2 = n2 >= 1 ? Math.floor(n2 / r2) : 0;
  if (s2 === 0) {
    o2.push(make_power$1(t4, n2));
    return;
  }
  let c2;
  if (is_positive_ast$1(t4, i2, false)) c2 = t4;
  else if (r2 % 2 == 1 && is_real_ast$1(t4, i2)) c2 = t4;
  else if (r2 % 2 == 0 && is_real_ast$1(t4, i2)) c2 = s2 % 2 == 0 ? t4 : [`apply`, `abs`, t4];
  else {
    o2.push(make_power$1(t4, n2));
    return;
  }
  a2.push(make_power$1(c2, s2)), o2.push(make_power$1(t4, n2 % r2));
}
function simplify_powers_in_roots$1(t4, n2) {
  if (!Array.isArray(t4)) return t4;
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `*`) {
    let t5 = [];
    for (let r4 of i2) {
      let i3 = simplify_powers_in_roots$1(r4, n2);
      Array.isArray(i3) && i3[0] === `*` ? t5.push(...i3.slice(1)) : t5.push(i3);
    }
    let { numberFactor: r3, expByVar: a2, varOrder: o2, others: s2 } = combine_factors$1(t5, n2), c2 = [];
    r3 !== 1 && c2.push(r3);
    for (let t6 of o2) {
      let n3 = make_power$1(t6, a2.get(t6));
      n3 !== 1 && c2.push(n3);
    }
    return c2.push(...s2), c2.length === 0 ? 1 : c2.length === 1 ? c2[0] : [`*`, ...c2];
  }
  if (r2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(i2[0])) {
    let t5 = i2[0], r3 = 2, a2 = i2[1];
    if (t5 === `cbrt`) r3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(i2[1]) && i2[1][0] === `tuple`) if (Number.isInteger(i2[1][2]) && i2[1][2] > 0) r3 = i2[1][2], a2 = i2[1][1];
    else return [`apply`, `nthroot`, ...i2.slice(1).map((t6) => simplify_powers_in_roots$1(t6, n2))];
    else r3 = 2;
    a2 = simplify_powers_in_roots$1(a2, n2);
    let o2 = [], s2 = collect_radicand_factors$1(a2, o2), { numberFactor: c2, expByVar: l2, varOrder: u2, others: d2 } = combine_factors$1(o2, n2);
    if (c2 === 0) return 0;
    let p2 = [], m2 = [];
    if (Number.isInteger(c2)) {
      let { n_outside: t6, n_inside: n3 } = pull_number_outside_root$1(c2, r3);
      t6 !== 1 && p2.push(t6), n3 !== 1 && m2.push(n3);
    } else c2 !== 1 && m2.push(c2);
    for (let t6 of u2) pull_factor_into_root$1(t6, l2.get(t6), r3, n2, p2, m2);
    for (let t6 of d2) Array.isArray(t6) && t6[0] === `^` && Number.isInteger(t6[2]) ? pull_factor_into_root$1(t6[1], t6[2], r3, n2, p2, m2) : m2.push(t6);
    let h2 = m2.filter((t6) => t6 !== 1), g2;
    if (h2.length === 0) g2 = s2 < 0 ? -1 : 1;
    else {
      let t6 = h2.length === 1 ? h2[0] : [`*`, ...h2];
      g2 = s2 < 0 ? [`-`, t6] : t6;
    }
    let v2 = p2.filter((t6) => t6 !== 1);
    return g2 !== 1 && v2.push(apply_root$1(g2, r3)), v2.length === 0 ? 1 : v2.length === 1 ? v2[0] : [`*`, ...v2];
  }
  return [r2, ...i2.map((t5) => simplify_powers_in_roots$1(t5, n2))];
}
var simplify_exports$1 = __exportAll$1({ add_unit: () => add_unit$1, clean: () => clean$2, collapse_unary_minus: () => collapse_unary_minus$1, collect_like_terms_factors: () => collect_like_terms_factors$1, default_order: () => default_order$1, evaluate_numbers: () => evaluate_numbers$1, perform_vector_matrix_additions_scalar_multiplications: () => perform_vector_matrix_additions_scalar_multiplications$1, remove_scaling_units: () => remove_scaling_units$1, remove_units: () => remove_units$1, set_small_zero: () => set_small_zero$1, simplify: () => simplify$1, simplify_logical: () => simplify_logical$1, simplify_ratios: () => simplify_ratios$1 });
function clean$2(t4) {
  return flatten$5$1(get_tree$1(t4));
}
function evalf$1(t4, n2) {
  return parseFloat(mathjs_default$1.format(t4, { notation: `exponential`, precision: n2 }));
}
function collapse_unary_minus$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map((t5) => collapse_unary_minus$1(t5)), r2 === `-`) {
    if (typeof i2[0] == `number`) return -i2[0];
    if (Array.isArray(i2[0]) && i2[0][0] === `*` && typeof i2[0][1] == `number`) return [`*`, -i2[0][1]].concat(i2[0].slice(2));
    if (Array.isArray(i2[0]) && i2[0][0] === `/`) {
      if (typeof i2[0][1] == `number`) return [`/`, -i2[0][1], i2[0][2]];
      if (Array.isArray(i2[0][1]) && i2[0][1][0] === `*` && typeof i2[0][1][1] == `number`) return [`/`, [`*`, -i2[0][1][1]].concat(i2[0][1].slice(2)), i2[0][2]];
    }
  }
  return [r2].concat(i2);
}
function simplify$1(t4, n2, r2) {
  var i2 = get_tree$1(t4);
  return contains_blank$1(i2) || (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2 = evaluate_numbers$1(i2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), !Array.isArray(i2)) ? i2 : (i2 = simplify_logical$1(i2, n2), i2 = perform_vector_matrix_additions_scalar_multiplications$1(i2), i2 = simplify_integers_in_roots$1(i2), i2 = collect_like_terms_factors$1(i2, n2, r2), i2);
}
function simplify_logical$1(t4, n2) {
  var r2 = get_tree$1(t4);
  if (contains_blank$1(r2)) return r2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), r2 = evaluate_numbers$1(r2, { assumptions: n2 }), r2 = unflattenRight$1(r2);
  var i2 = [];
  return i2.push([[`not`, [`not`, `a`]], `a`]), i2.push([[`not`, [`and`, `a`, `b`]], [`or`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`or`, `a`, `b`]], [`and`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`=`, `a`, `b`]], [`ne`, `a`, `b`]]), i2.push([[`not`, [`ne`, `a`, `b`]], [`=`, `a`, `b`]]), i2.push([[`not`, [`<`, `a`, `b`]], [`le`, `b`, `a`]]), i2.push([[`not`, [`le`, `a`, `b`]], [`not`, [`le`, `a`, `b`]]]), i2.push([[`not`, [`in`, `a`, `b`]], [`notin`, `a`, `b`]]), i2.push([[`not`, [`subset`, `a`, `b`]], [`notsubset`, `a`, `b`]]), r2 = applyAllTransformations$1(r2, i2, 20), r2 = flatten$5$1(r2), r2;
}
function simplify_integers_in_roots$1(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = 1, n3 = [];
    for (let i2 of r2) if (typeof i2 == `number`) t5 *= i2;
    else {
      let r3 = simplify_integers_in_roots$1(i2);
      Array.isArray(r3) && r3[0] === `*` ? typeof r3[1] == `number` ? (t5 *= r3[1], n3.push(...r3.slice(2))) : n3.push(...r3.slice(1)) : n3.push(r3);
    }
    return t5 !== 1 && n3.unshift(t5), [`*`, ...n3];
  }
  if (n2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(r2[0])) {
    let t5 = r2[0], n3 = 2, i2 = r2[1];
    if (t5 === `cbrt`) n3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(r2[1]) && r2[1][0] === `tuple`) if (Number.isInteger(r2[1][2]) && r2[1][2] > 0) n3 = r2[1][2], i2 = r2[1][1];
    else return [`apply`, `nthroot`, ...r2.slice(1).map(simplify_integers_in_roots$1)];
    else n3 = 2;
    if (i2 = simplify_integers_in_roots$1(i2), Number.isInteger(i2)) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root$1(i2, n3);
      if (t6 !== 1) return [`*`, t6, apply_root$1(r3, n3)];
    } else if (Array.isArray(i2) && i2[0] === `*` && typeof i2[1] == `number`) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root$1(i2[1], n3);
      if (t6 !== 1) return [`*`, t6, apply_root$1([`*`, r3, ...i2.slice(2)], n3)];
    }
    return apply_root$1(i2, n3);
  }
  return [n2, ...r2.map(simplify_integers_in_roots$1)];
}
function perform_vector_matrix_additions_scalar_multiplications$1(t4, n2 = true) {
  var r2 = get_tree$1(t4);
  r2 = perform_matrix_scalar_multiplications$1(r2), r2 = perform_vector_scalar_multiplications$1(r2, n2);
  let i2 = [`+`, `a`, `b`];
  return r2 = transform$1(r2, function(t5) {
    let r3 = match$1$1(t5, i2, { allow_permutations: true });
    if (r3) {
      let i3 = [`vector`, `altvector`];
      n2 && i3.push(`tuple`);
      let a2 = {}, o2 = {}, s2 = [];
      if (i3.includes(r3.a[0])) {
        let t6 = r3.a.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.a);
      } else if (r3.a[0] === `matrix`) {
        let t6 = r3.a[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.a);
      } else s2.push(r3.a);
      if (i3.includes(r3.b[0])) {
        let t6 = r3.b.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.b);
      } else if (r3.b[0] === `matrix`) {
        let t6 = r3.b[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.b);
      } else if (r3.b[0] === `+`) for (let t6 of r3.b.slice(1)) if (i3.includes(t6[0])) {
        let n3 = t6.length - 1;
        a2[n3] || (a2[n3] = []), a2[n3].push(t6);
      } else if (t6[0] === `matrix`) {
        let n3 = t6[1].slice(1).toString();
        o2[n3] || (o2[n3] = []), o2[n3].push(t6);
      } else s2.push(t6);
      else s2.push(r3.b);
      if (Object.values(a2).every((t6) => t6.length < 2) && Object.values(o2).every((t6) => t6.length < 2)) return t5;
      let c2 = s2;
      for (let t6 in a2) if (a2[t6].length < 2) c2.push(...a2[t6]);
      else {
        let n3 = a2[t6].some((t7) => t7[0] === `vector`), r4 = a2[t6].some((t7) => t7[0] === `tuple`), i4 = a2[t6].some((t7) => t7[0] === `altvector`), o3;
        o3 = n3 || r4 && i4 ? [`vector`] : i4 ? [`altvector`] : [`tuple`];
        for (let n4 = 0; n4 < t6; n4++) o3.push([`+`, ...a2[t6].map((t7) => t7[n4 + 1])]);
        c2.push(o3);
      }
      for (let t6 in o2) if (o2[t6].length < 2) c2.push(...o2[t6]);
      else {
        let [n3, r4] = t6.split(`,`).map(Number), i4 = [`tuple`];
        for (let a4 = 0; a4 < n3; a4++) {
          let n4 = [`tuple`];
          for (let i5 = 0; i5 < r4; i5++) n4.push([`+`, ...o2[t6].map((t7) => t7[2][a4 + 1][i5 + 1])]);
          i4.push(n4);
        }
        let a3 = [`matrix`, [`tuple`, n3, r4], i4];
        c2.push(a3);
      }
      return c2.length === 1 ? c2[0] : [`+`, ...c2];
    } else return t5;
  }), r2;
}
function contains_decimal_number$1(t4) {
  return typeof t4 == `string` ? false : typeof t4 == `number` ? !!(Number.isFinite(t4) && !Number.isInteger(t4)) : Array.isArray(t4) ? t4.slice(1).some((t5) => contains_decimal_number$1(t5)) : false;
}
function contains_only_numbers$1(t4, { include_number_symbols: n2 = false, evaluate_functions: r2 = false } = {}) {
  return typeof t4 == `string` ? !!(n2 && (t4 === `e` && mathjs_default$1.define_e || t4 === `pi` && mathjs_default$1.define_pi) || t4 === `i` && mathjs_default$1.define_i) : typeof t4 == `number` ? true : Array.isArray(t4) ? r2 && t4[0] === `apply` ? t4.slice(2).every((t5) => contains_only_numbers$1(t5, { include_number_symbols: n2 })) : t4.slice(1).every((t5) => contains_only_numbers$1(t5, { include_number_symbols: n2 })) : false;
}
function try_evaluate_sum_of_numbers$1(t4, n2, r2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) return n2;
    if (typeof n2 == `number`) return t4 + n2;
    if (Array.isArray(n2) && n2[0] === `+` && typeof n2[1] == `number`) return [`+`, t4 + n2[1], n2[2]];
    if (!r2 && Array.isArray(n2) && n2[0] === `+` && typeof n2[2] == `number`) return [`+`, t4 + n2[2], n2[1]];
  }
  return typeof n2 == `number` && n2 === 0 ? t4 : null;
}
function try_evaluate_negate_number$1(t4) {
  if (typeof t4 == `number`) return -t4;
  if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return [`*`, -t4[1]].concat(t4.slice(2));
  if (Array.isArray(t4) && t4[0] === `/`) {
    if (typeof t4[1] == `number`) return [`/`, -t4[1], t4[2]];
    if (Array.isArray(t4[1]) && t4[1][0] === `*` && typeof t4[1][1] == `number`) return [`/`, [`*`, -t4[1][1]].concat(t4[1].slice(2)), t4[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers$1(t4, n2) {
  if (typeof t4 == `number`) {
    if (isNaN(t4)) return NaN;
    if (typeof n2 == `number`) return t4 * n2;
    if (!isFinite(t4)) return t4 === 1 / 0 && is_negative_ast$1(n2) || t4 === -1 / 0 && is_positive_ast$1(n2) ? -1 / 0 : is_nonzero_ast$1(n2) === false ? NaN : 1 / 0;
    if (t4 === 0) return 0;
    if (t4 === 1) return n2;
    if (t4 === -1) return [`-`, n2];
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) return t4 *= n2[1], n2 = n2[2], t4 === 1 ? n2 : t4 === -1 ? [`-`, n2] : [`*`, t4, n2];
  }
  if (typeof n2 == `number`) {
    if (isNaN(n2)) return NaN;
    if (!isFinite(n2)) return n2 === 1 / 0 && is_negative_ast$1(t4) || n2 === -1 / 0 && is_positive_ast$1(t4) ? -1 / 0 : is_nonzero_ast$1(t4) === false ? NaN : 1 / 0;
    if (n2 === 0) return 0;
    if (n2 === 1) return t4;
    if (n2 === -1) return [`-`, t4];
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return n2 *= t4[1], t4 = t4[2], n2 === 1 ? t4 : n2 === -1 ? [`-`, t4] : [`*`, t4, n2];
  }
  if (mathjs_default$1.define_i && t4 === `i`) {
    if (n2 === `i`) return -1;
    if (Array.isArray(n2) && n2[0] === `*` && n2[1] === `i`) return [`-`, n2[2]];
  } else if (mathjs_default$1.define_i && n2 === `i` && Array.isArray(t4) && t4[0] === `*` && t4[1] === `i`) return [`-`, t4[2]];
  return null;
}
function try_evaluate_quotient_of_numbers$1(t4, n2, r2, i2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) {
      let t5 = is_nonzero_ast$1(n2, r2);
      if (t5) return 0;
      if (t5 === false) return NaN;
    }
    if (typeof n2 == `number`) {
      let r3 = t4 / n2;
      if (i2 === 1 / 0 || mathjs_default$1.round(r3, i2) === r3) return r3;
      if (n2 < 0) return [`/`, -t4, -n2];
    }
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) {
      let r3 = t4 / n2[1];
      if (i2 === 1 / 0 || mathjs_default$1.round(r3, i2) === r3) return [`/`, r3, n2[2]];
    }
  } else if (typeof n2 == `number`) {
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) {
      let r4 = t4[1] / n2;
      if (i2 === 1 / 0 || mathjs_default$1.round(r4, i2) === r4) return r4 === 1 ? t4[2] : [`*`, r4, t4[2]];
      if (n2 < 0) return [`/`, [`*`, -t4[1], t4[2]], -n2];
    }
    let r3 = 1 / n2;
    if (i2 === 1 / 0 || mathjs_default$1.round(r3, i2) === r3) return [`*`, r3, t4];
    if (n2 < 0) return Array.isArray(t4) && t4[0] === `-` ? [`/`, t4[1], -n2] : [`-`, [`/`, t4, -n2]];
  }
  return null;
}
function set_small_zero$1(t4, n2 = 1e-14) {
  var r2 = get_tree$1(t4);
  return typeof r2 == `number` ? mathjs_default$1.abs(r2) < n2 ? 0 : r2 : Array.isArray(r2) ? [r2[0], ...r2.slice(1).map((t5) => set_small_zero$1(t5, n2))] : r2;
}
function evaluate_numbers_sub$1(t4, n2, r2, i2, a2, o2) {
  if (t4 === void 0) return t4;
  if (typeof t4 == `number`) return o2 > 0 && mathjs_default$1.abs(t4) < o2 ? 0 : t4;
  if (contains_only_numbers$1(t4, { include_number_symbols: true, evaluate_functions: a2 })) {
    let n3 = function(n4) {
      if (o2 > 0 && mathjs_default$1.abs(n4) < o2) return 0;
      if (r2 === 1 / 0 || Number.isInteger(n4)) return n4;
      let i3 = evalf$1(n4, 14), s3 = evalf$1(n4, r2);
      if (r2 === 0 && (s3 = mathjs_default$1.round(n4)), s3 === i3 || contains_decimal_number$1(t4) && contains_only_numbers$1(t4, { include_number_symbols: true, evaluate_functions: a2 })) return n4;
      let c3 = mathjs_default$1.fraction(n4), l3 = { n: mathjs_default$1.number(c3.n), d: mathjs_default$1.number(c3.d), s: mathjs_default$1.number(c3.s) }, u2 = evalf$1(l3.d, 3);
      return (l3.n < 1e4 || u2 === l3.d) && evalf$1(l3.s * l3.n / l3.d, 14) === i3 ? l3.d === 1 ? l3.s * l3.n : [`/`, l3.s * l3.n, l3.d] : null;
    };
    var s2 = evaluate_to_constant$1(t4, { remove_units_first: false });
    if (!Number.isNaN(s2)) {
      if (typeof s2 == `number`) {
        if (Number.isFinite(s2)) {
          let t5 = n3(s2);
          if (t5 !== null) return t5;
        }
      } else if (s2 && Number.isFinite(s2.re) && Number.isFinite(s2.im)) {
        let t5 = n3(s2.re), r3 = n3(s2.im);
        if (t5 !== null && r3 !== null) {
          if (r3 === 0) return t5;
          {
            let n4;
            return n4 = r3 === 1 ? `i` : r3 === -1 ? [`-`, `i`] : [`*`, r3, `i`], t5 === 0 ? n4 : [`+`, t5, n4];
          }
        }
      }
    }
  }
  if (!Array.isArray(t4)) return t4;
  var c2 = t4[0], l2 = t4.slice(1).map((t5) => evaluate_numbers_sub$1(t5, n2, r2, i2, a2, o2));
  if (c2 === `+`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_sum_of_numbers$1(t5, n3, i2);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree$1(t5), a3 = get_unit_of_tree$1(n3);
      if (r4 && r4 === a3) {
        let a4 = try_evaluate_sum_of_numbers$1(remove_units$1(t5, false), remove_units$1(n3, false), i2);
        if (a4 !== null) return add_unit$1(a4, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `-`) {
    let t5 = try_evaluate_negate_number$1(l2[0]);
    if (t5 !== null) return t5;
    if (l2[0][0] === `unit`) {
      let t6 = get_unit_of_tree$1(l2[0]);
      if (t6) {
        let n3 = try_evaluate_negate_number$1(remove_units$1(l2[0], false));
        if (n3 !== null) return add_unit$1(n3, t6);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `*`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_product_of_numbers$1(t5, n3);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] !== `unit`) {
      let r4 = get_unit_of_tree$1(t5);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers$1(remove_units$1(t5, false), n3);
        if (i3 !== null) return add_unit$1(i3, r4);
      }
    }
    if (t5[0] !== `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree$1(n3);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers$1(t5, remove_units$1(n3, false));
        if (i3 !== null) return add_unit$1(i3, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `/`) {
    let t5 = l2[0], i3 = l2[1], a3 = try_evaluate_quotient_of_numbers$1(t5, i3, n2, r2);
    if (a3 !== null) return a3;
    if (t5[0] === `unit` && i3[0] !== `unit`) {
      let a4 = get_unit_of_tree$1(t5);
      if (a4) {
        let o3 = try_evaluate_quotient_of_numbers$1(remove_units$1(t5, false), i3, n2, r2);
        if (o3 !== null) return add_unit$1(o3, a4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `^`) {
    let t5 = l2[0], i3 = l2[1];
    if (typeof i3 == `number`) {
      if (i3 === 0) {
        if (!mathjs_default$1.pow_strict) return 1;
        let r3 = is_nonzero_ast$1(t5, n2);
        if (r3 && t5 !== 1 / 0 && t5 !== -1 / 0) return 1;
        if (r3 === false) return NaN;
      } else if (i3 === 1) return t5;
      else if (typeof t5 == `number`) {
        let n3 = mathjs_default$1.pow(t5, i3);
        if (r2 === 1 / 0 || mathjs_default$1.round(n3, r2) === n3) return n3;
      }
    } else if (t5 === 1) return 1;
    return [c2].concat(l2);
  }
  return [c2].concat(l2);
}
function evaluate_numbers$1(t4, { assumptions: n2, max_digits: r2, skip_ordering: i2 = false, evaluate_functions: a2 = false, set_small_zero: o2 = 0 } = {}) {
  (r2 === void 0 || !(Number.isInteger(r2) || r2 === 1 / 0)) && (r2 = 0), o2 === true && (o2 = 1e-14);
  var s2 = get_tree$1(t4);
  if (contains_blank$1(s2)) return s2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()]));
  var c2;
  return i2 ? (s2 = unflattenRight$1(flatten$5$1(s2)), c2 = evaluate_numbers_sub$1(s2, n2, r2, i2, a2, o2)) : (s2 = move_units_outside_products$1(s2), s2 = unflattenRight$1(default_order$1(flatten$5$1(s2))), c2 = default_order$1(evaluate_numbers_sub$1(s2, n2, r2, i2, a2, o2)), c2 = default_order$1(evaluate_numbers_sub$1(unflattenRight$1(c2), n2, r2, i2, a2, o2))), c2 = set_negative_zeros_to_zero$1(c2), flatten$5$1(c2);
}
function set_negative_zeros_to_zero$1(t4) {
  return t4 === 0 ? 0 : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map(set_negative_zeros_to_zero$1)] : t4;
}
function collect_like_terms_factors$1(t4, n2, r2) {
  function i2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  function a2(t5) {
    return !!(typeof t5 == `number` && t5 < 0 || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number` && t5 > 0);
  }
  function o2(t5) {
    if (typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`) return true;
    var n3 = evaluate_to_constant$1(t5, { remove_units_first: false });
    return !!Number.isFinite(n3);
  }
  let s2 = (t5) => !contains_pm$1(t5);
  var c2 = get_tree$1(t4);
  if (contains_blank$1(c2)) return c2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), c2 = evaluate_numbers$1(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true });
  var l2 = [];
  l2.push([[`/`, `x`, [`^`, `y`, `a`]], [`*`, `x`, [`^`, `y`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2 }]), l2.push([[`/`, `x`, [`apply`, `exp`, `a`]], [`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2, variables: { x: true, a: true } }]), l2.push([[`/`, `x`, `y`], [`*`, `x`, [`^`, `y`, [`-`, 1]]], { evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations$1(c2, l2, 40), l2 = [];
  for (let t5 in all_units$2) all_units$2[t5].prefix ? (l2.push([[`+`, [`unit`, t5, `x`], [`unit`, t5, `y`]], [`unit`, t5, [`+`, `x`, `y`]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, t5, `x`], [`-`, [`unit`, t5, `y`]]], [`unit`, t5, [`+`, `x`, [`-`, `y`]]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }])) : (l2.push([[`+`, [`unit`, `x`, t5], [`unit`, `y`, t5]], [`unit`, [`+`, `x`, `y`], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, `x`, t5], [`-`, [`unit`, `y`, t5]]], [`unit`, [`+`, `x`, [`-`, `y`]], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]));
  return l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: (t5) => is_nonzero_ast$1(t5, n2) && s2(t5), n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_positive_ast$1(t5, n2), m: (t5) => i2(t5) && is_positive_ast$1(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`-`, [`^`, `x`, `n`]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_negative_ast$1(t5, n2), m: (t5) => i2(t5) && is_negative_ast$1(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`apply`, `exp`, `n`], [`apply`, `exp`, `m`]], [`apply`, `exp`, [`+`, `n`, `m`]], { variables: { n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`*`, `m`, `x`]], [`*`, [`+`, `n`, `m`], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, `n1`, [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, `n1`, [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`-`, [`*`, `m`, `x`]]], [`*`, [`+`, `n`, [`-`, `m`]], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`-`, [`pm`, `x`]], [`pm`, `x`], { variables: { x: true } }]), l2.push([[`*`, `c`, [`pm`, `x`]], [`pm`, [`*`, `c`, `x`]], { variables: { c: (t5) => !contains_pm$1(t5), x: true }, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`*`, `x`, `y`], `a`], [`*`, [`^`, `x`, `a`], [`^`, `y`, `a`]], { allow_permutations: true }]), l2.push([[`^`, [`^`, `x`, `n`], `m`], [`^`, `x`, [`*`, `n`, `m`]], { variables: { x: true, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_permutations: true }]), l2.push([[`-`, [`+`, `a`, `b`]], [`+`, [`-`, `a`], [`-`, `b`]]]), l2.push([[`apply`, `cbrt`, [`*`, `a`, `x`]], [`-`, [`apply`, `cbrt`, [`-`, [`*`, `a`, `x`]]]], { variables: { a: (t5) => is_negative_ast$1(t5, n2), x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `cbrt`, [`-`, `x`]], [`-`, [`apply`, `cbrt`, `x`]], { variables: { x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`*`, `a`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, [`-`, [`*`, `a`, `x`]], `n`]]], { variables: { a: (t5) => is_negative_ast$1(t5, n2), x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`-`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, `x`, `n`]]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`^`, [`apply`, `abs`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`*`, `x`, `y`], [`*`, `x`, `y`], { variables: { x: o2, y: o2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations$1(c2, l2, 40), c2 = simplify_powers_in_roots$1(c2, n2), l2 = [], l2.push([[`*`, `x`, [`^`, `y`, [`-`, `a`]]], [`/`, `x`, [`^`, `y`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], [`/`, `x`, [`apply`, `exp`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1, variables: { x: true, a: true } }]), l2.push([[`*`, `x`, [`^`, `y`, `n`]], [`/`, `x`, [`^`, `y`, [`-`, `n`]]], { variables: { x: true, y: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, `n`]], [`/`, `x`, [`apply`, `exp`, [`-`, `n`]]], { variables: { x: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations$1(c2, l2, 40), l2 = [], l2.push([[`^`, `y`, `n`], [`/`, 1, [`^`, `y`, [`-`, `n`]]], { variables: { y: true, n: a2 }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`apply`, `exp`, `n`], [`/`, 1, [`apply`, `exp`, [`-`, `n`]]], { variables: { n: a2 }, evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations$1(c2, l2, 40), l2 = [], l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations$1(c2, l2, 40), l2 = [], l2.push([[`*`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `y`], `z`], { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations$1(c2, l2, 40), c2 = evaluate_numbers$1(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), c2;
}
function simplify_ratios$1(t4, n2) {
  function r2(t5) {
    var n3 = 1;
    return t5 = t5.map(function(t6) {
      if (typeof t6 == `number`) return t6 < 0 ? (n3 *= -1, -t6) : t6;
      if (!Array.isArray(t6)) return t6;
      if (t6[0] === `-`) return n3 *= -1, t6[1];
      if (t6[0] !== `+`) return t6;
      var r3 = false;
      if ((typeof t6[1] == `number` && t6[1] < 0 || Array.isArray(t6[1]) && t6[1][0] === `-` || Array.isArray(t6[1]) && t6[1][0] === `*` && Number(t6[1][1]) < 0) && (r3 = true), r3) {
        n3 *= -1;
        var i3 = t6.slice(1).map((t7) => [`-`, t7]);
        return evaluate_numbers$1([`+`].concat(i3));
      } else return t6;
    }), { factors: t5, sign_change: n3 };
  }
  function i2(t5, n3) {
    if (!Array.isArray(t5)) return n3 ? [`-`, t5] : t5;
    var a3 = t5[0];
    if (a3 === `-`) return i2(t5[1], n3 = true);
    var o2 = t5.slice(1).map((t6) => i2(t6));
    if (a3 !== `/`) return n3 ? [`-`, [a3, ...o2]] : [a3, ...o2];
    var s2 = o2[0], c2 = o2[1];
    s2 = default_order$1(s2, { ignore_negatives: true });
    var l2 = Array.isArray(s2) && s2[0] === `*` ? s2.slice(1) : [s2], u2 = r2(l2);
    l2 = u2.factors, n3 && (u2.sign_change *= -1), c2 = default_order$1(c2, { ignore_negatives: true });
    var d2 = Array.isArray(c2) && c2[0] === `*` ? c2.slice(1) : [c2], p2 = r2(d2);
    return d2 = p2.factors, u2.sign_change * p2.sign_change < 0 && (l2[0] = [`-`, l2[0]]), s2 = l2.length === 1 ? l2[0] : [`*`].concat(l2), c2 = d2.length === 1 ? d2[0] : [`*`].concat(d2), [`/`, s2, c2];
  }
  var a2 = get_tree$1(t4);
  return contains_blank$1(a2) ? a2 : (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2(a2));
}
function contains_blank$1(t4) {
  return t4 === `＿` ? true : Array.isArray(t4) ? t4.some(contains_blank$1) : false;
}
var all_units$2 = get_all_units$1();
function remove_units$1(t4, n2 = true) {
  var r2 = get_tree$1(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  if (i2 === `unit`) {
    let t5 = all_units$2[get_unit_of_tree$1(r2)];
    if (!t5) return r2;
    let i3 = remove_units$1(t5.prefix ? a2[1] : a2[0], n2);
    return n2 ? t5.scale(i3) : i3;
  } else return [i2, ...a2.map((t5) => remove_units$1(t5, n2))];
}
function remove_scaling_units$1(t4) {
  var n2 = get_tree$1(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `unit`) {
    let t5 = all_units$2[get_unit_of_tree$1(n2)];
    if (!(t5 && t5.only_scales)) return n2;
    let r3 = remove_scaling_units$1(t5.prefix ? i2[1] : i2[0]);
    return t5.scale(r3);
  } else return [r2, ...i2.map((t5) => remove_scaling_units$1(t5))];
}
function add_unit$1(t4, n2) {
  var r2 = get_tree$1(t4);
  let i2 = all_units$2[n2];
  return i2 ? i2.prefix ? [`unit`, n2, r2] : [`unit`, r2, n2] : r2;
}
function move_units_outside_products$1(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = [], n3 = [];
    for (let i3 of r2) {
      let r3 = get_unit_value_of_tree$1(i3);
      r3 ? (t5.push(r3[0]), n3.push(r3[1])) : n3.push(i3);
    }
    let i2 = [`*`, ...n3];
    for (let n4 of t5) i2 = add_unit$1(i2, n4);
    return i2;
  } else return [n2, ...r2.map(move_units_outside_products$1)];
}
var solve_exports$1 = __exportAll$1({ solve_linear: () => solve_linear$1 });
function solve_linear$1(t4, n2, r2) {
  if (typeof n2 == `string`) {
    r2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (r2 = t4.context.get_assumptions([t4.variables()]));
    var i2 = simplify$1(get_tree$1(t4), r2);
    if (Array.isArray(i2)) {
      var a2 = i2[0], o2 = i2.slice(1);
      if (a2 === `=` || a2 === `ne` || a2 === `<` || a2 === `le` || a2 === `>` || a2 === `ge`) {
        var s2 = simplify$1([`+`, o2[0], [`-`, o2[1]]], r2), c2 = (t5) => !variables$1(t5).includes(n2);
        if (s2 = simplify$1(applyAllTransformations$1(s2, [[[`+`, [`*`, `_a`, n2], [`*`, `_b`, n2]], [`*`, [`+`, `_a`, `_b`], n2], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_extended_match: true, allow_implicit_identities: [`_a`, `_b`], evaluate_numbers: true }]], 20)), variables$1(s2).includes(n2)) {
          var l2 = match$1$1(s2, [`+`, [`*`, `_a`, n2], `_b`], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_implicit_identities: [`_a`, `_b`] });
          if (l2) {
            var u2 = simplify$1(l2._a), d2 = simplify$1(l2._b);
            if (is_nonzero_ast$1(u2, r2)) {
              if (a2 === `=` || a2 === `ne` || is_positive_ast$1(u2, r2)) {
                let t5 = simplify$1([`/`, [`-`, d2], u2]);
                return [a2, n2, t5];
              }
              if (is_negative_ast$1(u2, r2)) {
                var p2 = simplify$1([`/`, [`-`, d2], u2]);
                return a2 = a2 === `<` ? `>` : a2 === `le` ? `ge` : a2 === `>` ? `<` : `le`, [a2, n2, p2];
              }
            }
          }
        }
      }
    }
  }
}
function clean_assumptions$1(t4, n2) {
  if (!Array.isArray(t4) || t4.length === 0) return t4;
  t4 = flatten$5$1(default_order$1(simplify_logical$1(expand_relations$1(t4))));
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `and` || r2 === `or`) {
    if (i2 = i2.reduce(function(t5, n3) {
      return t5.every(function(t6) {
        return !equal$1(t6, n3);
      }) && t5.push(n3), t5;
    }, []), r2 === `and` && n2 && Array.isArray(n2)) {
      let t5;
      t5 = n2[0] === `and` ? n2.slice(1) : [n2], i2 = i2.filter((n3) => t5.every((t6) => !equal$1(t6, n3)));
    }
    t4 = i2.length === 1 ? i2[0] : [r2].concat(i2);
  }
  if (r2 !== `and` && n2 && Array.isArray(n2)) {
    let r3;
    if (r3 = n2[0] === `and` ? n2.slice(1) : [n2], !r3.every((n3) => !equal$1(n3, t4))) return;
  }
  return t4;
}
function calculate_derived_assumptions$1(t4, n2) {
  if (n2 === void 0) {
    n2 = [];
    for (let r3 in t4.byvar) {
      let i3 = t4.byvar[r3];
      i3.length > 0 && n2.push(i3);
    }
    if (n2.length === 0) return {};
    n2 = n2.length === 1 ? n2[0] : [`and`].concat(n2), n2 = clean_assumptions$1(n2);
  }
  if (!Array.isArray(n2) || n2.length === 0) return {};
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `and` || r2 === `or`) {
    let n3 = i2.map(function(n4) {
      return calculate_derived_assumptions$1(t4, n4);
    }), a3 = [...new Set(n3.reduce((t5, n4) => [...t5, ...Object.keys(n4)], []))], o3 = {};
    for (let i3 of a3) {
      let a4 = n3.reduce(function(t5, n4) {
        return n4[i3] !== void 0 && t5.push(n4[i3]), t5;
      }, []);
      if (r2 === `and` || a4.length === n3.length) {
        let n4 = o3[i3];
        n4 = n4 === void 0 ? a4.length > 1 ? [r2].concat(a4) : a4[0] : a4.length > 1 ? [`and`, n4, [r2].concat(a4)] : [`and`, n4, a4[0]], o3[i3] = clean_assumptions$1(n4, get_assumptions$1(t4, i3, { omit_derived: true }));
      }
    }
    return o3;
  }
  let a2 = {};
  if (r2 === `=` || r2 === `ne` || r2 === `<` || r2 === `le` || r2 === `in` || r2 === `subset` || r2 === `notin` || r2 === `notsubset`) {
    var o2 = false;
    for (let n3 = 0; n3 < 2; n3++) {
      let c3 = i2[n3], l2 = i2[1 - n3], u2 = variables$1(l2);
      if (typeof c3 != `string` || u2.length === 0 || u2.includes(c3)) continue;
      o2 = true;
      var s2 = r2;
      n3 === 1 && (r2 === `<` ? s2 = `>` : r2 === `le` ? s2 = `ge` : r2 === `in` ? s2 = `ni` : r2 === `subset` ? s2 = `superset` : r2 === `notin` ? s2 = `notni` : r2 === `notsubset` && (s2 = `notsuperset`));
      let d2 = get_assumptions_for_expr$1(t4, l2, [c3]);
      if (d2 = combine_assumptions$1(c3, s2, l2, d2), d2 !== void 0) {
        let n4 = a2[c3];
        n4 = n4 === void 0 ? d2 : [`and`, n4, d2], a2[c3] = clean_assumptions$1(n4, get_assumptions$1(t4, c3, { omit_derived: true }));
      }
    }
    if (o2) return a2;
  }
  let c2 = [];
  for (let n3 of i2) {
    let r3 = get_assumptions_for_expr$1(t4, n3, []);
    r3 !== void 0 && c2.push(r3);
  }
  if (c2.length === 0) return {};
  c2 = c2.length === 1 ? c2[0] : [`and`].concat(c2);
  for (let r3 of variables$1(n2)) a2[r3] = clean_assumptions$1(c2, get_assumptions$1(t4, r3, { omit_derived: true }));
  return a2;
}
function get_assumptions_for_expr$1(t4, n2, r2) {
  let i2 = variables$1(n2);
  if (i2 = i2.filter((t5) => !r2.includes(t5)), i2.length === 0) return;
  function a2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  var o2 = [`_b`], s2 = [`_b`], c2 = { _b: a2 }, l2 = {};
  for (let t5 = 0; t5 < i2.length; t5++) {
    let n3 = `_a` + t5;
    l2[i2[t5]] = n3, o2.push([`*`, n3, i2[t5]]), s2.push(n3), c2[n3] = a2;
  }
  o2 = [`+`].concat(o2);
  var u2 = match$1$1(n2, o2, { variables: c2, allow_permutations: true, allow_extended_match: false, allow_implicit_identities: s2, max_group: 1 });
  if (!u2) {
    let i3 = [];
    for (let a3 of variables$1(n2)) {
      let n3 = get_assumptions_for_expr$1(t4, a3, r2);
      n3 !== void 0 && i3.push(n3);
    }
    return i3.length === 0 ? void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
  }
  for (let t5 of i2) l2[t5] = u2[l2[t5]];
  let d2 = false;
  u2._b === 0 && u2._a0 === 1 && i2.length === 1 && (d2 = true);
  var p2 = get_assumptions$1(t4, [i2], { exclude_variables: r2 });
  if (p2 === void 0) return;
  return clean_assumptions$1(m2(p2));
  function m2(a3) {
    if (!Array.isArray(a3)) return;
    var o3 = a3[0], s3 = a3.slice(1);
    if (o3 === `and` || o3 === `or`) {
      let t5 = s3.map(m2).filter((t6) => t6 !== void 0);
      return t5.length === 0 ? void 0 : o3 === `or` ? t5.length === s3.length ? [`or`].concat(t5) : void 0 : t5.length === 1 ? t5[0] : [`and`].concat(t5);
    }
    if (!([`=`, `ne`, `<`, `le`].includes(o3) || [`in`, `notin`, `subset`, `notsubset`].includes(o3) && d2)) {
      let i3 = r2.concat(variables$1(n2)), o4 = [];
      for (let n3 of variables$1(a3)) {
        if (i3.includes(n3)) continue;
        let r3 = get_assumptions_for_expr$1(t4, n3, i3);
        r3 !== void 0 && o4.push(r3);
      }
      return o4.length === 0 ? a3 : o4.length === 1 ? [`and`, a3, o4[0]] : [`and`, a3].concat(o4);
    }
    let c3 = [];
    for (let a4 = 0; a4 <= 1; a4++) {
      let d3 = s3[a4], m3 = s3[1 - a4];
      if (typeof d3 == `string` && i2.includes(d3)) {
        var u3 = {};
        u3[d3] = m3;
        var p3 = simplify$1(substitute$1$1(n2, u3)), h2 = false, g2 = o3;
        (a4 === 1 && l2[d3] > 0 || a4 === 0 && l2[d3] < 0) && (o3 === `<` ? (h2 = true, g2 = `>`) : o3 === `le` ? (h2 = true, g2 = `ge`) : o3 === `in` ? (h2 = true, g2 = `ni`) : o3 === `subset` ? (h2 = true, g2 = `superset`) : o3 === `notin` ? (h2 = true, g2 = `notni`) : o3 === `notsubset` && (h2 = true, g2 = `notsuperset`)), h2 ? c3.push([o3, p3, n2]) : c3.push([o3, n2, p3]);
        let i3 = get_assumptions_for_expr$1(t4, p3, r2.concat([d3]));
        i3 = combine_assumptions$1(n2, g2, p3, i3), i3 !== void 0 && c3.push(i3);
      }
    }
    if (c3.length === 1) return c3[0];
    if (c3.length > 1) return [`and`].concat(c3);
    let v2 = r2.concat(variables$1(n2));
    c3 = [];
    for (let n3 of variables$1(a3)) {
      if (v2.includes(n3)) continue;
      let r3 = get_assumptions_for_expr$1(t4, n3, v2);
      r3 !== void 0 && c3.push(r3);
    }
    return c3.length === 0 ? a3 : c3.length === 1 ? [`and`, a3, c3[0]] : [`and`, a3].concat(c3);
  }
}
function combine_assumptions$1(t4, n2, r2, i2) {
  if (![`=`, `ne`, `<`, `le`, `>`, `ge`, `in`, `notin`, `ni`, `notni`, `subset`, `notsubset`, `superset`, `notsuperset`].includes(n2)) return i2;
  if (Array.isArray(i2)) {
    var a2 = i2[0], o2 = i2.slice(1);
    if (a2 === `and` || a2 === `or`) {
      let i3 = o2.map((i4) => combine_assumptions$1(t4, n2, r2, i4)).filter((t5) => t5 !== void 0);
      return i3.length === 0 ? void 0 : a2 === `or` ? i3.length === o2.length ? [[`or`].concat(i3)] : void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
    }
    if (![`=`, `ne`, `<`, `le`, `in`, `notin`, `subset`, `notsubset`].includes(a2)) return i2;
    var s2 = a2, c2;
    if (equal$1(o2[0], r2)) c2 = o2[1];
    else if (equal$1(o2[1], r2)) c2 = o2[0], a2 === `<` ? s2 = `>` : a2 === `le` ? s2 = `ge` : a2 === `in` ? s2 = `ni` : a2 === `notin` ? s2 = `notni` : a2 === `subset` ? s2 = `superset` : a2 === `notsubset` && (s2 = `notsuperset`);
    else return i2;
    var l2;
    if (n2 === `=`) l2 = s2;
    else if (s2 === `=`) l2 = n2;
    else if (n2 === `<`) if (s2 === `<` || s2 === `le`) l2 = `<`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `le`) if (s2 === `<`) l2 = `<`;
    else if (s2 === `le`) l2 = `le`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `>`) if (s2 === `>` || s2 === `ge`) l2 = `>`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `ge`) if (s2 === `>`) l2 = `>`;
    else if (s2 === `ge`) l2 = `ge`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `in`) if (s2 === `subset`) l2 = `in`;
    else return;
    else if (n2 === `notin`) if (s2 === `superset`) l2 = `notin`;
    else return;
    else if (n2 === `ni`) if (s2 === `notin`) l2 = `notsubset`;
    else return;
    else if (n2 === `notni`) if (s2 === `in`) l2 = `notsuperset`;
    else return;
    else if (n2 === `subset`) if (s2 === `subset`) l2 = `subset`;
    else if (s2 === `notni`) l2 = `notni`;
    else if (s2 === `notsuperset`) l2 = `notsuperset`;
    else return;
    else if (n2 === `notsubset`) if (s2 === `superset`) l2 = `notsubset`;
    else return;
    else if (n2 === `superset`) if (s2 === `superset`) l2 = `superset`;
    else if (s2 === `ni`) l2 = `ni`;
    else if (s2 === `notsubset`) l2 = `notsubset`;
    else return;
    else if (n2 === `notsuperset`) if (s2 === `subset`) l2 = `notsuperset`;
    else return;
    else return;
    return l2 === `>` ? [`<`, c2, t4] : l2 === `ge` ? [`le`, c2, t4] : l2 === `ni` ? [`in`, c2, t4] : l2 === `notni` ? [`notin`, c2, t4] : l2 === `superset` ? [`subset`, c2, t4] : l2 === `notsuperset` ? [`notsubset`, c2, t4] : [l2, t4, c2];
  }
}
function filter_assumptions_from_tree$1(t4, n2) {
  if (!(!Array.isArray(t4) || t4.length === 0)) {
    Array.isArray(n2) || (n2 = [n2]);
    var r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `and`) {
      var a2 = i2.map(function(t5) {
        return filter_assumptions_from_tree$1(t5, n2);
      });
      return a2 = a2.filter((t5) => t5 !== void 0), a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : [`and`].concat(a2);
    }
    var o2 = variables$1(t4);
    if (!(n2.filter((t5) => o2.includes(t5)).length > 0)) return t4;
  }
}
function get_assumptions_sub$1(t4, n2, r2, i2) {
  Array.isArray(n2) || (n2 = [n2]);
  var a2 = [];
  if (n2.forEach(function(n3) {
    if (t4.byvar[n3] || t4.derived[n3]) {
      if (t4.byvar[n3] && t4.byvar[n3].length > 0) {
        var o2 = filter_assumptions_from_tree$1(t4.byvar[n3], r2);
        o2 !== void 0 && a2.push(o2);
      }
      if (t4.derived[n3] && t4.derived[n3].length > 0 && !i2) {
        var s2 = filter_assumptions_from_tree$1(t4.derived[n3], r2);
        s2 !== void 0 && a2.push(s2);
      }
    } else t4.generic.length > 0 && (n3 === `x` || !variables$1(t4.generic).includes(n3)) && a2.push(substitute$1$1(t4.generic, { x: n3 }));
  }), a2.length === 1 ? a2 = a2[0] : a2.length > 1 && (a2 = [`and`].concat(a2)), a2.length > 0) return clean_assumptions$1(a2);
}
function get_assumptions$1(t4, n2, r2) {
  r2 === void 0 && (r2 = {});
  var i2 = r2.exclude_variables;
  i2 === void 0 ? i2 = [] : Array.isArray(i2) || (i2 = [i2]);
  var a2, o2 = get_tree$1(n2);
  if (typeof o2 == `string`) a2 = [o2];
  else if (Array.isArray(o2)) Array.isArray(o2[0]) && (a2 = o2[0]);
  else return;
  return a2 ? get_assumptions_sub$1(t4, a2, i2, r2.omit_derived) : get_assumptions_for_expr$1(t4, o2, i2);
}
function add_assumption$1(t4, n2, r2) {
  var i2 = get_tree$1(n2);
  if (!Array.isArray(i2)) return 0;
  i2 = clean_assumptions$1(simplify$1(i2, t4));
  var a2 = add_assumption_sub$1(t4, i2, r2);
  return a2 && (t4.derived = calculate_derived_assumptions$1(t4)), a2;
}
function add_assumption_sub$1(t4, n2, r2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_assumption_sub$1(t4, n3, r2)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var i2 = variables$1(n2);
  if (i2.length === 0) return 0;
  let a2 = 0;
  !r2 && t4.generic.length > 0 && i2.forEach(function(n3) {
    t4.byvar[n3] === void 0 && (n3 === `x` || !variables$1(t4.generic).includes(n3)) && (add_assumption_sub$1(t4, substitute$1$1(t4.generic, { x: n3 }), true), a2 += 1);
  });
  for (let r3 of i2) {
    let i3 = solve_linear$1(n2, r3, t4), o2 = n2;
    i3 && (o2 = i3);
    let s2 = t4.byvar[r3];
    s2 !== void 0 && s2.length !== 0 && (o2 = [`and`, s2, o2]), o2 = clean_assumptions$1(o2), equal$1(o2, s2) || (t4.byvar[r3] = o2, a2 += 1);
  }
  return a2;
}
function add_generic_assumption$1(t4, n2) {
  var r2 = get_tree$1(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$1(simplify$1(r2, t4));
  var i2 = add_generic_assumption_sub$1(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$1(t4)), i2;
}
function add_generic_assumption_sub$1(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_generic_assumption_sub$1(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables$1(n2).includes(`x`)) return 0;
  let r2 = solve_linear$1(n2, `x`, t4), i2 = n2;
  r2 && (i2 = r2);
  let a2 = t4.generic;
  return a2.length !== 0 && (i2 = [`and`, a2, i2]), i2 = clean_assumptions$1(i2), equal$1(i2, a2) ? 0 : (t4.generic = i2, 1);
}
function remove_assumption$1(t4, n2) {
  var r2 = get_tree$1(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$1(simplify$1(r2, t4));
  var i2 = remove_assumption_sub$1(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$1(t4)), i2;
}
function remove_assumption_sub$1(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_assumption_sub$1(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var r2 = variables$1(n2);
  if (r2.length === 0) return 0;
  var i2 = 0;
  for (let a2 of r2) {
    let r3 = solve_linear$1(n2, a2, t4), o2 = t4.byvar[a2];
    if (!o2 || o2.length === 0) continue;
    let s2 = o2[0], c2 = o2.slice(1), l2 = c2.length, u2;
    if (s2 === `and`) if (c2 = c2.filter((t5) => !(equal$1(t5, n2) || equal$1(t5, r3))), c2.length === 0) u2 = [];
    else if (c2.length === 1) u2 = c2[0];
    else if (c2.length < l2) u2 = [s2].concat(c2);
    else continue;
    else if (equal$1(o2, n2) || equal$1(o2, r3)) u2 = [];
    else continue;
    i2 += 1, t4.byvar[a2] = u2;
  }
  return i2;
}
function remove_generic_assumption$1(t4, n2) {
  var r2 = get_tree$1(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions$1(simplify$1(r2, t4));
  var i2 = remove_generic_assumption_sub$1(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions$1(t4)), i2;
}
function remove_generic_assumption_sub$1(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_generic_assumption_sub$1(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables$1(n2).includes(`x`)) return 0;
  var r2 = t4.generic;
  if (r2.length === 0) return 0;
  let i2 = solve_linear$1(n2, `x`, t4);
  var a2 = r2[0], o2 = r2.slice(1), s2 = o2.length, c2;
  if (a2 === `and`) if (o2 = o2.filter((t5) => !(equal$1(t5, n2) || equal$1(t5, i2))), o2.length === 0) c2 = [];
  else if (o2.length === 1) c2 = o2[0];
  else if (o2.length < s2) c2 = [a2].concat(o2);
  else return 0;
  else if (equal$1(r2, n2) || equal$1(r2, i2)) c2 = [];
  else return 0;
  return t4.generic = c2, 1;
}
function initialize_assumptions$1() {
  var t4 = {};
  return t4.byvar = {}, t4.derived = {}, t4.generic = [], t4.not_commutative = [], t4.get_assumptions = function(n2, r2) {
    return get_assumptions$1(t4, n2, r2);
  }, t4.add_assumption = function(n2, r2) {
    return add_assumption$1(t4, n2, r2);
  }, t4.add_generic_assumption = function(n2) {
    return add_generic_assumption$1(t4, n2);
  }, t4.remove_assumption = function(n2) {
    return remove_assumption$1(t4, n2);
  }, t4.remove_generic_assumption = function(n2) {
    return remove_generic_assumption$1(t4, n2);
  }, t4;
}
var operators$1$1 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `\\pm ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return `\\frac{` + t4[0] + `}{` + t4[1] + `}`;
}, _: function(t4) {
  return t4[0] + `_{` + t4[1] + `}`;
}, "^": function(t4) {
  return t4[0] + `^{` + t4[1] + `}`;
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, array: function(t4) {
  return `\\left[ ` + t4.join(`, `) + ` \\right]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `\\left\\{ ` + t4.join(`, `) + ` \\right\\}`;
}, vector: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, altvector: function(t4) {
  return `\\left\\langle ` + t4.join(`, `) + ` \\right\\rangle`;
}, interval: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, matrix: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, and: function(t4) {
  return t4.join(` \\land `);
}, or: function(t4) {
  return t4.join(` \\lor `);
}, not: function(t4) {
  return `\\lnot ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` \\le `);
}, ge: function(t4) {
  return t4.join(` \\ge `);
}, ne: function(t4) {
  return t4.join(` \\ne `);
}, forall: function(t4) {
  return `\\forall ` + t4[0];
}, exists: function(t4) {
  return `\\exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` \\in ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` \\notin ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` \\ni ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` \\not\\ni ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` \\subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` \\subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` \\not\\subset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` \\not\\subseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` \\supset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` \\supseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` \\not\\supset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` \\not\\supseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` \\cup `);
}, intersect: function(t4) {
  return t4.join(` \\cap `);
}, implies: function(t4) {
  return t4.join(` \\implies `);
}, impliedby: function(t4) {
  return t4.join(` \\impliedby `);
}, iff: function(t4) {
  return t4.join(` \\iff `);
}, leftarrow: function(t4) {
  return t4.join(` \\leftarrow `);
}, rightarrow: function(t4) {
  return t4.join(` \\rightarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` \\leftrightarrow `);
}, perp: function(t4) {
  return t4.join(` \\perp `);
}, parallel: function(t4) {
  return t4.join(` \\parallel `);
}, derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, partial_derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, "|": function(t4) {
  return t4[0] + ` \\mid ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `\\binom{` + t4[0] + `}{` + t4[1] + `}`;
}, vec: function(t4) {
  return `\\vec{` + t4[0] + `}`;
}, linesegment: function(t4) {
  return `\\overline{` + t4.join(` `) + `}`;
}, angle: function(t4, n2) {
  return n2 ? `\\angle ` + t4.join(``) : `\\angle\\left( ` + t4.join(`, `) + ` \\right)`;
}, unit: function(t4) {
  return t4[1] === `\\circ` ? t4[0] + `^{\\circ}` : t4[0] + ` ` + t4[1];
} }, allowedLatexSymbolsDefault$1$1 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.cot.coth.csc.csch.sec.sech.sin.sinh.tan.tanh.arcsin.arccos.arctan.arccsc.arcsec.arccot.arg.Re.Im.det.angle.perp.circ.%.$.int.varnothing`.split(`.`), convertLatexSymbolsDefault$1 = { acos: `arccos`, acosh: `arccosh`, acot: `arccot`, acoth: `arccoth`, acsc: `arccsc`, acsch: `arccsch`, asec: `arcsec`, asech: `arcsech`, asin: `arcsin`, asinh: `arcsinh`, atan: `arctan`, atanh: `arctanh`, deg: `circ`, emptyset: `varnothing` }, matrixEnvironmentDefault$1 = `bmatrix`, astToLatex$1$1 = class astToLatex$13 {
  constructor({ allowedLatexSymbols: t4 = allowedLatexSymbolsDefault$1$1, convertLatexSymbols: n2 = convertLatexSymbolsDefault$1, matrixEnvironment: r2 = matrixEnvironmentDefault$1, padToDigits: i2 = null, padToDecimals: a2 = null, avoidScientificNotation: o2 = false, showBlanks: s2 = true } = {}) {
    this.allowedLatexSymbols = t4, this.convertLatexSymbols = n2, this.matrixEnvironment = r2, this.padToDigits = i2, this.padToDecimals = a2, this.avoidScientificNotation = o2, this.showBlanks = s2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions$1(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `\\ldots`;
    if (!(n2 in operators$1$1) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? operators$1$1[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? operators$1$1[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return operators$1$1[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return operators$1$1[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return operators$1$1[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? a2 += ` \\le ` : a2 += ` \\ge `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : operators$1$1[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? operators$1$1[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `-` || n2 === `pm` ? operators$1$1[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : n2 === `*` ? operators$1$1[n2](r2.map((function(t5, n3) {
      let i2;
      return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(t5), i2.match(/^[0-9]/) ? `\\cdot ` + i2 : t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2) : (i2 = this.factor(t5), t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2);
    }).bind(this))) : n2 === `/` || n2 === `unit` ? operators$1$1[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  simple_factor_or_function_or_parens(t4) {
    var n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` && ![`sqrt`, `cbrt`, `nthroot`].includes(t4[1]) || n2.match(/^\\left\(.*\\right\)$/) || n2.match(/^\\left\\langle.*\\right\\rangle$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  stringConvert(t4) {
    return t4.length > 1 ? (this.convertLatexSymbols[t4] && (t4 = this.convertLatexSymbols[t4]), this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : `\\operatorname{` + t4 + `}`) : this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : t4 === `＿` && !this.showBlanks ? `` : t4;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.stringConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return `\\infty`;
      if (t4 === -1 / 0) return `-\\infty`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation$1(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals$1(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (a2[0] === `+` && (a2 = a2.slice(1)), this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals$1(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals$1(i2, this.padToDigits, t5);
          }
        }
        return i2 + ` \\cdot 10^{` + a2 + `}`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) return r2[0] < 0 ? `\\left(` + r2[0].toString() + `\\right)^{` + r2[1].toString() + `}` : r2[0].toString() + `^{` + r2[1].toString() + `}`;
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      return this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `^{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `_`) {
      let t5 = this.factor(r2[0]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `_{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `\\left(` + i2 + `\\right)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `/`) return this.term(t4);
    else if (n2 === `-`) return operators$1$1[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return operators$1$1[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `\\left[ ` + i2 : `\\left( ` + i2, n3[2] ? i2 += ` \\right]` : i2 += ` \\right)`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `\\begin{` + this.matrixEnvironment + `} `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += ` & `);
        r3 < t5[1] - 1 && (i2 += ` \\\\ `);
      }
      return i2 = i2 + ` \\end{` + this.matrixEnvironment + `}`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `\\partial `);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 ? c2 = c2.trimRight() + `^{` + o2 + `}` + this.stringConvert(s2) : c2 += this.stringConvert(s2), c2 = `\\frac{ ` + c2 + ` }{ `;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.stringConvert(o3), i3 > 1 && (c2 = c2 + `^{` + i3 + `}`), c2 += ` `;
      }
      return c2 += `}`, c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `\\left|` + this.statement(r2[1]) + `\\right|`;
      if (r2[0] === `floor`) return `\\left\\lfloor ` + this.statement(r2[1]) + ` \\right\\rfloor`;
      if (r2[0] === `ceil`) return `\\left\\lceil ` + this.statement(r2[1]) + ` \\right\\rceil`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `\\left(` + t6 + `\\right)!`;
      } else if (r2[0] === `sqrt`) return `\\sqrt{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `cbrt`) return `\\sqrt[3]{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `nthroot`) return Array.isArray(r2[1]) && r2[1][0] === `tuple` && r2[1].length === 3 ? `\\sqrt[` + this.statement(r2[1][2]) + `]{` + this.statement(r2[1][1]) + `}` : `\\sqrt{` + this.statement(r2[1]) + `}`;
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3[i3.length - 1].match(/[a-zA-Z]/) && (i3 += `\\,`), i3 += t7.map((t8) => `d` + this.factor(t8[1])).join(`\\,`));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3;
      n3 = r2[0] === `log10` ? `\\log_{10}` : r2[0] === `re` ? `\\Re` : r2[0] === `im` ? `\\Im` : this.factor(r2[0]);
      let i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `\\left(` + i2 + `\\right)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return operators$1$1[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `\\left(` + this.statement(t4) + `\\right)`;
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) || t4[0] === `/` ? `\\left(` + n2 + `\\right)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    var n2 = this.term(t4);
    return n2.match(/^\\pm /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, operators$4 = { "+,add": function(t4) {
  return [`+`].concat(t4);
}, "*,multiply": function(t4) {
  return [`*`].concat(t4);
}, "/,divide": function(t4) {
  return [`/`, t4[0], t4[1]];
}, "-,unaryMinus": function(t4) {
  return [`-`, t4[0]];
}, "-,subtract": function(t4) {
  return [`+`, t4[0], [`-`, t4[1]]];
}, "^,pow": function(t4) {
  return [`^`, t4[0], t4[1]];
}, "and,and": function(t4) {
  return [`and`].concat(t4);
}, "or,or": function(t4) {
  return [`or`].concat(t4);
}, "not,not": function(t4) {
  return [`not`, t4[0]];
}, "==,equal": function(t4) {
  return [`=`].concat(t4);
}, "<,smaller": function(t4) {
  return [`<`, t4[0], t4[1]];
}, ">,larger": function(t4) {
  return [`>`, t4[0], t4[1]];
}, "<=,smallerEq": function(t4) {
  return [`le`, t4[0], t4[1]];
}, ">=,largerEq": function(t4) {
  return [`ge`, t4[0], t4[1]];
}, "!=,unequal": function(t4) {
  return [`ne`, t4[0], t4[1]];
}, "!,factorial": function(t4) {
  return [`apply`, `factorial`, t4[0]];
} }, mathjsToAst$1$1 = class mathjsToAst$13 {
  convert(t4) {
    if (t4.isConstantNode) return t4.value;
    if (t4.isSymbolNode) return t4.name;
    if (t4.isOperatorNode) {
      var n2 = [t4.op, t4.fn].join(`,`);
      if (n2 in operators$4) return operators$4[n2](t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
      throw Error(`Unsupported operator: ` + t4.op + `, ` + t4.fn);
    }
    if (t4.isFunctionNode) {
      var r2 = t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this));
      r2 = r2.length > 1 ? [`tuple`].concat(r2) : r2[0];
      var i2 = [`apply`, t4.name];
      return i2.push(r2), i2;
    }
    if (t4.isArrayNode) return [`vector`].concat(t4.args.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    if (t4.isParenthesisNode) return this.convert(t4.content);
    throw Error(`Unsupported node type: ` + t4.type);
  }
}, differentiation_exports$1 = __exportAll$1({ derivative: () => derivative$1, derivativeStory: () => derivativeStory$1, derivative_story: () => derivative_story$1, derivative_with_story: () => derivative_with_story$1 }), astToMathjs$3 = new astToMathjs$2$1({ mathjs: mathjs_default$1 }), mathjsToAst$2 = new mathjsToAst$1$1(), textToAst$2$1 = new textToAst$4$1(), astToLatex$2 = new astToLatex$1$1(), derivatives$1 = { sin: textToAst$2$1.convert(`cos x`), cos: textToAst$2$1.convert(`-(sin x)`), tan: textToAst$2$1.convert(`(sec x)^2`), cot: textToAst$2$1.convert(`-((csc x)^2)`), sec: textToAst$2$1.convert(`(sec x)*(tan x)`), csc: textToAst$2$1.convert(`-(csc x)*(cot x)`), sqrt: textToAst$2$1.convert(`1/(2*sqrt(x))`), cbrt: textToAst$2$1.convert(`1/(3*x^(2/3))`), log: textToAst$2$1.convert(`1/x`), ln: textToAst$2$1.convert(`1/x`), exp: textToAst$2$1.convert(`exp(x)`), arcsin: textToAst$2$1.convert(`1/sqrt(1 - x^2)`), arccos: textToAst$2$1.convert(`-1/sqrt(1 - x^2)`), arctan: textToAst$2$1.convert(`1/(1 + x^2)`), arccsc: textToAst$2$1.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), arcsec: textToAst$2$1.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), arccot: textToAst$2$1.convert(`-1/(1 + x^2)`), asin: textToAst$2$1.convert(`1/sqrt(1 - x^2)`), acos: textToAst$2$1.convert(`-1/sqrt(1 - x^2)`), atan: textToAst$2$1.convert(`1/(1 + x^2)`), acsc: textToAst$2$1.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), asec: textToAst$2$1.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), acot: textToAst$2$1.convert(`-1/(1 + x^2)`), abs: textToAst$2$1.convert(`abs(x)/x`) };
function derivative_with_story$1(t4, n2, r2 = []) {
  var i2 = get_tree$1(t4), a2 = `\\frac{d}{d` + n2 + `} `;
  if (typeof i2 == `number` || variables$1(i2).indexOf(n2) < 0) return r2.push(`The derivative of a constant is zero, that is, \\(` + a2 + astToLatex$2.convert(i2) + ` = 0\\).`), 0;
  if (typeof i2 == `string`) return n2 === i2 ? (r2.push(`We know the derivative of the identity function is one, that is, \\(` + a2 + astToLatex$2.convert(i2) + ` = 1\\).`), 1) : (r2.push(`As far as \\(` + astToLatex$2.convert(n2) + `\\) is concerned, \\(` + astToLatex$2.convert(i2) + `\\) is constant, so ` + a2 + astToLatex$2.convert(i2) + ` = 0\\).`), 0);
  if (!Array.isArray(i2)) return null;
  var o2 = i2[0], s2 = i2.slice(1);
  if (o2 === `apply` && s2[0] === `nthroot`) if (s2[1].length !== 3 || s2[1][0] !== `tuple`) s2[0] = `sqrt`;
  else {
    let t5 = s2[1][2];
    o2 = `^`, s2 = [s2[1][1], [`/`, 1, t5]];
  }
  if (o2 === `+` || o2 === `-` || o2 === `~`) {
    r2.push(`Using the sum rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return a2 + astToLatex$2.convert(t6);
    }).join(` + `) + `\\).`);
    let t5 = [o2].concat(s2.map(function(t6, i3) {
      return derivative_with_story$1(t6, n2, r2);
    }));
    return t5 = simplify$1(t5), r2.push(`So using the sum rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(t5) + `\\).`), t5;
  }
  if (o2 === `*`) {
    let t5 = [], o3 = [];
    for (let r3 = 0; r3 < s2.length; r3++) typeof s2[r3] == `number` || variables$1(s2[r3]).indexOf(n2) < 0 ? o3.push(s2[r3]) : t5.push(s2[r3]);
    if (o3.length > 0) {
      if (t5.length === 0) return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex$2.convert(i2) + ` = 0.\\)`), 0;
      let s3 = [`*`].concat(t5);
      if (t5.length === 1 && (s3 = t5[0]), s3 === n2) {
        r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + o3.map(function(t7, n3) {
          return astToLatex$2.convert(t7);
        }).join(` \\cdot `) + `\\).`);
        let t6 = [`*`].concat(o3);
        return t6 = simplify$1(t6), t6;
      }
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + o3.map(function(t6, n3) {
        return astToLatex$2.convert(t6);
      }).join(` \\cdot `) + ` \\cdot ` + a2 + `\\left(` + astToLatex$2.convert(s3) + `\\right)\\).`);
      let c3 = derivative_with_story$1(s3, n2, r2), l3 = [`*`].concat(o3.concat([c3]));
      return l3 = simplify$1(l3), r2.push(`And so \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(l3) + `\\).`), l3;
    }
    r2.push(`Using the product rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return s2.map(function(r3, i3) {
        return n3 === i3 ? a2 + `\\left(` + astToLatex$2.convert(t6) + `\\right)` : astToLatex$2.convert(r3);
      }).join(` \\cdot `);
    }).join(` + `) + `\\).`);
    let c2 = s2.slice(), l2 = [`+`].concat(s2.map(function(t6, i3) {
      return [`*`].concat(c2.map(function(t7, a3) {
        if (i3 === a3) {
          let i4 = derivative_with_story$1(t7, n2, r2);
          return i4 === 1 ? null : i4;
        } else return t7;
      }).filter(function(t7) {
        return t7 != null;
      }));
    }));
    return l2 = simplify$1(l2), r2.push(`So using the product rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(l2) + `\\).`), l2;
  }
  if (o2 === `/`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables$1(o3).indexOf(n2) < 0) {
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert([`/`, 1, o3]) + ` \\cdot ` + a2 + `\\left(` + astToLatex$2.convert(t5) + `\\right)\\).`);
      let s3 = derivative_with_story$1(t5, n2, r2), c3 = substitute$1$1(textToAst$2$1.convert(`(1/g)*d`), { d: s3, g: o3 });
      return c3 = simplify$1(c3), r2.push(`So \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(c3) + `\\).`), c3;
    }
    if (variables$1(t5).indexOf(n2) < 0) {
      t5 !== 1 && r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(t5) + ` \\cdot ` + a2 + `\\left(` + astToLatex$2.convert([`/`, 1, o3]) + `\\right)\\).`), r2.push(`Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(t5) + `\\cdot \\frac{-1}{ ` + astToLatex$2.convert(o3) + `^2} \\cdot ` + a2 + astToLatex$2.convert(o3) + `\\).`);
      let s3 = derivative_with_story$1(o3, n2, r2), c3 = substitute$1$1(textToAst$2$1.convert(`f * (-a/(g^2))`), { f: t5, a: s3, g: o3 });
      return c3 = simplify$1(c3), r2.push(`So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(c3) + `\\).`), c3;
    }
    r2.push(`Using the quotient rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = \\frac{` + a2 + `\\left(` + astToLatex$2.convert(t5) + `\\right) \\cdot ` + astToLatex$2.convert(o3) + ` - ` + astToLatex$2.convert(t5) + `\\cdot ` + a2 + `\\left(` + astToLatex$2.convert(o3) + `\\right)}{ \\left( ` + astToLatex$2.convert(o3) + ` \\right)^2} \\).`);
    let c2 = derivative_with_story$1(t5, n2, r2), l2 = derivative_with_story$1(o3, n2, r2), u2 = substitute$1$1(textToAst$2$1.convert(`(a * g - f * b)/(g^2)`), { a: c2, b: l2, f: t5, g: o3 });
    return u2 = simplify$1(u2), r2.push(`So using the quotient rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(u2) + `\\).`), u2;
  }
  if (o2 === `^`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables$1(o3).indexOf(n2) < 0) {
      if (typeof t5 == `string` && t5 === `x`) {
        if (typeof o3 == `number`) {
          let n4 = substitute$1$1(textToAst$2$1.convert(`n * (f^m)`), { n: o3, m: o3 - 1, f: t5 });
          return n4 = simplify$1(n4), r2.push(`By the power rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(o3) + ` \\cdot \\left(` + astToLatex$2.convert(t5) + `\\right)^{` + astToLatex$2.convert([`-`, o3, 1]) + `}\\).`), n4;
        }
        let n3 = substitute$1$1(textToAst$2$1.convert(`n * (f^(n-1))`), { n: o3, f: t5 });
        return n3 = simplify$1(n3), r2.push(`By the power rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(o3) + ` \\cdot \\left(` + astToLatex$2.convert(t5) + `\\right)^{` + astToLatex$2.convert([`-`, o3, 1]) + `}\\).`), n3;
      }
      o3 !== 1 && r2.push(`By the power rule and the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(o3) + ` \\cdot \\left(` + astToLatex$2.convert(t5) + `\\right)^{` + astToLatex$2.convert([`-`, o3, 1]) + `} \\cdot ` + a2 + astToLatex$2.convert(t5) + `\\).`);
      let s3 = derivative_with_story$1(t5, n2, r2);
      if (o3 === 1) return s3;
      if (typeof o3 == `number`) {
        let n3 = substitute$1$1(textToAst$2$1.convert(`n * (f^m) * a`), { n: o3, m: o3 - 1, f: t5, a: s3 });
        return n3 = simplify$1(n3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(n3) + `\\).`), n3;
      }
      let c3 = substitute$1$1(textToAst$2$1.convert(`n * (f^(n-1)) * a`), { n: o3, f: t5, a: s3 });
      return c3 = simplify$1(c3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(c3) + `\\).`), c3;
    }
    if (t5 === `e` && mathjs_default$1.define_e) {
      if (typeof o3 == `string` && o3 === n2) {
        let t7 = substitute$1$1(textToAst$2$1.convert(`e^(f)`), { f: o3 });
        return t7 = simplify$1(t7), r2.push(`The derivative of \\(e^` + astToLatex$2.convert(n2) + `\\) is itself, that is, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(i2) + `\\).`), t7;
      }
      r2.push(`Using the rule for \\(e^x\\) and the chain rule, we know \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(i2) + ` \\cdot ` + a2 + astToLatex$2.convert(o3) + `\\).`);
      let t6 = substitute$1$1(textToAst$2$1.convert(`e^(f)*d`), { f: o3, d: derivative_with_story$1(o3, n2, r2) });
      return t6 = simplify$1(t6), r2.push(`So using the rule for \\(e^x\\) and the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(t6) + `\\).`), t6;
    }
    if (typeof t5 == `number`) {
      if (typeof o3 == `string` && o3 === n2) {
        let s4 = substitute$1$1(textToAst$2$1.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
        return s4 = simplify$1(s4), r2.push(`The derivative of \\(a^` + astToLatex$2.convert(n2) + `\\) is \\(a^{` + astToLatex$2.convert(n2) + `} \\, \\log a\\), that is, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(s4) + `\\).`), s4;
      }
      let s3 = substitute$1$1(textToAst$2$1.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
      r2.push(`Using the rule for \\(a^x\\) and the chain rule, we know \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(s3) + ` \\cdot ` + a2 + astToLatex$2.convert(o3) + `\\).`);
      let c3 = substitute$1$1(textToAst$2$1.convert(`a^(b)*log(a)*d`), { a: t5, b: o3, d: derivative_with_story$1(o3, n2, r2) });
      return c3 = simplify$1(c3), r2.push(`So using the rule for \\(a^x\\) and the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(c3) + `\\).`), c3;
    }
    let c2 = t5, l2 = o3;
    r2.push(`Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = ` + astToLatex$2.convert(c2) + `\\) and \\(v(x) = ` + astToLatex$2.convert(l2) + `\\).`);
    let u2 = derivative_with_story$1(c2, n2, r2), d2 = derivative_with_story$1(l2, n2, r2), p2 = substitute$1$1(textToAst$2$1.convert(`(f^g)*(b * log(f) + (g * a)/f)`), { a: u2, b: d2, f: c2, g: l2 });
    return p2 = simplify$1(p2), r2.push(`So by the general rule for exponents, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(p2) + `\\).`), p2;
  }
  if (o2 === `apply` && !(s2[0] in derivatives$1)) {
    let t5 = s2[1];
    r2.push(`By the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(substitute$1$1([`apply`, s2[0] + `'`, `x`], { x: t5 })) + ` \\cdot ` + a2 + astToLatex$2.convert(t5) + `\\).`);
    let o3 = [`*`, substitute$1$1([`apply`, s2[0] + `'`, `x`], { x: t5 }), derivative_with_story$1(t5, n2, r2)];
    return o3 = simplify$1(o3), r2.push(`So by the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(o3) + `\\).`), o3;
  }
  if (o2 === `apply` && s2[0] in derivatives$1 || o2 in derivatives$1) {
    let t5 = false;
    o2 === `apply` && (o2 = s2[0], s2 = s2.slice(1), t5 = true);
    let c2 = s2[0];
    if (typeof c2 == `number`) {
      return r2.push(`The derivative of a constant is zero so \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(0) + `\\).`), 0;
    } else if (typeof c2 == `string` && c2 === n2) {
      let t6 = [`*`, substitute$1$1(derivatives$1[o2], { x: c2 })];
      return t6 = simplify$1(t6), r2.push(`It is the case that \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(t6) + `\\).`), t6;
    } else if (typeof c2 == `string` && c2 !== n2) {
      return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(0) + `\\).`), 0;
    } else {
      let s3 = [o2, `u`];
      t5 && (s3 = [`apply`].concat(s3)), r2.push(`Recall \\(\\frac{d}{du}` + astToLatex$2.convert(s3) + ` = ` + astToLatex$2.convert(derivative_with_story$1(s3, `u`, [])) + `\\).`), r2.push(`By the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(substitute$1$1(derivatives$1[o2], { x: c2 })) + ` \\cdot ` + a2 + astToLatex$2.convert(c2) + `\\).`);
      let l2 = [`*`, substitute$1$1(derivatives$1[o2], { x: c2 }), derivative_with_story$1(c2, n2, r2)];
      return l2 = simplify$1(l2), r2.push(`So by the chain rule, \\(` + a2 + astToLatex$2.convert(i2) + ` = ` + astToLatex$2.convert(l2) + `\\).`), l2;
    }
  }
  return 0;
}
function lowercaseFirstLetter$1(t4) {
  return t4.charAt(0).toLowerCase() + t4.slice(1);
}
function simplify_story$1(t4) {
  for (let n2 = t4.length - 1; n2 >= 1; n2--) t4[n2] === t4[n2 - 1] && t4.splice(n2, 1);
  for (let n2 = 0; n2 < t4.length; n2++) for (let r2 = n2 + 1; r2 < t4.length; r2++) t4[n2] === t4[r2] && (t4[r2] = `Again, ` + lowercaseFirstLetter$1(t4[r2]));
  return t4;
}
function derivative_story$1(t4, n2) {
  var r2 = [];
  return derivative_with_story$1(t4, n2, r2), r2 = simplify_story$1(r2), r2;
}
var derivativeStory$1 = derivative_story$1;
function derivative$1(t4, n2) {
  var r2 = get_tree$1(t4);
  let i2 = astToMathjs$3.convert(log_subscript_to_two_arg_log$1(normalize_function_names$1(normalize_applied_functions$1(r2)))), a2 = mathjs_default$1.derivative(i2, n2);
  return mathjsToAst$2.convert(a2);
}
function pm_equals_numerical$1({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, rng: p2 }) {
  let m2, h2, g2, v2, y2;
  try {
    ({ variables: m2, integer_variables: h2, functions: g2, expr: v2, other: y2 } = prepare_exprs_numerical_eval$1(t4, n2, i2, a2));
  } catch {
    return false;
  }
  let b2, x2;
  try {
    b2 = expand_pm_signs$1(v2.tree), x2 = expand_pm_signs$1(y2.tree);
  } catch {
    return false;
  }
  let S2, w2;
  try {
    S2 = b2.map((t5) => i2.fromAst(t5).f()), w2 = x2.map((t5) => a2.fromAst(t5).f());
  } catch {
    return false;
  }
  let E, D;
  if (l2 > 0 && b2.length > 0) try {
    let t5 = replace_numbers_with_parameters$1({ expr: v2, variables: m2, include_exponents: u2 });
    E = t5.parameters;
    let n3 = Object.keys(E);
    if (n3.length > 0) {
      let r3;
      try {
        r3 = expand_pm_signs$1(t5.expr_with_params);
      } catch {
        r3 = null;
      }
      r3 && r3.length === b2.length && (D = r3.map((t6) => {
        try {
          let r4 = i2.fromAst(t6), a3 = r4.derivative(n3[0]);
          d2 || (a3 = a3.multiply(E[n3[0]]));
          for (let t7 of n3.slice(1)) {
            let n4 = r4.derivative(t7);
            d2 || (n4 = n4.multiply(E[t7])), a3 = a3.add(n4);
          }
          return a3.multiply(l2).f();
        } catch {
          return;
        }
      }));
    }
  } catch {
  }
  let M2 = Number.MAX_VALUE * 1e-20, N2 = [10, 1, 100, 0.1, 1e3, 0.01], F = 0;
  for (let t5 = 0; t5 < 1e3; t5++) {
    let n3 = N2[Math.floor(t5 / 20) % N2.length], i3;
    try {
      i3 = r2(p2, m2, n3);
    } catch {
      continue;
    }
    for (let t6 = 0; t6 < h2.length; t6++) i3[h2[t6]] = generate_random_integer$1(-10, 10, p2);
    for (let t6 = 0; t6 < g2.length; t6++) i3[g2[t6]] = random_cubic$1(p2);
    let a3;
    if (D) {
      let t6 = Object.assign({}, i3, E);
      a3 = Array(D.length).fill(0);
      let n4 = false;
      for (let r3 = 0; r3 < D.length; r3++) {
        let i4 = D[r3];
        if (!i4) continue;
        let o3;
        try {
          o3 = mathjs_default$1.abs(i4(t6));
        } catch {
          n4 = true;
          break;
        }
        if (!Number.isFinite(o3)) {
          n4 = true;
          break;
        }
        a3[r3] = o3;
      }
      if (n4) continue;
    }
    let l3, u3;
    try {
      l3 = S2.map((t6) => t6(i3)), u3 = w2.map((t6) => t6(i3));
    } catch {
      continue;
    }
    if (!(!l3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default$1.abs(t6)) && mathjs_default$1.abs(t6) < M2) || !u3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default$1.abs(t6)) && mathjs_default$1.abs(t6) < M2))) {
      if (!value_multisets_match$1(l3, u3, o2, s2, c2, a3)) return false;
      if (F += 1, F >= 10) return true;
    }
  }
  return false;
}
function value_multisets_match$1(t4, n2, r2, i2, a2, o2) {
  let s2 = (t5) => o2 && o2[t5] !== void 0 ? o2[t5] : 0, c2 = (o3, c3) => values_close$1(t4[o3], n2[c3], r2, i2, a2, s2(o3));
  if (t4.length !== n2.length) return t4.every((t5, r3) => n2.some((t6, n3) => c2(r3, n3))) && n2.every((n3, r3) => t4.some((t5, n4) => c2(n4, r3)));
  let l2 = t4.length, u2 = Array(l2).fill(-1), d2 = (t5, n3) => {
    for (let r3 = 0; r3 < l2; r3++) if (!(n3[r3] || !c2(t5, r3)) && (n3[r3] = true, u2[r3] === -1 || d2(u2[r3], n3))) return u2[r3] = t5, true;
    return false;
  };
  for (let t5 = 0; t5 < l2; t5++) if (!d2(t5, Array(l2).fill(false))) return false;
  return true;
}
function values_close$1(t4, n2, r2, i2, a2, o2 = 0) {
  let s2 = mathjs_default$1.abs(t4), c2 = mathjs_default$1.abs(n2), l2 = Math.min(s2, c2), u2 = Math.max(s2, c2), d2 = o2;
  return d2 += l2 * r2, d2 = Math.min(d2, 0.1 * l2), d2 === 0 && (t4 === 0 || n2 === 0) ? d2 += a2 : d2 += i2, u2 === 0 || mathjs_default$1.abs(mathjs_default$1.subtract(t4, n2)) < d2;
}
var astToText$3 = new astToText$2$1();
function generate_random_integer$1(t4, n2, r2) {
  return t4 = mathjs_default$1.ceil(t4), n2 = mathjs_default$1.floor(n2), mathjs_default$1.floor(r2() * (n2 - t4 + 1)) + t4;
}
function random_cubic$1(t4) {
  let n2 = (t4() - 0.5) * 1, r2 = (t4() - 0.5) * 2, i2 = (t4() - 0.5) * 6, a2 = (t4() - 0.5) * 24;
  return function(t5) {
    return mathjs_default$1.add(mathjs_default$1.multiply(mathjs_default$1.add(mathjs_default$1.multiply(mathjs_default$1.add(mathjs_default$1.multiply(n2, t5), r2), t5), i2), t5), a2);
  };
}
var equals$6$1 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2 = 1e-12, absolute_tolerance: s2 = 0, tolerance_for_zero: c2 = 1e-15, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, coerce_tuples_arrays: p2 = true, coerce_vectors: m2 = true, rng: h2 }) {
  if (i2 ||= t4.context, a2 ||= n2.context, Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let g2 = t4.tree[0], v2 = t4.tree.slice(1), y2 = n2.tree[0], b2 = n2.tree.slice(1);
    if (g2 === `tuple` || g2 === `vector` || g2 === `altvector` || g2 === `list` || g2 === `array` || g2 === `matrix` || g2 === `interval`) {
      if (y2 !== g2 && ({ operator1: g2, operator2: y2, operands1: v2, operands2: b2 } = coerce_tuple_array_vectors$1({ operator1: g2, operator2: y2, operands1: v2, operands2: b2, coerce_tuples_arrays: p2, coerce_vectors: m2 })), y2 !== g2 || b2.length !== v2.length) return false;
      for (let t5 = 0; t5 < v2.length; t5++) if (!equals$6$1({ expr: i2.fromAst(v2[t5]), other: a2.fromAst(b2[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 })) return false;
      return true;
    }
    if (v2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(g2)) {
      if (b2.length !== 2 || (g2 === `>` ? (g2 = `<`, v2 = [v2[1], v2[0]]) : g2 === `ge` && (g2 = `le`, v2 = [v2[1], v2[0]]), y2 === `>` ? (y2 = `<`, b2 = [b2[1], b2[0]]) : y2 === `ge` && (y2 = `le`, b2 = [b2[1], b2[0]]), g2 !== y2)) return false;
      let t5 = [`+`, v2[0], [`-`, v2[1]]], n3 = [`+`, b2[0], [`-`, b2[1]]], x2 = g2 !== `=`;
      if (contains_pm$1(t5) || contains_pm$1(n3)) {
        if (g2 === `=`) {
          let g3 = (t6, n4) => {
            let r3 = expand_pm_signs$1(t6), i3 = [];
            for (let t7 of r3) {
              let r4 = n4.fromAst(t7).simplify().tree;
              i3.some((t8) => equal$1(t8, r4)) || i3.push(r4);
            }
            return i3.length === 1 ? i3[0] : [`*`, ...i3];
          }, v3, y3;
          try {
            v3 = g3(t5, i2), y3 = g3(n3, a2);
          } catch {
            return false;
          }
          return component_equals$1$1({ expr: i2.fromAst(v3), other: a2.fromAst(y3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: false, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
        }
        return pm_equals_numerical$1({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 });
      }
      return component_equals$1$1({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: x2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
    }
  }
  return contains_pm$1(t4.tree) || contains_pm$1(n2.tree) ? pm_equals_numerical$1({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 }) : component_equals$1$1({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
}, component_equals$1$1 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: o2 = false, require_positive_proportion: s2 = false, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 }) {
  var y2 = Number.MAX_VALUE * 1e-20, b2 = 0, x2 = 10, S2 = 100, w2, E, D;
  ({ variables: w2, integer_variables: E, functions: D, expr: t4, other: n2 } = prepare_exprs_numerical_eval$1(t4, n2, i2, a2));
  try {
    var O2 = t4.f(), j2 = n2.f();
  } catch {
    if (t4.equalsViaSyntax(n2, { allow_blanks: true, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2 })) return true;
    if (!(Array.isArray(t4.tree) && Array.isArray(n2.tree)) || t4.tree[0] !== n2.tree[0]) return false;
    let o3 = t4.tree.slice(1), s3 = n2.tree.slice(1);
    for (let t5 = 0; t5 < o3.length; t5++) if (!equals$6$1({ expr: i2.fromAst(o3[t5]), other: a2.fromAst(s3[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 })) return false;
    return true;
  }
  let M2, N2, F;
  if (d2 > 0) {
    let n3 = replace_numbers_with_parameters$1({ expr: t4, variables: w2, include_exponents: p2 });
    M2 = i2.fromAst(n3.expr_with_params), N2 = n3.parameters;
    let r3 = Object.keys(N2);
    if (r3.length > 0) {
      let t5 = M2.derivative(r3[0]);
      if (m2 || (t5 = t5.multiply(N2[r3[0]])), r3.length > 1) for (let n5 of r3.slice(1)) {
        let r4 = M2.derivative(n5);
        m2 || (r4 = r4.multiply(N2[n5])), t5 = t5.add(r4);
      }
      let n4 = t5.multiply(d2);
      try {
        F = n4.f();
      } catch {
      }
    }
  }
  var I2 = 1, L2 = [10, 1, 100, 0.1, 1e3, 0.01], R2 = 0;
  let z2 = 0, V2 = true, H2 = 0;
  for (let t5 = 0; t5 < 10 * S2; t5++) {
    try {
      var U2 = W2(L2[R2], v2);
    } catch {
      continue;
    }
    if (U2.always_zero === false && (V2 = false), !U2.equal && !U2.out_of_bounds && !U2.always_zero && U2.sufficient_finite_values !== false && (H2++, H2 > S2)) return false;
    if (U2.equal) if (U2.always_zero) {
      if (!V2) continue;
      if (z2 += 1, z2 > 5 && (R2 += 1, z2 = 0), R2 >= L2.length) return true;
      continue;
    } else return true;
  }
  return false;
  function W2(t5, n3) {
    var i3 = r2(n3, w2, t5);
    for (let t6 = 0; t6 < E.length; t6++) i3[E[t6]] = generate_random_integer$1(-10, 10, n3);
    for (let t6 = 0; t6 < D.length; t6++) i3[D[t6]] = random_cubic$1(n3);
    var a3;
    F && (a3 = Object.assign({}, i3, N2));
    var d3 = O2(i3), p3 = j2(i3);
    if (typeof d3 == `boolean` || typeof p3 == `boolean`) return { out_of_bounds: true, always_zero: false };
    var m3 = mathjs_default$1.abs(d3), h3 = mathjs_default$1.abs(p3);
    if (!(m3 < y2 && h3 < y2) || !((m3 === 0 || m3 > b2) && (h3 === 0 || h3 > b2))) return { out_of_bounds: true, always_zero: false };
    var g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), S3 = 1;
    let M3 = 0;
    if (F) {
      try {
        M3 = mathjs_default$1.abs(F(a3));
      } catch {
        return { equal_at_start: false, always_zero: false };
      }
      if (!Number.isFinite(M3)) return { equal_at_start: false, always_zero: false };
    }
    if (M3 += g3 * c2, M3 = Math.min(M3, 0.1 * g3), M3 === 0 && (d3 === 0 || p3 === 0) ? M3 += u2 : M3 += l2, !(v3 === 0 || mathjs_default$1.abs(mathjs_default$1.subtract(d3, p3)) < M3) && (!o2 || m3 === 0 || h3 === 0 || (S3 = mathjs_default$1.divide(d3, p3), s2 && !(S3 > 0)))) return { equal_at_start: false, always_zero: false };
    var L22 = v3 === 0, R22 = 0;
    for (let t6 = 0; t6 < 100; t6++) {
      var z22 = r2(n3, w2, I2 / 100, i3);
      for (let t7 = 0; t7 < E.length; t7++) z22[E[t7]] = generate_random_integer$1(-10, 10, n3);
      for (let t7 = 0; t7 < D.length; t7++) z22[D[t7]] = random_cubic$1(n3);
      var V22;
      F && (V22 = Object.assign({}, z22, N2));
      try {
        d3 = O2(z22), p3 = mathjs_default$1.multiply(j2(z22), S3);
      } catch {
        continue;
      }
      if (m3 = mathjs_default$1.abs(d3), h3 = mathjs_default$1.abs(p3), m3 < y2 && h3 < y2) {
        g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), R22++;
        let t7 = 0;
        if (F) {
          try {
            t7 = mathjs_default$1.abs(F(V22));
          } catch {
            continue;
          }
          if (!Number.isFinite(t7)) continue;
        }
        if (t7 += g3 * c2, t7 = Math.min(t7, 0.1 * g3), t7 === 0 && (d3 === 0 || p3 === 0) ? t7 += u2 : t7 += l2, !(v3 === 0 || mathjs_default$1.abs(mathjs_default$1.subtract(d3, p3)) < t7)) return { equality_in_middle: false, always_zero: false };
        if (L22 &&= v3 === 0, R22 >= x2) return { equal: true, always_zero: L22 };
      }
    }
    return { sufficient_finite_values: false, always_zero: L22 };
  }
};
function prepare_exprs_numerical_eval$1(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, { expr: t4, other: n2 } = normalize_for_equality_checking$1(t4, n2, r2, i2);
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  mathjs_default$1.define_pi && (a2 = a2.filter(function(t5) {
    return t5 !== `pi`;
  })), mathjs_default$1.define_i && (a2 = a2.filter(function(t5) {
    return t5 !== `i`;
  })), mathjs_default$1.define_e && (a2 = a2.filter(function(t5) {
    return t5 !== `e`;
  }));
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) (is_integer_ast$1(a2[t5], r2.assumptions) || is_integer_ast$1(a2[t5], i2.assumptions)) && o2.push(a2[t5]);
  var s2 = [.../* @__PURE__ */ new Set([...t4.functions(), ...n2.functions()])].filter((t5) => t5.length === 1 || t5.includes(`_`) || t5.includes(`^`)), c2 = s2.filter((t5) => a2.includes(t5));
  if (s2 = s2.filter((t5) => !a2.includes(t5)), c2.length > 0) {
    let o3 = t4.tree, l2 = n2.tree, u2 = `x1`;
    for (; [...s2, ...a2].includes(u2); ) u2 += `x1`;
    let d2 = `x2`;
    for (; [...s2, ...a2].includes(d2); ) d2 += `x2`;
    for (let t5 of c2) {
      let n3 = t5 + t5;
      for (; [...s2, ...a2].includes(n3); ) n3 += t5;
      let r3 = [[[`apply`, t5, u2], [`apply`, n3, u2], { variables: { [u2]: true } }]];
      o3 = applyAllTransformations$1(o3, r3), l2 = applyAllTransformations$1(l2, r3), s2.push(n3);
    }
    t4 = r2.fromAst(o3), n2 = i2.fromAst(l2);
  }
  return { variables: a2, integer_variables: o2, functions: s2, expr: t4, other: n2 };
}
function normalize_for_equality_checking$1(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, t4 = t4.normalize_function_names(), n2 = n2.normalize_function_names(), t4 = t4.log_subscript_to_two_arg_log(), n2 = n2.log_subscript_to_two_arg_log(), t4 = t4.subscripts_to_strings(), n2 = n2.subscripts_to_strings(), t4 = t4.normalize_applied_functions(), n2 = n2.normalize_applied_functions();
  let a2 = rename_functions_with_exponents$1(t4.tree), o2 = rename_functions_with_exponents$1(n2.tree);
  return t4 = r2.fromAst(rename_vecs$1(a2)), n2 = i2.fromAst(rename_vecs$1(o2)), { expr: t4, other: n2 };
}
function replace_numbers_with_parameters$1({ expr: t4, variables: n2, include_exponents: r2 = false }) {
  let i2 = {}, a2 = 0;
  function o2() {
    a2++;
    let t5 = `par` + a2;
    for (; n2.includes(t5); ) a2++, t5 = `par` + a2;
    return t5;
  }
  function s2(t5) {
    if (typeof t5 == `number`) {
      if (t5 === 0) return t5;
      {
        let n4 = o2();
        return i2[n4] = t5, n4;
      }
    }
    if (typeof t5 == `string`) {
      if (t5 === `pi`) {
        if (mathjs_default$1.define_pi) {
          let t6 = o2();
          return i2[t6] = mathjs_default$1.PI, t6;
        }
      } else if (t5 === `e` && mathjs_default$1.define_e) {
        let t6 = o2();
        return i2[t6] = mathjs_default$1.e, t6;
      }
      return t5;
    }
    if (!Array.isArray(t5)) return t5;
    let n3 = t5[0], a3 = t5.slice(1);
    return n3 === `^` && !r2 ? [n3, s2(a3[0]), a3[1]] : [n3, ...a3.map(s2)];
  }
  return t4 = t4.evaluate_numbers({ max_digits: 1 / 0 }), { expr_with_params: s2(t4.tree), parameters: i2 };
}
function rename_functions_with_exponents$1(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `apply`) {
    let t5 = r2[0];
    return Array.isArray(t5) && t5[0] === `^` && t5.slice(1).every((t6) => [`number`, `string`].includes(typeof t6)) && (t5 = astToText$3.convert(t5)), [`apply`, t5, r2[1]];
  }
  return [n2, ...r2.map(rename_functions_with_exponents$1)];
}
function rename_vecs$1(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  return n2 === `vec` && r2.length === 1 ? `__vec_` + astToText$3.convert(r2[0]) : [n2, ...r2.map(rename_vecs$1)];
}
function randomComplexBindings$1(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = mathjs_default$1.complex(t4() * 2 * r2 - r2, t4() * 2 * r2 - r2);
  }) : n2.forEach(function(n3) {
    a2[n3] = mathjs_default$1.complex(i2[n3].re + t4() * 2 * r2 - r2, i2[n3].im + t4() * 2 * r2 - r2);
  }), a2;
}
var equals$5$1 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = (0, import_seedrandom$1.default)(`complex_seed`);
  return t4 = t4.remove_scaling_units(), n2 = n2.remove_scaling_units(), equals$6$1({ expr: t4, other: n2, randomBindings: randomComplexBindings$1, expr_context: t4.context, other_context: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, coerce_tuples_arrays: u2, coerce_vectors: d2, rng: p2 });
};
function randomRealBindings$1(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = t4() * 2 * r2 - r2;
  }) : n2.forEach(function(n3) {
    a2[n3] = i2[n3] + t4() * 2 * r2 - r2;
  }), a2;
}
var equals$4$1 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false } = {}) {
  if (!t4.isAnalytic() || !n2.isAnalytic()) return false;
  let l2 = seedrandom(`real_seed`);
  return equals$6$1({ expr: t4, other: n2, randomBindings: randomRealBindings$1, expr_context: t4.context, other_content: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, rng: l2 });
}, equals$3$1 = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, allow_blanks: o2 = false, coerce_tuples_arrays: s2 = true, coerce_vectors: c2 = true } = {}) {
  if (!o2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let l2 = t4.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), u2 = n2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal$1(l2.tree, u2.tree, { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: s2, coerce_vectors: c2 });
};
function randomFiniteFieldBindings$1(t4, n2, r2) {
  var i2 = {};
  return n2.forEach(function(n3) {
    i2[n3] = Math.floor(t4() * r2);
  }), i2;
}
var equals$2$1 = function(t4, n2, { allow_blanks: r2 = false, coerce_tuples_arrays: i2 = true, coerce_vectors: a2 = true } = {}) {
  if (!r2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let o2 = (0, import_seedrandom$1.default)(`finite_field_seed`);
  if (Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let r3 = t4.tree[0], p2 = t4.tree.slice(1), m2 = n2.tree[0], h2 = n2.tree.slice(1);
    if (r3 === `tuple` || r3 === `vector` || r3 === `altvector` || r3 === `list` || r3 === `array` || r3 === `matrix` || r3 === `interval`) {
      if (m2 !== r3 && ({ operator1: r3, operator2: m2, operands1: p2, operands2: h2 } = coerce_tuple_array_vectors$1({ operator1: r3, operator2: m2, operands1: p2, operands2: h2, coerce_tuples_arrays: i2, coerce_vectors: a2 })), m2 !== r3 || h2.length !== p2.length) return false;
      for (let r4 = 0; r4 < p2.length; r4++) if (equals$2$1(t4.context.fromAst(p2[r4]), n2.context.fromAst(h2[r4]), o2) === false) return false;
      return;
    }
    if (p2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(r3)) {
      if (h2.length !== 2 || (r3 === `>` ? (r3 = `<`, p2 = [p2[1], p2[0]]) : r3 === `ge` && (r3 = `le`, p2 = [p2[1], p2[0]]), m2 === `>` ? (m2 = `<`, h2 = [h2[1], h2[0]]) : m2 === `ge` && (m2 = `le`, h2 = [h2[1], h2[0]]), r3 !== m2)) return false;
      let i3 = [`+`, p2[0], [`-`, p2[1]]], a3 = [`+`, h2[0], [`-`, h2[1]]], g2 = r3 !== `=`, v2 = t4.context.fromAst(i3), y2 = n2.context.fromAst(a3);
      try {
        let t5 = prepare_exprs_numerical_eval$1(v2, y2);
        if (t5.functions.length === 0) {
          var s2 = t5.expr.f(), c2 = t5.other.f();
          let r4 = Number.MAX_VALUE * 1e-20;
          for (let i4 = 0; i4 < 10; i4++) {
            var l2 = {};
            t5.variables.forEach(function(t6) {
              l2[t6] = o2() * 2 - 1;
            });
            for (let n3 = 0; n3 < t5.integer_variables.length; n3++) l2[t5.integer_variables[n3]] = mathjs_default$1.floor(o2() * 21) - 10;
            let i5 = s2(l2), p3 = c2(l2);
            var u2 = mathjs_default$1.abs(i5), d2 = mathjs_default$1.abs(p3);
            if (!(u2 < r4 && d2 < r4) || u2 == 0 || d2 === 0) continue;
            let m3 = mathjs_default$1.divide(i5, p3);
            if (g2 && !(m3 > 0)) return false;
            if (m3 !== 1) {
              let t6 = rationalApproximation$1(m3);
              y2 = n2.context.fromAst([`*`, [`/`, t6.numerator, t6.denominator], a3]);
            }
            break;
          }
        }
      } catch {
        return;
      }
      return component_equals$2(v2, y2, o2);
    }
  }
  return component_equals$2(t4, n2, o2);
}, component_equals$2 = function(t4, n2, r2) {
  ({ expr: t4, other: n2 } = normalize_for_equality_checking$1(t4, n2));
  let i2 = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  for (let o2 of i2) {
    let i3 = randomFiniteFieldBindings$1(r2, a2, o2);
    try {
      let r3 = t4.finite_field_evaluate(i3, o2), a3 = n2.finite_field_evaluate(i3, o2);
      if (!r3.approximate && !a3.approximate && !r3.isNaN() && !a3.isNaN() && r3.values.length > 0 && a3.values.length > 0 && !r3.equals(a3)) return false;
    } catch {
      return;
    }
  }
}, equals$1$1 = function(t4, n2, { min_elements_match: r2 = 3, match_partial: i2 = false } = {}) {
  if (!is_discrete_infinite_set$1(t4)) return false;
  if (is_discrete_infinite_set$1(n2)) {
    var a2 = [];
    let r3 = t4.context.get_assumptions(t4);
    if (r3 !== void 0 && a2.push(r3), r3 = n2.context.get_assumptions(n2), r3 !== void 0 && a2.push(r3), a2 = a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : clean_assumptions$1([`and`].concat(a2)), i2) {
      let r4 = contained_in$1(t4.tree, n2.tree, a2, i2);
      if (r4 === false) return 0;
      let o2 = contained_in$1(n2.tree, t4.tree, a2, i2);
      return o2 === false ? 0 : r4 === true ? o2 === true ? 1 : o2 : o2 === true ? r4 : Math.min(r4, o2);
    } else return contained_in$1(t4.tree, n2.tree, a2, i2) && contained_in$1(n2.tree, t4.tree, a2, i2);
  } else {
    let i3 = n2.tree;
    if (i3[0] !== `list`) return false;
    let a3 = i3.length - 2;
    if (i3[a3 + 1][0] !== `ldots` || a3 < r2) return false;
    let o2 = i3.slice(0, a3 + 1), s2 = sequence_from_discrete_infinite$1(t4, a3);
    return s2 ? (s2 = [`list`].concat(s2), equals$7(t4.context.from(s2), n2.context.from(o2))) : false;
  }
};
function is_discrete_infinite_set$1(t4) {
  var n2 = t4.tree;
  if (!Array.isArray(n2) || n2[0] !== `discrete_infinite_set`) return false;
  for (var r2 of n2.slice(1)) if (!Array.isArray(r2) || r2[0] !== `tuple` || r2.length !== 5) return false;
  return true;
}
function contained_in$1(t4, n2, r2, i2) {
  if (t4[0] === `discrete_infinite_set`) if (i2) {
    let a3 = 0;
    for (let o4 of t4.slice(1)) {
      let t5 = contained_in$1(o4, n2, r2, i2);
      t5 === true ? a3++ : t5 !== false && (a3 += t5);
    }
    let o3 = t4.length - 1;
    return a3 === o3 ? true : a3 === 0 ? false : a3 / o3;
  } else return t4.slice(1).every((t5) => contained_in$1(t5, n2, r2));
  var a2 = t4[1], o2 = t4[2], s2 = evaluate_numbers$1(t4[3], r2), c2 = t4[4];
  if (s2 !== -1 / 0 || c2 !== 1 / 0) return false;
  a2 = simplify$1([`/`, a2, o2], r2, 1 / 0);
  var l2 = n2.slice(1), u2 = [];
  for (let t5 = 0; t5 < l2.length; t5++) {
    let n3 = evaluate_numbers$1(l2[t5][3]), i3 = l2[t5][4];
    if (n3 !== -1 / 0 || i3 !== 1 / 0) return false;
    let a3 = simplify$1([`/`, l2[t5][1], o2], r2, 1 / 0), s3 = simplify$1([`/`, l2[t5][2], o2], r2, 1 / 0);
    if (typeof s3 != `number`) return false;
    let c3 = mathjs_default$1.fraction(s3), d3 = mathjs_default$1.number(c3.n), p3 = mathjs_default$1.number(c3.d);
    u2.push([d3, p3, a3, s3]);
  }
  for (u2.sort(); u2[0][0] === 1; ) {
    let t5 = u2[0][2], n3 = u2[0][3], i3 = simplify$1(expand$1([`+`, t5, [`-`, a2]]), r2, 1 / 0);
    if (Number.isFinite(i3) && Number.isFinite(n3) && (i3 = mathjs_default$1.mod(i3, n3), mathjs_default$1.min(i3, n3 - i3) < 1e-10 * n3)) return true;
    if (u2.splice(0, 1), u2.length === 0) return false;
  }
  var d2 = [...new Set(u2.map((t5) => t5[0]))];
  let p2 = 0;
  for (let t5 of d2) {
    let n3 = u2.map(function(n4, r3) {
      if (mathjs_default$1.mod(t5, n4[0]) === 0) {
        let i3 = t5 / n4[0];
        return [n4[0], i3, r3];
      } else return;
    }).filter((t6) => t6), o3 = [];
    for (let i3 of n3) {
      let n4 = i3[0], s3 = i3[1], c3 = i3[2], l3 = u2[c3][2], d3 = u2[c3][3];
      for (let i4 = 0; i4 < n4; i4++) {
        let c4 = simplify$1(expand$1([`+`, l3, [`-`, [`+`, a2, i4]]]), r2, 1 / 0);
        if (Number.isFinite(c4) && Number.isFinite(d3) && (c4 = mathjs_default$1.mod(c4, d3), mathjs_default$1.min(c4, d3 - c4) < 1e-10 * d3)) {
          for (let t6 = 0; t6 < s3; t6++) o3[i4 + t6 * n4] = true;
          let r3 = true;
          for (let n5 = 0; n5 < t5; n5++) if (!o3[n5]) {
            r3 = false;
            break;
          }
          if (r3) return true;
          break;
        }
      }
    }
    if (i2) {
      let n4 = 0;
      for (let r3 = 0; r3 < t5; r3++) o3[r3] && n4++;
      n4 /= t5, n4 > p2 && (p2 = n4);
    }
  }
  return i2 && p2 > 0 ? p2 : false;
}
function sequence_from_discrete_infinite$1(t4, n2) {
  var r2 = t4.tree.slice(1);
  if (r2.length > 1) return;
  let i2 = r2[0][1], a2 = r2[0][2], o2 = evaluate_numbers$1(r2[0][3]), s2 = r2[0][4];
  if (!Number.isInteger(o2) || s2 !== 1 / 0) return;
  let c2 = [];
  for (let t5 = 0; t5 < n2; t5++) c2.push(evaluate_numbers$1([`+`, [`*`, a2, o2 + t5], i2]));
  return c2;
}
var equality_exports$1 = __exportAll$1({ equals: () => equals$7, equalsDiscreteInfinite: () => equals$1$1, equalsViaComplex: () => equals$5$1, equalsViaFiniteField: () => equals$2$1, equalsViaReal: () => equals$4$1, equalsViaSyntax: () => equals$3$1 }), equals$7 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = t4.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), m2 = n2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return p2.equalsViaSyntax(m2, { allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : o2 === 0 && t4.equalsViaFiniteField(n2, { allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) == 0 ? false : t4.equalsViaComplex(n2, { relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : !!equals$1$1(t4, n2);
}, sign_error_exports$1 = __exportAll$1({ equalSpecifiedSignErrors: () => equalSpecifiedSignErrors$1, equalWithSignErrors: () => equalWithSignErrors$1 }), equalWithSignErrors$1 = function(t4, n2, { equalityFunction: r2 = equals$7, max_sign_errors: i2 = 1 } = {}) {
  if (r2(t4, n2)) return { matched: true, n_sign_errors: 0 };
  for (let a2 = 1; a2 <= i2; a2++) if (equalSpecifiedSignErrors$1(t4, n2, { equalityFunction: r2, n_sign_errors: a2 })) return { matched: true, n_sign_errors: a2 };
  return { matched: false };
}, equalSpecifiedSignErrors$1 = function(t4, n2, { equalityFunction: r2 = equals$7, n_sign_errors: i2 = 1 } = {}) {
  if (i2 === 0) return r2(t4, n2);
  if (!(Number.isInteger(i2) && i2 > 0)) throw Error(`Have not implemented equality check with ${i2} sign errors.`);
  if (i2 > 1) {
    let t5 = r2;
    r2 = function(n3, r3) {
      return equalSpecifiedSignErrors$1(n3, r3, { equalityFunction: t5, n_sign_errors: i2 - 1 });
    };
  }
  var a2 = t4.tree, o2 = [[a2]], s2 = 0, c2, l2;
  t4.tree = [`-`, a2];
  var u2 = r2(t4, n2);
  if (t4.tree = a2, u2) return true;
  for (; c2 = o2[s2++]; ) if (c2 = c2[0], Array.isArray(c2)) {
    for (l2 = 1; l2 < c2.length; l2++) if (o2.push([c2[l2]]), c2[l2] = [`-`, c2[l2]], u2 = r2(t4, n2), c2[l2] = c2[l2][1], u2) return true;
  }
  return false;
}, arithmetic_exports$1 = __exportAll$1({ add: () => add$3, copy: () => copy$1, divide: () => divide$2, mod: () => mod$2$1, multiply: () => multiply$1, pow: () => pow$2, subtract: () => subtract$1 });
function add$3(t4, n2) {
  return clean$2([`+`, get_tree$1(t4), get_tree$1(n2)]);
}
function subtract$1(t4, n2) {
  return clean$2([`+`, get_tree$1(t4), [`-`, get_tree$1(n2)]]);
}
function multiply$1(t4, n2) {
  return clean$2([`*`, get_tree$1(t4), get_tree$1(n2)]);
}
function divide$2(t4, n2) {
  return clean$2([`/`, get_tree$1(t4), get_tree$1(n2)]);
}
function pow$2(t4, n2) {
  return clean$2([`^`, get_tree$1(t4), get_tree$1(n2)]);
}
function mod$2$1(t4, n2) {
  return clean$2([`apply`, `mod`, [`tuple`, get_tree$1(t4), get_tree$1(n2)]]);
}
function copy$1(t4) {
  return get_tree$1(t4);
}
var analytic_exports$1 = __exportAll$1({ isAnalytic: () => isAnalytic$1 }), analytic_operators$1 = [`+`, `-`, `*`, `/`, `^`, `tuple`, `vector`, `altvector`, `list`, `array`, `matrix`, `interval`, `vec`], non_analytic_functions$1 = [`abs`, `sign`, `arg`], relation_operators$1 = [`=`, `le`, `ge`, `<`, `>`];
function isAnalytic$1(t4, { allow_abs: n2 = false, allow_arg: r2 = false, allow_relation: i2 = false } = {}) {
  var a2 = normalize_applied_functions$1(normalize_function_names$1(t4));
  a2 = subscripts_to_strings$1(a2);
  var o2 = operators$3$1(a2);
  for (let t5 = 0; t5 < o2.length; t5++) {
    let n3 = o2[t5];
    if (analytic_operators$1.indexOf(n3) === -1) if (i2) {
      if (relation_operators$1.indexOf(n3) === -1) return false;
    } else return false;
  }
  var s2 = functions$2$1(a2);
  for (let t5 = 0; t5 < s2.length; t5++) {
    let i3 = s2[t5];
    if (non_analytic_functions$1.includes(i3) && !(n2 && i3 == `abs` || r2 && i3 == `arg`)) return false;
  }
  return true;
}
var sets_exports$1 = __exportAll$1({ create_discrete_infinite_set: () => create_discrete_infinite_set$1 });
function create_discrete_infinite_set$1({ offsets: t4, periods: n2, min_index: r2 = [`-`, 1 / 0], max_index: i2 = 1 / 0 } = {}) {
  if (t4 = get_tree$1(t4), n2 = get_tree$1(n2), r2 = get_tree$1(r2), i2 = get_tree$1(i2), t4 === void 0 || n2 === void 0) return;
  let a2 = [];
  if (t4[0] === `list`) if (n2[0] === `list`) {
    if (t4.length !== n2.length || t4.length === 1) return;
    for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2[o2], r2, i2]);
  } else for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2, r2, i2]);
  else a2.push([`tuple`, t4, n2, r2, i2]);
  return [`discrete_infinite_set`].concat(a2);
}
var matrix_exports$1 = __exportAll$1({ cross_prod: () => cross_prod$1, dot_prod: () => dot_prod$1, matrix: () => matrix$1, scalar_mul: () => scalar_mul$1, vector_add: () => vector_add$1, vector_sub: () => vector_sub$1 });
function tuple$1(t4) {
  var n2 = [];
  n2.push(`tuple`);
  var r2 = t4.length;
  for (let i2 = 0; i2 < r2; i2++) n2.push(t4[i2]);
  return n2;
}
function matrix$1(t4) {
  var n2 = [];
  n2.push(`matrix`);
  var r2 = t4.length, i2 = t4[0].length;
  for (let n3 = 1; n3 < r2; n3++) if (t4[n3].length !== i2) throw Error(`Matrix dimensions mismatch`);
  n2.push(tuple$1([r2, i2]));
  let a2 = [];
  for (let n3 = 0; n3 < r2; n3++) a2.push(tuple$1(t4[n3].map(function(t5) {
    return t5.tree;
  })));
  return n2.push(tuple$1(a2)), n2;
}
function vector_add$1(t4, n2) {
  if (t4 = get_tree$1(t4), n2 = get_tree$1(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't add. Those aren't vectors, or the dimensions don't match`);
  var r2 = t4[0] === `altvector` && n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = t4.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`+`, t4[a2], n2[a2]]);
  return simplify$1(r2);
}
function scalar_mul$1(t4, n2) {
  if (n2 = get_tree$1(n2), n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't scalar multiply. Isn't a vector`);
  var r2 = n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = n2.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`*`, n2[a2], t4]);
  return simplify$1(r2);
}
function vector_sub$1(t4, n2) {
  return vector_add$1(t4, scalar_mul$1(-1, n2));
}
function dot_prod$1(t4, n2) {
  if (t4 = get_tree$1(t4), n2 = get_tree$1(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take dot product. Those aren't vectors, or the dimensions don't match`);
  var r2 = 0, i2 = 0, a2 = t4.length;
  for (let o2 = 1; o2 < a2; o2 += 1) i2 = [`*`, t4[o2], n2[o2]], r2 = [`+`, r2, i2];
  return simplify$1(r2);
}
function cross_prod$1(t4, n2) {
  if (t4 = get_tree$1(t4), n2 = get_tree$1(n2), t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take cross product. Those aren't vectors`);
  if (t4.length === 3 && n2.length === 3) return simplify$1([`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]]);
  if (t4.length === 4 && n2.length === 4) {
    var r2 = [`+`, [`*`, t4[2], n2[3]], [`-`, [`*`, t4[3], n2[2]]]], i2 = [`+`, [`*`, t4[3], n2[1]], [`-`, [`*`, t4[1], n2[3]]]], a2 = [`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]];
    return simplify$1([t4[0] === `altvector` && n2[0] === `altvector` ? `altvector` : `vector`, r2, i2, a2]);
  }
  throw Error(`Can't take cross product. The dimensions aren't both 2 or 3.`);
}
var astToGuppy$1$1 = class t32 {
  constructor() {
    this.operators = { "+": function(t4) {
      return t4.join(`<e>+</e>`);
    }, "-": function(t4) {
      return `<e>-` + t4.join(`-`) + `</e>`;
    }, "*": function(t4) {
      return t4.join(`<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>`);
    }, "/": function(n2) {
      return t32.dfrac(n2[0], n2[1]);
    }, "^": function(n2) {
      return t32.power(n2[0], n2[1]);
    }, sin: function(n2) {
      return t32.trig(`sin`, n2[0]);
    }, cos: function(n2) {
      return t32.trig(`cos`, n2[0]);
    }, tan: function(n2) {
      return t32.trig(`tan`, n2[0]);
    }, arcsin: function(n2) {
      return t32.trig(`arcsin`, n2[0]);
    }, arccos: function(n2) {
      return t32.trig(`arccos`, n2[0]);
    }, arctan: function(n2) {
      return t32.trig(`arctan`, n2[0]);
    }, arccsc: function(n2) {
      return t32.trig(`arccsc`, n2[0]);
    }, arcsec: function(n2) {
      return t32.trig(`arcsec`, n2[0]);
    }, arccot: function(n2) {
      return t32.trig(`arccot`, n2[0]);
    }, csc: function(n2) {
      return t32.trig(`csc`, n2[0]);
    }, sec: function(n2) {
      return t32.trig(`sec`, n2[0]);
    }, cot: function(n2) {
      return t32.trig(`cot`, n2[0]);
    }, log: function(n2) {
      return t32.trig(`log`, n2[0]);
    }, exp: function(n2) {
      return t32.trig(`exp`, n2[0]);
    }, ln: function(n2) {
      return t32.trig(`ln`, n2[0]);
    }, sqrt: function(n2) {
      return t32.sqrt(n2[0]);
    }, abs: function(n2) {
      return t32.abs(n2[0]);
    } };
  }
  static dfrac(t4, n2) {
    return `<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>` + t4 + `<e></e></c><c up="1" down="2" name="denominator"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static trig(t4, n2) {
    return `<f type="` + t4 + `" group="functions"><b p="latex">\\` + t4 + `\\left(<r ref="1"/>\\right)</b><b p="text"> ` + t4 + `(<r ref="1"/>)</b><c delete="1"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static sqrt(t4) {
    return `<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static power(t4, n2) {
    return `<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>` + t4 + `<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static abs(t4) {
    return `<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static paren(t4) {
    return `<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static isFunctionSymbol(t4) {
    return [`sin`, `cos`, `tan`, `csc`, `sec`, `cot`, `arcsin`, `arccos`, `arctan`, `arccsc`, `arcsec`, `arccot`, `log`, `ln`, `exp`, `sqrt`, `abs`, `this.factorial`].indexOf(t4) !== -1;
  }
  static isGreekLetterSymbol(t4) {
    return `pi.theta.theta.Theta.alpha.nu.beta.xi.Xi.gamma.Gamma.delta.Delta.pi.Pi.epsilon.epsilon.rho.rho.zeta.sigma.Sigma.eta.tau.upsilon.Upsilon.iota.phi.phi.Phi.kappa.chi.lambda.Lambda.psi.Psi.omega.Omega`.split(`.`).indexOf(t4) !== -1;
  }
  factorWithParenthesesIfNegated(n2) {
    var r2 = this.factor(n2);
    return r2.toString().match(/^<e>-/) ? t32.paren(r2.toString()) : r2;
  }
  factor(n2) {
    if (typeof n2 == `string`) return t32.isGreekLetterSymbol(n2) ? `<f type="` + n2 + `" group="greek" c="yes"><b p="latex">\\` + n2 + `</b><b p="text"> $` + n2 + `</b></f>` : `<e>` + n2 + `</e>`;
    if (typeof n2 == `number`) return `<e>` + n2 + `</e>`;
    if (!Array.isArray(n2)) return `<e></e>`;
    var r2 = n2[0], i2 = n2.slice(1);
    return r2 === `apply` && (r2 = n2[1], i2 = n2.slice(2)), r2 === `abs` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.expression(t4);
    }).bind(this))) : t32.isFunctionSymbol(r2) ? r2 === `this.factorial` && (i2[0].toString().length === 1 || i2[0].toString().match(/^[0-9]*$/)) ? this.operators[r2](i2) : this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : r2 === `^` || r2 === `~` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : t32.paren(this.expression(n2));
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `*` ? this.operators[n2](r2.map((function(t5, n3) {
      var r3 = this.factorWithParenthesesIfNegated(t5);
      return r3.toString().match(/^[0-9]/) && n3 > 0 ? ` * ` + r3 : r3;
    }).bind(this))) : n2 === `/` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this))) : this.factor(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` || n2 === `-` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factorWithParenthesesIfNegated(t5);
    }).bind(this))) : this.term(t4);
  }
  convert(t4) {
    return (`<m><e></e>` + this.expression(t4) + `<e></e></m>`).replace(/<\/e><e>/g, ``);
  }
}, glslOperators$1 = { "+": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `+` + t5;
  }), n2;
}, "-": function(t4) {
  var n2 = `-` + t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "~": function(t4) {
  var n2 = `vec2(0.0,0.0)`;
  return t4.forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "*": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cmul(` + n2 + `,` + t5 + `)`;
  }), n2;
}, "/": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cdiv(` + n2 + `,` + t5 + `)`;
  }), n2;
}, sin: function(t4) {
  return `csin(` + t4[0] + `)`;
}, cos: function(t4) {
  return `ccos(` + t4[0] + `)`;
}, tan: function(t4) {
  return `ctan(` + t4[0] + `)`;
}, sinh: function(t4) {
  return `csinh(` + t4[0] + `)`;
}, cosh: function(t4) {
  return `ccosh(` + t4[0] + `)`;
}, arcsin: function(t4) {
  return `carcsin(` + t4[0] + `)`;
}, arccos: function(t4) {
  return `carccos(` + t4[0] + `)`;
}, arctan: function(t4) {
  return `carctan(` + t4[0] + `)`;
}, arccsc: function(t4) {
  return `carcsin(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arcsec: function(t4) {
  return `carccos(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arccot: function(t4) {
  return `carctan(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, csc: function(t4) {
  return `ccsc(` + t4[0] + `)`;
}, sec: function(t4) {
  return `csec(` + t4[0] + `)`;
}, cot: function(t4) {
  return `ccot(` + t4[0] + `)`;
}, exp: function(t4) {
  return `cexp(` + t4[0] + `)`;
}, conj: function(t4) {
  return `conjugate(` + t4[0] + `)`;
}, sqrt: function(t4) {
  return `cpower(` + t4[0] + `,vec2(0.5,0.0))`;
}, log: function(t4) {
  return `clog(` + t4[0] + `)`;
}, ln: function(t4) {
  return `clog(` + t4[0] + `)`;
}, "^": function(t4) {
  return `cpower(` + t4[0] + `,` + t4[1] + `)`;
}, abs: function(t4) {
  return `cabs(` + t4[0] + `)`;
}, apply: function(t4) {
  return `vec2(NaN,NaN)`;
} }, astToGLSL$1$1 = class astToGLSL$13 {
  constructor() {
  }
  convert(t4) {
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (typeof t4 == `string`) return t4 === `e` ? `vec2(2.71828182845905,0.0)` : t4 === `pi` ? `vec2(3.14159265358979,0.0)` : t4 === `i` ? `vec2(0.0,1.0)` : String(t4);
    if (typeof t4 == `number`) return `vec2(` + String(t4) + `,0.0)`;
    if (`real` in t4 && `imaginary` in t4) return t4;
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to GLSL`);
      var n2 = r2[0], r2 = r2.slice(1);
      return glslOperators$1[n2](r2.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
    }
    if (n2 in glslOperators$1) return glslOperators$1[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, printing_exports$1 = __exportAll$1({ tex: () => tex$1, toGLSL: () => toGLSL$1, toLatex: () => toLatex$1, toString: () => toString$2, toXML: () => toXML$1 }), astToGuppy$2 = new astToGuppy$1$1(), astToGLSL$2 = new astToGLSL$1$1(), tex$1 = function(t4, n2) {
  return new astToLatex$1$1(n2).convert(t4.tree);
}, toLatex$1 = tex$1, toString$2 = function(t4, n2) {
  return new astToText$2$1(n2).convert(t4.tree);
}, toGLSL$1 = function(t4) {
  return astToGLSL$2.convert(t4.tree);
}, toXML$1 = function(t4) {
  return astToGuppy$2.convert(t4.tree);
}, integration_exports$1 = __exportAll$1({ integrateNumerically: () => integrateNumerically$1 }), integrateNumerically$1 = function(t4, n2, r2, i2) {
  for (var a2 = 100, o2 = 0, s2 = {}, c2 = 0; c2 < a2; c2++) s2[n2] = r2 + (i2 - r2) * (c2 + 0.5) / a2, o2 += t4.evaluate(s2);
  return o2 * (i2 - r2) / a2;
};
init_index_all$1(), init_index_all$1();
function expression_to_polynomial$1(t4) {
  var n2 = get_tree$1(t4);
  if (typeof n2 == `string`) return n2 === `pi` && mathjs_default$1.define_pi || n2 === `i` && mathjs_default$1.define_i || n2 === `e` && mathjs_default$1.define_e ? n2 : [`polynomial`, n2, [[1, 1]]];
  if (typeof n2 == `number`) return n2;
  var r2 = evaluate_to_constant$1(n2, { remove_units_first: false });
  if (Number.isFinite(r2)) return simplify$1(n2);
  if (!Array.isArray(n2) || !operators$3$1(n2).every((t5) => [`+`, `-`, `*`, `^`, `/`, `_`, `prime`].includes(t5))) return false;
  var i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `+`) {
    let t5 = a2.map(expression_to_polynomial$1);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_add$1(t6, n3)) : false;
  } else if (i2 === `-`) {
    let t5 = expression_to_polynomial$1(a2[0]);
    return t5 ? polynomial_neg$1(t5) : false;
  } else if (i2 === `*`) {
    let t5 = a2.map(expression_to_polynomial$1);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_mul$1(t6, n3)) : false;
  } else if (i2 === `^`) {
    let t5 = a2[0], r3 = expression_to_polynomial$1(t5);
    if (r3 === false) return false;
    let i3 = simplify$1(a2[1]);
    if (typeof i3 != `number` || i3 < 0 || !Number.isInteger(i3)) {
      let r4 = evaluate_to_constant$1(i3, { remove_units_first: false });
      if (Number.isFinite(r4)) {
        let n3 = mathjs_default$1.fraction(r4), i4 = { n: mathjs_default$1.number(n3.n), d: mathjs_default$1.number(n3.d), s: mathjs_default$1.number(n3.s) };
        if (i4.d <= 100) {
          t5 = i4.s < 0 ? [`^`, t5, [`/`, -1, i4.d]] : [`^`, t5, [`/`, 1, i4.d]];
          var o2 = [`polynomial`, simplify$1(t5), []];
          return o2[2].push([i4.n, 1]), o2;
        }
      }
      return [`polynomial`, n2, [[1, 1]]];
    }
    return i3 === 0 ? 1 : i3 === 1 ? r3 : polynomial_pow$1(r3, i3);
  } else if (i2 === `/`) {
    var s2 = a2[1], c2 = evaluate_to_constant$1(s2, { remove_units_first: false });
    return Number.isFinite(c2) ? polynomial_mul$1(expression_to_polynomial$1(a2[0]), [`/`, 1, c2]) : [`polynomial`, n2, [[1, 1]]];
  } else return [`polynomial`, n2, [[1, 1]]];
}
function polynomials_in_same_leading_variable$1(t4, n2) {
  return t4[1] !== n2[1] && (compare_function$1(t4[1], n2[1]) < 0 ? n2 = [`polynomial`, t4[1], [[0, n2]]] : t4 = [`polynomial`, n2[1], [[0, t4]]]), [t4, n2];
}
function polynomial_add$1(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify$1([`+`, t4, n2]);
    t4 = [`polynomial`, n2[1], [[0, t4]]];
  } else if (n2[0] !== `polynomial`) n2 = [`polynomial`, t4[1], [[0, n2]]];
  else {
    let r3 = polynomials_in_same_leading_variable$1(t4, n2);
    t4 = r3[0], n2 = r3[1];
  }
  let r2 = [`polynomial`, t4[1], []], i2 = t4[2], a2 = n2[2], o2 = r2[2], s2 = i2.length, c2 = a2.length, l2 = 0, u2 = 0;
  for (; l2 < s2 || u2 < c2; ) if (l2 === s2) a2[u2][1] && o2.push(a2[u2]), u2 += 1;
  else if (u2 === c2) i2[l2][1] && o2.push(i2[l2]), l2 += 1;
  else if (i2[l2][0] === a2[u2][0]) {
    let t5 = polynomial_add$1(i2[l2][1], a2[u2][1]);
    t5 && o2.push([i2[l2][0], t5]), l2 += 1, u2 += 1;
  } else i2[l2][0] < a2[u2][0] ? (i2[l2][1] && o2.push(i2[l2]), l2 += 1) : (a2[u2][1] && o2.push(a2[u2]), u2 += 1);
  return o2.length === 0 ? 0 : o2.length === 1 && o2[0][0] === 0 ? o2[0][1] : r2;
}
function polynomial_neg$1(t4) {
  if (t4[0] !== `polynomial`) return simplify$1([`-`, t4]);
  let n2 = [`polynomial`, t4[1], []], r2 = t4[2], i2 = n2[2], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2.push([r2[o2][0], polynomial_neg$1(r2[o2][1])]);
  return n2;
}
function polynomial_sub$1(t4, n2) {
  return polynomial_add$1(t4, polynomial_neg$1(n2));
}
function polynomial_mul$1(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify$1([`*`, t4, n2]);
    if (t4) {
      let r3 = [`polynomial`, n2[1], []], i3 = n2[2], a3 = r3[2];
      for (let n3 of i3) n3[1] && a3.push([n3[0], polynomial_mul$1(t4, n3[1])]);
      return r3;
    }
  } else if (n2 && n2[0] !== `polynomial`) {
    let r3 = [`polynomial`, t4[1], []], i3 = t4[2], a3 = r3[2];
    for (let t5 of i3) t5[1] && a3.push([t5[0], polynomial_mul$1(t5[1], n2)]);
    return r3;
  }
  let r2 = polynomials_in_same_leading_variable$1(t4, n2);
  t4 = r2[0], n2 = r2[1];
  let i2 = t4[2], a2 = n2[2], o2 = [`polynomial`, t4[1], []], s2 = o2[2], c2 = i2.length, l2 = a2.length, u2 = [];
  for (let t5 of i2) for (let n3 of a2) {
    let r3 = false, i3 = t5[0] + n3[0];
    for (let t6 of u2) if (i3 === t6) {
      r3 = true;
      break;
    }
    r3 || u2.push(i3);
  }
  u2.sort(function(t5, n3) {
    return t5 - n3;
  });
  for (let t5 of u2) {
    let n3 = 0, r3 = 0;
    for (; r3 < c2 && i2[r3][0] <= t5; ) {
      let o3 = 0;
      for (; o3 < l2 && a2[o3][0] <= t5; ) {
        if (i2[r3][0] + a2[o3][0] === t5) {
          n3 = polynomial_add$1(n3, polynomial_mul$1(i2[r3][1], a2[o3][1]));
          break;
        }
        o3 += 1;
      }
      r3 += 1;
    }
    n3 && s2.push([t5, n3]);
  }
  return o2;
}
function polynomial_pow$1(t4, n2) {
  if (isNaN(n2) || n2 < 0 || !Number.isInteger(n2)) return;
  let r2 = 1;
  for (; n2 > 0; ) n2 & 1 && (r2 = polynomial_mul$1(r2, t4)), t4 = polynomial_mul$1(t4, t4), n2 >>= 1;
  return r2;
}
function polynomial_to_expression$1(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = t4[1], r2 = t4[2], i2 = [], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) r2[o2][1] && (r2[o2][0] === 0 ? i2.push(polynomial_to_expression$1(r2[o2][1])) : r2[o2][0] === 1 ? i2.push([`*`, polynomial_to_expression$1(r2[o2][1]), n2]) : i2.push([`*`, polynomial_to_expression$1(r2[o2][1]), [`^`, n2, r2[o2][0]]]));
  return i2.length === 0 ? 0 : (i2.length === 1 ? i2 = i2[0] : i2.unshift(`+`), simplify$1(i2));
}
function initial_term$1(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = [];
  for (; Array.isArray(t4) && t4[0] === `polynomial`; ) {
    let r2 = t4[1], i2 = t4[2], a2 = i2[i2.length - 1][0];
    t4 = i2[i2.length - 1][1], n2.push([r2, a2]);
  }
  return [`monomial`, t4, n2];
}
function mono_less_than$1(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return false;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return true;
  let r2 = t4[2], i2 = n2[2], a2 = r2.length, o2 = i2.length;
  for (var s2 = a2 < o2 ? a2 : o2, c2 = 0; c2 < s2; c2++) {
    if (r2[c2][0] !== i2[c2][0]) return !(compare_function$1(r2[c2][0], i2[c2][0]) < 0);
    if (r2[c2][1] < i2[c2][1]) return true;
    if (r2[c2][1] > i2[c2][1]) return false;
  }
  return !(a2 === o2 || s2 === o2);
}
function mono_gcd$1(t4, n2) {
  if (!Array.isArray(t4) || !Array.isArray(n2) || t4[0] !== `monomial` || n2[0] !== `monomial`) return 1;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) r2[c2][0] === i2[l2][0] ? (r2[c2][1] < i2[l2][1] ? a2.push(r2[c2]) : a2.push(i2[l2]), c2 += 1, l2 += 1) : compare_function$1(r2[c2][0], i2[l2][0]) < 0 ? c2 += 1 : compare_function$1(i2[l2][0], r2[c2][0]) < 0 && (l2 += 1);
  return a2.length === 0 ? 1 : [`monomial`, 1, a2];
}
function mono_div$1(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return n2 === 1 ? t4 : !Array.isArray(t4) || t4[0] !== `monomial` ? evaluate_numbers$1([`/`, t4, n2]) : [t4[0], evaluate_numbers$1([`/`, t4[1], n2]), t4[2]];
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function$1(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function$1(i2[l2][0], r2[c2][0]) < 0) return;
  if (!(l2 < s2)) {
    for (; c2 < o2; ) a2.push(r2[c2]), c2 += 1;
    return a2.length === 0 ? n2[1] === 1 ? t4[1] : evaluate_numbers$1([`/`, t4[1], n2[1]]) : n2[1] === 1 ? [`monomial`, t4[1], a2] : [`monomial`, evaluate_numbers$1([`/`, t4[1], n2[1]]), a2];
  }
}
function mono_is_div$1(t4, n2) {
  if (n2 === 0) return false;
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return true;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return false;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return false;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function$1(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function$1(i2[l2][0], r2[c2][0]) < 0) return false;
  return !(l2 < s2);
}
function mono_to_poly$1(t4) {
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return t4;
  let n2 = t4[2].length - 1, r2 = t4[1];
  for (; n2 >= 0; ) {
    var i2 = [];
    i2.push([t4[2][n2][1], r2]), r2 = [`polynomial`, t4[2][n2][0], i2], --n2;
  }
  return r2;
}
function max_div_init$1(t4, n2) {
  if (t4 === 0) return 0;
  let r2 = t4, i2 = [];
  for (; Array.isArray(r2) && r2[0] === `polynomial`; ) {
    let t5 = r2[1], n3 = r2[2], a3 = n3[n3.length - 1][0];
    r2 = n3[n3.length - 1][1], i2.push([t5, a3]);
  }
  let a2 = [`monomial`, r2, i2], o2 = n2.length;
  for (var s2 = 0; s2 < o2; s2 += 1) if (mono_is_div$1(a2, n2[s2])) return [a2, s2];
  return max_div_init$1(polynomial_sub$1(t4, mono_to_poly$1(a2)), n2);
}
function poly_div$1(t4, n2) {
  let r2 = [], i2 = [], a2 = [], o2 = [], s2 = t4;
  for (var c2 of n2) r2.push(initial_term$1(c2));
  let l2 = max_div_init$1(s2, r2);
  for (; l2 !== 0; ) a2 = l2[1], o2 = mono_div$1(l2[0], r2[a2]), i2.push([a2, o2]), s2 = polynomial_sub$1(s2, polynomial_mul$1(mono_to_poly$1(o2), n2[a2])), l2 = max_div_init$1(s2, r2);
  return [i2, s2];
}
function prereduce$1(t4) {
  let n2 = t4.length, r2 = [];
  for (var i2 = 0; i2 < n2; i2++) {
    if (t4[i2] !== 0 && (!Array.isArray(t4[i2]) || t4[i2][0] !== `polynomial`)) return [1];
    t4[i2] !== 0 && r2.push(t4[i2]);
  }
  return r2.length === 0 ? [0] : r2;
}
function reduce_ith$1(t4, n2) {
  let r2 = [], a2 = [], o2 = [], s2 = n2[t4], c2 = n2.length;
  for (var l2 = 0; l2 < c2; l2 += 1) l2 === t4 ? r2.push(0) : r2.push(initial_term$1(n2[l2]));
  let u2 = max_div_init$1(s2, r2);
  for (; u2 !== 0; ) a2 = u2[1], o2 = mono_div$1(u2[0], r2[a2]), s2 = polynomial_sub$1(s2, polynomial_mul$1(mono_to_poly$1(o2), n2[a2])), u2 = max_div_init$1(s2, r2);
  return s2;
}
function reduce$2(t4) {
  let n2 = 0, r2 = [], i2 = prereduce$1(t4), a2 = i2.length;
  if (a2 === 1) return i2;
  let o2 = true;
  for (; o2; ) for (o2 = false, i2 = prereduce$1(i2), a2 = i2.length, n2 = 0; n2 < a2; ) r2 = reduce_ith$1(n2, i2), _$2.isEqual(r2, i2[n2]) || (i2[n2] = r2, o2 = true), n2 += 1;
  n2 = 0;
  let s2 = [], c2 = 0;
  for (; n2 < a2; ) s2 = initial_term$1(i2[n2]), !Array.isArray(s2) || s2[0] !== `monomial` ? i2[n2] = 1 : (c2 = s2[1], c2 !== 1 && (i2[n2] = polynomial_mul$1(i2[n2], [`/`, 1, c2]))), n2 += 1;
  return i2;
}
function hij$1(t4, n2, r2) {
  let i2 = initial_term$1(r2[t4]), a2 = initial_term$1(r2[n2]), o2 = mono_gcd$1(i2, a2), s2 = mono_to_poly$1(mono_div$1(i2, o2));
  return poly_div$1(polynomial_sub$1(polynomial_mul$1(mono_to_poly$1(mono_div$1(a2, o2)), r2[t4]), polynomial_mul$1(s2, r2[n2])), r2)[1];
}
function build_hij_table$1(t4, n2) {
  let r2 = n2.length, i2 = 0, a2 = 1, o2 = [];
  for (; a2 < r2; ) {
    for (; i2 < a2; ) t4[[i2, a2]] = hij$1(i2, a2, n2), t4[[i2, a2]] !== 0 && o2.push(t4[[i2, a2]]), i2 += 1;
    i2 = 0, a2 += 1;
  }
  return o2.length > 0 ? choice_lowest_degree$1(o2) : 0;
}
function update_hij_table$1(t4, n2, r2) {
  let i2 = n2.length;
  n2.push(r2);
  let a2 = 0, o2 = 1, s2 = [];
  for (; o2 < i2; ) {
    for (; a2 < o2; ) t4[[a2, o2]] !== 0 && (t4[[a2, o2]] = hij$1(a2, o2, n2), t4[[a2, o2]] !== 0 && s2.push(t4[[a2, o2]])), a2 += 1;
    a2 = 0, o2 += 1;
  }
  for (; a2 < i2; ) t4[[a2, i2]] = hij$1(a2, i2, n2), t4[[a2, i2]] !== 0 && s2.push(t4[[a2, i2]]), a2 += 1;
  return s2.length > 0 ? choice_lowest_degree$1(s2) : 0;
}
function choice_lowest_degree$1(t4) {
  let n2 = [], r2 = t4.length;
  for (a2 = 0; a2 < r2; a2 += 1) n2.push(initial_term$1(t4[a2]));
  let i2 = 0;
  for (var a2 = 1; a2 < r2; a2 += 1) {
    if (n2[a2] === 1) return 1;
    mono_less_than$1(n2[a2], n2[i2]) && (i2 = a2);
  }
  return t4[i2];
}
function reduced_grobner$1(t4) {
  let n2 = reduce$2(t4), r2 = {}, i2 = build_hij_table$1(r2, n2);
  for (; i2 !== 0; ) i2 = update_hij_table$1(r2, n2, i2);
  return n2 = reduce$2(n2), n2;
}
function poly_lcm$1(t4, n2) {
  let r2 = reduced_grobner$1([polynomial_mul$1([`polynomial`, `_t`, [[1, 1]]], t4), polynomial_mul$1([`polynomial`, `_t`, [[0, 1], [1, -1]]], n2)]), i2 = r2.length;
  for (var a2 = 0; a2 < i2; a2 += 1) {
    if (!Array.isArray(r2[a2]) || r2[a2][0] !== `polynomial`) return 1;
    if (r2[a2][1] !== `_t`) return r2[a2];
  }
}
function poly_gcd$1(t4, n2) {
  let r2 = poly_lcm$1(t4, n2), i2 = poly_div$1(polynomial_mul$1(t4, n2), [r2]), a2 = 0, o2 = i2[0].length;
  for (var s2 = 0; s2 < o2; s2 += 1) a2 = polynomial_add$1(a2, mono_to_poly$1(i2[0][s2][1]));
  let c2 = initial_term$1(a2);
  if (!Array.isArray(c2) || c2[0] !== `monomial`) a2 = 1;
  else {
    let t5 = c2[1];
    t5 !== 1 && (a2 = polynomial_mul$1(a2, [`/`, 1, t5]));
  }
  return a2;
}
function poly_by_divisor$1(t4, n2) {
  let r2 = poly_div$1(t4, [n2]), i2 = 0, a2 = r2[0].length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2 = polynomial_add$1(i2, mono_to_poly$1(r2[0][o2][1]));
  return i2;
}
function reduce_rational_expression$1(t4, n2) {
  let r2 = stringify_vars$1(t4), i2 = stringify_vars$1(n2);
  t4 = r2[0], n2 = i2[0];
  let a2 = poly_gcd$1(t4, n2), o2 = initial_term$1(n2)[1], s2 = polynomial_mul$1(a2, o2), c2 = poly_by_divisor$1(t4, s2), l2 = poly_by_divisor$1(n2, s2);
  return [destringify_vars$1(destringify_vars$1(c2, r2[1]), i2[1]), destringify_vars$1(destringify_vars$1(l2, r2[1]), i2[1])];
}
function stringify_vars$1(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return [t4, {}];
  let n2 = {}, r2 = `z` + JSON.stringify(t4[1]);
  n2[r2] = t4[1], t4[1] = r2;
  let i2 = t4[2], a2 = [];
  for (let t5 of i2) {
    a2 = stringify_vars$1(t5[1]), t5[1] = a2[0];
    for (let t6 in a2[1]) n2[t6] = a2[1][t6];
  }
  return [t4, n2];
}
function destringify_vars$1(t4, n2) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  n2[t4[1]] && (t4[1] = n2[t4[1]]);
  let r2 = t4[2];
  for (let t5 of r2) t5[1] = destringify_vars$1(t5[1], n2);
  return t4;
}
var rational_exports$1 = __exportAll$1({ common_denominator: () => common_denominator$1, reduce_rational: () => reduce_rational$1 }), textToAst$1$1 = new textToAst$4$1();
function common_denominator$1(t4, n2) {
  t4 = simplify$1(t4, n2);
  var r2 = [];
  return r2.push([textToAst$1$1.convert(`a/c+b/c`), textToAst$1$1.convert(`(a+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`a/c-b/c`), textToAst$1$1.convert(`(a-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`a+b/c`), textToAst$1$1.convert(`(ac+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`a-b/c`), textToAst$1$1.convert(`(ac-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`a/d+b/c`), textToAst$1$1.convert(`(ac+bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`a/d-b/c`), textToAst$1$1.convert(`(ac-bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`x*(y/z)`), textToAst$1$1.convert(`(x*y)/z`), { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1$1.convert(`(x/y)/z`), textToAst$1$1.convert(`x/(y*z)`), { allow_extended_match: true, allow_permutations: true }]), r2.push([textToAst$1$1.convert(`x/(y/z)`), textToAst$1$1.convert(`xz/y`), { allow_extended_match: true, allow_permutations: true }]), t4 = applyAllTransformations$1(t4, r2, 40), t4 = expand$1(t4, true), t4;
}
function as_num_denom$1(t4) {
  var n2 = get_tree$1(t4);
  return n2 = common_denominator$1(n2), n2[0] === `/` ? [n2[1], n2[2]] : [n2, 1];
}
function reduce_rational$1(t4) {
  var n2 = get_tree$1(t4), r2 = as_num_denom$1(n2);
  if (r2[1] === 1) return n2;
  var i2 = reduce_rational_expression$1(expression_to_polynomial$1(r2[0]), expression_to_polynomial$1(r2[1])), a2 = polynomial_to_expression$1(i2[0]), o2 = polynomial_to_expression$1(i2[1]);
  return o2 === 1 ? a2 : [`/`, a2, o2];
}
var round_exports$1 = __exportAll$1({ round_numbers_to_decimals: () => round_numbers_to_decimals$1, round_numbers_to_precision: () => round_numbers_to_precision$1, round_numbers_to_precision_plus_decimals: () => round_numbers_to_precision_plus_decimals$1 });
function toFixed$3(t4, n2) {
  return mathjs_default$1.format(t4, { notation: `fixed`, precision: n2 });
}
function round_numbers_to_precision$1(t4, n2 = 14) {
  var r2 = get_tree$1(t4);
  if (n2 < 1) throw Error(`For round_numbers_to_precision, digits must be positive`);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_precision, digits must be a number`);
  return n2 > 15 ? r2 : (n2 = Math.round(n2), round_numbers_to_precision_sub$1(r2, n2));
}
var round_numbers_to_precision_sub$1 = function(t4, n2 = 14) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let r2 = n2 - mathjs_default$1.floor(mathjs_default$1.log10(mathjs_default$1.abs(t4))) - 1;
    return parseFloat(r2 < 0 ? toFixed$3(t4, r2) + `0`.repeat(mathjs_default$1.abs(r2)) : toFixed$3(t4, r2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_sub$1(t5, n2))] : t4;
};
function round_numbers_to_decimals$1(t4, n2 = 14) {
  var r2 = get_tree$1(t4);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_decimals, ndecimals must be a number`);
  return n2 = Math.round(n2), n2 = Math.max(-330, Math.min(330, n2)), round_numbers_to_decimals_sub$1(r2, n2);
}
var round_numbers_to_decimals_sub$1 = function(t4, n2 = 0) {
  return typeof t4 == `number` ? parseFloat(n2 < 0 ? toFixed$3(t4, n2) + `0`.repeat(mathjs_default$1.abs(n2)) : toFixed$3(t4, n2)) : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_decimals_sub$1(t5, n2))] : t4;
};
function round_numbers_to_precision_plus_decimals$1(t4, n2 = 4, r2 = 2) {
  var i2 = get_tree$1(t4);
  let a2 = true, o2 = true;
  if (n2 >= 1) {
    if (n2 = Math.round(n2), n2 > 15) return i2;
  } else a2 = false;
  return Number.isFinite(r2) ? (r2 = Math.round(r2), r2 = Math.max(-330, Math.min(330, r2))) : o2 = false, a2 ? o2 ? round_numbers_to_precision_plus_decimals_sub$1(i2, n2, r2) : round_numbers_to_precision_sub$1(i2, n2) : o2 ? round_numbers_to_decimals_sub$1(i2, r2) : i2;
}
var round_numbers_to_precision_plus_decimals_sub$1 = function(t4, n2 = 4, r2 = 2) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let i2 = mathjs_default$1.floor(mathjs_default$1.log10(mathjs_default$1.abs(t4))), a2 = Math.max(n2 - i2 - 1, r2);
    return parseFloat(a2 < 0 ? toFixed$3(t4, a2) + `0`.repeat(mathjs_default$1.abs(a2)) : toFixed$3(t4, a2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_plus_decimals_sub$1(t5, n2, r2))] : t4;
}, match_exports$1 = __exportAll$1({ match: () => match$2 }), match$2 = function(t4, n2, r2) {
  return match$1$1(get_tree$1(t4), get_tree$1(n2), r2);
}, expression_to_tree$1$1 = [simplify_exports$1, differentiation_exports$1, normalization_exports$1, arithmetic_exports$1, transformation_exports$1, solve_exports$1, sets_exports$1, matrix_exports$1, rational_exports$1, round_exports$1], expression_to_other$1 = [variables_exports$1, printing_exports$1, equality_exports$1, integration_exports$1, evaluation_exports$1, analytic_exports$1, sign_error_exports$1, match_exports$1], standard_exports$1 = __exportAll$1({ abs: () => abs$2, acos: () => acos$2, acosh: () => acosh$3, acot: () => acot$1, acoth: () => acoth$1, acsc: () => acsc$1, acsch: () => acsch$1, asec: () => asec$1, asech: () => asech$1, asin: () => asin$2, asinh: () => asinh$3, atan: () => atan$2, atan2: () => atan2$2, atanh: () => atanh$3, conj: () => conj$1, cos: () => cos$2, cosh: () => cosh$4, cot: () => cot$1, coth: () => coth$1, csc: () => csc$1, csch: () => csch$1, erf: () => erf$1, exp: () => exp$2, factorial: () => factorial$1, gamma: () => gamma$1, im: () => im$1, log: () => log$2, log10: () => log10$3, re: () => re$2, sec: () => sec$1, sech: () => sech$1, sign: () => sign$3, sin: () => sin$2, sinh: () => sinh$4, sqrt: () => sqrt$2, tan: () => tan$2, tanh: () => tanh$3 });
function abs$2(t4) {
  return [`apply`, `abs`, get_tree$1(t4)];
}
function exp$2(t4) {
  return [`apply`, `exp`, get_tree$1(t4)];
}
function log$2(t4) {
  return [`apply`, `log`, get_tree$1(t4)];
}
function log10$3(t4) {
  return [`apply`, `log10`, get_tree$1(t4)];
}
function sign$3(t4) {
  return [`apply`, `sign`, get_tree$1(t4)];
}
function sqrt$2(t4) {
  return [`apply`, `sqrt`, get_tree$1(t4)];
}
function conj$1(t4) {
  return [`apply`, `conj`, get_tree$1(t4)];
}
function im$1(t4) {
  return [`apply`, `im`, get_tree$1(t4)];
}
function re$2(t4) {
  return [`apply`, `re`, get_tree$1(t4)];
}
function factorial$1(t4) {
  return [`apply`, `factorial`, get_tree$1(t4)];
}
function gamma$1(t4) {
  return [`apply`, `gamma`, get_tree$1(t4)];
}
function erf$1(t4) {
  return [`apply`, `erf`, get_tree$1(t4)];
}
function acos$2(t4) {
  return [`apply`, `acos`, get_tree$1(t4)];
}
function acosh$3(t4) {
  return [`apply`, `acosh`, get_tree$1(t4)];
}
function acot$1(t4) {
  return [`apply`, `acot`, get_tree$1(t4)];
}
function acoth$1(t4) {
  return [`apply`, `acoth`, get_tree$1(t4)];
}
function acsc$1(t4) {
  return [`apply`, `acsc`, get_tree$1(t4)];
}
function acsch$1(t4) {
  return [`apply`, `acsch`, get_tree$1(t4)];
}
function asec$1(t4) {
  return [`apply`, `asec`, get_tree$1(t4)];
}
function asech$1(t4) {
  return [`apply`, `asech`, get_tree$1(t4)];
}
function asin$2(t4) {
  return [`apply`, `asin`, get_tree$1(t4)];
}
function asinh$3(t4) {
  return [`apply`, `asinh`, get_tree$1(t4)];
}
function atan$2(t4) {
  return [`apply`, `atan`, get_tree$1(t4)];
}
function atanh$3(t4) {
  return [`apply`, `atanh`, get_tree$1(t4)];
}
function cos$2(t4) {
  return [`apply`, `cos`, get_tree$1(t4)];
}
function cosh$4(t4) {
  return [`apply`, `cosh`, get_tree$1(t4)];
}
function cot$1(t4) {
  return [`apply`, `cot`, get_tree$1(t4)];
}
function coth$1(t4) {
  return [`apply`, `coth`, get_tree$1(t4)];
}
function csc$1(t4) {
  return [`apply`, `csc`, get_tree$1(t4)];
}
function csch$1(t4) {
  return [`apply`, `csch`, get_tree$1(t4)];
}
function sec$1(t4) {
  return [`apply`, `sec`, get_tree$1(t4)];
}
function sech$1(t4) {
  return [`apply`, `sech`, get_tree$1(t4)];
}
function sin$2(t4) {
  return [`apply`, `sin`, get_tree$1(t4)];
}
function sinh$4(t4) {
  return [`apply`, `sinh`, get_tree$1(t4)];
}
function tan$2(t4) {
  return [`apply`, `tan`, get_tree$1(t4)];
}
function tanh$3(t4) {
  return [`apply`, `tanh`, get_tree$1(t4)];
}
function atan2$2(t4, n2) {
  return [`apply`, `atan2`, [`tuple`, get_tree$1(t4), get_tree$1(n2)]];
}
var expression_to_tree$2 = [standard_exports$1], whitespace_rule$1 = `\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b`, number_rules_sci$2 = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`]], number_rules_non_sci$2 = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_latex_rules$1 = [[`\\*`, `*`], [`\\/`, `/`], [`-`, `-`], [`\\+`, `+`], [`\\\\pm(?![a-zA-Z])`, `PM`], [`\\^`, `^`], [`\\(`, `(`], [`\\\\left\\s*\\(`, `(`], [`\\\\bigl\\s*\\(`, `(`], [`\\\\Bigl\\s*\\(`, `(`], [`\\\\biggl\\s*\\(`, `(`], [`\\\\Biggl\\s*\\(`, `(`], [`\\)`, `)`], [`\\\\right\\s*\\)`, `)`], [`\\\\bigr\\s*\\)`, `)`], [`\\\\Bigr\\s*\\)`, `)`], [`\\\\biggr\\s*\\)`, `)`], [`\\\\Biggr\\s*\\)`, `)`], [`\\[`, `[`], [`\\\\left\\s*\\[`, `[`], [`\\\\bigl\\s*\\[`, `[`], [`\\\\Bigl\\s*\\[`, `[`], [`\\\\biggl\\s*\\[`, `[`], [`\\\\Biggl\\s*\\[`, `[`], [`\\]`, `]`], [`\\\\right\\s*\\]`, `]`], [`\\\\bigr\\s*\\]`, `]`], [`\\\\Bigr\\s*\\]`, `]`], [`\\\\biggr\\s*\\]`, `]`], [`\\\\Biggr\\s*\\]`, `]`], [`\\|`, `|`], [`\\\\left\\s*\\|`, `|L`], [`\\\\bigl\\s*\\|`, `|L`], [`\\\\Bigl\\s*\\|`, `|L`], [`\\\\biggl\\s*\\|`, `|L`], [`\\\\Biggl\\s*\\|`, `|L`], [`\\\\right\\s*\\|`, `|`], [`\\\\bigr\\s*\\|`, `|`], [`\\\\Bigr\\s*\\|`, `|`], [`\\\\biggr\\s*\\|`, `|`], [`\\\\Biggr\\s*\\|`, `|`], [`\\\\big\\s*\\|`, `|`], [`\\\\Big\\s*\\|`, `|`], [`\\\\bigg\\s*\\|`, `|`], [`\\\\Bigg\\s*\\|`, `|`], [`{`, `{`], [`}`, `}`], [`\\\\{`, `LBRACE`], [`\\\\left\\s*\\\\{`, `LBRACE`], [`\\\\bigl\\s*\\\\{`, `LBRACE`], [`\\\\Bigl\\s*\\\\{`, `LBRACE`], [`\\\\biggl\\s*\\\\{`, `LBRACE`], [`\\\\Biggl\\s*\\\\{`, `LBRACE`], [`\\\\}`, `RBRACE`], [`\\\\right\\s*\\\\}`, `RBRACE`], [`\\\\bigr\\s*\\\\}`, `RBRACE`], [`\\\\Bigr\\s*\\\\}`, `RBRACE`], [`\\\\biggr\\s*\\\\}`, `RBRACE`], [`\\\\Biggr\\s*\\\\}`, `RBRACE`], [`\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\left\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\right\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\left\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\right\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\left\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\right\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\cdot(?![a-zA-Z])`, `*`], [`\\\\div(?![a-zA-Z])`, `/`], [`\\\\times(?![a-zA-Z])`, `*`], [`,`, `,`], [`:`, `:`], [`\\\\mid(?![a-zA-Z])`, `MID`], [`\\\\varnothing(?![a-zA-Z])`, `LATEXCOMMAND`, `\\emptyset`], [`\\\\vartheta(?![a-zA-Z])`, `LATEXCOMMAND`, `\\theta`], [`\\\\varepsilon(?![a-zA-Z])`, `LATEXCOMMAND`, `\\epsilon`], [`\\\\varrho(?![a-zA-Z])`, `LATEXCOMMAND`, `\\rho`], [`\\\\varphi(?![a-zA-Z])`, `LATEXCOMMAND`, `\\phi`], [`\\\\infty(?![a-zA-Z])`, `INFINITY`], [`\\\\asin(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arcsin`], [`\\\\acos(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arccos`], [`\\\\atan(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arctan`], [`\\\\sqrt(?![a-zA-Z])`, `SQRT`], [`\\\\land(?![a-zA-Z])`, `AND`], [`\\\\wedge(?![a-zA-Z])`, `AND`], [`\\\\lor(?![a-zA-Z])`, `OR`], [`\\\\vee(?![a-zA-Z])`, `OR`], [`\\\\lnot(?![a-zA-Z])`, `NOT`], [`\\\\neg(?![a-zA-Z])`, `NOT`], [`=`, `=`], [`\\\\neq(?![a-zA-Z])`, `NE`], [`\\\\ne(?![a-zA-Z])`, `NE`], [`\\\\not\\s*=`, `NE`], [`\\\\leq(?![a-zA-Z])`, `LE`], [`\\\\le(?![a-zA-Z])`, `LE`], [`\\\\geq(?![a-zA-Z])`, `GE`], [`\\\\ge(?![a-zA-Z])`, `GE`], [`<`, `<`], [`\\\\lt(?![a-zA-Z])`, `<`], [`>`, `>`], [`\\\\gt(?![a-zA-Z])`, `>`], [`\\\\forall(?![a-zA-Z])`, `FORALL`], [`\\\\exists(?![a-zA-Z])`, `EXISTS`], [`\\\\in(?![a-zA-Z])`, `IN`], [`\\\\notin(?![a-zA-Z])`, `NOTIN`], [`\\\\not\\s*\\\\in(?![a-zA-Z])`, `NOTIN`], [`\\\\ni(?![a-zA-Z])`, `NI`], [`\\\\not\\s*\\\\ni(?![a-zA-Z])`, `NOTNI`], [`\\\\subset(?![a-zA-Z])`, `SUBSET`], [`\\\\subseteq(?![a-zA-Z])`, `SUBSETEQ`], [`\\\\not\\s*\\\\subset(?![a-zA-Z])`, `NOTSUBSET`], [`\\\\not\\s*\\\\subseteq(?![a-zA-Z])`, `NOTSUBSETEQ`], [`\\\\supset(?![a-zA-Z])`, `SUPERSET`], [`\\\\supseteq(?![a-zA-Z])`, `SUPERSETEQ`], [`\\\\not\\s*\\\\supset(?![a-zA-Z])`, `NOTSUPERSET`], [`\\\\not\\s*\\\\supseteq(?![a-zA-Z])`, `NOTSUPERSETEQ`], [`\\\\cup(?![a-zA-Z])`, `UNION`], [`\\\\cap(?![a-zA-Z])`, `INTERSECT`], [`\\\\to(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\rightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\longrightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\gets(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\longleftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\longleftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\implies(?![a-zA-Z])`, `IMPLIES`], [`\\\\Longrightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\Rightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\impliedby(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Longleftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Leftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\iff(?![a-zA-Z])`, `IFF`], [`\\\\Longleftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\Leftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\perp(?![a-zA-Z])`, `PERP`], [`\\\\bot(?![a-zA-Z])`, `PERP`], [`\\\\parallel(?![a-zA-Z])`, `PARALLEL`], [`\\\\\\|`, `PARALLEL`], [`\\\\angle(?![a-zA-Z])`, `ANGLE`], [`\\\\int(?![a-zA-Z])`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`&`, `&`], [`\\\\ldots(?![a-zA-Z])`, `LDOTS`], [`\\\\\\\\`, `LINEBREAK`], [`\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `BEGINENVIRONMENT`], [`\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `ENDENVIRONMENT`], [`\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}`, `VARMULTICHAR`], [`\\\\[a-zA-Z]+(?![a-zA-Z])`, `LATEXCOMMAND`], [`\\\\[$%]`, `LATEXCOMMAND`], [`[a-zA-Z＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault$2 = true, allowedLatexSymbolsDefault$2 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.angle.circ.%.$.emptyset`.split(`.`), appliedFunctionSymbolsDefault$2 = `abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.Re.Im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault$2 = [`f`, `g`], operatorSymbolsDefault$2 = { frac: { nargs: 2, substitute: `/` }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: `linesegment`, remove_products: true } }, unitsDefault$2 = get_all_units$1();
unitsDefault$2.circ = unitsDefault$2.deg, unitsDefault$2.circ.substitute = `deg`, unitsDefault$2.circ.isExponent = true, delete unitsDefault$2.deg;
var parseLeibnizNotationDefault$2 = true, latexToAst$1$1 = class latexToAst$13 {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault$2, allowedLatexSymbols: n2 = allowedLatexSymbolsDefault$2, appliedFunctionSymbols: r2 = appliedFunctionSymbolsDefault$2, functionSymbols: i2 = functionSymbolsDefault$2, operatorSymbols: a2 = operatorSymbolsDefault$2, units: o2 = unitsDefault$2, parseLeibnizNotation: s2 = parseLeibnizNotationDefault$2, parseScientificNotation: c2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.allowedLatexSymbols = n2, this.appliedFunctionSymbols = r2, this.functionSymbols = i2, this.operatorSymbols = a2, this.units = o2, this.parseLeibnizNotation = s2;
    let l2 = base_latex_rules$1;
    l2 = c2 ? [...number_rules_sci$2, ...l2] : [...number_rules_non_sci$2, ...l2], this.lexer = new lexer$1(l2, whitespace_rule$1);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError$1(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError$1(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten$7(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      if (this.token.token_type !== `:` && this.token.token_type !== `MID`) return r2;
      let i2 = this.token.token_type === `:` ? `:` : `|`;
      return this.advance(), [i2, r2, this.statement_a()];
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type[0] !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten$7(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let t5 = r2.length;
      for (let [n3, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && n3 < t5 - 1) {
            let o2;
            o2 = n3 === t5 - 2 ? r2[t5 - 1] : this.convert_units_in_term([`*`, ...r2.slice(n3 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return n3 === 0 ? c2 : [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this)), c2];
          } else if (!a2.prefix && n3 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = n3 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this))], o2], n3 === t5 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(n3 + 1)]);
          }
        }
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    else if (n2 === `^`) {
      let t5 = this.units[r2[1]];
      if (t5 && t5.isExponent) {
        let n3 = r2[1];
        return t5.substitute && (n3 = t5.substitute), [`unit`, r2[0], n3];
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    }
    return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_single_digit_as_number() {
    if (this.token.token_type === `NUMBER` && this.token.token_text[0] !== `.`) {
      let t4 = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), t4;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    let n2 = this.get_single_digit_as_number();
    if (n2 !== null) return n2;
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n3 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n3 === false && (n3 = `＿`), n3;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `BEGINENVIRONMENT`) {
      let t5 = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if ([`matrix`, `pmatrix`, `bmatrix`].includes(t5)) {
        let r3 = 0, i3 = 0, o2 = [], s2 = [], c2 = 0, l2 = this.token.token_type;
        for (this.advance(); this.token.token_type !== `ENDENVIRONMENT`; ) this.token.token_type === `&` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), l2 = this.token.token_type, this.advance()) : this.token.token_type === `LINEBREAK` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, c2 = 0, s2 = [], l2 = this.token.token_type, this.advance()) : (s2.push(this.statement({ parse_absolute_value: n2 })), c2 += 1, l2 = ` `);
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== t5) throw new ParseError$1(`Expecting \\end{` + t5 + `}`, this.lexer.location);
        l2 === `&` && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, this.advance(), a2 = [`matrix`, [`tuple`, r3, i3]];
        let u2 = [`tuple`];
        for (let t6 of o2) {
          let n3 = [`tuple`].concat(t6);
          for (let r4 = t6.length; r4 < i3; r4 += 1) n3.push(0);
          u2.push(n3);
        }
        return a2.push(u2), a2;
      } else throw new ParseError$1(`Unrecognized environment ` + t5, this.lexer.location);
    }
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `SQRT`) {
      this.advance();
      let t5 = 2;
      if (this.token.token_type === `[`) {
        this.advance();
        let r4 = this.statement({ parse_absolute_value: n2 });
        if (this.token.token_type !== `]`) throw new ParseError$1(`Expecting ]`, this.lexer.location);
        this.advance(), t5 = r4;
      }
      if (this.token.token_type !== `{`) throw new ParseError$1(`Expecting {`, this.lexer.location);
      this.advance();
      let r3 = this.statement({ parse_absolute_value: n2 });
      if (this.token.token_type !== `}`) throw new ParseError$1(`Expecting }`, this.lexer.location);
      this.advance(), a2 = t5 === 2 ? [`apply`, `sqrt`, r3] : t5 === 3 ? [`apply`, `cbrt`, r3] : [`apply`, `nthroot`, [`tuple`, r3, t5]];
    } else if (this.token.token_type === `VAR` || this.token.token_type === `LATEXCOMMAND` || this.token.token_type === `VARMULTICHAR`) {
      if (a2 = this.token.token_text, this.token.token_type === `LATEXCOMMAND`) {
        if (a2 = a2.slice(1), !(this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2) || this.allowedLatexSymbols.includes(a2) || a2 in this.operatorSymbols)) throw new ParseError$1(`Unrecognized latex command ` + this.token.original_text, this.lexer.location);
      } else this.token.token_type === `VARMULTICHAR` && (a2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(a2)[1]);
      if (this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
        let t5 = false;
        if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), [`Re`, `Im`].includes(a2) && (a2 = a2.toLowerCase()), this.advance(), this.token.token_type === `_`) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
        }
        if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
        else {
          for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
          for (; this.token.token_type === `^`; ) {
            this.advance();
            let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
            a2 = [`^`, a2, t6];
          }
          if (this.token.token_type === `{` || this.token.token_type === `(`) {
            let t6;
            t6 = this.token.token_type === `{` ? `}` : `)`, this.advance();
            let n3 = this.statement_list();
            if (this.token.token_type !== t6) throw new ParseError$1(`Expecting ` + t6, this.lexer.location);
            this.advance(), n3[0] === `list` && (n3[0] = `tuple`), a2 = [`apply`, a2, n3];
          } else if (t5) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError$1(`Expecting ( after function`, this.lexer.location);
            let t6 = this.factor({ parse_absolute_value: n2 });
            t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
          }
        }
        return a2;
      } else if (a2 in this.operatorSymbols) {
        if (this.advance(), a2 === `frac` && this.parseLeibnizNotation) {
          let t6 = this.return_state(), n3 = this.leibniz_notation();
          if (n3) return n3;
          this.set_state(t6);
        }
        let t5 = a2;
        this.operatorSymbols[a2].substitute && (t5 = this.operatorSymbols[a2].substitute);
        let r3 = this.operatorSymbols[a2].nargs, i3 = this.operatorSymbols[a2].remove_products, o2 = [];
        for (let t6 = 0; t6 < r3; t6++) if (this.token.token_type === `{`) {
          this.advance();
          let t7 = this.statement({ parse_absolute_value: n2 });
          if (i3 && Array.isArray(t7) && t7[0] === `*` ? o2.push(...t7.slice(1)) : o2.push(t7), this.token.token_type !== `}`) throw new ParseError$1(`Expecting }`, this.lexer.location);
          this.advance();
        } else {
          let t7 = this.get_single_digit_as_number();
          if (t7 === null) if (this.token.token_type === `VAR`) t7 = this.token.token_text, this.advance();
          else throw new ParseError$1(`Expecting {`, this.lexer.location);
          o2.push(t7);
        }
        a2 = [t5, ...o2];
      } else this.advance();
    } else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LBRACE` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : this.token.token_type === `LBRACE` ? (n3 = `RBRACE`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError$1(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError$1(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` || t5 === `{` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `LBRACE` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `LBRACE` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type[0] === `|` && n2 && (t4 === 0 || !r2 || this.token.token_type[1] === `L`)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError$1(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `LFLOOR` || this.token.token_type === `LCEIL`) {
      let t5, n3;
      if (this.token.token_type === `LFLOOR` ? (t5 = `RFLOOR`, n3 = `floor`) : this.token.token_type === `LCEIL` && (t5 = `RCEIL`, n3 = `ceil`), this.advance(), a2 = this.statement(), a2 = [`apply`, n3, a2], this.token.token_type !== t5) throw new ParseError$1(`Expecting ` + t5, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `{` || this.token.token_type === `(`) {
      let t5;
      t5 = this.token.token_type === `{` ? `}` : `)`, this.advance();
      let n3 = this.statement_list();
      if (this.token.token_type !== t5) throw new ParseError$1(`Expecting ` + t5, this.lexer.location);
      this.advance(), n3[0] === `list` ? a2 = [`angle`, ...n3.slice(1)] : n3[0] === `*` && (a2 = [`angle`, n3]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten$7(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    if (this.token.token_type !== `{`) return false;
    this.advance();
    var t4 = this.token.token_text;
    let n2 = ``, r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (this.token.token_type === `LATEXCOMMAND` && t4.slice(1) === `partial`) n2 = `∂`;
    else if (this.token.token_type === `VAR` && t4 === `d`) n2 = `d`;
    else return false;
    if (this.advance(), this.token.token_type === `^`) {
      this.advance();
      let t5 = false;
      if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
      this.advance();
    }
    if (this.token.token_type === `VAR`) i2 = this.token.token_text;
    else if (this.token.token_type === `VARMULTICHAR`) i2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if (this.token.token_type === `LATEXCOMMAND`) if (t4 = this.token.token_text.slice(1), this.allowedLatexSymbols.includes(t4)) i2 = t4;
    else return false;
    if (this.advance(), this.token.token_type !== `}` || (this.advance(), this.token.token_type !== `{`)) return false;
    this.advance();
    let s2 = 0;
    for (; ; ) {
      if (!(n2 === `d` && this.token.token_type === `VAR` && this.token.token_text === `d` || n2 === `∂` && this.token.token_type === `LATEXCOMMAND` && this.token.token_text.slice(1) === `partial`)) return false;
      if (this.advance(), this.token.token_type === `VAR`) a2.push(this.token.token_text);
      else if (this.token.token_type === `VARMULTICHAR`) a2.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else if (this.token.token_type === `LATEXCOMMAND`) {
        let t5 = this.token.token_text.slice(1);
        if (this.allowedLatexSymbols.includes(t5)) a2.push(t5);
        else return false;
      } else return false;
      let c2 = 1;
      if (this.advance(), this.token.token_type === `^`) {
        this.advance();
        let t5 = false;
        if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (c2 = parseFloat(this.token.token_text), !Number.isInteger(c2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
        this.advance();
      }
      if (o2.push(c2), s2 += c2, s2 > r2) return false;
      if (s2 === r2) {
        if (this.token.token_type !== `}`) return false;
        this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, latexToGuppy$1 = class latexToGuppy3 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(t4));
  }
}, latexToMathjs$1 = class latexToMathjs3 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToMathjs = new astToMathjs$2$1();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(t4));
  }
}, latexToText$1 = class latexToText3 {
  constructor() {
    this.latexToAst = new latexToAst$1$1(), this.astToText = new astToText$2$1();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(t4));
  }
}, mathjsToGuppy$1 = class mathjsToGuppy3 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToLatex$1 = class mathjsToLatex3 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$1(), this.astToLatex = new astToLatex$1$1();
  }
  convert(t4) {
    return this.astToLatex.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToText$1 = class mathjsToText3 {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1$1(), this.astToText = new astToText$2$1();
  }
  convert(t4) {
    return this.astToText.convert(this.mathjsToAst.convert(t4));
  }
}, require_ms$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = 1e3, i2 = r2 * 60, a2 = i2 * 60, o2 = a2 * 24, s2 = o2 * 365.25;
  n2.exports = function(t5, n3) {
    n3 ||= {};
    var r3 = typeof t5;
    if (r3 === `string` && t5.length > 0) return c2(t5);
    if (r3 === `number` && isNaN(t5) === false) return n3.long ? u2(t5) : l2(t5);
    throw Error(`val is not a non-empty string or a valid number. val=` + JSON.stringify(t5));
  };
  function c2(t5) {
    if (t5 = String(t5), !(t5.length > 100)) {
      var n3 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t5);
      if (n3) {
        var c3 = parseFloat(n3[1]);
        switch ((n3[2] || `ms`).toLowerCase()) {
          case `years`:
          case `year`:
          case `yrs`:
          case `yr`:
          case `y`:
            return c3 * s2;
          case `days`:
          case `day`:
          case `d`:
            return c3 * o2;
          case `hours`:
          case `hour`:
          case `hrs`:
          case `hr`:
          case `h`:
            return c3 * a2;
          case `minutes`:
          case `minute`:
          case `mins`:
          case `min`:
          case `m`:
            return c3 * i2;
          case `seconds`:
          case `second`:
          case `secs`:
          case `sec`:
          case `s`:
            return c3 * r2;
          case `milliseconds`:
          case `millisecond`:
          case `msecs`:
          case `msec`:
          case `ms`:
            return c3;
          default:
            return;
        }
      }
    }
  }
  function l2(t5) {
    return t5 >= o2 ? Math.round(t5 / o2) + `d` : t5 >= a2 ? Math.round(t5 / a2) + `h` : t5 >= i2 ? Math.round(t5 / i2) + `m` : t5 >= r2 ? Math.round(t5 / r2) + `s` : t5 + `ms`;
  }
  function u2(t5) {
    return d2(t5, o2, `day`) || d2(t5, a2, `hour`) || d2(t5, i2, `minute`) || d2(t5, r2, `second`) || t5 + ` ms`;
  }
  function d2(t5, n3, r3) {
    if (!(t5 < n3)) return t5 < n3 * 1.5 ? Math.floor(t5 / n3) + ` ` + r3 : Math.ceil(t5 / n3) + ` ` + r3 + `s`;
  }
})), require_debug$1 = __commonJSMin$1(((t4, n2) => {
  t4 = n2.exports = a2.debug = a2.default = a2, t4.coerce = l2, t4.disable = s2, t4.enable = o2, t4.enabled = c2, t4.humanize = require_ms$1(), t4.names = [], t4.skips = [], t4.formatters = {};
  var r2;
  function i2(n3) {
    var r3 = 0, i3;
    for (i3 in n3) r3 = (r3 << 5) - r3 + n3.charCodeAt(i3), r3 |= 0;
    return t4.colors[Math.abs(r3) % t4.colors.length];
  }
  function a2(n3) {
    function a3() {
      if (a3.enabled) {
        var n4 = a3, i3 = +/* @__PURE__ */ new Date();
        n4.diff = i3 - (r2 || i3), n4.prev = r2, n4.curr = i3, r2 = i3;
        for (var o3 = Array(arguments.length), s3 = 0; s3 < o3.length; s3++) o3[s3] = arguments[s3];
        o3[0] = t4.coerce(o3[0]), typeof o3[0] != `string` && o3.unshift(`%O`);
        var c3 = 0;
        o3[0] = o3[0].replace(/%([a-zA-Z%])/g, function(r3, i4) {
          if (r3 === `%%`) return r3;
          c3++;
          var a4 = t4.formatters[i4];
          if (typeof a4 == `function`) {
            var s4 = o3[c3];
            r3 = a4.call(n4, s4), o3.splice(c3, 1), c3--;
          }
          return r3;
        }), t4.formatArgs.call(n4, o3), (a3.log || t4.log || console.log.bind(console)).apply(n4, o3);
      }
    }
    return a3.namespace = n3, a3.enabled = t4.enabled(n3), a3.useColors = t4.useColors(), a3.color = i2(n3), typeof t4.init == `function` && t4.init(a3), a3;
  }
  function o2(n3) {
    t4.save(n3), t4.names = [], t4.skips = [];
    for (var r3 = (typeof n3 == `string` ? n3 : ``).split(/[\s,]+/), i3 = r3.length, a3 = 0; a3 < i3; a3++) r3[a3] && (n3 = r3[a3].replace(/\*/g, `.*?`), n3[0] === `-` ? t4.skips.push(RegExp(`^` + n3.substr(1) + `$`)) : t4.names.push(RegExp(`^` + n3 + `$`)));
  }
  function s2() {
    t4.enable(``);
  }
  function c2(n3) {
    var r3, i3;
    for (r3 = 0, i3 = t4.skips.length; r3 < i3; r3++) if (t4.skips[r3].test(n3)) return false;
    for (r3 = 0, i3 = t4.names.length; r3 < i3; r3++) if (t4.names[r3].test(n3)) return true;
    return false;
  }
  function l2(t5) {
    return t5 instanceof Error ? t5.stack || t5.message : t5;
  }
})), require_browser$1 = __commonJSMin$1(((t4, n2) => {
  t4 = n2.exports = require_debug$1(), t4.log = a2, t4.formatArgs = i2, t4.save = o2, t4.load = s2, t4.useColors = r2, t4.storage = typeof chrome < `u` && chrome.storage !== void 0 ? chrome.storage.local : c2(), t4.colors = [`lightseagreen`, `forestgreen`, `goldenrod`, `dodgerblue`, `darkorchid`, `crimson`];
  function r2() {
    return typeof window < `u` && window.process && window.process.type === `renderer` ? true : typeof document < `u` && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < `u` && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  t4.formatters.j = function(t5) {
    try {
      return JSON.stringify(t5);
    } catch (t6) {
      return `[UnexpectedJSONParseError]: ` + t6.message;
    }
  };
  function i2(n3) {
    var r3 = this.useColors;
    if (n3[0] = (r3 ? `%c` : ``) + this.namespace + (r3 ? ` %c` : ` `) + n3[0] + (r3 ? `%c ` : ` `) + `+` + t4.humanize(this.diff), r3) {
      var i3 = `color: ` + this.color;
      n3.splice(1, 0, i3, `color: inherit`);
      var a3 = 0, o3 = 0;
      n3[0].replace(/%[a-zA-Z%]/g, function(t5) {
        t5 !== `%%` && (a3++, t5 === `%c` && (o3 = a3));
      }), n3.splice(o3, 0, i3);
    }
  }
  function a2() {
    return typeof console == `object` && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function o2(n3) {
    try {
      n3 == null ? t4.storage.removeItem(`debug`) : t4.storage.debug = n3;
    } catch {
    }
  }
  function s2() {
    var n3;
    try {
      n3 = t4.storage.debug;
    } catch {
    }
    return !n3 && typeof process < `u` && `env` in process && (n3 = process.env.DEBUG), n3;
  }
  t4.enable(s2());
  function c2() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})), require_xml_parser$1 = __commonJSMin$1(((t4, n2) => {
  var r2 = require_browser$1()(`xml-parser`);
  n2.exports = i2;
  function i2(t5) {
    return t5 = t5.trim(), t5 = t5.replace(/<!--[\s\S]*?-->/g, ``), n3();
    function n3() {
      return { declaration: i3(), root: a2() };
    }
    function i3() {
      if (l2(/^<\?xml\s*/)) {
        for (var t6 = { attributes: {} }; !(u2() || d2(`?>`)); ) {
          var n4 = s2();
          if (!n4) return t6;
          t6.attributes[n4.name] = n4.value;
        }
        return l2(/\?>\s*/), t6;
      }
    }
    function a2() {
      r2(`tag %j`, t5);
      var n4 = l2(/^<([\w-:.]+)\s*/);
      if (n4) {
        for (var i4 = { name: n4[1], attributes: {}, children: [] }; !(u2() || d2(`>`) || d2(`?>`) || d2(`/>`)); ) {
          var c3 = s2();
          if (!c3) return i4;
          i4.attributes[c3.name] = c3.value;
        }
        if (l2(/^\s*\/>\s*/)) return i4;
        l2(/\??>\s*/), i4.content = o2();
        for (var p2; p2 = a2(); ) i4.children.push(p2);
        return l2(/^<\/[\w-:.]+>\s*/), i4;
      }
    }
    function o2() {
      r2(`content %j`, t5);
      var n4 = l2(/^([^<]*)/);
      return n4 ? n4[1] : ``;
    }
    function s2() {
      r2(`attribute %j`, t5);
      var n4 = l2(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (n4) return { name: n4[1], value: c2(n4[2]) };
    }
    function c2(t6) {
      return t6.replace(/^['"]|['"]$/g, ``);
    }
    function l2(n4) {
      var r3 = t5.match(n4);
      if (r3) return t5 = t5.slice(r3[0].length), r3;
    }
    function u2() {
      return t5.length == 0;
    }
    function d2(n4) {
      return t5.indexOf(n4) == 0;
    }
  }
})), import_xml_parser$1 = __toESM$1(require_xml_parser$1()), entities$1 = { "&#913;": `\\Alpha`, "&Alpha;": `\\Alpha`, "&#x0391;": `\\Alpha`, "\\u0391;": `\\Alpha`, "&#914;": `\\Beta`, "&Beta;": `\\Beta`, "&#x0392;": `\\Beta`, "\\u0392;": `\\Beta`, "&#915;": `\\Gamma`, "&Gamma;": `\\Gamma`, "&#x0393;": `\\Gamma`, "\\u0393;": `\\Gamma`, "&#916;": `\\Delta`, "&Delta;": `\\Delta`, "&#x0394;": `\\Delta`, "\\u0394;": `\\Delta`, "&#917;": `\\Epsilon`, "&Epsilon;": `\\Epsilon`, "&#x0395;": `\\Epsilon`, "\\u0395;": `\\Epsilon`, "&#918;": `\\Zeta`, "&Zeta;": `\\Zeta`, "&#x0396;": `\\Zeta`, "\\u0396;": `\\Zeta`, "&#919;": `\\Eta`, "&Eta;": `\\Eta`, "&#x0397;": `\\Eta`, "\\u0397;": `\\Eta`, "&#920;": `\\Theta`, "&Theta;": `\\Theta`, "&#x0398;": `\\Theta`, "\\u0398;": `\\Theta`, "&#921;": `\\Iota`, "&Iota;": `\\Iota`, "&#x0399;": `\\Iota`, "\\u0399;": `\\Iota`, "&#922;": `\\Kappa`, "&Kappa;": `\\Kappa`, "&#x039A;": `\\Kappa`, "\\u039A;": `\\Kappa`, "&#923;": `\\Lambda`, "&Lambda;": `\\Lambda`, "&#x039B;": `\\Lambda`, "\\u039B;": `\\Lambda`, "&#924;": `\\Mu`, "&Mu;": `\\Mu`, "&#x039C;": `\\Mu`, "\\u039C;": `\\Mu`, "&#925;": `\\Nu`, "&Nu;": `\\Nu`, "&#x039D;": `\\Nu`, "\\u039D;": `\\Nu`, "&#926;": `\\Xi`, "&Xi;": `\\Xi`, "&#x039E;": `\\Xi`, "\\u039E;": `\\Xi`, "&#927;": `\\Omicron`, "&Omicron;": `\\Omicron`, "&#x039F;": `\\Omicron`, "\\u039F;": `\\Omicron`, "&#928;": `\\Pi`, "&Pi;": `\\Pi`, "&#x03A0;": `\\Pi`, "\\u03A0;": `\\Pi`, "&#929;": `\\Rho`, "&Rho;": `\\Rho`, "&#x03A1;": `\\Rho`, "\\u03A1;": `\\Rho`, "&#931;": `\\Sigma`, "&Sigma;": `\\Sigma`, "&#x03A3;": `\\Sigma`, "\\u03A3;": `\\Sigma`, "&#932;": `\\Tau`, "&Tau;": `\\Tau`, "&#x03A4;": `\\Tau`, "\\u03A4;": `\\Tau`, "&#933;": `\\Upsilon`, "&Upsilon;": `\\Upsilon`, "&#x03A5;": `\\Upsilon`, "\\u03A5;": `\\Upsilon`, "&#934;": `\\Phi`, "&Phi;": `\\Phi`, "&#x03A6;": `\\Phi`, "\\u03A6;": `\\Phi`, "&#935;": `\\Chi`, "&Chi;": `\\Chi`, "&#x03A7;": `\\Chi`, "\\u03A7;": `\\Chi`, "&#936;": `\\Psi`, "&Psi;": `\\Psi`, "&#x03A8;": `\\Psi`, "\\u03A8;": `\\Psi`, "&#937;": `\\Omega`, "&Omega;": `\\Omega`, "&#x03A9;": `\\Omega`, "\\u03A9;": `\\Omega`, "&#945;": `\\alpha`, "&alpha;": `\\alpha`, "&#x03B1;": `\\alpha`, "\\u03B1;": `\\alpha`, "&#946;": `\\beta`, "&beta;": `\\beta`, "&#x03B2;": `\\beta`, "\\u03B2;": `\\beta`, "&#947;": `\\gamma`, "&gamma;": `\\gamma`, "&#x03B3;": `\\gamma`, "\\u03B3;": `\\gamma`, "&#948;": `\\delta`, "&delta;": `\\delta`, "&#x03B4;": `\\delta`, "\\u03B4;": `\\delta`, "&#949;": `\\epsilon`, "&epsilon;": `\\epsilon`, "&#x03B5;": `\\epsilon`, "\\u03B5;": `\\epsilon`, "&#950;": `\\zeta`, "&zeta;": `\\zeta`, "&#x03B6;": `\\zeta`, "\\u03B6;": `\\zeta`, "&#951;": `\\eta`, "&eta;": `\\eta`, "&#x03B7;": `\\eta`, "\\u03B7;": `\\eta`, "&#952;": `\\theta`, "&theta;": `\\theta`, "&#x03B8;": `\\theta`, "\\u03B8;": `\\theta`, "&#953;": `\\iota`, "&iota;": `\\iota`, "&#x03B9;": `\\iota`, "\\u03B9;": `\\iota`, "&#954;": `\\kappa`, "&kappa;": `\\kappa`, "&#x03BA;": `\\kappa`, "\\u03BA;": `\\kappa`, "&#955;": `\\lambda`, "&lambda;": `\\lambda`, "&#x03BB;": `\\lambda`, "\\u03BB;": `\\lambda`, "&#956;": `\\mu`, "&mu;": `\\mu`, "&#x03BC;": `\\mu`, "\\u03BC;": `\\mu`, "&#957;": `\\nu`, "&nu;": `\\nu`, "&#x03BD;": `\\nu`, "\\u03BD;": `\\nu`, "&#958;": `\\xi`, "&xi;": `\\xi`, "&#x03BE;": `\\xi`, "\\u03BE;": `\\xi`, "&#959;": `\\omicron`, "&omicron;": `\\omicron`, "&#x03BF;": `\\omicron`, "\\u03BF;": `\\omicron`, "&#960;": `\\pi`, "&pi;": `\\pi`, "&#x03C0;": `\\pi`, "\\u03C0;": `\\pi`, "&#961;": `\\rho`, "&rho;": `\\rho`, "&#x03C1;": `\\rho`, "\\u03C1;": `\\rho`, "&#962;": `\\sigma`, ";": `\\sigma`, "&#x03C2;": `\\sigma`, "\\u03C2;": `\\sigma`, "&#963;": `\\sigma`, "&sigma;": `\\sigma`, "&#x03C3;": `\\sigma`, "\\u03C3;": `\\sigma`, "&#964;": `\\tau`, "&tau;": `\\tau`, "&#x03C4;": `\\tau`, "\\u03C4;": `\\tau`, "&#965;": `\\upsilon`, "&upsilon;": `\\upsilon`, "&#x03C5;": `\\upsilon`, "\\u03C5;": `\\upsilon`, "&#966;": `\\phi`, "&phi;": `\\phi`, "&#x03C6;": `\\phi`, "\\u03C6;": `\\phi`, "&#967;": `\\chi`, "&chi;": `\\chi`, "&#x03C7;": `\\chi`, "\\u03C7;": `\\chi`, "&#968;": `\\psi`, "&psi;": `\\psi`, "&#x03C8;": `\\psi`, "\\u03C8;": `\\psi`, "&#969;": `\\omega`, "&omega;": `\\omega`, "&#x03C9;": `\\omega`, "\\u03C9;": `\\omega`, "&#x2212;": `-`, "&minus;": `-`, "&#x221E;": `\\infty`, "&#8734;": `\\infty`, "&infin;": `\\infty`, "&sdot;": `\\cdot`, "&#x22C5;": `\\cdot`, "&#8901;": `\\cdot`, "&times;": `\\times`, "&#x00D7;": `\\times`, "&#215;": `\\times` }, mmlToLatex$1 = class mmlToLatex3 {
  parse(t4) {
    if (t4.name === `mi`) return entities$1[t4.content] ? entities$1[t4.content] : t4.content.length > 1 ? `\\` + t4.content : t4.content;
    if (t4.name === `mn`) return t4.content;
    if (t4.name === `msup`) return this.parse(t4.children[0]) + `^{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mroot`) return `\\sqrt[` + this.parse(t4.children[1]) + `]{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mfrac`) return `\\frac{` + this.parse(t4.children[0]) + `}{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `msqrt`) return `\\sqrt{` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `}`;
    if (t4.name === `mo`) return entities$1[t4.content] ? entities$1[t4.content] : t4.content === `&#x2061;` ? ` ` : t4.content;
    if (t4.name === `mrow` && t4.attributes.class === `MJX-TeXAtom-ORD`) return t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `);
    if (t4.name === `math` || t4.name === `mrow`) return `(` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `)`;
  }
  convert(t4) {
    return this.parse((0, import_xml_parser$1.default)(t4).root);
  }
}, mmlToAst$1$1 = class mmlToAst$13 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1();
  }
  convert(t4) {
    return this.latexToAst.convert(this.mmlToLatex.convert(t4));
  }
}, mmlToGuppy$1 = class mmlToGuppy3 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToMathjs$1 = class mmlToMathjs3 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToMathjs = new astToMathjs$2$1();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToText$1 = class mmlToText3 {
  constructor() {
    this.mmlToLatex = new mmlToLatex$1(), this.latexToAst = new latexToAst$1$1(), this.astToText = new astToText$2$1();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, textToGuppy$1 = class textToGuppy3 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToGuppy = new astToGuppy$1$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.textToAst.convert(t4));
  }
}, textToLatex$1 = class textToLatex3 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToLatex = new astToLatex$1$1();
  }
  convert(t4) {
    return this.astToLatex.convert(this.textToAst.convert(t4));
  }
}, textToMathjs$1 = class textToMathjs3 {
  constructor() {
    this.textToAst = new textToAst$4$1(), this.astToMathjs = new astToMathjs$2$1();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.textToAst.convert(t4));
  }
}, converters_exports$1 = __exportAll$1({ astToFiniteFieldObj: () => astToFiniteField$1$1, astToGLSL: () => astToGLSL$1$1, astToGuppyObj: () => astToGuppy$1$1, astToLatexObj: () => astToLatex$1$1, astToMathjsObj: () => astToMathjs$2$1, astToTextObj: () => astToText$2$1, latexToAstObj: () => latexToAst$1$1, latexToGuppyObj: () => latexToGuppy$1, latexToMathjsObj: () => latexToMathjs$1, latexToTextObj: () => latexToText$1, mathjsToAstObj: () => mathjsToAst$1$1, mathjsToGuppyObj: () => mathjsToGuppy$1, mathjsToLatexObj: () => mathjsToLatex$1, mathjsToTextObj: () => mathjsToText$1, mmlToAstObj: () => mmlToAst$1$1, mmlToGuppyObj: () => mmlToGuppy$1, mmlToLatexObj: () => mmlToLatex$1, mmlToMathjsObj: () => mmlToMathjs$1, mmlToTextObj: () => mmlToText$1, textToAstObj: () => textToAst$4$1, textToGuppyObj: () => textToGuppy$1, textToLatexObj: () => textToLatex$1, textToMathjsObj: () => textToMathjs$1 }), textToAst$5 = new textToAst$4$1(), latexToAst$2 = new latexToAst$1$1(), mmlToAst$2 = new mmlToAst$1$1(), utils$2 = { match: match$1$1, flatten: flatten$5$1, unflattenLeft: unflattenLeft$1, unflattenRight: unflattenRight$1 };
function Expression$1(t4, n2) {
  this.tree = flatten$5$1(t4), this.context = n2, this.toJSON = function() {
    let t5 = { objectType: `math-expression`, tree: this.tree }, n3 = {};
    for (let t6 in this.context.assumptions) Object.keys(this.context.assumptions[t6]).length > 0 && (n3[t6] = this.context.assumptions[t6]);
    return Object.keys(n3).length > 0 && (t5.assumptions = n3), t5;
  };
}
function extend$3(t4, n2) {
  return flatten_array$1(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) n2 ? (function() {
      var n3 = i2;
      t4[n3] = function() {
        return this.fromAst(r2[n3].apply(null, arguments));
      };
    })() : t4[i2] = r2[i2];
  }), t4;
}
function extend_prototype$1(t4, n2) {
  return flatten_array$1(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) (function() {
      var a2 = i2;
      t4[a2] = function() {
        var t5 = [this].concat(Array.prototype.slice.call(arguments));
        return n2 ? this.context.fromAst(r2[a2].apply(null, t5)) : r2[a2].apply(null, t5);
      };
    })();
  }), t4;
}
function create_from_multiple$1(t4, n2) {
  if (Array.isArray(t4) || typeof t4 == `number`) return new Expression$1(t4, Context$1);
  if (typeof t4 == `string`) try {
    return new Expression$1(textToAst$5.convert(t4), Context$1);
  } catch (n3) {
    try {
      return new Expression$1(latexToAst$2.convert(t4), Context$1);
    } catch (r2) {
      try {
        return new Expression$1(mmlToAst$2.convert(t4), Context$1);
      } catch (i2) {
        throw t4.indexOf(`\\`) === -1 ? t4.indexOf(`</`) === -1 ? n3 : i2 : r2;
      }
    }
  }
}
function parseText$1(t4, n2) {
  return new Expression$1(textToAst$5.convert(t4), Context$1);
}
function parseLatex$1(t4, n2) {
  return new Expression$1(latexToAst$2.convert(t4), Context$1);
}
function parseMml$1(t4, n2) {
  return new Expression$1(mmlToAst$2.convert(t4), Context$1);
}
var Context$1 = { ZmodN: ZmodN$1, assumptions: initialize_assumptions$1(), parser_parameters: {}, from: create_from_multiple$1, fromText: parseText$1, parse: parseText$1, fromLaTeX: parseLatex$1, fromLatex: parseLatex$1, fromTeX: parseLatex$1, fromTex: parseLatex$1, fromMml: parseMml$1, parse_tex: parseLatex$1, converters: converters_exports$1, utils: utils$2, fromAst: function(t4) {
  return new Expression$1(t4, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions$1();
}, get_assumptions: function(t4, n2) {
  return get_assumptions$1(this.assumptions, t4, n2);
}, add_assumption: function(t4, n2) {
  return add_assumption$1(this.assumptions, t4, n2);
}, add_generic_assumption: function(t4) {
  return add_generic_assumption$1(this.assumptions, t4);
}, remove_assumption: function(t4) {
  return remove_assumption$1(this.assumptions, t4);
}, remove_generic_assumption: function(t4) {
  return remove_generic_assumption$1(this.assumptions, t4);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions$1();
}, math: mathjs_default$1, reviver: function(t4, n2) {
  if (n2 && n2.objectType === `math-expression` && n2.tree !== void 0) {
    let t5 = Context$1.fromAst(n2.tree);
    return n2.assumptions !== void 0 && (t5.assumptions = n2.assumptions), t5;
  }
  return n2;
}, class: Expression$1 };
Context$1.set_to_default(), extend$3(Context$1, true, expression_to_tree$1$1, expression_to_tree$2), extend$3(Context$1, false, expression_to_other$1), extend_prototype$1(Expression$1.prototype, true, expression_to_tree$1$1), extend_prototype$1(Expression$1.prototype, false, expression_to_other$1);
function flatten_array$1(t4, n2) {
  n2 = n2 === void 0 ? [] : n2;
  for (var r2 = 0; r2 < t4.length; r2++) Array.isArray(t4[r2]) ? flatten_array$1(t4[r2], n2) : n2.push(t4[r2]);
  return n2;
}
var base32$1$1 = { exports: {} };
var hasRequiredBase32$1;
function requireBase32$1() {
  if (hasRequiredBase32$1) return base32$1$1.exports;
  hasRequiredBase32$1 = 1;
  (function(module) {
    (function() {
      var root2 = typeof window === "object" ? window : {};
      var NODE_JS = !root2.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root2 = commonjsGlobal$1;
      }
      var COMMON_JS = !root2.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position2, partial2) {
        if (partial2.length > 10) {
          partial2 = "..." + partial2.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position2 + " bytes: " + partial2 + " <-");
        err.position = position2;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i3 = 0, followingChars = 0, b2, c2;
        while (i3 < length) {
          b2 = bytes[i3++];
          if (b2 <= 127) {
            str += String.fromCharCode(b2);
            continue;
          } else if (b2 > 191 && b2 <= 223) {
            c2 = b2 & 31;
            followingChars = 1;
          } else if (b2 <= 239) {
            c2 = b2 & 15;
            followingChars = 2;
          } else if (b2 <= 247) {
            c2 = b2 & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i3, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b2 = bytes[i3++];
            if (b2 < 128 || b2 > 191) {
              throwInvalidUtf8(i3, str);
            }
            c2 <<= 6;
            c2 += b2 & 63;
          }
          if (c2 >= 55296 && c2 <= 57343) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 > 1114111) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 <= 65535) {
            str += String.fromCharCode(c2);
          } else {
            c2 -= 65536;
            str += String.fromCharCode((c2 >> 10) + 55296);
            str += String.fromCharCode((c2 & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index2 = 0, length = base32Str.length;
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index2++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3++);
          v5 = str.charCodeAt(i3++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code2, end = false, base32Str = "", index2 = 0, i3, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i3 = start; index2 < length && i3 < 5; ++index2) {
            code2 = str.charCodeAt(index2);
            if (code2 < 128) {
              blocks[i3++] = code2;
            } else if (code2 < 2048) {
              blocks[i3++] = 192 | code2 >> 6;
              blocks[i3++] = 128 | code2 & 63;
            } else if (code2 < 55296 || code2 >= 57344) {
              blocks[i3++] = 224 | code2 >> 12;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            } else {
              code2 = 65536 + ((code2 & 1023) << 10 | str.charCodeAt(++index2) & 1023);
              blocks[i3++] = 240 | code2 >> 18;
              blocks[i3++] = 128 | code2 >> 12 & 63;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            }
          }
          start = i3 - 5;
          if (index2 === length) {
            ++index2;
          }
          if (index2 > length && i3 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i3 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i3 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i3 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i3 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3++];
          v5 = bytes[i3++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i3++];
          v2 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode2 = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports2 = {
        encode: encode2,
        decode
      };
      decode.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports2;
      } else {
        root2.base32 = exports2;
      }
    })();
  })(base32$1$1);
  return base32$1$1.exports;
}
requireBase32$1();
const { gcd: gcd$3, lcm: lcm$1 } = Context$1.math;
const { mod: mod$3 } = Context$1.math;
const { dopri: dopri$1 } = Context$1.math;
const defaultCreativeCommonsVersion$1 = "4.0";
function creativeCommonsLicense$1(code2, name2, urlSlug, description) {
  return {
    code: code2,
    name: `Creative Commons ${name2}`,
    description,
    kind: "creative-commons",
    url: (version2 = defaultCreativeCommonsVersion$1) => `https://creativecommons.org/licenses/${urlSlug}/${version2}/`
  };
}
function fixedUrlLicense$1(code2, name2, url, description, kind) {
  return {
    code: code2,
    name: name2,
    description,
    kind,
    url: () => url
  };
}
const mediaLicenses$1 = [
  creativeCommonsLicense$1(
    "CC-BY",
    "Attribution",
    "by",
    "Creative Commons Attribution: reuse with credit, including commercially."
  ),
  creativeCommonsLicense$1(
    "CC-BY-SA",
    "Attribution-ShareAlike",
    "by-sa",
    "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense$1(
    "CC-BY-ND",
    "Attribution-NoDerivatives",
    "by-nd",
    "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."
  ),
  creativeCommonsLicense$1(
    "CC-BY-NC",
    "Attribution-NonCommercial",
    "by-nc",
    "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."
  ),
  creativeCommonsLicense$1(
    "CC-BY-NC-SA",
    "Attribution-NonCommercial-ShareAlike",
    "by-nc-sa",
    "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense$1(
    "CC-BY-NC-ND",
    "Attribution-NonCommercial-NoDerivatives",
    "by-nc-nd",
    "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."
  ),
  fixedUrlLicense$1(
    "CC0",
    "CC0 1.0 Public Domain Dedication",
    "https://creativecommons.org/publicdomain/zero/1.0/",
    "Creative Commons Zero: the creator has dedicated the work to the public domain.",
    "public-domain"
  ),
  fixedUrlLicense$1(
    "PDM",
    "Public Domain Mark 1.0",
    "https://creativecommons.org/publicdomain/mark/1.0/",
    "Public Domain Mark: the work is free of known copyright restrictions.",
    "public-domain"
  ),
  fixedUrlLicense$1(
    "GFDL",
    "GNU Free Documentation License",
    "https://www.gnu.org/licenses/fdl-1.3.html",
    "GNU Free Documentation License: copyleft license common on Wikimedia.",
    "license"
  ),
  fixedUrlLicense$1(
    "FAL",
    "Free Art License 1.3",
    "https://artlibre.org/licence/lal/en/",
    "Free Art License: copyleft license for artistic works.",
    "license"
  ),
  fixedUrlLicense$1(
    "OGL",
    "Open Government Licence v3.0 (UK)",
    "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    "UK Open Government Licence: reuse government material with attribution.",
    "license"
  ),
  fixedUrlLicense$1(
    "MIT",
    "MIT License",
    "https://opensource.org/license/mit",
    "MIT License: permissive license common for icon and illustration sets.",
    "license"
  ),
  fixedUrlLicense$1(
    "APACHE-2.0",
    "Apache License 2.0",
    "https://www.apache.org/licenses/LICENSE-2.0",
    "Apache License 2.0: permissive license common for icon and illustration sets.",
    "license"
  )
];
Object.fromEntries(
  mediaLicenses$1.map((info) => [info.code.toLowerCase(), info])
);
const mathjaxConfig = {
  tex: {
    tags: "ams",
    macros: {
      lt: "<",
      gt: ">",
      amp: "&",
      var: ["\\mathrm{#1}", 1],
      csch: "\\operatorname{csch}",
      sech: "\\operatorname{sech}",
      erf: "\\operatorname{erf}"
    },
    displayMath: [["\\[", "\\]"]]
  },
  output: {
    displayOverflow: "linebreak"
  }
};
var cssesc_1$1;
var hasRequiredCssesc$1;
function requireCssesc$1() {
  if (hasRequiredCssesc$1) return cssesc_1$1;
  hasRequiredCssesc$1 = 1;
  var object2 = {};
  var hasOwnProperty2 = object2.hasOwnProperty;
  var merge = function merge2(options2, defaults2) {
    if (!options2) {
      return defaults2;
    }
    var result2 = {};
    for (var key in defaults2) {
      result2[key] = hasOwnProperty2.call(options2, key) ? options2[key] : defaults2[key];
    }
    return result2;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string2, options2) {
    options2 = merge(options2, cssesc3.options);
    if (options2.quotes != "single" && options2.quotes != "double") {
      options2.quotes = "single";
    }
    var quote2 = options2.quotes == "double" ? '"' : "'";
    var isIdentifier = options2.isIdentifier;
    var firstChar = string2.charAt(0);
    var output = "";
    var counter2 = 0;
    var length = string2.length;
    while (counter2 < length) {
      var character = string2.charAt(counter2++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter2 < length) {
          var extra = string2.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter2--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options2.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote2 == character || character == "'" && quote2 == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options2.wrap) {
      return quote2 + output + quote2;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1$1 = cssesc2;
  return cssesc_1$1;
}
requireCssesc$1();
const globalThis$1 = Function("return this")() || {};
const virtualKeyboardState = globalThis$1?.virtualKeyboardState || {
  count: 0,
  keyboardDomNode: null,
  keyboardReactRoot: null,
  registrations: [],
  lastActiveRegistrationId: null,
  nextRegistrationId: 0
};
globalThis$1.virtualKeyboardState = virtualKeyboardState;
function getRegistrationById(id2) {
  if (id2 === null) {
    return null;
  }
  return virtualKeyboardState.registrations.find(
    (registration) => registration.id === id2
  ) ?? null;
}
function getTrayElement() {
  return document.getElementById("virtual-keyboard-tray");
}
function getActiveRegistration() {
  const activeElement = document.activeElement;
  for (let i2 = virtualKeyboardState.registrations.length - 1; i2 >= 0; i2 -= 1) {
    const registration = virtualKeyboardState.registrations[i2];
    const ownerElement = registration.ownerRef?.current;
    if (ownerElement && activeElement instanceof Node && (ownerElement === activeElement || ownerElement.contains(activeElement))) {
      virtualKeyboardState.lastActiveRegistrationId = registration.id;
      return registration;
    }
  }
  if (activeElement instanceof Node && getTrayElement()?.contains(activeElement)) {
    return getRegistrationById(
      virtualKeyboardState.lastActiveRegistrationId
    );
  }
  return null;
}
function getTrayTheme() {
  const activeRegistration = getActiveRegistration();
  if (activeRegistration) {
    return activeRegistration.theme;
  }
  const lastActiveRegistration = getRegistrationById(
    virtualKeyboardState.lastActiveRegistrationId
  );
  if (lastActiveRegistration) {
    return lastActiveRegistration.theme;
  }
  const registrations = virtualKeyboardState.registrations;
  return registrations[registrations.length - 1]?.theme;
}
function rerenderTray() {
  const theme2 = getTrayTheme();
  const trayEl = getTrayElement();
  if (trayEl) {
    const currentTheme = trayEl.getAttribute("data-theme") ?? void 0;
    if (currentTheme === theme2) {
      return;
    }
  }
  virtualKeyboardState.keyboardReactRoot?.render(renderTray(theme2));
}
function renderTray(theme2) {
  return /* @__PURE__ */ React__default.createElement(MathJaxContext, { config: mathjaxConfig, version: 4 }, /* @__PURE__ */ React__default.createElement(
    KeyboardTray,
    {
      theme: theme2,
      onClick: (e2) => {
        getActiveRegistration()?.onClick(e2);
      }
    }
  ));
}
function UniqueKeyboardTray({
  onClick,
  theme: theme2,
  ownerRef
}) {
  const [id2] = React__default.useState(() => {
    const next = virtualKeyboardState.nextRegistrationId;
    virtualKeyboardState.nextRegistrationId += 1;
    return next;
  });
  React__default.useEffect(() => {
    if (virtualKeyboardState.count === 0) {
      const keyboardDomNode = document.createElement("footer");
      keyboardDomNode.id = "virtual-keyboard-dummy";
      document.body.appendChild(keyboardDomNode);
      virtualKeyboardState.keyboardDomNode = keyboardDomNode;
      const root2 = clientExports.createRoot(keyboardDomNode);
      virtualKeyboardState.keyboardReactRoot = root2;
      virtualKeyboardState.handleFocusChange = () => {
        rerenderTray();
      };
      document.addEventListener(
        "focusin",
        virtualKeyboardState.handleFocusChange
      );
    }
    virtualKeyboardState.count += 1;
    virtualKeyboardState.registrations.push({
      id: id2,
      onClick,
      theme: theme2,
      ownerRef
    });
    rerenderTray();
    return () => {
      virtualKeyboardState.registrations = virtualKeyboardState.registrations.filter(
        (registration) => registration.id !== id2
      );
      if (virtualKeyboardState.lastActiveRegistrationId === id2) {
        const remaining = virtualKeyboardState.registrations;
        virtualKeyboardState.lastActiveRegistrationId = remaining[remaining.length - 1]?.id ?? null;
      }
      virtualKeyboardState.count -= 1;
      if (virtualKeyboardState.count === 0) {
        if (virtualKeyboardState.handleFocusChange) {
          document.removeEventListener(
            "focusin",
            virtualKeyboardState.handleFocusChange
          );
          virtualKeyboardState.handleFocusChange = void 0;
        }
        if (virtualKeyboardState.keyboardReactRoot) {
          const root2 = virtualKeyboardState.keyboardReactRoot;
          setTimeout(() => {
            root2.unmount();
          }, 0);
          virtualKeyboardState.keyboardReactRoot = null;
        }
        if (virtualKeyboardState.keyboardDomNode) {
          document.body.removeChild(
            virtualKeyboardState.keyboardDomNode
          );
          virtualKeyboardState.keyboardDomNode = null;
        }
      } else {
        rerenderTray();
      }
    };
  }, []);
  React__default.useEffect(() => {
    const registration = getRegistrationById(id2);
    if (registration) {
      registration.onClick = onClick;
      registration.theme = theme2;
      registration.ownerRef = ownerRef;
      rerenderTray();
    }
  }, [onClick, ownerRef, theme2]);
  return null;
}
function ExternalAwareVirtualKeyboard({
  externalVirtualKeyboardProvided = false,
  onClick = () => {
  },
  theme: theme2,
  ownerRef
}) {
  React__default.useEffect(() => {
    if (externalVirtualKeyboardProvided) {
      const listener = (event) => {
        if (event.source !== window.parent || event.data?.subject !== "keyboard") {
          return;
        }
        onClick(event.data.keyCommands);
      };
      window.addEventListener("message", listener);
      return () => {
        window.removeEventListener("message", listener);
      };
    }
  }, [externalVirtualKeyboardProvided, onClick]);
  return externalVirtualKeyboardProvided ? null : /* @__PURE__ */ React__default.createElement(
    UniqueKeyboardTray,
    {
      onClick,
      ownerRef,
      theme: theme2
    }
  );
}
var classnames = { exports: {} };
var hasRequiredClassnames;
function requireClassnames() {
  if (hasRequiredClassnames) return classnames.exports;
  hasRequiredClassnames = 1;
  (function(module) {
    (function() {
      var hasOwn = {}.hasOwnProperty;
      function classNames2() {
        var classes = "";
        for (var i2 = 0; i2 < arguments.length; i2++) {
          var arg = arguments[i2];
          if (arg) {
            classes = appendClass(classes, parseValue(arg));
          }
        }
        return classes;
      }
      function parseValue(arg) {
        if (typeof arg === "string" || typeof arg === "number") {
          return arg;
        }
        if (typeof arg !== "object") {
          return "";
        }
        if (Array.isArray(arg)) {
          return classNames2.apply(null, arg);
        }
        if (arg.toString !== Object.prototype.toString && !arg.toString.toString().includes("[native code]")) {
          return arg.toString();
        }
        var classes = "";
        for (var key in arg) {
          if (hasOwn.call(arg, key) && arg[key]) {
            classes = appendClass(classes, key);
          }
        }
        return classes;
      }
      function appendClass(value, newClass) {
        if (!newClass) {
          return value;
        }
        if (value) {
          return value + " " + newClass;
        }
        return value + newClass;
      }
      if (module.exports) {
        classNames2.default = classNames2;
        module.exports = classNames2;
      } else {
        window.classNames = classNames2;
      }
    })();
  })(classnames);
  return classnames.exports;
}
var classnamesExports = requireClassnames();
const classNames = /* @__PURE__ */ getDefaultExportFromCjs$5(classnamesExports);
const FocusableContext$1 = createContext(true);
function flatten2DArray$1(array) {
  const flattened2 = [];
  for (const row of array) flattened2.push(...row);
  return flattened2;
}
function reverseArray$1(array) {
  return array.slice().reverse();
}
function noop$3(..._2) {
}
function hasOwnProperty$4(object2, prop) {
  if (typeof Object.hasOwn === "function") return Object.hasOwn(object2, prop);
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain$2(...fns) {
  return (...args) => {
    for (const fn2 of fns) if (typeof fn2 === "function") fn2(...args);
  };
}
function omit$2(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) if (hasOwnProperty$4(result2, key)) delete result2[key];
  return result2;
}
function pick$2(object2, paths) {
  const result2 = {};
  for (const key of paths) if (hasOwnProperty$4(object2, key)) result2[key] = object2[key];
  return result2;
}
function identity$2(value) {
  return value;
}
function invariant$1(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys$1(obj) {
  return Object.keys(obj);
}
function disabledFromProps$1(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function removeUndefinedValues$1(obj) {
  const result2 = {};
  for (const key in obj) if (obj[key] !== void 0) result2[key] = obj[key];
  return result2;
}
function defaultValue$1(...values2) {
  for (const value of values2) if (value !== void 0) return value;
}
const canUseDOM$1 = checkIsBrowser$1();
function checkIsBrowser$1() {
  return typeof window !== "undefined" && !!window.document?.createElement;
}
function getDocument$1(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getActiveElement$1(node, activeDescendant = false) {
  const { activeElement } = getDocument$1(node);
  if (!activeElement?.nodeName) return null;
  if (isFrame$1(activeElement) && activeElement.contentDocument?.body) return getActiveElement$1(activeElement.contentDocument.body, activeDescendant);
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument$1(activeElement).getElementById(id2);
      if (element2) return element2;
    }
  }
  return activeElement;
}
function contains$3(parent, child) {
  return parent === child || parent.contains(child);
}
function isElement$4(target) {
  return target?.nodeType === 1;
}
function isNode$3(target) {
  return typeof target?.nodeType === "number";
}
function isFrame$1(element2) {
  return element2.tagName === "IFRAME";
}
function isButton$1(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) return buttonInputTypes$1.indexOf(element2.type) !== -1;
  return false;
}
const buttonInputTypes$1 = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible$1(element2) {
  if (typeof element2.checkVisibility === "function") return element2.checkVisibility();
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField$1(element2) {
  try {
    if (element2.tagName === "TEXTAREA") return true;
    if (element2.tagName !== "INPUT") return false;
    return element2.selectionStart !== null;
  } catch (_error) {
    return false;
  }
}
function isTextbox$1(element2) {
  return element2.isContentEditable || isTextField$1(element2);
}
function getTextboxValue$1(element2) {
  if (isTextField$1(element2)) return element2.value;
  if (element2.isContentEditable) {
    const range2 = getDocument$1(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection$1(element2) {
  let start = 0;
  let end = 0;
  if (isTextField$1(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument$1(element2).getSelection();
    if (selection2?.rangeCount && selection2.anchorNode && contains$3(element2, selection2.anchorNode) && selection2.focusNode && contains$3(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return {
    start,
    end
  };
}
function getScrollingElement$1(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  const doc2 = getDocument$1(element2);
  return getScrollingElement$1(element2.parentElement) || doc2.scrollingElement || doc2.body;
}
function sortBasedOnDOMPosition$1(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a2], [indexB, b2]) => {
    const elementA = getElement(a2);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding$1(elementA, elementB)) {
      if (indexA > indexB) isOrderDifferent = true;
      return -1;
    }
    if (indexA < indexB) isOrderDifferent = true;
    return 1;
  });
  if (isOrderDifferent) return pairs2.map(([_2, item]) => item);
  return items;
}
function isElementPreceding$1(a2, b2) {
  return Boolean(b2.compareDocumentPosition(a2) & Node.DOCUMENT_POSITION_PRECEDING);
}
function isApple$1() {
  if (!canUseDOM$1) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari$1() {
  return canUseDOM$1 && isApple$1() && /apple/i.test(navigator.vendor);
}
function isFirefox$1() {
  return canUseDOM$1 && /firefox\//i.test(navigator.userAgent);
}
function isPortalEvent$1(event) {
  const { currentTarget, target } = event;
  if (!currentTarget) return false;
  if (!isNode$3(target)) return true;
  return !contains$3(currentTarget, target);
}
function isSelfTarget$1(event) {
  return event.target === event.currentTarget;
}
function fireBlurEvent$1(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = {
    ...eventInit,
    bubbles: true
  };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent$1(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent$1(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside$1(event, container) {
  const containerElement = event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !isNode$3(relatedTarget) || !contains$3(containerElement, relatedTarget);
}
function queueBeforeEvent$1(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, {
    once: true,
    capture: true
  });
  return () => {
    cancelTimer();
    element2.removeEventListener(type, callSync, true);
  };
}
function addGlobalEventListener$1(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) children.push(addGlobalEventListener$1(type, listener, options2, frame));
  } catch {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch {
    }
    for (const remove2 of children) remove2();
  };
  return removeEventListener2;
}
const selector$1 = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function isFocusable$1(element2) {
  if (!element2.matches(selector$1)) return false;
  if (!isVisible$1(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function hasFocus$1(element2) {
  const activeElement = getActiveElement$1(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function focusIntoView$1(element2, options2) {
  if (!("scrollIntoView" in element2)) element2.focus();
  else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      ...options2
    });
  }
}
function createUndoCallback$1(callback) {
  return async () => {
    const redo2 = await callback?.();
    return createUndoCallback$1(async () => {
      await redo2?.();
      return callback;
    });
  };
}
createUndoManager$1();
function createUndoManager$1({ limit = 100 } = {}) {
  const undoStack = [];
  let redoStack = [];
  let currentGroup = null;
  const canUndo = () => undoStack.length > 0;
  const canRedo = () => redoStack.length > 0;
  const undo2 = async () => {
    if (!canUndo()) return;
    currentGroup = null;
    redoStack.push(await undoStack.pop()?.());
  };
  const redo2 = async () => {
    if (!canRedo()) return;
    currentGroup = null;
    undoStack.push(await redoStack.pop()?.());
  };
  const execute = async (callback, group2) => {
    if (!callback) return;
    const sameGroup = group2 === currentGroup;
    currentGroup = group2 ?? null;
    const nextIndex = sameGroup ? Math.max(0, undoStack.length - 1) : undoStack.length;
    const undoCallback = await callback();
    if (!undoCallback) return;
    redoStack = [];
    const currentUndo = undoStack[nextIndex];
    undoStack[nextIndex] = createUndoCallback$1(async () => {
      await undoCallback?.();
      const currentRedo = await currentUndo?.();
      return async () => {
        await currentRedo?.();
        await callback?.();
      };
    });
    while (undoStack.length > limit) undoStack.shift();
  };
  return {
    canUndo,
    canRedo,
    undo: undo2,
    redo: redo2,
    execute
  };
}
var jsxRuntime$1 = { exports: {} };
var reactJsxRuntime_production$1 = {};
var hasRequiredReactJsxRuntime_production$1;
function requireReactJsxRuntime_production$1() {
  if (hasRequiredReactJsxRuntime_production$1) return reactJsxRuntime_production$1;
  hasRequiredReactJsxRuntime_production$1 = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production$1.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production$1.jsx = jsxProd;
  reactJsxRuntime_production$1.jsxs = jsxProd;
  return reactJsxRuntime_production$1;
}
var reactJsxRuntime_development$1 = {};
var hasRequiredReactJsxRuntime_development$1;
function requireReactJsxRuntime_development$1() {
  if (hasRequiredReactJsxRuntime_development$1) return reactJsxRuntime_development$1;
  hasRequiredReactJsxRuntime_development$1 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React2 = React__default, REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = React2.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React2 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React2.react_stack_bottom_frame.bind(
      React2,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development$1.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development$1.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development$1.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development$1;
}
var hasRequiredJsxRuntime$1;
function requireJsxRuntime$1() {
  if (hasRequiredJsxRuntime$1) return jsxRuntime$1.exports;
  hasRequiredJsxRuntime$1 = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime$1.exports = requireReactJsxRuntime_production$1();
  } else {
    jsxRuntime$1.exports = requireReactJsxRuntime_development$1();
  }
  return jsxRuntime$1.exports;
}
var jsxRuntimeExports$1 = requireJsxRuntime$1();
function setRef$1(ref, value) {
  if (typeof ref === "function") {
    const cleanup = ref(value);
    if (typeof cleanup === "function") return cleanup;
  } else if (ref) ref.current = value;
}
function isValidElementWithRef$1(element2) {
  if (!element2) return false;
  if (!isValidElement(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty$1(element2) {
  if (!isValidElementWithRef$1(element2)) return null;
  return { ...element2.props }.ref || element2.ref;
}
function mergeProps$1(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$4(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      const baseClass = base2[prop];
      const overrideClass = overrides2[prop];
      if (baseClass && overrideClass) props2[prop] = `${baseClass} ${overrideClass}`;
      else props2[prop] = overrideClass || baseClass;
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? {
        ...base2[prop],
        ...overrides2[prop]
      } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (key.startsWith("on")) {
      if (typeof overrideValue !== "function") continue;
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
const _React$1 = { ...React };
const useReactId$1 = _React$1.useId;
const useReactInsertionEffect$1 = _React$1.useInsertionEffect;
const useSafeLayoutEffect$1 = canUseDOM$1 ? useLayoutEffect : useEffect;
function useLiveRef$1(value) {
  const ref = useRef(value);
  useSafeLayoutEffect$1(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent$1(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect$1) useReactInsertionEffect$1(() => {
    ref.current = callback;
  });
  else ref.current = callback;
  return useCallback((...args) => ref.current?.(...args), []);
}
function useTransactionState$1(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect$1(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs$1(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      const refEffects = [];
      for (const ref of refs) {
        if (!ref) continue;
        const cleanup = setRef$1(ref, value);
        refEffects.push({
          ref,
          cleanup: typeof cleanup === "function" ? cleanup : void 0
        });
      }
      if (!refEffects.some((effect) => effect.cleanup)) return;
      return () => {
        for (const { ref, cleanup } of refEffects) if (cleanup) cleanup();
        else setRef$1(ref, null);
      };
    };
  }, refs);
}
function useId$1(defaultId) {
  if (useReactId$1) {
    const reactId = useReactId$1();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect$1(() => {
    if (defaultId || id2) return;
    setId(`id-${Math.random().toString(36).slice(2, 8)}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName$1(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    if (typeof type2 !== "string") return;
    return type2;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined(type));
  useSafeLayoutEffect$1(() => {
    setTagName((refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement)?.tagName.toLowerCase() || stringOrUndefined(type));
  }, [refOrElement, type]);
  return tagName;
}
function useUpdateEffect$1(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) return effect();
    mounted.current = true;
  }, deps);
  useEffect(() => () => {
    mounted.current = false;
  }, []);
}
function useForceUpdate$1() {
  return useReducer(() => [], []);
}
function useBooleanEvent$1(booleanOrCallback) {
  return useEvent$1(typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback);
}
function useWrapElement$1(props2, callback, deps = []) {
  const wrapElement = useCallback((element2) => {
    if (props2.wrapElement) element2 = props2.wrapElement(element2);
    return callback(element2);
  }, [...deps, props2.wrapElement]);
  return {
    ...props2,
    wrapElement
  };
}
function useMetadataProps$1(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, parent, ...value !== void 0 ? [{ [key]: value }] : []);
  }, [
    parent,
    key,
    value
  ]);
  return [parent?.[key], { onLoadedMetadataCapture }];
}
function forwardRef$1(render) {
  const Role3 = React.forwardRef((props2, ref) => render({
    ...props2,
    ref
  }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo$1(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement$1(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs$1(props2.ref, getRefProperty$1(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = {
      ...render.props,
      ref: mergedRef
    };
    element2 = React.cloneElement(render, mergeProps$1(rest2, renderProps));
  } else if (render) element2 = render(rest2);
  else element2 = /* @__PURE__ */ jsxRuntimeExports$1.jsx(Type, { ...rest2 });
  if (wrapElement) return wrapElement(element2);
  return element2;
}
function createHook$1(useProps) {
  const useRole2 = (props2 = {}) => {
    return useProps(props2);
  };
  useRole2.displayName = useProps.name;
  return useRole2;
}
function createStoreContext$1(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(Provider2, {
      ...props2,
      children
    }), /* @__PURE__ */ jsxRuntimeExports$1.jsx(context.Provider, { ...props2 }));
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$1.jsx(ContextProvider, {
      ...props2,
      children: scopedProviders.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(Provider2, {
        ...props2,
        children
      }), /* @__PURE__ */ jsxRuntimeExports$1.jsx(scopedContext.Provider, { ...props2 }))
    });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
const TagName$8$1 = "div";
const accessibleWhenDisabledSymbol$1 = /* @__PURE__ */ Symbol("accessibleWhenDisabled");
const isSafariBrowser$2 = isSafari$1();
const alwaysFocusVisibleInputTypes$1 = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function isAlwaysFocusVisible$1(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) return alwaysFocusVisibleInputTypes$1.includes(type);
  if (element2.isContentEditable) return true;
  if (element2.getAttribute("role") === "combobox" && element2.dataset.name) return true;
  return false;
}
function isNativeTabbable$1(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute$1(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function isNativeSubmitControl$1(element2) {
  if (element2.tagName === "BUTTON") {
    const { type } = element2;
    return type === "submit";
  }
  if (element2.tagName === "INPUT") {
    const { type } = element2;
    return type === "submit" || type === "image";
  }
  return false;
}
function getTabIndex$1({ focusable, trulyDisabled, nativeTabbable, supportsDisabled, safariTabIndex, tabIndexProp }) {
  if (!focusable) return tabIndexProp;
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) return -1;
    return;
  }
  if (nativeTabbable) {
    if (safariTabIndex && tabIndexProp == null) return 0;
    return tabIndexProp;
  }
  return tabIndexProp ?? 0;
}
function useDisableEvent$1(onEvent, disabled) {
  return useEvent$1((event) => {
    onEvent?.(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
let hasInstalledGlobalEventListeners$2 = false;
let isKeyboardModality$1 = true;
function onGlobalMouseDown$1(event) {
  const target = event.target;
  if (isElement$4(target) && !target.hasAttribute("data-focus-visible")) isKeyboardModality$1 = false;
}
function onGlobalKeyDown$1(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality$1 = true;
}
const useFocusable$1 = createHook$1(function useFocusable22({ focusable = true, accessibleWhenDisabled, autoFocus, onFocusVisible, ...props2 }) {
  const ref = useRef(null);
  const [parentAccessibleWhenDisabled, metadataProps] = useMetadataProps$1(props2, accessibleWhenDisabledSymbol$1, accessibleWhenDisabled);
  accessibleWhenDisabled ??= parentAccessibleWhenDisabled;
  useEffect(() => {
    if (!focusable) return;
    if (hasInstalledGlobalEventListeners$2) return;
    addGlobalEventListener$1("mousedown", onGlobalMouseDown$1, true);
    addGlobalEventListener$1("keydown", onGlobalKeyDown$1, true);
    hasInstalledGlobalEventListeners$2 = true;
  }, [focusable]);
  const disabled = focusable && disabledFromProps$1(props2);
  const trulyDisabled = disabled && !accessibleWhenDisabled;
  const [focusVisible, setFocusVisible] = useState(false);
  const focusVisibleRef = useRef(false);
  const nativeSubmitObserverCleanupRef = useRef(null);
  const cleanupFocusVisible = useEvent$1((element2) => {
    nativeSubmitObserverCleanupRef.current?.();
    nativeSubmitObserverCleanupRef.current = null;
    focusVisibleRef.current = false;
    element2?.removeAttribute("data-focus-visible");
  });
  useEffect(() => {
    if (!focusable) return;
    if (!trulyDisabled) return;
    cleanupFocusVisible(ref.current);
    if (focusVisible) setFocusVisible(false);
  }, [
    focusable,
    trulyDisabled,
    focusVisible,
    cleanupFocusVisible
  ]);
  useEffect(() => {
    if (!focusable) return;
    if (!focusVisible) return;
    const element2 = ref.current;
    if (!element2) return;
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(() => {
      if (!isFocusable$1(element2)) {
        focusVisibleRef.current = false;
        setFocusVisible(false);
      }
    });
    observer.observe(element2);
    return () => observer.disconnect();
  }, [focusable, focusVisible]);
  useEffect(() => {
    return () => nativeSubmitObserverCleanupRef.current?.();
  }, []);
  const onKeyPressCapture = useDisableEvent$1(props2.onKeyPressCapture, disabled);
  const onMouseDownCapture = useDisableEvent$1(props2.onMouseDownCapture, disabled);
  const onClickCapture = useDisableEvent$1(props2.onClickCapture, disabled);
  const handleFocusVisible = (event, currentTarget) => {
    if (currentTarget) event.currentTarget = currentTarget;
    if (!focusable) return;
    const element2 = event.currentTarget;
    if (!element2) return;
    if (!hasFocus$1(element2)) return;
    onFocusVisible?.(event);
    if (event.defaultPrevented) return;
    element2.dataset.focusVisible = "true";
    focusVisibleRef.current = true;
    if (isNativeSubmitControl$1(element2)) {
      nativeSubmitObserverCleanupRef.current?.();
      nativeSubmitObserverCleanupRef.current = null;
      if (typeof IntersectionObserver !== "undefined") {
        const observer = new IntersectionObserver(() => {
          if (isFocusable$1(element2)) return;
          cleanupFocusVisible(element2);
        });
        observer.observe(element2);
        nativeSubmitObserverCleanupRef.current = () => observer.disconnect();
      }
      return;
    }
    setFocusVisible(true);
  };
  const onKeyDownCaptureProp = props2.onKeyDownCapture;
  const onKeyDownCapture = useEvent$1((event) => {
    onKeyDownCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (focusVisible) return;
    if (focusVisibleRef.current) return;
    if (event.metaKey) return;
    if (event.altKey) return;
    if (event.ctrlKey) return;
    if (!isSelfTarget$1(event)) return;
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    queueBeforeEvent$1(element2, "focusout", applyFocusVisible);
  });
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent$1((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (!isSelfTarget$1(event)) {
      setFocusVisible(false);
      return;
    }
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    if (isKeyboardModality$1 || isAlwaysFocusVisible$1(event.target)) queueBeforeEvent$1(event.target, "focusout", applyFocusVisible);
    else setFocusVisible(false);
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent$1((event) => {
    onBlurProp?.(event);
    if (!focusable) return;
    if (!isFocusEventOutside$1(event)) return;
    cleanupFocusVisible(event.currentTarget);
    setFocusVisible(false);
  });
  const autoFocusOnShow = useContext(FocusableContext$1);
  const autoFocusRef = useEvent$1((element2) => {
    if (!focusable) return;
    if (!autoFocus) return;
    if (!element2) return;
    if (!autoFocusOnShow) return;
    queueMicrotask(() => {
      if (hasFocus$1(element2)) return;
      if (!isFocusable$1(element2)) return;
      element2.focus();
    });
  });
  const tagName = useTagName$1(ref);
  const nativeTabbable = focusable && isNativeTabbable$1(tagName);
  const supportsDisabled = focusable && supportsDisabledAttribute$1(tagName);
  const [safariTabIndex, setSafariTabIndex] = useState(false);
  if (isSafariBrowser$2) useEffect(() => {
    if (!focusable) return;
    const element2 = ref.current;
    if (!element2) return;
    const { type } = element2;
    const isNativeCheckboxOrRadio = element2.tagName === "INPUT" && (type === "checkbox" || type === "radio");
    setSafariTabIndex(isButton$1(element2) || isNativeCheckboxOrRadio);
  }, [focusable]);
  const styleProp = props2.style;
  const style = useMemo(() => {
    if (trulyDisabled) return {
      pointerEvents: "none",
      ...styleProp
    };
    return styleProp;
  }, [trulyDisabled, styleProp]);
  props2 = {
    "data-focus-visible": focusable && focusVisible || void 0,
    "data-autofocus": autoFocus || void 0,
    "aria-disabled": disabled || void 0,
    ...props2,
    ...metadataProps,
    ref: useMergeRefs$1(ref, autoFocusRef, props2.ref),
    style,
    tabIndex: getTabIndex$1({
      focusable,
      trulyDisabled,
      nativeTabbable,
      supportsDisabled,
      safariTabIndex,
      tabIndexProp: props2.tabIndex
    }),
    disabled: supportsDisabled && trulyDisabled ? true : void 0,
    contentEditable: disabled ? void 0 : props2.contentEditable,
    onKeyPressCapture,
    onClickCapture,
    onMouseDownCapture,
    onKeyDownCapture,
    onFocusCapture,
    onBlur
  };
  return removeUndefinedValues$1(props2);
});
forwardRef$1(function Focusable2(props2) {
  return createElement$1(TagName$8$1, useFocusable$1(props2));
});
const TagName$7$1 = "button";
function isNativeClick$1(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") return isButton$1(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  if (event.key === " ") return isButton$1(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  return false;
}
const symbol$3 = /* @__PURE__ */ Symbol("command");
const useCommand$1 = createHook$1(function useCommand22({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
  const ref = useRef(null);
  const [isNativeButton, setIsNativeButton] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    setIsNativeButton(isButton$1(ref.current));
  }, []);
  const [active, setActive] = useState(false);
  const activeRef = useRef(false);
  const disabled = disabledFromProps$1(props2);
  const [isDuplicate, metadataProps] = useMetadataProps$1(props2, symbol$3, true);
  useSafeLayoutEffect$1(() => {
    if (!disabled) return;
    activeRef.current = false;
    setActive(false);
  }, [disabled]);
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent$1((event) => {
    onKeyDownProp?.(event);
    const element2 = event.currentTarget;
    if (event.defaultPrevented) return;
    if (isDuplicate) return;
    if (disabled) return;
    if (!isSelfTarget$1(event)) return;
    if (isTextField$1(element2)) return;
    if (element2.isContentEditable) return;
    const isEnter = clickOnEnter && event.key === "Enter";
    const isSpace2 = clickOnSpace && event.key === " ";
    const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
    const shouldPreventSpace = event.key === " " && !clickOnSpace;
    if (shouldPreventEnter || shouldPreventSpace) {
      event.preventDefault();
      return;
    }
    if (isEnter || isSpace2) {
      const nativeClick = isNativeClick$1(event);
      if (isEnter) {
        if (!nativeClick) {
          event.preventDefault();
          const { view, ...eventInit } = event;
          const click = () => fireClickEvent$1(element2, eventInit);
          if (isFirefox$1()) queueBeforeEvent$1(element2, "keyup", click);
          else queueMicrotask(click);
        }
      } else if (isSpace2) {
        activeRef.current = true;
        if (!nativeClick) {
          event.preventDefault();
          setActive(true);
        }
      }
    }
  });
  const onKeyUpProp = props2.onKeyUp;
  const onKeyUp = useEvent$1((event) => {
    onKeyUpProp?.(event);
    if (isDuplicate) return;
    const isSpace2 = clickOnSpace && event.key === " ";
    if (!activeRef.current || !isSpace2) return;
    const nativeClick = isNativeClick$1(event);
    activeRef.current = false;
    if (!nativeClick) setActive(false);
    if (event.defaultPrevented) return;
    if (!isSelfTarget$1(event)) return;
    if (disabled) return;
    if (event.metaKey) return;
    if (nativeClick) return;
    event.preventDefault();
    const element2 = event.currentTarget;
    const { view, ...eventInit } = event;
    queueMicrotask(() => fireClickEvent$1(element2, eventInit));
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent$1((event) => {
    onBlurProp?.(event);
    if (!activeRef.current) return;
    activeRef.current = false;
    setActive(false);
  });
  props2 = {
    "data-active": active || void 0,
    type: isNativeButton ? "button" : void 0,
    ...metadataProps,
    ...props2,
    ref: useMergeRefs$1(ref, props2.ref),
    onKeyDown,
    onKeyUp,
    onBlur
  };
  props2 = useFocusable$1(props2);
  return props2;
});
forwardRef$1(function Command3(props2) {
  return createElement$1(TagName$7$1, useCommand$1(props2));
});
const ctx$3$1 = createStoreContext$1();
const useCollectionContext$1 = ctx$3$1.useContext;
const CollectionContextProvider$1 = ctx$3$1.ContextProvider;
const CollectionScopedContextProvider$1 = ctx$3$1.ScopedContextProvider;
const TagName$6$1 = "div";
const useCollectionItem$1 = createHook$1(function useCollectionItem22({ store: store2, shouldRegisterItem = true, getItem = identity$2, element: element2, ...props2 }) {
  const context = useCollectionContext$1();
  store2 = store2 || context;
  const id2 = useId$1(props2.id);
  const ref = useRef(element2);
  useEffect(() => {
    const element22 = ref.current;
    if (!id2) return;
    if (!element22) return;
    if (!shouldRegisterItem) return;
    const item = getItem({
      id: id2,
      element: element22
    });
    return store2?.renderItem(item);
  }, [
    id2,
    shouldRegisterItem,
    getItem,
    store2
  ]);
  props2 = {
    ...props2,
    ref: useMergeRefs$1(ref, props2.ref)
  };
  return removeUndefinedValues$1(props2);
});
forwardRef$1(function CollectionItem2(props2) {
  return createElement$1(TagName$6$1, useCollectionItem$1(props2));
});
const ctx$2$1 = createStoreContext$1([CollectionContextProvider$1], [CollectionScopedContextProvider$1]);
const useCompositeScopedContext$1 = ctx$2$1.useScopedContext;
const useCompositeProviderContext$1 = ctx$2$1.useProviderContext;
const CompositeContextProvider$1 = ctx$2$1.ContextProvider;
const CompositeScopedContextProvider$1 = ctx$2$1.ScopedContextProvider;
const CompositeItemContext$1 = createContext(void 0);
const CompositeRowContext$1 = createContext(void 0);
function getInternal$1(store2, key) {
  const internals = store2.__unstableInternals;
  invariant$1(internals, "Invalid store");
  return internals[key];
}
function hasUpdatedKey$1(keys2, updatedKey) {
  if (!keys2) return true;
  for (const currentKey of keys2) if (updatedKey instanceof Set) {
    if (updatedKey.has(currentKey)) return true;
  } else if (currentKey === updatedKey) return true;
  return false;
}
function isSameValue$1(value, other) {
  return value === other || value !== value && other !== other;
}
function getCleanupPrevState$1(prevState, state, stateBeforeCleanup, updatedKey) {
  let cleanupPrevState;
  for (const key of getKeys$1(state)) {
    if (isSameValue$1(state[key], stateBeforeCleanup[key])) continue;
    if (updatedKey !== void 0 && hasUpdatedKey$1([key], updatedKey)) continue;
    cleanupPrevState ??= { ...prevState };
    cleanupPrevState[key] = state[key];
  }
  return cleanupPrevState;
}
const MAX_REPAIR_PASSES$1 = 100;
function addKeyedListener$1(map2, keys2, listener) {
  if (!keys2) return;
  for (const key of keys2) {
    let listeners = map2.get(key);
    if (!listeners) {
      listeners = /* @__PURE__ */ new Set();
      map2.set(key, listeners);
    }
    listeners.add(listener);
  }
}
function deleteKeyedListener$1(map2, keys2, listener) {
  if (!map2) return;
  if (!keys2) return;
  for (const key of keys2) {
    const listeners = map2.get(key);
    if (!listeners) continue;
    listeners.delete(listener);
    if (!listeners.size) map2.delete(key);
  }
}
function getFastPathNotifiedListeners$1(frame) {
  const notifiedListeners = /* @__PURE__ */ new Set();
  const currentListener = frame.currentListener;
  if (!currentListener) return notifiedListeners;
  for (const listener of frame.keyedListeners) {
    notifiedListeners.add(listener);
    if (listener === currentListener) return notifiedListeners;
  }
  notifiedListeners.clear();
  notifiedListeners.add(currentListener);
  return notifiedListeners;
}
function preserveFastPathNotifiedListeners$1(frame) {
  frame.notifiedListeners ??= getFastPathNotifiedListeners$1(frame);
}
function hasFastPathPassedListener$1(frame, listener) {
  if (!frame.currentListener) return false;
  let foundCurrentKeyedListener = false;
  for (const currentListener of frame.keyedListeners) {
    if (currentListener === frame.currentListener) {
      foundCurrentKeyedListener = true;
      continue;
    }
    if (!foundCurrentKeyedListener) continue;
    if (currentListener === listener) return false;
  }
  let foundListener = false;
  for (const currentListener of frame.group.listeners) {
    if (currentListener === frame.currentListener) return foundListener;
    if (currentListener === listener) foundListener = true;
  }
  return false;
}
function preserveFastPathFrames$1(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (listener && !frame.keyedListeners.has(listener)) continue;
    preserveFastPathNotifiedListeners$1(frame);
    for (const currentListener of frame.group.listeners) {
      if (currentListener === frame.currentListener) break;
      if (!hasFastPathPassedListener$1(frame, currentListener)) continue;
      frame.notifiedListeners?.add(currentListener);
    }
  }
}
function preserveFastPathPassedListeners$1(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!hasFastPathPassedListener$1(frame, listener)) continue;
    preserveFastPathNotifiedListeners$1(frame);
    frame.notifiedListeners?.add(listener);
  }
}
function preserveFastPathPassedKeyedListeners$1({ fastPathFrames, group: group2, keys: keys2, listener }) {
  const wasRegistered = group2.listeners.has(listener);
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    if (hasFastPathPassedListener$1(frame, listener)) {
      preserveFastPathNotifiedListeners$1(frame);
      frame.notifiedListeners?.add(listener);
    } else if (wasRegistered) {
      preserveFastPathNotifiedListeners$1(frame);
      frame.recoverToLive = true;
    }
  }
}
function clearFastPathNotifiedListener$1(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    frame.notifiedListeners?.delete(listener);
  }
}
function addFastPathKeyedListener$1({ fastPathFrames, group: group2, keys: keys2, listener }) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    frame.keyedListeners.add(listener);
  }
}
function runPendingCleanup$1(group2, listener) {
  if (!group2.disposables.size) return;
  const cleanup = group2.disposables.get(listener);
  if (!cleanup) return;
  group2.disposables.delete(listener);
  cleanup();
}
function setListenerCleanup$1(group2, listener, cleanup) {
  const currentCleanup = group2.disposables.get(listener);
  if (!currentCleanup) {
    group2.disposables.set(listener, cleanup);
    return;
  }
  group2.disposables.set(listener, () => {
    currentCleanup();
    cleanup();
  });
}
function notifyStoreListener$1(group2, listener, state, prevState, getState, updatedKey) {
  if (group2.suspendCounts?.has(listener)) return;
  const { disposables } = group2;
  const cleanup = disposables.size ? disposables.get(listener) : void 0;
  if (cleanup) {
    disposables.delete(listener);
    const stateBeforeCleanup = state;
    cleanup();
    state = getState?.() ?? state;
    if (state !== stateBeforeCleanup) prevState = getCleanupPrevState$1(prevState, state, stateBeforeCleanup, updatedKey) ?? prevState;
  }
  const result2 = listener(state, prevState);
  if (result2) setListenerCleanup$1(group2, listener, result2);
}
function runLiveListeners$1({ group: group2, getState, prevState, updatedKey, notifiedListeners }) {
  const allKeysListeners = group2.allKeysListeners;
  for (const listener of group2.listeners) {
    if (notifiedListeners?.has(listener)) continue;
    if (!allKeysListeners?.has(listener)) {
      if (!hasUpdatedKey$1(group2.listenerKeys.get(listener), updatedKey)) continue;
    }
    notifiedListeners?.add(listener);
    notifyStoreListener$1(group2, listener, getState(), prevState, getState, updatedKey);
  }
}
function createStore$1(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let destroy = noop$3;
  let batchPending = false;
  let inDispatch = false;
  let updatedKeys = /* @__PURE__ */ new Set();
  const instances = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const syncListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const batchListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initializedInstances = instances.size;
    const instance = /* @__PURE__ */ Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      if (!instances.delete(instance)) return;
      if (instances.size) return;
      destroy();
    };
    if (initializedInstances) return maybeDestroy;
    const stateKeys = getKeys$1(state);
    const desyncs = [];
    for (const store2 of stores) {
      const storeState = store2?.getState?.();
      if (!storeState) continue;
      const keys2 = stateKeys.filter((key) => hasOwnProperty$4(storeState, key));
      if (!keys2.length) continue;
      if (stores.length === 1 || keys2.length === stateKeys.length) {
        for (const key of keys2) desyncs.push(sync$1(store2, [key], (state2) => {
          setState(key, state2[key], true);
        }));
        continue;
      }
      desyncs.push(subscribe$1(store2, keys2, (state2, prevState) => {
        for (const key of keys2) {
          if (state2[key] === prevState[key]) continue;
          setState(key, state2[key], true);
        }
      }));
      for (const key of keys2) {
        const liveState = store2?.getState?.();
        if (!liveState) continue;
        setState(key, liveState[key], true);
      }
    }
    const teardowns = [];
    for (const setup2 of setups) teardowns.push(setup2());
    const cleanups2 = stores.map(init$1);
    destroy = chain$2(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const deleteListenerIndexes = (group2, listener, keys2) => {
    if (keys2 === void 0) return;
    if (keys2) deleteKeyedListener$1(group2.listenersByKey, keys2, listener);
    else group2.allKeysListeners?.delete(listener);
  };
  const fastPathFrames = [];
  const registerListener = (keys2, listener, group2 = syncListenerGroup) => {
    const listenerKeysValue = keys2 ? [...keys2] : null;
    const wasRegistered = group2.listeners.has(listener);
    if (!wasRegistered) clearFastPathNotifiedListener$1(fastPathFrames, group2, listener);
    if (!listenerKeysValue) {
      if (wasRegistered) preserveFastPathFrames$1(fastPathFrames, group2);
      preserveFastPathPassedListeners$1(fastPathFrames, group2, listener);
    } else preserveFastPathPassedKeyedListeners$1({
      fastPathFrames,
      group: group2,
      keys: listenerKeysValue,
      listener
    });
    if (wasRegistered) {
      preserveFastPathFrames$1(fastPathFrames, group2, listener);
      deleteListenerIndexes(group2, listener, group2.listenerKeys.get(listener));
    }
    group2.listeners.add(listener);
    if (listenerKeysValue) {
      group2.listenersByKey ??= /* @__PURE__ */ new Map();
      addKeyedListener$1(group2.listenersByKey, listenerKeysValue, listener);
      addFastPathKeyedListener$1({
        fastPathFrames,
        group: group2,
        keys: listenerKeysValue,
        listener
      });
    } else {
      group2.allKeysListeners ??= /* @__PURE__ */ new Set();
      group2.allKeysListeners.add(listener);
    }
    group2.listenerKeys.set(listener, listenerKeysValue);
    return () => {
      const cleanup = group2.disposables.get(listener);
      group2.disposables.delete(listener);
      preserveFastPathFrames$1(fastPathFrames, group2, listener);
      const currentKeys = group2.listenerKeys.get(listener);
      deleteListenerIndexes(group2, listener, listenerKeysValue);
      if (currentKeys !== listenerKeysValue) deleteListenerIndexes(group2, listener, currentKeys);
      group2.listenerKeys.delete(listener);
      group2.listeners.delete(listener);
      cleanup?.();
    };
  };
  const storeSubscribe = (keys2, listener) => registerListener(keys2, listener);
  const runInitialListener = (group2, listener, prevState) => {
    const shouldSuspend = group2.listeners.has(listener);
    if (shouldSuspend) {
      group2.suspendCounts ??= /* @__PURE__ */ new Map();
      const count = group2.suspendCounts.get(listener) ?? 0;
      group2.suspendCounts.set(listener, count + 1);
    }
    let cleanupPrevState;
    try {
      const stateBeforeCleanups = state;
      runPendingCleanup$1(group2, listener);
      if (state !== stateBeforeCleanups) cleanupPrevState = getCleanupPrevState$1(prevState, state, stateBeforeCleanups);
      const cleanup = listener(state, cleanupPrevState ?? prevState);
      if (cleanup) setListenerCleanup$1(group2, listener, cleanup);
    } finally {
      if (shouldSuspend) {
        const suspendCounts = group2.suspendCounts;
        const count = suspendCounts?.get(listener);
        if (count && count > 1) suspendCounts?.set(listener, count - 1);
        else suspendCounts?.delete(listener);
        if (!suspendCounts?.size) delete group2.suspendCounts;
      }
    }
  };
  const storeSync = (keys2, listener) => {
    runInitialListener(syncListenerGroup, listener, state);
    return registerListener(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    if (!batchListenerGroup.listeners.size && !inDispatch) prevStateBatch = state;
    runInitialListener(batchListenerGroup, listener, prevStateBatch);
    return registerListener(keys2, listener, batchListenerGroup);
  };
  const storePick = (keys2) => createStore$1(pick$2(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore$1(omit$2(state, keys2), finalStore);
  const getState = () => state;
  const runListeners = (group2, prevState, updatedKey) => {
    if (!(updatedKey instanceof Set) && !group2.allKeysListeners?.size) {
      const keyedListeners = group2.listenersByKey?.get(updatedKey);
      if (!keyedListeners) return;
      const frame = {
        group: group2,
        keyedListeners,
        updatedKey,
        currentListener: null
      };
      fastPathFrames.push(frame);
      try {
        for (const listener of keyedListeners) {
          if (frame.notifiedListeners?.has(listener)) continue;
          frame.currentListener = listener;
          frame.notifiedListeners?.add(listener);
          notifyStoreListener$1(group2, listener, state, prevState, getState, updatedKey);
          if (!group2.allKeysListeners?.size && !frame.recoverToLive) continue;
          const notifiedListeners = frame.notifiedListeners ?? getFastPathNotifiedListeners$1(frame);
          frame.notifiedListeners = notifiedListeners;
          frame.recovering = true;
          runLiveListeners$1({
            group: group2,
            getState,
            prevState,
            updatedKey,
            notifiedListeners
          });
          return;
        }
      } finally {
        fastPathFrames.pop();
      }
      return;
    }
    runLiveListeners$1({
      group: group2,
      getState,
      prevState,
      updatedKey
    });
  };
  const setState = (key, value, fromStores = false) => {
    if (!hasOwnProperty$4(state, key)) return;
    const currentValue = state[key];
    const nextValue = typeof value === "function" ? value(currentValue) : value;
    if (isSameValue$1(nextValue, currentValue)) return;
    const wasInDispatch = inDispatch;
    inDispatch = true;
    const prevState = state;
    const nextState = {
      ...state,
      [key]: nextValue
    };
    state = nextState;
    let superseded = false;
    try {
      if (!fromStores && stores.length) {
        for (const store2 of stores) {
          store2?.setState?.(key, nextValue);
          if (isSameValue$1(state[key], nextValue)) continue;
          superseded = true;
          break;
        }
        if (superseded) {
          let pass = 0;
          for (; pass < MAX_REPAIR_PASSES$1; pass += 1) {
            let changed = false;
            for (const store2 of stores) {
              const previousValue = state[key];
              store2?.setState?.(key, previousValue);
              if (!isSameValue$1(state[key], previousValue)) changed = true;
            }
            if (!changed) break;
          }
          if (process.env.NODE_ENV !== "production" && pass === MAX_REPAIR_PASSES$1) console.warn("Parent stores did not converge after a superseded fan-out; a parent listener may be rewriting this key in a cycle.");
        }
      }
      if (!superseded) runListeners(syncListenerGroup, state === nextState ? prevState : {
        ...state,
        [key]: prevState[key]
      }, key);
    } finally {
      inDispatch = wasInDispatch;
    }
    if (!batchListenerGroup.listeners.size) {
      if (!inDispatch) prevStateBatch = state;
      return;
    }
    updatedKeys.add(key);
    if (batchPending) return;
    batchPending = true;
    queueMicrotask(() => {
      batchPending = false;
      const snapshot = state;
      const updatedKeysSnapshot = updatedKeys;
      updatedKeys = /* @__PURE__ */ new Set();
      const prevStateBatchBefore = prevStateBatch;
      runListeners(batchListenerGroup, prevStateBatchBefore, updatedKeysSnapshot);
      if (prevStateBatch === prevStateBatchBefore) prevStateBatch = snapshot;
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "setup")(...args);
}
function init$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "init")(...args);
}
function subscribe$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "subscribe")(...args);
}
function sync$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "sync")(...args);
}
function batch$1(store2, ...args) {
  if (!store2) return;
  return getInternal$1(store2, "batch")(...args);
}
function throwOnConflictingProps$1(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    const stateKey = key.replace("default", "");
    return `${stateKey[0]?.toLowerCase() || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  if (!defaultKeys.filter((key) => hasOwnProperty$4(storeState, key)).length) return;
  throw new Error(`Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`);
}
function getCommonParent$1(items) {
  const firstItem = items.find((item) => !!item.element);
  const lastElement = [...items].reverse().find((item) => !!item.element)?.element;
  let parentElement = firstItem?.element?.parentElement;
  if (!lastElement) return getDocument$1(parentElement).body;
  while (parentElement) {
    if (parentElement.contains(lastElement)) return parentElement;
    parentElement = parentElement.parentElement;
  }
  return getDocument$1(parentElement).body;
}
function getPrivateStore$1(store2) {
  return store2?.__unstablePrivateStore;
}
function createCollectionStore$1(props2 = {}) {
  throwOnConflictingProps$1(props2, props2.store);
  const syncState = props2.store?.getState();
  const items = defaultValue$1(props2.items, syncState?.items, props2.defaultItems, []);
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue$1(syncState?.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore$1(props2.store);
  const privateStore = createStore$1({
    items,
    renderedItems: initialState2.renderedItems
  }, syncPrivateStore);
  const collection = createStore$1(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition$1(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup$1(collection, () => init$1(privateStore));
  setup$1(privateStore, () => {
    return batch$1(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup$1(privateStore, () => {
    return batch$1(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") return () => cancelAnimationFrame(raf);
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent$1(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = {
          ...prevItem,
          ...item
        };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) itemsMap.delete(item.id);
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(item, (getItems) => privateStore.setState("items", getItems), true);
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain$2(registerItem(item), mergeItem(item, (getItems) => privateStore.setState("renderedItems", getItems))),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) itemsMap.set(id2, item);
      }
      return item || null;
    },
    __unstablePrivateStore: privateStore
  };
}
const NULL_ITEM$1 = { id: null };
function findFirstEnabledItem$1$1(items, excludeId) {
  return items.find((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getEnabledItems$2(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getItemsInRow$1(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function findEnabledItemId$1({ items, fromIndex, step, rowId, excludeId }) {
  for (let i2 = fromIndex; i2 >= 0 && i2 < items.length; i2 += step) {
    const item = items[i2];
    if (!item) continue;
    if (item.rowId !== rowId) continue;
    if (item.disabled) continue;
    if (excludeId != null && item.id === excludeId) continue;
    return item.id;
  }
}
function flipItems$2(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM$1] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows$1$1(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => currentRow[0]?.rowId === item.rowId);
    if (row) row.push(item);
    else rows.push([item]);
  }
  return rows;
}
function getMaxRowLength$1(array) {
  let maxLength = 0;
  for (const { length } of array) if (length > maxLength) maxLength = length;
  return maxLength;
}
function createEmptyItem$1(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows$1(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength$1(rows);
  for (const row of rows) for (let i2 = 0; i2 < maxLength; i2 += 1) {
    const item = row[i2];
    if (!item || focusShift && item.disabled) {
      const previousItem = i2 === 0 && focusShift ? findFirstEnabledItem$1$1(row) : row[i2 - 1];
      row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem$1(previousItem?.rowId);
    }
  }
  return rows;
}
function verticalizeItems$1(items) {
  const rows = groupItemsByRows$1$1(items);
  const maxLength = getMaxRowLength$1(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) for (const row of rows) {
    const item = row[i2];
    if (item) verticalized.push({
      ...item,
      rowId: item.rowId ? `${i2}` : void 0
    });
  }
  return verticalized;
}
function createCompositeStore$1(props2 = {}) {
  const syncState = props2.store?.getState();
  const collection = createCollectionStore$1(props2);
  const activeId = defaultValue$1(props2.activeId, syncState?.activeId, props2.defaultActiveId);
  const composite = createStore$1({
    ...collection.getState(),
    id: defaultValue$1(props2.id, syncState?.id) ?? `id-${Math.random().toString(36).slice(2, 8)}`,
    activeId,
    baseElement: defaultValue$1(syncState?.baseElement, null),
    includesBaseElement: defaultValue$1(props2.includesBaseElement, syncState?.includesBaseElement, activeId === null),
    moves: defaultValue$1(syncState?.moves, 0),
    orientation: defaultValue$1(props2.orientation, syncState?.orientation, "both"),
    rtl: defaultValue$1(props2.rtl, syncState?.rtl, false),
    virtualFocus: defaultValue$1(props2.virtualFocus, syncState?.virtualFocus, false),
    focusLoop: defaultValue$1(props2.focusLoop, syncState?.focusLoop, false),
    focusWrap: defaultValue$1(props2.focusWrap, syncState?.focusWrap, false),
    focusShift: defaultValue$1(props2.focusShift, syncState?.focusShift, false)
  }, collection, props2.store);
  setup$1(composite, () => sync$1(composite, ["renderedItems", "activeId"], (state) => {
    composite.setState("activeId", (activeId2) => {
      if (activeId2 !== void 0) return activeId2;
      return findFirstEnabledItem$1$1(state.renderedItems)?.id;
    });
  }));
  const getNextId = (direction = "next", options2 = {}) => {
    const defaultState = composite.getState();
    const { skip = 0, activeId: activeId2 = defaultState.activeId, focusShift = defaultState.focusShift, focusLoop = defaultState.focusLoop, focusWrap = defaultState.focusWrap, includesBaseElement = defaultState.includesBaseElement, renderedItems = defaultState.renderedItems, rtl = defaultState.rtl } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    if (!skip && !focusWrap && !includesBaseElement && activeId2 != null) {
      if (!isVerticalDirection ? true : !canShift && !renderedItems.some((item) => item.rowId != null)) {
        const activeIndex2 = renderedItems.findIndex((item) => item.id === activeId2);
        const activeItem2 = renderedItems[activeIndex2];
        if (activeItem2) {
          const step = canReverse ? -1 : 1;
          const nextId = findEnabledItemId$1({
            items: renderedItems,
            fromIndex: activeIndex2 + step,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
          if (nextId !== void 0) return nextId;
          if (!(focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical"))) return void 0;
          return findEnabledItemId$1({
            items: renderedItems,
            fromIndex: step === 1 ? 0 : renderedItems.length - 1,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
        }
      }
    }
    let items = !isVerticalDirection ? renderedItems : flatten2DArray$1(normalizeRows$1(groupItemsByRows$1$1(renderedItems), activeId2, canShift));
    items = canReverse ? reverseArray$1(items) : items;
    items = isVerticalDirection ? verticalizeItems$1(items) : items;
    if (activeId2 == null) return findFirstEnabledItem$1$1(items)?.id;
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) return findFirstEnabledItem$1$1(items)?.id;
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow$1(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$2(nextItemsInRow, activeId2);
      return (nextEnabledItemsInRow.slice(skip)[0] || nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1])?.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) return findFirstEnabledItem$1$1(flipItems$2(canWrap && !hasNullItem ? items : getItemsInRow$1(items, activeItem.rowId), activeId2, hasNullItem), activeId2)?.id;
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem$1$1(hasNullItem ? nextItemsInRow : nextItems, activeId2);
      return hasNullItem ? nextItem2?.id || null : nextItem2?.id;
    }
    const nextItem = findFirstEnabledItem$1$1(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) return null;
    return nextItem?.id;
  };
  const getNextIdFromOptions = (direction, options2) => {
    if (typeof options2 === "number") return getNextId(direction, { skip: options2 });
    return getNextId(direction, options2);
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => findFirstEnabledItem$1$1(composite.getState().renderedItems)?.id,
    last: () => findFirstEnabledItem$1$1(reverseArray$1(composite.getState().renderedItems))?.id,
    next: (options2) => getNextIdFromOptions("next", options2),
    previous: (options2) => getNextIdFromOptions("previous", options2),
    down: (options2) => getNextIdFromOptions("down", options2),
    up: (options2) => getNextIdFromOptions("up", options2)
  };
}
const findFirstEnabledItem$2 = findFirstEnabledItem$1$1;
const groupItemsByRows$2 = groupItemsByRows$1$1;
function getEnabledItem$1(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function selectTextField$1(element2, collapseToEnd = false) {
  if (isTextField$1(element2)) element2.setSelectionRange(collapseToEnd ? element2.value.length : 0, element2.value.length);
  else if (element2.isContentEditable) {
    const selection2 = getDocument$1(element2).getSelection();
    selection2?.selectAllChildren(element2);
    if (collapseToEnd) selection2?.collapseToEnd();
  }
}
const FOCUS_SILENTLY$1 = /* @__PURE__ */ Symbol("FOCUS_SILENTLY");
function focusSilently$1(element2) {
  element2[FOCUS_SILENTLY$1] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused$1(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY$1];
  delete element2[FOCUS_SILENTLY$1];
  return isSilentlyFocused;
}
function isItem$1(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var shim$1 = { exports: {} };
var useSyncExternalStoreShim_production$1 = {};
var hasRequiredUseSyncExternalStoreShim_production$1;
function requireUseSyncExternalStoreShim_production$1() {
  if (hasRequiredUseSyncExternalStoreShim_production$1) return useSyncExternalStoreShim_production$1;
  hasRequiredUseSyncExternalStoreShim_production$1 = 1;
  var React2 = React__default;
  function is2(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$2(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$1(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
  useSyncExternalStoreShim_production$1.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production$1;
}
var useSyncExternalStoreShim_development$1 = {};
var hasRequiredUseSyncExternalStoreShim_development$1;
function requireUseSyncExternalStoreShim_development$1() {
  if (hasRequiredUseSyncExternalStoreShim_development$1) return useSyncExternalStoreShim_development$1;
  hasRequiredUseSyncExternalStoreShim_development$1 = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    function useSyncExternalStore$2(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$1(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    useSyncExternalStoreShim_development$1.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development$1;
}
var hasRequiredShim$1;
function requireShim$1() {
  if (hasRequiredShim$1) return shim$1.exports;
  hasRequiredShim$1 = 1;
  if (process.env.NODE_ENV === "production") {
    shim$1.exports = requireUseSyncExternalStoreShim_production$1();
  } else {
    shim$1.exports = requireUseSyncExternalStoreShim_development$1();
  }
  return shim$1.exports;
}
var shimExports$1 = requireShim$1();
const noopSubscribe$1 = () => () => {
};
function useStoreState$1(store2, keyOrSelector = identity$2) {
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe$1();
    return subscribe$1(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2?.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$4(state, key)) return;
    return state[key];
  };
  return shimExports$1.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject$1(store2, object2) {
  const objRef = React.useRef({});
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe$1();
    return subscribe$1(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const state = store2?.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$4(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) objRef.current = { ...obj };
    return objRef.current;
  };
  return shimExports$1.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps$1(store2, props2, key, setKey) {
  const value = hasOwnProperty$4(props2, key) ? props2[key] : void 0;
  const propsRef = useLiveRef$1({
    value,
    setValue: setKey ? props2[setKey] : void 0
  });
  useSafeLayoutEffect$1(() => {
    return sync$1(store2, [key], (state, prev) => {
      const { value: value2, setValue } = propsRef.current;
      if (!setValue) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect$1(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch$1(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore$1(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect$1(() => init$1(store2), [store2]);
  const useState2 = React.useCallback((keyOrSelector) => useStoreState$1(store2, keyOrSelector), [store2]);
  return [React.useMemo(() => ({
    ...store2,
    useState: useState2
  }), [store2, useState2]), useEvent$1(() => {
    setStore((store22) => createStore2({
      ...props2,
      ...store22.getState()
    }));
  })];
}
const TagName$5$1 = "button";
function isEditableElement$1(element2) {
  if (isTextbox$1(element2)) return true;
  return element2.tagName === "INPUT" && !isButton$1(element2);
}
function getNextPageOffset$1(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") return pageOffset + scrollingElement.scrollTop;
  return pageOffset;
}
function getItemOffset$1(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) return top2 + itemElement.clientHeight;
  return top2;
}
function findNextPageItemId$1(element2, store2, next, pageUp = false) {
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement$1(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset$1(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = getEnabledItem$1(store2, id2)?.element;
    if (!itemElement) continue;
    const difference = getItemOffset$1(itemElement, pageUp) - nextPageOffset;
    const absDifference = Math.abs(difference);
    if (pageUp && difference <= 0 || !pageUp && difference >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) id2 = previousId;
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem$1(event, store2) {
  if (isSelfTarget$1(event)) return false;
  return isItem$1(store2, event.target);
}
const useCompositeItem$1 = createHook$1(function useCompositeItem22({ store: store2, rowId: rowIdProp, preventScrollOnKeyDown = false, moveOnKeyPress = true, tabbable = false, getItem: getItemProp, "aria-setsize": ariaSetSizeProp, "aria-posinset": ariaPosInSetProp, ...props2 }) {
  const context = useCompositeScopedContext$1();
  store2 = store2 || context;
  const id2 = useId$1(props2.id);
  const ref = useRef(null);
  const row = useContext(CompositeRowContext$1);
  const trulyDisabled = disabledFromProps$1(props2) && !props2.accessibleWhenDisabled;
  const shouldRegisterItem = props2.shouldRegisterItem;
  const getRowId = (state) => {
    if (rowIdProp) return rowIdProp;
    if (!state) return;
    if (!row?.baseElement) return;
    if (row.baseElement !== state.baseElement) return;
    return row.id;
  };
  const { rowId, baseElement, isActiveItem, ariaSetSize, ariaPosInSet, isTabbable: isTabbable2 } = useStoreStateObject$1(store2, {
    rowId: getRowId,
    baseElement(state) {
      return state?.baseElement || void 0;
    },
    isActiveItem(state) {
      return !!state && state.activeId === id2;
    },
    ariaSetSize(state) {
      if (ariaSetSizeProp != null) return ariaSetSizeProp;
      if (!state) return;
      if (!row?.ariaSetSize) return;
      if (row.baseElement !== state.baseElement) return;
      return row.ariaSetSize;
    },
    ariaPosInSet(state) {
      if (ariaPosInSetProp != null) return ariaPosInSetProp;
      if (!state) return;
      if (!row?.ariaPosInSet) return;
      if (row.baseElement !== state.baseElement) return;
      const rowId2 = getRowId(state);
      const itemsInRow = state.renderedItems.filter((item) => item.rowId === rowId2);
      return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
    },
    isTabbable(state) {
      if (!state?.renderedItems.length) return true;
      if (state.virtualFocus) return false;
      if (tabbable) return true;
      if (state.activeId === null) return false;
      const item = store2?.item(state.activeId);
      if (item?.disabled) return true;
      if (!item?.element) return true;
      return state.activeId === id2;
    }
  });
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      id: id2 || item.id,
      rowId,
      disabled: trulyDisabled,
      children: item.element?.textContent
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [
    id2,
    rowId,
    trulyDisabled,
    getItemProp
  ]);
  const onFocusProp = props2.onFocus;
  const hasFocusedComposite = useRef(false);
  const cancelScheduledFocusRedirectRef = useRef(null);
  const onFocus = useEvent$1((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (isPortalEvent$1(event)) return;
    if (!id2) return;
    if (!store2) return;
    if (targetIsAnotherItem$1(event, store2)) return;
    const { virtualFocus, baseElement: baseElement2 } = store2.getState();
    store2.setActiveId(id2);
    if (isTextbox$1(event.currentTarget)) selectTextField$1(event.currentTarget);
    if (!virtualFocus) return;
    if (!isSelfTarget$1(event)) return;
    if (isEditableElement$1(event.currentTarget)) return;
    const redirectFocusToBaseElement = (currentTarget2, relatedTarget2, baseElement3) => {
      if (isSafari$1() && currentTarget2.hasAttribute("data-autofocus")) currentTarget2.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
      hasFocusedComposite.current = true;
      if (relatedTarget2 === baseElement3 || isItem$1(store2, relatedTarget2)) focusSilently$1(baseElement3);
      else baseElement3.focus();
    };
    if (baseElement2?.isConnected) {
      redirectFocusToBaseElement(event.currentTarget, event.relatedTarget, baseElement2);
      return;
    }
    if (shouldRegisterItem === false) return;
    const { currentTarget, relatedTarget } = event;
    const cancelScheduledFocusRedirect = () => {
      cancelScheduledFocusRedirectRef.current?.();
      cancelScheduledFocusRedirectRef.current = null;
    };
    cancelScheduledFocusRedirect();
    cancelScheduledFocusRedirectRef.current = subscribe$1(store2, null, () => {
      if (getActiveElement$1(currentTarget) !== currentTarget) {
        cancelScheduledFocusRedirect();
        return;
      }
      const state = store2.getState();
      const nextBaseElement = state.baseElement;
      if (!nextBaseElement?.isConnected) return;
      cancelScheduledFocusRedirect();
      if (!state.virtualFocus) return;
      redirectFocusToBaseElement(currentTarget, relatedTarget, nextBaseElement);
    });
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent$1((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (store2?.getState()?.virtualFocus && hasFocusedComposite.current) {
      hasFocusedComposite.current = false;
      event.preventDefault();
      event.stopPropagation();
    }
  });
  const onKeyDownProp = props2.onKeyDown;
  const preventScrollOnKeyDownProp = useBooleanEvent$1(preventScrollOnKeyDown);
  const moveOnKeyPressProp = useBooleanEvent$1(moveOnKeyPress);
  const onKeyDown = useEvent$1((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (!isSelfTarget$1(event)) return;
    if (!store2) return;
    const { currentTarget } = event;
    const state = store2.getState();
    const isGrid2 = !!store2.item(id2)?.rowId;
    const isVertical = state.orientation !== "horizontal";
    const isHorizontal = state.orientation !== "vertical";
    const canHomeEnd = () => {
      if (isGrid2) return true;
      if (isHorizontal) return true;
      if (!state.baseElement) return true;
      if (!isTextField$1(state.baseElement)) return true;
      return false;
    };
    const action = {
      ArrowUp: (isGrid2 || isVertical) && store2.up,
      ArrowRight: (isGrid2 || isHorizontal) && store2.next,
      ArrowDown: (isGrid2 || isVertical) && store2.down,
      ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
      Home: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.first();
        return store2?.previous(-1);
      },
      End: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.last();
        return store2?.next(-1);
      },
      PageUp: () => {
        return findNextPageItemId$1(currentTarget, store2, store2?.up, true);
      },
      PageDown: () => {
        return findNextPageItemId$1(currentTarget, store2, store2?.down);
      }
    }[event.key];
    if (action) {
      if (isTextbox$1(currentTarget)) {
        const selection2 = getTextboxSelection$1(currentTarget);
        const isLeft = isHorizontal && event.key === "ArrowLeft";
        const isRight = isHorizontal && event.key === "ArrowRight";
        const isUp = isVertical && event.key === "ArrowUp";
        const isDown = isVertical && event.key === "ArrowDown";
        if (isRight || isDown) {
          const { length: valueLength } = getTextboxValue$1(currentTarget);
          if (selection2.end !== valueLength) return;
        } else if ((isLeft || isUp) && selection2.start !== 0) return;
      }
      const nextId = action();
      if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(nextId);
      }
    }
  });
  const providerValue = useMemo(() => ({
    id: id2,
    baseElement
  }), [id2, baseElement]);
  props2 = useWrapElement$1(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(CompositeItemContext$1.Provider, {
    value: providerValue,
    children: element2
  }), [providerValue]);
  props2 = {
    "data-active-item": isActiveItem || void 0,
    ...props2,
    id: id2,
    ref: useMergeRefs$1(ref, props2.ref),
    tabIndex: isTabbable2 ? props2.tabIndex : -1,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useCommand$1(props2);
  props2 = useCollectionItem$1({
    store: store2,
    ...props2,
    getItem,
    shouldRegisterItem: id2 ? shouldRegisterItem : false
  });
  return removeUndefinedValues$1({
    ...props2,
    "aria-setsize": ariaSetSize,
    "aria-posinset": ariaPosInSet
  });
});
memo$1(forwardRef$1(function CompositeItem3(props2) {
  return createElement$1(TagName$5$1, useCompositeItem$1(props2));
}));
const TagName$4$1 = "div";
function isGrid$1(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey$1(event) {
  const target = event.target;
  if (target && !isTextField$1(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey$1(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy$1(store2, onKeyboardEvent, previousElementRef) {
  return useEvent$1((event) => {
    onKeyboardEvent?.(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget$1(event)) return;
    if (isModifierKey$1(event)) return;
    if (isPrintableKey$1(event)) return;
    const activeElement = getEnabledItem$1(store2, store2.getState().activeId)?.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    if (activeElement !== previousElementRef?.current) activeElement.focus();
    if (!fireKeyboardEvent$1(activeElement, event.type, eventInit)) event.preventDefault();
    if (event.currentTarget.contains(activeElement)) event.stopPropagation();
  });
}
function findFirstEnabledItemInTheLastRow$1(items) {
  return findFirstEnabledItem$2(flatten2DArray$1(reverseArray$1(groupItemsByRows$2(items))));
}
function withBaseScrollPreserved$1(store2, callback) {
  const { virtualFocus, baseElement } = store2.getState();
  if (!virtualFocus || !baseElement || !isTextField$1(baseElement)) {
    callback();
    return;
  }
  const savedScrollLeft = baseElement.scrollLeft;
  const savedScrollTop = baseElement.scrollTop;
  callback();
  baseElement.scrollLeft = savedScrollLeft;
  baseElement.scrollTop = savedScrollTop;
}
function useScheduleFocus$1(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = useStoreState$1(store2, (state) => scheduled ? getEnabledItem$1(store2, state.activeId) : null);
  useEffect(() => {
    const activeElement = activeItem?.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    withBaseScrollPreserved$1(store2, () => {
      activeElement.focus({ preventScroll: true });
    });
  }, [
    store2,
    activeItem,
    scheduled
  ]);
  return schedule;
}
const CompositeFocusOnMove$1 = memo$1(function CompositeFocusOnMove22({ store: store2, focusOnMove, previousElementRef }) {
  const moves = useStoreState$1(store2, "moves");
  const baseElement = useStoreState$1(store2, "baseElement");
  useEffect(() => {
    if (!moves) return;
    if (!focusOnMove) return;
    const { activeId } = store2.getState();
    const itemElement = getEnabledItem$1(store2, activeId)?.element;
    if (!itemElement) return;
    withBaseScrollPreserved$1(store2, () => focusIntoView$1(itemElement));
  }, [
    store2,
    moves,
    focusOnMove
  ]);
  useSafeLayoutEffect$1(() => {
    if (!moves) return;
    if (!baseElement) return;
    const { activeId } = store2.getState();
    if (!(activeId === null)) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (previousElement) fireBlurEvent$1(previousElement, { relatedTarget: baseElement });
    if (!hasFocus$1(baseElement)) baseElement.focus();
  }, [
    store2,
    moves,
    baseElement
  ]);
  return null;
});
const useComposite$1 = createHook$1(function useComposite22({ store: store2, composite = true, focusOnMove = composite, moveOnKeyPress = true, ...props2 }) {
  const context = useCompositeProviderContext$1();
  store2 = store2 || context;
  invariant$1(store2, process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component.");
  const ref = useRef(null);
  const previousElementRef = useRef(null);
  const scheduleFocus = useScheduleFocus$1(store2);
  const [, setBaseElement] = useTransactionState$1(composite ? store2.setBaseElement : null);
  const virtualFocus = useStoreState$1(store2, "virtualFocus");
  const activeId = useStoreState$1(store2, (state) => state.virtualFocus ? state.activeId : null);
  useSafeLayoutEffect$1(() => {
    if (!store2) return;
    if (!composite) return;
    if (!virtualFocus) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (!previousElement) return;
    const relatedTarget = getEnabledItem$1(store2, activeId)?.element || getActiveElement$1(previousElement);
    if (relatedTarget === previousElement) return;
    fireBlurEvent$1(previousElement, { relatedTarget });
  }, [
    store2,
    activeId,
    virtualFocus,
    composite
  ]);
  const onKeyDownCapture = useKeyboardEventProxy$1(store2, props2.onKeyDownCapture, previousElementRef);
  const onKeyUpCapture = useKeyboardEventProxy$1(store2, props2.onKeyUpCapture, previousElementRef);
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent$1((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (!virtualFocus2) return;
    const previousActiveElement = event.relatedTarget;
    const isSilentlyFocused = silentlyFocused$1(event.currentTarget);
    if (isSelfTarget$1(event) && isSilentlyFocused) {
      event.stopPropagation();
      previousElementRef.current = previousActiveElement;
    }
  });
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent$1((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (!composite) return;
    if (!store2) return;
    const { relatedTarget } = event;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (virtualFocus2) {
      if (isSelfTarget$1(event) && !isItem$1(store2, relatedTarget)) queueMicrotask(scheduleFocus);
    } else if (isSelfTarget$1(event)) store2.setActiveId(null);
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent$1((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
    if (!virtualFocus2) return;
    const activeElement = getEnabledItem$1(store2, activeId2)?.element;
    const nextActiveElement = event.relatedTarget;
    const nextActiveElementIsItem = isItem$1(store2, nextActiveElement);
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (isSelfTarget$1(event) && nextActiveElementIsItem) {
      if (nextActiveElement === activeElement) {
        if (previousElement && previousElement !== nextActiveElement) fireBlurEvent$1(previousElement, event);
      } else if (activeElement) fireBlurEvent$1(activeElement, event);
      else if (previousElement) fireBlurEvent$1(previousElement, event);
      event.stopPropagation();
    } else if (!isItem$1(store2, event.target) && activeElement) fireBlurEvent$1(activeElement, event);
  });
  const onKeyDownProp = props2.onKeyDown;
  const moveOnKeyPressProp = useBooleanEvent$1(moveOnKeyPress);
  const onKeyDown = useEvent$1((event) => {
    onKeyDownProp?.(event);
    if (event.nativeEvent.isComposing) return;
    if (event.defaultPrevented) return;
    if (!store2) return;
    if (!isSelfTarget$1(event)) return;
    const { orientation, renderedItems, activeId: activeId2, rtl } = store2.getState();
    if (getEnabledItem$1(store2, activeId2)?.element?.isConnected) return;
    const isVertical = orientation !== "horizontal";
    const isHorizontal = orientation !== "vertical";
    const grid = isGrid$1(renderedItems);
    if ((event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End") && isTextField$1(event.currentTarget)) return;
    const up = () => {
      if (grid) return findFirstEnabledItemInTheLastRow$1(renderedItems)?.id;
      return store2?.last();
    };
    const action = {
      ArrowUp: (grid || isVertical) && up,
      ArrowRight: (grid || isHorizontal) && (rtl ? store2.last : store2.first),
      ArrowDown: (grid || isVertical) && store2.first,
      ArrowLeft: (grid || isHorizontal) && (rtl ? store2.first : store2.last),
      Home: store2.first,
      End: store2.last,
      PageUp: store2.first,
      PageDown: store2.last
    }[event.key];
    if (action) {
      const id2 = action();
      if (id2 !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(id2);
      }
    }
  });
  props2 = useWrapElement$1(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsxs(CompositeScopedContextProvider$1, {
    value: store2,
    children: [element2, composite && /* @__PURE__ */ jsxRuntimeExports$1.jsx(CompositeFocusOnMove$1, {
      store: store2,
      focusOnMove,
      previousElementRef
    })]
  }), [
    store2,
    composite,
    focusOnMove
  ]);
  props2 = {
    "aria-activedescendant": useStoreState$1(store2, (state) => {
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return getEnabledItem$1(store2, state.activeId)?.id;
    }),
    ...props2,
    ref: useMergeRefs$1(ref, setBaseElement, props2.ref),
    onKeyDownCapture,
    onKeyUpCapture,
    onFocusCapture,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useFocusable$1({
    focusable: useStoreState$1(store2, (state) => composite && (state.virtualFocus || state.activeId === null)),
    ...props2
  });
  return props2;
});
forwardRef$1(function Composite3(props2) {
  return createElement$1(TagName$4$1, useComposite$1(props2));
});
function useCollectionStoreProps$1(store2, update, props2) {
  useUpdateEffect$1(update, [props2.store]);
  useStoreProps$1(store2, props2, "items", "setItems");
  return store2;
}
function useCompositeStoreOptions$1(props2) {
  return {
    id: useId$1(props2.id),
    ...props2
  };
}
function useCompositeStoreProps$1(store2, update, props2) {
  store2 = useCollectionStoreProps$1(store2, update, props2);
  useStoreProps$1(store2, props2, "activeId", "setActiveId");
  useStoreProps$1(store2, props2, "includesBaseElement");
  useStoreProps$1(store2, props2, "virtualFocus");
  useStoreProps$1(store2, props2, "orientation");
  useStoreProps$1(store2, props2, "rtl");
  useStoreProps$1(store2, props2, "focusLoop");
  useStoreProps$1(store2, props2, "focusWrap");
  useStoreProps$1(store2, props2, "focusShift");
  return store2;
}
const TagName$3$1 = "button";
const useButton$1 = createHook$1(function useButton2(props2) {
  const ref = useRef(null);
  const tagName = useTagName$1(ref, TagName$3$1);
  const [isNativeButton, setIsNativeButton] = useState(() => !!tagName && isButton$1({
    tagName,
    type: props2.type
  }));
  useEffect(() => {
    if (!ref.current) return;
    setIsNativeButton(isButton$1(ref.current));
  }, []);
  props2 = {
    role: !isNativeButton && tagName !== "a" ? "button" : void 0,
    ...props2,
    ref: useMergeRefs$1(ref, props2.ref)
  };
  props2 = useCommand$1(props2);
  return props2;
});
const Button$1 = forwardRef$1(function Button3(props2) {
  return createElement$1(TagName$3$1, useButton$1(props2));
});
const ctx$1$1 = createStoreContext$1([CompositeContextProvider$1], [CompositeScopedContextProvider$1]);
const useRadioContext = ctx$1$1.useContext;
const useRadioProviderContext = ctx$1$1.useProviderContext;
const RadioContextProvider = ctx$1$1.ContextProvider;
const RadioScopedContextProvider = ctx$1$1.ScopedContextProvider;
const TagName$2$1 = "input";
function getIsChecked(value, storeValue) {
  if (storeValue === void 0) return;
  if (value != null && storeValue != null) return storeValue === value;
  return !!storeValue;
}
function isNativeRadio(tagName, type) {
  return tagName === "input" && (!type || type === "radio");
}
const useRadio = createHook$1(function useRadio2({ store: store2, name: nameProp, value, checked, ...props2 }) {
  const context = useRadioContext();
  store2 = store2 || context;
  const id2 = useId$1(props2.id);
  const ref = useRef(null);
  const isChecked = useStoreState$1(store2, (state) => checked ?? getIsChecked(value, state?.value));
  const storeId = useStoreState$1(store2, "id");
  const name2 = nameProp ?? storeId;
  useEffect(() => {
    if (!id2) return;
    if (!isChecked) return;
    if (store2?.getState().activeId === id2) return;
    store2?.setActiveId(id2);
  }, [
    store2,
    isChecked,
    id2
  ]);
  const onChangeProp = props2.onChange;
  const nativeRadio = isNativeRadio(useTagName$1(ref, TagName$2$1), props2.type);
  const disabled = disabledFromProps$1(props2);
  const [propertyUpdated, schedulePropertyUpdate] = useForceUpdate$1();
  useEffect(() => {
    const element2 = ref.current;
    if (!element2) return;
    if (nativeRadio) return;
    if (isChecked !== void 0) element2.checked = isChecked;
    if (name2 !== void 0) element2.name = name2;
    if (value !== void 0) element2.value = `${value}`;
  }, [
    propertyUpdated,
    nativeRadio,
    isChecked,
    name2,
    value
  ]);
  const onChange = useEvent$1((event) => {
    if (disabled) {
      event.preventDefault();
      event.stopPropagation();
      return;
    }
    if (store2?.getState().value === value) return;
    if (!nativeRadio) {
      event.currentTarget.checked = true;
      schedulePropertyUpdate();
    }
    onChangeProp?.(event);
    if (event.defaultPrevented) return;
    store2?.setValue(value);
  });
  const onClickProp = props2.onClick;
  const onClick = useEvent$1((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (nativeRadio) return;
    onChange(event);
  });
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent$1((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (!nativeRadio) return;
    if (disabled) return;
    if (!store2) return;
    const { moves, activeId } = store2.getState();
    if (!moves) return;
    if (id2 && activeId !== id2) return;
    if (event.currentTarget.checked) return;
    event.currentTarget.click();
  });
  props2 = {
    role: !nativeRadio ? "radio" : void 0,
    type: nativeRadio ? "radio" : void 0,
    "aria-checked": isChecked,
    ...props2,
    id: id2,
    ref: useMergeRefs$1(ref, props2.ref),
    onChange,
    onClick,
    onFocus
  };
  props2 = useCompositeItem$1({
    store: store2,
    clickOnEnter: !nativeRadio,
    ...props2
  });
  return removeUndefinedValues$1({
    name: nativeRadio ? name2 : void 0,
    value: nativeRadio ? value : void 0,
    checked: isChecked,
    ...props2
  });
});
const Radio = memo$1(forwardRef$1(function Radio2(props2) {
  return createElement$1(TagName$2$1, useRadio(props2));
}));
const TagName$1$1 = "div";
function isCheckedRadio(element2) {
  if (!element2) return false;
  if (element2.tagName === "INPUT") {
    const { type, checked } = element2;
    if (type === "radio") return checked;
  }
  if (element2.getAttribute("role") !== "radio") return false;
  return element2.getAttribute("aria-checked") === "true";
}
function getCheckedRadioId(store2) {
  const { renderedItems } = store2.getState();
  return renderedItems.find((item) => isCheckedRadio(item.element))?.id;
}
const useRadioGroup = createHook$1(function useRadioGroup2({ store: store2, ...props2 }) {
  const context = useRadioProviderContext();
  store2 = store2 || context;
  invariant$1(store2, process.env.NODE_ENV !== "production" && "RadioGroup must receive a `store` prop or be wrapped in a RadioProvider component.");
  props2 = useWrapElement$1(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(RadioScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent$1((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!isFocusEventOutside$1(event)) return;
    const checkedId = getCheckedRadioId(store2);
    if (!checkedId) return;
    store2.setActiveId(checkedId);
  });
  props2 = {
    role: "radiogroup",
    ...props2,
    onBlurCapture
  };
  props2 = useComposite$1({
    store: store2,
    ...props2
  });
  return props2;
});
const RadioGroup = forwardRef$1(function RadioGroup2(props2) {
  return createElement$1(TagName$1$1, useRadioGroup(props2));
});
function createRadioStore(props2 = {}) {
  const syncState = props2.store?.getState();
  const composite = createCompositeStore$1({
    ...props2,
    focusLoop: defaultValue$1(props2.focusLoop, syncState?.focusLoop, true)
  });
  const radio = createStore$1({
    ...composite.getState(),
    value: defaultValue$1(props2.value, syncState?.value, props2.defaultValue, null)
  }, composite, props2.store);
  return {
    ...composite,
    ...radio,
    setValue: (value) => radio.setState("value", value)
  };
}
function useRadioStoreProps(store2, update, props2) {
  store2 = useCompositeStoreProps$1(store2, update, props2);
  useStoreProps$1(store2, props2, "value", "setValue");
  return store2;
}
function useRadioStore(props2 = {}) {
  props2 = useCompositeStoreOptions$1(props2);
  const [store2, update] = useStore$1(createRadioStore, props2);
  return useRadioStoreProps(store2, update, props2);
}
function RadioProvider(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$1.jsx(RadioContextProvider, {
    value: useRadioStore(props2),
    children: props2.children
  });
}
const CheckboxCheckedContext = createContext(false);
const ctx$a = createStoreContext$1();
const useCheckboxContext = ctx$a.useContext;
function getPrimitiveValue(value) {
  if (Array.isArray(value)) return value.toString();
  return value;
}
const TagName$D = "input";
function setMixed(element2, mixed) {
  if (mixed) element2.indeterminate = true;
  else if (element2.indeterminate) element2.indeterminate = false;
}
function isNativeCheckbox(tagName, type) {
  return tagName === "input" && (!type || type === "checkbox");
}
const useCheckbox = createHook$1(function useCheckbox2({ store: store2, name: name2, value: valueProp, checked: checkedProp, defaultChecked, ...props2 }) {
  const context = useCheckboxContext();
  store2 = store2 || context;
  const [_checked, setChecked] = useState(defaultChecked ?? false);
  const checked = useStoreState$1(store2, (state) => {
    if (checkedProp !== void 0) return checkedProp;
    if (state?.value === void 0) return _checked;
    if (valueProp != null) {
      if (Array.isArray(state.value)) {
        const primitiveValue = getPrimitiveValue(valueProp);
        return state.value.includes(primitiveValue);
      }
      return state.value === valueProp;
    }
    if (Array.isArray(state.value)) return false;
    if (typeof state.value === "boolean") return state.value;
    return false;
  });
  const ref = useRef(null);
  const nativeCheckbox = isNativeCheckbox(useTagName$1(ref, TagName$D), props2.type);
  const mixed = checked ? checked === "mixed" : void 0;
  const isChecked = checked === "mixed" ? false : checked;
  const disabled = disabledFromProps$1(props2);
  const [propertyUpdated, schedulePropertyUpdate] = useForceUpdate$1();
  useEffect(() => {
    const element2 = ref.current;
    if (!element2) return;
    setMixed(element2, mixed);
    if (nativeCheckbox) return;
    element2.checked = isChecked;
    if (name2 !== void 0) element2.name = name2;
    if (valueProp !== void 0) element2.value = String(valueProp);
  }, [
    propertyUpdated,
    mixed,
    nativeCheckbox,
    isChecked,
    name2,
    valueProp
  ]);
  const onChangeProp = props2.onChange;
  const onChange = useEvent$1((event) => {
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
      return;
    }
    setMixed(event.currentTarget, mixed);
    if (!nativeCheckbox) {
      event.currentTarget.checked = !event.currentTarget.checked;
      schedulePropertyUpdate();
    }
    onChangeProp?.(event);
    if (event.defaultPrevented) return;
    const elementChecked = event.currentTarget.checked;
    setChecked(elementChecked);
    store2?.setValue((prevValue) => {
      if (valueProp == null) return elementChecked;
      const primitiveValue = getPrimitiveValue(valueProp);
      if (!Array.isArray(prevValue)) return prevValue === primitiveValue ? false : primitiveValue;
      if (elementChecked) {
        if (prevValue.includes(primitiveValue)) return prevValue;
        return [...prevValue, primitiveValue];
      }
      return prevValue.filter((v2) => v2 !== primitiveValue);
    });
  });
  const onClickProp = props2.onClick;
  const onClick = useEvent$1((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (nativeCheckbox) return;
    onChange(event);
  });
  props2 = useWrapElement$1(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$1.jsx(CheckboxCheckedContext.Provider, {
    value: isChecked,
    children: element2
  }), [isChecked]);
  props2 = {
    role: !nativeCheckbox ? "checkbox" : void 0,
    type: nativeCheckbox ? "checkbox" : void 0,
    "aria-checked": checked,
    ...props2,
    ref: useMergeRefs$1(ref, props2.ref),
    onChange,
    onClick
  };
  props2 = useCommand$1({
    clickOnEnter: !nativeCheckbox,
    ...props2
  });
  return removeUndefinedValues$1({
    name: nativeCheckbox ? name2 : void 0,
    value: nativeCheckbox ? valueProp : void 0,
    checked: isChecked,
    ...props2
  });
});
const Checkbox = forwardRef$1(function Checkbox2(props2) {
  return createElement$1(TagName$D, useCheckbox(props2));
});
function Button2(props2) {
  if (props2.value != null && props2.children != null) {
    console.warn(
      "Button: Both `value` and `children` props are provided. Using `value`."
    );
  }
  let value = props2.value ?? props2.children;
  if (value && props2.valueHasLatex) {
    value = /* @__PURE__ */ React__default.createElement("span", { style: { pointerEvents: "none" } }, /* @__PURE__ */ React__default.createElement(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true }, value));
  }
  let icon = props2.icon && /* @__PURE__ */ React__default.createElement("div", { className: "button-icon" }, props2.icon);
  const button = /* @__PURE__ */ React__default.createElement(
    Button$1,
    {
      id: props2.id,
      disabled: props2.disabled,
      onClick: props2.onClick,
      onBlur: props2.onBlur,
      className: classNames(
        "doenet-button",
        {
          vertical: props2.vertical,
          alert: props2.alert
        },
        props2.className
      ),
      style: props2.fillColor ? {
        "--button-color": props2.fillColor
      } : void 0,
      "aria-label": props2.ariaLabel
    },
    icon,
    value
  );
  if (props2.label) {
    return /* @__PURE__ */ React__default.createElement(
      "div",
      {
        className: classNames("doenet-labelled-button", {
          vertical: props2.vertical
        })
      },
      /* @__PURE__ */ React__default.createElement("span", { className: "label" }, props2.label),
      button
    );
  }
  return button;
}
function ActionButton(props2) {
  return /* @__PURE__ */ React__default.createElement(
    Button2,
    {
      ...props2,
      className: classNames("action-button", props2.className)
    },
    props2.children
  );
}
const ActionButtonGroup = (props2) => {
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: classNames("doenet-button-group", {
        vertical: props2.vertical
      }),
      style: props2.style
    },
    props2.children
  );
};
function ToggleButton(props2) {
  const inputType = props2.inputType ?? "checkbox";
  const [isSelected2, setSelected] = useState(!!props2.isSelected);
  useEffect(() => {
    setSelected(!!props2.isSelected);
  }, [props2.isSelected]);
  if (props2.value != null && props2.children != null) {
    console.warn(
      "Button: Both `value` and `children` props are provided. Using `value`."
    );
  }
  let value = props2.value ?? props2.children;
  if (value && props2.valueHasLatex) {
    value = /* @__PURE__ */ React__default.createElement(MathJax, { hideUntilTypeset: "first", inline: true, dynamic: true }, value);
  }
  let icon = props2.icon && /* @__PURE__ */ React__default.createElement("div", { className: "button-icon" }, props2.icon);
  const Input = inputType === "radio" ? Radio : Checkbox;
  return /* @__PURE__ */ React__default.createElement(
    "label",
    {
      className: classNames(
        "doenet-toggle-button-label",
        "doenet-button",
        "action-button"
      )
    },
    /* @__PURE__ */ React__default.createElement(
      Input,
      {
        value: "",
        id: props2.id,
        checked: isSelected2,
        onChange: () => {
          setSelected(!isSelected2);
          if (props2.onClick) {
            props2.onClick(props2.index != null ? props2.index : null);
          }
        },
        onKeyDown: (e2) => {
          if (e2.key === "Enter") {
            e2.target.dispatchEvent(
              new MouseEvent("click", {
                bubbles: true,
                cancelable: true
              })
            );
          }
        },
        onFocus: props2.onFocus,
        onBlur: props2.onBlur,
        className: "doenet-toggle-button",
        "aria-label": props2.ariaLabel
      }
    ),
    icon,
    value
  );
}
function isToggleButton(node) {
  return React__default.isValidElement(node) && node.type === ToggleButton;
}
const ToggleButtonGroup = (props2) => {
  const [selectedIndex, setSelectedIndex] = useState(0);
  const containerRef = React__default.useRef(null);
  const onClick = React__default.useCallback(
    (e2) => {
      if ("key" in e2 && e2.key !== "Enter") {
        return;
      }
      const target = e2.target;
      const button = target.querySelector(".doenet-toggle-button") || target.closest(".doenet-toggle-button");
      if (!button || !containerRef.current) {
        return;
      }
      const allToggleButtons = Array.from(
        containerRef.current?.querySelectorAll(
          ".doenet-toggle-button"
        ) || []
      );
      const index2 = allToggleButtons.indexOf(button);
      if (index2 === -1) {
        return;
      }
      setSelectedIndex(index2);
      if (props2.onClick) {
        props2.onClick(index2);
      }
    },
    [props2.onClick]
  );
  const children = React__default.Children.map(props2.children, (child, index2) => {
    if (!isToggleButton(child)) {
      console.warn(
        "ToggleButtonGroup was passed a child that is not a ToggleButton."
      );
      return child;
    }
    return React__default.cloneElement(child, {
      isSelected: index2 === selectedIndex,
      index: index2,
      inputType: "radio"
      // Always use radio for ToggleButtonGroup
    });
  });
  return /* @__PURE__ */ React__default.createElement(RadioProvider, null, /* @__PURE__ */ React__default.createElement(
    RadioGroup,
    {
      className: classNames("doenet-button-group", {
        vertical: props2.vertical
      }),
      ref: containerRef,
      onClick,
      onKeyDown: onClick
    },
    children
  ));
};
var DefaultContext = {
  color: void 0,
  size: void 0,
  className: void 0,
  style: void 0,
  attr: void 0
};
var IconContext = React__default.createContext && /* @__PURE__ */ React__default.createContext(DefaultContext);
var _excluded$1 = ["attr", "size", "title"];
function _objectWithoutProperties(e2, t4) {
  if (null == e2) return {};
  var o2, r2, i2 = _objectWithoutPropertiesLoose$1(e2, t4);
  if (Object.getOwnPropertySymbols) {
    var n2 = Object.getOwnPropertySymbols(e2);
    for (r2 = 0; r2 < n2.length; r2++) o2 = n2[r2], -1 === t4.indexOf(o2) && {}.propertyIsEnumerable.call(e2, o2) && (i2[o2] = e2[o2]);
  }
  return i2;
}
function _objectWithoutPropertiesLoose$1(r2, e2) {
  if (null == r2) return {};
  var t4 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e2.indexOf(n2)) continue;
    t4[n2] = r2[n2];
  }
  return t4;
}
function _extends$2() {
  return _extends$2 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t4 = arguments[e2];
      for (var r2 in t4) ({}).hasOwnProperty.call(t4, r2) && (n2[r2] = t4[r2]);
    }
    return n2;
  }, _extends$2.apply(null, arguments);
}
function ownKeys$4(e2, r2) {
  var t4 = Object.keys(e2);
  if (Object.getOwnPropertySymbols) {
    var o2 = Object.getOwnPropertySymbols(e2);
    r2 && (o2 = o2.filter(function(r22) {
      return Object.getOwnPropertyDescriptor(e2, r22).enumerable;
    })), t4.push.apply(t4, o2);
  }
  return t4;
}
function _objectSpread$4(e2) {
  for (var r2 = 1; r2 < arguments.length; r2++) {
    var t4 = null != arguments[r2] ? arguments[r2] : {};
    r2 % 2 ? ownKeys$4(Object(t4), true).forEach(function(r22) {
      _defineProperty$1(e2, r22, t4[r22]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e2, Object.getOwnPropertyDescriptors(t4)) : ownKeys$4(Object(t4)).forEach(function(r22) {
      Object.defineProperty(e2, r22, Object.getOwnPropertyDescriptor(t4, r22));
    });
  }
  return e2;
}
function _defineProperty$1(e2, r2, t4) {
  return (r2 = _toPropertyKey(r2)) in e2 ? Object.defineProperty(e2, r2, { value: t4, enumerable: true, configurable: true, writable: true }) : e2[r2] = t4, e2;
}
function _toPropertyKey(t4) {
  var i2 = _toPrimitive(t4, "string");
  return "symbol" == typeof i2 ? i2 : i2 + "";
}
function _toPrimitive(t4, r2) {
  if ("object" != typeof t4 || !t4) return t4;
  var e2 = t4[Symbol.toPrimitive];
  if (void 0 !== e2) {
    var i2 = e2.call(t4, r2);
    if ("object" != typeof i2) return i2;
    throw new TypeError("@@toPrimitive must return a primitive value.");
  }
  return ("string" === r2 ? String : Number)(t4);
}
function Tree2Element(tree) {
  return tree && tree.map((node, i2) => /* @__PURE__ */ React__default.createElement(node.tag, _objectSpread$4({
    key: i2
  }, node.attr), Tree2Element(node.child)));
}
function GenIcon(data) {
  return (props2) => /* @__PURE__ */ React__default.createElement(IconBase, _extends$2({
    attr: _objectSpread$4({}, data.attr)
  }, props2), Tree2Element(data.child));
}
function IconBase(props2) {
  var elem = (conf) => {
    var attr = props2.attr, size2 = props2.size, title = props2.title, svgProps = _objectWithoutProperties(props2, _excluded$1);
    var computedSize = size2 || conf.size || "1em";
    var className;
    if (conf.className) className = conf.className;
    if (props2.className) className = (className ? className + " " : "") + props2.className;
    return /* @__PURE__ */ React__default.createElement("svg", _extends$2({
      stroke: "currentColor",
      fill: "currentColor",
      strokeWidth: "0"
    }, conf.attr, attr, svgProps, {
      className,
      style: _objectSpread$4(_objectSpread$4({
        color: props2.color || conf.color
      }, conf.style), props2.style),
      height: computedSize,
      width: computedSize,
      xmlns: "http://www.w3.org/2000/svg"
    }), title && /* @__PURE__ */ React__default.createElement("title", null, title), props2.children);
  };
  return IconContext !== void 0 ? /* @__PURE__ */ React__default.createElement(IconContext.Consumer, null, (conf) => elem(conf)) : elem(DefaultContext);
}
function BsGripVertical(props2) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M7 2a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 5a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0M7 8a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0m-3 3a1 1 0 1 1-2 0 1 1 0 0 1 2 0m3 0a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, "child": [] }] })(props2);
}
function BsGripHorizontal(props2) {
  return GenIcon({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M2 8a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m3 3a1 1 0 1 1 0 2 1 1 0 0 1 0-2m0-3a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, "child": [] }] })(props2);
}
const PanelGroupContext = createContext(null);
PanelGroupContext.displayName = "PanelGroupContext";
const DATA_ATTRIBUTES = {
  group: "data-panel-group",
  groupDirection: "data-panel-group-direction",
  groupId: "data-panel-group-id",
  panel: "data-panel",
  panelCollapsible: "data-panel-collapsible",
  panelId: "data-panel-id",
  panelSize: "data-panel-size",
  resizeHandle: "data-resize-handle",
  resizeHandleActive: "data-resize-handle-active",
  resizeHandleEnabled: "data-panel-resize-handle-enabled",
  resizeHandleId: "data-panel-resize-handle-id",
  resizeHandleState: "data-resize-handle-state"
};
const PRECISION = 10;
const useIsomorphicLayoutEffect = useLayoutEffect;
const useId$2 = React["useId".toString()];
const wrappedUseId = typeof useId$2 === "function" ? useId$2 : () => null;
let counter = 0;
function useUniqueId(idFromParams = null) {
  const idFromUseId = wrappedUseId();
  const idRef = useRef(idFromParams || idFromUseId || null);
  if (idRef.current === null) {
    idRef.current = "" + counter++;
  }
  return idFromParams !== null && idFromParams !== void 0 ? idFromParams : idRef.current;
}
function PanelWithForwardedRef({
  children,
  className: classNameFromProps = "",
  collapsedSize,
  collapsible,
  defaultSize,
  forwardedRef,
  id: idFromProps,
  maxSize,
  minSize,
  onCollapse,
  onExpand,
  onResize,
  order: order2,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest2
}) {
  const context = useContext(PanelGroupContext);
  if (context === null) {
    throw Error(`Panel components must be rendered within a PanelGroup container`);
  }
  const {
    collapsePanel,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    reevaluatePanelConstraints,
    registerPanel,
    resizePanel: resizePanel2,
    unregisterPanel
  } = context;
  const panelId = useUniqueId(idFromProps);
  const panelDataRef = useRef({
    callbacks: {
      onCollapse,
      onExpand,
      onResize
    },
    constraints: {
      collapsedSize,
      collapsible,
      defaultSize,
      maxSize,
      minSize
    },
    id: panelId,
    idIsFromProps: idFromProps !== void 0,
    order: order2
  });
  useRef({
    didLogMissingDefaultSizeWarning: false
  });
  useIsomorphicLayoutEffect(() => {
    const {
      callbacks,
      constraints
    } = panelDataRef.current;
    const prevConstraints = {
      ...constraints
    };
    panelDataRef.current.id = panelId;
    panelDataRef.current.idIsFromProps = idFromProps !== void 0;
    panelDataRef.current.order = order2;
    callbacks.onCollapse = onCollapse;
    callbacks.onExpand = onExpand;
    callbacks.onResize = onResize;
    constraints.collapsedSize = collapsedSize;
    constraints.collapsible = collapsible;
    constraints.defaultSize = defaultSize;
    constraints.maxSize = maxSize;
    constraints.minSize = minSize;
    if (prevConstraints.collapsedSize !== constraints.collapsedSize || prevConstraints.collapsible !== constraints.collapsible || prevConstraints.maxSize !== constraints.maxSize || prevConstraints.minSize !== constraints.minSize) {
      reevaluatePanelConstraints(panelDataRef.current, prevConstraints);
    }
  });
  useIsomorphicLayoutEffect(() => {
    const panelData = panelDataRef.current;
    registerPanel(panelData);
    return () => {
      unregisterPanel(panelData);
    };
  }, [order2, panelId, registerPanel, unregisterPanel]);
  useImperativeHandle(forwardedRef, () => ({
    collapse: () => {
      collapsePanel(panelDataRef.current);
    },
    expand: (minSize2) => {
      expandPanel(panelDataRef.current, minSize2);
    },
    getId() {
      return panelId;
    },
    getSize() {
      return getPanelSize(panelDataRef.current);
    },
    isCollapsed() {
      return isPanelCollapsed(panelDataRef.current);
    },
    isExpanded() {
      return !isPanelCollapsed(panelDataRef.current);
    },
    resize: (size2) => {
      resizePanel2(panelDataRef.current, size2);
    }
  }), [collapsePanel, expandPanel, getPanelSize, isPanelCollapsed, panelId, resizePanel2]);
  const style = getPanelStyle(panelDataRef.current, defaultSize);
  return createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: panelId,
    style: {
      ...style,
      ...styleFromProps
    },
    // CSS selectors
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.panel]: "",
    [DATA_ATTRIBUTES.panelCollapsible]: collapsible || void 0,
    [DATA_ATTRIBUTES.panelId]: panelId,
    [DATA_ATTRIBUTES.panelSize]: parseFloat("" + style.flexGrow).toFixed(1)
  });
}
const Panel = forwardRef$3((props2, ref) => createElement$3(PanelWithForwardedRef, {
  ...props2,
  forwardedRef: ref
}));
PanelWithForwardedRef.displayName = "Panel";
Panel.displayName = "forwardRef(Panel)";
let currentCursorStyle = null;
let prevRuleIndex = -1;
let styleElement = null;
function getCursorStyle(state, constraintFlags, isPointerDown2) {
  const horizontalMin = (constraintFlags & EXCEEDED_HORIZONTAL_MIN) !== 0;
  const horizontalMax = (constraintFlags & EXCEEDED_HORIZONTAL_MAX) !== 0;
  const verticalMin = (constraintFlags & EXCEEDED_VERTICAL_MIN) !== 0;
  const verticalMax = (constraintFlags & EXCEEDED_VERTICAL_MAX) !== 0;
  if (constraintFlags) {
    if (horizontalMin) {
      if (verticalMin) {
        return "se-resize";
      } else if (verticalMax) {
        return "ne-resize";
      } else {
        return "e-resize";
      }
    } else if (horizontalMax) {
      if (verticalMin) {
        return "sw-resize";
      } else if (verticalMax) {
        return "nw-resize";
      } else {
        return "w-resize";
      }
    } else if (verticalMin) {
      return "s-resize";
    } else if (verticalMax) {
      return "n-resize";
    }
  }
  switch (state) {
    case "horizontal":
      return "ew-resize";
    case "intersection":
      return "move";
    case "vertical":
      return "ns-resize";
  }
}
function resetGlobalCursorStyle() {
  if (styleElement !== null) {
    document.head.removeChild(styleElement);
    currentCursorStyle = null;
    styleElement = null;
    prevRuleIndex = -1;
  }
}
function setGlobalCursorStyle(state, constraintFlags, isPointerDown2) {
  var _styleElement$sheet$i, _styleElement$sheet2;
  const style = getCursorStyle(state, constraintFlags);
  if (currentCursorStyle === style) {
    return;
  }
  currentCursorStyle = style;
  if (styleElement === null) {
    styleElement = document.createElement("style");
    document.head.appendChild(styleElement);
  }
  if (prevRuleIndex >= 0) {
    var _styleElement$sheet;
    (_styleElement$sheet = styleElement.sheet) === null || _styleElement$sheet === void 0 ? void 0 : _styleElement$sheet.removeRule(prevRuleIndex);
  }
  prevRuleIndex = (_styleElement$sheet$i = (_styleElement$sheet2 = styleElement.sheet) === null || _styleElement$sheet2 === void 0 ? void 0 : _styleElement$sheet2.insertRule(`*{cursor: ${style} !important;}`)) !== null && _styleElement$sheet$i !== void 0 ? _styleElement$sheet$i : -1;
}
function isKeyDown(event) {
  return event.type === "keydown";
}
function isPointerEvent(event) {
  return event.type.startsWith("pointer");
}
function isMouseEvent(event) {
  return event.type.startsWith("mouse");
}
function getResizeEventCoordinates(event) {
  if (isPointerEvent(event)) {
    if (event.isPrimary) {
      return {
        x: event.clientX,
        y: event.clientY
      };
    }
  } else if (isMouseEvent(event)) {
    return {
      x: event.clientX,
      y: event.clientY
    };
  }
  return {
    x: Infinity,
    y: Infinity
  };
}
function getInputType() {
  if (typeof matchMedia === "function") {
    return matchMedia("(pointer:coarse)").matches ? "coarse" : "fine";
  }
}
function intersects(rectOne, rectTwo, strict) {
  {
    return rectOne.x < rectTwo.x + rectTwo.width && rectOne.x + rectOne.width > rectTwo.x && rectOne.y < rectTwo.y + rectTwo.height && rectOne.y + rectOne.height > rectTwo.y;
  }
}
function compare$1(a2, b2) {
  if (a2 === b2) throw new Error("Cannot compare node with itself");
  const ancestors = {
    a: get_ancestors(a2),
    b: get_ancestors(b2)
  };
  let common_ancestor;
  while (ancestors.a.at(-1) === ancestors.b.at(-1)) {
    a2 = ancestors.a.pop();
    b2 = ancestors.b.pop();
    common_ancestor = a2;
  }
  assert(common_ancestor, "Stacking order can only be calculated for elements with a common ancestor");
  const z_indexes = {
    a: get_z_index(find_stacking_context(ancestors.a)),
    b: get_z_index(find_stacking_context(ancestors.b))
  };
  if (z_indexes.a === z_indexes.b) {
    const children = common_ancestor.childNodes;
    const furthest_ancestors = {
      a: ancestors.a.at(-1),
      b: ancestors.b.at(-1)
    };
    let i2 = children.length;
    while (i2--) {
      const child = children[i2];
      if (child === furthest_ancestors.a) return 1;
      if (child === furthest_ancestors.b) return -1;
    }
  }
  return Math.sign(z_indexes.a - z_indexes.b);
}
const props = /\b(?:position|zIndex|opacity|transform|webkitTransform|mixBlendMode|filter|webkitFilter|isolation)\b/;
function is_flex_item(node) {
  var _get_parent;
  const display = getComputedStyle((_get_parent = get_parent(node)) !== null && _get_parent !== void 0 ? _get_parent : node).display;
  return display === "flex" || display === "inline-flex";
}
function creates_stacking_context(node) {
  const style = getComputedStyle(node);
  if (style.position === "fixed") return true;
  if (style.zIndex !== "auto" && (style.position !== "static" || is_flex_item(node))) return true;
  if (+style.opacity < 1) return true;
  if ("transform" in style && style.transform !== "none") return true;
  if ("webkitTransform" in style && style.webkitTransform !== "none") return true;
  if ("mixBlendMode" in style && style.mixBlendMode !== "normal") return true;
  if ("filter" in style && style.filter !== "none") return true;
  if ("webkitFilter" in style && style.webkitFilter !== "none") return true;
  if ("isolation" in style && style.isolation === "isolate") return true;
  if (props.test(style.willChange)) return true;
  if (style.webkitOverflowScrolling === "touch") return true;
  return false;
}
function find_stacking_context(nodes) {
  let i2 = nodes.length;
  while (i2--) {
    const node = nodes[i2];
    assert(node, "Missing node");
    if (creates_stacking_context(node)) return node;
  }
  return null;
}
function get_z_index(node) {
  return node && Number(getComputedStyle(node).zIndex) || 0;
}
function get_ancestors(node) {
  const ancestors = [];
  while (node) {
    ancestors.push(node);
    node = get_parent(node);
  }
  return ancestors;
}
function get_parent(node) {
  const {
    parentNode
  } = node;
  if (parentNode && parentNode instanceof ShadowRoot) {
    return parentNode.host;
  }
  return parentNode;
}
const EXCEEDED_HORIZONTAL_MIN = 1;
const EXCEEDED_HORIZONTAL_MAX = 2;
const EXCEEDED_VERTICAL_MIN = 4;
const EXCEEDED_VERTICAL_MAX = 8;
const isCoarsePointer = getInputType() === "coarse";
let intersectingHandles = [];
let isPointerDown = false;
let ownerDocumentCounts = /* @__PURE__ */ new Map();
let panelConstraintFlags = /* @__PURE__ */ new Map();
const registeredResizeHandlers = /* @__PURE__ */ new Set();
function registerResizeHandle(resizeHandleId, element2, direction, hitAreaMargins, setResizeHandlerState) {
  var _ownerDocumentCounts$;
  const {
    ownerDocument
  } = element2;
  const data = {
    direction,
    element: element2,
    hitAreaMargins,
    setResizeHandlerState
  };
  const count = (_ownerDocumentCounts$ = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$ !== void 0 ? _ownerDocumentCounts$ : 0;
  ownerDocumentCounts.set(ownerDocument, count + 1);
  registeredResizeHandlers.add(data);
  updateListeners();
  return function unregisterResizeHandle() {
    var _ownerDocumentCounts$2;
    panelConstraintFlags.delete(resizeHandleId);
    registeredResizeHandlers.delete(data);
    const count2 = (_ownerDocumentCounts$2 = ownerDocumentCounts.get(ownerDocument)) !== null && _ownerDocumentCounts$2 !== void 0 ? _ownerDocumentCounts$2 : 1;
    ownerDocumentCounts.set(ownerDocument, count2 - 1);
    updateListeners();
    if (count2 === 1) {
      ownerDocumentCounts.delete(ownerDocument);
    }
    if (intersectingHandles.includes(data)) {
      const index2 = intersectingHandles.indexOf(data);
      if (index2 >= 0) {
        intersectingHandles.splice(index2, 1);
      }
      updateCursor();
      setResizeHandlerState("up", true, null);
    }
  };
}
function handlePointerDown(event) {
  const {
    target
  } = event;
  const {
    x: x2,
    y: y2
  } = getResizeEventCoordinates(event);
  isPointerDown = true;
  recalculateIntersectingHandles({
    target,
    x: x2,
    y: y2
  });
  updateListeners();
  if (intersectingHandles.length > 0) {
    updateResizeHandlerStates("down", event);
    updateCursor();
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
}
function handlePointerMove(event) {
  const {
    x: x2,
    y: y2
  } = getResizeEventCoordinates(event);
  if (isPointerDown && // Skip this check for "pointerleave" events, else Firefox triggers a false positive (see #514)
  event.type !== "pointerleave" && event.buttons === 0) {
    isPointerDown = false;
    updateResizeHandlerStates("up", event);
  }
  if (!isPointerDown) {
    const {
      target
    } = event;
    recalculateIntersectingHandles({
      target,
      x: x2,
      y: y2
    });
  }
  updateResizeHandlerStates("move", event);
  updateCursor();
  if (intersectingHandles.length > 0) {
    event.preventDefault();
  }
}
function handlePointerUp(event) {
  const {
    target
  } = event;
  const {
    x: x2,
    y: y2
  } = getResizeEventCoordinates(event);
  panelConstraintFlags.clear();
  isPointerDown = false;
  if (intersectingHandles.length > 0) {
    event.preventDefault();
    if (!isWithinResizeHandle(target)) {
      event.stopImmediatePropagation();
    }
  }
  updateResizeHandlerStates("up", event);
  recalculateIntersectingHandles({
    target,
    x: x2,
    y: y2
  });
  updateCursor();
  updateListeners();
}
function isWithinResizeHandle(element2) {
  let currentElement = element2;
  while (currentElement) {
    if (currentElement.hasAttribute(DATA_ATTRIBUTES.resizeHandle)) {
      return true;
    }
    currentElement = currentElement.parentElement;
  }
  return false;
}
function recalculateIntersectingHandles({
  target,
  x: x2,
  y: y2
}) {
  intersectingHandles.splice(0);
  let targetElement = null;
  if (target instanceof HTMLElement || target instanceof SVGElement) {
    targetElement = target;
  }
  registeredResizeHandlers.forEach((data) => {
    const {
      element: dragHandleElement,
      hitAreaMargins
    } = data;
    const dragHandleRect = dragHandleElement.getBoundingClientRect();
    const {
      bottom,
      left,
      right,
      top: top2
    } = dragHandleRect;
    const margin = isCoarsePointer ? hitAreaMargins.coarse : hitAreaMargins.fine;
    const eventIntersects = x2 >= left - margin && x2 <= right + margin && y2 >= top2 - margin && y2 <= bottom + margin;
    if (eventIntersects) {
      if (targetElement !== null && document.contains(targetElement) && dragHandleElement !== targetElement && !dragHandleElement.contains(targetElement) && !targetElement.contains(dragHandleElement) && // Calculating stacking order has a cost, so we should avoid it if possible
      // That is why we only check potentially intersecting handles,
      // and why we skip if the event target is within the handle's DOM
      compare$1(targetElement, dragHandleElement) > 0) {
        let currentElement = targetElement;
        let didIntersect = false;
        while (currentElement) {
          if (currentElement.contains(dragHandleElement)) {
            break;
          } else if (intersects(currentElement.getBoundingClientRect(), dragHandleRect)) {
            didIntersect = true;
            break;
          }
          currentElement = currentElement.parentElement;
        }
        if (didIntersect) {
          return;
        }
      }
      intersectingHandles.push(data);
    }
  });
}
function reportConstraintsViolation(resizeHandleId, flag) {
  panelConstraintFlags.set(resizeHandleId, flag);
}
function updateCursor() {
  let intersectsHorizontal = false;
  let intersectsVertical = false;
  intersectingHandles.forEach((data) => {
    const {
      direction
    } = data;
    if (direction === "horizontal") {
      intersectsHorizontal = true;
    } else {
      intersectsVertical = true;
    }
  });
  let constraintFlags = 0;
  panelConstraintFlags.forEach((flag) => {
    constraintFlags |= flag;
  });
  if (intersectsHorizontal && intersectsVertical) {
    setGlobalCursorStyle("intersection", constraintFlags);
  } else if (intersectsHorizontal) {
    setGlobalCursorStyle("horizontal", constraintFlags);
  } else if (intersectsVertical) {
    setGlobalCursorStyle("vertical", constraintFlags);
  } else {
    resetGlobalCursorStyle();
  }
}
let listenersAbortController;
function updateListeners() {
  var _listenersAbortContro;
  (_listenersAbortContro = listenersAbortController) === null || _listenersAbortContro === void 0 ? void 0 : _listenersAbortContro.abort();
  listenersAbortController = new AbortController();
  const options2 = {
    capture: true,
    signal: listenersAbortController.signal
  };
  if (!registeredResizeHandlers.size) {
    return;
  }
  if (isPointerDown) {
    if (intersectingHandles.length > 0) {
      ownerDocumentCounts.forEach((count, ownerDocument) => {
        const {
          body
        } = ownerDocument;
        if (count > 0) {
          body.addEventListener("contextmenu", handlePointerUp, options2);
          body.addEventListener("pointerleave", handlePointerMove, options2);
          body.addEventListener("pointermove", handlePointerMove, options2);
        }
      });
    }
    ownerDocumentCounts.forEach((_2, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      body.addEventListener("pointerup", handlePointerUp, options2);
      body.addEventListener("pointercancel", handlePointerUp, options2);
    });
  } else {
    ownerDocumentCounts.forEach((count, ownerDocument) => {
      const {
        body
      } = ownerDocument;
      if (count > 0) {
        body.addEventListener("pointerdown", handlePointerDown, options2);
        body.addEventListener("pointermove", handlePointerMove, options2);
      }
    });
  }
}
function updateResizeHandlerStates(action, event) {
  registeredResizeHandlers.forEach((data) => {
    const {
      setResizeHandlerState
    } = data;
    const isActive = intersectingHandles.includes(data);
    setResizeHandlerState(action, isActive, event);
  });
}
function useForceUpdate$2() {
  const [_2, setCount] = useState(0);
  return useCallback(() => setCount((prevCount) => prevCount + 1), []);
}
function assert(expectedCondition, message) {
  if (!expectedCondition) {
    console.error(message);
    throw Error(message);
  }
}
function fuzzyCompareNumbers(actual, expected, fractionDigits = PRECISION) {
  if (actual.toFixed(fractionDigits) === expected.toFixed(fractionDigits)) {
    return 0;
  } else {
    return actual > expected ? 1 : -1;
  }
}
function fuzzyNumbersEqual$1(actual, expected, fractionDigits = PRECISION) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyNumbersEqual(actual, expected, fractionDigits) {
  return fuzzyCompareNumbers(actual, expected, fractionDigits) === 0;
}
function fuzzyLayoutsEqual(actual, expected, fractionDigits) {
  if (actual.length !== expected.length) {
    return false;
  }
  for (let index2 = 0; index2 < actual.length; index2++) {
    const actualSize = actual[index2];
    const expectedSize = expected[index2];
    if (!fuzzyNumbersEqual(actualSize, expectedSize, fractionDigits)) {
      return false;
    }
  }
  return true;
}
function resizePanel({
  panelConstraints: panelConstraintsArray,
  panelIndex,
  size: size2
}) {
  const panelConstraints = panelConstraintsArray[panelIndex];
  assert(panelConstraints != null, `Panel constraints not found for index ${panelIndex}`);
  let {
    collapsedSize = 0,
    collapsible,
    maxSize = 100,
    minSize = 0
  } = panelConstraints;
  if (fuzzyCompareNumbers(size2, minSize) < 0) {
    if (collapsible) {
      const halfwayPoint = (collapsedSize + minSize) / 2;
      if (fuzzyCompareNumbers(size2, halfwayPoint) < 0) {
        size2 = collapsedSize;
      } else {
        size2 = minSize;
      }
    } else {
      size2 = minSize;
    }
  }
  size2 = Math.min(maxSize, size2);
  size2 = parseFloat(size2.toFixed(PRECISION));
  return size2;
}
function adjustLayoutByDelta({
  delta,
  initialLayout,
  panelConstraints: panelConstraintsArray,
  pivotIndices,
  prevLayout,
  trigger
}) {
  if (fuzzyNumbersEqual(delta, 0)) {
    return initialLayout;
  }
  const nextLayout = [...initialLayout];
  const [firstPivotIndex, secondPivotIndex] = pivotIndices;
  assert(firstPivotIndex != null, "Invalid first pivot index");
  assert(secondPivotIndex != null, "Invalid second pivot index");
  let deltaApplied = 0;
  {
    if (trigger === "keyboard") {
      {
        const index2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
        const panelConstraints = panelConstraintsArray[index2];
        assert(panelConstraints, `Panel constraints not found for index ${index2}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index2];
          assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
          if (fuzzyNumbersEqual(prevSize, collapsedSize)) {
            const localDelta = minSize - prevSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
      {
        const index2 = delta < 0 ? firstPivotIndex : secondPivotIndex;
        const panelConstraints = panelConstraintsArray[index2];
        assert(panelConstraints, `No panel constraints found for index ${index2}`);
        const {
          collapsedSize = 0,
          collapsible,
          minSize = 0
        } = panelConstraints;
        if (collapsible) {
          const prevSize = initialLayout[index2];
          assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
          if (fuzzyNumbersEqual(prevSize, minSize)) {
            const localDelta = prevSize - collapsedSize;
            if (fuzzyCompareNumbers(localDelta, Math.abs(delta)) > 0) {
              delta = delta < 0 ? 0 - localDelta : localDelta;
            }
          }
        }
      }
    }
  }
  {
    const increment = delta < 0 ? 1 : -1;
    let index2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
    let maxAvailableDelta = 0;
    while (true) {
      const prevSize = initialLayout[index2];
      assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
      const maxSafeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index2,
        size: 100
      });
      const delta2 = maxSafeSize - prevSize;
      maxAvailableDelta += delta2;
      index2 += increment;
      if (index2 < 0 || index2 >= panelConstraintsArray.length) {
        break;
      }
    }
    const minAbsDelta = Math.min(Math.abs(delta), Math.abs(maxAvailableDelta));
    delta = delta < 0 ? 0 - minAbsDelta : minAbsDelta;
  }
  {
    const pivotIndex = delta < 0 ? firstPivotIndex : secondPivotIndex;
    let index2 = pivotIndex;
    while (index2 >= 0 && index2 < panelConstraintsArray.length) {
      const deltaRemaining = Math.abs(delta) - Math.abs(deltaApplied);
      const prevSize = initialLayout[index2];
      assert(prevSize != null, `Previous layout not found for panel index ${index2}`);
      const unsafeSize = prevSize - deltaRemaining;
      const safeSize = resizePanel({
        panelConstraints: panelConstraintsArray,
        panelIndex: index2,
        size: unsafeSize
      });
      if (!fuzzyNumbersEqual(prevSize, safeSize)) {
        deltaApplied += prevSize - safeSize;
        nextLayout[index2] = safeSize;
        if (deltaApplied.toFixed(3).localeCompare(Math.abs(delta).toFixed(3), void 0, {
          numeric: true
        }) >= 0) {
          break;
        }
      }
      if (delta < 0) {
        index2--;
      } else {
        index2++;
      }
    }
  }
  if (fuzzyLayoutsEqual(prevLayout, nextLayout)) {
    return prevLayout;
  }
  {
    const pivotIndex = delta < 0 ? secondPivotIndex : firstPivotIndex;
    const prevSize = initialLayout[pivotIndex];
    assert(prevSize != null, `Previous layout not found for panel index ${pivotIndex}`);
    const unsafeSize = prevSize + deltaApplied;
    const safeSize = resizePanel({
      panelConstraints: panelConstraintsArray,
      panelIndex: pivotIndex,
      size: unsafeSize
    });
    nextLayout[pivotIndex] = safeSize;
    if (!fuzzyNumbersEqual(safeSize, unsafeSize)) {
      let deltaRemaining = unsafeSize - safeSize;
      const pivotIndex2 = delta < 0 ? secondPivotIndex : firstPivotIndex;
      let index2 = pivotIndex2;
      while (index2 >= 0 && index2 < panelConstraintsArray.length) {
        const prevSize2 = nextLayout[index2];
        assert(prevSize2 != null, `Previous layout not found for panel index ${index2}`);
        const unsafeSize2 = prevSize2 + deltaRemaining;
        const safeSize2 = resizePanel({
          panelConstraints: panelConstraintsArray,
          panelIndex: index2,
          size: unsafeSize2
        });
        if (!fuzzyNumbersEqual(prevSize2, safeSize2)) {
          deltaRemaining -= safeSize2 - prevSize2;
          nextLayout[index2] = safeSize2;
        }
        if (fuzzyNumbersEqual(deltaRemaining, 0)) {
          break;
        }
        if (delta > 0) {
          index2--;
        } else {
          index2++;
        }
      }
    }
  }
  const totalSize = nextLayout.reduce((total, size2) => size2 + total, 0);
  if (!fuzzyNumbersEqual(totalSize, 100)) {
    return prevLayout;
  }
  return nextLayout;
}
function calculateAriaValues({
  layout,
  panelsArray,
  pivotIndices
}) {
  let currentMinSize = 0;
  let currentMaxSize = 100;
  let totalMinSize = 0;
  let totalMaxSize = 0;
  const firstIndex = pivotIndices[0];
  assert(firstIndex != null, "No pivot index found");
  panelsArray.forEach((panelData, index2) => {
    const {
      constraints
    } = panelData;
    const {
      maxSize = 100,
      minSize = 0
    } = constraints;
    if (index2 === firstIndex) {
      currentMinSize = minSize;
      currentMaxSize = maxSize;
    } else {
      totalMinSize += minSize;
      totalMaxSize += maxSize;
    }
  });
  const valueMax = Math.min(currentMaxSize, 100 - totalMinSize);
  const valueMin = Math.max(currentMinSize, 100 - totalMaxSize);
  const valueNow = layout[firstIndex];
  return {
    valueMax,
    valueMin,
    valueNow
  };
}
function getResizeHandleElementsForGroup(groupId, scope = document) {
  return Array.from(scope.querySelectorAll(`[${DATA_ATTRIBUTES.resizeHandleId}][data-panel-group-id="${groupId}"]`));
}
function getResizeHandleElementIndex(groupId, id2, scope = document) {
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index2 = handles.findIndex((handle) => handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId) === id2);
  return index2 !== null && index2 !== void 0 ? index2 : null;
}
function determinePivotIndices(groupId, dragHandleId, panelGroupElement) {
  const index2 = getResizeHandleElementIndex(groupId, dragHandleId, panelGroupElement);
  return index2 != null ? [index2, index2 + 1] : [-1, -1];
}
function isHTMLElement$1(target) {
  if (target instanceof HTMLElement) {
    return true;
  }
  return typeof target === "object" && target !== null && "tagName" in target && "getAttribute" in target;
}
function getPanelGroupElement(id2, rootElement = document) {
  if (isHTMLElement$1(rootElement) && rootElement.dataset.panelGroupId == id2) {
    return rootElement;
  }
  const element2 = rootElement.querySelector(`[data-panel-group][data-panel-group-id="${id2}"]`);
  if (element2) {
    return element2;
  }
  return null;
}
function getResizeHandleElement(id2, scope = document) {
  const element2 = scope.querySelector(`[${DATA_ATTRIBUTES.resizeHandleId}="${id2}"]`);
  if (element2) {
    return element2;
  }
  return null;
}
function getResizeHandlePanelIds(groupId, handleId, panelsArray, scope = document) {
  var _panelsArray$index$id, _panelsArray$index, _panelsArray$id, _panelsArray;
  const handle = getResizeHandleElement(handleId, scope);
  const handles = getResizeHandleElementsForGroup(groupId, scope);
  const index2 = handle ? handles.indexOf(handle) : -1;
  const idBefore = (_panelsArray$index$id = (_panelsArray$index = panelsArray[index2]) === null || _panelsArray$index === void 0 ? void 0 : _panelsArray$index.id) !== null && _panelsArray$index$id !== void 0 ? _panelsArray$index$id : null;
  const idAfter = (_panelsArray$id = (_panelsArray = panelsArray[index2 + 1]) === null || _panelsArray === void 0 ? void 0 : _panelsArray.id) !== null && _panelsArray$id !== void 0 ? _panelsArray$id : null;
  return [idBefore, idAfter];
}
function useWindowSplitterPanelGroupBehavior({
  committedValuesRef,
  eagerValuesRef,
  groupId,
  layout,
  panelDataArray,
  panelGroupElement,
  setLayout
}) {
  useRef({
    didWarnAboutMissingResizeHandle: false
  });
  useIsomorphicLayoutEffect(() => {
    if (!panelGroupElement) {
      return;
    }
    const resizeHandleElements = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    for (let index2 = 0; index2 < panelDataArray.length - 1; index2++) {
      const {
        valueMax,
        valueMin,
        valueNow
      } = calculateAriaValues({
        layout,
        panelsArray: panelDataArray,
        pivotIndices: [index2, index2 + 1]
      });
      const resizeHandleElement = resizeHandleElements[index2];
      if (resizeHandleElement == null) ;
      else {
        const panelData = panelDataArray[index2];
        assert(panelData, `No panel data found for index "${index2}"`);
        resizeHandleElement.setAttribute("aria-controls", panelData.id);
        resizeHandleElement.setAttribute("aria-valuemax", "" + Math.round(valueMax));
        resizeHandleElement.setAttribute("aria-valuemin", "" + Math.round(valueMin));
        resizeHandleElement.setAttribute("aria-valuenow", valueNow != null ? "" + Math.round(valueNow) : "");
      }
    }
    return () => {
      resizeHandleElements.forEach((resizeHandleElement, index2) => {
        resizeHandleElement.removeAttribute("aria-controls");
        resizeHandleElement.removeAttribute("aria-valuemax");
        resizeHandleElement.removeAttribute("aria-valuemin");
        resizeHandleElement.removeAttribute("aria-valuenow");
      });
    };
  }, [groupId, layout, panelDataArray, panelGroupElement]);
  useEffect(() => {
    if (!panelGroupElement) {
      return;
    }
    const eagerValues = eagerValuesRef.current;
    assert(eagerValues, `Eager values not found`);
    const {
      panelDataArray: panelDataArray2
    } = eagerValues;
    const groupElement = getPanelGroupElement(groupId, panelGroupElement);
    assert(groupElement != null, `No group found for id "${groupId}"`);
    const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
    assert(handles, `No resize handles found for group id "${groupId}"`);
    const cleanupFunctions = handles.map((handle) => {
      const handleId = handle.getAttribute(DATA_ATTRIBUTES.resizeHandleId);
      assert(handleId, `Resize handle element has no handle id attribute`);
      const [idBefore, idAfter] = getResizeHandlePanelIds(groupId, handleId, panelDataArray2, panelGroupElement);
      if (idBefore == null || idAfter == null) {
        return () => {
        };
      }
      const onKeyDown = (event) => {
        if (event.defaultPrevented) {
          return;
        }
        switch (event.key) {
          case "Enter": {
            event.preventDefault();
            const index2 = panelDataArray2.findIndex((panelData) => panelData.id === idBefore);
            if (index2 >= 0) {
              const panelData = panelDataArray2[index2];
              assert(panelData, `No panel data found for index ${index2}`);
              const size2 = layout[index2];
              const {
                collapsedSize = 0,
                collapsible,
                minSize = 0
              } = panelData.constraints;
              if (size2 != null && collapsible) {
                const nextLayout = adjustLayoutByDelta({
                  delta: fuzzyNumbersEqual(size2, collapsedSize) ? minSize - collapsedSize : collapsedSize - size2,
                  initialLayout: layout,
                  panelConstraints: panelDataArray2.map((panelData2) => panelData2.constraints),
                  pivotIndices: determinePivotIndices(groupId, handleId, panelGroupElement),
                  prevLayout: layout,
                  trigger: "keyboard"
                });
                if (layout !== nextLayout) {
                  setLayout(nextLayout);
                }
              }
            }
            break;
          }
        }
      };
      handle.addEventListener("keydown", onKeyDown);
      return () => {
        handle.removeEventListener("keydown", onKeyDown);
      };
    });
    return () => {
      cleanupFunctions.forEach((cleanupFunction) => cleanupFunction());
    };
  }, [panelGroupElement, committedValuesRef, eagerValuesRef, groupId, layout, panelDataArray, setLayout]);
}
function areEqual(arrayA, arrayB) {
  if (arrayA.length !== arrayB.length) {
    return false;
  }
  for (let index2 = 0; index2 < arrayA.length; index2++) {
    if (arrayA[index2] !== arrayB[index2]) {
      return false;
    }
  }
  return true;
}
function getResizeEventCursorPosition(direction, event) {
  const isHorizontal = direction === "horizontal";
  const {
    x: x2,
    y: y2
  } = getResizeEventCoordinates(event);
  return isHorizontal ? x2 : y2;
}
function calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement) {
  const isHorizontal = direction === "horizontal";
  const handleElement = getResizeHandleElement(dragHandleId, panelGroupElement);
  assert(handleElement, `No resize handle element found for id "${dragHandleId}"`);
  const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
  assert(groupId, `Resize handle element has no group id attribute`);
  let {
    initialCursorPosition
  } = initialDragState;
  const cursorPosition = getResizeEventCursorPosition(direction, event);
  const groupElement = getPanelGroupElement(groupId, panelGroupElement);
  assert(groupElement, `No group element found for id "${groupId}"`);
  const groupRect = groupElement.getBoundingClientRect();
  const groupSizeInPixels = isHorizontal ? groupRect.width : groupRect.height;
  const offsetPixels = cursorPosition - initialCursorPosition;
  const offsetPercentage = offsetPixels / groupSizeInPixels * 100;
  return offsetPercentage;
}
function calculateDeltaPercentage(event, dragHandleId, direction, initialDragState, keyboardResizeBy, panelGroupElement) {
  if (isKeyDown(event)) {
    const isHorizontal = direction === "horizontal";
    let delta = 0;
    if (event.shiftKey) {
      delta = 100;
    } else if (keyboardResizeBy != null) {
      delta = keyboardResizeBy;
    } else {
      delta = 10;
    }
    let movement = 0;
    switch (event.key) {
      case "ArrowDown":
        movement = isHorizontal ? 0 : delta;
        break;
      case "ArrowLeft":
        movement = isHorizontal ? -delta : 0;
        break;
      case "ArrowRight":
        movement = isHorizontal ? delta : 0;
        break;
      case "ArrowUp":
        movement = isHorizontal ? 0 : -delta;
        break;
      case "End":
        movement = 100;
        break;
      case "Home":
        movement = -100;
        break;
    }
    return movement;
  } else {
    if (initialDragState == null) {
      return 0;
    }
    return calculateDragOffsetPercentage(event, dragHandleId, direction, initialDragState, panelGroupElement);
  }
}
function calculateUnsafeDefaultLayout({
  panelDataArray
}) {
  const layout = Array(panelDataArray.length);
  const panelConstraintsArray = panelDataArray.map((panelData) => panelData.constraints);
  let numPanelsWithSizes = 0;
  let remainingSize = 100;
  for (let index2 = 0; index2 < panelDataArray.length; index2++) {
    const panelConstraints = panelConstraintsArray[index2];
    assert(panelConstraints, `Panel constraints not found for index ${index2}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      numPanelsWithSizes++;
      layout[index2] = defaultSize;
      remainingSize -= defaultSize;
    }
  }
  for (let index2 = 0; index2 < panelDataArray.length; index2++) {
    const panelConstraints = panelConstraintsArray[index2];
    assert(panelConstraints, `Panel constraints not found for index ${index2}`);
    const {
      defaultSize
    } = panelConstraints;
    if (defaultSize != null) {
      continue;
    }
    const numRemainingPanels = panelDataArray.length - numPanelsWithSizes;
    const size2 = remainingSize / numRemainingPanels;
    numPanelsWithSizes++;
    layout[index2] = size2;
    remainingSize -= size2;
  }
  return layout;
}
function callPanelCallbacks(panelsArray, layout, panelIdToLastNotifiedSizeMap) {
  layout.forEach((size2, index2) => {
    const panelData = panelsArray[index2];
    assert(panelData, `Panel data not found for index ${index2}`);
    const {
      callbacks,
      constraints,
      id: panelId
    } = panelData;
    const {
      collapsedSize = 0,
      collapsible
    } = constraints;
    const lastNotifiedSize = panelIdToLastNotifiedSizeMap[panelId];
    if (lastNotifiedSize == null || size2 !== lastNotifiedSize) {
      panelIdToLastNotifiedSizeMap[panelId] = size2;
      const {
        onCollapse,
        onExpand,
        onResize
      } = callbacks;
      if (onResize) {
        onResize(size2, lastNotifiedSize);
      }
      if (collapsible && (onCollapse || onExpand)) {
        if (onExpand && (lastNotifiedSize == null || fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && !fuzzyNumbersEqual$1(size2, collapsedSize)) {
          onExpand();
        }
        if (onCollapse && (lastNotifiedSize == null || !fuzzyNumbersEqual$1(lastNotifiedSize, collapsedSize)) && fuzzyNumbersEqual$1(size2, collapsedSize)) {
          onCollapse();
        }
      }
    }
  });
}
function compareLayouts(a2, b2) {
  if (a2.length !== b2.length) {
    return false;
  } else {
    for (let index2 = 0; index2 < a2.length; index2++) {
      if (a2[index2] != b2[index2]) {
        return false;
      }
    }
  }
  return true;
}
function computePanelFlexBoxStyle({
  defaultSize,
  dragState,
  layout,
  panelData,
  panelIndex,
  precision = 3
}) {
  const size2 = layout[panelIndex];
  let flexGrow;
  if (size2 == null) {
    flexGrow = defaultSize != void 0 ? defaultSize.toFixed(precision) : "1";
  } else if (panelData.length === 1) {
    flexGrow = "1";
  } else {
    flexGrow = size2.toFixed(precision);
  }
  return {
    flexBasis: 0,
    flexGrow,
    flexShrink: 1,
    // Without this, Panel sizes may be unintentionally overridden by their content
    overflow: "hidden",
    // Disable pointer events inside of a panel during resize
    // This avoid edge cases like nested iframes
    pointerEvents: dragState !== null ? "none" : void 0
  };
}
function debounce$1(callback, durationMs = 10) {
  let timeoutId = null;
  let callable = (...args) => {
    if (timeoutId !== null) {
      clearTimeout(timeoutId);
    }
    timeoutId = setTimeout(() => {
      callback(...args);
    }, durationMs);
  };
  return callable;
}
function initializeDefaultStorage(storageObject) {
  try {
    if (typeof localStorage !== "undefined") {
      storageObject.getItem = (name2) => {
        return localStorage.getItem(name2);
      };
      storageObject.setItem = (name2, value) => {
        localStorage.setItem(name2, value);
      };
    } else {
      throw new Error("localStorage not supported in this environment");
    }
  } catch (error) {
    console.error(error);
    storageObject.getItem = () => null;
    storageObject.setItem = () => {
    };
  }
}
function getPanelGroupKey(autoSaveId) {
  return `react-resizable-panels:${autoSaveId}`;
}
function getPanelKey(panels) {
  return panels.map((panel) => {
    const {
      constraints,
      id: id2,
      idIsFromProps,
      order: order2
    } = panel;
    if (idIsFromProps) {
      return id2;
    } else {
      return order2 ? `${order2}:${JSON.stringify(constraints)}` : JSON.stringify(constraints);
    }
  }).sort((a2, b2) => a2.localeCompare(b2)).join(",");
}
function loadSerializedPanelGroupState(autoSaveId, storage) {
  try {
    const panelGroupKey = getPanelGroupKey(autoSaveId);
    const serialized = storage.getItem(panelGroupKey);
    if (serialized) {
      const parsed = JSON.parse(serialized);
      if (typeof parsed === "object" && parsed != null) {
        return parsed;
      }
    }
  } catch (error) {
  }
  return null;
}
function loadPanelGroupState(autoSaveId, panels, storage) {
  var _loadSerializedPanelG, _state$panelKey;
  const state = (_loadSerializedPanelG = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG !== void 0 ? _loadSerializedPanelG : {};
  const panelKey = getPanelKey(panels);
  return (_state$panelKey = state[panelKey]) !== null && _state$panelKey !== void 0 ? _state$panelKey : null;
}
function savePanelGroupState(autoSaveId, panels, panelSizesBeforeCollapse, sizes, storage) {
  var _loadSerializedPanelG2;
  const panelGroupKey = getPanelGroupKey(autoSaveId);
  const panelKey = getPanelKey(panels);
  const state = (_loadSerializedPanelG2 = loadSerializedPanelGroupState(autoSaveId, storage)) !== null && _loadSerializedPanelG2 !== void 0 ? _loadSerializedPanelG2 : {};
  state[panelKey] = {
    expandToSizes: Object.fromEntries(panelSizesBeforeCollapse.entries()),
    layout: sizes
  };
  try {
    storage.setItem(panelGroupKey, JSON.stringify(state));
  } catch (error) {
    console.error(error);
  }
}
function validatePanelGroupLayout({
  layout: prevLayout,
  panelConstraints
}) {
  const nextLayout = [...prevLayout];
  const nextLayoutTotalSize = nextLayout.reduce((accumulated, current2) => accumulated + current2, 0);
  if (nextLayout.length !== panelConstraints.length) {
    throw Error(`Invalid ${panelConstraints.length} panel layout: ${nextLayout.map((size2) => `${size2}%`).join(", ")}`);
  } else if (!fuzzyNumbersEqual(nextLayoutTotalSize, 100) && nextLayout.length > 0) {
    for (let index2 = 0; index2 < panelConstraints.length; index2++) {
      const unsafeSize = nextLayout[index2];
      assert(unsafeSize != null, `No layout data found for index ${index2}`);
      const safeSize = 100 / nextLayoutTotalSize * unsafeSize;
      nextLayout[index2] = safeSize;
    }
  }
  let remainingSize = 0;
  for (let index2 = 0; index2 < panelConstraints.length; index2++) {
    const unsafeSize = nextLayout[index2];
    assert(unsafeSize != null, `No layout data found for index ${index2}`);
    const safeSize = resizePanel({
      panelConstraints,
      panelIndex: index2,
      size: unsafeSize
    });
    if (unsafeSize != safeSize) {
      remainingSize += unsafeSize - safeSize;
      nextLayout[index2] = safeSize;
    }
  }
  if (!fuzzyNumbersEqual(remainingSize, 0)) {
    for (let index2 = 0; index2 < panelConstraints.length; index2++) {
      const prevSize = nextLayout[index2];
      assert(prevSize != null, `No layout data found for index ${index2}`);
      const unsafeSize = prevSize + remainingSize;
      const safeSize = resizePanel({
        panelConstraints,
        panelIndex: index2,
        size: unsafeSize
      });
      if (prevSize !== safeSize) {
        remainingSize -= safeSize - prevSize;
        nextLayout[index2] = safeSize;
        if (fuzzyNumbersEqual(remainingSize, 0)) {
          break;
        }
      }
    }
  }
  return nextLayout;
}
const LOCAL_STORAGE_DEBOUNCE_INTERVAL = 100;
const defaultStorage = {
  getItem: (name2) => {
    initializeDefaultStorage(defaultStorage);
    return defaultStorage.getItem(name2);
  },
  setItem: (name2, value) => {
    initializeDefaultStorage(defaultStorage);
    defaultStorage.setItem(name2, value);
  }
};
const debounceMap = {};
function PanelGroupWithForwardedRef({
  autoSaveId = null,
  children,
  className: classNameFromProps = "",
  direction,
  forwardedRef,
  id: idFromProps = null,
  onLayout = null,
  keyboardResizeBy = null,
  storage = defaultStorage,
  style: styleFromProps,
  tagName: Type = "div",
  ...rest2
}) {
  const groupId = useUniqueId(idFromProps);
  const panelGroupElementRef = useRef(null);
  const [dragState, setDragState] = useState(null);
  const [layout, setLayout] = useState([]);
  const forceUpdate = useForceUpdate$2();
  const panelIdToLastNotifiedSizeMapRef = useRef({});
  const panelSizeBeforeCollapseRef = useRef(/* @__PURE__ */ new Map());
  const prevDeltaRef = useRef(0);
  const committedValuesRef = useRef({
    autoSaveId,
    direction,
    dragState,
    id: groupId,
    keyboardResizeBy,
    onLayout,
    storage
  });
  const eagerValuesRef = useRef({
    layout,
    panelDataArray: [],
    panelDataArrayChanged: false
  });
  useRef({
    didLogIdAndOrderWarning: false,
    didLogPanelConstraintsWarning: false,
    prevPanelIds: []
  });
  useImperativeHandle(forwardedRef, () => ({
    getId: () => committedValuesRef.current.id,
    getLayout: () => {
      const {
        layout: layout2
      } = eagerValuesRef.current;
      return layout2;
    },
    setLayout: (unsafeLayout) => {
      const {
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const safeLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, safeLayout)) {
        setLayout(safeLayout);
        eagerValuesRef.current.layout = safeLayout;
        if (onLayout2) {
          onLayout2(safeLayout);
        }
        callPanelCallbacks(panelDataArray, safeLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  }), []);
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.autoSaveId = autoSaveId;
    committedValuesRef.current.direction = direction;
    committedValuesRef.current.dragState = dragState;
    committedValuesRef.current.id = groupId;
    committedValuesRef.current.onLayout = onLayout;
    committedValuesRef.current.storage = storage;
  });
  useWindowSplitterPanelGroupBehavior({
    committedValuesRef,
    eagerValuesRef,
    groupId,
    layout,
    panelDataArray: eagerValuesRef.current.panelDataArray,
    setLayout,
    panelGroupElement: panelGroupElementRef.current
  });
  useEffect(() => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    if (autoSaveId) {
      if (layout.length === 0 || layout.length !== panelDataArray.length) {
        return;
      }
      let debouncedSave = debounceMap[autoSaveId];
      if (debouncedSave == null) {
        debouncedSave = debounce$1(savePanelGroupState, LOCAL_STORAGE_DEBOUNCE_INTERVAL);
        debounceMap[autoSaveId] = debouncedSave;
      }
      const clonedPanelDataArray = [...panelDataArray];
      const clonedPanelSizesBeforeCollapse = new Map(panelSizeBeforeCollapseRef.current);
      debouncedSave(autoSaveId, clonedPanelDataArray, clonedPanelSizesBeforeCollapse, layout, storage);
    }
  }, [autoSaveId, layout, storage]);
  useEffect(() => {
  });
  const collapsePanel = useCallback((panelData) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
      if (!fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        panelSizeBeforeCollapseRef.current.set(panelData.id, panelSize);
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - collapsedSize : collapsedSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const expandPanel = useCallback((panelData, minSizeOverride) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    if (panelData.constraints.collapsible) {
      const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
      const {
        collapsedSize = 0,
        panelSize = 0,
        minSize: minSizeFromProps = 0,
        pivotIndices
      } = panelDataHelper(panelDataArray, panelData, prevLayout);
      const minSize = minSizeOverride !== null && minSizeOverride !== void 0 ? minSizeOverride : minSizeFromProps;
      if (fuzzyNumbersEqual$1(panelSize, collapsedSize)) {
        const prevPanelSize = panelSizeBeforeCollapseRef.current.get(panelData.id);
        const baseSize = prevPanelSize != null && prevPanelSize >= minSize ? prevPanelSize : minSize;
        const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
        const delta = isLastPanel ? panelSize - baseSize : baseSize - panelSize;
        const nextLayout = adjustLayoutByDelta({
          delta,
          initialLayout: prevLayout,
          panelConstraints: panelConstraintsArray,
          pivotIndices,
          prevLayout,
          trigger: "imperative-api"
        });
        if (!compareLayouts(prevLayout, nextLayout)) {
          setLayout(nextLayout);
          eagerValuesRef.current.layout = nextLayout;
          if (onLayout2) {
            onLayout2(nextLayout);
          }
          callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
        }
      }
    }
  }, []);
  const getPanelSize = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return panelSize;
  }, []);
  const getPanelStyle = useCallback((panelData, defaultSize) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const panelIndex = findPanelDataIndex(panelDataArray, panelData);
    return computePanelFlexBoxStyle({
      defaultSize,
      dragState,
      layout,
      panelData: panelDataArray,
      panelIndex
    });
  }, [dragState, layout]);
  const isPanelCollapsed = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return collapsible === true && fuzzyNumbersEqual$1(panelSize, collapsedSize);
  }, []);
  const isPanelExpanded = useCallback((panelData) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize = 0,
      collapsible,
      panelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    return !collapsible || fuzzyCompareNumbers(panelSize, collapsedSize) > 0;
  }, []);
  const registerPanel = useCallback((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    panelDataArray.push(panelData);
    panelDataArray.sort((panelA, panelB) => {
      const orderA = panelA.order;
      const orderB = panelB.order;
      if (orderA == null && orderB == null) {
        return 0;
      } else if (orderA == null) {
        return -1;
      } else if (orderB == null) {
        return 1;
      } else {
        return orderA - orderB;
      }
    });
    eagerValuesRef.current.panelDataArrayChanged = true;
    forceUpdate();
  }, [forceUpdate]);
  useIsomorphicLayoutEffect(() => {
    if (eagerValuesRef.current.panelDataArrayChanged) {
      eagerValuesRef.current.panelDataArrayChanged = false;
      const {
        autoSaveId: autoSaveId2,
        onLayout: onLayout2,
        storage: storage2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      let unsafeLayout = null;
      if (autoSaveId2) {
        const state = loadPanelGroupState(autoSaveId2, panelDataArray, storage2);
        if (state) {
          panelSizeBeforeCollapseRef.current = new Map(Object.entries(state.expandToSizes));
          unsafeLayout = state.layout;
        }
      }
      if (unsafeLayout == null) {
        unsafeLayout = calculateUnsafeDefaultLayout({
          panelDataArray
        });
      }
      const nextLayout = validatePanelGroupLayout({
        layout: unsafeLayout,
        panelConstraints: panelDataArray.map((panelData) => panelData.constraints)
      });
      if (!areEqual(prevLayout, nextLayout)) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    }
  });
  useIsomorphicLayoutEffect(() => {
    const eagerValues = eagerValuesRef.current;
    return () => {
      eagerValues.layout = [];
    };
  }, []);
  const registerResizeHandle2 = useCallback((dragHandleId) => {
    let isRTL2 = false;
    const panelGroupElement = panelGroupElementRef.current;
    if (panelGroupElement) {
      const style2 = window.getComputedStyle(panelGroupElement, null);
      if (style2.getPropertyValue("direction") === "rtl") {
        isRTL2 = true;
      }
    }
    return function resizeHandler(event) {
      event.preventDefault();
      const panelGroupElement2 = panelGroupElementRef.current;
      if (!panelGroupElement2) {
        return () => null;
      }
      const {
        direction: direction2,
        dragState: dragState2,
        id: groupId2,
        keyboardResizeBy: keyboardResizeBy2,
        onLayout: onLayout2
      } = committedValuesRef.current;
      const {
        layout: prevLayout,
        panelDataArray
      } = eagerValuesRef.current;
      const {
        initialLayout
      } = dragState2 !== null && dragState2 !== void 0 ? dragState2 : {};
      const pivotIndices = determinePivotIndices(groupId2, dragHandleId, panelGroupElement2);
      let delta = calculateDeltaPercentage(event, dragHandleId, direction2, dragState2, keyboardResizeBy2, panelGroupElement2);
      const isHorizontal = direction2 === "horizontal";
      if (isHorizontal && isRTL2) {
        delta = -delta;
      }
      const panelConstraints = panelDataArray.map((panelData) => panelData.constraints);
      const nextLayout = adjustLayoutByDelta({
        delta,
        initialLayout: initialLayout !== null && initialLayout !== void 0 ? initialLayout : prevLayout,
        panelConstraints,
        pivotIndices,
        prevLayout,
        trigger: isKeyDown(event) ? "keyboard" : "mouse-or-touch"
      });
      const layoutChanged = !compareLayouts(prevLayout, nextLayout);
      if (isPointerEvent(event) || isMouseEvent(event)) {
        if (prevDeltaRef.current != delta) {
          prevDeltaRef.current = delta;
          if (!layoutChanged && delta !== 0) {
            if (isHorizontal) {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_HORIZONTAL_MIN : EXCEEDED_HORIZONTAL_MAX);
            } else {
              reportConstraintsViolation(dragHandleId, delta < 0 ? EXCEEDED_VERTICAL_MIN : EXCEEDED_VERTICAL_MAX);
            }
          } else {
            reportConstraintsViolation(dragHandleId, 0);
          }
        }
      }
      if (layoutChanged) {
        setLayout(nextLayout);
        eagerValuesRef.current.layout = nextLayout;
        if (onLayout2) {
          onLayout2(nextLayout);
        }
        callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
      }
    };
  }, []);
  const resizePanel2 = useCallback((panelData, unsafePanelSize) => {
    const {
      onLayout: onLayout2
    } = committedValuesRef.current;
    const {
      layout: prevLayout,
      panelDataArray
    } = eagerValuesRef.current;
    const panelConstraintsArray = panelDataArray.map((panelData2) => panelData2.constraints);
    const {
      panelSize,
      pivotIndices
    } = panelDataHelper(panelDataArray, panelData, prevLayout);
    assert(panelSize != null, `Panel size not found for panel "${panelData.id}"`);
    const isLastPanel = findPanelDataIndex(panelDataArray, panelData) === panelDataArray.length - 1;
    const delta = isLastPanel ? panelSize - unsafePanelSize : unsafePanelSize - panelSize;
    const nextLayout = adjustLayoutByDelta({
      delta,
      initialLayout: prevLayout,
      panelConstraints: panelConstraintsArray,
      pivotIndices,
      prevLayout,
      trigger: "imperative-api"
    });
    if (!compareLayouts(prevLayout, nextLayout)) {
      setLayout(nextLayout);
      eagerValuesRef.current.layout = nextLayout;
      if (onLayout2) {
        onLayout2(nextLayout);
      }
      callPanelCallbacks(panelDataArray, nextLayout, panelIdToLastNotifiedSizeMapRef.current);
    }
  }, []);
  const reevaluatePanelConstraints = useCallback((panelData, prevConstraints) => {
    const {
      layout: layout2,
      panelDataArray
    } = eagerValuesRef.current;
    const {
      collapsedSize: prevCollapsedSize = 0,
      collapsible: prevCollapsible
    } = prevConstraints;
    const {
      collapsedSize: nextCollapsedSize = 0,
      collapsible: nextCollapsible,
      maxSize: nextMaxSize = 100,
      minSize: nextMinSize = 0
    } = panelData.constraints;
    const {
      panelSize: prevPanelSize
    } = panelDataHelper(panelDataArray, panelData, layout2);
    if (prevPanelSize == null) {
      return;
    }
    if (prevCollapsible && nextCollapsible && fuzzyNumbersEqual$1(prevPanelSize, prevCollapsedSize)) {
      if (!fuzzyNumbersEqual$1(prevCollapsedSize, nextCollapsedSize)) {
        resizePanel2(panelData, nextCollapsedSize);
      }
    } else if (prevPanelSize < nextMinSize) {
      resizePanel2(panelData, nextMinSize);
    } else if (prevPanelSize > nextMaxSize) {
      resizePanel2(panelData, nextMaxSize);
    }
  }, [resizePanel2]);
  const startDragging = useCallback((dragHandleId, event) => {
    const {
      direction: direction2
    } = committedValuesRef.current;
    const {
      layout: layout2
    } = eagerValuesRef.current;
    if (!panelGroupElementRef.current) {
      return;
    }
    const handleElement = getResizeHandleElement(dragHandleId, panelGroupElementRef.current);
    assert(handleElement, `Drag handle element not found for id "${dragHandleId}"`);
    const initialCursorPosition = getResizeEventCursorPosition(direction2, event);
    setDragState({
      dragHandleId,
      dragHandleRect: handleElement.getBoundingClientRect(),
      initialCursorPosition,
      initialLayout: layout2
    });
  }, []);
  const stopDragging = useCallback(() => {
    setDragState(null);
  }, []);
  const unregisterPanel = useCallback((panelData) => {
    const {
      panelDataArray
    } = eagerValuesRef.current;
    const index2 = findPanelDataIndex(panelDataArray, panelData);
    if (index2 >= 0) {
      panelDataArray.splice(index2, 1);
      delete panelIdToLastNotifiedSizeMapRef.current[panelData.id];
      eagerValuesRef.current.panelDataArrayChanged = true;
      forceUpdate();
    }
  }, [forceUpdate]);
  const context = useMemo(() => ({
    collapsePanel,
    direction,
    dragState,
    expandPanel,
    getPanelSize,
    getPanelStyle,
    groupId,
    isPanelCollapsed,
    isPanelExpanded,
    reevaluatePanelConstraints,
    registerPanel,
    registerResizeHandle: registerResizeHandle2,
    resizePanel: resizePanel2,
    startDragging,
    stopDragging,
    unregisterPanel,
    panelGroupElement: panelGroupElementRef.current
  }), [collapsePanel, dragState, direction, expandPanel, getPanelSize, getPanelStyle, groupId, isPanelCollapsed, isPanelExpanded, reevaluatePanelConstraints, registerPanel, registerResizeHandle2, resizePanel2, startDragging, stopDragging, unregisterPanel]);
  const style = {
    display: "flex",
    flexDirection: direction === "horizontal" ? "row" : "column",
    height: "100%",
    overflow: "hidden",
    width: "100%"
  };
  return createElement$3(PanelGroupContext.Provider, {
    value: context
  }, createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: idFromProps,
    ref: panelGroupElementRef,
    style: {
      ...style,
      ...styleFromProps
    },
    // CSS selectors
    [DATA_ATTRIBUTES.group]: "",
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId
  }));
}
const PanelGroup$1 = forwardRef$3((props2, ref) => createElement$3(PanelGroupWithForwardedRef, {
  ...props2,
  forwardedRef: ref
}));
PanelGroupWithForwardedRef.displayName = "PanelGroup";
PanelGroup$1.displayName = "forwardRef(PanelGroup)";
function findPanelDataIndex(panelDataArray, panelData) {
  return panelDataArray.findIndex((prevPanelData) => prevPanelData === panelData || prevPanelData.id === panelData.id);
}
function panelDataHelper(panelDataArray, panelData, layout) {
  const panelIndex = findPanelDataIndex(panelDataArray, panelData);
  const isLastPanel = panelIndex === panelDataArray.length - 1;
  const pivotIndices = isLastPanel ? [panelIndex - 1, panelIndex] : [panelIndex, panelIndex + 1];
  const panelSize = layout[panelIndex];
  return {
    ...panelData.constraints,
    panelSize,
    pivotIndices
  };
}
function useWindowSplitterResizeHandlerBehavior({
  disabled,
  handleId,
  resizeHandler,
  panelGroupElement
}) {
  useEffect(() => {
    if (disabled || resizeHandler == null || panelGroupElement == null) {
      return;
    }
    const handleElement = getResizeHandleElement(handleId, panelGroupElement);
    if (handleElement == null) {
      return;
    }
    const onKeyDown = (event) => {
      if (event.defaultPrevented) {
        return;
      }
      switch (event.key) {
        case "ArrowDown":
        case "ArrowLeft":
        case "ArrowRight":
        case "ArrowUp":
        case "End":
        case "Home": {
          event.preventDefault();
          resizeHandler(event);
          break;
        }
        case "F6": {
          event.preventDefault();
          const groupId = handleElement.getAttribute(DATA_ATTRIBUTES.groupId);
          assert(groupId, `No group element found for id "${groupId}"`);
          const handles = getResizeHandleElementsForGroup(groupId, panelGroupElement);
          const index2 = getResizeHandleElementIndex(groupId, handleId, panelGroupElement);
          assert(index2 !== null, `No resize element found for id "${handleId}"`);
          const nextIndex = event.shiftKey ? index2 > 0 ? index2 - 1 : handles.length - 1 : index2 + 1 < handles.length ? index2 + 1 : 0;
          const nextHandle = handles[nextIndex];
          nextHandle.focus();
          break;
        }
      }
    };
    handleElement.addEventListener("keydown", onKeyDown);
    return () => {
      handleElement.removeEventListener("keydown", onKeyDown);
    };
  }, [panelGroupElement, disabled, handleId, resizeHandler]);
}
function PanelResizeHandle({
  children = null,
  className: classNameFromProps = "",
  disabled = false,
  hitAreaMargins,
  id: idFromProps,
  onBlur,
  onClick,
  onDragging,
  onFocus,
  onPointerDown,
  onPointerUp,
  style: styleFromProps = {},
  tabIndex = 0,
  tagName: Type = "div",
  ...rest2
}) {
  var _hitAreaMargins$coars, _hitAreaMargins$fine;
  const elementRef = useRef(null);
  const callbacksRef = useRef({
    onClick,
    onDragging,
    onPointerDown,
    onPointerUp
  });
  useEffect(() => {
    callbacksRef.current.onClick = onClick;
    callbacksRef.current.onDragging = onDragging;
    callbacksRef.current.onPointerDown = onPointerDown;
    callbacksRef.current.onPointerUp = onPointerUp;
  });
  const panelGroupContext = useContext(PanelGroupContext);
  if (panelGroupContext === null) {
    throw Error(`PanelResizeHandle components must be rendered within a PanelGroup container`);
  }
  const {
    direction,
    groupId,
    registerResizeHandle: registerResizeHandleWithParentGroup,
    startDragging,
    stopDragging,
    panelGroupElement
  } = panelGroupContext;
  const resizeHandleId = useUniqueId(idFromProps);
  const [state, setState] = useState("inactive");
  const [isFocused, setIsFocused] = useState(false);
  const [resizeHandler, setResizeHandler] = useState(null);
  const committedValuesRef = useRef({
    state
  });
  useIsomorphicLayoutEffect(() => {
    committedValuesRef.current.state = state;
  });
  useEffect(() => {
    if (disabled) {
      setResizeHandler(null);
    } else {
      const resizeHandler2 = registerResizeHandleWithParentGroup(resizeHandleId);
      setResizeHandler(() => resizeHandler2);
    }
  }, [disabled, resizeHandleId, registerResizeHandleWithParentGroup]);
  const coarseHitAreaMargins = (_hitAreaMargins$coars = hitAreaMargins === null || hitAreaMargins === void 0 ? void 0 : hitAreaMargins.coarse) !== null && _hitAreaMargins$coars !== void 0 ? _hitAreaMargins$coars : 15;
  const fineHitAreaMargins = (_hitAreaMargins$fine = hitAreaMargins === null || hitAreaMargins === void 0 ? void 0 : hitAreaMargins.fine) !== null && _hitAreaMargins$fine !== void 0 ? _hitAreaMargins$fine : 5;
  useEffect(() => {
    if (disabled || resizeHandler == null) {
      return;
    }
    const element2 = elementRef.current;
    assert(element2, "Element ref not attached");
    let didMove = false;
    const setResizeHandlerState = (action, isActive, event) => {
      if (!isActive) {
        setState("inactive");
        return;
      }
      switch (action) {
        case "down": {
          setState("drag");
          didMove = false;
          assert(event, 'Expected event to be defined for "down" action');
          startDragging(resizeHandleId, event);
          const {
            onDragging: onDragging2,
            onPointerDown: onPointerDown2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === void 0 ? void 0 : onDragging2(true);
          onPointerDown2 === null || onPointerDown2 === void 0 ? void 0 : onPointerDown2();
          break;
        }
        case "move": {
          const {
            state: state2
          } = committedValuesRef.current;
          didMove = true;
          if (state2 !== "drag") {
            setState("hover");
          }
          assert(event, 'Expected event to be defined for "move" action');
          resizeHandler(event);
          break;
        }
        case "up": {
          setState("hover");
          stopDragging();
          const {
            onClick: onClick2,
            onDragging: onDragging2,
            onPointerUp: onPointerUp2
          } = callbacksRef.current;
          onDragging2 === null || onDragging2 === void 0 ? void 0 : onDragging2(false);
          onPointerUp2 === null || onPointerUp2 === void 0 ? void 0 : onPointerUp2();
          if (!didMove) {
            onClick2 === null || onClick2 === void 0 ? void 0 : onClick2();
          }
          break;
        }
      }
    };
    return registerResizeHandle(resizeHandleId, element2, direction, {
      coarse: coarseHitAreaMargins,
      fine: fineHitAreaMargins
    }, setResizeHandlerState);
  }, [coarseHitAreaMargins, direction, disabled, fineHitAreaMargins, registerResizeHandleWithParentGroup, resizeHandleId, resizeHandler, startDragging, stopDragging]);
  useWindowSplitterResizeHandlerBehavior({
    disabled,
    handleId: resizeHandleId,
    resizeHandler,
    panelGroupElement
  });
  const style = {
    touchAction: "none",
    userSelect: "none"
  };
  return createElement$3(Type, {
    ...rest2,
    children,
    className: classNameFromProps,
    id: idFromProps,
    onBlur: () => {
      setIsFocused(false);
      onBlur === null || onBlur === void 0 ? void 0 : onBlur();
    },
    onFocus: () => {
      setIsFocused(true);
      onFocus === null || onFocus === void 0 ? void 0 : onFocus();
    },
    ref: elementRef,
    role: "separator",
    style: {
      ...style,
      ...styleFromProps
    },
    tabIndex,
    // CSS selectors
    [DATA_ATTRIBUTES.groupDirection]: direction,
    [DATA_ATTRIBUTES.groupId]: groupId,
    [DATA_ATTRIBUTES.resizeHandle]: "",
    [DATA_ATTRIBUTES.resizeHandleActive]: state === "drag" ? "pointer" : isFocused ? "keyboard" : void 0,
    [DATA_ATTRIBUTES.resizeHandleEnabled]: !disabled,
    [DATA_ATTRIBUTES.resizeHandleId]: resizeHandleId,
    [DATA_ATTRIBUTES.resizeHandleState]: state
  });
}
PanelResizeHandle.displayName = "PanelResizeHandle";
function ResizablePanelPair({
  panelA,
  panelB,
  preferredDirection = "horizontal",
  width = "100%",
  height = "100%",
  border = "1px solid"
}) {
  const panelContainerRef = React__default.useRef(null);
  const [direction, setDirection] = React__default.useState(preferredDirection);
  const grip = direction === "horizontal" ? /* @__PURE__ */ React__default.createElement(BsGripVertical, null) : /* @__PURE__ */ React__default.createElement(BsGripHorizontal, null);
  React__default.useEffect(() => {
    if (!panelContainerRef.current) {
      return;
    }
    const resizeObserver = new ResizeObserver((entries) => {
      for (const entry of entries) {
        const width2 = entry.contentRect.width;
        const desiredDirection = width2 < 430 ? "vertical" : preferredDirection;
        if (desiredDirection !== direction) {
          setDirection(desiredDirection);
        }
      }
    });
    resizeObserver.observe(panelContainerRef.current);
    return () => {
      resizeObserver.disconnect();
    };
  }, [direction, preferredDirection]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      ref: panelContainerRef,
      style: {
        width,
        height,
        border,
        boxSizing: "border-box"
      }
    },
    /* @__PURE__ */ React__default.createElement(PanelGroup$1, { direction }, /* @__PURE__ */ React__default.createElement(Panel, null, panelA), /* @__PURE__ */ React__default.createElement(
      PanelResizeHandle,
      {
        className: classNames("doenet-resizable-panel-handle", {
          vertical: direction === "vertical"
        }),
        "data-test": "contentPanelDragHandle"
      },
      grip
    ), /* @__PURE__ */ React__default.createElement(Panel, null, panelB))
  );
}
function ResizableCollapsiblePanelPair({
  mainPanel,
  subPanel,
  alwaysVisiblePanel,
  collapsedSize = 15,
  defaultSize,
  isOpen,
  setIsOpen
}) {
  const collapsablePanelRef = React__default.useRef(null);
  React__default.useEffect(() => {
    if (collapsablePanelRef.current) {
      if (isOpen) {
        collapsablePanelRef.current.expand();
      } else {
        collapsablePanelRef.current.collapse();
      }
    }
  }, [isOpen]);
  return /* @__PURE__ */ React__default.createElement("div", { style: { height: "100%", width: "100%", boxSizing: "border-box" } }, /* @__PURE__ */ React__default.createElement(PanelGroup$1, { direction: "vertical" }, /* @__PURE__ */ React__default.createElement(Panel, null, mainPanel), /* @__PURE__ */ React__default.createElement(
    PanelResizeHandle,
    {
      className: classNames(
        "doenet-resizable-panel-handle",
        "vertical",
        "collapsible",
        { isOpen }
      ),
      "data-test": "contentPanelDragHandle"
    },
    isOpen && /* @__PURE__ */ React__default.createElement(BsGripHorizontal, null)
  ), alwaysVisiblePanel, /* @__PURE__ */ React__default.createElement(
    Panel,
    {
      ref: collapsablePanelRef,
      collapsible: true,
      collapsedSize: 0,
      minSize: collapsedSize,
      defaultSize,
      onCollapse: () => {
        setIsOpen(false);
      },
      onExpand: () => {
        setIsOpen(true);
      }
    },
    subPanel
  )));
}
const CLASS_NAME = "doenet-ui-button";
function UiButton(props2) {
  let className = props2.className ? `${CLASS_NAME} ${props2.className}` : CLASS_NAME;
  return /* @__PURE__ */ React__default.createElement(Button$1, { ...props2, className });
}
let rangeFrom = [], rangeTo = [];
(() => {
  let numbers = "lc,34,7n,7,7b,19,,,,2,,2,,,20,b,1c,l,g,,2t,7,2,6,2,2,,4,z,,u,r,2j,b,1m,9,9,,o,4,,9,,3,,5,17,3,3b,f,,w,1j,,,,4,8,4,,3,7,a,2,t,,1m,,,,2,4,8,,9,,a,2,q,,2,2,1l,,4,2,4,2,2,3,3,,u,2,3,,b,2,1l,,4,5,,2,4,,k,2,m,6,,,1m,,,2,,4,8,,7,3,a,2,u,,1n,,,,c,,9,,14,,3,,1l,3,5,3,,4,7,2,b,2,t,,1m,,2,,2,,3,,5,2,7,2,b,2,s,2,1l,2,,,2,4,8,,9,,a,2,t,,20,,4,,2,3,,,8,,29,,2,7,c,8,2q,,2,9,b,6,22,2,r,,,,,,1j,e,,5,,2,5,b,,10,9,,2u,4,,6,,2,2,2,p,2,4,3,g,4,d,,2,2,6,,f,,jj,3,qa,3,t,3,t,2,u,2,1s,2,,7,8,,2,b,9,,19,3,3b,2,y,,3a,3,4,2,9,,6,3,63,2,2,,1m,,,7,,,,,2,8,6,a,2,,1c,h,1r,4,1c,7,,,5,,14,9,c,2,w,4,2,2,,3,1k,,,2,3,,,3,1m,8,2,2,48,3,,d,,7,4,,6,,3,2,5i,1m,,5,ek,,5f,x,2da,3,3x,,2o,w,fe,6,2x,2,n9w,4,,a,w,2,28,2,7k,,3,,4,,p,2,5,,47,2,q,i,d,,12,8,p,b,1a,3,1c,,2,4,2,2,13,,1v,6,2,2,2,2,c,,8,,1b,,1f,,,3,2,2,5,2,,,16,2,8,,6m,,2,,4,,fn4,,kh,g,g,g,a6,2,gt,,6a,,45,5,1ae,3,,2,5,4,14,3,4,,4l,2,fx,4,ar,2,49,b,4w,,1i,f,1k,3,1d,4,2,2,1x,3,10,5,,8,1q,,c,2,1g,9,a,4,2,,2n,3,2,,,2,6,,4g,,3,8,l,2,1l,2,,,,,m,,e,7,3,5,5f,8,2,3,,,n,,29,,2,6,,,2,,,2,,2,6j,,2,4,6,2,,2,r,2,2d,8,2,,,2,2y,,,,2,6,,,2t,3,2,4,,5,77,9,,2,6t,,a,2,,,4,,40,4,2,2,4,,w,a,14,6,2,4,8,,9,6,2,3,1a,d,,2,ba,7,,6,,,2a,m,2,7,,2,,2,3e,6,3,,,2,,7,,,20,2,3,,,,9n,2,f0b,5,1n,7,t4,,1r,4,29,,f5k,2,43q,,,3,4,5,8,8,2,7,u,4,44,3,1iz,1j,4,1e,8,,e,,m,5,,f,11s,7,,h,2,7,,2,,5,79,7,c5,4,15s,7,31,7,240,5,gx7k,2o,3k,6o".split(",").map((s2) => s2 ? parseInt(s2, 36) : 1);
  for (let i2 = 0, n2 = 0; i2 < numbers.length; i2++)
    (i2 % 2 ? rangeTo : rangeFrom).push(n2 = n2 + numbers[i2]);
})();
function isExtendingChar(code2) {
  if (code2 < 768) return false;
  for (let from = 0, to2 = rangeFrom.length; ; ) {
    let mid = from + to2 >> 1;
    if (code2 < rangeFrom[mid]) to2 = mid;
    else if (code2 >= rangeTo[mid]) from = mid + 1;
    else return true;
    if (from == to2) return false;
  }
}
function isRegionalIndicator(code2) {
  return code2 >= 127462 && code2 <= 127487;
}
const ZWJ = 8205;
function findClusterBreak$1(str, pos, forward = true, includeExtending = true) {
  return (forward ? nextClusterBreak : prevClusterBreak)(str, pos, includeExtending);
}
function nextClusterBreak(str, pos, includeExtending) {
  if (pos == str.length) return pos;
  if (pos && surrogateLow$1(str.charCodeAt(pos)) && surrogateHigh$1(str.charCodeAt(pos - 1))) pos--;
  let prev = codePointAt$1(str, pos);
  pos += codePointSize$1(prev);
  while (pos < str.length) {
    let next = codePointAt$1(str, pos);
    if (prev == ZWJ || next == ZWJ || includeExtending && isExtendingChar(next)) {
      pos += codePointSize$1(next);
      prev = next;
    } else if (isRegionalIndicator(next)) {
      let countBefore = 0, i2 = pos - 2;
      while (i2 >= 0 && isRegionalIndicator(codePointAt$1(str, i2))) {
        countBefore++;
        i2 -= 2;
      }
      if (countBefore % 2 == 0) break;
      else pos += 2;
    } else {
      break;
    }
  }
  return pos;
}
function prevClusterBreak(str, pos, includeExtending) {
  while (pos > 0) {
    let found = nextClusterBreak(str, pos - 2, includeExtending);
    if (found < pos) return found;
    pos--;
  }
  return 0;
}
function codePointAt$1(str, pos) {
  let code0 = str.charCodeAt(pos);
  if (!surrogateHigh$1(code0) || pos + 1 == str.length) return code0;
  let code1 = str.charCodeAt(pos + 1);
  if (!surrogateLow$1(code1)) return code0;
  return (code0 - 55296 << 10) + (code1 - 56320) + 65536;
}
function surrogateLow$1(ch) {
  return ch >= 56320 && ch < 57344;
}
function surrogateHigh$1(ch) {
  return ch >= 55296 && ch < 56320;
}
function codePointSize$1(code2) {
  return code2 < 65536 ? 1 : 2;
}
let Text$1 = class Text2 {
  /**
  Get the line description around the given position.
  */
  lineAt(pos) {
    if (pos < 0 || pos > this.length)
      throw new RangeError(`Invalid position ${pos} in document of length ${this.length}`);
    return this.lineInner(pos, false, 1, 0);
  }
  /**
  Get the description for the given (1-based) line number.
  */
  line(n2) {
    if (n2 < 1 || n2 > this.lines)
      throw new RangeError(`Invalid line number ${n2} in ${this.lines}-line document`);
    return this.lineInner(n2, true, 1, 0);
  }
  /**
  Replace a range of the text with the given content.
  */
  replace(from, to2, text2) {
    [from, to2] = clip(this, from, to2);
    let parts = [];
    this.decompose(
      0,
      from,
      parts,
      2
      /* Open.To */
    );
    if (text2.length)
      text2.decompose(
        0,
        text2.length,
        parts,
        1 | 2
        /* Open.To */
      );
    this.decompose(
      to2,
      this.length,
      parts,
      1
      /* Open.From */
    );
    return TextNode.from(parts, this.length - (to2 - from) + text2.length);
  }
  /**
  Append another document to this one.
  */
  append(other) {
    return this.replace(this.length, this.length, other);
  }
  /**
  Retrieve the text between the given points.
  */
  slice(from, to2 = this.length) {
    [from, to2] = clip(this, from, to2);
    let parts = [];
    this.decompose(from, to2, parts, 0);
    return TextNode.from(parts, to2 - from);
  }
  /**
  Test whether this text is equal to another instance.
  */
  eq(other) {
    if (other == this)
      return true;
    if (other.length != this.length || other.lines != this.lines)
      return false;
    let start = this.scanIdentical(other, 1), end = this.length - this.scanIdentical(other, -1);
    let a2 = new RawTextCursor(this), b2 = new RawTextCursor(other);
    for (let skip = start, pos = start; ; ) {
      a2.next(skip);
      b2.next(skip);
      skip = 0;
      if (a2.lineBreak != b2.lineBreak || a2.done != b2.done || a2.value != b2.value)
        return false;
      pos += a2.value.length;
      if (a2.done || pos >= end)
        return true;
    }
  }
  /**
  Iterate over the text. When `dir` is `-1`, iteration happens
  from end to start. This will return lines and the breaks between
  them as separate strings.
  */
  iter(dir = 1) {
    return new RawTextCursor(this, dir);
  }
  /**
  Iterate over a range of the text. When `from` > `to`, the
  iterator will run in reverse.
  */
  iterRange(from, to2 = this.length) {
    return new PartialTextCursor(this, from, to2);
  }
  /**
  Return a cursor that iterates over the given range of lines,
  _without_ returning the line breaks between, and yielding empty
  strings for empty lines.
  
  When `from` and `to` are given, they should be 1-based line numbers.
  */
  iterLines(from, to2) {
    let inner;
    if (from == null) {
      inner = this.iter();
    } else {
      if (to2 == null)
        to2 = this.lines + 1;
      let start = this.line(from).from;
      inner = this.iterRange(start, Math.max(start, to2 == this.lines + 1 ? this.length : to2 <= 1 ? 0 : this.line(to2 - 1).to));
    }
    return new LineCursor(inner);
  }
  /**
  Return the document as a string, using newline characters to
  separate lines.
  */
  toString() {
    return this.sliceString(0);
  }
  /**
  Convert the document to an array of lines (which can be
  deserialized again via [`Text.of`](https://codemirror.net/6/docs/ref/#state.Text^of)).
  */
  toJSON() {
    let lines = [];
    this.flatten(lines);
    return lines;
  }
  /**
  @internal
  */
  constructor() {
  }
  /**
  Create a `Text` instance for the given array of lines.
  */
  static of(text2) {
    if (text2.length == 0)
      throw new RangeError("A document must have at least one line");
    if (text2.length == 1 && !text2[0])
      return Text2.empty;
    return text2.length <= 32 ? new TextLeaf(text2) : TextNode.from(TextLeaf.split(text2, []));
  }
};
class TextLeaf extends Text$1 {
  constructor(text2, length = textLength(text2)) {
    super();
    this.text = text2;
    this.length = length;
  }
  get lines() {
    return this.text.length;
  }
  get children() {
    return null;
  }
  lineInner(target, isLine, line2, offset2) {
    for (let i2 = 0; ; i2++) {
      let string2 = this.text[i2], end = offset2 + string2.length;
      if ((isLine ? line2 : end) >= target)
        return new Line(offset2, end, line2, string2);
      offset2 = end + 1;
      line2++;
    }
  }
  decompose(from, to2, target, open) {
    let text2 = from <= 0 && to2 >= this.length ? this : new TextLeaf(sliceText(this.text, from, to2), Math.min(to2, this.length) - Math.max(0, from));
    if (open & 1) {
      let prev = target.pop();
      let joined = appendText(text2.text, prev.text.slice(), 0, text2.length);
      if (joined.length <= 32) {
        target.push(new TextLeaf(joined, prev.length + text2.length));
      } else {
        let mid = joined.length >> 1;
        target.push(new TextLeaf(joined.slice(0, mid)), new TextLeaf(joined.slice(mid)));
      }
    } else {
      target.push(text2);
    }
  }
  replace(from, to2, text2) {
    if (!(text2 instanceof TextLeaf))
      return super.replace(from, to2, text2);
    [from, to2] = clip(this, from, to2);
    let lines = appendText(this.text, appendText(text2.text, sliceText(this.text, 0, from)), to2);
    let newLen = this.length + text2.length - (to2 - from);
    if (lines.length <= 32)
      return new TextLeaf(lines, newLen);
    return TextNode.from(TextLeaf.split(lines, []), newLen);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    [from, to2] = clip(this, from, to2);
    let result2 = "";
    for (let pos = 0, i2 = 0; pos <= to2 && i2 < this.text.length; i2++) {
      let line2 = this.text[i2], end = pos + line2.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += line2.slice(Math.max(0, from - pos), to2 - pos);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let line2 of this.text)
      target.push(line2);
  }
  scanIdentical() {
    return 0;
  }
  static split(text2, target) {
    let part = [], len = -1;
    for (let line2 of text2) {
      part.push(line2);
      len += line2.length + 1;
      if (part.length == 32) {
        target.push(new TextLeaf(part, len));
        part = [];
        len = -1;
      }
    }
    if (len > -1)
      target.push(new TextLeaf(part, len));
    return target;
  }
}
class TextNode extends Text$1 {
  constructor(children, length) {
    super();
    this.children = children;
    this.length = length;
    this.lines = 0;
    for (let child of children)
      this.lines += child.lines;
  }
  lineInner(target, isLine, line2, offset2) {
    for (let i2 = 0; ; i2++) {
      let child = this.children[i2], end = offset2 + child.length, endLine = line2 + child.lines - 1;
      if ((isLine ? endLine : end) >= target)
        return child.lineInner(target, isLine, line2, offset2);
      offset2 = end + 1;
      line2 = endLine + 1;
    }
  }
  decompose(from, to2, target, open) {
    for (let i2 = 0, pos = 0; pos <= to2 && i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (from <= end && to2 >= pos) {
        let childOpen = open & ((pos <= from ? 1 : 0) | (end >= to2 ? 2 : 0));
        if (pos >= from && end <= to2 && !childOpen)
          target.push(child);
        else
          child.decompose(from - pos, to2 - pos, target, childOpen);
      }
      pos = end + 1;
    }
  }
  replace(from, to2, text2) {
    [from, to2] = clip(this, from, to2);
    if (text2.lines < this.lines)
      for (let i2 = 0, pos = 0; i2 < this.children.length; i2++) {
        let child = this.children[i2], end = pos + child.length;
        if (from >= pos && to2 <= end) {
          let updated = child.replace(from - pos, to2 - pos, text2);
          let totalLines = this.lines - child.lines + updated.lines;
          if (updated.lines < totalLines >> 5 - 1 && updated.lines > totalLines >> 5 + 1) {
            let copy2 = this.children.slice();
            copy2[i2] = updated;
            return new TextNode(copy2, this.length - (to2 - from) + text2.length);
          }
          return super.replace(pos, end, updated);
        }
        pos = end + 1;
      }
    return super.replace(from, to2, text2);
  }
  sliceString(from, to2 = this.length, lineSep = "\n") {
    [from, to2] = clip(this, from, to2);
    let result2 = "";
    for (let i2 = 0, pos = 0; i2 < this.children.length && pos <= to2; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos > from && i2)
        result2 += lineSep;
      if (from < end && to2 > pos)
        result2 += child.sliceString(from - pos, to2 - pos, lineSep);
      pos = end + 1;
    }
    return result2;
  }
  flatten(target) {
    for (let child of this.children)
      child.flatten(target);
  }
  scanIdentical(other, dir) {
    if (!(other instanceof TextNode))
      return 0;
    let length = 0;
    let [iA, iB, eA, eB] = dir > 0 ? [0, 0, this.children.length, other.children.length] : [this.children.length - 1, other.children.length - 1, -1, -1];
    for (; ; iA += dir, iB += dir) {
      if (iA == eA || iB == eB)
        return length;
      let chA = this.children[iA], chB = other.children[iB];
      if (chA != chB)
        return length + chA.scanIdentical(chB, dir);
      length += chA.length + 1;
    }
  }
  static from(children, length = children.reduce((l2, ch) => l2 + ch.length + 1, -1)) {
    let lines = 0;
    for (let ch of children)
      lines += ch.lines;
    if (lines < 32) {
      let flat = [];
      for (let ch of children)
        ch.flatten(flat);
      return new TextLeaf(flat, length);
    }
    let chunk2 = Math.max(
      32,
      lines >> 5
      /* Tree.BranchShift */
    ), maxChunk = chunk2 << 1, minChunk = chunk2 >> 1;
    let chunked = [], currentLines = 0, currentLen = -1, currentChunk = [];
    function add2(child) {
      let last2;
      if (child.lines > maxChunk && child instanceof TextNode) {
        for (let node of child.children)
          add2(node);
      } else if (child.lines > minChunk && (currentLines > minChunk || !currentLines)) {
        flush();
        chunked.push(child);
      } else if (child instanceof TextLeaf && currentLines && (last2 = currentChunk[currentChunk.length - 1]) instanceof TextLeaf && child.lines + last2.lines <= 32) {
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk[currentChunk.length - 1] = new TextLeaf(last2.text.concat(child.text), last2.length + 1 + child.length);
      } else {
        if (currentLines + child.lines > chunk2)
          flush();
        currentLines += child.lines;
        currentLen += child.length + 1;
        currentChunk.push(child);
      }
    }
    function flush() {
      if (currentLines == 0)
        return;
      chunked.push(currentChunk.length == 1 ? currentChunk[0] : TextNode.from(currentChunk, currentLen));
      currentLen = -1;
      currentLines = currentChunk.length = 0;
    }
    for (let child of children)
      add2(child);
    flush();
    return chunked.length == 1 ? chunked[0] : new TextNode(chunked, length);
  }
}
Text$1.empty = /* @__PURE__ */ new TextLeaf([""], 0);
function textLength(text2) {
  let length = -1;
  for (let line2 of text2)
    length += line2.length + 1;
  return length;
}
function appendText(text2, target, from = 0, to2 = 1e9) {
  for (let pos = 0, i2 = 0, first2 = true; i2 < text2.length && pos <= to2; i2++) {
    let line2 = text2[i2], end = pos + line2.length;
    if (end >= from) {
      if (end > to2)
        line2 = line2.slice(0, to2 - pos);
      if (pos < from)
        line2 = line2.slice(from - pos);
      if (first2) {
        target[target.length - 1] += line2;
        first2 = false;
      } else
        target.push(line2);
    }
    pos = end + 1;
  }
  return target;
}
function sliceText(text2, from, to2) {
  return appendText(text2, [""], from, to2);
}
class RawTextCursor {
  constructor(text2, dir = 1) {
    this.dir = dir;
    this.done = false;
    this.lineBreak = false;
    this.value = "";
    this.nodes = [text2];
    this.offsets = [dir > 0 ? 1 : (text2 instanceof TextLeaf ? text2.text.length : text2.children.length) << 1];
  }
  nextInner(skip, dir) {
    this.done = this.lineBreak = false;
    for (; ; ) {
      let last2 = this.nodes.length - 1;
      let top2 = this.nodes[last2], offsetValue = this.offsets[last2], offset2 = offsetValue >> 1;
      let size2 = top2 instanceof TextLeaf ? top2.text.length : top2.children.length;
      if (offset2 == (dir > 0 ? size2 : 0)) {
        if (last2 == 0) {
          this.done = true;
          this.value = "";
          return this;
        }
        if (dir > 0)
          this.offsets[last2 - 1]++;
        this.nodes.pop();
        this.offsets.pop();
      } else if ((offsetValue & 1) == (dir > 0 ? 0 : 1)) {
        this.offsets[last2] += dir;
        if (skip == 0) {
          this.lineBreak = true;
          this.value = "\n";
          return this;
        }
        skip--;
      } else if (top2 instanceof TextLeaf) {
        let next = top2.text[offset2 + (dir < 0 ? -1 : 0)];
        this.offsets[last2] += dir;
        if (next.length > Math.max(0, skip)) {
          this.value = skip == 0 ? next : dir > 0 ? next.slice(skip) : next.slice(0, next.length - skip);
          return this;
        }
        skip -= next.length;
      } else {
        let next = top2.children[offset2 + (dir < 0 ? -1 : 0)];
        if (skip > next.length) {
          skip -= next.length;
          this.offsets[last2] += dir;
        } else {
          if (dir < 0)
            this.offsets[last2]--;
          this.nodes.push(next);
          this.offsets.push(dir > 0 ? 1 : (next instanceof TextLeaf ? next.text.length : next.children.length) << 1);
        }
      }
    }
  }
  next(skip = 0) {
    if (skip < 0) {
      this.nextInner(-skip, -this.dir);
      skip = this.value.length;
    }
    return this.nextInner(skip, this.dir);
  }
}
class PartialTextCursor {
  constructor(text2, start, end) {
    this.value = "";
    this.done = false;
    this.cursor = new RawTextCursor(text2, start > end ? -1 : 1);
    this.pos = start > end ? text2.length : 0;
    this.from = Math.min(start, end);
    this.to = Math.max(start, end);
  }
  nextInner(skip, dir) {
    if (dir < 0 ? this.pos <= this.from : this.pos >= this.to) {
      this.value = "";
      this.done = true;
      return this;
    }
    skip += Math.max(0, dir < 0 ? this.pos - this.to : this.from - this.pos);
    let limit = dir < 0 ? this.pos - this.from : this.to - this.pos;
    if (skip > limit)
      skip = limit;
    limit -= skip;
    let { value } = this.cursor.next(skip);
    this.pos += (value.length + skip) * dir;
    this.value = value.length <= limit ? value : dir < 0 ? value.slice(value.length - limit) : value.slice(0, limit);
    this.done = !this.value;
    return this;
  }
  next(skip = 0) {
    if (skip < 0)
      skip = Math.max(skip, this.from - this.pos);
    else if (skip > 0)
      skip = Math.min(skip, this.to - this.pos);
    return this.nextInner(skip, this.cursor.dir);
  }
  get lineBreak() {
    return this.cursor.lineBreak && this.value != "";
  }
}
class LineCursor {
  constructor(inner) {
    this.inner = inner;
    this.afterBreak = true;
    this.value = "";
    this.done = false;
  }
  next(skip = 0) {
    let { done, lineBreak, value } = this.inner.next(skip);
    if (done && this.afterBreak) {
      this.value = "";
      this.afterBreak = false;
    } else if (done) {
      this.done = true;
      this.value = "";
    } else if (lineBreak) {
      if (this.afterBreak) {
        this.value = "";
      } else {
        this.afterBreak = true;
        this.next();
      }
    } else {
      this.value = value;
      this.afterBreak = false;
    }
    return this;
  }
  get lineBreak() {
    return false;
  }
}
if (typeof Symbol != "undefined") {
  Text$1.prototype[Symbol.iterator] = function() {
    return this.iter();
  };
  RawTextCursor.prototype[Symbol.iterator] = PartialTextCursor.prototype[Symbol.iterator] = LineCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
class Line {
  /**
  @internal
  */
  constructor(from, to2, number2, text2) {
    this.from = from;
    this.to = to2;
    this.number = number2;
    this.text = text2;
  }
  /**
  The length of the line (not including any line break after it).
  */
  get length() {
    return this.to - this.from;
  }
}
function clip(text2, from, to2) {
  from = Math.max(0, Math.min(text2.length, from));
  return [from, Math.max(from, Math.min(text2.length, to2))];
}
function findClusterBreak(str, pos, forward = true, includeExtending = true) {
  return findClusterBreak$1(str, pos, forward, includeExtending);
}
function surrogateLow(ch) {
  return ch >= 56320 && ch < 57344;
}
function surrogateHigh(ch) {
  return ch >= 55296 && ch < 56320;
}
function codePointAt(str, pos) {
  let code0 = str.charCodeAt(pos);
  if (!surrogateHigh(code0) || pos + 1 == str.length)
    return code0;
  let code1 = str.charCodeAt(pos + 1);
  if (!surrogateLow(code1))
    return code0;
  return (code0 - 55296 << 10) + (code1 - 56320) + 65536;
}
function fromCodePoint(code2) {
  if (code2 <= 65535)
    return String.fromCharCode(code2);
  code2 -= 65536;
  return String.fromCharCode((code2 >> 10) + 55296, (code2 & 1023) + 56320);
}
function codePointSize(code2) {
  return code2 < 65536 ? 1 : 2;
}
const DefaultSplit = /\r\n?|\n/;
var MapMode = /* @__PURE__ */ (function(MapMode2) {
  MapMode2[MapMode2["Simple"] = 0] = "Simple";
  MapMode2[MapMode2["TrackDel"] = 1] = "TrackDel";
  MapMode2[MapMode2["TrackBefore"] = 2] = "TrackBefore";
  MapMode2[MapMode2["TrackAfter"] = 3] = "TrackAfter";
  return MapMode2;
})(MapMode || (MapMode = {}));
class ChangeDesc {
  // Sections are encoded as pairs of integers. The first is the
  // length in the current document, and the second is -1 for
  // unaffected sections, and the length of the replacement content
  // otherwise. So an insertion would be (0, n>0), a deletion (n>0,
  // 0), and a replacement two positive numbers.
  /**
  @internal
  */
  constructor(sections) {
    this.sections = sections;
  }
  /**
  The length of the document before the change.
  */
  get length() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2)
      result2 += this.sections[i2];
    return result2;
  }
  /**
  The length of the document after the change.
  */
  get newLength() {
    let result2 = 0;
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let ins = this.sections[i2 + 1];
      result2 += ins < 0 ? this.sections[i2] : ins;
    }
    return result2;
  }
  /**
  False when there are actual changes in this set.
  */
  get empty() {
    return this.sections.length == 0 || this.sections.length == 2 && this.sections[1] < 0;
  }
  /**
  Iterate over the unchanged parts left by these changes. `posA`
  provides the position of the range in the old document, `posB`
  the new position in the changed document.
  */
  iterGaps(f2) {
    for (let i2 = 0, posA = 0, posB = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0) {
        f2(posA, posB, len);
        posB += len;
      } else {
        posB += ins;
      }
      posA += len;
    }
  }
  /**
  Iterate over the ranges changed by these changes. (See
  [`ChangeSet.iterChanges`](https://codemirror.net/6/docs/ref/#state.ChangeSet.iterChanges) for a
  variant that also provides you with the inserted text.)
  `fromA`/`toA` provides the extent of the change in the starting
  document, `fromB`/`toB` the extent of the replacement in the
  changed document.
  
  When `individual` is true, adjacent changes (which are kept
  separate for [position mapping](https://codemirror.net/6/docs/ref/#state.ChangeDesc.mapPos)) are
  reported separately.
  */
  iterChangedRanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  /**
  Get a description of the inverted form of these changes.
  */
  get invertedDesc() {
    let sections = [];
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      if (ins < 0)
        sections.push(len, ins);
      else
        sections.push(ins, len);
    }
    return new ChangeDesc(sections);
  }
  /**
  Compute the combined effect of applying another set of changes
  after this one. The length of the document after this set should
  match the length before `other`.
  */
  composeDesc(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other);
  }
  /**
  Map this description, which should start with the same document
  as `other`, over another set of changes, so that it can be
  applied after it. When `before` is true, map as if the changes
  in `this` happened before the ones in `other`.
  */
  mapDesc(other, before2 = false) {
    return other.empty ? this : mapSet(this, other, before2);
  }
  mapPos(pos, assoc = -1, mode = MapMode.Simple) {
    let posA = 0, posB = 0;
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++], endA = posA + len;
      if (ins < 0) {
        if (endA > pos)
          return posB + (pos - posA);
        posB += len;
      } else {
        if (mode != MapMode.Simple && endA >= pos && (mode == MapMode.TrackDel && posA < pos && endA > pos || mode == MapMode.TrackBefore && posA < pos || mode == MapMode.TrackAfter && endA > pos))
          return null;
        if (endA > pos || endA == pos && assoc < 0 && !len)
          return pos == posA || assoc < 0 ? posB : posB + ins;
        posB += ins;
      }
      posA = endA;
    }
    if (pos > posA)
      throw new RangeError(`Position ${pos} is out of range for changeset of length ${posA}`);
    return posB;
  }
  /**
  Check whether these changes touch a given range. When one of the
  changes entirely covers the range, the string `"cover"` is
  returned.
  */
  touchesRange(from, to2 = from) {
    for (let i2 = 0, pos = 0; i2 < this.sections.length && pos <= to2; ) {
      let len = this.sections[i2++], ins = this.sections[i2++], end = pos + len;
      if (ins >= 0 && pos <= to2 && end >= from)
        return pos < from && end > to2 ? "cover" : true;
      pos = end;
    }
    return false;
  }
  /**
  @internal
  */
  toString() {
    let result2 = "";
    for (let i2 = 0; i2 < this.sections.length; ) {
      let len = this.sections[i2++], ins = this.sections[i2++];
      result2 += (result2 ? " " : "") + len + (ins >= 0 ? ":" + ins : "");
    }
    return result2;
  }
  /**
  Serialize this change desc to a JSON-representable value.
  */
  toJSON() {
    return this.sections;
  }
  /**
  Create a change desc from its JSON representation (as produced
  by [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeDesc.toJSON).
  */
  static fromJSON(json) {
    if (!Array.isArray(json) || json.length % 2 || json.some((a2) => typeof a2 != "number"))
      throw new RangeError("Invalid JSON representation of ChangeDesc");
    return new ChangeDesc(json);
  }
  /**
  @internal
  */
  static create(sections) {
    return new ChangeDesc(sections);
  }
}
class ChangeSet extends ChangeDesc {
  constructor(sections, inserted) {
    super(sections);
    this.inserted = inserted;
  }
  /**
  Apply the changes to a document, returning the modified
  document.
  */
  apply(doc2) {
    if (this.length != doc2.length)
      throw new RangeError("Applying change set to a document with the wrong length");
    iterChanges(this, (fromA, toA, fromB, _toB, text2) => doc2 = doc2.replace(fromB, fromB + (toA - fromA), text2), false);
    return doc2;
  }
  mapDesc(other, before2 = false) {
    return mapSet(this, other, before2, true);
  }
  /**
  Given the document as it existed _before_ the changes, return a
  change set that represents the inverse of this set, which could
  be used to go from the document created by the changes back to
  the document as it existed before the changes.
  */
  invert(doc2) {
    let sections = this.sections.slice(), inserted = [];
    for (let i2 = 0, pos = 0; i2 < sections.length; i2 += 2) {
      let len = sections[i2], ins = sections[i2 + 1];
      if (ins >= 0) {
        sections[i2] = ins;
        sections[i2 + 1] = len;
        let index2 = i2 >> 1;
        while (inserted.length < index2)
          inserted.push(Text$1.empty);
        inserted.push(len ? doc2.slice(pos, pos + len) : Text$1.empty);
      }
      pos += len;
    }
    return new ChangeSet(sections, inserted);
  }
  /**
  Combine two subsequent change sets into a single set. `other`
  must start in the document produced by `this`. If `this` goes
  `docA` → `docB` and `other` represents `docB` → `docC`, the
  returned value will represent the change `docA` → `docC`.
  */
  compose(other) {
    return this.empty ? other : other.empty ? this : composeSets(this, other, true);
  }
  /**
  Given another change set starting in the same document, maps this
  change set over the other, producing a new change set that can be
  applied to the document produced by applying `other`. When
  `before` is `true`, order changes as if `this` comes before
  `other`, otherwise (the default) treat `other` as coming first.
  
  Given two changes `A` and `B`, `A.compose(B.map(A))` and
  `B.compose(A.map(B, true))` will produce the same document. This
  provides a basic form of [operational
  transformation](https://en.wikipedia.org/wiki/Operational_transformation),
  and can be used for collaborative editing.
  */
  map(other, before2 = false) {
    return other.empty ? this : mapSet(this, other, before2, true);
  }
  /**
  Iterate over the changed ranges in the document, calling `f` for
  each, with the range in the original document (`fromA`-`toA`)
  and the range that replaces it in the new document
  (`fromB`-`toB`).
  
  When `individual` is true, adjacent changes are reported
  separately.
  */
  iterChanges(f2, individual = false) {
    iterChanges(this, f2, individual);
  }
  /**
  Get a [change description](https://codemirror.net/6/docs/ref/#state.ChangeDesc) for this change
  set.
  */
  get desc() {
    return ChangeDesc.create(this.sections);
  }
  /**
  @internal
  */
  filter(ranges) {
    let resultSections = [], resultInserted = [], filteredSections = [];
    let iter = new SectionIter(this);
    done: for (let i2 = 0, pos = 0; ; ) {
      let next = i2 == ranges.length ? 1e9 : ranges[i2++];
      while (pos < next || pos == next && iter.len == 0) {
        if (iter.done)
          break done;
        let len = Math.min(iter.len, next - pos);
        addSection(filteredSections, len, -1);
        let ins = iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0;
        addSection(resultSections, len, ins);
        if (ins > 0)
          addInsert(resultInserted, resultSections, iter.text);
        iter.forward(len);
        pos += len;
      }
      let end = ranges[i2++];
      while (pos < end) {
        if (iter.done)
          break done;
        let len = Math.min(iter.len, end - pos);
        addSection(resultSections, len, -1);
        addSection(filteredSections, len, iter.ins == -1 ? -1 : iter.off == 0 ? iter.ins : 0);
        iter.forward(len);
        pos += len;
      }
    }
    return {
      changes: new ChangeSet(resultSections, resultInserted),
      filtered: ChangeDesc.create(filteredSections)
    };
  }
  /**
  Serialize this change set to a JSON-representable value.
  */
  toJSON() {
    let parts = [];
    for (let i2 = 0; i2 < this.sections.length; i2 += 2) {
      let len = this.sections[i2], ins = this.sections[i2 + 1];
      if (ins < 0)
        parts.push(len);
      else if (ins == 0)
        parts.push([len]);
      else
        parts.push([len].concat(this.inserted[i2 >> 1].toJSON()));
    }
    return parts;
  }
  /**
  Create a change set for the given changes, for a document of the
  given length, using `lineSep` as line separator.
  */
  static of(changes, length, lineSep) {
    let sections = [], inserted = [], pos = 0;
    let total = null;
    function flush(force = false) {
      if (!force && !sections.length)
        return;
      if (pos < length)
        addSection(sections, length - pos, -1);
      let set2 = new ChangeSet(sections, inserted);
      total = total ? total.compose(set2.map(total)) : set2;
      sections = [];
      inserted = [];
      pos = 0;
    }
    function process2(spec) {
      if (Array.isArray(spec)) {
        for (let sub2 of spec)
          process2(sub2);
      } else if (spec instanceof ChangeSet) {
        if (spec.length != length)
          throw new RangeError(`Mismatched change set length (got ${spec.length}, expected ${length})`);
        flush();
        total = total ? total.compose(spec.map(total)) : spec;
      } else {
        let { from, to: to2 = from, insert: insert2 } = spec;
        if (from > to2 || from < 0 || to2 > length)
          throw new RangeError(`Invalid change range ${from} to ${to2} (in doc of length ${length})`);
        let insText = !insert2 ? Text$1.empty : typeof insert2 == "string" ? Text$1.of(insert2.split(lineSep || DefaultSplit)) : insert2;
        let insLen = insText.length;
        if (from == to2 && insLen == 0)
          return;
        if (from < pos)
          flush();
        if (from > pos)
          addSection(sections, from - pos, -1);
        addSection(sections, to2 - from, insLen);
        addInsert(inserted, sections, insText);
        pos = to2;
      }
    }
    process2(changes);
    flush(!total);
    return total;
  }
  /**
  Create an empty changeset of the given length.
  */
  static empty(length) {
    return new ChangeSet(length ? [length, -1] : [], []);
  }
  /**
  Create a changeset from its JSON representation (as produced by
  [`toJSON`](https://codemirror.net/6/docs/ref/#state.ChangeSet.toJSON).
  */
  static fromJSON(json) {
    if (!Array.isArray(json))
      throw new RangeError("Invalid JSON representation of ChangeSet");
    let sections = [], inserted = [];
    for (let i2 = 0; i2 < json.length; i2++) {
      let part = json[i2];
      if (typeof part == "number") {
        sections.push(part, -1);
      } else if (!Array.isArray(part) || typeof part[0] != "number" || part.some((e2, i3) => i3 && typeof e2 != "string")) {
        throw new RangeError("Invalid JSON representation of ChangeSet");
      } else if (part.length == 1) {
        sections.push(part[0], 0);
      } else {
        while (inserted.length < i2)
          inserted.push(Text$1.empty);
        inserted[i2] = Text$1.of(part.slice(1));
        sections.push(part[0], inserted[i2].length);
      }
    }
    return new ChangeSet(sections, inserted);
  }
  /**
  @internal
  */
  static createSet(sections, inserted) {
    return new ChangeSet(sections, inserted);
  }
}
function addSection(sections, len, ins, forceJoin = false) {
  if (len == 0 && ins <= 0)
    return;
  let last2 = sections.length - 2;
  if (last2 >= 0 && ins <= 0 && ins == sections[last2 + 1])
    sections[last2] += len;
  else if (last2 >= 0 && len == 0 && sections[last2] == 0)
    sections[last2 + 1] += ins;
  else if (forceJoin) {
    sections[last2] += len;
    sections[last2 + 1] += ins;
  } else
    sections.push(len, ins);
}
function addInsert(values2, sections, value) {
  if (value.length == 0)
    return;
  let index2 = sections.length - 2 >> 1;
  if (index2 < values2.length) {
    values2[values2.length - 1] = values2[values2.length - 1].append(value);
  } else {
    while (values2.length < index2)
      values2.push(Text$1.empty);
    values2.push(value);
  }
}
function iterChanges(desc, f2, individual) {
  let inserted = desc.inserted;
  for (let posA = 0, posB = 0, i2 = 0; i2 < desc.sections.length; ) {
    let len = desc.sections[i2++], ins = desc.sections[i2++];
    if (ins < 0) {
      posA += len;
      posB += len;
    } else {
      let endA = posA, endB = posB, text2 = Text$1.empty;
      for (; ; ) {
        endA += len;
        endB += ins;
        if (ins && inserted)
          text2 = text2.append(inserted[i2 - 2 >> 1]);
        if (individual || i2 == desc.sections.length || desc.sections[i2 + 1] < 0)
          break;
        len = desc.sections[i2++];
        ins = desc.sections[i2++];
      }
      f2(posA, endA, posB, endB, text2);
      posA = endA;
      posB = endB;
    }
  }
}
function mapSet(setA, setB, before2, mkSet = false) {
  let sections = [], insert2 = mkSet ? [] : null;
  let a2 = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let inserted = -1; ; ) {
    if (a2.done && b2.len || b2.done && a2.len) {
      throw new Error("Mismatched change set lengths");
    } else if (a2.ins == -1 && b2.ins == -1) {
      let len = Math.min(a2.len, b2.len);
      addSection(sections, len, -1);
      a2.forward(len);
      b2.forward(len);
    } else if (b2.ins >= 0 && (a2.ins < 0 || inserted == a2.i || a2.off == 0 && (b2.len < a2.len || b2.len == a2.len && !before2))) {
      let len = b2.len;
      addSection(sections, b2.ins, -1);
      while (len) {
        let piece = Math.min(a2.len, len);
        if (a2.ins >= 0 && inserted < a2.i && a2.len <= piece) {
          addSection(sections, 0, a2.ins);
          if (insert2)
            addInsert(insert2, sections, a2.text);
          inserted = a2.i;
        }
        a2.forward(piece);
        len -= piece;
      }
      b2.next();
    } else if (a2.ins >= 0) {
      let len = 0, left = a2.len;
      while (left) {
        if (b2.ins == -1) {
          let piece = Math.min(left, b2.len);
          len += piece;
          left -= piece;
          b2.forward(piece);
        } else if (b2.ins == 0 && b2.len < left) {
          left -= b2.len;
          b2.next();
        } else {
          break;
        }
      }
      addSection(sections, len, inserted < a2.i ? a2.ins : 0);
      if (insert2 && inserted < a2.i)
        addInsert(insert2, sections, a2.text);
      inserted = a2.i;
      a2.forward(a2.len - left);
    } else if (a2.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else {
      throw new Error("Mismatched change set lengths");
    }
  }
}
function composeSets(setA, setB, mkSet = false) {
  let sections = [];
  let insert2 = mkSet ? [] : null;
  let a2 = new SectionIter(setA), b2 = new SectionIter(setB);
  for (let open = false; ; ) {
    if (a2.done && b2.done) {
      return insert2 ? ChangeSet.createSet(sections, insert2) : ChangeDesc.create(sections);
    } else if (a2.ins == 0) {
      addSection(sections, a2.len, 0, open);
      a2.next();
    } else if (b2.len == 0 && !b2.done) {
      addSection(sections, 0, b2.ins, open);
      if (insert2)
        addInsert(insert2, sections, b2.text);
      b2.next();
    } else if (a2.done || b2.done) {
      throw new Error("Mismatched change set lengths");
    } else {
      let len = Math.min(a2.len2, b2.len), sectionLen = sections.length;
      if (a2.ins == -1) {
        let insB = b2.ins == -1 ? -1 : b2.off ? 0 : b2.ins;
        addSection(sections, len, insB, open);
        if (insert2 && insB)
          addInsert(insert2, sections, b2.text);
      } else if (b2.ins == -1) {
        addSection(sections, a2.off ? 0 : a2.len, len, open);
        if (insert2)
          addInsert(insert2, sections, a2.textBit(len));
      } else {
        addSection(sections, a2.off ? 0 : a2.len, b2.off ? 0 : b2.ins, open);
        if (insert2 && !b2.off)
          addInsert(insert2, sections, b2.text);
      }
      open = (a2.ins > len || b2.ins >= 0 && b2.len > len) && (open || sections.length > sectionLen);
      a2.forward2(len);
      b2.forward(len);
    }
  }
}
class SectionIter {
  constructor(set2) {
    this.set = set2;
    this.i = 0;
    this.next();
  }
  next() {
    let { sections } = this.set;
    if (this.i < sections.length) {
      this.len = sections[this.i++];
      this.ins = sections[this.i++];
    } else {
      this.len = 0;
      this.ins = -2;
    }
    this.off = 0;
  }
  get done() {
    return this.ins == -2;
  }
  get len2() {
    return this.ins < 0 ? this.len : this.ins;
  }
  get text() {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length ? Text$1.empty : inserted[index2];
  }
  textBit(len) {
    let { inserted } = this.set, index2 = this.i - 2 >> 1;
    return index2 >= inserted.length && !len ? Text$1.empty : inserted[index2].slice(this.off, len == null ? void 0 : this.off + len);
  }
  forward(len) {
    if (len == this.len)
      this.next();
    else {
      this.len -= len;
      this.off += len;
    }
  }
  forward2(len) {
    if (this.ins == -1)
      this.forward(len);
    else if (len == this.ins)
      this.next();
    else {
      this.ins -= len;
      this.off += len;
    }
  }
}
let SelectionRange$1 = class SelectionRange2 {
  constructor(from, to2, flags, goalColumn) {
    this.from = from;
    this.to = to2;
    this.flags = flags;
    this.goalColumn = goalColumn;
  }
  /**
  The anchor of the range—the side that doesn't move when you
  extend it.
  */
  get anchor() {
    return this.flags & 32 ? this.to : this.from;
  }
  /**
  The head of the range, which is moved when the range is
  [extended](https://codemirror.net/6/docs/ref/#state.SelectionRange.extend).
  */
  get head() {
    return this.flags & 32 ? this.from : this.to;
  }
  /**
  True when `anchor` and `head` are at the same position.
  */
  get empty() {
    return this.from == this.to;
  }
  /**
  If this is a cursor that is explicitly associated with the
  character on one of its sides, this returns the side. -1 means
  the character before its position, 1 the character after, and 0
  means no association.
  */
  get assoc() {
    return this.flags & 8 ? -1 : this.flags & 16 ? 1 : 0;
  }
  /**
  A flag that, when set, makes some selection-extending commands
  treat the range's head and anchor as exchangeable, so that for
  example Shift-ArrowUp will make the lower side of the selection
  the anchor, even if that was the head before. Used to implement
  MacOS-style undirectional selections.
  */
  get undirectional() {
    return (this.flags & 64) > 0;
  }
  /**
  The bidirectional text level associated with this cursor, if
  any.
  */
  get bidiLevel() {
    let level = this.flags & 7;
    return level == 7 ? null : level;
  }
  /**
  Map this range through a change, producing a valid range in the
  updated document.
  */
  map(change, assoc = -1) {
    let from, to2;
    if (this.empty) {
      from = to2 = change.mapPos(this.from, assoc);
    } else {
      from = change.mapPos(this.from, 1);
      to2 = change.mapPos(this.to, -1);
    }
    return from == this.from && to2 == this.to ? this : new SelectionRange2(from, to2, this.flags, this.goalColumn);
  }
  /**
  Extend this range to cover at least `from` to `to`.
  */
  extend(from, to2 = from, assoc = 0) {
    if (from <= this.anchor && to2 >= this.anchor)
      return EditorSelection.range(from, to2, void 0, void 0, assoc);
    let head = Math.abs(from - this.anchor) > Math.abs(to2 - this.anchor) ? from : to2;
    return EditorSelection.range(this.anchor, head, void 0, void 0, assoc);
  }
  /**
  Compare this range to another range.
  */
  eq(other, includeAssoc = false) {
    return this.anchor == other.anchor && this.head == other.head && this.goalColumn == other.goalColumn && (!includeAssoc || !this.empty || this.assoc == other.assoc);
  }
  /**
  Return a JSON-serializable object representing the range.
  */
  toJSON() {
    return { anchor: this.anchor, head: this.head };
  }
  /**
  Convert a JSON representation of a range to a `SelectionRange`
  instance.
  */
  static fromJSON(json) {
    if (!json || typeof json.anchor != "number" || typeof json.head != "number")
      throw new RangeError("Invalid JSON representation for SelectionRange");
    return EditorSelection.range(json.anchor, json.head);
  }
  /**
  @internal
  */
  static create(from, to2, flags, goalColumn) {
    return new SelectionRange2(from, to2, flags, goalColumn);
  }
};
class EditorSelection {
  constructor(ranges, mainIndex) {
    this.ranges = ranges;
    this.mainIndex = mainIndex;
  }
  /**
  Map a selection through a change. Used to adjust the selection
  position for changes.
  */
  map(change, assoc = -1) {
    if (change.empty)
      return this;
    return EditorSelection.create(this.ranges.map((r2) => r2.map(change, assoc)), this.mainIndex);
  }
  /**
  Compare this selection to another selection. By default, ranges
  are compared only by position. When `includeAssoc` is true,
  cursor ranges must also have the same
  [`assoc`](https://codemirror.net/6/docs/ref/#state.SelectionRange.assoc) value.
  */
  eq(other, includeAssoc = false) {
    if (this.ranges.length != other.ranges.length || this.mainIndex != other.mainIndex)
      return false;
    for (let i2 = 0; i2 < this.ranges.length; i2++)
      if (!this.ranges[i2].eq(other.ranges[i2], includeAssoc))
        return false;
    return true;
  }
  /**
  Get the primary selection range. Usually, you should make sure
  your code applies to _all_ ranges, by using methods like
  [`changeByRange`](https://codemirror.net/6/docs/ref/#state.EditorState.changeByRange).
  */
  get main() {
    return this.ranges[this.mainIndex];
  }
  /**
  Make sure the selection only has one range. Returns a selection
  holding only the main range from this selection.
  */
  asSingle() {
    return this.ranges.length == 1 ? this : new EditorSelection([this.main], 0);
  }
  /**
  Extend this selection with an extra range.
  */
  addRange(range2, main2 = true) {
    return EditorSelection.create([range2].concat(this.ranges), main2 ? 0 : this.mainIndex + 1);
  }
  /**
  Replace a given range with another range, and then normalize the
  selection to merge and sort ranges if necessary.
  */
  replaceRange(range2, which = this.mainIndex) {
    let ranges = this.ranges.slice();
    ranges[which] = range2;
    return EditorSelection.create(ranges, this.mainIndex);
  }
  /**
  Convert this selection to an object that can be serialized to
  JSON.
  */
  toJSON() {
    return { ranges: this.ranges.map((r2) => r2.toJSON()), main: this.mainIndex };
  }
  /**
  Create a selection from a JSON representation.
  */
  static fromJSON(json) {
    if (!json || !Array.isArray(json.ranges) || typeof json.main != "number" || json.main >= json.ranges.length)
      throw new RangeError("Invalid JSON representation for EditorSelection");
    return new EditorSelection(json.ranges.map((r2) => SelectionRange$1.fromJSON(r2)), json.main);
  }
  /**
  Create a selection holding a single range.
  */
  static single(anchor, head = anchor) {
    return new EditorSelection([EditorSelection.range(anchor, head)], 0);
  }
  /**
  Sort and merge the given set of ranges, creating a valid
  selection.
  */
  static create(ranges, mainIndex = 0) {
    if (ranges.length == 0)
      throw new RangeError("A selection needs at least one range");
    for (let pos = 0, i2 = 0; i2 < ranges.length; i2++) {
      let range2 = ranges[i2];
      if (range2.empty ? range2.from <= pos : range2.from < pos)
        return EditorSelection.normalized(ranges.slice(), mainIndex);
      pos = range2.to;
    }
    return new EditorSelection(ranges, mainIndex);
  }
  /**
  Create a cursor selection range at the given position. You can
  safely ignore the optional arguments in most situations.
  */
  static cursor(pos, assoc = 0, bidiLevel, goalColumn) {
    return SelectionRange$1.create(pos, pos, (assoc == 0 ? 0 : assoc < 0 ? 8 : 16) | (bidiLevel == null ? 7 : Math.min(6, bidiLevel)), goalColumn);
  }
  /**
  Create a selection range.
  */
  static range(anchor, head, goalColumn, bidiLevel, assoc) {
    let flags = bidiLevel == null ? 7 : Math.min(6, bidiLevel);
    if (!assoc && anchor != head)
      assoc = head < anchor ? 1 : -1;
    if (assoc)
      flags |= assoc < 0 ? 8 : 16;
    return head < anchor ? SelectionRange$1.create(head, anchor, flags | 32, goalColumn) : SelectionRange$1.create(anchor, head, flags, goalColumn);
  }
  /**
  Create an [undirectional](https://codemirror.net/6/docs/ref/#state.SelectionRange.undirectional)
  selection range.
  */
  static undirectionalRange(from, to2) {
    return SelectionRange$1.create(from, to2, 64, void 0);
  }
  /**
  @internal
  */
  static normalized(ranges, mainIndex = 0) {
    let main2 = ranges[mainIndex];
    ranges.sort((a2, b2) => a2.from - b2.from);
    mainIndex = ranges.indexOf(main2);
    for (let i2 = 1; i2 < ranges.length; i2++) {
      let range2 = ranges[i2], prev = ranges[i2 - 1];
      if (range2.empty ? range2.from <= prev.to : range2.from < prev.to) {
        let from = prev.from, to2 = Math.max(range2.to, prev.to);
        if (i2 <= mainIndex)
          mainIndex--;
        ranges.splice(--i2, 2, range2.anchor > range2.head ? EditorSelection.range(to2, from) : EditorSelection.range(from, to2));
      }
    }
    return new EditorSelection(ranges, mainIndex);
  }
}
function checkSelection(selection2, docLength) {
  for (let range2 of selection2.ranges)
    if (range2.to > docLength)
      throw new RangeError("Selection points outside of document");
}
let nextID = 0;
class Facet {
  constructor(combine, compareInput, compare2, isStatic, enables) {
    this.combine = combine;
    this.compareInput = compareInput;
    this.compare = compare2;
    this.isStatic = isStatic;
    this.id = nextID++;
    this.default = combine([]);
    this.extensions = typeof enables == "function" ? enables(this) : enables;
  }
  /**
  Returns a facet reader for this facet, which can be used to
  [read](https://codemirror.net/6/docs/ref/#state.EditorState.facet) it but not to define values for it.
  */
  get reader() {
    return this;
  }
  /**
  Define a new facet.
  */
  static define(config2 = {}) {
    return new Facet(config2.combine || ((a2) => a2), config2.compareInput || ((a2, b2) => a2 === b2), config2.compare || (!config2.combine ? sameArray$1 : (a2, b2) => a2 === b2), !!config2.static, config2.enables);
  }
  /**
  Returns an extension that adds the given value to this facet.
  */
  of(value) {
    return new FacetProvider([], this, 0, value);
  }
  /**
  Create an extension that computes a value for the facet from a
  state. You must take care to declare the parts of the state that
  this value depends on, since your function is only called again
  for a new state when one of those parts changed.
  
  In cases where your value depends only on a single field, you'll
  want to use the [`from`](https://codemirror.net/6/docs/ref/#state.Facet.from) method instead.
  */
  compute(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 1, get2);
  }
  /**
  Create an extension that computes zero or more values for this
  facet from a state.
  */
  computeN(deps, get2) {
    if (this.isStatic)
      throw new Error("Can't compute a static facet");
    return new FacetProvider(deps, this, 2, get2);
  }
  from(field, get2) {
    if (!get2)
      get2 = (x2) => x2;
    return this.compute([field], (state) => get2(state.field(field)));
  }
}
function sameArray$1(a2, b2) {
  return a2 == b2 || a2.length == b2.length && a2.every((e2, i2) => e2 === b2[i2]);
}
class FacetProvider {
  constructor(dependencies2, facet, type, value) {
    this.dependencies = dependencies2;
    this.facet = facet;
    this.type = type;
    this.value = value;
    this.id = nextID++;
  }
  dynamicSlot(addresses) {
    var _a2;
    let getter = this.value;
    let compare2 = this.facet.compareInput;
    let id2 = this.id, idx = addresses[id2] >> 1, multi = this.type == 2;
    let depDoc = false, depSel = false, depAddrs = [];
    for (let dep of this.dependencies) {
      if (dep == "doc")
        depDoc = true;
      else if (dep == "selection")
        depSel = true;
      else if ((((_a2 = addresses[dep.id]) !== null && _a2 !== void 0 ? _a2 : 1) & 1) == 0)
        depAddrs.push(addresses[dep.id]);
    }
    return {
      create(state) {
        state.values[idx] = getter(state);
        return 1;
      },
      update(state, tr2) {
        if (depDoc && tr2.docChanged || depSel && (tr2.docChanged || tr2.selection) || ensureAll(state, depAddrs)) {
          let newVal = getter(state);
          if (multi ? !compareArray(newVal, state.values[idx], compare2) : !compare2(newVal, state.values[idx])) {
            state.values[idx] = newVal;
            return 1;
          }
        }
        return 0;
      },
      reconfigure: (state, oldState) => {
        let newVal, oldAddr = oldState.config.address[id2];
        if (oldAddr != null) {
          let oldVal = getAddr(oldState, oldAddr);
          if (this.dependencies.every((dep) => {
            return dep instanceof Facet ? oldState.facet(dep) === state.facet(dep) : dep instanceof StateField ? oldState.field(dep, false) == state.field(dep, false) : true;
          }) || (multi ? compareArray(newVal = getter(state), oldVal, compare2) : compare2(newVal = getter(state), oldVal))) {
            state.values[idx] = oldVal;
            return 0;
          }
        } else {
          newVal = getter(state);
        }
        state.values[idx] = newVal;
        return 1;
      }
    };
  }
}
function compareArray(a2, b2, compare2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (!compare2(a2[i2], b2[i2]))
      return false;
  return true;
}
function ensureAll(state, addrs) {
  let changed = false;
  for (let addr of addrs)
    if (ensureAddr(state, addr) & 1)
      changed = true;
  return changed;
}
function dynamicFacetSlot(addresses, facet, providers) {
  let providerAddrs = providers.map((p2) => addresses[p2.id]);
  let providerTypes = providers.map((p2) => p2.type);
  let dynamic = providerAddrs.filter((p2) => !(p2 & 1));
  let idx = addresses[facet.id] >> 1;
  function get2(state) {
    let values2 = [];
    for (let i2 = 0; i2 < providerAddrs.length; i2++) {
      let value = getAddr(state, providerAddrs[i2]);
      if (providerTypes[i2] == 2)
        for (let val of value)
          values2.push(val);
      else
        values2.push(value);
    }
    return facet.combine(values2);
  }
  return {
    create(state) {
      for (let addr of providerAddrs)
        ensureAddr(state, addr);
      state.values[idx] = get2(state);
      return 1;
    },
    update(state, tr2) {
      if (!ensureAll(state, dynamic))
        return 0;
      let value = get2(state);
      if (facet.compare(value, state.values[idx]))
        return 0;
      state.values[idx] = value;
      return 1;
    },
    reconfigure(state, oldState) {
      let depChanged = ensureAll(state, providerAddrs);
      let oldProviders = oldState.config.facets[facet.id], oldValue = oldState.facet(facet);
      if (oldProviders && !depChanged && sameArray$1(providers, oldProviders)) {
        state.values[idx] = oldValue;
        return 0;
      }
      let value = get2(state);
      if (facet.compare(value, oldValue)) {
        state.values[idx] = oldValue;
        return 0;
      }
      state.values[idx] = value;
      return 1;
    }
  };
}
const initField = /* @__PURE__ */ Facet.define({ static: true });
class StateField {
  constructor(id2, createF, updateF, compareF, spec) {
    this.id = id2;
    this.createF = createF;
    this.updateF = updateF;
    this.compareF = compareF;
    this.spec = spec;
    this.provides = void 0;
  }
  /**
  Define a state field.
  */
  static define(config2) {
    let field = new StateField(nextID++, config2.create, config2.update, config2.compare || ((a2, b2) => a2 === b2), config2);
    if (config2.provide)
      field.provides = config2.provide(field);
    return field;
  }
  create(state) {
    let init2 = state.facet(initField).find((i2) => i2.field == this);
    return ((init2 === null || init2 === void 0 ? void 0 : init2.create) || this.createF)(state);
  }
  /**
  @internal
  */
  slot(addresses) {
    let idx = addresses[this.id] >> 1;
    return {
      create: (state) => {
        state.values[idx] = this.create(state);
        return 1;
      },
      update: (state, tr2) => {
        let oldVal = state.values[idx];
        let value = this.updateF(oldVal, tr2);
        if (this.compareF(oldVal, value))
          return 0;
        state.values[idx] = value;
        return 1;
      },
      reconfigure: (state, oldState) => {
        let init2 = state.facet(initField), oldInit = oldState.facet(initField), reInit;
        if ((reInit = init2.find((i2) => i2.field == this)) && reInit != oldInit.find((i2) => i2.field == this)) {
          state.values[idx] = reInit.create(state);
          return 1;
        }
        if (oldState.config.address[this.id] != null) {
          state.values[idx] = oldState.field(this);
          return 0;
        }
        state.values[idx] = this.create(state);
        return 1;
      }
    };
  }
  /**
  Returns an extension that enables this field and overrides the
  way it is initialized. Can be useful when you need to provide a
  non-default starting value for the field.
  */
  init(create2) {
    return [this, initField.of({ field: this, create: create2 })];
  }
  /**
  State field instances can be used as
  [`Extension`](https://codemirror.net/6/docs/ref/#state.Extension) values to enable the field in a
  given state.
  */
  get extension() {
    return this;
  }
}
const Prec_ = { lowest: 4, low: 3, default: 2, high: 1, highest: 0 };
function prec(value) {
  return (ext) => new PrecExtension(ext, value);
}
const Prec = {
  /**
  The highest precedence level, for extensions that should end up
  near the start of the precedence ordering.
  */
  highest: /* @__PURE__ */ prec(Prec_.highest),
  /**
  A higher-than-default precedence, for extensions that should
  come before those with default precedence.
  */
  high: /* @__PURE__ */ prec(Prec_.high),
  /**
  The default precedence, which is also used for extensions
  without an explicit precedence.
  */
  default: /* @__PURE__ */ prec(Prec_.default),
  /**
  A lower-than-default precedence.
  */
  low: /* @__PURE__ */ prec(Prec_.low),
  /**
  The lowest precedence level. Meant for things that should end up
  near the end of the extension order.
  */
  lowest: /* @__PURE__ */ prec(Prec_.lowest)
};
class PrecExtension {
  constructor(inner, prec2) {
    this.inner = inner;
    this.prec = prec2;
  }
}
class Compartment {
  /**
  Create an instance of this compartment to add to your [state
  configuration](https://codemirror.net/6/docs/ref/#state.EditorStateConfig.extensions).
  */
  of(ext) {
    return new CompartmentInstance(this, ext);
  }
  /**
  Create an [effect](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) that
  reconfigures this compartment.
  */
  reconfigure(content2) {
    return Compartment.reconfigure.of({ compartment: this, extension: content2 });
  }
  /**
  Get the current content of the compartment in the state, or
  `undefined` if it isn't present.
  */
  get(state) {
    return state.config.compartments.get(this);
  }
}
class CompartmentInstance {
  constructor(compartment, inner) {
    this.compartment = compartment;
    this.inner = inner;
  }
}
class Configuration {
  constructor(base2, compartments, dynamicSlots, address, staticValues, facets) {
    this.base = base2;
    this.compartments = compartments;
    this.dynamicSlots = dynamicSlots;
    this.address = address;
    this.staticValues = staticValues;
    this.facets = facets;
    this.statusTemplate = [];
    while (this.statusTemplate.length < dynamicSlots.length)
      this.statusTemplate.push(
        0
        /* SlotStatus.Unresolved */
      );
  }
  staticFacet(facet) {
    let addr = this.address[facet.id];
    return addr == null ? facet.default : this.staticValues[addr >> 1];
  }
  static resolve(base2, compartments, oldState) {
    let fields = [];
    let facets = /* @__PURE__ */ Object.create(null);
    let newCompartments = /* @__PURE__ */ new Map();
    for (let ext of flatten$6(base2, compartments, newCompartments)) {
      if (ext instanceof StateField)
        fields.push(ext);
      else
        (facets[ext.facet.id] || (facets[ext.facet.id] = [])).push(ext);
    }
    let address = /* @__PURE__ */ Object.create(null);
    let staticValues = [];
    let dynamicSlots = [];
    for (let field of fields) {
      address[field.id] = dynamicSlots.length << 1;
      dynamicSlots.push((a2) => field.slot(a2));
    }
    let oldFacets = oldState === null || oldState === void 0 ? void 0 : oldState.config.facets;
    for (let id2 in facets) {
      let providers = facets[id2], facet = providers[0].facet;
      let oldProviders = oldFacets && oldFacets[id2] || [];
      if (providers.every(
        (p2) => p2.type == 0
        /* Provider.Static */
      )) {
        address[facet.id] = staticValues.length << 1 | 1;
        if (sameArray$1(oldProviders, providers)) {
          staticValues.push(oldState.facet(facet));
        } else {
          let value = facet.combine(providers.map((p2) => p2.value));
          staticValues.push(oldState && facet.compare(value, oldState.facet(facet)) ? oldState.facet(facet) : value);
        }
      } else {
        for (let p2 of providers) {
          if (p2.type == 0) {
            address[p2.id] = staticValues.length << 1 | 1;
            staticValues.push(p2.value);
          } else {
            address[p2.id] = dynamicSlots.length << 1;
            dynamicSlots.push((a2) => p2.dynamicSlot(a2));
          }
        }
        address[facet.id] = dynamicSlots.length << 1;
        dynamicSlots.push((a2) => dynamicFacetSlot(a2, facet, providers));
      }
    }
    let dynamic = dynamicSlots.map((f2) => f2(address));
    return new Configuration(base2, newCompartments, dynamic, address, staticValues, facets);
  }
}
function flatten$6(extension, compartments, newCompartments) {
  let result2 = [[], [], [], [], []];
  let seen = /* @__PURE__ */ new Map();
  function inner(ext, prec2) {
    let known = seen.get(ext);
    if (known != null) {
      if (known <= prec2)
        return;
      let found = result2[known].indexOf(ext);
      if (found > -1)
        result2[known].splice(found, 1);
      if (ext instanceof CompartmentInstance)
        newCompartments.delete(ext.compartment);
    }
    seen.set(ext, prec2);
    if (Array.isArray(ext)) {
      for (let e2 of ext)
        inner(e2, prec2);
    } else if (ext instanceof CompartmentInstance) {
      if (newCompartments.has(ext.compartment))
        throw new RangeError(`Duplicate use of compartment in extensions`);
      let content2 = compartments.get(ext.compartment) || ext.inner;
      newCompartments.set(ext.compartment, content2);
      inner(content2, prec2);
    } else if (ext instanceof PrecExtension) {
      inner(ext.inner, ext.prec);
    } else if (ext instanceof StateField) {
      result2[prec2].push(ext);
      if (ext.provides)
        inner(ext.provides, prec2);
    } else if (ext instanceof FacetProvider) {
      result2[prec2].push(ext);
      if (ext.facet.extensions)
        inner(ext.facet.extensions, Prec_.default);
    } else {
      let content2 = ext.extension;
      if (!content2)
        throw new Error(`Unrecognized extension value in extension set (${ext}). This sometimes happens because multiple instances of @codemirror/state are loaded, breaking instanceof checks.`);
      inner(content2, prec2);
    }
  }
  inner(extension, Prec_.default);
  return result2.reduce((a2, b2) => a2.concat(b2));
}
function ensureAddr(state, addr) {
  if (addr & 1)
    return 2;
  let idx = addr >> 1;
  let status = state.status[idx];
  if (status == 4)
    throw new Error("Cyclic dependency between fields and/or facets");
  if (status & 2)
    return status;
  state.status[idx] = 4;
  let changed = state.computeSlot(state, state.config.dynamicSlots[idx]);
  return state.status[idx] = 2 | changed;
}
function getAddr(state, addr) {
  return addr & 1 ? state.config.staticValues[addr >> 1] : state.values[addr >> 1];
}
const languageData = /* @__PURE__ */ Facet.define();
const allowMultipleSelections = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((v2) => v2),
  static: true
});
const lineSeparator = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : void 0,
  static: true
});
const changeFilter = /* @__PURE__ */ Facet.define();
const transactionFilter = /* @__PURE__ */ Facet.define();
const transactionExtender = /* @__PURE__ */ Facet.define();
const readOnly = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : false
});
class Annotation {
  /**
  @internal
  */
  constructor(type, value) {
    this.type = type;
    this.value = value;
  }
  /**
  Define a new type of annotation.
  */
  static define() {
    return new AnnotationType();
  }
}
class AnnotationType {
  /**
  Create an instance of this annotation.
  */
  of(value) {
    return new Annotation(this, value);
  }
}
class StateEffectType {
  /**
  @internal
  */
  constructor(map2) {
    this.map = map2;
  }
  /**
  Create a [state effect](https://codemirror.net/6/docs/ref/#state.StateEffect) instance of this
  type.
  */
  of(value) {
    return new StateEffect(this, value);
  }
}
class StateEffect {
  /**
  @internal
  */
  constructor(type, value) {
    this.type = type;
    this.value = value;
  }
  /**
  Map this effect through a position mapping. Will return
  `undefined` when that ends up deleting the effect.
  */
  map(mapping) {
    let mapped = this.type.map(this.value, mapping);
    return mapped === void 0 ? void 0 : mapped == this.value ? this : new StateEffect(this.type, mapped);
  }
  /**
  Tells you whether this effect object is of a given
  [type](https://codemirror.net/6/docs/ref/#state.StateEffectType).
  */
  is(type) {
    return this.type == type;
  }
  /**
  Define a new effect type. The type parameter indicates the type
  of values that his effect holds. It should be a type that
  doesn't include `undefined`, since that is used in
  [mapping](https://codemirror.net/6/docs/ref/#state.StateEffect.map) to indicate that an effect is
  removed.
  */
  static define(spec = {}) {
    return new StateEffectType(spec.map || ((v2) => v2));
  }
  /**
  Map an array of effects through a change set.
  */
  static mapEffects(effects, mapping) {
    if (!effects.length)
      return effects;
    let result2 = [];
    for (let effect of effects) {
      let mapped = effect.map(mapping);
      if (mapped)
        result2.push(mapped);
    }
    return result2;
  }
}
StateEffect.reconfigure = /* @__PURE__ */ StateEffect.define();
StateEffect.appendConfig = /* @__PURE__ */ StateEffect.define();
class Transaction {
  constructor(startState, changes, selection2, effects, annotations, scrollIntoView2) {
    this.startState = startState;
    this.changes = changes;
    this.selection = selection2;
    this.effects = effects;
    this.annotations = annotations;
    this.scrollIntoView = scrollIntoView2;
    this._doc = null;
    this._state = null;
    if (selection2)
      checkSelection(selection2, changes.newLength);
    if (!annotations.some((a2) => a2.type == Transaction.time))
      this.annotations = annotations.concat(Transaction.time.of(Date.now()));
  }
  /**
  @internal
  */
  static create(startState, changes, selection2, effects, annotations, scrollIntoView2) {
    return new Transaction(startState, changes, selection2, effects, annotations, scrollIntoView2);
  }
  /**
  The new document produced by the transaction. Contrary to
  [`.state`](https://codemirror.net/6/docs/ref/#state.Transaction.state)`.doc`, accessing this won't
  force the entire new state to be computed right away, so it is
  recommended that [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) use this getter
  when they need to look at the new document.
  */
  get newDoc() {
    return this._doc || (this._doc = this.changes.apply(this.startState.doc));
  }
  /**
  The new selection produced by the transaction. If
  [`this.selection`](https://codemirror.net/6/docs/ref/#state.Transaction.selection) is undefined,
  this will [map](https://codemirror.net/6/docs/ref/#state.EditorSelection.map) the start state's
  current selection through the changes made by the transaction.
  */
  get newSelection() {
    return this.selection || this.startState.selection.map(this.changes);
  }
  /**
  The new state created by the transaction. Computed on demand
  (but retained for subsequent access), so it is recommended not to
  access it in [transaction
  filters](https://codemirror.net/6/docs/ref/#state.EditorState^transactionFilter) when possible.
  */
  get state() {
    if (!this._state)
      this.startState.applyTransaction(this);
    return this._state;
  }
  /**
  Get the value of the given annotation type, if any.
  */
  annotation(type) {
    for (let ann of this.annotations)
      if (ann.type == type)
        return ann.value;
    return void 0;
  }
  /**
  Indicates whether the transaction changed the document.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Indicates whether this transaction reconfigures the state
  (through a [configuration compartment](https://codemirror.net/6/docs/ref/#state.Compartment) or
  with a top-level configuration
  [effect](https://codemirror.net/6/docs/ref/#state.StateEffect^reconfigure).
  */
  get reconfigured() {
    return this.startState.config != this.state.config;
  }
  /**
  Returns true if the transaction has a [user
  event](https://codemirror.net/6/docs/ref/#state.Transaction^userEvent) annotation that is equal to
  or more specific than `event`. For example, if the transaction
  has `"select.pointer"` as user event, `"select"` and
  `"select.pointer"` will match it.
  */
  isUserEvent(event) {
    let e2 = this.annotation(Transaction.userEvent);
    return !!(e2 && (e2 == event || e2.length > event.length && e2.slice(0, event.length) == event && e2[event.length] == "."));
  }
}
Transaction.time = /* @__PURE__ */ Annotation.define();
Transaction.userEvent = /* @__PURE__ */ Annotation.define();
Transaction.addToHistory = /* @__PURE__ */ Annotation.define();
Transaction.remote = /* @__PURE__ */ Annotation.define();
function joinRanges(a2, b2) {
  let result2 = [];
  for (let iA = 0, iB = 0; ; ) {
    let from, to2;
    if (iA < a2.length && (iB == b2.length || b2[iB] >= a2[iA])) {
      from = a2[iA++];
      to2 = a2[iA++];
    } else if (iB < b2.length) {
      from = b2[iB++];
      to2 = b2[iB++];
    } else
      return result2;
    if (!result2.length || result2[result2.length - 1] < from)
      result2.push(from, to2);
    else if (result2[result2.length - 1] < to2)
      result2[result2.length - 1] = to2;
  }
}
function mergeTransaction(a2, b2, sequential) {
  var _a2;
  let mapForA, mapForB, changes;
  if (sequential) {
    mapForA = b2.changes;
    mapForB = ChangeSet.empty(b2.changes.length);
    changes = a2.changes.compose(b2.changes);
  } else {
    mapForA = b2.changes.map(a2.changes);
    mapForB = a2.changes.mapDesc(b2.changes, true);
    changes = a2.changes.compose(mapForA);
  }
  return {
    changes,
    selection: b2.selection ? b2.selection.map(mapForB) : (_a2 = a2.selection) === null || _a2 === void 0 ? void 0 : _a2.map(mapForA),
    effects: StateEffect.mapEffects(a2.effects, mapForA).concat(StateEffect.mapEffects(b2.effects, mapForB)),
    annotations: a2.annotations.length ? a2.annotations.concat(b2.annotations) : b2.annotations,
    scrollIntoView: a2.scrollIntoView || b2.scrollIntoView
  };
}
function resolveTransactionInner(state, spec, docSize) {
  let sel = spec.selection, annotations = asArray$1(spec.annotations);
  if (spec.userEvent)
    annotations = annotations.concat(Transaction.userEvent.of(spec.userEvent));
  return {
    changes: spec.changes instanceof ChangeSet ? spec.changes : ChangeSet.of(spec.changes || [], docSize, state.facet(lineSeparator)),
    selection: sel && (sel instanceof EditorSelection ? sel : EditorSelection.single(sel.anchor, sel.head)),
    effects: asArray$1(spec.effects),
    annotations,
    scrollIntoView: !!spec.scrollIntoView
  };
}
function resolveTransaction(state, specs, filter2) {
  let s2 = resolveTransactionInner(state, specs.length ? specs[0] : {}, state.doc.length);
  if (specs.length && specs[0].filter === false)
    filter2 = false;
  for (let i2 = 1; i2 < specs.length; i2++) {
    if (specs[i2].filter === false)
      filter2 = false;
    let seq = !!specs[i2].sequential;
    s2 = mergeTransaction(s2, resolveTransactionInner(state, specs[i2], seq ? s2.changes.newLength : state.doc.length), seq);
  }
  let tr2 = Transaction.create(state, s2.changes, s2.selection, s2.effects, s2.annotations, s2.scrollIntoView);
  return extendTransaction(filter2 ? filterTransaction(tr2) : tr2);
}
function filterTransaction(tr2) {
  let state = tr2.startState;
  let result2 = true;
  for (let filter2 of state.facet(changeFilter)) {
    let value = filter2(tr2);
    if (value === false) {
      result2 = false;
      break;
    }
    if (Array.isArray(value))
      result2 = result2 === true ? value : joinRanges(result2, value);
  }
  if (result2 !== true) {
    let changes, back;
    if (result2 === false) {
      back = tr2.changes.invertedDesc;
      changes = ChangeSet.empty(state.doc.length);
    } else {
      let filtered = tr2.changes.filter(result2);
      changes = filtered.changes;
      back = filtered.filtered.mapDesc(filtered.changes).invertedDesc;
    }
    tr2 = Transaction.create(state, changes, tr2.selection && tr2.selection.map(back), StateEffect.mapEffects(tr2.effects, back), tr2.annotations, tr2.scrollIntoView);
  }
  let filters = state.facet(transactionFilter);
  for (let i2 = filters.length - 1; i2 >= 0; i2--) {
    let filtered = filters[i2](tr2);
    if (filtered instanceof Transaction)
      tr2 = filtered;
    else if (Array.isArray(filtered) && filtered.length == 1 && filtered[0] instanceof Transaction)
      tr2 = filtered[0];
    else
      tr2 = resolveTransaction(state, asArray$1(filtered), false);
  }
  return tr2;
}
function extendTransaction(tr2) {
  let state = tr2.startState, extenders = state.facet(transactionExtender), spec = tr2;
  for (let i2 = extenders.length - 1; i2 >= 0; i2--) {
    let extension = extenders[i2](tr2);
    if (extension && Object.keys(extension).length)
      spec = mergeTransaction(spec, resolveTransactionInner(state, extension, tr2.changes.newLength), true);
  }
  return spec == tr2 ? tr2 : Transaction.create(state, tr2.changes, tr2.selection, spec.effects, spec.annotations, spec.scrollIntoView);
}
const none$2 = [];
function asArray$1(value) {
  return value == null ? none$2 : Array.isArray(value) ? value : [value];
}
var CharCategory = /* @__PURE__ */ (function(CharCategory2) {
  CharCategory2[CharCategory2["Word"] = 0] = "Word";
  CharCategory2[CharCategory2["Space"] = 1] = "Space";
  CharCategory2[CharCategory2["Other"] = 2] = "Other";
  return CharCategory2;
})(CharCategory || (CharCategory = {}));
const nonASCIISingleCaseWordChar = /[\u00df\u0587\u0590-\u05f4\u0600-\u06ff\u3040-\u309f\u30a0-\u30ff\u3400-\u4db5\u4e00-\u9fcc\uac00-\ud7af]/;
let wordChar;
try {
  wordChar = /* @__PURE__ */ new RegExp("[\\p{Alphabetic}\\p{Number}_]", "u");
} catch (_2) {
}
function hasWordChar(str) {
  if (wordChar)
    return wordChar.test(str);
  for (let i2 = 0; i2 < str.length; i2++) {
    let ch = str[i2];
    if (/\w/.test(ch) || ch > "" && (ch.toUpperCase() != ch.toLowerCase() || nonASCIISingleCaseWordChar.test(ch)))
      return true;
  }
  return false;
}
function makeCategorizer(wordChars) {
  return (char) => {
    if (!/\S/.test(char))
      return CharCategory.Space;
    if (hasWordChar(char))
      return CharCategory.Word;
    for (let i2 = 0; i2 < wordChars.length; i2++)
      if (char.indexOf(wordChars[i2]) > -1)
        return CharCategory.Word;
    return CharCategory.Other;
  };
}
class EditorState {
  constructor(config2, doc2, selection2, values2, computeSlot, tr2) {
    this.config = config2;
    this.doc = doc2;
    this.selection = selection2;
    this.values = values2;
    this.status = config2.statusTemplate.slice();
    this.computeSlot = computeSlot;
    if (tr2)
      tr2._state = this;
    for (let i2 = 0; i2 < this.config.dynamicSlots.length; i2++)
      ensureAddr(this, i2 << 1);
    this.computeSlot = null;
  }
  field(field, require2 = true) {
    let addr = this.config.address[field.id];
    if (addr == null) {
      if (require2)
        throw new RangeError("Field is not present in this state");
      return void 0;
    }
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  /**
  Create a [transaction](https://codemirror.net/6/docs/ref/#state.Transaction) that updates this
  state. Any number of [transaction specs](https://codemirror.net/6/docs/ref/#state.TransactionSpec)
  can be passed. Unless
  [`sequential`](https://codemirror.net/6/docs/ref/#state.TransactionSpec.sequential) is set, the
  [changes](https://codemirror.net/6/docs/ref/#state.TransactionSpec.changes) (if any) of each spec
  are assumed to start in the _current_ document (not the document
  produced by previous specs), and its
  [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection) and
  [effects](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) are assumed to refer
  to the document created by its _own_ changes. The resulting
  transaction contains the combined effect of all the different
  specs. For [selection](https://codemirror.net/6/docs/ref/#state.TransactionSpec.selection), later
  specs take precedence over earlier ones.
  */
  update(...specs) {
    return resolveTransaction(this, specs, true);
  }
  /**
  @internal
  */
  applyTransaction(tr2) {
    let conf = this.config, { base: base2, compartments } = conf;
    for (let effect of tr2.effects) {
      if (effect.is(Compartment.reconfigure)) {
        if (conf) {
          compartments = /* @__PURE__ */ new Map();
          conf.compartments.forEach((val, key) => compartments.set(key, val));
          conf = null;
        }
        compartments.set(effect.value.compartment, effect.value.extension);
      } else if (effect.is(StateEffect.reconfigure)) {
        conf = null;
        base2 = effect.value;
      } else if (effect.is(StateEffect.appendConfig)) {
        conf = null;
        base2 = asArray$1(base2).concat(effect.value);
      }
    }
    let startValues;
    if (!conf) {
      conf = Configuration.resolve(base2, compartments, this);
      let intermediateState = new EditorState(conf, this.doc, this.selection, conf.dynamicSlots.map(() => null), (state, slot) => slot.reconfigure(state, this), null);
      startValues = intermediateState.values;
    } else {
      startValues = tr2.startState.values.slice();
    }
    let selection2 = tr2.startState.facet(allowMultipleSelections) ? tr2.newSelection : tr2.newSelection.asSingle();
    new EditorState(conf, tr2.newDoc, selection2, startValues, (state, slot) => slot.update(state, tr2), tr2);
  }
  /**
  Create a [transaction spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec) that
  replaces every selection range with the given content.
  */
  replaceSelection(text2) {
    if (typeof text2 == "string")
      text2 = this.toText(text2);
    return this.changeByRange((range2) => ({
      changes: { from: range2.from, to: range2.to, insert: text2 },
      range: EditorSelection.cursor(range2.from + text2.length)
    }));
  }
  /**
  Create a set of changes and a new selection by running the given
  function for each range in the active selection. The function
  can return an optional set of changes (in the coordinate space
  of the start document), plus an updated range (in the coordinate
  space of the document produced by the call's own changes). This
  method will merge all the changes and ranges into a single
  changeset and selection, and return it as a [transaction
  spec](https://codemirror.net/6/docs/ref/#state.TransactionSpec), which can be passed to
  [`update`](https://codemirror.net/6/docs/ref/#state.EditorState.update).
  */
  changeByRange(f2) {
    let sel = this.selection;
    let result1 = f2(sel.ranges[0]);
    let changes = this.changes(result1.changes), ranges = [result1.range];
    let effects = asArray$1(result1.effects);
    for (let i2 = 1; i2 < sel.ranges.length; i2++) {
      let result2 = f2(sel.ranges[i2]);
      let newChanges = this.changes(result2.changes), newMapped = newChanges.map(changes);
      for (let j2 = 0; j2 < i2; j2++)
        ranges[j2] = ranges[j2].map(newMapped);
      let mapBy = changes.mapDesc(newChanges, true);
      ranges.push(result2.range.map(mapBy));
      changes = changes.compose(newMapped);
      effects = StateEffect.mapEffects(effects, newMapped).concat(StateEffect.mapEffects(asArray$1(result2.effects), mapBy));
    }
    return {
      changes,
      selection: EditorSelection.create(ranges, sel.mainIndex),
      effects
    };
  }
  /**
  Create a [change set](https://codemirror.net/6/docs/ref/#state.ChangeSet) from the given change
  description, taking the state's document length and line
  separator into account.
  */
  changes(spec = []) {
    if (spec instanceof ChangeSet)
      return spec;
    return ChangeSet.of(spec, this.doc.length, this.facet(EditorState.lineSeparator));
  }
  /**
  Using the state's [line
  separator](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator), create a
  [`Text`](https://codemirror.net/6/docs/ref/#state.Text) instance from the given string.
  */
  toText(string2) {
    return Text$1.of(string2.split(this.facet(EditorState.lineSeparator) || DefaultSplit));
  }
  /**
  Return the given range of the document as a string.
  */
  sliceDoc(from = 0, to2 = this.doc.length) {
    return this.doc.sliceString(from, to2, this.lineBreak);
  }
  /**
  Get the value of a state [facet](https://codemirror.net/6/docs/ref/#state.Facet).
  */
  facet(facet) {
    let addr = this.config.address[facet.id];
    if (addr == null)
      return facet.default;
    ensureAddr(this, addr);
    return getAddr(this, addr);
  }
  /**
  Convert this state to a JSON-serializable object. When custom
  fields should be serialized, you can pass them in as an object
  mapping property names (in the resulting object, which should
  not use `doc` or `selection`) to fields.
  */
  toJSON(fields) {
    let result2 = {
      doc: this.sliceDoc(),
      selection: this.selection.toJSON()
    };
    if (fields)
      for (let prop in fields) {
        let value = fields[prop];
        if (value instanceof StateField && this.config.address[value.id] != null)
          result2[prop] = value.spec.toJSON(this.field(fields[prop]), this);
      }
    return result2;
  }
  /**
  Deserialize a state from its JSON representation. When custom
  fields should be deserialized, pass the same object you passed
  to [`toJSON`](https://codemirror.net/6/docs/ref/#state.EditorState.toJSON) when serializing as
  third argument.
  */
  static fromJSON(json, config2 = {}, fields) {
    if (!json || typeof json.doc != "string")
      throw new RangeError("Invalid JSON representation for EditorState");
    let fieldInit = [];
    if (fields)
      for (let prop in fields) {
        if (Object.prototype.hasOwnProperty.call(json, prop)) {
          let field = fields[prop], value = json[prop];
          fieldInit.push(field.init((state) => field.spec.fromJSON(value, state)));
        }
      }
    return EditorState.create({
      doc: json.doc,
      selection: EditorSelection.fromJSON(json.selection),
      extensions: config2.extensions ? fieldInit.concat([config2.extensions]) : fieldInit
    });
  }
  /**
  Create a new state. You'll usually only need this when
  initializing an editor—updated states are created by applying
  transactions.
  */
  static create(config2 = {}) {
    let configuration2 = Configuration.resolve(config2.extensions || [], /* @__PURE__ */ new Map());
    let doc2 = config2.doc instanceof Text$1 ? config2.doc : Text$1.of((config2.doc || "").split(configuration2.staticFacet(EditorState.lineSeparator) || DefaultSplit));
    let selection2 = !config2.selection ? EditorSelection.single(0) : config2.selection instanceof EditorSelection ? config2.selection : EditorSelection.single(config2.selection.anchor, config2.selection.head);
    checkSelection(selection2, doc2.length);
    if (!configuration2.staticFacet(allowMultipleSelections))
      selection2 = selection2.asSingle();
    return new EditorState(configuration2, doc2, selection2, configuration2.dynamicSlots.map(() => null), (state, slot) => slot.create(state), null);
  }
  /**
  The size (in columns) of a tab in the document, determined by
  the [`tabSize`](https://codemirror.net/6/docs/ref/#state.EditorState^tabSize) facet.
  */
  get tabSize() {
    return this.facet(EditorState.tabSize);
  }
  /**
  Get the proper [line-break](https://codemirror.net/6/docs/ref/#state.EditorState^lineSeparator)
  string for this state.
  */
  get lineBreak() {
    return this.facet(EditorState.lineSeparator) || "\n";
  }
  /**
  Returns true when the editor is
  [configured](https://codemirror.net/6/docs/ref/#state.EditorState^readOnly) to be read-only.
  */
  get readOnly() {
    return this.facet(readOnly);
  }
  /**
  Look up a translation for the given phrase (via the
  [`phrases`](https://codemirror.net/6/docs/ref/#state.EditorState^phrases) facet), or return the
  original string if no translation is found.
  
  If additional arguments are passed, they will be inserted in
  place of markers like `$1` (for the first value) and `$2`, etc.
  A single `$` is equivalent to `$1`, and `$$` will produce a
  literal dollar sign.
  */
  phrase(phrase2, ...insert2) {
    for (let map2 of this.facet(EditorState.phrases))
      if (Object.prototype.hasOwnProperty.call(map2, phrase2)) {
        phrase2 = map2[phrase2];
        break;
      }
    if (insert2.length)
      phrase2 = phrase2.replace(/\$(\$|\d*)/g, (m2, i2) => {
        if (i2 == "$")
          return "$";
        let n2 = +(i2 || 1);
        return !n2 || n2 > insert2.length ? m2 : insert2[n2 - 1];
      });
    return phrase2;
  }
  /**
  Find the values for a given language data field, provided by the
  the [`languageData`](https://codemirror.net/6/docs/ref/#state.EditorState^languageData) facet.
  
  Examples of language data fields are...
  
  - [`"commentTokens"`](https://codemirror.net/6/docs/ref/#commands.CommentTokens) for specifying
    comment syntax.
  - [`"autocomplete"`](https://codemirror.net/6/docs/ref/#autocomplete.autocompletion^config.override)
    for providing language-specific completion sources.
  - [`"wordChars"`](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) for adding
    characters that should be considered part of words in this
    language.
  - [`"closeBrackets"`](https://codemirror.net/6/docs/ref/#autocomplete.CloseBracketConfig) controls
    bracket closing behavior.
  */
  languageDataAt(name2, pos, side = -1) {
    let values2 = [];
    for (let provider of this.facet(languageData)) {
      for (let result2 of provider(this, pos, side)) {
        if (Object.prototype.hasOwnProperty.call(result2, name2))
          values2.push(result2[name2]);
      }
    }
    return values2;
  }
  /**
  Return a function that can categorize strings (expected to
  represent a single [grapheme cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak))
  into one of:
  
   - Word (contains an alphanumeric character or a character
     explicitly listed in the local language's `"wordChars"`
     language data, which should be a string)
   - Space (contains only whitespace)
   - Other (anything else)
  */
  charCategorizer(at2) {
    let chars = this.languageDataAt("wordChars", at2);
    return makeCategorizer(chars.length ? chars[0] : "");
  }
  /**
  Find the word at the given position, meaning the range
  containing all [word](https://codemirror.net/6/docs/ref/#state.CharCategory.Word) characters
  around it. If no word characters are adjacent to the position,
  this returns null.
  */
  wordAt(pos) {
    let { text: text2, from, length } = this.doc.lineAt(pos);
    let cat = this.charCategorizer(pos);
    let start = pos - from, end = pos - from;
    while (start > 0) {
      let prev = findClusterBreak(text2, start, false);
      if (cat(text2.slice(prev, start)) != CharCategory.Word)
        break;
      start = prev;
    }
    while (end < length) {
      let next = findClusterBreak(text2, end);
      if (cat(text2.slice(end, next)) != CharCategory.Word)
        break;
      end = next;
    }
    return start == end ? null : EditorSelection.range(start + from, end + from);
  }
}
EditorState.allowMultipleSelections = allowMultipleSelections;
EditorState.tabSize = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.length ? values2[0] : 4
});
EditorState.lineSeparator = lineSeparator;
EditorState.readOnly = readOnly;
EditorState.phrases = /* @__PURE__ */ Facet.define({
  compare(a2, b2) {
    let kA = Object.keys(a2), kB = Object.keys(b2);
    return kA.length == kB.length && kA.every((k2) => a2[k2] == b2[k2]);
  }
});
EditorState.languageData = languageData;
EditorState.changeFilter = changeFilter;
EditorState.transactionFilter = transactionFilter;
EditorState.transactionExtender = transactionExtender;
Compartment.reconfigure = /* @__PURE__ */ StateEffect.define();
function combineConfig(configs, defaults2, combine = {}) {
  let result2 = {};
  for (let config2 of configs)
    for (let key of Object.keys(config2)) {
      let value = config2[key], current2 = result2[key];
      if (current2 === void 0)
        result2[key] = value;
      else if (current2 === value || value === void 0) ;
      else if (Object.hasOwnProperty.call(combine, key))
        result2[key] = combine[key](current2, value);
      else
        throw new Error("Config merge conflict for field " + key);
    }
  for (let key in defaults2)
    if (result2[key] === void 0)
      result2[key] = defaults2[key];
  return result2;
}
class RangeValue {
  /**
  Compare this value with another value. Used when comparing
  rangesets. The default implementation compares by identity.
  Unless you are only creating a fixed number of unique instances
  of your value type, it is a good idea to implement this
  properly.
  */
  eq(other) {
    return this == other;
  }
  /**
  Create a [range](https://codemirror.net/6/docs/ref/#state.Range) with this value.
  */
  range(from, to2 = from) {
    return Range$3.create(from, to2, this);
  }
}
RangeValue.prototype.startSide = RangeValue.prototype.endSide = 0;
RangeValue.prototype.point = false;
RangeValue.prototype.mapMode = MapMode.TrackDel;
function cmpVal(a2, b2) {
  return a2 == b2 || a2.constructor == b2.constructor && a2.eq(b2);
}
let Range$3 = class Range22 {
  constructor(from, to2, value) {
    this.from = from;
    this.to = to2;
    this.value = value;
  }
  /**
  @internal
  */
  static create(from, to2, value) {
    return new Range22(from, to2, value);
  }
};
function cmpRange(a2, b2) {
  return a2.from - b2.from || a2.value.startSide - b2.value.startSide;
}
class Chunk {
  constructor(from, to2, value, maxPoint) {
    this.from = from;
    this.to = to2;
    this.value = value;
    this.maxPoint = maxPoint;
  }
  get length() {
    return this.to[this.to.length - 1];
  }
  // Find the index of the given position and side. Use the ranges'
  // `from` pos when `end == false`, `to` when `end == true`.
  findIndex(pos, side, end, startAt = 0) {
    let arr = end ? this.to : this.from;
    for (let lo2 = startAt, hi2 = arr.length; ; ) {
      if (lo2 == hi2)
        return lo2;
      let mid = lo2 + hi2 >> 1;
      let diff = arr[mid] - pos || (end ? this.value[mid].endSide : this.value[mid].startSide) - side;
      if (mid == lo2)
        return diff >= 0 ? lo2 : hi2;
      if (diff >= 0)
        hi2 = mid;
      else
        lo2 = mid + 1;
    }
  }
  between(offset2, from, to2, f2) {
    for (let i2 = this.findIndex(from, -1e9, true), e2 = this.findIndex(to2, 1e9, false, i2); i2 < e2; i2++)
      if (f2(this.from[i2] + offset2, this.to[i2] + offset2, this.value[i2]) === false)
        return false;
  }
  map(offset2, changes) {
    let value = [], from = [], to2 = [], newPos = -1, maxPoint = -1;
    for (let i2 = 0; i2 < this.value.length; i2++) {
      let val = this.value[i2], curFrom = this.from[i2] + offset2, curTo = this.to[i2] + offset2, newFrom, newTo;
      if (curFrom == curTo) {
        let mapped = changes.mapPos(curFrom, val.startSide, val.mapMode);
        if (mapped == null)
          continue;
        newFrom = newTo = mapped;
        if (val.startSide != val.endSide) {
          newTo = changes.mapPos(curFrom, val.endSide);
          if (newTo < newFrom)
            continue;
        }
      } else {
        newFrom = changes.mapPos(curFrom, val.startSide);
        newTo = changes.mapPos(curTo, val.endSide);
        if (newFrom > newTo || newFrom == newTo && val.startSide > 0 && val.endSide <= 0)
          continue;
      }
      if ((newTo - newFrom || val.endSide - val.startSide) < 0)
        continue;
      if (newPos < 0)
        newPos = newFrom;
      if (val.point)
        maxPoint = Math.max(maxPoint, newTo - newFrom);
      value.push(val);
      from.push(newFrom - newPos);
      to2.push(newTo - newPos);
    }
    return { mapped: value.length ? new Chunk(from, to2, value, maxPoint) : null, pos: newPos };
  }
}
class RangeSet {
  constructor(chunkPos, chunk2, nextLayer, maxPoint) {
    this.chunkPos = chunkPos;
    this.chunk = chunk2;
    this.nextLayer = nextLayer;
    this.maxPoint = maxPoint;
  }
  /**
  @internal
  */
  static create(chunkPos, chunk2, nextLayer, maxPoint) {
    return new RangeSet(chunkPos, chunk2, nextLayer, maxPoint);
  }
  /**
  @internal
  */
  get length() {
    let last2 = this.chunk.length - 1;
    return last2 < 0 ? 0 : Math.max(this.chunkEnd(last2), this.nextLayer.length);
  }
  /**
  The number of ranges in the set.
  */
  get size() {
    if (this.isEmpty)
      return 0;
    let size2 = this.nextLayer.size;
    for (let chunk2 of this.chunk)
      size2 += chunk2.value.length;
    return size2;
  }
  /**
  @internal
  */
  chunkEnd(index2) {
    return this.chunkPos[index2] + this.chunk[index2].length;
  }
  /**
  Update the range set, optionally adding new ranges or filtering
  out existing ones.
  
  (Note: The type parameter is just there as a kludge to work
  around TypeScript variance issues that prevented `RangeSet<X>`
  from being a subtype of `RangeSet<Y>` when `X` is a subtype of
  `Y`.)
  */
  update(updateSpec) {
    let { add: add2 = [], sort = false, filterFrom = 0, filterTo = this.length } = updateSpec;
    let filter2 = updateSpec.filter;
    if (add2.length == 0 && !filter2)
      return this;
    if (sort)
      add2 = add2.slice().sort(cmpRange);
    if (this.isEmpty)
      return add2.length ? RangeSet.of(add2) : this;
    let cur2 = new LayerCursor(this, null, -1).goto(0), i2 = 0, spill = [];
    let builder = new RangeSetBuilder();
    while (cur2.value || i2 < add2.length) {
      if (i2 < add2.length && (cur2.from - add2[i2].from || cur2.startSide - add2[i2].value.startSide) >= 0) {
        let range2 = add2[i2++];
        if (!builder.addInner(range2.from, range2.to, range2.value))
          spill.push(range2);
      } else if (cur2.rangeIndex == 1 && cur2.chunkIndex < this.chunk.length && (i2 == add2.length || this.chunkEnd(cur2.chunkIndex) < add2[i2].from) && (!filter2 || filterFrom > this.chunkEnd(cur2.chunkIndex) || filterTo < this.chunkPos[cur2.chunkIndex]) && builder.addChunk(this.chunkPos[cur2.chunkIndex], this.chunk[cur2.chunkIndex])) {
        cur2.nextChunk();
      } else {
        if (!filter2 || filterFrom > cur2.to || filterTo < cur2.from || filter2(cur2.from, cur2.to, cur2.value)) {
          if (!builder.addInner(cur2.from, cur2.to, cur2.value))
            spill.push(Range$3.create(cur2.from, cur2.to, cur2.value));
        }
        cur2.next();
      }
    }
    return builder.finishInner(this.nextLayer.isEmpty && !spill.length ? RangeSet.empty : this.nextLayer.update({ add: spill, filter: filter2, filterFrom, filterTo }));
  }
  /**
  Map this range set through a set of changes, return the new set.
  */
  map(changes) {
    if (changes.empty || this.isEmpty)
      return this;
    let chunks = [], chunkPos = [], maxPoint = -1;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk2 = this.chunk[i2];
      let touch = changes.touchesRange(start, start + chunk2.length);
      if (touch === false) {
        maxPoint = Math.max(maxPoint, chunk2.maxPoint);
        chunks.push(chunk2);
        chunkPos.push(changes.mapPos(start));
      } else if (touch === true) {
        let { mapped, pos } = chunk2.map(start, changes);
        if (mapped) {
          maxPoint = Math.max(maxPoint, mapped.maxPoint);
          chunks.push(mapped);
          chunkPos.push(pos);
        }
      }
    }
    let next = this.nextLayer.map(changes);
    return chunks.length == 0 ? next : new RangeSet(chunkPos, chunks, next || RangeSet.empty, maxPoint);
  }
  /**
  Iterate over the ranges that touch the region `from` to `to`,
  calling `f` for each. There is no guarantee that the ranges will
  be reported in any specific order. When the callback returns
  `false`, iteration stops.
  */
  between(from, to2, f2) {
    if (this.isEmpty)
      return;
    for (let i2 = 0; i2 < this.chunk.length; i2++) {
      let start = this.chunkPos[i2], chunk2 = this.chunk[i2];
      if (to2 >= start && from <= start + chunk2.length && chunk2.between(start, from - start, to2 - start, f2) === false)
        return;
    }
    this.nextLayer.between(from, to2, f2);
  }
  /**
  Iterate over the ranges in this set, in order, including all
  ranges that end at or after `from`.
  */
  iter(from = 0) {
    return HeapCursor.from([this]).goto(from);
  }
  /**
  @internal
  */
  get isEmpty() {
    return this.nextLayer == this;
  }
  /**
  Iterate over the ranges in a collection of sets, in order,
  starting from `from`.
  */
  static iter(sets, from = 0) {
    return HeapCursor.from(sets).goto(from);
  }
  /**
  Iterate over two groups of sets, calling methods on `comparator`
  to notify it of possible differences.
  */
  static compare(oldSets, newSets, textDiff, comparator, minPointSize = -1) {
    let a2 = oldSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let b2 = newSets.filter((set2) => set2.maxPoint > 0 || !set2.isEmpty && set2.maxPoint >= minPointSize);
    let sharedChunks = findSharedChunks(a2, b2, textDiff);
    let sideA = new SpanCursor(a2, sharedChunks, minPointSize);
    let sideB = new SpanCursor(b2, sharedChunks, minPointSize);
    textDiff.iterGaps((fromA, fromB, length) => compare(sideA, fromA, sideB, fromB, length, comparator));
    if (textDiff.empty && textDiff.length == 0)
      compare(sideA, 0, sideB, 0, 0, comparator);
  }
  /**
  Compare the contents of two groups of range sets, returning true
  if they are equivalent in the given range.
  */
  static eq(oldSets, newSets, from = 0, to2) {
    if (to2 == null)
      to2 = 1e9 - 1;
    let a2 = oldSets.filter((set2) => !set2.isEmpty && newSets.indexOf(set2) < 0);
    let b2 = newSets.filter((set2) => !set2.isEmpty && oldSets.indexOf(set2) < 0);
    if (a2.length != b2.length)
      return false;
    if (!a2.length)
      return true;
    let sharedChunks = findSharedChunks(a2, b2);
    let sideA = new SpanCursor(a2, sharedChunks, 0).goto(from), sideB = new SpanCursor(b2, sharedChunks, 0).goto(from);
    for (; ; ) {
      if (sideA.to != sideB.to || !sameValues(sideA.active, sideB.active) || sideA.point && (!sideB.point || !cmpVal(sideA.point, sideB.point)))
        return false;
      if (sideA.to > to2)
        return true;
      sideA.next();
      sideB.next();
    }
  }
  /**
  Iterate over a group of range sets at the same time, notifying
  the iterator about the ranges covering every given piece of
  content. Returns the open count (see
  [`SpanIterator.span`](https://codemirror.net/6/docs/ref/#state.SpanIterator.span)) at the end
  of the iteration.
  */
  static spans(sets, from, to2, iterator, minPointSize = -1) {
    let cursor2 = new SpanCursor(sets, null, minPointSize).goto(from), pos = from;
    let openRanges = cursor2.openStart;
    for (; ; ) {
      let curTo = Math.min(cursor2.to, to2);
      if (cursor2.point) {
        let active = cursor2.activeForPoint(cursor2.to);
        let openCount = cursor2.pointFrom < from ? active.length + 1 : cursor2.point.startSide < 0 ? active.length : Math.min(active.length, openRanges);
        iterator.point(pos, curTo, cursor2.point, active, openCount, cursor2.pointRank);
        openRanges = Math.min(cursor2.openEnd(curTo), active.length);
      } else if (curTo > pos) {
        iterator.span(pos, curTo, cursor2.active, openRanges);
        openRanges = cursor2.openEnd(curTo);
      }
      if (cursor2.to > to2)
        return openRanges + (cursor2.point && cursor2.to > to2 ? 1 : 0);
      pos = cursor2.to;
      cursor2.next();
    }
  }
  /**
  Create a range set for the given range or array of ranges. By
  default, this expects the ranges to be _sorted_ (by start
  position and, if two start at the same position,
  `value.startSide`). You can pass `true` as second argument to
  cause the method to sort them.
  */
  static of(ranges, sort = false) {
    let build = new RangeSetBuilder();
    for (let range2 of ranges instanceof Range$3 ? [ranges] : sort ? lazySort(ranges) : ranges)
      build.add(range2.from, range2.to, range2.value);
    return build.finish();
  }
  /**
  Join an array of range sets into a single set.
  */
  static join(sets) {
    if (!sets.length)
      return RangeSet.empty;
    let result2 = sets[sets.length - 1];
    for (let i2 = sets.length - 2; i2 >= 0; i2--) {
      for (let layer2 = sets[i2]; layer2 != RangeSet.empty; layer2 = layer2.nextLayer)
        result2 = new RangeSet(layer2.chunkPos, layer2.chunk, result2, Math.max(layer2.maxPoint, result2.maxPoint));
    }
    return result2;
  }
}
RangeSet.empty = /* @__PURE__ */ new RangeSet([], [], null, -1);
function lazySort(ranges) {
  if (ranges.length > 1)
    for (let prev = ranges[0], i2 = 1; i2 < ranges.length; i2++) {
      let cur2 = ranges[i2];
      if (cmpRange(prev, cur2) > 0)
        return ranges.slice().sort(cmpRange);
      prev = cur2;
    }
  return ranges;
}
RangeSet.empty.nextLayer = RangeSet.empty;
class RangeSetBuilder {
  finishChunk(newArrays) {
    this.chunks.push(new Chunk(this.from, this.to, this.value, this.maxPoint));
    this.chunkPos.push(this.chunkStart);
    this.chunkStart = -1;
    this.setMaxPoint = Math.max(this.setMaxPoint, this.maxPoint);
    this.maxPoint = -1;
    if (newArrays) {
      this.from = [];
      this.to = [];
      this.value = [];
    }
  }
  /**
  Create an empty builder.
  */
  constructor() {
    this.chunks = [];
    this.chunkPos = [];
    this.chunkStart = -1;
    this.last = null;
    this.lastFrom = -1e9;
    this.lastTo = -1e9;
    this.from = [];
    this.to = [];
    this.value = [];
    this.maxPoint = -1;
    this.setMaxPoint = -1;
    this.nextLayer = null;
  }
  /**
  Add a range. Ranges should be added in sorted (by `from` and
  `value.startSide`) order.
  */
  add(from, to2, value) {
    if (!this.addInner(from, to2, value))
      (this.nextLayer || (this.nextLayer = new RangeSetBuilder())).add(from, to2, value);
  }
  /**
  @internal
  */
  addInner(from, to2, value) {
    let diff = from - this.lastTo || value.startSide - this.last.endSide;
    if (diff <= 0 && (from - this.lastFrom || value.startSide - this.last.startSide) < 0)
      throw new Error("Ranges must be added sorted by `from` position and `startSide`");
    if (diff < 0)
      return false;
    if (this.from.length == 250)
      this.finishChunk(true);
    if (this.chunkStart < 0)
      this.chunkStart = from;
    this.from.push(from - this.chunkStart);
    this.to.push(to2 - this.chunkStart);
    this.last = value;
    this.lastFrom = from;
    this.lastTo = to2;
    this.value.push(value);
    if (value.point)
      this.maxPoint = Math.max(this.maxPoint, to2 - from);
    return true;
  }
  /**
  @internal
  */
  addChunk(from, chunk2) {
    if ((from - this.lastTo || chunk2.value[0].startSide - this.last.endSide) < 0)
      return false;
    if (this.from.length)
      this.finishChunk(true);
    this.setMaxPoint = Math.max(this.setMaxPoint, chunk2.maxPoint);
    this.chunks.push(chunk2);
    this.chunkPos.push(from);
    let last2 = chunk2.value.length - 1;
    this.last = chunk2.value[last2];
    this.lastFrom = chunk2.from[last2] + from;
    this.lastTo = chunk2.to[last2] + from;
    return true;
  }
  /**
  Finish the range set. Returns the new set. The builder can't be
  used anymore after this has been called.
  */
  finish() {
    return this.finishInner(RangeSet.empty);
  }
  /**
  @internal
  */
  finishInner(next) {
    if (this.from.length)
      this.finishChunk(false);
    if (this.chunks.length == 0)
      return next;
    let result2 = RangeSet.create(this.chunkPos, this.chunks, this.nextLayer ? this.nextLayer.finishInner(next) : next, this.setMaxPoint);
    this.from = null;
    return result2;
  }
}
function findSharedChunks(a2, b2, textDiff) {
  let inA = /* @__PURE__ */ new Map();
  for (let set2 of a2)
    for (let i2 = 0; i2 < set2.chunk.length; i2++)
      if (set2.chunk[i2].maxPoint <= 0)
        inA.set(set2.chunk[i2], set2.chunkPos[i2]);
  let shared = /* @__PURE__ */ new Set();
  for (let set2 of b2)
    for (let i2 = 0; i2 < set2.chunk.length; i2++) {
      let known = inA.get(set2.chunk[i2]);
      if (known != null && (textDiff ? textDiff.mapPos(known) : known) == set2.chunkPos[i2] && !(textDiff === null || textDiff === void 0 ? void 0 : textDiff.touchesRange(known, known + set2.chunk[i2].length)))
        shared.add(set2.chunk[i2]);
    }
  return shared;
}
class LayerCursor {
  constructor(layer2, skip, minPoint, rank = 0) {
    this.layer = layer2;
    this.skip = skip;
    this.minPoint = minPoint;
    this.rank = rank;
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  get endSide() {
    return this.value ? this.value.endSide : 0;
  }
  goto(pos, side = -1e9) {
    this.chunkIndex = this.rangeIndex = 0;
    this.gotoInner(pos, side, false);
    return this;
  }
  gotoInner(pos, side, forward) {
    while (this.chunkIndex < this.layer.chunk.length) {
      let next = this.layer.chunk[this.chunkIndex];
      if (!(this.skip && this.skip.has(next) || this.layer.chunkEnd(this.chunkIndex) < pos || next.maxPoint < this.minPoint))
        break;
      this.chunkIndex++;
      forward = false;
    }
    if (this.chunkIndex < this.layer.chunk.length) {
      let rangeIndex = this.layer.chunk[this.chunkIndex].findIndex(pos - this.layer.chunkPos[this.chunkIndex], side, true);
      if (!forward || this.rangeIndex < rangeIndex)
        this.setRangeIndex(rangeIndex);
    }
    this.next();
  }
  forward(pos, side) {
    if ((this.to - pos || this.endSide - side) < 0)
      this.gotoInner(pos, side, true);
  }
  next() {
    for (; ; ) {
      if (this.chunkIndex == this.layer.chunk.length) {
        this.from = this.to = 1e9;
        this.value = null;
        break;
      } else {
        let chunkPos = this.layer.chunkPos[this.chunkIndex], chunk2 = this.layer.chunk[this.chunkIndex];
        let from = chunkPos + chunk2.from[this.rangeIndex];
        this.from = from;
        this.to = chunkPos + chunk2.to[this.rangeIndex];
        this.value = chunk2.value[this.rangeIndex];
        this.setRangeIndex(this.rangeIndex + 1);
        if (this.minPoint < 0 || this.value.point && this.to - this.from >= this.minPoint)
          break;
      }
    }
  }
  setRangeIndex(index2) {
    if (index2 == this.layer.chunk[this.chunkIndex].value.length) {
      this.chunkIndex++;
      if (this.skip) {
        while (this.chunkIndex < this.layer.chunk.length && this.skip.has(this.layer.chunk[this.chunkIndex]))
          this.chunkIndex++;
      }
      this.rangeIndex = 0;
    } else {
      this.rangeIndex = index2;
    }
  }
  nextChunk() {
    this.chunkIndex++;
    this.rangeIndex = 0;
    this.next();
  }
  compare(other) {
    return this.from - other.from || this.startSide - other.startSide || this.rank - other.rank || this.to - other.to || this.endSide - other.endSide;
  }
}
class HeapCursor {
  constructor(heap) {
    this.heap = heap;
  }
  static from(sets, skip = null, minPoint = -1) {
    let heap = [];
    for (let i2 = 0; i2 < sets.length; i2++) {
      for (let cur2 = sets[i2]; !cur2.isEmpty; cur2 = cur2.nextLayer) {
        if (cur2.maxPoint >= minPoint)
          heap.push(new LayerCursor(cur2, skip, minPoint, i2));
      }
    }
    return heap.length == 1 ? heap[0] : new HeapCursor(heap);
  }
  get startSide() {
    return this.value ? this.value.startSide : 0;
  }
  goto(pos, side = -1e9) {
    for (let cur2 of this.heap)
      cur2.goto(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    this.next();
    return this;
  }
  forward(pos, side) {
    for (let cur2 of this.heap)
      cur2.forward(pos, side);
    for (let i2 = this.heap.length >> 1; i2 >= 0; i2--)
      heapBubble(this.heap, i2);
    if ((this.to - pos || this.value.endSide - side) < 0)
      this.next();
  }
  next() {
    if (this.heap.length == 0) {
      this.from = this.to = 1e9;
      this.value = null;
      this.rank = -1;
    } else {
      let top2 = this.heap[0];
      this.from = top2.from;
      this.to = top2.to;
      this.value = top2.value;
      this.rank = top2.rank;
      if (top2.value)
        top2.next();
      heapBubble(this.heap, 0);
    }
  }
}
function heapBubble(heap, index2) {
  for (let cur2 = heap[index2]; ; ) {
    let childIndex = (index2 << 1) + 1;
    if (childIndex >= heap.length)
      break;
    let child = heap[childIndex];
    if (childIndex + 1 < heap.length && child.compare(heap[childIndex + 1]) >= 0) {
      child = heap[childIndex + 1];
      childIndex++;
    }
    if (cur2.compare(child) < 0)
      break;
    heap[childIndex] = cur2;
    heap[index2] = child;
    index2 = childIndex;
  }
}
class SpanCursor {
  constructor(sets, skip, minPoint) {
    this.minPoint = minPoint;
    this.active = [];
    this.activeTo = [];
    this.activeRank = [];
    this.minActive = -1;
    this.point = null;
    this.pointFrom = 0;
    this.pointRank = 0;
    this.to = -1e9;
    this.endSide = 0;
    this.openStart = -1;
    this.cursor = HeapCursor.from(sets, skip, minPoint);
  }
  goto(pos, side = -1e9) {
    this.cursor.goto(pos, side);
    this.active.length = this.activeTo.length = this.activeRank.length = 0;
    this.minActive = -1;
    this.to = pos;
    this.endSide = side;
    this.openStart = -1;
    this.next();
    return this;
  }
  forward(pos, side) {
    while (this.minActive > -1 && (this.activeTo[this.minActive] - pos || this.active[this.minActive].endSide - side) < 0)
      this.removeActive(this.minActive);
    this.cursor.forward(pos, side);
  }
  removeActive(index2) {
    remove(this.active, index2);
    remove(this.activeTo, index2);
    remove(this.activeRank, index2);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  addActive(trackOpen) {
    let i2 = 0, { value, to: to2, rank } = this.cursor;
    while (i2 < this.activeRank.length && (rank - this.activeRank[i2] || to2 - this.activeTo[i2]) > 0)
      i2++;
    insert(this.active, i2, value);
    insert(this.activeTo, i2, to2);
    insert(this.activeRank, i2, rank);
    if (trackOpen)
      insert(trackOpen, i2, this.cursor.from);
    this.minActive = findMinIndex(this.active, this.activeTo);
  }
  // After calling this, if `this.point` != null, the next range is a
  // point. Otherwise, it's a regular range, covered by `this.active`.
  next() {
    let from = this.to, wasPoint = this.point;
    this.point = null;
    let trackOpen = this.openStart < 0 ? [] : null;
    for (; ; ) {
      let a2 = this.minActive;
      if (a2 > -1 && (this.activeTo[a2] - this.cursor.from || this.active[a2].endSide - this.cursor.startSide) < 0) {
        if (this.activeTo[a2] > from) {
          this.to = this.activeTo[a2];
          this.endSide = this.active[a2].endSide;
          break;
        }
        this.removeActive(a2);
        if (trackOpen)
          remove(trackOpen, a2);
      } else if (!this.cursor.value) {
        this.to = this.endSide = 1e9;
        break;
      } else if (this.cursor.from > from) {
        this.to = this.cursor.from;
        this.endSide = this.cursor.startSide;
        break;
      } else {
        let nextVal = this.cursor.value;
        if (!nextVal.point) {
          this.addActive(trackOpen);
          this.cursor.next();
        } else if (wasPoint && this.cursor.to == this.to && this.cursor.from < this.cursor.to) {
          this.cursor.next();
        } else {
          this.point = nextVal;
          this.pointFrom = this.cursor.from;
          this.pointRank = this.cursor.rank;
          this.to = this.cursor.to;
          this.endSide = nextVal.endSide;
          this.cursor.next();
          this.forward(this.to, this.endSide);
          break;
        }
      }
    }
    if (trackOpen) {
      this.openStart = 0;
      for (let i2 = trackOpen.length - 1; i2 >= 0 && trackOpen[i2] < from; i2--)
        this.openStart++;
    }
  }
  activeForPoint(to2) {
    if (!this.active.length)
      return this.active;
    let active = [];
    for (let i2 = this.active.length - 1; i2 >= 0; i2--) {
      if (this.activeRank[i2] < this.pointRank)
        break;
      if (this.activeTo[i2] > to2 || this.activeTo[i2] == to2 && this.active[i2].endSide >= this.point.endSide)
        active.push(this.active[i2]);
    }
    return active.reverse();
  }
  openEnd(to2) {
    let open = 0;
    for (let i2 = this.activeTo.length - 1; i2 >= 0 && this.activeTo[i2] > to2; i2--)
      open++;
    return open;
  }
}
function compare(a2, startA, b2, startB, length, comparator) {
  a2.goto(startA);
  b2.goto(startB);
  let endB = startB + length;
  let pos = startB, dPos = startB - startA;
  let bounds = !!comparator.boundChange;
  for (let boundChange = false; ; ) {
    let dEnd = a2.to + dPos - b2.to, diff = dEnd || a2.endSide - b2.endSide;
    let end = diff < 0 ? a2.to + dPos : b2.to, clipEnd = Math.min(end, endB);
    let point2 = a2.point || b2.point;
    if (point2) {
      if (!(a2.point && b2.point && cmpVal(a2.point, b2.point) && sameValues(a2.activeForPoint(a2.to), b2.activeForPoint(b2.to))))
        comparator.comparePoint(pos, clipEnd, a2.point, b2.point);
      boundChange = false;
    } else {
      if (boundChange)
        comparator.boundChange(pos);
      if (clipEnd > pos && !sameValues(a2.active, b2.active))
        comparator.compareRange(pos, clipEnd, a2.active, b2.active);
      if (bounds && clipEnd < endB && (dEnd || a2.openEnd(end) != b2.openEnd(end)))
        boundChange = true;
    }
    if (end > endB)
      break;
    pos = end;
    if (diff <= 0)
      a2.next();
    if (diff >= 0)
      b2.next();
  }
}
function sameValues(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (a2[i2] != b2[i2] && !cmpVal(a2[i2], b2[i2]))
      return false;
  return true;
}
function remove(array, index2) {
  for (let i2 = index2, e2 = array.length - 1; i2 < e2; i2++)
    array[i2] = array[i2 + 1];
  array.pop();
}
function insert(array, index2, value) {
  for (let i2 = array.length - 1; i2 >= index2; i2--)
    array[i2 + 1] = array[i2];
  array[index2] = value;
}
function findMinIndex(value, array) {
  let found = -1, foundPos = 1e9;
  for (let i2 = 0; i2 < array.length; i2++)
    if ((array[i2] - foundPos || value[i2].endSide - value[found].endSide) < 0) {
      found = i2;
      foundPos = array[i2];
    }
  return found;
}
function countColumn(string2, tabSize, to2 = string2.length) {
  let n2 = 0;
  for (let i2 = 0; i2 < to2 && i2 < string2.length; ) {
    if (string2.charCodeAt(i2) == 9) {
      n2 += tabSize - n2 % tabSize;
      i2++;
    } else {
      n2++;
      i2 = findClusterBreak(string2, i2);
    }
  }
  return n2;
}
function findColumn(string2, col, tabSize, strict) {
  for (let i2 = 0, n2 = 0; ; ) {
    if (n2 >= col)
      return i2;
    if (i2 == string2.length)
      break;
    n2 += string2.charCodeAt(i2) == 9 ? tabSize - n2 % tabSize : 1;
    i2 = findClusterBreak(string2, i2);
  }
  return strict === true ? -1 : string2.length;
}
const C = "ͼ";
const COUNT = typeof Symbol == "undefined" ? "__" + C : Symbol.for(C);
const SET = typeof Symbol == "undefined" ? "__styleSet" + Math.floor(Math.random() * 1e8) : /* @__PURE__ */ Symbol("styleSet");
const top = typeof globalThis != "undefined" ? globalThis : typeof window != "undefined" ? window : {};
class StyleModule {
  // :: (Object<Style>, ?{finish: ?(string) → string})
  // Create a style module from the given spec.
  //
  // When `finish` is given, it is called on regular (non-`@`)
  // selectors (after `&` expansion) to compute the final selector.
  constructor(spec, options2) {
    this.rules = [];
    let { finish } = options2 || {};
    function splitSelector(selector2) {
      return /^@/.test(selector2) ? [selector2] : selector2.split(/,\s*/);
    }
    function render(selectors, spec2, target, isKeyframes) {
      let local = [], isAt = /^@(\w+)\b/.exec(selectors[0]), keyframes = isAt && isAt[1] == "keyframes";
      if (isAt && spec2 == null) return target.push(selectors[0] + ";");
      for (let prop in spec2) {
        let value = spec2[prop];
        if (/&/.test(prop)) {
          render(
            prop.split(/,\s*/).map((part) => selectors.map((sel) => part.replace(/&/, sel))).reduce((a2, b2) => a2.concat(b2)),
            value,
            target
          );
        } else if (value && typeof value == "object") {
          if (!isAt) throw new RangeError("The value of a property (" + prop + ") should be a primitive value.");
          render(splitSelector(prop), value, local, keyframes);
        } else if (value != null) {
          local.push(prop.replace(/_.*/, "").replace(/[A-Z]/g, (l2) => "-" + l2.toLowerCase()) + ": " + value + ";");
        }
      }
      if (local.length || keyframes) {
        target.push((finish && !isAt && !isKeyframes ? selectors.map(finish) : selectors).join(", ") + " {" + local.join(" ") + "}");
      }
    }
    for (let prop in spec) render(splitSelector(prop), spec[prop], this.rules);
  }
  // :: () → string
  // Returns a string containing the module's CSS rules.
  getRules() {
    return this.rules.join("\n");
  }
  // :: () → string
  // Generate a new unique CSS class name.
  static newName() {
    let id2 = top[COUNT] || 1;
    top[COUNT] = id2 + 1;
    return C + id2.toString(36);
  }
  // :: (union<Document, ShadowRoot>, union<[StyleModule], StyleModule>, ?{nonce: ?string})
  //
  // Mount the given set of modules in the given DOM root, which ensures
  // that the CSS rules defined by the module are available in that
  // context.
  //
  // Rules are only added to the document once per root.
  //
  // Rule order will follow the order of the modules, so that rules from
  // modules later in the array take precedence of those from earlier
  // modules. If you call this function multiple times for the same root
  // in a way that changes the order of already mounted modules, the old
  // order will be changed.
  //
  // If a Content Security Policy nonce is provided, it is added to
  // the `<style>` tag generated by the library.
  static mount(root2, modules, options2) {
    let set2 = root2[SET], nonce = options2 && options2.nonce;
    if (!set2) set2 = new StyleSet(root2, nonce);
    else if (nonce) set2.setNonce(nonce);
    set2.mount(Array.isArray(modules) ? modules : [modules], root2);
  }
}
let adoptedSet = /* @__PURE__ */ new Map();
class StyleSet {
  constructor(root2, nonce) {
    let doc2 = root2.ownerDocument || root2, win = doc2.defaultView;
    if (!root2.head && root2.adoptedStyleSheets && win.CSSStyleSheet) {
      let adopted = adoptedSet.get(doc2);
      if (adopted) return root2[SET] = adopted;
      this.sheet = new win.CSSStyleSheet();
      adoptedSet.set(doc2, this);
    } else {
      this.styleTag = doc2.createElement("style");
      if (nonce) this.styleTag.setAttribute("nonce", nonce);
    }
    this.modules = [];
    root2[SET] = this;
  }
  mount(modules, root2) {
    let sheet = this.sheet;
    let pos = 0, j2 = 0;
    for (let i2 = 0; i2 < modules.length; i2++) {
      let mod2 = modules[i2], index2 = this.modules.indexOf(mod2);
      if (index2 < j2 && index2 > -1) {
        this.modules.splice(index2, 1);
        j2--;
        index2 = -1;
      }
      if (index2 == -1) {
        this.modules.splice(j2++, 0, mod2);
        if (sheet) for (let k2 = 0; k2 < mod2.rules.length; k2++)
          sheet.insertRule(mod2.rules[k2], pos++);
      } else {
        while (j2 < index2) pos += this.modules[j2++].rules.length;
        pos += mod2.rules.length;
        j2++;
      }
    }
    if (sheet) {
      if (root2.adoptedStyleSheets.indexOf(this.sheet) < 0)
        root2.adoptedStyleSheets = [this.sheet, ...root2.adoptedStyleSheets];
    } else {
      let text2 = "";
      for (let i2 = 0; i2 < this.modules.length; i2++)
        text2 += this.modules[i2].getRules() + "\n";
      this.styleTag.textContent = text2;
      let target = root2.head || root2;
      if (this.styleTag.parentNode != target)
        target.insertBefore(this.styleTag, target.firstChild);
    }
  }
  setNonce(nonce) {
    if (this.styleTag && this.styleTag.getAttribute("nonce") != nonce)
      this.styleTag.setAttribute("nonce", nonce);
  }
}
var base = {
  8: "Backspace",
  9: "Tab",
  10: "Enter",
  12: "NumLock",
  13: "Enter",
  16: "Shift",
  17: "Control",
  18: "Alt",
  20: "CapsLock",
  27: "Escape",
  32: " ",
  33: "PageUp",
  34: "PageDown",
  35: "End",
  36: "Home",
  37: "ArrowLeft",
  38: "ArrowUp",
  39: "ArrowRight",
  40: "ArrowDown",
  44: "PrintScreen",
  45: "Insert",
  46: "Delete",
  59: ";",
  61: "=",
  91: "Meta",
  92: "Meta",
  106: "*",
  107: "+",
  108: ",",
  109: "-",
  110: ".",
  111: "/",
  144: "NumLock",
  145: "ScrollLock",
  160: "Shift",
  161: "Shift",
  162: "Control",
  163: "Control",
  164: "Alt",
  165: "Alt",
  173: "-",
  186: ";",
  187: "=",
  188: ",",
  189: "-",
  190: ".",
  191: "/",
  192: "`",
  219: "[",
  220: "\\",
  221: "]",
  222: "'"
};
var shift$2 = {
  48: ")",
  49: "!",
  50: "@",
  51: "#",
  52: "$",
  53: "%",
  54: "^",
  55: "&",
  56: "*",
  57: "(",
  59: ":",
  61: "+",
  173: "_",
  186: ":",
  187: "+",
  188: "<",
  189: "_",
  190: ">",
  191: "?",
  192: "~",
  219: "{",
  220: "|",
  221: "}",
  222: '"'
};
var mac = typeof navigator != "undefined" && /Mac/.test(navigator.platform);
var ie$1 = typeof navigator != "undefined" && /MSIE \d|Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(navigator.userAgent);
for (var i$1 = 0; i$1 < 10; i$1++) base[48 + i$1] = base[96 + i$1] = String(i$1);
for (var i$1 = 1; i$1 <= 24; i$1++) base[i$1 + 111] = "F" + i$1;
for (var i$1 = 65; i$1 <= 90; i$1++) {
  base[i$1] = String.fromCharCode(i$1 + 32);
  shift$2[i$1] = String.fromCharCode(i$1);
}
for (var code in base) if (!shift$2.hasOwnProperty(code)) shift$2[code] = base[code];
function keyName(event) {
  var ignoreKey = mac && event.metaKey && event.shiftKey && !event.ctrlKey && !event.altKey || ie$1 && event.shiftKey && event.key && event.key.length == 1 || event.key == "Unidentified";
  var name2 = !ignoreKey && event.key || (event.shiftKey ? shift$2 : base)[event.keyCode] || event.key || "Unidentified";
  if (name2 == "Esc") name2 = "Escape";
  if (name2 == "Del") name2 = "Delete";
  if (name2 == "Left") name2 = "ArrowLeft";
  if (name2 == "Up") name2 = "ArrowUp";
  if (name2 == "Right") name2 = "ArrowRight";
  if (name2 == "Down") name2 = "ArrowDown";
  return name2;
}
function crelt() {
  var elt = arguments[0];
  if (typeof elt == "string") elt = document.createElement(elt);
  var i2 = 1, next = arguments[1];
  if (next && typeof next == "object" && next.nodeType == null && !Array.isArray(next)) {
    for (var name2 in next) if (Object.prototype.hasOwnProperty.call(next, name2)) {
      var value = next[name2];
      if (typeof value == "string") elt.setAttribute(name2, value);
      else if (value != null) elt[name2] = value;
    }
    i2++;
  }
  for (; i2 < arguments.length; i2++) add$2(elt, arguments[i2]);
  return elt;
}
function add$2(elt, child) {
  if (typeof child == "string") {
    elt.appendChild(document.createTextNode(child));
  } else if (child == null) ;
  else if (child.nodeType != null) {
    elt.appendChild(child);
  } else if (Array.isArray(child)) {
    for (var i2 = 0; i2 < child.length; i2++) add$2(elt, child[i2]);
  } else {
    throw new RangeError("Unsupported child node: " + child);
  }
}
let nav = typeof navigator != "undefined" ? navigator : { userAgent: "", vendor: "", platform: "" };
let doc = typeof document != "undefined" ? document : { documentElement: { style: {} } };
const ie_edge = /* @__PURE__ */ /Edge\/(\d+)/.exec(nav.userAgent);
const ie_upto10 = /* @__PURE__ */ /MSIE \d/.test(nav.userAgent);
const ie_11up = /* @__PURE__ */ /Trident\/(?:[7-9]|\d{2,})\..*rv:(\d+)/.exec(nav.userAgent);
const ie$2 = !!(ie_upto10 || ie_11up || ie_edge);
const gecko = !ie$2 && /* @__PURE__ */ /gecko\/(\d+)/i.test(nav.userAgent);
const chrome$1 = !ie$2 && /* @__PURE__ */ /Chrome\/(\d+)/.exec(nav.userAgent);
const webkit = "webkitFontSmoothing" in doc.documentElement.style;
const safari = !ie$2 && /* @__PURE__ */ /Apple Computer/.test(nav.vendor);
const ios = safari && (/* @__PURE__ */ /Mobile\/\w+/.test(nav.userAgent) || nav.maxTouchPoints > 2);
var browser$3 = {
  mac: ios || /* @__PURE__ */ /Mac/.test(nav.platform),
  windows: /* @__PURE__ */ /Win/.test(nav.platform),
  linux: /* @__PURE__ */ /Linux|X11/.test(nav.platform),
  ie: ie$2,
  ie_version: ie_upto10 ? doc.documentMode || 6 : ie_11up ? +ie_11up[1] : ie_edge ? +ie_edge[1] : 0,
  gecko,
  gecko_version: gecko ? +(/* @__PURE__ */ /Firefox\/(\d+)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  chrome: !!chrome$1,
  chrome_version: chrome$1 ? +chrome$1[1] : 0,
  ios,
  android: /* @__PURE__ */ /Android\b/.test(nav.userAgent),
  webkit_version: webkit ? +(/* @__PURE__ */ /\bAppleWebKit\/(\d+)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  safari,
  safari_version: safari ? +(/* @__PURE__ */ /\bVersion\/(\d+(\.\d+)?)/.exec(nav.userAgent) || [0, 0])[1] : 0,
  tabSize: doc.documentElement.style.tabSize != null ? "tab-size" : "-moz-tab-size"
};
function getSelection(root2) {
  let target;
  if (root2.nodeType == 11) {
    target = root2.getSelection ? root2 : root2.ownerDocument;
  } else {
    target = root2;
  }
  return target.getSelection();
}
function contains$1(dom, node) {
  return node ? dom == node || dom.contains(node.nodeType != 1 ? node.parentNode : node) : false;
}
function hasSelection(dom, selection2) {
  if (!selection2.anchorNode)
    return false;
  try {
    return contains$1(dom, selection2.anchorNode);
  } catch (_2) {
    return false;
  }
}
function clientRectsFor(dom) {
  if (dom.nodeType == 3)
    return textRange(dom, 0, dom.nodeValue.length).getClientRects();
  else if (dom.nodeType == 1)
    return dom.getClientRects();
  else
    return [];
}
function isEquivalentPosition(node, off, targetNode, targetOff) {
  return targetNode ? scanFor(node, off, targetNode, targetOff, -1) || scanFor(node, off, targetNode, targetOff, 1) : false;
}
function domIndex(node) {
  for (var index2 = 0; ; index2++) {
    node = node.previousSibling;
    if (!node)
      return index2;
  }
}
function isBlockElement(node) {
  return node.nodeType == 1 && /^(DIV|P|LI|UL|OL|BLOCKQUOTE|DD|DT|H\d|SECTION|PRE)$/.test(node.nodeName);
}
function scanFor(node, off, targetNode, targetOff, dir) {
  for (; ; ) {
    if (node == targetNode && off == targetOff)
      return true;
    if (off == (dir < 0 ? 0 : maxOffset(node))) {
      if (node.nodeName == "DIV")
        return false;
      let parent = node.parentNode;
      if (!parent || parent.nodeType != 1)
        return false;
      off = domIndex(node) + (dir < 0 ? 0 : 1);
      node = parent;
    } else if (node.nodeType == 1) {
      node = node.childNodes[off + (dir < 0 ? -1 : 0)];
      if (node.nodeType == 1 && node.contentEditable == "false")
        return false;
      off = dir < 0 ? maxOffset(node) : 0;
    } else {
      return false;
    }
  }
}
function maxOffset(node) {
  return node.nodeType == 3 ? node.nodeValue.length : node.childNodes.length;
}
function flattenRect(rect, left) {
  let x2 = left ? rect.left : rect.right;
  return { left: x2, right: x2, top: rect.top, bottom: rect.bottom };
}
function windowRect(win) {
  let vp = win.visualViewport;
  if (vp)
    return {
      left: 0,
      right: vp.width,
      top: 0,
      bottom: vp.height
    };
  return {
    left: 0,
    right: win.innerWidth,
    top: 0,
    bottom: win.innerHeight
  };
}
function getScale$1(elt, rect) {
  let scaleX = rect.width / elt.offsetWidth;
  let scaleY = rect.height / elt.offsetHeight;
  if (scaleX > 0.995 && scaleX < 1.005 || !isFinite(scaleX) || Math.abs(rect.width - elt.offsetWidth) < 1)
    scaleX = 1;
  if (scaleY > 0.995 && scaleY < 1.005 || !isFinite(scaleY) || Math.abs(rect.height - elt.offsetHeight) < 1)
    scaleY = 1;
  return { scaleX, scaleY };
}
function scrollRectIntoView(dom, rect, side, x2, y2, xMargin, yMargin, ltr) {
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  for (let cur2 = dom, stop = false; cur2 && !stop; ) {
    if (cur2.nodeType == 1) {
      let bounding, top2 = cur2 == doc2.body;
      let scaleX = 1, scaleY = 1;
      if (top2) {
        bounding = windowRect(win);
      } else {
        if (/^(fixed|sticky)$/.test(getComputedStyle(cur2).position))
          stop = true;
        if (cur2.scrollHeight <= cur2.clientHeight && cur2.scrollWidth <= cur2.clientWidth) {
          cur2 = cur2.assignedSlot || cur2.parentNode;
          continue;
        }
        let rect2 = cur2.getBoundingClientRect();
        ({ scaleX, scaleY } = getScale$1(cur2, rect2));
        bounding = {
          left: rect2.left,
          right: rect2.left + cur2.clientWidth * scaleX,
          top: rect2.top,
          bottom: rect2.top + cur2.clientHeight * scaleY
        };
      }
      let moveX = 0, moveY = 0;
      if (y2 == "nearest") {
        if (rect.top < bounding.top) {
          moveY = rect.top - (bounding.top + yMargin);
          if (side > 0 && rect.bottom > bounding.bottom + moveY)
            moveY = rect.bottom - bounding.bottom + yMargin;
        } else if (rect.bottom > bounding.bottom) {
          moveY = rect.bottom - bounding.bottom + yMargin;
          if (side < 0 && rect.top - moveY < bounding.top)
            moveY = rect.top - (bounding.top + yMargin);
        }
      } else {
        let rectHeight = rect.bottom - rect.top, boundingHeight = bounding.bottom - bounding.top;
        let targetTop = y2 == "center" && rectHeight <= boundingHeight ? rect.top + rectHeight / 2 - boundingHeight / 2 : y2 == "start" || y2 == "center" && side < 0 ? rect.top - yMargin : rect.bottom - boundingHeight + yMargin;
        moveY = targetTop - bounding.top;
      }
      if (x2 == "nearest") {
        if (rect.left < bounding.left) {
          moveX = rect.left - (bounding.left + xMargin);
          if (side > 0 && rect.right > bounding.right + moveX)
            moveX = rect.right - bounding.right + xMargin;
        } else if (rect.right > bounding.right) {
          moveX = rect.right - bounding.right + xMargin;
          if (side < 0 && rect.left < bounding.left + moveX)
            moveX = rect.left - (bounding.left + xMargin);
        }
      } else {
        let targetLeft = x2 == "center" ? rect.left + (rect.right - rect.left) / 2 - (bounding.right - bounding.left) / 2 : x2 == "start" == ltr ? rect.left - xMargin : rect.right - (bounding.right - bounding.left) + xMargin;
        moveX = targetLeft - bounding.left;
      }
      if (moveX || moveY) {
        if (top2) {
          win.scrollBy(moveX, moveY);
        } else {
          let movedX = 0, movedY = 0;
          if (moveY) {
            let start = cur2.scrollTop;
            cur2.scrollTop += moveY / scaleY;
            movedY = (cur2.scrollTop - start) * scaleY;
          }
          if (moveX) {
            let start = cur2.scrollLeft;
            cur2.scrollLeft += moveX / scaleX;
            movedX = (cur2.scrollLeft - start) * scaleX;
          }
          rect = {
            left: rect.left - movedX,
            top: rect.top - movedY,
            right: rect.right - movedX,
            bottom: rect.bottom - movedY
          };
          if (movedX && Math.abs(movedX - moveX) < 1)
            x2 = "nearest";
          if (movedY && Math.abs(movedY - moveY) < 1)
            y2 = "nearest";
        }
      }
      if (top2)
        break;
      if (rect.top < bounding.top || rect.bottom > bounding.bottom || rect.left < bounding.left || rect.right > bounding.right)
        rect = {
          left: Math.max(rect.left, bounding.left),
          right: Math.min(rect.right, bounding.right),
          top: Math.max(rect.top, bounding.top),
          bottom: Math.min(rect.bottom, bounding.bottom)
        };
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
}
function scrollableParents(dom) {
  let doc2 = dom.ownerDocument, x2, y2;
  for (let cur2 = dom.parentNode; cur2; ) {
    if (cur2 == doc2.body || x2 && y2) {
      break;
    } else if (cur2.nodeType == 1) {
      if (!y2 && cur2.scrollHeight > cur2.clientHeight)
        y2 = cur2;
      if (!x2 && cur2.scrollWidth > cur2.clientWidth)
        x2 = cur2;
      cur2 = cur2.assignedSlot || cur2.parentNode;
    } else if (cur2.nodeType == 11) {
      cur2 = cur2.host;
    } else {
      break;
    }
  }
  return { x: x2, y: y2 };
}
class DOMSelectionState {
  constructor() {
    this.anchorNode = null;
    this.anchorOffset = 0;
    this.focusNode = null;
    this.focusOffset = 0;
  }
  eq(domSel) {
    return this.anchorNode == domSel.anchorNode && this.anchorOffset == domSel.anchorOffset && this.focusNode == domSel.focusNode && this.focusOffset == domSel.focusOffset;
  }
  setRange(range2) {
    let { anchorNode, focusNode } = range2;
    this.set(anchorNode, Math.min(range2.anchorOffset, anchorNode ? maxOffset(anchorNode) : 0), focusNode, Math.min(range2.focusOffset, focusNode ? maxOffset(focusNode) : 0));
  }
  set(anchorNode, anchorOffset, focusNode, focusOffset) {
    this.anchorNode = anchorNode;
    this.anchorOffset = anchorOffset;
    this.focusNode = focusNode;
    this.focusOffset = focusOffset;
  }
}
let preventScrollSupported = null;
if (browser$3.safari && browser$3.safari_version >= 26)
  preventScrollSupported = false;
function focusPreventScroll(dom) {
  if (dom.setActive)
    return dom.setActive();
  if (preventScrollSupported)
    return dom.focus(preventScrollSupported);
  let stack = [];
  for (let cur2 = dom; cur2; cur2 = cur2.parentNode) {
    stack.push(cur2, cur2.scrollTop, cur2.scrollLeft);
    if (cur2 == cur2.ownerDocument)
      break;
  }
  dom.focus(preventScrollSupported == null ? {
    get preventScroll() {
      preventScrollSupported = { preventScroll: true };
      return true;
    }
  } : void 0);
  if (!preventScrollSupported) {
    preventScrollSupported = false;
    for (let i2 = 0; i2 < stack.length; ) {
      let elt = stack[i2++], top2 = stack[i2++], left = stack[i2++];
      if (elt.scrollTop != top2)
        elt.scrollTop = top2;
      if (elt.scrollLeft != left)
        elt.scrollLeft = left;
    }
  }
}
let scratchRange;
function textRange(node, from, to2 = from) {
  let range2 = scratchRange || (scratchRange = document.createRange());
  range2.setEnd(node, to2);
  range2.setStart(node, from);
  return range2;
}
function dispatchKey(elt, name2, code2, mods) {
  let options2 = { key: name2, code: name2, keyCode: code2, which: code2, cancelable: true };
  if (mods)
    ({ altKey: options2.altKey, ctrlKey: options2.ctrlKey, shiftKey: options2.shiftKey, metaKey: options2.metaKey } = mods);
  let down = new KeyboardEvent("keydown", options2);
  down.synthetic = true;
  elt.dispatchEvent(down);
  let up = new KeyboardEvent("keyup", options2);
  up.synthetic = true;
  elt.dispatchEvent(up);
  return down.defaultPrevented || up.defaultPrevented;
}
function getRoot(node) {
  while (node) {
    if (node && (node.nodeType == 9 || node.nodeType == 11 && node.host))
      return node;
    node = node.assignedSlot || node.parentNode;
  }
  return null;
}
function clearAttributes(node) {
  while (node.attributes.length)
    node.removeAttributeNode(node.attributes[0]);
}
function atElementStart(doc2, selection2) {
  let node = selection2.focusNode, offset2 = selection2.focusOffset;
  if (!node || selection2.anchorNode != node || selection2.anchorOffset != offset2)
    return false;
  offset2 = Math.min(offset2, maxOffset(node));
  for (; ; ) {
    if (offset2) {
      if (node.nodeType != 1)
        return false;
      let prev = node.childNodes[offset2 - 1];
      if (prev.contentEditable == "false")
        offset2--;
      else {
        node = prev;
        offset2 = maxOffset(node);
      }
    } else if (node == doc2) {
      return true;
    } else {
      offset2 = domIndex(node);
      node = node.parentNode;
    }
  }
}
function isScrolledToBottom(elt) {
  return elt.scrollTop > Math.max(1, elt.scrollHeight - elt.clientHeight - 4);
}
function textNodeBefore(startNode, startOffset) {
  for (let node = startNode, offset2 = startOffset; ; ) {
    if (node.nodeType == 3 && offset2 > 0) {
      return { node, offset: offset2 };
    } else if (node.nodeType == 1 && offset2 > 0) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset2 - 1];
      offset2 = maxOffset(node);
    } else if (node.parentNode && !isBlockElement(node)) {
      offset2 = domIndex(node);
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
function textNodeAfter(startNode, startOffset) {
  for (let node = startNode, offset2 = startOffset; ; ) {
    if (node.nodeType == 3 && offset2 < node.nodeValue.length) {
      return { node, offset: offset2 };
    } else if (node.nodeType == 1 && offset2 < node.childNodes.length) {
      if (node.contentEditable == "false")
        return null;
      node = node.childNodes[offset2];
      offset2 = 0;
    } else if (node.parentNode && !isBlockElement(node)) {
      offset2 = domIndex(node) + 1;
      node = node.parentNode;
    } else {
      return null;
    }
  }
}
class DOMPos {
  constructor(node, offset2, precise = true) {
    this.node = node;
    this.offset = offset2;
    this.precise = precise;
  }
  static before(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom), precise);
  }
  static after(dom, precise) {
    return new DOMPos(dom.parentNode, domIndex(dom) + 1, precise);
  }
}
const noChildren = [];
class ContentView {
  constructor() {
    this.parent = null;
    this.dom = null;
    this.flags = 2;
  }
  get overrideDOMText() {
    return null;
  }
  get posAtStart() {
    return this.parent ? this.parent.posBefore(this) : 0;
  }
  get posAtEnd() {
    return this.posAtStart + this.length;
  }
  posBefore(view) {
    let pos = this.posAtStart;
    for (let child of this.children) {
      if (child == view)
        return pos;
      pos += child.length + child.breakAfter;
    }
    throw new RangeError("Invalid child in posBefore");
  }
  posAfter(view) {
    return this.posBefore(view) + view.length;
  }
  sync(view, track) {
    if (this.flags & 2) {
      let parent = this.dom;
      let prev = null, next;
      for (let child of this.children) {
        if (child.flags & 7) {
          if (!child.dom && (next = prev ? prev.nextSibling : parent.firstChild)) {
            let contentView = ContentView.get(next);
            if (!contentView || !contentView.parent && contentView.canReuseDOM(child))
              child.reuseDOM(next);
          }
          child.sync(view, track);
          child.flags &= -8;
        }
        next = prev ? prev.nextSibling : parent.firstChild;
        if (track && !track.written && track.node == parent && next != child.dom)
          track.written = true;
        if (child.dom.parentNode == parent) {
          while (next && next != child.dom)
            next = rm$1(next);
        } else {
          parent.insertBefore(child.dom, next);
        }
        prev = child.dom;
      }
      next = prev ? prev.nextSibling : parent.firstChild;
      if (next && track && track.node == parent)
        track.written = true;
      while (next)
        next = rm$1(next);
    } else if (this.flags & 1) {
      for (let child of this.children)
        if (child.flags & 7) {
          child.sync(view, track);
          child.flags &= -8;
        }
    }
  }
  reuseDOM(_dom) {
  }
  localPosFromDOM(node, offset2) {
    let after2;
    if (node == this.dom) {
      after2 = this.dom.childNodes[offset2];
    } else {
      let bias = maxOffset(node) == 0 ? 0 : offset2 == 0 ? -1 : 1;
      for (; ; ) {
        let parent = node.parentNode;
        if (parent == this.dom)
          break;
        if (bias == 0 && parent.firstChild != parent.lastChild) {
          if (node == parent.firstChild)
            bias = -1;
          else
            bias = 1;
        }
        node = parent;
      }
      if (bias < 0)
        after2 = node;
      else
        after2 = node.nextSibling;
    }
    if (after2 == this.dom.firstChild)
      return 0;
    while (after2 && !ContentView.get(after2))
      after2 = after2.nextSibling;
    if (!after2)
      return this.length;
    for (let i2 = 0, pos = 0; ; i2++) {
      let child = this.children[i2];
      if (child.dom == after2)
        return pos;
      pos += child.length + child.breakAfter;
    }
  }
  domBoundsAround(from, to2, offset2 = 0) {
    let fromI = -1, fromStart = -1, toI = -1, toEnd = -1;
    for (let i2 = 0, pos = offset2, prevEnd = offset2; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (pos < from && end > to2)
        return child.domBoundsAround(from, to2, pos);
      if (end >= from && fromI == -1) {
        fromI = i2;
        fromStart = pos;
      }
      if (pos > to2 && child.dom.parentNode == this.dom) {
        toI = i2;
        toEnd = prevEnd;
        break;
      }
      prevEnd = end;
      pos = end + child.breakAfter;
    }
    return {
      from: fromStart,
      to: toEnd < 0 ? offset2 + this.length : toEnd,
      startDOM: (fromI ? this.children[fromI - 1].dom.nextSibling : null) || this.dom.firstChild,
      endDOM: toI < this.children.length && toI >= 0 ? this.children[toI].dom : null
    };
  }
  markDirty(andParent = false) {
    this.flags |= 2;
    this.markParentsDirty(andParent);
  }
  markParentsDirty(childList) {
    for (let parent = this.parent; parent; parent = parent.parent) {
      if (childList)
        parent.flags |= 2;
      if (parent.flags & 1)
        return;
      parent.flags |= 1;
      childList = false;
    }
  }
  setParent(parent) {
    if (this.parent != parent) {
      this.parent = parent;
      if (this.flags & 7)
        this.markParentsDirty(true);
    }
  }
  setDOM(dom) {
    if (this.dom == dom)
      return;
    if (this.dom)
      this.dom.cmView = null;
    this.dom = dom;
    dom.cmView = this;
  }
  get rootView() {
    for (let v2 = this; ; ) {
      let parent = v2.parent;
      if (!parent)
        return v2;
      v2 = parent;
    }
  }
  replaceChildren(from, to2, children = noChildren) {
    this.markDirty();
    for (let i2 = from; i2 < to2; i2++) {
      let child = this.children[i2];
      if (child.parent == this && children.indexOf(child) < 0)
        child.destroy();
    }
    if (children.length < 250)
      this.children.splice(from, to2 - from, ...children);
    else
      this.children = [].concat(this.children.slice(0, from), children, this.children.slice(to2));
    for (let i2 = 0; i2 < children.length; i2++)
      children[i2].setParent(this);
  }
  ignoreMutation(_rec) {
    return false;
  }
  ignoreEvent(_event) {
    return false;
  }
  childCursor(pos = this.length) {
    return new ChildCursor(this.children, pos, this.children.length);
  }
  childPos(pos, bias = 1) {
    return this.childCursor().findPos(pos, bias);
  }
  toString() {
    let name2 = this.constructor.name.replace("View", "");
    return name2 + (this.children.length ? "(" + this.children.join() + ")" : this.length ? "[" + (name2 == "Text" ? this.text : this.length) + "]" : "") + (this.breakAfter ? "#" : "");
  }
  static get(node) {
    return node.cmView;
  }
  get isEditable() {
    return true;
  }
  get isWidget() {
    return false;
  }
  get isHidden() {
    return false;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    return false;
  }
  become(other) {
    return false;
  }
  canReuseDOM(other) {
    return other.constructor == this.constructor && !((this.flags | other.flags) & 8);
  }
  // When this is a zero-length view with a side, this should return a
  // number <= 0 to indicate it is before its position, or a
  // number > 0 when after its position.
  getSide() {
    return 0;
  }
  destroy() {
    for (let child of this.children)
      if (child.parent == this)
        child.destroy();
    this.parent = null;
  }
}
ContentView.prototype.breakAfter = 0;
function rm$1(dom) {
  let next = dom.nextSibling;
  dom.parentNode.removeChild(dom);
  return next;
}
class ChildCursor {
  constructor(children, pos, i2) {
    this.children = children;
    this.pos = pos;
    this.i = i2;
    this.off = 0;
  }
  findPos(pos, bias = 1) {
    for (; ; ) {
      if (pos > this.pos || pos == this.pos && (bias > 0 || this.i == 0 || this.children[this.i - 1].breakAfter)) {
        this.off = pos - this.pos;
        return this;
      }
      let next = this.children[--this.i];
      this.pos -= next.length + next.breakAfter;
    }
  }
}
function replaceRange(parent, fromI, fromOff, toI, toOff, insert2, breakAtStart, openStart, openEnd) {
  let { children } = parent;
  let before2 = children.length ? children[fromI] : null;
  let last2 = insert2.length ? insert2[insert2.length - 1] : null;
  let breakAtEnd = last2 ? last2.breakAfter : breakAtStart;
  if (fromI == toI && before2 && !breakAtStart && !breakAtEnd && insert2.length < 2 && before2.merge(fromOff, toOff, insert2.length ? last2 : null, fromOff == 0, openStart, openEnd))
    return;
  if (toI < children.length) {
    let after2 = children[toI];
    if (after2 && (toOff < after2.length || after2.breakAfter && (last2 === null || last2 === void 0 ? void 0 : last2.breakAfter))) {
      if (fromI == toI) {
        after2 = after2.split(toOff);
        toOff = 0;
      }
      if (!breakAtEnd && last2 && after2.merge(0, toOff, last2, true, 0, openEnd)) {
        insert2[insert2.length - 1] = after2;
      } else {
        if (toOff || after2.children.length && !after2.children[0].length)
          after2.merge(0, toOff, null, false, 0, openEnd);
        insert2.push(after2);
      }
    } else if (after2 === null || after2 === void 0 ? void 0 : after2.breakAfter) {
      if (last2)
        last2.breakAfter = 1;
      else
        breakAtStart = 1;
    }
    toI++;
  }
  if (before2) {
    before2.breakAfter = breakAtStart;
    if (fromOff > 0) {
      if (!breakAtStart && insert2.length && before2.merge(fromOff, before2.length, insert2[0], false, openStart, 0)) {
        before2.breakAfter = insert2.shift().breakAfter;
      } else if (fromOff < before2.length || before2.children.length && before2.children[before2.children.length - 1].length == 0) {
        before2.merge(fromOff, before2.length, null, false, openStart, 0);
      }
      fromI++;
    }
  }
  while (fromI < toI && insert2.length) {
    if (children[toI - 1].become(insert2[insert2.length - 1])) {
      toI--;
      insert2.pop();
      openEnd = insert2.length ? 0 : openStart;
    } else if (children[fromI].become(insert2[0])) {
      fromI++;
      insert2.shift();
      openStart = insert2.length ? 0 : openEnd;
    } else {
      break;
    }
  }
  if (!insert2.length && fromI && toI < children.length && !children[fromI - 1].breakAfter && children[toI].merge(0, 0, children[fromI - 1], false, openStart, openEnd))
    fromI--;
  if (fromI < toI || insert2.length)
    parent.replaceChildren(fromI, toI, insert2);
}
function mergeChildrenInto(parent, from, to2, insert2, openStart, openEnd) {
  let cur2 = parent.childCursor();
  let { i: toI, off: toOff } = cur2.findPos(to2, 1);
  let { i: fromI, off: fromOff } = cur2.findPos(from, -1);
  let dLen = from - to2;
  for (let view of insert2)
    dLen += view.length;
  parent.length += dLen;
  replaceRange(parent, fromI, fromOff, toI, toOff, insert2, 0, openStart, openEnd);
}
const MaxJoinLen = 256;
class TextView extends ContentView {
  constructor(text2) {
    super();
    this.text = text2;
  }
  get length() {
    return this.text.length;
  }
  createDOM(textDOM) {
    this.setDOM(textDOM || document.createTextNode(this.text));
  }
  sync(view, track) {
    if (!this.dom)
      this.createDOM();
    if (this.dom.nodeValue != this.text) {
      if (track && track.node == this.dom)
        track.written = true;
      this.dom.nodeValue = this.text;
    }
  }
  reuseDOM(dom) {
    if (dom.nodeType == 3)
      this.createDOM(dom);
  }
  merge(from, to2, source) {
    if (this.flags & 8 || source && (!(source instanceof TextView) || this.length - (to2 - from) + source.length > MaxJoinLen || source.flags & 8))
      return false;
    this.text = this.text.slice(0, from) + (source ? source.text : "") + this.text.slice(to2);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = new TextView(this.text.slice(from));
    this.text = this.text.slice(0, from);
    this.markDirty();
    result2.flags |= this.flags & 8;
    return result2;
  }
  localPosFromDOM(node, offset2) {
    return node == this.dom ? offset2 : offset2 ? this.text.length : 0;
  }
  domAtPos(pos) {
    return new DOMPos(this.dom, pos);
  }
  domBoundsAround(_from, _to, offset2) {
    return { from: offset2, to: offset2 + this.length, startDOM: this.dom, endDOM: this.dom.nextSibling };
  }
  coordsAt(pos, side) {
    return textCoords(this.dom, pos, side);
  }
}
class MarkView extends ContentView {
  constructor(mark2, children = [], length = 0) {
    super();
    this.mark = mark2;
    this.children = children;
    this.length = length;
    for (let ch of children)
      ch.setParent(this);
  }
  setAttrs(dom) {
    clearAttributes(dom);
    if (this.mark.class)
      dom.className = this.mark.class;
    if (this.mark.attrs)
      for (let name2 in this.mark.attrs)
        dom.setAttribute(name2, this.mark.attrs[name2]);
    return dom;
  }
  canReuseDOM(other) {
    return super.canReuseDOM(other) && !((this.flags | other.flags) & 8);
  }
  reuseDOM(node) {
    if (node.nodeName == this.mark.tagName.toUpperCase()) {
      this.setDOM(node);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    if (!this.dom)
      this.setDOM(this.setAttrs(document.createElement(this.mark.tagName)));
    else if (this.flags & 4)
      this.setAttrs(this.dom);
    super.sync(view, track);
  }
  merge(from, to2, source, _hasStart, openStart, openEnd) {
    if (source && (!(source instanceof MarkView && source.mark.eq(this.mark)) || from && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    mergeChildrenInto(this, from, to2, source ? source.children.slice() : [], openStart - 1, openEnd - 1);
    this.markDirty();
    return true;
  }
  split(from) {
    let result2 = [], off = 0, detachFrom = -1, i2 = 0;
    for (let elt of this.children) {
      let end = off + elt.length;
      if (end > from)
        result2.push(off < from ? elt.split(from - off) : elt);
      if (detachFrom < 0 && off >= from)
        detachFrom = i2;
      off = end;
      i2++;
    }
    let length = this.length - from;
    this.length = from;
    if (detachFrom > -1) {
      this.children.length = detachFrom;
      this.markDirty();
    }
    return new MarkView(this.mark, result2, length);
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  coordsAt(pos, side) {
    return coordsInChildren(this, pos, side);
  }
}
function textCoords(text2, pos, side) {
  let length = text2.nodeValue.length;
  if (pos > length)
    pos = length;
  let from = pos, to2 = pos, flatten2 = 0;
  if (pos == 0 && side < 0 || pos == length && side >= 0) {
    if (!(browser$3.chrome || browser$3.gecko)) {
      if (pos) {
        from--;
        flatten2 = 1;
      } else if (to2 < length) {
        to2++;
        flatten2 = -1;
      }
    }
  } else {
    if (side < 0)
      from--;
    else if (to2 < length)
      to2++;
  }
  let rects = textRange(text2, from, to2).getClientRects();
  if (!rects.length)
    return null;
  let rect = rects[(flatten2 ? flatten2 < 0 : side >= 0) ? 0 : rects.length - 1];
  if (browser$3.safari && !flatten2 && rect.width == 0)
    rect = Array.prototype.find.call(rects, (r2) => r2.width) || rect;
  return flatten2 ? flattenRect(rect, flatten2 < 0) : rect || null;
}
class WidgetView extends ContentView {
  static create(widget, length, side) {
    return new WidgetView(widget, length, side);
  }
  constructor(widget, length, side) {
    super();
    this.widget = widget;
    this.length = length;
    this.side = side;
    this.prevWidget = null;
  }
  split(from) {
    let result2 = WidgetView.create(this.widget, this.length - from, this.side);
    this.length -= from;
    return result2;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      if (!this.widget.editable)
        this.dom.contentEditable = "false";
    }
  }
  getSide() {
    return this.side;
  }
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source && (!(source instanceof WidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  become(other) {
    if (other instanceof WidgetView && other.side == this.side && this.widget.constructor == other.widget.constructor) {
      if (!this.widget.compare(other.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get overrideDOMText() {
    if (this.length == 0)
      return Text$1.empty;
    let top2 = this;
    while (top2.parent)
      top2 = top2.parent;
    let { view } = top2, text2 = view && view.state.doc, start = this.posAtStart;
    return text2 ? text2.slice(start, start + this.length) : Text$1.empty;
  }
  domAtPos(pos) {
    return (this.length ? pos == 0 : this.side > 0) ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos, side) {
    let custom = this.widget.coordsAt(this.dom, pos, side);
    if (custom)
      return custom;
    let rects = this.dom.getClientRects(), rect = null;
    if (!rects.length)
      return null;
    let fromBack = this.side ? this.side < 0 : pos > 0;
    for (let i2 = fromBack ? rects.length - 1 : 0; ; i2 += fromBack ? -1 : 1) {
      rect = rects[i2];
      if (pos > 0 ? i2 == 0 : i2 == rects.length - 1 || rect.top < rect.bottom)
        break;
    }
    return flattenRect(rect, !fromBack);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  get isHidden() {
    return this.widget.isHidden;
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
}
class WidgetBufferView extends ContentView {
  constructor(side) {
    super();
    this.side = side;
  }
  get length() {
    return 0;
  }
  merge() {
    return false;
  }
  become(other) {
    return other instanceof WidgetBufferView && other.side == this.side;
  }
  split() {
    return new WidgetBufferView(this.side);
  }
  sync() {
    if (!this.dom) {
      let dom = document.createElement("img");
      dom.className = "cm-widgetBuffer";
      dom.setAttribute("aria-hidden", "true");
      this.setDOM(dom);
    }
  }
  getSide() {
    return this.side;
  }
  domAtPos(pos) {
    return this.side > 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom);
  }
  localPosFromDOM() {
    return 0;
  }
  domBoundsAround() {
    return null;
  }
  coordsAt(pos) {
    return this.dom.getBoundingClientRect();
  }
  get overrideDOMText() {
    return Text$1.empty;
  }
  get isHidden() {
    return true;
  }
}
TextView.prototype.children = WidgetView.prototype.children = WidgetBufferView.prototype.children = noChildren;
function inlineDOMAtPos(parent, pos) {
  let dom = parent.dom, { children } = parent, i2 = 0;
  for (let off = 0; i2 < children.length; i2++) {
    let child = children[i2], end = off + child.length;
    if (end == off && child.getSide() <= 0)
      continue;
    if (pos > off && pos < end && child.dom.parentNode == dom)
      return child.domAtPos(pos - off);
    if (pos <= off)
      break;
    off = end;
  }
  for (let j2 = i2; j2 > 0; j2--) {
    let prev = children[j2 - 1];
    if (prev.dom.parentNode == dom)
      return prev.domAtPos(prev.length);
  }
  for (let j2 = i2; j2 < children.length; j2++) {
    let next = children[j2];
    if (next.dom.parentNode == dom)
      return next.domAtPos(0);
  }
  return new DOMPos(dom, 0);
}
function joinInlineInto(parent, view, open) {
  let last2, { children } = parent;
  if (open > 0 && view instanceof MarkView && children.length && (last2 = children[children.length - 1]) instanceof MarkView && last2.mark.eq(view.mark)) {
    joinInlineInto(last2, view.children[0], open - 1);
  } else {
    children.push(view);
    view.setParent(parent);
  }
  parent.length += view.length;
}
function coordsInChildren(view, pos, side) {
  let before2 = null, beforePos = -1, after2 = null, afterPos = -1;
  function scan(view2, pos2) {
    for (let i2 = 0, off = 0; i2 < view2.children.length && off <= pos2; i2++) {
      let child = view2.children[i2], end = off + child.length;
      if (end >= pos2) {
        if (child.children.length) {
          scan(child, pos2 - off);
        } else if ((!after2 || after2.isHidden && (side > 0 || onSameLine(after2, child))) && (end > pos2 || off == end && child.getSide() > 0)) {
          after2 = child;
          afterPos = pos2 - off;
        } else if (off < pos2 || off == end && child.getSide() < 0 && !child.isHidden) {
          before2 = child;
          beforePos = pos2 - off;
        }
      }
      off = end;
    }
  }
  scan(view, pos);
  let target = (side < 0 ? before2 : after2) || before2 || after2;
  if (target)
    return target.coordsAt(Math.max(0, target == before2 ? beforePos : afterPos), side);
  return fallbackRect(view);
}
function fallbackRect(view) {
  let last2 = view.dom.lastChild;
  if (!last2)
    return view.dom.getBoundingClientRect();
  let rects = clientRectsFor(last2);
  return rects[rects.length - 1] || null;
}
function onSameLine(a2, b2) {
  let posA = a2.coordsAt(0, 1), posB = b2.coordsAt(0, 1);
  return posA && posB && posB.top < posA.bottom;
}
function combineAttrs(source, target) {
  for (let name2 in source) {
    if (name2 == "class" && target.class)
      target.class += " " + source.class;
    else if (name2 == "style" && target.style)
      target.style += ";" + source.style;
    else
      target[name2] = source[name2];
  }
  return target;
}
const noAttrs$1 = /* @__PURE__ */ Object.create(null);
function attrsEq(a2, b2, ignore) {
  if (a2 == b2)
    return true;
  if (!a2)
    a2 = noAttrs$1;
  if (!b2)
    b2 = noAttrs$1;
  let keysA = Object.keys(a2), keysB = Object.keys(b2);
  if (keysA.length - (ignore && keysA.indexOf(ignore) > -1 ? 1 : 0) != keysB.length - (ignore && keysB.indexOf(ignore) > -1 ? 1 : 0))
    return false;
  for (let key of keysA) {
    if (key != ignore && (keysB.indexOf(key) == -1 || a2[key] !== b2[key]))
      return false;
  }
  return true;
}
function updateAttrs(dom, prev, attrs) {
  let changed = false;
  if (prev) {
    for (let name2 in prev)
      if (!(attrs && name2 in attrs)) {
        changed = true;
        if (name2 == "style")
          dom.style.cssText = "";
        else
          dom.removeAttribute(name2);
      }
  }
  if (attrs) {
    for (let name2 in attrs)
      if (!(prev && prev[name2] == attrs[name2])) {
        changed = true;
        if (name2 == "style")
          dom.style.cssText = attrs[name2];
        else
          dom.setAttribute(name2, attrs[name2]);
      }
  }
  return changed;
}
function getAttrs(dom) {
  let attrs = /* @__PURE__ */ Object.create(null);
  for (let i2 = 0; i2 < dom.attributes.length; i2++) {
    let attr = dom.attributes[i2];
    attrs[attr.name] = attr.value;
  }
  return attrs;
}
class WidgetType {
  /**
  Compare this instance to another instance of the same type.
  (TypeScript can't express this, but only instances of the same
  specific class will be passed to this method.) This is used to
  avoid redrawing widgets when they are replaced by a new
  decoration of the same type. The default implementation just
  returns `false`, which will cause new instances of the widget to
  always be redrawn.
  */
  eq(widget) {
    return false;
  }
  /**
  Update a DOM element created by a widget of the same type (but
  different, non-`eq` content) to reflect this widget. May return
  true to indicate that it could update, false to indicate it
  couldn't (in which case the widget will be redrawn). The default
  implementation just returns false.
  */
  updateDOM(dom, view) {
    return false;
  }
  /**
  @internal
  */
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  /**
  The estimated height this widget will have, to be used when
  estimating the height of content that hasn't been drawn. May
  return -1 to indicate you don't know. The default implementation
  returns -1.
  */
  get estimatedHeight() {
    return -1;
  }
  /**
  For inline widgets that are displayed inline (as opposed to
  `inline-block`) and introduce line breaks (through `<br>` tags
  or textual newlines), this must indicate the amount of line
  breaks they introduce. Defaults to 0.
  */
  get lineBreaks() {
    return 0;
  }
  /**
  Can be used to configure which kinds of events inside the widget
  should be ignored by the editor. The default is to ignore all
  events.
  */
  ignoreEvent(event) {
    return true;
  }
  /**
  Override the way screen coordinates for positions at/in the
  widget are found. `pos` will be the offset into the widget, and
  `side` the side of the position that is being queried—less than
  zero for before, greater than zero for after, and zero for
  directly at that position.
  */
  coordsAt(dom, pos, side) {
    return null;
  }
  /**
  @internal
  */
  get isHidden() {
    return false;
  }
  /**
  @internal
  */
  get editable() {
    return false;
  }
  /**
  This is called when the an instance of the widget is removed
  from the editor view.
  */
  destroy(dom) {
  }
}
var BlockType = /* @__PURE__ */ (function(BlockType2) {
  BlockType2[BlockType2["Text"] = 0] = "Text";
  BlockType2[BlockType2["WidgetBefore"] = 1] = "WidgetBefore";
  BlockType2[BlockType2["WidgetAfter"] = 2] = "WidgetAfter";
  BlockType2[BlockType2["WidgetRange"] = 3] = "WidgetRange";
  return BlockType2;
})(BlockType || (BlockType = {}));
class Decoration extends RangeValue {
  constructor(startSide, endSide, widget, spec) {
    super();
    this.startSide = startSide;
    this.endSide = endSide;
    this.widget = widget;
    this.spec = spec;
  }
  /**
  @internal
  */
  get heightRelevant() {
    return false;
  }
  /**
  Create a mark decoration, which influences the styling of the
  content in its range. Nested mark decorations will cause nested
  DOM elements to be created. Nesting order is determined by
  precedence of the [facet](https://codemirror.net/6/docs/ref/#view.EditorView^decorations), with
  the higher-precedence decorations creating the inner DOM nodes.
  Such elements are split on line boundaries and on the boundaries
  of lower-precedence decorations.
  */
  static mark(spec) {
    return new MarkDecoration(spec);
  }
  /**
  Create a widget decoration, which displays a DOM element at the
  given position.
  */
  static widget(spec) {
    let side = Math.max(-1e4, Math.min(1e4, spec.side || 0)), block = !!spec.block;
    side += block && !spec.inlineOrder ? side > 0 ? 3e8 : -4e8 : side > 0 ? 1e8 : -1e8;
    return new PointDecoration(spec, side, side, block, spec.widget || null, false);
  }
  /**
  Create a replace decoration which replaces the given range with
  a widget, or simply hides it.
  */
  static replace(spec) {
    let block = !!spec.block, startSide, endSide;
    if (spec.isBlockGap) {
      startSide = -5e8;
      endSide = 4e8;
    } else {
      let { start, end } = getInclusive(spec, block);
      startSide = (start ? block ? -3e8 : -1 : 5e8) - 1;
      endSide = (end ? block ? 2e8 : 1 : -6e8) + 1;
    }
    return new PointDecoration(spec, startSide, endSide, block, spec.widget || null, true);
  }
  /**
  Create a line decoration, which can add DOM attributes to the
  line starting at the given position.
  */
  static line(spec) {
    return new LineDecoration(spec);
  }
  /**
  Build a [`DecorationSet`](https://codemirror.net/6/docs/ref/#view.DecorationSet) from the given
  decorated range or ranges. If the ranges aren't already sorted,
  pass `true` for `sort` to make the library sort them for you.
  */
  static set(of, sort = false) {
    return RangeSet.of(of, sort);
  }
  /**
  @internal
  */
  hasHeight() {
    return this.widget ? this.widget.estimatedHeight > -1 : false;
  }
}
Decoration.none = RangeSet.empty;
class MarkDecoration extends Decoration {
  constructor(spec) {
    let { start, end } = getInclusive(spec);
    super(start ? -1 : 5e8, end ? 1 : -6e8, null, spec);
    this.tagName = spec.tagName || "span";
    this.class = spec.class || "";
    this.attrs = spec.attributes || null;
  }
  eq(other) {
    var _a2, _b;
    return this == other || other instanceof MarkDecoration && this.tagName == other.tagName && (this.class || ((_a2 = this.attrs) === null || _a2 === void 0 ? void 0 : _a2.class)) == (other.class || ((_b = other.attrs) === null || _b === void 0 ? void 0 : _b.class)) && attrsEq(this.attrs, other.attrs, "class");
  }
  range(from, to2 = from) {
    if (from >= to2)
      throw new RangeError("Mark decorations may not be empty");
    return super.range(from, to2);
  }
}
MarkDecoration.prototype.point = false;
class LineDecoration extends Decoration {
  constructor(spec) {
    super(-2e8, -2e8, null, spec);
  }
  eq(other) {
    return other instanceof LineDecoration && this.spec.class == other.spec.class && attrsEq(this.spec.attributes, other.spec.attributes);
  }
  range(from, to2 = from) {
    if (to2 != from)
      throw new RangeError("Line decoration ranges must be zero-length");
    return super.range(from, to2);
  }
}
LineDecoration.prototype.mapMode = MapMode.TrackBefore;
LineDecoration.prototype.point = true;
class PointDecoration extends Decoration {
  constructor(spec, startSide, endSide, block, widget, isReplace) {
    super(startSide, endSide, widget, spec);
    this.block = block;
    this.isReplace = isReplace;
    this.mapMode = !block ? MapMode.TrackDel : startSide <= 0 ? MapMode.TrackBefore : MapMode.TrackAfter;
  }
  // Only relevant when this.block == true
  get type() {
    return this.startSide != this.endSide ? BlockType.WidgetRange : this.startSide <= 0 ? BlockType.WidgetBefore : BlockType.WidgetAfter;
  }
  get heightRelevant() {
    return this.block || !!this.widget && (this.widget.estimatedHeight >= 5 || this.widget.lineBreaks > 0);
  }
  eq(other) {
    return other instanceof PointDecoration && widgetsEq(this.widget, other.widget) && this.block == other.block && this.startSide == other.startSide && this.endSide == other.endSide;
  }
  range(from, to2 = from) {
    if (this.isReplace && (from > to2 || from == to2 && this.startSide > 0 && this.endSide <= 0))
      throw new RangeError("Invalid range for replacement decoration");
    if (!this.isReplace && to2 != from)
      throw new RangeError("Widget decorations can only have zero-length ranges");
    return super.range(from, to2);
  }
}
PointDecoration.prototype.point = true;
function getInclusive(spec, block = false) {
  let { inclusiveStart: start, inclusiveEnd: end } = spec;
  if (start == null)
    start = spec.inclusive;
  if (end == null)
    end = spec.inclusive;
  return { start: start !== null && start !== void 0 ? start : block, end: end !== null && end !== void 0 ? end : block };
}
function widgetsEq(a2, b2) {
  return a2 == b2 || !!(a2 && b2 && a2.compare(b2));
}
function addRange(from, to2, ranges, margin = 0) {
  let last2 = ranges.length - 1;
  if (last2 >= 0 && ranges[last2] + margin >= from)
    ranges[last2] = Math.max(ranges[last2], to2);
  else
    ranges.push(from, to2);
}
class LineView extends ContentView {
  constructor() {
    super(...arguments);
    this.children = [];
    this.length = 0;
    this.prevAttrs = void 0;
    this.attrs = null;
    this.breakAfter = 0;
  }
  // Consumes source
  merge(from, to2, source, hasStart, openStart, openEnd) {
    if (source) {
      if (!(source instanceof LineView))
        return false;
      if (!this.dom)
        source.transferDOM(this);
    }
    if (hasStart)
      this.setDeco(source ? source.attrs : null);
    mergeChildrenInto(this, from, to2, source ? source.children.slice() : [], openStart, openEnd);
    return true;
  }
  split(at2) {
    let end = new LineView();
    end.breakAfter = this.breakAfter;
    if (this.length == 0)
      return end;
    let { i: i2, off } = this.childPos(at2);
    if (off) {
      end.append(this.children[i2].split(off), 0);
      this.children[i2].merge(off, this.children[i2].length, null, false, 0, 0);
      i2++;
    }
    for (let j2 = i2; j2 < this.children.length; j2++)
      end.append(this.children[j2], 0);
    while (i2 > 0 && this.children[i2 - 1].length == 0)
      this.children[--i2].destroy();
    this.children.length = i2;
    this.markDirty();
    this.length = at2;
    return end;
  }
  transferDOM(other) {
    if (!this.dom)
      return;
    this.markDirty();
    other.setDOM(this.dom);
    other.prevAttrs = this.prevAttrs === void 0 ? this.attrs : this.prevAttrs;
    this.prevAttrs = void 0;
    this.dom = null;
  }
  setDeco(attrs) {
    if (!attrsEq(this.attrs, attrs)) {
      if (this.dom) {
        this.prevAttrs = this.attrs;
        this.markDirty();
      }
      this.attrs = attrs;
    }
  }
  append(child, openStart) {
    joinInlineInto(this, child, openStart);
  }
  // Only called when building a line view in ContentBuilder
  addLineDeco(deco) {
    let attrs = deco.spec.attributes, cls = deco.spec.class;
    if (attrs)
      this.attrs = combineAttrs(attrs, this.attrs || {});
    if (cls)
      this.attrs = combineAttrs({ class: cls }, this.attrs || {});
  }
  domAtPos(pos) {
    return inlineDOMAtPos(this, pos);
  }
  reuseDOM(node) {
    if (node.nodeName == "DIV") {
      this.setDOM(node);
      this.flags |= 4 | 2;
    }
  }
  sync(view, track) {
    var _a2;
    if (!this.dom) {
      this.setDOM(document.createElement("div"));
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    } else if (this.flags & 4) {
      clearAttributes(this.dom);
      this.dom.className = "cm-line";
      this.prevAttrs = this.attrs ? null : void 0;
    }
    if (this.prevAttrs !== void 0) {
      updateAttrs(this.dom, this.prevAttrs, this.attrs);
      this.dom.classList.add("cm-line");
      this.prevAttrs = void 0;
    }
    super.sync(view, track);
    let last2 = this.dom.lastChild;
    while (last2 && ContentView.get(last2) instanceof MarkView)
      last2 = last2.lastChild;
    if (!last2 || !this.length || last2.nodeName != "BR" && ((_a2 = ContentView.get(last2)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) == false && (!browser$3.ios || !this.children.some((ch) => ch instanceof TextView))) {
      let hack = document.createElement("BR");
      hack.cmIgnore = true;
      this.dom.appendChild(hack);
    }
  }
  measureTextSize() {
    if (this.children.length == 0 || this.length > 20)
      return null;
    let totalWidth = 0, textHeight;
    for (let child of this.children) {
      if (!(child instanceof TextView) || /[^ -~]/.test(child.text))
        return null;
      let rects = clientRectsFor(child.dom);
      if (rects.length != 1)
        return null;
      totalWidth += rects[0].width;
      textHeight = rects[0].height;
    }
    return !totalWidth ? null : {
      lineHeight: this.dom.getBoundingClientRect().height,
      charWidth: totalWidth / this.length,
      textHeight
    };
  }
  coordsAt(pos, side) {
    let rect = coordsInChildren(this, pos, side);
    if (!this.children.length && rect && this.parent) {
      let { heightOracle } = this.parent.view.viewState, height = rect.bottom - rect.top;
      if (Math.abs(height - heightOracle.lineHeight) < 2 && heightOracle.textHeight < height) {
        let dist2 = (height - heightOracle.textHeight) / 2;
        return { top: rect.top + dist2, bottom: rect.bottom - dist2, left: rect.left, right: rect.left };
      }
    }
    return rect;
  }
  become(other) {
    return other instanceof LineView && this.children.length == 0 && other.children.length == 0 && attrsEq(this.attrs, other.attrs) && this.breakAfter == other.breakAfter;
  }
  covers() {
    return true;
  }
  static find(docView, pos) {
    for (let i2 = 0, off = 0; i2 < docView.children.length; i2++) {
      let block = docView.children[i2], end = off + block.length;
      if (end >= pos) {
        if (block instanceof LineView)
          return block;
        if (end > pos)
          break;
      }
      off = end + block.breakAfter;
    }
    return null;
  }
}
class BlockWidgetView extends ContentView {
  constructor(widget, length, deco) {
    super();
    this.widget = widget;
    this.length = length;
    this.deco = deco;
    this.breakAfter = 0;
    this.prevWidget = null;
  }
  merge(from, to2, source, _takeDeco, openStart, openEnd) {
    if (source && (!(source instanceof BlockWidgetView) || !this.widget.compare(source.widget) || from > 0 && openStart <= 0 || to2 < this.length && openEnd <= 0))
      return false;
    this.length = from + (source ? source.length : 0) + (this.length - to2);
    return true;
  }
  domAtPos(pos) {
    return pos == 0 ? DOMPos.before(this.dom) : DOMPos.after(this.dom, pos == this.length);
  }
  split(at2) {
    let len = this.length - at2;
    this.length = at2;
    let end = new BlockWidgetView(this.widget, len, this.deco);
    end.breakAfter = this.breakAfter;
    return end;
  }
  get children() {
    return noChildren;
  }
  sync(view) {
    if (!this.dom || !this.widget.updateDOM(this.dom, view)) {
      if (this.dom && this.prevWidget)
        this.prevWidget.destroy(this.dom);
      this.prevWidget = null;
      this.setDOM(this.widget.toDOM(view));
      if (!this.widget.editable)
        this.dom.contentEditable = "false";
    }
  }
  get overrideDOMText() {
    return this.parent ? this.parent.view.state.doc.slice(this.posAtStart, this.posAtEnd) : Text$1.empty;
  }
  domBoundsAround() {
    return null;
  }
  become(other) {
    if (other instanceof BlockWidgetView && other.widget.constructor == this.widget.constructor) {
      if (!other.widget.compare(this.widget))
        this.markDirty(true);
      if (this.dom && !this.prevWidget)
        this.prevWidget = this.widget;
      this.widget = other.widget;
      this.length = other.length;
      this.deco = other.deco;
      this.breakAfter = other.breakAfter;
      return true;
    }
    return false;
  }
  ignoreMutation() {
    return true;
  }
  ignoreEvent(event) {
    return this.widget.ignoreEvent(event);
  }
  get isEditable() {
    return false;
  }
  get isWidget() {
    return true;
  }
  coordsAt(pos, side) {
    let custom = this.widget.coordsAt(this.dom, pos, side);
    if (custom)
      return custom;
    if (this.widget instanceof BlockGapWidget)
      return null;
    return flattenRect(this.dom.getBoundingClientRect(), this.length ? pos == 0 : side <= 0);
  }
  destroy() {
    super.destroy();
    if (this.dom)
      this.widget.destroy(this.dom);
  }
  covers(side) {
    let { startSide, endSide } = this.deco;
    return startSide == endSide ? false : side < 0 ? startSide < 0 : endSide > 0;
  }
}
class BlockGapWidget extends WidgetType {
  constructor(height) {
    super();
    this.height = height;
  }
  toDOM() {
    let elt = document.createElement("div");
    elt.className = "cm-gap";
    this.updateDOM(elt);
    return elt;
  }
  eq(other) {
    return other.height == this.height;
  }
  updateDOM(elt) {
    elt.style.height = this.height + "px";
    return true;
  }
  get editable() {
    return true;
  }
  get estimatedHeight() {
    return this.height;
  }
  ignoreEvent() {
    return false;
  }
}
class ContentBuilder {
  constructor(doc2, pos, end, disallowBlockEffectsFor) {
    this.doc = doc2;
    this.pos = pos;
    this.end = end;
    this.disallowBlockEffectsFor = disallowBlockEffectsFor;
    this.content = [];
    this.curLine = null;
    this.breakAtStart = 0;
    this.pendingBuffer = 0;
    this.bufferMarks = [];
    this.atCursorPos = true;
    this.openStart = -1;
    this.openEnd = -1;
    this.text = "";
    this.textOff = 0;
    this.cursor = doc2.iter();
    this.skip = pos;
  }
  posCovered() {
    if (this.content.length == 0)
      return !this.breakAtStart && this.doc.lineAt(this.pos).from != this.pos;
    let last2 = this.content[this.content.length - 1];
    return !(last2.breakAfter || last2 instanceof BlockWidgetView && last2.deco.endSide < 0);
  }
  getLine() {
    if (!this.curLine) {
      this.content.push(this.curLine = new LineView());
      this.atCursorPos = true;
    }
    return this.curLine;
  }
  flushBuffer(active = this.bufferMarks) {
    if (this.pendingBuffer) {
      this.curLine.append(wrapMarks(new WidgetBufferView(-1), active), active.length);
      this.pendingBuffer = 0;
    }
  }
  addBlockWidget(view) {
    this.flushBuffer();
    this.curLine = null;
    this.content.push(view);
  }
  finish(openEnd) {
    if (this.pendingBuffer && openEnd <= this.bufferMarks.length)
      this.flushBuffer();
    else
      this.pendingBuffer = 0;
    if (!this.posCovered() && !(openEnd && this.content.length && this.content[this.content.length - 1] instanceof BlockWidgetView))
      this.getLine();
  }
  buildText(length, active, openStart) {
    while (length > 0) {
      if (this.textOff == this.text.length) {
        let { value, lineBreak, done } = this.cursor.next(this.skip);
        this.skip = 0;
        if (done)
          throw new Error("Ran out of text content when drawing inline views");
        if (lineBreak) {
          if (!this.posCovered())
            this.getLine();
          if (this.content.length)
            this.content[this.content.length - 1].breakAfter = 1;
          else
            this.breakAtStart = 1;
          this.flushBuffer();
          this.curLine = null;
          this.atCursorPos = true;
          length--;
          continue;
        } else {
          this.text = value;
          this.textOff = 0;
        }
      }
      let remaining = Math.min(this.text.length - this.textOff, length);
      let take = Math.min(
        remaining,
        512
        /* T.Chunk */
      );
      this.flushBuffer(active.slice(active.length - openStart));
      this.getLine().append(wrapMarks(new TextView(this.text.slice(this.textOff, this.textOff + take)), active), openStart);
      this.atCursorPos = true;
      this.textOff += take;
      length -= take;
      openStart = remaining <= take ? 0 : active.length;
    }
  }
  span(from, to2, active, openStart) {
    this.buildText(to2 - from, active, openStart);
    this.pos = to2;
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  point(from, to2, deco, active, openStart, index2) {
    if (this.disallowBlockEffectsFor[index2] && deco instanceof PointDecoration) {
      if (deco.block)
        throw new RangeError("Block decorations may not be specified via plugins");
      if (to2 > this.doc.lineAt(this.pos).to)
        throw new RangeError("Decorations that replace line breaks may not be specified via plugins");
    }
    let len = to2 - from;
    if (deco instanceof PointDecoration) {
      if (deco.block) {
        if (deco.startSide > 0 && !this.posCovered())
          this.getLine();
        this.addBlockWidget(new BlockWidgetView(deco.widget || NullWidget.block, len, deco));
      } else {
        let view = WidgetView.create(deco.widget || NullWidget.inline, len, len ? 0 : deco.startSide);
        let cursorBefore = this.atCursorPos && !view.isEditable && openStart <= active.length && (from < to2 || deco.startSide > 0);
        let cursorAfter = !view.isEditable && (from < to2 || openStart > active.length || deco.startSide <= 0);
        let line2 = this.getLine();
        if (this.pendingBuffer == 2 && !cursorBefore && !view.isEditable)
          this.pendingBuffer = 0;
        this.flushBuffer(active);
        if (cursorBefore) {
          line2.append(wrapMarks(new WidgetBufferView(1), active), openStart);
          openStart = active.length + Math.max(0, openStart - active.length);
        }
        line2.append(wrapMarks(view, active), openStart);
        this.atCursorPos = cursorAfter;
        this.pendingBuffer = !cursorAfter ? 0 : from < to2 || openStart > active.length ? 1 : 2;
        if (this.pendingBuffer)
          this.bufferMarks = active.slice();
      }
    } else if (this.doc.lineAt(this.pos).from == this.pos) {
      this.getLine().addLineDeco(deco);
    }
    if (len) {
      if (this.textOff + len <= this.text.length) {
        this.textOff += len;
      } else {
        this.skip += len - (this.text.length - this.textOff);
        this.text = "";
        this.textOff = 0;
      }
      this.pos = to2;
    }
    if (this.openStart < 0)
      this.openStart = openStart;
  }
  static build(text2, from, to2, decorations2, dynamicDecorationMap) {
    let builder = new ContentBuilder(text2, from, to2, dynamicDecorationMap);
    builder.openEnd = RangeSet.spans(decorations2, from, to2, builder);
    if (builder.openStart < 0)
      builder.openStart = builder.openEnd;
    builder.finish(builder.openEnd);
    return builder;
  }
}
function wrapMarks(view, active) {
  for (let mark2 of active)
    view = new MarkView(mark2, [view], view.length);
  return view;
}
class NullWidget extends WidgetType {
  constructor(tag2) {
    super();
    this.tag = tag2;
  }
  eq(other) {
    return other.tag == this.tag;
  }
  toDOM() {
    return document.createElement(this.tag);
  }
  updateDOM(elt) {
    return elt.nodeName.toLowerCase() == this.tag;
  }
  get isHidden() {
    return true;
  }
}
NullWidget.inline = /* @__PURE__ */ new NullWidget("span");
NullWidget.block = /* @__PURE__ */ new NullWidget("div");
var Direction = /* @__PURE__ */ (function(Direction2) {
  Direction2[Direction2["LTR"] = 0] = "LTR";
  Direction2[Direction2["RTL"] = 1] = "RTL";
  return Direction2;
})(Direction || (Direction = {}));
const LTR = Direction.LTR, RTL = Direction.RTL;
function dec(str) {
  let result2 = [];
  for (let i2 = 0; i2 < str.length; i2++)
    result2.push(1 << +str[i2]);
  return result2;
}
const LowTypes = /* @__PURE__ */ dec("88888888888888888888888888888888888666888888787833333333337888888000000000000000000000000008888880000000000000000000000000088888888888888888888888888888888888887866668888088888663380888308888800000000000000000000000800000000000000000000000000000008");
const ArabicTypes = /* @__PURE__ */ dec("4444448826627288999999999992222222222222222222222222222222222222222222222229999999999999999999994444444444644222822222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222222999999949999999229989999223333333333");
const Brackets = /* @__PURE__ */ Object.create(null), BracketStack = [];
for (let p2 of ["()", "[]", "{}"]) {
  let l2 = /* @__PURE__ */ p2.charCodeAt(0), r2 = /* @__PURE__ */ p2.charCodeAt(1);
  Brackets[l2] = r2;
  Brackets[r2] = -l2;
}
function charType(ch) {
  return ch <= 247 ? LowTypes[ch] : 1424 <= ch && ch <= 1524 ? 2 : 1536 <= ch && ch <= 1785 ? ArabicTypes[ch - 1536] : 1774 <= ch && ch <= 2220 ? 4 : 8192 <= ch && ch <= 8204 ? 256 : 64336 <= ch && ch <= 65023 ? 4 : 1;
}
const BidiRE = /[\u0590-\u05f4\u0600-\u06ff\u0700-\u08ac\ufb50-\ufdff]/;
class BidiSpan {
  /**
  The direction of this span.
  */
  get dir() {
    return this.level % 2 ? RTL : LTR;
  }
  /**
  @internal
  */
  constructor(from, to2, level) {
    this.from = from;
    this.to = to2;
    this.level = level;
  }
  /**
  @internal
  */
  side(end, dir) {
    return this.dir == dir == end ? this.to : this.from;
  }
  /**
  @internal
  */
  forward(forward, dir) {
    return forward == (this.dir == dir);
  }
  /**
  @internal
  */
  static find(order2, index2, level, assoc) {
    let maybe = -1;
    for (let i2 = 0; i2 < order2.length; i2++) {
      let span = order2[i2];
      if (span.from <= index2 && span.to >= index2) {
        if (span.level == level)
          return i2;
        if (maybe < 0 || (assoc != 0 ? assoc < 0 ? span.from < index2 : span.to > index2 : order2[maybe].level > span.level))
          maybe = i2;
      }
    }
    if (maybe < 0)
      throw new RangeError("Index out of range");
    return maybe;
  }
}
function isolatesEq(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++) {
    let iA = a2[i2], iB = b2[i2];
    if (iA.from != iB.from || iA.to != iB.to || iA.direction != iB.direction || !isolatesEq(iA.inner, iB.inner))
      return false;
  }
  return true;
}
const types = [];
function computeCharTypes(line2, rFrom, rTo, isolates, outerType) {
  for (let iI = 0; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    let prevType = iI ? 256 : outerType;
    for (let i2 = from, prev = prevType, prevStrong = prevType; i2 < to2; i2++) {
      let type = charType(line2.charCodeAt(i2));
      if (type == 512)
        type = prev;
      else if (type == 8 && prevStrong == 4)
        type = 16;
      types[i2] = type == 4 ? 2 : type;
      if (type & 7)
        prevStrong = type;
      prev = type;
    }
    for (let i2 = from, prev = prevType, prevStrong = prevType; i2 < to2; i2++) {
      let type = types[i2];
      if (type == 128) {
        if (i2 < to2 - 1 && prev == types[i2 + 1] && prev & 24)
          type = types[i2] = prev;
        else
          types[i2] = 256;
      } else if (type == 64) {
        let end = i2 + 1;
        while (end < to2 && types[end] == 64)
          end++;
        let replace2 = i2 && prev == 8 || end < rTo && types[end] == 8 ? prevStrong == 1 ? 1 : 8 : 256;
        for (let j2 = i2; j2 < end; j2++)
          types[j2] = replace2;
        i2 = end - 1;
      } else if (type == 8 && prevStrong == 1) {
        types[i2] = 1;
      }
      prev = type;
      if (type & 7)
        prevStrong = type;
    }
  }
}
function processBracketPairs(line2, rFrom, rTo, isolates, outerType) {
  let oppositeType = outerType == 1 ? 2 : 1;
  for (let iI = 0, sI = 0, context = 0; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    for (let i2 = from, ch, br2, type; i2 < to2; i2++) {
      if (br2 = Brackets[ch = line2.charCodeAt(i2)]) {
        if (br2 < 0) {
          for (let sJ = sI - 3; sJ >= 0; sJ -= 3) {
            if (BracketStack[sJ + 1] == -br2) {
              let flags = BracketStack[sJ + 2];
              let type2 = flags & 2 ? outerType : !(flags & 4) ? 0 : flags & 1 ? oppositeType : outerType;
              if (type2)
                types[i2] = types[BracketStack[sJ]] = type2;
              sI = sJ;
              break;
            }
          }
        } else if (BracketStack.length == 189) {
          break;
        } else {
          BracketStack[sI++] = i2;
          BracketStack[sI++] = ch;
          BracketStack[sI++] = context;
        }
      } else if ((type = types[i2]) == 2 || type == 1) {
        let embed = type == outerType;
        context = embed ? 0 : 1;
        for (let sJ = sI - 3; sJ >= 0; sJ -= 3) {
          let cur2 = BracketStack[sJ + 2];
          if (cur2 & 2)
            break;
          if (embed) {
            BracketStack[sJ + 2] |= 2;
          } else {
            if (cur2 & 4)
              break;
            BracketStack[sJ + 2] |= 4;
          }
        }
      }
    }
  }
}
function processNeutrals(rFrom, rTo, isolates, outerType) {
  for (let iI = 0, prev = outerType; iI <= isolates.length; iI++) {
    let from = iI ? isolates[iI - 1].to : rFrom, to2 = iI < isolates.length ? isolates[iI].from : rTo;
    for (let i2 = from; i2 < to2; ) {
      let type = types[i2];
      if (type == 256) {
        let end = i2 + 1;
        for (; ; ) {
          if (end == to2) {
            if (iI == isolates.length)
              break;
            end = isolates[iI++].to;
            to2 = iI < isolates.length ? isolates[iI].from : rTo;
          } else if (types[end] == 256) {
            end++;
          } else {
            break;
          }
        }
        let beforeL = prev == 1;
        let afterL = (end < rTo ? types[end] : outerType) == 1;
        let replace2 = beforeL == afterL ? beforeL ? 1 : 2 : outerType;
        for (let j2 = end, jI = iI, fromJ = jI ? isolates[jI - 1].to : rFrom; j2 > i2; ) {
          if (j2 == fromJ) {
            j2 = isolates[--jI].from;
            fromJ = jI ? isolates[jI - 1].to : rFrom;
          }
          types[--j2] = replace2;
        }
        i2 = end;
      } else {
        prev = type;
        i2++;
      }
    }
  }
}
function emitSpans(line2, from, to2, level, baseLevel, isolates, order2) {
  let ourType = level % 2 ? 2 : 1;
  if (level % 2 == baseLevel % 2) {
    for (let iCh = from, iI = 0; iCh < to2; ) {
      let sameDir = true, isNum = false;
      if (iI == isolates.length || iCh < isolates[iI].from) {
        let next = types[iCh];
        if (next != ourType) {
          sameDir = false;
          isNum = next == 16;
        }
      }
      let recurse = !sameDir && ourType == 1 ? [] : null;
      let localLevel = sameDir ? level : level + 1;
      let iScan = iCh;
      run: for (; ; ) {
        if (iI < isolates.length && iScan == isolates[iI].from) {
          if (isNum)
            break run;
          let iso = isolates[iI];
          if (!sameDir)
            for (let upto = iso.to, jI = iI + 1; ; ) {
              if (upto == to2)
                break run;
              if (jI < isolates.length && isolates[jI].from == upto)
                upto = isolates[jI++].to;
              else if (types[upto] == ourType)
                break run;
              else
                break;
            }
          iI++;
          if (recurse) {
            recurse.push(iso);
          } else {
            if (iso.from > iCh)
              order2.push(new BidiSpan(iCh, iso.from, localLevel));
            let dirSwap = iso.direction == LTR != !(localLevel % 2);
            computeSectionOrder(line2, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order2);
            iCh = iso.to;
          }
          iScan = iso.to;
        } else if (iScan == to2 || (sameDir ? types[iScan] != ourType : types[iScan] == ourType)) {
          break;
        } else {
          iScan++;
        }
      }
      if (recurse)
        emitSpans(line2, iCh, iScan, level + 1, baseLevel, recurse, order2);
      else if (iCh < iScan)
        order2.push(new BidiSpan(iCh, iScan, localLevel));
      iCh = iScan;
    }
  } else {
    for (let iCh = to2, iI = isolates.length; iCh > from; ) {
      let sameDir = true, isNum = false;
      if (!iI || iCh > isolates[iI - 1].to) {
        let next = types[iCh - 1];
        if (next != ourType) {
          sameDir = false;
          isNum = next == 16;
        }
      }
      let recurse = !sameDir && ourType == 1 ? [] : null;
      let localLevel = sameDir ? level : level + 1;
      let iScan = iCh;
      run: for (; ; ) {
        if (iI && iScan == isolates[iI - 1].to) {
          if (isNum)
            break run;
          let iso = isolates[--iI];
          if (!sameDir)
            for (let upto = iso.from, jI = iI; ; ) {
              if (upto == from)
                break run;
              if (jI && isolates[jI - 1].to == upto)
                upto = isolates[--jI].from;
              else if (types[upto - 1] == ourType)
                break run;
              else
                break;
            }
          if (recurse) {
            recurse.push(iso);
          } else {
            if (iso.to < iCh)
              order2.push(new BidiSpan(iso.to, iCh, localLevel));
            let dirSwap = iso.direction == LTR != !(localLevel % 2);
            computeSectionOrder(line2, dirSwap ? level + 1 : level, baseLevel, iso.inner, iso.from, iso.to, order2);
            iCh = iso.from;
          }
          iScan = iso.from;
        } else if (iScan == from || (sameDir ? types[iScan - 1] != ourType : types[iScan - 1] == ourType)) {
          break;
        } else {
          iScan--;
        }
      }
      if (recurse)
        emitSpans(line2, iScan, iCh, level + 1, baseLevel, recurse, order2);
      else if (iScan < iCh)
        order2.push(new BidiSpan(iScan, iCh, localLevel));
      iCh = iScan;
    }
  }
}
function computeSectionOrder(line2, level, baseLevel, isolates, from, to2, order2) {
  let outerType = level % 2 ? 2 : 1;
  computeCharTypes(line2, from, to2, isolates, outerType);
  processBracketPairs(line2, from, to2, isolates, outerType);
  processNeutrals(from, to2, isolates, outerType);
  emitSpans(line2, from, to2, level, baseLevel, isolates, order2);
}
function computeOrder(line2, direction, isolates) {
  if (!line2)
    return [new BidiSpan(0, 0, direction == RTL ? 1 : 0)];
  if (direction == LTR && !isolates.length && !BidiRE.test(line2))
    return trivialOrder(line2.length);
  if (isolates.length)
    while (line2.length > types.length)
      types[types.length] = 256;
  let order2 = [], level = direction == LTR ? 0 : 1;
  computeSectionOrder(line2, level, level, isolates, 0, line2.length, order2);
  return order2;
}
function trivialOrder(length) {
  return [new BidiSpan(0, length, 0)];
}
let movedOver = "";
function moveVisually(line2, order2, dir, start, forward) {
  var _a2;
  let startIndex = start.head - line2.from;
  let spanI = BidiSpan.find(order2, startIndex, (_a2 = start.bidiLevel) !== null && _a2 !== void 0 ? _a2 : -1, start.assoc);
  let span = order2[spanI], spanEnd = span.side(forward, dir);
  if (startIndex == spanEnd) {
    let nextI = spanI += forward ? 1 : -1;
    if (nextI < 0 || nextI >= order2.length)
      return null;
    span = order2[spanI = nextI];
    startIndex = span.side(!forward, dir);
    spanEnd = span.side(forward, dir);
  }
  let nextIndex = findClusterBreak(line2.text, startIndex, span.forward(forward, dir));
  if (nextIndex < span.from || nextIndex > span.to)
    nextIndex = spanEnd;
  movedOver = line2.text.slice(Math.min(startIndex, nextIndex), Math.max(startIndex, nextIndex));
  let nextSpan = spanI == (forward ? order2.length - 1 : 0) ? null : order2[spanI + (forward ? 1 : -1)];
  if (nextSpan && nextIndex == spanEnd && nextSpan.level + (forward ? 0 : 1) < span.level)
    return EditorSelection.cursor(nextSpan.side(!forward, dir) + line2.from, nextSpan.forward(forward, dir) ? 1 : -1, nextSpan.level);
  return EditorSelection.cursor(nextIndex + line2.from, span.forward(forward, dir) ? -1 : 1, span.level);
}
function autoDirection(text2, from, to2) {
  for (let i2 = from; i2 < to2; i2++) {
    let type = charType(text2.charCodeAt(i2));
    if (type == 1)
      return LTR;
    if (type == 2 || type == 4)
      return RTL;
  }
  return LTR;
}
const clickAddsSelectionRange = /* @__PURE__ */ Facet.define();
const dragMovesSelection$1 = /* @__PURE__ */ Facet.define();
const mouseSelectionStyle = /* @__PURE__ */ Facet.define();
const exceptionSink = /* @__PURE__ */ Facet.define();
const updateListener = /* @__PURE__ */ Facet.define();
const inputHandler$1 = /* @__PURE__ */ Facet.define();
const focusChangeEffect = /* @__PURE__ */ Facet.define();
const clipboardInputFilter = /* @__PURE__ */ Facet.define();
const clipboardOutputFilter = /* @__PURE__ */ Facet.define();
const perLineTextDirection = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
const nativeSelectionHidden = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
const scrollHandler = /* @__PURE__ */ Facet.define();
class ScrollTarget {
  constructor(range2, y2 = "nearest", x2 = "nearest", yMargin = 5, xMargin = 5, isSnapshot = false) {
    this.range = range2;
    this.y = y2;
    this.x = x2;
    this.yMargin = yMargin;
    this.xMargin = xMargin;
    this.isSnapshot = isSnapshot;
  }
  map(changes) {
    return changes.empty ? this : new ScrollTarget(this.range.map(changes), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
  clip(state) {
    return this.range.to <= state.doc.length ? this : new ScrollTarget(EditorSelection.cursor(state.doc.length), this.y, this.x, this.yMargin, this.xMargin, this.isSnapshot);
  }
}
const scrollIntoView$1 = /* @__PURE__ */ StateEffect.define({ map: (t4, ch) => t4.map(ch) });
const setEditContextFormatting = /* @__PURE__ */ StateEffect.define();
function logException(state, exception, context) {
  let handler = state.facet(exceptionSink);
  if (handler.length)
    handler[0](exception);
  else if (window.onerror && window.onerror(String(exception), context, void 0, void 0, exception)) ;
  else if (context)
    console.error(context + ":", exception);
  else
    console.error(exception);
}
const editable = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.length ? values2[0] : true });
let nextPluginID = 0;
const viewPlugin = /* @__PURE__ */ Facet.define({
  combine(plugins2) {
    return plugins2.filter((p2, i2) => {
      for (let j2 = 0; j2 < i2; j2++)
        if (plugins2[j2].plugin == p2.plugin)
          return false;
      return true;
    });
  }
});
class ViewPlugin {
  constructor(id2, create2, domEventHandlers, domEventObservers, buildExtensions) {
    this.id = id2;
    this.create = create2;
    this.domEventHandlers = domEventHandlers;
    this.domEventObservers = domEventObservers;
    this.baseExtensions = buildExtensions(this);
    this.extension = this.baseExtensions.concat(viewPlugin.of({ plugin: this, arg: void 0 }));
  }
  /**
  Create an extension for this plugin with the given argument.
  */
  of(arg) {
    return this.baseExtensions.concat(viewPlugin.of({ plugin: this, arg }));
  }
  /**
  Define a plugin from a constructor function that creates the
  plugin's value, given an editor view.
  */
  static define(create2, spec) {
    const { eventHandlers, eventObservers, provide, decorations: deco } = spec || {};
    return new ViewPlugin(nextPluginID++, create2, eventHandlers, eventObservers, (plugin) => {
      let ext = [];
      if (deco)
        ext.push(decorations.of((view) => {
          let pluginInst = view.plugin(plugin);
          return pluginInst ? deco(pluginInst) : Decoration.none;
        }));
      if (provide)
        ext.push(provide(plugin));
      return ext;
    });
  }
  /**
  Create a plugin for a class whose constructor takes a single
  editor view as argument.
  */
  static fromClass(cls, spec) {
    return ViewPlugin.define((view, arg) => new cls(view, arg), spec);
  }
}
class PluginInstance {
  constructor(spec) {
    this.spec = spec;
    this.mustUpdate = null;
    this.value = null;
  }
  get plugin() {
    return this.spec && this.spec.plugin;
  }
  update(view) {
    if (!this.value) {
      if (this.spec) {
        try {
          this.value = this.spec.plugin.create(view, this.spec.arg);
        } catch (e2) {
          logException(view.state, e2, "CodeMirror plugin crashed");
          this.deactivate();
        }
      }
    } else if (this.mustUpdate) {
      let update = this.mustUpdate;
      this.mustUpdate = null;
      if (this.value.update) {
        try {
          this.value.update(update);
        } catch (e2) {
          logException(update.state, e2, "CodeMirror plugin crashed");
          if (this.value.destroy)
            try {
              this.value.destroy();
            } catch (_2) {
            }
          this.deactivate();
        }
      }
    }
    return this;
  }
  destroy(view) {
    var _a2;
    if ((_a2 = this.value) === null || _a2 === void 0 ? void 0 : _a2.destroy) {
      try {
        this.value.destroy();
      } catch (e2) {
        logException(view.state, e2, "CodeMirror plugin crashed");
      }
    }
  }
  deactivate() {
    this.spec = this.value = null;
  }
}
const editorAttributes = /* @__PURE__ */ Facet.define();
const contentAttributes = /* @__PURE__ */ Facet.define();
const decorations = /* @__PURE__ */ Facet.define();
const outerDecorations = /* @__PURE__ */ Facet.define();
const atomicRanges = /* @__PURE__ */ Facet.define();
const bidiIsolatedRanges = /* @__PURE__ */ Facet.define();
function getIsolatedRanges(view, line2) {
  let isolates = view.state.facet(bidiIsolatedRanges);
  if (!isolates.length)
    return isolates;
  let sets = isolates.map((i2) => i2 instanceof Function ? i2(view) : i2);
  let result2 = [];
  RangeSet.spans(sets, line2.from, line2.to, {
    point() {
    },
    span(fromDoc, toDoc, active, open) {
      let from = fromDoc - line2.from, to2 = toDoc - line2.from;
      let level = result2;
      for (let i2 = active.length - 1; i2 >= 0; i2--, open--) {
        let direction = active[i2].spec.bidiIsolate, update;
        if (direction == null)
          direction = autoDirection(line2.text, from, to2);
        if (open > 0 && level.length && (update = level[level.length - 1]).to == from && update.direction == direction) {
          update.to = to2;
          level = update.inner;
        } else {
          let add2 = { from, to: to2, direction, inner: [] };
          level.push(add2);
          level = add2.inner;
        }
      }
    }
  });
  return result2;
}
const scrollMargins = /* @__PURE__ */ Facet.define();
function getScrollMargins(view) {
  let left = 0, right = 0, top2 = 0, bottom = 0;
  for (let source of view.state.facet(scrollMargins)) {
    let m2 = source(view);
    if (m2) {
      if (m2.left != null)
        left = Math.max(left, m2.left);
      if (m2.right != null)
        right = Math.max(right, m2.right);
      if (m2.top != null)
        top2 = Math.max(top2, m2.top);
      if (m2.bottom != null)
        bottom = Math.max(bottom, m2.bottom);
    }
  }
  return { left, right, top: top2, bottom };
}
const styleModule = /* @__PURE__ */ Facet.define();
class ChangedRange {
  constructor(fromA, toA, fromB, toB) {
    this.fromA = fromA;
    this.toA = toA;
    this.fromB = fromB;
    this.toB = toB;
  }
  join(other) {
    return new ChangedRange(Math.min(this.fromA, other.fromA), Math.max(this.toA, other.toA), Math.min(this.fromB, other.fromB), Math.max(this.toB, other.toB));
  }
  addToSet(set2) {
    let i2 = set2.length, me2 = this;
    for (; i2 > 0; i2--) {
      let range2 = set2[i2 - 1];
      if (range2.fromA > me2.toA)
        continue;
      if (range2.toA < me2.fromA)
        break;
      me2 = me2.join(range2);
      set2.splice(i2 - 1, 1);
    }
    set2.splice(i2, 0, me2);
    return set2;
  }
  static extendWithRanges(diff, ranges) {
    if (ranges.length == 0)
      return diff;
    let result2 = [];
    for (let dI = 0, rI = 0, posA = 0, posB = 0; ; dI++) {
      let next = dI == diff.length ? null : diff[dI], off = posA - posB;
      let end = next ? next.fromB : 1e9;
      while (rI < ranges.length && ranges[rI] < end) {
        let from = ranges[rI], to2 = ranges[rI + 1];
        let fromB = Math.max(posB, from), toB = Math.min(end, to2);
        if (fromB <= toB)
          new ChangedRange(fromB + off, toB + off, fromB, toB).addToSet(result2);
        if (to2 > end)
          break;
        else
          rI += 2;
      }
      if (!next)
        return result2;
      new ChangedRange(next.fromA, next.toA, next.fromB, next.toB).addToSet(result2);
      posA = next.toA;
      posB = next.toB;
    }
  }
}
class ViewUpdate {
  constructor(view, state, transactions) {
    this.view = view;
    this.state = state;
    this.transactions = transactions;
    this.flags = 0;
    this.startState = view.state;
    this.changes = ChangeSet.empty(this.startState.doc.length);
    for (let tr2 of transactions)
      this.changes = this.changes.compose(tr2.changes);
    let changedRanges = [];
    this.changes.iterChangedRanges((fromA, toA, fromB, toB) => changedRanges.push(new ChangedRange(fromA, toA, fromB, toB)));
    this.changedRanges = changedRanges;
  }
  /**
  @internal
  */
  static create(view, state, transactions) {
    return new ViewUpdate(view, state, transactions);
  }
  /**
  Tells you whether the [viewport](https://codemirror.net/6/docs/ref/#view.EditorView.viewport) or
  [visible ranges](https://codemirror.net/6/docs/ref/#view.EditorView.visibleRanges) changed in this
  update.
  */
  get viewportChanged() {
    return (this.flags & 4) > 0;
  }
  /**
  Returns true when
  [`viewportChanged`](https://codemirror.net/6/docs/ref/#view.ViewUpdate.viewportChanged) is true
  and the viewport change is not just the result of mapping it in
  response to document changes.
  */
  get viewportMoved() {
    return (this.flags & 8) > 0;
  }
  /**
  Indicates whether the height of a block element in the editor
  changed in this update.
  */
  get heightChanged() {
    return (this.flags & 2) > 0;
  }
  /**
  Returns true when the document was modified or the size of the
  editor, or elements within the editor, changed.
  */
  get geometryChanged() {
    return this.docChanged || (this.flags & (16 | 2)) > 0;
  }
  /**
  True when this update indicates a focus change.
  */
  get focusChanged() {
    return (this.flags & 1) > 0;
  }
  /**
  Whether the document changed in this update.
  */
  get docChanged() {
    return !this.changes.empty;
  }
  /**
  Whether the selection was explicitly set in this update.
  */
  get selectionSet() {
    return this.transactions.some((tr2) => tr2.selection);
  }
  /**
  @internal
  */
  get empty() {
    return this.flags == 0 && this.transactions.length == 0;
  }
}
class DocView extends ContentView {
  get length() {
    return this.view.state.doc.length;
  }
  constructor(view) {
    super();
    this.view = view;
    this.decorations = [];
    this.dynamicDecorationMap = [false];
    this.domChanged = null;
    this.hasComposition = null;
    this.markedForComposition = /* @__PURE__ */ new Set();
    this.editContextFormatting = Decoration.none;
    this.lastCompositionAfterCursor = false;
    this.minWidth = 0;
    this.minWidthFrom = 0;
    this.minWidthTo = 0;
    this.impreciseAnchor = null;
    this.impreciseHead = null;
    this.forceSelection = false;
    this.lastUpdate = Date.now();
    this.setDOM(view.contentDOM);
    this.children = [new LineView()];
    this.children[0].setParent(this);
    this.updateDeco();
    this.updateInner([new ChangedRange(0, 0, 0, view.state.doc.length)], 0, null);
  }
  // Update the document view to a given state.
  update(update) {
    var _a2;
    let changedRanges = update.changedRanges;
    if (this.minWidth > 0 && changedRanges.length) {
      if (!changedRanges.every(({ fromA, toA }) => toA < this.minWidthFrom || fromA > this.minWidthTo)) {
        this.minWidth = this.minWidthFrom = this.minWidthTo = 0;
      } else {
        this.minWidthFrom = update.changes.mapPos(this.minWidthFrom, 1);
        this.minWidthTo = update.changes.mapPos(this.minWidthTo, 1);
      }
    }
    this.updateEditContextFormatting(update);
    let readCompositionAt = -1;
    if (this.view.inputState.composing >= 0 && !this.view.observer.editContext) {
      if ((_a2 = this.domChanged) === null || _a2 === void 0 ? void 0 : _a2.newSel)
        readCompositionAt = this.domChanged.newSel.head;
      else if (!touchesComposition(update.changes, this.hasComposition) && !update.selectionSet)
        readCompositionAt = update.state.selection.main.head;
    }
    let composition = readCompositionAt > -1 ? findCompositionRange(this.view, update.changes, readCompositionAt) : null;
    this.domChanged = null;
    if (this.hasComposition) {
      this.markedForComposition.clear();
      let { from, to: to2 } = this.hasComposition;
      changedRanges = new ChangedRange(from, to2, update.changes.mapPos(from, -1), update.changes.mapPos(to2, 1)).addToSet(changedRanges.slice());
    }
    this.hasComposition = composition ? { from: composition.range.fromB, to: composition.range.toB } : null;
    if ((browser$3.ie || browser$3.chrome) && !composition && update && update.state.doc.lines != update.startState.doc.lines)
      this.forceSelection = true;
    let prevDeco = this.decorations, deco = this.updateDeco();
    let decoDiff = findChangedDeco(prevDeco, deco, update.changes);
    changedRanges = ChangedRange.extendWithRanges(changedRanges, decoDiff);
    if (!(this.flags & 7) && changedRanges.length == 0) {
      return false;
    } else {
      this.updateInner(changedRanges, update.startState.doc.length, composition);
      if (update.transactions.length)
        this.lastUpdate = Date.now();
      return true;
    }
  }
  // Used by update and the constructor do perform the actual DOM
  // update
  updateInner(changes, oldLength, composition) {
    this.view.viewState.mustMeasureContent = true;
    this.updateChildren(changes, oldLength, composition);
    let { observer } = this.view;
    observer.ignore(() => {
      this.dom.style.height = this.view.viewState.contentHeight / this.view.scaleY + "px";
      this.dom.style.flexBasis = this.minWidth ? this.minWidth + "px" : "";
      let track = browser$3.chrome || browser$3.ios ? { node: observer.selectionRange.focusNode, written: false } : void 0;
      this.sync(this.view, track);
      this.flags &= -8;
      if (track && (track.written || observer.selectionRange.focusNode != track.node))
        this.forceSelection = true;
      this.dom.style.height = "";
    });
    this.markedForComposition.forEach(
      (cView) => cView.flags &= -9
      /* ViewFlag.Composition */
    );
    let gaps = [];
    if (this.view.viewport.from || this.view.viewport.to < this.view.state.doc.length) {
      for (let child of this.children)
        if (child instanceof BlockWidgetView && child.widget instanceof BlockGapWidget)
          gaps.push(child.dom);
    }
    observer.updateGaps(gaps);
  }
  updateChildren(changes, oldLength, composition) {
    let ranges = composition ? composition.range.addToSet(changes.slice()) : changes;
    let cursor2 = this.childCursor(oldLength);
    for (let i2 = ranges.length - 1; ; i2--) {
      let next = i2 >= 0 ? ranges[i2] : null;
      if (!next)
        break;
      let { fromA, toA, fromB, toB } = next, content2, breakAtStart, openStart, openEnd;
      if (composition && composition.range.fromB < toB && composition.range.toB > fromB) {
        let before2 = ContentBuilder.build(this.view.state.doc, fromB, composition.range.fromB, this.decorations, this.dynamicDecorationMap);
        let after2 = ContentBuilder.build(this.view.state.doc, composition.range.toB, toB, this.decorations, this.dynamicDecorationMap);
        breakAtStart = before2.breakAtStart;
        openStart = before2.openStart;
        openEnd = after2.openEnd;
        let compLine = this.compositionView(composition);
        if (after2.breakAtStart) {
          compLine.breakAfter = 1;
        } else if (after2.content.length && compLine.merge(compLine.length, compLine.length, after2.content[0], false, after2.openStart, 0)) {
          compLine.breakAfter = after2.content[0].breakAfter;
          after2.content.shift();
        }
        if (before2.content.length && compLine.merge(0, 0, before2.content[before2.content.length - 1], true, 0, before2.openEnd)) {
          before2.content.pop();
        }
        content2 = before2.content.concat(compLine).concat(after2.content);
      } else {
        ({ content: content2, breakAtStart, openStart, openEnd } = ContentBuilder.build(this.view.state.doc, fromB, toB, this.decorations, this.dynamicDecorationMap));
      }
      let { i: toI, off: toOff } = cursor2.findPos(toA, 1);
      let { i: fromI, off: fromOff } = cursor2.findPos(fromA, -1);
      replaceRange(this, fromI, fromOff, toI, toOff, content2, breakAtStart, openStart, openEnd);
    }
    if (composition)
      this.fixCompositionDOM(composition);
  }
  updateEditContextFormatting(update) {
    this.editContextFormatting = this.editContextFormatting.map(update.changes);
    for (let tr2 of update.transactions)
      for (let effect of tr2.effects)
        if (effect.is(setEditContextFormatting)) {
          this.editContextFormatting = effect.value;
        }
  }
  compositionView(composition) {
    let cur2 = new TextView(composition.text.nodeValue);
    cur2.flags |= 8;
    for (let { deco } of composition.marks)
      cur2 = new MarkView(deco, [cur2], cur2.length);
    let line2 = new LineView();
    line2.append(cur2, 0);
    return line2;
  }
  fixCompositionDOM(composition) {
    let fix = (dom, cView2) => {
      cView2.flags |= 8 | (cView2.children.some(
        (c2) => c2.flags & 7
        /* ViewFlag.Dirty */
      ) ? 1 : 0);
      this.markedForComposition.add(cView2);
      let prev = ContentView.get(dom);
      if (prev && prev != cView2)
        prev.dom = null;
      cView2.setDOM(dom);
    };
    let pos = this.childPos(composition.range.fromB, 1);
    let cView = this.children[pos.i];
    fix(composition.line, cView);
    for (let i2 = composition.marks.length - 1; i2 >= -1; i2--) {
      pos = cView.childPos(pos.off, 1);
      cView = cView.children[pos.i];
      fix(i2 >= 0 ? composition.marks[i2].node : composition.text, cView);
    }
  }
  // Sync the DOM selection to this.state.selection
  updateSelection(mustRead = false, fromPointer = false) {
    if (mustRead || !this.view.observer.selectionRange.focusNode)
      this.view.observer.readSelectionRange();
    let activeElt = this.view.root.activeElement, focused = activeElt == this.dom;
    let selectionNotFocus = !focused && !(this.view.state.facet(editable) || this.dom.tabIndex > -1) && hasSelection(this.dom, this.view.observer.selectionRange) && !(activeElt && this.dom.contains(activeElt));
    if (!(focused || fromPointer || selectionNotFocus))
      return;
    let force = this.forceSelection;
    this.forceSelection = false;
    let main2 = this.view.state.selection.main;
    let anchor = this.moveToLine(this.domAtPos(main2.anchor));
    let head = main2.empty ? anchor : this.moveToLine(this.domAtPos(main2.head));
    if (browser$3.gecko && main2.empty && !this.hasComposition && betweenUneditable(anchor)) {
      let dummy = document.createTextNode("");
      this.view.observer.ignore(() => anchor.node.insertBefore(dummy, anchor.node.childNodes[anchor.offset] || null));
      anchor = head = new DOMPos(dummy, 0);
      force = true;
    }
    let domSel = this.view.observer.selectionRange;
    if (force || !domSel.focusNode || (!isEquivalentPosition(anchor.node, anchor.offset, domSel.anchorNode, domSel.anchorOffset) || !isEquivalentPosition(head.node, head.offset, domSel.focusNode, domSel.focusOffset)) && !this.suppressWidgetCursorChange(domSel, main2)) {
      this.view.observer.ignore(() => {
        if (browser$3.android && browser$3.chrome && this.dom.contains(domSel.focusNode) && inUneditable(domSel.focusNode, this.dom)) {
          this.dom.blur();
          this.dom.focus({ preventScroll: true });
        }
        let rawSel = getSelection(this.view.root);
        if (!rawSel) ;
        else if (main2.empty) {
          if (browser$3.gecko) {
            let nextTo = nextToUneditable(anchor.node, anchor.offset);
            if (nextTo && nextTo != (1 | 2)) {
              let text2 = (nextTo == 1 ? textNodeBefore : textNodeAfter)(anchor.node, anchor.offset);
              if (text2)
                anchor = new DOMPos(text2.node, text2.offset);
            }
          }
          rawSel.collapse(anchor.node, anchor.offset);
          if (main2.bidiLevel != null && rawSel.caretBidiLevel !== void 0)
            rawSel.caretBidiLevel = main2.bidiLevel;
        } else if (rawSel.extend) {
          rawSel.collapse(anchor.node, anchor.offset);
          try {
            rawSel.extend(head.node, head.offset);
          } catch (_2) {
          }
        } else {
          let range2 = document.createRange();
          if (main2.anchor > main2.head)
            [anchor, head] = [head, anchor];
          range2.setEnd(head.node, head.offset);
          range2.setStart(anchor.node, anchor.offset);
          rawSel.removeAllRanges();
          rawSel.addRange(range2);
        }
        if (selectionNotFocus && this.view.root.activeElement == this.dom) {
          this.dom.blur();
          if (activeElt)
            activeElt.focus();
        }
      });
      this.view.observer.setSelectionRange(anchor, head);
    }
    this.impreciseAnchor = anchor.precise ? null : new DOMPos(domSel.anchorNode, domSel.anchorOffset);
    this.impreciseHead = head.precise ? null : new DOMPos(domSel.focusNode, domSel.focusOffset);
  }
  // If a zero-length widget is inserted next to the cursor during
  // composition, avoid moving it across it and disrupting the
  // composition.
  suppressWidgetCursorChange(sel, cursor2) {
    return this.hasComposition && cursor2.empty && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset) && this.posFromDOM(sel.focusNode, sel.focusOffset) == cursor2.head;
  }
  enforceCursorAssoc() {
    if (this.hasComposition)
      return;
    let { view } = this, cursor2 = view.state.selection.main;
    let sel = getSelection(view.root);
    let { anchorNode, anchorOffset } = view.observer.selectionRange;
    if (!sel || !cursor2.empty || !cursor2.assoc || !sel.modify)
      return;
    let line2 = LineView.find(this, cursor2.head);
    if (!line2)
      return;
    let lineStart = line2.posAtStart;
    if (cursor2.head == lineStart || cursor2.head == lineStart + line2.length)
      return;
    let before2 = this.coordsAt(cursor2.head, -1), after2 = this.coordsAt(cursor2.head, 1);
    if (!before2 || !after2 || before2.bottom > after2.top)
      return;
    let dom = this.domAtPos(cursor2.head + cursor2.assoc);
    sel.collapse(dom.node, dom.offset);
    sel.modify("move", cursor2.assoc < 0 ? "forward" : "backward", "lineboundary");
    view.observer.readSelectionRange();
    let newRange = view.observer.selectionRange;
    if (view.docView.posFromDOM(newRange.anchorNode, newRange.anchorOffset) != cursor2.from)
      sel.collapse(anchorNode, anchorOffset);
  }
  // If a position is in/near a block widget, move it to a nearby text
  // line, since we don't want the cursor inside a block widget.
  moveToLine(pos) {
    let dom = this.dom, newPos;
    if (pos.node != dom)
      return pos;
    for (let i2 = pos.offset; !newPos && i2 < dom.childNodes.length; i2++) {
      let view = ContentView.get(dom.childNodes[i2]);
      if (view instanceof LineView)
        newPos = view.domAtPos(0);
    }
    for (let i2 = pos.offset - 1; !newPos && i2 >= 0; i2--) {
      let view = ContentView.get(dom.childNodes[i2]);
      if (view instanceof LineView)
        newPos = view.domAtPos(view.length);
    }
    return newPos ? new DOMPos(newPos.node, newPos.offset, true) : pos;
  }
  nearest(dom) {
    for (let cur2 = dom; cur2; ) {
      let domView = ContentView.get(cur2);
      if (domView && domView.rootView == this)
        return domView;
      cur2 = cur2.parentNode;
    }
    return null;
  }
  posFromDOM(node, offset2) {
    let view = this.nearest(node);
    if (!view)
      throw new RangeError("Trying to find position for a DOM position outside of the document");
    return view.localPosFromDOM(node, offset2) + view.posAtStart;
  }
  domAtPos(pos) {
    let { i: i2, off } = this.childCursor().findPos(pos, -1);
    for (; i2 < this.children.length - 1; ) {
      let child = this.children[i2];
      if (off < child.length || child instanceof LineView)
        break;
      i2++;
      off = 0;
    }
    return this.children[i2].domAtPos(off);
  }
  coordsAt(pos, side) {
    let best = null, bestPos = 0;
    for (let off = this.length, i2 = this.children.length - 1; i2 >= 0; i2--) {
      let child = this.children[i2], end = off - child.breakAfter, start = end - child.length;
      if (end < pos)
        break;
      if (start <= pos && (start < pos || child.covers(-1)) && (end > pos || child.covers(1)) && (!best || child instanceof LineView && !(best instanceof LineView && side >= 0))) {
        best = child;
        bestPos = start;
      } else if (best && start == pos && end == pos && child instanceof BlockWidgetView && Math.abs(side) < 2) {
        if (child.deco.startSide < 0)
          break;
        else if (i2)
          best = null;
      }
      off = start;
    }
    return best ? best.coordsAt(pos - bestPos, side) : null;
  }
  coordsForChar(pos) {
    let { i: i2, off } = this.childPos(pos, 1), child = this.children[i2];
    if (!(child instanceof LineView))
      return null;
    while (child.children.length) {
      let { i: i3, off: childOff } = child.childPos(off, 1);
      for (; ; i3++) {
        if (i3 == child.children.length)
          return null;
        if ((child = child.children[i3]).length)
          break;
      }
      off = childOff;
    }
    if (!(child instanceof TextView))
      return null;
    let end = findClusterBreak(child.text, off);
    if (end == off)
      return null;
    let rects = textRange(child.dom, off, end).getClientRects();
    for (let i3 = 0; i3 < rects.length; i3++) {
      let rect = rects[i3];
      if (i3 == rects.length - 1 || rect.top < rect.bottom && rect.left < rect.right)
        return rect;
    }
    return null;
  }
  measureVisibleLineHeights(viewport) {
    let result2 = [], { from, to: to2 } = viewport;
    let contentWidth = this.view.contentDOM.clientWidth;
    let isWider = contentWidth > Math.max(this.view.scrollDOM.clientWidth, this.minWidth) + 1;
    let widest = -1, ltr = this.view.textDirection == Direction.LTR;
    for (let pos = 0, i2 = 0; i2 < this.children.length; i2++) {
      let child = this.children[i2], end = pos + child.length;
      if (end > to2)
        break;
      if (pos >= from) {
        let childRect = child.dom.getBoundingClientRect();
        result2.push(childRect.height);
        if (isWider) {
          let last2 = child.dom.lastChild;
          let rects = last2 ? clientRectsFor(last2) : [];
          if (rects.length) {
            let rect = rects[rects.length - 1];
            let width = ltr ? rect.right - childRect.left : childRect.right - rect.left;
            if (width > widest) {
              widest = width;
              this.minWidth = contentWidth;
              this.minWidthFrom = pos;
              this.minWidthTo = end;
            }
          }
        }
      }
      pos = end + child.breakAfter;
    }
    return result2;
  }
  textDirectionAt(pos) {
    let { i: i2 } = this.childPos(pos, 1);
    return getComputedStyle(this.children[i2].dom).direction == "rtl" ? Direction.RTL : Direction.LTR;
  }
  measureTextSize() {
    for (let child of this.children) {
      if (child instanceof LineView) {
        let measure = child.measureTextSize();
        if (measure)
          return measure;
      }
    }
    let dummy = document.createElement("div"), lineHeight, charWidth, textHeight;
    dummy.className = "cm-line";
    dummy.style.width = "99999px";
    dummy.style.position = "absolute";
    dummy.textContent = "abc def ghi jkl mno pqr stu";
    this.view.observer.ignore(() => {
      this.dom.appendChild(dummy);
      let rect = clientRectsFor(dummy.firstChild)[0];
      lineHeight = dummy.getBoundingClientRect().height;
      charWidth = rect ? rect.width / 27 : 7;
      textHeight = rect ? rect.height : lineHeight;
      dummy.remove();
    });
    return { lineHeight, charWidth, textHeight };
  }
  childCursor(pos = this.length) {
    let i2 = this.children.length;
    if (i2)
      pos -= this.children[--i2].length;
    return new ChildCursor(this.children, pos, i2);
  }
  computeBlockGapDeco() {
    let deco = [], vs = this.view.viewState;
    for (let pos = 0, i2 = 0; ; i2++) {
      let next = i2 == vs.viewports.length ? null : vs.viewports[i2];
      let end = next ? next.from - 1 : this.length;
      if (end > pos) {
        let height = (vs.lineBlockAt(end).bottom - vs.lineBlockAt(pos).top) / this.view.scaleY;
        deco.push(Decoration.replace({
          widget: new BlockGapWidget(height),
          block: true,
          inclusive: true,
          isBlockGap: true
        }).range(pos, end));
      }
      if (!next)
        break;
      pos = next.to + 1;
    }
    return Decoration.set(deco);
  }
  updateDeco() {
    let i2 = 1;
    let allDeco = this.view.state.facet(decorations).map((d2) => {
      let dynamic = this.dynamicDecorationMap[i2++] = typeof d2 == "function";
      return dynamic ? d2(this.view) : d2;
    });
    let dynamicOuter = false, outerDeco = this.view.state.facet(outerDecorations).map((d2, i3) => {
      let dynamic = typeof d2 == "function";
      if (dynamic)
        dynamicOuter = true;
      return dynamic ? d2(this.view) : d2;
    });
    if (outerDeco.length) {
      this.dynamicDecorationMap[i2++] = dynamicOuter;
      allDeco.push(RangeSet.join(outerDeco));
    }
    this.decorations = [
      this.editContextFormatting,
      ...allDeco,
      this.computeBlockGapDeco(),
      this.view.viewState.lineGapDeco
    ];
    while (i2 < this.decorations.length)
      this.dynamicDecorationMap[i2++] = false;
    return this.decorations;
  }
  scrollIntoView(target) {
    if (target.isSnapshot) {
      let ref = this.view.viewState.lineBlockAt(target.range.head);
      this.view.scrollDOM.scrollTop = ref.top - target.yMargin;
      this.view.scrollDOM.scrollLeft = target.xMargin;
      return;
    }
    for (let handler of this.view.state.facet(scrollHandler)) {
      try {
        if (handler(this.view, target.range, target))
          return true;
      } catch (e2) {
        logException(this.view.state, e2, "scroll handler");
      }
    }
    let { range: range2 } = target;
    let rect = this.coordsAt(range2.head, range2.empty ? range2.assoc : range2.head > range2.anchor ? -1 : 1), other;
    if (!rect)
      return;
    if (!range2.empty && (other = this.coordsAt(range2.anchor, range2.anchor > range2.head ? -1 : 1)))
      rect = {
        left: Math.min(rect.left, other.left),
        top: Math.min(rect.top, other.top),
        right: Math.max(rect.right, other.right),
        bottom: Math.max(rect.bottom, other.bottom)
      };
    let margins = getScrollMargins(this.view);
    let targetRect = {
      left: rect.left - margins.left,
      top: rect.top - margins.top,
      right: rect.right + margins.right,
      bottom: rect.bottom + margins.bottom
    };
    let { offsetWidth, offsetHeight } = this.view.scrollDOM;
    scrollRectIntoView(this.view.scrollDOM, targetRect, range2.head < range2.anchor ? -1 : 1, target.x, target.y, Math.max(Math.min(target.xMargin, offsetWidth), -offsetWidth), Math.max(Math.min(target.yMargin, offsetHeight), -offsetHeight), this.view.textDirection == Direction.LTR);
  }
  lineHasWidget(pos) {
    let { i: i2 } = this.childCursor().findPos(pos);
    if (i2 == this.children.length)
      return false;
    let scan = (child) => child instanceof WidgetView || child.children.some(scan);
    return scan(this.children[i2]);
  }
}
function betweenUneditable(pos) {
  return pos.node.nodeType == 1 && pos.node.firstChild && (pos.offset == 0 || pos.node.childNodes[pos.offset - 1].contentEditable == "false") && (pos.offset == pos.node.childNodes.length || pos.node.childNodes[pos.offset].contentEditable == "false");
}
function findCompositionNode(view, headPos) {
  let sel = view.observer.selectionRange;
  if (!sel.focusNode)
    return null;
  let textBefore = textNodeBefore(sel.focusNode, sel.focusOffset);
  let textAfter = textNodeAfter(sel.focusNode, sel.focusOffset);
  let textNode = textBefore || textAfter;
  if (textAfter && textBefore && textAfter.node != textBefore.node) {
    let descAfter = ContentView.get(textAfter.node);
    if (!descAfter || descAfter instanceof TextView && descAfter.text != textAfter.node.nodeValue) {
      textNode = textAfter;
    } else if (view.docView.lastCompositionAfterCursor) {
      let descBefore = ContentView.get(textBefore.node);
      if (!(!descBefore || descBefore instanceof TextView && descBefore.text != textBefore.node.nodeValue))
        textNode = textAfter;
    }
  }
  view.docView.lastCompositionAfterCursor = textNode != textBefore;
  if (!textNode)
    return null;
  let from = headPos - textNode.offset;
  return { from, to: from + textNode.node.nodeValue.length, node: textNode.node };
}
function findCompositionRange(view, changes, headPos) {
  let found = findCompositionNode(view, headPos);
  if (!found)
    return null;
  let { node: textNode, from, to: to2 } = found, text2 = textNode.nodeValue;
  if (/[\n\r]/.test(text2))
    return null;
  if (view.state.doc.sliceString(found.from, found.to) != text2)
    return null;
  let inv = changes.invertedDesc;
  let range2 = new ChangedRange(inv.mapPos(from), inv.mapPos(to2), from, to2);
  let marks = [];
  for (let parent = textNode.parentNode; ; parent = parent.parentNode) {
    let parentView = ContentView.get(parent);
    if (parentView instanceof MarkView)
      marks.push({ node: parent, deco: parentView.mark });
    else if (parentView instanceof LineView || parent.nodeName == "DIV" && parent.parentNode == view.contentDOM)
      return { range: range2, text: textNode, marks, line: parent };
    else if (parent != view.contentDOM)
      marks.push({ node: parent, deco: new MarkDecoration({
        inclusive: true,
        attributes: getAttrs(parent),
        tagName: parent.tagName.toLowerCase()
      }) });
    else
      return null;
  }
}
function nextToUneditable(node, offset2) {
  if (node.nodeType != 1)
    return 0;
  return (offset2 && node.childNodes[offset2 - 1].contentEditable == "false" ? 1 : 0) | (offset2 < node.childNodes.length && node.childNodes[offset2].contentEditable == "false" ? 2 : 0);
}
let DecorationComparator$1 = class DecorationComparator2 {
  constructor() {
    this.changes = [];
  }
  compareRange(from, to2) {
    addRange(from, to2, this.changes);
  }
  comparePoint(from, to2) {
    addRange(from, to2, this.changes);
  }
  boundChange(pos) {
    addRange(pos, pos, this.changes);
  }
};
function findChangedDeco(a2, b2, diff) {
  let comp = new DecorationComparator$1();
  RangeSet.compare(a2, b2, diff, comp);
  return comp.changes;
}
function inUneditable(node, inside2) {
  for (let cur2 = node; cur2 && cur2 != inside2; cur2 = cur2.assignedSlot || cur2.parentNode) {
    if (cur2.nodeType == 1 && cur2.contentEditable == "false") {
      return true;
    }
  }
  return false;
}
function touchesComposition(changes, composition) {
  let touched = false;
  if (composition)
    changes.iterChangedRanges((from, to2) => {
      if (from < composition.to && to2 > composition.from)
        touched = true;
    });
  return touched;
}
function groupAt(state, pos, bias = 1) {
  let categorize = state.charCategorizer(pos);
  let line2 = state.doc.lineAt(pos), linePos = pos - line2.from;
  if (line2.length == 0)
    return EditorSelection.cursor(pos);
  if (linePos == 0)
    bias = 1;
  else if (linePos == line2.length)
    bias = -1;
  let from = linePos, to2 = linePos;
  if (bias < 0)
    from = findClusterBreak(line2.text, linePos, false);
  else
    to2 = findClusterBreak(line2.text, linePos);
  let cat = categorize(line2.text.slice(from, to2));
  while (from > 0) {
    let prev = findClusterBreak(line2.text, from, false);
    if (categorize(line2.text.slice(prev, from)) != cat)
      break;
    from = prev;
  }
  while (to2 < line2.length) {
    let next = findClusterBreak(line2.text, to2);
    if (categorize(line2.text.slice(to2, next)) != cat)
      break;
    to2 = next;
  }
  return EditorSelection.range(from + line2.from, to2 + line2.from);
}
function getdx(x2, rect) {
  return rect.left > x2 ? rect.left - x2 : Math.max(0, x2 - rect.right);
}
function getdy(y2, rect) {
  return rect.top > y2 ? rect.top - y2 : Math.max(0, y2 - rect.bottom);
}
function yOverlap(a2, b2) {
  return a2.top < b2.bottom - 1 && a2.bottom > b2.top + 1;
}
function upTop(rect, top2) {
  return top2 < rect.top ? { top: top2, left: rect.left, right: rect.right, bottom: rect.bottom } : rect;
}
function upBot(rect, bottom) {
  return bottom > rect.bottom ? { top: rect.top, left: rect.left, right: rect.right, bottom } : rect;
}
function domPosAtCoords(parent, x2, y2) {
  let closest, closestRect, closestX, closestY, closestOverlap = false;
  let above, below, aboveRect, belowRect;
  for (let child = parent.firstChild; child; child = child.nextSibling) {
    let rects = clientRectsFor(child);
    for (let i2 = 0; i2 < rects.length; i2++) {
      let rect = rects[i2];
      if (closestRect && yOverlap(closestRect, rect))
        rect = upTop(upBot(rect, closestRect.bottom), closestRect.top);
      let dx = getdx(x2, rect), dy = getdy(y2, rect);
      if (dx == 0 && dy == 0)
        return child.nodeType == 3 ? domPosInText(child, x2, y2) : domPosAtCoords(child, x2, y2);
      if (!closest || closestY > dy || closestY == dy && closestX > dx) {
        closest = child;
        closestRect = rect;
        closestX = dx;
        closestY = dy;
        closestOverlap = !dx ? true : x2 < rect.left ? i2 > 0 : i2 < rects.length - 1;
      }
      if (dx == 0) {
        if (y2 > rect.bottom && (!aboveRect || aboveRect.bottom < rect.bottom)) {
          above = child;
          aboveRect = rect;
        } else if (y2 < rect.top && (!belowRect || belowRect.top > rect.top)) {
          below = child;
          belowRect = rect;
        }
      } else if (aboveRect && yOverlap(aboveRect, rect)) {
        aboveRect = upBot(aboveRect, rect.bottom);
      } else if (belowRect && yOverlap(belowRect, rect)) {
        belowRect = upTop(belowRect, rect.top);
      }
    }
  }
  if (aboveRect && aboveRect.bottom >= y2) {
    closest = above;
    closestRect = aboveRect;
  } else if (belowRect && belowRect.top <= y2) {
    closest = below;
    closestRect = belowRect;
  }
  if (!closest)
    return { node: parent, offset: 0 };
  let clipX = Math.max(closestRect.left, Math.min(closestRect.right, x2));
  if (closest.nodeType == 3)
    return domPosInText(closest, clipX, y2);
  if (closestOverlap && closest.contentEditable != "false")
    return domPosAtCoords(closest, clipX, y2);
  let offset2 = Array.prototype.indexOf.call(parent.childNodes, closest) + (x2 >= (closestRect.left + closestRect.right) / 2 ? 1 : 0);
  return { node: parent, offset: offset2 };
}
function domPosInText(node, x2, y2) {
  let len = node.nodeValue.length;
  let closestOffset = -1, closestDY = 1e9, generalSide = 0;
  for (let i2 = 0; i2 < len; i2++) {
    let rects = textRange(node, i2, i2 + 1).getClientRects();
    for (let j2 = 0; j2 < rects.length; j2++) {
      let rect = rects[j2];
      if (rect.top == rect.bottom)
        continue;
      if (!generalSide)
        generalSide = x2 - rect.left;
      let dy = (rect.top > y2 ? rect.top - y2 : y2 - rect.bottom) - 1;
      if (rect.left - 1 <= x2 && rect.right + 1 >= x2 && dy < closestDY) {
        let right = x2 >= (rect.left + rect.right) / 2, after2 = right;
        if (browser$3.chrome || browser$3.gecko) {
          let rectBefore = textRange(node, i2).getBoundingClientRect();
          if (Math.abs(rectBefore.left - rect.right) < 0.1)
            after2 = !right;
        }
        if (dy <= 0)
          return { node, offset: i2 + (after2 ? 1 : 0) };
        closestOffset = i2 + (after2 ? 1 : 0);
        closestDY = dy;
      }
    }
  }
  return { node, offset: closestOffset > -1 ? closestOffset : generalSide > 0 ? node.nodeValue.length : 0 };
}
function posAtCoords(view, coords, precise, bias = -1) {
  var _a2, _b;
  let content2 = view.contentDOM.getBoundingClientRect(), docTop = content2.top + view.viewState.paddingTop;
  let block, { docHeight } = view.viewState;
  let { x: x2, y: y2 } = coords, yOffset = y2 - docTop;
  if (yOffset < 0)
    return 0;
  if (yOffset > docHeight)
    return view.state.doc.length;
  for (let halfLine = view.viewState.heightOracle.textHeight / 2, bounced = false; ; ) {
    block = view.elementAtHeight(yOffset);
    if (block.type == BlockType.Text)
      break;
    for (; ; ) {
      yOffset = bias > 0 ? block.bottom + halfLine : block.top - halfLine;
      if (yOffset >= 0 && yOffset <= docHeight)
        break;
      if (bounced)
        return precise ? null : 0;
      bounced = true;
      bias = -bias;
    }
  }
  y2 = docTop + yOffset;
  let lineStart = block.from;
  if (lineStart < view.viewport.from)
    return view.viewport.from == 0 ? 0 : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y2);
  if (lineStart > view.viewport.to)
    return view.viewport.to == view.state.doc.length ? view.state.doc.length : precise ? null : posAtCoordsImprecise(view, content2, block, x2, y2);
  let doc2 = view.dom.ownerDocument;
  let root2 = view.root.elementFromPoint ? view.root : doc2;
  let element2 = root2.elementFromPoint(x2, y2);
  if (element2 && !view.contentDOM.contains(element2))
    element2 = null;
  if (!element2) {
    x2 = Math.max(content2.left + 1, Math.min(content2.right - 1, x2));
    element2 = root2.elementFromPoint(x2, y2);
    if (element2 && !view.contentDOM.contains(element2))
      element2 = null;
  }
  let node, offset2 = -1;
  if (element2 && ((_a2 = view.docView.nearest(element2)) === null || _a2 === void 0 ? void 0 : _a2.isEditable) != false) {
    if (doc2.caretPositionFromPoint) {
      let pos = doc2.caretPositionFromPoint(x2, y2);
      if (pos)
        ({ offsetNode: node, offset: offset2 } = pos);
    } else if (doc2.caretRangeFromPoint) {
      let range2 = doc2.caretRangeFromPoint(x2, y2);
      if (range2)
        ({ startContainer: node, startOffset: offset2 } = range2);
    }
    if (node && (!view.contentDOM.contains(node) || browser$3.safari && isSuspiciousSafariCaretResult(node, offset2, x2) || browser$3.chrome && isSuspiciousChromeCaretResult(node, offset2, x2)))
      node = void 0;
    if (node)
      offset2 = Math.min(maxOffset(node), offset2);
  }
  if (!node || !view.docView.dom.contains(node)) {
    let line2 = LineView.find(view.docView, lineStart);
    if (!line2)
      return yOffset > block.top + block.height / 2 ? block.to : block.from;
    ({ node, offset: offset2 } = domPosAtCoords(line2.dom, x2, y2));
  }
  let nearest = view.docView.nearest(node);
  if (!nearest)
    return null;
  if (nearest.isWidget && ((_b = nearest.dom) === null || _b === void 0 ? void 0 : _b.nodeType) == 1) {
    let rect = nearest.dom.getBoundingClientRect();
    return coords.y < rect.top || coords.y <= rect.bottom && coords.x <= (rect.left + rect.right) / 2 ? nearest.posAtStart : nearest.posAtEnd;
  } else {
    return nearest.localPosFromDOM(node, offset2) + nearest.posAtStart;
  }
}
function posAtCoordsImprecise(view, contentRect, block, x2, y2) {
  let into = Math.round((x2 - contentRect.left) * view.defaultCharacterWidth);
  if (view.lineWrapping && block.height > view.defaultLineHeight * 1.5) {
    let textHeight = view.viewState.heightOracle.textHeight;
    let line2 = Math.floor((y2 - block.top - (view.defaultLineHeight - textHeight) * 0.5) / textHeight);
    into += line2 * view.viewState.heightOracle.lineLength;
  }
  let content2 = view.state.sliceDoc(block.from, block.to);
  return block.from + findColumn(content2, into, view.state.tabSize);
}
function isEndOfLineBefore(node, offset2, x2) {
  let len, scan = node;
  if (node.nodeType != 3 || offset2 != (len = node.nodeValue.length))
    return false;
  for (; ; ) {
    let next = scan.nextSibling;
    if (next) {
      if (next.nodeName == "BR")
        break;
      return false;
    } else {
      let parent = scan.parentNode;
      if (!parent || parent.nodeName == "DIV")
        break;
      scan = parent;
    }
  }
  return textRange(node, len - 1, len).getBoundingClientRect().right > x2;
}
function isSuspiciousSafariCaretResult(node, offset2, x2) {
  return isEndOfLineBefore(node, offset2, x2);
}
function isSuspiciousChromeCaretResult(node, offset2, x2) {
  if (offset2 != 0)
    return isEndOfLineBefore(node, offset2, x2);
  for (let cur2 = node; ; ) {
    let parent = cur2.parentNode;
    if (!parent || parent.nodeType != 1 || parent.firstChild != cur2)
      return false;
    if (parent.classList.contains("cm-line"))
      break;
    cur2 = parent;
  }
  let rect = node.nodeType == 1 ? node.getBoundingClientRect() : textRange(node, 0, Math.max(node.nodeValue.length, 1)).getBoundingClientRect();
  return x2 - rect.left > 5;
}
function blockAt(view, pos, side) {
  let line2 = view.lineBlockAt(pos);
  if (Array.isArray(line2.type)) {
    let best;
    for (let l2 of line2.type) {
      if (l2.from > pos)
        break;
      if (l2.to < pos)
        continue;
      if (l2.from < pos && l2.to > pos)
        return l2;
      if (!best || l2.type == BlockType.Text && (best.type != l2.type || (side < 0 ? l2.from < pos : l2.to > pos)))
        best = l2;
    }
    return best || line2;
  }
  return line2;
}
function moveToLineBoundary(view, start, forward, includeWrap) {
  let line2 = blockAt(view, start.head, start.assoc || -1);
  let coords = !includeWrap || line2.type != BlockType.Text || !(view.lineWrapping || line2.widgetLineBreaks) ? null : view.coordsAtPos(start.assoc < 0 && start.head > line2.from ? start.head - 1 : start.head);
  if (coords) {
    let editorRect = view.dom.getBoundingClientRect();
    let direction = view.textDirectionAt(line2.from);
    let pos = view.posAtCoords({
      x: forward == (direction == Direction.LTR) ? editorRect.right - 1 : editorRect.left + 1,
      y: (coords.top + coords.bottom) / 2
    });
    if (pos != null)
      return EditorSelection.cursor(pos, forward ? -1 : 1);
  }
  return EditorSelection.cursor(forward ? line2.to : line2.from, forward ? -1 : 1);
}
function moveByChar(view, start, forward, by) {
  let line2 = view.state.doc.lineAt(start.head), spans = view.bidiSpans(line2);
  let direction = view.textDirectionAt(line2.from);
  for (let cur2 = start, check = null; ; ) {
    let next = moveVisually(line2, spans, direction, cur2, forward), char = movedOver;
    if (!next) {
      if (line2.number == (forward ? view.state.doc.lines : 1))
        return cur2;
      char = "\n";
      line2 = view.state.doc.line(line2.number + (forward ? 1 : -1));
      spans = view.bidiSpans(line2);
      next = view.visualLineSide(line2, !forward);
    }
    if (!check) {
      if (!by)
        return next;
      check = by(char);
    } else if (!check(char)) {
      return cur2;
    }
    cur2 = next;
  }
}
function byGroup(view, pos, start) {
  let categorize = view.state.charCategorizer(pos);
  let cat = categorize(start);
  return (next) => {
    let nextCat = categorize(next);
    if (cat == CharCategory.Space)
      cat = nextCat;
    return cat == nextCat;
  };
}
function moveVertically(view, start, forward, distance) {
  let startPos = start.head, dir = forward ? 1 : -1;
  if (startPos == (forward ? view.state.doc.length : 0))
    return EditorSelection.cursor(startPos, start.assoc);
  let goal = start.goalColumn, startY;
  let rect = view.contentDOM.getBoundingClientRect();
  let startCoords = view.coordsAtPos(startPos, start.assoc || -1), docTop = view.documentTop;
  if (startCoords) {
    if (goal == null)
      goal = startCoords.left - rect.left;
    startY = dir < 0 ? startCoords.top : startCoords.bottom;
  } else {
    let line2 = view.viewState.lineBlockAt(startPos);
    if (goal == null)
      goal = Math.min(rect.right - rect.left, view.defaultCharacterWidth * (startPos - line2.from));
    startY = (dir < 0 ? line2.top : line2.bottom) + docTop;
  }
  let resolvedGoal = rect.left + goal;
  let dist2 = distance !== null && distance !== void 0 ? distance : view.viewState.heightOracle.textHeight >> 1;
  for (let extra = 0; ; extra += 10) {
    let curY = startY + (dist2 + extra) * dir;
    let pos = posAtCoords(view, { x: resolvedGoal, y: curY }, false, dir);
    if (curY < rect.top || curY > rect.bottom || (dir < 0 ? pos < startPos : pos > startPos)) {
      let charRect = view.docView.coordsForChar(pos);
      let assoc = !charRect || curY < charRect.top ? -1 : 1;
      return EditorSelection.cursor(pos, assoc, void 0, goal);
    }
  }
}
function skipAtomicRanges(atoms, pos, bias) {
  for (; ; ) {
    let moved = 0;
    for (let set2 of atoms) {
      set2.between(pos - 1, pos + 1, (from, to2, value) => {
        if (pos > from && pos < to2) {
          let side = moved || bias || (pos - from < to2 - pos ? -1 : 1);
          pos = side < 0 ? from : to2;
          moved = side;
        }
      });
    }
    if (!moved)
      return pos;
  }
}
function skipAtomsForSelection(atoms, sel) {
  let ranges = null;
  for (let i2 = 0; i2 < sel.ranges.length; i2++) {
    let range2 = sel.ranges[i2], updated = null;
    if (range2.empty) {
      let pos = skipAtomicRanges(atoms, range2.from, 0);
      if (pos != range2.from)
        updated = EditorSelection.cursor(pos, -1);
    } else {
      let from = skipAtomicRanges(atoms, range2.from, -1);
      let to2 = skipAtomicRanges(atoms, range2.to, 1);
      if (from != range2.from || to2 != range2.to)
        updated = EditorSelection.range(range2.from == range2.anchor ? from : to2, range2.from == range2.head ? from : to2);
    }
    if (updated) {
      if (!ranges)
        ranges = sel.ranges.slice();
      ranges[i2] = updated;
    }
  }
  return ranges ? EditorSelection.create(ranges, sel.mainIndex) : sel;
}
function skipAtoms(view, oldPos, pos) {
  let newPos = skipAtomicRanges(view.state.facet(atomicRanges).map((f2) => f2(view)), pos.from, oldPos.head > pos.from ? -1 : 1);
  return newPos == pos.from ? pos : EditorSelection.cursor(newPos, newPos < pos.from ? 1 : -1);
}
const LineBreakPlaceholder = "￿";
class DOMReader {
  constructor(points, state) {
    this.points = points;
    this.text = "";
    this.lineSeparator = state.facet(EditorState.lineSeparator);
  }
  append(text2) {
    this.text += text2;
  }
  lineBreak() {
    this.text += LineBreakPlaceholder;
  }
  readRange(start, end) {
    if (!start)
      return this;
    let parent = start.parentNode;
    for (let cur2 = start; ; ) {
      this.findPointBefore(parent, cur2);
      let oldLen = this.text.length;
      this.readNode(cur2);
      let next = cur2.nextSibling;
      if (next == end)
        break;
      let view = ContentView.get(cur2), nextView = ContentView.get(next);
      if ((view && nextView ? view.breakAfter : (view ? view.breakAfter : isBlockElement(cur2)) || isBlockElement(next) && (cur2.nodeName != "BR" || cur2.cmIgnore) && this.text.length > oldLen) && !isEmptyToEnd(next, end))
        this.lineBreak();
      cur2 = next;
    }
    this.findPointBefore(parent, end);
    return this;
  }
  readTextNode(node) {
    let text2 = node.nodeValue;
    for (let point2 of this.points)
      if (point2.node == node)
        point2.pos = this.text.length + Math.min(point2.offset, text2.length);
    for (let off = 0, re2 = this.lineSeparator ? null : /\r\n?|\n/g; ; ) {
      let nextBreak = -1, breakSize = 1, m2;
      if (this.lineSeparator) {
        nextBreak = text2.indexOf(this.lineSeparator, off);
        breakSize = this.lineSeparator.length;
      } else if (m2 = re2.exec(text2)) {
        nextBreak = m2.index;
        breakSize = m2[0].length;
      }
      this.append(text2.slice(off, nextBreak < 0 ? text2.length : nextBreak));
      if (nextBreak < 0)
        break;
      this.lineBreak();
      if (breakSize > 1) {
        for (let point2 of this.points)
          if (point2.node == node && point2.pos > this.text.length)
            point2.pos -= breakSize - 1;
      }
      off = nextBreak + breakSize;
    }
  }
  readNode(node) {
    if (node.cmIgnore)
      return;
    let view = ContentView.get(node);
    let fromView = view && view.overrideDOMText;
    if (fromView != null) {
      this.findPointInside(node, fromView.length);
      for (let i2 = fromView.iter(); !i2.next().done; ) {
        if (i2.lineBreak)
          this.lineBreak();
        else
          this.append(i2.value);
      }
    } else if (node.nodeType == 3) {
      this.readTextNode(node);
    } else if (node.nodeName == "BR") {
      if (node.nextSibling)
        this.lineBreak();
    } else if (node.nodeType == 1) {
      this.readRange(node.firstChild, null);
    }
  }
  findPointBefore(node, next) {
    for (let point2 of this.points)
      if (point2.node == node && node.childNodes[point2.offset] == next)
        point2.pos = this.text.length;
  }
  findPointInside(node, length) {
    for (let point2 of this.points)
      if (node.nodeType == 3 ? point2.node == node : node.contains(point2.node))
        point2.pos = this.text.length + (isAtEnd(node, point2.node, point2.offset) ? length : 0);
  }
}
function isAtEnd(parent, node, offset2) {
  for (; ; ) {
    if (!node || offset2 < maxOffset(node))
      return false;
    if (node == parent)
      return true;
    offset2 = domIndex(node) + 1;
    node = node.parentNode;
  }
}
function isEmptyToEnd(node, end) {
  let widgets;
  for (; ; node = node.nextSibling) {
    if (node == end || !node)
      break;
    let view = ContentView.get(node);
    if (!((view === null || view === void 0 ? void 0 : view.isWidget) || node.cmIgnore))
      return false;
    if (view)
      (widgets || (widgets = [])).push(view);
  }
  if (widgets)
    for (let w2 of widgets) {
      let override = w2.overrideDOMText;
      if (override === null || override === void 0 ? void 0 : override.length)
        return false;
    }
  return true;
}
class DOMPoint {
  constructor(node, offset2) {
    this.node = node;
    this.offset = offset2;
    this.pos = -1;
  }
}
class DOMChange {
  constructor(view, start, end, typeOver) {
    this.typeOver = typeOver;
    this.bounds = null;
    this.text = "";
    this.domChanged = start > -1;
    let { impreciseHead: iHead, impreciseAnchor: iAnchor } = view.docView;
    if (view.state.readOnly && start > -1) {
      this.newSel = null;
    } else if (start > -1 && (this.bounds = view.docView.domBoundsAround(start, end, 0))) {
      let selPoints = iHead || iAnchor ? [] : selectionPoints(view);
      let reader = new DOMReader(selPoints, view.state);
      reader.readRange(this.bounds.startDOM, this.bounds.endDOM);
      this.text = reader.text;
      this.newSel = selectionFromPoints(selPoints, this.bounds.from);
    } else {
      let domSel = view.observer.selectionRange;
      let head = iHead && iHead.node == domSel.focusNode && iHead.offset == domSel.focusOffset || !contains$1(view.contentDOM, domSel.focusNode) ? view.state.selection.main.head : view.docView.posFromDOM(domSel.focusNode, domSel.focusOffset);
      let anchor = iAnchor && iAnchor.node == domSel.anchorNode && iAnchor.offset == domSel.anchorOffset || !contains$1(view.contentDOM, domSel.anchorNode) ? view.state.selection.main.anchor : view.docView.posFromDOM(domSel.anchorNode, domSel.anchorOffset);
      let vp = view.viewport;
      if ((browser$3.ios || browser$3.chrome) && view.state.selection.main.empty && head != anchor && (vp.from > 0 || vp.to < view.state.doc.length)) {
        let from = Math.min(head, anchor), to2 = Math.max(head, anchor);
        let offFrom = vp.from - from, offTo = vp.to - to2;
        if ((offFrom == 0 || offFrom == 1 || from == 0) && (offTo == 0 || offTo == -1 || to2 == view.state.doc.length)) {
          head = 0;
          anchor = view.state.doc.length;
        }
      }
      if (view.inputState.composing > -1 && view.state.selection.ranges.length > 1)
        this.newSel = view.state.selection.replaceRange(EditorSelection.range(anchor, head));
      else
        this.newSel = EditorSelection.single(anchor, head);
    }
  }
}
function applyDOMChange(view, domChange) {
  let change;
  let { newSel } = domChange, sel = view.state.selection.main;
  let lastKey = view.inputState.lastKeyTime > Date.now() - 100 ? view.inputState.lastKeyCode : -1;
  if (domChange.bounds) {
    let { from, to: to2 } = domChange.bounds;
    let preferredPos = sel.from, preferredSide = null;
    if (lastKey === 8 || browser$3.android && domChange.text.length < to2 - from) {
      preferredPos = sel.to;
      preferredSide = "end";
    }
    let diff = findDiff(view.state.doc.sliceString(from, to2, LineBreakPlaceholder), domChange.text, preferredPos - from, preferredSide);
    if (diff) {
      if (browser$3.chrome && lastKey == 13 && diff.toB == diff.from + 2 && domChange.text.slice(diff.from, diff.toB) == LineBreakPlaceholder + LineBreakPlaceholder)
        diff.toB--;
      change = {
        from: from + diff.from,
        to: from + diff.toA,
        insert: Text$1.of(domChange.text.slice(diff.from, diff.toB).split(LineBreakPlaceholder))
      };
    }
  } else if (newSel && (!view.hasFocus && view.state.facet(editable) || newSel.main.eq(sel))) {
    newSel = null;
  }
  if (!change && !newSel)
    return false;
  if (!change && domChange.typeOver && !sel.empty && newSel && newSel.main.empty) {
    change = { from: sel.from, to: sel.to, insert: view.state.doc.slice(sel.from, sel.to) };
  } else if ((browser$3.mac || browser$3.android) && change && change.from == change.to && change.from == sel.head - 1 && /^\. ?$/.test(change.insert.toString()) && view.contentDOM.getAttribute("autocorrect") == "off") {
    if (newSel && change.insert.length == 2)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: change.from, to: change.to, insert: Text$1.of([change.insert.toString().replace(".", " ")]) };
  } else if (change && change.from >= sel.from && change.to <= sel.to && (change.from != sel.from || change.to != sel.to) && sel.to - sel.from - (change.to - change.from) <= 4) {
    change = {
      from: sel.from,
      to: sel.to,
      insert: view.state.doc.slice(sel.from, change.from).append(change.insert).append(view.state.doc.slice(change.to, sel.to))
    };
  } else if (view.state.doc.lineAt(sel.from).to < sel.to && view.docView.lineHasWidget(sel.to) && view.inputState.insertingTextAt > Date.now() - 50) {
    change = {
      from: sel.from,
      to: sel.to,
      insert: view.state.toText(view.inputState.insertingText)
    };
  } else if (browser$3.chrome && change && change.from == change.to && change.from == sel.head && change.insert.toString() == "\n " && view.lineWrapping) {
    if (newSel)
      newSel = EditorSelection.single(newSel.main.anchor - 1, newSel.main.head - 1);
    change = { from: sel.from, to: sel.to, insert: Text$1.of([" "]) };
  }
  if (change) {
    return applyDOMChangeInner(view, change, newSel, lastKey);
  } else if (newSel && !newSel.main.eq(sel)) {
    let scrollIntoView2 = false, userEvent = "select";
    if (view.inputState.lastSelectionTime > Date.now() - 50) {
      if (view.inputState.lastSelectionOrigin == "select")
        scrollIntoView2 = true;
      userEvent = view.inputState.lastSelectionOrigin;
      if (userEvent == "select.pointer")
        newSel = skipAtomsForSelection(view.state.facet(atomicRanges).map((f2) => f2(view)), newSel);
    }
    view.dispatch({ selection: newSel, scrollIntoView: scrollIntoView2, userEvent });
    return true;
  } else {
    return false;
  }
}
function applyDOMChangeInner(view, change, newSel, lastKey = -1) {
  if (browser$3.ios && view.inputState.flushIOSKey(change))
    return true;
  let sel = view.state.selection.main;
  if (browser$3.android && (change.to == sel.to && // GBoard will sometimes remove a space it just inserted
  // after a completion when you press enter
  (change.from == sel.from || change.from == sel.from - 1 && view.state.sliceDoc(change.from, sel.from) == " ") && change.insert.length == 1 && change.insert.lines == 2 && dispatchKey(view.contentDOM, "Enter", 13) || (change.from == sel.from - 1 && change.to == sel.to && change.insert.length == 0 || lastKey == 8 && change.insert.length < change.to - change.from && change.to > sel.head) && dispatchKey(view.contentDOM, "Backspace", 8) || change.from == sel.from && change.to == sel.to + 1 && change.insert.length == 0 && dispatchKey(view.contentDOM, "Delete", 46)))
    return true;
  let text2 = change.insert.toString();
  if (view.inputState.composing >= 0)
    view.inputState.composing++;
  let defaultTr;
  let defaultInsert = () => defaultTr || (defaultTr = applyDefaultInsert(view, change, newSel));
  if (!view.state.facet(inputHandler$1).some((h2) => h2(view, change.from, change.to, text2, defaultInsert)))
    view.dispatch(defaultInsert());
  return true;
}
function applyDefaultInsert(view, change, newSel) {
  let tr2, startState = view.state, sel = startState.selection.main, inAtomic = -1;
  if (change.from == change.to && change.from < sel.from || change.from > sel.to) {
    let side = change.from < sel.from ? -1 : 1, pos = side < 0 ? sel.from : sel.to;
    let moved = skipAtomicRanges(startState.facet(atomicRanges).map((f2) => f2(view)), pos, side);
    if (change.from == moved)
      inAtomic = moved;
  }
  if (inAtomic > -1) {
    tr2 = {
      changes: change,
      selection: EditorSelection.cursor(change.from + change.insert.length, -1)
    };
  } else if (change.from >= sel.from && change.to <= sel.to && change.to - change.from >= (sel.to - sel.from) / 3 && (!newSel || newSel.main.empty && newSel.main.from == change.from + change.insert.length) && view.inputState.composing < 0) {
    let before2 = sel.from < change.from ? startState.sliceDoc(sel.from, change.from) : "";
    let after2 = sel.to > change.to ? startState.sliceDoc(change.to, sel.to) : "";
    tr2 = startState.replaceSelection(view.state.toText(before2 + change.insert.sliceString(0, void 0, view.state.lineBreak) + after2));
  } else {
    let changes = startState.changes(change);
    let mainSel = newSel && newSel.main.to <= changes.newLength ? newSel.main : void 0;
    if (startState.selection.ranges.length > 1 && (view.inputState.composing >= 0 || view.inputState.compositionPendingChange) && change.to <= sel.to + 10 && change.to >= sel.to - 10) {
      let replaced = view.state.sliceDoc(change.from, change.to);
      let compositionRange, composition = newSel && findCompositionNode(view, newSel.main.head);
      if (composition) {
        let dLen = change.insert.length - (change.to - change.from);
        compositionRange = { from: composition.from, to: composition.to - dLen };
      } else {
        compositionRange = view.state.doc.lineAt(sel.head);
      }
      let offset2 = sel.to - change.to;
      tr2 = startState.changeByRange((range2) => {
        if (range2.from == sel.from && range2.to == sel.to)
          return { changes, range: mainSel || range2.map(changes) };
        let to2 = range2.to - offset2, from = to2 - replaced.length;
        if (view.state.sliceDoc(from, to2) != replaced || // Unfortunately, there's no way to make multiple
        // changes in the same node work without aborting
        // composition, so cursors in the composition range are
        // ignored.
        to2 >= compositionRange.from && from <= compositionRange.to)
          return { range: range2 };
        let rangeChanges = startState.changes({ from, to: to2, insert: change.insert }), selOff = range2.to - sel.to;
        return {
          changes: rangeChanges,
          range: !mainSel ? range2.map(rangeChanges) : EditorSelection.range(Math.max(0, mainSel.anchor + selOff), Math.max(0, mainSel.head + selOff))
        };
      });
    } else {
      tr2 = {
        changes,
        selection: mainSel && startState.selection.replaceRange(mainSel)
      };
    }
  }
  let userEvent = "input.type";
  if (view.composing || view.inputState.compositionPendingChange && view.inputState.compositionEndedAt > Date.now() - 50) {
    view.inputState.compositionPendingChange = false;
    userEvent += ".compose";
    if (view.inputState.compositionFirstChange) {
      userEvent += ".start";
      view.inputState.compositionFirstChange = false;
    }
  }
  return startState.update(tr2, { userEvent, scrollIntoView: true });
}
function findDiff(a2, b2, preferredPos, preferredSide) {
  let minLen = Math.min(a2.length, b2.length);
  let from = 0;
  while (from < minLen && a2.charCodeAt(from) == b2.charCodeAt(from))
    from++;
  if (from == minLen && a2.length == b2.length)
    return null;
  let toA = a2.length, toB = b2.length;
  while (toA > 0 && toB > 0 && a2.charCodeAt(toA - 1) == b2.charCodeAt(toB - 1)) {
    toA--;
    toB--;
  }
  if (preferredSide == "end") {
    let adjust = Math.max(0, from - Math.min(toA, toB));
    preferredPos -= toA + adjust - from;
  }
  if (toA < from && a2.length < b2.length) {
    let move = preferredPos <= from && preferredPos >= toA ? from - preferredPos : 0;
    from -= move;
    toB = from + (toB - toA);
    toA = from;
  } else if (toB < from) {
    let move = preferredPos <= from && preferredPos >= toB ? from - preferredPos : 0;
    from -= move;
    toA = from + (toA - toB);
    toB = from;
  }
  return { from, toA, toB };
}
function selectionPoints(view) {
  let result2 = [];
  if (view.root.activeElement != view.contentDOM)
    return result2;
  let { anchorNode, anchorOffset, focusNode, focusOffset } = view.observer.selectionRange;
  if (anchorNode) {
    result2.push(new DOMPoint(anchorNode, anchorOffset));
    if (focusNode != anchorNode || focusOffset != anchorOffset)
      result2.push(new DOMPoint(focusNode, focusOffset));
  }
  return result2;
}
function selectionFromPoints(points, base2) {
  if (points.length == 0)
    return null;
  let anchor = points[0].pos, head = points.length == 2 ? points[1].pos : anchor;
  return anchor > -1 && head > -1 ? EditorSelection.single(anchor + base2, head + base2) : null;
}
class InputState {
  setSelectionOrigin(origin) {
    this.lastSelectionOrigin = origin;
    this.lastSelectionTime = Date.now();
  }
  constructor(view) {
    this.view = view;
    this.lastKeyCode = 0;
    this.lastKeyTime = 0;
    this.lastTouchTime = 0;
    this.lastFocusTime = 0;
    this.lastScrollTop = 0;
    this.lastScrollLeft = 0;
    this.pendingIOSKey = void 0;
    this.tabFocusMode = -1;
    this.lastSelectionOrigin = null;
    this.lastSelectionTime = 0;
    this.lastContextMenu = 0;
    this.scrollHandlers = [];
    this.handlers = /* @__PURE__ */ Object.create(null);
    this.composing = -1;
    this.compositionFirstChange = null;
    this.compositionEndedAt = 0;
    this.compositionPendingKey = false;
    this.compositionPendingChange = false;
    this.insertingText = "";
    this.insertingTextAt = 0;
    this.mouseSelection = null;
    this.draggedContent = null;
    this.handleEvent = this.handleEvent.bind(this);
    this.notifiedFocused = view.hasFocus;
    if (browser$3.safari)
      view.contentDOM.addEventListener("input", () => null);
    if (browser$3.gecko)
      firefoxCopyCutHack(view.contentDOM.ownerDocument);
  }
  handleEvent(event) {
    if (!eventBelongsToEditor(this.view, event) || this.ignoreDuringComposition(event))
      return;
    if (event.type == "keydown" && this.keydown(event))
      return;
    if (this.view.updateState != 0)
      Promise.resolve().then(() => this.runHandlers(event.type, event));
    else
      this.runHandlers(event.type, event);
  }
  runHandlers(type, event) {
    let handlers2 = this.handlers[type];
    if (handlers2) {
      for (let observer of handlers2.observers)
        observer(this.view, event);
      for (let handler of handlers2.handlers) {
        if (event.defaultPrevented)
          break;
        if (handler(this.view, event)) {
          event.preventDefault();
          break;
        }
      }
    }
  }
  ensureHandlers(plugins2) {
    let handlers2 = computeHandlers(plugins2), prev = this.handlers, dom = this.view.contentDOM;
    for (let type in handlers2)
      if (type != "scroll") {
        let passive = !handlers2[type].handlers.length;
        let exists = prev[type];
        if (exists && passive != !exists.handlers.length) {
          dom.removeEventListener(type, this.handleEvent);
          exists = null;
        }
        if (!exists)
          dom.addEventListener(type, this.handleEvent, { passive });
      }
    for (let type in prev)
      if (type != "scroll" && !handlers2[type])
        dom.removeEventListener(type, this.handleEvent);
    this.handlers = handlers2;
  }
  keydown(event) {
    this.lastKeyCode = event.keyCode;
    this.lastKeyTime = Date.now();
    if (event.keyCode == 9 && this.tabFocusMode > -1 && (!this.tabFocusMode || Date.now() <= this.tabFocusMode))
      return true;
    if (this.tabFocusMode > 0 && event.keyCode != 27 && modifierCodes.indexOf(event.keyCode) < 0)
      this.tabFocusMode = -1;
    if (browser$3.android && browser$3.chrome && !event.synthetic && (event.keyCode == 13 || event.keyCode == 8)) {
      this.view.observer.delayAndroidKey(event.key, event.keyCode);
      return true;
    }
    let pending;
    if (browser$3.ios && !event.synthetic && !event.altKey && !event.metaKey && ((pending = PendingKeys.find((key) => key.keyCode == event.keyCode)) && !event.ctrlKey || EmacsyPendingKeys.indexOf(event.key) > -1 && event.ctrlKey && !event.shiftKey)) {
      this.pendingIOSKey = pending || event;
      setTimeout(() => this.flushIOSKey(), 250);
      return true;
    }
    if (event.keyCode != 229)
      this.view.observer.forceFlush();
    return false;
  }
  flushIOSKey(change) {
    let key = this.pendingIOSKey;
    if (!key)
      return false;
    if (key.key == "Enter" && change && change.from < change.to && /^\S+$/.test(change.insert.toString()))
      return false;
    this.pendingIOSKey = void 0;
    return dispatchKey(this.view.contentDOM, key.key, key.keyCode, key instanceof KeyboardEvent ? key : void 0);
  }
  ignoreDuringComposition(event) {
    if (!/^key/.test(event.type) || event.synthetic)
      return false;
    if (this.composing > 0)
      return true;
    if (browser$3.safari && !browser$3.ios && this.compositionPendingKey && Date.now() - this.compositionEndedAt < 100) {
      this.compositionPendingKey = false;
      return true;
    }
    return false;
  }
  startMouseSelection(mouseSelection) {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
    this.mouseSelection = mouseSelection;
  }
  update(update) {
    this.view.observer.update(update);
    if (this.mouseSelection)
      this.mouseSelection.update(update);
    if (this.draggedContent && update.docChanged)
      this.draggedContent = this.draggedContent.map(update.changes);
    if (update.transactions.length)
      this.lastKeyCode = this.lastSelectionTime = 0;
  }
  destroy() {
    if (this.mouseSelection)
      this.mouseSelection.destroy();
  }
}
function bindHandler(plugin, handler) {
  return (view, event) => {
    try {
      return handler.call(plugin, event, view);
    } catch (e2) {
      logException(view.state, e2);
    }
  };
}
function computeHandlers(plugins2) {
  let result2 = /* @__PURE__ */ Object.create(null);
  function record(type) {
    return result2[type] || (result2[type] = { observers: [], handlers: [] });
  }
  for (let plugin of plugins2) {
    let spec = plugin.spec, handlers2 = spec && spec.plugin.domEventHandlers, observers2 = spec && spec.plugin.domEventObservers;
    if (handlers2)
      for (let type in handlers2) {
        let f2 = handlers2[type];
        if (f2)
          record(type).handlers.push(bindHandler(plugin.value, f2));
      }
    if (observers2)
      for (let type in observers2) {
        let f2 = observers2[type];
        if (f2)
          record(type).observers.push(bindHandler(plugin.value, f2));
      }
  }
  for (let type in handlers)
    record(type).handlers.push(handlers[type]);
  for (let type in observers)
    record(type).observers.push(observers[type]);
  return result2;
}
const PendingKeys = [
  { key: "Backspace", keyCode: 8, inputType: "deleteContentBackward" },
  { key: "Enter", keyCode: 13, inputType: "insertParagraph" },
  { key: "Enter", keyCode: 13, inputType: "insertLineBreak" },
  { key: "Delete", keyCode: 46, inputType: "deleteContentForward" }
];
const EmacsyPendingKeys = "dthko";
const modifierCodes = [16, 17, 18, 20, 91, 92, 224, 225];
const dragScrollMargin = 6;
function dragScrollSpeed(dist2) {
  return Math.max(0, dist2) * 0.7 + 8;
}
function dist$1$1(a2, b2) {
  return Math.max(Math.abs(a2.clientX - b2.clientX), Math.abs(a2.clientY - b2.clientY));
}
class MouseSelection {
  constructor(view, startEvent, style, mustSelect) {
    this.view = view;
    this.startEvent = startEvent;
    this.style = style;
    this.mustSelect = mustSelect;
    this.scrollSpeed = { x: 0, y: 0 };
    this.scrolling = -1;
    this.lastEvent = startEvent;
    this.scrollParents = scrollableParents(view.contentDOM);
    this.atoms = view.state.facet(atomicRanges).map((f2) => f2(view));
    let doc2 = view.contentDOM.ownerDocument;
    doc2.addEventListener("mousemove", this.move = this.move.bind(this));
    doc2.addEventListener("mouseup", this.up = this.up.bind(this));
    this.extend = startEvent.shiftKey;
    this.multiple = view.state.facet(EditorState.allowMultipleSelections) && addsSelectionRange(view, startEvent);
    this.dragging = isInPrimarySelection(view, startEvent) && getClickType(startEvent) == 1 ? null : false;
  }
  start(event) {
    if (this.dragging === false)
      this.select(event);
  }
  move(event) {
    if (event.buttons == 0)
      return this.destroy();
    if (this.dragging || this.dragging == null && dist$1$1(this.startEvent, event) < 10)
      return;
    this.select(this.lastEvent = event);
    let sx = 0, sy = 0;
    let left = 0, top2 = 0, right = this.view.win.innerWidth, bottom = this.view.win.innerHeight;
    if (this.scrollParents.x)
      ({ left, right } = this.scrollParents.x.getBoundingClientRect());
    if (this.scrollParents.y)
      ({ top: top2, bottom } = this.scrollParents.y.getBoundingClientRect());
    let margins = getScrollMargins(this.view);
    if (event.clientX - margins.left <= left + dragScrollMargin)
      sx = -dragScrollSpeed(left - event.clientX);
    else if (event.clientX + margins.right >= right - dragScrollMargin)
      sx = dragScrollSpeed(event.clientX - right);
    if (event.clientY - margins.top <= top2 + dragScrollMargin)
      sy = -dragScrollSpeed(top2 - event.clientY);
    else if (event.clientY + margins.bottom >= bottom - dragScrollMargin)
      sy = dragScrollSpeed(event.clientY - bottom);
    this.setScrollSpeed(sx, sy);
  }
  up(event) {
    if (this.dragging == null)
      this.select(this.lastEvent);
    if (!this.dragging)
      event.preventDefault();
    this.destroy();
  }
  destroy() {
    this.setScrollSpeed(0, 0);
    let doc2 = this.view.contentDOM.ownerDocument;
    doc2.removeEventListener("mousemove", this.move);
    doc2.removeEventListener("mouseup", this.up);
    this.view.inputState.mouseSelection = this.view.inputState.draggedContent = null;
  }
  setScrollSpeed(sx, sy) {
    this.scrollSpeed = { x: sx, y: sy };
    if (sx || sy) {
      if (this.scrolling < 0)
        this.scrolling = setInterval(() => this.scroll(), 50);
    } else if (this.scrolling > -1) {
      clearInterval(this.scrolling);
      this.scrolling = -1;
    }
  }
  scroll() {
    let { x: x2, y: y2 } = this.scrollSpeed;
    if (x2 && this.scrollParents.x) {
      this.scrollParents.x.scrollLeft += x2;
      x2 = 0;
    }
    if (y2 && this.scrollParents.y) {
      this.scrollParents.y.scrollTop += y2;
      y2 = 0;
    }
    if (x2 || y2)
      this.view.win.scrollBy(x2, y2);
    if (this.dragging === false)
      this.select(this.lastEvent);
  }
  select(event) {
    let { view } = this, selection2 = skipAtomsForSelection(this.atoms, this.style.get(event, this.extend, this.multiple));
    if (this.mustSelect || !selection2.eq(view.state.selection, this.dragging === false))
      this.view.dispatch({
        selection: selection2,
        userEvent: "select.pointer"
      });
    this.mustSelect = false;
  }
  update(update) {
    if (update.transactions.some((tr2) => tr2.isUserEvent("input.type")))
      this.destroy();
    else if (this.style.update(update))
      setTimeout(() => this.select(this.lastEvent), 20);
  }
}
function addsSelectionRange(view, event) {
  let facet = view.state.facet(clickAddsSelectionRange);
  return facet.length ? facet[0](event) : browser$3.mac ? event.metaKey : event.ctrlKey;
}
function dragMovesSelection(view, event) {
  let facet = view.state.facet(dragMovesSelection$1);
  return facet.length ? facet[0](event) : browser$3.mac ? !event.altKey : !event.ctrlKey;
}
function isInPrimarySelection(view, event) {
  let { main: main2 } = view.state.selection;
  if (main2.empty)
    return false;
  let sel = getSelection(view.root);
  if (!sel || sel.rangeCount == 0)
    return true;
  let rects = sel.getRangeAt(0).getClientRects();
  for (let i2 = 0; i2 < rects.length; i2++) {
    let rect = rects[i2];
    if (rect.left <= event.clientX && rect.right >= event.clientX && rect.top <= event.clientY && rect.bottom >= event.clientY)
      return true;
  }
  return false;
}
function eventBelongsToEditor(view, event) {
  if (!event.bubbles)
    return true;
  if (event.defaultPrevented)
    return false;
  for (let node = event.target, cView; node != view.contentDOM; node = node.parentNode)
    if (!node || node.nodeType == 11 || (cView = ContentView.get(node)) && cView.ignoreEvent(event))
      return false;
  return true;
}
const handlers = /* @__PURE__ */ Object.create(null);
const observers = /* @__PURE__ */ Object.create(null);
const brokenClipboardAPI = browser$3.ie && browser$3.ie_version < 15 || browser$3.ios && browser$3.webkit_version < 604;
function capturePaste(view) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.focus();
  setTimeout(() => {
    view.focus();
    target.remove();
    doPaste(view, target.value);
  }, 50);
}
function textFilter(state, facet, text2) {
  for (let filter2 of state.facet(facet))
    text2 = filter2(text2, state);
  return text2;
}
function doPaste(view, input) {
  input = textFilter(view.state, clipboardInputFilter, input);
  let { state } = view, changes, i2 = 1, text2 = state.toText(input);
  let byLine = text2.lines == state.selection.ranges.length;
  let linewise = lastLinewiseCopy != null && state.selection.ranges.every((r2) => r2.empty) && lastLinewiseCopy == text2.toString();
  if (linewise) {
    let lastLine = -1;
    changes = state.changeByRange((range2) => {
      let line2 = state.doc.lineAt(range2.from);
      if (line2.from == lastLine)
        return { range: range2 };
      lastLine = line2.from;
      let insert2 = state.toText((byLine ? text2.line(i2++).text : input) + state.lineBreak);
      return {
        changes: { from: line2.from, insert: insert2 },
        range: EditorSelection.cursor(range2.from + insert2.length)
      };
    });
  } else if (byLine) {
    changes = state.changeByRange((range2) => {
      let line2 = text2.line(i2++);
      return {
        changes: { from: range2.from, to: range2.to, insert: line2.text },
        range: EditorSelection.cursor(range2.from + line2.length)
      };
    });
  } else {
    changes = state.replaceSelection(text2);
  }
  view.dispatch(changes, {
    userEvent: "input.paste",
    scrollIntoView: true
  });
}
observers.scroll = (view) => {
  view.inputState.lastScrollTop = view.scrollDOM.scrollTop;
  view.inputState.lastScrollLeft = view.scrollDOM.scrollLeft;
};
handlers.keydown = (view, event) => {
  view.inputState.setSelectionOrigin("select");
  if (event.keyCode == 27 && view.inputState.tabFocusMode != 0)
    view.inputState.tabFocusMode = Date.now() + 2e3;
  return false;
};
observers.touchstart = (view, e2) => {
  view.inputState.lastTouchTime = Date.now();
  view.inputState.setSelectionOrigin("select.pointer");
};
observers.touchmove = (view) => {
  view.inputState.setSelectionOrigin("select.pointer");
};
handlers.mousedown = (view, event) => {
  view.observer.flush();
  if (view.inputState.lastTouchTime > Date.now() - 2e3)
    return false;
  let style = null;
  for (let makeStyle of view.state.facet(mouseSelectionStyle)) {
    style = makeStyle(view, event);
    if (style)
      break;
  }
  if (!style && event.button == 0)
    style = basicMouseSelection(view, event);
  if (style) {
    let mustFocus = !view.hasFocus;
    view.inputState.startMouseSelection(new MouseSelection(view, event, style, mustFocus));
    if (mustFocus)
      view.observer.ignore(() => {
        focusPreventScroll(view.contentDOM);
        let active = view.root.activeElement;
        if (active && !active.contains(view.contentDOM))
          active.blur();
      });
    let mouseSel = view.inputState.mouseSelection;
    if (mouseSel) {
      mouseSel.start(event);
      return mouseSel.dragging === false;
    }
  } else {
    view.inputState.setSelectionOrigin("select.pointer");
  }
  return false;
};
function rangeForClick(view, pos, bias, type) {
  if (type == 1) {
    return EditorSelection.cursor(pos, bias);
  } else if (type == 2) {
    return groupAt(view.state, pos, bias);
  } else {
    let visual = LineView.find(view.docView, pos), line2 = view.state.doc.lineAt(visual ? visual.posAtEnd : pos);
    let from = visual ? visual.posAtStart : line2.from, to2 = visual ? visual.posAtEnd : line2.to;
    if (to2 < view.state.doc.length && to2 == line2.to)
      to2++;
    return EditorSelection.range(from, to2);
  }
}
let inside = (x2, y2, rect) => y2 >= rect.top && y2 <= rect.bottom && x2 >= rect.left && x2 <= rect.right;
function findPositionSide(view, pos, x2, y2) {
  let line2 = LineView.find(view.docView, pos);
  if (!line2)
    return 1;
  let off = pos - line2.posAtStart;
  if (off == 0)
    return 1;
  if (off == line2.length)
    return -1;
  let before2 = line2.coordsAt(off, -1);
  if (before2 && inside(x2, y2, before2))
    return -1;
  let after2 = line2.coordsAt(off, 1);
  if (after2 && inside(x2, y2, after2))
    return 1;
  return before2 && before2.bottom >= y2 ? -1 : 1;
}
function queryPos(view, event) {
  let pos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  return { pos, bias: findPositionSide(view, pos, event.clientX, event.clientY) };
}
const BadMouseDetail = browser$3.ie && browser$3.ie_version <= 11;
let lastMouseDown = null, lastMouseDownCount = 0, lastMouseDownTime = 0;
function getClickType(event) {
  if (!BadMouseDetail)
    return event.detail;
  let last2 = lastMouseDown, lastTime = lastMouseDownTime;
  lastMouseDown = event;
  lastMouseDownTime = Date.now();
  return lastMouseDownCount = !last2 || lastTime > Date.now() - 400 && Math.abs(last2.clientX - event.clientX) < 2 && Math.abs(last2.clientY - event.clientY) < 2 ? (lastMouseDownCount + 1) % 3 : 1;
}
function basicMouseSelection(view, event) {
  let start = queryPos(view, event), type = getClickType(event);
  let startSel = view.state.selection;
  return {
    update(update) {
      if (update.docChanged) {
        start.pos = update.changes.mapPos(start.pos);
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, extend2, multiple) {
      let cur2 = queryPos(view, event2), removed;
      let range2 = rangeForClick(view, cur2.pos, cur2.bias, type);
      if (start.pos != cur2.pos && !extend2) {
        let startRange = rangeForClick(view, start.pos, start.bias, type);
        let from = Math.min(startRange.from, range2.from), to2 = Math.max(startRange.to, range2.to);
        range2 = from < range2.from ? EditorSelection.range(from, to2) : EditorSelection.range(to2, from);
      }
      if (extend2)
        return startSel.replaceRange(startSel.main.extend(range2.from, range2.to));
      else if (multiple && type == 1 && startSel.ranges.length > 1 && (removed = removeRangeAround(startSel, cur2.pos)))
        return removed;
      else if (multiple)
        return startSel.addRange(range2);
      else
        return EditorSelection.create([range2]);
    }
  };
}
function removeRangeAround(sel, pos) {
  for (let i2 = 0; i2 < sel.ranges.length; i2++) {
    let { from, to: to2 } = sel.ranges[i2];
    if (from <= pos && to2 >= pos)
      return EditorSelection.create(sel.ranges.slice(0, i2).concat(sel.ranges.slice(i2 + 1)), sel.mainIndex == i2 ? 0 : sel.mainIndex - (sel.mainIndex > i2 ? 1 : 0));
  }
  return null;
}
handlers.dragstart = (view, event) => {
  let { selection: { main: range2 } } = view.state;
  if (event.target.draggable) {
    let cView = view.docView.nearest(event.target);
    if (cView && cView.isWidget) {
      let from = cView.posAtStart, to2 = from + cView.length;
      if (from >= range2.to || to2 <= range2.from)
        range2 = EditorSelection.range(from, to2);
    }
  }
  let { inputState } = view;
  if (inputState.mouseSelection)
    inputState.mouseSelection.dragging = true;
  inputState.draggedContent = range2;
  if (event.dataTransfer) {
    event.dataTransfer.setData("Text", textFilter(view.state, clipboardOutputFilter, view.state.sliceDoc(range2.from, range2.to)));
    event.dataTransfer.effectAllowed = "copyMove";
  }
  return false;
};
handlers.dragend = (view) => {
  view.inputState.draggedContent = null;
  return false;
};
function dropText(view, event, text2, direct) {
  text2 = textFilter(view.state, clipboardInputFilter, text2);
  if (!text2)
    return;
  let dropPos = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  let { draggedContent } = view.inputState;
  let del = direct && draggedContent && dragMovesSelection(view, event) ? { from: draggedContent.from, to: draggedContent.to } : null;
  let ins = { from: dropPos, insert: text2 };
  let changes = view.state.changes(del ? [del, ins] : ins);
  view.focus();
  view.dispatch({
    changes,
    selection: { anchor: changes.mapPos(dropPos, -1), head: changes.mapPos(dropPos, 1) },
    userEvent: del ? "move.drop" : "input.drop"
  });
  view.inputState.draggedContent = null;
}
handlers.drop = (view, event) => {
  if (!event.dataTransfer)
    return false;
  if (view.state.readOnly)
    return true;
  let files = event.dataTransfer.files;
  if (files && files.length) {
    let text2 = Array(files.length), read = 0;
    let finishFile = () => {
      if (++read == files.length)
        dropText(view, event, text2.filter((s2) => s2 != null).join(view.state.lineBreak), false);
    };
    for (let i2 = 0; i2 < files.length; i2++) {
      let reader = new FileReader();
      reader.onerror = finishFile;
      reader.onload = () => {
        if (!/[\x00-\x08\x0e-\x1f]{2}/.test(reader.result))
          text2[i2] = reader.result;
        finishFile();
      };
      reader.readAsText(files[i2]);
    }
    return true;
  } else {
    let text2 = event.dataTransfer.getData("Text");
    if (text2) {
      dropText(view, event, text2, true);
      return true;
    }
  }
  return false;
};
handlers.paste = (view, event) => {
  if (view.state.readOnly)
    return true;
  view.observer.flush();
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    doPaste(view, data.getData("text/plain") || data.getData("text/uri-list"));
    return true;
  } else {
    capturePaste(view);
    return false;
  }
};
function captureCopy(view, text2) {
  let parent = view.dom.parentNode;
  if (!parent)
    return;
  let target = parent.appendChild(document.createElement("textarea"));
  target.style.cssText = "position: fixed; left: -10000px; top: 10px";
  target.value = text2;
  target.focus();
  target.selectionEnd = text2.length;
  target.selectionStart = 0;
  setTimeout(() => {
    target.remove();
    view.focus();
  }, 50);
}
function copiedRange(state) {
  let content2 = [], ranges = [], linewise = false;
  for (let range2 of state.selection.ranges)
    if (!range2.empty) {
      content2.push(state.sliceDoc(range2.from, range2.to));
      ranges.push(range2);
    }
  if (!content2.length) {
    let upto = -1;
    for (let { from } of state.selection.ranges) {
      let line2 = state.doc.lineAt(from);
      if (line2.number > upto) {
        content2.push(line2.text);
        ranges.push({ from: line2.from, to: Math.min(state.doc.length, line2.to + 1) });
      }
      upto = line2.number;
    }
    linewise = true;
  }
  return { text: textFilter(state, clipboardOutputFilter, content2.join(state.lineBreak)), ranges, linewise };
}
let lastLinewiseCopy = null;
handlers.copy = handlers.cut = (view, event) => {
  let { text: text2, ranges, linewise } = copiedRange(view.state);
  if (!text2 && !linewise)
    return false;
  lastLinewiseCopy = linewise ? text2 : null;
  if (event.type == "cut" && !view.state.readOnly)
    view.dispatch({
      changes: ranges,
      scrollIntoView: true,
      userEvent: "delete.cut"
    });
  let data = brokenClipboardAPI ? null : event.clipboardData;
  if (data) {
    data.clearData();
    data.setData("text/plain", text2);
    return true;
  } else {
    captureCopy(view, text2);
    return false;
  }
};
const isFocusChange = /* @__PURE__ */ Annotation.define();
function focusChangeTransaction(state, focus) {
  let effects = [];
  for (let getEffect of state.facet(focusChangeEffect)) {
    let effect = getEffect(state, focus);
    if (effect)
      effects.push(effect);
  }
  return effects.length ? state.update({ effects, annotations: isFocusChange.of(true) }) : null;
}
function updateForFocusChange(view) {
  setTimeout(() => {
    let focus = view.hasFocus;
    if (focus != view.inputState.notifiedFocused) {
      let tr2 = focusChangeTransaction(view.state, focus);
      if (tr2)
        view.dispatch(tr2);
      else
        view.update([]);
    }
  }, 10);
}
observers.focus = (view) => {
  view.inputState.lastFocusTime = Date.now();
  if (!view.scrollDOM.scrollTop && (view.inputState.lastScrollTop || view.inputState.lastScrollLeft)) {
    view.scrollDOM.scrollTop = view.inputState.lastScrollTop;
    view.scrollDOM.scrollLeft = view.inputState.lastScrollLeft;
  }
  updateForFocusChange(view);
};
observers.blur = (view) => {
  view.observer.clearSelectionRange();
  updateForFocusChange(view);
};
observers.compositionstart = observers.compositionupdate = (view) => {
  if (view.observer.editContext)
    return;
  if (view.inputState.compositionFirstChange == null)
    view.inputState.compositionFirstChange = true;
  if (view.inputState.composing < 0) {
    view.inputState.composing = 0;
  }
};
observers.compositionend = (view) => {
  if (view.observer.editContext)
    return;
  view.inputState.composing = -1;
  view.inputState.compositionEndedAt = Date.now();
  view.inputState.compositionPendingKey = true;
  view.inputState.compositionPendingChange = view.observer.pendingRecords().length > 0;
  view.inputState.compositionFirstChange = null;
  if (browser$3.chrome && browser$3.android) {
    view.observer.flushSoon();
  } else if (view.inputState.compositionPendingChange) {
    Promise.resolve().then(() => view.observer.flush());
  } else {
    setTimeout(() => {
      if (view.inputState.composing < 0 && view.docView.hasComposition)
        view.update([]);
    }, 50);
  }
};
observers.contextmenu = (view) => {
  view.inputState.lastContextMenu = Date.now();
};
handlers.beforeinput = (view, event) => {
  var _a2, _b;
  if (event.inputType == "insertText" || event.inputType == "insertCompositionText") {
    view.inputState.insertingText = event.data;
    view.inputState.insertingTextAt = Date.now();
  }
  if (event.inputType == "insertReplacementText" && view.observer.editContext) {
    let text2 = (_a2 = event.dataTransfer) === null || _a2 === void 0 ? void 0 : _a2.getData("text/plain"), ranges = event.getTargetRanges();
    if (text2 && ranges.length) {
      let r2 = ranges[0];
      let from = view.posAtDOM(r2.startContainer, r2.startOffset), to2 = view.posAtDOM(r2.endContainer, r2.endOffset);
      applyDOMChangeInner(view, { from, to: to2, insert: view.state.toText(text2) }, null);
      return true;
    }
  }
  let pending;
  if (browser$3.chrome && browser$3.android && (pending = PendingKeys.find((key) => key.inputType == event.inputType))) {
    view.observer.delayAndroidKey(pending.key, pending.keyCode);
    if (pending.key == "Backspace" || pending.key == "Delete") {
      let startViewHeight = ((_b = window.visualViewport) === null || _b === void 0 ? void 0 : _b.height) || 0;
      setTimeout(() => {
        var _a3;
        if ((((_a3 = window.visualViewport) === null || _a3 === void 0 ? void 0 : _a3.height) || 0) > startViewHeight + 10 && view.hasFocus) {
          view.contentDOM.blur();
          view.focus();
        }
      }, 100);
    }
  }
  if (browser$3.ios && event.inputType == "deleteContentForward") {
    view.observer.flushSoon();
  }
  if (browser$3.safari && event.inputType == "insertText" && view.inputState.composing >= 0) {
    setTimeout(() => observers.compositionend(view, event), 20);
  }
  return false;
};
const appliedFirefoxHack = /* @__PURE__ */ new Set();
function firefoxCopyCutHack(doc2) {
  if (!appliedFirefoxHack.has(doc2)) {
    appliedFirefoxHack.add(doc2);
    doc2.addEventListener("copy", () => {
    });
    doc2.addEventListener("cut", () => {
    });
  }
}
const wrappingWhiteSpace = ["pre-wrap", "normal", "pre-line", "break-spaces"];
let heightChangeFlag = false;
function clearHeightChangeFlag() {
  heightChangeFlag = false;
}
class HeightOracle {
  constructor(lineWrapping) {
    this.lineWrapping = lineWrapping;
    this.doc = Text$1.empty;
    this.heightSamples = {};
    this.lineHeight = 14;
    this.charWidth = 7;
    this.textHeight = 14;
    this.lineLength = 30;
  }
  heightForGap(from, to2) {
    let lines = this.doc.lineAt(to2).number - this.doc.lineAt(from).number + 1;
    if (this.lineWrapping)
      lines += Math.max(0, Math.ceil((to2 - from - lines * this.lineLength * 0.5) / this.lineLength));
    return this.lineHeight * lines;
  }
  heightForLine(length) {
    if (!this.lineWrapping)
      return this.lineHeight;
    let lines = 1 + Math.max(0, Math.ceil((length - this.lineLength) / Math.max(1, this.lineLength - 5)));
    return lines * this.lineHeight;
  }
  setDoc(doc2) {
    this.doc = doc2;
    return this;
  }
  mustRefreshForWrapping(whiteSpace) {
    return wrappingWhiteSpace.indexOf(whiteSpace) > -1 != this.lineWrapping;
  }
  mustRefreshForHeights(lineHeights) {
    let newHeight = false;
    for (let i2 = 0; i2 < lineHeights.length; i2++) {
      let h2 = lineHeights[i2];
      if (h2 < 0) {
        i2++;
      } else if (!this.heightSamples[Math.floor(h2 * 10)]) {
        newHeight = true;
        this.heightSamples[Math.floor(h2 * 10)] = true;
      }
    }
    return newHeight;
  }
  refresh(whiteSpace, lineHeight, charWidth, textHeight, lineLength, knownHeights) {
    let lineWrapping = wrappingWhiteSpace.indexOf(whiteSpace) > -1;
    let changed = Math.round(lineHeight) != Math.round(this.lineHeight) || this.lineWrapping != lineWrapping;
    this.lineWrapping = lineWrapping;
    this.lineHeight = lineHeight;
    this.charWidth = charWidth;
    this.textHeight = textHeight;
    this.lineLength = lineLength;
    if (changed) {
      this.heightSamples = {};
      for (let i2 = 0; i2 < knownHeights.length; i2++) {
        let h2 = knownHeights[i2];
        if (h2 < 0)
          i2++;
        else
          this.heightSamples[Math.floor(h2 * 10)] = true;
      }
    }
    return changed;
  }
}
class MeasuredHeights {
  constructor(from, heights) {
    this.from = from;
    this.heights = heights;
    this.index = 0;
  }
  get more() {
    return this.index < this.heights.length;
  }
}
class BlockInfo {
  /**
  @internal
  */
  constructor(from, length, top2, height, _content) {
    this.from = from;
    this.length = length;
    this.top = top2;
    this.height = height;
    this._content = _content;
  }
  /**
  The type of element this is. When querying lines, this may be
  an array of all the blocks that make up the line.
  */
  get type() {
    return typeof this._content == "number" ? BlockType.Text : Array.isArray(this._content) ? this._content : this._content.type;
  }
  /**
  The end of the element as a document position.
  */
  get to() {
    return this.from + this.length;
  }
  /**
  The bottom position of the element.
  */
  get bottom() {
    return this.top + this.height;
  }
  /**
  If this is a widget block, this will return the widget
  associated with it.
  */
  get widget() {
    return this._content instanceof PointDecoration ? this._content.widget : null;
  }
  /**
  If this is a textblock, this holds the number of line breaks
  that appear in widgets inside the block.
  */
  get widgetLineBreaks() {
    return typeof this._content == "number" ? this._content : 0;
  }
  /**
  @internal
  */
  join(other) {
    let content2 = (Array.isArray(this._content) ? this._content : [this]).concat(Array.isArray(other._content) ? other._content : [other]);
    return new BlockInfo(this.from, this.length + other.length, this.top, this.height + other.height, content2);
  }
}
var QueryType$1 = /* @__PURE__ */ (function(QueryType2) {
  QueryType2[QueryType2["ByPos"] = 0] = "ByPos";
  QueryType2[QueryType2["ByHeight"] = 1] = "ByHeight";
  QueryType2[QueryType2["ByPosNoHeight"] = 2] = "ByPosNoHeight";
  return QueryType2;
})(QueryType$1 || (QueryType$1 = {}));
const Epsilon = 1e-3;
class HeightMap {
  constructor(length, height, flags = 2) {
    this.length = length;
    this.height = height;
    this.flags = flags;
  }
  get outdated() {
    return (this.flags & 2) > 0;
  }
  set outdated(value) {
    this.flags = (value ? 2 : 0) | this.flags & -3;
  }
  setHeight(height) {
    if (this.height != height) {
      if (Math.abs(this.height - height) > Epsilon)
        heightChangeFlag = true;
      this.height = height;
    }
  }
  // Base case is to replace a leaf node, which simply builds a tree
  // from the new nodes and returns that (HeightMapBranch and
  // HeightMapGap override this to actually use from/to)
  replace(_from, _to, nodes) {
    return HeightMap.of(nodes);
  }
  // Again, these are base cases, and are overridden for branch and gap nodes.
  decomposeLeft(_to, result2) {
    result2.push(this);
  }
  decomposeRight(_from, result2) {
    result2.push(this);
  }
  applyChanges(decorations2, oldDoc, oracle, changes) {
    let me2 = this, doc2 = oracle.doc;
    for (let i2 = changes.length - 1; i2 >= 0; i2--) {
      let { fromA, toA, fromB, toB } = changes[i2];
      let start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle.setDoc(oldDoc), 0, 0);
      let end = start.to >= toA ? start : me2.lineAt(toA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      toB += end.to - toA;
      toA = end.to;
      while (i2 > 0 && start.from <= changes[i2 - 1].toA) {
        fromA = changes[i2 - 1].fromA;
        fromB = changes[i2 - 1].fromB;
        i2--;
        if (fromA < start.from)
          start = me2.lineAt(fromA, QueryType$1.ByPosNoHeight, oracle, 0, 0);
      }
      fromB += start.from - fromA;
      fromA = start.from;
      let nodes = NodeBuilder.build(oracle.setDoc(doc2), decorations2, fromB, toB);
      me2 = replace(me2, me2.replace(fromA, toA, nodes));
    }
    return me2.updateHeight(oracle, 0);
  }
  static empty() {
    return new HeightMapText(0, 0);
  }
  // nodes uses null values to indicate the position of line breaks.
  // There are never line breaks at the start or end of the array, or
  // two line breaks next to each other, and the array isn't allowed
  // to be empty (same restrictions as return value from the builder).
  static of(nodes) {
    if (nodes.length == 1)
      return nodes[0];
    let i2 = 0, j2 = nodes.length, before2 = 0, after2 = 0;
    for (; ; ) {
      if (i2 == j2) {
        if (before2 > after2 * 2) {
          let split = nodes[i2 - 1];
          if (split.break)
            nodes.splice(--i2, 1, split.left, null, split.right);
          else
            nodes.splice(--i2, 1, split.left, split.right);
          j2 += 1 + split.break;
          before2 -= split.size;
        } else if (after2 > before2 * 2) {
          let split = nodes[j2];
          if (split.break)
            nodes.splice(j2, 1, split.left, null, split.right);
          else
            nodes.splice(j2, 1, split.left, split.right);
          j2 += 2 + split.break;
          after2 -= split.size;
        } else {
          break;
        }
      } else if (before2 < after2) {
        let next = nodes[i2++];
        if (next)
          before2 += next.size;
      } else {
        let next = nodes[--j2];
        if (next)
          after2 += next.size;
      }
    }
    let brk = 0;
    if (nodes[i2 - 1] == null) {
      brk = 1;
      i2--;
    } else if (nodes[i2] == null) {
      brk = 1;
      j2++;
    }
    return new HeightMapBranch(HeightMap.of(nodes.slice(0, i2)), brk, HeightMap.of(nodes.slice(j2)));
  }
}
function replace(old, val) {
  if (old == val)
    return old;
  if (old.constructor != val.constructor)
    heightChangeFlag = true;
  return val;
}
HeightMap.prototype.size = 1;
class HeightMapBlock extends HeightMap {
  constructor(length, height, deco) {
    super(length, height);
    this.deco = deco;
  }
  blockAt(_height, _oracle, top2, offset2) {
    return new BlockInfo(offset2, this.length, top2, this.height, this.deco || 0);
  }
  lineAt(_value, _type, oracle, top2, offset2) {
    return this.blockAt(0, oracle, top2, offset2);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    if (from <= offset2 + this.length && to2 >= offset2)
      f2(this.blockAt(0, oracle, top2, offset2));
  }
  updateHeight(oracle, offset2 = 0, _force = false, measured) {
    if (measured && measured.from <= offset2 && measured.more)
      this.setHeight(measured.heights[measured.index++]);
    this.outdated = false;
    return this;
  }
  toString() {
    return `block(${this.length})`;
  }
}
class HeightMapText extends HeightMapBlock {
  constructor(length, height) {
    super(length, height, null);
    this.collapsed = 0;
    this.widgetHeight = 0;
    this.breaks = 0;
  }
  blockAt(_height, _oracle, top2, offset2) {
    return new BlockInfo(offset2, this.length, top2, this.height, this.breaks);
  }
  replace(_from, _to, nodes) {
    let node = nodes[0];
    if (nodes.length == 1 && (node instanceof HeightMapText || node instanceof HeightMapGap && node.flags & 4) && Math.abs(this.length - node.length) < 10) {
      if (node instanceof HeightMapGap)
        node = new HeightMapText(node.length, this.height);
      else
        node.height = this.height;
      if (!this.outdated)
        node.outdated = false;
      return node;
    } else {
      return HeightMap.of(nodes);
    }
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    if (measured && measured.from <= offset2 && measured.more)
      this.setHeight(measured.heights[measured.index++]);
    else if (force || this.outdated)
      this.setHeight(Math.max(this.widgetHeight, oracle.heightForLine(this.length - this.collapsed)) + this.breaks * oracle.lineHeight);
    this.outdated = false;
    return this;
  }
  toString() {
    return `line(${this.length}${this.collapsed ? -this.collapsed : ""}${this.widgetHeight ? ":" + this.widgetHeight : ""})`;
  }
}
class HeightMapGap extends HeightMap {
  constructor(length) {
    super(length, 0);
  }
  heightMetrics(oracle, offset2) {
    let firstLine = oracle.doc.lineAt(offset2).number, lastLine = oracle.doc.lineAt(offset2 + this.length).number;
    let lines = lastLine - firstLine + 1;
    let perLine, perChar = 0;
    if (oracle.lineWrapping) {
      let totalPerLine = Math.min(this.height, oracle.lineHeight * lines);
      perLine = totalPerLine / lines;
      if (this.length > lines + 1)
        perChar = (this.height - totalPerLine) / (this.length - lines - 1);
    } else {
      perLine = this.height / lines;
    }
    return { firstLine, lastLine, perLine, perChar };
  }
  blockAt(height, oracle, top2, offset2) {
    let { firstLine, lastLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    if (oracle.lineWrapping) {
      let guess = offset2 + (height < oracle.lineHeight ? 0 : Math.round(Math.max(0, Math.min(1, (height - top2) / this.height)) * this.length));
      let line2 = oracle.doc.lineAt(guess), lineHeight = perLine + line2.length * perChar;
      let lineTop = Math.max(top2, height - lineHeight / 2);
      return new BlockInfo(line2.from, line2.length, lineTop, lineHeight, 0);
    } else {
      let line2 = Math.max(0, Math.min(lastLine - firstLine, Math.floor((height - top2) / perLine)));
      let { from, length } = oracle.doc.line(firstLine + line2);
      return new BlockInfo(from, length, top2 + perLine * line2, perLine, 0);
    }
  }
  lineAt(value, type, oracle, top2, offset2) {
    if (type == QueryType$1.ByHeight)
      return this.blockAt(value, oracle, top2, offset2);
    if (type == QueryType$1.ByPosNoHeight) {
      let { from, to: to2 } = oracle.doc.lineAt(value);
      return new BlockInfo(from, to2 - from, 0, 0, 0);
    }
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    let line2 = oracle.doc.lineAt(value), lineHeight = perLine + line2.length * perChar;
    let linesAbove = line2.number - firstLine;
    let lineTop = top2 + perLine * linesAbove + perChar * (line2.from - offset2 - linesAbove);
    return new BlockInfo(line2.from, line2.length, Math.max(top2, Math.min(lineTop, top2 + this.height - lineHeight)), lineHeight, 0);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    from = Math.max(from, offset2);
    to2 = Math.min(to2, offset2 + this.length);
    let { firstLine, perLine, perChar } = this.heightMetrics(oracle, offset2);
    for (let pos = from, lineTop = top2; pos <= to2; ) {
      let line2 = oracle.doc.lineAt(pos);
      if (pos == from) {
        let linesAbove = line2.number - firstLine;
        lineTop += perLine * linesAbove + perChar * (from - offset2 - linesAbove);
      }
      let lineHeight = perLine + perChar * line2.length;
      f2(new BlockInfo(line2.from, line2.length, lineTop, lineHeight, 0));
      lineTop += lineHeight;
      pos = line2.to + 1;
    }
  }
  replace(from, to2, nodes) {
    let after2 = this.length - to2;
    if (after2 > 0) {
      let last2 = nodes[nodes.length - 1];
      if (last2 instanceof HeightMapGap)
        nodes[nodes.length - 1] = new HeightMapGap(last2.length + after2);
      else
        nodes.push(null, new HeightMapGap(after2 - 1));
    }
    if (from > 0) {
      let first2 = nodes[0];
      if (first2 instanceof HeightMapGap)
        nodes[0] = new HeightMapGap(from + first2.length);
      else
        nodes.unshift(new HeightMapGap(from - 1), null);
    }
    return HeightMap.of(nodes);
  }
  decomposeLeft(to2, result2) {
    result2.push(new HeightMapGap(to2 - 1), null);
  }
  decomposeRight(from, result2) {
    result2.push(null, new HeightMapGap(this.length - from - 1));
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    let end = offset2 + this.length;
    if (measured && measured.from <= offset2 + this.length && measured.more) {
      let nodes = [], pos = Math.max(offset2, measured.from), singleHeight = -1;
      if (measured.from > offset2)
        nodes.push(new HeightMapGap(measured.from - offset2 - 1).updateHeight(oracle, offset2));
      while (pos <= end && measured.more) {
        let len = oracle.doc.lineAt(pos).length;
        if (nodes.length)
          nodes.push(null);
        let height = measured.heights[measured.index++];
        if (singleHeight == -1)
          singleHeight = height;
        else if (Math.abs(height - singleHeight) >= Epsilon)
          singleHeight = -2;
        let line2 = new HeightMapText(len, height);
        line2.outdated = false;
        nodes.push(line2);
        pos += len + 1;
      }
      if (pos <= end)
        nodes.push(null, new HeightMapGap(end - pos).updateHeight(oracle, pos));
      let result2 = HeightMap.of(nodes);
      if (singleHeight < 0 || Math.abs(result2.height - this.height) >= Epsilon || Math.abs(singleHeight - this.heightMetrics(oracle, offset2).perLine) >= Epsilon)
        heightChangeFlag = true;
      return replace(this, result2);
    } else if (force || this.outdated) {
      this.setHeight(oracle.heightForGap(offset2, offset2 + this.length));
      this.outdated = false;
    }
    return this;
  }
  toString() {
    return `gap(${this.length})`;
  }
}
class HeightMapBranch extends HeightMap {
  constructor(left, brk, right) {
    super(left.length + brk + right.length, left.height + right.height, brk | (left.outdated || right.outdated ? 2 : 0));
    this.left = left;
    this.right = right;
    this.size = left.size + right.size;
  }
  get break() {
    return this.flags & 1;
  }
  blockAt(height, oracle, top2, offset2) {
    let mid = top2 + this.left.height;
    return height < mid ? this.left.blockAt(height, oracle, top2, offset2) : this.right.blockAt(height, oracle, mid, offset2 + this.left.length + this.break);
  }
  lineAt(value, type, oracle, top2, offset2) {
    let rightTop = top2 + this.left.height, rightOffset = offset2 + this.left.length + this.break;
    let left = type == QueryType$1.ByHeight ? value < rightTop : value < rightOffset;
    let base2 = left ? this.left.lineAt(value, type, oracle, top2, offset2) : this.right.lineAt(value, type, oracle, rightTop, rightOffset);
    if (this.break || (left ? base2.to < rightOffset : base2.from > rightOffset))
      return base2;
    let subQuery = type == QueryType$1.ByPosNoHeight ? QueryType$1.ByPosNoHeight : QueryType$1.ByPos;
    if (left)
      return base2.join(this.right.lineAt(rightOffset, subQuery, oracle, rightTop, rightOffset));
    else
      return this.left.lineAt(rightOffset, subQuery, oracle, top2, offset2).join(base2);
  }
  forEachLine(from, to2, oracle, top2, offset2, f2) {
    let rightTop = top2 + this.left.height, rightOffset = offset2 + this.left.length + this.break;
    if (this.break) {
      if (from < rightOffset)
        this.left.forEachLine(from, to2, oracle, top2, offset2, f2);
      if (to2 >= rightOffset)
        this.right.forEachLine(from, to2, oracle, rightTop, rightOffset, f2);
    } else {
      let mid = this.lineAt(rightOffset, QueryType$1.ByPos, oracle, top2, offset2);
      if (from < mid.from)
        this.left.forEachLine(from, mid.from - 1, oracle, top2, offset2, f2);
      if (mid.to >= from && mid.from <= to2)
        f2(mid);
      if (to2 > mid.to)
        this.right.forEachLine(mid.to + 1, to2, oracle, rightTop, rightOffset, f2);
    }
  }
  replace(from, to2, nodes) {
    let rightStart = this.left.length + this.break;
    if (to2 < rightStart)
      return this.balanced(this.left.replace(from, to2, nodes), this.right);
    if (from > this.left.length)
      return this.balanced(this.left, this.right.replace(from - rightStart, to2 - rightStart, nodes));
    let result2 = [];
    if (from > 0)
      this.decomposeLeft(from, result2);
    let left = result2.length;
    for (let node of nodes)
      result2.push(node);
    if (from > 0)
      mergeGaps(result2, left - 1);
    if (to2 < this.length) {
      let right = result2.length;
      this.decomposeRight(to2, result2);
      mergeGaps(result2, right);
    }
    return HeightMap.of(result2);
  }
  decomposeLeft(to2, result2) {
    let left = this.left.length;
    if (to2 <= left)
      return this.left.decomposeLeft(to2, result2);
    result2.push(this.left);
    if (this.break) {
      left++;
      if (to2 >= left)
        result2.push(null);
    }
    if (to2 > left)
      this.right.decomposeLeft(to2 - left, result2);
  }
  decomposeRight(from, result2) {
    let left = this.left.length, right = left + this.break;
    if (from >= right)
      return this.right.decomposeRight(from - right, result2);
    if (from < left)
      this.left.decomposeRight(from, result2);
    if (this.break && from < right)
      result2.push(null);
    result2.push(this.right);
  }
  balanced(left, right) {
    if (left.size > 2 * right.size || right.size > 2 * left.size)
      return HeightMap.of(this.break ? [left, null, right] : [left, right]);
    this.left = replace(this.left, left);
    this.right = replace(this.right, right);
    this.setHeight(left.height + right.height);
    this.outdated = left.outdated || right.outdated;
    this.size = left.size + right.size;
    this.length = left.length + this.break + right.length;
    return this;
  }
  updateHeight(oracle, offset2 = 0, force = false, measured) {
    let { left, right } = this, rightStart = offset2 + left.length + this.break, rebalance = null;
    if (measured && measured.from <= offset2 + left.length && measured.more)
      rebalance = left = left.updateHeight(oracle, offset2, force, measured);
    else
      left.updateHeight(oracle, offset2, force);
    if (measured && measured.from <= rightStart + right.length && measured.more)
      rebalance = right = right.updateHeight(oracle, rightStart, force, measured);
    else
      right.updateHeight(oracle, rightStart, force);
    if (rebalance)
      return this.balanced(left, right);
    this.height = this.left.height + this.right.height;
    this.outdated = false;
    return this;
  }
  toString() {
    return this.left + (this.break ? " " : "-") + this.right;
  }
}
function mergeGaps(nodes, around) {
  let before2, after2;
  if (nodes[around] == null && (before2 = nodes[around - 1]) instanceof HeightMapGap && (after2 = nodes[around + 1]) instanceof HeightMapGap)
    nodes.splice(around - 1, 3, new HeightMapGap(before2.length + 1 + after2.length));
}
const relevantWidgetHeight = 5;
class NodeBuilder {
  constructor(pos, oracle) {
    this.pos = pos;
    this.oracle = oracle;
    this.nodes = [];
    this.lineStart = -1;
    this.lineEnd = -1;
    this.covering = null;
    this.writtenTo = pos;
  }
  get isCovered() {
    return this.covering && this.nodes[this.nodes.length - 1] == this.covering;
  }
  span(_from, to2) {
    if (this.lineStart > -1) {
      let end = Math.min(to2, this.lineEnd), last2 = this.nodes[this.nodes.length - 1];
      if (last2 instanceof HeightMapText)
        last2.length += end - this.pos;
      else if (end > this.pos || !this.isCovered)
        this.nodes.push(new HeightMapText(end - this.pos, -1));
      this.writtenTo = end;
      if (to2 > end) {
        this.nodes.push(null);
        this.writtenTo++;
        this.lineStart = -1;
      }
    }
    this.pos = to2;
  }
  point(from, to2, deco) {
    if (from < to2 || deco.heightRelevant) {
      let height = deco.widget ? deco.widget.estimatedHeight : 0;
      let breaks = deco.widget ? deco.widget.lineBreaks : 0;
      if (height < 0)
        height = this.oracle.lineHeight;
      let len = to2 - from;
      if (deco.block) {
        this.addBlock(new HeightMapBlock(len, height, deco));
      } else if (len || breaks || height >= relevantWidgetHeight) {
        this.addLineDeco(height, breaks, len);
      }
    } else if (to2 > from) {
      this.span(from, to2);
    }
    if (this.lineEnd > -1 && this.lineEnd < this.pos)
      this.lineEnd = this.oracle.doc.lineAt(this.pos).to;
  }
  enterLine() {
    if (this.lineStart > -1)
      return;
    let { from, to: to2 } = this.oracle.doc.lineAt(this.pos);
    this.lineStart = from;
    this.lineEnd = to2;
    if (this.writtenTo < from) {
      if (this.writtenTo < from - 1 || this.nodes[this.nodes.length - 1] == null)
        this.nodes.push(this.blankContent(this.writtenTo, from - 1));
      this.nodes.push(null);
    }
    if (this.pos > from)
      this.nodes.push(new HeightMapText(this.pos - from, -1));
    this.writtenTo = this.pos;
  }
  blankContent(from, to2) {
    let gap = new HeightMapGap(to2 - from);
    if (this.oracle.doc.lineAt(from).to == to2)
      gap.flags |= 4;
    return gap;
  }
  ensureLine() {
    this.enterLine();
    let last2 = this.nodes.length ? this.nodes[this.nodes.length - 1] : null;
    if (last2 instanceof HeightMapText)
      return last2;
    let line2 = new HeightMapText(0, -1);
    this.nodes.push(line2);
    return line2;
  }
  addBlock(block) {
    this.enterLine();
    let deco = block.deco;
    if (deco && deco.startSide > 0 && !this.isCovered)
      this.ensureLine();
    this.nodes.push(block);
    this.writtenTo = this.pos = this.pos + block.length;
    if (deco && deco.endSide > 0)
      this.covering = block;
  }
  addLineDeco(height, breaks, length) {
    let line2 = this.ensureLine();
    line2.length += length;
    line2.collapsed += length;
    line2.widgetHeight = Math.max(line2.widgetHeight, height);
    line2.breaks += breaks;
    this.writtenTo = this.pos = this.pos + length;
  }
  finish(from) {
    let last2 = this.nodes.length == 0 ? null : this.nodes[this.nodes.length - 1];
    if (this.lineStart > -1 && !(last2 instanceof HeightMapText) && !this.isCovered)
      this.nodes.push(new HeightMapText(0, -1));
    else if (this.writtenTo < this.pos || last2 == null)
      this.nodes.push(this.blankContent(this.writtenTo, this.pos));
    let pos = from;
    for (let node of this.nodes) {
      if (node instanceof HeightMapText)
        node.updateHeight(this.oracle, pos);
      pos += node ? node.length : 1;
    }
    return this.nodes;
  }
  // Always called with a region that on both sides either stretches
  // to a line break or the end of the document.
  // The returned array uses null to indicate line breaks, but never
  // starts or ends in a line break, or has multiple line breaks next
  // to each other.
  static build(oracle, decorations2, from, to2) {
    let builder = new NodeBuilder(from, oracle);
    RangeSet.spans(decorations2, from, to2, builder, 0);
    return builder.finish(from);
  }
}
function heightRelevantDecoChanges(a2, b2, diff) {
  let comp = new DecorationComparator();
  RangeSet.compare(a2, b2, diff, comp, 0);
  return comp.changes;
}
class DecorationComparator {
  constructor() {
    this.changes = [];
  }
  compareRange() {
  }
  comparePoint(from, to2, a2, b2) {
    if (from < to2 || a2 && a2.heightRelevant || b2 && b2.heightRelevant)
      addRange(from, to2, this.changes, 5);
  }
}
function visiblePixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  let doc2 = dom.ownerDocument, win = doc2.defaultView || window;
  let left = Math.max(0, rect.left), right = Math.min(win.innerWidth, rect.right);
  let top2 = Math.max(0, rect.top), bottom = Math.min(win.innerHeight, rect.bottom);
  for (let parent = dom.parentNode; parent && parent != doc2.body; ) {
    if (parent.nodeType == 1) {
      let elt = parent;
      let style = window.getComputedStyle(elt);
      if ((elt.scrollHeight > elt.clientHeight || elt.scrollWidth > elt.clientWidth) && style.overflow != "visible") {
        let parentRect = elt.getBoundingClientRect();
        left = Math.max(left, parentRect.left);
        right = Math.min(right, parentRect.right);
        top2 = Math.max(top2, parentRect.top);
        bottom = Math.min(parent == dom.parentNode ? win.innerHeight : bottom, parentRect.bottom);
      }
      parent = style.position == "absolute" || style.position == "fixed" ? elt.offsetParent : elt.parentNode;
    } else if (parent.nodeType == 11) {
      parent = parent.host;
    } else {
      break;
    }
  }
  return {
    left: left - rect.left,
    right: Math.max(left, right) - rect.left,
    top: top2 - (rect.top + paddingTop),
    bottom: Math.max(top2, bottom) - (rect.top + paddingTop)
  };
}
function inWindow(elt) {
  let rect = elt.getBoundingClientRect(), win = elt.ownerDocument.defaultView || window;
  return rect.left < win.innerWidth && rect.right > 0 && rect.top < win.innerHeight && rect.bottom > 0;
}
function fullPixelRange(dom, paddingTop) {
  let rect = dom.getBoundingClientRect();
  return {
    left: 0,
    right: rect.right - rect.left,
    top: paddingTop,
    bottom: rect.bottom - (rect.top + paddingTop)
  };
}
class LineGap {
  constructor(from, to2, size2, displaySize) {
    this.from = from;
    this.to = to2;
    this.size = size2;
    this.displaySize = displaySize;
  }
  static same(a2, b2) {
    if (a2.length != b2.length)
      return false;
    for (let i2 = 0; i2 < a2.length; i2++) {
      let gA = a2[i2], gB = b2[i2];
      if (gA.from != gB.from || gA.to != gB.to || gA.size != gB.size)
        return false;
    }
    return true;
  }
  draw(viewState, wrapping) {
    return Decoration.replace({
      widget: new LineGapWidget(this.displaySize * (wrapping ? viewState.scaleY : viewState.scaleX), wrapping)
    }).range(this.from, this.to);
  }
}
class LineGapWidget extends WidgetType {
  constructor(size2, vertical) {
    super();
    this.size = size2;
    this.vertical = vertical;
  }
  eq(other) {
    return other.size == this.size && other.vertical == this.vertical;
  }
  toDOM() {
    let elt = document.createElement("div");
    if (this.vertical) {
      elt.style.height = this.size + "px";
    } else {
      elt.style.width = this.size + "px";
      elt.style.height = "2px";
      elt.style.display = "inline-block";
    }
    return elt;
  }
  get estimatedHeight() {
    return this.vertical ? this.size : -1;
  }
}
class ViewState {
  constructor(state) {
    this.state = state;
    this.pixelViewport = { left: 0, right: window.innerWidth, top: 0, bottom: 0 };
    this.inView = true;
    this.paddingTop = 0;
    this.paddingBottom = 0;
    this.contentDOMWidth = 0;
    this.contentDOMHeight = 0;
    this.editorHeight = 0;
    this.editorWidth = 0;
    this.scrollTop = 0;
    this.scrolledToBottom = false;
    this.scaleX = 1;
    this.scaleY = 1;
    this.scrollAnchorPos = 0;
    this.scrollAnchorHeight = -1;
    this.scaler = IdScaler;
    this.scrollTarget = null;
    this.printing = false;
    this.mustMeasureContent = true;
    this.defaultTextDirection = Direction.LTR;
    this.visibleRanges = [];
    this.mustEnforceCursorAssoc = false;
    let guessWrapping = state.facet(contentAttributes).some((v2) => typeof v2 != "function" && v2.class == "cm-lineWrapping");
    this.heightOracle = new HeightOracle(guessWrapping);
    this.stateDeco = state.facet(decorations).filter((d2) => typeof d2 != "function");
    this.heightMap = HeightMap.empty().applyChanges(this.stateDeco, Text$1.empty, this.heightOracle.setDoc(state.doc), [new ChangedRange(0, 0, 0, state.doc.length)]);
    for (let i2 = 0; i2 < 2; i2++) {
      this.viewport = this.getViewport(0, null);
      if (!this.updateForViewport())
        break;
    }
    this.updateViewportLines();
    this.lineGaps = this.ensureLineGaps([]);
    this.lineGapDeco = Decoration.set(this.lineGaps.map((gap) => gap.draw(this, false)));
    this.computeVisibleRanges();
  }
  updateForViewport() {
    let viewports = [this.viewport], { main: main2 } = this.state.selection;
    for (let i2 = 0; i2 <= 1; i2++) {
      let pos = i2 ? main2.head : main2.anchor;
      if (!viewports.some(({ from, to: to2 }) => pos >= from && pos <= to2)) {
        let { from, to: to2 } = this.lineBlockAt(pos);
        viewports.push(new Viewport(from, to2));
      }
    }
    this.viewports = viewports.sort((a2, b2) => a2.from - b2.from);
    return this.updateScaler();
  }
  updateScaler() {
    let scaler = this.scaler;
    this.scaler = this.heightMap.height <= 7e6 ? IdScaler : new BigScaler(this.heightOracle, this.heightMap, this.viewports);
    return scaler.eq(this.scaler) ? 0 : 2;
  }
  updateViewportLines() {
    this.viewportLines = [];
    this.heightMap.forEachLine(this.viewport.from, this.viewport.to, this.heightOracle.setDoc(this.state.doc), 0, 0, (block) => {
      this.viewportLines.push(scaleBlock(block, this.scaler));
    });
  }
  update(update, scrollTarget = null) {
    this.state = update.state;
    let prevDeco = this.stateDeco;
    this.stateDeco = this.state.facet(decorations).filter((d2) => typeof d2 != "function");
    let contentChanges = update.changedRanges;
    let heightChanges = ChangedRange.extendWithRanges(contentChanges, heightRelevantDecoChanges(prevDeco, this.stateDeco, update ? update.changes : ChangeSet.empty(this.state.doc.length)));
    let prevHeight = this.heightMap.height;
    let scrollAnchor = this.scrolledToBottom ? null : this.scrollAnchorAt(this.scrollTop);
    clearHeightChangeFlag();
    this.heightMap = this.heightMap.applyChanges(this.stateDeco, update.startState.doc, this.heightOracle.setDoc(this.state.doc), heightChanges);
    if (this.heightMap.height != prevHeight || heightChangeFlag)
      update.flags |= 2;
    if (scrollAnchor) {
      this.scrollAnchorPos = update.changes.mapPos(scrollAnchor.from, -1);
      this.scrollAnchorHeight = scrollAnchor.top;
    } else {
      this.scrollAnchorPos = -1;
      this.scrollAnchorHeight = prevHeight;
    }
    let viewport = heightChanges.length ? this.mapViewport(this.viewport, update.changes) : this.viewport;
    if (scrollTarget && (scrollTarget.range.head < viewport.from || scrollTarget.range.head > viewport.to) || !this.viewportIsAppropriate(viewport))
      viewport = this.getViewport(0, scrollTarget);
    let viewportChange = viewport.from != this.viewport.from || viewport.to != this.viewport.to;
    this.viewport = viewport;
    update.flags |= this.updateForViewport();
    if (viewportChange || !update.changes.empty || update.flags & 2)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(this.mapLineGaps(this.lineGaps, update.changes)));
    update.flags |= this.computeVisibleRanges(update.changes);
    if (scrollTarget)
      this.scrollTarget = scrollTarget;
    if (!this.mustEnforceCursorAssoc && update.selectionSet && update.view.lineWrapping && update.state.selection.main.empty && update.state.selection.main.assoc && !update.state.facet(nativeSelectionHidden))
      this.mustEnforceCursorAssoc = true;
  }
  measure(view) {
    let dom = view.contentDOM, style = window.getComputedStyle(dom);
    let oracle = this.heightOracle;
    let whiteSpace = style.whiteSpace;
    this.defaultTextDirection = style.direction == "rtl" ? Direction.RTL : Direction.LTR;
    let refresh = this.heightOracle.mustRefreshForWrapping(whiteSpace);
    let domRect = dom.getBoundingClientRect();
    let measureContent = refresh || this.mustMeasureContent || this.contentDOMHeight != domRect.height;
    this.contentDOMHeight = domRect.height;
    this.mustMeasureContent = false;
    let result2 = 0, bias = 0;
    if (domRect.width && domRect.height) {
      let { scaleX, scaleY } = getScale$1(dom, domRect);
      if (scaleX > 5e-3 && Math.abs(this.scaleX - scaleX) > 5e-3 || scaleY > 5e-3 && Math.abs(this.scaleY - scaleY) > 5e-3) {
        this.scaleX = scaleX;
        this.scaleY = scaleY;
        result2 |= 16;
        refresh = measureContent = true;
      }
    }
    let paddingTop = (parseInt(style.paddingTop) || 0) * this.scaleY;
    let paddingBottom = (parseInt(style.paddingBottom) || 0) * this.scaleY;
    if (this.paddingTop != paddingTop || this.paddingBottom != paddingBottom) {
      this.paddingTop = paddingTop;
      this.paddingBottom = paddingBottom;
      result2 |= 16 | 2;
    }
    if (this.editorWidth != view.scrollDOM.clientWidth) {
      if (oracle.lineWrapping)
        measureContent = true;
      this.editorWidth = view.scrollDOM.clientWidth;
      result2 |= 16;
    }
    let scrollTop = view.scrollDOM.scrollTop * this.scaleY;
    if (this.scrollTop != scrollTop) {
      this.scrollAnchorHeight = -1;
      this.scrollTop = scrollTop;
    }
    this.scrolledToBottom = isScrolledToBottom(view.scrollDOM);
    let pixelViewport = (this.printing ? fullPixelRange : visiblePixelRange)(dom, this.paddingTop);
    let dTop = pixelViewport.top - this.pixelViewport.top, dBottom = pixelViewport.bottom - this.pixelViewport.bottom;
    this.pixelViewport = pixelViewport;
    let inView = this.pixelViewport.bottom > this.pixelViewport.top && this.pixelViewport.right > this.pixelViewport.left;
    if (inView != this.inView) {
      this.inView = inView;
      if (inView)
        measureContent = true;
    }
    if (!this.inView && !this.scrollTarget && !inWindow(view.dom))
      return 0;
    let contentWidth = domRect.width;
    if (this.contentDOMWidth != contentWidth || this.editorHeight != view.scrollDOM.clientHeight) {
      this.contentDOMWidth = domRect.width;
      this.editorHeight = view.scrollDOM.clientHeight;
      result2 |= 16;
    }
    if (measureContent) {
      let lineHeights = view.docView.measureVisibleLineHeights(this.viewport);
      if (oracle.mustRefreshForHeights(lineHeights))
        refresh = true;
      if (refresh || oracle.lineWrapping && Math.abs(contentWidth - this.contentDOMWidth) > oracle.charWidth) {
        let { lineHeight, charWidth, textHeight } = view.docView.measureTextSize();
        refresh = lineHeight > 0 && oracle.refresh(whiteSpace, lineHeight, charWidth, textHeight, Math.max(5, contentWidth / charWidth), lineHeights);
        if (refresh) {
          view.docView.minWidth = 0;
          result2 |= 16;
        }
      }
      if (dTop > 0 && dBottom > 0)
        bias = Math.max(dTop, dBottom);
      else if (dTop < 0 && dBottom < 0)
        bias = Math.min(dTop, dBottom);
      clearHeightChangeFlag();
      for (let vp of this.viewports) {
        let heights = vp.from == this.viewport.from ? lineHeights : view.docView.measureVisibleLineHeights(vp);
        this.heightMap = (refresh ? HeightMap.empty().applyChanges(this.stateDeco, Text$1.empty, this.heightOracle, [new ChangedRange(0, 0, 0, view.state.doc.length)]) : this.heightMap).updateHeight(oracle, 0, refresh, new MeasuredHeights(vp.from, heights));
      }
      if (heightChangeFlag)
        result2 |= 2;
    }
    let viewportChange = !this.viewportIsAppropriate(this.viewport, bias) || this.scrollTarget && (this.scrollTarget.range.head < this.viewport.from || this.scrollTarget.range.head > this.viewport.to);
    if (viewportChange) {
      if (result2 & 2)
        result2 |= this.updateScaler();
      this.viewport = this.getViewport(bias, this.scrollTarget);
      result2 |= this.updateForViewport();
    }
    if (result2 & 2 || viewportChange)
      this.updateViewportLines();
    if (this.lineGaps.length || this.viewport.to - this.viewport.from > 2e3 << 1)
      this.updateLineGaps(this.ensureLineGaps(refresh ? [] : this.lineGaps, view));
    result2 |= this.computeVisibleRanges();
    if (this.mustEnforceCursorAssoc) {
      this.mustEnforceCursorAssoc = false;
      view.docView.enforceCursorAssoc();
    }
    return result2;
  }
  get visibleTop() {
    return this.scaler.fromDOM(this.pixelViewport.top);
  }
  get visibleBottom() {
    return this.scaler.fromDOM(this.pixelViewport.bottom);
  }
  getViewport(bias, scrollTarget) {
    let marginTop = 0.5 - Math.max(-0.5, Math.min(0.5, bias / 1e3 / 2));
    let map2 = this.heightMap, oracle = this.heightOracle;
    let { visibleTop, visibleBottom } = this;
    let viewport = new Viewport(map2.lineAt(visibleTop - marginTop * 1e3, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(visibleBottom + (1 - marginTop) * 1e3, QueryType$1.ByHeight, oracle, 0, 0).to);
    if (scrollTarget) {
      let { head } = scrollTarget.range;
      if (head < viewport.from || head > viewport.to) {
        let viewHeight = Math.min(this.editorHeight, this.pixelViewport.bottom - this.pixelViewport.top);
        let block = map2.lineAt(head, QueryType$1.ByPos, oracle, 0, 0), topPos;
        if (scrollTarget.y == "center")
          topPos = (block.top + block.bottom) / 2 - viewHeight / 2;
        else if (scrollTarget.y == "start" || scrollTarget.y == "nearest" && head < viewport.from)
          topPos = block.top;
        else
          topPos = block.bottom - viewHeight;
        viewport = new Viewport(map2.lineAt(topPos - 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).from, map2.lineAt(topPos + viewHeight + 1e3 / 2, QueryType$1.ByHeight, oracle, 0, 0).to);
      }
    }
    return viewport;
  }
  mapViewport(viewport, changes) {
    let from = changes.mapPos(viewport.from, -1), to2 = changes.mapPos(viewport.to, 1);
    return new Viewport(this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0).from, this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0).to);
  }
  // Checks if a given viewport covers the visible part of the
  // document and not too much beyond that.
  viewportIsAppropriate({ from, to: to2 }, bias = 0) {
    if (!this.inView)
      return true;
    let { top: top2 } = this.heightMap.lineAt(from, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { bottom } = this.heightMap.lineAt(to2, QueryType$1.ByPos, this.heightOracle, 0, 0);
    let { visibleTop, visibleBottom } = this;
    return (from == 0 || top2 <= visibleTop - Math.max(10, Math.min(
      -bias,
      250
      /* VP.MaxCoverMargin */
    ))) && (to2 == this.state.doc.length || bottom >= visibleBottom + Math.max(10, Math.min(
      bias,
      250
      /* VP.MaxCoverMargin */
    ))) && (top2 > visibleTop - 2 * 1e3 && bottom < visibleBottom + 2 * 1e3);
  }
  mapLineGaps(gaps, changes) {
    if (!gaps.length || changes.empty)
      return gaps;
    let mapped = [];
    for (let gap of gaps)
      if (!changes.touchesRange(gap.from, gap.to))
        mapped.push(new LineGap(changes.mapPos(gap.from), changes.mapPos(gap.to), gap.size, gap.displaySize));
    return mapped;
  }
  // Computes positions in the viewport where the start or end of a
  // line should be hidden, trying to reuse existing line gaps when
  // appropriate to avoid unneccesary redraws.
  // Uses crude character-counting for the positioning and sizing,
  // since actual DOM coordinates aren't always available and
  // predictable. Relies on generous margins (see LG.Margin) to hide
  // the artifacts this might produce from the user.
  ensureLineGaps(current2, mayMeasure) {
    let wrapping = this.heightOracle.lineWrapping;
    let margin = wrapping ? 1e4 : 2e3, halfMargin = margin >> 1, doubleMargin = margin << 1;
    if (this.defaultTextDirection != Direction.LTR && !wrapping)
      return [];
    let gaps = [];
    let addGap = (from, to2, line2, structure) => {
      if (to2 - from < halfMargin)
        return;
      let sel = this.state.selection.main, avoid = [sel.from];
      if (!sel.empty)
        avoid.push(sel.to);
      for (let pos of avoid) {
        if (pos > from && pos < to2) {
          addGap(from, pos - 10, line2, structure);
          addGap(pos + 10, to2, line2, structure);
          return;
        }
      }
      let gap = find$1(current2, (gap2) => gap2.from >= line2.from && gap2.to <= line2.to && Math.abs(gap2.from - from) < halfMargin && Math.abs(gap2.to - to2) < halfMargin && !avoid.some((pos) => gap2.from < pos && gap2.to > pos));
      if (!gap) {
        if (to2 < line2.to && mayMeasure && wrapping && mayMeasure.visibleRanges.some((r2) => r2.from <= to2 && r2.to >= to2)) {
          let lineStart = mayMeasure.moveToLineBoundary(EditorSelection.cursor(to2), false, true).head;
          if (lineStart > from)
            to2 = lineStart;
        }
        let size2 = this.gapSize(line2, from, to2, structure);
        let displaySize = wrapping || size2 < 2e6 ? size2 : 2e6;
        gap = new LineGap(from, to2, size2, displaySize);
      }
      gaps.push(gap);
    };
    let checkLine = (line2) => {
      if (line2.length < doubleMargin || line2.type != BlockType.Text)
        return;
      let structure = lineStructure(line2.from, line2.to, this.stateDeco);
      if (structure.total < doubleMargin)
        return;
      let target = this.scrollTarget ? this.scrollTarget.range.head : null;
      let viewFrom, viewTo;
      if (wrapping) {
        let marginHeight = margin / this.heightOracle.lineLength * this.heightOracle.lineHeight;
        let top2, bot;
        if (target != null) {
          let targetFrac = findFraction(structure, target);
          let spaceFrac = ((this.visibleBottom - this.visibleTop) / 2 + marginHeight) / line2.height;
          top2 = targetFrac - spaceFrac;
          bot = targetFrac + spaceFrac;
        } else {
          top2 = (this.visibleTop - line2.top - marginHeight) / line2.height;
          bot = (this.visibleBottom - line2.top + marginHeight) / line2.height;
        }
        viewFrom = findPosition(structure, top2);
        viewTo = findPosition(structure, bot);
      } else {
        let totalWidth = structure.total * this.heightOracle.charWidth;
        let marginWidth = margin * this.heightOracle.charWidth;
        let horizOffset = 0;
        if (totalWidth > 2e6)
          for (let old of current2) {
            if (old.from >= line2.from && old.from < line2.to && old.size != old.displaySize && old.from * this.heightOracle.charWidth + horizOffset < this.pixelViewport.left)
              horizOffset = old.size - old.displaySize;
          }
        let pxLeft = this.pixelViewport.left + horizOffset, pxRight = this.pixelViewport.right + horizOffset;
        let left, right;
        if (target != null) {
          let targetFrac = findFraction(structure, target);
          let spaceFrac = ((pxRight - pxLeft) / 2 + marginWidth) / totalWidth;
          left = targetFrac - spaceFrac;
          right = targetFrac + spaceFrac;
        } else {
          left = (pxLeft - marginWidth) / totalWidth;
          right = (pxRight + marginWidth) / totalWidth;
        }
        viewFrom = findPosition(structure, left);
        viewTo = findPosition(structure, right);
      }
      if (viewFrom > line2.from)
        addGap(line2.from, viewFrom, line2, structure);
      if (viewTo < line2.to)
        addGap(viewTo, line2.to, line2, structure);
    };
    for (let line2 of this.viewportLines) {
      if (Array.isArray(line2.type))
        line2.type.forEach(checkLine);
      else
        checkLine(line2);
    }
    return gaps;
  }
  gapSize(line2, from, to2, structure) {
    let fraction = findFraction(structure, to2) - findFraction(structure, from);
    if (this.heightOracle.lineWrapping) {
      return line2.height * fraction;
    } else {
      return structure.total * this.heightOracle.charWidth * fraction;
    }
  }
  updateLineGaps(gaps) {
    if (!LineGap.same(gaps, this.lineGaps)) {
      this.lineGaps = gaps;
      this.lineGapDeco = Decoration.set(gaps.map((gap) => gap.draw(this, this.heightOracle.lineWrapping)));
    }
  }
  computeVisibleRanges(changes) {
    let deco = this.stateDeco;
    if (this.lineGaps.length)
      deco = deco.concat(this.lineGapDeco);
    let ranges = [];
    RangeSet.spans(deco, this.viewport.from, this.viewport.to, {
      span(from, to2) {
        ranges.push({ from, to: to2 });
      },
      point() {
      }
    }, 20);
    let changed = 0;
    if (ranges.length != this.visibleRanges.length) {
      changed = 8 | 4;
    } else {
      for (let i2 = 0; i2 < ranges.length && !(changed & 8); i2++) {
        let old = this.visibleRanges[i2], nw = ranges[i2];
        if (old.from != nw.from || old.to != nw.to) {
          changed |= 4;
          if (!(changes && changes.mapPos(old.from, -1) == nw.from && changes.mapPos(old.to, 1) == nw.to))
            changed |= 8;
        }
      }
    }
    this.visibleRanges = ranges;
    return changed;
  }
  lineBlockAt(pos) {
    return pos >= this.viewport.from && pos <= this.viewport.to && this.viewportLines.find((b2) => b2.from <= pos && b2.to >= pos) || scaleBlock(this.heightMap.lineAt(pos, QueryType$1.ByPos, this.heightOracle, 0, 0), this.scaler);
  }
  lineBlockAtHeight(height) {
    return height >= this.viewportLines[0].top && height <= this.viewportLines[this.viewportLines.length - 1].bottom && this.viewportLines.find((l2) => l2.top <= height && l2.bottom >= height) || scaleBlock(this.heightMap.lineAt(this.scaler.fromDOM(height), QueryType$1.ByHeight, this.heightOracle, 0, 0), this.scaler);
  }
  scrollAnchorAt(scrollTop) {
    let block = this.lineBlockAtHeight(scrollTop + 8);
    return block.from >= this.viewport.from || this.viewportLines[0].top - scrollTop > 200 ? block : this.viewportLines[0];
  }
  elementAtHeight(height) {
    return scaleBlock(this.heightMap.blockAt(this.scaler.fromDOM(height), this.heightOracle, 0, 0), this.scaler);
  }
  get docHeight() {
    return this.scaler.toDOM(this.heightMap.height);
  }
  get contentHeight() {
    return this.docHeight + this.paddingTop + this.paddingBottom;
  }
}
class Viewport {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
}
function lineStructure(from, to2, stateDeco) {
  let ranges = [], pos = from, total = 0;
  RangeSet.spans(stateDeco, from, to2, {
    span() {
    },
    point(from2, to22) {
      if (from2 > pos) {
        ranges.push({ from: pos, to: from2 });
        total += from2 - pos;
      }
      pos = to22;
    }
  }, 20);
  if (pos < to2) {
    ranges.push({ from: pos, to: to2 });
    total += to2 - pos;
  }
  return { total, ranges };
}
function findPosition({ total, ranges }, ratio) {
  if (ratio <= 0)
    return ranges[0].from;
  if (ratio >= 1)
    return ranges[ranges.length - 1].to;
  let dist2 = Math.floor(total * ratio);
  for (let i2 = 0; ; i2++) {
    let { from, to: to2 } = ranges[i2], size2 = to2 - from;
    if (dist2 <= size2)
      return from + dist2;
    dist2 -= size2;
  }
}
function findFraction(structure, pos) {
  let counted = 0;
  for (let { from, to: to2 } of structure.ranges) {
    if (pos <= to2) {
      counted += pos - from;
      break;
    }
    counted += to2 - from;
  }
  return counted / structure.total;
}
function find$1(array, f2) {
  for (let val of array)
    if (f2(val))
      return val;
  return void 0;
}
const IdScaler = {
  toDOM(n2) {
    return n2;
  },
  fromDOM(n2) {
    return n2;
  },
  scale: 1,
  eq(other) {
    return other == this;
  }
};
class BigScaler {
  constructor(oracle, heightMap, viewports) {
    let vpHeight = 0, base2 = 0, domBase = 0;
    this.viewports = viewports.map(({ from, to: to2 }) => {
      let top2 = heightMap.lineAt(from, QueryType$1.ByPos, oracle, 0, 0).top;
      let bottom = heightMap.lineAt(to2, QueryType$1.ByPos, oracle, 0, 0).bottom;
      vpHeight += bottom - top2;
      return { from, to: to2, top: top2, bottom, domTop: 0, domBottom: 0 };
    });
    this.scale = (7e6 - vpHeight) / (heightMap.height - vpHeight);
    for (let obj of this.viewports) {
      obj.domTop = domBase + (obj.top - base2) * this.scale;
      domBase = obj.domBottom = obj.domTop + (obj.bottom - obj.top);
      base2 = obj.bottom;
    }
  }
  toDOM(n2) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp || n2 < vp.top)
        return domBase + (n2 - base2) * this.scale;
      if (n2 <= vp.bottom)
        return vp.domTop + (n2 - vp.top);
      base2 = vp.bottom;
      domBase = vp.domBottom;
    }
  }
  fromDOM(n2) {
    for (let i2 = 0, base2 = 0, domBase = 0; ; i2++) {
      let vp = i2 < this.viewports.length ? this.viewports[i2] : null;
      if (!vp || n2 < vp.domTop)
        return base2 + (n2 - domBase) / this.scale;
      if (n2 <= vp.domBottom)
        return vp.top + (n2 - vp.domTop);
      base2 = vp.bottom;
      domBase = vp.domBottom;
    }
  }
  eq(other) {
    if (!(other instanceof BigScaler))
      return false;
    return this.scale == other.scale && this.viewports.length == other.viewports.length && this.viewports.every((vp, i2) => vp.from == other.viewports[i2].from && vp.to == other.viewports[i2].to);
  }
}
function scaleBlock(block, scaler) {
  if (scaler.scale == 1)
    return block;
  let bTop = scaler.toDOM(block.top), bBottom = scaler.toDOM(block.bottom);
  return new BlockInfo(block.from, block.length, bTop, bBottom - bTop, Array.isArray(block._content) ? block._content.map((b2) => scaleBlock(b2, scaler)) : block._content);
}
const theme = /* @__PURE__ */ Facet.define({ combine: (strs) => strs.join(" ") });
const darkTheme = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.indexOf(true) > -1 });
const baseThemeID = /* @__PURE__ */ StyleModule.newName(), baseLightID = /* @__PURE__ */ StyleModule.newName(), baseDarkID = /* @__PURE__ */ StyleModule.newName();
const lightDarkIDs = { "&light": "." + baseLightID, "&dark": "." + baseDarkID };
function buildTheme(main2, spec, scopes) {
  return new StyleModule(spec, {
    finish(sel) {
      return /&/.test(sel) ? sel.replace(/&\w*/, (m2) => {
        if (m2 == "&")
          return main2;
        if (!scopes || !scopes[m2])
          throw new RangeError(`Unsupported selector: ${m2}`);
        return scopes[m2];
      }) : main2 + " " + sel;
    }
  });
}
const baseTheme$1$2 = /* @__PURE__ */ buildTheme("." + baseThemeID, {
  "&": {
    position: "relative !important",
    boxSizing: "border-box",
    "&.cm-focused": {
      // Provide a simple default outline to make sure a focused
      // editor is visually distinct. Can't leave the default behavior
      // because that will apply to the content element, which is
      // inside the scrollable container and doesn't include the
      // gutters. We also can't use an 'auto' outline, since those
      // are, for some reason, drawn behind the element content, which
      // will cause things like the active line background to cover
      // the outline (#297).
      outline: "1px dotted #212121"
    },
    display: "flex !important",
    flexDirection: "column"
  },
  ".cm-scroller": {
    display: "flex !important",
    alignItems: "flex-start !important",
    fontFamily: "monospace",
    lineHeight: 1.4,
    height: "100%",
    overflowX: "auto",
    position: "relative",
    zIndex: 0,
    overflowAnchor: "none"
  },
  ".cm-content": {
    margin: 0,
    flexGrow: 2,
    flexShrink: 0,
    display: "block",
    whiteSpace: "pre",
    wordWrap: "normal",
    // https://github.com/codemirror/dev/issues/456
    boxSizing: "border-box",
    minHeight: "100%",
    padding: "4px 0",
    outline: "none",
    "&[contenteditable=true]": {
      WebkitUserModify: "read-write-plaintext-only"
    }
  },
  ".cm-lineWrapping": {
    whiteSpace_fallback: "pre-wrap",
    // For IE
    whiteSpace: "break-spaces",
    wordBreak: "break-word",
    // For Safari, which doesn't support overflow-wrap: anywhere
    overflowWrap: "anywhere",
    flexShrink: 1
  },
  "&light .cm-content": { caretColor: "black" },
  "&dark .cm-content": { caretColor: "white" },
  ".cm-line": {
    display: "block",
    padding: "0 2px 0 6px"
  },
  ".cm-layer": {
    position: "absolute",
    left: 0,
    top: 0,
    contain: "size style",
    "& > *": {
      position: "absolute"
    }
  },
  "&light .cm-selectionBackground": {
    background: "#d9d9d9"
  },
  "&dark .cm-selectionBackground": {
    background: "#222"
  },
  "&light.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#d7d4f0"
  },
  "&dark.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground": {
    background: "#233"
  },
  ".cm-cursorLayer": {
    pointerEvents: "none"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer": {
    animation: "steps(1) cm-blink 1.2s infinite"
  },
  // Two animations defined so that we can switch between them to
  // restart the animation without forcing another style
  // recomputation.
  "@keyframes cm-blink": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  "@keyframes cm-blink2": { "0%": {}, "50%": { opacity: 0 }, "100%": {} },
  ".cm-cursor, .cm-dropCursor": {
    borderLeft: "1.2px solid black",
    marginLeft: "-0.6px",
    pointerEvents: "none"
  },
  ".cm-cursor": {
    display: "none"
  },
  "&dark .cm-cursor": {
    borderLeftColor: "#ddd"
  },
  ".cm-dropCursor": {
    position: "absolute"
  },
  "&.cm-focused > .cm-scroller > .cm-cursorLayer .cm-cursor": {
    display: "block"
  },
  ".cm-iso": {
    unicodeBidi: "isolate"
  },
  ".cm-announced": {
    position: "fixed",
    top: "-10000px"
  },
  "@media print": {
    ".cm-announced": { display: "none" }
  },
  "&light .cm-activeLine": { backgroundColor: "#cceeff44" },
  "&dark .cm-activeLine": { backgroundColor: "#99eeff33" },
  "&light .cm-specialChar": { color: "red" },
  "&dark .cm-specialChar": { color: "#f78" },
  ".cm-gutters": {
    flexShrink: 0,
    display: "flex",
    height: "100%",
    boxSizing: "border-box",
    zIndex: 200
  },
  ".cm-gutters-before": { insetInlineStart: 0 },
  ".cm-gutters-after": { insetInlineEnd: 0 },
  "&light .cm-gutters": {
    backgroundColor: "#f5f5f5",
    color: "#6c6c6c",
    border: "0px solid #ddd",
    "&.cm-gutters-before": { borderRightWidth: "1px" },
    "&.cm-gutters-after": { borderLeftWidth: "1px" }
  },
  "&dark .cm-gutters": {
    backgroundColor: "#333338",
    color: "#ccc"
  },
  ".cm-gutter": {
    display: "flex !important",
    // Necessary -- prevents margin collapsing
    flexDirection: "column",
    flexShrink: 0,
    boxSizing: "border-box",
    minHeight: "100%",
    overflow: "hidden"
  },
  ".cm-gutterElement": {
    boxSizing: "border-box"
  },
  ".cm-lineNumbers .cm-gutterElement": {
    padding: "0 3px 0 5px",
    minWidth: "20px",
    textAlign: "right",
    whiteSpace: "nowrap"
  },
  "&light .cm-activeLineGutter": {
    backgroundColor: "#e2f2ff"
  },
  "&dark .cm-activeLineGutter": {
    backgroundColor: "#222227"
  },
  ".cm-panels": {
    boxSizing: "border-box",
    position: "sticky",
    left: 0,
    right: 0,
    zIndex: 300
  },
  "&light .cm-panels": {
    backgroundColor: "#f5f5f5",
    color: "black"
  },
  "&light .cm-panels-top": {
    borderBottom: "1px solid #ddd"
  },
  "&light .cm-panels-bottom": {
    borderTop: "1px solid #ddd"
  },
  "&dark .cm-panels": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-dialog": {
    padding: "2px 19px 4px 6px",
    position: "relative",
    "& label": { fontSize: "80%" }
  },
  ".cm-dialog-close": {
    position: "absolute",
    top: "3px",
    right: "4px",
    backgroundColor: "inherit",
    border: "none",
    font: "inherit",
    fontSize: "14px",
    padding: "0"
  },
  ".cm-tab": {
    display: "inline-block",
    overflow: "hidden",
    verticalAlign: "bottom"
  },
  ".cm-widgetBuffer": {
    verticalAlign: "text-top",
    height: "1em",
    width: 0,
    display: "inline"
  },
  ".cm-placeholder": {
    color: "#888",
    display: "inline-block",
    verticalAlign: "top",
    userSelect: "none"
  },
  ".cm-highlightSpace": {
    backgroundImage: "radial-gradient(circle at 50% 55%, #aaa 20%, transparent 5%)",
    backgroundPosition: "center"
  },
  ".cm-highlightTab": {
    backgroundImage: `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" width="200" height="20"><path stroke="%23888" stroke-width="1" fill="none" d="M1 10H196L190 5M190 15L196 10M197 4L197 16"/></svg>')`,
    backgroundSize: "auto 100%",
    backgroundPosition: "right 90%",
    backgroundRepeat: "no-repeat"
  },
  ".cm-trailingSpace": {
    backgroundColor: "#ff332255"
  },
  ".cm-button": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    padding: ".2em 1em",
    borderRadius: "1px"
  },
  "&light .cm-button": {
    backgroundImage: "linear-gradient(#eff1f5, #d9d9df)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#b4b4b4, #d0d3d6)"
    }
  },
  "&dark .cm-button": {
    backgroundImage: "linear-gradient(#393939, #111)",
    border: "1px solid #888",
    "&:active": {
      backgroundImage: "linear-gradient(#111, #333)"
    }
  },
  ".cm-textfield": {
    verticalAlign: "middle",
    color: "inherit",
    fontSize: "70%",
    border: "1px solid silver",
    padding: ".2em .5em"
  },
  "&light .cm-textfield": {
    backgroundColor: "white"
  },
  "&dark .cm-textfield": {
    border: "1px solid #555",
    backgroundColor: "inherit"
  }
}, lightDarkIDs);
const observeOptions = {
  childList: true,
  characterData: true,
  subtree: true,
  attributes: true,
  characterDataOldValue: true
};
const useCharData = browser$3.ie && browser$3.ie_version <= 11;
class DOMObserver {
  constructor(view) {
    this.view = view;
    this.active = false;
    this.editContext = null;
    this.selectionRange = new DOMSelectionState();
    this.selectionChanged = false;
    this.delayedFlush = -1;
    this.resizeTimeout = -1;
    this.queue = [];
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
    this.lastChange = 0;
    this.scrollTargets = [];
    this.intersection = null;
    this.resizeScroll = null;
    this.intersecting = false;
    this.gapIntersection = null;
    this.gaps = [];
    this.printQuery = null;
    this.parentCheck = -1;
    this.dom = view.contentDOM;
    this.observer = new MutationObserver((mutations) => {
      for (let mut of mutations)
        this.queue.push(mut);
      if ((browser$3.ie && browser$3.ie_version <= 11 || browser$3.ios && view.composing) && mutations.some((m2) => m2.type == "childList" && m2.removedNodes.length || m2.type == "characterData" && m2.oldValue.length > m2.target.nodeValue.length))
        this.flushSoon();
      else
        this.flush();
    });
    if (window.EditContext && browser$3.android && view.constructor.EDIT_CONTEXT !== false && // Chrome <126 doesn't support inverted selections in edit context (#1392)
    !(browser$3.chrome && browser$3.chrome_version < 126)) {
      this.editContext = new EditContextManager(view);
      if (view.state.facet(editable))
        view.contentDOM.editContext = this.editContext.editContext;
    }
    if (useCharData)
      this.onCharData = (event) => {
        this.queue.push({
          target: event.target,
          type: "characterData",
          oldValue: event.prevValue
        });
        this.flushSoon();
      };
    this.onSelectionChange = this.onSelectionChange.bind(this);
    this.onResize = this.onResize.bind(this);
    this.onPrint = this.onPrint.bind(this);
    this.onScroll = this.onScroll.bind(this);
    if (window.matchMedia)
      this.printQuery = window.matchMedia("print");
    if (typeof ResizeObserver == "function") {
      this.resizeScroll = new ResizeObserver(() => {
        var _a2;
        if (((_a2 = this.view.docView) === null || _a2 === void 0 ? void 0 : _a2.lastUpdate) < Date.now() - 75)
          this.onResize();
      });
      this.resizeScroll.observe(view.scrollDOM);
    }
    this.addWindowListeners(this.win = view.win);
    this.start();
    if (typeof IntersectionObserver == "function") {
      this.intersection = new IntersectionObserver((entries) => {
        if (this.parentCheck < 0)
          this.parentCheck = setTimeout(this.listenForScroll.bind(this), 1e3);
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0 != this.intersecting) {
          this.intersecting = !this.intersecting;
          if (this.intersecting != this.view.inView)
            this.onScrollChanged(document.createEvent("Event"));
        }
      }, { threshold: [0, 1e-3] });
      this.intersection.observe(this.dom);
      this.gapIntersection = new IntersectionObserver((entries) => {
        if (entries.length > 0 && entries[entries.length - 1].intersectionRatio > 0)
          this.onScrollChanged(document.createEvent("Event"));
      }, {});
    }
    this.listenForScroll();
    this.readSelectionRange();
  }
  onScrollChanged(e2) {
    this.view.inputState.runHandlers("scroll", e2);
    if (this.intersecting)
      this.view.measure();
  }
  onScroll(e2) {
    if (this.intersecting)
      this.flush(false);
    if (this.editContext)
      this.view.requestMeasure(this.editContext.measureReq);
    this.onScrollChanged(e2);
  }
  onResize() {
    if (this.resizeTimeout < 0)
      this.resizeTimeout = setTimeout(() => {
        this.resizeTimeout = -1;
        this.view.requestMeasure();
      }, 50);
  }
  onPrint(event) {
    if ((event.type == "change" || !event.type) && !event.matches)
      return;
    this.view.viewState.printing = true;
    this.view.measure();
    setTimeout(() => {
      this.view.viewState.printing = false;
      this.view.requestMeasure();
    }, 500);
  }
  updateGaps(gaps) {
    if (this.gapIntersection && (gaps.length != this.gaps.length || this.gaps.some((g2, i2) => g2 != gaps[i2]))) {
      this.gapIntersection.disconnect();
      for (let gap of gaps)
        this.gapIntersection.observe(gap);
      this.gaps = gaps;
    }
  }
  onSelectionChange(event) {
    let wasChanged = this.selectionChanged;
    if (!this.readSelectionRange() || this.delayedAndroidKey)
      return;
    let { view } = this, sel = this.selectionRange;
    if (view.state.facet(editable) ? view.root.activeElement != this.dom : !hasSelection(this.dom, sel))
      return;
    let context = sel.anchorNode && view.docView.nearest(sel.anchorNode);
    if (context && context.ignoreEvent(event)) {
      if (!wasChanged)
        this.selectionChanged = false;
      return;
    }
    if ((browser$3.ie && browser$3.ie_version <= 11 || browser$3.android && browser$3.chrome) && !view.state.selection.main.empty && // (Selection.isCollapsed isn't reliable on IE)
    sel.focusNode && isEquivalentPosition(sel.focusNode, sel.focusOffset, sel.anchorNode, sel.anchorOffset))
      this.flushSoon();
    else
      this.flush(false);
  }
  readSelectionRange() {
    let { view } = this;
    let selection2 = getSelection(view.root);
    if (!selection2)
      return false;
    let range2 = browser$3.safari && view.root.nodeType == 11 && view.root.activeElement == this.dom && safariSelectionRangeHack(this.view, selection2) || selection2;
    if (!range2 || this.selectionRange.eq(range2))
      return false;
    let local = hasSelection(this.dom, range2);
    if (local && !this.selectionChanged && view.inputState.lastFocusTime > Date.now() - 200 && view.inputState.lastTouchTime < Date.now() - 300 && atElementStart(this.dom, range2)) {
      this.view.inputState.lastFocusTime = 0;
      view.docView.updateSelection();
      return false;
    }
    this.selectionRange.setRange(range2);
    if (local)
      this.selectionChanged = true;
    return true;
  }
  setSelectionRange(anchor, head) {
    this.selectionRange.set(anchor.node, anchor.offset, head.node, head.offset);
    this.selectionChanged = false;
  }
  clearSelectionRange() {
    this.selectionRange.set(null, 0, null, 0);
  }
  listenForScroll() {
    this.parentCheck = -1;
    let i2 = 0, changed = null;
    for (let dom = this.dom; dom; ) {
      if (dom.nodeType == 1) {
        if (!changed && i2 < this.scrollTargets.length && this.scrollTargets[i2] == dom)
          i2++;
        else if (!changed)
          changed = this.scrollTargets.slice(0, i2);
        if (changed)
          changed.push(dom);
        dom = dom.assignedSlot || dom.parentNode;
      } else if (dom.nodeType == 11) {
        dom = dom.host;
      } else {
        break;
      }
    }
    if (i2 < this.scrollTargets.length && !changed)
      changed = this.scrollTargets.slice(0, i2);
    if (changed) {
      for (let dom of this.scrollTargets)
        dom.removeEventListener("scroll", this.onScroll);
      for (let dom of this.scrollTargets = changed)
        dom.addEventListener("scroll", this.onScroll);
    }
  }
  ignore(f2) {
    if (!this.active)
      return f2();
    try {
      this.stop();
      return f2();
    } finally {
      this.start();
      this.clear();
    }
  }
  start() {
    if (this.active)
      return;
    this.observer.observe(this.dom, observeOptions);
    if (useCharData)
      this.dom.addEventListener("DOMCharacterDataModified", this.onCharData);
    this.active = true;
  }
  stop() {
    if (!this.active)
      return;
    this.active = false;
    this.observer.disconnect();
    if (useCharData)
      this.dom.removeEventListener("DOMCharacterDataModified", this.onCharData);
  }
  // Throw away any pending changes
  clear() {
    this.processRecords();
    this.queue.length = 0;
    this.selectionChanged = false;
  }
  // Chrome Android, especially in combination with GBoard, not only
  // doesn't reliably fire regular key events, but also often
  // surrounds the effect of enter or backspace with a bunch of
  // composition events that, when interrupted, cause text duplication
  // or other kinds of corruption. This hack makes the editor back off
  // from handling DOM changes for a moment when such a key is
  // detected (via beforeinput or keydown), and then tries to flush
  // them or, if that has no effect, dispatches the given key.
  delayAndroidKey(key, keyCode) {
    var _a2;
    if (!this.delayedAndroidKey) {
      let flush = () => {
        let key2 = this.delayedAndroidKey;
        if (key2) {
          this.clearDelayedAndroidKey();
          this.view.inputState.lastKeyCode = key2.keyCode;
          this.view.inputState.lastKeyTime = Date.now();
          let flushed = this.flush();
          if (!flushed && key2.force)
            dispatchKey(this.dom, key2.key, key2.keyCode);
        }
      };
      this.flushingAndroidKey = this.view.win.requestAnimationFrame(flush);
    }
    if (!this.delayedAndroidKey || key == "Enter")
      this.delayedAndroidKey = {
        key,
        keyCode,
        // Only run the key handler when no changes are detected if
        // this isn't coming right after another change, in which case
        // it is probably part of a weird chain of updates, and should
        // be ignored if it returns the DOM to its previous state.
        force: this.lastChange < Date.now() - 50 || !!((_a2 = this.delayedAndroidKey) === null || _a2 === void 0 ? void 0 : _a2.force)
      };
  }
  clearDelayedAndroidKey() {
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
    this.delayedAndroidKey = null;
    this.flushingAndroidKey = -1;
  }
  flushSoon() {
    if (this.delayedFlush < 0)
      this.delayedFlush = this.view.win.requestAnimationFrame(() => {
        this.delayedFlush = -1;
        this.flush();
      });
  }
  forceFlush() {
    if (this.delayedFlush >= 0) {
      this.view.win.cancelAnimationFrame(this.delayedFlush);
      this.delayedFlush = -1;
    }
    this.flush();
  }
  pendingRecords() {
    for (let mut of this.observer.takeRecords())
      this.queue.push(mut);
    return this.queue;
  }
  processRecords() {
    let records = this.pendingRecords();
    if (records.length)
      this.queue = [];
    let from = -1, to2 = -1, typeOver = false;
    for (let record of records) {
      let range2 = this.readMutation(record);
      if (!range2)
        continue;
      if (range2.typeOver)
        typeOver = true;
      if (from == -1) {
        ({ from, to: to2 } = range2);
      } else {
        from = Math.min(range2.from, from);
        to2 = Math.max(range2.to, to2);
      }
    }
    return { from, to: to2, typeOver };
  }
  readChange() {
    let { from, to: to2, typeOver } = this.processRecords();
    let newSel = this.selectionChanged && hasSelection(this.dom, this.selectionRange);
    if (from < 0 && !newSel)
      return null;
    if (from > -1)
      this.lastChange = Date.now();
    this.view.inputState.lastFocusTime = 0;
    this.selectionChanged = false;
    let change = new DOMChange(this.view, from, to2, typeOver);
    this.view.docView.domChanged = { newSel: change.newSel ? change.newSel.main : null };
    return change;
  }
  // Apply pending changes, if any
  flush(readSelection = true) {
    if (this.delayedFlush >= 0 || this.delayedAndroidKey)
      return false;
    if (readSelection)
      this.readSelectionRange();
    let domChange = this.readChange();
    if (!domChange) {
      this.view.requestMeasure();
      return false;
    }
    let startState = this.view.state;
    let handled = applyDOMChange(this.view, domChange);
    if (this.view.state == startState && (domChange.domChanged || domChange.newSel && !domChange.newSel.main.eq(this.view.state.selection.main)))
      this.view.update([]);
    return handled;
  }
  readMutation(rec) {
    let cView = this.view.docView.nearest(rec.target);
    if (!cView || cView.ignoreMutation(rec))
      return null;
    cView.markDirty(rec.type == "attributes");
    if (rec.type == "attributes")
      cView.flags |= 4;
    if (rec.type == "childList") {
      let childBefore = findChild(cView, rec.previousSibling || rec.target.previousSibling, -1);
      let childAfter = findChild(cView, rec.nextSibling || rec.target.nextSibling, 1);
      return {
        from: childBefore ? cView.posAfter(childBefore) : cView.posAtStart,
        to: childAfter ? cView.posBefore(childAfter) : cView.posAtEnd,
        typeOver: false
      };
    } else if (rec.type == "characterData") {
      return { from: cView.posAtStart, to: cView.posAtEnd, typeOver: rec.target.nodeValue == rec.oldValue };
    } else {
      return null;
    }
  }
  setWindow(win) {
    if (win != this.win) {
      this.removeWindowListeners(this.win);
      this.win = win;
      this.addWindowListeners(this.win);
    }
  }
  addWindowListeners(win) {
    win.addEventListener("resize", this.onResize);
    if (this.printQuery) {
      if (this.printQuery.addEventListener)
        this.printQuery.addEventListener("change", this.onPrint);
      else
        this.printQuery.addListener(this.onPrint);
    } else
      win.addEventListener("beforeprint", this.onPrint);
    win.addEventListener("scroll", this.onScroll);
    win.document.addEventListener("selectionchange", this.onSelectionChange);
  }
  removeWindowListeners(win) {
    win.removeEventListener("scroll", this.onScroll);
    win.removeEventListener("resize", this.onResize);
    if (this.printQuery) {
      if (this.printQuery.removeEventListener)
        this.printQuery.removeEventListener("change", this.onPrint);
      else
        this.printQuery.removeListener(this.onPrint);
    } else
      win.removeEventListener("beforeprint", this.onPrint);
    win.document.removeEventListener("selectionchange", this.onSelectionChange);
  }
  update(update) {
    if (this.editContext) {
      this.editContext.update(update);
      if (update.startState.facet(editable) != update.state.facet(editable))
        update.view.contentDOM.editContext = update.state.facet(editable) ? this.editContext.editContext : null;
    }
  }
  destroy() {
    var _a2, _b, _c;
    this.stop();
    (_a2 = this.intersection) === null || _a2 === void 0 ? void 0 : _a2.disconnect();
    (_b = this.gapIntersection) === null || _b === void 0 ? void 0 : _b.disconnect();
    (_c = this.resizeScroll) === null || _c === void 0 ? void 0 : _c.disconnect();
    for (let dom of this.scrollTargets)
      dom.removeEventListener("scroll", this.onScroll);
    this.removeWindowListeners(this.win);
    clearTimeout(this.parentCheck);
    clearTimeout(this.resizeTimeout);
    this.win.cancelAnimationFrame(this.delayedFlush);
    this.win.cancelAnimationFrame(this.flushingAndroidKey);
    if (this.editContext) {
      this.view.contentDOM.editContext = null;
      this.editContext.destroy();
    }
  }
}
function findChild(cView, dom, dir) {
  while (dom) {
    let curView = ContentView.get(dom);
    if (curView && curView.parent == cView)
      return curView;
    let parent = dom.parentNode;
    dom = parent != cView.dom ? parent : dir > 0 ? dom.nextSibling : dom.previousSibling;
  }
  return null;
}
function buildSelectionRangeFromRange(view, range2) {
  let anchorNode = range2.startContainer, anchorOffset = range2.startOffset;
  let focusNode = range2.endContainer, focusOffset = range2.endOffset;
  let curAnchor = view.docView.domAtPos(view.state.selection.main.anchor);
  if (isEquivalentPosition(curAnchor.node, curAnchor.offset, focusNode, focusOffset))
    [anchorNode, anchorOffset, focusNode, focusOffset] = [focusNode, focusOffset, anchorNode, anchorOffset];
  return { anchorNode, anchorOffset, focusNode, focusOffset };
}
function safariSelectionRangeHack(view, selection2) {
  if (selection2.getComposedRanges) {
    let range2 = selection2.getComposedRanges(view.root)[0];
    if (range2)
      return buildSelectionRangeFromRange(view, range2);
  }
  let found = null;
  function read(event) {
    event.preventDefault();
    event.stopImmediatePropagation();
    found = event.getTargetRanges()[0];
  }
  view.contentDOM.addEventListener("beforeinput", read, true);
  view.dom.ownerDocument.execCommand("indent");
  view.contentDOM.removeEventListener("beforeinput", read, true);
  return found ? buildSelectionRangeFromRange(view, found) : null;
}
class EditContextManager {
  constructor(view) {
    this.from = 0;
    this.to = 0;
    this.pendingContextChange = null;
    this.handlers = /* @__PURE__ */ Object.create(null);
    this.composing = null;
    this.resetRange(view.state);
    let context = this.editContext = new window.EditContext({
      text: view.state.doc.sliceString(this.from, this.to),
      selectionStart: this.toContextPos(Math.max(this.from, Math.min(this.to, view.state.selection.main.anchor))),
      selectionEnd: this.toContextPos(view.state.selection.main.head)
    });
    this.handlers.textupdate = (e2) => {
      let main2 = view.state.selection.main, { anchor, head } = main2;
      let from = this.toEditorPos(e2.updateRangeStart), to2 = this.toEditorPos(e2.updateRangeEnd);
      if (view.inputState.composing >= 0 && !this.composing)
        this.composing = { contextBase: e2.updateRangeStart, editorBase: from, drifted: false };
      let deletes = to2 - from > e2.text.length;
      if (from == this.from && anchor < this.from)
        from = anchor;
      else if (to2 == this.to && anchor > this.to)
        to2 = anchor;
      let diff = findDiff(view.state.sliceDoc(from, to2), e2.text, (deletes ? main2.from : main2.to) - from, deletes ? "end" : null);
      if (!diff) {
        let newSel = EditorSelection.single(this.toEditorPos(e2.selectionStart), this.toEditorPos(e2.selectionEnd));
        if (!newSel.main.eq(main2))
          view.dispatch({ selection: newSel, userEvent: "select" });
        return;
      }
      let change = {
        from: diff.from + from,
        to: diff.toA + from,
        insert: Text$1.of(e2.text.slice(diff.from, diff.toB).split("\n"))
      };
      if ((browser$3.mac || browser$3.android) && change.from == head - 1 && /^\. ?$/.test(e2.text) && view.contentDOM.getAttribute("autocorrect") == "off")
        change = { from, to: to2, insert: Text$1.of([e2.text.replace(".", " ")]) };
      this.pendingContextChange = change;
      if (!view.state.readOnly) {
        let newLen = this.to - this.from + (change.to - change.from + change.insert.length);
        applyDOMChangeInner(view, change, EditorSelection.single(this.toEditorPos(e2.selectionStart, newLen), this.toEditorPos(e2.selectionEnd, newLen)));
      }
      if (this.pendingContextChange) {
        this.revertPending(view.state);
        this.setSelection(view.state);
      }
      if (change.from < change.to && !change.insert.length && view.inputState.composing >= 0 && !/[\\p{Alphabetic}\\p{Number}_]/.test(context.text.slice(Math.max(0, e2.updateRangeStart - 1), Math.min(context.text.length, e2.updateRangeStart + 1))))
        this.handlers.compositionend(e2);
    };
    this.handlers.characterboundsupdate = (e2) => {
      let rects = [], prev = null;
      for (let i2 = this.toEditorPos(e2.rangeStart), end = this.toEditorPos(e2.rangeEnd); i2 < end; i2++) {
        let rect = view.coordsForChar(i2);
        prev = rect && new DOMRect(rect.left, rect.top, rect.right - rect.left, rect.bottom - rect.top) || prev || new DOMRect();
        rects.push(prev);
      }
      context.updateCharacterBounds(e2.rangeStart, rects);
    };
    this.handlers.textformatupdate = (e2) => {
      let deco = [];
      for (let format2 of e2.getTextFormats()) {
        let lineStyle = format2.underlineStyle, thickness = format2.underlineThickness;
        if (!/none/i.test(lineStyle) && !/none/i.test(thickness)) {
          let from = this.toEditorPos(format2.rangeStart), to2 = this.toEditorPos(format2.rangeEnd);
          if (from < to2) {
            let style = `text-decoration: underline ${/^[a-z]/.test(lineStyle) ? lineStyle + " " : lineStyle == "Dashed" ? "dashed " : lineStyle == "Squiggle" ? "wavy " : ""}${/thin/i.test(thickness) ? 1 : 2}px`;
            deco.push(Decoration.mark({ attributes: { style } }).range(from, to2));
          }
        }
      }
      view.dispatch({ effects: setEditContextFormatting.of(Decoration.set(deco)) });
    };
    this.handlers.compositionstart = () => {
      if (view.inputState.composing < 0) {
        view.inputState.composing = 0;
        view.inputState.compositionFirstChange = true;
      }
    };
    this.handlers.compositionend = () => {
      view.inputState.composing = -1;
      view.inputState.compositionFirstChange = null;
      if (this.composing) {
        let { drifted } = this.composing;
        this.composing = null;
        if (drifted)
          this.reset(view.state);
      }
    };
    for (let event in this.handlers)
      context.addEventListener(event, this.handlers[event]);
    this.measureReq = { read: (view2) => {
      this.editContext.updateControlBounds(view2.contentDOM.getBoundingClientRect());
      let sel = getSelection(view2.root);
      if (sel && sel.rangeCount)
        this.editContext.updateSelectionBounds(sel.getRangeAt(0).getBoundingClientRect());
    } };
  }
  applyEdits(update) {
    let off = 0, abort = false, pending = this.pendingContextChange;
    update.changes.iterChanges((fromA, toA, _fromB, _toB, insert2) => {
      if (abort)
        return;
      let dLen = insert2.length - (toA - fromA);
      if (pending && toA >= pending.to) {
        if (pending.from == fromA && pending.to == toA && pending.insert.eq(insert2)) {
          pending = this.pendingContextChange = null;
          off += dLen;
          this.to += dLen;
          return;
        } else {
          pending = null;
          this.revertPending(update.state);
        }
      }
      fromA += off;
      toA += off;
      if (toA <= this.from) {
        this.from += dLen;
        this.to += dLen;
      } else if (fromA < this.to) {
        if (fromA < this.from || toA > this.to || this.to - this.from + insert2.length > 3e4) {
          abort = true;
          return;
        }
        this.editContext.updateText(this.toContextPos(fromA), this.toContextPos(toA), insert2.toString());
        this.to += dLen;
      }
      off += dLen;
    });
    if (pending && !abort)
      this.revertPending(update.state);
    return !abort;
  }
  update(update) {
    let reverted = this.pendingContextChange, startSel = update.startState.selection.main;
    if (this.composing && (this.composing.drifted || !update.changes.touchesRange(startSel.from, startSel.to) && update.transactions.some((tr2) => !tr2.isUserEvent("input.type") && tr2.changes.touchesRange(this.from, this.to)))) {
      this.composing.drifted = true;
      this.composing.editorBase = update.changes.mapPos(this.composing.editorBase);
    } else if (!this.applyEdits(update) || !this.rangeIsValid(update.state)) {
      this.pendingContextChange = null;
      this.reset(update.state);
    } else if (update.docChanged || update.selectionSet || reverted) {
      this.setSelection(update.state);
    }
    if (update.geometryChanged || update.docChanged || update.selectionSet)
      update.view.requestMeasure(this.measureReq);
  }
  resetRange(state) {
    let { head } = state.selection.main;
    this.from = Math.max(
      0,
      head - 1e4
      /* CxVp.Margin */
    );
    this.to = Math.min(
      state.doc.length,
      head + 1e4
      /* CxVp.Margin */
    );
  }
  reset(state) {
    this.resetRange(state);
    this.editContext.updateText(0, this.editContext.text.length, state.doc.sliceString(this.from, this.to));
    this.setSelection(state);
  }
  revertPending(state) {
    let pending = this.pendingContextChange;
    this.pendingContextChange = null;
    this.editContext.updateText(this.toContextPos(pending.from), this.toContextPos(pending.from + pending.insert.length), state.doc.sliceString(pending.from, pending.to));
  }
  setSelection(state) {
    let { main: main2 } = state.selection;
    let start = this.toContextPos(Math.max(this.from, Math.min(this.to, main2.anchor)));
    let end = this.toContextPos(main2.head);
    if (this.editContext.selectionStart != start || this.editContext.selectionEnd != end)
      this.editContext.updateSelection(start, end);
  }
  rangeIsValid(state) {
    let { head } = state.selection.main;
    return !(this.from > 0 && head - this.from < 500 || this.to < state.doc.length && this.to - head < 500 || this.to - this.from > 1e4 * 3);
  }
  toEditorPos(contextPos, clipLen = this.to - this.from) {
    contextPos = Math.min(contextPos, clipLen);
    let c2 = this.composing;
    return c2 && c2.drifted ? c2.editorBase + (contextPos - c2.contextBase) : contextPos + this.from;
  }
  toContextPos(editorPos) {
    let c2 = this.composing;
    return c2 && c2.drifted ? c2.contextBase + (editorPos - c2.editorBase) : editorPos - this.from;
  }
  destroy() {
    for (let event in this.handlers)
      this.editContext.removeEventListener(event, this.handlers[event]);
  }
}
class EditorView {
  /**
  The current editor state.
  */
  get state() {
    return this.viewState.state;
  }
  /**
  To be able to display large documents without consuming too much
  memory or overloading the browser, CodeMirror only draws the
  code that is visible (plus a margin around it) to the DOM. This
  property tells you the extent of the current drawn viewport, in
  document positions.
  */
  get viewport() {
    return this.viewState.viewport;
  }
  /**
  When there are, for example, large collapsed ranges in the
  viewport, its size can be a lot bigger than the actual visible
  content. Thus, if you are doing something like styling the
  content in the viewport, it is preferable to only do so for
  these ranges, which are the subset of the viewport that is
  actually drawn.
  */
  get visibleRanges() {
    return this.viewState.visibleRanges;
  }
  /**
  Returns false when the editor is entirely scrolled out of view
  or otherwise hidden.
  */
  get inView() {
    return this.viewState.inView;
  }
  /**
  Indicates whether the user is currently composing text via
  [IME](https://en.wikipedia.org/wiki/Input_method), and at least
  one change has been made in the current composition.
  */
  get composing() {
    return !!this.inputState && this.inputState.composing > 0;
  }
  /**
  Indicates whether the user is currently in composing state. Note
  that on some platforms, like Android, this will be the case a
  lot, since just putting the cursor on a word starts a
  composition there.
  */
  get compositionStarted() {
    return !!this.inputState && this.inputState.composing >= 0;
  }
  /**
  The document or shadow root that the view lives in.
  */
  get root() {
    return this._root;
  }
  /**
  @internal
  */
  get win() {
    return this.dom.ownerDocument.defaultView || window;
  }
  /**
  Construct a new view. You'll want to either provide a `parent`
  option, or put `view.dom` into your document after creating a
  view, so that the user can see the editor.
  */
  constructor(config2 = {}) {
    var _a2;
    this.plugins = [];
    this.pluginMap = /* @__PURE__ */ new Map();
    this.editorAttrs = {};
    this.contentAttrs = {};
    this.bidiCache = [];
    this.destroyed = false;
    this.updateState = 2;
    this.measureScheduled = -1;
    this.measureRequests = [];
    this.contentDOM = document.createElement("div");
    this.scrollDOM = document.createElement("div");
    this.scrollDOM.tabIndex = -1;
    this.scrollDOM.className = "cm-scroller";
    this.scrollDOM.appendChild(this.contentDOM);
    this.announceDOM = document.createElement("div");
    this.announceDOM.className = "cm-announced";
    this.announceDOM.setAttribute("aria-live", "polite");
    this.dom = document.createElement("div");
    this.dom.appendChild(this.announceDOM);
    this.dom.appendChild(this.scrollDOM);
    if (config2.parent)
      config2.parent.appendChild(this.dom);
    let { dispatch } = config2;
    this.dispatchTransactions = config2.dispatchTransactions || dispatch && ((trs) => trs.forEach((tr2) => dispatch(tr2, this))) || ((trs) => this.update(trs));
    this.dispatch = this.dispatch.bind(this);
    this._root = config2.root || getRoot(config2.parent) || document;
    this.viewState = new ViewState(config2.state || EditorState.create(config2));
    if (config2.scrollTo && config2.scrollTo.is(scrollIntoView$1))
      this.viewState.scrollTarget = config2.scrollTo.value.clip(this.viewState.state);
    this.plugins = this.state.facet(viewPlugin).map((spec) => new PluginInstance(spec));
    for (let plugin of this.plugins)
      plugin.update(this);
    this.observer = new DOMObserver(this);
    this.inputState = new InputState(this);
    this.inputState.ensureHandlers(this.plugins);
    this.docView = new DocView(this);
    this.mountStyles();
    this.updateAttrs();
    this.updateState = 0;
    this.requestMeasure();
    if ((_a2 = document.fonts) === null || _a2 === void 0 ? void 0 : _a2.ready)
      document.fonts.ready.then(() => this.requestMeasure());
  }
  dispatch(...input) {
    let trs = input.length == 1 && input[0] instanceof Transaction ? input : input.length == 1 && Array.isArray(input[0]) ? input[0] : [this.state.update(...input)];
    this.dispatchTransactions(trs, this);
  }
  /**
  Update the view for the given array of transactions. This will
  update the visible document and selection to match the state
  produced by the transactions, and notify view plugins of the
  change. You should usually call
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead, which uses this
  as a primitive.
  */
  update(transactions) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.update are not allowed while an update is in progress");
    let redrawn = false, attrsChanged = false, update;
    let state = this.state;
    for (let tr2 of transactions) {
      if (tr2.startState != state)
        throw new RangeError("Trying to update state with a transaction that doesn't start from the previous state.");
      state = tr2.state;
    }
    if (this.destroyed) {
      this.viewState.state = state;
      return;
    }
    let focus = this.hasFocus, focusFlag = 0, dispatchFocus = null;
    if (transactions.some((tr2) => tr2.annotation(isFocusChange))) {
      this.inputState.notifiedFocused = focus;
      focusFlag = 1;
    } else if (focus != this.inputState.notifiedFocused) {
      this.inputState.notifiedFocused = focus;
      dispatchFocus = focusChangeTransaction(state, focus);
      if (!dispatchFocus)
        focusFlag = 1;
    }
    let pendingKey = this.observer.delayedAndroidKey, domChange = null;
    if (pendingKey) {
      this.observer.clearDelayedAndroidKey();
      domChange = this.observer.readChange();
      if (domChange && !this.state.doc.eq(state.doc) || !this.state.selection.eq(state.selection))
        domChange = null;
    } else {
      this.observer.clear();
    }
    if (state.facet(EditorState.phrases) != this.state.facet(EditorState.phrases))
      return this.setState(state);
    update = ViewUpdate.create(this, state, transactions);
    update.flags |= focusFlag;
    let scrollTarget = this.viewState.scrollTarget;
    try {
      this.updateState = 2;
      for (let tr2 of transactions) {
        if (scrollTarget)
          scrollTarget = scrollTarget.map(tr2.changes);
        if (tr2.scrollIntoView) {
          let { main: main2 } = tr2.state.selection;
          scrollTarget = new ScrollTarget(main2.empty ? main2 : EditorSelection.cursor(main2.head, main2.head > main2.anchor ? -1 : 1));
        }
        for (let e2 of tr2.effects)
          if (e2.is(scrollIntoView$1))
            scrollTarget = e2.value.clip(this.state);
      }
      this.viewState.update(update, scrollTarget);
      this.bidiCache = CachedOrder.update(this.bidiCache, update.changes);
      if (!update.empty) {
        this.updatePlugins(update);
        this.inputState.update(update);
      }
      redrawn = this.docView.update(update);
      if (this.state.facet(styleModule) != this.styleModules)
        this.mountStyles();
      attrsChanged = this.updateAttrs();
      this.showAnnouncements(transactions);
      this.docView.updateSelection(redrawn, transactions.some((tr2) => tr2.isUserEvent("select.pointer")));
    } finally {
      this.updateState = 0;
    }
    if (update.startState.facet(theme) != update.state.facet(theme))
      this.viewState.mustMeasureContent = true;
    if (redrawn || attrsChanged || scrollTarget || this.viewState.mustEnforceCursorAssoc || this.viewState.mustMeasureContent)
      this.requestMeasure();
    if (redrawn)
      this.docViewUpdate();
    if (!update.empty)
      for (let listener of this.state.facet(updateListener)) {
        try {
          listener(update);
        } catch (e2) {
          logException(this.state, e2, "update listener");
        }
      }
    if (dispatchFocus || domChange)
      Promise.resolve().then(() => {
        if (dispatchFocus && this.state == dispatchFocus.startState)
          this.dispatch(dispatchFocus);
        if (domChange) {
          if (!applyDOMChange(this, domChange) && pendingKey.force)
            dispatchKey(this.contentDOM, pendingKey.key, pendingKey.keyCode);
        }
      });
  }
  /**
  Reset the view to the given state. (This will cause the entire
  document to be redrawn and all view plugins to be reinitialized,
  so you should probably only use it when the new state isn't
  derived from the old state. Otherwise, use
  [`dispatch`](https://codemirror.net/6/docs/ref/#view.EditorView.dispatch) instead.)
  */
  setState(newState) {
    if (this.updateState != 0)
      throw new Error("Calls to EditorView.setState are not allowed while an update is in progress");
    if (this.destroyed) {
      this.viewState.state = newState;
      return;
    }
    this.updateState = 2;
    let hadFocus = this.hasFocus;
    try {
      for (let plugin of this.plugins)
        plugin.destroy(this);
      this.viewState = new ViewState(newState);
      this.plugins = newState.facet(viewPlugin).map((spec) => new PluginInstance(spec));
      this.pluginMap.clear();
      for (let plugin of this.plugins)
        plugin.update(this);
      this.docView.destroy();
      this.docView = new DocView(this);
      this.inputState.ensureHandlers(this.plugins);
      this.mountStyles();
      this.updateAttrs();
      this.bidiCache = [];
    } finally {
      this.updateState = 0;
    }
    if (hadFocus)
      this.focus();
    this.requestMeasure();
  }
  updatePlugins(update) {
    let prevSpecs = update.startState.facet(viewPlugin), specs = update.state.facet(viewPlugin);
    if (prevSpecs != specs) {
      let newPlugins = [];
      for (let spec of specs) {
        let found = prevSpecs.indexOf(spec);
        if (found < 0) {
          newPlugins.push(new PluginInstance(spec));
        } else {
          let plugin = this.plugins[found];
          plugin.mustUpdate = update;
          newPlugins.push(plugin);
        }
      }
      for (let plugin of this.plugins)
        if (plugin.mustUpdate != update)
          plugin.destroy(this);
      this.plugins = newPlugins;
      this.pluginMap.clear();
    } else {
      for (let p2 of this.plugins)
        p2.mustUpdate = update;
    }
    for (let i2 = 0; i2 < this.plugins.length; i2++)
      this.plugins[i2].update(this);
    if (prevSpecs != specs)
      this.inputState.ensureHandlers(this.plugins);
  }
  docViewUpdate() {
    for (let plugin of this.plugins) {
      let val = plugin.value;
      if (val && val.docViewUpdate) {
        try {
          val.docViewUpdate(this);
        } catch (e2) {
          logException(this.state, e2, "doc view update listener");
        }
      }
    }
  }
  /**
  @internal
  */
  measure(flush = true) {
    if (this.destroyed)
      return;
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    if (this.observer.delayedAndroidKey) {
      this.measureScheduled = -1;
      this.requestMeasure();
      return;
    }
    this.measureScheduled = 0;
    if (flush)
      this.observer.forceFlush();
    let updated = null;
    let sDOM = this.scrollDOM, scrollTop = sDOM.scrollTop * this.scaleY;
    let { scrollAnchorPos, scrollAnchorHeight } = this.viewState;
    if (Math.abs(scrollTop - this.viewState.scrollTop) > 1)
      scrollAnchorHeight = -1;
    this.viewState.scrollAnchorHeight = -1;
    try {
      for (let i2 = 0; ; i2++) {
        if (scrollAnchorHeight < 0) {
          if (isScrolledToBottom(sDOM)) {
            scrollAnchorPos = -1;
            scrollAnchorHeight = this.viewState.heightMap.height;
          } else {
            let block = this.viewState.scrollAnchorAt(scrollTop);
            scrollAnchorPos = block.from;
            scrollAnchorHeight = block.top;
          }
        }
        this.updateState = 1;
        let changed = this.viewState.measure(this);
        if (!changed && !this.measureRequests.length && this.viewState.scrollTarget == null)
          break;
        if (i2 > 5) {
          console.warn(this.measureRequests.length ? "Measure loop restarted more than 5 times" : "Viewport failed to stabilize");
          break;
        }
        let measuring = [];
        if (!(changed & 4))
          [this.measureRequests, measuring] = [measuring, this.measureRequests];
        let measured = measuring.map((m2) => {
          try {
            return m2.read(this);
          } catch (e2) {
            logException(this.state, e2);
            return BadMeasure;
          }
        });
        let update = ViewUpdate.create(this, this.state, []), redrawn = false;
        update.flags |= changed;
        if (!updated)
          updated = update;
        else
          updated.flags |= changed;
        this.updateState = 2;
        if (!update.empty) {
          this.updatePlugins(update);
          this.inputState.update(update);
          this.updateAttrs();
          redrawn = this.docView.update(update);
          if (redrawn)
            this.docViewUpdate();
        }
        for (let i3 = 0; i3 < measuring.length; i3++)
          if (measured[i3] != BadMeasure) {
            try {
              let m2 = measuring[i3];
              if (m2.write)
                m2.write(measured[i3], this);
            } catch (e2) {
              logException(this.state, e2);
            }
          }
        if (redrawn)
          this.docView.updateSelection(true);
        if (!update.viewportChanged && this.measureRequests.length == 0) {
          if (this.viewState.editorHeight) {
            if (this.viewState.scrollTarget) {
              this.docView.scrollIntoView(this.viewState.scrollTarget);
              this.viewState.scrollTarget = null;
              scrollAnchorHeight = -1;
              continue;
            } else {
              let newAnchorHeight = scrollAnchorPos < 0 ? this.viewState.heightMap.height : this.viewState.lineBlockAt(scrollAnchorPos).top;
              let diff = newAnchorHeight - scrollAnchorHeight;
              if (diff > 1 || diff < -1) {
                scrollTop = scrollTop + diff;
                sDOM.scrollTop = scrollTop / this.scaleY;
                scrollAnchorHeight = -1;
                continue;
              }
            }
          }
          break;
        }
      }
    } finally {
      this.updateState = 0;
      this.measureScheduled = -1;
    }
    if (updated && !updated.empty)
      for (let listener of this.state.facet(updateListener))
        listener(updated);
  }
  /**
  Get the CSS classes for the currently active editor themes.
  */
  get themeClasses() {
    return baseThemeID + " " + (this.state.facet(darkTheme) ? baseDarkID : baseLightID) + " " + this.state.facet(theme);
  }
  updateAttrs() {
    let editorAttrs = attrsFromFacet(this, editorAttributes, {
      class: "cm-editor" + (this.hasFocus ? " cm-focused " : " ") + this.themeClasses
    });
    let contentAttrs = {
      spellcheck: "false",
      autocorrect: "off",
      autocapitalize: "off",
      writingsuggestions: "false",
      translate: "no",
      contenteditable: !this.state.facet(editable) ? "false" : "true",
      class: "cm-content",
      style: `${browser$3.tabSize}: ${this.state.tabSize}`,
      role: "textbox",
      "aria-multiline": "true"
    };
    if (this.state.readOnly)
      contentAttrs["aria-readonly"] = "true";
    attrsFromFacet(this, contentAttributes, contentAttrs);
    let changed = this.observer.ignore(() => {
      let changedContent = updateAttrs(this.contentDOM, this.contentAttrs, contentAttrs);
      let changedEditor = updateAttrs(this.dom, this.editorAttrs, editorAttrs);
      return changedContent || changedEditor;
    });
    this.editorAttrs = editorAttrs;
    this.contentAttrs = contentAttrs;
    return changed;
  }
  showAnnouncements(trs) {
    let first2 = true;
    for (let tr2 of trs)
      for (let effect of tr2.effects)
        if (effect.is(EditorView.announce)) {
          if (first2)
            this.announceDOM.textContent = "";
          first2 = false;
          let div2 = this.announceDOM.appendChild(document.createElement("div"));
          div2.textContent = effect.value;
        }
  }
  mountStyles() {
    this.styleModules = this.state.facet(styleModule);
    let nonce = this.state.facet(EditorView.cspNonce);
    StyleModule.mount(this.root, this.styleModules.concat(baseTheme$1$2).reverse(), nonce ? { nonce } : void 0);
  }
  readMeasured() {
    if (this.updateState == 2)
      throw new Error("Reading the editor layout isn't allowed during an update");
    if (this.updateState == 0 && this.measureScheduled > -1)
      this.measure(false);
  }
  /**
  Schedule a layout measurement, optionally providing callbacks to
  do custom DOM measuring followed by a DOM write phase. Using
  this is preferable reading DOM layout directly from, for
  example, an event handler, because it'll make sure measuring and
  drawing done by other components is synchronized, avoiding
  unnecessary DOM layout computations.
  */
  requestMeasure(request) {
    if (this.measureScheduled < 0)
      this.measureScheduled = this.win.requestAnimationFrame(() => this.measure());
    if (request) {
      if (this.measureRequests.indexOf(request) > -1)
        return;
      if (request.key != null)
        for (let i2 = 0; i2 < this.measureRequests.length; i2++) {
          if (this.measureRequests[i2].key === request.key) {
            this.measureRequests[i2] = request;
            return;
          }
        }
      this.measureRequests.push(request);
    }
  }
  /**
  Get the value of a specific plugin, if present. Note that
  plugins that crash can be dropped from a view, so even when you
  know you registered a given plugin, it is recommended to check
  the return value of this method.
  */
  plugin(plugin) {
    let known = this.pluginMap.get(plugin);
    if (known === void 0 || known && known.plugin != plugin)
      this.pluginMap.set(plugin, known = this.plugins.find((p2) => p2.plugin == plugin) || null);
    return known && known.update(this).value;
  }
  /**
  The top position of the document, in screen coordinates. This
  may be negative when the editor is scrolled down. Points
  directly to the top of the first line, not above the padding.
  */
  get documentTop() {
    return this.contentDOM.getBoundingClientRect().top + this.viewState.paddingTop;
  }
  /**
  Reports the padding above and below the document.
  */
  get documentPadding() {
    return { top: this.viewState.paddingTop, bottom: this.viewState.paddingBottom };
  }
  /**
  If the editor is transformed with CSS, this provides the scale
  along the X axis. Otherwise, it will just be 1. Note that
  transforms other than translation and scaling are not supported.
  */
  get scaleX() {
    return this.viewState.scaleX;
  }
  /**
  Provide the CSS transformed scale along the Y axis.
  */
  get scaleY() {
    return this.viewState.scaleY;
  }
  /**
  Find the text line or block widget at the given vertical
  position (which is interpreted as relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop)).
  */
  elementAtHeight(height) {
    this.readMeasured();
    return this.viewState.elementAtHeight(height);
  }
  /**
  Find the line block (see
  [`lineBlockAt`](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt)) at the given
  height, again interpreted relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop).
  */
  lineBlockAtHeight(height) {
    this.readMeasured();
    return this.viewState.lineBlockAtHeight(height);
  }
  /**
  Get the extent and vertical position of all [line
  blocks](https://codemirror.net/6/docs/ref/#view.EditorView.lineBlockAt) in the viewport. Positions
  are relative to the [top of the
  document](https://codemirror.net/6/docs/ref/#view.EditorView.documentTop);
  */
  get viewportLineBlocks() {
    return this.viewState.viewportLines;
  }
  /**
  Find the line block around the given document position. A line
  block is a range delimited on both sides by either a
  non-[hidden](https://codemirror.net/6/docs/ref/#view.Decoration^replace) line break, or the
  start/end of the document. It will usually just hold a line of
  text, but may be broken into multiple textblocks by block
  widgets.
  */
  lineBlockAt(pos) {
    return this.viewState.lineBlockAt(pos);
  }
  /**
  The editor's total content height.
  */
  get contentHeight() {
    return this.viewState.contentHeight;
  }
  /**
  Move a cursor position by [grapheme
  cluster](https://codemirror.net/6/docs/ref/#state.findClusterBreak). `forward` determines whether
  the motion is away from the line start, or towards it. In
  bidirectional text, the line is traversed in visual order, using
  the editor's [text direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection).
  When the start position was the last one on the line, the
  returned position will be across the line break. If there is no
  further line, the original position is returned.
  
  By default, this method moves over a single cluster. The
  optional `by` argument can be used to move across more. It will
  be called with the first cluster as argument, and should return
  a predicate that determines, for each subsequent cluster,
  whether it should also be moved over.
  */
  moveByChar(start, forward, by) {
    return skipAtoms(this, start, moveByChar(this, start, forward, by));
  }
  /**
  Move a cursor position across the next group of either
  [letters](https://codemirror.net/6/docs/ref/#state.EditorState.charCategorizer) or non-letter
  non-whitespace characters.
  */
  moveByGroup(start, forward) {
    return skipAtoms(this, start, moveByChar(this, start, forward, (initial2) => byGroup(this, start.head, initial2)));
  }
  /**
  Get the cursor position visually at the start or end of a line.
  Note that this may differ from the _logical_ position at its
  start or end (which is simply at `line.from`/`line.to`) if text
  at the start or end goes against the line's base text direction.
  */
  visualLineSide(line2, end) {
    let order2 = this.bidiSpans(line2), dir = this.textDirectionAt(line2.from);
    let span = order2[end ? order2.length - 1 : 0];
    return EditorSelection.cursor(span.side(end, dir) + line2.from, span.forward(!end, dir) ? 1 : -1);
  }
  /**
  Move to the next line boundary in the given direction. If
  `includeWrap` is true, line wrapping is on, and there is a
  further wrap point on the current line, the wrap point will be
  returned. Otherwise this function will return the start or end
  of the line.
  */
  moveToLineBoundary(start, forward, includeWrap = true) {
    return moveToLineBoundary(this, start, forward, includeWrap);
  }
  /**
  Move a cursor position vertically. When `distance` isn't given,
  it defaults to moving to the next line (including wrapped
  lines). Otherwise, `distance` should provide a positive distance
  in pixels.
  
  When `start` has a
  [`goalColumn`](https://codemirror.net/6/docs/ref/#state.SelectionRange.goalColumn), the vertical
  motion will use that as a target horizontal position. Otherwise,
  the cursor's own horizontal position is used. The returned
  cursor will have its goal column set to whichever column was
  used.
  */
  moveVertically(start, forward, distance) {
    return skipAtoms(this, start, moveVertically(this, start, forward, distance));
  }
  /**
  Find the DOM parent node and offset (child offset if `node` is
  an element, character offset when it is a text node) at the
  given document position.
  
  Note that for positions that aren't currently in
  `visibleRanges`, the resulting DOM position isn't necessarily
  meaningful (it may just point before or after a placeholder
  element).
  */
  domAtPos(pos) {
    return this.docView.domAtPos(pos);
  }
  /**
  Find the document position at the given DOM node. Can be useful
  for associating positions with DOM events. Will raise an error
  when `node` isn't part of the editor content.
  */
  posAtDOM(node, offset2 = 0) {
    return this.docView.posFromDOM(node, offset2);
  }
  posAtCoords(coords, precise = true) {
    this.readMeasured();
    return posAtCoords(this, coords, precise);
  }
  /**
  Get the screen coordinates at the given document position.
  `side` determines whether the coordinates are based on the
  element before (-1) or after (1) the position (if no element is
  available on the given side, the method will transparently use
  another strategy to get reasonable coordinates).
  */
  coordsAtPos(pos, side = 1) {
    this.readMeasured();
    let rect = this.docView.coordsAt(pos, side);
    if (!rect || rect.left == rect.right)
      return rect;
    let line2 = this.state.doc.lineAt(pos), order2 = this.bidiSpans(line2);
    let span = order2[BidiSpan.find(order2, pos - line2.from, -1, side)];
    return flattenRect(rect, span.dir == Direction.LTR == side > 0);
  }
  /**
  Return the rectangle around a given character. If `pos` does not
  point in front of a character that is in the viewport and
  rendered (i.e. not replaced, not a line break), this will return
  null. For space characters that are a line wrap point, this will
  return the position before the line break.
  */
  coordsForChar(pos) {
    this.readMeasured();
    return this.docView.coordsForChar(pos);
  }
  /**
  The default width of a character in the editor. May not
  accurately reflect the width of all characters (given variable
  width fonts or styling of invididual ranges).
  */
  get defaultCharacterWidth() {
    return this.viewState.heightOracle.charWidth;
  }
  /**
  The default height of a line in the editor. May not be accurate
  for all lines.
  */
  get defaultLineHeight() {
    return this.viewState.heightOracle.lineHeight;
  }
  /**
  The text direction
  ([`direction`](https://developer.mozilla.org/en-US/docs/Web/CSS/direction)
  CSS property) of the editor's content element.
  */
  get textDirection() {
    return this.viewState.defaultTextDirection;
  }
  /**
  Find the text direction of the block at the given position, as
  assigned by CSS. If
  [`perLineTextDirection`](https://codemirror.net/6/docs/ref/#view.EditorView^perLineTextDirection)
  isn't enabled, or the given position is outside of the viewport,
  this will always return the same as
  [`textDirection`](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection). Note that
  this may trigger a DOM layout.
  */
  textDirectionAt(pos) {
    let perLine = this.state.facet(perLineTextDirection);
    if (!perLine || pos < this.viewport.from || pos > this.viewport.to)
      return this.textDirection;
    this.readMeasured();
    return this.docView.textDirectionAt(pos);
  }
  /**
  Whether this editor [wraps lines](https://codemirror.net/6/docs/ref/#view.EditorView.lineWrapping)
  (as determined by the
  [`white-space`](https://developer.mozilla.org/en-US/docs/Web/CSS/white-space)
  CSS property of its content element).
  */
  get lineWrapping() {
    return this.viewState.heightOracle.lineWrapping;
  }
  /**
  Returns the bidirectional text structure of the given line
  (which should be in the current document) as an array of span
  objects. The order of these spans matches the [text
  direction](https://codemirror.net/6/docs/ref/#view.EditorView.textDirection)—if that is
  left-to-right, the leftmost spans come first, otherwise the
  rightmost spans come first.
  */
  bidiSpans(line2) {
    if (line2.length > MaxBidiLine)
      return trivialOrder(line2.length);
    let dir = this.textDirectionAt(line2.from), isolates;
    for (let entry of this.bidiCache) {
      if (entry.from == line2.from && entry.dir == dir && (entry.fresh || isolatesEq(entry.isolates, isolates = getIsolatedRanges(this, line2))))
        return entry.order;
    }
    if (!isolates)
      isolates = getIsolatedRanges(this, line2);
    let order2 = computeOrder(line2.text, dir, isolates);
    this.bidiCache.push(new CachedOrder(line2.from, line2.to, dir, isolates, true, order2));
    return order2;
  }
  /**
  Check whether the editor has focus.
  */
  get hasFocus() {
    var _a2;
    return (this.dom.ownerDocument.hasFocus() || browser$3.safari && ((_a2 = this.inputState) === null || _a2 === void 0 ? void 0 : _a2.lastContextMenu) > Date.now() - 3e4) && this.root.activeElement == this.contentDOM;
  }
  /**
  Put focus on the editor.
  */
  focus() {
    this.observer.ignore(() => {
      focusPreventScroll(this.contentDOM);
      this.docView.updateSelection();
    });
  }
  /**
  Update the [root](https://codemirror.net/6/docs/ref/##view.EditorViewConfig.root) in which the editor lives. This is only
  necessary when moving the editor's existing DOM to a new window or shadow root.
  */
  setRoot(root2) {
    if (this._root != root2) {
      this._root = root2;
      this.observer.setWindow((root2.nodeType == 9 ? root2 : root2.ownerDocument).defaultView || window);
      this.mountStyles();
    }
  }
  /**
  Clean up this editor view, removing its element from the
  document, unregistering event handlers, and notifying
  plugins. The view instance can no longer be used after
  calling this.
  */
  destroy() {
    if (this.root.activeElement == this.contentDOM)
      this.contentDOM.blur();
    for (let plugin of this.plugins)
      plugin.destroy(this);
    this.plugins = [];
    this.inputState.destroy();
    this.docView.destroy();
    this.dom.remove();
    this.observer.destroy();
    if (this.measureScheduled > -1)
      this.win.cancelAnimationFrame(this.measureScheduled);
    this.destroyed = true;
  }
  /**
  Returns an effect that can be
  [added](https://codemirror.net/6/docs/ref/#state.TransactionSpec.effects) to a transaction to
  cause it to scroll the given position or range into view.
  */
  static scrollIntoView(pos, options2 = {}) {
    return scrollIntoView$1.of(new ScrollTarget(typeof pos == "number" ? EditorSelection.cursor(pos) : pos, options2.y, options2.x, options2.yMargin, options2.xMargin));
  }
  /**
  Return an effect that resets the editor to its current (at the
  time this method was called) scroll position. Note that this
  only affects the editor's own scrollable element, not parents.
  See also
  [`EditorViewConfig.scrollTo`](https://codemirror.net/6/docs/ref/#view.EditorViewConfig.scrollTo).
  
  The effect should be used with a document identical to the one
  it was created for. Failing to do so is not an error, but may
  not scroll to the expected position. You can
  [map](https://codemirror.net/6/docs/ref/#state.StateEffect.map) the effect to account for changes.
  */
  scrollSnapshot() {
    let { scrollTop, scrollLeft } = this.scrollDOM;
    let ref = this.viewState.scrollAnchorAt(scrollTop);
    return scrollIntoView$1.of(new ScrollTarget(EditorSelection.cursor(ref.from), "start", "start", ref.top - scrollTop, scrollLeft, true));
  }
  /**
  Enable or disable tab-focus mode, which disables key bindings
  for Tab and Shift-Tab, letting the browser's default
  focus-changing behavior go through instead. This is useful to
  prevent trapping keyboard users in your editor.
  
  Without argument, this toggles the mode. With a boolean, it
  enables (true) or disables it (false). Given a number, it
  temporarily enables the mode until that number of milliseconds
  have passed or another non-Tab key is pressed.
  */
  setTabFocusMode(to2) {
    if (to2 == null)
      this.inputState.tabFocusMode = this.inputState.tabFocusMode < 0 ? 0 : -1;
    else if (typeof to2 == "boolean")
      this.inputState.tabFocusMode = to2 ? 0 : -1;
    else if (this.inputState.tabFocusMode != 0)
      this.inputState.tabFocusMode = Date.now() + to2;
  }
  /**
  Returns an extension that can be used to add DOM event handlers.
  The value should be an object mapping event names to handler
  functions. For any given event, such functions are ordered by
  extension precedence, and the first handler to return true will
  be assumed to have handled that event, and no other handlers or
  built-in behavior will be activated for it. These are registered
  on the [content element](https://codemirror.net/6/docs/ref/#view.EditorView.contentDOM), except
  for `scroll` handlers, which will be called any time the
  editor's [scroll element](https://codemirror.net/6/docs/ref/#view.EditorView.scrollDOM) or one of
  its parent nodes is scrolled.
  */
  static domEventHandlers(handlers2) {
    return ViewPlugin.define(() => ({}), { eventHandlers: handlers2 });
  }
  /**
  Create an extension that registers DOM event observers. Contrary
  to event [handlers](https://codemirror.net/6/docs/ref/#view.EditorView^domEventHandlers),
  observers can't be prevented from running by a higher-precedence
  handler returning true. They also don't prevent other handlers
  and observers from running when they return true, and should not
  call `preventDefault`.
  */
  static domEventObservers(observers2) {
    return ViewPlugin.define(() => ({}), { eventObservers: observers2 });
  }
  /**
  Create a theme extension. The first argument can be a
  [`style-mod`](https://github.com/marijnh/style-mod#documentation)
  style spec providing the styles for the theme. These will be
  prefixed with a generated class for the style.
  
  Because the selectors will be prefixed with a scope class, rule
  that directly match the editor's [wrapper
  element](https://codemirror.net/6/docs/ref/#view.EditorView.dom)—to which the scope class will be
  added—need to be explicitly differentiated by adding an `&` to
  the selector for that element—for example
  `&.cm-focused`.
  
  When `dark` is set to true, the theme will be marked as dark,
  which will cause the `&dark` rules from [base
  themes](https://codemirror.net/6/docs/ref/#view.EditorView^baseTheme) to be used (as opposed to
  `&light` when a light theme is active).
  */
  static theme(spec, options2) {
    let prefix = StyleModule.newName();
    let result2 = [theme.of(prefix), styleModule.of(buildTheme(`.${prefix}`, spec))];
    if (options2 && options2.dark)
      result2.push(darkTheme.of(true));
    return result2;
  }
  /**
  Create an extension that adds styles to the base theme. Like
  with [`theme`](https://codemirror.net/6/docs/ref/#view.EditorView^theme), use `&` to indicate the
  place of the editor wrapper element when directly targeting
  that. You can also use `&dark` or `&light` instead to only
  target editors with a dark or light theme.
  */
  static baseTheme(spec) {
    return Prec.lowest(styleModule.of(buildTheme("." + baseThemeID, spec, lightDarkIDs)));
  }
  /**
  Retrieve an editor view instance from the view's DOM
  representation.
  */
  static findFromDOM(dom) {
    var _a2;
    let content2 = dom.querySelector(".cm-content");
    let cView = content2 && ContentView.get(content2) || ContentView.get(dom);
    return ((_a2 = cView === null || cView === void 0 ? void 0 : cView.rootView) === null || _a2 === void 0 ? void 0 : _a2.view) || null;
  }
}
EditorView.styleModule = styleModule;
EditorView.inputHandler = inputHandler$1;
EditorView.clipboardInputFilter = clipboardInputFilter;
EditorView.clipboardOutputFilter = clipboardOutputFilter;
EditorView.scrollHandler = scrollHandler;
EditorView.focusChangeEffect = focusChangeEffect;
EditorView.perLineTextDirection = perLineTextDirection;
EditorView.exceptionSink = exceptionSink;
EditorView.updateListener = updateListener;
EditorView.editable = editable;
EditorView.mouseSelectionStyle = mouseSelectionStyle;
EditorView.dragMovesSelection = dragMovesSelection$1;
EditorView.clickAddsSelectionRange = clickAddsSelectionRange;
EditorView.decorations = decorations;
EditorView.outerDecorations = outerDecorations;
EditorView.atomicRanges = atomicRanges;
EditorView.bidiIsolatedRanges = bidiIsolatedRanges;
EditorView.scrollMargins = scrollMargins;
EditorView.darkTheme = darkTheme;
EditorView.cspNonce = /* @__PURE__ */ Facet.define({ combine: (values2) => values2.length ? values2[0] : "" });
EditorView.contentAttributes = contentAttributes;
EditorView.editorAttributes = editorAttributes;
EditorView.lineWrapping = /* @__PURE__ */ EditorView.contentAttributes.of({ "class": "cm-lineWrapping" });
EditorView.announce = /* @__PURE__ */ StateEffect.define();
const MaxBidiLine = 4096;
const BadMeasure = {};
class CachedOrder {
  constructor(from, to2, dir, isolates, fresh, order2) {
    this.from = from;
    this.to = to2;
    this.dir = dir;
    this.isolates = isolates;
    this.fresh = fresh;
    this.order = order2;
  }
  static update(cache, changes) {
    if (changes.empty && !cache.some((c2) => c2.fresh))
      return cache;
    let result2 = [], lastDir = cache.length ? cache[cache.length - 1].dir : Direction.LTR;
    for (let i2 = Math.max(0, cache.length - 10); i2 < cache.length; i2++) {
      let entry = cache[i2];
      if (entry.dir == lastDir && !changes.touchesRange(entry.from, entry.to))
        result2.push(new CachedOrder(changes.mapPos(entry.from, 1), changes.mapPos(entry.to, -1), entry.dir, entry.isolates, false, entry.order));
    }
    return result2;
  }
}
function attrsFromFacet(view, facet, base2) {
  for (let sources = view.state.facet(facet), i2 = sources.length - 1; i2 >= 0; i2--) {
    let source = sources[i2], value = typeof source == "function" ? source(view) : source;
    if (value)
      combineAttrs(value, base2);
  }
  return base2;
}
const currentPlatform = browser$3.mac ? "mac" : browser$3.windows ? "win" : browser$3.linux ? "linux" : "key";
function normalizeKeyName(name2, platform2) {
  const parts = name2.split(/-(?!$)/);
  let result2 = parts[parts.length - 1];
  if (result2 == "Space")
    result2 = " ";
  let alt, ctrl, shift2, meta2;
  for (let i2 = 0; i2 < parts.length - 1; ++i2) {
    const mod2 = parts[i2];
    if (/^(cmd|meta|m)$/i.test(mod2))
      meta2 = true;
    else if (/^a(lt)?$/i.test(mod2))
      alt = true;
    else if (/^(c|ctrl|control)$/i.test(mod2))
      ctrl = true;
    else if (/^s(hift)?$/i.test(mod2))
      shift2 = true;
    else if (/^mod$/i.test(mod2)) {
      if (platform2 == "mac")
        meta2 = true;
      else
        ctrl = true;
    } else
      throw new Error("Unrecognized modifier name: " + mod2);
  }
  if (alt)
    result2 = "Alt-" + result2;
  if (ctrl)
    result2 = "Ctrl-" + result2;
  if (meta2)
    result2 = "Meta-" + result2;
  if (shift2)
    result2 = "Shift-" + result2;
  return result2;
}
function modifiers(name2, event, shift2) {
  if (event.altKey)
    name2 = "Alt-" + name2;
  if (event.ctrlKey)
    name2 = "Ctrl-" + name2;
  if (event.metaKey)
    name2 = "Meta-" + name2;
  if (shift2 !== false && event.shiftKey)
    name2 = "Shift-" + name2;
  return name2;
}
const handleKeyEvents = /* @__PURE__ */ Prec.default(/* @__PURE__ */ EditorView.domEventHandlers({
  keydown(event, view) {
    return runHandlers(getKeymap(view.state), event, view, "editor");
  }
}));
const keymap = /* @__PURE__ */ Facet.define({ enables: handleKeyEvents });
const Keymaps = /* @__PURE__ */ new WeakMap();
function getKeymap(state) {
  let bindings = state.facet(keymap);
  let map2 = Keymaps.get(bindings);
  if (!map2)
    Keymaps.set(bindings, map2 = buildKeymap(bindings.reduce((a2, b2) => a2.concat(b2), [])));
  return map2;
}
function runScopeHandlers(view, event, scope) {
  return runHandlers(getKeymap(view.state), event, view, scope);
}
let storedPrefix = null;
const PrefixTimeout = 4e3;
function buildKeymap(bindings, platform2 = currentPlatform) {
  let bound = /* @__PURE__ */ Object.create(null);
  let isPrefix = /* @__PURE__ */ Object.create(null);
  let checkPrefix = (name2, is2) => {
    let current2 = isPrefix[name2];
    if (current2 == null)
      isPrefix[name2] = is2;
    else if (current2 != is2)
      throw new Error("Key binding " + name2 + " is used both as a regular binding and as a multi-stroke prefix");
  };
  let add2 = (scope, key, command2, preventDefault, stopPropagation) => {
    var _a2, _b;
    let scopeObj = bound[scope] || (bound[scope] = /* @__PURE__ */ Object.create(null));
    let parts = key.split(/ (?!$)/).map((k2) => normalizeKeyName(k2, platform2));
    for (let i2 = 1; i2 < parts.length; i2++) {
      let prefix = parts.slice(0, i2).join(" ");
      checkPrefix(prefix, true);
      if (!scopeObj[prefix])
        scopeObj[prefix] = {
          preventDefault: true,
          stopPropagation: false,
          run: [(view) => {
            let ourObj = storedPrefix = { view, prefix, scope };
            setTimeout(() => {
              if (storedPrefix == ourObj)
                storedPrefix = null;
            }, PrefixTimeout);
            return true;
          }]
        };
    }
    let full = parts.join(" ");
    checkPrefix(full, false);
    let binding = scopeObj[full] || (scopeObj[full] = {
      preventDefault: false,
      stopPropagation: false,
      run: ((_b = (_a2 = scopeObj._any) === null || _a2 === void 0 ? void 0 : _a2.run) === null || _b === void 0 ? void 0 : _b.slice()) || []
    });
    if (command2)
      binding.run.push(command2);
    if (preventDefault)
      binding.preventDefault = true;
    if (stopPropagation)
      binding.stopPropagation = true;
  };
  for (let b2 of bindings) {
    let scopes = b2.scope ? b2.scope.split(" ") : ["editor"];
    if (b2.any)
      for (let scope of scopes) {
        let scopeObj = bound[scope] || (bound[scope] = /* @__PURE__ */ Object.create(null));
        if (!scopeObj._any)
          scopeObj._any = { preventDefault: false, stopPropagation: false, run: [] };
        let { any } = b2;
        for (let key in scopeObj)
          scopeObj[key].run.push((view) => any(view, currentKeyEvent));
      }
    let name2 = b2[platform2] || b2.key;
    if (!name2)
      continue;
    for (let scope of scopes) {
      add2(scope, name2, b2.run, b2.preventDefault, b2.stopPropagation);
      if (b2.shift)
        add2(scope, "Shift-" + name2, b2.shift, b2.preventDefault, b2.stopPropagation);
    }
  }
  return bound;
}
let currentKeyEvent = null;
function runHandlers(map2, event, view, scope) {
  currentKeyEvent = event;
  let name2 = keyName(event);
  let charCode = codePointAt(name2, 0), isChar = codePointSize(charCode) == name2.length && name2 != " ";
  let prefix = "", handled = false, prevented = false, stopPropagation = false;
  if (storedPrefix && storedPrefix.view == view && storedPrefix.scope == scope) {
    prefix = storedPrefix.prefix + " ";
    if (modifierCodes.indexOf(event.keyCode) < 0) {
      prevented = true;
      storedPrefix = null;
    }
  }
  let ran = /* @__PURE__ */ new Set();
  let runFor = (binding) => {
    if (binding) {
      for (let cmd2 of binding.run)
        if (!ran.has(cmd2)) {
          ran.add(cmd2);
          if (cmd2(view)) {
            if (binding.stopPropagation)
              stopPropagation = true;
            return true;
          }
        }
      if (binding.preventDefault) {
        if (binding.stopPropagation)
          stopPropagation = true;
        prevented = true;
      }
    }
    return false;
  };
  let scopeObj = map2[scope], baseName, shiftName;
  if (scopeObj) {
    if (runFor(scopeObj[prefix + modifiers(name2, event, !isChar)])) {
      handled = true;
    } else if (isChar && (event.altKey || event.metaKey || event.ctrlKey) && // Ctrl-Alt may be used for AltGr on Windows
    !(browser$3.windows && event.ctrlKey && event.altKey) && // Alt-combinations on macOS tend to be typed characters
    !(browser$3.mac && event.altKey && !(event.ctrlKey || event.metaKey)) && (baseName = base[event.keyCode]) && baseName != name2) {
      if (runFor(scopeObj[prefix + modifiers(baseName, event, true)])) {
        handled = true;
      } else if (event.shiftKey && (shiftName = shift$2[event.keyCode]) != name2 && shiftName != baseName && runFor(scopeObj[prefix + modifiers(shiftName, event, false)])) {
        handled = true;
      }
    } else if (isChar && event.shiftKey && runFor(scopeObj[prefix + modifiers(name2, event, true)])) {
      handled = true;
    }
    if (!handled && runFor(scopeObj._any))
      handled = true;
  }
  if (prevented)
    handled = true;
  if (handled && stopPropagation)
    event.stopPropagation();
  currentKeyEvent = null;
  return handled;
}
class RectangleMarker {
  /**
  Create a marker with the given class and dimensions. If `width`
  is null, the DOM element will get no width style.
  */
  constructor(className, left, top2, width, height) {
    this.className = className;
    this.left = left;
    this.top = top2;
    this.width = width;
    this.height = height;
  }
  draw() {
    let elt = document.createElement("div");
    elt.className = this.className;
    this.adjust(elt);
    return elt;
  }
  update(elt, prev) {
    if (prev.className != this.className)
      return false;
    this.adjust(elt);
    return true;
  }
  adjust(elt) {
    elt.style.left = this.left + "px";
    elt.style.top = this.top + "px";
    if (this.width != null)
      elt.style.width = this.width + "px";
    elt.style.height = this.height + "px";
  }
  eq(p2) {
    return this.left == p2.left && this.top == p2.top && this.width == p2.width && this.height == p2.height && this.className == p2.className;
  }
  /**
  Create a set of rectangles for the given selection range,
  assigning them theclass`className`. Will create a single
  rectangle for empty ranges, and a set of selection-style
  rectangles covering the range's content (in a bidi-aware
  way) for non-empty ones.
  */
  static forRange(view, className, range2) {
    if (range2.empty) {
      let pos = view.coordsAtPos(range2.head, range2.assoc || 1);
      if (!pos)
        return [];
      let base2 = getBase(view);
      return [new RectangleMarker(className, pos.left - base2.left, pos.top - base2.top, null, pos.bottom - pos.top)];
    } else {
      return rectanglesForRange(view, className, range2);
    }
  }
}
function getBase(view) {
  let rect = view.scrollDOM.getBoundingClientRect();
  let left = view.textDirection == Direction.LTR ? rect.left : rect.right - view.scrollDOM.clientWidth * view.scaleX;
  return { left: left - view.scrollDOM.scrollLeft * view.scaleX, top: rect.top - view.scrollDOM.scrollTop * view.scaleY };
}
function wrappedLine(view, pos, side, inside2) {
  let coords = view.coordsAtPos(pos, side * 2);
  if (!coords)
    return inside2;
  let editorRect = view.dom.getBoundingClientRect();
  let y2 = (coords.top + coords.bottom) / 2;
  let left = view.posAtCoords({ x: editorRect.left + 1, y: y2 });
  let right = view.posAtCoords({ x: editorRect.right - 1, y: y2 });
  if (left == null || right == null)
    return inside2;
  return { from: Math.max(inside2.from, Math.min(left, right)), to: Math.min(inside2.to, Math.max(left, right)) };
}
function rectanglesForRange(view, className, range2) {
  if (range2.to <= view.viewport.from || range2.from >= view.viewport.to)
    return [];
  let from = Math.max(range2.from, view.viewport.from), to2 = Math.min(range2.to, view.viewport.to);
  let ltr = view.textDirection == Direction.LTR;
  let content2 = view.contentDOM, contentRect = content2.getBoundingClientRect(), base2 = getBase(view);
  let lineElt = content2.querySelector(".cm-line"), lineStyle = lineElt && window.getComputedStyle(lineElt);
  let leftSide = contentRect.left + (lineStyle ? parseInt(lineStyle.paddingLeft) + Math.min(0, parseInt(lineStyle.textIndent)) : 0);
  let rightSide = contentRect.right - (lineStyle ? parseInt(lineStyle.paddingRight) : 0);
  let startBlock = blockAt(view, from, 1), endBlock = blockAt(view, to2, -1);
  let visualStart = startBlock.type == BlockType.Text ? startBlock : null;
  let visualEnd = endBlock.type == BlockType.Text ? endBlock : null;
  if (visualStart && (view.lineWrapping || startBlock.widgetLineBreaks))
    visualStart = wrappedLine(view, from, 1, visualStart);
  if (visualEnd && (view.lineWrapping || endBlock.widgetLineBreaks))
    visualEnd = wrappedLine(view, to2, -1, visualEnd);
  if (visualStart && visualEnd && visualStart.from == visualEnd.from && visualStart.to == visualEnd.to) {
    return pieces(drawForLine(range2.from, range2.to, visualStart));
  } else {
    let top2 = visualStart ? drawForLine(range2.from, null, visualStart) : drawForWidget(startBlock, false);
    let bottom = visualEnd ? drawForLine(null, range2.to, visualEnd) : drawForWidget(endBlock, true);
    let between = [];
    if ((visualStart || startBlock).to < (visualEnd || endBlock).from - (visualStart && visualEnd ? 1 : 0) || startBlock.widgetLineBreaks > 1 && top2.bottom + view.defaultLineHeight / 2 < bottom.top)
      between.push(piece(leftSide, top2.bottom, rightSide, bottom.top));
    else if (top2.bottom < bottom.top && view.elementAtHeight((top2.bottom + bottom.top) / 2).type == BlockType.Text)
      top2.bottom = bottom.top = (top2.bottom + bottom.top) / 2;
    return pieces(top2).concat(between).concat(pieces(bottom));
  }
  function piece(left, top2, right, bottom) {
    return new RectangleMarker(className, left - base2.left, top2 - base2.top, right - left, bottom - top2);
  }
  function pieces({ top: top2, bottom, horizontal }) {
    let pieces2 = [];
    for (let i2 = 0; i2 < horizontal.length; i2 += 2)
      pieces2.push(piece(horizontal[i2], top2, horizontal[i2 + 1], bottom));
    return pieces2;
  }
  function drawForLine(from2, to22, line2) {
    let top2 = 1e9, bottom = -1e9, horizontal = [];
    function addSpan(from3, fromOpen, to3, toOpen, dir) {
      let fromCoords = view.coordsAtPos(from3, from3 == line2.to ? -2 : 2);
      let toCoords = view.coordsAtPos(to3, to3 == line2.from ? 2 : -2);
      if (!fromCoords || !toCoords)
        return;
      top2 = Math.min(fromCoords.top, toCoords.top, top2);
      bottom = Math.max(fromCoords.bottom, toCoords.bottom, bottom);
      if (dir == Direction.LTR)
        horizontal.push(ltr && fromOpen ? leftSide : fromCoords.left, ltr && toOpen ? rightSide : toCoords.right);
      else
        horizontal.push(!ltr && toOpen ? leftSide : toCoords.left, !ltr && fromOpen ? rightSide : fromCoords.right);
    }
    let start = from2 !== null && from2 !== void 0 ? from2 : line2.from, end = to22 !== null && to22 !== void 0 ? to22 : line2.to;
    for (let r2 of view.visibleRanges)
      if (r2.to > start && r2.from < end) {
        for (let pos = Math.max(r2.from, start), endPos = Math.min(r2.to, end); ; ) {
          let docLine = view.state.doc.lineAt(pos);
          for (let span of view.bidiSpans(docLine)) {
            let spanFrom = span.from + docLine.from, spanTo = span.to + docLine.from;
            if (spanFrom >= endPos)
              break;
            if (spanTo > pos)
              addSpan(Math.max(spanFrom, pos), from2 == null && spanFrom <= start, Math.min(spanTo, endPos), to22 == null && spanTo >= end, span.dir);
          }
          pos = docLine.to + 1;
          if (pos >= endPos)
            break;
        }
      }
    if (horizontal.length == 0)
      addSpan(start, from2 == null, end, to22 == null, view.textDirection);
    return { top: top2, bottom, horizontal };
  }
  function drawForWidget(block, top2) {
    let y2 = contentRect.top + (top2 ? block.top : block.bottom);
    return { top: y2, bottom: y2, horizontal: [] };
  }
}
function sameMarker(a2, b2) {
  return a2.constructor == b2.constructor && a2.eq(b2);
}
class LayerView {
  constructor(view, layer2) {
    this.view = view;
    this.layer = layer2;
    this.drawn = [];
    this.scaleX = 1;
    this.scaleY = 1;
    this.measureReq = { read: this.measure.bind(this), write: this.draw.bind(this) };
    this.dom = view.scrollDOM.appendChild(document.createElement("div"));
    this.dom.classList.add("cm-layer");
    if (layer2.above)
      this.dom.classList.add("cm-layer-above");
    if (layer2.class)
      this.dom.classList.add(layer2.class);
    this.scale();
    this.dom.setAttribute("aria-hidden", "true");
    this.setOrder(view.state);
    view.requestMeasure(this.measureReq);
    if (layer2.mount)
      layer2.mount(this.dom, view);
  }
  update(update) {
    if (update.startState.facet(layerOrder) != update.state.facet(layerOrder))
      this.setOrder(update.state);
    if (this.layer.update(update, this.dom) || update.geometryChanged) {
      this.scale();
      update.view.requestMeasure(this.measureReq);
    }
  }
  docViewUpdate(view) {
    if (this.layer.updateOnDocViewUpdate !== false)
      view.requestMeasure(this.measureReq);
  }
  setOrder(state) {
    let pos = 0, order2 = state.facet(layerOrder);
    while (pos < order2.length && order2[pos] != this.layer)
      pos++;
    this.dom.style.zIndex = String((this.layer.above ? 150 : -1) - pos);
  }
  measure() {
    return this.layer.markers(this.view);
  }
  scale() {
    let { scaleX, scaleY } = this.view;
    if (scaleX != this.scaleX || scaleY != this.scaleY) {
      this.scaleX = scaleX;
      this.scaleY = scaleY;
      this.dom.style.transform = `scale(${1 / scaleX}, ${1 / scaleY})`;
    }
  }
  draw(markers) {
    if (markers.length != this.drawn.length || markers.some((p2, i2) => !sameMarker(p2, this.drawn[i2]))) {
      let old = this.dom.firstChild, oldI = 0;
      for (let marker of markers) {
        if (marker.update && old && marker.constructor && this.drawn[oldI].constructor && marker.update(old, this.drawn[oldI])) {
          old = old.nextSibling;
          oldI++;
        } else {
          this.dom.insertBefore(marker.draw(), old);
        }
      }
      while (old) {
        let next = old.nextSibling;
        old.remove();
        old = next;
      }
      this.drawn = markers;
      if (browser$3.safari && browser$3.safari_version >= 26)
        this.dom.style.display = this.dom.firstChild ? "" : "none";
    }
  }
  destroy() {
    if (this.layer.destroy)
      this.layer.destroy(this.dom, this.view);
    this.dom.remove();
  }
}
const layerOrder = /* @__PURE__ */ Facet.define();
function layer(config2) {
  return [
    ViewPlugin.define((v2) => new LayerView(v2, config2)),
    layerOrder.of(config2)
  ];
}
const selectionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      cursorBlinkRate: 1200,
      drawRangeCursor: true
    }, {
      cursorBlinkRate: (a2, b2) => Math.min(a2, b2),
      drawRangeCursor: (a2, b2) => a2 || b2
    });
  }
});
function drawSelection(config2 = {}) {
  return [
    selectionConfig.of(config2),
    cursorLayer,
    selectionLayer,
    hideNativeSelection,
    nativeSelectionHidden.of(true)
  ];
}
function configChanged(update) {
  return update.startState.facet(selectionConfig) != update.state.facet(selectionConfig);
}
const cursorLayer = /* @__PURE__ */ layer({
  above: true,
  markers(view) {
    let { state } = view, conf = state.facet(selectionConfig);
    let cursors = [];
    for (let r2 of state.selection.ranges) {
      let prim = r2 == state.selection.main;
      if (r2.empty || conf.drawRangeCursor) {
        let className = prim ? "cm-cursor cm-cursor-primary" : "cm-cursor cm-cursor-secondary";
        let cursor2 = r2.empty ? r2 : EditorSelection.cursor(r2.head, r2.head > r2.anchor ? -1 : 1);
        for (let piece of RectangleMarker.forRange(view, className, cursor2))
          cursors.push(piece);
      }
    }
    return cursors;
  },
  update(update, dom) {
    if (update.transactions.some((tr2) => tr2.selection))
      dom.style.animationName = dom.style.animationName == "cm-blink" ? "cm-blink2" : "cm-blink";
    let confChange = configChanged(update);
    if (confChange)
      setBlinkRate(update.state, dom);
    return update.docChanged || update.selectionSet || confChange;
  },
  mount(dom, view) {
    setBlinkRate(view.state, dom);
  },
  class: "cm-cursorLayer"
});
function setBlinkRate(state, dom) {
  dom.style.animationDuration = state.facet(selectionConfig).cursorBlinkRate + "ms";
}
const selectionLayer = /* @__PURE__ */ layer({
  above: false,
  markers(view) {
    return view.state.selection.ranges.map((r2) => r2.empty ? [] : RectangleMarker.forRange(view, "cm-selectionBackground", r2)).reduce((a2, b2) => a2.concat(b2));
  },
  update(update, dom) {
    return update.docChanged || update.selectionSet || update.viewportChanged || configChanged(update);
  },
  class: "cm-selectionLayer"
});
const hideNativeSelection = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ EditorView.theme({
  ".cm-line": {
    "& ::selection, &::selection": { backgroundColor: "transparent !important" },
    caretColor: "transparent !important"
  },
  ".cm-content": {
    caretColor: "transparent !important",
    "& :focus": {
      caretColor: "initial !important",
      "&::selection, & ::selection": {
        backgroundColor: "Highlight !important"
      }
    }
  }
}));
const setDropCursorPos = /* @__PURE__ */ StateEffect.define({
  map(pos, mapping) {
    return pos == null ? null : mapping.mapPos(pos);
  }
});
const dropCursorPos = /* @__PURE__ */ StateField.define({
  create() {
    return null;
  },
  update(pos, tr2) {
    if (pos != null)
      pos = tr2.changes.mapPos(pos);
    return tr2.effects.reduce((pos2, e2) => e2.is(setDropCursorPos) ? e2.value : pos2, pos);
  }
});
const drawDropCursor = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.cursor = null;
    this.measureReq = { read: this.readPos.bind(this), write: this.drawCursor.bind(this) };
  }
  update(update) {
    var _a2;
    let cursorPos = update.state.field(dropCursorPos);
    if (cursorPos == null) {
      if (this.cursor != null) {
        (_a2 = this.cursor) === null || _a2 === void 0 ? void 0 : _a2.remove();
        this.cursor = null;
      }
    } else {
      if (!this.cursor) {
        this.cursor = this.view.scrollDOM.appendChild(document.createElement("div"));
        this.cursor.className = "cm-dropCursor";
      }
      if (update.startState.field(dropCursorPos) != cursorPos || update.docChanged || update.geometryChanged)
        this.view.requestMeasure(this.measureReq);
    }
  }
  readPos() {
    let { view } = this;
    let pos = view.state.field(dropCursorPos);
    let rect = pos != null && view.coordsAtPos(pos);
    if (!rect)
      return null;
    let outer = view.scrollDOM.getBoundingClientRect();
    return {
      left: rect.left - outer.left + view.scrollDOM.scrollLeft * view.scaleX,
      top: rect.top - outer.top + view.scrollDOM.scrollTop * view.scaleY,
      height: rect.bottom - rect.top
    };
  }
  drawCursor(pos) {
    if (this.cursor) {
      let { scaleX, scaleY } = this.view;
      if (pos) {
        this.cursor.style.left = pos.left / scaleX + "px";
        this.cursor.style.top = pos.top / scaleY + "px";
        this.cursor.style.height = pos.height / scaleY + "px";
      } else {
        this.cursor.style.left = "-100000px";
      }
    }
  }
  destroy() {
    if (this.cursor)
      this.cursor.remove();
  }
  setDropPos(pos) {
    if (this.view.state.field(dropCursorPos) != pos)
      this.view.dispatch({ effects: setDropCursorPos.of(pos) });
  }
}, {
  eventObservers: {
    dragover(event) {
      this.setDropPos(this.view.posAtCoords({ x: event.clientX, y: event.clientY }));
    },
    dragleave(event) {
      if (event.target == this.view.contentDOM || !this.view.contentDOM.contains(event.relatedTarget))
        this.setDropPos(null);
    },
    dragend() {
      this.setDropPos(null);
    },
    drop() {
      this.setDropPos(null);
    }
  }
});
function dropCursor() {
  return [dropCursorPos, drawDropCursor];
}
function iterMatches(doc2, re2, from, to2, f2) {
  re2.lastIndex = 0;
  for (let cursor2 = doc2.iterRange(from, to2), pos = from, m2; !cursor2.next().done; pos += cursor2.value.length) {
    if (!cursor2.lineBreak)
      while (m2 = re2.exec(cursor2.value))
        f2(pos + m2.index, m2);
  }
}
function matchRanges(view, maxLength) {
  let visible = view.visibleRanges;
  if (visible.length == 1 && visible[0].from == view.viewport.from && visible[0].to == view.viewport.to)
    return visible;
  let result2 = [];
  for (let { from, to: to2 } of visible) {
    from = Math.max(view.state.doc.lineAt(from).from, from - maxLength);
    to2 = Math.min(view.state.doc.lineAt(to2).to, to2 + maxLength);
    if (result2.length && result2[result2.length - 1].to >= from)
      result2[result2.length - 1].to = to2;
    else
      result2.push({ from, to: to2 });
  }
  return result2;
}
class MatchDecorator {
  /**
  Create a decorator.
  */
  constructor(config2) {
    const { regexp, decoration, decorate, boundary, maxLength = 1e3 } = config2;
    if (!regexp.global)
      throw new RangeError("The regular expression given to MatchDecorator should have its 'g' flag set");
    this.regexp = regexp;
    if (decorate) {
      this.addMatch = (match2, view, from, add2) => decorate(add2, from, from + match2[0].length, match2, view);
    } else if (typeof decoration == "function") {
      this.addMatch = (match2, view, from, add2) => {
        let deco = decoration(match2, view, from);
        if (deco)
          add2(from, from + match2[0].length, deco);
      };
    } else if (decoration) {
      this.addMatch = (match2, _view, from, add2) => add2(from, from + match2[0].length, decoration);
    } else {
      throw new RangeError("Either 'decorate' or 'decoration' should be provided to MatchDecorator");
    }
    this.boundary = boundary;
    this.maxLength = maxLength;
  }
  /**
  Compute the full set of decorations for matches in the given
  view's viewport. You'll want to call this when initializing your
  plugin.
  */
  createDeco(view) {
    let build = new RangeSetBuilder(), add2 = build.add.bind(build);
    for (let { from, to: to2 } of matchRanges(view, this.maxLength))
      iterMatches(view.state.doc, this.regexp, from, to2, (from2, m2) => this.addMatch(m2, view, from2, add2));
    return build.finish();
  }
  /**
  Update a set of decorations for a view update. `deco` _must_ be
  the set of decorations produced by _this_ `MatchDecorator` for
  the view state before the update.
  */
  updateDeco(update, deco) {
    let changeFrom = 1e9, changeTo = -1;
    if (update.docChanged)
      update.changes.iterChanges((_f, _t, from, to2) => {
        if (to2 >= update.view.viewport.from && from <= update.view.viewport.to) {
          changeFrom = Math.min(from, changeFrom);
          changeTo = Math.max(to2, changeTo);
        }
      });
    if (update.viewportMoved || changeTo - changeFrom > 1e3)
      return this.createDeco(update.view);
    if (changeTo > -1)
      return this.updateRange(update.view, deco.map(update.changes), changeFrom, changeTo);
    return deco;
  }
  updateRange(view, deco, updateFrom, updateTo) {
    for (let r2 of view.visibleRanges) {
      let from = Math.max(r2.from, updateFrom), to2 = Math.min(r2.to, updateTo);
      if (to2 >= from) {
        let fromLine = view.state.doc.lineAt(from), toLine = fromLine.to < to2 ? view.state.doc.lineAt(to2) : fromLine;
        let start = Math.max(r2.from, fromLine.from), end = Math.min(r2.to, toLine.to);
        if (this.boundary) {
          for (; from > fromLine.from; from--)
            if (this.boundary.test(fromLine.text[from - 1 - fromLine.from])) {
              start = from;
              break;
            }
          for (; to2 < toLine.to; to2++)
            if (this.boundary.test(toLine.text[to2 - toLine.from])) {
              end = to2;
              break;
            }
        }
        let ranges = [], m2;
        let add2 = (from2, to22, deco2) => ranges.push(deco2.range(from2, to22));
        if (fromLine == toLine) {
          this.regexp.lastIndex = start - fromLine.from;
          while ((m2 = this.regexp.exec(fromLine.text)) && m2.index < end - fromLine.from)
            this.addMatch(m2, view, m2.index + fromLine.from, add2);
        } else {
          iterMatches(view.state.doc, this.regexp, start, end, (from2, m3) => this.addMatch(m3, view, from2, add2));
        }
        deco = deco.update({ filterFrom: start, filterTo: end, filter: (from2, to22) => from2 < start || to22 > end, add: ranges });
      }
    }
    return deco;
  }
}
const UnicodeRegexpSupport = /x/.unicode != null ? "gu" : "g";
const Specials = /* @__PURE__ */ new RegExp("[\0-\b\n--­؜​‎‏\u2028\u2029‭‮⁦⁧⁩\uFEFF￹-￼]", UnicodeRegexpSupport);
const Names = {
  0: "null",
  7: "bell",
  8: "backspace",
  10: "newline",
  11: "vertical tab",
  13: "carriage return",
  27: "escape",
  8203: "zero width space",
  8204: "zero width non-joiner",
  8205: "zero width joiner",
  8206: "left-to-right mark",
  8207: "right-to-left mark",
  8232: "line separator",
  8237: "left-to-right override",
  8238: "right-to-left override",
  8294: "left-to-right isolate",
  8295: "right-to-left isolate",
  8297: "pop directional isolate",
  8233: "paragraph separator",
  65279: "zero width no-break space",
  65532: "object replacement"
};
let _supportsTabSize = null;
function supportsTabSize() {
  var _a2;
  if (_supportsTabSize == null && typeof document != "undefined" && document.body) {
    let styles = document.body.style;
    _supportsTabSize = ((_a2 = styles.tabSize) !== null && _a2 !== void 0 ? _a2 : styles.MozTabSize) != null;
  }
  return _supportsTabSize || false;
}
const specialCharConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let config2 = combineConfig(configs, {
      render: null,
      specialChars: Specials,
      addSpecialChars: null
    });
    if (config2.replaceTabs = !supportsTabSize())
      config2.specialChars = new RegExp("	|" + config2.specialChars.source, UnicodeRegexpSupport);
    if (config2.addSpecialChars)
      config2.specialChars = new RegExp(config2.specialChars.source + "|" + config2.addSpecialChars.source, UnicodeRegexpSupport);
    return config2;
  }
});
function highlightSpecialChars(config2 = {}) {
  return [specialCharConfig.of(config2), specialCharPlugin()];
}
let _plugin = null;
function specialCharPlugin() {
  return _plugin || (_plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.decorations = Decoration.none;
      this.decorationCache = /* @__PURE__ */ Object.create(null);
      this.decorator = this.makeDecorator(view.state.facet(specialCharConfig));
      this.decorations = this.decorator.createDeco(view);
    }
    makeDecorator(conf) {
      return new MatchDecorator({
        regexp: conf.specialChars,
        decoration: (m2, view, pos) => {
          let { doc: doc2 } = view.state;
          let code2 = codePointAt(m2[0], 0);
          if (code2 == 9) {
            let line2 = doc2.lineAt(pos);
            let size2 = view.state.tabSize, col = countColumn(line2.text, size2, pos - line2.from);
            return Decoration.replace({
              widget: new TabWidget((size2 - col % size2) * this.view.defaultCharacterWidth / this.view.scaleX)
            });
          }
          return this.decorationCache[code2] || (this.decorationCache[code2] = Decoration.replace({ widget: new SpecialCharWidget(conf, code2) }));
        },
        boundary: conf.replaceTabs ? void 0 : /[^]/
      });
    }
    update(update) {
      let conf = update.state.facet(specialCharConfig);
      if (update.startState.facet(specialCharConfig) != conf) {
        this.decorator = this.makeDecorator(conf);
        this.decorations = this.decorator.createDeco(update.view);
      } else {
        this.decorations = this.decorator.updateDeco(update, this.decorations);
      }
    }
  }, {
    decorations: (v2) => v2.decorations
  }));
}
const DefaultPlaceholder = "•";
function placeholder$1(code2) {
  if (code2 >= 32)
    return DefaultPlaceholder;
  if (code2 == 10)
    return "␤";
  return String.fromCharCode(9216 + code2);
}
class SpecialCharWidget extends WidgetType {
  constructor(options2, code2) {
    super();
    this.options = options2;
    this.code = code2;
  }
  eq(other) {
    return other.code == this.code;
  }
  toDOM(view) {
    let ph = placeholder$1(this.code);
    let desc = view.state.phrase("Control character") + " " + (Names[this.code] || "0x" + this.code.toString(16));
    let custom = this.options.render && this.options.render(this.code, desc, ph);
    if (custom)
      return custom;
    let span = document.createElement("span");
    span.textContent = ph;
    span.title = desc;
    span.setAttribute("aria-label", desc);
    span.className = "cm-specialChar";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
class TabWidget extends WidgetType {
  constructor(width) {
    super();
    this.width = width;
  }
  eq(other) {
    return other.width == this.width;
  }
  toDOM() {
    let span = document.createElement("span");
    span.textContent = "	";
    span.className = "cm-tab";
    span.style.width = this.width + "px";
    return span;
  }
  ignoreEvent() {
    return false;
  }
}
function highlightActiveLine() {
  return activeLineHighlighter;
}
const lineDeco = /* @__PURE__ */ Decoration.line({ class: "cm-activeLine" });
const activeLineHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.docChanged || update.selectionSet)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let lastLineStart = -1, deco = [];
    for (let r2 of view.state.selection.ranges) {
      let line2 = view.lineBlockAt(r2.head);
      if (line2.from > lastLineStart) {
        deco.push(lineDeco.range(line2.from));
        lastLineStart = line2.from;
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
class Placeholder extends WidgetType {
  constructor(content2) {
    super();
    this.content = content2;
  }
  toDOM(view) {
    let wrap2 = document.createElement("span");
    wrap2.className = "cm-placeholder";
    wrap2.style.pointerEvents = "none";
    wrap2.appendChild(typeof this.content == "string" ? document.createTextNode(this.content) : typeof this.content == "function" ? this.content(view) : this.content.cloneNode(true));
    wrap2.setAttribute("aria-hidden", "true");
    return wrap2;
  }
  coordsAt(dom) {
    let rects = dom.firstChild ? clientRectsFor(dom.firstChild) : [];
    if (!rects.length)
      return null;
    let style = window.getComputedStyle(dom.parentNode);
    let rect = flattenRect(rects[0], style.direction != "rtl");
    let lineHeight = parseInt(style.lineHeight);
    if (rect.bottom - rect.top > lineHeight * 1.5)
      return { left: rect.left, right: rect.right, top: rect.top, bottom: rect.top + lineHeight };
    return rect;
  }
  ignoreEvent() {
    return false;
  }
}
function placeholder(content2) {
  let plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.placeholder = content2 ? Decoration.set([Decoration.widget({ widget: new Placeholder(content2), side: 1 }).range(0)]) : Decoration.none;
    }
    get decorations() {
      return this.view.state.doc.length ? Decoration.none : this.placeholder;
    }
  }, { decorations: (v2) => v2.decorations });
  return typeof content2 == "string" ? [
    plugin,
    EditorView.contentAttributes.of({ "aria-placeholder": content2 })
  ] : plugin;
}
const MaxOff = 2e3;
function rectangleFor(state, a2, b2) {
  let startLine = Math.min(a2.line, b2.line), endLine = Math.max(a2.line, b2.line);
  let ranges = [];
  if (a2.off > MaxOff || b2.off > MaxOff || a2.col < 0 || b2.col < 0) {
    let startOff = Math.min(a2.off, b2.off), endOff = Math.max(a2.off, b2.off);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line2 = state.doc.line(i2);
      if (line2.length <= endOff)
        ranges.push(EditorSelection.range(line2.from + startOff, line2.to + endOff));
    }
  } else {
    let startCol = Math.min(a2.col, b2.col), endCol = Math.max(a2.col, b2.col);
    for (let i2 = startLine; i2 <= endLine; i2++) {
      let line2 = state.doc.line(i2);
      let start = findColumn(line2.text, startCol, state.tabSize, true);
      if (start < 0) {
        ranges.push(EditorSelection.cursor(line2.to));
      } else {
        let end = findColumn(line2.text, endCol, state.tabSize);
        ranges.push(EditorSelection.range(line2.from + start, line2.from + end));
      }
    }
  }
  return ranges;
}
function absoluteColumn(view, x2) {
  let ref = view.coordsAtPos(view.viewport.from);
  return ref ? Math.round(Math.abs((ref.left - x2) / view.defaultCharacterWidth)) : -1;
}
function getPos(view, event) {
  let offset2 = view.posAtCoords({ x: event.clientX, y: event.clientY }, false);
  let line2 = view.state.doc.lineAt(offset2), off = offset2 - line2.from;
  let col = off > MaxOff ? -1 : off == line2.length ? absoluteColumn(view, event.clientX) : countColumn(line2.text, view.state.tabSize, offset2 - line2.from);
  return { line: line2.number, col, off };
}
function rectangleSelectionStyle(view, event) {
  let start = getPos(view, event), startSel = view.state.selection;
  if (!start)
    return null;
  return {
    update(update) {
      if (update.docChanged) {
        let newStart = update.changes.mapPos(update.startState.doc.line(start.line).from);
        let newLine = update.state.doc.lineAt(newStart);
        start = { line: newLine.number, col: start.col, off: Math.min(start.off, newLine.length) };
        startSel = startSel.map(update.changes);
      }
    },
    get(event2, _extend, multiple) {
      let cur2 = getPos(view, event2);
      if (!cur2)
        return startSel;
      let ranges = rectangleFor(view.state, start, cur2);
      if (!ranges.length)
        return startSel;
      if (multiple)
        return EditorSelection.create(ranges.concat(startSel.ranges));
      else
        return EditorSelection.create(ranges);
    }
  };
}
function rectangularSelection(options2) {
  let filter2 = ((e2) => e2.altKey && e2.button == 0);
  return EditorView.mouseSelectionStyle.of((view, event) => filter2(event) ? rectangleSelectionStyle(view, event) : null);
}
const keys$1 = {
  Alt: [18, (e2) => !!e2.altKey],
  Control: [17, (e2) => !!e2.ctrlKey],
  Shift: [16, (e2) => !!e2.shiftKey],
  Meta: [91, (e2) => !!e2.metaKey]
};
const showCrosshair = { style: "cursor: crosshair" };
function crosshairCursor(options2 = {}) {
  let [code2, getter] = keys$1[options2.key || "Alt"];
  let plugin = ViewPlugin.fromClass(class {
    constructor(view) {
      this.view = view;
      this.isDown = false;
    }
    set(isDown) {
      if (this.isDown != isDown) {
        this.isDown = isDown;
        this.view.update([]);
      }
    }
  }, {
    eventObservers: {
      keydown(e2) {
        this.set(e2.keyCode == code2 || getter(e2));
      },
      keyup(e2) {
        if (e2.keyCode == code2 || !getter(e2))
          this.set(false);
      },
      mousemove(e2) {
        this.set(getter(e2));
      }
    }
  });
  return [
    plugin,
    EditorView.contentAttributes.of((view) => {
      var _a2;
      return ((_a2 = view.plugin(plugin)) === null || _a2 === void 0 ? void 0 : _a2.isDown) ? showCrosshair : null;
    })
  ];
}
const Outside = "-10000px";
class TooltipViewManager {
  constructor(view, facet, createTooltipView, removeTooltipView) {
    this.facet = facet;
    this.createTooltipView = createTooltipView;
    this.removeTooltipView = removeTooltipView;
    this.input = view.state.facet(facet);
    this.tooltips = this.input.filter((t4) => t4);
    let prev = null;
    this.tooltipViews = this.tooltips.map((t4) => prev = createTooltipView(t4, prev));
  }
  update(update, above) {
    var _a2;
    let input = update.state.facet(this.facet);
    let tooltips = input.filter((x2) => x2);
    if (input === this.input) {
      for (let t4 of this.tooltipViews)
        if (t4.update)
          t4.update(update);
      return false;
    }
    let tooltipViews = [], newAbove = above ? [] : null;
    for (let i2 = 0; i2 < tooltips.length; i2++) {
      let tip = tooltips[i2], known = -1;
      if (!tip)
        continue;
      for (let i3 = 0; i3 < this.tooltips.length; i3++) {
        let other = this.tooltips[i3];
        if (other && other.create == tip.create)
          known = i3;
      }
      if (known < 0) {
        tooltipViews[i2] = this.createTooltipView(tip, i2 ? tooltipViews[i2 - 1] : null);
        if (newAbove)
          newAbove[i2] = !!tip.above;
      } else {
        let tooltipView = tooltipViews[i2] = this.tooltipViews[known];
        if (newAbove)
          newAbove[i2] = above[known];
        if (tooltipView.update)
          tooltipView.update(update);
      }
    }
    for (let t4 of this.tooltipViews)
      if (tooltipViews.indexOf(t4) < 0) {
        this.removeTooltipView(t4);
        (_a2 = t4.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t4);
      }
    if (above) {
      newAbove.forEach((val, i2) => above[i2] = val);
      above.length = newAbove.length;
    }
    this.input = input;
    this.tooltips = tooltips;
    this.tooltipViews = tooltipViews;
    return true;
  }
}
function windowSpace(view) {
  let docElt = view.dom.ownerDocument.documentElement;
  return { top: 0, left: 0, bottom: docElt.clientHeight, right: docElt.clientWidth };
}
const tooltipConfig = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    var _a2, _b, _c;
    return {
      position: browser$3.ios ? "absolute" : ((_a2 = values2.find((conf) => conf.position)) === null || _a2 === void 0 ? void 0 : _a2.position) || "fixed",
      parent: ((_b = values2.find((conf) => conf.parent)) === null || _b === void 0 ? void 0 : _b.parent) || null,
      tooltipSpace: ((_c = values2.find((conf) => conf.tooltipSpace)) === null || _c === void 0 ? void 0 : _c.tooltipSpace) || windowSpace
    };
  }
});
const knownHeight = /* @__PURE__ */ new WeakMap();
const tooltipPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.above = [];
    this.inView = true;
    this.madeAbsolute = false;
    this.lastTransaction = 0;
    this.measureTimeout = -1;
    let config2 = view.state.facet(tooltipConfig);
    this.position = config2.position;
    this.parent = config2.parent;
    this.classes = view.themeClasses;
    this.createContainer();
    this.measureReq = { read: this.readMeasure.bind(this), write: this.writeMeasure.bind(this), key: this };
    this.resizeObserver = typeof ResizeObserver == "function" ? new ResizeObserver(() => this.measureSoon()) : null;
    this.manager = new TooltipViewManager(view, showTooltip, (t4, p2) => this.createTooltip(t4, p2), (t4) => {
      if (this.resizeObserver)
        this.resizeObserver.unobserve(t4.dom);
      t4.dom.remove();
    });
    this.above = this.manager.tooltips.map((t4) => !!t4.above);
    this.intersectionObserver = typeof IntersectionObserver == "function" ? new IntersectionObserver((entries) => {
      if (Date.now() > this.lastTransaction - 50 && entries.length > 0 && entries[entries.length - 1].intersectionRatio < 1)
        this.measureSoon();
    }, { threshold: [1] }) : null;
    this.observeIntersection();
    view.win.addEventListener("resize", this.measureSoon = this.measureSoon.bind(this));
    this.maybeMeasure();
  }
  createContainer() {
    if (this.parent) {
      this.container = document.createElement("div");
      this.container.style.position = "relative";
      this.container.className = this.view.themeClasses;
      this.parent.appendChild(this.container);
    } else {
      this.container = this.view.dom;
    }
  }
  observeIntersection() {
    if (this.intersectionObserver) {
      this.intersectionObserver.disconnect();
      for (let tooltip of this.manager.tooltipViews)
        this.intersectionObserver.observe(tooltip.dom);
    }
  }
  measureSoon() {
    if (this.measureTimeout < 0)
      this.measureTimeout = setTimeout(() => {
        this.measureTimeout = -1;
        this.maybeMeasure();
      }, 50);
  }
  update(update) {
    if (update.transactions.length)
      this.lastTransaction = Date.now();
    let updated = this.manager.update(update, this.above);
    if (updated)
      this.observeIntersection();
    let shouldMeasure = updated || update.geometryChanged;
    let newConfig = update.state.facet(tooltipConfig);
    if (newConfig.position != this.position && !this.madeAbsolute) {
      this.position = newConfig.position;
      for (let t4 of this.manager.tooltipViews)
        t4.dom.style.position = this.position;
      shouldMeasure = true;
    }
    if (newConfig.parent != this.parent) {
      if (this.parent)
        this.container.remove();
      this.parent = newConfig.parent;
      this.createContainer();
      for (let t4 of this.manager.tooltipViews)
        this.container.appendChild(t4.dom);
      shouldMeasure = true;
    } else if (this.parent && this.view.themeClasses != this.classes) {
      this.classes = this.container.className = this.view.themeClasses;
    }
    if (shouldMeasure)
      this.maybeMeasure();
  }
  createTooltip(tooltip, prev) {
    let tooltipView = tooltip.create(this.view);
    let before2 = prev ? prev.dom : null;
    tooltipView.dom.classList.add("cm-tooltip");
    if (tooltip.arrow && !tooltipView.dom.querySelector(".cm-tooltip > .cm-tooltip-arrow")) {
      let arrow2 = document.createElement("div");
      arrow2.className = "cm-tooltip-arrow";
      tooltipView.dom.appendChild(arrow2);
    }
    tooltipView.dom.style.position = this.position;
    tooltipView.dom.style.top = Outside;
    tooltipView.dom.style.left = "0px";
    this.container.insertBefore(tooltipView.dom, before2);
    if (tooltipView.mount)
      tooltipView.mount(this.view);
    if (this.resizeObserver)
      this.resizeObserver.observe(tooltipView.dom);
    return tooltipView;
  }
  destroy() {
    var _a2, _b, _c;
    this.view.win.removeEventListener("resize", this.measureSoon);
    for (let tooltipView of this.manager.tooltipViews) {
      tooltipView.dom.remove();
      (_a2 = tooltipView.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(tooltipView);
    }
    if (this.parent)
      this.container.remove();
    (_b = this.resizeObserver) === null || _b === void 0 ? void 0 : _b.disconnect();
    (_c = this.intersectionObserver) === null || _c === void 0 ? void 0 : _c.disconnect();
    clearTimeout(this.measureTimeout);
  }
  readMeasure() {
    let scaleX = 1, scaleY = 1, makeAbsolute = false;
    if (this.position == "fixed" && this.manager.tooltipViews.length) {
      let { dom } = this.manager.tooltipViews[0];
      if (browser$3.safari) {
        let rect = dom.getBoundingClientRect();
        makeAbsolute = Math.abs(rect.top + 1e4) > 1 || Math.abs(rect.left) > 1;
      } else {
        makeAbsolute = !!dom.offsetParent && dom.offsetParent != this.container.ownerDocument.body;
      }
    }
    if (makeAbsolute || this.position == "absolute") {
      if (this.parent) {
        let rect = this.parent.getBoundingClientRect();
        if (rect.width && rect.height) {
          scaleX = rect.width / this.parent.offsetWidth;
          scaleY = rect.height / this.parent.offsetHeight;
        }
      } else {
        ({ scaleX, scaleY } = this.view.viewState);
      }
    }
    let visible = this.view.scrollDOM.getBoundingClientRect(), margins = getScrollMargins(this.view);
    return {
      visible: {
        left: visible.left + margins.left,
        top: visible.top + margins.top,
        right: visible.right - margins.right,
        bottom: visible.bottom - margins.bottom
      },
      parent: this.parent ? this.container.getBoundingClientRect() : this.view.dom.getBoundingClientRect(),
      pos: this.manager.tooltips.map((t4, i2) => {
        let tv = this.manager.tooltipViews[i2];
        return tv.getCoords ? tv.getCoords(t4.pos) : this.view.coordsAtPos(t4.pos);
      }),
      size: this.manager.tooltipViews.map(({ dom }) => dom.getBoundingClientRect()),
      space: this.view.state.facet(tooltipConfig).tooltipSpace(this.view),
      scaleX,
      scaleY,
      makeAbsolute
    };
  }
  writeMeasure(measured) {
    var _a2;
    if (measured.makeAbsolute) {
      this.madeAbsolute = true;
      this.position = "absolute";
      for (let t4 of this.manager.tooltipViews)
        t4.dom.style.position = "absolute";
    }
    let { visible, space, scaleX, scaleY } = measured;
    let others = [];
    for (let i2 = 0; i2 < this.manager.tooltips.length; i2++) {
      let tooltip = this.manager.tooltips[i2], tView = this.manager.tooltipViews[i2], { dom } = tView;
      let pos = measured.pos[i2], size2 = measured.size[i2];
      if (!pos || tooltip.clip !== false && (pos.bottom <= Math.max(visible.top, space.top) || pos.top >= Math.min(visible.bottom, space.bottom) || pos.right < Math.max(visible.left, space.left) - 0.1 || pos.left > Math.min(visible.right, space.right) + 0.1)) {
        dom.style.top = Outside;
        continue;
      }
      let arrow2 = tooltip.arrow ? tView.dom.querySelector(".cm-tooltip-arrow") : null;
      let arrowHeight = arrow2 ? 7 : 0;
      let width = size2.right - size2.left, height = (_a2 = knownHeight.get(tView)) !== null && _a2 !== void 0 ? _a2 : size2.bottom - size2.top;
      let offset2 = tView.offset || noOffset, ltr = this.view.textDirection == Direction.LTR;
      let left = size2.width > space.right - space.left ? ltr ? space.left : space.right - size2.width : ltr ? Math.max(space.left, Math.min(pos.left - (arrow2 ? 14 : 0) + offset2.x, space.right - width)) : Math.min(Math.max(space.left, pos.left - width + (arrow2 ? 14 : 0) - offset2.x), space.right - width);
      let above = this.above[i2];
      if (!tooltip.strictSide && (above ? pos.top - height - arrowHeight - offset2.y < space.top : pos.bottom + height + arrowHeight + offset2.y > space.bottom) && above == space.bottom - pos.bottom > pos.top - space.top)
        above = this.above[i2] = !above;
      let spaceVert = (above ? pos.top - space.top : space.bottom - pos.bottom) - arrowHeight;
      if (spaceVert < height && tView.resize !== false) {
        if (spaceVert < this.view.defaultLineHeight) {
          dom.style.top = Outside;
          continue;
        }
        knownHeight.set(tView, height);
        dom.style.height = (height = spaceVert) / scaleY + "px";
      } else if (dom.style.height) {
        dom.style.height = "";
      }
      let top2 = above ? pos.top - height - arrowHeight - offset2.y : pos.bottom + arrowHeight + offset2.y;
      let right = left + width;
      if (tView.overlap !== true) {
        for (let r2 of others)
          if (r2.left < right && r2.right > left && r2.top < top2 + height && r2.bottom > top2)
            top2 = above ? r2.top - height - 2 - arrowHeight : r2.bottom + arrowHeight + 2;
      }
      if (this.position == "absolute") {
        dom.style.top = (top2 - measured.parent.top) / scaleY + "px";
        setLeftStyle(dom, (left - measured.parent.left) / scaleX);
      } else {
        dom.style.top = top2 / scaleY + "px";
        setLeftStyle(dom, left / scaleX);
      }
      if (arrow2) {
        let arrowLeft = pos.left + (ltr ? offset2.x : -offset2.x) - (left + 14 - 7);
        arrow2.style.left = arrowLeft / scaleX + "px";
      }
      if (tView.overlap !== true)
        others.push({ left, top: top2, right, bottom: top2 + height });
      dom.classList.toggle("cm-tooltip-above", above);
      dom.classList.toggle("cm-tooltip-below", !above);
      if (tView.positioned)
        tView.positioned(measured.space);
    }
  }
  maybeMeasure() {
    if (this.manager.tooltips.length) {
      if (this.view.inView)
        this.view.requestMeasure(this.measureReq);
      if (this.inView != this.view.inView) {
        this.inView = this.view.inView;
        if (!this.inView)
          for (let tv of this.manager.tooltipViews)
            tv.dom.style.top = Outside;
      }
    }
  }
}, {
  eventObservers: {
    scroll() {
      this.maybeMeasure();
    }
  }
});
function setLeftStyle(elt, value) {
  let current2 = parseInt(elt.style.left, 10);
  if (isNaN(current2) || Math.abs(value - current2) > 1)
    elt.style.left = value + "px";
}
const baseTheme$5 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip": {
    zIndex: 500,
    boxSizing: "border-box"
  },
  "&light .cm-tooltip": {
    border: "1px solid #bbb",
    backgroundColor: "#f5f5f5"
  },
  "&light .cm-tooltip-section:not(:first-child)": {
    borderTop: "1px solid #bbb"
  },
  "&dark .cm-tooltip": {
    backgroundColor: "#333338",
    color: "white"
  },
  ".cm-tooltip-arrow": {
    height: `${7}px`,
    width: `${7 * 2}px`,
    position: "absolute",
    zIndex: -1,
    overflow: "hidden",
    "&:before, &:after": {
      content: "''",
      position: "absolute",
      width: 0,
      height: 0,
      borderLeft: `${7}px solid transparent`,
      borderRight: `${7}px solid transparent`
    },
    ".cm-tooltip-above &": {
      bottom: `-${7}px`,
      "&:before": {
        borderTop: `${7}px solid #bbb`
      },
      "&:after": {
        borderTop: `${7}px solid #f5f5f5`,
        bottom: "1px"
      }
    },
    ".cm-tooltip-below &": {
      top: `-${7}px`,
      "&:before": {
        borderBottom: `${7}px solid #bbb`
      },
      "&:after": {
        borderBottom: `${7}px solid #f5f5f5`,
        top: "1px"
      }
    }
  },
  "&dark .cm-tooltip .cm-tooltip-arrow": {
    "&:before": {
      borderTopColor: "#333338",
      borderBottomColor: "#333338"
    },
    "&:after": {
      borderTopColor: "transparent",
      borderBottomColor: "transparent"
    }
  }
});
const noOffset = { x: 0, y: 0 };
const showTooltip = /* @__PURE__ */ Facet.define({
  enables: [tooltipPlugin, baseTheme$5]
});
const showHoverTooltip = /* @__PURE__ */ Facet.define({
  combine: (inputs) => inputs.reduce((a2, i2) => a2.concat(i2), [])
});
class HoverTooltipHost {
  // Needs to be static so that host tooltip instances always match
  static create(view) {
    return new HoverTooltipHost(view);
  }
  constructor(view) {
    this.view = view;
    this.mounted = false;
    this.dom = document.createElement("div");
    this.dom.classList.add("cm-tooltip-hover");
    this.manager = new TooltipViewManager(view, showHoverTooltip, (t4, p2) => this.createHostedView(t4, p2), (t4) => t4.dom.remove());
  }
  createHostedView(tooltip, prev) {
    let hostedView = tooltip.create(this.view);
    hostedView.dom.classList.add("cm-tooltip-section");
    this.dom.insertBefore(hostedView.dom, prev ? prev.dom.nextSibling : this.dom.firstChild);
    if (this.mounted && hostedView.mount)
      hostedView.mount(this.view);
    return hostedView;
  }
  mount(view) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.mount)
        hostedView.mount(view);
    }
    this.mounted = true;
  }
  positioned(space) {
    for (let hostedView of this.manager.tooltipViews) {
      if (hostedView.positioned)
        hostedView.positioned(space);
    }
  }
  update(update) {
    this.manager.update(update);
  }
  destroy() {
    var _a2;
    for (let t4 of this.manager.tooltipViews)
      (_a2 = t4.destroy) === null || _a2 === void 0 ? void 0 : _a2.call(t4);
  }
  passProp(name2) {
    let value = void 0;
    for (let view of this.manager.tooltipViews) {
      let given = view[name2];
      if (given !== void 0) {
        if (value === void 0)
          value = given;
        else if (value !== given)
          return void 0;
      }
    }
    return value;
  }
  get offset() {
    return this.passProp("offset");
  }
  get getCoords() {
    return this.passProp("getCoords");
  }
  get overlap() {
    return this.passProp("overlap");
  }
  get resize() {
    return this.passProp("resize");
  }
}
const showHoverTooltipHost = /* @__PURE__ */ showTooltip.compute([showHoverTooltip], (state) => {
  let tooltips = state.facet(showHoverTooltip);
  if (tooltips.length === 0)
    return null;
  return {
    pos: Math.min(...tooltips.map((t4) => t4.pos)),
    end: Math.max(...tooltips.map((t4) => {
      var _a2;
      return (_a2 = t4.end) !== null && _a2 !== void 0 ? _a2 : t4.pos;
    })),
    create: HoverTooltipHost.create,
    above: tooltips[0].above,
    arrow: tooltips.some((t4) => t4.arrow)
  };
});
class HoverPlugin {
  constructor(view, source, field, setHover, hoverTime) {
    this.view = view;
    this.source = source;
    this.field = field;
    this.setHover = setHover;
    this.hoverTime = hoverTime;
    this.hoverTimeout = -1;
    this.restartTimeout = -1;
    this.pending = null;
    this.lastMove = { x: 0, y: 0, target: view.dom, time: 0 };
    this.checkHover = this.checkHover.bind(this);
    view.dom.addEventListener("mouseleave", this.mouseleave = this.mouseleave.bind(this));
    view.dom.addEventListener("mousemove", this.mousemove = this.mousemove.bind(this));
  }
  update() {
    if (this.pending) {
      this.pending = null;
      clearTimeout(this.restartTimeout);
      this.restartTimeout = setTimeout(() => this.startHover(), 20);
    }
  }
  get active() {
    return this.view.state.field(this.field);
  }
  checkHover() {
    this.hoverTimeout = -1;
    if (this.active.length)
      return;
    let hovered = Date.now() - this.lastMove.time;
    if (hovered < this.hoverTime)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime - hovered);
    else
      this.startHover();
  }
  startHover() {
    clearTimeout(this.restartTimeout);
    let { view, lastMove } = this;
    let desc = view.docView.nearest(lastMove.target);
    if (!desc)
      return;
    let pos, side = 1;
    if (desc instanceof WidgetView) {
      pos = desc.posAtStart;
    } else {
      pos = view.posAtCoords(lastMove);
      if (pos == null)
        return;
      let posCoords = view.coordsAtPos(pos);
      if (!posCoords || lastMove.y < posCoords.top || lastMove.y > posCoords.bottom || lastMove.x < posCoords.left - view.defaultCharacterWidth || lastMove.x > posCoords.right + view.defaultCharacterWidth)
        return;
      let bidi = view.bidiSpans(view.state.doc.lineAt(pos)).find((s2) => s2.from <= pos && s2.to >= pos);
      let rtl = bidi && bidi.dir == Direction.RTL ? -1 : 1;
      side = lastMove.x < posCoords.left ? -rtl : rtl;
    }
    let open = this.source(view, pos, side);
    if (open === null || open === void 0 ? void 0 : open.then) {
      let pending = this.pending = { pos };
      open.then((result2) => {
        if (this.pending == pending) {
          this.pending = null;
          if (result2 && !(Array.isArray(result2) && !result2.length))
            view.dispatch({ effects: this.setHover.of(Array.isArray(result2) ? result2 : [result2]) });
        }
      }, (e2) => logException(view.state, e2, "hover tooltip"));
    } else if (open && !(Array.isArray(open) && !open.length)) {
      view.dispatch({ effects: this.setHover.of(Array.isArray(open) ? open : [open]) });
    }
  }
  get tooltip() {
    let plugin = this.view.plugin(tooltipPlugin);
    let index2 = plugin ? plugin.manager.tooltips.findIndex((t4) => t4.create == HoverTooltipHost.create) : -1;
    return index2 > -1 ? plugin.manager.tooltipViews[index2] : null;
  }
  mousemove(event) {
    var _a2, _b;
    this.lastMove = { x: event.clientX, y: event.clientY, target: event.target, time: Date.now() };
    if (this.hoverTimeout < 0)
      this.hoverTimeout = setTimeout(this.checkHover, this.hoverTime);
    let { active, tooltip } = this;
    if (active.length && tooltip && !isInTooltip(tooltip.dom, event) || this.pending) {
      let { pos } = active[0] || this.pending, end = (_b = (_a2 = active[0]) === null || _a2 === void 0 ? void 0 : _a2.end) !== null && _b !== void 0 ? _b : pos;
      if (pos == end ? this.view.posAtCoords(this.lastMove) != pos : !isOverRange(this.view, pos, end, event.clientX, event.clientY)) {
        this.view.dispatch({ effects: this.setHover.of([]) });
        this.pending = null;
      }
    }
  }
  mouseleave(event) {
    clearTimeout(this.hoverTimeout);
    this.hoverTimeout = -1;
    let { active } = this;
    if (active.length) {
      let { tooltip } = this;
      let inTooltip = tooltip && tooltip.dom.contains(event.relatedTarget);
      if (!inTooltip)
        this.view.dispatch({ effects: this.setHover.of([]) });
      else
        this.watchTooltipLeave(tooltip.dom);
    }
  }
  watchTooltipLeave(tooltip) {
    let watch = (event) => {
      tooltip.removeEventListener("mouseleave", watch);
      if (this.active.length && !this.view.dom.contains(event.relatedTarget))
        this.view.dispatch({ effects: this.setHover.of([]) });
    };
    tooltip.addEventListener("mouseleave", watch);
  }
  destroy() {
    clearTimeout(this.hoverTimeout);
    this.view.dom.removeEventListener("mouseleave", this.mouseleave);
    this.view.dom.removeEventListener("mousemove", this.mousemove);
  }
}
const tooltipMargin = 4;
function isInTooltip(tooltip, event) {
  let { left, right, top: top2, bottom } = tooltip.getBoundingClientRect(), arrow2;
  if (arrow2 = tooltip.querySelector(".cm-tooltip-arrow")) {
    let arrowRect = arrow2.getBoundingClientRect();
    top2 = Math.min(arrowRect.top, top2);
    bottom = Math.max(arrowRect.bottom, bottom);
  }
  return event.clientX >= left - tooltipMargin && event.clientX <= right + tooltipMargin && event.clientY >= top2 - tooltipMargin && event.clientY <= bottom + tooltipMargin;
}
function isOverRange(view, from, to2, x2, y2, margin) {
  let rect = view.scrollDOM.getBoundingClientRect();
  let docBottom = view.documentTop + view.documentPadding.top + view.contentHeight;
  if (rect.left > x2 || rect.right < x2 || rect.top > y2 || Math.min(rect.bottom, docBottom) < y2)
    return false;
  let pos = view.posAtCoords({ x: x2, y: y2 }, false);
  return pos >= from && pos <= to2;
}
function hoverTooltip(source, options2 = {}) {
  let setHover = StateEffect.define();
  let hoverState = StateField.define({
    create() {
      return [];
    },
    update(value, tr2) {
      if (value.length) {
        if (options2.hideOnChange && (tr2.docChanged || tr2.selection))
          value = [];
        else if (options2.hideOn)
          value = value.filter((v2) => !options2.hideOn(tr2, v2));
        if (tr2.docChanged) {
          let mapped = [];
          for (let tooltip of value) {
            let newPos = tr2.changes.mapPos(tooltip.pos, -1, MapMode.TrackDel);
            if (newPos != null) {
              let copy2 = Object.assign(/* @__PURE__ */ Object.create(null), tooltip);
              copy2.pos = newPos;
              if (copy2.end != null)
                copy2.end = tr2.changes.mapPos(copy2.end);
              mapped.push(copy2);
            }
          }
          value = mapped;
        }
      }
      for (let effect of tr2.effects) {
        if (effect.is(setHover))
          value = effect.value;
        if (effect.is(closeHoverTooltipEffect))
          value = [];
      }
      return value;
    },
    provide: (f2) => showHoverTooltip.from(f2)
  });
  return {
    active: hoverState,
    extension: [
      hoverState,
      ViewPlugin.define((view) => new HoverPlugin(
        view,
        source,
        hoverState,
        setHover,
        options2.hoverTime || 300
        /* Hover.Time */
      )),
      showHoverTooltipHost
    ]
  };
}
function getTooltip(view, tooltip) {
  let plugin = view.plugin(tooltipPlugin);
  if (!plugin)
    return null;
  let found = plugin.manager.tooltips.indexOf(tooltip);
  return found < 0 ? null : plugin.manager.tooltipViews[found];
}
const closeHoverTooltipEffect = /* @__PURE__ */ StateEffect.define();
const panelConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    let topContainer, bottomContainer;
    for (let c2 of configs) {
      topContainer = topContainer || c2.topContainer;
      bottomContainer = bottomContainer || c2.bottomContainer;
    }
    return { topContainer, bottomContainer };
  }
});
function getPanel(view, panel) {
  let plugin = view.plugin(panelPlugin);
  let index2 = plugin ? plugin.specs.indexOf(panel) : -1;
  return index2 > -1 ? plugin.panels[index2] : null;
}
const panelPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.input = view.state.facet(showPanel);
    this.specs = this.input.filter((s2) => s2);
    this.panels = this.specs.map((spec) => spec(view));
    let conf = view.state.facet(panelConfig);
    this.top = new PanelGroup(view, true, conf.topContainer);
    this.bottom = new PanelGroup(view, false, conf.bottomContainer);
    this.top.sync(this.panels.filter((p2) => p2.top));
    this.bottom.sync(this.panels.filter((p2) => !p2.top));
    for (let p2 of this.panels) {
      p2.dom.classList.add("cm-panel");
      if (p2.mount)
        p2.mount();
    }
  }
  update(update) {
    let conf = update.state.facet(panelConfig);
    if (this.top.container != conf.topContainer) {
      this.top.sync([]);
      this.top = new PanelGroup(update.view, true, conf.topContainer);
    }
    if (this.bottom.container != conf.bottomContainer) {
      this.bottom.sync([]);
      this.bottom = new PanelGroup(update.view, false, conf.bottomContainer);
    }
    this.top.syncClasses();
    this.bottom.syncClasses();
    let input = update.state.facet(showPanel);
    if (input != this.input) {
      let specs = input.filter((x2) => x2);
      let panels = [], top2 = [], bottom = [], mount = [];
      for (let spec of specs) {
        let known = this.specs.indexOf(spec), panel;
        if (known < 0) {
          panel = spec(update.view);
          mount.push(panel);
        } else {
          panel = this.panels[known];
          if (panel.update)
            panel.update(update);
        }
        panels.push(panel);
        (panel.top ? top2 : bottom).push(panel);
      }
      this.specs = specs;
      this.panels = panels;
      this.top.sync(top2);
      this.bottom.sync(bottom);
      for (let p2 of mount) {
        p2.dom.classList.add("cm-panel");
        if (p2.mount)
          p2.mount();
      }
    } else {
      for (let p2 of this.panels)
        if (p2.update)
          p2.update(update);
    }
  }
  destroy() {
    this.top.sync([]);
    this.bottom.sync([]);
  }
}, {
  provide: (plugin) => EditorView.scrollMargins.of((view) => {
    let value = view.plugin(plugin);
    return value && { top: value.top.scrollMargin(), bottom: value.bottom.scrollMargin() };
  })
});
class PanelGroup {
  constructor(view, top2, container) {
    this.view = view;
    this.top = top2;
    this.container = container;
    this.dom = void 0;
    this.classes = "";
    this.panels = [];
    this.syncClasses();
  }
  sync(panels) {
    for (let p2 of this.panels)
      if (p2.destroy && panels.indexOf(p2) < 0)
        p2.destroy();
    this.panels = panels;
    this.syncDOM();
  }
  syncDOM() {
    if (this.panels.length == 0) {
      if (this.dom) {
        this.dom.remove();
        this.dom = void 0;
      }
      return;
    }
    if (!this.dom) {
      this.dom = document.createElement("div");
      this.dom.className = this.top ? "cm-panels cm-panels-top" : "cm-panels cm-panels-bottom";
      this.dom.style[this.top ? "top" : "bottom"] = "0";
      let parent = this.container || this.view.dom;
      parent.insertBefore(this.dom, this.top ? parent.firstChild : null);
    }
    let curDOM = this.dom.firstChild;
    for (let panel of this.panels) {
      if (panel.dom.parentNode == this.dom) {
        while (curDOM != panel.dom)
          curDOM = rm(curDOM);
        curDOM = curDOM.nextSibling;
      } else {
        this.dom.insertBefore(panel.dom, curDOM);
      }
    }
    while (curDOM)
      curDOM = rm(curDOM);
  }
  scrollMargin() {
    return !this.dom || this.container ? 0 : Math.max(0, this.top ? this.dom.getBoundingClientRect().bottom - Math.max(0, this.view.scrollDOM.getBoundingClientRect().top) : Math.min(innerHeight, this.view.scrollDOM.getBoundingClientRect().bottom) - this.dom.getBoundingClientRect().top);
  }
  syncClasses() {
    if (!this.container || this.classes == this.view.themeClasses)
      return;
    for (let cls of this.classes.split(" "))
      if (cls)
        this.container.classList.remove(cls);
    for (let cls of (this.classes = this.view.themeClasses).split(" "))
      if (cls)
        this.container.classList.add(cls);
  }
}
function rm(node) {
  let next = node.nextSibling;
  node.remove();
  return next;
}
const showPanel = /* @__PURE__ */ Facet.define({
  enables: panelPlugin
});
class GutterMarker extends RangeValue {
  /**
  @internal
  */
  compare(other) {
    return this == other || this.constructor == other.constructor && this.eq(other);
  }
  /**
  Compare this marker to another marker of the same type.
  */
  eq(other) {
    return false;
  }
  /**
  Called if the marker has a `toDOM` method and its representation
  was removed from a gutter.
  */
  destroy(dom) {
  }
}
GutterMarker.prototype.elementClass = "";
GutterMarker.prototype.toDOM = void 0;
GutterMarker.prototype.mapMode = MapMode.TrackBefore;
GutterMarker.prototype.startSide = GutterMarker.prototype.endSide = -1;
GutterMarker.prototype.point = true;
const gutterLineClass = /* @__PURE__ */ Facet.define();
const gutterWidgetClass = /* @__PURE__ */ Facet.define();
const defaults$1 = {
  class: "",
  renderEmptyElements: false,
  elementStyle: "",
  markers: () => RangeSet.empty,
  lineMarker: () => null,
  widgetMarker: () => null,
  lineMarkerChange: null,
  initialSpacer: null,
  updateSpacer: null,
  domEventHandlers: {},
  side: "before"
};
const activeGutters = /* @__PURE__ */ Facet.define();
function gutter(config2) {
  return [gutters(), activeGutters.of({ ...defaults$1, ...config2 })];
}
const unfixGutters = /* @__PURE__ */ Facet.define({
  combine: (values2) => values2.some((x2) => x2)
});
function gutters(config2) {
  let result2 = [
    gutterView
  ];
  return result2;
}
const gutterView = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.domAfter = null;
    this.prevViewport = view.viewport;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutters cm-gutters-before";
    this.dom.setAttribute("aria-hidden", "true");
    this.dom.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
    this.gutters = view.state.facet(activeGutters).map((conf) => new SingleGutterView(view, conf));
    this.fixed = !view.state.facet(unfixGutters);
    for (let gutter2 of this.gutters) {
      if (gutter2.config.side == "after")
        this.getDOMAfter().appendChild(gutter2.dom);
      else
        this.dom.appendChild(gutter2.dom);
    }
    if (this.fixed) {
      this.dom.style.position = "sticky";
    }
    this.syncGutters(false);
    view.scrollDOM.insertBefore(this.dom, view.contentDOM);
  }
  getDOMAfter() {
    if (!this.domAfter) {
      this.domAfter = document.createElement("div");
      this.domAfter.className = "cm-gutters cm-gutters-after";
      this.domAfter.setAttribute("aria-hidden", "true");
      this.domAfter.style.minHeight = this.view.contentHeight / this.view.scaleY + "px";
      this.domAfter.style.position = this.fixed ? "sticky" : "";
      this.view.scrollDOM.appendChild(this.domAfter);
    }
    return this.domAfter;
  }
  update(update) {
    if (this.updateGutters(update)) {
      let vpA = this.prevViewport, vpB = update.view.viewport;
      let vpOverlap = Math.min(vpA.to, vpB.to) - Math.max(vpA.from, vpB.from);
      this.syncGutters(vpOverlap < (vpB.to - vpB.from) * 0.8);
    }
    if (update.geometryChanged) {
      let min2 = this.view.contentHeight / this.view.scaleY + "px";
      this.dom.style.minHeight = min2;
      if (this.domAfter)
        this.domAfter.style.minHeight = min2;
    }
    if (this.view.state.facet(unfixGutters) != !this.fixed) {
      this.fixed = !this.fixed;
      this.dom.style.position = this.fixed ? "sticky" : "";
      if (this.domAfter)
        this.domAfter.style.position = this.fixed ? "sticky" : "";
    }
    this.prevViewport = update.view.viewport;
  }
  syncGutters(detach) {
    let after2 = this.dom.nextSibling;
    if (detach) {
      this.dom.remove();
      if (this.domAfter)
        this.domAfter.remove();
    }
    let lineClasses = RangeSet.iter(this.view.state.facet(gutterLineClass), this.view.viewport.from);
    let classSet = [];
    let contexts = this.gutters.map((gutter2) => new UpdateContext(gutter2, this.view.viewport, -this.view.documentPadding.top));
    for (let line2 of this.view.viewportLineBlocks) {
      if (classSet.length)
        classSet = [];
      if (Array.isArray(line2.type)) {
        let first2 = true;
        for (let b2 of line2.type) {
          if (b2.type == BlockType.Text && first2) {
            advanceCursor(lineClasses, classSet, b2.from);
            for (let cx of contexts)
              cx.line(this.view, b2, classSet);
            first2 = false;
          } else if (b2.widget) {
            for (let cx of contexts)
              cx.widget(this.view, b2);
          }
        }
      } else if (line2.type == BlockType.Text) {
        advanceCursor(lineClasses, classSet, line2.from);
        for (let cx of contexts)
          cx.line(this.view, line2, classSet);
      } else if (line2.widget) {
        for (let cx of contexts)
          cx.widget(this.view, line2);
      }
    }
    for (let cx of contexts)
      cx.finish();
    if (detach) {
      this.view.scrollDOM.insertBefore(this.dom, after2);
      if (this.domAfter)
        this.view.scrollDOM.appendChild(this.domAfter);
    }
  }
  updateGutters(update) {
    let prev = update.startState.facet(activeGutters), cur2 = update.state.facet(activeGutters);
    let change = update.docChanged || update.heightChanged || update.viewportChanged || !RangeSet.eq(update.startState.facet(gutterLineClass), update.state.facet(gutterLineClass), update.view.viewport.from, update.view.viewport.to);
    if (prev == cur2) {
      for (let gutter2 of this.gutters)
        if (gutter2.update(update))
          change = true;
    } else {
      change = true;
      let gutters2 = [];
      for (let conf of cur2) {
        let known = prev.indexOf(conf);
        if (known < 0) {
          gutters2.push(new SingleGutterView(this.view, conf));
        } else {
          this.gutters[known].update(update);
          gutters2.push(this.gutters[known]);
        }
      }
      for (let g2 of this.gutters) {
        g2.dom.remove();
        if (gutters2.indexOf(g2) < 0)
          g2.destroy();
      }
      for (let g2 of gutters2) {
        if (g2.config.side == "after")
          this.getDOMAfter().appendChild(g2.dom);
        else
          this.dom.appendChild(g2.dom);
      }
      this.gutters = gutters2;
    }
    return change;
  }
  destroy() {
    for (let view of this.gutters)
      view.destroy();
    this.dom.remove();
    if (this.domAfter)
      this.domAfter.remove();
  }
}, {
  provide: (plugin) => EditorView.scrollMargins.of((view) => {
    let value = view.plugin(plugin);
    if (!value || value.gutters.length == 0 || !value.fixed)
      return null;
    let before2 = value.dom.offsetWidth * view.scaleX, after2 = value.domAfter ? value.domAfter.offsetWidth * view.scaleX : 0;
    return view.textDirection == Direction.LTR ? { left: before2, right: after2 } : { right: before2, left: after2 };
  })
});
function asArray(val) {
  return Array.isArray(val) ? val : [val];
}
function advanceCursor(cursor2, collect, pos) {
  while (cursor2.value && cursor2.from <= pos) {
    if (cursor2.from == pos)
      collect.push(cursor2.value);
    cursor2.next();
  }
}
class UpdateContext {
  constructor(gutter2, viewport, height) {
    this.gutter = gutter2;
    this.height = height;
    this.i = 0;
    this.cursor = RangeSet.iter(gutter2.markers, viewport.from);
  }
  addElement(view, block, markers) {
    let { gutter: gutter2 } = this, above = (block.top - this.height) / view.scaleY, height = block.height / view.scaleY;
    if (this.i == gutter2.elements.length) {
      let newElt = new GutterElement(view, height, above, markers);
      gutter2.elements.push(newElt);
      gutter2.dom.appendChild(newElt.dom);
    } else {
      gutter2.elements[this.i].update(view, height, above, markers);
    }
    this.height = block.bottom;
    this.i++;
  }
  line(view, line2, extraMarkers) {
    let localMarkers = [];
    advanceCursor(this.cursor, localMarkers, line2.from);
    if (extraMarkers.length)
      localMarkers = localMarkers.concat(extraMarkers);
    let forLine = this.gutter.config.lineMarker(view, line2, localMarkers);
    if (forLine)
      localMarkers.unshift(forLine);
    let gutter2 = this.gutter;
    if (localMarkers.length == 0 && !gutter2.config.renderEmptyElements)
      return;
    this.addElement(view, line2, localMarkers);
  }
  widget(view, block) {
    let marker = this.gutter.config.widgetMarker(view, block.widget, block), markers = marker ? [marker] : null;
    for (let cls of view.state.facet(gutterWidgetClass)) {
      let marker2 = cls(view, block.widget, block);
      if (marker2)
        (markers || (markers = [])).push(marker2);
    }
    if (markers)
      this.addElement(view, block, markers);
  }
  finish() {
    let gutter2 = this.gutter;
    while (gutter2.elements.length > this.i) {
      let last2 = gutter2.elements.pop();
      gutter2.dom.removeChild(last2.dom);
      last2.destroy();
    }
  }
}
class SingleGutterView {
  constructor(view, config2) {
    this.view = view;
    this.config = config2;
    this.elements = [];
    this.spacer = null;
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutter" + (this.config.class ? " " + this.config.class : "");
    for (let prop in config2.domEventHandlers) {
      this.dom.addEventListener(prop, (event) => {
        let target = event.target, y2;
        if (target != this.dom && this.dom.contains(target)) {
          while (target.parentNode != this.dom)
            target = target.parentNode;
          let rect = target.getBoundingClientRect();
          y2 = (rect.top + rect.bottom) / 2;
        } else {
          y2 = event.clientY;
        }
        let line2 = view.lineBlockAtHeight(y2 - view.documentTop);
        if (config2.domEventHandlers[prop](view, line2, event))
          event.preventDefault();
      });
    }
    this.markers = asArray(config2.markers(view));
    if (config2.initialSpacer) {
      this.spacer = new GutterElement(view, 0, 0, [config2.initialSpacer(view)]);
      this.dom.appendChild(this.spacer.dom);
      this.spacer.dom.style.cssText += "visibility: hidden; pointer-events: none";
    }
  }
  update(update) {
    let prevMarkers = this.markers;
    this.markers = asArray(this.config.markers(update.view));
    if (this.spacer && this.config.updateSpacer) {
      let updated = this.config.updateSpacer(this.spacer.markers[0], update);
      if (updated != this.spacer.markers[0])
        this.spacer.update(update.view, 0, 0, [updated]);
    }
    let vp = update.view.viewport;
    return !RangeSet.eq(this.markers, prevMarkers, vp.from, vp.to) || (this.config.lineMarkerChange ? this.config.lineMarkerChange(update) : false);
  }
  destroy() {
    for (let elt of this.elements)
      elt.destroy();
  }
}
class GutterElement {
  constructor(view, height, above, markers) {
    this.height = -1;
    this.above = 0;
    this.markers = [];
    this.dom = document.createElement("div");
    this.dom.className = "cm-gutterElement";
    this.update(view, height, above, markers);
  }
  update(view, height, above, markers) {
    if (this.height != height) {
      this.height = height;
      this.dom.style.height = height + "px";
    }
    if (this.above != above)
      this.dom.style.marginTop = (this.above = above) ? above + "px" : "";
    if (!sameMarkers(this.markers, markers))
      this.setMarkers(view, markers);
  }
  setMarkers(view, markers) {
    let cls = "cm-gutterElement", domPos = this.dom.firstChild;
    for (let iNew = 0, iOld = 0; ; ) {
      let skipTo = iOld, marker = iNew < markers.length ? markers[iNew++] : null, matched = false;
      if (marker) {
        let c2 = marker.elementClass;
        if (c2)
          cls += " " + c2;
        for (let i2 = iOld; i2 < this.markers.length; i2++)
          if (this.markers[i2].compare(marker)) {
            skipTo = i2;
            matched = true;
            break;
          }
      } else {
        skipTo = this.markers.length;
      }
      while (iOld < skipTo) {
        let next = this.markers[iOld++];
        if (next.toDOM) {
          next.destroy(domPos);
          let after2 = domPos.nextSibling;
          domPos.remove();
          domPos = after2;
        }
      }
      if (!marker)
        break;
      if (marker.toDOM) {
        if (matched)
          domPos = domPos.nextSibling;
        else
          this.dom.insertBefore(marker.toDOM(view), domPos);
      }
      if (matched)
        iOld++;
    }
    this.dom.className = cls;
    this.markers = markers;
  }
  destroy() {
    this.setMarkers(null, []);
  }
}
function sameMarkers(a2, b2) {
  if (a2.length != b2.length)
    return false;
  for (let i2 = 0; i2 < a2.length; i2++)
    if (!a2[i2].compare(b2[i2]))
      return false;
  return true;
}
const lineNumberMarkers = /* @__PURE__ */ Facet.define();
const lineNumberWidgetMarker = /* @__PURE__ */ Facet.define();
const lineNumberConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, { formatNumber: String, domEventHandlers: {} }, {
      domEventHandlers(a2, b2) {
        let result2 = Object.assign({}, a2);
        for (let event in b2) {
          let exists = result2[event], add2 = b2[event];
          result2[event] = exists ? (view, line2, event2) => exists(view, line2, event2) || add2(view, line2, event2) : add2;
        }
        return result2;
      }
    });
  }
});
class NumberMarker extends GutterMarker {
  constructor(number2) {
    super();
    this.number = number2;
  }
  eq(other) {
    return this.number == other.number;
  }
  toDOM() {
    return document.createTextNode(this.number);
  }
}
function formatNumber(view, number2) {
  return view.state.facet(lineNumberConfig).formatNumber(number2, view.state);
}
const lineNumberGutter = /* @__PURE__ */ activeGutters.compute([lineNumberConfig], (state) => ({
  class: "cm-lineNumbers",
  renderEmptyElements: false,
  markers(view) {
    return view.state.facet(lineNumberMarkers);
  },
  lineMarker(view, line2, others) {
    if (others.some((m2) => m2.toDOM))
      return null;
    return new NumberMarker(formatNumber(view, view.state.doc.lineAt(line2.from).number));
  },
  widgetMarker: (view, widget, block) => {
    for (let m2 of view.state.facet(lineNumberWidgetMarker)) {
      let result2 = m2(view, widget, block);
      if (result2)
        return result2;
    }
    return null;
  },
  lineMarkerChange: (update) => update.startState.facet(lineNumberConfig) != update.state.facet(lineNumberConfig),
  initialSpacer(view) {
    return new NumberMarker(formatNumber(view, maxLineNumber(view.state.doc.lines)));
  },
  updateSpacer(spacer, update) {
    let max2 = formatNumber(update.view, maxLineNumber(update.view.state.doc.lines));
    return max2 == spacer.number ? spacer : new NumberMarker(max2);
  },
  domEventHandlers: state.facet(lineNumberConfig).domEventHandlers,
  side: "before"
}));
function lineNumbers(config2 = {}) {
  return [
    lineNumberConfig.of(config2),
    gutters(),
    lineNumberGutter
  ];
}
function maxLineNumber(lines) {
  let last2 = 9;
  while (last2 < lines)
    last2 = last2 * 10 + 9;
  return last2;
}
const activeLineGutterMarker = /* @__PURE__ */ new class extends GutterMarker {
  constructor() {
    super(...arguments);
    this.elementClass = "cm-activeLineGutter";
  }
}();
const activeLineGutterHighlighter = /* @__PURE__ */ gutterLineClass.compute(["selection"], (state) => {
  let marks = [], last2 = -1;
  for (let range2 of state.selection.ranges) {
    let linePos = state.doc.lineAt(range2.head).from;
    if (linePos > last2) {
      last2 = linePos;
      marks.push(activeLineGutterMarker.range(linePos));
    }
  }
  return RangeSet.of(marks);
});
function highlightActiveLineGutter() {
  return activeLineGutterHighlighter;
}
const DefaultBufferLength$1 = 1024;
let nextPropID$1 = 0;
let Range$2 = class Range3 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
};
let NodeProp$1 = class NodeProp22 {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID$1++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType$1.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
};
NodeProp$1.closedBy = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.openedBy = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.group = new NodeProp$1({ deserialize: (str) => str.split(" ") });
NodeProp$1.isolate = new NodeProp$1({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp$1.contextHash = new NodeProp$1({ perNode: true });
NodeProp$1.lookAhead = new NodeProp$1({ perNode: true });
NodeProp$1.mounted = new NodeProp$1({ perNode: true });
let MountedTree$1 = class MountedTree22 {
  constructor(tree, overlay, parser2, bracketed = false) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
    this.bracketed = bracketed;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp$1.mounted.id];
  }
};
const noProps$1 = /* @__PURE__ */ Object.create(null);
let NodeType$1 = class NodeType22 {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps$1;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType22(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp$1.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp$1.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
};
NodeType$1.none = new NodeType$1(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
const CachedNode$1 = /* @__PURE__ */ new WeakMap(), CachedInnerNode$1 = /* @__PURE__ */ new WeakMap();
var IterMode$1;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
  IterMode2[IterMode2["EnterBracketed"] = 16] = "EnterBracketed";
})(IterMode$1 || (IterMode$1 = {}));
let Tree$1 = class Tree22 {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree$1.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor$1(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode$1.get(this) || this.topNode;
    let cursor2 = new TreeCursor$1(scope);
    cursor2.moveTo(pos, side);
    CachedNode$1.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode$1(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode$1(CachedNode$1.get(this) || this.topNode, pos, side, false);
    CachedNode$1.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode$1(CachedInnerNode$1.get(this) || this.topNode, pos, side, true);
    CachedInnerNode$1.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator$1(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode$1.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode$1.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange$1(NodeType$1.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree22(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree22(NodeType$1.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree$1(data);
  }
};
Tree$1.empty = new Tree$1(NodeType$1.none, [], [], 0);
let FlatBufferCursor$1 = class FlatBufferCursor22 {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor22(this.buffer, this.index);
  }
};
let TreeBuffer$1 = class TreeBuffer22 {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType$1.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick2 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide$1(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick2 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick2;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer22(copy2, len, this.set);
  }
};
function checkSide$1(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode$1(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode$1 && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode$1.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode$1 && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
let BaseNode$1 = class BaseNode22 {
  cursor(mode = 0) {
    return new TreeCursor$1(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r2 = getChildren$1(this, type, before2, after2);
    return r2.length ? r2[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren$1(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode$1(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode$1(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext$1(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
};
let TreeNode$1 = class TreeNode22 extends BaseNode$1 {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from, mounted;
        if (!(mode & IterMode$1.EnterBracketed && next instanceof Tree$1 && (mounted = MountedTree$1.get(next)) && !mounted.overlay && mounted.bracketed && pos >= start && pos <= start + next.length) && !checkSide$1(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer$1) {
          if (mode & IterMode$1.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode$1(new BufferContext$1(parent, next, i2, start), null, index2);
        } else if (mode & IterMode$1.IncludeAnonymous || (!next.type.isAnonymous || hasChild$1(next))) {
          let mounted2;
          if (!(mode & IterMode$1.IgnoreMounts) && (mounted2 = MountedTree$1.get(next)) && !mounted2.overlay)
            return new TreeNode22(mounted2.tree, start, i2, parent);
          let inner = new TreeNode22(next, start, i2, parent);
          return mode & IterMode$1.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side, mode);
        }
      }
      if (mode & IterMode$1.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode$1.IgnoreOverlays) && (mounted = MountedTree$1.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from, enterBracketed = mode & IterMode$1.EnterBracketed && mounted.bracketed;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 || enterBracketed ? from <= rPos : from < rPos) && (side < 0 || enterBracketed ? to2 >= rPos : to2 > rPos))
          return new TreeNode22(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
};
function getChildren$1(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext$1(node, context, i2 = context.length - 1) {
  for (let p2 = node; i2 >= 0; p2 = p2.parent) {
    if (!p2)
      return false;
    if (!p2.type.isAnonymous) {
      if (context[i2] && context[i2] != p2.name)
        return false;
      i2--;
    }
  }
  return true;
}
let BufferContext$1 = class BufferContext22 {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
};
let BufferNode$1 = class BufferNode22 extends BaseNode$1 {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode22(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode$1.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode22(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode22(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode22(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree$1(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
};
function iterStack$1(heads) {
  if (!heads.length)
    return null;
  let pick2 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick2 = i2;
    }
  }
  let next = picked instanceof TreeNode$1 && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick2] = next;
  else
    newHeads.splice(pick2, 1);
  return new StackIterator$1(newHeads, picked);
}
let StackIterator$1 = class StackIterator22 {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack$1(this.heads);
  }
};
function stackIterator$1(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode$1 ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree$1.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode$1(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode$1(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack$1(layers) : inner;
}
let TreeCursor$1 = class TreeCursor22 {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    this.mode = mode & ~IterMode$1.EnterBracketed;
    if (node instanceof TreeNode$1) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n2 = node._parent; n2; n2 = n2._parent)
        this.stack.unshift(n2.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode$1) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode$1.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode$1.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode$1.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d2 = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d2 < 0 ? 0 : this.stack[d2] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d2 < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d2] + 3]))
        return this.yieldBuf(after2);
    }
    return d2 < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode$1.IncludeAnonymous || child instanceof TreeBuffer$1 || !child.type.isAnonymous || hasChild$1(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d2 = this.stack.length; d2 >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d2 + 1;
            break scan;
          }
        index2 = this.stack[--d2];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode$1(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode$1(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext$1(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d2 = this.stack.length - 1; i2 >= 0; d2--) {
      if (d2 < 0)
        return matchNodeContext$1(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d2]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
};
function hasChild$1(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer$1 || !ch.type.isAnonymous || hasChild$1(ch));
}
function buildTree$1(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength$1, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor$1(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer$1(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange$1(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer$1(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree$1) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp$1.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp$1.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp$1.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree$1(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree$1(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache$1 = /* @__PURE__ */ new WeakMap();
function nodeSize$1(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer$1 || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache$1.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree$1)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize$1(balanceType, child);
    }
    nodeSizeCache$1.set(node, size2);
  }
  return size2;
}
function balanceRange$1(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize$1(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize$1(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize$1(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange$1(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
class TreeFragment {
  /**
  Construct a tree fragment. You'll usually want to use
  [`addTree`](#common.TreeFragment^addTree) and
  [`applyChanges`](#common.TreeFragment^applyChanges) instead of
  calling this directly.
  */
  constructor(from, to2, tree, offset2, openStart = false, openEnd = false) {
    this.from = from;
    this.to = to2;
    this.tree = tree;
    this.offset = offset2;
    this.open = (openStart ? 1 : 0) | (openEnd ? 2 : 0);
  }
  /**
  Whether the start of the fragment represents the start of a
  parse, or the end of a change. (In the second case, it may not
  be safe to reuse some nodes at the start, depending on the
  parsing algorithm.)
  */
  get openStart() {
    return (this.open & 1) > 0;
  }
  /**
  Whether the end of the fragment represents the end of a
  full-document parse, or the start of a change.
  */
  get openEnd() {
    return (this.open & 2) > 0;
  }
  /**
  Create a set of fragments from a freshly parsed tree, or update
  an existing set of fragments by replacing the ones that overlap
  with a tree with content from the new tree. When `partial` is
  true, the parse is treated as incomplete, and the resulting
  fragment has [`openEnd`](#common.TreeFragment.openEnd) set to
  true.
  */
  static addTree(tree, fragments = [], partial2 = false) {
    let result2 = [new TreeFragment(0, tree.length, tree, 0, false, partial2)];
    for (let f2 of fragments)
      if (f2.to > tree.length)
        result2.push(f2);
    return result2;
  }
  /**
  Apply a set of edits to an array of fragments, removing or
  splitting fragments as necessary to remove edited ranges, and
  adjusting offsets for fragments that moved.
  */
  static applyChanges(fragments, changes, minGap = 128) {
    if (!changes.length)
      return fragments;
    let result2 = [];
    let fI = 1, nextF = fragments.length ? fragments[0] : null;
    for (let cI = 0, pos = 0, off = 0; ; cI++) {
      let nextC = cI < changes.length ? changes[cI] : null;
      let nextPos = nextC ? nextC.fromA : 1e9;
      if (nextPos - pos >= minGap)
        while (nextF && nextF.from < nextPos) {
          let cut = nextF;
          if (pos >= cut.from || nextPos <= cut.to || off) {
            let fFrom = Math.max(cut.from, pos) - off, fTo = Math.min(cut.to, nextPos) - off;
            cut = fFrom >= fTo ? null : new TreeFragment(fFrom, fTo, cut.tree, cut.offset + off, cI > 0, !!nextC);
          }
          if (cut)
            result2.push(cut);
          if (nextF.to > nextPos)
            break;
          nextF = fI < fragments.length ? fragments[fI++] : null;
        }
      if (!nextC)
        break;
      pos = nextC.toA;
      off = nextC.toA - nextC.toB;
    }
    return result2;
  }
}
let Parser$1 = class Parser22 {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput$1(input);
    ranges = !ranges ? [new Range$2(0, input.length)] : ranges.length ? ranges.map((r2) => new Range$2(r2.from, r2.to)) : [new Range$2(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
};
let StringInput$1 = class StringInput22 {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
};
new NodeProp$1({ perNode: true });
let nextTagID = 0;
class Tag {
  /**
  @internal
  */
  constructor(name2, set2, base2, modified) {
    this.name = name2;
    this.set = set2;
    this.base = base2;
    this.modified = modified;
    this.id = nextTagID++;
  }
  toString() {
    let { name: name2 } = this;
    for (let mod2 of this.modified)
      if (mod2.name)
        name2 = `${mod2.name}(${name2})`;
    return name2;
  }
  static define(nameOrParent, parent) {
    let name2 = typeof nameOrParent == "string" ? nameOrParent : "?";
    if (nameOrParent instanceof Tag)
      parent = nameOrParent;
    if (parent === null || parent === void 0 ? void 0 : parent.base)
      throw new Error("Can not derive from a modified tag");
    let tag2 = new Tag(name2, [], null, []);
    tag2.set.push(tag2);
    if (parent)
      for (let t4 of parent.set)
        tag2.set.push(t4);
    return tag2;
  }
  /**
  Define a tag _modifier_, which is a function that, given a tag,
  will return a tag that is a subtag of the original. Applying the
  same modifier to a twice tag will return the same value (`m1(t1)
  == m1(t1)`) and applying multiple modifiers will, regardless or
  order, produce the same tag (`m1(m2(t1)) == m2(m1(t1))`).
  
  When multiple modifiers are applied to a given base tag, each
  smaller set of modifiers is registered as a parent, so that for
  example `m1(m2(m3(t1)))` is a subtype of `m1(m2(t1))`,
  `m1(m3(t1)`, and so on.
  */
  static defineModifier(name2) {
    let mod2 = new Modifier(name2);
    return (tag2) => {
      if (tag2.modified.indexOf(mod2) > -1)
        return tag2;
      return Modifier.get(tag2.base || tag2, tag2.modified.concat(mod2).sort((a2, b2) => a2.id - b2.id));
    };
  }
}
let nextModifierID = 0;
class Modifier {
  constructor(name2) {
    this.name = name2;
    this.instances = [];
    this.id = nextModifierID++;
  }
  static get(base2, mods) {
    if (!mods.length)
      return base2;
    let exists = mods[0].instances.find((t4) => t4.base == base2 && sameArray(mods, t4.modified));
    if (exists)
      return exists;
    let set2 = [], tag2 = new Tag(base2.name, set2, base2, mods);
    for (let m2 of mods)
      m2.instances.push(tag2);
    let configs = powerSet(mods);
    for (let parent of base2.set)
      if (!parent.modified.length)
        for (let config2 of configs)
          set2.push(Modifier.get(parent, config2));
    return tag2;
  }
}
function sameArray(a2, b2) {
  return a2.length == b2.length && a2.every((x2, i2) => x2 == b2[i2]);
}
function powerSet(array) {
  let sets = [[]];
  for (let i2 = 0; i2 < array.length; i2++) {
    for (let j2 = 0, e2 = sets.length; j2 < e2; j2++) {
      sets.push(sets[j2].concat(array[i2]));
    }
  }
  return sets.sort((a2, b2) => b2.length - a2.length);
}
function styleTags(spec) {
  let byName = /* @__PURE__ */ Object.create(null);
  for (let prop in spec) {
    let tags2 = spec[prop];
    if (!Array.isArray(tags2))
      tags2 = [tags2];
    for (let part of prop.split(" "))
      if (part) {
        let pieces = [], mode = 2, rest2 = part;
        for (let pos = 0; ; ) {
          if (rest2 == "..." && pos > 0 && pos + 3 == part.length) {
            mode = 1;
            break;
          }
          let m2 = /^"(?:[^"\\]|\\.)*?"|[^\/!]+/.exec(rest2);
          if (!m2)
            throw new RangeError("Invalid path: " + part);
          pieces.push(m2[0] == "*" ? "" : m2[0][0] == '"' ? JSON.parse(m2[0]) : m2[0]);
          pos += m2[0].length;
          if (pos == part.length)
            break;
          let next = part[pos++];
          if (pos == part.length && next == "!") {
            mode = 0;
            break;
          }
          if (next != "/")
            throw new RangeError("Invalid path: " + part);
          rest2 = part.slice(pos);
        }
        let last2 = pieces.length - 1, inner = pieces[last2];
        if (!inner)
          throw new RangeError("Invalid path: " + part);
        let rule = new Rule(tags2, mode, last2 > 0 ? pieces.slice(0, last2) : null);
        byName[inner] = rule.sort(byName[inner]);
      }
  }
  return ruleNodeProp.add(byName);
}
const ruleNodeProp = new NodeProp$1({
  combine(a2, b2) {
    let cur2, root2, take;
    while (a2 || b2) {
      if (!a2 || b2 && a2.depth >= b2.depth) {
        take = b2;
        b2 = b2.next;
      } else {
        take = a2;
        a2 = a2.next;
      }
      if (cur2 && cur2.mode == take.mode && !take.context && !cur2.context)
        continue;
      let copy2 = new Rule(take.tags, take.mode, take.context);
      if (cur2)
        cur2.next = copy2;
      else
        root2 = copy2;
      cur2 = copy2;
    }
    return root2;
  }
});
class Rule {
  constructor(tags2, mode, context, next) {
    this.tags = tags2;
    this.mode = mode;
    this.context = context;
    this.next = next;
  }
  get opaque() {
    return this.mode == 0;
  }
  get inherit() {
    return this.mode == 1;
  }
  sort(other) {
    if (!other || other.depth < this.depth) {
      this.next = other;
      return this;
    }
    other.next = this.sort(other.next);
    return other;
  }
  get depth() {
    return this.context ? this.context.length : 0;
  }
}
Rule.empty = new Rule([], 2, null);
function tagHighlighter(tags2, options2) {
  let map2 = /* @__PURE__ */ Object.create(null);
  for (let style of tags2) {
    if (!Array.isArray(style.tag))
      map2[style.tag.id] = style.class;
    else
      for (let tag2 of style.tag)
        map2[tag2.id] = style.class;
  }
  let { scope, all: all2 = null } = options2 || {};
  return {
    style: (tags3) => {
      let cls = all2;
      for (let tag2 of tags3) {
        for (let sub2 of tag2.set) {
          let tagClass = map2[sub2.id];
          if (tagClass) {
            cls = cls ? cls + " " + tagClass : tagClass;
            break;
          }
        }
      }
      return cls;
    },
    scope
  };
}
function highlightTags(highlighters, tags2) {
  let result2 = null;
  for (let highlighter of highlighters) {
    let value = highlighter.style(tags2);
    if (value)
      result2 = result2 ? result2 + " " + value : value;
  }
  return result2;
}
function highlightTree(tree, highlighter, putStyle, from = 0, to2 = tree.length) {
  let builder = new HighlightBuilder(from, Array.isArray(highlighter) ? highlighter : [highlighter], putStyle);
  builder.highlightRange(tree.cursor(), from, to2, "", builder.highlighters);
  builder.flush(to2);
}
class HighlightBuilder {
  constructor(at2, highlighters, span) {
    this.at = at2;
    this.highlighters = highlighters;
    this.span = span;
    this.class = "";
  }
  startSpan(at2, cls) {
    if (cls != this.class) {
      this.flush(at2);
      if (at2 > this.at)
        this.at = at2;
      this.class = cls;
    }
  }
  flush(to2) {
    if (to2 > this.at && this.class)
      this.span(this.at, to2, this.class);
  }
  highlightRange(cursor2, from, to2, inheritedClass, highlighters) {
    let { type, from: start, to: end } = cursor2;
    if (start >= to2 || end <= from)
      return;
    if (type.isTop)
      highlighters = this.highlighters.filter((h2) => !h2.scope || h2.scope(type));
    let cls = inheritedClass;
    let rule = getStyleTags(cursor2) || Rule.empty;
    let tagCls = highlightTags(highlighters, rule.tags);
    if (tagCls) {
      if (cls)
        cls += " ";
      cls += tagCls;
      if (rule.mode == 1)
        inheritedClass += (inheritedClass ? " " : "") + tagCls;
    }
    this.startSpan(Math.max(from, start), cls);
    if (rule.opaque)
      return;
    let mounted = cursor2.tree && cursor2.tree.prop(NodeProp$1.mounted);
    if (mounted && mounted.overlay) {
      let inner = cursor2.node.enter(mounted.overlay[0].from + start, 1);
      let innerHighlighters = this.highlighters.filter((h2) => !h2.scope || h2.scope(mounted.tree.type));
      let hasChild2 = cursor2.firstChild();
      for (let i2 = 0, pos = start; ; i2++) {
        let next = i2 < mounted.overlay.length ? mounted.overlay[i2] : null;
        let nextPos = next ? next.from + start : end;
        let rangeFrom2 = Math.max(from, pos), rangeTo2 = Math.min(to2, nextPos);
        if (rangeFrom2 < rangeTo2 && hasChild2) {
          while (cursor2.from < rangeTo2) {
            this.highlightRange(cursor2, rangeFrom2, rangeTo2, inheritedClass, highlighters);
            this.startSpan(Math.min(rangeTo2, cursor2.to), cls);
            if (cursor2.to >= nextPos || !cursor2.nextSibling())
              break;
          }
        }
        if (!next || nextPos > to2)
          break;
        pos = next.to + start;
        if (pos > from) {
          this.highlightRange(inner.cursor(), Math.max(from, next.from + start), Math.min(to2, pos), "", innerHighlighters);
          this.startSpan(Math.min(to2, pos), cls);
        }
      }
      if (hasChild2)
        cursor2.parent();
    } else if (cursor2.firstChild()) {
      if (mounted)
        inheritedClass = "";
      do {
        if (cursor2.to <= from)
          continue;
        if (cursor2.from >= to2)
          break;
        this.highlightRange(cursor2, from, to2, inheritedClass, highlighters);
        this.startSpan(Math.min(to2, cursor2.to), cls);
      } while (cursor2.nextSibling());
      cursor2.parent();
    }
  }
}
function getStyleTags(node) {
  let rule = node.type.prop(ruleNodeProp);
  while (rule && rule.context && !node.matchContext(rule.context))
    rule = rule.next;
  return rule || null;
}
const t$2 = Tag.define;
const comment = t$2(), name$b = t$2(), typeName = t$2(name$b), propertyName = t$2(name$b), literal = t$2(), string$2 = t$2(literal), number$1$1 = t$2(literal), content$2 = t$2(), heading = t$2(content$2), keyword = t$2(), operator = t$2(), punctuation = t$2(), bracket = t$2(punctuation), meta = t$2();
const tags = {
  /**
  A comment.
  */
  comment,
  /**
  A line [comment](#highlight.tags.comment).
  */
  lineComment: t$2(comment),
  /**
  A block [comment](#highlight.tags.comment).
  */
  blockComment: t$2(comment),
  /**
  A documentation [comment](#highlight.tags.comment).
  */
  docComment: t$2(comment),
  /**
  Any kind of identifier.
  */
  name: name$b,
  /**
  The [name](#highlight.tags.name) of a variable.
  */
  variableName: t$2(name$b),
  /**
  A type [name](#highlight.tags.name).
  */
  typeName,
  /**
  A tag name (subtag of [`typeName`](#highlight.tags.typeName)).
  */
  tagName: t$2(typeName),
  /**
  A property or field [name](#highlight.tags.name).
  */
  propertyName,
  /**
  An attribute name (subtag of [`propertyName`](#highlight.tags.propertyName)).
  */
  attributeName: t$2(propertyName),
  /**
  The [name](#highlight.tags.name) of a class.
  */
  className: t$2(name$b),
  /**
  A label [name](#highlight.tags.name).
  */
  labelName: t$2(name$b),
  /**
  A namespace [name](#highlight.tags.name).
  */
  namespace: t$2(name$b),
  /**
  The [name](#highlight.tags.name) of a macro.
  */
  macroName: t$2(name$b),
  /**
  A literal value.
  */
  literal,
  /**
  A string [literal](#highlight.tags.literal).
  */
  string: string$2,
  /**
  A documentation [string](#highlight.tags.string).
  */
  docString: t$2(string$2),
  /**
  A character literal (subtag of [string](#highlight.tags.string)).
  */
  character: t$2(string$2),
  /**
  An attribute value (subtag of [string](#highlight.tags.string)).
  */
  attributeValue: t$2(string$2),
  /**
  A number [literal](#highlight.tags.literal).
  */
  number: number$1$1,
  /**
  An integer [number](#highlight.tags.number) literal.
  */
  integer: t$2(number$1$1),
  /**
  A floating-point [number](#highlight.tags.number) literal.
  */
  float: t$2(number$1$1),
  /**
  A boolean [literal](#highlight.tags.literal).
  */
  bool: t$2(literal),
  /**
  Regular expression [literal](#highlight.tags.literal).
  */
  regexp: t$2(literal),
  /**
  An escape [literal](#highlight.tags.literal), for example a
  backslash escape in a string.
  */
  escape: t$2(literal),
  /**
  A color [literal](#highlight.tags.literal).
  */
  color: t$2(literal),
  /**
  A URL [literal](#highlight.tags.literal).
  */
  url: t$2(literal),
  /**
  A language keyword.
  */
  keyword,
  /**
  The [keyword](#highlight.tags.keyword) for the self or this
  object.
  */
  self: t$2(keyword),
  /**
  The [keyword](#highlight.tags.keyword) for null.
  */
  null: t$2(keyword),
  /**
  A [keyword](#highlight.tags.keyword) denoting some atomic value.
  */
  atom: t$2(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that represents a unit.
  */
  unit: t$2(keyword),
  /**
  A modifier [keyword](#highlight.tags.keyword).
  */
  modifier: t$2(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that acts as an operator.
  */
  operatorKeyword: t$2(keyword),
  /**
  A control-flow related [keyword](#highlight.tags.keyword).
  */
  controlKeyword: t$2(keyword),
  /**
  A [keyword](#highlight.tags.keyword) that defines something.
  */
  definitionKeyword: t$2(keyword),
  /**
  A [keyword](#highlight.tags.keyword) related to defining or
  interfacing with modules.
  */
  moduleKeyword: t$2(keyword),
  /**
  An operator.
  */
  operator,
  /**
  An [operator](#highlight.tags.operator) that dereferences something.
  */
  derefOperator: t$2(operator),
  /**
  Arithmetic-related [operator](#highlight.tags.operator).
  */
  arithmeticOperator: t$2(operator),
  /**
  Logical [operator](#highlight.tags.operator).
  */
  logicOperator: t$2(operator),
  /**
  Bit [operator](#highlight.tags.operator).
  */
  bitwiseOperator: t$2(operator),
  /**
  Comparison [operator](#highlight.tags.operator).
  */
  compareOperator: t$2(operator),
  /**
  [Operator](#highlight.tags.operator) that updates its operand.
  */
  updateOperator: t$2(operator),
  /**
  [Operator](#highlight.tags.operator) that defines something.
  */
  definitionOperator: t$2(operator),
  /**
  Type-related [operator](#highlight.tags.operator).
  */
  typeOperator: t$2(operator),
  /**
  Control-flow [operator](#highlight.tags.operator).
  */
  controlOperator: t$2(operator),
  /**
  Program or markup punctuation.
  */
  punctuation,
  /**
  [Punctuation](#highlight.tags.punctuation) that separates
  things.
  */
  separator: t$2(punctuation),
  /**
  Bracket-style [punctuation](#highlight.tags.punctuation).
  */
  bracket,
  /**
  Angle [brackets](#highlight.tags.bracket) (usually `<` and `>`
  tokens).
  */
  angleBracket: t$2(bracket),
  /**
  Square [brackets](#highlight.tags.bracket) (usually `[` and `]`
  tokens).
  */
  squareBracket: t$2(bracket),
  /**
  Parentheses (usually `(` and `)` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  paren: t$2(bracket),
  /**
  Braces (usually `{` and `}` tokens). Subtag of
  [bracket](#highlight.tags.bracket).
  */
  brace: t$2(bracket),
  /**
  Content, for example plain text in XML or markup documents.
  */
  content: content$2,
  /**
  [Content](#highlight.tags.content) that represents a heading.
  */
  heading,
  /**
  A level 1 [heading](#highlight.tags.heading).
  */
  heading1: t$2(heading),
  /**
  A level 2 [heading](#highlight.tags.heading).
  */
  heading2: t$2(heading),
  /**
  A level 3 [heading](#highlight.tags.heading).
  */
  heading3: t$2(heading),
  /**
  A level 4 [heading](#highlight.tags.heading).
  */
  heading4: t$2(heading),
  /**
  A level 5 [heading](#highlight.tags.heading).
  */
  heading5: t$2(heading),
  /**
  A level 6 [heading](#highlight.tags.heading).
  */
  heading6: t$2(heading),
  /**
  A prose [content](#highlight.tags.content) separator (such as a horizontal rule).
  */
  contentSeparator: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that represents a list.
  */
  list: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that represents a quote.
  */
  quote: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that is emphasized.
  */
  emphasis: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that is styled strong.
  */
  strong: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that is part of a link.
  */
  link: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that is styled as code or
  monospace.
  */
  monospace: t$2(content$2),
  /**
  [Content](#highlight.tags.content) that has a strike-through
  style.
  */
  strikethrough: t$2(content$2),
  /**
  Inserted text in a change-tracking format.
  */
  inserted: t$2(),
  /**
  Deleted text.
  */
  deleted: t$2(),
  /**
  Changed text.
  */
  changed: t$2(),
  /**
  An invalid or unsyntactic element.
  */
  invalid: t$2(),
  /**
  Metadata or meta-instruction.
  */
  meta,
  /**
  [Metadata](#highlight.tags.meta) that applies to the entire
  document.
  */
  documentMeta: t$2(meta),
  /**
  [Metadata](#highlight.tags.meta) that annotates or adds
  attributes to a given syntactic element.
  */
  annotation: t$2(meta),
  /**
  Processing instruction or preprocessor directive. Subtag of
  [meta](#highlight.tags.meta).
  */
  processingInstruction: t$2(meta),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that a
  given element is being defined. Expected to be used with the
  various [name](#highlight.tags.name) tags.
  */
  definition: Tag.defineModifier("definition"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates that
  something is constant. Mostly expected to be used with
  [variable names](#highlight.tags.variableName).
  */
  constant: Tag.defineModifier("constant"),
  /**
  [Modifier](#highlight.Tag^defineModifier) used to indicate that
  a [variable](#highlight.tags.variableName) or [property
  name](#highlight.tags.propertyName) is being called or defined
  as a function.
  */
  function: Tag.defineModifier("function"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that can be applied to
  [names](#highlight.tags.name) to indicate that they belong to
  the language's standard environment.
  */
  standard: Tag.defineModifier("standard"),
  /**
  [Modifier](#highlight.Tag^defineModifier) that indicates a given
  [names](#highlight.tags.name) is local to some scope.
  */
  local: Tag.defineModifier("local"),
  /**
  A generic variant [modifier](#highlight.Tag^defineModifier) that
  can be used to tag language-specific alternative variants of
  some common tag. It is recommended for themes to define special
  forms of at least the [string](#highlight.tags.string) and
  [variable name](#highlight.tags.variableName) tags, since those
  come up a lot.
  */
  special: Tag.defineModifier("special")
};
for (let name2 in tags) {
  let val = tags[name2];
  if (val instanceof Tag)
    val.name = name2;
}
tagHighlighter([
  { tag: tags.link, class: "tok-link" },
  { tag: tags.heading, class: "tok-heading" },
  { tag: tags.emphasis, class: "tok-emphasis" },
  { tag: tags.strong, class: "tok-strong" },
  { tag: tags.keyword, class: "tok-keyword" },
  { tag: tags.atom, class: "tok-atom" },
  { tag: tags.bool, class: "tok-bool" },
  { tag: tags.url, class: "tok-url" },
  { tag: tags.labelName, class: "tok-labelName" },
  { tag: tags.inserted, class: "tok-inserted" },
  { tag: tags.deleted, class: "tok-deleted" },
  { tag: tags.literal, class: "tok-literal" },
  { tag: tags.string, class: "tok-string" },
  { tag: tags.number, class: "tok-number" },
  { tag: [tags.regexp, tags.escape, tags.special(tags.string)], class: "tok-string2" },
  { tag: tags.variableName, class: "tok-variableName" },
  { tag: tags.local(tags.variableName), class: "tok-variableName tok-local" },
  { tag: tags.definition(tags.variableName), class: "tok-variableName tok-definition" },
  { tag: tags.special(tags.variableName), class: "tok-variableName2" },
  { tag: tags.definition(tags.propertyName), class: "tok-propertyName tok-definition" },
  { tag: tags.typeName, class: "tok-typeName" },
  { tag: tags.namespace, class: "tok-namespace" },
  { tag: tags.className, class: "tok-className" },
  { tag: tags.macroName, class: "tok-macroName" },
  { tag: tags.propertyName, class: "tok-propertyName" },
  { tag: tags.operator, class: "tok-operator" },
  { tag: tags.comment, class: "tok-comment" },
  { tag: tags.meta, class: "tok-meta" },
  { tag: tags.invalid, class: "tok-invalid" },
  { tag: tags.punctuation, class: "tok-punctuation" }
]);
var _a;
const languageDataProp = /* @__PURE__ */ new NodeProp$1();
function defineLanguageFacet(baseData) {
  return Facet.define({
    combine: baseData ? (values2) => values2.concat(baseData) : void 0
  });
}
const sublanguageProp = /* @__PURE__ */ new NodeProp$1();
class Language {
  /**
  Construct a language object. If you need to invoke this
  directly, first define a data facet with
  [`defineLanguageFacet`](https://codemirror.net/6/docs/ref/#language.defineLanguageFacet), and then
  configure your parser to [attach](https://codemirror.net/6/docs/ref/#language.languageDataProp) it
  to the language's outer syntax node.
  */
  constructor(data, parser2, extraExtensions = [], name2 = "") {
    this.data = data;
    this.name = name2;
    if (!EditorState.prototype.hasOwnProperty("tree"))
      Object.defineProperty(EditorState.prototype, "tree", { get() {
        return syntaxTree(this);
      } });
    this.parser = parser2;
    this.extension = [
      language.of(this),
      EditorState.languageData.of((state, pos, side) => {
        let top2 = topNodeAt(state, pos, side), data2 = top2.type.prop(languageDataProp);
        if (!data2)
          return [];
        let base2 = state.facet(data2), sub2 = top2.type.prop(sublanguageProp);
        if (sub2) {
          let innerNode = top2.resolve(pos - top2.from, side);
          for (let sublang of sub2)
            if (sublang.test(innerNode, state)) {
              let data3 = state.facet(sublang.facet);
              return sublang.type == "replace" ? data3 : data3.concat(base2);
            }
        }
        return base2;
      })
    ].concat(extraExtensions);
  }
  /**
  Query whether this language is active at the given position.
  */
  isActiveAt(state, pos, side = -1) {
    return topNodeAt(state, pos, side).type.prop(languageDataProp) == this.data;
  }
  /**
  Find the document regions that were parsed using this language.
  The returned regions will _include_ any nested languages rooted
  in this language, when those exist.
  */
  findRegions(state) {
    let lang = state.facet(language);
    if ((lang === null || lang === void 0 ? void 0 : lang.data) == this.data)
      return [{ from: 0, to: state.doc.length }];
    if (!lang || !lang.allowsNesting)
      return [];
    let result2 = [];
    let explore = (tree, from) => {
      if (tree.prop(languageDataProp) == this.data) {
        result2.push({ from, to: from + tree.length });
        return;
      }
      let mount = tree.prop(NodeProp$1.mounted);
      if (mount) {
        if (mount.tree.prop(languageDataProp) == this.data) {
          if (mount.overlay)
            for (let r2 of mount.overlay)
              result2.push({ from: r2.from + from, to: r2.to + from });
          else
            result2.push({ from, to: from + tree.length });
          return;
        } else if (mount.overlay) {
          let size2 = result2.length;
          explore(mount.tree, mount.overlay[0].from + from);
          if (result2.length > size2)
            return;
        }
      }
      for (let i2 = 0; i2 < tree.children.length; i2++) {
        let ch = tree.children[i2];
        if (ch instanceof Tree$1)
          explore(ch, tree.positions[i2] + from);
      }
    };
    explore(syntaxTree(state), 0);
    return result2;
  }
  /**
  Indicates whether this language allows nested languages. The
  default implementation returns true.
  */
  get allowsNesting() {
    return true;
  }
}
Language.setState = /* @__PURE__ */ StateEffect.define();
function topNodeAt(state, pos, side) {
  let topLang = state.facet(language), tree = syntaxTree(state).topNode;
  if (!topLang || topLang.allowsNesting) {
    for (let node = tree; node; node = node.enter(pos, side, IterMode$1.ExcludeBuffers | IterMode$1.EnterBracketed))
      if (node.type.isTop)
        tree = node;
  }
  return tree;
}
class LRLanguage extends Language {
  constructor(data, parser2, name2) {
    super(data, parser2, [], name2);
    this.parser = parser2;
  }
  /**
  Define a language from a parser.
  */
  static define(spec) {
    let data = defineLanguageFacet(spec.languageData);
    return new LRLanguage(data, spec.parser.configure({
      props: [languageDataProp.add((type) => type.isTop ? data : void 0)]
    }), spec.name);
  }
  /**
  Create a new instance of this language with a reconfigured
  version of its parser and optionally a new name.
  */
  configure(options2, name2) {
    return new LRLanguage(this.data, this.parser.configure(options2), name2 || this.name);
  }
  get allowsNesting() {
    return this.parser.hasWrappers();
  }
}
function syntaxTree(state) {
  let field = state.field(Language.state, false);
  return field ? field.tree : Tree$1.empty;
}
class DocInput {
  /**
  Create an input object for the given document.
  */
  constructor(doc2) {
    this.doc = doc2;
    this.cursorPos = 0;
    this.string = "";
    this.cursor = doc2.iter();
  }
  get length() {
    return this.doc.length;
  }
  syncTo(pos) {
    this.string = this.cursor.next(pos - this.cursorPos).value;
    this.cursorPos = pos + this.string.length;
    return this.cursorPos - this.string.length;
  }
  chunk(pos) {
    this.syncTo(pos);
    return this.string;
  }
  get lineChunks() {
    return true;
  }
  read(from, to2) {
    let stringStart = this.cursorPos - this.string.length;
    if (from < stringStart || to2 >= this.cursorPos)
      return this.doc.sliceString(from, to2);
    else
      return this.string.slice(from - stringStart, to2 - stringStart);
  }
}
let currentContext = null;
class ParseContext {
  constructor(parser2, state, fragments = [], tree, treeLen, viewport, skipped, scheduleOn) {
    this.parser = parser2;
    this.state = state;
    this.fragments = fragments;
    this.tree = tree;
    this.treeLen = treeLen;
    this.viewport = viewport;
    this.skipped = skipped;
    this.scheduleOn = scheduleOn;
    this.parse = null;
    this.tempSkipped = [];
  }
  /**
  @internal
  */
  static create(parser2, state, viewport) {
    return new ParseContext(parser2, state, [], Tree$1.empty, 0, viewport, [], null);
  }
  startParse() {
    return this.parser.startParse(new DocInput(this.state.doc), this.fragments);
  }
  /**
  @internal
  */
  work(until, upto) {
    if (upto != null && upto >= this.state.doc.length)
      upto = void 0;
    if (this.tree != Tree$1.empty && this.isDone(upto !== null && upto !== void 0 ? upto : this.state.doc.length)) {
      this.takeTree();
      return true;
    }
    return this.withContext(() => {
      var _a2;
      if (typeof until == "number") {
        let endTime = Date.now() + until;
        until = () => Date.now() > endTime;
      }
      if (!this.parse)
        this.parse = this.startParse();
      if (upto != null && (this.parse.stoppedAt == null || this.parse.stoppedAt > upto) && upto < this.state.doc.length)
        this.parse.stopAt(upto);
      for (; ; ) {
        let done = this.parse.advance();
        if (done) {
          this.fragments = this.withoutTempSkipped(TreeFragment.addTree(done, this.fragments, this.parse.stoppedAt != null));
          this.treeLen = (_a2 = this.parse.stoppedAt) !== null && _a2 !== void 0 ? _a2 : this.state.doc.length;
          this.tree = done;
          this.parse = null;
          if (this.treeLen < (upto !== null && upto !== void 0 ? upto : this.state.doc.length))
            this.parse = this.startParse();
          else
            return true;
        }
        if (until())
          return false;
      }
    });
  }
  /**
  @internal
  */
  takeTree() {
    let pos, tree;
    if (this.parse && (pos = this.parse.parsedPos) >= this.treeLen) {
      if (this.parse.stoppedAt == null || this.parse.stoppedAt > pos)
        this.parse.stopAt(pos);
      this.withContext(() => {
        while (!(tree = this.parse.advance())) {
        }
      });
      this.treeLen = pos;
      this.tree = tree;
      this.fragments = this.withoutTempSkipped(TreeFragment.addTree(this.tree, this.fragments, true));
      this.parse = null;
    }
  }
  withContext(f2) {
    let prev = currentContext;
    currentContext = this;
    try {
      return f2();
    } finally {
      currentContext = prev;
    }
  }
  withoutTempSkipped(fragments) {
    for (let r2; r2 = this.tempSkipped.pop(); )
      fragments = cutFragments(fragments, r2.from, r2.to);
    return fragments;
  }
  /**
  @internal
  */
  changes(changes, newState) {
    let { fragments, tree, treeLen, viewport, skipped } = this;
    this.takeTree();
    if (!changes.empty) {
      let ranges = [];
      changes.iterChangedRanges((fromA, toA, fromB, toB) => ranges.push({ fromA, toA, fromB, toB }));
      fragments = TreeFragment.applyChanges(fragments, ranges);
      tree = Tree$1.empty;
      treeLen = 0;
      viewport = { from: changes.mapPos(viewport.from, -1), to: changes.mapPos(viewport.to, 1) };
      if (this.skipped.length) {
        skipped = [];
        for (let r2 of this.skipped) {
          let from = changes.mapPos(r2.from, 1), to2 = changes.mapPos(r2.to, -1);
          if (from < to2)
            skipped.push({ from, to: to2 });
        }
      }
    }
    return new ParseContext(this.parser, newState, fragments, tree, treeLen, viewport, skipped, this.scheduleOn);
  }
  /**
  @internal
  */
  updateViewport(viewport) {
    if (this.viewport.from == viewport.from && this.viewport.to == viewport.to)
      return false;
    this.viewport = viewport;
    let startLen = this.skipped.length;
    for (let i2 = 0; i2 < this.skipped.length; i2++) {
      let { from, to: to2 } = this.skipped[i2];
      if (from < viewport.to && to2 > viewport.from) {
        this.fragments = cutFragments(this.fragments, from, to2);
        this.skipped.splice(i2--, 1);
      }
    }
    if (this.skipped.length >= startLen)
      return false;
    this.reset();
    return true;
  }
  /**
  @internal
  */
  reset() {
    if (this.parse) {
      this.takeTree();
      this.parse = null;
    }
  }
  /**
  Notify the parse scheduler that the given region was skipped
  because it wasn't in view, and the parse should be restarted
  when it comes into view.
  */
  skipUntilInView(from, to2) {
    this.skipped.push({ from, to: to2 });
  }
  /**
  Returns a parser intended to be used as placeholder when
  asynchronously loading a nested parser. It'll skip its input and
  mark it as not-really-parsed, so that the next update will parse
  it again.
  
  When `until` is given, a reparse will be scheduled when that
  promise resolves.
  */
  static getSkippingParser(until) {
    return new class extends Parser$1 {
      createParse(input, fragments, ranges) {
        let from = ranges[0].from, to2 = ranges[ranges.length - 1].to;
        let parser2 = {
          parsedPos: from,
          advance() {
            let cx = currentContext;
            if (cx) {
              for (let r2 of ranges)
                cx.tempSkipped.push(r2);
              if (until)
                cx.scheduleOn = cx.scheduleOn ? Promise.all([cx.scheduleOn, until]) : until;
            }
            this.parsedPos = to2;
            return new Tree$1(NodeType$1.none, [], [], to2 - from);
          },
          stoppedAt: null,
          stopAt() {
          }
        };
        return parser2;
      }
    }();
  }
  /**
  @internal
  */
  isDone(upto) {
    upto = Math.min(upto, this.state.doc.length);
    let frags = this.fragments;
    return this.treeLen >= upto && frags.length && frags[0].from == 0 && frags[0].to >= upto;
  }
  /**
  Get the context for the current parse, or `null` if no editor
  parse is in progress.
  */
  static get() {
    return currentContext;
  }
}
function cutFragments(fragments, from, to2) {
  return TreeFragment.applyChanges(fragments, [{ fromA: from, toA: to2, fromB: from, toB: to2 }]);
}
class LanguageState {
  constructor(context) {
    this.context = context;
    this.tree = context.tree;
  }
  apply(tr2) {
    if (!tr2.docChanged && this.tree == this.context.tree)
      return this;
    let newCx = this.context.changes(tr2.changes, tr2.state);
    let upto = this.context.treeLen == tr2.startState.doc.length ? void 0 : Math.max(tr2.changes.mapPos(this.context.treeLen), newCx.viewport.to);
    if (!newCx.work(20, upto))
      newCx.takeTree();
    return new LanguageState(newCx);
  }
  static init(state) {
    let vpTo = Math.min(3e3, state.doc.length);
    let parseState = ParseContext.create(state.facet(language).parser, state, { from: 0, to: vpTo });
    if (!parseState.work(20, vpTo))
      parseState.takeTree();
    return new LanguageState(parseState);
  }
}
Language.state = /* @__PURE__ */ StateField.define({
  create: LanguageState.init,
  update(value, tr2) {
    for (let e2 of tr2.effects)
      if (e2.is(Language.setState))
        return e2.value;
    if (tr2.startState.facet(language) != tr2.state.facet(language))
      return LanguageState.init(tr2.state);
    return value.apply(tr2);
  }
});
let requestIdle = (callback) => {
  let timeout = setTimeout(
    () => callback(),
    500
    /* Work.MaxPause */
  );
  return () => clearTimeout(timeout);
};
if (typeof requestIdleCallback != "undefined")
  requestIdle = (callback) => {
    let idle = -1, timeout = setTimeout(
      () => {
        idle = requestIdleCallback(callback, {
          timeout: 500 - 100
          /* Work.MinPause */
        });
      },
      100
      /* Work.MinPause */
    );
    return () => idle < 0 ? clearTimeout(timeout) : cancelIdleCallback(idle);
  };
const isInputPending = typeof navigator != "undefined" && ((_a = navigator.scheduling) === null || _a === void 0 ? void 0 : _a.isInputPending) ? () => navigator.scheduling.isInputPending() : null;
const parseWorker = /* @__PURE__ */ ViewPlugin.fromClass(class ParseWorker {
  constructor(view) {
    this.view = view;
    this.working = null;
    this.workScheduled = 0;
    this.chunkEnd = -1;
    this.chunkBudget = -1;
    this.work = this.work.bind(this);
    this.scheduleWork();
  }
  update(update) {
    let cx = this.view.state.field(Language.state).context;
    if (cx.updateViewport(update.view.viewport) || this.view.viewport.to > cx.treeLen)
      this.scheduleWork();
    if (update.docChanged || update.selectionSet) {
      if (this.view.hasFocus)
        this.chunkBudget += 50;
      this.scheduleWork();
    }
    this.checkAsyncSchedule(cx);
  }
  scheduleWork() {
    if (this.working)
      return;
    let { state } = this.view, field = state.field(Language.state);
    if (field.tree != field.context.tree || !field.context.isDone(state.doc.length))
      this.working = requestIdle(this.work);
  }
  work(deadline) {
    this.working = null;
    let now = Date.now();
    if (this.chunkEnd < now && (this.chunkEnd < 0 || this.view.hasFocus)) {
      this.chunkEnd = now + 3e4;
      this.chunkBudget = 3e3;
    }
    if (this.chunkBudget <= 0)
      return;
    let { state, viewport: { to: vpTo } } = this.view, field = state.field(Language.state);
    if (field.tree == field.context.tree && field.context.isDone(
      vpTo + 1e5
      /* Work.MaxParseAhead */
    ))
      return;
    let endTime = Date.now() + Math.min(this.chunkBudget, 100, deadline && !isInputPending ? Math.max(25, deadline.timeRemaining() - 5) : 1e9);
    let viewportFirst = field.context.treeLen < vpTo && state.doc.length > vpTo + 1e3;
    let done = field.context.work(() => {
      return isInputPending && isInputPending() || Date.now() > endTime;
    }, vpTo + (viewportFirst ? 0 : 1e5));
    this.chunkBudget -= Date.now() - now;
    if (done || this.chunkBudget <= 0) {
      field.context.takeTree();
      this.view.dispatch({ effects: Language.setState.of(new LanguageState(field.context)) });
    }
    if (this.chunkBudget > 0 && !(done && !viewportFirst))
      this.scheduleWork();
    this.checkAsyncSchedule(field.context);
  }
  checkAsyncSchedule(cx) {
    if (cx.scheduleOn) {
      this.workScheduled++;
      cx.scheduleOn.then(() => this.scheduleWork()).catch((err) => logException(this.view.state, err)).then(() => this.workScheduled--);
      cx.scheduleOn = null;
    }
  }
  destroy() {
    if (this.working)
      this.working();
  }
  isWorking() {
    return !!(this.working || this.workScheduled > 0);
  }
}, {
  eventHandlers: { focus() {
    this.scheduleWork();
  } }
});
const language = /* @__PURE__ */ Facet.define({
  combine(languages2) {
    return languages2.length ? languages2[0] : null;
  },
  enables: (language2) => [
    Language.state,
    parseWorker,
    EditorView.contentAttributes.compute([language2], (state) => {
      let lang = state.facet(language2);
      return lang && lang.name ? { "data-language": lang.name } : {};
    })
  ]
});
class LanguageSupport {
  /**
  Create a language support object.
  */
  constructor(language2, support = []) {
    this.language = language2;
    this.support = support;
    this.extension = [language2, support];
  }
}
const indentService = /* @__PURE__ */ Facet.define();
const indentUnit = /* @__PURE__ */ Facet.define({
  combine: (values2) => {
    if (!values2.length)
      return "  ";
    let unit = values2[0];
    if (!unit || /\S/.test(unit) || Array.from(unit).some((e2) => e2 != unit[0]))
      throw new Error("Invalid indent unit: " + JSON.stringify(values2[0]));
    return unit;
  }
});
function getIndentUnit(state) {
  let unit = state.facet(indentUnit);
  return unit.charCodeAt(0) == 9 ? state.tabSize * unit.length : unit.length;
}
function indentString(state, cols) {
  let result2 = "", ts = state.tabSize, ch = state.facet(indentUnit)[0];
  if (ch == "	") {
    while (cols >= ts) {
      result2 += "	";
      cols -= ts;
    }
    ch = " ";
  }
  for (let i2 = 0; i2 < cols; i2++)
    result2 += ch;
  return result2;
}
function getIndentation(context, pos) {
  if (context instanceof EditorState)
    context = new IndentContext(context);
  for (let service of context.state.facet(indentService)) {
    let result2 = service(context, pos);
    if (result2 !== void 0)
      return result2;
  }
  let tree = syntaxTree(context.state);
  return tree.length >= pos ? syntaxIndentation(context, tree, pos) : null;
}
class IndentContext {
  /**
  Create an indent context.
  */
  constructor(state, options2 = {}) {
    this.state = state;
    this.options = options2;
    this.unit = getIndentUnit(state);
  }
  /**
  Get a description of the line at the given position, taking
  [simulated line
  breaks](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  into account. If there is such a break at `pos`, the `bias`
  argument determines whether the part of the line line before or
  after the break is used.
  */
  lineAt(pos, bias = 1) {
    let line2 = this.state.doc.lineAt(pos);
    let { simulateBreak, simulateDoubleBreak } = this.options;
    if (simulateBreak != null && simulateBreak >= line2.from && simulateBreak <= line2.to) {
      if (simulateDoubleBreak && simulateBreak == pos)
        return { text: "", from: pos };
      else if (bias < 0 ? simulateBreak < pos : simulateBreak <= pos)
        return { text: line2.text.slice(simulateBreak - line2.from), from: simulateBreak };
      else
        return { text: line2.text.slice(0, simulateBreak - line2.from), from: line2.from };
    }
    return line2;
  }
  /**
  Get the text directly after `pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  textAfterPos(pos, bias = 1) {
    if (this.options.simulateDoubleBreak && pos == this.options.simulateBreak)
      return "";
    let { text: text2, from } = this.lineAt(pos, bias);
    return text2.slice(pos - from, Math.min(text2.length, pos + 100 - from));
  }
  /**
  Find the column for the given position.
  */
  column(pos, bias = 1) {
    let { text: text2, from } = this.lineAt(pos, bias);
    let result2 = this.countColumn(text2, pos - from);
    let override = this.options.overrideIndentation ? this.options.overrideIndentation(from) : -1;
    if (override > -1)
      result2 += override - this.countColumn(text2, text2.search(/\S|$/));
    return result2;
  }
  /**
  Find the column position (taking tabs into account) of the given
  position in the given string.
  */
  countColumn(line2, pos = line2.length) {
    return countColumn(line2, this.state.tabSize, pos);
  }
  /**
  Find the indentation column of the line at the given point.
  */
  lineIndent(pos, bias = 1) {
    let { text: text2, from } = this.lineAt(pos, bias);
    let override = this.options.overrideIndentation;
    if (override) {
      let overriden = override(from);
      if (overriden > -1)
        return overriden;
    }
    return this.countColumn(text2, text2.search(/\S|$/));
  }
  /**
  Returns the [simulated line
  break](https://codemirror.net/6/docs/ref/#language.IndentContext.constructor^options.simulateBreak)
  for this context, if any.
  */
  get simulatedBreak() {
    return this.options.simulateBreak || null;
  }
}
const indentNodeProp = /* @__PURE__ */ new NodeProp$1();
function syntaxIndentation(cx, ast, pos) {
  let stack = ast.resolveStack(pos);
  let inner = ast.resolveInner(pos, -1).resolve(pos, 0).enterUnfinishedNodesBefore(pos);
  if (inner != stack.node) {
    let add2 = [];
    for (let cur2 = inner; cur2 && !(cur2.from < stack.node.from || cur2.to > stack.node.to || cur2.from == stack.node.from && cur2.type == stack.node.type); cur2 = cur2.parent)
      add2.push(cur2);
    for (let i2 = add2.length - 1; i2 >= 0; i2--)
      stack = { node: add2[i2], next: stack };
  }
  return indentFor(stack, cx, pos);
}
function indentFor(stack, cx, pos) {
  for (let cur2 = stack; cur2; cur2 = cur2.next) {
    let strategy = indentStrategy(cur2.node);
    if (strategy)
      return strategy(TreeIndentContext.create(cx, pos, cur2));
  }
  return 0;
}
function ignoreClosed(cx) {
  return cx.pos == cx.options.simulateBreak && cx.options.simulateDoubleBreak;
}
function indentStrategy(tree) {
  let strategy = tree.type.prop(indentNodeProp);
  if (strategy)
    return strategy;
  let first2 = tree.firstChild, close;
  if (first2 && (close = first2.type.prop(NodeProp$1.closedBy))) {
    let last2 = tree.lastChild, closed = last2 && close.indexOf(last2.name) > -1;
    return (cx) => delimitedStrategy(cx, true, 1, void 0, closed && !ignoreClosed(cx) ? last2.from : void 0);
  }
  return tree.parent == null ? topIndent : null;
}
function topIndent() {
  return 0;
}
class TreeIndentContext extends IndentContext {
  constructor(base2, pos, context) {
    super(base2.state, base2.options);
    this.base = base2;
    this.pos = pos;
    this.context = context;
  }
  /**
  The syntax tree node to which the indentation strategy
  applies.
  */
  get node() {
    return this.context.node;
  }
  /**
  @internal
  */
  static create(base2, pos, context) {
    return new TreeIndentContext(base2, pos, context);
  }
  /**
  Get the text directly after `this.pos`, either the entire line
  or the next 100 characters, whichever is shorter.
  */
  get textAfter() {
    return this.textAfterPos(this.pos);
  }
  /**
  Get the indentation at the reference line for `this.node`, which
  is the line on which it starts, unless there is a node that is
  _not_ a parent of this node covering the start of that line. If
  so, the line at the start of that node is tried, again skipping
  on if it is covered by another such node.
  */
  get baseIndent() {
    return this.baseIndentFor(this.node);
  }
  /**
  Get the indentation for the reference line of the given node
  (see [`baseIndent`](https://codemirror.net/6/docs/ref/#language.TreeIndentContext.baseIndent)).
  */
  baseIndentFor(node) {
    let line2 = this.state.doc.lineAt(node.from);
    for (; ; ) {
      let atBreak = node.resolve(line2.from);
      while (atBreak.parent && atBreak.parent.from == atBreak.from)
        atBreak = atBreak.parent;
      if (isParent(atBreak, node))
        break;
      line2 = this.state.doc.lineAt(atBreak.from);
    }
    return this.lineIndent(line2.from);
  }
  /**
  Continue looking for indentations in the node's parent nodes,
  and return the result of that.
  */
  continue() {
    return indentFor(this.context.next, this.base, this.pos);
  }
}
function isParent(parent, of) {
  for (let cur2 = of; cur2; cur2 = cur2.parent)
    if (parent == cur2)
      return true;
  return false;
}
function bracketedAligned(context) {
  let tree = context.node;
  let openToken = tree.childAfter(tree.from), last2 = tree.lastChild;
  if (!openToken)
    return null;
  let sim = context.options.simulateBreak;
  let openLine = context.state.doc.lineAt(openToken.from);
  let lineEnd = sim == null || sim <= openLine.from ? openLine.to : Math.min(openLine.to, sim);
  for (let pos = openToken.to; ; ) {
    let next = tree.childAfter(pos);
    if (!next || next == last2)
      return null;
    if (!next.type.isSkipped) {
      if (next.from >= lineEnd)
        return null;
      let space = /^ */.exec(openLine.text.slice(openToken.to - openLine.from))[0].length;
      return { from: openToken.from, to: openToken.to + space };
    }
    pos = next.to;
  }
}
function delimitedStrategy(context, align2, units, closing2, closedAt) {
  let after2 = context.textAfter, space = after2.match(/^\s*/)[0].length;
  let closed = closedAt == context.pos + space;
  let aligned = bracketedAligned(context);
  if (aligned)
    return closed ? context.column(aligned.from) : context.column(aligned.to);
  return context.baseIndent + (closed ? 0 : context.unit * units);
}
const DontIndentBeyond = 200;
function indentOnInput() {
  return EditorState.transactionFilter.of((tr2) => {
    if (!tr2.docChanged || !tr2.isUserEvent("input.type") && !tr2.isUserEvent("input.complete"))
      return tr2;
    let rules = tr2.startState.languageDataAt("indentOnInput", tr2.startState.selection.main.head);
    if (!rules.length)
      return tr2;
    let doc2 = tr2.newDoc, { head } = tr2.newSelection.main, line2 = doc2.lineAt(head);
    if (head > line2.from + DontIndentBeyond)
      return tr2;
    let lineStart = doc2.sliceString(line2.from, head);
    if (!rules.some((r2) => r2.test(lineStart)))
      return tr2;
    let { state } = tr2, last2 = -1, changes = [];
    for (let { head: head2 } of state.selection.ranges) {
      let line22 = state.doc.lineAt(head2);
      if (line22.from == last2)
        continue;
      last2 = line22.from;
      let indent2 = getIndentation(state, line22.from);
      if (indent2 == null)
        continue;
      let cur2 = /^\s*/.exec(line22.text)[0];
      let norm = indentString(state, indent2);
      if (cur2 != norm)
        changes.push({ from: line22.from, to: line22.from + cur2.length, insert: norm });
    }
    return changes.length ? [tr2, { changes, sequential: true }] : tr2;
  });
}
const foldService = /* @__PURE__ */ Facet.define();
const foldNodeProp = /* @__PURE__ */ new NodeProp$1();
function syntaxFolding(state, start, end) {
  let tree = syntaxTree(state);
  if (tree.length < end)
    return null;
  let stack = tree.resolveStack(end, 1);
  let found = null;
  for (let iter = stack; iter; iter = iter.next) {
    let cur2 = iter.node;
    if (cur2.to <= end || cur2.from > end)
      continue;
    if (found && cur2.from < start)
      break;
    let prop = cur2.type.prop(foldNodeProp);
    if (prop && (cur2.to < tree.length - 50 || tree.length == state.doc.length || !isUnfinished(cur2))) {
      let value = prop(cur2, state);
      if (value && value.from <= end && value.from >= start && value.to > end)
        found = value;
    }
  }
  return found;
}
function isUnfinished(node) {
  let ch = node.lastChild;
  return ch && ch.to == node.to && ch.type.isError;
}
function foldable(state, lineStart, lineEnd) {
  for (let service of state.facet(foldService)) {
    let result2 = service(state, lineStart, lineEnd);
    if (result2)
      return result2;
  }
  return syntaxFolding(state, lineStart, lineEnd);
}
function mapRange(range2, mapping) {
  let from = mapping.mapPos(range2.from, 1), to2 = mapping.mapPos(range2.to, -1);
  return from >= to2 ? void 0 : { from, to: to2 };
}
const foldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
const unfoldEffect = /* @__PURE__ */ StateEffect.define({ map: mapRange });
function selectedLines(view) {
  let lines = [];
  for (let { head } of view.state.selection.ranges) {
    if (lines.some((l2) => l2.from <= head && l2.to >= head))
      continue;
    lines.push(view.lineBlockAt(head));
  }
  return lines;
}
const foldState = /* @__PURE__ */ StateField.define({
  create() {
    return Decoration.none;
  },
  update(folded, tr2) {
    if (tr2.isUserEvent("delete"))
      tr2.changes.iterChangedRanges((fromA, toA) => folded = clearTouchedFolds(folded, fromA, toA));
    folded = folded.map(tr2.changes);
    let rangesToFold = [];
    for (let e2 of tr2.effects) {
      if (e2.is(foldEffect) && !foldExists(folded, e2.value.from, e2.value.to)) {
        rangesToFold.push(e2.value);
      } else if (e2.is(unfoldEffect)) {
        folded = folded.update({
          filter: (from, to2) => e2.value.from != from || e2.value.to != to2,
          filterFrom: e2.value.from,
          filterTo: e2.value.to
        });
      }
    }
    if (rangesToFold.length) {
      let { preparePlaceholder } = tr2.state.facet(foldConfig);
      let decorations2 = rangesToFold.map((value) => {
        let widget = !preparePlaceholder ? foldWidget : Decoration.replace({ widget: new PreparedFoldWidget(preparePlaceholder(tr2.state, value)) });
        return widget.range(value.from, value.to);
      });
      folded = folded.update({ add: decorations2 });
    }
    if (tr2.selection)
      folded = clearTouchedFolds(folded, tr2.selection.main.head);
    return folded;
  },
  provide: (f2) => EditorView.decorations.from(f2),
  toJSON(folded, state) {
    let ranges = [];
    folded.between(0, state.doc.length, (from, to2) => {
      ranges.push(from, to2);
    });
    return ranges;
  },
  fromJSON(value) {
    if (!Array.isArray(value) || value.length % 2)
      throw new RangeError("Invalid JSON for fold state");
    let ranges = [];
    for (let i2 = 0; i2 < value.length; ) {
      let from = value[i2++], to2 = value[i2++];
      if (typeof from != "number" || typeof to2 != "number")
        throw new RangeError("Invalid JSON for fold state");
      ranges.push(foldWidget.range(from, to2));
    }
    return Decoration.set(ranges, true);
  }
});
function clearTouchedFolds(folded, from, to2 = from) {
  let touched = false;
  folded.between(from, to2, (a2, b2) => {
    if (a2 < to2 && b2 > from)
      touched = true;
  });
  return !touched ? folded : folded.update({
    filterFrom: from,
    filterTo: to2,
    filter: (a2, b2) => a2 >= to2 || b2 <= from
  });
}
function findFold(state, from, to2) {
  var _a2;
  let found = null;
  (_a2 = state.field(foldState, false)) === null || _a2 === void 0 ? void 0 : _a2.between(from, to2, (from2, to22) => {
    if (!found || found.from > from2)
      found = { from: from2, to: to22 };
  });
  return found;
}
function foldExists(folded, from, to2) {
  let found = false;
  folded.between(from, from, (a2, b2) => {
    if (a2 == from && b2 == to2)
      found = true;
  });
  return found;
}
function maybeEnable(state, other) {
  return state.field(foldState, false) ? other : other.concat(StateEffect.appendConfig.of(codeFolding()));
}
const foldCode = (view) => {
  for (let line2 of selectedLines(view)) {
    let range2 = foldable(view.state, line2.from, line2.to);
    if (range2) {
      view.dispatch({ effects: maybeEnable(view.state, [foldEffect.of(range2), announceFold(view, range2)]) });
      return true;
    }
  }
  return false;
};
const unfoldCode = (view) => {
  if (!view.state.field(foldState, false))
    return false;
  let effects = [];
  for (let line2 of selectedLines(view)) {
    let folded = findFold(view.state, line2.from, line2.to);
    if (folded)
      effects.push(unfoldEffect.of(folded), announceFold(view, folded, false));
  }
  if (effects.length)
    view.dispatch({ effects });
  return effects.length > 0;
};
function announceFold(view, range2, fold = true) {
  let lineFrom = view.state.doc.lineAt(range2.from).number, lineTo = view.state.doc.lineAt(range2.to).number;
  return EditorView.announce.of(`${view.state.phrase(fold ? "Folded lines" : "Unfolded lines")} ${lineFrom} ${view.state.phrase("to")} ${lineTo}.`);
}
const foldAll = (view) => {
  let { state } = view, effects = [];
  for (let pos = 0; pos < state.doc.length; ) {
    let line2 = view.lineBlockAt(pos), range2 = foldable(state, line2.from, line2.to);
    if (range2)
      effects.push(foldEffect.of(range2));
    pos = (range2 ? view.lineBlockAt(range2.to) : line2).to + 1;
  }
  if (effects.length)
    view.dispatch({ effects: maybeEnable(view.state, effects) });
  return !!effects.length;
};
const unfoldAll = (view) => {
  let field = view.state.field(foldState, false);
  if (!field || !field.size)
    return false;
  let effects = [];
  field.between(0, view.state.doc.length, (from, to2) => {
    effects.push(unfoldEffect.of({ from, to: to2 }));
  });
  view.dispatch({ effects });
  return true;
};
const foldKeymap = [
  { key: "Ctrl-Shift-[", mac: "Cmd-Alt-[", run: foldCode },
  { key: "Ctrl-Shift-]", mac: "Cmd-Alt-]", run: unfoldCode },
  { key: "Ctrl-Alt-[", run: foldAll },
  { key: "Ctrl-Alt-]", run: unfoldAll }
];
const defaultConfig = {
  placeholderDOM: null,
  preparePlaceholder: null,
  placeholderText: "…"
};
const foldConfig = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return combineConfig(values2, defaultConfig);
  }
});
function codeFolding(config2) {
  let result2 = [foldState, baseTheme$1$1];
  return result2;
}
function widgetToDOM(view, prepared) {
  let { state } = view, conf = state.facet(foldConfig);
  let onclick = (event) => {
    let line2 = view.lineBlockAt(view.posAtDOM(event.target));
    let folded = findFold(view.state, line2.from, line2.to);
    if (folded)
      view.dispatch({ effects: unfoldEffect.of(folded) });
    event.preventDefault();
  };
  if (conf.placeholderDOM)
    return conf.placeholderDOM(view, onclick, prepared);
  let element2 = document.createElement("span");
  element2.textContent = conf.placeholderText;
  element2.setAttribute("aria-label", state.phrase("folded code"));
  element2.title = state.phrase("unfold");
  element2.className = "cm-foldPlaceholder";
  element2.onclick = onclick;
  return element2;
}
const foldWidget = /* @__PURE__ */ Decoration.replace({ widget: /* @__PURE__ */ new class extends WidgetType {
  toDOM(view) {
    return widgetToDOM(view, null);
  }
}() });
class PreparedFoldWidget extends WidgetType {
  constructor(value) {
    super();
    this.value = value;
  }
  eq(other) {
    return this.value == other.value;
  }
  toDOM(view) {
    return widgetToDOM(view, this.value);
  }
}
const foldGutterDefaults = {
  openText: "⌄",
  closedText: "›",
  markerDOM: null,
  domEventHandlers: {},
  foldingChanged: () => false
};
class FoldMarker extends GutterMarker {
  constructor(config2, open) {
    super();
    this.config = config2;
    this.open = open;
  }
  eq(other) {
    return this.config == other.config && this.open == other.open;
  }
  toDOM(view) {
    if (this.config.markerDOM)
      return this.config.markerDOM(this.open);
    let span = document.createElement("span");
    span.textContent = this.open ? this.config.openText : this.config.closedText;
    span.title = view.state.phrase(this.open ? "Fold line" : "Unfold line");
    return span;
  }
}
function foldGutter(config2 = {}) {
  let fullConfig = { ...foldGutterDefaults, ...config2 };
  let canFold = new FoldMarker(fullConfig, true), canUnfold = new FoldMarker(fullConfig, false);
  let markers = ViewPlugin.fromClass(class {
    constructor(view) {
      this.from = view.viewport.from;
      this.markers = this.buildMarkers(view);
    }
    update(update) {
      if (update.docChanged || update.viewportChanged || update.startState.facet(language) != update.state.facet(language) || update.startState.field(foldState, false) != update.state.field(foldState, false) || syntaxTree(update.startState) != syntaxTree(update.state) || fullConfig.foldingChanged(update))
        this.markers = this.buildMarkers(update.view);
    }
    buildMarkers(view) {
      let builder = new RangeSetBuilder();
      for (let line2 of view.viewportLineBlocks) {
        let mark2 = findFold(view.state, line2.from, line2.to) ? canUnfold : foldable(view.state, line2.from, line2.to) ? canFold : null;
        if (mark2)
          builder.add(line2.from, line2.from, mark2);
      }
      return builder.finish();
    }
  });
  let { domEventHandlers } = fullConfig;
  return [
    markers,
    gutter({
      class: "cm-foldGutter",
      markers(view) {
        var _a2;
        return ((_a2 = view.plugin(markers)) === null || _a2 === void 0 ? void 0 : _a2.markers) || RangeSet.empty;
      },
      initialSpacer() {
        return new FoldMarker(fullConfig, false);
      },
      domEventHandlers: {
        ...domEventHandlers,
        click: (view, line2, event) => {
          if (domEventHandlers.click && domEventHandlers.click(view, line2, event))
            return true;
          let folded = findFold(view.state, line2.from, line2.to);
          if (folded) {
            view.dispatch({ effects: unfoldEffect.of(folded) });
            return true;
          }
          let range2 = foldable(view.state, line2.from, line2.to);
          if (range2) {
            view.dispatch({ effects: foldEffect.of(range2) });
            return true;
          }
          return false;
        }
      }
    }),
    codeFolding()
  ];
}
const baseTheme$1$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-foldPlaceholder": {
    backgroundColor: "#eee",
    border: "1px solid #ddd",
    color: "#888",
    borderRadius: ".2em",
    margin: "0 1px",
    padding: "0 1px",
    cursor: "pointer"
  },
  ".cm-foldGutter span": {
    padding: "0 1px",
    cursor: "pointer"
  }
});
class HighlightStyle {
  constructor(specs, options2) {
    this.specs = specs;
    let modSpec;
    function def(spec) {
      let cls = StyleModule.newName();
      (modSpec || (modSpec = /* @__PURE__ */ Object.create(null)))["." + cls] = spec;
      return cls;
    }
    const all2 = typeof options2.all == "string" ? options2.all : options2.all ? def(options2.all) : void 0;
    const scopeOpt = options2.scope;
    this.scope = scopeOpt instanceof Language ? (type) => type.prop(languageDataProp) == scopeOpt.data : scopeOpt ? (type) => type == scopeOpt : void 0;
    this.style = tagHighlighter(specs.map((style) => ({
      tag: style.tag,
      class: style.class || def(Object.assign({}, style, { tag: null }))
    })), {
      all: all2
    }).style;
    this.module = modSpec ? new StyleModule(modSpec) : null;
    this.themeType = options2.themeType;
  }
  /**
  Create a highlighter style that associates the given styles to
  the given tags. The specs must be objects that hold a style tag
  or array of tags in their `tag` property, and either a single
  `class` property providing a static CSS class (for highlighter
  that rely on external styling), or a
  [`style-mod`](https://code.haverbeke.berlin/marijn/style-mod#documentation)-style
  set of CSS properties (which define the styling for those tags).
  
  The CSS rules created for a highlighter will be emitted in the
  order of the spec's properties. That means that for elements that
  have multiple tags associated with them, styles defined further
  down in the list will have a higher CSS precedence than styles
  defined earlier.
  */
  static define(specs, options2) {
    return new HighlightStyle(specs, options2 || {});
  }
}
const highlighterFacet = /* @__PURE__ */ Facet.define();
const fallbackHighlighter = /* @__PURE__ */ Facet.define({
  combine(values2) {
    return values2.length ? [values2[0]] : null;
  }
});
function getHighlighters(state) {
  let main2 = state.facet(highlighterFacet);
  return main2.length ? main2 : state.facet(fallbackHighlighter);
}
function syntaxHighlighting(highlighter, options2) {
  let ext = [treeHighlighter], themeType;
  if (highlighter instanceof HighlightStyle) {
    if (highlighter.module)
      ext.push(EditorView.styleModule.of(highlighter.module));
    themeType = highlighter.themeType;
  }
  if (options2 === null || options2 === void 0 ? void 0 : options2.fallback)
    ext.push(fallbackHighlighter.of(highlighter));
  else if (themeType)
    ext.push(highlighterFacet.computeN([EditorView.darkTheme], (state) => {
      return state.facet(EditorView.darkTheme) == (themeType == "dark") ? [highlighter] : [];
    }));
  else
    ext.push(highlighterFacet.of(highlighter));
  return ext;
}
class TreeHighlighter {
  constructor(view) {
    this.markCache = /* @__PURE__ */ Object.create(null);
    this.tree = syntaxTree(view.state);
    this.decorations = this.buildDeco(view, getHighlighters(view.state));
    this.decoratedTo = view.viewport.to;
  }
  update(update) {
    let tree = syntaxTree(update.state), highlighters = getHighlighters(update.state);
    let styleChange = highlighters != getHighlighters(update.startState);
    let { viewport } = update.view, decoratedToMapped = update.changes.mapPos(this.decoratedTo, 1);
    if (tree.length < viewport.to && !styleChange && tree.type == this.tree.type && decoratedToMapped >= viewport.to) {
      this.decorations = this.decorations.map(update.changes);
      this.decoratedTo = decoratedToMapped;
    } else if (tree != this.tree || update.viewportChanged || styleChange) {
      this.tree = tree;
      this.decorations = this.buildDeco(update.view, highlighters);
      this.decoratedTo = viewport.to;
    }
  }
  buildDeco(view, highlighters) {
    if (!highlighters || !this.tree.length)
      return Decoration.none;
    let builder = new RangeSetBuilder();
    for (let { from, to: to2 } of view.visibleRanges) {
      highlightTree(this.tree, highlighters, (from2, to22, style) => {
        builder.add(from2, to22, this.markCache[style] || (this.markCache[style] = Decoration.mark({ class: style })));
      }, from, to2);
    }
    return builder.finish();
  }
}
const treeHighlighter = /* @__PURE__ */ Prec.high(/* @__PURE__ */ ViewPlugin.fromClass(TreeHighlighter, {
  decorations: (v2) => v2.decorations
}));
const defaultHighlightStyle = /* @__PURE__ */ HighlightStyle.define([
  {
    tag: tags.meta,
    color: "#404740"
  },
  {
    tag: tags.link,
    textDecoration: "underline"
  },
  {
    tag: tags.heading,
    textDecoration: "underline",
    fontWeight: "bold"
  },
  {
    tag: tags.emphasis,
    fontStyle: "italic"
  },
  {
    tag: tags.strong,
    fontWeight: "bold"
  },
  {
    tag: tags.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: tags.keyword,
    color: "#708"
  },
  {
    tag: [tags.atom, tags.bool, tags.url, tags.contentSeparator, tags.labelName],
    color: "#219"
  },
  {
    tag: [tags.literal, tags.inserted],
    color: "#164"
  },
  {
    tag: [tags.string, tags.deleted],
    color: "#a11"
  },
  {
    tag: [tags.regexp, tags.escape, /* @__PURE__ */ tags.special(tags.string)],
    color: "#e40"
  },
  {
    tag: /* @__PURE__ */ tags.definition(tags.variableName),
    color: "#00f"
  },
  {
    tag: /* @__PURE__ */ tags.local(tags.variableName),
    color: "#30a"
  },
  {
    tag: [tags.typeName, tags.namespace],
    color: "#085"
  },
  {
    tag: tags.className,
    color: "#167"
  },
  {
    tag: [/* @__PURE__ */ tags.special(tags.variableName), tags.macroName],
    color: "#256"
  },
  {
    tag: /* @__PURE__ */ tags.definition(tags.propertyName),
    color: "#00c"
  },
  {
    tag: tags.comment,
    color: "#940"
  },
  {
    tag: tags.invalid,
    color: "#f00"
  }
]);
const baseTheme$4 = /* @__PURE__ */ EditorView.baseTheme({
  "&.cm-focused .cm-matchingBracket": { backgroundColor: "#328c8252" },
  "&.cm-focused .cm-nonmatchingBracket": { backgroundColor: "#bb555544" }
});
const DefaultScanDist = 1e4, DefaultBrackets = "()[]{}";
const bracketMatchingConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      afterCursor: true,
      brackets: DefaultBrackets,
      maxScanDistance: DefaultScanDist,
      renderMatch: defaultRenderMatch
    });
  }
});
const matchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-matchingBracket" }), nonmatchingMark = /* @__PURE__ */ Decoration.mark({ class: "cm-nonmatchingBracket" });
function defaultRenderMatch(match2) {
  let decorations2 = [];
  let mark2 = match2.matched ? matchingMark : nonmatchingMark;
  decorations2.push(mark2.range(match2.start.from, match2.start.to));
  if (match2.end)
    decorations2.push(mark2.range(match2.end.from, match2.end.to));
  return decorations2;
}
function bracketDeco(state) {
  let decorations2 = [];
  let config2 = state.facet(bracketMatchingConfig);
  for (let range2 of state.selection.ranges) {
    if (!range2.empty)
      continue;
    let match2 = matchBrackets(state, range2.head, -1, config2) || range2.head > 0 && matchBrackets(state, range2.head - 1, 1, config2) || config2.afterCursor && (matchBrackets(state, range2.head, 1, config2) || range2.head < state.doc.length && matchBrackets(state, range2.head + 1, -1, config2));
    if (match2)
      decorations2 = decorations2.concat(config2.renderMatch(match2, state));
  }
  return Decoration.set(decorations2, true);
}
const bracketMatcher = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.paused = false;
    this.decorations = bracketDeco(view.state);
  }
  update(update) {
    if (update.docChanged || update.selectionSet || this.paused) {
      if (update.view.composing) {
        this.decorations = this.decorations.map(update.changes);
        this.paused = true;
      } else {
        this.decorations = bracketDeco(update.state);
        this.paused = false;
      }
    }
  }
}, {
  decorations: (v2) => v2.decorations
});
const bracketMatchingUnique = [
  bracketMatcher,
  baseTheme$4
];
function bracketMatching(config2 = {}) {
  return [bracketMatchingConfig.of(config2), bracketMatchingUnique];
}
const bracketMatchingHandle = /* @__PURE__ */ new NodeProp$1();
function matchingNodes(node, dir, brackets) {
  let byProp = node.prop(dir < 0 ? NodeProp$1.openedBy : NodeProp$1.closedBy);
  if (byProp)
    return byProp;
  if (node.name.length == 1) {
    let index2 = brackets.indexOf(node.name);
    if (index2 > -1 && index2 % 2 == (dir < 0 ? 1 : 0))
      return [brackets[index2 + dir]];
  }
  return null;
}
function findHandle(node) {
  let hasHandle = node.type.prop(bracketMatchingHandle);
  return hasHandle ? hasHandle(node.node) : node;
}
function matchBrackets(state, pos, dir, config2 = {}) {
  let maxScanDistance = config2.maxScanDistance || DefaultScanDist, brackets = config2.brackets || DefaultBrackets;
  let tree = syntaxTree(state), node = tree.resolveInner(pos, dir);
  for (let cur2 = node; cur2; cur2 = cur2.parent) {
    let matches2 = matchingNodes(cur2.type, dir, brackets);
    if (matches2 && cur2.from < cur2.to) {
      let handle = findHandle(cur2);
      if (handle && (dir > 0 ? pos >= handle.from && pos < handle.to : pos > handle.from && pos <= handle.to))
        return matchMarkedBrackets(state, pos, dir, cur2, handle, matches2, brackets);
    }
  }
  return matchPlainBrackets(state, pos, dir, tree, node.type, maxScanDistance, brackets);
}
function matchMarkedBrackets(_state, _pos, dir, token, handle, matching, brackets) {
  let parent = token.parent, firstToken = { from: handle.from, to: handle.to };
  let depth = 0, cursor2 = parent === null || parent === void 0 ? void 0 : parent.cursor();
  if (cursor2 && (dir < 0 ? cursor2.childBefore(token.from) : cursor2.childAfter(token.to)))
    do {
      if (dir < 0 ? cursor2.to <= token.from : cursor2.from >= token.to) {
        if (depth == 0 && matching.indexOf(cursor2.type.name) > -1 && cursor2.from < cursor2.to) {
          let endHandle = findHandle(cursor2);
          return { start: firstToken, end: endHandle ? { from: endHandle.from, to: endHandle.to } : void 0, matched: true };
        } else if (matchingNodes(cursor2.type, dir, brackets)) {
          depth++;
        } else if (matchingNodes(cursor2.type, -dir, brackets)) {
          if (depth == 0) {
            let endHandle = findHandle(cursor2);
            return {
              start: firstToken,
              end: endHandle && endHandle.from < endHandle.to ? { from: endHandle.from, to: endHandle.to } : void 0,
              matched: false
            };
          }
          depth--;
        }
      }
    } while (dir < 0 ? cursor2.prevSibling() : cursor2.nextSibling());
  return { start: firstToken, matched: false };
}
function matchPlainBrackets(state, pos, dir, tree, tokenType, maxScanDistance, brackets) {
  if (dir < 0 ? !pos : pos == state.doc.length)
    return null;
  let startCh = dir < 0 ? state.sliceDoc(pos - 1, pos) : state.sliceDoc(pos, pos + 1);
  let bracket2 = brackets.indexOf(startCh);
  if (bracket2 < 0 || bracket2 % 2 == 0 != dir > 0)
    return null;
  let startToken = { from: dir < 0 ? pos - 1 : pos, to: dir > 0 ? pos + 1 : pos };
  let iter = state.doc.iterRange(pos, dir > 0 ? state.doc.length : 0), depth = 0;
  for (let distance = 0; !iter.next().done && distance <= maxScanDistance; ) {
    let text2 = iter.value;
    if (dir < 0)
      distance += text2.length;
    let basePos = pos + distance * dir;
    for (let pos2 = dir > 0 ? 0 : text2.length - 1, end = dir > 0 ? text2.length : -1; pos2 != end; pos2 += dir) {
      let found = brackets.indexOf(text2[pos2]);
      if (found < 0 || tree.resolveInner(basePos + pos2, 1).type != tokenType)
        continue;
      if (found % 2 == 0 == dir > 0) {
        depth++;
      } else if (depth == 1) {
        return { start: startToken, end: { from: basePos + pos2, to: basePos + pos2 + 1 }, matched: found >> 1 == bracket2 >> 1 };
      } else {
        depth--;
      }
    }
    if (dir > 0)
      distance += text2.length;
  }
  return iter.done ? { start: startToken, matched: false } : null;
}
const noTokens = /* @__PURE__ */ Object.create(null);
const typeArray = [NodeType$1.none];
const warned = [];
const byTag = /* @__PURE__ */ Object.create(null);
const defaultTable = /* @__PURE__ */ Object.create(null);
for (let [legacyName, name2] of [
  ["variable", "variableName"],
  ["variable-2", "variableName.special"],
  ["string-2", "string.special"],
  ["def", "variableName.definition"],
  ["tag", "tagName"],
  ["attribute", "attributeName"],
  ["type", "typeName"],
  ["builtin", "variableName.standard"],
  ["qualifier", "modifier"],
  ["error", "invalid"],
  ["header", "heading"],
  ["property", "propertyName"]
])
  defaultTable[legacyName] = /* @__PURE__ */ createTokenType(noTokens, name2);
function warnForPart(part, msg) {
  if (warned.indexOf(part) > -1)
    return;
  warned.push(part);
  console.warn(msg);
}
function createTokenType(extra, tagStr) {
  let tags$1 = [];
  for (let name3 of tagStr.split(" ")) {
    let found = [];
    for (let part of name3.split(".")) {
      let value = extra[part] || tags[part];
      if (!value) {
        warnForPart(part, `Unknown highlighting tag ${part}`);
      } else if (typeof value == "function") {
        if (!found.length)
          warnForPart(part, `Modifier ${part} used at start of tag`);
        else
          found = found.map(value);
      } else {
        if (found.length)
          warnForPart(part, `Tag ${part} used as modifier`);
        else
          found = Array.isArray(value) ? value : [value];
      }
    }
    for (let tag2 of found)
      tags$1.push(tag2);
  }
  if (!tags$1.length)
    return 0;
  let name2 = tagStr.replace(/ /g, "_"), key = name2 + " " + tags$1.map((t4) => t4.id);
  let known = byTag[key];
  if (known)
    return known.id;
  let type = byTag[key] = NodeType$1.define({
    id: typeArray.length,
    name: name2,
    props: [styleTags({ [name2]: tags$1 })]
  });
  typeArray.push(type);
  return type.id;
}
({
  rtl: /* @__PURE__ */ Decoration.mark({ class: "cm-iso", inclusive: true, attributes: { dir: "rtl" }, bidiIsolate: Direction.RTL }),
  ltr: /* @__PURE__ */ Decoration.mark({ class: "cm-iso", inclusive: true, attributes: { dir: "ltr" }, bidiIsolate: Direction.LTR })
});
class CompletionContext {
  /**
  Create a new completion context. (Mostly useful for testing
  completion sources—in the editor, the extension will create
  these for you.)
  */
  constructor(state, pos, explicit, view) {
    this.state = state;
    this.pos = pos;
    this.explicit = explicit;
    this.view = view;
    this.abortListeners = [];
    this.abortOnDocChange = false;
  }
  /**
  Get the extent, content, and (if there is a token) type of the
  token before `this.pos`.
  */
  tokenBefore(types2) {
    let token = syntaxTree(this.state).resolveInner(this.pos, -1);
    while (token && types2.indexOf(token.name) < 0)
      token = token.parent;
    return token ? {
      from: token.from,
      to: this.pos,
      text: this.state.sliceDoc(token.from, this.pos),
      type: token.type
    } : null;
  }
  /**
  Get the match of the given expression directly before the
  cursor.
  */
  matchBefore(expr) {
    let line2 = this.state.doc.lineAt(this.pos);
    let start = Math.max(line2.from, this.pos - 250);
    let str = line2.text.slice(start - line2.from, this.pos - line2.from);
    let found = str.search(ensureAnchor(expr, false));
    return found < 0 ? null : { from: start + found, to: this.pos, text: str.slice(found) };
  }
  /**
  Yields true when the query has been aborted. Can be useful in
  asynchronous queries to avoid doing work that will be ignored.
  */
  get aborted() {
    return this.abortListeners == null;
  }
  /**
  Allows you to register abort handlers, which will be called when
  the query is
  [aborted](https://codemirror.net/6/docs/ref/#autocomplete.CompletionContext.aborted).
  
  By default, running queries will not be aborted for regular
  typing or backspacing, on the assumption that they are likely to
  return a result with a
  [`validFor`](https://codemirror.net/6/docs/ref/#autocomplete.CompletionResult.validFor) field that
  allows the result to be used after all. Passing `onDocChange:
  true` will cause this query to be aborted for any document
  change.
  */
  addEventListener(type, listener, options2) {
    if (type == "abort" && this.abortListeners) {
      this.abortListeners.push(listener);
      if (options2 && options2.onDocChange)
        this.abortOnDocChange = true;
    }
  }
}
function toSet(chars) {
  let flat = Object.keys(chars).join("");
  let words = /\w/.test(flat);
  if (words)
    flat = flat.replace(/\w/g, "");
  return `[${words ? "\\w" : ""}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch$1(options2) {
  let first2 = /* @__PURE__ */ Object.create(null), rest2 = /* @__PURE__ */ Object.create(null);
  for (let { label: label2 } of options2) {
    first2[label2[0]] = true;
    for (let i2 = 1; i2 < label2.length; i2++)
      rest2[label2[i2]] = true;
  }
  let source = toSet(first2) + toSet(rest2) + "*$";
  return [new RegExp("^" + source), new RegExp(source)];
}
function completeFromList(list2) {
  let options2 = list2.map((o2) => typeof o2 == "string" ? { label: o2 } : o2);
  let [validFor, match2] = options2.every((o2) => /^\w+$/.test(o2.label)) ? [/\w*$/, /\w+$/] : prefixMatch$1(options2);
  return (context) => {
    let token = context.matchBefore(match2);
    return token || context.explicit ? { from: token ? token.from : context.pos, options: options2, validFor } : null;
  };
}
class Option {
  constructor(completion, source, match2, score2) {
    this.completion = completion;
    this.source = source;
    this.match = match2;
    this.score = score2;
  }
}
function cur(state) {
  return state.selection.main.from;
}
function ensureAnchor(expr, start) {
  var _a2;
  let { source } = expr;
  let addStart = start && source[0] != "^", addEnd = source[source.length - 1] != "$";
  if (!addStart && !addEnd)
    return expr;
  return new RegExp(`${addStart ? "^" : ""}(?:${source})${addEnd ? "$" : ""}`, (_a2 = expr.flags) !== null && _a2 !== void 0 ? _a2 : expr.ignoreCase ? "i" : "");
}
const pickedCompletion = /* @__PURE__ */ Annotation.define();
function insertCompletionText(state, text2, from, to2) {
  let { main: main2 } = state.selection, fromOff = from - main2.from, toOff = to2 - main2.from;
  return {
    ...state.changeByRange((range2) => {
      if (range2 != main2 && from != to2 && state.sliceDoc(range2.from + fromOff, range2.from + toOff) != state.sliceDoc(from, to2))
        return { range: range2 };
      let lines = state.toText(text2);
      return {
        changes: { from: range2.from + fromOff, to: to2 == main2.from ? range2.to : range2.from + toOff, insert: lines },
        range: EditorSelection.cursor(range2.from + fromOff + lines.length)
      };
    }),
    scrollIntoView: true,
    userEvent: "input.complete"
  };
}
const SourceCache = /* @__PURE__ */ new WeakMap();
function asSource(source) {
  if (!Array.isArray(source))
    return source;
  let known = SourceCache.get(source);
  if (!known)
    SourceCache.set(source, known = completeFromList(source));
  return known;
}
const startCompletionEffect = /* @__PURE__ */ StateEffect.define();
const closeCompletionEffect = /* @__PURE__ */ StateEffect.define();
class FuzzyMatcher {
  constructor(pattern) {
    this.pattern = pattern;
    this.chars = [];
    this.folded = [];
    this.any = [];
    this.precise = [];
    this.byWord = [];
    this.score = 0;
    this.matched = [];
    for (let p2 = 0; p2 < pattern.length; ) {
      let char = codePointAt(pattern, p2), size2 = codePointSize(char);
      this.chars.push(char);
      let part = pattern.slice(p2, p2 + size2), upper = part.toUpperCase();
      this.folded.push(codePointAt(upper == part ? part.toLowerCase() : upper, 0));
      p2 += size2;
    }
    this.astral = pattern.length != this.chars.length;
  }
  ret(score2, matched) {
    this.score = score2;
    this.matched = matched;
    return this;
  }
  // Matches a given word (completion) against the pattern (input).
  // Will return a boolean indicating whether there was a match and,
  // on success, set `this.score` to the score, `this.matched` to an
  // array of `from, to` pairs indicating the matched parts of `word`.
  //
  // The score is a number that is more negative the worse the match
  // is. See `Penalty` above.
  match(word) {
    if (this.pattern.length == 0)
      return this.ret(-100, []);
    if (word.length < this.pattern.length)
      return null;
    let { chars, folded, any, precise, byWord } = this;
    if (chars.length == 1) {
      let first2 = codePointAt(word, 0), firstSize = codePointSize(first2);
      let score2 = firstSize == word.length ? 0 : -100;
      if (first2 == chars[0]) ;
      else if (first2 == folded[0])
        score2 += -200;
      else
        return null;
      return this.ret(score2, [0, firstSize]);
    }
    let direct = word.indexOf(this.pattern);
    if (direct == 0)
      return this.ret(word.length == this.pattern.length ? 0 : -100, [0, this.pattern.length]);
    let len = chars.length, anyTo = 0;
    if (direct < 0) {
      for (let i2 = 0, e2 = Math.min(word.length, 200); i2 < e2 && anyTo < len; ) {
        let next = codePointAt(word, i2);
        if (next == chars[anyTo] || next == folded[anyTo])
          any[anyTo++] = i2;
        i2 += codePointSize(next);
      }
      if (anyTo < len)
        return null;
    }
    let preciseTo = 0;
    let byWordTo = 0, byWordFolded = false;
    let adjacentTo = 0, adjacentStart = -1, adjacentEnd = -1;
    let hasLower = /[a-z]/.test(word), wordAdjacent = true;
    for (let i2 = 0, e2 = Math.min(word.length, 200), prevType = 0; i2 < e2 && byWordTo < len; ) {
      let next = codePointAt(word, i2);
      if (direct < 0) {
        if (preciseTo < len && next == chars[preciseTo])
          precise[preciseTo++] = i2;
        if (adjacentTo < len) {
          if (next == chars[adjacentTo] || next == folded[adjacentTo]) {
            if (adjacentTo == 0)
              adjacentStart = i2;
            adjacentEnd = i2 + 1;
            adjacentTo++;
          } else {
            adjacentTo = 0;
          }
        }
      }
      let ch, type = next < 255 ? next >= 48 && next <= 57 || next >= 97 && next <= 122 ? 2 : next >= 65 && next <= 90 ? 1 : 0 : (ch = fromCodePoint(next)) != ch.toLowerCase() ? 1 : ch != ch.toUpperCase() ? 2 : 0;
      if (!i2 || type == 1 && hasLower || prevType == 0 && type != 0) {
        if (chars[byWordTo] == next || folded[byWordTo] == next && (byWordFolded = true))
          byWord[byWordTo++] = i2;
        else if (byWord.length)
          wordAdjacent = false;
      }
      prevType = type;
      i2 += codePointSize(next);
    }
    if (byWordTo == len && byWord[0] == 0 && wordAdjacent)
      return this.result(-100 + (byWordFolded ? -200 : 0), byWord, word);
    if (adjacentTo == len && adjacentStart == 0)
      return this.ret(-200 - word.length + (adjacentEnd == word.length ? 0 : -100), [0, adjacentEnd]);
    if (direct > -1)
      return this.ret(-700 - word.length, [direct, direct + this.pattern.length]);
    if (adjacentTo == len)
      return this.ret(-200 + -700 - word.length, [adjacentStart, adjacentEnd]);
    if (byWordTo == len)
      return this.result(-100 + (byWordFolded ? -200 : 0) + -700 + (wordAdjacent ? 0 : -1100), byWord, word);
    return chars.length == 2 ? null : this.result((any[0] ? -700 : 0) + -200 + -1100, any, word);
  }
  result(score2, positions, word) {
    let result2 = [], i2 = 0;
    for (let pos of positions) {
      let to2 = pos + (this.astral ? codePointSize(codePointAt(word, pos)) : 1);
      if (i2 && result2[i2 - 1] == pos)
        result2[i2 - 1] = to2;
      else {
        result2[i2++] = pos;
        result2[i2++] = to2;
      }
    }
    return this.ret(score2 - word.length, result2);
  }
}
class StrictMatcher {
  constructor(pattern) {
    this.pattern = pattern;
    this.matched = [];
    this.score = 0;
    this.folded = pattern.toLowerCase();
  }
  match(word) {
    if (word.length < this.pattern.length)
      return null;
    let start = word.slice(0, this.pattern.length);
    let match2 = start == this.pattern ? 0 : start.toLowerCase() == this.folded ? -200 : null;
    if (match2 == null)
      return null;
    this.matched = [0, start.length];
    this.score = match2 + (word.length == this.pattern.length ? 0 : -100);
    return this;
  }
}
const completionConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      activateOnTyping: true,
      activateOnCompletion: () => false,
      activateOnTypingDelay: 100,
      selectOnOpen: true,
      override: null,
      closeOnBlur: true,
      maxRenderedOptions: 100,
      defaultKeymap: true,
      tooltipClass: () => "",
      optionClass: () => "",
      aboveCursor: false,
      icons: true,
      addToOptions: [],
      positionInfo: defaultPositionInfo,
      filterStrict: false,
      compareCompletions: (a2, b2) => (a2.sortText || a2.label).localeCompare(b2.sortText || b2.label),
      interactionDelay: 75,
      updateSyncTime: 100
    }, {
      defaultKeymap: (a2, b2) => a2 && b2,
      closeOnBlur: (a2, b2) => a2 && b2,
      icons: (a2, b2) => a2 && b2,
      tooltipClass: (a2, b2) => (c2) => joinClass(a2(c2), b2(c2)),
      optionClass: (a2, b2) => (c2) => joinClass(a2(c2), b2(c2)),
      addToOptions: (a2, b2) => a2.concat(b2),
      filterStrict: (a2, b2) => a2 || b2
    });
  }
});
function joinClass(a2, b2) {
  return a2 ? b2 ? a2 + " " + b2 : a2 : b2;
}
function defaultPositionInfo(view, list2, option, info, space, tooltip) {
  let rtl = view.textDirection == Direction.RTL, left = rtl, narrow = false;
  let side = "top", offset2, maxWidth;
  let spaceLeft = list2.left - space.left, spaceRight = space.right - list2.right;
  let infoWidth = info.right - info.left, infoHeight = info.bottom - info.top;
  if (left && spaceLeft < Math.min(infoWidth, spaceRight))
    left = false;
  else if (!left && spaceRight < Math.min(infoWidth, spaceLeft))
    left = true;
  if (infoWidth <= (left ? spaceLeft : spaceRight)) {
    offset2 = Math.max(space.top, Math.min(option.top, space.bottom - infoHeight)) - list2.top;
    maxWidth = Math.min(400, left ? spaceLeft : spaceRight);
  } else {
    narrow = true;
    maxWidth = Math.min(
      400,
      (rtl ? list2.right : space.right - list2.left) - 30
      /* Info.Margin */
    );
    let spaceBelow = space.bottom - list2.bottom;
    if (spaceBelow >= infoHeight || spaceBelow > list2.top) {
      offset2 = option.bottom - list2.top;
    } else {
      side = "bottom";
      offset2 = list2.bottom - option.top;
    }
  }
  let scaleY = (list2.bottom - list2.top) / tooltip.offsetHeight;
  let scaleX = (list2.right - list2.left) / tooltip.offsetWidth;
  return {
    style: `${side}: ${offset2 / scaleY}px; max-width: ${maxWidth / scaleX}px`,
    class: "cm-completionInfo-" + (narrow ? rtl ? "left-narrow" : "right-narrow" : left ? "left" : "right")
  };
}
function optionContent(config2) {
  let content2 = config2.addToOptions.slice();
  if (config2.icons)
    content2.push({
      render(completion) {
        let icon = document.createElement("div");
        icon.classList.add("cm-completionIcon");
        if (completion.type)
          icon.classList.add(...completion.type.split(/\s+/g).map((cls) => "cm-completionIcon-" + cls));
        icon.setAttribute("aria-hidden", "true");
        return icon;
      },
      position: 20
    });
  content2.push({
    render(completion, _s, _v, match2) {
      let labelElt = document.createElement("span");
      labelElt.className = "cm-completionLabel";
      let label2 = completion.displayLabel || completion.label, off = 0;
      for (let j2 = 0; j2 < match2.length; ) {
        let from = match2[j2++], to2 = match2[j2++];
        if (from > off)
          labelElt.appendChild(document.createTextNode(label2.slice(off, from)));
        let span = labelElt.appendChild(document.createElement("span"));
        span.appendChild(document.createTextNode(label2.slice(from, to2)));
        span.className = "cm-completionMatchedText";
        off = to2;
      }
      if (off < label2.length)
        labelElt.appendChild(document.createTextNode(label2.slice(off)));
      return labelElt;
    },
    position: 50
  }, {
    render(completion) {
      if (!completion.detail)
        return null;
      let detailElt = document.createElement("span");
      detailElt.className = "cm-completionDetail";
      detailElt.textContent = completion.detail;
      return detailElt;
    },
    position: 80
  });
  return content2.sort((a2, b2) => a2.position - b2.position).map((a2) => a2.render);
}
function rangeAroundSelected(total, selected, max2) {
  if (total <= max2)
    return { from: 0, to: total };
  if (selected < 0)
    selected = 0;
  if (selected <= total >> 1) {
    let off2 = Math.floor(selected / max2);
    return { from: off2 * max2, to: (off2 + 1) * max2 };
  }
  let off = Math.floor((total - selected) / max2);
  return { from: total - (off + 1) * max2, to: total - off * max2 };
}
class CompletionTooltip {
  constructor(view, stateField, applyCompletion2) {
    this.view = view;
    this.stateField = stateField;
    this.applyCompletion = applyCompletion2;
    this.info = null;
    this.infoDestroy = null;
    this.placeInfoReq = {
      read: () => this.measureInfo(),
      write: (pos) => this.placeInfo(pos),
      key: this
    };
    this.space = null;
    this.currentClass = "";
    let cState = view.state.field(stateField);
    let { options: options2, selected } = cState.open;
    let config2 = view.state.facet(completionConfig);
    this.optionContent = optionContent(config2);
    this.optionClass = config2.optionClass;
    this.tooltipClass = config2.tooltipClass;
    this.range = rangeAroundSelected(options2.length, selected, config2.maxRenderedOptions);
    this.dom = document.createElement("div");
    this.dom.className = "cm-tooltip-autocomplete";
    this.updateTooltipClass(view.state);
    this.dom.addEventListener("mousedown", (e2) => {
      let { options: options22 } = view.state.field(stateField).open;
      for (let dom = e2.target, match2; dom && dom != this.dom; dom = dom.parentNode) {
        if (dom.nodeName == "LI" && (match2 = /-(\d+)$/.exec(dom.id)) && +match2[1] < options22.length) {
          this.applyCompletion(view, options22[+match2[1]]);
          e2.preventDefault();
          return;
        }
      }
    });
    this.dom.addEventListener("focusout", (e2) => {
      let state = view.state.field(this.stateField, false);
      if (state && state.tooltip && view.state.facet(completionConfig).closeOnBlur && e2.relatedTarget != view.contentDOM)
        view.dispatch({ effects: closeCompletionEffect.of(null) });
    });
    this.showOptions(options2, cState.id);
  }
  mount() {
    this.updateSel();
  }
  showOptions(options2, id2) {
    if (this.list)
      this.list.remove();
    this.list = this.dom.appendChild(this.createListBox(options2, id2, this.range));
    this.list.addEventListener("scroll", () => {
      if (this.info)
        this.view.requestMeasure(this.placeInfoReq);
    });
  }
  update(update) {
    var _a2;
    let cState = update.state.field(this.stateField);
    let prevState = update.startState.field(this.stateField);
    this.updateTooltipClass(update.state);
    if (cState != prevState) {
      let { options: options2, selected, disabled } = cState.open;
      if (!prevState.open || prevState.open.options != options2) {
        this.range = rangeAroundSelected(options2.length, selected, update.state.facet(completionConfig).maxRenderedOptions);
        this.showOptions(options2, cState.id);
      }
      this.updateSel();
      if (disabled != ((_a2 = prevState.open) === null || _a2 === void 0 ? void 0 : _a2.disabled))
        this.dom.classList.toggle("cm-tooltip-autocomplete-disabled", !!disabled);
    }
  }
  updateTooltipClass(state) {
    let cls = this.tooltipClass(state);
    if (cls != this.currentClass) {
      for (let c2 of this.currentClass.split(" "))
        if (c2)
          this.dom.classList.remove(c2);
      for (let c2 of cls.split(" "))
        if (c2)
          this.dom.classList.add(c2);
      this.currentClass = cls;
    }
  }
  positioned(space) {
    this.space = space;
    if (this.info)
      this.view.requestMeasure(this.placeInfoReq);
  }
  updateSel() {
    let cState = this.view.state.field(this.stateField), open = cState.open;
    if (open.selected > -1 && open.selected < this.range.from || open.selected >= this.range.to) {
      this.range = rangeAroundSelected(open.options.length, open.selected, this.view.state.facet(completionConfig).maxRenderedOptions);
      this.showOptions(open.options, cState.id);
    }
    let newSel = this.updateSelectedOption(open.selected);
    if (newSel) {
      this.destroyInfo();
      let { completion } = open.options[open.selected];
      let { info } = completion;
      if (!info)
        return;
      let infoResult = typeof info === "string" ? document.createTextNode(info) : info(completion);
      if (!infoResult)
        return;
      if ("then" in infoResult) {
        infoResult.then((obj) => {
          if (obj && this.view.state.field(this.stateField, false) == cState)
            this.addInfoPane(obj, completion);
        }).catch((e2) => logException(this.view.state, e2, "completion info"));
      } else {
        this.addInfoPane(infoResult, completion);
        newSel.setAttribute("aria-describedby", this.info.id);
      }
    }
  }
  addInfoPane(content2, completion) {
    this.destroyInfo();
    let wrap2 = this.info = document.createElement("div");
    wrap2.className = "cm-tooltip cm-completionInfo";
    wrap2.id = "cm-completionInfo-" + Math.floor(Math.random() * 65535).toString(16);
    if (content2.nodeType != null) {
      wrap2.appendChild(content2);
      this.infoDestroy = null;
    } else {
      let { dom, destroy } = content2;
      wrap2.appendChild(dom);
      this.infoDestroy = destroy || null;
    }
    this.dom.appendChild(wrap2);
    this.view.requestMeasure(this.placeInfoReq);
  }
  updateSelectedOption(selected) {
    let set2 = null;
    for (let opt = this.list.firstChild, i2 = this.range.from; opt; opt = opt.nextSibling, i2++) {
      if (opt.nodeName != "LI" || !opt.id) {
        i2--;
      } else if (i2 == selected) {
        if (!opt.hasAttribute("aria-selected")) {
          opt.setAttribute("aria-selected", "true");
          set2 = opt;
        }
      } else {
        if (opt.hasAttribute("aria-selected")) {
          opt.removeAttribute("aria-selected");
          opt.removeAttribute("aria-describedby");
        }
      }
    }
    if (set2)
      scrollIntoView(this.list, set2);
    return set2;
  }
  measureInfo() {
    let sel = this.dom.querySelector("[aria-selected]");
    if (!sel || !this.info)
      return null;
    let listRect = this.dom.getBoundingClientRect();
    let infoRect = this.info.getBoundingClientRect();
    let selRect = sel.getBoundingClientRect();
    let space = this.space;
    if (!space) {
      let docElt = this.dom.ownerDocument.documentElement;
      space = { left: 0, top: 0, right: docElt.clientWidth, bottom: docElt.clientHeight };
    }
    if (selRect.top > Math.min(space.bottom, listRect.bottom) - 10 || selRect.bottom < Math.max(space.top, listRect.top) + 10)
      return null;
    return this.view.state.facet(completionConfig).positionInfo(this.view, listRect, selRect, infoRect, space, this.dom);
  }
  placeInfo(pos) {
    if (this.info) {
      if (pos) {
        if (pos.style)
          this.info.style.cssText = pos.style;
        this.info.className = "cm-tooltip cm-completionInfo " + (pos.class || "");
      } else {
        this.info.style.cssText = "top: -1e6px";
      }
    }
  }
  createListBox(options2, id2, range2) {
    const ul = document.createElement("ul");
    ul.id = id2;
    ul.setAttribute("role", "listbox");
    ul.setAttribute("aria-expanded", "true");
    ul.setAttribute("aria-label", this.view.state.phrase("Completions"));
    ul.addEventListener("mousedown", (e2) => {
      if (e2.target == ul)
        e2.preventDefault();
    });
    let curSection = null;
    for (let i2 = range2.from; i2 < range2.to; i2++) {
      let { completion, match: match2 } = options2[i2], { section } = completion;
      if (section) {
        let name2 = typeof section == "string" ? section : section.name;
        if (name2 != curSection && (i2 > range2.from || range2.from == 0)) {
          curSection = name2;
          if (typeof section != "string" && section.header) {
            ul.appendChild(section.header(section));
          } else {
            let header = ul.appendChild(document.createElement("completion-section"));
            header.textContent = name2;
          }
        }
      }
      const li2 = ul.appendChild(document.createElement("li"));
      li2.id = id2 + "-" + i2;
      li2.setAttribute("role", "option");
      let cls = this.optionClass(completion);
      if (cls)
        li2.className = cls;
      for (let source of this.optionContent) {
        let node = source(completion, this.view.state, this.view, match2);
        if (node)
          li2.appendChild(node);
      }
    }
    if (range2.from)
      ul.classList.add("cm-completionListIncompleteTop");
    if (range2.to < options2.length)
      ul.classList.add("cm-completionListIncompleteBottom");
    return ul;
  }
  destroyInfo() {
    if (this.info) {
      if (this.infoDestroy)
        this.infoDestroy();
      this.info.remove();
      this.info = null;
    }
  }
  destroy() {
    this.destroyInfo();
  }
}
function completionTooltip(stateField, applyCompletion2) {
  return (view) => new CompletionTooltip(view, stateField, applyCompletion2);
}
function scrollIntoView(container, element2) {
  let parent = container.getBoundingClientRect();
  let self2 = element2.getBoundingClientRect();
  let scaleY = parent.height / container.offsetHeight;
  if (self2.top < parent.top)
    container.scrollTop -= (parent.top - self2.top) / scaleY;
  else if (self2.bottom > parent.bottom)
    container.scrollTop += (self2.bottom - parent.bottom) / scaleY;
}
function score(option) {
  return (option.boost || 0) * 100 + (option.apply ? 10 : 0) + (option.info ? 5 : 0) + (option.type ? 1 : 0);
}
function sortOptions(active, state) {
  let options2 = [];
  let sections = null, dynamicSectionScore = null;
  let addOption = (option) => {
    options2.push(option);
    let { section } = option.completion;
    if (section) {
      if (!sections)
        sections = [];
      let name2 = typeof section == "string" ? section : section.name;
      if (!sections.some((s2) => s2.name == name2))
        sections.push(typeof section == "string" ? { name: name2 } : section);
    }
  };
  let conf = state.facet(completionConfig);
  for (let a2 of active)
    if (a2.hasResult()) {
      let getMatch = a2.result.getMatch;
      if (a2.result.filter === false) {
        for (let option of a2.result.options) {
          addOption(new Option(option, a2.source, getMatch ? getMatch(option) : [], 1e9 - options2.length));
        }
      } else {
        let pattern = state.sliceDoc(a2.from, a2.to), match2;
        let matcher2 = conf.filterStrict ? new StrictMatcher(pattern) : new FuzzyMatcher(pattern);
        for (let option of a2.result.options)
          if (match2 = matcher2.match(option.label)) {
            let matched = !option.displayLabel ? match2.matched : getMatch ? getMatch(option, match2.matched) : [];
            let score2 = match2.score + (option.boost || 0);
            addOption(new Option(option, a2.source, matched, score2));
            if (typeof option.section == "object" && option.section.rank === "dynamic") {
              let { name: name2 } = option.section;
              if (!dynamicSectionScore)
                dynamicSectionScore = /* @__PURE__ */ Object.create(null);
              dynamicSectionScore[name2] = Math.max(score2, dynamicSectionScore[name2] || -1e9);
            }
          }
      }
    }
  if (sections) {
    let sectionOrder = /* @__PURE__ */ Object.create(null), pos = 0;
    let cmp = (a2, b2) => {
      return (a2.rank === "dynamic" && b2.rank === "dynamic" ? dynamicSectionScore[b2.name] - dynamicSectionScore[a2.name] : 0) || (typeof a2.rank == "number" ? a2.rank : 1e9) - (typeof b2.rank == "number" ? b2.rank : 1e9) || (a2.name < b2.name ? -1 : 1);
    };
    for (let s2 of sections.sort(cmp)) {
      pos -= 1e5;
      sectionOrder[s2.name] = pos;
    }
    for (let option of options2) {
      let { section } = option.completion;
      if (section)
        option.score += sectionOrder[typeof section == "string" ? section : section.name];
    }
  }
  let result2 = [], prev = null;
  let compare2 = conf.compareCompletions;
  for (let opt of options2.sort((a2, b2) => b2.score - a2.score || compare2(a2.completion, b2.completion))) {
    let cur2 = opt.completion;
    if (!prev || prev.label != cur2.label || prev.detail != cur2.detail || prev.type != null && cur2.type != null && prev.type != cur2.type || prev.apply != cur2.apply || prev.boost != cur2.boost)
      result2.push(opt);
    else if (score(opt.completion) > score(prev))
      result2[result2.length - 1] = opt;
    prev = opt.completion;
  }
  return result2;
}
class CompletionDialog {
  constructor(options2, attrs, tooltip, timestamp, selected, disabled) {
    this.options = options2;
    this.attrs = attrs;
    this.tooltip = tooltip;
    this.timestamp = timestamp;
    this.selected = selected;
    this.disabled = disabled;
  }
  setSelected(selected, id2) {
    return selected == this.selected || selected >= this.options.length ? this : new CompletionDialog(this.options, makeAttrs(id2, selected), this.tooltip, this.timestamp, selected, this.disabled);
  }
  static build(active, state, id2, prev, conf, didSetActive) {
    if (prev && !didSetActive && active.some((s2) => s2.isPending))
      return prev.setDisabled();
    let options2 = sortOptions(active, state);
    if (!options2.length)
      return prev && active.some((a2) => a2.isPending) ? prev.setDisabled() : null;
    let selected = state.facet(completionConfig).selectOnOpen ? 0 : -1;
    if (prev && prev.selected != selected && prev.selected != -1) {
      let selectedValue = prev.options[prev.selected].completion;
      for (let i2 = 0; i2 < options2.length; i2++)
        if (options2[i2].completion == selectedValue) {
          selected = i2;
          break;
        }
    }
    return new CompletionDialog(options2, makeAttrs(id2, selected), {
      pos: active.reduce((a2, b2) => b2.hasResult() ? Math.min(a2, b2.from) : a2, 1e8),
      create: createTooltip,
      above: conf.aboveCursor
    }, prev ? prev.timestamp : Date.now(), selected, false);
  }
  map(changes) {
    return new CompletionDialog(this.options, this.attrs, { ...this.tooltip, pos: changes.mapPos(this.tooltip.pos) }, this.timestamp, this.selected, this.disabled);
  }
  setDisabled() {
    return new CompletionDialog(this.options, this.attrs, this.tooltip, this.timestamp, this.selected, true);
  }
}
class CompletionState {
  constructor(active, id2, open) {
    this.active = active;
    this.id = id2;
    this.open = open;
  }
  static start() {
    return new CompletionState(none$1, "cm-ac-" + Math.floor(Math.random() * 2e6).toString(36), null);
  }
  update(tr2) {
    let { state } = tr2, conf = state.facet(completionConfig);
    let sources = conf.override || state.languageDataAt("autocomplete", cur(state)).map(asSource);
    let active = sources.map((source) => {
      let value = this.active.find((s2) => s2.source == source) || new ActiveSource(
        source,
        this.active.some(
          (a2) => a2.state != 0
          /* State.Inactive */
        ) ? 1 : 0
        /* State.Inactive */
      );
      return value.update(tr2, conf);
    });
    if (active.length == this.active.length && active.every((a2, i2) => a2 == this.active[i2]))
      active = this.active;
    let open = this.open, didSet = tr2.effects.some((e2) => e2.is(setActiveEffect));
    if (open && tr2.docChanged)
      open = open.map(tr2.changes);
    if (tr2.selection || active.some((a2) => a2.hasResult() && tr2.changes.touchesRange(a2.from, a2.to)) || !sameResults(active, this.active) || didSet)
      open = CompletionDialog.build(active, state, this.id, open, conf, didSet);
    else if (open && open.disabled && !active.some((a2) => a2.isPending))
      open = null;
    if (!open && active.every((a2) => !a2.isPending) && active.some((a2) => a2.hasResult()))
      active = active.map((a2) => a2.hasResult() ? new ActiveSource(
        a2.source,
        0
        /* State.Inactive */
      ) : a2);
    for (let effect of tr2.effects)
      if (effect.is(setSelectedEffect))
        open = open && open.setSelected(effect.value, this.id);
    return active == this.active && open == this.open ? this : new CompletionState(active, this.id, open);
  }
  get tooltip() {
    return this.open ? this.open.tooltip : null;
  }
  get attrs() {
    return this.open ? this.open.attrs : this.active.length ? baseAttrs : noAttrs;
  }
}
function sameResults(a2, b2) {
  if (a2 == b2)
    return true;
  for (let iA = 0, iB = 0; ; ) {
    while (iA < a2.length && !a2[iA].hasResult())
      iA++;
    while (iB < b2.length && !b2[iB].hasResult())
      iB++;
    let endA = iA == a2.length, endB = iB == b2.length;
    if (endA || endB)
      return endA == endB;
    if (a2[iA++].result != b2[iB++].result)
      return false;
  }
}
const baseAttrs = {
  "aria-autocomplete": "list"
};
const noAttrs = {};
function makeAttrs(id2, selected) {
  let result2 = {
    "aria-autocomplete": "list",
    "aria-haspopup": "listbox",
    "aria-controls": id2
  };
  if (selected > -1)
    result2["aria-activedescendant"] = id2 + "-" + selected;
  return result2;
}
const none$1 = [];
function getUpdateType(tr2, conf) {
  if (tr2.isUserEvent("input.complete")) {
    let completion = tr2.annotation(pickedCompletion);
    if (completion && conf.activateOnCompletion(completion))
      return 4 | 8;
  }
  let typing = tr2.isUserEvent("input.type");
  return typing && conf.activateOnTyping ? 4 | 1 : typing ? 1 : tr2.isUserEvent("delete.backward") ? 2 : tr2.selection ? 8 : tr2.docChanged ? 16 : 0;
}
class ActiveSource {
  constructor(source, state, explicit = false) {
    this.source = source;
    this.state = state;
    this.explicit = explicit;
  }
  hasResult() {
    return false;
  }
  get isPending() {
    return this.state == 1;
  }
  update(tr2, conf) {
    let type = getUpdateType(tr2, conf), value = this;
    if (type & 8 || type & 16 && this.touches(tr2))
      value = new ActiveSource(
        value.source,
        0
        /* State.Inactive */
      );
    if (type & 4 && value.state == 0)
      value = new ActiveSource(
        this.source,
        1
        /* State.Pending */
      );
    value = value.updateFor(tr2, type);
    for (let effect of tr2.effects) {
      if (effect.is(startCompletionEffect))
        value = new ActiveSource(value.source, 1, effect.value);
      else if (effect.is(closeCompletionEffect))
        value = new ActiveSource(
          value.source,
          0
          /* State.Inactive */
        );
      else if (effect.is(setActiveEffect)) {
        for (let active of effect.value)
          if (active.source == value.source)
            value = active;
      }
    }
    return value;
  }
  updateFor(tr2, type) {
    return this.map(tr2.changes);
  }
  map(changes) {
    return this;
  }
  touches(tr2) {
    return tr2.changes.touchesRange(cur(tr2.state));
  }
}
class ActiveResult extends ActiveSource {
  constructor(source, explicit, limit, result2, from, to2) {
    super(source, 3, explicit);
    this.limit = limit;
    this.result = result2;
    this.from = from;
    this.to = to2;
  }
  hasResult() {
    return true;
  }
  updateFor(tr2, type) {
    var _a2;
    if (!(type & 3))
      return this.map(tr2.changes);
    let result2 = this.result;
    if (result2.map && !tr2.changes.empty)
      result2 = result2.map(result2, tr2.changes);
    let from = tr2.changes.mapPos(this.from), to2 = tr2.changes.mapPos(this.to, 1);
    let pos = cur(tr2.state);
    if (pos > to2 || !result2 || type & 2 && (cur(tr2.startState) == this.from || pos < this.limit))
      return new ActiveSource(
        this.source,
        type & 4 ? 1 : 0
        /* State.Inactive */
      );
    let limit = tr2.changes.mapPos(this.limit);
    if (checkValid(result2.validFor, tr2.state, from, to2))
      return new ActiveResult(this.source, this.explicit, limit, result2, from, to2);
    if (result2.update && (result2 = result2.update(result2, from, to2, new CompletionContext(tr2.state, pos, false))))
      return new ActiveResult(this.source, this.explicit, limit, result2, result2.from, (_a2 = result2.to) !== null && _a2 !== void 0 ? _a2 : cur(tr2.state));
    return new ActiveSource(this.source, 1, this.explicit);
  }
  map(mapping) {
    if (mapping.empty)
      return this;
    let result2 = this.result.map ? this.result.map(this.result, mapping) : this.result;
    if (!result2)
      return new ActiveSource(
        this.source,
        0
        /* State.Inactive */
      );
    return new ActiveResult(this.source, this.explicit, mapping.mapPos(this.limit), this.result, mapping.mapPos(this.from), mapping.mapPos(this.to, 1));
  }
  touches(tr2) {
    return tr2.changes.touchesRange(this.from, this.to);
  }
}
function checkValid(validFor, state, from, to2) {
  if (!validFor)
    return false;
  let text2 = state.sliceDoc(from, to2);
  return typeof validFor == "function" ? validFor(text2, from, to2, state) : ensureAnchor(validFor, true).test(text2);
}
const setActiveEffect = /* @__PURE__ */ StateEffect.define({
  map(sources, mapping) {
    return sources.map((s2) => s2.map(mapping));
  }
});
const setSelectedEffect = /* @__PURE__ */ StateEffect.define();
const completionState = /* @__PURE__ */ StateField.define({
  create() {
    return CompletionState.start();
  },
  update(value, tr2) {
    return value.update(tr2);
  },
  provide: (f2) => [
    showTooltip.from(f2, (val) => val.tooltip),
    EditorView.contentAttributes.from(f2, (state) => state.attrs)
  ]
});
function applyCompletion(view, option) {
  const apply = option.completion.apply || option.completion.label;
  let result2 = view.state.field(completionState).active.find((a2) => a2.source == option.source);
  if (!(result2 instanceof ActiveResult))
    return false;
  if (typeof apply == "string")
    view.dispatch({
      ...insertCompletionText(view.state, apply, result2.from, result2.to),
      annotations: pickedCompletion.of(option.completion)
    });
  else
    apply(view, option.completion, result2.from, result2.to);
  return true;
}
const createTooltip = /* @__PURE__ */ completionTooltip(completionState, applyCompletion);
function moveCompletionSelection(forward, by = "option") {
  return (view) => {
    let cState = view.state.field(completionState, false);
    if (!cState || !cState.open || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
      return false;
    let step = 1, tooltip;
    if (by == "page" && (tooltip = getTooltip(view, cState.open.tooltip)))
      step = Math.max(2, Math.floor(tooltip.dom.offsetHeight / tooltip.dom.querySelector("li").offsetHeight) - 1);
    let { length } = cState.open.options;
    let selected = cState.open.selected > -1 ? cState.open.selected + step * (forward ? 1 : -1) : forward ? 0 : length - 1;
    if (selected < 0)
      selected = by == "page" ? 0 : length - 1;
    else if (selected >= length)
      selected = by == "page" ? length - 1 : 0;
    view.dispatch({ effects: setSelectedEffect.of(selected) });
    return true;
  };
}
const acceptCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (view.state.readOnly || !cState || !cState.open || cState.open.selected < 0 || cState.open.disabled || Date.now() - cState.open.timestamp < view.state.facet(completionConfig).interactionDelay)
    return false;
  return applyCompletion(view, cState.open.options[cState.open.selected]);
};
const startCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState)
    return false;
  view.dispatch({ effects: startCompletionEffect.of(true) });
  return true;
};
const closeCompletion = (view) => {
  let cState = view.state.field(completionState, false);
  if (!cState || !cState.active.some(
    (a2) => a2.state != 0
    /* State.Inactive */
  ))
    return false;
  view.dispatch({ effects: closeCompletionEffect.of(null) });
  return true;
};
class RunningQuery {
  constructor(active, context) {
    this.active = active;
    this.context = context;
    this.time = Date.now();
    this.updates = [];
    this.done = void 0;
  }
}
const MaxUpdateCount = 50, MinAbortTime = 1e3;
const completionPlugin = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.debounceUpdate = -1;
    this.running = [];
    this.debounceAccept = -1;
    this.pendingStart = false;
    this.composing = 0;
    for (let active of view.state.field(completionState).active)
      if (active.isPending)
        this.startQuery(active);
  }
  update(update) {
    let cState = update.state.field(completionState);
    let conf = update.state.facet(completionConfig);
    if (!update.selectionSet && !update.docChanged && update.startState.field(completionState) == cState)
      return;
    let doesReset = update.transactions.some((tr2) => {
      let type = getUpdateType(tr2, conf);
      return type & 8 || (tr2.selection || tr2.docChanged) && !(type & 3);
    });
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (doesReset || query.context.abortOnDocChange && update.docChanged || query.updates.length + update.transactions.length > MaxUpdateCount && Date.now() - query.time > MinAbortTime) {
        for (let handler of query.context.abortListeners) {
          try {
            handler();
          } catch (e2) {
            logException(this.view.state, e2);
          }
        }
        query.context.abortListeners = null;
        this.running.splice(i2--, 1);
      } else {
        query.updates.push(...update.transactions);
      }
    }
    if (this.debounceUpdate > -1)
      clearTimeout(this.debounceUpdate);
    if (update.transactions.some((tr2) => tr2.effects.some((e2) => e2.is(startCompletionEffect))))
      this.pendingStart = true;
    let delay = this.pendingStart ? 50 : conf.activateOnTypingDelay;
    this.debounceUpdate = cState.active.some((a2) => a2.isPending && !this.running.some((q2) => q2.active.source == a2.source)) ? setTimeout(() => this.startUpdate(), delay) : -1;
    if (this.composing != 0)
      for (let tr2 of update.transactions) {
        if (tr2.isUserEvent("input.type"))
          this.composing = 2;
        else if (this.composing == 2 && tr2.selection)
          this.composing = 3;
      }
  }
  startUpdate() {
    this.debounceUpdate = -1;
    this.pendingStart = false;
    let { state } = this.view, cState = state.field(completionState);
    for (let active of cState.active) {
      if (active.isPending && !this.running.some((r2) => r2.active.source == active.source))
        this.startQuery(active);
    }
    if (this.running.length && cState.open && cState.open.disabled)
      this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(completionConfig).updateSyncTime);
  }
  startQuery(active) {
    let { state } = this.view, pos = cur(state);
    let context = new CompletionContext(state, pos, active.explicit, this.view);
    let pending = new RunningQuery(active, context);
    this.running.push(pending);
    Promise.resolve(active.source(context)).then((result2) => {
      if (!pending.context.aborted) {
        pending.done = result2 || null;
        this.scheduleAccept();
      }
    }, (err) => {
      this.view.dispatch({ effects: closeCompletionEffect.of(null) });
      logException(this.view.state, err);
    });
  }
  scheduleAccept() {
    if (this.running.every((q2) => q2.done !== void 0))
      this.accept();
    else if (this.debounceAccept < 0)
      this.debounceAccept = setTimeout(() => this.accept(), this.view.state.facet(completionConfig).updateSyncTime);
  }
  // For each finished query in this.running, try to create a result
  // or, if appropriate, restart the query.
  accept() {
    var _a2;
    if (this.debounceAccept > -1)
      clearTimeout(this.debounceAccept);
    this.debounceAccept = -1;
    let updated = [];
    let conf = this.view.state.facet(completionConfig), cState = this.view.state.field(completionState);
    for (let i2 = 0; i2 < this.running.length; i2++) {
      let query = this.running[i2];
      if (query.done === void 0)
        continue;
      this.running.splice(i2--, 1);
      if (query.done) {
        let pos = cur(query.updates.length ? query.updates[0].startState : this.view.state);
        let limit = Math.min(pos, query.done.from + (query.active.explicit ? 0 : 1));
        let active = new ActiveResult(query.active.source, query.active.explicit, limit, query.done, query.done.from, (_a2 = query.done.to) !== null && _a2 !== void 0 ? _a2 : pos);
        for (let tr2 of query.updates)
          active = active.update(tr2, conf);
        if (active.hasResult()) {
          updated.push(active);
          continue;
        }
      }
      let current2 = cState.active.find((a2) => a2.source == query.active.source);
      if (current2 && current2.isPending) {
        if (query.done == null) {
          let active = new ActiveSource(
            query.active.source,
            0
            /* State.Inactive */
          );
          for (let tr2 of query.updates)
            active = active.update(tr2, conf);
          if (!active.isPending)
            updated.push(active);
        } else {
          this.startQuery(current2);
        }
      }
    }
    if (updated.length || cState.open && cState.open.disabled)
      this.view.dispatch({ effects: setActiveEffect.of(updated) });
  }
}, {
  eventHandlers: {
    blur(event) {
      let state = this.view.state.field(completionState, false);
      if (state && state.tooltip && this.view.state.facet(completionConfig).closeOnBlur) {
        let dialog = state.open && getTooltip(this.view, state.open.tooltip);
        if (!dialog || !dialog.dom.contains(event.relatedTarget))
          setTimeout(() => this.view.dispatch({ effects: closeCompletionEffect.of(null) }), 10);
      }
    },
    compositionstart() {
      this.composing = 1;
    },
    compositionend() {
      if (this.composing == 3) {
        setTimeout(() => this.view.dispatch({ effects: startCompletionEffect.of(false) }), 20);
      }
      this.composing = 0;
    }
  }
});
const windows = typeof navigator == "object" && /* @__PURE__ */ /Win/.test(navigator.platform);
const commitCharacters = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ EditorView.domEventHandlers({
  keydown(event, view) {
    let field = view.state.field(completionState, false);
    if (!field || !field.open || field.open.disabled || field.open.selected < 0 || event.key.length > 1 || event.ctrlKey && !(windows && event.altKey) || event.metaKey)
      return false;
    let option = field.open.options[field.open.selected];
    let result2 = field.active.find((a2) => a2.source == option.source);
    let commitChars = option.completion.commitCharacters || result2.result.commitCharacters;
    if (commitChars && commitChars.indexOf(event.key) > -1)
      applyCompletion(view, option);
    return false;
  }
}));
const baseTheme$3 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-tooltip.cm-tooltip-autocomplete": {
    "& > ul": {
      fontFamily: "monospace",
      whiteSpace: "nowrap",
      overflow: "hidden auto",
      maxWidth_fallback: "700px",
      maxWidth: "min(700px, 95vw)",
      minWidth: "250px",
      maxHeight: "10em",
      height: "100%",
      listStyle: "none",
      margin: 0,
      padding: 0,
      "& > li, & > completion-section": {
        padding: "1px 3px",
        lineHeight: 1.2
      },
      "& > li": {
        overflowX: "hidden",
        textOverflow: "ellipsis",
        cursor: "pointer"
      },
      "& > completion-section": {
        display: "list-item",
        borderBottom: "1px solid silver",
        paddingLeft: "0.5em",
        opacity: 0.7
      }
    }
  },
  "&light .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#17c",
    color: "white"
  },
  "&light .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#777"
  },
  "&dark .cm-tooltip-autocomplete ul li[aria-selected]": {
    background: "#347",
    color: "white"
  },
  "&dark .cm-tooltip-autocomplete-disabled ul li[aria-selected]": {
    background: "#444"
  },
  ".cm-completionListIncompleteTop:before, .cm-completionListIncompleteBottom:after": {
    content: '"···"',
    opacity: 0.5,
    display: "block",
    textAlign: "center"
  },
  ".cm-tooltip.cm-completionInfo": {
    position: "absolute",
    padding: "3px 9px",
    width: "max-content",
    maxWidth: `${400}px`,
    boxSizing: "border-box",
    whiteSpace: "pre-line"
  },
  ".cm-completionInfo.cm-completionInfo-left": { right: "100%" },
  ".cm-completionInfo.cm-completionInfo-right": { left: "100%" },
  ".cm-completionInfo.cm-completionInfo-left-narrow": { right: `${30}px` },
  ".cm-completionInfo.cm-completionInfo-right-narrow": { left: `${30}px` },
  "&light .cm-snippetField": { backgroundColor: "#00000022" },
  "&dark .cm-snippetField": { backgroundColor: "#ffffff22" },
  ".cm-snippetFieldPosition": {
    verticalAlign: "text-top",
    width: 0,
    height: "1.15em",
    display: "inline-block",
    margin: "0 -0.7px -.7em",
    borderLeft: "1.4px dotted #888"
  },
  ".cm-completionMatchedText": {
    textDecoration: "underline"
  },
  ".cm-completionDetail": {
    marginLeft: "0.5em",
    fontStyle: "italic"
  },
  ".cm-completionIcon": {
    fontSize: "90%",
    width: ".8em",
    display: "inline-block",
    textAlign: "center",
    paddingRight: ".6em",
    opacity: "0.6",
    boxSizing: "content-box"
  },
  ".cm-completionIcon-function, .cm-completionIcon-method": {
    "&:after": { content: "'ƒ'" }
  },
  ".cm-completionIcon-class": {
    "&:after": { content: "'○'" }
  },
  ".cm-completionIcon-interface": {
    "&:after": { content: "'◌'" }
  },
  ".cm-completionIcon-variable": {
    "&:after": { content: "'𝑥'" }
  },
  ".cm-completionIcon-constant": {
    "&:after": { content: "'𝐶'" }
  },
  ".cm-completionIcon-type": {
    "&:after": { content: "'𝑡'" }
  },
  ".cm-completionIcon-enum": {
    "&:after": { content: "'∪'" }
  },
  ".cm-completionIcon-property": {
    "&:after": { content: "'□'" }
  },
  ".cm-completionIcon-keyword": {
    "&:after": { content: "'🔑︎'" }
    // Disable emoji rendering
  },
  ".cm-completionIcon-namespace": {
    "&:after": { content: "'▢'" }
  },
  ".cm-completionIcon-text": {
    "&:after": { content: "'abc'", fontSize: "50%", verticalAlign: "middle" }
  }
});
const defaults = {
  brackets: ["(", "[", "{", "'", '"'],
  before: ")]}:;>",
  stringPrefixes: []
};
const closeBracketEffect = /* @__PURE__ */ StateEffect.define({
  map(value, mapping) {
    let mapped = mapping.mapPos(value, -1, MapMode.TrackAfter);
    return mapped == null ? void 0 : mapped;
  }
});
const closedBracket = /* @__PURE__ */ new class extends RangeValue {
}();
closedBracket.startSide = 1;
closedBracket.endSide = -1;
const bracketState = /* @__PURE__ */ StateField.define({
  create() {
    return RangeSet.empty;
  },
  update(value, tr2) {
    value = value.map(tr2.changes);
    if (tr2.selection) {
      let line2 = tr2.state.doc.lineAt(tr2.selection.main.head);
      value = value.update({ filter: (from) => from >= line2.from && from <= line2.to });
    }
    for (let effect of tr2.effects)
      if (effect.is(closeBracketEffect))
        value = value.update({ add: [closedBracket.range(effect.value, effect.value + 1)] });
    return value;
  }
});
function closeBrackets() {
  return [inputHandler, bracketState];
}
const definedClosing = "()[]{}<>«»»«［］｛｝";
function closing(ch) {
  for (let i2 = 0; i2 < definedClosing.length; i2 += 2)
    if (definedClosing.charCodeAt(i2) == ch)
      return definedClosing.charAt(i2 + 1);
  return fromCodePoint(ch < 128 ? ch : ch + 1);
}
function config$2(state, pos) {
  return state.languageDataAt("closeBrackets", pos)[0] || defaults;
}
const android = typeof navigator == "object" && /* @__PURE__ */ /Android\b/.test(navigator.userAgent);
const inputHandler = /* @__PURE__ */ EditorView.inputHandler.of((view, from, to2, insert2) => {
  if ((android ? view.composing : view.compositionStarted) || view.state.readOnly)
    return false;
  let sel = view.state.selection.main;
  if (insert2.length > 2 || insert2.length == 2 && codePointSize(codePointAt(insert2, 0)) == 1 || from != sel.from || to2 != sel.to)
    return false;
  let tr2 = insertBracket(view.state, insert2);
  if (!tr2)
    return false;
  view.dispatch(tr2);
  return true;
});
const deleteBracketPair = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let conf = config$2(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  let dont = null, changes = state.changeByRange((range2) => {
    if (range2.empty) {
      let before2 = prevChar(state.doc, range2.head);
      for (let token of tokens) {
        if (token == before2 && nextChar(state.doc, range2.head) == closing(codePointAt(token, 0)))
          return {
            changes: { from: range2.head - token.length, to: range2.head + token.length },
            range: EditorSelection.cursor(range2.head - token.length)
          };
      }
    }
    return { range: dont = range2 };
  });
  if (!dont)
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "delete.backward" }));
  return !dont;
};
const closeBracketsKeymap = [
  { key: "Backspace", run: deleteBracketPair }
];
function insertBracket(state, bracket2) {
  let conf = config$2(state, state.selection.main.head);
  let tokens = conf.brackets || defaults.brackets;
  for (let tok of tokens) {
    let closed = closing(codePointAt(tok, 0));
    if (bracket2 == tok)
      return closed == tok ? handleSame(state, tok, tokens.indexOf(tok + tok + tok) > -1, conf) : handleOpen(state, tok, closed, conf.before || defaults.before);
    if (bracket2 == closed && closedBracketAt(state, state.selection.main.from))
      return handleClose(state, tok, closed);
  }
  return null;
}
function closedBracketAt(state, pos) {
  let found = false;
  state.field(bracketState).between(0, state.doc.length, (from) => {
    if (from == pos)
      found = true;
  });
  return found;
}
function nextChar(doc2, pos) {
  let next = doc2.sliceString(pos, pos + 2);
  return next.slice(0, codePointSize(codePointAt(next, 0)));
}
function prevChar(doc2, pos) {
  let prev = doc2.sliceString(pos - 2, pos);
  return codePointSize(codePointAt(prev, 0)) == prev.length ? prev : prev.slice(1);
}
function handleOpen(state, open, close, closeBefore) {
  let dont = null, changes = state.changeByRange((range2) => {
    if (!range2.empty)
      return {
        changes: [{ insert: open, from: range2.from }, { insert: close, from: range2.to }],
        effects: closeBracketEffect.of(range2.to + open.length),
        range: EditorSelection.range(range2.anchor + open.length, range2.head + open.length)
      };
    let next = nextChar(state.doc, range2.head);
    if (!next || /\s/.test(next) || closeBefore.indexOf(next) > -1)
      return {
        changes: { insert: open + close, from: range2.head },
        effects: closeBracketEffect.of(range2.head + open.length),
        range: EditorSelection.cursor(range2.head + open.length)
      };
    return { range: dont = range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleClose(state, _open, close) {
  let dont = null, changes = state.changeByRange((range2) => {
    if (range2.empty && nextChar(state.doc, range2.head) == close)
      return {
        changes: { from: range2.head, to: range2.head + close.length, insert: close },
        range: EditorSelection.cursor(range2.head + close.length)
      };
    return dont = { range: range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function handleSame(state, token, allowTriple, config2) {
  let stringPrefixes = config2.stringPrefixes || defaults.stringPrefixes;
  let dont = null, changes = state.changeByRange((range2) => {
    if (!range2.empty)
      return {
        changes: [{ insert: token, from: range2.from }, { insert: token, from: range2.to }],
        effects: closeBracketEffect.of(range2.to + token.length),
        range: EditorSelection.range(range2.anchor + token.length, range2.head + token.length)
      };
    let pos = range2.head, next = nextChar(state.doc, pos), start;
    if (next == token) {
      if (nodeStart(state, pos)) {
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
      } else if (closedBracketAt(state, pos)) {
        let isTriple = allowTriple && state.sliceDoc(pos, pos + token.length * 3) == token + token + token;
        let content2 = isTriple ? token + token + token : token;
        return {
          changes: { from: pos, to: pos + content2.length, insert: content2 },
          range: EditorSelection.cursor(pos + content2.length)
        };
      }
    } else if (allowTriple && state.sliceDoc(pos - 2 * token.length, pos) == token + token && (start = canStartStringAt(state, pos - 2 * token.length, stringPrefixes)) > -1 && nodeStart(state, start)) {
      return {
        changes: { insert: token + token + token + token, from: pos },
        effects: closeBracketEffect.of(pos + token.length),
        range: EditorSelection.cursor(pos + token.length)
      };
    } else if (state.charCategorizer(pos)(next) != CharCategory.Word) {
      if (canStartStringAt(state, pos, stringPrefixes) > -1 && !probablyInString(state, pos, token, stringPrefixes))
        return {
          changes: { insert: token + token, from: pos },
          effects: closeBracketEffect.of(pos + token.length),
          range: EditorSelection.cursor(pos + token.length)
        };
    }
    return { range: dont = range2 };
  });
  return dont ? null : state.update(changes, {
    scrollIntoView: true,
    userEvent: "input.type"
  });
}
function nodeStart(state, pos) {
  let tree = syntaxTree(state).resolveInner(pos + 1);
  return tree.parent && tree.from == pos;
}
function probablyInString(state, pos, quoteToken, prefixes) {
  let node = syntaxTree(state).resolveInner(pos, -1);
  let maxPrefix = prefixes.reduce((m2, p2) => Math.max(m2, p2.length), 0);
  for (let i2 = 0; i2 < 5; i2++) {
    let start = state.sliceDoc(node.from, Math.min(node.to, node.from + quoteToken.length + maxPrefix));
    let quotePos = start.indexOf(quoteToken);
    if (!quotePos || quotePos > -1 && prefixes.indexOf(start.slice(0, quotePos)) > -1) {
      let first2 = node.firstChild;
      while (first2 && first2.from == node.from && first2.to - first2.from > quoteToken.length + quotePos) {
        if (state.sliceDoc(first2.to - quoteToken.length, first2.to) == quoteToken)
          return false;
        first2 = first2.firstChild;
      }
      return true;
    }
    let parent = node.to == pos && node.parent;
    if (!parent)
      break;
    node = parent;
  }
  return false;
}
function canStartStringAt(state, pos, prefixes) {
  let charCat = state.charCategorizer(pos);
  if (charCat(state.sliceDoc(pos - 1, pos)) != CharCategory.Word)
    return pos;
  for (let prefix of prefixes) {
    let start = pos - prefix.length;
    if (state.sliceDoc(start, pos) == prefix && charCat(state.sliceDoc(start - 1, start)) != CharCategory.Word)
      return start;
  }
  return -1;
}
function autocompletion(config2 = {}) {
  return [
    commitCharacters,
    completionState,
    completionConfig.of(config2),
    completionPlugin,
    completionKeymapExt,
    baseTheme$3
  ];
}
const completionKeymap = [
  { key: "Ctrl-Space", run: startCompletion },
  { mac: "Alt-`", run: startCompletion },
  { mac: "Alt-i", run: startCompletion },
  { key: "Escape", run: closeCompletion },
  { key: "ArrowDown", run: /* @__PURE__ */ moveCompletionSelection(true) },
  { key: "ArrowUp", run: /* @__PURE__ */ moveCompletionSelection(false) },
  { key: "PageDown", run: /* @__PURE__ */ moveCompletionSelection(true, "page") },
  { key: "PageUp", run: /* @__PURE__ */ moveCompletionSelection(false, "page") },
  { key: "Enter", run: acceptCompletion }
];
const completionKeymapExt = /* @__PURE__ */ Prec.highest(/* @__PURE__ */ keymap.computeN([completionConfig], (state) => state.facet(completionConfig).defaultKeymap ? [completionKeymap] : []));
function completionStatus(state) {
  let cState = state.field(completionState, false);
  return cState && cState.active.some((a2) => a2.isPending) ? "pending" : cState && cState.active.some(
    (a2) => a2.state != 0
    /* State.Inactive */
  ) ? "active" : null;
}
function selectedCompletion(state) {
  var _a2;
  let open = (_a2 = state.field(completionState, false)) === null || _a2 === void 0 ? void 0 : _a2.open;
  return open && !open.disabled && open.selected >= 0 ? open.options[open.selected].completion : null;
}
function _extends$1() {
  return _extends$1 = Object.assign ? Object.assign.bind() : function(n2) {
    for (var e2 = 1; e2 < arguments.length; e2++) {
      var t4 = arguments[e2];
      for (var r2 in t4) ({}).hasOwnProperty.call(t4, r2) && (n2[r2] = t4[r2]);
    }
    return n2;
  }, _extends$1.apply(null, arguments);
}
function _objectWithoutPropertiesLoose(r2, e2) {
  if (null == r2) return {};
  var t4 = {};
  for (var n2 in r2) if ({}.hasOwnProperty.call(r2, n2)) {
    if (-1 !== e2.indexOf(n2)) continue;
    t4[n2] = r2[n2];
  }
  return t4;
}
const toggleComment = (target) => {
  let { state } = target, line2 = state.doc.lineAt(state.selection.main.from), config2 = getConfig(target.state, line2.from);
  return config2.line ? toggleLineComment(target) : config2.block ? toggleBlockCommentByLine(target) : false;
};
function command(f2, option) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let tr2 = f2(option, state);
    if (!tr2)
      return false;
    dispatch(state.update(tr2));
    return true;
  };
}
const toggleLineComment = /* @__PURE__ */ command(
  changeLineComment,
  0
  /* CommentOption.Toggle */
);
const toggleBlockComment = /* @__PURE__ */ command(
  changeBlockComment,
  0
  /* CommentOption.Toggle */
);
const toggleBlockCommentByLine = /* @__PURE__ */ command(
  (o2, s2) => changeBlockComment(o2, s2, selectedLineRanges(s2)),
  0
  /* CommentOption.Toggle */
);
function getConfig(state, pos) {
  let data = state.languageDataAt("commentTokens", pos, 1);
  return data.length ? data[0] : {};
}
const SearchMargin = 50;
function findBlockComment(state, { open, close }, from, to2) {
  let textBefore = state.sliceDoc(from - SearchMargin, from);
  let textAfter = state.sliceDoc(to2, to2 + SearchMargin);
  let spaceBefore = /\s*$/.exec(textBefore)[0].length, spaceAfter = /^\s*/.exec(textAfter)[0].length;
  let beforeOff = textBefore.length - spaceBefore;
  if (textBefore.slice(beforeOff - open.length, beforeOff) == open && textAfter.slice(spaceAfter, spaceAfter + close.length) == close) {
    return {
      open: { pos: from - spaceBefore, margin: spaceBefore && 1 },
      close: { pos: to2 + spaceAfter, margin: spaceAfter && 1 }
    };
  }
  let startText, endText;
  if (to2 - from <= 2 * SearchMargin) {
    startText = endText = state.sliceDoc(from, to2);
  } else {
    startText = state.sliceDoc(from, from + SearchMargin);
    endText = state.sliceDoc(to2 - SearchMargin, to2);
  }
  let startSpace = /^\s*/.exec(startText)[0].length, endSpace = /\s*$/.exec(endText)[0].length;
  let endOff = endText.length - endSpace - close.length;
  if (startText.slice(startSpace, startSpace + open.length) == open && endText.slice(endOff, endOff + close.length) == close) {
    return {
      open: {
        pos: from + startSpace + open.length,
        margin: /\s/.test(startText.charAt(startSpace + open.length)) ? 1 : 0
      },
      close: {
        pos: to2 - endSpace - close.length,
        margin: /\s/.test(endText.charAt(endOff - 1)) ? 1 : 0
      }
    };
  }
  return null;
}
function selectedLineRanges(state) {
  let ranges = [];
  for (let r2 of state.selection.ranges) {
    let fromLine = state.doc.lineAt(r2.from);
    let toLine = r2.to <= fromLine.to ? fromLine : state.doc.lineAt(r2.to);
    if (toLine.from > fromLine.from && toLine.from == r2.to)
      toLine = r2.to == fromLine.to + 1 ? fromLine : state.doc.lineAt(r2.to - 1);
    let last2 = ranges.length - 1;
    if (last2 >= 0 && ranges[last2].to > fromLine.from)
      ranges[last2].to = toLine.to;
    else
      ranges.push({ from: fromLine.from + /^\s*/.exec(fromLine.text)[0].length, to: toLine.to });
  }
  return ranges;
}
function changeBlockComment(option, state, ranges = state.selection.ranges) {
  let tokens = ranges.map((r2) => getConfig(state, r2.from).block);
  if (!tokens.every((c2) => c2))
    return null;
  let comments = ranges.map((r2, i2) => findBlockComment(state, tokens[i2], r2.from, r2.to));
  if (option != 2 && !comments.every((c2) => c2)) {
    return { changes: state.changes(ranges.map((range2, i2) => {
      if (comments[i2])
        return [];
      return [{ from: range2.from, insert: tokens[i2].open + " " }, { from: range2.to, insert: " " + tokens[i2].close }];
    })) };
  } else if (option != 1 && comments.some((c2) => c2)) {
    let changes = [];
    for (let i2 = 0, comment2; i2 < comments.length; i2++)
      if (comment2 = comments[i2]) {
        let token = tokens[i2], { open, close } = comment2;
        changes.push({ from: open.pos - token.open.length, to: open.pos + open.margin }, { from: close.pos - close.margin, to: close.pos + token.close.length });
      }
    return { changes };
  }
  return null;
}
function changeLineComment(option, state, ranges = state.selection.ranges) {
  let lines = [];
  let prevLine = -1;
  ranges: for (let { from, to: to2 } of ranges) {
    let startI = lines.length, minIndent = 1e9, token;
    for (let pos = from; pos <= to2; ) {
      let line2 = state.doc.lineAt(pos);
      if (token == void 0) {
        token = getConfig(state, line2.from).line;
        if (!token)
          continue ranges;
      }
      if (line2.from > prevLine && (from == to2 || to2 > line2.from)) {
        prevLine = line2.from;
        let indent2 = /^\s*/.exec(line2.text)[0].length;
        let empty2 = indent2 == line2.length;
        let comment2 = line2.text.slice(indent2, indent2 + token.length) == token ? indent2 : -1;
        if (indent2 < line2.text.length && indent2 < minIndent)
          minIndent = indent2;
        lines.push({ line: line2, comment: comment2, token, indent: indent2, empty: empty2, single: false });
      }
      pos = line2.to + 1;
    }
    if (minIndent < 1e9) {
      for (let i2 = startI; i2 < lines.length; i2++)
        if (lines[i2].indent < lines[i2].line.text.length)
          lines[i2].indent = minIndent;
    }
    if (lines.length == startI + 1)
      lines[startI].single = true;
  }
  if (option != 2 && lines.some((l2) => l2.comment < 0 && (!l2.empty || l2.single))) {
    let changes = [];
    for (let { line: line2, token, indent: indent2, empty: empty2, single } of lines)
      if (single || !empty2)
        changes.push({ from: line2.from + indent2, insert: token + " " });
    let changeSet = state.changes(changes);
    return { changes: changeSet, selection: state.selection.map(changeSet, 1) };
  } else if (option != 1 && lines.some((l2) => l2.comment >= 0)) {
    let changes = [];
    for (let { line: line2, comment: comment2, token } of lines)
      if (comment2 >= 0) {
        let from = line2.from + comment2, to2 = from + token.length;
        if (line2.text[to2 - line2.from] == " ")
          to2++;
        changes.push({ from, to: to2 });
      }
    return { changes };
  }
  return null;
}
const fromHistory = /* @__PURE__ */ Annotation.define();
const isolateHistory = /* @__PURE__ */ Annotation.define();
const invertedEffects = /* @__PURE__ */ Facet.define();
const historyConfig = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      minDepth: 100,
      newGroupDelay: 500,
      joinToEvent: (_t, isAdjacent2) => isAdjacent2
    }, {
      minDepth: Math.max,
      newGroupDelay: Math.min,
      joinToEvent: (a2, b2) => (tr2, adj) => a2(tr2, adj) || b2(tr2, adj)
    });
  }
});
const historyField_ = /* @__PURE__ */ StateField.define({
  create() {
    return HistoryState.empty;
  },
  update(state, tr2) {
    let config2 = tr2.state.facet(historyConfig);
    let fromHist = tr2.annotation(fromHistory);
    if (fromHist) {
      let item = HistEvent.fromTransaction(tr2, fromHist.selection), from = fromHist.side;
      let other = from == 0 ? state.undone : state.done;
      if (item)
        other = updateBranch(other, other.length, config2.minDepth, item);
      else
        other = addSelection(other, tr2.startState.selection);
      return new HistoryState(from == 0 ? fromHist.rest : other, from == 0 ? other : fromHist.rest);
    }
    let isolate = tr2.annotation(isolateHistory);
    if (isolate == "full" || isolate == "before")
      state = state.isolate();
    if (tr2.annotation(Transaction.addToHistory) === false)
      return !tr2.changes.empty ? state.addMapping(tr2.changes.desc) : state;
    let event = HistEvent.fromTransaction(tr2);
    let time = tr2.annotation(Transaction.time), userEvent = tr2.annotation(Transaction.userEvent);
    if (event)
      state = state.addChanges(event, time, userEvent, config2, tr2);
    else if (tr2.selection)
      state = state.addSelection(tr2.startState.selection, time, userEvent, config2.newGroupDelay);
    if (isolate == "full" || isolate == "after")
      state = state.isolate();
    return state;
  },
  toJSON(value) {
    return { done: value.done.map((e2) => e2.toJSON()), undone: value.undone.map((e2) => e2.toJSON()) };
  },
  fromJSON(json) {
    return new HistoryState(json.done.map(HistEvent.fromJSON), json.undone.map(HistEvent.fromJSON));
  }
});
function history(config2 = {}) {
  return [
    historyField_,
    historyConfig.of(config2),
    EditorView.domEventHandlers({
      beforeinput(e2, view) {
        let command2 = e2.inputType == "historyUndo" ? undo : e2.inputType == "historyRedo" ? redo : null;
        if (!command2)
          return false;
        e2.preventDefault();
        return command2(view);
      }
    })
  ];
}
function cmd(side, selection2) {
  return function({ state, dispatch }) {
    if (!selection2 && state.readOnly)
      return false;
    let historyState = state.field(historyField_, false);
    if (!historyState)
      return false;
    let tr2 = historyState.pop(side, state, selection2);
    if (!tr2)
      return false;
    dispatch(tr2);
    return true;
  };
}
const undo = /* @__PURE__ */ cmd(0, false);
const redo = /* @__PURE__ */ cmd(1, false);
const undoSelection = /* @__PURE__ */ cmd(0, true);
const redoSelection = /* @__PURE__ */ cmd(1, true);
class HistEvent {
  constructor(changes, effects, mapped, startSelection, selectionsAfter) {
    this.changes = changes;
    this.effects = effects;
    this.mapped = mapped;
    this.startSelection = startSelection;
    this.selectionsAfter = selectionsAfter;
  }
  setSelAfter(after2) {
    return new HistEvent(this.changes, this.effects, this.mapped, this.startSelection, after2);
  }
  toJSON() {
    var _a2, _b, _c;
    return {
      changes: (_a2 = this.changes) === null || _a2 === void 0 ? void 0 : _a2.toJSON(),
      mapped: (_b = this.mapped) === null || _b === void 0 ? void 0 : _b.toJSON(),
      startSelection: (_c = this.startSelection) === null || _c === void 0 ? void 0 : _c.toJSON(),
      selectionsAfter: this.selectionsAfter.map((s2) => s2.toJSON())
    };
  }
  static fromJSON(json) {
    return new HistEvent(json.changes && ChangeSet.fromJSON(json.changes), [], json.mapped && ChangeDesc.fromJSON(json.mapped), json.startSelection && EditorSelection.fromJSON(json.startSelection), json.selectionsAfter.map(EditorSelection.fromJSON));
  }
  // This does not check `addToHistory` and such, it assumes the
  // transaction needs to be converted to an item. Returns null when
  // there are no changes or effects in the transaction.
  static fromTransaction(tr2, selection2) {
    let effects = none;
    for (let invert2 of tr2.startState.facet(invertedEffects)) {
      let result2 = invert2(tr2);
      if (result2.length)
        effects = effects.concat(result2);
    }
    if (!effects.length && tr2.changes.empty)
      return null;
    return new HistEvent(tr2.changes.invert(tr2.startState.doc), effects, void 0, selection2 || tr2.startState.selection, none);
  }
  static selection(selections) {
    return new HistEvent(void 0, none, void 0, void 0, selections);
  }
}
function updateBranch(branch, to2, maxLen, newEvent) {
  let start = to2 + 1 > maxLen + 20 ? to2 - maxLen - 1 : 0;
  let newBranch = branch.slice(start, to2);
  newBranch.push(newEvent);
  return newBranch;
}
function isAdjacent(a2, b2) {
  let ranges = [], isAdjacent2 = false;
  a2.iterChangedRanges((f2, t4) => ranges.push(f2, t4));
  b2.iterChangedRanges((_f, _t, f2, t4) => {
    for (let i2 = 0; i2 < ranges.length; ) {
      let from = ranges[i2++], to2 = ranges[i2++];
      if (t4 >= from && f2 <= to2)
        isAdjacent2 = true;
    }
  });
  return isAdjacent2;
}
function eqSelectionShape(a2, b2) {
  return a2.ranges.length == b2.ranges.length && a2.ranges.filter((r2, i2) => r2.empty != b2.ranges[i2].empty).length === 0;
}
function conc(a2, b2) {
  return !a2.length ? b2 : !b2.length ? a2 : a2.concat(b2);
}
const none = [];
const MaxSelectionsPerEvent = 200;
function addSelection(branch, selection2) {
  if (!branch.length) {
    return [HistEvent.selection([selection2])];
  } else {
    let lastEvent = branch[branch.length - 1];
    let sels = lastEvent.selectionsAfter.slice(Math.max(0, lastEvent.selectionsAfter.length - MaxSelectionsPerEvent));
    if (sels.length && sels[sels.length - 1].eq(selection2))
      return branch;
    sels.push(selection2);
    return updateBranch(branch, branch.length - 1, 1e9, lastEvent.setSelAfter(sels));
  }
}
function popSelection(branch) {
  let last2 = branch[branch.length - 1];
  let newBranch = branch.slice();
  newBranch[branch.length - 1] = last2.setSelAfter(last2.selectionsAfter.slice(0, last2.selectionsAfter.length - 1));
  return newBranch;
}
function addMappingToBranch(branch, mapping) {
  if (!branch.length)
    return branch;
  let length = branch.length, selections = none;
  while (length) {
    let event = mapEvent(branch[length - 1], mapping, selections);
    if (event.changes && !event.changes.empty || event.effects.length) {
      let result2 = branch.slice(0, length);
      result2[length - 1] = event;
      return result2;
    } else {
      mapping = event.mapped;
      length--;
      selections = event.selectionsAfter;
    }
  }
  return selections.length ? [HistEvent.selection(selections)] : none;
}
function mapEvent(event, mapping, extraSelections) {
  let selections = conc(event.selectionsAfter.length ? event.selectionsAfter.map((s2) => s2.map(mapping)) : none, extraSelections);
  if (!event.changes)
    return HistEvent.selection(selections);
  let mappedChanges = event.changes.map(mapping), before2 = mapping.mapDesc(event.changes, true);
  let fullMapping = event.mapped ? event.mapped.composeDesc(before2) : before2;
  return new HistEvent(mappedChanges, StateEffect.mapEffects(event.effects, mapping), fullMapping, event.startSelection.map(before2), selections);
}
const joinableUserEvent = /^(input\.type|delete)($|\.)/;
class HistoryState {
  constructor(done, undone, prevTime = 0, prevUserEvent = void 0) {
    this.done = done;
    this.undone = undone;
    this.prevTime = prevTime;
    this.prevUserEvent = prevUserEvent;
  }
  isolate() {
    return this.prevTime ? new HistoryState(this.done, this.undone) : this;
  }
  addChanges(event, time, userEvent, config2, tr2) {
    let done = this.done, lastEvent = done[done.length - 1];
    if (lastEvent && lastEvent.changes && !lastEvent.changes.empty && event.changes && (!userEvent || joinableUserEvent.test(userEvent)) && (!lastEvent.selectionsAfter.length && time - this.prevTime < config2.newGroupDelay && config2.joinToEvent(tr2, isAdjacent(lastEvent.changes, event.changes)) || // For compose (but not compose.start) events, always join with previous event
    userEvent == "input.type.compose")) {
      done = updateBranch(done, done.length - 1, config2.minDepth, new HistEvent(event.changes.compose(lastEvent.changes), conc(StateEffect.mapEffects(event.effects, lastEvent.changes), lastEvent.effects), lastEvent.mapped, lastEvent.startSelection, none));
    } else {
      done = updateBranch(done, done.length, config2.minDepth, event);
    }
    return new HistoryState(done, none, time, userEvent);
  }
  addSelection(selection2, time, userEvent, newGroupDelay) {
    let last2 = this.done.length ? this.done[this.done.length - 1].selectionsAfter : none;
    if (last2.length > 0 && time - this.prevTime < newGroupDelay && userEvent == this.prevUserEvent && userEvent && /^select($|\.)/.test(userEvent) && eqSelectionShape(last2[last2.length - 1], selection2))
      return this;
    return new HistoryState(addSelection(this.done, selection2), this.undone, time, userEvent);
  }
  addMapping(mapping) {
    return new HistoryState(addMappingToBranch(this.done, mapping), addMappingToBranch(this.undone, mapping), this.prevTime, this.prevUserEvent);
  }
  pop(side, state, onlySelection) {
    let branch = side == 0 ? this.done : this.undone;
    if (branch.length == 0)
      return null;
    let event = branch[branch.length - 1], selection2 = event.selectionsAfter[0] || (event.startSelection ? event.startSelection.map(event.changes.invertedDesc, 1) : state.selection);
    if (onlySelection && event.selectionsAfter.length) {
      return state.update({
        selection: event.selectionsAfter[event.selectionsAfter.length - 1],
        annotations: fromHistory.of({ side, rest: popSelection(branch), selection: selection2 }),
        userEvent: side == 0 ? "select.undo" : "select.redo",
        scrollIntoView: true
      });
    } else if (!event.changes) {
      return null;
    } else {
      let rest2 = branch.length == 1 ? none : branch.slice(0, branch.length - 1);
      if (event.mapped)
        rest2 = addMappingToBranch(rest2, event.mapped);
      return state.update({
        changes: event.changes,
        selection: event.startSelection,
        effects: event.effects,
        annotations: fromHistory.of({ side, rest: rest2, selection: selection2 }),
        filter: false,
        userEvent: side == 0 ? "undo" : "redo",
        scrollIntoView: true
      });
    }
  }
}
HistoryState.empty = /* @__PURE__ */ new HistoryState(none, none);
const historyKeymap = [
  { key: "Mod-z", run: undo, preventDefault: true },
  { key: "Mod-y", mac: "Mod-Shift-z", run: redo, preventDefault: true },
  { linux: "Ctrl-Shift-z", run: redo, preventDefault: true },
  { key: "Mod-u", run: undoSelection, preventDefault: true },
  { key: "Alt-u", mac: "Mod-Shift-u", run: redoSelection, preventDefault: true }
];
function updateSel(sel, by) {
  return EditorSelection.create(sel.ranges.map(by), sel.mainIndex);
}
function setSel(state, selection2) {
  return state.update({ selection: selection2, scrollIntoView: true, userEvent: "select" });
}
function moveSel({ state, dispatch }, how) {
  let selection2 = updateSel(state.selection, how);
  if (selection2.eq(state.selection, true))
    return false;
  dispatch(setSel(state, selection2));
  return true;
}
function rangeEnd(range2, forward) {
  return EditorSelection.cursor(forward ? range2.to : range2.from);
}
function cursorByChar(view, forward) {
  return moveSel(view, (range2) => range2.empty ? view.moveByChar(range2, forward) : rangeEnd(range2, forward));
}
function ltrAtCursor(view) {
  return view.textDirectionAt(view.state.selection.main.head) == Direction.LTR;
}
const cursorCharLeft = (view) => cursorByChar(view, !ltrAtCursor(view));
const cursorCharRight = (view) => cursorByChar(view, ltrAtCursor(view));
function cursorByGroup(view, forward) {
  return moveSel(view, (range2) => range2.empty ? view.moveByGroup(range2, forward) : rangeEnd(range2, forward));
}
const cursorGroupLeft = (view) => cursorByGroup(view, !ltrAtCursor(view));
const cursorGroupRight = (view) => cursorByGroup(view, ltrAtCursor(view));
function interestingNode(state, node, bracketProp) {
  if (node.type.prop(bracketProp))
    return true;
  let len = node.to - node.from;
  return len && (len > 2 || /[^\s,.;:]/.test(state.sliceDoc(node.from, node.to))) || node.firstChild;
}
function moveBySyntax(state, start, forward) {
  let pos = syntaxTree(state).resolveInner(start.head);
  let bracketProp = forward ? NodeProp$1.closedBy : NodeProp$1.openedBy;
  for (let at2 = start.head; ; ) {
    let next = forward ? pos.childAfter(at2) : pos.childBefore(at2);
    if (!next)
      break;
    if (interestingNode(state, next, bracketProp))
      pos = next;
    else
      at2 = forward ? next.to : next.from;
  }
  let bracket2 = pos.type.prop(bracketProp), match2, newPos;
  if (bracket2 && (match2 = forward ? matchBrackets(state, pos.from, 1) : matchBrackets(state, pos.to, -1)) && match2.matched)
    newPos = forward ? match2.end.to : match2.end.from;
  else
    newPos = forward ? pos.to : pos.from;
  return EditorSelection.cursor(newPos, forward ? -1 : 1);
}
const cursorSyntaxLeft = (view) => moveSel(view, (range2) => moveBySyntax(view.state, range2, !ltrAtCursor(view)));
const cursorSyntaxRight = (view) => moveSel(view, (range2) => moveBySyntax(view.state, range2, ltrAtCursor(view)));
function cursorByLine(view, forward) {
  return moveSel(view, (range2) => {
    if (!range2.empty)
      return rangeEnd(range2, forward);
    let moved = view.moveVertically(range2, forward);
    return moved.head != range2.head ? moved : view.moveToLineBoundary(range2, forward);
  });
}
const cursorLineUp = (view) => cursorByLine(view, false);
const cursorLineDown = (view) => cursorByLine(view, true);
function pageInfo(view) {
  let selfScroll = view.scrollDOM.clientHeight < view.scrollDOM.scrollHeight - 2;
  let marginTop = 0, marginBottom = 0, height;
  if (selfScroll) {
    for (let source of view.state.facet(EditorView.scrollMargins)) {
      let margins = source(view);
      if (margins === null || margins === void 0 ? void 0 : margins.top)
        marginTop = Math.max(margins === null || margins === void 0 ? void 0 : margins.top, marginTop);
      if (margins === null || margins === void 0 ? void 0 : margins.bottom)
        marginBottom = Math.max(margins === null || margins === void 0 ? void 0 : margins.bottom, marginBottom);
    }
    height = view.scrollDOM.clientHeight - marginTop - marginBottom;
  } else {
    height = (view.dom.ownerDocument.defaultView || window).innerHeight;
  }
  return {
    marginTop,
    marginBottom,
    selfScroll,
    height: Math.max(view.defaultLineHeight, height - 5)
  };
}
function cursorByPage(view, forward) {
  let page = pageInfo(view);
  let { state } = view, selection2 = updateSel(state.selection, (range2) => {
    return range2.empty ? view.moveVertically(range2, forward, page.height) : rangeEnd(range2, forward);
  });
  if (selection2.eq(state.selection))
    return false;
  let effect;
  if (page.selfScroll) {
    let startPos = view.coordsAtPos(state.selection.main.head);
    let scrollRect = view.scrollDOM.getBoundingClientRect();
    let scrollTop = scrollRect.top + page.marginTop, scrollBottom = scrollRect.bottom - page.marginBottom;
    if (startPos && startPos.top > scrollTop && startPos.bottom < scrollBottom)
      effect = EditorView.scrollIntoView(selection2.main.head, { y: "start", yMargin: startPos.top - scrollTop });
  }
  view.dispatch(setSel(state, selection2), { effects: effect });
  return true;
}
const cursorPageUp = (view) => cursorByPage(view, false);
const cursorPageDown = (view) => cursorByPage(view, true);
function moveByLineBoundary(view, start, forward) {
  let line2 = view.lineBlockAt(start.head), moved = view.moveToLineBoundary(start, forward);
  if (moved.head == start.head && moved.head != (forward ? line2.to : line2.from))
    moved = view.moveToLineBoundary(start, forward, false);
  if (!forward && moved.head == line2.from && line2.length) {
    let space = /^\s*/.exec(view.state.sliceDoc(line2.from, Math.min(line2.from + 100, line2.to)))[0].length;
    if (space && start.head != line2.from + space)
      moved = EditorSelection.cursor(line2.from + space);
  }
  return moved;
}
const cursorLineBoundaryForward = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, true));
const cursorLineBoundaryBackward = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, false));
const cursorLineBoundaryLeft = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, !ltrAtCursor(view)));
const cursorLineBoundaryRight = (view) => moveSel(view, (range2) => moveByLineBoundary(view, range2, ltrAtCursor(view)));
const cursorLineStart = (view) => moveSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).from, 1));
const cursorLineEnd = (view) => moveSel(view, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).to, -1));
function toMatchingBracket(state, dispatch, extend2) {
  let found = false, selection2 = updateSel(state.selection, (range2) => {
    let matching = matchBrackets(state, range2.head, -1) || matchBrackets(state, range2.head, 1) || range2.head > 0 && matchBrackets(state, range2.head - 1, 1) || range2.head < state.doc.length && matchBrackets(state, range2.head + 1, -1);
    if (!matching || !matching.end)
      return range2;
    found = true;
    let head = matching.start.from == range2.head ? matching.end.to : matching.end.from;
    return EditorSelection.cursor(head);
  });
  if (!found)
    return false;
  dispatch(setSel(state, selection2));
  return true;
}
const cursorMatchingBracket = ({ state, dispatch }) => toMatchingBracket(state, dispatch);
function extendSel(target, forward, how) {
  let selection2 = updateSel(target.state.selection, (range2) => {
    if (range2.undirectional && range2.head >= range2.anchor != forward)
      range2 = EditorSelection.range(range2.head, range2.anchor);
    let head = how(range2);
    return EditorSelection.range(range2.anchor, head.head, head.goalColumn, head.bidiLevel || void 0, head.assoc);
  });
  if (selection2.eq(target.state.selection))
    return false;
  target.dispatch(setSel(target.state, selection2));
  return true;
}
function selectByChar(view, forward) {
  return extendSel(view, forward, (range2) => view.moveByChar(range2, forward));
}
const selectCharLeft = (view) => selectByChar(view, !ltrAtCursor(view));
const selectCharRight = (view) => selectByChar(view, ltrAtCursor(view));
function selectByGroup(view, forward) {
  return extendSel(view, forward, (range2) => view.moveByGroup(range2, forward));
}
const selectGroupLeft = (view) => selectByGroup(view, !ltrAtCursor(view));
const selectGroupRight = (view) => selectByGroup(view, ltrAtCursor(view));
const selectSyntaxLeft = (view) => {
  let forward = !ltrAtCursor(view);
  return extendSel(view, forward, (range2) => moveBySyntax(view.state, range2, forward));
};
const selectSyntaxRight = (view) => {
  let forward = ltrAtCursor(view);
  return extendSel(view, forward, (range2) => moveBySyntax(view.state, range2, forward));
};
function selectByLine(view, forward) {
  return extendSel(view, forward, (range2) => view.moveVertically(range2, forward));
}
const selectLineUp = (view) => selectByLine(view, false);
const selectLineDown = (view) => selectByLine(view, true);
function selectByPage(view, forward) {
  return extendSel(view, forward, (range2) => view.moveVertically(range2, forward, pageInfo(view).height));
}
const selectPageUp = (view) => selectByPage(view, false);
const selectPageDown = (view) => selectByPage(view, true);
const selectLineBoundaryForward = (view) => extendSel(view, true, (range2) => moveByLineBoundary(view, range2, true));
const selectLineBoundaryBackward = (view) => extendSel(view, false, (range2) => moveByLineBoundary(view, range2, false));
const selectLineBoundaryLeft = (view) => {
  let forward = !ltrAtCursor(view);
  return extendSel(view, forward, (range2) => moveByLineBoundary(view, range2, forward));
};
const selectLineBoundaryRight = (view) => {
  let forward = ltrAtCursor(view);
  return extendSel(view, forward, (range2) => moveByLineBoundary(view, range2, forward));
};
const selectLineStart = (view) => extendSel(view, false, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).from));
const selectLineEnd = (view) => extendSel(view, true, (range2) => EditorSelection.cursor(view.lineBlockAt(range2.head).to));
const cursorDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: 0 }));
  return true;
};
const cursorDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.doc.length }));
  return true;
};
const selectDocStart = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: 0 }));
  return true;
};
const selectDocEnd = ({ state, dispatch }) => {
  dispatch(setSel(state, { anchor: state.selection.main.anchor, head: state.doc.length }));
  return true;
};
const selectAll = ({ state, dispatch }) => {
  dispatch(state.update({ selection: { anchor: 0, head: state.doc.length }, userEvent: "select" }));
  return true;
};
const selectLine = ({ state, dispatch }) => {
  let ranges = selectedLineBlocks(state).map(({ from, to: to2 }) => EditorSelection.range(from, Math.min(to2 + 1, state.doc.length)));
  dispatch(state.update({ selection: EditorSelection.create(ranges), userEvent: "select" }));
  return true;
};
const selectParentSyntax = ({ state, dispatch }) => {
  let selection2 = updateSel(state.selection, (range2) => {
    let tree = syntaxTree(state), stack = tree.resolveStack(range2.from, 1);
    if (range2.empty) {
      let stackBefore = tree.resolveStack(range2.from, -1);
      if (stackBefore.node.from >= stack.node.from && stackBefore.node.to <= stack.node.to)
        stack = stackBefore;
    }
    for (let cur2 = stack; cur2; cur2 = cur2.next) {
      let { node } = cur2;
      if ((node.from < range2.from && node.to >= range2.to || node.to > range2.to && node.from <= range2.from) && cur2.next)
        return EditorSelection.range(node.to, node.from);
    }
    return range2;
  });
  if (selection2.eq(state.selection))
    return false;
  dispatch(setSel(state, selection2));
  return true;
};
function addCursorVertically(view, forward) {
  let { state } = view, sel = state.selection, ranges = state.selection.ranges.slice();
  for (let range2 of state.selection.ranges) {
    let line2 = state.doc.lineAt(range2.head);
    if (forward ? line2.to < view.state.doc.length : line2.from > 0)
      for (let cur2 = range2; ; ) {
        let next = view.moveVertically(cur2, forward);
        if (next.head < line2.from || next.head > line2.to) {
          if (!ranges.some((r2) => r2.head == next.head))
            ranges.push(next);
          break;
        } else if (next.head == cur2.head) {
          break;
        } else {
          cur2 = next;
        }
      }
  }
  if (ranges.length == sel.ranges.length)
    return false;
  view.dispatch(setSel(state, EditorSelection.create(ranges, ranges.length - 1)));
  return true;
}
const addCursorAbove = (view) => addCursorVertically(view, false);
const addCursorBelow = (view) => addCursorVertically(view, true);
const simplifySelection = ({ state, dispatch }) => {
  let cur2 = state.selection, selection2 = null;
  if (cur2.ranges.length > 1)
    selection2 = EditorSelection.create([cur2.main]);
  else if (!cur2.main.empty)
    selection2 = EditorSelection.create([EditorSelection.cursor(cur2.main.head)]);
  if (!selection2)
    return false;
  dispatch(setSel(state, selection2));
  return true;
};
function deleteBy(target, by) {
  if (target.state.readOnly)
    return false;
  let event = "delete.selection", { state } = target;
  let changes = state.changeByRange((range2) => {
    let { from, to: to2 } = range2;
    if (from == to2) {
      let towards = by(range2);
      if (towards < from) {
        event = "delete.backward";
        towards = skipAtomic(target, towards, false);
      } else if (towards > from) {
        event = "delete.forward";
        towards = skipAtomic(target, towards, true);
      }
      from = Math.min(from, towards);
      to2 = Math.max(to2, towards);
    } else {
      from = skipAtomic(target, from, false);
      to2 = skipAtomic(target, to2, true);
    }
    return from == to2 ? { range: range2 } : { changes: { from, to: to2 }, range: EditorSelection.cursor(from, from < range2.head ? -1 : 1) };
  });
  if (changes.changes.empty)
    return false;
  target.dispatch(state.update(changes, {
    scrollIntoView: true,
    userEvent: event,
    effects: event == "delete.selection" ? EditorView.announce.of(state.phrase("Selection deleted")) : void 0
  }));
  return true;
}
function skipAtomic(target, pos, forward) {
  if (target instanceof EditorView)
    for (let ranges of target.state.facet(EditorView.atomicRanges).map((f2) => f2(target)))
      ranges.between(pos, pos, (from, to2) => {
        if (from < pos && to2 > pos)
          pos = forward ? to2 : from;
      });
  return pos;
}
const deleteByChar = (target, forward, byIndentUnit) => deleteBy(target, (range2) => {
  let pos = range2.from, { state } = target, line2 = state.doc.lineAt(pos), before2, targetPos;
  if (byIndentUnit && !forward && pos > line2.from && pos < line2.from + 200 && !/[^ \t]/.test(before2 = line2.text.slice(0, pos - line2.from))) {
    if (before2[before2.length - 1] == "	")
      return pos - 1;
    let col = countColumn(before2, state.tabSize), drop = col % getIndentUnit(state) || getIndentUnit(state);
    for (let i2 = 0; i2 < drop && before2[before2.length - 1 - i2] == " "; i2++)
      pos--;
    targetPos = pos;
  } else {
    targetPos = findClusterBreak(line2.text, pos - line2.from, forward, forward) + line2.from;
    if (targetPos == pos && line2.number != (forward ? state.doc.lines : 1))
      targetPos += forward ? 1 : -1;
    else if (!forward && /[\ufe00-\ufe0f]/.test(line2.text.slice(targetPos - line2.from, pos - line2.from)))
      targetPos = findClusterBreak(line2.text, targetPos - line2.from, false, false) + line2.from;
  }
  return targetPos;
});
const deleteCharBackward = (view) => deleteByChar(view, false, true);
const deleteCharForward = (view) => deleteByChar(view, true, false);
const deleteByGroup = (target, forward) => deleteBy(target, (range2) => {
  let pos = range2.head, { state } = target, line2 = state.doc.lineAt(pos);
  let categorize = state.charCategorizer(pos);
  for (let cat = null; ; ) {
    if (pos == (forward ? line2.to : line2.from)) {
      if (pos == range2.head && line2.number != (forward ? state.doc.lines : 1))
        pos += forward ? 1 : -1;
      break;
    }
    let next = findClusterBreak(line2.text, pos - line2.from, forward) + line2.from;
    let nextChar2 = line2.text.slice(Math.min(pos, next) - line2.from, Math.max(pos, next) - line2.from);
    let nextCat = categorize(nextChar2);
    if (cat != null && nextCat != cat)
      break;
    if (nextChar2 != " " || pos != range2.head)
      cat = nextCat;
    pos = next;
  }
  return pos;
});
const deleteGroupBackward = (target) => deleteByGroup(target, false);
const deleteGroupForward = (target) => deleteByGroup(target, true);
const deleteToLineEnd = (view) => deleteBy(view, (range2) => {
  let lineEnd = view.lineBlockAt(range2.head).to;
  return range2.head < lineEnd ? lineEnd : Math.min(view.state.doc.length, range2.head + 1);
});
const deleteLineBoundaryBackward = (view) => deleteBy(view, (range2) => {
  let lineStart = view.moveToLineBoundary(range2, false).head;
  return range2.head > lineStart ? lineStart : Math.max(0, range2.head - 1);
});
const deleteLineBoundaryForward = (view) => deleteBy(view, (range2) => {
  let lineStart = view.moveToLineBoundary(range2, true).head;
  return range2.head < lineStart ? lineStart : Math.min(view.state.doc.length, range2.head + 1);
});
const splitLine = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range2) => {
    return {
      changes: { from: range2.from, to: range2.to, insert: Text$1.of(["", ""]) },
      range: EditorSelection.cursor(range2.from)
    };
  });
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
  return true;
};
const transposeChars = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let changes = state.changeByRange((range2) => {
    if (!range2.empty || range2.from == 0 || range2.from == state.doc.length)
      return { range: range2 };
    let pos = range2.from, line2 = state.doc.lineAt(pos);
    let from = pos == line2.from ? pos - 1 : findClusterBreak(line2.text, pos - line2.from, false) + line2.from;
    let to2 = pos == line2.to ? pos + 1 : findClusterBreak(line2.text, pos - line2.from, true) + line2.from;
    return {
      changes: { from, to: to2, insert: state.doc.slice(pos, to2).append(state.doc.slice(from, pos)) },
      range: EditorSelection.cursor(to2)
    };
  });
  if (changes.changes.empty)
    return false;
  dispatch(state.update(changes, { scrollIntoView: true, userEvent: "move.character" }));
  return true;
};
function selectedLineBlocks(state) {
  let blocks = [], upto = -1;
  for (let range2 of state.selection.ranges) {
    let startLine = state.doc.lineAt(range2.from), endLine = state.doc.lineAt(range2.to);
    if (!range2.empty && range2.to == endLine.from)
      endLine = state.doc.lineAt(range2.to - 1);
    if (upto >= startLine.number) {
      let prev = blocks[blocks.length - 1];
      prev.to = endLine.to;
      prev.ranges.push(range2);
    } else {
      blocks.push({ from: startLine.from, to: endLine.to, ranges: [range2] });
    }
    upto = endLine.number + 1;
  }
  return blocks;
}
function moveLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [], ranges = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward ? block.to == state.doc.length : block.from == 0)
      continue;
    let nextLine = state.doc.lineAt(forward ? block.to + 1 : block.from - 1);
    let size2 = nextLine.length + 1;
    if (forward) {
      changes.push({ from: block.to, to: nextLine.to }, { from: block.from, insert: nextLine.text + state.lineBreak });
      for (let r2 of block.ranges)
        ranges.push(EditorSelection.range(Math.min(state.doc.length, r2.anchor + size2), Math.min(state.doc.length, r2.head + size2)));
    } else {
      changes.push({ from: nextLine.from, to: block.from }, { from: block.to, insert: state.lineBreak + nextLine.text });
      for (let r2 of block.ranges)
        ranges.push(EditorSelection.range(r2.anchor - size2, r2.head - size2));
    }
  }
  if (!changes.length)
    return false;
  dispatch(state.update({
    changes,
    scrollIntoView: true,
    selection: EditorSelection.create(ranges, state.selection.mainIndex),
    userEvent: "move.line"
  }));
  return true;
}
const moveLineUp = ({ state, dispatch }) => moveLine(state, dispatch, false);
const moveLineDown = ({ state, dispatch }) => moveLine(state, dispatch, true);
function copyLine(state, dispatch, forward) {
  if (state.readOnly)
    return false;
  let changes = [];
  for (let block of selectedLineBlocks(state)) {
    if (forward)
      changes.push({ from: block.from, insert: state.doc.slice(block.from, block.to) + state.lineBreak });
    else
      changes.push({ from: block.to, insert: state.lineBreak + state.doc.slice(block.from, block.to) });
  }
  let changeSet = state.changes(changes);
  dispatch(state.update({
    changes: changeSet,
    selection: state.selection.map(changeSet, forward ? 1 : -1),
    scrollIntoView: true,
    userEvent: "input.copyline"
  }));
  return true;
}
const copyLineUp = ({ state, dispatch }) => copyLine(state, dispatch, false);
const copyLineDown = ({ state, dispatch }) => copyLine(state, dispatch, true);
const deleteLine = (view) => {
  if (view.state.readOnly)
    return false;
  let { state } = view, changes = state.changes(selectedLineBlocks(state).map(({ from, to: to2 }) => {
    if (from > 0)
      from--;
    else if (to2 < state.doc.length)
      to2++;
    return { from, to: to2 };
  }));
  let selection2 = updateSel(state.selection, (range2) => {
    let dist2 = void 0;
    if (view.lineWrapping) {
      let block = view.lineBlockAt(range2.head), pos = view.coordsAtPos(range2.head, range2.assoc || 1);
      if (pos)
        dist2 = block.bottom + view.documentTop - pos.bottom + view.defaultLineHeight / 2;
    }
    return view.moveVertically(range2, true, dist2);
  }).map(changes);
  view.dispatch({ changes, selection: selection2, scrollIntoView: true, userEvent: "delete.line" });
  return true;
};
function isBetweenBrackets(state, pos) {
  if (/\(\)|\[\]|\{\}/.test(state.sliceDoc(pos - 1, pos + 1)))
    return { from: pos, to: pos };
  let context = syntaxTree(state).resolveInner(pos);
  let before2 = context.childBefore(pos), after2 = context.childAfter(pos), closedBy;
  if (before2 && after2 && before2.to <= pos && after2.from >= pos && (closedBy = before2.type.prop(NodeProp$1.closedBy)) && closedBy.indexOf(after2.name) > -1 && state.doc.lineAt(before2.to).from == state.doc.lineAt(after2.from).from && !/\S/.test(state.sliceDoc(before2.to, after2.from)))
    return { from: before2.to, to: after2.from };
  return null;
}
const insertNewlineAndIndent = /* @__PURE__ */ newlineAndIndent(false);
const insertBlankLine = /* @__PURE__ */ newlineAndIndent(true);
function newlineAndIndent(atEof) {
  return ({ state, dispatch }) => {
    if (state.readOnly)
      return false;
    let changes = state.changeByRange((range2) => {
      let { from, to: to2 } = range2, line2 = state.doc.lineAt(from);
      let explode = !atEof && from == to2 && isBetweenBrackets(state, from);
      if (atEof)
        from = to2 = (to2 <= line2.to ? line2 : state.doc.lineAt(to2)).to;
      let cx = new IndentContext(state, { simulateBreak: from, simulateDoubleBreak: !!explode });
      let indent2 = getIndentation(cx, from);
      if (indent2 == null)
        indent2 = countColumn(/^\s*/.exec(state.doc.lineAt(from).text)[0], state.tabSize);
      while (to2 < line2.to && /\s/.test(line2.text[to2 - line2.from]))
        to2++;
      if (explode)
        ({ from, to: to2 } = explode);
      else if (from > line2.from && from < line2.from + 100 && !/\S/.test(line2.text.slice(0, from)))
        from = line2.from;
      let insert2 = ["", indentString(state, indent2)];
      if (explode)
        insert2.push(indentString(state, cx.lineIndent(line2.from, -1)));
      return {
        changes: { from, to: to2, insert: Text$1.of(insert2) },
        range: EditorSelection.cursor(from + 1 + insert2[1].length)
      };
    });
    dispatch(state.update(changes, { scrollIntoView: true, userEvent: "input" }));
    return true;
  };
}
function changeBySelectedLine(state, f2) {
  let atLine = -1;
  return state.changeByRange((range2) => {
    let changes = [];
    for (let pos = range2.from; pos <= range2.to; ) {
      let line2 = state.doc.lineAt(pos);
      if (line2.number > atLine && (range2.empty || range2.to > line2.from)) {
        f2(line2, changes, range2);
        atLine = line2.number;
      }
      pos = line2.to + 1;
    }
    let changeSet = state.changes(changes);
    return {
      changes,
      range: EditorSelection.range(changeSet.mapPos(range2.anchor, 1), changeSet.mapPos(range2.head, 1))
    };
  });
}
const indentSelection = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  let updated = /* @__PURE__ */ Object.create(null);
  let context = new IndentContext(state, { overrideIndentation: (start) => {
    let found = updated[start];
    return found == null ? -1 : found;
  } });
  let changes = changeBySelectedLine(state, (line2, changes2, range2) => {
    let indent2 = getIndentation(context, line2.from);
    if (indent2 == null)
      return;
    if (!/\S/.test(line2.text))
      indent2 = 0;
    let cur2 = /^\s*/.exec(line2.text)[0];
    let norm = indentString(state, indent2);
    if (cur2 != norm || range2.from < line2.from + cur2.length) {
      updated[line2.from] = indent2;
      changes2.push({ from: line2.from, to: line2.from + cur2.length, insert: norm });
    }
  });
  if (!changes.changes.empty)
    dispatch(state.update(changes, { userEvent: "indent" }));
  return true;
};
const indentMore = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line2, changes) => {
    changes.push({ from: line2.from, insert: state.facet(indentUnit) });
  }), { userEvent: "input.indent" }));
  return true;
};
const indentLess = ({ state, dispatch }) => {
  if (state.readOnly)
    return false;
  dispatch(state.update(changeBySelectedLine(state, (line2, changes) => {
    let space = /^\s*/.exec(line2.text)[0];
    if (!space)
      return;
    let col = countColumn(space, state.tabSize), keep = 0;
    let insert2 = indentString(state, Math.max(0, col - getIndentUnit(state)));
    while (keep < space.length && keep < insert2.length && space.charCodeAt(keep) == insert2.charCodeAt(keep))
      keep++;
    changes.push({ from: line2.from + keep, to: line2.from + space.length, insert: insert2.slice(keep) });
  }), { userEvent: "delete.dedent" }));
  return true;
};
const toggleTabFocusMode = (view) => {
  view.setTabFocusMode();
  return true;
};
const emacsStyleKeymap = [
  { key: "Ctrl-b", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Ctrl-f", run: cursorCharRight, shift: selectCharRight },
  { key: "Ctrl-p", run: cursorLineUp, shift: selectLineUp },
  { key: "Ctrl-n", run: cursorLineDown, shift: selectLineDown },
  { key: "Ctrl-a", run: cursorLineStart, shift: selectLineStart },
  { key: "Ctrl-e", run: cursorLineEnd, shift: selectLineEnd },
  { key: "Ctrl-d", run: deleteCharForward },
  { key: "Ctrl-h", run: deleteCharBackward },
  { key: "Ctrl-k", run: deleteToLineEnd },
  { key: "Ctrl-Alt-h", run: deleteGroupBackward },
  { key: "Ctrl-o", run: splitLine },
  { key: "Ctrl-t", run: transposeChars },
  { key: "Ctrl-v", run: cursorPageDown }
];
const standardKeymap = /* @__PURE__ */ [
  { key: "ArrowLeft", run: cursorCharLeft, shift: selectCharLeft, preventDefault: true },
  { key: "Mod-ArrowLeft", mac: "Alt-ArrowLeft", run: cursorGroupLeft, shift: selectGroupLeft, preventDefault: true },
  { mac: "Cmd-ArrowLeft", run: cursorLineBoundaryLeft, shift: selectLineBoundaryLeft, preventDefault: true },
  { key: "ArrowRight", run: cursorCharRight, shift: selectCharRight, preventDefault: true },
  { key: "Mod-ArrowRight", mac: "Alt-ArrowRight", run: cursorGroupRight, shift: selectGroupRight, preventDefault: true },
  { mac: "Cmd-ArrowRight", run: cursorLineBoundaryRight, shift: selectLineBoundaryRight, preventDefault: true },
  { key: "ArrowUp", run: cursorLineUp, shift: selectLineUp, preventDefault: true },
  { mac: "Cmd-ArrowUp", run: cursorDocStart, shift: selectDocStart },
  { mac: "Ctrl-ArrowUp", run: cursorPageUp, shift: selectPageUp },
  { key: "ArrowDown", run: cursorLineDown, shift: selectLineDown, preventDefault: true },
  { mac: "Cmd-ArrowDown", run: cursorDocEnd, shift: selectDocEnd },
  { mac: "Ctrl-ArrowDown", run: cursorPageDown, shift: selectPageDown },
  { key: "PageUp", run: cursorPageUp, shift: selectPageUp },
  { key: "PageDown", run: cursorPageDown, shift: selectPageDown },
  { key: "Home", run: cursorLineBoundaryBackward, shift: selectLineBoundaryBackward, preventDefault: true },
  { key: "Mod-Home", run: cursorDocStart, shift: selectDocStart },
  { key: "End", run: cursorLineBoundaryForward, shift: selectLineBoundaryForward, preventDefault: true },
  { key: "Mod-End", run: cursorDocEnd, shift: selectDocEnd },
  { key: "Enter", run: insertNewlineAndIndent, shift: insertNewlineAndIndent },
  { key: "Mod-a", run: selectAll },
  { key: "Backspace", run: deleteCharBackward, shift: deleteCharBackward, preventDefault: true },
  { key: "Delete", run: deleteCharForward, preventDefault: true },
  { key: "Mod-Backspace", mac: "Alt-Backspace", run: deleteGroupBackward, preventDefault: true },
  { key: "Mod-Delete", mac: "Alt-Delete", run: deleteGroupForward, preventDefault: true },
  { mac: "Mod-Backspace", run: deleteLineBoundaryBackward, preventDefault: true },
  { mac: "Mod-Delete", run: deleteLineBoundaryForward, preventDefault: true }
].concat(/* @__PURE__ */ emacsStyleKeymap.map((b2) => ({ mac: b2.key, run: b2.run, shift: b2.shift })));
const defaultKeymap = /* @__PURE__ */ [
  { key: "Alt-ArrowLeft", mac: "Ctrl-ArrowLeft", run: cursorSyntaxLeft, shift: selectSyntaxLeft },
  { key: "Alt-ArrowRight", mac: "Ctrl-ArrowRight", run: cursorSyntaxRight, shift: selectSyntaxRight },
  { key: "Alt-ArrowUp", run: moveLineUp },
  { key: "Shift-Alt-ArrowUp", run: copyLineUp },
  { key: "Alt-ArrowDown", run: moveLineDown },
  { key: "Shift-Alt-ArrowDown", run: copyLineDown },
  { key: "Mod-Alt-ArrowUp", run: addCursorAbove },
  { key: "Mod-Alt-ArrowDown", run: addCursorBelow },
  { key: "Escape", run: simplifySelection },
  { key: "Mod-Enter", run: insertBlankLine },
  { key: "Alt-l", mac: "Ctrl-l", run: selectLine },
  { key: "Mod-i", run: selectParentSyntax, preventDefault: true },
  { key: "Mod-[", run: indentLess },
  { key: "Mod-]", run: indentMore },
  { key: "Mod-Alt-\\", run: indentSelection },
  { key: "Shift-Mod-k", run: deleteLine },
  { key: "Shift-Mod-\\", run: cursorMatchingBracket },
  { key: "Mod-/", run: toggleComment },
  { key: "Alt-A", run: toggleBlockComment },
  { key: "Ctrl-m", mac: "Shift-Alt-m", run: toggleTabFocusMode }
].concat(standardKeymap);
const indentWithTab = { key: "Tab", run: indentMore, shift: indentLess };
const basicNormalize = typeof String.prototype.normalize == "function" ? (x2) => x2.normalize("NFKD") : (x2) => x2;
class SearchCursor {
  /**
  Create a text cursor. The query is the search string, `from` to
  `to` provides the region to search.
  
  When `normalize` is given, it will be called, on both the query
  string and the content it is matched against, before comparing.
  You can, for example, create a case-insensitive search by
  passing `s => s.toLowerCase()`.
  
  Text is always normalized with
  [`.normalize("NFKD")`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/String/normalize)
  (when supported).
  */
  constructor(text2, query, from = 0, to2 = text2.length, normalize2, test) {
    this.test = test;
    this.value = { from: 0, to: 0 };
    this.done = false;
    this.matches = [];
    this.buffer = "";
    this.bufferPos = 0;
    this.iter = text2.iterRange(from, to2);
    this.bufferStart = from;
    this.normalize = normalize2 ? (x2) => normalize2(basicNormalize(x2)) : basicNormalize;
    this.query = this.normalize(query);
  }
  peek() {
    if (this.bufferPos == this.buffer.length) {
      this.bufferStart += this.buffer.length;
      this.iter.next();
      if (this.iter.done)
        return -1;
      this.bufferPos = 0;
      this.buffer = this.iter.value;
    }
    return codePointAt(this.buffer, this.bufferPos);
  }
  /**
  Look for the next match. Updates the iterator's
  [`value`](https://codemirror.net/6/docs/ref/#search.SearchCursor.value) and
  [`done`](https://codemirror.net/6/docs/ref/#search.SearchCursor.done) properties. Should be called
  at least once before using the cursor.
  */
  next() {
    while (this.matches.length)
      this.matches.pop();
    return this.nextOverlapping();
  }
  /**
  The `next` method will ignore matches that partially overlap a
  previous match. This method behaves like `next`, but includes
  such matches.
  */
  nextOverlapping() {
    for (; ; ) {
      let next = this.peek();
      if (next < 0) {
        this.done = true;
        return this;
      }
      let str = fromCodePoint(next), start = this.bufferStart + this.bufferPos;
      this.bufferPos += codePointSize(next);
      let norm = this.normalize(str);
      if (norm.length)
        for (let i2 = 0, pos = start; ; i2++) {
          let code2 = norm.charCodeAt(i2);
          let match2 = this.match(code2, pos, this.bufferPos + this.bufferStart);
          if (i2 == norm.length - 1) {
            if (match2) {
              this.value = match2;
              return this;
            }
            break;
          }
          if (pos == start && i2 < str.length && str.charCodeAt(i2) == code2)
            pos++;
        }
    }
  }
  match(code2, pos, end) {
    let match2 = null;
    for (let i2 = 0; i2 < this.matches.length; i2 += 2) {
      let index2 = this.matches[i2], keep = false;
      if (this.query.charCodeAt(index2) == code2) {
        if (index2 == this.query.length - 1) {
          match2 = { from: this.matches[i2 + 1], to: end };
        } else {
          this.matches[i2]++;
          keep = true;
        }
      }
      if (!keep) {
        this.matches.splice(i2, 2);
        i2 -= 2;
      }
    }
    if (this.query.charCodeAt(0) == code2) {
      if (this.query.length == 1)
        match2 = { from: pos, to: end };
      else
        this.matches.push(1, pos);
    }
    if (match2 && this.test && !this.test(match2.from, match2.to, this.buffer, this.bufferStart))
      match2 = null;
    return match2;
  }
}
if (typeof Symbol != "undefined")
  SearchCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
const empty = { from: -1, to: -1, match: /* @__PURE__ */ /.*/.exec("") };
const baseFlags = "gm" + (/x/.unicode == null ? "" : "u");
class RegExpCursor {
  /**
  Create a cursor that will search the given range in the given
  document. `query` should be the raw pattern (as you'd pass it to
  `new RegExp`).
  */
  constructor(text2, query, options2, from = 0, to2 = text2.length) {
    this.text = text2;
    this.to = to2;
    this.curLine = "";
    this.done = false;
    this.value = empty;
    if (/\\[sWDnr]|\n|\r|\[\^/.test(query))
      return new MultilineRegExpCursor(text2, query, options2, from, to2);
    this.re = new RegExp(query, baseFlags + ((options2 === null || options2 === void 0 ? void 0 : options2.ignoreCase) ? "i" : ""));
    this.test = options2 === null || options2 === void 0 ? void 0 : options2.test;
    this.iter = text2.iter();
    let startLine = text2.lineAt(from);
    this.curLineStart = startLine.from;
    this.matchPos = toCharEnd(text2, from);
    this.getLine(this.curLineStart);
  }
  getLine(skip) {
    this.iter.next(skip);
    if (this.iter.lineBreak) {
      this.curLine = "";
    } else {
      this.curLine = this.iter.value;
      if (this.curLineStart + this.curLine.length > this.to)
        this.curLine = this.curLine.slice(0, this.to - this.curLineStart);
      this.iter.next();
    }
  }
  nextLine() {
    this.curLineStart = this.curLineStart + this.curLine.length + 1;
    if (this.curLineStart > this.to)
      this.curLine = "";
    else
      this.getLine(0);
  }
  /**
  Move to the next match, if there is one.
  */
  next() {
    for (let off = this.matchPos - this.curLineStart; ; ) {
      this.re.lastIndex = off;
      let match2 = this.matchPos <= this.to && this.re.exec(this.curLine);
      if (match2) {
        let from = this.curLineStart + match2.index, to2 = from + match2[0].length;
        this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
        if (from == this.curLineStart + this.curLine.length)
          this.nextLine();
        if ((from < to2 || from > this.value.to) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          return this;
        }
        off = this.matchPos - this.curLineStart;
      } else if (this.curLineStart + this.curLine.length < this.to) {
        this.nextLine();
        off = 0;
      } else {
        this.done = true;
        return this;
      }
    }
  }
}
const flattened = /* @__PURE__ */ new WeakMap();
class FlattenedDoc {
  constructor(from, text2) {
    this.from = from;
    this.text = text2;
  }
  get to() {
    return this.from + this.text.length;
  }
  static get(doc2, from, to2) {
    let cached = flattened.get(doc2);
    if (!cached || cached.from >= to2 || cached.to <= from) {
      let flat = new FlattenedDoc(from, doc2.sliceString(from, to2));
      flattened.set(doc2, flat);
      return flat;
    }
    if (cached.from == from && cached.to == to2)
      return cached;
    let { text: text2, from: cachedFrom } = cached;
    if (cachedFrom > from) {
      text2 = doc2.sliceString(from, cachedFrom) + text2;
      cachedFrom = from;
    }
    if (cached.to < to2)
      text2 += doc2.sliceString(cached.to, to2);
    flattened.set(doc2, new FlattenedDoc(cachedFrom, text2));
    return new FlattenedDoc(from, text2.slice(from - cachedFrom, to2 - cachedFrom));
  }
}
class MultilineRegExpCursor {
  constructor(text2, query, options2, from, to2) {
    this.text = text2;
    this.to = to2;
    this.done = false;
    this.value = empty;
    this.matchPos = toCharEnd(text2, from);
    this.re = new RegExp(query, baseFlags + ((options2 === null || options2 === void 0 ? void 0 : options2.ignoreCase) ? "i" : ""));
    this.test = options2 === null || options2 === void 0 ? void 0 : options2.test;
    this.flat = FlattenedDoc.get(text2, from, this.chunkEnd(
      from + 5e3
      /* Chunk.Base */
    ));
  }
  chunkEnd(pos) {
    return pos >= this.to ? this.to : this.text.lineAt(pos).to;
  }
  next() {
    for (; ; ) {
      let off = this.re.lastIndex = this.matchPos - this.flat.from;
      let match2 = this.re.exec(this.flat.text);
      if (match2 && !match2[0] && match2.index == off) {
        this.re.lastIndex = off + 1;
        match2 = this.re.exec(this.flat.text);
      }
      if (match2) {
        let from = this.flat.from + match2.index, to2 = from + match2[0].length;
        if ((this.flat.to >= this.to || match2.index + match2[0].length <= this.flat.text.length - 10) && (!this.test || this.test(from, to2, match2))) {
          this.value = { from, to: to2, match: match2 };
          this.matchPos = toCharEnd(this.text, to2 + (from == to2 ? 1 : 0));
          return this;
        }
      }
      if (this.flat.to == this.to) {
        this.done = true;
        return this;
      }
      this.flat = FlattenedDoc.get(this.text, this.flat.from, this.chunkEnd(this.flat.from + this.flat.text.length * 2));
    }
  }
}
if (typeof Symbol != "undefined") {
  RegExpCursor.prototype[Symbol.iterator] = MultilineRegExpCursor.prototype[Symbol.iterator] = function() {
    return this;
  };
}
function validRegExp(source) {
  try {
    new RegExp(source, baseFlags);
    return true;
  } catch (_a2) {
    return false;
  }
}
function toCharEnd(text2, pos) {
  if (pos >= text2.length)
    return pos;
  let line2 = text2.lineAt(pos), next;
  while (pos < line2.to && (next = line2.text.charCodeAt(pos - line2.from)) >= 56320 && next < 57344)
    pos++;
  return pos;
}
function createLineDialog(view) {
  let line2 = String(view.state.doc.lineAt(view.state.selection.main.head).number);
  let input = crelt("input", { class: "cm-textfield", name: "line", value: line2 });
  let dom = crelt("form", {
    class: "cm-gotoLine",
    onkeydown: (event) => {
      if (event.keyCode == 27) {
        event.preventDefault();
        view.dispatch({ effects: dialogEffect.of(false) });
        view.focus();
      } else if (event.keyCode == 13) {
        event.preventDefault();
        go2();
      }
    },
    onsubmit: (event) => {
      event.preventDefault();
      go2();
    }
  }, crelt("label", view.state.phrase("Go to line"), ": ", input), " ", crelt("button", { class: "cm-button", type: "submit" }, view.state.phrase("go")), crelt("button", {
    name: "close",
    onclick: () => {
      view.dispatch({ effects: dialogEffect.of(false) });
      view.focus();
    },
    "aria-label": view.state.phrase("close"),
    type: "button"
  }, ["×"]));
  function go2() {
    let match2 = /^([+-])?(\d+)?(:\d+)?(%)?$/.exec(input.value);
    if (!match2)
      return;
    let { state } = view, startLine = state.doc.lineAt(state.selection.main.head);
    let [, sign2, ln2, cl, percent] = match2;
    let col = cl ? +cl.slice(1) : 0;
    let line22 = ln2 ? +ln2 : startLine.number;
    if (ln2 && percent) {
      let pc = line22 / 100;
      if (sign2)
        pc = pc * (sign2 == "-" ? -1 : 1) + startLine.number / state.doc.lines;
      line22 = Math.round(state.doc.lines * pc);
    } else if (ln2 && sign2) {
      line22 = line22 * (sign2 == "-" ? -1 : 1) + startLine.number;
    }
    let docLine = state.doc.line(Math.max(1, Math.min(state.doc.lines, line22)));
    let selection2 = EditorSelection.cursor(docLine.from + Math.max(0, Math.min(col, docLine.length)));
    view.dispatch({
      effects: [dialogEffect.of(false), EditorView.scrollIntoView(selection2.from, { y: "center" })],
      selection: selection2
    });
    view.focus();
  }
  return { dom };
}
const dialogEffect = /* @__PURE__ */ StateEffect.define();
const dialogField = /* @__PURE__ */ StateField.define({
  create() {
    return true;
  },
  update(value, tr2) {
    for (let e2 of tr2.effects)
      if (e2.is(dialogEffect))
        value = e2.value;
    return value;
  },
  provide: (f2) => showPanel.from(f2, (val) => val ? createLineDialog : null)
});
const gotoLine = (view) => {
  let panel = getPanel(view, createLineDialog);
  if (!panel) {
    let effects = [dialogEffect.of(true)];
    if (view.state.field(dialogField, false) == null)
      effects.push(StateEffect.appendConfig.of([dialogField, baseTheme$1]));
    view.dispatch({ effects });
    panel = getPanel(view, createLineDialog);
  }
  if (panel)
    panel.dom.querySelector("input").select();
  return true;
};
const baseTheme$1 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-gotoLine": {
    padding: "2px 6px 4px",
    position: "relative",
    "& label": { fontSize: "80%" },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      bottom: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: "0"
    }
  }
});
const defaultHighlightOptions = {
  highlightWordAroundCursor: false,
  minSelectionLength: 1,
  maxMatches: 100,
  wholeWords: false
};
const highlightConfig = /* @__PURE__ */ Facet.define({
  combine(options2) {
    return combineConfig(options2, defaultHighlightOptions, {
      highlightWordAroundCursor: (a2, b2) => a2 || b2,
      minSelectionLength: Math.min,
      maxMatches: Math.min
    });
  }
});
function highlightSelectionMatches(options2) {
  let ext = [defaultTheme, matchHighlighter];
  return ext;
}
const matchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch" });
const mainMatchDeco = /* @__PURE__ */ Decoration.mark({ class: "cm-selectionMatch cm-selectionMatch-main" });
function insideWordBoundaries(check, state, from, to2) {
  return (from == 0 || check(state.sliceDoc(from - 1, from)) != CharCategory.Word) && (to2 == state.doc.length || check(state.sliceDoc(to2, to2 + 1)) != CharCategory.Word);
}
function insideWord(check, state, from, to2) {
  return check(state.sliceDoc(from, from + 1)) == CharCategory.Word && check(state.sliceDoc(to2 - 1, to2)) == CharCategory.Word;
}
const matchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.decorations = this.getDeco(view);
  }
  update(update) {
    if (update.selectionSet || update.docChanged || update.viewportChanged)
      this.decorations = this.getDeco(update.view);
  }
  getDeco(view) {
    let conf = view.state.facet(highlightConfig);
    let { state } = view, sel = state.selection;
    if (sel.ranges.length > 1)
      return Decoration.none;
    let range2 = sel.main, query, check = null;
    if (range2.empty) {
      if (!conf.highlightWordAroundCursor)
        return Decoration.none;
      let word = state.wordAt(range2.head);
      if (!word)
        return Decoration.none;
      check = state.charCategorizer(range2.head);
      query = state.sliceDoc(word.from, word.to);
    } else {
      let len = range2.to - range2.from;
      if (len < conf.minSelectionLength || len > 200)
        return Decoration.none;
      if (conf.wholeWords) {
        query = state.sliceDoc(range2.from, range2.to);
        check = state.charCategorizer(range2.head);
        if (!(insideWordBoundaries(check, state, range2.from, range2.to) && insideWord(check, state, range2.from, range2.to)))
          return Decoration.none;
      } else {
        query = state.sliceDoc(range2.from, range2.to);
        if (!query)
          return Decoration.none;
      }
    }
    let deco = [];
    for (let part of view.visibleRanges) {
      let cursor2 = new SearchCursor(state.doc, query, part.from, part.to);
      while (!cursor2.next().done) {
        let { from, to: to2 } = cursor2.value;
        if (!check || insideWordBoundaries(check, state, from, to2)) {
          if (range2.empty && from <= range2.from && to2 >= range2.to)
            deco.push(mainMatchDeco.range(from, to2));
          else if (from >= range2.to || to2 <= range2.from)
            deco.push(matchDeco.range(from, to2));
          if (deco.length > conf.maxMatches)
            return Decoration.none;
        }
      }
    }
    return Decoration.set(deco);
  }
}, {
  decorations: (v2) => v2.decorations
});
const defaultTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-selectionMatch": { backgroundColor: "#99ff7780" },
  ".cm-searchMatch .cm-selectionMatch": { backgroundColor: "transparent" }
});
const selectWord = ({ state, dispatch }) => {
  let { selection: selection2 } = state;
  let newSel = EditorSelection.create(selection2.ranges.map((range2) => state.wordAt(range2.head) || EditorSelection.cursor(range2.head)), selection2.mainIndex);
  if (newSel.eq(selection2))
    return false;
  dispatch(state.update({ selection: newSel }));
  return true;
};
function findNextOccurrence(state, query) {
  let { main: main2, ranges } = state.selection;
  let word = state.wordAt(main2.head), fullWord = word && word.from == main2.from && word.to == main2.to;
  for (let cycled = false, cursor2 = new SearchCursor(state.doc, query, ranges[ranges.length - 1].to); ; ) {
    cursor2.next();
    if (cursor2.done) {
      if (cycled)
        return null;
      cursor2 = new SearchCursor(state.doc, query, 0, Math.max(0, ranges[ranges.length - 1].from - 1));
      cycled = true;
    } else {
      if (cycled && ranges.some((r2) => r2.from == cursor2.value.from))
        continue;
      if (fullWord) {
        let word2 = state.wordAt(cursor2.value.from);
        if (!word2 || word2.from != cursor2.value.from || word2.to != cursor2.value.to)
          continue;
      }
      return cursor2.value;
    }
  }
}
const selectNextOccurrence = ({ state, dispatch }) => {
  let { ranges } = state.selection;
  if (ranges.some((sel) => sel.from === sel.to))
    return selectWord({ state, dispatch });
  let searchedText = state.sliceDoc(ranges[0].from, ranges[0].to);
  if (state.selection.ranges.some((r2) => state.sliceDoc(r2.from, r2.to) != searchedText))
    return false;
  let range2 = findNextOccurrence(state, searchedText);
  if (!range2)
    return false;
  dispatch(state.update({
    selection: state.selection.addRange(EditorSelection.range(range2.from, range2.to), false),
    effects: EditorView.scrollIntoView(range2.to)
  }));
  return true;
};
const searchConfigFacet = /* @__PURE__ */ Facet.define({
  combine(configs) {
    return combineConfig(configs, {
      top: false,
      caseSensitive: false,
      literal: false,
      regexp: false,
      wholeWord: false,
      createPanel: (view) => new SearchPanel(view),
      scrollToMatch: (range2) => EditorView.scrollIntoView(range2)
    });
  }
});
class SearchQuery {
  /**
  Create a query object.
  */
  constructor(config2) {
    this.search = config2.search;
    this.caseSensitive = !!config2.caseSensitive;
    this.literal = !!config2.literal;
    this.regexp = !!config2.regexp;
    this.replace = config2.replace || "";
    this.valid = !!this.search && (!this.regexp || validRegExp(this.search));
    this.unquoted = this.unquote(this.search);
    this.wholeWord = !!config2.wholeWord;
  }
  /**
  @internal
  */
  unquote(text2) {
    return this.literal ? text2 : text2.replace(/\\([nrt\\])/g, (_2, ch) => ch == "n" ? "\n" : ch == "r" ? "\r" : ch == "t" ? "	" : "\\");
  }
  /**
  Compare this query to another query.
  */
  eq(other) {
    return this.search == other.search && this.replace == other.replace && this.caseSensitive == other.caseSensitive && this.regexp == other.regexp && this.wholeWord == other.wholeWord;
  }
  /**
  @internal
  */
  create() {
    return this.regexp ? new RegExpQuery(this) : new StringQuery(this);
  }
  /**
  Get a search cursor for this query, searching through the given
  range in the given state.
  */
  getCursor(state, from = 0, to2) {
    let st2 = state.doc ? state : EditorState.create({ doc: state });
    if (to2 == null)
      to2 = st2.doc.length;
    return this.regexp ? regexpCursor(this, st2, from, to2) : stringCursor(this, st2, from, to2);
  }
}
class QueryType {
  constructor(spec) {
    this.spec = spec;
  }
}
function stringCursor(spec, state, from, to2) {
  return new SearchCursor(state.doc, spec.unquoted, from, to2, spec.caseSensitive ? void 0 : (x2) => x2.toLowerCase(), spec.wholeWord ? stringWordTest(state.doc, state.charCategorizer(state.selection.main.head)) : void 0);
}
function stringWordTest(doc2, categorizer) {
  return (from, to2, buf, bufPos) => {
    if (bufPos > from || bufPos + buf.length < to2) {
      bufPos = Math.max(0, from - 2);
      buf = doc2.sliceString(bufPos, Math.min(doc2.length, to2 + 2));
    }
    return (categorizer(charBefore(buf, from - bufPos)) != CharCategory.Word || categorizer(charAfter(buf, from - bufPos)) != CharCategory.Word) && (categorizer(charAfter(buf, to2 - bufPos)) != CharCategory.Word || categorizer(charBefore(buf, to2 - bufPos)) != CharCategory.Word);
  };
}
class StringQuery extends QueryType {
  constructor(spec) {
    super(spec);
  }
  nextMatch(state, curFrom, curTo) {
    let cursor2 = stringCursor(this.spec, state, curTo, state.doc.length).nextOverlapping();
    if (cursor2.done) {
      let end = Math.min(state.doc.length, curFrom + this.spec.unquoted.length);
      cursor2 = stringCursor(this.spec, state, 0, end).nextOverlapping();
    }
    return cursor2.done || cursor2.value.from == curFrom && cursor2.value.to == curTo ? null : cursor2.value;
  }
  // Searching in reverse is, rather than implementing an inverted search
  // cursor, done by scanning chunk after chunk forward.
  prevMatchInRange(state, from, to2) {
    for (let pos = to2; ; ) {
      let start = Math.max(from, pos - 1e4 - this.spec.unquoted.length);
      let cursor2 = stringCursor(this.spec, state, start, pos), range2 = null;
      while (!cursor2.nextOverlapping().done)
        range2 = cursor2.value;
      if (range2)
        return range2;
      if (start == from)
        return null;
      pos -= 1e4;
    }
  }
  prevMatch(state, curFrom, curTo) {
    let found = this.prevMatchInRange(state, 0, curFrom);
    if (!found)
      found = this.prevMatchInRange(state, Math.max(0, curTo - this.spec.unquoted.length), state.doc.length);
    return found && (found.from != curFrom || found.to != curTo) ? found : null;
  }
  getReplacement(_result) {
    return this.spec.unquote(this.spec.replace);
  }
  matchAll(state, limit) {
    let cursor2 = stringCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor2.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor2.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor2 = stringCursor(this.spec, state, Math.max(0, from - this.spec.unquoted.length), Math.min(to2 + this.spec.unquoted.length, state.doc.length));
    while (!cursor2.next().done)
      add2(cursor2.value.from, cursor2.value.to);
  }
}
function regexpCursor(spec, state, from, to2) {
  return new RegExpCursor(state.doc, spec.search, {
    ignoreCase: !spec.caseSensitive,
    test: spec.wholeWord ? regexpWordTest(state.charCategorizer(state.selection.main.head)) : void 0
  }, from, to2);
}
function charBefore(str, index2) {
  return str.slice(findClusterBreak(str, index2, false), index2);
}
function charAfter(str, index2) {
  return str.slice(index2, findClusterBreak(str, index2));
}
function regexpWordTest(categorizer) {
  return (_from, _to, match2) => !match2[0].length || (categorizer(charBefore(match2.input, match2.index)) != CharCategory.Word || categorizer(charAfter(match2.input, match2.index)) != CharCategory.Word) && (categorizer(charAfter(match2.input, match2.index + match2[0].length)) != CharCategory.Word || categorizer(charBefore(match2.input, match2.index + match2[0].length)) != CharCategory.Word);
}
class RegExpQuery extends QueryType {
  nextMatch(state, curFrom, curTo) {
    let cursor2 = regexpCursor(this.spec, state, curTo, state.doc.length).next();
    if (cursor2.done)
      cursor2 = regexpCursor(this.spec, state, 0, curFrom).next();
    return cursor2.done ? null : cursor2.value;
  }
  prevMatchInRange(state, from, to2) {
    for (let size2 = 1; ; size2++) {
      let start = Math.max(
        from,
        to2 - size2 * 1e4
        /* FindPrev.ChunkSize */
      );
      let cursor2 = regexpCursor(this.spec, state, start, to2), range2 = null;
      while (!cursor2.next().done)
        range2 = cursor2.value;
      if (range2 && (start == from || range2.from > start + 10))
        return range2;
      if (start == from)
        return null;
    }
  }
  prevMatch(state, curFrom, curTo) {
    return this.prevMatchInRange(state, 0, curFrom) || this.prevMatchInRange(state, curTo, state.doc.length);
  }
  getReplacement(result2) {
    return this.spec.unquote(this.spec.replace).replace(/\$([$&]|\d+)/g, (m2, i2) => {
      if (i2 == "&")
        return result2.match[0];
      if (i2 == "$")
        return "$";
      for (let l2 = i2.length; l2 > 0; l2--) {
        let n2 = +i2.slice(0, l2);
        if (n2 > 0 && n2 < result2.match.length)
          return result2.match[n2] + i2.slice(l2);
      }
      return m2;
    });
  }
  matchAll(state, limit) {
    let cursor2 = regexpCursor(this.spec, state, 0, state.doc.length), ranges = [];
    while (!cursor2.next().done) {
      if (ranges.length >= limit)
        return null;
      ranges.push(cursor2.value);
    }
    return ranges;
  }
  highlight(state, from, to2, add2) {
    let cursor2 = regexpCursor(this.spec, state, Math.max(
      0,
      from - 250
      /* RegExp.HighlightMargin */
    ), Math.min(to2 + 250, state.doc.length));
    while (!cursor2.next().done)
      add2(cursor2.value.from, cursor2.value.to);
  }
}
const setSearchQuery = /* @__PURE__ */ StateEffect.define();
const togglePanel$1 = /* @__PURE__ */ StateEffect.define();
const searchState = /* @__PURE__ */ StateField.define({
  create(state) {
    return new SearchState(defaultQuery(state).create(), null);
  },
  update(value, tr2) {
    for (let effect of tr2.effects) {
      if (effect.is(setSearchQuery))
        value = new SearchState(effect.value.create(), value.panel);
      else if (effect.is(togglePanel$1))
        value = new SearchState(value.query, effect.value ? createSearchPanel : null);
    }
    return value;
  },
  provide: (f2) => showPanel.from(f2, (val) => val.panel)
});
class SearchState {
  constructor(query, panel) {
    this.query = query;
    this.panel = panel;
  }
}
const matchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch" }), selectedMatchMark = /* @__PURE__ */ Decoration.mark({ class: "cm-searchMatch cm-searchMatch-selected" });
const searchHighlighter = /* @__PURE__ */ ViewPlugin.fromClass(class {
  constructor(view) {
    this.view = view;
    this.decorations = this.highlight(view.state.field(searchState));
  }
  update(update) {
    let state = update.state.field(searchState);
    if (state != update.startState.field(searchState) || update.docChanged || update.selectionSet || update.viewportChanged)
      this.decorations = this.highlight(state);
  }
  highlight({ query, panel }) {
    if (!panel || !query.spec.valid)
      return Decoration.none;
    let { view } = this;
    let builder = new RangeSetBuilder();
    for (let i2 = 0, ranges = view.visibleRanges, l2 = ranges.length; i2 < l2; i2++) {
      let { from, to: to2 } = ranges[i2];
      while (i2 < l2 - 1 && to2 > ranges[i2 + 1].from - 2 * 250)
        to2 = ranges[++i2].to;
      query.highlight(view.state, from, to2, (from2, to22) => {
        let selected = view.state.selection.ranges.some((r2) => r2.from == from2 && r2.to == to22);
        builder.add(from2, to22, selected ? selectedMatchMark : matchMark);
      });
    }
    return builder.finish();
  }
}, {
  decorations: (v2) => v2.decorations
});
function searchCommand(f2) {
  return (view) => {
    let state = view.state.field(searchState, false);
    return state && state.query.spec.valid ? f2(view, state) : openSearchPanel(view);
  };
}
const findNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { to: to2 } = view.state.selection.main;
  let next = query.nextMatch(view.state, to2, to2);
  if (!next)
    return false;
  let selection2 = EditorSelection.single(next.from, next.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection: selection2,
    effects: [announceMatch(view, next), config2.scrollToMatch(selection2.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const findPrevious = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from } = state.selection.main;
  let prev = query.prevMatch(state, from, from);
  if (!prev)
    return false;
  let selection2 = EditorSelection.single(prev.from, prev.to);
  let config2 = view.state.facet(searchConfigFacet);
  view.dispatch({
    selection: selection2,
    effects: [announceMatch(view, prev), config2.scrollToMatch(selection2.main, view)],
    userEvent: "select.search"
  });
  selectSearchInput(view);
  return true;
});
const selectMatches = /* @__PURE__ */ searchCommand((view, { query }) => {
  let ranges = query.matchAll(view.state, 1e3);
  if (!ranges || !ranges.length)
    return false;
  view.dispatch({
    selection: EditorSelection.create(ranges.map((r2) => EditorSelection.range(r2.from, r2.to))),
    userEvent: "select.search.matches"
  });
  return true;
});
const selectSelectionMatches = ({ state, dispatch }) => {
  let sel = state.selection;
  if (sel.ranges.length > 1 || sel.main.empty)
    return false;
  let { from, to: to2 } = sel.main;
  let ranges = [], main2 = 0;
  for (let cur2 = new SearchCursor(state.doc, state.sliceDoc(from, to2)); !cur2.next().done; ) {
    if (ranges.length > 1e3)
      return false;
    if (cur2.value.from == from)
      main2 = ranges.length;
    ranges.push(EditorSelection.range(cur2.value.from, cur2.value.to));
  }
  dispatch(state.update({
    selection: EditorSelection.create(ranges, main2),
    userEvent: "select.search.matches"
  }));
  return true;
};
const replaceNext = /* @__PURE__ */ searchCommand((view, { query }) => {
  let { state } = view, { from, to: to2 } = state.selection.main;
  if (state.readOnly)
    return false;
  let match2 = query.nextMatch(state, from, from);
  if (!match2)
    return false;
  let next = match2;
  let changes = [], selection2, replacement;
  let effects = [];
  if (next.from == from && next.to == to2) {
    replacement = state.toText(query.getReplacement(next));
    changes.push({ from: next.from, to: next.to, insert: replacement });
    next = query.nextMatch(state, next.from, next.to);
    effects.push(EditorView.announce.of(state.phrase("replaced match on line $", state.doc.lineAt(from).number) + "."));
  }
  let changeSet = view.state.changes(changes);
  if (next) {
    selection2 = EditorSelection.single(next.from, next.to).map(changeSet);
    effects.push(announceMatch(view, next));
    effects.push(state.facet(searchConfigFacet).scrollToMatch(selection2.main, view));
  }
  view.dispatch({
    changes: changeSet,
    selection: selection2,
    effects,
    userEvent: "input.replace"
  });
  return true;
});
const replaceAll$1 = /* @__PURE__ */ searchCommand((view, { query }) => {
  if (view.state.readOnly)
    return false;
  let changes = query.matchAll(view.state, 1e9).map((match2) => {
    let { from, to: to2 } = match2;
    return { from, to: to2, insert: query.getReplacement(match2) };
  });
  if (!changes.length)
    return false;
  let announceText = view.state.phrase("replaced $ matches", changes.length) + ".";
  view.dispatch({
    changes,
    effects: EditorView.announce.of(announceText),
    userEvent: "input.replace.all"
  });
  return true;
});
function createSearchPanel(view) {
  return view.state.facet(searchConfigFacet).createPanel(view);
}
function defaultQuery(state, fallback) {
  var _a2, _b, _c, _d, _e2;
  let sel = state.selection.main;
  let selText = sel.empty || sel.to > sel.from + 100 ? "" : state.sliceDoc(sel.from, sel.to);
  if (fallback && !selText)
    return fallback;
  let config2 = state.facet(searchConfigFacet);
  return new SearchQuery({
    search: ((_a2 = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _a2 !== void 0 ? _a2 : config2.literal) ? selText : selText.replace(/\n/g, "\\n"),
    caseSensitive: (_b = fallback === null || fallback === void 0 ? void 0 : fallback.caseSensitive) !== null && _b !== void 0 ? _b : config2.caseSensitive,
    literal: (_c = fallback === null || fallback === void 0 ? void 0 : fallback.literal) !== null && _c !== void 0 ? _c : config2.literal,
    regexp: (_d = fallback === null || fallback === void 0 ? void 0 : fallback.regexp) !== null && _d !== void 0 ? _d : config2.regexp,
    wholeWord: (_e2 = fallback === null || fallback === void 0 ? void 0 : fallback.wholeWord) !== null && _e2 !== void 0 ? _e2 : config2.wholeWord
  });
}
function getSearchInput(view) {
  let panel = getPanel(view, createSearchPanel);
  return panel && panel.dom.querySelector("[main-field]");
}
function selectSearchInput(view) {
  let input = getSearchInput(view);
  if (input && input == view.root.activeElement)
    input.select();
}
const openSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (state && state.panel) {
    let searchInput = getSearchInput(view);
    if (searchInput && searchInput != view.root.activeElement) {
      let query = defaultQuery(view.state, state.query.spec);
      if (query.valid)
        view.dispatch({ effects: setSearchQuery.of(query) });
      searchInput.focus();
      searchInput.select();
    }
  } else {
    view.dispatch({ effects: [
      togglePanel$1.of(true),
      state ? setSearchQuery.of(defaultQuery(view.state, state.query.spec)) : StateEffect.appendConfig.of(searchExtensions)
    ] });
  }
  return true;
};
const closeSearchPanel = (view) => {
  let state = view.state.field(searchState, false);
  if (!state || !state.panel)
    return false;
  let panel = getPanel(view, createSearchPanel);
  if (panel && panel.dom.contains(view.root.activeElement))
    view.focus();
  view.dispatch({ effects: togglePanel$1.of(false) });
  return true;
};
const searchKeymap = [
  { key: "Mod-f", run: openSearchPanel, scope: "editor search-panel" },
  { key: "F3", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Mod-g", run: findNext, shift: findPrevious, scope: "editor search-panel", preventDefault: true },
  { key: "Escape", run: closeSearchPanel, scope: "editor search-panel" },
  { key: "Mod-Shift-l", run: selectSelectionMatches },
  { key: "Mod-Alt-g", run: gotoLine },
  { key: "Mod-d", run: selectNextOccurrence, preventDefault: true }
];
class SearchPanel {
  constructor(view) {
    this.view = view;
    let query = this.query = view.state.field(searchState).query.spec;
    this.commit = this.commit.bind(this);
    this.searchField = crelt("input", {
      value: query.search,
      placeholder: phrase(view, "Find"),
      "aria-label": phrase(view, "Find"),
      class: "cm-textfield",
      name: "search",
      form: "",
      "main-field": "true",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.replaceField = crelt("input", {
      value: query.replace,
      placeholder: phrase(view, "Replace"),
      "aria-label": phrase(view, "Replace"),
      class: "cm-textfield",
      name: "replace",
      form: "",
      onchange: this.commit,
      onkeyup: this.commit
    });
    this.caseField = crelt("input", {
      type: "checkbox",
      name: "case",
      form: "",
      checked: query.caseSensitive,
      onchange: this.commit
    });
    this.reField = crelt("input", {
      type: "checkbox",
      name: "re",
      form: "",
      checked: query.regexp,
      onchange: this.commit
    });
    this.wordField = crelt("input", {
      type: "checkbox",
      name: "word",
      form: "",
      checked: query.wholeWord,
      onchange: this.commit
    });
    function button(name2, onclick, content2) {
      return crelt("button", { class: "cm-button", name: name2, onclick, type: "button" }, content2);
    }
    this.dom = crelt("div", { onkeydown: (e2) => this.keydown(e2), class: "cm-search" }, [
      this.searchField,
      button("next", () => findNext(view), [phrase(view, "next")]),
      button("prev", () => findPrevious(view), [phrase(view, "previous")]),
      button("select", () => selectMatches(view), [phrase(view, "all")]),
      crelt("label", null, [this.caseField, phrase(view, "match case")]),
      crelt("label", null, [this.reField, phrase(view, "regexp")]),
      crelt("label", null, [this.wordField, phrase(view, "by word")]),
      ...view.state.readOnly ? [] : [
        crelt("br"),
        this.replaceField,
        button("replace", () => replaceNext(view), [phrase(view, "replace")]),
        button("replaceAll", () => replaceAll$1(view), [phrase(view, "replace all")])
      ],
      crelt("button", {
        name: "close",
        onclick: () => closeSearchPanel(view),
        "aria-label": phrase(view, "close"),
        type: "button"
      }, ["×"])
    ]);
  }
  commit() {
    let query = new SearchQuery({
      search: this.searchField.value,
      caseSensitive: this.caseField.checked,
      regexp: this.reField.checked,
      wholeWord: this.wordField.checked,
      replace: this.replaceField.value
    });
    if (!query.eq(this.query)) {
      this.query = query;
      this.view.dispatch({ effects: setSearchQuery.of(query) });
    }
  }
  keydown(e2) {
    if (runScopeHandlers(this.view, e2, "search-panel")) {
      e2.preventDefault();
    } else if (e2.keyCode == 13 && e2.target == this.searchField) {
      e2.preventDefault();
      (e2.shiftKey ? findPrevious : findNext)(this.view);
    } else if (e2.keyCode == 13 && e2.target == this.replaceField) {
      e2.preventDefault();
      replaceNext(this.view);
    }
  }
  update(update) {
    for (let tr2 of update.transactions)
      for (let effect of tr2.effects) {
        if (effect.is(setSearchQuery) && !effect.value.eq(this.query))
          this.setQuery(effect.value);
      }
  }
  setQuery(query) {
    this.query = query;
    this.searchField.value = query.search;
    this.replaceField.value = query.replace;
    this.caseField.checked = query.caseSensitive;
    this.reField.checked = query.regexp;
    this.wordField.checked = query.wholeWord;
  }
  mount() {
    this.searchField.select();
  }
  get pos() {
    return 80;
  }
  get top() {
    return this.view.state.facet(searchConfigFacet).top;
  }
}
function phrase(view, phrase2) {
  return view.state.phrase(phrase2);
}
const AnnounceMargin = 30;
const Break = /[\s\.,:;?!]/;
function announceMatch(view, { from, to: to2 }) {
  let line2 = view.state.doc.lineAt(from), lineEnd = view.state.doc.lineAt(to2).to;
  let start = Math.max(line2.from, from - AnnounceMargin), end = Math.min(lineEnd, to2 + AnnounceMargin);
  let text2 = view.state.sliceDoc(start, end);
  if (start != line2.from) {
    for (let i2 = 0; i2 < AnnounceMargin; i2++)
      if (!Break.test(text2[i2 + 1]) && Break.test(text2[i2])) {
        text2 = text2.slice(i2);
        break;
      }
  }
  if (end != lineEnd) {
    for (let i2 = text2.length - 1; i2 > text2.length - AnnounceMargin; i2--)
      if (!Break.test(text2[i2 - 1]) && Break.test(text2[i2])) {
        text2 = text2.slice(0, i2);
        break;
      }
  }
  return EditorView.announce.of(`${view.state.phrase("current match")}. ${text2} ${view.state.phrase("on line")} ${line2.number}.`);
}
const baseTheme$2 = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-panel.cm-search": {
    padding: "2px 6px 4px",
    position: "relative",
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "4px",
      backgroundColor: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    },
    "& input, & button, & label": {
      margin: ".2em .6em .2em 0"
    },
    "& input[type=checkbox]": {
      marginRight: ".2em"
    },
    "& label": {
      fontSize: "80%",
      whiteSpace: "pre"
    }
  },
  "&light .cm-searchMatch": { backgroundColor: "#ffff0054" },
  "&dark .cm-searchMatch": { backgroundColor: "#00ffff8a" },
  "&light .cm-searchMatch-selected": { backgroundColor: "#ff6a0054" },
  "&dark .cm-searchMatch-selected": { backgroundColor: "#ff00ff8a" }
});
const searchExtensions = [
  searchState,
  /* @__PURE__ */ Prec.low(searchHighlighter),
  baseTheme$2
];
class SelectedDiagnostic {
  constructor(from, to2, diagnostic2) {
    this.from = from;
    this.to = to2;
    this.diagnostic = diagnostic2;
  }
}
class LintState {
  constructor(diagnostics, panel, selected) {
    this.diagnostics = diagnostics;
    this.panel = panel;
    this.selected = selected;
  }
  static init(diagnostics, panel, state) {
    let diagnosticFilter = state.facet(lintConfig).markerFilter;
    if (diagnosticFilter)
      diagnostics = diagnosticFilter(diagnostics, state);
    let sorted = diagnostics.slice().sort((a2, b2) => a2.from - b2.from || a2.to - b2.to);
    let deco = new RangeSetBuilder(), active = [], pos = 0;
    let scan = state.doc.iter(), scanPos = 0, docLen = state.doc.length;
    for (let i2 = 0; ; ) {
      let next = i2 == sorted.length ? null : sorted[i2];
      if (!next && !active.length)
        break;
      let from, to2;
      if (active.length) {
        from = pos;
        to2 = active.reduce((p2, d2) => Math.min(p2, d2.to), next && next.from > from ? next.from : 1e8);
      } else {
        from = next.from;
        if (from > docLen)
          break;
        to2 = next.to;
        active.push(next);
        i2++;
      }
      while (i2 < sorted.length) {
        let next2 = sorted[i2];
        if (next2.from == from && (next2.to > next2.from || next2.to == from)) {
          active.push(next2);
          i2++;
          to2 = Math.min(next2.to, to2);
        } else {
          to2 = Math.min(next2.from, to2);
          break;
        }
      }
      to2 = Math.min(to2, docLen);
      let widget = false;
      if (active.some((d2) => d2.from == from && (d2.to == to2 || to2 == docLen))) {
        widget = from == to2;
        if (!widget && to2 - from < 10) {
          let behind = from - (scanPos + scan.value.length);
          if (behind > 0) {
            scan.next(behind);
            scanPos = from;
          }
          for (let check = from; ; ) {
            if (check >= to2) {
              widget = true;
              break;
            }
            if (!scan.lineBreak && scanPos + scan.value.length > check)
              break;
            check = scanPos + scan.value.length;
            scanPos += scan.value.length;
            scan.next();
          }
        }
      }
      let sev = maxSeverity(active);
      if (widget) {
        deco.add(from, from, Decoration.widget({
          widget: new DiagnosticWidget(sev),
          diagnostics: active.slice()
        }));
      } else {
        let markClass = active.reduce((c2, d2) => d2.markClass ? c2 + " " + d2.markClass : c2, "");
        deco.add(from, to2, Decoration.mark({
          class: "cm-lintRange cm-lintRange-" + sev + markClass,
          diagnostics: active.slice(),
          inclusiveEnd: active.some((a2) => a2.to > to2)
        }));
      }
      pos = to2;
      if (pos == docLen)
        break;
      for (let i3 = 0; i3 < active.length; i3++)
        if (active[i3].to <= pos)
          active.splice(i3--, 1);
    }
    let set2 = deco.finish();
    return new LintState(set2, panel, findDiagnostic(set2));
  }
}
function findDiagnostic(diagnostics, diagnostic2 = null, after2 = 0) {
  let found = null;
  diagnostics.between(after2, 1e9, (from, to2, { spec }) => {
    if (diagnostic2 && spec.diagnostics.indexOf(diagnostic2) < 0)
      return;
    if (!found)
      found = new SelectedDiagnostic(from, to2, diagnostic2 || spec.diagnostics[0]);
    else if (spec.diagnostics.indexOf(found.diagnostic) < 0)
      return false;
    else
      found = new SelectedDiagnostic(found.from, to2, found.diagnostic);
  });
  return found;
}
function hideTooltip(tr2, tooltip) {
  let from = tooltip.pos, to2 = tooltip.end || from;
  let result2 = tr2.state.facet(lintConfig).hideOn(tr2, from, to2);
  if (result2 != null)
    return result2;
  let line2 = tr2.startState.doc.lineAt(tooltip.pos);
  return !!(tr2.effects.some((e2) => e2.is(setDiagnosticsEffect)) || tr2.changes.touchesRange(line2.from, Math.max(line2.to, to2)));
}
function maybeEnableLint(state, effects) {
  return state.field(lintState, false) ? effects : effects.concat(StateEffect.appendConfig.of(lintExtensions));
}
function setDiagnostics(state, diagnostics) {
  return {
    effects: maybeEnableLint(state, [setDiagnosticsEffect.of(diagnostics)])
  };
}
const setDiagnosticsEffect = /* @__PURE__ */ StateEffect.define();
const togglePanel = /* @__PURE__ */ StateEffect.define();
const movePanelSelection = /* @__PURE__ */ StateEffect.define();
const lintState = /* @__PURE__ */ StateField.define({
  create() {
    return new LintState(Decoration.none, null, null);
  },
  update(value, tr2) {
    if (tr2.docChanged && value.diagnostics.size) {
      let mapped = value.diagnostics.map(tr2.changes), selected = null, panel = value.panel;
      if (value.selected) {
        let selPos = tr2.changes.mapPos(value.selected.from, 1);
        selected = findDiagnostic(mapped, value.selected.diagnostic, selPos) || findDiagnostic(mapped, null, selPos);
      }
      if (!mapped.size && panel && tr2.state.facet(lintConfig).autoPanel)
        panel = null;
      value = new LintState(mapped, panel, selected);
    }
    for (let effect of tr2.effects) {
      if (effect.is(setDiagnosticsEffect)) {
        let panel = !tr2.state.facet(lintConfig).autoPanel ? value.panel : effect.value.length ? LintPanel.open : null;
        value = LintState.init(effect.value, panel, tr2.state);
      } else if (effect.is(togglePanel)) {
        value = new LintState(value.diagnostics, effect.value ? LintPanel.open : null, value.selected);
      } else if (effect.is(movePanelSelection)) {
        value = new LintState(value.diagnostics, value.panel, effect.value);
      }
    }
    return value;
  },
  provide: (f2) => [
    showPanel.from(f2, (val) => val.panel),
    EditorView.decorations.from(f2, (s2) => s2.diagnostics)
  ]
});
const activeMark = /* @__PURE__ */ Decoration.mark({ class: "cm-lintRange cm-lintRange-active" });
function lintTooltip(view, pos, side) {
  let { diagnostics } = view.state.field(lintState);
  let found, start = -1, end = -1;
  diagnostics.between(pos - (side < 0 ? 1 : 0), pos + (side > 0 ? 1 : 0), (from, to2, { spec }) => {
    if (pos >= from && pos <= to2 && (from == to2 || (pos > from || side > 0) && (pos < to2 || side < 0))) {
      found = spec.diagnostics;
      start = from;
      end = to2;
      return false;
    }
  });
  let diagnosticFilter = view.state.facet(lintConfig).tooltipFilter;
  if (found && diagnosticFilter)
    found = diagnosticFilter(found, view.state);
  if (!found)
    return null;
  return {
    pos: start,
    end,
    above: view.state.doc.lineAt(start).to < end,
    create() {
      return { dom: diagnosticsTooltip(view, found) };
    }
  };
}
function diagnosticsTooltip(view, diagnostics) {
  return crelt("ul", { class: "cm-tooltip-lint" }, diagnostics.map((d2) => renderDiagnostic(view, d2, false)));
}
const openLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    view.dispatch({ effects: maybeEnableLint(view.state, [togglePanel.of(true)]) });
  let panel = getPanel(view, LintPanel.open);
  if (panel)
    panel.dom.querySelector(".cm-panel-lint ul").focus();
  return true;
};
const closeLintPanel = (view) => {
  let field = view.state.field(lintState, false);
  if (!field || !field.panel)
    return false;
  view.dispatch({ effects: togglePanel.of(false) });
  return true;
};
const nextDiagnostic = (view) => {
  let field = view.state.field(lintState, false);
  if (!field)
    return false;
  let sel = view.state.selection.main, next = field.diagnostics.iter(sel.to + 1);
  if (!next.value) {
    next = field.diagnostics.iter(0);
    if (!next.value || next.from == sel.from && next.to == sel.to)
      return false;
  }
  view.dispatch({ selection: { anchor: next.from, head: next.to }, scrollIntoView: true });
  return true;
};
const lintKeymap = [
  { key: "Mod-Shift-m", run: openLintPanel, preventDefault: true },
  { key: "F8", run: nextDiagnostic }
];
const lintConfig = /* @__PURE__ */ Facet.define({
  combine(input) {
    return {
      sources: input.map((i2) => i2.source).filter((x2) => x2 != null),
      ...combineConfig(input.map((i2) => i2.config), {
        delay: 750,
        markerFilter: null,
        tooltipFilter: null,
        needsRefresh: null,
        hideOn: () => null
      }, {
        delay: Math.max,
        markerFilter: combineFilter,
        tooltipFilter: combineFilter,
        needsRefresh: (a2, b2) => !a2 ? b2 : !b2 ? a2 : (u2) => a2(u2) || b2(u2),
        hideOn: (a2, b2) => !a2 ? b2 : !b2 ? a2 : (t4, x2, y2) => a2(t4, x2, y2) || b2(t4, x2, y2),
        autoPanel: (a2, b2) => a2 || b2
      })
    };
  }
});
function combineFilter(a2, b2) {
  return !a2 ? b2 : !b2 ? a2 : (d2, s2) => b2(a2(d2, s2), s2);
}
function assignKeys(actions) {
  let assigned = [];
  if (actions)
    actions: for (let { name: name2 } of actions) {
      for (let i2 = 0; i2 < name2.length; i2++) {
        let ch = name2[i2];
        if (/[a-zA-Z]/.test(ch) && !assigned.some((c2) => c2.toLowerCase() == ch.toLowerCase())) {
          assigned.push(ch);
          continue actions;
        }
      }
      assigned.push("");
    }
  return assigned;
}
function renderDiagnostic(view, diagnostic2, inPanel) {
  var _a2;
  let keys2 = inPanel ? assignKeys(diagnostic2.actions) : [];
  return crelt("li", { class: "cm-diagnostic cm-diagnostic-" + diagnostic2.severity }, crelt("span", { class: "cm-diagnosticText" }, diagnostic2.renderMessage ? diagnostic2.renderMessage(view) : diagnostic2.message), (_a2 = diagnostic2.actions) === null || _a2 === void 0 ? void 0 : _a2.map((action, i2) => {
    let fired = false, click = (e2) => {
      e2.preventDefault();
      if (fired)
        return;
      fired = true;
      let found = findDiagnostic(view.state.field(lintState).diagnostics, diagnostic2);
      if (found)
        action.apply(view, found.from, found.to);
    };
    let { name: name2 } = action, keyIndex = keys2[i2] ? name2.indexOf(keys2[i2]) : -1;
    let nameElt = keyIndex < 0 ? name2 : [
      name2.slice(0, keyIndex),
      crelt("u", name2.slice(keyIndex, keyIndex + 1)),
      name2.slice(keyIndex + 1)
    ];
    let markClass = action.markClass ? " " + action.markClass : "";
    return crelt("button", {
      type: "button",
      class: "cm-diagnosticAction" + markClass,
      onclick: click,
      onmousedown: click,
      "aria-label": ` Action: ${name2}${keyIndex < 0 ? "" : ` (access key "${keys2[i2]})"`}.`
    }, nameElt);
  }), diagnostic2.source && crelt("div", { class: "cm-diagnosticSource" }, diagnostic2.source));
}
class DiagnosticWidget extends WidgetType {
  constructor(sev) {
    super();
    this.sev = sev;
  }
  eq(other) {
    return other.sev == this.sev;
  }
  toDOM() {
    return crelt("span", { class: "cm-lintPoint cm-lintPoint-" + this.sev });
  }
}
class PanelItem {
  constructor(view, diagnostic2) {
    this.diagnostic = diagnostic2;
    this.id = "item_" + Math.floor(Math.random() * 4294967295).toString(16);
    this.dom = renderDiagnostic(view, diagnostic2, true);
    this.dom.id = this.id;
    this.dom.setAttribute("role", "option");
  }
}
class LintPanel {
  constructor(view) {
    this.view = view;
    this.items = [];
    let onkeydown = (event) => {
      if (event.keyCode == 27) {
        closeLintPanel(this.view);
        this.view.focus();
      } else if (event.keyCode == 38 || event.keyCode == 33) {
        this.moveSelection((this.selectedIndex - 1 + this.items.length) % this.items.length);
      } else if (event.keyCode == 40 || event.keyCode == 34) {
        this.moveSelection((this.selectedIndex + 1) % this.items.length);
      } else if (event.keyCode == 36) {
        this.moveSelection(0);
      } else if (event.keyCode == 35) {
        this.moveSelection(this.items.length - 1);
      } else if (event.keyCode == 13) {
        this.view.focus();
      } else if (event.keyCode >= 65 && event.keyCode <= 90 && this.selectedIndex >= 0) {
        let { diagnostic: diagnostic2 } = this.items[this.selectedIndex], keys2 = assignKeys(diagnostic2.actions);
        for (let i2 = 0; i2 < keys2.length; i2++)
          if (keys2[i2].toUpperCase().charCodeAt(0) == event.keyCode) {
            let found = findDiagnostic(this.view.state.field(lintState).diagnostics, diagnostic2);
            if (found)
              diagnostic2.actions[i2].apply(view, found.from, found.to);
          }
      } else {
        return;
      }
      event.preventDefault();
    };
    let onclick = (event) => {
      for (let i2 = 0; i2 < this.items.length; i2++) {
        if (this.items[i2].dom.contains(event.target))
          this.moveSelection(i2);
      }
    };
    this.list = crelt("ul", {
      tabIndex: 0,
      role: "listbox",
      "aria-label": this.view.state.phrase("Diagnostics"),
      onkeydown,
      onclick
    });
    this.dom = crelt("div", { class: "cm-panel-lint" }, this.list, crelt("button", {
      type: "button",
      name: "close",
      "aria-label": this.view.state.phrase("close"),
      onclick: () => closeLintPanel(this.view)
    }, "×"));
    this.update();
  }
  get selectedIndex() {
    let selected = this.view.state.field(lintState).selected;
    if (!selected)
      return -1;
    for (let i2 = 0; i2 < this.items.length; i2++)
      if (this.items[i2].diagnostic == selected.diagnostic)
        return i2;
    return -1;
  }
  update() {
    let { diagnostics, selected } = this.view.state.field(lintState);
    let i2 = 0, needsSync = false, newSelectedItem = null;
    let seen = /* @__PURE__ */ new Set();
    diagnostics.between(0, this.view.state.doc.length, (_start, _end, { spec }) => {
      for (let diagnostic2 of spec.diagnostics) {
        if (seen.has(diagnostic2))
          continue;
        seen.add(diagnostic2);
        let found = -1, item;
        for (let j2 = i2; j2 < this.items.length; j2++)
          if (this.items[j2].diagnostic == diagnostic2) {
            found = j2;
            break;
          }
        if (found < 0) {
          item = new PanelItem(this.view, diagnostic2);
          this.items.splice(i2, 0, item);
          needsSync = true;
        } else {
          item = this.items[found];
          if (found > i2) {
            this.items.splice(i2, found - i2);
            needsSync = true;
          }
        }
        if (selected && item.diagnostic == selected.diagnostic) {
          if (!item.dom.hasAttribute("aria-selected")) {
            item.dom.setAttribute("aria-selected", "true");
            newSelectedItem = item;
          }
        } else if (item.dom.hasAttribute("aria-selected")) {
          item.dom.removeAttribute("aria-selected");
        }
        i2++;
      }
    });
    while (i2 < this.items.length && !(this.items.length == 1 && this.items[0].diagnostic.from < 0)) {
      needsSync = true;
      this.items.pop();
    }
    if (this.items.length == 0) {
      this.items.push(new PanelItem(this.view, {
        from: -1,
        to: -1,
        severity: "info",
        message: this.view.state.phrase("No diagnostics")
      }));
      needsSync = true;
    }
    if (newSelectedItem) {
      this.list.setAttribute("aria-activedescendant", newSelectedItem.id);
      this.view.requestMeasure({
        key: this,
        read: () => ({ sel: newSelectedItem.dom.getBoundingClientRect(), panel: this.list.getBoundingClientRect() }),
        write: ({ sel, panel }) => {
          let scaleY = panel.height / this.list.offsetHeight;
          if (sel.top < panel.top)
            this.list.scrollTop -= (panel.top - sel.top) / scaleY;
          else if (sel.bottom > panel.bottom)
            this.list.scrollTop += (sel.bottom - panel.bottom) / scaleY;
        }
      });
    } else if (this.selectedIndex < 0) {
      this.list.removeAttribute("aria-activedescendant");
    }
    if (needsSync)
      this.sync();
  }
  sync() {
    let domPos = this.list.firstChild;
    function rm2() {
      let prev = domPos;
      domPos = prev.nextSibling;
      prev.remove();
    }
    for (let item of this.items) {
      if (item.dom.parentNode == this.list) {
        while (domPos != item.dom)
          rm2();
        domPos = item.dom.nextSibling;
      } else {
        this.list.insertBefore(item.dom, domPos);
      }
    }
    while (domPos)
      rm2();
  }
  moveSelection(selectedIndex) {
    if (this.selectedIndex < 0)
      return;
    let field = this.view.state.field(lintState);
    let selection2 = findDiagnostic(field.diagnostics, this.items[selectedIndex].diagnostic);
    if (!selection2)
      return;
    this.view.dispatch({
      selection: { anchor: selection2.from, head: selection2.to },
      scrollIntoView: true,
      effects: movePanelSelection.of(selection2)
    });
  }
  static open(view) {
    return new LintPanel(view);
  }
}
function svg(content2, attrs = `viewBox="0 0 40 40"`) {
  return `url('data:image/svg+xml,<svg xmlns="http://www.w3.org/2000/svg" ${attrs}>${encodeURIComponent(content2)}</svg>')`;
}
function underline(color) {
  return svg(`<path d="m0 2.5 l2 -1.5 l1 0 l2 1.5 l1 0" stroke="${color}" fill="none" stroke-width=".7"/>`, `width="6" height="3"`);
}
const baseTheme = /* @__PURE__ */ EditorView.baseTheme({
  ".cm-diagnostic": {
    padding: "3px 6px 3px 8px",
    marginLeft: "-1px",
    display: "block",
    whiteSpace: "pre-wrap"
  },
  ".cm-diagnostic-error": { borderLeft: "5px solid #d11" },
  ".cm-diagnostic-warning": { borderLeft: "5px solid orange" },
  ".cm-diagnostic-info": { borderLeft: "5px solid #999" },
  ".cm-diagnostic-hint": { borderLeft: "5px solid #66d" },
  ".cm-diagnosticAction": {
    font: "inherit",
    border: "none",
    padding: "2px 4px",
    backgroundColor: "#444",
    color: "white",
    borderRadius: "3px",
    marginLeft: "8px",
    cursor: "pointer"
  },
  ".cm-diagnosticSource": {
    fontSize: "70%",
    opacity: 0.7
  },
  ".cm-lintRange": {
    backgroundPosition: "left bottom",
    backgroundRepeat: "repeat-x",
    paddingBottom: "0.7px"
  },
  ".cm-lintRange-error": { backgroundImage: /* @__PURE__ */ underline("#d11") },
  ".cm-lintRange-warning": { backgroundImage: /* @__PURE__ */ underline("orange") },
  ".cm-lintRange-info": { backgroundImage: /* @__PURE__ */ underline("#999") },
  ".cm-lintRange-hint": { backgroundImage: /* @__PURE__ */ underline("#66d") },
  ".cm-lintRange-active": { backgroundColor: "#ffdd9980" },
  ".cm-tooltip-lint": {
    padding: 0,
    margin: 0
  },
  ".cm-lintPoint": {
    position: "relative",
    "&:after": {
      content: '""',
      position: "absolute",
      bottom: 0,
      left: "-2px",
      borderLeft: "3px solid transparent",
      borderRight: "3px solid transparent",
      borderBottom: "4px solid #d11"
    }
  },
  ".cm-lintPoint-warning": {
    "&:after": { borderBottomColor: "orange" }
  },
  ".cm-lintPoint-info": {
    "&:after": { borderBottomColor: "#999" }
  },
  ".cm-lintPoint-hint": {
    "&:after": { borderBottomColor: "#66d" }
  },
  ".cm-panel.cm-panel-lint": {
    position: "relative",
    "& ul": {
      maxHeight: "100px",
      overflowY: "auto",
      "& [aria-selected]": {
        backgroundColor: "#ddd",
        "& u": { textDecoration: "underline" }
      },
      "&:focus [aria-selected]": {
        background_fallback: "#bdf",
        backgroundColor: "Highlight",
        color_fallback: "white",
        color: "HighlightText"
      },
      "& u": { textDecoration: "none" },
      padding: 0,
      margin: 0
    },
    "& [name=close]": {
      position: "absolute",
      top: "0",
      right: "2px",
      background: "inherit",
      border: "none",
      font: "inherit",
      padding: 0,
      margin: 0
    }
  }
});
function severityWeight(sev) {
  return sev == "error" ? 4 : sev == "warning" ? 3 : sev == "info" ? 2 : 1;
}
function maxSeverity(diagnostics) {
  let sev = "hint", weight = 1;
  for (let d2 of diagnostics) {
    let w2 = severityWeight(d2.severity);
    if (w2 > weight) {
      weight = w2;
      sev = d2.severity;
    }
  }
  return sev;
}
const lintExtensions = [
  lintState,
  /* @__PURE__ */ EditorView.decorations.compute([lintState], (state) => {
    let { selected, panel } = state.field(lintState);
    return !selected || !panel || selected.from == selected.to ? Decoration.none : Decoration.set([
      activeMark.range(selected.from, selected.to)
    ]);
  }),
  /* @__PURE__ */ hoverTooltip(lintTooltip, { hideOn: hideTooltip }),
  baseTheme
];
var basicSetup = function basicSetup2(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  var _options = options2, _options$crosshairCur = _options.crosshairCursor, initCrosshairCursor = _options$crosshairCur === void 0 ? false : _options$crosshairCur;
  var keymaps = [];
  if (options2.closeBracketsKeymap !== false) {
    keymaps = keymaps.concat(closeBracketsKeymap);
  }
  if (options2.defaultKeymap !== false) {
    keymaps = keymaps.concat(defaultKeymap);
  }
  if (options2.searchKeymap !== false) {
    keymaps = keymaps.concat(searchKeymap);
  }
  if (options2.historyKeymap !== false) {
    keymaps = keymaps.concat(historyKeymap);
  }
  if (options2.foldKeymap !== false) {
    keymaps = keymaps.concat(foldKeymap);
  }
  if (options2.completionKeymap !== false) {
    keymaps = keymaps.concat(completionKeymap);
  }
  if (options2.lintKeymap !== false) {
    keymaps = keymaps.concat(lintKeymap);
  }
  var extensions = [];
  if (options2.lineNumbers !== false) extensions.push(lineNumbers());
  if (options2.highlightActiveLineGutter !== false) extensions.push(highlightActiveLineGutter());
  if (options2.highlightSpecialChars !== false) extensions.push(highlightSpecialChars());
  if (options2.history !== false) extensions.push(history());
  if (options2.foldGutter !== false) extensions.push(foldGutter());
  if (options2.drawSelection !== false) extensions.push(drawSelection());
  if (options2.dropCursor !== false) extensions.push(dropCursor());
  if (options2.allowMultipleSelections !== false) extensions.push(EditorState.allowMultipleSelections.of(true));
  if (options2.indentOnInput !== false) extensions.push(indentOnInput());
  if (options2.syntaxHighlighting !== false) extensions.push(syntaxHighlighting(defaultHighlightStyle, {
    fallback: true
  }));
  if (options2.bracketMatching !== false) extensions.push(bracketMatching());
  if (options2.closeBrackets !== false) extensions.push(closeBrackets());
  if (options2.autocompletion !== false) extensions.push(autocompletion());
  if (options2.rectangularSelection !== false) extensions.push(rectangularSelection());
  if (initCrosshairCursor !== false) extensions.push(crosshairCursor());
  if (options2.highlightActiveLine !== false) extensions.push(highlightActiveLine());
  if (options2.highlightSelectionMatches !== false) extensions.push(highlightSelectionMatches());
  if (options2.tabSize && typeof options2.tabSize === "number") extensions.push(indentUnit.of(" ".repeat(options2.tabSize)));
  return extensions.concat([keymap.of(keymaps.flat())]).filter(Boolean);
};
const chalky = "#e5c07b", coral = "#e06c75", cyan = "#56b6c2", invalid = "#ffffff", ivory = "#abb2bf", stone = "#7d8799", malibu = "#61afef", sage = "#98c379", whiskey = "#d19a66", violet = "#c678dd", darkBackground = "#21252b", highlightBackground = "#2c313a", background = "#282c34", tooltipBackground = "#353a42", selection = "#3E4451", cursor$1 = "#528bff";
const oneDarkTheme = /* @__PURE__ */ EditorView.theme({
  "&": {
    color: ivory,
    backgroundColor: background
  },
  ".cm-content": {
    caretColor: cursor$1
  },
  ".cm-cursor, .cm-dropCursor": { borderLeftColor: cursor$1 },
  "&.cm-focused > .cm-scroller > .cm-selectionLayer .cm-selectionBackground, .cm-selectionBackground, .cm-content ::selection": { backgroundColor: selection },
  ".cm-panels": { backgroundColor: darkBackground, color: ivory },
  ".cm-panels.cm-panels-top": { borderBottom: "2px solid black" },
  ".cm-panels.cm-panels-bottom": { borderTop: "2px solid black" },
  ".cm-searchMatch": {
    backgroundColor: "#72a1ff59",
    outline: "1px solid #457dff"
  },
  ".cm-searchMatch.cm-searchMatch-selected": {
    backgroundColor: "#6199ff2f"
  },
  ".cm-activeLine": { backgroundColor: "#6699ff0b" },
  ".cm-selectionMatch": { backgroundColor: "#aafe661a" },
  "&.cm-focused .cm-matchingBracket, &.cm-focused .cm-nonmatchingBracket": {
    backgroundColor: "#bad0f847"
  },
  ".cm-gutters": {
    backgroundColor: background,
    color: stone,
    border: "none"
  },
  ".cm-activeLineGutter": {
    backgroundColor: highlightBackground
  },
  ".cm-foldPlaceholder": {
    backgroundColor: "transparent",
    border: "none",
    color: "#ddd"
  },
  ".cm-tooltip": {
    border: "none",
    backgroundColor: tooltipBackground
  },
  ".cm-tooltip .cm-tooltip-arrow:before": {
    borderTopColor: "transparent",
    borderBottomColor: "transparent"
  },
  ".cm-tooltip .cm-tooltip-arrow:after": {
    borderTopColor: tooltipBackground,
    borderBottomColor: tooltipBackground
  },
  ".cm-tooltip-autocomplete": {
    "& > ul > li[aria-selected]": {
      backgroundColor: highlightBackground,
      color: ivory
    }
  }
}, { dark: true });
const oneDarkHighlightStyle = /* @__PURE__ */ HighlightStyle.define([
  {
    tag: tags.keyword,
    color: violet
  },
  {
    tag: [tags.name, tags.deleted, tags.character, tags.propertyName, tags.macroName],
    color: coral
  },
  {
    tag: [/* @__PURE__ */ tags.function(tags.variableName), tags.labelName],
    color: malibu
  },
  {
    tag: [tags.color, /* @__PURE__ */ tags.constant(tags.name), /* @__PURE__ */ tags.standard(tags.name)],
    color: whiskey
  },
  {
    tag: [/* @__PURE__ */ tags.definition(tags.name), tags.separator],
    color: ivory
  },
  {
    tag: [tags.typeName, tags.className, tags.number, tags.changed, tags.annotation, tags.modifier, tags.self, tags.namespace],
    color: chalky
  },
  {
    tag: [tags.operator, tags.operatorKeyword, tags.url, tags.escape, tags.regexp, tags.link, /* @__PURE__ */ tags.special(tags.string)],
    color: cyan
  },
  {
    tag: [tags.meta, tags.comment],
    color: stone
  },
  {
    tag: tags.strong,
    fontWeight: "bold"
  },
  {
    tag: tags.emphasis,
    fontStyle: "italic"
  },
  {
    tag: tags.strikethrough,
    textDecoration: "line-through"
  },
  {
    tag: tags.link,
    color: stone,
    textDecoration: "underline"
  },
  {
    tag: tags.heading,
    fontWeight: "bold",
    color: coral
  },
  {
    tag: [tags.atom, tags.bool, /* @__PURE__ */ tags.special(tags.variableName)],
    color: whiskey
  },
  {
    tag: [tags.processingInstruction, tags.string, tags.inserted],
    color: sage
  },
  {
    tag: tags.invalid,
    color: invalid
  }
]);
const oneDark = [oneDarkTheme, /* @__PURE__ */ syntaxHighlighting(oneDarkHighlightStyle)];
var defaultLightThemeOption = EditorView.theme({
  "&": {
    backgroundColor: "#fff"
  }
}, {
  dark: false
});
var getDefaultExtensions = function getDefaultExtensions2(optios) {
  if (optios === void 0) {
    optios = {};
  }
  var _optios = optios, _optios$indentWithTab = _optios.indentWithTab, defaultIndentWithTab = _optios$indentWithTab === void 0 ? true : _optios$indentWithTab, _optios$editable = _optios.editable, editable2 = _optios$editable === void 0 ? true : _optios$editable, _optios$readOnly = _optios.readOnly, readOnly2 = _optios$readOnly === void 0 ? false : _optios$readOnly, _optios$theme = _optios.theme, theme2 = _optios$theme === void 0 ? "light" : _optios$theme, _optios$placeholder = _optios.placeholder, placeholderStr = _optios$placeholder === void 0 ? "" : _optios$placeholder, _optios$basicSetup = _optios.basicSetup, defaultBasicSetup = _optios$basicSetup === void 0 ? true : _optios$basicSetup;
  var getExtensions = [];
  if (defaultIndentWithTab) {
    getExtensions.unshift(keymap.of([indentWithTab]));
  }
  if (defaultBasicSetup) {
    if (typeof defaultBasicSetup === "boolean") {
      getExtensions.unshift(basicSetup());
    } else {
      getExtensions.unshift(basicSetup(defaultBasicSetup));
    }
  }
  if (placeholderStr) {
    getExtensions.unshift(placeholder(placeholderStr));
  }
  switch (theme2) {
    case "light":
      getExtensions.push(defaultLightThemeOption);
      break;
    case "dark":
      getExtensions.push(oneDark);
      break;
    case "none":
      break;
    default:
      getExtensions.push(theme2);
      break;
  }
  if (editable2 === false) {
    getExtensions.push(EditorView.editable.of(false));
  }
  if (readOnly2) {
    getExtensions.push(EditorState.readOnly.of(true));
  }
  return [...getExtensions];
};
var getStatistics = (view) => {
  return {
    line: view.state.doc.lineAt(view.state.selection.main.from),
    lineCount: view.state.doc.lines,
    lineBreak: view.state.lineBreak,
    length: view.state.doc.length,
    readOnly: view.state.readOnly,
    tabSize: view.state.tabSize,
    selection: view.state.selection,
    selectionAsSingle: view.state.selection.asSingle().main,
    ranges: view.state.selection.ranges,
    selectionCode: view.state.sliceDoc(view.state.selection.main.from, view.state.selection.main.to),
    selections: view.state.selection.ranges.map((r2) => view.state.sliceDoc(r2.from, r2.to)),
    selectedText: view.state.selection.ranges.some((r2) => !r2.empty)
  };
};
class TimeoutLatch {
  constructor(callback, timeoutMS) {
    this.timeLeftMS = void 0;
    this.timeoutMS = void 0;
    this.isCancelled = false;
    this.isTimeExhausted = false;
    this.callbacks = [];
    this.timeLeftMS = timeoutMS;
    this.timeoutMS = timeoutMS;
    this.callbacks.push(callback);
  }
  tick() {
    if (!this.isCancelled && !this.isTimeExhausted) {
      this.timeLeftMS--;
      if (this.timeLeftMS <= 0) {
        this.isTimeExhausted = true;
        var callbacks = this.callbacks.slice();
        this.callbacks.length = 0;
        callbacks.forEach((callback) => {
          try {
            callback();
          } catch (error) {
            console.error("TimeoutLatch callback error:", error);
          }
        });
      }
    }
  }
  cancel() {
    this.isCancelled = true;
    this.callbacks.length = 0;
  }
  reset() {
    this.timeLeftMS = this.timeoutMS;
    this.isCancelled = false;
    this.isTimeExhausted = false;
  }
  get isDone() {
    return this.isCancelled || this.isTimeExhausted;
  }
}
class Scheduler {
  constructor() {
    this.interval = null;
    this.latches = /* @__PURE__ */ new Set();
  }
  add(latch) {
    this.latches.add(latch);
    this.start();
  }
  remove(latch) {
    this.latches.delete(latch);
    if (this.latches.size === 0) {
      this.stop();
    }
  }
  start() {
    if (this.interval === null) {
      this.interval = setInterval(() => {
        this.latches.forEach((latch) => {
          latch.tick();
          if (latch.isDone) {
            this.remove(latch);
          }
        });
      }, 1);
    }
  }
  stop() {
    if (this.interval !== null) {
      clearInterval(this.interval);
      this.interval = null;
    }
  }
}
var globalScheduler = null;
var getScheduler = () => {
  if (typeof window === "undefined") {
    return new Scheduler();
  }
  if (!globalScheduler) {
    globalScheduler = new Scheduler();
  }
  return globalScheduler;
};
var ExternalChange = Annotation.define();
var TYPING_TIMOUT = 200;
var emptyExtensions = [];
function useCodeMirror(props2) {
  var value = props2.value, selection2 = props2.selection, onChange = props2.onChange, onStatistics = props2.onStatistics, onCreateEditor = props2.onCreateEditor, onUpdate = props2.onUpdate, _props$extensions = props2.extensions, extensions = _props$extensions === void 0 ? emptyExtensions : _props$extensions, autoFocus = props2.autoFocus, _props$theme = props2.theme, theme2 = _props$theme === void 0 ? "light" : _props$theme, _props$height = props2.height, height = _props$height === void 0 ? null : _props$height, _props$minHeight = props2.minHeight, minHeight = _props$minHeight === void 0 ? null : _props$minHeight, _props$maxHeight = props2.maxHeight, maxHeight = _props$maxHeight === void 0 ? null : _props$maxHeight, _props$width = props2.width, width = _props$width === void 0 ? null : _props$width, _props$minWidth = props2.minWidth, minWidth = _props$minWidth === void 0 ? null : _props$minWidth, _props$maxWidth = props2.maxWidth, maxWidth = _props$maxWidth === void 0 ? null : _props$maxWidth, _props$placeholder = props2.placeholder, placeholderStr = _props$placeholder === void 0 ? "" : _props$placeholder, _props$editable = props2.editable, editable2 = _props$editable === void 0 ? true : _props$editable, _props$readOnly = props2.readOnly, readOnly2 = _props$readOnly === void 0 ? false : _props$readOnly, _props$indentWithTab = props2.indentWithTab, defaultIndentWithTab = _props$indentWithTab === void 0 ? true : _props$indentWithTab, _props$basicSetup = props2.basicSetup, defaultBasicSetup = _props$basicSetup === void 0 ? true : _props$basicSetup, root2 = props2.root, initialState2 = props2.initialState;
  var _useState = useState(), container = _useState[0], setContainer = _useState[1];
  var _useState2 = useState(), view = _useState2[0], setView = _useState2[1];
  var _useState3 = useState(), state = _useState3[0], setState = _useState3[1];
  var typingLatch = useState(() => ({
    current: null
  }))[0];
  var pendingUpdate = useState(() => ({
    current: null
  }))[0];
  var defaultThemeOption = EditorView.theme({
    "&": {
      height,
      minHeight,
      maxHeight,
      width,
      minWidth,
      maxWidth
    },
    "& .cm-scroller": {
      height: "100% !important"
    }
  });
  var updateListener2 = EditorView.updateListener.of((vu2) => {
    if (vu2.docChanged && typeof onChange === "function" && // Fix echoing of the remote changes:
    // If transaction is market as remote we don't have to call `onChange` handler again
    !vu2.transactions.some((tr2) => tr2.annotation(ExternalChange))) {
      if (typingLatch.current) {
        typingLatch.current.reset();
      } else {
        typingLatch.current = new TimeoutLatch(() => {
          if (pendingUpdate.current) {
            var forceUpdate = pendingUpdate.current;
            pendingUpdate.current = null;
            forceUpdate();
          }
          typingLatch.current = null;
        }, TYPING_TIMOUT);
        getScheduler().add(typingLatch.current);
      }
      var doc2 = vu2.state.doc;
      var _value = doc2.toString();
      onChange(_value, vu2);
    }
    onStatistics && onStatistics(getStatistics(vu2));
  });
  var defaultExtensions = getDefaultExtensions({
    theme: theme2,
    editable: editable2,
    readOnly: readOnly2,
    placeholder: placeholderStr,
    indentWithTab: defaultIndentWithTab,
    basicSetup: defaultBasicSetup
  });
  var getExtensions = [updateListener2, defaultThemeOption, ...defaultExtensions];
  if (onUpdate && typeof onUpdate === "function") {
    getExtensions.push(EditorView.updateListener.of(onUpdate));
  }
  getExtensions = getExtensions.concat(extensions);
  useLayoutEffect(() => {
    if (container && !state) {
      var config2 = {
        doc: value,
        selection: selection2,
        extensions: getExtensions
      };
      var stateCurrent = initialState2 ? EditorState.fromJSON(initialState2.json, config2, initialState2.fields) : EditorState.create(config2);
      setState(stateCurrent);
      if (!view) {
        var viewCurrent = new EditorView({
          state: stateCurrent,
          parent: container,
          root: root2
        });
        setView(viewCurrent);
        onCreateEditor && onCreateEditor(viewCurrent, stateCurrent);
      }
    }
    return () => {
      if (view) {
        setState(void 0);
        setView(void 0);
      }
    };
  }, [container, state]);
  useEffect(() => {
    if (props2.container) {
      setContainer(props2.container);
    }
  }, [props2.container]);
  useEffect(() => () => {
    if (view) {
      view.destroy();
      setView(void 0);
    }
    if (typingLatch.current) {
      typingLatch.current.cancel();
      typingLatch.current = null;
    }
  }, [view]);
  useEffect(() => {
    if (autoFocus && view) {
      view.focus();
    }
  }, [autoFocus, view]);
  useEffect(() => {
    if (view) {
      view.dispatch({
        effects: StateEffect.reconfigure.of(getExtensions)
      });
    }
  }, [theme2, extensions, height, minHeight, maxHeight, width, minWidth, maxWidth, placeholderStr, editable2, readOnly2, defaultIndentWithTab, defaultBasicSetup, onChange, onUpdate]);
  useEffect(() => {
    if (value === void 0) {
      return;
    }
    var currentValue = view ? view.state.doc.toString() : "";
    if (view && value !== currentValue) {
      var isTyping = typingLatch.current && !typingLatch.current.isDone;
      var forceUpdate = () => {
        if (view && value !== view.state.doc.toString()) {
          view.dispatch({
            changes: {
              from: 0,
              to: view.state.doc.toString().length,
              insert: value || ""
            },
            annotations: [ExternalChange.of(true)]
          });
        }
      };
      if (!isTyping) {
        forceUpdate();
      } else {
        pendingUpdate.current = forceUpdate;
      }
    }
  }, [value, view]);
  return {
    state,
    setState,
    view,
    setView,
    container,
    setContainer
  };
}
function getAugmentedNamespace(n2) {
  if (Object.prototype.hasOwnProperty.call(n2, "__esModule")) return n2;
  var f2 = n2.default;
  if (typeof f2 == "function") {
    var a2 = function a3() {
      var isInstance = false;
      try {
        isInstance = this instanceof a3;
      } catch {
      }
      if (isInstance) {
        return Reflect.construct(f2, arguments, this.constructor);
      }
      return f2.apply(this, arguments);
    };
    a2.prototype = f2.prototype;
  } else a2 = {};
  Object.defineProperty(a2, "__esModule", { value: true });
  Object.keys(n2).forEach(function(k2) {
    var d2 = Object.getOwnPropertyDescriptor(n2, k2);
    Object.defineProperty(a2, k2, d2.get ? d2 : {
      enumerable: true,
      get: function() {
        return n2[k2];
      }
    });
  });
  return a2;
}
var jsxRuntime = { exports: {} };
var reactJsxRuntime_production = {};
var hasRequiredReactJsxRuntime_production;
function requireReactJsxRuntime_production() {
  if (hasRequiredReactJsxRuntime_production) return reactJsxRuntime_production;
  hasRequiredReactJsxRuntime_production = 1;
  var REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment");
  function jsxProd(type, config2, maybeKey) {
    var key = null;
    void 0 !== maybeKey && (key = "" + maybeKey);
    void 0 !== config2.key && (key = "" + config2.key);
    if ("key" in config2) {
      maybeKey = {};
      for (var propName in config2)
        "key" !== propName && (maybeKey[propName] = config2[propName]);
    } else maybeKey = config2;
    config2 = maybeKey.ref;
    return {
      $$typeof: REACT_ELEMENT_TYPE,
      type,
      key,
      ref: void 0 !== config2 ? config2 : null,
      props: maybeKey
    };
  }
  reactJsxRuntime_production.Fragment = REACT_FRAGMENT_TYPE;
  reactJsxRuntime_production.jsx = jsxProd;
  reactJsxRuntime_production.jsxs = jsxProd;
  return reactJsxRuntime_production;
}
var reactJsxRuntime_development = {};
var hasRequiredReactJsxRuntime_development;
function requireReactJsxRuntime_development() {
  if (hasRequiredReactJsxRuntime_development) return reactJsxRuntime_development;
  hasRequiredReactJsxRuntime_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function getComponentNameFromType(type) {
      if (null == type) return null;
      if ("function" === typeof type)
        return type.$$typeof === REACT_CLIENT_REFERENCE ? null : type.displayName || type.name || null;
      if ("string" === typeof type) return type;
      switch (type) {
        case REACT_FRAGMENT_TYPE:
          return "Fragment";
        case REACT_PROFILER_TYPE:
          return "Profiler";
        case REACT_STRICT_MODE_TYPE:
          return "StrictMode";
        case REACT_SUSPENSE_TYPE:
          return "Suspense";
        case REACT_SUSPENSE_LIST_TYPE:
          return "SuspenseList";
        case REACT_ACTIVITY_TYPE:
          return "Activity";
      }
      if ("object" === typeof type)
        switch ("number" === typeof type.tag && console.error(
          "Received an unexpected object in getComponentNameFromType(). This is likely a bug in React. Please file an issue."
        ), type.$$typeof) {
          case REACT_PORTAL_TYPE:
            return "Portal";
          case REACT_CONTEXT_TYPE:
            return type.displayName || "Context";
          case REACT_CONSUMER_TYPE:
            return (type._context.displayName || "Context") + ".Consumer";
          case REACT_FORWARD_REF_TYPE:
            var innerType = type.render;
            type = type.displayName;
            type || (type = innerType.displayName || innerType.name || "", type = "" !== type ? "ForwardRef(" + type + ")" : "ForwardRef");
            return type;
          case REACT_MEMO_TYPE:
            return innerType = type.displayName || null, null !== innerType ? innerType : getComponentNameFromType(type.type) || "Memo";
          case REACT_LAZY_TYPE:
            innerType = type._payload;
            type = type._init;
            try {
              return getComponentNameFromType(type(innerType));
            } catch (x2) {
            }
        }
      return null;
    }
    function testStringCoercion(value) {
      return "" + value;
    }
    function checkKeyStringCoercion(value) {
      try {
        testStringCoercion(value);
        var JSCompiler_inline_result = false;
      } catch (e2) {
        JSCompiler_inline_result = true;
      }
      if (JSCompiler_inline_result) {
        JSCompiler_inline_result = console;
        var JSCompiler_temp_const = JSCompiler_inline_result.error;
        var JSCompiler_inline_result$jscomp$0 = "function" === typeof Symbol && Symbol.toStringTag && value[Symbol.toStringTag] || value.constructor.name || "Object";
        JSCompiler_temp_const.call(
          JSCompiler_inline_result,
          "The provided key is an unsupported type %s. This value must be coerced to a string before using it here.",
          JSCompiler_inline_result$jscomp$0
        );
        return testStringCoercion(value);
      }
    }
    function getTaskName(type) {
      if (type === REACT_FRAGMENT_TYPE) return "<>";
      if ("object" === typeof type && null !== type && type.$$typeof === REACT_LAZY_TYPE)
        return "<...>";
      try {
        var name2 = getComponentNameFromType(type);
        return name2 ? "<" + name2 + ">" : "<...>";
      } catch (x2) {
        return "<...>";
      }
    }
    function getOwner() {
      var dispatcher = ReactSharedInternals.A;
      return null === dispatcher ? null : dispatcher.getOwner();
    }
    function UnknownOwner() {
      return Error("react-stack-top-frame");
    }
    function hasValidKey(config2) {
      if (hasOwnProperty2.call(config2, "key")) {
        var getter = Object.getOwnPropertyDescriptor(config2, "key").get;
        if (getter && getter.isReactWarning) return false;
      }
      return void 0 !== config2.key;
    }
    function defineKeyPropWarningGetter(props2, displayName) {
      function warnAboutAccessingKey() {
        specialPropKeyWarningShown || (specialPropKeyWarningShown = true, console.error(
          "%s: `key` is not a prop. Trying to access it will result in `undefined` being returned. If you need to access the same value within the child component, you should pass it as a different prop. (https://react.dev/link/special-props)",
          displayName
        ));
      }
      warnAboutAccessingKey.isReactWarning = true;
      Object.defineProperty(props2, "key", {
        get: warnAboutAccessingKey,
        configurable: true
      });
    }
    function elementRefGetterWithDeprecationWarning() {
      var componentName = getComponentNameFromType(this.type);
      didWarnAboutElementRef[componentName] || (didWarnAboutElementRef[componentName] = true, console.error(
        "Accessing element.ref was removed in React 19. ref is now a regular prop. It will be removed from the JSX Element type in a future release."
      ));
      componentName = this.props.ref;
      return void 0 !== componentName ? componentName : null;
    }
    function ReactElement(type, key, props2, owner, debugStack, debugTask) {
      var refProp = props2.ref;
      type = {
        $$typeof: REACT_ELEMENT_TYPE,
        type,
        key,
        props: props2,
        _owner: owner
      };
      null !== (void 0 !== refProp ? refProp : null) ? Object.defineProperty(type, "ref", {
        enumerable: false,
        get: elementRefGetterWithDeprecationWarning
      }) : Object.defineProperty(type, "ref", { enumerable: false, value: null });
      type._store = {};
      Object.defineProperty(type._store, "validated", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: 0
      });
      Object.defineProperty(type, "_debugInfo", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: null
      });
      Object.defineProperty(type, "_debugStack", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugStack
      });
      Object.defineProperty(type, "_debugTask", {
        configurable: false,
        enumerable: false,
        writable: true,
        value: debugTask
      });
      Object.freeze && (Object.freeze(type.props), Object.freeze(type));
      return type;
    }
    function jsxDEVImpl(type, config2, maybeKey, isStaticChildren, debugStack, debugTask) {
      var children = config2.children;
      if (void 0 !== children)
        if (isStaticChildren)
          if (isArrayImpl(children)) {
            for (isStaticChildren = 0; isStaticChildren < children.length; isStaticChildren++)
              validateChildKeys(children[isStaticChildren]);
            Object.freeze && Object.freeze(children);
          } else
            console.error(
              "React.jsx: Static children should always be an array. You are likely explicitly calling React.jsxs or React.jsxDEV. Use the Babel transform instead."
            );
        else validateChildKeys(children);
      if (hasOwnProperty2.call(config2, "key")) {
        children = getComponentNameFromType(type);
        var keys2 = Object.keys(config2).filter(function(k2) {
          return "key" !== k2;
        });
        isStaticChildren = 0 < keys2.length ? "{key: someKey, " + keys2.join(": ..., ") + ": ...}" : "{key: someKey}";
        didWarnAboutKeySpread[children + isStaticChildren] || (keys2 = 0 < keys2.length ? "{" + keys2.join(": ..., ") + ": ...}" : "{}", console.error(
          'A props object containing a "key" prop is being spread into JSX:\n  let props = %s;\n  <%s {...props} />\nReact keys must be passed directly to JSX without using spread:\n  let props = %s;\n  <%s key={someKey} {...props} />',
          isStaticChildren,
          children,
          keys2,
          children
        ), didWarnAboutKeySpread[children + isStaticChildren] = true);
      }
      children = null;
      void 0 !== maybeKey && (checkKeyStringCoercion(maybeKey), children = "" + maybeKey);
      hasValidKey(config2) && (checkKeyStringCoercion(config2.key), children = "" + config2.key);
      if ("key" in config2) {
        maybeKey = {};
        for (var propName in config2)
          "key" !== propName && (maybeKey[propName] = config2[propName]);
      } else maybeKey = config2;
      children && defineKeyPropWarningGetter(
        maybeKey,
        "function" === typeof type ? type.displayName || type.name || "Unknown" : type
      );
      return ReactElement(
        type,
        children,
        maybeKey,
        getOwner(),
        debugStack,
        debugTask
      );
    }
    function validateChildKeys(node) {
      isValidElement2(node) ? node._store && (node._store.validated = 1) : "object" === typeof node && null !== node && node.$$typeof === REACT_LAZY_TYPE && ("fulfilled" === node._payload.status ? isValidElement2(node._payload.value) && node._payload.value._store && (node._payload.value._store.validated = 1) : node._store && (node._store.validated = 1));
    }
    function isValidElement2(object2) {
      return "object" === typeof object2 && null !== object2 && object2.$$typeof === REACT_ELEMENT_TYPE;
    }
    var React$1 = React__default, REACT_ELEMENT_TYPE = /* @__PURE__ */ Symbol.for("react.transitional.element"), REACT_PORTAL_TYPE = /* @__PURE__ */ Symbol.for("react.portal"), REACT_FRAGMENT_TYPE = /* @__PURE__ */ Symbol.for("react.fragment"), REACT_STRICT_MODE_TYPE = /* @__PURE__ */ Symbol.for("react.strict_mode"), REACT_PROFILER_TYPE = /* @__PURE__ */ Symbol.for("react.profiler"), REACT_CONSUMER_TYPE = /* @__PURE__ */ Symbol.for("react.consumer"), REACT_CONTEXT_TYPE = /* @__PURE__ */ Symbol.for("react.context"), REACT_FORWARD_REF_TYPE = /* @__PURE__ */ Symbol.for("react.forward_ref"), REACT_SUSPENSE_TYPE = /* @__PURE__ */ Symbol.for("react.suspense"), REACT_SUSPENSE_LIST_TYPE = /* @__PURE__ */ Symbol.for("react.suspense_list"), REACT_MEMO_TYPE = /* @__PURE__ */ Symbol.for("react.memo"), REACT_LAZY_TYPE = /* @__PURE__ */ Symbol.for("react.lazy"), REACT_ACTIVITY_TYPE = /* @__PURE__ */ Symbol.for("react.activity"), REACT_CLIENT_REFERENCE = /* @__PURE__ */ Symbol.for("react.client.reference"), ReactSharedInternals = React$1.__CLIENT_INTERNALS_DO_NOT_USE_OR_WARN_USERS_THEY_CANNOT_UPGRADE, hasOwnProperty2 = Object.prototype.hasOwnProperty, isArrayImpl = Array.isArray, createTask = console.createTask ? console.createTask : function() {
      return null;
    };
    React$1 = {
      react_stack_bottom_frame: function(callStackForError) {
        return callStackForError();
      }
    };
    var specialPropKeyWarningShown;
    var didWarnAboutElementRef = {};
    var unknownOwnerDebugStack = React$1.react_stack_bottom_frame.bind(
      React$1,
      UnknownOwner
    )();
    var unknownOwnerDebugTask = createTask(getTaskName(UnknownOwner));
    var didWarnAboutKeySpread = {};
    reactJsxRuntime_development.Fragment = REACT_FRAGMENT_TYPE;
    reactJsxRuntime_development.jsx = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        false,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
    reactJsxRuntime_development.jsxs = function(type, config2, maybeKey) {
      var trackActualOwner = 1e4 > ReactSharedInternals.recentlyCreatedOwnerStacks++;
      return jsxDEVImpl(
        type,
        config2,
        maybeKey,
        true,
        trackActualOwner ? Error("react-stack-top-frame") : unknownOwnerDebugStack,
        trackActualOwner ? createTask(getTaskName(type)) : unknownOwnerDebugTask
      );
    };
  })();
  return reactJsxRuntime_development;
}
var hasRequiredJsxRuntime;
function requireJsxRuntime() {
  if (hasRequiredJsxRuntime) return jsxRuntime.exports;
  hasRequiredJsxRuntime = 1;
  if (process.env.NODE_ENV === "production") {
    jsxRuntime.exports = requireReactJsxRuntime_production();
  } else {
    jsxRuntime.exports = requireReactJsxRuntime_development();
  }
  return jsxRuntime.exports;
}
var jsxRuntimeExports = requireJsxRuntime();
var _excluded = ["className", "value", "selection", "extensions", "onChange", "onStatistics", "onCreateEditor", "onUpdate", "autoFocus", "theme", "height", "minHeight", "maxHeight", "width", "minWidth", "maxWidth", "basicSetup", "placeholder", "indentWithTab", "editable", "readOnly", "root", "initialState"];
var ReactCodeMirror = /* @__PURE__ */ forwardRef$3((props2, ref) => {
  var className = props2.className, _props$value = props2.value, value = _props$value === void 0 ? "" : _props$value, selection2 = props2.selection, _props$extensions = props2.extensions, extensions = _props$extensions === void 0 ? [] : _props$extensions, onChange = props2.onChange, onStatistics = props2.onStatistics, onCreateEditor = props2.onCreateEditor, onUpdate = props2.onUpdate, autoFocus = props2.autoFocus, _props$theme = props2.theme, theme2 = _props$theme === void 0 ? "light" : _props$theme, height = props2.height, minHeight = props2.minHeight, maxHeight = props2.maxHeight, width = props2.width, minWidth = props2.minWidth, maxWidth = props2.maxWidth, basicSetup3 = props2.basicSetup, placeholder2 = props2.placeholder, indentWithTab2 = props2.indentWithTab, editable2 = props2.editable, readOnly2 = props2.readOnly, root2 = props2.root, initialState2 = props2.initialState, other = _objectWithoutPropertiesLoose(props2, _excluded);
  var editor = useRef(null);
  var _useCodeMirror = useCodeMirror({
    root: root2,
    value,
    autoFocus,
    theme: theme2,
    height,
    minHeight,
    maxHeight,
    width,
    minWidth,
    maxWidth,
    basicSetup: basicSetup3,
    placeholder: placeholder2,
    indentWithTab: indentWithTab2,
    editable: editable2,
    readOnly: readOnly2,
    selection: selection2,
    onChange,
    onStatistics,
    onCreateEditor,
    onUpdate,
    extensions,
    initialState: initialState2
  }), state = _useCodeMirror.state, view = _useCodeMirror.view, container = _useCodeMirror.container, setContainer = _useCodeMirror.setContainer;
  useImperativeHandle(ref, () => ({
    editor: editor.current,
    state,
    view
  }), [editor, container, state, view]);
  var setEditorRef = useCallback((el) => {
    editor.current = el;
    setContainer(el);
  }, [setContainer]);
  if (typeof value !== "string") {
    throw new Error("value must be typeof string but got " + typeof value);
  }
  var defaultClassNames = typeof theme2 === "string" ? "cm-theme-" + theme2 : "cm-theme";
  return /* @__PURE__ */ jsxRuntimeExports.jsx("div", _extends$1({
    ref: setEditorRef,
    className: "" + defaultClassNames + (className ? " " + className : "")
  }, other));
});
ReactCodeMirror.displayName = "CodeMirror";
function ccount(value, character) {
  const source = String(value);
  if (typeof character !== "string") {
    throw new TypeError("Expected character");
  }
  let count = 0;
  let index2 = source.indexOf(character);
  while (index2 !== -1) {
    count++;
    index2 = source.indexOf(character, index2 + character.length);
  }
  return count;
}
const defaultSubsetRegex = /["&'<>`]/g;
const surrogatePairsRegex = /[\uD800-\uDBFF][\uDC00-\uDFFF]/g;
const controlCharactersRegex = (
  // eslint-disable-next-line no-control-regex, unicorn/no-hex-escape
  /[\x01-\t\v\f\x0E-\x1F\x7F\x81\x8D\x8F\x90\x9D\xA0-\uFFFF]/g
);
const regexEscapeRegex = /[|\\{}()[\]^$+*?.]/g;
const subsetToRegexCache = /* @__PURE__ */ new WeakMap();
function core$1$1(value, options2) {
  value = value.replace(
    options2.subset ? charactersToExpressionCached(options2.subset) : defaultSubsetRegex,
    basic
  );
  if (options2.subset || options2.escapeOnly) {
    return value;
  }
  return value.replace(surrogatePairsRegex, surrogate).replace(controlCharactersRegex, basic);
  function surrogate(pair2, index2, all2) {
    return options2.format(
      (pair2.charCodeAt(0) - 55296) * 1024 + pair2.charCodeAt(1) - 56320 + 65536,
      all2.charCodeAt(index2 + 2),
      options2
    );
  }
  function basic(character, index2, all2) {
    return options2.format(
      character.charCodeAt(0),
      all2.charCodeAt(index2 + 1),
      options2
    );
  }
}
function charactersToExpressionCached(subset) {
  let cached = subsetToRegexCache.get(subset);
  if (!cached) {
    cached = charactersToExpression(subset);
    subsetToRegexCache.set(subset, cached);
  }
  return cached;
}
function charactersToExpression(subset) {
  const groups = [];
  let index2 = -1;
  while (++index2 < subset.length) {
    groups.push(subset[index2].replace(regexEscapeRegex, "\\$&"));
  }
  return new RegExp("(?:" + groups.join("|") + ")", "g");
}
function formatBasic(code2) {
  return "&#x" + code2.toString(16).toUpperCase() + ";";
}
function stringifyEntitiesLight(value, options2) {
  return core$1$1(value, Object.assign({ format: formatBasic }, options2));
}
function escape$1(value, subset, unsafe) {
  const result2 = clean$1(value);
  return unsafe ? result2.replace(unsafe, encode2) : encode2(result2);
  function encode2(value2) {
    return stringifyEntitiesLight(value2, { subset }).replace(/&#x3C;/g, "&lt;").replace(/&#x26;/g, "&amp;");
  }
}
const nonCharacter = /[\u0000-\u0008\u000B\u000C\u000E-\u001F]/g;
function clean$1(value) {
  return String(value || "").replace(nonCharacter, "");
}
function name$a(value) {
  const subset = ["	", "\n", " ", '"', "&", "'", "/", "<", "=", ">"];
  return escape$1(value, subset);
}
function mergeAdjacentTextInArray(nodes) {
  const needsMerging = nodes.some(
    (n2, i2) => n2.type === "text" && nodes[i2 + 1]?.type === "text"
  );
  if (!needsMerging) {
    return nodes;
  }
  const ret = [];
  for (let i2 = 0; i2 < nodes.length; i2++) {
    let node = nodes[i2];
    let nextNode = nodes[i2 + 1];
    if (!nextNode) {
      ret.push(node);
      continue;
    }
    if (node.type === "text" && nextNode.type === "text") {
      node = { ...node };
      ret.push(node);
      while (nextNode?.type === "text") {
        node.value += nextNode.value;
        if (node.position && nextNode.position) {
          node.position.end = nextNode.position.end;
        }
        i2++;
        nextNode = nodes[i2 + 1];
      }
    } else {
      ret.push(node);
    }
  }
  return ret;
}
function findNodesWithPositionInfo(nodes) {
  if (typeof nodes !== "object" || nodes === null) {
    return [];
  }
  if (Array.isArray(nodes)) {
    return nodes.flatMap(findNodesWithPositionInfo);
  }
  if (!("type" in nodes)) {
    return [];
  }
  const ret = "position" in nodes ? [nodes] : [];
  for (const value of Object.values(nodes)) {
    if (Array.isArray(value)) {
      ret.push(...findNodesWithPositionInfo(value));
    }
  }
  return ret;
}
function macroToString(node) {
  if (Array.isArray(node)) {
    return node.map((n2) => macroToString(n2)).join("");
  }
  switch (node.type) {
    case "macro": {
      const macro = unwrappedMacroToString$1(node);
      let start = "$";
      let end = "";
      if (macroNeedsParens$1(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      const macro = unwrappedMacroToString$1(node.macro);
      let start = "$$";
      let end = "";
      if (macroNeedsParens$1(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map(macroToString).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "text":
      return toXml(node);
    default:
      console.warn("Unhandled node type", node);
  }
  return "$ERROR";
}
function unwrappedMacroToString$1(nodes) {
  const path = macroPathToString$1(nodes.path);
  const attrs = Object.values(nodes.attributes || {}).map(attrToString$1).join(" ");
  let attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  let propAccess = "";
  if (nodes.accessedProp) {
    propAccess = "." + unwrappedMacroToString$1(nodes.accessedProp);
  }
  return path + attrsStr + propAccess;
}
function macroPathToString$1(path) {
  return path.map(macroPathPartToString$1).join("/");
}
function macroPathPartToString$1(pathPart) {
  return pathPart.name + pathPart.index.map((part) => `[${macroToString(part.value)}]`).join("");
}
function attrToString$1(attr) {
  const name2 = attr.name;
  if (attr.children.length === 0) {
    return name2;
  }
  const value = attr.children.map(macroToString).join("");
  return `${name2}=${quote(value)}`;
}
function macroNeedsParens$1(macro) {
  if (macro.type === "function") {
    return macroNeedsParens$1(macro.macro);
  }
  if (macro.path.length > 1) {
    return true;
  }
  return macro.path.some((part) => part.name.includes("-")) || macro.accessedProp != null && macroNeedsParens$1(macro.accessedProp);
}
function toXml(tree, options2) {
  options2 = options2 || {};
  if (!tree) {
    return "";
  }
  const node = Array.isArray(tree) ? { type: "root", children: tree } : tree;
  return nodesToXml(node, options2);
}
function nodesToXml(node, options2) {
  if (Array.isArray(node)) {
    if (!node.some((n2) => n2.type === "pathPart")) {
      return mergeAdjacentTextInArray(node).map((child) => nodesToXml(child, options2)).join("");
    } else {
      return node.map((part) => nodesToXml(part, options2)).join(".");
    }
  }
  const type = node && node.type;
  switch (node?.type) {
    case "root":
      return nodesToXml(node.children, options2);
    case "cdata": {
      const unsafe = /]]>/g;
      const subset = [">"];
      return "<![CDATA[" + escape$1(node.value, subset, unsafe) + "]]>";
    }
    case "comment":
      return "<!--" + escape$1(node.value, ["-"]) + "-->";
    case "doctype": {
      const nodeName = name$a(node.name);
      const pub = node.public;
      const sys = node.system;
      let result2 = "<!DOCTYPE";
      if (nodeName !== "") {
        result2 += " " + nodeName;
      }
      if (pub) {
        result2 += " PUBLIC " + quote(pub);
      } else if (sys) {
        result2 += " SYSTEM";
      }
      if (sys) {
        result2 += " " + quote(sys);
      }
      return result2 + ">";
    }
    case "attribute": {
      return attrToString(node, options2);
    }
    case "element": {
      const nodeName = name$a(node.name);
      const content2 = nodesToXml(node.children, options2);
      const attributes = node.attributes || [];
      const attrs = Object.values(attributes).map(
        (attr) => attrToString(attr, options2)
      );
      const printedAttrs = (attrs.length > 0 ? " " : "") + attrs.join(" ");
      if (node.children.length === 0 || !options2.inlineErrors && node.children.every((c2) => c2.type === "error")) {
        return `<${nodeName}${printedAttrs} />`;
      }
      return `<${nodeName}${printedAttrs}>${content2}</${nodeName}>`;
    }
    case "instruction": {
      const unsafe = /\?>/g;
      const subset = [">"];
      const nodeName = name$a(node.name);
      const result2 = escape$1(node.value, subset, unsafe);
      return "<?" + nodeName + (result2 ? " " + result2 : "") + "?>";
    }
    case "text": {
      let escapedText = escape$1(node.value, ["&", "<"]);
      if (options2.doenetSyntax) {
        escapedText = escapedText.replace(/&lt;(?=\s|=)/g, "<");
        escapedText = escapedText.replace(/&amp;(?!\S*;)/g, "&");
      }
      return escapedText;
    }
    case "error": {
      if (options2.inlineErrors) {
        const errorElement = {
          type: "element",
          name: "_error",
          attributes: {
            message: {
              type: "attribute",
              name: "message",
              children: [{ type: "text", value: node.message }]
            }
          },
          children: [{ type: "text", value: node.message }]
        };
        return nodesToXml(errorElement, options2);
      }
      return "";
    }
    case "macro": {
      if (node.version === "0.6") {
        return macroToString(node);
      }
      const macro = unwrappedMacroToString(node, options2);
      let start = "$";
      let end = "";
      if (macroNeedsParens(node)) {
        start += "(";
        end += ")";
      }
      return start + macro + end;
    }
    case "function": {
      if (node.version === "0.6") {
        return macroToString(node);
      }
      const macro = unwrappedMacroToString(node, options2);
      let start = "$$";
      let end = "";
      if (macroNeedsParens(node)) {
        start += "(";
        end += ")";
      }
      const args = node.input ? `(${node.input.map((a2) => nodesToXml(a2, options2)).join(", ")})` : "";
      return start + macro + end + args;
    }
    case "pathPart": {
      return node.name + node.index.map((ind) => `[${nodesToXml(ind.value, options2)}]`).join("");
    }
  }
  if (!type) {
    throw new Error("Expected node, not `" + node + "`");
  }
  throw new Error("Cannot compile unknown node `" + type + "`");
}
function quote(value) {
  const result2 = String(value);
  let quoteMark = '"';
  const other = quoteMark === '"' ? "'" : '"';
  if (ccount(result2, quoteMark) > ccount(result2, other)) {
    quoteMark = other;
  }
  return quoteMark + escape$1(result2, ["<", quoteMark]) + quoteMark;
}
function unwrappedMacroToString(nodes, options2) {
  const path = macroPathToString(nodes.path, options2);
  let attrsStr = "";
  if (nodes.type === "macro") {
    const attrs = Object.values(nodes.attributes || {}).map((a2) => attrToString(a2, options2)).join(" ");
    attrsStr = attrs.length > 0 ? `{${attrs}}` : "";
  }
  let propAccess = "";
  return path + attrsStr + propAccess;
}
function macroPathToString(path, options2) {
  return path.map((part) => macroPathPartToString(part, options2)).join(".");
}
function macroPathPartToString(pathPart, options2) {
  return pathPart.name + pathPart.index.map((part) => `[${nodesToXml(part.value, options2)}]`).join("");
}
function attrToString(attr, options2) {
  if (attr.children.length === 0) {
    if (options2.doenetSyntax) {
      return name$a(attr.name);
    }
    return `${name$a(attr.name)}="true"`;
  }
  return `${name$a(attr.name)}=${quote(nodesToXml(attr.children, options2))}`;
}
function macroNeedsParens(macro) {
  return macro.path.some((part) => part.name.includes("-"));
}
const StartTag = 1, StartCloseTag = 2, MissingCloseTag = 3, mismatchedStartCloseTag = 4, incompleteStartCloseTag = 5, commentContent$1 = 36, piContent$1 = 37, cdataContent$1 = 38, Text = 7, Element$1 = 12, EndTag = 13, OpenTag = 14, TagName$C = 15, Attribute = 16, AttributeValue = 19, CloseTag = 20, SelfCloseEndTag = 21, SelfClosingTag = 22, MismatchedCloseTag = 25;
const DefaultBufferLength = 1024;
let nextPropID = 0;
let Range$1 = class Range4 {
  constructor(from, to2) {
    this.from = from;
    this.to = to2;
  }
};
class NodeProp {
  /**
  Create a new node prop type.
  */
  constructor(config2 = {}) {
    this.id = nextPropID++;
    this.perNode = !!config2.perNode;
    this.deserialize = config2.deserialize || (() => {
      throw new Error("This node type doesn't define a deserialize function");
    });
    this.combine = config2.combine || null;
  }
  /**
  This is meant to be used with
  [`NodeSet.extend`](#common.NodeSet.extend) or
  [`LRParser.configure`](#lr.ParserConfig.props) to compute
  prop values for each node type in the set. Takes a [match
  object](#common.NodeType^match) or function that returns undefined
  if the node type doesn't get this prop, and the prop's value if
  it does.
  */
  add(match2) {
    if (this.perNode)
      throw new RangeError("Can't add per-node props to node types");
    if (typeof match2 != "function")
      match2 = NodeType.match(match2);
    return (type) => {
      let result2 = match2(type);
      return result2 === void 0 ? null : [this, result2];
    };
  }
}
NodeProp.closedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.openedBy = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.group = new NodeProp({ deserialize: (str) => str.split(" ") });
NodeProp.isolate = new NodeProp({ deserialize: (value) => {
  if (value && value != "rtl" && value != "ltr" && value != "auto")
    throw new RangeError("Invalid value for isolate: " + value);
  return value || "auto";
} });
NodeProp.contextHash = new NodeProp({ perNode: true });
NodeProp.lookAhead = new NodeProp({ perNode: true });
NodeProp.mounted = new NodeProp({ perNode: true });
class MountedTree {
  constructor(tree, overlay, parser2, bracketed = false) {
    this.tree = tree;
    this.overlay = overlay;
    this.parser = parser2;
    this.bracketed = bracketed;
  }
  /**
  @internal
  */
  static get(tree) {
    return tree && tree.props && tree.props[NodeProp.mounted.id];
  }
}
const noProps = /* @__PURE__ */ Object.create(null);
class NodeType {
  /**
  @internal
  */
  constructor(name2, props2, id2, flags = 0) {
    this.name = name2;
    this.props = props2;
    this.id = id2;
    this.flags = flags;
  }
  /**
  Define a node type.
  */
  static define(spec) {
    let props2 = spec.props && spec.props.length ? /* @__PURE__ */ Object.create(null) : noProps;
    let flags = (spec.top ? 1 : 0) | (spec.skipped ? 2 : 0) | (spec.error ? 4 : 0) | (spec.name == null ? 8 : 0);
    let type = new NodeType(spec.name || "", props2, spec.id, flags);
    if (spec.props)
      for (let src of spec.props) {
        if (!Array.isArray(src))
          src = src(type);
        if (src) {
          if (src[0].perNode)
            throw new RangeError("Can't store a per-node prop on a node type");
          props2[src[0].id] = src[1];
        }
      }
    return type;
  }
  /**
  Retrieves a node prop for this type. Will return `undefined` if
  the prop isn't present on this node.
  */
  prop(prop) {
    return this.props[prop.id];
  }
  /**
  True when this is the top node of a grammar.
  */
  get isTop() {
    return (this.flags & 1) > 0;
  }
  /**
  True when this node is produced by a skip rule.
  */
  get isSkipped() {
    return (this.flags & 2) > 0;
  }
  /**
  Indicates whether this is an error node.
  */
  get isError() {
    return (this.flags & 4) > 0;
  }
  /**
  When true, this node type doesn't correspond to a user-declared
  named node, for example because it is used to cache repetition.
  */
  get isAnonymous() {
    return (this.flags & 8) > 0;
  }
  /**
  Returns true when this node's name or one of its
  [groups](#common.NodeProp^group) matches the given string.
  */
  is(name2) {
    if (typeof name2 == "string") {
      if (this.name == name2)
        return true;
      let group2 = this.prop(NodeProp.group);
      return group2 ? group2.indexOf(name2) > -1 : false;
    }
    return this.id == name2;
  }
  /**
  Create a function from node types to arbitrary values by
  specifying an object whose property names are node or
  [group](#common.NodeProp^group) names. Often useful with
  [`NodeProp.add`](#common.NodeProp.add). You can put multiple
  names, separated by spaces, in a single property name to map
  multiple node names to a single value.
  */
  static match(map2) {
    let direct = /* @__PURE__ */ Object.create(null);
    for (let prop in map2)
      for (let name2 of prop.split(" "))
        direct[name2] = map2[prop];
    return (node) => {
      for (let groups = node.prop(NodeProp.group), i2 = -1; i2 < (groups ? groups.length : 0); i2++) {
        let found = direct[i2 < 0 ? node.name : groups[i2]];
        if (found)
          return found;
      }
    };
  }
}
NodeType.none = new NodeType(
  "",
  /* @__PURE__ */ Object.create(null),
  0,
  8
  /* NodeFlag.Anonymous */
);
class NodeSet {
  /**
  Create a set with the given types. The `id` property of each
  type should correspond to its position within the array.
  */
  constructor(types2) {
    this.types = types2;
    for (let i2 = 0; i2 < types2.length; i2++)
      if (types2[i2].id != i2)
        throw new RangeError("Node type ids should correspond to array positions when creating a node set");
  }
  /**
  Create a copy of this set with some node properties added. The
  arguments to this method can be created with
  [`NodeProp.add`](#common.NodeProp.add).
  */
  extend(...props2) {
    let newTypes = [];
    for (let type of this.types) {
      let newProps = null;
      for (let source of props2) {
        let add2 = source(type);
        if (add2) {
          if (!newProps)
            newProps = Object.assign({}, type.props);
          let value = add2[1], prop = add2[0];
          if (prop.combine && prop.id in newProps)
            value = prop.combine(newProps[prop.id], value);
          newProps[prop.id] = value;
        }
      }
      newTypes.push(newProps ? new NodeType(type.name, newProps, type.id, type.flags) : type);
    }
    return new NodeSet(newTypes);
  }
}
const CachedNode = /* @__PURE__ */ new WeakMap(), CachedInnerNode = /* @__PURE__ */ new WeakMap();
var IterMode;
(function(IterMode2) {
  IterMode2[IterMode2["ExcludeBuffers"] = 1] = "ExcludeBuffers";
  IterMode2[IterMode2["IncludeAnonymous"] = 2] = "IncludeAnonymous";
  IterMode2[IterMode2["IgnoreMounts"] = 4] = "IgnoreMounts";
  IterMode2[IterMode2["IgnoreOverlays"] = 8] = "IgnoreOverlays";
  IterMode2[IterMode2["EnterBracketed"] = 16] = "EnterBracketed";
})(IterMode || (IterMode = {}));
class Tree {
  /**
  Construct a new tree. See also [`Tree.build`](#common.Tree^build).
  */
  constructor(type, children, positions, length, props2) {
    this.type = type;
    this.children = children;
    this.positions = positions;
    this.length = length;
    this.props = null;
    if (props2 && props2.length) {
      this.props = /* @__PURE__ */ Object.create(null);
      for (let [prop, value] of props2)
        this.props[typeof prop == "number" ? prop : prop.id] = value;
    }
  }
  /**
  @internal
  */
  toString() {
    let mounted = MountedTree.get(this);
    if (mounted && !mounted.overlay)
      return mounted.tree.toString();
    let children = "";
    for (let ch of this.children) {
      let str = ch.toString();
      if (str) {
        if (children)
          children += ",";
        children += str;
      }
    }
    return !this.type.name ? children : (/\W/.test(this.type.name) && !this.type.isError ? JSON.stringify(this.type.name) : this.type.name) + (children.length ? "(" + children + ")" : "");
  }
  /**
  Get a [tree cursor](#common.TreeCursor) positioned at the top of
  the tree. Mode can be used to [control](#common.IterMode) which
  nodes the cursor visits.
  */
  cursor(mode = 0) {
    return new TreeCursor(this.topNode, mode);
  }
  /**
  Get a [tree cursor](#common.TreeCursor) pointing into this tree
  at the given position and side (see
  [`moveTo`](#common.TreeCursor.moveTo).
  */
  cursorAt(pos, side = 0, mode = 0) {
    let scope = CachedNode.get(this) || this.topNode;
    let cursor2 = new TreeCursor(scope);
    cursor2.moveTo(pos, side);
    CachedNode.set(this, cursor2._tree);
    return cursor2;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) object for the top of the
  tree.
  */
  get topNode() {
    return new TreeNode(this, 0, 0, null);
  }
  /**
  Get the [syntax node](#common.SyntaxNode) at the given position.
  If `side` is -1, this will move into nodes that end at the
  position. If 1, it'll move into nodes that start at the
  position. With 0, it'll only enter nodes that cover the position
  from both sides.
  
  Note that this will not enter
  [overlays](#common.MountedTree.overlay), and you often want
  [`resolveInner`](#common.Tree.resolveInner) instead.
  */
  resolve(pos, side = 0) {
    let node = resolveNode(CachedNode.get(this) || this.topNode, pos, side, false);
    CachedNode.set(this, node);
    return node;
  }
  /**
  Like [`resolve`](#common.Tree.resolve), but will enter
  [overlaid](#common.MountedTree.overlay) nodes, producing a syntax node
  pointing into the innermost overlaid tree at the given position
  (with parent links going through all parent structure, including
  the host trees).
  */
  resolveInner(pos, side = 0) {
    let node = resolveNode(CachedInnerNode.get(this) || this.topNode, pos, side, true);
    CachedInnerNode.set(this, node);
    return node;
  }
  /**
  In some situations, it can be useful to iterate through all
  nodes around a position, including those in overlays that don't
  directly cover the position. This method gives you an iterator
  that will produce all nodes, from small to big, around the given
  position.
  */
  resolveStack(pos, side = 0) {
    return stackIterator(this, pos, side);
  }
  /**
  Iterate over the tree and its children, calling `enter` for any
  node that touches the `from`/`to` region (if given) before
  running over such a node's children, and `leave` (if given) when
  leaving the node. When `enter` returns `false`, that node will
  not have its children iterated over (or `leave` called).
  */
  iterate(spec) {
    let { enter, leave, from = 0, to: to2 = this.length } = spec;
    let mode = spec.mode || 0, anon = (mode & IterMode.IncludeAnonymous) > 0;
    for (let c2 = this.cursor(mode | IterMode.IncludeAnonymous); ; ) {
      let entered = false;
      if (c2.from <= to2 && c2.to >= from && (!anon && c2.type.isAnonymous || enter(c2) !== false)) {
        if (c2.firstChild())
          continue;
        entered = true;
      }
      for (; ; ) {
        if (entered && leave && (anon || !c2.type.isAnonymous))
          leave(c2);
        if (c2.nextSibling())
          break;
        if (!c2.parent())
          return;
        entered = true;
      }
    }
  }
  /**
  Get the value of the given [node prop](#common.NodeProp) for this
  node. Works with both per-node and per-type props.
  */
  prop(prop) {
    return !prop.perNode ? this.type.prop(prop) : this.props ? this.props[prop.id] : void 0;
  }
  /**
  Returns the node's [per-node props](#common.NodeProp.perNode) in a
  format that can be passed to the [`Tree`](#common.Tree)
  constructor.
  */
  get propValues() {
    let result2 = [];
    if (this.props)
      for (let id2 in this.props)
        result2.push([+id2, this.props[id2]]);
    return result2;
  }
  /**
  Balance the direct children of this tree, producing a copy of
  which may have children grouped into subtrees with type
  [`NodeType.none`](#common.NodeType^none).
  */
  balance(config2 = {}) {
    return this.children.length <= 8 ? this : balanceRange(NodeType.none, this.children, this.positions, 0, this.children.length, 0, this.length, (children, positions, length) => new Tree(this.type, children, positions, length, this.propValues), config2.makeTree || ((children, positions, length) => new Tree(NodeType.none, children, positions, length)));
  }
  /**
  Build a tree from a postfix-ordered buffer of node information,
  or a cursor over such a buffer.
  */
  static build(data) {
    return buildTree(data);
  }
}
Tree.empty = new Tree(NodeType.none, [], [], 0);
class FlatBufferCursor {
  constructor(buffer, index2) {
    this.buffer = buffer;
    this.index = index2;
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  get pos() {
    return this.index;
  }
  next() {
    this.index -= 4;
  }
  fork() {
    return new FlatBufferCursor(this.buffer, this.index);
  }
}
class TreeBuffer {
  /**
  Create a tree buffer.
  */
  constructor(buffer, length, set2) {
    this.buffer = buffer;
    this.length = length;
    this.set = set2;
  }
  /**
  @internal
  */
  get type() {
    return NodeType.none;
  }
  /**
  @internal
  */
  toString() {
    let result2 = [];
    for (let index2 = 0; index2 < this.buffer.length; ) {
      result2.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2.join(",");
  }
  /**
  @internal
  */
  childString(index2) {
    let id2 = this.buffer[index2], endIndex = this.buffer[index2 + 3];
    let type = this.set.types[id2], result2 = type.name;
    if (/\W/.test(result2) && !type.isError)
      result2 = JSON.stringify(result2);
    index2 += 4;
    if (endIndex == index2)
      return result2;
    let children = [];
    while (index2 < endIndex) {
      children.push(this.childString(index2));
      index2 = this.buffer[index2 + 3];
    }
    return result2 + "(" + children.join(",") + ")";
  }
  /**
  @internal
  */
  findChild(startIndex, endIndex, dir, pos, side) {
    let { buffer } = this, pick2 = -1;
    for (let i2 = startIndex; i2 != endIndex; i2 = buffer[i2 + 3]) {
      if (checkSide(side, pos, buffer[i2 + 1], buffer[i2 + 2])) {
        pick2 = i2;
        if (dir > 0)
          break;
      }
    }
    return pick2;
  }
  /**
  @internal
  */
  slice(startI, endI, from) {
    let b2 = this.buffer;
    let copy2 = new Uint16Array(endI - startI), len = 0;
    for (let i2 = startI, j2 = 0; i2 < endI; ) {
      copy2[j2++] = b2[i2++];
      copy2[j2++] = b2[i2++] - from;
      let to2 = copy2[j2++] = b2[i2++] - from;
      copy2[j2++] = b2[i2++] - startI;
      len = Math.max(len, to2);
    }
    return new TreeBuffer(copy2, len, this.set);
  }
}
function checkSide(side, pos, from, to2) {
  switch (side) {
    case -2:
      return from < pos;
    case -1:
      return to2 >= pos && from < pos;
    case 0:
      return from < pos && to2 > pos;
    case 1:
      return from <= pos && to2 > pos;
    case 2:
      return to2 > pos;
    case 4:
      return true;
  }
}
function resolveNode(node, pos, side, overlays) {
  var _a2;
  while (node.from == node.to || (side < 1 ? node.from >= pos : node.from > pos) || (side > -1 ? node.to <= pos : node.to < pos)) {
    let parent = !overlays && node instanceof TreeNode && node.index < 0 ? null : node.parent;
    if (!parent)
      return node;
    node = parent;
  }
  let mode = overlays ? 0 : IterMode.IgnoreOverlays;
  if (overlays)
    for (let scan = node, parent = scan.parent; parent; scan = parent, parent = scan.parent) {
      if (scan instanceof TreeNode && scan.index < 0 && ((_a2 = parent.enter(pos, side, mode)) === null || _a2 === void 0 ? void 0 : _a2.from) != scan.from)
        node = parent;
    }
  for (; ; ) {
    let inner = node.enter(pos, side, mode);
    if (!inner)
      return node;
    node = inner;
  }
}
class BaseNode {
  cursor(mode = 0) {
    return new TreeCursor(this, mode);
  }
  getChild(type, before2 = null, after2 = null) {
    let r2 = getChildren(this, type, before2, after2);
    return r2.length ? r2[0] : null;
  }
  getChildren(type, before2 = null, after2 = null) {
    return getChildren(this, type, before2, after2);
  }
  resolve(pos, side = 0) {
    return resolveNode(this, pos, side, false);
  }
  resolveInner(pos, side = 0) {
    return resolveNode(this, pos, side, true);
  }
  matchContext(context) {
    return matchNodeContext(this.parent, context);
  }
  enterUnfinishedNodesBefore(pos) {
    let scan = this.childBefore(pos), node = this;
    while (scan) {
      let last2 = scan.lastChild;
      if (!last2 || last2.to != scan.to)
        break;
      if (last2.type.isError && last2.from == last2.to) {
        node = scan;
        scan = last2.prevSibling;
      } else {
        scan = last2;
      }
    }
    return node;
  }
  get node() {
    return this;
  }
  get next() {
    return this.parent;
  }
}
class TreeNode extends BaseNode {
  constructor(_tree, from, index2, _parent) {
    super();
    this._tree = _tree;
    this.from = from;
    this.index = index2;
    this._parent = _parent;
  }
  get type() {
    return this._tree.type;
  }
  get name() {
    return this._tree.type.name;
  }
  get to() {
    return this.from + this._tree.length;
  }
  nextChild(i2, dir, pos, side, mode = 0) {
    for (let parent = this; ; ) {
      for (let { children, positions } = parent._tree, e2 = dir > 0 ? children.length : -1; i2 != e2; i2 += dir) {
        let next = children[i2], start = positions[i2] + parent.from, mounted;
        if (!(mode & IterMode.EnterBracketed && next instanceof Tree && (mounted = MountedTree.get(next)) && !mounted.overlay && mounted.bracketed && pos >= start && pos <= start + next.length) && !checkSide(side, pos, start, start + next.length))
          continue;
        if (next instanceof TreeBuffer) {
          if (mode & IterMode.ExcludeBuffers)
            continue;
          let index2 = next.findChild(0, next.buffer.length, dir, pos - start, side);
          if (index2 > -1)
            return new BufferNode(new BufferContext(parent, next, i2, start), null, index2);
        } else if (mode & IterMode.IncludeAnonymous || (!next.type.isAnonymous || hasChild(next))) {
          let mounted2;
          if (!(mode & IterMode.IgnoreMounts) && (mounted2 = MountedTree.get(next)) && !mounted2.overlay)
            return new TreeNode(mounted2.tree, start, i2, parent);
          let inner = new TreeNode(next, start, i2, parent);
          return mode & IterMode.IncludeAnonymous || !inner.type.isAnonymous ? inner : inner.nextChild(dir < 0 ? next.children.length - 1 : 0, dir, pos, side, mode);
        }
      }
      if (mode & IterMode.IncludeAnonymous || !parent.type.isAnonymous)
        return null;
      if (parent.index >= 0)
        i2 = parent.index + dir;
      else
        i2 = dir < 0 ? -1 : parent._parent._tree.children.length;
      parent = parent._parent;
      if (!parent)
        return null;
    }
  }
  get firstChild() {
    return this.nextChild(
      0,
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.nextChild(
      0,
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.nextChild(
      this._tree.children.length - 1,
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this._tree.prop(prop);
  }
  enter(pos, side, mode = 0) {
    let mounted;
    if (!(mode & IterMode.IgnoreOverlays) && (mounted = MountedTree.get(this._tree)) && mounted.overlay) {
      let rPos = pos - this.from, enterBracketed = mode & IterMode.EnterBracketed && mounted.bracketed;
      for (let { from, to: to2 } of mounted.overlay) {
        if ((side > 0 || enterBracketed ? from <= rPos : from < rPos) && (side < 0 || enterBracketed ? to2 >= rPos : to2 > rPos))
          return new TreeNode(mounted.tree, mounted.overlay[0].from + this.from, -1, this);
      }
    }
    return this.nextChild(0, 1, pos, side, mode);
  }
  nextSignificantParent() {
    let val = this;
    while (val.type.isAnonymous && val._parent)
      val = val._parent;
    return val;
  }
  get parent() {
    return this._parent ? this._parent.nextSignificantParent() : null;
  }
  get nextSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index + 1,
      1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get prevSibling() {
    return this._parent && this.index >= 0 ? this._parent.nextChild(
      this.index - 1,
      -1,
      0,
      4
      /* Side.DontCare */
    ) : null;
  }
  get tree() {
    return this._tree;
  }
  toTree() {
    return this._tree;
  }
  /**
  @internal
  */
  toString() {
    return this._tree.toString();
  }
}
function getChildren(node, type, before2, after2) {
  let cur2 = node.cursor(), result2 = [];
  if (!cur2.firstChild())
    return result2;
  if (before2 != null)
    for (let found = false; !found; ) {
      found = cur2.type.is(before2);
      if (!cur2.nextSibling())
        return result2;
    }
  for (; ; ) {
    if (after2 != null && cur2.type.is(after2))
      return result2;
    if (cur2.type.is(type))
      result2.push(cur2.node);
    if (!cur2.nextSibling())
      return after2 == null ? result2 : [];
  }
}
function matchNodeContext(node, context, i2 = context.length - 1) {
  for (let p2 = node; i2 >= 0; p2 = p2.parent) {
    if (!p2)
      return false;
    if (!p2.type.isAnonymous) {
      if (context[i2] && context[i2] != p2.name)
        return false;
      i2--;
    }
  }
  return true;
}
class BufferContext {
  constructor(parent, buffer, index2, start) {
    this.parent = parent;
    this.buffer = buffer;
    this.index = index2;
    this.start = start;
  }
}
class BufferNode extends BaseNode {
  get name() {
    return this.type.name;
  }
  get from() {
    return this.context.start + this.context.buffer.buffer[this.index + 1];
  }
  get to() {
    return this.context.start + this.context.buffer.buffer[this.index + 2];
  }
  constructor(context, _parent, index2) {
    super();
    this.context = context;
    this._parent = _parent;
    this.index = index2;
    this.type = context.buffer.set.types[context.buffer.buffer[index2]];
  }
  child(dir, pos, side) {
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get firstChild() {
    return this.child(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  get lastChild() {
    return this.child(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  childAfter(pos) {
    return this.child(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  childBefore(pos) {
    return this.child(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  prop(prop) {
    return this.type.prop(prop);
  }
  enter(pos, side, mode = 0) {
    if (mode & IterMode.ExcludeBuffers)
      return null;
    let { buffer } = this.context;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], side > 0 ? 1 : -1, pos - this.context.start, side);
    return index2 < 0 ? null : new BufferNode(this.context, this, index2);
  }
  get parent() {
    return this._parent || this.context.parent.nextSignificantParent();
  }
  externalSibling(dir) {
    return this._parent ? null : this.context.parent.nextChild(
      this.context.index + dir,
      dir,
      0,
      4
      /* Side.DontCare */
    );
  }
  get nextSibling() {
    let { buffer } = this.context;
    let after2 = buffer.buffer[this.index + 3];
    if (after2 < (this._parent ? buffer.buffer[this._parent.index + 3] : buffer.buffer.length))
      return new BufferNode(this.context, this._parent, after2);
    return this.externalSibling(1);
  }
  get prevSibling() {
    let { buffer } = this.context;
    let parentStart = this._parent ? this._parent.index + 4 : 0;
    if (this.index == parentStart)
      return this.externalSibling(-1);
    return new BufferNode(this.context, this._parent, buffer.findChild(
      parentStart,
      this.index,
      -1,
      0,
      4
      /* Side.DontCare */
    ));
  }
  get tree() {
    return null;
  }
  toTree() {
    let children = [], positions = [];
    let { buffer } = this.context;
    let startI = this.index + 4, endI = buffer.buffer[this.index + 3];
    if (endI > startI) {
      let from = buffer.buffer[this.index + 1];
      children.push(buffer.slice(startI, endI, from));
      positions.push(0);
    }
    return new Tree(this.type, children, positions, this.to - this.from);
  }
  /**
  @internal
  */
  toString() {
    return this.context.buffer.childString(this.index);
  }
}
function iterStack(heads) {
  if (!heads.length)
    return null;
  let pick2 = 0, picked = heads[0];
  for (let i2 = 1; i2 < heads.length; i2++) {
    let node = heads[i2];
    if (node.from > picked.from || node.to < picked.to) {
      picked = node;
      pick2 = i2;
    }
  }
  let next = picked instanceof TreeNode && picked.index < 0 ? null : picked.parent;
  let newHeads = heads.slice();
  if (next)
    newHeads[pick2] = next;
  else
    newHeads.splice(pick2, 1);
  return new StackIterator(newHeads, picked);
}
class StackIterator {
  constructor(heads, node) {
    this.heads = heads;
    this.node = node;
  }
  get next() {
    return iterStack(this.heads);
  }
}
function stackIterator(tree, pos, side) {
  let inner = tree.resolveInner(pos, side), layers = null;
  for (let scan = inner instanceof TreeNode ? inner : inner.context.parent; scan; scan = scan.parent) {
    if (scan.index < 0) {
      let parent = scan.parent;
      (layers || (layers = [inner])).push(parent.resolve(pos, side));
      scan = parent;
    } else {
      let mount = MountedTree.get(scan.tree);
      if (mount && mount.overlay && mount.overlay[0].from <= pos && mount.overlay[mount.overlay.length - 1].to >= pos) {
        let root2 = new TreeNode(mount.tree, mount.overlay[0].from + scan.from, -1, scan);
        (layers || (layers = [inner])).push(resolveNode(root2, pos, side, false));
      }
    }
  }
  return layers ? iterStack(layers) : inner;
}
class TreeCursor {
  /**
  Shorthand for `.type.name`.
  */
  get name() {
    return this.type.name;
  }
  /**
  @internal
  */
  constructor(node, mode = 0) {
    this.buffer = null;
    this.stack = [];
    this.index = 0;
    this.bufferNode = null;
    this.mode = mode & ~IterMode.EnterBracketed;
    if (node instanceof TreeNode) {
      this.yieldNode(node);
    } else {
      this._tree = node.context.parent;
      this.buffer = node.context;
      for (let n2 = node._parent; n2; n2 = n2._parent)
        this.stack.unshift(n2.index);
      this.bufferNode = node;
      this.yieldBuf(node.index);
    }
  }
  yieldNode(node) {
    if (!node)
      return false;
    this._tree = node;
    this.type = node.type;
    this.from = node.from;
    this.to = node.to;
    return true;
  }
  yieldBuf(index2, type) {
    this.index = index2;
    let { start, buffer } = this.buffer;
    this.type = type || buffer.set.types[buffer.buffer[index2]];
    this.from = start + buffer.buffer[index2 + 1];
    this.to = start + buffer.buffer[index2 + 2];
    return true;
  }
  /**
  @internal
  */
  yield(node) {
    if (!node)
      return false;
    if (node instanceof TreeNode) {
      this.buffer = null;
      return this.yieldNode(node);
    }
    this.buffer = node.context;
    return this.yieldBuf(node.index, node.type);
  }
  /**
  @internal
  */
  toString() {
    return this.buffer ? this.buffer.buffer.childString(this.index) : this._tree.toString();
  }
  /**
  @internal
  */
  enterChild(dir, pos, side) {
    if (!this.buffer)
      return this.yield(this._tree.nextChild(dir < 0 ? this._tree._tree.children.length - 1 : 0, dir, pos, side, this.mode));
    let { buffer } = this.buffer;
    let index2 = buffer.findChild(this.index + 4, buffer.buffer[this.index + 3], dir, pos - this.buffer.start, side);
    if (index2 < 0)
      return false;
    this.stack.push(this.index);
    return this.yieldBuf(index2);
  }
  /**
  Move the cursor to this node's first child. When this returns
  false, the node has no child, and the cursor has not been moved.
  */
  firstChild() {
    return this.enterChild(
      1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to this node's last child.
  */
  lastChild() {
    return this.enterChild(
      -1,
      0,
      4
      /* Side.DontCare */
    );
  }
  /**
  Move the cursor to the first child that ends after `pos`.
  */
  childAfter(pos) {
    return this.enterChild(
      1,
      pos,
      2
      /* Side.After */
    );
  }
  /**
  Move to the last child that starts before `pos`.
  */
  childBefore(pos) {
    return this.enterChild(
      -1,
      pos,
      -2
      /* Side.Before */
    );
  }
  /**
  Move the cursor to the child around `pos`. If side is -1 the
  child may end at that position, when 1 it may start there. This
  will also enter [overlaid](#common.MountedTree.overlay)
  [mounted](#common.NodeProp^mounted) trees unless `overlays` is
  set to false.
  */
  enter(pos, side, mode = this.mode) {
    if (!this.buffer)
      return this.yield(this._tree.enter(pos, side, mode));
    return mode & IterMode.ExcludeBuffers ? false : this.enterChild(1, pos, side);
  }
  /**
  Move to the node's parent node, if this isn't the top node.
  */
  parent() {
    if (!this.buffer)
      return this.yieldNode(this.mode & IterMode.IncludeAnonymous ? this._tree._parent : this._tree.parent);
    if (this.stack.length)
      return this.yieldBuf(this.stack.pop());
    let parent = this.mode & IterMode.IncludeAnonymous ? this.buffer.parent : this.buffer.parent.nextSignificantParent();
    this.buffer = null;
    return this.yieldNode(parent);
  }
  /**
  @internal
  */
  sibling(dir) {
    if (!this.buffer)
      return !this._tree._parent ? false : this.yield(this._tree.index < 0 ? null : this._tree._parent.nextChild(this._tree.index + dir, dir, 0, 4, this.mode));
    let { buffer } = this.buffer, d2 = this.stack.length - 1;
    if (dir < 0) {
      let parentStart = d2 < 0 ? 0 : this.stack[d2] + 4;
      if (this.index != parentStart)
        return this.yieldBuf(buffer.findChild(
          parentStart,
          this.index,
          -1,
          0,
          4
          /* Side.DontCare */
        ));
    } else {
      let after2 = buffer.buffer[this.index + 3];
      if (after2 < (d2 < 0 ? buffer.buffer.length : buffer.buffer[this.stack[d2] + 3]))
        return this.yieldBuf(after2);
    }
    return d2 < 0 ? this.yield(this.buffer.parent.nextChild(this.buffer.index + dir, dir, 0, 4, this.mode)) : false;
  }
  /**
  Move to this node's next sibling, if any.
  */
  nextSibling() {
    return this.sibling(1);
  }
  /**
  Move to this node's previous sibling, if any.
  */
  prevSibling() {
    return this.sibling(-1);
  }
  atLastNode(dir) {
    let index2, parent, { buffer } = this;
    if (buffer) {
      if (dir > 0) {
        if (this.index < buffer.buffer.buffer.length)
          return false;
      } else {
        for (let i2 = 0; i2 < this.index; i2++)
          if (buffer.buffer.buffer[i2 + 3] < this.index)
            return false;
      }
      ({ index: index2, parent } = buffer);
    } else {
      ({ index: index2, _parent: parent } = this._tree);
    }
    for (; parent; { index: index2, _parent: parent } = parent) {
      if (index2 > -1)
        for (let i2 = index2 + dir, e2 = dir < 0 ? -1 : parent._tree.children.length; i2 != e2; i2 += dir) {
          let child = parent._tree.children[i2];
          if (this.mode & IterMode.IncludeAnonymous || child instanceof TreeBuffer || !child.type.isAnonymous || hasChild(child))
            return false;
        }
    }
    return true;
  }
  move(dir, enter) {
    if (enter && this.enterChild(
      dir,
      0,
      4
      /* Side.DontCare */
    ))
      return true;
    for (; ; ) {
      if (this.sibling(dir))
        return true;
      if (this.atLastNode(dir) || !this.parent())
        return false;
    }
  }
  /**
  Move to the next node in a
  [pre-order](https://en.wikipedia.org/wiki/Tree_traversal#Pre-order,_NLR)
  traversal, going from a node to its first child or, if the
  current node is empty or `enter` is false, its next sibling or
  the next sibling of the first parent node that has one.
  */
  next(enter = true) {
    return this.move(1, enter);
  }
  /**
  Move to the next node in a last-to-first pre-order traversal. A
  node is followed by its last child or, if it has none, its
  previous sibling or the previous sibling of the first parent
  node that has one.
  */
  prev(enter = true) {
    return this.move(-1, enter);
  }
  /**
  Move the cursor to the innermost node that covers `pos`. If
  `side` is -1, it will enter nodes that end at `pos`. If it is 1,
  it will enter nodes that start at `pos`.
  */
  moveTo(pos, side = 0) {
    while (this.from == this.to || (side < 1 ? this.from >= pos : this.from > pos) || (side > -1 ? this.to <= pos : this.to < pos))
      if (!this.parent())
        break;
    while (this.enterChild(1, pos, side)) {
    }
    return this;
  }
  /**
  Get a [syntax node](#common.SyntaxNode) at the cursor's current
  position.
  */
  get node() {
    if (!this.buffer)
      return this._tree;
    let cache = this.bufferNode, result2 = null, depth = 0;
    if (cache && cache.context == this.buffer) {
      scan: for (let index2 = this.index, d2 = this.stack.length; d2 >= 0; ) {
        for (let c2 = cache; c2; c2 = c2._parent)
          if (c2.index == index2) {
            if (index2 == this.index)
              return c2;
            result2 = c2;
            depth = d2 + 1;
            break scan;
          }
        index2 = this.stack[--d2];
      }
    }
    for (let i2 = depth; i2 < this.stack.length; i2++)
      result2 = new BufferNode(this.buffer, result2, this.stack[i2]);
    return this.bufferNode = new BufferNode(this.buffer, result2, this.index);
  }
  /**
  Get the [tree](#common.Tree) that represents the current node, if
  any. Will return null when the node is in a [tree
  buffer](#common.TreeBuffer).
  */
  get tree() {
    return this.buffer ? null : this._tree._tree;
  }
  /**
  Iterate over the current node and all its descendants, calling
  `enter` when entering a node and `leave`, if given, when leaving
  one. When `enter` returns `false`, any children of that node are
  skipped, and `leave` isn't called for it.
  */
  iterate(enter, leave) {
    for (let depth = 0; ; ) {
      let mustLeave = false;
      if (this.type.isAnonymous || enter(this) !== false) {
        if (this.firstChild()) {
          depth++;
          continue;
        }
        if (!this.type.isAnonymous)
          mustLeave = true;
      }
      for (; ; ) {
        if (mustLeave && leave)
          leave(this);
        mustLeave = this.type.isAnonymous;
        if (!depth)
          return;
        if (this.nextSibling())
          break;
        this.parent();
        depth--;
        mustLeave = true;
      }
    }
  }
  /**
  Test whether the current node matches a given context—a sequence
  of direct parent node names. Empty strings in the context array
  are treated as wildcards.
  */
  matchContext(context) {
    if (!this.buffer)
      return matchNodeContext(this.node.parent, context);
    let { buffer } = this.buffer, { types: types2 } = buffer.set;
    for (let i2 = context.length - 1, d2 = this.stack.length - 1; i2 >= 0; d2--) {
      if (d2 < 0)
        return matchNodeContext(this._tree, context, i2);
      let type = types2[buffer.buffer[this.stack[d2]]];
      if (!type.isAnonymous) {
        if (context[i2] && context[i2] != type.name)
          return false;
        i2--;
      }
    }
    return true;
  }
}
function hasChild(tree) {
  return tree.children.some((ch) => ch instanceof TreeBuffer || !ch.type.isAnonymous || hasChild(ch));
}
function buildTree(data) {
  var _a2;
  let { buffer, nodeSet, maxBufferLength = DefaultBufferLength, reused = [], minRepeatType = nodeSet.types.length } = data;
  let cursor2 = Array.isArray(buffer) ? new FlatBufferCursor(buffer, buffer.length) : buffer;
  let types2 = nodeSet.types;
  let contextHash = 0, lookAhead = 0;
  function takeNode(parentStart, minPos, children2, positions2, inRepeat, depth) {
    let { id: id2, start, end, size: size2 } = cursor2;
    let lookAheadAtStart = lookAhead, contextAtStart = contextHash;
    if (size2 < 0) {
      cursor2.next();
      if (size2 == -1) {
        let node2 = reused[id2];
        children2.push(node2);
        positions2.push(start - parentStart);
        return;
      } else if (size2 == -3) {
        contextHash = id2;
        return;
      } else if (size2 == -4) {
        lookAhead = id2;
        return;
      } else {
        throw new RangeError(`Unrecognized record size: ${size2}`);
      }
    }
    let type = types2[id2], node, buffer2;
    let startPos = start - parentStart;
    if (end - start <= maxBufferLength && (buffer2 = findBufferSize(cursor2.pos - minPos, inRepeat))) {
      let data2 = new Uint16Array(buffer2.size - buffer2.skip);
      let endPos = cursor2.pos - buffer2.size, index2 = data2.length;
      while (cursor2.pos > endPos)
        index2 = copyToBuffer(buffer2.start, data2, index2);
      node = new TreeBuffer(data2, end - buffer2.start, nodeSet);
      startPos = buffer2.start - parentStart;
    } else {
      let endPos = cursor2.pos - size2;
      cursor2.next();
      let localChildren = [], localPositions = [];
      let localInRepeat = id2 >= minRepeatType ? id2 : -1;
      let lastGroup = 0, lastEnd = end;
      while (cursor2.pos > endPos) {
        if (localInRepeat >= 0 && cursor2.id == localInRepeat && cursor2.size >= 0) {
          if (cursor2.end <= lastEnd - maxBufferLength) {
            makeRepeatLeaf(localChildren, localPositions, start, lastGroup, cursor2.end, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
            lastGroup = localChildren.length;
            lastEnd = cursor2.end;
          }
          cursor2.next();
        } else if (depth > 2500) {
          takeFlatNode(start, endPos, localChildren, localPositions);
        } else {
          takeNode(start, endPos, localChildren, localPositions, localInRepeat, depth + 1);
        }
      }
      if (localInRepeat >= 0 && lastGroup > 0 && lastGroup < localChildren.length)
        makeRepeatLeaf(localChildren, localPositions, start, lastGroup, start, lastEnd, localInRepeat, lookAheadAtStart, contextAtStart);
      localChildren.reverse();
      localPositions.reverse();
      if (localInRepeat > -1 && lastGroup > 0) {
        let make = makeBalanced(type, contextAtStart);
        node = balanceRange(type, localChildren, localPositions, 0, localChildren.length, 0, end - start, make, make);
      } else {
        node = makeTree(type, localChildren, localPositions, end - start, lookAheadAtStart - end, contextAtStart);
      }
    }
    children2.push(node);
    positions2.push(startPos);
  }
  function takeFlatNode(parentStart, minPos, children2, positions2) {
    let nodes = [];
    let nodeCount = 0, stopAt = -1;
    while (cursor2.pos > minPos) {
      let { id: id2, start, end, size: size2 } = cursor2;
      if (size2 > 4) {
        cursor2.next();
      } else if (stopAt > -1 && start < stopAt) {
        break;
      } else {
        if (stopAt < 0)
          stopAt = end - maxBufferLength;
        nodes.push(id2, start, end);
        nodeCount++;
        cursor2.next();
      }
    }
    if (nodeCount) {
      let buffer2 = new Uint16Array(nodeCount * 4);
      let start = nodes[nodes.length - 2];
      for (let i2 = nodes.length - 3, j2 = 0; i2 >= 0; i2 -= 3) {
        buffer2[j2++] = nodes[i2];
        buffer2[j2++] = nodes[i2 + 1] - start;
        buffer2[j2++] = nodes[i2 + 2] - start;
        buffer2[j2++] = j2;
      }
      children2.push(new TreeBuffer(buffer2, nodes[2] - start, nodeSet));
      positions2.push(start - parentStart);
    }
  }
  function makeBalanced(type, contextHash2) {
    return (children2, positions2, length2) => {
      let lookAhead2 = 0, lastI = children2.length - 1, last2, lookAheadProp;
      if (lastI >= 0 && (last2 = children2[lastI]) instanceof Tree) {
        if (!lastI && last2.type == type && last2.length == length2)
          return last2;
        if (lookAheadProp = last2.prop(NodeProp.lookAhead))
          lookAhead2 = positions2[lastI] + last2.length + lookAheadProp;
      }
      return makeTree(type, children2, positions2, length2, lookAhead2, contextHash2);
    };
  }
  function makeRepeatLeaf(children2, positions2, base2, i2, from, to2, type, lookAhead2, contextHash2) {
    let localChildren = [], localPositions = [];
    while (children2.length > i2) {
      localChildren.push(children2.pop());
      localPositions.push(positions2.pop() + base2 - from);
    }
    children2.push(makeTree(nodeSet.types[type], localChildren, localPositions, to2 - from, lookAhead2 - to2, contextHash2));
    positions2.push(from - base2);
  }
  function makeTree(type, children2, positions2, length2, lookAhead2, contextHash2, props2) {
    if (contextHash2) {
      let pair2 = [NodeProp.contextHash, contextHash2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    if (lookAhead2 > 25) {
      let pair2 = [NodeProp.lookAhead, lookAhead2];
      props2 = props2 ? [pair2].concat(props2) : [pair2];
    }
    return new Tree(type, children2, positions2, length2, props2);
  }
  function findBufferSize(maxSize, inRepeat) {
    let fork = cursor2.fork();
    let size2 = 0, start = 0, skip = 0, minStart = fork.end - maxBufferLength;
    let result2 = { size: 0, start: 0, skip: 0 };
    scan: for (let minPos = fork.pos - maxSize; fork.pos > minPos; ) {
      let nodeSize2 = fork.size;
      if (fork.id == inRepeat && nodeSize2 >= 0) {
        result2.size = size2;
        result2.start = start;
        result2.skip = skip;
        skip += 4;
        size2 += 4;
        fork.next();
        continue;
      }
      let startPos = fork.pos - nodeSize2;
      if (nodeSize2 < 0 || startPos < minPos || fork.start < minStart)
        break;
      let localSkipped = fork.id >= minRepeatType ? 4 : 0;
      let nodeStart2 = fork.start;
      fork.next();
      while (fork.pos > startPos) {
        if (fork.size < 0) {
          if (fork.size == -3 || fork.size == -4)
            localSkipped += 4;
          else
            break scan;
        } else if (fork.id >= minRepeatType) {
          localSkipped += 4;
        }
        fork.next();
      }
      start = nodeStart2;
      size2 += nodeSize2;
      skip += localSkipped;
    }
    if (inRepeat < 0 || size2 == maxSize) {
      result2.size = size2;
      result2.start = start;
      result2.skip = skip;
    }
    return result2.size > 4 ? result2 : void 0;
  }
  function copyToBuffer(bufferStart, buffer2, index2) {
    let { id: id2, start, end, size: size2 } = cursor2;
    cursor2.next();
    if (size2 >= 0 && id2 < minRepeatType) {
      let startIndex = index2;
      if (size2 > 4) {
        let endPos = cursor2.pos - (size2 - 4);
        while (cursor2.pos > endPos)
          index2 = copyToBuffer(bufferStart, buffer2, index2);
      }
      buffer2[--index2] = startIndex;
      buffer2[--index2] = end - bufferStart;
      buffer2[--index2] = start - bufferStart;
      buffer2[--index2] = id2;
    } else if (size2 == -3) {
      contextHash = id2;
    } else if (size2 == -4) {
      lookAhead = id2;
    }
    return index2;
  }
  let children = [], positions = [];
  while (cursor2.pos > 0)
    takeNode(data.start || 0, data.bufferStart || 0, children, positions, -1, 0);
  let length = (_a2 = data.length) !== null && _a2 !== void 0 ? _a2 : children.length ? positions[0] + children[0].length : 0;
  return new Tree(types2[data.topID], children.reverse(), positions.reverse(), length);
}
const nodeSizeCache = /* @__PURE__ */ new WeakMap();
function nodeSize(balanceType, node) {
  if (!balanceType.isAnonymous || node instanceof TreeBuffer || node.type != balanceType)
    return 1;
  let size2 = nodeSizeCache.get(node);
  if (size2 == null) {
    size2 = 1;
    for (let child of node.children) {
      if (child.type != balanceType || !(child instanceof Tree)) {
        size2 = 1;
        break;
      }
      size2 += nodeSize(balanceType, child);
    }
    nodeSizeCache.set(node, size2);
  }
  return size2;
}
function balanceRange(balanceType, children, positions, from, to2, start, length, mkTop, mkTree) {
  let total = 0;
  for (let i2 = from; i2 < to2; i2++)
    total += nodeSize(balanceType, children[i2]);
  let maxChild = Math.ceil(
    total * 1.5 / 8
    /* Balance.BranchFactor */
  );
  let localChildren = [], localPositions = [];
  function divide2(children2, positions2, from2, to22, offset2) {
    for (let i2 = from2; i2 < to22; ) {
      let groupFrom = i2, groupStart = positions2[i2], groupSize = nodeSize(balanceType, children2[i2]);
      i2++;
      for (; i2 < to22; i2++) {
        let nextSize = nodeSize(balanceType, children2[i2]);
        if (groupSize + nextSize >= maxChild)
          break;
        groupSize += nextSize;
      }
      if (i2 == groupFrom + 1) {
        if (groupSize > maxChild) {
          let only = children2[groupFrom];
          divide2(only.children, only.positions, 0, only.children.length, positions2[groupFrom] + offset2);
          continue;
        }
        localChildren.push(children2[groupFrom]);
      } else {
        let length2 = positions2[i2 - 1] + children2[i2 - 1].length - groupStart;
        localChildren.push(balanceRange(balanceType, children2, positions2, groupFrom, i2, groupStart, length2, null, mkTree));
      }
      localPositions.push(groupStart + offset2 - start);
    }
  }
  divide2(children, positions, from, to2, 0);
  return (mkTop || mkTree)(localChildren, localPositions, length);
}
class Parser {
  /**
  Start a parse, returning a [partial parse](#common.PartialParse)
  object. [`fragments`](#common.TreeFragment) can be passed in to
  make the parse incremental.
  
  By default, the entire input is parsed. You can pass `ranges`,
  which should be a sorted array of non-empty, non-overlapping
  ranges, to parse only those ranges. The tree returned in that
  case will start at `ranges[0].from`.
  */
  startParse(input, fragments, ranges) {
    if (typeof input == "string")
      input = new StringInput(input);
    ranges = !ranges ? [new Range$1(0, input.length)] : ranges.length ? ranges.map((r2) => new Range$1(r2.from, r2.to)) : [new Range$1(0, 0)];
    return this.createParse(input, fragments || [], ranges);
  }
  /**
  Run a full parse, returning the resulting tree.
  */
  parse(input, fragments, ranges) {
    let parse2 = this.startParse(input, fragments, ranges);
    for (; ; ) {
      let done = parse2.advance();
      if (done)
        return done;
    }
  }
}
class StringInput {
  constructor(string2) {
    this.string = string2;
  }
  get length() {
    return this.string.length;
  }
  chunk(from) {
    return this.string.slice(from);
  }
  get lineChunks() {
    return false;
  }
  read(from, to2) {
    return this.string.slice(from, to2);
  }
}
new NodeProp({ perNode: true });
class Stack {
  /**
  @internal
  */
  constructor(p2, stack, state, reducePos, pos, score2, buffer, bufferBase, curContext, lookAhead = 0, parent) {
    this.p = p2;
    this.stack = stack;
    this.state = state;
    this.reducePos = reducePos;
    this.pos = pos;
    this.score = score2;
    this.buffer = buffer;
    this.bufferBase = bufferBase;
    this.curContext = curContext;
    this.lookAhead = lookAhead;
    this.parent = parent;
  }
  /**
  @internal
  */
  toString() {
    return `[${this.stack.filter((_2, i2) => i2 % 3 == 0).concat(this.state)}]@${this.pos}${this.score ? "!" + this.score : ""}`;
  }
  // Start an empty stack
  /**
  @internal
  */
  static start(p2, state, pos = 0) {
    let cx = p2.parser.context;
    return new Stack(p2, [], state, pos, pos, 0, [], 0, cx ? new StackContext(cx, cx.start) : null, 0, null);
  }
  /**
  The stack's current [context](#lr.ContextTracker) value, if
  any. Its type will depend on the context tracker's type
  parameter, or it will be `null` if there is no context
  tracker.
  */
  get context() {
    return this.curContext ? this.curContext.context : null;
  }
  // Push a state onto the stack, tracking its start position as well
  // as the buffer base at that point.
  /**
  @internal
  */
  pushState(state, start) {
    this.stack.push(this.state, start, this.bufferBase + this.buffer.length);
    this.state = state;
  }
  // Apply a reduce action
  /**
  @internal
  */
  reduce(action) {
    var _a2;
    let depth = action >> 19, type = action & 65535;
    let { parser: parser2 } = this.p;
    let lookaheadRecord = this.reducePos < this.pos - 25 && this.setLookAhead(this.pos);
    let dPrec = parser2.dynamicPrecedence(type);
    if (dPrec)
      this.score += dPrec;
    if (depth == 0) {
      if (type < parser2.minRepeatTerm && this.reducePos < this.pos)
        this.reducePos = this.pos;
      this.pushState(parser2.getGoto(this.state, type, true), this.reducePos);
      if (type < parser2.minRepeatTerm)
        this.storeNode(type, this.reducePos, this.reducePos, lookaheadRecord ? 8 : 4, true);
      this.reduceContext(type, this.reducePos);
      return;
    }
    let base2 = this.stack.length - (depth - 1) * 3 - (action & 262144 ? 6 : 0);
    let start = base2 ? this.stack[base2 - 2] : this.p.ranges[0].from;
    if (type < parser2.minRepeatTerm && start == this.reducePos && this.reducePos < this.pos)
      this.reducePos = this.pos;
    let size2 = this.reducePos - start;
    if (size2 >= 2e3 && !((_a2 = this.p.parser.nodeSet.types[type]) === null || _a2 === void 0 ? void 0 : _a2.isAnonymous)) {
      if (start == this.p.lastBigReductionStart) {
        this.p.bigReductionCount++;
        this.p.lastBigReductionSize = size2;
      } else if (this.p.lastBigReductionSize < size2) {
        this.p.bigReductionCount = 1;
        this.p.lastBigReductionStart = start;
        this.p.lastBigReductionSize = size2;
      }
    }
    let bufferBase = base2 ? this.stack[base2 - 1] : 0, count = this.bufferBase + this.buffer.length - bufferBase;
    if (type < parser2.minRepeatTerm || action & 131072) {
      let pos = parser2.stateFlag(
        this.state,
        1
        /* StateFlag.Skipped */
      ) ? this.pos : this.reducePos;
      this.storeNode(type, start, pos, count + 4, true);
    }
    if (action & 262144) {
      this.state = this.stack[base2];
    } else {
      let baseStateID = this.stack[base2 - 3];
      this.state = parser2.getGoto(baseStateID, type, true);
    }
    while (this.stack.length > base2)
      this.stack.pop();
    this.reduceContext(type, start);
  }
  // Shift a value into the buffer
  /**
  @internal
  */
  storeNode(term, start, end, size2 = 4, mustSink = false) {
    if (term == 0 && (!this.stack.length || this.stack[this.stack.length - 1] < this.buffer.length + this.bufferBase)) {
      let top2 = this.buffer.length;
      if (top2 > 0 && this.buffer[top2 - 4] == 0 && this.buffer[top2 - 1] > -1) {
        if (start == end)
          return;
        if (this.buffer[top2 - 2] >= start) {
          this.buffer[top2 - 2] = end;
          return;
        }
      }
    }
    if (!mustSink || this.pos == end) {
      this.buffer.push(term, start, end, size2);
    } else {
      let index2 = this.buffer.length;
      if (index2 > 0 && (this.buffer[index2 - 4] != 0 || this.buffer[index2 - 1] < 0)) {
        let mustMove = false;
        for (let scan = index2; scan > 0 && this.buffer[scan - 2] > end; scan -= 4) {
          if (this.buffer[scan - 1] >= 0) {
            mustMove = true;
            break;
          }
        }
        if (mustMove)
          while (index2 > 0 && this.buffer[index2 - 2] > end) {
            this.buffer[index2] = this.buffer[index2 - 4];
            this.buffer[index2 + 1] = this.buffer[index2 - 3];
            this.buffer[index2 + 2] = this.buffer[index2 - 2];
            this.buffer[index2 + 3] = this.buffer[index2 - 1];
            index2 -= 4;
            if (size2 > 4)
              size2 -= 4;
          }
      }
      this.buffer[index2] = term;
      this.buffer[index2 + 1] = start;
      this.buffer[index2 + 2] = end;
      this.buffer[index2 + 3] = size2;
    }
  }
  // Apply a shift action
  /**
  @internal
  */
  shift(action, type, start, end) {
    if (action & 131072) {
      this.pushState(action & 65535, this.pos);
    } else if ((action & 262144) == 0) {
      let nextState = action, { parser: parser2 } = this.p;
      this.pos = end;
      let skipped = parser2.stateFlag(
        nextState,
        1
        /* StateFlag.Skipped */
      );
      if (!skipped && (end > start || type <= parser2.maxNode))
        this.reducePos = end;
      this.pushState(nextState, skipped ? start : Math.min(start, this.reducePos));
      this.shiftContext(type, start);
      if (type <= parser2.maxNode)
        this.buffer.push(type, start, end, 4);
    } else {
      this.pos = end;
      this.shiftContext(type, start);
      if (type <= this.p.parser.maxNode)
        this.buffer.push(type, start, end, 4);
    }
  }
  // Apply an action
  /**
  @internal
  */
  apply(action, next, nextStart, nextEnd) {
    if (action & 65536)
      this.reduce(action);
    else
      this.shift(action, next, nextStart, nextEnd);
  }
  // Add a prebuilt (reused) node into the buffer.
  /**
  @internal
  */
  useNode(value, next) {
    let index2 = this.p.reused.length - 1;
    if (index2 < 0 || this.p.reused[index2] != value) {
      this.p.reused.push(value);
      index2++;
    }
    let start = this.pos;
    this.reducePos = this.pos = start + value.length;
    this.pushState(next, start);
    this.buffer.push(
      index2,
      start,
      this.reducePos,
      -1
      /* size == -1 means this is a reused value */
    );
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reuse(this.curContext.context, value, this, this.p.stream.reset(this.pos - value.length)));
  }
  // Split the stack. Due to the buffer sharing and the fact
  // that `this.stack` tends to stay quite shallow, this isn't very
  // expensive.
  /**
  @internal
  */
  split() {
    let parent = this;
    let off = parent.buffer.length;
    if (off && parent.buffer[off - 4] == 0)
      off -= 4;
    while (off > 0 && parent.buffer[off - 2] > parent.reducePos)
      off -= 4;
    let buffer = parent.buffer.slice(off), base2 = parent.bufferBase + off;
    while (parent && base2 == parent.bufferBase)
      parent = parent.parent;
    return new Stack(this.p, this.stack.slice(), this.state, this.reducePos, this.pos, this.score, buffer, base2, this.curContext, this.lookAhead, parent);
  }
  // Try to recover from an error by 'deleting' (ignoring) one token.
  /**
  @internal
  */
  recoverByDelete(next, nextEnd) {
    let isNode2 = next <= this.p.parser.maxNode;
    if (isNode2)
      this.storeNode(next, this.pos, nextEnd, 4);
    this.storeNode(0, this.pos, nextEnd, isNode2 ? 8 : 4);
    this.pos = this.reducePos = nextEnd;
    this.score -= 190;
  }
  /**
  Check if the given term would be able to be shifted (optionally
  after some reductions) on this stack. This can be useful for
  external tokenizers that want to make sure they only provide a
  given token when it applies.
  */
  canShift(term) {
    for (let sim = new SimulatedStack(this); ; ) {
      let action = this.p.parser.stateSlot(
        sim.state,
        4
        /* ParseState.DefaultReduce */
      ) || this.p.parser.hasAction(sim.state, term);
      if (action == 0)
        return false;
      if ((action & 65536) == 0)
        return true;
      sim.reduce(action);
    }
  }
  // Apply up to Recover.MaxNext recovery actions that conceptually
  // inserts some missing token or rule.
  /**
  @internal
  */
  recoverByInsert(next) {
    if (this.stack.length >= 300)
      return [];
    let nextStates = this.p.parser.nextStates(this.state);
    if (nextStates.length > 4 << 1 || this.stack.length >= 120) {
      let best = [];
      for (let i2 = 0, s2; i2 < nextStates.length; i2 += 2) {
        if ((s2 = nextStates[i2 + 1]) != this.state && this.p.parser.hasAction(s2, next))
          best.push(nextStates[i2], s2);
      }
      if (this.stack.length < 120)
        for (let i2 = 0; best.length < 4 << 1 && i2 < nextStates.length; i2 += 2) {
          let s2 = nextStates[i2 + 1];
          if (!best.some((v2, i22) => i22 & 1 && v2 == s2))
            best.push(nextStates[i2], s2);
        }
      nextStates = best;
    }
    let result2 = [];
    for (let i2 = 0; i2 < nextStates.length && result2.length < 4; i2 += 2) {
      let s2 = nextStates[i2 + 1];
      if (s2 == this.state)
        continue;
      let stack = this.split();
      stack.pushState(s2, this.pos);
      stack.storeNode(0, stack.pos, stack.pos, 4, true);
      stack.shiftContext(nextStates[i2], this.pos);
      stack.reducePos = this.pos;
      stack.score -= 200;
      result2.push(stack);
    }
    return result2;
  }
  // Force a reduce, if possible. Return false if that can't
  // be done.
  /**
  @internal
  */
  forceReduce() {
    let { parser: parser2 } = this.p;
    let reduce2 = parser2.stateSlot(
      this.state,
      5
      /* ParseState.ForcedReduce */
    );
    if ((reduce2 & 65536) == 0)
      return false;
    if (!parser2.validAction(this.state, reduce2)) {
      let depth = reduce2 >> 19, term = reduce2 & 65535;
      let target = this.stack.length - depth * 3;
      if (target < 0 || parser2.getGoto(this.stack[target], term, false) < 0) {
        let backup = this.findForcedReduction();
        if (backup == null)
          return false;
        reduce2 = backup;
      }
      this.storeNode(0, this.pos, this.pos, 4, true);
      this.score -= 100;
    }
    this.reducePos = this.pos;
    this.reduce(reduce2);
    return true;
  }
  /**
  Try to scan through the automaton to find some kind of reduction
  that can be applied. Used when the regular ForcedReduce field
  isn't a valid action. @internal
  */
  findForcedReduction() {
    let { parser: parser2 } = this.p, seen = [];
    let explore = (state, depth) => {
      if (seen.includes(state))
        return;
      seen.push(state);
      return parser2.allActions(state, (action) => {
        if (action & (262144 | 131072)) ;
        else if (action & 65536) {
          let rDepth = (action >> 19) - depth;
          if (rDepth > 1) {
            let term = action & 65535, target = this.stack.length - rDepth * 3;
            if (target >= 0 && parser2.getGoto(this.stack[target], term, false) >= 0)
              return rDepth << 19 | 65536 | term;
          }
        } else {
          let found = explore(action, depth + 1);
          if (found != null)
            return found;
        }
      });
    };
    return explore(this.state, 0);
  }
  /**
  @internal
  */
  forceAll() {
    while (!this.p.parser.stateFlag(
      this.state,
      2
      /* StateFlag.Accepting */
    )) {
      if (!this.forceReduce()) {
        this.storeNode(0, this.pos, this.pos, 4, true);
        break;
      }
    }
    return this;
  }
  /**
  Check whether this state has no further actions (assumed to be a direct descendant of the
  top state, since any other states must be able to continue
  somehow). @internal
  */
  get deadEnd() {
    if (this.stack.length != 3)
      return false;
    let { parser: parser2 } = this.p;
    return parser2.data[parser2.stateSlot(
      this.state,
      1
      /* ParseState.Actions */
    )] == 65535 && !parser2.stateSlot(
      this.state,
      4
      /* ParseState.DefaultReduce */
    );
  }
  /**
  Restart the stack (put it back in its start state). Only safe
  when this.stack.length == 3 (state is directly below the top
  state). @internal
  */
  restart() {
    this.storeNode(0, this.pos, this.pos, 4, true);
    this.state = this.stack[0];
    this.stack.length = 0;
  }
  /**
  @internal
  */
  sameState(other) {
    if (this.state != other.state || this.stack.length != other.stack.length)
      return false;
    for (let i2 = 0; i2 < this.stack.length; i2 += 3)
      if (this.stack[i2] != other.stack[i2])
        return false;
    return true;
  }
  /**
  Get the parser used by this stack.
  */
  get parser() {
    return this.p.parser;
  }
  /**
  Test whether a given dialect (by numeric ID, as exported from
  the terms file) is enabled.
  */
  dialectEnabled(dialectID) {
    return this.p.parser.dialect.flags[dialectID];
  }
  shiftContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.shift(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  reduceContext(term, start) {
    if (this.curContext)
      this.updateContext(this.curContext.tracker.reduce(this.curContext.context, term, this, this.p.stream.reset(start)));
  }
  /**
  @internal
  */
  emitContext() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -3)
      this.buffer.push(this.curContext.hash, this.pos, this.pos, -3);
  }
  /**
  @internal
  */
  emitLookAhead() {
    let last2 = this.buffer.length - 1;
    if (last2 < 0 || this.buffer[last2] != -4)
      this.buffer.push(this.lookAhead, this.pos, this.pos, -4);
  }
  updateContext(context) {
    if (context != this.curContext.context) {
      let newCx = new StackContext(this.curContext.tracker, context);
      if (newCx.hash != this.curContext.hash)
        this.emitContext();
      this.curContext = newCx;
    }
  }
  /**
  @internal
  */
  setLookAhead(lookAhead) {
    if (lookAhead <= this.lookAhead)
      return false;
    this.emitLookAhead();
    this.lookAhead = lookAhead;
    return true;
  }
  /**
  @internal
  */
  close() {
    if (this.curContext && this.curContext.tracker.strict)
      this.emitContext();
    if (this.lookAhead > 0)
      this.emitLookAhead();
  }
}
class StackContext {
  constructor(tracker, context) {
    this.tracker = tracker;
    this.context = context;
    this.hash = tracker.strict ? tracker.hash(context) : 0;
  }
}
class SimulatedStack {
  constructor(start) {
    this.start = start;
    this.state = start.state;
    this.stack = start.stack;
    this.base = this.stack.length;
  }
  reduce(action) {
    let term = action & 65535, depth = action >> 19;
    if (depth == 0) {
      if (this.stack == this.start.stack)
        this.stack = this.stack.slice();
      this.stack.push(this.state, 0, 0);
      this.base += 3;
    } else {
      this.base -= (depth - 1) * 3;
    }
    let goto = this.start.p.parser.getGoto(this.stack[this.base - 3], term, true);
    this.state = goto;
  }
}
class StackBufferCursor {
  constructor(stack, pos, index2) {
    this.stack = stack;
    this.pos = pos;
    this.index = index2;
    this.buffer = stack.buffer;
    if (this.index == 0)
      this.maybeNext();
  }
  static create(stack, pos = stack.bufferBase + stack.buffer.length) {
    return new StackBufferCursor(stack, pos, pos - stack.bufferBase);
  }
  maybeNext() {
    let next = this.stack.parent;
    if (next != null) {
      this.index = this.stack.bufferBase - next.bufferBase;
      this.stack = next;
      this.buffer = next.buffer;
    }
  }
  get id() {
    return this.buffer[this.index - 4];
  }
  get start() {
    return this.buffer[this.index - 3];
  }
  get end() {
    return this.buffer[this.index - 2];
  }
  get size() {
    return this.buffer[this.index - 1];
  }
  next() {
    this.index -= 4;
    this.pos -= 4;
    if (this.index == 0)
      this.maybeNext();
  }
  fork() {
    return new StackBufferCursor(this.stack, this.pos, this.index);
  }
}
function decodeArray(input, Type = Uint16Array) {
  if (typeof input != "string")
    return input;
  let array = null;
  for (let pos = 0, out = 0; pos < input.length; ) {
    let value = 0;
    for (; ; ) {
      let next = input.charCodeAt(pos++), stop = false;
      if (next == 126) {
        value = 65535;
        break;
      }
      if (next >= 92)
        next--;
      if (next >= 34)
        next--;
      let digit = next - 32;
      if (digit >= 46) {
        digit -= 46;
        stop = true;
      }
      value += digit;
      if (stop)
        break;
      value *= 46;
    }
    if (array)
      array[out++] = value;
    else
      array = new Type(value);
  }
  return array;
}
class CachedToken {
  constructor() {
    this.start = -1;
    this.value = -1;
    this.end = -1;
    this.extended = -1;
    this.lookAhead = 0;
    this.mask = 0;
    this.context = 0;
  }
}
const nullToken = new CachedToken();
class InputStream {
  /**
  @internal
  */
  constructor(input, ranges) {
    this.input = input;
    this.ranges = ranges;
    this.chunk = "";
    this.chunkOff = 0;
    this.chunk2 = "";
    this.chunk2Pos = 0;
    this.next = -1;
    this.token = nullToken;
    this.rangeIndex = 0;
    this.pos = this.chunkPos = ranges[0].from;
    this.range = ranges[0];
    this.end = ranges[ranges.length - 1].to;
    this.readNext();
  }
  /**
  @internal
  */
  resolveOffset(offset2, assoc) {
    let range2 = this.range, index2 = this.rangeIndex;
    let pos = this.pos + offset2;
    while (pos < range2.from) {
      if (!index2)
        return null;
      let next = this.ranges[--index2];
      pos -= range2.from - next.to;
      range2 = next;
    }
    while (assoc < 0 ? pos > range2.to : pos >= range2.to) {
      if (index2 == this.ranges.length - 1)
        return null;
      let next = this.ranges[++index2];
      pos += next.from - range2.to;
      range2 = next;
    }
    return pos;
  }
  /**
  @internal
  */
  clipPos(pos) {
    if (pos >= this.range.from && pos < this.range.to)
      return pos;
    for (let range2 of this.ranges)
      if (range2.to > pos)
        return Math.max(pos, range2.from);
    return this.end;
  }
  /**
  Look at a code unit near the stream position. `.peek(0)` equals
  `.next`, `.peek(-1)` gives you the previous character, and so
  on.
  
  Note that looking around during tokenizing creates dependencies
  on potentially far-away content, which may reduce the
  effectiveness incremental parsing—when looking forward—or even
  cause invalid reparses when looking backward more than 25 code
  units, since the library does not track lookbehind.
  */
  peek(offset2) {
    let idx = this.chunkOff + offset2, pos, result2;
    if (idx >= 0 && idx < this.chunk.length) {
      pos = this.pos + offset2;
      result2 = this.chunk.charCodeAt(idx);
    } else {
      let resolved = this.resolveOffset(offset2, 1);
      if (resolved == null)
        return -1;
      pos = resolved;
      if (pos >= this.chunk2Pos && pos < this.chunk2Pos + this.chunk2.length) {
        result2 = this.chunk2.charCodeAt(pos - this.chunk2Pos);
      } else {
        let i2 = this.rangeIndex, range2 = this.range;
        while (range2.to <= pos)
          range2 = this.ranges[++i2];
        this.chunk2 = this.input.chunk(this.chunk2Pos = pos);
        if (pos + this.chunk2.length > range2.to)
          this.chunk2 = this.chunk2.slice(0, range2.to - pos);
        result2 = this.chunk2.charCodeAt(0);
      }
    }
    if (pos >= this.token.lookAhead)
      this.token.lookAhead = pos + 1;
    return result2;
  }
  /**
  Accept a token. By default, the end of the token is set to the
  current stream position, but you can pass an offset (relative to
  the stream position) to change that.
  */
  acceptToken(token, endOffset = 0) {
    let end = endOffset ? this.resolveOffset(endOffset, -1) : this.pos;
    if (end == null || end < this.token.start)
      throw new RangeError("Token end out of bounds");
    this.token.value = token;
    this.token.end = end;
  }
  /**
  Accept a token ending at a specific given position.
  */
  acceptTokenTo(token, endPos) {
    this.token.value = token;
    this.token.end = endPos;
  }
  getChunk() {
    if (this.pos >= this.chunk2Pos && this.pos < this.chunk2Pos + this.chunk2.length) {
      let { chunk: chunk2, chunkPos } = this;
      this.chunk = this.chunk2;
      this.chunkPos = this.chunk2Pos;
      this.chunk2 = chunk2;
      this.chunk2Pos = chunkPos;
      this.chunkOff = this.pos - this.chunkPos;
    } else {
      this.chunk2 = this.chunk;
      this.chunk2Pos = this.chunkPos;
      let nextChunk = this.input.chunk(this.pos);
      let end = this.pos + nextChunk.length;
      this.chunk = end > this.range.to ? nextChunk.slice(0, this.range.to - this.pos) : nextChunk;
      this.chunkPos = this.pos;
      this.chunkOff = 0;
    }
  }
  readNext() {
    if (this.chunkOff >= this.chunk.length) {
      this.getChunk();
      if (this.chunkOff == this.chunk.length)
        return this.next = -1;
    }
    return this.next = this.chunk.charCodeAt(this.chunkOff);
  }
  /**
  Move the stream forward N (defaults to 1) code units. Returns
  the new value of [`next`](#lr.InputStream.next).
  */
  advance(n2 = 1) {
    this.chunkOff += n2;
    while (this.pos + n2 >= this.range.to) {
      if (this.rangeIndex == this.ranges.length - 1)
        return this.setDone();
      n2 -= this.range.to - this.pos;
      this.range = this.ranges[++this.rangeIndex];
      this.pos = this.range.from;
    }
    this.pos += n2;
    if (this.pos >= this.token.lookAhead)
      this.token.lookAhead = this.pos + 1;
    return this.readNext();
  }
  setDone() {
    this.pos = this.chunkPos = this.end;
    this.range = this.ranges[this.rangeIndex = this.ranges.length - 1];
    this.chunk = "";
    return this.next = -1;
  }
  /**
  @internal
  */
  reset(pos, token) {
    if (token) {
      this.token = token;
      token.start = pos;
      token.lookAhead = pos + 1;
      token.value = token.extended = -1;
    } else {
      this.token = nullToken;
    }
    if (this.pos != pos) {
      this.pos = pos;
      if (pos == this.end) {
        this.setDone();
        return this;
      }
      while (pos < this.range.from)
        this.range = this.ranges[--this.rangeIndex];
      while (pos >= this.range.to)
        this.range = this.ranges[++this.rangeIndex];
      if (pos >= this.chunkPos && pos < this.chunkPos + this.chunk.length) {
        this.chunkOff = pos - this.chunkPos;
      } else {
        this.chunk = "";
        this.chunkOff = 0;
      }
      this.readNext();
    }
    return this;
  }
  /**
  @internal
  */
  read(from, to2) {
    if (from >= this.chunkPos && to2 <= this.chunkPos + this.chunk.length)
      return this.chunk.slice(from - this.chunkPos, to2 - this.chunkPos);
    if (from >= this.chunk2Pos && to2 <= this.chunk2Pos + this.chunk2.length)
      return this.chunk2.slice(from - this.chunk2Pos, to2 - this.chunk2Pos);
    if (from >= this.range.from && to2 <= this.range.to)
      return this.input.read(from, to2);
    let result2 = "";
    for (let r2 of this.ranges) {
      if (r2.from >= to2)
        break;
      if (r2.to > from)
        result2 += this.input.read(Math.max(r2.from, from), Math.min(r2.to, to2));
    }
    return result2;
  }
}
class TokenGroup {
  constructor(data, id2) {
    this.data = data;
    this.id = id2;
  }
  token(input, stack) {
    let { parser: parser2 } = stack.p;
    readToken(this.data, input, stack, this.id, parser2.data, parser2.tokenPrecTable);
  }
}
TokenGroup.prototype.contextual = TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
TokenGroup.prototype.fallback = TokenGroup.prototype.extend = false;
class ExternalTokenizer {
  /**
  Create a tokenizer. The first argument is the function that,
  given an input stream, scans for the types of tokens it
  recognizes at the stream's position, and calls
  [`acceptToken`](#lr.InputStream.acceptToken) when it finds
  one.
  */
  constructor(token, options2 = {}) {
    this.token = token;
    this.contextual = !!options2.contextual;
    this.fallback = !!options2.fallback;
    this.extend = !!options2.extend;
  }
}
function readToken(data, input, stack, group2, precTable, precOffset) {
  let state = 0, groupMask = 1 << group2, { dialect } = stack.p.parser;
  scan: for (; ; ) {
    if ((groupMask & data[state]) == 0)
      break;
    let accEnd = data[state + 1];
    for (let i2 = state + 3; i2 < accEnd; i2 += 2)
      if ((data[i2 + 1] & groupMask) > 0) {
        let term = data[i2];
        if (dialect.allows(term) && (input.token.value == -1 || input.token.value == term || overrides(term, input.token.value, precTable, precOffset))) {
          input.acceptToken(term);
          break;
        }
      }
    let next = input.next, low = 0, high = data[state + 2];
    if (input.next < 0 && high > low && data[accEnd + high * 3 - 3] == 65535) {
      state = data[accEnd + high * 3 - 1];
      continue scan;
    }
    for (; low < high; ) {
      let mid = low + high >> 1;
      let index2 = accEnd + mid + (mid << 1);
      let from = data[index2], to2 = data[index2 + 1] || 65536;
      if (next < from)
        high = mid;
      else if (next >= to2)
        low = mid + 1;
      else {
        state = data[index2 + 2];
        input.advance();
        continue scan;
      }
    }
    break;
  }
}
function findOffset(data, start, term) {
  for (let i2 = start, next; (next = data[i2]) != 65535; i2++)
    if (next == term)
      return i2 - start;
  return -1;
}
function overrides(token, prev, tableData, tableOffset) {
  let iPrev = findOffset(tableData, tableOffset, prev);
  return iPrev < 0 || findOffset(tableData, tableOffset, token) < iPrev;
}
const verbose = typeof process != "undefined" && process.env && /\bparse\b/.test(process.env.LOG);
let stackIDs = null;
function cutAt(tree, pos, side) {
  let cursor2 = tree.cursor(IterMode.IncludeAnonymous);
  cursor2.moveTo(pos);
  for (; ; ) {
    if (!(side < 0 ? cursor2.childBefore(pos) : cursor2.childAfter(pos)))
      for (; ; ) {
        if ((side < 0 ? cursor2.to < pos : cursor2.from > pos) && !cursor2.type.isError)
          return side < 0 ? Math.max(0, Math.min(
            cursor2.to - 1,
            pos - 25
            /* Lookahead.Margin */
          )) : Math.min(tree.length, Math.max(
            cursor2.from + 1,
            pos + 25
            /* Lookahead.Margin */
          ));
        if (side < 0 ? cursor2.prevSibling() : cursor2.nextSibling())
          break;
        if (!cursor2.parent())
          return side < 0 ? 0 : tree.length;
      }
  }
}
class FragmentCursor {
  constructor(fragments, nodeSet) {
    this.fragments = fragments;
    this.nodeSet = nodeSet;
    this.i = 0;
    this.fragment = null;
    this.safeFrom = -1;
    this.safeTo = -1;
    this.trees = [];
    this.start = [];
    this.index = [];
    this.nextFragment();
  }
  nextFragment() {
    let fr2 = this.fragment = this.i == this.fragments.length ? null : this.fragments[this.i++];
    if (fr2) {
      this.safeFrom = fr2.openStart ? cutAt(fr2.tree, fr2.from + fr2.offset, 1) - fr2.offset : fr2.from;
      this.safeTo = fr2.openEnd ? cutAt(fr2.tree, fr2.to + fr2.offset, -1) - fr2.offset : fr2.to;
      while (this.trees.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
      }
      this.trees.push(fr2.tree);
      this.start.push(-fr2.offset);
      this.index.push(0);
      this.nextStart = this.safeFrom;
    } else {
      this.nextStart = 1e9;
    }
  }
  // `pos` must be >= any previously given `pos` for this cursor
  nodeAt(pos) {
    if (pos < this.nextStart)
      return null;
    while (this.fragment && this.safeTo <= pos)
      this.nextFragment();
    if (!this.fragment)
      return null;
    for (; ; ) {
      let last2 = this.trees.length - 1;
      if (last2 < 0) {
        this.nextFragment();
        return null;
      }
      let top2 = this.trees[last2], index2 = this.index[last2];
      if (index2 == top2.children.length) {
        this.trees.pop();
        this.start.pop();
        this.index.pop();
        continue;
      }
      let next = top2.children[index2];
      let start = this.start[last2] + top2.positions[index2];
      if (start > pos) {
        this.nextStart = start;
        return null;
      }
      if (next instanceof Tree) {
        if (start == pos) {
          if (start < this.safeFrom)
            return null;
          let end = start + next.length;
          if (end <= this.safeTo) {
            let lookAhead = next.prop(NodeProp.lookAhead);
            if (!lookAhead || end + lookAhead < this.fragment.to)
              return next;
          }
        }
        this.index[last2]++;
        if (start + next.length >= Math.max(this.safeFrom, pos)) {
          this.trees.push(next);
          this.start.push(start);
          this.index.push(0);
        }
      } else {
        this.index[last2]++;
        this.nextStart = start + next.length;
      }
    }
  }
}
class TokenCache {
  constructor(parser2, stream) {
    this.stream = stream;
    this.tokens = [];
    this.mainToken = null;
    this.actions = [];
    this.tokens = parser2.tokenizers.map((_2) => new CachedToken());
  }
  getActions(stack) {
    let actionIndex = 0;
    let main2 = null;
    let { parser: parser2 } = stack.p, { tokenizers } = parser2;
    let mask = parser2.stateSlot(
      stack.state,
      3
      /* ParseState.TokenizerMask */
    );
    let context = stack.curContext ? stack.curContext.hash : 0;
    let lookAhead = 0;
    for (let i2 = 0; i2 < tokenizers.length; i2++) {
      if ((1 << i2 & mask) == 0)
        continue;
      let tokenizer = tokenizers[i2], token = this.tokens[i2];
      if (main2 && !tokenizer.fallback)
        continue;
      if (tokenizer.contextual || token.start != stack.pos || token.mask != mask || token.context != context) {
        this.updateCachedToken(token, tokenizer, stack);
        token.mask = mask;
        token.context = context;
      }
      if (token.lookAhead > token.end + 25)
        lookAhead = Math.max(token.lookAhead, lookAhead);
      if (token.value != 0) {
        let startIndex = actionIndex;
        if (token.extended > -1)
          actionIndex = this.addActions(stack, token.extended, token.end, actionIndex);
        actionIndex = this.addActions(stack, token.value, token.end, actionIndex);
        if (!tokenizer.extend) {
          main2 = token;
          if (actionIndex > startIndex)
            break;
        }
      }
    }
    while (this.actions.length > actionIndex)
      this.actions.pop();
    if (lookAhead)
      stack.setLookAhead(lookAhead);
    if (!main2 && stack.pos == this.stream.end) {
      main2 = new CachedToken();
      main2.value = stack.p.parser.eofTerm;
      main2.start = main2.end = stack.pos;
      actionIndex = this.addActions(stack, main2.value, main2.end, actionIndex);
    }
    this.mainToken = main2;
    return this.actions;
  }
  getMainToken(stack) {
    if (this.mainToken)
      return this.mainToken;
    let main2 = new CachedToken(), { pos, p: p2 } = stack;
    main2.start = pos;
    main2.end = Math.min(pos + 1, p2.stream.end);
    main2.value = pos == p2.stream.end ? p2.parser.eofTerm : 0;
    return main2;
  }
  updateCachedToken(token, tokenizer, stack) {
    let start = this.stream.clipPos(stack.pos);
    tokenizer.token(this.stream.reset(start, token), stack);
    if (token.value > -1) {
      let { parser: parser2 } = stack.p;
      for (let i2 = 0; i2 < parser2.specialized.length; i2++)
        if (parser2.specialized[i2] == token.value) {
          let result2 = parser2.specializers[i2](this.stream.read(token.start, token.end), stack);
          if (result2 >= 0 && stack.p.parser.dialect.allows(result2 >> 1)) {
            if ((result2 & 1) == 0)
              token.value = result2 >> 1;
            else
              token.extended = result2 >> 1;
            break;
          }
        }
    } else {
      token.value = 0;
      token.end = this.stream.clipPos(start + 1);
    }
  }
  putAction(action, token, end, index2) {
    for (let i2 = 0; i2 < index2; i2 += 3)
      if (this.actions[i2] == action)
        return index2;
    this.actions[index2++] = action;
    this.actions[index2++] = token;
    this.actions[index2++] = end;
    return index2;
  }
  addActions(stack, token, end, index2) {
    let { state } = stack, { parser: parser2 } = stack.p, { data } = parser2;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = parser2.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ); ; i2 += 3) {
        if (data[i2] == 65535) {
          if (data[i2 + 1] == 1) {
            i2 = pair(data, i2 + 2);
          } else {
            if (index2 == 0 && data[i2 + 1] == 2)
              index2 = this.putAction(pair(data, i2 + 2), token, end, index2);
            break;
          }
        }
        if (data[i2] == token)
          index2 = this.putAction(pair(data, i2 + 1), token, end, index2);
      }
    }
    return index2;
  }
}
class Parse {
  constructor(parser2, input, fragments, ranges) {
    this.parser = parser2;
    this.input = input;
    this.ranges = ranges;
    this.recovering = 0;
    this.nextStackID = 9812;
    this.minStackPos = 0;
    this.reused = [];
    this.stoppedAt = null;
    this.lastBigReductionStart = -1;
    this.lastBigReductionSize = 0;
    this.bigReductionCount = 0;
    this.stream = new InputStream(input, ranges);
    this.tokens = new TokenCache(parser2, this.stream);
    this.topTerm = parser2.top[1];
    let { from } = ranges[0];
    this.stacks = [Stack.start(this, parser2.top[0], from)];
    this.fragments = fragments.length && this.stream.end - from > parser2.bufferLength * 4 ? new FragmentCursor(fragments, parser2.nodeSet) : null;
  }
  get parsedPos() {
    return this.minStackPos;
  }
  // Move the parser forward. This will process all parse stacks at
  // `this.pos` and try to advance them to a further position. If no
  // stack for such a position is found, it'll start error-recovery.
  //
  // When the parse is finished, this will return a syntax tree. When
  // not, it returns `null`.
  advance() {
    let stacks = this.stacks, pos = this.minStackPos;
    let newStacks = this.stacks = [];
    let stopped, stoppedTokens;
    if (this.bigReductionCount > 300 && stacks.length == 1) {
      let [s2] = stacks;
      while (s2.forceReduce() && s2.stack.length && s2.stack[s2.stack.length - 2] >= this.lastBigReductionStart) {
      }
      this.bigReductionCount = this.lastBigReductionSize = 0;
    }
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2];
      for (; ; ) {
        this.tokens.mainToken = null;
        if (stack.pos > pos) {
          newStacks.push(stack);
        } else if (this.advanceStack(stack, newStacks, stacks)) {
          continue;
        } else {
          if (!stopped) {
            stopped = [];
            stoppedTokens = [];
          }
          stopped.push(stack);
          let tok = this.tokens.getMainToken(stack);
          stoppedTokens.push(tok.value, tok.end);
        }
        break;
      }
    }
    if (!newStacks.length) {
      let finished = stopped && findFinished(stopped);
      if (finished) {
        if (verbose)
          console.log("Finish with " + this.stackID(finished));
        return this.stackToTree(finished);
      }
      if (this.parser.strict) {
        if (verbose && stopped)
          console.log("Stuck with token " + (this.tokens.mainToken ? this.parser.getName(this.tokens.mainToken.value) : "none"));
        throw new SyntaxError("No parse at " + pos);
      }
      if (!this.recovering)
        this.recovering = 5;
    }
    if (this.recovering && stopped) {
      let finished = this.stoppedAt != null && stopped[0].pos > this.stoppedAt ? stopped[0] : this.runRecovery(stopped, stoppedTokens, newStacks);
      if (finished) {
        if (verbose)
          console.log("Force-finish " + this.stackID(finished));
        return this.stackToTree(finished.forceAll());
      }
    }
    if (this.recovering) {
      let maxRemaining = this.recovering == 1 ? 1 : this.recovering * 3;
      if (newStacks.length > maxRemaining) {
        newStacks.sort((a2, b2) => b2.score - a2.score);
        while (newStacks.length > maxRemaining)
          newStacks.pop();
      }
      if (newStacks.some((s2) => s2.reducePos > pos))
        this.recovering--;
    } else if (newStacks.length > 1) {
      outer: for (let i2 = 0; i2 < newStacks.length - 1; i2++) {
        let stack = newStacks[i2];
        for (let j2 = i2 + 1; j2 < newStacks.length; j2++) {
          let other = newStacks[j2];
          if (stack.sameState(other) || stack.buffer.length > 500 && other.buffer.length > 500) {
            if ((stack.score - other.score || stack.buffer.length - other.buffer.length) > 0) {
              newStacks.splice(j2--, 1);
            } else {
              newStacks.splice(i2--, 1);
              continue outer;
            }
          }
        }
      }
      if (newStacks.length > 12) {
        newStacks.sort((a2, b2) => b2.score - a2.score);
        newStacks.splice(
          12,
          newStacks.length - 12
          /* Rec.MaxStackCount */
        );
      }
    }
    this.minStackPos = newStacks[0].pos;
    for (let i2 = 1; i2 < newStacks.length; i2++)
      if (newStacks[i2].pos < this.minStackPos)
        this.minStackPos = newStacks[i2].pos;
    return null;
  }
  stopAt(pos) {
    if (this.stoppedAt != null && this.stoppedAt < pos)
      throw new RangeError("Can't move stoppedAt forward");
    this.stoppedAt = pos;
  }
  // Returns an updated version of the given stack, or null if the
  // stack can't advance normally. When `split` and `stacks` are
  // given, stacks split off by ambiguous operations will be pushed to
  // `split`, or added to `stacks` if they move `pos` forward.
  advanceStack(stack, stacks, split) {
    let start = stack.pos, { parser: parser2 } = this;
    let base2 = verbose ? this.stackID(stack) + " -> " : "";
    if (this.stoppedAt != null && start > this.stoppedAt)
      return stack.forceReduce() ? stack : null;
    if (this.fragments) {
      let strictCx = stack.curContext && stack.curContext.tracker.strict, cxHash = strictCx ? stack.curContext.hash : 0;
      for (let cached = this.fragments.nodeAt(start); cached; ) {
        let match2 = this.parser.nodeSet.types[cached.type.id] == cached.type ? parser2.getGoto(stack.state, cached.type.id) : -1;
        if (match2 > -1 && cached.length && (!strictCx || (cached.prop(NodeProp.contextHash) || 0) == cxHash)) {
          stack.useNode(cached, match2);
          if (verbose)
            console.log(base2 + this.stackID(stack) + ` (via reuse of ${parser2.getName(cached.type.id)})`);
          return true;
        }
        if (!(cached instanceof Tree) || cached.children.length == 0 || cached.positions[0] > 0)
          break;
        let inner = cached.children[0];
        if (inner instanceof Tree && cached.positions[0] == 0)
          cached = inner;
        else
          break;
      }
    }
    let defaultReduce = parser2.stateSlot(
      stack.state,
      4
      /* ParseState.DefaultReduce */
    );
    if (defaultReduce > 0) {
      stack.reduce(defaultReduce);
      if (verbose)
        console.log(base2 + this.stackID(stack) + ` (via always-reduce ${parser2.getName(
          defaultReduce & 65535
          /* Action.ValueMask */
        )})`);
      return true;
    }
    if (stack.stack.length >= 8400) {
      while (stack.stack.length > 6e3 && stack.forceReduce()) {
      }
    }
    let actions = this.tokens.getActions(stack);
    for (let i2 = 0; i2 < actions.length; ) {
      let action = actions[i2++], term = actions[i2++], end = actions[i2++];
      let last2 = i2 == actions.length || !split;
      let localStack = last2 ? stack : stack.split();
      let main2 = this.tokens.mainToken;
      localStack.apply(action, term, main2 ? main2.start : localStack.pos, end);
      if (verbose)
        console.log(base2 + this.stackID(localStack) + ` (via ${(action & 65536) == 0 ? "shift" : `reduce of ${parser2.getName(
          action & 65535
          /* Action.ValueMask */
        )}`} for ${parser2.getName(term)} @ ${start}${localStack == stack ? "" : ", split"})`);
      if (last2)
        return true;
      else if (localStack.pos > start)
        stacks.push(localStack);
      else
        split.push(localStack);
    }
    return false;
  }
  // Advance a given stack forward as far as it will go. Returns the
  // (possibly updated) stack if it got stuck, or null if it moved
  // forward and was given to `pushStackDedup`.
  advanceFully(stack, newStacks) {
    let pos = stack.pos;
    for (; ; ) {
      if (!this.advanceStack(stack, null, null))
        return false;
      if (stack.pos > pos) {
        pushStackDedup(stack, newStacks);
        return true;
      }
    }
  }
  runRecovery(stacks, tokens, newStacks) {
    let finished = null, restarted = false;
    for (let i2 = 0; i2 < stacks.length; i2++) {
      let stack = stacks[i2], token = tokens[i2 << 1], tokenEnd = tokens[(i2 << 1) + 1];
      let base2 = verbose ? this.stackID(stack) + " -> " : "";
      if (stack.deadEnd) {
        if (restarted)
          continue;
        restarted = true;
        stack.restart();
        if (verbose)
          console.log(base2 + this.stackID(stack) + " (restarted)");
        let done = this.advanceFully(stack, newStacks);
        if (done)
          continue;
      }
      let force = stack.split(), forceBase = base2;
      for (let j2 = 0; j2 < 10 && force.forceReduce(); j2++) {
        if (verbose)
          console.log(forceBase + this.stackID(force) + " (via force-reduce)");
        let done = this.advanceFully(force, newStacks);
        if (done)
          break;
        if (verbose)
          forceBase = this.stackID(force) + " -> ";
      }
      for (let insert2 of stack.recoverByInsert(token)) {
        if (verbose)
          console.log(base2 + this.stackID(insert2) + " (via recover-insert)");
        this.advanceFully(insert2, newStacks);
      }
      if (this.stream.end > stack.pos) {
        if (tokenEnd == stack.pos) {
          tokenEnd++;
          token = 0;
        }
        stack.recoverByDelete(token, tokenEnd);
        if (verbose)
          console.log(base2 + this.stackID(stack) + ` (via recover-delete ${this.parser.getName(token)})`);
        pushStackDedup(stack, newStacks);
      } else if (!finished || finished.score < force.score) {
        finished = force;
      }
    }
    return finished;
  }
  // Convert the stack's buffer to a syntax tree.
  stackToTree(stack) {
    stack.close();
    return Tree.build({
      buffer: StackBufferCursor.create(stack),
      nodeSet: this.parser.nodeSet,
      topID: this.topTerm,
      maxBufferLength: this.parser.bufferLength,
      reused: this.reused,
      start: this.ranges[0].from,
      length: stack.pos - this.ranges[0].from,
      minRepeatType: this.parser.minRepeatTerm
    });
  }
  stackID(stack) {
    let id2 = (stackIDs || (stackIDs = /* @__PURE__ */ new WeakMap())).get(stack);
    if (!id2)
      stackIDs.set(stack, id2 = String.fromCodePoint(this.nextStackID++));
    return id2 + stack;
  }
}
function pushStackDedup(stack, newStacks) {
  for (let i2 = 0; i2 < newStacks.length; i2++) {
    let other = newStacks[i2];
    if (other.pos == stack.pos && other.sameState(stack)) {
      if (newStacks[i2].score < stack.score)
        newStacks[i2] = stack;
      return;
    }
  }
  newStacks.push(stack);
}
class Dialect {
  constructor(source, flags, disabled) {
    this.source = source;
    this.flags = flags;
    this.disabled = disabled;
  }
  allows(term) {
    return !this.disabled || this.disabled[term] == 0;
  }
}
const id = (x2) => x2;
class ContextTracker {
  /**
  Define a context tracker.
  */
  constructor(spec) {
    this.start = spec.start;
    this.shift = spec.shift || id;
    this.reduce = spec.reduce || id;
    this.reuse = spec.reuse || id;
    this.hash = spec.hash || (() => 0);
    this.strict = spec.strict !== false;
  }
}
class LRParser extends Parser {
  /**
  @internal
  */
  constructor(spec) {
    super();
    this.wrappers = [];
    if (spec.version != 14)
      throw new RangeError(`Parser version (${spec.version}) doesn't match runtime version (${14})`);
    let nodeNames = spec.nodeNames.split(" ");
    this.minRepeatTerm = nodeNames.length;
    for (let i2 = 0; i2 < spec.repeatNodeCount; i2++)
      nodeNames.push("");
    let topTerms = Object.keys(spec.topRules).map((r2) => spec.topRules[r2][1]);
    let nodeProps = [];
    for (let i2 = 0; i2 < nodeNames.length; i2++)
      nodeProps.push([]);
    function setProp(nodeID, prop, value) {
      nodeProps[nodeID].push([prop, prop.deserialize(String(value))]);
    }
    if (spec.nodeProps)
      for (let propSpec of spec.nodeProps) {
        let prop = propSpec[0];
        if (typeof prop == "string")
          prop = NodeProp[prop];
        for (let i2 = 1; i2 < propSpec.length; ) {
          let next = propSpec[i2++];
          if (next >= 0) {
            setProp(next, prop, propSpec[i2++]);
          } else {
            let value = propSpec[i2 + -next];
            for (let j2 = -next; j2 > 0; j2--)
              setProp(propSpec[i2++], prop, value);
            i2++;
          }
        }
      }
    this.nodeSet = new NodeSet(nodeNames.map((name2, i2) => NodeType.define({
      name: i2 >= this.minRepeatTerm ? void 0 : name2,
      id: i2,
      props: nodeProps[i2],
      top: topTerms.indexOf(i2) > -1,
      error: i2 == 0,
      skipped: spec.skippedNodes && spec.skippedNodes.indexOf(i2) > -1
    })));
    if (spec.propSources)
      this.nodeSet = this.nodeSet.extend(...spec.propSources);
    this.strict = false;
    this.bufferLength = DefaultBufferLength;
    let tokenArray = decodeArray(spec.tokenData);
    this.context = spec.context;
    this.specializerSpecs = spec.specialized || [];
    this.specialized = new Uint16Array(this.specializerSpecs.length);
    for (let i2 = 0; i2 < this.specializerSpecs.length; i2++)
      this.specialized[i2] = this.specializerSpecs[i2].term;
    this.specializers = this.specializerSpecs.map(getSpecializer);
    this.states = decodeArray(spec.states, Uint32Array);
    this.data = decodeArray(spec.stateData);
    this.goto = decodeArray(spec.goto);
    this.maxTerm = spec.maxTerm;
    this.tokenizers = spec.tokenizers.map((value) => typeof value == "number" ? new TokenGroup(tokenArray, value) : value);
    this.topRules = spec.topRules;
    this.dialects = spec.dialects || {};
    this.dynamicPrecedences = spec.dynamicPrecedences || null;
    this.tokenPrecTable = spec.tokenPrec;
    this.termNames = spec.termNames || null;
    this.maxNode = this.nodeSet.types.length - 1;
    this.dialect = this.parseDialect();
    this.top = this.topRules[Object.keys(this.topRules)[0]];
  }
  createParse(input, fragments, ranges) {
    let parse2 = new Parse(this, input, fragments, ranges);
    for (let w2 of this.wrappers)
      parse2 = w2(parse2, input, fragments, ranges);
    return parse2;
  }
  /**
  Get a goto table entry @internal
  */
  getGoto(state, term, loose = false) {
    let table = this.goto;
    if (term >= table[0])
      return -1;
    for (let pos = table[term + 1]; ; ) {
      let groupTag = table[pos++], last2 = groupTag & 1;
      let target = table[pos++];
      if (last2 && loose)
        return target;
      for (let end = pos + (groupTag >> 1); pos < end; pos++)
        if (table[pos] == state)
          return target;
      if (last2)
        return -1;
    }
  }
  /**
  Check if this state has an action for a given terminal @internal
  */
  hasAction(state, terminal) {
    let data = this.data;
    for (let set2 = 0; set2 < 2; set2++) {
      for (let i2 = this.stateSlot(
        state,
        set2 ? 2 : 1
        /* ParseState.Actions */
      ), next; ; i2 += 3) {
        if ((next = data[i2]) == 65535) {
          if (data[i2 + 1] == 1)
            next = data[i2 = pair(data, i2 + 2)];
          else if (data[i2 + 1] == 2)
            return pair(data, i2 + 2);
          else
            break;
        }
        if (next == terminal || next == 0)
          return pair(data, i2 + 1);
      }
    }
    return 0;
  }
  /**
  @internal
  */
  stateSlot(state, slot) {
    return this.states[state * 6 + slot];
  }
  /**
  @internal
  */
  stateFlag(state, flag) {
    return (this.stateSlot(
      state,
      0
      /* ParseState.Flags */
    ) & flag) > 0;
  }
  /**
  @internal
  */
  validAction(state, action) {
    return !!this.allActions(state, (a2) => a2 == action ? true : null);
  }
  /**
  @internal
  */
  allActions(state, action) {
    let deflt = this.stateSlot(
      state,
      4
      /* ParseState.DefaultReduce */
    );
    let result2 = deflt ? action(deflt) : void 0;
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); result2 == null; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      result2 = action(pair(this.data, i2 + 1));
    }
    return result2;
  }
  /**
  Get the states that can follow this one through shift actions or
  goto jumps. @internal
  */
  nextStates(state) {
    let result2 = [];
    for (let i2 = this.stateSlot(
      state,
      1
      /* ParseState.Actions */
    ); ; i2 += 3) {
      if (this.data[i2] == 65535) {
        if (this.data[i2 + 1] == 1)
          i2 = pair(this.data, i2 + 2);
        else
          break;
      }
      if ((this.data[i2 + 2] & 65536 >> 16) == 0) {
        let value = this.data[i2 + 1];
        if (!result2.some((v2, i22) => i22 & 1 && v2 == value))
          result2.push(this.data[i2], value);
      }
    }
    return result2;
  }
  /**
  Configure the parser. Returns a new parser instance that has the
  given settings modified. Settings not provided in `config` are
  kept from the original parser.
  */
  configure(config2) {
    let copy2 = Object.assign(Object.create(LRParser.prototype), this);
    if (config2.props)
      copy2.nodeSet = this.nodeSet.extend(...config2.props);
    if (config2.top) {
      let info = this.topRules[config2.top];
      if (!info)
        throw new RangeError(`Invalid top rule name ${config2.top}`);
      copy2.top = info;
    }
    if (config2.tokenizers)
      copy2.tokenizers = this.tokenizers.map((t4) => {
        let found = config2.tokenizers.find((r2) => r2.from == t4);
        return found ? found.to : t4;
      });
    if (config2.specializers) {
      copy2.specializers = this.specializers.slice();
      copy2.specializerSpecs = this.specializerSpecs.map((s2, i2) => {
        let found = config2.specializers.find((r2) => r2.from == s2.external);
        if (!found)
          return s2;
        let spec = Object.assign(Object.assign({}, s2), { external: found.to });
        copy2.specializers[i2] = getSpecializer(spec);
        return spec;
      });
    }
    if (config2.contextTracker)
      copy2.context = config2.contextTracker;
    if (config2.dialect)
      copy2.dialect = this.parseDialect(config2.dialect);
    if (config2.strict != null)
      copy2.strict = config2.strict;
    if (config2.wrap)
      copy2.wrappers = copy2.wrappers.concat(config2.wrap);
    if (config2.bufferLength != null)
      copy2.bufferLength = config2.bufferLength;
    return copy2;
  }
  /**
  Tells you whether any [parse wrappers](#lr.ParserConfig.wrap)
  are registered for this parser.
  */
  hasWrappers() {
    return this.wrappers.length > 0;
  }
  /**
  Returns the name associated with a given term. This will only
  work for all terms when the parser was generated with the
  `--names` option. By default, only the names of tagged terms are
  stored.
  */
  getName(term) {
    return this.termNames ? this.termNames[term] : String(term <= this.maxNode && this.nodeSet.types[term].name || term);
  }
  /**
  The eof term id is always allocated directly after the node
  types. @internal
  */
  get eofTerm() {
    return this.maxNode + 1;
  }
  /**
  The type of top node produced by the parser.
  */
  get topNode() {
    return this.nodeSet.types[this.top[1]];
  }
  /**
  @internal
  */
  dynamicPrecedence(term) {
    let prec2 = this.dynamicPrecedences;
    return prec2 == null ? 0 : prec2[term] || 0;
  }
  /**
  @internal
  */
  parseDialect(dialect) {
    let values2 = Object.keys(this.dialects), flags = values2.map(() => false);
    if (dialect)
      for (let part of dialect.split(" ")) {
        let id2 = values2.indexOf(part);
        if (id2 >= 0)
          flags[id2] = true;
      }
    let disabled = null;
    for (let i2 = 0; i2 < values2.length; i2++)
      if (!flags[i2]) {
        for (let j2 = this.dialects[values2[i2]], id2; (id2 = this.data[j2++]) != 65535; )
          (disabled || (disabled = new Uint8Array(this.maxTerm + 1)))[id2] = 1;
      }
    return new Dialect(dialect, flags, disabled);
  }
  /**
  Used by the output of the parser generator. Not available to
  user code. @hide
  */
  static deserialize(spec) {
    return new LRParser(spec);
  }
}
function pair(data, off) {
  return data[off] | data[off + 1] << 16;
}
function findFinished(stacks) {
  let best = null;
  for (let stack of stacks) {
    let stopped = stack.p.stoppedAt;
    if ((stack.pos == stack.p.stream.end || stopped != null && stack.pos > stopped) && stack.p.parser.stateFlag(
      stack.state,
      2
      /* StateFlag.Accepting */
    ) && (!best || best.score < stack.score))
      best = stack;
  }
  return best;
}
function getSpecializer(spec) {
  if (spec.external) {
    let mask = spec.extend ? 1 : 0;
    return (value, stack) => spec.external(value, stack) << 1 | mask;
  }
  return spec.get;
}
function nameChar(ch) {
  return ch == 45 || ch == 46 || ch == 58 || ch >= 65 && ch <= 90 || ch == 95 || ch >= 97 && ch <= 122 || ch >= 161;
}
function isSpace(ch) {
  return ch == 9 || ch == 10 || ch == 13 || ch == 32;
}
let cachedName = null, cachedInput = null, cachedPos = 0;
function tagNameAfter(input, offset2) {
  let pos = input.pos + offset2;
  if (cachedInput == input && cachedPos == pos) return cachedName;
  while (isSpace(input.peek(offset2))) offset2++;
  let name2 = "";
  for (; ; ) {
    let next = input.peek(offset2);
    if (!nameChar(next)) break;
    name2 += String.fromCharCode(next);
    offset2++;
  }
  cachedInput = input;
  cachedPos = pos;
  return cachedName = name2 || null;
}
class ElementContext {
  constructor(name2, parent) {
    this.name = name2;
    this.parent = parent ?? null;
    this.hash = parent ? parent.hash : 0;
    for (let i2 = 0; i2 < name2.length; i2++) {
      this.hash += (this.hash << 4) + name2.charCodeAt(i2) + (name2.charCodeAt(i2) << 8);
    }
  }
}
const elementContext = new ContextTracker({
  start: null,
  shift(context, term, stack, input) {
    return term == StartTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  reduce(context, term) {
    return term == Element$1 && context ? context.parent : context;
  },
  reuse(context, node, _stack, input) {
    let type = node.type.id;
    return type == StartTag || type == OpenTag ? new ElementContext(tagNameAfter(input, 1) || "", context) : context;
  },
  hash(context) {
    return context ? context.hash : 0;
  },
  strict: false
});
const startTag = new ExternalTokenizer(
  (input, stack) => {
    if (input.next !== 60) {
      return;
    }
    const nextNext = input.peek(1);
    if (nextNext === 61) {
      return;
    }
    input.advance();
    if (input.next === 47) {
      input.advance();
      let name2 = tagNameAfter(input, 0);
      if (!name2) {
        return input.acceptToken(incompleteStartCloseTag);
      }
      if (stack.context && name2.toLowerCase() == stack.context.name.toLowerCase()) {
        return input.acceptToken(StartCloseTag);
      }
      for (let cx = stack.context; cx; cx = cx.parent) {
        if (cx.name === name2) {
          return input.acceptToken(MissingCloseTag, -2);
        }
      }
      input.acceptToken(mismatchedStartCloseTag);
    } else if (
      // @ts-ignore
      input.next !== 33 && // @ts-ignore
      input.next !== 63 && !isSpace(input.next)
    ) {
      return input.acceptToken(StartTag);
    }
  },
  { contextual: true }
);
const textLessThan = new ExternalTokenizer((input) => {
  if (input.next !== 60) {
    return;
  }
  const nextNext = input.peek(1);
  if (nextNext === 60) {
    return input.acceptToken(Text, 1);
  }
});
function scanTo(type, end) {
  return new ExternalTokenizer((input) => {
    for (let endPos = 0, len = 0; ; len++) {
      if (input.next < 0) {
        if (len) {
          input.acceptToken(type);
        }
        break;
      }
      if (input.next == end.charCodeAt(endPos)) {
        endPos++;
        if (endPos == end.length) {
          if (len > end.length) {
            input.acceptToken(type, 1 - end.length);
          }
          break;
        }
      } else {
        endPos = 0;
      }
      input.advance();
    }
  });
}
const commentContent = scanTo(commentContent$1, "-->");
const piContent = scanTo(piContent$1, "?>");
const cdataContent = scanTo(cdataContent$1, "]]>");
const parser = LRParser.deserialize({
  version: 14,
  states: "(jOVOqOOOzO!jO'#CgO!SQ!bO'#CjO!|OqO'#ChOOOP'#Ch'#ChO#TO!dO'#CsO#]O!fO'#CtO#eQ!bO'#CuOOOP'#DW'#DWOOOP'#Cw'#CwQVOqOOOOOW'#Cx'#CxO#jO!jO,59ROOOP,59R,59RO#rQ#tO,59UOOOP'#C|'#C|O#}OqO,59SO$UQ!bO'#CpOOOP,59S,59SOOOQ'#C}'#C}O$ZO!dO,59_OOOP,59_,59_OOOS'#DO'#DOO$cO!fO,59`OOOP,59`,59`O$kQ!bO,59aOOOP-E6u-E6uOOOW-E6v-E6vOOOP1G.m1G.mO$pQ#tO'#ClOOQO'#Cy'#CyO%OQ#tO1G.pOOOP1G.p1G.pOOOP1G.x1G.xOOOP-E6z-E6zOOOP1G.n1G.nO%ZQ!bO,59[OOOQ-E6{-E6{OOOP1G.y1G.yOOOS-E6|-E6|OOOP1G.z1G.zOOOP1G.{1G.{O%`Q!bO,59WOOQO-E6w-E6wOOOP7+$[7+$[OOOP7+$d7+$dOOOP1G.v1G.vO%hO&jO'#CoO%yO,UO'#CoOOQO1G.r1G.rOOOO'#Cz'#CzO&[O&jO,59ZOOQO,59Z,59ZOOOO'#C{'#C{O&mO,UO,59ZOOOO-E6x-E6xOOQO1G.u1G.uOOOO-E6y-E6y",
  stateData: "'T~OyOS~OPQOSVOTWOVWOWWOXWOYWOjXO|PO!STO!UUO~OvZO{]O~O_^O~OPQOQaOSVOTWOVWOWWOXWOYWO|PO!STO!UUO~ORbO~P!XOtcO!ReO~OufO!ThO~O_iO~OvZO{lO~O]pOamOeqO~ORsO~P!XO_tO~OtcO!RvO~OufO!TxO~O]yO~ObzO]`Xa`Xe`X~O]|OamOe}O~O]!OO~O}!PO!P!QO~OW!SOX!SOY!SO}!UO!O!SO~OW!VOX!VOY!VO!P!UO!Q!VO~OW!SOX!SOY!SO}!YO!O!SO~OW!VOX!VOY!VO!P!YO!Q!VO~OXWYW~",
  goto: "#w{PPPPPPPPPPP||P!SP!YPP!^!aP!g|||P!m!s!y#P#V#]#c#iPPPPPPP#oXWORY`XRORY`Tn^oR!RzQbRRs`XSORY`QYORjYQ[PRk[Qo^R{oQ!T!PR!X!TQ!W!QR!Z!WQ`RRr`QdTRudQgURwgSXOYT_R`",
  nodeNames: "⚠ StartTag StartCloseTag MissingCloseTag StartCloseTag StartCloseTag Document Text EntityReference CharacterReference Ampersand Cdata Element EndTag OpenTag TagName Attribute AttributeName Is AttributeValue CloseTag SelfCloseEndTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl",
  maxTerm: 52,
  context: elementContext,
  nodeProps: [
    [
      "closedBy",
      1,
      "SelfCloseEndTag EndTag",
      14,
      "CloseTag MissingCloseTag"
    ],
    [
      "openedBy",
      13,
      "StartTag StartCloseTag",
      20,
      "OpenTag",
      21,
      "StartTag"
    ]
  ],
  skippedNodes: [0],
  repeatNodeCount: 8,
  tokenData: "!2c~R!YOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs2wsv$qvw3gwx7lx}$q}!O8_!O!P$q!P!Q:}!Q![$q![!]<q!]!^$q!^!_@X!_!`!,a!`!a!-X!a!b!.P!b!c$q!c!}<q!}#P$q#P#Q!/s#Q#R$q#R#S<q#S#T$q#T#o<q#o%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U$q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qi$zXVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qa%nVVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%gP&YUVPOv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP&oTXY'OYZ'O]^'Opq'O!_!`&TP'T]VPOX&TXY'OYZ'OZ]&T]^'O^p&Tpq'Oqv&Tw!^&T!^!_&l!_;'S&T;'S;=`'|<%lO&TP(PP;=`<%l&Ta(X]!Q`OX)QXY)iYZ)iZ])Q]^)i^p)Qpq)iqv)Qx!_)Q!_!`%g!`;'S)Q;'S;=`)c<%lO)Q`)VS!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)Q`)fP;=`<%l)Qa)p^VP!Q`OX%gXY)iYZ)iZ]%g]^)i^p%gpq)iqv%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%ga*oP;=`<%l%gX*yWVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX+h^!OWOX,dXY-OYZ-OZ],d]^-O^p,dpq-Oqr,dsv,dw!_,d!_!`*r!`;'S,d;'S;=`,x<%lO,dW,iT!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dW,{P;=`<%l,dX-V_VP!OWOX*rXY-OYZ-OZ]*r]^-O^p*rpq-Oqr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rX.XP;=`<%l*ri.c`!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0Xqr/ers)Qsv/ewx,dx!_/e!_!`$q!`;'S/e;'S;=`0R<%lO/eh/lV!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eh0UP;=`<%l/ei0b`VP!OW!Q`OX$qXY0XYZ0XZ]$q]^0X^p$qpq0Xqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qi1gP;=`<%l$qo1u`VP!OW!Q`yUOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk3QV}YVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;'S%g;'S;=`*l<%lO%g~3laY~st4q![!]5u!c!}5u#R#S5u#T#o5u%W%o5u%p&a5u&b1p5u4U4d5u4e$IS5u$I`$Ib5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~4tQ!Q![4z#l#m5Y~4}Q!Q![4z!]!^5T~5YOX~~5]R!Q![5f!c!i5f#T#Z5f~5iS!Q![5f!]!^5T!c!i5f#T#Z5f~5xg}!O5u!O!P5u!Q![5u![!]5u!]!^7a!c!}5u#R#S5u#T#o5u$}%O5u%W%o5u%p&a5u&b1p5u1p4U5u4U4d5u4e$IS5u$I`$Ib5u$Je$Jg5u$Kh%#t5u&/x&Et5u&FV;'S5u;'S;:j7f?&r?Ah5u?BY?Mn5u~7fOW~~7iP;=`<%l5uk7uW!PbVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;'S*r;'S;=`.U<%lO*rk8hZVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O9Z!O!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk9dZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a:V!a;'S$q;'S;=`1d<%lO$qk:bX!RQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qm;WZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a;y!a;'S$q;'S;=`1d<%lO$qm<UXeSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo=O!PaS_QVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O<q!O!P<q!P!Q$q!Q![<q![!]<q!]!^$q!^!_.[!_!c$q!c!}<q!}#R$q#R#S<q#S#T$q#T#o<q#o$}$q$}%O<q%O%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U<q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Je$q$Je$Jg<q$Jg$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;'S<q;'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qo@UP;=`<%l<qi@`b!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0XqrAhrs)Qsv/ewx,dx!_/e!_!`$q!`!a/e!a!b!+q!b;'S/e;'S;=`0R<%lO/eiAo_!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OBn!O!f/e!f!gDQ!g!}/e!}#OMT#O#W/e#W#X!']#X;'S/e;'S;=`0R<%lO/eiBuX!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OCb!O;'S/e;'S;=`0R<%lO/eiCkV!SP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiDXX!OW!Q`Or/ers)Qsv/ewx,dx!q/e!q!rDt!r;'S/e;'S;=`0R<%lO/eiD{X!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fEh!f;'S/e;'S;=`0R<%lO/eiEoX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!wF[!w;'S/e;'S;=`0R<%lO/eiFcX!OW!Q`Or/ers)Qsv/ewx,dx!{/e!{!|GO!|;'S/e;'S;=`0R<%lO/eiGVX!OW!Q`Or/ers)Qsv/ewx,dx!r/e!r!sGr!s;'S/e;'S;=`0R<%lO/eiGyX!OW!Q`Or/ers)Qsv/ewx,dx!g/e!g!hHf!h;'S/e;'S;=`0R<%lO/eiHmY!OW!Q`OrHfrsI]svHfvwIwwxKPx!`Hf!`!aL_!a;'SHf;'S;=`L}<%lOHfaIbV!Q`OvI]vxIwx!`I]!`!aJf!a;'SI];'S;=`Jy<%lOI]PIzTO!`Iw!`!aJZ!a;'SIw;'S;=`J`<%lOIwPJ`OjPPJcP;=`<%lIwaJmSjP!Q`Ov)Qx;'S)Q;'S;=`)c<%lO)QaJ|P;=`<%lI]XKUX!OWOrKPrsIwsvKPvwIww!`KP!`!aKq!a;'SKP;'S;=`LX<%lOKPXKxTjP!OWOr,dsv,dw;'S,d;'S;=`,x<%lO,dXL[P;=`<%lKPiLhVjP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/eiMQP;=`<%lHfiM[Z!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fM}!f#V/e#V#W!$_#W;'S/e;'S;=`0R<%lO/eiNUX!OW!Q`Or/ers)Qsv/ewx,dx!f/e!f!gNq!g;'S/e;'S;=`0R<%lO/eiNxX!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d! e!d;'S/e;'S;=`0R<%lO/ei! lX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!w!!X!w;'S/e;'S;=`0R<%lO/ei!!`X!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d!!{!d;'S/e;'S;=`0R<%lO/ei!#SX!OW!Q`Or/ers)Qsv/ewx,dx!}/e!}#O!#o#O;'S/e;'S;=`0R<%lO/ei!#xV|P!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/ei!$fX!OW!Q`Or/ers)Qsv/ewx,dx#W/e#W#X!%R#X;'S/e;'S;=`0R<%lO/ei!%YX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!%u#U;'S/e;'S;=`0R<%lO/ei!%|X!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!&i#i;'S/e;'S;=`0R<%lO/ei!&pX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!!{#U;'S/e;'S;=`0R<%lO/ei!'dX!OW!Q`Or/ers)Qsv/ewx,dx#c/e#c#d!(P#d;'S/e;'S;=`0R<%lO/ei!(WX!OW!Q`Or/ers)Qsv/ewx,dx#V/e#V#W!(s#W;'S/e;'S;=`0R<%lO/ei!(zX!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!)g#i;'S/e;'S;=`0R<%lO/ei!)nX!OW!Q`Or/ers)Qsv/ewx,dx#m/e#m#n!*Z#n;'S/e;'S;=`0R<%lO/ei!*bX!OW!Q`Or/ers)Qsv/ewx,dx#d/e#d#e!*}#e;'S/e;'S;=`0R<%lO/ei!+UX!OW!Q`Or/ers)Qsv/ewx,dx#X/e#X#YHf#Y;'S/e;'S;=`0R<%lO/ei!+zV!UP!OW!Q`Or/ers)Qsv/ewx,dx;'S/e;'S;=`0R<%lO/em!,lXbSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qo!-dX]UVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!.YZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!.{!a;'S$q;'S;=`1d<%lO$qk!/WX!TQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$qk!/|ZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_#P$q#P#Q!0o#Q;'S$q;'S;=`1d<%lO$qk!0xZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!1k!a;'S$q;'S;=`1d<%lO$qk!1vX{QVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;'S$q;'S;=`1d<%lO$q",
  tokenizers: [
    startTag,
    commentContent,
    piContent,
    cdataContent,
    textLessThan,
    0,
    1,
    2,
    3,
    4
  ],
  topRules: { Document: [0, 6] },
  tokenPrec: 276
});
const _ENTITY_MAP = { "AEli": "Æ", "AElig": "Æ", "AM": "&", "AMP": "&", "Aacut": "Á", "Aacute": "Á", "Abreve": "Ă", "Acir": "Â", "Acirc": "Â", "Acy": "А", "Afr": "𝔄", "Agrav": "À", "Agrave": "À", "Alpha": "Α", "Amacr": "Ā", "And": "⩓", "Aogon": "Ą", "Aopf": "𝔸", "ApplyFunction": "⁡", "Arin": "Å", "Aring": "Å", "Ascr": "𝒜", "Assign": "≔", "Atild": "Ã", "Atilde": "Ã", "Aum": "Ä", "Auml": "Ä", "Backslash": "∖", "Barv": "⫧", "Barwed": "⌆", "Bcy": "Б", "Because": "∵", "Bernoullis": "ℬ", "Beta": "Β", "Bfr": "𝔅", "Bopf": "𝔹", "Breve": "˘", "Bscr": "ℬ", "Bumpeq": "≎", "CHcy": "Ч", "COP": "©", "COPY": "©", "Cacute": "Ć", "Cap": "⋒", "CapitalDifferentialD": "ⅅ", "Cayleys": "ℭ", "Ccaron": "Č", "Ccedi": "Ç", "Ccedil": "Ç", "Ccirc": "Ĉ", "Cconint": "∰", "Cdot": "Ċ", "Cedilla": "¸", "CenterDot": "·", "Cfr": "ℭ", "Chi": "Χ", "CircleDot": "⊙", "CircleMinus": "⊖", "CirclePlus": "⊕", "CircleTimes": "⊗", "ClockwiseContourIntegral": "∲", "CloseCurlyDoubleQuote": "”", "CloseCurlyQuote": "’", "Colon": "∷", "Colone": "⩴", "Congruent": "≡", "Conint": "∯", "ContourIntegral": "∮", "Copf": "ℂ", "Coproduct": "∐", "CounterClockwiseContourIntegral": "∳", "Cross": "⨯", "Cscr": "𝒞", "Cup": "⋓", "CupCap": "≍", "DD": "ⅅ", "DDotrahd": "⤑", "DJcy": "Ђ", "DScy": "Ѕ", "DZcy": "Џ", "Dagger": "‡", "Darr": "↡", "Dashv": "⫤", "Dcaron": "Ď", "Dcy": "Д", "Del": "∇", "Delta": "Δ", "Dfr": "𝔇", "DiacriticalAcute": "´", "DiacriticalDot": "˙", "DiacriticalDoubleAcute": "˝", "DiacriticalGrave": "`", "DiacriticalTilde": "˜", "Diamond": "⋄", "DifferentialD": "ⅆ", "Dopf": "𝔻", "Dot": "¨", "DotDot": "⃜", "DotEqual": "≐", "DoubleContourIntegral": "∯", "DoubleDot": "¨", "DoubleDownArrow": "⇓", "DoubleLeftArrow": "⇐", "DoubleLeftRightArrow": "⇔", "DoubleLeftTee": "⫤", "DoubleLongLeftArrow": "⟸", "DoubleLongLeftRightArrow": "⟺", "DoubleLongRightArrow": "⟹", "DoubleRightArrow": "⇒", "DoubleRightTee": "⊨", "DoubleUpArrow": "⇑", "DoubleUpDownArrow": "⇕", "DoubleVerticalBar": "∥", "DownArrow": "↓", "DownArrowBar": "⤓", "DownArrowUpArrow": "⇵", "DownBreve": "̑", "DownLeftRightVector": "⥐", "DownLeftTeeVector": "⥞", "DownLeftVector": "↽", "DownLeftVectorBar": "⥖", "DownRightTeeVector": "⥟", "DownRightVector": "⇁", "DownRightVectorBar": "⥗", "DownTee": "⊤", "DownTeeArrow": "↧", "Downarrow": "⇓", "Dscr": "𝒟", "Dstrok": "Đ", "ENG": "Ŋ", "ET": "Ð", "ETH": "Ð", "Eacut": "É", "Eacute": "É", "Ecaron": "Ě", "Ecir": "Ê", "Ecirc": "Ê", "Ecy": "Э", "Edot": "Ė", "Efr": "𝔈", "Egrav": "È", "Egrave": "È", "Element": "∈", "Emacr": "Ē", "EmptySmallSquare": "◻", "EmptyVerySmallSquare": "▫", "Eogon": "Ę", "Eopf": "𝔼", "Epsilon": "Ε", "Equal": "⩵", "EqualTilde": "≂", "Equilibrium": "⇌", "Escr": "ℰ", "Esim": "⩳", "Eta": "Η", "Eum": "Ë", "Euml": "Ë", "Exists": "∃", "ExponentialE": "ⅇ", "Fcy": "Ф", "Ffr": "𝔉", "FilledSmallSquare": "◼", "FilledVerySmallSquare": "▪", "Fopf": "𝔽", "ForAll": "∀", "Fouriertrf": "ℱ", "Fscr": "ℱ", "GJcy": "Ѓ", "G": ">", "GT": ">", "Gamma": "Γ", "Gammad": "Ϝ", "Gbreve": "Ğ", "Gcedil": "Ģ", "Gcirc": "Ĝ", "Gcy": "Г", "Gdot": "Ġ", "Gfr": "𝔊", "Gg": "⋙", "Gopf": "𝔾", "GreaterEqual": "≥", "GreaterEqualLess": "⋛", "GreaterFullEqual": "≧", "GreaterGreater": "⪢", "GreaterLess": "≷", "GreaterSlantEqual": "⩾", "GreaterTilde": "≳", "Gscr": "𝒢", "Gt": "≫", "HARDcy": "Ъ", "Hacek": "ˇ", "Hat": "^", "Hcirc": "Ĥ", "Hfr": "ℌ", "HilbertSpace": "ℋ", "Hopf": "ℍ", "HorizontalLine": "─", "Hscr": "ℋ", "Hstrok": "Ħ", "HumpDownHump": "≎", "HumpEqual": "≏", "IEcy": "Е", "IJlig": "Ĳ", "IOcy": "Ё", "Iacut": "Í", "Iacute": "Í", "Icir": "Î", "Icirc": "Î", "Icy": "И", "Idot": "İ", "Ifr": "ℑ", "Igrav": "Ì", "Igrave": "Ì", "Im": "ℑ", "Imacr": "Ī", "ImaginaryI": "ⅈ", "Implies": "⇒", "Int": "∬", "Integral": "∫", "Intersection": "⋂", "InvisibleComma": "⁣", "InvisibleTimes": "⁢", "Iogon": "Į", "Iopf": "𝕀", "Iota": "Ι", "Iscr": "ℐ", "Itilde": "Ĩ", "Iukcy": "І", "Ium": "Ï", "Iuml": "Ï", "Jcirc": "Ĵ", "Jcy": "Й", "Jfr": "𝔍", "Jopf": "𝕁", "Jscr": "𝒥", "Jsercy": "Ј", "Jukcy": "Є", "KHcy": "Х", "KJcy": "Ќ", "Kappa": "Κ", "Kcedil": "Ķ", "Kcy": "К", "Kfr": "𝔎", "Kopf": "𝕂", "Kscr": "𝒦", "LJcy": "Љ", "L": "<", "LT": "<", "Lacute": "Ĺ", "Lambda": "Λ", "Lang": "⟪", "Laplacetrf": "ℒ", "Larr": "↞", "Lcaron": "Ľ", "Lcedil": "Ļ", "Lcy": "Л", "LeftAngleBracket": "⟨", "LeftArrow": "←", "LeftArrowBar": "⇤", "LeftArrowRightArrow": "⇆", "LeftCeiling": "⌈", "LeftDoubleBracket": "⟦", "LeftDownTeeVector": "⥡", "LeftDownVector": "⇃", "LeftDownVectorBar": "⥙", "LeftFloor": "⌊", "LeftRightArrow": "↔", "LeftRightVector": "⥎", "LeftTee": "⊣", "LeftTeeArrow": "↤", "LeftTeeVector": "⥚", "LeftTriangle": "⊲", "LeftTriangleBar": "⧏", "LeftTriangleEqual": "⊴", "LeftUpDownVector": "⥑", "LeftUpTeeVector": "⥠", "LeftUpVector": "↿", "LeftUpVectorBar": "⥘", "LeftVector": "↼", "LeftVectorBar": "⥒", "Leftarrow": "⇐", "Leftrightarrow": "⇔", "LessEqualGreater": "⋚", "LessFullEqual": "≦", "LessGreater": "≶", "LessLess": "⪡", "LessSlantEqual": "⩽", "LessTilde": "≲", "Lfr": "𝔏", "Ll": "⋘", "Lleftarrow": "⇚", "Lmidot": "Ŀ", "LongLeftArrow": "⟵", "LongLeftRightArrow": "⟷", "LongRightArrow": "⟶", "Longleftarrow": "⟸", "Longleftrightarrow": "⟺", "Longrightarrow": "⟹", "Lopf": "𝕃", "LowerLeftArrow": "↙", "LowerRightArrow": "↘", "Lscr": "ℒ", "Lsh": "↰", "Lstrok": "Ł", "Lt": "≪", "Map": "⤅", "Mcy": "М", "MediumSpace": " ", "Mellintrf": "ℳ", "Mfr": "𝔐", "MinusPlus": "∓", "Mopf": "𝕄", "Mscr": "ℳ", "Mu": "Μ", "NJcy": "Њ", "Nacute": "Ń", "Ncaron": "Ň", "Ncedil": "Ņ", "Ncy": "Н", "NegativeMediumSpace": "​", "NegativeThickSpace": "​", "NegativeThinSpace": "​", "NegativeVeryThinSpace": "​", "NestedGreaterGreater": "≫", "NestedLessLess": "≪", "NewLine": "\n", "Nfr": "𝔑", "NoBreak": "⁠", "NonBreakingSpace": " ", "Nopf": "ℕ", "Not": "⫬", "NotCongruent": "≢", "NotCupCap": "≭", "NotDoubleVerticalBar": "∦", "NotElement": "∉", "NotEqual": "≠", "NotEqualTilde": "≂̸", "NotExists": "∄", "NotGreater": "≯", "NotGreaterEqual": "≱", "NotGreaterFullEqual": "≧̸", "NotGreaterGreater": "≫̸", "NotGreaterLess": "≹", "NotGreaterSlantEqual": "⩾̸", "NotGreaterTilde": "≵", "NotHumpDownHump": "≎̸", "NotHumpEqual": "≏̸", "NotLeftTriangle": "⋪", "NotLeftTriangleBar": "⧏̸", "NotLeftTriangleEqual": "⋬", "NotLess": "≮", "NotLessEqual": "≰", "NotLessGreater": "≸", "NotLessLess": "≪̸", "NotLessSlantEqual": "⩽̸", "NotLessTilde": "≴", "NotNestedGreaterGreater": "⪢̸", "NotNestedLessLess": "⪡̸", "NotPrecedes": "⊀", "NotPrecedesEqual": "⪯̸", "NotPrecedesSlantEqual": "⋠", "NotReverseElement": "∌", "NotRightTriangle": "⋫", "NotRightTriangleBar": "⧐̸", "NotRightTriangleEqual": "⋭", "NotSquareSubset": "⊏̸", "NotSquareSubsetEqual": "⋢", "NotSquareSuperset": "⊐̸", "NotSquareSupersetEqual": "⋣", "NotSubset": "⊂⃒", "NotSubsetEqual": "⊈", "NotSucceeds": "⊁", "NotSucceedsEqual": "⪰̸", "NotSucceedsSlantEqual": "⋡", "NotSucceedsTilde": "≿̸", "NotSuperset": "⊃⃒", "NotSupersetEqual": "⊉", "NotTilde": "≁", "NotTildeEqual": "≄", "NotTildeFullEqual": "≇", "NotTildeTilde": "≉", "NotVerticalBar": "∤", "Nscr": "𝒩", "Ntild": "Ñ", "Ntilde": "Ñ", "Nu": "Ν", "OElig": "Œ", "Oacut": "Ó", "Oacute": "Ó", "Ocir": "Ô", "Ocirc": "Ô", "Ocy": "О", "Odblac": "Ő", "Ofr": "𝔒", "Ograv": "Ò", "Ograve": "Ò", "Omacr": "Ō", "Omega": "Ω", "Omicron": "Ο", "Oopf": "𝕆", "OpenCurlyDoubleQuote": "“", "OpenCurlyQuote": "‘", "Or": "⩔", "Oscr": "𝒪", "Oslas": "Ø", "Oslash": "Ø", "Otild": "Õ", "Otilde": "Õ", "Otimes": "⨷", "Oum": "Ö", "Ouml": "Ö", "OverBar": "‾", "OverBrace": "⏞", "OverBracket": "⎴", "OverParenthesis": "⏜", "PartialD": "∂", "Pcy": "П", "Pfr": "𝔓", "Phi": "Φ", "Pi": "Π", "PlusMinus": "±", "Poincareplane": "ℌ", "Popf": "ℙ", "Pr": "⪻", "Precedes": "≺", "PrecedesEqual": "⪯", "PrecedesSlantEqual": "≼", "PrecedesTilde": "≾", "Prime": "″", "Product": "∏", "Proportion": "∷", "Proportional": "∝", "Pscr": "𝒫", "Psi": "Ψ", "QUO": '"', "QUOT": '"', "Qfr": "𝔔", "Qopf": "ℚ", "Qscr": "𝒬", "RBarr": "⤐", "RE": "®", "REG": "®", "Racute": "Ŕ", "Rang": "⟫", "Rarr": "↠", "Rarrtl": "⤖", "Rcaron": "Ř", "Rcedil": "Ŗ", "Rcy": "Р", "Re": "ℜ", "ReverseElement": "∋", "ReverseEquilibrium": "⇋", "ReverseUpEquilibrium": "⥯", "Rfr": "ℜ", "Rho": "Ρ", "RightAngleBracket": "⟩", "RightArrow": "→", "RightArrowBar": "⇥", "RightArrowLeftArrow": "⇄", "RightCeiling": "⌉", "RightDoubleBracket": "⟧", "RightDownTeeVector": "⥝", "RightDownVector": "⇂", "RightDownVectorBar": "⥕", "RightFloor": "⌋", "RightTee": "⊢", "RightTeeArrow": "↦", "RightTeeVector": "⥛", "RightTriangle": "⊳", "RightTriangleBar": "⧐", "RightTriangleEqual": "⊵", "RightUpDownVector": "⥏", "RightUpTeeVector": "⥜", "RightUpVector": "↾", "RightUpVectorBar": "⥔", "RightVector": "⇀", "RightVectorBar": "⥓", "Rightarrow": "⇒", "Ropf": "ℝ", "RoundImplies": "⥰", "Rrightarrow": "⇛", "Rscr": "ℛ", "Rsh": "↱", "RuleDelayed": "⧴", "SHCHcy": "Щ", "SHcy": "Ш", "SOFTcy": "Ь", "Sacute": "Ś", "Sc": "⪼", "Scaron": "Š", "Scedil": "Ş", "Scirc": "Ŝ", "Scy": "С", "Sfr": "𝔖", "ShortDownArrow": "↓", "ShortLeftArrow": "←", "ShortRightArrow": "→", "ShortUpArrow": "↑", "Sigma": "Σ", "SmallCircle": "∘", "Sopf": "𝕊", "Sqrt": "√", "Square": "□", "SquareIntersection": "⊓", "SquareSubset": "⊏", "SquareSubsetEqual": "⊑", "SquareSuperset": "⊐", "SquareSupersetEqual": "⊒", "SquareUnion": "⊔", "Sscr": "𝒮", "Star": "⋆", "Sub": "⋐", "Subset": "⋐", "SubsetEqual": "⊆", "Succeeds": "≻", "SucceedsEqual": "⪰", "SucceedsSlantEqual": "≽", "SucceedsTilde": "≿", "SuchThat": "∋", "Sum": "∑", "Sup": "⋑", "Superset": "⊃", "SupersetEqual": "⊇", "Supset": "⋑", "THOR": "Þ", "THORN": "Þ", "TRADE": "™", "TSHcy": "Ћ", "TScy": "Ц", "Tab": "	", "Tau": "Τ", "Tcaron": "Ť", "Tcedil": "Ţ", "Tcy": "Т", "Tfr": "𝔗", "Therefore": "∴", "Theta": "Θ", "ThickSpace": "  ", "ThinSpace": " ", "Tilde": "∼", "TildeEqual": "≃", "TildeFullEqual": "≅", "TildeTilde": "≈", "Topf": "𝕋", "TripleDot": "⃛", "Tscr": "𝒯", "Tstrok": "Ŧ", "Uacut": "Ú", "Uacute": "Ú", "Uarr": "↟", "Uarrocir": "⥉", "Ubrcy": "Ў", "Ubreve": "Ŭ", "Ucir": "Û", "Ucirc": "Û", "Ucy": "У", "Udblac": "Ű", "Ufr": "𝔘", "Ugrav": "Ù", "Ugrave": "Ù", "Umacr": "Ū", "UnderBar": "_", "UnderBrace": "⏟", "UnderBracket": "⎵", "UnderParenthesis": "⏝", "Union": "⋃", "UnionPlus": "⊎", "Uogon": "Ų", "Uopf": "𝕌", "UpArrow": "↑", "UpArrowBar": "⤒", "UpArrowDownArrow": "⇅", "UpDownArrow": "↕", "UpEquilibrium": "⥮", "UpTee": "⊥", "UpTeeArrow": "↥", "Uparrow": "⇑", "Updownarrow": "⇕", "UpperLeftArrow": "↖", "UpperRightArrow": "↗", "Upsi": "ϒ", "Upsilon": "Υ", "Uring": "Ů", "Uscr": "𝒰", "Utilde": "Ũ", "Uum": "Ü", "Uuml": "Ü", "VDash": "⊫", "Vbar": "⫫", "Vcy": "В", "Vdash": "⊩", "Vdashl": "⫦", "Vee": "⋁", "Verbar": "‖", "Vert": "‖", "VerticalBar": "∣", "VerticalLine": "|", "VerticalSeparator": "❘", "VerticalTilde": "≀", "VeryThinSpace": " ", "Vfr": "𝔙", "Vopf": "𝕍", "Vscr": "𝒱", "Vvdash": "⊪", "Wcirc": "Ŵ", "Wedge": "⋀", "Wfr": "𝔚", "Wopf": "𝕎", "Wscr": "𝒲", "Xfr": "𝔛", "Xi": "Ξ", "Xopf": "𝕏", "Xscr": "𝒳", "YAcy": "Я", "YIcy": "Ї", "YUcy": "Ю", "Yacut": "Ý", "Yacute": "Ý", "Ycirc": "Ŷ", "Ycy": "Ы", "Yfr": "𝔜", "Yopf": "𝕐", "Yscr": "𝒴", "Yuml": "Ÿ", "ZHcy": "Ж", "Zacute": "Ź", "Zcaron": "Ž", "Zcy": "З", "Zdot": "Ż", "ZeroWidthSpace": "​", "Zeta": "Ζ", "Zfr": "ℨ", "Zopf": "ℤ", "Zscr": "𝒵", "aacut": "á", "aacute": "á", "abreve": "ă", "ac": "∾", "acE": "∾̳", "acd": "∿", "acir": "â", "acirc": "â", "acut": "´", "acute": "´", "acy": "а", "aeli": "æ", "aelig": "æ", "af": "⁡", "afr": "𝔞", "agrav": "à", "agrave": "à", "alefsym": "ℵ", "aleph": "ℵ", "alpha": "α", "amacr": "ā", "amalg": "⨿", "am": "&", "amp": "&", "and": "∧", "andand": "⩕", "andd": "⩜", "andslope": "⩘", "andv": "⩚", "ang": "∠", "ange": "⦤", "angle": "∠", "angmsd": "∡", "angmsdaa": "⦨", "angmsdab": "⦩", "angmsdac": "⦪", "angmsdad": "⦫", "angmsdae": "⦬", "angmsdaf": "⦭", "angmsdag": "⦮", "angmsdah": "⦯", "angrt": "∟", "angrtvb": "⊾", "angrtvbd": "⦝", "angsph": "∢", "angst": "Å", "angzarr": "⍼", "aogon": "ą", "aopf": "𝕒", "ap": "≈", "apE": "⩰", "apacir": "⩯", "ape": "≊", "apid": "≋", "apos": "'", "approx": "≈", "approxeq": "≊", "arin": "å", "aring": "å", "ascr": "𝒶", "ast": "*", "asymp": "≈", "asympeq": "≍", "atild": "ã", "atilde": "ã", "aum": "ä", "auml": "ä", "awconint": "∳", "awint": "⨑", "bNot": "⫭", "backcong": "≌", "backepsilon": "϶", "backprime": "‵", "backsim": "∽", "backsimeq": "⋍", "barvee": "⊽", "barwed": "⌅", "barwedge": "⌅", "bbrk": "⎵", "bbrktbrk": "⎶", "bcong": "≌", "bcy": "б", "bdquo": "„", "becaus": "∵", "because": "∵", "bemptyv": "⦰", "bepsi": "϶", "bernou": "ℬ", "beta": "β", "beth": "ℶ", "between": "≬", "bfr": "𝔟", "bigcap": "⋂", "bigcirc": "◯", "bigcup": "⋃", "bigodot": "⨀", "bigoplus": "⨁", "bigotimes": "⨂", "bigsqcup": "⨆", "bigstar": "★", "bigtriangledown": "▽", "bigtriangleup": "△", "biguplus": "⨄", "bigvee": "⋁", "bigwedge": "⋀", "bkarow": "⤍", "blacklozenge": "⧫", "blacksquare": "▪", "blacktriangle": "▴", "blacktriangledown": "▾", "blacktriangleleft": "◂", "blacktriangleright": "▸", "blank": "␣", "blk12": "▒", "blk14": "░", "blk34": "▓", "block": "█", "bne": "=⃥", "bnequiv": "≡⃥", "bnot": "⌐", "bopf": "𝕓", "bot": "⊥", "bottom": "⊥", "bowtie": "⋈", "boxDL": "╗", "boxDR": "╔", "boxDl": "╖", "boxDr": "╓", "boxH": "═", "boxHD": "╦", "boxHU": "╩", "boxHd": "╤", "boxHu": "╧", "boxUL": "╝", "boxUR": "╚", "boxUl": "╜", "boxUr": "╙", "boxV": "║", "boxVH": "╬", "boxVL": "╣", "boxVR": "╠", "boxVh": "╫", "boxVl": "╢", "boxVr": "╟", "boxbox": "⧉", "boxdL": "╕", "boxdR": "╒", "boxdl": "┐", "boxdr": "┌", "boxh": "─", "boxhD": "╥", "boxhU": "╨", "boxhd": "┬", "boxhu": "┴", "boxminus": "⊟", "boxplus": "⊞", "boxtimes": "⊠", "boxuL": "╛", "boxuR": "╘", "boxul": "┘", "boxur": "└", "boxv": "│", "boxvH": "╪", "boxvL": "╡", "boxvR": "╞", "boxvh": "┼", "boxvl": "┤", "boxvr": "├", "bprime": "‵", "breve": "˘", "brvba": "¦", "brvbar": "¦", "bscr": "𝒷", "bsemi": "⁏", "bsim": "∽", "bsime": "⋍", "bsol": "\\", "bsolb": "⧅", "bsolhsub": "⟈", "bull": "•", "bullet": "•", "bump": "≎", "bumpE": "⪮", "bumpe": "≏", "bumpeq": "≏", "cacute": "ć", "cap": "∩", "capand": "⩄", "capbrcup": "⩉", "capcap": "⩋", "capcup": "⩇", "capdot": "⩀", "caps": "∩︀", "caret": "⁁", "caron": "ˇ", "ccaps": "⩍", "ccaron": "č", "ccedi": "ç", "ccedil": "ç", "ccirc": "ĉ", "ccups": "⩌", "ccupssm": "⩐", "cdot": "ċ", "cedi": "¸", "cedil": "¸", "cemptyv": "⦲", "cen": "¢", "cent": "¢", "centerdot": "·", "cfr": "𝔠", "chcy": "ч", "check": "✓", "checkmark": "✓", "chi": "χ", "cir": "○", "cirE": "⧃", "circ": "ˆ", "circeq": "≗", "circlearrowleft": "↺", "circlearrowright": "↻", "circledR": "®", "circledS": "Ⓢ", "circledast": "⊛", "circledcirc": "⊚", "circleddash": "⊝", "cire": "≗", "cirfnint": "⨐", "cirmid": "⫯", "cirscir": "⧂", "clubs": "♣", "clubsuit": "♣", "colon": ":", "colone": "≔", "coloneq": "≔", "comma": ",", "commat": "@", "comp": "∁", "compfn": "∘", "complement": "∁", "complexes": "ℂ", "cong": "≅", "congdot": "⩭", "conint": "∮", "copf": "𝕔", "coprod": "∐", "cop": "©", "copy": "©", "copysr": "℗", "crarr": "↵", "cross": "✗", "cscr": "𝒸", "csub": "⫏", "csube": "⫑", "csup": "⫐", "csupe": "⫒", "ctdot": "⋯", "cudarrl": "⤸", "cudarrr": "⤵", "cuepr": "⋞", "cuesc": "⋟", "cularr": "↶", "cularrp": "⤽", "cup": "∪", "cupbrcap": "⩈", "cupcap": "⩆", "cupcup": "⩊", "cupdot": "⊍", "cupor": "⩅", "cups": "∪︀", "curarr": "↷", "curarrm": "⤼", "curlyeqprec": "⋞", "curlyeqsucc": "⋟", "curlyvee": "⋎", "curlywedge": "⋏", "curre": "¤", "curren": "¤", "curvearrowleft": "↶", "curvearrowright": "↷", "cuvee": "⋎", "cuwed": "⋏", "cwconint": "∲", "cwint": "∱", "cylcty": "⌭", "dArr": "⇓", "dHar": "⥥", "dagger": "†", "daleth": "ℸ", "darr": "↓", "dash": "‐", "dashv": "⊣", "dbkarow": "⤏", "dblac": "˝", "dcaron": "ď", "dcy": "д", "dd": "ⅆ", "ddagger": "‡", "ddarr": "⇊", "ddotseq": "⩷", "de": "°", "deg": "°", "delta": "δ", "demptyv": "⦱", "dfisht": "⥿", "dfr": "𝔡", "dharl": "⇃", "dharr": "⇂", "diam": "⋄", "diamond": "⋄", "diamondsuit": "♦", "diams": "♦", "die": "¨", "digamma": "ϝ", "disin": "⋲", "div": "÷", "divid": "÷", "divide": "÷", "divideontimes": "⋇", "divonx": "⋇", "djcy": "ђ", "dlcorn": "⌞", "dlcrop": "⌍", "dollar": "$", "dopf": "𝕕", "dot": "˙", "doteq": "≐", "doteqdot": "≑", "dotminus": "∸", "dotplus": "∔", "dotsquare": "⊡", "doublebarwedge": "⌆", "downarrow": "↓", "downdownarrows": "⇊", "downharpoonleft": "⇃", "downharpoonright": "⇂", "drbkarow": "⤐", "drcorn": "⌟", "drcrop": "⌌", "dscr": "𝒹", "dscy": "ѕ", "dsol": "⧶", "dstrok": "đ", "dtdot": "⋱", "dtri": "▿", "dtrif": "▾", "duarr": "⇵", "duhar": "⥯", "dwangle": "⦦", "dzcy": "џ", "dzigrarr": "⟿", "eDDot": "⩷", "eDot": "≑", "eacut": "é", "eacute": "é", "easter": "⩮", "ecaron": "ě", "ecir": "ê", "ecirc": "ê", "ecolon": "≕", "ecy": "э", "edot": "ė", "ee": "ⅇ", "efDot": "≒", "efr": "𝔢", "eg": "⪚", "egrav": "è", "egrave": "è", "egs": "⪖", "egsdot": "⪘", "el": "⪙", "elinters": "⏧", "ell": "ℓ", "els": "⪕", "elsdot": "⪗", "emacr": "ē", "empty": "∅", "emptyset": "∅", "emptyv": "∅", "emsp13": " ", "emsp14": " ", "emsp": " ", "eng": "ŋ", "ensp": " ", "eogon": "ę", "eopf": "𝕖", "epar": "⋕", "eparsl": "⧣", "eplus": "⩱", "epsi": "ε", "epsilon": "ε", "epsiv": "ϵ", "eqcirc": "≖", "eqcolon": "≕", "eqsim": "≂", "eqslantgtr": "⪖", "eqslantless": "⪕", "equals": "=", "equest": "≟", "equiv": "≡", "equivDD": "⩸", "eqvparsl": "⧥", "erDot": "≓", "erarr": "⥱", "escr": "ℯ", "esdot": "≐", "esim": "≂", "eta": "η", "et": "ð", "eth": "ð", "eum": "ë", "euml": "ë", "euro": "€", "excl": "!", "exist": "∃", "expectation": "ℰ", "exponentiale": "ⅇ", "fallingdotseq": "≒", "fcy": "ф", "female": "♀", "ffilig": "ﬃ", "fflig": "ﬀ", "ffllig": "ﬄ", "ffr": "𝔣", "filig": "ﬁ", "fjlig": "fj", "flat": "♭", "fllig": "ﬂ", "fltns": "▱", "fnof": "ƒ", "fopf": "𝕗", "forall": "∀", "fork": "⋔", "forkv": "⫙", "fpartint": "⨍", "frac1": "¼", "frac12": "½", "frac13": "⅓", "frac14": "¼", "frac15": "⅕", "frac16": "⅙", "frac18": "⅛", "frac23": "⅔", "frac25": "⅖", "frac3": "¾", "frac34": "¾", "frac35": "⅗", "frac38": "⅜", "frac45": "⅘", "frac56": "⅚", "frac58": "⅝", "frac78": "⅞", "frasl": "⁄", "frown": "⌢", "fscr": "𝒻", "gE": "≧", "gEl": "⪌", "gacute": "ǵ", "gamma": "γ", "gammad": "ϝ", "gap": "⪆", "gbreve": "ğ", "gcirc": "ĝ", "gcy": "г", "gdot": "ġ", "ge": "≥", "gel": "⋛", "geq": "≥", "geqq": "≧", "geqslant": "⩾", "ges": "⩾", "gescc": "⪩", "gesdot": "⪀", "gesdoto": "⪂", "gesdotol": "⪄", "gesl": "⋛︀", "gesles": "⪔", "gfr": "𝔤", "gg": "≫", "ggg": "⋙", "gimel": "ℷ", "gjcy": "ѓ", "gl": "≷", "glE": "⪒", "gla": "⪥", "glj": "⪤", "gnE": "≩", "gnap": "⪊", "gnapprox": "⪊", "gne": "⪈", "gneq": "⪈", "gneqq": "≩", "gnsim": "⋧", "gopf": "𝕘", "grave": "`", "gscr": "ℊ", "gsim": "≳", "gsime": "⪎", "gsiml": "⪐", "g": ">", "gt": ">", "gtcc": "⪧", "gtcir": "⩺", "gtdot": "⋗", "gtlPar": "⦕", "gtquest": "⩼", "gtrapprox": "⪆", "gtrarr": "⥸", "gtrdot": "⋗", "gtreqless": "⋛", "gtreqqless": "⪌", "gtrless": "≷", "gtrsim": "≳", "gvertneqq": "≩︀", "gvnE": "≩︀", "hArr": "⇔", "hairsp": " ", "half": "½", "hamilt": "ℋ", "hardcy": "ъ", "harr": "↔", "harrcir": "⥈", "harrw": "↭", "hbar": "ℏ", "hcirc": "ĥ", "hearts": "♥", "heartsuit": "♥", "hellip": "…", "hercon": "⊹", "hfr": "𝔥", "hksearow": "⤥", "hkswarow": "⤦", "hoarr": "⇿", "homtht": "∻", "hookleftarrow": "↩", "hookrightarrow": "↪", "hopf": "𝕙", "horbar": "―", "hscr": "𝒽", "hslash": "ℏ", "hstrok": "ħ", "hybull": "⁃", "hyphen": "‐", "iacut": "í", "iacute": "í", "ic": "⁣", "icir": "î", "icirc": "î", "icy": "и", "iecy": "е", "iexc": "¡", "iexcl": "¡", "iff": "⇔", "ifr": "𝔦", "igrav": "ì", "igrave": "ì", "ii": "ⅈ", "iiiint": "⨌", "iiint": "∭", "iinfin": "⧜", "iiota": "℩", "ijlig": "ĳ", "imacr": "ī", "image": "ℑ", "imagline": "ℐ", "imagpart": "ℑ", "imath": "ı", "imof": "⊷", "imped": "Ƶ", "in": "∈", "incare": "℅", "infin": "∞", "infintie": "⧝", "inodot": "ı", "int": "∫", "intcal": "⊺", "integers": "ℤ", "intercal": "⊺", "intlarhk": "⨗", "intprod": "⨼", "iocy": "ё", "iogon": "į", "iopf": "𝕚", "iota": "ι", "iprod": "⨼", "iques": "¿", "iquest": "¿", "iscr": "𝒾", "isin": "∈", "isinE": "⋹", "isindot": "⋵", "isins": "⋴", "isinsv": "⋳", "isinv": "∈", "it": "⁢", "itilde": "ĩ", "iukcy": "і", "ium": "ï", "iuml": "ï", "jcirc": "ĵ", "jcy": "й", "jfr": "𝔧", "jmath": "ȷ", "jopf": "𝕛", "jscr": "𝒿", "jsercy": "ј", "jukcy": "є", "kappa": "κ", "kappav": "ϰ", "kcedil": "ķ", "kcy": "к", "kfr": "𝔨", "kgreen": "ĸ", "khcy": "х", "kjcy": "ќ", "kopf": "𝕜", "kscr": "𝓀", "lAarr": "⇚", "lArr": "⇐", "lAtail": "⤛", "lBarr": "⤎", "lE": "≦", "lEg": "⪋", "lHar": "⥢", "lacute": "ĺ", "laemptyv": "⦴", "lagran": "ℒ", "lambda": "λ", "lang": "⟨", "langd": "⦑", "langle": "⟨", "lap": "⪅", "laqu": "«", "laquo": "«", "larr": "←", "larrb": "⇤", "larrbfs": "⤟", "larrfs": "⤝", "larrhk": "↩", "larrlp": "↫", "larrpl": "⤹", "larrsim": "⥳", "larrtl": "↢", "lat": "⪫", "latail": "⤙", "late": "⪭", "lates": "⪭︀", "lbarr": "⤌", "lbbrk": "❲", "lbrace": "{", "lbrack": "[", "lbrke": "⦋", "lbrksld": "⦏", "lbrkslu": "⦍", "lcaron": "ľ", "lcedil": "ļ", "lceil": "⌈", "lcub": "{", "lcy": "л", "ldca": "⤶", "ldquo": "“", "ldquor": "„", "ldrdhar": "⥧", "ldrushar": "⥋", "ldsh": "↲", "le": "≤", "leftarrow": "←", "leftarrowtail": "↢", "leftharpoondown": "↽", "leftharpoonup": "↼", "leftleftarrows": "⇇", "leftrightarrow": "↔", "leftrightarrows": "⇆", "leftrightharpoons": "⇋", "leftrightsquigarrow": "↭", "leftthreetimes": "⋋", "leg": "⋚", "leq": "≤", "leqq": "≦", "leqslant": "⩽", "les": "⩽", "lescc": "⪨", "lesdot": "⩿", "lesdoto": "⪁", "lesdotor": "⪃", "lesg": "⋚︀", "lesges": "⪓", "lessapprox": "⪅", "lessdot": "⋖", "lesseqgtr": "⋚", "lesseqqgtr": "⪋", "lessgtr": "≶", "lesssim": "≲", "lfisht": "⥼", "lfloor": "⌊", "lfr": "𝔩", "lg": "≶", "lgE": "⪑", "lhard": "↽", "lharu": "↼", "lharul": "⥪", "lhblk": "▄", "ljcy": "љ", "ll": "≪", "llarr": "⇇", "llcorner": "⌞", "llhard": "⥫", "lltri": "◺", "lmidot": "ŀ", "lmoust": "⎰", "lmoustache": "⎰", "lnE": "≨", "lnap": "⪉", "lnapprox": "⪉", "lne": "⪇", "lneq": "⪇", "lneqq": "≨", "lnsim": "⋦", "loang": "⟬", "loarr": "⇽", "lobrk": "⟦", "longleftarrow": "⟵", "longleftrightarrow": "⟷", "longmapsto": "⟼", "longrightarrow": "⟶", "looparrowleft": "↫", "looparrowright": "↬", "lopar": "⦅", "lopf": "𝕝", "loplus": "⨭", "lotimes": "⨴", "lowast": "∗", "lowbar": "_", "loz": "◊", "lozenge": "◊", "lozf": "⧫", "lpar": "(", "lparlt": "⦓", "lrarr": "⇆", "lrcorner": "⌟", "lrhar": "⇋", "lrhard": "⥭", "lrm": "‎", "lrtri": "⊿", "lsaquo": "‹", "lscr": "𝓁", "lsh": "↰", "lsim": "≲", "lsime": "⪍", "lsimg": "⪏", "lsqb": "[", "lsquo": "‘", "lsquor": "‚", "lstrok": "ł", "l": "<", "lt": "<", "ltcc": "⪦", "ltcir": "⩹", "ltdot": "⋖", "lthree": "⋋", "ltimes": "⋉", "ltlarr": "⥶", "ltquest": "⩻", "ltrPar": "⦖", "ltri": "◃", "ltrie": "⊴", "ltrif": "◂", "lurdshar": "⥊", "luruhar": "⥦", "lvertneqq": "≨︀", "lvnE": "≨︀", "mDDot": "∺", "mac": "¯", "macr": "¯", "male": "♂", "malt": "✠", "maltese": "✠", "map": "↦", "mapsto": "↦", "mapstodown": "↧", "mapstoleft": "↤", "mapstoup": "↥", "marker": "▮", "mcomma": "⨩", "mcy": "м", "mdash": "—", "measuredangle": "∡", "mfr": "𝔪", "mho": "℧", "micr": "µ", "micro": "µ", "mid": "∣", "midast": "*", "midcir": "⫰", "middo": "·", "middot": "·", "minus": "−", "minusb": "⊟", "minusd": "∸", "minusdu": "⨪", "mlcp": "⫛", "mldr": "…", "mnplus": "∓", "models": "⊧", "mopf": "𝕞", "mp": "∓", "mscr": "𝓂", "mstpos": "∾", "mu": "μ", "multimap": "⊸", "mumap": "⊸", "nGg": "⋙̸", "nGt": "≫⃒", "nGtv": "≫̸", "nLeftarrow": "⇍", "nLeftrightarrow": "⇎", "nLl": "⋘̸", "nLt": "≪⃒", "nLtv": "≪̸", "nRightarrow": "⇏", "nVDash": "⊯", "nVdash": "⊮", "nabla": "∇", "nacute": "ń", "nang": "∠⃒", "nap": "≉", "napE": "⩰̸", "napid": "≋̸", "napos": "ŉ", "napprox": "≉", "natur": "♮", "natural": "♮", "naturals": "ℕ", "nbs": " ", "nbsp": " ", "nbump": "≎̸", "nbumpe": "≏̸", "ncap": "⩃", "ncaron": "ň", "ncedil": "ņ", "ncong": "≇", "ncongdot": "⩭̸", "ncup": "⩂", "ncy": "н", "ndash": "–", "ne": "≠", "neArr": "⇗", "nearhk": "⤤", "nearr": "↗", "nearrow": "↗", "nedot": "≐̸", "nequiv": "≢", "nesear": "⤨", "nesim": "≂̸", "nexist": "∄", "nexists": "∄", "nfr": "𝔫", "ngE": "≧̸", "nge": "≱", "ngeq": "≱", "ngeqq": "≧̸", "ngeqslant": "⩾̸", "nges": "⩾̸", "ngsim": "≵", "ngt": "≯", "ngtr": "≯", "nhArr": "⇎", "nharr": "↮", "nhpar": "⫲", "ni": "∋", "nis": "⋼", "nisd": "⋺", "niv": "∋", "njcy": "њ", "nlArr": "⇍", "nlE": "≦̸", "nlarr": "↚", "nldr": "‥", "nle": "≰", "nleftarrow": "↚", "nleftrightarrow": "↮", "nleq": "≰", "nleqq": "≦̸", "nleqslant": "⩽̸", "nles": "⩽̸", "nless": "≮", "nlsim": "≴", "nlt": "≮", "nltri": "⋪", "nltrie": "⋬", "nmid": "∤", "nopf": "𝕟", "no": "¬", "not": "¬", "notin": "∉", "notinE": "⋹̸", "notindot": "⋵̸", "notinva": "∉", "notinvb": "⋷", "notinvc": "⋶", "notni": "∌", "notniva": "∌", "notnivb": "⋾", "notnivc": "⋽", "npar": "∦", "nparallel": "∦", "nparsl": "⫽⃥", "npart": "∂̸", "npolint": "⨔", "npr": "⊀", "nprcue": "⋠", "npre": "⪯̸", "nprec": "⊀", "npreceq": "⪯̸", "nrArr": "⇏", "nrarr": "↛", "nrarrc": "⤳̸", "nrarrw": "↝̸", "nrightarrow": "↛", "nrtri": "⋫", "nrtrie": "⋭", "nsc": "⊁", "nsccue": "⋡", "nsce": "⪰̸", "nscr": "𝓃", "nshortmid": "∤", "nshortparallel": "∦", "nsim": "≁", "nsime": "≄", "nsimeq": "≄", "nsmid": "∤", "nspar": "∦", "nsqsube": "⋢", "nsqsupe": "⋣", "nsub": "⊄", "nsubE": "⫅̸", "nsube": "⊈", "nsubset": "⊂⃒", "nsubseteq": "⊈", "nsubseteqq": "⫅̸", "nsucc": "⊁", "nsucceq": "⪰̸", "nsup": "⊅", "nsupE": "⫆̸", "nsupe": "⊉", "nsupset": "⊃⃒", "nsupseteq": "⊉", "nsupseteqq": "⫆̸", "ntgl": "≹", "ntild": "ñ", "ntilde": "ñ", "ntlg": "≸", "ntriangleleft": "⋪", "ntrianglelefteq": "⋬", "ntriangleright": "⋫", "ntrianglerighteq": "⋭", "nu": "ν", "num": "#", "numero": "№", "numsp": " ", "nvDash": "⊭", "nvHarr": "⤄", "nvap": "≍⃒", "nvdash": "⊬", "nvge": "≥⃒", "nvgt": ">⃒", "nvinfin": "⧞", "nvlArr": "⤂", "nvle": "≤⃒", "nvlt": "<⃒", "nvltrie": "⊴⃒", "nvrArr": "⤃", "nvrtrie": "⊵⃒", "nvsim": "∼⃒", "nwArr": "⇖", "nwarhk": "⤣", "nwarr": "↖", "nwarrow": "↖", "nwnear": "⤧", "oS": "Ⓢ", "oacut": "ó", "oacute": "ó", "oast": "⊛", "ocir": "ô", "ocirc": "ô", "ocy": "о", "odash": "⊝", "odblac": "ő", "odiv": "⨸", "odot": "⊙", "odsold": "⦼", "oelig": "œ", "ofcir": "⦿", "ofr": "𝔬", "ogon": "˛", "ograv": "ò", "ograve": "ò", "ogt": "⧁", "ohbar": "⦵", "ohm": "Ω", "oint": "∮", "olarr": "↺", "olcir": "⦾", "olcross": "⦻", "oline": "‾", "olt": "⧀", "omacr": "ō", "omega": "ω", "omicron": "ο", "omid": "⦶", "ominus": "⊖", "oopf": "𝕠", "opar": "⦷", "operp": "⦹", "oplus": "⊕", "or": "∨", "orarr": "↻", "ord": "º", "order": "ℴ", "orderof": "ℴ", "ordf": "ª", "ordm": "º", "origof": "⊶", "oror": "⩖", "orslope": "⩗", "orv": "⩛", "oscr": "ℴ", "oslas": "ø", "oslash": "ø", "osol": "⊘", "otild": "õ", "otilde": "õ", "otimes": "⊗", "otimesas": "⨶", "oum": "ö", "ouml": "ö", "ovbar": "⌽", "par": "¶", "para": "¶", "parallel": "∥", "parsim": "⫳", "parsl": "⫽", "part": "∂", "pcy": "п", "percnt": "%", "period": ".", "permil": "‰", "perp": "⊥", "pertenk": "‱", "pfr": "𝔭", "phi": "φ", "phiv": "ϕ", "phmmat": "ℳ", "phone": "☎", "pi": "π", "pitchfork": "⋔", "piv": "ϖ", "planck": "ℏ", "planckh": "ℎ", "plankv": "ℏ", "plus": "+", "plusacir": "⨣", "plusb": "⊞", "pluscir": "⨢", "plusdo": "∔", "plusdu": "⨥", "pluse": "⩲", "plusm": "±", "plusmn": "±", "plussim": "⨦", "plustwo": "⨧", "pm": "±", "pointint": "⨕", "popf": "𝕡", "poun": "£", "pound": "£", "pr": "≺", "prE": "⪳", "prap": "⪷", "prcue": "≼", "pre": "⪯", "prec": "≺", "precapprox": "⪷", "preccurlyeq": "≼", "preceq": "⪯", "precnapprox": "⪹", "precneqq": "⪵", "precnsim": "⋨", "precsim": "≾", "prime": "′", "primes": "ℙ", "prnE": "⪵", "prnap": "⪹", "prnsim": "⋨", "prod": "∏", "profalar": "⌮", "profline": "⌒", "profsurf": "⌓", "prop": "∝", "propto": "∝", "prsim": "≾", "prurel": "⊰", "pscr": "𝓅", "psi": "ψ", "puncsp": " ", "qfr": "𝔮", "qint": "⨌", "qopf": "𝕢", "qprime": "⁗", "qscr": "𝓆", "quaternions": "ℍ", "quatint": "⨖", "quest": "?", "questeq": "≟", "quo": '"', "quot": '"', "rAarr": "⇛", "rArr": "⇒", "rAtail": "⤜", "rBarr": "⤏", "rHar": "⥤", "race": "∽̱", "racute": "ŕ", "radic": "√", "raemptyv": "⦳", "rang": "⟩", "rangd": "⦒", "range": "⦥", "rangle": "⟩", "raqu": "»", "raquo": "»", "rarr": "→", "rarrap": "⥵", "rarrb": "⇥", "rarrbfs": "⤠", "rarrc": "⤳", "rarrfs": "⤞", "rarrhk": "↪", "rarrlp": "↬", "rarrpl": "⥅", "rarrsim": "⥴", "rarrtl": "↣", "rarrw": "↝", "ratail": "⤚", "ratio": "∶", "rationals": "ℚ", "rbarr": "⤍", "rbbrk": "❳", "rbrace": "}", "rbrack": "]", "rbrke": "⦌", "rbrksld": "⦎", "rbrkslu": "⦐", "rcaron": "ř", "rcedil": "ŗ", "rceil": "⌉", "rcub": "}", "rcy": "р", "rdca": "⤷", "rdldhar": "⥩", "rdquo": "”", "rdquor": "”", "rdsh": "↳", "real": "ℜ", "realine": "ℛ", "realpart": "ℜ", "reals": "ℝ", "rect": "▭", "re": "®", "reg": "®", "rfisht": "⥽", "rfloor": "⌋", "rfr": "𝔯", "rhard": "⇁", "rharu": "⇀", "rharul": "⥬", "rho": "ρ", "rhov": "ϱ", "rightarrow": "→", "rightarrowtail": "↣", "rightharpoondown": "⇁", "rightharpoonup": "⇀", "rightleftarrows": "⇄", "rightleftharpoons": "⇌", "rightrightarrows": "⇉", "rightsquigarrow": "↝", "rightthreetimes": "⋌", "ring": "˚", "risingdotseq": "≓", "rlarr": "⇄", "rlhar": "⇌", "rlm": "‏", "rmoust": "⎱", "rmoustache": "⎱", "rnmid": "⫮", "roang": "⟭", "roarr": "⇾", "robrk": "⟧", "ropar": "⦆", "ropf": "𝕣", "roplus": "⨮", "rotimes": "⨵", "rpar": ")", "rpargt": "⦔", "rppolint": "⨒", "rrarr": "⇉", "rsaquo": "›", "rscr": "𝓇", "rsh": "↱", "rsqb": "]", "rsquo": "’", "rsquor": "’", "rthree": "⋌", "rtimes": "⋊", "rtri": "▹", "rtrie": "⊵", "rtrif": "▸", "rtriltri": "⧎", "ruluhar": "⥨", "rx": "℞", "sacute": "ś", "sbquo": "‚", "sc": "≻", "scE": "⪴", "scap": "⪸", "scaron": "š", "sccue": "≽", "sce": "⪰", "scedil": "ş", "scirc": "ŝ", "scnE": "⪶", "scnap": "⪺", "scnsim": "⋩", "scpolint": "⨓", "scsim": "≿", "scy": "с", "sdot": "⋅", "sdotb": "⊡", "sdote": "⩦", "seArr": "⇘", "searhk": "⤥", "searr": "↘", "searrow": "↘", "sec": "§", "sect": "§", "semi": ";", "seswar": "⤩", "setminus": "∖", "setmn": "∖", "sext": "✶", "sfr": "𝔰", "sfrown": "⌢", "sharp": "♯", "shchcy": "щ", "shcy": "ш", "shortmid": "∣", "shortparallel": "∥", "sh": "­", "shy": "­", "sigma": "σ", "sigmaf": "ς", "sigmav": "ς", "sim": "∼", "simdot": "⩪", "sime": "≃", "simeq": "≃", "simg": "⪞", "simgE": "⪠", "siml": "⪝", "simlE": "⪟", "simne": "≆", "simplus": "⨤", "simrarr": "⥲", "slarr": "←", "smallsetminus": "∖", "smashp": "⨳", "smeparsl": "⧤", "smid": "∣", "smile": "⌣", "smt": "⪪", "smte": "⪬", "smtes": "⪬︀", "softcy": "ь", "sol": "/", "solb": "⧄", "solbar": "⌿", "sopf": "𝕤", "spades": "♠", "spadesuit": "♠", "spar": "∥", "sqcap": "⊓", "sqcaps": "⊓︀", "sqcup": "⊔", "sqcups": "⊔︀", "sqsub": "⊏", "sqsube": "⊑", "sqsubset": "⊏", "sqsubseteq": "⊑", "sqsup": "⊐", "sqsupe": "⊒", "sqsupset": "⊐", "sqsupseteq": "⊒", "squ": "□", "square": "□", "squarf": "▪", "squf": "▪", "srarr": "→", "sscr": "𝓈", "ssetmn": "∖", "ssmile": "⌣", "sstarf": "⋆", "star": "☆", "starf": "★", "straightepsilon": "ϵ", "straightphi": "ϕ", "strns": "¯", "sub": "⊂", "subE": "⫅", "subdot": "⪽", "sube": "⊆", "subedot": "⫃", "submult": "⫁", "subnE": "⫋", "subne": "⊊", "subplus": "⪿", "subrarr": "⥹", "subset": "⊂", "subseteq": "⊆", "subseteqq": "⫅", "subsetneq": "⊊", "subsetneqq": "⫋", "subsim": "⫇", "subsub": "⫕", "subsup": "⫓", "succ": "≻", "succapprox": "⪸", "succcurlyeq": "≽", "succeq": "⪰", "succnapprox": "⪺", "succneqq": "⪶", "succnsim": "⋩", "succsim": "≿", "sum": "∑", "sung": "♪", "sup": "⊃", "sup1": "¹", "sup2": "²", "sup3": "³", "supE": "⫆", "supdot": "⪾", "supdsub": "⫘", "supe": "⊇", "supedot": "⫄", "suphsol": "⟉", "suphsub": "⫗", "suplarr": "⥻", "supmult": "⫂", "supnE": "⫌", "supne": "⊋", "supplus": "⫀", "supset": "⊃", "supseteq": "⊇", "supseteqq": "⫆", "supsetneq": "⊋", "supsetneqq": "⫌", "supsim": "⫈", "supsub": "⫔", "supsup": "⫖", "swArr": "⇙", "swarhk": "⤦", "swarr": "↙", "swarrow": "↙", "swnwar": "⤪", "szli": "ß", "szlig": "ß", "target": "⌖", "tau": "τ", "tbrk": "⎴", "tcaron": "ť", "tcedil": "ţ", "tcy": "т", "tdot": "⃛", "telrec": "⌕", "tfr": "𝔱", "there4": "∴", "therefore": "∴", "theta": "θ", "thetasym": "ϑ", "thetav": "ϑ", "thickapprox": "≈", "thicksim": "∼", "thinsp": " ", "thkap": "≈", "thksim": "∼", "thor": "þ", "thorn": "þ", "tilde": "˜", "time": "×", "times": "×", "timesb": "⊠", "timesbar": "⨱", "timesd": "⨰", "tint": "∭", "toea": "⤨", "top": "⊤", "topbot": "⌶", "topcir": "⫱", "topf": "𝕥", "topfork": "⫚", "tosa": "⤩", "tprime": "‴", "trade": "™", "triangle": "▵", "triangledown": "▿", "triangleleft": "◃", "trianglelefteq": "⊴", "triangleq": "≜", "triangleright": "▹", "trianglerighteq": "⊵", "tridot": "◬", "trie": "≜", "triminus": "⨺", "triplus": "⨹", "trisb": "⧍", "tritime": "⨻", "trpezium": "⏢", "tscr": "𝓉", "tscy": "ц", "tshcy": "ћ", "tstrok": "ŧ", "twixt": "≬", "twoheadleftarrow": "↞", "twoheadrightarrow": "↠", "uArr": "⇑", "uHar": "⥣", "uacut": "ú", "uacute": "ú", "uarr": "↑", "ubrcy": "ў", "ubreve": "ŭ", "ucir": "û", "ucirc": "û", "ucy": "у", "udarr": "⇅", "udblac": "ű", "udhar": "⥮", "ufisht": "⥾", "ufr": "𝔲", "ugrav": "ù", "ugrave": "ù", "uharl": "↿", "uharr": "↾", "uhblk": "▀", "ulcorn": "⌜", "ulcorner": "⌜", "ulcrop": "⌏", "ultri": "◸", "umacr": "ū", "um": "¨", "uml": "¨", "uogon": "ų", "uopf": "𝕦", "uparrow": "↑", "updownarrow": "↕", "upharpoonleft": "↿", "upharpoonright": "↾", "uplus": "⊎", "upsi": "υ", "upsih": "ϒ", "upsilon": "υ", "upuparrows": "⇈", "urcorn": "⌝", "urcorner": "⌝", "urcrop": "⌎", "uring": "ů", "urtri": "◹", "uscr": "𝓊", "utdot": "⋰", "utilde": "ũ", "utri": "▵", "utrif": "▴", "uuarr": "⇈", "uum": "ü", "uuml": "ü", "uwangle": "⦧", "vArr": "⇕", "vBar": "⫨", "vBarv": "⫩", "vDash": "⊨", "vangrt": "⦜", "varepsilon": "ϵ", "varkappa": "ϰ", "varnothing": "∅", "varphi": "ϕ", "varpi": "ϖ", "varpropto": "∝", "varr": "↕", "varrho": "ϱ", "varsigma": "ς", "varsubsetneq": "⊊︀", "varsubsetneqq": "⫋︀", "varsupsetneq": "⊋︀", "varsupsetneqq": "⫌︀", "vartheta": "ϑ", "vartriangleleft": "⊲", "vartriangleright": "⊳", "vcy": "в", "vdash": "⊢", "vee": "∨", "veebar": "⊻", "veeeq": "≚", "vellip": "⋮", "verbar": "|", "vert": "|", "vfr": "𝔳", "vltri": "⊲", "vnsub": "⊂⃒", "vnsup": "⊃⃒", "vopf": "𝕧", "vprop": "∝", "vrtri": "⊳", "vscr": "𝓋", "vsubnE": "⫋︀", "vsubne": "⊊︀", "vsupnE": "⫌︀", "vsupne": "⊋︀", "vzigzag": "⦚", "wcirc": "ŵ", "wedbar": "⩟", "wedge": "∧", "wedgeq": "≙", "weierp": "℘", "wfr": "𝔴", "wopf": "𝕨", "wp": "℘", "wr": "≀", "wreath": "≀", "wscr": "𝓌", "xcap": "⋂", "xcirc": "◯", "xcup": "⋃", "xdtri": "▽", "xfr": "𝔵", "xhArr": "⟺", "xharr": "⟷", "xi": "ξ", "xlArr": "⟸", "xlarr": "⟵", "xmap": "⟼", "xnis": "⋻", "xodot": "⨀", "xopf": "𝕩", "xoplus": "⨁", "xotime": "⨂", "xrArr": "⟹", "xrarr": "⟶", "xscr": "𝓍", "xsqcup": "⨆", "xuplus": "⨄", "xutri": "△", "xvee": "⋁", "xwedge": "⋀", "yacut": "ý", "yacute": "ý", "yacy": "я", "ycirc": "ŷ", "ycy": "ы", "ye": "¥", "yen": "¥", "yfr": "𝔶", "yicy": "ї", "yopf": "𝕪", "yscr": "𝓎", "yucy": "ю", "yum": "ÿ", "yuml": "ÿ", "zacute": "ź", "zcaron": "ž", "zcy": "з", "zdot": "ż", "zeetrf": "ℨ", "zeta": "ζ", "zfr": "𝔷", "zhcy": "ж", "zigrarr": "⇝", "zopf": "𝕫", "zscr": "𝓏", "zwj": "‍", "zwnj": "‌" };
const ENTITY_MAP = _ENTITY_MAP;
function entityStringToRawString(entityStr) {
  if (!entityStr.startsWith("&")) {
    entityStr = "&" + entityStr;
  }
  if (!entityStr.endsWith(";")) {
    entityStr += ";";
  }
  try {
    if (entityStr.charAt(1) === "#") {
      const val = entityStr.charAt(2) === "x" ? parseInt(entityStr.slice(3, entityStr.length - 1), 16) : parseInt(entityStr.slice(2, entityStr.length - 1), 10);
      return String.fromCharCode(val);
    }
    const trimmedEntityString = entityStr.slice(1, entityStr.length - 1);
    if (trimmedEntityString in ENTITY_MAP) {
      return ENTITY_MAP[trimmedEntityString];
    }
  } catch (e2) {
    console.warn(
      `Encountered error when converting entity "${entityStr}": ${e2.message}`
    );
  }
  console.warn(`Cannot convert XML entity "${entityStr}"`);
  return entityStr;
}
function entityToString(node, source) {
  switch (node.name) {
    case "CharacterReference":
    case "EntityReference": {
      const entity = extractContent(node, source);
      const converted = entityStringToRawString(entity);
      if (converted === "$" && /[a-zA-Z_]/.test(source.charAt(node.to))) {
        return converted + "​";
      }
      return converted;
    }
  }
  throw new Error(
    `Cannot use entityToString to convert a node of type ${node.name}`
  );
}
function removeQuotes(str) {
  if (str.startsWith("'") || str.startsWith('"')) {
    str = str.slice(1);
  }
  if (str.endsWith("'") || str.endsWith('"')) {
    str = str.slice(0, str.length - 1);
  }
  return str;
}
function unescapeEntities(node, source) {
  const rawValue = extractContent(node, source);
  const entities2 = node.getChildren("EntityReference");
  if (entities2.length === 0) {
    return rawValue;
  }
  let i2 = 0;
  let ret = "";
  for (const entity of entities2) {
    ret += rawValue.slice(i2, entity.from - node.from);
    ret += entityToString(entity, source);
    i2 = entity.to - node.from;
  }
  ret += rawValue.slice(i2);
  return ret;
}
function textNodeToText(node, source) {
  if (node.name !== "Text") {
    throw new Error(
      `Can only convert node of type "Text", not the passed-in type of "${node.name}"`
    );
  }
  return unescapeEntities(node, source);
}
function attributeValueText(node, source) {
  if (node.name !== "AttributeValue") {
    throw new Error(
      `Can only get the text of an "AttributeValue" type node, not "${node.name}"`
    );
  }
  return removeQuotes(unescapeEntities(node, source));
}
function lezerNodeToPosition(node, offsetToPositionMap, adjustForQuotes = false) {
  const { rowMap, columnMap } = offsetToPositionMap;
  let { from, to: to2 } = node;
  if (adjustForQuotes) {
    from += 1;
    to2 -= 1;
  }
  return {
    start: {
      line: rowMap[from] + 1,
      column: columnMap[from] + 1,
      offset: from
    },
    end: { line: rowMap[to2] + 1, column: columnMap[to2] + 1, offset: to2 }
  };
}
function extractContent(node, source) {
  return source.slice(node.from, node.to);
}
function createOffsetToPositionMap$1(source) {
  const rowMap = new Uint32Array(source.length + 1);
  const columnMap = new Uint32Array(source.length + 1);
  const len = source.length;
  let currentRow = 0;
  let currentColumn = 0;
  for (let i2 = 0; i2 < len; i2++) {
    rowMap[i2] = currentRow;
    columnMap[i2] = currentColumn;
    if (source.charAt(i2) === "\n") {
      currentRow += 1;
      currentColumn = 0;
    } else {
      currentColumn += 1;
    }
  }
  rowMap[len] = currentRow;
  columnMap[len] = currentColumn;
  return { rowMap, columnMap };
}
function extractDoctypeInfo(rawDoctype) {
  if (rawDoctype.startsWith("<!DOCTYPE")) {
    rawDoctype = rawDoctype.slice(10);
  }
  if (rawDoctype.endsWith(">")) {
    rawDoctype = rawDoctype.slice(0, rawDoctype.length - 1);
  }
  rawDoctype = rawDoctype.trim();
  const match2 = rawDoctype.match(/^[\w-]*/);
  const name2 = match2?.[0] || "";
  if (name2) {
    rawDoctype = rawDoctype.slice(name2.length).trim();
  }
  let _public = null;
  let system = null;
  if (rawDoctype.startsWith("PUBLIC")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22) {
      if (match22[0]) {
        _public = match22[0].slice(1, match22[0].length - 1);
      }
      if (match22[1]) {
        system = match22[1].slice(1, match22[1].length - 1);
      }
    }
  }
  if (rawDoctype.startsWith("SYSTEM")) {
    rawDoctype = rawDoctype.slice(6);
    const match22 = rawDoctype.match(/(["'])(.*?)\1/g);
    if (match22 && match22[0]) {
      system = match22[0].slice(1, match22[0].length - 1);
    }
  }
  return { name: name2, public: _public, system };
}
function findFirstErrorInChild(node) {
  if (node.type.name === "⚠") {
    return node;
  }
  let child = node.firstChild;
  while (child) {
    const error = findFirstErrorInChild(child);
    if (error) {
      return error;
    }
    child = child.nextSibling;
  }
  return null;
}
function getLezerChildren(node) {
  const ret = [];
  let child = node.firstChild;
  while (child) {
    ret.push(child);
    child = child.nextSibling;
  }
  return ret;
}
function updateNodePositionData(nodeToUpdate, referenceNode, offsetToPositionMap) {
  if (!nodeToUpdate.position || !referenceNode.position) {
    return;
  }
  const offset2 = referenceNode.position.start.offset;
  if (nodeToUpdate.position.start.offset != null && offset2 != null) {
    nodeToUpdate.position.start.offset += offset2;
  }
  if (nodeToUpdate.position.end.offset != null && offset2 != null) {
    nodeToUpdate.position.end.offset += offset2;
  }
  const startOffset = nodeToUpdate.position.start.offset;
  const endOffset = nodeToUpdate.position.end.offset;
  if (startOffset != null && endOffset != null) {
    nodeToUpdate.position.start.line = offsetToPositionMap.rowMap[startOffset] + 1;
    nodeToUpdate.position.start.column = offsetToPositionMap.columnMap[startOffset] + 1;
    nodeToUpdate.position.end.line = offsetToPositionMap.rowMap[endOffset] + 1;
    nodeToUpdate.position.end.column = offsetToPositionMap.columnMap[endOffset] + 1;
  }
}
function createErrorNode(node, source, offsetToPositionMap) {
  if (!node.type.isError && !node.type.is(MissingCloseTag)) {
    throw new Error("Function can only be called on a node of type error.");
  }
  function errorNode(message, options2) {
    const { startNode = node, endNode = node } = options2 ?? {};
    const startPos = lezerNodeToPosition(startNode, offsetToPositionMap);
    const endPos = startNode !== endNode ? lezerNodeToPosition(endNode, offsetToPositionMap) : startPos;
    return {
      type: "error",
      message,
      position: { start: startPos.start, end: endPos.end }
    };
  }
  const parent = node.parent;
  if (!parent) {
    const message = `Invalid DoenetML: ${extractContent(node, source)}`;
    return {
      type: "error",
      message,
      position: lezerNodeToPosition(node, offsetToPositionMap)
    };
  }
  switch (parent.type.id) {
    case Element$1: {
      const openTag = parent.getChild(OpenTag);
      const closeTag = parent.getChild(CloseTag);
      const tagNameTag = (openTag || parent.getChild(SelfClosingTag) || closeTag)?.getChild(TagName$C);
      const openTagName = tagNameTag ? extractContent(tagNameTag, source) : "";
      if (openTag && !closeTag) {
        const openTagName2 = tagNameTag ? extractContent(tagNameTag, source) : "";
        const message = `Invalid DoenetML: The tag \`${extractContent(
          openTag,
          source
        )}\` has no closing tag. Expected a self-closing tag or a \`</${openTagName2}>\` tag.`;
        return errorNode(message, {
          startNode: openTag,
          endNode: openTag
        });
      }
      return errorNode(
        `Invalid DoenetML: Error in tag \`<${openTagName}>\``
      );
    }
    case Attribute: {
      const value = extractContent(parent, source);
      const attributeNameNode = parent.getChild("AttributeName");
      const isNode2 = parent.getChild("Is");
      if (attributeNameNode && isNode2) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute \`${value}\` appears to be missing a value.`
        );
      }
      return errorNode(
        `Invalid DoenetML: Invalid attribute \`${value}\``
      );
    }
    case AttributeValue: {
      const attribute = parent.parent;
      const value = extractContent(parent, source);
      const openQuote = value[0];
      const closeQuote = value[value.length - 1];
      if (!attribute || openQuote === closeQuote) {
        return errorNode(
          `Invalid DoenetML: Invalid attribute value \`${value}\``
        );
      }
      const correctQuote = openQuote.match(/['"]/) ? openQuote : closeQuote.match(/['"]/) ? closeQuote : '"';
      return errorNode(
        `Invalid DoenetML: Invalid attribute value \`${value}\`. The quote marks do not match. You appear to be missing a \`${correctQuote}\``
      );
    }
    case OpenTag: {
      const tagName = parent.getChild(TagName$C);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name, e.g. \`<\``
        );
      }
      const endTag = parent.getChild(EndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
    case SelfClosingTag: {
      const tagName = parent.getChild(TagName$C);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a tag without a tag name \`<${extractContent(
            node,
            source
          )}>\``
        );
      }
      const endTag = parent.getChild(SelfCloseEndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (\`/>\` appears to be missing).`
        );
      }
      return errorNode(
        `Invalid DoenetML: Tag \`${extractContent(
          parent,
          source
        )}\` is not valid. It may have incorrect attributes.`
      );
    }
    case MismatchedCloseTag:
    case CloseTag: {
      const tagName = parent.getChild(TagName$C);
      if (!tagName) {
        return errorNode(
          `Invalid DoenetML: Found a closing tag without a tag name, e.g. \`</\``
        );
      }
      const endTag = parent.getChild(EndTag);
      if (!endTag) {
        return errorNode(
          `Invalid DoenetML: Tag \`${extractContent(
            parent,
            source
          )}\` was not closed (a \`>\` appears to be missing).`,
          { startNode: parent, endNode: tagName }
        );
      }
    }
  }
  return errorNode(`Could not convert node ${node} to Dast node.`);
}
function unquotedAttributeValueMessage(assignName, valueName) {
  return `Attribute values must be enclosed in quotes: \`${assignName}="${valueName}"\``;
}
function findBareAttributeValuePairs(attrs, source) {
  if (attrs.length < 2) {
    return [];
  }
  const sorted = attrs.filter(
    (a2) => a2.position?.start.offset != null && a2.position?.end.offset != null
  ).sort(
    (a2, b2) => (a2.position?.start.offset ?? 0) - (b2.position?.start.offset ?? 0)
  );
  const pairs2 = [];
  for (let i2 = 1; i2 < sorted.length; i2++) {
    const prev = sorted[i2 - 1];
    const curr = sorted[i2];
    if (prev.children.length !== 0 || curr.children.length !== 0) {
      continue;
    }
    const prevSrc = source.slice(
      prev.position?.start.offset ?? 0,
      prev.position?.end.offset ?? 0
    );
    if (!/=\s*$/.test(prevSrc)) {
      continue;
    }
    pairs2.push({ assignAttr: prev, valueAttr: curr });
  }
  return pairs2;
}
const _MacroParser = (
  // @generated by Peggy 5.1.0.
  //
  // https://peggyjs.org/
  /* @__PURE__ */ (function() {
    class peg$SyntaxError extends SyntaxError {
      constructor(message, expected, found, location) {
        super(message);
        this.expected = expected;
        this.found = found;
        this.location = location;
        this.name = "SyntaxError";
      }
      format(sources) {
        let str = "Error: " + this.message;
        if (this.location) {
          let src = null;
          const st2 = sources.find((s22) => s22.source === this.location.source);
          if (st2) {
            src = st2.text.split(/\r\n|\n|\r/g);
          }
          const s2 = this.location.start;
          const offset_s = this.location.source && typeof this.location.source.offset === "function" ? this.location.source.offset(s2) : s2;
          const loc = this.location.source + ":" + offset_s.line + ":" + offset_s.column;
          if (src) {
            const e2 = this.location.end;
            const filler = "".padEnd(offset_s.line.toString().length, " ");
            const line2 = src[s2.line - 1];
            const last2 = s2.line === e2.line ? e2.column : line2.length + 1;
            const hatLen = last2 - s2.column || 1;
            str += "\n --> " + loc + "\n" + filler + " |\n" + offset_s.line + " | " + line2 + "\n" + filler + " | " + "".padEnd(s2.column - 1, " ") + "".padEnd(hatLen, "^");
          } else {
            str += "\n at " + loc;
          }
        }
        return str;
      }
      static buildMessage(expected, found) {
        function hex(ch) {
          return ch.codePointAt(0).toString(16).toUpperCase();
        }
        const nonPrintable = Object.prototype.hasOwnProperty.call(RegExp.prototype, "unicode") ? new RegExp("[\\p{C}\\p{Mn}\\p{Mc}]", "gu") : null;
        function unicodeEscape(s2) {
          if (nonPrintable) {
            return s2.replace(nonPrintable, (ch) => "\\u{" + hex(ch) + "}");
          }
          return s2;
        }
        function literalEscape(s2) {
          return unicodeEscape(s2.replace(/\\/g, "\\\\").replace(/"/g, '\\"').replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        function classEscape(s2) {
          return unicodeEscape(s2.replace(/\\/g, "\\\\").replace(/\]/g, "\\]").replace(/\^/g, "\\^").replace(/-/g, "\\-").replace(/\0/g, "\\0").replace(/\t/g, "\\t").replace(/\n/g, "\\n").replace(/\r/g, "\\r").replace(/[\x00-\x0F]/g, (ch) => "\\x0" + hex(ch)).replace(/[\x10-\x1F\x7F-\x9F]/g, (ch) => "\\x" + hex(ch)));
        }
        const DESCRIBE_EXPECTATION_FNS = {
          literal(expectation) {
            return '"' + literalEscape(expectation.text) + '"';
          },
          class(expectation) {
            const escapedParts = expectation.parts.map(
              (part) => Array.isArray(part) ? classEscape(part[0]) + "-" + classEscape(part[1]) : classEscape(part)
            );
            return "[" + (expectation.inverted ? "^" : "") + escapedParts.join("") + "]" + (expectation.unicode ? "u" : "");
          },
          any() {
            return "any character";
          },
          end() {
            return "end of input";
          },
          other(expectation) {
            return expectation.description;
          }
        };
        function describeExpectation(expectation) {
          return DESCRIBE_EXPECTATION_FNS[expectation.type](expectation);
        }
        function describeExpected(expected2) {
          const descriptions = expected2.map(describeExpectation);
          descriptions.sort();
          if (descriptions.length > 0) {
            let j2 = 1;
            for (let i2 = 1; i2 < descriptions.length; i2++) {
              if (descriptions[i2 - 1] !== descriptions[i2]) {
                descriptions[j2] = descriptions[i2];
                j2++;
              }
            }
            descriptions.length = j2;
          }
          switch (descriptions.length) {
            case 1:
              return descriptions[0];
            case 2:
              return descriptions[0] + " or " + descriptions[1];
            default:
              return descriptions.slice(0, -1).join(", ") + ", or " + descriptions[descriptions.length - 1];
          }
        }
        function describeFound(found2) {
          return found2 ? '"' + literalEscape(found2) + '"' : "end of input";
        }
        return "Expected " + describeExpected(expected) + " but " + describeFound(found) + " found.";
      }
    }
    function peg$parse(input, options2) {
      options2 = options2 !== void 0 ? options2 : {};
      const peg$FAILED = {};
      const peg$source = options2.grammarSource;
      const peg$startRuleFunctions = {
        top: peg$parsetop
      };
      let peg$startRuleFunction = peg$parsetop;
      const peg$c0 = ".";
      const peg$c1 = "$";
      const peg$c2 = "(";
      const peg$c3 = ")";
      const peg$c4 = "$$";
      const peg$c5 = ",";
      const peg$c6 = "{";
      const peg$c7 = "}";
      const peg$c8 = "[";
      const peg$c9 = "]";
      const peg$c10 = "=";
      const peg$c11 = '"';
      const peg$c12 = "'";
      const peg$r0 = /^[a-zA-Z_]/;
      const peg$r1 = /^[a-zA-Z0-9_]/;
      const peg$r2 = /^[a-zA-Z0-9_\-]/;
      const peg$r3 = /^[a-zA-Z0-9_:\-]/;
      const peg$r4 = /^[^$]/;
      const peg$r5 = /^[^(),$]/;
      const peg$r6 = /^[^(),]/;
      const peg$r7 = /^[^()$]/;
      const peg$r8 = /^[^()]/;
      const peg$r9 = /^[^'$]/;
      const peg$r10 = /^[^']/;
      const peg$r11 = /^[^\]$]/;
      const peg$r12 = /^[^\]]/;
      const peg$r13 = /^[^"$]/;
      const peg$r14 = /^[^"]/;
      const peg$r15 = /^[ \t\r\n]/;
      const peg$e0 = peg$classExpectation([["a", "z"], ["A", "Z"], "_"], false, false, false);
      const peg$e1 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_"], false, false, false);
      const peg$e2 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", "-"], false, false, false);
      const peg$e3 = peg$literalExpectation(".", false);
      const peg$e4 = peg$literalExpectation("$", false);
      const peg$e5 = peg$literalExpectation("(", false);
      const peg$e6 = peg$literalExpectation(")", false);
      const peg$e7 = peg$literalExpectation("$$", false);
      const peg$e8 = peg$literalExpectation(",", false);
      const peg$e9 = peg$literalExpectation("{", false);
      const peg$e10 = peg$literalExpectation("}", false);
      const peg$e11 = peg$literalExpectation("[", false);
      const peg$e12 = peg$literalExpectation("]", false);
      const peg$e13 = peg$literalExpectation("=", false);
      const peg$e14 = peg$classExpectation([["a", "z"], ["A", "Z"], ["0", "9"], "_", ":", "-"], false, false, false);
      const peg$e15 = peg$literalExpectation('"', false);
      const peg$e16 = peg$literalExpectation("'", false);
      const peg$e17 = peg$classExpectation(["$"], true, false, false);
      const peg$e18 = peg$anyExpectation();
      const peg$e19 = peg$classExpectation(["(", ")", ",", "$"], true, false, false);
      const peg$e20 = peg$classExpectation(["(", ")", ","], true, false, false);
      const peg$e21 = peg$classExpectation(["(", ")", "$"], true, false, false);
      const peg$e22 = peg$classExpectation(["(", ")"], true, false, false);
      const peg$e23 = peg$classExpectation(["'", "$"], true, false, false);
      const peg$e24 = peg$classExpectation(["'"], true, false, false);
      const peg$e25 = peg$classExpectation(["]", "$"], true, false, false);
      const peg$e26 = peg$classExpectation(["]"], true, false, false);
      const peg$e27 = peg$classExpectation(['"', "$"], true, false, false);
      const peg$e28 = peg$classExpectation(['"'], true, false, false);
      const peg$e29 = peg$classExpectation([" ", "	", "\r", "\n"], false, false, false);
      function peg$f0(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f1(name2, index2) {
        return withPosition({ type: "pathPart", name: name2, index: index2 });
      }
      function peg$f2(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f3(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f4(macro) {
        return withPosition(macro);
      }
      function peg$f5(macro) {
        return withPosition(macro);
      }
      function peg$f6(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f7(path, attrs) {
        return withPosition({
          type: "macro",
          path,
          attributes: attrs || {}
        });
      }
      function peg$f8(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f9(path, input2) {
        return withPosition({
          type: "function",
          path,
          input: input2
        });
      }
      function peg$f10(start, rest2) {
        return [start, ...rest2];
      }
      function peg$f11(a2, rest2, b2) {
        return [a2, ...rest2, b2];
      }
      function peg$f12(x2) {
        return x2.flat();
      }
      function peg$f13(a2, rest2, b2) {
        return [a2, ...rest2, b2];
      }
      function peg$f14(x2) {
        return x2.flat();
      }
      function peg$f15(attrs) {
        return Object.fromEntries(attrs.map((a2) => [a2.name, a2]));
      }
      function peg$f16(value) {
        return withPosition({ type: "index", value });
      }
      function peg$f17(name2, children) {
        return withPosition({ type: "attribute", name: name2, children });
      }
      function peg$f18(name2) {
        return withPosition({
          type: "attribute",
          name: name2,
          children: []
        });
      }
      function peg$f19(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f21() {
        return withPosition({ type: "text", value: "(" });
      }
      function peg$f22() {
        return withPosition({ type: "text", value: ")" });
      }
      function peg$f23(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f24(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f25(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f26(value) {
        return withPosition({ type: "text", value });
      }
      function peg$f27(value) {
        return withPosition({ type: "text", value });
      }
      let peg$currPos = options2.peg$currPos | 0;
      let peg$savedPos = peg$currPos;
      const peg$posDetailsCache = [{ line: 1, column: 1 }];
      let peg$maxFailPos = peg$currPos;
      let peg$maxFailExpected = options2.peg$maxFailExpected || [];
      let peg$silentFails = options2.peg$silentFails | 0;
      let peg$result;
      if (options2.startRule) {
        if (!(options2.startRule in peg$startRuleFunctions)) {
          throw new Error(`Can't start parsing from rule "` + options2.startRule + '".');
        }
        peg$startRuleFunction = peg$startRuleFunctions[options2.startRule];
      }
      function location() {
        return peg$computeLocation(peg$savedPos, peg$currPos);
      }
      function peg$getUnicode(pos = peg$currPos) {
        const cp = input.codePointAt(pos);
        if (cp === void 0) {
          return "";
        }
        return String.fromCodePoint(cp);
      }
      function peg$literalExpectation(text2, ignoreCase) {
        return { type: "literal", text: text2, ignoreCase };
      }
      function peg$classExpectation(parts, inverted, ignoreCase, unicode) {
        return { type: "class", parts, inverted, ignoreCase, unicode };
      }
      function peg$anyExpectation() {
        return { type: "any" };
      }
      function peg$endExpectation() {
        return { type: "end" };
      }
      function peg$computePosDetails(pos) {
        let details = peg$posDetailsCache[pos];
        let p2;
        if (details) {
          return details;
        } else {
          if (pos >= peg$posDetailsCache.length) {
            p2 = peg$posDetailsCache.length - 1;
          } else {
            p2 = pos;
            while (!peg$posDetailsCache[--p2]) {
            }
          }
          details = peg$posDetailsCache[p2];
          details = {
            line: details.line,
            column: details.column
          };
          while (p2 < pos) {
            if (input.charCodeAt(p2) === 10) {
              details.line++;
              details.column = 1;
            } else {
              details.column++;
            }
            p2++;
          }
          peg$posDetailsCache[pos] = details;
          return details;
        }
      }
      function peg$computeLocation(startPos, endPos, offset2) {
        const startPosDetails = peg$computePosDetails(startPos);
        const endPosDetails = peg$computePosDetails(endPos);
        const res = {
          source: peg$source,
          start: {
            offset: startPos,
            line: startPosDetails.line,
            column: startPosDetails.column
          },
          end: {
            offset: endPos,
            line: endPosDetails.line,
            column: endPosDetails.column
          }
        };
        return res;
      }
      function peg$fail(expected2) {
        if (peg$currPos < peg$maxFailPos) {
          return;
        }
        if (peg$currPos > peg$maxFailPos) {
          peg$maxFailPos = peg$currPos;
          peg$maxFailExpected = [];
        }
        peg$maxFailExpected.push(expected2);
      }
      function peg$buildStructuredError(expected2, found, location2) {
        return new peg$SyntaxError(
          peg$SyntaxError.buildMessage(expected2, found),
          expected2,
          found,
          location2
        );
      }
      function peg$parsetop() {
        let s0, s1;
        s0 = [];
        s1 = peg$parseMacro();
        if (s1 === peg$FAILED) {
          s1 = peg$parseFunctionMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseText();
          }
        }
        while (s1 !== peg$FAILED) {
          s0.push(s1);
          s1 = peg$parseMacro();
          if (s1 === peg$FAILED) {
            s1 = peg$parseFunctionMacro();
            if (s1 === peg$FAILED) {
              s1 = peg$parseText();
            }
          }
        }
        return s0;
      }
      function peg$parseSimpleIdent() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = input.charAt(peg$currPos);
        if (peg$r0.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e0);
          }
        }
        if (s2 !== peg$FAILED) {
          s3 = [];
          s4 = input.charAt(peg$currPos);
          if (peg$r1.test(s4)) {
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e1);
            }
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = input.charAt(peg$currPos);
            if (peg$r1.test(s4)) {
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e1);
              }
            }
          }
          s2 = [s2, s3];
          s1 = s2;
        } else {
          peg$currPos = s1;
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseIdent() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r2.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e2);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r2.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e2);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseSimplePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseSimpleIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f0(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePathPart() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$parseIdent();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parsePropIndex();
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parsePropIndex();
          }
          peg$savedPos = s0;
          s0 = peg$f1(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseSimplePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parseSimplePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parseSimplePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parseSimplePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f2(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePath() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = peg$parsePathPart();
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 46) {
            s4 = peg$c0;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e3);
            }
          }
          if (s4 !== peg$FAILED) {
            s5 = peg$parsePathPart();
            if (s5 !== peg$FAILED) {
              s3 = s5;
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$currPos;
            if (input.charCodeAt(peg$currPos) === 46) {
              s4 = peg$c0;
              peg$currPos++;
            } else {
              s4 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e3);
              }
            }
            if (s4 !== peg$FAILED) {
              s5 = peg$parsePathPart();
              if (s5 !== peg$FAILED) {
                s3 = s5;
              } else {
                peg$currPos = s3;
                s3 = peg$FAILED;
              }
            } else {
              peg$currPos = s3;
              s3 = peg$FAILED;
            }
          }
          peg$savedPos = s0;
          s0 = peg$f3(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseMacro() {
        let s0, s1, s2, s3, s4;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 36) {
          s1 = peg$c1;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e4);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parseFullAddressMacro();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                peg$savedPos = s0;
                s0 = peg$f4(s3);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 36) {
            s1 = peg$c1;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e4);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimpleAddressMacro();
            if (s2 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f5(s2);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseSimpleAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parseSimplePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f6(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFullAddressMacro() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = peg$parsePath();
        if (s1 !== peg$FAILED) {
          s2 = peg$parsePropAttrs();
          if (s2 === peg$FAILED) {
            s2 = null;
          }
          peg$savedPos = s0;
          s0 = peg$f7(s1, s2);
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionMacro() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        if (input.substr(peg$currPos, 2) === peg$c4) {
          s1 = peg$c4;
          peg$currPos += 2;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e7);
          }
        }
        if (s1 !== peg$FAILED) {
          if (input.charCodeAt(peg$currPos) === 40) {
            s2 = peg$c2;
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e5);
            }
          }
          if (s2 !== peg$FAILED) {
            s3 = peg$parsePath();
            if (s3 !== peg$FAILED) {
              if (input.charCodeAt(peg$currPos) === 41) {
                s4 = peg$c3;
                peg$currPos++;
              } else {
                s4 = peg$FAILED;
                if (peg$silentFails === 0) {
                  peg$fail(peg$e6);
                }
              }
              if (s4 !== peg$FAILED) {
                s5 = peg$parseFunctionInput();
                if (s5 === peg$FAILED) {
                  s5 = null;
                }
                peg$savedPos = s0;
                s0 = peg$f8(s3, s5);
              } else {
                peg$currPos = s0;
                s0 = peg$FAILED;
              }
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.substr(peg$currPos, 2) === peg$c4) {
            s1 = peg$c4;
            peg$currPos += 2;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e7);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = peg$parseSimplePath();
            if (s2 !== peg$FAILED) {
              s3 = peg$parseFunctionInput();
              if (s3 === peg$FAILED) {
                s3 = null;
              }
              peg$savedPos = s0;
              s0 = peg$f9(s2, s3);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseFunctionInput() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = peg$parseFunctionArgumentList();
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 41) {
            s5 = peg$c3;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e6);
            }
          }
          if (s5 !== peg$FAILED) {
            s0 = s3;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseFunctionArgumentList() {
        let s0, s1, s2, s3, s5, s7;
        s0 = peg$currPos;
        s1 = peg$parseBalancedParenTextNoComma();
        s2 = [];
        s3 = peg$currPos;
        peg$parse_();
        if (input.charCodeAt(peg$currPos) === 44) {
          s5 = peg$c5;
          peg$currPos++;
        } else {
          s5 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e8);
          }
        }
        if (s5 !== peg$FAILED) {
          peg$parse_();
          s7 = peg$parseBalancedParenTextNoComma();
          s3 = s7;
        } else {
          peg$currPos = s3;
          s3 = peg$FAILED;
        }
        while (s3 !== peg$FAILED) {
          s2.push(s3);
          s3 = peg$currPos;
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 44) {
            s5 = peg$c5;
            peg$currPos++;
          } else {
            s5 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e8);
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s7 = peg$parseBalancedParenTextNoComma();
            s3 = s7;
          } else {
            peg$currPos = s3;
            s3 = peg$FAILED;
          }
        }
        peg$savedPos = s0;
        s0 = peg$f10(s1, s2);
        return s0;
      }
      function peg$parseBalancedParenTextNoComma() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParenOrComma();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f11(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParenOrComma();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f11(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f12(s1);
        s0 = s1;
        return s0;
      }
      function peg$parseBalancedParenText() {
        let s0, s1, s2, s3, s4, s5;
        s0 = peg$currPos;
        s1 = [];
        s2 = peg$parseMacro();
        if (s2 === peg$FAILED) {
          s2 = peg$parseFunctionMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseTextWithoutParen();
            if (s2 === peg$FAILED) {
              s2 = peg$currPos;
              s3 = peg$parseOpenParen();
              if (s3 !== peg$FAILED) {
                s4 = peg$parseBalancedParenText();
                s5 = peg$parseCloseParen();
                if (s5 !== peg$FAILED) {
                  peg$savedPos = s2;
                  s2 = peg$f13(s3, s4, s5);
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              } else {
                peg$currPos = s2;
                s2 = peg$FAILED;
              }
            }
          }
        }
        while (s2 !== peg$FAILED) {
          s1.push(s2);
          s2 = peg$parseMacro();
          if (s2 === peg$FAILED) {
            s2 = peg$parseFunctionMacro();
            if (s2 === peg$FAILED) {
              s2 = peg$parseTextWithoutParen();
              if (s2 === peg$FAILED) {
                s2 = peg$currPos;
                s3 = peg$parseOpenParen();
                if (s3 !== peg$FAILED) {
                  s4 = peg$parseBalancedParenText();
                  s5 = peg$parseCloseParen();
                  if (s5 !== peg$FAILED) {
                    peg$savedPos = s2;
                    s2 = peg$f13(s3, s4, s5);
                  } else {
                    peg$currPos = s2;
                    s2 = peg$FAILED;
                  }
                } else {
                  peg$currPos = s2;
                  s2 = peg$FAILED;
                }
              }
            }
          }
        }
        peg$savedPos = s0;
        s1 = peg$f14(s1);
        s0 = s1;
        return s0;
      }
      function peg$parsePropAttrs() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 123) {
          s1 = peg$c6;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e9);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseAttr();
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseAttr();
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 125) {
            s4 = peg$c7;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e10);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f15(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parsePropIndex() {
        let s0, s1, s3, s4, s5;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 91) {
          s1 = peg$c8;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e11);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$parse_();
          s3 = [];
          s4 = peg$currPos;
          s5 = peg$parseFunctionMacro();
          if (s5 === peg$FAILED) {
            s5 = peg$parseMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseTextWithoutClosingSquareBrace();
            }
          }
          if (s5 !== peg$FAILED) {
            peg$parse_();
            s4 = s5;
          } else {
            peg$currPos = s4;
            s4 = peg$FAILED;
          }
          while (s4 !== peg$FAILED) {
            s3.push(s4);
            s4 = peg$currPos;
            s5 = peg$parseFunctionMacro();
            if (s5 === peg$FAILED) {
              s5 = peg$parseMacro();
              if (s5 === peg$FAILED) {
                s5 = peg$parseTextWithoutClosingSquareBrace();
              }
            }
            if (s5 !== peg$FAILED) {
              peg$parse_();
              s4 = s5;
            } else {
              peg$currPos = s4;
              s4 = peg$FAILED;
            }
          }
          if (input.charCodeAt(peg$currPos) === 93) {
            s4 = peg$c9;
            peg$currPos++;
          } else {
            s4 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e12);
            }
          }
          if (s4 !== peg$FAILED) {
            peg$savedPos = s0;
            s0 = peg$f16(s3);
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        return s0;
      }
      function peg$parseAttr() {
        let s0, s1, s3, s5;
        s0 = peg$currPos;
        s1 = peg$parseAttrName();
        if (s1 !== peg$FAILED) {
          peg$parse_();
          if (input.charCodeAt(peg$currPos) === 61) {
            s3 = peg$c10;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e13);
            }
          }
          if (s3 !== peg$FAILED) {
            peg$parse_();
            s5 = peg$parseAttrValue();
            if (s5 !== peg$FAILED) {
              peg$savedPos = s0;
              s0 = peg$f17(s1, s5);
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          s1 = peg$parseAttrName();
          if (s1 !== peg$FAILED) {
            peg$savedPos = s0;
            s1 = peg$f18(s1);
          }
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrName() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r3.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e14);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r3.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e14);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function peg$parseAttrValue() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 34) {
          s1 = peg$c11;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e15);
          }
        }
        if (s1 !== peg$FAILED) {
          s2 = [];
          s3 = peg$parseMacro();
          if (s3 === peg$FAILED) {
            s3 = peg$parseFunctionMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseTextWithoutDoubleQuote();
            }
          }
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutDoubleQuote();
              }
            }
          }
          if (input.charCodeAt(peg$currPos) === 34) {
            s3 = peg$c11;
            peg$currPos++;
          } else {
            s3 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e15);
            }
          }
          if (s3 !== peg$FAILED) {
            s0 = s2;
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        } else {
          peg$currPos = s0;
          s0 = peg$FAILED;
        }
        if (s0 === peg$FAILED) {
          s0 = peg$currPos;
          if (input.charCodeAt(peg$currPos) === 39) {
            s1 = peg$c12;
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e16);
            }
          }
          if (s1 !== peg$FAILED) {
            s2 = [];
            s3 = peg$parseMacro();
            if (s3 === peg$FAILED) {
              s3 = peg$parseFunctionMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseTextWithoutQuote();
              }
            }
            while (s3 !== peg$FAILED) {
              s2.push(s3);
              s3 = peg$parseMacro();
              if (s3 === peg$FAILED) {
                s3 = peg$parseFunctionMacro();
                if (s3 === peg$FAILED) {
                  s3 = peg$parseTextWithoutQuote();
                }
              }
            }
            if (input.charCodeAt(peg$currPos) === 39) {
              s3 = peg$c12;
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e16);
              }
            }
            if (s3 !== peg$FAILED) {
              s0 = s2;
            } else {
              peg$currPos = s0;
              s0 = peg$FAILED;
            }
          } else {
            peg$currPos = s0;
            s0 = peg$FAILED;
          }
        }
        return s0;
      }
      function peg$parseText() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r4.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e17);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r4.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e17);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          if (input.length > peg$currPos) {
            s1 = input.charAt(peg$currPos);
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e18);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f19(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseOpenParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 40) {
          s1 = peg$c2;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e5);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f21();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseCloseParen() {
        let s0, s1;
        s0 = peg$currPos;
        if (input.charCodeAt(peg$currPos) === 41) {
          s1 = peg$c3;
          peg$currPos++;
        } else {
          s1 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e6);
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f22();
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParenOrComma() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r5.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e19);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r5.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e19);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r6.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e20);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f23(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutParen() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r7.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e21);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r7.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e21);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r8.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e22);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f24(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r9.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e23);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r9.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e23);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r10.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e24);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f25(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutClosingSquareBrace() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r11.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e25);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r11.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e25);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 === peg$FAILED) {
          s2 = input.charAt(peg$currPos);
          if (peg$r12.test(s2)) {
            peg$currPos++;
          } else {
            s2 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e26);
            }
          }
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f26(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parseTextWithoutDoubleQuote() {
        let s0, s1, s2, s3;
        s0 = peg$currPos;
        s1 = peg$currPos;
        s2 = [];
        s3 = input.charAt(peg$currPos);
        if (peg$r13.test(s3)) {
          peg$currPos++;
        } else {
          s3 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e27);
          }
        }
        if (s3 !== peg$FAILED) {
          while (s3 !== peg$FAILED) {
            s2.push(s3);
            s3 = input.charAt(peg$currPos);
            if (peg$r13.test(s3)) {
              peg$currPos++;
            } else {
              s3 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e27);
              }
            }
          }
        } else {
          s2 = peg$FAILED;
        }
        if (s2 !== peg$FAILED) {
          s1 = input.substring(s1, peg$currPos);
        } else {
          s1 = s2;
        }
        if (s1 === peg$FAILED) {
          s1 = input.charAt(peg$currPos);
          if (peg$r14.test(s1)) {
            peg$currPos++;
          } else {
            s1 = peg$FAILED;
            if (peg$silentFails === 0) {
              peg$fail(peg$e28);
            }
          }
        }
        if (s1 !== peg$FAILED) {
          peg$savedPos = s0;
          s1 = peg$f27(s1);
        }
        s0 = s1;
        return s0;
      }
      function peg$parse_() {
        let s0, s1, s2;
        s0 = peg$currPos;
        s1 = [];
        s2 = input.charAt(peg$currPos);
        if (peg$r15.test(s2)) {
          peg$currPos++;
        } else {
          s2 = peg$FAILED;
          if (peg$silentFails === 0) {
            peg$fail(peg$e29);
          }
        }
        if (s2 !== peg$FAILED) {
          while (s2 !== peg$FAILED) {
            s1.push(s2);
            s2 = input.charAt(peg$currPos);
            if (peg$r15.test(s2)) {
              peg$currPos++;
            } else {
              s2 = peg$FAILED;
              if (peg$silentFails === 0) {
                peg$fail(peg$e29);
              }
            }
          }
        } else {
          s1 = peg$FAILED;
        }
        if (s1 !== peg$FAILED) {
          s0 = input.substring(s0, peg$currPos);
        } else {
          s0 = s1;
        }
        return s0;
      }
      function withPosition(node) {
        const { start, end } = location();
        return { ...node, position: { start, end } };
      }
      peg$result = peg$startRuleFunction();
      const peg$success = peg$result !== peg$FAILED && peg$currPos === input.length;
      function peg$throw() {
        if (peg$result !== peg$FAILED && peg$currPos < input.length) {
          peg$fail(peg$endExpectation());
        }
        throw peg$buildStructuredError(
          peg$maxFailExpected,
          peg$maxFailPos < input.length ? peg$getUnicode(peg$maxFailPos) : null,
          peg$maxFailPos < input.length ? peg$computeLocation(peg$maxFailPos, peg$maxFailPos + 1) : peg$computeLocation(peg$maxFailPos, peg$maxFailPos)
        );
      }
      if (options2.peg$library) {
        return (
          /** @type {any} */
          {
            peg$result,
            peg$currPos,
            peg$FAILED,
            peg$maxFailExpected,
            peg$maxFailPos,
            peg$success,
            peg$throw: peg$success ? void 0 : peg$throw
          }
        );
      }
      if (peg$success) {
        return peg$result;
      } else {
        peg$throw();
      }
    }
    return {
      StartRules: ["top"],
      SyntaxError: peg$SyntaxError,
      parse: peg$parse
    };
  })()
);
const MacroParser = _MacroParser;
function parseMacros(str) {
  return MacroParser.parse(str);
}
function gobbleFunctionArguments(nodes) {
  if (!nodes.some((node) => node.type === "function" && node.input == null)) {
    return nodes;
  }
  nodes = nodes.map(
    (node) => node.type === "text" ? splitTextAtSpecialChars(node) : node
  ).flat();
  const ret = [];
  let functionNode = null;
  for (let i2 = 0; i2 < nodes.length; i2++) {
    const node = nodes[i2];
    if (node.type === "function" && node.input == null) {
      functionNode = node;
      ret.push(node);
      continue;
    }
    if (!functionNode) {
      ret.push(node);
      continue;
    }
    if (!(node.type === "text" && node.value === "(") || !hasClosingParen(nodes.slice(i2))) {
      functionNode = null;
      ret.push(node);
      continue;
    }
    let currentFunctionArg = [];
    functionNode.input = [];
    let parenDepth = 1;
    i2++;
    while (functionNode) {
      const nextNode = nodes[i2];
      if (!nextNode) {
        throw new Error(
          "Failed to find next node when search for function arguments"
        );
      }
      if (nextNode.type !== "text") {
        currentFunctionArg.push(nextNode);
        i2++;
        continue;
      }
      if (nextNode.value === "(") {
        parenDepth++;
      }
      if (nextNode.value === "," && parenDepth <= 1) {
        functionNode.input.push(
          trimWhitespace(currentFunctionArg)
        );
        currentFunctionArg = [];
        i2++;
        continue;
      }
      if (nextNode.value === ")") {
        parenDepth--;
        if (parenDepth === 0) {
          functionNode.input.push(
            trimWhitespace(
              gobbleFunctionArguments(
                currentFunctionArg
              )
            )
          );
          currentFunctionArg = [];
          if (nextNode.position) {
            functionNode.position.end = {
              ...nextNode.position.end
            };
          }
          functionNode = null;
          i2++;
          continue;
        }
      }
      i2++;
      currentFunctionArg.push(nextNode);
    }
    i2--;
  }
  return ret;
}
function splitTextAtSpecialChars(node) {
  const pos = node.value.search(/[\(\),]/);
  if (pos < 0) {
    return [node];
  }
  const [left, middle, right] = splitTextNodeAt(node, pos);
  const ret = [left, middle, ...splitTextAtSpecialChars(right)];
  return ret.filter((node2) => node2.value !== "");
}
const DEFAULT_POSITION = {
  start: { offset: 0, line: 1, column: 1 },
  end: { offset: 0, line: 1, column: 1 }
};
function splitTextNodeAt(node, pos) {
  const { value, position: position2 = DEFAULT_POSITION } = node;
  if (pos < 0 || pos > value.length) {
    throw new Error(
      `Cannot split a string at a value larger than its length (got pos:${pos} for text node "${value}")`
    );
  }
  const { rowMap, columnMap } = createOffsetToPositionMap$1(value);
  const leftValue = value.slice(0, pos);
  const left = {
    type: "text",
    value: leftValue,
    position: {
      start: { ...position2.start },
      end: {
        offset: (position2.start.offset || 0) + leftValue.length,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      }
    }
  };
  const middleValue = value.slice(pos, pos + 1);
  const middle = {
    type: "text",
    value: middleValue,
    position: {
      start: {
        offset: (position2.start.offset || 0) + pos,
        line: rowMap[pos] + position2.start.line,
        column: columnMap[pos] + position2.start.column
      },
      end: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  const rightValue = value.slice(pos + 1);
  const right = {
    type: "text",
    value: rightValue,
    position: {
      end: { ...position2.end },
      start: {
        offset: (position2.start.offset || 0) + pos + 1,
        line: rowMap[pos + 1] + position2.start.line,
        column: columnMap[pos + 1] + position2.start.column
      }
    }
  };
  return [left, middle, right];
}
function hasClosingParen(nodes) {
  return nodes.some(
    (node) => node.type === "text" && node.value.includes(")")
  );
}
function trimWhitespace(nodes) {
  const firstNode = nodes[0];
  const lastNode = nodes[nodes.length - 1];
  if (!firstNode || !lastNode) {
    return nodes;
  }
  if (firstNode.type === "text") {
    firstNode.value = firstNode.value.trimStart();
    if (firstNode.value === "") {
      nodes.shift();
    }
  }
  if (lastNode.type === "text") {
    lastNode.value = lastNode.value.trimEnd();
    if (lastNode.value === "") {
      nodes.pop();
    }
  }
  return nodes;
}
function stringToLezer(source) {
  const tree = parser.parse(source);
  return tree.topNode;
}
function lezerToDast(node, source) {
  if (typeof node === "string") {
    const tree = parser.parse(node);
    source = node;
    return _lezerToDast(tree.topNode, source);
  }
  if (source == null) {
    throw new Error(
      `If you provide a SyntaxNode, you must also provide the source string`
    );
  }
  return _lezerToDast(node, source);
}
function _lezerToDast(node, source) {
  const offsetMap = createOffsetToPositionMap$1(source);
  return {
    type: "root",
    children: gobbleFunctionArguments(lezerNodeToDastNode(node)),
    position: lezerNodeToPosition(node, offsetMap),
    sources: [source]
  };
  function lezerNodeToDastNode(node2) {
    if (!node2) {
      throw new Error(`Expecting node but got ${JSON.stringify(node2)}`);
    }
    const name2 = node2.type.name;
    switch (name2) {
      case "Document":
        return getLezerChildren(node2).flatMap(lezerNodeToDastNode);
      case "Element": {
        const openTag = node2.getChild("OpenTag") || node2.getChild("SelfClosingTag");
        if (!openTag) {
          console.warn(
            `Could not find open tag for element ${extractContent(
              node2,
              source
            )}`
          );
          return [];
        }
        let children = [];
        const openTagError = findFirstErrorInChild(openTag);
        if (openTagError && !isInsideAttribute(openTagError, openTag)) {
          const errorNode = createErrorNode(
            openTagError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        let elementError = node2.getChild("⚠") || node2.getChild(MissingCloseTag);
        if (openTag.type.name === "OpenTag" && !node2.getChild("CloseTag") && !openTagError && elementError) {
          const errorNode = createErrorNode(
            elementError,
            source,
            offsetMap
          );
          children.push(errorNode);
        }
        const tag2 = openTag.getChild("TagName");
        const name22 = tag2 ? extractContent(tag2, source) : "";
        const attrEntries = [];
        for (const attrTag of openTag.getChildren("Attribute")) {
          const attrName = attrTag.getChild("AttributeName");
          const attrValue = attrTag.getChild("AttributeValue");
          if (!attrName) {
            const error = findFirstErrorInChild(attrTag);
            if (error) {
              children.push(
                createErrorNode(error, source, offsetMap)
              );
            }
            continue;
          }
          let attrChildren = attrValue ? [
            ...reprocessTextForMacros(
              {
                type: "text",
                value: attributeValueText(
                  attrValue,
                  source
                ),
                position: lezerNodeToPosition(
                  attrValue,
                  offsetMap,
                  true
                )
              },
              offsetMap
            )
          ] : [];
          attrEntries.push({
            attrTag,
            dastAttr: {
              type: "attribute",
              name: extractContent(attrName, source),
              children: attrChildren,
              position: lezerNodeToPosition(attrTag, offsetMap)
            }
          });
        }
        const bareValuePairs = findBareAttributeValuePairs(
          attrEntries.map((e2) => e2.dastAttr),
          source
        );
        const pairedAssignAttrs = new Set(
          bareValuePairs.map((p2) => p2.assignAttr)
        );
        const pairByValueAttr = new Map(
          bareValuePairs.map((p2) => [p2.valueAttr, p2])
        );
        const attributesList = [];
        for (const { attrTag, dastAttr } of attrEntries) {
          const pair2 = pairByValueAttr.get(dastAttr);
          if (pair2) {
            children.push({
              type: "error",
              message: unquotedAttributeValueMessage(
                pair2.assignAttr.name,
                pair2.valueAttr.name
              ),
              position: pair2.valueAttr.position
            });
            continue;
          }
          if (pairedAssignAttrs.has(dastAttr)) {
            continue;
          }
          const error = findFirstErrorInChild(attrTag);
          if (error) {
            const errorNode = createErrorNode(
              error,
              source,
              offsetMap
            );
            children.push(errorNode);
          }
          attributesList.push(dastAttr);
        }
        children.push(
          ...getLezerChildren(node2).flatMap(
            (n2) => lezerNodeToDastNode(n2)
          )
        );
        children = gobbleFunctionArguments(
          children
        );
        return [
          {
            type: "element",
            name: name22,
            attributes: Object.fromEntries(
              attributesList.map((a2) => [a2.name, a2])
            ),
            children,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Text": {
        const textNode = {
          type: "text",
          value: textNodeToText(node2, source),
          position: lezerNodeToPosition(node2, offsetMap)
        };
        return reprocessTextForMacros(textNode, offsetMap);
      }
      case "Ampersand":
        return [
          {
            type: "text",
            value: "&",
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      case "CharacterReference":
      case "EntityReference":
        return [
          {
            type: "text",
            value: entityToString(node2, source),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      case "ProcessingInst": {
        const fullContent = extractContent(node2, source);
        let value = fullContent.slice(2, fullContent.length - 2);
        const match2 = value.match(/^[\w-]*/);
        const name22 = match2?.[0] || "";
        if (name22) {
          value = value.slice(name22.length).trim();
        }
        return [
          {
            type: "instruction",
            name: name22,
            value,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Comment": {
        const fullContent = extractContent(node2, source);
        return [
          {
            type: "comment",
            value: fullContent.slice(4, fullContent.length - 3),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Cdata": {
        const fullContent = extractContent(node2, source);
        return [
          {
            type: "cdata",
            value: fullContent.slice(9, fullContent.length - 3),
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "DoctypeDecl": {
        const fullContent = extractContent(node2, source);
        let value = fullContent.slice(10, fullContent.length - 1);
        const doctypeInfo = extractDoctypeInfo(value);
        return [
          {
            type: "doctype",
            ...doctypeInfo,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "Attribute":
      case "AttributeName":
      case "AttributeValue":
      case "EndTag":
      case "Is":
      case "OpenTag":
      case "SelfCloseEndTag":
      case "SelfClosingTag":
      case "TagName":
      case "StartTag":
      case "StartCloseTag":
        return [];
      case "CloseTag": {
        const errorNode = findFirstErrorInChild(node2);
        if (errorNode) {
          return [createErrorNode(errorNode, source, offsetMap)];
        }
        return [];
      }
      case "MismatchedCloseTag": {
        const closeTagError = findFirstErrorInChild(node2);
        if (closeTagError) {
          return [createErrorNode(closeTagError, source, offsetMap)];
        }
        const parent = node2.parent;
        const openTag = parent?.getChild(OpenTag);
        const closeTag = parent?.getChild(CloseTag);
        if (!parent || !openTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition(node2, offsetMap)
            }
          ];
        }
        if (closeTag) {
          const message2 = `Invalid DoenetML: Found closing tag \`${extractContent(
            node2,
            source
          )}\`, but no corresponding opening tag`;
          return [
            {
              type: "error",
              message: message2,
              position: lezerNodeToPosition(node2, offsetMap)
            }
          ];
        }
        const tagNameTag = openTag.getChild(TagName$C);
        const openTagName = tagNameTag ? extractContent(tagNameTag, source) : "";
        const message = `Invalid DoenetML: Mismatched closing tag. Expected \`</${openTagName}>\`. Found \`${extractContent(
          node2,
          source
        )}\``;
        return [
          {
            type: "error",
            message,
            position: lezerNodeToPosition(node2, offsetMap)
          }
        ];
      }
      case "MissingCloseTag":
      case "⚠":
        return [];
      default:
        const unhandledName = name2;
        console.log(
          `Encountered Lezer node of unknown type ${unhandledName}`
        );
    }
    return [];
  }
}
function isInsideAttribute(error, openTag) {
  let p2 = error.parent;
  while (p2 && p2 !== openTag) {
    if (p2.type.name === "Attribute" && p2.parent === openTag) {
      return true;
    }
    p2 = p2.parent;
  }
  return false;
}
function reprocessTextForMacros(textNode, offsetToPositionMap) {
  if (!textNode.value.includes("$")) {
    return [textNode];
  }
  const parsed = parseMacros(textNode.value);
  const nodesToProcess = findNodesWithPositionInfo(parsed);
  nodesToProcess.forEach((n2) => {
    updateNodePositionData(n2, textNode, offsetToPositionMap);
  });
  return parsed;
}
const CONTINUE = /* @__PURE__ */ Symbol("continue");
const SKIP = /* @__PURE__ */ Symbol("skip");
const EXIT = /* @__PURE__ */ Symbol("exit");
const DEFAULT_CONTEXT = {};
function visit(tree, visitor, options2) {
  const {
    startingContext = DEFAULT_CONTEXT,
    test = () => true,
    includeArrays = false
  } = {};
  let enter;
  let leave;
  if (typeof visitor === "function") {
    enter = visitor;
  } else if (visitor && typeof visitor === "object") {
    enter = visitor.enter;
    leave = visitor.leave;
  }
  walk(tree, {
    key: void 0,
    index: void 0,
    parents: [],
    containingArray: void 0,
    context: { ...startingContext }
  });
  function walk(node, { key, index: index2, parents, context, containingArray }) {
    const nodePassesTest = includeArrays ? test(node, { key, index: index2, parents, context, containingArray }) : !Array.isArray(node) && test(node, { key, index: index2, parents, context, containingArray });
    const result2 = enter && nodePassesTest ? toResult(
      enter(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : [CONTINUE];
    if (result2[0] === EXIT) {
      return result2;
    }
    if (result2[0] === SKIP) {
      return leave && nodePassesTest ? toResult(
        leave(node, {
          key,
          index: index2,
          parents,
          context,
          containingArray
        })
      ) : result2;
    }
    if (Array.isArray(node)) {
      for (let index22 = 0; index22 > -1 && index22 < node.length; index22++) {
        const item = node[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          containingArray: node
        });
        if (result22[0] === EXIT) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else if (node.type === "function" && node.input) {
      for (let index22 = 0; index22 > -1 && index22 < node.input.length; index22++) {
        const item = node.input[index22];
        const result22 = walk(item, {
          key,
          index: index22,
          parents,
          context,
          // `node.input` is an array of arrays; the containing array should be, for example, `node.input[0]` so we set it to `undefined` here.
          containingArray: void 0
        });
        if (result22[0] === EXIT) {
          return result22;
        }
        if (typeof result22[1] === "number") {
          index22 = result22[1] - 1;
        }
      }
    } else {
      const key2 = "children";
      if (key2 in node) {
        const grandparents = node.type === "root" ? parents : [node, ...parents];
        const result22 = walk(node.children, {
          key: key2,
          index: void 0,
          parents: grandparents,
          context,
          containingArray: void 0
        });
        if (result22[0] === EXIT) {
          return result22;
        }
      }
    }
    return leave && nodePassesTest ? toResult(
      leave(node, {
        key,
        index: index2,
        parents,
        context,
        containingArray
      })
    ) : result2;
  }
}
function toResult(value) {
  if (value == null) {
    return [CONTINUE];
  }
  if (Array.isArray(value)) {
    return value;
  }
  if (typeof value === "number") {
    return [CONTINUE, value];
  }
  return [value];
}
function bail(error) {
  if (error) {
    throw error;
  }
}
function getDefaultExportFromCjs$1(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var extend$1$1;
var hasRequiredExtend;
function requireExtend() {
  if (hasRequiredExtend) return extend$1$1;
  hasRequiredExtend = 1;
  var hasOwn = Object.prototype.hasOwnProperty;
  var toStr = Object.prototype.toString;
  var defineProperty = Object.defineProperty;
  var gOPD = Object.getOwnPropertyDescriptor;
  var isArray2 = function isArray22(arr) {
    if (typeof Array.isArray === "function") {
      return Array.isArray(arr);
    }
    return toStr.call(arr) === "[object Array]";
  };
  var isPlainObject2 = function isPlainObject3(obj) {
    if (!obj || toStr.call(obj) !== "[object Object]") {
      return false;
    }
    var hasOwnConstructor = hasOwn.call(obj, "constructor");
    var hasIsPrototypeOf = obj.constructor && obj.constructor.prototype && hasOwn.call(obj.constructor.prototype, "isPrototypeOf");
    if (obj.constructor && !hasOwnConstructor && !hasIsPrototypeOf) {
      return false;
    }
    var key;
    for (key in obj) {
    }
    return typeof key === "undefined" || hasOwn.call(obj, key);
  };
  var setProperty2 = function setProperty22(target, options2) {
    if (defineProperty && options2.name === "__proto__") {
      defineProperty(target, options2.name, {
        enumerable: true,
        configurable: true,
        value: options2.newValue,
        writable: true
      });
    } else {
      target[options2.name] = options2.newValue;
    }
  };
  var getProperty = function getProperty2(obj, name2) {
    if (name2 === "__proto__") {
      if (!hasOwn.call(obj, name2)) {
        return void 0;
      } else if (gOPD) {
        return gOPD(obj, name2).value;
      }
    }
    return obj[name2];
  };
  extend$1$1 = function extend2() {
    var options2, name2, src, copy2, copyIsArray, clone2;
    var target = arguments[0];
    var i2 = 1;
    var length = arguments.length;
    var deep = false;
    if (typeof target === "boolean") {
      deep = target;
      target = arguments[1] || {};
      i2 = 2;
    }
    if (target == null || typeof target !== "object" && typeof target !== "function") {
      target = {};
    }
    for (; i2 < length; ++i2) {
      options2 = arguments[i2];
      if (options2 != null) {
        for (name2 in options2) {
          src = getProperty(target, name2);
          copy2 = getProperty(options2, name2);
          if (target !== copy2) {
            if (deep && copy2 && (isPlainObject2(copy2) || (copyIsArray = isArray2(copy2)))) {
              if (copyIsArray) {
                copyIsArray = false;
                clone2 = src && isArray2(src) ? src : [];
              } else {
                clone2 = src && isPlainObject2(src) ? src : {};
              }
              setProperty2(target, { name: name2, newValue: extend2(deep, clone2, copy2) });
            } else if (typeof copy2 !== "undefined") {
              setProperty2(target, { name: name2, newValue: copy2 });
            }
          }
        }
      }
    }
    return target;
  };
  return extend$1$1;
}
var extendExports = requireExtend();
const extend$2 = /* @__PURE__ */ getDefaultExportFromCjs$1(extendExports);
function isPlainObject$1(value) {
  if (typeof value !== "object" || value === null) {
    return false;
  }
  const prototype = Object.getPrototypeOf(value);
  return (prototype === null || prototype === Object.prototype || Object.getPrototypeOf(prototype) === null) && !(Symbol.toStringTag in value) && !(Symbol.iterator in value);
}
function trough() {
  const fns = [];
  const pipeline = { run, use };
  return pipeline;
  function run(...values2) {
    let middlewareIndex = -1;
    const callback = values2.pop();
    if (typeof callback !== "function") {
      throw new TypeError("Expected function as last argument, not " + callback);
    }
    next(null, ...values2);
    function next(error, ...output) {
      const fn2 = fns[++middlewareIndex];
      let index2 = -1;
      if (error) {
        callback(error);
        return;
      }
      while (++index2 < values2.length) {
        if (output[index2] === null || output[index2] === void 0) {
          output[index2] = values2[index2];
        }
      }
      values2 = output;
      if (fn2) {
        wrap$1(fn2, next)(...output);
      } else {
        callback(null, ...output);
      }
    }
  }
  function use(middelware) {
    if (typeof middelware !== "function") {
      throw new TypeError(
        "Expected `middelware` to be a function, not " + middelware
      );
    }
    fns.push(middelware);
    return pipeline;
  }
}
function wrap$1(middleware, callback) {
  let called;
  return wrapped;
  function wrapped(...parameters) {
    const fnExpectsCallback = middleware.length > parameters.length;
    let result2;
    if (fnExpectsCallback) {
      parameters.push(done);
    }
    try {
      result2 = middleware.apply(this, parameters);
    } catch (error) {
      const exception = (
        /** @type {Error} */
        error
      );
      if (fnExpectsCallback && called) {
        throw exception;
      }
      return done(exception);
    }
    if (!fnExpectsCallback) {
      if (result2 && result2.then && typeof result2.then === "function") {
        result2.then(then, done);
      } else if (result2 instanceof Error) {
        done(result2);
      } else {
        then(result2);
      }
    }
  }
  function done(error, ...output) {
    if (!called) {
      called = true;
      callback(error, ...output);
    }
  }
  function then(value) {
    done(null, value);
  }
}
function stringifyPosition(value) {
  if (!value || typeof value !== "object") {
    return "";
  }
  if ("position" in value || "type" in value) {
    return position(value.position);
  }
  if ("start" in value || "end" in value) {
    return position(value);
  }
  if ("line" in value || "column" in value) {
    return point(value);
  }
  return "";
}
function point(point2) {
  return index(point2 && point2.line) + ":" + index(point2 && point2.column);
}
function position(pos) {
  return point(pos && pos.start) + "-" + point(pos && pos.end);
}
function index(value) {
  return value && typeof value === "number" ? value : 1;
}
class VFileMessage extends Error {
  /**
   * Create a message for `reason`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {Options | null | undefined} [options]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | Options | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns
   *   Instance of `VFileMessage`.
   */
  // eslint-disable-next-line complexity
  constructor(causeOrReason, optionsOrParentOrPlace, origin) {
    super();
    if (typeof optionsOrParentOrPlace === "string") {
      origin = optionsOrParentOrPlace;
      optionsOrParentOrPlace = void 0;
    }
    let reason = "";
    let options2 = {};
    let legacyCause = false;
    if (optionsOrParentOrPlace) {
      if ("line" in optionsOrParentOrPlace && "column" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("start" in optionsOrParentOrPlace && "end" in optionsOrParentOrPlace) {
        options2 = { place: optionsOrParentOrPlace };
      } else if ("type" in optionsOrParentOrPlace) {
        options2 = {
          ancestors: [optionsOrParentOrPlace],
          place: optionsOrParentOrPlace.position
        };
      } else {
        options2 = { ...optionsOrParentOrPlace };
      }
    }
    if (typeof causeOrReason === "string") {
      reason = causeOrReason;
    } else if (!options2.cause && causeOrReason) {
      legacyCause = true;
      reason = causeOrReason.message;
      options2.cause = causeOrReason;
    }
    if (!options2.ruleId && !options2.source && typeof origin === "string") {
      const index2 = origin.indexOf(":");
      if (index2 === -1) {
        options2.ruleId = origin;
      } else {
        options2.source = origin.slice(0, index2);
        options2.ruleId = origin.slice(index2 + 1);
      }
    }
    if (!options2.place && options2.ancestors && options2.ancestors) {
      const parent = options2.ancestors[options2.ancestors.length - 1];
      if (parent) {
        options2.place = parent.position;
      }
    }
    const start = options2.place && "start" in options2.place ? options2.place.start : options2.place;
    this.ancestors = options2.ancestors || void 0;
    this.cause = options2.cause || void 0;
    this.column = start ? start.column : void 0;
    this.fatal = void 0;
    this.file = "";
    this.message = reason;
    this.line = start ? start.line : void 0;
    this.name = stringifyPosition(options2.place) || "1:1";
    this.place = options2.place || void 0;
    this.reason = this.message;
    this.ruleId = options2.ruleId || void 0;
    this.source = options2.source || void 0;
    this.stack = legacyCause && options2.cause && typeof options2.cause.stack === "string" ? options2.cause.stack : "";
    this.actual = void 0;
    this.expected = void 0;
    this.note = void 0;
    this.url = void 0;
  }
}
VFileMessage.prototype.file = "";
VFileMessage.prototype.name = "";
VFileMessage.prototype.reason = "";
VFileMessage.prototype.message = "";
VFileMessage.prototype.stack = "";
VFileMessage.prototype.column = void 0;
VFileMessage.prototype.line = void 0;
VFileMessage.prototype.ancestors = void 0;
VFileMessage.prototype.cause = void 0;
VFileMessage.prototype.fatal = void 0;
VFileMessage.prototype.place = void 0;
VFileMessage.prototype.ruleId = void 0;
VFileMessage.prototype.source = void 0;
const minpath = { basename, dirname, extname, join: join$1$1, sep: "/" };
function basename(path, extname2) {
  if (extname2 !== void 0 && typeof extname2 !== "string") {
    throw new TypeError('"ext" argument must be a string');
  }
  assertPath$1(path);
  let start = 0;
  let end = -1;
  let index2 = path.length;
  let seenNonSlash;
  if (extname2 === void 0 || extname2.length === 0 || extname2.length > path.length) {
    while (index2--) {
      if (path.codePointAt(index2) === 47) {
        if (seenNonSlash) {
          start = index2 + 1;
          break;
        }
      } else if (end < 0) {
        seenNonSlash = true;
        end = index2 + 1;
      }
    }
    return end < 0 ? "" : path.slice(start, end);
  }
  if (extname2 === path) {
    return "";
  }
  let firstNonSlashEnd = -1;
  let extnameIndex = extname2.length - 1;
  while (index2--) {
    if (path.codePointAt(index2) === 47) {
      if (seenNonSlash) {
        start = index2 + 1;
        break;
      }
    } else {
      if (firstNonSlashEnd < 0) {
        seenNonSlash = true;
        firstNonSlashEnd = index2 + 1;
      }
      if (extnameIndex > -1) {
        if (path.codePointAt(index2) === extname2.codePointAt(extnameIndex--)) {
          if (extnameIndex < 0) {
            end = index2;
          }
        } else {
          extnameIndex = -1;
          end = firstNonSlashEnd;
        }
      }
    }
  }
  if (start === end) {
    end = firstNonSlashEnd;
  } else if (end < 0) {
    end = path.length;
  }
  return path.slice(start, end);
}
function dirname(path) {
  assertPath$1(path);
  if (path.length === 0) {
    return ".";
  }
  let end = -1;
  let index2 = path.length;
  let unmatchedSlash;
  while (--index2) {
    if (path.codePointAt(index2) === 47) {
      if (unmatchedSlash) {
        end = index2;
        break;
      }
    } else if (!unmatchedSlash) {
      unmatchedSlash = true;
    }
  }
  return end < 0 ? path.codePointAt(0) === 47 ? "/" : "." : end === 1 && path.codePointAt(0) === 47 ? "//" : path.slice(0, end);
}
function extname(path) {
  assertPath$1(path);
  let index2 = path.length;
  let end = -1;
  let startPart = 0;
  let startDot = -1;
  let preDotState = 0;
  let unmatchedSlash;
  while (index2--) {
    const code2 = path.codePointAt(index2);
    if (code2 === 47) {
      if (unmatchedSlash) {
        startPart = index2 + 1;
        break;
      }
      continue;
    }
    if (end < 0) {
      unmatchedSlash = true;
      end = index2 + 1;
    }
    if (code2 === 46) {
      if (startDot < 0) {
        startDot = index2;
      } else if (preDotState !== 1) {
        preDotState = 1;
      }
    } else if (startDot > -1) {
      preDotState = -1;
    }
  }
  if (startDot < 0 || end < 0 || // We saw a non-dot character immediately before the dot.
  preDotState === 0 || // The (right-most) trimmed path component is exactly `..`.
  preDotState === 1 && startDot === end - 1 && startDot === startPart + 1) {
    return "";
  }
  return path.slice(startDot, end);
}
function join$1$1(...segments) {
  let index2 = -1;
  let joined;
  while (++index2 < segments.length) {
    assertPath$1(segments[index2]);
    if (segments[index2]) {
      joined = joined === void 0 ? segments[index2] : joined + "/" + segments[index2];
    }
  }
  return joined === void 0 ? "." : normalize$1(joined);
}
function normalize$1(path) {
  assertPath$1(path);
  const absolute = path.codePointAt(0) === 47;
  let value = normalizeString$1(path, !absolute);
  if (value.length === 0 && !absolute) {
    value = ".";
  }
  if (value.length > 0 && path.codePointAt(path.length - 1) === 47) {
    value += "/";
  }
  return absolute ? "/" + value : value;
}
function normalizeString$1(path, allowAboveRoot) {
  let result2 = "";
  let lastSegmentLength = 0;
  let lastSlash = -1;
  let dots = 0;
  let index2 = -1;
  let code2;
  let lastSlashIndex;
  while (++index2 <= path.length) {
    if (index2 < path.length) {
      code2 = path.codePointAt(index2);
    } else if (code2 === 47) {
      break;
    } else {
      code2 = 47;
    }
    if (code2 === 47) {
      if (lastSlash === index2 - 1 || dots === 1) ;
      else if (lastSlash !== index2 - 1 && dots === 2) {
        if (result2.length < 2 || lastSegmentLength !== 2 || result2.codePointAt(result2.length - 1) !== 46 || result2.codePointAt(result2.length - 2) !== 46) {
          if (result2.length > 2) {
            lastSlashIndex = result2.lastIndexOf("/");
            if (lastSlashIndex !== result2.length - 1) {
              if (lastSlashIndex < 0) {
                result2 = "";
                lastSegmentLength = 0;
              } else {
                result2 = result2.slice(0, lastSlashIndex);
                lastSegmentLength = result2.length - 1 - result2.lastIndexOf("/");
              }
              lastSlash = index2;
              dots = 0;
              continue;
            }
          } else if (result2.length > 0) {
            result2 = "";
            lastSegmentLength = 0;
            lastSlash = index2;
            dots = 0;
            continue;
          }
        }
        if (allowAboveRoot) {
          result2 = result2.length > 0 ? result2 + "/.." : "..";
          lastSegmentLength = 2;
        }
      } else {
        if (result2.length > 0) {
          result2 += "/" + path.slice(lastSlash + 1, index2);
        } else {
          result2 = path.slice(lastSlash + 1, index2);
        }
        lastSegmentLength = index2 - lastSlash - 1;
      }
      lastSlash = index2;
      dots = 0;
    } else if (code2 === 46 && dots > -1) {
      dots++;
    } else {
      dots = -1;
    }
  }
  return result2;
}
function assertPath$1(path) {
  if (typeof path !== "string") {
    throw new TypeError(
      "Path must be a string. Received " + JSON.stringify(path)
    );
  }
}
const minproc = { cwd };
function cwd() {
  return "/";
}
function isUrl(fileUrlOrPath) {
  return Boolean(
    fileUrlOrPath !== null && typeof fileUrlOrPath === "object" && "href" in fileUrlOrPath && fileUrlOrPath.href && "protocol" in fileUrlOrPath && fileUrlOrPath.protocol && // @ts-expect-error: indexing is fine.
    fileUrlOrPath.auth === void 0
  );
}
function urlToPath(path) {
  if (typeof path === "string") {
    path = new URL(path);
  } else if (!isUrl(path)) {
    const error = new TypeError(
      'The "path" argument must be of type string or an instance of URL. Received `' + path + "`"
    );
    error.code = "ERR_INVALID_ARG_TYPE";
    throw error;
  }
  if (path.protocol !== "file:") {
    const error = new TypeError("The URL must be of scheme file");
    error.code = "ERR_INVALID_URL_SCHEME";
    throw error;
  }
  return getPathFromURLPosix(path);
}
function getPathFromURLPosix(url) {
  if (url.hostname !== "") {
    const error = new TypeError(
      'File URL host must be "localhost" or empty on darwin'
    );
    error.code = "ERR_INVALID_FILE_URL_HOST";
    throw error;
  }
  const pathname = url.pathname;
  let index2 = -1;
  while (++index2 < pathname.length) {
    if (pathname.codePointAt(index2) === 37 && pathname.codePointAt(index2 + 1) === 50) {
      const third = pathname.codePointAt(index2 + 2);
      if (third === 70 || third === 102) {
        const error = new TypeError(
          "File URL path must not include encoded / characters"
        );
        error.code = "ERR_INVALID_FILE_URL_PATH";
        throw error;
      }
    }
  }
  return decodeURIComponent(pathname);
}
const order = (
  /** @type {const} */
  [
    "history",
    "path",
    "basename",
    "stem",
    "extname",
    "dirname"
  ]
);
class VFile {
  /**
   * Create a new virtual file.
   *
   * `options` is treated as:
   *
   * *   `string` or `Uint8Array` — `{value: options}`
   * *   `URL` — `{path: options}`
   * *   `VFile` — shallow copies its data over to the new file
   * *   `object` — all fields are shallow copied over to the new file
   *
   * Path related fields are set in the following order (least specific to
   * most specific): `history`, `path`, `basename`, `stem`, `extname`,
   * `dirname`.
   *
   * You cannot set `dirname` or `extname` without setting either `history`,
   * `path`, `basename`, or `stem` too.
   *
   * @param {Compatible | null | undefined} [value]
   *   File value.
   * @returns
   *   New instance.
   */
  constructor(value) {
    let options2;
    if (!value) {
      options2 = {};
    } else if (isUrl(value)) {
      options2 = { path: value };
    } else if (typeof value === "string" || isUint8Array$1(value)) {
      options2 = { value };
    } else {
      options2 = value;
    }
    this.cwd = "cwd" in options2 ? "" : minproc.cwd();
    this.data = {};
    this.history = [];
    this.messages = [];
    this.value;
    this.map;
    this.result;
    this.stored;
    let index2 = -1;
    while (++index2 < order.length) {
      const field2 = order[index2];
      if (field2 in options2 && options2[field2] !== void 0 && options2[field2] !== null) {
        this[field2] = field2 === "history" ? [...options2[field2]] : options2[field2];
      }
    }
    let field;
    for (field in options2) {
      if (!order.includes(field)) {
        this[field] = options2[field];
      }
    }
  }
  /**
   * Get the basename (including extname) (example: `'index.min.js'`).
   *
   * @returns {string | undefined}
   *   Basename.
   */
  get basename() {
    return typeof this.path === "string" ? minpath.basename(this.path) : void 0;
  }
  /**
   * Set basename (including extname) (`'index.min.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} basename
   *   Basename.
   * @returns {undefined}
   *   Nothing.
   */
  set basename(basename2) {
    assertNonEmpty(basename2, "basename");
    assertPart(basename2, "basename");
    this.path = minpath.join(this.dirname || "", basename2);
  }
  /**
   * Get the parent path (example: `'~'`).
   *
   * @returns {string | undefined}
   *   Dirname.
   */
  get dirname() {
    return typeof this.path === "string" ? minpath.dirname(this.path) : void 0;
  }
  /**
   * Set the parent path (example: `'~'`).
   *
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} dirname
   *   Dirname.
   * @returns {undefined}
   *   Nothing.
   */
  set dirname(dirname2) {
    assertPath(this.basename, "dirname");
    this.path = minpath.join(dirname2 || "", this.basename);
  }
  /**
   * Get the extname (including dot) (example: `'.js'`).
   *
   * @returns {string | undefined}
   *   Extname.
   */
  get extname() {
    return typeof this.path === "string" ? minpath.extname(this.path) : void 0;
  }
  /**
   * Set the extname (including dot) (example: `'.js'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be set if there’s no `path` yet.
   *
   * @param {string | undefined} extname
   *   Extname.
   * @returns {undefined}
   *   Nothing.
   */
  set extname(extname2) {
    assertPart(extname2, "extname");
    assertPath(this.dirname, "extname");
    if (extname2) {
      if (extname2.codePointAt(0) !== 46) {
        throw new Error("`extname` must start with `.`");
      }
      if (extname2.includes(".", 1)) {
        throw new Error("`extname` cannot contain multiple dots");
      }
    }
    this.path = minpath.join(this.dirname, this.stem + (extname2 || ""));
  }
  /**
   * Get the full path (example: `'~/index.min.js'`).
   *
   * @returns {string}
   *   Path.
   */
  get path() {
    return this.history[this.history.length - 1];
  }
  /**
   * Set the full path (example: `'~/index.min.js'`).
   *
   * Cannot be nullified.
   * You can set a file URL (a `URL` object with a `file:` protocol) which will
   * be turned into a path with `url.fileURLToPath`.
   *
   * @param {URL | string} path
   *   Path.
   * @returns {undefined}
   *   Nothing.
   */
  set path(path) {
    if (isUrl(path)) {
      path = urlToPath(path);
    }
    assertNonEmpty(path, "path");
    if (this.path !== path) {
      this.history.push(path);
    }
  }
  /**
   * Get the stem (basename w/o extname) (example: `'index.min'`).
   *
   * @returns {string | undefined}
   *   Stem.
   */
  get stem() {
    return typeof this.path === "string" ? minpath.basename(this.path, this.extname) : void 0;
  }
  /**
   * Set the stem (basename w/o extname) (example: `'index.min'`).
   *
   * Cannot contain path separators (`'/'` on unix, macOS, and browsers, `'\'`
   * on windows).
   * Cannot be nullified (use `file.path = file.dirname` instead).
   *
   * @param {string} stem
   *   Stem.
   * @returns {undefined}
   *   Nothing.
   */
  set stem(stem) {
    assertNonEmpty(stem, "stem");
    assertPart(stem, "stem");
    this.path = minpath.join(this.dirname || "", stem + (this.extname || ""));
  }
  // Normal prototypal methods.
  /**
   * Create a fatal message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `true` (error; file not usable)
   * and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {never}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {never}
   *   Never.
   * @throws {VFileMessage}
   *   Message.
   */
  fail(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = true;
    throw message;
  }
  /**
   * Create an info message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `undefined` (info; change
   * likely not needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  info(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = this.message(causeOrReason, optionsOrParentOrPlace, origin);
    message.fatal = void 0;
    return message;
  }
  /**
   * Create a message for `reason` associated with the file.
   *
   * The `fatal` field of the message is set to `false` (warning; change may be
   * needed) and the `file` field is set to the current file path.
   * The message is added to the `messages` field on `file`.
   *
   * > 🪦 **Note**: also has obsolete signatures.
   *
   * @overload
   * @param {string} reason
   * @param {MessageOptions | null | undefined} [options]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {string} reason
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Node | NodeLike | null | undefined} parent
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {Point | Position | null | undefined} place
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @overload
   * @param {Error | VFileMessage} cause
   * @param {string | null | undefined} [origin]
   * @returns {VFileMessage}
   *
   * @param {Error | VFileMessage | string} causeOrReason
   *   Reason for message, should use markdown.
   * @param {Node | NodeLike | MessageOptions | Point | Position | string | null | undefined} [optionsOrParentOrPlace]
   *   Configuration (optional).
   * @param {string | null | undefined} [origin]
   *   Place in code where the message originates (example:
   *   `'my-package:my-rule'` or `'my-rule'`).
   * @returns {VFileMessage}
   *   Message.
   */
  message(causeOrReason, optionsOrParentOrPlace, origin) {
    const message = new VFileMessage(
      // @ts-expect-error: the overloads are fine.
      causeOrReason,
      optionsOrParentOrPlace,
      origin
    );
    if (this.path) {
      message.name = this.path + ":" + message.name;
      message.file = this.path;
    }
    message.fatal = false;
    this.messages.push(message);
    return message;
  }
  /**
   * Serialize the file.
   *
   * > **Note**: which encodings are supported depends on the engine.
   * > For info on Node.js, see:
   * > <https://nodejs.org/api/util.html#whatwg-supported-encodings>.
   *
   * @param {string | null | undefined} [encoding='utf8']
   *   Character encoding to understand `value` as when it’s a `Uint8Array`
   *   (default: `'utf-8'`).
   * @returns {string}
   *   Serialized file.
   */
  toString(encoding) {
    if (this.value === void 0) {
      return "";
    }
    if (typeof this.value === "string") {
      return this.value;
    }
    const decoder = new TextDecoder(encoding || void 0);
    return decoder.decode(this.value);
  }
}
function assertPart(part, name2) {
  if (part && part.includes(minpath.sep)) {
    throw new Error(
      "`" + name2 + "` cannot be a path: did not expect `" + minpath.sep + "`"
    );
  }
}
function assertNonEmpty(part, name2) {
  if (!part) {
    throw new Error("`" + name2 + "` cannot be empty");
  }
}
function assertPath(path, name2) {
  if (!path) {
    throw new Error("Setting `" + name2 + "` requires `path` to be set too");
  }
}
function isUint8Array$1(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const CallableInstance = (
  /**
   * @type {new <Parameters extends Array<unknown>, Result>(property: string | symbol) => (...parameters: Parameters) => Result}
   */
  /** @type {unknown} */
  /**
   * @this {Function}
   * @param {string | symbol} property
   * @returns {(...parameters: Array<unknown>) => unknown}
   */
  (function(property2) {
    const self2 = this;
    const constr = self2.constructor;
    const proto = (
      /** @type {Record<string | symbol, Function>} */
      // Prototypes do exist.
      // type-coverage:ignore-next-line
      constr.prototype
    );
    const value = proto[property2];
    const apply = function() {
      return value.apply(apply, arguments);
    };
    Object.setPrototypeOf(apply, proto);
    return apply;
  })
);
const own = {}.hasOwnProperty;
class Processor extends CallableInstance {
  /**
   * Create a processor.
   */
  constructor() {
    super("copy");
    this.Compiler = void 0;
    this.Parser = void 0;
    this.attachers = [];
    this.compiler = void 0;
    this.freezeIndex = -1;
    this.frozen = void 0;
    this.namespace = {};
    this.parser = void 0;
    this.transformers = trough();
  }
  /**
   * Copy a processor.
   *
   * @deprecated
   *   This is a private internal method and should not be used.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   New *unfrozen* processor ({@linkcode Processor}) that is
   *   configured to work the same as its ancestor.
   *   When the descendant processor is configured in the future it does not
   *   affect the ancestral processor.
   */
  copy() {
    const destination = (
      /** @type {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>} */
      new Processor()
    );
    let index2 = -1;
    while (++index2 < this.attachers.length) {
      const attacher = this.attachers[index2];
      destination.use(...attacher);
    }
    destination.data(extend$2(true, {}, this.namespace));
    return destination;
  }
  /**
   * Configure the processor with info available to all plugins.
   * Information is stored in an object.
   *
   * Typically, options can be given to a specific plugin, but sometimes it
   * makes sense to have information shared with several plugins.
   * For example, a list of HTML elements that are self-closing, which is
   * needed during all phases.
   *
   * > **Note**: setting information cannot occur on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * > **Note**: to register custom data in TypeScript, augment the
   * > {@linkcode Data} interface.
   *
   * @example
   *   This example show how to get and set info:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   const processor = unified().data('alpha', 'bravo')
   *
   *   processor.data('alpha') // => 'bravo'
   *
   *   processor.data() // => {alpha: 'bravo'}
   *
   *   processor.data({charlie: 'delta'})
   *
   *   processor.data() // => {charlie: 'delta'}
   *   ```
   *
   * @template {keyof Data} Key
   *
   * @overload
   * @returns {Data}
   *
   * @overload
   * @param {Data} dataset
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Key} key
   * @returns {Data[Key]}
   *
   * @overload
   * @param {Key} key
   * @param {Data[Key]} value
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @param {Data | Key} [key]
   *   Key to get or set, or entire dataset to set, or nothing to get the
   *   entire dataset (optional).
   * @param {Data[Key]} [value]
   *   Value to set (optional).
   * @returns {unknown}
   *   The current processor when setting, the value at `key` when getting, or
   *   the entire dataset when getting without key.
   */
  data(key, value) {
    if (typeof key === "string") {
      if (arguments.length === 2) {
        assertUnfrozen("data", this.frozen);
        this.namespace[key] = value;
        return this;
      }
      return own.call(this.namespace, key) && this.namespace[key] || void 0;
    }
    if (key) {
      assertUnfrozen("data", this.frozen);
      this.namespace = key;
      return this;
    }
    return this.namespace;
  }
  /**
   * Freeze a processor.
   *
   * Frozen processors are meant to be extended and not to be configured
   * directly.
   *
   * When a processor is frozen it cannot be unfrozen.
   * New processors working the same way can be created by calling the
   * processor.
   *
   * It’s possible to freeze processors explicitly by calling `.freeze()`.
   * Processors freeze automatically when `.parse()`, `.run()`, `.runSync()`,
   * `.stringify()`, `.process()`, or `.processSync()` are called.
   *
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   The current processor.
   */
  freeze() {
    if (this.frozen) {
      return this;
    }
    const self2 = (
      /** @type {Processor} */
      /** @type {unknown} */
      this
    );
    while (++this.freezeIndex < this.attachers.length) {
      const [attacher, ...options2] = this.attachers[this.freezeIndex];
      if (options2[0] === false) {
        continue;
      }
      if (options2[0] === true) {
        options2[0] = void 0;
      }
      const transformer = attacher.call(self2, ...options2);
      if (typeof transformer === "function") {
        this.transformers.use(transformer);
      }
    }
    this.frozen = true;
    this.freezeIndex = Number.POSITIVE_INFINITY;
    return this;
  }
  /**
   * Parse text to a syntax tree.
   *
   * > **Note**: `parse` freezes the processor if not already *frozen*.
   *
   * > **Note**: `parse` performs the parse phase, not the run phase or other
   * > phases.
   *
   * @param {Compatible | undefined} [file]
   *   file to parse (optional); typically `string` or `VFile`; any value
   *   accepted as `x` in `new VFile(x)`.
   * @returns {ParseTree extends undefined ? Node : ParseTree}
   *   Syntax tree representing `file`.
   */
  parse(file) {
    this.freeze();
    const realFile = vfile(file);
    const parser2 = this.parser || this.Parser;
    assertParser("parse", parser2);
    return parser2(String(realFile), realFile);
  }
  /**
   * Process the given file as configured on the processor.
   *
   * > **Note**: `process` freezes the processor if not already *frozen*.
   *
   * > **Note**: `process` performs the parse, run, and stringify phases.
   *
   * @overload
   * @param {Compatible | undefined} file
   * @param {ProcessCallback<VFileWithOutput<CompileResult>>} done
   * @returns {undefined}
   *
   * @overload
   * @param {Compatible | undefined} [file]
   * @returns {Promise<VFileWithOutput<CompileResult>>}
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`]; any value accepted as
   *   `x` in `new VFile(x)`.
   * @param {ProcessCallback<VFileWithOutput<CompileResult>> | undefined} [done]
   *   Callback (optional).
   * @returns {Promise<VFile> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise a promise, rejected with a fatal error or resolved with the
   *   processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  process(file, done) {
    const self2 = this;
    this.freeze();
    assertParser("process", this.parser || this.Parser);
    assertCompiler("process", this.compiler || this.Compiler);
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile(file);
      const parseTree = (
        /** @type {HeadTree extends undefined ? Node : HeadTree} */
        /** @type {unknown} */
        self2.parse(realFile)
      );
      self2.run(parseTree, realFile, function(error, tree, file2) {
        if (error || !tree || !file2) {
          return realDone(error);
        }
        const compileTree = (
          /** @type {CompileTree extends undefined ? Node : CompileTree} */
          /** @type {unknown} */
          tree
        );
        const compileResult = self2.stringify(compileTree, file2);
        if (looksLikeAValue(compileResult)) {
          file2.value = compileResult;
        } else {
          file2.result = compileResult;
        }
        realDone(
          error,
          /** @type {VFileWithOutput<CompileResult>} */
          file2
        );
      });
      function realDone(error, file2) {
        if (error || !file2) {
          reject2(error);
        } else if (resolve) {
          resolve(file2);
        } else {
          done(void 0, file2);
        }
      }
    }
  }
  /**
   * Process the given file as configured on the processor.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `processSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `processSync` performs the parse, run, and stringify phases.
   *
   * @param {Compatible | undefined} [file]
   *   File (optional); typically `string` or `VFile`; any value accepted as
   *   `x` in `new VFile(x)`.
   * @returns {VFileWithOutput<CompileResult>}
   *   The processed file.
   *
   *   The parsed, transformed, and compiled value is available at
   *   `file.value` (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most
   *   > compilers return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  processSync(file) {
    let complete = false;
    let result2;
    this.freeze();
    assertParser("processSync", this.parser || this.Parser);
    assertCompiler("processSync", this.compiler || this.Compiler);
    this.process(file, realDone);
    assertDone("processSync", "process", complete);
    return result2;
    function realDone(error, file2) {
      complete = true;
      bail(error);
      result2 = file2;
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * > **Note**: `run` freezes the processor if not already *frozen*.
   *
   * > **Note**: `run` performs the run phase, not other phases.
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} file
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} done
   * @returns {undefined}
   *
   * @overload
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   * @param {Compatible | undefined} [file]
   * @returns {Promise<TailTree extends undefined ? Node : TailTree>}
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {(
   *   RunCallback<TailTree extends undefined ? Node : TailTree> |
   *   Compatible
   * )} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @param {RunCallback<TailTree extends undefined ? Node : TailTree>} [done]
   *   Callback (optional).
   * @returns {Promise<TailTree extends undefined ? Node : TailTree> | undefined}
   *   Nothing if `done` is given.
   *   Otherwise, a promise rejected with a fatal error or resolved with the
   *   transformed tree.
   */
  run(tree, file, done) {
    assertNode(tree);
    this.freeze();
    const transformers = this.transformers;
    if (!done && typeof file === "function") {
      done = file;
      file = void 0;
    }
    return done ? executor(void 0, done) : new Promise(executor);
    function executor(resolve, reject2) {
      const realFile = vfile(file);
      transformers.run(tree, realFile, realDone);
      function realDone(error, outputTree, file2) {
        const resultingTree = (
          /** @type {TailTree extends undefined ? Node : TailTree} */
          outputTree || tree
        );
        if (error) {
          reject2(error);
        } else if (resolve) {
          resolve(resultingTree);
        } else {
          done(void 0, resultingTree, file2);
        }
      }
    }
  }
  /**
   * Run *transformers* on a syntax tree.
   *
   * An error is thrown if asynchronous transforms are configured.
   *
   * > **Note**: `runSync` freezes the processor if not already *frozen*.
   *
   * > **Note**: `runSync` performs the run phase, not other phases.
   *
   * @param {HeadTree extends undefined ? Node : HeadTree} tree
   *   Tree to transform and inspect.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {TailTree extends undefined ? Node : TailTree}
   *   Transformed tree.
   */
  runSync(tree, file) {
    let complete = false;
    let result2;
    this.run(tree, file, realDone);
    assertDone("runSync", "run", complete);
    return result2;
    function realDone(error, tree2) {
      bail(error);
      result2 = tree2;
      complete = true;
    }
  }
  /**
   * Compile a syntax tree.
   *
   * > **Note**: `stringify` freezes the processor if not already *frozen*.
   *
   * > **Note**: `stringify` performs the stringify phase, not the run phase
   * > or other phases.
   *
   * @param {CompileTree extends undefined ? Node : CompileTree} tree
   *   Tree to compile.
   * @param {Compatible | undefined} [file]
   *   File associated with `node` (optional); any value accepted as `x` in
   *   `new VFile(x)`.
   * @returns {CompileResult extends undefined ? Value : CompileResult}
   *   Textual representation of the tree (see note).
   *
   *   > **Note**: unified typically compiles by serializing: most compilers
   *   > return `string` (or `Uint8Array`).
   *   > Some compilers, such as the one configured with
   *   > [`rehype-react`][rehype-react], return other values (in this case, a
   *   > React tree).
   *   > If you’re using a compiler that doesn’t serialize, expect different
   *   > result values.
   *   >
   *   > To register custom results in TypeScript, add them to
   *   > {@linkcode CompileResultMap}.
   *
   *   [rehype-react]: https://github.com/rehypejs/rehype-react
   */
  stringify(tree, file) {
    this.freeze();
    const realFile = vfile(file);
    const compiler = this.compiler || this.Compiler;
    assertCompiler("stringify", compiler);
    assertNode(tree);
    return compiler(tree, realFile);
  }
  /**
   * Configure the processor to use a plugin, a list of usable values, or a
   * preset.
   *
   * If the processor is already using a plugin, the previous plugin
   * configuration is changed based on the options that are passed in.
   * In other words, the plugin is not added a second time.
   *
   * > **Note**: `use` cannot be called on *frozen* processors.
   * > Call the processor first to create a new unfrozen processor.
   *
   * @example
   *   There are many ways to pass plugins to `.use()`.
   *   This example gives an overview:
   *
   *   ```js
   *   import {unified} from 'unified'
   *
   *   unified()
   *     // Plugin with options:
   *     .use(pluginA, {x: true, y: true})
   *     // Passing the same plugin again merges configuration (to `{x: true, y: false, z: true}`):
   *     .use(pluginA, {y: false, z: true})
   *     // Plugins:
   *     .use([pluginB, pluginC])
   *     // Two plugins, the second with options:
   *     .use([pluginD, [pluginE, {}]])
   *     // Preset with plugins and settings:
   *     .use({plugins: [pluginF, [pluginG, {}]], settings: {position: false}})
   *     // Settings only:
   *     .use({settings: {position: false}})
   *   ```
   *
   * @template {Array<unknown>} [Parameters=[]]
   * @template {Node | string | undefined} [Input=undefined]
   * @template [Output=Input]
   *
   * @overload
   * @param {Preset | null | undefined} [preset]
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {PluggableList} list
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *
   * @overload
   * @param {Plugin<Parameters, Input, Output>} plugin
   * @param {...(Parameters | [boolean])} parameters
   * @returns {UsePlugin<ParseTree, HeadTree, TailTree, CompileTree, CompileResult, Input, Output>}
   *
   * @param {PluggableList | Plugin | Preset | null | undefined} value
   *   Usable value.
   * @param {...unknown} parameters
   *   Parameters, when a plugin is given as a usable value.
   * @returns {Processor<ParseTree, HeadTree, TailTree, CompileTree, CompileResult>}
   *   Current processor.
   */
  use(value, ...parameters) {
    const attachers = this.attachers;
    const namespace = this.namespace;
    assertUnfrozen("use", this.frozen);
    if (value === null || value === void 0) ;
    else if (typeof value === "function") {
      addPlugin(value, parameters);
    } else if (typeof value === "object") {
      if (Array.isArray(value)) {
        addList(value);
      } else {
        addPreset(value);
      }
    } else {
      throw new TypeError("Expected usable value, not `" + value + "`");
    }
    return this;
    function add2(value2) {
      if (typeof value2 === "function") {
        addPlugin(value2, []);
      } else if (typeof value2 === "object") {
        if (Array.isArray(value2)) {
          const [plugin, ...parameters2] = (
            /** @type {PluginTuple<Array<unknown>>} */
            value2
          );
          addPlugin(plugin, parameters2);
        } else {
          addPreset(value2);
        }
      } else {
        throw new TypeError("Expected usable value, not `" + value2 + "`");
      }
    }
    function addPreset(result2) {
      if (!("plugins" in result2) && !("settings" in result2)) {
        throw new Error(
          "Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither"
        );
      }
      addList(result2.plugins);
      if (result2.settings) {
        namespace.settings = extend$2(true, namespace.settings, result2.settings);
      }
    }
    function addList(plugins2) {
      let index2 = -1;
      if (plugins2 === null || plugins2 === void 0) ;
      else if (Array.isArray(plugins2)) {
        while (++index2 < plugins2.length) {
          const thing = plugins2[index2];
          add2(thing);
        }
      } else {
        throw new TypeError("Expected a list of plugins, not `" + plugins2 + "`");
      }
    }
    function addPlugin(plugin, parameters2) {
      let index2 = -1;
      let entryIndex = -1;
      while (++index2 < attachers.length) {
        if (attachers[index2][0] === plugin) {
          entryIndex = index2;
          break;
        }
      }
      if (entryIndex === -1) {
        attachers.push([plugin, ...parameters2]);
      } else if (parameters2.length > 0) {
        let [primary, ...rest2] = parameters2;
        const currentPrimary = attachers[entryIndex][1];
        if (isPlainObject$1(currentPrimary) && isPlainObject$1(primary)) {
          primary = extend$2(true, currentPrimary, primary);
        }
        attachers[entryIndex] = [plugin, primary, ...rest2];
      }
    }
  }
}
new Processor().freeze();
function assertParser(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `parser`");
  }
}
function assertCompiler(name2, value) {
  if (typeof value !== "function") {
    throw new TypeError("Cannot `" + name2 + "` without `compiler`");
  }
}
function assertUnfrozen(name2, frozen) {
  if (frozen) {
    throw new Error(
      "Cannot call `" + name2 + "` on a frozen processor.\nCreate a new processor first, by calling it: use `processor()` instead of `processor`."
    );
  }
}
function assertNode(node) {
  if (!isPlainObject$1(node) || typeof node.type !== "string") {
    throw new TypeError("Expected node, got `" + node + "`");
  }
}
function assertDone(name2, asyncName, complete) {
  if (!complete) {
    throw new Error(
      "`" + name2 + "` finished async. Use `" + asyncName + "` instead"
    );
  }
}
function vfile(value) {
  return looksLikeAVFile(value) ? value : new VFile(value);
}
function looksLikeAVFile(value) {
  return Boolean(
    value && typeof value === "object" && "message" in value && "messages" in value
  );
}
function looksLikeAValue(value) {
  return typeof value === "string" || isUint8Array(value);
}
function isUint8Array(value) {
  return Boolean(
    value && typeof value === "object" && "byteLength" in value && "byteOffset" in value
  );
}
const SCORED_SECTION_COMPONENT_TYPES = [
  "document",
  "section",
  "subsection",
  "subsubsection",
  "paragraphs",
  "aside",
  "objectives",
  "problem",
  "exercise",
  "question",
  "activity",
  "example",
  "definition",
  "note",
  "theorem",
  "part",
  "task",
  "proof",
  "problems",
  "exercises",
  "standinForFutureLayoutTag",
  "externalContent",
  "cascade",
  "div",
  "span",
  "ol",
  "ul",
  "li",
  "p"
];
function renamedScoredSectionAttribute(oldName, newName) {
  const rule = {
    to: newName,
    warningMessage: `[deprecation] Attribute \`${oldName}\` is deprecated; use \`${newName}\` instead.`,
    conflictWarningMessage: `[deprecation] Attribute \`${oldName}\` is deprecated and ignored because \`${newName}\` is also specified.`
  };
  return Object.fromEntries(
    SCORED_SECTION_COMPONENT_TYPES.map((comp) => [
      comp,
      { [oldName]: rule }
    ])
  );
}
function ignoredAttributes(componentName, attributeNames) {
  return Object.fromEntries(
    attributeNames.map((attributeName) => [
      attributeName,
      {
        warningMessage: `[deprecation] Attribute \`${attributeName}\` on \`<${componentName}>\` is deprecated and ignored.`
      }
    ])
  );
}
const SCORED_SECTION_COLORING_RENAMES = renamedScoredSectionAttribute(
  "forceIndividualAnswerColoring",
  "colorAnswersSeparately"
);
const DEPRECATION_REGISTRY = {
  attributeRenames: {
    // Merge per-component rules, spreading scored-section rename rules
    // first so component-specific rules take precedence on conflict.
    ...SCORED_SECTION_COLORING_RENAMES,
    document: {
      // document already has a scored-section rename (spread above) plus
      // its own documentWideCheckWork rename.
      ...SCORED_SECTION_COLORING_RENAMES["document"],
      documentWideCheckWork: {
        to: "sectionWideCheckWork",
        warningMessage: "[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated; use `sectionWideCheckWork` instead.",
        conflictWarningMessage: "[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated and ignored because `sectionWideCheckWork` is also specified."
      }
    },
    selectFromSequence: {
      sortResults: {
        to: "sort",
        warningMessage: "[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated; use `sort` instead.",
        conflictWarningMessage: "[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated and ignored because `sort` is also specified."
      }
    },
    selectPrimeNumbers: {
      minValue: {
        to: "from",
        warningMessage: "[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated; use `from` instead.",
        conflictWarningMessage: "[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated and ignored because `from` is also specified."
      },
      maxValue: {
        to: "to",
        warningMessage: "[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated; use `to` instead.",
        conflictWarningMessage: "[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated and ignored because `to` is also specified."
      },
      sortResults: {
        to: "sort",
        warningMessage: "[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated; use `sort` instead.",
        conflictWarningMessage: "[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated and ignored because `sort` is also specified."
      }
    },
    samplePrimeNumbers: {
      minValue: {
        to: "from",
        warningMessage: "[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated; use `from` instead.",
        conflictWarningMessage: "[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated and ignored because `from` is also specified."
      },
      maxValue: {
        to: "to",
        warningMessage: "[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated; use `to` instead.",
        conflictWarningMessage: "[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated and ignored because `to` is also specified."
      }
    }
  },
  attributeRemovals: {
    // `description` and `shortDescription` previously inherited these
    // attributes from `Div` / `Text`, which are inappropriate parents for
    // them. The attributes never had a meaningful effect on these
    // components; they are dropped with a warning.
    description: ignoredAttributes("description", [
      "aggregateScores",
      "weight",
      "sectionWideCheckWork",
      "showCorrectness",
      "colorCorrectness",
      "forceIndividualAnswerColoring",
      "submitLabel",
      "submitLabelNoCorrectness",
      "displayDigitsForCreditAchieved"
    ]),
    shortDescription: ignoredAttributes("shortDescription", [
      "draggable",
      "layer",
      "isLatex",
      "anchor",
      "positionFromAnchor"
    ])
  },
  componentRenames: {}
};
function lowerKeys(o2) {
  return Object.fromEntries(
    Object.entries(o2).map(([k2, v2]) => [k2.toLowerCase(), v2])
  );
}
function buildDeprecationIndex(registry) {
  return {
    attributeRenames: Object.fromEntries(
      Object.entries(registry.attributeRenames).map(([comp, rules]) => [
        comp,
        lowerKeys(rules)
      ])
    ),
    attributeRemovals: Object.fromEntries(
      Object.entries(registry.attributeRemovals).map(([comp, rules]) => [
        comp,
        lowerKeys(rules)
      ])
    ),
    componentRenames: Object.fromEntries(
      Object.entries(registry.componentRenames).map(([comp, rule]) => [
        comp,
        rule.attributeRenames ? {
          ...rule,
          attributeRenames: lowerKeys(rule.attributeRenames)
        } : rule
      ])
    )
  };
}
buildDeprecationIndex(DEPRECATION_REGISTRY);
const parserWithMetadata = parser.configure({
  props: [
    indentNodeProp.add({
      // Indentation depends on the latest parse tree. If the user edits
      // the document and immediately inserts a newline before the parser
      // catches up (usually within a few tens of milliseconds), the new
      // line can momentarily fall back to column 0.
      Element(context) {
        let closed = /^\s*<\//.test(context.textAfter);
        return context.lineIndent(context.node.from) + (closed ? 0 : context.unit);
      },
      "OpenTag CloseTag SelfClosingTag"(context) {
        if (context.node.firstChild?.name == "TagName") {
          return context.column(context.node.from);
        }
        return context.column(context.node.from) + context.unit;
      }
    }),
    foldNodeProp.add({
      Element(subtree2) {
        let first2 = subtree2.firstChild;
        let last2 = subtree2.lastChild;
        if (!first2 || first2.name != "OpenTag") return null;
        return {
          from: first2.to,
          to: last2?.name == "CloseTag" ? last2.from : subtree2.to
        };
      }
    }),
    styleTags({
      AttributeValue: tags.string,
      Text: tags.content,
      TagName: tags.tagName,
      MismatchedCloseTag: tags.invalid,
      "StartTag StartCloseTag EndTag SelfCloseEndTag": tags.angleBracket,
      "MismatchedCloseTag/TagName": [tags.tagName, tags.invalid],
      "MismatchedCloseTag/StartCloseTag": tags.invalid,
      AttributeName: tags.propertyName,
      Is: tags.definitionOperator,
      "EntityReference CharacterReference": tags.character,
      Comment: tags.blockComment,
      Macro: tags.macroName
    })
  ]
});
function createHighlightStyle(colors) {
  return HighlightStyle.define([
    { tag: tags.string, color: colors.string },
    { tag: tags.tagName, color: colors.tagName },
    { tag: tags.angleBracket, color: colors.tagName },
    { tag: tags.propertyName, color: colors.propertyName },
    { tag: tags.invalid, color: colors.invalid },
    { tag: tags.blockComment, color: colors.blockComment },
    { tag: tags.macroName, color: colors.macroName },
    { tag: tags.content, color: colors.content },
    { tag: tags.definitionOperator, color: colors.content },
    { tag: tags.character, color: colors.tagName }
  ]);
}
const customHighlightStyle = createHighlightStyle({
  string: "#00732f",
  // Dark green - 4.62:1 on white
  tagName: "#0550ae",
  // Blue - 7.67:1 on white
  propertyName: "#953800",
  // Burnt orange - 5.17:1 on white
  invalid: "#a80000",
  // Dark red - 6.23:1 on white
  blockComment: "#656d76",
  // Gray - 4.54:1 on white
  macroName: "#6f42c1",
  // Purple - 5.01:1 on white
  content: "#24292f"
  // Near black - 15.3:1 on white
});
const doenetLanguage = LRLanguage.define({
  parser: parserWithMetadata,
  languageData: {
    commentTokens: { block: { open: "<!--", close: "-->" } },
    indentOnInput: /^\s*<\/$/
  }
});
const darkHighlightStyle = createHighlightStyle({
  string: "#56d364",
  // green  ~7.1:1 on #121212
  tagName: "#79c0ff",
  // blue   ~10:1 on #121212
  propertyName: "#ffa657",
  // orange ~7.4:1 on #121212
  invalid: "#ff7b72",
  // red    ~6.4:1 on #121212
  blockComment: "#8b949e",
  // gray   ~6.5:1 on #121212
  macroName: "#d2a8ff",
  // purple ~9.6:1 on #121212
  content: "#e6edf3"
  // near-white ~16:1 on #121212
});
function syntaxHighlightingExtension(darkMode) {
  return new LanguageSupport(doenetLanguage, [
    syntaxHighlighting(
      darkMode === "dark" ? darkHighlightStyle : customHighlightStyle
    )
  ]);
}
const tab = "  ";
const tabCommand = ({ state, dispatch }) => {
  console.log("running");
  dispatch(
    state.update(state.replaceSelection(tab), {
      scrollIntoView: true,
      annotations: Transaction.userEvent.of("input")
    })
  );
  return true;
};
const tabExtension = keymap.of([
  {
    key: "Tab",
    run: tabCommand
  }
]);
var dist$2 = {};
var core$2 = {};
var debug$2 = {};
var hasRequiredDebug$2;
function requireDebug$2() {
  if (hasRequiredDebug$2) return debug$2;
  hasRequiredDebug$2 = 1;
  Object.defineProperty(debug$2, "__esModule", { value: true });
  debug$2.getType = getType2;
  debug$2.throwUnknownDataType = throwUnknownDataType;
  debug$2.throwUnsupportedData = throwUnsupportedData;
  function getType2(o2) {
    return Object.prototype.toString.call(o2);
  }
  function throwUnknownDataType(o2) {
    throw new TypeError("unsupported data type: " + getType2(o2));
  }
  function throwUnsupportedData(name2) {
    throw new TypeError("unsupported data type: " + name2);
  }
  return debug$2;
}
var encode$1$1 = {};
var number$2 = {};
var hasRequiredNumber$2;
function requireNumber$2() {
  if (hasRequiredNumber$2) return number$2;
  hasRequiredNumber$2 = 1;
  Object.defineProperty(number$2, "__esModule", { value: true });
  number$2.s_to_int = s_to_int;
  number$2.s_to_big_int = s_to_big_int;
  number$2.int_to_s = int_to_s;
  number$2.big_int_to_s = big_int_to_s;
  number$2.num_to_s = num_to_s;
  number$2.int_str_to_s = int_str_to_s;
  number$2.s_to_num = s_to_num;
  let i_to_s = "";
  for (let i2 = 0; i2 < 10; i2++) {
    const c2 = String.fromCharCode(48 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + 32 + i2);
    i_to_s += c2;
  }
  const N2 = i_to_s.length;
  const s_to_i = {};
  for (let i2 = 0; i2 < N2; i2++) {
    const s2 = i_to_s[i2];
    s_to_i[s2] = i2;
  }
  function s_to_int(s2) {
    let acc = 0;
    let pow2 = 1;
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = s_to_i[c2];
      x2 *= pow2;
      acc += x2;
      pow2 *= N2;
    }
    return acc;
  }
  function s_to_big_int(s2) {
    let acc = BigInt(0);
    let pow2 = BigInt(1);
    const n2 = BigInt(N2);
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = BigInt(s_to_i[c2]);
      x2 *= pow2;
      acc += x2;
      pow2 *= n2;
    }
    return acc;
  }
  function int_to_s(int) {
    if (int === 0) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== 0) {
      const i2 = int % N2;
      const c2 = i_to_s[i2];
      acc.push(c2);
      int -= i2;
      int /= N2;
    }
    return acc.reverse().join("");
  }
  function big_int_to_s(int) {
    const zero = BigInt(0);
    const n2 = BigInt(N2);
    if (int === zero) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== zero) {
      const i2 = int % n2;
      const c2 = i_to_s[Number(i2)];
      acc.push(c2);
      int /= n2;
    }
    return acc.reverse().join("");
  }
  function reverse(s2) {
    return s2.split("").reverse().join("");
  }
  function num_to_s(num) {
    if (num < 0) {
      return "-" + num_to_s(-num);
    }
    let [a2, b2] = num.toString().split(".");
    if (!b2) {
      if (a2.includes("e")) {
        const [a1, a22] = a2.split("e");
        a2 = a1;
        b2 = "0e" + a22;
      } else {
        return int_to_s(num);
      }
    }
    let c2;
    if (b2) {
      [b2, c2] = b2.split("e");
    }
    a2 = int_str_to_s(a2);
    b2 = reverse(b2);
    b2 = int_str_to_s(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += ".";
      switch (c2[0]) {
        case "+":
          c2 = c2.slice(1);
          break;
        case "-":
          str += "-";
          c2 = c2.slice(1);
          break;
      }
      c2 = int_str_to_s(c2);
      str += c2;
    }
    return str;
  }
  function int_str_to_s(int_str) {
    const num = +int_str;
    if (num.toString() === int_str && num + 1 !== num && num - 1 !== num) {
      return int_to_s(num);
    }
    return ":" + big_int_to_s(BigInt(int_str));
  }
  function s_to_int_str(s2) {
    if (s2[0] === ":") {
      return s_to_big_int(s2.substring(1)).toString();
    }
    return s_to_int(s2).toString();
  }
  function s_to_num(s2) {
    if (s2[0] === "-") {
      return -s_to_num(s2.substr(1));
    }
    let [a2, b2, c2] = s2.split(".");
    if (!b2) {
      return s_to_int(a2);
    }
    a2 = s_to_int_str(a2);
    b2 = s_to_int_str(b2);
    b2 = reverse(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += "e";
      let neg = false;
      if (c2[0] === "-") {
        neg = true;
        c2 = c2.slice(1);
      }
      c2 = s_to_int_str(c2);
      str += neg ? -c2 : +c2;
    }
    return +str;
  }
  return number$2;
}
var hasRequiredEncode$2;
function requireEncode$2() {
  if (hasRequiredEncode$2) return encode$1$1;
  hasRequiredEncode$2 = 1;
  Object.defineProperty(encode$1$1, "__esModule", { value: true });
  encode$1$1.encodeNum = encodeNum;
  encode$1$1.decodeNum = decodeNum;
  encode$1$1.decodeKey = decodeKey;
  encode$1$1.encodeBool = encodeBool;
  encode$1$1.decodeBool = decodeBool;
  encode$1$1.encodeStr = encodeStr;
  encode$1$1.decodeStr = decodeStr;
  const number_1 = requireNumber$2();
  function encodeNum(num) {
    if (num === Infinity) {
      return "N|+";
    }
    if (num === -Infinity) {
      return "N|-";
    }
    if (Number.isNaN(num)) {
      return "N|0";
    }
    return "n|" + (0, number_1.num_to_s)(num);
  }
  function decodeNum(s2) {
    if (s2.length === 3 && s2[0] === "N" && s2[1] === "|") {
      switch (s2[2]) {
        case "+":
          return Infinity;
        case "-":
          return -Infinity;
        case "0":
          return NaN;
      }
    }
    return (0, number_1.s_to_num)(s2.slice(2));
  }
  function decodeKey(key) {
    return typeof key === "number" ? key : (0, number_1.s_to_int)(key);
  }
  function encodeBool(b2) {
    return b2 ? "b|T" : "b|F";
  }
  function decodeBool(s2) {
    if (s2.length === 3 && s2[0] === "b" && s2[1] === "|") {
      switch (s2[2]) {
        case "T":
          return true;
        case "F":
          return false;
      }
    }
    return !!s2;
  }
  function encodeStr(str) {
    if (str[1] === "|") {
      switch (str[0]) {
        case "b":
        case "o":
        case "n":
        case "a":
        case "s":
          return "s|" + str;
      }
    }
    return str;
  }
  function decodeStr(s2) {
    return s2[0] === "s" && s2[1] === "|" ? s2.substr(2) : s2;
  }
  return encode$1$1;
}
var memory$2 = {};
var config$1$1 = {};
var hasRequiredConfig$2;
function requireConfig$2() {
  if (hasRequiredConfig$2) return config$1$1;
  hasRequiredConfig$2 = 1;
  Object.defineProperty(config$1$1, "__esModule", { value: true });
  config$1$1.config = void 0;
  config$1$1.config = {
    // default will not sort the object key
    sort_key: false,
    // default will convert into null silently like JSON.stringify
    preserve_nan: false,
    error_on_nan: false,
    preserve_infinite: false,
    error_on_infinite: false
  };
  return config$1$1;
}
var hasRequiredMemory$2;
function requireMemory$2() {
  if (hasRequiredMemory$2) return memory$2;
  hasRequiredMemory$2 = 1;
  Object.defineProperty(memory$2, "__esModule", { value: true });
  memory$2.memToValues = memToValues;
  memory$2.makeInMemoryStore = makeInMemoryStore;
  memory$2.makeInMemoryCache = makeInMemoryCache;
  memory$2.makeInMemoryMemory = makeInMemoryMemory;
  memory$2.addValue = addValue;
  const config_1 = requireConfig$2();
  const debug_1 = requireDebug$2();
  const encode_1 = requireEncode$2();
  const number_1 = requireNumber$2();
  function memToValues(mem) {
    return mem.store.toArray();
  }
  function makeInMemoryStore() {
    const mem = [];
    return {
      forEach(cb2) {
        for (let i2 = 0; i2 < mem.length; i2++) {
          if (cb2(mem[i2]) === "break") {
            return;
          }
        }
      },
      add(value) {
        mem.push(value);
      },
      toArray() {
        return mem;
      }
    };
  }
  function makeInMemoryCache() {
    const valueMem = /* @__PURE__ */ Object.create(null);
    const schemaMem = /* @__PURE__ */ Object.create(null);
    return {
      getValue(key) {
        return valueMem[key];
      },
      getSchema(key) {
        return schemaMem[key];
      },
      forEachValue(cb2) {
        for (const [key, value] of Object.entries(valueMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      forEachSchema(cb2) {
        for (const [key, value] of Object.entries(schemaMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      setValue(key, value) {
        valueMem[key] = value;
      },
      setSchema(key, value) {
        schemaMem[key] = value;
      },
      hasValue(key) {
        return key in valueMem;
      },
      hasSchema(key) {
        return key in schemaMem;
      }
    };
  }
  function makeInMemoryMemory() {
    return {
      store: makeInMemoryStore(),
      cache: makeInMemoryCache(),
      keyCount: 0
    };
  }
  function getValueKey(mem, value) {
    if (mem.cache.hasValue(value)) {
      return mem.cache.getValue(value);
    }
    const id2 = mem.keyCount++;
    const key = (0, number_1.num_to_s)(id2);
    mem.store.add(value);
    mem.cache.setValue(value, key);
    return key;
  }
  function getSchema(mem, keys2) {
    if (config_1.config.sort_key) {
      keys2.sort();
    }
    const schema = keys2.join(",");
    if (mem.cache.hasSchema(schema)) {
      return mem.cache.getSchema(schema);
    }
    const key_id = addValue(mem, keys2, void 0);
    mem.cache.setSchema(schema, key_id);
    return key_id;
  }
  function addValue(mem, o2, parent) {
    if (o2 === null) {
      return "";
    }
    switch (typeof o2) {
      case "undefined":
        if (Array.isArray(parent)) {
          return addValue(mem, null, parent);
        }
        break;
      case "object":
        if (o2 === null) {
          return getValueKey(mem, null);
        }
        if (Array.isArray(o2)) {
          let acc = "a";
          for (let i2 = 0; i2 < o2.length; i2++) {
            const v2 = o2[i2];
            const key = v2 === null ? "_" : addValue(mem, v2, o2);
            acc += "|" + key;
          }
          if (acc === "a") {
            acc = "a|";
          }
          return getValueKey(mem, acc);
        } else {
          const keys2 = Object.keys(o2);
          if (keys2.length === 0) {
            return getValueKey(mem, "o|");
          }
          let acc = "o";
          const key_id = getSchema(mem, keys2);
          acc += "|" + key_id;
          for (const key of keys2) {
            const value = o2[key];
            const v2 = addValue(mem, value, o2);
            acc += "|" + v2;
          }
          return getValueKey(mem, acc);
        }
      case "boolean":
        return getValueKey(mem, (0, encode_1.encodeBool)(o2));
      case "number":
        if (Number.isNaN(o2)) {
          if (config_1.config.preserve_nan) {
            return getValueKey(mem, "N|0");
          }
          if (config_1.config.error_on_nan) {
            (0, debug_1.throwUnsupportedData)("[number NaN]");
          }
          return "";
        }
        if (Number.POSITIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|+");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number Infinity]");
          }
          return "";
        }
        if (Number.NEGATIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|-");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number -Infinity]");
          }
          return "";
        }
        return getValueKey(mem, (0, encode_1.encodeNum)(o2));
      case "string":
        return getValueKey(mem, (0, encode_1.encodeStr)(o2));
    }
    return (0, debug_1.throwUnknownDataType)(o2);
  }
  return memory$2;
}
var hasRequiredCore$2;
function requireCore$2() {
  if (hasRequiredCore$2) return core$2;
  hasRequiredCore$2 = 1;
  Object.defineProperty(core$2, "__esModule", { value: true });
  core$2.compress = compress;
  core$2.decode = decode;
  core$2.decompress = decompress;
  const debug_1 = requireDebug$2();
  const encode_1 = requireEncode$2();
  const memory_1 = requireMemory$2();
  const number_1 = requireNumber$2();
  function compress(o2) {
    const mem = (0, memory_1.makeInMemoryMemory)();
    const root2 = (0, memory_1.addValue)(mem, o2, void 0);
    const values2 = (0, memory_1.memToValues)(mem);
    return [values2, root2];
  }
  function decodeObject(values2, s2) {
    if (s2 === "o|") {
      return {};
    }
    const o2 = {};
    const vs = s2.split("|");
    const key_id = vs[1];
    let keys2 = decode(values2, key_id);
    const n2 = vs.length;
    if (n2 - 2 === 1 && !Array.isArray(keys2)) {
      keys2 = [keys2];
    }
    for (let i2 = 2; i2 < n2; i2++) {
      const k2 = keys2[i2 - 2];
      let v2 = vs[i2];
      v2 = decode(values2, v2);
      o2[k2] = v2;
    }
    return o2;
  }
  function decodeArray2(values2, s2) {
    if (s2 === "a|") {
      return [];
    }
    const vs = s2.split("|");
    const n2 = vs.length - 1;
    const xs = new Array(n2);
    for (let i2 = 0; i2 < n2; i2++) {
      let v2 = vs[i2 + 1];
      v2 = decode(values2, v2);
      xs[i2] = v2;
    }
    return xs;
  }
  function decode(values2, key) {
    if (key === "" || key === "_") {
      return null;
    }
    const id2 = (0, encode_1.decodeKey)(key);
    const v2 = values2[id2];
    if (v2 === null) {
      return v2;
    }
    switch (typeof v2) {
      case "undefined":
        return v2;
      case "number":
        return v2;
      case "string":
        if (v2[1] === "|") {
          switch (v2[0]) {
            case "b": {
              switch (v2[2]) {
                case "T":
                  return true;
                case "F":
                  return false;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "o":
              return decodeObject(values2, v2);
            case "n":
              return (0, number_1.s_to_num)(v2.slice(2));
            case "N": {
              switch (v2[2]) {
                case "+":
                  return Infinity;
                case "-":
                  return -Infinity;
                case "0":
                  return NaN;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "a":
              return decodeArray2(values2, v2);
          }
        }
        return (0, encode_1.decodeStr)(v2);
    }
    return (0, debug_1.throwUnknownDataType)(v2);
  }
  function decompress(c2) {
    const [values2, root2] = c2;
    return decode(values2, root2);
  }
  return core$2;
}
var helpers$2 = {};
var hasRequiredHelpers$2;
function requireHelpers$2() {
  if (hasRequiredHelpers$2) return helpers$2;
  hasRequiredHelpers$2 = 1;
  Object.defineProperty(helpers$2, "__esModule", { value: true });
  helpers$2.trimUndefined = trimUndefined;
  helpers$2.trimUndefinedRecursively = trimUndefinedRecursively;
  function trimUndefined(object2) {
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      }
    }
  }
  function trimUndefinedRecursively(object2) {
    trimUndefinedRecursivelyLoop(object2, /* @__PURE__ */ new Set());
  }
  function trimUndefinedRecursivelyLoop(object2, tracks) {
    tracks.add(object2);
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      } else {
        const value = object2[key];
        if (value && typeof value === "object" && !tracks.has(value)) {
          trimUndefinedRecursivelyLoop(value, tracks);
        }
      }
    }
  }
  return helpers$2;
}
var hasRequiredDist$2;
function requireDist$2() {
  if (hasRequiredDist$2) return dist$2;
  hasRequiredDist$2 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.config = exports2.trimUndefinedRecursively = exports2.trimUndefined = exports2.addValue = exports2.decode = exports2.decompress = exports2.compress = void 0;
    var core_1 = requireCore$2();
    Object.defineProperty(exports2, "compress", { enumerable: true, get: function() {
      return core_1.compress;
    } });
    Object.defineProperty(exports2, "decompress", { enumerable: true, get: function() {
      return core_1.decompress;
    } });
    var core_2 = requireCore$2();
    Object.defineProperty(exports2, "decode", { enumerable: true, get: function() {
      return core_2.decode;
    } });
    var memory_1 = requireMemory$2();
    Object.defineProperty(exports2, "addValue", { enumerable: true, get: function() {
      return memory_1.addValue;
    } });
    var helpers_1 = requireHelpers$2();
    Object.defineProperty(exports2, "trimUndefined", { enumerable: true, get: function() {
      return helpers_1.trimUndefined;
    } });
    Object.defineProperty(exports2, "trimUndefinedRecursively", { enumerable: true, get: function() {
      return helpers_1.trimUndefinedRecursively;
    } });
    var config_1 = requireConfig$2();
    Object.defineProperty(exports2, "config", { enumerable: true, get: function() {
      return config_1.config;
    } });
  })(dist$2);
  return dist$2;
}
var distExports$2 = requireDist$2();
const doenetSchema$1 = distExports$2.decompress([["elements", "aliasedElements", "a|0|1", "name", "children", "childBuckets", "abstractAncestors", "attributes", "properties", "top", "acceptsStringChildren", "takesIndex", "docsSlug", "summary", "layoutCategory", "a|3|4|5|6|7|8|9|A|B|C|D|E", "title", "rightHandSide", "xLabel", "yLabel", "br", "m", "me", "men", "md", "mdn", "mrow", "not", "and", "or", "xor", "iff", "implies", "isInteger", "isNumber", "isBetween", "sum", "product", "clampNumber", "wrapNumberPeriodic", "round", "setSmallToZero", "convertSetToList", "ceil", "floor", "abs", "sign", "mean", "median", "variance", "standardDeviation", "count", "min", "max", "mod", "gcd", "lcm", "extractMath", "clampFunction", "wrapFunctionPeriodic", "derivative", "extractMathOperator", "em", "alert", "q", "sq", "term", "c", "tag", "tage", "tagc", "attr", "ndash", "mdash", "nbsp", "ellipsis", "lq", "rq", "lsq", "rsq", "odeSystem", "equilibriumPoint", "equilibriumLine", "atom", "ion", "ionicCompound", "electronConfiguration", "span", "displayDoenetML", "matrixInput", "fractionInput", "text", "textList", "boolean", "booleanList", "math", "mathList", "tupleList", "numberList", "collect", "ref", "point", "coords", "line", "bezierControls", "vector", "angle", "answer", "mathInput", "textInput", "booleanInput", "choiceInput", "choice", "number", "integer", "function", "piecewiseFunction", "interval", "sequence", "cell", "repeat", "repeatForSequence", "intersection", "conditionalContent", "asList", "selectFromSequence", "select", "group", "evaluate", "selectRandomNumbers", "sampleRandomNumbers", "selectPrimeNumbers", "samplePrimeNumbers", "substitute", "periodicSet", "intComma", "pluralize", "lorem", "updateValue", "callAction", "triggerSet", "functionIterates", "module", "footnote", "endpoint", "sort", "shuffle", "solveEquations", "subsetOfReals", "split", "bestFitLine", "hasSameFactoring", "label", "matchesPattern", "matrix", "latex", "pointList", "intervalList", "vectorList", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y", "11111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222212221222221112111121222112211111222", "_textOrInline", "_inline", "_base", "a|2b|2c|2d", "description", "type", "a|3|2f|2g", "The name used to reference this component from elsewhere in the document.", "o|2h|3|2i|1T", "defaultValue", "values", "a|3|2f|2k|2l|2g", "hide", "Whether to hide this component from the rendered output.", "b|F", "true", "false", "a|2q|2r", "o|2m|2n|2o|2p|2s|1V", "disabled", "Whether this component is disabled and cannot be interacted with.", "o|2m|2u|2v|2p|2s|1V", "fixed", "Whether this component's value is fixed and cannot be modified.", "o|2m|2x|2y|2p|2s|1V", "fixLocation", "Whether this component's location is fixed (preventing it from being moved while still allowing other modifications).", "o|2m|30|31|2p|2s|1V", "a|3|2f|2k|2g", "styleNumber", "The style number used to select this component's visual styling from the available style definitions.", "n|1", "o|33|34|35|36|1q", "isResponse", "Whether this component is treated as a response for the purposes of assessment.", "o|2m|38|39|2p|2s|1V", "extend", "Extend another component by reference, inheriting its children and attributes. Enter a reference as `$name`.", "reference", "o|2h|3B|3C|3D", "copy", "Create an independent copy of another component by reference. Enter a references a `$name`.", "o|2h|3F|3G|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H", "isArray", "fromAttribute", "a|3|2g|3J|2f|3K", "b|T", "o|3L|2n|1V|2p|2o|3M", "o|3L|34|1q|2p|35|3M", "o|3L|38|1V|2p|39|3M", "a|3|2g|3J|2f", "hidden", "Whether this component is hidden from the rendered output.", "o|3Q|3R|1V|2p|3S", "o|3Q|2u|1V|2p|2v", "o|3Q|2x|1V|2p|2y", "o|3Q|30|1V|2p|31", "doenetML", "The DoenetML source code that produced this component.", "o|3Q|3X|1T|2p|3Y", "value", "The combined content of this component's children.", "o|3Q|3a|G|2p|3b", "The combined content of this component's children, as a plain text string.", "o|3Q|1T|1T|2p|3d", "a|3N|3O|3P|3T|3U|3V|3W|3Z|3c|3e", "Creates a title within a document, section, or other block component", "inline", "o|F|G|2Z|2a|2e|3I|3f|3M|3M|2p|G|3g|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1222211111111111111111111112222222221222202222122222222212222122222122221212222", "a|2c|2d", "highlighted", "autocompleteValues", "a|3|2f|3m|2k|2l|3n|2g", "format", "Input format.", "a|1T|2V", "a|3a|2f", "Plain-text math notation (e.g., `x^2 + 1`).", "o|3s|1T|3t", "LaTeX-formatted math (e.g., `x^{2} + 1`).", "o|3s|2V|3v", "a|3u|3w", "keyword", "o|3o|3p|3q|3M|1T|3r|3x|3y", "simplify", "Level of simplification applied to the expression.", "none", "full", "numbers", "numbersPreserveOrder", "normalizeOrder", "a|42|43|44|45|46|2q|2r", "No simplification is applied.", "o|3s|42|48", "Fully simplify the expression.", "o|3s|43|4A", "Simplify numeric subexpressions only, leaving symbolic structure intact.", "o|3s|44|4C", "Like `numbers`, but does not reorder commutative operands.", "o|3s|45|4E", "Reorder commutative operands into a canonical form without simplifying values.", "o|3s|46|4G", "a|49|4B|4D|4F|4H", "o|3o|40|41|3M|42|47|4I|3y", "expand", "Whether to expand the expression.", "o|2m|4K|4L|2p|2s|1V", "groupName", "a|3|2f|4N|3m|2k|2g", "displayDigits", "Number of significant digits to display when rendering this number.", "number-display", "n|3", "o|4O|4P|4Q|4R|3M|4S|1q", "a|3|2f|4N|2k|2g", "displayDecimals", "Number of decimal places to display when rendering this number.", "n|2", "o|4U|4V|4W|4R|4X|1q", "displaySmallAsZero", "Threshold below which numbers are displayed as zero.", "n|1.0.-E", "o|4U|4Z|4a|4R|4b|1p", "a|3|2f|4N|2k|2l|2g", "padZeros", "Whether to pad displayed numbers with trailing zeros to fill the requested digits/decimals.", "o|4d|4e|4f|4R|2p|2s|1V", "avoidScientificNotation", "Whether to render numbers in full decimal form rather than scientific notation.", "o|4d|4h|4i|4R|2p|2s|1V", "renderMode", 'How the math is rendered (e.g. "inline", "display").', "o|33|4k|4l|3h|1T", "unordered", "Whether tuple- or list-like math expressions should be treated as unordered for comparison.", "o|2m|4n|4o|2p|2s|1V", "createVectors", "Whether tuple-like expressions are interpreted as vectors.", "o|2m|4q|4r|2p|2s|1V", "createIntervals", "Whether range expressions are interpreted as intervals.", "o|2m|4t|4u|2p|2s|1V", "functionSymbols", "Symbols treated as function names when parsing.", "f", "g", "a|4y|4z", "o|33|4w|4x|50|1U", "referencesAreFunctionSymbols", "References whose names should be treated as function symbols when parsing.", "a|", "o|33|52|53|54|3D", "splitSymbols", "Whether multi-character symbols are split into a product of variables.", "o|2m|56|57|3M|2s|1V", "parseScientificNotation", "Whether to parse expressions like 1e3 as scientific notation.", "o|2m|59|5A|2p|2s|1V", "displayBlanks", "Whether blanks (placeholders) are visibly rendered.", "o|2m|5C|5D|3M|2s|1V", "assumptions", "Assumptions applied when simplifying or comparing.", "a|2g|2V", "＿", "o|5H|1X|5I", "o|33|5F|5G|5J|1X", "draggable", "Whether the math component can be dragged on a graph.", "o|2m|5L|5M|3M|2s|1V", "layer", "Z-order layer index when shown on a graph.", "n|0", "o|33|5O|5P|5Q|1p", "anchor", "Coordinates of the anchor point used to position this component on a graph.", "positioning", "\\left( 0, 0 \\right)", "o|5H|1X|5V", "o|4U|5S|5T|5U|5W|1d", "a|3|2f|4N|2k|2l|3n|2g", "positionFromAnchor", "Where this component sits relative to its anchor point.", "center", "upperRight", "upperLeft", "lowerRight", "lowerLeft", "bottom", "left", "right", "a|5c|5d|5e|5f|9|5g|5h|5i|5b", "Place the component above and to the right of the anchor point.", "o|3s|5c|5k", "Place the component above and to the left of the anchor point.", "o|3s|5d|5m", "Place the component below and to the right of the anchor point.", "o|3s|5e|5o", "Place the component below and to the left of the anchor point.", "o|3s|5f|5q", "Place the component directly above the anchor point.", "o|3s|9|5s", "Place the component directly below the anchor point.", "o|3s|5g|5u", "Place the component directly to the left of the anchor point.", "o|3s|5h|5w", "Place the component directly to the right of the anchor point.", "o|3s|5i|5y", "Center the component on the anchor point.", "o|3s|5b|60", "a|5l|5n|5p|5r|5t|5v|5x|5z|61", "o|5Y|5Z|5a|5U|5b|5j|62|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "a|3|2g|3J|2f|3K|3m", "o|65|3p|1T|2p|3q|3M|3M", "o|65|40|1T|2p|41|3M|3M", "o|3L|4K|1V|2p|4L|3M", "o|3L|4k|1T|2p|4l|3M", "o|3L|4q|1V|2p|4r|3M", "o|3L|4t|1V|2p|4u|3M", "o|3L|4w|1U|2p|4x|3M", "o|3L|56|1V|2p|57|3M", "o|3L|59|1V|2p|5A|3M", "o|3L|5C|1V|2p|5D|3M", "o|3L|5F|1X|2p|5G|3M", "o|3L|5L|1V|2p|5M|3M", "o|3L|5O|1p|2p|5P|3M", "a|3|2g|3J|2f|3K|4N", "o|6J|5Z|1T|2p|5a|3M|5U", "textColor", "Human-readable name for this component's text color, derived from the active style and theme.", "o|3Q|6L|1T|2p|6M", "backgroundColor", "Human-readable name for this component's background color, derived from the active style and theme.", "o|3Q|6O|1T|2p|6P", "textStyleDescription", "Human-readable description of this component's text styling (color and any background color).", "o|3Q|6R|1T|2p|6S", "a|3|2g|3J|2f|4N", "The coordinates where this component is anchored on the graph.", "o|6U|5S|1d|2p|6V|5U", "o|3Q|4P|1q|2p|4Q", "o|3Q|4V|1q|2p|4W", "o|3Q|4Z|1p|2p|4a", "o|3Q|4e|1V|2p|4f", "o|3Q|4h|1V|2p|4i", "Whether list-like values are treated as unordered.", "o|3Q|4n|1V|2p|6c", "The math expression value.", "o|3Q|3a|H|2p|6e", "The numeric value of the expression (NaN if not a number).", "o|3Q|1p|1p|2p|6g", "Whether the expression evaluates to a finite number.", "o|3Q|Y|1V|2p|6i", "isNumeric", "Whether the expression evaluates to any number (including infinities).", "o|3Q|6k|1V|2p|6l", "The expression rendered as a LaTeX string.", "o|3Q|2V|2V|2p|6n", "The expression rendered as a plain text string.", "o|3Q|1T|1T|2p|6p", "numDimensions", "The number of dimensions if the math expression is interpreted as a vector or matrix.", "o|3Q|6r|1q|2p|6s", "indexedArrayDescription", "a|3|2g|3J|2f|6r|6u", "The math expression interpreted as a vector (its components).", "a|3J|2g", "o|6x|2p|1h", "a|6y", "o|6v|1h|1X|3M|6w|36|6z", "list", "The math expression interpreted as a list (its elements).", "a|3J|2g|6r", "o|73|3M|1X|36", "a|74", "o|6v|71|1X|3M|72|36|75", "matrixSize", "The size of the math expression as a matrix, as a [numRows, numColumns] list.", "o|3Q|77|1a|2p|78", "numRows", "The number of rows when the math expression is interpreted as a matrix.", "o|3Q|7A|1q|2p|7B", "numColumns", "The number of columns when the math expression is interpreted as a matrix.", "o|3Q|7D|1q|2p|7E", "The math expression interpreted as a matrix (its entries by row and column).", "o|6x|2p|2U", "a|7H|7H", "o|6v|2U|1X|3M|7G|4X|7I", "rows", "The matrix's entries grouped by row.", "o|6v|7K|1X|3M|7L|4X|7I", "columns", "The matrix's entries grouped by column.", "o|6v|7N|1X|3M|7O|4X|7I", "x", "The first component of the math expression when interpreted as a vector.", "o|3Q|7Q|1X|2p|7R", "y", "The second component of the math expression when interpreted as a vector.", "o|3Q|7T|1X|2p|7U", "z", "The third component of the math expression when interpreted as a vector.", "o|3Q|7W|1X|2p|7X", "numListItems", "The number of items when the math expression is interpreted as a list.", "o|3Q|7Z|1q|2p|7a", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|6f|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A right-hand-side expression of an equation in an ODE system", "o|F|H|3j|3k|3l|64|7c|3M|3M|2p|H|7d|3h", "for", "Reference to the component this label is for (e.g., an input).", "o|2h|7f|7g|3D", "forObject", "Reference to the graphical object this label is attached to.", "o|2h|7i|7j|3D", "Whether the label can be dragged on a graph.", "o|2m|5L|7l|3M|2s|1V", "maskLabel", "Whether to give the label an opaque background so it stays legible when it overlaps an axis, grid line, or another object.", "o|2m|7n|7o|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|7h|7k|7m|5R|7p|5X|63", "o|3L|5L|1V|2p|7l|3M", "o|3L|7n|1V|2p|7o|3M", "hasLatex", "Whether the label contains LaTeX content.", "o|3Q|7t|1V|2p|7u", "The label's text content.", "o|3Q|1T|1T|2p|7w", "The label's content as a LaTeX string.", "o|3Q|2V|2V|2p|7y", "The label's content as a label-typed value.", "o|3Q|3a|I|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|81", "A label for the x-axis of a graph", "o|F|I|2Z|2a|3l|7q|82|3M|3M|2p|I|83|3h", "o|3Q|3a|J|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|85", "A label for the y-axis of a graph", "o|F|J|2Z|2a|3l|7q|86|3M|3M|2p|J|87|3h", "statement", "introduction", "conclusion", "hr", "section", "subsection", "subsubsection", "paragraphs", "aside", "objectives", "problem", "exercise", "question", "activity", "example", "definition", "note", "theorem", "part", "task", "proof", "problems", "exercises", "ol", "ul", "cobwebPolyline", "equilibriumCurve", "orbitalDiagram", "orbitalDiagramInput", "sideBySide", "sbsGroup", "stack", "div", "pre", "paginator", "paginatorControls", "solution", "givenAnswer", "document", "p", "lineSegment", "ray", "polyline", "polygon", "triangle", "rectangle", "regularPolygon", "circle", "parabola", "curve", "award", "graph", "annotations", "annotation", "slider", "spreadsheet", "row", "column", "cellBlock", "tabular", "table", "figure", "pegboard", "variantControl", "animateFromSequence", "image", "video", "hint", "feedback", "moduleAttributes", "setup", "caption", "subsetOfRealsInput", "regionBetweenCurveXAxis", "regionBetweenCurves", "regionHalfPlane", "codeEditor", "legend", "eigenDecomposition", "blockQuote", "stickyGroup", "pretzel", "cascade", "a|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|1z|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_block", "a|9W|2d", "aggregateScores", "Whether to aggregate scores of scored descendants into a section credit-achieved value.", "scoring", "o|4d|9Y|9Z|9a|2p|2s|1V", "weight", "Relative weight of this section when aggregated by an enclosing scored section.", "o|4U|9c|9d|9a|36|1p", "sectionWideCheckWork", "Whether to show a single section-wide check-work button instead of per-answer buttons.", "o|4d|9f|9g|9a|2p|2s|1V", "maxNumAttempts", "Maximum number of times the section-wide check-work button can be submitted. Once reached, all enclosed answers are disabled.", "Infinity", "o|4U|9i|9j|9a|9k|1q", "showCorrectness", "Whether to display correctness indicators for the answers it contains.", "o|4d|9m|9n|9a|3M|2s|1V", "colorCorrectness", "Whether to color-code the answers it contains based on correctness.", "o|4d|9p|9q|9a|3M|2s|1V", "colorAnswersSeparately", "When section-wide check work is enabled, color each answer based on its own correctness rather than the section's overall credit.", "o|4d|9s|9t|9a|2p|2s|1V", "submitLabel", "Label for the section-wide submit button when correctness is shown.", "Check Work", "o|4U|9v|9w|9a|9x|1T", "submitLabelNoCorrectness", "Label for the section-wide submit button when correctness is not shown.", "Submit Response", "o|4U|9z|A0|9a|A1|1T", "displayDigitsForCreditAchieved", "Number of significant digits to display for the credit achieved value.", "o|4U|A3|A4|9a|4S|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "o|6J|9c|1p|2p|9d|3M|9a", "o|6J|9f|1V|2p|9g|3M|9a", "o|6J|9i|1q|2p|9j|3M|9a", "o|6J|9v|1T|2p|9w|3M|9a", "o|6J|9z|1T|2p|A0|3M|9a", "o|6J|A3|1q|2p|A4|3M|9a", "numSubmissions", "Number of times the section-wide check-work button has been submitted.", "o|3Q|AD|1q|2p|AE", "numAttemptsLeft", "Remaining number of section-wide submissions before the maximum is reached.", "o|3Q|AG|1q|2p|AH", "Whether scores of scored descendants are aggregated into this section's credit value.", "o|3Q|9Y|1V|2p|AJ", "creditAchieved", "Aggregate credit achieved (between 0 and 1) for scored descendants of this section.", "o|3Q|AL|1p|2p|AM", "percentCreditAchieved", "Aggregate credit achieved as a percentage (between 0 and 100).", "o|3Q|AO|1p|2p|AP", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ", "A block container for the statement of a problem, theorem, or similar", "block", "o|F|89|9U|9V|9X|A6|AR|3M|3M|2p|89|AS|AT", "A block container for the introduction of a section", "o|F|8A|9U|9V|9X|A6|AR|3M|3M|2p|8A|AV|AT", "A block container for the conclusion of a section", "o|F|8B|9U|9V|9X|A6|AR|3M|3M|2p|8B|AX|AT", "", "a|3N|3O|3P|3T|3U|3V|3W|3Z", "A line break", "o|F|K|54|AZ|3l|3I|Aa|3M|2p|2p|K|Ab|3h", "A horizontal rule used to separate content", "o|F|8C|54|AZ|9X|3I|Aa|3M|2p|2p|8C|Ad|AT", "cascadeMessage", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|8W|8X", "1111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222221222122222111211112122211221111122200", "The paragraph's text content.", "o|3Q|1T|1T|2p|Ai", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|Aj", "Placeholder shown inside a `<cascade>` in place of a not-yet-revealed entry", "o|F|Af|Ag|Ah|9X|A6|Ak|2p|3M|2p|Af|Al|AT", "else", "a|2d", "a|3|2f|2l|2g", "condition", "Boolean expression; this case is selected when the condition is true.", "o|Ap|Aq|Ar|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|As", "conditionSatisfied", "Whether this case's condition is currently satisfied.", "o|3Q|Au|1V|2p|Av", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Aw", "Default branch within a `<conditionalContent>`; matched when no `<case>` condition is true", "other", "o|F|An|9U|9V|Ao|At|Ax|2p|3M|2p|An|Ay|Az", "Whether the math display can be dragged on a graph.", "o|2m|5L|B1|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63", "o|3L|5L|1V|2p|B1|3M", "The math content rendered as a LaTeX string.", "o|3Q|2V|2V|2p|B5", "The math content rendered as a plain text string.", "o|3Q|1T|1T|2p|B7", "The math content as a math expression.", "o|3Q|1X|1X|2p|B9", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA", "Inline math rendered with LaTeX", "o|F|L|2Z|2a|3l|B3|BB|3M|3M|2p|L|BC|3h", "Display math rendered with LaTeX", "o|F|M|2Z|2a|3l|B3|BB|3M|3M|2p|M|BE|3h", "equationTag", "The equation number (when numbered).", "o|3Q|BG|1T|2p|BH", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA|BI", "Numbered display math rendered with LaTeX", "o|F|N|2Z|2a|3l|B3|BJ|3M|3M|2p|N|BK|3h", "a|Q|1z", "02", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8", "Display math with multiple aligned rows", "o|F|O|BM|BN|3l|B3|BO|3M|2p|2p|O|BP|3h", "Numbered display math with multiple aligned rows", "o|F|P|BM|BN|3l|B3|BO|3M|2p|2p|P|BR|3h", "Whether to attach an equation number to this row.", "o|Ap|1p|BT|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63|BU", "A row of math within an aligned display", "o|F|Q|2Z|2a|3l|BV|BJ|3M|3M|2p|Q|BW|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "1222211111111111111111111112221222221220202222122222012212222122222111221211222221111111110212120", "_booleanOperatorOneInput", "a|Ba|2c|2d", "symbolicEquality", "Whether children compared via this boolean use symbolic equality.", "o|2m|Bc|Bd|2p|2s|1V", "expandOnCompare", "Whether to expand math expressions before comparing.", "o|2m|Bf|Bg|2p|2s|1V", "a|3|2f|2k|2l|3n|2g", "simplifyOnCompare", "Level of simplification applied to math expressions before comparing.", "No simplification is applied before comparing.", "o|3s|42|Bl", "Fully simplify both expressions before comparing.", "o|3s|43|Bn", "a|Bm|Bo|4D|4F|4H", "o|Bi|Bj|Bk|42|47|Bp|3y", "unorderedCompare", "Whether order is ignored when comparing list-like values.", "o|2m|Br|Bs|2p|2s|1V", "matchByExactPositions", "Whether to match list values by exact position rather than by content.", "o|2m|Bu|Bv|2p|2s|1V", "allowedErrorInNumbers", "Maximum allowed numeric error when comparing numbers.", "o|33|Bx|By|5Q|1p", "includeErrorInNumberExponents", "Whether the allowed numeric error also applies to numbers in exponents.", "o|2m|C0|C1|2p|2s|1V", "allowedErrorIsAbsolute", "Whether allowedErrorInNumbers is interpreted as an absolute (rather than relative) tolerance.", "o|2m|C3|C4|2p|2s|1V", "numSignErrorsMatched", "Maximum number of sign errors that still count as a match.", "o|33|C6|C7|5Q|1p", "numPeriodicSetMatchesRequired", "Number of consecutive elements of a periodic set required to count as a match.", "o|33|C9|CA|4S|1q", "caseInsensitiveMatch", "Whether text comparisons ignore letter case.", "o|2m|CC|CD|2p|2s|1V", "matchBlanks", "Whether unfilled blanks in a math expression count as a match.", "o|2m|CF|CG|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH", "o|3L|Bc|1V|2p|Bd|3M", "o|3L|Bf|1V|2p|Bg|3M", "o|3L|Bj|1T|2p|Bk|3M", "o|3L|Br|1V|2p|Bs|3M", "o|3L|Bu|1V|2p|Bv|3M", "o|3L|Bx|1p|2p|By|3M", "o|3L|C0|1V|2p|C1|3M", "o|3L|C3|1V|2p|C4|3M", "o|3L|C6|1p|2p|C7|3M", "o|3L|C9|1q|2p|CA|3M", "o|3L|CC|1V|2p|CD|3M", "o|3L|CF|1V|2p|CG|3M", 'The boolean rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|CV", "The boolean result of applying this operator to its single boolean input.", "o|3Q|3a|1V|2p|CX", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|CW|CY", "Logical negation of a boolean value", "o|F|R|BY|BZ|Bb|CI|CZ|3M|3M|2p|R|Ca|3h", "a|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|1z|2R|2T", "111111111022211", "_booleanOperator", "a|Ce|2c|2d", "The boolean result of applying this operator to its child boolean values.", "o|3Q|3a|1V|2p|Cg", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Ch|CW", "Logical AND: true only when all child boolean values are true", "o|F|S|Cc|Cd|Cf|CI|Ci|3M|3M|2p|S|Cj|3h", "Logical OR: true when at least one child boolean value is true", "o|F|T|Cc|Cd|Cf|CI|Ci|3M|3M|2p|T|Cl|3h", "Logical exclusive OR: true when exactly one child boolean value is true", "o|F|U|Cc|Cd|Cf|CI|Ci|3M|3M|2p|U|Cn|3h", "IF and only iF: Logical bicondition (IFF): true when all child boolean values are the same", "o|F|V|Cc|Cd|Cf|CI|Ci|3M|3M|2p|V|Cp|3h", "Logical implication (binary): true when the first value is false or the second value is true", "o|F|W|Cc|Cd|Cf|CI|Ci|3M|3M|2p|W|Cr|3h", "_booleanOperatorOfMath", "a|Ct|2c|2d", "The boolean result of applying this operator to its child math values.", "o|3Q|3a|1V|2p|Cv", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Cw|CW", "True when the math child evaluates to an integer", "o|F|X|3j|3k|Cu|CI|Cx|3M|3M|2p|X|Cy|3h", "True when the math child evaluates to a finite number", "o|F|Y|3j|3k|Cu|CI|Cx|3M|3M|2p|Y|D0|3h", "limits", "Numeric limits used by the boolean operator (e.g. bounds for isBetween).", "o|33|D2|D3|54|1a", "strict", "Whether the comparison is strict (e.g. uses < instead of ≤).", "o|2m|D5|D6|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|D4|D7", "o|3L|D2|1a|2p|D3|3M", "o|3L|D5|1V|2p|D6|3M", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|D9|DA|3T|3U|3V|3W|3Z|Cw|CW", "True when a math value is between two given bounds", "o|F|Z|3j|3k|Cu|D8|DB|3M|3M|2p|Z|DC|3h", "1222211111111111111111111112222222221222202222122222012212222122222122221212222", "_mathOperator", "a|DF|2c|2d", "forceSymbolic", "Whether to force the operator to evaluate symbolically rather than numerically.", "o|2m|DH|DI|2p|2s|1V", "forceNumeric", "Whether to force the operator to evaluate numerically rather than symbolically.", "o|2m|DK|DL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM", "o|3L|DH|1V|2p|DI|3M", "o|3L|DK|1V|2p|DL|3M", "o|3Q|3a|a|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DQ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sum of the child math or number values", "o|F|a|3j|DE|DG|DN|DR|3M|3M|2p|a|DS|3h", "o|3Q|3a|b|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DU|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Product of the child math or number values", "o|F|b|3j|DE|DG|DN|DV|3M|3M|2p|b|DW|3h", "_mathOperatorOneInput", "a|DY|2c|2d", "lowerValue", "Lower bound used by the operator.", "o|33|Da|Db|5Q|1p", "upperValue", "Upper bound used by the operator.", "o|33|Dd|De|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dc|Df", "o|3L|Da|1p|2p|Db|3M", "o|3L|Dd|1p|2p|De|3M", "o|3Q|3a|c|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Clamps a number to a specified range", "o|F|c|3j|3k|DZ|Dg|Dk|3M|3M|2p|c|Dl|3h", "o|3Q|3a|d|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dn|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Wraps a number into a periodic range", "o|F|d|3j|3k|DZ|Dg|Do|3M|3M|2p|d|Dp|3h", "n|E", "o|4O|4P|4Q|4R|3M|Dr|1q", "numDecimals", "Number of decimal places (for round-style operators).", "o|33|Dt|Du|5Q|1p", "numDigits", "Number of significant digits (for round-style operators).", "o|33|Dw|Dx||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|Ds|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dv|Dy", "o|3L|Dt|1p|2p|Du|3M", "o|3L|Dw|1p|2p|Dx|3M", "o|3Q|3a|e|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|E0|E1|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|E2|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Rounds a number to a specified precision", "o|F|e|3j|3k|DZ|Dz|E3|3M|3M|2p|e|E4|3h", "threshold", "Threshold value used by the operator.", "o|33|E6|E7|4b|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|E8", "o|3L|E6|1p|2p|E7|3M", "o|3Q|3a|f|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|EA|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Replaces values with magnitude below a threshold with zero", "o|F|f|3j|3k|DZ|E9|EC|3M|3M|2p|f|ED|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|g|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|EG|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Converts a math set expression into a list expression", "o|F|g|3j|3k|DZ|EF|EH|3M|3M|2p|g|EI|3h", "o|3Q|3a|h|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EK|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Smallest integer ≥ the input value", "o|F|h|3j|3k|DZ|64|EL|3M|3M|2p|h|EM|3h", "o|3Q|3a|i|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EO|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Largest integer ≤ the input value", "o|F|i|3j|3k|DZ|64|EP|3M|3M|2p|i|EQ|3h", "o|3Q|3a|j|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ES|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Absolute value of an expression", "o|F|j|3j|3k|DZ|64|ET|3M|3M|2p|j|EU|3h", "o|3Q|3a|k|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EW|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sign of the input (-1, 0, or 1)", "o|F|k|3j|3k|DZ|64|EX|3M|3M|2p|k|EY|3h", "o|3Q|3a|l|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ea|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Arithmetic mean of the child math or number values", "o|F|l|3j|DE|DG|DN|Eb|3M|3M|2p|l|Ec|3h", "o|3Q|3a|m|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ee|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Median of the child math or number values", "o|F|m|3j|DE|DG|DN|Ef|3M|3M|2p|m|Eg|3h", "population", "Whether to use the population formula (rather than sample).", "o|2m|Ei|Ej|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM|Ek", "o|3L|Ei|1V|2p|Ej|3M", "o|3Q|3a|n|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|En|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Variance of the child math or number values", "o|F|n|3j|DE|DG|El|Eo|3M|3M|2p|n|Ep|3h", "o|3Q|3a|o|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Er|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Standard deviation of the child math or number values", "o|F|o|3j|DE|DG|El|Es|3M|3M|2p|o|Et|3h", "o|3Q|3a|p|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ev|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "The number of the child math or number values", "o|F|p|3j|DE|DG|DN|Ew|3M|3M|2p|p|Ex|3h", "o|3Q|3a|q|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ez|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Minimum of the child math or number values", "o|F|q|3j|DE|DG|DN|F0|3M|3M|2p|q|F1|3h", "o|3Q|3a|r|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F3|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Maximum of the child math or number values", "o|F|r|3j|DE|DG|DN|F4|3M|3M|2p|r|F5|3h", "o|3Q|3a|s|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F7|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Modulo (remainder) of two values", "o|F|s|3j|DE|DG|DN|F8|3M|3M|2p|s|F9|3h", "o|3Q|3a|t|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Greatest common divisor of integer inputs", "o|F|t|3j|DE|DG|DN|FC|3M|3M|2p|t|FD|3h", "o|3Q|3a|u|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FF|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Least common multiple of integer inputs", "o|F|u|3j|DE|DG|DN|FG|3M|3M|2p|u|FH|3h", "What kind of sub-expression to extract.", "operand", "functionArgument", "numOperands", "recursiveOperands", "a|FK|1r|FL|FM|FN", "Extract a single operand of the top-level operation.", "o|3s|FK|FP", "Extract the function being applied (for a function call).", "o|3s|1r|FR", "Extract an argument of the function being called.", "o|3s|FL|FT", "Extract the count of operands at the top level.", "o|3s|FM|FV", "Extract all operands found recursively through nested operations.", "o|3s|FN|FX", "a|FQ|FS|FU|FW|FY", "o|Bi|2g|FJ||FO|FZ|3y", "operandNumber", "1-based index of the operand to extract.", "o|33|Fb|Fc||1p", "argumentNumber", "1-based index of the argument to extract.", "o|33|Fe|Ff||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Fa|Fd|Fg", "o|3L|Fb|1p|2p|Fc|3M", "o|3L|Fe|1p|2p|Ff|3M", "o|3Q|3a|v|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Fi|Fj|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Fk|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Extracts a sub-expression from a math expression by name or index", "o|F|v|3j|3k|DZ|Fh|Fl|3M|3M|2p|v|Fm|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|2S", "1222211111111111111111111111112222221222202222122222220112222122222122221212222110", "_functionOperator", "a|Fq|2c|2d", "Level of simplification applied to the function's formula.", "Fully simplify the function's formula.", "o|3s|43|Ft", "a|49|Fu|4D|4F|4H", "o|Bi|40|Fs|43|47|Fv|3y", "Whether to expand the function's formula.", "o|2m|4K|Fx|2p|2s|1V", "xscale", "Scale factor used along the x-axis.", "o|33|Fz|G0|36|1p", "yscale", "Scale factor used along the y-axis.", "o|33|G2|G3|36|1p", "numInputs", "Number of input arguments the function accepts.", "o|2h|G5|G6|1q", "numOutputs", "Number of output values the function produces.", "o|33|G8|G9|36|1q", "domain", "Restriction of the function's domain to a list of intervals.", "o|2h|GB|GC|2X", "labelIsName", "Whether to use this component's name as its rendered label.", "labels", "o|4d|GE|GF|GG|2p|2s|1V", "applyStyleToLabel", "Whether to apply the function's style to its label.", "o|2m|GI|GJ|2p|2s|1V", "labelPosition", "Position of the function's label.", "a|5c|5d|5e|5f|9|5g|5h|5i", "Place the label above and to the right of the function curve.", "o|3s|5c|GO", "Place the label above and to the left of the function curve.", "o|3s|5d|GQ", "Place the label below and to the right of the function curve.", "o|3s|5e|GS", "Place the label below and to the left of the function curve.", "o|3s|5f|GU", "Place the label directly above the function curve.", "o|3s|9|GW", "Place the label directly below the function curve.", "o|3s|5g|GY", "Place the label directly to the left of the function curve.", "o|3s|5h|Ga", "Place the label directly to the right of the function curve.", "o|3s|5i|Gc", "a|GP|GR|GT|GV|GX|GZ|Gb|Gd", "o|Bi|GL|GM|5c|GN|Ge|3y", "Z-order layer index for stacking the function on a graph.", "o|33|5O|Gg|5Q|1p", "minima", "Local minima of an interpolated function.", "extrema", "o|2h|Gi|Gj|Gk", "maxima", "Local maxima of an interpolated function.", "o|2h|Gm|Gn|Gk", "Local extrema (combined minima and maxima) of an interpolated function.", "o|2h|Gk|Gp|Gk", "through", "Points the interpolated function should pass through.", "o|2h|Gr|Gs|2W", "throughSlopes", "Slopes the interpolated function should have at each through-point.", "o|2h|Gu|Gv|1Y", "variables", "Names of the function's input variables.", "_variableNameList", "o|2h|Gx|Gy|Gz", "variable", "Name of the function's single input variable.", "_variableName", "o|2h|H1|H2|H3", "symbolic", "Whether the function should be evaluated symbolically rather than numerically.", "o|2m|H5|H6|3M|2s|1V", "o|4U|4P|4Q|4R|4S|1q", "nearestPointAsCurve", "Whether nearest-point queries should treat the function as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|HA|2p|2s|1V", "a|3|2f|2l|3n|2g", "lineStyle", "Stroke style for lines.", "solid", "dashed", "dotted", "a|HF|HG|HH", "Continuous, unbroken stroke.", "o|3s|HF|HJ", "Stroke composed of evenly-spaced dashes.", "o|3s|HG|HL", "Stroke composed of evenly-spaced dots.", "o|3s|HH|HN", "a|HK|HM|HO", "o|HC|HD|HE|HI|HP|3y", "lineWidth", "Stroke width for lines, in pixels.", "o|2h|HR|HS|1p", "Lower bound for the operator's range.", "o|33|Da|HU|5Q|1p", "Upper bound for the operator's range.", "o|33|Dd|HW|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|HV|HX", "expandSpecified", "o|3Q|HZ|1V|2p|Fx", "o|3L|Fz|1p|2p|G0|3M", "o|3L|G2|1p|2p|G3|3M", "o|6J|GE|1V|2p|GF|3M|GG", "o|3L|GI|1V|2p|GJ|3M", "o|3L|GL|1T|2p|GM|3M", "o|3L|5O|1p|2p|Gg|3M", "o|3L|Da|1p|2p|HU|3M", "o|3L|Dd|1p|2p|HW|3M", "The label rendered with this component.", "o|6U|2S|2S|2p|Hj|GG", "styleDescription", "A textual description of the function's style.", "o|3Q|Hl|1T|2p|Hm", "styleDescriptionWithNoun", 'Style description including the word "function".', "o|3Q|Ho|1T|2p|Hp", "Number of input variables of the function.", "o|3Q|G5|1q|2p|Hr", "Number of output values of the function.", "o|3Q|G8|1q|2p|Ht", "Domain interval(s) of the function.", "o|73|3M|1t|36", "a|Hw", "o|6v|GB|1t|3M|Hv|36|Hx", "Level of simplification applied when displaying the formula.", "o|3Q|40|1T|2p|Hz", "Whether to expand the formula.", "o|3Q|4K|1T|2p|I1", "Whether the function is treated symbolically.", "o|3Q|H5|1V|2p|I3", "The names of the function's input variables.", "o|73|3M|H3|36", "a|I6", "o|6v|Gx|H3|3M|I5|36|I7", "formula", "The symbolic formula of the function produced by this operator.", "o|3Q|I9|1X|2p|IA", "The function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|IC", "The function rendered as a plain text string.", "o|3Q|1T|1T|2p|IE", "numMinima", "Number of local minima of the function.", "o|3Q|IG|1p|2p|IH", "Local minima of the function.", "o|73|3M|1d|36", "o|6x|2p|1d", "a|IK|IL", "o|6v|Gi|1p|3M|IJ|4X|IM", "minimumLocations", "The x-coordinates of the function's local minima.", "o|73|3M|1p|36", "a|IQ", "o|6v|IO|1p|3M|IP|36|IR", "minimumValues", "The values of the function's local minima.", "o|6v|IT|1p|3M|IU|36|IR", "globalMinimum", "The global minimum of the function (if attained).", "a|IL", "o|6v|IW|1p|3M|IX|36|IY", "globalInfimum", "The global infimum of the function.", "o|6v|Ia|1p|3M|Ib|36|IY", "numMaxima", "Number of local maxima of the function.", "o|3Q|Id|1p|2p|Ie", "Local maxima of the function.", "o|6v|Gm|1p|3M|Ig|4X|IM", "maximumLocations", "The x-coordinates of the function's local maxima.", "o|6v|Ii|1p|3M|Ij|36|IR", "maximumValues", "The values of the function's local maxima.", "o|6v|Il|1p|3M|Im|36|IR", "globalMaximum", "The global maximum of the function (if attained).", "o|6v|Io|1p|3M|Ip|36|IY", "globalSupremum", "The global supremum of the function.", "o|6v|Ir|1p|3M|Is|36|IY", "numExtrema", "Number of local extrema (minima + maxima) of the function.", "o|3Q|Iu|1p|2p|Iv", "Local extrema (minima + maxima) of the function.", "o|6v|Gk|1p|3M|Ix|4X|IM", "extremumLocations", "The x-coordinates of the function's local extrema.", "o|6v|Iz|1p|3M|J0|36|IR", "extremumValues", "The values of the function's local extrema.", "o|6v|J2|1p|3M|J3|36|IR", "The function's first input variable name.", "o|3Q|H1|H3|2p|J5", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|Hh|Hi|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function clamped to a specified output range", "o|F|w|Fo|Fp|Fr|HY|J7|3M|3M|2p|w|J8|3h", "A function wrapped into a periodic output range", "o|F|x|Fo|Fp|Fr|HY|J7|3M|3M|2p|x|JA|3h", "derivVariables", "Names of variables to differentiate with respect to.", "o|2h|JC|JD|Gz", "derivVariable", "Name of the variable to differentiate with respect to.", "o|2h|JF|JG|H3", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|JE|JH", "Number of input variables.", "o|3Q|G5|1q|2p|JJ", "Names of the input variables.", "o|6v|Gx|H3|3M|JL|36|I7", "numDerivatives", "Number of derivatives applied.", "o|3Q|JN|1q|2p|JO", "Variables with respect to which derivatives are taken.", "o|6v|JC|H3|3M|JQ|36|I7", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|Hu|Hy|I0|I2|I4|JM|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|JP|JR|J6", "The derivative of a function", "o|F|y|Fo|Fp|Fr|JI|JS|3M|3M|2p|y|JT|3h", "_textOperatorOfMath", "a|JV|2c|2d", "Whether the text can be dragged on a graph.", "o|2m|5L|JX|3M|2s|1V", "isLatex", "Whether the text content is treated as LaTeX.", "o|2m|JZ|Ja|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63", "o|3L|5L|1V|2p|JX|3M", "o|3L|JZ|1V|2p|Ja|3M", "The text result of applying this operator to its child math values.", "o|3Q|3a|1T|2p|Jf", "The text rendered as a plain text string.", "o|3Q|1T|1T|2p|Jh", "The text parsed as a math expression.", "o|3Q|1X|1X|2p|Jj", "The text parsed as a number.", "o|3Q|1p|1p|2p|Jl", "numWords", "The number of words in the text value.", "o|3Q|Jn|1q|2p|Jo", "words", "The text value split into words.", "o|73|3M|1T|36", "a|Js", "o|6v|Jq|1T|3M|Jr|36|Jt", "numCharacters", "The number of characters (graphemes) in the text value.", "o|3Q|Jv|1q|2p|Jw", "characters", "The text value split into characters (graphemes).", "o|6v|Jy|1T|3M|Jz|36|Jt", "The number of comma-separated items when the text is interpreted as a list.", "o|3Q|7Z|1q|2p|K1", "The text value split into items at commas.", "o|6v|71|1T|3M|K3|36|Jt", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|Jg|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", 'Returns the top-level operator of a math expression as text (e.g. "+", "vector")', "o|F|z|3j|3k|JW|Jc|K5|3M|2p|2p|z|K6|3h", "_inlineRenderInlineChildren", "a|K8|2c|2d", "The combined text content of this component's children, with optional begin/end delimiters.", "o|3Q|1T|1T|2p|KA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|KB", "Emphasized inline text (italic by default)", "o|F|10|2Z|2a|K9|3I|KC|3M|3M|2p|10|KD|3h", "Bold text", "o|F|11|2Z|2a|K9|3I|KC|3M|3M|2p|11|KF|3h", "Inline double-quoted text", "o|F|12|2Z|2a|K9|3I|KC|3M|3M|2p|12|KH|3h", "Inline single-quoted text", "o|F|13|2Z|2a|K9|3I|KC|3M|3M|2p|13|KJ|3h", "An inline term, styled distinctively", "o|F|14|2Z|2a|K9|3I|KC|3M|3M|2p|14|KL|3h", "Inline code text", "o|F|15|2Z|2a|K9|3I|KC|3M|3M|2p|15|KN|3h", "Renders enclosed text as an opening tag, `< >`", "o|F|16|2Z|2a|K9|3I|KC|3M|3M|2p|16|KP|3h", "Renders enclosed text as a self-closing tag, `< />`", "o|F|17|2Z|2a|K9|3I|KC|3M|3M|2p|17|KR|3h", "Renders enclosed text as a closing tag, `</ >`", "o|F|18|2Z|2a|K9|3I|KC|3M|3M|2p|18|KT|3h", "Renders a styled attribute name", "o|F|19|2Z|2a|K9|3I|KC|3M|3M|2p|19|KV|3h", "_singleCharacterInline", "a|KX|2c|2d", "The unicode character rendered by this component.", "o|3Q|1T|1T|2p|KZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Ka", "Renders an en-dash (–) character", "o|F|1A|54|AZ|KY|3I|Kb|3M|2p|2p|1A|Kc|3h", "Renders an em-dash (—) character", "o|F|1B|54|AZ|KY|3I|Kb|3M|2p|2p|1B|Ke|3h", "Renders a non-breaking space character", "o|F|1C|54|AZ|KY|3I|Kb|3M|2p|2p|1C|Kg|3h", "Renders a horizontal ellipsis (…) character", "o|F|1D|54|AZ|KY|3I|Kb|3M|2p|2p|1D|Ki|3h", "Renders a left double quotation mark (“)", "o|F|1E|54|AZ|KY|3I|Kb|3M|2p|2p|1E|Kk|3h", "Renders a right double quotation mark (”)", "o|F|1F|54|AZ|KY|3I|Kb|3M|2p|2p|1F|Km|3h", "Renders a left single quotation mark (‘)", "o|F|1G|54|AZ|KY|3I|Kb|3M|2p|2p|1G|Ko|3h", "Renders a right single quotation mark (’)", "o|F|1H|54|AZ|KY|3I|Kb|3M|2p|2p|1H|Kq|3h", "styleDefinition", "feedbackDefinition", "a|1z|9A|G|9H|Ks|Kt|Af|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1000000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_sectioningComponentNumberWithSiblings", "_sectioningComponent", "a|Kw|Kx|9W|2d", "boxed", "Whether to render this section with a visible box around it.", "o|2m|Kz|L0|2p|2s|1V", "includeAutoName", 'Whether to include the auto-generated section name (e.g. "Section") in the rendered title.', "o|2m|L2|L3|2p|2s|1V", "includeAutoNumber", "Whether to include the auto-generated section number in the rendered title.", "o|2m|L5|L6|2p|2s|1V", "noAutoTitle", "Whether to suppress the auto-generated title entirely.", "o|2m|L8|L9|2p|2s|1V", "includeAutoNameIfNoTitle", "Whether to include the auto-generated name when no explicit title is provided.", "o|2m|LB|LC|3M|2s|1V", "includeAutoNumberIfNoTitle", "Whether to include the auto-generated number when no explicit title is provided.", "o|2m|LE|LF|3M|2s|1V", "Whether to render this section's children as a list.", "o|2m|20|LH|2p|2s|1V", "collapsible", "Whether the section can be collapsed and expanded.", "o|2m|LJ|LK|2p|2s|1V", "startOpen", "Whether the collapsible section starts in the open state.", "o|2m|LM|LN|3M|2s|1V", "level", "The heading level for this section (overrides the default level inferred from nesting).", "o|2h|LP|LQ|1q", "completedColor", "Color used to indicate this section has been completed.", "var(--lightGreen)", "o|33|LS|LT|LU|1T", "inProgressColor", "Color used to indicate this section is in progress.", "var(--mainGray)", "o|33|LW|LX|LY|1T", "notStartedColor", "Color used to indicate this section has not been started.", "o|33|La|Lb|LY|1T", "completedColorDarkMode", "Color used to indicate this section has been completed (dark mode). If omitted, the dark-mode color is derived from `completedColor` when that attribute is explicitly set; otherwise falls back to a dark green that meets WCAG AA contrast for white text.", "#1a5e20", "o|33|Ld|Le|Lf|1T", "inProgressColorDarkMode", "Color used to indicate this section is in progress (dark mode). If omitted, the dark-mode color is derived from `inProgressColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "#3a3a3a", "o|33|Lh|Li|Lj|1T", "notStartedColorDarkMode", "Color used to indicate this section has not been started (dark mode). If omitted, the dark-mode color is derived from `notStartedColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "o|33|Ll|Lm|Lj|1T", "includeParentNumber", "Whether to prefix this section's number with the parent section's number.", "o|2m|Lo|Lp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|Lq", "o|3L|L2|1V|2p|L3|3M", "o|3L|L5|1V|2p|L6|3M", "o|3L|L8|1V|2p|L9|3M", "o|3L|LB|1V|2p|LC|3M", "o|3L|LE|1V|2p|LF|3M", "o|3L|20|1V|2p|LH|3M", "o|3L|LJ|1V|2p|LK|3M", "o|3L|Lo|1V|2p|Lp|3M", "Whether this section is rendered with a visible box around it.", "o|3Q|Kz|1V|2p|M0", "sectionNumber", "The displayed number for this section.", "o|3Q|M2|1T|2p|M3", "The displayed title text for this section.", "o|3Q|G|1T|2p|M5", "open", "Whether this section is currently open (for collapsible sections).", "o|3Q|M7|1V|2p|M8", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|Lz|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A section of a document, with a title (auto-generated or custom) and content", "o|F|8D|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8D|MB|AT", "A sectional component nested one heading level deeper than `<section>`", "o|F|8E|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8E|MD|AT", "A sectional component nested one heading level deeper than `<subsection>`", "o|F|8F|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8F|MF|AT", "o|2m|Lo|Lp|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A subsection of paragraphs (rendered at heading level 4)", "o|F|8G|Ku|Kv|Ky|MI|MA|3M|3M|2p|8G|MJ|AT", "o|2m|LJ|LK|3M|2s|1V", "o|2m|LM|LN|2p|2s|1V", "postponeRendering", "Whether to delay rendering this section's contents until expanded.", "o|Ap|MN|MO|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|ML|MM|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|MP", "A note set off from the main flow of the document", "o|F|8H|Ku|Kv|Ky|MQ|MA|3M|3M|2p|8H|MR|AT", "o|2m|Kz|L0|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|MT|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A section listing learning objectives", "o|F|8I|Ku|Kv|Ky|MU|MA|3M|3M|2p|8I|MV|AT", "o|4d|9Y|9Z|9a|3M|2s|1V", "isDistractor", "Whether this section is a distractor (e.g. a wrong-answer choice for matching).", "o|Ap|MY|MZ|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|MX|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|Ma", "A sectional component that defines a scored problem", "o|F|8J|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8J|Mc|AT", "A sectional component that defines a scored exercise", "o|F|8K|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8K|Me|AT", "A sectional component that defines a scored question; similar to a `<problem>`", "o|F|8L|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8L|Mg|AT", "A sectional component with score aggregation, similar to `<problem>`", "o|F|8M|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8M|Mi|AT", "A sectional component that defines an example", "o|F|8N|Ku|Kv|Ky|MI|MA|3M|3M|2p|8N|Mk|AT", "A sectional component for defining a term or concept", "o|F|8O|Ku|Kv|Ky|MI|MA|3M|3M|2p|8O|Mm|AT", "A note section, set off from the main flow of the document", "o|F|8P|Ku|Kv|Ky|MI|MA|3M|3M|2p|8P|Mo|AT", "A sectional component for the statement of a theorem (or similar formal statement)", "o|F|8Q|Ku|Kv|Ky|MI|MA|3M|3M|2p|8Q|Mq|AT", "A subsection-style block rendered as a list item (a part of an exercise or problem)", "o|F|8R|Ku|Kv|Ky|MI|MA|3M|3M|2p|8R|Ms|AT", "A task of a multi-task activity or problem (alias for `<part>`)", "o|F|8S|Ku|Kv|Ky|MI|MA|3M|3M|2p|8S|Mu|AT", "_unnumberedSectioningComponent", "a|Mw|Kx|9W|2d", "o|2m|LE|LF|2p|2s|1V", "renameTo", 'Override the auto-generated section name (e.g. rename "Section" to a custom label).', "o|2h|Mz|N0|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|My|LI|ML|MM|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|MP", "The displayed number for this section (always null for unnumbered sections).", "o|3Q|M2|1T|2p|N3", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|N4|M6|M9", "A proof section", "o|F|8T|Ku|Kv|Mx|N2|N5|3M|3M|2p|8T|N6|AT", "a|Kx|9W|2d", "o|2m|20|LH|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|N9|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A container element grouping `<problem>` components, which are rendered as a list by default", "o|F|8U|Ku|Kv|N8|NA|NB|3M|3M|2p|8U|NC|AT", "A container element grouping `<exercise>` components, which are rendered as a list by default", "o|F|8V|Ku|Kv|N8|NA|NB|3M|3M|2p|8V|NE|AT", "li", "a|NG|1z", "Nesting level of this list (1-based).", "o|2h|LP|NI|1q", "marker", "Marker style for list items (e.g. 'disc', 'circle', '1', 'a').", "o|33|NK|NL||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|NJ|NM|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "An ordered list", "o|F|8W|NH|BN|9X|NN|AR|3M|2p|2p|8W|NO|AT", "An unordered list", "o|F|8X|NH|BN|9X|NN|AR|3M|2p|2p|8X|NQ|AT", "The list's content rendered as plain text.", "o|3Q|1T|1T|2p|NS", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|NT", "A list item within `<ol>` / `<ul>`", "o|F|NG|9U|9V|Ao|A6|NU|2p|3M|2p|NG|NV|Az", "a|H|1z", "independentVariable", "The independent variable of the ODE system.", "t", "o|5H|1X|Na", "o|33|NY|NZ|Nb|H3", "initialIndependentVariableValue", "The value of the independent variable at which the initial conditions are specified.", "0", "o|5H|1X|Nf", "o|33|Nd|Ne|Ng|1X", 'How to format the rendered system of equations (e.g. "align").', "align", "o|33|4k|Ni|Nj|1T", "chunkSize", "Step-size chunk used when numerically integrating the system.", "n|A", "o|33|Nl|Nm|Nn|1p", "tolerance", "Numerical tolerance used by the integrator.", "n|0.Q0u", "o|33|Np|Nq|Nr|1p", "maxIterations", "Maximum number of iterations the integrator may perform.", "n|G8", "o|33|Nt|Nu|Nv|1p", "hideInitialCondition", "Whether to hide the initial condition from the rendered output.", "o|2m|Nx|Ny|2p|2s|1V", "initialConditions", "The initial values of each dependent variable, in order.", "o|2h|O0|O1|1Y", "The dependent variables of the system, in the same order as the right-hand sides.", "o|2h|Gx|O3|Gz", "Whether to display equation numbers next to each equation.", "o|2m|1p|O5|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Nc|Nh|H8|4Y|4c|4g|4j|Nk|No|Ns|Nw|Nz|O2|O4|O6", "o|3L|NY|H3|2p|NZ|3M", "o|3L|Nd|1X|2p|Ne|3M", "o|3L|4k|1T|2p|Ni|3M", "o|3L|Nl|1p|2p|Nm|3M", "o|3L|Np|1p|2p|Nq|3M", "o|3L|Nt|1p|2p|Nu|3M", "o|3L|Nx|1V|2p|Ny|3M", "o|3L|1p|1V|2p|O5|3M", "The dependent variables of the system, in order matching the right-hand sides.", "o|6v|Gx|H3|3M|OG|36|I7", "rhss", "The right-hand-side expressions of each ODE in the system.", "o|6v|OI|1X|3M|OJ|36|75", "The initial values of each dependent variable at the initial independent variable value.", "o|6v|O0|1X|3M|OL|36|75", "The displayed equation number tag (when equation numbering is enabled).", "o|3Q|BG|1T|2p|ON", "The full ODE system rendered as a LaTeX string.", "o|3Q|2V|2V|2p|OP", "numericalSolutions", "Numerical solution functions for each dependent variable, as functions of the independent variable.", "o|73|3M|1r|36", "a|OT", "o|6v|OR|1r|3M|OS|36|OU", "rhs", "The right-hand-side expression of the first ODE in the system.", "o|3Q|OW|1X|2p|OX", "righthandside", "o|3Q|OZ|1X|2p|OX", "righthandsides", "o|6v|Ob|1X|3M|OJ|36|75", "initialCondition", "The initial value of the first dependent variable at the initial independent-variable value.", "o|3Q|Od|1X|2p|Oe", "numericalSolution", "Numerical solution function for the first dependent variable, as a function of the independent variable.", "o|3Q|Og|1r|2p|Oh", "a|3N|3O|3P|O8|O9|OA|OB|OC|OD|OE|OF|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|OH|OK|OM|OO|OQ|OV|OY|Oa|Oc|Of|Oi", "A system of first-order ordinary differential equations with initial conditions, rendered as math and numerically integrable", "o|F|1I|NX|BN|3l|O7|Oj|3M|2p|2p|1I|Ok|3h", "a|I|J|1z|2S", "1120", "_graphical", "a|Oo|2d", "Whether to apply this component's selected style to its label.", "o|2m|GI|Oq|2p|2s|1V", "Z-order layer index used to stack graphical components (higher values render on top).", "o|33|5O|Os|5Q|1q", "Whether the polyline can be dragged on a graph.", "o|2m|5L|Ou|3M|2s|1V", "verticesDraggable", "Whether individual vertices may be dragged independently.", "o|Ap|Ow|Ox|2s|1V", "vertices", "The list of vertex points that define the shape.", "o|2h|Oz|P0|2W", "showCoordsWhenDragging", "Whether to show coordinate labels while dragging.", "o|2m|P2|P3|3M|2s|1V", "rigid", "Whether the polyline is treated as rigid (preserves shape under drag).", "o|2m|P5|P6|2p|2s|1V", "preserveSimilarity", "Whether the shape is preserved up to similarity (uniform scaling) under drag.", "o|2m|P8|P9|2p|2s|1V", "rotationHandleVertices", "Vertex indices that should display rotation handles when the shape is rigid or preserves similarity.", "a|36", "o|33|PB|PC|PD|1a", "rotateAround", "What point to rotate the shape around.", "centroid", "vertex", "a|PH|PI|1d", "Rotate around the centroid of the shape.", "o|3s|PH|PK", "Rotate around the vertex specified by `rotationVertex`.", "o|3s|PI|PM", "Rotate around the explicit point given by `rotationCenter`.", "o|3s|1d|PO", "a|PL|PN|PP", "o|Bi|PF|PG|PH|PJ|PQ|3y", "rotationCenter", "The point to rotate around when rotateAround is 'point'.", "o|33|PS|PT||1d", "rotationVertex", "The vertex index to rotate around when rotateAround is 'vertex'.", "o|33|PV|PW|36|1q", "allowRotation", "Whether the polyline can be rotated under drag.", "o|2m|PY|PZ|3M|2s|1V", "allowTranslation", "Whether the polyline can be translated under drag.", "o|2m|Pb|Pc|3M|2s|1V", "allowDilation", "Whether the shape can be dilated (scaled) under drag.", "o|2m|Pe|Pf|3M|2s|1V", "minShrink", "Minimum scaling factor allowed when dilating.", "n|0.1", "o|33|Ph|Pi|Pj|1p", "allowReflection", "Whether the polyline can be reflected under drag.", "o|2m|Pl|Pm|3M|2s|1V", "attractThreshold", "Distance within which a dragged vertex snaps to the function curve or diagonal.", "n|0.5", "o|33|Po|Pp|Pq|1p", "numPoints", "Number of points (iterations) currently shown on the cobweb diagram.", "o|33|Ps|Pt|36|1p", "Symbol used as the independent variable when displaying iterate values.", "o|5H|1X|7Q", "o|33|H1|Pv|Pw|H3", "numIterationsRequired", "Minimum number of iterations the user is required to perform.", "o|33|Py|Pz|5Q|1p", "initialPoint", "The starting point on the diagonal where iteration begins.", "o|2h|Q1|Q2|1d", "The function being iterated.", "o|2h|1r|Q4|1r", "lockToSolution", "Whether to constrain dragged vertices to the correct cobweb solution.", "o|2m|Q6|Q7|2p|2s|1V", "defaultPoint", "The default location for newly added points on the cobweb diagram.", "o|2h|Q9|QA|1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|Pr|Pu|Px|Q0|Q3|Q5|Q8|QB", "o|3L|GI|1V|2p|Oq|3M", "o|3L|5O|1q|2p|Os|3M", "o|3L|5L|1V|2p|Ou|3M", "o|3L|P2|1V|2p|P3|3M", "o|3L|P5|1V|2p|P6|3M", "o|3L|PY|1V|2p|PZ|3M", "o|3L|Pb|1V|2p|Pc|3M", "o|3L|Pl|1V|2p|Pm|3M", "o|3L|Po|1p|2p|Pp|3M", "o|3L|Ps|1p|2p|Pt|3M", "o|3L|H1|H3|2p|Pv|3M", "o|3L|Py|1p|2p|Pz|3M", "A textual description of the polyline's style.", "o|3Q|Hl|1T|2p|QP", 'Style description including the word "polyline".', "o|3Q|Ho|1T|2p|QR", "Whether the polyline preserves its shape (up to similarity).", "o|3Q|P8|1V|2p|QT", "Whether the polyline can be dilated under drag.", "o|3Q|Pe|1V|2p|QV", "Whether each vertex can be dragged independently.", "o|3Q|Ow|1V|2p|QX", "The number of dimensions the polyline lives in.", "o|3Q|6r|1p|2p|QZ", "indexAliases", "a|3|2g|3J|2f|6r|6u|Qb", "The vertices of the polyline.", "a|7Q|7T|7W", "a|54|Qe", "o|Qc|Oz|1X|3M|Qd|4X|IM|Qf", "length", "The total length of the polyline.", "o|3Q|Qh|1p|2p|Qi", "The centroid of the polyline's vertices.", "o|6v|5b|1X|3M|Qk|36|IY", "o|6v|Q1|1X|3M|Q2|36|IY", "correctVertices", "Per-vertex flags indicating whether each vertex is positioned at the correct cobweb solution.", "o|73|3M|1V|36", "a|Qp", "o|6v|Qn|1V|3M|Qo|36|Qq", "fractionCorrectVertices", "The fraction of vertices placed at correct cobweb positions.", "o|3Q|Qs|1p|2p|Qt", "numGradedVertices", "The number of cobweb vertices that were evaluated for correctness.", "o|3Q|Qv|1p|2p|Qw", "numCorrectVertices", "The number of cobweb vertices placed at correct positions.", "o|3Q|Qy|1p|2p|Qz", "fractionCorrectVerticesAdjusted", "The fraction of correct vertices, scaled by the required minimum number of iterations.", "o|3Q|R1|1p|2p|R2", "numGradedVerticesAdjusted", "The effective number of graded vertices after adjusting for the required minimum number of iterations.", "o|3Q|R4|1p|2p|R5", "numIterateValues", "The number of iterate values produced by the cobweb diagram.", "o|3Q|R7|1p|2p|R8", "iterateValues", "The list of iterate values shown by the cobweb diagram.", "o|6v|RA|1X|3M|RB|36|75", "numVertices", "Number of cobweb vertices currently shown (alias for numPoints).", "o|3Q|RD|1p|2p|RE", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|Qa|Qg|Qj|Ql|Qm|Qr|Qu|Qx|R0|R3|R6|R9|RC|RF", "An interactive cobweb diagram for visualizing iteration of a one-variable function", "o|F|8Y|Om|On|Op|QC|RG|3M|2p|2p|8Y|RH|Az", "constrainToGrid", "constrainToGraph", "attractToGrid", "constrainTo", "attractTo", "constraintUnion", "attractToConstraint", "constrainToInterior", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|RJ|RK|RL|RM|RN|RO|RP|RQ|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "112011111111111111111111111110220101221211112221111111122220122222222222222222222222222222", "markerStyle", "Marker shape.", "square", "triangleUp", "triangleDown", "triangleLeft", "triangleRight", "diamond", "a|8u|RV|8r|RW|RX|RY|RZ|Ra", "Circular marker.", "o|3s|8u|Rc", "Square marker.", "o|3s|RV|Re", 'Triangular marker pointing up (alias for "triangleUp").', "o|3s|8r|Rg", "Triangular marker pointing up.", "o|3s|RW|Ri", "Triangular marker pointing down.", "o|3s|RX|Rk", "Triangular marker pointing left.", "o|3s|RY|Rm", "Triangular marker pointing right.", "o|3s|RZ|Ro", "Diamond-shaped marker.", "o|3s|Ra|Rq", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr", "o|HC|RT|RU|Rb|Rs|3y", "markerSize", "Marker size in pixels.", "o|2h|Ru|Rv|1p", "Whether the point can be dragged on a graph.", "o|2m|5L|Rx|3M|2s|1V", "The first coordinate (x) of the point.", "o|2h|7Q|Rz|1X", "The second coordinate (y) of the point.", "o|2h|7T|S1|1X", "The third coordinate (z) of the point.", "o|2h|7W|S3|1X", "xs", "The point's coordinates as a list.", "o|2h|S5|S6|1Y", "The point's coordinates as a single math expression.", "o|2h|1e|S8|1e", "Position of the point's label.", "Place the label above and to the right of the point.", "o|3s|5c|SB", "Place the label above and to the left of the point.", "o|3s|5d|SD", "Place the label below and to the right of the point.", "o|3s|5e|SF", "Place the label below and to the left of the point.", "o|3s|5f|SH", "Place the label directly above the point.", "o|3s|9|SJ", "Place the label directly below the point.", "o|3s|5g|SL", "Place the label directly to the left of the point.", "o|3s|5h|SN", "Place the label directly to the right of the point.", "o|3s|5i|SP", "a|SC|SE|SG|SI|SK|SM|SO|SQ", "o|Bi|GL|SA|5c|GN|SR|3y", "addControls", "Whether to render interactive control handles.", "both", "xOnly", "yOnly", "a|42|SV|SW|SX|2q|2r", "Show no control handles.", "o|3s|42|SZ", "Show control handles for moving the point in both x and y.", "o|3s|SV|Sb", "Show a control handle that constrains motion to the x direction.", "o|3s|SW|Sd", "Show a control handle that constrains motion to the y direction.", "o|3s|SX|Sf", "a|Sa|Sc|Se|Sg", "o|Bi|ST|SU|SV|SY|Sh|3y", "hideOffGraphIndicator", "Whether to suppress the indicator drawn at the edge when the point is off-screen.", "o|Ap|Sj|Sk|2s|1V", "controlOrder", "Slot order for graph controls (1-indexed; 0 means no explicit slot request).", "o|33|Sm|Sn|5Q|1q", "stable", "Whether the equilibrium is stable (rendered filled) or unstable (rendered open).", "o|2m|Sp|Sq|3M|2s|1V", "switchable", "Whether the user can toggle the stability of this equilibrium by clicking it.", "o|2m|Ss|St|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|Sr|Su", "o|3L|5L|1V|2p|Rx|3M", "o|3L|GL|1T|2p|SA|3M", "o|3L|ST|1T|2p|SU|3M", "o|3L|Sm|1q|2p|Sn|3M", "o|3L|Sp|1V|2p|Sq|3M", "o|3L|Ss|1V|2p|St|3M", "scales", "The graph axis scales (x and y) used when applying this constraint.", "o|3Q|T2|1p|2p|T3", "constraintUsed", "Whether this constraint was applied to the component.", "o|3Q|T5|1V|2p|T6", "A textual description of the point's style.", "o|3Q|Hl|1T|2p|T8", 'Style description including the word "point".', "o|3Q|Ho|1T|2p|TA", "Whether to suppress the off-graph indicator when out of view.", "o|3Q|Sj|1V|2p|TC", "Number of dimensions of the point.", "o|3Q|6r|1p|2p|TE", "o|6v|S5|1X|3M|S6|36|75", "The point's coordinates as a math expression.", "o|3Q|1e|1e|2p|TH", "The point rendered as a LaTeX string.", "o|3Q|2V|2V|2p|TJ", "numDimensionsForConstraints", "Number of dimensions exposed to constraint computations (alias for numDimensions).", "o|3Q|TL|1p|2p|TM", "o|3Q|7Q|1X|2p|Rz", "o|3Q|7T|1X|2p|S1", "o|3Q|7W|1X|2p|S3", "o|3Q|3a|1e|2p|S8", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|T0|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "An equilibrium point of a dynamical system, rendered as a filled point if stable or open if unstable", "o|F|1J|RR|RS|Op|Sv|TS|3M|3M|2p|1J|TT|Az", "a|I|J|1z|2S|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1120122221111111111111111111111222222222122220222212222201221222122222122221212222", "Whether the line can be dragged on a graph.", "o|2m|5L|TX|3M|2s|1V", "equation", "Implicit equation defining the line.", "o|2h|TZ|Ta|1X", "Points the line passes through.", "o|2h|Gr|Tc|2W", "slope", "Slope of the line.", "o|2h|Te|Tf|1p", "perpendicularTo", "Direction the line should be perpendicular to (e.g. another line or vector).", "_directionComponent", "o|2h|Th|Ti|Tj", "parallelTo", "Direction the line should be parallel to (e.g. another line or vector).", "o|2h|Tl|Tm|Tj", "Names of the variables used in the line equation.", "o|2h|Gx|To|Gz", "Where the label sits along this line/curve.", "a|5c|5d|5e|5f|5b|9|5g|5h|5i", "Place the label above and to the right of the line.", "o|3s|5c|Ts", "Place the label above and to the left of the line.", "o|3s|5d|Tu", "Place the label below and to the right of the line.", "o|3s|5e|Tw", "Place the label below and to the left of the line.", "o|3s|5f|Ty", "Place the label at the midpoint of the line.", "o|3s|5b|U0", "Place the label directly above the line.", "o|3s|9|U2", "Place the label directly below the line.", "o|3s|5g|U4", "Place the label directly to the left of the line.", "o|3s|5h|U6", "Place the label directly to the right of the line.", "o|3s|5i|U8", "a|Tt|Tv|Tx|Tz|U1|U3|U5|U7|U9", "o|Bi|GL|Tq|5b|Tr|UA|3y", "Whether the equilibrium is stable (rendered solid) or unstable (rendered dashed).", "o|2m|Sp|UC|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|UD|Su", "o|3L|5L|1V|2p|TX|3M", "o|3L|GL|1T|2p|Tq|3M", "o|3L|Sp|1V|2p|UC|3M", "A textual description of the line's style.", "o|3Q|Hl|1T|2p|UI", 'Style description including the word "line".', "o|3Q|Ho|1T|2p|UK", "Number of dimensions the line lives in.", "o|3Q|6r|1p|2p|UM", "Variable names used in the line's equation.", "o|6v|Gx|H3|3M|UO|36|I7", "points", "Two points the line passes through.", "o|Qc|UQ|1X|3M|UR|4X|IM|Qf", "The line's equation as a math expression.", "o|3Q|TZ|1X|2p|UT", "coeff0", "The constant term in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UV|1X|2p|UW", "coeffvar1", "The coefficient of the first variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UY|1X|2p|UZ", "coeffvar2", "The coefficient of the second variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|Ub|1X|2p|Uc", "The slope of the line (2D only).", "o|3Q|Te|1X|2p|Ue", "xintercept", "The x-intercept of the line.", "o|3Q|Ug|1X|2p|Uh", "yintercept", "The y-intercept of the line.", "o|3Q|Uj|1X|2p|Uk", "The line's equation rendered as LaTeX.", "o|3Q|2V|2V|2p|Um", "The line's equation rendered as plain text.", "o|3Q|1T|1T|2p|Uo", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "An equilibrium line of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|1K|TV|TW|Op|UE|Uq|3M|3M|2p|1K|Ur|Az", "a|I|J|1z|2S|w|x|y|1r|1s|1g|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11201110101222211111111111111111111112222221222202222122222011222122222122221212222", "fillOpacity", "Opacity of solid fills, 0 to 1.", "o|2h|Uv|Uw|1p", "fillPatternOpacity", "Opacity of pattern fills (non-solid fillStyle), 0 to 1.", "o|2h|Uy|Uz|1p", "fillStyle", "Fill pattern used inside closed shapes.", "horizontal", "vertical", "diagonal", "backDiagonal", "dots", "diamonds", "a|HF|V3|V4|V5|V6|V7|V8", "Solid fill.", "o|3s|HF|VA", "Horizontal line pattern.", "o|3s|V3|VC", "Vertical line pattern.", "o|3s|V4|VE", "Diagonal line pattern (/).", "o|3s|V5|VG", "Back-diagonal line pattern (\\).", "o|3s|V6|VI", "Dots pattern.", "o|3s|V7|VK", "Filled diamonds pattern.", "o|3s|V8|VM", "a|VB|VD|VF|VH|VJ|VL|VN", "o|HC|V1|V2|V9|VO|3y", "Whether the curve can be dragged on a graph.", "o|2m|5L|VQ|3M|2s|1V", "Position of the curve's label relative to the curve.", "Place the label above and to the right of the curve.", "o|3s|5c|VT", "Place the label above and to the left of the curve.", "o|3s|5d|VV", "Place the label below and to the right of the curve.", "o|3s|5e|VX", "Place the label below and to the left of the curve.", "o|3s|5f|VZ", "Place the label directly above the curve.", "o|3s|9|Vb", "Place the label directly below the curve.", "o|3s|5g|Vd", "Place the label directly to the left of the curve.", "o|3s|5h|Vf", "Place the label directly to the right of the curve.", "o|3s|5i|Vh", "a|VU|VW|VY|Va|Vc|Ve|Vg|Vi", "o|Bi|GL|VS|5c|GN|Vj|3y", "flipFunction", "Whether to swap the function and its argument (i.e., reflect across y=x).", "o|2m|Vl|Vm|2p|2s|1V", "numDiscretizationPoints", "Number of points used when discretizing the curve for rendering.", "o|33|Vo|Vp|Nv|1p", "periodic", "Whether the curve is treated as periodic when interpolating between control points.", "o|2m|Vr|Vs|2p|2s|1V", "splineTension", "Tension parameter used when fitting a spline through control points.", "n|0.8", "o|33|Vu|Vv|Vw|1p", "extrapolateBackward", "Whether to extrapolate the curve before its first defined point.", "o|2m|Vy|Vz|2p|2s|1V", "extrapolateForward", "Whether to extrapolate the curve beyond its last defined point.", "o|2m|W1|W2|2p|2s|1V", "splineForm", "Form of spline used to interpolate between control points.", "centripetal", "uniform", "a|W6|W7", "Centripetal Catmull-Rom spline (avoids self-intersection at sharp turns).", "o|3s|W6|W9", "Uniform Catmull-Rom spline with evenly spaced parameterization.", "o|3s|W7|WB", "a|WA|WC", "o|Bi|W4|W5|W6|W8|WD|3y", "Name of the curve's parameter or independent variable.", "o|33|H1|WF|Pw|H3", "Points the interpolated curve passes through.", "o|2h|Gr|WH|2W", "parMin", "Minimum value of the curve's parameter (for parametric curves).", "o|2h|WJ|WK|1X", "parMax", "Maximum value of the curve's parameter (for parametric curves).", "o|2h|WM|WN|1X", "Whether to show coordinate labels while dragging the curve.", "o|2m|P2|WP|3M|2s|1V", "Whether nearest-point queries should treat this as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|WR|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j|UD|Su", "o|3L|5L|1V|2p|VQ|3M", "o|3L|GL|1T|2p|VS|3M", "o|3L|Vl|1V|2p|Vm|3M", "o|3L|Vo|1p|2p|Vp|3M", "o|3L|Vr|1V|2p|Vs|3M", "o|3L|Vu|1p|2p|Vv|3M", "o|3L|Vy|1V|2p|Vz|3M", "o|3L|W1|1V|2p|W2|3M", "o|3L|W4|1T|2p|W5|3M", "o|3L|P2|1V|2p|WP|3M", "A textual description of the curve's style.", "o|3Q|Hl|1T|2p|We", 'Style description including the word "curve".', "o|3Q|Ho|1T|2p|Wg", "Maximum value of the curve's parameter.", "o|3Q|WM|1p|2p|Wi", "Minimum value of the curve's parameter.", "o|3Q|WJ|1p|2p|Wk", "Number of dimensions the curve lives in.", "o|3Q|6r|1p|2p|Wm", "throughPoints", "Points the curve is constrained to pass through.", "o|6v|Wo|1X|3M|Wp|4X|IM", "vectorControlDirections", "Direction symmetry of each control vector pair.", "o|6v|Wr|1T|3M|Ws|36|Jt", "hiddenControls", "Whether each control vector is currently hidden.", "o|6v|Wu|1V|3M|Wv|36|Qq", "controlVectors", "The Bezier control vectors at each through-point.", "o|73|3M|1h|4X", "o|73|3M|1h|36", "a|Wz|X0|6y", "a|54|54|Qe", "o|Qc|Wx|1X|3M|Wy|4S|X1|X2", "controlPoints", "The Bezier control points (vertex + offset) for each through-point.", "o|73|3M|1d|4X", "a|X6|IK|IL", "o|6v|X4|1X|3M|X5|4S|X7", "extrapolateBackwardMode", "The extrapolation style used before the first through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|X9|1T|2p|XA", "extrapolateForwardMode", "The extrapolation style used beyond the last through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|XC|1T|2p|XD", "fs", "The component functions of the curve as functions of its parameter.", "o|6v|XF|1r|3M|XG|36|OU", "numXCriticalPoints", "The number of x-critical points (horizontal tangents) on the curve.", "o|3Q|XI|1q|2p|XJ", "xCriticalPoints", "The x-critical points (horizontal tangents) on the curve.", "o|6v|XL|1p|3M|XM|4X|IM", "numYCriticalPoints", "The number of y-critical points (vertical tangents) on the curve.", "o|3Q|XO|1q|2p|XP", "yCriticalPoints", "The y-critical points (vertical tangents) on the curve.", "o|6v|XR|1p|3M|XS|4X|IM", "numCurvatureChangePoints", "The number of points where the curve's curvature changes sign.", "o|3Q|XU|1q|2p|XV", "curvatureChangePoints", "Points where the curve's curvature changes sign (inflection points).", "o|6v|XX|1p|3M|XY|4X|IM", "The first component function of the curve as a function of its parameter.", "o|3Q|4y|1r|2p|Xa", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "An equilibrium curve of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|8Z|Ut|Uu|Op|WT|Xc|3M|3M|2p|8Z|Xd|Az", "symbol", 'The chemical symbol of the atom (e.g. "H", "He", "Li").', "o|2h|Xf|Xg|1T", "atomicNumber", "The atomic number of the atom (number of protons).", "o|2h|Xi|Xj|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Xh|Xk|H8|4Y|4c|4g|4j", "The atomic number of the element.", "o|3Q|Xi|1q|2p|Xm", "The chemical symbol of the element.", "o|3Q|Xf|1T|2p|Xo", "The full name of the element.", "o|3Q|3|1T|2p|Xq", "The group number of the element in the periodic table.", "o|3Q|23|1q|2p|Xs", "atomicMass", "The atomic mass of the element.", "o|3Q|Xu|1p|2p|Xv", "phaseAtSTP", "The phase (solid, liquid, or gas) of the element at standard temperature and pressure.", "o|3Q|Xx|1T|2p|Xy", "chargeOfCommonIon", "The charge of the most common ion of this element.", "o|3Q|Y0|1q|2p|Y1", "metalCategory", "The metal category of the element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Y4", `The descriptive name of the element's periodic group (e.g. "Alkali metals").`, "o|3Q|4N|1T|2p|Y6", "period", "The period number of the element in the periodic table.", "o|3Q|Y8|1q|2p|Y9", "ionizationEnergy", "The first ionization energy of the element.", "o|3Q|YB|1p|2p|YC", "meltingPoint", "The melting point of the element.", "o|3Q|YE|1p|2p|YF", "boilingPoint", "The boiling point of the element.", "o|3Q|YH|1p|2p|YI", "atomicRadius", "The atomic radius of the element.", "o|3Q|YK|1q|2p|YL", "density", "The density of the element at standard conditions.", "o|3Q|YN|1p|2p|YO", "electronegativity", "The Pauling electronegativity of the element.", "o|3Q|YQ|1p|2p|YR", "The electron configuration of the element as a math expression.", "o|3Q|1O|1O|2p|YT", "The orbital diagram of the element.", "o|3Q|8a|8a|2p|YV", "The atom rendered as a math expression with the element symbol.", "o|3Q|1X|1X|2p|YX", "The atom rendered as a LaTeX string.", "o|3Q|2V|2V|2p|YZ", "The atom rendered as a plain text string.", "o|3Q|1T|1T|2p|Yb", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|Xn|Xp|Xr|Xt|Xw|Xz|Y2|Y5|Y7|YA|YD|YG|YJ|YM|YP|YS|YU|YW|YY|Ya|Yc", "Represents a chemical element by symbol or atomic number, exposing its periodic-table properties", "o|F|1L|54|AZ|3l|Xl|Yd|3M|2p|2p|1L|Ye|3h", "a|1L|1z", 'The chemical symbol of the element (e.g. "Na", "Cl").', "o|2h|Xf|Yh|1T", "o|2h|Xi|Xm|1q", "charge", "The charge of the ion (positive for cations, negative for anions).", "o|2h|Yk|Yl|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Yi|Yj|Ym", "The charge of the ion.", "o|3Q|Yk|1q|2p|Yo", 'The full name of the ion (e.g. "sodium ion").', "o|3Q|3|1T|2p|Yq", "The group number of the underlying element in the periodic table.", "o|3Q|23|1q|2p|Ys", "The metal category of the underlying element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Yu", "The descriptive name of the underlying element's periodic group.", "o|3Q|4N|1T|2p|Yw", "The period number of the underlying element in the periodic table.", "o|3Q|Y8|1q|2p|Yy", "The ion rendered as a math expression (element symbol with charge).", "o|3Q|1X|1X|2p|Z0", "The ion rendered as a LaTeX string.", "o|3Q|2V|2V|2p|Z2", "The ion rendered as a plain text string.", "o|3Q|1T|1T|2p|Z4", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|Xn|Xp|Yp|Yr|Yt|Yv|Yx|Yz|Z1|Z3|Z5", "Represents a charged ion specified by element and charge, rendered with its chemical formula", "o|F|1M|Yg|BN|3l|Yn|Z6|3M|2p|2p|1M|Z7|3h", "a|1L|1M|1z", "202", "The chemical symbol of an element in the compound.", "o|2h|Xf|ZB|1T", "The atomic number of an element in the compound.", "o|2h|Xi|ZD|1q", "The charge of an ion in the compound.", "o|2h|Yk|ZF|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ZC|ZE|ZG", "The ionic compound rendered as a math expression of its chemical formula.", "o|3Q|1X|1X|2p|ZI", "The ionic compound rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZK", "The ionic compound rendered as a plain text string.", "o|3Q|1T|1T|2p|ZM", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|ZJ|ZL|ZN", "Forms a balanced ionic compound from constituent ions and renders its chemical formula", "o|F|1N|Z9|ZA|3l|ZH|ZO|3M|2p|2p|1N|ZP|3h", "o|3Q|3a|1O|2p|6e", "The electron configuration rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZS", "The electron configuration rendered as a unicode text string.", "o|3Q|1T|1T|2p|ZU", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ZR|6h|6j|6m|ZT|ZV|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Renders an electron configuration with sublevel labels and superscripted electron counts", "o|F|1O|3j|3k|3l|64|ZW|3M|3M|2p|1O|ZX|3h", "a|1Z|1z|8a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02012222111111111111111111111122222222212222022212222201221222122222122221212222", "Text labels for each orbital row.", "o|33|GG|Zb|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zc", "The orbital diagram value as a list of rows, each with a label and boxes containing up/down arrows.", "o|3Q|3a|8a|2p|Ze", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zf", "Renders an orbital diagram showing electrons in atomic orbitals as up/down arrows in boxes", "o|F|8a|ZZ|Za|9X|Zd|Zg|3M|3M|2p|8a|Zh|AT", "prefill", "An orbital diagram used to prefill the input before the student begins.", "o|33|Zj|Zk|54|8a", "prefillLabel", "Text labels to prefill for each orbital row.", "o|33|Zm|Zn|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zl|Zo", "The current orbital diagram entered by the student.", "o|3Q|3a|8a|2p|Zq", "The orbital diagram rows in display order (reversed from the underlying value).", "o|3Q|7K|8a|2p|Zs", "The number of orbital rows in the diagram.", "o|3Q|7A|1q|2p|Zu", "selectedRowIndex", "Index of the currently selected orbital row (1-based; 0 if none selected).", "o|3Q|Zw|1q|2p|Zx", "selectedBoxIndex", "Index of the currently selected box within the selected row (1-based; 0 if none selected).", "o|3Q|Zz|1q|2p|a0", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zr|Zt|Zv|Zy|a1", "An interactive widget where students fill in an orbital diagram by adding boxes, rows, and up/down arrows (block-level; does not inherit from Input)", "o|F|8b|54|AZ|9X|Zp|a2|3M|2p|2p|8b|a3|AT", "code", "Identifier used to reference this feedback definition.", "o|2h|a5|a6|1T", "Default feedback text for this code.", "o|2h|1T|a8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|a7|a9", "A reusable feedback definition referenced by other components", "o|F|Kt|54|AZ|Ao|aA|Aa|3M|2p|2p|Kt|aB|Az", "Index identifying which style this definition applies to.", "o|33|34|aD|36|1q", "lineColor", "Color used for line strokes (light mode).", "o|2h|aF|aG|1T", "lineColorWord", "Human-readable name of the line color (light mode).", "o|2h|aI|aJ|1T", "lineColorDarkMode", "Color used for line strokes (dark mode).", "o|2h|aL|aM|1T", "lineColorWordDarkMode", "Human-readable name of the line color (dark mode).", "o|2h|aO|aP|1T", "lineOpacity", "Opacity of line strokes, 0 to 1.", "o|2h|aR|aS|1p", "lineWidthWord", "Human-readable name of the line width.", "o|2h|aU|aV|1T", "lineStyleWord", "Human-readable name of the line style.", "o|2h|aX|aY|1T", "markerColor", "Color used for markers/points (light mode).", "o|2h|aa|ab|1T", "markerColorWord", "Human-readable name of the marker color (light mode).", "o|2h|ad|ae|1T", "markerColorDarkMode", "Color used for markers/points (dark mode).", "o|2h|ag|ah|1T", "markerColorWordDarkMode", "Human-readable name of the marker color (dark mode).", "o|2h|aj|ak|1T", "markerOpacity", "Opacity of markers/points, 0 to 1.", "o|2h|am|an|1p", "cross", "plus", "a|8u|RV|8r|RW|RX|RY|RZ|Ra|ap|aq", "Cross-shaped marker (×).", "o|3s|ap|as", "Plus-shaped marker (+).", "o|3s|aq|au", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr|at|av", "o|HC|RT|RU|ar|aw|3y", "markerStyleWord", "Human-readable name of the marker style.", "o|2h|ay|az|1T", "markerFilled", "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior.", "o|Ap|b1|b2|2s|1V", "fillColor", "Fill color used inside closed shapes (light mode).", "o|2h|b4|b5|1T", "fillColorWord", "Human-readable name of the fill color (light mode).", "o|2h|b7|b8|1T", "fillColorDarkMode", "Fill color used inside closed shapes (dark mode).", "o|2h|bA|bB|1T", "fillColorWordDarkMode", "Human-readable name of the fill color (dark mode).", "o|2h|bD|bE|1T", "fillStyleWord", "Human-readable name of the fill style.", "o|2h|bG|bH|1T", "Text color (light mode).", "o|2h|6L|bJ|1T", "textColorWord", "Human-readable name of the text color (light mode).", "o|2h|bL|bM|1T", "textColorDarkMode", "Text color (dark mode).", "o|2h|bO|bP|1T", "textColorWordDarkMode", "Human-readable name of the text color (dark mode).", "o|2h|bR|bS|1T", "highContrastColor", "High-contrast accent color (light mode).", "o|2h|bU|bV|1T", "highContrastColorWord", "Human-readable name of the high-contrast accent color (light mode).", "o|2h|bX|bY|1T", "highContrastColorDarkMode", "High-contrast accent color (dark mode).", "o|2h|ba|bb|1T", "highContrastColorWordDarkMode", "Human-readable name of the high-contrast accent color (dark mode).", "o|2h|bd|be|1T", "Background color (light mode).", "o|2h|6O|bg|1T", "backgroundColorWord", "Human-readable name of the background color (light mode).", "o|2h|bi|bj|1T", "backgroundColorDarkMode", "Background color (dark mode).", "o|2h|bl|bm|1T", "backgroundColorWordDarkMode", "Human-readable name of the background color (dark mode).", "o|2h|bo|bp|1T", "a|2j|2t|2w|2z|32|aE|3A|3E|3H|aH|aK|aN|aQ|aT|HT|aW|HQ|aZ|ac|af|ai|al|ao|ax|b0|Rw|b3|b6|b9|bC|bF|Ux|V0|VP|bI|bK|bN|bQ|bT|bW|bZ|bc|bf|bh|bk|bn|bq", "a|3N|3P|3T|3U|3V|3W|3Z", "A reusable style definition referenced by other components", "o|F|Ks|54|AZ|Ao|br|bs|3M|2p|2p|Ks|bt|Az", "a|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|1b|8y|92|96|97|98|1w|1x|1y|1z|22|23|9C|9D|9E|9F|2D|2I|9I|2L|2M|9J|2P|9N|9Q|9S|9T", "1111111111111111111111111111111111111211111222222111122122121111", "width", "Total rendered width of the side-by-side container.", "componentSize", "o|2h|bx|by|bz", "widths", "List of widths for each panel.", "_componentSizeList", "o|2h|c1|c2|c3", "margins", "List of margin widths between panels.", "o|2h|c5|c6|c3", "valign", "Default vertical alignment for all panels.", "middle", "a|9|cA|5g", "Align panels to the top.", "o|3s|9|cC", "Vertically center panels.", "o|3s|cA|cE", "Align panels to the bottom.", "o|3s|5g|cG", "a|cD|cF|cH", "o|HC|c8|c9|cB|cI|3y", "isList", "a|3|2f|2l|3n|cK|2g", "valigns", "Per-panel vertical alignment values.", "Align the panel to the top.", "o|3s|9|cO", "Vertically center the panel.", "o|3s|cA|cQ", "Align the panel to the bottom.", "o|3s|5g|cS", "a|cP|cR|cT", "o|cL|cM|cN|cB|cU|3M|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|c0|c4|c7|cJ|cV", "absoluteMeasurements", "Whether children's widths are interpreted in absolute units.", "o|3Q|cX|1V|2p|cY", "gapWidth", "The gap width between panels as a percentage of the total container width.", "o|3Q|ca|1p|2p|cb", "The list of child widths.", "o|6v|c1|1p|3M|cd|36|IR", "Margins between adjacent children.", "o|6v|c5|1p|3M|cf|36|IR", "Vertical alignment of each child.", "o|6v|cM|1T|3M|ch|36|Jt", "a|3N|3O|3P|3T|3U|3V|3W|3Z|cZ|cc|ce|cg|ci", "Renders children in a side-by-side horizontal layout", "o|F|8c|bv|bw|9X|cW|cj|3M|2p|2p|8c|ck|AT", "a|8c|1z", "A group of `<sideBySide>` components that share alignment and spacing", "o|F|8d|cm|BN|9X|cW|cj|3M|2p|2p|8d|cn|AT", "A vertical container element for organizing content within a `<sideBySide>`", "o|F|8e|9U|9V|9X|3I|Aa|3M|3M|2p|8e|cp|AT", "A generic block-level container", "o|F|8f|9U|9V|9X|A6|AR|3M|3M|2p|8f|cr|AT", "A generic inline container", "o|F|1P|9U|9V|3l|A6|AR|3M|3M|2p|1P|ct|3h", "A preformatted block preserving whitespace", "o|F|8g|9U|9V|9X|3I|Aa|3M|3M|2p|8g|cv|AT", "The verbatim text content.", "o|3Q|1T|1T|2p|cx", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|cy", "Displays a DoenetML source string verbatim", "o|F|1Q|9U|9V|3l|3I|cz|3M|3M|2p|1Q|d0|3h", "initialPage", "1-based page index shown on first render.", "o|33|d2|d3|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|d4", "numPages", "The total number of pages.", "o|3Q|d6|1q|2p|d7", "currentPage", "The currently displayed page (1-based).", "o|3Q|d9|1q|2p|dA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|d8|dB", "Defines a paginated section of content", "o|F|8h|9U|9V|9X|d5|dC|3M|3M|2p|8h|dD|AT", "previousLabel", 'Label for the "previous page" button.', "Previous", "o|33|dF|dG|dH|1T", "nextLabel", 'Label for the "next page" button.', "Next", "o|33|dJ|dK|dL|1T", "pageLabel", "Label format for the current page indicator.", "Page", "o|33|dN|dO|dP|1T", "Reference to the `<paginator>` these controls operate on.", "o|2h|8h|dR|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dI|dM|dQ|dS", "o|3L|dF|1T|2p|dG|3M", "o|3L|dJ|1T|2p|dK|3M", "o|3L|dN|1T|2p|dO|3M", "disabledDirectly", "Whether the controls are disabled directly (rather than via inheritance).", "o|3Q|dX|1V|2p|dY", "a|3N|3O|3P|dU|dV|dW|3T|3U|3V|3W|3Z|dZ", "Previous/next page controls referencing a paginator elsewhere in the document", "o|F|8i|54|AZ|9X|dT|da|3M|2p|2p|8i|db|AT", "shortDescription", "a|I|J|1z|2S|2f|dd|2U", "1120000", "_input", "a|dg|2c|2d", "Position of the label relative to the input.", "a|5h|5i", "Place the label to the left of the input.", "o|3s|5h|dk", "Place the label to the right of the input.", "o|3s|5i|dm", "a|dl|dn", "o|Bi|GL|di|5h|dj|do|3y", "forAnswer", "References to `<answer>` elements that this input should submit to.", "o|2h|dq|dr|3D", "Number of rows in the matrix input.", "o|33|7A|dt|36|1q", "Number of columns in the matrix input.", "o|33|7D|dv|36|1q", "showSizeControls", "Whether to render controls for resizing the matrix.", "o|2m|dx|dy|3M|2s|1V", "defaultEntry", "Default value used for empty matrix cells.", "o|33|e0|e1|5J|1X", "Initial matrix value displayed in the input.", "o|33|Zj|e3|5J|1X", "Input format for the math entered.", "o|Bi|3p|e5|1T|3r|3x|3y", "o|4U|4P|4Q|4R|Nn|1q", "o|4U|4Z|4a|4R|5Q|1p", "bindValueTo", "Two-way binding target for the input's value.", "o|2h|e9|eA|1X", "unionFromU", 'Whether "U" between sets is parsed as union.', "o|2m|eC|eD|2p|2s|1V", "minComponentWidth", "Minimum rendered width for each cell, in pixels.", "o|33|eF|eG|5Q|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|du|dw|dz|e2|e4|e6|51|58|5B|e7|4Y|e8|4g|4j|eB|eE|eH", "o|3L|GL|1T|2p|di|3M", "o|3L|dx|1V|2p|dy|3M", "o|3L|Zj|1X|2p|e3|3M", "o|3L|3p|1T|2p|e5|3M", "o|3L|eC|1V|2p|eD|3M", "A short accessibility description of this input; it is visible to screen readers but not rendered visually.", "o|3Q|dd|1T|2p|eO", "focused", "Whether the matrix input currently has keyboard focus.", "o|3Q|eQ|1V|2p|eR", "valueChanged", "Whether the value has been changed from its initial state.", "o|3Q|eT|1V|2p|eU", "immediateValueChanged", "Whether the value, including in-progress edits, has been changed from its initial state.", "o|3Q|eW|1V|2p|eX", "The number of rows of the matrix.", "o|3Q|7A|1q|2p|eZ", "The number of columns of the matrix.", "o|3Q|7D|1q|2p|eb", "The matrix value of the input.", "o|3Q|3a|1X|2p|ed", "immediateValue", "The matrix value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|eg", "The current matrix as a text string.", "o|3Q|1T|1T|2p|ei", "The matrix as a math expression.", "o|6v|2U|1X|3M|ek|4X|7I", "a|3N|3O|3P|eJ|Hd|eK|eL|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|eS|6X|6Y|6Z|6a|6b|eV|eY|ea|ec|ee|eh|ej|el|7P|7M", "An interactive matrix input where each cell accepts a math value", "o|F|1R|de|df|dh|eI|em|3M|2p|2p|1R|en|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "112000122221111111111111111111111222222222122220222212222222221222122222122221212222", "prefillNumerator", "Initial value displayed in the numerator input.", "o|33|er|es|5J|1X", "prefillDenominator", "Initial value displayed in the denominator input.", "o|33|eu|ev|5J|1X", "Minimum rendered width for the numerator and denominator, in pixels.", "o|33|eF|ex|5Q|1q", "Two-way binding target for the fraction's value.", "o|2h|e9|ez|1X", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|et|ew|e6|51|58|5B|e7|4Y|e8|4g|4j|eE|ey|f0", "o|3L|er|1X|2p|es|3M", "o|3L|eu|1X|2p|ev|3M", "Whether the fraction input currently has keyboard focus.", "o|3Q|eQ|1V|2p|f4", "The fraction value of the input (numerator divided by denominator).", "o|3Q|3a|1X|2p|f6", "The fraction value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|f8", "numerator", "The numerator of the fraction.", "o|3Q|fA|1X|2p|fB", "denominator", "The denominator of the fraction.", "o|3Q|fD|1X|2p|fE", "The current fraction as a text string.", "o|3Q|1T|1T|2p|fG", "a|3N|3O|3P|eJ|Hd|f2|f3|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|f5|6X|6Y|6Z|6a|6b|eV|f7|eY|f9|fC|fF|fH", "An interactive fraction input with a numerator and a denominator, each accepting a math value.", "o|F|1S|ep|eq|dh|f1|fI|3M|2p|2p|1S|fJ|3h", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "111111111111111111111111111111111111111111111111111111111111111112211111111121212222121212211111111111222222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "Whether the solution is initially hidden.", "o|2m|2n|fN|2p|2s|1V", "a|2j|fO|2w|2z|32|37|3A|3E|3H", "Whether the solution is currently hidden.", "o|3Q|2n|1V|2p|fQ", "Whether the solution is currently open (revealed).", "o|3Q|M7|1V|2p|fS", "a|3O|3P|3T|3U|3V|3W|3Z|fR|fT", "A solution to an exercise, shown on demand", "o|F|8j|fL|fM|9X|fP|fU|3M|3M|2p|8j|fV|AT", 'A sectional component that renders an expandable block labeled "Answer"', "o|F|8k|fL|fM|9X|fP|fU|3M|3M|2p|8k|fX|AT", "a|1z|9A|G|9H|Ks|Kt|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "100000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "xmlns", "XML namespace declaration (accepted for compatibility; not used).", "o|2h|fb|fc|1T", "Document type identifier.", "o|2h|2g|fe|1T", "a|2j|32|3E|3H|9h|9l|9o|9r|9u|9y|A2|A5|fd|ff", "Aggregate credit achieved (0 to 1) for scored content in the document.", "o|3Q|AL|1p|2p|fh", "Aggregate credit achieved as a percentage (0 to 100) for scored content in the document.", "o|3Q|AO|1p|2p|fj", "The document's title.", "o|3Q|G|1T|2p|fl", "a|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|fi|fk|fm", "The top-level container for a DoenetML document (added implicitly if not present)", "o|F|8l|fZ|fa|Ao|fg|fn|3M|3M|2p|8l|fo|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19", "2222222222222222222222222222222222222212220222222222222222222222221122222212111111111111111111", "The text value.", "o|3Q|3a|1T|2p|fs", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|ft|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", "A text string", "o|F|1T|fq|fr|3l|Jc|fu|3M|3M|2p|1T|fv|3h", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X", "2222222222222222222222222222222222222212220222222222222222222222221122222212", "_composite", "a|fz|2d", "a|3|2f|2k", "o|g1|2x|2y|2p", "a|3|2f", "o|g3|38|39", "Whether the order of items should be treated as unordered.", "o|2m|4n|g5|2p|2s|1V", "maxNumber", "Maximum number of items to retain in the list.", "o|33|g7|g8|9k|1p", "Whether to render the items separated by commas (true) or with no separator (false).", "o|2m|20|gA|3M|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|g6|g9|gB", "o|3L|4n|1V|2p|g5|3M", "o|3L|g7|1p|2p|g8|3M", "numComponents", "The number of items in the text list.", "o|3Q|gF|1p|2p|gG", "numValues", "The number of text values in the list.", "o|3Q|gI|1p|2p|gJ", "a|3N|3O|gD|gE|3Z|gH|gK", "A list of texts", "o|F|1U|fx|fy|g0|gC|gL|3M|3M|3M|1U|gM|Az", "A paragraph of inline content", "o|F|8m|Ag|Ah|9X|A6|Ak|3M|3M|2p|8m|gO|AT", "The boolean value (true or false).", "o|3Q|3a|1V|2p|gQ", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|gR|CW", "A boolean value", "o|F|1V|BY|BZ|3l|CI|gS|3M|3M|2p|1V|gT|3h", "Whether the order of items in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|gV|2p|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB", "o|3L|4n|1V|2p|gV|3M", "The number of items in the boolean list.", "o|3Q|gF|1p|2p|gZ", "The number of booleans in the list.", "o|3Q|gI|1p|2p|gb", "a|3N|3O|gY|gE|3Z|ga|gc", "A list of booleans", "o|F|1W|Cc|Cd|g0|gX|gd|3M|3M|3M|1W|ge|Az", "o|3Q|3a|1X|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A math expression", "o|F|1X|3j|3k|3l|64|gh|3M|3M|2p|1X|gi|3h", "mergeMathLists", "Whether nested math-list children should be flattened into this list.", "o|Ap|gk|gl|2s|1V", "o|g3|4P|4Q", "o|g3|4V|4W", "o|g3|4Z|4a", "o|g3|4e|4f", "o|g3|4h|4i", "Symbols treated as function names when parsing items.", "o|33|4w|gs|50|1U", "References whose names should be treated as function symbols when parsing items.", "o|33|52|gu|54|3D", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gm|gB|gn|go|gp|gq|gr|gt|gv|58|5B", "o|3L|4w|1U|2p|gs|3M", "o|3Q|4n|1V|2p|gV", "Whether nested math lists are merged into the parent list.", "o|3Q|gk|1V|2p|gz", "The number of items in the math list.", "o|3Q|gF|1p|2p|h1", "The number of math expressions in the list.", "o|3Q|gI|1p|2p|h3", "a|3N|3O|gE|gx|6D|6E|3Z|gy|h0|h2|h4", "A list of math expressions", "o|F|1Y|3j|3k|g0|gw|h5|3M|3M|3M|1Y|h6|Az", "A list of math tuples, parsed from parenthesized comma-separated pieces", "o|F|1Z|3j|3k|g0|gw|h5|3M|3M|3M|1Z|h8|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1111111111111111111111121220222101122221222221222112222222222222222222222222222", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB|gn|go|gp|gq|gr", "The number of items in the number list.", "o|3Q|gF|1p|2p|hD", "The number of numbers in the list.", "o|3Q|gI|1p|2p|hF", "a|3N|3O|gE|3Z|gy|hE|hG", "A list of numbers", "o|F|1a|hA|hB|g0|hC|hH|3M|3M|3M|1a|hI|Az", "Maximum number of descendants to collect.", "o|33|g7|hK||1p", "from", "Component subtree(s) to collect descendants from.", "o|2h|hM|hN|3D", "componentType", "Component type of descendants to collect.", "o|2h|hP|hQ|1T", "a|2j|32|3E|3H|hL|hO|hR|gB", "o|3L|g7|1p|2p|hK|3M", "a|hT|3Z", "Collects descendants of a component matching a specified component type", "o|F|1b|54|AZ|g0|hS|hU|3M|2p|3M|1b|hV|Az", "to", "The target that the reference points to (component reference or URL string).", "referenceOrText", "o|2h|hX|hY|hZ", "textType", "Type of text to use for the reference label.", "type-global", "o|33|hb|hc|hd|1T", "createButton", "Whether to render this reference as a clickable button.", "o|2m|hf|hg|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ha|he|hh", "o|3L|hb|1T|2p|hc|3M", "url", "The resolved URL of the referenced component.", "o|3Q|hk|1T|2p|hl", "linkText", "The display text used for the link.", "o|3Q|hn|1T|2p|ho", "The text used as the link label.", "o|3Q|1T|1T|2p|hq", "a|3N|3O|3P|hj|3T|3U|3V|3W|3Z|hm|hp|hr", "A link to a component reference or to a URL", "o|F|1c|9U|9V|3l|hi|hs|3M|3M|2p|1c|ht|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|ax|Rw|b3|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point with coordinates that can be displayed and dragged on a graph", "o|F|1d|RR|RS|Op|hv|hw|3M|3M|2p|1d|hx|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1e|2p|6e", "Whether tuple-like expressions render as vectors (always true for `<coords>`).", "o|3Q|4q|1V|2p|i1", "a|3N|3O|3P|66|67|68|69|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|i0|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|i2|7S|7V|7Y|7b", "A math expression treated as a vector of coordinates", "o|F|1e|3j|3k|3l|hz|i3|3M|3M|2p|1e|i4|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "A line through two points or defined by an equation", "o|F|1f|TV|TW|Op|i6|i7|3M|3M|2p|1f|i8|Az", "Whether the line segment can be dragged on a graph.", "o|2m|5L|iA|3M|2s|1V", "endpointsDraggable", "Whether the line segment's endpoints can be dragged.", "o|Ap|iC|iD|2s|1V", "endpoints", "The two endpoints of the line segment.", "o|2h|iF|iG|2W", "a|iF|42|2q|2r", "Show control handles for both endpoints of the segment.", "o|3s|iF|iJ", "a|iK|Sa", "o|Bi|ST|SU|iF|iI|iL|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|iB|iE|iH|iM|P4|UB|H8|4Y|4c|4g|4j|So", "o|3L|5L|1V|2p|iA|3M", "A textual description of the line segment's style.", "o|3Q|Hl|1T|2p|iP", 'Style description including "line segment".', "o|3Q|Ho|1T|2p|iR", "Whether each endpoint can be dragged independently.", "o|3Q|iC|1V|2p|iT", "Number of dimensions the segment lives in.", "o|3Q|6r|1p|2p|iV", "The endpoints of the line segment.", "o|Qc|iF|1X|3M|iX|4X|IM|Qf", "The length of the line segment.", "o|3Q|Qh|1X|2p|iZ", "The slope of the line segment (2D only).", "o|3Q|Te|1p|2p|ib", "a|3N|3O|3P|Hd|QD|7s|QE|iO|Sy|QG|UG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|iQ|iS|iU|iW|iY|ia|ic", "A line segment between two endpoints", "o|F|8n|Om|On|Op|iN|id|3M|2p|2p|8n|ie|Az", "Whether the ray can be dragged on a graph.", "o|2m|5L|ig|3M|2s|1V", "The starting point (endpoint) of the ray.", "o|2h|2K|ii|1d", "A point the ray passes through (used with endpoint or direction).", "o|2h|Gr|ik|1d", "direction", "The direction the ray points in.", "o|2h|im|in|1h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|ih|ij|il|io|UB|H8|4Y|4c|4g|4j", "o|3L|5L|1V|2p|ig|3M", "A textual description of the ray's style.", "o|3Q|Hl|1T|2p|ir", 'Style description including the word "ray".', "o|3Q|Ho|1T|2p|it", "Number of dimensions the ray lives in.", "o|3Q|6r|1p|2p|iv", "The direction vector of the ray.", "o|6v|im|1X|3M|ix|36|6z", "A point the ray passes through.", "a|Qe", "o|Qc|Gr|1X|3M|iz|36|IY|j0", "The starting endpoint of the ray.", "o|Qc|2K|1X|3M|j2|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|iq|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|is|iu|iw|iy|j1|j3", "A ray starting at one point passing through another", "o|F|8o|Om|On|Op|ip|j4|3M|2p|2p|8o|j5|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j", "The number of vertices in the polyline.", "o|3Q|RD|1p|2p|j8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|j9|Qa|Qg|Qj|Ql", "A polyline (open polygon) defined by a list of vertices", "o|F|8p|Om|On|Op|j7|jA|3M|2p|2p|8p|jB|Az", "Whether to render interactive vertex control handles.", "a|5b|42|2q|2r", "Show a control handle for moving the polygon's center.", "o|3s|5b|jF", "a|jG|Sa", "o|Bi|ST|jD|5b|jE|jH|3y", "filled", "Whether to fill the interior of the polygon.", "o|2m|jJ|jK|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|jI|jL|So", "o|3L|ST|1T|2p|jD|3M", "o|3L|jJ|1V|2p|jK|3M", "A textual description of the polygon's style.", "o|3Q|Hl|1T|2p|jP", 'Style description including the word "polygon".', "o|3Q|Ho|1T|2p|jR", "borderStyleDescription", "A textual description of the polygon's border style.", "o|3Q|jT|1T|2p|jU", "fillStyleDescription", "A textual description of the polygon's fill style.", "o|3Q|jW|1T|2p|jX", "perimeter", "The perimeter of the polygon.", "o|3Q|jZ|1p|2p|ja", "area", "The area enclosed by the polygon.", "o|3Q|jc|1p|2p|jd", "numSides", "The number of sides of the polygon.", "o|3Q|jf|1p|2p|jg", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|j9|Qa|Qg|Ql|jV|jY|jb|je|jh", "A polygon defined by a list of vertices", "o|F|8q|Om|On|Op|jM|ji|3M|2p|2p|8q|jj|Az", "The number of vertices (always 3 for a triangle).", "o|3Q|RD|1p|2p|jl", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|jm|Qa|Qg|Ql|jV|jY|jb|je|jh", "A triangle defined by three vertices", "o|F|8r|Om|On|Op|jM|jn|3M|2p|2p|8r|jo|Az", "centerWidthAndHeight", "widthAndHeight", "a|5b|jr|jq|42|2q|2r", "Show a single control handle for moving the rectangle's center.", "o|3s|5b|jt", "Show control handles for resizing width and height.", "o|3s|jr|jv", "Show control handles for both moving the center and resizing.", "o|3s|jq|jx", "a|ju|jw|jy|Sa", "o|Bi|ST|SU|jq|js|jz|3y", "The rectangle's center point.", "o|2h|5b|k1|1d", "The rectangle's width.", "o|2h|bx|k3|1p", "height", "The rectangle's height.", "o|2h|k5|k6|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|k0|jL|So|k2|k4|k7", "The number of vertices (always 4 for a rectangle).", "o|3Q|RD|1p|2p|k9", "The four corner vertices of the rectangle.", "o|Qc|Oz|1X|3M|kB|4X|IM|Qf", "The rectangle's center coordinates.", "o|6v|5b|1X|3M|kD|36|IY", "o|3Q|bx|1p|2p|k3", "o|3Q|k5|1p|2p|k6", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|kA|Qa|kC|kE|jV|jY|jb|je|kF|kG|jh", "A rectangle, potentially defined by width, height, center and/or corner vertices", "o|F|8s|Om|On|Op|k8|kH|3M|2p|2p|8s|kI|Az", "centerAndRadius", "radius", "a|5b|kL|kK|42|2q|2r", "Show a control handle for resizing the polygon's radius.", "o|3s|kL|kN", "Show control handles for both moving the center and resizing the radius.", "o|3s|kK|kP", "a|jG|kO|kQ|Sa", "o|Bi|ST|SU|kK|kM|kR|3y", "Number of vertices in the regular polygon.", "o|33|RD|kT|4S|1q", "Number of sides in the regular polygon (alias for numVertices).", "o|2h|jf|kV|1q", "Center of the regular polygon.", "o|2h|5b|kX|1d", "circumradius", "Distance from center to a vertex (circumscribed-circle radius).", "o|2h|kZ|ka|1p", "Alias for circumradius.", "o|2h|kL|kc|1p", "inradius", "Distance from center to the midpoint of a side (inscribed-circle radius).", "o|2h|ke|kf|1p", "apothem", "Alias for inradius.", "o|2h|kh|ki|1p", "sideLength", "Length of each side of the regular polygon.", "o|2h|kk|kl|1p", "Total perimeter of the regular polygon.", "o|2h|jZ|kn|1p", "Total area enclosed by the regular polygon.", "o|2h|jc|kp|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|kS|jL|So|kU|kW|kY|kb|kd|kg|kj|km|ko|kq", "Whether to preserve similarity when dragging.", "o|3Q|P8|1V|2p|ks", "The number of vertices (sides) of the regular polygon.", "o|3Q|RD|1q|2p|ku", "The center coordinates of the regular polygon.", "o|6v|5b|1X|3M|kw|36|IY", "The radius of the circumscribed circle.", "o|3Q|kZ|1p|2p|ky", "The radius of the inscribed circle.", "o|3Q|ke|1p|2p|l0", "The length of each side.", "o|3Q|kk|1p|2p|l2", "The number of sides of the regular polygon.", "o|3Q|jf|1q|2p|l4", "Distance from center to a vertex (alias for circumradius).", "o|3Q|kL|1p|2p|l6", "Distance from center to the midpoint of a side (alias for inradius).", "o|3Q|kh|1p|2p|l8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|kt|QW|QY|kv|Qa|Qg|kx|jV|jY|jb|je|kz|l1|l3|l5|l7|l9", "A regular polygon with a given number of sides", "o|F|8t|Om|On|Op|kr|lA|3M|2p|2p|8t|lB|Az", "Points the circle passes through.", "o|2h|Gr|lD|2W", "The circle's center point.", "o|2h|5b|lF|1d", "The circle's radius.", "o|2h|kL|lH|1X", "Whether to render interactive control handles on the circle.", "Show a control handle for moving the circle's center.", "o|3s|5b|lK", "Show a control handle for resizing the circle's radius.", "o|3s|kL|lM", "a|lL|lN|kQ|Sa", "o|Bi|ST|lJ|kK|kM|lO|3y", "Whether to fill the interior of the circle.", "o|2m|jJ|lQ|2p|2s|1V", "Whether to suppress the indicator drawn at the edge when the component is off-screen.", "o|Ap|Sj|lS|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|lE|WQ|WS|H8|4Y|4c|4g|4j|lG|lI|lP|lR|lT|So", "o|3L|ST|1T|2p|lJ|3M", "o|3L|jJ|1V|2p|lQ|3M", "A textual description of the circle's style.", "o|3Q|Hl|1T|2p|lX", 'Style description including the word "circle".', "o|3Q|Ho|1T|2p|lZ", "A textual description of the circle's border style.", "o|3Q|jT|1T|2p|lb", "A textual description of the circle's fill style.", "o|3Q|jW|1T|2p|ld", "Whether to suppress the off-graph indicator when the circle is outside the visible area.", "o|3Q|Sj|1V|2p|lf", "Maximum value of the curve parameter (always 2π for a circle).", "o|3Q|WM|1p|2p|lh", "Minimum value of the curve parameter (always 0 for a circle).", "o|3Q|WJ|1p|2p|lj", "Points the circle is constrained to pass through.", "o|Qc|Wo|1X|3M|ll|4X|IM|Qf", "The radius of the circle.", "o|3Q|kL|1X|2p|ln", "diameter", "The diameter of the circle.", "o|3Q|lp|1X|2p|lq", "circumference", "The circumference of the circle.", "o|3Q|ls|1X|2p|lt", "The area enclosed by the circle.", "o|3Q|jc|1X|2p|lv", "The center coordinates of the circle.", "o|Qc|5b|1X|3M|lx|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|lV|lW|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|lY|la|lc|le|lg|li|lk|lm|lo|lr|lu|lw|ly", "A circle, potentially defined by center, radius, and/or points on the circle", "o|F|8u|TV|TW|Op|lU|lz|3M|3M|2p|8u|m0|Az", "Points the parabola passes through.", "o|2h|Gr|m2|2W", "The vertex of the parabola.", "o|33|PI|m4||1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|m3|WQ|WS|H8|4Y|4c|4g|4j|m5", 'Style description including the word "parabola".', "o|3Q|Ho|1T|2p|m7", "Maximum value of the parabola's parameter.", "o|3Q|WM|1p|2p|m9", "Minimum value of the parabola's parameter.", "o|3Q|WJ|1p|2p|mB", "o|6v|Wo|1X|3M|m2|4X|IM", "a", "The leading coefficient of the parabola (in y = a x^2 + b x + c).", "o|3Q|mE|1p|2p|mF", "b", "The linear coefficient in y = a x^2 + b x + c.", "o|3Q|mH|1p|2p|mI", "The constant term in y = a x^2 + b x + c.", "o|3Q|15|1p|2p|mK", "The vertex coordinates of the parabola.", "o|6v|PI|1X|3M|mM|36|IY", "The parabola's equation as a math expression.", "o|3Q|TZ|1X|2p|mO", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|m8|mA|mC|mD|mG|mJ|mL|mN|mP", "A parabola defined by formula or geometric parameters", "o|F|8v|TV|TW|Op|m6|mQ|3M|3M|2p|8v|mR|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "A curve defined by a function, parametric formulas, or control points", "o|F|8w|Ut|Uu|Op|mT|mU|3M|3M|2p|8w|mV|Az", "a|Wx|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02122221111111111111111111111222222222122220222212222201221222122222122221212222", "alwaysVisible", "Whether Bezier control handles are always shown (rather than only when the curve is selected).", "o|2m|mZ|ma|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|mb", "o|3L|mZ|1V|2p|ma|3M", "a|3N|3O|3P|md|3T|3U|3V|3W|3Z", "Defines Bezier control vectors at points along a curve", "o|F|1g|mX|mY|3l|mc|me|3M|3M|2p|1g|mf|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1O|1X|1Y|1Z|1e|1h|1t|1u|1z|21|24|29|2A|2O|2U|2X|2Y|L|M|N|Q|w|x|y|z|1J|1K|1L|1M|1N|1R|1S|1T|1U|1a|1d|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2K|2Q|2V|2W", "1111111111111111111111110221012221211122222222222222222222222222222222222222222", "Whether the order of vectors in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|mj|2p|2s|1V", "Maximum number of vectors to retain in the list.", "o|33|g7|ml|9k|1p", "Direction in which the control vectors apply at the vertex.", "symmetric", "previous", "next", "a|mo|mp|mq|SV|42", "Mirror the control vector on both sides of the vertex.", "o|3s|mo|ms", "Apply the control vector toward the previous segment only.", "o|3s|mp|mu", "Apply the control vector toward the next segment only.", "o|3s|mq|mw", "Apply independent control vectors to both adjacent segments.", "o|3s|SV|my", "No control vector at this vertex.", "o|3s|42|n0", "a|mt|mv|mx|mz|n1", "o|Bi|im|mn|mo|mr|n2|3y", "pointNumber", "1-based index of the vertex these control vectors attach to.", "o|33|n4|n5||1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr|n3|n6", "o|3L|g7|1p|2p|ml|3M", "o|3L|im|1T|2p|mn|3M", "o|3L|n4|1p|2p|n5|3M", "numVectors", "The number of vectors in the list.", "o|3Q|nB|1p|2p|nC", "o|3Q|gI|1p|2p|nC", "a|3N|3O|n8|n9|nA|3Z|gy|nD|nE", "Bezier control vectors at points defining a curve (used inside `<bezierControls>`)", "o|F|Wx|mh|mi|g0|n7|nF|2p|3M|2p|Wx|nG|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "1120111111111111111111111111102201012212111122222220122222222222222222222222222222", "Whether the vector can be dragged on a graph.", "o|2m|5L|nK|3M|2s|1V", "headDraggable", "Whether the vector's head can be dragged.", "o|Ap|nM|nN|2s|1V", "tailDraggable", "Whether the vector's tail can be dragged.", "o|Ap|nP|nQ|2s|1V", "The first component (x) of the vector's displacement.", "o|2h|7Q|nS|1X", "The second component (y) of the vector's displacement.", "o|2h|7T|nU|1X", "The third component (z) of the vector's displacement.", "o|2h|7W|nW|1X", "The vector's displacement components as a list.", "o|2h|S5|nY|1Y", "displacement", "The vector's displacement (head minus tail).", "o|2h|na|nb|1e", "head", "The head (tip) point of the vector.", "o|2h|nd|ne|1d", "tail", "The tail (base) point of the vector.", "o|2h|ng|nh|1d", "headAndTail", "headOnly", "tailOnly", "a|na|nj|nk|nl|42|2q|2r", "Show a control handle for translating the whole vector.", "o|3s|na|nn", "Show control handles for both the head and the tail.", "o|3s|nj|np", "Show a control handle only at the head.", "o|3s|nk|nr", "Show a control handle only at the tail.", "o|3s|nl|nt", "a|no|nq|ns|nu|Sa", "o|Bi|ST|SU|na|nm|nv|3y", "displayWithAngleBrackets", "Whether to display the vector with angle brackets (e.g. ⟨1,2⟩).", "o|2m|nx|ny|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|nL|nO|nR|nT|nV|nX|nZ|nc|nf|ni|nw|UB|H8|4Y|4c|4g|4j|nz|P4|So", "o|3L|5L|1V|2p|nK|3M", "o|3L|nx|1V|2p|ny|3M", "A textual description of the vector's style.", "o|3Q|Hl|1T|2p|o3", 'Style description including the word "vector".', "o|3Q|Ho|1T|2p|o5", "Whether the vector's tail can be dragged independently.", "o|3Q|nP|1V|2p|o7", "Whether the vector's head can be dragged independently.", "o|3Q|nM|1V|2p|o9", "Number of dimensions of the vector.", "o|3Q|6r|1p|2p|oB", "The displacement (head − tail) of the vector.", "o|Qc|na|1X|3M|oD|36|6z|j0", "Coordinates of the vector's head.", "o|Qc|nd|1X|3M|oF|36|IY|j0", "Coordinates of the vector's tail.", "o|Qc|ng|1X|3M|oH|36|IY|j0", "magnitude", "The magnitude (length) of the vector.", "o|3Q|oJ|1X|2p|oK", "The vector rendered as a LaTeX string.", "o|3Q|2V|2V|2p|oM", "o|3Q|7Q|1X|2p|nS", "o|3Q|7T|1X|2p|nU", "o|3Q|7W|1X|2p|nW", "a|3N|3O|3P|Hd|QD|7s|QE|o1|Sy|UG|o2|QG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|o4|o6|o8|oA|oC|oE|oG|oI|oL|oN|oO|oP|oQ", "A geometric vector with tail and head", "o|F|1h|nI|nJ|Op|o0|oR|3M|3M|2p|1h|oS|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1120111111111111111111111112122022210112221222221222112222222222222222222222222222", "Radius of the rendered angle arc.", "1", "o|5H|1X|oX", "o|33|kL|oW|oY|1X", "chooseReflexAngle", "How to handle reflex angles.", "never", "allowed", "always", "a|oc|od|oe", "Always normalize to the non-reflex angle (less than 180°).", "o|3s|oc|og", "Use a reflex angle (greater than 180°) if it matches the input.", "o|3s|od|oi", "Always render the angle as a reflex angle.", "o|3s|oe|ok", "a|oh|oj|ol", "o|Bi|oa|ob|oc|of|om|3y", "inDegrees", "Whether to interpret and display the angle in degrees rather than radians.", "o|2m|oo|op|2p|2s|1V", "radians", "The angle measure in radians.", "o|2h|or|os|1X", "degrees", "The angle measure in degrees.", "o|2h|ou|ov|1X", "Three points (vertex in the middle) defining the angle.", "o|2h|Gr|ox|2W", "betweenLines", "Two lines whose intersection forms the angle.", "_lineListComponent", "o|2h|oz|p0|p1", "emphasizeRightAngle", "Whether to render right angles with the conventional square symbol.", "o|2m|p3|p4|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|oZ|on|oq|ot|ow|oy|p2|H8|4Y|4c|4g|4j|p5", "o|3L|kL|1X|2p|oW|3M", "o|3L|oa|1T|2p|ob|3M", "o|3L|oo|1V|2p|op|3M", "o|3L|p3|1V|2p|p4|3M", "o|3Q|or|1X|2p|os", "o|3Q|ou|1X|2p|ov", "o|3Q|3a|1X|2p|os", "o|3Q|1i|1X|2p|os", "a|3N|3O|3P|Hd|QD|7s|QE|p7|p8|p9|pA|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|pB|pC|pD|pE", "An angle defined by three points or a measure", "o|F|1i|oU|oV|Op|p6|pF|3M|3M|2p|1i|pG|Az", "considerAsResponses", "a|8x|1z|1R|1S|1k|1l|1m|1n|pI|I|J|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2T", "021111110110001222211111111111111111111112221222221000010212220012212221222221112212112221111111110011", "Relative weight of this answer when aggregating credit across multiple answers.", "answer-grading", "o|4U|9c|pL|pM|36|1p", "handGraded", "Whether this answer is graded by hand rather than automatically.", "o|4d|pO|pP|pM|2p|2s|1V", "matchPartial", "Whether to award partial credit when the response is partially correct.", "o|4d|pR|pS|pM|2p|2s|1V", "Maximum number of times the response can be submitted.", "o|4U|9i|pU|pM|9k|1q", "Whether to display whether the submitted response is correct.", "o|4d|9m|pW|pM|3M|2s|1V", "Whether to color-code the response based on its correctness.", "o|4d|9p|pY|pM|3M|2s|1V", "disableAfterCorrect", "Whether to disable the answer after a fully correct response has been submitted.", "o|4d|pa|pb|pM|2p|2s|1V", "Label for the submit button when correctness is shown.", "o|4U|9v|pd|pM|9x|1T", "Label for the submit button when correctness is not shown.", "o|4U|9z|pf|pM|A1|1T", "displayDigitsForResponses", "Number of significant digits to display when rendering numeric responses.", "o|4U|ph|pi|pM|Nn|1q", "o|4U|A3|A4|pM|4S|1q", "a|3|2f|3m|2k|2l|2g", "Whether to render the answer's input inline rather than as a block.", "o|pl|3h|pm|3M|2p|2s|1V", "Whether comparison uses symbolic equality (rather than numeric evaluation).", "o|pl|Bc|po|3M|2p|2s|1V", "forceFullCheckWorkButton", "Whether to always render a full-size check-work button.", "o|2m|pq|pr|2p|2s|1V", "forceSmallCheckWorkButton", "Whether to always render a small check-work button.", "o|2m|pt|pu|2p|2s|1V", "Level of simplification applied to math expressions before comparing them.", "o|Bi|Bj|pw|42|47|Bp|3y", "Whether to expand math expressions before comparing them.", "o|2m|Bf|py|2p|2s|1V", "Whether order is ignored when comparing list-like responses.", "o|2m|Br|q0|2p|2s|1V", "Whether to match list responses by exact position rather than by content.", "o|2m|Bu|q2|2p|2s|1V", "numAwardsCredited", "Maximum number of matching awards whose credits are summed.", "o|33|q4|q5|36|1q", "colorInputsSeparately", "Attempt to color each input separately based on the awards that reference it, rather than all inputs sharing the same overall credit color.", "o|2m|q7|q8|2p|2s|1V", "Maximum allowed numeric error when comparing numbers (relative or absolute).", "o|33|Bx|qA|5Q|1p", "Type of input the answer expects.", "videoWatched", "a|1X|1T|1V|qD", "Expect a math expression answer.", "o|3s|1X|qF", "Expect a text answer.", "o|3s|1T|qH", "Expect a boolean answer.", "o|3s|1V|qJ", "Mark correct when the associated video has been watched.", "o|3s|qD|qL", "a|qG|qI|qK|qM", "o|Bi|2g|qC||qE|qN|3y", "selectMultiple", "For choice answers: whether multiple choices may be selected.", "o|2m|qP|qQ|2p|2s|1V", "shuffleOrder", "For choice answers: whether to display choices in randomized order.", "o|2m|qS|qT|2p|2s|1V", "preserveLastChoice", "For choice answers: whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|qW|2p|2s|1V", "disableWrongChoices", "Whether incorrect choices are disabled after being submitted.", "o|2m|qY|qZ|2p|2s|1V", "creditByAttempt", 'Per-attempt credit multipliers (e.g. "1 0.7 0.5" for full/70%/50% on attempts 1/2/3+).', "o|33|qb|qc|54|1a", "Whether multi-character symbols should be split into a product of single-character variables when parsing.", "o|2m|56|qe|3M|2s|1V", "expanded", "Whether the answer's submitted-response panel is expanded by default.", "o|2m|qg|qh|2p|2s|1V", "showPreview", "Whether to display a preview of the response as the student types.", "o|2m|qj|qk|2p|2s|1V", "Reference to a video; when watched, this answer's videoWatched type marks credit.", "o|2h|9D|qm|3D", "videoCreditLabel", "Label shown next to the credit indicator for a video-watched answer.", "o|2h|qo|qp|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|pn|pp|ps|pv|px|pz|q1|q3|q6|q9|qB|C2|C5|C8|CB|CE|CH|qO|qR|qU|qX|qa|qd|qf|5B|qi|ql|qn|qq|GH", "o|6J|9c|1p|2p|pL|3M|pM", "o|6J|pO|1V|2p|pP|3M|pM", "o|6J|pR|1V|2p|pS|3M|pM", "o|6J|9i|1q|2p|pU|3M|pM", "o|6J|pa|1V|2p|pb|3M|pM", "o|6J|9v|1T|2p|pd|3M|pM", "o|6J|9z|1T|2p|pf|3M|pM", "o|6J|ph|1q|2p|pi|3M|pM", "o|6J|A3|1q|2p|A4|3M|pM", "o|65|3h|1V|2p|pm|3M|3M", "o|65|Bc|1V|2p|po|3M|3M", "o|3L|pq|1V|2p|pr|3M", "o|3L|pt|1V|2p|pu|3M", "o|3L|Bj|1T|2p|pw|3M", "o|3L|Bf|1V|2p|py|3M", "o|3L|Br|1V|2p|q0|3M", "o|3L|Bu|1V|2p|q2|3M", "o|3L|q4|1q|2p|q5|3M", "o|3L|q7|1V|2p|q8|3M", "o|3L|Bx|1p|2p|qA|3M", "o|3L|qP|1V|2p|qQ|3M", "o|3L|qS|1V|2p|qT|3M", "o|3L|qV|1V|2p|qW|3M", "o|3L|qY|1V|2p|qZ|3M", "o|3L|qb|1a|2p|qc|3M", "o|3L|56|1V|2p|qe|3M", "o|3L|qg|1V|2p|qh|3M", "o|3L|qj|1V|2p|qk|3M", "The fraction of credit achieved on the most recent submission (between 0 and 1).", "o|3Q|AL|1p|2p|rK", "responseHasBeenSubmitted", "Whether a response has ever been submitted for this answer.", "o|3Q|rM|1V|2p|rN", "justSubmitted", "Whether the most recent submission for this answer has not yet been changed.", "o|3Q|rP|1V|2p|rQ", "Total number of times a response has been submitted.", "o|3Q|AD|1q|2p|rS", "Remaining number of submission attempts before the maximum is reached.", "o|3Q|AG|1q|2p|rU", "Whether this answer is disabled and is no longer accepting submissions.", "o|3Q|2u|1V|2p|rW", "Whether any input within this answer currently has keyboard focus.", "o|3Q|eQ|1V|2p|rY", "numResponses", "The number of current (unsubmitted) response values from this answer's inputs.", "o|3Q|ra|1p|2p|rb", "a|3|3J|2f|6r|6u", "currentResponses", "The current (unsubmitted) response values from this answer's inputs.", "a|3J|6r", "o|rg|3M|36", "a|rh", "o|rd|re|3M|rf|36|ri", "numSubmittedResponses", "The number of response values from the most recent submission.", "o|3Q|rk|1p|2p|rl", "submittedResponses", "The response values from the most recent submission.", "o|rd|rn|3M|ro|36|ri", "numFeedbacks", "The number of feedback messages produced by matched awards or applicable feedback definitions.", "o|3Q|rq|1p|2p|rr", "feedbacks", "The feedback messages produced by matched awards or applicable feedback definitions.", "o|73|3M|9F|36", "a|rv", "o|6v|rt|9F|3M|ru|36|rw", "a|3|3J|2f", "currentResponse", "The current (unsubmitted) response value from the answer's first input.", "o|ry|rz|2p|s0", "submittedResponse", "The first response value from the most recent submission.", "o|ry|s2|2p|s3", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|r1|r2|r3|r4|r5|r6|r7|r8|r9|rA|rB|CP|CQ|CR|CS|CT|CU|rC|rD|rE|rF|rG|rH|6E|rI|rJ|Hd|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|Hk|rZ|rc|rj|rm|rp|rs|rx|s1|s4", "answer1", "Assigns credit to student responses based on matches or logical rules", "o|F|1j|pJ|pK|3l|qr|s5|3M|2p|2p|s6|s7|3h", "when", "a|s9|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "02122221111111111111111111111222122222122020222212222201221222122222111221211222221111111110212120", "credit", "Fraction of credit (0 to 1) granted when this award matches.", "o|33|sC|sD|36|1p", "o|2m|pR|pS|2p|2s|1V", "o|2m|Bc|po|2p|2s|1V", "feedbackCodes", "Codes that select reusable feedback messages when this award matches.", "o|33|sH|sI|54|1U", "feedbackText", "Custom feedback text shown when this award matches.", "o|33|sK|sL||1T", "referencesAreResponses", "References to components whose values should be treated as responses for this award.", "o|2h|sN|sO|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|sE|sF|sG|pz|px|q1|q3|qB|C2|C5|C8|CB|CE|CH|sJ|sM|sP|qf|5B", "o|3L|sC|1p|2p|sD|3M", "o|3L|pR|1V|2p|pS|3M", "o|3L|Bc|1V|2p|po|3M", "o|3L|sH|1U|2p|sI|3M", "o|3L|sK|1T|2p|sL|3M", "creditAchievedIfSubmit", "Credit (0 to 1) this award would grant if submitted with the current response.", "o|3Q|sW|1p|2p|sX", "fractionSatisfiedIfSubmit", "Fraction (0 to 1) by which this award's match condition is currently satisfied.", "o|3Q|sZ|1p|2p|sa", "fractionSatisfied", "Fraction (0 to 1) by which this award's match condition was satisfied at last submission.", "o|3Q|sc|1p|2p|sd", "Credit (0 to 1) this award granted at the last submission.", "o|3Q|AL|1p|2p|sf", "awarded", "Whether this award was matched at the last submission.", "o|3Q|sh|1V|2p|si", "The number of feedback messages associated with this award.", "o|3Q|rq|1p|2p|sk", "The feedback messages produced by this award.", "o|6v|rt|9F|3M|sm|36|rw", "The first feedback message produced by this award.", "o|3Q|9F|9F|2p|so", "a|3N|3O|3P|sR|sS|sT|r6|r5|r7|r8|rB|CP|CQ|CR|CS|CT|CU|sU|sV|rH|6E|3T|3U|3V|3W|3Z|sY|sb|se|sg|sj|sl|sn|sp", "Specifies conditions for awarding credit in an answer", "o|F|8x|sA|sB|Ao|sQ|sq|3M|3M|2p|8x|sr|Az", "Whether to match partial conditions for partial credit.", "o|2m|pR|st|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|su", "o|3L|pR|1V|2p|st|3M", "Whether the condition is currently true.", "o|3Q|3a|1V|2p|sx", "Fraction of the boolean condition that is satisfied (0 to 1).", "o|3Q|sc|1p|2p|sz", "Whether the condition is currently satisfied; equivalent to value.", "o|3Q|Au|1V|2p|t1", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|sw|3T|3U|3V|3W|3Z|sy|t0|t2|CW", "Defines logical conditions within an `<award>`", "o|F|s9|BY|BZ|3l|sv|t3|2p|3M|2p|s9|t4|3h", "Initial value displayed in the input.", "o|33|Zj|t6|5J|1X", "prefillLatex", "Initial value as a LaTeX string.", "o|33|t8|t9|AZ|2V", "o|Bi|3p|3q|1T|3r|3x|3y", "additionalFunctionNames", "Extra identifiers to auto-format as function names in the editor (e.g., 'erf'). Entries that also appear in `removedFunctionNames` are dropped.", "o|33|tC|tD|54|1U", "removedFunctionNames", "Built-in function names to stop auto-formatting in the editor (e.g., 'min' so 'kg/min' can be typed as a unit).", "o|33|tF|tG|54|1U", "resetFunctionNames", "When set, replaces the entire auto-formatted function name list (defaults, `additionalFunctionNames`, and `removedFunctionNames` are all ignored). Set to an empty value to disable auto-formatting entirely.", "o|33|tI|tJ||1U", "Whether multi-character symbols are split into a product of single-character variables.", "o|2m|56|tL|3M|2s|1V", "hideNaN", "Whether to hide NaN values when displaying the input.", "o|2m|tN|tO|3M|2s|1V", "removeStrings", "Substrings to strip from the input before parsing.", "o|33|tQ|tR||1U", "minWidth", "Minimum rendered width of the input.", "n|o", "o|33|tT|tU|tV|1q", "Whether to display a preview of the parsed math.", "o|2m|qj|tX|2p|2s|1V", "Whether the input can be dragged on a graph.", "o|2m|5L|tZ|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|t7|tA|tB|51|tE|tH|tK|tM|5B|e7|4Y|e8|4g|4j|eB|eE|tP|tS|tW|tY|ta|5X|63", "o|3L|Zj|1X|2p|t6|3M", "o|3L|t8|2V|2p|t9|3M", "o|3L|3p|1T|2p|3q|3M", "o|3L|tC|1U|2p|tD|3M", "o|3L|tF|1U|2p|tG|3M", "o|3L|tI|1U|2p|tJ|3M", "o|3L|56|1V|2p|tL|3M", "o|3L|tN|1V|2p|tO|3M", "o|3L|tT|1q|2p|tU|3M", "o|3L|5L|1V|2p|tZ|3M", "Whether this input currently has keyboard focus.", "o|3Q|eQ|1V|2p|tm", "o|3Q|qj|1V|2p|tX", "The math value of the input.", "o|3Q|3a|1X|2p|tp", "The math value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|tr", "The current input as a text string.", "o|3Q|1T|1T|2p|tt", "rawRendererValue", "The raw value used by the renderer (e.g. LaTeX string).", "o|3Q|tv|2V|2p|tw", "a|3N|3O|3P|eJ|Hd|tc|td|te|6C|tf|tg|th|ti|6E|eN|tj|tk|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6X|6Y|6Z|6a|6b|6W|to|eV|tq|eY|ts|tu|tx|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "An interactive math input", "o|F|1k|ep|eq|dh|tb|ty|3M|3M|2p|1k|tz|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2T|2U|2V|2X", "112000222222222222222222222222222222222222122202222222222222222222222112222212", "Initial text shown in the input before the user types.", "o|33|Zj|u3|AZ|1T", "o|2h|e9|eA|1T", "Whether the input renders as a multi-line text area.", "o|2m|qg|u6|2p|2s|1V", "Display width of the input.", "o|2h|bx|u8|bz", "Display height of the input.", "size", "isAbsolute", "a|uB|uC", "n|1w", "o|uD|uE|3M", "o|33|k5|uA|uF|bz", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|u4|u5|u7|u9|uG|ta|5X|63", "o|3L|Zj|1T|2p|u3|3M", "o|3L|qg|1V|2p|u6|3M", "o|3L|k5|bz|2p|uA|3M", "o|3Q|bx|bz|2p|u8", "The text value of the input.", "o|3Q|3a|1T|2p|uM", "The text value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|uO", "The current text as a plain text string.", "o|3Q|1T|1T|2p|uQ", "a|3N|3O|3P|eJ|Hd|uI|uJ|uK|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|eV|eY|6W|uL|uN|uP|uR|Jp|Ju|Jx|K0|K2|K4", "An interactive text input", "o|F|1l|u1|u2|dh|uH|uS|3M|3M|2p|1l|uT|3h", "a|I|J|1z|2S|2f|dd|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|2R|2T|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11200011111111102211122221111111111111111111111222222222122220222212222201221222122222122221212222", "o|Bi|GL|di|5i|dj|do|3y", "The initial value of the input before the student interacts.", "o|2m|Zj|uY|2p|2s|1V", "asToggleButton", "Whether to render the input as a toggle button rather than a checkbox.", "o|2m|ua|ub|2p|2s|1V", "o|Ap|e9|eA|2s|1V", "Whether the input can be dragged on a graph by its anchor.", "o|2m|5L|ue|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|uX|ds|GH|uZ|uc|ud|uf|5X|63", "o|3L|Zj|1V|2p|uY|3M", "o|3L|ua|1V|2p|ub|3M", "o|3L|5L|1V|2p|ue|3M", "Whether the input's value has been changed from its prefill value.", "o|3Q|eT|1V|2p|uk", "The current boolean value of the input.", "o|3Q|3a|1V|2p|um", 'The current value rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|uo", "a|3N|3O|3P|eJ|Hd|uh|ui|uj|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6W|ul|un|up", "An interactive boolean (toggle/checkbox) input", "o|F|1m|uV|uW|dh|ug|uq|3M|3M|2p|1m|ur|3h", "a|I|J|1z|2S|2f|dd|1o", "Whether multiple choices may be selected.", "o|2m|qP|uu|2p|2s|1V", "Whether to award partial credit when only some correct choices are selected.", "o|2m|pR|uw|2p|2s|1V", "Whether to render the input inline (as a dropdown) rather than as a list of choices.", "o|2m|3h|uy|2p|2s|1V", "Whether to display the choices in randomized order.", "o|2m|qS|v0|2p|2s|1V", "Whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|v2|2p|2s|1V", "preselectChoice", "Index of a choice to pre-select on initial render.", "o|33|v4|v5||1p", "placeHolder", "Placeholder text shown when no choice is selected.", "o|33|v7|v8|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|uv|ux|uz|v1|v3|v6|u5|v9", "o|3L|qP|1V|2p|uu|3M", "o|3L|pR|1V|2p|uw|3M", "o|3L|qS|1V|2p|v0|3M", "o|3L|qV|1V|2p|v2|3M", "Whether the input is rendered inline (as a dropdown).", "o|3Q|3h|1V|2p|vF", "numChoices", "The number of choices available in the input.", "o|3Q|vH|1p|2p|vI", "choiceTexts", "The text contents of all choices in displayed order.", "o|6v|vK|1T|3M|vL|36|Jt", "choiceMaths", "The math expressions of all choices in displayed order.", "o|6v|vN|1X|3M|vO|36|75", "Whether the input's selection has been changed from its initial state.", "o|3Q|eT|1V|2p|vQ", "selectedIndices", "Indices (1-based) of the currently selected choices.", "o|6v|vS|1p|3M|vT|36|IR", "selectedValues", "Text values of the currently selected choices.", "o|rd|vV|3M|vW|36|ri", "The number of feedback messages produced by selected choices.", "o|3Q|rq|1p|2p|vY", "Feedback messages produced by selected choices.", "o|6v|rt|9F|3M|va|36|rw", "selectedIndex", "The 1-based index of the first currently selected choice.", "o|3Q|vc|1p|2p|vd", "selectedValue", "The text value of the first currently selected choice.", "o|ry|vf|2p|vg", "The text values of the currently selected choices.", "o|rd|2l|3M|vi|36|ri", "valueToRecordOnSubmit", "Indices of the currently selected choices (recorded when the answer is submitted).", "o|6v|vk|1p|3M|vl|36|IR", "a|3N|3O|3P|eJ|Hd|vB|vC|vD|vE|3T|3U|3V|3W|3Z|Hk|eP|tn|vG|vJ|vM|vP|vR|vU|vX|vZ|vb|ve|vh|vj|vm", "A multiple-choice input, allowing selection from a list of choices", "o|F|1n|ut|df|dh|vA|vn|3M|2p|2p|1n|vo|3h", "Fraction of credit (0 to 1) granted when this choice is selected.", "o|33|sC|vq|5Q|1p", "Codes that select reusable feedback messages when this choice is selected.", "o|33|sH|vs|54|1U", "Custom feedback text shown when this choice is selected.", "o|33|sK|vu||1T", "preSelect", "Whether this choice is pre-selected on initial render.", "o|2m|vw|vx|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|vr|vt|vv|vy", "o|3L|sC|1p|2p|vq|3M", "o|3L|sH|1U|2p|vs|3M", "o|3L|sK|1T|2p|vu|3M", "The choice's content as a text string.", "o|3Q|1T|1T|2p|w3", "The choice's content interpreted as a math expression.", "o|3Q|1X|1X|2p|w5", "selected", "Whether this choice is currently selected.", "o|3Q|w7|1V|2p|w8", "submitted", "Whether this choice was selected at the most recent submission.", "o|3Q|wA|1V|2p|wB", "Whether this choice is disabled (cannot be selected).", "o|3Q|2u|1V|2p|wD", "feedbacktext", "Feedback messages shown when this choice is selected.", "o|3Q|rt|wF|2p|wG", "a|3N|3O|3P|w0|w1|w2|3T|3V|3W|3Z|w4|w6|w9|wC|wE|wH", "A single choice within a `<choiceInput>` or an `<answer>`.", "o|F|1o|9U|9V|3l|vz|wI|3M|3M|2p|1o|wJ|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m", "111111111111111111111111102022210112222122222111211122222222222222222222222222222111111111021212", "renderAsMath", "Whether to render the number using math typography.", "o|2m|wN|wO|2p|2s|1V", "convertBoolean", "Whether to convert boolean inputs to 1/0 instead of NaN.", "o|2m|wQ|wR|2p|2s|1V", "valueOnNaN", "Numeric value to use when the input cannot be parsed.", "NaN", "o|33|wT|wU|wV|1p", "Whether the number can be dragged on a graph.", "o|2m|5L|wX|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j|wP|wS|wW|wY|5R|5X|63", "o|3L|wN|1V|2p|wO|3M", "o|3L|5L|1V|2p|wX|3M", "The numeric value.", "o|3Q|3a|1p|2p|wc", "The number rendered as plain text.", "o|3Q|1T|1T|2p|we", "The number's value as a math expression.", "o|3Q|1X|1X|2p|wg", "The number rendered as LaTeX.", "o|3Q|2V|2V|2p|wi", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wd|wf|wh|wj", "A numeric floating point value", "o|F|1p|wL|wM|3l|wZ|wk|3M|3M|2p|1p|wl|3h", "The integer value.", "o|3Q|3a|1q|2p|wn", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wf|wh|wj|wo", "An integer value", "o|F|1q|wL|wM|3l|wZ|wp|3M|3M|2p|1q|wq|3h", "a|I|1z|J|dd|2f|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y|9C|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|z|1L|1M|1T|1U|1V|1W|1a|1o|1p|1q|1v|25|26|27|28|2B|2C|2D|2R|2S|2T|2V|1N|1R|1S|1k|O|P|2E|2F|2G|1m|1l|8y|8z", "020001111111111111111111111122211111022211111111111111122122212222121212212111111122200111222222222122022222012222211220212220010000000", "xMin", "Minimum value displayed on the x axis.", "n|-A", "o|33|wu|wv|ww|1p", "xMax", "Maximum value displayed on the x axis.", "o|33|wy|wz|Nn|1p", "yMin", "Minimum value displayed on the y axis.", "o|33|x1|x2|ww|1p", "yMax", "Maximum value displayed on the y axis.", "o|33|x4|x5|Nn|1p", "Explicit width of the graph (overrides size).", "o|2h|bx|x7|bz", "Named size preset for the graph.", "medium", "tiny", "small", "large", "a|xB|xC|xA|xD|43", "About 1/12 the full width.", "o|3s|xB|xF", "About 30% of the full width.", "o|3s|xC|xH", "About half the full width.", "o|3s|xA|xJ", "About 70% of the full width.", "o|3s|xD|xL", "The full available width.", "o|3s|43|xN", "a|xG|xI|xK|xM|xO", "o|Bi|uB|x9|xA|xE|xP|3y", "aspectRatio", "Aspect ratio (width / height) for the graph.", "o|33|xR|xS|36|1p", "displayMode", "How to size the graph.", "a|AT|3h", "Display as a block element on its own line.", "o|3s|AT|xX", "Render inline with surrounding text.", "o|3s|3h|xZ", "a|xY|xa", "o|Bi|xU|xV|AT|xW|xb|3y", "horizontalAlign", "Horizontal alignment of the graph within its container.", "a|5b|5h|5i", "Center the graph horizontally.", "o|3s|5b|xg", "Align the graph to the left edge.", "o|3s|5h|xi", "Align the graph to the right edge.", "o|3s|5i|xk", "a|xh|xj|xl", "o|Bi|xd|xe|5b|xf|xm|3y", "identicalAxisScales", "Whether to force the x and y axis scales to be equal.", "o|2m|xo|xp|2p|2s|1V", "displayXAxis", "Whether to display the x axis.", "o|2m|xr|xs|3M|2s|1V", "displayYAxis", "Whether to display the y axis.", "o|2m|xu|xv|3M|2s|1V", "Whether to render interactive zoom/pan controls.", "all", "slidersOnly", "inputsOnly", "a|xy|xz|y0|42|2q|2r", "Render both sliders and input boxes.", "o|3s|xy|y2", "Render only slider controls.", "o|3s|xz|y4", "Render only input-box controls.", "o|3s|y0|y6", "Render no interactive controls.", "o|3s|42|y8", "a|y3|y5|y7|y9", "o|Bi|ST|xx|42|y1|yA|3y", "controlsPosition", "Position of the graph controls.", "a|5g|5h|5i|9", "Place controls below the graph.", "o|3s|5g|yF", "Place controls to the left of the graph.", "o|3s|5h|yH", "Place controls to the right of the graph.", "o|3s|5i|yJ", "Place controls above the graph.", "o|3s|9|yL", "a|yG|yI|yK|yM", "o|Bi|yC|yD|5h|yE|yN|3y", "displayXAxisTicks", "Whether to display tick marks on the x axis.", "o|2m|yP|yQ|3M|2s|1V", "displayYAxisTicks", "Whether to display tick marks on the y axis.", "o|2m|yS|yT|3M|2s|1V", "displayXAxisTickLabels", "Whether to display labels on x-axis ticks.", "o|2m|yV|yW|3M|2s|1V", "displayYAxisTickLabels", "Whether to display labels on y-axis ticks.", "o|2m|yY|yZ|3M|2s|1V", "xLabelPosition", "Position of the x-axis label.", "a|5i|5h", "Place the x-axis label at the right end of the axis.", "o|3s|5i|ye", "Place the x-axis label at the left end of the axis.", "o|3s|5h|yg", "a|yf|yh", "o|Bi|yb|yc|5i|yd|yi|3y", "xTickScaleFactor", "Scale factor applied to x-axis tick spacing.", "o|33|yk|yl||1X", "yLabelPosition", "Position of the y-axis label.", "a|9|5g", "Place the y-axis label at the top of the axis.", "o|3s|9|yq", "Place the y-axis label at the bottom of the axis.", "o|3s|5g|ys", "a|yr|yt", "o|Bi|yn|yo|9|yp|yu|3y", "yLabelAlignment", "Alignment of the y-axis label.", "Align the y-axis label to the left of the axis.", "o|3s|5h|yy", "Align the y-axis label to the right of the axis.", "o|3s|5i|z0", "a|yz|z1", "o|Bi|yw|yx|5h|dj|z2|3y", "yTickScaleFactor", "Scale factor applied to y-axis tick spacing.", "o|33|z4|z5||1X", "showNavigation", "Whether to show navigation controls (pan/zoom).", "o|2m|z7|z8|3M|2s|1V", "fixAxes", "Whether the axis limits are locked (preventing zoom/pan).", "o|2m|zA|zB|2p|2s|1V", "grid", "Grid density to render on the graph (off, minor, medium, or major).", "o|2h|zD|zE|1T", "showBorder", "Whether to render a border around the graph.", "o|2m|zG|zH|3M|2s|1V", "hideOffGraphIndicators", "Whether to suppress indicators for objects outside the visible region.", "o|2m|zJ|zK|2p|2s|1V", "decorative", "Whether the graph is purely decorative (excluded from a11y tree).", "o|2m|zM|zN|2p|2s|1V", "renderer", "Which renderer to use for the graph.", "doenet", "prefigure", "a|zR|zS", "Render using the built-in Doenet graph renderer.", "o|3s|zR|zU", "Render using the PreFigure SVG-based renderer.", "o|3s|zS|zW", "a|zV|zX", "o|Bi|zP|zQ|zR|zT|zY|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|wx|x0|x3|x6|x8|xQ|xT|xc|xn|xq|xt|xw|yB|yO|yR|yU|yX|ya|yj|ym|yv|z3|z6|z9|zC|zF|H8|4Y|4c|4g|4j|zI|zL|zO|zZ", "o|3L|xU|1T|2p|xV|3M", "o|3L|xd|1T|2p|xe|3M", "o|3L|xo|1V|2p|xp|3M", "o|3L|xr|1V|2p|xs|3M", "o|3L|xu|1V|2p|xv|3M", "o|3L|ST|1T|2p|xx|3M", "o|3L|yC|1T|2p|yD|3M", "o|3L|yP|1V|2p|yQ|3M", "o|3L|yS|1V|2p|yT|3M", "o|3L|yb|1T|2p|yc|3M", "o|3L|yk|1X|2p|yl|3M", "o|3L|yn|1T|2p|yo|3M", "o|3L|yw|1T|2p|yx|3M", "o|3L|z4|1X|2p|z5|3M", "o|3L|z7|1V|2p|z8|3M", "o|3L|zG|1V|2p|zH|3M", "o|3L|zJ|1V|2p|zK|3M", "o|3L|zM|1V|2p|zN|3M", "o|3L|zP|1T|2p|zQ|3M", "A short accessibility description of the graph.", "o|3Q|dd|1T|2p|zu", "Whether the visible axes range is locked.", "o|3Q|zA|1V|2p|zw", "The x-axis label text.", "o|3Q|I|2S|2p|zy", "The y-axis label text.", "o|3Q|J|2S|2p|100", "hasAuthorAnnotations", "Whether the graph contains any author-provided `<annotations>` child.", "o|3Q|102|1V|2p|103", "prefigureXML", "The Prefigure-formatted XML rendered for this graph, or null if not using the Prefigure renderer.", "o|3Q|105|1T|2p|106", "The size of the graph.", "o|3Q|uB|1T|2p|108", "The width of the graph.", "o|3Q|bx|bz|2p|10A", "The aspect ratio (width / height) of the graph.", "o|3Q|xR|1p|2p|10C", "effectiveRenderer", "The renderer actually used after resolving fallbacks.", "o|3Q|10E|1T|2p|10F", "Whether x-axis tick labels are displayed.", "o|3Q|yV|1V|2p|10H", "Whether y-axis tick labels are displayed.", "o|3Q|yY|1V|2p|10J", "Minimum x value displayed.", "o|3Q|wu|1p|2p|10L", "Maximum x value displayed.", "o|3Q|wy|1p|2p|10N", "Minimum y value displayed.", "o|3Q|x1|1p|2p|10P", "Maximum y value displayed.", "o|3Q|x4|1p|2p|10R", "xScale", "Scale used along the x axis (xMax − xMin).", "o|3Q|10T|1p|2p|10U", "yScale", "Scale used along the y axis (yMax − yMin).", "o|3Q|10W|1p|2p|10X", "Grid line spacing on the graph.", "o|ry|zD|2p|10Z", "a|3N|3O|3P|zb|zc|zd|ze|zf|zg|zh|zi|zj|zk|zl|zm|zn|zo|zp|zq|zr|zs|zt|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|zv|zx|zz|101|104|107|109|10B|10D|10G|10I|10K|10M|10O|10Q|10S|10V|10Y|10a", "A 2D coordinate-axis graph", "o|F|8y|ws|wt|9X|za|10b|3M|2p|2p|8y|10c|AT", "a|90|1z", "A container of annotation children for screen reader navigation of a graph", "o|F|8z|10e|BN|Ao|3I|Aa|3M|2p|2p|8z|10f|Az", "Reference to the component this annotation is attached to.", "o|2h|1c|10h|3D", "The annotation text read by screen readers.", "o|33|1T|10j|AZ|1T", "speech", "More detailed spoken text used by screen readers; used if expert mode is activated or extra details are requested.", "o|33|10l|10m|AZ|1T", "sonify", "Whether to play a tone when this annotation is focused and it references a function.", "o|2m|10o|10p|2p|2s|1V", "circular", "Whether navigation through this annotation's children wraps around.", "o|2m|10r|10s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|10i|10k|10n|10q|10t", "o|3L|1T|1T|2p|10j|3M", "o|3L|10l|1T|2p|10m|3M", "o|3L|10o|1V|2p|10p|3M", "o|3L|10r|1V|2p|10s|3M", "a|3N|3O|3P|10v|10w|10x|10y|3T|3U|3V|3W|3Z", "An annotation for screen reader navigation of a graph", "o|F|90|10e|BN|Ao|10u|10z|3M|2p|2p|90|110|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "The symbolic formula of the function.", "o|3Q|I9|1X|2p|113", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|114|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A mathematical function, defined by formula or interpolation", "o|F|1r|Fo|Fp|3l|112|115|3M|3M|2p|1r|116|3h", "a|w|x|y|1r|1s|1z|I|J|2S", "111012110", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|GD|GH|GK|Gf|Gh|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "Number of output values.", "o|3Q|G8|1q|2p|11B", "The piecewise formula of the function.", "o|3Q|I9|1X|2p|11D", "The piecewise function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|11F", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|11C|I0|I2|I4|I8|11E|11G|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function defined piecewise from sub-functions on intervals", "o|F|1s|118|119|3l|11A|11H|3M|2p|2p|1s|11I|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1t|2p|6e", "Whether this math component renders intervals as intervals (always true for `<interval>`).", "o|3Q|4t|1V|2p|11M", "a|3N|3O|3P|66|67|68|69|6A|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|11L|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|11N|7S|7V|7Y|7b", "A math expression treated as an interval of real numbers", "o|F|1t|3j|3k|3l|11K|11O|3M|3M|2p|1t|11P|3h", "option", "selectForVariants", "Variant indices for which this option is selected.", "textListFromString", "o|33|11S|11T|54|11U", "selectWeight", "Relative weight when randomly selecting an option.", "o|33|11W|11X|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11V|11Y", "o|3L|11S|11U|2p|11T|3M", "o|3L|11W|1p|2p|11X|3M", "a|3N|3O|3P|11a|11b|3T|3U|3V|3W|3Z", "A single option within a `<select>` block", "o|F|11R|9U|9V|Ao|11Z|11c|2p|3M|2p|11R|11d|Az", "The kind of values in the sequence.", "letters", "a|1p|1X|11g", "A sequence of numeric values.", "o|3s|1p|11i", "A sequence of math expressions (allows symbolic from/to/step).", "o|3s|1X|11k", "A sequence of letters (single-letter or multi-letter labels).", "o|3s|11g|11m", "a|11j|11l|11n", "o|HC|2g|11f|11h|11o|3y", "The first value in the sequence.", "_componentWithSelectableType", "o|2h|hM|11q|11r", "The last value in the sequence. Used together with from to determine length when length is not specified.", "o|2h|hX|11t|11r", "step", "The increment between successive values in the sequence.", "o|2h|11v|11w|1X", "The number of values in the sequence.", "o|2h|Qh|11y|1q", "exclude", "Values to exclude from the sequence.", "_componentListWithSelectableType", "o|2h|120|121|122", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB", "a|3N|3O|3P|3Z", "Generates a sequence of numbers, math expressions, or letters", "o|F|1u|54|AZ|g0|124|125|3M|2p|3M|1u|126|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|1L|1M|1V|1W|1o|2R|2S|2T", "2222222222222222222222212022222201222222222222112221211222222222222222222202", "Type of value the slider produces.", "a|1p|1T", "Slider produces numeric values between `from` and `to`.", "o|3s|1p|12C", "Slider produces text values, one per child of the slider.", "o|3s|1T|12E", "a|12D|12F", "o|3o|2g|12A|3M|1p|12B|12G|3y", "Display width of the slider.", "n|4q", "o|uD|12J|3M", "o|33|bx|12I|12K|bz", "Display height of the slider.", "n|1c", "o|uD|12N|3M", "o|33|k5|12M|12O|bz", "initialValue", "Initial value of the slider before any user interaction.", "o|33|12Q|12R||11r", "showControls", "Whether to render play/pause controls alongside the slider.", "o|2m|12T|12U|2p|2s|1V", "showTicks", "Whether to render tick marks on the slider.", "o|2m|12W|12X|3M|2s|1V", "rotateTickLabels", "Whether to rotate the tick labels.", "o|2m|12Z|12a|2p|2s|1V", "showValue", "Whether to display the current value next to the slider.", "o|2m|12c|12d|3M|2s|1V", "a|3|2f|3m|2k|2g", "Minimum value of the slider's range.", "o|12f|hM|12g|3M|5Q|1p", "Maximum value of the slider's range.", "o|12f|hX|12i|3M|Nn|1p", "Increment between successive slider positions.", "o|12f|11v|12k|3M|36|1p", "o|2h|e9|eA|11r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|12H|12L|12P|12S|12V|12Y|12b|12e|12h|12j|12l|GH|H8|4Y|4c|4g|4j|12m", "o|3L|bx|bz|2p|12I|3M", "o|3L|k5|bz|2p|12M|3M", "o|3L|12T|1V|2p|12U|3M", "o|3L|12W|1V|2p|12X|3M", "o|3L|12Z|1V|2p|12a|3M", "o|3L|12c|1V|2p|12d|3M", "o|65|hM|1p|2p|12g|3M|3M", "o|65|hX|1p|2p|12i|3M|3M", "o|65|11v|1p|2p|12k|3M|3M", "items", "The values the slider can take.", "o|ry|12x|2p|12y", "numItems", "The total number of values.", "o|3Q|130|1q|2p|131", "The current value of the slider.", "o|ry|3a|2p|133", "a|3N|3O|3P|12o|12p|12q|12r|12s|12t|12u|12v|12w|Hd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|12z|132|134", "An interactive slider input", "o|F|91|128|129|Ao|12n|135|3M|2p|2p|91|136|Az", "a|1v|1z|93|94|95", "02000", "Display width of the spreadsheet.", "o|uD|12N|2p", "o|33|bx|13A|13B|bz", "minNumRows", "Minimum number of rows displayed.", "n|4", "o|33|13D|13E|13F|1p", "minNumColumns", "Minimum number of columns displayed.", "o|33|13H|13I|13F|1p", "Display height of the spreadsheet.", "o|2h|k5|13K|bz", "columnHeaders", "Header labels for the columns.", "o|2m|13M|13N|3M|2s|1V", "rowHeaders", "Header labels for the rows.", "o|2m|13P|13Q|3M|2s|1V", "fixedRowsTop", "Number of top rows fixed in place when scrolling.", "o|33|13S|13T|5Q|1q", "fixedColumnsLeft", "Number of left columns fixed in place when scrolling.", "o|33|13V|13W|5Q|1q", "hiddenColumns", "Indices of columns to hide.", "o|33|13Y|13Z|54|1a", "hiddenRows", "Indices of rows to hide.", "o|33|13b|13c|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|13C|13G|13J|13L|13O|13R|13U|13X|13a|13d", "o|3L|bx|bz|2p|13A|3M", "o|3L|13D|1p|2p|13E|3M", "o|3L|13H|1p|2p|13I|3M", "o|3L|13M|1V|2p|13N|3M", "o|3L|13P|1V|2p|13Q|3M", "o|3L|13S|1q|2p|13T|3M", "o|3L|13V|1q|2p|13W|3M", "o|3L|13Y|1a|2p|13Z|3M", "o|3L|13b|1a|2p|13c|3M", "The number of rows.", "o|3Q|7A|1p|2p|13o", "The number of columns.", "o|3Q|7D|1p|2p|13q", "o|3Q|k5|bz|2p|13K", "cells", "The raw text contents of all cells.", "o|6x|2p|95", "o|6x|2p|93", "a|13v|13w", "o|6v|13t|1v|3M|13u|4X|13x", "The cells grouped by row.", "o|6v|7K|1v|3M|13z|4X|13x", "The cells grouped by column.", "o|6x|2p|94", "a|13v|142", "o|6v|7N|1v|3M|141|4X|143", "evaluatedCells", "The evaluated values of all cells.", "o|6v|145|1v|3M|146|4X|13x", "evaluatedRows", "The evaluated cell values grouped by row.", "o|6v|148|1v|3M|149|4X|13x", "evaluatedColumns", "The evaluated cell values grouped by column.", "o|6v|14B|1v|3M|14C|4X|143", "pointsInCells", "Cells whose values are interpreted as points.", "a|X6|IK", "o|6v|14E|1d|3M|14F|4X|14G", "pointsInRows", "Cell-derived points grouped by row.", "o|6v|14I|1d|3M|14J|4X|14G", "pointsInColumns", "Cell-derived points grouped by column.", "o|6v|14L|1d|3M|14M|4X|14G", "a|3N|3O|3P|13f|13g|13h|13i|13j|13k|13l|13m|13n|3T|3U|3V|3W|3Z|13p|13r|13s|13y|140|144|147|14A|14D|14H|14K|14N", "An interactive spreadsheet", "o|F|92|138|139|9X|13e|14O|3M|2p|2p|92|14P|AT", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|G|I|J|89|8A|8B|K|8C|O|P|R|S|T|U|V|W|X|Y|Z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|8Z|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|8j|8k|8l|8m|1V|1W|1b|1c|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1j|8x|1l|1m|1n|8y|8z|90|91|92|93|94|95|96|97|98|1w|1x|99|1y|20|9A|22|23|9B|9C|9D|9E|9F|2E|2F|2G|2H|2I|9G|9H|2J|9I|2L|2M|2N|9J|2P|9K|9L|9M|9N|2R|9O|2S|2T|9P|9Q|9R|9S|9T", "1111111111111111111111111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "rowNum", "Row number where this cell is placed (1-based).", "o|33|14T|14U||1T", "colNum", "Column number where this cell is placed (1-based).", "o|33|14W|14X||1T", "colSpan", "Number of columns this cell spans.", "o|33|14Z|14a|36|1q", "halign", "Horizontal alignment for the cell's content (left, center, or right).", "o|33|14c|14d|5h|1T", "Border style for the bottom edge of the cell.", "o|33|5g|14f|42|1T", "Border style for the right edge of the cell.", "o|33|5i|14h|42|1T", "Initial text content of the cell.", "o|33|Zj|14j|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|14V|14Y|14b|14e|14g|14i|14k", "o|3L|14T|1T|2p|14U|3M", "o|3L|14W|1T|2p|14X|3M", "o|3L|14Z|1q|2p|14a|3M", "o|3L|Zj|1T|2p|14j|3M", "Horizontal alignment of the cell's content (left, center, or right).", "o|3Q|14c|1T|2p|14q", "o|3Q|5g|1T|2p|14f", "o|3Q|5i|1T|2p|14h", "inHeader", "Whether this cell is in a header row of the table.", "o|3Q|14u|1V|2p|14v", "The cell's content as a text string.", "o|3Q|1T|1T|2p|14x", "The cell's content interpreted as a math expression.", "o|3Q|1X|1X|2p|14z", "The cell's content interpreted as a number.", "o|3Q|1p|1p|2p|151", "a|3N|3O|3P|14m|14n|14o|14p|3T|3U|3V|3W|3Z|14r|14s|14t|14w|14y|150|152", "A single cell within a tabular layout or spreadsheet", "o|F|1v|14R|14S|Ao|14l|153|3M|3M|2p|1v|154|Az", "displayContext", "a|3|4|5|6|7|8|9|A|B|C|D|E|156", "a|1v|1z", "Row number where this row is placed (1-based).", "o|33|14T|159||1T", "header", "Whether this row is a header row.", "o|2m|15B|15C|2p|2s|1V", "Default horizontal alignment for cells in this row.", "o|33|14c|15E|5h|1T", "Default vertical alignment for cells in this row.", "o|33|c8|15G|cA|1T", "Border style for the left edge of this row.", "o|33|5h|15I|42|1T", "Border style for the bottom edge of this row.", "o|33|5g|15K|42|1T", "o|2h|4w|4x|1U", "o|2h|52|53|3D", "o|Ap|56|57|2s|1V", "o|Ap|59|5A|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15A|15D|15F|15H|15J|15L|15M|15N|15O|15P", "o|3L|14T|1T|2p|159|3M", "o|3L|15B|1V|2p|15C|3M", "o|3Q|14c|1T|2p|15E", "o|3Q|c8|1T|2p|15G", "Border style for the left edge of the row.", "o|3Q|5h|1T|2p|15V", "Border style for the bottom edge of the row.", "o|3Q|5g|1T|2p|15X", "a|3N|3O|3P|15R|15S|3T|3U|3V|3W|3Z|15T|15U|15W|15Y", "row_table", "A row within a tabular layout", "in a table", "o|157|93|158|BN|Ao|15Q|15Z|3M|2p|2p|15a|15b|Az|15c", "Column number where this column is placed (1-based).", "o|33|14W|15e||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15f|15M|15N|15O|15P", "o|3L|14W|1T|2p|15e|3M", "a|3N|3O|3P|15h|3T|3U|3V|3W|3Z", "column_table", "A column of cells within a `<spreadsheet>`", "o|157|94|158|BN|Ao|15g|15i|3M|2p|2p|15j|15k|Az|15c", "Row number where this block starts (1-based; can be a letter or number).", "o|33|14T|15m||1T", "Column number where this block starts (1-based; can be a letter or number).", "o|33|14W|15o||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15n|15p", "o|3L|14T|1T|2p|15m|3M", "o|3L|14W|1T|2p|15o|3M", "a|3N|3O|3P|15r|15s|3T|3U|3V|3W|3Z", "Container for grouping `<cell>`, `<row>`, and `<column>` children inside a `<spreadsheet>`", "o|F|95|138|139|Ao|15q|15t|3M|2p|2p|95|15u|Az", "a|93|1z", "Display width of the tabular layout.", "o|33|bx|15x|13B|bz", "Display height of the tabular layout.", "o|33|k5|15z||bz", "Default horizontal alignment for cells.", "justify", "a|5h|5b|5i|162", "Left-align cell content.", "o|3s|5h|164", "Center cell content horizontally.", "o|3s|5b|166", "Right-align cell content.", "o|3s|5i|168", "Justify cell content across the full cell width.", "o|3s|162|16A", "a|165|167|169|16B", "o|Bi|14c|161|5h|163|16C|3y", "Default vertical alignment for cells.", "Align cell content to the top.", "o|3s|9|16F", "Center cell content vertically.", "o|3s|cA|16H", "Align cell content to the bottom.", "o|3s|5g|16J", "a|16G|16I|16K", "o|Bi|c8|16E|cA|cB|16L|3y", "Border style for the top edge of the layout.", "minor", "major", "a|42|16O|xA|16P", "Do not render a border.", "o|3s|42|16R", "Render a thin border line.", "o|3s|16O|16T", "Render a medium-weight border line.", "o|3s|xA|16V", "Render a thick border line.", "o|3s|16P|16X", "a|16S|16U|16W|16Y", "o|Bi|9|16N|42|16Q|16Z|3y", "Border style for the left edge of the layout.", "o|Bi|5h|16b|42|16Q|16Z|3y", "Border style for the bottom edge of the layout.", "o|Bi|5g|16d|42|16Q|16Z|3y", "Border style for the right edge of the layout.", "o|Bi|5i|16f|42|16Q|16Z|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15y|160|16D|16M|16a|16c|16e|16g", "o|3L|bx|bz|2p|15x|3M", "o|3L|k5|bz|2p|15z|3M", "o|3L|14c|1T|2p|161|3M", "o|3L|c8|1T|2p|16E|3M", "o|3L|9|1T|2p|16N|3M", "o|3L|5h|1T|2p|16b|3M", "o|3L|5g|1T|2p|16d|3M", "o|3L|5i|1T|2p|16f|3M", "a|3N|3O|3P|16i|16j|16k|16l|16m|16n|16o|16p|3T|3U|3V|3W|3Z", "A simple tabular layout of cells", "o|F|96|15w|BN|9X|16h|16q|3M|2p|2p|96|16r|AT", "a|G|1z|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "021111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "suppressTableNameInTitle", "Whether to omit the auto-generated table name from the title.", "o|2m|16v|16w|2p|2s|1V", "Whether to display an auto-generated table number.", "o|2m|1p|16y|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|16x|16z", "tableEnumeration", "Auto-generated number for this table.", "o|3Q|171|1T|2p|172", "tableName", "The full display name of the table (e.g., 'Table 2').", "o|3Q|174|1T|2p|175", "The table's title.", "o|3Q|G|1T|2p|177", "a|3N|3O|3P|3T|3U|3V|3W|3Z|173|176|178", "A container element for a `<tabular>`", "o|F|97|16t|16u|9X|170|179|3M|3M|2p|97|17A|AT", "a|1z|9I|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9J|9N|9Q|9S|9T", "201111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222212221222221112111121222112211111222111111111111111111111111111111111111111111111111111", "suppressFigureNameInCaption", "Whether to omit the auto-generated figure name from the caption.", "o|2m|17E|17F|2p|2s|1V", "Whether to display an auto-generated figure number.", "o|2m|1p|17H|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|17G|17I", "figureEnumeration", "Auto-generated number for this figure.", "o|3Q|17K|1T|2p|17L", "figureName", "The full display name of the figure (e.g., 'Figure 3').", "o|3Q|17N|1T|2p|17O", "The figure's caption text.", "o|3Q|9I|1T|2p|17Q", "a|3N|3O|3P|3T|3U|3V|3W|3Z|17M|17P|17R", "A figure container holding graphical content with a caption", "o|F|98|17C|17D|9X|17J|17S|3M|3M|2p|98|17T|AT", "Whether the generated repeats should be treated as responses for assessment.", "o|g3|38|17V", "valueName", "Name to bind the current item to inside the repeat template.", "o|33|17X|17Y||1T", "indexName", "Name to bind the current 1-based index to inside the repeat template.", "o|33|17a|17b||1T", "The collection of items to iterate over when generating repeats.", "o|2h|7f|17d|23", "Component type used to wrap each item in the source.", "o|2h|2g|17f|1T", "a|2j|2t|2w|2z|32|37|17W|3E|3H|17Z|17c|17e|17g|gB", "a|3N|3O|3Z", "Repeats template content for each item in a source", "o|F|1w|9U|9V|g0|17h|17i|3M|3M|3M|1w|17j|Az", "a|2j|2t|2w|2z|32|37|17W|3E|3H|11p|11s|11u|11x|11z|123|17Z|17c|gB", "Repeats template content for each value in an arithmetic sequence", "o|F|1x|9U|9V|g0|17l|17i|3M|3M|3M|1x|17m|Az", "dx", "Horizontal spacing between pegs.", "o|33|17o|17p|36|1p", "dy", "Vertical spacing between pegs.", "o|33|17r|17s|36|1p", "xoffset", "Horizontal offset of the peg grid origin.", "o|33|17u|17v|5Q|1p", "yoffset", "Vertical offset of the peg grid origin.", "o|33|17x|17y|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|17q|17t|17w|17z", "o|3L|17o|1p|2p|17p|3M", "o|3L|17r|1p|2p|17s|3M", "o|3L|17u|1p|2p|17v|3M", "o|3L|17x|1p|2p|17y|3M", "a|3N|3O|3P|Hd|QD|7s|QE|181|182|183|184|3T|3U|3V|3W|3Z|Hk", "Renders a grid of pegs on a graph", "o|F|99|Om|On|Op|180|185|3M|2p|2p|99|186|Az", "_constraint", "a|188|2d", "Horizontal grid spacing.", "o|33|17o|18A|36|1p", "Vertical grid spacing.", "o|33|17r|18C|36|1p", "dz", "Depth-wise grid spacing.", "o|33|18E|18F|36|1p", "Horizontal offset of the grid origin.", "o|33|17u|18H|5Q|1p", "Vertical offset of the grid origin.", "o|33|17x|18J|5Q|1p", "zoffset", "Depth-wise offset of the grid origin.", "o|33|18L|18M|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N", "o|3L|17o|1p|2p|18A|3M", "o|3L|17r|1p|2p|18C|3M", "o|3L|18E|1p|2p|18F|3M", "o|3L|17u|1p|2p|18H|3M", "o|3L|17x|1p|2p|18J|3M", "o|3L|18L|1p|2p|18M|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie on a grid", "o|F|RJ|54|AZ|189|18O|18V|2p|2p|2p|RJ|18W|Az", "buffer", "Distance from the graph edge inside which the position is still considered constrained.", "n|0.A", "o|33|18Y|18Z|18a|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18b", "o|3L|18Y|1p|2p|18Z|3M", "a|3N|3O|3P|18d|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie within a graph's bounds", "o|F|RK|54|AZ|189|18c|18e|2p|2p|2p|RK|18f|Az", "xthreshold", "Horizontal distance within which the position attracts to a grid line.", "n|0.2", "o|33|18h|18i|18j|1p", "ythreshold", "Vertical distance within which the position attracts to a grid line.", "o|33|18l|18m|18j|1p", "zthreshold", "Depth-wise distance within which the position attracts to a grid line.", "o|33|18o|18p|18j|1p", "includeGridlines", "Whether to attract to entire grid lines (in addition to grid intersection points).", "o|2m|18r|18s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N|18k|18n|18q|18t", "o|3L|18h|1p|2p|18i|3M", "o|3L|18l|1p|2p|18m|3M", "o|3L|18o|1p|2p|18p|3M", "o|3L|18r|1V|2p|18s|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|18v|18w|18x|18y|3T|3U|3V|3W|3Z", "Attracts a graphical component's position to grid lines when nearby", "o|F|RL|54|AZ|189|18u|18z|2p|2p|2p|RL|190|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|1z|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "222222222222222222222222221111222221211111111111112222221222222222122221111121222", "relativeToGraphScales", "Whether the constraint is interpreted relative to the enclosing graph's scales.", "o|2m|194|195|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|196", "o|3L|194|1V|2p|195|3M", "a|3N|3O|3P|198|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to be within another component or components", "o|F|RM|192|193|189|197|199|2p|2p|2p|RM|19A|Az", "Whether the attraction threshold is interpreted relative to the enclosing graph's scales rather than absolute coordinates.", "o|2m|194|19C|2p|2s|1V", "Distance within which the position attracts to a target.", "o|2h|E6|19E|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19D|19F", "o|3L|194|1V|2p|19C|3M", "o|3Q|E6|1p|2p|19E", "a|3N|3O|3P|19H|3T|3U|3V|3W|3Z|19I", "Attracts a graphical component's position to another component when nearby", "o|F|RN|192|193|189|19G|19J|2p|2p|2p|RN|19K|Az", "a|RJ|RK|RL|RM|RN|RO|RP|RQ|1z", "111111112", "A constraint that is satisfied if any of its child constraints are satisfied", "o|F|RO|19M|19N|189|3I|Aa|2p|2p|2p|RO|19O|Az", "Distance within which the position attracts to the constraint location.", "o|33|E6|19Q|Pq|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19R", "o|3L|E6|1p|2p|19Q|3M", "a|3N|3O|3P|19T|3T|3U|3V|3W|3Z", "Wraps another constraint so it acts as a soft attraction within a threshold", "o|F|RP|19M|19N|189|19S|19U|2p|2p|2p|RP|19V|Az", "Constrains a graphical component's position to lie inside a region", "o|F|RQ|192|193|189|197|199|2p|2p|2p|RQ|19X|Az", "a|1K|1f|1z|2Q|8n|8u|8q|8r|8s|8t|8Y|8p", "102100011110", "Style number applied to the resulting intersection components.", "o|g3|34|19b", "a|2j|2t|2w|2z|32|19c|3A|3E|3H|gB", "a|3N|3P|3Z", "Renders intersections between graphical objects", "o|F|1y|19Z|19a|g0|19d|19e|3M|2p|2p|1y|19f|Az", "case", "a|1z|19h|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y|An", "101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111110", "Convenience for a single-case form: the boolean condition for which the children are rendered.", "o|Ap|Aq|19k|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19l", "Renders content conditionally based on its `<case>` or `<else>` children", "o|F|1z|19i|19j|g0|19m|125|3M|3M|2p|1z|19n|Az", "The children rendered as a comma-separated text string.", "o|3Q|1T|1T|2p|19p", "The children rendered as a comma-separated LaTeX string.", "o|3Q|2V|2V|2p|19r", "a|3N|3O|3P|3T|3U|3V|3W|3Z|19q|19s", "Renders its children as a comma-separated list", "o|F|20|2Z|2a|3l|3I|19t|3M|3M|2p|20|19u|3h", "numVariants", "The total number of variants to generate.", "o|2h|19w|19x|1q", "uniqueVariants", "Whether to require generated variants to be uniquely distinguishable.", "o|Ap|19z|1A0|2s|1V", "variantsToInclude", "Restrict the available variants to this list (by name or index).", "o|2h|1A2|1A3|11U", "variantsToExclude", "Variants to exclude from those generated.", "o|2h|1A5|1A6|11U", "variantNames", "Names assigned to the generated variants.", "o|2h|1A8|1A9|11U", "seeds", "Random seeds used when generating variants.", "o|2h|1AB|1AC|11U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19y|1A1|1A4|1A7|1AA|1AD", "Configures how variants are generated for the enclosing document or section", "o|F|9A|54|AZ|Ao|1AE|Aa|3M|2p|2p|9A|1AF|Az", "numToSelect", "How many values to select from the sequence.", "o|33|1AH|1AI|36|1q", "withReplacement", "Whether the same value can be selected more than once.", "o|2m|1AK|1AL|2p|2s|1V", "Whether and how to sort the selected values.", "unsorted", "increasing", "decreasing", "a|1AO|1AP|1AQ|2q|2r", "Preserve the random selection order.", "o|3s|1AO|1AS", "Sort the selected values in increasing order.", "o|3s|1AP|1AU", "Sort the selected values in decreasing order.", "o|3s|1AQ|1AW", "a|1AT|1AV|1AX", "o|Bi|2L|1AN|1AO|1AR|1AY|3y", "excludeCombinations", "Lists of value combinations to exclude from the selection.", "_componentListOfListsWithSelectableType", "o|2h|1Aa|1Ab|1Ac", "coprime", "Require the selected numbers to be pairwise coprime (numbers only).", "o|2m|1Ae|1Af|2p|2s|1V", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB|1AJ|1AM|1AZ|1Ad|1Ag", "o|3L|1AH|1q|2p|1AI|3M", "o|3L|1AK|1V|2p|1AL|3M", "o|3L|2L|1T|2p|1AN|3M", "o|3L|1Ae|1V|2p|1Af|3M", "a|3N|3O|3P|1Ai|1Aj|1Ak|1Al|3Z", "Randomly selects values from a sequence of numbers, math expressions, or letters to create document variants", "o|F|21|54|AZ|g0|1Ah|1Am|3M|2p|3M|21|1An|Az", "a|11R|1z", "How many child components to select.", "o|33|1AH|1Aq|36|1q", "Whether the same child can be selected more than once.", "o|2m|1AK|1As|2p|2s|1V", "Component type to select from.", "o|2h|2g|1Au|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ar|1At|1Av|gB", "o|3L|1AH|1q|2p|1Aq|3M", "o|3L|1AK|1V|2p|1As|3M", "a|3N|3O|3P|1Ax|1Ay|3Z", "Randomly selects components from a list of children to create document variants", "o|F|22|1Ap|BN|g0|1Aw|1Az|3M|3M|3M|22|1B0|Az", "Whether this group's children should be treated as responses for assessment.", "o|g3|38|1B2", "rendered", "Whether the group's children are rendered.", "o|2m|1B4|1B5|3M|2s|1V", "createComponentOfType", "Component type to wrap each child as when expanding the group.", "o|2h|1B7|1B8|1T", "Number of components to create when expanding (used with createComponentOfType).", "o|2h|gF|1BA|1p", "Whether to render the group's children separated by commas (true) or with no separator (false).", "o|2m|20|1BC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|1B3|3E|3H|1B6|1B9|1BB|1BD", "o|3L|1B4|1V|2p|1B5|3M", "a|3N|3O|1BF|3Z", "A logical grouping of components", "o|F|23|9U|9V|g0|1BE|1BG|3M|3M|2p|23|1BH|Az", "target", "Reference to the state variable that will be animated.", "o|2h|1BJ|1BK|3D", "animationOn", "Whether the animation is currently playing.", "o|2m|1BM|1BN|2p|2s|1V", "animationMode", "How the animation steps through the sequence.", "increase", "decrease", "increase once", "decrease once", "oscillate", "a|1BR|1BS|1BT|1BU|1BV", "Step through values from first to last, looping back to the start.", "o|3s|1BR|1BX", "Step through values from last to first, looping back to the end.", "o|3s|1BS|1BZ", "Step from first to last and stop without looping.", "o|3s|1BT|1Bb", "Step from last to first and stop without looping.", "o|3s|1BU|1Bd", "Step from first to last, then reverse direction at each end.", "o|3s|1BV|1Bf", "a|1BY|1Ba|1Bc|1Be|1Bg", "o|Bi|1BP|1BQ|1BR|1BW|1Bh|3y", "animationInterval", "Time in milliseconds between successive animation steps.", "o|33|1Bj|1Bk|Nv|1p", "allowAdjustmentsWhileRunning", "Whether sequence parameters can be adjusted while the animation is running.", "o|2m|1Bm|1Bn|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11p|11s|11u|11x|11z|123|1BL|1BO|1Bi|1Bl|1Bo", "o|3L|1BM|1V|2p|1BN|3M", "o|3L|1BP|1T|2p|1BQ|3M", "o|3L|1Bj|1p|2p|1Bk|3M", "o|3L|1Bm|1V|2p|1Bn|3M", "Index of the currently selected value in the sequence (1-based).", "o|3Q|vc|1p|2p|1Bu", "The currently selected value of the animation.", "o|ry|3a|2p|1Bw", "currentAnimationDirection", 'Current direction of the animation ("increase" or "decrease"; flips during oscillation).', "o|3Q|1By|1T|2p|1Bz", "a|3N|3O|3P|1Bq|1Br|1Bs|1Bt|3T|3U|3V|3W|3Z|1Bv|1Bx|1C0", "Animates a value through a sequence over time", "o|F|9B|54|AZ|Ao|1Bp|1C1|3M|2p|2p|9B|1C2|Az", "Whether to treat the inputs as unordered.", "o|2m|4n|1C4|2p|2s|1V", "Whether to force symbolic evaluation.", "o|2m|DH|1C6|2p|2s|1V", "Whether to force numeric evaluation.", "o|2m|DK|1C8|2p|2s|1V", "The function to evaluate.", "o|2h|1r|1CA|1r", "input", "Input value(s) at which to evaluate the function.", "o|2h|1CC|1CD|1Y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1C5|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1C7|1C9|1CB|1CE", "o|3L|4n|1V|2p|1C4|3M", "o|3L|DH|1V|2p|1C6|3M", "o|3L|DK|1V|2p|1C8|3M", "o|3Q|3a|24|2p|6e", "The function evaluated at the inputs as a math expression.", "o|3Q|I9|1X|2p|1CK", "a|3N|3O|3P|66|67|68|69|1CG|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1CH|1CI|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1CJ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1CL|7S|7V|7Y|7b", "Evaluates a function at a math value", "o|F|24|54|AZ|3l|1CF|1CM|3M|2p|2p|24|1CN|3h", "Distribution from which to sample.", "discreteUniform", "gaussian", "a|W7|1CQ|1CR", "Continuous uniform distribution over `[from, to]`.", "o|3s|W7|1CT", "Discrete uniform distribution over integers in `[from, to]`.", "o|3s|1CQ|1CV", "Normal (Gaussian) distribution with the specified mean and standard deviation.", "o|3s|1CR|1CX", "a|1CU|1CW|1CY", "o|Bi|2g|1CP|W7|1CS|1CZ|3y", "Mean of the sampling distribution (Gaussian).", "o|33|l|1Cb|5Q|1p", "Standard deviation of the sampling distribution (Gaussian).", "o|33|o|1Cd|36|1p", "Variance of the sampling distribution (Gaussian).", "o|33|n|1Cf|36|1p", "Lower bound of the sampling range.", "o|33|hM|1Ch||1p", "Upper bound of the sampling range.", "o|33|hX|1Cj||1p", "Step size between samples for the discrete-uniform distribution.", "o|33|11v|1Cl|36|1p", "Values to exclude from the sample space.", "o|33|120|1Cn|54|1a", "How many random numbers to select.", "o|33|1AH|1Cp|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|gB|1Cq", "o|3L|2g|1T|2p|1CP|3M", "o|3L|1AH|1q|2p|1Cp|3M", "Step size between sample values (for discrete distributions).", "o|3Q|11v|1p|2p|1Cu", "o|3Q|hM|1p|2p|1Ch", "o|3Q|hX|1p|2p|1Cj", "Mean of the sampling distribution.", "o|3Q|l|1p|2p|1Cy", "Variance of the sampling distribution.", "o|3Q|n|1p|2p|1D0", "Standard deviation of the sampling distribution.", "o|3Q|o|1p|2p|1D2", "a|3N|3O|3P|1Cs|1Ct|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Selects a fixed set of random numbers to create document variants", "o|F|25|54|AZ|g0|1Cr|1D4|3M|2p|3M|25|1D5|Az", "numSamples", "Number of samples to draw.", "o|33|1D7|1D8|36|1p", "variantDeterminesSeed", "Whether the document's variant index determines the random seed.", "o|Ap|1DA|1DB|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1D9|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|1DC|gB", "o|3L|1D7|1p|2p|1D8|3M", "o|3L|1DA|1V|2p|1DB|3M", "a|3N|3O|3P|1DE|1Cs|1DF|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Samples random numbers from a distribution", "o|F|26|54|AZ|g0|1DD|1DG|3M|2p|3M|26|1DH|Az", "Lower bound (inclusive) of the prime range to select from.", "o|33|hM|1DJ|4X|1q", "Upper bound (inclusive) of the prime range to select from.", "o|33|hX|1DL|12N|1q", "Primes to exclude from the selection.", "o|33|120|1DN|54|1a", "How many prime numbers to select.", "o|33|1AH|1DP|36|1q", "Whether the same prime can be selected more than once.", "o|2m|1AK|1DR|2p|2s|1V", "Sort order applied to the selected primes.", "Sort the selected primes in increasing order.", "o|3s|1AP|1DU", "Sort the selected primes in decreasing order.", "o|3s|1AQ|1DW", "a|1AT|1DV|1DX", "o|Bi|2L|1DT|1AO|1AR|1DY|3y", "Combinations of values that should not be selected together.", "_listOfNumberLists", "o|2h|1Aa|1Da|1Db", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1DK|1DM|1DO|1DQ|1DS|1DZ|1Dc|gB", "o|3L|hM|1q|2p|1DJ|3M", "o|3L|hX|1q|2p|1DL|3M", "o|3L|120|1a|2p|1DN|3M", "o|3L|1AH|1q|2p|1DP|3M", "o|3L|1AK|1V|2p|1DR|3M", "o|3L|2L|1T|2p|1DT|3M", "a|3N|3O|3P|1De|1Df|1Dg|1Dh|1Di|1Dj|3Z", "Randomly selects prime numbers from a range to create document variants", "o|F|27|54|AZ|g0|1Dd|1Dk|3M|2p|3M|27|1Dl|Az", "Number of prime samples to draw.", "o|33|1D7|1Dn|36|1p", "Lower bound (inclusive) of the prime range to sample from.", "o|33|hM|1Dp|4X|1q", "Upper bound (inclusive) of the prime range to sample from.", "o|33|hX|1Dr|12N|1q", "Primes to exclude from the sample.", "o|33|120|1Dt|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Do|1Dq|1Ds|1Du|1DC|gB", "o|3L|1D7|1p|2p|1Dn|3M", "o|3L|hM|1q|2p|1Dp|3M", "o|3L|hX|1q|2p|1Dr|3M", "o|3L|120|1a|2p|1Dt|3M", "a|3N|3O|3P|1Dw|1Dx|1Dy|1Dz|1DF|3Z", "Samples random prime numbers", "o|F|28|54|AZ|g0|1Dv|1E0|3M|2p|3M|28|1E1|Az", "Type of values being substituted.", "a|1X|1T", "Substitute within math expressions.", "o|3s|1X|1E5", "Substitute within text values.", "o|3s|1T|1E7", "a|1E6|1E8", "o|HC|2g|1E3|1E4|1E9|3y", "match", "Pattern to match in the source value.", "o|33|1EB|1EC||11r", "replacement", "Value to substitute in place of each match.", "o|33|1EE|1EF||11r", "Level of simplification applied after substitution.", "Fully simplify the resulting expression.", "o|3s|43|1EI", "a|49|1EJ|4D|4F|4H", "o|Bi|40|1EH|42|47|1EK|3y", "matchWholeWord", "Whether matching is restricted to whole words (text mode).", "o|2m|1EM|1EN|2p|2s|1V", "matchCase", "Whether matching is case-sensitive (text mode).", "o|2m|1EP|1EQ|2p|2s|1V", "preserveCase", "Whether the case of the original is preserved when substituting.", "o|2m|1ES|1ET|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1EA|1ED|1EG|1EL|H8|4Y|4c|4g|4j|1EO|1ER|1EU", "o|3L|2g|1T|2p|1E3|3M", "o|3L|40|1T|2p|1EH|3M", "o|3L|1EM|1V|2p|1EN|3M", "o|3L|1EP|1V|2p|1EQ|3M", "o|3L|1ES|1V|2p|1ET|3M", "a|3N|3O|3P|1EW|1EX|1EY|1EZ|1Ea|3Z|6X|6Y|6Z|6a|6b", "Substitutes math expressions into another expression", "o|F|29|9U|9V|g0|1EV|1Eb|3M|3M|3M|29|1Ec|Az", "o|Ap|4n|4o|2s|1V", "minIndex", "Smallest period index considered when listing offsets.", "-Infinity", "o|33|1Ef|1Eg|1Eh|1q", "maxIndex", "Largest period index considered when listing offsets.", "o|33|1Ej|1Ek|9k|1q", "offsets", "Offsets within one period.", "o|33|1Em|1En||1Y", "The period of the set.", "o|33|Y8|1Ep||1X", "minIndexAsList", "Smallest period index when rendered as a list.", "n|-1", "o|33|1Er|1Es|1Et|1q", "maxIndexAsList", "Largest period index when rendered as a list.", "o|33|1Ev|1Ew|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Ei|1El|1Eo|1Eq|1Eu|1Ex", "o|3L|1Ef|1q|2p|1Eg|3M", "o|3L|1Ej|1q|2p|1Ek|3M", "o|3L|1Em|1Y|2p|1En|3M", "o|3L|Y8|1X|2p|1Ep|3M", "o|3L|1Er|1q|2p|1Es|3M", "o|3L|1Ev|1q|2p|1Ew|3M", "o|3Q|3a|2A|2p|6e", "numOffsets", "The number of distinct offsets within one period.", "o|3Q|1F6|1q|2p|1F7", "redundantOffsets", "Offsets that are redundant given the period.", "o|3Q|1F9|1V|2p|1FA", "The periodic set rendered as a list of explicit values.", "o|3Q|20|1Y|2p|1FC", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1Ez|1F0|1F1|1F2|1F3|1F4|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1F5|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1F8|1FB|1FD|7S|7V|7Y|7b", "A periodic set of real numbers", "o|F|2A|54|AZ|3l|1Ey|1FE|3M|2p|2p|2A|1FF|3h", "a|1z|dd|2f", "200", "Explicit width of the image (overrides size).", "o|33|bx|1FJ||bz", "Named size preset for the image.", "o|Bi|uB|1FL|xA|xE|xP|3y", "Aspect ratio (width / height) for the image.", "o|33|xR|1FN||1p", "How to size the image.", "o|Bi|xU|1FP|AT|xW|xb|3y", "Horizontal alignment of the image within its container.", "Center the image horizontally.", "o|3s|5b|1FS", "Align the image to the left edge.", "o|3s|5h|1FU", "Align the image to the right edge.", "o|3s|5i|1FW", "a|1FT|1FV|1FX", "o|Bi|xd|1FR|5b|xf|1FY|3y", "Whether the image is purely decorative.", "o|2m|zM|1Fa|2p|2s|1V", "source", "URL or path of the image source.", "o|33|1Fc|1Fd|AZ|1T", "authorName", "Name of the author of the image.", "o|33|1Ff|1Fg||1T", "authorUrl", "URL to link the author's name to in the attribution (e.g. the author's profile page).", "o|33|1Fi|1Fj||1T", "imageName", "Name of the image, used in place of the generic word “Image” in the attribution.", "o|33|1Fl|1Fm||1T", "originalUrl", "Original URL where the image can be found, used to link the image name in the attribution.", "o|33|1Fo|1Fp||1T", "licenseName", "Name of the license for the image.", "o|33|1Fr|1Fs||1T", "licenseUrl", "URL for the license of the image.", "o|33|1Fu|1Fv||1T", "a|3|2f|2k|2l|3n|cK|2g", "licenseCodes", "License code(s) for the image. Specify two codes to indicate the image is dual licensed.", "CC-BY", "CC-BY-SA", "CC-BY-ND", "CC-BY-NC", "CC-BY-NC-SA", "CC-BY-NC-ND", "CC0", "PDM", "GFDL", "FAL", "OGL", "MIT", "APACHE-2.0", "a|1G0|1G1|1G2|1G3|1G4|1G5|1G6|1G7|1G8|1G9|1GA|1GB|1GC", "Creative Commons Attribution: reuse with credit, including commercially.", "o|3s|1G0|1GE", "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license.", "o|3s|1G1|1GG", "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit.", "o|3s|1G2|1GI", "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes.", "o|3s|1G3|1GK", "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license.", "o|3s|1G4|1GM", "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit.", "o|3s|1G5|1GO", "Creative Commons Zero: the creator has dedicated the work to the public domain.", "o|3s|1G6|1GQ", "Public Domain Mark: the work is free of known copyright restrictions.", "o|3s|1G7|1GS", "GNU Free Documentation License: copyleft license common on Wikimedia.", "o|3s|1G8|1GU", "Free Art License: copyleft license for artistic works.", "o|3s|1G9|1GW", "UK Open Government Licence: reuse government material with attribution.", "o|3s|1GA|1GY", "MIT License: permissive license common for icon and illustration sets.", "o|3s|1GB|1Ga", "Apache License 2.0: permissive license common for icon and illustration sets.", "o|3s|1GC|1Gc", "a|1GF|1GH|1GJ|1GL|1GN|1GP|1GR|1GT|1GV|1GX|1GZ|1Gb|1Gd", "o|1Fx|1Fy|1Fz||1GD|1Ge|3M|3y", "licenseVersion", "Version of the Creative Commons license(s) given in `licenseCodes` (ignored by non-Creative-Commons licenses).", "4.0", "1.0", "2.0", "2.5", "3.0", "a|1Gj|1Gk|1Gl|1Gm|1Gi", "Creative Commons version 1.0.", "o|3s|1Gj|1Go", "Creative Commons version 2.0.", "o|3s|1Gk|1Gq", "Creative Commons version 2.5.", "o|3s|1Gl|1Gs", "Creative Commons version 3.0.", "o|3s|1Gm|1Gu", "Creative Commons version 4.0.", "o|3s|1Gi|1Gw", "a|1Gp|1Gr|1Gt|1Gv|1Gx", "o|Bi|1Gg|1Gh|1Gi|1Gn|1Gy|3y", "asFileName", "File name to use when downloading the image.", "o|33|1H0|1H1||1T", "mimeType", "MIME type of the image.", "o|33|1H3|1H4||1T", "Whether the image can be dragged on a graph.", "o|2m|5L|1H6|3M|2s|1V", "rotate", "Rotation angle (radians) applied to the image.", "o|33|1H8|1H9|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1FK|1FM|1FO|1FQ|1FZ|1Fb|1Fe|1Fh|1Fk|1Fn|1Fq|1Ft|1Fw|1Gf|1Gz|1H2|1H5|1H7|5R|5X|63|1HA", "o|3L|xU|1T|2p|1FP|3M", "o|3L|xd|1T|2p|1FR|3M", "o|3L|zM|1V|2p|1Fa|3M", "o|3L|1Fc|1T|2p|1Fd|3M", "o|3L|1Ff|1T|2p|1Fg|3M", "o|3L|1Fi|1T|2p|1Fj|3M", "o|3L|1Fl|1T|2p|1Fm|3M", "o|3L|1Fo|1T|2p|1Fp|3M", "o|3L|1Fy|1U|2p|1Fz|3M", "o|3L|1Gg|1T|2p|1Gh|3M", "o|3L|1H0|1T|2p|1H1|3M", "o|3L|1H3|1T|2p|1H4|3M", "o|3L|5L|1V|2p|1H6|3M", "o|3L|1H8|1p|2p|1H9|3M", "A short accessibility description of the image.", "o|3Q|dd|1T|2p|1HQ", "The size of the image.", "o|3Q|uB|1T|2p|1HS", "The display width of the image.", "o|3Q|bx|bz|2p|1HU", "The aspect ratio (width / height) of the image.", "o|3Q|xR|1p|2p|1HW", "licenseNames", "The license name(s) for the image. Derived from `licenseCodes` when given; otherwise from the `licenseName` attribute.", "o|3Q|1HY|1U|2p|1HZ", "licenseUrls", "The license URL(s) for the image. Derived from `licenseCodes` (and `licenseVersion`) when given; otherwise from the `licenseUrl` attribute.", "o|3Q|1Hb|1U|2p|1Hc", "a|3N|3O|3P|1HC|1HD|1HE|1HF|1HG|1HH|1HI|1HJ|1HK|1HL|1HM|1HN|1HO|6I|6K|1HP|3T|3U|3V|3W|3Z|6W|1HR|1HT|1HV|1HX|1Ha|1Hd", "Displays a static image", "o|F|9C|1FH|1FI|9X|1HB|1He|3M|2p|2p|9C|1Hf|AT", "Explicit width of the video player (overrides size).", "o|2h|bx|1Hh|bz", "Named size preset for the video player.", "o|Bi|uB|1Hj|43|xE|xP|3y", "Aspect ratio (width / height) for the video player.", "16 / 9", "o|33|xR|1Hl|1Hm|1p", "How to size the video player.", "o|Bi|xU|1Ho|AT|xW|xb|3y", "Horizontal alignment of the video within its container.", "Center the video horizontally.", "o|3s|5b|1Hr", "Align the video to the left edge.", "o|3s|5h|1Ht", "Align the video to the right edge.", "o|3s|5i|1Hv", "a|1Hs|1Hu|1Hw", "o|Bi|xd|1Hq|5b|xf|1Hx|3y", "youtube", "YouTube video ID to embed.", "o|33|1Hz|1I0||1T", "URL of the video source.", "o|33|1Fc|1I2||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Hi|1Hk|1Hn|1Hp|1Hy|1I1|1I3", "o|3L|xU|1T|2p|1Ho|3M", "o|3L|xd|1T|2p|1Hq|3M", "o|3L|1Hz|1T|2p|1I0|3M", "o|3L|1Fc|1T|2p|1I2|3M", "A short accessibility description of the video.", "o|3Q|dd|1T|2p|1I9", "The size of the video player.", "o|3Q|uB|1T|2p|1IB", "The display width of the video player.", "o|3Q|bx|bz|2p|1ID", "The aspect ratio (width / height) of the video player.", "o|3Q|xR|1p|2p|1IF", "state", "The video's current playback state (e.g. playing, paused).", "o|3Q|1IH|1T|2p|1II", "time", "The current playback time in seconds.", "o|3Q|1IK|1p|2p|1IL", "duration", "The total duration of the video in seconds.", "o|3Q|1IN|1p|2p|1IO", "secondsWatched", "Total seconds the viewer has watched.", "o|3Q|1IQ|1p|2p|1IR", "fractionWatched", "Fraction of the video the viewer has watched (0 to 1).", "o|3Q|1IT|1p|2p|1IU", "a|3N|3O|3P|1I5|1I6|1I7|1I8|3T|3U|3V|3W|3Z|1IA|1IC|1IE|1IG|1IJ|1IM|1IP|1IS|1IV", "Embeds a video player", "o|F|9D|1FH|1FI|9X|1I4|1IW|3M|2p|2p|9D|1IX|AT", "a|G|1z|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "0111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Whether the hint is currently open (revealed).", "o|3Q|M7|1V|2p|1Ib", "The hint's title text.", "o|3Q|G|1T|2p|1Id", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Ic|1Ie", "Hint shown on demand to help with an exercise", "o|F|9E|1IZ|1Ia|9X|3I|1If|3M|3M|2p|9E|1Ig|AT", "The formatted value rendered as a text string.", "o|3Q|1T|1T|2p|1Ii", "The numeric value with thousands separators.", "o|3Q|3a|2B|2p|1Ik", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Ij|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1Il", "Renders a numeric value with thousands separators (e.g. 1,000,000)", "o|F|2B|fq|fr|3l|Jc|1Im|3M|3M|2p|2B|1In|3h", "pluralForm", "Custom plural form to use (overrides automatic pluralization).", "o|33|1Ip|1Iq||1T", "basedOnNumber", "Number that determines whether to use the singular or plural form.", "o|33|1Is|1It||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63|1Ir|1Iu", "o|3L|1Ip|1T|2p|1Iq|3M", "o|3L|1Is|1p|2p|1It|3M", "The selected word as a text string.", "o|3Q|1T|1T|2p|1Iy", "The selected (singular or plural) word.", "o|3Q|3a|1T|2p|1J0", "a|3N|3O|3P|Jd|6I|Je|6K|1Iw|1Ix|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Iz|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1J1", "Renders a word in its singular or plural form based on a count", "o|F|2C|fq|fr|3l|1Iv|1J2|3M|3M|2p|2C|1J3|3h", "Boolean expression; the feedback is shown when the condition is true.", "o|Ap|Aq|1J5|2s|1V", "updateWith", "References whose changes trigger re-evaluation of the feedback.", "o|2h|1J7|1J8|3D", "a|2j|2w|2z|32|37|3A|3E|3H|1J6|1J9", "a|3O|3P|3T|3U|3V|3W|3Z", "Targeted feedback shown when conditions are met", "o|F|9F|9U|9V|9X|1JA|1JB|3M|3M|2p|9F|1JC|AT", "Marks its children as response components for an enclosing answer", "o|F|pI|9U|9V|Ao|3I|Aa|2p|3M|2p|pI|1JE|Az", "A single conditional branch within `<conditionalContent>`", "o|F|19h|9U|9V|Ao|At|Ax|2p|3M|2p|19h|1JG|Az", "minSentencesPerParagraph", "Minimum number of sentences per generated paragraph.", "o|33|1JI|1JJ|13F|1p", "maxSentencesPerParagraph", "Maximum number of sentences per generated paragraph.", "n|8", "o|33|1JL|1JM|1JN|1p", "minWordsPerSentence", "Minimum number of words per generated sentence.", "o|33|1JP|1JQ|13F|1p", "maxWordsPerSentence", "Maximum number of words per generated sentence.", "o|33|1JS|1JT|1JN|1p", "generateWords", "Number of words of lorem-ipsum to generate.", "o|33|1JV|1JW||1p", "generateSentences", "Number of sentences of lorem-ipsum to generate.", "o|33|1JY|1JZ||1p", "generateParagraphs", "Number of paragraphs of lorem-ipsum to generate.", "o|33|1Jb|1Jc||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1JK|1JO|1JR|1JU|1JX|1Ja|1Jd", "o|3L|1JI|1p|2p|1JJ|3M", "o|3L|1JL|1p|2p|1JM|3M", "o|3L|1JP|1p|2p|1JQ|3M", "o|3L|1JS|1p|2p|1JT|3M", "a|3N|3O|3P|1Jf|1Jg|1Jh|1Ji|3Z", "Generates lorem ipsum placeholder text", "o|F|2D|54|AZ|g0|1Je|1Jj|3M|2p|2p|2D|1Jk|Az", "Reference to the state variable that will be updated.", "o|2h|1BJ|1Jm|3D", "Component type used to interpret the new value.", "a|1X|1p|1V|1T", "Treat the new value as a math expression.", "o|3s|1X|1Jq", "Treat the new value as a number.", "o|3s|1p|1Js", "Treat the new value as a boolean.", "o|3s|1V|1Ju", "Treat the new value as text.", "o|3s|1T|1Jw", "a|1Jr|1Jt|1Jv|1Jx", "o|HC|2g|1Jo|1Jp|1Jy|3y", "newValue", "New value to assign to the target.", "o|2h|1K0|1K1|11r", "Whether the update button can be dragged on a graph.", "o|2m|5L|1K3|3M|2s|1V", "triggerWhen", "Boolean expression that fires the action whenever it transitions to true.", "triggering", "o|4d|1K5|1K6|1K7|2p|2s|1V", "a|3|2f|4N|2g", "triggerWith", "References to components whose value changes should fire this action.", "o|1K9|1KA|1KB|1K7|3D", "triggerWhenObjectsClicked", "References to components whose click events should fire this action.", "o|1K9|1KD|1KE|1K7|3D", "triggerWhenObjectsFocused", "References to components whose focus events should fire this action.", "o|1K9|1KG|1KH|1K7|3D", "Level of simplification applied to the new value.", "Fully simplify the new value.", "o|3s|43|1KK", "a|49|1KL|4D|4F|4H", "o|Bi|40|1KJ|42|47|1KM|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Jn|1Jz|1K2|1K4|5X|63|GH|1K8|1KC|1KF|1KI|1KN", "o|3L|5L|1V|2p|1K3|3M", "o|3L|40|1T|2p|1KJ|3M", "a|3N|3O|3P|1KP|6K|Hd|1KQ|3T|3U|3V|3W|3Z|Hk|6W", "Updates one or more state variables on a target component", "o|F|2E|Om|On|3l|1KO|1KR|3M|2p|2p|2E|1KS|3h", "a|I|J|1z|2S|G|H|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1110111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Reference to the component whose action will be invoked.", "o|2h|1BJ|1KW|3D", "actionName", "Name of the action to invoke on the target component.", "o|33|1KY|1KZ||1T", "Whether the action button can be dragged on a graph.", "o|2m|5L|1Kb|3M|2s|1V", "Numeric arguments passed to the invoked action.", "o|2h|44|1Kd|1a", "Numeric argument passed to the invoked action.", "o|2h|1p|1Kf|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1KX|1Ka|1Kc|GH|5X|63|1K8|1KC|1KF|1KI|1Ke|1Kg", "o|3L|1KY|1T|2p|1KZ|3M", "o|3L|5L|1V|2p|1Kb|3M", "a|3N|3O|3P|1Ki|1Kj|Hd|6K|3T|3U|3V|3W|3Z|Hk|6W", "Triggers an action when clicked or in response to a specified user interaction", "o|F|2F|1KU|1KV|3l|1Kh|1Kk|3M|3M|2p|2F|1Kl|3h", "a|1z|2E|2F|I|J|2S", "200110", "Whether the trigger set's button can be dragged on a graph.", "o|2m|5L|1Kp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Kq|5X|63|GH|1K8|1KC|1KF|1KI", "o|3L|5L|1V|2p|1Kp|3M", "a|3N|3O|3P|1Ks|6K|Hd|3T|3U|3V|3W|3Z|Hk|6W", "Groups a set of `<updateValue>` or `<callAction>` components which share a single trigger condition", "o|F|2G|1Kn|1Ko|3l|1Kr|1Kt|3M|2p|2p|2G|1Ku|3h", "numIterates", "Number of iterations to compute.", "o|33|1Kw|1Kx|5Q|1q", "Starting value passed to the function on the first iteration.", "o|33|12Q|1Kz|5J|1X", "The function to iterate.", "o|2h|1r|1L1|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ky|1C7|1C9|1L0|1L2|H8|4Y|4c|4g|4j", "o|3L|1Kw|1q|2p|1Kx|3M", "Number of dimensions of each iterate.", "o|3Q|6r|1q|2p|1L5", "allIterates", "All computed iterates of the function.", "o|3Q|1L7|1Y|2p|1L8", "allIteratesWithInitial", "All iterates including the initial value.", "o|3Q|1LA|1Y|2p|1LB", "iterates", "The list of iterate values.", "o|6v|1LD|1X|3M|1LE|36|75", "finalIterate", "The last iterate value.", "o|3Q|1LG|1X|2p|1LH", "a|3N|3O|3P|1L4|1CH|1CI|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1L6|1L9|1LC|1LF|1LI", "List of values produced by iterating a function", "o|F|2H|54|AZ|3l|1L3|1LJ|3M|2p|2p|2H|1LK|3h", "a|2j|2t|2w|2z|32|1B3|3E|3H|1B6|1B9|1BB|1BD", "a|3N|1BF|3Z", "A reusable group with parameterized attributes; can be copied elsewhere with new parameter values", "o|F|2I|9U|9V|g0|1LM|1LN|3M|3M|2p|2I|1LO|Az", "Declares attributes accepted by an enclosing `<module>`", "o|F|9G|9U|9V|g0|3I|125|3M|3M|2p|9G|1LQ|Az", "a|Ks|1z|Kt|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "010111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Container for components used for setup but not rendered", "o|F|9H|1LS|1LT|g0|3I|125|3M|3M|2p|9H|1LU|Az", "The footnote's body as plain text.", "o|3Q|1T|1T|2p|1LW", "footnoteTag", "The auto-generated marker (number) used to reference this footnote.", "o|3Q|1LY|1T|2p|1LZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1LX|1La", "Inline footnote whose body is shown on demand and is auto-numbered in the document", "o|F|2J|2Z|2a|3l|3I|1Lb|3M|3M|2p|2J|1Lc|3h", "The caption rendered as a plain text string.", "o|3Q|1T|1T|2p|1Le", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Lf", "A caption attached to a figure or table", "o|F|9I|fL|fM|9X|3I|1Lg|3M|3M|2p|9I|1Lh|AT", "Whether the endpoint is open (excluded) rather than closed (included).", "o|2m|M7|1Lj|2p|2s|1V", "Whether the user can toggle the endpoint between open and closed by clicking it.", "o|2m|Ss|1Ll|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|1Lk|1Lm", "o|3L|M7|1V|2p|1Lj|3M", "o|3L|Ss|1V|2p|1Ll|3M", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|1Lo|1Lp|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point that marks the endpoint of an interval, rendered open or closed", "o|F|2K|RR|RS|Op|1Ln|1Lq|3M|3M|2p|2K|1Lr|Az", "sortVectorsBy", "Whether to sort vectors by component or by magnitude.", "a|na|ng", "Sort vectors by their displacement components.", "o|3s|na|1Lw", "Sort vectors by the position of their tail point.", "o|3s|ng|1Ly", "a|1Lx|1Lz", "o|Bi|1Lt|1Lu|na|1Lv|1M0|3y", "sortByComponent", "Index of the component to sort by (when sorting vectors).", "o|33|1M2|1M3|oX|1q", "sortByProp", 'Name of a property to sort by (e.g. "x" for sorting points by x-coordinate).', "o|2h|1M5|1M6|1T", "Component type to sort children as.", "o|2h|2g|1M8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1M1|1M4|1M7|1M9|gB", "o|3L|1Lt|1T|2p|1Lu|3M", "o|3L|1M2|1q|2p|1M3|3M", "a|3N|3O|3P|1MB|1MC|3Z", "Sorts a list according to a comparison function", "o|F|2L|9U|9V|g0|1MA|1MD|3M|3M|3M|2L|1ME|Az", "Component type to shuffle children as.", "o|2h|2g|1MG|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MH|gB", "Randomly shuffles its children", "o|F|2M|9U|9V|g0|1MI|125|3M|3M|3M|2M|1MJ|Az", "Names of the variables to solve for.", "o|2h|Gx|1ML|Gz", "Number of points used when searching for solutions numerically.", "o|33|Vo|1MN|12N|1p", "minVar", "Lower bound of the variable's search range.", "o|33|1MP|1MQ||1p", "maxVar", "Upper bound of the variable's search range.", "o|33|1MS|1MT||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MM|1MO|1MR|1MU", "o|3L|Vo|1p|2p|1MN|3M", "The variables of the equations.", "o|6v|Gx|H3|3M|1MX|36|I7", "numSolutions", "The number of numerical solutions found.", "o|3Q|1MZ|1q|2p|1Ma", "solutions", "The numerical solutions of the equations.", "o|6v|1Mc|1X|3M|1Md|36|75", "The first variable being solved for.", "o|3Q|H1|H3|2p|1Mf", "a|3N|3O|3P|1MW|3T|3U|3V|3W|3Z|1MY|1Mb|1Me|1Mg", "Numerically solves a system of equations", "o|F|2N|3j|3k|3l|1MV|1Mh|3M|3M|2p|2N|1Mi|3h", "Variable name displayed on the number line.", "o|33|H1|1Mk|Pw|H3", "Input format used for parsing entered subsets.", "Parse entered subsets as plain-text notation.", "o|3s|1T|1Mn", "Parse entered subsets as LaTeX notation.", "o|3s|2V|1Mp", "a|1Mo|1Mq", "o|Bi|3p|1Mm|1T|3r|1Mr|3y", "Initial subset displayed in the input.", "o|33|Zj|1Mt|AZ|1T", "o|2h|e9|eA|2O", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ml|1Ms|1Mu|1Mv", "o|3L|H1|H3|2p|1Mk|3M", "o|3L|3p|1T|2p|1Mm|3M", "o|3L|Zj|1T|2p|1Mt|3M", "subsetValue", "The current subset of the reals entered by the user.", "o|3Q|1N0|2O|2p|1N1", "The boundary points that delimit the subset.", "o|6v|UQ|1X|3M|1N3|36|75", "pointsClosed", "Whether each boundary point of the subset is a closed (included) endpoint.", "o|6v|1N5|1V|3M|1N6|36|Qq", "intervals", "The intervals (non-degenerate components) of the subset.", "o|6v|1N8|1X|3M|1N9|36|75", "isolatedPoints", "The isolated (non-interval) points of the subset.", "o|6v|1NB|1X|3M|1NC|36|75", "a|3N|3O|3P|1Mx|1My|1Mz|3T|3U|3V|3W|3Z|1N2|1N4|1N7|1NA|1ND", "An interactive number-line widget for entering a subset of real numbers (block-level; does not inherit from Input)", "o|F|9J|54|AZ|9X|1Mw|1NE|3M|2p|2p|9J|1NF|AT", "o|2m|4t|4u|3M|2s|1V", "Name of the variable used when expressing the subset.", "o|33|H1|1NI|Pw|H3", "How the subset is displayed.", "inequalities", "a|1N8|1NL", "Display the subset using interval notation (e.g., `(0, 1]`).", "o|3s|1N8|1NN", "Display the subset using inequalities (e.g., `0 < x ≤ 1`).", "o|3s|1NL|1NP", "a|1NO|1NQ", "o|Bi|xU|1NK|1N8|1NM|1NR|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|1NH|51|55|58|5B|5E|5K|5N|5R|5X|63|1NJ|1NS", "o|3L|xU|1T|2p|1NK|3M", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1NU|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1N4|1N7|1NA|1ND|7S|7V|7Y|7b", "A subset of the real numbers, defined by intervals and points", "o|F|2O|3j|3k|3l|1NT|1NV|3M|3M|2p|2O|1NW|3h", "Type of value being split.", "a|1T", "Split text values.", "o|3s|1T|1Na", "a|1Nb", "o|HC|2g|1NY|1NZ|1Nc|3y", "splitBy", "How to break the input string into pieces.", "letter", "word", "comma", "a|1Ng|1Nh|1Ni", "Split into individual characters.", "o|3s|1Ng|1Nk", "Split into whitespace-separated words.", "o|3s|1Nh|1Nm", "Split on comma boundaries.", "o|3s|1Ni|1No", "a|1Nl|1Nn|1Np", "o|Bi|1Ne|1Nf|1Ng|1Nj|1Nq|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Nd|1Nr|gB", "Splits a string or list into pieces", "o|F|2P|9U|9V|g0|1Ns|125|3M|3M|2p|2P|1Nt|Az", "data", "The data points to fit a line to.", "o|2h|1Nv|1Nw|2W", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|1Nx", "Number of dimensions of the line (always 2 for a best-fit line).", "o|3Q|6r|1p|2p|1Nz", "Whether the line can be dragged (always false for a best-fit line).", "o|3Q|5L|1V|2p|1O1", "The data points used to compute the best-fit line.", "o|6v|1Nv|1X|3M|1O3|4X|IM", "a|3N|3O|3P|Hd|QD|7s|QE|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|1O0|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up|1O2|1O4", "The best-fit line for a set of points", "o|F|2Q|Om|On|Op|1Ny|1O5|3M|2p|2p|2Q|1O6|Az", "boundaryValues", "Boundary values defining the region's left/right edges.", "a|5Q|36", "o|33|1O8|1O9|1OA|1a", "The function whose graph bounds the region.", "o|2h|1r|1OC|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OB|1OD", "o|3L|1O8|1a|2p|1O9|3M", "A textual description of the region's style.", "o|3Q|Hl|1T|2p|1OG", 'Style description including the word "region".', "o|3Q|Ho|1T|2p|1OI", "a|3N|3O|3P|Hd|QD|7s|QE|1OF|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between a curve and the x-axis", "o|F|9K|Om|On|Op|1OE|1OK|3M|2p|2p|9K|1OL|Az", "a|I|J|1z|2S|w|x|y|1r|1s", "112011101", "Boundary values defining the region's edges.", "o|33|1O8|1OP|1OA|1a", "flipFunctions", "Whether to swap the role of x and y for the input functions.", "o|2m|1OR|1OS|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OQ|1OT", "o|3L|1O8|1a|2p|1OP|3M", "o|3L|1OR|1V|2p|1OS|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1OV|1OW|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between two curves", "o|F|9L|1ON|1OO|Op|1OU|1OX|3M|2p|2p|9L|1OY|Az", "Whether the half-plane extends horizontally, bounded by the vertical line x = boundaryValue. If false, the half-plane extends vertically, bounded by the horizontal line y = boundaryValue.", "o|2m|V3|1Oa|3M|2s|1V", "boundaryValue", "Position of the bounding line: x = boundaryValue when horizontal is true, y = boundaryValue when horizontal is false.", "o|33|1Oc|1Od|5Q|1p", "greaterThan", "Whether the region is the side where the inequality is greater than the boundary.", "o|2m|1Of|1Og|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Ob|1Oe|1Oh", "o|3L|V3|1V|2p|1Oa|3M", "o|3L|1Oc|1p|2p|1Od|3M", "o|3L|1Of|1V|2p|1Og|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Oj|1Ok|1Ol|3T|3U|3V|3W|3Z|Hk", "A half-plane region bounded by a line", "o|F|9M|Om|On|Op|1Oi|1Om|3M|2p|2p|9M|1On|Az", "Initial code shown in the editor before the user types.", "o|33|Zj|1Op|AZ|1T", 'Editor width (e.g. "100%" or "600px").', "100", "o|uD|1Os|2p", "o|33|bx|1Or|1Ot|bz", 'Editor height (e.g. "500px").', "n|6S", "o|uD|1Ow|3M", "o|33|k5|1Ov|1Ox|bz", "viewerRatio", "Fraction of the editor area allotted to the live viewer.", "o|2h|1Oz|1P0|1p", "showResults", "Whether to render the results panel alongside the editor.", "o|2m|1P2|1P3|2p|2s|1V", "showFormatter", "Whether to show a code formatter button.", "o|2m|1P5|1P6|2p|2s|1V", "resultsLocation", "Position of the results panel relative to the editor.", "a|5g|5h|5i", "Place the results panel below the editor.", "o|3s|5g|1PB", "Place the results panel to the left of the editor.", "o|3s|5h|1PD", "Place the results panel to the right of the editor.", "o|3s|5i|1PF", "a|1PC|1PE|1PG", "o|Bi|1P8|1P9|5g|1PA|1PH|3y", "readOnly", "Whether the editor is read-only.", "o|2m|1PJ|1PK|2p|2s|1V", "initialOpenTab", "Which diagnostics/responses tab to open initially.", "first", "errors", "warnings", "info", "accessibility", "responses", "help", "a|42|1PO|1PP|1PQ|1PR|1PS|1PT|1PU", "Panel starts closed.", "o|3s|42|1PW", "Open the first available tab.", "o|3s|1PO|1PY", "Open the errors tab.", "o|3s|1PP|1Pa", "Open the warnings tab.", "o|3s|1PQ|1Pc", "Open the info tab.", "o|3s|1PR|1Pe", "Open the accessibility tab.", "o|3s|1PS|1Pg", "Open the responses tab.", "o|3s|1PT|1Pi", "Open the help tab.", "o|3s|1PU|1Pk", "a|1PX|1PZ|1Pb|1Pd|1Pf|1Ph|1Pj|1Pl", "o|Bi|1PM|1PN|1PO|1PV|1Pm|3y", "renderedName", "Name to assign to the dynamically-rendered DoenetML output.", "o|2h|1Po|1Pp|1T", "staticName", "Name to assign to the static DoenetML source.", "o|2h|1Pr|1Ps|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Oq|u5|1Ou|1Oy|1P1|1P4|1P7|1PI|1PL|1Pn|1Pq|1Pt", "o|3L|Zj|1T|2p|1Op|3M", "o|3L|bx|bz|2p|1Or|3M", "o|3L|k5|bz|2p|1Ov|3M", "o|3L|1P2|1V|2p|1P3|3M", "o|3L|1P5|1V|2p|1P6|3M", "o|3L|1P8|1T|2p|1P9|3M", "o|3L|1PJ|1V|2p|1PK|3M", "o|3L|1PM|1T|2p|1PN|3M", "The code value of the input.", "o|3Q|3a|1T|2p|1Q3", "The code value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|1Q5", "The current code as a plain text string.", "o|3Q|1T|1T|2p|1Q7", "a|3N|3O|3P|1Pv|1Pw|1Px|1Py|1Pz|1Q0|1Q1|1Q2|3T|3U|3V|3W|3Z|eV|eY|1Q4|1Q6|1Q8", "An interactive DoenetML code editor", "o|F|9N|9U|9V|9X|1Pu|1Q9|3M|3M|2p|9N|1QA|AT", "Variable used when comparing factored expressions.", "o|33|H1|1QC|Pw|H3", "restrictDivision", "Whether to disallow dividing through to match factored forms.", "o|2m|1QE|1QF|2p|2s|1V", "monomialFactorMustMatch", "Whether monomial factors must match exactly (implies restrictDivision).", "o|2m|1QH|1QI|2p|2s|1V", "allowOnlySignDifferences", "Whether to count factorizations as equivalent when they differ only by sign.", "o|2m|1QK|1QL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1QD|1QG|1QJ|1QM", "Whether the input math expressions share the same factoring.", "o|3Q|3a|1V|2p|1QO", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|1QP|CW", "Boolean condition that tests for equivalent factoring", "o|F|2R|3j|3k|3l|1QN|1QQ|3M|2p|2p|2R|1QR|3h", "position", "Position of the legend on the graph.", "a|5c|5d|5e|5f", "Place the legend in the upper-right corner.", "o|3s|5c|1QW", "Place the legend in the upper-left corner.", "o|3s|5d|1QY", "Place the legend in the lower-right corner.", "o|3s|5e|1Qa", "Place the legend in the lower-left corner.", "o|3s|5f|1Qc", "a|1QX|1QZ|1Qb|1Qd", "o|Bi|1QT|1QU|5c|1QV|1Qe|3y", "displayClosedSwatches", "Whether to render closed/filled swatches in the legend.", "o|2m|1Qg|1Qh|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Qf|1Qi", "o|3L|1QT|1T|2p|1QU|3M", "o|3L|1Qg|1V|2p|1Qh|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Qk|1Ql|3T|3U|3V|3W|3Z|Hk", "A legend describing the contents of a graph", "o|F|9O|Om|On|Op|1Qj|1Qm|3M|2p|2p|9O|1Qn|Az", "o|3Q|3a|2S|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|1Qp", "A label for an input, answer, button, or graphical object", "o|F|2S|2Z|2a|3l|7q|1Qq|3M|3M|2p|2S|1Qr|3h", "pattern", "Math expression pattern to match against.", "o|2h|1Qt|1Qu|1X", "allowImplicitIdentities", "Whether to allow implicit identity transformations when matching.", "o|2m|1Qw|1Qx|2p|2s|1V", "allowPermutations", "Whether to allow permutations of operands when matching.", "o|2m|1Qz|1R0|3M|2s|1V", "requireNumericMatches", "Whether numeric placeholders must match numbers.", "o|2m|1R2|1R3|2p|2s|1V", "requireVariableMatches", "Whether variable placeholders must match variables.", "o|2m|1R5|1R6|2p|2s|1V", "excludeMatches", "Patterns whose matches are excluded.", "o|33|1R8|1R9|54|1Y", "matchExpressionWithBlanks", "Whether to allow expressions with blanks to match.", "o|2m|1RB|1RC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1Qv|1Qy|1R1|1R4|1R7|1RA|1RD", "o|3L|1Qw|1V|2p|1Qx|3M", "o|3L|1Qz|1V|2p|1R0|3M", "o|3L|1R2|1V|2p|1R3|3M", "o|3L|1R5|1V|2p|1R6|3M", "o|3L|1R8|1Y|2p|1R9|3M", "o|3L|1RB|1V|2p|1RC|3M", "Whether the input matches the pattern.", "o|3Q|3a|1V|2p|1RL", "numMatches", "The number of matches found.", "o|3Q|1RN|1p|2p|1RO", "patternMatches", "The list of matched sub-expressions.", "o|6v|1RQ|1X|3M|1RR|36|75", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|1RF|1RG|1RH|1RI|1RJ|1RK|3T|3U|3V|3W|3Z|1RM|CW|1RP|1RS", "Boolean condition that tests whether input matches a math pattern", "o|F|2T|3j|3k|3l|1RE|1RT|3M|3M|2p|2T|1RU|3h", "childContextHelp", "a|3|4|5|6|7|8|9|A|B|C|D|E|1RW", "a|93|1z|94", "020", "Value used for entries that aren't explicitly specified.", "o|33|e0|1Ra|Ng|1X", "Number of rows in the matrix.", "o|2h|7A|1Rc|1q", "Number of columns in the matrix.", "o|2h|7D|1Re|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Rb|1Rd|1Rf", "Whether matrix entries should be treated as unordered.", "o|3Q|4n|1V|2p|1Rh", "o|3Q|3a|2U|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1Ri|1Rj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A matrix of math values", "a|93|94", "matrixRow", "matrixColumn", "o|1Rm|1Rn|1Ro", "o|1RX|2U|1RY|1RZ|3l|1Rg|1Rk|3M|2p|2p|2U|1Rl|3h|1Rp", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j", "numEigenvectors", "The number of eigenvectors found in the decomposition.", "o|3Q|1Rs|1q|2p|1Rt", "eigenvalues", "The eigenvalues of the matrix.", "o|6v|1Rv|1p|3M|1Rw|36|IR", "eigenvectors", "The eigenvectors of the matrix, as a 2D array (one column per eigenvalue).", "a|X0|6y", "o|Qc|1Ry|1p|3M|1Rz|4X|1S0|Qf", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1Ru|1Rx|1S1", "Computes the eigenvalues and eigenvectors of a square matrix", "o|F|9P|3j|3k|Ao|1Rr|1S2|3M|2p|2p|9P|1S3|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19|w|x|y|1J|1K|1N|1R|1S|1d|1f|1h|1i|1k|1r|1s|2K|2Q|2W|2Y|O|P", "1220111222222222111111111111111111111112210222022212221222212222211121222112111111111111111111222222222222222222201", "o|2m|JZ|Ja|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|1S7|5X|63", "o|3Q|3a|2V|2p|fs", "The LaTeX content as a string.", "o|3Q|2V|2V|2p|1SA", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1S9|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1SB", "A snippet of LaTeX that can be rendered as math", "o|F|2V|1S5|1S6|3l|1S8|1SC|3M|3M|2p|2V|1SD|3h", "A block-level quotation", "o|F|9Q|9U|9V|9X|3I|Aa|3M|3M|2p|9Q|1SF|AT", "Extra information about an enclosing component, shown to all users in a popup or disclosure", "o|F|2f|9U|9V|9X|3I|Aa|2p|3M|2p|2f|1SH|AT", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "112022222222222222222222222222111122222121111111111111222222122222222122221111121222", "Whether the snapping threshold is interpreted relative to graph scales.", "o|2m|194|1SL|2p|2s|1V", "Distance threshold within which group members snap together.", "o|2h|E6|1SN|1p", "angleThreshold", "Angular distance within which group members snap together.", "n|0.:7C4pdy2qXy", "o|33|1SP|1SQ|1SR|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1SM|1SO|1SS", "o|3L|194|1V|2p|1SL|3M", "o|3L|1SP|1p|2p|1SQ|3M", "Distance within which group members attract each other.", "o|3Q|E6|1p|2p|1SW", "a|3N|3O|3P|Hd|QD|7s|QE|1SU|1SV|3T|3U|3V|3W|3Z|Hk|T4|1SX", "Constrains group members to attract to each other when nearby", "o|F|9R|1SJ|1SK|Op|1ST|1SY|3M|2p|2p|9R|1SZ|Az", "a|8J", "_blockScoredComponent", "a|1Sc|9W|2d", "maxNumColumns", "Maximum number of columns when arranging child problems.", "o|33|1Se|1Sf|4X|1q", "mode", "Arrangement mode for the child problems.", "circuit", "a|9S|1Sj", "Interleaved arrangement where each problem's answer feeds the next and one can start with any problem.", "o|3s|9S|1Sl", "A variant of the pretzel where one must start with the first problem.", "o|3s|1Sj|1Sn", "a|1Sm|1So", "o|Bi|1Sh|1Si|9S|1Sk|1Sp|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|1Sg|1Sq", "o|3L|1Se|1q|2p|1Sf|3M", "o|3L|1Sh|1T|2p|1Si|3M", "numProblems", "The number of child problems.", "o|3Q|1Su|1q|2p|1Sv", "The current responses across all child problems.", "o|6v|re|1T|3M|1Sx|36|Jt", "The number of responses submitted.", "o|3Q|rk|1p|2p|1Sz", "The most recently submitted responses.", "o|6v|rn|1T|3M|1T1|36|Jt", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|1Ss|1St|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|1Sw|1Sy|1T0|1T2", "A response-matching component where students enter a sequence to match statements and answers", "o|F|9S|1Sb|Nf|1Sd|1Sr|1T3|3M|2p|2p|9S|1T4|AT", "o|2m|L8|L9|3M|2s|1V", "hideFutureSections", "Whether to hide later cascade sections until previous ones are completed.", "o|2m|1T7|1T8|2p|2s|1V", "revealAll", "Whether all cascade entries should be revealed regardless of progress.", "o|2m|1TA|1TB|2p|2s|1V", "boxAll", "Whether to draw boxes around all cascade entries regardless of progress.", "o|2m|1TD|1TE|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|1T6|LD|LG|LI|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|1T9|1TC|1TF", "o|3L|1T7|1V|2p|1T8|3M", "o|3Q|20|1V|2p|LH", "numCompleted", "The number of cascade sections currently completed.", "o|3Q|1TJ|1q|2p|1TK", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Ly|1TH|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9|1TI|1TL", "Sectional component that reveals its children step-by-step", "o|F|9T|Ku|Kv|N8|1TG|1TM|3M|3M|2p|9T|1TN|AT", "The short description text.", "o|3Q|3a|dd|2p|1TP", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1TQ|3e", "A short accessibility description (e.g. for a `<graph>`) read by screen readers", "o|F|dd|2Z|2a|2e|3I|1TR|2p|3M|2p|dd|1TS|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|1z|21|24|29|2A|2K|2O|2U|2W|2X|2Y|L|M|N|Q|w|x|y|z|1K|1L|1M|1N|1R|1S|1T|1U|1a|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2Q|2V", "1111111111111111111111111022012122212111122222222222222222222222222222222222222", "Whether the order of points in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1TW|2p|2s|1V", "Maximum number of points to retain in the list.", "o|33|g7|1TY|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1TX|1TZ|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1TY|3M", "The number of points in the list.", "o|3Q|Ps|1p|2p|1Tc", "o|3Q|gI|1p|2p|1Tc", "a|3N|3O|1Tb|3Z|gy|1Td|1Te", "A list of points", "o|F|2W|1TU|1TV|g0|1Ta|1Tf|3M|3M|2p|2W|1Tg|Az", "a|1t|1z|2X|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2Y", "0221222211111111111111111111112222222221222202222122222222222212222212222121222", "Whether the order of intervals in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1Tk|2p|2s|1V", "Maximum number of intervals to retain in the list.", "o|33|g7|1Tm|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1Tl|1Tn|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1Tm|3M", "numIntervals", "The number of intervals in the list.", "o|3Q|1Tq|1p|2p|1Tr", "o|3Q|gI|1p|2p|1Tr", "a|3N|3O|1Tp|3Z|gy|1Ts|1Tt", "A list of intervals", "o|F|2X|1Ti|1Tj|g0|1To|1Tu|3M|3M|2p|2X|1Tv|Az", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr", "a|3N|3O|n8|3Z|gy|nD|nE", "A list of vectors", "o|F|2Y|mh|mi|g0|1Tx|1Ty|3M|3M|2p|2Y|1Tz|Az", "a|3i|7e|84|88|AU|AW|AY|Ac|Ae|Am|B0|BD|BF|BL|BQ|BS|BX|Cb|Ck|Cm|Co|Cq|Cs|Cz|D1|DD|DT|DX|Dm|Dq|E5|EE|EJ|EN|ER|EV|EZ|Ed|Eh|Eq|Eu|Ey|F2|F6|FA|FE|FI|Fn|J9|JB|JU|K7|KE|KG|KI|KK|KM|KO|KQ|KS|KU|KW|Kd|Kf|Kh|Kj|Kl|Kn|Kp|Kr|MC|ME|MG|MK|MS|MW|Md|Mf|Mh|Mj|Ml|Mn|Mp|Mr|Mt|Mv|N7|ND|NF|NP|NR|NW|Ol|RI|TU|Us|Xe|Yf|Z8|ZQ|ZY|Zi|a4|aC|bu|cl|co|cq|cs|cu|cw|d1|dE|dc|eo|fK|fW|fY|fp|fw|gN|gP|gU|gf|gj|h7|h9|hJ|hW|hu|hy|i5|i9|if|j6|jC|jk|jp|kJ|lC|m1|mS|mW|mg|nH|oT|pH|s8|ss|t5|u0|uU|us|vp|wK|wm|wr|10d|10g|111|117|11J|11Q|11e|127|137|14Q|155|15d|15l|15v|16s|17B|17U|17k|17n|187|18X|18g|191|19B|19L|19P|19W|19Y|19g|19o|19v|1AG|1Ao|1B1|1BI|1C3|1CO|1D6|1DI|1Dm|1E2|1Ed|1FG|1Hg|1IY|1Ih|1Io|1J4|1JD|1JF|1JH|1Jl|1KT|1Km|1Kv|1LL|1LP|1LR|1LV|1Ld|1Li|1Ls|1MF|1MK|1Mj|1NG|1NX|1Nu|1O7|1OM|1OZ|1Oo|1QB|1QS|1Qo|1Qs|1RV|1Rq|1S4|1SE|1SG|1SI|1Sa|1T5|1TO|1TT|1Th|1Tw|1U0", "a|1Rn|1Ro", "displayName", "a|3|7|8|C|D|4|5|6|A|1U3|156", "row_matrix", "A list of math values defining the row of a matrix", "in a matrix", "o|1U4|1Rn|gw|h5|1U5|1U6|3j|3k|g0|3M|93|1U7", "column_matrix", "A list of math values defining the column of a matrix", "o|1U4|1Ro|gw|h5|1U9|1UA|3j|3k|g0|3M|94|1U7", "o|1U2|1U8|1UB", "o|2|1U1|1UC"], "1UD"]);
distExports$2.decompress([["multiple-choice-answer", "multiple-choice-select-multiple-answer", "if-at-(immediate-feedback-assessment-technique)-answer", "answer-labeled", "pretzel-06", "pretzel-08", "pretzel-10", "pretzel-12", "table-with-tabular", "video-watched-credit", "a|0|1|2|3|4|5|6|7|8|9", "element", "snippet", "description", "cursor", "a|B|C|D|E", "answer", '\n<answer name="mcq" inline="false" shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>', "Multiple choice answer template", "selectionStartOffset", "selectionEndOffset", "a|J|K", "n|F", "n|I", "o|L|M|N", "o|F|G|H|I|O", '\n<answer name="mcq" selectMultiple inline="false" shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>', "Multiple choice select-multiple answer template", "o|F|G|Q|R|O", '\n<answer name="ifat" disableWrongChoices creditByAttempt="1 0.7 0.5" disableAfterCorrect shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>', "IF-AT (Immediate Feedback Assessment Technique) answer template", "n|J", "o|L|M|V", "o|F|G|T|U|W", '\n<answer name="answer1">\n  <label></label>\n</answer>', "answer with label (for accessibility)", "n|M", "o|L|M|a", "o|F|G|Y|Z|b", "pretzel", '\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>', "Pretzel template with 6 problems", "n|G", "n|O", "o|L|g|h", "o|F|d|e|f|i", '\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>', "Pretzel template with 8 problems", "o|F|d|k|l|i", '\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 9 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 10 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>', "Pretzel template with 10 problems", "o|F|d|n|o|i", '\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 9 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 10 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 11 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 12 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>', "Pretzel template with 12 problems", "o|F|d|q|r|i", "table", '\n<table name="table1">\n  <title></title>\n  <tabular>\n    <row header>\n      <cell></cell>\n      <cell></cell>\n    </row>\n    <row>\n      <cell></cell>\n      <cell></cell>\n    </row>\n  </tabular>\n</table>', "Table with tabular template", "n|E", "n|K", "o|L|w|x", "o|F|t|u|v|y", "video", '\n<video name="video1" youtube="" >\n  <shortDescription></shortDescription>\n</video>\n<answer name="video1Watched" type="videoWatched" video="$video1" />\n', "Video that gives credit when watched", "o|F|10|11|12|y", "o|A|P|S|X|c|j|m|p|s|z|13"], "14"]);
var main$3 = {};
var api$2 = {};
var semanticTokens = {};
var main$2$1 = {};
var main$1$1 = {};
var ril$1 = {};
var api$1$1 = {};
var messages$1$1 = {};
var is$2 = {};
var hasRequiredIs$2;
function requireIs$2() {
  if (hasRequiredIs$2) return is$2;
  hasRequiredIs$2 = 1;
  Object.defineProperty(is$2, "__esModule", { value: true });
  is$2.stringArray = is$2.array = is$2.func = is$2.error = is$2.number = is$2.string = is$2.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is$2.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is$2.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is$2.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is$2.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is$2.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is$2.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is$2.stringArray = stringArray;
  return is$2;
}
var hasRequiredMessages$1$1;
function requireMessages$1$1() {
  if (hasRequiredMessages$1$1) return messages$1$1;
  hasRequiredMessages$1$1 = 1;
  Object.defineProperty(messages$1$1, "__esModule", { value: true });
  messages$1$1.Message = messages$1$1.NotificationType9 = messages$1$1.NotificationType8 = messages$1$1.NotificationType7 = messages$1$1.NotificationType6 = messages$1$1.NotificationType5 = messages$1$1.NotificationType4 = messages$1$1.NotificationType3 = messages$1$1.NotificationType2 = messages$1$1.NotificationType1 = messages$1$1.NotificationType0 = messages$1$1.NotificationType = messages$1$1.RequestType9 = messages$1$1.RequestType8 = messages$1$1.RequestType7 = messages$1$1.RequestType6 = messages$1$1.RequestType5 = messages$1$1.RequestType4 = messages$1$1.RequestType3 = messages$1$1.RequestType2 = messages$1$1.RequestType1 = messages$1$1.RequestType = messages$1$1.RequestType0 = messages$1$1.AbstractMessageSignature = messages$1$1.ParameterStructures = messages$1$1.ResponseError = messages$1$1.ErrorCodes = void 0;
  const is2 = requireIs$2();
  var ErrorCodes;
  (function(ErrorCodes2) {
    ErrorCodes2.ParseError = -32700;
    ErrorCodes2.InvalidRequest = -32600;
    ErrorCodes2.MethodNotFound = -32601;
    ErrorCodes2.InvalidParams = -32602;
    ErrorCodes2.InternalError = -32603;
    ErrorCodes2.jsonrpcReservedErrorRangeStart = -32099;
    ErrorCodes2.serverErrorStart = -32099;
    ErrorCodes2.MessageWriteError = -32099;
    ErrorCodes2.MessageReadError = -32098;
    ErrorCodes2.PendingResponseRejected = -32097;
    ErrorCodes2.ConnectionInactive = -32096;
    ErrorCodes2.ServerNotInitialized = -32002;
    ErrorCodes2.UnknownErrorCode = -32001;
    ErrorCodes2.jsonrpcReservedErrorRangeEnd = -32e3;
    ErrorCodes2.serverErrorEnd = -32e3;
  })(ErrorCodes || (messages$1$1.ErrorCodes = ErrorCodes = {}));
  class ResponseError extends Error {
    constructor(code2, message, data) {
      super(message);
      this.code = is2.number(code2) ? code2 : ErrorCodes.UnknownErrorCode;
      this.data = data;
      Object.setPrototypeOf(this, ResponseError.prototype);
    }
    toJson() {
      const result2 = {
        code: this.code,
        message: this.message
      };
      if (this.data !== void 0) {
        result2.data = this.data;
      }
      return result2;
    }
  }
  messages$1$1.ResponseError = ResponseError;
  class ParameterStructures {
    constructor(kind) {
      this.kind = kind;
    }
    static is(value) {
      return value === ParameterStructures.auto || value === ParameterStructures.byName || value === ParameterStructures.byPosition;
    }
    toString() {
      return this.kind;
    }
  }
  messages$1$1.ParameterStructures = ParameterStructures;
  ParameterStructures.auto = new ParameterStructures("auto");
  ParameterStructures.byPosition = new ParameterStructures("byPosition");
  ParameterStructures.byName = new ParameterStructures("byName");
  class AbstractMessageSignature {
    constructor(method, numberOfParams) {
      this.method = method;
      this.numberOfParams = numberOfParams;
    }
    get parameterStructures() {
      return ParameterStructures.auto;
    }
  }
  messages$1$1.AbstractMessageSignature = AbstractMessageSignature;
  class RequestType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1$1.RequestType0 = RequestType0;
  class RequestType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1$1.RequestType = RequestType;
  class RequestType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1$1.RequestType1 = RequestType1;
  class RequestType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1$1.RequestType2 = RequestType2;
  class RequestType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1$1.RequestType3 = RequestType3;
  class RequestType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1$1.RequestType4 = RequestType4;
  class RequestType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1$1.RequestType5 = RequestType5;
  class RequestType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1$1.RequestType6 = RequestType6;
  class RequestType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1$1.RequestType7 = RequestType7;
  class RequestType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1$1.RequestType8 = RequestType8;
  class RequestType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1$1.RequestType9 = RequestType9;
  class NotificationType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1$1.NotificationType = NotificationType;
  class NotificationType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1$1.NotificationType0 = NotificationType0;
  class NotificationType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1$1.NotificationType1 = NotificationType1;
  class NotificationType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1$1.NotificationType2 = NotificationType2;
  class NotificationType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1$1.NotificationType3 = NotificationType3;
  class NotificationType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1$1.NotificationType4 = NotificationType4;
  class NotificationType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1$1.NotificationType5 = NotificationType5;
  class NotificationType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1$1.NotificationType6 = NotificationType6;
  class NotificationType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1$1.NotificationType7 = NotificationType7;
  class NotificationType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1$1.NotificationType8 = NotificationType8;
  class NotificationType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1$1.NotificationType9 = NotificationType9;
  var Message;
  (function(Message2) {
    function isRequest(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && (is2.string(candidate.id) || is2.number(candidate.id));
    }
    Message2.isRequest = isRequest;
    function isNotification(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && message.id === void 0;
    }
    Message2.isNotification = isNotification;
    function isResponse(message) {
      const candidate = message;
      return candidate && (candidate.result !== void 0 || !!candidate.error) && (is2.string(candidate.id) || is2.number(candidate.id) || candidate.id === null);
    }
    Message2.isResponse = isResponse;
  })(Message || (messages$1$1.Message = Message = {}));
  return messages$1$1;
}
var linkedMap$1 = {};
var hasRequiredLinkedMap$1;
function requireLinkedMap$1() {
  if (hasRequiredLinkedMap$1) return linkedMap$1;
  hasRequiredLinkedMap$1 = 1;
  var _a2;
  Object.defineProperty(linkedMap$1, "__esModule", { value: true });
  linkedMap$1.LRUCache = linkedMap$1.LinkedMap = linkedMap$1.Touch = void 0;
  var Touch;
  (function(Touch2) {
    Touch2.None = 0;
    Touch2.First = 1;
    Touch2.AsOld = Touch2.First;
    Touch2.Last = 2;
    Touch2.AsNew = Touch2.Last;
  })(Touch || (linkedMap$1.Touch = Touch = {}));
  class LinkedMap {
    constructor() {
      this[_a2] = "LinkedMap";
      this._map = /* @__PURE__ */ new Map();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state = 0;
    }
    clear() {
      this._map.clear();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state++;
    }
    isEmpty() {
      return !this._head && !this._tail;
    }
    get size() {
      return this._size;
    }
    get first() {
      return this._head?.value;
    }
    get last() {
      return this._tail?.value;
    }
    has(key) {
      return this._map.has(key);
    }
    get(key, touch = Touch.None) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      if (touch !== Touch.None) {
        this.touch(item, touch);
      }
      return item.value;
    }
    set(key, value, touch = Touch.None) {
      let item = this._map.get(key);
      if (item) {
        item.value = value;
        if (touch !== Touch.None) {
          this.touch(item, touch);
        }
      } else {
        item = { key, value, next: void 0, previous: void 0 };
        switch (touch) {
          case Touch.None:
            this.addItemLast(item);
            break;
          case Touch.First:
            this.addItemFirst(item);
            break;
          case Touch.Last:
            this.addItemLast(item);
            break;
          default:
            this.addItemLast(item);
            break;
        }
        this._map.set(key, item);
        this._size++;
      }
      return this;
    }
    delete(key) {
      return !!this.remove(key);
    }
    remove(key) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      this._map.delete(key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    shift() {
      if (!this._head && !this._tail) {
        return void 0;
      }
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      const item = this._head;
      this._map.delete(item.key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    forEach(callbackfn, thisArg) {
      const state = this._state;
      let current2 = this._head;
      while (current2) {
        if (thisArg) {
          callbackfn.bind(thisArg)(current2.value, current2.key, this);
        } else {
          callbackfn(current2.value, current2.key, this);
        }
        if (this._state !== state) {
          throw new Error(`LinkedMap got modified during iteration.`);
        }
        current2 = current2.next;
      }
    }
    keys() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.key, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    values() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.value, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    entries() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: [current2.key, current2.value], done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    [(_a2 = Symbol.toStringTag, Symbol.iterator)]() {
      return this.entries();
    }
    trimOld(newSize) {
      if (newSize >= this.size) {
        return;
      }
      if (newSize === 0) {
        this.clear();
        return;
      }
      let current2 = this._head;
      let currentSize = this.size;
      while (current2 && currentSize > newSize) {
        this._map.delete(current2.key);
        current2 = current2.next;
        currentSize--;
      }
      this._head = current2;
      this._size = currentSize;
      if (current2) {
        current2.previous = void 0;
      }
      this._state++;
    }
    addItemFirst(item) {
      if (!this._head && !this._tail) {
        this._tail = item;
      } else if (!this._head) {
        throw new Error("Invalid list");
      } else {
        item.next = this._head;
        this._head.previous = item;
      }
      this._head = item;
      this._state++;
    }
    addItemLast(item) {
      if (!this._head && !this._tail) {
        this._head = item;
      } else if (!this._tail) {
        throw new Error("Invalid list");
      } else {
        item.previous = this._tail;
        this._tail.next = item;
      }
      this._tail = item;
      this._state++;
    }
    removeItem(item) {
      if (item === this._head && item === this._tail) {
        this._head = void 0;
        this._tail = void 0;
      } else if (item === this._head) {
        if (!item.next) {
          throw new Error("Invalid list");
        }
        item.next.previous = void 0;
        this._head = item.next;
      } else if (item === this._tail) {
        if (!item.previous) {
          throw new Error("Invalid list");
        }
        item.previous.next = void 0;
        this._tail = item.previous;
      } else {
        const next = item.next;
        const previous2 = item.previous;
        if (!next || !previous2) {
          throw new Error("Invalid list");
        }
        next.previous = previous2;
        previous2.next = next;
      }
      item.next = void 0;
      item.previous = void 0;
      this._state++;
    }
    touch(item, touch) {
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      if (touch !== Touch.First && touch !== Touch.Last) {
        return;
      }
      if (touch === Touch.First) {
        if (item === this._head) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._tail) {
          previous2.next = void 0;
          this._tail = previous2;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.previous = void 0;
        item.next = this._head;
        this._head.previous = item;
        this._head = item;
        this._state++;
      } else if (touch === Touch.Last) {
        if (item === this._tail) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._head) {
          next.previous = void 0;
          this._head = next;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.next = void 0;
        item.previous = this._tail;
        this._tail.next = item;
        this._tail = item;
        this._state++;
      }
    }
    toJSON() {
      const data = [];
      this.forEach((value, key) => {
        data.push([key, value]);
      });
      return data;
    }
    fromJSON(data) {
      this.clear();
      for (const [key, value] of data) {
        this.set(key, value);
      }
    }
  }
  linkedMap$1.LinkedMap = LinkedMap;
  class LRUCache extends LinkedMap {
    constructor(limit, ratio = 1) {
      super();
      this._limit = limit;
      this._ratio = Math.min(Math.max(0, ratio), 1);
    }
    get limit() {
      return this._limit;
    }
    set limit(limit) {
      this._limit = limit;
      this.checkTrim();
    }
    get ratio() {
      return this._ratio;
    }
    set ratio(ratio) {
      this._ratio = Math.min(Math.max(0, ratio), 1);
      this.checkTrim();
    }
    get(key, touch = Touch.AsNew) {
      return super.get(key, touch);
    }
    peek(key) {
      return super.get(key, Touch.None);
    }
    set(key, value) {
      super.set(key, value, Touch.Last);
      this.checkTrim();
      return this;
    }
    checkTrim() {
      if (this.size > this._limit) {
        this.trimOld(Math.round(this._limit * this._ratio));
      }
    }
  }
  linkedMap$1.LRUCache = LRUCache;
  return linkedMap$1;
}
var disposable$1 = {};
var hasRequiredDisposable$1;
function requireDisposable$1() {
  if (hasRequiredDisposable$1) return disposable$1;
  hasRequiredDisposable$1 = 1;
  Object.defineProperty(disposable$1, "__esModule", { value: true });
  disposable$1.Disposable = void 0;
  var Disposable;
  (function(Disposable2) {
    function create2(func) {
      return {
        dispose: func
      };
    }
    Disposable2.create = create2;
  })(Disposable || (disposable$1.Disposable = Disposable = {}));
  return disposable$1;
}
var events$1 = {};
var ral$1 = {};
var hasRequiredRal$1;
function requireRal$1() {
  if (hasRequiredRal$1) return ral$1;
  hasRequiredRal$1 = 1;
  Object.defineProperty(ral$1, "__esModule", { value: true });
  let _ral;
  function RAL() {
    if (_ral === void 0) {
      throw new Error(`No runtime abstraction layer installed`);
    }
    return _ral;
  }
  (function(RAL2) {
    function install(ral2) {
      if (ral2 === void 0) {
        throw new Error(`No runtime abstraction layer provided`);
      }
      _ral = ral2;
    }
    RAL2.install = install;
  })(RAL || (RAL = {}));
  ral$1.default = RAL;
  return ral$1;
}
var hasRequiredEvents$1;
function requireEvents$1() {
  if (hasRequiredEvents$1) return events$1;
  hasRequiredEvents$1 = 1;
  Object.defineProperty(events$1, "__esModule", { value: true });
  events$1.Emitter = events$1.Event = void 0;
  const ral_1 = requireRal$1();
  var Event2;
  (function(Event22) {
    const _disposable = { dispose() {
    } };
    Event22.None = function() {
      return _disposable;
    };
  })(Event2 || (events$1.Event = Event2 = {}));
  class CallbackList {
    add(callback, context = null, bucket) {
      if (!this._callbacks) {
        this._callbacks = [];
        this._contexts = [];
      }
      this._callbacks.push(callback);
      this._contexts.push(context);
      if (Array.isArray(bucket)) {
        bucket.push({ dispose: () => this.remove(callback, context) });
      }
    }
    remove(callback, context = null) {
      if (!this._callbacks) {
        return;
      }
      let foundCallbackWithDifferentContext = false;
      for (let i2 = 0, len = this._callbacks.length; i2 < len; i2++) {
        if (this._callbacks[i2] === callback) {
          if (this._contexts[i2] === context) {
            this._callbacks.splice(i2, 1);
            this._contexts.splice(i2, 1);
            return;
          } else {
            foundCallbackWithDifferentContext = true;
          }
        }
      }
      if (foundCallbackWithDifferentContext) {
        throw new Error("When adding a listener with a context, you should remove it with the same context");
      }
    }
    invoke(...args) {
      if (!this._callbacks) {
        return [];
      }
      const ret = [], callbacks = this._callbacks.slice(0), contexts = this._contexts.slice(0);
      for (let i2 = 0, len = callbacks.length; i2 < len; i2++) {
        try {
          ret.push(callbacks[i2].apply(contexts[i2], args));
        } catch (e2) {
          (0, ral_1.default)().console.error(e2);
        }
      }
      return ret;
    }
    isEmpty() {
      return !this._callbacks || this._callbacks.length === 0;
    }
    dispose() {
      this._callbacks = void 0;
      this._contexts = void 0;
    }
  }
  class Emitter {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * For the public to allow to subscribe
     * to events from this Emitter
     */
    get event() {
      if (!this._event) {
        this._event = (listener, thisArgs, disposables) => {
          if (!this._callbacks) {
            this._callbacks = new CallbackList();
          }
          if (this._options && this._options.onFirstListenerAdd && this._callbacks.isEmpty()) {
            this._options.onFirstListenerAdd(this);
          }
          this._callbacks.add(listener, thisArgs);
          const result2 = {
            dispose: () => {
              if (!this._callbacks) {
                return;
              }
              this._callbacks.remove(listener, thisArgs);
              result2.dispose = Emitter._noop;
              if (this._options && this._options.onLastListenerRemove && this._callbacks.isEmpty()) {
                this._options.onLastListenerRemove(this);
              }
            }
          };
          if (Array.isArray(disposables)) {
            disposables.push(result2);
          }
          return result2;
        };
      }
      return this._event;
    }
    /**
     * To be kept private to fire an event to
     * subscribers
     */
    fire(event) {
      if (this._callbacks) {
        this._callbacks.invoke.call(this._callbacks, event);
      }
    }
    dispose() {
      if (this._callbacks) {
        this._callbacks.dispose();
        this._callbacks = void 0;
      }
    }
  }
  events$1.Emitter = Emitter;
  Emitter._noop = function() {
  };
  return events$1;
}
var cancellation$1 = {};
var hasRequiredCancellation$1;
function requireCancellation$1() {
  if (hasRequiredCancellation$1) return cancellation$1;
  hasRequiredCancellation$1 = 1;
  Object.defineProperty(cancellation$1, "__esModule", { value: true });
  cancellation$1.CancellationTokenSource = cancellation$1.CancellationToken = void 0;
  const ral_1 = requireRal$1();
  const Is2 = requireIs$2();
  const events_1 = requireEvents$1();
  var CancellationToken;
  (function(CancellationToken2) {
    CancellationToken2.None = Object.freeze({
      isCancellationRequested: false,
      onCancellationRequested: events_1.Event.None
    });
    CancellationToken2.Cancelled = Object.freeze({
      isCancellationRequested: true,
      onCancellationRequested: events_1.Event.None
    });
    function is2(value) {
      const candidate = value;
      return candidate && (candidate === CancellationToken2.None || candidate === CancellationToken2.Cancelled || Is2.boolean(candidate.isCancellationRequested) && !!candidate.onCancellationRequested);
    }
    CancellationToken2.is = is2;
  })(CancellationToken || (cancellation$1.CancellationToken = CancellationToken = {}));
  const shortcutEvent = Object.freeze(function(callback, context) {
    const handle = (0, ral_1.default)().timer.setTimeout(callback.bind(context), 0);
    return { dispose() {
      handle.dispose();
    } };
  });
  class MutableToken {
    constructor() {
      this._isCancelled = false;
    }
    cancel() {
      if (!this._isCancelled) {
        this._isCancelled = true;
        if (this._emitter) {
          this._emitter.fire(void 0);
          this.dispose();
        }
      }
    }
    get isCancellationRequested() {
      return this._isCancelled;
    }
    get onCancellationRequested() {
      if (this._isCancelled) {
        return shortcutEvent;
      }
      if (!this._emitter) {
        this._emitter = new events_1.Emitter();
      }
      return this._emitter.event;
    }
    dispose() {
      if (this._emitter) {
        this._emitter.dispose();
        this._emitter = void 0;
      }
    }
  }
  class CancellationTokenSource {
    get token() {
      if (!this._token) {
        this._token = new MutableToken();
      }
      return this._token;
    }
    cancel() {
      if (!this._token) {
        this._token = CancellationToken.Cancelled;
      } else {
        this._token.cancel();
      }
    }
    dispose() {
      if (!this._token) {
        this._token = CancellationToken.None;
      } else if (this._token instanceof MutableToken) {
        this._token.dispose();
      }
    }
  }
  cancellation$1.CancellationTokenSource = CancellationTokenSource;
  return cancellation$1;
}
var sharedArrayCancellation$1 = {};
var hasRequiredSharedArrayCancellation$1;
function requireSharedArrayCancellation$1() {
  if (hasRequiredSharedArrayCancellation$1) return sharedArrayCancellation$1;
  hasRequiredSharedArrayCancellation$1 = 1;
  Object.defineProperty(sharedArrayCancellation$1, "__esModule", { value: true });
  sharedArrayCancellation$1.SharedArrayReceiverStrategy = sharedArrayCancellation$1.SharedArraySenderStrategy = void 0;
  const cancellation_1 = requireCancellation$1();
  var CancellationState;
  (function(CancellationState2) {
    CancellationState2.Continue = 0;
    CancellationState2.Cancelled = 1;
  })(CancellationState || (CancellationState = {}));
  class SharedArraySenderStrategy {
    constructor() {
      this.buffers = /* @__PURE__ */ new Map();
    }
    enableCancellation(request) {
      if (request.id === null) {
        return;
      }
      const buffer = new SharedArrayBuffer(4);
      const data = new Int32Array(buffer, 0, 1);
      data[0] = CancellationState.Continue;
      this.buffers.set(request.id, buffer);
      request.$cancellationData = buffer;
    }
    async sendCancellation(_conn, id2) {
      const buffer = this.buffers.get(id2);
      if (buffer === void 0) {
        return;
      }
      const data = new Int32Array(buffer, 0, 1);
      Atomics.store(data, 0, CancellationState.Cancelled);
    }
    cleanup(id2) {
      this.buffers.delete(id2);
    }
    dispose() {
      this.buffers.clear();
    }
  }
  sharedArrayCancellation$1.SharedArraySenderStrategy = SharedArraySenderStrategy;
  class SharedArrayBufferCancellationToken {
    constructor(buffer) {
      this.data = new Int32Array(buffer, 0, 1);
    }
    get isCancellationRequested() {
      return Atomics.load(this.data, 0) === CancellationState.Cancelled;
    }
    get onCancellationRequested() {
      throw new Error(`Cancellation over SharedArrayBuffer doesn't support cancellation events`);
    }
  }
  class SharedArrayBufferCancellationTokenSource {
    constructor(buffer) {
      this.token = new SharedArrayBufferCancellationToken(buffer);
    }
    cancel() {
    }
    dispose() {
    }
  }
  class SharedArrayReceiverStrategy {
    constructor() {
      this.kind = "request";
    }
    createCancellationTokenSource(request) {
      const buffer = request.$cancellationData;
      if (buffer === void 0) {
        return new cancellation_1.CancellationTokenSource();
      }
      return new SharedArrayBufferCancellationTokenSource(buffer);
    }
  }
  sharedArrayCancellation$1.SharedArrayReceiverStrategy = SharedArrayReceiverStrategy;
  return sharedArrayCancellation$1;
}
var messageReader$1 = {};
var semaphore$1 = {};
var hasRequiredSemaphore$1;
function requireSemaphore$1() {
  if (hasRequiredSemaphore$1) return semaphore$1;
  hasRequiredSemaphore$1 = 1;
  Object.defineProperty(semaphore$1, "__esModule", { value: true });
  semaphore$1.Semaphore = void 0;
  const ral_1 = requireRal$1();
  class Semaphore {
    constructor(capacity = 1) {
      if (capacity <= 0) {
        throw new Error("Capacity must be greater than 0");
      }
      this._capacity = capacity;
      this._active = 0;
      this._waiting = [];
    }
    lock(thunk2) {
      return new Promise((resolve, reject2) => {
        this._waiting.push({ thunk: thunk2, resolve, reject: reject2 });
        this.runNext();
      });
    }
    get active() {
      return this._active;
    }
    runNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      (0, ral_1.default)().timer.setImmediate(() => this.doRunNext());
    }
    doRunNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      const next = this._waiting.shift();
      this._active++;
      if (this._active > this._capacity) {
        throw new Error(`To many thunks active`);
      }
      try {
        const result2 = next.thunk();
        if (result2 instanceof Promise) {
          result2.then((value) => {
            this._active--;
            next.resolve(value);
            this.runNext();
          }, (err) => {
            this._active--;
            next.reject(err);
            this.runNext();
          });
        } else {
          this._active--;
          next.resolve(result2);
          this.runNext();
        }
      } catch (err) {
        this._active--;
        next.reject(err);
        this.runNext();
      }
    }
  }
  semaphore$1.Semaphore = Semaphore;
  return semaphore$1;
}
var hasRequiredMessageReader$1;
function requireMessageReader$1() {
  if (hasRequiredMessageReader$1) return messageReader$1;
  hasRequiredMessageReader$1 = 1;
  Object.defineProperty(messageReader$1, "__esModule", { value: true });
  messageReader$1.ReadableStreamMessageReader = messageReader$1.AbstractMessageReader = messageReader$1.MessageReader = void 0;
  const ral_1 = requireRal$1();
  const Is2 = requireIs$2();
  const events_1 = requireEvents$1();
  const semaphore_1 = requireSemaphore$1();
  var MessageReader;
  (function(MessageReader2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.listen) && Is2.func(candidate.dispose) && Is2.func(candidate.onError) && Is2.func(candidate.onClose) && Is2.func(candidate.onPartialMessage);
    }
    MessageReader2.is = is2;
  })(MessageReader || (messageReader$1.MessageReader = MessageReader = {}));
  class AbstractMessageReader {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
      this.partialMessageEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error) {
      this.errorEmitter.fire(this.asError(error));
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    get onPartialMessage() {
      return this.partialMessageEmitter.event;
    }
    firePartialMessage(info) {
      this.partialMessageEmitter.fire(info);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Reader received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageReader$1.AbstractMessageReader = AbstractMessageReader;
  var ResolvedMessageReaderOptions;
  (function(ResolvedMessageReaderOptions2) {
    function fromOptions(options2) {
      let charset;
      let contentDecoder;
      const contentDecoders = /* @__PURE__ */ new Map();
      let contentTypeDecoder;
      const contentTypeDecoders = /* @__PURE__ */ new Map();
      if (options2 === void 0 || typeof options2 === "string") {
        charset = options2 ?? "utf-8";
      } else {
        charset = options2.charset ?? "utf-8";
        if (options2.contentDecoder !== void 0) {
          contentDecoder = options2.contentDecoder;
          contentDecoders.set(contentDecoder.name, contentDecoder);
        }
        if (options2.contentDecoders !== void 0) {
          for (const decoder of options2.contentDecoders) {
            contentDecoders.set(decoder.name, decoder);
          }
        }
        if (options2.contentTypeDecoder !== void 0) {
          contentTypeDecoder = options2.contentTypeDecoder;
          contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
        }
        if (options2.contentTypeDecoders !== void 0) {
          for (const decoder of options2.contentTypeDecoders) {
            contentTypeDecoders.set(decoder.name, decoder);
          }
        }
      }
      if (contentTypeDecoder === void 0) {
        contentTypeDecoder = (0, ral_1.default)().applicationJson.decoder;
        contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
      }
      return { charset, contentDecoder, contentDecoders, contentTypeDecoder, contentTypeDecoders };
    }
    ResolvedMessageReaderOptions2.fromOptions = fromOptions;
  })(ResolvedMessageReaderOptions || (ResolvedMessageReaderOptions = {}));
  class ReadableStreamMessageReader extends AbstractMessageReader {
    constructor(readable, options2) {
      super();
      this.readable = readable;
      this.options = ResolvedMessageReaderOptions.fromOptions(options2);
      this.buffer = (0, ral_1.default)().messageBuffer.create(this.options.charset);
      this._partialMessageTimeout = 1e4;
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.readSemaphore = new semaphore_1.Semaphore(1);
    }
    set partialMessageTimeout(timeout) {
      this._partialMessageTimeout = timeout;
    }
    get partialMessageTimeout() {
      return this._partialMessageTimeout;
    }
    listen(callback) {
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.partialMessageTimer = void 0;
      this.callback = callback;
      const result2 = this.readable.onData((data) => {
        this.onData(data);
      });
      this.readable.onError((error) => this.fireError(error));
      this.readable.onClose(() => this.fireClose());
      return result2;
    }
    onData(data) {
      try {
        this.buffer.append(data);
        while (true) {
          if (this.nextMessageLength === -1) {
            const headers = this.buffer.tryReadHeaders(true);
            if (!headers) {
              return;
            }
            const contentLength = headers.get("content-length");
            if (!contentLength) {
              this.fireError(new Error(`Header must provide a Content-Length property.
${JSON.stringify(Object.fromEntries(headers))}`));
              return;
            }
            const length = parseInt(contentLength);
            if (isNaN(length)) {
              this.fireError(new Error(`Content-Length value must be a number. Got ${contentLength}`));
              return;
            }
            this.nextMessageLength = length;
          }
          const body = this.buffer.tryReadBody(this.nextMessageLength);
          if (body === void 0) {
            this.setPartialMessageTimer();
            return;
          }
          this.clearPartialMessageTimer();
          this.nextMessageLength = -1;
          this.readSemaphore.lock(async () => {
            const bytes = this.options.contentDecoder !== void 0 ? await this.options.contentDecoder.decode(body) : body;
            const message = await this.options.contentTypeDecoder.decode(bytes, this.options);
            this.callback(message);
          }).catch((error) => {
            this.fireError(error);
          });
        }
      } catch (error) {
        this.fireError(error);
      }
    }
    clearPartialMessageTimer() {
      if (this.partialMessageTimer) {
        this.partialMessageTimer.dispose();
        this.partialMessageTimer = void 0;
      }
    }
    setPartialMessageTimer() {
      this.clearPartialMessageTimer();
      if (this._partialMessageTimeout <= 0) {
        return;
      }
      this.partialMessageTimer = (0, ral_1.default)().timer.setTimeout((token, timeout) => {
        this.partialMessageTimer = void 0;
        if (token === this.messageToken) {
          this.firePartialMessage({ messageToken: token, waitingTime: timeout });
          this.setPartialMessageTimer();
        }
      }, this._partialMessageTimeout, this.messageToken, this._partialMessageTimeout);
    }
  }
  messageReader$1.ReadableStreamMessageReader = ReadableStreamMessageReader;
  return messageReader$1;
}
var messageWriter$1 = {};
var hasRequiredMessageWriter$1;
function requireMessageWriter$1() {
  if (hasRequiredMessageWriter$1) return messageWriter$1;
  hasRequiredMessageWriter$1 = 1;
  Object.defineProperty(messageWriter$1, "__esModule", { value: true });
  messageWriter$1.WriteableStreamMessageWriter = messageWriter$1.AbstractMessageWriter = messageWriter$1.MessageWriter = void 0;
  const ral_1 = requireRal$1();
  const Is2 = requireIs$2();
  const semaphore_1 = requireSemaphore$1();
  const events_1 = requireEvents$1();
  const ContentLength = "Content-Length: ";
  const CRLF = "\r\n";
  var MessageWriter;
  (function(MessageWriter2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.dispose) && Is2.func(candidate.onClose) && Is2.func(candidate.onError) && Is2.func(candidate.write);
    }
    MessageWriter2.is = is2;
  })(MessageWriter || (messageWriter$1.MessageWriter = MessageWriter = {}));
  class AbstractMessageWriter {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error, message, count) {
      this.errorEmitter.fire([this.asError(error), message, count]);
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Writer received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageWriter$1.AbstractMessageWriter = AbstractMessageWriter;
  var ResolvedMessageWriterOptions;
  (function(ResolvedMessageWriterOptions2) {
    function fromOptions(options2) {
      if (options2 === void 0 || typeof options2 === "string") {
        return { charset: options2 ?? "utf-8", contentTypeEncoder: (0, ral_1.default)().applicationJson.encoder };
      } else {
        return { charset: options2.charset ?? "utf-8", contentEncoder: options2.contentEncoder, contentTypeEncoder: options2.contentTypeEncoder ?? (0, ral_1.default)().applicationJson.encoder };
      }
    }
    ResolvedMessageWriterOptions2.fromOptions = fromOptions;
  })(ResolvedMessageWriterOptions || (ResolvedMessageWriterOptions = {}));
  class WriteableStreamMessageWriter extends AbstractMessageWriter {
    constructor(writable, options2) {
      super();
      this.writable = writable;
      this.options = ResolvedMessageWriterOptions.fromOptions(options2);
      this.errorCount = 0;
      this.writeSemaphore = new semaphore_1.Semaphore(1);
      this.writable.onError((error) => this.fireError(error));
      this.writable.onClose(() => this.fireClose());
    }
    async write(msg) {
      return this.writeSemaphore.lock(async () => {
        const payload = this.options.contentTypeEncoder.encode(msg, this.options).then((buffer) => {
          if (this.options.contentEncoder !== void 0) {
            return this.options.contentEncoder.encode(buffer);
          } else {
            return buffer;
          }
        });
        return payload.then((buffer) => {
          const headers = [];
          headers.push(ContentLength, buffer.byteLength.toString(), CRLF);
          headers.push(CRLF);
          return this.doWrite(msg, headers, buffer);
        }, (error) => {
          this.fireError(error);
          throw error;
        });
      });
    }
    async doWrite(msg, headers, data) {
      try {
        await this.writable.write(headers.join(""), "ascii");
        return this.writable.write(data);
      } catch (error) {
        this.handleError(error, msg);
        return Promise.reject(error);
      }
    }
    handleError(error, msg) {
      this.errorCount++;
      this.fireError(error, msg, this.errorCount);
    }
    end() {
      this.writable.end();
    }
  }
  messageWriter$1.WriteableStreamMessageWriter = WriteableStreamMessageWriter;
  return messageWriter$1;
}
var messageBuffer$1 = {};
var hasRequiredMessageBuffer$1;
function requireMessageBuffer$1() {
  if (hasRequiredMessageBuffer$1) return messageBuffer$1;
  hasRequiredMessageBuffer$1 = 1;
  Object.defineProperty(messageBuffer$1, "__esModule", { value: true });
  messageBuffer$1.AbstractMessageBuffer = void 0;
  const CR = 13;
  const LF = 10;
  const CRLF = "\r\n";
  class AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      this._encoding = encoding;
      this._chunks = [];
      this._totalLength = 0;
    }
    get encoding() {
      return this._encoding;
    }
    append(chunk2) {
      const toAppend = typeof chunk2 === "string" ? this.fromString(chunk2, this._encoding) : chunk2;
      this._chunks.push(toAppend);
      this._totalLength += toAppend.byteLength;
    }
    tryReadHeaders(lowerCaseKeys = false) {
      if (this._chunks.length === 0) {
        return void 0;
      }
      let state = 0;
      let chunkIndex = 0;
      let offset2 = 0;
      let chunkBytesRead = 0;
      row: while (chunkIndex < this._chunks.length) {
        const chunk2 = this._chunks[chunkIndex];
        offset2 = 0;
        while (offset2 < chunk2.length) {
          const value = chunk2[offset2];
          switch (value) {
            case CR:
              switch (state) {
                case 0:
                  state = 1;
                  break;
                case 2:
                  state = 3;
                  break;
                default:
                  state = 0;
              }
              break;
            case LF:
              switch (state) {
                case 1:
                  state = 2;
                  break;
                case 3:
                  state = 4;
                  offset2++;
                  break row;
                default:
                  state = 0;
              }
              break;
            default:
              state = 0;
          }
          offset2++;
        }
        chunkBytesRead += chunk2.byteLength;
        chunkIndex++;
      }
      if (state !== 4) {
        return void 0;
      }
      const buffer = this._read(chunkBytesRead + offset2);
      const result2 = /* @__PURE__ */ new Map();
      const headers = this.toString(buffer, "ascii").split(CRLF);
      if (headers.length < 2) {
        return result2;
      }
      for (let i2 = 0; i2 < headers.length - 2; i2++) {
        const header = headers[i2];
        const index2 = header.indexOf(":");
        if (index2 === -1) {
          throw new Error(`Message header must separate key and value using ':'
${header}`);
        }
        const key = header.substr(0, index2);
        const value = header.substr(index2 + 1).trim();
        result2.set(lowerCaseKeys ? key.toLowerCase() : key, value);
      }
      return result2;
    }
    tryReadBody(length) {
      if (this._totalLength < length) {
        return void 0;
      }
      return this._read(length);
    }
    get numberOfBytes() {
      return this._totalLength;
    }
    _read(byteCount) {
      if (byteCount === 0) {
        return this.emptyBuffer();
      }
      if (byteCount > this._totalLength) {
        throw new Error(`Cannot read so many bytes!`);
      }
      if (this._chunks[0].byteLength === byteCount) {
        const chunk2 = this._chunks[0];
        this._chunks.shift();
        this._totalLength -= byteCount;
        return this.asNative(chunk2);
      }
      if (this._chunks[0].byteLength > byteCount) {
        const chunk2 = this._chunks[0];
        const result3 = this.asNative(chunk2, byteCount);
        this._chunks[0] = chunk2.slice(byteCount);
        this._totalLength -= byteCount;
        return result3;
      }
      const result2 = this.allocNative(byteCount);
      let resultOffset = 0;
      let chunkIndex = 0;
      while (byteCount > 0) {
        const chunk2 = this._chunks[chunkIndex];
        if (chunk2.byteLength > byteCount) {
          const chunkPart = chunk2.slice(0, byteCount);
          result2.set(chunkPart, resultOffset);
          resultOffset += byteCount;
          this._chunks[chunkIndex] = chunk2.slice(byteCount);
          this._totalLength -= byteCount;
          byteCount -= byteCount;
        } else {
          result2.set(chunk2, resultOffset);
          resultOffset += chunk2.byteLength;
          this._chunks.shift();
          this._totalLength -= chunk2.byteLength;
          byteCount -= chunk2.byteLength;
        }
      }
      return result2;
    }
  }
  messageBuffer$1.AbstractMessageBuffer = AbstractMessageBuffer;
  return messageBuffer$1;
}
var connection$1$1 = {};
var hasRequiredConnection$1$1;
function requireConnection$1$1() {
  if (hasRequiredConnection$1$1) return connection$1$1;
  hasRequiredConnection$1$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createMessageConnection = exports2.ConnectionOptions = exports2.MessageStrategy = exports2.CancellationStrategy = exports2.CancellationSenderStrategy = exports2.CancellationReceiverStrategy = exports2.RequestCancellationReceiverStrategy = exports2.IdCancellationReceiverStrategy = exports2.ConnectionStrategy = exports2.ConnectionError = exports2.ConnectionErrors = exports2.LogTraceNotification = exports2.SetTraceNotification = exports2.TraceFormat = exports2.TraceValues = exports2.Trace = exports2.NullLogger = exports2.ProgressType = exports2.ProgressToken = void 0;
    const ral_1 = requireRal$1();
    const Is2 = requireIs$2();
    const messages_1 = requireMessages$1$1();
    const linkedMap_1 = requireLinkedMap$1();
    const events_1 = requireEvents$1();
    const cancellation_1 = requireCancellation$1();
    var CancelNotification;
    (function(CancelNotification2) {
      CancelNotification2.type = new messages_1.NotificationType("$/cancelRequest");
    })(CancelNotification || (CancelNotification = {}));
    var ProgressToken;
    (function(ProgressToken2) {
      function is2(value) {
        return typeof value === "string" || typeof value === "number";
      }
      ProgressToken2.is = is2;
    })(ProgressToken || (exports2.ProgressToken = ProgressToken = {}));
    var ProgressNotification;
    (function(ProgressNotification2) {
      ProgressNotification2.type = new messages_1.NotificationType("$/progress");
    })(ProgressNotification || (ProgressNotification = {}));
    class ProgressType {
      constructor() {
      }
    }
    exports2.ProgressType = ProgressType;
    var StarRequestHandler;
    (function(StarRequestHandler2) {
      function is2(value) {
        return Is2.func(value);
      }
      StarRequestHandler2.is = is2;
    })(StarRequestHandler || (StarRequestHandler = {}));
    exports2.NullLogger = Object.freeze({
      error: () => {
      },
      warn: () => {
      },
      info: () => {
      },
      log: () => {
      }
    });
    var Trace;
    (function(Trace2) {
      Trace2[Trace2["Off"] = 0] = "Off";
      Trace2[Trace2["Messages"] = 1] = "Messages";
      Trace2[Trace2["Compact"] = 2] = "Compact";
      Trace2[Trace2["Verbose"] = 3] = "Verbose";
    })(Trace || (exports2.Trace = Trace = {}));
    var TraceValues;
    (function(TraceValues2) {
      TraceValues2.Off = "off";
      TraceValues2.Messages = "messages";
      TraceValues2.Compact = "compact";
      TraceValues2.Verbose = "verbose";
    })(TraceValues || (exports2.TraceValues = TraceValues = {}));
    (function(Trace2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return Trace2.Off;
        }
        value = value.toLowerCase();
        switch (value) {
          case "off":
            return Trace2.Off;
          case "messages":
            return Trace2.Messages;
          case "compact":
            return Trace2.Compact;
          case "verbose":
            return Trace2.Verbose;
          default:
            return Trace2.Off;
        }
      }
      Trace2.fromString = fromString;
      function toString2(value) {
        switch (value) {
          case Trace2.Off:
            return "off";
          case Trace2.Messages:
            return "messages";
          case Trace2.Compact:
            return "compact";
          case Trace2.Verbose:
            return "verbose";
          default:
            return "off";
        }
      }
      Trace2.toString = toString2;
    })(Trace || (exports2.Trace = Trace = {}));
    var TraceFormat;
    (function(TraceFormat2) {
      TraceFormat2["Text"] = "text";
      TraceFormat2["JSON"] = "json";
    })(TraceFormat || (exports2.TraceFormat = TraceFormat = {}));
    (function(TraceFormat2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return TraceFormat2.Text;
        }
        value = value.toLowerCase();
        if (value === "json") {
          return TraceFormat2.JSON;
        } else {
          return TraceFormat2.Text;
        }
      }
      TraceFormat2.fromString = fromString;
    })(TraceFormat || (exports2.TraceFormat = TraceFormat = {}));
    var SetTraceNotification;
    (function(SetTraceNotification2) {
      SetTraceNotification2.type = new messages_1.NotificationType("$/setTrace");
    })(SetTraceNotification || (exports2.SetTraceNotification = SetTraceNotification = {}));
    var LogTraceNotification;
    (function(LogTraceNotification2) {
      LogTraceNotification2.type = new messages_1.NotificationType("$/logTrace");
    })(LogTraceNotification || (exports2.LogTraceNotification = LogTraceNotification = {}));
    var ConnectionErrors;
    (function(ConnectionErrors2) {
      ConnectionErrors2[ConnectionErrors2["Closed"] = 1] = "Closed";
      ConnectionErrors2[ConnectionErrors2["Disposed"] = 2] = "Disposed";
      ConnectionErrors2[ConnectionErrors2["AlreadyListening"] = 3] = "AlreadyListening";
    })(ConnectionErrors || (exports2.ConnectionErrors = ConnectionErrors = {}));
    class ConnectionError extends Error {
      constructor(code2, message) {
        super(message);
        this.code = code2;
        Object.setPrototypeOf(this, ConnectionError.prototype);
      }
    }
    exports2.ConnectionError = ConnectionError;
    var ConnectionStrategy;
    (function(ConnectionStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.cancelUndispatched);
      }
      ConnectionStrategy2.is = is2;
    })(ConnectionStrategy || (exports2.ConnectionStrategy = ConnectionStrategy = {}));
    var IdCancellationReceiverStrategy;
    (function(IdCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.kind === void 0 || candidate.kind === "id") && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      IdCancellationReceiverStrategy2.is = is2;
    })(IdCancellationReceiverStrategy || (exports2.IdCancellationReceiverStrategy = IdCancellationReceiverStrategy = {}));
    var RequestCancellationReceiverStrategy;
    (function(RequestCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && candidate.kind === "request" && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      RequestCancellationReceiverStrategy2.is = is2;
    })(RequestCancellationReceiverStrategy || (exports2.RequestCancellationReceiverStrategy = RequestCancellationReceiverStrategy = {}));
    var CancellationReceiverStrategy;
    (function(CancellationReceiverStrategy2) {
      CancellationReceiverStrategy2.Message = Object.freeze({
        createCancellationTokenSource(_2) {
          return new cancellation_1.CancellationTokenSource();
        }
      });
      function is2(value) {
        return IdCancellationReceiverStrategy.is(value) || RequestCancellationReceiverStrategy.is(value);
      }
      CancellationReceiverStrategy2.is = is2;
    })(CancellationReceiverStrategy || (exports2.CancellationReceiverStrategy = CancellationReceiverStrategy = {}));
    var CancellationSenderStrategy;
    (function(CancellationSenderStrategy2) {
      CancellationSenderStrategy2.Message = Object.freeze({
        sendCancellation(conn, id2) {
          return conn.sendNotification(CancelNotification.type, { id: id2 });
        },
        cleanup(_2) {
        }
      });
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.sendCancellation) && Is2.func(candidate.cleanup);
      }
      CancellationSenderStrategy2.is = is2;
    })(CancellationSenderStrategy || (exports2.CancellationSenderStrategy = CancellationSenderStrategy = {}));
    var CancellationStrategy;
    (function(CancellationStrategy2) {
      CancellationStrategy2.Message = Object.freeze({
        receiver: CancellationReceiverStrategy.Message,
        sender: CancellationSenderStrategy.Message
      });
      function is2(value) {
        const candidate = value;
        return candidate && CancellationReceiverStrategy.is(candidate.receiver) && CancellationSenderStrategy.is(candidate.sender);
      }
      CancellationStrategy2.is = is2;
    })(CancellationStrategy || (exports2.CancellationStrategy = CancellationStrategy = {}));
    var MessageStrategy;
    (function(MessageStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.handleMessage);
      }
      MessageStrategy2.is = is2;
    })(MessageStrategy || (exports2.MessageStrategy = MessageStrategy = {}));
    var ConnectionOptions;
    (function(ConnectionOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (CancellationStrategy.is(candidate.cancellationStrategy) || ConnectionStrategy.is(candidate.connectionStrategy) || MessageStrategy.is(candidate.messageStrategy));
      }
      ConnectionOptions2.is = is2;
    })(ConnectionOptions || (exports2.ConnectionOptions = ConnectionOptions = {}));
    var ConnectionState;
    (function(ConnectionState2) {
      ConnectionState2[ConnectionState2["New"] = 1] = "New";
      ConnectionState2[ConnectionState2["Listening"] = 2] = "Listening";
      ConnectionState2[ConnectionState2["Closed"] = 3] = "Closed";
      ConnectionState2[ConnectionState2["Disposed"] = 4] = "Disposed";
    })(ConnectionState || (ConnectionState = {}));
    function createMessageConnection2(messageReader2, messageWriter2, _logger, options2) {
      const logger = _logger !== void 0 ? _logger : exports2.NullLogger;
      let sequenceNumber = 0;
      let notificationSequenceNumber = 0;
      let unknownResponseSequenceNumber = 0;
      const version2 = "2.0";
      let starRequestHandler = void 0;
      const requestHandlers = /* @__PURE__ */ new Map();
      let starNotificationHandler = void 0;
      const notificationHandlers = /* @__PURE__ */ new Map();
      const progressHandlers = /* @__PURE__ */ new Map();
      let timer;
      let messageQueue = new linkedMap_1.LinkedMap();
      let responsePromises = /* @__PURE__ */ new Map();
      let knownCanceledRequests = /* @__PURE__ */ new Set();
      let requestTokens = /* @__PURE__ */ new Map();
      let trace = Trace.Off;
      let traceFormat = TraceFormat.Text;
      let tracer;
      let state = ConnectionState.New;
      const errorEmitter = new events_1.Emitter();
      const closeEmitter = new events_1.Emitter();
      const unhandledNotificationEmitter = new events_1.Emitter();
      const unhandledProgressEmitter = new events_1.Emitter();
      const disposeEmitter = new events_1.Emitter();
      const cancellationStrategy = options2 && options2.cancellationStrategy ? options2.cancellationStrategy : CancellationStrategy.Message;
      function createRequestQueueKey(id2) {
        if (id2 === null) {
          throw new Error(`Can't send requests with id null since the response can't be correlated.`);
        }
        return "req-" + id2.toString();
      }
      function createResponseQueueKey(id2) {
        if (id2 === null) {
          return "res-unknown-" + (++unknownResponseSequenceNumber).toString();
        } else {
          return "res-" + id2.toString();
        }
      }
      function createNotificationQueueKey() {
        return "not-" + (++notificationSequenceNumber).toString();
      }
      function addMessageToQueue(queue, message) {
        if (messages_1.Message.isRequest(message)) {
          queue.set(createRequestQueueKey(message.id), message);
        } else if (messages_1.Message.isResponse(message)) {
          queue.set(createResponseQueueKey(message.id), message);
        } else {
          queue.set(createNotificationQueueKey(), message);
        }
      }
      function cancelUndispatched(_message) {
        return void 0;
      }
      function isListening() {
        return state === ConnectionState.Listening;
      }
      function isClosed() {
        return state === ConnectionState.Closed;
      }
      function isDisposed() {
        return state === ConnectionState.Disposed;
      }
      function closeHandler() {
        if (state === ConnectionState.New || state === ConnectionState.Listening) {
          state = ConnectionState.Closed;
          closeEmitter.fire(void 0);
        }
      }
      function readErrorHandler(error) {
        errorEmitter.fire([error, void 0, void 0]);
      }
      function writeErrorHandler(data) {
        errorEmitter.fire(data);
      }
      messageReader2.onClose(closeHandler);
      messageReader2.onError(readErrorHandler);
      messageWriter2.onClose(closeHandler);
      messageWriter2.onError(writeErrorHandler);
      function triggerMessageQueue() {
        if (timer || messageQueue.size === 0) {
          return;
        }
        timer = (0, ral_1.default)().timer.setImmediate(() => {
          timer = void 0;
          processMessageQueue();
        });
      }
      function handleMessage(message) {
        if (messages_1.Message.isRequest(message)) {
          handleRequest(message);
        } else if (messages_1.Message.isNotification(message)) {
          handleNotification(message);
        } else if (messages_1.Message.isResponse(message)) {
          handleResponse(message);
        } else {
          handleInvalidMessage(message);
        }
      }
      function processMessageQueue() {
        if (messageQueue.size === 0) {
          return;
        }
        const message = messageQueue.shift();
        try {
          const messageStrategy = options2?.messageStrategy;
          if (MessageStrategy.is(messageStrategy)) {
            messageStrategy.handleMessage(message, handleMessage);
          } else {
            handleMessage(message);
          }
        } finally {
          triggerMessageQueue();
        }
      }
      const callback = (message) => {
        try {
          if (messages_1.Message.isNotification(message) && message.method === CancelNotification.type.method) {
            const cancelId = message.params.id;
            const key = createRequestQueueKey(cancelId);
            const toCancel = messageQueue.get(key);
            if (messages_1.Message.isRequest(toCancel)) {
              const strategy = options2?.connectionStrategy;
              const response = strategy && strategy.cancelUndispatched ? strategy.cancelUndispatched(toCancel, cancelUndispatched) : cancelUndispatched(toCancel);
              if (response && (response.error !== void 0 || response.result !== void 0)) {
                messageQueue.delete(key);
                requestTokens.delete(cancelId);
                response.id = toCancel.id;
                traceSendingResponse(response, message.method, Date.now());
                messageWriter2.write(response).catch(() => logger.error(`Sending response for canceled message failed.`));
                return;
              }
            }
            const cancellationToken = requestTokens.get(cancelId);
            if (cancellationToken !== void 0) {
              cancellationToken.cancel();
              traceReceivedNotification(message);
              return;
            } else {
              knownCanceledRequests.add(cancelId);
            }
          }
          addMessageToQueue(messageQueue, message);
        } finally {
          triggerMessageQueue();
        }
      };
      function handleRequest(requestMessage) {
        if (isDisposed()) {
          return;
        }
        function reply(resultOrError, method, startTime2) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id
          };
          if (resultOrError instanceof messages_1.ResponseError) {
            message.error = resultOrError.toJson();
          } else {
            message.result = resultOrError === void 0 ? null : resultOrError;
          }
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replyError(error, method, startTime2) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            error: error.toJson()
          };
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replySuccess(result2, method, startTime2) {
          if (result2 === void 0) {
            result2 = null;
          }
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            result: result2
          };
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        traceReceivedRequest(requestMessage);
        const element2 = requestHandlers.get(requestMessage.method);
        let type;
        let requestHandler;
        if (element2) {
          type = element2.type;
          requestHandler = element2.handler;
        }
        const startTime = Date.now();
        if (requestHandler || starRequestHandler) {
          const tokenKey = requestMessage.id ?? String(Date.now());
          const cancellationSource = IdCancellationReceiverStrategy.is(cancellationStrategy.receiver) ? cancellationStrategy.receiver.createCancellationTokenSource(tokenKey) : cancellationStrategy.receiver.createCancellationTokenSource(requestMessage);
          if (requestMessage.id !== null && knownCanceledRequests.has(requestMessage.id)) {
            cancellationSource.cancel();
          }
          if (requestMessage.id !== null) {
            requestTokens.set(tokenKey, cancellationSource);
          }
          try {
            let handlerResult;
            if (requestHandler) {
              if (requestMessage.params === void 0) {
                if (type !== void 0 && type.numberOfParams !== 0) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines ${type.numberOfParams} params but received none.`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(cancellationSource.token);
              } else if (Array.isArray(requestMessage.params)) {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byName) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by name but received parameters by position`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(...requestMessage.params, cancellationSource.token);
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by position but received parameters by name`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(requestMessage.params, cancellationSource.token);
              }
            } else if (starRequestHandler) {
              handlerResult = starRequestHandler(requestMessage.method, requestMessage.params, cancellationSource.token);
            }
            const promise = handlerResult;
            if (!handlerResult) {
              requestTokens.delete(tokenKey);
              replySuccess(handlerResult, requestMessage.method, startTime);
            } else if (promise.then) {
              promise.then((resultOrError) => {
                requestTokens.delete(tokenKey);
                reply(resultOrError, requestMessage.method, startTime);
              }, (error) => {
                requestTokens.delete(tokenKey);
                if (error instanceof messages_1.ResponseError) {
                  replyError(error, requestMessage.method, startTime);
                } else if (error && Is2.string(error.message)) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime);
                } else {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime);
                }
              });
            } else {
              requestTokens.delete(tokenKey);
              reply(handlerResult, requestMessage.method, startTime);
            }
          } catch (error) {
            requestTokens.delete(tokenKey);
            if (error instanceof messages_1.ResponseError) {
              reply(error, requestMessage.method, startTime);
            } else if (error && Is2.string(error.message)) {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime);
            } else {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime);
            }
          }
        } else {
          replyError(new messages_1.ResponseError(messages_1.ErrorCodes.MethodNotFound, `Unhandled method ${requestMessage.method}`), requestMessage.method, startTime);
        }
      }
      function handleResponse(responseMessage) {
        if (isDisposed()) {
          return;
        }
        if (responseMessage.id === null) {
          if (responseMessage.error) {
            logger.error(`Received response message without id: Error is: 
${JSON.stringify(responseMessage.error, void 0, 4)}`);
          } else {
            logger.error(`Received response message without id. No further error information provided.`);
          }
        } else {
          const key = responseMessage.id;
          const responsePromise = responsePromises.get(key);
          traceReceivedResponse(responseMessage, responsePromise);
          if (responsePromise !== void 0) {
            responsePromises.delete(key);
            try {
              if (responseMessage.error) {
                const error = responseMessage.error;
                responsePromise.reject(new messages_1.ResponseError(error.code, error.message, error.data));
              } else if (responseMessage.result !== void 0) {
                responsePromise.resolve(responseMessage.result);
              } else {
                throw new Error("Should never happen.");
              }
            } catch (error) {
              if (error.message) {
                logger.error(`Response handler '${responsePromise.method}' failed with message: ${error.message}`);
              } else {
                logger.error(`Response handler '${responsePromise.method}' failed unexpectedly.`);
              }
            }
          }
        }
      }
      function handleNotification(message) {
        if (isDisposed()) {
          return;
        }
        let type = void 0;
        let notificationHandler;
        if (message.method === CancelNotification.type.method) {
          const cancelId = message.params.id;
          knownCanceledRequests.delete(cancelId);
          traceReceivedNotification(message);
          return;
        } else {
          const element2 = notificationHandlers.get(message.method);
          if (element2) {
            notificationHandler = element2.handler;
            type = element2.type;
          }
        }
        if (notificationHandler || starNotificationHandler) {
          try {
            traceReceivedNotification(message);
            if (notificationHandler) {
              if (message.params === void 0) {
                if (type !== void 0) {
                  if (type.numberOfParams !== 0 && type.parameterStructures !== messages_1.ParameterStructures.byName) {
                    logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received none.`);
                  }
                }
                notificationHandler();
              } else if (Array.isArray(message.params)) {
                const params = message.params;
                if (message.method === ProgressNotification.type.method && params.length === 2 && ProgressToken.is(params[0])) {
                  notificationHandler({ token: params[0], value: params[1] });
                } else {
                  if (type !== void 0) {
                    if (type.parameterStructures === messages_1.ParameterStructures.byName) {
                      logger.error(`Notification ${message.method} defines parameters by name but received parameters by position`);
                    }
                    if (type.numberOfParams !== message.params.length) {
                      logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received ${params.length} arguments`);
                    }
                  }
                  notificationHandler(...params);
                }
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  logger.error(`Notification ${message.method} defines parameters by position but received parameters by name`);
                }
                notificationHandler(message.params);
              }
            } else if (starNotificationHandler) {
              starNotificationHandler(message.method, message.params);
            }
          } catch (error) {
            if (error.message) {
              logger.error(`Notification handler '${message.method}' failed with message: ${error.message}`);
            } else {
              logger.error(`Notification handler '${message.method}' failed unexpectedly.`);
            }
          }
        } else {
          unhandledNotificationEmitter.fire(message);
        }
      }
      function handleInvalidMessage(message) {
        if (!message) {
          logger.error("Received empty message.");
          return;
        }
        logger.error(`Received message which is neither a response nor a notification message:
${JSON.stringify(message, null, 4)}`);
        const responseMessage = message;
        if (Is2.string(responseMessage.id) || Is2.number(responseMessage.id)) {
          const key = responseMessage.id;
          const responseHandler = responsePromises.get(key);
          if (responseHandler) {
            responseHandler.reject(new Error("The received response has neither a result nor an error property."));
          }
        }
      }
      function stringifyTrace(params) {
        if (params === void 0 || params === null) {
          return void 0;
        }
        switch (trace) {
          case Trace.Verbose:
            return JSON.stringify(params, null, 4);
          case Trace.Compact:
            return JSON.stringify(params);
          default:
            return void 0;
        }
      }
      function traceSendingRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Sending request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("send-request", message);
        }
      }
      function traceSendingNotification(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Sending notification '${message.method}'.`, data);
        } else {
          logLSPMessage("send-notification", message);
        }
      }
      function traceSendingResponse(message, method, startTime) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          tracer.log(`Sending response '${method} - (${message.id})'. Processing request took ${Date.now() - startTime}ms`, data);
        } else {
          logLSPMessage("send-response", message);
        }
      }
      function traceReceivedRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Received request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("receive-request", message);
        }
      }
      function traceReceivedNotification(message) {
        if (trace === Trace.Off || !tracer || message.method === LogTraceNotification.type.method) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Received notification '${message.method}'.`, data);
        } else {
          logLSPMessage("receive-notification", message);
        }
      }
      function traceReceivedResponse(message, responsePromise) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          if (responsePromise) {
            const error = message.error ? ` Request failed: ${message.error.message} (${message.error.code}).` : "";
            tracer.log(`Received response '${responsePromise.method} - (${message.id})' in ${Date.now() - responsePromise.timerStart}ms.${error}`, data);
          } else {
            tracer.log(`Received response ${message.id} without active response promise.`, data);
          }
        } else {
          logLSPMessage("receive-response", message);
        }
      }
      function logLSPMessage(type, message) {
        if (!tracer || trace === Trace.Off) {
          return;
        }
        const lspMessage = {
          isLSPMessage: true,
          type,
          message,
          timestamp: Date.now()
        };
        tracer.log(lspMessage);
      }
      function throwIfClosedOrDisposed() {
        if (isClosed()) {
          throw new ConnectionError(ConnectionErrors.Closed, "Connection is closed.");
        }
        if (isDisposed()) {
          throw new ConnectionError(ConnectionErrors.Disposed, "Connection is disposed.");
        }
      }
      function throwIfListening() {
        if (isListening()) {
          throw new ConnectionError(ConnectionErrors.AlreadyListening, "Connection is already listening");
        }
      }
      function throwIfNotListening() {
        if (!isListening()) {
          throw new Error("Call listen() first.");
        }
      }
      function undefinedToNull(param) {
        if (param === void 0) {
          return null;
        } else {
          return param;
        }
      }
      function nullToUndefined(param) {
        if (param === null) {
          return void 0;
        } else {
          return param;
        }
      }
      function isNamedParam(param) {
        return param !== void 0 && param !== null && !Array.isArray(param) && typeof param === "object";
      }
      function computeSingleParam(parameterStructures, param) {
        switch (parameterStructures) {
          case messages_1.ParameterStructures.auto:
            if (isNamedParam(param)) {
              return nullToUndefined(param);
            } else {
              return [undefinedToNull(param)];
            }
          case messages_1.ParameterStructures.byName:
            if (!isNamedParam(param)) {
              throw new Error(`Received parameters by name but param is not an object literal.`);
            }
            return nullToUndefined(param);
          case messages_1.ParameterStructures.byPosition:
            return [undefinedToNull(param)];
          default:
            throw new Error(`Unknown parameter structure ${parameterStructures.toString()}`);
        }
      }
      function computeMessageParams(type, params) {
        let result2;
        const numberOfParams = type.numberOfParams;
        switch (numberOfParams) {
          case 0:
            result2 = void 0;
            break;
          case 1:
            result2 = computeSingleParam(type.parameterStructures, params[0]);
            break;
          default:
            result2 = [];
            for (let i2 = 0; i2 < params.length && i2 < numberOfParams; i2++) {
              result2.push(undefinedToNull(params[i2]));
            }
            if (params.length < numberOfParams) {
              for (let i2 = params.length; i2 < numberOfParams; i2++) {
                result2.push(null);
              }
            }
            break;
        }
        return result2;
      }
      const connection2 = {
        sendNotification: (type, ...args) => {
          throwIfClosedOrDisposed();
          let method;
          let messageParams;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' notification parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
          }
          const notificationMessage = {
            jsonrpc: version2,
            method,
            params: messageParams
          };
          traceSendingNotification(notificationMessage);
          return messageWriter2.write(notificationMessage).catch((error) => {
            logger.error(`Sending notification failed.`);
            throw error;
          });
        },
        onNotification: (type, handler) => {
          throwIfClosedOrDisposed();
          let method;
          if (Is2.func(type)) {
            starNotificationHandler = type;
          } else if (handler) {
            if (Is2.string(type)) {
              method = type;
              notificationHandlers.set(type, { type: void 0, handler });
            } else {
              method = type.method;
              notificationHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method !== void 0) {
                notificationHandlers.delete(method);
              } else {
                starNotificationHandler = void 0;
              }
            }
          };
        },
        onProgress: (_type, token, handler) => {
          if (progressHandlers.has(token)) {
            throw new Error(`Progress handler for token ${token} already registered`);
          }
          progressHandlers.set(token, handler);
          return {
            dispose: () => {
              progressHandlers.delete(token);
            }
          };
        },
        sendProgress: (_type, token, value) => {
          return connection2.sendNotification(ProgressNotification.type, { token, value });
        },
        onUnhandledProgress: unhandledProgressEmitter.event,
        sendRequest: (type, ...args) => {
          throwIfClosedOrDisposed();
          throwIfNotListening();
          let method;
          let messageParams;
          let token = void 0;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            const last2 = args[args.length - 1];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            if (cancellation_1.CancellationToken.is(last2)) {
              paramEnd = paramEnd - 1;
              token = last2;
            }
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' request parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
            const numberOfParams = type.numberOfParams;
            token = cancellation_1.CancellationToken.is(params[numberOfParams]) ? params[numberOfParams] : void 0;
          }
          const id2 = sequenceNumber++;
          let disposable2;
          if (token) {
            disposable2 = token.onCancellationRequested(() => {
              const p2 = cancellationStrategy.sender.sendCancellation(connection2, id2);
              if (p2 === void 0) {
                logger.log(`Received no promise from cancellation strategy when cancelling id ${id2}`);
                return Promise.resolve();
              } else {
                return p2.catch(() => {
                  logger.log(`Sending cancellation messages for id ${id2} failed`);
                });
              }
            });
          }
          const requestMessage = {
            jsonrpc: version2,
            id: id2,
            method,
            params: messageParams
          };
          traceSendingRequest(requestMessage);
          if (typeof cancellationStrategy.sender.enableCancellation === "function") {
            cancellationStrategy.sender.enableCancellation(requestMessage);
          }
          return new Promise(async (resolve, reject2) => {
            const resolveWithCleanup = (r2) => {
              resolve(r2);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const rejectWithCleanup = (r2) => {
              reject2(r2);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const responsePromise = { method, timerStart: Date.now(), resolve: resolveWithCleanup, reject: rejectWithCleanup };
            try {
              responsePromises.set(id2, responsePromise);
              await messageWriter2.write(requestMessage);
            } catch (error) {
              responsePromises.delete(id2);
              responsePromise.reject(new messages_1.ResponseError(messages_1.ErrorCodes.MessageWriteError, error.message ? error.message : "Unknown reason"));
              logger.error(`Sending request failed.`);
              throw error;
            }
          });
        },
        onRequest: (type, handler) => {
          throwIfClosedOrDisposed();
          let method = null;
          if (StarRequestHandler.is(type)) {
            method = void 0;
            starRequestHandler = type;
          } else if (Is2.string(type)) {
            method = null;
            if (handler !== void 0) {
              method = type;
              requestHandlers.set(type, { handler, type: void 0 });
            }
          } else {
            if (handler !== void 0) {
              method = type.method;
              requestHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method === null) {
                return;
              }
              if (method !== void 0) {
                requestHandlers.delete(method);
              } else {
                starRequestHandler = void 0;
              }
            }
          };
        },
        hasPendingResponse: () => {
          return responsePromises.size > 0;
        },
        trace: async (_value, _tracer, sendNotificationOrTraceOptions) => {
          let _sendNotification = false;
          let _traceFormat = TraceFormat.Text;
          if (sendNotificationOrTraceOptions !== void 0) {
            if (Is2.boolean(sendNotificationOrTraceOptions)) {
              _sendNotification = sendNotificationOrTraceOptions;
            } else {
              _sendNotification = sendNotificationOrTraceOptions.sendNotification || false;
              _traceFormat = sendNotificationOrTraceOptions.traceFormat || TraceFormat.Text;
            }
          }
          trace = _value;
          traceFormat = _traceFormat;
          if (trace === Trace.Off) {
            tracer = void 0;
          } else {
            tracer = _tracer;
          }
          if (_sendNotification && !isClosed() && !isDisposed()) {
            await connection2.sendNotification(SetTraceNotification.type, { value: Trace.toString(_value) });
          }
        },
        onError: errorEmitter.event,
        onClose: closeEmitter.event,
        onUnhandledNotification: unhandledNotificationEmitter.event,
        onDispose: disposeEmitter.event,
        end: () => {
          messageWriter2.end();
        },
        dispose: () => {
          if (isDisposed()) {
            return;
          }
          state = ConnectionState.Disposed;
          disposeEmitter.fire(void 0);
          const error = new messages_1.ResponseError(messages_1.ErrorCodes.PendingResponseRejected, "Pending response rejected since connection got disposed");
          for (const promise of responsePromises.values()) {
            promise.reject(error);
          }
          responsePromises = /* @__PURE__ */ new Map();
          requestTokens = /* @__PURE__ */ new Map();
          knownCanceledRequests = /* @__PURE__ */ new Set();
          messageQueue = new linkedMap_1.LinkedMap();
          if (Is2.func(messageWriter2.dispose)) {
            messageWriter2.dispose();
          }
          if (Is2.func(messageReader2.dispose)) {
            messageReader2.dispose();
          }
        },
        listen: () => {
          throwIfClosedOrDisposed();
          throwIfListening();
          state = ConnectionState.Listening;
          messageReader2.listen(callback);
        },
        inspect: () => {
          (0, ral_1.default)().console.log("inspect");
        }
      };
      connection2.onNotification(LogTraceNotification.type, (params) => {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        const verbose2 = trace === Trace.Verbose || trace === Trace.Compact;
        tracer.log(params.message, verbose2 ? params.verbose : void 0);
      });
      connection2.onNotification(ProgressNotification.type, (params) => {
        const handler = progressHandlers.get(params.token);
        if (handler) {
          handler(params.value);
        } else {
          unhandledProgressEmitter.fire(params);
        }
      });
      return connection2;
    }
    exports2.createMessageConnection = createMessageConnection2;
  })(connection$1$1);
  return connection$1$1;
}
var hasRequiredApi$2;
function requireApi$2() {
  if (hasRequiredApi$2) return api$1$1;
  hasRequiredApi$2 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ProgressType = exports2.ProgressToken = exports2.createMessageConnection = exports2.NullLogger = exports2.ConnectionOptions = exports2.ConnectionStrategy = exports2.AbstractMessageBuffer = exports2.WriteableStreamMessageWriter = exports2.AbstractMessageWriter = exports2.MessageWriter = exports2.ReadableStreamMessageReader = exports2.AbstractMessageReader = exports2.MessageReader = exports2.SharedArrayReceiverStrategy = exports2.SharedArraySenderStrategy = exports2.CancellationToken = exports2.CancellationTokenSource = exports2.Emitter = exports2.Event = exports2.Disposable = exports2.LRUCache = exports2.Touch = exports2.LinkedMap = exports2.ParameterStructures = exports2.NotificationType9 = exports2.NotificationType8 = exports2.NotificationType7 = exports2.NotificationType6 = exports2.NotificationType5 = exports2.NotificationType4 = exports2.NotificationType3 = exports2.NotificationType2 = exports2.NotificationType1 = exports2.NotificationType0 = exports2.NotificationType = exports2.ErrorCodes = exports2.ResponseError = exports2.RequestType9 = exports2.RequestType8 = exports2.RequestType7 = exports2.RequestType6 = exports2.RequestType5 = exports2.RequestType4 = exports2.RequestType3 = exports2.RequestType2 = exports2.RequestType1 = exports2.RequestType0 = exports2.RequestType = exports2.Message = exports2.RAL = void 0;
    exports2.MessageStrategy = exports2.CancellationStrategy = exports2.CancellationSenderStrategy = exports2.CancellationReceiverStrategy = exports2.ConnectionError = exports2.ConnectionErrors = exports2.LogTraceNotification = exports2.SetTraceNotification = exports2.TraceFormat = exports2.TraceValues = exports2.Trace = void 0;
    const messages_1 = requireMessages$1$1();
    Object.defineProperty(exports2, "Message", { enumerable: true, get: function() {
      return messages_1.Message;
    } });
    Object.defineProperty(exports2, "RequestType", { enumerable: true, get: function() {
      return messages_1.RequestType;
    } });
    Object.defineProperty(exports2, "RequestType0", { enumerable: true, get: function() {
      return messages_1.RequestType0;
    } });
    Object.defineProperty(exports2, "RequestType1", { enumerable: true, get: function() {
      return messages_1.RequestType1;
    } });
    Object.defineProperty(exports2, "RequestType2", { enumerable: true, get: function() {
      return messages_1.RequestType2;
    } });
    Object.defineProperty(exports2, "RequestType3", { enumerable: true, get: function() {
      return messages_1.RequestType3;
    } });
    Object.defineProperty(exports2, "RequestType4", { enumerable: true, get: function() {
      return messages_1.RequestType4;
    } });
    Object.defineProperty(exports2, "RequestType5", { enumerable: true, get: function() {
      return messages_1.RequestType5;
    } });
    Object.defineProperty(exports2, "RequestType6", { enumerable: true, get: function() {
      return messages_1.RequestType6;
    } });
    Object.defineProperty(exports2, "RequestType7", { enumerable: true, get: function() {
      return messages_1.RequestType7;
    } });
    Object.defineProperty(exports2, "RequestType8", { enumerable: true, get: function() {
      return messages_1.RequestType8;
    } });
    Object.defineProperty(exports2, "RequestType9", { enumerable: true, get: function() {
      return messages_1.RequestType9;
    } });
    Object.defineProperty(exports2, "ResponseError", { enumerable: true, get: function() {
      return messages_1.ResponseError;
    } });
    Object.defineProperty(exports2, "ErrorCodes", { enumerable: true, get: function() {
      return messages_1.ErrorCodes;
    } });
    Object.defineProperty(exports2, "NotificationType", { enumerable: true, get: function() {
      return messages_1.NotificationType;
    } });
    Object.defineProperty(exports2, "NotificationType0", { enumerable: true, get: function() {
      return messages_1.NotificationType0;
    } });
    Object.defineProperty(exports2, "NotificationType1", { enumerable: true, get: function() {
      return messages_1.NotificationType1;
    } });
    Object.defineProperty(exports2, "NotificationType2", { enumerable: true, get: function() {
      return messages_1.NotificationType2;
    } });
    Object.defineProperty(exports2, "NotificationType3", { enumerable: true, get: function() {
      return messages_1.NotificationType3;
    } });
    Object.defineProperty(exports2, "NotificationType4", { enumerable: true, get: function() {
      return messages_1.NotificationType4;
    } });
    Object.defineProperty(exports2, "NotificationType5", { enumerable: true, get: function() {
      return messages_1.NotificationType5;
    } });
    Object.defineProperty(exports2, "NotificationType6", { enumerable: true, get: function() {
      return messages_1.NotificationType6;
    } });
    Object.defineProperty(exports2, "NotificationType7", { enumerable: true, get: function() {
      return messages_1.NotificationType7;
    } });
    Object.defineProperty(exports2, "NotificationType8", { enumerable: true, get: function() {
      return messages_1.NotificationType8;
    } });
    Object.defineProperty(exports2, "NotificationType9", { enumerable: true, get: function() {
      return messages_1.NotificationType9;
    } });
    Object.defineProperty(exports2, "ParameterStructures", { enumerable: true, get: function() {
      return messages_1.ParameterStructures;
    } });
    const linkedMap_1 = requireLinkedMap$1();
    Object.defineProperty(exports2, "LinkedMap", { enumerable: true, get: function() {
      return linkedMap_1.LinkedMap;
    } });
    Object.defineProperty(exports2, "LRUCache", { enumerable: true, get: function() {
      return linkedMap_1.LRUCache;
    } });
    Object.defineProperty(exports2, "Touch", { enumerable: true, get: function() {
      return linkedMap_1.Touch;
    } });
    const disposable_1 = requireDisposable$1();
    Object.defineProperty(exports2, "Disposable", { enumerable: true, get: function() {
      return disposable_1.Disposable;
    } });
    const events_1 = requireEvents$1();
    Object.defineProperty(exports2, "Event", { enumerable: true, get: function() {
      return events_1.Event;
    } });
    Object.defineProperty(exports2, "Emitter", { enumerable: true, get: function() {
      return events_1.Emitter;
    } });
    const cancellation_1 = requireCancellation$1();
    Object.defineProperty(exports2, "CancellationTokenSource", { enumerable: true, get: function() {
      return cancellation_1.CancellationTokenSource;
    } });
    Object.defineProperty(exports2, "CancellationToken", { enumerable: true, get: function() {
      return cancellation_1.CancellationToken;
    } });
    const sharedArrayCancellation_1 = requireSharedArrayCancellation$1();
    Object.defineProperty(exports2, "SharedArraySenderStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArraySenderStrategy;
    } });
    Object.defineProperty(exports2, "SharedArrayReceiverStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArrayReceiverStrategy;
    } });
    const messageReader_1 = requireMessageReader$1();
    Object.defineProperty(exports2, "MessageReader", { enumerable: true, get: function() {
      return messageReader_1.MessageReader;
    } });
    Object.defineProperty(exports2, "AbstractMessageReader", { enumerable: true, get: function() {
      return messageReader_1.AbstractMessageReader;
    } });
    Object.defineProperty(exports2, "ReadableStreamMessageReader", { enumerable: true, get: function() {
      return messageReader_1.ReadableStreamMessageReader;
    } });
    const messageWriter_1 = requireMessageWriter$1();
    Object.defineProperty(exports2, "MessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.MessageWriter;
    } });
    Object.defineProperty(exports2, "AbstractMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.AbstractMessageWriter;
    } });
    Object.defineProperty(exports2, "WriteableStreamMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.WriteableStreamMessageWriter;
    } });
    const messageBuffer_1 = requireMessageBuffer$1();
    Object.defineProperty(exports2, "AbstractMessageBuffer", { enumerable: true, get: function() {
      return messageBuffer_1.AbstractMessageBuffer;
    } });
    const connection_1 = requireConnection$1$1();
    Object.defineProperty(exports2, "ConnectionStrategy", { enumerable: true, get: function() {
      return connection_1.ConnectionStrategy;
    } });
    Object.defineProperty(exports2, "ConnectionOptions", { enumerable: true, get: function() {
      return connection_1.ConnectionOptions;
    } });
    Object.defineProperty(exports2, "NullLogger", { enumerable: true, get: function() {
      return connection_1.NullLogger;
    } });
    Object.defineProperty(exports2, "createMessageConnection", { enumerable: true, get: function() {
      return connection_1.createMessageConnection;
    } });
    Object.defineProperty(exports2, "ProgressToken", { enumerable: true, get: function() {
      return connection_1.ProgressToken;
    } });
    Object.defineProperty(exports2, "ProgressType", { enumerable: true, get: function() {
      return connection_1.ProgressType;
    } });
    Object.defineProperty(exports2, "Trace", { enumerable: true, get: function() {
      return connection_1.Trace;
    } });
    Object.defineProperty(exports2, "TraceValues", { enumerable: true, get: function() {
      return connection_1.TraceValues;
    } });
    Object.defineProperty(exports2, "TraceFormat", { enumerable: true, get: function() {
      return connection_1.TraceFormat;
    } });
    Object.defineProperty(exports2, "SetTraceNotification", { enumerable: true, get: function() {
      return connection_1.SetTraceNotification;
    } });
    Object.defineProperty(exports2, "LogTraceNotification", { enumerable: true, get: function() {
      return connection_1.LogTraceNotification;
    } });
    Object.defineProperty(exports2, "ConnectionErrors", { enumerable: true, get: function() {
      return connection_1.ConnectionErrors;
    } });
    Object.defineProperty(exports2, "ConnectionError", { enumerable: true, get: function() {
      return connection_1.ConnectionError;
    } });
    Object.defineProperty(exports2, "CancellationReceiverStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationReceiverStrategy;
    } });
    Object.defineProperty(exports2, "CancellationSenderStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationSenderStrategy;
    } });
    Object.defineProperty(exports2, "CancellationStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationStrategy;
    } });
    Object.defineProperty(exports2, "MessageStrategy", { enumerable: true, get: function() {
      return connection_1.MessageStrategy;
    } });
    const ral_1 = requireRal$1();
    exports2.RAL = ral_1.default;
  })(api$1$1);
  return api$1$1;
}
var hasRequiredRil$1;
function requireRil$1() {
  if (hasRequiredRil$1) return ril$1;
  hasRequiredRil$1 = 1;
  Object.defineProperty(ril$1, "__esModule", { value: true });
  const api_1 = requireApi$2();
  class MessageBuffer extends api_1.AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      super(encoding);
      this.asciiDecoder = new TextDecoder("ascii");
    }
    emptyBuffer() {
      return MessageBuffer.emptyBuffer;
    }
    fromString(value, _encoding) {
      return new TextEncoder().encode(value);
    }
    toString(value, encoding) {
      if (encoding === "ascii") {
        return this.asciiDecoder.decode(value);
      } else {
        return new TextDecoder(encoding).decode(value);
      }
    }
    asNative(buffer, length) {
      if (length === void 0) {
        return buffer;
      } else {
        return buffer.slice(0, length);
      }
    }
    allocNative(length) {
      return new Uint8Array(length);
    }
  }
  MessageBuffer.emptyBuffer = new Uint8Array(0);
  class ReadableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
      this._onData = new api_1.Emitter();
      this._messageListener = (event) => {
        const blob = event.data;
        blob.arrayBuffer().then((buffer) => {
          this._onData.fire(new Uint8Array(buffer));
        }, () => {
          (0, api_1.RAL)().console.error(`Converting blob to array buffer failed.`);
        });
      };
      this.socket.addEventListener("message", this._messageListener);
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    onData(listener) {
      return this._onData.event(listener);
    }
  }
  class WritableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    write(data, encoding) {
      if (typeof data === "string") {
        if (encoding !== void 0 && encoding !== "utf-8") {
          throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${encoding}`);
        }
        this.socket.send(data);
      } else {
        this.socket.send(data);
      }
      return Promise.resolve();
    }
    end() {
      this.socket.close();
    }
  }
  const _textEncoder = new TextEncoder();
  const _ril = Object.freeze({
    messageBuffer: Object.freeze({
      create: (encoding) => new MessageBuffer(encoding)
    }),
    applicationJson: Object.freeze({
      encoder: Object.freeze({
        name: "application/json",
        encode: (msg, options2) => {
          if (options2.charset !== "utf-8") {
            throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${options2.charset}`);
          }
          return Promise.resolve(_textEncoder.encode(JSON.stringify(msg, void 0, 0)));
        }
      }),
      decoder: Object.freeze({
        name: "application/json",
        decode: (buffer, options2) => {
          if (!(buffer instanceof Uint8Array)) {
            throw new Error(`In a Browser environments only Uint8Arrays are supported.`);
          }
          return Promise.resolve(JSON.parse(new TextDecoder(options2.charset).decode(buffer)));
        }
      })
    }),
    stream: Object.freeze({
      asReadableStream: (socket) => new ReadableStreamWrapper(socket),
      asWritableStream: (socket) => new WritableStreamWrapper(socket)
    }),
    console,
    timer: Object.freeze({
      setTimeout(callback, ms, ...args) {
        const handle = setTimeout(callback, ms, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setImmediate(callback, ...args) {
        const handle = setTimeout(callback, 0, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setInterval(callback, ms, ...args) {
        const handle = setInterval(callback, ms, ...args);
        return { dispose: () => clearInterval(handle) };
      }
    })
  });
  function RIL() {
    return _ril;
  }
  (function(RIL2) {
    function install() {
      api_1.RAL.install(_ril);
    }
    RIL2.install = install;
  })(RIL || (RIL = {}));
  ril$1.default = RIL;
  return ril$1;
}
var hasRequiredMain$2;
function requireMain$2() {
  if (hasRequiredMain$2) return main$1$1;
  hasRequiredMain$2 = 1;
  (function(exports2) {
    var __createBinding = main$1$1 && main$1$1.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = main$1$1 && main$1$1.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createMessageConnection = exports2.BrowserMessageWriter = exports2.BrowserMessageReader = void 0;
    const ril_1 = requireRil$1();
    ril_1.default.install();
    const api_1 = requireApi$2();
    __exportStar(requireApi$2(), exports2);
    class BrowserMessageReader extends api_1.AbstractMessageReader {
      constructor(port) {
        super();
        this._onData = new api_1.Emitter();
        this._messageListener = (event) => {
          this._onData.fire(event.data);
        };
        port.addEventListener("error", (event) => this.fireError(event));
        port.onmessage = this._messageListener;
      }
      listen(callback) {
        return this._onData.event(callback);
      }
    }
    exports2.BrowserMessageReader = BrowserMessageReader;
    class BrowserMessageWriter extends api_1.AbstractMessageWriter {
      constructor(port) {
        super();
        this.port = port;
        this.errorCount = 0;
        port.addEventListener("error", (event) => this.fireError(event));
      }
      write(msg) {
        try {
          this.port.postMessage(msg);
          return Promise.resolve();
        } catch (error) {
          this.handleError(error, msg);
          return Promise.reject(error);
        }
      }
      handleError(error, msg) {
        this.errorCount++;
        this.fireError(error, msg, this.errorCount);
      }
      end() {
      }
    }
    exports2.BrowserMessageWriter = BrowserMessageWriter;
    function createMessageConnection2(reader, writer, logger, options2) {
      if (logger === void 0) {
        logger = api_1.NullLogger;
      }
      if (api_1.ConnectionStrategy.is(options2)) {
        options2 = { connectionStrategy: options2 };
      }
      return (0, api_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports2.createMessageConnection = createMessageConnection2;
  })(main$1$1);
  return main$1$1;
}
var browser$2;
var hasRequiredBrowser$2;
function requireBrowser$2() {
  if (hasRequiredBrowser$2) return browser$2;
  hasRequiredBrowser$2 = 1;
  browser$2 = requireMain$2();
  return browser$2;
}
var api$3 = {};
var DocumentUri$1;
(function(DocumentUri2) {
  function is2(value) {
    return typeof value === "string";
  }
  DocumentUri2.is = is2;
})(DocumentUri$1 || (DocumentUri$1 = {}));
var URI$1;
(function(URI2) {
  function is2(value) {
    return typeof value === "string";
  }
  URI2.is = is2;
})(URI$1 || (URI$1 = {}));
var integer$1;
(function(integer2) {
  integer2.MIN_VALUE = -2147483648;
  integer2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && integer2.MIN_VALUE <= value && value <= integer2.MAX_VALUE;
  }
  integer2.is = is2;
})(integer$1 || (integer$1 = {}));
var uinteger$1;
(function(uinteger2) {
  uinteger2.MIN_VALUE = 0;
  uinteger2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && uinteger2.MIN_VALUE <= value && value <= uinteger2.MAX_VALUE;
  }
  uinteger2.is = is2;
})(uinteger$1 || (uinteger$1 = {}));
var Position$1;
(function(Position2) {
  function create2(line2, character) {
    if (line2 === Number.MAX_VALUE) {
      line2 = uinteger$1.MAX_VALUE;
    }
    if (character === Number.MAX_VALUE) {
      character = uinteger$1.MAX_VALUE;
    }
    return { line: line2, character };
  }
  Position2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.uinteger(candidate.line) && Is$1.uinteger(candidate.character);
  }
  Position2.is = is2;
})(Position$1 || (Position$1 = {}));
var Range$4;
(function(Range5) {
  function create2(one, two, three, four) {
    if (Is$1.uinteger(one) && Is$1.uinteger(two) && Is$1.uinteger(three) && Is$1.uinteger(four)) {
      return { start: Position$1.create(one, two), end: Position$1.create(three, four) };
    } else if (Position$1.is(one) && Position$1.is(two)) {
      return { start: one, end: two };
    } else {
      throw new Error(`Range#create called with invalid arguments[${one}, ${two}, ${three}, ${four}]`);
    }
  }
  Range5.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.objectLiteral(candidate) && Position$1.is(candidate.start) && Position$1.is(candidate.end);
  }
  Range5.is = is2;
})(Range$4 || (Range$4 = {}));
var Location$1;
(function(Location2) {
  function create2(uri, range2) {
    return { uri, range: range2 };
  }
  Location2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.objectLiteral(candidate) && Range$4.is(candidate.range) && (Is$1.string(candidate.uri) || Is$1.undefined(candidate.uri));
  }
  Location2.is = is2;
})(Location$1 || (Location$1 = {}));
var LocationLink$1;
(function(LocationLink2) {
  function create2(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
    return { targetUri, targetRange, targetSelectionRange, originSelectionRange };
  }
  LocationLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.objectLiteral(candidate) && Range$4.is(candidate.targetRange) && Is$1.string(candidate.targetUri) && Range$4.is(candidate.targetSelectionRange) && (Range$4.is(candidate.originSelectionRange) || Is$1.undefined(candidate.originSelectionRange));
  }
  LocationLink2.is = is2;
})(LocationLink$1 || (LocationLink$1 = {}));
var Color$1;
(function(Color2) {
  function create2(red, green, blue, alpha) {
    return {
      red,
      green,
      blue,
      alpha
    };
  }
  Color2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.numberRange(candidate.red, 0, 1) && Is$1.numberRange(candidate.green, 0, 1) && Is$1.numberRange(candidate.blue, 0, 1) && Is$1.numberRange(candidate.alpha, 0, 1);
  }
  Color2.is = is2;
})(Color$1 || (Color$1 = {}));
var ColorInformation$1;
(function(ColorInformation2) {
  function create2(range2, color) {
    return {
      range: range2,
      color
    };
  }
  ColorInformation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Range$4.is(candidate.range) && Color$1.is(candidate.color);
  }
  ColorInformation2.is = is2;
})(ColorInformation$1 || (ColorInformation$1 = {}));
var ColorPresentation$1;
(function(ColorPresentation2) {
  function create2(label2, textEdit, additionalTextEdits) {
    return {
      label: label2,
      textEdit,
      additionalTextEdits
    };
  }
  ColorPresentation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.string(candidate.label) && (Is$1.undefined(candidate.textEdit) || TextEdit$1.is(candidate)) && (Is$1.undefined(candidate.additionalTextEdits) || Is$1.typedArray(candidate.additionalTextEdits, TextEdit$1.is));
  }
  ColorPresentation2.is = is2;
})(ColorPresentation$1 || (ColorPresentation$1 = {}));
var FoldingRangeKind$1;
(function(FoldingRangeKind2) {
  FoldingRangeKind2.Comment = "comment";
  FoldingRangeKind2.Imports = "imports";
  FoldingRangeKind2.Region = "region";
})(FoldingRangeKind$1 || (FoldingRangeKind$1 = {}));
var FoldingRange$1;
(function(FoldingRange2) {
  function create2(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
    const result2 = {
      startLine,
      endLine
    };
    if (Is$1.defined(startCharacter)) {
      result2.startCharacter = startCharacter;
    }
    if (Is$1.defined(endCharacter)) {
      result2.endCharacter = endCharacter;
    }
    if (Is$1.defined(kind)) {
      result2.kind = kind;
    }
    if (Is$1.defined(collapsedText)) {
      result2.collapsedText = collapsedText;
    }
    return result2;
  }
  FoldingRange2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.uinteger(candidate.startLine) && Is$1.uinteger(candidate.startLine) && (Is$1.undefined(candidate.startCharacter) || Is$1.uinteger(candidate.startCharacter)) && (Is$1.undefined(candidate.endCharacter) || Is$1.uinteger(candidate.endCharacter)) && (Is$1.undefined(candidate.kind) || Is$1.string(candidate.kind));
  }
  FoldingRange2.is = is2;
})(FoldingRange$1 || (FoldingRange$1 = {}));
var DiagnosticRelatedInformation$1;
(function(DiagnosticRelatedInformation2) {
  function create2(location, message) {
    return {
      location,
      message
    };
  }
  DiagnosticRelatedInformation2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Location$1.is(candidate.location) && Is$1.string(candidate.message);
  }
  DiagnosticRelatedInformation2.is = is2;
})(DiagnosticRelatedInformation$1 || (DiagnosticRelatedInformation$1 = {}));
var DiagnosticSeverity$1;
(function(DiagnosticSeverity2) {
  DiagnosticSeverity2.Error = 1;
  DiagnosticSeverity2.Warning = 2;
  DiagnosticSeverity2.Information = 3;
  DiagnosticSeverity2.Hint = 4;
})(DiagnosticSeverity$1 || (DiagnosticSeverity$1 = {}));
var DiagnosticTag$1;
(function(DiagnosticTag2) {
  DiagnosticTag2.Unnecessary = 1;
  DiagnosticTag2.Deprecated = 2;
})(DiagnosticTag$1 || (DiagnosticTag$1 = {}));
var CodeDescription$1;
(function(CodeDescription2) {
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.string(candidate.href);
  }
  CodeDescription2.is = is2;
})(CodeDescription$1 || (CodeDescription$1 = {}));
var Diagnostic$1;
(function(Diagnostic2) {
  function create2(range2, message, severity, code2, source, relatedInformation) {
    let result2 = { range: range2, message };
    if (Is$1.defined(severity)) {
      result2.severity = severity;
    }
    if (Is$1.defined(code2)) {
      result2.code = code2;
    }
    if (Is$1.defined(source)) {
      result2.source = source;
    }
    if (Is$1.defined(relatedInformation)) {
      result2.relatedInformation = relatedInformation;
    }
    return result2;
  }
  Diagnostic2.create = create2;
  function is2(value) {
    var _a2;
    let candidate = value;
    return Is$1.defined(candidate) && Range$4.is(candidate.range) && Is$1.string(candidate.message) && (Is$1.number(candidate.severity) || Is$1.undefined(candidate.severity)) && (Is$1.integer(candidate.code) || Is$1.string(candidate.code) || Is$1.undefined(candidate.code)) && (Is$1.undefined(candidate.codeDescription) || Is$1.string((_a2 = candidate.codeDescription) === null || _a2 === void 0 ? void 0 : _a2.href)) && (Is$1.string(candidate.source) || Is$1.undefined(candidate.source)) && (Is$1.undefined(candidate.relatedInformation) || Is$1.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation$1.is));
  }
  Diagnostic2.is = is2;
})(Diagnostic$1 || (Diagnostic$1 = {}));
var Command$1;
(function(Command22) {
  function create2(title, command2, ...args) {
    let result2 = { title, command: command2 };
    if (Is$1.defined(args) && args.length > 0) {
      result2.arguments = args;
    }
    return result2;
  }
  Command22.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.title) && Is$1.string(candidate.command);
  }
  Command22.is = is2;
})(Command$1 || (Command$1 = {}));
var TextEdit$1;
(function(TextEdit2) {
  function replace2(range2, newText) {
    return { range: range2, newText };
  }
  TextEdit2.replace = replace2;
  function insert2(position2, newText) {
    return { range: { start: position2, end: position2 }, newText };
  }
  TextEdit2.insert = insert2;
  function del(range2) {
    return { range: range2, newText: "" };
  }
  TextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.string(candidate.newText) && Range$4.is(candidate.range);
  }
  TextEdit2.is = is2;
})(TextEdit$1 || (TextEdit$1 = {}));
var ChangeAnnotation$1;
(function(ChangeAnnotation2) {
  function create2(label2, needsConfirmation, description) {
    const result2 = { label: label2 };
    if (needsConfirmation !== void 0) {
      result2.needsConfirmation = needsConfirmation;
    }
    if (description !== void 0) {
      result2.description = description;
    }
    return result2;
  }
  ChangeAnnotation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Is$1.string(candidate.label) && (Is$1.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === void 0) && (Is$1.string(candidate.description) || candidate.description === void 0);
  }
  ChangeAnnotation2.is = is2;
})(ChangeAnnotation$1 || (ChangeAnnotation$1 = {}));
var ChangeAnnotationIdentifier$1;
(function(ChangeAnnotationIdentifier2) {
  function is2(value) {
    const candidate = value;
    return Is$1.string(candidate);
  }
  ChangeAnnotationIdentifier2.is = is2;
})(ChangeAnnotationIdentifier$1 || (ChangeAnnotationIdentifier$1 = {}));
var AnnotatedTextEdit$1;
(function(AnnotatedTextEdit2) {
  function replace2(range2, newText, annotation) {
    return { range: range2, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.replace = replace2;
  function insert2(position2, newText, annotation) {
    return { range: { start: position2, end: position2 }, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.insert = insert2;
  function del(range2, annotation) {
    return { range: range2, newText: "", annotationId: annotation };
  }
  AnnotatedTextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return TextEdit$1.is(candidate) && (ChangeAnnotation$1.is(candidate.annotationId) || ChangeAnnotationIdentifier$1.is(candidate.annotationId));
  }
  AnnotatedTextEdit2.is = is2;
})(AnnotatedTextEdit$1 || (AnnotatedTextEdit$1 = {}));
var TextDocumentEdit$1;
(function(TextDocumentEdit2) {
  function create2(textDocument, edits) {
    return { textDocument, edits };
  }
  TextDocumentEdit2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && OptionalVersionedTextDocumentIdentifier$1.is(candidate.textDocument) && Array.isArray(candidate.edits);
  }
  TextDocumentEdit2.is = is2;
})(TextDocumentEdit$1 || (TextDocumentEdit$1 = {}));
var CreateFile$1;
(function(CreateFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "create",
      uri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  CreateFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "create" && Is$1.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is$1.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is$1.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier$1.is(candidate.annotationId));
  }
  CreateFile2.is = is2;
})(CreateFile$1 || (CreateFile$1 = {}));
var RenameFile$1;
(function(RenameFile2) {
  function create2(oldUri, newUri, options2, annotation) {
    let result2 = {
      kind: "rename",
      oldUri,
      newUri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  RenameFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "rename" && Is$1.string(candidate.oldUri) && Is$1.string(candidate.newUri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is$1.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is$1.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier$1.is(candidate.annotationId));
  }
  RenameFile2.is = is2;
})(RenameFile$1 || (RenameFile$1 = {}));
var DeleteFile$1;
(function(DeleteFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "delete",
      uri
    };
    if (options2 !== void 0 && (options2.recursive !== void 0 || options2.ignoreIfNotExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  DeleteFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "delete" && Is$1.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.recursive === void 0 || Is$1.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === void 0 || Is$1.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier$1.is(candidate.annotationId));
  }
  DeleteFile2.is = is2;
})(DeleteFile$1 || (DeleteFile$1 = {}));
var WorkspaceEdit$1;
(function(WorkspaceEdit2) {
  function is2(value) {
    let candidate = value;
    return candidate && (candidate.changes !== void 0 || candidate.documentChanges !== void 0) && (candidate.documentChanges === void 0 || candidate.documentChanges.every((change) => {
      if (Is$1.string(change.kind)) {
        return CreateFile$1.is(change) || RenameFile$1.is(change) || DeleteFile$1.is(change);
      } else {
        return TextDocumentEdit$1.is(change);
      }
    }));
  }
  WorkspaceEdit2.is = is2;
})(WorkspaceEdit$1 || (WorkspaceEdit$1 = {}));
let TextEditChangeImpl$1 = class TextEditChangeImpl2 {
  constructor(edits, changeAnnotations) {
    this.edits = edits;
    this.changeAnnotations = changeAnnotations;
  }
  insert(position2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit$1.insert(position2, newText);
    } else if (ChangeAnnotationIdentifier$1.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit$1.insert(position2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit$1.insert(position2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  replace(range2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit$1.replace(range2, newText);
    } else if (ChangeAnnotationIdentifier$1.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit$1.replace(range2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit$1.replace(range2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  delete(range2, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit$1.del(range2);
    } else if (ChangeAnnotationIdentifier$1.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit$1.del(range2, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit$1.del(range2, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  add(edit) {
    this.edits.push(edit);
  }
  all() {
    return this.edits;
  }
  clear() {
    this.edits.splice(0, this.edits.length);
  }
  assertChangeAnnotations(value) {
    if (value === void 0) {
      throw new Error(`Text edit change is not configured to manage change annotations.`);
    }
  }
};
let ChangeAnnotations$1 = class ChangeAnnotations2 {
  constructor(annotations) {
    this._annotations = annotations === void 0 ? /* @__PURE__ */ Object.create(null) : annotations;
    this._counter = 0;
    this._size = 0;
  }
  all() {
    return this._annotations;
  }
  get size() {
    return this._size;
  }
  manage(idOrAnnotation, annotation) {
    let id2;
    if (ChangeAnnotationIdentifier$1.is(idOrAnnotation)) {
      id2 = idOrAnnotation;
    } else {
      id2 = this.nextId();
      annotation = idOrAnnotation;
    }
    if (this._annotations[id2] !== void 0) {
      throw new Error(`Id ${id2} is already in use.`);
    }
    if (annotation === void 0) {
      throw new Error(`No annotation provided for id ${id2}`);
    }
    this._annotations[id2] = annotation;
    this._size++;
    return id2;
  }
  nextId() {
    this._counter++;
    return this._counter.toString();
  }
};
let WorkspaceChange$1 = class WorkspaceChange2 {
  constructor(workspaceEdit) {
    this._textEditChanges = /* @__PURE__ */ Object.create(null);
    if (workspaceEdit !== void 0) {
      this._workspaceEdit = workspaceEdit;
      if (workspaceEdit.documentChanges) {
        this._changeAnnotations = new ChangeAnnotations$1(workspaceEdit.changeAnnotations);
        workspaceEdit.changeAnnotations = this._changeAnnotations.all();
        workspaceEdit.documentChanges.forEach((change) => {
          if (TextDocumentEdit$1.is(change)) {
            const textEditChange = new TextEditChangeImpl$1(change.edits, this._changeAnnotations);
            this._textEditChanges[change.textDocument.uri] = textEditChange;
          }
        });
      } else if (workspaceEdit.changes) {
        Object.keys(workspaceEdit.changes).forEach((key) => {
          const textEditChange = new TextEditChangeImpl$1(workspaceEdit.changes[key]);
          this._textEditChanges[key] = textEditChange;
        });
      }
    } else {
      this._workspaceEdit = {};
    }
  }
  /**
   * Returns the underlying {@link WorkspaceEdit} literal
   * use to be returned from a workspace edit operation like rename.
   */
  get edit() {
    this.initDocumentChanges();
    if (this._changeAnnotations !== void 0) {
      if (this._changeAnnotations.size === 0) {
        this._workspaceEdit.changeAnnotations = void 0;
      } else {
        this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
      }
    }
    return this._workspaceEdit;
  }
  getTextEditChange(key) {
    if (OptionalVersionedTextDocumentIdentifier$1.is(key)) {
      this.initDocumentChanges();
      if (this._workspaceEdit.documentChanges === void 0) {
        throw new Error("Workspace edit is not configured for document changes.");
      }
      const textDocument = { uri: key.uri, version: key.version };
      let result2 = this._textEditChanges[textDocument.uri];
      if (!result2) {
        const edits = [];
        const textDocumentEdit = {
          textDocument,
          edits
        };
        this._workspaceEdit.documentChanges.push(textDocumentEdit);
        result2 = new TextEditChangeImpl$1(edits, this._changeAnnotations);
        this._textEditChanges[textDocument.uri] = result2;
      }
      return result2;
    } else {
      this.initChanges();
      if (this._workspaceEdit.changes === void 0) {
        throw new Error("Workspace edit is not configured for normal text edit changes.");
      }
      let result2 = this._textEditChanges[key];
      if (!result2) {
        let edits = [];
        this._workspaceEdit.changes[key] = edits;
        result2 = new TextEditChangeImpl$1(edits);
        this._textEditChanges[key] = result2;
      }
      return result2;
    }
  }
  initDocumentChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._changeAnnotations = new ChangeAnnotations$1();
      this._workspaceEdit.documentChanges = [];
      this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
    }
  }
  initChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._workspaceEdit.changes = /* @__PURE__ */ Object.create(null);
    }
  }
  createFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation$1.is(optionsOrAnnotation) || ChangeAnnotationIdentifier$1.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = CreateFile$1.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier$1.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = CreateFile$1.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  renameFile(oldUri, newUri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation$1.is(optionsOrAnnotation) || ChangeAnnotationIdentifier$1.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = RenameFile$1.create(oldUri, newUri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier$1.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = RenameFile$1.create(oldUri, newUri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  deleteFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation$1.is(optionsOrAnnotation) || ChangeAnnotationIdentifier$1.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = DeleteFile$1.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier$1.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = DeleteFile$1.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
};
var TextDocumentIdentifier$1;
(function(TextDocumentIdentifier2) {
  function create2(uri) {
    return { uri };
  }
  TextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.uri);
  }
  TextDocumentIdentifier2.is = is2;
})(TextDocumentIdentifier$1 || (TextDocumentIdentifier$1 = {}));
var VersionedTextDocumentIdentifier$1;
(function(VersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  VersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.uri) && Is$1.integer(candidate.version);
  }
  VersionedTextDocumentIdentifier2.is = is2;
})(VersionedTextDocumentIdentifier$1 || (VersionedTextDocumentIdentifier$1 = {}));
var OptionalVersionedTextDocumentIdentifier$1;
(function(OptionalVersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  OptionalVersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.uri) && (candidate.version === null || Is$1.integer(candidate.version));
  }
  OptionalVersionedTextDocumentIdentifier2.is = is2;
})(OptionalVersionedTextDocumentIdentifier$1 || (OptionalVersionedTextDocumentIdentifier$1 = {}));
var TextDocumentItem$1;
(function(TextDocumentItem2) {
  function create2(uri, languageId, version2, text2) {
    return { uri, languageId, version: version2, text: text2 };
  }
  TextDocumentItem2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.uri) && Is$1.string(candidate.languageId) && Is$1.integer(candidate.version) && Is$1.string(candidate.text);
  }
  TextDocumentItem2.is = is2;
})(TextDocumentItem$1 || (TextDocumentItem$1 = {}));
var MarkupKind$1;
(function(MarkupKind2) {
  MarkupKind2.PlainText = "plaintext";
  MarkupKind2.Markdown = "markdown";
  function is2(value) {
    const candidate = value;
    return candidate === MarkupKind2.PlainText || candidate === MarkupKind2.Markdown;
  }
  MarkupKind2.is = is2;
})(MarkupKind$1 || (MarkupKind$1 = {}));
var MarkupContent$1;
(function(MarkupContent2) {
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(value) && MarkupKind$1.is(candidate.kind) && Is$1.string(candidate.value);
  }
  MarkupContent2.is = is2;
})(MarkupContent$1 || (MarkupContent$1 = {}));
var CompletionItemKind$1;
(function(CompletionItemKind2) {
  CompletionItemKind2.Text = 1;
  CompletionItemKind2.Method = 2;
  CompletionItemKind2.Function = 3;
  CompletionItemKind2.Constructor = 4;
  CompletionItemKind2.Field = 5;
  CompletionItemKind2.Variable = 6;
  CompletionItemKind2.Class = 7;
  CompletionItemKind2.Interface = 8;
  CompletionItemKind2.Module = 9;
  CompletionItemKind2.Property = 10;
  CompletionItemKind2.Unit = 11;
  CompletionItemKind2.Value = 12;
  CompletionItemKind2.Enum = 13;
  CompletionItemKind2.Keyword = 14;
  CompletionItemKind2.Snippet = 15;
  CompletionItemKind2.Color = 16;
  CompletionItemKind2.File = 17;
  CompletionItemKind2.Reference = 18;
  CompletionItemKind2.Folder = 19;
  CompletionItemKind2.EnumMember = 20;
  CompletionItemKind2.Constant = 21;
  CompletionItemKind2.Struct = 22;
  CompletionItemKind2.Event = 23;
  CompletionItemKind2.Operator = 24;
  CompletionItemKind2.TypeParameter = 25;
})(CompletionItemKind$1 || (CompletionItemKind$1 = {}));
var InsertTextFormat$1;
(function(InsertTextFormat2) {
  InsertTextFormat2.PlainText = 1;
  InsertTextFormat2.Snippet = 2;
})(InsertTextFormat$1 || (InsertTextFormat$1 = {}));
var CompletionItemTag$1;
(function(CompletionItemTag2) {
  CompletionItemTag2.Deprecated = 1;
})(CompletionItemTag$1 || (CompletionItemTag$1 = {}));
var InsertReplaceEdit$1;
(function(InsertReplaceEdit2) {
  function create2(newText, insert2, replace2) {
    return { newText, insert: insert2, replace: replace2 };
  }
  InsertReplaceEdit2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate && Is$1.string(candidate.newText) && Range$4.is(candidate.insert) && Range$4.is(candidate.replace);
  }
  InsertReplaceEdit2.is = is2;
})(InsertReplaceEdit$1 || (InsertReplaceEdit$1 = {}));
var InsertTextMode$1;
(function(InsertTextMode2) {
  InsertTextMode2.asIs = 1;
  InsertTextMode2.adjustIndentation = 2;
})(InsertTextMode$1 || (InsertTextMode$1 = {}));
var CompletionItemLabelDetails$1;
(function(CompletionItemLabelDetails2) {
  function is2(value) {
    const candidate = value;
    return candidate && (Is$1.string(candidate.detail) || candidate.detail === void 0) && (Is$1.string(candidate.description) || candidate.description === void 0);
  }
  CompletionItemLabelDetails2.is = is2;
})(CompletionItemLabelDetails$1 || (CompletionItemLabelDetails$1 = {}));
var CompletionItem$1;
(function(CompletionItem2) {
  function create2(label2) {
    return { label: label2 };
  }
  CompletionItem2.create = create2;
})(CompletionItem$1 || (CompletionItem$1 = {}));
var CompletionList$1;
(function(CompletionList2) {
  function create2(items, isIncomplete) {
    return { items: items ? items : [], isIncomplete: !!isIncomplete };
  }
  CompletionList2.create = create2;
})(CompletionList$1 || (CompletionList$1 = {}));
var MarkedString$1;
(function(MarkedString2) {
  function fromPlainText(plainText) {
    return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&");
  }
  MarkedString2.fromPlainText = fromPlainText;
  function is2(value) {
    const candidate = value;
    return Is$1.string(candidate) || Is$1.objectLiteral(candidate) && Is$1.string(candidate.language) && Is$1.string(candidate.value);
  }
  MarkedString2.is = is2;
})(MarkedString$1 || (MarkedString$1 = {}));
var Hover$1;
(function(Hover2) {
  function is2(value) {
    let candidate = value;
    return !!candidate && Is$1.objectLiteral(candidate) && (MarkupContent$1.is(candidate.contents) || MarkedString$1.is(candidate.contents) || Is$1.typedArray(candidate.contents, MarkedString$1.is)) && (value.range === void 0 || Range$4.is(value.range));
  }
  Hover2.is = is2;
})(Hover$1 || (Hover$1 = {}));
var ParameterInformation$1;
(function(ParameterInformation2) {
  function create2(label2, documentation) {
    return documentation ? { label: label2, documentation } : { label: label2 };
  }
  ParameterInformation2.create = create2;
})(ParameterInformation$1 || (ParameterInformation$1 = {}));
var SignatureInformation$1;
(function(SignatureInformation2) {
  function create2(label2, documentation, ...parameters) {
    let result2 = { label: label2 };
    if (Is$1.defined(documentation)) {
      result2.documentation = documentation;
    }
    if (Is$1.defined(parameters)) {
      result2.parameters = parameters;
    } else {
      result2.parameters = [];
    }
    return result2;
  }
  SignatureInformation2.create = create2;
})(SignatureInformation$1 || (SignatureInformation$1 = {}));
var DocumentHighlightKind$1;
(function(DocumentHighlightKind2) {
  DocumentHighlightKind2.Text = 1;
  DocumentHighlightKind2.Read = 2;
  DocumentHighlightKind2.Write = 3;
})(DocumentHighlightKind$1 || (DocumentHighlightKind$1 = {}));
var DocumentHighlight$1;
(function(DocumentHighlight2) {
  function create2(range2, kind) {
    let result2 = { range: range2 };
    if (Is$1.number(kind)) {
      result2.kind = kind;
    }
    return result2;
  }
  DocumentHighlight2.create = create2;
})(DocumentHighlight$1 || (DocumentHighlight$1 = {}));
var SymbolKind$1;
(function(SymbolKind2) {
  SymbolKind2.File = 1;
  SymbolKind2.Module = 2;
  SymbolKind2.Namespace = 3;
  SymbolKind2.Package = 4;
  SymbolKind2.Class = 5;
  SymbolKind2.Method = 6;
  SymbolKind2.Property = 7;
  SymbolKind2.Field = 8;
  SymbolKind2.Constructor = 9;
  SymbolKind2.Enum = 10;
  SymbolKind2.Interface = 11;
  SymbolKind2.Function = 12;
  SymbolKind2.Variable = 13;
  SymbolKind2.Constant = 14;
  SymbolKind2.String = 15;
  SymbolKind2.Number = 16;
  SymbolKind2.Boolean = 17;
  SymbolKind2.Array = 18;
  SymbolKind2.Object = 19;
  SymbolKind2.Key = 20;
  SymbolKind2.Null = 21;
  SymbolKind2.EnumMember = 22;
  SymbolKind2.Struct = 23;
  SymbolKind2.Event = 24;
  SymbolKind2.Operator = 25;
  SymbolKind2.TypeParameter = 26;
})(SymbolKind$1 || (SymbolKind$1 = {}));
var SymbolTag$1;
(function(SymbolTag2) {
  SymbolTag2.Deprecated = 1;
})(SymbolTag$1 || (SymbolTag$1 = {}));
var SymbolInformation$1;
(function(SymbolInformation2) {
  function create2(name2, kind, range2, uri, containerName) {
    let result2 = {
      name: name2,
      kind,
      location: { uri, range: range2 }
    };
    if (containerName) {
      result2.containerName = containerName;
    }
    return result2;
  }
  SymbolInformation2.create = create2;
})(SymbolInformation$1 || (SymbolInformation$1 = {}));
var WorkspaceSymbol$1;
(function(WorkspaceSymbol2) {
  function create2(name2, kind, uri, range2) {
    return range2 !== void 0 ? { name: name2, kind, location: { uri, range: range2 } } : { name: name2, kind, location: { uri } };
  }
  WorkspaceSymbol2.create = create2;
})(WorkspaceSymbol$1 || (WorkspaceSymbol$1 = {}));
var DocumentSymbol$1;
(function(DocumentSymbol2) {
  function create2(name2, detail, kind, range2, selectionRange, children) {
    let result2 = {
      name: name2,
      detail,
      kind,
      range: range2,
      selectionRange
    };
    if (children !== void 0) {
      result2.children = children;
    }
    return result2;
  }
  DocumentSymbol2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is$1.string(candidate.name) && Is$1.number(candidate.kind) && Range$4.is(candidate.range) && Range$4.is(candidate.selectionRange) && (candidate.detail === void 0 || Is$1.string(candidate.detail)) && (candidate.deprecated === void 0 || Is$1.boolean(candidate.deprecated)) && (candidate.children === void 0 || Array.isArray(candidate.children)) && (candidate.tags === void 0 || Array.isArray(candidate.tags));
  }
  DocumentSymbol2.is = is2;
})(DocumentSymbol$1 || (DocumentSymbol$1 = {}));
var CodeActionKind$1;
(function(CodeActionKind2) {
  CodeActionKind2.Empty = "";
  CodeActionKind2.QuickFix = "quickfix";
  CodeActionKind2.Refactor = "refactor";
  CodeActionKind2.RefactorExtract = "refactor.extract";
  CodeActionKind2.RefactorInline = "refactor.inline";
  CodeActionKind2.RefactorRewrite = "refactor.rewrite";
  CodeActionKind2.Source = "source";
  CodeActionKind2.SourceOrganizeImports = "source.organizeImports";
  CodeActionKind2.SourceFixAll = "source.fixAll";
})(CodeActionKind$1 || (CodeActionKind$1 = {}));
var CodeActionTriggerKind$1;
(function(CodeActionTriggerKind2) {
  CodeActionTriggerKind2.Invoked = 1;
  CodeActionTriggerKind2.Automatic = 2;
})(CodeActionTriggerKind$1 || (CodeActionTriggerKind$1 = {}));
var CodeActionContext$1;
(function(CodeActionContext2) {
  function create2(diagnostics, only, triggerKind) {
    let result2 = { diagnostics };
    if (only !== void 0 && only !== null) {
      result2.only = only;
    }
    if (triggerKind !== void 0 && triggerKind !== null) {
      result2.triggerKind = triggerKind;
    }
    return result2;
  }
  CodeActionContext2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.typedArray(candidate.diagnostics, Diagnostic$1.is) && (candidate.only === void 0 || Is$1.typedArray(candidate.only, Is$1.string)) && (candidate.triggerKind === void 0 || candidate.triggerKind === CodeActionTriggerKind$1.Invoked || candidate.triggerKind === CodeActionTriggerKind$1.Automatic);
  }
  CodeActionContext2.is = is2;
})(CodeActionContext$1 || (CodeActionContext$1 = {}));
var CodeAction$1;
(function(CodeAction2) {
  function create2(title, kindOrCommandOrEdit, kind) {
    let result2 = { title };
    let checkKind = true;
    if (typeof kindOrCommandOrEdit === "string") {
      checkKind = false;
      result2.kind = kindOrCommandOrEdit;
    } else if (Command$1.is(kindOrCommandOrEdit)) {
      result2.command = kindOrCommandOrEdit;
    } else {
      result2.edit = kindOrCommandOrEdit;
    }
    if (checkKind && kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  CodeAction2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is$1.string(candidate.title) && (candidate.diagnostics === void 0 || Is$1.typedArray(candidate.diagnostics, Diagnostic$1.is)) && (candidate.kind === void 0 || Is$1.string(candidate.kind)) && (candidate.edit !== void 0 || candidate.command !== void 0) && (candidate.command === void 0 || Command$1.is(candidate.command)) && (candidate.isPreferred === void 0 || Is$1.boolean(candidate.isPreferred)) && (candidate.edit === void 0 || WorkspaceEdit$1.is(candidate.edit));
  }
  CodeAction2.is = is2;
})(CodeAction$1 || (CodeAction$1 = {}));
var CodeLens$1;
(function(CodeLens2) {
  function create2(range2, data) {
    let result2 = { range: range2 };
    if (Is$1.defined(data)) {
      result2.data = data;
    }
    return result2;
  }
  CodeLens2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Range$4.is(candidate.range) && (Is$1.undefined(candidate.command) || Command$1.is(candidate.command));
  }
  CodeLens2.is = is2;
})(CodeLens$1 || (CodeLens$1 = {}));
var FormattingOptions$1;
(function(FormattingOptions2) {
  function create2(tabSize, insertSpaces) {
    return { tabSize, insertSpaces };
  }
  FormattingOptions2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.uinteger(candidate.tabSize) && Is$1.boolean(candidate.insertSpaces);
  }
  FormattingOptions2.is = is2;
})(FormattingOptions$1 || (FormattingOptions$1 = {}));
var DocumentLink$1;
(function(DocumentLink2) {
  function create2(range2, target, data) {
    return { range: range2, target, data };
  }
  DocumentLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Range$4.is(candidate.range) && (Is$1.undefined(candidate.target) || Is$1.string(candidate.target));
  }
  DocumentLink2.is = is2;
})(DocumentLink$1 || (DocumentLink$1 = {}));
var SelectionRange$2;
(function(SelectionRange3) {
  function create2(range2, parent) {
    return { range: range2, parent };
  }
  SelectionRange3.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.objectLiteral(candidate) && Range$4.is(candidate.range) && (candidate.parent === void 0 || SelectionRange3.is(candidate.parent));
  }
  SelectionRange3.is = is2;
})(SelectionRange$2 || (SelectionRange$2 = {}));
var SemanticTokenTypes$1;
(function(SemanticTokenTypes2) {
  SemanticTokenTypes2["namespace"] = "namespace";
  SemanticTokenTypes2["type"] = "type";
  SemanticTokenTypes2["class"] = "class";
  SemanticTokenTypes2["enum"] = "enum";
  SemanticTokenTypes2["interface"] = "interface";
  SemanticTokenTypes2["struct"] = "struct";
  SemanticTokenTypes2["typeParameter"] = "typeParameter";
  SemanticTokenTypes2["parameter"] = "parameter";
  SemanticTokenTypes2["variable"] = "variable";
  SemanticTokenTypes2["property"] = "property";
  SemanticTokenTypes2["enumMember"] = "enumMember";
  SemanticTokenTypes2["event"] = "event";
  SemanticTokenTypes2["function"] = "function";
  SemanticTokenTypes2["method"] = "method";
  SemanticTokenTypes2["macro"] = "macro";
  SemanticTokenTypes2["keyword"] = "keyword";
  SemanticTokenTypes2["modifier"] = "modifier";
  SemanticTokenTypes2["comment"] = "comment";
  SemanticTokenTypes2["string"] = "string";
  SemanticTokenTypes2["number"] = "number";
  SemanticTokenTypes2["regexp"] = "regexp";
  SemanticTokenTypes2["operator"] = "operator";
  SemanticTokenTypes2["decorator"] = "decorator";
})(SemanticTokenTypes$1 || (SemanticTokenTypes$1 = {}));
var SemanticTokenModifiers$1;
(function(SemanticTokenModifiers2) {
  SemanticTokenModifiers2["declaration"] = "declaration";
  SemanticTokenModifiers2["definition"] = "definition";
  SemanticTokenModifiers2["readonly"] = "readonly";
  SemanticTokenModifiers2["static"] = "static";
  SemanticTokenModifiers2["deprecated"] = "deprecated";
  SemanticTokenModifiers2["abstract"] = "abstract";
  SemanticTokenModifiers2["async"] = "async";
  SemanticTokenModifiers2["modification"] = "modification";
  SemanticTokenModifiers2["documentation"] = "documentation";
  SemanticTokenModifiers2["defaultLibrary"] = "defaultLibrary";
})(SemanticTokenModifiers$1 || (SemanticTokenModifiers$1 = {}));
var SemanticTokens$1;
(function(SemanticTokens2) {
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && (candidate.resultId === void 0 || typeof candidate.resultId === "string") && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === "number");
  }
  SemanticTokens2.is = is2;
})(SemanticTokens$1 || (SemanticTokens$1 = {}));
var InlineValueText$1;
(function(InlineValueText2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  InlineValueText2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range$4.is(candidate.range) && Is$1.string(candidate.text);
  }
  InlineValueText2.is = is2;
})(InlineValueText$1 || (InlineValueText$1 = {}));
var InlineValueVariableLookup$1;
(function(InlineValueVariableLookup2) {
  function create2(range2, variableName, caseSensitiveLookup) {
    return { range: range2, variableName, caseSensitiveLookup };
  }
  InlineValueVariableLookup2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range$4.is(candidate.range) && Is$1.boolean(candidate.caseSensitiveLookup) && (Is$1.string(candidate.variableName) || candidate.variableName === void 0);
  }
  InlineValueVariableLookup2.is = is2;
})(InlineValueVariableLookup$1 || (InlineValueVariableLookup$1 = {}));
var InlineValueEvaluatableExpression$1;
(function(InlineValueEvaluatableExpression2) {
  function create2(range2, expression) {
    return { range: range2, expression };
  }
  InlineValueEvaluatableExpression2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range$4.is(candidate.range) && (Is$1.string(candidate.expression) || candidate.expression === void 0);
  }
  InlineValueEvaluatableExpression2.is = is2;
})(InlineValueEvaluatableExpression$1 || (InlineValueEvaluatableExpression$1 = {}));
var InlineValueContext$1;
(function(InlineValueContext2) {
  function create2(frameId, stoppedLocation) {
    return { frameId, stoppedLocation };
  }
  InlineValueContext2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.defined(candidate) && Range$4.is(value.stoppedLocation);
  }
  InlineValueContext2.is = is2;
})(InlineValueContext$1 || (InlineValueContext$1 = {}));
var InlayHintKind$1;
(function(InlayHintKind2) {
  InlayHintKind2.Type = 1;
  InlayHintKind2.Parameter = 2;
  function is2(value) {
    return value === 1 || value === 2;
  }
  InlayHintKind2.is = is2;
})(InlayHintKind$1 || (InlayHintKind$1 = {}));
var InlayHintLabelPart$1;
(function(InlayHintLabelPart2) {
  function create2(value) {
    return { value };
  }
  InlayHintLabelPart2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && (candidate.tooltip === void 0 || Is$1.string(candidate.tooltip) || MarkupContent$1.is(candidate.tooltip)) && (candidate.location === void 0 || Location$1.is(candidate.location)) && (candidate.command === void 0 || Command$1.is(candidate.command));
  }
  InlayHintLabelPart2.is = is2;
})(InlayHintLabelPart$1 || (InlayHintLabelPart$1 = {}));
var InlayHint$1;
(function(InlayHint2) {
  function create2(position2, label2, kind) {
    const result2 = { position: position2, label: label2 };
    if (kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  InlayHint2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && Position$1.is(candidate.position) && (Is$1.string(candidate.label) || Is$1.typedArray(candidate.label, InlayHintLabelPart$1.is)) && (candidate.kind === void 0 || InlayHintKind$1.is(candidate.kind)) && candidate.textEdits === void 0 || Is$1.typedArray(candidate.textEdits, TextEdit$1.is) && (candidate.tooltip === void 0 || Is$1.string(candidate.tooltip) || MarkupContent$1.is(candidate.tooltip)) && (candidate.paddingLeft === void 0 || Is$1.boolean(candidate.paddingLeft)) && (candidate.paddingRight === void 0 || Is$1.boolean(candidate.paddingRight));
  }
  InlayHint2.is = is2;
})(InlayHint$1 || (InlayHint$1 = {}));
var StringValue$1;
(function(StringValue2) {
  function createSnippet(value) {
    return { kind: "snippet", value };
  }
  StringValue2.createSnippet = createSnippet;
})(StringValue$1 || (StringValue$1 = {}));
var InlineCompletionItem$1;
(function(InlineCompletionItem2) {
  function create2(insertText, filterText, range2, command2) {
    return { insertText, filterText, range: range2, command: command2 };
  }
  InlineCompletionItem2.create = create2;
})(InlineCompletionItem$1 || (InlineCompletionItem$1 = {}));
var InlineCompletionList$1;
(function(InlineCompletionList2) {
  function create2(items) {
    return { items };
  }
  InlineCompletionList2.create = create2;
})(InlineCompletionList$1 || (InlineCompletionList$1 = {}));
var InlineCompletionTriggerKind$1;
(function(InlineCompletionTriggerKind2) {
  InlineCompletionTriggerKind2.Invoked = 0;
  InlineCompletionTriggerKind2.Automatic = 1;
})(InlineCompletionTriggerKind$1 || (InlineCompletionTriggerKind$1 = {}));
var SelectedCompletionInfo$1;
(function(SelectedCompletionInfo2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  SelectedCompletionInfo2.create = create2;
})(SelectedCompletionInfo$1 || (SelectedCompletionInfo$1 = {}));
var InlineCompletionContext$1;
(function(InlineCompletionContext2) {
  function create2(triggerKind, selectedCompletionInfo) {
    return { triggerKind, selectedCompletionInfo };
  }
  InlineCompletionContext2.create = create2;
})(InlineCompletionContext$1 || (InlineCompletionContext$1 = {}));
var WorkspaceFolder$1;
(function(WorkspaceFolder2) {
  function is2(value) {
    const candidate = value;
    return Is$1.objectLiteral(candidate) && URI$1.is(candidate.uri) && Is$1.string(candidate.name);
  }
  WorkspaceFolder2.is = is2;
})(WorkspaceFolder$1 || (WorkspaceFolder$1 = {}));
const EOL$1 = ["\n", "\r\n", "\r"];
var TextDocument$1;
(function(TextDocument2) {
  function create2(uri, languageId, version2, content2) {
    return new FullTextDocument$1(uri, languageId, version2, content2);
  }
  TextDocument2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is$1.defined(candidate) && Is$1.string(candidate.uri) && (Is$1.undefined(candidate.languageId) || Is$1.string(candidate.languageId)) && Is$1.uinteger(candidate.lineCount) && Is$1.func(candidate.getText) && Is$1.func(candidate.positionAt) && Is$1.func(candidate.offsetAt) ? true : false;
  }
  TextDocument2.is = is2;
  function applyEdits(document2, edits) {
    let text2 = document2.getText();
    let sortedEdits = mergeSort(edits, (a2, b2) => {
      let diff = a2.range.start.line - b2.range.start.line;
      if (diff === 0) {
        return a2.range.start.character - b2.range.start.character;
      }
      return diff;
    });
    let lastModifiedOffset = text2.length;
    for (let i2 = sortedEdits.length - 1; i2 >= 0; i2--) {
      let e2 = sortedEdits[i2];
      let startOffset = document2.offsetAt(e2.range.start);
      let endOffset = document2.offsetAt(e2.range.end);
      if (endOffset <= lastModifiedOffset) {
        text2 = text2.substring(0, startOffset) + e2.newText + text2.substring(endOffset, text2.length);
      } else {
        throw new Error("Overlapping edit");
      }
      lastModifiedOffset = startOffset;
    }
    return text2;
  }
  TextDocument2.applyEdits = applyEdits;
  function mergeSort(data, compare2) {
    if (data.length <= 1) {
      return data;
    }
    const p2 = data.length / 2 | 0;
    const left = data.slice(0, p2);
    const right = data.slice(p2);
    mergeSort(left, compare2);
    mergeSort(right, compare2);
    let leftIdx = 0;
    let rightIdx = 0;
    let i2 = 0;
    while (leftIdx < left.length && rightIdx < right.length) {
      let ret = compare2(left[leftIdx], right[rightIdx]);
      if (ret <= 0) {
        data[i2++] = left[leftIdx++];
      } else {
        data[i2++] = right[rightIdx++];
      }
    }
    while (leftIdx < left.length) {
      data[i2++] = left[leftIdx++];
    }
    while (rightIdx < right.length) {
      data[i2++] = right[rightIdx++];
    }
    return data;
  }
})(TextDocument$1 || (TextDocument$1 = {}));
let FullTextDocument$1 = class FullTextDocument2 {
  constructor(uri, languageId, version2, content2) {
    this._uri = uri;
    this._languageId = languageId;
    this._version = version2;
    this._content = content2;
    this._lineOffsets = void 0;
  }
  get uri() {
    return this._uri;
  }
  get languageId() {
    return this._languageId;
  }
  get version() {
    return this._version;
  }
  getText(range2) {
    if (range2) {
      let start = this.offsetAt(range2.start);
      let end = this.offsetAt(range2.end);
      return this._content.substring(start, end);
    }
    return this._content;
  }
  update(event, version2) {
    this._content = event.text;
    this._version = version2;
    this._lineOffsets = void 0;
  }
  getLineOffsets() {
    if (this._lineOffsets === void 0) {
      let lineOffsets = [];
      let text2 = this._content;
      let isLineStart = true;
      for (let i2 = 0; i2 < text2.length; i2++) {
        if (isLineStart) {
          lineOffsets.push(i2);
          isLineStart = false;
        }
        let ch = text2.charAt(i2);
        isLineStart = ch === "\r" || ch === "\n";
        if (ch === "\r" && i2 + 1 < text2.length && text2.charAt(i2 + 1) === "\n") {
          i2++;
        }
      }
      if (isLineStart && text2.length > 0) {
        lineOffsets.push(text2.length);
      }
      this._lineOffsets = lineOffsets;
    }
    return this._lineOffsets;
  }
  positionAt(offset2) {
    offset2 = Math.max(Math.min(offset2, this._content.length), 0);
    let lineOffsets = this.getLineOffsets();
    let low = 0, high = lineOffsets.length;
    if (high === 0) {
      return Position$1.create(0, offset2);
    }
    while (low < high) {
      let mid = Math.floor((low + high) / 2);
      if (lineOffsets[mid] > offset2) {
        high = mid;
      } else {
        low = mid + 1;
      }
    }
    let line2 = low - 1;
    return Position$1.create(line2, offset2 - lineOffsets[line2]);
  }
  offsetAt(position2) {
    let lineOffsets = this.getLineOffsets();
    if (position2.line >= lineOffsets.length) {
      return this._content.length;
    } else if (position2.line < 0) {
      return 0;
    }
    let lineOffset = lineOffsets[position2.line];
    let nextLineOffset = position2.line + 1 < lineOffsets.length ? lineOffsets[position2.line + 1] : this._content.length;
    return Math.max(Math.min(lineOffset + position2.character, nextLineOffset), lineOffset);
  }
  get lineCount() {
    return this.getLineOffsets().length;
  }
};
var Is$1;
(function(Is2) {
  const toString2 = Object.prototype.toString;
  function defined(value) {
    return typeof value !== "undefined";
  }
  Is2.defined = defined;
  function undefined$1(value) {
    return typeof value === "undefined";
  }
  Is2.undefined = undefined$1;
  function boolean(value) {
    return value === true || value === false;
  }
  Is2.boolean = boolean;
  function string2(value) {
    return toString2.call(value) === "[object String]";
  }
  Is2.string = string2;
  function number2(value) {
    return toString2.call(value) === "[object Number]";
  }
  Is2.number = number2;
  function numberRange(value, min2, max2) {
    return toString2.call(value) === "[object Number]" && min2 <= value && value <= max2;
  }
  Is2.numberRange = numberRange;
  function integer2(value) {
    return toString2.call(value) === "[object Number]" && -2147483648 <= value && value <= 2147483647;
  }
  Is2.integer = integer2;
  function uinteger2(value) {
    return toString2.call(value) === "[object Number]" && 0 <= value && value <= 2147483647;
  }
  Is2.uinteger = uinteger2;
  function func(value) {
    return toString2.call(value) === "[object Function]";
  }
  Is2.func = func;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  Is2.objectLiteral = objectLiteral;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  Is2.typedArray = typedArray;
})(Is$1 || (Is$1 = {}));
const main$4 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AnnotatedTextEdit() {
    return AnnotatedTextEdit$1;
  },
  get ChangeAnnotation() {
    return ChangeAnnotation$1;
  },
  get ChangeAnnotationIdentifier() {
    return ChangeAnnotationIdentifier$1;
  },
  get CodeAction() {
    return CodeAction$1;
  },
  get CodeActionContext() {
    return CodeActionContext$1;
  },
  get CodeActionKind() {
    return CodeActionKind$1;
  },
  get CodeActionTriggerKind() {
    return CodeActionTriggerKind$1;
  },
  get CodeDescription() {
    return CodeDescription$1;
  },
  get CodeLens() {
    return CodeLens$1;
  },
  get Color() {
    return Color$1;
  },
  get ColorInformation() {
    return ColorInformation$1;
  },
  get ColorPresentation() {
    return ColorPresentation$1;
  },
  get Command() {
    return Command$1;
  },
  get CompletionItem() {
    return CompletionItem$1;
  },
  get CompletionItemKind() {
    return CompletionItemKind$1;
  },
  get CompletionItemLabelDetails() {
    return CompletionItemLabelDetails$1;
  },
  get CompletionItemTag() {
    return CompletionItemTag$1;
  },
  get CompletionList() {
    return CompletionList$1;
  },
  get CreateFile() {
    return CreateFile$1;
  },
  get DeleteFile() {
    return DeleteFile$1;
  },
  get Diagnostic() {
    return Diagnostic$1;
  },
  get DiagnosticRelatedInformation() {
    return DiagnosticRelatedInformation$1;
  },
  get DiagnosticSeverity() {
    return DiagnosticSeverity$1;
  },
  get DiagnosticTag() {
    return DiagnosticTag$1;
  },
  get DocumentHighlight() {
    return DocumentHighlight$1;
  },
  get DocumentHighlightKind() {
    return DocumentHighlightKind$1;
  },
  get DocumentLink() {
    return DocumentLink$1;
  },
  get DocumentSymbol() {
    return DocumentSymbol$1;
  },
  get DocumentUri() {
    return DocumentUri$1;
  },
  EOL: EOL$1,
  get FoldingRange() {
    return FoldingRange$1;
  },
  get FoldingRangeKind() {
    return FoldingRangeKind$1;
  },
  get FormattingOptions() {
    return FormattingOptions$1;
  },
  get Hover() {
    return Hover$1;
  },
  get InlayHint() {
    return InlayHint$1;
  },
  get InlayHintKind() {
    return InlayHintKind$1;
  },
  get InlayHintLabelPart() {
    return InlayHintLabelPart$1;
  },
  get InlineCompletionContext() {
    return InlineCompletionContext$1;
  },
  get InlineCompletionItem() {
    return InlineCompletionItem$1;
  },
  get InlineCompletionList() {
    return InlineCompletionList$1;
  },
  get InlineCompletionTriggerKind() {
    return InlineCompletionTriggerKind$1;
  },
  get InlineValueContext() {
    return InlineValueContext$1;
  },
  get InlineValueEvaluatableExpression() {
    return InlineValueEvaluatableExpression$1;
  },
  get InlineValueText() {
    return InlineValueText$1;
  },
  get InlineValueVariableLookup() {
    return InlineValueVariableLookup$1;
  },
  get InsertReplaceEdit() {
    return InsertReplaceEdit$1;
  },
  get InsertTextFormat() {
    return InsertTextFormat$1;
  },
  get InsertTextMode() {
    return InsertTextMode$1;
  },
  get Location() {
    return Location$1;
  },
  get LocationLink() {
    return LocationLink$1;
  },
  get MarkedString() {
    return MarkedString$1;
  },
  get MarkupContent() {
    return MarkupContent$1;
  },
  get MarkupKind() {
    return MarkupKind$1;
  },
  get OptionalVersionedTextDocumentIdentifier() {
    return OptionalVersionedTextDocumentIdentifier$1;
  },
  get ParameterInformation() {
    return ParameterInformation$1;
  },
  get Position() {
    return Position$1;
  },
  get Range() {
    return Range$4;
  },
  get RenameFile() {
    return RenameFile$1;
  },
  get SelectedCompletionInfo() {
    return SelectedCompletionInfo$1;
  },
  get SelectionRange() {
    return SelectionRange$2;
  },
  get SemanticTokenModifiers() {
    return SemanticTokenModifiers$1;
  },
  get SemanticTokenTypes() {
    return SemanticTokenTypes$1;
  },
  get SemanticTokens() {
    return SemanticTokens$1;
  },
  get SignatureInformation() {
    return SignatureInformation$1;
  },
  get StringValue() {
    return StringValue$1;
  },
  get SymbolInformation() {
    return SymbolInformation$1;
  },
  get SymbolKind() {
    return SymbolKind$1;
  },
  get SymbolTag() {
    return SymbolTag$1;
  },
  get TextDocument() {
    return TextDocument$1;
  },
  get TextDocumentEdit() {
    return TextDocumentEdit$1;
  },
  get TextDocumentIdentifier() {
    return TextDocumentIdentifier$1;
  },
  get TextDocumentItem() {
    return TextDocumentItem$1;
  },
  get TextEdit() {
    return TextEdit$1;
  },
  get URI() {
    return URI$1;
  },
  get VersionedTextDocumentIdentifier() {
    return VersionedTextDocumentIdentifier$1;
  },
  WorkspaceChange: WorkspaceChange$1,
  get WorkspaceEdit() {
    return WorkspaceEdit$1;
  },
  get WorkspaceFolder() {
    return WorkspaceFolder$1;
  },
  get WorkspaceSymbol() {
    return WorkspaceSymbol$1;
  },
  get integer() {
    return integer$1;
  },
  get uinteger() {
    return uinteger$1;
  }
}, Symbol.toStringTag, { value: "Module" }));
const require$$1$1 = /* @__PURE__ */ getAugmentedNamespace(main$4);
var messages$2 = {};
var hasRequiredMessages$2;
function requireMessages$2() {
  if (hasRequiredMessages$2) return messages$2;
  hasRequiredMessages$2 = 1;
  Object.defineProperty(messages$2, "__esModule", { value: true });
  messages$2.ProtocolNotificationType = messages$2.ProtocolNotificationType0 = messages$2.ProtocolRequestType = messages$2.ProtocolRequestType0 = messages$2.RegistrationType = messages$2.MessageDirection = void 0;
  const vscode_jsonrpc_1 = requireMain$2();
  var MessageDirection;
  (function(MessageDirection2) {
    MessageDirection2["clientToServer"] = "clientToServer";
    MessageDirection2["serverToClient"] = "serverToClient";
    MessageDirection2["both"] = "both";
  })(MessageDirection || (messages$2.MessageDirection = MessageDirection = {}));
  class RegistrationType {
    constructor(method) {
      this.method = method;
    }
  }
  messages$2.RegistrationType = RegistrationType;
  class ProtocolRequestType0 extends vscode_jsonrpc_1.RequestType0 {
    constructor(method) {
      super(method);
    }
  }
  messages$2.ProtocolRequestType0 = ProtocolRequestType0;
  class ProtocolRequestType extends vscode_jsonrpc_1.RequestType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages$2.ProtocolRequestType = ProtocolRequestType;
  class ProtocolNotificationType0 extends vscode_jsonrpc_1.NotificationType0 {
    constructor(method) {
      super(method);
    }
  }
  messages$2.ProtocolNotificationType0 = ProtocolNotificationType0;
  class ProtocolNotificationType extends vscode_jsonrpc_1.NotificationType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages$2.ProtocolNotificationType = ProtocolNotificationType;
  return messages$2;
}
var protocol$1 = {};
var is$1$1 = {};
var hasRequiredIs$1$1;
function requireIs$1$1() {
  if (hasRequiredIs$1$1) return is$1$1;
  hasRequiredIs$1$1 = 1;
  Object.defineProperty(is$1$1, "__esModule", { value: true });
  is$1$1.objectLiteral = is$1$1.typedArray = is$1$1.stringArray = is$1$1.array = is$1$1.func = is$1$1.error = is$1$1.number = is$1$1.string = is$1$1.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is$1$1.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is$1$1.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is$1$1.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is$1$1.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is$1$1.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is$1$1.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is$1$1.stringArray = stringArray;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  is$1$1.typedArray = typedArray;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  is$1$1.objectLiteral = objectLiteral;
  return is$1$1;
}
var protocol_implementation$1 = {};
var hasRequiredProtocol_implementation$1;
function requireProtocol_implementation$1() {
  if (hasRequiredProtocol_implementation$1) return protocol_implementation$1;
  hasRequiredProtocol_implementation$1 = 1;
  Object.defineProperty(protocol_implementation$1, "__esModule", { value: true });
  protocol_implementation$1.ImplementationRequest = void 0;
  const messages_1 = requireMessages$2();
  var ImplementationRequest;
  (function(ImplementationRequest2) {
    ImplementationRequest2.method = "textDocument/implementation";
    ImplementationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ImplementationRequest2.type = new messages_1.ProtocolRequestType(ImplementationRequest2.method);
  })(ImplementationRequest || (protocol_implementation$1.ImplementationRequest = ImplementationRequest = {}));
  return protocol_implementation$1;
}
var protocol_typeDefinition$1 = {};
var hasRequiredProtocol_typeDefinition$1;
function requireProtocol_typeDefinition$1() {
  if (hasRequiredProtocol_typeDefinition$1) return protocol_typeDefinition$1;
  hasRequiredProtocol_typeDefinition$1 = 1;
  Object.defineProperty(protocol_typeDefinition$1, "__esModule", { value: true });
  protocol_typeDefinition$1.TypeDefinitionRequest = void 0;
  const messages_1 = requireMessages$2();
  var TypeDefinitionRequest;
  (function(TypeDefinitionRequest2) {
    TypeDefinitionRequest2.method = "textDocument/typeDefinition";
    TypeDefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeDefinitionRequest2.type = new messages_1.ProtocolRequestType(TypeDefinitionRequest2.method);
  })(TypeDefinitionRequest || (protocol_typeDefinition$1.TypeDefinitionRequest = TypeDefinitionRequest = {}));
  return protocol_typeDefinition$1;
}
var protocol_workspaceFolder$1 = {};
var hasRequiredProtocol_workspaceFolder$1;
function requireProtocol_workspaceFolder$1() {
  if (hasRequiredProtocol_workspaceFolder$1) return protocol_workspaceFolder$1;
  hasRequiredProtocol_workspaceFolder$1 = 1;
  Object.defineProperty(protocol_workspaceFolder$1, "__esModule", { value: true });
  protocol_workspaceFolder$1.DidChangeWorkspaceFoldersNotification = protocol_workspaceFolder$1.WorkspaceFoldersRequest = void 0;
  const messages_1 = requireMessages$2();
  var WorkspaceFoldersRequest;
  (function(WorkspaceFoldersRequest2) {
    WorkspaceFoldersRequest2.method = "workspace/workspaceFolders";
    WorkspaceFoldersRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkspaceFoldersRequest2.type = new messages_1.ProtocolRequestType0(WorkspaceFoldersRequest2.method);
  })(WorkspaceFoldersRequest || (protocol_workspaceFolder$1.WorkspaceFoldersRequest = WorkspaceFoldersRequest = {}));
  var DidChangeWorkspaceFoldersNotification;
  (function(DidChangeWorkspaceFoldersNotification2) {
    DidChangeWorkspaceFoldersNotification2.method = "workspace/didChangeWorkspaceFolders";
    DidChangeWorkspaceFoldersNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeWorkspaceFoldersNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWorkspaceFoldersNotification2.method);
  })(DidChangeWorkspaceFoldersNotification || (protocol_workspaceFolder$1.DidChangeWorkspaceFoldersNotification = DidChangeWorkspaceFoldersNotification = {}));
  return protocol_workspaceFolder$1;
}
var protocol_configuration$1 = {};
var hasRequiredProtocol_configuration$1;
function requireProtocol_configuration$1() {
  if (hasRequiredProtocol_configuration$1) return protocol_configuration$1;
  hasRequiredProtocol_configuration$1 = 1;
  Object.defineProperty(protocol_configuration$1, "__esModule", { value: true });
  protocol_configuration$1.ConfigurationRequest = void 0;
  const messages_1 = requireMessages$2();
  var ConfigurationRequest;
  (function(ConfigurationRequest2) {
    ConfigurationRequest2.method = "workspace/configuration";
    ConfigurationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ConfigurationRequest2.type = new messages_1.ProtocolRequestType(ConfigurationRequest2.method);
  })(ConfigurationRequest || (protocol_configuration$1.ConfigurationRequest = ConfigurationRequest = {}));
  return protocol_configuration$1;
}
var protocol_colorProvider$1 = {};
var hasRequiredProtocol_colorProvider$1;
function requireProtocol_colorProvider$1() {
  if (hasRequiredProtocol_colorProvider$1) return protocol_colorProvider$1;
  hasRequiredProtocol_colorProvider$1 = 1;
  Object.defineProperty(protocol_colorProvider$1, "__esModule", { value: true });
  protocol_colorProvider$1.ColorPresentationRequest = protocol_colorProvider$1.DocumentColorRequest = void 0;
  const messages_1 = requireMessages$2();
  var DocumentColorRequest;
  (function(DocumentColorRequest2) {
    DocumentColorRequest2.method = "textDocument/documentColor";
    DocumentColorRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentColorRequest2.type = new messages_1.ProtocolRequestType(DocumentColorRequest2.method);
  })(DocumentColorRequest || (protocol_colorProvider$1.DocumentColorRequest = DocumentColorRequest = {}));
  var ColorPresentationRequest;
  (function(ColorPresentationRequest2) {
    ColorPresentationRequest2.method = "textDocument/colorPresentation";
    ColorPresentationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ColorPresentationRequest2.type = new messages_1.ProtocolRequestType(ColorPresentationRequest2.method);
  })(ColorPresentationRequest || (protocol_colorProvider$1.ColorPresentationRequest = ColorPresentationRequest = {}));
  return protocol_colorProvider$1;
}
var protocol_foldingRange$1 = {};
var hasRequiredProtocol_foldingRange$1;
function requireProtocol_foldingRange$1() {
  if (hasRequiredProtocol_foldingRange$1) return protocol_foldingRange$1;
  hasRequiredProtocol_foldingRange$1 = 1;
  Object.defineProperty(protocol_foldingRange$1, "__esModule", { value: true });
  protocol_foldingRange$1.FoldingRangeRefreshRequest = protocol_foldingRange$1.FoldingRangeRequest = void 0;
  const messages_1 = requireMessages$2();
  var FoldingRangeRequest;
  (function(FoldingRangeRequest2) {
    FoldingRangeRequest2.method = "textDocument/foldingRange";
    FoldingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    FoldingRangeRequest2.type = new messages_1.ProtocolRequestType(FoldingRangeRequest2.method);
  })(FoldingRangeRequest || (protocol_foldingRange$1.FoldingRangeRequest = FoldingRangeRequest = {}));
  var FoldingRangeRefreshRequest;
  (function(FoldingRangeRefreshRequest2) {
    FoldingRangeRefreshRequest2.method = `workspace/foldingRange/refresh`;
    FoldingRangeRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    FoldingRangeRefreshRequest2.type = new messages_1.ProtocolRequestType0(FoldingRangeRefreshRequest2.method);
  })(FoldingRangeRefreshRequest || (protocol_foldingRange$1.FoldingRangeRefreshRequest = FoldingRangeRefreshRequest = {}));
  return protocol_foldingRange$1;
}
var protocol_declaration$1 = {};
var hasRequiredProtocol_declaration$1;
function requireProtocol_declaration$1() {
  if (hasRequiredProtocol_declaration$1) return protocol_declaration$1;
  hasRequiredProtocol_declaration$1 = 1;
  Object.defineProperty(protocol_declaration$1, "__esModule", { value: true });
  protocol_declaration$1.DeclarationRequest = void 0;
  const messages_1 = requireMessages$2();
  var DeclarationRequest;
  (function(DeclarationRequest2) {
    DeclarationRequest2.method = "textDocument/declaration";
    DeclarationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DeclarationRequest2.type = new messages_1.ProtocolRequestType(DeclarationRequest2.method);
  })(DeclarationRequest || (protocol_declaration$1.DeclarationRequest = DeclarationRequest = {}));
  return protocol_declaration$1;
}
var protocol_selectionRange$1 = {};
var hasRequiredProtocol_selectionRange$1;
function requireProtocol_selectionRange$1() {
  if (hasRequiredProtocol_selectionRange$1) return protocol_selectionRange$1;
  hasRequiredProtocol_selectionRange$1 = 1;
  Object.defineProperty(protocol_selectionRange$1, "__esModule", { value: true });
  protocol_selectionRange$1.SelectionRangeRequest = void 0;
  const messages_1 = requireMessages$2();
  var SelectionRangeRequest;
  (function(SelectionRangeRequest2) {
    SelectionRangeRequest2.method = "textDocument/selectionRange";
    SelectionRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SelectionRangeRequest2.type = new messages_1.ProtocolRequestType(SelectionRangeRequest2.method);
  })(SelectionRangeRequest || (protocol_selectionRange$1.SelectionRangeRequest = SelectionRangeRequest = {}));
  return protocol_selectionRange$1;
}
var protocol_progress$1 = {};
var hasRequiredProtocol_progress$1;
function requireProtocol_progress$1() {
  if (hasRequiredProtocol_progress$1) return protocol_progress$1;
  hasRequiredProtocol_progress$1 = 1;
  Object.defineProperty(protocol_progress$1, "__esModule", { value: true });
  protocol_progress$1.WorkDoneProgressCancelNotification = protocol_progress$1.WorkDoneProgressCreateRequest = protocol_progress$1.WorkDoneProgress = void 0;
  const vscode_jsonrpc_1 = requireMain$2();
  const messages_1 = requireMessages$2();
  var WorkDoneProgress;
  (function(WorkDoneProgress2) {
    WorkDoneProgress2.type = new vscode_jsonrpc_1.ProgressType();
    function is2(value) {
      return value === WorkDoneProgress2.type;
    }
    WorkDoneProgress2.is = is2;
  })(WorkDoneProgress || (protocol_progress$1.WorkDoneProgress = WorkDoneProgress = {}));
  var WorkDoneProgressCreateRequest;
  (function(WorkDoneProgressCreateRequest2) {
    WorkDoneProgressCreateRequest2.method = "window/workDoneProgress/create";
    WorkDoneProgressCreateRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkDoneProgressCreateRequest2.type = new messages_1.ProtocolRequestType(WorkDoneProgressCreateRequest2.method);
  })(WorkDoneProgressCreateRequest || (protocol_progress$1.WorkDoneProgressCreateRequest = WorkDoneProgressCreateRequest = {}));
  var WorkDoneProgressCancelNotification;
  (function(WorkDoneProgressCancelNotification2) {
    WorkDoneProgressCancelNotification2.method = "window/workDoneProgress/cancel";
    WorkDoneProgressCancelNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkDoneProgressCancelNotification2.type = new messages_1.ProtocolNotificationType(WorkDoneProgressCancelNotification2.method);
  })(WorkDoneProgressCancelNotification || (protocol_progress$1.WorkDoneProgressCancelNotification = WorkDoneProgressCancelNotification = {}));
  return protocol_progress$1;
}
var protocol_callHierarchy$1 = {};
var hasRequiredProtocol_callHierarchy$1;
function requireProtocol_callHierarchy$1() {
  if (hasRequiredProtocol_callHierarchy$1) return protocol_callHierarchy$1;
  hasRequiredProtocol_callHierarchy$1 = 1;
  Object.defineProperty(protocol_callHierarchy$1, "__esModule", { value: true });
  protocol_callHierarchy$1.CallHierarchyOutgoingCallsRequest = protocol_callHierarchy$1.CallHierarchyIncomingCallsRequest = protocol_callHierarchy$1.CallHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages$2();
  var CallHierarchyPrepareRequest;
  (function(CallHierarchyPrepareRequest2) {
    CallHierarchyPrepareRequest2.method = "textDocument/prepareCallHierarchy";
    CallHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyPrepareRequest2.method);
  })(CallHierarchyPrepareRequest || (protocol_callHierarchy$1.CallHierarchyPrepareRequest = CallHierarchyPrepareRequest = {}));
  var CallHierarchyIncomingCallsRequest;
  (function(CallHierarchyIncomingCallsRequest2) {
    CallHierarchyIncomingCallsRequest2.method = "callHierarchy/incomingCalls";
    CallHierarchyIncomingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyIncomingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyIncomingCallsRequest2.method);
  })(CallHierarchyIncomingCallsRequest || (protocol_callHierarchy$1.CallHierarchyIncomingCallsRequest = CallHierarchyIncomingCallsRequest = {}));
  var CallHierarchyOutgoingCallsRequest;
  (function(CallHierarchyOutgoingCallsRequest2) {
    CallHierarchyOutgoingCallsRequest2.method = "callHierarchy/outgoingCalls";
    CallHierarchyOutgoingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyOutgoingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyOutgoingCallsRequest2.method);
  })(CallHierarchyOutgoingCallsRequest || (protocol_callHierarchy$1.CallHierarchyOutgoingCallsRequest = CallHierarchyOutgoingCallsRequest = {}));
  return protocol_callHierarchy$1;
}
var protocol_semanticTokens$1 = {};
var hasRequiredProtocol_semanticTokens$1;
function requireProtocol_semanticTokens$1() {
  if (hasRequiredProtocol_semanticTokens$1) return protocol_semanticTokens$1;
  hasRequiredProtocol_semanticTokens$1 = 1;
  Object.defineProperty(protocol_semanticTokens$1, "__esModule", { value: true });
  protocol_semanticTokens$1.SemanticTokensRefreshRequest = protocol_semanticTokens$1.SemanticTokensRangeRequest = protocol_semanticTokens$1.SemanticTokensDeltaRequest = protocol_semanticTokens$1.SemanticTokensRequest = protocol_semanticTokens$1.SemanticTokensRegistrationType = protocol_semanticTokens$1.TokenFormat = void 0;
  const messages_1 = requireMessages$2();
  var TokenFormat;
  (function(TokenFormat2) {
    TokenFormat2.Relative = "relative";
  })(TokenFormat || (protocol_semanticTokens$1.TokenFormat = TokenFormat = {}));
  var SemanticTokensRegistrationType;
  (function(SemanticTokensRegistrationType2) {
    SemanticTokensRegistrationType2.method = "textDocument/semanticTokens";
    SemanticTokensRegistrationType2.type = new messages_1.RegistrationType(SemanticTokensRegistrationType2.method);
  })(SemanticTokensRegistrationType || (protocol_semanticTokens$1.SemanticTokensRegistrationType = SemanticTokensRegistrationType = {}));
  var SemanticTokensRequest;
  (function(SemanticTokensRequest2) {
    SemanticTokensRequest2.method = "textDocument/semanticTokens/full";
    SemanticTokensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRequest2.method);
    SemanticTokensRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRequest || (protocol_semanticTokens$1.SemanticTokensRequest = SemanticTokensRequest = {}));
  var SemanticTokensDeltaRequest;
  (function(SemanticTokensDeltaRequest2) {
    SemanticTokensDeltaRequest2.method = "textDocument/semanticTokens/full/delta";
    SemanticTokensDeltaRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensDeltaRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensDeltaRequest2.method);
    SemanticTokensDeltaRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensDeltaRequest || (protocol_semanticTokens$1.SemanticTokensDeltaRequest = SemanticTokensDeltaRequest = {}));
  var SemanticTokensRangeRequest;
  (function(SemanticTokensRangeRequest2) {
    SemanticTokensRangeRequest2.method = "textDocument/semanticTokens/range";
    SemanticTokensRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRangeRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRangeRequest2.method);
    SemanticTokensRangeRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRangeRequest || (protocol_semanticTokens$1.SemanticTokensRangeRequest = SemanticTokensRangeRequest = {}));
  var SemanticTokensRefreshRequest;
  (function(SemanticTokensRefreshRequest2) {
    SemanticTokensRefreshRequest2.method = `workspace/semanticTokens/refresh`;
    SemanticTokensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    SemanticTokensRefreshRequest2.type = new messages_1.ProtocolRequestType0(SemanticTokensRefreshRequest2.method);
  })(SemanticTokensRefreshRequest || (protocol_semanticTokens$1.SemanticTokensRefreshRequest = SemanticTokensRefreshRequest = {}));
  return protocol_semanticTokens$1;
}
var protocol_showDocument$1 = {};
var hasRequiredProtocol_showDocument$1;
function requireProtocol_showDocument$1() {
  if (hasRequiredProtocol_showDocument$1) return protocol_showDocument$1;
  hasRequiredProtocol_showDocument$1 = 1;
  Object.defineProperty(protocol_showDocument$1, "__esModule", { value: true });
  protocol_showDocument$1.ShowDocumentRequest = void 0;
  const messages_1 = requireMessages$2();
  var ShowDocumentRequest;
  (function(ShowDocumentRequest2) {
    ShowDocumentRequest2.method = "window/showDocument";
    ShowDocumentRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ShowDocumentRequest2.type = new messages_1.ProtocolRequestType(ShowDocumentRequest2.method);
  })(ShowDocumentRequest || (protocol_showDocument$1.ShowDocumentRequest = ShowDocumentRequest = {}));
  return protocol_showDocument$1;
}
var protocol_linkedEditingRange$1 = {};
var hasRequiredProtocol_linkedEditingRange$1;
function requireProtocol_linkedEditingRange$1() {
  if (hasRequiredProtocol_linkedEditingRange$1) return protocol_linkedEditingRange$1;
  hasRequiredProtocol_linkedEditingRange$1 = 1;
  Object.defineProperty(protocol_linkedEditingRange$1, "__esModule", { value: true });
  protocol_linkedEditingRange$1.LinkedEditingRangeRequest = void 0;
  const messages_1 = requireMessages$2();
  var LinkedEditingRangeRequest;
  (function(LinkedEditingRangeRequest2) {
    LinkedEditingRangeRequest2.method = "textDocument/linkedEditingRange";
    LinkedEditingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    LinkedEditingRangeRequest2.type = new messages_1.ProtocolRequestType(LinkedEditingRangeRequest2.method);
  })(LinkedEditingRangeRequest || (protocol_linkedEditingRange$1.LinkedEditingRangeRequest = LinkedEditingRangeRequest = {}));
  return protocol_linkedEditingRange$1;
}
var protocol_fileOperations$1 = {};
var hasRequiredProtocol_fileOperations$1;
function requireProtocol_fileOperations$1() {
  if (hasRequiredProtocol_fileOperations$1) return protocol_fileOperations$1;
  hasRequiredProtocol_fileOperations$1 = 1;
  Object.defineProperty(protocol_fileOperations$1, "__esModule", { value: true });
  protocol_fileOperations$1.WillDeleteFilesRequest = protocol_fileOperations$1.DidDeleteFilesNotification = protocol_fileOperations$1.DidRenameFilesNotification = protocol_fileOperations$1.WillRenameFilesRequest = protocol_fileOperations$1.DidCreateFilesNotification = protocol_fileOperations$1.WillCreateFilesRequest = protocol_fileOperations$1.FileOperationPatternKind = void 0;
  const messages_1 = requireMessages$2();
  var FileOperationPatternKind;
  (function(FileOperationPatternKind2) {
    FileOperationPatternKind2.file = "file";
    FileOperationPatternKind2.folder = "folder";
  })(FileOperationPatternKind || (protocol_fileOperations$1.FileOperationPatternKind = FileOperationPatternKind = {}));
  var WillCreateFilesRequest;
  (function(WillCreateFilesRequest2) {
    WillCreateFilesRequest2.method = "workspace/willCreateFiles";
    WillCreateFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillCreateFilesRequest2.type = new messages_1.ProtocolRequestType(WillCreateFilesRequest2.method);
  })(WillCreateFilesRequest || (protocol_fileOperations$1.WillCreateFilesRequest = WillCreateFilesRequest = {}));
  var DidCreateFilesNotification;
  (function(DidCreateFilesNotification2) {
    DidCreateFilesNotification2.method = "workspace/didCreateFiles";
    DidCreateFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCreateFilesNotification2.type = new messages_1.ProtocolNotificationType(DidCreateFilesNotification2.method);
  })(DidCreateFilesNotification || (protocol_fileOperations$1.DidCreateFilesNotification = DidCreateFilesNotification = {}));
  var WillRenameFilesRequest;
  (function(WillRenameFilesRequest2) {
    WillRenameFilesRequest2.method = "workspace/willRenameFiles";
    WillRenameFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillRenameFilesRequest2.type = new messages_1.ProtocolRequestType(WillRenameFilesRequest2.method);
  })(WillRenameFilesRequest || (protocol_fileOperations$1.WillRenameFilesRequest = WillRenameFilesRequest = {}));
  var DidRenameFilesNotification;
  (function(DidRenameFilesNotification2) {
    DidRenameFilesNotification2.method = "workspace/didRenameFiles";
    DidRenameFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidRenameFilesNotification2.type = new messages_1.ProtocolNotificationType(DidRenameFilesNotification2.method);
  })(DidRenameFilesNotification || (protocol_fileOperations$1.DidRenameFilesNotification = DidRenameFilesNotification = {}));
  var DidDeleteFilesNotification;
  (function(DidDeleteFilesNotification2) {
    DidDeleteFilesNotification2.method = "workspace/didDeleteFiles";
    DidDeleteFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidDeleteFilesNotification2.type = new messages_1.ProtocolNotificationType(DidDeleteFilesNotification2.method);
  })(DidDeleteFilesNotification || (protocol_fileOperations$1.DidDeleteFilesNotification = DidDeleteFilesNotification = {}));
  var WillDeleteFilesRequest;
  (function(WillDeleteFilesRequest2) {
    WillDeleteFilesRequest2.method = "workspace/willDeleteFiles";
    WillDeleteFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillDeleteFilesRequest2.type = new messages_1.ProtocolRequestType(WillDeleteFilesRequest2.method);
  })(WillDeleteFilesRequest || (protocol_fileOperations$1.WillDeleteFilesRequest = WillDeleteFilesRequest = {}));
  return protocol_fileOperations$1;
}
var protocol_moniker$1 = {};
var hasRequiredProtocol_moniker$1;
function requireProtocol_moniker$1() {
  if (hasRequiredProtocol_moniker$1) return protocol_moniker$1;
  hasRequiredProtocol_moniker$1 = 1;
  Object.defineProperty(protocol_moniker$1, "__esModule", { value: true });
  protocol_moniker$1.MonikerRequest = protocol_moniker$1.MonikerKind = protocol_moniker$1.UniquenessLevel = void 0;
  const messages_1 = requireMessages$2();
  var UniquenessLevel;
  (function(UniquenessLevel2) {
    UniquenessLevel2.document = "document";
    UniquenessLevel2.project = "project";
    UniquenessLevel2.group = "group";
    UniquenessLevel2.scheme = "scheme";
    UniquenessLevel2.global = "global";
  })(UniquenessLevel || (protocol_moniker$1.UniquenessLevel = UniquenessLevel = {}));
  var MonikerKind;
  (function(MonikerKind2) {
    MonikerKind2.$import = "import";
    MonikerKind2.$export = "export";
    MonikerKind2.local = "local";
  })(MonikerKind || (protocol_moniker$1.MonikerKind = MonikerKind = {}));
  var MonikerRequest;
  (function(MonikerRequest2) {
    MonikerRequest2.method = "textDocument/moniker";
    MonikerRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    MonikerRequest2.type = new messages_1.ProtocolRequestType(MonikerRequest2.method);
  })(MonikerRequest || (protocol_moniker$1.MonikerRequest = MonikerRequest = {}));
  return protocol_moniker$1;
}
var protocol_typeHierarchy$1 = {};
var hasRequiredProtocol_typeHierarchy$1;
function requireProtocol_typeHierarchy$1() {
  if (hasRequiredProtocol_typeHierarchy$1) return protocol_typeHierarchy$1;
  hasRequiredProtocol_typeHierarchy$1 = 1;
  Object.defineProperty(protocol_typeHierarchy$1, "__esModule", { value: true });
  protocol_typeHierarchy$1.TypeHierarchySubtypesRequest = protocol_typeHierarchy$1.TypeHierarchySupertypesRequest = protocol_typeHierarchy$1.TypeHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages$2();
  var TypeHierarchyPrepareRequest;
  (function(TypeHierarchyPrepareRequest2) {
    TypeHierarchyPrepareRequest2.method = "textDocument/prepareTypeHierarchy";
    TypeHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchyPrepareRequest2.method);
  })(TypeHierarchyPrepareRequest || (protocol_typeHierarchy$1.TypeHierarchyPrepareRequest = TypeHierarchyPrepareRequest = {}));
  var TypeHierarchySupertypesRequest;
  (function(TypeHierarchySupertypesRequest2) {
    TypeHierarchySupertypesRequest2.method = "typeHierarchy/supertypes";
    TypeHierarchySupertypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySupertypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySupertypesRequest2.method);
  })(TypeHierarchySupertypesRequest || (protocol_typeHierarchy$1.TypeHierarchySupertypesRequest = TypeHierarchySupertypesRequest = {}));
  var TypeHierarchySubtypesRequest;
  (function(TypeHierarchySubtypesRequest2) {
    TypeHierarchySubtypesRequest2.method = "typeHierarchy/subtypes";
    TypeHierarchySubtypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySubtypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySubtypesRequest2.method);
  })(TypeHierarchySubtypesRequest || (protocol_typeHierarchy$1.TypeHierarchySubtypesRequest = TypeHierarchySubtypesRequest = {}));
  return protocol_typeHierarchy$1;
}
var protocol_inlineValue$1 = {};
var hasRequiredProtocol_inlineValue$1;
function requireProtocol_inlineValue$1() {
  if (hasRequiredProtocol_inlineValue$1) return protocol_inlineValue$1;
  hasRequiredProtocol_inlineValue$1 = 1;
  Object.defineProperty(protocol_inlineValue$1, "__esModule", { value: true });
  protocol_inlineValue$1.InlineValueRefreshRequest = protocol_inlineValue$1.InlineValueRequest = void 0;
  const messages_1 = requireMessages$2();
  var InlineValueRequest;
  (function(InlineValueRequest2) {
    InlineValueRequest2.method = "textDocument/inlineValue";
    InlineValueRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineValueRequest2.type = new messages_1.ProtocolRequestType(InlineValueRequest2.method);
  })(InlineValueRequest || (protocol_inlineValue$1.InlineValueRequest = InlineValueRequest = {}));
  var InlineValueRefreshRequest;
  (function(InlineValueRefreshRequest2) {
    InlineValueRefreshRequest2.method = `workspace/inlineValue/refresh`;
    InlineValueRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlineValueRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlineValueRefreshRequest2.method);
  })(InlineValueRefreshRequest || (protocol_inlineValue$1.InlineValueRefreshRequest = InlineValueRefreshRequest = {}));
  return protocol_inlineValue$1;
}
var protocol_inlayHint$1 = {};
var hasRequiredProtocol_inlayHint$1;
function requireProtocol_inlayHint$1() {
  if (hasRequiredProtocol_inlayHint$1) return protocol_inlayHint$1;
  hasRequiredProtocol_inlayHint$1 = 1;
  Object.defineProperty(protocol_inlayHint$1, "__esModule", { value: true });
  protocol_inlayHint$1.InlayHintRefreshRequest = protocol_inlayHint$1.InlayHintResolveRequest = protocol_inlayHint$1.InlayHintRequest = void 0;
  const messages_1 = requireMessages$2();
  var InlayHintRequest;
  (function(InlayHintRequest2) {
    InlayHintRequest2.method = "textDocument/inlayHint";
    InlayHintRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintRequest2.type = new messages_1.ProtocolRequestType(InlayHintRequest2.method);
  })(InlayHintRequest || (protocol_inlayHint$1.InlayHintRequest = InlayHintRequest = {}));
  var InlayHintResolveRequest;
  (function(InlayHintResolveRequest2) {
    InlayHintResolveRequest2.method = "inlayHint/resolve";
    InlayHintResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintResolveRequest2.type = new messages_1.ProtocolRequestType(InlayHintResolveRequest2.method);
  })(InlayHintResolveRequest || (protocol_inlayHint$1.InlayHintResolveRequest = InlayHintResolveRequest = {}));
  var InlayHintRefreshRequest;
  (function(InlayHintRefreshRequest2) {
    InlayHintRefreshRequest2.method = `workspace/inlayHint/refresh`;
    InlayHintRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlayHintRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlayHintRefreshRequest2.method);
  })(InlayHintRefreshRequest || (protocol_inlayHint$1.InlayHintRefreshRequest = InlayHintRefreshRequest = {}));
  return protocol_inlayHint$1;
}
var protocol_diagnostic$1 = {};
var hasRequiredProtocol_diagnostic$1;
function requireProtocol_diagnostic$1() {
  if (hasRequiredProtocol_diagnostic$1) return protocol_diagnostic$1;
  hasRequiredProtocol_diagnostic$1 = 1;
  Object.defineProperty(protocol_diagnostic$1, "__esModule", { value: true });
  protocol_diagnostic$1.DiagnosticRefreshRequest = protocol_diagnostic$1.WorkspaceDiagnosticRequest = protocol_diagnostic$1.DocumentDiagnosticRequest = protocol_diagnostic$1.DocumentDiagnosticReportKind = protocol_diagnostic$1.DiagnosticServerCancellationData = void 0;
  const vscode_jsonrpc_1 = requireMain$2();
  const Is2 = requireIs$1$1();
  const messages_1 = requireMessages$2();
  var DiagnosticServerCancellationData;
  (function(DiagnosticServerCancellationData2) {
    function is2(value) {
      const candidate = value;
      return candidate && Is2.boolean(candidate.retriggerRequest);
    }
    DiagnosticServerCancellationData2.is = is2;
  })(DiagnosticServerCancellationData || (protocol_diagnostic$1.DiagnosticServerCancellationData = DiagnosticServerCancellationData = {}));
  var DocumentDiagnosticReportKind;
  (function(DocumentDiagnosticReportKind2) {
    DocumentDiagnosticReportKind2.Full = "full";
    DocumentDiagnosticReportKind2.Unchanged = "unchanged";
  })(DocumentDiagnosticReportKind || (protocol_diagnostic$1.DocumentDiagnosticReportKind = DocumentDiagnosticReportKind = {}));
  var DocumentDiagnosticRequest;
  (function(DocumentDiagnosticRequest2) {
    DocumentDiagnosticRequest2.method = "textDocument/diagnostic";
    DocumentDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentDiagnosticRequest2.type = new messages_1.ProtocolRequestType(DocumentDiagnosticRequest2.method);
    DocumentDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(DocumentDiagnosticRequest || (protocol_diagnostic$1.DocumentDiagnosticRequest = DocumentDiagnosticRequest = {}));
  var WorkspaceDiagnosticRequest;
  (function(WorkspaceDiagnosticRequest2) {
    WorkspaceDiagnosticRequest2.method = "workspace/diagnostic";
    WorkspaceDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkspaceDiagnosticRequest2.type = new messages_1.ProtocolRequestType(WorkspaceDiagnosticRequest2.method);
    WorkspaceDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(WorkspaceDiagnosticRequest || (protocol_diagnostic$1.WorkspaceDiagnosticRequest = WorkspaceDiagnosticRequest = {}));
  var DiagnosticRefreshRequest;
  (function(DiagnosticRefreshRequest2) {
    DiagnosticRefreshRequest2.method = `workspace/diagnostic/refresh`;
    DiagnosticRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    DiagnosticRefreshRequest2.type = new messages_1.ProtocolRequestType0(DiagnosticRefreshRequest2.method);
  })(DiagnosticRefreshRequest || (protocol_diagnostic$1.DiagnosticRefreshRequest = DiagnosticRefreshRequest = {}));
  return protocol_diagnostic$1;
}
var protocol_notebook$1 = {};
var hasRequiredProtocol_notebook$1;
function requireProtocol_notebook$1() {
  if (hasRequiredProtocol_notebook$1) return protocol_notebook$1;
  hasRequiredProtocol_notebook$1 = 1;
  Object.defineProperty(protocol_notebook$1, "__esModule", { value: true });
  protocol_notebook$1.DidCloseNotebookDocumentNotification = protocol_notebook$1.DidSaveNotebookDocumentNotification = protocol_notebook$1.DidChangeNotebookDocumentNotification = protocol_notebook$1.NotebookCellArrayChange = protocol_notebook$1.DidOpenNotebookDocumentNotification = protocol_notebook$1.NotebookDocumentSyncRegistrationType = protocol_notebook$1.NotebookDocument = protocol_notebook$1.NotebookCell = protocol_notebook$1.ExecutionSummary = protocol_notebook$1.NotebookCellKind = void 0;
  const vscode_languageserver_types_1 = require$$1$1;
  const Is2 = requireIs$1$1();
  const messages_1 = requireMessages$2();
  var NotebookCellKind;
  (function(NotebookCellKind2) {
    NotebookCellKind2.Markup = 1;
    NotebookCellKind2.Code = 2;
    function is2(value) {
      return value === 1 || value === 2;
    }
    NotebookCellKind2.is = is2;
  })(NotebookCellKind || (protocol_notebook$1.NotebookCellKind = NotebookCellKind = {}));
  var ExecutionSummary;
  (function(ExecutionSummary2) {
    function create2(executionOrder, success) {
      const result2 = { executionOrder };
      if (success === true || success === false) {
        result2.success = success;
      }
      return result2;
    }
    ExecutionSummary2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.executionOrder) && (candidate.success === void 0 || Is2.boolean(candidate.success));
    }
    ExecutionSummary2.is = is2;
    function equals2(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      return one.executionOrder === other.executionOrder && one.success === other.success;
    }
    ExecutionSummary2.equals = equals2;
  })(ExecutionSummary || (protocol_notebook$1.ExecutionSummary = ExecutionSummary = {}));
  var NotebookCell;
  (function(NotebookCell2) {
    function create2(kind, document2) {
      return { kind, document: document2 };
    }
    NotebookCell2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && NotebookCellKind.is(candidate.kind) && vscode_languageserver_types_1.DocumentUri.is(candidate.document) && (candidate.metadata === void 0 || Is2.objectLiteral(candidate.metadata));
    }
    NotebookCell2.is = is2;
    function diff(one, two) {
      const result2 = /* @__PURE__ */ new Set();
      if (one.document !== two.document) {
        result2.add("document");
      }
      if (one.kind !== two.kind) {
        result2.add("kind");
      }
      if (one.executionSummary !== two.executionSummary) {
        result2.add("executionSummary");
      }
      if ((one.metadata !== void 0 || two.metadata !== void 0) && !equalsMetadata(one.metadata, two.metadata)) {
        result2.add("metadata");
      }
      if ((one.executionSummary !== void 0 || two.executionSummary !== void 0) && !ExecutionSummary.equals(one.executionSummary, two.executionSummary)) {
        result2.add("executionSummary");
      }
      return result2;
    }
    NotebookCell2.diff = diff;
    function equalsMetadata(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      if (typeof one !== typeof other) {
        return false;
      }
      if (typeof one !== "object") {
        return false;
      }
      const oneArray = Array.isArray(one);
      const otherArray = Array.isArray(other);
      if (oneArray !== otherArray) {
        return false;
      }
      if (oneArray && otherArray) {
        if (one.length !== other.length) {
          return false;
        }
        for (let i2 = 0; i2 < one.length; i2++) {
          if (!equalsMetadata(one[i2], other[i2])) {
            return false;
          }
        }
      }
      if (Is2.objectLiteral(one) && Is2.objectLiteral(other)) {
        const oneKeys = Object.keys(one);
        const otherKeys = Object.keys(other);
        if (oneKeys.length !== otherKeys.length) {
          return false;
        }
        oneKeys.sort();
        otherKeys.sort();
        if (!equalsMetadata(oneKeys, otherKeys)) {
          return false;
        }
        for (let i2 = 0; i2 < oneKeys.length; i2++) {
          const prop = oneKeys[i2];
          if (!equalsMetadata(one[prop], other[prop])) {
            return false;
          }
        }
      }
      return true;
    }
  })(NotebookCell || (protocol_notebook$1.NotebookCell = NotebookCell = {}));
  var NotebookDocument;
  (function(NotebookDocument2) {
    function create2(uri, notebookType, version2, cells) {
      return { uri, notebookType, version: version2, cells };
    }
    NotebookDocument2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && Is2.string(candidate.uri) && vscode_languageserver_types_1.integer.is(candidate.version) && Is2.typedArray(candidate.cells, NotebookCell.is);
    }
    NotebookDocument2.is = is2;
  })(NotebookDocument || (protocol_notebook$1.NotebookDocument = NotebookDocument = {}));
  var NotebookDocumentSyncRegistrationType;
  (function(NotebookDocumentSyncRegistrationType2) {
    NotebookDocumentSyncRegistrationType2.method = "notebookDocument/sync";
    NotebookDocumentSyncRegistrationType2.messageDirection = messages_1.MessageDirection.clientToServer;
    NotebookDocumentSyncRegistrationType2.type = new messages_1.RegistrationType(NotebookDocumentSyncRegistrationType2.method);
  })(NotebookDocumentSyncRegistrationType || (protocol_notebook$1.NotebookDocumentSyncRegistrationType = NotebookDocumentSyncRegistrationType = {}));
  var DidOpenNotebookDocumentNotification;
  (function(DidOpenNotebookDocumentNotification2) {
    DidOpenNotebookDocumentNotification2.method = "notebookDocument/didOpen";
    DidOpenNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidOpenNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenNotebookDocumentNotification2.method);
    DidOpenNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidOpenNotebookDocumentNotification || (protocol_notebook$1.DidOpenNotebookDocumentNotification = DidOpenNotebookDocumentNotification = {}));
  var NotebookCellArrayChange;
  (function(NotebookCellArrayChange2) {
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.start) && vscode_languageserver_types_1.uinteger.is(candidate.deleteCount) && (candidate.cells === void 0 || Is2.typedArray(candidate.cells, NotebookCell.is));
    }
    NotebookCellArrayChange2.is = is2;
    function create2(start, deleteCount, cells) {
      const result2 = { start, deleteCount };
      if (cells !== void 0) {
        result2.cells = cells;
      }
      return result2;
    }
    NotebookCellArrayChange2.create = create2;
  })(NotebookCellArrayChange || (protocol_notebook$1.NotebookCellArrayChange = NotebookCellArrayChange = {}));
  var DidChangeNotebookDocumentNotification;
  (function(DidChangeNotebookDocumentNotification2) {
    DidChangeNotebookDocumentNotification2.method = "notebookDocument/didChange";
    DidChangeNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeNotebookDocumentNotification2.method);
    DidChangeNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidChangeNotebookDocumentNotification || (protocol_notebook$1.DidChangeNotebookDocumentNotification = DidChangeNotebookDocumentNotification = {}));
  var DidSaveNotebookDocumentNotification;
  (function(DidSaveNotebookDocumentNotification2) {
    DidSaveNotebookDocumentNotification2.method = "notebookDocument/didSave";
    DidSaveNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidSaveNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveNotebookDocumentNotification2.method);
    DidSaveNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidSaveNotebookDocumentNotification || (protocol_notebook$1.DidSaveNotebookDocumentNotification = DidSaveNotebookDocumentNotification = {}));
  var DidCloseNotebookDocumentNotification;
  (function(DidCloseNotebookDocumentNotification2) {
    DidCloseNotebookDocumentNotification2.method = "notebookDocument/didClose";
    DidCloseNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCloseNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseNotebookDocumentNotification2.method);
    DidCloseNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidCloseNotebookDocumentNotification || (protocol_notebook$1.DidCloseNotebookDocumentNotification = DidCloseNotebookDocumentNotification = {}));
  return protocol_notebook$1;
}
var protocol_inlineCompletion$1 = {};
var hasRequiredProtocol_inlineCompletion$1;
function requireProtocol_inlineCompletion$1() {
  if (hasRequiredProtocol_inlineCompletion$1) return protocol_inlineCompletion$1;
  hasRequiredProtocol_inlineCompletion$1 = 1;
  Object.defineProperty(protocol_inlineCompletion$1, "__esModule", { value: true });
  protocol_inlineCompletion$1.InlineCompletionRequest = void 0;
  const messages_1 = requireMessages$2();
  var InlineCompletionRequest;
  (function(InlineCompletionRequest2) {
    InlineCompletionRequest2.method = "textDocument/inlineCompletion";
    InlineCompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineCompletionRequest2.type = new messages_1.ProtocolRequestType(InlineCompletionRequest2.method);
  })(InlineCompletionRequest || (protocol_inlineCompletion$1.InlineCompletionRequest = InlineCompletionRequest = {}));
  return protocol_inlineCompletion$1;
}
var hasRequiredProtocol$1;
function requireProtocol$1() {
  if (hasRequiredProtocol$1) return protocol$1;
  hasRequiredProtocol$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.WorkspaceSymbolRequest = exports2.CodeActionResolveRequest = exports2.CodeActionRequest = exports2.DocumentSymbolRequest = exports2.DocumentHighlightRequest = exports2.ReferencesRequest = exports2.DefinitionRequest = exports2.SignatureHelpRequest = exports2.SignatureHelpTriggerKind = exports2.HoverRequest = exports2.CompletionResolveRequest = exports2.CompletionRequest = exports2.CompletionTriggerKind = exports2.PublishDiagnosticsNotification = exports2.WatchKind = exports2.RelativePattern = exports2.FileChangeType = exports2.DidChangeWatchedFilesNotification = exports2.WillSaveTextDocumentWaitUntilRequest = exports2.WillSaveTextDocumentNotification = exports2.TextDocumentSaveReason = exports2.DidSaveTextDocumentNotification = exports2.DidCloseTextDocumentNotification = exports2.DidChangeTextDocumentNotification = exports2.TextDocumentContentChangeEvent = exports2.DidOpenTextDocumentNotification = exports2.TextDocumentSyncKind = exports2.TelemetryEventNotification = exports2.LogMessageNotification = exports2.ShowMessageRequest = exports2.ShowMessageNotification = exports2.MessageType = exports2.DidChangeConfigurationNotification = exports2.ExitNotification = exports2.ShutdownRequest = exports2.InitializedNotification = exports2.InitializeErrorCodes = exports2.InitializeRequest = exports2.WorkDoneProgressOptions = exports2.TextDocumentRegistrationOptions = exports2.StaticRegistrationOptions = exports2.PositionEncodingKind = exports2.FailureHandlingKind = exports2.ResourceOperationKind = exports2.UnregistrationRequest = exports2.RegistrationRequest = exports2.DocumentSelector = exports2.NotebookCellTextDocumentFilter = exports2.NotebookDocumentFilter = exports2.TextDocumentFilter = void 0;
    exports2.MonikerRequest = exports2.MonikerKind = exports2.UniquenessLevel = exports2.WillDeleteFilesRequest = exports2.DidDeleteFilesNotification = exports2.WillRenameFilesRequest = exports2.DidRenameFilesNotification = exports2.WillCreateFilesRequest = exports2.DidCreateFilesNotification = exports2.FileOperationPatternKind = exports2.LinkedEditingRangeRequest = exports2.ShowDocumentRequest = exports2.SemanticTokensRegistrationType = exports2.SemanticTokensRefreshRequest = exports2.SemanticTokensRangeRequest = exports2.SemanticTokensDeltaRequest = exports2.SemanticTokensRequest = exports2.TokenFormat = exports2.CallHierarchyPrepareRequest = exports2.CallHierarchyOutgoingCallsRequest = exports2.CallHierarchyIncomingCallsRequest = exports2.WorkDoneProgressCancelNotification = exports2.WorkDoneProgressCreateRequest = exports2.WorkDoneProgress = exports2.SelectionRangeRequest = exports2.DeclarationRequest = exports2.FoldingRangeRefreshRequest = exports2.FoldingRangeRequest = exports2.ColorPresentationRequest = exports2.DocumentColorRequest = exports2.ConfigurationRequest = exports2.DidChangeWorkspaceFoldersNotification = exports2.WorkspaceFoldersRequest = exports2.TypeDefinitionRequest = exports2.ImplementationRequest = exports2.ApplyWorkspaceEditRequest = exports2.ExecuteCommandRequest = exports2.PrepareRenameRequest = exports2.RenameRequest = exports2.PrepareSupportDefaultBehavior = exports2.DocumentOnTypeFormattingRequest = exports2.DocumentRangesFormattingRequest = exports2.DocumentRangeFormattingRequest = exports2.DocumentFormattingRequest = exports2.DocumentLinkResolveRequest = exports2.DocumentLinkRequest = exports2.CodeLensRefreshRequest = exports2.CodeLensResolveRequest = exports2.CodeLensRequest = exports2.WorkspaceSymbolResolveRequest = void 0;
    exports2.InlineCompletionRequest = exports2.DidCloseNotebookDocumentNotification = exports2.DidSaveNotebookDocumentNotification = exports2.DidChangeNotebookDocumentNotification = exports2.NotebookCellArrayChange = exports2.DidOpenNotebookDocumentNotification = exports2.NotebookDocumentSyncRegistrationType = exports2.NotebookDocument = exports2.NotebookCell = exports2.ExecutionSummary = exports2.NotebookCellKind = exports2.DiagnosticRefreshRequest = exports2.WorkspaceDiagnosticRequest = exports2.DocumentDiagnosticRequest = exports2.DocumentDiagnosticReportKind = exports2.DiagnosticServerCancellationData = exports2.InlayHintRefreshRequest = exports2.InlayHintResolveRequest = exports2.InlayHintRequest = exports2.InlineValueRefreshRequest = exports2.InlineValueRequest = exports2.TypeHierarchySupertypesRequest = exports2.TypeHierarchySubtypesRequest = exports2.TypeHierarchyPrepareRequest = void 0;
    const messages_1 = requireMessages$2();
    const vscode_languageserver_types_1 = require$$1$1;
    const Is2 = requireIs$1$1();
    const protocol_implementation_1 = requireProtocol_implementation$1();
    Object.defineProperty(exports2, "ImplementationRequest", { enumerable: true, get: function() {
      return protocol_implementation_1.ImplementationRequest;
    } });
    const protocol_typeDefinition_1 = requireProtocol_typeDefinition$1();
    Object.defineProperty(exports2, "TypeDefinitionRequest", { enumerable: true, get: function() {
      return protocol_typeDefinition_1.TypeDefinitionRequest;
    } });
    const protocol_workspaceFolder_1 = requireProtocol_workspaceFolder$1();
    Object.defineProperty(exports2, "WorkspaceFoldersRequest", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.WorkspaceFoldersRequest;
    } });
    Object.defineProperty(exports2, "DidChangeWorkspaceFoldersNotification", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.DidChangeWorkspaceFoldersNotification;
    } });
    const protocol_configuration_1 = requireProtocol_configuration$1();
    Object.defineProperty(exports2, "ConfigurationRequest", { enumerable: true, get: function() {
      return protocol_configuration_1.ConfigurationRequest;
    } });
    const protocol_colorProvider_1 = requireProtocol_colorProvider$1();
    Object.defineProperty(exports2, "DocumentColorRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.DocumentColorRequest;
    } });
    Object.defineProperty(exports2, "ColorPresentationRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.ColorPresentationRequest;
    } });
    const protocol_foldingRange_1 = requireProtocol_foldingRange$1();
    Object.defineProperty(exports2, "FoldingRangeRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRequest;
    } });
    Object.defineProperty(exports2, "FoldingRangeRefreshRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRefreshRequest;
    } });
    const protocol_declaration_1 = requireProtocol_declaration$1();
    Object.defineProperty(exports2, "DeclarationRequest", { enumerable: true, get: function() {
      return protocol_declaration_1.DeclarationRequest;
    } });
    const protocol_selectionRange_1 = requireProtocol_selectionRange$1();
    Object.defineProperty(exports2, "SelectionRangeRequest", { enumerable: true, get: function() {
      return protocol_selectionRange_1.SelectionRangeRequest;
    } });
    const protocol_progress_1 = requireProtocol_progress$1();
    Object.defineProperty(exports2, "WorkDoneProgress", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgress;
    } });
    Object.defineProperty(exports2, "WorkDoneProgressCreateRequest", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCreateRequest;
    } });
    Object.defineProperty(exports2, "WorkDoneProgressCancelNotification", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCancelNotification;
    } });
    const protocol_callHierarchy_1 = requireProtocol_callHierarchy$1();
    Object.defineProperty(exports2, "CallHierarchyIncomingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyIncomingCallsRequest;
    } });
    Object.defineProperty(exports2, "CallHierarchyOutgoingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyOutgoingCallsRequest;
    } });
    Object.defineProperty(exports2, "CallHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyPrepareRequest;
    } });
    const protocol_semanticTokens_1 = requireProtocol_semanticTokens$1();
    Object.defineProperty(exports2, "TokenFormat", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.TokenFormat;
    } });
    Object.defineProperty(exports2, "SemanticTokensRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensDeltaRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensDeltaRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRangeRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRangeRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRefreshRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRefreshRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRegistrationType", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRegistrationType;
    } });
    const protocol_showDocument_1 = requireProtocol_showDocument$1();
    Object.defineProperty(exports2, "ShowDocumentRequest", { enumerable: true, get: function() {
      return protocol_showDocument_1.ShowDocumentRequest;
    } });
    const protocol_linkedEditingRange_1 = requireProtocol_linkedEditingRange$1();
    Object.defineProperty(exports2, "LinkedEditingRangeRequest", { enumerable: true, get: function() {
      return protocol_linkedEditingRange_1.LinkedEditingRangeRequest;
    } });
    const protocol_fileOperations_1 = requireProtocol_fileOperations$1();
    Object.defineProperty(exports2, "FileOperationPatternKind", { enumerable: true, get: function() {
      return protocol_fileOperations_1.FileOperationPatternKind;
    } });
    Object.defineProperty(exports2, "DidCreateFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidCreateFilesNotification;
    } });
    Object.defineProperty(exports2, "WillCreateFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillCreateFilesRequest;
    } });
    Object.defineProperty(exports2, "DidRenameFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidRenameFilesNotification;
    } });
    Object.defineProperty(exports2, "WillRenameFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillRenameFilesRequest;
    } });
    Object.defineProperty(exports2, "DidDeleteFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidDeleteFilesNotification;
    } });
    Object.defineProperty(exports2, "WillDeleteFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillDeleteFilesRequest;
    } });
    const protocol_moniker_1 = requireProtocol_moniker$1();
    Object.defineProperty(exports2, "UniquenessLevel", { enumerable: true, get: function() {
      return protocol_moniker_1.UniquenessLevel;
    } });
    Object.defineProperty(exports2, "MonikerKind", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerKind;
    } });
    Object.defineProperty(exports2, "MonikerRequest", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerRequest;
    } });
    const protocol_typeHierarchy_1 = requireProtocol_typeHierarchy$1();
    Object.defineProperty(exports2, "TypeHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchyPrepareRequest;
    } });
    Object.defineProperty(exports2, "TypeHierarchySubtypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySubtypesRequest;
    } });
    Object.defineProperty(exports2, "TypeHierarchySupertypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySupertypesRequest;
    } });
    const protocol_inlineValue_1 = requireProtocol_inlineValue$1();
    Object.defineProperty(exports2, "InlineValueRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRequest;
    } });
    Object.defineProperty(exports2, "InlineValueRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRefreshRequest;
    } });
    const protocol_inlayHint_1 = requireProtocol_inlayHint$1();
    Object.defineProperty(exports2, "InlayHintRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRequest;
    } });
    Object.defineProperty(exports2, "InlayHintResolveRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintResolveRequest;
    } });
    Object.defineProperty(exports2, "InlayHintRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRefreshRequest;
    } });
    const protocol_diagnostic_1 = requireProtocol_diagnostic$1();
    Object.defineProperty(exports2, "DiagnosticServerCancellationData", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticServerCancellationData;
    } });
    Object.defineProperty(exports2, "DocumentDiagnosticReportKind", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticReportKind;
    } });
    Object.defineProperty(exports2, "DocumentDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticRequest;
    } });
    Object.defineProperty(exports2, "WorkspaceDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.WorkspaceDiagnosticRequest;
    } });
    Object.defineProperty(exports2, "DiagnosticRefreshRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticRefreshRequest;
    } });
    const protocol_notebook_1 = requireProtocol_notebook$1();
    Object.defineProperty(exports2, "NotebookCellKind", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellKind;
    } });
    Object.defineProperty(exports2, "ExecutionSummary", { enumerable: true, get: function() {
      return protocol_notebook_1.ExecutionSummary;
    } });
    Object.defineProperty(exports2, "NotebookCell", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCell;
    } });
    Object.defineProperty(exports2, "NotebookDocument", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocument;
    } });
    Object.defineProperty(exports2, "NotebookDocumentSyncRegistrationType", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocumentSyncRegistrationType;
    } });
    Object.defineProperty(exports2, "DidOpenNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidOpenNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "NotebookCellArrayChange", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellArrayChange;
    } });
    Object.defineProperty(exports2, "DidChangeNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidChangeNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "DidSaveNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidSaveNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "DidCloseNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidCloseNotebookDocumentNotification;
    } });
    const protocol_inlineCompletion_1 = requireProtocol_inlineCompletion$1();
    Object.defineProperty(exports2, "InlineCompletionRequest", { enumerable: true, get: function() {
      return protocol_inlineCompletion_1.InlineCompletionRequest;
    } });
    var TextDocumentFilter;
    (function(TextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.string(candidate) || (Is2.string(candidate.language) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      TextDocumentFilter2.is = is2;
    })(TextDocumentFilter || (exports2.TextDocumentFilter = TextDocumentFilter = {}));
    var NotebookDocumentFilter;
    (function(NotebookDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebookType) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      NotebookDocumentFilter2.is = is2;
    })(NotebookDocumentFilter || (exports2.NotebookDocumentFilter = NotebookDocumentFilter = {}));
    var NotebookCellTextDocumentFilter;
    (function(NotebookCellTextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebook) || NotebookDocumentFilter.is(candidate.notebook)) && (candidate.language === void 0 || Is2.string(candidate.language));
      }
      NotebookCellTextDocumentFilter2.is = is2;
    })(NotebookCellTextDocumentFilter || (exports2.NotebookCellTextDocumentFilter = NotebookCellTextDocumentFilter = {}));
    var DocumentSelector;
    (function(DocumentSelector2) {
      function is2(value) {
        if (!Array.isArray(value)) {
          return false;
        }
        for (let elem of value) {
          if (!Is2.string(elem) && !TextDocumentFilter.is(elem) && !NotebookCellTextDocumentFilter.is(elem)) {
            return false;
          }
        }
        return true;
      }
      DocumentSelector2.is = is2;
    })(DocumentSelector || (exports2.DocumentSelector = DocumentSelector = {}));
    var RegistrationRequest;
    (function(RegistrationRequest2) {
      RegistrationRequest2.method = "client/registerCapability";
      RegistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      RegistrationRequest2.type = new messages_1.ProtocolRequestType(RegistrationRequest2.method);
    })(RegistrationRequest || (exports2.RegistrationRequest = RegistrationRequest = {}));
    var UnregistrationRequest;
    (function(UnregistrationRequest2) {
      UnregistrationRequest2.method = "client/unregisterCapability";
      UnregistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      UnregistrationRequest2.type = new messages_1.ProtocolRequestType(UnregistrationRequest2.method);
    })(UnregistrationRequest || (exports2.UnregistrationRequest = UnregistrationRequest = {}));
    var ResourceOperationKind;
    (function(ResourceOperationKind2) {
      ResourceOperationKind2.Create = "create";
      ResourceOperationKind2.Rename = "rename";
      ResourceOperationKind2.Delete = "delete";
    })(ResourceOperationKind || (exports2.ResourceOperationKind = ResourceOperationKind = {}));
    var FailureHandlingKind;
    (function(FailureHandlingKind2) {
      FailureHandlingKind2.Abort = "abort";
      FailureHandlingKind2.Transactional = "transactional";
      FailureHandlingKind2.TextOnlyTransactional = "textOnlyTransactional";
      FailureHandlingKind2.Undo = "undo";
    })(FailureHandlingKind || (exports2.FailureHandlingKind = FailureHandlingKind = {}));
    var PositionEncodingKind;
    (function(PositionEncodingKind2) {
      PositionEncodingKind2.UTF8 = "utf-8";
      PositionEncodingKind2.UTF16 = "utf-16";
      PositionEncodingKind2.UTF32 = "utf-32";
    })(PositionEncodingKind || (exports2.PositionEncodingKind = PositionEncodingKind = {}));
    var StaticRegistrationOptions;
    (function(StaticRegistrationOptions2) {
      function hasId(value) {
        const candidate = value;
        return candidate && Is2.string(candidate.id) && candidate.id.length > 0;
      }
      StaticRegistrationOptions2.hasId = hasId;
    })(StaticRegistrationOptions || (exports2.StaticRegistrationOptions = StaticRegistrationOptions = {}));
    var TextDocumentRegistrationOptions;
    (function(TextDocumentRegistrationOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.documentSelector === null || DocumentSelector.is(candidate.documentSelector));
      }
      TextDocumentRegistrationOptions2.is = is2;
    })(TextDocumentRegistrationOptions || (exports2.TextDocumentRegistrationOptions = TextDocumentRegistrationOptions = {}));
    var WorkDoneProgressOptions;
    (function(WorkDoneProgressOptions2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (candidate.workDoneProgress === void 0 || Is2.boolean(candidate.workDoneProgress));
      }
      WorkDoneProgressOptions2.is = is2;
      function hasWorkDoneProgress(value) {
        const candidate = value;
        return candidate && Is2.boolean(candidate.workDoneProgress);
      }
      WorkDoneProgressOptions2.hasWorkDoneProgress = hasWorkDoneProgress;
    })(WorkDoneProgressOptions || (exports2.WorkDoneProgressOptions = WorkDoneProgressOptions = {}));
    var InitializeRequest;
    (function(InitializeRequest2) {
      InitializeRequest2.method = "initialize";
      InitializeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializeRequest2.type = new messages_1.ProtocolRequestType(InitializeRequest2.method);
    })(InitializeRequest || (exports2.InitializeRequest = InitializeRequest = {}));
    var InitializeErrorCodes;
    (function(InitializeErrorCodes2) {
      InitializeErrorCodes2.unknownProtocolVersion = 1;
    })(InitializeErrorCodes || (exports2.InitializeErrorCodes = InitializeErrorCodes = {}));
    var InitializedNotification;
    (function(InitializedNotification2) {
      InitializedNotification2.method = "initialized";
      InitializedNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializedNotification2.type = new messages_1.ProtocolNotificationType(InitializedNotification2.method);
    })(InitializedNotification || (exports2.InitializedNotification = InitializedNotification = {}));
    var ShutdownRequest;
    (function(ShutdownRequest2) {
      ShutdownRequest2.method = "shutdown";
      ShutdownRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ShutdownRequest2.type = new messages_1.ProtocolRequestType0(ShutdownRequest2.method);
    })(ShutdownRequest || (exports2.ShutdownRequest = ShutdownRequest = {}));
    var ExitNotification;
    (function(ExitNotification2) {
      ExitNotification2.method = "exit";
      ExitNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExitNotification2.type = new messages_1.ProtocolNotificationType0(ExitNotification2.method);
    })(ExitNotification || (exports2.ExitNotification = ExitNotification = {}));
    var DidChangeConfigurationNotification;
    (function(DidChangeConfigurationNotification2) {
      DidChangeConfigurationNotification2.method = "workspace/didChangeConfiguration";
      DidChangeConfigurationNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeConfigurationNotification2.type = new messages_1.ProtocolNotificationType(DidChangeConfigurationNotification2.method);
    })(DidChangeConfigurationNotification || (exports2.DidChangeConfigurationNotification = DidChangeConfigurationNotification = {}));
    var MessageType;
    (function(MessageType2) {
      MessageType2.Error = 1;
      MessageType2.Warning = 2;
      MessageType2.Info = 3;
      MessageType2.Log = 4;
      MessageType2.Debug = 5;
    })(MessageType || (exports2.MessageType = MessageType = {}));
    var ShowMessageNotification;
    (function(ShowMessageNotification2) {
      ShowMessageNotification2.method = "window/showMessage";
      ShowMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageNotification2.type = new messages_1.ProtocolNotificationType(ShowMessageNotification2.method);
    })(ShowMessageNotification || (exports2.ShowMessageNotification = ShowMessageNotification = {}));
    var ShowMessageRequest;
    (function(ShowMessageRequest2) {
      ShowMessageRequest2.method = "window/showMessageRequest";
      ShowMessageRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageRequest2.type = new messages_1.ProtocolRequestType(ShowMessageRequest2.method);
    })(ShowMessageRequest || (exports2.ShowMessageRequest = ShowMessageRequest = {}));
    var LogMessageNotification;
    (function(LogMessageNotification2) {
      LogMessageNotification2.method = "window/logMessage";
      LogMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      LogMessageNotification2.type = new messages_1.ProtocolNotificationType(LogMessageNotification2.method);
    })(LogMessageNotification || (exports2.LogMessageNotification = LogMessageNotification = {}));
    var TelemetryEventNotification;
    (function(TelemetryEventNotification2) {
      TelemetryEventNotification2.method = "telemetry/event";
      TelemetryEventNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      TelemetryEventNotification2.type = new messages_1.ProtocolNotificationType(TelemetryEventNotification2.method);
    })(TelemetryEventNotification || (exports2.TelemetryEventNotification = TelemetryEventNotification = {}));
    var TextDocumentSyncKind;
    (function(TextDocumentSyncKind2) {
      TextDocumentSyncKind2.None = 0;
      TextDocumentSyncKind2.Full = 1;
      TextDocumentSyncKind2.Incremental = 2;
    })(TextDocumentSyncKind || (exports2.TextDocumentSyncKind = TextDocumentSyncKind = {}));
    var DidOpenTextDocumentNotification;
    (function(DidOpenTextDocumentNotification2) {
      DidOpenTextDocumentNotification2.method = "textDocument/didOpen";
      DidOpenTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidOpenTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenTextDocumentNotification2.method);
    })(DidOpenTextDocumentNotification || (exports2.DidOpenTextDocumentNotification = DidOpenTextDocumentNotification = {}));
    var TextDocumentContentChangeEvent;
    (function(TextDocumentContentChangeEvent2) {
      function isIncremental(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range !== void 0 && (candidate.rangeLength === void 0 || typeof candidate.rangeLength === "number");
      }
      TextDocumentContentChangeEvent2.isIncremental = isIncremental;
      function isFull(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range === void 0 && candidate.rangeLength === void 0;
      }
      TextDocumentContentChangeEvent2.isFull = isFull;
    })(TextDocumentContentChangeEvent || (exports2.TextDocumentContentChangeEvent = TextDocumentContentChangeEvent = {}));
    var DidChangeTextDocumentNotification;
    (function(DidChangeTextDocumentNotification2) {
      DidChangeTextDocumentNotification2.method = "textDocument/didChange";
      DidChangeTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeTextDocumentNotification2.method);
    })(DidChangeTextDocumentNotification || (exports2.DidChangeTextDocumentNotification = DidChangeTextDocumentNotification = {}));
    var DidCloseTextDocumentNotification;
    (function(DidCloseTextDocumentNotification2) {
      DidCloseTextDocumentNotification2.method = "textDocument/didClose";
      DidCloseTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidCloseTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseTextDocumentNotification2.method);
    })(DidCloseTextDocumentNotification || (exports2.DidCloseTextDocumentNotification = DidCloseTextDocumentNotification = {}));
    var DidSaveTextDocumentNotification;
    (function(DidSaveTextDocumentNotification2) {
      DidSaveTextDocumentNotification2.method = "textDocument/didSave";
      DidSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveTextDocumentNotification2.method);
    })(DidSaveTextDocumentNotification || (exports2.DidSaveTextDocumentNotification = DidSaveTextDocumentNotification = {}));
    var TextDocumentSaveReason;
    (function(TextDocumentSaveReason2) {
      TextDocumentSaveReason2.Manual = 1;
      TextDocumentSaveReason2.AfterDelay = 2;
      TextDocumentSaveReason2.FocusOut = 3;
    })(TextDocumentSaveReason || (exports2.TextDocumentSaveReason = TextDocumentSaveReason = {}));
    var WillSaveTextDocumentNotification;
    (function(WillSaveTextDocumentNotification2) {
      WillSaveTextDocumentNotification2.method = "textDocument/willSave";
      WillSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(WillSaveTextDocumentNotification2.method);
    })(WillSaveTextDocumentNotification || (exports2.WillSaveTextDocumentNotification = WillSaveTextDocumentNotification = {}));
    var WillSaveTextDocumentWaitUntilRequest;
    (function(WillSaveTextDocumentWaitUntilRequest2) {
      WillSaveTextDocumentWaitUntilRequest2.method = "textDocument/willSaveWaitUntil";
      WillSaveTextDocumentWaitUntilRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentWaitUntilRequest2.type = new messages_1.ProtocolRequestType(WillSaveTextDocumentWaitUntilRequest2.method);
    })(WillSaveTextDocumentWaitUntilRequest || (exports2.WillSaveTextDocumentWaitUntilRequest = WillSaveTextDocumentWaitUntilRequest = {}));
    var DidChangeWatchedFilesNotification;
    (function(DidChangeWatchedFilesNotification2) {
      DidChangeWatchedFilesNotification2.method = "workspace/didChangeWatchedFiles";
      DidChangeWatchedFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeWatchedFilesNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWatchedFilesNotification2.method);
    })(DidChangeWatchedFilesNotification || (exports2.DidChangeWatchedFilesNotification = DidChangeWatchedFilesNotification = {}));
    var FileChangeType;
    (function(FileChangeType2) {
      FileChangeType2.Created = 1;
      FileChangeType2.Changed = 2;
      FileChangeType2.Deleted = 3;
    })(FileChangeType || (exports2.FileChangeType = FileChangeType = {}));
    var RelativePattern;
    (function(RelativePattern2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (vscode_languageserver_types_1.URI.is(candidate.baseUri) || vscode_languageserver_types_1.WorkspaceFolder.is(candidate.baseUri)) && Is2.string(candidate.pattern);
      }
      RelativePattern2.is = is2;
    })(RelativePattern || (exports2.RelativePattern = RelativePattern = {}));
    var WatchKind;
    (function(WatchKind2) {
      WatchKind2.Create = 1;
      WatchKind2.Change = 2;
      WatchKind2.Delete = 4;
    })(WatchKind || (exports2.WatchKind = WatchKind = {}));
    var PublishDiagnosticsNotification;
    (function(PublishDiagnosticsNotification2) {
      PublishDiagnosticsNotification2.method = "textDocument/publishDiagnostics";
      PublishDiagnosticsNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      PublishDiagnosticsNotification2.type = new messages_1.ProtocolNotificationType(PublishDiagnosticsNotification2.method);
    })(PublishDiagnosticsNotification || (exports2.PublishDiagnosticsNotification = PublishDiagnosticsNotification = {}));
    var CompletionTriggerKind;
    (function(CompletionTriggerKind2) {
      CompletionTriggerKind2.Invoked = 1;
      CompletionTriggerKind2.TriggerCharacter = 2;
      CompletionTriggerKind2.TriggerForIncompleteCompletions = 3;
    })(CompletionTriggerKind || (exports2.CompletionTriggerKind = CompletionTriggerKind = {}));
    var CompletionRequest;
    (function(CompletionRequest2) {
      CompletionRequest2.method = "textDocument/completion";
      CompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionRequest2.type = new messages_1.ProtocolRequestType(CompletionRequest2.method);
    })(CompletionRequest || (exports2.CompletionRequest = CompletionRequest = {}));
    var CompletionResolveRequest;
    (function(CompletionResolveRequest2) {
      CompletionResolveRequest2.method = "completionItem/resolve";
      CompletionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionResolveRequest2.type = new messages_1.ProtocolRequestType(CompletionResolveRequest2.method);
    })(CompletionResolveRequest || (exports2.CompletionResolveRequest = CompletionResolveRequest = {}));
    var HoverRequest;
    (function(HoverRequest2) {
      HoverRequest2.method = "textDocument/hover";
      HoverRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      HoverRequest2.type = new messages_1.ProtocolRequestType(HoverRequest2.method);
    })(HoverRequest || (exports2.HoverRequest = HoverRequest = {}));
    var SignatureHelpTriggerKind;
    (function(SignatureHelpTriggerKind2) {
      SignatureHelpTriggerKind2.Invoked = 1;
      SignatureHelpTriggerKind2.TriggerCharacter = 2;
      SignatureHelpTriggerKind2.ContentChange = 3;
    })(SignatureHelpTriggerKind || (exports2.SignatureHelpTriggerKind = SignatureHelpTriggerKind = {}));
    var SignatureHelpRequest;
    (function(SignatureHelpRequest2) {
      SignatureHelpRequest2.method = "textDocument/signatureHelp";
      SignatureHelpRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      SignatureHelpRequest2.type = new messages_1.ProtocolRequestType(SignatureHelpRequest2.method);
    })(SignatureHelpRequest || (exports2.SignatureHelpRequest = SignatureHelpRequest = {}));
    var DefinitionRequest;
    (function(DefinitionRequest2) {
      DefinitionRequest2.method = "textDocument/definition";
      DefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DefinitionRequest2.type = new messages_1.ProtocolRequestType(DefinitionRequest2.method);
    })(DefinitionRequest || (exports2.DefinitionRequest = DefinitionRequest = {}));
    var ReferencesRequest;
    (function(ReferencesRequest2) {
      ReferencesRequest2.method = "textDocument/references";
      ReferencesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ReferencesRequest2.type = new messages_1.ProtocolRequestType(ReferencesRequest2.method);
    })(ReferencesRequest || (exports2.ReferencesRequest = ReferencesRequest = {}));
    var DocumentHighlightRequest;
    (function(DocumentHighlightRequest2) {
      DocumentHighlightRequest2.method = "textDocument/documentHighlight";
      DocumentHighlightRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentHighlightRequest2.type = new messages_1.ProtocolRequestType(DocumentHighlightRequest2.method);
    })(DocumentHighlightRequest || (exports2.DocumentHighlightRequest = DocumentHighlightRequest = {}));
    var DocumentSymbolRequest;
    (function(DocumentSymbolRequest2) {
      DocumentSymbolRequest2.method = "textDocument/documentSymbol";
      DocumentSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentSymbolRequest2.type = new messages_1.ProtocolRequestType(DocumentSymbolRequest2.method);
    })(DocumentSymbolRequest || (exports2.DocumentSymbolRequest = DocumentSymbolRequest = {}));
    var CodeActionRequest;
    (function(CodeActionRequest2) {
      CodeActionRequest2.method = "textDocument/codeAction";
      CodeActionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionRequest2.type = new messages_1.ProtocolRequestType(CodeActionRequest2.method);
    })(CodeActionRequest || (exports2.CodeActionRequest = CodeActionRequest = {}));
    var CodeActionResolveRequest;
    (function(CodeActionResolveRequest2) {
      CodeActionResolveRequest2.method = "codeAction/resolve";
      CodeActionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionResolveRequest2.type = new messages_1.ProtocolRequestType(CodeActionResolveRequest2.method);
    })(CodeActionResolveRequest || (exports2.CodeActionResolveRequest = CodeActionResolveRequest = {}));
    var WorkspaceSymbolRequest;
    (function(WorkspaceSymbolRequest2) {
      WorkspaceSymbolRequest2.method = "workspace/symbol";
      WorkspaceSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolRequest2.method);
    })(WorkspaceSymbolRequest || (exports2.WorkspaceSymbolRequest = WorkspaceSymbolRequest = {}));
    var WorkspaceSymbolResolveRequest;
    (function(WorkspaceSymbolResolveRequest2) {
      WorkspaceSymbolResolveRequest2.method = "workspaceSymbol/resolve";
      WorkspaceSymbolResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolResolveRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolResolveRequest2.method);
    })(WorkspaceSymbolResolveRequest || (exports2.WorkspaceSymbolResolveRequest = WorkspaceSymbolResolveRequest = {}));
    var CodeLensRequest;
    (function(CodeLensRequest2) {
      CodeLensRequest2.method = "textDocument/codeLens";
      CodeLensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensRequest2.type = new messages_1.ProtocolRequestType(CodeLensRequest2.method);
    })(CodeLensRequest || (exports2.CodeLensRequest = CodeLensRequest = {}));
    var CodeLensResolveRequest;
    (function(CodeLensResolveRequest2) {
      CodeLensResolveRequest2.method = "codeLens/resolve";
      CodeLensResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensResolveRequest2.type = new messages_1.ProtocolRequestType(CodeLensResolveRequest2.method);
    })(CodeLensResolveRequest || (exports2.CodeLensResolveRequest = CodeLensResolveRequest = {}));
    var CodeLensRefreshRequest;
    (function(CodeLensRefreshRequest2) {
      CodeLensRefreshRequest2.method = `workspace/codeLens/refresh`;
      CodeLensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      CodeLensRefreshRequest2.type = new messages_1.ProtocolRequestType0(CodeLensRefreshRequest2.method);
    })(CodeLensRefreshRequest || (exports2.CodeLensRefreshRequest = CodeLensRefreshRequest = {}));
    var DocumentLinkRequest;
    (function(DocumentLinkRequest2) {
      DocumentLinkRequest2.method = "textDocument/documentLink";
      DocumentLinkRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkRequest2.method);
    })(DocumentLinkRequest || (exports2.DocumentLinkRequest = DocumentLinkRequest = {}));
    var DocumentLinkResolveRequest;
    (function(DocumentLinkResolveRequest2) {
      DocumentLinkResolveRequest2.method = "documentLink/resolve";
      DocumentLinkResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkResolveRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkResolveRequest2.method);
    })(DocumentLinkResolveRequest || (exports2.DocumentLinkResolveRequest = DocumentLinkResolveRequest = {}));
    var DocumentFormattingRequest;
    (function(DocumentFormattingRequest2) {
      DocumentFormattingRequest2.method = "textDocument/formatting";
      DocumentFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentFormattingRequest2.method);
    })(DocumentFormattingRequest || (exports2.DocumentFormattingRequest = DocumentFormattingRequest = {}));
    var DocumentRangeFormattingRequest;
    (function(DocumentRangeFormattingRequest2) {
      DocumentRangeFormattingRequest2.method = "textDocument/rangeFormatting";
      DocumentRangeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangeFormattingRequest2.method);
    })(DocumentRangeFormattingRequest || (exports2.DocumentRangeFormattingRequest = DocumentRangeFormattingRequest = {}));
    var DocumentRangesFormattingRequest;
    (function(DocumentRangesFormattingRequest2) {
      DocumentRangesFormattingRequest2.method = "textDocument/rangesFormatting";
      DocumentRangesFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangesFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangesFormattingRequest2.method);
    })(DocumentRangesFormattingRequest || (exports2.DocumentRangesFormattingRequest = DocumentRangesFormattingRequest = {}));
    var DocumentOnTypeFormattingRequest;
    (function(DocumentOnTypeFormattingRequest2) {
      DocumentOnTypeFormattingRequest2.method = "textDocument/onTypeFormatting";
      DocumentOnTypeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentOnTypeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentOnTypeFormattingRequest2.method);
    })(DocumentOnTypeFormattingRequest || (exports2.DocumentOnTypeFormattingRequest = DocumentOnTypeFormattingRequest = {}));
    var PrepareSupportDefaultBehavior;
    (function(PrepareSupportDefaultBehavior2) {
      PrepareSupportDefaultBehavior2.Identifier = 1;
    })(PrepareSupportDefaultBehavior || (exports2.PrepareSupportDefaultBehavior = PrepareSupportDefaultBehavior = {}));
    var RenameRequest;
    (function(RenameRequest2) {
      RenameRequest2.method = "textDocument/rename";
      RenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      RenameRequest2.type = new messages_1.ProtocolRequestType(RenameRequest2.method);
    })(RenameRequest || (exports2.RenameRequest = RenameRequest = {}));
    var PrepareRenameRequest;
    (function(PrepareRenameRequest2) {
      PrepareRenameRequest2.method = "textDocument/prepareRename";
      PrepareRenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      PrepareRenameRequest2.type = new messages_1.ProtocolRequestType(PrepareRenameRequest2.method);
    })(PrepareRenameRequest || (exports2.PrepareRenameRequest = PrepareRenameRequest = {}));
    var ExecuteCommandRequest;
    (function(ExecuteCommandRequest2) {
      ExecuteCommandRequest2.method = "workspace/executeCommand";
      ExecuteCommandRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExecuteCommandRequest2.type = new messages_1.ProtocolRequestType(ExecuteCommandRequest2.method);
    })(ExecuteCommandRequest || (exports2.ExecuteCommandRequest = ExecuteCommandRequest = {}));
    var ApplyWorkspaceEditRequest;
    (function(ApplyWorkspaceEditRequest2) {
      ApplyWorkspaceEditRequest2.method = "workspace/applyEdit";
      ApplyWorkspaceEditRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ApplyWorkspaceEditRequest2.type = new messages_1.ProtocolRequestType("workspace/applyEdit");
    })(ApplyWorkspaceEditRequest || (exports2.ApplyWorkspaceEditRequest = ApplyWorkspaceEditRequest = {}));
  })(protocol$1);
  return protocol$1;
}
var connection$2 = {};
var hasRequiredConnection$2;
function requireConnection$2() {
  if (hasRequiredConnection$2) return connection$2;
  hasRequiredConnection$2 = 1;
  Object.defineProperty(connection$2, "__esModule", { value: true });
  connection$2.createProtocolConnection = void 0;
  const vscode_jsonrpc_1 = requireMain$2();
  function createProtocolConnection(input, output, logger, options2) {
    if (vscode_jsonrpc_1.ConnectionStrategy.is(options2)) {
      options2 = { connectionStrategy: options2 };
    }
    return (0, vscode_jsonrpc_1.createMessageConnection)(input, output, logger, options2);
  }
  connection$2.createProtocolConnection = createProtocolConnection;
  return connection$2;
}
var hasRequiredApi$1$1;
function requireApi$1$1() {
  if (hasRequiredApi$1$1) return api$3;
  hasRequiredApi$1$1 = 1;
  (function(exports2) {
    var __createBinding = api$3 && api$3.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = api$3 && api$3.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.LSPErrorCodes = exports2.createProtocolConnection = void 0;
    __exportStar(requireMain$2(), exports2);
    __exportStar(require$$1$1, exports2);
    __exportStar(requireMessages$2(), exports2);
    __exportStar(requireProtocol$1(), exports2);
    var connection_1 = requireConnection$2();
    Object.defineProperty(exports2, "createProtocolConnection", { enumerable: true, get: function() {
      return connection_1.createProtocolConnection;
    } });
    var LSPErrorCodes;
    (function(LSPErrorCodes2) {
      LSPErrorCodes2.lspReservedErrorRangeStart = -32899;
      LSPErrorCodes2.RequestFailed = -32803;
      LSPErrorCodes2.ServerCancelled = -32802;
      LSPErrorCodes2.ContentModified = -32801;
      LSPErrorCodes2.RequestCancelled = -32800;
      LSPErrorCodes2.lspReservedErrorRangeEnd = -32800;
    })(LSPErrorCodes || (exports2.LSPErrorCodes = LSPErrorCodes = {}));
  })(api$3);
  return api$3;
}
var hasRequiredMain$1$1;
function requireMain$1$1() {
  if (hasRequiredMain$1$1) return main$2$1;
  hasRequiredMain$1$1 = 1;
  (function(exports2) {
    var __createBinding = main$2$1 && main$2$1.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = main$2$1 && main$2$1.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createProtocolConnection = void 0;
    const browser_1 = requireBrowser$2();
    __exportStar(requireBrowser$2(), exports2);
    __exportStar(requireApi$1$1(), exports2);
    function createProtocolConnection(reader, writer, logger, options2) {
      return (0, browser_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports2.createProtocolConnection = createProtocolConnection;
  })(main$2$1);
  return main$2$1;
}
var hasRequiredSemanticTokens;
function requireSemanticTokens() {
  if (hasRequiredSemanticTokens) return semanticTokens;
  hasRequiredSemanticTokens = 1;
  Object.defineProperty(semanticTokens, "__esModule", { value: true });
  semanticTokens.SemanticTokensBuilder = semanticTokens.SemanticTokensDiff = semanticTokens.SemanticTokensFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const SemanticTokensFeature = (Base) => {
    return class extends Base {
      get semanticTokens() {
        return {
          refresh: () => {
            return this.connection.sendRequest(vscode_languageserver_protocol_1.SemanticTokensRefreshRequest.type);
          },
          on: (handler) => {
            const type = vscode_languageserver_protocol_1.SemanticTokensRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          },
          onDelta: (handler) => {
            const type = vscode_languageserver_protocol_1.SemanticTokensDeltaRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          },
          onRange: (handler) => {
            const type = vscode_languageserver_protocol_1.SemanticTokensRangeRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          }
        };
      }
    };
  };
  semanticTokens.SemanticTokensFeature = SemanticTokensFeature;
  class SemanticTokensDiff {
    constructor(originalSequence, modifiedSequence) {
      this.originalSequence = originalSequence;
      this.modifiedSequence = modifiedSequence;
    }
    computeDiff() {
      const originalLength = this.originalSequence.length;
      const modifiedLength = this.modifiedSequence.length;
      let startIndex = 0;
      while (startIndex < modifiedLength && startIndex < originalLength && this.originalSequence[startIndex] === this.modifiedSequence[startIndex]) {
        startIndex++;
      }
      if (startIndex < modifiedLength && startIndex < originalLength) {
        let originalEndIndex = originalLength - 1;
        let modifiedEndIndex = modifiedLength - 1;
        while (originalEndIndex >= startIndex && modifiedEndIndex >= startIndex && this.originalSequence[originalEndIndex] === this.modifiedSequence[modifiedEndIndex]) {
          originalEndIndex--;
          modifiedEndIndex--;
        }
        if (originalEndIndex < startIndex || modifiedEndIndex < startIndex) {
          originalEndIndex++;
          modifiedEndIndex++;
        }
        const deleteCount = originalEndIndex - startIndex + 1;
        const newData = this.modifiedSequence.slice(startIndex, modifiedEndIndex + 1);
        if (newData.length === 1 && newData[0] === this.originalSequence[originalEndIndex]) {
          return [
            { start: startIndex, deleteCount: deleteCount - 1 }
          ];
        } else {
          return [
            { start: startIndex, deleteCount, data: newData }
          ];
        }
      } else if (startIndex < modifiedLength) {
        return [
          { start: startIndex, deleteCount: 0, data: this.modifiedSequence.slice(startIndex) }
        ];
      } else if (startIndex < originalLength) {
        return [
          { start: startIndex, deleteCount: originalLength - startIndex }
        ];
      } else {
        return [];
      }
    }
  }
  semanticTokens.SemanticTokensDiff = SemanticTokensDiff;
  class SemanticTokensBuilder {
    constructor() {
      this._prevData = void 0;
      this.initialize();
    }
    initialize() {
      this._id = Date.now();
      this._prevLine = 0;
      this._prevChar = 0;
      this._data = [];
      this._dataLen = 0;
    }
    push(line2, char, length, tokenType, tokenModifiers) {
      let pushLine = line2;
      let pushChar = char;
      if (this._dataLen > 0) {
        pushLine -= this._prevLine;
        if (pushLine === 0) {
          pushChar -= this._prevChar;
        }
      }
      this._data[this._dataLen++] = pushLine;
      this._data[this._dataLen++] = pushChar;
      this._data[this._dataLen++] = length;
      this._data[this._dataLen++] = tokenType;
      this._data[this._dataLen++] = tokenModifiers;
      this._prevLine = line2;
      this._prevChar = char;
    }
    get id() {
      return this._id.toString();
    }
    previousResult(id2) {
      if (this.id === id2) {
        this._prevData = this._data;
      }
      this.initialize();
    }
    build() {
      this._prevData = void 0;
      return {
        resultId: this.id,
        data: this._data
      };
    }
    canBuildEdits() {
      return this._prevData !== void 0;
    }
    buildEdits() {
      if (this._prevData !== void 0) {
        return {
          resultId: this.id,
          edits: new SemanticTokensDiff(this._prevData, this._data).computeDiff()
        };
      } else {
        return this.build();
      }
    }
  }
  semanticTokens.SemanticTokensBuilder = SemanticTokensBuilder;
  return semanticTokens;
}
var inlineCompletion_proposed = {};
var hasRequiredInlineCompletion_proposed;
function requireInlineCompletion_proposed() {
  if (hasRequiredInlineCompletion_proposed) return inlineCompletion_proposed;
  hasRequiredInlineCompletion_proposed = 1;
  Object.defineProperty(inlineCompletion_proposed, "__esModule", { value: true });
  inlineCompletion_proposed.InlineCompletionFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const InlineCompletionFeature = (Base) => {
    return class extends Base {
      get inlineCompletion() {
        return {
          on: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.InlineCompletionRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params));
            });
          }
        };
      }
    };
  };
  inlineCompletion_proposed.InlineCompletionFeature = InlineCompletionFeature;
  return inlineCompletion_proposed;
}
var textDocuments = {};
var hasRequiredTextDocuments;
function requireTextDocuments() {
  if (hasRequiredTextDocuments) return textDocuments;
  hasRequiredTextDocuments = 1;
  Object.defineProperty(textDocuments, "__esModule", { value: true });
  textDocuments.TextDocuments = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  class TextDocuments {
    /**
     * Create a new text document manager.
     */
    constructor(configuration2) {
      this._configuration = configuration2;
      this._syncedDocuments = /* @__PURE__ */ new Map();
      this._onDidChangeContent = new vscode_languageserver_protocol_1.Emitter();
      this._onDidOpen = new vscode_languageserver_protocol_1.Emitter();
      this._onDidClose = new vscode_languageserver_protocol_1.Emitter();
      this._onDidSave = new vscode_languageserver_protocol_1.Emitter();
      this._onWillSave = new vscode_languageserver_protocol_1.Emitter();
    }
    /**
     * An event that fires when a text document managed by this manager
     * has been opened.
     */
    get onDidOpen() {
      return this._onDidOpen.event;
    }
    /**
     * An event that fires when a text document managed by this manager
     * has been opened or the content changes.
     */
    get onDidChangeContent() {
      return this._onDidChangeContent.event;
    }
    /**
     * An event that fires when a text document managed by this manager
     * will be saved.
     */
    get onWillSave() {
      return this._onWillSave.event;
    }
    /**
     * Sets a handler that will be called if a participant wants to provide
     * edits during a text document save.
     */
    onWillSaveWaitUntil(handler) {
      this._willSaveWaitUntil = handler;
    }
    /**
     * An event that fires when a text document managed by this manager
     * has been saved.
     */
    get onDidSave() {
      return this._onDidSave.event;
    }
    /**
     * An event that fires when a text document managed by this manager
     * has been closed.
     */
    get onDidClose() {
      return this._onDidClose.event;
    }
    /**
     * Returns the document for the given URI. Returns undefined if
     * the document is not managed by this instance.
     *
     * @param uri The text document's URI to retrieve.
     * @return the text document or `undefined`.
     */
    get(uri) {
      return this._syncedDocuments.get(uri);
    }
    /**
     * Returns all text documents managed by this instance.
     *
     * @return all text documents.
     */
    all() {
      return Array.from(this._syncedDocuments.values());
    }
    /**
     * Returns the URIs of all text documents managed by this instance.
     *
     * @return the URI's of all text documents.
     */
    keys() {
      return Array.from(this._syncedDocuments.keys());
    }
    /**
     * Listens for `low level` notification on the given connection to
     * update the text documents managed by this instance.
     *
     * Please note that the connection only provides handlers not an event model. Therefore
     * listening on a connection will overwrite the following handlers on a connection:
     * `onDidOpenTextDocument`, `onDidChangeTextDocument`, `onDidCloseTextDocument`,
     * `onWillSaveTextDocument`, `onWillSaveTextDocumentWaitUntil` and `onDidSaveTextDocument`.
     *
     * Use the corresponding events on the TextDocuments instance instead.
     *
     * @param connection The connection to listen on.
     */
    listen(connection2) {
      connection2.__textDocumentSync = vscode_languageserver_protocol_1.TextDocumentSyncKind.Incremental;
      const disposables = [];
      disposables.push(connection2.onDidOpenTextDocument((event) => {
        const td = event.textDocument;
        const document2 = this._configuration.create(td.uri, td.languageId, td.version, td.text);
        this._syncedDocuments.set(td.uri, document2);
        const toFire = Object.freeze({ document: document2 });
        this._onDidOpen.fire(toFire);
        this._onDidChangeContent.fire(toFire);
      }));
      disposables.push(connection2.onDidChangeTextDocument((event) => {
        const td = event.textDocument;
        const changes = event.contentChanges;
        if (changes.length === 0) {
          return;
        }
        const { version: version2 } = td;
        if (version2 === null || version2 === void 0) {
          throw new Error(`Received document change event for ${td.uri} without valid version identifier`);
        }
        let syncedDocument = this._syncedDocuments.get(td.uri);
        if (syncedDocument !== void 0) {
          syncedDocument = this._configuration.update(syncedDocument, changes, version2);
          this._syncedDocuments.set(td.uri, syncedDocument);
          this._onDidChangeContent.fire(Object.freeze({ document: syncedDocument }));
        }
      }));
      disposables.push(connection2.onDidCloseTextDocument((event) => {
        let syncedDocument = this._syncedDocuments.get(event.textDocument.uri);
        if (syncedDocument !== void 0) {
          this._syncedDocuments.delete(event.textDocument.uri);
          this._onDidClose.fire(Object.freeze({ document: syncedDocument }));
        }
      }));
      disposables.push(connection2.onWillSaveTextDocument((event) => {
        let syncedDocument = this._syncedDocuments.get(event.textDocument.uri);
        if (syncedDocument !== void 0) {
          this._onWillSave.fire(Object.freeze({ document: syncedDocument, reason: event.reason }));
        }
      }));
      disposables.push(connection2.onWillSaveTextDocumentWaitUntil((event, token) => {
        let syncedDocument = this._syncedDocuments.get(event.textDocument.uri);
        if (syncedDocument !== void 0 && this._willSaveWaitUntil) {
          return this._willSaveWaitUntil(Object.freeze({ document: syncedDocument, reason: event.reason }), token);
        } else {
          return [];
        }
      }));
      disposables.push(connection2.onDidSaveTextDocument((event) => {
        let syncedDocument = this._syncedDocuments.get(event.textDocument.uri);
        if (syncedDocument !== void 0) {
          this._onDidSave.fire(Object.freeze({ document: syncedDocument }));
        }
      }));
      return vscode_languageserver_protocol_1.Disposable.create(() => {
        disposables.forEach((disposable2) => disposable2.dispose());
      });
    }
  }
  textDocuments.TextDocuments = TextDocuments;
  return textDocuments;
}
var notebook = {};
var hasRequiredNotebook;
function requireNotebook() {
  if (hasRequiredNotebook) return notebook;
  hasRequiredNotebook = 1;
  Object.defineProperty(notebook, "__esModule", { value: true });
  notebook.NotebookDocuments = notebook.NotebookSyncFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const textDocuments_1 = requireTextDocuments();
  const NotebookSyncFeature = (Base) => {
    return class extends Base {
      get synchronization() {
        return {
          onDidOpenNotebookDocument: (handler) => {
            return this.connection.onNotification(vscode_languageserver_protocol_1.DidOpenNotebookDocumentNotification.type, (params) => {
              handler(params);
            });
          },
          onDidChangeNotebookDocument: (handler) => {
            return this.connection.onNotification(vscode_languageserver_protocol_1.DidChangeNotebookDocumentNotification.type, (params) => {
              handler(params);
            });
          },
          onDidSaveNotebookDocument: (handler) => {
            return this.connection.onNotification(vscode_languageserver_protocol_1.DidSaveNotebookDocumentNotification.type, (params) => {
              handler(params);
            });
          },
          onDidCloseNotebookDocument: (handler) => {
            return this.connection.onNotification(vscode_languageserver_protocol_1.DidCloseNotebookDocumentNotification.type, (params) => {
              handler(params);
            });
          }
        };
      }
    };
  };
  notebook.NotebookSyncFeature = NotebookSyncFeature;
  class CellTextDocumentConnection {
    onDidOpenTextDocument(handler) {
      this.openHandler = handler;
      return vscode_languageserver_protocol_1.Disposable.create(() => {
        this.openHandler = void 0;
      });
    }
    openTextDocument(params) {
      this.openHandler && this.openHandler(params);
    }
    onDidChangeTextDocument(handler) {
      this.changeHandler = handler;
      return vscode_languageserver_protocol_1.Disposable.create(() => {
        this.changeHandler = handler;
      });
    }
    changeTextDocument(params) {
      this.changeHandler && this.changeHandler(params);
    }
    onDidCloseTextDocument(handler) {
      this.closeHandler = handler;
      return vscode_languageserver_protocol_1.Disposable.create(() => {
        this.closeHandler = void 0;
      });
    }
    closeTextDocument(params) {
      this.closeHandler && this.closeHandler(params);
    }
    onWillSaveTextDocument() {
      return CellTextDocumentConnection.NULL_DISPOSE;
    }
    onWillSaveTextDocumentWaitUntil() {
      return CellTextDocumentConnection.NULL_DISPOSE;
    }
    onDidSaveTextDocument() {
      return CellTextDocumentConnection.NULL_DISPOSE;
    }
  }
  CellTextDocumentConnection.NULL_DISPOSE = Object.freeze({ dispose: () => {
  } });
  class NotebookDocuments {
    constructor(configurationOrTextDocuments) {
      if (configurationOrTextDocuments instanceof textDocuments_1.TextDocuments) {
        this._cellTextDocuments = configurationOrTextDocuments;
      } else {
        this._cellTextDocuments = new textDocuments_1.TextDocuments(configurationOrTextDocuments);
      }
      this.notebookDocuments = /* @__PURE__ */ new Map();
      this.notebookCellMap = /* @__PURE__ */ new Map();
      this._onDidOpen = new vscode_languageserver_protocol_1.Emitter();
      this._onDidChange = new vscode_languageserver_protocol_1.Emitter();
      this._onDidSave = new vscode_languageserver_protocol_1.Emitter();
      this._onDidClose = new vscode_languageserver_protocol_1.Emitter();
    }
    get cellTextDocuments() {
      return this._cellTextDocuments;
    }
    getCellTextDocument(cell) {
      return this._cellTextDocuments.get(cell.document);
    }
    getNotebookDocument(uri) {
      return this.notebookDocuments.get(uri);
    }
    getNotebookCell(uri) {
      const value = this.notebookCellMap.get(uri);
      return value && value[0];
    }
    findNotebookDocumentForCell(cell) {
      const key = typeof cell === "string" ? cell : cell.document;
      const value = this.notebookCellMap.get(key);
      return value && value[1];
    }
    get onDidOpen() {
      return this._onDidOpen.event;
    }
    get onDidSave() {
      return this._onDidSave.event;
    }
    get onDidChange() {
      return this._onDidChange.event;
    }
    get onDidClose() {
      return this._onDidClose.event;
    }
    /**
     * Listens for `low level` notification on the given connection to
     * update the notebook documents managed by this instance.
     *
     * Please note that the connection only provides handlers not an event model. Therefore
     * listening on a connection will overwrite the following handlers on a connection:
     * `onDidOpenNotebookDocument`, `onDidChangeNotebookDocument`, `onDidSaveNotebookDocument`,
     *  and `onDidCloseNotebookDocument`.
     *
     * @param connection The connection to listen on.
     */
    listen(connection2) {
      const cellTextDocumentConnection = new CellTextDocumentConnection();
      const disposables = [];
      disposables.push(this.cellTextDocuments.listen(cellTextDocumentConnection));
      disposables.push(connection2.notebooks.synchronization.onDidOpenNotebookDocument((params) => {
        this.notebookDocuments.set(params.notebookDocument.uri, params.notebookDocument);
        for (const cellTextDocument of params.cellTextDocuments) {
          cellTextDocumentConnection.openTextDocument({ textDocument: cellTextDocument });
        }
        this.updateCellMap(params.notebookDocument);
        this._onDidOpen.fire(params.notebookDocument);
      }));
      disposables.push(connection2.notebooks.synchronization.onDidChangeNotebookDocument((params) => {
        const notebookDocument = this.notebookDocuments.get(params.notebookDocument.uri);
        if (notebookDocument === void 0) {
          return;
        }
        notebookDocument.version = params.notebookDocument.version;
        const oldMetadata = notebookDocument.metadata;
        let metadataChanged = false;
        const change = params.change;
        if (change.metadata !== void 0) {
          metadataChanged = true;
          notebookDocument.metadata = change.metadata;
        }
        const opened = [];
        const closed = [];
        const data = [];
        const text2 = [];
        if (change.cells !== void 0) {
          const changedCells = change.cells;
          if (changedCells.structure !== void 0) {
            const array = changedCells.structure.array;
            notebookDocument.cells.splice(array.start, array.deleteCount, ...array.cells !== void 0 ? array.cells : []);
            if (changedCells.structure.didOpen !== void 0) {
              for (const open of changedCells.structure.didOpen) {
                cellTextDocumentConnection.openTextDocument({ textDocument: open });
                opened.push(open.uri);
              }
            }
            if (changedCells.structure.didClose) {
              for (const close of changedCells.structure.didClose) {
                cellTextDocumentConnection.closeTextDocument({ textDocument: close });
                closed.push(close.uri);
              }
            }
          }
          if (changedCells.data !== void 0) {
            const cellUpdates = new Map(changedCells.data.map((cell) => [cell.document, cell]));
            for (let i2 = 0; i2 <= notebookDocument.cells.length; i2++) {
              const change2 = cellUpdates.get(notebookDocument.cells[i2].document);
              if (change2 !== void 0) {
                const old = notebookDocument.cells.splice(i2, 1, change2);
                data.push({ old: old[0], new: change2 });
                cellUpdates.delete(change2.document);
                if (cellUpdates.size === 0) {
                  break;
                }
              }
            }
          }
          if (changedCells.textContent !== void 0) {
            for (const cellTextDocument of changedCells.textContent) {
              cellTextDocumentConnection.changeTextDocument({ textDocument: cellTextDocument.document, contentChanges: cellTextDocument.changes });
              text2.push(cellTextDocument.document.uri);
            }
          }
        }
        this.updateCellMap(notebookDocument);
        const changeEvent = { notebookDocument };
        if (metadataChanged) {
          changeEvent.metadata = { old: oldMetadata, new: notebookDocument.metadata };
        }
        const added = [];
        for (const open of opened) {
          added.push(this.getNotebookCell(open));
        }
        const removed = [];
        for (const close of closed) {
          removed.push(this.getNotebookCell(close));
        }
        const textContent = [];
        for (const change2 of text2) {
          textContent.push(this.getNotebookCell(change2));
        }
        if (added.length > 0 || removed.length > 0 || data.length > 0 || textContent.length > 0) {
          changeEvent.cells = { added, removed, changed: { data, textContent } };
        }
        if (changeEvent.metadata !== void 0 || changeEvent.cells !== void 0) {
          this._onDidChange.fire(changeEvent);
        }
      }));
      disposables.push(connection2.notebooks.synchronization.onDidSaveNotebookDocument((params) => {
        const notebookDocument = this.notebookDocuments.get(params.notebookDocument.uri);
        if (notebookDocument === void 0) {
          return;
        }
        this._onDidSave.fire(notebookDocument);
      }));
      disposables.push(connection2.notebooks.synchronization.onDidCloseNotebookDocument((params) => {
        const notebookDocument = this.notebookDocuments.get(params.notebookDocument.uri);
        if (notebookDocument === void 0) {
          return;
        }
        this._onDidClose.fire(notebookDocument);
        for (const cellTextDocument of params.cellTextDocuments) {
          cellTextDocumentConnection.closeTextDocument({ textDocument: cellTextDocument });
        }
        this.notebookDocuments.delete(params.notebookDocument.uri);
        for (const cell of notebookDocument.cells) {
          this.notebookCellMap.delete(cell.document);
        }
      }));
      return vscode_languageserver_protocol_1.Disposable.create(() => {
        disposables.forEach((disposable2) => disposable2.dispose());
      });
    }
    updateCellMap(notebookDocument) {
      for (const cell of notebookDocument.cells) {
        this.notebookCellMap.set(cell.document, [cell, notebookDocument]);
      }
    }
  }
  notebook.NotebookDocuments = NotebookDocuments;
  return notebook;
}
var server = {};
var is$3 = {};
var hasRequiredIs$3;
function requireIs$3() {
  if (hasRequiredIs$3) return is$3;
  hasRequiredIs$3 = 1;
  Object.defineProperty(is$3, "__esModule", { value: true });
  is$3.thenable = is$3.typedArray = is$3.stringArray = is$3.array = is$3.func = is$3.error = is$3.number = is$3.string = is$3.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is$3.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is$3.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is$3.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is$3.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is$3.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is$3.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is$3.stringArray = stringArray;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  is$3.typedArray = typedArray;
  function thenable(value) {
    return value && func(value.then);
  }
  is$3.thenable = thenable;
  return is$3;
}
var uuid = {};
var hasRequiredUuid;
function requireUuid() {
  if (hasRequiredUuid) return uuid;
  hasRequiredUuid = 1;
  Object.defineProperty(uuid, "__esModule", { value: true });
  uuid.generateUuid = uuid.parse = uuid.isUUID = uuid.v4 = uuid.empty = void 0;
  class ValueUUID {
    constructor(_value) {
      this._value = _value;
    }
    asHex() {
      return this._value;
    }
    equals(other) {
      return this.asHex() === other.asHex();
    }
  }
  class V4UUID extends ValueUUID {
    static _oneOf(array) {
      return array[Math.floor(array.length * Math.random())];
    }
    static _randomHex() {
      return V4UUID._oneOf(V4UUID._chars);
    }
    constructor() {
      super([
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        "-",
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        "-",
        "4",
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        "-",
        V4UUID._oneOf(V4UUID._timeHighBits),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        "-",
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex(),
        V4UUID._randomHex()
      ].join(""));
    }
  }
  V4UUID._chars = ["0", "1", "2", "3", "4", "5", "6", "6", "7", "8", "9", "a", "b", "c", "d", "e", "f"];
  V4UUID._timeHighBits = ["8", "9", "a", "b"];
  uuid.empty = new ValueUUID("00000000-0000-0000-0000-000000000000");
  function v4() {
    return new V4UUID();
  }
  uuid.v4 = v4;
  const _UUIDPattern = /^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;
  function isUUID(value) {
    return _UUIDPattern.test(value);
  }
  uuid.isUUID = isUUID;
  function parse2(value) {
    if (!isUUID(value)) {
      throw new Error("invalid uuid");
    }
    return new ValueUUID(value);
  }
  uuid.parse = parse2;
  function generateUuid() {
    return v4().asHex();
  }
  uuid.generateUuid = generateUuid;
  return uuid;
}
var progress = {};
var hasRequiredProgress;
function requireProgress() {
  if (hasRequiredProgress) return progress;
  hasRequiredProgress = 1;
  Object.defineProperty(progress, "__esModule", { value: true });
  progress.attachPartialResult = progress.ProgressFeature = progress.attachWorkDone = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const uuid_1 = requireUuid();
  class WorkDoneProgressReporterImpl {
    constructor(_connection, _token) {
      this._connection = _connection;
      this._token = _token;
      WorkDoneProgressReporterImpl.Instances.set(this._token, this);
    }
    begin(title, percentage, message, cancellable) {
      let param = {
        kind: "begin",
        title,
        percentage,
        message,
        cancellable
      };
      this._connection.sendProgress(vscode_languageserver_protocol_1.WorkDoneProgress.type, this._token, param);
    }
    report(arg0, arg1) {
      let param = {
        kind: "report"
      };
      if (typeof arg0 === "number") {
        param.percentage = arg0;
        if (arg1 !== void 0) {
          param.message = arg1;
        }
      } else {
        param.message = arg0;
      }
      this._connection.sendProgress(vscode_languageserver_protocol_1.WorkDoneProgress.type, this._token, param);
    }
    done() {
      WorkDoneProgressReporterImpl.Instances.delete(this._token);
      this._connection.sendProgress(vscode_languageserver_protocol_1.WorkDoneProgress.type, this._token, { kind: "end" });
    }
  }
  WorkDoneProgressReporterImpl.Instances = /* @__PURE__ */ new Map();
  class WorkDoneProgressServerReporterImpl extends WorkDoneProgressReporterImpl {
    constructor(connection2, token) {
      super(connection2, token);
      this._source = new vscode_languageserver_protocol_1.CancellationTokenSource();
    }
    get token() {
      return this._source.token;
    }
    done() {
      this._source.dispose();
      super.done();
    }
    cancel() {
      this._source.cancel();
    }
  }
  class NullProgressReporter {
    constructor() {
    }
    begin() {
    }
    report() {
    }
    done() {
    }
  }
  class NullProgressServerReporter extends NullProgressReporter {
    constructor() {
      super();
      this._source = new vscode_languageserver_protocol_1.CancellationTokenSource();
    }
    get token() {
      return this._source.token;
    }
    done() {
      this._source.dispose();
    }
    cancel() {
      this._source.cancel();
    }
  }
  function attachWorkDone(connection2, params) {
    if (params === void 0 || params.workDoneToken === void 0) {
      return new NullProgressReporter();
    }
    const token = params.workDoneToken;
    delete params.workDoneToken;
    return new WorkDoneProgressReporterImpl(connection2, token);
  }
  progress.attachWorkDone = attachWorkDone;
  const ProgressFeature = (Base) => {
    return class extends Base {
      constructor() {
        super();
        this._progressSupported = false;
      }
      initialize(capabilities) {
        super.initialize(capabilities);
        if (capabilities?.window?.workDoneProgress === true) {
          this._progressSupported = true;
          this.connection.onNotification(vscode_languageserver_protocol_1.WorkDoneProgressCancelNotification.type, (params) => {
            let progress2 = WorkDoneProgressReporterImpl.Instances.get(params.token);
            if (progress2 instanceof WorkDoneProgressServerReporterImpl || progress2 instanceof NullProgressServerReporter) {
              progress2.cancel();
            }
          });
        }
      }
      attachWorkDoneProgress(token) {
        if (token === void 0) {
          return new NullProgressReporter();
        } else {
          return new WorkDoneProgressReporterImpl(this.connection, token);
        }
      }
      createWorkDoneProgress() {
        if (this._progressSupported) {
          const token = (0, uuid_1.generateUuid)();
          return this.connection.sendRequest(vscode_languageserver_protocol_1.WorkDoneProgressCreateRequest.type, { token }).then(() => {
            const result2 = new WorkDoneProgressServerReporterImpl(this.connection, token);
            return result2;
          });
        } else {
          return Promise.resolve(new NullProgressServerReporter());
        }
      }
    };
  };
  progress.ProgressFeature = ProgressFeature;
  var ResultProgress;
  (function(ResultProgress2) {
    ResultProgress2.type = new vscode_languageserver_protocol_1.ProgressType();
  })(ResultProgress || (ResultProgress = {}));
  class ResultProgressReporterImpl {
    constructor(_connection, _token) {
      this._connection = _connection;
      this._token = _token;
    }
    report(data) {
      this._connection.sendProgress(ResultProgress.type, this._token, data);
    }
  }
  function attachPartialResult(connection2, params) {
    if (params === void 0 || params.partialResultToken === void 0) {
      return void 0;
    }
    const token = params.partialResultToken;
    delete params.partialResultToken;
    return new ResultProgressReporterImpl(connection2, token);
  }
  progress.attachPartialResult = attachPartialResult;
  return progress;
}
var configuration = {};
var hasRequiredConfiguration;
function requireConfiguration() {
  if (hasRequiredConfiguration) return configuration;
  hasRequiredConfiguration = 1;
  Object.defineProperty(configuration, "__esModule", { value: true });
  configuration.ConfigurationFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const Is2 = requireIs$3();
  const ConfigurationFeature = (Base) => {
    return class extends Base {
      getConfiguration(arg) {
        if (!arg) {
          return this._getConfiguration({});
        } else if (Is2.string(arg)) {
          return this._getConfiguration({ section: arg });
        } else {
          return this._getConfiguration(arg);
        }
      }
      _getConfiguration(arg) {
        let params = {
          items: Array.isArray(arg) ? arg : [arg]
        };
        return this.connection.sendRequest(vscode_languageserver_protocol_1.ConfigurationRequest.type, params).then((result2) => {
          if (Array.isArray(result2)) {
            return Array.isArray(arg) ? result2 : result2[0];
          } else {
            return Array.isArray(arg) ? [] : null;
          }
        });
      }
    };
  };
  configuration.ConfigurationFeature = ConfigurationFeature;
  return configuration;
}
var workspaceFolder = {};
var hasRequiredWorkspaceFolder;
function requireWorkspaceFolder() {
  if (hasRequiredWorkspaceFolder) return workspaceFolder;
  hasRequiredWorkspaceFolder = 1;
  Object.defineProperty(workspaceFolder, "__esModule", { value: true });
  workspaceFolder.WorkspaceFoldersFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const WorkspaceFoldersFeature = (Base) => {
    return class extends Base {
      constructor() {
        super();
        this._notificationIsAutoRegistered = false;
      }
      initialize(capabilities) {
        super.initialize(capabilities);
        let workspaceCapabilities = capabilities.workspace;
        if (workspaceCapabilities && workspaceCapabilities.workspaceFolders) {
          this._onDidChangeWorkspaceFolders = new vscode_languageserver_protocol_1.Emitter();
          this.connection.onNotification(vscode_languageserver_protocol_1.DidChangeWorkspaceFoldersNotification.type, (params) => {
            this._onDidChangeWorkspaceFolders.fire(params.event);
          });
        }
      }
      fillServerCapabilities(capabilities) {
        super.fillServerCapabilities(capabilities);
        const changeNotifications = capabilities.workspace?.workspaceFolders?.changeNotifications;
        this._notificationIsAutoRegistered = changeNotifications === true || typeof changeNotifications === "string";
      }
      getWorkspaceFolders() {
        return this.connection.sendRequest(vscode_languageserver_protocol_1.WorkspaceFoldersRequest.type);
      }
      get onDidChangeWorkspaceFolders() {
        if (!this._onDidChangeWorkspaceFolders) {
          throw new Error("Client doesn't support sending workspace folder change events.");
        }
        if (!this._notificationIsAutoRegistered && !this._unregistration) {
          this._unregistration = this.connection.client.register(vscode_languageserver_protocol_1.DidChangeWorkspaceFoldersNotification.type);
        }
        return this._onDidChangeWorkspaceFolders.event;
      }
    };
  };
  workspaceFolder.WorkspaceFoldersFeature = WorkspaceFoldersFeature;
  return workspaceFolder;
}
var callHierarchy = {};
var hasRequiredCallHierarchy;
function requireCallHierarchy() {
  if (hasRequiredCallHierarchy) return callHierarchy;
  hasRequiredCallHierarchy = 1;
  Object.defineProperty(callHierarchy, "__esModule", { value: true });
  callHierarchy.CallHierarchyFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const CallHierarchyFeature = (Base) => {
    return class extends Base {
      get callHierarchy() {
        return {
          onPrepare: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.CallHierarchyPrepareRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), void 0);
            });
          },
          onIncomingCalls: (handler) => {
            const type = vscode_languageserver_protocol_1.CallHierarchyIncomingCallsRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          },
          onOutgoingCalls: (handler) => {
            const type = vscode_languageserver_protocol_1.CallHierarchyOutgoingCallsRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          }
        };
      }
    };
  };
  callHierarchy.CallHierarchyFeature = CallHierarchyFeature;
  return callHierarchy;
}
var showDocument = {};
var hasRequiredShowDocument;
function requireShowDocument() {
  if (hasRequiredShowDocument) return showDocument;
  hasRequiredShowDocument = 1;
  Object.defineProperty(showDocument, "__esModule", { value: true });
  showDocument.ShowDocumentFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const ShowDocumentFeature = (Base) => {
    return class extends Base {
      showDocument(params) {
        return this.connection.sendRequest(vscode_languageserver_protocol_1.ShowDocumentRequest.type, params);
      }
    };
  };
  showDocument.ShowDocumentFeature = ShowDocumentFeature;
  return showDocument;
}
var fileOperations = {};
var hasRequiredFileOperations;
function requireFileOperations() {
  if (hasRequiredFileOperations) return fileOperations;
  hasRequiredFileOperations = 1;
  Object.defineProperty(fileOperations, "__esModule", { value: true });
  fileOperations.FileOperationsFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const FileOperationsFeature = (Base) => {
    return class extends Base {
      onDidCreateFiles(handler) {
        return this.connection.onNotification(vscode_languageserver_protocol_1.DidCreateFilesNotification.type, (params) => {
          handler(params);
        });
      }
      onDidRenameFiles(handler) {
        return this.connection.onNotification(vscode_languageserver_protocol_1.DidRenameFilesNotification.type, (params) => {
          handler(params);
        });
      }
      onDidDeleteFiles(handler) {
        return this.connection.onNotification(vscode_languageserver_protocol_1.DidDeleteFilesNotification.type, (params) => {
          handler(params);
        });
      }
      onWillCreateFiles(handler) {
        return this.connection.onRequest(vscode_languageserver_protocol_1.WillCreateFilesRequest.type, (params, cancel) => {
          return handler(params, cancel);
        });
      }
      onWillRenameFiles(handler) {
        return this.connection.onRequest(vscode_languageserver_protocol_1.WillRenameFilesRequest.type, (params, cancel) => {
          return handler(params, cancel);
        });
      }
      onWillDeleteFiles(handler) {
        return this.connection.onRequest(vscode_languageserver_protocol_1.WillDeleteFilesRequest.type, (params, cancel) => {
          return handler(params, cancel);
        });
      }
    };
  };
  fileOperations.FileOperationsFeature = FileOperationsFeature;
  return fileOperations;
}
var linkedEditingRange = {};
var hasRequiredLinkedEditingRange;
function requireLinkedEditingRange() {
  if (hasRequiredLinkedEditingRange) return linkedEditingRange;
  hasRequiredLinkedEditingRange = 1;
  Object.defineProperty(linkedEditingRange, "__esModule", { value: true });
  linkedEditingRange.LinkedEditingRangeFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const LinkedEditingRangeFeature = (Base) => {
    return class extends Base {
      onLinkedEditingRange(handler) {
        return this.connection.onRequest(vscode_languageserver_protocol_1.LinkedEditingRangeRequest.type, (params, cancel) => {
          return handler(params, cancel, this.attachWorkDoneProgress(params), void 0);
        });
      }
    };
  };
  linkedEditingRange.LinkedEditingRangeFeature = LinkedEditingRangeFeature;
  return linkedEditingRange;
}
var typeHierarchy = {};
var hasRequiredTypeHierarchy;
function requireTypeHierarchy() {
  if (hasRequiredTypeHierarchy) return typeHierarchy;
  hasRequiredTypeHierarchy = 1;
  Object.defineProperty(typeHierarchy, "__esModule", { value: true });
  typeHierarchy.TypeHierarchyFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const TypeHierarchyFeature = (Base) => {
    return class extends Base {
      get typeHierarchy() {
        return {
          onPrepare: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.TypeHierarchyPrepareRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), void 0);
            });
          },
          onSupertypes: (handler) => {
            const type = vscode_languageserver_protocol_1.TypeHierarchySupertypesRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          },
          onSubtypes: (handler) => {
            const type = vscode_languageserver_protocol_1.TypeHierarchySubtypesRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          }
        };
      }
    };
  };
  typeHierarchy.TypeHierarchyFeature = TypeHierarchyFeature;
  return typeHierarchy;
}
var inlineValue = {};
var hasRequiredInlineValue;
function requireInlineValue() {
  if (hasRequiredInlineValue) return inlineValue;
  hasRequiredInlineValue = 1;
  Object.defineProperty(inlineValue, "__esModule", { value: true });
  inlineValue.InlineValueFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const InlineValueFeature = (Base) => {
    return class extends Base {
      get inlineValue() {
        return {
          refresh: () => {
            return this.connection.sendRequest(vscode_languageserver_protocol_1.InlineValueRefreshRequest.type);
          },
          on: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.InlineValueRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params));
            });
          }
        };
      }
    };
  };
  inlineValue.InlineValueFeature = InlineValueFeature;
  return inlineValue;
}
var foldingRange = {};
var hasRequiredFoldingRange;
function requireFoldingRange() {
  if (hasRequiredFoldingRange) return foldingRange;
  hasRequiredFoldingRange = 1;
  Object.defineProperty(foldingRange, "__esModule", { value: true });
  foldingRange.FoldingRangeFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const FoldingRangeFeature = (Base) => {
    return class extends Base {
      get foldingRange() {
        return {
          refresh: () => {
            return this.connection.sendRequest(vscode_languageserver_protocol_1.FoldingRangeRefreshRequest.type);
          },
          on: (handler) => {
            const type = vscode_languageserver_protocol_1.FoldingRangeRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          }
        };
      }
    };
  };
  foldingRange.FoldingRangeFeature = FoldingRangeFeature;
  return foldingRange;
}
var inlayHint = {};
var hasRequiredInlayHint;
function requireInlayHint() {
  if (hasRequiredInlayHint) return inlayHint;
  hasRequiredInlayHint = 1;
  Object.defineProperty(inlayHint, "__esModule", { value: true });
  inlayHint.InlayHintFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const InlayHintFeature = (Base) => {
    return class extends Base {
      get inlayHint() {
        return {
          refresh: () => {
            return this.connection.sendRequest(vscode_languageserver_protocol_1.InlayHintRefreshRequest.type);
          },
          on: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.InlayHintRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params));
            });
          },
          resolve: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.InlayHintResolveRequest.type, (params, cancel) => {
              return handler(params, cancel);
            });
          }
        };
      }
    };
  };
  inlayHint.InlayHintFeature = InlayHintFeature;
  return inlayHint;
}
var diagnostic = {};
var hasRequiredDiagnostic;
function requireDiagnostic() {
  if (hasRequiredDiagnostic) return diagnostic;
  hasRequiredDiagnostic = 1;
  Object.defineProperty(diagnostic, "__esModule", { value: true });
  diagnostic.DiagnosticFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const DiagnosticFeature = (Base) => {
    return class extends Base {
      get diagnostics() {
        return {
          refresh: () => {
            return this.connection.sendRequest(vscode_languageserver_protocol_1.DiagnosticRefreshRequest.type);
          },
          on: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.DocumentDiagnosticRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(vscode_languageserver_protocol_1.DocumentDiagnosticRequest.partialResult, params));
            });
          },
          onWorkspace: (handler) => {
            return this.connection.onRequest(vscode_languageserver_protocol_1.WorkspaceDiagnosticRequest.type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(vscode_languageserver_protocol_1.WorkspaceDiagnosticRequest.partialResult, params));
            });
          }
        };
      }
    };
  };
  diagnostic.DiagnosticFeature = DiagnosticFeature;
  return diagnostic;
}
var moniker = {};
var hasRequiredMoniker;
function requireMoniker() {
  if (hasRequiredMoniker) return moniker;
  hasRequiredMoniker = 1;
  Object.defineProperty(moniker, "__esModule", { value: true });
  moniker.MonikerFeature = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const MonikerFeature = (Base) => {
    return class extends Base {
      get moniker() {
        return {
          on: (handler) => {
            const type = vscode_languageserver_protocol_1.MonikerRequest.type;
            return this.connection.onRequest(type, (params, cancel) => {
              return handler(params, cancel, this.attachWorkDoneProgress(params), this.attachPartialResultProgress(type, params));
            });
          }
        };
      }
    };
  };
  moniker.MonikerFeature = MonikerFeature;
  return moniker;
}
var hasRequiredServer;
function requireServer() {
  if (hasRequiredServer) return server;
  hasRequiredServer = 1;
  Object.defineProperty(server, "__esModule", { value: true });
  server.createConnection = server.combineFeatures = server.combineNotebooksFeatures = server.combineLanguagesFeatures = server.combineWorkspaceFeatures = server.combineWindowFeatures = server.combineClientFeatures = server.combineTracerFeatures = server.combineTelemetryFeatures = server.combineConsoleFeatures = server._NotebooksImpl = server._LanguagesImpl = server.BulkUnregistration = server.BulkRegistration = server.ErrorMessageTracker = void 0;
  const vscode_languageserver_protocol_1 = requireMain$1$1();
  const Is2 = requireIs$3();
  const UUID = requireUuid();
  const progress_1 = requireProgress();
  const configuration_1 = requireConfiguration();
  const workspaceFolder_1 = requireWorkspaceFolder();
  const callHierarchy_1 = requireCallHierarchy();
  const semanticTokens_1 = requireSemanticTokens();
  const showDocument_1 = requireShowDocument();
  const fileOperations_1 = requireFileOperations();
  const linkedEditingRange_1 = requireLinkedEditingRange();
  const typeHierarchy_1 = requireTypeHierarchy();
  const inlineValue_1 = requireInlineValue();
  const foldingRange_1 = requireFoldingRange();
  const inlayHint_1 = requireInlayHint();
  const diagnostic_1 = requireDiagnostic();
  const notebook_1 = requireNotebook();
  const moniker_1 = requireMoniker();
  function null2Undefined(value) {
    if (value === null) {
      return void 0;
    }
    return value;
  }
  class ErrorMessageTracker {
    constructor() {
      this._messages = /* @__PURE__ */ Object.create(null);
    }
    /**
     * Add a message to the tracker.
     *
     * @param message The message to add.
     */
    add(message) {
      let count = this._messages[message];
      if (!count) {
        count = 0;
      }
      count++;
      this._messages[message] = count;
    }
    /**
     * Send all tracked messages to the connection's window.
     *
     * @param connection The connection established between client and server.
     */
    sendErrors(connection2) {
      Object.keys(this._messages).forEach((message) => {
        connection2.window.showErrorMessage(message);
      });
    }
  }
  server.ErrorMessageTracker = ErrorMessageTracker;
  class RemoteConsoleImpl {
    constructor() {
    }
    rawAttach(connection2) {
      this._rawConnection = connection2;
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    fillServerCapabilities(_capabilities) {
    }
    initialize(_capabilities) {
    }
    error(message) {
      this.send(vscode_languageserver_protocol_1.MessageType.Error, message);
    }
    warn(message) {
      this.send(vscode_languageserver_protocol_1.MessageType.Warning, message);
    }
    info(message) {
      this.send(vscode_languageserver_protocol_1.MessageType.Info, message);
    }
    log(message) {
      this.send(vscode_languageserver_protocol_1.MessageType.Log, message);
    }
    debug(message) {
      this.send(vscode_languageserver_protocol_1.MessageType.Debug, message);
    }
    send(type, message) {
      if (this._rawConnection) {
        this._rawConnection.sendNotification(vscode_languageserver_protocol_1.LogMessageNotification.type, { type, message }).catch(() => {
          (0, vscode_languageserver_protocol_1.RAL)().console.error(`Sending log message failed`);
        });
      }
    }
  }
  class _RemoteWindowImpl {
    constructor() {
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    showErrorMessage(message, ...actions) {
      let params = { type: vscode_languageserver_protocol_1.MessageType.Error, message, actions };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.ShowMessageRequest.type, params).then(null2Undefined);
    }
    showWarningMessage(message, ...actions) {
      let params = { type: vscode_languageserver_protocol_1.MessageType.Warning, message, actions };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.ShowMessageRequest.type, params).then(null2Undefined);
    }
    showInformationMessage(message, ...actions) {
      let params = { type: vscode_languageserver_protocol_1.MessageType.Info, message, actions };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.ShowMessageRequest.type, params).then(null2Undefined);
    }
  }
  const RemoteWindowImpl = (0, showDocument_1.ShowDocumentFeature)((0, progress_1.ProgressFeature)(_RemoteWindowImpl));
  var BulkRegistration;
  (function(BulkRegistration2) {
    function create2() {
      return new BulkRegistrationImpl();
    }
    BulkRegistration2.create = create2;
  })(BulkRegistration || (server.BulkRegistration = BulkRegistration = {}));
  class BulkRegistrationImpl {
    constructor() {
      this._registrations = [];
      this._registered = /* @__PURE__ */ new Set();
    }
    add(type, registerOptions) {
      const method = Is2.string(type) ? type : type.method;
      if (this._registered.has(method)) {
        throw new Error(`${method} is already added to this registration`);
      }
      const id2 = UUID.generateUuid();
      this._registrations.push({
        id: id2,
        method,
        registerOptions: registerOptions || {}
      });
      this._registered.add(method);
    }
    asRegistrationParams() {
      return {
        registrations: this._registrations
      };
    }
  }
  var BulkUnregistration;
  (function(BulkUnregistration2) {
    function create2() {
      return new BulkUnregistrationImpl(void 0, []);
    }
    BulkUnregistration2.create = create2;
  })(BulkUnregistration || (server.BulkUnregistration = BulkUnregistration = {}));
  class BulkUnregistrationImpl {
    constructor(_connection, unregistrations) {
      this._connection = _connection;
      this._unregistrations = /* @__PURE__ */ new Map();
      unregistrations.forEach((unregistration) => {
        this._unregistrations.set(unregistration.method, unregistration);
      });
    }
    get isAttached() {
      return !!this._connection;
    }
    attach(connection2) {
      this._connection = connection2;
    }
    add(unregistration) {
      this._unregistrations.set(unregistration.method, unregistration);
    }
    dispose() {
      let unregistrations = [];
      for (let unregistration of this._unregistrations.values()) {
        unregistrations.push(unregistration);
      }
      let params = {
        unregisterations: unregistrations
      };
      this._connection.sendRequest(vscode_languageserver_protocol_1.UnregistrationRequest.type, params).catch(() => {
        this._connection.console.info(`Bulk unregistration failed.`);
      });
    }
    disposeSingle(arg) {
      const method = Is2.string(arg) ? arg : arg.method;
      const unregistration = this._unregistrations.get(method);
      if (!unregistration) {
        return false;
      }
      let params = {
        unregisterations: [unregistration]
      };
      this._connection.sendRequest(vscode_languageserver_protocol_1.UnregistrationRequest.type, params).then(() => {
        this._unregistrations.delete(method);
      }, (_error) => {
        this._connection.console.info(`Un-registering request handler for ${unregistration.id} failed.`);
      });
      return true;
    }
  }
  class RemoteClientImpl {
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    register(typeOrRegistrations, registerOptionsOrType, registerOptions) {
      if (typeOrRegistrations instanceof BulkRegistrationImpl) {
        return this.registerMany(typeOrRegistrations);
      } else if (typeOrRegistrations instanceof BulkUnregistrationImpl) {
        return this.registerSingle1(typeOrRegistrations, registerOptionsOrType, registerOptions);
      } else {
        return this.registerSingle2(typeOrRegistrations, registerOptionsOrType);
      }
    }
    registerSingle1(unregistration, type, registerOptions) {
      const method = Is2.string(type) ? type : type.method;
      const id2 = UUID.generateUuid();
      let params = {
        registrations: [{ id: id2, method, registerOptions: registerOptions || {} }]
      };
      if (!unregistration.isAttached) {
        unregistration.attach(this.connection);
      }
      return this.connection.sendRequest(vscode_languageserver_protocol_1.RegistrationRequest.type, params).then((_result) => {
        unregistration.add({ id: id2, method });
        return unregistration;
      }, (_error) => {
        this.connection.console.info(`Registering request handler for ${method} failed.`);
        return Promise.reject(_error);
      });
    }
    registerSingle2(type, registerOptions) {
      const method = Is2.string(type) ? type : type.method;
      const id2 = UUID.generateUuid();
      let params = {
        registrations: [{ id: id2, method, registerOptions: registerOptions || {} }]
      };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.RegistrationRequest.type, params).then((_result) => {
        return vscode_languageserver_protocol_1.Disposable.create(() => {
          this.unregisterSingle(id2, method).catch(() => {
            this.connection.console.info(`Un-registering capability with id ${id2} failed.`);
          });
        });
      }, (_error) => {
        this.connection.console.info(`Registering request handler for ${method} failed.`);
        return Promise.reject(_error);
      });
    }
    unregisterSingle(id2, method) {
      let params = {
        unregisterations: [{ id: id2, method }]
      };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.UnregistrationRequest.type, params).catch(() => {
        this.connection.console.info(`Un-registering request handler for ${id2} failed.`);
      });
    }
    registerMany(registrations) {
      let params = registrations.asRegistrationParams();
      return this.connection.sendRequest(vscode_languageserver_protocol_1.RegistrationRequest.type, params).then(() => {
        return new BulkUnregistrationImpl(this._connection, params.registrations.map((registration) => {
          return { id: registration.id, method: registration.method };
        }));
      }, (_error) => {
        this.connection.console.info(`Bulk registration failed.`);
        return Promise.reject(_error);
      });
    }
  }
  class _RemoteWorkspaceImpl {
    constructor() {
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    applyEdit(paramOrEdit) {
      function isApplyWorkspaceEditParams(value) {
        return value && !!value.edit;
      }
      let params = isApplyWorkspaceEditParams(paramOrEdit) ? paramOrEdit : { edit: paramOrEdit };
      return this.connection.sendRequest(vscode_languageserver_protocol_1.ApplyWorkspaceEditRequest.type, params);
    }
  }
  const RemoteWorkspaceImpl = (0, fileOperations_1.FileOperationsFeature)((0, workspaceFolder_1.WorkspaceFoldersFeature)((0, configuration_1.ConfigurationFeature)(_RemoteWorkspaceImpl)));
  class TracerImpl {
    constructor() {
      this._trace = vscode_languageserver_protocol_1.Trace.Off;
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    set trace(value) {
      this._trace = value;
    }
    log(message, verbose2) {
      if (this._trace === vscode_languageserver_protocol_1.Trace.Off) {
        return;
      }
      this.connection.sendNotification(vscode_languageserver_protocol_1.LogTraceNotification.type, {
        message,
        verbose: this._trace === vscode_languageserver_protocol_1.Trace.Verbose ? verbose2 : void 0
      }).catch(() => {
      });
    }
  }
  class TelemetryImpl {
    constructor() {
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    logEvent(data) {
      this.connection.sendNotification(vscode_languageserver_protocol_1.TelemetryEventNotification.type, data).catch(() => {
        this.connection.console.log(`Sending TelemetryEventNotification failed`);
      });
    }
  }
  class _LanguagesImpl {
    constructor() {
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    attachWorkDoneProgress(params) {
      return (0, progress_1.attachWorkDone)(this.connection, params);
    }
    attachPartialResultProgress(_type, params) {
      return (0, progress_1.attachPartialResult)(this.connection, params);
    }
  }
  server._LanguagesImpl = _LanguagesImpl;
  const LanguagesImpl = (0, foldingRange_1.FoldingRangeFeature)((0, moniker_1.MonikerFeature)((0, diagnostic_1.DiagnosticFeature)((0, inlayHint_1.InlayHintFeature)((0, inlineValue_1.InlineValueFeature)((0, typeHierarchy_1.TypeHierarchyFeature)((0, linkedEditingRange_1.LinkedEditingRangeFeature)((0, semanticTokens_1.SemanticTokensFeature)((0, callHierarchy_1.CallHierarchyFeature)(_LanguagesImpl)))))))));
  class _NotebooksImpl {
    constructor() {
    }
    attach(connection2) {
      this._connection = connection2;
    }
    get connection() {
      if (!this._connection) {
        throw new Error("Remote is not attached to a connection yet.");
      }
      return this._connection;
    }
    initialize(_capabilities) {
    }
    fillServerCapabilities(_capabilities) {
    }
    attachWorkDoneProgress(params) {
      return (0, progress_1.attachWorkDone)(this.connection, params);
    }
    attachPartialResultProgress(_type, params) {
      return (0, progress_1.attachPartialResult)(this.connection, params);
    }
  }
  server._NotebooksImpl = _NotebooksImpl;
  const NotebooksImpl = (0, notebook_1.NotebookSyncFeature)(_NotebooksImpl);
  function combineConsoleFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineConsoleFeatures = combineConsoleFeatures;
  function combineTelemetryFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineTelemetryFeatures = combineTelemetryFeatures;
  function combineTracerFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineTracerFeatures = combineTracerFeatures;
  function combineClientFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineClientFeatures = combineClientFeatures;
  function combineWindowFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineWindowFeatures = combineWindowFeatures;
  function combineWorkspaceFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineWorkspaceFeatures = combineWorkspaceFeatures;
  function combineLanguagesFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineLanguagesFeatures = combineLanguagesFeatures;
  function combineNotebooksFeatures(one, two) {
    return function(Base) {
      return two(one(Base));
    };
  }
  server.combineNotebooksFeatures = combineNotebooksFeatures;
  function combineFeatures(one, two) {
    function combine(one2, two2, func) {
      if (one2 && two2) {
        return func(one2, two2);
      } else if (one2) {
        return one2;
      } else {
        return two2;
      }
    }
    let result2 = {
      __brand: "features",
      console: combine(one.console, two.console, combineConsoleFeatures),
      tracer: combine(one.tracer, two.tracer, combineTracerFeatures),
      telemetry: combine(one.telemetry, two.telemetry, combineTelemetryFeatures),
      client: combine(one.client, two.client, combineClientFeatures),
      window: combine(one.window, two.window, combineWindowFeatures),
      workspace: combine(one.workspace, two.workspace, combineWorkspaceFeatures),
      languages: combine(one.languages, two.languages, combineLanguagesFeatures),
      notebooks: combine(one.notebooks, two.notebooks, combineNotebooksFeatures)
    };
    return result2;
  }
  server.combineFeatures = combineFeatures;
  function createConnection(connectionFactory, watchDog, factories) {
    const logger = factories && factories.console ? new (factories.console(RemoteConsoleImpl))() : new RemoteConsoleImpl();
    const connection2 = connectionFactory(logger);
    logger.rawAttach(connection2);
    const tracer = factories && factories.tracer ? new (factories.tracer(TracerImpl))() : new TracerImpl();
    const telemetry = factories && factories.telemetry ? new (factories.telemetry(TelemetryImpl))() : new TelemetryImpl();
    const client2 = factories && factories.client ? new (factories.client(RemoteClientImpl))() : new RemoteClientImpl();
    const remoteWindow = factories && factories.window ? new (factories.window(RemoteWindowImpl))() : new RemoteWindowImpl();
    const workspace = factories && factories.workspace ? new (factories.workspace(RemoteWorkspaceImpl))() : new RemoteWorkspaceImpl();
    const languages2 = factories && factories.languages ? new (factories.languages(LanguagesImpl))() : new LanguagesImpl();
    const notebooks = factories && factories.notebooks ? new (factories.notebooks(NotebooksImpl))() : new NotebooksImpl();
    const allRemotes = [logger, tracer, telemetry, client2, remoteWindow, workspace, languages2, notebooks];
    function asPromise(value) {
      if (value instanceof Promise) {
        return value;
      } else if (Is2.thenable(value)) {
        return new Promise((resolve, reject2) => {
          value.then((resolved) => resolve(resolved), (error) => reject2(error));
        });
      } else {
        return Promise.resolve(value);
      }
    }
    let shutdownHandler = void 0;
    let initializeHandler = void 0;
    let exitHandler = void 0;
    let protocolConnection = {
      listen: () => connection2.listen(),
      sendRequest: (type, ...params) => connection2.sendRequest(Is2.string(type) ? type : type.method, ...params),
      onRequest: (type, handler) => connection2.onRequest(type, handler),
      sendNotification: (type, param) => {
        const method = Is2.string(type) ? type : type.method;
        return connection2.sendNotification(method, param);
      },
      onNotification: (type, handler) => connection2.onNotification(type, handler),
      onProgress: connection2.onProgress,
      sendProgress: connection2.sendProgress,
      onInitialize: (handler) => {
        initializeHandler = handler;
        return {
          dispose: () => {
            initializeHandler = void 0;
          }
        };
      },
      onInitialized: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.InitializedNotification.type, handler),
      onShutdown: (handler) => {
        shutdownHandler = handler;
        return {
          dispose: () => {
            shutdownHandler = void 0;
          }
        };
      },
      onExit: (handler) => {
        exitHandler = handler;
        return {
          dispose: () => {
            exitHandler = void 0;
          }
        };
      },
      get console() {
        return logger;
      },
      get telemetry() {
        return telemetry;
      },
      get tracer() {
        return tracer;
      },
      get client() {
        return client2;
      },
      get window() {
        return remoteWindow;
      },
      get workspace() {
        return workspace;
      },
      get languages() {
        return languages2;
      },
      get notebooks() {
        return notebooks;
      },
      onDidChangeConfiguration: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidChangeConfigurationNotification.type, handler),
      onDidChangeWatchedFiles: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidChangeWatchedFilesNotification.type, handler),
      __textDocumentSync: void 0,
      onDidOpenTextDocument: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidOpenTextDocumentNotification.type, handler),
      onDidChangeTextDocument: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidChangeTextDocumentNotification.type, handler),
      onDidCloseTextDocument: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidCloseTextDocumentNotification.type, handler),
      onWillSaveTextDocument: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.WillSaveTextDocumentNotification.type, handler),
      onWillSaveTextDocumentWaitUntil: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.WillSaveTextDocumentWaitUntilRequest.type, handler),
      onDidSaveTextDocument: (handler) => connection2.onNotification(vscode_languageserver_protocol_1.DidSaveTextDocumentNotification.type, handler),
      sendDiagnostics: (params) => connection2.sendNotification(vscode_languageserver_protocol_1.PublishDiagnosticsNotification.type, params),
      onHover: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.HoverRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      onCompletion: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CompletionRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onCompletionResolve: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CompletionResolveRequest.type, handler),
      onSignatureHelp: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.SignatureHelpRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      onDeclaration: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DeclarationRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onDefinition: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DefinitionRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onTypeDefinition: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.TypeDefinitionRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onImplementation: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.ImplementationRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onReferences: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.ReferencesRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onDocumentHighlight: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentHighlightRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onDocumentSymbol: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentSymbolRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onWorkspaceSymbol: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.WorkspaceSymbolRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onWorkspaceSymbolResolve: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.WorkspaceSymbolResolveRequest.type, handler),
      onCodeAction: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CodeActionRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onCodeActionResolve: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CodeActionResolveRequest.type, (params, cancel) => {
        return handler(params, cancel);
      }),
      onCodeLens: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CodeLensRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onCodeLensResolve: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.CodeLensResolveRequest.type, (params, cancel) => {
        return handler(params, cancel);
      }),
      onDocumentFormatting: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentFormattingRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      onDocumentRangeFormatting: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentRangeFormattingRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      onDocumentOnTypeFormatting: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentOnTypeFormattingRequest.type, (params, cancel) => {
        return handler(params, cancel);
      }),
      onRenameRequest: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.RenameRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      onPrepareRename: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.PrepareRenameRequest.type, (params, cancel) => {
        return handler(params, cancel);
      }),
      onDocumentLinks: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentLinkRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onDocumentLinkResolve: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentLinkResolveRequest.type, (params, cancel) => {
        return handler(params, cancel);
      }),
      onDocumentColor: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.DocumentColorRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onColorPresentation: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.ColorPresentationRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onFoldingRanges: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.FoldingRangeRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onSelectionRanges: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.SelectionRangeRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), (0, progress_1.attachPartialResult)(connection2, params));
      }),
      onExecuteCommand: (handler) => connection2.onRequest(vscode_languageserver_protocol_1.ExecuteCommandRequest.type, (params, cancel) => {
        return handler(params, cancel, (0, progress_1.attachWorkDone)(connection2, params), void 0);
      }),
      dispose: () => connection2.dispose()
    };
    for (let remote of allRemotes) {
      remote.attach(protocolConnection);
    }
    connection2.onRequest(vscode_languageserver_protocol_1.InitializeRequest.type, (params) => {
      watchDog.initialize(params);
      if (Is2.string(params.trace)) {
        tracer.trace = vscode_languageserver_protocol_1.Trace.fromString(params.trace);
      }
      for (let remote of allRemotes) {
        remote.initialize(params.capabilities);
      }
      if (initializeHandler) {
        let result2 = initializeHandler(params, new vscode_languageserver_protocol_1.CancellationTokenSource().token, (0, progress_1.attachWorkDone)(connection2, params), void 0);
        return asPromise(result2).then((value) => {
          if (value instanceof vscode_languageserver_protocol_1.ResponseError) {
            return value;
          }
          let result3 = value;
          if (!result3) {
            result3 = { capabilities: {} };
          }
          let capabilities = result3.capabilities;
          if (!capabilities) {
            capabilities = {};
            result3.capabilities = capabilities;
          }
          if (capabilities.textDocumentSync === void 0 || capabilities.textDocumentSync === null) {
            capabilities.textDocumentSync = Is2.number(protocolConnection.__textDocumentSync) ? protocolConnection.__textDocumentSync : vscode_languageserver_protocol_1.TextDocumentSyncKind.None;
          } else if (!Is2.number(capabilities.textDocumentSync) && !Is2.number(capabilities.textDocumentSync.change)) {
            capabilities.textDocumentSync.change = Is2.number(protocolConnection.__textDocumentSync) ? protocolConnection.__textDocumentSync : vscode_languageserver_protocol_1.TextDocumentSyncKind.None;
          }
          for (let remote of allRemotes) {
            remote.fillServerCapabilities(capabilities);
          }
          return result3;
        });
      } else {
        let result2 = { capabilities: { textDocumentSync: vscode_languageserver_protocol_1.TextDocumentSyncKind.None } };
        for (let remote of allRemotes) {
          remote.fillServerCapabilities(result2.capabilities);
        }
        return result2;
      }
    });
    connection2.onRequest(vscode_languageserver_protocol_1.ShutdownRequest.type, () => {
      watchDog.shutdownReceived = true;
      if (shutdownHandler) {
        return shutdownHandler(new vscode_languageserver_protocol_1.CancellationTokenSource().token);
      } else {
        return void 0;
      }
    });
    connection2.onNotification(vscode_languageserver_protocol_1.ExitNotification.type, () => {
      try {
        if (exitHandler) {
          exitHandler();
        }
      } finally {
        if (watchDog.shutdownReceived) {
          watchDog.exit(0);
        } else {
          watchDog.exit(1);
        }
      }
    });
    connection2.onNotification(vscode_languageserver_protocol_1.SetTraceNotification.type, (params) => {
      tracer.trace = vscode_languageserver_protocol_1.Trace.fromString(params.value);
    });
    return protocolConnection;
  }
  server.createConnection = createConnection;
  return server;
}
var hasRequiredApi$3;
function requireApi$3() {
  if (hasRequiredApi$3) return api$2;
  hasRequiredApi$3 = 1;
  (function(exports2) {
    var __createBinding = api$2 && api$2.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = api$2 && api$2.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ProposedFeatures = exports2.NotebookDocuments = exports2.TextDocuments = exports2.SemanticTokensBuilder = void 0;
    const semanticTokens_1 = requireSemanticTokens();
    Object.defineProperty(exports2, "SemanticTokensBuilder", { enumerable: true, get: function() {
      return semanticTokens_1.SemanticTokensBuilder;
    } });
    const ic = requireInlineCompletion_proposed();
    __exportStar(requireMain$1$1(), exports2);
    const textDocuments_1 = requireTextDocuments();
    Object.defineProperty(exports2, "TextDocuments", { enumerable: true, get: function() {
      return textDocuments_1.TextDocuments;
    } });
    const notebook_1 = requireNotebook();
    Object.defineProperty(exports2, "NotebookDocuments", { enumerable: true, get: function() {
      return notebook_1.NotebookDocuments;
    } });
    __exportStar(requireServer(), exports2);
    var ProposedFeatures;
    (function(ProposedFeatures2) {
      ProposedFeatures2.all = {
        __brand: "features",
        languages: ic.InlineCompletionFeature
      };
    })(ProposedFeatures || (exports2.ProposedFeatures = ProposedFeatures = {}));
  })(api$2);
  return api$2;
}
var browser$1$1;
var hasRequiredBrowser$1$1;
function requireBrowser$1$1() {
  if (hasRequiredBrowser$1$1) return browser$1$1;
  hasRequiredBrowser$1$1 = 1;
  browser$1$1 = requireMain$1$1();
  return browser$1$1;
}
var hasRequiredMain$3;
function requireMain$3() {
  if (hasRequiredMain$3) return main$3;
  hasRequiredMain$3 = 1;
  (function(exports2) {
    var __createBinding = main$3 && main$3.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = main$3 && main$3.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createConnection = void 0;
    const api_1 = requireApi$3();
    __exportStar(requireBrowser$1$1(), exports2);
    __exportStar(requireApi$3(), exports2);
    let _shutdownReceived = false;
    const watchDog = {
      initialize: (_params) => {
      },
      get shutdownReceived() {
        return _shutdownReceived;
      },
      set shutdownReceived(value) {
        _shutdownReceived = value;
      },
      exit: (_code) => {
      }
    };
    function createConnection(arg1, arg2, arg3, arg4) {
      let factories;
      let reader;
      let writer;
      let options2;
      if (arg1 !== void 0 && arg1.__brand === "features") {
        factories = arg1;
        arg1 = arg2;
        arg2 = arg3;
        arg3 = arg4;
      }
      if (api_1.ConnectionStrategy.is(arg1) || api_1.ConnectionOptions.is(arg1)) {
        options2 = arg1;
      } else {
        reader = arg1;
        writer = arg2;
        options2 = arg3;
      }
      const connectionFactory = (logger) => {
        return (0, api_1.createProtocolConnection)(reader, writer, logger, options2);
      };
      return (0, api_1.createConnection)(connectionFactory, watchDog, factories);
    }
    exports2.createConnection = createConnection;
  })(main$3);
  return main$3;
}
var browser$4;
var hasRequiredBrowser$3;
function requireBrowser$3() {
  if (hasRequiredBrowser$3) return browser$4;
  hasRequiredBrowser$3 = 1;
  browser$4 = requireMain$3();
  return browser$4;
}
var browserExports$1 = requireBrowser$3();
function initOffsetToRowCache() {
  return createOffsetToPositionMap(this.source);
}
function initRowToOffsetCache() {
  const source = this.source || "";
  const numLines = (String(source).match(/\n/g) || "").length + 1;
  const rowToOffset = new Uint32Array(numLines);
  const len = source.length;
  let currentRow = 0;
  rowToOffset[0] = 0;
  for (let i2 = 0; i2 < len; i2++) {
    if (source.charAt(i2) === "\n") {
      currentRow += 1;
      rowToOffset[currentRow] = i2 + 1;
    }
  }
  return rowToOffset;
}
function initLezer() {
  return stringToLezer(this.source || "");
}
function initLezerCursor() {
  const lezer = this._lezer();
  return lezer.cursor();
}
function initDast() {
  return lezerToDast(this._lezer(), this.source);
}
function initParentMap() {
  const parentMap = /* @__PURE__ */ new Map();
  for (const node2 of this.dast.children) {
    parentMap.set(node2, this.dast);
  }
  visit(this.dast, (_node) => {
    const node2 = _node;
    if (node2.type === "element") {
      for (const child of node2.children) {
        parentMap.set(child, node2);
      }
    }
  });
  return parentMap;
}
function initOffsetToNodeMapRight() {
  const dast = this.dast;
  const offsetToNodeMap = new Array(
    this.source.length
  ).fill(null);
  visit(dast, (_node) => {
    const node2 = _node;
    if (node2.type === "error") {
      return;
    }
    if (!node2.position) {
      return;
    }
    const { start, end } = node2.position;
    if (start.offset == null || end.offset == null) {
      return;
    }
    for (let i2 = start.offset; i2 < end.offset; i2++) {
      offsetToNodeMap[i2] = node2;
    }
  });
  return offsetToNodeMap;
}
function initOffsetToNodeMapLeft() {
  const dast = this.dast;
  const offsetToNodeMap = [dast, ...this._offsetToNodeMapRight()];
  offsetToNodeMap.pop();
  return offsetToNodeMap;
}
function initOffsetToNodeIndexMap() {
  const nodeToIndexMap = /* @__PURE__ */ new Map();
  const containingElementMap = /* @__PURE__ */ new Map();
  const dast = this.dast;
  let nextIndex = 0;
  const assignIndices = (node2, containingElement) => {
    const nextContaining = node2.type === "element" ? node2 : containingElement;
    containingElementMap.set(node2, nextContaining);
    if (node2.type === "element") {
      nodeToIndexMap.set(node2, nextIndex++);
      for (const child of node2.children) {
        assignIndices(child, node2);
      }
    }
  };
  nodeToIndexMap.set(dast, nextIndex++);
  for (const child of dast.children) {
    assignIndices(child, dast);
  }
  const offsetToNodeMap = this._offsetToNodeMapRight();
  const offsetToIndexMap = offsetToNodeMap.map((node2) => {
    if (!node2) {
      return null;
    }
    const target = node2.type === "element" ? node2 : containingElementMap.get(node2) ?? dast;
    return nodeToIndexMap.get(target) ?? null;
  });
  return offsetToIndexMap;
}
function initDescendantNamesMap() {
  const dast = this.dast;
  const namesInScope = /* @__PURE__ */ new Map();
  const rootAccessList = [];
  namesInScope.set(dast, rootAccessList);
  visit(dast, (_node, info) => {
    const node2 = _node;
    if (!(node2.type === "element")) {
      return;
    }
    if (!namesInScope.has(node2)) {
      namesInScope.set(node2, []);
    }
    const nameAttr = node2.attributes["name"];
    if (!nameAttr) {
      return;
    }
    const name2 = toXml(nameAttr.children);
    for (const _parent of info.parents) {
      const parent = _parent;
      if (!namesInScope.has(parent)) {
        namesInScope.set(parent, []);
      }
      const accessList = namesInScope.get(parent);
      accessList.push({ name: name2, element: node2 });
    }
    rootAccessList.push({ name: name2, element: node2 });
  });
  return namesInScope;
}
function createOffsetToPositionMap(source) {
  if (!source) {
    source = "";
  }
  const rowMap = new Uint32Array(source.length + 1);
  const columnMap = new Uint32Array(source.length + 1);
  const len = source.length;
  let currentRow = 0;
  let currentColumn = 0;
  for (let i2 = 0; i2 < len; i2++) {
    rowMap[i2] = currentRow;
    columnMap[i2] = currentColumn;
    if (source.charAt(i2) === "\n") {
      currentRow += 1;
      currentColumn = 0;
    } else {
      currentColumn += 1;
    }
  }
  rowMap[len] = currentRow;
  columnMap[len] = currentColumn;
  return { rowMap, columnMap };
}
function uninitializedLazyData() {
  return { type: "lazy-data", init: false, data: null };
}
function initializedLazyData(data) {
  return { type: "lazy-data", init: true, data };
}
function resetLazyData(lazyData) {
  lazyData.init = false;
  lazyData.data = null;
}
function isLazyData(obj) {
  return typeof obj === "object" && obj != null && obj.type === "lazy-data";
}
class LazyDataObject {
  constructor() {
    this._lazyData = {};
  }
  /**
   * Clear all stale data to force a recompute next time it's used.
   */
  _clearLazyData() {
    for (const [name2, val] of Object.entries(this._lazyData)) {
      resetLazyData(val);
    }
  }
  /**
   * Create a `getter` function for lazily computed data. You must pass in the name of the
   */
  _lazyDataGetter(initFunction) {
    const cacheName = generateNameFromInitializer(
      initFunction,
      this._lazyData
    );
    this._lazyData[cacheName] = uninitializedLazyData();
    return function getter() {
      if (!(cacheName in this._lazyData)) {
        throw new Error(
          `Lazy data cache object named "${cacheName}" not found`
        );
      }
      const lazyData = this._lazyData[cacheName];
      if (!isLazyData(lazyData)) {
        throw new Error(
          `Asked to treat "${cacheName}" as a lazy data but it appears not to be`
        );
      }
      if (!lazyData.init) {
        this._lazyData[cacheName] = initializedLazyData(
          initFunction.call(this)
        );
        return getter.call(this);
      }
      return lazyData.data;
    };
  }
}
function generateNameFromInitializer(fn2, existingNames) {
  const fnSource = fn2.toString();
  let name2 = (fnSource.replace("function ", "").replace(/\(.*/, "").split("\n")[0] || "").replace(/^(_?)init/, "");
  while (name2 in existingNames) {
    name2 += "_";
  }
  return name2;
}
function elementAtOffsetWithContext(offset2) {
  if (typeof offset2 !== "number") {
    offset2 = this.rowColToOffset(offset2);
  }
  let cursorPosition = "unknown";
  let cursorIsTopLevelBody = false;
  const prevChar2 = this.source.charAt(offset2 - 1);
  const exactNodeAtOffset = this.nodeAtOffset(offset2);
  const parent = exactNodeAtOffset ? this.getParent(exactNodeAtOffset) : null;
  let node2 = this.nodeAtOffset(offset2, {
    type: "element"
  });
  const leftLezerCursor = this._lezerCursor();
  leftLezerCursor.moveTo(offset2, -1);
  const leftLezerNodeParentName = leftLezerCursor.node.parent?.type?.name;
  const atOpenTagNameEnd = leftLezerCursor.node.type.name === "TagName" && (leftLezerNodeParentName === "OpenTag" || leftLezerNodeParentName === "SelfClosingTag");
  if (exactNodeAtOffset && exactNodeAtOffset !== node2 || !exactNodeAtOffset || !parent || node2?.type === "element" && node2.name === "" && parent.type === "root") {
    cursorPosition = "body";
  }
  if (node2?.type === "element" && node2.position?.start?.offset === offset2 && !atOpenTagNameEnd) {
    cursorPosition = "body";
    const isNamedElement = node2.name !== "";
    if (parent?.type === "element") {
      node2 = parent;
    } else {
      node2 = null;
      cursorIsTopLevelBody = parent?.type === "root" && isNamedElement;
    }
  }
  if (!node2 && !cursorIsTopLevelBody) {
    cursorPosition = "unknown";
  }
  if (node2 && cursorPosition === "unknown") {
    const cursor2 = this._lezerCursor();
    cursor2.moveTo(offset2, -1);
    const leftNode = cursor2.node;
    cursor2.moveTo(offset2, 1);
    const rightNode = cursor2.node;
    const atNodeBoundary = leftNode.index !== rightNode.index;
    const lezerNode = atNodeBoundary ? prevChar2.match(/\w/) ? leftNode : rightNode : leftNode;
    const rightNodeType = rightNode.type.name;
    if (atNodeBoundary && rightNodeType === "StartCloseTag" && !atOpenTagNameEnd) {
      cursorPosition = "body";
      const leftElement = this.nodeAtOffset(leftNode.from, {
        type: "element"
      });
      const leftParentType = leftNode.parent?.type?.name;
      if (leftElement && (leftParentType === "CloseTag" || leftParentType === "SelfClosingTag")) {
        const parentElement = this.getParent(leftElement);
        node2 = parentElement?.type === "element" ? parentElement : null;
      } else {
        node2 = leftElement;
      }
    } else {
      const lezerNodeType = lezerNode.type.name;
      const lezerNodeParentType = lezerNode.parent?.type?.name;
      switch (lezerNodeType) {
        case "TagName": {
          if (lezerNodeParentType === "OpenTag" || lezerNodeParentType === "SelfClosingTag") {
            cursorPosition = "openTagName";
            const tagOwner = this.nodeAtOffset(lezerNode.from, {
              type: "element"
            });
            if (tagOwner) {
              node2 = tagOwner;
            }
          } else {
            cursorPosition = "closeTagName";
          }
          break;
        }
        case "AttributeName":
          cursorPosition = "attributeName";
          break;
        case "AttributeValue": {
          const firstChar = this.source.charAt(lezerNode.from);
          cursorPosition = firstChar === '"' || firstChar === "'" ? "attributeValue" : "attributeName";
          break;
        }
        case "OpenTag":
        case "SelfClosingTag":
        case "SelfCloseEndTag":
          cursorPosition = "openTag";
          break;
        case "EndTag":
          if (lezerNodeParentType === "OpenTag" || lezerNodeParentType === "SelfClosingTag") {
            cursorPosition = "openTag";
          } else if (!prevChar2.match(/(\s|\n)/)) {
            cursorPosition = "closeTagName";
          } else {
            cursorPosition = "unknown";
          }
          break;
        case "StartCloseTag":
          cursorPosition = "closeTagName";
          break;
      }
    }
  }
  if (!node2 && prevChar2.match(/(\w|<)/)) {
    return this.elementAtOffsetWithContext(offset2 - 1);
  }
  const prevCharIsWhitespace = Boolean(prevChar2.match(/(\s|\n)/));
  let prevNonWhitespaceCharOffset = offset2 - 1;
  while (this.source.charAt(prevNonWhitespaceCharOffset).match(/(\s|\n)/)) {
    prevNonWhitespaceCharOffset -= 1;
  }
  const prevNonWhitespaceChar = this.source.charAt(
    prevNonWhitespaceCharOffset
  );
  if (cursorPosition === "body" && prevCharIsWhitespace) {
    const precedingNode = this.nodeAtOffset(offset2 - 1);
    if (precedingNode && precedingNode.type === "element") {
      node2 = precedingNode;
    }
  }
  if (!node2 && cursorPosition === "unknown" && prevCharIsWhitespace) {
    if (prevNonWhitespaceChar !== ">") {
      const precedingNode = this.nodeAtOffset(
        prevNonWhitespaceCharOffset
      );
      if (precedingNode && precedingNode.type === "element") {
        node2 = precedingNode;
      }
    }
  }
  if (node2 && cursorPosition === "unknown" && prevCharIsWhitespace) {
    const cursor2 = this._lezerCursor();
    cursor2.moveTo(prevNonWhitespaceCharOffset, 1);
    const lezerNodeType = cursor2.node.type.name;
    const lezerNodeParentType = cursor2.node.parent?.type?.name;
    switch (lezerNodeType) {
      case "TagName": {
        if (lezerNodeParentType === "CloseTag") {
          break;
        }
      }
      case "Attribute":
      case "AttributeName":
      case "AttributeValue":
        cursorPosition = "openTag";
        break;
    }
  }
  if (node2?.type !== "element") {
    node2 = null;
  }
  if (node2 && node2.name === "") {
    if (cursorPosition === "body") {
      const parent2 = this.getParent(node2);
      if (parent2?.type === "element") {
        node2 = parent2;
      } else {
        node2 = null;
        cursorPosition = "unknown";
      }
    } else if (offset2 > 0) {
      return this.elementAtOffsetWithContext(offset2 - 1);
    } else {
      return { node: null, cursorPosition: "unknown" };
    }
  }
  return { node: node2, cursorPosition };
}
function getMacroReferentAtOffset(offset2, macro) {
  const [pathPart, ...restPath] = macro.path;
  if (!pathPart) {
    return null;
  }
  if (pathPart.index.length > 0) {
    throw new Error(
      `The first part of a macro path must be just a name without an index. Failed to resolve "${toXml(
        macro
      )}"`
    );
  }
  let referent = this.getReferentAtOffset(offset2, pathPart.name);
  if (!referent) {
    return null;
  }
  if (restPath.length === 0) {
    return {
      node: referent,
      unresolvedPath: []
    };
  }
  let currReferent = referent;
  for (let i2 = 0; i2 < restPath.length; i2++) {
    const part = restPath[i2];
    if (part.index.length > 0) {
      return {
        node: referent,
        unresolvedPath: restPath.slice(i2)
      };
    }
    const propReferent = this.getNamedDescendant(currReferent, part.name);
    if (!propReferent) {
      return {
        node: referent,
        unresolvedPath: restPath.slice(i2)
      };
    }
    referent = propReferent;
    currReferent = propReferent;
  }
  return {
    node: referent,
    unresolvedPath: []
  };
}
function getAddressableNamesAtOffset(offset2) {
  const currElement = this.elementAtOffsetWithContext(offset2).node || this.dast;
  const descendantNamesMap = this._descendantNamesMap();
  const addressableChildren = getMacroAddressableChildrenAtElement(
    currElement,
    descendantNamesMap
  );
  const parents = this.getParents(currElement);
  const addressableParents = parents.map(
    (ancestor) => getMacroAddressableChildrenAtElement(ancestor, descendantNamesMap)
  );
  return mergeLeftUniquePrefixes(addressableChildren, addressableParents);
}
function getMacroAddressableChildrenAtElement(currElement, descendantNamesMap) {
  const accessList = descendantNamesMap.get(currElement);
  if (!accessList) {
    throw new Error(
      `Expected accessList to be defined for ${currElement.type === "root" ? "root" : currElement.name}`
    );
  }
  const ret = [];
  const addressableNames = new Set(
    filterUnique(accessList.map((n2) => n2.name))
  );
  for (const name2 of addressableNames) {
    ret.push([name2]);
  }
  for (const { name: name2, element: element2 } of accessList.filter(
    (n2) => addressableNames.has(n2.name)
  )) {
    const childNames = getMacroAddressableChildrenAtElement(
      element2,
      descendantNamesMap
    );
    ret.push(...childNames.map((childName) => [name2, ...childName]));
  }
  return ret;
}
function filterUnique(names) {
  const counts = /* @__PURE__ */ new Map();
  for (const name2 of names) {
    counts.set(name2, (counts.get(name2) || 0) + 1);
  }
  return names.filter((name2) => counts.get(name2) === 1);
}
function mergeLeftUniquePrefixes(base2, toMerge) {
  const ret = [...base2];
  const normalizedPrefixes = new Set(
    base2.flatMap(getPrefixes).map((p2) => p2.join(","))
  );
  for (const addresses of toMerge) {
    const newPrefixes = [];
    for (const address of addresses) {
      if (getPrefixes(address).some(
        (p2) => normalizedPrefixes.has(p2.join(","))
      )) {
        continue;
      }
      ret.push(address);
      newPrefixes.push(...getPrefixes(address).map((p2) => p2.join(",")));
    }
    for (const prefix of newPrefixes) {
      normalizedPrefixes.add(prefix);
    }
  }
  return ret;
}
function getPrefixes(address) {
  return address.map((_2, i2) => address.slice(0, i2 + 1));
}
function nodeAtOffset(offset2, options2) {
  let { type, side = "right" } = options2 || {};
  if (typeof offset2 !== "number") {
    offset2 = this.rowColToOffset(offset2);
  }
  if (offset2 < 0 || offset2 > this.source.length) {
    return null;
  }
  if (offset2 > 0 && offset2 === this.source.length && side === "left") {
    side = "right";
    offset2 -= 1;
  }
  const offsetToNodeMap = side === "right" ? this._offsetToNodeMapRight() : this._offsetToNodeMapLeft();
  let ret = offsetToNodeMap[offset2] || null;
  if (type != null) {
    while (ret && ret.type !== "root" && ret.type !== type) {
      ret = this.getParent(ret);
    }
    if (ret && ret.type !== type) {
      return null;
    }
  }
  return ret;
}
function elementAtOffset(offset2, options2) {
  const { side = "right" } = options2 || {};
  if (typeof offset2 !== "number") {
    offset2 = this.rowColToOffset(offset2);
  }
  return this.nodeAtOffset(offset2, { type: "element", side });
}
const ATTR_VALUE_CHAR = /[A-Za-z0-9_-]/;
function scanBareValueRun(source, from) {
  let valueStartOffset = from;
  while (valueStartOffset > 0 && ATTR_VALUE_CHAR.test(source.charAt(valueStartOffset - 1))) {
    valueStartOffset--;
  }
  let scan = valueStartOffset;
  while (scan > 0 && /\s/.test(source.charAt(scan - 1))) {
    scan--;
  }
  const equalsOffset = scan > 0 && source.charAt(scan - 1) === "=" ? scan - 1 : null;
  return { valueStartOffset, equalsOffset };
}
function findPrecedingEqualsForBareValue(source, from) {
  return scanBareValueRun(source, from).equalsOffset;
}
function synthesizeStrippedAttribute(source, tokenStart, tokenEnd, offsetToRowCol) {
  if (tokenEnd <= tokenStart) {
    return null;
  }
  const start = offsetToRowCol(tokenStart);
  const end = offsetToRowCol(tokenEnd);
  return {
    type: "attribute",
    name: source.slice(tokenStart, tokenEnd),
    children: [],
    position: {
      start: {
        line: start.line,
        column: start.column,
        offset: tokenStart
      },
      end: { line: end.line, column: end.column, offset: tokenEnd }
    }
  };
}
function scanIdentifierBackward(source, from) {
  let offset2 = from;
  while (offset2 > 0 && ATTR_VALUE_CHAR.test(source.charAt(offset2 - 1))) {
    offset2--;
  }
  return offset2;
}
function scanIdentifierForward(source, from) {
  let offset2 = from;
  while (offset2 < source.length && ATTR_VALUE_CHAR.test(source.charAt(offset2))) {
    offset2++;
  }
  return offset2;
}
function nonTagIdentifierSpan(source, start, end) {
  if (start === end) return null;
  if (start > 0 && source.charAt(start - 1) === "<") return null;
  return { start, end };
}
function identifierAtOffset(source, offset2) {
  return nonTagIdentifierSpan(
    source,
    scanIdentifierBackward(source, offset2),
    scanIdentifierForward(source, offset2)
  );
}
function identifierPrecedingOffset(source, offset2) {
  let scan = offset2;
  while (scan > 0 && /\s/.test(source.charAt(scan - 1))) {
    scan--;
  }
  return nonTagIdentifierSpan(
    source,
    scanIdentifierBackward(source, scan),
    scan
  );
}
function findAttributeContainingOffset(attributes, offset2, opts) {
  const endInclusive = opts?.endInclusive ?? true;
  const exclude = opts?.exclude;
  const match2 = attributes.find((a2) => {
    if (a2 === exclude) return false;
    const start = a2.position?.start.offset;
    const end = a2.position?.end.offset;
    if (start == null || end == null) return false;
    return start <= offset2 && (endInclusive ? end >= offset2 : end > offset2);
  });
  return match2 ?? null;
}
class DoenetSourceObject extends LazyDataObject {
  constructor(source) {
    super();
    this.source = "";
    this._lezer = this._lazyDataGetter(initLezer);
    this._lezerCursor = this._lazyDataGetter(initLezerCursor);
    this._dast = this._lazyDataGetter(initDast);
    this._offsetToRowCache = this._lazyDataGetter(initOffsetToRowCache);
    this._rowToOffsetCache = this._lazyDataGetter(initRowToOffsetCache);
    this._parentMap = this._lazyDataGetter(initParentMap);
    this._offsetToNodeMapRight = this._lazyDataGetter(initOffsetToNodeMapRight);
    this._offsetToNodeMapLeft = this._lazyDataGetter(initOffsetToNodeMapLeft);
    this._offsetToNodeIndexMap = this._lazyDataGetter(initOffsetToNodeIndexMap);
    this._descendantNamesMap = this._lazyDataGetter(initDescendantNamesMap);
    this.nodeAtOffset = nodeAtOffset;
    this.elementAtOffsetWithContext = elementAtOffsetWithContext;
    this.elementAtOffset = elementAtOffset;
    this.getMacroReferentAtOffset = getMacroReferentAtOffset;
    this.getAddressableNamesAtOffset = getAddressableNamesAtOffset;
    if (source != null) {
      this.setSource(source);
    }
  }
  /**
   * Set the DoenetML source string. All future queries will be run on this source.
   */
  setSource(source) {
    if (this.source === source) {
      return this;
    }
    this._clearLazyData();
    this.source = source;
    return this;
  }
  /**
   * Given a 0-index offset into the source string, return the 1-index line and column.
   */
  offsetToRowCol(offset2) {
    const offsetToRowCache = this._offsetToRowCache();
    return {
      line: offsetToRowCache.rowMap[offset2] + 1,
      column: offsetToRowCache.columnMap[offset2] + 1
    };
  }
  /**
   * Given a 0-index offset into the source string, return an LSP position.
   */
  offsetToLSPPosition(offset2) {
    const offsetToRowCache = this._offsetToRowCache();
    return {
      line: offsetToRowCache.rowMap[offset2],
      character: offsetToRowCache.columnMap[offset2]
    };
  }
  /**
   * Given a 1-index line and column, return the 0-index offset into the source string.
   */
  rowColToOffset(rowCol) {
    const _rowToOffsetCache = this._rowToOffsetCache();
    let row = ("row" in rowCol ? rowCol.row : rowCol.line) - 1;
    let col = ("col" in rowCol ? rowCol.col : "column" in rowCol ? rowCol.column : rowCol.character) - 1;
    if ("character" in rowCol) {
      row += 1;
      col += 1;
    }
    return _rowToOffsetCache[row] + col;
  }
  /**
   * Get a Rust-compatible root/element index at the given offset.
   * Returns the index of the nearest containing element (or root),
   * or `null` if no node exists at that position.
   *
   * Offsets are cursor positions, so `offset === source.length` is valid
   * (cursor at end-of-file). For that case we use left-of-cursor semantics
   * and return the same index as `source.length - 1` when the source is
   * non-empty.
   *
   * This mapping is used for Rust resolver integration to identify nodes by stable indices
   * rather than object references.
   *
   * @param offset The 0-based character offset into the source string
   * @returns The root/element index, or null if no node at offset
   */
  getNodeIndexAtOffset(offset2) {
    const offsetToIndexMap = this._offsetToNodeIndexMap();
    if (offset2 < 0 || offset2 > this.source.length) {
      return null;
    }
    if (offset2 === this.source.length) {
      if (this.source.length === 0) {
        return null;
      }
      return offsetToIndexMap[this.source.length - 1] ?? null;
    }
    return offsetToIndexMap[offset2] ?? null;
  }
  /**
   * Get the element attribute at `offset`, if it exists.
   *
   * Accepts cursors reported as `attributeName` or `attributeValue` as well
   * as the boundary cases `openTag` (e.g. cursor right after the opening
   * quote of a value) and `unknown` (e.g. cursor right after `=` on a
   * partial attribute, before the value is opened). In all cases the result
   * is restricted to a real attribute range, so cursors that aren't inside
   * any attribute (between attrs, on the tag name, on body text) return
   * `null`.
   *
   * Also applies an unquoted-value spillover heuristic: when the cursor
   * lands in a bogus attribute that the parser produced for the unquoted
   * value of a preceding attribute (e.g. the `full` in `<math simplify=full`
   * or `<math simplify= full`), returns the preceding attribute so callers
   * follow the user's intent rather than the parser's tokenization.
   *
   * Finally, when no attribute range contains the cursor at all, a
   * bare-value-after-`=` fallback walks back over value chars and
   * whitespace; if `=` precedes them, the attribute whose range contains
   * that `=` is returned. This mirrors the fallback in
   * `AutoCompleter.getCompletionItems` for parser states where typed
   * value chars don't yet land inside any attribute's range.
   *
   * Caveat — synthesized return values: when `lezer-to-dast` stripped
   * a bare-value pair from `node.attributes` (`<math simplify=full>` —
   * #1197), the fallback synthesizes a virtual `DastAttribute` from
   * the identifier in the source via `synthesizeStrippedAttribute`.
   * Such returns carry `name` and `position` but always
   * `children: []` — the value half was stripped along with the
   * assign half and is not reconstructed.  Callers that need the
   * typed value (`toXml(attr.children)` on a synthesized return
   * yields `""`) should slice `this.source` around `attr.position`
   * themselves.  Today's only consumers (`computeContextHelp`,
   * autocomplete) read only `attr.name`, so this is transparent;
   * future consumers reading `attr.children` need to handle the
   * synthesized case explicitly.
   */
  attributeAtOffset(offset2) {
    if (typeof offset2 !== "number") {
      offset2 = this.rowColToOffset(offset2);
    }
    const _offset = offset2;
    const containingElm = this.elementAtOffsetWithContext(offset2);
    if (!containingElm.node || containingElm.cursorPosition !== "attributeName" && containingElm.cursorPosition !== "attributeValue" && // `openTag` is reported once the cursor sits past an attribute
    // name on the equals/quote boundary in some cases, and
    // `unknown` is reported in others (e.g. cursor right after `=`
    // on a partial attribute, before the value is opened). The
    // position-containment check below still restricts the result
    // to a real attribute range, so cursors between attrs
    // (`<math foo |bar`) or on the tag name return null naturally.
    containingElm.cursorPosition !== "openTag" && containingElm.cursorPosition !== "unknown") {
      return null;
    }
    const attributes = Object.values(containingElm.node.attributes);
    const attribute = findAttributeContainingOffset(attributes, _offset);
    if (!attribute) {
      const equalsOffset = findPrecedingEqualsForBareValue(
        this.source,
        _offset
      );
      if (equalsOffset != null) {
        const containing = findAttributeContainingOffset(
          attributes,
          equalsOffset,
          { endInclusive: false }
        );
        if (containing) return containing;
        const ident2 = identifierPrecedingOffset(
          this.source,
          equalsOffset
        );
        if (ident2) {
          return synthesizeStrippedAttribute(
            this.source,
            ident2.start,
            ident2.end,
            (o2) => this.offsetToRowCol(o2)
          );
        }
        return null;
      }
      const ident = identifierAtOffset(this.source, _offset);
      if (ident) {
        return synthesizeStrippedAttribute(
          this.source,
          ident.start,
          ident.end,
          (o2) => this.offsetToRowCol(o2)
        );
      }
      return null;
    }
    const startOffset = attribute.position?.start.offset;
    if (startOffset != null && startOffset > 0) {
      const equalsOffset = findPrecedingEqualsForBareValue(
        this.source,
        startOffset
      );
      if (equalsOffset != null) {
        const preceding = findAttributeContainingOffset(
          attributes,
          equalsOffset,
          { endInclusive: false, exclude: attribute }
        );
        if (preceding) return preceding;
      }
    }
    return attribute;
  }
  /**
   * Returns whether `node` is a complete element (`true`) or
   * partially complete (`false`). Complete elements are valid xml.
   * Incomplete elements are `<abc` or `<abc>`.
   */
  isCompleteElement(node2) {
    if (node2.type !== "element") {
      throw new Error(
        `Node ${toXml(
          node2
        )} is not an element. Only elements maybe passed to this function.`
      );
    }
    if (!node2.position || node2.position.start.offset == null) {
      throw new Error(
        `Node ${JSON.stringify(node2)} is missing position information`
      );
    }
    const cursor2 = this._lezerCursor();
    cursor2.moveTo(node2.position.start.offset + 1, 0);
    const lezerNode = cursor2.node;
    const lezerNodeParent = lezerNode.parent;
    const nodeName = lezerNode.type.name;
    let tagComplete = true;
    let closed = true;
    switch (nodeName) {
      case "OpenTag": {
        if (!lezerNode.getChild("EndTag")) {
          tagComplete = false;
        }
        if (!lezerNodeParent?.getChild("CloseTag")) {
          closed = false;
        } else if (this._isCloseTagStolenFromAncestor(lezerNodeParent)) {
          closed = false;
        }
        break;
      }
      case "SelfClosingTag": {
        if (!lezerNode.getChild("SelfCloseEndTag")) {
          tagComplete = false;
        }
        break;
      }
      default:
        console.warn(
          "Could not find OpenTag or SelfClosingTag for node",
          node2
        );
    }
    return { tagComplete, closed };
  }
  /**
   * Walk up the contiguous chain of same-name ancestor `Element` nodes
   * starting from `elementNode`'s parent. Returns true if any of those
   * same-name ancestors is missing its `CloseTag` — meaning the parser's
   * stack-based matching has shifted close tags down a level and the
   * close tag the parser attributed to `elementNode` was, from the user's
   * perspective, "stolen" from an ancestor (issue #1117).
   *
   * Stops at the first ancestor with a different tag name (or at the
   * root): the stealing pattern only happens through a same-name chain,
   * because that's the only configuration where the parser stack can
   * shuffle close tags. For example, `<p><div><p></p></div>` does NOT
   * trigger — `<div>` breaks the chain and the inner `</p>` is
   * genuinely the inner `<p>`'s own.
   *
   * Comparison is case-sensitive to match XML/DoenetML semantics.
   */
  _isCloseTagStolenFromAncestor(elementNode) {
    const openTag = elementNode.getChild("OpenTag");
    const tagNameNode = openTag?.getChild("TagName");
    if (!tagNameNode) {
      return false;
    }
    const tagName = this.source.slice(tagNameNode.from, tagNameNode.to);
    if (!tagName) {
      return false;
    }
    let ancestor = elementNode.parent;
    while (ancestor) {
      if (ancestor.type.name !== "Element") {
        return false;
      }
      const ancestorOpenTag = ancestor.getChild("OpenTag");
      const ancestorTagNameNode = ancestorOpenTag?.getChild("TagName");
      if (!ancestorTagNameNode) {
        return false;
      }
      const ancestorName = this.source.slice(
        ancestorTagNameNode.from,
        ancestorTagNameNode.to
      );
      if (ancestorName !== tagName) {
        return false;
      }
      if (!ancestor.getChild("CloseTag")) {
        return true;
      }
      ancestor = ancestor.parent;
    }
    return false;
  }
  /**
   * Get the offset ranges for the tag(s) of `node`. (I.e., just the part
   * in the angle brackets without the children.) If the tag is incomplete or
   * is a self-closing tag, only one range will be returned.
   *
   * Note: these values are given as **offsets**.
   */
  getElementTagRanges(node2) {
    const start = node2.position?.start?.offset || 0;
    const end = node2.position?.end?.offset || 0;
    const childrenStart = node2.children[0]?.position?.start?.offset;
    const childrenEnd = node2.children[node2.children.length - 1]?.position?.end?.offset;
    if (childrenStart == null || childrenEnd == null) {
      return [{ start, end }];
    }
    return [
      { start, end: childrenStart },
      { start: childrenEnd, end }
    ];
  }
  /**
   * Get the parent of `node`. Node must be in `this.dast`.
   */
  getParent(node2) {
    const parentMap = this._parentMap();
    return parentMap.get(node2) || null;
  }
  /**
   * Get the tag name of the parent element of `node`, or `undefined` when
   * the parent is the document root (no `name` field) or `node` has no
   * parent at all. Convenience over `getParent` that's used wherever the
   * alias-aware schema lookups need the grandparent/parent name string —
   * keeping the `parent && "name" in parent ? parent.name : undefined`
   * dance in one place so callsites don't drift.
   */
  getParentElementName(node2) {
    const parent = this.getParent(node2);
    return parent && "name" in parent ? parent.name : void 0;
  }
  /**
   * Get all parents of `node`. The first element in the array is the immediate parent followed
   * by more distant ancestors.
   *
   * Node must be in `this.dast`.
   */
  getParents(node2) {
    const ret = [];
    let parent = this.getParent(node2);
    while (parent && parent.type !== "root") {
      ret.push(parent);
      parent = this.getParent(parent);
    }
    ret.push(this.dast);
    return ret;
  }
  /**
   * Get the unique descendant of `node` with name `name`.
   */
  getNamedDescendant(node2, name2) {
    if (!node2) {
      return null;
    }
    const descendantNamesMap = this._descendantNamesMap();
    const accessibleNames = (descendantNamesMap.get(node2) || []).filter(
      (e2) => e2.name === name2
    );
    if (accessibleNames.length === 1) {
      return accessibleNames[0].element;
    }
    return null;
  }
  /**
   * Get all descendant names directly addressable from `node`.
   */
  getDescendantNamesForNode(node2) {
    if (!node2) {
      return [];
    }
    return (this._descendantNamesMap().get(node2) || []).map(
      ({ name: name2 }) => name2
    );
  }
  /**
   * Get descendant names that are uniquely addressable from `node`.
   *
   * This mirrors `getNamedDescendant` semantics: names that occur more than
   * once under the same node are excluded.
   */
  getUniqueDescendantNamesForNode(node2) {
    const names = this.getDescendantNamesForNode(node2);
    const counts = /* @__PURE__ */ new Map();
    for (const name2 of names) {
      counts.set(name2, (counts.get(name2) || 0) + 1);
    }
    return names.filter((name2) => counts.get(name2) === 1);
  }
  /**
   * Get the unique item with name `name` resolved from position `offset`.
   */
  getReferentAtOffset(offset2, name2) {
    const { node: node2 } = this.elementAtOffsetWithContext(offset2);
    let parent = node2;
    let referent = this.getNamedDescendant(parent, name2);
    while (parent && parent.type !== "root" && !referent) {
      parent = this._parentMap().get(parent);
      referent = this.getNamedDescendant(parent, name2);
    }
    if (!parent && !referent) {
      referent = this.getNamedDescendant(this.dast, name2);
    }
    return referent || null;
  }
  /**
   * Return the smallest range that contains all of the nodes in `nodes`.
   */
  getNodeRange(nodes, style) {
    if (!Array.isArray(nodes)) {
      nodes = [nodes];
    }
    let start = Math.min(
      Infinity,
      ...nodes.map((n2) => n2.position?.start?.offset || 0)
    );
    if (start === Infinity) {
      start = 0;
    }
    const end = Math.max(
      0,
      ...nodes.map((n2) => n2.position?.end?.offset || 0)
    );
    if (style === "lsp") {
      return {
        start: this.offsetToLSPPosition(start),
        end: this.offsetToLSPPosition(end)
      };
    }
    return {
      start: this.offsetToRowCol(start),
      end: this.offsetToRowCol(end)
    };
  }
  /**
   * The DAST representation of `source`.
   */
  get dast() {
    return this._dast();
  }
  /**
   * The Lezer TreeCursor for the parsed version of `source`.
   */
  get lezerCursor() {
    return this._lezerCursor();
  }
}
const SELECT_FAMILY_COUNT_ATTRIBUTE = {
  select: "numToSelect",
  selectFromSequence: "numToSelect",
  selectRandomNumbers: "numToSelect",
  selectPrimeNumbers: "numToSelect",
  samplePrimeNumbers: "numSamples",
  sampleRandomNumbers: "numSamples"
};
Object.fromEntries(
  Object.entries(SELECT_FAMILY_COUNT_ATTRIBUTE).map(([k2, v2]) => [
    k2.toLowerCase(),
    v2
  ])
);
const CONTAINER_SUGGESTION_OVERRIDES_RAW = {
  module: ["moduleAttributes", "section", "graph", "p", "function"],
  moduleAttributes: [
    "number",
    "math",
    "text",
    "boolean",
    "point",
    "function"
  ],
  setup: [
    // <select*> and <repeat*> are the natural construction primitives for
    // initializing state inside `<setup>`.
    "select",
    "selectFromSequence",
    "selectPrimeNumbers",
    "selectRandomNumbers",
    "repeat",
    "repeatForSequence",
    // …then the basic value-producing components.
    "number",
    "math",
    "text",
    "boolean",
    "point",
    "function"
  ],
  document: ["title", "setup"],
  _sectioningComponent: ["title", "setup"],
  answer: [
    "label",
    "award",
    "choice",
    "shortDescription",
    "description",
    "considerAsResponses"
  ],
  award: ["when", "math", "number", "text", "boolean", "point"],
  boolean: ["math", "number", "text", "boolean", "point", "function"],
  when: ["math", "number", "text", "boolean", "point", "function"],
  _input: ["label", "shortDescription", "description"],
  choiceInput: ["choice", "label", "shortDescription", "description"],
  graph: [
    "shortDescription",
    "point",
    "function",
    "xLabel",
    "yLabel",
    "_graphical",
    "description"
  ],
  conditionalContent: ["case", "else"],
  math: [
    "math",
    "number",
    "m",
    "round",
    "mean",
    "mod",
    "ceil",
    "floor",
    "abs",
    "median",
    "standardDeviation",
    "variance"
  ],
  sort: [
    "math",
    "number",
    "text",
    "point",
    "vector",
    "mathList",
    "numberList",
    "textList",
    "pointList",
    "vectorList"
  ],
  shuffle: [
    "math",
    "number",
    "text",
    "point",
    "vector",
    "mathList",
    "numberList",
    "textList",
    "pointList",
    "vectorList"
  ],
  sideBySide: ["stack"]
};
const FAVORITE_COMPONENTS = [
  // Ordered as a round-robin across categories so the top of the list
  // (what the help panel shows) spans many categories rather than clumping
  // similar components together.
  //
  // The first round (positions 0–5) is one pick per category, so the
  // 6-chip panel hits text, math, graphics, assessment, pedagogical, and
  // media in one screen:
  "p",
  // text
  "math",
  // math
  "graph",
  // graphics
  "answer",
  // interactive / assessment
  "example",
  // pedagogical
  "image",
  // media / lists
  // Second round adds the scaffolding category and the next pick per
  // earlier category, keeping diversity high as the list grows:
  "section",
  // text 2
  "m",
  // math 2
  "point",
  // graphics 2
  "mathInput",
  // interactive 2
  "hint",
  // pedagogical 2
  "ol",
  // media 2
  "sequence",
  // scaffolding 1
  // Subsequent rounds continue the same cycle to the tail:
  "me",
  // math 3
  "line",
  // graphics 3
  "choice",
  // interactive 3
  "problem",
  // pedagogical 3
  "video",
  // media 3
  "repeat",
  // scaffolding 2
  "number",
  // math 4
  "vector",
  // graphics 4
  "choiceInput",
  // interactive 4
  "ul",
  // media 4
  "repeatForSequence",
  // scaffolding 3
  "function",
  // math 5
  "circle",
  // graphics 5
  "feedback",
  // interactive 5
  "label"
  // graphics 6
];
new Map(
  FAVORITE_COMPONENTS.map((name2, i2) => [name2.toLowerCase(), i2])
);
new Map(
  Object.entries(CONTAINER_SUGGESTION_OVERRIDES_RAW).map(([k2, v2]) => [
    k2.toLowerCase(),
    v2
  ])
);
doenetSchema$1.elements;
const convert = (
  // Note: overloads in JSDoc can’t yet use different `@template`s.
  /**
   * @type {(
   *   (<Condition extends string>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & {type: Condition}) &
   *   (<Condition extends Props>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Condition) &
   *   (<Condition extends TestFunction>(test: Condition) => (node: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node & Predicate<Condition, Node>) &
   *   ((test?: null | undefined) => (node?: unknown, index?: number | null | undefined, parent?: Parent | null | undefined, context?: unknown) => node is Node) &
   *   ((test?: Test) => Check)
   * )}
   */
  /**
   * @param {Test} [test]
   * @returns {Check}
   */
  (function(test) {
    if (test === null || test === void 0) {
      return ok;
    }
    if (typeof test === "function") {
      return castFactory(test);
    }
    if (typeof test === "object") {
      return Array.isArray(test) ? anyFactory(test) : (
        // Cast because `ReadonlyArray` goes into the above but `isArray`
        // narrows to `Array`.
        propertiesFactory(
          /** @type {Props} */
          test
        )
      );
    }
    if (typeof test === "string") {
      return typeFactory(test);
    }
    throw new Error("Expected function, string, or object as test");
  })
);
function anyFactory(tests) {
  const checks = [];
  let index2 = -1;
  while (++index2 < tests.length) {
    checks[index2] = convert(tests[index2]);
  }
  return castFactory(any);
  function any(...parameters) {
    let index22 = -1;
    while (++index22 < checks.length) {
      if (checks[index22].apply(this, parameters)) return true;
    }
    return false;
  }
}
function propertiesFactory(check) {
  const checkAsRecord = (
    /** @type {Record<string, unknown>} */
    check
  );
  return castFactory(all2);
  function all2(node2) {
    const nodeAsRecord = (
      /** @type {Record<string, unknown>} */
      /** @type {unknown} */
      node2
    );
    let key;
    for (key in check) {
      if (nodeAsRecord[key] !== checkAsRecord[key]) return false;
    }
    return true;
  }
}
function typeFactory(check) {
  return castFactory(type);
  function type(node2) {
    return node2 && node2.type === check;
  }
}
function castFactory(testFunction) {
  return check;
  function check(value, index2, parent) {
    return Boolean(
      looksLikeANode(value) && testFunction.call(
        this,
        value,
        typeof index2 === "number" ? index2 : void 0,
        parent || void 0
      )
    );
  }
}
function ok() {
  return true;
}
function looksLikeANode(value) {
  return value !== null && typeof value === "object" && "type" in value;
}
convert([
  "break",
  "delete",
  "emphasis",
  // To do: next major: removed since footnotes were added to GFM.
  "footnote",
  "footnoteReference",
  "image",
  "imageReference",
  "inlineCode",
  // Enabled by `mdast-util-math`:
  "inlineMath",
  "link",
  "linkReference",
  // Enabled by `mdast-util-mdx`:
  "mdxJsxTextElement",
  // Enabled by `mdast-util-mdx`:
  "mdxTextExpression",
  "strong",
  "text",
  // Enabled by `mdast-util-directive`:
  "textDirective"
]);
const COMPLETION_TYPES = {
  /** Element / tag name, e.g. `<math>`. */
  component: "component",
  /** A property of a referenced component, e.g. `$m.displayDecimals`. */
  referenceProperty: "refproperty",
  /** A closing-tag suggestion, e.g. `/math>`. */
  closeTag: "closetag",
  /** A predefined multi-element snippet. */
  snippet: "snippet",
  /** An attribute name. */
  attributeName: "enum",
  /** An enumerated attribute value. */
  attributeValue: "value",
  /** A reference name, e.g. `$myMath`. */
  reference: "reference"
};
const completionItemKindName = new Map(
  Object.entries(browserExports$1.CompletionItemKind).filter(([, value]) => typeof value === "number").map(([name2, value]) => [value, name2])
);
function deriveCompletionType(item) {
  const { kind, detail, label: label2 } = item;
  if (kind == null) {
    return void 0;
  }
  switch (kind) {
    case browserExports$1.CompletionItemKind.Property:
      if (label2.startsWith("/")) {
        return COMPLETION_TYPES.closeTag;
      }
      return detail ? COMPLETION_TYPES.referenceProperty : COMPLETION_TYPES.component;
    case browserExports$1.CompletionItemKind.Snippet:
      return COMPLETION_TYPES.snippet;
    case browserExports$1.CompletionItemKind.Enum:
      return COMPLETION_TYPES.attributeName;
    case browserExports$1.CompletionItemKind.Value:
      return COMPLETION_TYPES.attributeValue;
    case browserExports$1.CompletionItemKind.Reference:
      return COMPLETION_TYPES.reference;
    default:
      return completionItemKindName.get(kind)?.toLowerCase();
  }
}
var commonjsGlobal = typeof globalThis !== "undefined" ? globalThis : typeof window !== "undefined" ? window : typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : {};
function getDefaultExportFromCjs(x2) {
  return x2 && x2.__esModule && Object.prototype.hasOwnProperty.call(x2, "default") ? x2["default"] : x2;
}
var colorName$1;
var hasRequiredColorName;
function requireColorName() {
  if (hasRequiredColorName) return colorName$1;
  hasRequiredColorName = 1;
  colorName$1 = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  return colorName$1;
}
var colorNameExports = requireColorName();
const colorName = /* @__PURE__ */ getDefaultExportFromCjs(colorNameExports);
var nearestColor$2 = { exports: {} };
var nearestColor$1 = nearestColor$2.exports;
var hasRequiredNearestColor;
function requireNearestColor() {
  if (hasRequiredNearestColor) return nearestColor$2.exports;
  hasRequiredNearestColor = 1;
  (function(module) {
    (function(context) {
      function nearestColor2(needle, colors) {
        needle = parseColor(needle);
        if (!needle) {
          return null;
        }
        var distanceSq, minDistanceSq = Infinity, rgb, value;
        colors || (colors = nearestColor2.DEFAULT_COLORS);
        for (var i2 = 0; i2 < colors.length; ++i2) {
          rgb = colors[i2].rgb;
          distanceSq = Math.pow(needle.r - rgb.r, 2) + Math.pow(needle.g - rgb.g, 2) + Math.pow(needle.b - rgb.b, 2);
          if (distanceSq < minDistanceSq) {
            minDistanceSq = distanceSq;
            value = colors[i2];
          }
        }
        if (value.name) {
          return {
            name: value.name,
            value: value.source,
            rgb: value.rgb,
            distance: Math.sqrt(minDistanceSq)
          };
        }
        return value.source;
      }
      nearestColor2.from = function from(availableColors) {
        var colors = mapColors(availableColors), nearestColorBase = nearestColor2;
        var matcher2 = function nearestColor3(hex) {
          return nearestColorBase(hex, colors);
        };
        matcher2.from = from;
        matcher2.or = function or2(alternateColors) {
          var extendedColors = colors.concat(mapColors(alternateColors));
          return nearestColor2.from(extendedColors);
        };
        return matcher2;
      };
      function mapColors(colors) {
        if (colors instanceof Array) {
          return colors.map(function(color2) {
            return createColorSpec(color2);
          });
        }
        return Object.keys(colors).map(function(name2) {
          return createColorSpec(colors[name2], name2);
        });
      }
      function parseColor(source) {
        var red, green, blue;
        if (typeof source === "object") {
          return source;
        }
        if (source in nearestColor2.STANDARD_COLORS) {
          return parseColor(nearestColor2.STANDARD_COLORS[source]);
        }
        var hexMatch = source.match(/^#?((?:[0-9a-f]{3}){1,2})$/i);
        if (hexMatch) {
          hexMatch = hexMatch[1];
          if (hexMatch.length === 3) {
            hexMatch = [
              hexMatch.charAt(0) + hexMatch.charAt(0),
              hexMatch.charAt(1) + hexMatch.charAt(1),
              hexMatch.charAt(2) + hexMatch.charAt(2)
            ];
          } else {
            hexMatch = [
              hexMatch.substring(0, 2),
              hexMatch.substring(2, 4),
              hexMatch.substring(4, 6)
            ];
          }
          red = parseInt(hexMatch[0], 16);
          green = parseInt(hexMatch[1], 16);
          blue = parseInt(hexMatch[2], 16);
          return { r: red, g: green, b: blue };
        }
        var rgbMatch = source.match(/^rgb\(\s*(\d{1,3}%?),\s*(\d{1,3}%?),\s*(\d{1,3}%?)\s*\)$/i);
        if (rgbMatch) {
          red = parseComponentValue(rgbMatch[1]);
          green = parseComponentValue(rgbMatch[2]);
          blue = parseComponentValue(rgbMatch[3]);
          return { r: red, g: green, b: blue };
        }
        throw Error('"' + source + '" is not a valid color');
      }
      function createColorSpec(input, name2) {
        var color2 = {};
        if (name2) {
          color2.name = name2;
        }
        if (typeof input === "string") {
          color2.source = input;
          color2.rgb = parseColor(input);
        } else if (typeof input === "object") {
          if (input.source) {
            return createColorSpec(input.source, input.name);
          }
          color2.rgb = input;
          color2.source = rgbToHex(input);
        }
        return color2;
      }
      function parseComponentValue(string2) {
        if (string2.charAt(string2.length - 1) === "%") {
          return Math.round(parseInt(string2, 10) * 255 / 100);
        }
        return Number(string2);
      }
      function rgbToHex(rgb) {
        return "#" + leadingZero(rgb.r.toString(16)) + leadingZero(rgb.g.toString(16)) + leadingZero(rgb.b.toString(16));
      }
      function leadingZero(value) {
        if (value.length === 1) {
          value = "0" + value;
        }
        return value;
      }
      nearestColor2.STANDARD_COLORS = {
        aqua: "#0ff",
        black: "#000",
        blue: "#00f",
        fuchsia: "#f0f",
        gray: "#808080",
        green: "#008000",
        lime: "#0f0",
        maroon: "#800000",
        navy: "#000080",
        olive: "#808000",
        orange: "#ffa500",
        purple: "#800080",
        red: "#f00",
        silver: "#c0c0c0",
        teal: "#008080",
        white: "#fff",
        yellow: "#ff0"
      };
      nearestColor2.DEFAULT_COLORS = mapColors([
        "#f00",
        // r
        "#f80",
        // o
        "#ff0",
        // y
        "#0f0",
        // g
        "#00f",
        // b
        "#008",
        // i
        "#808"
        // v
      ]);
      nearestColor2.VERSION = "0.4.4";
      if (module && module.exports) {
        module.exports = nearestColor2;
      } else {
        context.nearestColor = nearestColor2;
      }
    })(nearestColor$1);
  })(nearestColor$2);
  return nearestColor$2.exports;
}
var nearestColorExports = requireNearestColor();
const nearestColor = /* @__PURE__ */ getDefaultExportFromCjs(nearestColorExports);
const canonicalColorHexByKey = {
  black: "#000000",
  white: "#ffffff",
  gray: "#808080",
  red: "#ff0000",
  orange: "#ffa500",
  yellow: "#ffff00",
  green: "#008000",
  cyan: "#00ffff",
  blue: "#0000ff",
  purple: "#800080",
  pink: "#ffc0cb",
  brown: "#a52a2a"
};
const canonicalAnchorDefinitions = Object.fromEntries(
  Object.entries(canonicalColorHexByKey).map(([canonical, hex]) => [
    canonical,
    { hex, canonical }
  ])
);
const extraAnchorDefinitions = {
  silver: { hex: "#c0c0c0", canonical: "gray" },
  grayDark: { hex: "#4d4d4d", canonical: "gray" },
  grayCustom: { hex: "#757575", canonical: "gray" },
  grayLight: { hex: "#c8c8c8", canonical: "gray" },
  grayLighter: { hex: "#dcdcdc", canonical: "gray" },
  maroon: { hex: "#800000", canonical: "red" },
  redLight: { hex: "#f08080", canonical: "red" },
  redCustom: { hex: "#D4042D", canonical: "red" },
  redDark: { hex: "#8b0000", canonical: "red" },
  orangeLight: { hex: "#ffa07a", canonical: "orange" },
  orangeCustom: { hex: "#F19143", canonical: "orange" },
  orangePresetAccessible: { hex: "#a6510c", canonical: "orange" },
  orangeDark: { hex: "#ff8c00", canonical: "orange" },
  yellowLight: { hex: "#ffffe0", canonical: "yellow" },
  yellowDark: { hex: "#bdb76b", canonical: "yellow" },
  yellowgreen: { hex: "#9acd32", canonical: "green" },
  olive: { hex: "#808000", canonical: "green" },
  lime: { hex: "#00ff00", canonical: "green" },
  greenLight: { hex: "#90ee90", canonical: "green" },
  greenCustom: { hex: "#2ca02c", canonical: "green" },
  greenDark: { hex: "#006400", canonical: "green" },
  teal: { hex: "#008080", canonical: "green" },
  aqua: { hex: "#00ffff", canonical: "cyan" },
  cyanLight: { hex: "#e0ffff", canonical: "cyan" },
  cyanDark: { hex: "#008b8b", canonical: "cyan" },
  navy: { hex: "#000080", canonical: "blue" },
  blueCustom: { hex: "#648FFF", canonical: "blue" },
  bluePresetAccessible: { hex: "#1f5dff", canonical: "blue" },
  blueLight: { hex: "#add8e6", canonical: "blue" },
  blueDark: { hex: "#00008b", canonical: "blue" },
  fuchsia: { hex: "#ff00ff", canonical: "purple" },
  purpleCustom: { hex: "#644CD6", canonical: "purple" },
  purpleLight: { hex: "#dda0dd", canonical: "purple" },
  purpleDark: { hex: "#8b008b", canonical: "purple" },
  hotpink: { hex: "#ff69b4", canonical: "pink" },
  pinkDark: { hex: "#ff1493", canonical: "pink" },
  brownLight: { hex: "#deb887", canonical: "brown" },
  brownDark: { hex: "#8b4513", canonical: "brown" }
};
const anchorDefinitions = {
  ...canonicalAnchorDefinitions,
  ...extraAnchorDefinitions
};
const matchColorHexByName = Object.fromEntries(
  Object.entries(anchorDefinitions).map(([name2, definition2]) => [
    name2,
    definition2.hex
  ])
);
Object.fromEntries(
  Object.entries(anchorDefinitions).map(([name2, definition2]) => [
    name2,
    definition2.canonical
  ])
);
nearestColor.from(matchColorHexByName);
/* @__PURE__ */ new Set([
  ...Object.keys(colorName),
  "transparent",
  "currentcolor"
]);
var r = { grad: 0.9, turn: 360, rad: 360 / (2 * Math.PI) }, t$1 = function(r2) {
  return "string" == typeof r2 ? r2.length > 0 : "number" == typeof r2;
}, n = function(r2, t222, n2) {
  return void 0 === t222 && (t222 = 0), void 0 === n2 && (n2 = Math.pow(10, t222)), Math.round(n2 * r2) / n2 + 0;
}, e$1 = function(r2, t222, n2) {
  return void 0 === t222 && (t222 = 0), void 0 === n2 && (n2 = 1), r2 > n2 ? n2 : r2 > t222 ? r2 : t222;
}, u = function(r2) {
  return (r2 = isFinite(r2) ? r2 % 360 : 0) > 0 ? r2 : r2 + 360;
}, a = function(r2) {
  return { r: e$1(r2.r, 0, 255), g: e$1(r2.g, 0, 255), b: e$1(r2.b, 0, 255), a: e$1(r2.a) };
}, o$1 = function(r2) {
  return { r: n(r2.r), g: n(r2.g), b: n(r2.b), a: n(r2.a, 3) };
}, i = /^#([0-9a-f]{3,8})$/i, s = function(r2) {
  var t222 = r2.toString(16);
  return t222.length < 2 ? "0" + t222 : t222;
}, h = function(r2) {
  var t222 = r2.r, n2 = r2.g, e2 = r2.b, u2 = r2.a, a2 = Math.max(t222, n2, e2), o2 = a2 - Math.min(t222, n2, e2), i2 = o2 ? a2 === t222 ? (n2 - e2) / o2 : a2 === n2 ? 2 + (e2 - t222) / o2 : 4 + (t222 - n2) / o2 : 0;
  return { h: 60 * (i2 < 0 ? i2 + 6 : i2), s: a2 ? o2 / a2 * 100 : 0, v: a2 / 255 * 100, a: u2 };
}, b$1 = function(r2) {
  var t222 = r2.h, n2 = r2.s, e2 = r2.v, u2 = r2.a;
  t222 = t222 / 360 * 6, n2 /= 100, e2 /= 100;
  var a2 = Math.floor(t222), o2 = e2 * (1 - n2), i2 = e2 * (1 - (t222 - a2) * n2), s2 = e2 * (1 - (1 - t222 + a2) * n2), h2 = a2 % 6;
  return { r: 255 * [e2, i2, o2, o2, s2, e2][h2], g: 255 * [s2, e2, e2, i2, o2, o2][h2], b: 255 * [o2, o2, s2, e2, e2, i2][h2], a: u2 };
}, g$1 = function(r2) {
  return { h: u(r2.h), s: e$1(r2.s, 0, 100), l: e$1(r2.l, 0, 100), a: e$1(r2.a) };
}, d = function(r2) {
  return { h: n(r2.h), s: n(r2.s), l: n(r2.l), a: n(r2.a, 3) };
}, f$1 = function(r2) {
  return b$1((n2 = (t222 = r2).s, { h: t222.h, s: (n2 *= ((e2 = t222.l) < 50 ? e2 : 100 - e2) / 100) > 0 ? 2 * n2 / (e2 + n2) * 100 : 0, v: e2 + n2, a: t222.a }));
  var t222, n2, e2;
}, c = function(r2) {
  return { h: (t222 = h(r2)).h, s: (u2 = (200 - (n2 = t222.s)) * (e2 = t222.v) / 100) > 0 && u2 < 200 ? n2 * e2 / 100 / (u2 <= 100 ? u2 : 200 - u2) * 100 : 0, l: u2 / 2, a: t222.a };
  var t222, n2, e2, u2;
}, l = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s*,\s*([+-]?\d*\.?\d+)%\s*,\s*([+-]?\d*\.?\d+)%\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, p = /^hsla?\(\s*([+-]?\d*\.?\d+)(deg|rad|grad|turn)?\s+([+-]?\d*\.?\d+)%\s+([+-]?\d*\.?\d+)%\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, v$1 = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*,\s*([+-]?\d*\.?\d+)(%)?\s*(?:,\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, m = /^rgba?\(\s*([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s+([+-]?\d*\.?\d+)(%)?\s*(?:\/\s*([+-]?\d*\.?\d+)(%)?\s*)?\)$/i, y$1 = { string: [[function(r2) {
  var t222 = i.exec(r2);
  return t222 ? (r2 = t222[1]).length <= 4 ? { r: parseInt(r2[0] + r2[0], 16), g: parseInt(r2[1] + r2[1], 16), b: parseInt(r2[2] + r2[2], 16), a: 4 === r2.length ? n(parseInt(r2[3] + r2[3], 16) / 255, 2) : 1 } : 6 === r2.length || 8 === r2.length ? { r: parseInt(r2.substr(0, 2), 16), g: parseInt(r2.substr(2, 2), 16), b: parseInt(r2.substr(4, 2), 16), a: 8 === r2.length ? n(parseInt(r2.substr(6, 2), 16) / 255, 2) : 1 } : null : null;
}, "hex"], [function(r2) {
  var t222 = v$1.exec(r2) || m.exec(r2);
  return t222 ? t222[2] !== t222[4] || t222[4] !== t222[6] ? null : a({ r: Number(t222[1]) / (t222[2] ? 100 / 255 : 1), g: Number(t222[3]) / (t222[4] ? 100 / 255 : 1), b: Number(t222[5]) / (t222[6] ? 100 / 255 : 1), a: void 0 === t222[7] ? 1 : Number(t222[7]) / (t222[8] ? 100 : 1) }) : null;
}, "rgb"], [function(t222) {
  var n2 = l.exec(t222) || p.exec(t222);
  if (!n2) return null;
  var e2, u2, a2 = g$1({ h: (e2 = n2[1], u2 = n2[2], void 0 === u2 && (u2 = "deg"), Number(e2) * (r[u2] || 1)), s: Number(n2[3]), l: Number(n2[4]), a: void 0 === n2[5] ? 1 : Number(n2[5]) / (n2[6] ? 100 : 1) });
  return f$1(a2);
}, "hsl"]], object: [[function(r2) {
  var n2 = r2.r, e2 = r2.g, u2 = r2.b, o2 = r2.a, i2 = void 0 === o2 ? 1 : o2;
  return t$1(n2) && t$1(e2) && t$1(u2) ? a({ r: Number(n2), g: Number(e2), b: Number(u2), a: Number(i2) }) : null;
}, "rgb"], [function(r2) {
  var n2 = r2.h, e2 = r2.s, u2 = r2.l, a2 = r2.a, o2 = void 0 === a2 ? 1 : a2;
  if (!t$1(n2) || !t$1(e2) || !t$1(u2)) return null;
  var i2 = g$1({ h: Number(n2), s: Number(e2), l: Number(u2), a: Number(o2) });
  return f$1(i2);
}, "hsl"], [function(r2) {
  var n2 = r2.h, a2 = r2.s, o2 = r2.v, i2 = r2.a, s2 = void 0 === i2 ? 1 : i2;
  if (!t$1(n2) || !t$1(a2) || !t$1(o2)) return null;
  var h2 = (function(r3) {
    return { h: u(r3.h), s: e$1(r3.s, 0, 100), v: e$1(r3.v, 0, 100), a: e$1(r3.a) };
  })({ h: Number(n2), s: Number(a2), v: Number(o2), a: Number(s2) });
  return b$1(h2);
}, "hsv"]] }, N$1 = function(r2, t222) {
  for (var n2 = 0; n2 < t222.length; n2++) {
    var e2 = t222[n2][0](r2);
    if (e2) return [e2, t222[n2][1]];
  }
  return [null, void 0];
}, x$1 = function(r2) {
  return "string" == typeof r2 ? N$1(r2.trim(), y$1.string) : "object" == typeof r2 && null !== r2 ? N$1(r2, y$1.object) : [null, void 0];
}, M$1 = function(r2, t222) {
  var n2 = c(r2);
  return { h: n2.h, s: e$1(n2.s + 100 * t222, 0, 100), l: n2.l, a: n2.a };
}, H$1 = function(r2) {
  return (299 * r2.r + 587 * r2.g + 114 * r2.b) / 1e3 / 255;
}, $$1 = function(r2, t222) {
  var n2 = c(r2);
  return { h: n2.h, s: n2.s, l: e$1(n2.l + 100 * t222, 0, 100), a: n2.a };
}, j$1 = (function() {
  function r2(r3) {
    this.parsed = x$1(r3)[0], this.rgba = this.parsed || { r: 0, g: 0, b: 0, a: 1 };
  }
  return r2.prototype.isValid = function() {
    return null !== this.parsed;
  }, r2.prototype.brightness = function() {
    return n(H$1(this.rgba), 2);
  }, r2.prototype.isDark = function() {
    return H$1(this.rgba) < 0.5;
  }, r2.prototype.isLight = function() {
    return H$1(this.rgba) >= 0.5;
  }, r2.prototype.toHex = function() {
    return r3 = o$1(this.rgba), t222 = r3.r, e2 = r3.g, u2 = r3.b, i2 = (a2 = r3.a) < 1 ? s(n(255 * a2)) : "", "#" + s(t222) + s(e2) + s(u2) + i2;
    var r3, t222, e2, u2, a2, i2;
  }, r2.prototype.toRgb = function() {
    return o$1(this.rgba);
  }, r2.prototype.toRgbString = function() {
    return r3 = o$1(this.rgba), t222 = r3.r, n2 = r3.g, e2 = r3.b, (u2 = r3.a) < 1 ? "rgba(" + t222 + ", " + n2 + ", " + e2 + ", " + u2 + ")" : "rgb(" + t222 + ", " + n2 + ", " + e2 + ")";
    var r3, t222, n2, e2, u2;
  }, r2.prototype.toHsl = function() {
    return d(c(this.rgba));
  }, r2.prototype.toHslString = function() {
    return r3 = d(c(this.rgba)), t222 = r3.h, n2 = r3.s, e2 = r3.l, (u2 = r3.a) < 1 ? "hsla(" + t222 + ", " + n2 + "%, " + e2 + "%, " + u2 + ")" : "hsl(" + t222 + ", " + n2 + "%, " + e2 + "%)";
    var r3, t222, n2, e2, u2;
  }, r2.prototype.toHsv = function() {
    return r3 = h(this.rgba), { h: n(r3.h), s: n(r3.s), v: n(r3.v), a: n(r3.a, 3) };
    var r3;
  }, r2.prototype.invert = function() {
    return w({ r: 255 - (r3 = this.rgba).r, g: 255 - r3.g, b: 255 - r3.b, a: r3.a });
    var r3;
  }, r2.prototype.saturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w(M$1(this.rgba, r3));
  }, r2.prototype.desaturate = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w(M$1(this.rgba, -r3));
  }, r2.prototype.grayscale = function() {
    return w(M$1(this.rgba, -1));
  }, r2.prototype.lighten = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w($$1(this.rgba, r3));
  }, r2.prototype.darken = function(r3) {
    return void 0 === r3 && (r3 = 0.1), w($$1(this.rgba, -r3));
  }, r2.prototype.rotate = function(r3) {
    return void 0 === r3 && (r3 = 15), this.hue(this.hue() + r3);
  }, r2.prototype.alpha = function(r3) {
    return "number" == typeof r3 ? w({ r: (t222 = this.rgba).r, g: t222.g, b: t222.b, a: r3 }) : n(this.rgba.a, 3);
    var t222;
  }, r2.prototype.hue = function(r3) {
    var t222 = c(this.rgba);
    return "number" == typeof r3 ? w({ h: r3, s: t222.s, l: t222.l, a: t222.a }) : n(t222.h);
  }, r2.prototype.isEqual = function(r3) {
    return this.toHex() === w(r3).toHex();
  }, r2;
})(), w = function(r2) {
  return r2 instanceof j$1 ? r2 : new j$1(r2);
}, S$1 = [], k$1 = function(r2) {
  r2.forEach(function(r3) {
    S$1.indexOf(r3) < 0 && (r3(j$1, y$1), S$1.push(r3));
  });
};
var o = function(o2) {
  var t222 = o2 / 255;
  return t222 < 0.04045 ? t222 / 12.92 : Math.pow((t222 + 0.055) / 1.055, 2.4);
}, t = function(t222) {
  return 0.2126 * o(t222.r) + 0.7152 * o(t222.g) + 0.0722 * o(t222.b);
};
function a11yPlugin(o2) {
  o2.prototype.luminance = function() {
    return o3 = t(this.rgba), void 0 === (r2 = 2) && (r2 = 0), void 0 === n2 && (n2 = Math.pow(10, r2)), Math.round(n2 * o3) / n2 + 0;
    var o3, r2, n2;
  }, o2.prototype.contrast = function(r2) {
    void 0 === r2 && (r2 = "#FFF");
    var n2, a2, i2, e2, v2, u2, d2, c2 = r2 instanceof o2 ? r2 : new o2(r2);
    return e2 = this.rgba, v2 = c2.toRgb(), u2 = t(e2), d2 = t(v2), n2 = u2 > d2 ? (u2 + 0.05) / (d2 + 0.05) : (d2 + 0.05) / (u2 + 0.05), void 0 === (a2 = 2) && (a2 = 0), void 0 === i2 && (i2 = Math.pow(10, a2)), Math.floor(i2 * n2) / i2 + 0;
  }, o2.prototype.isReadable = function(o3, t222) {
    return void 0 === o3 && (o3 = "#FFF"), void 0 === t222 && (t222 = {}), this.contrast(o3) >= (e2 = void 0 === (i2 = (r2 = t222).size) ? "normal" : i2, "AAA" === (a2 = void 0 === (n2 = r2.level) ? "AA" : n2) && "normal" === e2 ? 7 : "AA" === a2 && "large" === e2 ? 3 : 4.5);
    var r2, n2, a2, i2, e2;
  };
}
function namesPlugin(e2, f2) {
  var a2 = { white: "#ffffff", bisque: "#ffe4c4", blue: "#0000ff", cadetblue: "#5f9ea0", chartreuse: "#7fff00", chocolate: "#d2691e", coral: "#ff7f50", antiquewhite: "#faebd7", aqua: "#00ffff", azure: "#f0ffff", whitesmoke: "#f5f5f5", papayawhip: "#ffefd5", plum: "#dda0dd", blanchedalmond: "#ffebcd", black: "#000000", gold: "#ffd700", goldenrod: "#daa520", gainsboro: "#dcdcdc", cornsilk: "#fff8dc", cornflowerblue: "#6495ed", burlywood: "#deb887", aquamarine: "#7fffd4", beige: "#f5f5dc", crimson: "#dc143c", cyan: "#00ffff", darkblue: "#00008b", darkcyan: "#008b8b", darkgoldenrod: "#b8860b", darkkhaki: "#bdb76b", darkgray: "#a9a9a9", darkgreen: "#006400", darkgrey: "#a9a9a9", peachpuff: "#ffdab9", darkmagenta: "#8b008b", darkred: "#8b0000", darkorchid: "#9932cc", darkorange: "#ff8c00", darkslateblue: "#483d8b", gray: "#808080", darkslategray: "#2f4f4f", darkslategrey: "#2f4f4f", deeppink: "#ff1493", deepskyblue: "#00bfff", wheat: "#f5deb3", firebrick: "#b22222", floralwhite: "#fffaf0", ghostwhite: "#f8f8ff", darkviolet: "#9400d3", magenta: "#ff00ff", green: "#008000", dodgerblue: "#1e90ff", grey: "#808080", honeydew: "#f0fff0", hotpink: "#ff69b4", blueviolet: "#8a2be2", forestgreen: "#228b22", lawngreen: "#7cfc00", indianred: "#cd5c5c", indigo: "#4b0082", fuchsia: "#ff00ff", brown: "#a52a2a", maroon: "#800000", mediumblue: "#0000cd", lightcoral: "#f08080", darkturquoise: "#00ced1", lightcyan: "#e0ffff", ivory: "#fffff0", lightyellow: "#ffffe0", lightsalmon: "#ffa07a", lightseagreen: "#20b2aa", linen: "#faf0e6", mediumaquamarine: "#66cdaa", lemonchiffon: "#fffacd", lime: "#00ff00", khaki: "#f0e68c", mediumseagreen: "#3cb371", limegreen: "#32cd32", mediumspringgreen: "#00fa9a", lightskyblue: "#87cefa", lightblue: "#add8e6", midnightblue: "#191970", lightpink: "#ffb6c1", mistyrose: "#ffe4e1", moccasin: "#ffe4b5", mintcream: "#f5fffa", lightslategray: "#778899", lightslategrey: "#778899", navajowhite: "#ffdead", navy: "#000080", mediumvioletred: "#c71585", powderblue: "#b0e0e6", palegoldenrod: "#eee8aa", oldlace: "#fdf5e6", paleturquoise: "#afeeee", mediumturquoise: "#48d1cc", mediumorchid: "#ba55d3", rebeccapurple: "#663399", lightsteelblue: "#b0c4de", mediumslateblue: "#7b68ee", thistle: "#d8bfd8", tan: "#d2b48c", orchid: "#da70d6", mediumpurple: "#9370db", purple: "#800080", pink: "#ffc0cb", skyblue: "#87ceeb", springgreen: "#00ff7f", palegreen: "#98fb98", red: "#ff0000", yellow: "#ffff00", slateblue: "#6a5acd", lavenderblush: "#fff0f5", peru: "#cd853f", palevioletred: "#db7093", violet: "#ee82ee", teal: "#008080", slategray: "#708090", slategrey: "#708090", aliceblue: "#f0f8ff", darkseagreen: "#8fbc8f", darkolivegreen: "#556b2f", greenyellow: "#adff2f", seagreen: "#2e8b57", seashell: "#fff5ee", tomato: "#ff6347", silver: "#c0c0c0", sienna: "#a0522d", lavender: "#e6e6fa", lightgreen: "#90ee90", orange: "#ffa500", orangered: "#ff4500", steelblue: "#4682b4", royalblue: "#4169e1", turquoise: "#40e0d0", yellowgreen: "#9acd32", salmon: "#fa8072", saddlebrown: "#8b4513", sandybrown: "#f4a460", rosybrown: "#bc8f8f", darksalmon: "#e9967a", lightgoldenrodyellow: "#fafad2", snow: "#fffafa", lightgrey: "#d3d3d3", lightgray: "#d3d3d3", dimgray: "#696969", dimgrey: "#696969", olivedrab: "#6b8e23", olive: "#808000" }, r2 = {};
  for (var d2 in a2) r2[a2[d2]] = d2;
  var l2 = {};
  e2.prototype.toName = function(f3) {
    if (!(this.rgba.a || this.rgba.r || this.rgba.g || this.rgba.b)) return "transparent";
    var d3, i2, n2 = r2[this.toHex()];
    if (n2) return n2;
    if (null == f3 ? void 0 : f3.closest) {
      var o2 = this.toRgb(), t222 = 1 / 0, b2 = "black";
      if (!l2.length) for (var c2 in a2) l2[c2] = new e2(a2[c2]).toRgb();
      for (var g2 in a2) {
        var u2 = (d3 = o2, i2 = l2[g2], Math.pow(d3.r - i2.r, 2) + Math.pow(d3.g - i2.g, 2) + Math.pow(d3.b - i2.b, 2));
        u2 < t222 && (t222 = u2, b2 = g2);
      }
      return b2;
    }
  };
  f2.string.push([function(f3) {
    var r3 = f3.toLowerCase(), d3 = "transparent" === r3 ? "#0000" : a2[r3];
    return d3 ? new e2(d3).toRgb() : null;
  }, "name"]);
}
k$1([a11yPlugin, namesPlugin]);
let styleAttributes = {
  lineColor: {
    componentType: "text",
    description: "Color used for line strokes (light mode)."
  },
  lineColorWord: {
    componentType: "text",
    description: "Human-readable name of the line color (light mode)."
  },
  lineColorDarkMode: {
    componentType: "text",
    description: "Color used for line strokes (dark mode)."
  },
  lineColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the line color (dark mode)."
  },
  lineOpacity: {
    componentType: "number",
    description: "Opacity of line strokes, 0 to 1."
  },
  lineWidth: {
    componentType: "number",
    description: "Stroke width for lines, in pixels."
  },
  lineWidthWord: {
    componentType: "text",
    description: "Human-readable name of the line width."
  },
  lineStyle: {
    componentType: "text",
    description: "Stroke style for lines.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Continuous, unbroken stroke." },
      {
        value: "dashed",
        description: "Stroke composed of evenly-spaced dashes."
      },
      {
        value: "dotted",
        description: "Stroke composed of evenly-spaced dots."
      }
    ]
  },
  lineStyleWord: {
    componentType: "text",
    description: "Human-readable name of the line style."
  },
  markerColor: {
    componentType: "text",
    description: "Color used for markers/points (light mode)."
  },
  markerColorWord: {
    componentType: "text",
    description: "Human-readable name of the marker color (light mode)."
  },
  markerColorDarkMode: {
    componentType: "text",
    description: "Color used for markers/points (dark mode)."
  },
  markerColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the marker color (dark mode)."
  },
  markerOpacity: {
    componentType: "number",
    description: "Opacity of markers/points, 0 to 1."
  },
  markerStyle: {
    componentType: "text",
    description: "Marker shape.",
    toLowerCase: true,
    validValues: [
      { value: "circle", description: "Circular marker." },
      { value: "square", description: "Square marker." },
      {
        value: "triangle",
        description: 'Triangular marker pointing up (alias for "triangleUp").'
      },
      {
        value: "triangleUp",
        description: "Triangular marker pointing up."
      },
      {
        value: "triangleDown",
        description: "Triangular marker pointing down."
      },
      {
        value: "triangleLeft",
        description: "Triangular marker pointing left."
      },
      {
        value: "triangleRight",
        description: "Triangular marker pointing right."
      },
      { value: "diamond", description: "Diamond-shaped marker." },
      { value: "cross", description: "Cross-shaped marker (×)." },
      { value: "plus", description: "Plus-shaped marker (+)." }
    ]
  },
  markerStyleWord: {
    componentType: "text",
    description: "Human-readable name of the marker style."
  },
  markerSize: {
    componentType: "number",
    description: "Marker size in pixels."
  },
  markerFilled: {
    componentType: "boolean",
    description: "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."
  },
  fillColor: {
    componentType: "text",
    description: "Fill color used inside closed shapes (light mode)."
  },
  fillColorWord: {
    componentType: "text",
    description: "Human-readable name of the fill color (light mode)."
  },
  fillColorDarkMode: {
    componentType: "text",
    description: "Fill color used inside closed shapes (dark mode)."
  },
  fillColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the fill color (dark mode)."
  },
  fillOpacity: {
    componentType: "number",
    description: "Opacity of solid fills, 0 to 1."
  },
  fillPatternOpacity: {
    componentType: "number",
    description: "Opacity of pattern fills (non-solid fillStyle), 0 to 1."
  },
  fillStyle: {
    componentType: "text",
    description: "Fill pattern used inside closed shapes.",
    toLowerCase: true,
    validValues: [
      { value: "solid", description: "Solid fill." },
      {
        value: "horizontal",
        description: "Horizontal line pattern."
      },
      {
        value: "vertical",
        description: "Vertical line pattern."
      },
      {
        value: "diagonal",
        description: "Diagonal line pattern (/)."
      },
      {
        value: "backDiagonal",
        description: "Back-diagonal line pattern (\\)."
      },
      {
        value: "dots",
        description: "Dots pattern."
      },
      {
        value: "diamonds",
        description: "Filled diamonds pattern."
      }
    ]
  },
  fillStyleWord: {
    componentType: "text",
    description: "Human-readable name of the fill style."
  },
  textColor: {
    componentType: "text",
    description: "Text color (light mode)."
  },
  textColorWord: {
    componentType: "text",
    description: "Human-readable name of the text color (light mode)."
  },
  textColorDarkMode: {
    componentType: "text",
    description: "Text color (dark mode)."
  },
  textColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the text color (dark mode)."
  },
  highContrastColor: {
    componentType: "text",
    description: "High-contrast accent color (light mode)."
  },
  highContrastColorWord: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (light mode)."
  },
  highContrastColorDarkMode: {
    componentType: "text",
    description: "High-contrast accent color (dark mode)."
  },
  highContrastColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the high-contrast accent color (dark mode)."
  },
  backgroundColor: {
    componentType: "text",
    description: "Background color (light mode)."
  },
  backgroundColorWord: {
    componentType: "text",
    description: "Human-readable name of the background color (light mode)."
  },
  backgroundColorDarkMode: {
    componentType: "text",
    description: "Background color (dark mode)."
  },
  backgroundColorWordDarkMode: {
    componentType: "text",
    description: "Human-readable name of the background color (dark mode)."
  }
};
styleAttributes.markerStyle.validValues.filter(
  (entry) => entry.value !== "cross" && entry.value !== "plus"
);
const MARKER_OVERRIDE_KEYS = [
  "markerStyle",
  "markerSize",
  "markerFilled"
];
const LINE_OVERRIDE_KEYS = [
  "lineStyle",
  "lineWidth"
];
const FILL_OVERRIDE_KEYS = [
  "fillOpacity",
  "fillPatternOpacity",
  "fillStyle"
];
const markerOverrideAttributes = Object.fromEntries(
  MARKER_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
const lineOverrideAttributes = Object.fromEntries(
  LINE_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
const fillOverrideAttributes = Object.fromEntries(
  FILL_OVERRIDE_KEYS.map((key) => [key, styleAttributes[key]])
);
({
  ...markerOverrideAttributes,
  ...lineOverrideAttributes,
  ...fillOverrideAttributes
});
const STYLE_OVERRIDE_CATEGORIES = {
  marker: markerOverrideAttributes,
  line: lineOverrideAttributes,
  fill: fillOverrideAttributes
};
for (const [category, group2] of Object.entries(STYLE_OVERRIDE_CATEGORIES)) {
  for (const [key, spec] of Object.entries(group2)) {
    if (key.toLowerCase().includes("color")) {
      throw new Error(
        `Style override category "${category}" contains color-related key "${key}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`
      );
    }
    if (key.endsWith("Opacity") && key !== "fillOpacity" && key !== "fillPatternOpacity") {
      throw new Error(
        `Style override category "${category}" contains contrast-feeding opacity key "${key}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`
      );
    }
    if (spec.componentType === "text" && !spec.toLowerCase) {
      throw new Error(
        `Style override key "${key}" in category "${category}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`
      );
    }
  }
}
const coloredItemsForWords = [
  "line",
  "marker",
  "fill",
  "text",
  "highContrast",
  "background"
];
var __create = Object.create, __defProp$1 = Object.defineProperty, __getOwnPropDesc = Object.getOwnPropertyDescriptor, __getOwnPropNames = Object.getOwnPropertyNames, __getProtoOf = Object.getPrototypeOf, __hasOwnProp = Object.prototype.hasOwnProperty, __esmMin = (t4, n2) => () => (t4 && (n2 = t4(t4 = 0)), n2), __commonJSMin = (t4, n2) => () => (n2 || (t4((n2 = { exports: {} }).exports, n2), t4 = null), n2.exports), __exportAll = (t4, n2) => {
  let r2 = {};
  for (var i2 in t4) __defProp$1(r2, i2, { get: t4[i2], enumerable: true });
  return __defProp$1(r2, Symbol.toStringTag, { value: `Module` }), r2;
}, __copyProps = (t4, n2, r2, i2) => {
  if (n2 && typeof n2 == `object` || typeof n2 == `function`) for (var a2 = __getOwnPropNames(n2), o2 = 0, s2 = a2.length, c2; o2 < s2; o2++) c2 = a2[o2], !__hasOwnProp.call(t4, c2) && c2 !== r2 && __defProp$1(t4, c2, { get: ((t5) => n2[t5]).bind(null, c2), enumerable: !(i2 = __getOwnPropDesc(n2, c2)) || i2.enumerable });
  return t4;
}, __toESM = (t4, n2, r2) => (r2 = t4 == null ? {} : __create(__getProtoOf(t4)), __copyProps(__defProp$1(r2, `default`, { value: t4, enumerable: true }), t4)), __toCommonJS = (t4) => __hasOwnProp.call(t4, `module.exports`) ? t4[`module.exports`] : __copyProps(__defProp$1({}, `__esModule`, { value: true }), t4), get_tree = function(t4) {
  if (t4 != null) return t4.tree === void 0 ? t4 : t4.tree;
};
function* subsets(t4, n2) {
  var r2 = t4.length;
  if (n2 === void 0 && (n2 = r2), n2 !== 0) {
    for (let n3 = 0; n3 < r2; n3++) yield [t4[n3]];
    if (n2 !== 1) for (let i2 = 0; i2 < r2; i2++) {
      let r3 = subsets(t4.slice(i2 + 1), n2 - 1);
      for (let n3 of r3) yield [t4[i2]].concat(n3);
    }
  }
}
var is_associative$1 = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten$5(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return flatten$5(t5);
  }), is_associative$1[r2]) {
    for (var a2 = [], o2 = 0; o2 < i2.length; o2++) Array.isArray(i2[o2]) && i2[o2][0] === r2 && i2[o2].length > 2 ? a2 = a2.concat(i2[o2].slice(1)) : a2.push(i2[o2]);
    i2 = a2;
  }
  return [r2].concat(i2);
}
var unflattenRight = function(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenRight(t5);
  }), i2.length > 2 && is_associative$1[r2]) {
    for (var a2 = [r2, i2[0], void 0], o2 = a2, s2 = 1; s2 < i2.length - 1; s2++) o2[2] = [r2, i2[s2], void 0], o2 = o2[2];
    return o2[2] = i2[i2.length - 1], a2;
  }
  return [r2].concat(i2);
}, unflattenLeft = function(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map(function(t5, n3) {
    return unflattenLeft(t5);
  }), i2.length > 2 && is_associative$1[r2]) {
    for (var a2 = [r2, void 0, i2[i2.length - 1]], o2 = a2, s2 = i2.length - 2; s2 > 0; s2--) o2[1] = [r2, void 0, i2[s2]], o2 = o2[1];
    return o2[1] = i2[0], a2;
  }
  return [r2].concat(i2);
}, allChildren = function(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return is_associative$1[n2] ? r2.reduce(function(t5, r3) {
    return Array.isArray(r3) && r3[0] === n2 ? t5.concat(allChildren(r3)) : t5.concat([r3]);
  }, []) : r2;
};
function _extends() {
  return _extends = Object.assign ? Object.assign.bind() : function(t4) {
    for (var n2 = 1; n2 < arguments.length; n2++) {
      var r2 = arguments[n2];
      for (var i2 in r2) ({}).hasOwnProperty.call(r2, i2) && (t4[i2] = r2[i2]);
    }
    return t4;
  }, _extends.apply(null, arguments);
}
var DEFAULT_CONFIG = { relTol: 1e-12, absTol: 1e-15, matrix: `Matrix`, number: `number`, numberFallback: `number`, precision: 64, predictable: false, randomSeed: null, legacySubset: false };
function getSafeProperty(t4, n2) {
  if (isSafeObjectProperty(t4, n2) || isSafeArrayProperty(t4, n2)) return t4[n2];
  throw isSafeMethod(t4, n2) ? Error(`Cannot access method "${n2}" as a property`) : t4 == null ? TypeError(`Cannot access property "${n2}": object is ${t4}`) : Error(`No access to property "` + n2 + `"`);
}
function setSafeProperty(t4, n2, r2) {
  if (isSafeObjectProperty(t4, n2) || isSafeArrayProperty(t4, n2)) return t4[n2] = r2, r2;
  throw Error(`No access to property "${n2}"`);
}
function isSafeObjectProperty(t4, n2) {
  return isPlainObject(t4) ? !(n2 in Object.prototype) : false;
}
function isSafeArrayProperty(t4, n2) {
  return Array.isArray(t4) ? typeof n2 == `number` || typeof n2 == `string` && isInteger$1(n2) || n2 === `length` : false;
}
function isInteger$1(t4) {
  return /^\d+$/.test(t4);
}
function getSafeMethod(t4, n2) {
  if (!isSafeMethod(t4, n2)) throw Error(`No access to method "` + n2 + `"`);
  return t4[n2];
}
function isSafeMethod(t4, n2) {
  return t4 == null || typeof t4[n2] != `function` || hasOwnProperty$1$1(t4, n2) && Object.getPrototypeOf && n2 in Object.getPrototypeOf(t4) ? false : safeNativeMethods.has(n2) ? true : !(n2 in Object.prototype || n2 in Function.prototype);
}
function isPlainObject(t4) {
  return typeof t4 == `object` && t4 && t4.constructor === Object;
}
var safeNativeMethods = /* @__PURE__ */ new Set([`toString`, `valueOf`, `toLocaleString`]), ObjectWrappingMap = class {
  constructor(t4) {
    this.wrappedObject = t4, this[Symbol.iterator] = this.entries;
  }
  keys() {
    return Object.keys(this.wrappedObject).filter((t4) => this.has(t4)).values();
  }
  get(t4) {
    return getSafeProperty(this.wrappedObject, t4);
  }
  set(t4, n2) {
    return setSafeProperty(this.wrappedObject, t4, n2), this;
  }
  has(t4) {
    return isSafeObjectProperty(this.wrappedObject, t4) && t4 in this.wrappedObject;
  }
  entries() {
    return mapIterator(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    isSafeObjectProperty(this.wrappedObject, t4) && delete this.wrappedObject[t4];
  }
  clear() {
    for (var t4 of this.keys()) this.delete(t4);
  }
  get size() {
    return Object.keys(this.wrappedObject).length;
  }
}, PartitionedMap = class {
  constructor(t4, n2, r2) {
    this.a = t4, this.b = n2, this.bKeys = r2, this[Symbol.iterator] = this.entries;
  }
  get(t4) {
    return this.bKeys.has(t4) ? this.b.get(t4) : this.a.get(t4);
  }
  set(t4, n2) {
    return this.bKeys.has(t4) ? this.b.set(t4, n2) : this.a.set(t4, n2), this;
  }
  has(t4) {
    return this.b.has(t4) || this.a.has(t4);
  }
  keys() {
    return (/* @__PURE__ */ new Set([...this.a.keys(), ...this.b.keys()]))[Symbol.iterator]();
  }
  entries() {
    return mapIterator(this.keys(), (t4) => [t4, this.get(t4)]);
  }
  forEach(t4) {
    for (var n2 of this.keys()) t4(this.get(n2), n2, this);
  }
  delete(t4) {
    return this.bKeys.has(t4) ? this.b.delete(t4) : this.a.delete(t4);
  }
  clear() {
    this.a.clear(), this.b.clear();
  }
  get size() {
    return [...this.keys()].length;
  }
};
function mapIterator(t4, n2) {
  return { next: () => {
    var r2 = t4.next();
    return r2.done ? r2 : { value: n2(r2.value), done: false };
  } };
}
function createEmptyMap() {
  return /* @__PURE__ */ new Map();
}
function createMap$1(t4) {
  if (!t4) return createEmptyMap();
  if (isMap(t4)) return t4;
  if (isObject$1(t4)) return new ObjectWrappingMap(t4);
  throw Error(`createMap can create maps from objects or Maps`);
}
function toObject(t4) {
  if (t4 instanceof ObjectWrappingMap) return t4.wrappedObject;
  var n2 = {};
  for (var r2 of t4.keys()) setSafeProperty(n2, r2, t4.get(r2));
  return n2;
}
function isNumber(t4) {
  return typeof t4 == `number`;
}
function isBigNumber(t4) {
  return !t4 || typeof t4 != `object` || typeof t4.constructor != `function` ? false : t4.isBigNumber === true && typeof t4.constructor.prototype == `object` && t4.constructor.prototype.isBigNumber === true || typeof t4.constructor.isDecimal == `function` && t4.constructor.isDecimal(t4) === true;
}
function isBigInt(t4) {
  return typeof t4 == `bigint`;
}
function isComplex(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isComplex === true || false;
}
function isFraction(t4) {
  return t4 && typeof t4 == `object` && Object.getPrototypeOf(t4).isFraction === true || false;
}
function isUnit(t4) {
  return t4 && t4.constructor.prototype.isUnit === true || false;
}
function isString(t4) {
  return typeof t4 == `string`;
}
var isArray = Array.isArray;
function isMatrix(t4) {
  return t4 && t4.constructor.prototype.isMatrix === true || false;
}
function isCollection(t4) {
  return Array.isArray(t4) || isMatrix(t4);
}
function isDenseMatrix(t4) {
  return t4 && t4.isDenseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isSparseMatrix(t4) {
  return t4 && t4.isSparseMatrix && t4.constructor.prototype.isMatrix === true || false;
}
function isRange(t4) {
  return t4 && t4.constructor.prototype.isRange === true || false;
}
function isIndex(t4) {
  return t4 && t4.constructor.prototype.isIndex === true || false;
}
function isBoolean$1(t4) {
  return typeof t4 == `boolean`;
}
function isResultSet(t4) {
  return t4 && t4.constructor.prototype.isResultSet === true || false;
}
function isHelp(t4) {
  return t4 && t4.constructor.prototype.isHelp === true || false;
}
function isFunction$1(t4) {
  return typeof t4 == `function`;
}
function isDate(t4) {
  return t4 instanceof Date;
}
function isRegExp(t4) {
  return t4 instanceof RegExp;
}
function isObject$1(t4) {
  return !!(t4 && typeof t4 == `object` && t4.constructor === Object && !isComplex(t4) && !isFraction(t4));
}
function isMap(t4) {
  return t4 ? t4 instanceof Map || t4 instanceof ObjectWrappingMap || typeof t4.set == `function` && typeof t4.get == `function` && typeof t4.keys == `function` && typeof t4.has == `function` : false;
}
function isPartitionedMap(t4) {
  return isMap(t4) && isMap(t4.a) && isMap(t4.b);
}
function isObjectWrappingMap(t4) {
  return isMap(t4) && isObject$1(t4.wrappedObject);
}
function isNull$1(t4) {
  return t4 === null;
}
function isUndefined$1(t4) {
  return t4 === void 0;
}
function isAccessorNode(t4) {
  return t4 && t4.isAccessorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isArrayNode(t4) {
  return t4 && t4.isArrayNode === true && t4.constructor.prototype.isNode === true || false;
}
function isAssignmentNode(t4) {
  return t4 && t4.isAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isBlockNode(t4) {
  return t4 && t4.isBlockNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConditionalNode(t4) {
  return t4 && t4.isConditionalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isConstantNode(t4) {
  return t4 && t4.isConstantNode === true && t4.constructor.prototype.isNode === true || false;
}
function rule2Node(t4) {
  return isConstantNode(t4) || isOperatorNode(t4) && t4.args.length === 1 && isConstantNode(t4.args[0]) && `-+~`.includes(t4.op);
}
function isFunctionAssignmentNode(t4) {
  return t4 && t4.isFunctionAssignmentNode === true && t4.constructor.prototype.isNode === true || false;
}
function isFunctionNode(t4) {
  return t4 && t4.isFunctionNode === true && t4.constructor.prototype.isNode === true || false;
}
function isIndexNode(t4) {
  return t4 && t4.isIndexNode === true && t4.constructor.prototype.isNode === true || false;
}
function isNode$2(t4) {
  return t4 && t4.isNode === true && t4.constructor.prototype.isNode === true || false;
}
function isObjectNode(t4) {
  return t4 && t4.isObjectNode === true && t4.constructor.prototype.isNode === true || false;
}
function isOperatorNode(t4) {
  return t4 && t4.isOperatorNode === true && t4.constructor.prototype.isNode === true || false;
}
function isParenthesisNode(t4) {
  return t4 && t4.isParenthesisNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRangeNode(t4) {
  return t4 && t4.isRangeNode === true && t4.constructor.prototype.isNode === true || false;
}
function isRelationalNode(t4) {
  return t4 && t4.isRelationalNode === true && t4.constructor.prototype.isNode === true || false;
}
function isSymbolNode(t4) {
  return t4 && t4.isSymbolNode === true && t4.constructor.prototype.isNode === true || false;
}
function isChain(t4) {
  return t4 && t4.constructor.prototype.isChain === true || false;
}
function typeOf(t4) {
  var n2 = typeof t4;
  return n2 === `object` ? t4 === null ? `null` : isBigNumber(t4) ? `BigNumber` : t4.constructor && t4.constructor.name ? t4.constructor.name : `Object` : n2;
}
function clone$3(t4) {
  var n2 = typeof t4;
  if (n2 === `number` || n2 === `bigint` || n2 === `string` || n2 === `boolean` || t4 == null) return t4;
  if (typeof t4.clone == `function`) return t4.clone();
  if (Array.isArray(t4)) return t4.map(function(t5) {
    return clone$3(t5);
  });
  if (t4 instanceof Date) return new Date(t4.valueOf());
  if (isBigNumber(t4)) return t4;
  if (isObject$1(t4)) return mapObject$1(t4, clone$3);
  if (n2 === `function`) return t4;
  throw TypeError(`Cannot clone: unknown type of value (value: ${t4})`);
}
function mapObject$1(t4, n2) {
  var r2 = {};
  for (var i2 in t4) hasOwnProperty$1$1(t4, i2) && (r2[i2] = n2(t4[i2]));
  return r2;
}
function extend$1(t4, n2) {
  for (var r2 in n2) hasOwnProperty$1$1(n2, r2) && (t4[r2] = n2[r2]);
  return t4;
}
function deepExtend(t4, n2) {
  if (Array.isArray(n2)) throw TypeError(`Arrays are not supported by deepExtend`);
  for (var r2 in n2) if (hasOwnProperty$1$1(n2, r2) && !(r2 in Object.prototype) && !(r2 in Function.prototype)) if (n2[r2] && n2[r2].constructor === Object) t4[r2] === void 0 && (t4[r2] = {}), t4[r2] && t4[r2].constructor === Object ? deepExtend(t4[r2], n2[r2]) : t4[r2] = n2[r2];
  else if (Array.isArray(n2[r2])) throw TypeError(`Arrays are not supported by deepExtend`);
  else t4[r2] = n2[r2];
  return t4;
}
function deepStrictEqual(t4, n2) {
  var r2, i2, a2;
  if (Array.isArray(t4)) {
    if (!Array.isArray(n2) || t4.length !== n2.length) return false;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) if (!deepStrictEqual(t4[i2], n2[i2])) return false;
    return true;
  } else if (typeof t4 == `function`) return t4 === n2;
  else if (t4 instanceof Object) {
    if (Array.isArray(n2) || !(n2 instanceof Object)) return false;
    for (r2 in t4) if (!(r2 in n2) || !deepStrictEqual(t4[r2], n2[r2])) return false;
    for (r2 in n2) if (!(r2 in t4)) return false;
    return true;
  } else return t4 === n2;
}
function deepFlatten(t4) {
  var n2 = {};
  return _deepFlatten(t4, n2), n2;
}
function _deepFlatten(t4, n2) {
  for (var r2 in t4) if (hasOwnProperty$1$1(t4, r2)) {
    var i2 = t4[r2];
    typeof i2 == `object` && i2 ? _deepFlatten(i2, n2) : n2[r2] = i2;
  }
}
function lazy(t4, n2, r2) {
  var i2 = true, a2;
  Object.defineProperty(t4, n2, { get: function() {
    return i2 &&= (a2 = r2(), false), a2;
  }, set: function(t5) {
    a2 = t5, i2 = false;
  }, configurable: true, enumerable: true });
}
function hasOwnProperty$1$1(t4, n2) {
  return t4 && Object.hasOwnProperty.call(t4, n2);
}
function isLegacyFactory(t4) {
  return t4 && typeof t4.factory == `function`;
}
function pickShallow(t4, n2) {
  for (var r2 = {}, i2 = 0; i2 < n2.length; i2++) {
    var a2 = n2[i2], o2 = t4[a2];
    o2 !== void 0 && (r2[a2] = o2);
  }
  return r2;
}
var MATRIX_OPTIONS = [`Matrix`, `Array`], NUMBER_OPTIONS = [`number`, `BigNumber`, `bigint`, `Fraction`];
function configFactory(t4, n2) {
  function r2(i2) {
    if (i2) {
      if (i2.epsilon !== void 0) {
        console.warn(`Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.`);
        var a2 = clone$3(i2);
        return a2.relTol = i2.epsilon, a2.absTol = i2.epsilon * 1e-3, delete a2.epsilon, r2(a2);
      }
      i2.legacySubset === true && console.warn(`Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.`);
      var o2 = clone$3(t4);
      validateOption(i2, `matrix`, MATRIX_OPTIONS), validateOption(i2, `number`, NUMBER_OPTIONS), deepExtend(t4, i2);
      var s2 = clone$3(t4);
      return n2(`config`, s2, o2, clone$3(i2)), s2;
    } else return clone$3(t4);
  }
  return r2.MATRIX_OPTIONS = MATRIX_OPTIONS, r2.NUMBER_OPTIONS = NUMBER_OPTIONS, Object.keys(DEFAULT_CONFIG).forEach((n3) => {
    Object.defineProperty(r2, n3, { get: () => t4[n3], enumerable: true, configurable: true });
  }), r2;
}
function validateOption(t4, n2, r2) {
  t4[n2] !== void 0 && !r2.includes(t4[n2]) && console.warn(`Warning: Unknown value "` + t4[n2] + `" for configuration option "` + n2 + `". Available options: ` + r2.map((t5) => JSON.stringify(t5)).join(`, `) + `.`);
}
var require_typed_function = __commonJSMin(((t4, n2) => {
  (function(r2, i2) {
    typeof t4 == `object` && n2 !== void 0 ? n2.exports = i2() : typeof define == `function` && define.amd ? define(i2) : (r2 = typeof globalThis < `u` ? globalThis : r2 || self, r2[`'typed'`] = i2());
  })(t4, (function() {
    function t5() {
      return true;
    }
    function n3() {
      return false;
    }
    function r2() {
    }
    let i2 = `Argument is not a typed-function.`;
    function a2() {
      function o2(t6) {
        return typeof t6 == `object` && !!t6 && t6.constructor === Object;
      }
      let s2 = [{ name: `number`, test: function(t6) {
        return typeof t6 == `number`;
      } }, { name: `string`, test: function(t6) {
        return typeof t6 == `string`;
      } }, { name: `boolean`, test: function(t6) {
        return typeof t6 == `boolean`;
      } }, { name: `Function`, test: function(t6) {
        return typeof t6 == `function`;
      } }, { name: `Array`, test: Array.isArray }, { name: `Date`, test: function(t6) {
        return t6 instanceof Date;
      } }, { name: `RegExp`, test: function(t6) {
        return t6 instanceof RegExp;
      } }, { name: `Object`, test: o2 }, { name: `null`, test: function(t6) {
        return t6 === null;
      } }, { name: `undefined`, test: function(t6) {
        return t6 === void 0;
      } }], c2 = { name: `any`, test: t5, isAny: true }, l2, u2, d2 = 0, p2 = { createCount: 0 };
      function m2(t6) {
        let n4 = l2.get(t6);
        if (n4) return n4;
        let r3 = `Unknown type "` + t6 + `"`, i3 = t6.toLowerCase(), a3;
        for (a3 of u2) if (a3.toLowerCase() === i3) {
          r3 += `. Did you mean "` + a3 + `" ?`;
          break;
        }
        throw TypeError(r3);
      }
      function h2(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `any`, r3 = n4 ? m2(n4).index : u2.length, i3 = [];
        for (let n5 = 0; n5 < t6.length; ++n5) {
          if (!t6[n5] || typeof t6[n5].name != `string` || typeof t6[n5].test != `function`) throw TypeError(`Object with properties {name: string, test: function} expected`);
          let a4 = t6[n5].name;
          if (l2.has(a4)) throw TypeError(`Duplicate type name "` + a4 + `"`);
          i3.push(a4), l2.set(a4, { name: a4, test: t6[n5].test, isAny: t6[n5].isAny, index: r3 + n5, conversionsTo: [] });
        }
        let a3 = u2.slice(r3);
        u2 = u2.slice(0, r3).concat(i3).concat(a3);
        for (let t7 = r3 + i3.length; t7 < u2.length; ++t7) l2.get(u2[t7]).index = t7;
      }
      function g2() {
        l2 = /* @__PURE__ */ new Map(), u2 = [], d2 = 0, h2([c2], false);
      }
      g2(), h2(s2);
      function v2() {
        let t6;
        for (t6 of u2) l2.get(t6).conversionsTo = [];
        d2 = 0;
      }
      function y2(t6) {
        let n4 = u2.filter((n5) => {
          let r3 = l2.get(n5);
          return !r3.isAny && r3.test(t6);
        });
        return n4.length ? n4 : [`any`];
      }
      function b2(t6) {
        return t6 && typeof t6 == `function` && `_typedFunctionData` in t6;
      }
      function x2(t6, n4, r3) {
        if (!b2(t6)) throw TypeError(i2);
        let a3 = r3 && r3.exact, o3 = M2(Array.isArray(n4) ? n4.join(`,`) : n4), s3 = E(o3);
        if (!a3 || s3 in t6.signatures) {
          let n5 = t6._typedFunctionData.signatureMap.get(s3);
          if (n5) return n5;
        }
        let c3 = o3.length, l3;
        if (a3) {
          l3 = [];
          let n5;
          for (n5 in t6.signatures) l3.push(t6._typedFunctionData.signatureMap.get(n5));
        } else l3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < c3; ++t7) {
          let n5 = o3[t7], r4 = [], i3;
          for (i3 of l3) {
            let a4 = L2(i3.params, t7);
            if (!(!a4 || n5.restParam && !a4.restParam)) {
              if (!a4.hasAny) {
                let t8 = j2(a4);
                if (n5.types.some((n6) => !t8.has(n6.name))) continue;
              }
              r4.push(i3);
            }
          }
          if (l3 = r4, l3.length === 0) break;
        }
        let u3;
        for (u3 of l3) if (u3.params.length <= c3) return u3;
        throw TypeError(`Signature not found (signature: ` + (t6.name || `unnamed`) + `(` + E(o3, `, `) + `))`);
      }
      function S2(t6, n4, r3) {
        return x2(t6, n4, r3).implementation;
      }
      function w2(t6, n4) {
        let r3 = m2(n4);
        if (r3.test(t6)) return t6;
        let i3 = r3.conversionsTo;
        if (i3.length === 0) throw Error(`There are no conversions to ` + n4 + ` defined.`);
        for (let n5 = 0; n5 < i3.length; n5++) if (m2(i3[n5].from).test(t6)) return i3[n5].convert(t6);
        throw Error(`Cannot convert ` + t6 + ` to ` + n4);
      }
      function E(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `,`;
        return t6.map((t7) => t7.name).join(n4);
      }
      function D(t6) {
        let n4 = t6.indexOf(`...`) === 0, r3 = (n4 ? t6.length > 3 ? t6.slice(3) : `any` : t6).split(`|`).map((t7) => m2(t7.trim())), i3 = false, a3 = n4 ? `...` : ``;
        return { types: r3.map(function(t7) {
          return i3 = t7.isAny || i3, a3 += t7.name + `|`, { name: t7.name, typeIndex: t7.index, test: t7.test, isAny: t7.isAny, conversion: null, conversionIndex: -1 };
        }), name: a3.slice(0, -1), hasAny: i3, hasConversion: false, restParam: n4 };
      }
      function O2(t6) {
        let n4 = q2(t6.types.map((t7) => t7.name)), r3 = t6.hasAny, i3 = t6.name, a3 = n4.map(function(t7) {
          let n5 = m2(t7.from);
          return r3 = n5.isAny || r3, i3 += `|` + t7.from, { name: t7.from, typeIndex: n5.index, test: n5.test, isAny: n5.isAny, conversion: t7, conversionIndex: t7.index };
        });
        return { types: t6.types.concat(a3), name: i3, hasAny: r3, hasConversion: a3.length > 0, restParam: t6.restParam };
      }
      function j2(t6) {
        return t6.typeSet || (t6.typeSet = /* @__PURE__ */ new Set(), t6.types.forEach((n4) => t6.typeSet.add(n4.name))), t6.typeSet;
      }
      function M2(t6) {
        let n4 = [];
        if (typeof t6 != `string`) throw TypeError(`Signatures must be strings`);
        let r3 = t6.trim();
        if (r3 === ``) return n4;
        let i3 = r3.split(`,`);
        for (let t7 = 0; t7 < i3.length; ++t7) {
          let r4 = D(i3[t7].trim());
          if (r4.restParam && t7 !== i3.length - 1) throw SyntaxError(`Unexpected rest parameter "` + i3[t7] + `": only allowed for the last parameter`);
          if (r4.types.length === 0) return null;
          n4.push(r4);
        }
        return n4;
      }
      function N2(t6) {
        let n4 = se2(t6);
        return n4 ? n4.restParam : false;
      }
      function F(n4) {
        if (!n4 || n4.types.length === 0) return t5;
        if (n4.types.length === 1) return m2(n4.types[0].name).test;
        if (n4.types.length === 2) {
          let t6 = m2(n4.types[0].name).test, r3 = m2(n4.types[1].name).test;
          return function(n5) {
            return t6(n5) || r3(n5);
          };
        } else {
          let t6 = n4.types.map(function(t7) {
            return m2(t7.name).test;
          });
          return function(n5) {
            for (let r3 = 0; r3 < t6.length; r3++) if (t6[r3](n5)) return true;
            return false;
          };
        }
      }
      function I2(t6) {
        let n4, r3, i3;
        if (N2(t6)) {
          n4 = $2(t6).map(F);
          let r4 = n4.length, i4 = F(se2(t6)), a3 = function(t7) {
            for (let n5 = r4; n5 < t7.length; n5++) if (!i4(t7[n5])) return false;
            return true;
          };
          return function(t7) {
            for (let r5 = 0; r5 < n4.length; r5++) if (!n4[r5](t7[r5])) return false;
            return a3(t7) && t7.length >= r4 + 1;
          };
        } else if (t6.length === 0) return function(t7) {
          return t7.length === 0;
        };
        else if (t6.length === 1) return r3 = F(t6[0]), function(t7) {
          return r3(t7[0]) && t7.length === 1;
        };
        else if (t6.length === 2) return r3 = F(t6[0]), i3 = F(t6[1]), function(t7) {
          return r3(t7[0]) && i3(t7[1]) && t7.length === 2;
        };
        else return n4 = t6.map(F), function(t7) {
          for (let r4 = 0; r4 < n4.length; r4++) if (!n4[r4](t7[r4])) return false;
          return t7.length === n4.length;
        };
      }
      function L2(t6, n4) {
        return n4 < t6.length ? t6[n4] : N2(t6) ? se2(t6) : null;
      }
      function R2(t6, n4) {
        let r3 = L2(t6, n4);
        return r3 ? j2(r3) : /* @__PURE__ */ new Set();
      }
      function z2(t6) {
        return t6.conversion === null || t6.conversion === void 0;
      }
      function V2(t6, n4) {
        let r3 = /* @__PURE__ */ new Set();
        return t6.forEach((t7) => {
          let i3 = R2(t7.params, n4), a3;
          for (a3 of i3) r3.add(a3);
        }), r3.has(`any`) ? [`any`] : Array.from(r3);
      }
      function H2(t6, n4, r3) {
        let i3, a3, o3 = t6 || `unnamed`, s3 = r3, c3;
        for (c3 = 0; c3 < n4.length; c3++) {
          let t7 = [];
          if (s3.forEach((r4) => {
            let i4 = F(L2(r4.params, c3));
            (c3 < r4.params.length || N2(r4.params)) && i4(n4[c3]) && t7.push(r4);
          }), t7.length === 0) {
            if (a3 = V2(s3, c3), a3.length > 0) {
              let t8 = y2(n4[c3]);
              return i3 = TypeError(`Unexpected type of argument in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, actual: ` + t8.join(` | `) + `, index: ` + c3 + `)`), i3.data = { category: `wrongType`, fn: o3, index: c3, actual: t8, expected: a3 }, i3;
            }
          } else s3 = t7;
        }
        let l3 = s3.map(function(t7) {
          return N2(t7.params) ? 1 / 0 : t7.params.length;
        });
        if (n4.length < Math.min.apply(null, l3)) return a3 = V2(s3, c3), i3 = TypeError(`Too few arguments in function ` + o3 + ` (expected: ` + a3.join(` or `) + `, index: ` + n4.length + `)`), i3.data = { category: `tooFewArgs`, fn: o3, index: n4.length, expected: a3 }, i3;
        let u3 = Math.max.apply(null, l3);
        if (n4.length > u3) return i3 = TypeError(`Too many arguments in function ` + o3 + ` (expected: ` + u3 + `, actual: ` + n4.length + `)`), i3.data = { category: `tooManyArgs`, fn: o3, index: n4.length, expectedLength: u3 }, i3;
        let d3 = [];
        for (let t7 = 0; t7 < n4.length; ++t7) d3.push(y2(n4[t7]).join(`|`));
        return i3 = TypeError(`Arguments of type "` + d3.join(`, `) + `" do not match any of the defined signatures of function ` + o3 + `.`), i3.data = { category: `mismatch`, actual: d3 }, i3;
      }
      function U2(t6) {
        let n4 = u2.length + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) && (n4 = Math.min(n4, t6.types[r3].typeIndex));
        return n4;
      }
      function W2(t6) {
        let n4 = d2 + 1;
        for (let r3 = 0; r3 < t6.types.length; r3++) z2(t6.types[r3]) || (n4 = Math.min(n4, t6.types[r3].conversionIndex));
        return n4;
      }
      function G2(t6, n4) {
        if (t6.hasAny) {
          if (!n4.hasAny) return 1;
        } else if (n4.hasAny) return -1;
        if (t6.restParam) {
          if (!n4.restParam) return 1;
        } else if (n4.restParam) return -1;
        if (t6.hasConversion) {
          if (!n4.hasConversion) return 1;
        } else if (n4.hasConversion) return -1;
        let r3 = U2(t6) - U2(n4);
        if (r3 < 0) return -1;
        if (r3 > 0) return 1;
        let i3 = W2(t6) - W2(n4);
        return i3 < 0 ? -1 : +(i3 > 0);
      }
      function K2(t6, n4) {
        let r3 = t6.params, i3 = n4.params, a3 = se2(r3), o3 = se2(i3), s3 = N2(r3), c3 = N2(i3);
        if (s3 && a3.hasAny) {
          if (!c3 || !o3.hasAny) return 1;
        } else if (c3 && o3.hasAny) return -1;
        let l3 = 0, u3 = 0, d3;
        for (d3 of r3) d3.hasAny && ++l3, d3.hasConversion && ++u3;
        let p3 = 0, m3 = 0;
        for (d3 of i3) d3.hasAny && ++p3, d3.hasConversion && ++m3;
        if (l3 !== p3) return l3 - p3;
        if (s3 && a3.hasConversion) {
          if (!c3 || !o3.hasConversion) return 1;
        } else if (c3 && o3.hasConversion) return -1;
        if (u3 !== m3) return u3 - m3;
        if (s3) {
          if (!c3) return 1;
        } else if (c3) return -1;
        let h3 = (r3.length - i3.length) * (s3 ? -1 : 1);
        if (h3 !== 0) return h3;
        let g3 = [], v3 = 0;
        for (let t7 = 0; t7 < r3.length; ++t7) {
          let n5 = G2(r3[t7], i3[t7]);
          g3.push(n5), v3 += n5;
        }
        if (v3 !== 0) return v3;
        let y3;
        for (y3 of g3) if (y3 !== 0) return y3;
        return 0;
      }
      function q2(t6) {
        if (t6.length === 0) return [];
        let n4 = t6.map(m2);
        t6.length > 1 && n4.sort((t7, n5) => t7.index - n5.index);
        let r3 = n4[0].conversionsTo;
        if (t6.length === 1) return r3;
        r3 = r3.concat([]);
        let i3 = new Set(t6);
        for (let t7 = 1; t7 < n4.length; ++t7) {
          let a3;
          for (a3 of n4[t7].conversionsTo) i3.has(a3.from) || (r3.push(a3), i3.add(a3.from));
        }
        return r3;
      }
      function J(t6, n4) {
        let r3 = n4;
        if (t6.some((t7) => t7.hasConversion)) {
          let i4 = N2(t6), a3 = t6.map(ee2);
          r3 = function() {
            let t7 = [], r4 = i4 ? arguments.length - 1 : arguments.length;
            for (let n5 = 0; n5 < r4; n5++) t7[n5] = a3[n5](arguments[n5]);
            return i4 && (t7[r4] = arguments[r4].map(a3[r4])), n4.apply(this, t7);
          };
        }
        let i3 = r3;
        if (N2(t6)) {
          let n5 = t6.length - 1;
          i3 = function() {
            return r3.apply(this, ce2(arguments, 0, n5).concat([ce2(arguments, n5)]));
          };
        }
        return i3;
      }
      function ee2(t6) {
        let n4, r3, i3, a3, o3 = [], s3 = [];
        switch (t6.types.forEach(function(t7) {
          t7.conversion && (o3.push(m2(t7.conversion.from).test), s3.push(t7.conversion.convert));
        }), s3.length) {
          case 0:
            return function(t7) {
              return t7;
            };
          case 1:
            return n4 = o3[0], i3 = s3[0], function(t7) {
              return n4(t7) ? i3(t7) : t7;
            };
          case 2:
            return n4 = o3[0], r3 = o3[1], i3 = s3[0], a3 = s3[1], function(t7) {
              return n4(t7) ? i3(t7) : r3(t7) ? a3(t7) : t7;
            };
          default:
            return function(t7) {
              for (let n5 = 0; n5 < s3.length; n5++) if (o3[n5](t7)) return s3[n5](t7);
              return t7;
            };
        }
      }
      function Y2(t6) {
        function n4(t7, r3, i3) {
          if (r3 < t7.length) {
            let a3 = t7[r3], o3 = [];
            if (a3.restParam) {
              let t8 = a3.types.filter(z2);
              t8.length < a3.types.length && o3.push({ types: t8, name: `...` + t8.map((t9) => t9.name).join(`|`), hasAny: t8.some((t9) => t9.isAny), hasConversion: false, restParam: true }), o3.push(a3);
            } else o3 = a3.types.map(function(t8) {
              return { types: [t8], name: t8.name, hasAny: t8.isAny, hasConversion: t8.conversion, restParam: false };
            });
            return ue2(o3, function(a4) {
              return n4(t7, r3 + 1, i3.concat([a4]));
            });
          } else return [i3];
        }
        return n4(t6, 0, []);
      }
      function te2(t6, n4) {
        let r3 = Math.max(t6.length, n4.length);
        for (let i4 = 0; i4 < r3; i4++) {
          let r4 = R2(t6, i4), a4 = R2(n4, i4), o4 = false, s4;
          for (s4 of a4) if (r4.has(s4)) {
            o4 = true;
            break;
          }
          if (!o4) return false;
        }
        let i3 = t6.length, a3 = n4.length, o3 = N2(t6), s3 = N2(n4);
        return o3 ? s3 ? i3 === a3 : a3 >= i3 : s3 ? i3 >= a3 : i3 === a3;
      }
      function ne2(t6) {
        return t6.map((t7) => he2(t7) ? pe2(t7.referToSelf.callback) : me2(t7) ? fe2(t7.referTo.references, t7.referTo.callback) : t7);
      }
      function X2(t6, n4, r3) {
        let i3 = [], a3;
        for (a3 of t6) {
          let t7 = r3[a3];
          if (typeof t7 != `number`) throw TypeError(`No definition for referenced signature "` + a3 + `"`);
          if (t7 = n4[t7], typeof t7 != `function`) return false;
          i3.push(t7);
        }
        return i3;
      }
      function ie2(t6, n4, r3) {
        let i3 = ne2(t6), a3 = Array(i3.length).fill(false), o3 = true;
        for (; o3; ) {
          o3 = false;
          let t7 = true;
          for (let s3 = 0; s3 < i3.length; ++s3) {
            if (a3[s3]) continue;
            let c3 = i3[s3];
            if (he2(c3)) i3[s3] = c3.referToSelf.callback(r3), i3[s3].referToSelf = c3.referToSelf, a3[s3] = true, t7 = false;
            else if (me2(c3)) {
              let r4 = X2(c3.referTo.references, i3, n4);
              r4 ? (i3[s3] = c3.referTo.callback.apply(this, r4), i3[s3].referTo = c3.referTo, a3[s3] = true, t7 = false) : o3 = true;
            }
          }
          if (t7 && o3) throw SyntaxError(`Circular reference detected in resolving typed.referTo`);
        }
        return i3;
      }
      function ae2(t6) {
        let n4 = /\bthis(\(|\.signatures\b)/;
        Object.keys(t6).forEach((r3) => {
          let i3 = t6[r3];
          if (n4.test(i3.toString())) throw SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.");
        });
      }
      function Z2(t6, i3) {
        if (p2.createCount++, Object.keys(i3).length === 0) throw SyntaxError(`No signatures provided`);
        p2.warnAgainstDeprecatedThis && ae2(i3);
        let a3 = [], o3 = [], s3 = {}, c3 = [], l3;
        for (l3 in i3) {
          if (!Object.prototype.hasOwnProperty.call(i3, l3)) continue;
          let t7 = M2(l3);
          if (!t7) continue;
          a3.forEach(function(n5) {
            if (te2(n5, t7)) throw TypeError(`Conflicting signatures "` + E(n5) + `" and "` + E(t7) + `".`);
          }), a3.push(t7);
          let n4 = o3.length;
          o3.push(i3[l3]);
          let r3 = t7.map(O2), u4;
          for (u4 of Y2(r3)) {
            let t8 = E(u4);
            c3.push({ params: u4, name: t8, fn: n4 }), u4.every((t9) => !t9.hasConversion) && (s3[t8] = n4);
          }
        }
        c3.sort(K2);
        let u3 = ie2(o3, s3, ye22), d3;
        for (d3 in s3) Object.prototype.hasOwnProperty.call(s3, d3) && (s3[d3] = u3[s3[d3]]);
        let m3 = [], h3 = /* @__PURE__ */ new Map();
        for (d3 of c3) h3.has(d3.name) || (d3.fn = u3[d3.fn], m3.push(d3), h3.set(d3.name, d3));
        let g3 = m3[0] && m3[0].params.length <= 2 && !N2(m3[0].params), v3 = m3[1] && m3[1].params.length <= 2 && !N2(m3[1].params), y3 = m3[2] && m3[2].params.length <= 2 && !N2(m3[2].params), b3 = m3[3] && m3[3].params.length <= 2 && !N2(m3[3].params), x3 = m3[4] && m3[4].params.length <= 2 && !N2(m3[4].params), S3 = m3[5] && m3[5].params.length <= 2 && !N2(m3[5].params), w3 = g3 && v3 && y3 && b3 && x3 && S3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].test = I2(m3[t7].params);
        let D2 = g3 ? F(m3[0].params[0]) : n3, j3 = v3 ? F(m3[1].params[0]) : n3, L22 = y3 ? F(m3[2].params[0]) : n3, R22 = b3 ? F(m3[3].params[0]) : n3, z22 = x3 ? F(m3[4].params[0]) : n3, V22 = S3 ? F(m3[5].params[0]) : n3, H3 = g3 ? F(m3[0].params[1]) : n3, U22 = v3 ? F(m3[1].params[1]) : n3, W22 = y3 ? F(m3[2].params[1]) : n3, G22 = b3 ? F(m3[3].params[1]) : n3, q22 = x3 ? F(m3[4].params[1]) : n3, ee22 = S3 ? F(m3[5].params[1]) : n3;
        for (let t7 = 0; t7 < m3.length; ++t7) m3[t7].implementation = J(m3[t7].params, m3[t7].fn);
        let ne22 = g3 ? m3[0].implementation : r2, X22 = v3 ? m3[1].implementation : r2, Z22 = y3 ? m3[2].implementation : r2, oe22 = b3 ? m3[3].implementation : r2, $3 = x3 ? m3[4].implementation : r2, se22 = S3 ? m3[5].implementation : r2, ce22 = g3 ? m3[0].params.length : -1, le22 = v3 ? m3[1].params.length : -1, ue22 = y3 ? m3[2].params.length : -1, de22 = b3 ? m3[3].params.length : -1, fe22 = x3 ? m3[4].params.length : -1, pe22 = S3 ? m3[5].params.length : -1, me22 = w3 ? 6 : 0, he22 = m3.length, ge22 = m3.map((t7) => t7.test), _e22 = m3.map((t7) => t7.implementation), ve22 = function() {
          for (let t7 = me22; t7 < he22; t7++) if (ge22[t7](arguments)) return _e22[t7].apply(this, arguments);
          return p2.onMismatch(t6, arguments, m3);
        };
        function ye22(t7, n4) {
          return arguments.length === ce22 && D2(t7) && H3(n4) ? ne22.apply(this, arguments) : arguments.length === le22 && j3(t7) && U22(n4) ? X22.apply(this, arguments) : arguments.length === ue22 && L22(t7) && W22(n4) ? Z22.apply(this, arguments) : arguments.length === de22 && R22(t7) && G22(n4) ? oe22.apply(this, arguments) : arguments.length === fe22 && z22(t7) && q22(n4) ? $3.apply(this, arguments) : arguments.length === pe22 && V22(t7) && ee22(n4) ? se22.apply(this, arguments) : ve22.apply(this, arguments);
        }
        try {
          Object.defineProperty(ye22, "name", { value: t6 });
        } catch {
        }
        return ye22.signatures = s3, ye22._typedFunctionData = { signatures: m3, signatureMap: h3 }, ye22;
      }
      function oe2(t6, n4, r3) {
        throw H2(t6, n4, r3);
      }
      function $2(t6) {
        return ce2(t6, 0, t6.length - 1);
      }
      function se2(t6) {
        return t6[t6.length - 1];
      }
      function ce2(t6, n4, r3) {
        return Array.prototype.slice.call(t6, n4, r3);
      }
      function le2(t6, n4) {
        for (let r3 = 0; r3 < t6.length; r3++) if (n4(t6[r3])) return t6[r3];
      }
      function ue2(t6, n4) {
        return Array.prototype.concat.apply([], t6.map(n4));
      }
      function de2() {
        let t6 = $2(arguments).map((t7) => E(M2(t7))), n4 = se2(arguments);
        if (typeof n4 != `function`) throw TypeError(`Callback function expected as last argument`);
        return fe2(t6, n4);
      }
      function fe2(t6, n4) {
        return { referTo: { references: t6, callback: n4 } };
      }
      function pe2(t6) {
        if (typeof t6 != `function`) throw TypeError(`Callback function expected as first argument`);
        return { referToSelf: { callback: t6 } };
      }
      function me2(t6) {
        return t6 && typeof t6.referTo == `object` && Array.isArray(t6.referTo.references) && typeof t6.referTo.callback == `function`;
      }
      function he2(t6) {
        return t6 && typeof t6.referToSelf == `object` && typeof t6.referToSelf.callback == `function`;
      }
      function ge2(t6, n4) {
        if (!t6) return n4;
        if (n4 && n4 !== t6) {
          let r3 = Error(`Function names do not match (expected: ` + t6 + `, actual: ` + n4 + `)`);
          throw r3.data = { actual: n4, expected: t6 }, r3;
        }
        return t6;
      }
      function _e2(t6) {
        let n4;
        for (let r3 in t6) Object.prototype.hasOwnProperty.call(t6, r3) && (b2(t6[r3]) || typeof t6[r3].signature == `string`) && (n4 = ge2(n4, t6[r3].name));
        return n4;
      }
      function ve2(t6, n4) {
        let r3;
        for (r3 in n4) if (Object.prototype.hasOwnProperty.call(n4, r3)) {
          if (r3 in t6 && n4[r3] !== t6[r3]) {
            let i3 = Error(`Signature "` + r3 + `" is defined twice`);
            throw i3.data = { signature: r3, sourceFunction: n4[r3], destFunction: t6[r3] }, i3;
          }
          t6[r3] = n4[r3];
        }
      }
      let ye2 = p2;
      p2 = function(t6) {
        let n4 = typeof t6 == `string`, r3 = +!!n4, i3 = n4 ? t6 : ``, a3 = {};
        for (let t7 = r3; t7 < arguments.length; ++t7) {
          let r4 = arguments[t7], s3 = {}, c3;
          if (typeof r4 == `function` ? (c3 = r4.name, typeof r4.signature == `string` ? s3[r4.signature] = r4 : b2(r4) && (s3 = r4.signatures)) : o2(r4) && (s3 = r4, n4 || (c3 = _e2(r4))), Object.keys(s3).length === 0) {
            let n5 = TypeError(`Argument to 'typed' at index ` + t7 + ` is not a (typed) function, nor an object with signatures as keys and functions as values.`);
            throw n5.data = { index: t7, argument: r4 }, n5;
          }
          n4 || (i3 = ge2(i3, c3)), ve2(a3, s3);
        }
        return Z2(i3 || ``, a3);
      }, p2.create = a2, p2.createCount = ye2.createCount, p2.onMismatch = oe2, p2.throwMismatchError = oe2, p2.createError = H2, p2.clear = g2, p2.clearConversions = v2, p2.addTypes = h2, p2._findType = m2, p2.referTo = de2, p2.referToSelf = pe2, p2.convert = w2, p2.findSignature = x2, p2.find = S2, p2.isTypedFunction = b2, p2.warnAgainstDeprecatedThis = true, p2.addType = function(t6, n4) {
        let r3 = `any`;
        n4 !== false && l2.has(`Object`) && (r3 = `Object`), p2.addTypes([t6], r3);
      };
      function be2(t6) {
        if (!t6 || typeof t6.from != `string` || typeof t6.to != `string` || typeof t6.convert != `function`) throw TypeError(`Object with properties {from: string, to: string, convert: function} expected`);
        if (t6.to === t6.from) throw SyntaxError(`Illegal to define conversion from "` + t6.from + `" to itself.`);
      }
      return p2.addConversion = function(t6) {
        let n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : { override: false };
        be2(t6);
        let r3 = m2(t6.to), i3 = r3.conversionsTo.find((n5) => n5.from === t6.from);
        if (i3) if (n4 && n4.override) p2.removeConversion({ from: i3.from, to: t6.to, convert: i3.convert });
        else throw Error(`There is already a conversion from "` + t6.from + `" to "` + r3.name + `"`);
        r3.conversionsTo.push({ from: t6.from, convert: t6.convert, index: d2++ });
      }, p2.addConversions = function(t6, n4) {
        t6.forEach((t7) => p2.addConversion(t7, n4));
      }, p2.removeConversion = function(t6) {
        be2(t6);
        let n4 = m2(t6.to), r3 = le2(n4.conversionsTo, (n5) => n5.from === t6.from);
        if (!r3) throw Error(`Attempt to remove nonexistent conversion from ` + t6.from + ` to ` + t6.to);
        if (r3.convert !== t6.convert) throw Error(`Conversion to remove does not match existing conversion`);
        let i3 = n4.conversionsTo.indexOf(r3);
        n4.conversionsTo.splice(i3, 1);
      }, p2.resolve = function(t6, n4) {
        if (!b2(t6)) throw TypeError(i2);
        let r3 = t6._typedFunctionData.signatures;
        for (let t7 = 0; t7 < r3.length; ++t7) if (r3[t7].test(n4)) return r3[t7];
        return null;
      }, p2;
    }
    return a2();
  }));
}));
function factory(t4, n2, r2, i2) {
  function a2(i3) {
    var a3 = pickShallow(i3, n2.map(stripOptionalNotation));
    return assertDependencies(t4, n2, i3), r2(a3);
  }
  return a2.isFactory = true, a2.fn = t4, a2.dependencies = n2.slice().sort(), i2 && (a2.meta = i2), a2;
}
function isFactory(t4) {
  return typeof t4 == `function` && typeof t4.fn == `string` && Array.isArray(t4.dependencies);
}
function assertDependencies(t4, n2, r2) {
  if (!n2.filter((t5) => !isOptionalDependency(t5)).every((t5) => r2[t5] !== void 0)) {
    var i2 = n2.filter((t5) => r2[t5] === void 0);
    throw Error(`Cannot create function "${t4}", some dependencies are missing: ${i2.map((t5) => `"${t5}"`).join(`, `)}.`);
  }
}
function isOptionalDependency(t4) {
  return t4 && t4[0] === `?`;
}
function stripOptionalNotation(t4) {
  return t4 && t4[0] === `?` ? t4.slice(1) : t4;
}
function isInteger(t4) {
  return typeof t4 == `boolean` ? true : Number.isFinite(t4) ? t4 === Math.round(t4) : false;
}
function safeNumberType(t4, n2) {
  if (n2.number === `bigint`) try {
    BigInt(t4);
  } catch {
    return n2.numberFallback;
  }
  return n2.number;
}
var sign$2 = Math.sign || function(t4) {
  return t4 > 0 ? 1 : t4 < 0 ? -1 : 0;
}, log2$1 = Math.log2 || function(t4) {
  return Math.log(t4) / Math.LN2;
}, log10$2 = Math.log10 || function(t4) {
  return Math.log(t4) / Math.LN10;
}, log1p = Math.log1p || function(t4) {
  return Math.log(t4 + 1);
}, cbrt$1 = Math.cbrt || function(t4) {
  if (t4 === 0) return t4;
  var n2 = t4 < 0, r2;
  return n2 && (t4 = -t4), Number.isFinite(t4) ? (r2 = Math.exp(Math.log(t4) / 3), r2 = (t4 / (r2 * r2) + 2 * r2) / 3) : r2 = t4, n2 ? -r2 : r2;
}, expm1 = Math.expm1 || function(t4) {
  return t4 >= 2e-4 || t4 <= -2e-4 ? Math.exp(t4) - 1 : t4 + t4 * t4 / 2 + t4 * t4 * t4 / 6;
};
function formatNumberToBase(t4, n2, r2) {
  var i2 = { 2: `0b`, 8: `0o`, 16: `0x` }[n2], a2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger(r2)) throw Error(`size must be an integer`);
    if (t4 > 2 ** (r2 - 1) - 1 || t4 < -(2 ** (r2 - 1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!isInteger(t4)) throw Error(`Value must be an integer`);
    t4 < 0 && (t4 += 2 ** r2), a2 = `i${r2}`;
  }
  var o2 = ``;
  return t4 < 0 && (t4 = -t4, o2 = `-`), `${o2}${i2}${t4.toString(n2)}${a2}`;
}
function format$2(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (t4 === 1 / 0) return `Infinity`;
  if (t4 === -1 / 0) return `-Infinity`;
  if (isNaN(t4)) return `NaN`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$2(t4, i2);
    case `exponential`:
      return toExponential$1(t4, i2);
    case `engineering`:
      return toEngineering$1(t4, i2);
    case `bin`:
      return formatNumberToBase(t4, 2, a2);
    case `oct`:
      return formatNumberToBase(t4, 8, a2);
    case `hex`:
      return formatNumberToBase(t4, 16, a2);
    case `auto`:
      return toPrecision(t4, i2, n2).replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function normalizeFormatOptions(t4) {
  var n2 = `auto`, r2, i2;
  if (t4 !== void 0) if (isNumber(t4)) r2 = t4;
  else if (isBigNumber(t4)) r2 = t4.toNumber();
  else if (isObject$1(t4)) t4.precision !== void 0 && (r2 = _toNumberOrThrow(t4.precision, () => {
    throw Error(`Option "precision" must be a number or BigNumber`);
  })), t4.wordSize !== void 0 && (i2 = _toNumberOrThrow(t4.wordSize, () => {
    throw Error(`Option "wordSize" must be a number or BigNumber`);
  })), t4.notation && (n2 = t4.notation);
  else throw Error(`Unsupported type of options, number, BigNumber, or object expected`);
  return { notation: n2, precision: r2, wordSize: i2 };
}
function splitNumber(t4) {
  var n2 = String(t4).toLowerCase().match(/^(-?)(\d+\.?\d*)(e([+-]?\d+))?$/);
  if (!n2) throw SyntaxError(`Invalid number ` + t4);
  var r2 = n2[1], i2 = n2[2], a2 = parseFloat(n2[4] || `0`), o2 = i2.indexOf(`.`);
  a2 += o2 === -1 ? i2.length - 1 : o2 - 1;
  var s2 = i2.replace(`.`, ``).replace(/^0*/, function(t5) {
    return a2 -= t5.length, ``;
  }).replace(/0*$/, ``).split(``).map(function(t5) {
    return parseInt(t5);
  });
  return s2.length === 0 && (s2.push(0), a2++), { sign: r2, coefficients: s2, exponent: a2 };
}
function toEngineering$1(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = roundDigits(splitNumber(t4), n2), i2 = r2.exponent, a2 = r2.coefficients, o2 = i2 % 3 == 0 ? i2 : i2 < 0 ? i2 - 3 - i2 % 3 : i2 - i2 % 3;
  if (isNumber(n2)) for (; n2 > a2.length || i2 - o2 + 1 > a2.length; ) a2.push(0);
  else for (var s2 = Math.abs(i2 - o2) - (a2.length - 1), c2 = 0; c2 < s2; c2++) a2.push(0);
  for (var l2 = Math.abs(i2 - o2), u2 = 1; l2 > 0; ) u2++, l2--;
  var d2 = a2.slice(u2).join(``), p2 = isNumber(n2) && d2.length || d2.match(/[1-9]/) ? `.` + d2 : ``, m2 = a2.slice(0, u2).join(``) + p2 + `e` + (i2 >= 0 ? `+` : ``) + o2.toString();
  return r2.sign + m2;
}
function toFixed$2(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var r2 = splitNumber(t4), i2 = typeof n2 == `number` ? roundDigits(r2, r2.exponent + 1 + n2) : r2, a2 = i2.coefficients, o2 = i2.exponent + 1, s2 = o2 + (n2 || 0);
  return a2.length < s2 && (a2 = a2.concat(zeros(s2 - a2.length))), o2 < 0 && (a2 = zeros(-o2 + 1).concat(a2), o2 = 1), o2 < a2.length && a2.splice(o2, 0, o2 === 0 ? `0.` : `.`), i2.sign + a2.join(``);
}
function toExponential$1(t4, n2) {
  if (isNaN(t4) || !Number.isFinite(Number(t4))) return String(t4);
  var r2 = splitNumber(t4), i2 = n2 ? roundDigits(r2, n2) : r2, a2 = i2.coefficients, o2 = i2.exponent;
  a2.length < n2 && (a2 = a2.concat(zeros(n2 - a2.length)));
  var s2 = a2.shift();
  return i2.sign + s2 + (a2.length > 0 ? `.` + a2.join(``) : ``) + `e` + (o2 >= 0 ? `+` : ``) + o2;
}
function toPrecision(t4, n2, r2) {
  if (isNaN(t4) || !Number.isFinite(t4)) return String(t4);
  var i2 = _toNumberOrDefault$1(r2?.lowerExp, -3), a2 = _toNumberOrDefault$1(r2?.upperExp, 5), o2 = splitNumber(t4), s2 = n2 ? roundDigits(o2, n2) : o2;
  if (s2.exponent < i2 || s2.exponent >= a2) return toExponential$1(t4, n2);
  var c2 = s2.coefficients, l2 = s2.exponent;
  c2.length < n2 && (c2 = c2.concat(zeros(n2 - c2.length))), c2 = c2.concat(zeros(l2 - c2.length + 1 + (c2.length < n2 ? n2 - c2.length : 0))), c2 = zeros(-l2).concat(c2);
  var u2 = l2 > 0 ? l2 : 0;
  return u2 < c2.length - 1 && c2.splice(u2 + 1, 0, `.`), s2.sign + c2.join(``);
}
function roundDigits(t4, n2) {
  for (var r2 = { sign: t4.sign, coefficients: t4.coefficients, exponent: t4.exponent }, i2 = r2.coefficients; n2 <= 0; ) i2.unshift(0), r2.exponent++, n2++;
  if (i2.length > n2 && i2.splice(n2, i2.length - n2)[0] >= 5) {
    var a2 = n2 - 1;
    for (i2[a2]++; i2[a2] === 10; ) i2.pop(), a2 === 0 && (i2.unshift(0), r2.exponent++, a2++), a2--, i2[a2]++;
  }
  return r2;
}
function zeros(t4) {
  for (var n2 = [], r2 = 0; r2 < t4; r2++) n2.push(0);
  return n2;
}
function digits(t4) {
  return t4.toExponential().replace(/e.*$/, ``).replace(/^0\.?0*|\./, ``).length;
}
function nearlyEqual$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-8, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return isNaN(t4) || isNaN(n2) ? false : !Number.isFinite(t4) || !Number.isFinite(n2) ? t4 === n2 : t4 === n2 ? true : Math.abs(t4 - n2) <= Math.max(r2 * Math.max(Math.abs(t4), Math.abs(n2)), i2);
}
var acosh$2 = Math.acosh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 - 1) + t4);
}, asinh$2 = Math.asinh || function(t4) {
  return Math.log(Math.sqrt(t4 * t4 + 1) + t4);
}, atanh$2 = Math.atanh || function(t4) {
  return Math.log((1 + t4) / (1 - t4)) / 2;
}, cosh$3 = Math.cosh || function(t4) {
  return (Math.exp(t4) + Math.exp(-t4)) / 2;
}, sinh$3 = Math.sinh || function(t4) {
  return (Math.exp(t4) - Math.exp(-t4)) / 2;
}, tanh$2 = Math.tanh || function(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 - 1) / (n2 + 1);
};
function copysign(t4, n2) {
  return true ^ (n2 > 0 ? true : n2 < 0 ? false : 1 / n2 == 1 / 0) ? -t4 : t4;
}
function _toNumberOrThrow(t4, n2) {
  if (isNumber(t4)) return t4;
  if (isBigNumber(t4)) return t4.toNumber();
  n2();
}
function _toNumberOrDefault$1(t4, n2) {
  return isNumber(t4) ? t4 : isBigNumber(t4) ? t4.toNumber() : n2;
}
var import_typed_function = __toESM(require_typed_function()), _createTyped2 = function() {
  return _createTyped2 = import_typed_function.default.create, import_typed_function.default;
}, dependencies$322 = [`?BigNumber`, `?Complex`, `?DenseMatrix`, `?Fraction`], createTyped = factory(`typed`, dependencies$322, function(t4) {
  var { BigNumber: n2, Complex: r2, DenseMatrix: i2, Fraction: a2 } = t4, o2 = _createTyped2();
  return o2.clear(), o2.addTypes([{ name: `number`, test: isNumber }, { name: `Complex`, test: isComplex }, { name: `BigNumber`, test: isBigNumber }, { name: `bigint`, test: isBigInt }, { name: `Fraction`, test: isFraction }, { name: `Unit`, test: isUnit }, { name: `identifier`, test: (t5) => isString && /^(?:[A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])(?:[0-9A-Za-z\xAA\xB5\xBA\xC0-\xD6\xD8-\xF6\xF8-\u02C1\u02C6-\u02D1\u02E0-\u02E4\u02EC\u02EE\u0370-\u0374\u0376\u0377\u037A-\u037D\u037F\u0386\u0388-\u038A\u038C\u038E-\u03A1\u03A3-\u03F5\u03F7-\u0481\u048A-\u052F\u0531-\u0556\u0559\u0560-\u0588\u05D0-\u05EA\u05EF-\u05F2\u0620-\u064A\u066E\u066F\u0671-\u06D3\u06D5\u06E5\u06E6\u06EE\u06EF\u06FA-\u06FC\u06FF\u0710\u0712-\u072F\u074D-\u07A5\u07B1\u07CA-\u07EA\u07F4\u07F5\u07FA\u0800-\u0815\u081A\u0824\u0828\u0840-\u0858\u0860-\u086A\u0870-\u0887\u0889-\u088F\u08A0-\u08C9\u0904-\u0939\u093D\u0950\u0958-\u0961\u0971-\u0980\u0985-\u098C\u098F\u0990\u0993-\u09A8\u09AA-\u09B0\u09B2\u09B6-\u09B9\u09BD\u09CE\u09DC\u09DD\u09DF-\u09E1\u09F0\u09F1\u09FC\u0A05-\u0A0A\u0A0F\u0A10\u0A13-\u0A28\u0A2A-\u0A30\u0A32\u0A33\u0A35\u0A36\u0A38\u0A39\u0A59-\u0A5C\u0A5E\u0A72-\u0A74\u0A85-\u0A8D\u0A8F-\u0A91\u0A93-\u0AA8\u0AAA-\u0AB0\u0AB2\u0AB3\u0AB5-\u0AB9\u0ABD\u0AD0\u0AE0\u0AE1\u0AF9\u0B05-\u0B0C\u0B0F\u0B10\u0B13-\u0B28\u0B2A-\u0B30\u0B32\u0B33\u0B35-\u0B39\u0B3D\u0B5C\u0B5D\u0B5F-\u0B61\u0B71\u0B83\u0B85-\u0B8A\u0B8E-\u0B90\u0B92-\u0B95\u0B99\u0B9A\u0B9C\u0B9E\u0B9F\u0BA3\u0BA4\u0BA8-\u0BAA\u0BAE-\u0BB9\u0BD0\u0C05-\u0C0C\u0C0E-\u0C10\u0C12-\u0C28\u0C2A-\u0C39\u0C3D\u0C58-\u0C5A\u0C5C\u0C5D\u0C60\u0C61\u0C80\u0C85-\u0C8C\u0C8E-\u0C90\u0C92-\u0CA8\u0CAA-\u0CB3\u0CB5-\u0CB9\u0CBD\u0CDC-\u0CDE\u0CE0\u0CE1\u0CF1\u0CF2\u0D04-\u0D0C\u0D0E-\u0D10\u0D12-\u0D3A\u0D3D\u0D4E\u0D54-\u0D56\u0D5F-\u0D61\u0D7A-\u0D7F\u0D85-\u0D96\u0D9A-\u0DB1\u0DB3-\u0DBB\u0DBD\u0DC0-\u0DC6\u0E01-\u0E30\u0E32\u0E33\u0E40-\u0E46\u0E81\u0E82\u0E84\u0E86-\u0E8A\u0E8C-\u0EA3\u0EA5\u0EA7-\u0EB0\u0EB2\u0EB3\u0EBD\u0EC0-\u0EC4\u0EC6\u0EDC-\u0EDF\u0F00\u0F40-\u0F47\u0F49-\u0F6C\u0F88-\u0F8C\u1000-\u102A\u103F\u1050-\u1055\u105A-\u105D\u1061\u1065\u1066\u106E-\u1070\u1075-\u1081\u108E\u10A0-\u10C5\u10C7\u10CD\u10D0-\u10FA\u10FC-\u1248\u124A-\u124D\u1250-\u1256\u1258\u125A-\u125D\u1260-\u1288\u128A-\u128D\u1290-\u12B0\u12B2-\u12B5\u12B8-\u12BE\u12C0\u12C2-\u12C5\u12C8-\u12D6\u12D8-\u1310\u1312-\u1315\u1318-\u135A\u1380-\u138F\u13A0-\u13F5\u13F8-\u13FD\u1401-\u166C\u166F-\u167F\u1681-\u169A\u16A0-\u16EA\u16F1-\u16F8\u1700-\u1711\u171F-\u1731\u1740-\u1751\u1760-\u176C\u176E-\u1770\u1780-\u17B3\u17D7\u17DC\u1820-\u1878\u1880-\u1884\u1887-\u18A8\u18AA\u18B0-\u18F5\u1900-\u191E\u1950-\u196D\u1970-\u1974\u1980-\u19AB\u19B0-\u19C9\u1A00-\u1A16\u1A20-\u1A54\u1AA7\u1B05-\u1B33\u1B45-\u1B4C\u1B83-\u1BA0\u1BAE\u1BAF\u1BBA-\u1BE5\u1C00-\u1C23\u1C4D-\u1C4F\u1C5A-\u1C7D\u1C80-\u1C8A\u1C90-\u1CBA\u1CBD-\u1CBF\u1CE9-\u1CEC\u1CEE-\u1CF3\u1CF5\u1CF6\u1CFA\u1D00-\u1DBF\u1E00-\u1F15\u1F18-\u1F1D\u1F20-\u1F45\u1F48-\u1F4D\u1F50-\u1F57\u1F59\u1F5B\u1F5D\u1F5F-\u1F7D\u1F80-\u1FB4\u1FB6-\u1FBC\u1FBE\u1FC2-\u1FC4\u1FC6-\u1FCC\u1FD0-\u1FD3\u1FD6-\u1FDB\u1FE0-\u1FEC\u1FF2-\u1FF4\u1FF6-\u1FFC\u2071\u207F\u2090-\u209C\u2102\u2107\u210A-\u2113\u2115\u2119-\u211D\u2124\u2126\u2128\u212A-\u212D\u212F-\u2139\u213C-\u213F\u2145-\u2149\u214E\u2183\u2184\u2C00-\u2CE4\u2CEB-\u2CEE\u2CF2\u2CF3\u2D00-\u2D25\u2D27\u2D2D\u2D30-\u2D67\u2D6F\u2D80-\u2D96\u2DA0-\u2DA6\u2DA8-\u2DAE\u2DB0-\u2DB6\u2DB8-\u2DBE\u2DC0-\u2DC6\u2DC8-\u2DCE\u2DD0-\u2DD6\u2DD8-\u2DDE\u2E2F\u3005\u3006\u3031-\u3035\u303B\u303C\u3041-\u3096\u309D-\u309F\u30A1-\u30FA\u30FC-\u30FF\u3105-\u312F\u3131-\u318E\u31A0-\u31BF\u31F0-\u31FF\u3400-\u4DBF\u4E00-\uA48C\uA4D0-\uA4FD\uA500-\uA60C\uA610-\uA61F\uA62A\uA62B\uA640-\uA66E\uA67F-\uA69D\uA6A0-\uA6E5\uA717-\uA71F\uA722-\uA788\uA78B-\uA7DC\uA7F1-\uA801\uA803-\uA805\uA807-\uA80A\uA80C-\uA822\uA840-\uA873\uA882-\uA8B3\uA8F2-\uA8F7\uA8FB\uA8FD\uA8FE\uA90A-\uA925\uA930-\uA946\uA960-\uA97C\uA984-\uA9B2\uA9CF\uA9E0-\uA9E4\uA9E6-\uA9EF\uA9FA-\uA9FE\uAA00-\uAA28\uAA40-\uAA42\uAA44-\uAA4B\uAA60-\uAA76\uAA7A\uAA7E-\uAAAF\uAAB1\uAAB5\uAAB6\uAAB9-\uAABD\uAAC0\uAAC2\uAADB-\uAADD\uAAE0-\uAAEA\uAAF2-\uAAF4\uAB01-\uAB06\uAB09-\uAB0E\uAB11-\uAB16\uAB20-\uAB26\uAB28-\uAB2E\uAB30-\uAB5A\uAB5C-\uAB69\uAB70-\uABE2\uAC00-\uD7A3\uD7B0-\uD7C6\uD7CB-\uD7FB\uF900-\uFA6D\uFA70-\uFAD9\uFB00-\uFB06\uFB13-\uFB17\uFB1D\uFB1F-\uFB28\uFB2A-\uFB36\uFB38-\uFB3C\uFB3E\uFB40\uFB41\uFB43\uFB44\uFB46-\uFBB1\uFBD3-\uFD3D\uFD50-\uFD8F\uFD92-\uFDC7\uFDF0-\uFDFB\uFE70-\uFE74\uFE76-\uFEFC\uFF21-\uFF3A\uFF41-\uFF5A\uFF66-\uFFBE\uFFC2-\uFFC7\uFFCA-\uFFCF\uFFD2-\uFFD7\uFFDA-\uFFDC]|\uD800[\uDC00-\uDC0B\uDC0D-\uDC26\uDC28-\uDC3A\uDC3C\uDC3D\uDC3F-\uDC4D\uDC50-\uDC5D\uDC80-\uDCFA\uDE80-\uDE9C\uDEA0-\uDED0\uDF00-\uDF1F\uDF2D-\uDF40\uDF42-\uDF49\uDF50-\uDF75\uDF80-\uDF9D\uDFA0-\uDFC3\uDFC8-\uDFCF]|\uD801[\uDC00-\uDC9D\uDCB0-\uDCD3\uDCD8-\uDCFB\uDD00-\uDD27\uDD30-\uDD63\uDD70-\uDD7A\uDD7C-\uDD8A\uDD8C-\uDD92\uDD94\uDD95\uDD97-\uDDA1\uDDA3-\uDDB1\uDDB3-\uDDB9\uDDBB\uDDBC\uDDC0-\uDDF3\uDE00-\uDF36\uDF40-\uDF55\uDF60-\uDF67\uDF80-\uDF85\uDF87-\uDFB0\uDFB2-\uDFBA]|\uD802[\uDC00-\uDC05\uDC08\uDC0A-\uDC35\uDC37\uDC38\uDC3C\uDC3F-\uDC55\uDC60-\uDC76\uDC80-\uDC9E\uDCE0-\uDCF2\uDCF4\uDCF5\uDD00-\uDD15\uDD20-\uDD39\uDD40-\uDD59\uDD80-\uDDB7\uDDBE\uDDBF\uDE00\uDE10-\uDE13\uDE15-\uDE17\uDE19-\uDE35\uDE60-\uDE7C\uDE80-\uDE9C\uDEC0-\uDEC7\uDEC9-\uDEE4\uDF00-\uDF35\uDF40-\uDF55\uDF60-\uDF72\uDF80-\uDF91]|\uD803[\uDC00-\uDC48\uDC80-\uDCB2\uDCC0-\uDCF2\uDD00-\uDD23\uDD4A-\uDD65\uDD6F-\uDD85\uDE80-\uDEA9\uDEB0\uDEB1\uDEC2-\uDEC7\uDF00-\uDF1C\uDF27\uDF30-\uDF45\uDF70-\uDF81\uDFB0-\uDFC4\uDFE0-\uDFF6]|\uD804[\uDC03-\uDC37\uDC71\uDC72\uDC75\uDC83-\uDCAF\uDCD0-\uDCE8\uDD03-\uDD26\uDD44\uDD47\uDD50-\uDD72\uDD76\uDD83-\uDDB2\uDDC1-\uDDC4\uDDDA\uDDDC\uDE00-\uDE11\uDE13-\uDE2B\uDE3F\uDE40\uDE80-\uDE86\uDE88\uDE8A-\uDE8D\uDE8F-\uDE9D\uDE9F-\uDEA8\uDEB0-\uDEDE\uDF05-\uDF0C\uDF0F\uDF10\uDF13-\uDF28\uDF2A-\uDF30\uDF32\uDF33\uDF35-\uDF39\uDF3D\uDF50\uDF5D-\uDF61\uDF80-\uDF89\uDF8B\uDF8E\uDF90-\uDFB5\uDFB7\uDFD1\uDFD3]|\uD805[\uDC00-\uDC34\uDC47-\uDC4A\uDC5F-\uDC61\uDC80-\uDCAF\uDCC4\uDCC5\uDCC7\uDD80-\uDDAE\uDDD8-\uDDDB\uDE00-\uDE2F\uDE44\uDE80-\uDEAA\uDEB8\uDF00-\uDF1A\uDF40-\uDF46]|\uD806[\uDC00-\uDC2B\uDCA0-\uDCDF\uDCFF-\uDD06\uDD09\uDD0C-\uDD13\uDD15\uDD16\uDD18-\uDD2F\uDD3F\uDD41\uDDA0-\uDDA7\uDDAA-\uDDD0\uDDE1\uDDE3\uDE00\uDE0B-\uDE32\uDE3A\uDE50\uDE5C-\uDE89\uDE9D\uDEB0-\uDEF8\uDFC0-\uDFE0]|\uD807[\uDC00-\uDC08\uDC0A-\uDC2E\uDC40\uDC72-\uDC8F\uDD00-\uDD06\uDD08\uDD09\uDD0B-\uDD30\uDD46\uDD60-\uDD65\uDD67\uDD68\uDD6A-\uDD89\uDD98\uDDB0-\uDDDB\uDEE0-\uDEF2\uDF02\uDF04-\uDF10\uDF12-\uDF33\uDFB0]|\uD808[\uDC00-\uDF99]|\uD809[\uDC80-\uDD43]|\uD80B[\uDF90-\uDFF0]|[\uD80C\uD80E\uD80F\uD81C-\uD822\uD840-\uD868\uD86A-\uD86D\uD86F-\uD872\uD874-\uD879\uD880-\uD883\uD885-\uD88C][\uDC00-\uDFFF]|\uD80D[\uDC00-\uDC2F\uDC41-\uDC46\uDC60-\uDFFF]|\uD810[\uDC00-\uDFFA]|\uD811[\uDC00-\uDE46]|\uD818[\uDD00-\uDD1D]|\uD81A[\uDC00-\uDE38\uDE40-\uDE5E\uDE70-\uDEBE\uDED0-\uDEED\uDF00-\uDF2F\uDF40-\uDF43\uDF63-\uDF77\uDF7D-\uDF8F]|\uD81B[\uDD40-\uDD6C\uDE40-\uDE7F\uDEA0-\uDEB8\uDEBB-\uDED3\uDF00-\uDF4A\uDF50\uDF93-\uDF9F\uDFE0\uDFE1\uDFE3\uDFF2\uDFF3]|\uD823[\uDC00-\uDCD5\uDCFF-\uDD1E\uDD80-\uDDF2]|\uD82B[\uDFF0-\uDFF3\uDFF5-\uDFFB\uDFFD\uDFFE]|\uD82C[\uDC00-\uDD22\uDD32\uDD50-\uDD52\uDD55\uDD64-\uDD67\uDD70-\uDEFB]|\uD82F[\uDC00-\uDC6A\uDC70-\uDC7C\uDC80-\uDC88\uDC90-\uDC99]|\uD835[\uDC00-\uDC54\uDC56-\uDC9C\uDC9E\uDC9F\uDCA2\uDCA5\uDCA6\uDCA9-\uDCAC\uDCAE-\uDCB9\uDCBB\uDCBD-\uDCC3\uDCC5-\uDD05\uDD07-\uDD0A\uDD0D-\uDD14\uDD16-\uDD1C\uDD1E-\uDD39\uDD3B-\uDD3E\uDD40-\uDD44\uDD46\uDD4A-\uDD50\uDD52-\uDEA5\uDEA8-\uDEC0\uDEC2-\uDEDA\uDEDC-\uDEFA\uDEFC-\uDF14\uDF16-\uDF34\uDF36-\uDF4E\uDF50-\uDF6E\uDF70-\uDF88\uDF8A-\uDFA8\uDFAA-\uDFC2\uDFC4-\uDFCB]|\uD837[\uDF00-\uDF1E\uDF25-\uDF2A]|\uD838[\uDC30-\uDC6D\uDD00-\uDD2C\uDD37-\uDD3D\uDD4E\uDE90-\uDEAD\uDEC0-\uDEEB]|\uD839[\uDCD0-\uDCEB\uDDD0-\uDDED\uDDF0\uDEC0-\uDEDE\uDEE0-\uDEE2\uDEE4\uDEE5\uDEE7-\uDEED\uDEF0-\uDEF4\uDEFE\uDEFF\uDFE0-\uDFE6\uDFE8-\uDFEB\uDFED\uDFEE\uDFF0-\uDFFE]|\uD83A[\uDC00-\uDCC4\uDD00-\uDD43\uDD4B]|\uD83B[\uDE00-\uDE03\uDE05-\uDE1F\uDE21\uDE22\uDE24\uDE27\uDE29-\uDE32\uDE34-\uDE37\uDE39\uDE3B\uDE42\uDE47\uDE49\uDE4B\uDE4D-\uDE4F\uDE51\uDE52\uDE54\uDE57\uDE59\uDE5B\uDE5D\uDE5F\uDE61\uDE62\uDE64\uDE67-\uDE6A\uDE6C-\uDE72\uDE74-\uDE77\uDE79-\uDE7C\uDE7E\uDE80-\uDE89\uDE8B-\uDE9B\uDEA1-\uDEA3\uDEA5-\uDEA9\uDEAB-\uDEBB]|\uD869[\uDC00-\uDEDF\uDF00-\uDFFF]|\uD86E[\uDC00-\uDC1D\uDC20-\uDFFF]|\uD873[\uDC00-\uDEAD\uDEB0-\uDFFF]|\uD87A[\uDC00-\uDFE0\uDFF0-\uDFFF]|\uD87B[\uDC00-\uDE5D]|\uD87E[\uDC00-\uDE1D]|\uD884[\uDC00-\uDF4A\uDF50-\uDFFF]|\uD88D[\uDC00-\uDC79])*$/.test(t5) }, { name: `string`, test: isString }, { name: `Chain`, test: isChain }, { name: `Array`, test: isArray }, { name: `Matrix`, test: isMatrix }, { name: `DenseMatrix`, test: isDenseMatrix }, { name: `SparseMatrix`, test: isSparseMatrix }, { name: `Range`, test: isRange }, { name: `Index`, test: isIndex }, { name: `boolean`, test: isBoolean$1 }, { name: `ResultSet`, test: isResultSet }, { name: `Help`, test: isHelp }, { name: `function`, test: isFunction$1 }, { name: `Date`, test: isDate }, { name: `RegExp`, test: isRegExp }, { name: `null`, test: isNull$1 }, { name: `undefined`, test: isUndefined$1 }, { name: `AccessorNode`, test: isAccessorNode }, { name: `ArrayNode`, test: isArrayNode }, { name: `AssignmentNode`, test: isAssignmentNode }, { name: `BlockNode`, test: isBlockNode }, { name: `ConditionalNode`, test: isConditionalNode }, { name: `ConstantNode`, test: isConstantNode }, { name: `FunctionNode`, test: isFunctionNode }, { name: `FunctionAssignmentNode`, test: isFunctionAssignmentNode }, { name: `IndexNode`, test: isIndexNode }, { name: `Node`, test: isNode$2 }, { name: `ObjectNode`, test: isObjectNode }, { name: `OperatorNode`, test: isOperatorNode }, { name: `ParenthesisNode`, test: isParenthesisNode }, { name: `RangeNode`, test: isRangeNode }, { name: `RelationalNode`, test: isRelationalNode }, { name: `SymbolNode`, test: isSymbolNode }, { name: `Map`, test: isMap }, { name: `Object`, test: isObject$1 }]), o2.addConversions([{ from: `number`, to: `BigNumber`, convert: function(t5) {
    if (n2 || throwNoBignumber(t5), digits(t5) > 15) throw TypeError(`Cannot implicitly convert a number with >15 significant digits to BigNumber (value: ` + t5 + `). Use function bignumber(x) to convert to BigNumber.`);
    return new n2(t5);
  } }, { from: `number`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex(t5), new r2(t5, 0);
  } }, { from: `BigNumber`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex(t5), new r2(t5.toNumber(), 0);
  } }, { from: `bigint`, to: `number`, convert: function(t5) {
    if (t5 > 2 ** 53 - 1) throw TypeError(`Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: ` + t5 + `)`);
    return Number(t5);
  } }, { from: `bigint`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber(t5), new n2(t5.toString());
  } }, { from: `bigint`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction(t5), new a2(t5);
  } }, { from: `Fraction`, to: `BigNumber`, convert: function(t5) {
    throw TypeError(`Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.`);
  } }, { from: `Fraction`, to: `Complex`, convert: function(t5) {
    return r2 || throwNoComplex(t5), new r2(t5.valueOf(), 0);
  } }, { from: `number`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction(t5);
    var n3 = new a2(t5);
    if (n3.valueOf() !== t5) throw TypeError(`Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: ` + t5 + `). Use function fraction(x) to convert to Fraction.`);
    return n3;
  } }, { from: `string`, to: `number`, convert: function(t5) {
    var n3 = Number(t5);
    if (isNaN(n3)) throw Error(`Cannot convert "` + t5 + `" to a number`);
    return n3;
  } }, { from: `string`, to: `BigNumber`, convert: function(t5) {
    n2 || throwNoBignumber(t5);
    try {
      return new n2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigNumber`);
    }
  } }, { from: `string`, to: `bigint`, convert: function(t5) {
    try {
      return BigInt(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to BigInt`);
    }
  } }, { from: `string`, to: `Fraction`, convert: function(t5) {
    a2 || throwNoFraction(t5);
    try {
      return new a2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Fraction`);
    }
  } }, { from: `string`, to: `Complex`, convert: function(t5) {
    r2 || throwNoComplex(t5);
    try {
      return new r2(t5);
    } catch {
      throw Error(`Cannot convert "` + t5 + `" to Complex`);
    }
  } }, { from: `boolean`, to: `number`, convert: function(t5) {
    return +t5;
  } }, { from: `boolean`, to: `BigNumber`, convert: function(t5) {
    return n2 || throwNoBignumber(t5), new n2(+t5);
  } }, { from: `boolean`, to: `bigint`, convert: function(t5) {
    return BigInt(+t5);
  } }, { from: `boolean`, to: `Fraction`, convert: function(t5) {
    return a2 || throwNoFraction(t5), new a2(+t5);
  } }, { from: `boolean`, to: `string`, convert: function(t5) {
    return String(t5);
  } }, { from: `Array`, to: `Matrix`, convert: function(t5) {
    return i2 || throwNoMatrix(), new i2(t5);
  } }, { from: `Matrix`, to: `Array`, convert: function(t5) {
    return t5.valueOf();
  } }]), o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2.onMismatch = (t5, n3, r3) => {
    var i3 = o2.createError(t5, n3, r3);
    if ([`wrongType`, `mismatch`].includes(i3.data.category) && n3.length === 1 && isCollection(n3[0]) && r3.some((t6) => !t6.params.includes(`,`))) {
      var a3 = TypeError(`Function '${t5}' doesn't apply to matrices. To call it elementwise on a matrix 'M', try 'map(M, ${t5})'.`);
      throw a3.data = i3.data, a3;
    }
    throw i3;
  }, o2;
});
function throwNoBignumber(t4) {
  throw Error(`Cannot convert value ${t4} into a BigNumber: no class 'BigNumber' provided`);
}
function throwNoComplex(t4) {
  throw Error(`Cannot convert value ${t4} into a Complex number: no class 'Complex' provided`);
}
function throwNoMatrix() {
  throw Error(`Cannot convert array into a Matrix: no class 'DenseMatrix' provided`);
}
function throwNoFraction(t4) {
  throw Error(`Cannot convert value ${t4} into a Fraction, no class 'Fraction' provided.`);
}
var name$321 = `ResultSet`, dependencies$321 = [], createResultSet = factory(name$321, dependencies$321, () => {
  function t4(n2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    this.entries = n2 || [];
  }
  return t4.prototype.type = `ResultSet`, t4.prototype.isResultSet = true, t4.prototype.valueOf = function() {
    return this.entries;
  }, t4.prototype.toString = function() {
    return `[` + this.entries.map(String).join(`, `) + `]`;
  }, t4.prototype.toJSON = function() {
    return { mathjs: `ResultSet`, entries: this.entries };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.entries);
  }, t4;
}, { isClass: true }), EXP_LIMIT = 9e15, MAX_DIGITS = 1e9, NUMERALS = `0123456789abcdef`, LN10 = `2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058`, PI = `3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789`, DEFAULTS = { precision: 20, rounding: 4, modulo: 1, toExpNeg: -7, toExpPos: 21, minE: -EXP_LIMIT, maxE: EXP_LIMIT, crypto: false }, inexact, quadrant, external = true, decimalError = `[DecimalError] `, invalidArgument = decimalError + `Invalid argument: `, precisionLimitExceeded = decimalError + `Precision limit exceeded`, cryptoUnavailable = decimalError + `crypto unavailable`, tag = `[object Decimal]`, mathfloor = Math.floor, mathpow = Math.pow, isBinary = /^0b([01]+(\.[01]*)?|\.[01]+)(p[+-]?\d+)?$/i, isHex = /^0x([0-9a-f]+(\.[0-9a-f]*)?|\.[0-9a-f]+)(p[+-]?\d+)?$/i, isOctal = /^0o([0-7]+(\.[0-7]*)?|\.[0-7]+)(p[+-]?\d+)?$/i, isDecimal = /^(\d+(\.\d*)?|\.\d+)(e[+-]?\d+)?$/i, BASE = 1e7, LOG_BASE = 7, MAX_SAFE_INTEGER = 9007199254740991, LN10_PRECISION = LN10.length - 1, PI_PRECISION = PI.length - 1, P$3 = { toStringTag: tag };
P$3.absoluteValue = P$3.abs = function() {
  var t4 = new this.constructor(this);
  return t4.s < 0 && (t4.s = 1), finalise(t4);
}, P$3.ceil = function() {
  return finalise(new this.constructor(this), this.e + 1, 2);
}, P$3.clampedTo = P$3.clamp = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  if (t4 = new a2(t4), n2 = new a2(n2), !t4.s || !n2.s) return new a2(NaN);
  if (t4.gt(n2)) throw Error(invalidArgument + n2);
  return r2 = i2.cmp(t4), r2 < 0 ? t4 : i2.cmp(n2) > 0 ? n2 : new a2(i2);
}, P$3.comparedTo = P$3.cmp = function(t4) {
  var n2, r2, i2, a2, o2 = this, s2 = o2.d, c2 = (t4 = new o2.constructor(t4)).d, l2 = o2.s, u2 = t4.s;
  if (!s2 || !c2) return !l2 || !u2 ? NaN : l2 === u2 ? s2 === c2 ? 0 : !s2 ^ l2 < 0 ? 1 : -1 : l2;
  if (!s2[0] || !c2[0]) return s2[0] ? l2 : c2[0] ? -u2 : 0;
  if (l2 !== u2) return l2;
  if (o2.e !== t4.e) return o2.e > t4.e ^ l2 < 0 ? 1 : -1;
  for (i2 = s2.length, a2 = c2.length, n2 = 0, r2 = i2 < a2 ? i2 : a2; n2 < r2; ++n2) if (s2[n2] !== c2[n2]) return s2[n2] > c2[n2] ^ l2 < 0 ? 1 : -1;
  return i2 === a2 ? 0 : i2 > a2 ^ l2 < 0 ? 1 : -1;
}, P$3.cosine = P$3.cos = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.d ? r2.d[0] ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE, i2.rounding = 1, r2 = cosine(i2, toLessThanHalfPi(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise(quadrant == 2 || quadrant == 3 ? r2.neg() : r2, t4, n2, true)) : new i2(1) : new i2(NaN);
}, P$3.cubeRoot = P$3.cbrt = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor;
  if (!d2.isFinite() || d2.isZero()) return new p2(d2);
  for (external = false, o2 = d2.s * mathpow(d2.s * d2, 1 / 3), !o2 || Math.abs(o2) == 1 / 0 ? (r2 = digitsToString(d2.d), t4 = d2.e, (o2 = (t4 - r2.length + 1) % 3) && (r2 += o2 == 1 || o2 == -2 ? `0` : `00`), o2 = mathpow(r2, 1 / 3), t4 = mathfloor((t4 + 1) / 3) - (t4 % 3 == (t4 < 0 ? -1 : 2)), o2 == 1 / 0 ? r2 = `5e` + t4 : (r2 = o2.toExponential(), r2 = r2.slice(0, r2.indexOf(`e`) + 1) + t4), i2 = new p2(r2), i2.s = d2.s) : i2 = new p2(o2.toString()), s2 = (t4 = p2.precision) + 3; ; ) if (c2 = i2, l2 = c2.times(c2).times(c2), u2 = l2.plus(d2), i2 = divide$1(u2.plus(d2).times(c2), u2.plus(l2), s2 + 2, 1), digitsToString(c2.d).slice(0, s2) === (r2 = digitsToString(i2.d)).slice(0, s2)) if (r2 = r2.slice(s2 - 3, s2 + 1), r2 == `9999` || !a2 && r2 == `4999`) {
    if (!a2 && (finalise(c2, t4 + 1, 0), c2.times(c2).times(c2).eq(d2))) {
      i2 = c2;
      break;
    }
    s2 += 4, a2 = 1;
  } else {
    (!+r2 || !+r2.slice(1) && r2.charAt(0) == `5`) && (finalise(i2, t4 + 1, 1), n2 = !i2.times(i2).times(i2).eq(d2));
    break;
  }
  return external = true, finalise(i2, t4, p2.rounding, n2);
}, P$3.decimalPlaces = P$3.dp = function() {
  var t4, n2 = this.d, r2 = NaN;
  if (n2) {
    if (t4 = n2.length - 1, r2 = (t4 - mathfloor(this.e / LOG_BASE)) * LOG_BASE, t4 = n2[t4], t4) for (; t4 % 10 == 0; t4 /= 10) r2--;
    r2 < 0 && (r2 = 0);
  }
  return r2;
}, P$3.dividedBy = P$3.div = function(t4) {
  return divide$1(this, new this.constructor(t4));
}, P$3.dividedToIntegerBy = P$3.divToInt = function(t4) {
  var n2 = this, r2 = n2.constructor;
  return finalise(divide$1(n2, new r2(t4), 0, 1, 1), r2.precision, r2.rounding);
}, P$3.equals = P$3.eq = function(t4) {
  return this.cmp(t4) === 0;
}, P$3.floor = function() {
  return finalise(new this.constructor(this), this.e + 1, 3);
}, P$3.greaterThan = P$3.gt = function(t4) {
  return this.cmp(t4) > 0;
}, P$3.greaterThanOrEqualTo = P$3.gte = function(t4) {
  var n2 = this.cmp(t4);
  return n2 == 1 || n2 === 0;
}, P$3.hyperbolicCosine = P$3.cosh = function() {
  var t4, n2, r2, i2, a2, o2 = this, s2 = o2.constructor, c2 = new s2(1);
  if (!o2.isFinite()) return new s2(o2.s ? 1 / 0 : NaN);
  if (o2.isZero()) return c2;
  r2 = s2.precision, i2 = s2.rounding, s2.precision = r2 + Math.max(o2.e, o2.sd()) + 4, s2.rounding = 1, a2 = o2.d.length, a2 < 32 ? (t4 = Math.ceil(a2 / 3), n2 = (1 / tinyPow(4, t4)).toString()) : (t4 = 16, n2 = `2.3283064365386962890625e-10`), o2 = taylorSeries(s2, 1, o2.times(n2), new s2(1), true);
  for (var l2, u2 = t4, d2 = new s2(8); u2--; ) l2 = o2.times(o2), o2 = c2.minus(l2.times(d2.minus(l2.times(d2))));
  return finalise(o2, s2.precision = r2, s2.rounding = i2, true);
}, P$3.hyperbolicSine = P$3.sinh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  if (!a2.isFinite() || a2.isZero()) return new o2(a2);
  if (n2 = o2.precision, r2 = o2.rounding, o2.precision = n2 + Math.max(a2.e, a2.sd()) + 4, o2.rounding = 1, i2 = a2.d.length, i2 < 3) a2 = taylorSeries(o2, 2, a2, a2, true);
  else {
    t4 = 1.4 * Math.sqrt(i2), t4 = t4 > 16 ? 16 : t4 | 0, a2 = a2.times(1 / tinyPow(5, t4)), a2 = taylorSeries(o2, 2, a2, a2, true);
    for (var s2, c2 = new o2(5), l2 = new o2(16), u2 = new o2(20); t4--; ) s2 = a2.times(a2), a2 = a2.times(c2.plus(s2.times(l2.times(s2).plus(u2))));
  }
  return o2.precision = n2, o2.rounding = r2, finalise(a2, n2, r2, true);
}, P$3.hyperbolicTangent = P$3.tanh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 7, i2.rounding = 1, divide$1(r2.sinh(), r2.cosh(), i2.precision = t4, i2.rounding = n2)) : new i2(r2.s);
}, P$3.inverseCosine = P$3.acos = function() {
  var t4, n2 = this, r2 = n2.constructor, i2 = n2.abs().cmp(1), a2 = r2.precision, o2 = r2.rounding;
  return i2 === -1 ? n2.isZero() ? getPi(r2, a2 + 4, o2).times(0.5) : (r2.precision = a2 + 6, r2.rounding = 1, n2 = n2.asin(), t4 = getPi(r2, a2 + 4, o2).times(0.5), r2.precision = a2, r2.rounding = o2, t4.minus(n2)) : i2 === 0 ? n2.isNeg() ? getPi(r2, a2, o2) : new r2(0) : new r2(NaN);
}, P$3.inverseHyperbolicCosine = P$3.acosh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.lte(1) ? new i2(r2.eq(1) ? 0 : NaN) : r2.isFinite() ? (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(Math.abs(r2.e), r2.sd()) + 4, i2.rounding = 1, external = false, r2 = r2.times(r2).minus(1).sqrt().plus(r2), external = true, i2.precision = t4, i2.rounding = n2, r2.ln()) : new i2(r2);
}, P$3.inverseHyperbolicSine = P$3.asinh = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return !r2.isFinite() || r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 2 * Math.max(Math.abs(r2.e), r2.sd()) + 6, i2.rounding = 1, external = false, r2 = r2.times(r2).plus(1).sqrt().plus(r2), external = true, i2.precision = t4, i2.rounding = n2, r2.ln());
}, P$3.inverseHyperbolicTangent = P$3.atanh = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isFinite() ? a2.e >= 0 ? new o2(a2.abs().eq(1) ? a2.s / 0 : a2.isZero() ? a2 : NaN) : (t4 = o2.precision, n2 = o2.rounding, i2 = a2.sd(), Math.max(i2, t4) < 2 * -a2.e - 1 ? finalise(new o2(a2), t4, n2, true) : (o2.precision = r2 = i2 - a2.e, a2 = divide$1(a2.plus(1), new o2(1).minus(a2), r2 + t4, 1), o2.precision = t4 + 4, o2.rounding = 1, a2 = a2.ln(), o2.precision = t4, o2.rounding = n2, a2.times(0.5))) : new o2(NaN);
}, P$3.inverseSine = P$3.asin = function() {
  var t4, n2, r2, i2, a2 = this, o2 = a2.constructor;
  return a2.isZero() ? new o2(a2) : (n2 = a2.abs().cmp(1), r2 = o2.precision, i2 = o2.rounding, n2 === -1 ? (o2.precision = r2 + 6, o2.rounding = 1, a2 = a2.div(new o2(1).minus(a2.times(a2)).sqrt().plus(1)).atan(), o2.precision = r2, o2.rounding = i2, a2.times(2)) : n2 === 0 ? (t4 = getPi(o2, r2 + 4, i2).times(0.5), t4.s = a2.s, t4) : new o2(NaN));
}, P$3.inverseTangent = P$3.atan = function() {
  var t4, n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding;
  if (!u2.isFinite()) {
    if (!u2.s) return new d2(NaN);
    if (p2 + 4 <= PI_PRECISION) return s2 = getPi(d2, p2 + 4, m2).times(0.5), s2.s = u2.s, s2;
  } else if (u2.isZero()) return new d2(u2);
  else if (u2.abs().eq(1) && p2 + 4 <= PI_PRECISION) return s2 = getPi(d2, p2 + 4, m2).times(0.25), s2.s = u2.s, s2;
  for (d2.precision = c2 = p2 + 10, d2.rounding = 1, r2 = Math.min(28, c2 / LOG_BASE + 2 | 0), t4 = r2; t4; --t4) u2 = u2.div(u2.times(u2).plus(1).sqrt().plus(1));
  for (external = false, n2 = Math.ceil(c2 / LOG_BASE), i2 = 1, l2 = u2.times(u2), s2 = new d2(u2), a2 = u2; t4 !== -1; ) if (a2 = a2.times(l2), o2 = s2.minus(a2.div(i2 += 2)), a2 = a2.times(l2), s2 = o2.plus(a2.div(i2 += 2)), s2.d[n2] !== void 0) for (t4 = n2; s2.d[t4] === o2.d[t4] && t4--; ) ;
  return r2 && (s2 = s2.times(2 << r2 - 1)), external = true, finalise(s2, d2.precision = p2, d2.rounding = m2, true);
}, P$3.isFinite = function() {
  return !!this.d;
}, P$3.isInteger = P$3.isInt = function() {
  return !!this.d && mathfloor(this.e / LOG_BASE) > this.d.length - 2;
}, P$3.isNaN = function() {
  return !this.s;
}, P$3.isNegative = P$3.isNeg = function() {
  return this.s < 0;
}, P$3.isPositive = P$3.isPos = function() {
  return this.s > 0;
}, P$3.isZero = function() {
  return !!this.d && this.d[0] === 0;
}, P$3.lessThan = P$3.lt = function(t4) {
  return this.cmp(t4) < 0;
}, P$3.lessThanOrEqualTo = P$3.lte = function(t4) {
  return this.cmp(t4) < 1;
}, P$3.logarithm = P$3.log = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2 = this, d2 = u2.constructor, p2 = d2.precision, m2 = d2.rounding, h2 = 5;
  if (t4 == null) t4 = new d2(10), n2 = true;
  else {
    if (t4 = new d2(t4), r2 = t4.d, t4.s < 0 || !r2 || !r2[0] || t4.eq(1)) return new d2(NaN);
    n2 = t4.eq(10);
  }
  if (r2 = u2.d, u2.s < 0 || !r2 || !r2[0] || u2.eq(1)) return new d2(r2 && !r2[0] ? -1 / 0 : u2.s == 1 ? r2 ? 0 : 1 / 0 : NaN);
  if (n2) if (r2.length > 1) o2 = true;
  else {
    for (a2 = r2[0]; a2 % 10 == 0; ) a2 /= 10;
    o2 = a2 !== 1;
  }
  if (external = false, c2 = p2 + h2, s2 = naturalLogarithm(u2, c2), i2 = n2 ? getLn10(d2, c2 + 10) : naturalLogarithm(t4, c2), l2 = divide$1(s2, i2, c2, 1), checkRoundingDigits(l2.d, a2 = p2, m2)) do
    if (c2 += 10, s2 = naturalLogarithm(u2, c2), i2 = n2 ? getLn10(d2, c2 + 10) : naturalLogarithm(t4, c2), l2 = divide$1(s2, i2, c2, 1), !o2) {
      +digitsToString(l2.d).slice(a2 + 1, a2 + 15) + 1 == 1e14 && (l2 = finalise(l2, p2 + 1, 0));
      break;
    }
  while (checkRoundingDigits(l2.d, a2 += 10, m2));
  return external = true, finalise(l2, p2, m2);
}, P$3.minus = P$3.sub = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.constructor;
  if (t4 = new g2(t4), !h2.d || !t4.d) return !h2.s || !t4.s ? t4 = new g2(NaN) : h2.d ? t4.s = -t4.s : t4 = new g2(t4.d || h2.s !== t4.s ? h2 : NaN), t4;
  if (h2.s != t4.s) return t4.s = -t4.s, h2.plus(t4);
  if (u2 = h2.d, m2 = t4.d, c2 = g2.precision, l2 = g2.rounding, !u2[0] || !m2[0]) {
    if (m2[0]) t4.s = -t4.s;
    else if (u2[0]) t4 = new g2(h2);
    else return new g2(l2 === 3 ? -0 : 0);
    return external ? finalise(t4, c2, l2) : t4;
  }
  if (r2 = mathfloor(t4.e / LOG_BASE), d2 = mathfloor(h2.e / LOG_BASE), u2 = u2.slice(), o2 = d2 - r2, o2) {
    for (p2 = o2 < 0, p2 ? (n2 = u2, o2 = -o2, s2 = m2.length) : (n2 = m2, r2 = d2, s2 = u2.length), i2 = Math.max(Math.ceil(c2 / LOG_BASE), s2) + 2, o2 > i2 && (o2 = i2, n2.length = 1), n2.reverse(), i2 = o2; i2--; ) n2.push(0);
    n2.reverse();
  } else {
    for (i2 = u2.length, s2 = m2.length, p2 = i2 < s2, p2 && (s2 = i2), i2 = 0; i2 < s2; i2++) if (u2[i2] != m2[i2]) {
      p2 = u2[i2] < m2[i2];
      break;
    }
    o2 = 0;
  }
  for (p2 && (n2 = u2, u2 = m2, m2 = n2, t4.s = -t4.s), s2 = u2.length, i2 = m2.length - s2; i2 > 0; --i2) u2[s2++] = 0;
  for (i2 = m2.length; i2 > o2; ) {
    if (u2[--i2] < m2[i2]) {
      for (a2 = i2; a2 && u2[--a2] === 0; ) u2[a2] = BASE - 1;
      --u2[a2], u2[i2] += BASE;
    }
    u2[i2] -= m2[i2];
  }
  for (; u2[--s2] === 0; ) u2.pop();
  for (; u2[0] === 0; u2.shift()) --r2;
  return u2[0] ? (t4.d = u2, t4.e = getBase10Exponent(u2, r2), external ? finalise(t4, c2, l2) : t4) : new g2(l2 === 3 ? -0 : 0);
}, P$3.modulo = P$3.mod = function(t4) {
  var n2, r2 = this, i2 = r2.constructor;
  return t4 = new i2(t4), !r2.d || !t4.s || t4.d && !t4.d[0] ? new i2(NaN) : !t4.d || r2.d && !r2.d[0] ? finalise(new i2(r2), i2.precision, i2.rounding) : (external = false, i2.modulo == 9 ? (n2 = divide$1(r2, t4.abs(), 0, 3, 1), n2.s *= t4.s) : n2 = divide$1(r2, t4, 0, i2.modulo, 1), n2 = n2.times(t4), external = true, r2.minus(n2));
}, P$3.naturalExponential = P$3.exp = function() {
  return naturalExponential(this);
}, P$3.naturalLogarithm = P$3.ln = function() {
  return naturalLogarithm(this);
}, P$3.negated = P$3.neg = function() {
  var t4 = new this.constructor(this);
  return t4.s = -t4.s, finalise(t4);
}, P$3.plus = P$3.add = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2 = this, m2 = p2.constructor;
  if (t4 = new m2(t4), !p2.d || !t4.d) return !p2.s || !t4.s ? t4 = new m2(NaN) : p2.d || (t4 = new m2(t4.d || p2.s === t4.s ? p2 : NaN)), t4;
  if (p2.s != t4.s) return t4.s = -t4.s, p2.minus(t4);
  if (u2 = p2.d, d2 = t4.d, c2 = m2.precision, l2 = m2.rounding, !u2[0] || !d2[0]) return d2[0] || (t4 = new m2(p2)), external ? finalise(t4, c2, l2) : t4;
  if (o2 = mathfloor(p2.e / LOG_BASE), i2 = mathfloor(t4.e / LOG_BASE), u2 = u2.slice(), a2 = o2 - i2, a2) {
    for (a2 < 0 ? (r2 = u2, a2 = -a2, s2 = d2.length) : (r2 = d2, i2 = o2, s2 = u2.length), o2 = Math.ceil(c2 / LOG_BASE), s2 = o2 > s2 ? o2 + 1 : s2 + 1, a2 > s2 && (a2 = s2, r2.length = 1), r2.reverse(); a2--; ) r2.push(0);
    r2.reverse();
  }
  for (s2 = u2.length, a2 = d2.length, s2 - a2 < 0 && (a2 = s2, r2 = d2, d2 = u2, u2 = r2), n2 = 0; a2; ) n2 = (u2[--a2] = u2[a2] + d2[a2] + n2) / BASE | 0, u2[a2] %= BASE;
  for (n2 && (u2.unshift(n2), ++i2), s2 = u2.length; u2[--s2] == 0; ) u2.pop();
  return t4.d = u2, t4.e = getBase10Exponent(u2, i2), external ? finalise(t4, c2, l2) : t4;
}, P$3.precision = P$3.sd = function(t4) {
  var n2, r2 = this;
  if (t4 !== void 0 && t4 !== !!t4 && t4 !== 1 && t4 !== 0) throw Error(invalidArgument + t4);
  return r2.d ? (n2 = getPrecision(r2.d), t4 && r2.e + 1 > n2 && (n2 = r2.e + 1)) : n2 = NaN, n2;
}, P$3.round = function() {
  var t4 = this, n2 = t4.constructor;
  return finalise(new n2(t4), t4.e + 1, n2.rounding);
}, P$3.sine = P$3.sin = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + Math.max(r2.e, r2.sd()) + LOG_BASE, i2.rounding = 1, r2 = sine(i2, toLessThanHalfPi(i2, r2)), i2.precision = t4, i2.rounding = n2, finalise(quadrant > 2 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3.squareRoot = P$3.sqrt = function() {
  var t4, n2, r2, i2, a2, o2, s2 = this, c2 = s2.d, l2 = s2.e, u2 = s2.s, d2 = s2.constructor;
  if (u2 !== 1 || !c2 || !c2[0]) return new d2(!u2 || u2 < 0 && (!c2 || c2[0]) ? NaN : c2 ? s2 : 1 / 0);
  for (external = false, u2 = Math.sqrt(+s2), u2 == 0 || u2 == 1 / 0 ? (n2 = digitsToString(c2), (n2.length + l2) % 2 == 0 && (n2 += `0`), u2 = Math.sqrt(n2), l2 = mathfloor((l2 + 1) / 2) - (l2 < 0 || l2 % 2), u2 == 1 / 0 ? n2 = `5e` + l2 : (n2 = u2.toExponential(), n2 = n2.slice(0, n2.indexOf(`e`) + 1) + l2), i2 = new d2(n2)) : i2 = new d2(u2.toString()), r2 = (l2 = d2.precision) + 3; ; ) if (o2 = i2, i2 = o2.plus(divide$1(s2, o2, r2 + 2, 1)).times(0.5), digitsToString(o2.d).slice(0, r2) === (n2 = digitsToString(i2.d)).slice(0, r2)) if (n2 = n2.slice(r2 - 3, r2 + 1), n2 == `9999` || !a2 && n2 == `4999`) {
    if (!a2 && (finalise(o2, l2 + 1, 0), o2.times(o2).eq(s2))) {
      i2 = o2;
      break;
    }
    r2 += 4, a2 = 1;
  } else {
    (!+n2 || !+n2.slice(1) && n2.charAt(0) == `5`) && (finalise(i2, l2 + 1, 1), t4 = !i2.times(i2).eq(s2));
    break;
  }
  return external = true, finalise(i2, l2, d2.rounding, t4);
}, P$3.tangent = P$3.tan = function() {
  var t4, n2, r2 = this, i2 = r2.constructor;
  return r2.isFinite() ? r2.isZero() ? new i2(r2) : (t4 = i2.precision, n2 = i2.rounding, i2.precision = t4 + 10, i2.rounding = 1, r2 = r2.sin(), r2.s = 1, r2 = divide$1(r2, new i2(1).minus(r2.times(r2)).sqrt(), t4 + 10, 0), i2.precision = t4, i2.rounding = n2, finalise(quadrant == 2 || quadrant == 4 ? r2.neg() : r2, t4, n2, true)) : new i2(NaN);
}, P$3.times = P$3.mul = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2 = this, p2 = d2.constructor, m2 = d2.d, h2 = (t4 = new p2(t4)).d;
  if (t4.s *= d2.s, !m2 || !m2[0] || !h2 || !h2[0]) return new p2(!t4.s || m2 && !m2[0] && !h2 || h2 && !h2[0] && !m2 ? NaN : !m2 || !h2 ? t4.s / 0 : t4.s * 0);
  for (r2 = mathfloor(d2.e / LOG_BASE) + mathfloor(t4.e / LOG_BASE), l2 = m2.length, u2 = h2.length, l2 < u2 && (o2 = m2, m2 = h2, h2 = o2, s2 = l2, l2 = u2, u2 = s2), o2 = [], s2 = l2 + u2, i2 = s2; i2--; ) o2.push(0);
  for (i2 = u2; --i2 >= 0; ) {
    for (n2 = 0, a2 = l2 + i2; a2 > i2; ) c2 = o2[a2] + h2[i2] * m2[a2 - i2 - 1] + n2, o2[a2--] = c2 % BASE | 0, n2 = c2 / BASE | 0;
    o2[a2] = (o2[a2] + n2) % BASE | 0;
  }
  for (; !o2[--s2]; ) o2.pop();
  return n2 ? ++r2 : o2.shift(), t4.d = o2, t4.e = getBase10Exponent(o2, r2), external ? finalise(t4, p2.precision, p2.rounding) : t4;
}, P$3.toBinary = function(t4, n2) {
  return toStringBinary(this, 2, t4, n2);
}, P$3.toDecimalPlaces = P$3.toDP = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return r2 = new i2(r2), t4 === void 0 ? r2 : (checkInt32(t4, 0, MAX_DIGITS), n2 === void 0 ? n2 = i2.rounding : checkInt32(n2, 0, 8), finalise(r2, t4 + r2.e + 1, n2));
}, P$3.toExponential = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString(i2, true) : (checkInt32(t4, 0, MAX_DIGITS), n2 === void 0 ? n2 = a2.rounding : checkInt32(n2, 0, 8), i2 = finalise(new a2(i2), t4 + 1, n2), r2 = finiteToString(i2, true, t4 + 1)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3.toFixed = function(t4, n2) {
  var r2, i2, a2 = this, o2 = a2.constructor;
  return t4 === void 0 ? r2 = finiteToString(a2) : (checkInt32(t4, 0, MAX_DIGITS), n2 === void 0 ? n2 = o2.rounding : checkInt32(n2, 0, 8), i2 = finalise(new o2(a2), t4 + a2.e + 1, n2), r2 = finiteToString(i2, false, t4 + i2.e + 1)), a2.isNeg() && !a2.isZero() ? `-` + r2 : r2;
}, P$3.toFraction = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = this, g2 = h2.d, v2 = h2.constructor;
  if (!g2) return new v2(h2);
  if (u2 = r2 = new v2(1), i2 = l2 = new v2(0), n2 = new v2(i2), o2 = n2.e = getPrecision(g2) - h2.e - 1, s2 = o2 % LOG_BASE, n2.d[0] = mathpow(10, s2 < 0 ? LOG_BASE + s2 : s2), t4 == null) t4 = o2 > 0 ? n2 : u2;
  else {
    if (c2 = new v2(t4), !c2.isInt() || c2.lt(u2)) throw Error(invalidArgument + c2);
    t4 = c2.gt(n2) ? o2 > 0 ? n2 : u2 : c2;
  }
  for (external = false, c2 = new v2(digitsToString(g2)), d2 = v2.precision, v2.precision = o2 = g2.length * LOG_BASE * 2; p2 = divide$1(c2, n2, 0, 1, 1), a2 = r2.plus(p2.times(i2)), a2.cmp(t4) != 1; ) r2 = i2, i2 = a2, a2 = u2, u2 = l2.plus(p2.times(a2)), l2 = a2, a2 = n2, n2 = c2.minus(p2.times(a2)), c2 = a2;
  return a2 = divide$1(t4.minus(r2), i2, 0, 1, 1), l2 = l2.plus(a2.times(u2)), r2 = r2.plus(a2.times(i2)), l2.s = u2.s = h2.s, m2 = divide$1(u2, i2, o2, 1).minus(h2).abs().cmp(divide$1(l2, r2, o2, 1).minus(h2).abs()) < 1 ? [u2, i2] : [l2, r2], v2.precision = d2, external = true, m2;
}, P$3.toHexadecimal = P$3.toHex = function(t4, n2) {
  return toStringBinary(this, 16, t4, n2);
}, P$3.toNearest = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  if (r2 = new i2(r2), t4 == null) {
    if (!r2.d) return r2;
    t4 = new i2(1), n2 = i2.rounding;
  } else {
    if (t4 = new i2(t4), n2 === void 0 ? n2 = i2.rounding : checkInt32(n2, 0, 8), !r2.d) return t4.s ? r2 : t4;
    if (!t4.d) return t4.s &&= r2.s, t4;
  }
  return t4.d[0] ? (external = false, r2 = divide$1(r2, t4, 0, n2, 1).times(t4), external = true, finalise(r2)) : (t4.s = r2.s, r2 = t4), r2;
}, P$3.toNumber = function() {
  return +this;
}, P$3.toOctal = function(t4, n2) {
  return toStringBinary(this, 8, t4, n2);
}, P$3.toPower = P$3.pow = function(t4) {
  var n2, r2, i2, a2, o2, s2, c2 = this, l2 = c2.constructor, u2 = +(t4 = new l2(t4));
  if (!c2.d || !t4.d || !c2.d[0] || !t4.d[0]) return new l2(mathpow(+c2, u2));
  if (c2 = new l2(c2), c2.eq(1)) return c2;
  if (i2 = l2.precision, o2 = l2.rounding, t4.eq(1)) return finalise(c2, i2, o2);
  if (n2 = mathfloor(t4.e / LOG_BASE), n2 >= t4.d.length - 1 && (r2 = u2 < 0 ? -u2 : u2) <= MAX_SAFE_INTEGER) return a2 = intPow(l2, c2, r2, i2), t4.s < 0 ? new l2(1).div(a2) : finalise(a2, i2, o2);
  if (s2 = c2.s, s2 < 0) {
    if (n2 < t4.d.length - 1) return new l2(NaN);
    if (t4.d[n2] & 1 || (s2 = 1), c2.e == 0 && c2.d[0] == 1 && c2.d.length == 1) return c2.s = s2, c2;
  }
  return r2 = mathpow(+c2, u2), n2 = r2 == 0 || !isFinite(r2) ? mathfloor(u2 * (Math.log(`0.` + digitsToString(c2.d)) / Math.LN10 + c2.e + 1)) : new l2(r2 + ``).e, n2 > l2.maxE + 1 || n2 < l2.minE - 1 ? new l2(n2 > 0 ? s2 / 0 : 0) : (external = false, l2.rounding = c2.s = 1, r2 = Math.min(12, (n2 + ``).length), a2 = naturalExponential(t4.times(naturalLogarithm(c2, i2 + r2)), i2), a2.d && (a2 = finalise(a2, i2 + 5, 1), checkRoundingDigits(a2.d, i2, o2) && (n2 = i2 + 10, a2 = finalise(naturalExponential(t4.times(naturalLogarithm(c2, n2 + r2)), n2), n2 + 5, 1), +digitsToString(a2.d).slice(i2 + 1, i2 + 15) + 1 == 1e14 && (a2 = finalise(a2, i2 + 1, 0)))), a2.s = s2, external = true, l2.rounding = o2, finalise(a2, i2, o2));
}, P$3.toPrecision = function(t4, n2) {
  var r2, i2 = this, a2 = i2.constructor;
  return t4 === void 0 ? r2 = finiteToString(i2, i2.e <= a2.toExpNeg || i2.e >= a2.toExpPos) : (checkInt32(t4, 1, MAX_DIGITS), n2 === void 0 ? n2 = a2.rounding : checkInt32(n2, 0, 8), i2 = finalise(new a2(i2), t4, n2), r2 = finiteToString(i2, t4 <= i2.e || i2.e <= a2.toExpNeg, t4)), i2.isNeg() && !i2.isZero() ? `-` + r2 : r2;
}, P$3.toSignificantDigits = P$3.toSD = function(t4, n2) {
  var r2 = this, i2 = r2.constructor;
  return t4 === void 0 ? (t4 = i2.precision, n2 = i2.rounding) : (checkInt32(t4, 1, MAX_DIGITS), n2 === void 0 ? n2 = i2.rounding : checkInt32(n2, 0, 8)), finalise(new i2(r2), t4, n2);
}, P$3.toString = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() && !t4.isZero() ? `-` + r2 : r2;
}, P$3.truncated = P$3.trunc = function() {
  return finalise(new this.constructor(this), this.e + 1, 1);
}, P$3.valueOf = P$3.toJSON = function() {
  var t4 = this, n2 = t4.constructor, r2 = finiteToString(t4, t4.e <= n2.toExpNeg || t4.e >= n2.toExpPos);
  return t4.isNeg() ? `-` + r2 : r2;
};
function digitsToString(t4) {
  var n2, r2, i2, a2 = t4.length - 1, o2 = ``, s2 = t4[0];
  if (a2 > 0) {
    for (o2 += s2, n2 = 1; n2 < a2; n2++) i2 = t4[n2] + ``, r2 = LOG_BASE - i2.length, r2 && (o2 += getZeroString(r2)), o2 += i2;
    s2 = t4[n2], i2 = s2 + ``, r2 = LOG_BASE - i2.length, r2 && (o2 += getZeroString(r2));
  } else if (s2 === 0) return `0`;
  for (; s2 % 10 == 0; ) s2 /= 10;
  return o2 + s2;
}
function checkInt32(t4, n2, r2) {
  if (t4 !== ~~t4 || t4 < n2 || t4 > r2) throw Error(invalidArgument + t4);
}
function checkRoundingDigits(t4, n2, r2, i2) {
  var a2, o2, s2, c2;
  for (o2 = t4[0]; o2 >= 10; o2 /= 10) --n2;
  return --n2 < 0 ? (n2 += LOG_BASE, a2 = 0) : (a2 = Math.ceil((n2 + 1) / LOG_BASE), n2 %= LOG_BASE), o2 = mathpow(10, LOG_BASE - n2), c2 = t4[a2] % o2 | 0, i2 == null ? n2 < 3 ? (n2 == 0 ? c2 = c2 / 100 | 0 : n2 == 1 && (c2 = c2 / 10 | 0), s2 = r2 < 4 && c2 == 99999 || r2 > 3 && c2 == 49999 || c2 == 5e4 || c2 == 0) : s2 = (r2 < 4 && c2 + 1 == o2 || r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 100 | 0) == mathpow(10, n2 - 2) - 1 || (c2 == o2 / 2 || c2 == 0) && (t4[a2 + 1] / o2 / 100 | 0) == 0 : n2 < 4 ? (n2 == 0 ? c2 = c2 / 1e3 | 0 : n2 == 1 ? c2 = c2 / 100 | 0 : n2 == 2 && (c2 = c2 / 10 | 0), s2 = (i2 || r2 < 4) && c2 == 9999 || !i2 && r2 > 3 && c2 == 4999) : s2 = ((i2 || r2 < 4) && c2 + 1 == o2 || !i2 && r2 > 3 && c2 + 1 == o2 / 2) && (t4[a2 + 1] / o2 / 1e3 | 0) == mathpow(10, n2 - 3) - 1, s2;
}
function convertBase(t4, n2, r2) {
  for (var i2, a2 = [0], o2, s2 = 0, c2 = t4.length; s2 < c2; ) {
    for (o2 = a2.length; o2--; ) a2[o2] *= n2;
    for (a2[0] += NUMERALS.indexOf(t4.charAt(s2++)), i2 = 0; i2 < a2.length; i2++) a2[i2] > r2 - 1 && (a2[i2 + 1] === void 0 && (a2[i2 + 1] = 0), a2[i2 + 1] += a2[i2] / r2 | 0, a2[i2] %= r2);
  }
  return a2.reverse();
}
function cosine(t4, n2) {
  var r2, i2, a2;
  if (n2.isZero()) return n2;
  i2 = n2.d.length, i2 < 32 ? (r2 = Math.ceil(i2 / 3), a2 = (1 / tinyPow(4, r2)).toString()) : (r2 = 16, a2 = `2.3283064365386962890625e-10`), t4.precision += r2, n2 = taylorSeries(t4, 1, n2.times(a2), new t4(1));
  for (var o2 = r2; o2--; ) {
    var s2 = n2.times(n2);
    n2 = s2.times(s2).minus(s2).times(8).plus(1);
  }
  return t4.precision -= r2, n2;
}
var divide$1 = /* @__PURE__ */ (function() {
  function t4(t5, n3, r3) {
    var i2, a2 = 0, o2 = t5.length;
    for (t5 = t5.slice(); o2--; ) i2 = t5[o2] * n3 + a2, t5[o2] = i2 % r3 | 0, a2 = i2 / r3 | 0;
    return a2 && t5.unshift(a2), t5;
  }
  function n2(t5, n3, r3, i2) {
    var a2, o2;
    if (r3 != i2) o2 = r3 > i2 ? 1 : -1;
    else for (a2 = o2 = 0; a2 < r3; a2++) if (t5[a2] != n3[a2]) {
      o2 = t5[a2] > n3[a2] ? 1 : -1;
      break;
    }
    return o2;
  }
  function r2(t5, n3, r3, i2) {
    for (var a2 = 0; r3--; ) t5[r3] -= a2, a2 = +(t5[r3] < n3[r3]), t5[r3] = a2 * i2 + t5[r3] - n3[r3];
    for (; !t5[0] && t5.length > 1; ) t5.shift();
  }
  return function(i2, a2, o2, s2, c2, l2) {
    var u2, d2, p2, m2, h2, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2, L2 = i2.constructor, R2 = i2.s == a2.s ? 1 : -1, z2 = i2.d, V2 = a2.d;
    if (!z2 || !z2[0] || !V2 || !V2[0]) return new L2(!i2.s || !a2.s || (z2 ? V2 && z2[0] == V2[0] : !V2) ? NaN : z2 && z2[0] == 0 || !V2 ? R2 * 0 : R2 / 0);
    for (l2 ? (h2 = 1, d2 = i2.e - a2.e) : (l2 = BASE, h2 = LOG_BASE, d2 = mathfloor(i2.e / h2) - mathfloor(a2.e / h2)), F = V2.length, M2 = z2.length, b2 = new L2(R2), x2 = b2.d = [], p2 = 0; V2[p2] == (z2[p2] || 0); p2++) ;
    if (V2[p2] > (z2[p2] || 0) && d2--, o2 == null ? (D = o2 = L2.precision, s2 = L2.rounding) : D = c2 ? o2 + (i2.e - a2.e) + 1 : o2, D < 0) x2.push(1), g2 = true;
    else {
      if (D = D / h2 + 2 | 0, p2 = 0, F == 1) {
        for (m2 = 0, V2 = V2[0], D++; (p2 < M2 || m2) && D--; p2++) O2 = m2 * l2 + (z2[p2] || 0), x2[p2] = O2 / V2 | 0, m2 = O2 % V2 | 0;
        g2 = m2 || p2 < M2;
      } else {
        for (m2 = l2 / (V2[0] + 1) | 0, m2 > 1 && (V2 = t4(V2, m2, l2), z2 = t4(z2, m2, l2), F = V2.length, M2 = z2.length), j2 = F, S2 = z2.slice(0, F), w2 = S2.length; w2 < F; ) S2[w2++] = 0;
        I2 = V2.slice(), I2.unshift(0), N2 = V2[0], V2[1] >= l2 / 2 && ++N2;
        do
          m2 = 0, u2 = n2(V2, S2, F, w2), u2 < 0 ? (E = S2[0], F != w2 && (E = E * l2 + (S2[1] || 0)), m2 = E / N2 | 0, m2 > 1 ? (m2 >= l2 && (m2 = l2 - 1), v2 = t4(V2, m2, l2), y2 = v2.length, w2 = S2.length, u2 = n2(v2, S2, y2, w2), u2 == 1 && (m2--, r2(v2, F < y2 ? I2 : V2, y2, l2))) : (m2 == 0 && (u2 = m2 = 1), v2 = V2.slice()), y2 = v2.length, y2 < w2 && v2.unshift(0), r2(S2, v2, w2, l2), u2 == -1 && (w2 = S2.length, u2 = n2(V2, S2, F, w2), u2 < 1 && (m2++, r2(S2, F < w2 ? I2 : V2, w2, l2))), w2 = S2.length) : u2 === 0 && (m2++, S2 = [0]), x2[p2++] = m2, u2 && S2[0] ? S2[w2++] = z2[j2] || 0 : (S2 = [z2[j2]], w2 = 1);
        while ((j2++ < M2 || S2[0] !== void 0) && D--);
        g2 = S2[0] !== void 0;
      }
      x2[0] || x2.shift();
    }
    if (h2 == 1) b2.e = d2, inexact = g2;
    else {
      for (p2 = 1, m2 = x2[0]; m2 >= 10; m2 /= 10) p2++;
      b2.e = p2 + d2 * h2 - 1, finalise(b2, c2 ? o2 + b2.e + 1 : o2, s2, g2);
    }
    return b2;
  };
})();
function finalise(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor;
  out: if (n2 != null) {
    if (p2 = t4.d, !p2) return t4;
    for (a2 = 1, c2 = p2[0]; c2 >= 10; c2 /= 10) a2++;
    if (o2 = n2 - a2, o2 < 0) o2 += LOG_BASE, s2 = n2, d2 = p2[m2 = 0], l2 = d2 / mathpow(10, a2 - s2 - 1) % 10 | 0;
    else if (m2 = Math.ceil((o2 + 1) / LOG_BASE), c2 = p2.length, m2 >= c2) if (i2) {
      for (; c2++ <= m2; ) p2.push(0);
      d2 = l2 = 0, a2 = 1, o2 %= LOG_BASE, s2 = o2 - LOG_BASE + 1;
    } else break out;
    else {
      for (d2 = c2 = p2[m2], a2 = 1; c2 >= 10; c2 /= 10) a2++;
      o2 %= LOG_BASE, s2 = o2 - LOG_BASE + a2, l2 = s2 < 0 ? 0 : d2 / mathpow(10, a2 - s2 - 1) % 10 | 0;
    }
    if (i2 = i2 || n2 < 0 || p2[m2 + 1] !== void 0 || (s2 < 0 ? d2 : d2 % mathpow(10, a2 - s2 - 1)), u2 = r2 < 4 ? (l2 || i2) && (r2 == 0 || r2 == (t4.s < 0 ? 3 : 2)) : l2 > 5 || l2 == 5 && (r2 == 4 || i2 || r2 == 6 && (o2 > 0 ? s2 > 0 ? d2 / mathpow(10, a2 - s2) : 0 : p2[m2 - 1]) % 10 & 1 || r2 == (t4.s < 0 ? 8 : 7)), n2 < 1 || !p2[0]) return p2.length = 0, u2 ? (n2 -= t4.e + 1, p2[0] = mathpow(10, (LOG_BASE - n2 % LOG_BASE) % LOG_BASE), t4.e = -n2 || 0) : p2[0] = t4.e = 0, t4;
    if (o2 == 0 ? (p2.length = m2, c2 = 1, m2--) : (p2.length = m2 + 1, c2 = mathpow(10, LOG_BASE - o2), p2[m2] = s2 > 0 ? (d2 / mathpow(10, a2 - s2) % mathpow(10, s2) | 0) * c2 : 0), u2) for (; ; ) if (m2 == 0) {
      for (o2 = 1, s2 = p2[0]; s2 >= 10; s2 /= 10) o2++;
      for (s2 = p2[0] += c2, c2 = 1; s2 >= 10; s2 /= 10) c2++;
      o2 != c2 && (t4.e++, p2[0] == BASE && (p2[0] = 1));
      break;
    } else {
      if (p2[m2] += c2, p2[m2] != BASE) break;
      p2[m2--] = 0, c2 = 1;
    }
    for (o2 = p2.length; p2[--o2] === 0; ) p2.pop();
  }
  return external && (t4.e > h2.maxE ? (t4.d = null, t4.e = NaN) : t4.e < h2.minE && (t4.e = 0, t4.d = [0])), t4;
}
function finiteToString(t4, n2, r2) {
  if (!t4.isFinite()) return nonFiniteToString(t4);
  var i2, a2 = t4.e, o2 = digitsToString(t4.d), s2 = o2.length;
  return n2 ? (r2 && (i2 = r2 - s2) > 0 ? o2 = o2.charAt(0) + `.` + o2.slice(1) + getZeroString(i2) : s2 > 1 && (o2 = o2.charAt(0) + `.` + o2.slice(1)), o2 = o2 + (t4.e < 0 ? `e` : `e+`) + t4.e) : a2 < 0 ? (o2 = `0.` + getZeroString(-a2 - 1) + o2, r2 && (i2 = r2 - s2) > 0 && (o2 += getZeroString(i2))) : a2 >= s2 ? (o2 += getZeroString(a2 + 1 - s2), r2 && (i2 = r2 - a2 - 1) > 0 && (o2 = o2 + `.` + getZeroString(i2))) : ((i2 = a2 + 1) < s2 && (o2 = o2.slice(0, i2) + `.` + o2.slice(i2)), r2 && (i2 = r2 - s2) > 0 && (a2 + 1 === s2 && (o2 += `.`), o2 += getZeroString(i2))), o2;
}
function getBase10Exponent(t4, n2) {
  var r2 = t4[0];
  for (n2 *= LOG_BASE; r2 >= 10; r2 /= 10) n2++;
  return n2;
}
function getLn10(t4, n2, r2) {
  if (n2 > LN10_PRECISION) throw external = true, r2 && (t4.precision = r2), Error(precisionLimitExceeded);
  return finalise(new t4(LN10), n2, 1, true);
}
function getPi(t4, n2, r2) {
  if (n2 > PI_PRECISION) throw Error(precisionLimitExceeded);
  return finalise(new t4(PI), n2, r2, true);
}
function getPrecision(t4) {
  var n2 = t4.length - 1, r2 = n2 * LOG_BASE + 1;
  if (n2 = t4[n2], n2) {
    for (; n2 % 10 == 0; n2 /= 10) r2--;
    for (n2 = t4[0]; n2 >= 10; n2 /= 10) r2++;
  }
  return r2;
}
function getZeroString(t4) {
  for (var n2 = ``; t4--; ) n2 += `0`;
  return n2;
}
function intPow(t4, n2, r2, i2) {
  var a2, o2 = new t4(1), s2 = Math.ceil(i2 / LOG_BASE + 4);
  for (external = false; ; ) {
    if (r2 % 2 && (o2 = o2.times(n2), truncate(o2.d, s2) && (a2 = true)), r2 = mathfloor(r2 / 2), r2 === 0) {
      r2 = o2.d.length - 1, a2 && o2.d[r2] === 0 && ++o2.d[r2];
      break;
    }
    n2 = n2.times(n2), truncate(n2.d, s2);
  }
  return external = true, o2;
}
function isOdd(t4) {
  return t4.d[t4.d.length - 1] & 1;
}
function maxOrMin(t4, n2, r2) {
  for (var i2, a2 = new t4(n2[0]), o2 = 0; ++o2 < n2.length; ) if (i2 = new t4(n2[o2]), i2.s) a2[r2](i2) && (a2 = i2);
  else {
    a2 = i2;
    break;
  }
  return a2;
}
function naturalExponential(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2 = 0, d2 = 0, p2 = 0, m2 = t4.constructor, h2 = m2.rounding, g2 = m2.precision;
  if (!t4.d || !t4.d[0] || t4.e > 17) return new m2(t4.d ? t4.d[0] ? t4.s < 0 ? 0 : 1 / 0 : 1 : t4.s ? t4.s < 0 ? 0 : t4 : NaN);
  for (n2 == null ? (external = false, l2 = g2) : l2 = n2, c2 = new m2(0.03125); t4.e > -2; ) t4 = t4.times(c2), p2 += 5;
  for (i2 = Math.log(mathpow(2, p2)) / Math.LN10 * 2 + 5 | 0, l2 += i2, r2 = o2 = s2 = new m2(1), m2.precision = l2; ; ) {
    if (o2 = finalise(o2.times(t4), l2, 1), r2 = r2.times(++d2), c2 = s2.plus(divide$1(o2, r2, l2, 1)), digitsToString(c2.d).slice(0, l2) === digitsToString(s2.d).slice(0, l2)) {
      for (a2 = p2; a2--; ) s2 = finalise(s2.times(s2), l2, 1);
      if (n2 == null) if (u2 < 3 && checkRoundingDigits(s2.d, l2 - i2, h2, u2)) m2.precision = l2 += 10, r2 = o2 = c2 = new m2(1), d2 = 0, u2++;
      else return finalise(s2, m2.precision = g2, h2, external = true);
      else return m2.precision = g2, s2;
    }
    s2 = c2;
  }
}
function naturalLogarithm(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = 1, g2 = 10, v2 = t4, y2 = v2.d, b2 = v2.constructor, x2 = b2.rounding, S2 = b2.precision;
  if (v2.s < 0 || !y2 || !y2[0] || !v2.e && y2[0] == 1 && y2.length == 1) return new b2(y2 && !y2[0] ? -1 / 0 : v2.s == 1 ? y2 ? 0 : v2 : NaN);
  if (n2 == null ? (external = false, d2 = S2) : d2 = n2, b2.precision = d2 += g2, r2 = digitsToString(y2), i2 = r2.charAt(0), Math.abs(o2 = v2.e) < 15e14) {
    for (; i2 < 7 && i2 != 1 || i2 == 1 && r2.charAt(1) > 3; ) v2 = v2.times(t4), r2 = digitsToString(v2.d), i2 = r2.charAt(0), h2++;
    o2 = v2.e, i2 > 1 ? (v2 = new b2(`0.` + r2), o2++) : v2 = new b2(i2 + `.` + r2.slice(1));
  } else return u2 = getLn10(b2, d2 + 2, S2).times(o2 + ``), v2 = naturalLogarithm(new b2(i2 + `.` + r2.slice(1)), d2 - g2).plus(u2), b2.precision = S2, n2 == null ? finalise(v2, S2, x2, external = true) : v2;
  for (p2 = v2, l2 = s2 = v2 = divide$1(v2.minus(1), v2.plus(1), d2, 1), m2 = finalise(v2.times(v2), d2, 1), a2 = 3; ; ) {
    if (s2 = finalise(s2.times(m2), d2, 1), u2 = l2.plus(divide$1(s2, new b2(a2), d2, 1)), digitsToString(u2.d).slice(0, d2) === digitsToString(l2.d).slice(0, d2)) if (l2 = l2.times(2), o2 !== 0 && (l2 = l2.plus(getLn10(b2, d2 + 2, S2).times(o2 + ``))), l2 = divide$1(l2, new b2(h2), d2, 1), n2 == null) if (checkRoundingDigits(l2.d, d2 - g2, x2, c2)) b2.precision = d2 += g2, u2 = s2 = v2 = divide$1(p2.minus(1), p2.plus(1), d2, 1), m2 = finalise(v2.times(v2), d2, 1), a2 = c2 = 1;
    else return finalise(l2, b2.precision = S2, x2, external = true);
    else return b2.precision = S2, l2;
    l2 = u2, a2 += 2;
  }
}
function nonFiniteToString(t4) {
  return String(t4.s * t4.s / 0);
}
function parseDecimal(t4, n2) {
  var r2, i2, a2;
  for ((r2 = n2.indexOf(`.`)) > -1 && (n2 = n2.replace(`.`, ``)), (i2 = n2.search(/e/i)) > 0 ? (r2 < 0 && (r2 = i2), r2 += +n2.slice(i2 + 1), n2 = n2.substring(0, i2)) : r2 < 0 && (r2 = n2.length), i2 = 0; n2.charCodeAt(i2) === 48; i2++) ;
  for (a2 = n2.length; n2.charCodeAt(a2 - 1) === 48; --a2) ;
  if (n2 = n2.slice(i2, a2), n2) {
    if (a2 -= i2, t4.e = r2 = r2 - i2 - 1, t4.d = [], i2 = (r2 + 1) % LOG_BASE, r2 < 0 && (i2 += LOG_BASE), i2 < a2) {
      for (i2 && t4.d.push(+n2.slice(0, i2)), a2 -= LOG_BASE; i2 < a2; ) t4.d.push(+n2.slice(i2, i2 += LOG_BASE));
      n2 = n2.slice(i2), i2 = LOG_BASE - n2.length;
    } else i2 -= a2;
    for (; i2--; ) n2 += `0`;
    t4.d.push(+n2), external && (t4.e > t4.constructor.maxE ? (t4.d = null, t4.e = NaN) : t4.e < t4.constructor.minE && (t4.e = 0, t4.d = [0]));
  } else t4.e = 0, t4.d = [0];
  return t4;
}
function parseOther(t4, n2) {
  var r2, i2, a2, o2, s2, c2, l2, u2, d2;
  if (n2.indexOf(`_`) > -1) {
    if (n2 = n2.replace(/(\d)_(?=\d)/g, `$1`), isDecimal.test(n2)) return parseDecimal(t4, n2);
  } else if (n2 === `Infinity` || n2 === `NaN`) return +n2 || (t4.s = NaN), t4.e = NaN, t4.d = null, t4;
  if (isHex.test(n2)) r2 = 16, n2 = n2.toLowerCase();
  else if (isBinary.test(n2)) r2 = 2;
  else if (isOctal.test(n2)) r2 = 8;
  else throw Error(invalidArgument + n2);
  for (o2 = n2.search(/p/i), o2 > 0 ? (l2 = +n2.slice(o2 + 1), n2 = n2.substring(2, o2)) : n2 = n2.slice(2), o2 = n2.indexOf(`.`), s2 = o2 >= 0, i2 = t4.constructor, s2 && (n2 = n2.replace(`.`, ``), c2 = n2.length, o2 = c2 - o2, a2 = intPow(i2, new i2(r2), o2, o2 * 2)), u2 = convertBase(n2, r2, BASE), d2 = u2.length - 1, o2 = d2; u2[o2] === 0; --o2) u2.pop();
  return o2 < 0 ? new i2(t4.s * 0) : (t4.e = getBase10Exponent(u2, d2), t4.d = u2, external = false, s2 && (t4 = divide$1(t4, a2, c2 * 4)), l2 && (t4 = t4.times(Math.abs(l2) < 54 ? mathpow(2, l2) : Decimal.pow(2, l2))), external = true, t4);
}
function sine(t4, n2) {
  var r2, i2 = n2.d.length;
  if (i2 < 3) return n2.isZero() ? n2 : taylorSeries(t4, 2, n2, n2);
  r2 = 1.4 * Math.sqrt(i2), r2 = r2 > 16 ? 16 : r2 | 0, n2 = n2.times(1 / tinyPow(5, r2)), n2 = taylorSeries(t4, 2, n2, n2);
  for (var a2, o2 = new t4(5), s2 = new t4(16), c2 = new t4(20); r2--; ) a2 = n2.times(n2), n2 = n2.times(o2.plus(a2.times(s2.times(a2).minus(c2))));
  return n2;
}
function taylorSeries(t4, n2, r2, i2, a2) {
  var o2, s2, c2, l2, d2 = t4.precision, p2 = Math.ceil(d2 / LOG_BASE);
  for (external = false, l2 = r2.times(r2), c2 = new t4(i2); ; ) {
    if (s2 = divide$1(c2.times(l2), new t4(n2++ * n2++), d2, 1), c2 = a2 ? i2.plus(s2) : i2.minus(s2), i2 = divide$1(s2.times(l2), new t4(n2++ * n2++), d2, 1), s2 = c2.plus(i2), s2.d[p2] !== void 0) {
      for (o2 = p2; s2.d[o2] === c2.d[o2] && o2--; ) ;
      if (o2 == -1) break;
    }
    o2 = c2, c2 = i2, i2 = s2, s2 = o2;
  }
  return external = true, s2.d.length = p2 + 1, s2;
}
function tinyPow(t4, n2) {
  for (var r2 = t4; --n2; ) r2 *= t4;
  return r2;
}
function toLessThanHalfPi(t4, n2) {
  var r2, i2 = n2.s < 0, a2 = getPi(t4, t4.precision, 1), o2 = a2.times(0.5);
  if (n2 = n2.abs(), n2.lte(o2)) return quadrant = i2 ? 4 : 1, n2;
  if (r2 = n2.divToInt(a2), r2.isZero()) quadrant = i2 ? 3 : 2;
  else {
    if (n2 = n2.minus(r2.times(a2)), n2.lte(o2)) return quadrant = isOdd(r2) ? i2 ? 2 : 3 : i2 ? 4 : 1, n2;
    quadrant = isOdd(r2) ? i2 ? 1 : 4 : i2 ? 3 : 2;
  }
  return n2.minus(a2).abs();
}
function toStringBinary(t4, n2, r2, i2) {
  var a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = t4.constructor, g2 = r2 !== void 0;
  if (g2 ? (checkInt32(r2, 1, MAX_DIGITS), i2 === void 0 ? i2 = h2.rounding : checkInt32(i2, 0, 8)) : (r2 = h2.precision, i2 = h2.rounding), !t4.isFinite()) d2 = nonFiniteToString(t4);
  else {
    for (d2 = finiteToString(t4), s2 = d2.indexOf(`.`), g2 ? (a2 = 2, n2 == 16 ? r2 = r2 * 4 - 3 : n2 == 8 && (r2 = r2 * 3 - 2)) : a2 = n2, s2 >= 0 && (d2 = d2.replace(`.`, ``), m2 = new h2(1), m2.e = d2.length - s2, m2.d = convertBase(finiteToString(m2), 10, a2), m2.e = m2.d.length), p2 = convertBase(d2, 10, a2), o2 = l2 = p2.length; p2[--l2] == 0; ) p2.pop();
    if (!p2[0]) d2 = g2 ? `0p+0` : `0`;
    else {
      if (s2 < 0 ? o2-- : (t4 = new h2(t4), t4.d = p2, t4.e = o2, t4 = divide$1(t4, m2, r2, i2, 0, a2), p2 = t4.d, o2 = t4.e, u2 = inexact), s2 = p2[r2], c2 = a2 / 2, u2 ||= p2[r2 + 1] !== void 0, u2 = i2 < 4 ? (s2 !== void 0 || u2) && (i2 === 0 || i2 === (t4.s < 0 ? 3 : 2)) : s2 > c2 || s2 === c2 && (i2 === 4 || u2 || i2 === 6 && p2[r2 - 1] & 1 || i2 === (t4.s < 0 ? 8 : 7)), p2.length = r2, u2) for (; ++p2[--r2] > a2 - 1; ) p2[r2] = 0, r2 || (++o2, p2.unshift(1));
      for (l2 = p2.length; !p2[l2 - 1]; --l2) ;
      for (s2 = 0, d2 = ``; s2 < l2; s2++) d2 += NUMERALS.charAt(p2[s2]);
      if (g2) {
        if (l2 > 1) if (n2 == 16 || n2 == 8) {
          for (s2 = n2 == 16 ? 4 : 3, --l2; l2 % s2; l2++) d2 += `0`;
          for (p2 = convertBase(d2, a2, n2), l2 = p2.length; !p2[l2 - 1]; --l2) ;
          for (s2 = 1, d2 = `1.`; s2 < l2; s2++) d2 += NUMERALS.charAt(p2[s2]);
        } else d2 = d2.charAt(0) + `.` + d2.slice(1);
        d2 = d2 + (o2 < 0 ? `p` : `p+`) + o2;
      } else if (o2 < 0) {
        for (; ++o2; ) d2 = `0` + d2;
        d2 = `0.` + d2;
      } else if (++o2 > l2) for (o2 -= l2; o2--; ) d2 += `0`;
      else o2 < l2 && (d2 = d2.slice(0, o2) + `.` + d2.slice(o2));
    }
    d2 = (n2 == 16 ? `0x` : n2 == 2 ? `0b` : n2 == 8 ? `0o` : ``) + d2;
  }
  return t4.s < 0 ? `-` + d2 : d2;
}
function truncate(t4, n2) {
  if (t4.length > n2) return t4.length = n2, true;
}
function abs$1(t4) {
  return new this(t4).abs();
}
function acos$1(t4) {
  return new this(t4).acos();
}
function acosh$1(t4) {
  return new this(t4).acosh();
}
function add$1(t4, n2) {
  return new this(t4).plus(n2);
}
function asin$1(t4) {
  return new this(t4).asin();
}
function asinh$1(t4) {
  return new this(t4).asinh();
}
function atan$1(t4) {
  return new this(t4).atan();
}
function atanh$1(t4) {
  return new this(t4).atanh();
}
function atan2$1(t4, n2) {
  t4 = new this(t4), n2 = new this(n2);
  var r2, i2 = this.precision, a2 = this.rounding, o2 = i2 + 4;
  return !t4.s || !n2.s ? r2 = new this(NaN) : !t4.d && !n2.d ? (r2 = getPi(this, o2, 1).times(n2.s > 0 ? 0.25 : 0.75), r2.s = t4.s) : !n2.d || t4.isZero() ? (r2 = n2.s < 0 ? getPi(this, i2, a2) : new this(0), r2.s = t4.s) : !t4.d || n2.isZero() ? (r2 = getPi(this, o2, 1).times(0.5), r2.s = t4.s) : n2.s < 0 ? (this.precision = o2, this.rounding = 1, r2 = this.atan(divide$1(t4, n2, o2, 1)), n2 = getPi(this, o2, 1), this.precision = i2, this.rounding = a2, r2 = t4.s < 0 ? r2.minus(n2) : r2.plus(n2)) : r2 = this.atan(divide$1(t4, n2, o2, 1)), r2;
}
function cbrt(t4) {
  return new this(t4).cbrt();
}
function ceil(t4) {
  return finalise(t4 = new this(t4), t4.e + 1, 2);
}
function clamp$1(t4, n2, r2) {
  return new this(t4).clamp(n2, r2);
}
function config$3(t4) {
  if (!t4 || typeof t4 != `object`) throw Error(decimalError + `Object expected`);
  var n2, r2, i2, a2 = t4.defaults === true, o2 = [`precision`, 1, MAX_DIGITS, `rounding`, 0, 8, `toExpNeg`, -EXP_LIMIT, 0, `toExpPos`, 0, EXP_LIMIT, `maxE`, 0, EXP_LIMIT, `minE`, -EXP_LIMIT, 0, `modulo`, 0, 9];
  for (n2 = 0; n2 < o2.length; n2 += 3) if (r2 = o2[n2], a2 && (this[r2] = DEFAULTS[r2]), (i2 = t4[r2]) !== void 0) if (mathfloor(i2) === i2 && i2 >= o2[n2 + 1] && i2 <= o2[n2 + 2]) this[r2] = i2;
  else throw Error(invalidArgument + r2 + `: ` + i2);
  if (r2 = `crypto`, a2 && (this[r2] = DEFAULTS[r2]), (i2 = t4[r2]) !== void 0) if (i2 === true || i2 === false || i2 === 0 || i2 === 1) if (i2) if (typeof crypto < `u` && crypto && (crypto.getRandomValues || crypto.randomBytes)) this[r2] = true;
  else throw Error(cryptoUnavailable);
  else this[r2] = false;
  else throw Error(invalidArgument + r2 + `: ` + i2);
  return this;
}
function cos$1(t4) {
  return new this(t4).cos();
}
function cosh$2(t4) {
  return new this(t4).cosh();
}
function clone$2(t4) {
  var n2, r2, i2;
  function a2(t5) {
    var n3, r3, i3, o2 = this;
    if (!(o2 instanceof a2)) return new a2(t5);
    if (o2.constructor = a2, isDecimalInstance(t5)) {
      o2.s = t5.s, external ? !t5.d || t5.e > a2.maxE ? (o2.e = NaN, o2.d = null) : t5.e < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = t5.e, o2.d = t5.d.slice()) : (o2.e = t5.e, o2.d = t5.d ? t5.d.slice() : t5.d);
      return;
    }
    if (i3 = typeof t5, i3 === `number`) {
      if (t5 === 0) {
        o2.s = 1 / t5 < 0 ? -1 : 1, o2.e = 0, o2.d = [0];
        return;
      }
      if (t5 < 0 ? (t5 = -t5, o2.s = -1) : o2.s = 1, t5 === ~~t5 && t5 < 1e7) {
        for (n3 = 0, r3 = t5; r3 >= 10; r3 /= 10) n3++;
        external ? n3 > a2.maxE ? (o2.e = NaN, o2.d = null) : n3 < a2.minE ? (o2.e = 0, o2.d = [0]) : (o2.e = n3, o2.d = [t5]) : (o2.e = n3, o2.d = [t5]);
        return;
      } else if (t5 * 0 != 0) {
        t5 || (o2.s = NaN), o2.e = NaN, o2.d = null;
        return;
      }
      return parseDecimal(o2, t5.toString());
    } else if (i3 !== `string`) throw Error(invalidArgument + t5);
    return (r3 = t5.charCodeAt(0)) === 45 ? (t5 = t5.slice(1), o2.s = -1) : (r3 === 43 && (t5 = t5.slice(1)), o2.s = 1), isDecimal.test(t5) ? parseDecimal(o2, t5) : parseOther(o2, t5);
  }
  if (a2.prototype = P$3, a2.ROUND_UP = 0, a2.ROUND_DOWN = 1, a2.ROUND_CEIL = 2, a2.ROUND_FLOOR = 3, a2.ROUND_HALF_UP = 4, a2.ROUND_HALF_DOWN = 5, a2.ROUND_HALF_EVEN = 6, a2.ROUND_HALF_CEIL = 7, a2.ROUND_HALF_FLOOR = 8, a2.EUCLID = 9, a2.config = a2.set = config$3, a2.clone = clone$2, a2.isDecimal = isDecimalInstance, a2.abs = abs$1, a2.acos = acos$1, a2.acosh = acosh$1, a2.add = add$1, a2.asin = asin$1, a2.asinh = asinh$1, a2.atan = atan$1, a2.atanh = atanh$1, a2.atan2 = atan2$1, a2.cbrt = cbrt, a2.ceil = ceil, a2.clamp = clamp$1, a2.cos = cos$1, a2.cosh = cosh$2, a2.div = div, a2.exp = exp$1, a2.floor = floor$1, a2.hypot = hypot$1, a2.ln = ln$1, a2.log = log$1, a2.log10 = log10$1, a2.log2 = log2, a2.max = max$1, a2.min = min$1, a2.mod = mod$1, a2.mul = mul, a2.pow = pow$1, a2.random = random$1, a2.round = round$1, a2.sign = sign$1, a2.sin = sin$1, a2.sinh = sinh$2, a2.sqrt = sqrt$1, a2.sub = sub, a2.sum = sum, a2.tan = tan$1, a2.tanh = tanh$1, a2.trunc = trunc$1, t4 === void 0 && (t4 = {}), t4 && t4.defaults !== true) for (i2 = [`precision`, `rounding`, `toExpNeg`, `toExpPos`, `maxE`, `minE`, `modulo`, `crypto`], n2 = 0; n2 < i2.length; ) t4.hasOwnProperty(r2 = i2[n2++]) || (t4[r2] = this[r2]);
  return a2.config(t4), a2;
}
function div(t4, n2) {
  return new this(t4).div(n2);
}
function exp$1(t4) {
  return new this(t4).exp();
}
function floor$1(t4) {
  return finalise(t4 = new this(t4), t4.e + 1, 3);
}
function hypot$1() {
  var t4, n2, r2 = new this(0);
  for (external = false, t4 = 0; t4 < arguments.length; ) if (n2 = new this(arguments[t4++]), n2.d) r2.d && (r2 = r2.plus(n2.times(n2)));
  else {
    if (n2.s) return external = true, new this(1 / 0);
    r2 = n2;
  }
  return external = true, r2.sqrt();
}
function isDecimalInstance(t4) {
  return t4 instanceof Decimal || t4 && t4.toStringTag === tag || false;
}
function ln$1(t4) {
  return new this(t4).ln();
}
function log$1(t4, n2) {
  return new this(t4).log(n2);
}
function log2(t4) {
  return new this(t4).log(2);
}
function log10$1(t4) {
  return new this(t4).log(10);
}
function max$1() {
  return maxOrMin(this, arguments, `lt`);
}
function min$1() {
  return maxOrMin(this, arguments, `gt`);
}
function mod$1(t4, n2) {
  return new this(t4).mod(n2);
}
function mul(t4, n2) {
  return new this(t4).mul(n2);
}
function pow$1(t4, n2) {
  return new this(t4).pow(n2);
}
function random$1(t4) {
  var n2, r2, i2, a2, o2 = 0, s2 = new this(1), c2 = [];
  if (t4 === void 0 ? t4 = this.precision : checkInt32(t4, 1, MAX_DIGITS), i2 = Math.ceil(t4 / LOG_BASE), !this.crypto) for (; o2 < i2; ) c2[o2++] = Math.random() * 1e7 | 0;
  else if (crypto.getRandomValues) for (n2 = crypto.getRandomValues(new Uint32Array(i2)); o2 < i2; ) a2 = n2[o2], a2 >= 429e7 ? n2[o2] = crypto.getRandomValues(new Uint32Array(1))[0] : c2[o2++] = a2 % 1e7;
  else if (crypto.randomBytes) {
    for (n2 = crypto.randomBytes(i2 *= 4); o2 < i2; ) a2 = n2[o2] + (n2[o2 + 1] << 8) + (n2[o2 + 2] << 16) + ((n2[o2 + 3] & 127) << 24), a2 >= 214e7 ? crypto.randomBytes(4).copy(n2, o2) : (c2.push(a2 % 1e7), o2 += 4);
    o2 = i2 / 4;
  } else throw Error(cryptoUnavailable);
  for (i2 = c2[--o2], t4 %= LOG_BASE, i2 && t4 && (a2 = mathpow(10, LOG_BASE - t4), c2[o2] = (i2 / a2 | 0) * a2); c2[o2] === 0; o2--) c2.pop();
  if (o2 < 0) r2 = 0, c2 = [0];
  else {
    for (r2 = -1; c2[0] === 0; r2 -= LOG_BASE) c2.shift();
    for (i2 = 1, a2 = c2[0]; a2 >= 10; a2 /= 10) i2++;
    i2 < LOG_BASE && (r2 -= LOG_BASE - i2);
  }
  return s2.e = r2, s2.d = c2, s2;
}
function round$1(t4) {
  return finalise(t4 = new this(t4), t4.e + 1, this.rounding);
}
function sign$1(t4) {
  return t4 = new this(t4), t4.d ? t4.d[0] ? t4.s : 0 * t4.s : t4.s || NaN;
}
function sin$1(t4) {
  return new this(t4).sin();
}
function sinh$2(t4) {
  return new this(t4).sinh();
}
function sqrt$1(t4) {
  return new this(t4).sqrt();
}
function sub(t4, n2) {
  return new this(t4).sub(n2);
}
function sum() {
  var t4 = 0, n2 = arguments, r2 = new this(n2[t4]);
  for (external = false; r2.s && ++t4 < n2.length; ) r2 = r2.plus(n2[t4]);
  return external = true, finalise(r2, this.precision, this.rounding);
}
function tan$1(t4) {
  return new this(t4).tan();
}
function tanh$1(t4) {
  return new this(t4).tanh();
}
function trunc$1(t4) {
  return finalise(t4 = new this(t4), t4.e + 1, 1);
}
P$3[/* @__PURE__ */ Symbol.for(`nodejs.util.inspect.custom`)] = P$3.toString, P$3[Symbol.toStringTag] = `Decimal`;
var Decimal = P$3.constructor = clone$2(DEFAULTS);
LN10 = new Decimal(LN10), PI = new Decimal(PI);
var name$320 = `BigNumber`, dependencies$320 = [`?on`, `config`], createBigNumberClass = factory(name$320, dependencies$320, (t4) => {
  var { on: n2, config: r2 } = t4, i2 = Decimal.clone({ precision: r2.precision, modulo: Decimal.EUCLID });
  return i2.prototype = Object.create(i2.prototype), i2.prototype.type = `BigNumber`, i2.prototype.isBigNumber = true, i2.prototype.toJSON = function() {
    return { mathjs: `BigNumber`, value: this.toString() };
  }, i2.fromJSON = function(t5) {
    return new i2(t5.value);
  }, n2 && n2(`config`, function(t5, n3) {
    t5.precision !== n3.precision && i2.config({ precision: t5.precision });
  }), i2;
}, { isClass: true }), cosh$1 = Math.cosh || function(t4) {
  return Math.abs(t4) < 1e-9 ? 1 - t4 : (Math.exp(t4) + Math.exp(-t4)) * 0.5;
}, sinh$1 = Math.sinh || function(t4) {
  return Math.abs(t4) < 1e-9 ? t4 : (Math.exp(t4) - Math.exp(-t4)) * 0.5;
}, cosm1 = function(t4) {
  let n2 = Math.PI / 4;
  if (-n2 > t4 || t4 > n2) return Math.cos(t4) - 1;
  let r2 = t4 * t4;
  return r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 * (r2 / 20922789888e3 - 1 / 87178291200) + 1 / 479001600) - 1 / 3628800) + 1 / 40320) - 1 / 720) + 1 / 24) - 1 / 2);
}, hypot = function(t4, n2) {
  return t4 = Math.abs(t4), n2 = Math.abs(n2), t4 < n2 && ([t4, n2] = [n2, t4]), t4 < 1e8 ? Math.sqrt(t4 * t4 + n2 * n2) : (n2 /= t4, t4 * Math.sqrt(1 + n2 * n2));
}, parser_exit = function() {
  throw SyntaxError(`Invalid Param`);
};
function logHypot(t4, n2) {
  let r2 = Math.abs(t4), i2 = Math.abs(n2);
  return t4 === 0 ? Math.log(i2) : n2 === 0 ? Math.log(r2) : r2 < 3e3 && i2 < 3e3 ? Math.log(t4 * t4 + n2 * n2) * 0.5 : (t4 *= 0.5, n2 *= 0.5, 0.5 * Math.log(t4 * t4 + n2 * n2) + Math.LN2);
}
var P$2 = { re: 0, im: 0 }, parse$1 = function(t4, n2) {
  let r2 = P$2;
  if (t4 == null) r2.re = r2.im = 0;
  else if (n2 !== void 0) r2.re = t4, r2.im = n2;
  else switch (typeof t4) {
    case `object`:
      if (`im` in t4 && `re` in t4) r2.re = t4.re, r2.im = t4.im;
      else if (`abs` in t4 && `arg` in t4) {
        if (!isFinite(t4.abs) && isFinite(t4.arg)) return Complex.INFINITY;
        r2.re = t4.abs * Math.cos(t4.arg), r2.im = t4.abs * Math.sin(t4.arg);
      } else if (`r` in t4 && `phi` in t4) {
        if (!isFinite(t4.r) && isFinite(t4.phi)) return Complex.INFINITY;
        r2.re = t4.r * Math.cos(t4.phi), r2.im = t4.r * Math.sin(t4.phi);
      } else t4.length === 2 ? (r2.re = t4[0], r2.im = t4[1]) : parser_exit();
      break;
    case `string`:
      r2.im = r2.re = 0;
      let n3 = t4.replace(/_/g, ``).match(/\d+\.?\d*e[+-]?\d+|\d+\.?\d*|\.\d+|./g), i2 = 1, a2 = 0;
      n3 === null && parser_exit();
      for (let t5 = 0; t5 < n3.length; t5++) {
        let o2 = n3[t5];
        o2 === ` ` || o2 === `	` || o2 === `
` || (o2 === `+` ? i2++ : o2 === `-` ? a2++ : o2 === `i` || o2 === `I` ? (i2 + a2 === 0 && parser_exit(), n3[t5 + 1] !== ` ` && !isNaN(n3[t5 + 1]) ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + n3[t5 + 1]), t5++) : r2.im += parseFloat((a2 % 2 ? `-` : ``) + `1`), i2 = a2 = 0) : ((i2 + a2 === 0 || isNaN(o2)) && parser_exit(), n3[t5 + 1] === `i` || n3[t5 + 1] === `I` ? (r2.im += parseFloat((a2 % 2 ? `-` : ``) + o2), t5++) : r2.re += parseFloat((a2 % 2 ? `-` : ``) + o2), i2 = a2 = 0));
      }
      i2 + a2 > 0 && parser_exit();
      break;
    case `number`:
      r2.im = 0, r2.re = t4;
      break;
    default:
      parser_exit();
  }
  return isNaN(r2.re) || isNaN(r2.im), r2;
};
function Complex(t4, n2) {
  if (!(this instanceof Complex)) return new Complex(t4, n2);
  let r2 = parse$1(t4, n2);
  this.re = r2.re, this.im = r2.im;
}
Complex.prototype = { re: 0, im: 0, sign: function() {
  let t4 = hypot(this.re, this.im);
  return new Complex(this.re / t4, this.im / t4);
}, add: function(t4, n2) {
  let r2 = parse$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex.NAN : Complex.INFINITY : new Complex(this.re + r2.re, this.im + r2.im);
}, sub: function(t4, n2) {
  let r2 = parse$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im));
  return i2 || a2 ? i2 && a2 ? Complex.NAN : Complex.INFINITY : new Complex(this.re - r2.re, this.im - r2.im);
}, mul: function(t4, n2) {
  let r2 = parse$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  return i2 && s2 || a2 && o2 ? Complex.NAN : i2 || a2 ? Complex.INFINITY : r2.im === 0 && this.im === 0 ? new Complex(this.re * r2.re, 0) : new Complex(this.re * r2.re - this.im * r2.im, this.re * r2.im + this.im * r2.re);
}, div: function(t4, n2) {
  let r2 = parse$1(t4, n2), i2 = this.isInfinite(), a2 = !(isFinite(r2.re) && isFinite(r2.im)), o2 = this.re === 0 && this.im === 0, s2 = r2.re === 0 && r2.im === 0;
  if (o2 && s2 || i2 && a2) return Complex.NAN;
  if (s2 || i2) return Complex.INFINITY;
  if (o2 || a2) return Complex.ZERO;
  if (r2.im === 0) return new Complex(this.re / r2.re, this.im / r2.re);
  if (Math.abs(r2.re) < Math.abs(r2.im)) {
    let t5 = r2.re / r2.im, n3 = r2.re * t5 + r2.im;
    return new Complex((this.re * t5 + this.im) / n3, (this.im * t5 - this.re) / n3);
  } else {
    let t5 = r2.im / r2.re, n3 = r2.im * t5 + r2.re;
    return new Complex((this.re + this.im * t5) / n3, (this.im - this.re * t5) / n3);
  }
}, pow: function(t4, n2) {
  let r2 = parse$1(t4, n2), i2 = this.re === 0 && this.im === 0;
  if (r2.re === 0 && r2.im === 0) return Complex.ONE;
  if (r2.im === 0) {
    if (this.im === 0 && this.re > 0) return new Complex(this.re ** +r2.re, 0);
    if (this.re === 0) switch ((r2.re % 4 + 4) % 4) {
      case 0:
        return new Complex(this.im ** +r2.re, 0);
      case 1:
        return new Complex(0, this.im ** +r2.re);
      case 2:
        return new Complex(-(this.im ** +r2.re), 0);
      case 3:
        return new Complex(0, -(this.im ** +r2.re));
    }
  }
  if (i2 && r2.re > 0) return Complex.ZERO;
  let a2 = Math.atan2(this.im, this.re), o2 = logHypot(this.re, this.im), s2 = Math.exp(r2.re * o2 - r2.im * a2), c2 = r2.im * o2 + r2.re * a2;
  return new Complex(s2 * Math.cos(c2), s2 * Math.sin(c2));
}, sqrt: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return t4 >= 0 ? new Complex(Math.sqrt(t4), 0) : new Complex(0, Math.sqrt(-t4));
  let r2 = hypot(t4, n2), i2 = Math.sqrt(0.5 * (r2 + Math.abs(t4))), a2 = Math.abs(n2) / (2 * i2);
  return t4 >= 0 ? new Complex(i2, n2 < 0 ? -a2 : a2) : new Complex(a2, n2 < 0 ? -i2 : i2);
}, exp: function() {
  let t4 = Math.exp(this.re);
  return this.im === 0 ? new Complex(t4, 0) : new Complex(t4 * Math.cos(this.im), t4 * Math.sin(this.im));
}, expm1: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex(Math.expm1(t4) * Math.cos(n2) + cosm1(n2), Math.exp(t4) * Math.sin(n2));
}, log: function() {
  let t4 = this.re, n2 = this.im;
  return n2 === 0 && t4 > 0 ? new Complex(Math.log(t4), 0) : new Complex(logHypot(t4, n2), Math.atan2(n2, t4));
}, abs: function() {
  return hypot(this.re, this.im);
}, arg: function() {
  return Math.atan2(this.im, this.re);
}, sin: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex(Math.sin(t4) * cosh$1(n2), Math.cos(t4) * sinh$1(n2));
}, cos: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex(Math.cos(t4) * cosh$1(n2), -Math.sin(t4) * sinh$1(n2));
}, tan: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) + cosh$1(n2);
  return new Complex(Math.sin(t4) / r2, sinh$1(n2) / r2);
}, cot: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = Math.cos(t4) - cosh$1(n2);
  return new Complex(-Math.sin(t4) / r2, sinh$1(n2) / r2);
}, sec: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1(2 * n2) + 0.5 * Math.cos(2 * t4);
  return new Complex(Math.cos(t4) * cosh$1(n2) / r2, Math.sin(t4) * sinh$1(n2) / r2);
}, csc: function() {
  let t4 = this.re, n2 = this.im, r2 = 0.5 * cosh$1(2 * n2) - 0.5 * Math.cos(2 * t4);
  return new Complex(Math.sin(t4) * cosh$1(n2) / r2, -Math.cos(t4) * sinh$1(n2) / r2);
}, asin: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex(r2.re - n2, r2.im + t4).log();
  return new Complex(i2.im, -i2.re);
}, acos: function() {
  let t4 = this.re, n2 = this.im, r2 = new Complex(n2 * n2 - t4 * t4 + 1, -2 * t4 * n2).sqrt(), i2 = new Complex(r2.re - n2, r2.im + t4).log();
  return new Complex(Math.PI / 2 - i2.im, i2.re);
}, atan: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0) {
    if (n2 === 1) return new Complex(0, 1 / 0);
    if (n2 === -1) return new Complex(0, -1 / 0);
  }
  let r2 = t4 * t4 + (1 - n2) * (1 - n2), i2 = new Complex((1 - n2 * n2 - t4 * t4) / r2, -2 * t4 / r2).log();
  return new Complex(-0.5 * i2.im, 0.5 * i2.re);
}, acot: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex(Math.atan2(1, t4), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atan() : new Complex(t4 / r2, -n2 / r2).atan();
}, asec: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex(0, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acos() : new Complex(t4 / r2, -n2 / r2).acos();
}, acsc: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex(Math.PI / 2, 1 / 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asin() : new Complex(t4 / r2, -n2 / r2).asin();
}, sinh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex(sinh$1(t4) * Math.cos(n2), cosh$1(t4) * Math.sin(n2));
}, cosh: function() {
  let t4 = this.re, n2 = this.im;
  return new Complex(cosh$1(t4) * Math.cos(n2), sinh$1(t4) * Math.sin(n2));
}, tanh: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1(t4) + Math.cos(n2);
  return new Complex(sinh$1(t4) / r2, Math.sin(n2) / r2);
}, coth: function() {
  let t4 = 2 * this.re, n2 = 2 * this.im, r2 = cosh$1(t4) - Math.cos(n2);
  return new Complex(sinh$1(t4) / r2, -Math.sin(n2) / r2);
}, csch: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) - cosh$1(2 * t4);
  return new Complex(-2 * sinh$1(t4) * Math.cos(n2) / r2, 2 * cosh$1(t4) * Math.sin(n2) / r2);
}, sech: function() {
  let t4 = this.re, n2 = this.im, r2 = Math.cos(2 * n2) + cosh$1(2 * t4);
  return new Complex(2 * cosh$1(t4) * Math.cos(n2) / r2, -2 * sinh$1(t4) * Math.sin(n2) / r2);
}, asinh: function() {
  let t4 = this.im;
  this.im = -this.re, this.re = t4;
  let n2 = this.asin();
  return this.re = -this.im, this.im = t4, t4 = n2.re, n2.re = -n2.im, n2.im = t4, n2;
}, acosh: function() {
  let t4 = this.acos();
  if (t4.im <= 0) {
    let n2 = t4.re;
    t4.re = -t4.im, t4.im = n2;
  } else {
    let n2 = t4.im;
    t4.im = -t4.re, t4.re = n2;
  }
  return t4;
}, atanh: function() {
  let t4 = this.re, n2 = this.im, r2 = t4 > 1 && n2 === 0, i2 = 1 - t4, a2 = 1 + t4, o2 = i2 * i2 + n2 * n2, s2 = o2 === 0 ? new Complex(t4 === -1 ? 0 : t4 / 0, n2 === 0 ? 0 : n2 / 0) : new Complex((a2 * i2 - n2 * n2) / o2, (n2 * i2 + a2 * n2) / o2), c2 = s2.re;
  return s2.re = logHypot(s2.re, s2.im) / 2, s2.im = Math.atan2(s2.im, c2) / 2, r2 && (s2.im = -s2.im), s2;
}, acoth: function() {
  let t4 = this.re, n2 = this.im;
  if (t4 === 0 && n2 === 0) return new Complex(0, Math.PI / 2);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).atanh() : new Complex(t4 / r2, -n2 / r2).atanh();
}, acsch: function() {
  let t4 = this.re, n2 = this.im;
  if (n2 === 0) return new Complex(t4 === 0 ? 1 / 0 : Math.log(t4 + Math.sqrt(t4 * t4 + 1)), 0);
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).asinh() : new Complex(t4 / r2, -n2 / r2).asinh();
}, asech: function() {
  let t4 = this.re, n2 = this.im;
  if (this.isZero()) return Complex.INFINITY;
  let r2 = t4 * t4 + n2 * n2;
  return r2 === 0 ? new Complex(t4 === 0 ? 0 : t4 / 0, n2 === 0 ? 0 : -n2 / 0).acosh() : new Complex(t4 / r2, -n2 / r2).acosh();
}, inverse: function() {
  if (this.isZero()) return Complex.INFINITY;
  if (this.isInfinite()) return Complex.ZERO;
  let t4 = this.re, n2 = this.im, r2 = t4 * t4 + n2 * n2;
  return new Complex(t4 / r2, -n2 / r2);
}, conjugate: function() {
  return new Complex(this.re, -this.im);
}, neg: function() {
  return new Complex(-this.re, -this.im);
}, ceil: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex(Math.ceil(this.re * t4) / t4, Math.ceil(this.im * t4) / t4);
}, floor: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex(Math.floor(this.re * t4) / t4, Math.floor(this.im * t4) / t4);
}, round: function(t4) {
  return t4 = 10 ** (t4 || 0), new Complex(Math.round(this.re * t4) / t4, Math.round(this.im * t4) / t4);
}, equals: function(t4, n2) {
  let r2 = parse$1(t4, n2);
  return Math.abs(r2.re - this.re) <= Complex.EPSILON && Math.abs(r2.im - this.im) <= Complex.EPSILON;
}, clone: function() {
  return new Complex(this.re, this.im);
}, toString: function() {
  let t4 = this.re, n2 = this.im, r2 = ``;
  return this.isNaN() ? `NaN` : this.isInfinite() ? `Infinity` : (Math.abs(t4) < Complex.EPSILON && (t4 = 0), Math.abs(n2) < Complex.EPSILON && (n2 = 0), n2 === 0 ? r2 + t4 : (t4 === 0 ? n2 < 0 && (n2 = -n2, r2 += `-`) : (r2 += t4, r2 += ` `, n2 < 0 ? (n2 = -n2, r2 += `-`) : r2 += `+`, r2 += ` `), n2 !== 1 && (r2 += n2), r2 + `i`));
}, toVector: function() {
  return [this.re, this.im];
}, valueOf: function() {
  return this.im === 0 ? this.re : null;
}, isNaN: function() {
  return isNaN(this.re) || isNaN(this.im);
}, isZero: function() {
  return this.im === 0 && this.re === 0;
}, isFinite: function() {
  return isFinite(this.re) && isFinite(this.im);
}, isInfinite: function() {
  return !this.isFinite();
} }, Complex.ZERO = new Complex(0, 0), Complex.ONE = new Complex(1, 0), Complex.I = new Complex(0, 1), Complex.PI = new Complex(Math.PI, 0), Complex.E = new Complex(Math.E, 0), Complex.INFINITY = new Complex(1 / 0, 1 / 0), Complex.NAN = new Complex(NaN, NaN), Complex.EPSILON = 1e-15;
var name$319 = `Complex`, dependencies$319 = [], createComplexClass = factory(name$319, dependencies$319, () => (Object.defineProperty(Complex, "name", { value: `Complex` }), Complex.prototype.constructor = Complex, Complex.prototype.type = `Complex`, Complex.prototype.isComplex = true, Complex.prototype.toJSON = function() {
  return { mathjs: `Complex`, re: this.re, im: this.im };
}, Complex.prototype.toPolar = function() {
  return { r: this.abs(), phi: this.arg() };
}, Complex.prototype.format = function(t4) {
  var n2 = ``, r2 = this.im, i2 = this.re, a2 = format$2(this.re, t4), o2 = format$2(this.im, t4), s2 = isNumber(t4) ? t4 : t4 ? t4.precision : null;
  if (s2 !== null) {
    var c2 = 10 ** -s2;
    Math.abs(i2 / r2) < c2 && (i2 = 0), Math.abs(r2 / i2) < c2 && (r2 = 0);
  }
  return n2 = r2 === 0 ? a2 : i2 === 0 ? r2 === 1 ? `i` : r2 === -1 ? `-i` : o2 + `i` : r2 < 0 ? r2 === -1 ? a2 + ` - i` : a2 + ` - ` + o2.substring(1) + `i` : r2 === 1 ? a2 + ` + i` : a2 + ` + ` + o2 + `i`, n2;
}, Complex.fromPolar = function(t4) {
  switch (arguments.length) {
    case 1:
      var n2 = arguments[0];
      if (typeof n2 == `object`) return Complex(n2);
      throw TypeError(`Input has to be an object with r and phi keys.`);
    case 2:
      var r2 = arguments[0], i2 = arguments[1];
      if (isNumber(r2)) {
        if (isUnit(i2) && i2.hasBase(`ANGLE`) && (i2 = i2.toNumber(`rad`)), isNumber(i2)) return new Complex({ r: r2, phi: i2 });
        throw TypeError(`Phi is not a number nor an angle unit.`);
      } else throw TypeError(`Radius r is not a number.`);
    default:
      throw SyntaxError(`Wrong number of arguments in function fromPolar`);
  }
}, Complex.prototype.valueOf = Complex.prototype.toString, Complex.fromJSON = function(t4) {
  return new Complex(t4);
}, Complex.compare = function(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}, Complex), { isClass: true });
typeof BigInt > `u` && (BigInt = function(t4) {
  if (isNaN(t4)) throw Error(``);
  return t4;
});
var C_ZERO = BigInt(0), C_ONE = BigInt(1), C_TWO = BigInt(2), C_FIVE = BigInt(5), C_TEN = BigInt(10), MAX_CYCLE_LEN = 2e3, P$1 = { s: C_ONE, n: C_ZERO, d: C_ONE };
function assign(t4, n2) {
  try {
    t4 = BigInt(t4);
  } catch {
    throw InvalidParameter();
  }
  return t4 * n2;
}
function trunc(t4) {
  return typeof t4 == `bigint` ? t4 : Math.floor(t4);
}
function newFraction(t4, n2) {
  if (n2 === C_ZERO) throw DivisionByZero();
  let r2 = Object.create(Fraction.prototype);
  r2.s = t4 < C_ZERO ? -C_ONE : C_ONE, t4 = t4 < C_ZERO ? -t4 : t4;
  let i2 = gcd$1(t4, n2);
  return r2.n = t4 / i2, r2.d = n2 / i2, r2;
}
function factorize(t4) {
  let n2 = {}, r2 = t4, i2 = C_TWO, a2 = C_FIVE - C_ONE;
  for (; a2 <= r2; ) {
    for (; r2 % i2 === C_ZERO; ) r2 /= i2, n2[i2] = (n2[i2] || C_ZERO) + C_ONE;
    a2 += C_ONE + C_TWO * i2++;
  }
  return r2 === t4 ? n2[t4] = (n2[t4] || C_ZERO) + C_ONE : r2 > 1 && (n2[r2] = (n2[r2] || C_ZERO) + C_ONE), n2;
}
var parse$2 = function(t4, n2) {
  let r2 = C_ZERO, i2 = C_ONE, a2 = C_ONE;
  if (t4 != null) if (n2 !== void 0) {
    if (typeof t4 == `bigint`) r2 = t4;
    else if (isNaN(t4)) throw InvalidParameter();
    else if (t4 % 1 != 0) throw NonIntegerParameter();
    else r2 = BigInt(t4);
    if (typeof n2 == `bigint`) i2 = n2;
    else if (isNaN(n2)) throw InvalidParameter();
    else if (n2 % 1 != 0) throw NonIntegerParameter();
    else i2 = BigInt(n2);
    a2 = r2 * i2;
  } else if (typeof t4 == `object`) {
    if (`d` in t4 && `n` in t4) r2 = BigInt(t4.n), i2 = BigInt(t4.d), `s` in t4 && (r2 *= BigInt(t4.s));
    else if (0 in t4) r2 = BigInt(t4[0]), 1 in t4 && (i2 = BigInt(t4[1]));
    else if (typeof t4 == `bigint`) r2 = t4;
    else throw InvalidParameter();
    a2 = r2 * i2;
  } else if (typeof t4 == `number`) {
    if (isNaN(t4)) throw InvalidParameter();
    if (t4 < 0 && (a2 = -C_ONE, t4 = -t4), t4 % 1 == 0) r2 = BigInt(t4);
    else {
      let n3 = 1, a3 = 0, o2 = 1, s2 = 1, c2 = 1, l2 = 1e7;
      for (t4 >= 1 && (n3 = 10 ** Math.floor(1 + Math.log10(t4)), t4 /= n3); o2 <= l2 && c2 <= l2; ) {
        let n4 = (a3 + s2) / (o2 + c2);
        if (t4 === n4) {
          o2 + c2 <= l2 ? (r2 = a3 + s2, i2 = o2 + c2) : c2 > o2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
          break;
        } else t4 > n4 ? (a3 += s2, o2 += c2) : (s2 += a3, c2 += o2), o2 > l2 ? (r2 = s2, i2 = c2) : (r2 = a3, i2 = o2);
      }
      r2 = BigInt(r2) * BigInt(n3), i2 = BigInt(i2);
    }
  } else if (typeof t4 == `string`) {
    let n3 = 0, o2 = C_ZERO, s2 = C_ZERO, c2 = C_ZERO, l2 = C_ONE, u2 = C_ONE, d2 = t4.replace(/_/g, ``).match(/\d+|./g);
    if (d2 === null) throw InvalidParameter();
    if (d2[n3] === `-` ? (a2 = -C_ONE, n3++) : d2[n3] === `+` && n3++, d2.length === n3 + 1 ? s2 = assign(d2[n3++], a2) : d2[n3 + 1] === `.` || d2[n3] === `.` ? (d2[n3] !== `.` && (o2 = assign(d2[n3++], a2)), n3++, (n3 + 1 === d2.length || d2[n3 + 1] === `(` && d2[n3 + 3] === `)` || d2[n3 + 1] === `'` && d2[n3 + 3] === `'`) && (s2 = assign(d2[n3], a2), l2 = C_TEN ** BigInt(d2[n3].length), n3++), (d2[n3] === `(` && d2[n3 + 2] === `)` || d2[n3] === `'` && d2[n3 + 2] === `'`) && (c2 = assign(d2[n3 + 1], a2), u2 = C_TEN ** BigInt(d2[n3 + 1].length) - C_ONE, n3 += 3)) : d2[n3 + 1] === `/` || d2[n3 + 1] === `:` ? (s2 = assign(d2[n3], a2), l2 = assign(d2[n3 + 2], C_ONE), n3 += 3) : d2[n3 + 3] === `/` && d2[n3 + 1] === ` ` && (o2 = assign(d2[n3], a2), s2 = assign(d2[n3 + 2], a2), l2 = assign(d2[n3 + 4], C_ONE), n3 += 5), d2.length <= n3) i2 = l2 * u2, a2 = r2 = c2 + i2 * o2 + u2 * s2;
    else throw InvalidParameter();
  } else if (typeof t4 == `bigint`) r2 = t4, a2 = t4, i2 = C_ONE;
  else throw InvalidParameter();
  if (i2 === C_ZERO) throw DivisionByZero();
  P$1.s = a2 < C_ZERO ? -C_ONE : C_ONE, P$1.n = r2 < C_ZERO ? -r2 : r2, P$1.d = i2 < C_ZERO ? -i2 : i2;
};
function modpow(t4, n2, r2) {
  let i2 = C_ONE;
  for (; n2 > C_ZERO; t4 = t4 * t4 % r2, n2 >>= C_ONE) n2 & C_ONE && (i2 = i2 * t4 % r2);
  return i2;
}
function cycleLen(t4, n2) {
  for (; n2 % C_TWO === C_ZERO; n2 /= C_TWO) ;
  for (; n2 % C_FIVE === C_ZERO; n2 /= C_FIVE) ;
  if (n2 === C_ONE) return C_ZERO;
  let r2 = C_TEN % n2, i2 = 1;
  for (; r2 !== C_ONE; i2++) if (r2 = r2 * C_TEN % n2, i2 > MAX_CYCLE_LEN) return C_ZERO;
  return BigInt(i2);
}
function cycleStart(t4, n2, r2) {
  let i2 = C_ONE, a2 = modpow(C_TEN, r2, n2);
  for (let t5 = 0; t5 < 300; t5++) {
    if (i2 === a2) return BigInt(t5);
    i2 = i2 * C_TEN % n2, a2 = a2 * C_TEN % n2;
  }
  return 0;
}
function gcd$1(t4, n2) {
  if (!t4) return n2;
  if (!n2) return t4;
  for (; ; ) {
    if (t4 %= n2, !t4) return n2;
    if (n2 %= t4, !n2) return t4;
  }
}
function Fraction(t4, n2) {
  if (parse$2(t4, n2), this instanceof Fraction) t4 = gcd$1(P$1.d, P$1.n), this.s = P$1.s, this.n = P$1.n / t4, this.d = P$1.d / t4;
  else return newFraction(P$1.s * P$1.n, P$1.d);
}
var DivisionByZero = function() {
  return Error(`Division by Zero`);
}, InvalidParameter = function() {
  return Error(`Invalid argument`);
}, NonIntegerParameter = function() {
  return Error(`Parameters must be integer`);
};
Fraction.prototype = { s: C_ONE, n: C_ZERO, d: C_ONE, abs: function() {
  return newFraction(this.n, this.d);
}, neg: function() {
  return newFraction(-this.s * this.n, this.d);
}, add: function(t4, n2) {
  return parse$2(t4, n2), newFraction(this.s * this.n * P$1.d + P$1.s * this.d * P$1.n, this.d * P$1.d);
}, sub: function(t4, n2) {
  return parse$2(t4, n2), newFraction(this.s * this.n * P$1.d - P$1.s * this.d * P$1.n, this.d * P$1.d);
}, mul: function(t4, n2) {
  return parse$2(t4, n2), newFraction(this.s * P$1.s * this.n * P$1.n, this.d * P$1.d);
}, div: function(t4, n2) {
  return parse$2(t4, n2), newFraction(this.s * P$1.s * this.n * P$1.d, this.d * P$1.n);
}, clone: function() {
  return newFraction(this.s * this.n, this.d);
}, mod: function(t4, n2) {
  if (t4 === void 0) return newFraction(this.s * this.n % this.d, C_ONE);
  if (parse$2(t4, n2), C_ZERO === P$1.n * this.d) throw DivisionByZero();
  return newFraction(this.s * (P$1.d * this.n) % (P$1.n * this.d), P$1.d * this.d);
}, gcd: function(t4, n2) {
  return parse$2(t4, n2), newFraction(gcd$1(P$1.n, this.n) * gcd$1(P$1.d, this.d), P$1.d * this.d);
}, lcm: function(t4, n2) {
  return parse$2(t4, n2), P$1.n === C_ZERO && this.n === C_ZERO ? newFraction(C_ZERO, C_ONE) : newFraction(P$1.n * this.n, gcd$1(P$1.n, this.n) * gcd$1(P$1.d, this.d));
}, inverse: function() {
  return newFraction(this.s * this.d, this.n);
}, pow: function(t4, n2) {
  if (parse$2(t4, n2), P$1.d === C_ONE) return P$1.s < C_ZERO ? newFraction((this.s * this.d) ** P$1.n, this.n ** P$1.n) : newFraction((this.s * this.n) ** P$1.n, this.d ** P$1.n);
  if (this.s < C_ZERO) return null;
  let r2 = factorize(this.n), i2 = factorize(this.d), a2 = C_ONE, o2 = C_ONE;
  for (let t5 in r2) if (t5 !== `1`) {
    if (t5 === `0`) {
      a2 = C_ZERO;
      break;
    }
    if (r2[t5] *= P$1.n, r2[t5] % P$1.d === C_ZERO) r2[t5] /= P$1.d;
    else return null;
    a2 *= BigInt(t5) ** r2[t5];
  }
  for (let t5 in i2) if (t5 !== `1`) {
    if (i2[t5] *= P$1.n, i2[t5] % P$1.d === C_ZERO) i2[t5] /= P$1.d;
    else return null;
    o2 *= BigInt(t5) ** i2[t5];
  }
  return P$1.s < C_ZERO ? newFraction(o2, a2) : newFraction(a2, o2);
}, log: function(t4, n2) {
  if (parse$2(t4, n2), this.s <= C_ZERO || P$1.s <= C_ZERO) return null;
  let r2 = {}, i2 = factorize(P$1.n), a2 = factorize(P$1.d), o2 = factorize(this.n), s2 = factorize(this.d);
  for (let t5 in a2) i2[t5] = (i2[t5] || C_ZERO) - a2[t5];
  for (let t5 in s2) o2[t5] = (o2[t5] || C_ZERO) - s2[t5];
  for (let t5 in i2) t5 !== `1` && (r2[t5] = true);
  for (let t5 in o2) t5 !== `1` && (r2[t5] = true);
  let c2 = null, l2 = null;
  for (let t5 in r2) {
    let n3 = i2[t5] || C_ZERO, r3 = o2[t5] || C_ZERO;
    if (n3 === C_ZERO) {
      if (r3 !== C_ZERO) return null;
      continue;
    }
    let a3 = r3, s3 = n3, u2 = gcd$1(a3, s3);
    if (a3 /= u2, s3 /= u2, c2 === null && l2 === null) c2 = a3, l2 = s3;
    else if (a3 * l2 !== c2 * s3) return null;
  }
  return c2 !== null && l2 !== null ? newFraction(c2, l2) : null;
}, equals: function(t4, n2) {
  return parse$2(t4, n2), this.s * this.n * P$1.d === P$1.s * P$1.n * this.d;
}, lt: function(t4, n2) {
  return parse$2(t4, n2), this.s * this.n * P$1.d < P$1.s * P$1.n * this.d;
}, lte: function(t4, n2) {
  return parse$2(t4, n2), this.s * this.n * P$1.d <= P$1.s * P$1.n * this.d;
}, gt: function(t4, n2) {
  return parse$2(t4, n2), this.s * this.n * P$1.d > P$1.s * P$1.n * this.d;
}, gte: function(t4, n2) {
  return parse$2(t4, n2), this.s * this.n * P$1.d >= P$1.s * P$1.n * this.d;
}, compare: function(t4, n2) {
  parse$2(t4, n2);
  let r2 = this.s * this.n * P$1.d - P$1.s * P$1.n * this.d;
  return (C_ZERO < r2) - (r2 < C_ZERO);
}, ceil: function(t4) {
  return t4 = C_TEN ** BigInt(t4 || 0), newFraction(trunc(this.s * t4 * this.n / this.d) + (t4 * this.n % this.d > C_ZERO && this.s >= C_ZERO ? C_ONE : C_ZERO), t4);
}, floor: function(t4) {
  return t4 = C_TEN ** BigInt(t4 || 0), newFraction(trunc(this.s * t4 * this.n / this.d) - (t4 * this.n % this.d > C_ZERO && this.s < C_ZERO ? C_ONE : C_ZERO), t4);
}, round: function(t4) {
  return t4 = C_TEN ** BigInt(t4 || 0), newFraction(trunc(this.s * t4 * this.n / this.d) + this.s * ((this.s >= C_ZERO ? C_ONE : C_ZERO) + C_TWO * (t4 * this.n % this.d) > this.d ? C_ONE : C_ZERO), t4);
}, roundTo: function(t4, n2) {
  parse$2(t4, n2);
  let r2 = this.n * P$1.d, i2 = this.d * P$1.n, a2 = r2 % i2, o2 = trunc(r2 / i2);
  return a2 + a2 >= i2 && o2++, newFraction(this.s * o2 * P$1.n, P$1.d);
}, divisible: function(t4, n2) {
  return parse$2(t4, n2), !(!(P$1.n * this.d) || this.n * P$1.d % (P$1.n * this.d));
}, valueOf: function() {
  return Number(this.s * this.n) / Number(this.d);
}, toString: function(t4) {
  let n2 = this.n, r2 = this.d;
  t4 ||= 15;
  let i2 = cycleLen(n2, r2), a2 = cycleStart(n2, r2, i2), o2 = this.s < C_ZERO ? `-` : ``;
  if (o2 += trunc(n2 / r2), n2 %= r2, n2 *= C_TEN, n2 && (o2 += `.`), i2) {
    for (let t5 = a2; t5--; ) o2 += trunc(n2 / r2), n2 %= r2, n2 *= C_TEN;
    o2 += `(`;
    for (let t5 = i2; t5--; ) o2 += trunc(n2 / r2), n2 %= r2, n2 *= C_TEN;
    o2 += `)`;
  } else for (let i3 = t4; n2 && i3--; ) o2 += trunc(n2 / r2), n2 %= r2, n2 *= C_TEN;
  return o2;
}, toFraction: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO ? `-` : ``;
  if (r2 === C_ONE) i2 += n2;
  else {
    let a2 = trunc(n2 / r2);
    t4 && a2 > C_ZERO && (i2 += a2, i2 += ` `, n2 %= r2), i2 += n2, i2 += `/`, i2 += r2;
  }
  return i2;
}, toLatex: function(t4) {
  let n2 = this.n, r2 = this.d, i2 = this.s < C_ZERO ? `-` : ``;
  if (r2 === C_ONE) i2 += n2;
  else {
    let a2 = trunc(n2 / r2);
    t4 && a2 > C_ZERO && (i2 += a2, n2 %= r2), i2 += `\\frac{`, i2 += n2, i2 += `}{`, i2 += r2, i2 += `}`;
  }
  return i2;
}, toContinued: function() {
  let t4 = this.n, n2 = this.d, r2 = [];
  do {
    r2.push(trunc(t4 / n2));
    let i2 = t4 % n2;
    t4 = n2, n2 = i2;
  } while (t4 !== C_ONE);
  return r2;
}, simplify: function(t4) {
  let n2 = BigInt(1 / (t4 || 1e-3) | 0), r2 = this.abs(), i2 = r2.toContinued();
  for (let t5 = 1; t5 < i2.length; t5++) {
    let a2 = newFraction(i2[t5 - 1], C_ONE);
    for (let n3 = t5 - 2; n3 >= 0; n3--) a2 = a2.inverse().add(i2[n3]);
    let o2 = a2.sub(r2);
    if (o2.n * n2 < o2.d) return a2.mul(this.s);
  }
  return this;
} };
var name$318 = `Fraction`, dependencies$318 = [], createFractionClass = factory(name$318, dependencies$318, () => (Object.defineProperty(Fraction, "name", { value: `Fraction` }), Fraction.prototype.constructor = Fraction, Fraction.prototype.type = `Fraction`, Fraction.prototype.isFraction = true, Fraction.prototype.toJSON = function() {
  return { mathjs: `Fraction`, n: String(this.s * this.n), d: String(this.d) };
}, Fraction.fromJSON = function(t4) {
  return new Fraction(t4);
}, Fraction), { isClass: true }), name$317 = `Range`, dependencies$317 = [], createRangeClass = factory(name$317, dependencies$317, () => {
  function t4(n2, r2, i2) {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
    var a2 = n2 != null, o2 = r2 != null, s2 = i2 != null;
    if (a2) {
      if (isBigNumber(n2)) n2 = n2.toNumber();
      else if (typeof n2 != `number` && !isBigInt(n2)) throw TypeError(`Parameter start must be a number or bigint`);
    }
    if (o2) {
      if (isBigNumber(r2)) r2 = r2.toNumber();
      else if (typeof r2 != `number` && !isBigInt(r2)) throw TypeError(`Parameter end must be a number or bigint`);
    }
    if (s2) {
      if (isBigNumber(i2)) i2 = i2.toNumber();
      else if (typeof i2 != `number` && !isBigInt(i2)) throw TypeError(`Parameter step must be a number or bigint`);
    }
    if (this.start = a2 ? parseFloat(n2) : 0, this.end = o2 ? parseFloat(r2) : 0, this.step = s2 ? parseFloat(i2) : 1, s2 && nearlyEqual$1(this.step, 0)) throw Error(`Step must not be zero`);
  }
  return t4.prototype.type = `Range`, t4.prototype.isRange = true, t4.parse = function(n2) {
    if (typeof n2 != `string`) return null;
    var r2 = n2.split(`:`).map(function(t5) {
      return parseFloat(t5);
    });
    if (r2.some(function(t5) {
      return isNaN(t5);
    })) return null;
    switch (r2.length) {
      case 2:
        return new t4(r2[0], r2[1]);
      case 3:
        return new t4(r2[0], r2[2], r2[1]);
      default:
        return null;
    }
  }, t4.prototype.clone = function() {
    return new t4(this.start, this.end, this.step);
  }, t4.prototype.size = function() {
    var t5 = 0, n2 = this.start, r2 = this.step, i2 = this.end - n2;
    return sign$2(r2) === sign$2(i2) ? t5 = Math.ceil(i2 / r2) : i2 === 0 && (t5 = 0), isNaN(t5) && (t5 = 0), [t5];
  }, t4.prototype.min = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start : this.start + (t5 - 1) * this.step;
  }, t4.prototype.max = function() {
    var t5 = this.size()[0];
    if (t5 > 0) return this.step > 0 ? this.start + (t5 - 1) * this.step : this.start;
  }, t4.prototype.forEach = function(t5) {
    var n2 = this.start, r2 = this.step, i2 = this.end, a2 = 0;
    if (r2 > 0) for (; n2 < i2; ) t5(n2, [a2], this), n2 += r2, a2++;
    else if (r2 < 0) for (; n2 > i2; ) t5(n2, [a2], this), n2 += r2, a2++;
  }, t4.prototype.map = function(t5) {
    var n2 = [];
    return this.forEach(function(r2, i2, a2) {
      n2[i2[0]] = t5(r2, i2, a2);
    }), n2;
  }, t4.prototype.toArray = function() {
    var t5 = [];
    return this.forEach(function(n2, r2) {
      t5[r2[0]] = n2;
    }), t5;
  }, t4.prototype.valueOf = function() {
    return this.toArray();
  }, t4.prototype.format = function(t5) {
    var n2 = format$2(this.start, t5);
    return this.step !== 1 && (n2 += `:` + format$2(this.step, t5)), n2 += `:` + format$2(this.end, t5), n2;
  }, t4.prototype.toString = function() {
    return this.format();
  }, t4.prototype.toJSON = function() {
    return { mathjs: `Range`, start: this.start, end: this.end, step: this.step };
  }, t4.fromJSON = function(n2) {
    return new t4(n2.start, n2.end, n2.step);
  }, t4;
}, { isClass: true }), name$316 = `Matrix`, dependencies$316 = [], createMatrixClass = factory(name$316, dependencies$316, () => {
  function t4() {
    if (!(this instanceof t4)) throw SyntaxError(`Constructor must be called with the new operator`);
  }
  return t4.prototype.type = `Matrix`, t4.prototype.isMatrix = true, t4.prototype.storage = function() {
    throw Error(`Cannot invoke storage on a Matrix interface`);
  }, t4.prototype.datatype = function() {
    throw Error(`Cannot invoke datatype on a Matrix interface`);
  }, t4.prototype.create = function(t5, n2) {
    throw Error(`Cannot invoke create on a Matrix interface`);
  }, t4.prototype.subset = function(t5, n2, r2) {
    throw Error(`Cannot invoke subset on a Matrix interface`);
  }, t4.prototype.get = function(t5) {
    throw Error(`Cannot invoke get on a Matrix interface`);
  }, t4.prototype.set = function(t5, n2, r2) {
    throw Error(`Cannot invoke set on a Matrix interface`);
  }, t4.prototype.resize = function(t5, n2) {
    throw Error(`Cannot invoke resize on a Matrix interface`);
  }, t4.prototype.reshape = function(t5, n2) {
    throw Error(`Cannot invoke reshape on a Matrix interface`);
  }, t4.prototype.clone = function() {
    throw Error(`Cannot invoke clone on a Matrix interface`);
  }, t4.prototype.size = function() {
    throw Error(`Cannot invoke size on a Matrix interface`);
  }, t4.prototype.map = function(t5, n2) {
    throw Error(`Cannot invoke map on a Matrix interface`);
  }, t4.prototype.forEach = function(t5) {
    throw Error(`Cannot invoke forEach on a Matrix interface`);
  }, t4.prototype[Symbol.iterator] = function() {
    throw Error(`Cannot iterate a Matrix interface`);
  }, t4.prototype.toArray = function() {
    throw Error(`Cannot invoke toArray on a Matrix interface`);
  }, t4.prototype.valueOf = function() {
    throw Error(`Cannot invoke valueOf on a Matrix interface`);
  }, t4.prototype.format = function(t5) {
    throw Error(`Cannot invoke format on a Matrix interface`);
  }, t4.prototype.toString = function() {
    throw Error(`Cannot invoke toString on a Matrix interface`);
  }, t4;
}, { isClass: true });
function formatBigNumberToBase(t4, n2, r2) {
  var i2 = t4.constructor, a2 = new i2(2), o2 = ``;
  if (r2) {
    if (r2 < 1) throw Error(`size must be in greater than 0`);
    if (!isInteger(r2)) throw Error(`size must be an integer`);
    if (t4.greaterThan(a2.pow(r2 - 1).sub(1)) || t4.lessThan(a2.pow(r2 - 1).mul(-1))) throw Error(`Value must be in range [-2^${r2 - 1}, 2^${r2 - 1}-1]`);
    if (!t4.isInteger()) throw Error(`Value must be an integer`);
    t4.lessThan(0) && (t4 = t4.add(a2.pow(r2))), o2 = `i${r2}`;
  }
  switch (n2) {
    case 2:
      return `${t4.toBinary()}${o2}`;
    case 8:
      return `${t4.toOctal()}${o2}`;
    case 16:
      return `${t4.toHexadecimal()}${o2}`;
    default:
      throw Error(`Base ${n2} not supported `);
  }
}
function format$1(t4, n2) {
  if (typeof n2 == `function`) return n2(t4);
  if (!t4.isFinite()) return t4.isNaN() ? `NaN` : t4.gt(0) ? `Infinity` : `-Infinity`;
  var { notation: r2, precision: i2, wordSize: a2 } = normalizeFormatOptions(n2);
  switch (r2) {
    case `fixed`:
      return toFixed$1(t4, i2);
    case `exponential`:
      return toExponential(t4, i2);
    case `engineering`:
      return toEngineering(t4, i2);
    case `bin`:
      return formatBigNumberToBase(t4, 2, a2);
    case `oct`:
      return formatBigNumberToBase(t4, 8, a2);
    case `hex`:
      return formatBigNumberToBase(t4, 16, a2);
    case `auto`:
      var o2 = _toNumberOrDefault(n2?.lowerExp, -3), s2 = _toNumberOrDefault(n2?.upperExp, 5);
      if (t4.isZero()) return `0`;
      var c2, l2 = t4.toSignificantDigits(i2), u2 = l2.e;
      return c2 = u2 >= o2 && u2 < s2 ? l2.toFixed() : toExponential(t4, i2), c2.replace(/((\.\d*?)(0+))($|e)/, function() {
        var t5 = arguments[2], n3 = arguments[4];
        return t5 === `.` ? n3 : t5 + n3;
      });
    default:
      throw Error(`Unknown notation "` + r2 + `". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.`);
  }
}
function toEngineering(t4, n2) {
  var r2 = t4.e, i2 = r2 % 3 == 0 ? r2 : r2 < 0 ? r2 - 3 - r2 % 3 : r2 - r2 % 3, a2 = t4.mul(10 ** -i2).toPrecision(n2);
  if (a2.includes(`e`)) {
    var o2 = t4.constructor;
    a2 = new o2(a2).toFixed();
  }
  return a2 + `e` + (r2 >= 0 ? `+` : ``) + i2.toString();
}
function toExponential(t4, n2) {
  return n2 === void 0 ? t4.toExponential() : t4.toExponential(n2 - 1);
}
function toFixed$1(t4, n2) {
  return t4.toFixed(n2);
}
function _toNumberOrDefault(t4, n2) {
  return isNumber(t4) ? t4 : isBigNumber(t4) ? t4.toNumber() : n2;
}
function endsWith(t4, n2) {
  var r2 = t4.length - n2.length, i2 = t4.length;
  return t4.substring(r2, i2) === n2;
}
function format(t4, n2) {
  var r2 = _format(t4, n2);
  return n2 && typeof n2 == `object` && `truncate` in n2 && r2.length > n2.truncate ? r2.substring(0, n2.truncate - 3) + `...` : r2;
}
function _format(t4, n2) {
  return typeof t4 == `number` ? format$2(t4, n2) : isBigNumber(t4) ? format$1(t4, n2) : looksLikeFraction(t4) ? !n2 || n2.fraction !== `decimal` ? `${t4.s * t4.n}/${t4.d}` : t4.toString() : Array.isArray(t4) ? formatArray(t4, n2) : isString(t4) ? stringify(t4) : typeof t4 == `function` ? t4.syntax ? String(t4.syntax) : `function` : t4 && typeof t4 == `object` ? typeof t4.format == `function` ? t4.format(n2) : t4 && t4.toString(n2) !== {}.toString() ? t4.toString(n2) : `{` + Object.keys(t4).map((r2) => stringify(r2) + `: ` + format(t4[r2], n2)).join(`, `) + `}` : String(t4);
}
function stringify(t4) {
  for (var n2 = String(t4), r2 = ``, i2 = 0; i2 < n2.length; ) {
    var a2 = n2.charAt(i2);
    r2 += a2 in controlCharacters ? controlCharacters[a2] : a2, i2++;
  }
  return `"` + r2 + `"`;
}
var controlCharacters = { '"': `\\"`, "\\": `\\\\`, "\b": `\\b`, "\f": `\\f`, "\n": `\\n`, "\r": `\\r`, "	": `\\t` };
function escape(t4) {
  var n2 = String(t4);
  return n2 = n2.replace(/&/g, `&amp;`).replace(/"/g, `&quot;`).replace(/'/g, `&#39;`).replace(/</g, `&lt;`).replace(/>/g, `&gt;`), n2;
}
function formatArray(t4, n2) {
  if (Array.isArray(t4)) {
    for (var r2 = `[`, i2 = t4.length, a2 = 0; a2 < i2; a2++) a2 !== 0 && (r2 += `, `), r2 += formatArray(t4[a2], n2);
    return r2 += `]`, r2;
  } else return format(t4, n2);
}
function looksLikeFraction(t4) {
  return t4 && typeof t4 == `object` && typeof t4.s == `bigint` && typeof t4.n == `bigint` && typeof t4.d == `bigint` || false;
}
function compareText(t4, n2) {
  if (!isString(t4)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf(t4) + `, index: 0)`);
  if (!isString(n2)) throw TypeError(`Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: ` + typeOf(n2) + `, index: 1)`);
  return t4 === n2 ? 0 : t4 > n2 ? 1 : -1;
}
function DimensionError(t4, n2, r2) {
  if (!(this instanceof DimensionError)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.actual = t4, this.expected = n2, this.relation = r2, this.message = `Dimension mismatch (` + (Array.isArray(t4) ? `[` + t4.join(`, `) + `]` : t4) + ` ` + (this.relation || `!=`) + ` ` + (Array.isArray(n2) ? `[` + n2.join(`, `) + `]` : n2) + `)`, this.stack = Error().stack;
}
DimensionError.prototype = RangeError(), DimensionError.prototype.constructor = RangeError, DimensionError.prototype.name = `DimensionError`, DimensionError.prototype.isDimensionError = true;
function IndexError(t4, n2, r2) {
  if (!(this instanceof IndexError)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.index = t4, arguments.length < 3 ? (this.min = 0, this.max = n2) : (this.min = n2, this.max = r2), this.min !== void 0 && this.index < this.min ? this.message = `Index out of range (` + this.index + ` < ` + this.min + `)` : this.max !== void 0 && this.index >= this.max ? this.message = `Index out of range (` + this.index + ` > ` + (this.max - 1) + `)` : this.message = `Index out of range (` + this.index + `)`, this.stack = Error().stack;
}
IndexError.prototype = RangeError(), IndexError.prototype.constructor = RangeError, IndexError.prototype.name = `IndexError`, IndexError.prototype.isIndexError = true;
function arraySize(t4) {
  for (var n2 = []; Array.isArray(t4); ) n2.push(t4.length), t4 = t4[0];
  return n2;
}
function _validate(t4, n2, r2) {
  var i2, a2 = t4.length;
  if (a2 !== n2[r2]) throw new DimensionError(a2, n2[r2]);
  if (r2 < n2.length - 1) {
    var o2 = r2 + 1;
    for (i2 = 0; i2 < a2; i2++) {
      var s2 = t4[i2];
      if (!Array.isArray(s2)) throw new DimensionError(n2.length - 1, n2.length, `<`);
      _validate(t4[i2], n2, o2);
    }
  } else for (i2 = 0; i2 < a2; i2++) if (Array.isArray(t4[i2])) throw new DimensionError(n2.length + 1, n2.length, `>`);
}
function validate(t4, n2) {
  if (n2.length === 0) {
    if (Array.isArray(t4)) throw new DimensionError(t4.length, 0);
  } else _validate(t4, n2, 0);
}
function validateIndexSourceSize(t4, n2) {
  var r2 = t4.isMatrix ? t4._size : arraySize(t4);
  n2._sourceSize.forEach((t5, n3) => {
    if (t5 !== null && t5 !== r2[n3]) throw new DimensionError(t5, r2[n3]);
  });
}
function validateIndex(t4, n2) {
  if (t4 !== void 0) {
    if (!isNumber(t4) || !isInteger(t4)) throw TypeError(`Index must be an integer (value: ` + t4 + `)`);
    if (t4 < 0 || typeof n2 == `number` && t4 >= n2) throw new IndexError(t4, n2);
  }
}
function isEmptyIndex(t4) {
  for (var n2 = 0; n2 < t4._dimensions.length; ++n2) {
    var r2 = t4._dimensions[n2];
    if (r2._data && isArray(r2._data)) {
      if (r2._size[0] === 0) return true;
    } else if (r2.isRange) {
      if (r2.start === r2.end) return true;
    } else if (isString(r2) && r2.length === 0) return true;
  }
  return false;
}
function resize(t4, n2, r2) {
  if (!Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw Error(`Resizing to scalar is not supported`);
  return n2.forEach(function(t5) {
    if (!isNumber(t5) || !isInteger(t5) || t5 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format(n2) + `)`);
  }), (isNumber(t4) || isBigNumber(t4)) && (t4 = [t4]), _resize(t4, n2, 0, r2 === void 0 ? 0 : r2), t4;
}
function _resize(t4, n2, r2, i2) {
  var a2, o2, s2 = t4.length, c2 = n2[r2], l2 = Math.min(s2, c2);
  if (t4.length = c2, r2 < n2.length - 1) {
    var u2 = r2 + 1;
    for (a2 = 0; a2 < l2; a2++) o2 = t4[a2], Array.isArray(o2) || (o2 = [o2], t4[a2] = o2), _resize(o2, n2, u2, i2);
    for (a2 = l2; a2 < c2; a2++) o2 = [], t4[a2] = o2, _resize(o2, n2, u2, i2);
  } else {
    for (a2 = 0; a2 < l2; a2++) for (; Array.isArray(t4[a2]); ) t4[a2] = t4[a2][0];
    for (a2 = l2; a2 < c2; a2++) t4[a2] = i2;
  }
}
function reshape(t4, n2) {
  var r2 = flatten$4(t4, true), i2 = r2.length;
  if (!Array.isArray(t4) || !Array.isArray(n2)) throw TypeError(`Array expected`);
  if (n2.length === 0) throw new DimensionError(0, i2, `!=`);
  n2 = processSizesWildcard(n2, i2);
  var a2 = product$1(n2);
  if (i2 !== a2) throw new DimensionError(a2, i2, `!=`);
  try {
    return _reshape(r2, n2);
  } catch (t5) {
    throw t5 instanceof DimensionError ? new DimensionError(a2, i2, `!=`) : t5;
  }
}
function processSizesWildcard(t4, n2) {
  var r2 = product$1(t4), i2 = t4.slice(), a2 = -1, o2 = t4.indexOf(a2);
  if (t4.indexOf(a2, o2 + 1) >= 0) throw Error(`More than one wildcard in sizes`);
  var s2 = o2 >= 0, c2 = n2 % r2 === 0;
  if (s2) if (c2) i2[o2] = -n2 / r2;
  else throw Error(`Could not replace wildcard, since ` + n2 + ` is no multiple of ` + -r2);
  return i2;
}
function product$1(t4) {
  return t4.reduce((t5, n2) => t5 * n2, 1);
}
function _reshape(t4, n2) {
  for (var r2 = t4, i2, a2 = n2.length - 1; a2 > 0; a2--) {
    var o2 = n2[a2];
    i2 = [];
    for (var s2 = r2.length / o2, c2 = 0; c2 < s2; c2++) i2.push(r2.slice(c2 * o2, (c2 + 1) * o2));
    r2 = i2;
  }
  return r2;
}
function squeeze(t4, n2) {
  for (var r2 = arraySize(t4); Array.isArray(t4) && t4.length === 1; ) t4 = t4[0], r2.shift();
  for (var i2 = r2.length; r2[i2 - 1] === 1; ) i2--;
  return i2 < r2.length && (t4 = _squeeze(t4, i2, 0), r2.length = i2), t4;
}
function _squeeze(t4, n2, r2) {
  var i2, a2;
  if (r2 < n2) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _squeeze(t4[i2], n2, o2);
  } else for (; Array.isArray(t4); ) t4 = t4[0];
  return t4;
}
function unsqueeze(t4, n2, r2, i2) {
  var a2 = i2 || arraySize(t4);
  if (r2) for (var o2 = 0; o2 < r2; o2++) t4 = [t4], a2.unshift(1);
  for (t4 = _unsqueeze(t4, n2, 0); a2.length < n2; ) a2.push(1);
  return t4;
}
function _unsqueeze(t4, n2, r2) {
  var i2, a2;
  if (Array.isArray(t4)) {
    var o2 = r2 + 1;
    for (i2 = 0, a2 = t4.length; i2 < a2; i2++) t4[i2] = _unsqueeze(t4[i2], n2, o2);
  } else for (var s2 = r2; s2 < n2; s2++) t4 = [t4];
  return t4;
}
function flatten$4(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : false;
  if (!Array.isArray(t4)) return t4;
  if (typeof n2 != `boolean`) throw TypeError(`Boolean expected for second argument of flatten`);
  var r2 = [];
  return n2 ? a2(t4) : i2(t4), r2;
  function i2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      var a3 = t5[n3];
      Array.isArray(a3) ? i2(a3) : r2.push(a3);
    }
  }
  function a2(t5) {
    if (Array.isArray(t5[0])) for (var n3 = 0; n3 < t5.length; n3++) a2(t5[n3]);
    else for (var i3 = 0; i3 < t5.length; i3++) r2.push(t5[i3]);
  }
}
function map$1(t4, n2) {
  return Array.prototype.map.call(t4, n2);
}
function forEach(t4, n2) {
  Array.prototype.forEach.call(t4, n2);
}
function filter$1(t4, n2) {
  if (arraySize(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, n2);
}
function filterRegExp(t4, n2) {
  if (arraySize(t4).length !== 1) throw Error(`Only one dimensional matrices supported`);
  return Array.prototype.filter.call(t4, (t5) => n2.test(t5));
}
function join$2(t4, n2) {
  return Array.prototype.join.call(t4, n2);
}
function identify(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  var n2 = [], r2 = 0;
  n2[0] = { value: t4[0], identifier: 0 };
  for (var i2 = 1; i2 < t4.length; i2++) t4[i2] === t4[i2 - 1] ? r2++ : r2 = 0, n2.push({ value: t4[i2], identifier: r2 });
  return n2;
}
function generalize(t4) {
  if (!Array.isArray(t4)) throw TypeError(`Array input expected`);
  if (t4.length === 0) return t4;
  for (var n2 = [], r2 = 0; r2 < t4.length; r2++) n2.push(t4[r2].value);
  return n2;
}
function getArrayDataType(t4, n2) {
  for (var r2, i2 = 0, a2 = 0; a2 < t4.length; a2++) {
    var o2 = t4[a2], s2 = Array.isArray(o2);
    if (a2 === 0 && s2 && (i2 = o2.length), s2 && o2.length !== i2) return;
    var c2 = s2 ? getArrayDataType(o2, n2) : n2(o2);
    if (r2 === void 0) r2 = c2;
    else if (r2 !== c2) return `mixed`;
  }
  return r2;
}
function concatRecursive(t4, n2, r2, i2) {
  if (i2 < r2) {
    if (t4.length !== n2.length) throw new DimensionError(t4.length, n2.length);
    for (var a2 = [], o2 = 0; o2 < t4.length; o2++) a2[o2] = concatRecursive(t4[o2], n2[o2], r2, i2 + 1);
    return a2;
  } else return t4.concat(n2);
}
function concat() {
  var t4 = Array.prototype.slice.call(arguments, 0, -1), n2 = Array.prototype.slice.call(arguments, -1);
  if (t4.length === 1) return t4[0];
  if (t4.length > 1) return t4.slice(1).reduce(function(t5, r2) {
    return concatRecursive(t5, r2, n2, 0);
  }, t4[0]);
  throw Error(`Wrong number of arguments in function concat`);
}
function broadcastSizes() {
  for (var t4 = [...arguments], n2 = t4.map((t5) => t5.length), r2 = Math.max(...n2), i2 = Array(r2).fill(null), a2 = 0; a2 < t4.length; a2++) for (var o2 = t4[a2], s2 = n2[a2], c2 = 0; c2 < s2; c2++) {
    var l2 = r2 - s2 + c2;
    o2[c2] > i2[l2] && (i2[l2] = o2[c2]);
  }
  for (var u2 = 0; u2 < t4.length; u2++) checkBroadcastingRules(t4[u2], i2);
  return i2;
}
function checkBroadcastingRules(t4, n2) {
  for (var r2 = n2.length, i2 = t4.length, a2 = 0; a2 < i2; a2++) {
    var o2 = r2 - i2 + a2;
    if (t4[a2] < n2[o2] && t4[a2] > 1 || t4[a2] > n2[o2]) throw Error(`shape mismatch: mismatch is found in arg with shape (${t4}) not possible to broadcast dimension ${i2} with size ${t4[a2]} to size ${n2[o2]}`);
  }
}
function broadcastTo(t4, n2) {
  var r2 = arraySize(t4);
  if (deepStrictEqual(r2, n2)) return t4;
  checkBroadcastingRules(r2, n2);
  var i2 = broadcastSizes(r2, n2), a2 = i2.length, o2 = [...Array(a2 - r2.length).fill(1), ...r2], s2 = clone$1(t4);
  r2.length < a2 && (s2 = reshape(s2, o2), r2 = arraySize(s2));
  for (var c2 = 0; c2 < a2; c2++) r2[c2] < i2[c2] && (s2 = stretch(s2, i2[c2], c2), r2 = arraySize(s2));
  return s2;
}
function stretch(t4, n2, r2) {
  return concat(...Array(n2).fill(t4), r2);
}
function get$1(t4, n2) {
  if (!Array.isArray(t4)) throw Error(`Array expected`);
  if (!Array.isArray(n2)) throw Error(`Array expected for index`);
  var r2 = arraySize(t4);
  if (n2.length !== r2.length) throw new DimensionError(n2.length, r2.length);
  for (var i2 = 0; i2 < n2.length; i2++) validateIndex(n2[i2], r2[i2]);
  return n2.reduce((t5, n3) => t5[n3], t4);
}
function deepMap$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return [];
  if (r2) return o2(t4);
  var i2 = [];
  return a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) {
      for (var s2 = r3.length, c2 = Array(s2), l2 = 0; l2 < s2; l2++) i2[o3] = l2, c2[l2] = a2(r3[l2], o3 + 1);
      return c2;
    } else return n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) {
      for (var r3 = t5.length, i3 = Array(r3), a3 = 0; a3 < r3; a3++) i3[a3] = o2(t5[a3]);
      return i3;
    } else return n2(t5);
  }
}
function deepForEach$1(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
  if (t4.length === 0) return;
  if (r2) {
    o2(t4);
    return;
  }
  var i2 = [];
  a2(t4, 0);
  function a2(r3, o3) {
    if (Array.isArray(r3)) for (var s2 = r3.length, c2 = 0; c2 < s2; c2++) i2[o3] = c2, a2(r3[c2], o3 + 1);
    else n2(r3, i2.slice(0, o3), t4);
  }
  function o2(t5) {
    if (Array.isArray(t5)) for (var r3 = t5.length, i3 = 0; i3 < r3; i3++) o2(t5[i3]);
    else n2(t5);
  }
}
function clone$1(t4) {
  return _extends([], t4);
}
function optimizeCallback(t4, n2, r2, i2) {
  if (import_typed_function.default.isTypedFunction(t4)) {
    var a2;
    if (i2) a2 = 1;
    else {
      var o2 = n2.isMatrix ? n2.size() : arraySize(n2);
      if (!o2.length || o2[o2.length - 1] === 0) return { isUnary: i2, fn: t4 };
      var s2 = o2.map(() => 0);
      a2 = _findNumberOfArgumentsTyped(t4, n2.isMatrix ? n2.get(s2) : get$1(n2, s2), s2, n2);
    }
    var c2;
    if (n2.isMatrix && n2.dataType !== `mixed` && n2.dataType !== void 0) {
      var l2 = _findSingleSignatureWithArity(t4, a2);
      c2 = l2 === void 0 ? t4 : l2;
    } else c2 = t4;
    return a2 >= 1 && a2 <= 3 ? { isUnary: a2 === 1, fn: function() {
      return _tryFunctionWithArgs(c2, [...arguments].slice(0, a2), r2, t4.name);
    } } : { isUnary: false, fn: function() {
      return _tryFunctionWithArgs(c2, [...arguments], r2, t4.name);
    } };
  }
  return i2 === void 0 ? { isUnary: _findIfCallbackIsUnary(t4), fn: t4 } : { isUnary: i2, fn: t4 };
}
function _findSingleSignatureWithArity(t4, n2) {
  var r2 = [];
  if (Object.entries(t4.signatures).forEach((t5) => {
    var [i2, a2] = t5;
    i2.split(`,`).length === n2 && r2.push(a2);
  }), r2.length === 1) return r2[0];
}
function _findIfCallbackIsUnary(t4) {
  if (t4.length !== 1) return false;
  var n2 = t4.toString();
  if (/arguments/.test(n2)) return false;
  var r2 = n2.match(/\(.*?\)/);
  return !/\.\.\./.test(r2);
}
function _findNumberOfArgumentsTyped(t4, n2, r2, i2) {
  for (var a2 = [n2, r2, i2], o2 = 3; o2 > 0; o2--) {
    var s2 = a2.slice(0, o2);
    if (import_typed_function.default.resolve(t4, s2) !== null) return o2;
  }
}
function _tryFunctionWithArgs(t4, n2, r2, i2) {
  try {
    return t4(...n2);
  } catch (t5) {
    _createCallbackError(t5, n2, r2, i2);
  }
}
function _createCallbackError(t4, n2, r2, i2) {
  if (t4 instanceof TypeError && t4.data?.category === `wrongType`) {
    var o2 = [];
    throw o2.push(`value: ${typeOf(n2[0])}`), n2.length >= 2 && o2.push(`index: ${typeOf(n2[1])}`), n2.length >= 3 && o2.push(`array: ${typeOf(n2[2])}`), TypeError(`Function ${r2} cannot apply callback arguments ${i2}(${o2.join(`, `)}) at index ${JSON.stringify(n2[1])}`);
  } else throw TypeError(`Function ${r2} cannot apply callback arguments to function ${i2}: ${t4.message}`);
}
var name$315 = `DenseMatrix`, dependencies$315 = [`Matrix`, `config`], createDenseMatrixClass = factory(name$315, dependencies$315, (t4) => {
  var { Matrix: n2, config: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix(t5)) t5.type === `DenseMatrix` ? (this._data = clone$3(t5._data), this._size = clone$3(t5._size), this._datatype = n3 || t5._datatype) : (this._data = t5.toArray(), this._size = t5.size(), this._datatype = n3 || t5._datatype);
    else if (t5 && isArray(t5.data) && isArray(t5.size)) this._data = t5.data, this._size = t5.size, validate(this._data, this._size), this._datatype = n3 || t5.datatype;
    else if (isArray(t5)) this._data = d2(t5), this._size = arraySize(this._data), validate(this._data, this._size), this._datatype = n3;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3;
  }
  i2.prototype = new n2(), i2.prototype.createDenseMatrix = function(t5, n3) {
    return new i2(t5, n3);
  }, Object.defineProperty(i2, "name", { value: `DenseMatrix` }), i2.prototype.constructor = i2, i2.prototype.type = `DenseMatrix`, i2.prototype.isDenseMatrix = true, i2.prototype.getDataType = function() {
    return getArrayDataType(this._data, typeOf);
  }, i2.prototype.storage = function() {
    return `dense`;
  }, i2.prototype.datatype = function() {
    return this._datatype;
  }, i2.prototype.create = function(t5, n3) {
    return new i2(t5, n3);
  }, i2.prototype.subset = function(t5, n3, r3) {
    switch (arguments.length) {
      case 1:
        return a2(this, t5);
      case 2:
      case 3:
        return s2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.get = function(t5) {
    return get$1(this._data, t5);
  }, i2.prototype.set = function(t5, n3, r3) {
    if (!isArray(t5)) throw TypeError(`Array expected`);
    if (t5.length < this._size.length) throw new DimensionError(t5.length, this._size.length, `<`);
    var i3, a3, o3, s3 = t5.map(function(t6) {
      return t6 + 1;
    });
    u2(this, s3, r3);
    var c3 = this._data;
    for (i3 = 0, a3 = t5.length - 1; i3 < a3; i3++) o3 = t5[i3], validateIndex(o3, c3.length), c3 = c3[o3];
    return o3 = t5[t5.length - 1], validateIndex(o3, c3.length), c3[o3] = n3, this;
  };
  function a2(t5, n3) {
    if (!isIndex(n3)) throw TypeError(`Invalid index`);
    if (r2.legacySubset ? n3.size().every((t6) => t6 === 1) : n3.isScalar()) return t5.get(n3.min());
    var a3 = n3.size();
    if (a3.length !== t5._size.length) throw new DimensionError(a3.length, t5._size.length);
    for (var s3 = n3.min(), c3 = n3.max(), l3 = 0, u3 = t5._size.length; l3 < u3; l3++) validateIndex(s3[l3], t5._size[l3]), validateIndex(c3[l3], t5._size[l3]);
    var d3 = new i2(), p2 = o2(t5._data, n3);
    return d3._size = p2.size, d3._datatype = t5._datatype, d3._data = p2.data, r2.legacySubset ? d3.reshape(n3.size()) : d3;
  }
  function o2(t5, n3) {
    var r3 = n3.size().length - 1, i3 = Array(r3);
    return { data: a3(t5), size: i3.filter((t6) => t6 !== null) };
    function a3(t6) {
      var o3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, s3 = n3.dimension(o3);
      function c3(t7, n4) {
        return isNumber(t7) ? n4(t7) : t7.map(n4).valueOf();
      }
      return isNumber(s3) ? i3[o3] = null : i3[o3] = s3.size()[0], o3 < r3 ? c3(s3, (n4) => (validateIndex(n4, t6.length), a3(t6[n4], o3 + 1))) : c3(s3, (n4) => (validateIndex(n4, t6.length), t6[n4]));
    }
  }
  function s2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix(r3) ? (s3 = r3.size(), r3 = r3.valueOf()) : s3 = arraySize(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (!deepStrictEqual(s3, a3)) {
        if (s3.length === 0) r3 = broadcastTo([r3], a3);
        else try {
          r3 = broadcastTo(r3, a3);
        } catch {
        }
        s3 = arraySize(r3);
      }
      if (a3.length < t5._size.length) throw new DimensionError(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var l3 = 0, d3 = 0; a3[l3] === 1 && s3[l3] === 1; ) l3++;
        for (; a3[l3] === 1; ) d3++, l3++;
        r3 = unsqueeze(r3, a3.length, d3, s3);
      }
      if (!deepStrictEqual(a3, s3)) throw new DimensionError(a3, s3, `>`);
      u2(t5, n3.max().map(function(t6) {
        return t6 + 1;
      }), i3), c2(t5._data, n3, r3);
    }
    return t5;
  }
  function c2(t5, n3, r3) {
    var i3 = n3.size().length - 1;
    a3(t5, r3);
    function a3(t6, r4) {
      var o3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 0, s3 = n3.dimension(o3), c3 = (n4, i4) => {
        validateIndex(n4, t6.length), a3(t6[n4], r4[i4[0]], o3 + 1);
      }, l3 = (n4, i4) => {
        validateIndex(n4, t6.length), t6[n4] = r4[i4[0]];
      };
      o3 < i3 ? isNumber(s3) ? c3(s3, [0]) : s3.forEach(c3) : isNumber(s3) ? l3(s3, [0]) : s3.forEach(l3);
    }
  }
  i2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    return l2(r3 ? this.clone() : this, i3, n3);
  };
  function l2(t5, n3, r3) {
    if (n3.length === 0) {
      for (var i3 = t5._data; isArray(i3); ) i3 = i3[0];
      return i3;
    }
    return t5._size = n3.slice(0), t5._data = resize(t5._data, t5._size, r3), t5;
  }
  i2.prototype.reshape = function(t5, n3) {
    var r3 = n3 ? this.clone() : this;
    return r3._data = reshape(r3._data, t5), r3._size = processSizesWildcard(t5, r3._size.reduce((t6, n4) => t6 * n4)), r3;
  };
  function u2(t5, n3, r3) {
    for (var i3 = t5._size.slice(0), a3 = false; i3.length < n3.length; ) i3.push(0), a3 = true;
    for (var o3 = 0, s3 = n3.length; o3 < s3; o3++) n3[o3] > i3[o3] && (i3[o3] = n3[o3], a3 = true);
    a3 && l2(t5, i3, r3);
  }
  i2.prototype.clone = function() {
    return new i2({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, i2.prototype.size = function() {
    return this._size.slice(0);
  }, i2.prototype.map = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return r3.clone();
    var a3 = optimizeCallback(t5, r3, `map`, n3), o3 = a3.fn, s3 = r3.create(void 0, r3._datatype);
    if (s3._size = r3._size, n3 || a3.isUnary) return s3._data = m2(r3._data), s3;
    if (i3 === 0) {
      for (var c3 = r3.valueOf(), l3 = Array(c3.length), u3 = 0; u3 < c3.length; u3++) l3[u3] = o3(c3[u3], [u3], r3);
      return s3._data = l3, s3;
    }
    var d3 = [];
    return s3._data = p2(r3._data), s3;
    function p2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, a4 = Array(t6.length);
      if (n4 < i3) for (var s4 = 0; s4 < t6.length; s4++) d3[n4] = s4, a4[s4] = p2(t6[s4], n4 + 1);
      else for (var c4 = 0; c4 < t6.length; c4++) d3[n4] = c4, a4[c4] = o3(t6[c4], d3.slice(), r3);
      return a4;
    }
    function m2(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, r4 = Array(t6.length);
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) r4[a4] = m2(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) r4[s4] = o3(t6[s4]);
      return r4;
    }
  }, i2.prototype.forEach = function(t5) {
    var n3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, r3 = this, i3 = r3._size.length - 1;
    if (i3 < 0) return;
    var a3 = optimizeCallback(t5, r3, `map`, n3), o3 = a3.fn;
    if (n3 || a3.isUnary) {
      u3(r3._data);
      return;
    }
    if (i3 === 0) {
      for (var s3 = 0; s3 < r3._data.length; s3++) o3(r3._data[s3], [s3], r3);
      return;
    }
    var c3 = [];
    l3(r3._data);
    function l3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var a4 = 0; a4 < t6.length; a4++) c3[n4] = a4, l3(t6[a4], n4 + 1);
      else for (var s4 = 0; s4 < t6.length; s4++) c3[n4] = s4, o3(t6[s4], c3.slice(), r3);
    }
    function u3(t6) {
      var n4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
      if (n4 < i3) for (var r4 = 0; r4 < t6.length; r4++) u3(t6[r4], n4 + 1);
      else for (var a4 = 0; a4 < t6.length; a4++) o3(t6[a4]);
    }
  }, i2.prototype[Symbol.iterator] = function* () {
    var t5 = this._size.length - 1;
    if (!(t5 < 0)) {
      if (t5 === 0) {
        for (var n3 = 0; n3 < this._data.length; n3++) yield { value: this._data[n3], index: [n3] };
        return;
      }
      for (var r3 = Array(t5 + 1).fill(0), i3 = this._size.reduce((t6, n4) => t6 * n4, 1), a3 = 0; a3 < i3; a3++) {
        for (var o3 = this._data, s3 = 0; s3 < t5; s3++) o3 = o3[r3[s3]];
        yield { value: o3[r3[t5]], index: r3.slice() };
        for (var c3 = t5; c3 >= 0 && (r3[c3]++, !(r3[c3] < this._size[c3])); c3--) r3[c3] = 0;
      }
    }
  }, i2.prototype.rows = function() {
    var t5 = [];
    if (this.size().length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var n3 of this._data) t5.push(new i2([n3], this._datatype));
    return t5;
  }, i2.prototype.columns = function() {
    var t5 = this, n3 = [], r3 = this.size();
    if (r3.length !== 2) throw TypeError(`Rows can only be returned for a 2D matrix.`);
    for (var a3 = this._data, o3 = function(r4) {
      var o4 = a3.map((t6) => [t6[r4]]);
      n3.push(new i2(o4, t5._datatype));
    }, s3 = 0; s3 < r3[1]; s3++) o3(s3);
    return n3;
  }, i2.prototype.toArray = function() {
    return clone$3(this._data);
  }, i2.prototype.valueOf = function() {
    return this._data;
  }, i2.prototype.format = function(t5) {
    return format(this._data, t5);
  }, i2.prototype.toString = function() {
    return format(this._data);
  }, i2.prototype.toJSON = function() {
    return { mathjs: `DenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber(t5) && (t5 = t5.toNumber()), !isNumber(t5) || !isInteger(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    for (var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, a3 = this._size[0], o3 = this._size[1], s3 = Math.min(a3 - r3, o3 - n3), c3 = [], l3 = 0; l3 < s3; l3++) c3[l3] = this._data[l3 + r3][l3 + n3];
    return new i2({ data: c3, size: [s3], datatype: this._datatype });
  }, i2.diagonal = function(t5, n3, r3, a3) {
    if (!isArray(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber(t6) && (t6 = t6.toNumber()), !isNumber(t6) || !isInteger(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), r3) {
      if (isBigNumber(r3) && (r3 = r3.toNumber()), !isNumber(r3) || !isInteger(r3)) throw TypeError(`The parameter k must be an integer number`);
    } else r3 = 0;
    var o3 = r3 > 0 ? r3 : 0, s3 = r3 < 0 ? -r3 : 0, c3 = t5[0], l3 = t5[1], u3 = Math.min(c3 - s3, l3 - o3), d3;
    if (isArray(n3)) {
      if (n3.length !== u3) throw Error(`Invalid value array length`);
      d3 = function(t6) {
        return n3[t6];
      };
    } else if (isMatrix(n3)) {
      var p2 = n3.size();
      if (p2.length !== 1 || p2[0] !== u3) throw Error(`Invalid matrix length`);
      d3 = function(t6) {
        return n3.get([t6]);
      };
    } else d3 = function() {
      return n3;
    };
    a3 ||= isBigNumber(d3(0)) ? d3(0).mul(0) : 0;
    var m2 = [];
    if (t5.length > 0) {
      m2 = resize(m2, t5, a3);
      for (var h2 = 0; h2 < u3; h2++) m2[h2 + s3][h2 + o3] = d3(h2);
    }
    return new i2({ data: m2, size: [c3, l3] });
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function(t5, n3) {
    if (!isNumber(t5) || !isInteger(t5) || !isNumber(n3) || !isInteger(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex(t5, this._size[0]), validateIndex(n3, this._size[0]), i2._swapRows(t5, n3, this._data), this;
  }, i2._swapRows = function(t5, n3, r3) {
    var i3 = r3[t5];
    r3[t5] = r3[n3], r3[n3] = i3;
  };
  function d2(t5) {
    return isMatrix(t5) ? d2(t5.valueOf()) : isArray(t5) ? t5.map(d2) : t5;
  }
  return i2;
}, { isClass: true }), name$314 = `clone`, dependencies$314 = [`typed`], createClone = factory(name$314, dependencies$314, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$314, { any: clone$3 });
});
function _switch$1(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
function containsCollections(t4) {
  for (var n2 = 0; n2 < t4.length; n2++) if (isCollection(t4[n2])) return true;
  return false;
}
function deepForEach(t4, n2) {
  isMatrix(t4) ? t4.forEach((t5) => n2(t5), false, true) : deepForEach$1(t4, n2, true);
}
function deepMap(t4, n2, r2) {
  if (!r2) return isMatrix(t4) ? t4.map((t5) => n2(t5), false, true) : deepMap$1(t4, n2, true);
  var i2 = (t5) => t5 === 0 ? t5 : n2(t5);
  return isMatrix(t4) ? t4.map((t5) => i2(t5), false, true) : deepMap$1(t4, i2, true);
}
function reduce$1(t4, n2, r2) {
  var i2 = Array.isArray(t4) ? arraySize(t4) : t4.size();
  if (n2 < 0 || n2 >= i2.length) throw new IndexError(n2, i2.length);
  return isMatrix(t4) ? t4.create(_reduce(t4.valueOf(), n2, r2), t4.datatype()) : _reduce(t4, n2, r2);
}
function _reduce(t4, n2, r2) {
  var i2, a2, o2, s2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (s2 = _switch$1(t4), a2 = [], i2 = 0; i2 < s2.length; i2++) a2[i2] = _reduce(s2[i2], n2 - 1, r2);
    return a2;
  } else {
    for (o2 = t4[0], i2 = 1; i2 < t4.length; i2++) o2 = r2(o2, t4[i2]);
    return o2;
  }
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _reduce(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function scatter(t4, n2, r2, i2, a2, o2, s2, c2, l2, u2, d2) {
  var p2 = t4._values, m2 = t4._index, h2 = t4._ptr, g2, v2, y2, b2;
  if (i2) for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? (i2[b2] = c2(i2[b2], p2[g2]), a2[b2] = o2) : (r2[b2] = o2, s2.push(b2), i2[b2] = p2[g2]);
  else for (v2 = h2[n2], y2 = h2[n2 + 1], g2 = v2; g2 < y2; g2++) b2 = m2[g2], r2[b2] === o2 ? a2[b2] = o2 : (r2[b2] = o2, s2.push(b2));
}
var name$313 = `isInteger`, dependencies$313 = [`typed`, `equal`], createIsInteger = factory(name$313, dependencies$313, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$313, { number: (t5) => Number.isFinite(t5) ? r2(t5, Math.round(t5)) : false, BigNumber: (t5) => t5.isFinite() ? r2(t5.round(), t5) : false, bigint: (t5) => true, Fraction: (t5) => t5.d === 1n, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), n1$4 = `number`, n2$3 = `number, number`;
function absNumber(t4) {
  return Math.abs(t4);
}
absNumber.signature = n1$4;
function addNumber(t4, n2) {
  return t4 + n2;
}
addNumber.signature = n2$3;
function subtractNumber(t4, n2) {
  return t4 - n2;
}
subtractNumber.signature = n2$3;
function multiplyNumber(t4, n2) {
  return t4 * n2;
}
multiplyNumber.signature = n2$3;
function unaryMinusNumber(t4) {
  return -t4;
}
unaryMinusNumber.signature = n1$4;
function unaryPlusNumber(t4) {
  return t4;
}
unaryPlusNumber.signature = n1$4;
function cbrtNumber(t4) {
  return cbrt$1(t4);
}
cbrtNumber.signature = n1$4;
function cubeNumber(t4) {
  return t4 * t4 * t4;
}
cubeNumber.signature = n1$4;
function expNumber(t4) {
  return Math.exp(t4);
}
expNumber.signature = n1$4;
function expm1Number(t4) {
  return expm1(t4);
}
expm1Number.signature = n1$4;
function lcmNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Parameters in function lcm must be integer numbers`);
  if (t4 === 0 || n2 === 0) return 0;
  for (var r2, i2 = t4 * n2; n2 !== 0; ) r2 = n2, n2 = t4 % r2, t4 = r2;
  return Math.abs(i2 / t4);
}
lcmNumber.signature = n2$3;
function logNumber(t4, n2) {
  return n2 ? Math.log(t4) / Math.log(n2) : Math.log(t4);
}
function log10Number(t4) {
  return log10$2(t4);
}
log10Number.signature = n1$4;
function log2Number(t4) {
  return log2$1(t4);
}
log2Number.signature = n1$4;
function nthRootNumber(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 2, r2 = n2 < 0;
  if (r2 && (n2 = -n2), n2 === 0) throw Error(`Root must be non-zero`);
  if (t4 < 0 && Math.abs(n2) % 2 != 1) throw Error(`Root must be odd when a is negative.`);
  if (t4 === 0) return r2 ? 1 / 0 : 0;
  if (!isFinite(t4)) return r2 ? 0 : t4;
  var i2 = Math.abs(t4) ** (1 / n2);
  return i2 = t4 < 0 ? -i2 : i2, r2 ? 1 / i2 : i2;
}
function signNumber(t4) {
  return sign$2(t4);
}
signNumber.signature = n1$4;
function squareNumber(t4) {
  return t4 * t4;
}
squareNumber.signature = n1$4;
function xgcdNumber(t4, n2) {
  var r2, i2, a2, o2 = 0, s2 = 1, c2 = 1, l2 = 0;
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Parameters in function xgcd must be integer numbers`);
  for (; n2; ) i2 = Math.floor(t4 / n2), a2 = t4 - i2 * n2, r2 = o2, o2 = s2 - i2 * o2, s2 = r2, r2 = c2, c2 = l2 - i2 * c2, l2 = r2, t4 = n2, n2 = a2;
  return t4 < 0 ? [-t4, -s2, -l2] : [t4, t4 ? s2 : 0, l2];
}
xgcdNumber.signature = n2$3;
function powNumber(t4, n2) {
  return t4 * t4 < 1 && n2 === 1 / 0 || t4 * t4 > 1 && n2 === -1 / 0 ? 0 : t4 ** +n2;
}
powNumber.signature = n2$3;
function roundNumber(t4) {
  var n2 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0;
  if (!isInteger(n2) || n2 < 0 || n2 > 15) throw Error(`Number of decimals in function round must be an integer from 0 to 15 inclusive`);
  return parseFloat(toFixed$2(t4, n2));
}
var n1$3 = `number`, n2$2 = `number, number`;
function bitAndNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function bitAnd`);
  return t4 & n2;
}
bitAndNumber.signature = n2$2;
function bitNotNumber(t4) {
  if (!isInteger(t4)) throw Error(`Integer expected in function bitNot`);
  return ~t4;
}
bitNotNumber.signature = n1$3;
function bitOrNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function bitOr`);
  return t4 | n2;
}
bitOrNumber.signature = n2$2;
function bitXorNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function bitXor`);
  return t4 ^ n2;
}
bitXorNumber.signature = n2$2;
function leftShiftNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function leftShift`);
  return t4 << n2;
}
leftShiftNumber.signature = n2$2;
function rightArithShiftNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function rightArithShift`);
  return t4 >> n2;
}
rightArithShiftNumber.signature = n2$2;
function rightLogShiftNumber(t4, n2) {
  if (!isInteger(t4) || !isInteger(n2)) throw Error(`Integers expected in function rightLogShift`);
  return t4 >>> n2;
}
rightLogShiftNumber.signature = n2$2;
function product(t4, n2) {
  if (n2 < t4) return 1;
  if (n2 === t4) return n2;
  var r2 = n2 + t4 >> 1;
  return product(t4, r2) * product(r2 + 1, n2);
}
function combinationsNumber(t4, n2) {
  if (!isInteger(t4) || t4 < 0 || !isInteger(n2) || n2 < 0) throw TypeError(`Positive integer value expected in function combinations`);
  if (n2 > t4) throw TypeError(`k must be less than or equal to n`);
  for (var r2 = t4 - n2, i2 = 1, a2 = n2 < r2 ? r2 + 1 : n2 + 1, o2 = 2, s2 = n2 < r2 ? n2 : r2, c2 = a2; c2 <= t4; ++c2) for (i2 *= c2; o2 <= s2 && i2 % o2 === 0; ) i2 /= o2, ++o2;
  return o2 <= s2 && (i2 /= product(o2, s2)), i2;
}
combinationsNumber.signature = `number, number`;
var pi$1 = Math.PI, tau = 2 * Math.PI, e = Math.E, phi = 1.618033988749895, n1$2 = `number`, n2$1 = `number, number`;
function notNumber(t4) {
  return !t4;
}
notNumber.signature = n1$2;
function orNumber(t4, n2) {
  return !!(t4 || n2);
}
orNumber.signature = n2$1;
function xorNumber(t4, n2) {
  return !!t4 != !!n2;
}
xorNumber.signature = n2$1;
function andNumber(t4, n2) {
  return !!(t4 && n2);
}
andNumber.signature = n2$1;
function gammaNumber(t4) {
  var n2;
  if (isInteger(t4)) return t4 <= 0 ? Number.isFinite(t4) ? 1 / 0 : NaN : t4 > 171 ? 1 / 0 : product(1, t4 - 1);
  if (t4 < 0.5) return Math.PI / (Math.sin(Math.PI * t4) * gammaNumber(1 - t4));
  if (t4 >= 171.35) return 1 / 0;
  if (t4 > 85) {
    var r2 = t4 * t4, i2 = r2 * t4, a2 = i2 * t4, o2 = a2 * t4;
    return Math.sqrt(2 * Math.PI / t4) * (t4 / Math.E) ** +t4 * (1 + 1 / (12 * t4) + 1 / (288 * r2) - 139 / (51840 * i2) - 571 / (2488320 * a2) + 163879 / (209018880 * o2) + 5246819 / (75246796800 * o2 * t4));
  }
  --t4, n2 = gammaP[0];
  for (var s2 = 1; s2 < gammaP.length; ++s2) n2 += gammaP[s2] / (t4 + s2);
  var c2 = t4 + gammaG + 0.5;
  return Math.sqrt(2 * Math.PI) * c2 ** +(t4 + 0.5) * Math.exp(-c2) * n2;
}
gammaNumber.signature = `number`;
var gammaG = 4.7421875, gammaP = [0.9999999999999971, 57.15623566586292, -59.59796035547549, 14.136097974741746, -0.4919138160976202, 3399464998481189e-20, 4652362892704858e-20, -9837447530487956e-20, 1580887032249125e-19, -21026444172410488e-20, 21743961811521265e-20, -1643181065367639e-19, 8441822398385275e-20, -26190838401581408e-21, 36899182659531625e-22], lnSqrt2PI = 0.9189385332046728, lgammaSeries = [1.000000000190015, 76.18009172947146, -86.50532032941678, 24.01409824083091, -1.231739572450155, 0.001208650973866179, -5395239384953e-18];
function lgammaNumber(t4) {
  if (t4 < 0) return NaN;
  if (t4 === 0) return 1 / 0;
  if (!Number.isFinite(t4)) return t4;
  if (t4 < 0.5) return Math.log(Math.PI / Math.sin(Math.PI * t4)) - lgammaNumber(1 - t4);
  --t4;
  for (var n2 = t4 + 5 + 0.5, r2 = lgammaSeries[0], i2 = 6; i2 >= 1; i2--) r2 += lgammaSeries[i2] / (t4 + i2);
  return lnSqrt2PI + (t4 + 0.5) * Math.log(n2) - n2 + Math.log(r2);
}
lgammaNumber.signature = `number`;
var n1$1 = `number`;
function acoshNumber(t4) {
  return acosh$2(t4);
}
acoshNumber.signature = n1$1;
function acotNumber(t4) {
  return Math.atan(1 / t4);
}
acotNumber.signature = n1$1;
function acothNumber(t4) {
  return Number.isFinite(t4) ? (Math.log((t4 + 1) / t4) + Math.log(t4 / (t4 - 1))) / 2 : 0;
}
acothNumber.signature = n1$1;
function acscNumber(t4) {
  return Math.asin(1 / t4);
}
acscNumber.signature = n1$1;
function acschNumber(t4) {
  var n2 = 1 / t4;
  return Math.log(n2 + Math.sqrt(n2 * n2 + 1));
}
acschNumber.signature = n1$1;
function asecNumber(t4) {
  return Math.acos(1 / t4);
}
asecNumber.signature = n1$1;
function asechNumber(t4) {
  var n2 = 1 / t4, r2 = Math.sqrt(n2 * n2 - 1);
  return Math.log(r2 + n2);
}
asechNumber.signature = n1$1;
function asinhNumber(t4) {
  return asinh$2(t4);
}
asinhNumber.signature = n1$1;
function atanhNumber(t4) {
  return atanh$2(t4);
}
atanhNumber.signature = n1$1;
function cotNumber(t4) {
  return 1 / Math.tan(t4);
}
cotNumber.signature = n1$1;
function cothNumber(t4) {
  var n2 = Math.exp(2 * t4);
  return (n2 + 1) / (n2 - 1);
}
cothNumber.signature = n1$1;
function cscNumber(t4) {
  return 1 / Math.sin(t4);
}
cscNumber.signature = n1$1;
function cschNumber(t4) {
  return t4 === 0 ? 1 / 0 : Math.abs(2 / (Math.exp(t4) - Math.exp(-t4))) * sign$2(t4);
}
cschNumber.signature = n1$1;
function secNumber(t4) {
  return 1 / Math.cos(t4);
}
secNumber.signature = n1$1;
function sechNumber(t4) {
  return 2 / (Math.exp(t4) + Math.exp(-t4));
}
sechNumber.signature = n1$1;
function sinhNumber(t4) {
  return sinh$3(t4);
}
sinhNumber.signature = n1$1;
var n1 = `number`;
function isNegativeNumber(t4) {
  return t4 < 0;
}
isNegativeNumber.signature = n1;
function isPositiveNumber(t4) {
  return t4 > 0;
}
isPositiveNumber.signature = n1;
function isNaNNumber(t4) {
  return Number.isNaN(t4);
}
isNaNNumber.signature = n1;
function nearlyEqual(t4, n2) {
  var r2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : 1e-9, i2 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : 0;
  if (r2 <= 0) throw Error(`Relative tolerance must be greater than 0`);
  if (i2 < 0) throw Error(`Absolute tolerance must be at least 0`);
  return t4.isNaN() || n2.isNaN() ? false : !t4.isFinite() || !n2.isFinite() ? t4.eq(n2) : t4.eq(n2) ? true : t4.minus(n2).abs().lte(t4.constructor.max(t4.constructor.max(t4.abs(), n2.abs()).mul(r2), i2));
}
var name$312 = `isNegative`, dependencies$312 = [`typed`, `config`], createIsNegative = factory(name$312, dependencies$312, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$312, { number: (t5) => nearlyEqual$1(t5, 0, r2.relTol, r2.absTol) ? false : isNegativeNumber(t5), BigNumber: (t5) => nearlyEqual(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 < 0n, Fraction: (t5) => t5.s < 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$311 = `isNumeric`, dependencies$311 = [`typed`], createIsNumeric = factory(name$311, dependencies$311, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$311, { "number | BigNumber | bigint | Fraction | boolean": () => true, "Complex | Unit | string | null | undefined | Node": () => false, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$310 = `hasNumericValue`, dependencies$310 = [`typed`, `isNumeric`], createHasNumericValue = factory(name$310, dependencies$310, (t4) => {
  var { typed: n2, isNumeric: r2 } = t4;
  return n2(name$310, { boolean: () => true, string: function(t5) {
    return t5.trim().length > 0 && !isNaN(Number(t5));
  }, any: function(t5) {
    return r2(t5);
  } });
}), name$309 = `isPositive`, dependencies$309 = [`typed`, `config`], createIsPositive = factory(name$309, dependencies$309, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$309, { number: (t5) => nearlyEqual$1(t5, 0, r2.relTol, r2.absTol) ? false : isPositiveNumber(t5), BigNumber: (t5) => nearlyEqual(t5, new t5.constructor(0), r2.relTol, r2.absTol) ? false : !t5.isNeg() && !t5.isZero() && !t5.isNaN(), bigint: (t5) => t5 > 0n, Fraction: (t5) => t5.s > 0n && t5.n > 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$308 = `isZero`, dependencies$308 = [`typed`, `equalScalar`], createIsZero = factory(name$308, dependencies$308, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$308, { "number | BigNumber | Complex | Fraction": (t5) => r2(t5, 0), bigint: (t5) => t5 === 0n, Unit: n2.referToSelf((t5) => (r3) => n2.find(t5, r3.valueType())(r3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$307 = `isNaN`, dependencies$307 = [`typed`], createIsNaN = factory(name$307, dependencies$307, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$307, { number: isNaNNumber, BigNumber: function(t5) {
    return t5.isNaN();
  }, bigint: function(t5) {
    return false;
  }, Fraction: function(t5) {
    return false;
  }, Complex: function(t5) {
    return t5.isNaN();
  }, Unit: function(t5) {
    return Number.isNaN(t5.value);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$306 = `isBounded`, dependencies$306 = [`typed`], createIsBounded = factory(name$306, dependencies$306, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$306, { number: (t5) => Number.isFinite(t5), "BigNumber | Complex": (t5) => t5.isFinite(), "bigint | Fraction": () => true, "null | undefined": () => false, Unit: n2.referToSelf((t5) => (n3) => t5(n3.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => (Array.isArray(n3) || (n3 = n3.valueOf()), n3.every((n4) => t5(n4)))) });
}), name$305 = `isFinite`, dependencies$305 = [`typed`, `isBounded`, `map`], createIsFinite = factory(name$305, dependencies$305, (t4) => {
  var { typed: n2, isBounded: r2, map: i2 } = t4;
  return n2(name$305, { "Array | Matrix": (t5) => i2(t5, r2), any: (t5) => r2(t5) });
}), name$304 = `typeOf`, dependencies$304 = [`typed`], createTypeOf = factory(name$304, dependencies$304, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$304, { any: typeOf });
});
function complexEquals(t4, n2, r2, i2) {
  return nearlyEqual$1(t4.re, n2.re, r2, i2) && nearlyEqual$1(t4.im, n2.im, r2, i2);
}
var createCompareUnits = factory(`compareUnits`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (!r2.equalBase(i2)) throw Error(`Cannot compare units with different base`);
    return n2.find(t5, [r2.valueType(), i2.valueType()])(r2.value, i2.value);
  }) };
}), name$303 = `equalScalar`, dependencies$303 = [`typed`, `config`], createEqualScalar = factory(name$303, dependencies$303, (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303, { "boolean, boolean": function(t5, n3) {
    return t5 === n3;
  }, "number, number": function(t5, n3) {
    return nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.eq(n3) || nearlyEqual(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.equals(n3);
  }, "Complex, Complex": function(t5, n3) {
    return complexEquals(t5, n3, r2.relTol, r2.absTol);
  } }, createCompareUnits({ typed: n2 }));
});
factory(name$303, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$303, { "number, number": function(t5, n3) {
    return nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  } });
});
var name$302 = `SparseMatrix`, dependencies$302 = [`typed`, `equalScalar`, `Matrix`], createSparseMatrixClass = factory(name$302, dependencies$302, (t4) => {
  var { typed: n2, equalScalar: r2, Matrix: i2 } = t4;
  function a2(t5, n3) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix(t5)) o2(this, t5, n3);
    else if (t5 && isArray(t5.index) && isArray(t5.ptr) && isArray(t5.size)) this._values = t5.values, this._index = t5.index, this._ptr = t5.ptr, this._size = t5.size, this._datatype = n3 || t5.datatype;
    else if (isArray(t5)) s2(this, t5, n3);
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf(t5) + `)`);
    else this._values = [], this._index = [], this._ptr = [0], this._size = [0, 0], this._datatype = n3;
  }
  function o2(t5, n3, r3) {
    n3.type === `SparseMatrix` ? (t5._values = n3._values ? clone$3(n3._values) : void 0, t5._index = clone$3(n3._index), t5._ptr = clone$3(n3._ptr), t5._size = clone$3(n3._size), t5._datatype = r3 || n3._datatype) : s2(t5, n3.valueOf(), r3 || n3._datatype);
  }
  function s2(t5, i3, a3) {
    t5._values = [], t5._index = [], t5._ptr = [], t5._datatype = a3;
    var o3 = i3.length, s3 = 0, c3 = r2, l3 = 0;
    if (isString(a3) && (c3 = n2.find(r2, [a3, a3]) || r2, l3 = n2.convert(0, a3)), o3 > 0) {
      var u3 = 0;
      do {
        t5._ptr.push(t5._index.length);
        for (var d3 = 0; d3 < o3; d3++) {
          var p3 = i3[d3];
          if (isArray(p3)) {
            if (u3 === 0 && s3 < p3.length && (s3 = p3.length), u3 < p3.length) {
              var m3 = p3[u3];
              c3(m3, l3) || (t5._values.push(m3), t5._index.push(d3));
            }
          } else u3 === 0 && s3 < 1 && (s3 = 1), c3(p3, l3) || (t5._values.push(p3), t5._index.push(d3));
        }
        u3++;
      } while (u3 < s3);
    }
    for (; t5._ptr.length <= s3; ) t5._ptr.push(t5._index.length);
    t5._size = [o3, s3];
  }
  a2.prototype = new i2(), a2.prototype.createSparseMatrix = function(t5, n3) {
    return new a2(t5, n3);
  }, Object.defineProperty(a2, "name", { value: `SparseMatrix` }), a2.prototype.constructor = a2, a2.prototype.type = `SparseMatrix`, a2.prototype.isSparseMatrix = true, a2.prototype.getDataType = function() {
    return getArrayDataType(this._values, typeOf);
  }, a2.prototype.storage = function() {
    return `sparse`;
  }, a2.prototype.datatype = function() {
    return this._datatype;
  }, a2.prototype.create = function(t5, n3) {
    return new a2(t5, n3);
  }, a2.prototype.density = function() {
    var t5 = this._size[0], n3 = this._size[1];
    return t5 !== 0 && n3 !== 0 ? this._index.length / (t5 * n3) : 0;
  }, a2.prototype.subset = function(t5, n3, r3) {
    if (!this._values) throw Error(`Cannot invoke subset on a Pattern only matrix`);
    switch (arguments.length) {
      case 1:
        return c2(this, t5);
      case 2:
      case 3:
        return l2(this, t5, n3, r3);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  };
  function c2(t5, n3) {
    if (!isIndex(n3)) throw TypeError(`Invalid index`);
    if (n3.isScalar()) return t5.get(n3.min());
    var r3 = n3.size();
    if (r3.length !== t5._size.length) throw new DimensionError(r3.length, t5._size.length);
    var i3, o3, s3, c3, l3 = n3.min(), u3 = n3.max();
    for (i3 = 0, o3 = t5._size.length; i3 < o3; i3++) validateIndex(l3[i3], t5._size[i3]), validateIndex(u3[i3], t5._size[i3]);
    var d3 = t5._values, p3 = t5._index, m3 = t5._ptr, h3 = n3.dimension(0), g3 = n3.dimension(1), v2 = [], y2 = [];
    function b2(t6, n4) {
      y2[t6] = n4[0], v2[t6] = true;
    }
    Number.isInteger(h3) ? b2(h3, [0]) : h3.forEach(b2);
    var x2 = d3 ? [] : void 0, S2 = [], w2 = [];
    function E(t6) {
      for (w2.push(S2.length), s3 = m3[t6], c3 = m3[t6 + 1]; s3 < c3; s3++) i3 = p3[s3], v2[i3] === true && (S2.push(y2[i3]), x2 && x2.push(d3[s3]));
    }
    return Number.isInteger(g3) ? E(g3) : g3.forEach(E), w2.push(S2.length), new a2({ values: x2, index: S2, ptr: w2, size: r3, datatype: t5._datatype });
  }
  function l2(t5, n3, r3, i3) {
    if (!n3 || n3.isIndex !== true) throw TypeError(`Invalid index`);
    var a3 = n3.size(), o3 = n3.isScalar(), s3;
    if (isMatrix(r3) ? (s3 = r3.size(), r3 = r3.toArray()) : s3 = arraySize(r3), o3) {
      if (s3.length !== 0) throw TypeError(`Scalar expected`);
      t5.set(n3.min(), r3, i3);
    } else {
      if (a3.length !== 1 && a3.length !== 2) throw new DimensionError(a3.length, t5._size.length, `<`);
      if (s3.length < a3.length) {
        for (var c3 = 0, l3 = 0; a3[c3] === 1 && s3[c3] === 1; ) c3++;
        for (; a3[c3] === 1; ) l3++, c3++;
        r3 = unsqueeze(r3, a3.length, l3, s3);
      }
      if (!deepStrictEqual(a3, s3)) throw new DimensionError(a3, s3, `>`);
      if (a3.length === 1) p3(n3.dimension(0), (n4, a4) => {
        validateIndex(n4), t5.set([n4, 0], r3[a4[0]], i3);
      });
      else {
        var u3 = n3.dimension(0), d3 = n3.dimension(1);
        p3(u3, (n4, a4) => {
          validateIndex(n4), p3(d3, (o4, s4) => {
            validateIndex(o4), t5.set([n4, o4], r3[a4[0]][s4[0]], i3);
          });
        });
      }
    }
    return t5;
    function p3(t6, n4) {
      isNumber(t6) ? n4(t6, [0]) : t6.forEach(n4);
    }
  }
  a2.prototype.get = function(t5) {
    if (!isArray(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke get on a Pattern only matrix`);
    var n3 = t5[0], r3 = t5[1];
    validateIndex(n3, this._size[0]), validateIndex(r3, this._size[1]);
    var i3 = u2(n3, this._ptr[r3], this._ptr[r3 + 1], this._index);
    return i3 < this._ptr[r3 + 1] && this._index[i3] === n3 ? this._values[i3] : 0;
  }, a2.prototype.set = function(t5, i3, a3) {
    if (!isArray(t5)) throw TypeError(`Array expected`);
    if (t5.length !== this._size.length) throw new DimensionError(t5.length, this._size.length);
    if (!this._values) throw Error(`Cannot invoke set on a Pattern only matrix`);
    var o3 = t5[0], s3 = t5[1], c3 = this._size[0], l3 = this._size[1], h3 = r2, g3 = 0;
    isString(this._datatype) && (h3 = n2.find(r2, [this._datatype, this._datatype]) || r2, g3 = n2.convert(0, this._datatype)), (o3 > c3 - 1 || s3 > l3 - 1) && (m2(this, Math.max(o3 + 1, c3), Math.max(s3 + 1, l3), a3), c3 = this._size[0], l3 = this._size[1]), validateIndex(o3, c3), validateIndex(s3, l3);
    var v2 = u2(o3, this._ptr[s3], this._ptr[s3 + 1], this._index);
    return v2 < this._ptr[s3 + 1] && this._index[v2] === o3 ? h3(i3, g3) ? d2(v2, s3, this._values, this._index, this._ptr) : this._values[v2] = i3 : h3(i3, g3) || p2(v2, o3, s3, i3, this._values, this._index, this._ptr), this;
  };
  function u2(t5, n3, r3, i3) {
    if (r3 - n3 === 0) return r3;
    for (var a3 = n3; a3 < r3; a3++) if (i3[a3] === t5) return a3;
    return n3;
  }
  function d2(t5, n3, r3, i3, a3) {
    r3.splice(t5, 1), i3.splice(t5, 1);
    for (var o3 = n3 + 1; o3 < a3.length; o3++) a3[o3]--;
  }
  function p2(t5, n3, r3, i3, a3, o3, s3) {
    a3.splice(t5, 0, i3), o3.splice(t5, 0, n3);
    for (var c3 = r3 + 1; c3 < s3.length; c3++) s3[c3]++;
  }
  a2.prototype.resize = function(t5, n3, r3) {
    if (!isCollection(t5)) throw TypeError(`Array or Matrix expected`);
    var i3 = t5.valueOf().map((t6) => Array.isArray(t6) && t6.length === 1 ? t6[0] : t6);
    if (i3.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    return i3.forEach(function(t6) {
      if (!isNumber(t6) || !isInteger(t6) || t6 < 0) throw TypeError(`Invalid size, must contain positive integers (size: ` + format(i3) + `)`);
    }), m2(r3 ? this.clone() : this, i3[0], i3[1], n3);
  };
  function m2(t5, i3, a3, o3) {
    var s3 = o3 || 0, c3 = r2, l3 = 0;
    isString(t5._datatype) && (c3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, l3 = n2.convert(0, t5._datatype), s3 = n2.convert(s3, t5._datatype));
    var u3 = !c3(s3, l3), d3 = t5._size[0], p3 = t5._size[1], m3, h3, g3;
    if (a3 > p3) {
      for (h3 = p3; h3 < a3; h3++) if (t5._ptr[h3] = t5._values.length, u3) for (m3 = 0; m3 < d3; m3++) t5._values.push(s3), t5._index.push(m3);
      t5._ptr[a3] = t5._values.length;
    } else a3 < p3 && (t5._ptr.splice(a3 + 1, p3 - a3), t5._values.splice(t5._ptr[a3], t5._values.length), t5._index.splice(t5._ptr[a3], t5._index.length));
    if (p3 = a3, i3 > d3) {
      if (u3) {
        var v2 = 0;
        for (h3 = 0; h3 < p3; h3++) {
          t5._ptr[h3] = t5._ptr[h3] + v2, g3 = t5._ptr[h3 + 1] + v2;
          var y2 = 0;
          for (m3 = d3; m3 < i3; m3++, y2++) t5._values.splice(g3 + y2, 0, s3), t5._index.splice(g3 + y2, 0, m3), v2++;
        }
        t5._ptr[p3] = t5._values.length;
      }
    } else if (i3 < d3) {
      var b2 = 0;
      for (h3 = 0; h3 < p3; h3++) {
        t5._ptr[h3] = t5._ptr[h3] - b2;
        var x2 = t5._ptr[h3], S2 = t5._ptr[h3 + 1] - b2;
        for (g3 = x2; g3 < S2; g3++) m3 = t5._index[g3], m3 > i3 - 1 && (t5._values.splice(g3, 1), t5._index.splice(g3, 1), b2++);
      }
      t5._ptr[h3] = t5._values.length;
    }
    return t5._size[0] = i3, t5._size[1] = a3, t5;
  }
  a2.prototype.reshape = function(t5, n3) {
    if (!isArray(t5)) throw TypeError(`Array expected`);
    if (t5.length !== 2) throw Error(`Sparse matrices can only be reshaped in two dimensions`);
    t5.forEach(function(n4) {
      if (!isNumber(n4) || !isInteger(n4) || n4 <= -2 || n4 === 0) throw TypeError(`Invalid size, must contain positive integers or -1 (size: ` + format(t5) + `)`);
    });
    var r3 = this._size[0] * this._size[1];
    if (t5 = processSizesWildcard(t5, r3), r3 !== t5[0] * t5[1]) throw Error(`Reshaping sparse matrix will result in the wrong number of elements`);
    var i3 = n3 ? this.clone() : this;
    if (this._size[0] === t5[0] && this._size[1] === t5[1]) return i3;
    for (var a3 = [], o3 = 0; o3 < i3._ptr.length; o3++) for (var s3 = 0; s3 < i3._ptr[o3 + 1] - i3._ptr[o3]; s3++) a3.push(o3);
    for (var c3 = i3._values.slice(), l3 = i3._index.slice(), d3 = 0; d3 < i3._index.length; d3++) {
      var m3 = l3[d3], h3 = a3[d3], g3 = m3 * i3._size[1] + h3;
      a3[d3] = g3 % t5[1], l3[d3] = Math.floor(g3 / t5[1]);
    }
    i3._values.length = 0, i3._index.length = 0, i3._ptr.length = t5[1] + 1, i3._size = t5.slice();
    for (var v2 = 0; v2 < i3._ptr.length; v2++) i3._ptr[v2] = 0;
    for (var y2 = 0; y2 < c3.length; y2++) {
      var b2 = l3[y2], x2 = a3[y2], S2 = c3[y2];
      p2(u2(b2, i3._ptr[x2], i3._ptr[x2 + 1], i3._index), b2, x2, S2, i3._values, i3._index, i3._ptr);
    }
    return i3;
  }, a2.prototype.clone = function() {
    return new a2({ values: this._values ? clone$3(this._values) : void 0, index: clone$3(this._index), ptr: clone$3(this._ptr), size: clone$3(this._size), datatype: this._datatype });
  }, a2.prototype.size = function() {
    return this._size.slice(0);
  }, a2.prototype.map = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke map on a Pattern only matrix`);
    var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback(t5, r3, `map`);
    return h2(this, 0, i3 - 1, 0, a3 - 1, function(t6, n4, i4) {
      return o3.fn(t6, [n4, i4], r3);
    }, n3);
  };
  function h2(t5, i3, o3, s3, c3, l3, u3) {
    var d3 = [], p3 = [], m3 = [], h3 = r2, g3 = 0;
    isString(t5._datatype) && (h3 = n2.find(r2, [t5._datatype, t5._datatype]) || r2, g3 = n2.convert(0, t5._datatype));
    for (var v2 = function(t6, n3, r3) {
      var i4 = l3(t6, n3, r3);
      h3(i4, g3) || (d3.push(i4), p3.push(n3));
    }, y2 = s3; y2 <= c3; y2++) {
      m3.push(d3.length);
      var b2 = t5._ptr[y2], x2 = t5._ptr[y2 + 1];
      if (u3) for (var S2 = b2; S2 < x2; S2++) {
        var w2 = t5._index[S2];
        w2 >= i3 && w2 <= o3 && v2(t5._values[S2], w2 - i3, y2 - s3);
      }
      else {
        for (var E = {}, D = b2; D < x2; D++) {
          var O2 = t5._index[D];
          E[O2] = t5._values[D];
        }
        for (var j2 = i3; j2 <= o3; j2++) v2(j2 in E ? E[j2] : 0, j2 - i3, y2 - s3);
      }
    }
    return m3.push(d3.length), new a2({ values: d3, index: p3, ptr: m3, size: [o3 - i3 + 1, c3 - s3 + 1] });
  }
  a2.prototype.forEach = function(t5, n3) {
    if (!this._values) throw Error(`Cannot invoke forEach on a Pattern only matrix`);
    for (var r3 = this, i3 = this._size[0], a3 = this._size[1], o3 = optimizeCallback(t5, r3, `forEach`), s3 = 0; s3 < a3; s3++) {
      var c3 = this._ptr[s3], l3 = this._ptr[s3 + 1];
      if (n3) for (var u3 = c3; u3 < l3; u3++) {
        var d3 = this._index[u3];
        o3.fn(this._values[u3], [d3, s3], r3);
      }
      else {
        for (var p3 = {}, m3 = c3; m3 < l3; m3++) {
          var h3 = this._index[m3];
          p3[h3] = this._values[m3];
        }
        for (var g3 = 0; g3 < i3; g3++) {
          var v2 = g3 in p3 ? p3[g3] : 0;
          o3.fn(v2, [g3, s3], r3);
        }
      }
    }
  }, a2.prototype[Symbol.iterator] = function* () {
    if (!this._values) throw Error(`Cannot iterate a Pattern only matrix`);
    for (var t5 = this._size[1], n3 = 0; n3 < t5; n3++) for (var r3 = this._ptr[n3], i3 = this._ptr[n3 + 1], a3 = r3; a3 < i3; a3++) {
      var o3 = this._index[a3];
      yield { value: this._values[a3], index: [o3, n3] };
    }
  }, a2.prototype.toArray = function() {
    return g2(this._values, this._index, this._ptr, this._size, true);
  }, a2.prototype.valueOf = function() {
    return g2(this._values, this._index, this._ptr, this._size, false);
  };
  function g2(t5, n3, r3, i3, a3) {
    var o3 = i3[0], s3 = i3[1], c3 = [], l3, u3;
    for (l3 = 0; l3 < o3; l3++) for (c3[l3] = [], u3 = 0; u3 < s3; u3++) c3[l3][u3] = 0;
    for (u3 = 0; u3 < s3; u3++) for (var d3 = r3[u3], p3 = r3[u3 + 1], m3 = d3; m3 < p3; m3++) l3 = n3[m3], c3[l3][u3] = t5 ? a3 ? clone$3(t5[m3]) : t5[m3] : 1;
    return c3;
  }
  return a2.prototype.format = function(t5) {
    for (var n3 = this._size[0], r3 = this._size[1], i3 = this.density(), a3 = `Sparse Matrix [` + format(n3, t5) + ` x ` + format(r3, t5) + `] density: ` + format(i3, t5) + `
`, o3 = 0; o3 < r3; o3++) for (var s3 = this._ptr[o3], c3 = this._ptr[o3 + 1], l3 = s3; l3 < c3; l3++) {
      var u3 = this._index[l3];
      a3 += `
    (` + format(u3, t5) + `, ` + format(o3, t5) + `) ==> ` + (this._values ? format(this._values[l3], t5) : `X`);
    }
    return a3;
  }, a2.prototype.toString = function() {
    return format(this.toArray());
  }, a2.prototype.toJSON = function() {
    return { mathjs: `SparseMatrix`, values: this._values, index: this._index, ptr: this._ptr, size: this._size, datatype: this._datatype };
  }, a2.prototype.diagonal = function(t5) {
    if (t5) {
      if (isBigNumber(t5) && (t5 = t5.toNumber()), !isNumber(t5) || !isInteger(t5)) throw TypeError(`The parameter k must be an integer number`);
    } else t5 = 0;
    var n3 = t5 > 0 ? t5 : 0, r3 = t5 < 0 ? -t5 : 0, i3 = this._size[0], o3 = this._size[1], s3 = Math.min(i3 - r3, o3 - n3), c3 = [], l3 = [], u3 = [];
    u3[0] = 0;
    for (var d3 = n3; d3 < o3 && c3.length < s3; d3++) for (var p3 = this._ptr[d3], m3 = this._ptr[d3 + 1], h3 = p3; h3 < m3; h3++) {
      var g3 = this._index[h3];
      if (g3 === d3 - n3 + r3) {
        c3.push(this._values[h3]), l3[c3.length - 1] = g3 - r3;
        break;
      }
    }
    return u3.push(c3.length), new a2({ values: c3, index: l3, ptr: u3, size: [s3, 1] });
  }, a2.fromJSON = function(t5) {
    return new a2(t5);
  }, a2.diagonal = function(t5, i3, o3, s3, c3) {
    if (!isArray(t5)) throw TypeError(`Array expected, size parameter`);
    if (t5.length !== 2) throw Error(`Only two dimensions matrix are supported`);
    if (t5 = t5.map(function(t6) {
      if (isBigNumber(t6) && (t6 = t6.toNumber()), !isNumber(t6) || !isInteger(t6) || t6 < 1) throw Error(`Size values must be positive integers`);
      return t6;
    }), o3) {
      if (isBigNumber(o3) && (o3 = o3.toNumber()), !isNumber(o3) || !isInteger(o3)) throw TypeError(`The parameter k must be an integer number`);
    } else o3 = 0;
    var l3 = r2, u3 = 0;
    isString(c3) && (l3 = n2.find(r2, [c3, c3]) || r2, u3 = n2.convert(0, c3));
    var d3 = o3 > 0 ? o3 : 0, p3 = o3 < 0 ? -o3 : 0, m3 = t5[0], h3 = t5[1], g3 = Math.min(m3 - p3, h3 - d3), v2;
    if (isArray(i3)) {
      if (i3.length !== g3) throw Error(`Invalid value array length`);
      v2 = function(t6) {
        return i3[t6];
      };
    } else if (isMatrix(i3)) {
      var y2 = i3.size();
      if (y2.length !== 1 || y2[0] !== g3) throw Error(`Invalid matrix length`);
      v2 = function(t6) {
        return i3.get([t6]);
      };
    } else v2 = function() {
      return i3;
    };
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < h3; w2++) {
      S2.push(b2.length);
      var E = w2 - d3;
      if (E >= 0 && E < g3) {
        var D = v2(E);
        l3(D, u3) || (x2.push(E + p3), b2.push(D));
      }
    }
    return S2.push(b2.length), new a2({ values: b2, index: x2, ptr: S2, size: [m3, h3] });
  }, a2.prototype.swapRows = function(t5, n3) {
    if (!isNumber(t5) || !isInteger(t5) || !isNumber(n3) || !isInteger(n3)) throw Error(`Row index must be positive integers`);
    if (this._size.length !== 2) throw Error(`Only two dimensional matrix is supported`);
    return validateIndex(t5, this._size[0]), validateIndex(n3, this._size[0]), a2._swapRows(t5, n3, this._size[1], this._values, this._index, this._ptr), this;
  }, a2._forEachRow = function(t5, n3, r3, i3, a3) {
    for (var o3 = i3[t5], s3 = i3[t5 + 1], c3 = o3; c3 < s3; c3++) a3(r3[c3], n3[c3]);
  }, a2._swapRows = function(t5, n3, r3, i3, a3, o3) {
    for (var s3 = 0; s3 < r3; s3++) {
      var c3 = o3[s3], l3 = o3[s3 + 1], d3 = u2(t5, c3, l3, a3), p3 = u2(n3, c3, l3, a3);
      if (d3 < l3 && p3 < l3 && a3[d3] === t5 && a3[p3] === n3) {
        if (i3) {
          var m3 = i3[d3];
          i3[d3] = i3[p3], i3[p3] = m3;
        }
        continue;
      }
      if (d3 < l3 && a3[d3] === t5 && (p3 >= l3 || a3[p3] !== n3)) {
        var h3 = i3 ? i3[d3] : void 0;
        a3.splice(p3, 0, n3), i3 && i3.splice(p3, 0, h3), a3.splice(p3 <= d3 ? d3 + 1 : d3, 1), i3 && i3.splice(p3 <= d3 ? d3 + 1 : d3, 1);
        continue;
      }
      if (p3 < l3 && a3[p3] === n3 && (d3 >= l3 || a3[d3] !== t5)) {
        var g3 = i3 ? i3[p3] : void 0;
        a3.splice(d3, 0, t5), i3 && i3.splice(d3, 0, g3), a3.splice(d3 <= p3 ? p3 + 1 : p3, 1), i3 && i3.splice(d3 <= p3 ? p3 + 1 : p3, 1);
      }
    }
  }, a2;
}, { isClass: true }), name$301 = `number`, dependencies$301 = [`typed`];
function getNonDecimalNumberParts(t4) {
  var n2 = t4.match(/(0[box])([0-9a-fA-F]*)\.([0-9a-fA-F]*)/);
  return n2 ? { input: t4, radix: { "0b": 2, "0o": 8, "0x": 16 }[n2[1]], integerPart: n2[2], fractionalPart: n2[3] } : null;
}
function makeNumberFromNonDecimalParts(t4) {
  for (var n2 = parseInt(t4.integerPart, t4.radix), r2 = 0, i2 = 0; i2 < t4.fractionalPart.length; i2++) {
    var a2 = parseInt(t4.fractionalPart[i2], t4.radix);
    r2 += a2 / t4.radix ** +(i2 + 1);
  }
  var o2 = n2 + r2;
  if (isNaN(o2)) throw SyntaxError(`String "` + t4.input + `" is not a valid number`);
  return o2;
}
var createNumber = factory(name$301, dependencies$301, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`number`, { "": function() {
    return 0;
  }, number: function(t5) {
    return t5;
  }, string: function(t5) {
    if (t5 === `NaN`) return NaN;
    var n3 = getNonDecimalNumberParts(t5);
    if (n3) return makeNumberFromNonDecimalParts(n3);
    var r3 = 0, i2 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    i2 && (r3 = Number(i2[2]), t5 = i2[1]);
    var a2 = Number(t5);
    if (isNaN(a2)) throw SyntaxError(`String "` + t5 + `" is not a valid number`);
    if (i2) {
      if (a2 > 2 ** r3 - 1) throw SyntaxError(`String "${t5}" is out of range`);
      a2 >= 2 ** (r3 - 1) && (a2 -= 2 ** r3);
    }
    return a2;
  }, BigNumber: function(t5) {
    return t5.toNumber();
  }, bigint: function(t5) {
    return Number(t5);
  }, Fraction: function(t5) {
    return t5.valueOf();
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), null: function(t5) {
    return 0;
  }, "Unit, string | Unit": function(t5, n3) {
    return t5.toNumber(n3);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return parseFloat(t5.value);
  }, r2;
}), name$300 = `bigint`, dependencies$300 = [`typed`], createBigint = factory(name$300, dependencies$300, (t4) => {
  var { typed: n2 } = t4, r2 = n2(`bigint`, { "": function() {
    return 0n;
  }, bigint: function(t5) {
    return t5;
  }, number: function(t5) {
    return BigInt(t5.toFixed());
  }, BigNumber: function(t5) {
    return BigInt(t5.round().toString());
  }, Fraction: function(t5) {
    return BigInt(t5.valueOf().toFixed());
  }, "string | boolean": function(t5) {
    return BigInt(t5);
  }, null: function(t5) {
    return 0n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
  return r2.fromJSON = function(t5) {
    return BigInt(t5.value);
  }, r2;
}), name$299 = `string`, dependencies$299 = [`typed`], createString = factory(name$299, dependencies$299, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$299, { "": function() {
    return ``;
  }, number: format$2, null: function(t5) {
    return `null`;
  }, boolean: function(t5) {
    return t5 + ``;
  }, string: function(t5) {
    return t5;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)), any: function(t5) {
    return String(t5);
  } });
}), name$298 = `boolean`, dependencies$298 = [`typed`], createBoolean = factory(name$298, dependencies$298, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$298, { "": function() {
    return false;
  }, boolean: function(t5) {
    return t5;
  }, number: function(t5) {
    return !!t5;
  }, null: function(t5) {
    return false;
  }, BigNumber: function(t5) {
    return !t5.isZero();
  }, string: function(t5) {
    var n3 = t5.toLowerCase();
    if (n3 === `true`) return true;
    if (n3 === `false`) return false;
    var r2 = Number(t5);
    if (t5 !== `` && !isNaN(r2)) return !!r2;
    throw Error(`Cannot convert "` + t5 + `" to a boolean`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$297 = `bignumber`, dependencies$297 = [`typed`, `BigNumber`], createBignumber = factory(name$297, dependencies$297, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(`bignumber`, { "": function() {
    return new r2(0);
  }, number: function(t5) {
    return new r2(t5 + ``);
  }, string: function(t5) {
    var n3 = t5.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);
    if (n3) {
      var i2 = n3[2], a2 = r2(n3[1]), o2 = new r2(2).pow(Number(i2));
      if (a2.gt(o2.sub(1))) throw SyntaxError(`String "${t5}" is out of range`);
      var s2 = new r2(2).pow(Number(i2) - 1);
      return a2.gte(s2) ? a2.sub(o2) : a2;
    }
    return new r2(t5);
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Fraction: function(t5) {
    return new r2(String(t5.n)).div(String(t5.d)).times(String(t5.s));
  }, null: function(t5) {
    return new r2(0);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$296 = `complex`, dependencies$296 = [`typed`, `Complex`], createComplex = factory(name$296, dependencies$296, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(`complex`, { "": function() {
    return r2.ZERO;
  }, number: function(t5) {
    return new r2(t5, 0);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return new r2(t5.toNumber(), n3.toNumber());
  }, Fraction: function(t5) {
    return new r2(t5.valueOf(), 0);
  }, Complex: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2(t5);
  }, null: function(t5) {
    return r2(0);
  }, Object: function(t5) {
    if (`re` in t5 && `im` in t5) return new r2(t5.re, t5.im);
    if (`r` in t5 && `phi` in t5 || `abs` in t5 && `arg` in t5) return new r2(t5);
    throw Error(`Expected object with properties (re and im) or (r and phi) or (abs and arg)`);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$295 = `fraction`, dependencies$295 = [`typed`, `Fraction`], createFraction = factory(name$295, dependencies$295, (t4) => {
  var { typed: n2, Fraction: r2 } = t4;
  return n2(`fraction`, { number: function(t5) {
    if (!Number.isFinite(t5) || isNaN(t5)) throw Error(t5 + ` cannot be represented as a fraction`);
    return new r2(t5);
  }, string: function(t5) {
    return new r2(t5);
  }, "number, number": function(t5, n3) {
    return new r2(t5, n3);
  }, "bigint, bigint": function(t5, n3) {
    return new r2(t5, n3);
  }, null: function(t5) {
    return new r2(0);
  }, BigNumber: function(t5) {
    return new r2(t5.toString());
  }, bigint: function(t5) {
    return new r2(t5.toString());
  }, Fraction: function(t5) {
    return t5;
  }, Unit: n2.referToSelf((t5) => (n3) => {
    var r3 = n3.clone();
    return r3.value = t5(n3.value), r3;
  }), Object: function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$294 = `matrix`, dependencies$294 = [`typed`, `Matrix`, `DenseMatrix`, `SparseMatrix`], createMatrix = factory(name$294, dependencies$294, (t4) => {
  var { typed: n2, Matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$294, { "": function() {
    return o2([]);
  }, string: function(t5) {
    return o2([], t5);
  }, "string, string": function(t5, n3) {
    return o2([], t5, n3);
  }, Array: function(t5) {
    return o2(t5);
  }, Matrix: function(t5) {
    return o2(t5, t5.storage());
  }, "Array | Matrix, string": o2, "Array | Matrix, string, string": o2 });
  function o2(t5, n3, r3) {
    if (n3 === `dense` || n3 === "default" || n3 === void 0) return new i2(t5, r3);
    if (n3 === `sparse`) return new a2(t5, r3);
    throw TypeError(`Unknown matrix type ` + JSON.stringify(n3) + `.`);
  }
}), name$293 = `matrixFromFunction`, dependencies$293 = [`typed`, `matrix`, `isZero`], createMatrixFromFunction = factory(name$293, dependencies$293, (t4) => {
  var { typed: n2, matrix: r2, isZero: i2 } = t4;
  return n2(name$293, { "Array | Matrix, function, string, string": function(t5, n3, r3, i3) {
    return a2(t5, n3, r3, i3);
  }, "Array | Matrix, function, string": function(t5, n3, r3) {
    return a2(t5, n3, r3);
  }, "Matrix, function": function(t5, n3) {
    return a2(t5, n3, `dense`);
  }, "Array, function": function(t5, n3) {
    return a2(t5, n3, `dense`).toArray();
  }, "Array | Matrix, string, function": function(t5, n3, r3) {
    return a2(t5, r3, n3);
  }, "Array | Matrix, string, string, function": function(t5, n3, r3, i3) {
    return a2(t5, i3, n3, r3);
  } });
  function a2(t5, n3, a3, o2) {
    var s2 = o2 === void 0 ? r2(a3) : r2(a3, o2);
    return s2.resize(t5), s2.forEach(function(t6, r3) {
      var a4 = n3(r3);
      i2(a4) || s2.set(r3, a4);
    }), s2;
  }
}), name$292 = `matrixFromRows`, dependencies$292 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromRows = factory(name$292, dependencies$292, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$292, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one row is needed to construct a matrix.`);
    var n3 = s2(t5[0]), r3 = [];
    for (var a3 of t5) {
      var o3 = s2(a3);
      if (o3 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (o3 | 0));
      r3.push(i2(a3));
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$291 = `matrixFromColumns`, dependencies$291 = [`typed`, `matrix`, `flatten`, `size`], createMatrixFromColumns = factory(name$291, dependencies$291, (t4) => {
  var { typed: n2, matrix: r2, flatten: i2, size: a2 } = t4;
  return n2(name$291, { "...Array": function(t5) {
    return o2(t5);
  }, "...Matrix": function(t5) {
    return r2(o2(t5.map((t6) => t6.toArray())));
  } });
  function o2(t5) {
    if (t5.length === 0) throw TypeError(`At least one column is needed to construct a matrix.`);
    for (var n3 = s2(t5[0]), r3 = [], a3 = 0; a3 < n3; a3++) r3[a3] = [];
    for (var o3 of t5) {
      var c2 = s2(o3);
      if (c2 !== n3) throw TypeError(`The vectors had different length: ` + (n3 | 0) + ` ≠ ` + (c2 | 0));
      for (var l2 = i2(o3), u2 = 0; u2 < n3; u2++) r3[u2].push(l2[u2]);
    }
    return r3;
  }
  function s2(t5) {
    var n3 = a2(t5);
    if (n3.length === 1) return n3[0];
    if (n3.length === 2) {
      if (n3[0] === 1) return n3[1];
      if (n3[1] === 1) return n3[0];
      throw TypeError(`At least one of the arguments is not a vector.`);
    } else throw TypeError(`Only one- or two-dimensional vectors are supported.`);
  }
}), name$290 = `splitUnit`, dependencies$290 = [`typed`], createSplitUnit = factory(name$290, dependencies$290, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$290, { "Unit, Array": function(t5, n3) {
    return t5.splitUnit(n3);
  } });
}), name$289 = `unaryMinus`, dependencies$289 = [`typed`], createUnaryMinus = factory(name$289, dependencies$289, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$289, { number: unaryMinusNumber, "Complex | BigNumber | Fraction": (t5) => t5.neg(), bigint: (t5) => -t5, Unit: n2.referToSelf((t5) => (r2) => {
    var i2 = r2.clone();
    return i2.value = n2.find(t5, i2.valueType())(r2.value), i2;
  }), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)) });
}), name$288 = `unaryPlus`, dependencies$288 = [`typed`, `config`, `numeric`], createUnaryPlus = factory(name$288, dependencies$288, (t4) => {
  var { typed: n2, config: r2, numeric: i2 } = t4;
  return n2(name$288, { number: unaryPlusNumber, Complex: function(t5) {
    return t5;
  }, BigNumber: function(t5) {
    return t5;
  }, bigint: function(t5) {
    return t5;
  }, Fraction: function(t5) {
    return t5;
  }, Unit: function(t5) {
    return t5.clone();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), boolean: function(t5) {
    return i2(+!!t5, r2.number);
  }, string: function(t5) {
    return i2(t5, safeNumberType(t5, r2));
  } });
}), name$287 = `abs`, dependencies$287 = [`typed`], createAbs = factory(name$287, dependencies$287, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$287, { number: absNumber, "Complex | BigNumber | Fraction | Unit": (t5) => t5.abs(), bigint: (t5) => t5 < 0n ? -t5 : t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)) });
}), name$286 = `mapSlices`, dependencies$286 = [`typed`, `isInteger`], createMapSlices = factory(name$286, dependencies$286, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$286, { "Array | Matrix, number | BigNumber, function": function(t5, n3, i2) {
    if (!r2(n3)) throw TypeError(`Integer number expected for dimension`);
    var a2 = Array.isArray(t5) ? arraySize(t5) : t5.size();
    if (n3 < 0 || n3 >= a2.length) throw new IndexError(n3, a2.length);
    return isMatrix(t5) ? t5.create(_mapSlices(t5.valueOf(), n3, i2), t5.datatype()) : _mapSlices(t5, n3, i2);
  } });
}, { formerly: `apply` });
function _mapSlices(t4, n2, r2) {
  var i2, a2, o2;
  if (n2 <= 0) if (Array.isArray(t4[0])) {
    for (o2 = _switch(t4), a2 = [], i2 = 0; i2 < o2.length; i2++) a2[i2] = _mapSlices(o2[i2], n2 - 1, r2);
    return a2;
  } else return r2(t4);
  else {
    for (a2 = [], i2 = 0; i2 < t4.length; i2++) a2[i2] = _mapSlices(t4[i2], n2 - 1, r2);
    return a2;
  }
}
function _switch(t4) {
  var n2 = t4.length, r2 = t4[0].length, i2, a2, o2 = [];
  for (a2 = 0; a2 < r2; a2++) {
    var s2 = [];
    for (i2 = 0; i2 < n2; i2++) s2.push(t4[i2][a2]);
    o2.push(s2);
  }
  return o2;
}
var name$285 = `addScalar`, dependencies$285 = [`typed`], createAddScalar = factory(name$285, dependencies$285, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$285, { "number, number": addNumber, "Complex, Complex": function(t5, n3) {
    return t5.add(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.plus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 + n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.add(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$284 = `subtractScalar`, dependencies$284 = [`typed`], createSubtractScalar = factory(name$284, dependencies$284, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$284, { "number, number": subtractNumber, "Complex, Complex": function(t5, n3) {
    return t5.sub(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.minus(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 - n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.sub(n3);
  }, "Unit, Unit": n2.referToSelf((t5) => (r2, i2) => {
    if (r2.value === null || r2.value === void 0) throw Error(`Parameter x contains a unit with undefined value`);
    if (i2.value === null || i2.value === void 0) throw Error(`Parameter y contains a unit with undefined value`);
    if (!r2.equalBase(i2)) throw Error(`Units do not match`);
    var a2 = r2.clone();
    return a2.value = n2.find(t5, [a2.valueType(), i2.valueType()])(a2.value, i2.value), a2.fixPrefix = false, a2;
  }) });
}), name$283 = `cbrt`, dependencies$283 = [`config`, `typed`, `isNegative`, `unaryMinus`, `matrix`, `Complex`, `BigNumber`, `Fraction`], createCbrt = factory(name$283, dependencies$283, (t4) => {
  var { config: n2, typed: r2, isNegative: i2, unaryMinus: a2, matrix: o2, Complex: s2, BigNumber: c2, Fraction: l2 } = t4;
  return r2(name$283, { number: cbrtNumber, Complex: u2, "Complex, boolean": u2, BigNumber: function(t5) {
    return t5.cbrt();
  }, Unit: d2 });
  function u2(t5, r3) {
    var i3 = t5.arg() / 3, a3 = t5.abs(), c3 = new s2(cbrtNumber(a3), 0).mul(new s2(0, i3).exp());
    if (r3) {
      var l3 = [c3, new s2(cbrtNumber(a3), 0).mul(new s2(0, i3 + Math.PI * 2 / 3).exp()), new s2(cbrtNumber(a3), 0).mul(new s2(0, i3 - Math.PI * 2 / 3).exp())];
      return n2.matrix === `Array` ? l3 : o2(l3);
    } else return c3;
  }
  function d2(t5) {
    if (t5.value && isComplex(t5.value)) {
      var n3 = t5.clone();
      return n3.value = 1, n3 = n3.pow(1 / 3), n3.value = u2(t5.value), n3;
    } else {
      var r3 = i2(t5.value);
      r3 && (t5.value = a2(t5.value));
      var o3 = isBigNumber(t5.value) ? new c2(1).div(3) : isFraction(t5.value) ? new l2(1, 3) : 1 / 3, s3 = t5.pow(o3);
      return r3 && (s3.value = a2(s3.value)), s3;
    }
  }
}), name$282 = `matAlgo11xS0s`, dependencies$282 = [`typed`, `equalScalar`], createMatAlgo11xS0s = factory(name$282, dependencies$282, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof d2 == `string` && (h2 = d2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), i2 = n2.convert(i2, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = [], x2 = [], S2 = [], w2 = 0; w2 < m2; w2++) {
      S2[w2] = x2.length;
      for (var E = l2[w2], D = l2[w2 + 1], O2 = E; O2 < D; O2++) {
        var j2 = c2[O2], M2 = o2 ? y2(i2, s2[O2]) : y2(s2[O2], i2);
        g2(M2, v2) || (x2.push(j2), b2.push(M2));
      }
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: h2 });
  };
}), name$281 = `matAlgo12xSfs`, dependencies$281 = [`typed`, `DenseMatrix`], createMatAlgo12xSfs = factory(name$281, dependencies$281, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = o2 ? g2(i2, 0) : g2(0, i2);
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
}), name$280 = `matAlgo14xDs`, dependencies$280 = [`typed`], createMatAlgo14xDs = factory(name$280, dependencies$280, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype, u2, d2 = a2;
    typeof l2 == `string` && (u2 = l2, i2 = n2.convert(i2, u2), d2 = n2.find(a2, [u2, u2]));
    var p2 = c2.length > 0 ? r2(d2, 0, c2, c2[0], s2, i2, o2) : [];
    return t5.createDenseMatrix({ data: p2, size: clone$3(c2), datatype: u2 });
  };
  function r2(t5, n3, i2, a2, o2, s2, c2) {
    var l2 = [];
    if (n3 === i2.length - 1) for (var u2 = 0; u2 < a2; u2++) l2[u2] = c2 ? t5(s2, o2[u2]) : t5(o2[u2], s2);
    else for (var d2 = 0; d2 < a2; d2++) l2[d2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[d2], s2, c2);
    return l2;
  }
}), name$279 = `ceil`, dependencies$279 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen$1 = new Decimal(10), createCeilNumber = factory(name$279, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.ceil(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$279, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger(n3)) throw RangeError(`number of decimals in function ceil must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in ceil number must be in range 0-15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createCeil = factory(name$279, dependencies$279, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs({ typed: n2 }), p2 = createCeilNumber({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual(t6, n4, r2.relTol, r2.absTol), a3 = t5.ceil(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`ceil`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.ceil();
  }, "Complex, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen$1.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.ceil();
  }, "Fraction, number": function(t5, n3) {
    return t5.ceil(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.ceil(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$278 = `cube`, dependencies$278 = [`typed`], createCube = factory(name$278, dependencies$278, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$278, { number: cubeNumber, Complex: function(t5) {
    return t5.mul(t5).mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5).times(t5);
  }, bigint: function(t5) {
    return t5 * t5 * t5;
  }, Fraction: function(t5) {
    return t5.pow(3);
  }, Unit: function(t5) {
    return t5.pow(3);
  } });
}), name$277 = `exp`, dependencies$277 = [`typed`], createExp = factory(name$277, dependencies$277, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$277, { number: expNumber, Complex: function(t5) {
    return t5.exp();
  }, BigNumber: function(t5) {
    return t5.exp();
  } });
}), name$276 = `expm1`, dependencies$276 = [`typed`, `Complex`], createExpm1 = factory(name$276, dependencies$276, (t4) => {
  var { typed: n2, Complex: r2 } = t4;
  return n2(name$276, { number: expm1Number, Complex: function(t5) {
    var n3 = Math.exp(t5.re);
    return new r2(n3 * Math.cos(t5.im) - 1, n3 * Math.sin(t5.im));
  }, BigNumber: function(t5) {
    return t5.exp().minus(1);
  } });
}), name$275 = `fix`, dependencies$275 = [`typed`, `Complex`, `matrix`, `ceil`, `floor`, `equalScalar`, `zeros`, `DenseMatrix`], createFixNumber = factory(name$275, [`typed`, `ceil`, `floor`], (t4) => {
  var { typed: n2, ceil: r2, floor: i2 } = t4;
  return n2(name$275, { number: function(t5) {
    return t5 > 0 ? i2(t5) : r2(t5);
  }, "number, number": function(t5, n3) {
    return t5 > 0 ? i2(t5, n3) : r2(t5, n3);
  } });
}), createFix = factory(name$275, dependencies$275, (t4) => {
  var { typed: n2, Complex: r2, matrix: i2, ceil: a2, floor: o2, equalScalar: s2, zeros: c2, DenseMatrix: l2 } = t4, u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: l2 }), d2 = createMatAlgo14xDs({ typed: n2 }), p2 = createFixNumber({ typed: n2, ceil: a2, floor: o2 });
  return n2(`fix`, { number: p2.signatures.number, "number, number | BigNumber": p2.signatures[`number,number`], Complex: function(t5) {
    return new r2(t5.re > 0 ? Math.floor(t5.re) : Math.ceil(t5.re), t5.im > 0 ? Math.floor(t5.im) : Math.ceil(t5.im));
  }, "Complex, number": function(t5, n3) {
    return new r2(t5.re > 0 ? o2(t5.re, n3) : a2(t5.re, n3), t5.im > 0 ? o2(t5.im, n3) : a2(t5.im, n3));
  }, "Complex, BigNumber": function(t5, n3) {
    var i3 = n3.toNumber();
    return new r2(t5.re > 0 ? o2(t5.re, i3) : a2(t5.re, i3), t5.im > 0 ? o2(t5.im, i3) : a2(t5.im, i3));
  }, BigNumber: function(t5) {
    return t5.isNegative() ? a2(t5) : o2(t5);
  }, "BigNumber, number | BigNumber": function(t5, n3) {
    return t5.isNegative() ? a2(t5, n3) : o2(t5, n3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.s < 0n ? t5.ceil() : t5.floor();
  }, "Fraction, number | BigNumber": function(t5, n3) {
    return t5.s < 0n ? a2(t5, n3) : o2(t5, n3);
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), "Array | Matrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap(n3, (n4) => t5(n4, r3), true)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, 0) ? c2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$274 = `floor`, dependencies$274 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`], bigTen = new Decimal(10), createFloorNumber = factory(name$274, [`typed`, `config`, `round`], (t4) => {
  var { typed: n2, config: r2, round: i2 } = t4;
  function a2(t5) {
    var n3 = Math.floor(t5), a3 = i2(t5);
    return n3 === a3 ? n3 : nearlyEqual$1(t5, a3, r2.relTol, r2.absTol) && !nearlyEqual$1(t5, n3, r2.relTol, r2.absTol) ? a3 : n3;
  }
  return n2(name$274, { number: a2, "number, number": function(t5, n3) {
    if (!isInteger(n3)) throw RangeError(`number of decimals in function floor must be an integer`);
    if (n3 < 0 || n3 > 15) throw RangeError(`number of decimals in floor number must be in range 0 - 15`);
    var r3 = 10 ** n3;
    return a2(t5 * r3) / r3;
  } });
}), createFloor = factory(name$274, dependencies$274, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s({ typed: n2, equalScalar: o2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs({ typed: n2 }), p2 = createFloorNumber({ typed: n2, config: r2, round: i2 });
  function m2(t5) {
    var n3 = (t6, n4) => nearlyEqual(t6, n4, r2.relTol, r2.absTol), a3 = t5.floor(), o3 = i2(t5);
    return a3.eq(o3) ? a3 : n3(t5, o3) && !n3(t5, a3) ? o3 : a3;
  }
  return n2(`floor`, { number: p2.signatures.number, "number,number": p2.signatures[`number,number`], Complex: function(t5) {
    return t5.floor();
  }, "Complex, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, BigNumber: m2, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = bigTen.pow(n3);
    return m2(t5.mul(r3)).div(r3);
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.floor();
  }, "Fraction, number": function(t5, n3) {
    return t5.floor(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    return t5.floor(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => deepMap(n3, (n4) => t5(n4, r3), true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "number | Complex | Fraction | BigNumber, Array": n2.referToSelf((t5) => (n3, r3) => d2(a2(r3), n3, t5, true).valueOf()), "number | Complex | Fraction | BigNumber, Matrix": n2.referToSelf((t5) => (n3, r3) => o2(n3, 0) ? s2(r3.size(), r3.storage()) : r3.storage() === `dense` ? d2(r3, n3, t5, true) : u2(r3, n3, t5, true)) });
}), name$273 = `matAlgo02xDS0`, dependencies$273 = [`typed`, `equalScalar`], createMatAlgo02xDS0 = factory(name$273, dependencies$273, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._data, c2 = t5._size, l2 = t5._datatype || t5.getDataType(), u2 = i2._values, d2 = i2._index, p2 = i2._ptr, m2 = i2._size, h2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (c2.length !== m2.length) throw new DimensionError(c2.length, m2.length);
    if (c2[0] !== m2[0] || c2[1] !== m2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + c2 + `) must match Matrix B (` + m2 + `)`);
    if (!u2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var g2 = c2[0], v2 = c2[1], y2, b2 = r2, x2 = 0, S2 = a2;
    typeof l2 == `string` && l2 === h2 && l2 !== `mixed` && (y2 = l2, b2 = n2.find(r2, [y2, y2]), x2 = n2.convert(0, y2), S2 = n2.find(a2, [y2, y2]));
    for (var w2 = [], E = [], D = [], O2 = 0; O2 < v2; O2++) {
      D[O2] = E.length;
      for (var j2 = p2[O2], M2 = p2[O2 + 1], N2 = j2; N2 < M2; N2++) {
        var F = d2[N2], I2 = o2 ? S2(u2[N2], s2[F][O2]) : S2(s2[F][O2], u2[N2]);
        b2(I2, x2) || (E.push(F), w2.push(I2));
      }
    }
    return D[v2] = E.length, i2.createSparseMatrix({ values: w2, index: E, ptr: D, size: [g2, v2], datatype: l2 === t5._datatype && h2 === i2._datatype ? y2 : void 0 });
  };
}), name$272 = `matAlgo03xDSf`, dependencies$272 = [`typed`], createMatAlgo03xDSf = factory(name$272, dependencies$272, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2, y2 = 0, b2 = i2;
    typeof c2 == `string` && c2 === m2 && c2 !== `mixed` && (v2 = c2, y2 = n2.convert(0, v2), b2 = n2.find(i2, [v2, v2]));
    for (var x2 = [], S2 = 0; S2 < h2; S2++) x2[S2] = [];
    for (var w2 = [], E = [], D = 0; D < g2; D++) {
      for (var O2 = D + 1, j2 = d2[D], M2 = d2[D + 1], N2 = j2; N2 < M2; N2++) {
        var F = u2[N2];
        w2[F] = a2 ? b2(l2[N2], o2[F][D]) : b2(o2[F][D], l2[N2]), E[F] = O2;
      }
      for (var I2 = 0; I2 < h2; I2++) E[I2] === O2 ? x2[I2][D] = w2[I2] : x2[I2][D] = a2 ? b2(y2, o2[I2][D]) : b2(o2[I2][D], y2);
    }
    return t5.createDenseMatrix({ data: x2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$271 = `matAlgo05xSfSf`, dependencies$271 = [`typed`, `equalScalar`], createMatAlgo05xSfSf = factory(name$271, dependencies$271, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = E ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var V2 = L2 + 1;
      for (R2 = c2[L2], z2 = c2[L2 + 1]; R2 < z2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = V2, j2 && (j2[I2] = o2[R2]);
      for (R2 = m2[L2], z2 = m2[L2 + 1]; R2 < z2; R2++) I2 = p2[R2], N2[I2] !== V2 && D.push(I2), F[I2] = V2, M2 && (M2[I2] = d2[R2]);
      if (E) for (R2 = O2[L2]; R2 < D.length; ) {
        I2 = D[R2];
        var H2 = N2[I2], U2 = F[I2];
        if (H2 === V2 || U2 === V2) {
          var W2 = H2 === V2 ? j2[I2] : S2, G2 = U2 === V2 ? M2[I2] : S2, K2 = w2(W2, G2);
          x2(K2, S2) ? D.splice(R2, 1) : (E.push(K2), R2++);
        }
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$270 = `matAlgo13xDD`, dependencies$270 = [`typed`], createMatAlgo13xDD = factory(name$270, dependencies$270, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype, l2 = i2._data, u2 = i2._size, d2 = i2._datatype, p2 = [];
    if (s2.length !== u2.length) throw new DimensionError(s2.length, u2.length);
    for (var m2 = 0; m2 < s2.length; m2++) {
      if (s2[m2] !== u2[m2]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
      p2[m2] = s2[m2];
    }
    var h2, g2 = a2;
    typeof c2 == `string` && c2 === d2 && (h2 = c2, g2 = n2.find(a2, [h2, h2]));
    var v2 = p2.length > 0 ? r2(g2, 0, p2, p2[0], o2, l2) : [];
    return t5.createDenseMatrix({ data: v2, size: p2, datatype: h2 });
  };
  function r2(t5, n3, i2, a2, o2, s2) {
    var c2 = [];
    if (n3 === i2.length - 1) for (var l2 = 0; l2 < a2; l2++) c2[l2] = t5(o2[l2], s2[l2]);
    else for (var u2 = 0; u2 < a2; u2++) c2[u2] = r2(t5, n3 + 1, i2, i2[n3 + 1], o2[u2], s2[u2]);
    return c2;
  }
});
function broadcast(t4, n2) {
  if (deepStrictEqual(t4.size(), n2.size())) return [t4, n2];
  var r2 = broadcastSizes(t4.size(), n2.size());
  return [t4, n2].map((t5) => _broadcastTo(t5, r2));
}
function _broadcastTo(t4, n2) {
  return deepStrictEqual(t4.size(), n2) ? t4 : t4.create(broadcastTo(t4.valueOf(), n2), t4.datatype());
}
var name$269 = `matrixAlgorithmSuite`, dependencies$269 = [`typed`, `matrix`], createMatrixAlgorithmSuite = factory(name$269, dependencies$269, (t4) => {
  var { typed: n2, matrix: r2 } = t4, i2 = createMatAlgo13xDD({ typed: n2 }), a2 = createMatAlgo14xDs({ typed: n2 });
  return function(t5) {
    var o2 = t5.elop, s2 = t5.SD || t5.DS, c2;
    o2 ? (c2 = { "DenseMatrix, DenseMatrix": (t6, n3) => i2(...broadcast(t6, n3), o2), "Array, Array": (t6, n3) => i2(...broadcast(r2(t6), r2(n3)), o2).valueOf(), "Array, DenseMatrix": (t6, n3) => i2(...broadcast(r2(t6), n3), o2), "DenseMatrix, Array": (t6, n3) => i2(...broadcast(t6, r2(n3)), o2) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = (n3, r3) => t5.SS(...broadcast(n3, r3), o2, false)), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = (n3, r3) => t5.DS(...broadcast(n3, r3), o2, false), c2[`Array, SparseMatrix`] = (n3, i3) => t5.DS(...broadcast(r2(n3), i3), o2, false)), s2 && (c2[`SparseMatrix, DenseMatrix`] = (t6, n3) => s2(...broadcast(n3, t6), o2, true), c2[`SparseMatrix, Array`] = (t6, n3) => s2(...broadcast(r2(n3), t6), o2, true))) : (c2 = { "DenseMatrix, DenseMatrix": n2.referToSelf((t6) => (n3, r3) => i2(...broadcast(n3, r3), t6)), "Array, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast(r2(n3), r2(a3)), t6).valueOf()), "Array, DenseMatrix": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast(r2(n3), a3), t6)), "DenseMatrix, Array": n2.referToSelf((t6) => (n3, a3) => i2(...broadcast(n3, r2(a3)), t6)) }, t5.SS && (c2[`SparseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.SS(...broadcast(r3, i3), n3, false))), t5.DS && (c2[`DenseMatrix, SparseMatrix`] = n2.referToSelf((n3) => (r3, i3) => t5.DS(...broadcast(r3, i3), n3, false)), c2[`Array, SparseMatrix`] = n2.referToSelf((n3) => (i3, a3) => t5.DS(...broadcast(r2(i3), a3), n3, false))), s2 && (c2[`SparseMatrix, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => s2(...broadcast(r3, n3), t6, true)), c2[`SparseMatrix, Array`] = n2.referToSelf((t6) => (n3, i3) => s2(...broadcast(r2(i3), n3), t6, true))));
    var l2 = t5.scalar || `any`;
    (t5.Ds || t5.Ss) && (o2 ? (c2[`DenseMatrix,` + l2] = (t6, n3) => a2(t6, n3, o2, false), c2[l2 + `, DenseMatrix`] = (t6, n3) => a2(n3, t6, o2, true), c2[`Array,` + l2] = (t6, n3) => a2(r2(t6), n3, o2, false).valueOf(), c2[l2 + `, Array`] = (t6, n3) => a2(r2(n3), t6, o2, true).valueOf()) : (c2[`DenseMatrix,` + l2] = n2.referToSelf((t6) => (n3, r3) => a2(n3, r3, t6, false)), c2[l2 + `, DenseMatrix`] = n2.referToSelf((t6) => (n3, r3) => a2(r3, n3, t6, true)), c2[`Array,` + l2] = n2.referToSelf((t6) => (n3, i3) => a2(r2(n3), i3, t6, false).valueOf()), c2[l2 + `, Array`] = n2.referToSelf((t6) => (n3, i3) => a2(r2(i3), n3, t6, true).valueOf())));
    var u2 = t5.sS === void 0 ? t5.Ss : t5.sS;
    return o2 ? (t5.Ss && (c2[`SparseMatrix,` + l2] = (n3, r3) => t5.Ss(n3, r3, o2, false)), u2 && (c2[l2 + `, SparseMatrix`] = (t6, n3) => u2(n3, t6, o2, true))) : (t5.Ss && (c2[`SparseMatrix,` + l2] = n2.referToSelf((n3) => (r3, i3) => t5.Ss(r3, i3, n3, false))), u2 && (c2[l2 + `, SparseMatrix`] = n2.referToSelf((t6) => (n3, r3) => u2(r3, n3, t6, true)))), o2 && o2.signatures && extend$1(c2, o2.signatures), c2;
  };
}), name$268 = `mod`, dependencies$268 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createMod = factory(name$268, dependencies$268, (t4) => {
  var { typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createFloor({ typed: n2, config: r2, round: i2, matrix: a2, equalScalar: o2, zeros: s2, DenseMatrix: c2 }), d2 = createMatAlgo02xDS0({ typed: n2, equalScalar: o2 }), p2 = createMatAlgo03xDSf({ typed: n2 }), m2 = createMatAlgo05xSfSf({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo11xS0s({ typed: n2, equalScalar: o2 }), g2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: c2 }), v2 = createMatrixAlgorithmSuite({ typed: n2, matrix: a2, concat: l2 });
  return n2(name$268, { "number, number": y2, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isZero() ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  }, "bigint, bigint": function(t5, n3) {
    if (n3 === 0n) return t5;
    if (t5 < 0) {
      var r3 = t5 % n3;
      return r3 === 0n ? r3 : r3 + n3;
    }
    return t5 % n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return n3.equals(0) ? t5 : t5.sub(n3.mul(u2(t5.div(n3))));
  } }, v2({ SS: m2, DS: p2, SD: d2, Ss: h2, sS: g2 }));
  function y2(t5, n3) {
    return n3 === 0 ? t5 : t5 - n3 * u2(t5 / n3);
  }
}), name$267 = `matAlgo01xDSid`, dependencies$267 = [`typed`], createMatAlgo01xDSid = factory(name$267, dependencies$267, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, r2, i2, a2) {
    var o2 = t5._data, s2 = t5._size, c2 = t5._datatype || t5.getDataType(), l2 = r2._values, u2 = r2._index, d2 = r2._ptr, p2 = r2._size, m2 = r2._datatype || r2._data === void 0 ? r2._datatype : r2.getDataType();
    if (s2.length !== p2.length) throw new DimensionError(s2.length, p2.length);
    if (s2[0] !== p2[0] || s2[1] !== p2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + p2 + `)`);
    if (!l2) throw Error(`Cannot perform operation on Dense Matrix and Pattern Sparse Matrix`);
    var h2 = s2[0], g2 = s2[1], v2 = typeof c2 == `string` && c2 !== `mixed` && c2 === m2 ? c2 : void 0, y2 = v2 ? n2.find(i2, [v2, v2]) : i2, b2, x2, S2 = [];
    for (b2 = 0; b2 < h2; b2++) S2[b2] = [];
    var w2 = [], E = [];
    for (x2 = 0; x2 < g2; x2++) {
      for (var D = x2 + 1, O2 = d2[x2], j2 = d2[x2 + 1], M2 = O2; M2 < j2; M2++) b2 = u2[M2], w2[b2] = a2 ? y2(l2[M2], o2[b2][x2]) : y2(o2[b2][x2], l2[M2]), E[b2] = D;
      for (b2 = 0; b2 < h2; b2++) E[b2] === D ? S2[b2][x2] = w2[b2] : S2[b2][x2] = o2[b2][x2];
    }
    return t5.createDenseMatrix({ data: S2, size: [h2, g2], datatype: c2 === t5._datatype && m2 === r2._datatype ? v2 : void 0 });
  };
}), name$266 = `matAlgo04xSidSid`, dependencies$266 = [`typed`, `equalScalar`], createMatAlgo04xSidSid = factory(name$266, dependencies$266, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = o2 && d2 ? [] : void 0, M2 = o2 && d2 ? [] : void 0, N2 = [], F = [], I2, L2, R2, z2, V2;
    for (L2 = 0; L2 < y2; L2++) {
      O2[L2] = D.length;
      var H2 = L2 + 1;
      for (z2 = c2[L2], V2 = c2[L2 + 1], R2 = z2; R2 < V2; R2++) I2 = s2[R2], D.push(I2), N2[I2] = H2, j2 && (j2[I2] = o2[R2]);
      for (z2 = m2[L2], V2 = m2[L2 + 1], R2 = z2; R2 < V2; R2++) if (I2 = p2[R2], N2[I2] === H2) {
        if (j2) {
          var U2 = w2(j2[I2], d2[R2]);
          x2(U2, S2) ? N2[I2] = null : j2[I2] = U2;
        }
      } else D.push(I2), F[I2] = H2, M2 && (M2[I2] = d2[R2]);
      if (j2 && M2) for (R2 = O2[L2]; R2 < D.length; ) I2 = D[R2], N2[I2] === H2 ? (E[R2] = j2[I2], R2++) : F[I2] === H2 ? (E[R2] = M2[I2], R2++) : D.splice(R2, 1);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$265 = `matAlgo10xSids`, dependencies$265 = [`typed`, `DenseMatrix`], createMatAlgo10xSids = factory(name$265, dependencies$265, (t4) => {
  var { typed: n2, DenseMatrix: r2 } = t4;
  return function(t5, i2, a2, o2) {
    var s2 = t5._values, c2 = t5._index, l2 = t5._ptr, u2 = t5._size, d2 = t5._datatype;
    if (!s2) throw Error(`Cannot perform operation on Pattern Sparse Matrix and Scalar value`);
    var p2 = u2[0], m2 = u2[1], h2, g2 = a2;
    typeof d2 == `string` && (h2 = d2, i2 = n2.convert(i2, h2), g2 = n2.find(a2, [h2, h2]));
    for (var v2 = [], y2 = [], b2 = [], x2 = 0; x2 < m2; x2++) {
      for (var S2 = x2 + 1, w2 = l2[x2], E = l2[x2 + 1], D = w2; D < E; D++) {
        var O2 = c2[D];
        y2[O2] = s2[D], b2[O2] = S2;
      }
      for (var j2 = 0; j2 < p2; j2++) x2 === 0 && (v2[j2] = []), b2[j2] === S2 ? v2[j2][x2] = o2 ? g2(i2, y2[j2]) : g2(y2[j2], i2) : v2[j2][x2] = i2;
    }
    return new r2({ data: v2, size: [p2, m2], datatype: h2 });
  };
});
function ArgumentsError(t4, n2, r2, i2) {
  if (!(this instanceof ArgumentsError)) throw SyntaxError(`Constructor must be called with the new operator`);
  this.fn = t4, this.count = n2, this.min = r2, this.max = i2, this.message = `Wrong number of arguments in function ` + t4 + ` (` + n2 + ` provided, ` + r2 + (i2 == null ? `` : `-` + i2) + ` expected)`, this.stack = Error().stack;
}
ArgumentsError.prototype = Error(), ArgumentsError.prototype.constructor = Error, ArgumentsError.prototype.name = `ArgumentsError`, ArgumentsError.prototype.isArgumentsError = true;
var name$264 = `gcd`, dependencies$264 = [`typed`, `config`, `round`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`, `concat`], gcdTypes = `number | BigNumber | Fraction | Matrix | Array`, gcdManyTypesSignature = `${gcdTypes}, ${gcdTypes}, ...${gcdTypes}`;
function is1d(t4) {
  return !t4.some((t5) => Array.isArray(t5));
}
var createGcd = factory(name$264, dependencies$264, (t4) => {
  var { typed: n2, matrix: r2, config: i2, round: a2, equalScalar: o2, zeros: s2, BigNumber: c2, DenseMatrix: l2, concat: u2 } = t4, d2 = createMod({ typed: n2, config: i2, round: a2, matrix: r2, equalScalar: o2, zeros: s2, DenseMatrix: l2, concat: u2 }), p2 = createMatAlgo01xDSid({ typed: n2 }), m2 = createMatAlgo04xSidSid({ typed: n2, equalScalar: o2 }), h2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: l2 }), g2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: u2 });
  return n2(name$264, { "number, number": v2, "BigNumber, BigNumber": y2, "Fraction, Fraction": (t5, n3) => t5.gcd(n3) }, g2({ SS: m2, DS: p2, Ss: h2 }), { [gcdManyTypesSignature]: n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), Array: n2.referToSelf((t5) => (n3) => {
    if (n3.length === 1 && Array.isArray(n3[0]) && is1d(n3[0])) return t5(...n3[0]);
    if (is1d(n3)) return t5(...n3);
    throw new ArgumentsError(`gcd() supports only 1d matrices!`);
  }), Matrix: n2.referToSelf((t5) => (n3) => t5(n3.toArray())) });
  function v2(t5, n3) {
    if (!isInteger(t5) || !isInteger(n3)) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3; n3 !== 0; ) r3 = d2(t5, n3), t5 = n3, n3 = r3;
    return t5 < 0 ? -t5 : t5;
  }
  function y2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function gcd must be integer numbers`);
    for (var r3 = new c2(0); !n3.isZero(); ) {
      var i3 = d2(t5, n3);
      t5 = n3, n3 = i3;
    }
    return t5.lt(r3) ? t5.neg() : t5;
  }
}), name$263 = `matAlgo06xS0S0`, dependencies$263 = [`typed`, `equalScalar`], createMatAlgo06xS0S0 = factory(name$263, dependencies$263, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = i2._values, u2 = i2._size, d2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (s2.length !== u2.length) throw new DimensionError(s2.length, u2.length);
    if (s2[0] !== u2[0] || s2[1] !== u2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + u2 + `)`);
    var p2 = s2[0], m2 = s2[1], h2, g2 = r2, v2 = 0, y2 = a2;
    typeof c2 == `string` && c2 === d2 && c2 !== `mixed` && (h2 = c2, g2 = n2.find(r2, [h2, h2]), v2 = n2.convert(0, h2), y2 = n2.find(a2, [h2, h2]));
    for (var b2 = o2 && l2 ? [] : void 0, x2 = [], S2 = [], w2 = b2 ? [] : void 0, E = [], D = [], O2 = 0; O2 < m2; O2++) {
      S2[O2] = x2.length;
      var j2 = O2 + 1;
      if (scatter(t5, O2, E, w2, D, j2, x2, y2), scatter(i2, O2, E, w2, D, j2, x2, y2), w2) for (var M2 = S2[O2]; M2 < x2.length; ) {
        var N2 = x2[M2];
        if (D[N2] === j2) {
          var F = w2[N2];
          g2(F, v2) ? x2.splice(M2, 1) : (b2.push(F), M2++);
        } else x2.splice(M2, 1);
      }
      else for (var I2 = S2[O2]; I2 < x2.length; ) D[x2[I2]] === j2 ? I2++ : x2.splice(I2, 1);
    }
    return S2[m2] = x2.length, t5.createSparseMatrix({ values: b2, index: x2, ptr: S2, size: [p2, m2], datatype: c2 === t5._datatype && d2 === i2._datatype ? h2 : void 0 });
  };
}), name$262 = `lcm`, dependencies$262 = [`typed`, `matrix`, `equalScalar`, `concat`], createLcm = factory(name$262, dependencies$262, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: a2 }), u2 = `number | BigNumber | Fraction | Matrix | Array`, d2 = {};
  return d2[`${u2}, ${u2}, ...${u2}`] = n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }), n2(name$262, { "number, number": lcmNumber, "BigNumber, BigNumber": p2, "Fraction, Fraction": (t5, n3) => t5.lcm(n3) }, l2({ SS: s2, DS: o2, Ss: c2 }), d2);
  function p2(t5, n3) {
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function lcm must be integer numbers`);
    if (t5.isZero()) return t5;
    if (n3.isZero()) return n3;
    for (var r3 = t5.times(n3); !n3.isZero(); ) {
      var i3 = n3;
      n3 = t5.mod(i3), t5 = i3;
    }
    return r3.div(t5).abs();
  }
});
function promoteLogarithm(t4, n2, r2, i2) {
  return function(a2) {
    if (a2 > 0 || r2.predictable) {
      if (a2 <= 0) return NaN;
      var o2 = a2.toString(16), s2 = o2.substring(0, 15);
      return t4 * (o2.length - s2.length) + n2(Number(`0x` + s2));
    }
    return i2(a2.toNumber());
  };
}
var name$261 = `log10`, dependencies$261 = [`typed`, `config`, `Complex`], log16 = log10Number(16), createLog10 = factory(name$261, dependencies$261, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return t5.log().div(Math.LN10);
  }
  function o2(t5) {
    return a2(new i2(t5, 0));
  }
  return n2(name$261, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log10Number(t5) : o2(t5);
  }, bigint: promoteLogarithm(log16, log10Number, r2, o2), Complex: a2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log() : o2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$260 = `log2`, dependencies$260 = [`typed`, `config`, `Complex`], createLog2 = factory(name$260, dependencies$260, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  function a2(t5) {
    return o2(new i2(t5, 0));
  }
  return n2(name$260, { number: function(t5) {
    return t5 >= 0 || r2.predictable ? log2Number(t5) : a2(t5);
  }, bigint: promoteLogarithm(4, log2Number, r2, a2), Complex: o2, BigNumber: function(t5) {
    return !t5.isNegative() || r2.predictable ? t5.log(2) : a2(t5.toNumber());
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
  function o2(t5) {
    var n3 = Math.sqrt(t5.re * t5.re + t5.im * t5.im);
    return new i2(Math.log2 ? Math.log2(n3) : Math.log(n3) / Math.LN2, Math.atan2(t5.im, t5.re) / Math.LN2);
  }
}), name$259 = `multiplyScalar`, dependencies$259 = [`typed`], createMultiplyScalar = factory(name$259, dependencies$259, (t4) => {
  var { typed: n2 } = t4;
  return n2(`multiplyScalar`, { "number, number": multiplyNumber, "Complex, Complex": function(t5, n3) {
    return t5.mul(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.times(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 * n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.mul(n3);
  }, "number | Fraction | BigNumber | Complex, Unit": (t5, n3) => n3.multiply(t5), "Unit, number | Fraction | BigNumber | Complex | Unit": (t5, n3) => t5.multiply(n3) });
}), name$258 = `multiply`, dependencies$258 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `equalScalar`, `dot`], createMultiply = factory(name$258, dependencies$258, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, equalScalar: o2, dot: s2 } = t4, c2 = createMatAlgo11xS0s({ typed: n2, equalScalar: o2 }), l2 = createMatAlgo14xDs({ typed: n2 });
  function u2(t5, n3) {
    switch (t5.length) {
      case 1:
        switch (n3.length) {
          case 1:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vectors must have the same length`);
            break;
          case 2:
            if (t5[0] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Vector length (` + t5[0] + `) must match Matrix rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      case 2:
        switch (n3.length) {
          case 1:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix columns (` + t5[1] + `) must match Vector length (` + n3[0] + `)`);
            break;
          case 2:
            if (t5[1] !== n3[0]) throw RangeError(`Dimension mismatch in multiplication. Matrix A columns (` + t5[1] + `) must match Matrix B rows (` + n3[0] + `)`);
            break;
          default:
            throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix B has ` + n3.length + ` dimensions)`);
        }
        break;
      default:
        throw Error(`Can only multiply a 1 or 2 dimensional matrix (Matrix A has ` + t5.length + ` dimensions)`);
    }
  }
  function d2(t5, n3, r3) {
    if (r3 === 0) throw Error(`Cannot multiply two empty vectors`);
    return s2(t5, n3);
  }
  function p2(t5, n3) {
    if (n3.storage() !== `dense`) throw Error(`Support for SparseMatrix not implemented`);
    return m2(t5, n3);
  }
  function m2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = u3[1], h3, g3 = i2, v3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && (h3 = c3, g3 = n2.find(i2, [h3, h3]), v3 = n2.find(a2, [h3, h3]));
    for (var y3 = [], b3 = 0; b3 < m3; b3++) {
      for (var x3 = v3(o3[0], l3[0][b3]), S3 = 1; S3 < p3; S3++) x3 = g3(x3, v3(o3[S3], l3[S3][b3]));
      y3[b3] = x3;
    }
    return t5.createDenseMatrix({ data: y3, size: [m3], datatype: c3 === t5._datatype && d3 === r3._datatype ? h3 : void 0 });
  }
  var h2 = n2(`_multiplyMatrixVector`, { "DenseMatrix, any": v2, "SparseMatrix, any": x2 }), g2 = n2(`_multiplyMatrixMatrix`, { "DenseMatrix, DenseMatrix": y2, "DenseMatrix, SparseMatrix": b2, "SparseMatrix, DenseMatrix": S2, "SparseMatrix, SparseMatrix": w2 });
  function v2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._datatype || r3.getDataType(), d3 = s3[0], p3 = s3[1], m3, h3 = i2, g3 = a2;
    c3 && u3 && c3 === u3 && typeof c3 == `string` && c3 !== `mixed` && (m3 = c3, h3 = n2.find(i2, [m3, m3]), g3 = n2.find(a2, [m3, m3]));
    for (var v3 = [], y3 = 0; y3 < d3; y3++) {
      for (var b3 = o3[y3], x3 = g3(b3[0], l3[0]), S3 = 1; S3 < p3; S3++) x3 = h3(x3, g3(b3[S3], l3[S3]));
      v3[y3] = x3;
    }
    return t5.createDenseMatrix({ data: v3, size: [d3], datatype: c3 === t5._datatype && u3 === r3._datatype ? m3 : void 0 });
  }
  function y2(t5, r3) {
    var o3 = t5._data, s3 = t5._size, c3 = t5._datatype || t5.getDataType(), l3 = r3._data, u3 = r3._size, d3 = r3._datatype || r3.getDataType(), p3 = s3[0], m3 = s3[1], h3 = u3[1], g3, v3 = i2, y3 = a2;
    c3 && d3 && c3 === d3 && typeof c3 == `string` && c3 !== `mixed` && c3 !== `mixed` && (g3 = c3, v3 = n2.find(i2, [g3, g3]), y3 = n2.find(a2, [g3, g3]));
    for (var b3 = [], x3 = 0; x3 < p3; x3++) {
      var S3 = o3[x3];
      b3[x3] = [];
      for (var w3 = 0; w3 < h3; w3++) {
        for (var E = y3(S3[0], l3[0][w3]), D = 1; D < m3; D++) E = v3(E, y3(S3[D], l3[D][w3]));
        b3[x3][w3] = E;
      }
    }
    return t5.createDenseMatrix({ data: b3, size: [p3, h3], datatype: c3 === t5._datatype && d3 === r3._datatype ? g3 : void 0 });
  }
  function b2(t5, r3) {
    var s3 = t5._data, c3 = t5._size, l3 = t5._datatype || t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._size, h3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType();
    if (!u3) throw Error(`Cannot multiply Dense Matrix times Pattern only Matrix`);
    var g3 = c3[0], v3 = m3[1], y3, b3 = i2, x3 = a2, S3 = o2, w3 = 0;
    l3 && h3 && l3 === h3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]), S3 = n2.find(o2, [y3, y3]), w3 = n2.convert(0, y3));
    for (var E = [], D = [], O2 = [], j2 = r3.createSparseMatrix({ values: E, index: D, ptr: O2, size: [g3, v3], datatype: l3 === t5._datatype && h3 === r3._datatype ? y3 : void 0 }), M2 = 0; M2 < v3; M2++) {
      O2[M2] = D.length;
      var N2 = p3[M2], F = p3[M2 + 1];
      if (F > N2) for (var I2 = 0, L2 = 0; L2 < g3; L2++) {
        for (var R2 = L2 + 1, z2 = void 0, V2 = N2; V2 < F; V2++) {
          var H2 = d3[V2];
          I2 === R2 ? z2 = b3(z2, x3(s3[L2][H2], u3[V2])) : (z2 = x3(s3[L2][H2], u3[V2]), I2 = R2);
        }
        I2 === R2 && !S3(z2, w3) && (D.push(L2), E.push(z2));
      }
    }
    return O2[v3] = D.length, j2;
  }
  function x2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = [], v3 = [], y3 = [], b3, x3 = i2, S3 = a2, w3 = o2, E = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (b3 = u3, x3 = n2.find(i2, [b3, b3]), S3 = n2.find(a2, [b3, b3]), w3 = n2.find(o2, [b3, b3]), E = n2.convert(0, b3));
    var D = [], O2 = [];
    y3[0] = 0;
    for (var j2 = 0; j2 < h3; j2++) {
      var M2 = d3[j2];
      if (!w3(M2, E)) for (var N2 = l3[j2], F = l3[j2 + 1], I2 = N2; I2 < F; I2++) {
        var L2 = c3[I2];
        O2[L2] ? D[L2] = x3(D[L2], S3(M2, s3[I2])) : (O2[L2] = true, v3.push(L2), D[L2] = S3(M2, s3[I2]));
      }
    }
    for (var R2 = v3.length, z2 = 0; z2 < R2; z2++) g3[z2] = D[v3[z2]];
    return y3[1] = v3.length, t5.createSparseMatrix({ values: g3, index: v3, ptr: y3, size: [m3, 1], datatype: u3 === t5._datatype && p3 === r3._datatype ? b3 : void 0 });
  }
  function S2(t5, r3) {
    var s3 = t5._values, c3 = t5._index, l3 = t5._ptr, u3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType();
    if (!s3) throw Error(`Cannot multiply Pattern only Matrix times Dense Matrix`);
    var d3 = r3._data, p3 = r3._datatype || r3.getDataType(), m3 = t5._size[0], h3 = r3._size[0], g3 = r3._size[1], v3, y3 = i2, b3 = a2, x3 = o2, S3 = 0;
    u3 && p3 && u3 === p3 && typeof u3 == `string` && u3 !== `mixed` && (v3 = u3, y3 = n2.find(i2, [v3, v3]), b3 = n2.find(a2, [v3, v3]), x3 = n2.find(o2, [v3, v3]), S3 = n2.convert(0, v3));
    for (var w3 = [], E = [], D = [], O2 = t5.createSparseMatrix({ values: w3, index: E, ptr: D, size: [m3, g3], datatype: u3 === t5._datatype && p3 === r3._datatype ? v3 : void 0 }), j2 = [], M2 = [], N2 = 0; N2 < g3; N2++) {
      D[N2] = E.length;
      for (var F = N2 + 1, I2 = 0; I2 < h3; I2++) {
        var L2 = d3[I2][N2];
        if (!x3(L2, S3)) for (var R2 = l3[I2], z2 = l3[I2 + 1], V2 = R2; V2 < z2; V2++) {
          var H2 = c3[V2];
          M2[H2] === F ? j2[H2] = y3(j2[H2], b3(L2, s3[V2])) : (M2[H2] = F, E.push(H2), j2[H2] = b3(L2, s3[V2]));
        }
      }
      for (var U2 = D[N2], W2 = E.length, G2 = U2; G2 < W2; G2++) w3[G2] = j2[E[G2]];
    }
    return D[g3] = E.length, O2;
  }
  function w2(t5, r3) {
    var o3 = t5._values, s3 = t5._index, c3 = t5._ptr, l3 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), u3 = r3._values, d3 = r3._index, p3 = r3._ptr, m3 = r3._datatype || r3._data === void 0 ? r3._datatype : r3.getDataType(), h3 = t5._size[0], g3 = r3._size[1], v3 = o3 && u3, y3, b3 = i2, x3 = a2;
    l3 && m3 && l3 === m3 && typeof l3 == `string` && l3 !== `mixed` && (y3 = l3, b3 = n2.find(i2, [y3, y3]), x3 = n2.find(a2, [y3, y3]));
    for (var S3 = v3 ? [] : void 0, w3 = [], E = [], D = t5.createSparseMatrix({ values: S3, index: w3, ptr: E, size: [h3, g3], datatype: l3 === t5._datatype && m3 === r3._datatype ? y3 : void 0 }), O2 = v3 ? [] : void 0, j2 = [], M2, N2, F, I2, L2, R2, z2, V2, H2 = 0; H2 < g3; H2++) {
      E[H2] = w3.length;
      var U2 = H2 + 1;
      for (L2 = p3[H2], R2 = p3[H2 + 1], I2 = L2; I2 < R2; I2++) if (V2 = d3[I2], v3) for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] === U2 ? O2[z2] = b3(O2[z2], x3(u3[I2], o3[M2])) : (j2[z2] = U2, w3.push(z2), O2[z2] = x3(u3[I2], o3[M2]));
      else for (N2 = c3[V2], F = c3[V2 + 1], M2 = N2; M2 < F; M2++) z2 = s3[M2], j2[z2] !== U2 && (j2[z2] = U2, w3.push(z2));
      if (v3) for (var W2 = E[H2], G2 = w3.length, K2 = W2; K2 < G2; K2++) S3[K2] = O2[w3[K2]];
    }
    return E[g3] = w3.length, D;
  }
  return n2(name$258, a2, { "Array, Array": n2.referTo(`Matrix, Matrix`, (t5) => (n3, i3) => {
    u2(arraySize(n3), arraySize(i3));
    var a3 = t5(r2(n3), r2(i3));
    return isMatrix(a3) ? a3.valueOf() : a3;
  }), "Matrix, Matrix": function(t5, n3) {
    var r3 = t5.size(), i3 = n3.size();
    return u2(r3, i3), r3.length === 1 ? i3.length === 1 ? d2(t5, n3, r3[0]) : p2(t5, n3) : i3.length === 1 ? h2(t5, n3) : g2(t5, n3);
  }, "Matrix, Array": n2.referTo(`Matrix,Matrix`, (t5) => (n3, i3) => t5(n3, r2(i3))), "Array, Matrix": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3, i3.storage()), i3)), "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, a2, false);
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, a2, false);
  }, "any, SparseMatrix": function(t5, n3) {
    return c2(n3, t5, a2, true);
  }, "any, DenseMatrix": function(t5, n3) {
    return l2(n3, t5, a2, true);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, a2, false).valueOf();
  }, "any, Array": function(t5, n3) {
    return l2(r2(n3), t5, a2, true).valueOf();
  }, "any, any": a2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) });
}), name$257 = `nthRoot`, dependencies$257 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `concat`], createNthRoot = factory(name$257, dependencies$257, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid({ typed: n2 }), c2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), d2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: o2 });
  function p2() {
    throw Error(`Complex number not supported in function nthRoot. Use nthRoots instead.`);
  }
  return n2(name$257, { number: nthRootNumber, "number, number": nthRootNumber, BigNumber: (t5) => m2(t5, new a2(2)), "BigNumber, BigNumber": m2, Complex: p2, "Complex, number": p2, Array: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(r2(n3), 2).valueOf()), DenseMatrix: n2.referTo(`DenseMatrix,number`, (t5) => (n3) => t5(n3, 2)), SparseMatrix: n2.referTo(`SparseMatrix,number`, (t5) => (n3) => t5(n3, 2)), "SparseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return l2(n3, r3, t5);
    throw Error(`Root must be non-zero`);
  }), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return s2(n3, r3, t5, false);
    throw Error(`Root must be non-zero`);
  }), "Array, SparseMatrix": n2.referTo(`DenseMatrix,SparseMatrix`, (t5) => (n3, i3) => t5(r2(n3), i3)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => {
    if (r3.density() === 1) return u2(r3, n3, t5, true);
    throw Error(`Root must be non-zero`);
  }) }, d2({ scalar: `number | BigNumber`, SD: c2, Ss: u2, sS: false }));
  function m2(t5, n3) {
    var r3 = a2.precision, i3 = a2.clone({ precision: r3 + 2 }), o3 = new a2(0), s3 = new i3(1), c3 = n3.isNegative();
    if (c3 && (n3 = n3.neg()), n3.isZero()) throw Error(`Root must be non-zero`);
    if (t5.isNegative() && !n3.abs().mod(2).equals(1)) throw Error(`Root must be odd when a is negative.`);
    if (t5.isZero()) return c3 ? new i3(1 / 0) : 0;
    if (!t5.isFinite()) return c3 ? o3 : t5;
    var l3 = t5.abs().pow(s3.div(n3));
    return l3 = t5.isNeg() ? l3.neg() : l3, new a2((c3 ? s3.div(l3) : l3).toPrecision(r3));
  }
}), name$256 = `sign`, dependencies$256 = [`typed`, `BigNumber`, `Fraction`, `complex`], createSign = factory(name$256, dependencies$256, (t4) => {
  var { typed: n2, BigNumber: r2, complex: i2, Fraction: a2 } = t4;
  return n2(name$256, { number: signNumber, Complex: function(t5) {
    return t5.im === 0 ? i2(signNumber(t5.re)) : t5.sign();
  }, BigNumber: function(t5) {
    return new r2(t5.cmp(0));
  }, bigint: function(t5) {
    return t5 > 0n ? 1n : t5 < 0n ? -1n : 0n;
  }, Fraction: function(t5) {
    return t5.n === 0n ? new a2(0) : new a2(t5.s);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), Unit: n2.referToSelf((t5) => (r3) => {
    if (!r3._isDerived() && r3.units[0].unit.offset !== 0) throw TypeError(`sign is ambiguous for units with offset`);
    return n2.find(t5, r3.valueType())(r3.value);
  }) });
}), name$255 = `sqrt`, dependencies$255 = [`config`, `typed`, `Complex`], createSqrt = factory(name$255, dependencies$255, (t4) => {
  var { config: n2, typed: r2, Complex: i2 } = t4;
  return r2(`sqrt`, { number: a2, Complex: function(t5) {
    return t5.sqrt();
  }, BigNumber: function(t5) {
    return !t5.isNegative() || n2.predictable ? t5.sqrt() : a2(t5.toNumber());
  }, Unit: function(t5) {
    return t5.pow(0.5);
  } });
  function a2(t5) {
    return isNaN(t5) ? NaN : t5 >= 0 || n2.predictable ? Math.sqrt(t5) : new i2(t5, 0).sqrt();
  }
}), name$254 = `square`, dependencies$254 = [`typed`], createSquare = factory(name$254, dependencies$254, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$254, { number: squareNumber, Complex: function(t5) {
    return t5.mul(t5);
  }, BigNumber: function(t5) {
    return t5.times(t5);
  }, bigint: function(t5) {
    return t5 * t5;
  }, Fraction: function(t5) {
    return t5.mul(t5);
  }, Unit: function(t5) {
    return t5.pow(2);
  } });
}), name$253 = `subtract`, dependencies$253 = [`typed`, `matrix`, `equalScalar`, `subtractScalar`, `unaryMinus`, `DenseMatrix`, `concat`], createSubtract = factory(name$253, dependencies$253, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, subtractScalar: a2, unaryMinus: o2, DenseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid({ typed: n2 }), u2 = createMatAlgo03xDSf({ typed: n2 }), d2 = createMatAlgo05xSfSf({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: s2 }), m2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: s2 }), h2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$253, { "any, any": a2 }, h2({ elop: a2, SS: d2, DS: l2, SD: u2, Ss: m2, sS: p2 }));
}), name$252 = `xgcd`, dependencies$252 = [`typed`, `config`, `matrix`, `BigNumber`], createXgcd = factory(name$252, dependencies$252, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$252, { "number, number": function(t5, n3) {
    var a3 = xgcdNumber(t5, n3);
    return r2.matrix === `Array` ? a3 : i2(a3);
  }, "BigNumber, BigNumber": o2 });
  function o2(t5, n3) {
    var o3, s2, c2, l2 = new a2(0), u2 = new a2(1), d2 = l2, p2 = u2, m2 = u2, h2 = l2;
    if (!t5.isInt() || !n3.isInt()) throw Error(`Parameters in function xgcd must be integer numbers`);
    for (; !n3.isZero(); ) s2 = t5.div(n3).floor(), c2 = t5.mod(n3), o3 = d2, d2 = p2.minus(s2.times(d2)), p2 = o3, o3 = m2, m2 = h2.minus(s2.times(m2)), h2 = o3, t5 = n3, n3 = c2;
    var g2 = t5.lt(l2) ? [t5.neg(), p2.neg(), h2.neg()] : [t5, t5.isZero() ? 0 : p2, h2];
    return r2.matrix === `Array` ? g2 : i2(g2);
  }
}), name$251 = `invmod`, dependencies$251 = [`typed`, `config`, `BigNumber`, `xgcd`, `equal`, `smaller`, `mod`, `add`, `isInteger`], createInvmod = factory(name$251, dependencies$251, (t4) => {
  var { typed: n2, config: r2, BigNumber: i2, xgcd: a2, equal: o2, smaller: s2, mod: c2, add: l2, isInteger: u2 } = t4;
  return n2(name$251, { "number, number": d2, "BigNumber, BigNumber": d2 });
  function d2(t5, n3) {
    if (!u2(t5) || !u2(n3)) throw Error(`Parameters in function invmod must be integer numbers`);
    if (t5 = c2(t5, n3), o2(n3, 0)) throw Error(`Divisor must be non zero`);
    var r3 = a2(t5, n3);
    r3 = r3.valueOf();
    var [d3, p2] = r3;
    return o2(d3, i2(1)) ? (p2 = c2(p2, n3), s2(p2, i2(0)) && (p2 = l2(p2, n3)), p2) : NaN;
  }
}), name$250 = `matAlgo09xS0Sf`, dependencies$250 = [`typed`, `equalScalar`], createMatAlgo09xS0Sf = factory(name$250, dependencies$250, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    var E = o2 && d2 ? [] : void 0, D = [], O2 = [], j2 = E ? [] : void 0, M2 = [], N2, F, I2, L2, R2;
    for (F = 0; F < y2; F++) {
      O2[F] = D.length;
      var z2 = F + 1;
      if (j2) for (L2 = m2[F], R2 = m2[F + 1], I2 = L2; I2 < R2; I2++) N2 = p2[I2], M2[N2] = z2, j2[N2] = d2[I2];
      for (L2 = c2[F], R2 = c2[F + 1], I2 = L2; I2 < R2; I2++) if (N2 = s2[I2], j2) {
        var V2 = M2[N2] === z2 ? j2[N2] : S2, H2 = w2(o2[I2], V2);
        x2(H2, S2) || (D.push(N2), E.push(H2));
      } else D.push(N2);
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), name$249 = `dotMultiply`, dependencies$249 = [`typed`, `matrix`, `equalScalar`, `multiplyScalar`, `concat`], createDotMultiply = factory(name$249, dependencies$249, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, multiplyScalar: a2, concat: o2 } = t4, s2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo09xS0Sf({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 });
  return n2(name$249, createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: o2 })({ elop: a2, SS: c2, DS: s2, Ss: l2 }));
});
function bitAndBigNumber(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitAnd`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero() || n2.eq(-1) || t4.eq(n2)) return t4;
  if (n2.isZero() || t4.eq(-1)) return n2;
  if (!t4.isFinite() || !n2.isFinite()) {
    if (!t4.isFinite() && !n2.isFinite()) return t4.isNegative() === n2.isNegative() ? t4 : new r2(0);
    if (!t4.isFinite()) return n2.isNegative() ? t4 : t4.isNegative() ? new r2(0) : n2;
    if (!n2.isFinite()) return t4.isNegative() ? n2 : n2.isNegative() ? new r2(0) : t4;
  }
  return bitwise(t4, n2, function(t5, n3) {
    return t5 & n3;
  });
}
function bitNotBigNumber(t4) {
  if (t4.isFinite() && !t4.isInteger()) throw Error(`Integer expected in function bitNot`);
  var n2 = t4.constructor, r2 = n2.precision;
  n2.config({ precision: 1e9 });
  var i2 = t4.plus(new n2(1));
  return i2.s = -i2.s || null, n2.config({ precision: r2 }), i2;
}
function bitOrBigNumber(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitOr`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  var i2 = new r2(-1);
  return t4.isZero() || n2.eq(i2) || t4.eq(n2) ? n2 : n2.isZero() || t4.eq(i2) ? t4 : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !t4.isNegative() && n2.isNegative() || t4.isNegative() && !n2.isNegative() && !n2.isFinite() ? i2 : t4.isNegative() && n2.isNegative() ? t4.isFinite() ? t4 : n2 : t4.isFinite() ? n2 : t4 : bitwise(t4, n2, function(t5, n3) {
    return t5 | n3;
  });
}
function bitwise(t4, n2, r2) {
  var i2 = t4.constructor, a2, o2, s2 = +(t4.s < 0), c2 = +(n2.s < 0);
  if (s2) {
    a2 = decCoefficientToBinaryString(bitNotBigNumber(t4));
    for (var l2 = 0; l2 < a2.length; ++l2) a2[l2] ^= 1;
  } else a2 = decCoefficientToBinaryString(t4);
  if (c2) {
    o2 = decCoefficientToBinaryString(bitNotBigNumber(n2));
    for (var u2 = 0; u2 < o2.length; ++u2) o2[u2] ^= 1;
  } else o2 = decCoefficientToBinaryString(n2);
  var d2, p2, m2;
  a2.length <= o2.length ? (d2 = a2, p2 = o2, m2 = s2) : (d2 = o2, p2 = a2, m2 = c2);
  var h2 = d2.length, g2 = p2.length, v2 = r2(s2, c2) ^ 1, y2 = new i2(v2 ^ 1), b2 = new i2(1), x2 = new i2(2), S2 = i2.precision;
  for (i2.config({ precision: 1e9 }); h2 > 0; ) r2(d2[--h2], p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  for (; g2 > 0; ) r2(m2, p2[--g2]) === v2 && (y2 = y2.plus(b2)), b2 = b2.times(x2);
  return i2.config({ precision: S2 }), v2 === 0 && (y2.s = -y2.s), y2;
}
function decCoefficientToBinaryString(t4) {
  for (var n2 = t4.d, r2 = n2[0] + ``, i2 = 1; i2 < n2.length; ++i2) {
    for (var a2 = n2[i2] + ``, o2 = 7 - a2.length; o2--; ) a2 = `0` + a2;
    r2 += a2;
  }
  for (var s2 = r2.length; r2.charAt(s2) === `0`; ) s2--;
  var c2 = t4.e, l2 = r2.slice(0, s2 + 1 || 1), u2 = l2.length;
  if (c2 > 0) if (++c2 > u2) for (c2 -= u2; c2--; ) l2 += `0`;
  else c2 < u2 && (l2 = l2.slice(0, c2) + `.` + l2.slice(c2));
  for (var d2 = [0], p2 = 0; p2 < l2.length; ) {
    for (var m2 = d2.length; m2--; ) d2[m2] *= 10;
    d2[0] += parseInt(l2.charAt(p2++));
    for (var h2 = 0; h2 < d2.length; ++h2) d2[h2] > 1 && ((d2[h2 + 1] === null || d2[h2 + 1] === void 0) && (d2[h2 + 1] = 0), d2[h2 + 1] += d2[h2] >> 1, d2[h2] &= 1);
  }
  return d2.reverse();
}
function bitXor(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function bitXor`);
  var r2 = t4.constructor;
  if (t4.isNaN() || n2.isNaN()) return new r2(NaN);
  if (t4.isZero()) return n2;
  if (n2.isZero()) return t4;
  if (t4.eq(n2)) return new r2(0);
  var i2 = new r2(-1);
  return t4.eq(i2) ? bitNotBigNumber(n2) : n2.eq(i2) ? bitNotBigNumber(t4) : !t4.isFinite() || !n2.isFinite() ? !t4.isFinite() && !n2.isFinite() ? i2 : new r2(t4.isNegative() === n2.isNegative() ? 1 / 0 : -1 / 0) : bitwise(t4, n2, function(t5, n3) {
    return t5 ^ n3;
  });
}
function leftShiftBigNumber(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function leftShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : !t4.isFinite() && !n2.isFinite() ? new r2(NaN) : n2.lt(55) ? t4.times(2 ** n2.toNumber() + ``) : t4.times(new r2(2).pow(n2));
}
function rightArithShiftBigNumber(t4, n2) {
  if (t4.isFinite() && !t4.isInteger() || n2.isFinite() && !n2.isInteger()) throw Error(`Integers expected in function rightArithShift`);
  var r2 = t4.constructor;
  return t4.isNaN() || n2.isNaN() || n2.isNegative() && !n2.isZero() ? new r2(NaN) : t4.isZero() || n2.isZero() ? t4 : n2.isFinite() ? n2.lt(55) ? t4.div(2 ** n2.toNumber() + ``).floor() : t4.div(new r2(2).pow(n2)).floor() : t4.isNegative() ? new r2(-1) : t4.isFinite() ? new r2(0) : new r2(NaN);
}
var name$248 = `bitAnd`, dependencies$248 = [`typed`, `matrix`, `equalScalar`, `concat`], createBitAnd = factory(name$248, dependencies$248, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, concat: a2 } = t4, o2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), s2 = createMatAlgo06xS0S0({ typed: n2, equalScalar: i2 }), c2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), l2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$248, { "number, number": bitAndNumber, "BigNumber, BigNumber": bitAndBigNumber, "bigint, bigint": (t5, n3) => t5 & n3 }, l2({ SS: s2, DS: o2, Ss: c2 }));
}), name$247 = `bitNot`, dependencies$247 = [`typed`], createBitNot = factory(name$247, dependencies$247, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$247, { number: bitNotNumber, BigNumber: bitNotBigNumber, bigint: (t5) => ~t5, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$246 = `bitOr`, dependencies$246 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOr = factory(name$246, dependencies$246, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo01xDSid({ typed: n2 }), c2 = createMatAlgo04xSidSid({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$246, { "number, number": bitOrNumber, "BigNumber, BigNumber": bitOrBigNumber, "bigint, bigint": (t5, n3) => t5 | n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$245 = `matAlgo07xSSf`, dependencies$245 = [`typed`, `SparseMatrix`], createMatAlgo07xSSf = factory(name$245, dependencies$245, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return function(t5, a2, o2) {
    var s2 = t5._size, c2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), l2 = a2._size, u2 = a2._datatype || a2._data === void 0 ? a2._datatype : a2.getDataType();
    if (s2.length !== l2.length) throw new DimensionError(s2.length, l2.length);
    if (s2[0] !== l2[0] || s2[1] !== l2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + s2 + `) must match Matrix B (` + l2 + `)`);
    var d2 = s2[0], p2 = s2[1], m2, h2 = 0, g2 = o2;
    typeof c2 == `string` && c2 === u2 && c2 !== `mixed` && (m2 = c2, h2 = n2.convert(0, m2), g2 = n2.find(o2, [m2, m2]));
    for (var v2 = [], y2 = [], b2 = Array(p2 + 1).fill(0), x2 = [], S2 = [], w2 = [], E = [], D = 0; D < p2; D++) {
      var O2 = D + 1, j2 = 0;
      i2(t5, D, w2, x2, O2), i2(a2, D, E, S2, O2);
      for (var M2 = 0; M2 < d2; M2++) {
        var N2 = w2[M2] === O2 ? x2[M2] : h2, F = E[M2] === O2 ? S2[M2] : h2, I2 = g2(N2, F);
        I2 !== 0 && I2 !== false && (y2.push(M2), v2.push(I2), j2++);
      }
      b2[D + 1] = b2[D] + j2;
    }
    return new r2({ values: v2, index: y2, ptr: b2, size: [d2, p2], datatype: c2 === t5._datatype && u2 === a2._datatype ? m2 : void 0 });
  };
  function i2(t5, n3, r3, i3, a2) {
    for (var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = c2[n3], u2 = c2[n3 + 1]; l2 < u2; l2++) {
      var d2 = s2[l2];
      r3[d2] = a2, i3[d2] = o2[l2];
    }
  }
}), name$244 = `bitXor`, dependencies$244 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createBitXor = factory(name$244, dependencies$244, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf({ typed: n2 }), c2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$244, { "number, number": bitXorNumber, "BigNumber, BigNumber": bitXor, "bigint, bigint": (t5, n3) => t5 ^ n3 }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$243 = `arg`, dependencies$243 = [`typed`], createArg = factory(name$243, dependencies$243, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$243, { number: function(t5) {
    return Math.atan2(0, t5);
  }, BigNumber: function(t5) {
    return t5.constructor.atan2(0, t5);
  }, Complex: function(t5) {
    return t5.arg();
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$242 = `conj`, dependencies$242 = [`typed`], createConj = factory(name$242, dependencies$242, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$242, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.conjugate(), Unit: n2.referToSelf((t5) => (n3) => new n3.constructor(t5(n3.toNumeric()), n3.formatUnits())), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$241 = `im`, dependencies$241 = [`typed`], createIm = factory(name$241, dependencies$241, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$241, { number: () => 0, "BigNumber | Fraction": (t5) => t5.mul(0), Complex: (t5) => t5.im, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$240 = `re`, dependencies$240 = [`typed`], createRe = factory(name$240, dependencies$240, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$240, { "number | BigNumber | Fraction": (t5) => t5, Complex: (t5) => t5.re, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$239 = `not`, dependencies$239 = [`typed`], createNot = factory(name$239, dependencies$239, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$239, { "null | undefined": () => true, number: notNumber, Complex: function(t5) {
    return t5.re === 0 && t5.im === 0;
  }, BigNumber: function(t5) {
    return t5.isZero() || t5.isNaN();
  }, bigint: (t5) => !t5, Unit: n2.referToSelf((t5) => (r2) => n2.find(t5, r2.valueType())(r2.value)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$238 = `nullish`, dependencies$238 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullish = factory(name$238, dependencies$238, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createMatAlgo03xDSf({ typed: n2 }), c2 = createMatAlgo14xDs({ typed: n2 }), l2 = createMatAlgo13xDD({ typed: n2 });
  return n2(name$238, { "number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any": (t5, n3) => t5, "null, any": (t5, n3) => n3, "undefined, any": (t5, n3) => n3, "SparseMatrix, Array | Matrix": (t5, n3) => {
    var r3 = i2(t5), a3 = i2(n3);
    if (o2(r3, a3)) return t5;
    throw new DimensionError(r3, a3);
  }, "DenseMatrix, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5)), "DenseMatrix, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => s2(n3, r3, t5, false)), "DenseMatrix, Array": n2.referToSelf((t5) => (n3, i3) => l2(n3, r2(i3), t5)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => c2(n3, r3, t5, false)), "Array, Array": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), r2(i3), t5).valueOf()), "Array, DenseMatrix": n2.referToSelf((t5) => (n3, i3) => l2(r2(n3), i3, t5)), "Array, SparseMatrix": n2.referToSelf((t5) => (n3, i3) => s2(r2(n3), i3, t5, false)), "Array, any": n2.referToSelf((t5) => (n3, i3) => c2(r2(n3), i3, t5, false).valueOf()) });
}), name$237 = `or`, dependencies$237 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOr = factory(name$237, dependencies$237, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createMatAlgo03xDSf({ typed: n2 }), c2 = createMatAlgo05xSfSf({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: a2 }), u2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: o2 });
  return n2(name$237, { "number, number": orNumber, "Complex, Complex": function(t5, n3) {
    return t5.re !== 0 || t5.im !== 0 || n3.re !== 0 || n3.im !== 0;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !t5.isNaN() || !n3.isZero() && !n3.isNaN();
  }, "bigint, bigint": orNumber, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$236 = `xor`, dependencies$236 = [`typed`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createXor = factory(name$236, dependencies$236, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, concat: a2, SparseMatrix: o2 } = t4, s2 = createMatAlgo03xDSf({ typed: n2 }), c2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: o2 }), l2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: i2 }), u2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: a2 });
  return n2(name$236, { "number, number": xorNumber, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) != (n3.re !== 0 || n3.im !== 0);
  }, "bigint, bigint": xorNumber, "BigNumber, BigNumber": function(t5, n3) {
    return (!t5.isZero() && !t5.isNaN()) != (!n3.isZero() && !n3.isNaN());
  }, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)) }, u2({ SS: c2, DS: s2, Ss: l2 }));
}), name$235 = `concat`, dependencies$235 = [`typed`, `matrix`, `isInteger`], createConcat = factory(name$235, dependencies$235, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4;
  return n2(name$235, { "...Array | Matrix | number | BigNumber": function(t5) {
    var n3, a2 = t5.length, o2 = -1, s2, c2 = false, l2 = [];
    for (n3 = 0; n3 < a2; n3++) {
      var u2 = t5[n3];
      if (isMatrix(u2) && (c2 = true), isNumber(u2) || isBigNumber(u2)) {
        if (n3 !== a2 - 1) throw Error(`Dimension must be specified as last argument`);
        if (s2 = o2, o2 = u2.valueOf(), !i2(o2)) throw TypeError(`Integer number expected for dimension`);
        if (o2 < 0 || n3 > 0 && o2 > s2) throw new IndexError(o2, s2 + 1);
      } else {
        var d2 = clone$3(u2).valueOf(), p2 = arraySize(d2);
        if (l2[n3] = d2, s2 = o2, o2 = p2.length - 1, n3 > 0 && o2 !== s2) throw new DimensionError(s2 + 1, o2 + 1);
      }
    }
    if (l2.length === 0) throw SyntaxError(`At least one matrix expected`);
    for (var m2 = l2.shift(); l2.length; ) m2 = concat(m2, l2.shift(), o2);
    return c2 ? r2(m2) : m2;
  }, "...string": function(t5) {
    return t5.join(``);
  } });
}), name$234 = `column`, dependencies$234 = [`typed`, `Index`, `matrix`, `range`], createColumn = factory(name$234, dependencies$234, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$234, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex(n3, t5.size()[1]);
    var o3 = new r2(a2(0, t5.size()[0]), [n3]), s2 = t5.subset(o3);
    return isMatrix(s2) ? s2 : i2([[s2]]);
  }
}), name$233 = `count`, dependencies$233 = [`typed`, `size`, `prod`], createCount = factory(name$233, dependencies$233, (t4) => {
  var { typed: n2, size: r2, prod: i2 } = t4;
  return n2(name$233, { string: function(t5) {
    return t5.length;
  }, "Matrix | Array": function(t5) {
    return i2(r2(t5));
  } });
}), name$232 = `cross`, dependencies$232 = [`typed`, `matrix`, `subtract`, `multiply`], createCross = factory(name$232, dependencies$232, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, multiply: a2 } = t4;
  return n2(name$232, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function o2(t5, n3) {
    var r3 = Math.max(arraySize(t5).length, arraySize(n3).length);
    t5 = squeeze(t5), n3 = squeeze(n3);
    var o3 = arraySize(t5), s2 = arraySize(n3);
    if (o3.length !== 1 || s2.length !== 1 || o3[0] !== 3 || s2[0] !== 3) throw RangeError(`Vectors with length 3 expected (Size A = [` + o3.join(`, `) + `], B = [` + s2.join(`, `) + `])`);
    var c2 = [i2(a2(t5[1], n3[2]), a2(t5[2], n3[1])), i2(a2(t5[2], n3[0]), a2(t5[0], n3[2])), i2(a2(t5[0], n3[1]), a2(t5[1], n3[0]))];
    return r3 > 1 ? [c2] : c2;
  }
}), name$231 = `diag`, dependencies$231 = [`typed`, `matrix`, `DenseMatrix`, `SparseMatrix`], createDiag = factory(name$231, dependencies$231, (t4) => {
  var { typed: n2, matrix: r2, DenseMatrix: i2, SparseMatrix: a2 } = t4;
  return n2(name$231, { Array: function(t5) {
    return o2(t5, 0, arraySize(t5), null);
  }, "Array, number": function(t5, n3) {
    return o2(t5, n3, arraySize(t5), null);
  }, "Array, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), arraySize(t5), null);
  }, "Array, string": function(t5, n3) {
    return o2(t5, 0, arraySize(t5), n3);
  }, "Array, number, string": function(t5, n3, r3) {
    return o2(t5, n3, arraySize(t5), r3);
  }, "Array, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), arraySize(t5), r3);
  }, Matrix: function(t5) {
    return o2(t5, 0, t5.size(), t5.storage());
  }, "Matrix, number": function(t5, n3) {
    return o2(t5, n3, t5.size(), t5.storage());
  }, "Matrix, BigNumber": function(t5, n3) {
    return o2(t5, n3.toNumber(), t5.size(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return o2(t5, 0, t5.size(), n3);
  }, "Matrix, number, string": function(t5, n3, r3) {
    return o2(t5, n3, t5.size(), r3);
  }, "Matrix, BigNumber, string": function(t5, n3, r3) {
    return o2(t5, n3.toNumber(), t5.size(), r3);
  } });
  function o2(t5, n3, r3, i3) {
    if (!isInteger(n3)) throw TypeError(`Second parameter in function diag must be an integer`);
    var a3 = n3 > 0 ? n3 : 0, o3 = n3 < 0 ? -n3 : 0;
    switch (r3.length) {
      case 1:
        return s2(t5, n3, i3, r3[0], o3, a3);
      case 2:
        return c2(t5, n3, i3, r3, o3, a3);
    }
    throw RangeError(`Matrix for function diag must be 2 dimensional`);
  }
  function s2(t5, n3, r3, o3, s3, c3) {
    var l2 = [o3 + s3, o3 + c3];
    if (r3 && r3 !== `sparse` && r3 !== `dense`) throw TypeError(`Unknown matrix type ${r3}"`);
    var u2 = r3 === `sparse` ? a2.diagonal(l2, t5, n3) : i2.diagonal(l2, t5, n3);
    return r3 === null ? u2.valueOf() : u2;
  }
  function c2(t5, n3, i3, a3, o3, s3) {
    if (isMatrix(t5)) {
      var c3 = t5.diagonal(n3);
      return i3 === null ? c3.valueOf() : i3 === c3.storage() ? c3 : r2(c3, i3);
    }
    for (var l2 = Math.min(a3[0] - o3, a3[1] - s3), u2 = [], d2 = 0; d2 < l2; d2++) u2[d2] = t5[d2 + o3][d2 + s3];
    return i3 === null ? u2 : r2(u2);
  }
}), name$230 = `filter`, dependencies$230 = [`typed`], createFilter = factory(name$230, dependencies$230, (t4) => {
  var { typed: n2 } = t4;
  return n2(`filter`, { "Array, function": _filterCallback, "Matrix, function": function(t5, n3) {
    return t5.create(_filterCallback(t5.valueOf(), n3), t5.datatype());
  }, "Array, RegExp": filterRegExp, "Matrix, RegExp": function(t5, n3) {
    return t5.create(filterRegExp(t5.valueOf(), n3), t5.datatype());
  } });
});
function _filterCallback(t4, n2) {
  var r2 = optimizeCallback(n2, t4, `filter`);
  return r2.isUnary ? filter$1(t4, r2.fn) : filter$1(t4, function(t5, n3, i2) {
    return r2.fn(t5, [n3], i2);
  });
}
var name$229 = `flatten`, dependencies$229 = [`typed`], createFlatten = factory(name$229, dependencies$229, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$229, { Array: function(t5) {
    return flatten$4(t5);
  }, DenseMatrix: function(t5) {
    return t5.create(flatten$4(t5.valueOf(), true), t5.datatype());
  }, SparseMatrix: function(t5) {
    throw TypeError(`SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())`);
  } });
}), name$228 = `forEach`, dependencies$228 = [`typed`], createForEach = factory(name$228, dependencies$228, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$228, { "Array, function": _forEach, "Matrix, function": function(t5, n3) {
    t5.forEach(n3);
  } });
});
function _forEach(t4, n2) {
  var r2 = optimizeCallback(n2, t4, name$228);
  deepForEach$1(t4, r2.fn, r2.isUnary);
}
var name$227 = `getMatrixDataType`, dependencies$227 = [`typed`], createGetMatrixDataType = factory(name$227, dependencies$227, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$227, { Array: function(t5) {
    return getArrayDataType(t5, typeOf);
  }, Matrix: function(t5) {
    return t5.getDataType();
  } });
}), name$226 = `identity`, dependencies$226 = [`typed`, `config`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`], createIdentity = factory(name$226, dependencies$226, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2, DenseMatrix: o2, SparseMatrix: s2 } = t4;
  return n2(name$226, { "": function() {
    return r2.matrix === `Matrix` ? i2([]) : [];
  }, string: function(t5) {
    return i2(t5);
  }, "number | BigNumber": function(t5) {
    return l2(t5, t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, string": function(t5, n3) {
    return l2(t5, t5, n3);
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return l2(t5, n3, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber, number | BigNumber, string": function(t5, n3, r3) {
    return l2(t5, n3, r3);
  }, Array: function(t5) {
    return c2(t5);
  }, "Array, string": function(t5, n3) {
    return c2(t5, n3);
  }, Matrix: function(t5) {
    return c2(t5.valueOf(), t5.storage());
  }, "Matrix, string": function(t5, n3) {
    return c2(t5.valueOf(), n3);
  } });
  function c2(t5, n3) {
    switch (t5.length) {
      case 0:
        return n3 ? i2(n3) : [];
      case 1:
        return l2(t5[0], t5[0], n3);
      case 2:
        return l2(t5[0], t5[1], n3);
      default:
        throw Error(`Vector containing two values expected`);
    }
  }
  function l2(t5, n3, r3) {
    var i3 = isBigNumber(t5) || isBigNumber(n3) ? a2 : null;
    if (isBigNumber(t5) && (t5 = t5.toNumber()), isBigNumber(n3) && (n3 = n3.toNumber()), !isInteger(t5) || t5 < 1 || !isInteger(n3) || n3 < 1) throw Error(`Parameters in function identity must be positive integers`);
    var c3 = i3 ? new a2(1) : 1, l3 = i3 ? new i3(0) : 0, u2 = [t5, n3];
    if (r3) {
      if (r3 === `sparse`) return s2.diagonal(u2, c3, 0, l3);
      if (r3 === `dense`) return o2.diagonal(u2, c3, 0, l3);
      throw TypeError(`Unknown matrix type "${r3}"`);
    }
    for (var d2 = resize([], u2, l3), p2 = t5 < n3 ? t5 : n3, m2 = 0; m2 < p2; m2++) d2[m2][m2] = c3;
    return d2;
  }
}), name$225 = `kron`, dependencies$225 = [`typed`, `matrix`, `multiplyScalar`], createKron = factory(name$225, dependencies$225, (t4) => {
  var { typed: n2, matrix: r2, multiplyScalar: i2 } = t4;
  return n2(name$225, { "Matrix, Matrix": function(t5, n3) {
    return r2(o2(t5.toArray(), n3.toArray()));
  }, "Matrix, Array": function(t5, n3) {
    return r2(o2(t5.toArray(), n3));
  }, "Array, Matrix": function(t5, n3) {
    return r2(o2(t5, n3.toArray()));
  }, "Array, Array": o2 });
  function a2(t5, n3) {
    return t5.flatMap((t6) => n3.map((n4) => i2(t6, n4)));
  }
  function o2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : -1;
    if (r3 < 0) {
      var i3 = arraySize(t5).length, s2 = arraySize(n3).length;
      for (r3 = Math.max(i3, s2); i3++ < r3; ) t5 = [t5];
      for (; s2++ < r3; ) n3 = [n3];
    }
    return r3 === 1 ? a2(t5, n3) : t5.flatMap((t6) => n3.map((n4) => o2(t6, n4, r3 - 1)));
  }
}), name$224 = `map`, dependencies$224 = [`typed`], createMap = factory(name$224, dependencies$224, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$224, { "Array, function": c2, "Matrix, function": function(t5, n3) {
    return t5.map(n3);
  }, "Array|Matrix, Array|Matrix, ...Array|Matrix|function": (t5, n3, i3) => r2([t5, n3, ...i3.slice(0, i3.length - 1)], i3[i3.length - 1]) });
  function r2(t5, r3) {
    if (typeof r3 != `function`) throw Error(`Last argument must be a callback function`);
    var l2 = t5[0].isMatrix, u2 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize(t6)), d2 = broadcastSizes(...u2), p2 = t5.length, m2 = l2 ? (t6, n3) => t6.get(n3) : get$1, h2 = t5.map((t6, n3) => {
      var r4 = u2[n3].map(() => 0);
      return t6.isMatrix ? t6.get(r4) : get$1(t6, r4);
    }), g2 = n2.isTypedFunction(r3) ? s2(r3, h2, d2.map(() => 0), t5) : o2(r3, p2);
    if (g2 < 2) return i2(t5, a2(g2, r3, null));
    var v2 = l2 ? t5.map((n3) => n3.isMatrix ? n3.create(broadcastTo(n3.toArray(), d2), n3.datatype()) : t5[0].create(broadcastTo(n3.valueOf(), d2))) : t5.map((t6) => t6.isMatrix ? broadcastTo(t6.toArray(), d2) : broadcastTo(t6, d2)), y2 = a2(g2, r3, v2), b2 = (t6, n3) => y2([t6, ...v2.slice(1).map((t7) => m2(t7, n3))], n3);
    return l2 ? v2[0].map(b2) : c2(v2[0], b2);
  }
  function i2(t5, n3) {
    var r3 = t5[0], i3 = t5.map((t6) => t6.isMatrix ? t6.valueOf() : t6), a3 = t5.map((t6) => t6.isMatrix ? t6.size() : arraySize(t6)), o3 = broadcastSizes(...a3), s3 = a3.map((t6) => o3.length - t6.length), c3 = o3.length - 1, l2 = n3.length > 1 ? [] : null, u2 = p2(i3, 0);
    if (r3.isMatrix) {
      var d2 = r3.create();
      return d2._data = u2, d2._size = o3, d2;
    } else return u2;
    function p2(t6) {
      var r4 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : 0, i4 = o3[r4], a4 = Array(i4);
      if (r4 < c3) for (var u3 = function(n4) {
        l2 && (l2[r4] = n4), a4[n4] = p2(t6.map((t7, i5) => s3[i5] > r4 ? t7 : t7.length === 1 ? t7[0] : t7[n4]), r4 + 1);
      }, d3 = 0; d3 < i4; d3++) u3(d3);
      else for (var m2 = function(i5) {
        l2 && (l2[r4] = i5), a4[i5] = n3(t6.map((t7) => t7.length === 1 ? t7[0] : t7[i5]), l2 ? l2.slice() : void 0);
      }, h2 = 0; h2 < i4; h2++) m2(h2);
      return a4;
    }
  }
  function a2(t5, n3, r3) {
    switch (t5) {
      case 0:
        return (t6) => n3(...t6);
      case 1:
        return (t6, r4) => n3(...t6, r4);
      case 2:
        return (t6, i3) => n3(...t6, i3, ...r3);
    }
  }
  function o2(t5, n3) {
    var r3 = t5.toString();
    if (/arguments/.test(r3)) return 2;
    var i3 = r3.match(/\(.*?\)/);
    return /\.\.\./.test(i3) || t5.length > n3 + 1 ? 2 : +(t5.length === n3 + 1);
  }
  function s2(t5, r3, i3, a3) {
    return n2.resolve(t5, [...r3, i3, ...a3]) === null ? n2.resolve(t5, [...r3, i3]) === null ? (n2.resolve(t5, r3), 0) : 1 : 2;
  }
  function c2(t5, n3) {
    var r3 = optimizeCallback(n3, t5, name$224);
    return deepMap$1(t5, r3.fn, r3.isUnary);
  }
}), name$223 = `diff`, dependencies$223 = [`typed`, `matrix`, `subtract`, `number`], createDiff = factory(name$223, dependencies$223, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2 } = t4;
  return n2(name$223, { "Array | Matrix": function(t5) {
    return isMatrix(t5) ? r2(s2(t5.toArray())) : s2(t5);
  }, "Array | Matrix, number": function(t5, n3) {
    if (!isInteger(n3)) throw RangeError(`Dimension must be a whole number`);
    return isMatrix(t5) ? r2(o2(t5.toArray(), n3)) : o2(t5, n3);
  }, "Array, BigNumber": n2.referTo(`Array,number`, (t5) => (n3, r3) => t5(n3, a2(r3))), "Matrix, BigNumber": n2.referTo(`Matrix,number`, (t5) => (n3, r3) => t5(n3, a2(r3))) });
  function o2(t5, n3) {
    if (isMatrix(t5) && (t5 = t5.toArray()), !Array.isArray(t5)) throw RangeError(`Array/Matrix does not have that many dimensions`);
    if (n3 > 0) {
      var r3 = [];
      return t5.forEach((t6) => {
        r3.push(o2(t6, n3 - 1));
      }), r3;
    } else if (n3 === 0) return s2(t5);
    else throw RangeError(`Cannot have negative dimension`);
  }
  function s2(t5) {
    for (var n3 = [], r3 = t5.length, i3 = 1; i3 < r3; i3++) n3.push(c2(t5[i3 - 1], t5[i3]));
    return n3;
  }
  function c2(t5, n3) {
    isMatrix(t5) && (t5 = t5.toArray()), isMatrix(n3) && (n3 = n3.toArray());
    var r3 = Array.isArray(t5), a3 = Array.isArray(n3);
    if (r3 && a3) return l2(t5, n3);
    if (!r3 && !a3) return i2(n3, t5);
    throw TypeError(`Cannot calculate difference between 1 array and 1 non-array`);
  }
  function l2(t5, n3) {
    if (t5.length !== n3.length) throw RangeError(`Not all sub-arrays have the same length`);
    for (var r3 = [], i3 = t5.length, a3 = 0; a3 < i3; a3++) r3.push(c2(t5[a3], n3[a3]));
    return r3;
  }
}), name$222 = `ones`, dependencies$222 = [`typed`, `config`, `matrix`, `BigNumber`], createOnes = factory(name$222, dependencies$222, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(`ones`, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(1) : 1;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger(t6) || t6 < 0) throw Error(`Parameters in function ones must be positive integers`);
    });
  }
});
function noBignumber() {
  throw Error(`No "bignumber" implementation available`);
}
function noFraction() {
  throw Error(`No "fraction" implementation available`);
}
function noMatrix() {
  throw Error(`No "matrix" implementation available`);
}
var name$221 = `range`, dependencies$221 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRange = factory(name$221, dependencies$221, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, smaller: o2, smallerEq: s2, larger: c2, largerEq: l2, add: u2, isZero: d2, isPositive: p2 } = t4;
  return n2(name$221, { string: h2, "string, boolean": h2, number: function(t5) {
    throw TypeError(`Too few arguments to function range(): ${t5}`);
  }, boolean: function(t5) {
    throw TypeError(`Unexpected type of argument 1 to function range(): ${t5}, number|bigint|BigNumber|Fraction`);
  }, "number, number": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "number, number, number": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "number, number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "number, number, number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "bigint, bigint|number": function(t5, n3) {
    return m2(g2(t5, n3, 1n, false));
  }, "number, bigint": function(t5, n3) {
    return m2(g2(BigInt(t5), n3, 1n, false));
  }, "bigint, bigint|number, bigint|number": function(t5, n3, r3) {
    return m2(g2(t5, n3, BigInt(r3), false));
  }, "number, bigint, bigint|number": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), false));
  }, "bigint, bigint|number, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1n, r3));
  }, "number, bigint, boolean": function(t5, n3, r3) {
    return m2(g2(BigInt(t5), n3, 1n, r3));
  }, "bigint, bigint|number, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, BigInt(r3), i3));
  }, "number, bigint, bigint|number, boolean": function(t5, n3, r3, i3) {
    return m2(g2(BigInt(t5), n3, BigInt(r3), i3));
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3 = t5.constructor;
    return m2(g2(t5, n3, new r3(1), false));
  }, "BigNumber, BigNumber, BigNumber": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "BigNumber, BigNumber, boolean": function(t5, n3, r3) {
    var i3 = t5.constructor;
    return m2(g2(t5, n3, new i3(1), r3));
  }, "BigNumber, BigNumber, BigNumber, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Fraction, Fraction": function(t5, n3) {
    return m2(g2(t5, n3, 1, false));
  }, "Fraction, Fraction, Fraction": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Fraction, Fraction, boolean": function(t5, n3, r3) {
    return m2(g2(t5, n3, 1, r3));
  }, "Fraction, Fraction, Fraction, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  }, "Unit, Unit, Unit": function(t5, n3, r3) {
    return m2(g2(t5, n3, r3, false));
  }, "Unit, Unit, Unit, boolean": function(t5, n3, r3, i3) {
    return m2(g2(t5, n3, r3, i3));
  } });
  function m2(t5) {
    return r2.matrix === `Matrix` ? i2 ? i2(t5) : noMatrix() : t5;
  }
  function h2(t5, n3) {
    var i3 = v2(t5);
    if (!i3) throw SyntaxError(`String "` + t5 + `" is no valid range`);
    return r2.number === `BigNumber` ? (a2 === void 0 && noBignumber(), m2(g2(a2(i3.start), a2(i3.end), a2(i3.step)))) : m2(g2(i3.start, i3.end, i3.step, n3));
  }
  function g2(t5, n3, r3, i3) {
    var a3 = [];
    if (d2(r3)) throw Error(`Step must be non-zero`);
    for (var m3 = p2(r3) ? i3 ? s2 : o2 : i3 ? l2 : c2, h3 = t5; m3(h3, n3); ) a3.push(h3), h3 = u2(h3, r3);
    return a3;
  }
  function v2(t5) {
    var n3 = t5.split(`:`).map(function(t6) {
      return Number(t6);
    });
    if (n3.some(function(t6) {
      return isNaN(t6);
    })) return null;
    switch (n3.length) {
      case 2:
        return { start: n3[0], end: n3[1], step: 1 };
      case 3:
        return { start: n3[0], end: n3[2], step: n3[1] };
      default:
        return null;
    }
  }
}), name$220 = `reshape`, dependencies$220 = [`typed`, `isInteger`, `matrix`], createReshape = factory(name$220, dependencies$220, (t4) => {
  var { typed: n2, isInteger: r2 } = t4;
  return n2(name$220, { "Matrix, Array": function(t5, n3) {
    return t5.reshape(n3, true);
  }, "Array, Array": function(t5, n3) {
    return n3.forEach(function(t6) {
      if (!r2(t6)) throw TypeError(`Invalid size for dimension: ` + t6);
    }), reshape(t5, n3);
  } });
}), name$219 = `resize`, dependencies$219 = [`config`, `matrix`], createResize = factory(name$219, dependencies$219, (t4) => {
  var { config: n2, matrix: r2 } = t4;
  return function(t5, a2, o2) {
    if (arguments.length !== 2 && arguments.length !== 3) throw new ArgumentsError(`resize`, arguments.length, 2, 3);
    if (isMatrix(a2) && (a2 = a2.valueOf()), isBigNumber(a2[0]) && (a2 = a2.map(function(t6) {
      return isBigNumber(t6) ? t6.toNumber() : t6;
    })), isMatrix(t5)) return t5.resize(a2, o2, true);
    if (typeof t5 == `string`) return i2(t5, a2, o2);
    var s2 = Array.isArray(t5) ? false : n2.matrix !== `Array`;
    if (a2.length === 0) {
      for (; Array.isArray(t5); ) t5 = t5[0];
      return clone$3(t5);
    } else {
      Array.isArray(t5) || (t5 = [t5]), t5 = clone$3(t5);
      var c2 = resize(t5, a2, o2);
      return s2 ? r2(c2) : c2;
    }
  };
  function i2(t5, n3, r3) {
    if (r3 !== void 0) {
      if (typeof r3 != `string` || r3.length !== 1) throw TypeError(`Single character expected as defaultValue`);
    } else r3 = ` `;
    if (n3.length !== 1) throw new DimensionError(n3.length, 1);
    var i3 = n3[0];
    if (typeof i3 != `number` || !isInteger(i3)) throw TypeError(`Invalid size, must contain positive integers (size: ` + format(n3) + `)`);
    if (t5.length > i3) return t5.substring(0, i3);
    if (t5.length < i3) {
      for (var a2 = t5, o2 = 0, s2 = i3 - t5.length; o2 < s2; o2++) a2 += r3;
      return a2;
    } else return t5;
  }
}), name$218 = `rotate`, dependencies$218 = [`typed`, `multiply`, `rotationMatrix`], createRotate = factory(name$218, dependencies$218, (t4) => {
  var { typed: n2, multiply: r2, rotationMatrix: i2 } = t4;
  return n2(name$218, { "Array , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5).toArray();
  }, "Matrix , number | BigNumber | Complex | Unit": function(t5, n3) {
    return a2(t5, 2), r2(i2(n3), t5);
  }, "Array, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  }, "Matrix, number | BigNumber | Complex | Unit, Array | Matrix": function(t5, n3, o2) {
    return a2(t5, 3), r2(i2(n3, o2), t5);
  } });
  function a2(t5, n3) {
    var r3 = Array.isArray(t5) ? arraySize(t5) : t5.size();
    if (r3.length > 2 || r3.length === 2 && r3[1] !== 1 || r3[0] !== n3) throw RangeError(`Vector must be of dimensions 1x${n3}`);
  }
}), name$217 = `rotationMatrix`, dependencies$217 = [`typed`, `config`, `multiplyScalar`, `addScalar`, `unaryMinus`, `norm`, `matrix`, `BigNumber`, `DenseMatrix`, `SparseMatrix`, `cos`, `sin`], createRotationMatrix = factory(name$217, dependencies$217, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, addScalar: a2, unaryMinus: o2, norm: s2, BigNumber: c2, matrix: l2, DenseMatrix: u2, SparseMatrix: d2, cos: p2, sin: m2 } = t4;
  return n2(name$217, { "": function() {
    return r2.matrix === `Matrix` ? l2([]) : [];
  }, string: function(t5) {
    return l2(t5);
  }, "number | BigNumber | Complex | Unit": function(t5) {
    return h2(t5, r2.matrix === `Matrix` ? `dense` : void 0);
  }, "number | BigNumber | Complex | Unit, string": function(t5, n3) {
    return h2(t5, n3);
  }, "number | BigNumber | Complex | Unit, Array": function(t5, n3) {
    var r3 = l2(n3);
    return g2(r3), b2(t5, r3, void 0);
  }, "number | BigNumber | Complex | Unit, Matrix": function(t5, n3) {
    return g2(n3), b2(t5, n3, n3.storage() || (r2.matrix === `Matrix` ? `dense` : void 0));
  }, "number | BigNumber | Complex | Unit, Array, string": function(t5, n3, r3) {
    var i3 = l2(n3);
    return g2(i3), b2(t5, i3, r3);
  }, "number | BigNumber | Complex | Unit, Matrix, string": function(t5, n3, r3) {
    return g2(n3), b2(t5, n3, r3);
  } });
  function h2(t5, n3) {
    var r3 = isBigNumber(t5) ? new c2(-1) : -1, a3 = p2(t5), o3 = m2(t5);
    return y2([[a3, i2(r3, o3)], [o3, a3]], n3);
  }
  function g2(t5) {
    var n3 = t5.size();
    if (n3.length < 1 || n3[0] !== 3) throw RangeError(`Vector must be of dimensions 1x3`);
  }
  function v2(t5) {
    return t5.reduce((t6, n3) => i2(t6, n3));
  }
  function y2(t5, n3) {
    if (n3) {
      if (n3 === `sparse`) return new d2(t5);
      if (n3 === `dense`) return new u2(t5);
      throw TypeError(`Unknown matrix type "${n3}"`);
    }
    return t5;
  }
  function b2(t5, n3, r3) {
    var i3 = s2(n3);
    if (i3 === 0) throw RangeError(`Rotation around zero vector`);
    var l3 = isBigNumber(t5) ? c2 : null, u3 = l3 ? new l3(1) : 1, d3 = l3 ? new l3(-1) : -1, h3 = l3 ? new l3(n3.get([0]) / i3) : n3.get([0]) / i3, g3 = l3 ? new l3(n3.get([1]) / i3) : n3.get([1]) / i3, b3 = l3 ? new l3(n3.get([2]) / i3) : n3.get([2]) / i3, x2 = p2(t5), S2 = a2(u3, o2(x2)), w2 = m2(t5), E = a2(x2, v2([h3, h3, S2])), D = a2(v2([h3, g3, S2]), v2([d3, b3, w2])), O2 = a2(v2([h3, b3, S2]), v2([g3, w2])), j2 = a2(v2([h3, g3, S2]), v2([b3, w2])), M2 = a2(x2, v2([g3, g3, S2])), N2 = a2(v2([g3, b3, S2]), v2([d3, h3, w2])), F = a2(v2([h3, b3, S2]), v2([d3, g3, w2])), I2 = a2(v2([g3, b3, S2]), v2([h3, w2])), L2 = a2(x2, v2([b3, b3, S2]));
    return y2([[E, D, O2], [j2, M2, N2], [F, I2, L2]], r3);
  }
}), name$216 = `row`, dependencies$216 = [`typed`, `Index`, `matrix`, `range`], createRow = factory(name$216, dependencies$216, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4;
  return n2(name$216, { "Matrix, number": o2, "Array, number": function(t5, n3) {
    return o2(i2(clone$3(t5)), n3).valueOf();
  } });
  function o2(t5, n3) {
    if (t5.size().length !== 2) throw Error(`Only two dimensional matrix is supported`);
    validateIndex(n3, t5.size()[0]);
    var o3 = a2(0, t5.size()[1]), s2 = new r2([n3], o3), c2 = t5.subset(s2);
    return isMatrix(c2) ? c2 : i2([[c2]]);
  }
}), name$215 = `size`, dependencies$215 = [`typed`], createSize = factory(name$215, dependencies$215, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$215, { Matrix: (t5) => t5.size(), Array: arraySize, string: (t5) => [t5.length], "number | Complex | BigNumber | Unit | boolean | null": (t5) => [] });
}), name$214 = `squeeze`, dependencies$214 = [`typed`], createSqueeze = factory(name$214, dependencies$214, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$214, { Array: function(t5) {
    return squeeze(clone$3(t5));
  }, Matrix: function(t5) {
    var n3 = squeeze(t5.toArray());
    return Array.isArray(n3) ? t5.create(n3, t5.datatype()) : n3;
  }, any: function(t5) {
    return clone$3(t5);
  } });
}), name$213 = `subset`, dependencies$213 = [`typed`, `matrix`, `zeros`, `add`], createSubset = factory(name$213, dependencies$213, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4;
  return n2(name$213, { "Matrix, Index": function(t5, n3) {
    return isEmptyIndex(n3) ? r2() : (validateIndexSourceSize(t5, n3), t5.subset(n3));
  }, "Array, Index": n2.referTo(`Matrix, Index`, function(t5) {
    return function(n3, i3) {
      var a3 = t5(r2(n3), i3);
      return i3.isScalar() ? a3 : a3.valueOf();
    };
  }), "Object, Index": _getObjectProperty, "string, Index": _getSubstring, "Matrix, Index, any, any": function(t5, n3, r3, i3) {
    return isEmptyIndex(n3) ? t5 : (validateIndexSourceSize(t5, n3), t5.clone().subset(n3, o2(r3, n3), i3));
  }, "Array, Index, any, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3, o3) {
      var s2 = t5(r2(n3), i3, a3, o3);
      return s2.isMatrix ? s2.valueOf() : s2;
    };
  }), "Array, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, i3, a3) {
      return t5(r2(n3), i3, a3, void 0).valueOf();
    };
  }), "Matrix, Index, any": n2.referTo(`Matrix, Index, any, any`, function(t5) {
    return function(n3, r3, i3) {
      return t5(n3, r3, i3, void 0);
    };
  }), "string, Index, string": _setSubstring, "string, Index, string, string": _setSubstring, "Object, Index, any": _setObjectProperty });
  function o2(t5, n3) {
    if (typeof t5 == `string`) throw Error(`can't boradcast a string`);
    if (n3.isScalar()) return t5;
    var r3 = n3.size();
    if (r3.every((t6) => t6 > 0)) try {
      return a2(t5, i2(r3));
    } catch {
      return t5;
    }
    else return t5;
  }
});
function _getSubstring(t4, n2) {
  if (!isIndex(n2)) throw TypeError(`Index expected`);
  if (isEmptyIndex(n2)) return ``;
  if (validateIndexSourceSize(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError(n2.size().length, 1);
  var r2 = t4.length;
  validateIndex(n2.min()[0], r2), validateIndex(n2.max()[0], r2);
  var i2 = n2.dimension(0), a2 = ``;
  function o2(n3) {
    a2 += t4.charAt(n3);
  }
  return Number.isInteger(i2) ? o2(i2) : i2.forEach(o2), a2;
}
function _setSubstring(t4, n2, r2, i2) {
  if (!n2 || n2.isIndex !== true) throw TypeError(`Index expected`);
  if (isEmptyIndex(n2)) return t4;
  if (validateIndexSourceSize(Array.from(t4), n2), n2.size().length !== 1) throw new DimensionError(n2.size().length, 1);
  if (i2 !== void 0) {
    if (typeof i2 != `string` || i2.length !== 1) throw TypeError(`Single character expected as defaultValue`);
  } else i2 = ` `;
  var a2 = n2.dimension(0);
  if ((Number.isInteger(a2) ? 1 : a2.size()[0]) !== r2.length) throw new DimensionError(a2.size()[0], r2.length);
  var o2 = t4.length;
  validateIndex(n2.min()[0]), validateIndex(n2.max()[0]);
  for (var s2 = [], c2 = 0; c2 < o2; c2++) s2[c2] = t4.charAt(c2);
  function l2(t5, n3) {
    s2[t5] = r2.charAt(n3[0]);
  }
  if (Number.isInteger(a2) ? l2(a2, [0]) : a2.forEach(l2), s2.length > o2) for (var u2 = o2 - 1, d2 = s2.length; u2 < d2; u2++) s2[u2] || (s2[u2] = i2);
  return s2.join(``);
}
function _getObjectProperty(t4, n2) {
  if (!isEmptyIndex(n2)) {
    if (n2.size().length !== 1) throw new DimensionError(n2.size(), 1);
    var r2 = n2.dimension(0);
    if (typeof r2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
    return getSafeProperty(t4, r2);
  }
}
function _setObjectProperty(t4, n2, r2) {
  if (isEmptyIndex(n2)) return t4;
  if (n2.size().length !== 1) throw new DimensionError(n2.size(), 1);
  var i2 = n2.dimension(0);
  if (typeof i2 != `string`) throw TypeError(`String expected as index to retrieve an object property`);
  var a2 = clone$3(t4);
  return setSafeProperty(a2, i2, r2), a2;
}
var name$212 = `transpose`, dependencies$212 = [`typed`, `matrix`], createTranspose = factory(name$212, dependencies$212, (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return n2(name$212, { Array: (t5) => i2(r2(t5)).valueOf(), Matrix: i2, any: clone$3 });
  function i2(t5) {
    var n3 = t5.size(), r3;
    switch (n3.length) {
      case 1:
        r3 = t5.clone();
        break;
      case 2:
        var i3 = n3[0], s2 = n3[1];
        if (s2 === 0) throw RangeError(`Cannot transpose a 2D matrix with no columns (size: ` + format(n3) + `)`);
        switch (t5.storage()) {
          case `dense`:
            r3 = a2(t5, i3, s2);
            break;
          case `sparse`:
            r3 = o2(t5, i3, s2);
            break;
        }
        break;
      default:
        throw RangeError(`Matrix must be a vector or two dimensional (size: ` + format(n3) + `)`);
    }
    return r3;
  }
  function a2(t5, n3, r3) {
    for (var i3 = t5._data, a3 = [], o3, s2 = 0; s2 < r3; s2++) {
      o3 = a3[s2] = [];
      for (var c2 = 0; c2 < n3; c2++) o3[c2] = clone$3(i3[c2][s2]);
    }
    return t5.createDenseMatrix({ data: a3, size: [r3, n3], datatype: t5._datatype });
  }
  function o2(t5, n3, r3) {
    for (var i3 = t5._values, a3 = t5._index, o3 = t5._ptr, s2 = i3 ? [] : void 0, c2 = [], l2 = [], u2 = [], d2 = 0; d2 < n3; d2++) u2[d2] = 0;
    var p2, m2, h2;
    for (p2 = 0, m2 = a3.length; p2 < m2; p2++) u2[a3[p2]]++;
    for (var g2 = 0, v2 = 0; v2 < n3; v2++) l2.push(g2), g2 += u2[v2], u2[v2] = l2[v2];
    for (l2.push(g2), h2 = 0; h2 < r3; h2++) for (var y2 = o3[h2], b2 = o3[h2 + 1], x2 = y2; x2 < b2; x2++) {
      var S2 = u2[a3[x2]]++;
      c2[S2] = h2, i3 && (s2[S2] = clone$3(i3[x2]));
    }
    return t5.createSparseMatrix({ values: s2, index: c2, ptr: l2, size: [r3, n3], datatype: t5._datatype });
  }
}), name$211 = `ctranspose`, dependencies$211 = [`typed`, `transpose`, `conj`], createCtranspose = factory(name$211, dependencies$211, (t4) => {
  var { typed: n2, transpose: r2, conj: i2 } = t4;
  return n2(name$211, { any: function(t5) {
    return i2(r2(t5));
  } });
}), name$210 = `zeros`, dependencies$210 = [`typed`, `config`, `matrix`, `BigNumber`], createZeros = factory(name$210, dependencies$210, (t4) => {
  var { typed: n2, config: r2, matrix: i2, BigNumber: a2 } = t4;
  return n2(name$210, { "": function() {
    return r2.matrix === `Array` ? o2([]) : o2([], `default`);
  }, "...number | BigNumber | string": function(t5) {
    return typeof t5[t5.length - 1] == `string` ? o2(t5, t5.pop()) : r2.matrix === `Array` ? o2(t5) : o2(t5, `default`);
  }, Array: o2, Matrix: function(t5) {
    var n3 = t5.storage();
    return o2(t5.valueOf(), n3);
  }, "Array | Matrix, string": function(t5, n3) {
    return o2(t5.valueOf(), n3);
  } });
  function o2(t5, n3) {
    var r3 = s2(t5) ? new a2(0) : 0;
    if (c2(t5), n3) {
      var o3 = i2(n3);
      return t5.length > 0 ? o3.resize(t5, r3) : o3;
    } else {
      var l2 = [];
      return t5.length > 0 ? resize(l2, t5, r3) : l2;
    }
  }
  function s2(t5) {
    var n3 = false;
    return t5.forEach(function(t6, r3, i3) {
      isBigNumber(t6) && (n3 = true, i3[r3] = t6.toNumber());
    }), n3;
  }
  function c2(t5) {
    t5.forEach(function(t6) {
      if (typeof t6 != `number` || !isInteger(t6) || t6 < 0) throw Error(`Parameters in function zeros must be positive integers`);
    });
  }
}), name$209 = `fft`, dependencies$209 = [`typed`, `matrix`, `addScalar`, `multiplyScalar`, `divideScalar`, `exp`, `tau`, `i`, `dotDivide`, `conj`, `pow`, `ceil`, `log2`], createFft = factory(name$209, dependencies$209, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, multiplyScalar: a2, divideScalar: o2, exp: s2, tau: c2, i: l2, dotDivide: u2, conj: d2, pow: p2, ceil: m2, log2: h2 } = t4;
  return n2(name$209, { Array: g2, Matrix: function(t5) {
    return t5.create(g2(t5.valueOf()), t5.datatype());
  } });
  function g2(t5) {
    var n3 = arraySize(t5);
    return n3.length === 1 ? b2(t5, n3[0]) : v2(t5.map((t6) => g2(t6, n3.slice(1))), 0);
  }
  function v2(t5, n3) {
    var r3 = arraySize(t5);
    if (n3 !== 0) return Array(r3[0]).fill(0).map((r4, i4) => v2(t5[i4], n3 - 1));
    if (r3.length === 1) return b2(t5);
    function i3(t6) {
      var n4 = arraySize(t6);
      return Array(n4[1]).fill(0).map((r4, i4) => Array(n4[0]).fill(0).map((n5, r5) => t6[r5][i4]));
    }
    return i3(v2(i3(t5), 1));
  }
  function y2(t5) {
    for (var n3 = t5.length, r3 = s2(o2(a2(-1, a2(l2, c2)), n3)), i3 = [], v3 = 1 - n3; v3 < n3; v3++) i3.push(p2(r3, o2(p2(v3, 2), 2)));
    for (var y3 = p2(2, m2(h2(n3 + n3 - 1))), x2 = [...Array(n3).fill(0).map((r4, o3) => a2(t5[o3], i3[n3 - 1 + o3])), ...Array(y3 - n3).fill(0)], S2 = [...Array(n3 + n3 - 1).fill(0).map((t6, n4) => o2(1, i3[n4])), ...Array(y3 - (n3 + n3 - 1)).fill(0)], w2 = b2(x2), E = b2(S2), D = u2(d2(g2(d2(Array(y3).fill(0).map((t6, n4) => a2(w2[n4], E[n4]))))), y3), O2 = [], j2 = n3 - 1; j2 < n3 + n3 - 1; j2++) O2.push(a2(D[j2], i3[j2]));
    return O2;
  }
  function b2(t5) {
    var n3 = t5.length;
    if (n3 === 1) return [t5[0]];
    if (n3 % 2 == 0) {
      for (var r3 = [...b2(t5.filter((t6, n4) => n4 % 2 == 0)), ...b2(t5.filter((t6, n4) => n4 % 2 == 1))], u3 = 0; u3 < n3 / 2; u3++) {
        var d3 = r3[u3], p3 = a2(r3[u3 + n3 / 2], s2(a2(a2(c2, l2), o2(-u3, n3))));
        r3[u3] = i2(d3, p3), r3[u3 + n3 / 2] = i2(d3, a2(-1, p3));
      }
      return r3;
    } else return y2(t5);
  }
}), name$208 = `ifft`, dependencies$208 = [`typed`, `fft`, `dotDivide`, `conj`], createIfft = factory(name$208, dependencies$208, (t4) => {
  var { typed: n2, fft: r2, dotDivide: i2, conj: a2 } = t4;
  return n2(name$208, { "Array | Matrix": function(t5) {
    var n3 = isMatrix(t5) ? t5.size() : arraySize(t5);
    return i2(a2(r2(a2(t5))), n3.reduce((t6, n4) => t6 * n4, 1));
  } });
});
function _typeof(t4) {
  "@babel/helpers - typeof";
  return _typeof = typeof Symbol == `function` && typeof Symbol.iterator == `symbol` ? function(t5) {
    return typeof t5;
  } : function(t5) {
    return t5 && typeof Symbol == `function` && t5.constructor === Symbol && t5 !== Symbol.prototype ? `symbol` : typeof t5;
  }, _typeof(t4);
}
function toPrimitive(t4, n2) {
  if (_typeof(t4) != `object` || !t4) return t4;
  var r2 = t4[Symbol.toPrimitive];
  if (r2 !== void 0) {
    var i2 = r2.call(t4, n2);
    if (_typeof(i2) != `object`) return i2;
    throw TypeError(`@@toPrimitive must return a primitive value.`);
  }
  return (n2 === `string` ? String : Number)(t4);
}
function toPropertyKey(t4) {
  var n2 = toPrimitive(t4, `string`);
  return _typeof(n2) == `symbol` ? n2 : n2 + ``;
}
function _defineProperty(t4, n2, r2) {
  return (n2 = toPropertyKey(n2)) in t4 ? Object.defineProperty(t4, n2, { value: r2, enumerable: true, configurable: true, writable: true }) : t4[n2] = r2, t4;
}
function ownKeys$3(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$3(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$3(Object(r2), true).forEach(function(n3) {
      _defineProperty(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$3(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$207 = `solveODE`, dependencies$207 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `max`, `map`, `abs`, `isPositive`, `isNegative`, `larger`, `smaller`, `matrix`, `bignumber`, `unaryMinus`], createSolveODE = factory(name$207, dependencies$207, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, max: s2, map: c2, abs: l2, isPositive: u2, isNegative: d2, larger: p2, smaller: m2, matrix: h2, bignumber: g2, unaryMinus: v2 } = t4;
  function y2(t5) {
    return function(n3, h3, y3, b3) {
      if (!(h3.length === 2 && (h3.every(D) || h3.every(isUnit)))) throw Error(`"tspan" must be an Array of two numeric values or two units [tStart, tEnd]`);
      var x3 = h3[0], S3 = h3[1], O22 = p2(S3, x3), j2 = b3.firstStep;
      if (j2 !== void 0 && !u2(j2)) throw Error(`"firstStep" must be positive`);
      var M2 = b3.maxStep;
      if (M2 !== void 0 && !u2(M2)) throw Error(`"maxStep" must be positive`);
      var N2 = b3.minStep;
      if (N2 && d2(N2)) throw Error(`"minStep" must be positive or zero`);
      var F = [x3, S3, j2, N2, M2].filter((t6) => t6 !== void 0);
      if (!(F.every(D) || F.every(isUnit))) throw Error(`Inconsistent type of "t" dependant variables`);
      for (var I2 = 1, L2 = b3.tol ? b3.tol : 1e-4, R2 = b3.minDelta ? b3.minDelta : 0.2, z2 = b3.maxDelta ? b3.maxDelta : 5, V2 = b3.maxIter ? b3.maxIter : 1e4, H2 = [x3, S3, ...y3, M2, N2].some(isBigNumber), [U2, W2, G2, K2] = H2 ? [g2(t5.a), g2(t5.c), g2(t5.b), g2(t5.bp)] : [t5.a, t5.c, t5.b, t5.bp], q2 = j2 ? O22 ? j2 : v2(j2) : o2(i2(S3, x3), I2), J = [x3], ee2 = [y3], Y2 = i2(G2, K2), te2 = 0, ne2 = 0, X2 = w2(O22), ie2 = E(O22); X2(J[te2], S3); ) {
        var ae2 = [];
        q2 = ie2(J[te2], S3, q2), ae2.push(n3(J[te2], ee2[te2]));
        for (var Z2 = 1; Z2 < W2.length; ++Z2) ae2.push(n3(r2(J[te2], a2(W2[Z2], q2)), r2(ee2[te2], a2(q2, U2[Z2], ae2))));
        var oe2 = s2(l2(c2(a2(Y2, ae2), (t6) => isUnit(t6) ? t6.value : t6)));
        oe2 < L2 && L2 / oe2 > 1 / 4 && (J.push(r2(J[te2], q2)), ee2.push(r2(ee2[te2], a2(q2, G2, ae2))), te2++);
        var $2 = 0.84 * (L2 / oe2) ** (1 / 5);
        if (m2($2, R2) ? $2 = R2 : p2($2, z2) && ($2 = z2), $2 = H2 ? g2($2) : $2, q2 = a2(q2, $2), M2 && p2(l2(q2), M2) ? q2 = O22 ? M2 : v2(M2) : N2 && m2(l2(q2), N2) && (q2 = O22 ? N2 : v2(N2)), ne2++, ne2 > V2) throw Error(`Maximum number of iterations reached, try changing options`);
      }
      return { t: J, y: ee2 };
    };
  }
  function b2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 2], [0, 3 / 4], [2 / 9, 1 / 3, 4 / 9]], c: [null, 1 / 2, 3 / 4, 1], b: [2 / 9, 1 / 3, 4 / 9, 0], bp: [7 / 24, 1 / 4, 1 / 3, 1 / 8] })(t5, n3, r3, i3);
  }
  function x2(t5, n3, r3, i3) {
    return y2({ a: [[], [1 / 5], [3 / 40, 9 / 40], [44 / 45, -56 / 15, 32 / 9], [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84]], c: [null, 1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], b: [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84, 0], bp: [5179 / 57600, 0, 7571 / 16695, 393 / 640, -92097 / 339200, 187 / 2100, 1 / 40] })(t5, n3, r3, i3);
  }
  function S2(t5, n3, r3, i3) {
    var a3 = i3.method ? i3.method : `RK45`, o3 = { RK23: b2, RK45: x2 };
    if (a3.toUpperCase() in o3) {
      var s3 = _objectSpread$3({}, i3);
      return delete s3.method, o3[a3.toUpperCase()](t5, n3, r3, s3);
    } else {
      var c3 = Object.keys(o3).map((t6) => `"${t6}"`), l3 = `${c3.slice(0, -1).join(`, `)} and ${c3.slice(-1)}`;
      throw Error(`Unavailable method "${a3}". Available methods are ${l3}`);
    }
  }
  function w2(t5) {
    return t5 ? m2 : p2;
  }
  function E(t5) {
    var n3 = t5 ? p2 : m2;
    return function(t6, a3, o3) {
      return n3(r2(t6, o3), a3) ? i2(a3, t6) : o3;
    };
  }
  function D(t5) {
    return isBigNumber(t5) || isNumber(t5);
  }
  function O2(t5, n3, r3, i3) {
    var a3 = S2(t5, n3.toArray(), r3.toArray(), i3);
    return { t: h2(a3.t), y: h2(a3.y) };
  }
  return n2(`solveODE`, { "function, Array, Array, Object": S2, "function, Matrix, Matrix, Object": O2, "function, Array, Array": (t5, n3, r3) => S2(t5, n3, r3, {}), "function, Matrix, Matrix": (t5, n3, r3) => O2(t5, n3, r3, {}), "function, Array, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3, [r3], {});
    return { t: i3.t, y: i3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit": (t5, n3, r3) => {
    var i3 = S2(t5, n3.toArray(), [r3], {});
    return { t: h2(i3.t), y: h2(i3.y.map((t6) => t6[0])) };
  }, "function, Array, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3, [r3], i3);
    return { t: a3.t, y: a3.y.map((t6) => t6[0]) };
  }, "function, Matrix, number | BigNumber | Unit, Object": (t5, n3, r3, i3) => {
    var a3 = S2(t5, n3.toArray(), [r3], i3);
    return { t: h2(a3.t), y: h2(a3.y.map((t6) => t6[0])) };
  } });
}), name$206 = `erf`, dependencies$206 = [`typed`], createErf = factory(name$206, dependencies$206, (t4) => {
  var { typed: n2 } = t4;
  return n2(`name`, { number: function(t5) {
    var n3 = Math.abs(t5);
    return n3 >= MAX_NUM ? sign$2(t5) : n3 <= THRESH ? sign$2(t5) * r2(n3) : n3 <= 4 ? sign$2(t5) * (1 - i2(n3)) : sign$2(t5) * (1 - a2(n3));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
  function r2(t5) {
    var n3 = t5 * t5, r3 = P[0][4] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 3; a3 += 1) r3 = (r3 + P[0][a3]) * n3, i3 = (i3 + Q$1[0][a3]) * n3;
    return t5 * (r3 + P[0][3]) / (i3 + Q$1[0][3]);
  }
  function i2(t5) {
    var n3 = P[1][8] * t5, r3 = t5, i3;
    for (i3 = 0; i3 < 7; i3 += 1) n3 = (n3 + P[1][i3]) * t5, r3 = (r3 + Q$1[1][i3]) * t5;
    var a3 = (n3 + P[1][7]) / (r3 + Q$1[1][7]), o2 = parseInt(t5 * 16) / 16, s2 = (t5 - o2) * (t5 + o2);
    return Math.exp(-o2 * o2) * Math.exp(-s2) * a3;
  }
  function a2(t5) {
    var n3 = 1 / (t5 * t5), r3 = P[2][5] * n3, i3 = n3, a3;
    for (a3 = 0; a3 < 4; a3 += 1) r3 = (r3 + P[2][a3]) * n3, i3 = (i3 + Q$1[2][a3]) * n3;
    var o2 = n3 * (r3 + P[2][4]) / (i3 + Q$1[2][4]);
    o2 = (SQRPI - o2) / t5, n3 = parseInt(t5 * 16) / 16;
    var s2 = (t5 - n3) * (t5 + n3);
    return Math.exp(-n3 * n3) * Math.exp(-s2) * o2;
  }
}), THRESH = 0.46875, SQRPI = 0.5641895835477563, P = [[3.1611237438705655, 113.86415415105016, 377.485237685302, 3209.3775891384694, 0.18577770618460315], [0.5641884969886701, 8.883149794388377, 66.11919063714163, 298.6351381974001, 881.952221241769, 1712.0476126340707, 2051.0783778260716, 1230.3393547979972, 21531153547440383e-24], [0.30532663496123236, 0.36034489994980445, 0.12578172611122926, 0.016083785148742275, 6587491615298378e-19, 0.016315387137302097]], Q$1 = [[23.601290952344122, 244.02463793444417, 1282.6165260773723, 2844.236833439171], [15.744926110709835, 117.6939508913125, 537.1811018620099, 1621.3895745666903, 3290.7992357334597, 4362.619090143247, 3439.3676741437216, 1230.3393548037495], [2.568520192289822, 1.8729528499234604, 0.5279051029514285, 0.06051834131244132, 0.0023352049762686918]], MAX_NUM = 2 ** 53, name$205 = `zeta`, dependencies$205 = [`typed`, `config`, `multiply`, `pow`, `divide`, `factorial`, `equal`, `smallerEq`, `isBounded`, `isNegative`, `gamma`, `sin`, `subtract`, `add`, `?Complex`, `?BigNumber`, `pi`], createZeta = factory(name$205, dependencies$205, (t4) => {
  var { typed: n2, config: r2, multiply: i2, pow: a2, divide: o2, factorial: s2, equal: c2, smallerEq: l2, isBounded: u2, isNegative: d2, gamma: p2, sin: m2, subtract: h2, add: g2, Complex: v2, BigNumber: y2, pi: b2 } = t4;
  return n2(name$205, { number: (t5) => x2(t5, (t6) => t6, () => 20), BigNumber: (t5) => x2(t5, (t6) => new y2(t6), () => Math.abs(Math.log10(r2.relTol))), Complex: S2 });
  function x2(t5, n3, r3) {
    return c2(t5, 0) ? n3(-0.5) : c2(t5, 1) ? n3(NaN) : u2(t5) ? w2(t5, n3, r3, (t6) => t6) : d2(t5) ? n3(NaN) : n3(1);
  }
  function S2(t5) {
    return t5.re === 0 && t5.im === 0 ? new v2(-0.5) : t5.re === 1 ? new v2(NaN, NaN) : t5.re === 1 / 0 && t5.im === 0 ? new v2(1) : t5.im === 1 / 0 || t5.re === -1 / 0 ? new v2(NaN, NaN) : w2(t5, (t6) => t6, (t6) => Math.round(1.3 * 15 + 0.9 * Math.abs(t6.im)), (t6) => t6.re);
  }
  function w2(t5, n3, r3, s3) {
    var c3 = r3(t5);
    if (s3(t5) > -(c3 - 1) / 2) return D(t5, n3(c3), n3);
    var l3 = i2(a2(2, t5), a2(n3(b2), h2(t5, 1)));
    return l3 = i2(l3, m2(i2(o2(n3(b2), 2), t5))), l3 = i2(l3, p2(h2(1, t5))), i2(l3, w2(h2(1, t5), n3, r3, s3));
  }
  function E(t5, n3) {
    for (var r3 = t5, c3 = t5; l2(c3, n3); c3 = g2(c3, 1)) {
      var u3 = o2(i2(s2(g2(n3, h2(c3, 1))), a2(4, c3)), i2(s2(h2(n3, c3)), s2(i2(2, c3))));
      r3 = g2(r3, u3);
    }
    return i2(n3, r3);
  }
  function D(t5, n3, r3) {
    for (var s3 = o2(1, i2(E(r3(0), n3), h2(1, a2(2, h2(1, t5))))), c3 = r3(0), u3 = r3(1); l2(u3, n3); u3 = g2(u3, 1)) c3 = g2(c3, o2(i2((-1) ** (u3 - 1), E(u3, n3)), a2(u3, t5)));
    return i2(s3, c3);
  }
}), name$204 = `mode`, dependencies$204 = [`typed`, `isNaN`, `isNumeric`], createMode = factory(name$204, dependencies$204, (t4) => {
  var { typed: n2, isNaN: r2, isNumeric: i2 } = t4;
  return n2(name$204, { "Array | Matrix": a2, "...": function(t5) {
    return a2(t5);
  } });
  function a2(t5) {
    if (t5 = flatten$4(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate mode of an empty array`);
    for (var n3 = {}, a3 = [], o2 = 0, s2 = 0; s2 < t5.length; s2++) {
      var c2 = t5[s2];
      if (i2(c2) && r2(c2)) throw Error(`Cannot calculate mode of an array containing NaN values`);
      c2 in n3 || (n3[c2] = 0), n3[c2]++, n3[c2] === o2 ? a3.push(c2) : n3[c2] > o2 && (o2 = n3[c2], a3 = [c2]);
    }
    return a3;
  }
});
function improveErrorMessage(t4, n2, r2) {
  var i2;
  return String(t4).includes(`Unexpected type`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf(r2) + `, value: ` + JSON.stringify(r2) + `)` : ` (type: ` + t4.data.actual + `)`, TypeError(`Cannot calculate ` + n2 + `, unexpected type of argument` + i2)) : String(t4).includes(`complex numbers`) ? (i2 = arguments.length > 2 ? ` (type: ` + typeOf(r2) + `, value: ` + JSON.stringify(r2) + `)` : ``, TypeError(`Cannot calculate ` + n2 + `, no ordering relation is defined for complex numbers` + i2)) : t4;
}
var name$203 = `prod`, dependencies$203 = [`typed`, `config`, `multiplyScalar`, `numeric`], createProd = factory(name$203, dependencies$203, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, numeric: a2 } = t4;
  return n2(name$203, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`prod(A, dim) is not yet supported`);
  }, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    if (deepForEach(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage(n4, `prod`, t6);
      }
    }), typeof n3 == `string` && (n3 = a2(n3, safeNumberType(n3, r2))), n3 === void 0) throw Error(`Cannot calculate prod of an empty array`);
    return n3;
  }
}), name$202 = `format`, dependencies$202 = [`typed`], createFormat = factory(name$202, dependencies$202, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$202, { any: format, "any, Object | function | number | BigNumber": format });
}), name$201 = `bin`, dependencies$201 = [`typed`, `format`], createBin = factory(name$201, dependencies$201, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$201, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `bin` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `bin`, wordSize: n3 });
  } });
}), name$200 = `oct`, dependencies$200 = [`typed`, `format`], createOct = factory(name$200, dependencies$200, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$200, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `oct` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `oct`, wordSize: n3 });
  } });
}), name$199 = `hex`, dependencies$199 = [`typed`, `format`], createHex = factory(name$199, dependencies$199, (t4) => {
  var { typed: n2, format: r2 } = t4;
  return n2(name$199, { "number | BigNumber": function(t5) {
    return r2(t5, { notation: `hex` });
  }, "number | BigNumber, number | BigNumber": function(t5, n3) {
    return r2(t5, { notation: `hex`, wordSize: n3 });
  } });
}), printTemplate = /\$([\w.]+)/g, name$198 = `print`, dependencies$198 = [`typed`], createPrint = factory(name$198, dependencies$198, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$198, { "string, Object | Array": _print, "string, Object | Array, number | Object": _print });
});
function _print(t4, n2, r2) {
  return t4.replace(printTemplate, function(t5, i2) {
    var a2 = i2.split(`.`), o2 = n2[a2.shift()];
    for (o2 !== void 0 && o2.isMatrix && (o2 = o2.toArray()); a2.length && o2 !== void 0; ) {
      var s2 = a2.shift();
      o2 = s2 ? o2[s2] : o2 + `.`;
    }
    return o2 === void 0 ? t5 : isString(o2) ? o2 : format(o2, r2);
  });
}
var name$197 = `to`, dependencies$197 = [`typed`, `matrix`, `concat`], createTo = factory(name$197, dependencies$197, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$197, { "Unit, Unit | string": (t5, n3) => t5.to(n3) }, createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: i2 })({ Ds: true }));
}), name$196 = `toBest`, dependencies$196 = [`typed`], createToBest = factory(name$196, dependencies$196, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$196, { Unit: (t5) => t5.toBest(), "Unit, string": (t5, n3) => t5.toBest(n3.split(`,`)), "Unit, string, Object": (t5, n3, r2) => t5.toBest(n3.split(`,`), r2), "Unit, Array": (t5, n3) => t5.toBest(n3), "Unit, Array, Object": (t5, n3, r2) => t5.toBest(n3, r2) });
}), name$195 = `isPrime`, dependencies$195 = [`typed`], createIsPrime = factory(name$195, dependencies$195, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$195, { number: function(t5) {
    if (t5 <= 3) return t5 > 1;
    if (t5 % 2 == 0 || t5 % 3 == 0) return false;
    for (var n3 = 5; n3 * n3 <= t5; n3 += 6) if (t5 % n3 === 0 || t5 % (n3 + 2) === 0) return false;
    return true;
  }, bigint: function(t5) {
    if (t5 <= 3n) return t5 > 1n;
    if (t5 % 2n == 0n || t5 % 3n == 0n) return false;
    for (var n3 = 5n; n3 * n3 <= t5; n3 += 6n) if (t5 % n3 === 0n || t5 % (n3 + 2n) === 0n) return false;
    return true;
  }, BigNumber: function(t5) {
    if (t5.lte(3)) return t5.gt(1);
    if (t5.mod(2).eq(0) || t5.mod(3).eq(0)) return false;
    if (t5.lt(2 ** 32)) {
      for (var n3 = t5.toNumber(), r2 = 5; r2 * r2 <= n3; r2 += 6) if (n3 % r2 === 0 || n3 % (r2 + 2) === 0) return false;
      return true;
    }
    function i2(t6, n4, r3) {
      for (var i3 = 1; !n4.eq(0); ) n4.mod(2).eq(0) ? (n4 = n4.div(2), t6 = t6.mul(t6).mod(r3)) : (n4 = n4.sub(1), i3 = t6.mul(i3).mod(r3));
      return i3;
    }
    t5 = new (t5.constructor.clone({ precision: t5.toFixed(0).length * 2 }))(t5);
    for (var a2 = 0, o2 = t5.sub(1); o2.mod(2).eq(0); ) o2 = o2.div(2), a2 += 1;
    var s2 = null;
    if (t5.lt(`3317044064679887385961981`)) s2 = [2, 3, 5, 7, 11, 13, 17, 19, 23, 29, 31, 37, 41].filter((n4) => n4 < t5);
    else {
      var c2 = Math.min(t5.toNumber() - 2, Math.floor(2 * (t5.toFixed(0).length * Math.log(10)) ** 2));
      s2 = [];
      for (var l2 = 2; l2 <= c2; l2 += 1) s2.push(c2);
    }
    for (var u2 = 0; u2 < s2.length; u2 += 1) {
      var d2 = s2[u2], p2 = i2(t5.sub(t5).add(d2), o2, t5);
      if (!p2.eq(1)) {
        for (var m2 = 0, h2 = p2; !h2.eq(t5.sub(1)); m2 += 1, h2 = h2.mul(h2).mod(t5)) if (m2 === a2 - 1) return false;
      }
    }
    return true;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$194 = `numeric`, dependencies$194 = [`number`, `?bignumber`, `?fraction`], createNumeric = factory(name$194, dependencies$194, (t4) => {
  var { number: n2, bignumber: r2, fraction: i2 } = t4, a2 = { string: true, number: true, BigNumber: true, Fraction: true }, o2 = { number: (t5) => n2(t5), BigNumber: r2 ? (t5) => r2(t5) : noBignumber, bigint: (t5) => BigInt(t5), Fraction: i2 ? (t5) => i2(t5) : noFraction };
  return function(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : `number`;
    if ((arguments.length > 2 ? arguments[2] : void 0) !== void 0) throw SyntaxError(`numeric() takes one or two arguments`);
    var r3 = typeOf(t5);
    if (!(r3 in a2)) throw TypeError(`Cannot convert ` + t5 + ` of type "` + r3 + `"; valid input types are ` + Object.keys(a2).join(`, `));
    if (!(n3 in o2)) throw TypeError(`Cannot convert ` + t5 + ` to type "` + n3 + `"; valid output types are ` + Object.keys(o2).join(`, `));
    return n3 === r3 ? t5 : o2[n3](t5);
  };
}), name$193 = `divideScalar`, dependencies$193 = [`typed`, `numeric`], createDivideScalar = factory(name$193, dependencies$193, (t4) => {
  var { typed: n2, numeric: r2 } = t4;
  return n2(name$193, { "number, number": function(t5, n3) {
    return t5 / n3;
  }, "Complex, Complex": function(t5, n3) {
    return t5.div(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return t5.div(n3);
  }, "bigint, bigint": function(t5, n3) {
    return t5 / n3;
  }, "Fraction, Fraction": function(t5, n3) {
    return t5.div(n3);
  }, "Unit, number | Complex | Fraction | BigNumber | Unit": (t5, n3) => t5.divide(n3), "number | Fraction | Complex | BigNumber, Unit": (t5, n3) => n3.divideInto(t5) });
}), name$192 = `pow`, dependencies$192 = [`typed`, `config`, `identity`, `multiply`, `matrix`, `inv`, `fraction`, `number`, `Complex`], createPow = factory(name$192, dependencies$192, (t4) => {
  var { typed: n2, config: r2, identity: i2, multiply: a2, matrix: o2, inv: s2, number: c2, fraction: l2, Complex: u2 } = t4;
  return n2(name$192, { "number, number": d2, "Complex, Complex": function(t5, n3) {
    return t5.pow(n3);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return n3.isInteger() || t5 >= 0 || r2.predictable ? t5.pow(n3) : new u2(t5.toNumber(), 0).pow(n3.toNumber(), 0);
  }, "bigint, bigint": (t5, n3) => t5 ** n3, "Fraction, Fraction": function(t5, n3) {
    var i3 = t5.pow(n3);
    if (i3 != null) return i3;
    if (r2.predictable) throw Error(`Result of pow is non-rational and cannot be expressed as a fraction`);
    return d2(t5.valueOf(), n3.valueOf());
  }, "Array, number": p2, "Array, BigNumber": function(t5, n3) {
    return p2(t5, n3.toNumber());
  }, "Matrix, number": m2, "Matrix, BigNumber": function(t5, n3) {
    return m2(t5, n3.toNumber());
  }, "Unit, number | BigNumber": function(t5, n3) {
    return t5.pow(n3);
  } });
  function d2(t5, n3) {
    if (r2.predictable && !isInteger(n3) && t5 < 0) try {
      var i3 = l2(n3), a3 = c2(i3);
      if ((n3 === a3 || Math.abs((n3 - a3) / n3) < 1e-14) && i3.d % 2n == 1n) return (i3.n % 2n == 0n ? 1 : -1) * (-t5) ** +n3;
    } catch {
    }
    return r2.predictable && (t5 < -1 && n3 === 1 / 0 || t5 > -1 && t5 < 0 && n3 === -1 / 0) ? NaN : isInteger(n3) || t5 >= 0 || r2.predictable ? powNumber(t5, n3) : t5 * t5 < 1 && n3 === 1 / 0 || t5 * t5 > 1 && n3 === -1 / 0 ? 0 : new u2(t5, 0).pow(n3, 0);
  }
  function p2(t5, n3) {
    if (!isInteger(n3)) throw TypeError(`For A^b, b must be an integer (value is ` + n3 + `)`);
    var r3 = arraySize(t5);
    if (r3.length !== 2) throw Error(`For A^b, A must be 2 dimensional (A has ` + r3.length + ` dimensions)`);
    if (r3[0] !== r3[1]) throw Error(`For A^b, A must be square (size is ` + r3[0] + `x` + r3[1] + `)`);
    if (n3 < 0) try {
      return p2(s2(t5), -n3);
    } catch (t6) {
      throw t6.message === `Cannot calculate inverse, determinant is zero` ? TypeError(`For A^b, when A is not invertible, b must be a positive integer (value is ` + n3 + `)`) : t6;
    }
    for (var o3 = i2(r3[0]).valueOf(), c3 = t5; n3 >= 1; ) (n3 & 1) == 1 && (o3 = a2(c3, o3)), n3 >>= 1, c3 = a2(c3, c3);
    return o3;
  }
  function m2(t5, n3) {
    return o2(p2(t5.valueOf(), n3));
  }
}), NO_INT = `Number of decimals in function round must be an integer`, name$191 = `round`, dependencies$191 = [`typed`, `config`, `matrix`, `equalScalar`, `zeros`, `BigNumber`, `DenseMatrix`], createRound = factory(name$191, dependencies$191, (t4) => {
  var { typed: n2, config: r2, matrix: i2, equalScalar: a2, zeros: o2, BigNumber: s2, DenseMatrix: c2 } = t4, l2 = createMatAlgo11xS0s({ typed: n2, equalScalar: a2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: c2 }), d2 = createMatAlgo14xDs({ typed: n2 });
  function p2(t5) {
    return Math.abs(splitNumber(t5).exponent);
  }
  return n2(name$191, { number: function(t5) {
    var n3 = roundNumber(t5, p2(r2.relTol));
    return roundNumber(nearlyEqual$1(t5, n3, r2.relTol, r2.absTol) ? n3 : t5);
  }, "number, number": function(t5, n3) {
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return roundNumber(t5, n3);
    var a3 = roundNumber(t5, i3);
    return roundNumber(nearlyEqual$1(t5, a3, r2.relTol, r2.absTol) ? a3 : t5, n3);
  }, "number, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT);
    return new s2(t5).toDecimalPlaces(n3.toNumber());
  }, Complex: function(t5) {
    return t5.round();
  }, "Complex, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT);
    return t5.round(n3);
  }, "Complex, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT);
    var r3 = n3.toNumber();
    return t5.round(r3);
  }, BigNumber: function(t5) {
    var n3 = new s2(t5).toDecimalPlaces(p2(r2.relTol));
    return (nearlyEqual(t5, n3, r2.relTol, r2.absTol) ? n3 : t5).toDecimalPlaces(0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT);
    var i3 = p2(r2.relTol);
    if (n3 >= i3) return t5.toDecimalPlaces(n3.toNumber());
    var a3 = t5.toDecimalPlaces(i3);
    return (nearlyEqual(t5, a3, r2.relTol, r2.absTol) ? a3 : t5).toDecimalPlaces(n3.toNumber());
  }, bigint: (t5) => t5, "bigint, number": (t5, n3) => t5, "bigint, BigNumber": (t5, n3) => t5, Fraction: function(t5) {
    return t5.round();
  }, "Fraction, number": function(t5, n3) {
    if (n3 % 1) throw TypeError(NO_INT);
    return t5.round(n3);
  }, "Fraction, BigNumber": function(t5, n3) {
    if (!n3.isInteger()) throw TypeError(NO_INT);
    return t5.round(n3.toNumber());
  }, "Unit, number, Unit": n2.referToSelf((t5) => function(n3, r3, i3) {
    var a3 = n3.toNumeric(i3);
    return i3.multiply(t5(a3, r3));
  }), "Unit, BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => t5(n3, r3.toNumber(), i3)), "Array | Matrix, number | BigNumber, Unit": n2.referToSelf((t5) => (n3, r3, i3) => deepMap(n3, (n4) => t5(n4, r3, i3), true)), "Array | Matrix | Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3, 0, r3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5, true)), "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => l2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(n3, r3, t5, false)), "Array, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => d2(i2(n3), r3, t5, false).valueOf()), "number | Complex | BigNumber | Fraction, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : u2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => a2(n3, 0) ? o2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | Complex | BigNumber | Fraction, Array": n2.referToSelf((t5) => (n3, r3) => d2(i2(r3), n3, t5, true).valueOf()) });
}), name$190 = `log`, dependencies$190 = [`config`, `typed`, `typeOf`, `divideScalar`, `Complex`], nlg16 = Math.log(16), createLog = factory(name$190, dependencies$190, (t4) => {
  var { typed: n2, typeOf: r2, config: i2, divideScalar: a2, Complex: o2 } = t4;
  function s2(t5) {
    return t5.log();
  }
  function c2(t5) {
    return s2(new o2(t5, 0));
  }
  return n2(name$190, { number: function(t5) {
    return t5 >= 0 || i2.predictable ? logNumber(t5) : c2(t5);
  }, bigint: promoteLogarithm(nlg16, logNumber, i2, c2), Complex: s2, BigNumber: function(t5) {
    return !t5.isNegative() || i2.predictable ? t5.ln() : c2(t5.toNumber());
  }, "any, any": n2.referToSelf((t5) => (n3, i3) => {
    if (r2(n3) === `Fraction` && r2(i3) === `Fraction`) {
      var o3 = n3.log(i3);
      if (o3 !== null) return o3;
    }
    return a2(t5(n3), t5(i3));
  }) });
}), name$189 = `log1p`, dependencies$189 = [`typed`, `config`, `divideScalar`, `log`, `Complex`], createLog1p = factory(name$189, dependencies$189, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, log: a2, Complex: o2 } = t4;
  return n2(name$189, { number: function(t5) {
    return t5 >= -1 || r2.predictable ? log1p(t5) : s2(new o2(t5, 0));
  }, Complex: s2, BigNumber: function(t5) {
    var n3 = t5.plus(1);
    return !n3.isNegative() || r2.predictable ? n3.ln() : s2(new o2(t5.toNumber(), 0));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)), "any, any": n2.referToSelf((t5) => (n3, r3) => i2(t5(n3), a2(r3))) });
  function s2(t5) {
    var n3 = t5.re + 1;
    return new o2(Math.log(Math.sqrt(n3 * n3 + t5.im * t5.im)), Math.atan2(t5.im, n3));
  }
}), name$188 = `nthRoots`, dependencies$188 = [`config`, `typed`, `divideScalar`, `Complex`], createNthRoots = factory(name$188, dependencies$188, (t4) => {
  var { typed: n2, config: r2, divideScalar: i2, Complex: a2 } = t4, o2 = [function(t5) {
    return new a2(t5, 0);
  }, function(t5) {
    return new a2(0, t5);
  }, function(t5) {
    return new a2(-t5, 0);
  }, function(t5) {
    return new a2(0, -t5);
  }];
  function s2(t5, n3) {
    if (n3 < 0) throw Error(`Root must be greater than zero`);
    if (n3 === 0) throw Error(`Root must be non-zero`);
    if (n3 % 1 != 0) throw Error(`Root must be an integer`);
    if (t5 === 0 || t5.abs() === 0) return [new a2(0, 0)];
    var r3 = typeof t5 == `number`, i3;
    (r3 || t5.re === 0 || t5.im === 0) && (i3 = r3 ? 2 * (t5 < 0) : t5.im === 0 ? 2 * (t5.re < 0) : 2 * (t5.im < 0) + 1);
    for (var s3 = t5.arg(), c2 = t5.abs(), l2 = [], u2 = c2 ** (1 / n3), d2 = 0; d2 < n3; d2++) {
      var p2 = (i3 + 4 * d2) / n3;
      if (p2 === Math.round(p2)) {
        l2.push(o2[p2 % 4](u2));
        continue;
      }
      l2.push(new a2({ r: u2, phi: (s3 + 2 * Math.PI * d2) / n3 }));
    }
    return l2;
  }
  return n2(name$188, { Complex: function(t5) {
    return s2(t5, 2);
  }, "Complex, number": s2 });
}), name$187 = `dotPow`, dependencies$187 = [`typed`, `equalScalar`, `matrix`, `pow`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotPow = factory(name$187, dependencies$187, (t4) => {
  var { typed: n2, equalScalar: r2, matrix: i2, pow: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf({ typed: n2 }), u2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo11xS0s({ typed: n2, equalScalar: r2 }), p2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite({ typed: n2, matrix: i2, concat: s2 }), h2 = {};
  for (var g2 in a2.signatures) Object.prototype.hasOwnProperty.call(a2.signatures, g2) && !g2.includes(`Matrix`) && !g2.includes(`Array`) && (h2[g2] = a2.signatures[g2]);
  return n2(name$187, m2({ elop: n2(h2), SS: u2, DS: l2, Ss: d2, sS: p2 }));
}), name$186 = `dotDivide`, dependencies$186 = [`typed`, `matrix`, `equalScalar`, `divideScalar`, `DenseMatrix`, `concat`, `SparseMatrix`], createDotDivide = factory(name$186, dependencies$186, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, divideScalar: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo03xDSf({ typed: n2 }), d2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: c2 }), p2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 });
  return n2(name$186, createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 })({ elop: a2, SS: d2, DS: u2, SD: l2, Ss: p2, sS: m2 }));
});
function createSolveValidation(t4) {
  var { DenseMatrix: n2 } = t4;
  return function(t5, r2, i2) {
    var a2 = t5.size();
    if (a2.length !== 2) throw RangeError(`Matrix must be two dimensional (size: ` + format(a2) + `)`);
    var o2 = a2[0];
    if (o2 !== a2[1]) throw RangeError(`Matrix must be square (size: ` + format(a2) + `)`);
    var s2 = [];
    if (isMatrix(r2)) {
      var c2 = r2.size(), l2 = r2._data;
      if (c2.length === 1) {
        if (c2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var u2 = 0; u2 < o2; u2++) s2[u2] = [l2[u2]];
        return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
      }
      if (c2.length === 2) {
        if (c2[0] !== o2 || c2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        if (isDenseMatrix(r2)) {
          if (i2) {
            s2 = [];
            for (var d2 = 0; d2 < o2; d2++) s2[d2] = [l2[d2][0]];
            return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
          }
          return r2;
        }
        if (isSparseMatrix(r2)) {
          for (var p2 = 0; p2 < o2; p2++) s2[p2] = [0];
          for (var m2 = r2._values, h2 = r2._index, g2 = r2._ptr, v2 = g2[1], y2 = g2[0]; y2 < v2; y2++) {
            var b2 = h2[y2];
            s2[b2][0] = m2[y2];
          }
          return new n2({ data: s2, size: [o2, 1], datatype: r2._datatype });
        }
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
    if (isArray(r2)) {
      var x2 = arraySize(r2);
      if (x2.length === 1) {
        if (x2[0] !== o2) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var S2 = 0; S2 < o2; S2++) s2[S2] = [r2[S2]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      if (x2.length === 2) {
        if (x2[0] !== o2 || x2[1] !== 1) throw RangeError(`Dimension mismatch. Matrix columns must match vector length.`);
        for (var w2 = 0; w2 < o2; w2++) s2[w2] = [r2[w2][0]];
        return new n2({ data: s2, size: [o2, 1] });
      }
      throw RangeError(`Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.`);
    }
  };
}
var name$185 = `lsolve`, dependencies$185 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolve = factory(name$185, dependencies$185, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation({ DenseMatrix: c2 });
  return n2(name$185, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = 0; h2 < d3; h2++) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 + 1; b2 < u3; b2++) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = 0; v2 < d3; v2++) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1], D = w2; D < E; D++) {
          var O2 = m2[D];
          O2 === v2 ? b2 = p2[D] : O2 > v2 && (x2.push(p2[D]), S2.push(O2));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var j2 = i2(y2, b2), M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          r3[F] = [o2(r3[F][0] || 0, a2(j2, x2[M2]))];
        }
        g2[v2] = [j2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$184 = `usolve`, dependencies$184 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolve = factory(name$184, dependencies$184, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation({ DenseMatrix: c2 });
  return n2(name$184, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).valueOf();
  } });
  function u2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = [], m2 = t5._data, h2 = d3 - 1; h2 >= 0; h2--) {
      var g2 = r3[h2][0] || 0, v2 = void 0;
      if (s2(g2, 0)) v2 = 0;
      else {
        var y2 = m2[h2][h2];
        if (s2(y2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        v2 = i2(g2, y2);
        for (var b2 = h2 - 1; b2 >= 0; b2--) r3[b2] = [o2(r3[b2][0] || 0, a2(v2, m2[b2][h2]))];
      }
      p2[h2] = [v2];
    }
    return new c2({ data: p2, size: [u3, 1] });
  }
  function d2(t5, n3) {
    n3 = l2(t5, n3, true);
    for (var r3 = n3._data, u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = [], v2 = d3 - 1; v2 >= 0; v2--) {
      var y2 = r3[v2][0] || 0;
      if (s2(y2, 0)) g2[v2] = [0];
      else {
        for (var b2 = 0, x2 = [], S2 = [], w2 = h2[v2], E = h2[v2 + 1] - 1; E >= w2; E--) {
          var D = m2[E];
          D === v2 ? b2 = p2[E] : D < v2 && (x2.push(p2[E]), S2.push(D));
        }
        if (s2(b2, 0)) throw Error(`Linear system cannot be solved since matrix is singular`);
        for (var O2 = i2(y2, b2), j2 = 0, M2 = S2.length; j2 < M2; j2++) {
          var N2 = S2[j2];
          r3[N2] = [o2(r3[N2][0], a2(O2, x2[j2]))];
        }
        g2[v2] = [O2];
      }
    }
    return new c2({ data: g2, size: [u3, 1] });
  }
}), name$183 = `lsolveAll`, dependencies$183 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createLsolveAll = factory(name$183, dependencies$183, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation({ DenseMatrix: c2 });
  return n2(name$183, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1], m2 = 0; m2 < p2; m2++) for (var h2 = r3.length, g2 = 0; g2 < h2; g2++) {
      var v2 = r3[g2];
      if (!s2(u3[m2][m2], 0)) {
        v2[m2] = i2(v2[m2], u3[m2][m2]);
        for (var y2 = m2 + 1; y2 < p2; y2++) v2[y2] = o2(v2[y2], a2(v2[m2], u3[y2][m2]));
      } else if (!s2(v2[m2], 0)) {
        if (g2 === 0) return [];
        r3.splice(g2, 1), --g2, --h2;
      } else if (g2 === 0) {
        var b2 = [...v2];
        b2[m2] = 1;
        for (var x2 = m2 + 1; x2 < p2; x2++) b2[x2] = o2(b2[x2], u3[x2][m2]);
        r3.push(b2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = 0; g2 < d3; g2++) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = w2; O2 < E; O2++) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 > g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$182 = `usolveAll`, dependencies$182 = [`typed`, `matrix`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `equalScalar`, `DenseMatrix`], createUsolveAll = factory(name$182, dependencies$182, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, multiplyScalar: a2, subtractScalar: o2, equalScalar: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation({ DenseMatrix: c2 });
  return n2(name$182, { "SparseMatrix, Array | Matrix": function(t5, n3) {
    return d2(t5, n3);
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    return u2(t5, n3);
  }, "Array, Array | Matrix": function(t5, n3) {
    return u2(r2(t5), n3).map((t6) => t6.valueOf());
  } });
  function u2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._data, d3 = t5._size[0], p2 = t5._size[1] - 1; p2 >= 0; p2--) for (var m2 = r3.length, h2 = 0; h2 < m2; h2++) {
      var g2 = r3[h2];
      if (!s2(u3[p2][p2], 0)) {
        g2[p2] = i2(g2[p2], u3[p2][p2]);
        for (var v2 = p2 - 1; v2 >= 0; v2--) g2[v2] = o2(g2[v2], a2(g2[p2], u3[v2][p2]));
      } else if (!s2(g2[p2], 0)) {
        if (h2 === 0) return [];
        r3.splice(h2, 1), --h2, --m2;
      } else if (h2 === 0) {
        var y2 = [...g2];
        y2[p2] = 1;
        for (var b2 = p2 - 1; b2 >= 0; b2--) y2[b2] = o2(y2[b2], u3[b2][p2]);
        r3.push(y2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [d3, 1] }));
  }
  function d2(t5, n3) {
    for (var r3 = [l2(t5, n3, true)._data.map((t6) => t6[0])], u3 = t5._size[0], d3 = t5._size[1], p2 = t5._values, m2 = t5._index, h2 = t5._ptr, g2 = d3 - 1; g2 >= 0; g2--) for (var v2 = r3.length, y2 = 0; y2 < v2; y2++) {
      for (var b2 = r3[y2], x2 = [], S2 = [], w2 = h2[g2], E = h2[g2 + 1], D = 0, O2 = E - 1; O2 >= w2; O2--) {
        var j2 = m2[O2];
        j2 === g2 ? D = p2[O2] : j2 < g2 && (x2.push(p2[O2]), S2.push(j2));
      }
      if (!s2(D, 0)) {
        b2[g2] = i2(b2[g2], D);
        for (var M2 = 0, N2 = S2.length; M2 < N2; M2++) {
          var F = S2[M2];
          b2[F] = o2(b2[F], a2(b2[g2], x2[M2]));
        }
      } else if (!s2(b2[g2], 0)) {
        if (y2 === 0) return [];
        r3.splice(y2, 1), --y2, --v2;
      } else if (y2 === 0) {
        var I2 = [...b2];
        I2[g2] = 1;
        for (var L2 = 0, R2 = S2.length; L2 < R2; L2++) {
          var z2 = S2[L2];
          I2[z2] = o2(I2[z2], x2[L2]);
        }
        r3.push(I2);
      }
    }
    return r3.map((t6) => new c2({ data: t6.map((t7) => [t7]), size: [u3, 1] }));
  }
}), name$181 = `matAlgo08xS0Sid`, dependencies$181 = [`typed`, `equalScalar`], createMatAlgo08xS0Sid = factory(name$181, dependencies$181, (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return function(t5, i2, a2) {
    var o2 = t5._values, s2 = t5._index, c2 = t5._ptr, l2 = t5._size, u2 = t5._datatype || t5._data === void 0 ? t5._datatype : t5.getDataType(), d2 = i2._values, p2 = i2._index, m2 = i2._ptr, h2 = i2._size, g2 = i2._datatype || i2._data === void 0 ? i2._datatype : i2.getDataType();
    if (l2.length !== h2.length) throw new DimensionError(l2.length, h2.length);
    if (l2[0] !== h2[0] || l2[1] !== h2[1]) throw RangeError(`Dimension mismatch. Matrix A (` + l2 + `) must match Matrix B (` + h2 + `)`);
    if (!o2 || !d2) throw Error(`Cannot perform operation on Pattern Sparse Matrices`);
    var v2 = l2[0], y2 = l2[1], b2, x2 = r2, S2 = 0, w2 = a2;
    typeof u2 == `string` && u2 === g2 && u2 !== `mixed` && (b2 = u2, x2 = n2.find(r2, [b2, b2]), S2 = n2.convert(0, b2), w2 = n2.find(a2, [b2, b2]));
    for (var E = [], D = [], O2 = [], j2 = [], M2 = [], N2, F, I2, L2, R2 = 0; R2 < y2; R2++) {
      O2[R2] = D.length;
      var z2 = R2 + 1;
      for (F = c2[R2], I2 = c2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = s2[N2], M2[L2] = z2, j2[L2] = o2[N2], D.push(L2);
      for (F = m2[R2], I2 = m2[R2 + 1], N2 = F; N2 < I2; N2++) L2 = p2[N2], M2[L2] === z2 && (j2[L2] = w2(j2[L2], d2[N2]));
      for (N2 = O2[R2]; N2 < D.length; ) {
        L2 = D[N2];
        var V2 = j2[L2];
        x2(V2, S2) ? D.splice(N2, 1) : (E.push(V2), N2++);
      }
    }
    return O2[y2] = D.length, t5.createSparseMatrix({ values: E, index: D, ptr: O2, size: [v2, y2], datatype: u2 === t5._datatype && g2 === i2._datatype ? b2 : void 0 });
  };
}), createUseMatrixForArrayScalar = factory(`useMatrixForArrayScalar`, [`typed`, `matrix`], (t4) => {
  var { typed: n2, matrix: r2 } = t4;
  return { "Array, number": n2.referTo(`DenseMatrix, number`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "Array, BigNumber": n2.referTo(`DenseMatrix, BigNumber`, (t5) => (n3, i2) => t5(r2(n3), i2).valueOf()), "number, Array": n2.referTo(`number, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()), "BigNumber, Array": n2.referTo(`BigNumber, DenseMatrix`, (t5) => (n3, i2) => t5(n3, r2(i2)).valueOf()) };
}), name$180 = `leftShift`, dependencies$180 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createLeftShift = factory(name$180, dependencies$180, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid({ typed: n2 }), l2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs({ typed: n2 }), h2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar({ typed: n2, matrix: r2 });
  return n2(name$180, { "number, number": leftShiftNumber, "BigNumber, BigNumber": leftShiftBigNumber, "bigint, bigint": (t5, n3) => t5 << n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$179 = `rightArithShift`, dependencies$179 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightArithShift = factory(name$179, dependencies$179, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid({ typed: n2 }), l2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs({ typed: n2 }), h2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar({ typed: n2, matrix: r2 });
  return n2(name$179, { "number, number": rightArithShiftNumber, "BigNumber, BigNumber": rightArithShiftBigNumber, "bigint, bigint": (t5, n3) => t5 >> n3, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$178 = `rightLogShift`, dependencies$178 = [`typed`, `matrix`, `equalScalar`, `zeros`, `DenseMatrix`, `concat`], createRightLogShift = factory(name$178, dependencies$178, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo01xDSid({ typed: n2 }), l2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo08xS0Sid({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: o2 }), p2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), m2 = createMatAlgo14xDs({ typed: n2 }), h2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 }), g2 = createUseMatrixForArrayScalar({ typed: n2, matrix: r2 });
  return n2(name$178, { "number, number": rightLogShiftNumber, "SparseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : p2(n3, r3, t5, false)), "DenseMatrix, number | BigNumber": n2.referToSelf((t5) => (n3, r3) => i2(r3, 0) ? n3.clone() : m2(n3, r3, t5, false)), "number | BigNumber, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : d2(r3, n3, t5, true)), "number | BigNumber, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => i2(n3, 0) ? a2(r3.size(), r3.storage()) : m2(r3, n3, t5, true)) }, g2, h2({ SS: u2, DS: c2, SD: l2 }));
}), name$177 = `and`, dependencies$177 = [`typed`, `matrix`, `equalScalar`, `zeros`, `not`, `concat`], createAnd = factory(name$177, dependencies$177, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo06xS0S0({ typed: n2, equalScalar: i2 }), u2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo14xDs({ typed: n2 }), p2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$177, { "number, number": andNumber, "Complex, Complex": function(t5, n3) {
    return (t5.re !== 0 || t5.im !== 0) && (n3.re !== 0 || n3.im !== 0);
  }, "BigNumber, BigNumber": function(t5, n3) {
    return !t5.isZero() && !n3.isZero() && !t5.isNaN() && !n3.isNaN();
  }, "bigint, bigint": andNumber, "Unit, Unit": n2.referToSelf((t5) => (n3, r3) => t5(n3.value || 0, r3.value || 0)), "SparseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : u2(n3, r3, t5, false)), "DenseMatrix, any": n2.referToSelf((t5) => (n3, r3) => o2(r3) ? a2(n3.size(), n3.storage()) : d2(n3, r3, t5, false)), "any, SparseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : u2(r3, n3, t5, true)), "any, DenseMatrix": n2.referToSelf((t5) => (n3, r3) => o2(n3) ? a2(n3.size(), n3.storage()) : d2(r3, n3, t5, true)), "Array, any": n2.referToSelf((t5) => (n3, i3) => t5(r2(n3), i3).valueOf()), "any, Array": n2.referToSelf((t5) => (n3, i3) => t5(n3, r2(i3)).valueOf()) }, p2({ SS: l2, DS: c2 }));
}), name$176 = `compare`, dependencies$176 = [`typed`, `config`, `matrix`, `equalScalar`, `BigNumber`, `Fraction`, `DenseMatrix`, `concat`], createCompare = factory(name$176, dependencies$176, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, BigNumber: o2, Fraction: s2, DenseMatrix: c2, concat: l2 } = t4, u2 = createMatAlgo03xDSf({ typed: n2 }), d2 = createMatAlgo05xSfSf({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: c2 }), m2 = createMatrixAlgorithmSuite({ typed: n2, matrix: a2, concat: l2 }), h2 = createCompareUnits({ typed: n2 });
  return n2(name$176, createCompareNumber({ typed: n2, config: r2 }), { "boolean, boolean": function(t5, n3) {
    return t5 === n3 ? 0 : t5 > n3 ? 1 : -1;
  }, "BigNumber, BigNumber": function(t5, n3) {
    return nearlyEqual(t5, n3, r2.relTol, r2.absTol) ? new o2(0) : new o2(t5.cmp(n3));
  }, "bigint, bigint": function(t5, n3) {
    return t5 === n3 ? 0n : t5 > n3 ? 1n : -1n;
  }, "Fraction, Fraction": function(t5, n3) {
    return new s2(t5.compare(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, h2, m2({ SS: d2, DS: u2, Ss: p2 }));
}), createCompareNumber = factory(name$176, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$176, { "number, number": function(t5, n3) {
    return nearlyEqual$1(t5, n3, r2.relTol, r2.absTol) ? 0 : t5 > n3 ? 1 : -1;
  } });
}), require_naturalSort = __commonJSMin(((t4, n2) => {
  n2.exports = function t5(n3, r2) {
    var i2 = /(^([+\-]?(?:0|[1-9]\d*)(?:\.\d*)?(?:[eE][+\-]?\d+)?)?$|^0x[0-9a-f]+$|\d+)/gi, a2 = /(^[ ]*|[ ]*$)/g, o2 = /(^([\w ]+,?[\w ]+)?[\w ]+,?[\w ]+\d+:\d+(:\d+)?[\w ]?|^\d{1,4}[\/\-]\d{1,4}[\/\-]\d{1,4}|^\w+, \w+ \d+, \d{4})/, s2 = /^0x[0-9a-f]+$/i, c2 = /^0/, l2 = function(n4) {
      return t5.insensitive && (`` + n4).toLowerCase() || `` + n4;
    }, u2 = l2(n3).replace(a2, ``) || ``, d2 = l2(r2).replace(a2, ``) || ``, p2 = u2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), m2 = d2.replace(i2, `\0$1\0`).replace(/\0$/, ``).replace(/^\0/, ``).split(`\0`), h2 = parseInt(u2.match(s2), 16) || p2.length !== 1 && u2.match(o2) && Date.parse(u2), g2 = parseInt(d2.match(s2), 16) || h2 && d2.match(o2) && Date.parse(d2) || null, v2, y2;
    if (g2) {
      if (h2 < g2) return -1;
      if (h2 > g2) return 1;
    }
    for (var b2 = 0, x2 = Math.max(p2.length, m2.length); b2 < x2; b2++) {
      if (v2 = !(p2[b2] || ``).match(c2) && parseFloat(p2[b2]) || p2[b2] || 0, y2 = !(m2[b2] || ``).match(c2) && parseFloat(m2[b2]) || m2[b2] || 0, isNaN(v2) !== isNaN(y2)) return isNaN(v2) ? 1 : -1;
      if (typeof v2 != typeof y2 && (v2 += ``, y2 += ``), v2 < y2) return -1;
      if (v2 > y2) return 1;
    }
    return 0;
  };
})), import_naturalSort = __toESM(require_naturalSort()), name$175 = `compareNatural`, dependencies$175 = [`typed`, `compare`], createCompareNatural = factory(name$175, dependencies$175, (t4) => {
  var { typed: n2, compare: r2 } = t4, i2 = r2.signatures[`boolean,boolean`];
  return n2(name$175, { "any, any": a2 });
  function a2(t5, n3) {
    var l2 = typeOf(t5), u2 = typeOf(n3), d2;
    if ((l2 === `number` || l2 === `BigNumber` || l2 === `Fraction` || l2 === `bigint`) && (u2 === `number` || u2 === `BigNumber` || u2 === `Fraction` || u2 === `bigint`)) return d2 = r2(t5, n3), d2.toString() === `0` ? (0, import_naturalSort.default)(l2, u2) : d2 > 0 ? 1 : -1;
    var p2 = [`Array`, `DenseMatrix`, `SparseMatrix`];
    if (p2.includes(l2) || p2.includes(u2)) return d2 = o2(a2, t5, n3), d2 === 0 ? (0, import_naturalSort.default)(l2, u2) : d2;
    if (l2 !== u2) return (0, import_naturalSort.default)(l2, u2);
    if (l2 === `Complex`) return compareComplexNumbers(t5, n3);
    if (l2 === `Unit`) return t5.equalBase(n3) ? a2(t5.value, n3.value) : s2(a2, t5.formatUnits(), n3.formatUnits());
    if (l2 === `boolean`) return i2(t5, n3);
    if (l2 === `string`) return (0, import_naturalSort.default)(t5, n3);
    if (l2 === `Object`) return c2(a2, t5, n3);
    if (l2 === `null` || l2 === `undefined`) return 0;
    throw TypeError(`Unsupported type of value "` + l2 + `"`);
  }
  function o2(t5, n3, r3) {
    return isSparseMatrix(n3) && isSparseMatrix(r3) ? s2(t5, n3.toJSON().values, r3.toJSON().values) : isSparseMatrix(n3) ? o2(t5, n3.toArray(), r3) : isSparseMatrix(r3) ? o2(t5, n3, r3.toArray()) : isDenseMatrix(n3) ? o2(t5, n3.toJSON().data, r3) : isDenseMatrix(r3) ? o2(t5, n3, r3.toJSON().data) : Array.isArray(n3) ? Array.isArray(r3) ? s2(t5, n3, r3) : o2(t5, n3, [r3]) : o2(t5, [n3], r3);
  }
  function s2(t5, n3, r3) {
    for (var i3 = 0, a3 = Math.min(n3.length, r3.length); i3 < a3; i3++) {
      var o3 = t5(n3[i3], r3[i3]);
      if (o3 !== 0) return o3;
    }
    return n3.length > r3.length ? 1 : n3.length < r3.length ? -1 : 0;
  }
  function c2(t5, n3, r3) {
    var i3 = Object.keys(n3), a3 = Object.keys(r3);
    i3.sort(import_naturalSort.default), a3.sort(import_naturalSort.default);
    var o3 = s2(t5, i3, a3);
    if (o3 !== 0) return o3;
    for (var c3 = 0; c3 < i3.length; c3++) {
      var l2 = t5(n3[i3[c3]], r3[a3[c3]]);
      if (l2 !== 0) return l2;
    }
    return 0;
  }
});
function compareComplexNumbers(t4, n2) {
  return t4.re > n2.re ? 1 : t4.re < n2.re ? -1 : t4.im > n2.im ? 1 : t4.im < n2.im ? -1 : 0;
}
var name$174 = `compareText`, dependencies$174 = [`typed`, `matrix`, `concat`];
compareText.signature = `any, any`;
var createCompareText = factory(name$174, dependencies$174, (t4) => {
  var { typed: n2, matrix: r2, concat: i2 } = t4;
  return n2(name$174, compareText, createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: i2 })({ elop: compareText, Ds: true }));
}), name$173 = `equal`, dependencies$173 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `SparseMatrix`], createEqual = factory(name$173, dependencies$173, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf({ typed: n2 }), l2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2 });
  return n2(name$173, createEqualNumber({ typed: n2, equalScalar: i2 }), d2({ elop: i2, SS: l2, DS: c2, Ss: u2 }));
}), createEqualNumber = factory(name$173, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$173, { "any, any": function(t5, n3) {
    return t5 === null ? n3 === null : n3 === null ? t5 === null : t5 === void 0 ? n3 === void 0 : n3 === void 0 ? t5 === void 0 : r2(t5, n3);
  } });
}), name$172 = `equalText`, dependencies$172 = [`typed`, `compareText`, `isZero`], createEqualText = factory(name$172, dependencies$172, (t4) => {
  var { typed: n2, compareText: r2, isZero: i2 } = t4;
  return n2(name$172, { "any, any": function(t5, n3) {
    return i2(r2(t5, n3));
  } });
}), name$171 = `smaller`, dependencies$171 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmaller = factory(name$171, dependencies$171, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf({ typed: n2 }), u2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits({ typed: n2 });
  function h2(t5, n3) {
    return t5.lt(n3) && !nearlyEqual(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$171, createSmallerNumber({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 < n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 < n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === -1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function(t5, n3) {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createSmallerNumber = factory(name$171, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$171, { "number, number": function(t5, n3) {
    return t5 < n3 && !nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$170 = `smallerEq`, dependencies$170 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createSmallerEq = factory(name$170, dependencies$170, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf({ typed: n2 }), l2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits({ typed: n2 });
  return n2(name$170, createSmallerEqNumber({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 <= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.lte(n3) || nearlyEqual(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": (t5, n3) => t5 <= n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== 1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createSmallerEqNumber = factory(name$170, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$170, { "number, number": function(t5, n3) {
    return t5 <= n3 || nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$169 = `larger`, dependencies$169 = [`typed`, `config`, `bignumber`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLarger = factory(name$169, dependencies$169, (t4) => {
  var { typed: n2, config: r2, bignumber: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf({ typed: n2 }), u2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite({ typed: n2, matrix: a2, concat: s2 }), m2 = createCompareUnits({ typed: n2 });
  function h2(t5, n3) {
    return t5.gt(n3) && !nearlyEqual(t5, n3, r2.relTol, r2.absTol);
  }
  return n2(name$169, createLargerNumber({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 > n3, "BigNumber, BigNumber": h2, "bigint, bigint": (t5, n3) => t5 > n3, "Fraction, Fraction": (t5, n3) => t5.compare(n3) === 1, "Fraction, BigNumber": function(t5, n3) {
    return h2(i2(t5), n3);
  }, "BigNumber, Fraction": function(t5, n3) {
    return h2(t5, i2(n3));
  }, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, m2, p2({ SS: u2, DS: l2, Ss: d2 }));
}), createLargerNumber = factory(name$169, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$169, { "number, number": function(t5, n3) {
    return t5 > n3 && !nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$168 = `largerEq`, dependencies$168 = [`typed`, `config`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createLargerEq = factory(name$168, dependencies$168, (t4) => {
  var { typed: n2, config: r2, matrix: i2, DenseMatrix: a2, concat: o2, SparseMatrix: s2 } = t4, c2 = createMatAlgo03xDSf({ typed: n2 }), l2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: s2 }), u2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: a2 }), d2 = createMatrixAlgorithmSuite({ typed: n2, matrix: i2, concat: o2 }), p2 = createCompareUnits({ typed: n2 });
  return n2(name$168, createLargerEqNumber({ typed: n2, config: r2 }), { "boolean, boolean": (t5, n3) => t5 >= n3, "BigNumber, BigNumber": function(t5, n3) {
    return t5.gte(n3) || nearlyEqual(t5, n3, r2.relTol, r2.absTol);
  }, "bigint, bigint": function(t5, n3) {
    return t5 >= n3;
  }, "Fraction, Fraction": (t5, n3) => t5.compare(n3) !== -1, "Complex, Complex": function() {
    throw TypeError(`No ordering relation is defined for complex numbers`);
  } }, p2, d2({ SS: l2, DS: c2, Ss: u2 }));
}), createLargerEqNumber = factory(name$168, [`typed`, `config`], (t4) => {
  var { typed: n2, config: r2 } = t4;
  return n2(name$168, { "number, number": function(t5, n3) {
    return t5 >= n3 || nearlyEqual$1(t5, n3, r2.relTol, r2.absTol);
  } });
}), name$167 = `deepEqual`, dependencies$167 = [`typed`, `equal`], createDeepEqual = factory(name$167, dependencies$167, (t4) => {
  var { typed: n2, equal: r2 } = t4;
  return n2(name$167, { "any, any": function(t5, n3) {
    return i2(t5.valueOf(), n3.valueOf());
  } });
  function i2(t5, n3) {
    if (Array.isArray(t5)) if (Array.isArray(n3)) {
      var a2 = t5.length;
      if (a2 !== n3.length) return false;
      for (var o2 = 0; o2 < a2; o2++) if (!i2(t5[o2], n3[o2])) return false;
      return true;
    } else return false;
    else if (Array.isArray(n3)) return false;
    else return r2(t5, n3);
  }
}), name$166 = `unequal`, dependencies$166 = [`typed`, `config`, `equalScalar`, `matrix`, `DenseMatrix`, `concat`, `SparseMatrix`], createUnequal = factory(name$166, dependencies$166, (t4) => {
  var { typed: n2, config: r2, equalScalar: i2, matrix: a2, DenseMatrix: o2, concat: s2, SparseMatrix: c2 } = t4, l2 = createMatAlgo03xDSf({ typed: n2 }), u2 = createMatAlgo07xSSf({ typed: n2, SparseMatrix: c2 }), d2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite({ typed: n2, matrix: a2, concat: s2 });
  return n2(name$166, createUnequalNumber({ typed: n2, equalScalar: i2 }), p2({ elop: m2, SS: u2, DS: l2, Ss: d2 }));
  function m2(t5, n3) {
    return !i2(t5, n3);
  }
}), createUnequalNumber = factory(name$166, [`typed`, `equalScalar`], (t4) => {
  var { typed: n2, equalScalar: r2 } = t4;
  return n2(name$166, { "any, any": function(t5, n3) {
    return t5 === null ? n3 !== null : n3 === null ? t5 !== null : t5 === void 0 ? n3 !== void 0 : n3 === void 0 ? t5 !== void 0 : !r2(t5, n3);
  } });
}), name$165 = `partitionSelect`, dependencies$165 = [`typed`, `isNumeric`, `isNaN`, `compare`], createPartitionSelect = factory(name$165, dependencies$165, (t4) => {
  var { typed: n2, isNumeric: r2, isNaN: i2, compare: a2 } = t4, o2 = a2, s2 = (t5, n3) => -a2(t5, n3);
  return n2(name$165, { "Array | Matrix, number": function(t5, n3) {
    return c2(t5, n3, o2);
  }, "Array | Matrix, number, string": function(t5, n3, r3) {
    if (r3 === `asc`) return c2(t5, n3, o2);
    if (r3 === `desc`) return c2(t5, n3, s2);
    throw Error(`Compare string must be "asc" or "desc"`);
  }, "Array | Matrix, number, function": c2 });
  function c2(t5, n3, r3) {
    if (!isInteger(n3) || n3 < 0) throw Error(`k must be a non-negative integer`);
    if (isMatrix(t5)) {
      if (t5.size().length > 1) throw Error(`Only one dimensional matrices supported`);
      return l2(t5.valueOf(), n3, r3);
    }
    if (Array.isArray(t5)) return l2(t5, n3, r3);
  }
  function l2(t5, n3, a3) {
    if (n3 >= t5.length) throw Error(`k out of bounds`);
    for (var o3 = 0; o3 < t5.length; o3++) if (r2(t5[o3]) && i2(t5[o3])) return t5[o3];
    for (var s3 = 0, c3 = t5.length - 1; s3 < c3; ) {
      for (var l3 = s3, u2 = c3, d2 = t5[Math.floor(Math.random() * (c3 - s3 + 1)) + s3]; l3 < u2; ) if (a3(t5[l3], d2) >= 0) {
        var p2 = t5[u2];
        t5[u2] = t5[l3], t5[l3] = p2, --u2;
      } else ++l3;
      a3(t5[l3], d2) > 0 && --l3, n3 <= l3 ? c3 = l3 : s3 = l3 + 1;
    }
    return t5[n3];
  }
}), name$164 = `sort`, dependencies$164 = [`typed`, `matrix`, `compare`, `compareNatural`], createSort = factory(name$164, dependencies$164, (t4) => {
  var { typed: n2, matrix: r2, compare: i2, compareNatural: a2 } = t4, o2 = i2, s2 = (t5, n3) => -i2(t5, n3);
  return n2(name$164, { Array: function(t5) {
    return l2(t5), t5.sort(o2);
  }, Matrix: function(t5) {
    return u2(t5), r2(t5.toArray().sort(o2), t5.storage());
  }, "Array, function": function(t5, n3) {
    return l2(t5), t5.sort(n3);
  }, "Matrix, function": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(n3), t5.storage());
  }, "Array, string": function(t5, n3) {
    return l2(t5), t5.sort(c2(n3));
  }, "Matrix, string": function(t5, n3) {
    return u2(t5), r2(t5.toArray().sort(c2(n3)), t5.storage());
  } });
  function c2(t5) {
    if (t5 === `asc`) return o2;
    if (t5 === `desc`) return s2;
    if (t5 === `natural`) return a2;
    throw Error(`String "asc", "desc", or "natural" expected`);
  }
  function l2(t5) {
    if (arraySize(t5).length !== 1) throw Error(`One dimensional array expected`);
  }
  function u2(t5) {
    if (t5.size().length !== 1) throw Error(`One dimensional matrix expected`);
  }
}), name$163 = `max`, dependencies$163 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMax = factory(name$163, dependencies$163, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4;
  return n2(name$163, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`Scalar values expected in function max`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage(t6, `max`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage(n4, `max`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate max of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType(n3, r2))), n3;
  }
}), name$162 = `min`, dependencies$162 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMin = factory(name$162, dependencies$162, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4;
  return n2(name$162, { "Array | Matrix": c2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return reduce$1(t5, n3.valueOf(), s2);
  }, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`Scalar values expected in function min`);
    return c2(t5);
  } });
  function s2(t5, n3) {
    try {
      return a2(t5, n3) ? t5 : n3;
    } catch (t6) {
      throw improveErrorMessage(t6, `min`, n3);
    }
  }
  function c2(t5) {
    var n3;
    if (deepForEach(t5, function(t6) {
      try {
        (o2(t6) || n3 === void 0 || a2(t6, n3)) && (n3 = t6);
      } catch (n4) {
        throw improveErrorMessage(n4, `min`, t6);
      }
    }), n3 === void 0) throw Error(`Cannot calculate min of an empty array`);
    return typeof n3 == `string` && (n3 = i2(n3, safeNumberType(n3, r2))), n3;
  }
}), name$161 = `ImmutableDenseMatrix`, dependencies$161 = [`smaller`, `DenseMatrix`], createImmutableDenseMatrixClass = factory(name$161, dependencies$161, (t4) => {
  var { smaller: n2, DenseMatrix: r2 } = t4;
  function i2(t5, n3) {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (n3 && !isString(n3)) throw Error(`Invalid datatype: ` + n3);
    if (isMatrix(t5) || isArray(t5)) {
      var a2 = new r2(t5, n3);
      this._data = a2._data, this._size = a2._size, this._datatype = a2._datatype, this._min = null, this._max = null;
    } else if (t5 && isArray(t5.data) && isArray(t5.size)) this._data = t5.data, this._size = t5.size, this._datatype = t5.datatype, this._min = t5.min === void 0 ? null : t5.min, this._max = t5.max === void 0 ? null : t5.max;
    else if (t5) throw TypeError(`Unsupported type of data (` + typeOf(t5) + `)`);
    else this._data = [], this._size = [0], this._datatype = n3, this._min = null, this._max = null;
  }
  return i2.prototype = new r2(), i2.prototype.type = `ImmutableDenseMatrix`, i2.prototype.isImmutableDenseMatrix = true, i2.prototype.subset = function(t5) {
    switch (arguments.length) {
      case 1:
        var n3 = r2.prototype.subset.call(this, t5);
        return isMatrix(n3) ? new i2({ data: n3._data, size: n3._size, datatype: n3._datatype }) : n3;
      case 2:
      case 3:
        throw Error(`Cannot invoke set subset on an Immutable Matrix instance`);
      default:
        throw SyntaxError(`Wrong number of arguments`);
    }
  }, i2.prototype.set = function() {
    throw Error(`Cannot invoke set on an Immutable Matrix instance`);
  }, i2.prototype.resize = function() {
    throw Error(`Cannot invoke resize on an Immutable Matrix instance`);
  }, i2.prototype.reshape = function() {
    throw Error(`Cannot invoke reshape on an Immutable Matrix instance`);
  }, i2.prototype.clone = function() {
    return new i2({ data: clone$3(this._data), size: clone$3(this._size), datatype: this._datatype });
  }, i2.prototype.toJSON = function() {
    return { mathjs: `ImmutableDenseMatrix`, data: this._data, size: this._size, datatype: this._datatype };
  }, i2.fromJSON = function(t5) {
    return new i2(t5);
  }, i2.prototype.swapRows = function() {
    throw Error(`Cannot invoke swapRows on an Immutable Matrix instance`);
  }, i2.prototype.min = function() {
    if (this._min === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(r3, t5)) && (t5 = r3);
      }), this._min = t5 === null ? void 0 : t5;
    }
    return this._min;
  }, i2.prototype.max = function() {
    if (this._max === null) {
      var t5 = null;
      this.forEach(function(r3) {
        (t5 === null || n2(t5, r3)) && (t5 = r3);
      }), this._max = t5 === null ? void 0 : t5;
    }
    return this._max;
  }, i2;
}, { isClass: true }), name$160 = `Index`, dependencies$160 = [`ImmutableDenseMatrix`, `getMatrixDataType`], createIndexClass = factory(name$160, dependencies$160, (t4) => {
  var { ImmutableDenseMatrix: n2, getMatrixDataType: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._dimensions = [], this._sourceSize = [], this._isScalar = true;
    for (var t5 = 0, n3 = arguments.length; t5 < n3; t5++) {
      var o2 = t5 < 0 || arguments.length <= t5 ? void 0 : arguments[t5], s2 = isArray(o2), c2 = isMatrix(o2), l2 = typeof o2, u2 = null;
      if (isRange(o2)) this._dimensions.push(o2), this._isScalar = false;
      else if (s2 || c2) {
        var d2 = void 0;
        this._isScalar = false, r2(o2) === `boolean` ? (s2 && (d2 = a2(_booleansArrayToNumbersForIndex(o2).valueOf())), c2 && (d2 = a2(_booleansArrayToNumbersForIndex(o2._data).valueOf())), u2 = o2.valueOf().length) : d2 = a2(o2.valueOf()), this._dimensions.push(d2);
      } else if (l2 === `number`) this._dimensions.push(o2);
      else if (l2 === `bigint`) this._dimensions.push(Number(o2));
      else if (l2 === `string`) this._dimensions.push(o2);
      else throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      this._sourceSize.push(u2);
    }
  }
  i2.prototype.type = `Index`, i2.prototype.isIndex = true;
  function a2(t5) {
    for (var r3 = 0, i3 = t5.length; r3 < i3; r3++) if (!isNumber(t5[r3]) || !isInteger(t5[r3])) throw TypeError(`Index parameters must be positive integer numbers`);
    var a3 = new n2();
    return a3._data = t5, a3._size = [t5.length], a3;
  }
  return i2.prototype.clone = function() {
    var t5 = new i2();
    return t5._dimensions = clone$3(this._dimensions), t5._isScalar = this._isScalar, t5._sourceSize = this._sourceSize, t5;
  }, i2.create = function(t5) {
    var n3 = new i2();
    return i2.apply(n3, t5), n3;
  }, i2.prototype.size = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString(i3) || isNumber(i3) ? 1 : i3.size()[0];
    }
    return t5;
  }, i2.prototype.max = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString(i3) || isNumber(i3) ? i3 : i3.max();
    }
    return t5;
  }, i2.prototype.min = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5[n3] = isString(i3) || isNumber(i3) ? i3 : i3.min();
    }
    return t5;
  }, i2.prototype.forEach = function(t5) {
    for (var n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) t5(this._dimensions[n3], n3, this);
  }, i2.prototype.dimension = function(t5) {
    return isNumber(t5) ? this._dimensions[t5] ?? null : null;
  }, i2.prototype.isObjectProperty = function() {
    return this._dimensions.length === 1 && isString(this._dimensions[0]);
  }, i2.prototype.getObjectProperty = function() {
    return this.isObjectProperty() ? this._dimensions[0] : null;
  }, i2.prototype.isScalar = function() {
    return this._isScalar;
  }, i2.prototype.toArray = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      t5.push(isString(i3) || isNumber(i3) ? i3 : i3.toArray());
    }
    return t5;
  }, i2.prototype.valueOf = i2.prototype.toArray, i2.prototype.toString = function() {
    for (var t5 = [], n3 = 0, r3 = this._dimensions.length; n3 < r3; n3++) {
      var i3 = this._dimensions[n3];
      isString(i3) ? t5.push(JSON.stringify(i3)) : t5.push(i3.toString());
    }
    return `[` + t5.join(`, `) + `]`;
  }, i2.prototype.toJSON = function() {
    return { mathjs: `Index`, dimensions: this._dimensions };
  }, i2.fromJSON = function(t5) {
    return i2.create(t5.dimensions);
  }, i2;
}, { isClass: true });
function _booleansArrayToNumbersForIndex(t4) {
  var n2 = [];
  return t4.forEach((t5, r2) => {
    t5 && n2.push(r2);
  }), n2;
}
var name$159 = `FibonacciHeap`, dependencies$159 = [`smaller`, `larger`], createFibonacciHeapClass = factory(name$159, dependencies$159, (t4) => {
  var { smaller: n2, larger: r2 } = t4, i2 = 1 / Math.log((1 + Math.sqrt(5)) / 2);
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._minimum = null, this._size = 0;
  }
  a2.prototype.type = `FibonacciHeap`, a2.prototype.isFibonacciHeap = true, a2.prototype.insert = function(t5, r3) {
    var i3 = { key: t5, value: r3, degree: 0 };
    if (this._minimum) {
      var a3 = this._minimum;
      i3.left = a3, i3.right = a3.right, a3.right = i3, i3.right.left = i3, n2(t5, a3.key) && (this._minimum = i3);
    } else i3.left = i3, i3.right = i3, this._minimum = i3;
    return this._size++, i3;
  }, a2.prototype.size = function() {
    return this._size;
  }, a2.prototype.clear = function() {
    this._minimum = null, this._size = 0;
  }, a2.prototype.isEmpty = function() {
    return this._size === 0;
  }, a2.prototype.extractMinimum = function() {
    var t5 = this._minimum;
    if (t5 === null) return t5;
    for (var n3 = this._minimum, r3 = t5.degree, i3 = t5.child; r3 > 0; ) {
      var a3 = i3.right;
      i3.left.right = i3.right, i3.right.left = i3.left, i3.left = n3, i3.right = n3.right, n3.right = i3, i3.right.left = i3, i3.parent = null, i3 = a3, r3--;
    }
    return t5.left.right = t5.right, t5.right.left = t5.left, t5 === t5.right ? n3 = null : (n3 = t5.right, n3 = u2(n3, this._size)), this._size--, this._minimum = n3, t5;
  }, a2.prototype.remove = function(t5) {
    this._minimum = o2(this._minimum, t5, -1), this.extractMinimum();
  };
  function o2(t5, r3, i3) {
    r3.key = i3;
    var a3 = r3.parent;
    return a3 && n2(r3.key, a3.key) && (s2(t5, r3, a3), c2(t5, a3)), n2(r3.key, t5.key) && (t5 = r3), t5;
  }
  function s2(t5, n3, r3) {
    n3.left.right = n3.right, n3.right.left = n3.left, r3.degree--, r3.child === n3 && (r3.child = n3.right), r3.degree === 0 && (r3.child = null), n3.left = t5, n3.right = t5.right, t5.right = n3, n3.right.left = n3, n3.parent = null, n3.mark = false;
  }
  function c2(t5, n3) {
    var r3 = n3.parent;
    r3 && (n3.mark ? (s2(t5, n3, r3), c2(r3)) : n3.mark = true);
  }
  var l2 = function(t5, n3) {
    t5.left.right = t5.right, t5.right.left = t5.left, t5.parent = n3, n3.child ? (t5.left = n3.child, t5.right = n3.child.right, n3.child.right = t5, t5.right.left = t5) : (n3.child = t5, t5.right = t5, t5.left = t5), n3.degree++, t5.mark = false;
  };
  function u2(t5, a3) {
    var o3 = Math.floor(Math.log(a3) * i2) + 1, s3 = Array(o3), c3 = 0, u3 = t5;
    if (u3) for (c3++, u3 = u3.right; u3 !== t5; ) c3++, u3 = u3.right;
    for (var d2; c3 > 0; ) {
      for (var p2 = u3.degree, m2 = u3.right; d2 = s3[p2], d2; ) {
        if (r2(u3.key, d2.key)) {
          var h2 = d2;
          d2 = u3, u3 = h2;
        }
        l2(d2, u3), s3[p2] = null, p2++;
      }
      s3[p2] = u3, u3 = m2, c3--;
    }
    t5 = null;
    for (var g2 = 0; g2 < o3; g2++) d2 = s3[g2], d2 && (t5 ? (d2.left.right = d2.right, d2.right.left = d2.left, d2.left = t5, d2.right = t5.right, t5.right = d2, d2.right.left = d2, n2(d2.key, t5.key) && (t5 = d2)) : t5 = d2);
    return t5;
  }
  return a2;
}, { isClass: true }), name$158 = `Spa`, dependencies$158 = [`addScalar`, `equalScalar`, `FibonacciHeap`], createSpaClass = factory(name$158, dependencies$158, (t4) => {
  var { addScalar: n2, equalScalar: r2, FibonacciHeap: i2 } = t4;
  function a2() {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    this._values = [], this._heap = new i2();
  }
  return a2.prototype.type = `Spa`, a2.prototype.isSpa = true, a2.prototype.set = function(t5, n3) {
    if (this._values[t5]) this._values[t5].value = n3;
    else {
      var r3 = this._heap.insert(t5, n3);
      this._values[t5] = r3;
    }
  }, a2.prototype.get = function(t5) {
    var n3 = this._values[t5];
    return n3 ? n3.value : 0;
  }, a2.prototype.accumulate = function(t5, r3) {
    var i3 = this._values[t5];
    i3 ? i3.value = n2(i3.value, r3) : (i3 = this._heap.insert(t5, r3), this._values[t5] = i3);
  }, a2.prototype.forEach = function(t5, n3, i3) {
    var a3 = this._heap, o2 = this._values, s2 = [], c2 = a3.extractMinimum();
    for (c2 && s2.push(c2); c2 && c2.key <= n3; ) c2.key >= t5 && (r2(c2.value, 0) || i3(c2.key, c2.value, this)), c2 = a3.extractMinimum(), c2 && s2.push(c2);
    for (var l2 = 0; l2 < s2.length; l2++) {
      var u2 = s2[l2];
      c2 = a3.insert(u2.key, u2.value), o2[c2.key] = c2;
    }
  }, a2.prototype.swap = function(t5, n3) {
    var r3 = this._values[t5], i3 = this._values[n3];
    if (!r3 && i3) r3 = this._heap.insert(t5, i3.value), this._heap.remove(i3), this._values[t5] = r3, this._values[n3] = void 0;
    else if (r3 && !i3) i3 = this._heap.insert(n3, r3.value), this._heap.remove(r3), this._values[n3] = i3, this._values[t5] = void 0;
    else if (r3 && i3) {
      var a3 = r3.value;
      r3.value = i3.value, i3.value = a3;
    }
  }, a2;
}, { isClass: true });
function lruQueue(t4) {
  var n2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null), o2 = 0, s2 = function(t5) {
    var s3 = a2[t5];
    if (s3 && (delete i2[s3], delete a2[t5], --n2, r2 === s3)) {
      if (!n2) {
        o2 = 0, r2 = 1;
        return;
      }
      for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
    }
  };
  return t4 = Math.abs(t4), { hit: function(c2) {
    var l2 = a2[c2], u2 = ++o2;
    if (i2[u2] = c2, a2[c2] = u2, !l2) return ++n2, n2 <= t4 ? void 0 : (c2 = i2[r2], s2(c2), c2);
    if (delete i2[l2], r2 === l2) for (; !Object.prototype.hasOwnProperty.call(i2, ++r2); ) ;
  }, delete: s2, clear: function() {
    n2 = o2 = 0, r2 = 1, i2 = /* @__PURE__ */ Object.create(null), a2 = /* @__PURE__ */ Object.create(null);
  } };
}
function memoize$1(t4) {
  var { hasher: n2, limit: r2 } = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
  return r2 ??= 1 / 0, n2 ??= JSON.stringify, function i2() {
    typeof i2.cache != `object` && (i2.cache = { values: /* @__PURE__ */ new Map(), lru: lruQueue(r2 || 1 / 0) });
    var a2 = [...arguments], o2 = n2(a2);
    if (i2.cache.values.has(o2)) return i2.cache.lru.hit(o2), i2.cache.values.get(o2);
    var s2 = t4.apply(t4, a2);
    return i2.cache.values.set(o2, s2), i2.cache.values.delete(i2.cache.lru.hit(o2)), s2;
  };
}
var createBigNumberE = memoize$1(function(t4) {
  return new t4(1).exp();
}, { hasher }), createBigNumberPhi = memoize$1(function(t4) {
  return new t4(1).plus(new t4(5).sqrt()).div(2);
}, { hasher }), createBigNumberPi = memoize$1(function(t4) {
  return t4.acos(-1);
}, { hasher }), createBigNumberTau = memoize$1(function(t4) {
  return createBigNumberPi(t4).times(2);
}, { hasher });
function hasher(t4) {
  return t4[0].precision;
}
function ownKeys$2(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$2(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$2(Object(r2), true).forEach(function(n3) {
      _defineProperty(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$2(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$157 = `Unit`, dependencies$157 = [`?on`, `config`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `abs`, `fix`, `round`, `equal`, `isNumeric`, `format`, `number`, `Complex`, `BigNumber`, `Fraction`], createUnitClass = factory(name$157, dependencies$157, (t4) => {
  var { on: n2, config: r2, addScalar: i2, subtractScalar: a2, multiplyScalar: o2, divideScalar: s2, pow: c2, abs: l2, fix: u2, round: d2, equal: p2, isNumeric: m2, format: h2, number: g2, Complex: v2, BigNumber: y2, Fraction: b2 } = t4, x2 = g2, S2 = false, w2 = true;
  function E(t5, n3) {
    if (!(this instanceof E)) throw Error(`Constructor must be called with the new operator`);
    if (!(t5 == null || m2(t5) || isComplex(t5))) throw TypeError(`First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined`);
    if (this.fixPrefix = S2, this.skipAutomaticSimplification = w2, n3 === void 0) this.units = [], this.dimensions = ee2.map((t6) => 0);
    else if (typeof n3 == `string`) {
      var r3 = E.parse(n3);
      this.units = r3.units, this.dimensions = r3.dimensions;
    } else if (isUnit(n3) && n3.value === null) this.fixPrefix = n3.fixPrefix, this.skipAutomaticSimplification = n3.skipAutomaticSimplification, this.dimensions = n3.dimensions.slice(0), this.units = n3.units.map((t6) => _extends({}, t6));
    else throw TypeError(`Second parameter in Unit constructor must be a string or valueless Unit`);
    this.value = this._normalize(t5);
  }
  Object.defineProperty(E, "name", { value: `Unit` }), E.prototype.constructor = E, E.prototype.type = `Unit`, E.prototype.isUnit = true;
  var D, O2, j2;
  function M2() {
    for (; j2 === ` ` || j2 === `	`; ) I2();
  }
  function N2(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }
  function F(t5) {
    return t5 >= `0` && t5 <= `9`;
  }
  function I2() {
    O2++, j2 = D.charAt(O2);
  }
  function L2(t5) {
    O2 = t5, j2 = D.charAt(O2);
  }
  function R2() {
    var t5 = ``, n3 = O2;
    if (j2 === `+` ? I2() : j2 === `-` && (t5 += j2, I2()), !N2(j2)) return L2(n3), null;
    if (j2 === `.`) {
      if (t5 += j2, I2(), !F(j2)) return L2(n3), null;
    } else {
      for (; F(j2); ) t5 += j2, I2();
      j2 === `.` && (t5 += j2, I2());
    }
    for (; F(j2); ) t5 += j2, I2();
    if (j2 === `E` || j2 === `e`) {
      var r3 = ``, i3 = O2;
      if (r3 += j2, I2(), (j2 === `+` || j2 === `-`) && (r3 += j2, I2()), !F(j2)) return L2(i3), t5;
      for (t5 += r3; F(j2); ) t5 += j2, I2();
    }
    return t5;
  }
  function z2() {
    for (var t5 = ``; F(j2) || E.isValidAlpha(j2); ) t5 += j2, I2();
    var n3 = t5.charAt(0);
    return E.isValidAlpha(n3) ? t5 : null;
  }
  function V2(t5) {
    return j2 === t5 ? (I2(), t5) : null;
  }
  E.parse = function(t5, n3) {
    if (n3 ||= {}, D = t5, O2 = -1, j2 = ``, typeof D != `string`) throw TypeError(`Invalid argument in Unit.parse, string expected`);
    var i3 = new E();
    i3.units = [];
    var a3 = 1, o3 = false;
    I2(), M2();
    var s3 = R2(), c3 = null;
    if (s3) {
      if (r2.number === `BigNumber`) c3 = new y2(s3);
      else if (r2.number === `Fraction`) try {
        c3 = new b2(s3);
      } catch {
        c3 = parseFloat(s3);
      }
      else c3 = parseFloat(s3);
      M2(), V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) && (a3 = -1, o3 = true);
    }
    for (var l3 = [], u3 = 1; ; ) {
      for (M2(); j2 === `(`; ) l3.push(a3), u3 *= a3, a3 = 1, I2(), M2();
      var d3 = void 0;
      if (j2) {
        var p3 = j2;
        if (d3 = z2(), d3 === null) throw SyntaxError(`Unexpected "` + p3 + `" in "` + D + `" at index ` + O2.toString());
      } else break;
      var m3 = H2(d3);
      if (m3 === null) throw SyntaxError(`Unit "` + d3 + `" not found.`);
      var h3 = a3 * u3;
      if (M2(), V2(`^`)) {
        M2();
        var g3 = R2();
        if (g3 === null) throw SyntaxError(`In "` + t5 + `", "^" must be followed by a floating-point number`);
        h3 *= g3;
      }
      i3.units.push({ unit: m3.unit, prefix: m3.prefix, power: h3 });
      for (var v3 = 0; v3 < ee2.length; v3++) i3.dimensions[v3] += (m3.unit.dimensions[v3] || 0) * h3;
      for (M2(); j2 === `)`; ) {
        if (l3.length === 0) throw SyntaxError(`Unmatched ")" in "` + D + `" at index ` + O2.toString());
        u3 /= l3.pop(), I2(), M2();
      }
      if (o3 = false, V2(`*`) ? (a3 = 1, o3 = true) : V2(`/`) ? (a3 = -1, o3 = true) : a3 = 1, m3.unit.base) {
        var x3 = m3.unit.base.key;
        Z2.auto[x3] = { unit: m3.unit, prefix: m3.prefix };
      }
    }
    if (M2(), j2) throw SyntaxError(`Could not parse: "` + t5 + `"`);
    if (o3) throw SyntaxError(`Trailing characters: "` + t5 + `"`);
    if (l3.length !== 0) throw SyntaxError(`Unmatched "(" in "` + D + `"`);
    if (i3.units.length === 0 && !n3.allowNoUnits) throw SyntaxError(`"` + t5 + `" contains no units`);
    return i3.value = c3 === void 0 ? null : i3._normalize(c3), i3;
  }, E.prototype.clone = function() {
    var t5 = new E();
    t5.fixPrefix = this.fixPrefix, t5.skipAutomaticSimplification = this.skipAutomaticSimplification, t5.value = clone$3(this.value), t5.dimensions = this.dimensions.slice(0), t5.units = [];
    for (var n3 = 0; n3 < this.units.length; n3++) for (var r3 in t5.units[n3] = {}, this.units[n3]) hasOwnProperty$1$1(this.units[n3], r3) && (t5.units[n3][r3] = this.units[n3][r3]);
    return t5;
  }, E.prototype.valueType = function() {
    return typeOf(this.value);
  }, E.prototype._isDerived = function() {
    return this.units.length === 0 ? false : this.units.length > 1 || Math.abs(this.units[0].power - 1) > 1e-15;
  }, E.prototype._normalize = function(t5) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var n3 = t5, r3 = E._getNumberConverter(typeOf(t5)), i3 = 0; i3 < this.units.length; i3++) {
      var a3 = r3(this.units[i3].unit.value), s3 = r3(this.units[i3].prefix.value), l3 = r3(this.units[i3].power);
      n3 = o2(n3, c2(o2(a3, s3), l3));
    }
    return n3;
  }, E.prototype._denormalize = function(t5, n3) {
    if (t5 == null || this.units.length === 0) return t5;
    for (var r3 = t5, i3 = E._getNumberConverter(typeOf(t5)), a3 = 0; a3 < this.units.length; a3++) {
      var l3 = i3(this.units[a3].unit.value), u3 = i3(this.units[a3].prefix.value), d3 = i3(this.units[a3].power);
      r3 = s2(r3, c2(o2(l3, u3), d3));
    }
    return r3;
  };
  var H2 = memoize$1((t5) => {
    if (hasOwnProperty$1$1(X2, t5)) {
      var n3 = X2[t5];
      return { unit: n3, prefix: n3.prefixes[``] };
    }
    for (var r3 in X2) if (hasOwnProperty$1$1(X2, r3) && endsWith(t5, r3)) {
      var i3 = X2[r3], a3 = t5.length - r3.length, o3 = t5.substring(0, a3), s3 = hasOwnProperty$1$1(i3.prefixes, o3) ? i3.prefixes[o3] : void 0;
      if (s3 !== void 0) return { unit: i3, prefix: s3 };
    }
    return null;
  }, { hasher: (t5) => t5[0], limit: 100 });
  E.isValuelessUnit = function(t5) {
    return H2(t5) !== null;
  }, E.prototype.hasBase = function(t5) {
    if (typeof t5 == `string` && (t5 = Y2[t5]), !t5) return false;
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equalBase = function(t5) {
    for (var n3 = 0; n3 < ee2.length; n3++) if (Math.abs((this.dimensions[n3] || 0) - (t5.dimensions[n3] || 0)) > 1e-12) return false;
    return true;
  }, E.prototype.equals = function(t5) {
    return this.equalBase(t5) && p2(this.value, t5.value);
  }, E.prototype.multiply = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) + (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var s3 = _objectSpread$2({}, r3.units[a3]);
      n3.units.push(s3);
    }
    return this.value !== null || r3.value !== null ? n3.value = o2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.divideInto = function(t5) {
    return new E(t5).divide(this);
  }, E.prototype.divide = function(t5) {
    for (var n3 = this.clone(), r3 = isUnit(t5) ? t5 : new E(t5), i3 = 0; i3 < ee2.length; i3++) n3.dimensions[i3] = (this.dimensions[i3] || 0) - (r3.dimensions[i3] || 0);
    for (var a3 = 0; a3 < r3.units.length; a3++) {
      var o3 = _objectSpread$2(_objectSpread$2({}, r3.units[a3]), {}, { power: -r3.units[a3].power });
      n3.units.push(o3);
    }
    return this.value !== null || r3.value !== null ? n3.value = s2(this.value === null ? this._normalize(W2(r3.value)) : this.value, r3.value === null ? r3._normalize(W2(this.value)) : r3.value) : n3.value = null, isUnit(t5) && (n3.skipAutomaticSimplification = false), U2(n3);
  }, E.prototype.pow = function(t5) {
    for (var n3 = this.clone(), r3 = 0; r3 < ee2.length; r3++) n3.dimensions[r3] = (this.dimensions[r3] || 0) * t5;
    for (var i3 = 0; i3 < n3.units.length; i3++) n3.units[i3].power *= t5;
    return n3.value === null ? n3.value = null : n3.value = c2(n3.value, t5), n3.skipAutomaticSimplification = false, U2(n3);
  };
  function U2(t5) {
    return t5.equalBase(Y2.NONE) && t5.value !== null && !r2.predictable ? t5.value : t5;
  }
  function W2(t5) {
    return E._getNumberConverter(typeOf(t5))(1);
  }
  E.prototype.abs = function() {
    var t5 = this.clone();
    if (t5.value !== null) if (t5._isDerived() || t5.units.length === 0 || t5.units[0].unit.offset === 0) t5.value = l2(t5.value);
    else {
      var n3 = t5._numberConverter(), r3 = o2(n3(t5.units[0].unit.value), n3(t5.units[0].unit.offset));
      t5.value = a2(l2(i2(t5.value, r3)), r3);
    }
    for (var s3 in t5.units) (t5.units[s3].unit.name === `VA` || t5.units[s3].unit.name === `VAR`) && (t5.units[s3].unit = X2.W);
    return t5;
  }, E.prototype.to = function(t5) {
    var n3 = this.value === null ? this._normalize(1) : this.value, r3;
    if (typeof t5 == `string`) r3 = E.parse(t5);
    else if (isUnit(t5)) r3 = t5.clone();
    else throw Error(`String or Unit expected as parameter`);
    if (!this.equalBase(r3)) throw Error(`Units do not match ('${r3.toString()}' != '${this.toString()}')`);
    if (r3.value !== null) throw Error(`Cannot convert to a unit with a value`);
    if (this.value === null || this._isDerived() || this.units.length === 0 || r3.units.length === 0 || this.units[0].unit.offset === r3.units[0].unit.offset) r3.value = clone$3(n3);
    else {
      var s3 = E._getNumberConverter(typeOf(n3)), c3 = this.units[0].unit.value, l3 = this.units[0].unit.offset, u3 = o2(c3, l3), d3 = r3.units[0].unit.value, p3 = r3.units[0].unit.offset, m3 = o2(d3, p3);
      r3.value = i2(n3, s3(a2(u3, m3)));
    }
    return r3.fixPrefix = true, r3.skipAutomaticSimplification = true, r3;
  }, E.prototype.toNumber = function(t5) {
    return x2(this.toNumeric(t5));
  }, E.prototype.toNumeric = function(t5) {
    var n3 = t5 ? this.to(t5) : this.clone();
    return n3._isDerived() || n3.units.length === 0 ? n3._denormalize(n3.value) : n3._denormalize(n3.value, n3.units[0].prefix.value);
  }, E.prototype.toString = function() {
    return this.format();
  }, E.prototype.toJSON = function() {
    return { mathjs: `Unit`, value: this._denormalize(this.value), unit: this.units.length > 0 ? this.formatUnits() : null, fixPrefix: this.fixPrefix, skipSimp: this.skipAutomaticSimplification };
  }, E.fromJSON = function(t5) {
    var a3 = new E(t5.value, t5.unit ?? void 0);
    return a3.fixPrefix = t5.fixPrefix ?? S2, a3.skipAutomaticSimplification = t5.skipSimp ?? w2, a3;
  }, E.prototype.valueOf = E.prototype.toString, E.prototype.simplify = function() {
    var t5 = this.clone(), n3 = [], r3;
    for (var i3 in oe2) if (hasOwnProperty$1$1(oe2, i3) && t5.hasBase(Y2[i3])) {
      r3 = i3;
      break;
    }
    if (r3 === `NONE`) t5.units = [];
    else {
      var a3;
      if (r3 && hasOwnProperty$1$1(oe2, r3) && (a3 = oe2[r3]), a3) t5.units = [{ unit: a3.unit, prefix: a3.prefix, power: 1 }];
      else {
        for (var o3 = false, s3 = 0; s3 < ee2.length; s3++) {
          var c3 = ee2[s3];
          Math.abs(t5.dimensions[s3] || 0) > 1e-12 && (hasOwnProperty$1$1(oe2, c3) ? n3.push({ unit: oe2[c3].unit, prefix: oe2[c3].prefix, power: t5.dimensions[s3] || 0 }) : o3 = true);
        }
        n3.length < t5.units.length && !o3 && (t5.units = n3);
      }
    }
    return t5;
  }, E.prototype.toSI = function() {
    for (var t5 = this.clone(), n3 = [], r3 = 0; r3 < ee2.length; r3++) {
      var i3 = ee2[r3];
      if (Math.abs(t5.dimensions[r3] || 0) > 1e-12) if (hasOwnProperty$1$1(Z2.si, i3)) n3.push({ unit: Z2.si[i3].unit, prefix: Z2.si[i3].prefix, power: t5.dimensions[r3] || 0 });
      else throw Error(`Cannot express custom unit ` + i3 + ` in SI units`);
    }
    return t5.units = n3, t5.fixPrefix = true, t5.skipAutomaticSimplification = true, this.value === null ? t5 : (t5.value = null, this.to(t5));
  }, E.prototype.formatUnits = function() {
    for (var t5 = ``, n3 = ``, r3 = 0, i3 = 0, a3 = 0; a3 < this.units.length; a3++) this.units[a3].power > 0 ? (r3++, t5 += ` ` + this.units[a3].prefix.name + this.units[a3].unit.name, Math.abs(this.units[a3].power - 1) > 1e-15 && (t5 += `^` + this.units[a3].power)) : this.units[a3].power < 0 && i3++;
    if (i3 > 0) for (var o3 = 0; o3 < this.units.length; o3++) this.units[o3].power < 0 && (r3 > 0 ? (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, Math.abs(this.units[o3].power + 1) > 1e-15 && (n3 += `^` + -this.units[o3].power)) : (n3 += ` ` + this.units[o3].prefix.name + this.units[o3].unit.name, n3 += `^` + this.units[o3].power));
    t5 = t5.substr(1), n3 = n3.substr(1), r3 > 1 && i3 > 0 && (t5 = `(` + t5 + `)`), i3 > 1 && r3 > 0 && (n3 = `(` + n3 + `)`);
    var s3 = t5;
    return r3 > 0 && i3 > 0 && (s3 += ` / `), s3 += n3, s3;
  }, E.prototype.toBest = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : [], n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {};
    if (t5 && !Array.isArray(t5)) throw Error(`Invalid unit type. Expected string or Unit.`);
    var r3 = this.units[0].unit.prefixes;
    if (t5 && t5.length > 0) {
      var i3 = t5.map((t6) => {
        var n4 = null;
        if (typeof t6 == `string`) {
          if (n4 = E.parse(t6), !n4) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        } else if (!isUnit(t6)) throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        n4 === null && (n4 = t6.clone());
        try {
          return this.to(n4.formatUnits()), n4;
        } catch {
          throw Error(`Invalid unit type. Expected compatible string or Unit.`);
        }
      }).map((t6) => t6.units[0].prefix);
      this.units[0].unit.prefixes = i3.reduce((t6, n4) => (t6[n4.name] = n4, t6), {}), this.units[0].prefix = i3[0];
    }
    var a3 = G2(this, n3).simp;
    return this.units[0].unit.prefixes = r3, a3.fixPrefix = true, a3;
  }, E.prototype.format = function(t5) {
    var { simp: n3, valueStr: r3, unitStr: i3 } = G2(this, t5), a3 = r3;
    return n3.value && isComplex(n3.value) && (a3 = `(` + a3 + `)`), i3.length > 0 && a3.length > 0 && (a3 += ` `), a3 += i3, a3;
  };
  function G2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = t5.skipAutomaticSimplification || t5.value === null ? t5.clone() : t5.simplify();
    K2(r3), q2(r3, n3.offset);
    var i3 = r3._denormalize(r3.value);
    return { simp: r3, valueStr: r3.value === null ? `` : h2(i3, n3 || {}), unitStr: r3.formatUnits() };
  }
  function K2(t5) {
    var n3 = false;
    for (var r3 in t5.value !== void 0 && t5.value !== null && isComplex(t5.value) && (n3 = Math.abs(t5.value.re) < 1e-14), t5.units) hasOwnProperty$1$1(t5.units, r3) && t5.units[r3].unit && (t5.units[r3].unit.name === `VA` && n3 ? t5.units[r3].unit = X2.VAR : t5.units[r3].unit.name === `VAR` && !n3 && (t5.units[r3].unit = X2.VA));
  }
  function q2(t5, n3) {
    t5.units.length === 1 && !t5.fixPrefix && Math.abs(t5.units[0].power - Math.round(t5.units[0].power)) < 1e-14 && (t5.units[0].prefix = t5._bestPrefix(n3));
  }
  E.prototype._bestPrefix = function() {
    var t5 = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : 1.2;
    if (this.units.length !== 1 || Math.abs(this.units[0].power - Math.round(this.units[0].power)) >= 1e-14) throw Error(`Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!`);
    var n3 = this.value === null ? 0 : l2(this.value), r3 = l2(this.units[0].unit.value), i3 = this.units[0].prefix;
    if (n3 === 0) return i3;
    var a3 = this.units[0].power, o3 = Math.log(n3 / (i3.value * r3) ** +a3) / Math.LN10 - t5;
    if (o3 > -2.200001 && o3 < 1.800001) return i3;
    o3 = Math.abs(o3);
    var s3 = this.units[0].unit.prefixes;
    for (var c3 in s3) if (hasOwnProperty$1$1(s3, c3)) {
      var u3 = s3[c3];
      if (u3.scientific) {
        var d3 = Math.abs(Math.log(n3 / (u3.value * r3) ** +a3) / Math.LN10 - t5);
        (d3 < o3 || d3 === o3 && u3.name.length < i3.name.length) && (i3 = u3, o3 = d3);
      }
    }
    return i3;
  }, E.prototype.splitUnit = function(t5) {
    for (var n3 = this.clone(), r3 = [], o3 = 0; o3 < t5.length && (n3 = n3.to(t5[o3]), o3 !== t5.length - 1); o3++) {
      var s3 = n3.toNumeric(), c3 = d2(s3), l3 = void 0;
      l3 = p2(c3, s3) ? c3 : u2(n3.toNumeric());
      var m3 = new E(l3, t5[o3].toString());
      r3.push(m3), n3 = a2(n3, m3);
    }
    for (var h3 = 0, g3 = 0; g3 < r3.length; g3++) h3 = i2(h3, r3[g3].value);
    return p2(h3, this.value) && (n3.value = 0), r3.push(n3), r3;
  };
  var J = { NONE: { "": { name: ``, value: 1, scientific: true } }, SHORT: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 10, scientific: false }, h: { name: `h`, value: 100, scientific: false }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true }, R: { name: `R`, value: 1e27, scientific: true }, Q: { name: `Q`, value: 1e30, scientific: true }, d: { name: `d`, value: 0.1, scientific: false }, c: { name: `c`, value: 0.01, scientific: false }, m: { name: `m`, value: 1e-3, scientific: true }, u: { name: `u`, value: 1e-6, scientific: true }, n: { name: `n`, value: 1e-9, scientific: true }, p: { name: `p`, value: 1e-12, scientific: true }, f: { name: `f`, value: 1e-15, scientific: true }, a: { name: `a`, value: 1e-18, scientific: true }, z: { name: `z`, value: 1e-21, scientific: true }, y: { name: `y`, value: 1e-24, scientific: true }, r: { name: `r`, value: 1e-27, scientific: true }, q: { name: `q`, value: 1e-30, scientific: true } }, LONG: { "": { name: ``, value: 1, scientific: true }, deca: { name: `deca`, value: 10, scientific: false }, hecto: { name: `hecto`, value: 100, scientific: false }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true }, ronna: { name: `ronna`, value: 1e27, scientific: true }, quetta: { name: `quetta`, value: 1e30, scientific: true }, deci: { name: `deci`, value: 0.1, scientific: false }, centi: { name: `centi`, value: 0.01, scientific: false }, milli: { name: `milli`, value: 1e-3, scientific: true }, micro: { name: `micro`, value: 1e-6, scientific: true }, nano: { name: `nano`, value: 1e-9, scientific: true }, pico: { name: `pico`, value: 1e-12, scientific: true }, femto: { name: `femto`, value: 1e-15, scientific: true }, atto: { name: `atto`, value: 1e-18, scientific: true }, zepto: { name: `zepto`, value: 1e-21, scientific: true }, yocto: { name: `yocto`, value: 1e-24, scientific: true }, ronto: { name: `ronto`, value: 1e-27, scientific: true }, quecto: { name: `quecto`, value: 1e-30, scientific: true } }, SQUARED: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 100, scientific: false }, h: { name: `h`, value: 1e4, scientific: false }, k: { name: `k`, value: 1e6, scientific: true }, M: { name: `M`, value: 1e12, scientific: true }, G: { name: `G`, value: 1e18, scientific: true }, T: { name: `T`, value: 1e24, scientific: true }, P: { name: `P`, value: 1e30, scientific: true }, E: { name: `E`, value: 1e36, scientific: true }, Z: { name: `Z`, value: 1e42, scientific: true }, Y: { name: `Y`, value: 1e48, scientific: true }, R: { name: `R`, value: 1e54, scientific: true }, Q: { name: `Q`, value: 1e60, scientific: true }, d: { name: `d`, value: 0.01, scientific: false }, c: { name: `c`, value: 1e-4, scientific: false }, m: { name: `m`, value: 1e-6, scientific: true }, u: { name: `u`, value: 1e-12, scientific: true }, n: { name: `n`, value: 1e-18, scientific: true }, p: { name: `p`, value: 1e-24, scientific: true }, f: { name: `f`, value: 1e-30, scientific: true }, a: { name: `a`, value: 1e-36, scientific: true }, z: { name: `z`, value: 1e-42, scientific: true }, y: { name: `y`, value: 1e-48, scientific: true }, r: { name: `r`, value: 1e-54, scientific: true }, q: { name: `q`, value: 1e-60, scientific: true } }, CUBIC: { "": { name: ``, value: 1, scientific: true }, da: { name: `da`, value: 1e3, scientific: false }, h: { name: `h`, value: 1e6, scientific: false }, k: { name: `k`, value: 1e9, scientific: true }, M: { name: `M`, value: 1e18, scientific: true }, G: { name: `G`, value: 1e27, scientific: true }, T: { name: `T`, value: 1e36, scientific: true }, P: { name: `P`, value: 1e45, scientific: true }, E: { name: `E`, value: 1e54, scientific: true }, Z: { name: `Z`, value: 1e63, scientific: true }, Y: { name: `Y`, value: 1e72, scientific: true }, R: { name: `R`, value: 1e81, scientific: true }, Q: { name: `Q`, value: 1e90, scientific: true }, d: { name: `d`, value: 1e-3, scientific: false }, c: { name: `c`, value: 1e-6, scientific: false }, m: { name: `m`, value: 1e-9, scientific: true }, u: { name: `u`, value: 1e-18, scientific: true }, n: { name: `n`, value: 1e-27, scientific: true }, p: { name: `p`, value: 1e-36, scientific: true }, f: { name: `f`, value: 1e-45, scientific: true }, a: { name: `a`, value: 1e-54, scientific: true }, z: { name: `z`, value: 1e-63, scientific: true }, y: { name: `y`, value: 1e-72, scientific: true }, r: { name: `r`, value: 1e-81, scientific: true }, q: { name: `q`, value: 1e-90, scientific: true } }, BINARY_SHORT_SI: { "": { name: ``, value: 1, scientific: true }, k: { name: `k`, value: 1e3, scientific: true }, M: { name: `M`, value: 1e6, scientific: true }, G: { name: `G`, value: 1e9, scientific: true }, T: { name: `T`, value: 1e12, scientific: true }, P: { name: `P`, value: 1e15, scientific: true }, E: { name: `E`, value: 1e18, scientific: true }, Z: { name: `Z`, value: 1e21, scientific: true }, Y: { name: `Y`, value: 1e24, scientific: true } }, BINARY_SHORT_IEC: { "": { name: ``, value: 1, scientific: true }, Ki: { name: `Ki`, value: 1024, scientific: true }, Mi: { name: `Mi`, value: 1024 ** 2, scientific: true }, Gi: { name: `Gi`, value: 1024 ** 3, scientific: true }, Ti: { name: `Ti`, value: 1024 ** 4, scientific: true }, Pi: { name: `Pi`, value: 1024 ** 5, scientific: true }, Ei: { name: `Ei`, value: 1024 ** 6, scientific: true }, Zi: { name: `Zi`, value: 1024 ** 7, scientific: true }, Yi: { name: `Yi`, value: 1024 ** 8, scientific: true } }, BINARY_LONG_SI: { "": { name: ``, value: 1, scientific: true }, kilo: { name: `kilo`, value: 1e3, scientific: true }, mega: { name: `mega`, value: 1e6, scientific: true }, giga: { name: `giga`, value: 1e9, scientific: true }, tera: { name: `tera`, value: 1e12, scientific: true }, peta: { name: `peta`, value: 1e15, scientific: true }, exa: { name: `exa`, value: 1e18, scientific: true }, zetta: { name: `zetta`, value: 1e21, scientific: true }, yotta: { name: `yotta`, value: 1e24, scientific: true } }, BINARY_LONG_IEC: { "": { name: ``, value: 1, scientific: true }, kibi: { name: `kibi`, value: 1024, scientific: true }, mebi: { name: `mebi`, value: 1024 ** 2, scientific: true }, gibi: { name: `gibi`, value: 1024 ** 3, scientific: true }, tebi: { name: `tebi`, value: 1024 ** 4, scientific: true }, pebi: { name: `pebi`, value: 1024 ** 5, scientific: true }, exi: { name: `exi`, value: 1024 ** 6, scientific: true }, zebi: { name: `zebi`, value: 1024 ** 7, scientific: true }, yobi: { name: `yobi`, value: 1024 ** 8, scientific: true } }, BTU: { "": { name: ``, value: 1, scientific: true }, MM: { name: `MM`, value: 1e6, scientific: true } } };
  J.SHORTLONG = _extends({}, J.SHORT, J.LONG), J.BINARY_SHORT = _extends({}, J.BINARY_SHORT_SI, J.BINARY_SHORT_IEC), J.BINARY_LONG = _extends({}, J.BINARY_LONG_SI, J.BINARY_LONG_IEC);
  var ee2 = [`MASS`, `LENGTH`, `TIME`, `CURRENT`, `TEMPERATURE`, `LUMINOUS_INTENSITY`, `AMOUNT_OF_SUBSTANCE`, `ANGLE`, `BIT`], Y2 = { NONE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 0] }, MASS: { dimensions: [1, 0, 0, 0, 0, 0, 0, 0, 0] }, LENGTH: { dimensions: [0, 1, 0, 0, 0, 0, 0, 0, 0] }, TIME: { dimensions: [0, 0, 1, 0, 0, 0, 0, 0, 0] }, CURRENT: { dimensions: [0, 0, 0, 1, 0, 0, 0, 0, 0] }, TEMPERATURE: { dimensions: [0, 0, 0, 0, 1, 0, 0, 0, 0] }, LUMINOUS_INTENSITY: { dimensions: [0, 0, 0, 0, 0, 1, 0, 0, 0] }, AMOUNT_OF_SUBSTANCE: { dimensions: [0, 0, 0, 0, 0, 0, 1, 0, 0] }, FORCE: { dimensions: [1, 1, -2, 0, 0, 0, 0, 0, 0] }, SURFACE: { dimensions: [0, 2, 0, 0, 0, 0, 0, 0, 0] }, VOLUME: { dimensions: [0, 3, 0, 0, 0, 0, 0, 0, 0] }, ENERGY: { dimensions: [1, 2, -2, 0, 0, 0, 0, 0, 0] }, POWER: { dimensions: [1, 2, -3, 0, 0, 0, 0, 0, 0] }, PRESSURE: { dimensions: [1, -1, -2, 0, 0, 0, 0, 0, 0] }, ELECTRIC_CHARGE: { dimensions: [0, 0, 1, 1, 0, 0, 0, 0, 0] }, ELECTRIC_CAPACITANCE: { dimensions: [-1, -2, 4, 2, 0, 0, 0, 0, 0] }, ELECTRIC_POTENTIAL: { dimensions: [1, 2, -3, -1, 0, 0, 0, 0, 0] }, ELECTRIC_RESISTANCE: { dimensions: [1, 2, -3, -2, 0, 0, 0, 0, 0] }, ELECTRIC_INDUCTANCE: { dimensions: [1, 2, -2, -2, 0, 0, 0, 0, 0] }, ELECTRIC_CONDUCTANCE: { dimensions: [-1, -2, 3, 2, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX: { dimensions: [1, 2, -2, -1, 0, 0, 0, 0, 0] }, MAGNETIC_FLUX_DENSITY: { dimensions: [1, 0, -2, -1, 0, 0, 0, 0, 0] }, FREQUENCY: { dimensions: [0, 0, -1, 0, 0, 0, 0, 0, 0] }, ANGLE: { dimensions: [0, 0, 0, 0, 0, 0, 0, 1, 0] }, BIT: { dimensions: [0, 0, 0, 0, 0, 0, 0, 0, 1] } };
  for (var te2 in Y2) hasOwnProperty$1$1(Y2, te2) && (Y2[te2].key = te2);
  var ne2 = { name: ``, base: {}, value: 1, offset: 0, dimensions: ee2.map((t5) => 0) }, X2 = { meter: { name: `meter`, base: Y2.LENGTH, prefixes: J.LONG, value: 1, offset: 0 }, inch: { name: `inch`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, foot: { name: `foot`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yard: { name: `yard`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mile: { name: `mile`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, link: { name: `link`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rod: { name: `rod`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.0292, offset: 0 }, chain: { name: `chain`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, angstrom: { name: `angstrom`, base: Y2.LENGTH, prefixes: J.NONE, value: 1e-10, offset: 0 }, m: { name: `m`, base: Y2.LENGTH, prefixes: J.SHORT, value: 1, offset: 0 }, in: { name: `in`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.0254, offset: 0 }, ft: { name: `ft`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.3048, offset: 0 }, yd: { name: `yd`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.9144, offset: 0 }, mi: { name: `mi`, base: Y2.LENGTH, prefixes: J.NONE, value: 1609.344, offset: 0 }, li: { name: `li`, base: Y2.LENGTH, prefixes: J.NONE, value: 0.201168, offset: 0 }, rd: { name: `rd`, base: Y2.LENGTH, prefixes: J.NONE, value: 5.02921, offset: 0 }, ch: { name: `ch`, base: Y2.LENGTH, prefixes: J.NONE, value: 20.1168, offset: 0 }, mil: { name: `mil`, base: Y2.LENGTH, prefixes: J.NONE, value: 254e-7, offset: 0 }, m2: { name: `m2`, base: Y2.SURFACE, prefixes: J.SQUARED, value: 1, offset: 0 }, sqin: { name: `sqin`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-8, offset: 0 }, sqft: { name: `sqft`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.09290304, offset: 0 }, sqyd: { name: `sqyd`, base: Y2.SURFACE, prefixes: J.NONE, value: 0.83612736, offset: 0 }, sqmi: { name: `sqmi`, base: Y2.SURFACE, prefixes: J.NONE, value: 2589988110336e-6, offset: 0 }, sqrd: { name: `sqrd`, base: Y2.SURFACE, prefixes: J.NONE, value: 25.29295, offset: 0 }, sqch: { name: `sqch`, base: Y2.SURFACE, prefixes: J.NONE, value: 404.6873, offset: 0 }, sqmil: { name: `sqmil`, base: Y2.SURFACE, prefixes: J.NONE, value: 64516e-14, offset: 0 }, acre: { name: `acre`, base: Y2.SURFACE, prefixes: J.NONE, value: 4046.86, offset: 0 }, hectare: { name: `hectare`, base: Y2.SURFACE, prefixes: J.NONE, value: 1e4, offset: 0 }, m3: { name: `m3`, base: Y2.VOLUME, prefixes: J.CUBIC, value: 1, offset: 0 }, L: { name: `L`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, l: { name: `l`, base: Y2.VOLUME, prefixes: J.SHORT, value: 1e-3, offset: 0 }, litre: { name: `litre`, base: Y2.VOLUME, prefixes: J.LONG, value: 1e-3, offset: 0 }, cuin: { name: `cuin`, base: Y2.VOLUME, prefixes: J.NONE, value: 16387064e-12, offset: 0 }, cuft: { name: `cuft`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.028316846592, offset: 0 }, cuyd: { name: `cuyd`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.764554857984, offset: 0 }, teaspoon: { name: `teaspoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-6, offset: 0 }, tablespoon: { name: `tablespoon`, base: Y2.VOLUME, prefixes: J.NONE, value: 15e-6, offset: 0 }, drop: { name: `drop`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, gtt: { name: `gtt`, base: Y2.VOLUME, prefixes: J.NONE, value: 5e-8, offset: 0 }, minim: { name: `minim`, base: Y2.VOLUME, prefixes: J.NONE, value: 61611519921875e-21, offset: 0 }, fluiddram: { name: `fluiddram`, base: Y2.VOLUME, prefixes: J.NONE, value: 36966911953125e-19, offset: 0 }, fluidounce: { name: `fluidounce`, base: Y2.VOLUME, prefixes: J.NONE, value: 295735295625e-16, offset: 0 }, gill: { name: `gill`, base: Y2.VOLUME, prefixes: J.NONE, value: 11829411825e-14, offset: 0 }, cc: { name: `cc`, base: Y2.VOLUME, prefixes: J.NONE, value: 1e-6, offset: 0 }, cup: { name: `cup`, base: Y2.VOLUME, prefixes: J.NONE, value: 2365882365e-13, offset: 0 }, pint: { name: `pint`, base: Y2.VOLUME, prefixes: J.NONE, value: 473176473e-12, offset: 0 }, quart: { name: `quart`, base: Y2.VOLUME, prefixes: J.NONE, value: 946352946e-12, offset: 0 }, gallon: { name: `gallon`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.003785411784, offset: 0 }, beerbarrel: { name: `beerbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.117347765304, offset: 0 }, oilbarrel: { name: `oilbarrel`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.158987294928, offset: 0 }, hogshead: { name: `hogshead`, base: Y2.VOLUME, prefixes: J.NONE, value: 0.238480942392, offset: 0 }, g: { name: `g`, base: Y2.MASS, prefixes: J.SHORT, value: 1e-3, offset: 0 }, gram: { name: `gram`, base: Y2.MASS, prefixes: J.LONG, value: 1e-3, offset: 0 }, ton: { name: `ton`, base: Y2.MASS, prefixes: J.SHORT, value: 907.18474, offset: 0 }, t: { name: `t`, base: Y2.MASS, prefixes: J.SHORT, value: 1e3, offset: 0 }, tonne: { name: `tonne`, base: Y2.MASS, prefixes: J.LONG, value: 1e3, offset: 0 }, grain: { name: `grain`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dram: { name: `dram`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, ounce: { name: `ounce`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, poundmass: { name: `poundmass`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, hundredweight: { name: `hundredweight`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, stick: { name: `stick`, base: Y2.MASS, prefixes: J.NONE, value: 0.115, offset: 0 }, stone: { name: `stone`, base: Y2.MASS, prefixes: J.NONE, value: 6.35029318, offset: 0 }, gr: { name: `gr`, base: Y2.MASS, prefixes: J.NONE, value: 6479891e-11, offset: 0 }, dr: { name: `dr`, base: Y2.MASS, prefixes: J.NONE, value: 0.0017718451953125, offset: 0 }, oz: { name: `oz`, base: Y2.MASS, prefixes: J.NONE, value: 0.028349523125, offset: 0 }, lbm: { name: `lbm`, base: Y2.MASS, prefixes: J.NONE, value: 0.45359237, offset: 0 }, cwt: { name: `cwt`, base: Y2.MASS, prefixes: J.NONE, value: 45.359237, offset: 0 }, s: { name: `s`, base: Y2.TIME, prefixes: J.SHORT, value: 1, offset: 0 }, min: { name: `min`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, h: { name: `h`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, second: { name: `second`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, sec: { name: `sec`, base: Y2.TIME, prefixes: J.LONG, value: 1, offset: 0 }, minute: { name: `minute`, base: Y2.TIME, prefixes: J.NONE, value: 60, offset: 0 }, hour: { name: `hour`, base: Y2.TIME, prefixes: J.NONE, value: 3600, offset: 0 }, day: { name: `day`, base: Y2.TIME, prefixes: J.NONE, value: 86400, offset: 0 }, week: { name: `week`, base: Y2.TIME, prefixes: J.NONE, value: 7 * 86400, offset: 0 }, month: { name: `month`, base: Y2.TIME, prefixes: J.NONE, value: 2629800, offset: 0 }, year: { name: `year`, base: Y2.TIME, prefixes: J.NONE, value: 31557600, offset: 0 }, decade: { name: `decade`, base: Y2.TIME, prefixes: J.NONE, value: 315576e3, offset: 0 }, century: { name: `century`, base: Y2.TIME, prefixes: J.NONE, value: 315576e4, offset: 0 }, millennium: { name: `millennium`, base: Y2.TIME, prefixes: J.NONE, value: 315576e5, offset: 0 }, hertz: { name: `Hertz`, base: Y2.FREQUENCY, prefixes: J.LONG, value: 1, offset: 0, reciprocal: true }, Hz: { name: `Hz`, base: Y2.FREQUENCY, prefixes: J.SHORT, value: 1, offset: 0, reciprocal: true }, rad: { name: `rad`, base: Y2.ANGLE, prefixes: J.SHORT, value: 1, offset: 0 }, radian: { name: `radian`, base: Y2.ANGLE, prefixes: J.LONG, value: 1, offset: 0 }, deg: { name: `deg`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, degree: { name: `degree`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, grad: { name: `grad`, base: Y2.ANGLE, prefixes: J.SHORT, value: null, offset: 0 }, gradian: { name: `gradian`, base: Y2.ANGLE, prefixes: J.LONG, value: null, offset: 0 }, cycle: { name: `cycle`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcsec: { name: `arcsec`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, arcmin: { name: `arcmin`, base: Y2.ANGLE, prefixes: J.NONE, value: null, offset: 0 }, A: { name: `A`, base: Y2.CURRENT, prefixes: J.SHORT, value: 1, offset: 0 }, ampere: { name: `ampere`, base: Y2.CURRENT, prefixes: J.LONG, value: 1, offset: 0 }, K: { name: `K`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 0 }, degC: { name: `degC`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: 1, offset: 273.15 }, degF: { name: `degF`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 459.67 }, degR: { name: `degR`, base: Y2.TEMPERATURE, prefixes: J.SHORT, value: new b2(5, 9), offset: 0 }, kelvin: { name: `kelvin`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 0 }, celsius: { name: `celsius`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: 1, offset: 273.15 }, fahrenheit: { name: `fahrenheit`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 459.67 }, rankine: { name: `rankine`, base: Y2.TEMPERATURE, prefixes: J.LONG, value: new b2(5, 9), offset: 0 }, mol: { name: `mol`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, mole: { name: `mole`, base: Y2.AMOUNT_OF_SUBSTANCE, prefixes: J.LONG, value: 1, offset: 0 }, cd: { name: `cd`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, candela: { name: `candela`, base: Y2.LUMINOUS_INTENSITY, prefixes: J.LONG, value: 1, offset: 0 }, N: { name: `N`, base: Y2.FORCE, prefixes: J.SHORT, value: 1, offset: 0 }, newton: { name: `newton`, base: Y2.FORCE, prefixes: J.LONG, value: 1, offset: 0 }, dyn: { name: `dyn`, base: Y2.FORCE, prefixes: J.SHORT, value: 1e-5, offset: 0 }, dyne: { name: `dyne`, base: Y2.FORCE, prefixes: J.LONG, value: 1e-5, offset: 0 }, lbf: { name: `lbf`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, poundforce: { name: `poundforce`, base: Y2.FORCE, prefixes: J.NONE, value: 4.4482216152605, offset: 0 }, kip: { name: `kip`, base: Y2.FORCE, prefixes: J.LONG, value: 4448.2216, offset: 0 }, kilogramforce: { name: `kilogramforce`, base: Y2.FORCE, prefixes: J.NONE, value: 9.80665, offset: 0 }, J: { name: `J`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1, offset: 0 }, joule: { name: `joule`, base: Y2.ENERGY, prefixes: J.LONG, value: 1, offset: 0 }, erg: { name: `erg`, base: Y2.ENERGY, prefixes: J.SHORTLONG, value: 1e-7, offset: 0 }, Wh: { name: `Wh`, base: Y2.ENERGY, prefixes: J.SHORT, value: 3600, offset: 0 }, BTU: { name: `BTU`, base: Y2.ENERGY, prefixes: J.BTU, value: 1055.05585262, offset: 0 }, eV: { name: `eV`, base: Y2.ENERGY, prefixes: J.SHORT, value: 1602176565e-28, offset: 0 }, electronvolt: { name: `electronvolt`, base: Y2.ENERGY, prefixes: J.LONG, value: 1602176565e-28, offset: 0 }, W: { name: `W`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, watt: { name: `watt`, base: Y2.POWER, prefixes: J.LONG, value: 1, offset: 0 }, hp: { name: `hp`, base: Y2.POWER, prefixes: J.NONE, value: 745.6998715386, offset: 0 }, VAR: { name: `VAR`, base: Y2.POWER, prefixes: J.SHORT, value: v2.I, offset: 0 }, VA: { name: `VA`, base: Y2.POWER, prefixes: J.SHORT, value: 1, offset: 0 }, Pa: { name: `Pa`, base: Y2.PRESSURE, prefixes: J.SHORT, value: 1, offset: 0 }, psi: { name: `psi`, base: Y2.PRESSURE, prefixes: J.NONE, value: 6894.75729276459, offset: 0 }, atm: { name: `atm`, base: Y2.PRESSURE, prefixes: J.NONE, value: 101325, offset: 0 }, bar: { name: `bar`, base: Y2.PRESSURE, prefixes: J.SHORTLONG, value: 1e5, offset: 0 }, torr: { name: `torr`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmHg: { name: `mmHg`, base: Y2.PRESSURE, prefixes: J.NONE, value: 133.322, offset: 0 }, mmH2O: { name: `mmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 9.80665, offset: 0 }, cmH2O: { name: `cmH2O`, base: Y2.PRESSURE, prefixes: J.NONE, value: 98.0665, offset: 0 }, coulomb: { name: `coulomb`, base: Y2.ELECTRIC_CHARGE, prefixes: J.LONG, value: 1, offset: 0 }, C: { name: `C`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 1, offset: 0 }, Ah: { name: `Ah`, base: Y2.ELECTRIC_CHARGE, prefixes: J.SHORT, value: 3600, offset: 0 }, farad: { name: `farad`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.LONG, value: 1, offset: 0 }, F: { name: `F`, base: Y2.ELECTRIC_CAPACITANCE, prefixes: J.SHORT, value: 1, offset: 0 }, volt: { name: `volt`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.LONG, value: 1, offset: 0 }, V: { name: `V`, base: Y2.ELECTRIC_POTENTIAL, prefixes: J.SHORT, value: 1, offset: 0 }, ohm: { name: `ohm`, base: Y2.ELECTRIC_RESISTANCE, prefixes: J.SHORTLONG, value: 1, offset: 0 }, henry: { name: `henry`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, H: { name: `H`, base: Y2.ELECTRIC_INDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, siemens: { name: `siemens`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.LONG, value: 1, offset: 0 }, S: { name: `S`, base: Y2.ELECTRIC_CONDUCTANCE, prefixes: J.SHORT, value: 1, offset: 0 }, weber: { name: `weber`, base: Y2.MAGNETIC_FLUX, prefixes: J.LONG, value: 1, offset: 0 }, Wb: { name: `Wb`, base: Y2.MAGNETIC_FLUX, prefixes: J.SHORT, value: 1, offset: 0 }, tesla: { name: `tesla`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.LONG, value: 1, offset: 0 }, T: { name: `T`, base: Y2.MAGNETIC_FLUX_DENSITY, prefixes: J.SHORT, value: 1, offset: 0 }, b: { name: `b`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 1, offset: 0 }, bits: { name: `bits`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 1, offset: 0 }, B: { name: `B`, base: Y2.BIT, prefixes: J.BINARY_SHORT, value: 8, offset: 0 }, bytes: { name: `bytes`, base: Y2.BIT, prefixes: J.BINARY_LONG, value: 8, offset: 0 } }, ie2 = { meters: `meter`, inches: `inch`, feet: `foot`, yards: `yard`, miles: `mile`, links: `link`, rods: `rod`, chains: `chain`, angstroms: `angstrom`, lt: `l`, litres: `litre`, liter: `litre`, liters: `litre`, teaspoons: `teaspoon`, tablespoons: `tablespoon`, minims: `minim`, fldr: `fluiddram`, fluiddrams: `fluiddram`, floz: `fluidounce`, fluidounces: `fluidounce`, gi: `gill`, gills: `gill`, cp: `cup`, cups: `cup`, pt: `pint`, pints: `pint`, qt: `quart`, quarts: `quart`, gal: `gallon`, gallons: `gallon`, bbl: `beerbarrel`, beerbarrels: `beerbarrel`, obl: `oilbarrel`, oilbarrels: `oilbarrel`, hogsheads: `hogshead`, gtts: `gtt`, grams: `gram`, tons: `ton`, tonnes: `tonne`, grains: `grain`, drams: `dram`, ounces: `ounce`, poundmasses: `poundmass`, hundredweights: `hundredweight`, sticks: `stick`, lb: `lbm`, lbs: `lbm`, kips: `kip`, kgf: `kilogramforce`, acres: `acre`, hectares: `hectare`, sqfeet: `sqft`, sqyard: `sqyd`, sqmile: `sqmi`, sqmiles: `sqmi`, mmhg: `mmHg`, mmh2o: `mmH2O`, cmh2o: `cmH2O`, seconds: `second`, secs: `second`, minutes: `minute`, mins: `minute`, hours: `hour`, hr: `hour`, hrs: `hour`, days: `day`, weeks: `week`, months: `month`, years: `year`, decades: `decade`, centuries: `century`, millennia: `millennium`, hertz: `hertz`, radians: `radian`, degrees: `degree`, gradians: `gradian`, cycles: `cycle`, arcsecond: `arcsec`, arcseconds: `arcsec`, arcminute: `arcmin`, arcminutes: `arcmin`, BTUs: `BTU`, watts: `watt`, joules: `joule`, amperes: `ampere`, amps: `ampere`, amp: `ampere`, coulombs: `coulomb`, volts: `volt`, ohms: `ohm`, farads: `farad`, webers: `weber`, teslas: `tesla`, electronvolts: `electronvolt`, moles: `mole`, bit: `bits`, byte: `bytes` };
  function ae2(t5) {
    if (t5.number === `BigNumber`) {
      var n3 = createBigNumberPi(y2);
      X2.rad.value = new y2(1), X2.deg.value = n3.div(180), X2.grad.value = n3.div(200), X2.cycle.value = n3.times(2), X2.arcsec.value = n3.div(648e3), X2.arcmin.value = n3.div(10800);
    } else X2.rad.value = 1, X2.deg.value = Math.PI / 180, X2.grad.value = Math.PI / 200, X2.cycle.value = Math.PI * 2, X2.arcsec.value = Math.PI / 648e3, X2.arcmin.value = Math.PI / 10800;
    X2.radian.value = X2.rad.value, X2.degree.value = X2.deg.value, X2.gradian.value = X2.grad.value;
  }
  ae2(r2), n2 && n2(`config`, function(t5, n3) {
    t5.number !== n3.number && ae2(t5);
  });
  var Z2 = { si: { NONE: { unit: ne2, prefix: J.NONE[``] }, LENGTH: { unit: X2.m, prefix: J.SHORT[``] }, MASS: { unit: X2.g, prefix: J.SHORT.k }, TIME: { unit: X2.s, prefix: J.SHORT[``] }, CURRENT: { unit: X2.A, prefix: J.SHORT[``] }, TEMPERATURE: { unit: X2.K, prefix: J.SHORT[``] }, LUMINOUS_INTENSITY: { unit: X2.cd, prefix: J.SHORT[``] }, AMOUNT_OF_SUBSTANCE: { unit: X2.mol, prefix: J.SHORT[``] }, ANGLE: { unit: X2.rad, prefix: J.SHORT[``] }, BIT: { unit: X2.bits, prefix: J.SHORT[``] }, FORCE: { unit: X2.N, prefix: J.SHORT[``] }, ENERGY: { unit: X2.J, prefix: J.SHORT[``] }, POWER: { unit: X2.W, prefix: J.SHORT[``] }, PRESSURE: { unit: X2.Pa, prefix: J.SHORT[``] }, ELECTRIC_CHARGE: { unit: X2.C, prefix: J.SHORT[``] }, ELECTRIC_CAPACITANCE: { unit: X2.F, prefix: J.SHORT[``] }, ELECTRIC_POTENTIAL: { unit: X2.V, prefix: J.SHORT[``] }, ELECTRIC_RESISTANCE: { unit: X2.ohm, prefix: J.SHORT[``] }, ELECTRIC_INDUCTANCE: { unit: X2.H, prefix: J.SHORT[``] }, ELECTRIC_CONDUCTANCE: { unit: X2.S, prefix: J.SHORT[``] }, MAGNETIC_FLUX: { unit: X2.Wb, prefix: J.SHORT[``] }, MAGNETIC_FLUX_DENSITY: { unit: X2.T, prefix: J.SHORT[``] }, FREQUENCY: { unit: X2.Hz, prefix: J.SHORT[``] } } };
  Z2.cgs = JSON.parse(JSON.stringify(Z2.si)), Z2.cgs.LENGTH = { unit: X2.m, prefix: J.SHORT.c }, Z2.cgs.MASS = { unit: X2.g, prefix: J.SHORT[``] }, Z2.cgs.FORCE = { unit: X2.dyn, prefix: J.SHORT[``] }, Z2.cgs.ENERGY = { unit: X2.erg, prefix: J.NONE[``] }, Z2.us = JSON.parse(JSON.stringify(Z2.si)), Z2.us.LENGTH = { unit: X2.ft, prefix: J.NONE[``] }, Z2.us.MASS = { unit: X2.lbm, prefix: J.NONE[``] }, Z2.us.TEMPERATURE = { unit: X2.degF, prefix: J.NONE[``] }, Z2.us.FORCE = { unit: X2.lbf, prefix: J.NONE[``] }, Z2.us.ENERGY = { unit: X2.BTU, prefix: J.BTU[``] }, Z2.us.POWER = { unit: X2.hp, prefix: J.NONE[``] }, Z2.us.PRESSURE = { unit: X2.psi, prefix: J.NONE[``] }, Z2.auto = JSON.parse(JSON.stringify(Z2.si));
  var oe2 = Z2.auto;
  for (var $2 in E.setUnitSystem = function(t5) {
    if (hasOwnProperty$1$1(Z2, t5)) oe2 = Z2[t5];
    else throw Error(`Unit system ` + t5 + ` does not exist. Choices are: ` + Object.keys(Z2).join(`, `));
  }, E.getUnitSystem = function() {
    for (var t5 in Z2) if (hasOwnProperty$1$1(Z2, t5) && Z2[t5] === oe2) return t5;
  }, E.typeConverters = { BigNumber: function(t5) {
    return t5 != null && t5.isFraction ? new y2(String(t5.n)).div(String(t5.d)).times(String(t5.s)) : new y2(t5 + ``);
  }, Fraction: function(t5) {
    return new b2(t5);
  }, Complex: function(t5) {
    return t5;
  }, number: function(t5) {
    return t5 != null && t5.isFraction ? g2(t5) : t5;
  } }, E.prototype._numberConverter = function() {
    var t5 = E.typeConverters[this.valueType()];
    if (t5) return t5;
    throw TypeError(`Unsupported Unit value type "` + this.valueType() + `"`);
  }, E._getNumberConverter = function(t5) {
    if (!E.typeConverters[t5]) throw TypeError(`Unsupported type "` + t5 + `"`);
    return E.typeConverters[t5];
  }, X2) if (hasOwnProperty$1$1(X2, $2)) {
    var se2 = X2[$2];
    se2.dimensions = se2.base.dimensions;
  }
  for (var ce2 in ie2) if (hasOwnProperty$1$1(ie2, ce2)) {
    var le2 = X2[ie2[ce2]], ue2 = {};
    for (var de2 in le2) hasOwnProperty$1$1(le2, de2) && (ue2[de2] = le2[de2]);
    ue2.name = ce2, X2[ce2] = ue2;
  }
  E.isValidAlpha = function(t5) {
    return /^[a-zA-Z]$/.test(t5);
  };
  function fe2(t5) {
    for (var n3 = 0; n3 < t5.length; n3++) {
      if (j2 = t5.charAt(n3), n3 === 0 && !E.isValidAlpha(j2)) throw Error(`Invalid unit name (must begin with alpha character): "` + t5 + `"`);
      if (n3 > 0 && !(E.isValidAlpha(j2) || F(j2))) throw Error(`Invalid unit name (only alphanumeric characters are allowed): "` + t5 + `"`);
    }
  }
  return E.createUnit = function(t5, n3) {
    if (typeof t5 != `object`) throw TypeError(`createUnit expects first parameter to be of type 'Object'`);
    if (n3 && n3.override) {
      for (var r3 in t5) if (hasOwnProperty$1$1(t5, r3) && E.deleteUnit(r3), t5[r3].aliases) for (var i3 = 0; i3 < t5[r3].aliases.length; i3++) E.deleteUnit(t5[r3].aliases[i3]);
    }
    var a3;
    for (var o3 in t5) hasOwnProperty$1$1(t5, o3) && (a3 = E.createUnitSingle(o3, t5[o3]));
    return a3;
  }, E.createUnitSingle = function(t5, n3) {
    if (n3 ??= {}, typeof t5 != `string`) throw TypeError(`createUnitSingle expects first parameter to be of type 'string'`);
    if (hasOwnProperty$1$1(X2, t5)) throw Error(`Cannot create unit "` + t5 + `": a unit with that name already exists`);
    fe2(t5);
    var r3 = null, i3 = [], a3 = 0, o3, s3, c3;
    if (n3 && n3.type === `Unit`) r3 = n3.clone();
    else if (typeof n3 == `string`) n3 !== `` && (o3 = n3);
    else if (typeof n3 == `object`) o3 = n3.definition, s3 = n3.prefixes, a3 = n3.offset, c3 = n3.baseName, n3.aliases && (i3 = n3.aliases.valueOf());
    else throw TypeError(`Cannot create unit "` + t5 + `" from "` + n3.toString() + `": expecting "string" or "Unit" or "Object"`);
    if (i3) {
      for (var l3 = 0; l3 < i3.length; l3++) if (hasOwnProperty$1$1(X2, i3[l3])) throw Error(`Cannot create alias "` + i3[l3] + `": a unit with that name already exists`);
    }
    if (o3 && typeof o3 == `string` && !r3) try {
      r3 = E.parse(o3, { allowNoUnits: true });
    } catch (n4) {
      throw n4.message = `Could not create unit "` + t5 + `" from "` + o3 + `": ` + n4.message, n4;
    }
    else o3 && o3.type === `Unit` && (r3 = o3.clone());
    i3 ||= [], a3 ||= 0, s3 = s3 && s3.toUpperCase && J[s3.toUpperCase()] || J.NONE;
    var u3 = {};
    if (r3) {
      u3 = { name: t5, value: r3.value, dimensions: r3.dimensions.slice(0), prefixes: s3, offset: a3 };
      var d3 = false;
      for (var p3 in Y2) if (hasOwnProperty$1$1(Y2, p3)) {
        for (var m3 = true, h3 = 0; h3 < ee2.length; h3++) if (Math.abs((u3.dimensions[h3] || 0) - (Y2[p3].dimensions[h3] || 0)) > 1e-12) {
          m3 = false;
          break;
        }
        if (m3) {
          d3 = true, u3.base = Y2[p3];
          break;
        }
      }
      if (!d3) {
        c3 ||= t5 + `_STUFF`;
        var g3 = { dimensions: r3.dimensions.slice(0) };
        g3.key = c3, Y2[c3] = g3, oe2[c3] = { unit: u3, prefix: J.NONE[``] }, u3.base = Y2[c3];
      }
    } else {
      if (c3 ||= t5 + `_STUFF`, ee2.indexOf(c3) >= 0) throw Error(`Cannot create new base unit "` + t5 + `": a base unit with that name already exists (and cannot be overridden)`);
      for (var v3 in ee2.push(c3), Y2) hasOwnProperty$1$1(Y2, v3) && (Y2[v3].dimensions[ee2.length - 1] = 0);
      for (var y3 = { dimensions: [] }, b3 = 0; b3 < ee2.length; b3++) y3.dimensions[b3] = 0;
      y3.dimensions[ee2.length - 1] = 1, y3.key = c3, Y2[c3] = y3, u3 = { name: t5, value: 1, dimensions: Y2[c3].dimensions.slice(0), prefixes: s3, offset: a3, base: Y2[c3] }, oe2[c3] = { unit: u3, prefix: J.NONE[``] };
    }
    E.UNITS[t5] = u3;
    for (var x3 = 0; x3 < i3.length; x3++) {
      var S3 = i3[x3], w3 = {};
      for (var D2 in u3) hasOwnProperty$1$1(u3, D2) && (w3[D2] = u3[D2]);
      w3.name = S3, E.UNITS[S3] = w3;
    }
    return delete H2.cache, new E(null, t5);
  }, E.deleteUnit = function(t5) {
    delete E.UNITS[t5], delete H2.cache;
  }, E.PREFIXES = J, E.BASE_DIMENSIONS = ee2, E.BASE_UNITS = Y2, E.UNIT_SYSTEMS = Z2, E.UNITS = X2, E;
}, { isClass: true }), name$156 = `unit`, dependencies$156 = [`typed`, `Unit`], createUnitFunction = factory(name$156, dependencies$156, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$156, { Unit: function(t5) {
    return t5.clone();
  }, string: function(t5) {
    return r2.isValuelessUnit(t5) ? new r2(null, t5) : r2.parse(t5, { allowNoUnits: true });
  }, "number | BigNumber | Fraction | Complex, string | Unit": function(t5, n3) {
    return new r2(t5, n3);
  }, "number | BigNumber | Fraction": function(t5) {
    return new r2(t5);
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$155 = `sparse`, dependencies$155 = [`typed`, `SparseMatrix`], createSparse = factory(name$155, dependencies$155, (t4) => {
  var { typed: n2, SparseMatrix: r2 } = t4;
  return n2(name$155, { "": function() {
    return new r2([]);
  }, string: function(t5) {
    return new r2([], t5);
  }, "Array | Matrix": function(t5) {
    return new r2(t5);
  }, "Array | Matrix, string": function(t5, n3) {
    return new r2(t5, n3);
  } });
}), name$154 = `createUnit`, dependencies$154 = [`typed`, `Unit`], createCreateUnit = factory(name$154, dependencies$154, (t4) => {
  var { typed: n2, Unit: r2 } = t4;
  return n2(name$154, { "Object, Object": function(t5, n3) {
    return r2.createUnit(t5, n3);
  }, Object: function(t5) {
    return r2.createUnit(t5, {});
  }, "string, Unit | string | Object, Object": function(t5, n3, i2) {
    var a2 = {};
    return a2[t5] = n3, r2.createUnit(a2, i2);
  }, "string, Unit | string | Object": function(t5, n3) {
    var i2 = {};
    return i2[t5] = n3, r2.createUnit(i2, {});
  }, string: function(t5) {
    var n3 = {};
    return n3[t5] = {}, r2.createUnit(n3, {});
  } });
}), name$153 = `acos`, dependencies$153 = [`typed`, `config`, `Complex`], createAcos = factory(name$153, dependencies$153, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$153, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.acos(t5) : new i2(t5, 0).acos();
  }, Complex: function(t5) {
    return t5.acos();
  }, BigNumber: function(t5) {
    return t5.acos();
  } });
}), name$152 = `acosh`, dependencies$152 = [`typed`, `config`, `Complex`], createAcosh = factory(name$152, dependencies$152, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$152, { number: function(t5) {
    return t5 >= 1 || r2.predictable ? acoshNumber(t5) : t5 <= -1 ? new i2(Math.log(Math.sqrt(t5 * t5 - 1) - t5), Math.PI) : new i2(t5, 0).acosh();
  }, Complex: function(t5) {
    return t5.acosh();
  }, BigNumber: function(t5) {
    return t5.acosh();
  } });
}), name$151 = `acot`, dependencies$151 = [`typed`, `BigNumber`], createAcot = factory(name$151, dependencies$151, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$151, { number: acotNumber, Complex: function(t5) {
    return t5.acot();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).atan();
  } });
}), name$150 = `acoth`, dependencies$150 = [`typed`, `config`, `Complex`, `BigNumber`], createAcoth = factory(name$150, dependencies$150, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$150, { number: function(t5) {
    return t5 >= 1 || t5 <= -1 || r2.predictable ? acothNumber(t5) : new i2(t5, 0).acoth();
  }, Complex: function(t5) {
    return t5.acoth();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).atanh();
  } });
}), name$149 = `acsc`, dependencies$149 = [`typed`, `config`, `Complex`, `BigNumber`], createAcsc = factory(name$149, dependencies$149, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$149, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? acscNumber(t5) : new i2(t5, 0).acsc();
  }, Complex: function(t5) {
    return t5.acsc();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).asin();
  } });
}), name$148 = `acsch`, dependencies$148 = [`typed`, `BigNumber`], createAcsch = factory(name$148, dependencies$148, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$148, { number: acschNumber, Complex: function(t5) {
    return t5.acsch();
  }, BigNumber: function(t5) {
    return new r2(1).div(t5).asinh();
  } });
}), name$147 = `asec`, dependencies$147 = [`typed`, `config`, `Complex`, `BigNumber`], createAsec = factory(name$147, dependencies$147, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$147, { number: function(t5) {
    return t5 <= -1 || t5 >= 1 || r2.predictable ? asecNumber(t5) : new i2(t5, 0).asec();
  }, Complex: function(t5) {
    return t5.asec();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acos();
  } });
}), name$146 = `asech`, dependencies$146 = [`typed`, `config`, `Complex`, `BigNumber`], createAsech = factory(name$146, dependencies$146, (t4) => {
  var { typed: n2, config: r2, Complex: i2, BigNumber: a2 } = t4;
  return n2(name$146, { number: function(t5) {
    if (t5 <= 1 && t5 >= -1 || r2.predictable) {
      var n3 = 1 / t5;
      if (n3 > 0 || r2.predictable) return asechNumber(t5);
      var a3 = Math.sqrt(n3 * n3 - 1);
      return new i2(Math.log(a3 - n3), Math.PI);
    }
    return new i2(t5, 0).asech();
  }, Complex: function(t5) {
    return t5.asech();
  }, BigNumber: function(t5) {
    return new a2(1).div(t5).acosh();
  } });
}), name$145 = `asin`, dependencies$145 = [`typed`, `config`, `Complex`], createAsin = factory(name$145, dependencies$145, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$145, { number: function(t5) {
    return t5 >= -1 && t5 <= 1 || r2.predictable ? Math.asin(t5) : new i2(t5, 0).asin();
  }, Complex: function(t5) {
    return t5.asin();
  }, BigNumber: function(t5) {
    return t5.asin();
  } });
}), name$144 = `asinh`, dependencies$144 = [`typed`], createAsinh = factory(name$144, dependencies$144, (t4) => {
  var { typed: n2 } = t4;
  return n2(`asinh`, { number: asinhNumber, Complex: function(t5) {
    return t5.asinh();
  }, BigNumber: function(t5) {
    return t5.asinh();
  } });
}), name$143 = `atan`, dependencies$143 = [`typed`], createAtan = factory(name$143, dependencies$143, (t4) => {
  var { typed: n2 } = t4;
  return n2(`atan`, { number: function(t5) {
    return Math.atan(t5);
  }, Complex: function(t5) {
    return t5.atan();
  }, BigNumber: function(t5) {
    return t5.atan();
  } });
}), name$142 = `atan2`, dependencies$142 = [`typed`, `matrix`, `equalScalar`, `BigNumber`, `DenseMatrix`, `concat`], createAtan2 = factory(name$142, dependencies$142, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, BigNumber: a2, DenseMatrix: o2, concat: s2 } = t4, c2 = createMatAlgo02xDS0({ typed: n2, equalScalar: i2 }), l2 = createMatAlgo03xDSf({ typed: n2 }), u2 = createMatAlgo09xS0Sf({ typed: n2, equalScalar: i2 }), d2 = createMatAlgo11xS0s({ typed: n2, equalScalar: i2 }), p2 = createMatAlgo12xSfs({ typed: n2, DenseMatrix: o2 }), m2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: s2 });
  return n2(name$142, { "number, number": Math.atan2, "BigNumber, BigNumber": (t5, n3) => a2.atan2(t5, n3) }, m2({ scalar: `number | BigNumber`, SS: u2, DS: l2, SD: c2, Ss: d2, sS: p2 }));
}), name$141 = `atanh`, dependencies$141 = [`typed`, `config`, `Complex`], createAtanh = factory(name$141, dependencies$141, (t4) => {
  var { typed: n2, config: r2, Complex: i2 } = t4;
  return n2(name$141, { number: function(t5) {
    return t5 <= 1 && t5 >= -1 || r2.predictable ? atanhNumber(t5) : new i2(t5, 0).atanh();
  }, Complex: function(t5) {
    return t5.atanh();
  }, BigNumber: function(t5) {
    return t5.atanh();
  } });
}), createTrigUnit = factory(`trigUnit`, [`typed`], (t4) => {
  var { typed: n2 } = t4;
  return { Unit: n2.referToSelf((t5) => (r2) => {
    if (!r2.hasBase(r2.constructor.BASE_UNITS.ANGLE)) throw TypeError(`Unit in function cot is no angle`);
    return n2.find(t5, r2.valueType())(r2.value);
  }) };
}), name$140 = `cos`, dependencies$140 = [`typed`], createCos = factory(name$140, dependencies$140, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit({ typed: n2 });
  return n2(name$140, { number: Math.cos, "Complex | BigNumber": (t5) => t5.cos() }, r2);
}), name$139 = `cosh`, dependencies$139 = [`typed`], createCosh = factory(name$139, dependencies$139, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$139, { number: cosh$3, "Complex | BigNumber": (t5) => t5.cosh() });
}), name$138 = `cot`, dependencies$138 = [`typed`, `BigNumber`], createCot = factory(name$138, dependencies$138, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit({ typed: n2 });
  return n2(name$138, { number: cotNumber, Complex: (t5) => t5.cot(), BigNumber: (t5) => new r2(1).div(t5.tan()) }, i2);
}), name$137 = `coth`, dependencies$137 = [`typed`, `BigNumber`], createCoth = factory(name$137, dependencies$137, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$137, { number: cothNumber, Complex: (t5) => t5.coth(), BigNumber: (t5) => new r2(1).div(t5.tanh()) });
}), name$136 = `csc`, dependencies$136 = [`typed`, `BigNumber`], createCsc = factory(name$136, dependencies$136, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit({ typed: n2 });
  return n2(name$136, { number: cscNumber, Complex: (t5) => t5.csc(), BigNumber: (t5) => new r2(1).div(t5.sin()) }, i2);
}), name$135 = `csch`, dependencies$135 = [`typed`, `BigNumber`], createCsch = factory(name$135, dependencies$135, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$135, { number: cschNumber, Complex: (t5) => t5.csch(), BigNumber: (t5) => new r2(1).div(t5.sinh()) });
}), name$134 = `sec`, dependencies$134 = [`typed`, `BigNumber`], createSec = factory(name$134, dependencies$134, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4, i2 = createTrigUnit({ typed: n2 });
  return n2(name$134, { number: secNumber, Complex: (t5) => t5.sec(), BigNumber: (t5) => new r2(1).div(t5.cos()) }, i2);
}), name$133 = `sech`, dependencies$133 = [`typed`, `BigNumber`], createSech = factory(name$133, dependencies$133, (t4) => {
  var { typed: n2, BigNumber: r2 } = t4;
  return n2(name$133, { number: sechNumber, Complex: (t5) => t5.sech(), BigNumber: (t5) => new r2(1).div(t5.cosh()) });
}), name$132 = `sin`, dependencies$132 = [`typed`], createSin = factory(name$132, dependencies$132, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit({ typed: n2 });
  return n2(name$132, { number: Math.sin, "Complex | BigNumber": (t5) => t5.sin() }, r2);
}), name$131 = `sinh`, dependencies$131 = [`typed`], createSinh = factory(name$131, dependencies$131, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$131, { number: sinhNumber, "Complex | BigNumber": (t5) => t5.sinh() });
}), name$130 = `tan`, dependencies$130 = [`typed`], createTan = factory(name$130, dependencies$130, (t4) => {
  var { typed: n2 } = t4, r2 = createTrigUnit({ typed: n2 });
  return n2(name$130, { number: Math.tan, "Complex | BigNumber": (t5) => t5.tan() }, r2);
}), name$129 = `tanh`, dependencies$129 = [`typed`], createTanh = factory(name$129, dependencies$129, (t4) => {
  var { typed: n2 } = t4;
  return n2(`tanh`, { number: tanh$2, "Complex | BigNumber": (t5) => t5.tanh() });
}), name$128 = `setCartesian`, dependencies$128 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetCartesian = factory(name$128, dependencies$128, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$128, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2 = [];
    if (i2(r2(t5), new o2(0)) !== 0 && i2(r2(n3), new o2(0)) !== 0) {
      var l2 = flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), u2 = flatten$4(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2);
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) c2.push([l2[d2], u2[p2]]);
    }
    return Array.isArray(t5) && Array.isArray(n3) ? c2 : new s2(c2);
  } });
}), name$127 = `setDifference`, dependencies$127 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDifference = factory(name$127, dependencies$127, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$127, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0) c2 = [];
    else if (i2(r2(n3), new o2(0)) === 0) return flatten$4(t5.toArray());
    else {
      var l2 = identify(flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify(flatten$4(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2, p2 = 0; p2 < l2.length; p2++) {
        d2 = false;
        for (var m2 = 0; m2 < u2.length; m2++) if (a2(l2[p2].value, u2[m2].value) === 0 && l2[p2].identifier === u2[m2].identifier) {
          d2 = true;
          break;
        }
        d2 || c2.push(l2[p2]);
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize(c2) : new s2(generalize(c2));
  } });
}), name$126 = `setDistinct`, dependencies$126 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetDistinct = factory(name$126, dependencies$126, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$126, { "Array | Matrix": function(t5) {
    var n3;
    if (i2(r2(t5), new o2(0)) === 0) n3 = [];
    else {
      var c2 = flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2);
      n3 = [], n3.push(c2[0]);
      for (var l2 = 1; l2 < c2.length; l2++) a2(c2[l2], c2[l2 - 1]) !== 0 && n3.push(c2[l2]);
    }
    return Array.isArray(t5) ? n3 : new s2(n3);
  } });
}), name$125 = `setIntersect`, dependencies$125 = [`typed`, `size`, `subset`, `compareNatural`, `Index`, `DenseMatrix`], createSetIntersect = factory(name$125, dependencies$125, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2, DenseMatrix: s2 } = t4;
  return n2(name$125, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    var c2;
    if (i2(r2(t5), new o2(0)) === 0 || i2(r2(n3), new o2(0)) === 0) c2 = [];
    else {
      var l2 = identify(flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), u2 = identify(flatten$4(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2));
      c2 = [];
      for (var d2 = 0; d2 < l2.length; d2++) for (var p2 = 0; p2 < u2.length; p2++) if (a2(l2[d2].value, u2[p2].value) === 0 && l2[d2].identifier === u2[p2].identifier) {
        c2.push(l2[d2]);
        break;
      }
    }
    return Array.isArray(t5) && Array.isArray(n3) ? generalize(c2) : new s2(generalize(c2));
  } });
}), name$124 = `setIsSubset`, dependencies$124 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetIsSubset = factory(name$124, dependencies$124, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$124, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (i2(r2(t5), new o2(0)) === 0) return true;
    if (i2(r2(n3), new o2(0)) === 0) return false;
    for (var s2 = identify(flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2)), c2 = identify(flatten$4(Array.isArray(n3) ? n3 : n3.toArray()).sort(a2)), l2, u2 = 0; u2 < s2.length; u2++) {
      l2 = false;
      for (var d2 = 0; d2 < c2.length; d2++) if (a2(s2[u2].value, c2[d2].value) === 0 && s2[u2].identifier === c2[d2].identifier) {
        l2 = true;
        break;
      }
      if (l2 === false) return false;
    }
    return true;
  } });
}), name$123 = `setMultiplicity`, dependencies$123 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetMultiplicity = factory(name$123, dependencies$123, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$123, { "number | BigNumber | Fraction | Complex, Array | Matrix": function(t5, n3) {
    if (i2(r2(n3), new o2(0)) === 0) return 0;
    for (var s2 = flatten$4(Array.isArray(n3) ? n3 : n3.toArray()), c2 = 0, l2 = 0; l2 < s2.length; l2++) a2(s2[l2], t5) === 0 && c2++;
    return c2;
  } });
}), name$122 = `setPowerset`, dependencies$122 = [`typed`, `size`, `subset`, `compareNatural`, `Index`], createSetPowerset = factory(name$122, dependencies$122, (t4) => {
  var { typed: n2, size: r2, subset: i2, compareNatural: a2, Index: o2 } = t4;
  return n2(name$122, { "Array | Matrix": function(t5) {
    if (i2(r2(t5), new o2(0)) === 0) return [];
    for (var n3 = flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(a2), l2 = [], u2 = 0; u2.toString(2).length <= n3.length; ) l2.push(s2(n3, u2.toString(2).split(``).reverse())), u2++;
    return c2(l2);
  } });
  function s2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3.length; i3++) n3[i3] === `1` && r3.push(t5[i3]);
    return r3;
  }
  function c2(t5) {
    for (var n3 = [], r3 = t5.length - 1; r3 > 0; r3--) for (var i3 = 0; i3 < r3; i3++) t5[i3].length > t5[i3 + 1].length && (n3 = t5[i3], t5[i3] = t5[i3 + 1], t5[i3 + 1] = n3);
    return t5;
  }
}), name$121 = `setSize`, dependencies$121 = [`typed`, `compareNatural`], createSetSize = factory(name$121, dependencies$121, (t4) => {
  var { typed: n2, compareNatural: r2 } = t4;
  return n2(name$121, { "Array | Matrix": function(t5) {
    return Array.isArray(t5) ? flatten$4(t5).length : flatten$4(t5.toArray()).length;
  }, "Array | Matrix, boolean": function(t5, n3) {
    if (n3 === false || t5.length === 0) return Array.isArray(t5) ? flatten$4(t5).length : flatten$4(t5.toArray()).length;
    for (var i2 = flatten$4(Array.isArray(t5) ? t5 : t5.toArray()).sort(r2), a2 = 1, o2 = 1; o2 < i2.length; o2++) r2(i2[o2], i2[o2 - 1]) !== 0 && a2++;
    return a2;
  } });
}), name$120 = `setSymDifference`, dependencies$120 = [`typed`, `size`, `concat`, `subset`, `setDifference`, `Index`], createSetSymDifference = factory(name$120, dependencies$120, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setDifference: o2, Index: s2 } = t4;
  return n2(name$120, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new s2(0)) === 0) return flatten$4(n3);
    if (a2(r2(n3), new s2(0)) === 0) return flatten$4(t5);
    var c2 = flatten$4(t5), l2 = flatten$4(n3);
    return i2(o2(c2, l2), o2(l2, c2));
  } });
}), name$119 = `setUnion`, dependencies$119 = [`typed`, `size`, `concat`, `subset`, `setIntersect`, `setSymDifference`, `Index`], createSetUnion = factory(name$119, dependencies$119, (t4) => {
  var { typed: n2, size: r2, concat: i2, subset: a2, setIntersect: o2, setSymDifference: s2, Index: c2 } = t4;
  return n2(name$119, { "Array | Matrix, Array | Matrix": function(t5, n3) {
    if (a2(r2(t5), new c2(0)) === 0) return flatten$4(n3);
    if (a2(r2(n3), new c2(0)) === 0) return flatten$4(t5);
    var l2 = flatten$4(t5), u2 = flatten$4(n3);
    return i2(s2(l2, u2), o2(l2, u2));
  } });
}), name$118 = `add`, dependencies$118 = [`typed`, `matrix`, `addScalar`, `equalScalar`, `DenseMatrix`, `SparseMatrix`, `concat`], createAdd = factory(name$118, dependencies$118, (t4) => {
  var { typed: n2, matrix: r2, addScalar: i2, equalScalar: a2, DenseMatrix: o2, SparseMatrix: s2, concat: c2 } = t4, l2 = createMatAlgo01xDSid({ typed: n2 }), u2 = createMatAlgo04xSidSid({ typed: n2, equalScalar: a2 }), d2 = createMatAlgo10xSids({ typed: n2, DenseMatrix: o2 }), p2 = createMatrixAlgorithmSuite({ typed: n2, matrix: r2, concat: c2 });
  return n2(name$118, { "any, any": i2, "any, any, ...any": n2.referToSelf((t5) => (n3, r3, i3) => {
    for (var a3 = t5(n3, r3), o3 = 0; o3 < i3.length; o3++) a3 = t5(a3, i3[o3]);
    return a3;
  }) }, p2({ elop: i2, DS: l2, SS: u2, Ss: d2 }));
}), name$117 = `hypot`, dependencies$117 = [`typed`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `sqrt`, `smaller`, `isPositive`], createHypot = factory(name$117, dependencies$117, (t4) => {
  var { typed: n2, abs: r2, addScalar: i2, divideScalar: a2, multiplyScalar: o2, sqrt: s2, smaller: c2, isPositive: l2 } = t4;
  return n2(name$117, { "... number | BigNumber": u2, Array: u2, Matrix: (t5) => u2(flatten$4(t5.toArray(), true)) });
  function u2(t5) {
    for (var n3 = 0, u3 = 0, d2 = 0; d2 < t5.length; d2++) {
      if (isComplex(t5[d2])) throw TypeError(`Unexpected type of argument to hypot`);
      var p2 = r2(t5[d2]);
      c2(u3, p2) ? (n3 = o2(n3, o2(a2(u3, p2), a2(u3, p2))), n3 = i2(n3, 1), u3 = p2) : n3 = i2(n3, l2(p2) ? o2(a2(p2, u3), a2(p2, u3)) : p2);
    }
    return o2(u3, s2(n3));
  }
}), name$116 = `norm`, dependencies$116 = [`typed`, `abs`, `add`, `pow`, `conj`, `sqrt`, `multiply`, `equalScalar`, `larger`, `smaller`, `matrix`, `ctranspose`, `eigs`], createNorm = factory(name$116, dependencies$116, (t4) => {
  var { typed: n2, abs: r2, add: i2, pow: a2, conj: o2, sqrt: s2, multiply: c2, equalScalar: l2, larger: u2, smaller: d2, matrix: p2, ctranspose: m2, eigs: h2 } = t4;
  return n2(name$116, { number: Math.abs, Complex: function(t5) {
    return t5.abs();
  }, BigNumber: function(t5) {
    return t5.abs();
  }, boolean: function(t5) {
    return Math.abs(t5);
  }, Array: function(t5) {
    return D(p2(t5), 2);
  }, Matrix: function(t5) {
    return D(t5, 2);
  }, "Array, number | BigNumber | string": function(t5, n3) {
    return D(p2(t5), n3);
  }, "Matrix, number | BigNumber | string": function(t5, n3) {
    return D(t5, n3);
  } });
  function g2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      u2(i3, n3) && (n3 = i3);
    }, true), n3;
  }
  function v2(t5) {
    var n3;
    return t5.forEach(function(t6) {
      var i3 = r2(t6);
      (!n3 || d2(i3, n3)) && (n3 = i3);
    }, true), n3 || 0;
  }
  function y2(t5, n3) {
    if (n3 === 1 / 0 || n3 === `inf`) return g2(t5);
    if (n3 === -1 / 0 || n3 === `-inf`) return v2(t5);
    if (n3 === `fro`) return D(t5, 2);
    if (typeof n3 == `number` && !isNaN(n3)) {
      if (!l2(n3, 0)) {
        var o3 = 0;
        return t5.forEach(function(t6) {
          o3 = i2(a2(r2(t6), n3), o3);
        }, true), a2(o3, 1 / n3);
      }
      return 1 / 0;
    }
    throw Error(`Unsupported parameter value`);
  }
  function b2(t5) {
    var n3 = 0;
    return t5.forEach(function(t6, r3) {
      n3 = i2(n3, c2(t6, o2(t6)));
    }), r2(s2(n3));
  }
  function x2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[1], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function S2(t5) {
    var n3 = t5.size();
    if (n3[0] !== n3[1]) throw RangeError(`Invalid matrix dimensions`);
    var i3 = h2(c2(m2(t5), t5)).values.toArray(), a3 = i3[i3.length - 1];
    return r2(s2(a3));
  }
  function w2(t5) {
    var n3 = [], a3 = 0;
    return t5.forEach(function(t6, o3) {
      var s3 = o3[0], c3 = i2(n3[s3] || 0, r2(t6));
      u2(c3, a3) && (a3 = c3), n3[s3] = c3;
    }, true), a3;
  }
  function E(t5, n3) {
    if (n3 === 1) return x2(t5);
    if (n3 === 1 / 0 || n3 === `inf`) return w2(t5);
    if (n3 === `fro`) return b2(t5);
    if (n3 === 2) return S2(t5);
    throw Error(`Unsupported parameter value ` + n3);
  }
  function D(t5, n3) {
    var r3 = t5.size();
    if (r3.length === 1) return y2(t5, n3);
    if (r3.length === 2) {
      if (r3[0] && r3[1]) return E(t5, n3);
      throw RangeError(`Invalid matrix dimensions`);
    }
  }
}), name$115 = `dot`, dependencies$115 = [`typed`, `addScalar`, `multiplyScalar`, `conj`, `size`], createDot = factory(name$115, dependencies$115, (t4) => {
  var { typed: n2, addScalar: r2, multiplyScalar: i2, conj: a2, size: o2 } = t4;
  return n2(name$115, { "Array | DenseMatrix, Array | DenseMatrix": c2, "SparseMatrix, SparseMatrix": l2 });
  function s2(t5, n3) {
    var r3 = o2(t5), i3 = o2(n3), a3, s3;
    if (r3.length === 1) a3 = r3[0];
    else if (r3.length === 2 && r3[1] === 1) a3 = r3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + r3.join(`, `) + `)`);
    if (i3.length === 1) s3 = i3[0];
    else if (i3.length === 2 && i3[1] === 1) s3 = i3[0];
    else throw RangeError(`Expected a column vector, instead got a matrix of size (` + i3.join(`, `) + `)`);
    if (a3 !== s3) throw RangeError(`Vectors must have equal length (` + a3 + ` != ` + s3 + `)`);
    if (a3 === 0) throw RangeError(`Cannot calculate the dot product of empty vectors`);
    return a3;
  }
  function c2(t5, c3) {
    var l3 = s2(t5, c3), u2 = isMatrix(t5) ? t5._data : t5, d2 = isMatrix(t5) ? t5._datatype || t5.getDataType() : void 0, p2 = isMatrix(c3) ? c3._data : c3, m2 = isMatrix(c3) ? c3._datatype || c3.getDataType() : void 0, h2 = o2(t5).length === 2, g2 = o2(c3).length === 2, v2 = r2, y2 = i2;
    if (d2 && m2 && d2 === m2 && typeof d2 == `string` && d2 !== `mixed`) {
      var b2 = d2;
      v2 = n2.find(r2, [b2, b2]), y2 = n2.find(i2, [b2, b2]);
    }
    if (!h2 && !g2) {
      for (var x2 = y2(a2(u2[0]), p2[0]), S2 = 1; S2 < l3; S2++) x2 = v2(x2, y2(a2(u2[S2]), p2[S2]));
      return x2;
    }
    if (!h2 && g2) {
      for (var w2 = y2(a2(u2[0]), p2[0][0]), E = 1; E < l3; E++) w2 = v2(w2, y2(a2(u2[E]), p2[E][0]));
      return w2;
    }
    if (h2 && !g2) {
      for (var D = y2(a2(u2[0][0]), p2[0]), O2 = 1; O2 < l3; O2++) D = v2(D, y2(a2(u2[O2][0]), p2[O2]));
      return D;
    }
    if (h2 && g2) {
      for (var j2 = y2(a2(u2[0][0]), p2[0][0]), M2 = 1; M2 < l3; M2++) j2 = v2(j2, y2(a2(u2[M2][0]), p2[M2][0]));
      return j2;
    }
  }
  function l2(t5, n3) {
    s2(t5, n3);
    for (var a3 = t5._index, o3 = t5._values, c3 = n3._index, l3 = n3._values, u2 = 0, d2 = r2, p2 = i2, m2 = 0, h2 = 0; m2 < a3.length && h2 < c3.length; ) {
      var g2 = a3[m2], v2 = c3[h2];
      if (g2 < v2) {
        m2++;
        continue;
      }
      if (g2 > v2) {
        h2++;
        continue;
      }
      g2 === v2 && (u2 = d2(u2, p2(o3[m2], l3[h2])), m2++, h2++);
    }
    return u2;
  }
}), name$114 = `trace`, dependencies$114 = [`typed`, `matrix`, `add`], createTrace = factory(name$114, dependencies$114, (t4) => {
  var { typed: n2, matrix: r2, add: i2 } = t4;
  return n2(`trace`, { Array: function(t5) {
    return a2(r2(t5));
  }, SparseMatrix: o2, DenseMatrix: a2, any: clone$3 });
  function a2(t5) {
    var n3 = t5._size, r3 = t5._data;
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return clone$3(r3[0]);
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      case 2:
        var a3 = n3[0];
        if (a3 === n3[1]) {
          for (var o3 = 0, s2 = 0; s2 < a3; s2++) o3 = i2(o3, r3[s2][s2]);
          return o3;
        } else throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format(n3) + `)`);
    }
  }
  function o2(t5) {
    var n3 = t5._values, r3 = t5._index, a3 = t5._ptr, o3 = t5._size, s2 = o3[0], c2 = o3[1];
    if (s2 === c2) {
      var l2 = 0;
      if (n3.length > 0) for (var u2 = 0; u2 < c2; u2++) for (var d2 = a3[u2], p2 = a3[u2 + 1], m2 = d2; m2 < p2; m2++) {
        var h2 = r3[m2];
        if (h2 === u2) {
          l2 = i2(l2, n3[m2]);
          break;
        }
        if (h2 > u2) break;
      }
      return l2;
    }
    throw RangeError(`Matrix must be square (size: ` + format(o3) + `)`);
  }
}), name$113 = `index`, dependencies$113 = [`typed`, `Index`], createIndex = factory(name$113, dependencies$113, (t4) => {
  var { typed: n2, Index: r2 } = t4;
  return n2(name$113, { "...number | string | BigNumber | Range | Array | Matrix": function(t5) {
    var n3 = t5.map(function(t6) {
      return isBigNumber(t6) ? t6.toNumber() : isArray(t6) || isMatrix(t6) ? t6.map(function(t7) {
        return isBigNumber(t7) ? t7.toNumber() : t7;
      }) : t6;
    }), i2 = new r2();
    return r2.apply(i2, n3), i2;
  } });
}), keywords = /* @__PURE__ */ new Set([`end`]), name$112 = `Node`, dependencies$112 = [`mathWithTransform`], createNode = factory(name$112, dependencies$112, (t4) => {
  var { mathWithTransform: n2 } = t4;
  function r2(t5) {
    for (var n3 of [...keywords]) if (t5.has(n3)) throw Error(`Scope contains an illegal symbol, "` + n3 + `" is a reserved keyword`);
  }
  class i2 {
    get type() {
      return `Node`;
    }
    get isNode() {
      return true;
    }
    evaluate(t5) {
      return this.compile().evaluate(t5);
    }
    compile() {
      var t5 = this._compile(n2, {}), i3 = {}, a2 = null;
      function o2(n3) {
        var o3 = createMap$1(n3);
        return r2(o3), t5(o3, i3, a2);
      }
      return { evaluate: o2 };
    }
    _compile(t5, n3) {
      throw Error(`Method _compile must be implemented by type ` + this.type);
    }
    forEach(t5) {
      throw Error(`Cannot run forEach on a Node interface`);
    }
    map(t5) {
      throw Error(`Cannot run map on a Node interface`);
    }
    _ifNode(t5) {
      if (!isNode$2(t5)) throw TypeError(`Callback function must return a Node`);
      return t5;
    }
    traverse(t5) {
      t5(this, null, null);
      function n3(t6, r3) {
        t6.forEach(function(t7, i3, a2) {
          r3(t7, i3, a2), n3(t7, r3);
        });
      }
      n3(this, t5);
    }
    transform(t5) {
      function n3(r3, i3, a2) {
        var o2 = t5(r3, i3, a2);
        return o2 === r3 ? r3.map(n3) : o2;
      }
      return n3(this, null, null);
    }
    filter(t5) {
      var n3 = [];
      return this.traverse(function(r3, i3, a2) {
        t5(r3, i3, a2) && n3.push(r3);
      }), n3;
    }
    clone() {
      throw Error(`Cannot clone a Node interface`);
    }
    cloneDeep() {
      return this.map(function(t5) {
        return t5.cloneDeep();
      });
    }
    equals(t5) {
      return t5 ? this.type === t5.type && deepStrictEqual(this, t5) : false;
    }
    toString(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toString(t5) : n3;
    }
    _toString() {
      throw Error(`_toString not implemented for ` + this.type);
    }
    toJSON() {
      throw Error(`Cannot serialize object: toJSON not implemented by ` + this.type);
    }
    toHTML(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toHTML(t5) : n3;
    }
    _toHTML() {
      throw Error(`_toHTML not implemented for ` + this.type);
    }
    toTex(t5) {
      var n3 = this._getCustomString(t5);
      return n3 === void 0 ? this._toTex(t5) : n3;
    }
    _toTex(t5) {
      throw Error(`_toTex not implemented for ` + this.type);
    }
    _getCustomString(t5) {
      if (t5 && typeof t5 == `object`) switch (typeof t5.handler) {
        case `object`:
        case `undefined`:
          return;
        case `function`:
          return t5.handler(this, t5);
        default:
          throw TypeError(`Object or function expected as callback`);
      }
    }
    getIdentifier() {
      return this.type;
    }
    getContent() {
      return this;
    }
  }
  return i2;
}, { isClass: true, isNode: true });
function errorTransform(t4) {
  return t4 && t4.isIndexError ? new IndexError(t4.index + 1, t4.min + 1, t4.max === void 0 ? void 0 : t4.max + 1) : t4;
}
function accessFactory(t4) {
  var { subset: n2 } = t4;
  return function(t5, r2) {
    try {
      if (Array.isArray(t5)) return n2(t5, r2);
      if (t5 && typeof t5.subset == `function`) return t5.subset(r2);
      if (typeof t5 == `string`) return n2(t5, r2);
      if (typeof t5 == `object`) {
        if (!r2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return getSafeProperty(t5, r2.getObjectProperty());
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform(t6);
    }
  };
}
var name$111 = `AccessorNode`, dependencies$111 = [`subset`, `Node`], createAccessorNode = factory(name$111, dependencies$111, (t4) => {
  var { subset: n2, Node: r2 } = t4, i2 = accessFactory({ subset: n2 });
  function a2(t5) {
    return !(isAccessorNode(t5) || isArrayNode(t5) || isConstantNode(t5) || isFunctionNode(t5) || isObjectNode(t5) || isParenthesisNode(t5) || isSymbolNode(t5));
  }
  class o2 extends r2 {
    constructor(t5, n3) {
      var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false;
      if (super(), !isNode$2(t5)) throw TypeError(`Node expected for parameter "object"`);
      if (!isIndexNode(n3)) throw TypeError(`IndexNode expected for parameter "index"`);
      this.object = t5, this.index = n3, this.optionalChaining = r3;
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$111;
    }
    get isAccessorNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), a3 = this.index._compile(t5, n3), o3 = this.optionalChaining, s2 = isAccessorNode(this.object) && this.object.optionalChaining;
      if (this.index.isObjectProperty()) {
        var c2 = this.index.getObjectProperty();
        return function(t6, n4, i3) {
          var a4 = i3 || {}, l2 = r3(t6, n4, a4);
          if (o3 && l2 == null) {
            a4.optionalShortCircuit = true;
            return;
          }
          if (!(s2 && a4 != null && a4.optionalShortCircuit)) return getSafeProperty(l2, c2);
        };
      } else return function(t6, n4, c3) {
        var l2 = c3 || {}, u2 = r3(t6, n4, l2);
        if (o3 && u2 == null) {
          l2.optionalShortCircuit = true;
          return;
        }
        if (!(s2 && l2 != null && l2.optionalShortCircuit)) return i2(u2, a3(t6, n4, u2));
      };
    }
    forEach(t5) {
      t5(this.object, `object`, this), t5(this.index, `index`, this);
    }
    map(t5) {
      return new o2(this._ifNode(t5(this.object, `object`, this)), this._ifNode(t5(this.index, `index`, this)), this.optionalChaining);
    }
    clone() {
      return new o2(this.object, this.index, this.optionalChaining);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5);
      a2(this.object) && (n3 = `(` + n3 + `)`);
      var r3 = this.optionalChaining ? this.index.dotNotation ? `?` : `?.` : ``;
      return n3 + r3 + this.index.toString(t5);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5);
      return a2(this.object) && (n3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n3 + this.index.toHTML(t5);
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5);
      return a2(this.object) && (n3 = `\\left(' + object + '\\right)`), n3 + this.index.toTex(t5);
    }
    toJSON() {
      return { mathjs: name$111, object: this.object, index: this.index, optionalChaining: this.optionalChaining };
    }
    static fromJSON(t5) {
      return new o2(t5.object, t5.index, t5.optionalChaining);
    }
  }
  return _defineProperty(o2, `name`, name$111), o2;
}, { isClass: true, isNode: true }), name$110 = `ArrayNode`, dependencies$110 = [`Node`], createArrayNode = factory(name$110, dependencies$110, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.items = t5 || [], !Array.isArray(this.items) || !this.items.every(isNode$2)) throw TypeError(`Array containing Nodes expected`);
    }
    get type() {
      return name$110;
    }
    get isArrayNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = map$1(this.items, function(r4) {
        return r4._compile(t5, n3);
      });
      if (t5.config.matrix !== `Array`) {
        var i2 = t5.matrix;
        return function(t6, n4, a2) {
          return i2(map$1(r3, function(r4) {
            return r4(t6, n4, a2);
          }));
        };
      } else return function(t6, n4, i3) {
        return map$1(r3, function(r4) {
          return r4(t6, n4, i3);
        });
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.items.length; n3++) {
        var r3 = this.items[n3];
        t5(r3, `items[` + n3 + `]`, this);
      }
    }
    map(t5) {
      for (var n3 = [], i2 = 0; i2 < this.items.length; i2++) n3[i2] = this._ifNode(t5(this.items[i2], `items[` + i2 + `]`, this));
      return new r2(n3);
    }
    clone() {
      return new r2(this.items.slice(0));
    }
    _toString(t5) {
      return `[` + this.items.map(function(n3) {
        return n3.toString(t5);
      }).join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$110, items: this.items };
    }
    static fromJSON(t5) {
      return new r2(t5.items);
    }
    _toHTML(t5) {
      return `<span class="math-parenthesis math-square-parenthesis">[</span>` + this.items.map(function(n3) {
        return n3.toHTML(t5);
      }).join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      function n3(r3, i2) {
        var a2 = r3.some(isArrayNode) && !r3.every(isArrayNode), o2 = i2 || a2, s2 = o2 ? `&` : `\\\\`, c2 = r3.map(function(r4) {
          return r4.items ? n3(r4.items, !i2) : r4.toTex(t5);
        }).join(s2);
        return a2 || !o2 || o2 && !i2 ? `\\begin{bmatrix}` + c2 + `\\end{bmatrix}` : c2;
      }
      return n3(this.items, false);
    }
  }
  return _defineProperty(r2, `name`, name$110), r2;
}, { isClass: true, isNode: true });
function assignFactory(t4) {
  var { subset: n2, matrix: r2 } = t4;
  return function(t5, i2, a2) {
    try {
      if (Array.isArray(t5)) return r2(t5).subset(i2, a2).valueOf().forEach((n3, r3) => {
        t5[r3] = n3;
      }), t5;
      if (t5 && typeof t5.subset == `function`) return t5.subset(i2, a2);
      if (typeof t5 == `string`) return n2(t5, i2, a2);
      if (typeof t5 == `object`) {
        if (!i2.isObjectProperty()) throw TypeError(`Cannot apply a numeric index as object property`);
        return setSafeProperty(t5, i2.getObjectProperty(), a2), t5;
      } else throw TypeError(`Cannot apply index: unsupported type of object`);
    } catch (t6) {
      throw errorTransform(t6);
    }
  };
}
var properties = [{ AssignmentNode: {}, FunctionAssignmentNode: {} }, { ConditionalNode: { latexLeftParens: false, latexRightParens: false, latexParens: false } }, { "OperatorNode:or": { op: `or`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:xor": { op: `xor`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:and": { op: `and`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitOr": { op: `|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitXor": { op: `^|`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:bitAnd": { op: `&`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:equal": { op: `==`, associativity: `left`, associativeWith: [] }, "OperatorNode:unequal": { op: `!=`, associativity: `left`, associativeWith: [] }, "OperatorNode:smaller": { op: `<`, associativity: `left`, associativeWith: [] }, "OperatorNode:larger": { op: `>`, associativity: `left`, associativeWith: [] }, "OperatorNode:smallerEq": { op: `<=`, associativity: `left`, associativeWith: [] }, "OperatorNode:largerEq": { op: `>=`, associativity: `left`, associativeWith: [] }, RelationalNode: { associativity: `left`, associativeWith: [] } }, { "OperatorNode:leftShift": { op: `<<`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightArithShift": { op: `>>`, associativity: `left`, associativeWith: [] }, "OperatorNode:rightLogShift": { op: `>>>`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:to": { op: `to`, associativity: `left`, associativeWith: [] } }, { RangeNode: {} }, { "OperatorNode:add": { op: `+`, associativity: `left`, associativeWith: [`OperatorNode:add`, `OperatorNode:subtract`] }, "OperatorNode:subtract": { op: `-`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { op: `*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] }, "OperatorNode:divide": { op: `/`, associativity: `left`, associativeWith: [], latexLeftParens: false, latexRightParens: false, latexParens: false }, "OperatorNode:dotMultiply": { op: `.*`, associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `OperatorNode:dotMultiply`, `OperatorNode:doDivide`] }, "OperatorNode:dotDivide": { op: `./`, associativity: `left`, associativeWith: [] }, "OperatorNode:mod": { op: `mod`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:multiply": { associativity: `left`, associativeWith: [`OperatorNode:multiply`, `OperatorNode:divide`, `Operator:dotMultiply`, `Operator:dotDivide`] } }, { "OperatorNode:unaryPlus": { op: `+`, associativity: `right` }, "OperatorNode:unaryMinus": { op: `-`, associativity: `right` }, "OperatorNode:bitNot": { op: `~`, associativity: `right` }, "OperatorNode:not": { op: `not`, associativity: `right` } }, { "OperatorNode:pow": { op: `^`, associativity: `right`, associativeWith: [], latexRightParens: false }, "OperatorNode:dotPow": { op: `.^`, associativity: `right`, associativeWith: [] } }, { "OperatorNode:nullish": { op: `??`, associativity: `left`, associativeWith: [] } }, { "OperatorNode:factorial": { op: `!`, associativity: `left` } }, { "OperatorNode:ctranspose": { op: `'`, associativity: `left` } }];
function unwrapParen(t4, n2) {
  if (!n2 || n2 !== `auto`) return t4;
  for (var r2 = t4; isParenthesisNode(r2); ) r2 = r2.content;
  return r2;
}
function getPrecedence(t4, n2, r2, i2) {
  var a2 = t4;
  n2 !== `keep` && (a2 = t4.getContent());
  for (var o2 = a2.getIdentifier(), s2 = null, c2 = 0; c2 < properties.length; c2++) if (o2 in properties[c2]) {
    s2 = c2;
    break;
  }
  if (o2 === `OperatorNode:multiply` && a2.implicit && r2 !== `show`) {
    var l2 = unwrapParen(a2.args[0], n2);
    !(isConstantNode(l2) && i2 && i2.getIdentifier() === `OperatorNode:divide` && rule2Node(unwrapParen(i2.args[0], n2))) && !(l2.getIdentifier() === `OperatorNode:divide` && rule2Node(unwrapParen(l2.args[0], n2)) && isConstantNode(unwrapParen(l2.args[1]))) && (s2 += 1);
  }
  return s2;
}
function getAssociativity(t4, n2) {
  var r2 = t4;
  n2 !== `keep` && (r2 = t4.getContent());
  var i2 = r2.getIdentifier(), a2 = getPrecedence(r2, n2);
  if (a2 === null) return null;
  var o2 = properties[a2][i2];
  if (hasOwnProperty$1$1(o2, `associativity`)) {
    if (o2.associativity === `left`) return `left`;
    if (o2.associativity === `right`) return `right`;
    throw Error(`'` + i2 + `' has the invalid associativity '` + o2.associativity + `'.`);
  }
  return null;
}
function isAssociativeWith(t4, n2, r2) {
  var i2 = r2 === `keep` ? t4 : t4.getContent(), a2 = r2 === `keep` ? n2 : t4.getContent(), o2 = i2.getIdentifier(), s2 = a2.getIdentifier(), c2 = getPrecedence(i2, r2);
  if (c2 === null) return null;
  var l2 = properties[c2][o2];
  if (hasOwnProperty$1$1(l2, `associativeWith`) && l2.associativeWith instanceof Array) {
    for (var u2 = 0; u2 < l2.associativeWith.length; u2++) if (l2.associativeWith[u2] === s2) return true;
    return false;
  }
  return null;
}
function getOperator(t4) {
  var n2 = `OperatorNode:` + t4;
  for (var r2 of properties) if (n2 in r2) return r2[n2].op;
  return null;
}
var name$109 = `AssignmentNode`, dependencies$109 = [`subset`, `?matrix`, `Node`], createAssignmentNode = factory(name$109, dependencies$109, (t4) => {
  var { subset: n2, matrix: r2, Node: i2 } = t4, a2 = accessFactory({ subset: n2 }), o2 = assignFactory({ subset: n2, matrix: r2 });
  function s2(t5, n3, r3) {
    n3 ||= `keep`;
    var i3 = getPrecedence(t5, n3, r3), a3 = getPrecedence(t5.value, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), this.object = t5, this.index = r3 ? n3 : null, this.value = r3 || n3, !isSymbolNode(t5) && !isAccessorNode(t5)) throw TypeError(`SymbolNode or AccessorNode expected as "object"`);
      if (isSymbolNode(t5) && t5.name === `end`) throw Error(`Cannot assign to symbol "end"`);
      if (this.index && !isIndexNode(this.index)) throw TypeError(`IndexNode expected as "index"`);
      if (!isNode$2(this.value)) throw TypeError(`Node expected as "value"`);
    }
    get name() {
      return this.index ? this.index.isObjectProperty() ? this.index.getObjectProperty() : `` : this.object.name || ``;
    }
    get type() {
      return name$109;
    }
    get isAssignmentNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.object._compile(t5, n3), i3 = this.index ? this.index._compile(t5, n3) : null, s3 = this.value._compile(t5, n3), c3 = this.object.name;
      if (!this.index) {
        if (!isSymbolNode(this.object)) throw TypeError(`SymbolNode expected as object`);
        return function(t6, n4, r4) {
          var i4 = s3(t6, n4, r4);
          return t6.set(c3, i4), i4;
        };
      } else if (this.index.isObjectProperty()) {
        var l2 = this.index.getObjectProperty();
        return function(t6, n4, i4) {
          var a3 = r3(t6, n4, i4), o3 = s3(t6, n4, i4);
          return setSafeProperty(a3, l2, o3), o3;
        };
      } else if (isSymbolNode(this.object)) return function(t6, n4, a3) {
        var l3 = r3(t6, n4, a3), u3 = s3(t6, n4, a3), d3 = i3(t6, n4, l3);
        return t6.set(c3, o2(l3, d3, u3)), u3;
      };
      else {
        var u2 = this.object.object._compile(t5, n3);
        if (this.object.index.isObjectProperty()) {
          var d2 = this.object.index.getObjectProperty();
          return function(t6, n4, r4) {
            var a3 = u2(t6, n4, r4), c4 = getSafeProperty(a3, d2), l3 = i3(t6, n4, c4), p3 = s3(t6, n4, r4);
            return setSafeProperty(a3, d2, o2(c4, l3, p3)), p3;
          };
        } else {
          var p2 = this.object.index._compile(t5, n3);
          return function(t6, n4, r4) {
            var c4 = u2(t6, n4, r4), l3 = p2(t6, n4, c4), d3 = a2(c4, l3), m2 = i3(t6, n4, d3), h2 = s3(t6, n4, r4);
            return o2(c4, l3, o2(d3, m2, h2)), h2;
          };
        }
      }
    }
    forEach(t5) {
      t5(this.object, `object`, this), this.index && t5(this.index, `index`, this), t5(this.value, `value`, this);
    }
    map(t5) {
      return new c2(this._ifNode(t5(this.object, `object`, this)), this.index ? this._ifNode(t5(this.index, `index`, this)) : null, this._ifNode(t5(this.value, `value`, this)));
    }
    clone() {
      return new c2(this.object, this.index, this.value);
    }
    _toString(t5) {
      var n3 = this.object.toString(t5), r3 = this.index ? this.index.toString(t5) : ``, i3 = this.value.toString(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `(` + i3 + `)`), n3 + r3 + ` = ` + i3;
    }
    toJSON() {
      return { mathjs: name$109, object: this.object, index: this.index, value: this.value };
    }
    static fromJSON(t5) {
      return new c2(t5.object, t5.index, t5.value);
    }
    _toHTML(t5) {
      var n3 = this.object.toHTML(t5), r3 = this.index ? this.index.toHTML(t5) : ``, i3 = this.value.toHTML(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `<span class="math-paranthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-paranthesis math-round-parenthesis">)</span>`), n3 + r3 + `<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + i3;
    }
    _toTex(t5) {
      var n3 = this.object.toTex(t5), r3 = this.index ? this.index.toTex(t5) : ``, i3 = this.value.toTex(t5);
      return s2(this, t5 && t5.parenthesis, t5 && t5.implicit) && (i3 = `\\left(${i3}\\right)`), n3 + r3 + `=` + i3;
    }
  }
  return _defineProperty(c2, `name`, name$109), c2;
}, { isClass: true, isNode: true }), name$108 = `BlockNode`, dependencies$108 = [`ResultSet`, `Node`], createBlockNode = factory(name$108, dependencies$108, (t4) => {
  var { ResultSet: n2, Node: r2 } = t4;
  class i2 extends r2 {
    constructor(t5) {
      if (super(), !Array.isArray(t5)) throw Error(`Array expected`);
      this.blocks = t5.map(function(t6) {
        var n3 = t6 && t6.node, r3 = t6 && t6.visible !== void 0 ? t6.visible : true;
        if (!isNode$2(n3)) throw TypeError(`Property "node" must be a Node`);
        if (typeof r3 != `boolean`) throw TypeError(`Property "visible" must be a boolean`);
        return { node: n3, visible: r3 };
      });
    }
    get type() {
      return name$108;
    }
    get isBlockNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = map$1(this.blocks, function(n3) {
        return { evaluate: n3.node._compile(t5, r3), visible: n3.visible };
      });
      return function(t6, r4, a2) {
        var o2 = [];
        return forEach(i3, function(n3) {
          var i4 = n3.evaluate(t6, r4, a2);
          n3.visible && o2.push(i4);
        }), new n2(o2);
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.blocks.length; n3++) t5(this.blocks[n3].node, `blocks[` + n3 + `].node`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.blocks.length; r3++) {
        var a2 = this.blocks[r3];
        n3[r3] = { node: this._ifNode(t5(a2.node, `blocks[` + r3 + `].node`, this)), visible: a2.visible };
      }
      return new i2(n3);
    }
    clone() {
      return new i2(this.blocks.map(function(t5) {
        return { node: t5.node, visible: t5.visible };
      }));
    }
    _toString(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toString(t5) + (n3.visible ? `` : `;`);
      }).join(`
`);
    }
    toJSON() {
      return { mathjs: name$108, blocks: this.blocks };
    }
    static fromJSON(t5) {
      return new i2(t5.blocks);
    }
    _toHTML(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toHTML(t5) + (n3.visible ? `` : `<span class="math-separator">;</span>`);
      }).join(`<span class="math-separator"><br /></span>`);
    }
    _toTex(t5) {
      return this.blocks.map(function(n3) {
        return n3.node.toTex(t5) + (n3.visible ? `` : `;`);
      }).join(`\\;\\;
`);
    }
  }
  return _defineProperty(i2, `name`, name$108), i2;
}, { isClass: true, isNode: true }), name$107 = `ConditionalNode`, dependencies$107 = [`Node`], createConditionalNode = factory(name$107, dependencies$107, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5) {
    if (typeof t5 == `number` || typeof t5 == `boolean` || typeof t5 == `string`) return !!t5;
    if (t5) {
      if (isBigNumber(t5)) return !t5.isZero();
      if (isComplex(t5)) return !!(t5.re || t5.im);
      if (isUnit(t5)) return !!t5.value;
    }
    if (t5 == null) return false;
    throw TypeError(`Unsupported type of condition "` + typeOf(t5) + `"`);
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$2(t5)) throw TypeError(`Parameter condition must be a Node`);
      if (!isNode$2(n3)) throw TypeError(`Parameter trueExpr must be a Node`);
      if (!isNode$2(r3)) throw TypeError(`Parameter falseExpr must be a Node`);
      this.condition = t5, this.trueExpr = n3, this.falseExpr = r3;
    }
    get type() {
      return name$107;
    }
    get isConditionalNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.condition._compile(t5, n3), a2 = this.trueExpr._compile(t5, n3), o2 = this.falseExpr._compile(t5, n3);
      return function(t6, n4, s2) {
        return r2(i3(t6, n4, s2)) ? a2(t6, n4, s2) : o2(t6, n4, s2);
      };
    }
    forEach(t5) {
      t5(this.condition, `condition`, this), t5(this.trueExpr, `trueExpr`, this), t5(this.falseExpr, `falseExpr`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.condition, `condition`, this)), this._ifNode(t5(this.trueExpr, `trueExpr`, this)), this._ifNode(t5(this.falseExpr, `falseExpr`, this)));
    }
    clone() {
      return new i2(this.condition, this.trueExpr, this.falseExpr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence(this, n3, t5 && t5.implicit), i3 = this.condition.toString(t5), a2 = getPrecedence(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `(` + i3 + `)`);
      var o2 = this.trueExpr.toString(t5), s2 = getPrecedence(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `(` + o2 + `)`);
      var c2 = this.falseExpr.toString(t5), l2 = getPrecedence(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `(` + c2 + `)`), i3 + ` ? ` + o2 + ` : ` + c2;
    }
    toJSON() {
      return { mathjs: name$107, condition: this.condition, trueExpr: this.trueExpr, falseExpr: this.falseExpr };
    }
    static fromJSON(t5) {
      return new i2(t5.condition, t5.trueExpr, t5.falseExpr);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence(this, n3, t5 && t5.implicit), i3 = this.condition.toHTML(t5), a2 = getPrecedence(this.condition, n3, t5 && t5.implicit);
      (n3 === `all` || this.condition.type === `OperatorNode` || a2 !== null && a2 <= r3) && (i3 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + i3 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var o2 = this.trueExpr.toHTML(t5), s2 = getPrecedence(this.trueExpr, n3, t5 && t5.implicit);
      (n3 === `all` || this.trueExpr.type === `OperatorNode` || s2 !== null && s2 <= r3) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`);
      var c2 = this.falseExpr.toHTML(t5), l2 = getPrecedence(this.falseExpr, n3, t5 && t5.implicit);
      return (n3 === `all` || this.falseExpr.type === `OperatorNode` || l2 !== null && l2 <= r3) && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), i3 + `<span class="math-operator math-conditional-operator">?</span>` + o2 + `<span class="math-operator math-conditional-operator">:</span>` + c2;
    }
    _toTex(t5) {
      return `\\begin{cases} {` + this.trueExpr.toTex(t5) + `}, &\\quad{\\text{if }\\;` + this.condition.toTex(t5) + `}\\\\{` + this.falseExpr.toTex(t5) + `}, &\\quad{\\text{otherwise}}\\end{cases}`;
    }
  }
  return _defineProperty(i2, `name`, name$107), i2;
}, { isClass: true, isNode: true }), require_dist = __commonJSMin(((t4, n2) => {
  var r2 = Object.assign || function(t5) {
    for (var n3 = 1; n3 < arguments.length; n3++) {
      var r3 = arguments[n3];
      for (var i3 in r3) Object.prototype.hasOwnProperty.call(r3, i3) && (t5[i3] = r3[i3]);
    }
    return t5;
  }, i2 = { "{": `\\{`, "}": `\\}`, "\\": `\\textbackslash{}`, "#": `\\#`, $: `\\$`, "%": `\\%`, "&": `\\&`, "^": `\\textasciicircum{}`, _: `\\_`, "~": `\\textasciitilde{}` }, a2 = { "–": `\\--`, "—": `\\---`, " ": `~`, "	": `\\qquad{}`, "\r\n": `\\newline{}`, "\n": `\\newline{}` }, o2 = function(t5, n3) {
    return r2({}, t5, n3);
  };
  n2.exports = function(t5) {
    for (var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, s2 = n3.preserveFormatting, c2 = s2 === void 0 ? false : s2, l2 = n3.escapeMapFn, u2 = l2 === void 0 ? o2 : l2, d2 = String(t5), p2 = ``, m2 = u2(r2({}, i2), c2 ? r2({}, a2) : {}), h2 = Object.keys(m2), g2 = function() {
      var t6 = false;
      h2.forEach(function(n4, r3) {
        t6 || d2.length >= n4.length && d2.slice(0, n4.length) === n4 && (p2 += m2[h2[r3]], d2 = d2.slice(n4.length, d2.length), t6 = true);
      }), t6 || (p2 += d2.slice(0, 1), d2 = d2.slice(1, d2.length));
    }; d2; ) g2();
    return p2;
  };
})), import_dist = __toESM(require_dist()), latexSymbols = { Alpha: `A`, alpha: `\\alpha`, Beta: `B`, beta: `\\beta`, Gamma: `\\Gamma`, gamma: `\\gamma`, Delta: `\\Delta`, delta: `\\delta`, Epsilon: `E`, epsilon: `\\epsilon`, varepsilon: `\\varepsilon`, Zeta: `Z`, zeta: `\\zeta`, Eta: `H`, eta: `\\eta`, Theta: `\\Theta`, theta: `\\theta`, vartheta: `\\vartheta`, Iota: `I`, iota: `\\iota`, Kappa: `K`, kappa: `\\kappa`, varkappa: `\\varkappa`, Lambda: `\\Lambda`, lambda: `\\lambda`, Mu: `M`, mu: `\\mu`, Nu: `N`, nu: `\\nu`, Xi: `\\Xi`, xi: `\\xi`, Omicron: `O`, omicron: `o`, Pi: `\\Pi`, pi: `\\pi`, varpi: `\\varpi`, Rho: `P`, rho: `\\rho`, varrho: `\\varrho`, Sigma: `\\Sigma`, sigma: `\\sigma`, varsigma: `\\varsigma`, Tau: `T`, tau: `\\tau`, Upsilon: `\\Upsilon`, upsilon: `\\upsilon`, Phi: `\\Phi`, phi: `\\phi`, varphi: `\\varphi`, Chi: `X`, chi: `\\chi`, Psi: `\\Psi`, psi: `\\psi`, Omega: `\\Omega`, omega: `\\omega`, true: `\\mathrm{True}`, false: `\\mathrm{False}`, i: `i`, inf: `\\infty`, Inf: `\\infty`, infinity: `\\infty`, Infinity: `\\infty`, oo: `\\infty`, lim: `\\lim`, undefined: `\\mathbf{?}` }, latexOperators = { transpose: `^\\top`, ctranspose: `^H`, factorial: `!`, pow: `^`, dotPow: `.^\\wedge`, unaryPlus: `+`, unaryMinus: `-`, bitNot: `\\~`, not: `\\neg`, multiply: `\\cdot`, divide: `\\frac`, dotMultiply: `.\\cdot`, dotDivide: `.:`, mod: `\\mod`, add: `+`, subtract: `-`, to: `\\rightarrow`, leftShift: `<<`, rightArithShift: `>>`, rightLogShift: `>>>`, equal: `=`, unequal: `\\neq`, smaller: `<`, larger: `>`, smallerEq: `\\leq`, largerEq: `\\geq`, bitAnd: `\\&`, bitXor: `\\underline{|}`, bitOr: `|`, and: `\\wedge`, xor: `\\veebar`, or: `\\vee` }, latexFunctions = { abs: { 1: "\\left|${args[0]}\\right|" }, add: { 2: `\\left(\${args[0]}${latexOperators.add}\${args[1]}\\right)` }, cbrt: { 1: "\\sqrt[3]{${args[0]}}" }, ceil: { 1: "\\left\\lceil${args[0]}\\right\\rceil" }, cube: { 1: "\\left(${args[0]}\\right)^3" }, divide: { 2: "\\frac{${args[0]}}{${args[1]}}" }, dotDivide: { 2: `\\left(\${args[0]}${latexOperators.dotDivide}\${args[1]}\\right)` }, dotMultiply: { 2: `\\left(\${args[0]}${latexOperators.dotMultiply}\${args[1]}\\right)` }, dotPow: { 2: `\\left(\${args[0]}${latexOperators.dotPow}\${args[1]}\\right)` }, exp: { 1: "\\exp\\left(${args[0]}\\right)" }, expm1: `\\left(e${latexOperators.pow}{\${args[0]}}-1\\right)`, fix: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, floor: { 1: "\\left\\lfloor${args[0]}\\right\\rfloor" }, fraction: { 2: "\\frac{${args[0]}}{${args[1]}}" }, gcd: "\\gcd\\left(${args}\\right)", hypot: "\\hypot\\left(${args}\\right)", log: { 1: "\\ln\\left(${args[0]}\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}\\right)" }, log10: { 1: "\\log_{10}\\left(${args[0]}\\right)" }, log1p: { 1: "\\ln\\left(${args[0]}+1\\right)", 2: "\\log_{${args[1]}}\\left(${args[0]}+1\\right)" }, log2: "\\log_{2}\\left(${args[0]}\\right)", mod: { 2: `\\left(\${args[0]}${latexOperators.mod}\${args[1]}\\right)` }, multiply: { 2: `\\left(\${args[0]}${latexOperators.multiply}\${args[1]}\\right)` }, norm: { 1: "\\left\\|${args[0]}\\right\\|", 2: void 0 }, nthRoot: { 2: "\\sqrt[${args[1]}]{${args[0]}}" }, nthRoots: { 2: "\\{y : y^${args[1]} = {${args[0]}}\\}" }, pow: { 2: `\\left(\${args[0]}\\right)${latexOperators.pow}{\${args[1]}}` }, round: { 1: "\\left\\lfloor${args[0]}\\right\\rceil", 2: void 0 }, sign: { 1: "\\mathrm{${name}}\\left(${args[0]}\\right)" }, sqrt: { 1: "\\sqrt{${args[0]}}" }, square: { 1: "\\left(${args[0]}\\right)^2" }, subtract: { 2: `\\left(\${args[0]}${latexOperators.subtract}\${args[1]}\\right)` }, unaryMinus: { 1: `${latexOperators.unaryMinus}\\left(\${args[0]}\\right)` }, unaryPlus: { 1: `${latexOperators.unaryPlus}\\left(\${args[0]}\\right)` }, bitAnd: { 2: `\\left(\${args[0]}${latexOperators.bitAnd}\${args[1]}\\right)` }, bitNot: { 1: latexOperators.bitNot + "\\left(${args[0]}\\right)" }, bitOr: { 2: `\\left(\${args[0]}${latexOperators.bitOr}\${args[1]}\\right)` }, bitXor: { 2: `\\left(\${args[0]}${latexOperators.bitXor}\${args[1]}\\right)` }, leftShift: { 2: `\\left(\${args[0]}${latexOperators.leftShift}\${args[1]}\\right)` }, rightArithShift: { 2: `\\left(\${args[0]}${latexOperators.rightArithShift}\${args[1]}\\right)` }, rightLogShift: { 2: `\\left(\${args[0]}${latexOperators.rightLogShift}\${args[1]}\\right)` }, bellNumbers: { 1: "\\mathrm{B}_{${args[0]}}" }, catalan: { 1: "\\mathrm{C}_{${args[0]}}" }, stirlingS2: { 2: "\\mathrm{S}\\left(${args}\\right)" }, arg: { 1: "\\arg\\left(${args[0]}\\right)" }, conj: { 1: "\\left(${args[0]}\\right)^*" }, im: { 1: "\\Im\\left\\lbrace${args[0]}\\right\\rbrace" }, re: { 1: "\\Re\\left\\lbrace${args[0]}\\right\\rbrace" }, and: { 2: `\\left(\${args[0]}${latexOperators.and}\${args[1]}\\right)` }, not: { 1: latexOperators.not + "\\left(${args[0]}\\right)" }, or: { 2: `\\left(\${args[0]}${latexOperators.or}\${args[1]}\\right)` }, xor: { 2: `\\left(\${args[0]}${latexOperators.xor}\${args[1]}\\right)` }, cross: { 2: "\\left(${args[0]}\\right)\\times\\left(${args[1]}\\right)" }, ctranspose: { 1: `\\left(\${args[0]}\\right)${latexOperators.ctranspose}` }, det: { 1: "\\det\\left(${args[0]}\\right)" }, dot: { 2: "\\left(${args[0]}\\cdot${args[1]}\\right)" }, expm: { 1: "\\exp\\left(${args[0]}\\right)" }, inv: { 1: "\\left(${args[0]}\\right)^{-1}" }, pinv: { 1: "\\left(${args[0]}\\right)^{+}" }, sqrtm: { 1: `{\${args[0]}}${latexOperators.pow}{\\frac{1}{2}}` }, trace: { 1: "\\mathrm{tr}\\left(${args[0]}\\right)" }, transpose: { 1: `\\left(\${args[0]}\\right)${latexOperators.transpose}` }, combinations: { 2: "\\binom{${args[0]}}{${args[1]}}" }, combinationsWithRep: { 2: "\\left(\\!\\!{\\binom{${args[0]}}{${args[1]}}}\\!\\!\\right)" }, factorial: { 1: `\\left(\${args[0]}\\right)${latexOperators.factorial}` }, gamma: { 1: "\\Gamma\\left(${args[0]}\\right)" }, lgamma: { 1: "\\ln\\Gamma\\left(${args[0]}\\right)" }, equal: { 2: `\\left(\${args[0]}${latexOperators.equal}\${args[1]}\\right)` }, larger: { 2: `\\left(\${args[0]}${latexOperators.larger}\${args[1]}\\right)` }, largerEq: { 2: `\\left(\${args[0]}${latexOperators.largerEq}\${args[1]}\\right)` }, smaller: { 2: `\\left(\${args[0]}${latexOperators.smaller}\${args[1]}\\right)` }, smallerEq: { 2: `\\left(\${args[0]}${latexOperators.smallerEq}\${args[1]}\\right)` }, unequal: { 2: `\\left(\${args[0]}${latexOperators.unequal}\${args[1]}\\right)` }, erf: { 1: "erf\\left(${args[0]}\\right)" }, max: "\\max\\left(${args}\\right)", min: "\\min\\left(${args}\\right)", variance: "\\mathrm{Var}\\left(${args}\\right)", acos: { 1: "\\cos^{-1}\\left(${args[0]}\\right)" }, acosh: { 1: "\\cosh^{-1}\\left(${args[0]}\\right)" }, acot: { 1: "\\cot^{-1}\\left(${args[0]}\\right)" }, acoth: { 1: "\\coth^{-1}\\left(${args[0]}\\right)" }, acsc: { 1: "\\csc^{-1}\\left(${args[0]}\\right)" }, acsch: { 1: "\\mathrm{csch}^{-1}\\left(${args[0]}\\right)" }, asec: { 1: "\\sec^{-1}\\left(${args[0]}\\right)" }, asech: { 1: "\\mathrm{sech}^{-1}\\left(${args[0]}\\right)" }, asin: { 1: "\\sin^{-1}\\left(${args[0]}\\right)" }, asinh: { 1: "\\sinh^{-1}\\left(${args[0]}\\right)" }, atan: { 1: "\\tan^{-1}\\left(${args[0]}\\right)" }, atan2: { 2: "\\mathrm{atan2}\\left(${args}\\right)" }, atanh: { 1: "\\tanh^{-1}\\left(${args[0]}\\right)" }, cos: { 1: "\\cos\\left(${args[0]}\\right)" }, cosh: { 1: "\\cosh\\left(${args[0]}\\right)" }, cot: { 1: "\\cot\\left(${args[0]}\\right)" }, coth: { 1: "\\coth\\left(${args[0]}\\right)" }, csc: { 1: "\\csc\\left(${args[0]}\\right)" }, csch: { 1: "\\mathrm{csch}\\left(${args[0]}\\right)" }, sec: { 1: "\\sec\\left(${args[0]}\\right)" }, sech: { 1: "\\mathrm{sech}\\left(${args[0]}\\right)" }, sin: { 1: "\\sin\\left(${args[0]}\\right)" }, sinh: { 1: "\\sinh\\left(${args[0]}\\right)" }, tan: { 1: "\\tan\\left(${args[0]}\\right)" }, tanh: { 1: "\\tanh\\left(${args[0]}\\right)" }, to: { 2: `\\left(\${args[0]}${latexOperators.to}\${args[1]}\\right)` }, numeric: function(t4, n2) {
  return t4.args[0].toTex();
}, number: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" }, string: { 0: `\\mathtt{""}`, 1: "\\mathrm{string}\\left(${args[0]}\\right)" }, bignumber: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, bigint: { 0: `0`, 1: "\\left(${args[0]}\\right)" }, complex: { 0: `0`, 1: "\\left(${args[0]}\\right)", 2: `\\left(\\left(\${args[0]}\\right)+${latexSymbols.i}\\cdot\\left(\${args[1]}\\right)\\right)` }, matrix: { 0: `\\begin{bmatrix}\\end{bmatrix}`, 1: "\\left(${args[0]}\\right)", 2: "\\left(${args[0]}\\right)" }, sparse: { 0: `\\begin{bsparse}\\end{bsparse}`, 1: "\\left(${args[0]}\\right)" }, unit: { 1: "\\left(${args[0]}\\right)", 2: "\\left(\\left(${args[0]}\\right)${args[1]}\\right)" } }, defaultTemplate = "\\mathrm{${name}}\\left(${args}\\right)", latexUnits = { deg: `^\\circ` };
function escapeLatex(t4) {
  return (0, import_dist.default)(t4, { preserveFormatting: true });
}
function toSymbol(t4, n2) {
  return n2 = n2 === void 0 ? false : n2, n2 ? hasOwnProperty$1$1(latexUnits, t4) ? latexUnits[t4] : `\\mathrm{` + escapeLatex(t4) + `}` : hasOwnProperty$1$1(latexSymbols, t4) ? latexSymbols[t4] : escapeLatex(t4);
}
var name$106 = `ConstantNode`, dependencies$106 = [`Node`, `isBounded`], createConstantNode = factory(name$106, dependencies$106, (t4) => {
  var { Node: n2, isBounded: r2 } = t4;
  class i2 extends n2 {
    constructor(t5) {
      super(), this.value = t5;
    }
    get type() {
      return name$106;
    }
    get isConstantNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.value;
      return function() {
        return r3;
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    clone() {
      return new i2(this.value);
    }
    _toString(t5) {
      return format(this.value, t5);
    }
    _toHTML(t5) {
      var n3 = this._toString(t5);
      switch (typeOf(this.value)) {
        case `number`:
        case `bigint`:
        case `BigNumber`:
        case `Fraction`:
          return `<span class="math-number">` + n3 + `</span>`;
        case `string`:
          return `<span class="math-string">` + n3 + `</span>`;
        case `boolean`:
          return `<span class="math-boolean">` + n3 + `</span>`;
        case `null`:
          return `<span class="math-null-symbol">` + n3 + `</span>`;
        case `undefined`:
          return `<span class="math-undefined">` + n3 + `</span>`;
        default:
          return `<span class="math-symbol">` + n3 + `</span>`;
      }
    }
    toJSON() {
      return { mathjs: name$106, value: this.value };
    }
    static fromJSON(t5) {
      return new i2(t5.value);
    }
    _toTex(t5) {
      var n3 = this._toString(t5);
      switch (typeOf(this.value)) {
        case `string`:
          return `\\mathtt{` + escapeLatex(n3) + `}`;
        case `number`:
        case `BigNumber`:
          if (!r2(this.value)) return this.value.valueOf() < 0 ? `-\\infty` : `\\infty`;
          var i3 = n3.toLowerCase().indexOf(`e`);
          return i3 === -1 ? n3 : n3.substring(0, i3) + `\\cdot10^{` + n3.substring(i3 + 1) + `}`;
        case `bigint`:
          return n3.toString();
        case `Fraction`:
          return this.value.toLatex();
        default:
          return n3;
      }
    }
  }
  return _defineProperty(i2, `name`, name$106), i2;
}, { isClass: true, isNode: true }), name$105 = `FunctionAssignmentNode`, dependencies$105 = [`typed`, `Node`], createFunctionAssignmentNode = factory(name$105, dependencies$105, (t4) => {
  var { typed: n2, Node: r2 } = t4;
  function i2(t5, n3, r3) {
    var i3 = getPrecedence(t5, n3, r3), a3 = getPrecedence(t5.expr, n3, r3);
    return n3 === `all` || a3 !== null && a3 <= i3;
  }
  class a2 extends r2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      if (!Array.isArray(n3)) throw TypeError(`Array containing strings or objects expected for parameter "params"`);
      if (!isNode$2(r3)) throw TypeError(`Node expected for parameter "expr"`);
      if (keywords.has(t5)) throw Error(`Illegal function name, "` + t5 + `" is a reserved keyword`);
      var i3 = /* @__PURE__ */ new Set();
      for (var a3 of n3) {
        var o2 = typeof a3 == `string` ? a3 : a3.name;
        if (i3.has(o2)) throw Error(`Duplicate parameter name "${o2}"`);
        i3.add(o2);
      }
      this.name = t5, this.params = n3.map(function(t6) {
        return t6 && t6.name || t6;
      }), this.types = n3.map(function(t6) {
        return t6 && t6.type || `any`;
      }), this.expr = r3;
    }
    get type() {
      return name$105;
    }
    get isFunctionAssignmentNode() {
      return true;
    }
    _compile(t5, r3) {
      var i3 = Object.create(r3);
      forEach(this.params, function(t6) {
        i3[t6] = true;
      });
      var a3 = this.expr, o2 = a3._compile(t5, i3), s2 = this.name, c2 = this.params, l2 = join$2(this.types, `,`), u2 = s2 + `(` + join$2(this.params, `, `) + `)`;
      return function(t6, r4, i4) {
        var d2 = {};
        d2[l2] = function() {
          for (var n3 = Object.create(r4), a4 = 0; a4 < c2.length; a4++) n3[c2[a4]] = arguments[a4];
          return o2(t6, n3, i4);
        };
        var p2 = n2(s2, d2);
        return p2.syntax = u2, p2.expr = a3.toString(), t6.set(s2, p2), p2;
      };
    }
    forEach(t5) {
      t5(this.expr, `expr`, this);
    }
    map(t5) {
      var n3 = this._ifNode(t5(this.expr, `expr`, this));
      return new a2(this.name, this.params.slice(0), n3);
    }
    clone() {
      return new a2(this.name, this.params.slice(0), this.expr);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toString(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `(` + r3 + `)`), this.name + `(` + this.params.join(`, `) + `) = ` + r3;
    }
    toJSON() {
      var t5 = this.types;
      return { mathjs: name$105, name: this.name, params: this.params.map(function(n3, r3) {
        return { name: n3, type: t5[r3] };
      }), expr: this.expr };
    }
    static fromJSON(t5) {
      return new a2(t5.name, t5.params, t5.expr);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = [], a3 = 0; a3 < this.params.length; a3++) r3.push(`<span class="math-symbol math-parameter">` + escape(this.params[a3]) + `</span>`);
      var o2 = this.expr.toHTML(t5);
      return i2(this, n3, t5 && t5.implicit) && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), `<span class="math-function">` + escape(this.name) + `</span><span class="math-parenthesis math-round-parenthesis">(</span>` + r3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>` + o2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = this.expr.toTex(t5);
      return i2(this, n3, t5 && t5.implicit) && (r3 = `\\left(${r3}\\right)`), `\\mathrm{` + this.name + `}\\left(` + this.params.map(toSymbol).join(`,`) + `\\right)=` + r3;
    }
  }
  return _defineProperty(a2, `name`, name$105), a2;
}, { isClass: true, isNode: true }), name$104 = `IndexNode`, dependencies$104 = [`Node`, `size`], createIndexNode = factory(name$104, dependencies$104, (t4) => {
  var { Node: n2, size: r2 } = t4;
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), this.dimensions = t5, this.dotNotation = n3 || false, !Array.isArray(t5) || !t5.every(isNode$2)) throw TypeError(`Array containing Nodes expected for parameter "dimensions"`);
      if (this.dotNotation && !this.isObjectProperty()) throw Error(`dotNotation only applicable for object properties`);
    }
    get type() {
      return name$104;
    }
    get isIndexNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = map$1(this.dimensions, function(i4, a3) {
        if (i4.filter((t6) => t6.isSymbolNode && t6.name === `end`).length > 0) {
          var o2 = Object.create(n3);
          o2.end = true;
          var s2 = i4._compile(t5, o2);
          return function(t6, n4, i5) {
            if (!isMatrix(i5) && !isArray(i5) && !isString(i5)) throw TypeError(`Cannot resolve "end": context must be a Matrix, Array, or string but is ` + typeOf(i5));
            var o3 = r2(i5), c2 = Object.create(n4);
            return c2.end = o3[a3], s2(t6, c2, i5);
          };
        } else return i4._compile(t5, n3);
      }), a2 = getSafeProperty(t5, `index`);
      return function(t6, n4, r3) {
        return a2(...map$1(i3, function(i4) {
          return i4(t6, n4, r3);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.dimensions.length; n3++) t5(this.dimensions[n3], `dimensions[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this._ifNode(t5(this.dimensions[r3], `dimensions[` + r3 + `]`, this));
      return new i2(n3, this.dotNotation);
    }
    clone() {
      return new i2(this.dimensions.slice(0), this.dotNotation);
    }
    isObjectProperty() {
      return this.dimensions.length === 1 && isConstantNode(this.dimensions[0]) && typeof this.dimensions[0].value == `string`;
    }
    getObjectProperty() {
      return this.isObjectProperty() ? this.dimensions[0].value : null;
    }
    _toString(t5) {
      return this.dotNotation ? `.` + this.getObjectProperty() : `[` + this.dimensions.join(`, `) + `]`;
    }
    toJSON() {
      return { mathjs: name$104, dimensions: this.dimensions, dotNotation: this.dotNotation };
    }
    static fromJSON(t5) {
      return new i2(t5.dimensions, t5.dotNotation);
    }
    _toHTML(t5) {
      for (var n3 = [], r3 = 0; r3 < this.dimensions.length; r3++) n3[r3] = this.dimensions[r3].toHTML();
      return this.dotNotation ? `<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">` + escape(this.getObjectProperty()) + `</span>` : `<span class="math-parenthesis math-square-parenthesis">[</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-square-parenthesis">]</span>`;
    }
    _toTex(t5) {
      var n3 = this.dimensions.map(function(n4) {
        return n4.toTex(t5);
      });
      return this.dotNotation ? `.` + this.getObjectProperty() : `_{` + n3.join(`,`) + `}`;
    }
  }
  return _defineProperty(i2, `name`, name$104), i2;
}, { isClass: true, isNode: true }), name$103 = `ObjectNode`, dependencies$103 = [`Node`], createObjectNode = factory(name$103, dependencies$103, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), this.properties = t5 || {}, t5 && (typeof t5 != `object` || !Object.keys(t5).every(function(n3) {
        return isNode$2(t5[n3]);
      }))) throw TypeError(`Object containing Nodes expected`);
    }
    get type() {
      return name$103;
    }
    get isObjectNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = {};
      for (var i2 in this.properties) if (hasOwnProperty$1$1(this.properties, i2)) {
        var a2 = stringify(i2), o2 = JSON.parse(a2);
        r3[o2] = getSafeProperty(this.properties, i2)._compile(t5, n3);
      }
      return function(t6, n4, i3) {
        var a3 = {};
        for (var o3 in r3) hasOwnProperty$1$1(r3, o3) && (a3[o3] = r3[o3](t6, n4, i3));
        return a3;
      };
    }
    forEach(t5) {
      for (var n3 in this.properties) hasOwnProperty$1$1(this.properties, n3) && t5(this.properties[n3], `properties[` + stringify(n3) + `]`, this);
    }
    map(t5) {
      var n3 = {};
      for (var i2 in this.properties) hasOwnProperty$1$1(this.properties, i2) && (n3[i2] = this._ifNode(t5(this.properties[i2], `properties[` + stringify(i2) + `]`, this)));
      return new r2(n3);
    }
    clone() {
      var t5 = {};
      for (var n3 in this.properties) hasOwnProperty$1$1(this.properties, n3) && (t5[n3] = this.properties[n3]);
      return new r2(t5);
    }
    _toString(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$1(this.properties, r3) && n3.push(stringify(r3) + `: ` + this.properties[r3].toString(t5));
      return `{` + n3.join(`, `) + `}`;
    }
    toJSON() {
      return { mathjs: name$103, properties: this.properties };
    }
    static fromJSON(t5) {
      return new r2(t5.properties);
    }
    _toHTML(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$1(this.properties, r3) && n3.push(`<span class="math-symbol math-property">` + escape(r3) + `</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>` + this.properties[r3].toHTML(t5));
      return `<span class="math-parenthesis math-curly-parenthesis">{</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-parenthesis math-curly-parenthesis">}</span>`;
    }
    _toTex(t5) {
      var n3 = [];
      for (var r3 in this.properties) hasOwnProperty$1$1(this.properties, r3) && n3.push(`\\mathbf{` + r3 + `:} & ` + this.properties[r3].toTex(t5) + `\\\\`);
      return `\\left\\{\\begin{array}{ll}` + n3.join(`
`) + `\\end{array}\\right\\}`;
    }
  }
  return _defineProperty(r2, `name`, name$103), r2;
}, { isClass: true, isNode: true });
function createSubScope(t4, n2) {
  return new PartitionedMap(t4, new ObjectWrappingMap(n2), new Set(Object.keys(n2)));
}
var name$102 = `OperatorNode`, dependencies$102 = [`Node`], createOperatorNode = factory(name$102, dependencies$102, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3) {
    var i3 = t5;
    if (n3 === `auto`) for (; isParenthesisNode(i3); ) i3 = i3.content;
    return isConstantNode(i3) ? true : isOperatorNode(i3) ? r2(i3.args[0], n3) : false;
  }
  function i2(t5, n3, i3, a3, o2) {
    var s2 = getPrecedence(t5, n3, i3), c2 = getAssociativity(t5, n3);
    if (n3 === `all` || a3.length > 2 && t5.getIdentifier() !== `OperatorNode:add` && t5.getIdentifier() !== `OperatorNode:multiply`) return a3.map(function(t6) {
      switch (t6.getContent().type) {
        case `ArrayNode`:
        case `ConstantNode`:
        case `SymbolNode`:
        case `ParenthesisNode`:
          return false;
        default:
          return true;
      }
    });
    var l2;
    switch (a3.length) {
      case 0:
        l2 = [];
        break;
      case 1:
        var u2 = getPrecedence(a3[0], n3, i3, t5);
        if (o2 && u2 !== null) {
          var d2, p2;
          if (n3 === `keep` ? (d2 = a3[0].getIdentifier(), p2 = t5.getIdentifier()) : (d2 = a3[0].getContent().getIdentifier(), p2 = t5.getContent().getIdentifier()), properties[s2][p2].latexLeftParens === false) {
            l2 = [false];
            break;
          }
          if (properties[u2][d2].latexParens === false) {
            l2 = [false];
            break;
          }
        }
        if (u2 === null) {
          l2 = [false];
          break;
        }
        if (u2 <= s2) {
          l2 = [true];
          break;
        }
        l2 = [false];
        break;
      case 2:
        var m2, h2 = getPrecedence(a3[0], n3, i3, t5), g2 = isAssociativeWith(t5, a3[0], n3);
        m2 = h2 === null ? false : h2 === s2 && c2 === `right` && !g2 ? true : h2 < s2;
        var v2, y2 = getPrecedence(a3[1], n3, i3, t5), b2 = isAssociativeWith(t5, a3[1], n3);
        if (v2 = y2 === null ? false : y2 === s2 && c2 === `left` && !b2 ? true : y2 < s2, o2) {
          var x2, S2, w2;
          n3 === `keep` ? (x2 = t5.getIdentifier(), S2 = t5.args[0].getIdentifier(), w2 = t5.args[1].getIdentifier()) : (x2 = t5.getContent().getIdentifier(), S2 = t5.args[0].getContent().getIdentifier(), w2 = t5.args[1].getContent().getIdentifier()), h2 !== null && (properties[s2][x2].latexLeftParens === false && (m2 = false), properties[h2][S2].latexParens === false && (m2 = false)), y2 !== null && (properties[s2][x2].latexRightParens === false && (v2 = false), properties[y2][w2].latexParens === false && (v2 = false));
        }
        l2 = [m2, v2];
        break;
      default:
        (t5.getIdentifier() === `OperatorNode:add` || t5.getIdentifier() === `OperatorNode:multiply`) && (l2 = a3.map(function(r3) {
          var a4 = getPrecedence(r3, n3, i3, t5), o3 = isAssociativeWith(t5, r3, n3), l3 = getAssociativity(r3, n3);
          return a4 === null ? false : s2 === a4 && c2 === l3 && !o3 ? true : a4 < s2;
        }));
        break;
    }
    if (a3.length >= 2 && t5.getIdentifier() === `OperatorNode:multiply` && t5.implicit && n3 !== `all` && i3 === `hide`) for (var E = 1; E < l2.length; ++E) r2(a3[E], n3) && !l2[E - 1] && (n3 !== `keep` || !isParenthesisNode(a3[E - 1])) && (l2[E] = true);
    return l2;
  }
  class a2 extends n2 {
    constructor(t5, n3, r3, i3, a3) {
      if (super(), typeof t5 != `string`) throw TypeError(`string expected for parameter "op"`);
      if (typeof n3 != `string`) throw TypeError(`string expected for parameter "fn"`);
      if (!Array.isArray(r3) || !r3.every(isNode$2)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      this.implicit = i3 === true, this.isPercentage = a3 === true, this.op = t5, this.fn = n3, this.args = r3 || [];
    }
    get type() {
      return name$102;
    }
    get isOperatorNode() {
      return true;
    }
    _compile(t5, n3) {
      if (typeof this.fn != `string` || !isSafeMethod(t5, this.fn)) throw t5[this.fn] ? Error(`No access to function "` + this.fn + `"`) : Error(`Function ` + this.fn + ` missing in provided namespace "math"`);
      var r3 = getSafeProperty(t5, this.fn), i3 = map$1(this.args, function(r4) {
        return r4._compile(t5, n3);
      });
      if (typeof r3 == `function` && r3.rawArgs === true) {
        var a3 = this.args;
        return function(n4, i4, o3) {
          return r3(a3, t5, createSubScope(n4, i4));
        };
      } else if (i3.length === 1) {
        var o2 = i3[0];
        return function(t6, n4, i4) {
          return r3(o2(t6, n4, i4));
        };
      } else if (i3.length === 2) {
        var s2 = i3[0], c2 = i3[1];
        return function(t6, n4, i4) {
          return r3(s2(t6, n4, i4), c2(t6, n4, i4));
        };
      } else return function(t6, n4, a4) {
        return r3.apply(null, map$1(i3, function(r4) {
          return r4(t6, n4, a4);
        }));
      };
    }
    forEach(t5) {
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = [], r3 = 0; r3 < this.args.length; r3++) n3[r3] = this._ifNode(t5(this.args[r3], `args[` + r3 + `]`, this));
      return new a2(this.op, this.fn, n3, this.implicit, this.isPercentage);
    }
    clone() {
      return new a2(this.op, this.fn, this.args.slice(0), this.implicit, this.isPercentage);
    }
    isUnary() {
      return this.args.length === 1;
    }
    isBinary() {
      return this.args.length === 2;
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity(this, n3), c2 = a3[0].toString(t5);
        o2[0] && (c2 = `(` + c2 + `)`);
        var l2 = /[a-zA-Z]+/.test(this.op);
        return s2 === `right` ? this.op + (l2 ? ` ` : ``) + c2 : s2 === `left` ? c2 + (l2 ? ` ` : ``) + this.op : c2 + this.op;
      } else if (a3.length === 2) {
        var u2 = a3[0].toString(t5), d2 = a3[1].toString(t5);
        return o2[0] && (u2 = `(` + u2 + `)`), o2[1] && (d2 = `(` + d2 + `)`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? u2 + ` ` + d2 : u2 + ` ` + this.op + ` ` + d2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var p2 = a3.map(function(n4, r4) {
          return n4 = n4.toString(t5), o2[r4] && (n4 = `(` + n4 + `)`), n4;
        });
        return this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? p2.join(` `) : p2.join(` ` + this.op + ` `);
      } else return this.fn + `(` + this.args.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$102, op: this.op, fn: this.fn, args: this.args, implicit: this.implicit, isPercentage: this.isPercentage };
    }
    static fromJSON(t5) {
      return new a2(t5.op, t5.fn, t5.args, t5.implicit, t5.isPercentage);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, false);
      if (a3.length === 1) {
        var s2 = getAssociativity(this, n3), c2 = a3[0].toHTML(t5);
        return o2[0] && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), s2 === `right` ? `<span class="math-operator math-unary-operator math-lefthand-unary-operator">` + escape(this.op) + `</span>` + c2 : c2 + `<span class="math-operator math-unary-operator math-righthand-unary-operator">` + escape(this.op) + `</span>`;
      } else if (a3.length === 2) {
        var l2 = a3[0].toHTML(t5), u2 = a3[1].toHTML(t5);
        return o2[0] && (l2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + l2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), o2[1] && (u2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + u2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? l2 + `<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>` + u2 : l2 + `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape(this.op) + `</span>` + u2;
      } else {
        var d2 = a3.map(function(n4, r4) {
          return n4 = n4.toHTML(t5), o2[r4] && (n4 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + n4 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), n4;
        });
        return a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`) ? this.implicit && this.getIdentifier() === `OperatorNode:multiply` && r3 === `hide` ? d2.join(`<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>`) : d2.join(`<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape(this.op) + `</span>`) : `<span class="math-function">` + escape(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + d2.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
      }
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = t5 && t5.implicit ? t5.implicit : `hide`, a3 = this.args, o2 = i2(this, n3, r3, a3, true), s2 = latexOperators[this.fn];
      if (s2 = s2 === void 0 ? this.op : s2, a3.length === 1) {
        var c2 = getAssociativity(this, n3), l2 = a3[0].toTex(t5);
        return o2[0] && (l2 = `\\left(${l2}\\right)`), c2 === `right` ? s2 + l2 : l2 + s2;
      } else if (a3.length === 2) {
        var u2 = a3[0], d2 = u2.toTex(t5);
        o2[0] && (d2 = `\\left(${d2}\\right)`);
        var p2 = a3[1].toTex(t5);
        o2[1] && (p2 = `\\left(${p2}\\right)`);
        var m2 = n3 === `keep` ? u2.getIdentifier() : u2.getContent().getIdentifier();
        switch (this.getIdentifier()) {
          case `OperatorNode:divide`:
            return s2 + `{` + d2 + `}{` + p2 + `}`;
          case `OperatorNode:pow`:
            switch (d2 = `{` + d2 + `}`, p2 = `{` + p2 + `}`, m2) {
              case `ConditionalNode`:
              case `OperatorNode:divide`:
                d2 = `\\left(${d2}\\right)`;
            }
            break;
          case `OperatorNode:multiply`:
            if (this.implicit && r3 === `hide`) return d2 + `~` + p2;
        }
        return d2 + s2 + p2;
      } else if (a3.length > 2 && (this.getIdentifier() === `OperatorNode:add` || this.getIdentifier() === `OperatorNode:multiply`)) {
        var h2 = a3.map(function(n4, r4) {
          return n4 = n4.toTex(t5), o2[r4] && (n4 = `\\left(${n4}\\right)`), n4;
        });
        return this.getIdentifier() === `OperatorNode:multiply` && this.implicit && r3 === `hide` ? h2.join(`~`) : h2.join(s2);
      } else return `\\mathrm{` + this.fn + `}\\left(` + a3.map(function(n4) {
        return n4.toTex(t5);
      }).join(`,`) + `\\right)`;
    }
    getIdentifier() {
      return this.type + `:` + this.fn;
    }
  }
  return _defineProperty(a2, `name`, name$102), a2;
}, { isClass: true, isNode: true }), name$101 = `ParenthesisNode`, dependencies$101 = [`Node`], createParenthesisNode = factory(name$101, dependencies$101, (t4) => {
  var { Node: n2 } = t4;
  class r2 extends n2 {
    constructor(t5) {
      if (super(), !isNode$2(t5)) throw TypeError(`Node expected for parameter "content"`);
      this.content = t5;
    }
    get type() {
      return name$101;
    }
    get isParenthesisNode() {
      return true;
    }
    _compile(t5, n3) {
      return this.content._compile(t5, n3);
    }
    getContent() {
      return this.content.getContent();
    }
    forEach(t5) {
      t5(this.content, `content`, this);
    }
    map(t5) {
      return new r2(t5(this.content, `content`, this));
    }
    clone() {
      return new r2(this.content);
    }
    _toString(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `(` + this.content.toString(t5) + `)` : this.content.toString(t5);
    }
    toJSON() {
      return { mathjs: name$101, content: this.content };
    }
    static fromJSON(t5) {
      return new r2(t5.content);
    }
    _toHTML(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + this.content.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : this.content.toHTML(t5);
    }
    _toTex(t5) {
      return !t5 || t5 && !t5.parenthesis || t5 && t5.parenthesis === `keep` ? `\\left(${this.content.toTex(t5)}\\right)` : this.content.toTex(t5);
    }
  }
  return _defineProperty(r2, `name`, name$101), r2;
}, { isClass: true, isNode: true }), name$100 = `RangeNode`, dependencies$100 = [`Node`], createRangeNode = factory(name$100, dependencies$100, (t4) => {
  var { Node: n2 } = t4;
  function r2(t5, n3, r3) {
    var i3 = getPrecedence(t5, n3, r3), a2 = {}, o2 = getPrecedence(t5.start, n3, r3);
    if (a2.start = o2 !== null && o2 <= i3 || n3 === `all`, t5.step) {
      var s2 = getPrecedence(t5.step, n3, r3);
      a2.step = s2 !== null && s2 <= i3 || n3 === `all`;
    }
    var c2 = getPrecedence(t5.end, n3, r3);
    return a2.end = c2 !== null && c2 <= i3 || n3 === `all`, a2;
  }
  class i2 extends n2 {
    constructor(t5, n3, r3) {
      if (super(), !isNode$2(t5) || !isNode$2(n3) || r3 && !isNode$2(r3)) throw TypeError(`Node expected`);
      if (arguments.length > 3) throw Error(`Too many arguments`);
      this.start = t5, this.end = n3, this.step = r3 || null;
    }
    get type() {
      return name$100;
    }
    get isRangeNode() {
      return true;
    }
    needsEnd() {
      return this.filter(function(t5) {
        return isSymbolNode(t5) && t5.name === `end`;
      }).length > 0;
    }
    _compile(t5, n3) {
      var r3 = t5.range, i3 = this.start._compile(t5, n3), a2 = this.end._compile(t5, n3);
      if (this.step) {
        var o2 = this.step._compile(t5, n3);
        return function(t6, n4, s2) {
          return r3(i3(t6, n4, s2), a2(t6, n4, s2), o2(t6, n4, s2));
        };
      } else return function(t6, n4, o3) {
        return r3(i3(t6, n4, o3), a2(t6, n4, o3));
      };
    }
    forEach(t5) {
      t5(this.start, `start`, this), t5(this.end, `end`, this), this.step && t5(this.step, `step`, this);
    }
    map(t5) {
      return new i2(this._ifNode(t5(this.start, `start`, this)), this._ifNode(t5(this.end, `end`, this)), this.step && this._ifNode(t5(this.step, `step`, this)));
    }
    clone() {
      return new i2(this.start, this.end, this.step && this.step);
    }
    _toString(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toString(t5);
      if (i3.start && (o2 = `(` + o2 + `)`), a2 = o2, this.step) {
        var s2 = this.step.toString(t5);
        i3.step && (s2 = `(` + s2 + `)`), a2 += `:` + s2;
      }
      var c2 = this.end.toString(t5);
      return i3.end && (c2 = `(` + c2 + `)`), a2 += `:` + c2, a2;
    }
    toJSON() {
      return { mathjs: name$100, start: this.start, end: this.end, step: this.step };
    }
    static fromJSON(t5) {
      return new i2(t5.start, t5.end, t5.step);
    }
    _toHTML(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2, o2 = this.start.toHTML(t5);
      if (i3.start && (o2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + o2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 = o2, this.step) {
        var s2 = this.step.toHTML(t5);
        i3.step && (s2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + s2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + s2;
      }
      var c2 = this.end.toHTML(t5);
      return i3.end && (c2 = `<span class="math-parenthesis math-round-parenthesis">(</span>` + c2 + `<span class="math-parenthesis math-round-parenthesis">)</span>`), a2 += `<span class="math-operator math-range-operator">:</span>` + c2, a2;
    }
    _toTex(t5) {
      var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = r2(this, n3, t5 && t5.implicit), a2 = this.start.toTex(t5);
      if (i3.start && (a2 = `\\left(${a2}\\right)`), this.step) {
        var o2 = this.step.toTex(t5);
        i3.step && (o2 = `\\left(${o2}\\right)`), a2 += `:` + o2;
      }
      var s2 = this.end.toTex(t5);
      return i3.end && (s2 = `\\left(${s2}\\right)`), a2 += `:` + s2, a2;
    }
  }
  return _defineProperty(i2, `name`, name$100), i2;
}, { isClass: true, isNode: true }), name$99 = `RelationalNode`, dependencies$99 = [`Node`], createRelationalNode = factory(name$99, dependencies$99, (t4) => {
  var { Node: n2 } = t4, r2 = { equal: `==`, unequal: `!=`, smaller: `<`, larger: `>`, smallerEq: `<=`, largerEq: `>=` };
  class i2 extends n2 {
    constructor(t5, n3) {
      if (super(), !Array.isArray(t5)) throw TypeError(`Parameter conditionals must be an array`);
      if (!Array.isArray(n3)) throw TypeError(`Parameter params must be an array`);
      if (t5.length !== n3.length - 1) throw TypeError(`Parameter params must contain exactly one more element than parameter conditionals`);
      this.conditionals = t5, this.params = n3;
    }
    get type() {
      return name$99;
    }
    get isRelationalNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this, i3 = this.params.map((r4) => r4._compile(t5, n3));
      return function(n4, a2, o2) {
        for (var s2, c2 = i3[0](n4, a2, o2), l2 = 0; l2 < r3.conditionals.length; l2++) if (s2 = c2, c2 = i3[l2 + 1](n4, a2, o2), !getSafeProperty(t5, r3.conditionals[l2])(s2, c2)) return false;
        return true;
      };
    }
    forEach(t5) {
      this.params.forEach((n3, r3) => t5(n3, `params[` + r3 + `]`, this), this);
    }
    map(t5) {
      return new i2(this.conditionals.slice(), this.params.map((n3, r3) => this._ifNode(t5(n3, `params[` + r3 + `]`, this)), this));
    }
    clone() {
      return new i2(this.conditionals, this.params);
    }
    _toString(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `(` + r3.toString(t5) + `)` : r3.toString(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += ` ` + r2[this.conditionals[s2]], o2 += ` ` + a2[s2 + 1];
      return o2;
    }
    toJSON() {
      return { mathjs: name$99, conditionals: this.conditionals, params: this.params };
    }
    static fromJSON(t5) {
      return new i2(t5.conditionals, t5.params);
    }
    _toHTML(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, i3 = getPrecedence(this, n3, t5 && t5.implicit), a2 = this.params.map(function(r3, a3) {
        var o3 = getPrecedence(r3, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= i3 ? `<span class="math-parenthesis math-round-parenthesis">(</span>` + r3.toHTML(t5) + `<span class="math-parenthesis math-round-parenthesis">)</span>` : r3.toHTML(t5);
      }), o2 = a2[0], s2 = 0; s2 < this.conditionals.length; s2++) o2 += `<span class="math-operator math-binary-operator math-explicit-binary-operator">` + escape(r2[this.conditionals[s2]]) + `</span>` + a2[s2 + 1];
      return o2;
    }
    _toTex(t5) {
      for (var n3 = t5 && t5.parenthesis ? t5.parenthesis : `keep`, r3 = getPrecedence(this, n3, t5 && t5.implicit), i3 = this.params.map(function(i4, a3) {
        var o3 = getPrecedence(i4, n3, t5 && t5.implicit);
        return n3 === `all` || o3 !== null && o3 <= r3 ? `\\left(` + i4.toTex(t5) + `\right)` : i4.toTex(t5);
      }), a2 = i3[0], o2 = 0; o2 < this.conditionals.length; o2++) a2 += latexOperators[this.conditionals[o2]] + i3[o2 + 1];
      return a2;
    }
  }
  return _defineProperty(i2, `name`, name$99), i2;
}, { isClass: true, isNode: true }), name$98 = `SymbolNode`, dependencies$98 = [`math`, `?Unit`, `Node`], createSymbolNode = factory(name$98, dependencies$98, (t4) => {
  var { math: n2, Unit: r2, Node: i2 } = t4;
  function a2(t5) {
    return r2 ? r2.isValuelessUnit(t5) : false;
  }
  class o2 extends i2 {
    constructor(t5) {
      if (super(), typeof t5 != `string`) throw TypeError(`String expected for parameter "name"`);
      this.name = t5;
    }
    get type() {
      return `SymbolNode`;
    }
    get isSymbolNode() {
      return true;
    }
    _compile(t5, n3) {
      var i3 = this.name;
      if (n3[i3] === true) return function(t6, n4, r3) {
        return getSafeProperty(n4, i3);
      };
      if (i3 in t5) return function(n4, r3, a3) {
        return n4.has(i3) ? n4.get(i3) : getSafeProperty(t5, i3);
      };
      var s2 = a2(i3);
      return function(t6, n4, a3) {
        return t6.has(i3) ? t6.get(i3) : s2 ? new r2(null, i3) : o2.onUndefinedSymbol(i3);
      };
    }
    forEach(t5) {
    }
    map(t5) {
      return this.clone();
    }
    static onUndefinedSymbol(t5) {
      throw Error(`Undefined symbol ` + t5);
    }
    clone() {
      return new o2(this.name);
    }
    _toString(t5) {
      return this.name;
    }
    _toHTML(t5) {
      var n3 = escape(this.name);
      return n3 === `true` || n3 === `false` ? `<span class="math-symbol math-boolean">` + n3 + `</span>` : n3 === `i` ? `<span class="math-symbol math-imaginary-symbol">` + n3 + `</span>` : n3 === `Infinity` ? `<span class="math-symbol math-infinity-symbol">` + n3 + `</span>` : n3 === `NaN` ? `<span class="math-symbol math-nan-symbol">` + n3 + `</span>` : n3 === `null` ? `<span class="math-symbol math-null-symbol">` + n3 + `</span>` : n3 === `undefined` ? `<span class="math-symbol math-undefined-symbol">` + n3 + `</span>` : `<span class="math-symbol">` + n3 + `</span>`;
    }
    toJSON() {
      return { mathjs: `SymbolNode`, name: this.name };
    }
    static fromJSON(t5) {
      return new o2(t5.name);
    }
    _toTex(t5) {
      var r3 = false;
      n2[this.name] === void 0 && a2(this.name) && (r3 = true);
      var i3 = toSymbol(this.name, r3);
      return i3[0] === `\\` ? i3 : ` ` + i3;
    }
  }
  return o2;
}, { isClass: true, isNode: true }), name$97 = `FunctionNode`, dependencies$97 = [`math`, `Node`, `SymbolNode`], createFunctionNode = factory(name$97, dependencies$97, (t4) => {
  var n2, { math: r2, Node: i2, SymbolNode: a2 } = t4, o2 = (t5) => format(t5, { truncate: 78 });
  function s2(t5, n3, r3) {
    for (var i3 = ``, a3 = /\$(?:\{([a-z_][a-z_0-9]*)(?:\[([0-9]+)\])?\}|\$)/gi, o3 = 0, s3; (s3 = a3.exec(t5)) !== null; ) if (i3 += t5.substring(o3, s3.index), o3 = s3.index, s3[0] === `$$`) i3 += `$`, o3++;
    else {
      o3 += s3[0].length;
      var c3 = n3[s3[1]];
      if (!c3) throw ReferenceError(`Template: Property ` + s3[1] + ` does not exist.`);
      if (s3[2] === void 0) switch (typeof c3) {
        case `string`:
          i3 += c3;
          break;
        case `object`:
          if (isNode$2(c3)) i3 += c3.toTex(r3);
          else if (Array.isArray(c3)) i3 += c3.map(function(t6, n4) {
            if (isNode$2(t6)) return t6.toTex(r3);
            throw TypeError(`Template: ` + s3[1] + `[` + n4 + `] is not a Node.`);
          }).join(`,`);
          else throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
          break;
        default:
          throw TypeError(`Template: ` + s3[1] + ` has to be a Node, String or array of Nodes`);
      }
      else if (isNode$2(c3[s3[2]] && c3[s3[2]])) i3 += c3[s3[2]].toTex(r3);
      else throw TypeError(`Template: ` + s3[1] + `[` + s3[2] + `] is not a Node.`);
    }
    return i3 += t5.slice(o3), i3;
  }
  class c2 extends i2 {
    constructor(t5, n3, r3) {
      if (super(), typeof t5 == `string` && (t5 = new a2(t5)), !isNode$2(t5)) throw TypeError(`Node expected as parameter "fn"`);
      if (!Array.isArray(n3) || !n3.every(isNode$2)) throw TypeError(`Array containing Nodes expected for parameter "args"`);
      var i3 = typeof r3;
      if (!(i3 === `undefined` || i3 === `boolean`)) throw TypeError(`optional flag, if specified, must be boolean`);
      this.fn = t5, this.args = n3 || [], this.optional = !!r3;
    }
    get name() {
      return this.fn.name || ``;
    }
    get type() {
      return name$97;
    }
    get isFunctionNode() {
      return true;
    }
    _compile(t5, n3) {
      var r3 = this.args.map((r4) => r4._compile(t5, n3)), i3 = this.optional || isAccessorNode(this.fn) && this.fn.optionalChaining;
      if (isSymbolNode(this.fn)) {
        var a3 = this.fn.name;
        if (n3[a3]) {
          var s3 = this.args;
          return function(n4, c3, l3) {
            var u3 = getSafeProperty(c3, a3);
            if (!(i3 && u3 === void 0)) {
              if (typeof u3 != `function`) throw TypeError(`Argument '${a3}' was not a function; received: ${o2(u3)}`);
              if (u3.rawArgs) return u3(s3, t5, createSubScope(n4, c3));
              var d3 = r3.map((t6) => t6(n4, c3, l3));
              return u3.apply(u3, d3);
            }
          };
        } else {
          var l2 = a3 in t5 ? getSafeProperty(t5, a3) : void 0, u2 = typeof l2 == `function` && l2.rawArgs === true, d2 = (n4) => {
            var r4;
            if (n4.has(a3)) r4 = n4.get(a3);
            else if (a3 in t5) r4 = getSafeProperty(t5, a3);
            else if (i3) r4 = void 0;
            else return c2.onUndefinedFunction(a3);
            if (typeof r4 == `function` || i3 && r4 === void 0) return r4;
            throw TypeError(`'${a3}' is not a function; its value is:
  ${o2(r4)}`);
          };
          if (u2) {
            var p2 = this.args;
            return function(n4, i4, a4) {
              var o3 = d2(n4);
              return o3.rawArgs === true ? o3(p2, t5, createSubScope(n4, i4)) : o3(...r3.map((t6) => t6(n4, i4, a4)));
            };
          } else switch (r3.length) {
            case 0:
              return function(t6, n4, r4) {
                var a4 = d2(t6);
                if (!(i3 && a4 === void 0)) return a4();
              };
            case 1:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0];
                  return o3(s4(t6, n4, a4));
                }
              };
            case 2:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) {
                  var s4 = r3[0], c3 = r3[1];
                  return o3(s4(t6, n4, a4), c3(t6, n4, a4));
                }
              };
            default:
              return function(t6, n4, a4) {
                var o3 = d2(t6);
                if (!(i3 && o3 === void 0)) return o3(...r3.map((r4) => r4(t6, n4, a4)));
              };
          }
        }
      } else if (isAccessorNode(this.fn) && isIndexNode(this.fn.index) && this.fn.index.isObjectProperty()) {
        var m2 = this.fn.object._compile(t5, n3), h2 = this.fn.index.getObjectProperty(), g2 = this.args;
        return function(n4, a4, o3) {
          var s4 = m2(n4, a4, o3);
          if (!(i3 && (s4 == null || s4[h2] === void 0))) {
            var c3 = getSafeMethod(s4, h2);
            if (c3 != null && c3.rawArgs) return c3(g2, t5, createSubScope(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, o3));
            return c3.apply(s4, l3);
          }
        };
      } else {
        var v2 = this.fn.toString(), y2 = this.fn._compile(t5, n3), b2 = this.args;
        return function(n4, a4, s4) {
          var c3 = y2(n4, a4, s4);
          if (!(i3 && c3 === void 0)) {
            if (typeof c3 != `function`) throw TypeError(`Expression '${v2}' did not evaluate to a function; value is:
  ${o2(c3)}`);
            if (c3.rawArgs) return c3(b2, t5, createSubScope(n4, a4));
            var l3 = r3.map((t6) => t6(n4, a4, s4));
            return c3.apply(c3, l3);
          }
        };
      }
    }
    forEach(t5) {
      t5(this.fn, `fn`, this);
      for (var n3 = 0; n3 < this.args.length; n3++) t5(this.args[n3], `args[` + n3 + `]`, this);
    }
    map(t5) {
      for (var n3 = this._ifNode(t5(this.fn, `fn`, this)), r3 = [], i3 = 0; i3 < this.args.length; i3++) r3[i3] = this._ifNode(t5(this.args[i3], `args[` + i3 + `]`, this));
      return new c2(n3, r3);
    }
    clone() {
      return new c2(this.fn, this.args.slice(0));
    }
    toString(t5) {
      var n3, r3 = this.fn.toString(t5);
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$1(t5.handler, r3) && (n3 = t5.handler[r3](this, t5)), n3 === void 0 ? super.toString(t5) : n3;
    }
    _toString(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toString(t5);
      });
      return (isFunctionAssignmentNode(this.fn) ? `(` + this.fn.toString(t5) + `)` : this.fn.toString(t5)) + `(` + n3.join(`, `) + `)`;
    }
    toJSON() {
      return { mathjs: name$97, fn: this.fn, args: this.args };
    }
    _toHTML(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toHTML(t5);
      });
      return `<span class="math-function">` + escape(this.fn) + `</span><span class="math-paranthesis math-round-parenthesis">(</span>` + n3.join(`<span class="math-separator">,</span>`) + `<span class="math-paranthesis math-round-parenthesis">)</span>`;
    }
    toTex(t5) {
      var n3;
      return t5 && typeof t5.handler == `object` && hasOwnProperty$1$1(t5.handler, this.name) && (n3 = t5.handler[this.name](this, t5)), n3 === void 0 ? super.toTex(t5) : n3;
    }
    _toTex(t5) {
      var n3 = this.args.map(function(n4) {
        return n4.toTex(t5);
      }), i3;
      latexFunctions[this.name] && (i3 = latexFunctions[this.name]), r2[this.name] && (typeof r2[this.name].toTex == `function` || typeof r2[this.name].toTex == `object` || typeof r2[this.name].toTex == `string`) && (i3 = r2[this.name].toTex);
      var a3;
      switch (typeof i3) {
        case `function`:
          a3 = i3(this, t5);
          break;
        case `string`:
          a3 = s2(i3, this, t5);
          break;
        case `object`:
          switch (typeof i3[n3.length]) {
            case `function`:
              a3 = i3[n3.length](this, t5);
              break;
            case `string`:
              a3 = s2(i3[n3.length], this, t5);
              break;
          }
      }
      return a3 === void 0 ? s2(defaultTemplate, this, t5) : a3;
    }
    getIdentifier() {
      return this.type + `:` + this.name;
    }
  }
  return n2 = c2, _defineProperty(c2, `name`, name$97), _defineProperty(c2, `onUndefinedFunction`, function(t5) {
    throw Error(`Undefined function ` + t5);
  }), _defineProperty(c2, `fromJSON`, function(t5) {
    return new n2(t5.fn, t5.args);
  }), c2;
}, { isClass: true, isNode: true }), name$96 = `parse`, dependencies$96 = [`typed`, `numeric`, `config`, `AccessorNode`, `ArrayNode`, `AssignmentNode`, `BlockNode`, `ConditionalNode`, `ConstantNode`, `FunctionAssignmentNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `RangeNode`, `RelationalNode`, `SymbolNode`], createParse = factory(name$96, dependencies$96, (t4) => {
  var { typed: n2, numeric: r2, config: i2, AccessorNode: a2, ArrayNode: o2, AssignmentNode: s2, BlockNode: c2, ConditionalNode: l2, ConstantNode: u2, FunctionAssignmentNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, ParenthesisNode: v2, RangeNode: y2, RelationalNode: b2, SymbolNode: x2 } = t4, S2 = n2(name$96, { string: function(t5) {
    return K2(t5, {});
  }, "Array | Matrix": function(t5) {
    return w2(t5, {});
  }, "string, Object": function(t5, n3) {
    return K2(t5, n3.nodes === void 0 ? {} : n3.nodes);
  }, "Array | Matrix, Object": w2 });
  function w2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3.nodes === void 0 ? {} : n3.nodes;
    return deepMap(t5, function(t6) {
      if (typeof t6 != `string`) throw TypeError(`String expected`);
      return K2(t6, r3);
    });
  }
  var E = { NULL: 0, DELIMITER: 1, NUMBER: 2, SYMBOL: 3, UNKNOWN: 4 }, D = { ",": true, "(": true, ")": true, "[": true, "]": true, "{": true, "}": true, '"': true, "'": true, ";": true, "+": true, "-": true, "*": true, ".*": true, "/": true, "./": true, "%": true, "^": true, ".^": true, "~": true, "!": true, "&": true, "|": true, "^|": true, "=": true, ":": true, "?": true, "?.": true, "??": true, "==": true, "!=": true, "<": true, ">": true, "<=": true, ">=": true, "<<": true, ">>": true, ">>>": true }, O2 = { mod: true, to: true, in: true, and: true, xor: true, or: true, not: true }, j2 = { true: true, false: false, null: null, undefined: void 0 }, M2 = [`NaN`, `Infinity`], N2 = { '"': `"`, "'": `'`, "\\": `\\`, "/": `/`, b: `\b`, f: `\f`, n: `
`, r: `\r`, t: `	` };
  function F() {
    return { extraNodes: {}, expression: ``, comment: ``, index: 0, token: ``, tokenType: E.NULL, nestingLevel: 0, conditionalLevel: null };
  }
  function I2(t5, n3) {
    return t5.expression.substr(t5.index, n3);
  }
  function L2(t5) {
    return I2(t5, 1);
  }
  function R2(t5) {
    t5.index++;
  }
  function z2(t5) {
    return t5.expression.charAt(t5.index - 1);
  }
  function V2(t5) {
    return t5.expression.charAt(t5.index + 1);
  }
  function H2(t5) {
    for (t5.tokenType = E.NULL, t5.token = ``, t5.comment = ``; ; ) {
      if (L2(t5) === `#`) for (; L2(t5) !== `
` && L2(t5) !== ``; ) t5.comment += L2(t5), R2(t5);
      if (S2.isWhitespace(L2(t5), t5.nestingLevel)) R2(t5);
      else break;
    }
    if (L2(t5) === ``) {
      t5.tokenType = E.DELIMITER;
      return;
    }
    if (L2(t5) === `
` && !t5.nestingLevel) {
      t5.tokenType = E.DELIMITER, t5.token = L2(t5), R2(t5);
      return;
    }
    var n3 = L2(t5), r3 = I2(t5, 2), i3 = I2(t5, 3);
    if (i3.length === 3 && D[i3]) {
      t5.tokenType = E.DELIMITER, t5.token = i3, R2(t5), R2(t5), R2(t5);
      return;
    }
    if (r3.length === 2 && D[r3] && (r3 !== `?.` || !S2.isDigit(t5.expression.charAt(t5.index + 2)))) {
      t5.tokenType = E.DELIMITER, t5.token = r3, R2(t5), R2(t5);
      return;
    }
    if (D[n3]) {
      t5.tokenType = E.DELIMITER, t5.token = n3, R2(t5);
      return;
    }
    if (S2.isDigitDot(n3)) {
      t5.tokenType = E.NUMBER;
      var a3 = I2(t5, 2);
      if (a3 === `0b` || a3 === `0o` || a3 === `0x`) {
        for (t5.token += L2(t5), R2(t5), t5.token += L2(t5), R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        if (L2(t5) === `.`) for (t5.token += `.`, R2(t5); S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        else if (L2(t5) === `i`) for (t5.token += `i`, R2(t5); S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        return;
      }
      if (L2(t5) === `.`) {
        if (t5.token += L2(t5), R2(t5), !S2.isDigit(L2(t5))) {
          t5.tokenType = E.DELIMITER;
          return;
        }
      } else {
        for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
        S2.isDecimalMark(L2(t5), V2(t5)) && (t5.token += L2(t5), R2(t5));
      }
      for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      if (L2(t5) === `E` || L2(t5) === `e`) {
        if (S2.isDigit(V2(t5)) || V2(t5) === `-` || V2(t5) === `+`) {
          if (t5.token += L2(t5), R2(t5), (L2(t5) === `+` || L2(t5) === `-`) && (t5.token += L2(t5), R2(t5)), !S2.isDigit(L2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
          for (; S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
          if (S2.isDecimalMark(L2(t5), V2(t5))) throw ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
        } else if (S2.isDecimalMark(V2(t5), t5.expression.charAt(t5.index + 2))) throw R2(t5), ke2(t5, `Digit expected, got "` + L2(t5) + `"`);
      }
      return;
    }
    if (S2.isAlpha(L2(t5), z2(t5), V2(t5))) {
      for (; S2.isAlpha(L2(t5), z2(t5), V2(t5)) || S2.isDigit(L2(t5)); ) t5.token += L2(t5), R2(t5);
      hasOwnProperty$1$1(O2, t5.token) ? t5.tokenType = E.DELIMITER : t5.tokenType = E.SYMBOL;
      return;
    }
    for (t5.tokenType = E.UNKNOWN; L2(t5) !== ``; ) t5.token += L2(t5), R2(t5);
    throw ke2(t5, `Syntax error in part "` + t5.token + `"`);
  }
  function U2(t5) {
    do
      H2(t5);
    while (t5.token === `
`);
  }
  function W2(t5) {
    t5.nestingLevel++;
  }
  function G2(t5) {
    t5.nestingLevel--;
  }
  S2.isAlpha = function(t5, n3, r3) {
    return S2.isValidLatinOrGreek(t5) || S2.isValidMathSymbol(t5, r3) || S2.isValidMathSymbol(n3, t5);
  }, S2.isValidLatinOrGreek = function(t5) {
    return /^[a-zA-Z_$\u00C0-\u02AF\u0370-\u03FF\u2100-\u214F]$/.test(t5);
  }, S2.isValidMathSymbol = function(t5, n3) {
    return /^[\uD835]$/.test(t5) && /^[\uDC00-\uDFFF]$/.test(n3) && /^[^\uDC55\uDC9D\uDCA0\uDCA1\uDCA3\uDCA4\uDCA7\uDCA8\uDCAD\uDCBA\uDCBC\uDCC4\uDD06\uDD0B\uDD0C\uDD15\uDD1D\uDD3A\uDD3F\uDD45\uDD47-\uDD49\uDD51\uDEA6\uDEA7\uDFCC\uDFCD]$/.test(n3);
  }, S2.isWhitespace = function(t5, n3) {
    return t5 === ` ` || t5 === `	` || t5 === ` ` || t5 === `
` && n3 > 0;
  }, S2.isDecimalMark = function(t5, n3) {
    return t5 === `.` && n3 !== `/` && n3 !== `*` && n3 !== `^`;
  }, S2.isDigitDot = function(t5) {
    return t5 >= `0` && t5 <= `9` || t5 === `.`;
  }, S2.isDigit = function(t5) {
    return t5 >= `0` && t5 <= `9`;
  };
  function K2(t5, n3) {
    var r3 = F();
    _extends(r3, { expression: t5, extraNodes: n3 }), H2(r3);
    var i3 = q2(r3);
    if (r3.token !== ``) throw r3.tokenType === E.DELIMITER ? Ae2(r3, `Unexpected operator ` + r3.token) : ke2(r3, `Unexpected part "` + r3.token + `"`);
    return i3;
  }
  function q2(t5) {
    var n3, r3 = [], i3;
    for (t5.token !== `` && t5.token !== `
` && t5.token !== `;` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment)); t5.token === `
` || t5.token === `;`; ) r3.length === 0 && n3 && (i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 })), H2(t5), t5.token !== `
` && t5.token !== `;` && t5.token !== `` && (n3 = J(t5), t5.comment && (n3.comment = t5.comment), i3 = t5.token !== `;`, r3.push({ node: n3, visible: i3 }));
    return r3.length > 0 ? new c2(r3) : (n3 || (n3 = new u2(void 0), t5.comment && (n3.comment = t5.comment)), n3);
  }
  function J(t5) {
    var n3, r3, i3, a3, o3 = ee2(t5);
    if (t5.token === `=`) {
      if (isSymbolNode(o3)) return n3 = o3.name, U2(t5), i3 = J(t5), new s2(new x2(n3), i3);
      if (isAccessorNode(o3)) {
        if (o3.optionalChaining) throw ke2(t5, `Cannot assign to optional chain`);
        return U2(t5), i3 = J(t5), new s2(o3.object, o3.index, i3);
      } else if (isFunctionNode(o3) && isSymbolNode(o3.fn) && (a3 = true, r3 = [], n3 = o3.name, o3.args.forEach(function(t6, n4) {
        isSymbolNode(t6) ? r3[n4] = t6.name : a3 = false;
      }), a3)) return U2(t5), i3 = J(t5), new d2(n3, r3, i3);
      throw ke2(t5, `Invalid left hand side of assignment operator =`);
    }
    return o3;
  }
  function ee2(t5) {
    for (var n3 = Y2(t5); t5.token === `?`; ) {
      var r3 = t5.conditionalLevel;
      t5.conditionalLevel = t5.nestingLevel, U2(t5);
      var i3 = n3, a3 = J(t5);
      if (t5.token !== `:`) throw ke2(t5, `False part of conditional expression expected`);
      t5.conditionalLevel = null, U2(t5), n3 = new l2(i3, a3, J(t5)), t5.conditionalLevel = r3;
    }
    return n3;
  }
  function Y2(t5) {
    for (var n3 = te2(t5); t5.token === `or`; ) U2(t5), n3 = new g2(`or`, `or`, [n3, te2(t5)]);
    return n3;
  }
  function te2(t5) {
    for (var n3 = ne2(t5); t5.token === `xor`; ) U2(t5), n3 = new g2(`xor`, `xor`, [n3, ne2(t5)]);
    return n3;
  }
  function ne2(t5) {
    for (var n3 = X2(t5); t5.token === `and`; ) U2(t5), n3 = new g2(`and`, `and`, [n3, X2(t5)]);
    return n3;
  }
  function X2(t5) {
    for (var n3 = ie2(t5); t5.token === `|`; ) U2(t5), n3 = new g2(`|`, `bitOr`, [n3, ie2(t5)]);
    return n3;
  }
  function ie2(t5) {
    for (var n3 = ae2(t5); t5.token === `^|`; ) U2(t5), n3 = new g2(`^|`, `bitXor`, [n3, ae2(t5)]);
    return n3;
  }
  function ae2(t5) {
    for (var n3 = Z2(t5); t5.token === `&`; ) U2(t5), n3 = new g2(`&`, `bitAnd`, [n3, Z2(t5)]);
    return n3;
  }
  function Z2(t5) {
    for (var n3 = [oe2(t5)], r3 = [], i3 = { "==": `equal`, "!=": `unequal`, "<": `smaller`, ">": `larger`, "<=": `smallerEq`, ">=": `largerEq` }; hasOwnProperty$1$1(i3, t5.token); ) {
      var a3 = { name: t5.token, fn: i3[t5.token] };
      r3.push(a3), U2(t5), n3.push(oe2(t5));
    }
    return n3.length === 1 ? n3[0] : n3.length === 2 ? new g2(r3[0].name, r3[0].fn, n3) : new b2(r3.map((t6) => t6.fn), n3);
  }
  function oe2(t5) {
    for (var n3 = $2(t5), r3, i3, a3, o3 = { "<<": `leftShift`, ">>": `rightArithShift`, ">>>": `rightLogShift` }; hasOwnProperty$1$1(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), a3 = [n3, $2(t5)], n3 = new g2(r3, i3, a3);
    return n3;
  }
  function $2(t5) {
    for (var n3 = se2(t5), r3, i3, a3, o3 = { to: `to`, in: `to` }; hasOwnProperty$1$1(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], U2(t5), r3 === `in` && `])},;`.includes(t5.token) ? n3 = new g2(`*`, `multiply`, [n3, new x2(`in`)], true) : (a3 = [n3, se2(t5)], n3 = new g2(r3, i3, a3));
    return n3;
  }
  function se2(t5) {
    var n3, r3 = [];
    if (t5.token === `:`) {
      if (t5.conditionalLevel === t5.nestingLevel) throw ke2(t5, `The true-expression of a conditional operator may not be empty`);
      n3 = new u2(1);
    } else n3 = ce2(t5);
    if (t5.token === `:` && t5.conditionalLevel !== t5.nestingLevel) {
      for (r3.push(n3); t5.token === `:` && r3.length < 3; ) U2(t5), t5.token === `)` || t5.token === `]` || t5.token === `,` || t5.token === `` ? r3.push(new x2(`end`)) : r3.push(ce2(t5));
      n3 = r3.length === 3 ? new y2(r3[0], r3[2], r3[1]) : new y2(r3[0], r3[1]);
    }
    return n3;
  }
  function ce2(t5) {
    for (var n3 = le2(t5), r3, i3, a3, o3 = { "+": `add`, "-": `subtract` }; hasOwnProperty$1$1(o3, t5.token); ) {
      r3 = t5.token, i3 = o3[r3], U2(t5);
      var s3 = le2(t5);
      a3 = s3.isPercentage ? [n3, new g2(`*`, `multiply`, [n3, s3])] : [n3, s3], n3 = new g2(r3, i3, a3);
    }
    return n3;
  }
  function le2(t5) {
    for (var n3 = ue2(t5), r3 = n3, i3, a3, o3 = { "*": `multiply`, ".*": `dotMultiply`, "/": `divide`, "./": `dotDivide`, "%": `mod`, mod: `mod` }; hasOwnProperty$1$1(o3, t5.token); ) i3 = t5.token, a3 = o3[i3], U2(t5), r3 = ue2(t5), n3 = new g2(i3, a3, [n3, r3]);
    return n3;
  }
  function ue2(t5) {
    for (var n3 = de2(t5), r3 = n3; t5.tokenType === E.SYMBOL || t5.token === `in` && isConstantNode(n3) || t5.token === `in` && isOperatorNode(n3) && n3.fn === `unaryMinus` && isConstantNode(n3.args[0]) || t5.tokenType === E.NUMBER && !isConstantNode(r3) && (!isOperatorNode(r3) || r3.op === `!`) || t5.token === `(`; ) r3 = de2(t5), n3 = new g2(`*`, `multiply`, [n3, r3], true);
    return n3;
  }
  function de2(t5) {
    for (var n3 = fe2(t5), r3 = n3, i3 = []; t5.token === `/` && rule2Node(r3); ) if (i3.push(_extends({}, t5)), U2(t5), t5.tokenType === E.NUMBER) if (i3.push(_extends({}, t5)), U2(t5), t5.tokenType === E.SYMBOL || t5.token === `(` || t5.token === `in`) _extends(t5, i3.pop()), i3.pop(), r3 = fe2(t5), n3 = new g2(`/`, `divide`, [n3, r3]);
    else {
      i3.pop(), _extends(t5, i3.pop());
      break;
    }
    else {
      _extends(t5, i3.pop());
      break;
    }
    return n3;
  }
  function fe2(t5) {
    var n3 = pe2(t5);
    if (t5.token === `%`) {
      var r3 = _extends({}, t5);
      U2(t5);
      try {
        pe2(t5), _extends(t5, r3);
      } catch {
        n3 = new g2(`/`, `divide`, [n3, new u2(100)], false, true);
      }
    }
    return n3;
  }
  function pe2(t5) {
    var n3, r3, i3, a3 = { "-": `unaryMinus`, "+": `unaryPlus`, "~": `bitNot`, not: `not` };
    return hasOwnProperty$1$1(a3, t5.token) ? (i3 = a3[t5.token], n3 = t5.token, U2(t5), r3 = [pe2(t5)], new g2(n3, i3, r3)) : me2(t5);
  }
  function me2(t5) {
    var n3 = he2(t5), r3, i3, a3;
    return (t5.token === `^` || t5.token === `.^`) && (r3 = t5.token, i3 = r3 === `^` ? `pow` : `dotPow`, U2(t5), a3 = [n3, pe2(t5)], n3 = new g2(r3, i3, a3)), n3;
  }
  function he2(t5) {
    for (var n3 = ge2(t5); t5.token === `??`; ) U2(t5), n3 = new g2(`??`, `nullish`, [n3, ge2(t5)]);
    return n3;
  }
  function ge2(t5) {
    for (var n3 = _e2(t5), r3, i3, a3, o3 = { "!": `factorial`, "'": `ctranspose` }; hasOwnProperty$1$1(o3, t5.token); ) r3 = t5.token, i3 = o3[r3], H2(t5), a3 = [n3], n3 = new g2(r3, i3, a3), n3 = ye2(t5, n3);
    return n3;
  }
  function _e2(t5) {
    var n3 = [];
    if (t5.tokenType === E.SYMBOL && hasOwnProperty$1$1(t5.extraNodes, t5.token)) {
      var r3 = t5.extraNodes[t5.token];
      if (H2(t5), t5.token === `(`) {
        if (n3 = [], W2(t5), H2(t5), t5.token !== `)`) for (n3.push(J(t5)); t5.token === `,`; ) H2(t5), n3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5);
      }
      return new r3(n3);
    }
    return ve2(t5);
  }
  function ve2(t5) {
    var n3, i3;
    return t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2 ? (i3 = t5.token, H2(t5), n3 = hasOwnProperty$1$1(j2, i3) ? new u2(j2[i3]) : M2.includes(i3) ? new u2(r2(i3, `number`)) : new x2(i3), n3 = ye2(t5, n3), n3) : be2(t5);
  }
  function ye2(t5, n3, r3) {
    for (var i3; ; ) {
      var o3 = false;
      t5.token === `?.` && (o3 = true, H2(t5));
      var s3 = (t5.token === `(` || t5.token === `[` || t5.token === `.`) && true;
      if (!(o3 || s3)) break;
      if (i3 = [], t5.token === `(`) if (o3 || isSymbolNode(n3) || isAccessorNode(n3)) {
        if (W2(t5), H2(t5), t5.token !== `)`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
        G2(t5), H2(t5), n3 = new p2(n3, i3, o3);
      } else return n3;
      else if (t5.token === `[`) {
        if (W2(t5), H2(t5), t5.token !== `]`) for (i3.push(J(t5)); t5.token === `,`; ) H2(t5), i3.push(J(t5));
        if (t5.token !== `]`) throw ke2(t5, `Parenthesis ] expected`);
        G2(t5), H2(t5), n3 = new a2(n3, new m2(i3), o3);
      } else {
        if (o3 || H2(t5), !(t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2)) {
          var c3 = `Property name expected after `;
          throw c3 += o3 ? `optional chain` : `dot`, ke2(t5, c3);
        }
        i3.push(new u2(t5.token)), H2(t5), n3 = new a2(n3, new m2(i3, true), o3);
      }
    }
    return n3;
  }
  function be2(t5) {
    var n3, r3;
    return t5.token === `"` || t5.token === `'` ? (r3 = xe2(t5, t5.token), n3 = new u2(r3), n3 = ye2(t5, n3), n3) : Se2(t5);
  }
  function xe2(t5, n3) {
    for (var r3 = ``; L2(t5) !== `` && L2(t5) !== n3; ) if (L2(t5) === `\\`) {
      R2(t5);
      var i3 = L2(t5), a3 = N2[i3];
      if (a3 !== void 0) r3 += a3, t5.index += 1;
      else if (i3 === `u`) {
        var o3 = t5.expression.slice(t5.index + 1, t5.index + 5);
        if (/^[0-9A-Fa-f]{4}$/.test(o3)) r3 += String.fromCharCode(parseInt(o3, 16)), t5.index += 5;
        else throw ke2(t5, `Invalid unicode character \\u${o3}`);
      } else throw ke2(t5, `Bad escape character \\${i3}`);
    } else r3 += L2(t5), R2(t5);
    if (H2(t5), t5.token !== n3) throw ke2(t5, `End of string ${n3} expected`);
    return H2(t5), r3;
  }
  function Se2(t5) {
    var n3, r3, i3, a3;
    if (t5.token === `[`) {
      if (W2(t5), H2(t5), t5.token !== `]`) {
        var s3 = Ce2(t5);
        if (t5.token === `;`) {
          for (i3 = 1, r3 = [s3]; t5.token === `;`; ) H2(t5), t5.token !== `]` && (r3[i3] = Ce2(t5), i3++);
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), a3 = r3[0].items.length;
          for (var c3 = 1; c3 < i3; c3++) if (r3[c3].items.length !== a3) throw Ae2(t5, `Column dimensions mismatch (` + r3[c3].items.length + ` !== ` + a3 + `)`);
          n3 = new o2(r3);
        } else {
          if (t5.token !== `]`) throw ke2(t5, `End of matrix ] expected`);
          G2(t5), H2(t5), n3 = s3;
        }
      } else G2(t5), H2(t5), n3 = new o2([]);
      return ye2(t5, n3);
    }
    return we2(t5);
  }
  function Ce2(t5) {
    for (var n3 = [J(t5)], r3 = 1; t5.token === `,`; ) H2(t5), t5.token !== `]` && t5.token !== `;` && (n3[r3] = J(t5), r3++);
    return new o2(n3);
  }
  function we2(t5) {
    if (t5.token === `{`) {
      W2(t5);
      var n3, r3 = {};
      do
        if (H2(t5), t5.token !== `}`) {
          if (t5.token === `"` || t5.token === `'`) n3 = xe2(t5, t5.token);
          else if (t5.tokenType === E.SYMBOL || t5.tokenType === E.DELIMITER && t5.token in O2) n3 = t5.token, H2(t5);
          else throw ke2(t5, `Symbol or string expected as object key`);
          if (t5.token !== `:`) throw ke2(t5, `Colon : expected after object key`);
          H2(t5), r3[n3] = J(t5);
        }
      while (t5.token === `,`);
      if (t5.token !== `}`) throw ke2(t5, `Comma , or bracket } expected after object value`);
      G2(t5), H2(t5);
      var i3 = new h2(r3);
      return i3 = ye2(t5, i3), i3;
    }
    return Te2(t5);
  }
  function Te2(t5) {
    var n3;
    if (t5.tokenType === E.NUMBER) {
      n3 = t5.token, H2(t5);
      var a3 = safeNumberType(n3, i2);
      return new u2(r2(n3, a3));
    }
    return Ee2(t5);
  }
  function Ee2(t5) {
    var n3;
    if (t5.token === `(`) {
      if (W2(t5), H2(t5), n3 = J(t5), t5.token !== `)`) throw ke2(t5, `Parenthesis ) expected`);
      return G2(t5), H2(t5), n3 = new v2(n3), n3 = ye2(t5, n3), n3;
    }
    return De2(t5);
  }
  function De2(t5) {
    throw t5.token === `` ? ke2(t5, `Unexpected end of expression`) : ke2(t5, `Value expected`);
  }
  function Oe2(t5) {
    return t5.index - t5.token.length + 1;
  }
  function ke2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  function Ae2(t5, n3) {
    var r3 = Oe2(t5), i3 = SyntaxError(n3 + ` (char ` + r3 + `)`);
    return i3.char = r3, i3;
  }
  return n2.addConversion({ from: `string`, to: `Node`, convert: S2 }), S2;
}), name$95 = `compile`, dependencies$95 = [`typed`, `parse`], createCompile = factory(name$95, dependencies$95, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$95, { string: function(t5) {
    return r2(t5).compile();
  }, "Array | Matrix": function(t5) {
    return deepMap(t5, function(t6) {
      return r2(t6).compile();
    });
  } });
}), name$94 = `evaluate`, dependencies$94 = [`typed`, `parse`], createEvaluate = factory(name$94, dependencies$94, (t4) => {
  var { typed: n2, parse: r2 } = t4;
  return n2(name$94, { string: function(t5) {
    var n3 = createEmptyMap();
    return r2(t5).compile().evaluate(n3);
  }, "string, Map | Object": function(t5, n3) {
    return r2(t5).compile().evaluate(n3);
  }, "Array | Matrix": function(t5) {
    var n3 = createEmptyMap();
    return deepMap(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  }, "Array | Matrix, Map | Object": function(t5, n3) {
    return deepMap(t5, function(t6) {
      return r2(t6).compile().evaluate(n3);
    });
  } });
}), name$93 = `Parser`, dependencies$93 = [`evaluate`, `parse`], createParserClass = factory(name$93, dependencies$93, (t4) => {
  var { evaluate: n2, parse: r2 } = t4;
  function i2() {
    if (!(this instanceof i2)) throw SyntaxError(`Constructor must be called with the new operator`);
    Object.defineProperty(this, "scope", { value: createEmptyMap(), writable: false });
  }
  i2.prototype.type = `Parser`, i2.prototype.isParser = true, i2.prototype.evaluate = function(t5) {
    return n2(t5, this.scope);
  }, i2.prototype.get = function(t5) {
    if (this.scope.has(t5)) return this.scope.get(t5);
  }, i2.prototype.getAll = function() {
    return toObject(this.scope);
  }, i2.prototype.getAllAsMap = function() {
    return this.scope;
  };
  function a2(t5) {
    if (t5.length === 0) return false;
    for (var n3 = 0; n3 < t5.length; n3++) {
      var i3 = t5.charAt(n3 - 1), a3 = t5.charAt(n3), o2 = t5.charAt(n3 + 1);
      if (!(r2.isAlpha(a3, i3, o2) || n3 > 0 && r2.isDigit(a3))) return false;
    }
    return true;
  }
  return i2.prototype.set = function(t5, n3) {
    if (!a2(t5)) throw Error(`Invalid variable name: '${t5}'. Variable names must follow the specified rules.`);
    return this.scope.set(t5, n3), n3;
  }, i2.prototype.remove = function(t5) {
    this.scope.delete(t5);
  }, i2.prototype.clear = function() {
    this.scope.clear();
  }, i2.prototype.toJSON = function() {
    var t5 = { mathjs: `Parser`, variables: {}, functions: {} };
    for (var [n3, r3] of this.scope) if (isFunction$1(r3)) {
      if (!isExpressionFunction(r3)) throw Error(`Cannot serialize external function ${n3}`);
      t5.functions[n3] = `${r3.syntax} = ${r3.expr}`;
    } else t5.variables[n3] = r3;
    return t5;
  }, i2.fromJSON = function(t5) {
    var n3 = new i2();
    return Object.entries(t5.variables).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.set(r3, i3);
    }), Object.entries(t5.functions).forEach((t6) => {
      var [r3, i3] = t6;
      return n3.evaluate(i3);
    }), n3;
  }, i2;
}, { isClass: true });
function isExpressionFunction(t4) {
  return typeof t4 == `function` && typeof t4.syntax == `string` && typeof t4.expr == `string`;
}
var name$92 = `parser`, dependencies$92 = [`typed`, `Parser`], createParser = factory(name$92, dependencies$92, (t4) => {
  var { typed: n2, Parser: r2 } = t4;
  return n2(name$92, { "": function() {
    return new r2();
  } });
}), name$91 = `lup`, dependencies$91 = [`typed`, `matrix`, `abs`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `larger`, `equalScalar`, `unaryMinus`, `DenseMatrix`, `SparseMatrix`, `Spa`], createLup = factory(name$91, dependencies$91, (t4) => {
  var { typed: n2, matrix: r2, abs: i2, addScalar: a2, divideScalar: o2, multiplyScalar: s2, subtractScalar: c2, larger: l2, equalScalar: u2, unaryMinus: d2, DenseMatrix: p2, SparseMatrix: m2, Spa: h2 } = t4;
  return n2(name$91, { DenseMatrix: function(t5) {
    return g2(t5);
  }, SparseMatrix: function(t5) {
    return v2(t5);
  }, Array: function(t5) {
    var n3 = g2(r2(t5));
    return { L: n3.L.valueOf(), U: n3.U.valueOf(), p: n3.p };
  } });
  function g2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], d3 = Math.min(n3, r3), m3 = clone$3(t5._data), h3 = [], g3 = [n3, d3], v3 = [], y2 = [d3, r3], b2, x2, S2, w2 = [];
    for (b2 = 0; b2 < n3; b2++) w2[b2] = b2;
    for (x2 = 0; x2 < r3; x2++) {
      if (x2 > 0) for (b2 = 0; b2 < n3; b2++) {
        var E = Math.min(b2, x2), D = 0;
        for (S2 = 0; S2 < E; S2++) D = a2(D, s2(m3[b2][S2], m3[S2][x2]));
        m3[b2][x2] = c2(m3[b2][x2], D);
      }
      var O2 = x2, j2 = 0, M2 = 0;
      for (b2 = x2; b2 < n3; b2++) {
        var N2 = m3[b2][x2], F = i2(N2);
        l2(F, j2) && (O2 = b2, j2 = F, M2 = N2);
      }
      if (x2 !== O2 && (w2[x2] = [w2[O2], w2[O2] = w2[x2]][0], p2._swapRows(x2, O2, m3)), x2 < n3) for (b2 = x2 + 1; b2 < n3; b2++) {
        var I2 = m3[b2][x2];
        u2(I2, 0) || (m3[b2][x2] = o2(m3[b2][x2], M2));
      }
    }
    for (x2 = 0; x2 < r3; x2++) for (b2 = 0; b2 < n3; b2++) {
      if (x2 === 0 && (b2 < r3 && (v3[b2] = []), h3[b2] = []), b2 < x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 0);
        continue;
      }
      if (b2 === x2) {
        b2 < r3 && (v3[b2][x2] = m3[b2][x2]), x2 < n3 && (h3[b2][x2] = 1);
        continue;
      }
      b2 < r3 && (v3[b2][x2] = 0), x2 < n3 && (h3[b2][x2] = m3[b2][x2]);
    }
    var L2 = new p2({ data: h3, size: g3 }), R2 = new p2({ data: v3, size: y2 }), z2 = [];
    for (b2 = 0, d3 = w2.length; b2 < d3; b2++) z2[w2[b2]] = b2;
    return { L: L2, U: R2, p: z2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
  function v2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], a3 = Math.min(n3, r3), c3 = t5._values, p3 = t5._index, g3 = t5._ptr, v3 = [], y2 = [], b2 = [], x2 = [n3, a3], S2 = [], w2 = [], E = [], D = [a3, r3], O2, j2, M2, N2 = [], F = [];
    for (O2 = 0; O2 < n3; O2++) N2[O2] = O2, F[O2] = O2;
    var I2 = function(t6, n4) {
      var r4 = F[t6], i3 = F[n4];
      N2[r4] = n4, N2[i3] = t6, F[t6] = i3, F[n4] = r4;
    }, L2 = function() {
      var t6 = new h2();
      j2 < n3 && (b2.push(v3.length), v3.push(1), y2.push(j2)), E.push(S2.length);
      var r4 = g3[j2], a4 = g3[j2 + 1];
      for (M2 = r4; M2 < a4; M2++) O2 = p3[M2], t6.set(N2[O2], c3[M2]);
      j2 > 0 && t6.forEach(0, j2 - 1, function(n4, r5) {
        m2._forEachRow(n4, v3, y2, b2, function(i3, a5) {
          i3 > n4 && t6.accumulate(i3, d2(s2(a5, r5)));
        });
      });
      var F2 = j2, L22 = t6.get(j2), R2 = i2(L22);
      t6.forEach(j2 + 1, n3 - 1, function(t7, n4) {
        var r5 = i2(n4);
        l2(r5, R2) && (F2 = t7, R2 = r5, L22 = n4);
      }), j2 !== F2 && (m2._swapRows(j2, F2, x2[1], v3, y2, b2), m2._swapRows(j2, F2, D[1], S2, w2, E), t6.swap(j2, F2), I2(j2, F2)), t6.forEach(0, n3 - 1, function(t7, n4) {
        t7 <= j2 ? (S2.push(n4), w2.push(t7)) : (n4 = o2(n4, L22), u2(n4, 0) || (v3.push(n4), y2.push(t7)));
      });
    };
    for (j2 = 0; j2 < r3; j2++) L2();
    return E.push(S2.length), b2.push(v3.length), { L: new m2({ values: v3, index: y2, ptr: b2, size: x2 }), U: new m2({ values: S2, index: w2, ptr: E, size: D }), p: N2, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
P: ` + this.p;
    } };
  }
}), name$90 = `qr`, dependencies$90 = [`typed`, `matrix`, `zeros`, `identity`, `isZero`, `equal`, `sign`, `sqrt`, `conj`, `unaryMinus`, `addScalar`, `divideScalar`, `multiplyScalar`, `subtractScalar`, `complex`], createQr = factory(name$90, dependencies$90, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, identity: a2, isZero: o2, equal: s2, sign: c2, sqrt: l2, conj: u2, unaryMinus: d2, addScalar: p2, divideScalar: m2, multiplyScalar: h2, subtractScalar: g2, complex: v2 } = t4;
  return _extends(n2(name$90, { DenseMatrix: function(t5) {
    return b2(t5);
  }, SparseMatrix: function(t5) {
    return x2();
  }, Array: function(t5) {
    var n3 = b2(r2(t5));
    return { Q: n3.Q.valueOf(), R: n3.R.valueOf() };
  } }), { _denseQRimpl: y2 });
  function y2(t5) {
    var n3 = t5._size[0], r3 = t5._size[1], v3 = a2([n3], `dense`), y3 = v3._data, b3 = t5.clone(), x3 = b3._data, S2, w2, E, D = i2([n3], ``);
    for (E = 0; E < Math.min(r3, n3); ++E) {
      var O2 = x3[E][E], j2 = d2(s2(O2, 0) ? 1 : c2(O2)), M2 = u2(j2), N2 = 0;
      for (S2 = E; S2 < n3; S2++) N2 = p2(N2, h2(x3[S2][E], u2(x3[S2][E])));
      var F = h2(j2, l2(N2));
      if (!o2(F)) {
        var I2 = g2(O2, F);
        for (D[E] = 1, S2 = E + 1; S2 < n3; S2++) D[S2] = m2(x3[S2][E], I2);
        var L2 = d2(u2(m2(I2, F))), R2 = void 0;
        for (w2 = E; w2 < r3; w2++) {
          for (R2 = 0, S2 = E; S2 < n3; S2++) R2 = p2(R2, h2(u2(D[S2]), x3[S2][w2]));
          for (R2 = h2(R2, L2), S2 = E; S2 < n3; S2++) x3[S2][w2] = h2(g2(x3[S2][w2], h2(D[S2], R2)), M2);
        }
        for (S2 = 0; S2 < n3; S2++) {
          for (R2 = 0, w2 = E; w2 < n3; w2++) R2 = p2(R2, h2(y3[S2][w2], D[w2]));
          for (R2 = h2(R2, L2), w2 = E; w2 < n3; ++w2) y3[S2][w2] = m2(g2(y3[S2][w2], h2(R2, u2(D[w2]))), M2);
        }
      }
    }
    return { Q: v3, R: b3, toString: function() {
      return `Q: ` + this.Q.toString() + `
R: ` + this.R.toString();
    } };
  }
  function b2(t5) {
    var n3 = y2(t5), r3 = n3.R._data;
    if (t5._data.length > 0) for (var i3 = r3[0][0].type === `Complex` ? v2(0) : 0, a3 = 0; a3 < r3.length; ++a3) for (var o3 = 0; o3 < a3 && o3 < (r3[0] || []).length; ++o3) r3[a3][o3] = i3;
    return n3;
  }
  function x2(t5) {
    throw Error(`qr not implemented for sparse matrices yet`);
  }
});
function csPermute(t4, n2, r2, i2) {
  for (var a2 = t4._values, o2 = t4._index, s2 = t4._ptr, c2 = t4._size, l2 = t4._datatype, u2 = c2[0], d2 = c2[1], p2 = null, m2 = [], h2 = [], g2 = 0, v2 = 0; v2 < d2; v2++) {
    h2[v2] = g2;
    for (var y2 = r2 ? r2[v2] : v2, b2 = s2[y2], x2 = s2[y2 + 1], S2 = b2; S2 < x2; S2++) m2[g2] = o2[S2], p2 && (p2[g2] = a2[S2]), g2++;
  }
  return h2[d2] = g2, t4.createSparseMatrix({ values: p2, index: m2, ptr: h2, size: [u2, d2], datatype: l2 });
}
function csTdfs(t4, n2, r2, i2, a2, o2, s2) {
  var c2 = 0;
  for (r2[s2] = t4; c2 >= 0; ) {
    var l2 = r2[s2 + c2], u2 = r2[i2 + l2];
    u2 === -1 ? (c2--, o2[n2++] = l2) : (r2[i2 + l2] = r2[a2 + u2], ++c2, r2[s2 + c2] = u2);
  }
  return n2;
}
function csPost(t4, n2) {
  if (!t4) return null;
  var r2 = 0, i2, a2 = [], o2 = [], s2 = 0, c2 = n2, l2 = 2 * n2;
  for (i2 = 0; i2 < n2; i2++) o2[s2 + i2] = -1;
  for (i2 = n2 - 1; i2 >= 0; i2--) t4[i2] !== -1 && (o2[c2 + i2] = o2[s2 + t4[i2]], o2[s2 + t4[i2]] = i2);
  for (i2 = 0; i2 < n2; i2++) t4[i2] === -1 && (r2 = csTdfs(i2, r2, o2, s2, c2, a2, l2));
  return a2;
}
function csEtree(t4, n2) {
  if (!t4) return null;
  var r2 = t4._index, i2 = t4._ptr, a2 = t4._size, o2 = a2[0], s2 = a2[1], c2 = [], l2 = [], u2 = 0, d2 = s2, p2, m2;
  for (p2 = 0; p2 < o2; p2++) l2[d2 + p2] = -1;
  for (var h2 = 0; h2 < s2; h2++) {
    c2[h2] = -1, l2[u2 + h2] = -1;
    for (var g2 = i2[h2], v2 = i2[h2 + 1], y2 = g2; y2 < v2; y2++) {
      var b2 = r2[y2];
      for (p2 = l2[d2 + b2]; p2 !== -1 && p2 < h2; p2 = m2) m2 = l2[u2 + p2], l2[u2 + p2] = h2, m2 === -1 && (c2[p2] = h2);
      l2[d2 + b2] = h2;
    }
  }
  return c2;
}
function csFkeep(t4, n2, r2) {
  for (var i2 = t4._values, a2 = t4._index, o2 = t4._ptr, s2 = t4._size[1], c2 = 0, l2 = 0; l2 < s2; l2++) {
    var u2 = o2[l2];
    for (o2[l2] = c2; u2 < o2[l2 + 1]; u2++) n2(a2[u2], l2, i2 ? i2[u2] : 1, r2) && (a2[c2] = a2[u2], i2 && (i2[c2] = i2[u2]), c2++);
  }
  return o2[s2] = c2, a2.splice(c2, a2.length - c2), i2 && i2.splice(c2, i2.length - c2), c2;
}
function csFlip(t4) {
  return -t4 - 2;
}
var name$89 = `csAmd`, dependencies$89 = [`add`, `multiply`, `transpose`], createCsAmd = factory(name$89, dependencies$89, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4;
  return function(t5, n3) {
    if (!n3 || t5 <= 0 || t5 > 3) return null;
    var r3 = n3._size, i3 = r3[0], u2 = r3[1], d2 = 0, p2 = Math.max(16, 10 * Math.sqrt(u2));
    p2 = Math.min(u2 - 2, p2);
    var m2 = a2(t5, n3, i3, u2, p2);
    csFkeep(m2, l2, null);
    for (var h2 = m2._index, g2 = m2._ptr, v2 = g2[u2], y2 = [], b2 = [], x2 = 0, S2 = u2 + 1, w2 = 2 * (u2 + 1), E = 3 * (u2 + 1), D = 4 * (u2 + 1), O2 = 5 * (u2 + 1), j2 = 6 * (u2 + 1), M2 = 7 * (u2 + 1), N2 = y2, F = o2(u2, g2, b2, x2, E, N2, w2, M2, S2, j2, D, O2), I2 = s2(u2, g2, b2, O2, D, j2, p2, S2, E, N2, w2), L2 = 0, R2, z2, V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2; I2 < u2; ) {
      for (V2 = -1; L2 < u2 && (V2 = b2[E + L2]) === -1; L2++) ;
      b2[w2 + V2] !== -1 && (N2[b2[w2 + V2]] = -1), b2[E + L2] = b2[w2 + V2];
      var ae2 = b2[D + V2], Z2 = b2[S2 + V2];
      I2 += Z2;
      var oe2 = 0;
      b2[S2 + V2] = -Z2;
      var $2 = g2[V2], se2 = ae2 === 0 ? $2 : v2, ce2 = se2;
      for (H2 = 1; H2 <= ae2 + 1; H2++) {
        for (H2 > ae2 ? (W2 = V2, G2 = $2, K2 = b2[x2 + V2] - ae2) : (W2 = h2[$2++], G2 = g2[W2], K2 = b2[x2 + W2]), U2 = 1; U2 <= K2; U2++) R2 = h2[G2++], !((q2 = b2[S2 + R2]) <= 0) && (oe2 += q2, b2[S2 + R2] = -q2, h2[ce2++] = R2, b2[w2 + R2] !== -1 && (N2[b2[w2 + R2]] = N2[R2]), N2[R2] === -1 ? b2[E + b2[O2 + R2]] = b2[w2 + R2] : b2[w2 + N2[R2]] = b2[w2 + R2]);
        W2 !== V2 && (g2[W2] = csFlip(V2), b2[j2 + W2] = 0);
      }
      for (ae2 !== 0 && (v2 = ce2), b2[O2 + V2] = oe2, g2[V2] = se2, b2[x2 + V2] = ce2 - se2, b2[D + V2] = -2, F = c2(F, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !((ee2 = b2[D + R2]) <= 0)) {
        q2 = -b2[S2 + R2];
        var le2 = F - q2;
        for ($2 = g2[R2], Y2 = g2[R2] + ee2 - 1; $2 <= Y2; $2++) W2 = h2[$2], b2[j2 + W2] >= F ? b2[j2 + W2] -= q2 : b2[j2 + W2] !== 0 && (b2[j2 + W2] = b2[O2 + W2] + le2);
      }
      for (J = se2; J < ce2; J++) {
        for (R2 = h2[J], Y2 = g2[R2], te2 = Y2 + b2[D + R2] - 1, ne2 = Y2, X2 = 0, ie2 = 0, $2 = Y2; $2 <= te2; $2++) if (W2 = h2[$2], b2[j2 + W2] !== 0) {
          var ue2 = b2[j2 + W2] - F;
          ue2 > 0 ? (ie2 += ue2, h2[ne2++] = W2, X2 += W2) : (g2[W2] = csFlip(V2), b2[j2 + W2] = 0);
        }
        b2[D + R2] = ne2 - Y2 + 1;
        var de2 = ne2, fe2 = Y2 + b2[x2 + R2];
        for ($2 = te2 + 1; $2 < fe2; $2++) {
          z2 = h2[$2];
          var pe2 = b2[S2 + z2];
          pe2 <= 0 || (ie2 += pe2, h2[ne2++] = z2, X2 += z2);
        }
        ie2 === 0 ? (g2[R2] = csFlip(V2), q2 = -b2[S2 + R2], oe2 -= q2, Z2 += q2, I2 += q2, b2[S2 + R2] = 0, b2[D + R2] = -1) : (b2[O2 + R2] = Math.min(b2[O2 + R2], ie2), h2[ne2] = h2[de2], h2[de2] = h2[Y2], h2[Y2] = V2, b2[x2 + R2] = ne2 - Y2 + 1, X2 = (X2 < 0 ? -X2 : X2) % u2, b2[w2 + R2] = b2[M2 + X2], b2[M2 + X2] = R2, N2[R2] = X2);
      }
      for (b2[O2 + V2] = oe2, d2 = Math.max(d2, oe2), F = c2(F + d2, d2, b2, j2, u2), J = se2; J < ce2; J++) if (R2 = h2[J], !(b2[S2 + R2] >= 0)) for (X2 = N2[R2], R2 = b2[M2 + X2], b2[M2 + X2] = -1; R2 !== -1 && b2[w2 + R2] !== -1; R2 = b2[w2 + R2], F++) {
        for (K2 = b2[x2 + R2], ee2 = b2[D + R2], $2 = g2[R2] + 1; $2 <= g2[R2] + K2 - 1; $2++) b2[j2 + h2[$2]] = F;
        var me2 = R2;
        for (z2 = b2[w2 + R2]; z2 !== -1; ) {
          var he2 = b2[x2 + z2] === K2 && b2[D + z2] === ee2;
          for ($2 = g2[z2] + 1; he2 && $2 <= g2[z2] + K2 - 1; $2++) b2[j2 + h2[$2]] !== F && (he2 = 0);
          he2 ? (g2[z2] = csFlip(R2), b2[S2 + R2] += b2[S2 + z2], b2[S2 + z2] = 0, b2[D + z2] = -1, z2 = b2[w2 + z2], b2[w2 + me2] = z2) : (me2 = z2, z2 = b2[w2 + z2]);
        }
      }
      for ($2 = se2, J = se2; J < ce2; J++) R2 = h2[J], !((q2 = -b2[S2 + R2]) <= 0) && (b2[S2 + R2] = q2, ie2 = b2[O2 + R2] + oe2 - q2, ie2 = Math.min(ie2, u2 - I2 - q2), b2[E + ie2] !== -1 && (N2[b2[E + ie2]] = R2), b2[w2 + R2] = b2[E + ie2], N2[R2] = -1, b2[E + ie2] = R2, L2 = Math.min(L2, ie2), b2[O2 + R2] = ie2, h2[$2++] = R2);
      b2[S2 + V2] = Z2, (b2[x2 + V2] = $2 - se2) === 0 && (g2[V2] = -1, b2[j2 + V2] = 0), ae2 !== 0 && (v2 = $2);
    }
    for (R2 = 0; R2 < u2; R2++) g2[R2] = csFlip(g2[R2]);
    for (z2 = 0; z2 <= u2; z2++) b2[E + z2] = -1;
    for (z2 = u2; z2 >= 0; z2--) b2[S2 + z2] > 0 || (b2[w2 + z2] = b2[E + g2[z2]], b2[E + g2[z2]] = z2);
    for (W2 = u2; W2 >= 0; W2--) b2[S2 + W2] <= 0 || g2[W2] !== -1 && (b2[w2 + W2] = b2[E + g2[W2]], b2[E + g2[W2]] = W2);
    for (V2 = 0, R2 = 0; R2 <= u2; R2++) g2[R2] === -1 && (V2 = csTdfs(R2, V2, b2, E, w2, y2, j2));
    return y2.splice(y2.length - 1, 1), y2;
  };
  function a2(t5, a3, o3, s3, c3) {
    var l3 = i2(a3);
    if (t5 === 1 && s3 === o3) return n2(a3, l3);
    if (t5 === 2) {
      for (var u2 = l3._index, d2 = l3._ptr, p2 = 0, m2 = 0; m2 < o3; m2++) {
        var h2 = d2[m2];
        if (d2[m2] = p2, !(d2[m2 + 1] - h2 > c3)) for (var g2 = d2[m2 + 1]; h2 < g2; h2++) u2[p2++] = u2[h2];
      }
      return d2[o3] = p2, a3 = i2(l3), r2(l3, a3);
    }
    return r2(l3, a3);
  }
  function o2(t5, n3, r3, i3, a3, o3, s3, l3, u2, d2, p2, m2) {
    for (var h2 = 0; h2 < t5; h2++) r3[i3 + h2] = n3[h2 + 1] - n3[h2];
    r3[i3 + t5] = 0;
    for (var g2 = 0; g2 <= t5; g2++) r3[a3 + g2] = -1, o3[g2] = -1, r3[s3 + g2] = -1, r3[l3 + g2] = -1, r3[u2 + g2] = 1, r3[d2 + g2] = 1, r3[p2 + g2] = 0, r3[m2 + g2] = r3[i3 + g2];
    var v2 = c2(0, 0, r3, d2, t5);
    return r3[p2 + t5] = -2, n3[t5] = -1, r3[d2 + t5] = 0, v2;
  }
  function s2(t5, n3, r3, i3, a3, o3, s3, c3, l3, u2, d2) {
    for (var p2 = 0, m2 = 0; m2 < t5; m2++) {
      var h2 = r3[i3 + m2];
      if (h2 === 0) r3[a3 + m2] = -2, p2++, n3[m2] = -1, r3[o3 + m2] = 0;
      else if (h2 > s3) r3[c3 + m2] = 0, r3[a3 + m2] = -1, p2++, n3[m2] = csFlip(t5), r3[c3 + t5]++;
      else {
        var g2 = r3[l3 + h2];
        g2 !== -1 && (u2[g2] = m2), r3[d2 + m2] = r3[l3 + h2], r3[l3 + h2] = m2;
      }
    }
    return p2;
  }
  function c2(t5, n3, r3, i3, a3) {
    if (t5 < 2 || t5 + n3 < 0) {
      for (var o3 = 0; o3 < a3; o3++) r3[i3 + o3] !== 0 && (r3[i3 + o3] = 1);
      t5 = 2;
    }
    return t5;
  }
  function l2(t5, n3) {
    return t5 !== n3;
  }
});
function csLeaf(t4, n2, r2, i2, a2, o2, s2) {
  var c2, l2, u2 = 0, d2;
  if (t4 <= n2 || r2[i2 + n2] <= r2[a2 + t4]) return -1;
  r2[a2 + t4] = r2[i2 + n2];
  var p2 = r2[o2 + t4];
  if (r2[o2 + t4] = n2, p2 === -1) u2 = 1, d2 = t4;
  else {
    for (u2 = 2, d2 = p2; d2 !== r2[s2 + d2]; d2 = r2[s2 + d2]) ;
    for (c2 = p2; c2 !== d2; c2 = l2) l2 = r2[s2 + c2], r2[s2 + c2] = d2;
  }
  return { jleaf: u2, q: d2 };
}
var name$88 = `csCounts`, dependencies$88 = [`transpose`], createCsCounts = factory(name$88, dependencies$88, (t4) => {
  var { transpose: n2 } = t4;
  return function(t5, r2, i2, a2) {
    if (!t5 || !r2 || !i2) return null;
    var o2 = t5._size, s2 = o2[0], c2 = o2[1], l2, u2, d2, p2, m2, h2, g2, v2 = 4 * c2 + (a2 ? c2 + s2 + 1 : 0), y2 = [], b2 = 0, x2 = c2, S2 = 2 * c2, w2 = 3 * c2, E = 4 * c2, D = 5 * c2 + 1;
    for (d2 = 0; d2 < v2; d2++) y2[d2] = -1;
    var O2 = [], j2 = n2(t5), M2 = j2._index, N2 = j2._ptr;
    for (d2 = 0; d2 < c2; d2++) for (u2 = i2[d2], O2[u2] = +(y2[w2 + u2] === -1); u2 !== -1 && y2[w2 + u2] === -1; u2 = r2[u2]) y2[w2 + u2] = d2;
    if (a2) {
      for (d2 = 0; d2 < c2; d2++) y2[i2[d2]] = d2;
      for (l2 = 0; l2 < s2; l2++) {
        for (d2 = c2, h2 = N2[l2], g2 = N2[l2 + 1], m2 = h2; m2 < g2; m2++) d2 = Math.min(d2, y2[M2[m2]]);
        y2[D + l2] = y2[E + d2], y2[E + d2] = l2;
      }
    }
    for (l2 = 0; l2 < c2; l2++) y2[b2 + l2] = l2;
    for (d2 = 0; d2 < c2; d2++) {
      for (u2 = i2[d2], r2[u2] !== -1 && O2[r2[u2]]--, p2 = a2 ? y2[E + d2] : u2; p2 !== -1; p2 = a2 ? y2[D + p2] : -1) for (m2 = N2[p2]; m2 < N2[p2 + 1]; m2++) {
        l2 = M2[m2];
        var F = csLeaf(l2, u2, y2, w2, x2, S2, b2);
        F.jleaf >= 1 && O2[u2]++, F.jleaf === 2 && O2[F.q]--;
      }
      r2[u2] !== -1 && (y2[b2 + u2] = r2[u2]);
    }
    for (u2 = 0; u2 < c2; u2++) r2[u2] !== -1 && (O2[r2[u2]] += O2[u2]);
    return O2;
  };
}), name$87 = `csSqr`, dependencies$87 = [`add`, `multiply`, `transpose`], createCsSqr = factory(name$87, dependencies$87, (t4) => {
  var { add: n2, multiply: r2, transpose: i2 } = t4, a2 = createCsAmd({ add: n2, multiply: r2, transpose: i2 }), o2 = createCsCounts({ transpose: i2 });
  return function(t5, n3, r3) {
    var i3 = n3._ptr, c2 = n3._size[1], l2, u2 = {};
    if (u2.q = a2(t5, n3), t5 && !u2.q) return null;
    if (r3) {
      var d2 = t5 ? csPermute(n3, null, u2.q) : n3;
      u2.parent = csEtree(d2);
      var p2 = csPost(u2.parent, c2);
      if (u2.cp = o2(d2, u2.parent, p2, 1), d2 && u2.parent && u2.cp && s2(d2, u2)) for (u2.unz = 0, l2 = 0; l2 < c2; l2++) u2.unz += u2.cp[l2];
    } else u2.unz = 4 * i3[c2] + c2, u2.lnz = u2.unz;
    return u2;
  };
  function s2(t5, n3) {
    var r3 = t5._ptr, i3 = t5._index, a3 = t5._size, o3 = a3[0], s3 = a3[1];
    n3.pinv = [], n3.leftmost = [];
    var c2 = n3.parent, l2 = n3.pinv, u2 = n3.leftmost, d2 = [], p2 = 0, m2 = o3, h2 = o3 + s3, g2 = o3 + 2 * s3, v2, y2, b2, x2, S2;
    for (y2 = 0; y2 < s3; y2++) d2[m2 + y2] = -1, d2[h2 + y2] = -1, d2[g2 + y2] = 0;
    for (v2 = 0; v2 < o3; v2++) u2[v2] = -1;
    for (y2 = s3 - 1; y2 >= 0; y2--) for (x2 = r3[y2], S2 = r3[y2 + 1], b2 = x2; b2 < S2; b2++) u2[i3[b2]] = y2;
    for (v2 = o3 - 1; v2 >= 0; v2--) l2[v2] = -1, y2 = u2[v2], y2 !== -1 && (d2[g2 + y2]++ === 0 && (d2[h2 + y2] = v2), d2[p2 + v2] = d2[m2 + y2], d2[m2 + y2] = v2);
    for (n3.lnz = 0, n3.m2 = o3, y2 = 0; y2 < s3; y2++) if (v2 = d2[m2 + y2], n3.lnz++, v2 < 0 && (v2 = n3.m2++), l2[v2] = y2, !(--g2[y2] <= 0)) {
      n3.lnz += d2[g2 + y2];
      var w2 = c2[y2];
      w2 !== -1 && (d2[g2 + w2] === 0 && (d2[h2 + w2] = d2[h2 + y2]), d2[p2 + d2[h2 + y2]] = d2[m2 + w2], d2[m2 + w2] = d2[p2 + v2], d2[g2 + w2] += d2[g2 + y2]);
    }
    for (v2 = 0; v2 < o3; v2++) l2[v2] < 0 && (l2[v2] = y2++);
    return true;
  }
});
function csMarked(t4, n2) {
  return t4[n2] < 0;
}
function csMark(t4, n2) {
  t4[n2] = csFlip(t4[n2]);
}
function csUnflip(t4) {
  return t4 < 0 ? csFlip(t4) : t4;
}
function csDfs(t4, n2, r2, i2, a2) {
  var o2 = n2._index, s2 = n2._ptr, c2 = n2._size[1], l2, u2, d2, p2 = 0;
  for (i2[0] = t4; p2 >= 0; ) {
    t4 = i2[p2];
    var m2 = a2 ? a2[t4] : t4;
    csMarked(s2, t4) || (csMark(s2, t4), i2[c2 + p2] = m2 < 0 ? 0 : csUnflip(s2[m2]));
    var h2 = 1;
    for (u2 = i2[c2 + p2], d2 = m2 < 0 ? 0 : csUnflip(s2[m2 + 1]); u2 < d2; u2++) if (l2 = o2[u2], !csMarked(s2, l2)) {
      i2[c2 + p2] = u2, i2[++p2] = l2, h2 = 0;
      break;
    }
    h2 && (p2--, i2[--r2] = t4);
  }
  return r2;
}
function csReach(t4, n2, r2, i2, a2) {
  var o2 = t4._ptr, s2 = t4._size, c2 = n2._index, l2 = n2._ptr, u2 = s2[1], d2, p2, m2, h2 = u2;
  for (p2 = l2[r2], m2 = l2[r2 + 1], d2 = p2; d2 < m2; d2++) {
    var g2 = c2[d2];
    csMarked(o2, g2) || (h2 = csDfs(g2, t4, h2, i2, a2));
  }
  for (d2 = h2; d2 < u2; d2++) csMark(o2, i2[d2]);
  return h2;
}
var name$86 = `csSpsolve`, dependencies$86 = [`divideScalar`, `multiply`, `subtract`], createCsSpsolve = factory(name$86, dependencies$86, (t4) => {
  var { divideScalar: n2, multiply: r2, subtract: i2 } = t4;
  return function(t5, a2, o2, s2, c2, l2, u2) {
    var d2 = t5._values, p2 = t5._index, m2 = t5._ptr, h2 = t5._size[1], g2 = a2._values, v2 = a2._index, y2 = a2._ptr, b2, x2, S2, w2, E = csReach(t5, a2, o2, s2, l2);
    for (b2 = E; b2 < h2; b2++) c2[s2[b2]] = 0;
    for (x2 = y2[o2], S2 = y2[o2 + 1], b2 = x2; b2 < S2; b2++) c2[v2[b2]] = g2[b2];
    for (var D = E; D < h2; D++) {
      var O2 = s2[D], j2 = l2 ? l2[O2] : O2;
      if (!(j2 < 0)) for (x2 = m2[j2], S2 = m2[j2 + 1], c2[O2] = n2(c2[O2], d2[u2 ? x2 : S2 - 1]), b2 = u2 ? x2 + 1 : x2, w2 = u2 ? S2 : S2 - 1; b2 < w2; b2++) {
        var M2 = p2[b2];
        c2[M2] = i2(c2[M2], r2(d2[b2], c2[O2]));
      }
    }
    return E;
  };
}), name$85 = `csLu`, dependencies$85 = [`abs`, `divideScalar`, `multiply`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createCsLu = factory(name$85, dependencies$85, (t4) => {
  var { abs: n2, divideScalar: r2, multiply: i2, subtract: a2, larger: o2, largerEq: s2, SparseMatrix: c2 } = t4, l2 = createCsSpsolve({ divideScalar: r2, multiply: i2, subtract: a2 });
  return function(t5, a3, u2) {
    if (!t5) return null;
    var d2 = t5._size[1], p2, m2 = 100, h2 = 100;
    a3 && (p2 = a3.q, m2 = a3.lnz || m2, h2 = a3.unz || h2);
    var g2 = [], v2 = [], y2 = [], b2 = new c2({ values: g2, index: v2, ptr: y2, size: [d2, d2] }), x2 = [], S2 = [], w2 = [], E = new c2({ values: x2, index: S2, ptr: w2, size: [d2, d2] }), D = [], O2, j2, M2 = [], N2 = [];
    for (O2 = 0; O2 < d2; O2++) M2[O2] = 0, D[O2] = -1, y2[O2 + 1] = 0;
    m2 = 0, h2 = 0;
    for (var F = 0; F < d2; F++) {
      y2[F] = m2, w2[F] = h2;
      var I2 = p2 ? p2[F] : F, L2 = l2(b2, t5, I2, N2, M2, D, 1), R2 = -1, z2 = -1;
      for (j2 = L2; j2 < d2; j2++) if (O2 = N2[j2], D[O2] < 0) {
        var V2 = n2(M2[O2]);
        o2(V2, z2) && (z2 = V2, R2 = O2);
      } else S2[h2] = D[O2], x2[h2++] = M2[O2];
      if (R2 === -1 || z2 <= 0) return null;
      D[I2] < 0 && s2(n2(M2[I2]), i2(z2, u2)) && (R2 = I2);
      var H2 = M2[R2];
      for (S2[h2] = F, x2[h2++] = H2, D[R2] = F, v2[m2] = R2, g2[m2++] = 1, j2 = L2; j2 < d2; j2++) O2 = N2[j2], D[O2] < 0 && (v2[m2] = O2, g2[m2++] = r2(M2[O2], H2)), M2[O2] = 0;
    }
    for (y2[d2] = m2, w2[d2] = h2, j2 = 0; j2 < m2; j2++) v2[j2] = D[v2[j2]];
    return g2.splice(m2, g2.length - m2), v2.splice(m2, v2.length - m2), x2.splice(h2, x2.length - h2), S2.splice(h2, S2.length - h2), { L: b2, U: E, pinv: D };
  };
}), name$84 = `slu`, dependencies$84 = [`typed`, `abs`, `add`, `multiply`, `transpose`, `divideScalar`, `subtract`, `larger`, `largerEq`, `SparseMatrix`], createSlu = factory(name$84, dependencies$84, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, transpose: o2, divideScalar: s2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 } = t4, p2 = createCsSqr({ add: i2, multiply: a2, transpose: o2 }), m2 = createCsLu({ abs: r2, divideScalar: s2, multiply: a2, subtract: c2, larger: l2, largerEq: u2, SparseMatrix: d2 });
  return n2(name$84, { "SparseMatrix, number, number": function(t5, n3, r3) {
    if (!isInteger(n3) || n3 < 0 || n3 > 3) throw Error(`Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]`);
    if (r3 < 0 || r3 > 1) throw Error(`Partial pivoting threshold must be a number from 0 to 1`);
    var i3 = p2(n3, t5, false), a3 = m2(t5, i3, r3);
    return { L: a3.L, U: a3.U, p: a3.pinv, q: i3.q, toString: function() {
      return `L: ` + this.L.toString() + `
U: ` + this.U.toString() + `
p: ` + this.p.toString() + (this.q ? `
q: ` + this.q.toString() : ``) + `
`;
    } };
  } });
});
function csIpvec(t4, n2) {
  var r2, i2 = n2.length, a2 = [];
  if (t4) for (r2 = 0; r2 < i2; r2++) a2[t4[r2]] = n2[r2];
  else for (r2 = 0; r2 < i2; r2++) a2[r2] = n2[r2];
  return a2;
}
var name$83 = `lusolve`, dependencies$83 = [`typed`, `matrix`, `lup`, `slu`, `usolve`, `lsolve`, `DenseMatrix`], createLusolve = factory(name$83, dependencies$83, (t4) => {
  var { typed: n2, matrix: r2, lup: i2, slu: a2, usolve: o2, lsolve: s2, DenseMatrix: c2 } = t4, l2 = createSolveValidation({ DenseMatrix: c2 });
  return n2(name$83, { "Array, Array | Matrix": function(t5, n3) {
    t5 = r2(t5);
    var a3 = i2(t5);
    return d2(a3.L, a3.U, a3.p, null, n3).valueOf();
  }, "DenseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix": function(t5, n3) {
    var r3 = i2(t5);
    return d2(r3.L, r3.U, r3.p, null, n3);
  }, "SparseMatrix, Array | Matrix, number, number": function(t5, n3, r3, i3) {
    var o3 = a2(t5, r3, i3);
    return d2(o3.L, o3.U, o3.p, o3.q, n3);
  }, "Object, Array | Matrix": function(t5, n3) {
    return d2(t5.L, t5.U, t5.p, t5.q, n3);
  } });
  function u2(t5) {
    if (isMatrix(t5)) return t5;
    if (isArray(t5)) return r2(t5);
    throw TypeError(`Invalid Matrix LU decomposition`);
  }
  function d2(t5, n3, r3, i3, a3) {
    t5 = u2(t5), n3 = u2(n3), r3 && (a3 = l2(t5, a3, true), a3._data = csIpvec(r3, a3._data));
    var c3 = s2(t5, a3), d3 = o2(n3, c3);
    return i3 && (d3._data = csIpvec(i3, d3._data)), d3;
  }
}), name$82 = `polynomialRoot`, dependencies$82 = [`typed`, `isZero`, `equalScalar`, `add`, `subtract`, `multiply`, `divide`, `sqrt`, `unaryMinus`, `cbrt`, `typeOf`, `im`, `re`], createPolynomialRoot = factory(name$82, dependencies$82, (t4) => {
  var { typed: n2, isZero: r2, equalScalar: i2, add: a2, subtract: o2, multiply: s2, divide: c2, sqrt: l2, unaryMinus: u2, cbrt: d2, typeOf: p2, im: m2, re: h2 } = t4;
  return n2(name$82, { "number|Complex, ...number|Complex": (t5, n3) => {
    for (var g2 = [t5, ...n3]; g2.length > 0 && r2(g2[g2.length - 1]); ) g2.pop();
    if (g2.length < 2) throw RangeError(`Polynomial [${t5}, ${n3}] must have a non-zero non-constant coefficient`);
    switch (g2.length) {
      case 2:
        return [u2(c2(g2[0], g2[1]))];
      case 3:
        var [v2, y2, b2] = g2, x2 = s2(2, b2), S2 = s2(y2, y2), w2 = s2(4, b2, v2);
        if (i2(S2, w2)) return [c2(u2(y2), x2)];
        var E = l2(o2(S2, w2));
        return [c2(o2(E, y2), x2), c2(o2(u2(E), y2), x2)];
      case 4:
        var [D, O2, j2, M2] = g2, N2 = u2(s2(3, M2)), F = s2(j2, j2), I2 = s2(3, M2, O2), L2 = a2(s2(2, j2, j2, j2), s2(27, M2, M2, D)), R2 = s2(9, M2, j2, O2);
        if (i2(F, I2) && i2(L2, R2)) return [c2(j2, N2)];
        var z2 = o2(F, I2), V2 = o2(L2, R2);
        return i2(a2(s2(18, M2, j2, O2, D), s2(j2, j2, O2, O2)), a2(s2(4, j2, j2, j2, D), s2(4, M2, O2, O2, O2), s2(27, M2, M2, D, D))) ? [c2(o2(s2(4, M2, j2, O2), a2(s2(9, M2, M2, D), s2(j2, j2, j2))), s2(M2, z2)), c2(o2(s2(9, M2, D), s2(j2, O2)), s2(2, z2))] : d2(i2(F, I2) ? V2 : c2(a2(V2, l2(o2(s2(V2, V2), s2(4, z2, z2, z2)))), 2), true).toArray().map((t6) => c2(a2(j2, t6, c2(z2, t6)), N2)).map((t6) => p2(t6) === `Complex` && i2(h2(t6), h2(t6) + m2(t6)) ? h2(t6) : t6);
      default:
        throw RangeError(`only implemented for cubic or lower-order polynomials, not ${g2}`);
    }
  } });
}), name$81 = `Help`, dependencies$81 = [`evaluate`], createHelpClass = factory(name$81, dependencies$81, (t4) => {
  var { evaluate: n2 } = t4;
  function r2(t5) {
    if (!(this instanceof r2)) throw SyntaxError(`Constructor must be called with the new operator`);
    if (!t5) throw Error(`Argument "doc" missing`);
    this.doc = t5;
  }
  return r2.prototype.type = `Help`, r2.prototype.isHelp = true, r2.prototype.toString = function() {
    var t5 = this.doc || {}, r3 = `
`;
    if (t5.name && (r3 += `Name: ` + t5.name + `

`), t5.category && (r3 += `Category: ` + t5.category + `

`), t5.description && (r3 += `Description:
    ` + t5.description + `

`), t5.syntax && (r3 += `Syntax:
    ` + t5.syntax.join(`
    `) + `

`), t5.examples) {
      r3 += `Examples:
`;
      for (var i2 = false, a2 = n2(`config()`), o2 = { config: (t6) => (i2 = true, n2(`config(newConfig)`, { newConfig: t6 })) }, s2 = 0; s2 < t5.examples.length; s2++) {
        var c2 = t5.examples[s2];
        r3 += `    ` + c2 + `
`;
        var l2 = void 0;
        try {
          l2 = n2(c2, o2);
        } catch (t6) {
          l2 = t6;
        }
        l2 !== void 0 && !isHelp(l2) && (r3 += `        ` + format(l2, { precision: 14 }) + `
`);
      }
      r3 += `
`, i2 && n2(`config(originalConfig)`, { originalConfig: a2 });
    }
    return t5.mayThrow && t5.mayThrow.length && (r3 += `Throws: ` + t5.mayThrow.join(`, `) + `

`), t5.seealso && t5.seealso.length && (r3 += `See also: ` + t5.seealso.join(`, `) + `
`), r3;
  }, r2.prototype.toJSON = function() {
    var t5 = clone$3(this.doc);
    return t5.mathjs = `Help`, t5;
  }, r2.fromJSON = function(t5) {
    var n3 = {};
    return Object.keys(t5).filter((t6) => t6 !== `mathjs`).forEach((r3) => {
      n3[r3] = t5[r3];
    }), new r2(n3);
  }, r2.prototype.valueOf = r2.prototype.toString, r2;
}, { isClass: true }), name$80 = `Chain`, dependencies$80 = [`?on`, `math`, `typed`], createChainClass = factory(name$80, dependencies$80, (t4) => {
  var { on: n2, math: r2, typed: i2 } = t4;
  function a2(t5) {
    if (!(this instanceof a2)) throw SyntaxError(`Constructor must be called with the new operator`);
    isChain(t5) ? this.value = t5.value : this.value = t5;
  }
  a2.prototype.type = `Chain`, a2.prototype.isChain = true, a2.prototype.done = function() {
    return this.value;
  }, a2.prototype.valueOf = function() {
    return this.value;
  }, a2.prototype.toString = function() {
    return format(this.value);
  }, a2.prototype.toJSON = function() {
    return { mathjs: `Chain`, value: this.value };
  }, a2.fromJSON = function(t5) {
    return new a2(t5.value);
  };
  function o2(t5, n3) {
    typeof n3 == `function` && (a2.prototype[t5] = c2(n3));
  }
  function s2(t5, n3) {
    lazy(a2.prototype, t5, function() {
      var t6 = n3();
      if (typeof t6 == `function`) return c2(t6);
    });
  }
  function c2(t5) {
    return function() {
      if (arguments.length === 0) return new a2(t5(this.value));
      for (var n3 = [this.value], r3 = 0; r3 < arguments.length; r3++) n3[r3 + 1] = arguments[r3];
      if (i2.isTypedFunction(t5)) {
        var o3 = i2.resolve(t5, n3);
        if (o3.params.length === 1) throw Error(`chain function ` + t5.name + ` cannot match rest parameter between chain value and additional arguments.`);
        return new a2(o3.implementation.apply(t5, n3));
      }
      return new a2(t5.apply(t5, n3));
    };
  }
  a2.createProxy = function(t5, n3) {
    if (typeof t5 == `string`) o2(t5, n3);
    else {
      var r3 = function(n4) {
        hasOwnProperty$1$1(t5, n4) && l2[n4] === void 0 && s2(n4, () => t5[n4]);
      };
      for (var i3 in t5) r3(i3);
    }
  };
  var l2 = { expression: true, docs: true, type: true, classes: true, json: true, error: true, isChain: true };
  return a2.createProxy(r2), n2 && n2(`import`, function(t5, n3, r3) {
    r3 || s2(t5, n3);
  }), a2;
}, { isClass: true }), eDocs = { name: `e`, category: `Constants`, syntax: [`e`], description: `Euler's number, the base of the natural logarithm. Approximately equal to 2.71828`, examples: [`e`, `e ^ 2`, `exp(2)`, `log(e)`], seealso: [`exp`] }, falseDocs = { name: `false`, category: `Constants`, syntax: [`false`], description: `Boolean value false`, examples: [`false`], seealso: [`true`] }, iDocs = { name: `i`, category: `Constants`, syntax: [`i`], description: `Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.`, examples: [`i`, `i * i`, `sqrt(-1)`], seealso: [] }, InfinityDocs = { name: `Infinity`, category: `Constants`, syntax: [`Infinity`], description: `Infinity, a number which is larger than the maximum number that can be handled by a floating point number.`, examples: [`Infinity`, `1 / 0`], seealso: [] }, LN10Docs = { name: `LN10`, category: `Constants`, syntax: [`LN10`], description: `Returns the natural logarithm of 10, approximately equal to 2.302`, examples: [`LN10`, `log(10)`], seealso: [] }, LN2Docs = { name: `LN2`, category: `Constants`, syntax: [`LN2`], description: `Returns the natural logarithm of 2, approximately equal to 0.693`, examples: [`LN2`, `log(2)`], seealso: [] }, LOG10EDocs = { name: `LOG10E`, category: `Constants`, syntax: [`LOG10E`], description: `Returns the base-10 logarithm of E, approximately equal to 0.434`, examples: [`LOG10E`, `log(e, 10)`], seealso: [] }, LOG2EDocs = { name: `LOG2E`, category: `Constants`, syntax: [`LOG2E`], description: `Returns the base-2 logarithm of E, approximately equal to 1.442`, examples: [`LOG2E`, `log(e, 2)`], seealso: [] }, NaNDocs = { name: `NaN`, category: `Constants`, syntax: [`NaN`], description: `Not a number`, examples: [`NaN`, `0 / 0`], seealso: [] }, nullDocs = { name: `null`, category: `Constants`, syntax: [`null`], description: `Value null`, examples: [`null`], seealso: [`true`, `false`] }, phiDocs = { name: `phi`, category: `Constants`, syntax: [`phi`], description: "Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...", examples: [`phi`], seealso: [] }, piDocs = { name: `pi`, category: `Constants`, syntax: [`pi`], description: `The number pi is a mathematical constant that is the ratio of a circle's circumference to its diameter, and is approximately equal to 3.14159`, examples: [`pi`, `sin(pi/2)`], seealso: [`tau`] }, SQRT12Docs = { name: `SQRT1_2`, category: `Constants`, syntax: [`SQRT1_2`], description: `Returns the square root of 1/2, approximately equal to 0.707`, examples: [`SQRT1_2`, `sqrt(1/2)`], seealso: [] }, SQRT2Docs = { name: `SQRT2`, category: `Constants`, syntax: [`SQRT2`], description: `Returns the square root of 2, approximately equal to 1.414`, examples: [`SQRT2`, `sqrt(2)`], seealso: [] }, tauDocs = { name: `tau`, category: `Constants`, syntax: [`tau`], description: `Tau is the ratio constant of a circle's circumference to radius, equal to 2 * pi, approximately 6.2832.`, examples: [`tau`, `2 * pi`], seealso: [`pi`] }, trueDocs = { name: `true`, category: `Constants`, syntax: [`true`], description: `Boolean value true`, examples: [`true`], seealso: [`false`] }, versionDocs = { name: `version`, category: `Constants`, syntax: [`version`], description: `A string with the version number of math.js`, examples: [`version`], seealso: [] }, bignumberDocs = { name: `bignumber`, category: `Construction`, syntax: [`bignumber(x)`], description: `Create a big number from a number or string.`, examples: [`0.1 + 0.2`, `bignumber(0.1) + bignumber(0.2)`, `bignumber("7.2")`, `bignumber("7.2e500")`, `bignumber([0.1, 0.2, 0.3])`], seealso: [`boolean`, `bigint`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, bigintDocs = { name: `bigint`, category: `Construction`, syntax: [`bigint(x)`], description: `Create a bigint, an integer with an arbitrary number of digits, from a number or string.`, examples: [`123123123123123123 # a large number will lose digits`, `bigint("123123123123123123")`, `bignumber(["1", "3", "5"])`], seealso: [`boolean`, `bignumber`, `number`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, booleanDocs = { name: `boolean`, category: `Construction`, syntax: [`x`, `boolean(x)`], description: `Convert a string or number into a boolean.`, examples: [`boolean(0)`, `boolean(1)`, `boolean(3)`, `boolean("true")`, `boolean("false")`, `boolean([1, 0, 1, 1])`], seealso: [`bignumber`, `complex`, `index`, `matrix`, `number`, `string`, `unit`] }, complexDocs = { name: `complex`, category: `Construction`, syntax: [`complex()`, `complex(re, im)`, `complex(string)`], description: `Create a complex number.`, examples: [`complex()`, `complex(2, 3)`, `complex("7 - 2i")`], seealso: [`bignumber`, `boolean`, `index`, `matrix`, `number`, `string`, `unit`] }, createUnitDocs = { name: `createUnit`, category: `Construction`, syntax: [`createUnit(definitions)`, `createUnit(name, definition)`], description: `Create a user-defined unit and register it with the Unit type.`, examples: [`createUnit("foo")`, `createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})`, `createUnit("mph", "1 mile/hour")`], seealso: [`unit`, `splitUnit`] }, fractionDocs = { name: `fraction`, category: `Construction`, syntax: [`fraction(num)`, `fraction(matrix)`, `fraction(num,den)`, `fraction({n: num, d: den})`], description: `Create a fraction from a number or from integer numerator and denominator.`, examples: [`fraction(0.125)`, `fraction(1, 3) + fraction(2, 5)`, `fraction({n: 333, d: 53})`, `fraction([sqrt(9), sqrt(10), sqrt(11)])`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `string`, `unit`] }, indexDocs = { name: `index`, category: `Construction`, syntax: [`[start]`, `[start:end]`, `[start:step:end]`, `[start1, start 2, ...]`, `[start1:end1, start2:end2, ...]`, `[start1:step1:end1, start2:step2:end2, ...]`], description: `Create an index to get or replace a subset of a matrix`, examples: [`A = [1, 2, 3; 4, 5, 6]`, `A[1, :]`, `A[1, 2] = 50`, `A[1:2, 1:2] = 1`, `B = [1, 2, 3]`, `B[B>1 and B<3]`], seealso: [`bignumber`, `boolean`, `complex`, `matrix`, `number`, `range`, `string`, `unit`] }, matrixDocs = { name: `matrix`, category: `Construction`, syntax: [`[]`, `[a1, b1, ...; a2, b2, ...]`, `matrix()`, `matrix("dense")`, `matrix([...])`], description: `Create a matrix.`, examples: [`[]`, `[1, 2, 3]`, `[1, 2, 3; 4, 5, 6]`, `matrix()`, `matrix([3, 4])`, `matrix([3, 4; 5, 6], "sparse")`, `matrix([3, 4; 5, 6], "sparse", "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `sparse`] }, numberDocs = { name: `number`, category: `Construction`, syntax: [`x`, `number(x)`, `number(unit, valuelessUnit)`], description: `Create a number or convert a string or boolean into a number.`, examples: [`2`, `2e3`, `4.05`, `number(2)`, `number("7.2")`, `number(true)`, `number([true, false, true, true])`, `number(unit("52cm"), "m")`], seealso: [`bignumber`, `bigint`, `boolean`, `complex`, `fraction`, `index`, `matrix`, `string`, `unit`] }, sparseDocs = { name: `sparse`, category: `Construction`, syntax: [`sparse()`, `sparse([a1, b1, ...; a1, b2, ...])`, `sparse([a1, b1, ...; a1, b2, ...], "number")`], description: `Create a sparse matrix.`, examples: [`sparse()`, `sparse([3, 4; 5, 6])`, `sparse([3, 0; 5, 0], "number")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `number`, `string`, `unit`, `matrix`] }, splitUnitDocs = { name: `splitUnit`, category: `Construction`, syntax: [`splitUnit(unit: Unit, parts: Unit[])`], description: `Split a unit in an array of units whose sum is equal to the original unit.`, examples: [`splitUnit(1 m, ["feet", "inch"])`], seealso: [`unit`, `createUnit`] }, stringDocs = { name: `string`, category: `Construction`, syntax: [`"text"`, `string(x)`], description: `Create a string or convert a value to a string`, examples: [`"Hello World!"`, `string(4.2)`, `string(3 + 2i)`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `unit`] }, unitDocs = { name: `unit`, category: `Construction`, syntax: [`value unit`, `unit(value, unit)`, `unit(string)`], description: `Create a unit.`, examples: [`5.5 mm`, `3 inch`, `unit(7.1, "kilogram")`, `unit("23 deg")`], seealso: [`bignumber`, `boolean`, `complex`, `index`, `matrix`, `number`, `string`] }, configDocs = { name: `config`, category: `Core`, syntax: [`config()`, `config(options)`], description: `Get configuration or change configuration.`, examples: [`config()`, `1/3 + 1/4`, `config({number: "Fraction"})`, `1/3 + 1/4`], seealso: [] }, importDocs = { name: `import`, category: `Core`, syntax: [`import(functions)`, `import(functions, options)`], description: `Import functions or constants from an object.`, examples: [`import({myFn: f(x)=x^2, myConstant: 32 })`, `myFn(2)`, `myConstant`], seealso: [] }, typedDocs = { name: `typed`, category: `Core`, syntax: [`typed(signatures)`, `typed(name, signatures)`], description: `Create a typed function.`, examples: [`double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })`, `double(2)`, `double("hello")`], seealso: [] }, derivativeDocs = { name: `derivative`, category: `Algebra`, syntax: [`derivative(expr, variable)`, `derivative(expr, variable, {simplify: boolean})`], description: `Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.`, examples: [`derivative("2x^3", "x")`, `derivative("2x^3", "x", {simplify: false})`, `derivative("2x^2 + 3x + 4", "x")`, `derivative("sin(2x)", "x")`, `f = parse("x^2 + x")`, `x = parse("x")`, `df = derivative(f, x)`, `df.evaluate({x: 3})`], seealso: [`simplify`, `parse`, `evaluate`] }, leafCountDocs = { name: `leafCount`, category: `Algebra`, syntax: [`leafCount(expr)`], description: `Computes the number of leaves in the parse tree of the given expression`, examples: [`leafCount("e^(i*pi)-1")`, `leafCount(parse("{a: 22/7, b: 10^(1/2)}"))`], seealso: [`simplify`] }, lsolveDocs = { name: `lsolve`, category: `Algebra`, syntax: [`x=lsolve(L, b)`], description: `Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolveAll`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lsolveAllDocs = { name: `lsolveAll`, category: `Algebra`, syntax: [`x=lsolveAll(L, b)`], description: `Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lsolve(a, b)`], seealso: [`lsolve`, `lup`, `lusolve`, `usolve`, `matrix`, `sparse`] }, lupDocs = { name: `lup`, category: `Algebra`, syntax: [`lup(m)`], description: `Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U`, examples: [`lup([[2, 1], [1, 4]])`, `lup(matrix([[2, 1], [1, 4]]))`, `lup(sparse([[2, 1], [1, 4]]))`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `slu`, `qr`] }, lusolveDocs = { name: `lusolve`, category: `Algebra`, syntax: [`x=lusolve(A, b)`, `x=lusolve(lu, b)`], description: `Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.`, examples: [`a = [-2, 3; 2, 1]`, `b = [11, 9]`, `x = lusolve(a, b)`], seealso: [`lup`, `slu`, `lsolve`, `usolve`, `matrix`, `sparse`] }, polynomialRootDocs = { name: `polynomialRoot`, category: `Algebra`, syntax: [`x=polynomialRoot(-6, 3)`, `x=polynomialRoot(4, -4, 1)`, `x=polynomialRoot(-8, 12, -6, 1)`], description: `Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.`, examples: [`a = polynomialRoot(-6, 11, -6, 1)`], seealso: [`cbrt`, `sqrt`] }, qrDocs = { name: `qr`, category: `Algebra`, syntax: [`qr(A)`], description: "Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.", examples: [`qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])`], seealso: [`lup`, `slu`, `matrix`] }, rationalizeDocs = { name: `rationalize`, category: `Algebra`, syntax: [`rationalize(expr)`, `rationalize(expr, scope)`, `rationalize(expr, scope, detailed)`], description: `Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.`, examples: [`rationalize("2x/y - y/(x+1)")`, `rationalize("2x/y - y/(x+1)", true)`], seealso: [`simplify`] }, resolveDocs = { name: `resolve`, category: `Algebra`, syntax: [`resolve(node, scope)`], description: `Recursively substitute variables in an expression tree.`, examples: [`resolve(parse("1 + x"), { x: 7 })`, `resolve(parse("size(text)"), { text: "Hello World" })`, `resolve(parse("x + y"), { x: parse("3z") })`, `resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })`], seealso: [`simplify`, `evaluate`], mayThrow: [`ReferenceError`] }, simplifyDocs = { name: `simplify`, category: `Algebra`, syntax: [`simplify(expr)`, `simplify(expr, rules)`], description: `Simplify an expression tree.`, examples: [`simplify("3 + 2 / 4")`, `simplify("2x + x")`, `f = parse("x * (x + 2 + x)")`, `simplified = simplify(f)`, `simplified.evaluate({x: 2})`], seealso: [`simplifyCore`, `derivative`, `evaluate`, `parse`, `rationalize`, `resolve`] }, simplifyConstantDocs = { name: `simplifyConstant`, category: `Algebra`, syntax: [`simplifyConstant(expr)`, `simplifyConstant(expr, options)`], description: `Replace constant subexpressions of node with their values.`, examples: [`simplifyConstant("(3-3)*x")`, `simplifyConstant(parse("z-cos(tau/8)"))`], seealso: [`simplify`, `simplifyCore`, `evaluate`] }, simplifyCoreDocs = { name: `simplifyCore`, category: `Algebra`, syntax: [`simplifyCore(node)`], description: `Perform simple one-pass simplifications on an expression tree.`, examples: [`simplifyCore(parse("0*x"))`, `simplifyCore(parse("(x+0)*2"))`], seealso: [`simplify`, `simplifyConstant`, `evaluate`] }, sluDocs = { name: `slu`, category: `Algebra`, syntax: [`slu(A, order, threshold)`], description: `Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U`, examples: [`slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)`], seealso: [`lusolve`, `lsolve`, `usolve`, `matrix`, `sparse`, `lup`, `qr`] }, symbolicEqualDocs = { name: `symbolicEqual`, category: `Algebra`, syntax: [`symbolicEqual(expr1, expr2)`, `symbolicEqual(expr1, expr2, options)`], description: `Returns true if the difference of the expressions simplifies to 0`, examples: [`symbolicEqual("x*y","y*x")`, `symbolicEqual("abs(x^2)", "x^2")`, `symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})`], seealso: [`simplify`, `evaluate`] }, usolveDocs = { name: `usolve`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolveAll`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, usolveAllDocs = { name: `usolveAll`, category: `Algebra`, syntax: [`x=usolve(U, b)`], description: `Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.`, examples: [`x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])`], seealso: [`usolve`, `lup`, `lusolve`, `lsolve`, `matrix`, `sparse`] }, absDocs = { name: `abs`, category: `Arithmetic`, syntax: [`abs(x)`], description: `Compute the absolute value.`, examples: [`abs(3.5)`, `abs(-4.2)`], seealso: [`sign`] }, addDocs = { name: `add`, category: `Operators`, syntax: [`x + y`, `add(x, y)`], description: `Add two values.`, examples: [`a = 2.1 + 3.6`, `a - 3.6`, `3 + 2i`, `3 cm + 2 inch`, `"2.3" + "4"`], seealso: [`subtract`] }, cbrtDocs = { name: `cbrt`, category: `Arithmetic`, syntax: [`cbrt(x)`, `cbrt(x, allRoots)`], description: "Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned", examples: [`cbrt(64)`, `cube(4)`, `cbrt(-8)`, `cbrt(2 + 3i)`, `cbrt(8i)`, `cbrt(8i, true)`, `cbrt(27 m^3)`], seealso: [`square`, `sqrt`, `cube`, `multiply`] }, ceilDocs = { name: `ceil`, category: `Arithmetic`, syntax: [`ceil(x)`, `ceil(x, n)`, `ceil(unit, valuelessUnit)`, `ceil(unit, n, valuelessUnit)`], description: `Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.`, examples: [`ceil(3.2)`, `ceil(3.8)`, `ceil(-4.2)`, `ceil(3.241cm, cm)`, `ceil(3.241cm, 2, cm)`], seealso: [`floor`, `fix`, `round`] }, cubeDocs = { name: `cube`, category: `Arithmetic`, syntax: [`cube(x)`], description: `Compute the cube of a value. The cube of x is x * x * x.`, examples: [`cube(2)`, `2^3`, `2 * 2 * 2`], seealso: [`multiply`, `square`, `pow`] }, divideDocs = { name: `divide`, category: `Operators`, syntax: [`x / y`, `divide(x, y)`], description: `Divide two values.`, examples: [`a = 2 / 3`, `a * 3`, `4.5 / 2`, `3 + 4 / 2`, `(3 + 4) / 2`, `18 km / 4.5`], seealso: [`multiply`] }, dotDivideDocs = { name: `dotDivide`, category: `Operators`, syntax: [`x ./ y`, `dotDivide(x, y)`], description: `Divide two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a ./ b`], seealso: [`multiply`, `dotMultiply`, `divide`] }, dotMultiplyDocs = { name: `dotMultiply`, category: `Operators`, syntax: [`x .* y`, `dotMultiply(x, y)`], description: `Multiply two values element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `b = [2, 1, 1; 3, 2, 5]`, `a .* b`], seealso: [`multiply`, `divide`, `dotDivide`] }, dotPowDocs = { name: `dotPow`, category: `Operators`, syntax: [`x .^ y`, `dotPow(x, y)`], description: `Calculates the power of x to y element wise.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a .^ 2`], seealso: [`pow`] }, expDocs = { name: `exp`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Calculate the exponent of a value.`, examples: [`exp(1.3)`, `e ^ 1.3`, `log(exp(1.3))`, `x = 2.4`, `(exp(i*x) == cos(x) + i*sin(x))   # Euler's formula`], seealso: [`expm`, `expm1`, `pow`, `log`] }, expmDocs = { name: `expm`, category: `Arithmetic`, syntax: [`exp(x)`], description: `Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.`, examples: [`expm([[0,2],[0,0]])`], seealso: [`exp`] }, expm1Docs = { name: `expm1`, category: `Arithmetic`, syntax: [`expm1(x)`], description: `Calculate the value of subtracting 1 from the exponential value.`, examples: [`expm1(2)`, `pow(e, 2) - 1`, `log(expm1(2) + 1)`], seealso: [`exp`, `pow`, `log`] }, fixDocs = { name: `fix`, category: `Arithmetic`, syntax: [`fix(x)`, `fix(x, n)`, `fix(unit, valuelessUnit)`, `fix(unit, n, valuelessUnit)`], description: `Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.`, examples: [`fix(3.2)`, `fix(3.8)`, `fix(-4.2)`, `fix(-4.8)`, `fix(3.241cm, cm)`, `fix(3.241cm, 2, cm)`], seealso: [`ceil`, `floor`, `round`] }, floorDocs = { name: `floor`, category: `Arithmetic`, syntax: [`floor(x)`, `floor(x, n)`, `floor(unit, valuelessUnit)`, `floor(unit, n, valuelessUnit)`], description: `Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.`, examples: [`floor(3.2)`, `floor(3.8)`, `floor(-4.2)`, `floor(3.241cm, cm)`, `floor(3.241cm, 2, cm)`], seealso: [`ceil`, `fix`, `round`] }, gcdDocs = { name: `gcd`, category: `Arithmetic`, syntax: [`gcd(a, b)`, `gcd(a, b, c, ...)`], description: `Compute the greatest common divisor.`, examples: [`gcd(8, 12)`, `gcd(-4, 6)`, `gcd(25, 15, -10)`], seealso: [`lcm`, `xgcd`] }, hypotDocs = { name: `hypot`, category: `Arithmetic`, syntax: [`hypot(a, b, c, ...)`, `hypot([a, b, c, ...])`], description: `Calculate the hypotenuse of a list with values.`, examples: [`hypot(3, 4)`, `sqrt(3^2 + 4^2)`, `hypot(-2)`, `hypot([3, 4, 5])`], seealso: [`abs`, `norm`] }, invmodDocs = { name: `invmod`, category: `Arithmetic`, syntax: [`invmod(a, b)`], description: `Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)`, examples: [`invmod(8, 12)`, `invmod(7, 13)`, `invmod(15151, 15122)`], seealso: [`gcd`, `xgcd`] }, lcmDocs = { name: `lcm`, category: `Arithmetic`, syntax: [`lcm(x, y)`], description: `Compute the least common multiple.`, examples: [`lcm(4, 6)`, `lcm(6, 21)`, `lcm(6, 21, 5)`], seealso: [`gcd`] }, logDocs = { name: `log`, category: `Arithmetic`, syntax: [`log(x)`, `log(x, base)`], description: `Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).`, examples: [`log(3.5)`, `a = log(2.4)`, `exp(a)`, `10 ^ 4`, `log(10000, 10)`, `log(10000) / log(10)`, `b = log(1024, 2)`, `2 ^ b`], seealso: [`exp`, `log1p`, `log2`, `log10`] }, log10Docs = { name: `log10`, category: `Arithmetic`, syntax: [`log10(x)`], description: `Compute the 10-base logarithm of a value.`, examples: [`log10(0.00001)`, `log10(10000)`, `10 ^ 4`, `log(10000) / log(10)`, `log(10000, 10)`], seealso: [`exp`, `log`] }, log1pDocs = { name: `log1p`, category: `Arithmetic`, syntax: [`log1p(x)`, `log1p(x, base)`], description: "Calculate the logarithm of a `value+1`", examples: [`log1p(2.5)`, `exp(log1p(1.4))`, `pow(10, 4)`, `log1p(9999, 10)`, `log1p(9999) / log(10)`], seealso: [`exp`, `log`, `log2`, `log10`] }, log2Docs = { name: `log2`, category: `Arithmetic`, syntax: [`log2(x)`], description: "Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.", examples: [`log2(0.03125)`, `log2(16)`, `log2(16) / log2(2)`, `pow(2, 4)`], seealso: [`exp`, `log1p`, `log`, `log10`] }, modDocs = { name: `mod`, category: `Operators`, syntax: [`x % y`, `x mod y`, `mod(x, y)`], description: `Calculates the modulus, the remainder of an integer division.`, examples: [`7 % 3`, `11 % 2`, `10 mod 4`, `isOdd(x) = x % 2`, `isOdd(2)`, `isOdd(3)`], seealso: [`divide`] }, multiplyDocs = { name: `multiply`, category: `Operators`, syntax: [`x * y`, `multiply(x, y)`], description: `multiply two values.`, examples: [`a = 2.1 * 3.4`, `a / 3.4`, `2 * 3 + 4`, `2 * (3 + 4)`, `3 * 2.1 km`], seealso: [`divide`] }, normDocs = { name: `norm`, category: `Arithmetic`, syntax: [`norm(x)`, `norm(x, p)`], description: `Calculate the norm of a number, vector or matrix.`, examples: [`abs(-3.5)`, `norm(-3.5)`, `norm(3 - 4i)`, `norm([1, 2, -3], Infinity)`, `norm([1, 2, -3], -Infinity)`, `norm([3, 4], 2)`, `norm([[1, 2], [3, 4]], 1)`, `norm([[1, 2], [3, 4]], "inf")`, `norm([[1, 2], [3, 4]], "fro")`] }, nthRootDocs = { name: `nthRoot`, category: `Arithmetic`, syntax: [`nthRoot(a)`, `nthRoot(a, root)`], description: `Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".`, examples: [`4 ^ 3`, `nthRoot(64, 3)`, `nthRoot(9, 2)`, `sqrt(9)`], seealso: [`nthRoots`, `pow`, `sqrt`] }, nthRootsDocs = { name: `nthRoots`, category: `Arithmetic`, syntax: [`nthRoots(A)`, `nthRoots(A, root)`], description: `Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.`, examples: [`nthRoots(1)`, `nthRoots(1, 3)`], seealso: [`sqrt`, `pow`, `nthRoot`] }, powDocs = { name: `pow`, category: `Operators`, syntax: [`x ^ y`, `pow(x, y)`], description: `Calculates the power of x to y, x^y.`, examples: [`2^3`, `2*2*2`, `1 + e ^ (pi * i)`, `pow([[1, 2], [4, 3]], 2)`, `pow([[1, 2], [4, 3]], -1)`], seealso: [`multiply`, `nthRoot`, `nthRoots`, `sqrt`] }, roundDocs = { name: `round`, category: `Arithmetic`, syntax: [`round(x)`, `round(x, n)`, `round(unit, valuelessUnit)`, `round(unit, n, valuelessUnit)`], description: `round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.`, examples: [`round(3.2)`, `round(3.8)`, `round(-4.2)`, `round(-4.8)`, `round(pi, 3)`, `round(123.45678, 2)`, `round(3.241cm, 2, cm)`, `round([3.2, 3.8, -4.7])`], seealso: [`ceil`, `floor`, `fix`] }, signDocs = { name: `sign`, category: `Arithmetic`, syntax: [`sign(x)`], description: `Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.`, examples: [`sign(3.5)`, `sign(-4.2)`, `sign(0)`], seealso: [`abs`] }, sqrtDocs = { name: `sqrt`, category: `Arithmetic`, syntax: [`sqrt(x)`], description: `Compute the square root value. If x = y * y, then y is the square root of x.`, examples: [`sqrt(25)`, `5 * 5`, `sqrt(-1)`], seealso: [`square`, `sqrtm`, `multiply`, `nthRoot`, `nthRoots`, `pow`] }, sqrtmDocs = { name: `sqrtm`, category: `Arithmetic`, syntax: [`sqrtm(x)`], description: "Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.", examples: [`sqrtm([[33, 24], [48, 57]])`], seealso: [`sqrt`, `abs`, `square`, `multiply`] }, sylvesterDocs = { name: `sylvester`, category: `Algebra`, syntax: [`sylvester(A,B,C)`], description: `Solves the real-valued Sylvester equation AX+XB=C for X`, examples: [`sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])`, `A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]`, `sylvester(A, B, C)`], seealso: [`schur`, `lyap`] }, schurDocs = { name: `schur`, category: `Algebra`, syntax: [`schur(A)`], description: `Performs a real Schur decomposition of the real matrix A = UTU'`, examples: [`schur([[1, 0], [-4, 3]])`, `A = [[1, 0], [-4, 3]]`, `schur(A)`], seealso: [`lyap`, `sylvester`] }, lyapDocs = { name: `lyap`, category: `Algebra`, syntax: [`lyap(A,Q)`], description: `Solves the Continuous-time Lyapunov equation AP+PA'+Q=0 for P`, examples: [`lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])`, `A = [[-2, 0], [1, -4]]`, `Q = [[3, 1], [1, 3]]`, `lyap(A,Q)`], seealso: [`schur`, `sylvester`] }, squareDocs = { name: `square`, category: `Arithmetic`, syntax: [`square(x)`], description: `Compute the square of a value. The square of x is x * x.`, examples: [`square(3)`, `sqrt(9)`, `3^2`, `3 * 3`], seealso: [`multiply`, `pow`, `sqrt`, `cube`] }, subtractDocs = { name: `subtract`, category: `Operators`, syntax: [`x - y`, `subtract(x, y)`], description: `subtract two values.`, examples: [`a = 5.3 - 2`, `a + 2`, `2/3 - 1/6`, `2 * 3 - 3`, `2.1 km - 500m`], seealso: [`add`] }, unaryMinusDocs = { name: `unaryMinus`, category: `Operators`, syntax: [`-x`, `unaryMinus(x)`], description: `Inverse the sign of a value. Converts booleans and strings to numbers.`, examples: [`-4.5`, `-(-5.6)`, `-"22"`], seealso: [`add`, `subtract`, `unaryPlus`] }, unaryPlusDocs = { name: `unaryPlus`, category: `Operators`, syntax: [`+x`, `unaryPlus(x)`], description: `Converts booleans and strings to numbers.`, examples: [`+true`, `+"2"`], seealso: [`add`, `subtract`, `unaryMinus`] }, xgcdDocs = { name: `xgcd`, category: `Arithmetic`, syntax: [`xgcd(a, b)`], description: `Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.`, examples: [`xgcd(8, 12)`, `gcd(8, 12)`, `xgcd(36163, 21199)`], seealso: [`gcd`, `lcm`] }, numDocs = { name: `num`, category: `Fraction`, syntax: [`num(x)`], description: `Get the numerator of a fraction.`, examples: [`num(fraction(2, 3))`, `num(fraction(5, 8))`], seealso: [`den`, `fraction`] }, denDocs = { name: `den`, category: `Fraction`, syntax: [`den(x)`], description: `Get the denominator of a fraction.`, examples: [`den(fraction(2, 3))`, `den(fraction(5, 8))`], seealso: [`num`, `fraction`] }, bitAndDocs = { name: `bitAnd`, category: `Bitwise`, syntax: [`x & y`, `bitAnd(x, y)`], description: `Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0`, examples: [`5 & 3`, `bitAnd(53, 131)`, `[1, 12, 31] & 42`], seealso: [`bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitNotDocs = { name: `bitNot`, category: `Bitwise`, syntax: [`~x`, `bitNot(x)`], description: `Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.`, examples: [`~1`, `~2`, `bitNot([2, -3, 4])`], seealso: [`bitAnd`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitOrDocs = { name: `bitOr`, category: `Bitwise`, syntax: [`x | y`, `bitOr(x, y)`], description: `Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.`, examples: [`5 | 3`, `bitOr([1, 2, 3], 4)`], seealso: [`bitAnd`, `bitNot`, `bitXor`, `leftShift`, `rightArithShift`, `rightLogShift`] }, bitXorDocs = { name: `bitXor`, category: `Bitwise`, syntax: [`bitXor(x, y)`], description: `Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.`, examples: [`bitOr(1, 2)`, `bitXor([2, 3, 4], 4)`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `leftShift`, `rightArithShift`, `rightLogShift`] }, leftShiftDocs = { name: `leftShift`, category: `Bitwise`, syntax: [`x << y`, `leftShift(x, y)`], description: `Bitwise left logical shift of a value x by y number of bits.`, examples: [`4 << 1`, `8 >> 1`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `rightArithShift`, `rightLogShift`] }, rightArithShiftDocs = { name: `rightArithShift`, category: `Bitwise`, syntax: [`x >> y`, `rightArithShift(x, y)`], description: `Bitwise right arithmetic shift of a value x by y number of bits.`, examples: [`8 >> 1`, `4 << 1`, `-12 >> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightLogShift`] }, rightLogShiftDocs = { name: `rightLogShift`, category: `Bitwise`, syntax: [`x >>> y`, `rightLogShift(x, y)`], description: `Bitwise right logical shift of a value x by y number of bits.`, examples: [`8 >>> 1`, `4 << 1`, `-12 >>> 2`], seealso: [`bitAnd`, `bitNot`, `bitOr`, `bitXor`, `leftShift`, `rightArithShift`] }, bellNumbersDocs = { name: `bellNumbers`, category: `Combinatorics`, syntax: [`bellNumbers(n)`], description: "The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.", examples: [`bellNumbers(3)`, `bellNumbers(8)`], seealso: [`stirlingS2`] }, catalanDocs = { name: `catalan`, category: `Combinatorics`, syntax: [`catalan(n)`], description: `The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.`, examples: [`catalan(3)`, `catalan(8)`], seealso: [`bellNumbers`] }, compositionDocs = { name: `composition`, category: `Combinatorics`, syntax: [`composition(n, k)`], description: `The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.`, examples: [`composition(5, 3)`], seealso: [`combinations`] }, stirlingS2Docs = { name: `stirlingS2`, category: `Combinatorics`, syntax: [`stirlingS2(n, k)`], description: "The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.", examples: [`stirlingS2(5, 3)`], seealso: [`bellNumbers`, `bernoulli`] }, argDocs = { name: `arg`, category: `Complex`, syntax: [`arg(x)`], description: `Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).`, examples: [`arg(2 + 2i)`, `atan2(3, 2)`, `arg(2 + 3i)`], seealso: [`re`, `im`, `conj`, `abs`] }, conjDocs = { name: `conj`, category: `Complex`, syntax: [`conj(x)`], description: `Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.`, examples: [`conj(2 + 3i)`, `conj(2 - 3i)`, `conj(-5.2i)`], seealso: [`re`, `im`, `abs`, `arg`] }, imDocs = { name: `im`, category: `Complex`, syntax: [`im(x)`], description: `Get the imaginary part of a complex number.`, examples: [`im(2 + 3i)`, `re(2 + 3i)`, `im(-5.2i)`, `im(2.4)`], seealso: [`re`, `conj`, `abs`, `arg`] }, reDocs = { name: `re`, category: `Complex`, syntax: [`re(x)`], description: `Get the real part of a complex number.`, examples: [`re(2 + 3i)`, `im(2 + 3i)`, `re(-5.2i)`, `re(2.4)`], seealso: [`im`, `conj`, `abs`, `arg`] }, evaluateDocs = { name: `evaluate`, category: `Expression`, syntax: [`evaluate(expression)`, `evaluate(expression, scope)`, `evaluate([expr1, expr2, expr3, ...])`, `evaluate([expr1, expr2, expr3, ...], scope)`], description: `Evaluate an expression or an array with expressions.`, examples: [`evaluate("2 + 3")`, `evaluate("sqrt(16)")`, `evaluate("2 inch to cm")`, `evaluate("sin(x * pi)", { "x": 1/2 })`, `evaluate(["width=2", "height=4","width*height"])`], seealso: [`parser`, `parse`, `compile`] }, parserDocs = { name: `parser`, category: `Expression`, syntax: [`parser()`], description: `Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.`, examples: [`myParser = parser()`, `myParser.evaluate("sqrt(3^2 + 4^2)")`, `myParser.set("x", 3)`, `myParser.evaluate("y = x + 3")`, `myParser.evaluate(["y = x + 3", "y = y + 1"])`, `myParser.get("y")`], seealso: [`evaluate`, `parse`, `compile`] }, parseDocs = { name: `parse`, category: `Expression`, syntax: [`parse(expr)`, `parse(expr, options)`, `parse([expr1, expr2, expr3, ...])`, `parse([expr1, expr2, expr3, ...], options)`], description: `Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().`, examples: [`node1 = parse("sqrt(3^2 + 4^2)")`, `node1.evaluate()`, `code1 = node1.compile()`, `code1.evaluate()`, `scope = {a: 3, b: 4}`, `node2 = parse("a * b")`, `node2.evaluate(scope)`, `code2 = node2.compile()`, `code2.evaluate(scope)`], seealso: [`parser`, `evaluate`, `compile`] }, compileDocs = { name: `compile`, category: `Expression`, syntax: [`compile(expr) `, `compile([expr1, expr2, expr3, ...])`], description: `Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.`, examples: [`code1 = compile("sqrt(3^2 + 4^2)")`, `code1.evaluate() `, `code2 = compile("a * b")`, `code2.evaluate({a: 3, b: 4})`], seealso: [`parser`, `parse`, `evaluate`] }, helpDocs = { name: `help`, category: `Expression`, syntax: [`help(object)`, `help(string)`], description: `Display documentation on a function or data type.`, examples: [`help(sqrt)`, `help("complex")`], seealso: [] }, distanceDocs = { name: `distance`, category: `Geometry`, syntax: [`distance([x1, y1], [x2, y2])`, `distance([[x1, y1], [x2, y2]])`], description: `Calculates the Euclidean distance between two points.`, examples: [`distance([0,0], [4,4])`, `distance([[0,0], [4,4]])`], seealso: [] }, intersectDocs = { name: `intersect`, category: `Geometry`, syntax: [`intersect(expr1, expr2, expr3, expr4)`, `intersect(expr1, expr2, expr3)`], description: `Computes the intersection point of lines and/or planes.`, examples: [`intersect([0, 0], [10, 10], [10, 0], [0, 10])`, `intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])`], seealso: [] }, andDocs = { name: `and`, category: `Logical`, syntax: [`x and y`, `and(x, y)`], description: `Logical and. Test whether two values are both defined with a nonzero/nonempty value.`, examples: [`true and false`, `true and true`, `2 and 4`], seealso: [`not`, `or`, `xor`] }, notDocs = { name: `not`, category: `Logical`, syntax: [`not x`, `not(x)`], description: `Logical not. Flips the boolean value of given argument.`, examples: [`not true`, `not false`, `not 2`, `not 0`], seealso: [`and`, `or`, `xor`] }, nullishDocs = { name: `nullish`, category: `Logical`, syntax: [`x ?? y`, `nullish(x, y)`], description: `Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.`, examples: [`null ?? 42`, `undefined ?? 42`, `0 ?? 42`, `false ?? 42`, `null ?? undefined ?? 42`], seealso: [`and`, `or`, `not`] }, orDocs = { name: `or`, category: `Logical`, syntax: [`x or y`, `or(x, y)`], description: `Logical or. Test if at least one value is defined with a nonzero/nonempty value.`, examples: [`true or false`, `false or false`, `0 or 4`], seealso: [`not`, `and`, `xor`] }, xorDocs = { name: `xor`, category: `Logical`, syntax: [`x xor y`, `xor(x, y)`], description: `Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.`, examples: [`true xor false`, `false xor false`, `true xor true`, `0 xor 4`], seealso: [`not`, `and`, `or`] }, mapSlicesDocs = { name: `mapSlices`, category: `Matrix`, syntax: [`mapSlices(A, dim, callback)`], description: `Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.`, examples: [`A = [[1, 2], [3, 4]]`, `mapSlices(A, 1, sum)`, `mapSlices(A, 2, prod)`], seealso: [`map`, `forEach`] }, columnDocs = { name: `column`, category: `Matrix`, syntax: [`column(x, index)`], description: `Return a column from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `column(A, 1)`, `column(A, 2)`], seealso: [`row`, `matrixFromColumns`] }, concatDocs = { name: `concat`, category: `Matrix`, syntax: [`concat(A, B, C, ...)`, `concat(A, B, C, ..., dim)`], description: `Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.`, examples: [`A = [1, 2; 5, 6]`, `B = [3, 4; 7, 8]`, `concat(A, B)`, `concat(A, B, 1)`, `concat(A, B, 2)`], seealso: [`det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, countDocs = { name: `count`, category: `Matrix`, syntax: [`count(x)`], description: `Count the number of elements of a matrix, array or string.`, examples: [`a = [1, 2; 3, 4; 5, 6]`, `count(a)`, `size(a)`, `count("hello world")`], seealso: [`size`] }, crossDocs = { name: `cross`, category: `Matrix`, syntax: [`cross(A, B)`], description: `Calculate the cross product for two vectors in three dimensional space.`, examples: [`cross([1, 1, 0],  [0, 1, 1])`, `cross([3, -3, 1], [4, 9, 2])`, `cross([2, 3, 4],  [5, 6, 7])`], seealso: [`multiply`, `dot`] }, ctransposeDocs = { name: `ctranspose`, category: `Matrix`, syntax: [`x'`, `ctranspose(x)`], description: `Complex Conjugate and Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `ctranspose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, detDocs = { name: `det`, category: `Matrix`, syntax: [`det(x)`], description: `Calculate the determinant of a matrix`, examples: [`det([1, 2; 3, 4])`, `det([-2, 2, 3; -1, 1, 3; 2, 0, -1])`], seealso: [`concat`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diagDocs = { name: `diag`, category: `Matrix`, syntax: [`diag(x)`, `diag(x, k)`], description: `Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.`, examples: [`diag(1:3)`, `diag(1:3, 1)`, `a = [1, 2, 3; 4, 5, 6; 7, 8, 9]`, `diag(a)`], seealso: [`concat`, `det`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, diffDocs = { name: `diff`, category: `Matrix`, syntax: [`diff(arr)`, `diff(arr, dim)`], description: [`Create a new matrix or array with the difference of the passed matrix or array.`, `Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference`, `If no dimension parameter is passed it is assumed as dimension 0`, `Dimension is zero-based in javascript and one-based in the parser`, `Arrays must be 'rectangular' meaning arrays like [1, 2]`, `If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays`], examples: [`A = [1, 2, 4, 7, 0]`, `diff(A)`, `diff(A, 1)`, `B = [[1, 2], [3, 4]]`, `diff(B)`, `diff(B, 1)`, `diff(B, 2)`, `diff(B, bignumber(2))`, `diff([[1, 2], matrix([3, 4])], 2)`], seealso: [`subtract`, `partitionSelect`] }, dotDocs = { name: `dot`, category: `Matrix`, syntax: [`dot(A, B)`, `A * B`], description: `Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn`, examples: [`dot([2, 4, 1], [2, 2, 3])`, `[2, 4, 1] * [2, 2, 3]`], seealso: [`multiply`, `cross`] }, eigsDocs = { name: `eigs`, category: `Matrix`, syntax: [`eigs(x)`], description: `Calculate the eigenvalues and optionally eigenvectors of a square matrix`, examples: [`eigs([[5, 2.3], [2.3, 1]])`, `eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })`], seealso: [`inv`] }, filterDocs = { name: `filter`, category: `Matrix`, syntax: [`filter(x, test)`], description: `Filter items in a matrix.`, examples: [`isPositive(x) = x > 0`, `filter([6, -2, -1, 4, 3], isPositive)`, `filter([6, -2, 0, 1, 0], x != 0)`], seealso: [`sort`, `map`, `forEach`] }, flattenDocs = { name: `flatten`, category: `Matrix`, syntax: [`flatten(x)`], description: `Flatten a multi dimensional matrix into a single dimensional matrix.`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `size(a)`, `b = flatten(a)`, `size(b)`], seealso: [`concat`, `resize`, `size`, `squeeze`] }, forEachDocs = { name: `forEach`, category: `Matrix`, syntax: [`forEach(x, callback)`], description: `Iterates over all elements of a matrix/array, and executes the given callback function.`, examples: [`numberOfPets = {}`, `addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;`, `forEach(["Dog","Cat","Cat"], addPet)`, `numberOfPets`], seealso: [`map`, `sort`, `filter`] }, getMatrixDataTypeDocs = { name: `getMatrixDataType`, category: `Matrix`, syntax: [`getMatrixDataType(x)`], description: `Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".`, examples: [`getMatrixDataType([1, 2, 3])`, `getMatrixDataType([[5 cm], [2 inch]])`, `getMatrixDataType([1, "text"])`, `getMatrixDataType([1, bignumber(4)])`], seealso: [`matrix`, `sparse`, `typeOf`] }, identityDocs = { name: `identity`, category: `Matrix`, syntax: [`identity(n)`, `identity(m, n)`, `identity([m, n])`], description: `Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.`, examples: [`identity(3)`, `identity(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `identity(size(a))`], seealso: [`concat`, `det`, `diag`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, invDocs = { name: `inv`, category: `Matrix`, syntax: [`inv(x)`], description: `Calculate the inverse of a matrix`, examples: [`inv([1, 2; 3, 4])`, `inv(4)`, `1 / 4`], seealso: [`concat`, `det`, `diag`, `identity`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, pinvDocs = { name: `pinv`, category: `Matrix`, syntax: [`pinv(x)`], description: `Calculate the Moore–Penrose inverse of a matrix`, examples: [`pinv([1, 2; 3, 4])`, `pinv([[1, 0], [0, 1], [0, 1]])`, `pinv(4)`], seealso: [`inv`] }, kronDocs = { name: `kron`, category: `Matrix`, syntax: [`kron(x, y)`], description: `Calculates the Kronecker product of 2 matrices or vectors.`, examples: [`kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])`, `kron([1,1], [2,3,4])`], seealso: [`multiply`, `dot`, `cross`] }, mapDocs = { name: `map`, category: `Matrix`, syntax: [`map(x, callback)`, `map(x, y, ..., callback)`], description: `Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.`, examples: [`map([1, 2, 3], square)`, `map([1, 2], [3, 4], f(a,b) = a + b)`], seealso: [`filter`, `forEach`] }, matrixFromColumnsDocs = { name: `matrixFromColumns`, category: `Matrix`, syntax: [`matrixFromColumns(...arr)`, `matrixFromColumns(row1, row2)`, `matrixFromColumns(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual columns.`, examples: [`matrixFromColumns([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromRows`, `matrixFromFunction`, `zeros`] }, matrixFromFunctionDocs = { name: `matrixFromFunction`, category: `Matrix`, syntax: [`matrixFromFunction(size, fn)`, `matrixFromFunction(size, fn, format)`, `matrixFromFunction(size, fn, format, datatype)`, `matrixFromFunction(size, format, fn)`, `matrixFromFunction(size, format, datatype, fn)`], description: `Create a matrix by evaluating a generating function at each index.`, examples: [`f(I) = I[1] - I[2]`, `matrixFromFunction([3,3], f)`, `g(I) = I[1] - I[2] == 1 ? 4 : 0`, `matrixFromFunction([100, 100], "sparse", g)`, `matrixFromFunction([5], random)`], seealso: [`matrix`, `matrixFromRows`, `matrixFromColumns`, `zeros`] }, matrixFromRowsDocs = { name: `matrixFromRows`, category: `Matrix`, syntax: [`matrixFromRows(...arr)`, `matrixFromRows(row1, row2)`, `matrixFromRows(row1, row2, row3)`], description: `Create a dense matrix from vectors as individual rows.`, examples: [`matrixFromRows([1, 2, 3], [[4],[5],[6]])`], seealso: [`matrix`, `matrixFromColumns`, `matrixFromFunction`, `zeros`] }, onesDocs = { name: `ones`, category: `Matrix`, syntax: [`ones(m)`, `ones(m, n)`, `ones(m, n, p, ...)`, `ones([m])`, `ones([m, n])`, `ones([m, n, p, ...])`], description: `Create a matrix containing ones.`, examples: [`ones(3)`, `ones(3, 5)`, `ones([2,3]) * 4.5`, `a = [1, 2, 3; 4, 5, 6]`, `ones(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, partitionSelectDocs = { name: `partitionSelect`, category: `Matrix`, syntax: [`partitionSelect(x, k)`, `partitionSelect(x, k, compare)`], description: `Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.`, examples: [`partitionSelect([5, 10, 1], 2)`, `partitionSelect(["C", "B", "A", "D"], 1, compareText)`, `arr = [5, 2, 1]`, `partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]`, `arr`, `partitionSelect(arr, 1, 'desc') # returns 2, arr is now: [5, 2, 1]`, `arr`], seealso: [`sort`] }, rangeDocs = { name: `range`, category: `Type`, syntax: [`start:end`, `start:step:end`, `range(start, end)`, `range(start, end, step)`, `range(string)`], description: `Create a range. Lower bound of the range is included, upper bound is excluded.`, examples: [`1:5`, `3:-1:-3`, `range(3, 7)`, `range(0, 12, 2)`, `range("4:10")`, `range(1m, 1m, 3m)`, `a = [1, 2, 3, 4; 5, 6, 7, 8]`, `a[1:2, 1:2]`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `size`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, reshapeDocs = { name: `reshape`, category: `Matrix`, syntax: [`reshape(x, sizes)`], description: `Reshape a multi dimensional array to fit the specified dimensions.`, examples: [`reshape([1, 2, 3, 4, 5, 6], [2, 3])`, `reshape([[1, 2], [3, 4]], [1, 4])`, `reshape([[1, 2], [3, 4]], [4])`, `reshape([1, 2, 3, 4], [-1, 2])`], seealso: [`size`, `squeeze`, `resize`] }, resizeDocs = { name: `resize`, category: `Matrix`, syntax: [`resize(x, size)`, `resize(x, size, defaultValue)`], description: `Resize a matrix.`, examples: [`resize([1,2,3,4,5], [3])`, `resize([1,2,3], [5])`, `resize([1,2,3], [5], -1)`, `resize(2, [2, 3])`, `resize("hello", [8], "!")`], seealso: [`size`, `subset`, `squeeze`, `reshape`] }, rotateDocs = { name: `rotate`, category: `Matrix`, syntax: [`rotate(w, theta)`, `rotate(w, theta, v)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotate([1, 0], pi / 2)`, `rotate(matrix([1, 0]), unit("35deg"))`, `rotate([1, 0, 0], unit("90deg"), [0, 0, 1])`, `rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))`], seealso: [`matrix`, `rotationMatrix`] }, rotationMatrixDocs = { name: `rotationMatrix`, category: `Matrix`, syntax: [`rotationMatrix(theta)`, `rotationMatrix(theta, v)`, `rotationMatrix(theta, v, format)`], description: `Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.`, examples: [`rotationMatrix(pi / 2)`, `rotationMatrix(unit("45deg"), [0, 0, 1])`, `rotationMatrix(1, matrix([0, 0, 1]), "sparse")`], seealso: [`cos`, `sin`] }, rowDocs = { name: `row`, category: `Matrix`, syntax: [`row(x, index)`], description: `Return a row from a matrix or array.`, examples: [`A = [[1, 2], [3, 4]]`, `row(A, 1)`, `row(A, 2)`], seealso: [`column`, `matrixFromRows`] }, sizeDocs = { name: `size`, category: `Matrix`, syntax: [`size(x)`], description: `Calculate the size of a matrix.`, examples: [`size(2.3)`, `size("hello world")`, `a = [1, 2; 3, 4; 5, 6]`, `size(a)`, `size(1:6)`], seealso: [`concat`, `count`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `squeeze`, `subset`, `trace`, `transpose`, `zeros`] }, sortDocs = { name: `sort`, category: `Matrix`, syntax: [`sort(x)`, `sort(x, compare)`], description: `Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.`, examples: [`sort([5, 10, 1])`, `sort(["C", "B", "A", "D"], "natural")`, `sortByLength(a, b) = size(a)[1] - size(b)[1]`, `sort(["Langdon", "Tom", "Sara"], sortByLength)`, `sort(["10", "1", "2"], "natural")`], seealso: [`map`, `filter`, `forEach`] }, squeezeDocs = { name: `squeeze`, category: `Matrix`, syntax: [`squeeze(x)`], description: `Remove inner and outer singleton dimensions from a matrix.`, examples: [`a = zeros(3,2,1)`, `size(squeeze(a))`, `b = zeros(1,1,3)`, `size(squeeze(b))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `subset`, `trace`, `transpose`, `zeros`] }, subsetDocs = { name: `subset`, category: `Matrix`, syntax: [`value(index)`, `value(index) = replacement`, `subset(value, [index])`, `subset(value, [index], replacement)`], description: "Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.", examples: [`d = [1, 2; 3, 4]`, `e = []`, `e[1, 1:2] = [5, 6]`, `e[2, :] = [7, 8]`, `f = d * e`, `f[2, 1]`, `f[:, 1]`, `f[[1,2], [1,3]] = [9, 10; 11, 12]`, `f`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `trace`, `transpose`, `zeros`] }, traceDocs = { name: `trace`, category: `Matrix`, syntax: [`trace(A)`], description: `Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.`, examples: [`A = [1, 2, 3; -1, 2, 3; 2, 0, 3]`, `trace(A)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `transpose`, `zeros`] }, transposeDocs = { name: `transpose`, category: `Matrix`, syntax: [`x'`, `transpose(x)`], description: `Transpose a matrix`, examples: [`a = [1, 2, 3; 4, 5, 6]`, `a'`, `transpose(a)`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `zeros`] }, zerosDocs = { name: `zeros`, category: `Matrix`, syntax: [`zeros(m)`, `zeros(m, n)`, `zeros(m, n, p, ...)`, `zeros([m])`, `zeros([m, n])`, `zeros([m, n, p, ...])`], description: `Create a matrix containing zeros.`, examples: [`zeros(3)`, `zeros(3, 5)`, `a = [1, 2, 3; 4, 5, 6]`, `zeros(size(a))`], seealso: [`concat`, `det`, `diag`, `identity`, `inv`, `ones`, `range`, `size`, `squeeze`, `subset`, `trace`, `transpose`] }, fftDocs = { name: `fft`, category: `Matrix`, syntax: [`fft(x)`], description: `Calculate N-dimensional Fourier transform`, examples: [`fft([[1, 0], [1, 0]])`], seealso: [`ifft`] }, ifftDocs = { name: `ifft`, category: `Matrix`, syntax: [`ifft(x)`], description: `Calculate N-dimensional inverse Fourier transform`, examples: [`ifft([[2, 2], [0, 0]])`], seealso: [`fft`] }, bernoulliDocs = { name: `bernoulli`, category: `Probability`, syntax: [`bernoulli(n)`], description: `The nth Bernoulli number`, examples: [`bernoulli(4)`, `bernoulli(fraction(12))`], seealso: [`combinations`, `gamma`, `stirlingS2`] }, combinationsDocs = { name: `combinations`, category: `Probability`, syntax: [`combinations(n, k)`], description: `Compute the number of combinations of n items taken k at a time`, examples: [`combinations(7, 5)`], seealso: [`combinationsWithRep`, `permutations`, `factorial`] }, combinationsWithRepDocs = { name: `combinationsWithRep`, category: `Probability`, syntax: [`combinationsWithRep(n, k)`], description: `Compute the number of combinations of n items taken k at a time with replacements.`, examples: [`combinationsWithRep(7, 5)`], seealso: [`combinations`, `permutations`, `factorial`] }, factorialDocs = { name: `factorial`, category: `Probability`, syntax: [`n!`, `factorial(n)`], description: `Compute the factorial of a value`, examples: [`5!`, `5 * 4 * 3 * 2 * 1`, `3!`], seealso: [`combinations`, `combinationsWithRep`, `permutations`, `gamma`] }, gammaDocs = { name: `gamma`, category: `Probability`, syntax: [`gamma(n)`], description: `Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.`, examples: [`gamma(4)`, `3!`, `gamma(1/2)`, `sqrt(pi)`], seealso: [`factorial`] }, lgammaDocs = { name: `lgamma`, category: `Probability`, syntax: [`lgamma(n)`], description: `Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.`, examples: [`lgamma(4)`, `lgamma(1/2)`, `lgamma(i)`, `lgamma(complex(1.1, 2))`], seealso: [`gamma`] }, kldivergenceDocs = { name: `kldivergence`, category: `Probability`, syntax: [`kldivergence(x, y)`], description: `Calculate the Kullback-Leibler (KL) divergence  between two distributions.`, examples: [`kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])`], seealso: [] }, multinomialDocs = { name: `multinomial`, category: `Probability`, syntax: [`multinomial(A)`], description: "Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.", examples: [`multinomial([1, 2, 1])`], seealso: [`combinations`, `factorial`] }, permutationsDocs = { name: `permutations`, category: `Probability`, syntax: [`permutations(n)`, `permutations(n, k)`], description: `Compute the number of permutations of n items taken k at a time`, examples: [`permutations(5)`, `permutations(5, 3)`], seealso: [`combinations`, `combinationsWithRep`, `factorial`] }, pickRandomDocs = { name: `pickRandom`, category: `Probability`, syntax: [`pickRandom(array)`, `pickRandom(array, number)`, `pickRandom(array, weights)`, `pickRandom(array, number, weights)`, `pickRandom(array, weights, number)`], description: `Pick a random entry from a given array.`, examples: [`pickRandom(0:10)`, `pickRandom([1, 3, 1, 6])`, `pickRandom([1, 3, 1, 6], 2)`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])`, `pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)`], seealso: [`random`, `randomInt`] }, randomDocs = { name: `random`, category: `Probability`, syntax: [`random()`, `random(max)`, `random(min, max)`, `random(size)`, `random(size, max)`, `random(size, min, max)`], description: `Return a random number.`, examples: [`random()`, `random(10, 20)`, `random([2, 3])`], seealso: [`pickRandom`, `randomInt`] }, randomIntDocs = { name: `randomInt`, category: `Probability`, syntax: [`randomInt(max)`, `randomInt(min, max)`, `randomInt(size)`, `randomInt(size, max)`, `randomInt(size, min, max)`], description: `Return a random integer number`, examples: [`randomInt(10, 20)`, `randomInt([2, 3], 10)`], seealso: [`pickRandom`, `random`] }, compareDocs = { name: `compare`, category: `Relational`, syntax: [`compare(x, y)`], description: `Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compare(2, 3)`, `compare(3, 2)`, `compare(2, 2)`, `compare(5cm, 40mm)`, `compare(2, [1, 2, 3])`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compareNatural`, `compareText`] }, compareNaturalDocs = { name: `compareNatural`, category: `Relational`, syntax: [`compareNatural(x, y)`], description: `Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareNatural(2, 3)`, `compareNatural(3, 2)`, `compareNatural(2, 2)`, `compareNatural(5cm, 40mm)`, `compareNatural("2", "10")`, `compareNatural(2 + 3i, 2 + 4i)`, `compareNatural([1, 2, 4], [1, 2, 3])`, `compareNatural([1, 5], [1, 2, 3])`, `compareNatural([1, 2], [1, 2])`, `compareNatural({a: 2}, {a: 4})`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`, `compareText`] }, compareTextDocs = { name: `compareText`, category: `Relational`, syntax: [`compareText(x, y)`], description: `Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.`, examples: [`compareText("B", "A")`, `compareText("A", "B")`, `compareText("A", "A")`, `compareText("2", "10")`, `compare("2", "10")`, `compare(2, 10)`, `compareNatural("2", "10")`, `compareText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`] }, deepEqualDocs = { name: `deepEqual`, category: `Relational`, syntax: [`deepEqual(x, y)`], description: `Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.`, examples: [`deepEqual([1,3,4], [1,3,4])`, `deepEqual([1,3,4], [1,3])`], seealso: [`equal`, `unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`] }, equalDocs = { name: `equal`, category: `Relational`, syntax: [`x == y`, `equal(x, y)`], description: `Check equality of two values. Returns true if the values are equal, and false if not.`, examples: [`2+2 == 3`, `2+2 == 4`, `a = 3.2`, `b = 6-2.8`, `a == b`, `50cm == 0.5m`], seealso: [`unequal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`, `equalText`] }, equalTextDocs = { name: `equalText`, category: `Relational`, syntax: [`equalText(x, y)`], description: `Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.`, examples: [`equalText("Hello", "Hello")`, `equalText("a", "A")`, `equal("2e3", "2000")`, `equalText("2e3", "2000")`, `equalText("B", ["A", "B", "C"])`], seealso: [`compare`, `compareNatural`, `compareText`, `equal`] }, largerDocs = { name: `larger`, category: `Relational`, syntax: [`x > y`, `larger(x, y)`], description: `Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 > 3`, `5 > 2*2`, `a = 3.3`, `b = 6-2.8`, `(a > b)`, `(b < a)`, `5 cm > 2 inch`], seealso: [`equal`, `unequal`, `smaller`, `smallerEq`, `largerEq`, `compare`] }, largerEqDocs = { name: `largerEq`, category: `Relational`, syntax: [`x >= y`, `largerEq(x, y)`], description: `Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.`, examples: [`2 >= 1+1`, `2 > 1+1`, `a = 3.2`, `b = 6-2.8`, `(a >= b)`], seealso: [`equal`, `unequal`, `smallerEq`, `smaller`, `compare`] }, smallerDocs = { name: `smaller`, category: `Relational`, syntax: [`x < y`, `smaller(x, y)`], description: `Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.`, examples: [`2 < 3`, `5 < 2*2`, `a = 3.3`, `b = 6-2.8`, `(a < b)`, `5 cm < 2 inch`], seealso: [`equal`, `unequal`, `larger`, `smallerEq`, `largerEq`, `compare`] }, smallerEqDocs = { name: `smallerEq`, category: `Relational`, syntax: [`x <= y`, `smallerEq(x, y)`], description: `Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.`, examples: [`2 <= 1+1`, `2 < 1+1`, `a = 3.2`, `b = 6-2.8`, `(a <= b)`], seealso: [`equal`, `unequal`, `larger`, `smaller`, `largerEq`, `compare`] }, unequalDocs = { name: `unequal`, category: `Relational`, syntax: [`x != y`, `unequal(x, y)`], description: `Check unequality of two values. Returns true if the values are unequal, and false if they are equal.`, examples: [`2+2 != 3`, `2+2 != 4`, `a = 3.2`, `b = 6-2.8`, `a != b`, `50cm != 0.5m`, `5 cm != 2 inch`], seealso: [`equal`, `smaller`, `larger`, `smallerEq`, `largerEq`, `compare`, `deepEqual`] }, setCartesianDocs = { name: `setCartesian`, category: `Set`, syntax: [`setCartesian(set1, set2)`], description: `Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.`, examples: [`setCartesian([1, 2], [3, 4])`], seealso: [`setUnion`, `setIntersect`, `setDifference`, `setPowerset`] }, setDifferenceDocs = { name: `setDifference`, category: `Set`, syntax: [`setDifference(set1, set2)`], description: `Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setSymDifference`] }, setDistinctDocs = { name: `setDistinct`, category: `Set`, syntax: [`setDistinct(set)`], description: `Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setDistinct([1, 1, 1, 2, 2, 3])`], seealso: [`setMultiplicity`] }, setIntersectDocs = { name: `setIntersect`, category: `Set`, syntax: [`setIntersect(set1, set2)`], description: `Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIntersect([1, 2, 3, 4], [3, 4, 5, 6])`, `setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setDifference`] }, setIsSubsetDocs = { name: `setIsSubset`, category: `Set`, syntax: [`setIsSubset(set1, set2)`], description: `Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setIsSubset([1, 2], [3, 4, 5, 6])`, `setIsSubset([3, 4], [3, 4, 5, 6])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setMultiplicityDocs = { name: `setMultiplicity`, category: `Set`, syntax: [`setMultiplicity(element, set)`], description: `Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setMultiplicity(1, [1, 2, 2, 4])`, `setMultiplicity(2, [1, 2, 2, 4])`], seealso: [`setDistinct`, `setSize`] }, setPowersetDocs = { name: `setPowerset`, category: `Set`, syntax: [`setPowerset(set)`], description: `Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setPowerset([1, 2, 3])`], seealso: [`setCartesian`] }, setSizeDocs = { name: `setSize`, category: `Set`, syntax: [`setSize(set)`, `setSize(set, unique)`], description: `Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.`, examples: [`setSize([1, 2, 2, 4])`, `setSize([1, 2, 2, 4], true)`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setSymDifferenceDocs = { name: `setSymDifference`, category: `Set`, syntax: [`setSymDifference(set1, set2)`], description: `Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])`, `setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setUnion`, `setIntersect`, `setDifference`] }, setUnionDocs = { name: `setUnion`, category: `Set`, syntax: [`setUnion(set1, set2)`], description: `Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.`, examples: [`setUnion([1, 2, 3, 4], [3, 4, 5, 6])`, `setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])`], seealso: [`setIntersect`, `setDifference`] }, zpk2tfDocs = { name: `zpk2tf`, category: `Signal`, syntax: [`zpk2tf(z, p, k)`], description: `Compute the transfer function of a zero-pole-gain model.`, examples: [`zpk2tf([1, 2], [-1, -2], 1)`, `zpk2tf([1, 2], [-1, -2])`, `zpk2tf([1 - 3i, 2 + 2i], [-1, -2])`], seealso: [] }, freqzDocs = { name: `freqz`, category: `Signal`, syntax: [`freqz(b, a)`, `freqz(b, a, w)`], description: `Calculates the frequency response of a filter given its numerator and denominator coefficients.`, examples: [`freqz([1, 2], [1, 2, 3])`, `freqz([1, 2], [1, 2, 3], [0, 1])`, `freqz([1, 2], [1, 2, 3], 512)`], seealso: [] }, erfDocs = { name: `erf`, category: `Special`, syntax: [`erf(x)`], description: `Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x`, examples: [`erf(0.2)`, `erf(-0.5)`, `erf(4)`], seealso: [] }, zetaDocs = { name: `zeta`, category: `Special`, syntax: [`zeta(s)`], description: `Compute the Riemann Zeta Function using an infinite series and Riemann's Functional Equation for the entire complex plane`, examples: [`zeta(0.2)`, `zeta(-0.5)`, `zeta(4)`], seealso: [] }, madDocs = { name: `mad`, category: `Statistics`, syntax: [`mad(a, b, c, ...)`, `mad(A)`], description: `Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.`, examples: [`mad(10, 20, 30)`, `mad([1, 2, 3])`], seealso: [`mean`, `median`, `std`, `abs`] }, maxDocs = { name: `max`, category: `Statistics`, syntax: [`max(a, b, c, ...)`, `max(A)`, `max(A, dimension)`], description: `Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`max(2, 3, 4, 1)`, `max([2, 3, 4, 1])`, `max([2, 5; 4, 3])`, `max([2, 5; 4, 3], 1)`, `max([2, 5; 4, 3], 2)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, meanDocs = { name: `mean`, category: `Statistics`, syntax: [`mean(a, b, c, ...)`, `mean(A)`, `mean(A, dimension)`], description: `Compute the arithmetic mean of a list of values.`, examples: [`mean(2, 3, 4, 1)`, `mean([2, 3, 4, 1])`, `mean([2, 5; 4, 3])`, `mean([2, 5; 4, 3], 1)`, `mean([2, 5; 4, 3], 2)`, `mean([1.0, 2.7, 3.2, 4.0])`], seealso: [`max`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, medianDocs = { name: `median`, category: `Statistics`, syntax: [`median(a, b, c, ...)`, `median(A)`], description: `Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.`, examples: [`median(5, 2, 7)`, `median([3, -1, 5, 7])`], seealso: [`max`, `mean`, `min`, `prod`, `std`, `sum`, `variance`, `quantileSeq`] }, minDocs = { name: `min`, category: `Statistics`, syntax: [`min(a, b, c, ...)`, `min(A)`, `min(A, dimension)`], description: `Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.`, examples: [`min(2, 3, 4, 1)`, `min([2, 3, 4, 1])`, `min([2, 5; 4, 3])`, `min([2, 5; 4, 3], 1)`, `min([2, 5; 4, 3], 2)`, `min(2.7, 7.1, -4.5, 2.0, 4.1)`, `max(2.7, 7.1, -4.5, 2.0, 4.1)`], seealso: [`max`, `mean`, `median`, `prod`, `std`, `sum`, `variance`] }, modeDocs = { name: `mode`, category: `Statistics`, syntax: [`mode(a, b, c, ...)`, `mode(A)`, `mode(A, a, b, B, c, ...)`], description: `Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.`, examples: [`mode(2, 1, 4, 3, 1)`, `mode([1, 2.7, 3.2, 4, 2.7])`, `mode(1, 4, 6, 1, 6)`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `std`, `sum`, `variance`] }, prodDocs = { name: `prod`, category: `Statistics`, syntax: [`prod(a, b, c, ...)`, `prod(A)`], description: `Compute the product of all values.`, examples: [`prod(2, 3, 4)`, `prod([2, 3, 4])`, `prod([2, 5; 4, 3])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `std`, `sum`, `variance`] }, quantileSeqDocs = { name: `quantileSeq`, category: `Statistics`, syntax: [`quantileSeq(A, prob[, sorted])`, `quantileSeq(A, [prob1, prob2, ...][, sorted])`, `quantileSeq(A, N[, sorted])`], description: `Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. 

In case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`, examples: [`quantileSeq([3, -1, 5, 7], 0.5)`, `quantileSeq([3, -1, 5, 7], [1/3, 2/3])`, `quantileSeq([3, -1, 5, 7], 2)`, `quantileSeq([-1, 3, 5, 7], 0.5, true)`], seealso: [`mean`, `median`, `min`, `max`, `prod`, `std`, `sum`, `variance`] }, stdDocs = { name: `std`, category: `Statistics`, syntax: [`std(a, b, c, ...)`, `std(A)`, `std(A, dimension)`, `std(A, normalization)`, `std(A, dimension, normalization)`], description: `Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`std(2, 4, 6)`, `std([2, 4, 6, 8])`, `std([2, 4, 6, 8], "uncorrected")`, `std([2, 4, 6, 8], "biased")`, `std([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `prod`, `sum`, `variance`] }, cumSumDocs = { name: `cumsum`, category: `Statistics`, syntax: [`cumsum(a, b, c, ...)`, `cumsum(A)`], description: `Compute the cumulative sum of all values.`, examples: [`cumsum(2, 3, 4, 1)`, `cumsum([2, 3, 4, 1])`, `cumsum([1, 2; 3, 4])`, `cumsum([1, 2; 3, 4], 1)`, `cumsum([1, 2; 3, 4], 2)`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `sum`, `variance`] }, sumDocs = { name: `sum`, category: `Statistics`, syntax: [`sum(a, b, c, ...)`, `sum(A)`, `sum(A, dimension)`], description: `Compute the sum of all values.`, examples: [`sum(2, 3, 4, 1)`, `sum([2, 3, 4, 1])`, `sum([2, 5; 4, 3])`], seealso: [`max`, `mean`, `median`, `min`, `prod`, `std`, `variance`] }, varianceDocs = { name: `variance`, category: `Statistics`, syntax: [`variance(a, b, c, ...)`, `variance(A)`, `variance(A, dimension)`, `variance(A, normalization)`, `variance(A, dimension, normalization)`], description: `Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".`, examples: [`variance(2, 4, 6)`, `variance([2, 4, 6, 8])`, `variance([2, 4, 6, 8], "uncorrected")`, `variance([2, 4, 6, 8], "biased")`, `variance([1, 2, 3; 4, 5, 6])`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, corrDocs = { name: `corr`, category: `Statistics`, syntax: [`corr(A,B)`], description: `Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.`, examples: [`corr([2, 4, 6, 8],[1, 2, 3, 6])`, `corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))`], seealso: [`max`, `mean`, `min`, `median`, `min`, `prod`, `std`, `sum`] }, acosDocs = { name: `acos`, category: `Trigonometry`, syntax: [`acos(x)`], description: `Compute the inverse cosine of a value in radians.`, examples: [`acos(0.5)`, `acos(cos(2.3))`], seealso: [`cos`, `atan`, `asin`] }, acoshDocs = { name: `acosh`, category: `Trigonometry`, syntax: [`acosh(x)`], description: "Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.", examples: [`acosh(1.5)`], seealso: [`cosh`, `asinh`, `atanh`] }, acotDocs = { name: `acot`, category: `Trigonometry`, syntax: [`acot(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acot(0.5)`, `acot(cot(0.5))`, `acot(2)`], seealso: [`cot`, `atan`] }, acothDocs = { name: `acoth`, category: `Trigonometry`, syntax: [`acoth(x)`], description: "Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.", examples: [`acoth(2)`, `acoth(0.5)`], seealso: [`acsch`, `asech`] }, acscDocs = { name: `acsc`, category: `Trigonometry`, syntax: [`acsc(x)`], description: `Calculate the inverse cotangent of a value.`, examples: [`acsc(2)`, `acsc(csc(0.5))`, `acsc(0.5)`], seealso: [`csc`, `asin`, `asec`] }, acschDocs = { name: `acsch`, category: `Trigonometry`, syntax: [`acsch(x)`], description: "Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.", examples: [`acsch(0.5)`], seealso: [`asech`, `acoth`] }, asecDocs = { name: `asec`, category: `Trigonometry`, syntax: [`asec(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asec(0.5)`, `asec(sec(0.5))`, `asec(2)`], seealso: [`acos`, `acot`, `acsc`] }, asechDocs = { name: `asech`, category: `Trigonometry`, syntax: [`asech(x)`], description: `Calculate the inverse secant of a value.`, examples: [`asech(0.5)`], seealso: [`acsch`, `acoth`] }, asinDocs = { name: `asin`, category: `Trigonometry`, syntax: [`asin(x)`], description: `Compute the inverse sine of a value in radians.`, examples: [`asin(0.5)`, `asin(sin(0.5))`], seealso: [`sin`, `acos`, `atan`] }, asinhDocs = { name: `asinh`, category: `Trigonometry`, syntax: [`asinh(x)`], description: "Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.", examples: [`asinh(0.5)`], seealso: [`acosh`, `atanh`] }, atanDocs = { name: `atan`, category: `Trigonometry`, syntax: [`atan(x)`], description: `Compute the inverse tangent of a value in radians.`, examples: [`atan(0.5)`, `atan(tan(0.5))`], seealso: [`tan`, `acos`, `asin`] }, atan2Docs = { name: `atan2`, category: `Trigonometry`, syntax: [`atan2(y, x)`], description: `Computes the principal value of the arc tangent of y/x in radians.`, examples: [`atan2(2, 2) / pi`, `angle = 60 deg in rad`, `x = cos(angle)`, `y = sin(angle)`, `atan2(y, x)`], seealso: [`sin`, `cos`, `tan`] }, atanhDocs = { name: `atanh`, category: `Trigonometry`, syntax: [`atanh(x)`], description: "Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.", examples: [`atanh(0.5)`], seealso: [`acosh`, `asinh`] }, cosDocs = { name: `cos`, category: `Trigonometry`, syntax: [`cos(x)`], description: `Compute the cosine of x in radians.`, examples: [`cos(2)`, `cos(pi / 4) ^ 2`, `cos(180 deg)`, `cos(60 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`acos`, `sin`, `tan`] }, coshDocs = { name: `cosh`, category: `Trigonometry`, syntax: [`cosh(x)`], description: `Compute the hyperbolic cosine of x in radians.`, examples: [`cosh(0.5)`], seealso: [`sinh`, `tanh`, `coth`] }, cotDocs = { name: `cot`, category: `Trigonometry`, syntax: [`cot(x)`], description: `Compute the cotangent of x in radians. Defined as 1/tan(x)`, examples: [`cot(2)`, `1 / tan(2)`], seealso: [`sec`, `csc`, `tan`] }, cothDocs = { name: `coth`, category: `Trigonometry`, syntax: [`coth(x)`], description: `Compute the hyperbolic cotangent of x in radians.`, examples: [`coth(2)`, `1 / tanh(2)`], seealso: [`sech`, `csch`, `tanh`] }, cscDocs = { name: `csc`, category: `Trigonometry`, syntax: [`csc(x)`], description: `Compute the cosecant of x in radians. Defined as 1/sin(x)`, examples: [`csc(2)`, `1 / sin(2)`], seealso: [`sec`, `cot`, `sin`] }, cschDocs = { name: `csch`, category: `Trigonometry`, syntax: [`csch(x)`], description: `Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)`, examples: [`csch(2)`, `1 / sinh(2)`], seealso: [`sech`, `coth`, `sinh`] }, secDocs = { name: `sec`, category: `Trigonometry`, syntax: [`sec(x)`], description: `Compute the secant of x in radians. Defined as 1/cos(x)`, examples: [`sec(2)`, `1 / cos(2)`], seealso: [`cot`, `csc`, `cos`] }, sechDocs = { name: `sech`, category: `Trigonometry`, syntax: [`sech(x)`], description: `Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)`, examples: [`sech(2)`, `1 / cosh(2)`], seealso: [`coth`, `csch`, `cosh`] }, sinDocs = { name: `sin`, category: `Trigonometry`, syntax: [`sin(x)`], description: `Compute the sine of x in radians.`, examples: [`sin(2)`, `sin(pi / 4) ^ 2`, `sin(90 deg)`, `sin(30 deg)`, `sin(0.2)^2 + cos(0.2)^2`], seealso: [`asin`, `cos`, `tan`] }, sinhDocs = { name: `sinh`, category: `Trigonometry`, syntax: [`sinh(x)`], description: `Compute the hyperbolic sine of x in radians.`, examples: [`sinh(0.5)`], seealso: [`cosh`, `tanh`] }, tanDocs = { name: `tan`, category: `Trigonometry`, syntax: [`tan(x)`], description: `Compute the tangent of x in radians.`, examples: [`tan(0.5)`, `sin(0.5) / cos(0.5)`, `tan(pi / 4)`, `tan(45 deg)`], seealso: [`atan`, `sin`, `cos`] }, tanhDocs = { name: `tanh`, category: `Trigonometry`, syntax: [`tanh(x)`], description: `Compute the hyperbolic tangent of x in radians.`, examples: [`tanh(0.5)`, `sinh(0.5) / cosh(0.5)`], seealso: [`sinh`, `cosh`] }, toDocs = { name: `to`, category: `Units`, syntax: [`x to unit`, `to(x, unit)`], description: `Change the unit of a value.`, examples: [`5 inch to cm`, `3.2kg to g`, `16 bytes in bits`], seealso: [] }, toBestDocs = { name: `toBest`, category: `Units`, syntax: [`toBest(x)`, `toBest(x, unitList)`, `toBest(x, unitList, options)`], description: `Converts to the most appropriate display unit.`, examples: [`toBest(unit(5000, "m"))`, `toBest(unit(3500000, "W"))`, `toBest(unit(0.000000123, "A"))`, `toBest(unit(10, "m"), "cm")`, `toBest(unit(10, "m"), "mm,km", {offset: 1.5})`], seealso: [] }, binDocs = { name: `bin`, category: `Utils`, syntax: [`bin(value)`], description: `Format a number as binary`, examples: [`bin(2)`], seealso: [`oct`, `hex`] }, cloneDocs = { name: `clone`, category: `Utils`, syntax: [`clone(x)`], description: `Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices`, examples: [`clone(3.5)`, `clone(2 - 4i)`, `clone(45 deg)`, `clone([1, 2; 3, 4])`, `clone("hello world")`], seealso: [] }, formatDocs = { name: `format`, category: `Utils`, syntax: [`format(value)`, `format(value, precision)`], description: `Format a value of any type as string.`, examples: [`format(2.3)`, `format(3 - 4i)`, `format([])`, `format(pi, 3)`], seealso: [`print`] }, hasNumericValueDocs = { name: `hasNumericValue`, category: `Utils`, syntax: [`hasNumericValue(x)`], description: `Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.`, examples: [`hasNumericValue(2)`, `hasNumericValue("2")`, `isNumeric("2")`, `hasNumericValue(0)`, `hasNumericValue(bignumber(500))`, `hasNumericValue(fraction(0.125))`, `hasNumericValue(2 + 3i)`, `hasNumericValue([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `isNumeric`] }, hexDocs = { name: `hex`, category: `Utils`, syntax: [`hex(value)`], description: `Format a number as hexadecimal`, examples: [`hex(240)`], seealso: [`bin`, `oct`] }, isIntegerDocs = { name: `isInteger`, category: `Utils`, syntax: [`isInteger(x)`], description: `Test whether a value is an integer number.`, examples: [`isInteger(2)`, `isInteger(3.5)`, `isInteger([3, 0.5, -2])`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`] }, isNaNDocs = { name: `isNaN`, category: `Utils`, syntax: [`isNaN(x)`], description: `Test whether a value is NaN (not a number)`, examples: [`isNaN(2)`, `isNaN(0 / 0)`, `isNaN(NaN)`, `isNaN(Infinity)`], seealso: [`isNegative`, `isNumeric`, `isPositive`, `isZero`, `isFinite`, `isBounded`] }, isBoundedDocs = { name: `isBounded`, category: `Utils`, syntax: [`isBounded(x)`], description: `Test whether a value or its entries are bounded.`, examples: [`isBounded(Infinity)`, `isBounded(bigint(3))`, `isBounded([3, -Infinity, -3])`], seealso: [`isFinite`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isFiniteDocs = { name: `isFinite`, category: `Utils`, syntax: [`isFinite(x)`], description: `Test whether a value is finite, elementwise on collections.`, examples: [`isFinite(Infinity)`, `isFinite(bigint(3))`, `isFinite([3, -Infinity, -3])`], seealso: [`isBounded`, `isNumeric`, `isNaN`, `isNegative`, `isPositive`] }, isNegativeDocs = { name: `isNegative`, category: `Utils`, syntax: [`isNegative(x)`], description: `Test whether a value is negative: smaller than zero.`, examples: [`isNegative(2)`, `isNegative(0)`, `isNegative(-4)`, `isNegative([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isPositive`, `isZero`] }, isNumericDocs = { name: `isNumeric`, category: `Utils`, syntax: [`isNumeric(x)`], description: `Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.`, examples: [`isNumeric(2)`, `isNumeric("2")`, `hasNumericValue("2")`, `isNumeric(0)`, `isNumeric(bignumber(500))`, `isNumeric(fraction(0.125))`, `isNumeric(2 + 3i)`, `isNumeric([2.3, "foo", false])`], seealso: [`isInteger`, `isZero`, `isNegative`, `isPositive`, `isNaN`, `hasNumericValue`, `isFinite`, `isBounded`] }, isPositiveDocs = { name: `isPositive`, category: `Utils`, syntax: [`isPositive(x)`], description: `Test whether a value is positive: larger than zero.`, examples: [`isPositive(2)`, `isPositive(0)`, `isPositive(-4)`, `isPositive([3, 0.5, -2])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isPrimeDocs = { name: `isPrime`, category: `Utils`, syntax: [`isPrime(x)`], description: `Test whether a value is prime: has no divisors other than itself and one.`, examples: [`isPrime(3)`, `isPrime(-2)`, `isPrime([2, 17, 100])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isZero`] }, isZeroDocs = { name: `isZero`, category: `Utils`, syntax: [`isZero(x)`], description: `Test whether a value is zero.`, examples: [`isZero(2)`, `isZero(0)`, `isZero(-4)`, `isZero([3, 0, -2, 0])`], seealso: [`isInteger`, `isNumeric`, `isNegative`, `isPositive`] }, numericDocs = { name: `numeric`, category: `Utils`, syntax: [`numeric(x)`], description: `Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.`, examples: [`numeric("4")`, `numeric("4", "number")`, `numeric("4", "bigint")`, `numeric("4", "BigNumber")`, `numeric("4", "Fraction")`, `numeric(4, "Fraction")`, `numeric(fraction(2, 5), "number")`], seealso: [`number`, `bigint`, `fraction`, `bignumber`, `string`, `format`] }, octDocs = { name: `oct`, category: `Utils`, syntax: [`oct(value)`], description: `Format a number as octal`, examples: [`oct(56)`], seealso: [`bin`, `hex`] }, printDocs = { name: `print`, category: `Utils`, syntax: [`print(template, values)`, `print(template, values, precision)`], description: `Interpolate values into a string template.`, examples: [`print("Lucy is $age years old", {age: 5})`, `print("The value of pi is $pi", {pi: pi}, 3)`, `print("Hello, $user.name!", {user: {name: "John"}})`, `print("Values: $1, $2, $3", [6, 9, 4])`], seealso: [`format`] }, typeOfDocs = { name: `typeOf`, category: `Utils`, syntax: [`typeOf(x)`], description: `Get the type of a variable.`, examples: [`typeOf(3.5)`, `typeOf(2 - 4i)`, `typeOf(45 deg)`, `typeOf("hello world")`], seealso: [`getMatrixDataType`] }, solveODEDocs = { name: `solveODE`, category: `Numeric`, syntax: [`solveODE(func, tspan, y0)`, `solveODE(func, tspan, y0, options)`], description: `Numerical Integration of Ordinary Differential Equations.`, examples: [`f(t,y) = y`, `tspan = [0, 4]`, `solveODE(f, tspan, 1)`, `solveODE(f, tspan, [1, 2])`, `solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })`], seealso: [`derivative`, `simplifyCore`] }, embeddedDocs = { bignumber: bignumberDocs, bigint: bigintDocs, boolean: booleanDocs, complex: complexDocs, createUnit: createUnitDocs, fraction: fractionDocs, index: indexDocs, matrix: matrixDocs, number: numberDocs, sparse: sparseDocs, splitUnit: splitUnitDocs, string: stringDocs, unit: unitDocs, e: eDocs, E: eDocs, false: falseDocs, i: iDocs, Infinity: InfinityDocs, LN2: LN2Docs, LN10: LN10Docs, LOG2E: LOG2EDocs, LOG10E: LOG10EDocs, NaN: NaNDocs, null: nullDocs, pi: piDocs, PI: piDocs, phi: phiDocs, SQRT1_2: SQRT12Docs, SQRT2: SQRT2Docs, tau: tauDocs, true: trueDocs, version: versionDocs, speedOfLight: { description: `Speed of light in vacuum`, examples: [`speedOfLight`] }, gravitationConstant: { description: `Newtonian constant of gravitation`, examples: [`gravitationConstant`] }, planckConstant: { description: `Planck constant`, examples: [`planckConstant`] }, reducedPlanckConstant: { description: `Reduced Planck constant`, examples: [`reducedPlanckConstant`] }, magneticConstant: { description: `Magnetic constant (vacuum permeability)`, examples: [`magneticConstant`] }, electricConstant: { description: `Electric constant (vacuum permeability)`, examples: [`electricConstant`] }, vacuumImpedance: { description: `Characteristic impedance of vacuum`, examples: [`vacuumImpedance`] }, coulomb: { description: `Coulomb's constant. Deprecated in favor of coulombConstant`, examples: [`coulombConstant`] }, coulombConstant: { description: `Coulomb's constant`, examples: [`coulombConstant`] }, elementaryCharge: { description: `Elementary charge`, examples: [`elementaryCharge`] }, bohrMagneton: { description: `Bohr magneton`, examples: [`bohrMagneton`] }, conductanceQuantum: { description: `Conductance quantum`, examples: [`conductanceQuantum`] }, inverseConductanceQuantum: { description: `Inverse conductance quantum`, examples: [`inverseConductanceQuantum`] }, magneticFluxQuantum: { description: `Magnetic flux quantum`, examples: [`magneticFluxQuantum`] }, nuclearMagneton: { description: `Nuclear magneton`, examples: [`nuclearMagneton`] }, klitzing: { description: `Von Klitzing constant`, examples: [`klitzing`] }, bohrRadius: { description: `Bohr radius`, examples: [`bohrRadius`] }, classicalElectronRadius: { description: `Classical electron radius`, examples: [`classicalElectronRadius`] }, electronMass: { description: `Electron mass`, examples: [`electronMass`] }, fermiCoupling: { description: `Fermi coupling constant`, examples: [`fermiCoupling`] }, fineStructure: { description: `Fine-structure constant`, examples: [`fineStructure`] }, hartreeEnergy: { description: `Hartree energy`, examples: [`hartreeEnergy`] }, protonMass: { description: `Proton mass`, examples: [`protonMass`] }, deuteronMass: { description: `Deuteron Mass`, examples: [`deuteronMass`] }, neutronMass: { description: `Neutron mass`, examples: [`neutronMass`] }, quantumOfCirculation: { description: `Quantum of circulation`, examples: [`quantumOfCirculation`] }, rydberg: { description: `Rydberg constant`, examples: [`rydberg`] }, thomsonCrossSection: { description: `Thomson cross section`, examples: [`thomsonCrossSection`] }, weakMixingAngle: { description: `Weak mixing angle`, examples: [`weakMixingAngle`] }, efimovFactor: { description: `Efimov factor`, examples: [`efimovFactor`] }, atomicMass: { description: `Atomic mass constant`, examples: [`atomicMass`] }, avogadro: { description: `Avogadro's number`, examples: [`avogadro`] }, boltzmann: { description: `Boltzmann constant`, examples: [`boltzmann`] }, faraday: { description: `Faraday constant`, examples: [`faraday`] }, firstRadiation: { description: `First radiation constant`, examples: [`firstRadiation`] }, loschmidt: { description: `Loschmidt constant at T=273.15 K and p=101.325 kPa`, examples: [`loschmidt`] }, gasConstant: { description: `Gas constant`, examples: [`gasConstant`] }, molarPlanckConstant: { description: `Molar Planck constant`, examples: [`molarPlanckConstant`] }, molarVolume: { description: `Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa`, examples: [`molarVolume`] }, sackurTetrode: { description: `Sackur-Tetrode constant at T=1 K and p=101.325 kPa`, examples: [`sackurTetrode`] }, secondRadiation: { description: `Second radiation constant`, examples: [`secondRadiation`] }, stefanBoltzmann: { description: `Stefan-Boltzmann constant`, examples: [`stefanBoltzmann`] }, wienDisplacement: { description: `Wien displacement law constant`, examples: [`wienDisplacement`] }, molarMass: { description: `Molar mass constant`, examples: [`molarMass`] }, molarMassC12: { description: `Molar mass constant of carbon-12`, examples: [`molarMassC12`] }, gravity: { description: `Standard acceleration of gravity (standard acceleration of free-fall on Earth)`, examples: [`gravity`] }, planckLength: { description: `Planck length`, examples: [`planckLength`] }, planckMass: { description: `Planck mass`, examples: [`planckMass`] }, planckTime: { description: `Planck time`, examples: [`planckTime`] }, planckCharge: { description: `Planck charge`, examples: [`planckCharge`] }, planckTemperature: { description: `Planck temperature`, examples: [`planckTemperature`] }, derivative: derivativeDocs, lsolve: lsolveDocs, lsolveAll: lsolveAllDocs, lup: lupDocs, lusolve: lusolveDocs, leafCount: leafCountDocs, polynomialRoot: polynomialRootDocs, resolve: resolveDocs, simplify: simplifyDocs, simplifyConstant: simplifyConstantDocs, simplifyCore: simplifyCoreDocs, symbolicEqual: symbolicEqualDocs, rationalize: rationalizeDocs, slu: sluDocs, usolve: usolveDocs, usolveAll: usolveAllDocs, qr: qrDocs, abs: absDocs, add: addDocs, cbrt: cbrtDocs, ceil: ceilDocs, cube: cubeDocs, divide: divideDocs, dotDivide: dotDivideDocs, dotMultiply: dotMultiplyDocs, dotPow: dotPowDocs, exp: expDocs, expm: expmDocs, expm1: expm1Docs, fix: fixDocs, floor: floorDocs, gcd: gcdDocs, hypot: hypotDocs, lcm: lcmDocs, log: logDocs, log2: log2Docs, log1p: log1pDocs, log10: log10Docs, mod: modDocs, multiply: multiplyDocs, norm: normDocs, nthRoot: nthRootDocs, nthRoots: nthRootsDocs, pow: powDocs, round: roundDocs, sign: signDocs, sqrt: sqrtDocs, sqrtm: sqrtmDocs, square: squareDocs, subtract: subtractDocs, unaryMinus: unaryMinusDocs, unaryPlus: unaryPlusDocs, xgcd: xgcdDocs, invmod: invmodDocs, num: numDocs, den: denDocs, bitAnd: bitAndDocs, bitNot: bitNotDocs, bitOr: bitOrDocs, bitXor: bitXorDocs, leftShift: leftShiftDocs, rightArithShift: rightArithShiftDocs, rightLogShift: rightLogShiftDocs, bellNumbers: bellNumbersDocs, catalan: catalanDocs, composition: compositionDocs, stirlingS2: stirlingS2Docs, config: configDocs, import: importDocs, typed: typedDocs, arg: argDocs, conj: conjDocs, re: reDocs, im: imDocs, evaluate: evaluateDocs, help: helpDocs, parse: parseDocs, parser: parserDocs, compile: compileDocs, distance: distanceDocs, intersect: intersectDocs, and: andDocs, not: notDocs, nullish: nullishDocs, or: orDocs, xor: xorDocs, mapSlices: mapSlicesDocs, concat: concatDocs, count: countDocs, cross: crossDocs, column: columnDocs, ctranspose: ctransposeDocs, det: detDocs, diag: diagDocs, diff: diffDocs, dot: dotDocs, getMatrixDataType: getMatrixDataTypeDocs, identity: identityDocs, filter: filterDocs, flatten: flattenDocs, forEach: forEachDocs, inv: invDocs, pinv: pinvDocs, eigs: eigsDocs, kron: kronDocs, matrixFromFunction: matrixFromFunctionDocs, matrixFromRows: matrixFromRowsDocs, matrixFromColumns: matrixFromColumnsDocs, map: mapDocs, ones: onesDocs, partitionSelect: partitionSelectDocs, range: rangeDocs, resize: resizeDocs, reshape: reshapeDocs, rotate: rotateDocs, rotationMatrix: rotationMatrixDocs, row: rowDocs, size: sizeDocs, sort: sortDocs, squeeze: squeezeDocs, subset: subsetDocs, trace: traceDocs, transpose: transposeDocs, zeros: zerosDocs, fft: fftDocs, ifft: ifftDocs, sylvester: sylvesterDocs, schur: schurDocs, lyap: lyapDocs, solveODE: solveODEDocs, bernoulli: bernoulliDocs, combinations: combinationsDocs, combinationsWithRep: combinationsWithRepDocs, factorial: factorialDocs, gamma: gammaDocs, kldivergence: kldivergenceDocs, lgamma: lgammaDocs, multinomial: multinomialDocs, permutations: permutationsDocs, pickRandom: pickRandomDocs, random: randomDocs, randomInt: randomIntDocs, compare: compareDocs, compareNatural: compareNaturalDocs, compareText: compareTextDocs, deepEqual: deepEqualDocs, equal: equalDocs, equalText: equalTextDocs, larger: largerDocs, largerEq: largerEqDocs, smaller: smallerDocs, smallerEq: smallerEqDocs, unequal: unequalDocs, setCartesian: setCartesianDocs, setDifference: setDifferenceDocs, setDistinct: setDistinctDocs, setIntersect: setIntersectDocs, setIsSubset: setIsSubsetDocs, setMultiplicity: setMultiplicityDocs, setPowerset: setPowersetDocs, setSize: setSizeDocs, setSymDifference: setSymDifferenceDocs, setUnion: setUnionDocs, zpk2tf: zpk2tfDocs, freqz: freqzDocs, erf: erfDocs, zeta: zetaDocs, cumsum: cumSumDocs, mad: madDocs, max: maxDocs, mean: meanDocs, median: medianDocs, min: minDocs, mode: modeDocs, prod: prodDocs, quantileSeq: quantileSeqDocs, std: stdDocs, sum: sumDocs, variance: varianceDocs, corr: corrDocs, acos: acosDocs, acosh: acoshDocs, acot: acotDocs, acoth: acothDocs, acsc: acscDocs, acsch: acschDocs, asec: asecDocs, asech: asechDocs, asin: asinDocs, asinh: asinhDocs, atan: atanDocs, atanh: atanhDocs, atan2: atan2Docs, cos: cosDocs, cosh: coshDocs, cot: cotDocs, coth: cothDocs, csc: cscDocs, csch: cschDocs, sec: secDocs, sech: sechDocs, sin: sinDocs, sinh: sinhDocs, tan: tanDocs, tanh: tanhDocs, to: toDocs, toBest: toBestDocs, clone: cloneDocs, format: formatDocs, bin: binDocs, oct: octDocs, hex: hexDocs, isNaN: isNaNDocs, isBounded: isBoundedDocs, isFinite: isFiniteDocs, isInteger: isIntegerDocs, isNegative: isNegativeDocs, isNumeric: isNumericDocs, hasNumericValue: hasNumericValueDocs, isPositive: isPositiveDocs, isPrime: isPrimeDocs, isZero: isZeroDocs, print: printDocs, typeOf: typeOfDocs, numeric: numericDocs }, name$79 = `help`, dependencies$79 = [`typed`, `mathWithTransform`, `Help`], createHelp = factory(name$79, dependencies$79, (t4) => {
  var { typed: n2, mathWithTransform: r2, Help: i2 } = t4;
  return n2(name$79, { any: function(t5) {
    var n3, a2 = t5;
    if (typeof t5 != `string`) {
      for (n3 in r2) if (hasOwnProperty$1$1(r2, n3) && t5 === r2[n3]) {
        a2 = n3;
        break;
      }
    }
    var o2 = getSafeProperty(embeddedDocs, a2);
    if (!o2) {
      var s2 = typeof a2 == `function` ? a2.name : a2;
      throw Error(`No documentation found on "` + s2 + `"`);
    }
    return new i2(o2);
  } });
}), name$78 = `chain`, dependencies$78 = [`typed`, `Chain`], createChain = factory(name$78, dependencies$78, (t4) => {
  var { typed: n2, Chain: r2 } = t4;
  return n2(name$78, { "": function() {
    return new r2();
  }, any: function(t5) {
    return new r2(t5);
  } });
}), name$77 = `det`, dependencies$77 = [`typed`, `matrix`, `subtractScalar`, `multiply`, `divideScalar`, `isZero`, `unaryMinus`], createDet = factory(name$77, dependencies$77, (t4) => {
  var { typed: n2, matrix: r2, subtractScalar: i2, multiply: a2, divideScalar: o2, isZero: s2, unaryMinus: c2 } = t4;
  return n2(name$77, { any: function(t5) {
    return clone$3(t5);
  }, "Array | Matrix": function(t5) {
    var n3;
    switch (isMatrix(t5) ? n3 = t5.size() : Array.isArray(t5) ? (t5 = r2(t5), n3 = t5.size()) : n3 = [], n3.length) {
      case 0:
        return clone$3(t5);
      case 1:
        if (n3[0] === 1) return clone$3(t5.valueOf()[0]);
        if (n3[0] === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      case 2:
        var i3 = n3[0], a3 = n3[1];
        if (i3 === a3) return l2(t5.clone().valueOf(), i3);
        if (a3 === 0) return 1;
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format(n3) + `)`);
    }
  } });
  function l2(t5, n3, r3) {
    if (n3 === 1) return clone$3(t5[0][0]);
    if (n3 === 2) return i2(a2(t5[0][0], t5[1][1]), a2(t5[1][0], t5[0][1]));
    for (var l3 = false, u2 = Array(n3).fill(0).map((t6, n4) => n4), d2 = 0; d2 < n3; d2++) {
      var p2 = u2[d2];
      if (s2(t5[p2][d2])) {
        var m2 = void 0;
        for (m2 = d2 + 1; m2 < n3; m2++) if (!s2(t5[u2[m2]][d2])) {
          p2 = u2[m2], u2[m2] = u2[d2], u2[d2] = p2, l3 = !l3;
          break;
        }
        if (m2 === n3) return t5[p2][d2];
      }
      for (var h2 = t5[p2][d2], g2 = d2 === 0 ? 1 : t5[u2[d2 - 1]][d2 - 1], v2 = d2 + 1; v2 < n3; v2++) for (var y2 = u2[v2], b2 = d2 + 1; b2 < n3; b2++) t5[y2][b2] = o2(i2(a2(t5[y2][b2], h2), a2(t5[y2][d2], t5[p2][b2])), g2);
    }
    var x2 = t5[u2[n3 - 1]][n3 - 1];
    return l3 ? c2(x2) : x2;
  }
}), name$76 = `inv`, dependencies$76 = [`typed`, `matrix`, `divideScalar`, `addScalar`, `multiply`, `unaryMinus`, `det`, `identity`, `abs`], createInv = factory(name$76, dependencies$76, (t4) => {
  var { typed: n2, matrix: r2, divideScalar: i2, addScalar: a2, multiply: o2, unaryMinus: s2, det: c2, identity: l2, abs: u2 } = t4;
  return n2(name$76, { "Array | Matrix": function(t5) {
    var n3 = isMatrix(t5) ? t5.size() : arraySize(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return isMatrix(t5) ? r2([i2(1, t5.valueOf()[0])]) : [i2(1, t5[0])];
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      case 2:
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) return isMatrix(t5) ? r2(d2(t5.valueOf(), a3, o3), t5.storage()) : d2(t5, a3, o3);
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format(n3) + `)`);
    }
  }, any: function(t5) {
    return i2(1, t5);
  } });
  function d2(t5, n3, r3) {
    var d3, p2, m2, h2, g2;
    if (n3 === 1) {
      if (h2 = t5[0][0], h2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(1, h2)]];
    } else if (n3 === 2) {
      var v2 = c2(t5);
      if (v2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
      return [[i2(t5[1][1], v2), i2(s2(t5[0][1]), v2)], [i2(s2(t5[1][0]), v2), i2(t5[0][0], v2)]];
    } else {
      var y2 = t5.concat();
      for (d3 = 0; d3 < n3; d3++) y2[d3] = y2[d3].concat();
      for (var b2 = l2(n3).valueOf(), x2 = 0; x2 < r3; x2++) {
        var S2 = u2(y2[x2][x2]), w2 = x2;
        for (d3 = x2 + 1; d3 < n3; ) u2(y2[d3][x2]) > S2 && (S2 = u2(y2[d3][x2]), w2 = d3), d3++;
        if (S2 === 0) throw Error(`Cannot calculate inverse, determinant is zero`);
        d3 = w2, d3 !== x2 && (g2 = y2[x2], y2[x2] = y2[d3], y2[d3] = g2, g2 = b2[x2], b2[x2] = b2[d3], b2[d3] = g2);
        var E = y2[x2], D = b2[x2];
        for (d3 = 0; d3 < n3; d3++) {
          var O2 = y2[d3], j2 = b2[d3];
          if (d3 !== x2) {
            if (O2[x2] !== 0) {
              for (m2 = i2(s2(O2[x2]), E[x2]), p2 = x2; p2 < r3; p2++) O2[p2] = a2(O2[p2], o2(m2, E[p2]));
              for (p2 = 0; p2 < r3; p2++) j2[p2] = a2(j2[p2], o2(m2, D[p2]));
            }
          } else {
            for (m2 = E[x2], p2 = x2; p2 < r3; p2++) O2[p2] = i2(O2[p2], m2);
            for (p2 = 0; p2 < r3; p2++) j2[p2] = i2(j2[p2], m2);
          }
        }
      }
      return b2;
    }
  }
}), name$75 = `pinv`, dependencies$75 = [`typed`, `matrix`, `inv`, `deepEqual`, `equal`, `dotDivide`, `dot`, `ctranspose`, `divideScalar`, `multiply`, `add`, `Complex`], createPinv = factory(name$75, dependencies$75, (t4) => {
  var { typed: n2, matrix: r2, inv: i2, deepEqual: a2, equal: o2, dotDivide: s2, dot: c2, ctranspose: l2, divideScalar: u2, multiply: d2, add: p2, Complex: m2 } = t4;
  return n2(name$75, { "Array | Matrix": function(t5) {
    var n3 = isMatrix(t5) ? t5.size() : arraySize(t5);
    switch (n3.length) {
      case 1:
        return b2(t5) ? l2(t5) : n3[0] === 1 ? i2(t5) : s2(l2(t5), c2(t5, t5));
      case 2:
        if (b2(t5)) return l2(t5);
        var a3 = n3[0], o3 = n3[1];
        if (a3 === o3) try {
          return i2(t5);
        } catch (t6) {
          if (!(t6 instanceof Error && t6.message.match(/Cannot calculate inverse, determinant is zero/))) throw t6;
        }
        return isMatrix(t5) ? r2(h2(t5.valueOf(), a3, o3), t5.storage()) : h2(t5, a3, o3);
      default:
        throw RangeError(`Matrix must be two dimensional (size: ` + format(n3) + `)`);
    }
  }, any: function(t5) {
    return o2(t5, 0) ? clone$3(t5) : u2(1, t5);
  } });
  function h2(t5, n3, r3) {
    var { C: a3, F: o3 } = v2(t5, n3, r3), s3 = d2(i2(d2(l2(a3), a3)), l2(a3));
    return d2(d2(l2(o3), i2(d2(o3, l2(o3)))), s3);
  }
  function g2(t5, n3, r3) {
    for (var i3 = clone$3(t5), a3 = 0, o3 = 0; o3 < n3; o3++) {
      if (r3 <= a3) return i3;
      for (var c3 = o3; y2(i3[c3][a3]); ) if (c3++, n3 === c3 && (c3 = o3, a3++, r3 === a3)) return i3;
      [i3[c3], i3[o3]] = [i3[o3], i3[c3]];
      for (var l3 = i3[o3][a3], u3 = 0; u3 < r3; u3++) i3[o3][u3] = s2(i3[o3][u3], l3);
      for (var m3 = 0; m3 < n3; m3++) if (m3 !== o3) {
        l3 = i3[m3][a3];
        for (var h3 = 0; h3 < r3; h3++) i3[m3][h3] = p2(i3[m3][h3], d2(-1, d2(l3, i3[o3][h3])));
      }
      a3++;
    }
    return i3;
  }
  function v2(t5, n3, r3) {
    var i3 = g2(t5, n3, r3);
    return { C: t5.map((t6, r4) => t6.filter((t7, r5) => r5 < n3 && !y2(c2(i3[r5], i3[r5])))), F: i3.filter((t6, n4) => !y2(c2(i3[n4], i3[n4]))) };
  }
  function y2(t5) {
    return o2(p2(t5, m2(1, 1)), p2(0, m2(1, 1)));
  }
  function b2(t5) {
    return a2(p2(t5, m2(1, 1)), p2(d2(t5, 0), m2(1, 1)));
  }
});
function createComplexEigs(t4) {
  var { addScalar: n2, subtract: r2, flatten: i2, multiply: a2, multiplyScalar: o2, divideScalar: s2, sqrt: c2, abs: l2, bignumber: u2, diag: d2, size: p2, reshape: m2, inv: h2, qr: g2, usolve: v2, usolveAll: y2, equal: b2, complex: x2, larger: S2, smaller: w2, matrixFromColumns: E, dot: D } = t4;
  function O2(t5, n3, r3, i3) {
    var a3 = arguments.length > 4 && arguments[4] !== void 0 ? arguments[4] : true, o3 = j2(t5, n3, r3, i3, a3);
    M2(t5, n3, r3, i3, a3, o3);
    var { values: s3, C: c3 } = N2(t5, n3, r3, i3, a3);
    return a3 ? { values: s3, eigenvectors: F(t5, n3, c3, o3, s3, r3, i3) } : { values: s3 };
  }
  function j2(t5, r3, i3, a3, c3) {
    var p3 = a3 === `BigNumber`, m3 = a3 === `Complex`, h3 = p3 ? u2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1, v3 = p3 ? u2(1) : 1, y3 = p3 ? u2(10) : 2, E2 = o2(y3, y3), D2;
    c3 && (D2 = Array(r3).fill(g3));
    for (var O22 = false; !O22; ) {
      O22 = true;
      for (var j3 = 0; j3 < r3; j3++) {
        for (var M3 = h3, N3 = h3, F2 = 0; F2 < r3; F2++) j3 !== F2 && (M3 = n2(M3, l2(t5[F2][j3])), N3 = n2(N3, l2(t5[j3][F2])));
        if (!b2(M3, 0) && !b2(N3, 0)) {
          for (var I22 = v3, L22 = M3, R22 = s2(N3, y3), z22 = o2(N3, y3); w2(L22, R22); ) L22 = o2(L22, E2), I22 = o2(I22, y3);
          for (; S2(L22, z22); ) L22 = s2(L22, E2), I22 = s2(I22, y3);
          if (w2(s2(n2(L22, N3), I22), o2(n2(M3, N3), 0.95))) {
            O22 = false;
            for (var V22 = s2(1, I22), H3 = 0; H3 < r3; H3++) j3 !== H3 && (t5[j3][H3] = o2(t5[j3][H3], V22), t5[H3][j3] = o2(t5[H3][j3], I22));
            c3 && (D2[j3] = o2(D2[j3], V22));
          }
        }
      }
    }
    return c3 ? d2(D2) : null;
  }
  function M2(t5, i3, a3, c3, d3, p3) {
    var m3 = c3 === `BigNumber`, h3 = m3 ? u2(0) : c3 === `Complex` ? x2(0) : 0;
    m3 && (a3 = u2(a3));
    for (var g3 = 0; g3 < i3 - 2; g3++) {
      for (var v3 = 0, y3 = h3, b3 = g3 + 1; b3 < i3; b3++) {
        var S3 = t5[b3][g3];
        w2(l2(y3), l2(S3)) && (y3 = S3, v3 = b3);
      }
      if (!w2(l2(y3), a3)) {
        if (v3 !== g3 + 1) {
          var E2 = t5[v3];
          t5[v3] = t5[g3 + 1], t5[g3 + 1] = E2;
          for (var D2 = 0; D2 < i3; D2++) {
            var O22 = t5[D2][v3];
            t5[D2][v3] = t5[D2][g3 + 1], t5[D2][g3 + 1] = O22;
          }
          if (d3) {
            var j3 = p3[v3];
            p3[v3] = p3[g3 + 1], p3[g3 + 1] = j3;
          }
        }
        for (var M3 = g3 + 2; M3 < i3; M3++) {
          var N3 = s2(t5[M3][g3], y3);
          if (N3 !== 0) {
            for (var F2 = 0; F2 < i3; F2++) t5[M3][F2] = r2(t5[M3][F2], o2(N3, t5[g3 + 1][F2]));
            for (var I22 = 0; I22 < i3; I22++) t5[I22][g3 + 1] = n2(t5[I22][g3 + 1], o2(N3, t5[I22][M3]));
            if (d3) for (var L22 = 0; L22 < i3; L22++) p3[M3][L22] = r2(p3[M3][L22], o2(N3, p3[g3 + 1][L22]));
          }
        }
      }
    }
    return p3;
  }
  function N2(t5, i3, o3, s3, c3) {
    var p3 = s3 === `BigNumber`, m3 = p3 ? u2(1) : s3 === `Complex` ? x2(1) : 1;
    p3 && (o3 = u2(o3));
    for (var h3 = clone$3(t5), v3 = [], y3 = i3, b3 = [], S3 = c3 ? d2(Array(i3).fill(m3)) : void 0, E2 = c3 ? d2(Array(y3).fill(m3)) : void 0, D2 = 0; D2 <= 100; ) {
      D2 += 1;
      for (var O22 = h3[y3 - 1][y3 - 1], j3 = 0; j3 < y3; j3++) h3[j3][j3] = r2(h3[j3][j3], O22);
      var { Q: M3, R: N3 } = g2(h3);
      h3 = a2(N3, M3);
      for (var F2 = 0; F2 < y3; F2++) h3[F2][F2] = n2(h3[F2][F2], O22);
      if (c3 && (E2 = a2(E2, M3)), y3 === 1 || w2(l2(h3[y3 - 1][y3 - 2]), o3)) {
        D2 = 0, v3.push(h3[y3 - 1][y3 - 1]), c3 && (b3.unshift([[1]]), R2(E2, i3), S3 = a2(S3, E2), y3 > 1 && (E2 = d2(Array(y3 - 1).fill(m3)))), --y3, h3.pop();
        for (var V22 = 0; V22 < y3; V22++) h3[V22].pop();
      } else if (y3 === 2 || w2(l2(h3[y3 - 2][y3 - 3]), o3)) {
        D2 = 0;
        var H3 = I2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1]);
        v3.push(...H3), c3 && (b3.unshift(L2(h3[y3 - 2][y3 - 2], h3[y3 - 2][y3 - 1], h3[y3 - 1][y3 - 2], h3[y3 - 1][y3 - 1], H3[0], H3[1], o3, s3)), R2(E2, i3), S3 = a2(S3, E2), y3 > 2 && (E2 = d2(Array(y3 - 2).fill(m3)))), y3 -= 2, h3.pop(), h3.pop();
        for (var U22 = 0; U22 < y3; U22++) h3[U22].pop(), h3[U22].pop();
      }
      if (y3 === 0) break;
    }
    if (v3.sort((t6, n3) => +r2(l2(t6), l2(n3))), D2 > 100) {
      var W22 = Error(`The eigenvalues failed to converge. Only found these eigenvalues: ` + v3.join(`, `));
      throw W22.values = v3, W22.vectors = [], W22;
    }
    return { values: v3, C: c3 ? a2(S3, z2(b3, i3)) : void 0 };
  }
  function F(t5, n3, o3, s3, c3, l3, p3) {
    var m3 = a2(h2(o3), t5, o3), g3 = p3 === `BigNumber`, v3 = p3 === `Complex`, S3 = g3 ? u2(0) : v3 ? x2(0) : 0, w3 = g3 ? u2(1) : v3 ? x2(1) : 1, E2 = [], D2 = [];
    for (var O22 of c3) {
      var j3 = V2(E2, O22, b2);
      j3 === -1 ? (E2.push(O22), D2.push(1)) : D2[j3] += 1;
    }
    for (var M3 = [], N3 = E2.length, F2 = Array(n3).fill(S3), I22 = d2(Array(n3).fill(w3)), L22 = function() {
      var t6 = E2[R22], c4 = r2(m3, a2(t6, I22)), u3 = y2(c4, F2);
      for (u3.shift(); u3.length < D2[R22]; ) {
        var d3 = H2(c4, n3, u3, l3, p3);
        if (d3 === null) break;
        u3.push(d3);
      }
      var g4 = a2(h2(s3), o3);
      u3 = u3.map((t7) => a2(g4, t7)), M3.push(...u3.map((n4) => ({ value: t6, vector: i2(n4) })));
    }, R22 = 0; R22 < N3; R22++) L22();
    return M3;
  }
  function I2(t5, i3, a3, s3) {
    var l3 = n2(t5, s3), u3 = r2(o2(t5, s3), o2(i3, a3)), d3 = o2(l3, 0.5), p3 = o2(c2(r2(o2(l3, l3), o2(4, u3))), 0.5);
    return [n2(d3, p3), r2(d3, p3)];
  }
  function L2(t5, n3, i3, a3, o3, s3, c3, d3) {
    var p3 = d3 === `BigNumber`, m3 = d3 === `Complex`, h3 = p3 ? u2(0) : m3 ? x2(0) : 0, g3 = p3 ? u2(1) : m3 ? x2(1) : 1;
    if (w2(l2(i3), c3)) return [[g3, h3], [h3, g3]];
    if (S2(l2(r2(o3, s3)), c3)) return [[r2(o3, a3), r2(s3, a3)], [i3, i3]];
    var v3 = r2(t5, o3), y3 = r2(a3, o3);
    return w2(l2(n3), c3) && w2(l2(y3), c3) ? [[v3, g3], [i3, h3]] : [[n3, h3], [y3, g3]];
  }
  function R2(t5, n3) {
    for (var r3 = 0; r3 < t5.length; r3++) t5[r3].push(...Array(n3 - t5[r3].length).fill(0));
    for (var i3 = t5.length; i3 < n3; i3++) t5.push(Array(n3).fill(0)), t5[i3][i3] = 1;
    return t5;
  }
  function z2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < n3; i3++) r3[i3] = Array(n3).fill(0);
    var a3 = 0;
    for (var o3 of t5) {
      for (var s3 = o3.length, c3 = 0; c3 < s3; c3++) for (var l3 = 0; l3 < s3; l3++) r3[a3 + c3][a3 + l3] = o3[c3][l3];
      a3 += s3;
    }
    return r3;
  }
  function V2(t5, n3, r3) {
    for (var i3 = 0; i3 < t5.length; i3++) if (r3(t5[i3], n3)) return i3;
    return -1;
  }
  function H2(t5, n3, r3, i3, a3) {
    for (var o3 = a3 === `BigNumber` ? u2(1e3) : 1e3, s3, c3 = 0; c3 < 5; ++c3) {
      s3 = U2(n3, r3, a3);
      try {
        s3 = v2(t5, s3);
      } catch {
        continue;
      }
      if (S2(G2(s3), o3)) break;
    }
    if (c3 >= 5) return null;
    for (c3 = 0; ; ) {
      var l3 = v2(t5, s3);
      if (w2(G2(W2(s3, [l3])), i3)) break;
      if (++c3 >= 10) return null;
      s3 = K2(l3);
    }
    return s3;
  }
  function U2(t5, n3, r3) {
    var i3 = r3 === `BigNumber`, a3 = r3 === `Complex`, o3 = Array(t5).fill(0).map((t6) => 2 * Math.random() - 1);
    return i3 && (o3 = o3.map((t6) => u2(t6))), a3 && (o3 = o3.map((t6) => x2(t6))), o3 = W2(o3, n3), K2(o3, r3);
  }
  function W2(t5, n3) {
    var i3 = p2(t5);
    for (var o3 of n3) o3 = m2(o3, i3), t5 = r2(t5, a2(s2(D(o3, t5), D(o3, o3)), o3));
    return t5;
  }
  function G2(t5) {
    return l2(c2(D(t5, t5)));
  }
  function K2(t5, n3) {
    return a2(s2(n3 === `BigNumber` ? u2(1) : n3 === `Complex` ? x2(1) : 1, G2(t5)), t5);
  }
  return O2;
}
function createRealSymmetric(t4) {
  var { config: n2, addScalar: r2, subtract: i2, abs: a2, atan: o2, cos: s2, sin: c2, multiplyScalar: l2, inv: u2, bignumber: d2, multiply: p2, add: m2 } = t4;
  function h2(t5, r3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n2.relTol, a3 = arguments.length > 3 ? arguments[3] : void 0, o3 = arguments.length > 4 ? arguments[4] : void 0;
    if (a3 === `number`) return g2(t5, i3, o3);
    if (a3 === `BigNumber`) return v2(t5, i3, o3);
    throw TypeError(`Unsupported data type: ` + a3);
  }
  function g2(t5, n3, r3) {
    var i3 = t5.length, a3 = Math.abs(n3 / i3), o3, s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3).fill(0), s3[c3][c3] = 1;
    }
    for (var l3 = D(t5); Math.abs(l3[1]) >= Math.abs(a3); ) {
      var u3 = l3[0][0], d3 = l3[0][1];
      o3 = y2(t5[u3][u3], t5[d3][d3], t5[u3][d3]), t5 = E(t5, o3, u3, d3), r3 && (s3 = x2(s3, o3, u3, d3)), l3 = D(t5);
    }
    for (var p3 = Array(i3).fill(0), m3 = 0; m3 < i3; m3++) p3[m3] = t5[m3][m3];
    return j2(clone$3(p3), s3, r3);
  }
  function v2(t5, n3, r3) {
    var i3 = t5.length, o3 = a2(n3 / i3), s3, c3;
    if (r3) {
      c3 = Array(i3);
      for (var l3 = 0; l3 < i3; l3++) c3[l3] = Array(i3).fill(0), c3[l3][l3] = 1;
    }
    for (var u3 = O2(t5); a2(u3[1]) >= a2(o3); ) {
      var d3 = u3[0][0], p3 = u3[0][1];
      s3 = b2(t5[d3][d3], t5[p3][p3], t5[d3][p3]), t5 = w2(t5, s3, d3, p3), r3 && (c3 = S2(c3, s3, d3, p3)), u3 = O2(t5);
    }
    for (var m3 = Array(i3).fill(0), h3 = 0; h3 < i3; h3++) m3[h3] = t5[h3][h3];
    return j2(clone$3(m3), c3, r3);
  }
  function y2(t5, r3, i3) {
    var a3 = r3 - t5;
    return Math.abs(a3) <= n2.relTol ? Math.PI / 4 : 0.5 * Math.atan(2 * i3 / (r3 - t5));
  }
  function b2(t5, r3, s3) {
    var c3 = i2(r3, t5);
    return a2(c3) <= n2.relTol ? d2(-1).acos().div(4) : l2(0.5, o2(p2(2, s3, u2(c3))));
  }
  function x2(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = Array(a3).fill(0), l3 = Array(a3).fill(0), u3 = 0; u3 < a3; u3++) c3[u3] = o3 * t5[u3][r3] - s3 * t5[u3][i3], l3[u3] = s3 * t5[u3][r3] + o3 * t5[u3][i3];
    for (var d3 = 0; d3 < a3; d3++) t5[d3][r3] = c3[d3], t5[d3][i3] = l3[d3];
    return t5;
  }
  function S2(t5, n3, a3, o3) {
    for (var u3 = t5.length, p3 = s2(n3), m3 = c2(n3), h3 = Array(u3).fill(d2(0)), g3 = Array(u3).fill(d2(0)), v3 = 0; v3 < u3; v3++) h3[v3] = i2(l2(p3, t5[v3][a3]), l2(m3, t5[v3][o3])), g3[v3] = r2(l2(m3, t5[v3][a3]), l2(p3, t5[v3][o3]));
    for (var y3 = 0; y3 < u3; y3++) t5[y3][a3] = h3[y3], t5[y3][o3] = g3[y3];
    return t5;
  }
  function w2(t5, n3, a3, o3) {
    for (var u3 = t5.length, h3 = d2(s2(n3)), g3 = d2(c2(n3)), v3 = l2(h3, h3), y3 = l2(g3, g3), b3 = Array(u3).fill(d2(0)), x3 = Array(u3).fill(d2(0)), S3 = p2(d2(2), h3, g3, t5[a3][o3]), w3 = r2(i2(l2(v3, t5[a3][a3]), S3), l2(y3, t5[o3][o3])), E2 = m2(l2(y3, t5[a3][a3]), S3, l2(v3, t5[o3][o3])), D2 = 0; D2 < u3; D2++) b3[D2] = i2(l2(h3, t5[a3][D2]), l2(g3, t5[o3][D2])), x3[D2] = r2(l2(g3, t5[a3][D2]), l2(h3, t5[o3][D2]));
    t5[a3][a3] = w3, t5[o3][o3] = E2, t5[a3][o3] = d2(0), t5[o3][a3] = d2(0);
    for (var O22 = 0; O22 < u3; O22++) O22 !== a3 && O22 !== o3 && (t5[a3][O22] = b3[O22], t5[O22][a3] = b3[O22], t5[o3][O22] = x3[O22], t5[O22][o3] = x3[O22]);
    return t5;
  }
  function E(t5, n3, r3, i3) {
    for (var a3 = t5.length, o3 = Math.cos(n3), s3 = Math.sin(n3), c3 = o3 * o3, l3 = s3 * s3, u3 = Array(a3).fill(0), d3 = Array(a3).fill(0), p3 = c3 * t5[r3][r3] - 2 * o3 * s3 * t5[r3][i3] + l3 * t5[i3][i3], m3 = l3 * t5[r3][r3] + 2 * o3 * s3 * t5[r3][i3] + c3 * t5[i3][i3], h3 = 0; h3 < a3; h3++) u3[h3] = o3 * t5[r3][h3] - s3 * t5[i3][h3], d3[h3] = s3 * t5[r3][h3] + o3 * t5[i3][h3];
    t5[r3][r3] = p3, t5[i3][i3] = m3, t5[r3][i3] = 0, t5[i3][r3] = 0;
    for (var g3 = 0; g3 < a3; g3++) g3 !== r3 && g3 !== i3 && (t5[r3][g3] = u3[g3], t5[g3][r3] = u3[g3], t5[i3][g3] = d3[g3], t5[g3][i3] = d3[g3]);
    return t5;
  }
  function D(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], a3 = 0; a3 < n3; a3++) for (var o3 = a3 + 1; o3 < n3; o3++) Math.abs(r3) < Math.abs(t5[a3][o3]) && (r3 = Math.abs(t5[a3][o3]), i3 = [a3, o3]);
    return [i3, r3];
  }
  function O2(t5) {
    for (var n3 = t5.length, r3 = 0, i3 = [0, 1], o3 = 0; o3 < n3; o3++) for (var s3 = o3 + 1; s3 < n3; s3++) a2(r3) < a2(t5[o3][s3]) && (r3 = a2(t5[o3][s3]), i3 = [o3, s3]);
    return [i3, r3];
  }
  function j2(t5, n3, r3) {
    var i3 = t5.length, o3 = Array(i3), s3;
    if (r3) {
      s3 = Array(i3);
      for (var c3 = 0; c3 < i3; c3++) s3[c3] = Array(i3);
    }
    for (var l3 = 0; l3 < i3; l3++) {
      for (var u3 = 0, d3 = t5[0], p3 = 0; p3 < t5.length; p3++) a2(t5[p3]) < a2(d3) && (u3 = p3, d3 = t5[u3]);
      if (o3[l3] = t5.splice(u3, 1)[0], r3) for (var m3 = 0; m3 < i3; m3++) s3[l3][m3] = n3[m3][u3], n3[m3].splice(u3, 1);
    }
    return r3 ? { values: o3, eigenvectors: s3.map((t6, n4) => ({ value: o3[n4], vector: t6 })) } : { values: o3 };
  }
  return h2;
}
var name$74 = `eigs`, dependencies$74 = `config.typed.matrix.addScalar.equal.subtract.abs.atan.cos.sin.multiplyScalar.divideScalar.inv.bignumber.multiply.add.larger.column.flatten.number.complex.sqrt.diag.size.reshape.qr.usolve.usolveAll.im.re.smaller.matrixFromColumns.dot`.split(`.`), createEigs = factory(name$74, dependencies$74, (t4) => {
  var { config: n2, typed: r2, matrix: i2, addScalar: a2, subtract: o2, equal: s2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, divideScalar: m2, inv: h2, bignumber: g2, multiply: v2, add: y2, larger: b2, column: x2, flatten: S2, number: w2, complex: E, sqrt: D, diag: O2, size: j2, reshape: M2, qr: N2, usolve: F, usolveAll: I2, im: L2, re: R2, smaller: z2, matrixFromColumns: V2, dot: H2 } = t4, U2 = createRealSymmetric({ config: n2, addScalar: a2, subtract: o2, abs: c2, atan: l2, cos: u2, sin: d2, multiplyScalar: p2, inv: h2, bignumber: g2, multiply: v2, add: y2 }), W2 = createComplexEigs({ addScalar: a2, subtract: o2, multiply: v2, multiplyScalar: p2, flatten: S2, divideScalar: m2, sqrt: D, abs: c2, bignumber: g2, diag: O2, size: j2, reshape: M2, qr: N2, inv: h2, usolve: F, usolveAll: I2, equal: s2, complex: E, larger: b2, smaller: z2, matrixFromColumns: V2, dot: H2 });
  return r2(`eigs`, { Array: function(t5) {
    return G2(i2(t5));
  }, "Array, number|BigNumber": function(t5, n3) {
    return G2(i2(t5), { precision: n3 });
  }, "Array, Object"(t5, n3) {
    return G2(i2(t5), n3);
  }, Matrix: function(t5) {
    return G2(t5, { matricize: true });
  }, "Matrix, number|BigNumber": function(t5, n3) {
    return G2(t5, { precision: n3, matricize: true });
  }, "Matrix, Object": function(t5, n3) {
    var r3 = { matricize: true };
    return _extends(r3, n3), G2(t5, r3);
  } });
  function G2(t5) {
    var a3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, o3 = `eigenvectors` in a3 ? a3.eigenvectors : true, s3 = K2(t5, a3.precision ?? n2.relTol, o3);
    return a3.matricize && (s3.values = i2(s3.values), o3 && (s3.eigenvectors = s3.eigenvectors.map((t6) => {
      var { value: n3, vector: r3 } = t6;
      return { value: n3, vector: i2(r3) };
    }))), o3 && Object.defineProperty(s3, "vectors", { enumerable: false, get: () => {
      throw Error(`eigs(M).vectors replaced with eigs(M).eigenvectors`);
    } }), s3;
  }
  function K2(t5, n3, r3) {
    var i3 = t5.toArray(), a3 = t5.size();
    if (a3.length !== 2 || a3[0] !== a3[1]) throw RangeError(`Matrix must be square (size: ${format(a3)})`);
    var o3 = a3[0];
    return J(i3, o3, n3) && (ee2(i3, o3), q2(i3, o3, n3)) ? U2(i3, o3, n3, Y2(t5, i3, o3), r3) : W2(i3, o3, n3, Y2(t5, i3, o3), r3);
  }
  function q2(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = i3; a3 < n3; a3++) if (b2(g2(c2(o2(t5[i3][a3], t5[a3][i3]))), r3)) return false;
    return true;
  }
  function J(t5, n3, r3) {
    for (var i3 = 0; i3 < n3; i3++) for (var a3 = 0; a3 < n3; a3++) if (b2(g2(c2(L2(t5[i3][a3]))), r3)) return false;
    return true;
  }
  function ee2(t5, n3) {
    for (var r3 = 0; r3 < n3; r3++) for (var i3 = 0; i3 < n3; i3++) t5[r3][i3] = R2(t5[r3][i3]);
  }
  function Y2(t5, n3, r3) {
    var i3 = t5.datatype();
    if (i3 === `number` || i3 === `BigNumber` || i3 === `Complex`) return i3;
    for (var a3 = false, o3 = false, s3 = false, c3 = 0; c3 < r3; c3++) for (var l3 = 0; l3 < r3; l3++) {
      var u3 = n3[c3][l3];
      if (isNumber(u3) || isFraction(u3)) a3 = true;
      else if (isBigNumber(u3)) o3 = true;
      else if (isComplex(u3)) s3 = true;
      else throw TypeError(`Unsupported type in Matrix: ` + typeOf(u3));
    }
    if (o3 && s3 && console.warn(`Complex BigNumbers not supported, this operation will lose precission.`), s3) {
      for (var d3 = 0; d3 < r3; d3++) for (var p3 = 0; p3 < r3; p3++) n3[d3][p3] = E(n3[d3][p3]);
      return `Complex`;
    }
    if (o3) {
      for (var m3 = 0; m3 < r3; m3++) for (var h3 = 0; h3 < r3; h3++) n3[m3][h3] = g2(n3[m3][h3]);
      return `BigNumber`;
    }
    if (a3) {
      for (var v3 = 0; v3 < r3; v3++) for (var y3 = 0; y3 < r3; y3++) n3[v3][y3] = w2(n3[v3][y3]);
      return `number`;
    } else throw TypeError(`Matrix contains unsupported types only.`);
  }
}), name$73 = `expm`, dependencies$73 = [`typed`, `abs`, `add`, `identity`, `inv`, `multiply`], createExpm = factory(name$73, dependencies$73, (t4) => {
  var { typed: n2, abs: r2, add: i2, identity: a2, inv: o2, multiply: s2 } = t4;
  return n2(name$73, { Matrix: function(t5) {
    var n3 = t5.size();
    if (n3.length !== 2 || n3[0] !== n3[1]) throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
    for (var r3 = n3[0], u3 = l2(c2(t5), 1e-15), d2 = u3.q, p2 = u3.j, m2 = s2(t5, 2 ** -p2), h2 = a2(r3), g2 = a2(r3), v2 = 1, y2 = m2, b2 = -1, x2 = 1; x2 <= d2; x2++) x2 > 1 && (y2 = s2(y2, m2), b2 = -b2), v2 = v2 * (d2 - x2 + 1) / ((2 * d2 - x2 + 1) * x2), h2 = i2(h2, s2(v2, y2)), g2 = i2(g2, s2(v2 * b2, y2));
    for (var S2 = s2(o2(g2), h2), w2 = 0; w2 < p2; w2++) S2 = s2(S2, S2);
    return isSparseMatrix(t5) ? t5.createSparseMatrix(S2) : S2;
  } });
  function c2(t5) {
    for (var n3 = t5.size()[0], i3 = 0, a3 = 0; a3 < n3; a3++) {
      for (var o3 = 0, s3 = 0; s3 < n3; s3++) o3 += r2(t5.get([a3, s3]));
      i3 = Math.max(o3, i3);
    }
    return i3;
  }
  function l2(t5, n3) {
    for (var r3 = 30, i3 = 0; i3 < r3; i3++) for (var a3 = 0; a3 <= i3; a3++) {
      var o3 = i3 - a3;
      if (u2(t5, a3, o3) < n3) return { q: a3, j: o3 };
    }
    throw Error(`Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)`);
  }
  function u2(t5, n3, r3) {
    for (var i3 = 1, a3 = 2; a3 <= n3; a3++) i3 *= a3;
    for (var o3 = i3, s3 = n3 + 1; s3 <= 2 * n3; s3++) o3 *= s3;
    var c3 = o3 * (2 * n3 + 1);
    return 8 * (t5 / 2 ** r3) ** (2 * n3) * i3 * i3 / (o3 * c3);
  }
}), name$72 = `sqrtm`, dependencies$72 = [`typed`, `abs`, `add`, `multiply`, `map`, `sqrt`, `subtract`, `inv`, `size`, `max`, `identity`], createSqrtm = factory(name$72, dependencies$72, (t4) => {
  var { typed: n2, abs: r2, add: i2, multiply: a2, map: o2, sqrt: s2, subtract: c2, inv: l2, size: u2, max: d2, identity: p2 } = t4, m2 = 1e3, h2 = 1e-6;
  function g2(t5) {
    var n3, o3 = 0, s3 = t5, g3 = p2(u2(t5));
    do {
      var v2 = s3;
      if (s3 = a2(0.5, i2(v2, l2(g3))), g3 = a2(0.5, i2(g3, l2(v2))), n3 = d2(r2(c2(s3, v2))), n3 > h2 && ++o3 > m2) throw Error(`computing square root of matrix: iterative method could not converge`);
    } while (n3 > h2);
    return s3;
  }
  return n2(name$72, { "Array | Matrix": function(t5) {
    var n3 = isMatrix(t5) ? t5.size() : arraySize(t5);
    switch (n3.length) {
      case 1:
        if (n3[0] === 1) return o2(t5, s2);
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      case 2:
        if (n3[0] === n3[1]) return g2(t5);
        throw RangeError(`Matrix must be square (size: ` + format(n3) + `)`);
      default:
        throw RangeError(`Matrix must be at most two dimensional (size: ` + format(n3) + `)`);
    }
  } });
}), name$71 = `sylvester`, dependencies$71 = [`typed`, `schur`, `matrixFromColumns`, `matrix`, `multiply`, `range`, `concat`, `transpose`, `index`, `subset`, `add`, `subtract`, `identity`, `lusolve`, `abs`], createSylvester = factory(name$71, dependencies$71, (t4) => {
  var { typed: n2, schur: r2, matrixFromColumns: i2, matrix: a2, multiply: o2, range: s2, concat: c2, transpose: l2, index: u2, subset: d2, add: p2, subtract: m2, identity: h2, lusolve: g2, abs: v2, config: y2 } = t4;
  return n2(name$71, { "Matrix, Matrix, Matrix": b2, "Array, Matrix, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), n3, r3);
  }, "Array, Array, Matrix": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), r3);
  }, "Array, Matrix, Array": function(t5, n3, r3) {
    return b2(a2(t5), n3, a2(r3));
  }, "Matrix, Array, Matrix": function(t5, n3, r3) {
    return b2(t5, a2(n3), r3);
  }, "Matrix, Array, Array": function(t5, n3, r3) {
    return b2(t5, a2(n3), a2(r3));
  }, "Matrix, Matrix, Array": function(t5, n3, r3) {
    return b2(t5, n3, a2(r3));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return b2(a2(t5), a2(n3), a2(r3)).toArray();
  } });
  function b2(t5, n3, y3) {
    for (var b3 = n3.size()[0], x2 = t5.size()[0], S2 = r2(t5), w2 = S2.T, E = S2.U, D = r2(o2(-1, n3)), O2 = D.T, j2 = D.U, M2 = o2(o2(l2(E), y3), j2), N2 = s2(0, x2), F = [], I2 = (t6, n4) => c2(t6, n4, 1), L2 = (t6, n4) => c2(t6, n4, 0), R2 = 0; R2 < b3; R2++) if (R2 < b3 - 1 && v2(d2(O2, u2(R2 + 1, R2))) > 1e-5) {
      for (var z2 = L2(d2(M2, u2(N2, [R2])), d2(M2, u2(N2, [R2 + 1]))), V2 = 0; V2 < R2; V2++) z2 = p2(z2, L2(o2(F[V2], d2(O2, u2(V2, R2))), o2(F[V2], d2(O2, u2(V2, R2 + 1)))));
      var H2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2)))), U2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2)))), W2 = o2(h2(x2), o2(-1, d2(O2, u2(R2, R2 + 1)))), G2 = o2(h2(x2), o2(-1, d2(O2, u2(R2 + 1, R2 + 1)))), K2 = g2(L2(I2(p2(w2, H2), U2), I2(W2, p2(w2, G2))), z2);
      F[R2] = K2.subset(u2(s2(0, x2), [0])), F[R2 + 1] = K2.subset(u2(s2(x2, 2 * x2), [0])), R2++;
    } else {
      for (var q2 = d2(M2, u2(N2, [R2])), J = 0; J < R2; J++) q2 = p2(q2, o2(F[J], d2(O2, u2(J, R2))));
      F[R2] = g2(m2(w2, o2(d2(O2, u2(R2, R2)), h2(x2))), q2);
    }
    return o2(E, o2(a2(i2(...F)), l2(j2)));
  }
}), name$70 = `schur`, dependencies$70 = [`typed`, `matrix`, `identity`, `multiply`, `qr`, `norm`, `subtract`], createSchur = factory(name$70, dependencies$70, (t4) => {
  var { typed: n2, matrix: r2, identity: i2, multiply: a2, qr: o2, norm: s2, subtract: c2 } = t4;
  return n2(name$70, { Array: function(t5) {
    var n3 = l2(r2(t5));
    return { U: n3.U.valueOf(), T: n3.T.valueOf() };
  }, Matrix: function(t5) {
    return l2(t5);
  } });
  function l2(t5) {
    var n3 = t5.size()[0], r3 = t5, l3 = i2(n3), u2 = 0, d2;
    do {
      d2 = r3;
      var p2 = o2(r3), m2 = p2.Q, h2 = p2.R;
      if (r3 = a2(h2, m2), l3 = a2(l3, m2), u2++ > 100) break;
    } while (s2(c2(r3, d2)) > 1e-4);
    return { U: l3, T: r3 };
  }
}), name$69 = `lyap`, dependencies$69 = [`typed`, `matrix`, `sylvester`, `multiply`, `transpose`], createLyap = factory(name$69, dependencies$69, (t4) => {
  var { typed: n2, matrix: r2, sylvester: i2, multiply: a2, transpose: o2 } = t4;
  return n2(name$69, { "Matrix, Matrix": function(t5, n3) {
    return i2(t5, o2(t5), a2(-1, n3));
  }, "Array, Matrix": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), a2(-1, n3));
  }, "Matrix, Array": function(t5, n3) {
    return i2(t5, o2(r2(t5)), r2(a2(-1, n3)));
  }, "Array, Array": function(t5, n3) {
    return i2(r2(t5), o2(r2(t5)), r2(a2(-1, n3))).toArray();
  } });
}), name$68 = `divide`, dependencies$68 = [`typed`, `matrix`, `multiply`, `equalScalar`, `divideScalar`, `inv`], createDivide = factory(name$68, dependencies$68, (t4) => {
  var { typed: n2, matrix: r2, multiply: i2, equalScalar: a2, divideScalar: o2, inv: s2 } = t4, c2 = createMatAlgo11xS0s({ typed: n2, equalScalar: a2 }), l2 = createMatAlgo14xDs({ typed: n2 });
  return n2(`divide`, extend$1({ "Array | Matrix, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  }, "DenseMatrix, any": function(t5, n3) {
    return l2(t5, n3, o2, false);
  }, "SparseMatrix, any": function(t5, n3) {
    return c2(t5, n3, o2, false);
  }, "Array, any": function(t5, n3) {
    return l2(r2(t5), n3, o2, false).valueOf();
  }, "any, Array | Matrix": function(t5, n3) {
    return i2(t5, s2(n3));
  } }, o2.signatures));
}), name$67 = `distance`, dependencies$67 = [`typed`, `addScalar`, `subtractScalar`, `divideScalar`, `multiplyScalar`, `deepEqual`, `sqrt`, `abs`], createDistance = factory(name$67, dependencies$67, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, deepEqual: s2, sqrt: c2, abs: l2 } = t4;
  return n2(name$67, { "Array, Array, Array": function(t5, n3, r3) {
    if (t5.length === 2 && n3.length === 2 && r3.length === 2) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!d2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!d2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (s2(n3, r3)) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      var o3 = i2(r3[1], n3[1]), c3 = i2(n3[0], r3[0]), l3 = i2(a2(r3[0], n3[1]), a2(n3[0], r3[1]));
      return y2(t5[0], t5[1], o3, c3, l3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object, Object": function(t5, n3, r3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2 && Object.keys(r3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers`);
      if (!d2(r3)) throw TypeError(`Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers`);
      if (s2(g2(n3), g2(r3))) throw TypeError(`LinePoint1 should not be same with LinePoint2`);
      if (`pointX` in t5 && `pointY` in t5 && `lineOnePtX` in n3 && `lineOnePtY` in n3 && `lineTwoPtX` in r3 && `lineTwoPtY` in r3) {
        var o3 = i2(r3.lineTwoPtY, n3.lineOnePtY), c3 = i2(n3.lineOnePtX, r3.lineTwoPtX), l3 = i2(a2(r3.lineTwoPtX, n3.lineOnePtY), a2(n3.lineOnePtX, r3.lineTwoPtY));
        return y2(t5.pointX, t5.pointY, o3, c3, l3);
      } else throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Array, Array": function(t5, n3) {
    if (t5.length === 2 && n3.length === 3) {
      if (!d2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!p2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      return y2(t5[0], t5[1], n3[0], n3[1], n3[2]);
    } else if (t5.length === 3 && n3.length === 6) {
      if (!p2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!h2(n3)) throw TypeError(`Array with 6 numbers or BigNumbers expected for second argument`);
      return b2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], n3[3], n3[4], n3[5]);
    } else if (t5.length === n3.length && t5.length > 0) {
      if (!m2(t5) || !m2(n3)) throw TypeError(`All values of an array should be numbers or BigNumbers`);
      return x2(t5, n3);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, "Object, Object": function(t5, n3) {
    if (Object.keys(t5).length === 2 && Object.keys(n3).length === 3) {
      if (!d2(t5)) throw TypeError(`Values of pointX and pointY should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `xCoeffLine` in n3 && `yCoeffLine` in n3 && `constant` in n3) return y2(t5.pointX, t5.pointY, n3.xCoeffLine, n3.yCoeffLine, n3.constant);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 6) {
      if (!p2(t5)) throw TypeError(`Values of pointX, pointY and pointZ should be numbers or BigNumbers`);
      if (!h2(n3)) throw TypeError(`Values of x0, y0, z0, a, b and c should be numbers or BigNumbers`);
      if (`pointX` in t5 && `pointY` in t5 && `x0` in n3 && `y0` in n3 && `z0` in n3 && `a` in n3 && `b` in n3 && `c` in n3) return b2(t5.pointX, t5.pointY, t5.pointZ, n3.x0, n3.y0, n3.z0, n3.a, n3.b, n3.c);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 2 && Object.keys(n3).length === 2) {
      if (!d2(t5)) throw TypeError(`Values of pointOneX and pointOneY should be numbers or BigNumbers`);
      if (!d2(n3)) throw TypeError(`Values of pointTwoX and pointTwoY should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3) return x2([t5.pointOneX, t5.pointOneY], [n3.pointTwoX, n3.pointTwoY]);
      throw TypeError(`Key names do not match`);
    } else if (Object.keys(t5).length === 3 && Object.keys(n3).length === 3) {
      if (!p2(t5)) throw TypeError(`Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers`);
      if (!p2(n3)) throw TypeError(`Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers`);
      if (`pointOneX` in t5 && `pointOneY` in t5 && `pointOneZ` in t5 && `pointTwoX` in n3 && `pointTwoY` in n3 && `pointTwoZ` in n3) return x2([t5.pointOneX, t5.pointOneY, t5.pointOneZ], [n3.pointTwoX, n3.pointTwoY, n3.pointTwoZ]);
      throw TypeError(`Key names do not match`);
    } else throw TypeError(`Invalid Arguments: Try again`);
  }, Array: function(t5) {
    if (!v2(t5)) throw TypeError(`Incorrect array format entered for pairwise distance calculation`);
    return S2(t5);
  } });
  function u2(t5) {
    return typeof t5 == `number` || isBigNumber(t5);
  }
  function d2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]);
  }
  function p2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]);
  }
  function m2(t5) {
    return Array.isArray(t5) || (t5 = g2(t5)), t5.every(u2);
  }
  function h2(t5) {
    return t5.constructor !== Array && (t5 = g2(t5)), u2(t5[0]) && u2(t5[1]) && u2(t5[2]) && u2(t5[3]) && u2(t5[4]) && u2(t5[5]);
  }
  function g2(t5) {
    for (var n3 = Object.keys(t5), r3 = [], i3 = 0; i3 < n3.length; i3++) r3.push(t5[n3[i3]]);
    return r3;
  }
  function v2(t5) {
    if (t5[0].length === 2 && u2(t5[0][0]) && u2(t5[0][1])) {
      if (t5.some((t6) => t6.length !== 2 || !u2(t6[0]) || !u2(t6[1]))) return false;
    } else if (t5[0].length === 3 && u2(t5[0][0]) && u2(t5[0][1]) && u2(t5[0][2])) {
      if (t5.some((t6) => t6.length !== 3 || !u2(t6[0]) || !u2(t6[1]) || !u2(t6[2]))) return false;
    } else return false;
    return true;
  }
  function y2(t5, n3, i3, s3, u3) {
    return o2(l2(r2(r2(a2(i3, t5), a2(s3, n3)), u3)), c2(r2(a2(i3, i3), a2(s3, s3))));
  }
  function b2(t5, n3, s3, l3, u3, d3, p3, m3, h3) {
    var g3 = [i2(a2(i2(u3, n3), h3), a2(i2(d3, s3), m3)), i2(a2(i2(d3, s3), p3), a2(i2(l3, t5), h3)), i2(a2(i2(l3, t5), m3), a2(i2(u3, n3), p3))];
    g3 = c2(r2(r2(a2(g3[0], g3[0]), a2(g3[1], g3[1])), a2(g3[2], g3[2])));
    var v3 = c2(r2(r2(a2(p3, p3), a2(m3, m3)), a2(h3, h3)));
    return o2(g3, v3);
  }
  function x2(t5, n3) {
    for (var o3 = t5.length, s3 = 0, l3 = 0, u3 = 0; u3 < o3; u3++) l3 = i2(t5[u3], n3[u3]), s3 = r2(a2(l3, l3), s3);
    return c2(s3);
  }
  function S2(t5) {
    for (var n3 = [], r3 = [], i3 = [], a3 = 0; a3 < t5.length - 1; a3++) for (var o3 = a3 + 1; o3 < t5.length; o3++) t5[0].length === 2 ? (r3 = [t5[a3][0], t5[a3][1]], i3 = [t5[o3][0], t5[o3][1]]) : t5[0].length === 3 && (r3 = [t5[a3][0], t5[a3][1], t5[a3][2]], i3 = [t5[o3][0], t5[o3][1], t5[o3][2]]), n3.push(x2(r3, i3));
    return n3;
  }
}), name$66 = `intersect`, dependencies$66 = [`typed`, `config`, `abs`, `add`, `addScalar`, `matrix`, `multiply`, `multiplyScalar`, `divideScalar`, `subtract`, `smaller`, `equalScalar`, `flatten`, `isZero`, `isNumeric`], createIntersect = factory(name$66, dependencies$66, (t4) => {
  var { typed: n2, config: r2, abs: i2, add: a2, addScalar: o2, matrix: s2, multiply: c2, multiplyScalar: l2, divideScalar: u2, subtract: d2, smaller: p2, equalScalar: m2, flatten: h2, isZero: g2, isNumeric: v2 } = t4;
  return n2(`intersect`, { "Array, Array, Array": y2, "Array, Array, Array, Array": b2, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var i3 = y2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return i3 === null ? null : s2(i3);
  }, "Matrix, Matrix, Matrix, Matrix": function(t5, n3, r3, i3) {
    var a3 = b2(t5.valueOf(), n3.valueOf(), r3.valueOf(), i3.valueOf());
    return a3 === null ? null : s2(a3);
  } });
  function y2(t5, n3, r3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), !w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
    if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
    if (!E(r3)) throw TypeError(`Array with 4 numbers expected as third argument`);
    return M2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], r3[3]);
  }
  function b2(t5, n3, r3, i3) {
    if (t5 = x2(t5), n3 = x2(n3), r3 = x2(r3), i3 = x2(i3), t5.length === 2) {
      if (!S2(t5)) throw TypeError(`Array with 2 numbers or BigNumbers expected for first argument`);
      if (!S2(n3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for second argument`);
      if (!S2(r3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for third argument`);
      if (!S2(i3)) throw TypeError(`Array with 2 numbers or BigNumbers expected for fourth argument`);
      return D(t5, n3, r3, i3);
    } else if (t5.length === 3) {
      if (!w2(t5)) throw TypeError(`Array with 3 numbers or BigNumbers expected for first argument`);
      if (!w2(n3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for second argument`);
      if (!w2(r3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for third argument`);
      if (!w2(i3)) throw TypeError(`Array with 3 numbers or BigNumbers expected for fourth argument`);
      return j2(t5[0], t5[1], t5[2], n3[0], n3[1], n3[2], r3[0], r3[1], r3[2], i3[0], i3[1], i3[2]);
    } else throw TypeError(`Arrays with two or thee dimensional points expected`);
  }
  function x2(t5) {
    return t5.length === 1 ? t5[0] : t5.length > 1 && Array.isArray(t5[0]) && t5.every((t6) => Array.isArray(t6) && t6.length === 1) ? h2(t5) : t5;
  }
  function S2(t5) {
    return t5.length === 2 && v2(t5[0]) && v2(t5[1]);
  }
  function w2(t5) {
    return t5.length === 3 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]);
  }
  function E(t5) {
    return t5.length === 4 && v2(t5[0]) && v2(t5[1]) && v2(t5[2]) && v2(t5[3]);
  }
  function D(t5, n3, s3, m3) {
    var h3 = t5, v3 = s3, y3 = d2(h3, n3), b3 = d2(v3, m3), x3 = d2(l2(y3[0], b3[1]), l2(b3[0], y3[1]));
    if (g2(x3) || p2(i2(x3), r2.relTol)) return null;
    var S3 = l2(b3[0], h3[1]), w3 = l2(b3[1], h3[0]), E2 = l2(b3[0], v3[1]), D2 = l2(b3[1], v3[0]);
    return a2(c2(y3, u2(o2(d2(d2(S3, w3), E2), D2), x3)), h3);
  }
  function O2(t5, n3, r3, i3, a3, s3, c3, u3, p3, m3, h3, g3) {
    var v3 = l2(d2(t5, n3), d2(r3, i3)), y3 = l2(d2(a3, s3), d2(c3, u3)), b3 = l2(d2(p3, m3), d2(h3, g3));
    return o2(o2(v3, y3), b3);
  }
  function j2(t5, n3, r3, i3, a3, s3, c3, p3, h3, v3, y3, b3) {
    var x3 = O2(t5, c3, v3, c3, n3, p3, y3, p3, r3, h3, b3, h3), S3 = O2(v3, c3, i3, t5, y3, p3, a3, n3, b3, h3, s3, r3), w3 = O2(t5, c3, i3, t5, n3, p3, a3, n3, r3, h3, s3, r3), E2 = O2(v3, c3, v3, c3, y3, p3, y3, p3, b3, h3, b3, h3), D2 = O2(i3, t5, i3, t5, a3, n3, a3, n3, s3, r3, s3, r3), j3 = d2(l2(x3, S3), l2(w3, E2)), M3 = d2(l2(D2, E2), l2(S3, S3));
    if (g2(M3)) return null;
    var N2 = u2(j3, M3), F = u2(o2(x3, l2(N2, S3)), E2), I2 = o2(t5, l2(N2, d2(i3, t5))), L2 = o2(n3, l2(N2, d2(a3, n3))), R2 = o2(r3, l2(N2, d2(s3, r3))), z2 = o2(c3, l2(F, d2(v3, c3))), V2 = o2(p3, l2(F, d2(y3, p3))), H2 = o2(h3, l2(F, d2(b3, h3)));
    return m2(I2, z2) && m2(L2, V2) && m2(R2, H2) ? [I2, L2, R2] : null;
  }
  function M2(t5, n3, r3, i3, a3, s3, c3, p3, m3, h3) {
    var g3 = l2(t5, c3), v3 = l2(i3, c3), y3 = l2(n3, p3), b3 = l2(a3, p3), x3 = l2(r3, m3), S3 = l2(s3, m3), w3 = u2(d2(d2(d2(h3, g3), y3), x3), d2(d2(d2(o2(o2(v3, b3), S3), g3), y3), x3));
    return [o2(t5, l2(w3, d2(i3, t5))), o2(n3, l2(w3, d2(a3, n3))), o2(r3, l2(w3, d2(s3, r3)))];
  }
}), name$65 = `sum`, dependencies$65 = [`typed`, `config`, `add`, `numeric`], createSum = factory(name$65, dependencies$65, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4;
  return n2(name$65, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": s2, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`Scalar values expected in function sum`);
    return o2(t5);
  } });
  function o2(t5) {
    var n3;
    return deepForEach(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : i2(n3, t6);
      } catch (n4) {
        throw improveErrorMessage(n4, `sum`, t6);
      }
    }), n3 === void 0 && (n3 = a2(0, r2.number)), typeof n3 == `string` && (n3 = a2(n3, safeNumberType(n3, r2))), n3;
  }
  function s2(t5, n3) {
    try {
      return reduce$1(t5, n3, i2);
    } catch (t6) {
      throw improveErrorMessage(t6, `sum`);
    }
  }
}), name$64 = `cumsum`, dependencies$64 = [`typed`, `add`, `unaryPlus`], createCumSum = factory(name$64, dependencies$64, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4;
  return n2(name$64, { Array: a2, Matrix: function(t5) {
    return t5.create(a2(t5.valueOf(), t5.datatype()));
  }, "Array, number | BigNumber": s2, "Matrix, number | BigNumber": function(t5, n3) {
    return t5.create(s2(t5.valueOf(), n3), t5.datatype());
  }, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`All values expected to be scalar in function cumsum`);
    return a2(t5);
  } });
  function a2(t5) {
    try {
      return o2(t5);
    } catch (t6) {
      throw improveErrorMessage(t6, name$64);
    }
  }
  function o2(t5) {
    if (t5.length === 0) return [];
    for (var n3 = [i2(t5[0])], a3 = 1; a3 < t5.length; ++a3) n3.push(r2(n3[a3 - 1], t5[a3]));
    return n3;
  }
  function s2(t5, n3) {
    var r3 = arraySize(t5);
    if (n3 < 0 || n3 >= r3.length) throw new IndexError(n3, r3.length);
    try {
      return c2(t5, n3);
    } catch (t6) {
      throw improveErrorMessage(t6, name$64);
    }
  }
  function c2(t5, n3) {
    var r3, i3, a3;
    if (n3 <= 0) {
      var s3 = t5[0][0];
      if (Array.isArray(s3)) {
        for (a3 = _switch$1(t5), i3 = [], r3 = 0; r3 < a3.length; r3++) i3[r3] = c2(a3[r3], n3 - 1);
        return i3;
      } else return o2(t5);
    } else {
      for (i3 = [], r3 = 0; r3 < t5.length; r3++) i3[r3] = c2(t5[r3], n3 - 1);
      return i3;
    }
  }
}), name$63 = `mean`, dependencies$63 = [`typed`, `add`, `divide`], createMean = factory(name$63, dependencies$63, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4;
  return n2(name$63, { "Array | Matrix": o2, "Array | Matrix, number | BigNumber": a2, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`Scalar values expected in function mean`);
    return o2(t5);
  } });
  function a2(t5, n3) {
    try {
      return i2(reduce$1(t5, n3, r2), (Array.isArray(t5) ? arraySize(t5) : t5.size())[n3]);
    } catch (t6) {
      throw improveErrorMessage(t6, `mean`);
    }
  }
  function o2(t5) {
    var n3, a3 = 0;
    if (deepForEach(t5, function(t6) {
      try {
        n3 = n3 === void 0 ? t6 : r2(n3, t6), a3++;
      } catch (n4) {
        throw improveErrorMessage(n4, `mean`, t6);
      }
    }), a3 === 0) throw Error(`Cannot calculate the mean of an empty array`);
    return i2(n3, a3);
  }
}), name$62 = `median`, dependencies$62 = [`typed`, `add`, `divide`, `compare`, `partitionSelect`], createMedian = factory(name$62, dependencies$62, (t4) => {
  var { typed: n2, add: r2, divide: i2, compare: a2, partitionSelect: o2 } = t4;
  function s2(t5) {
    try {
      t5 = flatten$4(t5.valueOf());
      var n3 = t5.length;
      if (n3 === 0) throw Error(`Cannot calculate median of an empty array`);
      if (n3 % 2 == 0) {
        for (var r3 = n3 / 2 - 1, i3 = o2(t5, r3 + 1), s3 = t5[r3], u2 = 0; u2 < r3; ++u2) a2(t5[u2], s3) > 0 && (s3 = t5[u2]);
        return l2(s3, i3);
      } else return c2(o2(t5, (n3 - 1) / 2));
    } catch (t6) {
      throw improveErrorMessage(t6, `median`);
    }
  }
  var c2 = n2({ "number | BigNumber | Complex | Unit": function(t5) {
    return t5;
  } }), l2 = n2({ "number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit": function(t5, n3) {
    return i2(r2(t5, n3), 2);
  } });
  return n2(name$62, { "Array | Matrix": s2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    throw Error(`median(A, dim) is not yet supported`);
  }, "...": function(t5) {
    if (containsCollections(t5)) throw TypeError(`Scalar values expected in function median`);
    return s2(t5);
  } });
}), name$61 = `mad`, dependencies$61 = [`typed`, `abs`, `map`, `median`, `subtract`], createMad = factory(name$61, dependencies$61, (t4) => {
  var { typed: n2, abs: r2, map: i2, median: a2, subtract: o2 } = t4;
  return n2(name$61, { "Array | Matrix": s2, "...": function(t5) {
    return s2(t5);
  } });
  function s2(t5) {
    if (t5 = flatten$4(t5.valueOf()), t5.length === 0) throw Error(`Cannot calculate median absolute deviation (mad) of an empty array`);
    try {
      var n3 = a2(t5);
      return a2(i2(t5, function(t6) {
        return r2(o2(t6, n3));
      }));
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(`median`) ? TypeError(t6.message.replace(`median`, `mad`)) : improveErrorMessage(t6, `mad`);
    }
  }
}), DEFAULT_NORMALIZATION = `unbiased`, name$60 = `variance`, dependencies$60 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVariance = factory(name$60, dependencies$60, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4;
  return n2(name$60, { "Array | Matrix": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, string": l2, "Array | Matrix, number | BigNumber": function(t5, n3) {
    return u2(t5, n3, DEFAULT_NORMALIZATION);
  }, "Array | Matrix, number | BigNumber, string": u2, "...": function(t5) {
    return l2(t5, DEFAULT_NORMALIZATION);
  } });
  function l2(t5, n3) {
    var s3, l3 = 0;
    if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
    if (deepForEach(t5, function(t6) {
      try {
        s3 = s3 === void 0 ? t6 : r2(s3, t6), l3++;
      } catch (n4) {
        throw improveErrorMessage(n4, `variance`, t6);
      }
    }), l3 === 0) throw Error(`Cannot calculate variance of an empty array`);
    var u3 = o2(s3, l3);
    if (s3 = void 0, deepForEach(t5, function(t6) {
      var n4 = i2(t6, u3);
      s3 = s3 === void 0 ? a2(n4, n4) : r2(s3, a2(n4, n4));
    }), c2(s3)) return s3;
    switch (n3) {
      case `uncorrected`:
        return o2(s3, l3);
      case `biased`:
        return o2(s3, l3 + 1);
      case `unbiased`:
        var d2 = isBigNumber(s3) ? s3.mul(0) : 0;
        return l3 === 1 ? d2 : o2(s3, l3 - 1);
      default:
        throw Error(`Unknown normalization "` + n3 + `". Choose "unbiased" (default), "uncorrected", or "biased".`);
    }
  }
  function u2(t5, n3, r3) {
    try {
      if (t5.length === 0) throw SyntaxError(`Function variance requires one or more parameters (0 provided)`);
      return s2(t5, n3, (t6) => l2(t6, r3));
    } catch (t6) {
      throw improveErrorMessage(t6, `variance`);
    }
  }
}), name$59 = `quantileSeq`, dependencies$59 = [`typed`, `?bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeq = factory(name$59, dependencies$59, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4;
  return n2(name$59, { "Array | Matrix, number | BigNumber": (t5, n3) => v2(t5, n3, false), "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, false, r3, v2), "Array | Matrix, number | BigNumber, boolean": v2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, v2), "Array | Matrix, Array | Matrix": (t5, n3) => y2(t5, n3, false), "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, false, r3, y2), "Array | Matrix, Array | Matrix, boolean": y2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, i3, y2) });
  function g2(t5, n3, r3, i3, a3) {
    return h2(t5, i3, (t6) => a3(t6, n3, r3));
  }
  function v2(t5, n3, a3) {
    var s3, c3 = t5.valueOf();
    if (d2(n3, 0)) throw Error(`N/prob must be non-negative`);
    if (p2(n3, 1)) return isNumber(n3) ? b2(c3, n3, a3) : r2(b2(c3, n3, a3));
    if (m2(n3, 1)) {
      if (!u2(n3)) throw Error(`N must be a positive integer`);
      if (m2(n3, 4294967295)) throw Error(`N must be less than or equal to 2^32-1, as that is the maximum length of an Array`);
      var l3 = i2(n3, 1);
      s3 = [];
      for (var h3 = 0; d2(h3, n3); h3++) {
        var g3 = o2(h3 + 1, l3);
        s3.push(b2(c3, g3, a3));
      }
      return isNumber(n3) ? s3 : r2(s3);
    }
  }
  function y2(t5, n3, r3) {
    for (var i3 = t5.valueOf(), a3 = n3.valueOf(), o3 = [], s3 = 0; s3 < a3.length; ++s3) o3.push(b2(i3, a3[s3], r3));
    return o3;
  }
  function b2(t5, n3, r3) {
    var o3 = flatten$4(t5), d3 = o3.length;
    if (d3 === 0) throw Error(`Cannot calculate quantile of an empty sequence`);
    var p3 = isNumber(n3) ? n3 * (d3 - 1) : n3.times(d3 - 1), m3 = isNumber(n3) ? Math.floor(p3) : p3.floor().toNumber(), h3 = isNumber(n3) ? p3 % 1 : p3.minus(m3);
    if (u2(p3)) return r3 ? o3[p3] : c2(o3, isNumber(n3) ? p3 : p3.valueOf());
    var g3, v3;
    if (r3) g3 = o3[m3], v3 = o3[m3 + 1];
    else {
      v3 = c2(o3, m3 + 1), g3 = o3[m3];
      for (var y3 = 0; y3 < m3; ++y3) l2(o3[y3], g3) > 0 && (g3 = o3[y3]);
    }
    return i2(s2(g3, a2(1, h3)), s2(v3, h3));
  }
}), name$58 = `std`, dependencies$58 = [`typed`, `map`, `sqrt`, `variance`], createStd = factory(name$58, dependencies$58, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4;
  return n2(name$58, { "Array | Matrix": o2, "Array | Matrix, string": o2, "Array | Matrix, number | BigNumber": o2, "Array | Matrix, number | BigNumber, string": o2, "...": function(t5) {
    return o2(t5);
  } });
  function o2(t5, n3) {
    if (t5.length === 0) throw SyntaxError(`Function std requires one or more parameters (0 provided)`);
    try {
      var o3 = a2.apply(null, arguments);
      return isCollection(o3) ? r2(o3, i2) : i2(o3);
    } catch (t6) {
      throw t6 instanceof TypeError && t6.message.includes(` variance`) ? TypeError(t6.message.replace(` variance`, ` std`)) : t6;
    }
  }
}), name$57 = `corr`, dependencies$57 = [`typed`, `matrix`, `mean`, `sqrt`, `sum`, `add`, `subtract`, `multiply`, `pow`, `divide`], createCorr = factory(name$57, dependencies$57, (t4) => {
  var { typed: n2, matrix: r2, sqrt: i2, sum: a2, add: o2, subtract: s2, multiply: c2, pow: l2, divide: u2 } = t4;
  return n2(name$57, { "Array, Array": function(t5, n3) {
    return d2(t5, n3);
  }, "Matrix, Matrix": function(t5, n3) {
    var i3 = d2(t5.toArray(), n3.toArray());
    return Array.isArray(i3) ? r2(i3) : i3;
  } });
  function d2(t5, n3) {
    var r3 = [];
    if (Array.isArray(t5[0]) && Array.isArray(n3[0])) {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same length.`);
      for (var i3 = 0; i3 < t5.length; i3++) {
        if (t5[i3].length !== n3[i3].length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
        r3.push(p2(t5[i3], n3[i3]));
      }
      return r3;
    } else {
      if (t5.length !== n3.length) throw SyntaxError(`Dimension mismatch. Array A and B must have the same number of elements.`);
      return p2(t5, n3);
    }
  }
  function p2(t5, n3) {
    var r3 = t5.length, d3 = a2(t5), p3 = a2(n3), m2 = t5.reduce((t6, r4, i3) => o2(t6, c2(r4, n3[i3])), 0), h2 = a2(t5.map((t6) => l2(t6, 2))), g2 = a2(n3.map((t6) => l2(t6, 2)));
    return u2(s2(c2(r3, m2), c2(d3, p3)), i2(c2(s2(c2(r3, h2), l2(d3, 2)), s2(c2(r3, g2), l2(p3, 2)))));
  }
}), name$56 = `bernoulli`, dependencies$56 = [`typed`, `config`, `isInteger`, `number`, `?BigNumber`, `?Fraction`], createBernoulli = factory(name$56, dependencies$56, (t4) => {
  var { typed: n2, config: r2, number: i2, BigNumber: a2, Fraction: o2 } = t4, s2 = [void 0], c2 = [void 0], l2 = [void 0], u2 = 50;
  return n2(name$56, { number: (t5) => _bernoulli(t5, (t6) => t6, s2, (t6, n3) => t6 + n3, (t6, n3) => t6 * n3, (t6, n3) => t6 / n3), "bigint | Fraction": (t5) => _bernoulli(i2(t5), (t6) => new o2(t6), c2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3)), BigNumber: (t5) => (r2.precision !== u2 && (l2 = [void 0], u2 = r2.precision), _bernoulli(i2(t5), (t6) => new a2(t6), l2, (t6, n3) => t6.add(n3), (t6, n3) => t6.mul(n3), (t6, n3) => t6.div(n3))) });
});
function _bernoulli(t4, n2, r2, i2, a2, o2) {
  if (t4 < 0 || !isInteger(t4)) throw RangeError(`Bernoulli index must be nonnegative integer`);
  if (t4 === 0) return n2(1);
  if (t4 === 1) return o2(n2(-1), n2(2));
  if (t4 % 2 == 1) return n2(0);
  var s2 = n2(1);
  r2.length === 1 && r2.push([o2(s2, n2(-3)), o2(s2, n2(-2)), o2(s2, n2(6))]);
  for (var c2 = t4 / 2, l2 = n2(0), u2 = n2(2); r2.length <= c2; ) {
    for (var d2 = r2.length, p2 = Math.floor((d2 + 1) / 2), m2 = l2, h2 = 1; h2 < p2; ++h2) m2 = i2(m2, a2(r2[h2][0], r2[d2 - h2][0]));
    m2 = a2(m2, u2), d2 % 2 == 0 && (m2 = i2(m2, a2(r2[p2][0], r2[p2][0]))), m2 = o2(m2, n2(-(2 * d2 + 1)));
    var g2 = o2(a2(r2[d2 - 1][1], n2(-d2 * (2 * d2 - 1))), u2);
    r2.push([m2, g2, a2(g2, m2)]);
  }
  return r2[c2][2];
}
var name$55 = `combinations`, dependencies$55 = [`typed`], createCombinations = factory(name$55, dependencies$55, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$55, { "number, number": combinationsNumber, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = t5.minus(n3), s2 = new r2(1);
    if (!isPositiveInteger$2(t5) || !isPositiveInteger$2(n3)) throw TypeError(`Positive integer value expected in function combinations`);
    if (n3.gt(t5)) throw TypeError(`k must be less than n in function combinations`);
    if (i2 = s2, n3.lt(o2)) for (a2 = s2; a2.lte(o2); a2 = a2.plus(s2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = s2; a2.lte(n3); a2 = a2.plus(s2)) i2 = i2.times(o2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$2(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$54 = `combinationsWithRep`, dependencies$54 = [`typed`], createCombinationsWithRep = factory(name$54, dependencies$54, (t4) => {
  var { typed: n2 } = t4;
  return n2(name$54, { "number, number": function(t5, n3) {
    if (!isInteger(t5) || t5 < 0 || !isInteger(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5 < 1) throw TypeError(`k must be less than or equal to n + k - 1`);
    return n3 < t5 - 1 ? product(t5, t5 + n3 - 1) / product(1, n3) : product(n3 + 1, t5 + n3 - 1) / product(1, t5 - 1);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r2 = t5.constructor, i2, a2, o2 = new r2(1), s2 = t5.minus(o2);
    if (!isPositiveInteger$1(t5) || !isPositiveInteger$1(n3)) throw TypeError(`Positive integer value expected in function combinationsWithRep`);
    if (t5.lt(o2)) throw TypeError(`k must be less than or equal to n + k - 1 in function combinationsWithRep`);
    if (i2 = o2, n3.lt(s2)) for (a2 = o2; a2.lte(s2); a2 = a2.plus(o2)) i2 = i2.times(n3.plus(a2)).dividedBy(a2);
    else for (a2 = o2; a2.lte(n3); a2 = a2.plus(o2)) i2 = i2.times(s2.plus(a2)).dividedBy(a2);
    return i2;
  } });
});
function isPositiveInteger$1(t4) {
  return t4.isInteger() && t4.gte(0);
}
var name$53 = `gamma`, dependencies$53 = [`typed`, `config`, `multiplyScalar`, `pow`, `BigNumber`, `Complex`], createGamma = factory(name$53, dependencies$53, (t4) => {
  var { typed: n2, config: r2, multiplyScalar: i2, pow: a2, BigNumber: o2, Complex: s2 } = t4;
  function c2(t5) {
    if (t5.im === 0) return gammaNumber(t5.re);
    if (t5.re < 0.5) {
      var n3 = new s2(1 - t5.re, -t5.im), r3 = new s2(Math.PI * t5.re, Math.PI * t5.im);
      return new s2(Math.PI).div(r3.sin()).div(c2(n3));
    }
    t5 = new s2(t5.re - 1, t5.im);
    for (var i3 = new s2(gammaP[0], 0), a3 = 1; a3 < gammaP.length; ++a3) {
      var o3 = new s2(gammaP[a3], 0);
      i3 = i3.add(o3.div(t5.add(a3)));
    }
    var l3 = new s2(t5.re + gammaG + 0.5, t5.im), u2 = Math.sqrt(2 * Math.PI), d2 = l3.pow(t5.add(0.5)), p2 = l3.neg().exp();
    return i3.mul(u2).mul(d2).mul(p2);
  }
  return n2(name$53, { number: gammaNumber, Complex: c2, BigNumber: function(t5) {
    if (t5.isInteger()) return t5.isNegative() || t5.isZero() ? new o2(1 / 0) : l2(t5.minus(1));
    if (!t5.isFinite()) return new o2(t5.isNegative() ? NaN : 1 / 0);
    throw Error(`Integer BigNumber expected`);
  } });
  function l2(t5) {
    if (t5 < 8) return new o2([1, 1, 2, 6, 24, 120, 720, 5040][t5]);
    var n3 = r2.precision + (Math.log(t5.toNumber()) | 0), i3 = o2.clone({ precision: n3 });
    if (t5 % 2 == 1) return t5.times(l2(new o2(t5 - 1)));
    for (var a3 = t5, s3 = new i3(t5), c3 = t5.toNumber(); a3 > 2; ) a3 -= 2, c3 += a3, s3 = s3.times(c3);
    return new o2(s3.toPrecision(o2.precision));
  }
}), name$52 = `lgamma`, dependencies$52 = [`Complex`, `typed`], createLgamma = factory(name$52, dependencies$52, (t4) => {
  var { Complex: n2, typed: r2 } = t4, i2 = 7, a2 = 7, o2 = [-0.029550653594771242, 0.00641025641025641, -0.0019175269175269176, 8417508417508417e-19, -5952380952380953e-19, 7936507936507937e-19, -0.002777777777777778, 0.08333333333333333];
  return r2(name$52, { number: lgammaNumber, Complex: s2, BigNumber: function() {
    throw Error(`mathjs doesn't yet provide an implementation of the algorithm lgamma for BigNumber`);
  } });
  function s2(t5) {
    var r3 = 6.283185307179586, o3 = 1.1447298858494002, u2 = 0.1;
    if (t5.isNaN()) return new n2(NaN, NaN);
    if (t5.im === 0) return new n2(lgammaNumber(t5.re), 0);
    if (t5.re >= i2 || Math.abs(t5.im) >= a2) return c2(t5);
    if (t5.re <= u2) {
      var d2 = copysign(r3, t5.im) * Math.floor(0.5 * t5.re + 0.25), p2 = t5.mul(Math.PI).sin().log(), m2 = s2(new n2(1 - t5.re, -t5.im));
      return new n2(o3, d2).sub(p2).sub(m2);
    } else if (t5.im >= 0) return l2(t5);
    else return l2(t5.conjugate()).conjugate();
  }
  function c2(t5) {
    for (var r3 = t5.sub(0.5).mul(t5.log()).sub(t5).add(lnSqrt2PI), i3 = new n2(1, 0).div(t5), a3 = i3.div(t5), s3 = o2[0], c3 = o2[1], l3 = 2 * a3.re, u2 = a3.re * a3.re + a3.im * a3.im, d2 = 2; d2 < 8; d2++) {
      var p2 = c3;
      c3 = -u2 * s3 + o2[d2], s3 = l3 * s3 + p2;
    }
    var m2 = i3.mul(a3.mul(s3).add(c3));
    return r3.add(m2);
  }
  function l2(t5) {
    var r3 = 0, a3 = 0, o3 = t5;
    for (t5 = t5.add(1); t5.re <= i2; ) {
      o3 = o3.mul(t5);
      var s3 = +(o3.im < 0);
      s3 !== 0 && a3 === 0 && r3++, a3 = s3, t5 = t5.add(1);
    }
    return c2(t5).sub(o3.log()).sub(new n2(0, r3 * 2 * Math.PI * 1));
  }
}), name$51 = `factorial`, dependencies$51 = [`typed`, `gamma`], createFactorial = factory(name$51, dependencies$51, (t4) => {
  var { typed: n2, gamma: r2 } = t4;
  return n2(name$51, { number: function(t5) {
    if (t5 < 0) throw Error(`Value must be non-negative`);
    return r2(t5 + 1);
  }, BigNumber: function(t5) {
    if (t5.isNegative()) throw Error(`Value must be non-negative`);
    return r2(t5.plus(1));
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name$50 = `kldivergence`, dependencies$50 = [`typed`, `matrix`, `divide`, `sum`, `multiply`, `map`, `dotDivide`, `log`, `isNumeric`], createKldivergence = factory(name$50, dependencies$50, (t4) => {
  var { typed: n2, matrix: r2, divide: i2, sum: a2, multiply: o2, map: s2, dotDivide: c2, log: l2, isNumeric: u2 } = t4;
  return n2(name$50, { "Array, Array": function(t5, n3) {
    return d2(r2(t5), r2(n3));
  }, "Matrix, Array": function(t5, n3) {
    return d2(t5, r2(n3));
  }, "Array, Matrix": function(t5, n3) {
    return d2(r2(t5), n3);
  }, "Matrix, Matrix": function(t5, n3) {
    return d2(t5, n3);
  } });
  function d2(t5, n3) {
    var r3 = n3.size().length, d3 = t5.size().length;
    if (r3 > 1) throw Error(`first object must be one dimensional`);
    if (d3 > 1) throw Error(`second object must be one dimensional`);
    if (r3 !== d3) throw Error(`Length of two vectors must be equal`);
    if (a2(t5) === 0) throw Error(`Sum of elements in first object must be non zero`);
    if (a2(n3) === 0) throw Error(`Sum of elements in second object must be non zero`);
    var p2 = i2(t5, a2(t5)), m2 = a2(o2(p2, s2(c2(p2, i2(n3, a2(n3))), (t6) => l2(t6))));
    return u2(m2) ? m2 : NaN;
  }
}), name$49 = `multinomial`, dependencies$49 = [`typed`, `add`, `divide`, `multiply`, `factorial`, `isInteger`, `isPositive`], createMultinomial = factory(name$49, dependencies$49, (t4) => {
  var { typed: n2, add: r2, divide: i2, multiply: a2, factorial: o2, isInteger: s2, isPositive: c2 } = t4;
  return n2(name$49, { "Array | Matrix": function(t5) {
    var n3 = 0, l2 = 1;
    return deepForEach(t5, function(t6) {
      if (!s2(t6) || !c2(t6)) throw TypeError(`Positive integer value expected in function multinomial`);
      n3 = r2(n3, t6), l2 = a2(l2, o2(t6));
    }), i2(o2(n3), l2);
  } });
}), name$48 = `permutations`, dependencies$48 = [`typed`, `factorial`], createPermutations = factory(name$48, dependencies$48, (t4) => {
  var { typed: n2, factorial: r2 } = t4;
  return n2(name$48, { "number | BigNumber": r2, "number, number": function(t5, n3) {
    if (!isInteger(t5) || t5 < 0 || !isInteger(n3) || n3 < 0) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3 > t5) throw TypeError(`second argument k must be less than or equal to first argument n`);
    return product(t5 - n3 + 1, t5);
  }, "BigNumber, BigNumber": function(t5, n3) {
    var r3, i2;
    if (!isPositiveInteger(t5) || !isPositiveInteger(n3)) throw TypeError(`Positive integer value expected in function permutations`);
    if (n3.gt(t5)) throw TypeError(`second argument k must be less than or equal to first argument n`);
    for (r3 = t5.mul(0).add(1), i2 = t5.minus(n3).plus(1); i2.lte(t5); i2 = i2.plus(1)) r3 = r3.times(i2);
    return r3;
  } });
});
function isPositiveInteger(t4) {
  return t4.isInteger() && t4.gte(0);
}
var require_alea = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = s2();
      n4.next = function() {
        var t7 = 2091639 * n4.s0 + n4.c * 23283064365386963e-26;
        return n4.s0 = n4.s1, n4.s1 = n4.s2, n4.s2 = t7 - (n4.c = t7 | 0);
      }, n4.c = 1, n4.s0 = r3(` `), n4.s1 = r3(` `), n4.s2 = r3(` `), n4.s0 -= r3(t6), n4.s0 < 0 && (n4.s0 += 1), n4.s1 -= r3(t6), n4.s1 < 0 && (n4.s1 += 1), n4.s2 -= r3(t6), n4.s2 < 0 && (n4.s2 += 1), r3 = null;
    }
    function a2(t6, n4) {
      return n4.c = t6.c, n4.s0 = t6.s0, n4.s1 = t6.s1, n4.s2 = t6.s2, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s3 = r3.next;
      return s3.int32 = function() {
        return r3.next() * 4294967296 | 0;
      }, s3.double = function() {
        return s3() + (s3() * 2097152 | 0) * 11102230246251565e-32;
      }, s3.quick = s3, o3 && (typeof o3 == `object` && a2(o3, r3), s3.state = function() {
        return a2(r3, {});
      }), s3;
    }
    function s2() {
      var t6 = 4022871197;
      return function(n4) {
        n4 = String(n4);
        for (var r3 = 0; r3 < n4.length; r3++) {
          t6 += n4.charCodeAt(r3);
          var i3 = 0.02519603282416938 * t6;
          t6 = i3 >>> 0, i3 -= t6, i3 *= t6, t6 = i3 >>> 0, i3 -= t6, t6 += i3 * 4294967296;
        }
        return (t6 >>> 0) * 23283064365386963e-26;
      };
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.alea = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor128 = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.next = function() {
        var t7 = n4.x ^ n4.x << 11;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w ^= n4.w >>> 19 ^ t7 ^ t7 >>> 8;
      }, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor128 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorwow = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.x ^ n4.x >>> 2;
        return n4.x = n4.y, n4.y = n4.z, n4.z = n4.w, n4.w = n4.v, (n4.d = n4.d + 362437 | 0) + (n4.v = n4.v ^ n4.v << 4 ^ (t7 ^ t7 << 1)) | 0;
      }, n4.x = 0, n4.y = 0, n4.z = 0, n4.w = 0, n4.v = 0, t6 === (t6 | 0) ? n4.x = t6 : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 64; i3++) n4.x ^= r3.charCodeAt(i3) | 0, i3 == r3.length && (n4.d = n4.x << 10 ^ n4.x >>> 4), n4.next();
    }
    function a2(t6, n4) {
      return n4.x = t6.x, n4.y = t6.y, n4.z = t6.z, n4.w = t6.w, n4.v = t6.v, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorwow = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xorshift7 = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.x, r4 = n4.i, i3 = t7[r4], a3;
        return i3 ^= i3 >>> 7, a3 = i3 ^ i3 << 24, i3 = t7[r4 + 1 & 7], a3 ^= i3 ^ i3 >>> 10, i3 = t7[r4 + 3 & 7], a3 ^= i3 ^ i3 >>> 3, i3 = t7[r4 + 4 & 7], a3 ^= i3 ^ i3 << 7, i3 = t7[r4 + 7 & 7], i3 ^= i3 << 13, a3 ^= i3 ^ i3 << 9, t7[r4] = a3, n4.i = r4 + 1 & 7, a3;
      };
      function r3(t7, n5) {
        var r4, i3 = [];
        if (n5 === (n5 | 0)) i3[0] = n5;
        else for (n5 = `` + n5, r4 = 0; r4 < n5.length; ++r4) i3[r4 & 7] = i3[r4 & 7] << 15 ^ n5.charCodeAt(r4) + i3[r4 + 1 & 7] << 13;
        for (; i3.length < 8; ) i3.push(0);
        for (r4 = 0; r4 < 8 && i3[r4] === 0; ++r4) ;
        for (r4 == 8 ? i3[7] = -1 : i3[r4], t7.x = i3, t7.i = 0, r4 = 256; r4 > 0; --r4) t7.next();
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.x = t6.x.slice(), n4.i = t6.i, n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.x && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xorshift7 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_xor4096 = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this;
      n4.next = function() {
        var t7 = n4.w, r4 = n4.X, i3 = n4.i, a3, o3;
        return n4.w = t7 = t7 + 1640531527 | 0, o3 = r4[i3 + 34 & 127], a3 = r4[i3 = i3 + 1 & 127], o3 ^= o3 << 13, a3 ^= a3 << 17, o3 ^= o3 >>> 15, a3 ^= a3 >>> 12, o3 = r4[i3] = o3 ^ a3, n4.i = i3, o3 + (t7 ^ t7 >>> 16) | 0;
      };
      function r3(t7, n5) {
        var r4, i3, a3, o3, s2, c2 = [], l2 = 128;
        for (n5 === (n5 | 0) ? (i3 = n5, n5 = null) : (n5 += `\0`, i3 = 0, l2 = Math.max(l2, n5.length)), a3 = 0, o3 = -32; o3 < l2; ++o3) n5 && (i3 ^= n5.charCodeAt((o3 + 32) % n5.length)), o3 === 0 && (s2 = i3), i3 ^= i3 << 10, i3 ^= i3 >>> 15, i3 ^= i3 << 4, i3 ^= i3 >>> 13, o3 >= 0 && (s2 = s2 + 1640531527 | 0, r4 = c2[o3 & 127] ^= i3 + s2, a3 = r4 == 0 ? a3 + 1 : 0);
        for (a3 >= 128 && (c2[(n5 && n5.length || 0) & 127] = -1), a3 = 127, o3 = 512; o3 > 0; --o3) i3 = c2[a3 + 34 & 127], r4 = c2[a3 = a3 + 1 & 127], i3 ^= i3 << 13, r4 ^= r4 << 17, i3 ^= i3 >>> 15, r4 ^= r4 >>> 12, c2[a3] = i3 ^ r4;
        t7.w = s2, t7.X = c2, t7.i = a3;
      }
      r3(n4, t6);
    }
    function a2(t6, n4) {
      return n4.i = t6.i, n4.w = t6.w, n4.X = t6.X.slice(), n4;
    }
    function o2(t6, n4) {
      t6 ??= +/* @__PURE__ */ new Date();
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (o3.X && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.xor4096 = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require_tychei = __commonJSMin(((t4, n2) => {
  (function(t5, n3, r2) {
    function i2(t6) {
      var n4 = this, r3 = ``;
      n4.next = function() {
        var t7 = n4.b, r4 = n4.c, i4 = n4.d, a3 = n4.a;
        return t7 = t7 << 25 ^ t7 >>> 7 ^ r4, r4 = r4 - i4 | 0, i4 = i4 << 24 ^ i4 >>> 8 ^ a3, a3 = a3 - t7 | 0, n4.b = t7 = t7 << 20 ^ t7 >>> 12 ^ r4, n4.c = r4 = r4 - i4 | 0, n4.d = i4 << 16 ^ r4 >>> 16 ^ a3, n4.a = a3 - t7 | 0;
      }, n4.a = 0, n4.b = 0, n4.c = -1640531527, n4.d = 1367130551, t6 === Math.floor(t6) ? (n4.a = t6 / 4294967296 | 0, n4.b = t6 | 0) : r3 += t6;
      for (var i3 = 0; i3 < r3.length + 20; i3++) n4.b ^= r3.charCodeAt(i3) | 0, n4.next();
    }
    function a2(t6, n4) {
      return n4.a = t6.a, n4.b = t6.b, n4.c = t6.c, n4.d = t6.d, n4;
    }
    function o2(t6, n4) {
      var r3 = new i2(t6), o3 = n4 && n4.state, s2 = function() {
        return (r3.next() >>> 0) / 4294967296;
      };
      return s2.double = function() {
        do
          var t7 = ((r3.next() >>> 11) + (r3.next() >>> 0) / 4294967296) / (1 << 21);
        while (t7 === 0);
        return t7;
      }, s2.int32 = r3.next, s2.quick = s2, o3 && (typeof o3 == `object` && a2(o3, r3), s2.state = function() {
        return a2(r3, {});
      }), s2;
    }
    n3 && n3.exports ? n3.exports = o2 : r2 && r2.amd ? r2(function() {
      return o2;
    }) : this.tychei = o2;
  })(t4, typeof n2 == `object` && n2, typeof define == `function` && define);
})), require___vite_browser_external = __commonJSMin(((t4, n2) => {
  n2.exports = {};
})), require_seedrandom$1 = __commonJSMin(((t4, n2) => {
  (function(t5, r2, i2) {
    var a2 = 256, o2 = 6, s2 = 52, c2 = `random`, l2 = i2.pow(a2, o2), u2 = i2.pow(2, s2), d2 = u2 * 2, p2 = a2 - 1, m2;
    function h2(t6, n3, s3) {
      var p3 = [];
      n3 = n3 == 1 ? { entropy: true } : n3 || {};
      var m3 = b2(y2(n3.entropy ? [t6, S2(r2)] : t6 ?? x2(), 3), p3), h3 = new g2(p3), w2 = function() {
        for (var t7 = h3.g(o2), n4 = l2, r3 = 0; t7 < u2; ) t7 = (t7 + r3) * a2, n4 *= a2, r3 = h3.g(1);
        for (; t7 >= d2; ) t7 /= 2, n4 /= 2, r3 >>>= 1;
        return (t7 + r3) / n4;
      };
      return w2.int32 = function() {
        return h3.g(4) | 0;
      }, w2.quick = function() {
        return h3.g(4) / 4294967296;
      }, w2.double = w2, b2(S2(h3.S), r2), (n3.pass || s3 || function(t7, n4, r3, a3) {
        return a3 && (a3.S && v2(a3, h3), t7.state = function() {
          return v2(h3, {});
        }), r3 ? (i2[c2] = t7, n4) : t7;
      })(w2, m3, `global` in n3 ? n3.global : this == i2, n3.state);
    }
    function g2(t6) {
      var n3, r3 = t6.length, i3 = this, o3 = 0, s3 = i3.i = i3.j = 0, c3 = i3.S = [];
      for (r3 || (t6 = [r3++]); o3 < a2; ) c3[o3] = o3++;
      for (o3 = 0; o3 < a2; o3++) c3[o3] = c3[s3 = p2 & s3 + t6[o3 % r3] + (n3 = c3[o3])], c3[s3] = n3;
      (i3.g = function(t7) {
        for (var n4, r4 = 0, o4 = i3.i, s4 = i3.j, c4 = i3.S; t7--; ) n4 = c4[o4 = p2 & o4 + 1], r4 = r4 * a2 + c4[p2 & (c4[o4] = c4[s4 = p2 & s4 + n4]) + (c4[s4] = n4)];
        return i3.i = o4, i3.j = s4, r4;
      })(a2);
    }
    function v2(t6, n3) {
      return n3.i = t6.i, n3.j = t6.j, n3.S = t6.S.slice(), n3;
    }
    function y2(t6, n3) {
      var r3 = [], i3 = typeof t6, a3;
      if (n3 && i3 == `object`) for (a3 in t6) try {
        r3.push(y2(t6[a3], n3 - 1));
      } catch {
      }
      return r3.length ? r3 : i3 == `string` ? t6 : t6 + `\0`;
    }
    function b2(t6, n3) {
      for (var r3 = t6 + ``, i3, a3 = 0; a3 < r3.length; ) n3[p2 & a3] = p2 & (i3 ^= n3[p2 & a3] * 19) + r3.charCodeAt(a3++);
      return S2(n3);
    }
    function x2() {
      try {
        var n3;
        return m2 && (n3 = m2.randomBytes) ? n3 = n3(a2) : (n3 = new Uint8Array(a2), (t5.crypto || t5.msCrypto).getRandomValues(n3)), S2(n3);
      } catch {
        var i3 = t5.navigator, o3 = i3 && i3.plugins;
        return [+/* @__PURE__ */ new Date(), t5, o3, t5.screen, S2(r2)];
      }
    }
    function S2(t6) {
      return String.fromCharCode.apply(0, t6);
    }
    if (b2(i2.random(), r2), typeof n2 == `object` && n2.exports) {
      n2.exports = h2;
      try {
        m2 = require___vite_browser_external();
      } catch {
      }
    } else typeof define == `function` && define.amd ? define(function() {
      return h2;
    }) : i2[`seed` + c2] = h2;
  })(typeof self < `u` ? self : t4, [], Math);
})), require_seedrandom = __commonJSMin(((t4, n2) => {
  var r2 = require_alea(), i2 = require_xor128(), a2 = require_xorwow(), o2 = require_xorshift7(), s2 = require_xor4096(), c2 = require_tychei(), l2 = require_seedrandom$1();
  l2.alea = r2, l2.xor128 = i2, l2.xorwow = a2, l2.xorshift7 = o2, l2.xor4096 = s2, l2.tychei = c2, n2.exports = l2;
})), import_seedrandom = __toESM(require_seedrandom()), singletonRandom = (0, import_seedrandom.default)(Date.now());
function createRng(t4) {
  var n2;
  function r2(t5) {
    n2 = t5 === null ? singletonRandom : (0, import_seedrandom.default)(String(t5));
  }
  r2(t4);
  function i2() {
    return n2();
  }
  return i2;
}
var name$47 = `pickRandom`, dependencies$47 = [`typed`, `config`, `?on`], createPickRandom = factory(name$47, dependencies$47, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng(t5.randomSeed));
  }), n2(name$47, { "Array | Matrix": function(t5) {
    return o2(t5, {});
  }, "Array | Matrix, Object": function(t5, n3) {
    return o2(t5, n3);
  }, "Array | Matrix, number": function(t5, n3) {
    return o2(t5, { number: n3 });
  }, "Array | Matrix, Array | Matrix": function(t5, n3) {
    return o2(t5, { weights: n3 });
  }, "Array | Matrix, Array | Matrix, number": function(t5, n3, r3) {
    return o2(t5, { number: r3, weights: n3 });
  }, "Array | Matrix, number, Array | Matrix": function(t5, n3, r3) {
    return o2(t5, { number: n3, weights: r3 });
  } });
  function o2(t5, n3) {
    var { number: r3, weights: i3, elementWise: o3 = true } = n3, s2 = r3 === void 0;
    s2 && (r3 = 1);
    var c2 = isMatrix(t5) ? t5.create : isMatrix(i3) ? i3.create : null;
    t5 = t5.valueOf(), i3 &&= i3.valueOf(), o3 === true && (t5 = flatten$4(t5), i3 = flatten$4(i3));
    var l2 = 0;
    if (i3 !== void 0) {
      if (i3.length !== t5.length) throw Error(`Weights must have the same length as possibles`);
      for (var u2 = 0, d2 = i3.length; u2 < d2; u2++) {
        if (!isNumber(i3[u2]) || i3[u2] < 0) throw Error(`Weights must be an array of positive numbers`);
        l2 += i3[u2];
      }
    }
    for (var p2 = t5.length, m2 = [], h2; m2.length < r3; ) {
      if (i3 === void 0) h2 = t5[Math.floor(a2() * p2)];
      else for (var g2 = a2() * l2, v2 = 0, y2 = t5.length; v2 < y2; v2++) if (g2 -= i3[v2], g2 < 0) {
        h2 = t5[v2];
        break;
      }
      m2.push(h2);
    }
    return s2 ? m2[0] : c2 ? c2(m2) : m2;
  }
});
function randomMatrix(t4, n2) {
  var r2 = [];
  if (t4 = t4.slice(0), t4.length > 1) for (var i2 = 0, a2 = t4.shift(); i2 < a2; i2++) r2.push(randomMatrix(t4, n2));
  else for (var o2 = 0, s2 = t4.shift(); o2 < s2; o2++) r2.push(n2());
  return r2;
}
var name$46 = `random`, dependencies$46 = [`typed`, `config`, `?on`], createRandom = factory(name$46, dependencies$46, (t4) => {
  var { typed: n2, config: r2, on: i2 } = t4, a2 = createRng(r2.randomSeed);
  return i2 && i2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (a2 = createRng(t5.randomSeed));
  }), n2(name$46, { "": () => s2(0, 1), number: (t5) => s2(0, t5), "number, number": (t5, n3) => s2(t5, n3), "Array | Matrix": (t5) => o2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => o2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => o2(t5, n3, r3) });
  function o2(t5, n3, r3) {
    var i3 = randomMatrix(t5.valueOf(), () => s2(n3, r3));
    return isMatrix(t5) ? t5.create(i3, `number`) : i3;
  }
  function s2(t5, n3) {
    return t5 + a2() * (n3 - t5);
  }
}), name$45 = `randomInt`, dependencies$45 = [`typed`, `config`, `log2`, `?on`], createRandomInt = factory(name$45, dependencies$45, (t4) => {
  var { typed: n2, config: r2, log2: i2, on: a2 } = t4, o2 = createRng(r2.randomSeed);
  return a2 && a2(`config`, function(t5, n3) {
    t5.randomSeed !== n3.randomSeed && (o2 = createRng(t5.randomSeed));
  }), n2(name$45, { "": () => c2(0, 2), number: (t5) => c2(0, t5), "number, number": (t5, n3) => c2(t5, n3), bigint: (t5) => l2(0n, t5), "bigint, bigint": l2, "Array | Matrix": (t5) => s2(t5, 0, 1), "Array | Matrix, number": (t5, n3) => s2(t5, 0, n3), "Array | Matrix, number, number": (t5, n3, r3) => s2(t5, n3, r3) });
  function s2(t5, n3, r3) {
    var i3 = randomMatrix(t5.valueOf(), () => c2(n3, r3));
    return isMatrix(t5) ? t5.create(i3, `number`) : i3;
  }
  function c2(t5, n3) {
    return Math.floor(t5 + o2() * (n3 - t5));
  }
  function l2(t5, n3) {
    var r3 = 2n ** 30n, a3 = n3 - t5;
    if (a3 <= r3) return t5 + BigInt(c2(0, Number(a3)));
    for (var s3 = i2(a3), l3 = a3; l3 >= a3; ) {
      l3 = 0n;
      for (var u2 = 0; u2 < s3; ++u2) l3 = 2n * l3 + (o2() < 0.5 ? 0n : 1n);
    }
    return t5 + l3;
  }
}), name$44 = `stirlingS2`, dependencies$44 = [`typed`, `addScalar`, `subtractScalar`, `multiplyScalar`, `divideScalar`, `pow`, `factorial`, `combinations`, `isNegative`, `isInteger`, `number`, `?bignumber`, `larger`], createStirlingS2 = factory(name$44, dependencies$44, (t4) => {
  var { typed: n2, addScalar: r2, subtractScalar: i2, multiplyScalar: a2, divideScalar: o2, pow: s2, factorial: c2, combinations: l2, isNegative: u2, isInteger: d2, number: p2, bignumber: m2, larger: h2 } = t4, g2 = [], v2 = [];
  return n2(name$44, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!d2(t5) || u2(t5) || !d2(n3) || u2(n3)) throw TypeError(`Non-negative integer value expected in function stirlingS2`);
    if (h2(n3, t5)) throw TypeError(`k must be less than or equal to n in function stirlingS2`);
    var i3 = !(isNumber(t5) && isNumber(n3)), o3 = i3 ? v2 : g2, s3 = i3 ? m2 : p2, c3 = p2(t5), l3 = p2(n3);
    if (o3[c3] && o3[c3].length > l3) return o3[c3][l3];
    for (var y2 = 0; y2 <= c3; ++y2) if (o3[y2] || (o3[y2] = [s3(+(y2 === 0))]), y2 !== 0) for (var b2 = o3[y2], x2 = o3[y2 - 1], S2 = b2.length; S2 <= y2 && S2 <= l3; ++S2) S2 === y2 ? b2[S2] = 1 : b2[S2] = r2(a2(s3(S2), x2[S2]), x2[S2 - 1]);
    return o3[c3][l3];
  } });
}), name$43 = `bellNumbers`, dependencies$43 = [`typed`, `addScalar`, `isNegative`, `isInteger`, `stirlingS2`], createBellNumbers = factory(name$43, dependencies$43, (t4) => {
  var { typed: n2, addScalar: r2, isNegative: i2, isInteger: a2, stirlingS2: o2 } = t4;
  return n2(name$43, { "number | BigNumber": function(t5) {
    if (!a2(t5) || i2(t5)) throw TypeError(`Non-negative integer value expected in function bellNumbers`);
    for (var n3 = 0, s2 = 0; s2 <= t5; s2++) n3 = r2(n3, o2(t5, s2));
    return n3;
  } });
}), name$42 = `catalan`, dependencies$42 = [`typed`, `addScalar`, `divideScalar`, `multiplyScalar`, `combinations`, `isNegative`, `isInteger`], createCatalan = factory(name$42, dependencies$42, (t4) => {
  var { typed: n2, addScalar: r2, divideScalar: i2, multiplyScalar: a2, combinations: o2, isNegative: s2, isInteger: c2 } = t4;
  return n2(name$42, { "number | BigNumber": function(t5) {
    if (!c2(t5) || s2(t5)) throw TypeError(`Non-negative integer value expected in function catalan`);
    return i2(o2(a2(t5, 2), t5), r2(t5, 1));
  } });
}), name$41 = `composition`, dependencies$41 = [`typed`, `addScalar`, `combinations`, `isNegative`, `isPositive`, `isInteger`, `larger`], createComposition = factory(name$41, dependencies$41, (t4) => {
  var { typed: n2, addScalar: r2, combinations: i2, isPositive: a2, isNegative: o2, isInteger: s2, larger: c2 } = t4;
  return n2(name$41, { "number | BigNumber, number | BigNumber": function(t5, n3) {
    if (!s2(t5) || !a2(t5) || !s2(n3) || !a2(n3)) throw TypeError(`Positive integer value expected in function composition`);
    if (c2(n3, t5)) throw TypeError(`k must be less than or equal to n in function composition`);
    return i2(r2(t5, -1), r2(n3, -1));
  } });
}), name$40 = `leafCount`, dependencies$40 = [`parse`, `typed`], createLeafCount = factory(name$40, dependencies$40, (t4) => {
  var { parse: n2, typed: r2 } = t4;
  function i2(t5) {
    var n3 = 0;
    return t5.forEach((t6) => {
      n3 += i2(t6);
    }), n3 || 1;
  }
  return r2(name$40, { Node: function(t5) {
    return i2(t5);
  } });
});
function isNumericNode(t4) {
  return isConstantNode(t4) || isOperatorNode(t4) && t4.isUnary() && isConstantNode(t4.args[0]);
}
function isConstantExpression(t4) {
  return !!(isConstantNode(t4) || (isFunctionNode(t4) || isOperatorNode(t4)) && t4.args.every(isConstantExpression) || isParenthesisNode(t4) && isConstantExpression(t4.content));
}
function ownKeys$1(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread$1(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys$1(Object(r2), true).forEach(function(n3) {
      _defineProperty(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys$1(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$39 = `simplifyUtil`, dependencies$39 = [`FunctionNode`, `OperatorNode`, `SymbolNode`], createUtil = factory(name$39, dependencies$39, (t4) => {
  var { FunctionNode: n2, OperatorNode: r2, SymbolNode: i2 } = t4, a2 = true, o2 = false, s2 = `defaultF`, c2 = { add: { trivial: a2, total: a2, commutative: a2, associative: a2 }, unaryPlus: { trivial: a2, total: a2, commutative: a2, associative: a2 }, subtract: { trivial: o2, total: a2, commutative: o2, associative: o2 }, multiply: { trivial: a2, total: a2, commutative: a2, associative: a2 }, divide: { trivial: o2, total: a2, commutative: o2, associative: o2 }, paren: { trivial: a2, total: a2, commutative: a2, associative: o2 }, defaultF: { trivial: o2, total: a2, commutative: o2, associative: o2 } }, l2 = { divide: { total: o2 }, log: { total: o2 } }, u2 = { subtract: { total: o2 }, abs: { trivial: a2 }, log: { total: a2 } };
  function d2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : c2, i3 = s2;
    if (typeof t5 == `string` ? i3 = t5 : isOperatorNode(t5) ? i3 = t5.fn.toString() : isFunctionNode(t5) ? i3 = t5.name : isParenthesisNode(t5) && (i3 = `paren`), hasOwnProperty$1$1(r3, i3)) {
      var a3 = r3[i3];
      if (hasOwnProperty$1$1(a3, n3)) return a3[n3];
      if (hasOwnProperty$1$1(c2, i3)) return c2[i3][n3];
    }
    if (hasOwnProperty$1$1(r3, s2)) {
      var o3 = r3[s2];
      return hasOwnProperty$1$1(o3, n3) ? o3[n3] : c2[s2][n3];
    }
    if (hasOwnProperty$1$1(c2, i3)) {
      var l3 = c2[i3];
      if (hasOwnProperty$1$1(l3, n3)) return l3[n3];
    }
    return c2[s2][n3];
  }
  function p2(t5) {
    return d2(t5, `commutative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function m2(t5) {
    return d2(t5, `associative`, arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : c2);
  }
  function h2(t5, n3) {
    var r3 = _objectSpread$1({}, t5);
    for (var i3 in n3) hasOwnProperty$1$1(t5, i3) ? r3[i3] = _objectSpread$1(_objectSpread$1({}, n3[i3]), t5[i3]) : r3[i3] = n3[i3];
    return r3;
  }
  function g2(t5, n3) {
    if (!t5.args || t5.args.length === 0) return t5;
    t5.args = v2(t5, n3);
    for (var r3 = 0; r3 < t5.args.length; r3++) g2(t5.args[r3], n3);
  }
  function v2(t5, n3) {
    var r3, i3 = [], a3 = function(t6) {
      for (var n4 = 0; n4 < t6.args.length; n4++) {
        var o3 = t6.args[n4];
        isOperatorNode(o3) && r3 === o3.op ? a3(o3) : i3.push(o3);
      }
    };
    return m2(t5, n3) ? (r3 = t5.op, a3(t5), i3) : t5.args;
  }
  function y2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) y2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.pop(); t5.args.length > 0; ) o3 = r3([t5.args.pop(), o3]);
        t5.args = o3.args;
      }
    }
  }
  function b2(t5, n3) {
    if (!(!t5.args || t5.args.length === 0)) {
      for (var r3 = x2(t5), i3 = t5.args.length, a3 = 0; a3 < i3; a3++) b2(t5.args[a3], n3);
      if (i3 > 2 && m2(t5, n3)) {
        for (var o3 = t5.args.shift(); t5.args.length > 0; ) o3 = r3([o3, t5.args.shift()]);
        t5.args = o3.args;
      }
    }
  }
  function x2(t5) {
    return isOperatorNode(t5) ? function(n3) {
      try {
        return new r2(t5.op, t5.fn, n3, t5.implicit);
      } catch (t6) {
        return console.error(t6), [];
      }
    } : function(r3) {
      return new n2(new i2(t5.name), r3);
    };
  }
  return { createMakeNodeFunction: x2, hasProperty: d2, isCommutative: p2, isAssociative: m2, mergeContext: h2, flatten: g2, allChildren: v2, unflattenr: y2, unflattenl: b2, defaultContext: c2, realContext: l2, positiveContext: u2 };
}), name$38 = `simplify`, dependencies$38 = [`typed`, `parse`, `equal`, `resolve`, `simplifyConstant`, `simplifyCore`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`, `replacer`], createSimplify = factory(name$38, dependencies$38, (t4) => {
  var { typed: n2, parse: r2, equal: i2, resolve: a2, simplifyConstant: o2, simplifyCore: s2, AccessorNode: c2, ArrayNode: l2, ConstantNode: u2, FunctionNode: d2, IndexNode: p2, ObjectNode: m2, OperatorNode: h2, ParenthesisNode: g2, SymbolNode: v2, replacer: y2 } = t4, { hasProperty: b2, isCommutative: x2, isAssociative: S2, mergeContext: w2, flatten: E, unflattenr: D, unflattenl: O2, createMakeNodeFunction: j2, defaultContext: M2, realContext: N2, positiveContext: F } = createUtil({ FunctionNode: d2, OperatorNode: h2, SymbolNode: v2 });
  n2.addConversion({ from: `Object`, to: `Map`, convert: createMap$1 });
  var I2 = n2(`simplify`, { Node: W2, "Node, Map": (t5, n3) => W2(t5, false, n3), "Node, Map, Object": (t5, n3, r3) => W2(t5, false, n3, r3), "Node, Array": W2, "Node, Array, Map": W2, "Node, Array, Map, Object": W2 });
  n2.removeConversion({ from: `Object`, to: `Map`, convert: createMap$1 }), I2.defaultContext = M2, I2.realContext = N2, I2.positiveContext = F;
  function L2(t5) {
    return t5.transform(function(t6) {
      return isParenthesisNode(t6) ? L2(t6.content) : t6;
    });
  }
  var R2 = { true: true, false: true, e: true, i: true, Infinity: true, LN2: true, LN10: true, LOG2E: true, LOG10E: true, NaN: true, phi: true, pi: true, SQRT1_2: true, SQRT2: true, tau: true };
  I2.rules = [s2, { l: `log(e)`, r: `1` }, { s: `n-n1 -> n+-n1`, assuming: { subtract: { total: true } } }, { s: `n-n -> 0`, assuming: { subtract: { total: false } } }, { s: `-(cl*v) -> v * (-cl)`, assuming: { multiply: { commutative: true }, subtract: { total: true } } }, { s: `-(cl*v) -> (-cl) * v`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { s: `-(v*cl) -> v * (-cl)`, assuming: { multiply: { commutative: false }, subtract: { total: true } } }, { l: `-(n1/n2)`, r: `-n1/n2` }, { l: `-v`, r: `v * (-1)` }, { l: `(n1 + n2)*(-1)`, r: `n1*(-1) + n2*(-1)`, repeat: true }, { l: `n/n1^n2`, r: `n*n1^-n2` }, { l: `n/n1`, r: `n*n1^-1` }, { s: `(n1*n2)^n3 -> n1^n3 * n2^n3`, assuming: { multiply: { commutative: true } } }, { s: `(n1*n2)^(-1) -> n2^(-1) * n1^(-1)`, assuming: { multiply: { commutative: false } } }, { s: `(n ^ n1) ^ n2 -> n ^ (n1 * n2)`, assuming: { divide: { total: true } } }, { l: ` vd   * ( vd   * n1 + n2)`, r: `vd^2       * n1 +  vd   * n2` }, { s: ` vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { s: `vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2`, assuming: { divide: { total: true } } }, { l: `n*n`, r: `n^2` }, { s: `n * n^n1 -> n^(n1+1)`, assuming: { divide: { total: true } } }, { s: `n^n1 * n^n2 -> n^(n1+n2)`, assuming: { divide: { total: true } } }, o2, { s: `n+n -> 2*n`, assuming: { add: { total: true } } }, { l: `n+-n`, r: `0` }, { l: `vd*n + vd`, r: `vd*(n+1)` }, { l: `n3*n1 + n3*n2`, r: `n3*(n1+n2)` }, { l: `n3^(-n4)*n1 +   n3  * n2`, r: `n3^(-n4)*(n1 + n3^(n4+1) *n2)` }, { l: `n3^(-n4)*n1 + n3^n5 * n2`, r: `n3^(-n4)*(n1 + n3^(n4+n5)*n2)` }, { s: `n*vd + vd -> (n+1)*vd`, assuming: { multiply: { commutative: false } } }, { s: `vd + n*vd -> (1+n)*vd`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3 + n2*n3 -> (n1+n2)*n3`, assuming: { multiply: { commutative: false } } }, { s: `n^n1 * n -> n^(n1+1)`, assuming: { divide: { total: true }, multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { s: `n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)`, assuming: { multiply: { commutative: false } } }, { l: `n*cd + cd`, r: `(n+1)*cd` }, { s: `cd*n + cd -> cd*(n+1)`, assuming: { multiply: { commutative: false } } }, { s: `cd + cd*n -> cd*(1+n)`, assuming: { multiply: { commutative: false } } }, o2, { s: `(-n)*n1 -> -(n*n1)`, assuming: { subtract: { total: true } } }, { s: `n1*(-n) -> -(n1*n)`, assuming: { subtract: { total: true }, multiply: { commutative: false } } }, { s: `ce+ve -> ve+ce`, assuming: { add: { commutative: true } }, imposeContext: { add: { commutative: false } } }, { s: `vd*cd -> cd*vd`, assuming: { multiply: { commutative: true } }, imposeContext: { multiply: { commutative: false } } }, { l: `n+-n1`, r: `n-n1` }, { l: `n+-(n1)`, r: `n-(n1)` }, { s: `n*(n1^-1) -> n/n1`, assuming: { multiply: { commutative: true } } }, { s: `n*n1^-n2 -> n/n1^n2`, assuming: { multiply: { commutative: true } } }, { s: `n^-1 -> 1/n`, assuming: { multiply: { commutative: true } } }, { l: `n^1`, r: `n` }, { s: `n*(n1/n2) -> (n*n1)/n2`, assuming: { multiply: { associative: true } } }, { s: `n-(n1+n2) -> n-n1-n2`, assuming: { addition: { associative: true, commutative: true } } }, { l: `1*n`, r: `n`, imposeContext: { multiply: { commutative: true } } }, { s: `n1/(n2/n3) -> (n1*n3)/n2`, assuming: { multiply: { associative: true } } }, { l: `n1/(-n2)`, r: `-n1/n2` }];
  function z2(t5, n3) {
    var i3 = {};
    if (t5.s) {
      var a3 = t5.s.split(`->`);
      if (a3.length === 2) i3.l = a3[0], i3.r = a3[1];
      else throw SyntaxError(`Could not parse rule: ` + t5.s);
    } else i3.l = t5.l, i3.r = t5.r;
    i3.l = L2(r2(i3.l)), i3.r = L2(r2(i3.r));
    for (var o3 of [`imposeContext`, `repeat`, `assuming`]) o3 in t5 && (i3[o3] = t5[o3]);
    if (t5.evaluate && (i3.evaluate = r2(t5.evaluate)), S2(i3.l, n3)) {
      var s3 = !x2(i3.l, n3), c3;
      s3 && (c3 = U2());
      var l3 = j2(i3.l), u3 = U2();
      i3.expanded = {}, i3.expanded.l = l3([i3.l, u3]), E(i3.expanded.l, n3), D(i3.expanded.l, n3), i3.expanded.r = l3([i3.r, u3]), s3 && (i3.expandedNC1 = {}, i3.expandedNC1.l = l3([c3, i3.l]), i3.expandedNC1.r = l3([c3, i3.r]), i3.expandedNC2 = {}, i3.expandedNC2.l = l3([c3, i3.expanded.l]), i3.expandedNC2.r = l3([c3, i3.expanded.r]));
    }
    return i3;
  }
  function V2(t5, n3) {
    for (var r3 = [], i3 = 0; i3 < t5.length; i3++) {
      var a3 = t5[i3], o3 = void 0, s3 = typeof a3;
      switch (s3) {
        case `string`:
          a3 = { s: a3 };
        case `object`:
          o3 = z2(a3, n3);
          break;
        case `function`:
          o3 = a3;
          break;
        default:
          throw TypeError(`Unsupported type of rule: ` + s3);
      }
      r3.push(o3);
    }
    return r3;
  }
  var H2 = 0;
  function U2() {
    return new v2(`_p` + H2++);
  }
  function W2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : createEmptyMap(), i3 = arguments.length > 3 && arguments[3] !== void 0 ? arguments[3] : {}, o3 = i3.consoleDebug;
    n3 = V2(n3 || I2.rules, i3.context);
    var s3 = a2(t5, r3);
    s3 = L2(s3);
    for (var c3 = {}, l3 = s3.toString({ parenthesis: `all` }); !c3[l3]; ) {
      c3[l3] = true, H2 = 0;
      var u3 = l3;
      o3 && console.log(`Working on: `, l3);
      for (var d3 = 0; d3 < n3.length; d3++) {
        var p3 = ``;
        if (typeof n3[d3] == `function` ? (s3 = n3[d3](s3, i3), o3 && (p3 = n3[d3].name)) : (E(s3, i3.context), s3 = K2(s3, n3[d3], i3.context), o3 && (p3 = `${n3[d3].l.toString()} -> ${n3[d3].r.toString()}`)), o3) {
          var m3 = s3.toString({ parenthesis: `all` });
          m3 !== u3 && (console.log(`Applying`, p3, `produced`, m3), u3 = m3);
        }
        O2(s3, i3.context);
      }
      l3 = s3.toString({ parenthesis: `all` });
    }
    return s3;
  }
  function G2(t5, n3, r3) {
    var i3 = t5;
    if (t5) for (var a3 = 0; a3 < t5.length; ++a3) {
      var o3 = K2(t5[a3], n3, r3);
      o3 !== t5[a3] && (i3 === t5 && (i3 = t5.slice()), i3[a3] = o3);
    }
    return i3;
  }
  function K2(t5, n3, r3) {
    if (n3.assuming) {
      for (var i3 in n3.assuming) for (var a3 in n3.assuming[i3]) if (b2(i3, a3, r3) !== n3.assuming[i3][a3]) return t5;
    }
    var o3 = w2(n3.imposeContext, r3), s3 = t5;
    if (s3 instanceof h2 || s3 instanceof d2) {
      var u3 = G2(s3.args, n3, r3);
      u3 !== s3.args && (s3 = s3.clone(), s3.args = u3);
    } else if (s3 instanceof g2) {
      if (s3.content) {
        var v3 = K2(s3.content, n3, r3);
        v3 !== s3.content && (s3 = new g2(v3));
      }
    } else if (s3 instanceof l2) {
      var y3 = G2(s3.items, n3, r3);
      y3 !== s3.items && (s3 = new l2(y3));
    } else if (s3 instanceof c2) {
      var x3 = s3.object;
      s3.object && (x3 = K2(s3.object, n3, r3));
      var S3 = s3.index;
      s3.index && (S3 = K2(s3.index, n3, r3)), (x3 !== s3.object || S3 !== s3.index) && (s3 = new c2(x3, S3));
    } else if (s3 instanceof p2) {
      var E2 = G2(s3.dimensions, n3, r3);
      E2 !== s3.dimensions && (s3 = new p2(E2));
    } else if (s3 instanceof m2) {
      var D2 = false, O22 = {};
      for (var j3 in s3.properties) O22[j3] = K2(s3.properties[j3], n3, r3), O22[j3] !== s3.properties[j3] && (D2 = true);
      D2 && (s3 = new m2(O22));
    }
    var M3 = n3.r, N3 = te2(n3.l, s3, o3)[0];
    if (!N3 && n3.expanded && (M3 = n3.expanded.r, N3 = te2(n3.expanded.l, s3, o3)[0]), !N3 && n3.expandedNC1 && (M3 = n3.expandedNC1.r, N3 = te2(n3.expandedNC1.l, s3, o3)[0], N3 ||= (M3 = n3.expandedNC2.r, te2(n3.expandedNC2.l, s3, o3)[0])), N3) {
      var F2 = s3.implicit;
      s3 = M3.clone(), F2 && `implicit` in M3 && (s3.implicit = true), s3 = s3.transform(function(t6) {
        return t6.isSymbolNode && hasOwnProperty$1$1(N3.placeholders, t6.name) ? N3.placeholders[t6.name].clone() : t6;
      });
    }
    return n3.repeat && s3 !== t5 && (s3 = K2(s3, n3, r3)), s3;
  }
  function q2(t5, n3) {
    var r3 = [], i3, a3, o3 = j2(t5);
    if (x2(t5, n3)) for (var s3 = 0; s3 < t5.args.length; s3++) a3 = t5.args.slice(0), a3.splice(s3, 1), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([t5.args[s3], i3]));
    else for (var c3 = 1; c3 < t5.args.length; c3++) {
      var l3 = t5.args[0];
      c3 > 1 && (l3 = o3(t5.args.slice(0, c3))), a3 = t5.args.slice(c3), i3 = a3.length === 1 ? a3[0] : o3(a3), r3.push(o3([l3, i3]));
    }
    return r3;
  }
  function J(t5, n3) {
    var r3 = { placeholders: {} };
    if (!t5.placeholders && !n3.placeholders) return r3;
    if (!t5.placeholders) return n3;
    if (!n3.placeholders) return t5;
    for (var i3 in t5.placeholders) if (hasOwnProperty$1$1(t5.placeholders, i3) && (r3.placeholders[i3] = t5.placeholders[i3], hasOwnProperty$1$1(n3.placeholders, i3) && !ne2(t5.placeholders[i3], n3.placeholders[i3]))) return null;
    for (var a3 in n3.placeholders) hasOwnProperty$1$1(n3.placeholders, a3) && (r3.placeholders[a3] = n3.placeholders[a3]);
    return r3;
  }
  function ee2(t5, n3) {
    var r3 = [];
    if (t5.length === 0 || n3.length === 0) return r3;
    for (var i3, a3 = 0; a3 < t5.length; a3++) for (var o3 = 0; o3 < n3.length; o3++) i3 = J(t5[a3], n3[o3]), i3 && r3.push(i3);
    return r3;
  }
  function Y2(t5) {
    if (t5.length === 0) return t5;
    for (var n3 = t5.reduce(ee2), r3 = [], i3 = {}, a3 = 0; a3 < n3.length; a3++) {
      var o3 = JSON.stringify(n3[a3], y2);
      i3[o3] || (i3[o3] = true, r3.push(n3[a3]));
    }
    return r3;
  }
  function te2(t5, n3, r3, a3) {
    var o3 = [{ placeholders: {} }];
    if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return [];
      } else if (t5 instanceof d2 && t5.name !== n3.name) return [];
      if (n3.args.length === 1 && t5.args.length === 1 || !S2(n3, r3) && n3.args.length === t5.args.length || a3) {
        for (var s3 = [], c3 = 0; c3 < t5.args.length; c3++) {
          var l3 = te2(t5.args[c3], n3.args[c3], r3);
          if (l3.length === 0) break;
          s3.push(l3);
        }
        if (s3.length !== t5.args.length) {
          if (!x2(n3, r3) || t5.args.length === 1) return [];
          if (t5.args.length > 2) throw Error(`permuting >2 commutative non-associative rule arguments not yet implemented`);
          var p3 = te2(t5.args[0], n3.args[1], r3);
          if (p3.length === 0) return [];
          var m3 = te2(t5.args[1], n3.args[0], r3);
          if (m3.length === 0) return [];
          s3 = [p3, m3];
        }
        o3 = Y2(s3);
      } else if (n3.args.length >= 2 && t5.args.length === 2) {
        for (var g3 = q2(n3, r3), y3 = [], b3 = 0; b3 < g3.length; b3++) {
          var w3 = te2(t5, g3[b3], r3, true);
          y3 = y3.concat(w3);
        }
        return y3;
      } else if (t5.args.length > 2) throw Error(`Unexpected non-binary associative function: ` + t5.toString());
      else return [];
    } else if (t5 instanceof v2) {
      if (t5.name.length === 0) throw Error(`Symbol in rule has 0 length...!?`);
      if (R2[t5.name]) {
        if (t5.name !== n3.name) return [];
      } else switch (t5.name[1] >= `a` && t5.name[1] <= `z` ? t5.name.substring(0, 2) : t5.name[0]) {
        case `n`:
        case `_p`:
          o3[0].placeholders[t5.name] = n3;
          break;
        case `c`:
        case `cl`:
          if (isConstantNode(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `v`:
          if (!isConstantNode(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vl`:
          if (isSymbolNode(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `cd`:
          if (isNumericNode(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `vd`:
          if (!isNumericNode(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ce`:
          if (isConstantExpression(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        case `ve`:
          if (!isConstantExpression(n3)) o3[0].placeholders[t5.name] = n3;
          else return [];
          break;
        default:
          throw Error(`Invalid symbol in rule: ` + t5.name);
      }
    } else if (t5 instanceof u2) {
      if (!i2(t5.value, n3.value)) return [];
    } else return [];
    return o3;
  }
  function ne2(t5, n3) {
    if (t5 instanceof u2 && n3 instanceof u2) {
      if (!i2(t5.value, n3.value)) return false;
    } else if (t5 instanceof v2 && n3 instanceof v2) {
      if (t5.name !== n3.name) return false;
    } else if (t5 instanceof h2 && n3 instanceof h2 || t5 instanceof d2 && n3 instanceof d2) {
      if (t5 instanceof h2) {
        if (t5.op !== n3.op || t5.fn !== n3.fn) return false;
      } else if (t5 instanceof d2 && t5.name !== n3.name) return false;
      if (t5.args.length !== n3.args.length) return false;
      for (var r3 = 0; r3 < t5.args.length; r3++) if (!ne2(t5.args[r3], n3.args[r3])) return false;
    } else return false;
    return true;
  }
  return I2;
}), name$37 = `simplifyConstant`, dependencies$37 = [`typed`, `config`, `mathWithTransform`, `matrix`, `isBounded`, `?fraction`, `?bignumber`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `SymbolNode`], createSimplifyConstant = factory(name$37, dependencies$37, (t4) => {
  var { typed: n2, config: r2, mathWithTransform: i2, matrix: a2, isBounded: o2, fraction: s2, bignumber: c2, AccessorNode: l2, ArrayNode: u2, ConstantNode: d2, FunctionNode: p2, IndexNode: m2, ObjectNode: h2, OperatorNode: g2, SymbolNode: v2 } = t4, { isCommutative: y2, isAssociative: b2, allChildren: x2, createMakeNodeFunction: S2 } = createUtil({ FunctionNode: p2, OperatorNode: g2, SymbolNode: v2 }), w2 = n2(`simplifyConstant`, { Node: (t5) => j2(z2(t5, {})), "Node, Object": function(t5, n3) {
    return j2(z2(t5, n3));
  } });
  function E(t5) {
    return isFraction(t5) ? t5.valueOf() : t5 instanceof Array ? t5.map(E) : isMatrix(t5) ? a2(E(t5.valueOf())) : t5;
  }
  function D(t5, n3, r3) {
    try {
      return i2[t5].apply(null, n3);
    } catch {
      return n3 = n3.map(E), N2(i2[t5].apply(null, n3), r3);
    }
  }
  var O2 = n2({ Fraction: I2, number: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, BigNumber: function(t5) {
    return t5 < 0 ? F(new d2(-t5)) : new d2(t5);
  }, bigint: function(t5) {
    return t5 < 0n ? F(new d2(-t5)) : new d2(t5);
  }, Complex: function(t5) {
    throw Error(`Cannot convert Complex number to Node`);
  }, string: function(t5) {
    return new d2(t5);
  }, Matrix: function(t5) {
    return new u2(t5.valueOf().map((t6) => O2(t6)));
  } });
  function j2(t5) {
    return isNode$2(t5) ? t5 : O2(t5);
  }
  function M2(t5, n3) {
    if (n3 && n3.exactFractions !== false && o2(t5) && s2) {
      var r3 = s2(t5), i3 = n3 && typeof n3.fractionsLimit == `number` ? n3.fractionsLimit : 1 / 0;
      if (r3.valueOf() === t5 && r3.n < i3 && r3.d < i3) return r3;
    }
    return t5;
  }
  var N2 = n2({ "string, Object": function(t5, n3) {
    var i3 = safeNumberType(t5, r2);
    return i3 === `BigNumber` ? (c2 === void 0 && noBignumber(), c2(t5)) : i3 === `bigint` ? BigInt(t5) : i3 === `Fraction` ? (s2 === void 0 && noFraction(), s2(t5)) : M2(parseFloat(t5), n3);
  }, "Fraction, Object": function(t5, n3) {
    return t5;
  }, "BigNumber, Object": function(t5, n3) {
    return t5;
  }, "number, Object": function(t5, n3) {
    return M2(t5, n3);
  }, "bigint, Object": function(t5, n3) {
    return t5;
  }, "Complex, Object": function(t5, n3) {
    return t5.im === 0 ? M2(t5.re, n3) : t5;
  }, "Matrix, Object": function(t5, n3) {
    return a2(M2(t5.valueOf()));
  }, "Array, Object": function(t5, n3) {
    return t5.map(M2);
  } });
  function F(t5) {
    return new g2(`-`, `unaryMinus`, [t5]);
  }
  function I2(t5) {
    var n3 = (t6) => r2.number === `BigNumber` && c2 ? c2(t6) : Number(t6), i3 = t5.s * t5.n, a3 = i3 < 0n ? new g2(`-`, `unaryMinus`, [new d2(-n3(i3))]) : new d2(n3(i3));
    return t5.d === 1n ? a3 : new g2(`/`, `divide`, [a3, new d2(n3(t5.d))]);
  }
  function L2(t5, n3, r3) {
    if (!isIndexNode(n3)) return new l2(j2(t5), j2(n3));
    if (isArrayNode(t5) || isMatrix(t5)) {
      for (var i3 = Array.from(n3.dimensions); i3.length > 0; ) if (isConstantNode(i3[0]) && typeof i3[0].value != `string`) {
        var o3 = N2(i3.shift().value, r3);
        isArrayNode(t5) ? t5 = t5.items[o3 - 1] : (t5 = t5.valueOf()[o3 - 1], t5 instanceof Array && (t5 = a2(t5)));
      } else if (i3.length > 1 && isConstantNode(i3[1]) && typeof i3[1].value != `string`) {
        var s3 = N2(i3[1].value, r3), c3 = [], p3 = isArrayNode(t5) ? t5.items : t5.valueOf();
        for (var h3 of p3) if (isArrayNode(h3)) c3.push(h3.items[s3 - 1]);
        else if (isMatrix(t5)) c3.push(h3[s3 - 1]);
        else break;
        if (c3.length === p3.length) t5 = isArrayNode(t5) ? new u2(c3) : a2(c3), i3.splice(1, 1);
        else break;
      } else break;
      return i3.length === n3.dimensions.length ? new l2(j2(t5), n3) : i3.length > 0 ? (n3 = new m2(i3), new l2(j2(t5), n3)) : t5;
    }
    if (isObjectNode(t5) && n3.dimensions.length === 1 && isConstantNode(n3.dimensions[0])) {
      var g3 = n3.dimensions[0].value;
      return g3 in t5.properties ? t5.properties[g3] : new d2();
    }
    return new l2(j2(t5), n3);
  }
  function R2(t5, n3, r3, i3) {
    var a3 = n3.shift(), o3 = n3.reduce((n4, a4) => {
      if (!isNode$2(a4)) {
        var o4 = n4.pop();
        if (isNode$2(o4)) return [o4, a4];
        try {
          return n4.push(D(t5, [o4, a4], i3)), n4;
        } catch {
          n4.push(o4);
        }
      }
      return n4.push(j2(n4.pop())), [r3([n4.length === 1 ? n4[0] : r3(n4), j2(a4)])];
    }, [a3]);
    return o3.length === 1 ? o3[0] : r3([o3[0], O2(o3[1])]);
  }
  function z2(t5, n3) {
    switch (t5.type) {
      case `SymbolNode`:
        return t5;
      case `ConstantNode`:
        switch (typeof t5.value) {
          case `number`:
            return N2(t5.value, n3);
          case `bigint`:
            return N2(t5.value, n3);
          case `string`:
            return t5.value;
          default:
            if (!isNaN(t5.value)) return N2(t5.value, n3);
        }
        return t5;
      case `FunctionNode`:
        if (i2[t5.name] && i2[t5.name].rawArgs) return t5;
        if (![`add`, `multiply`].includes(t5.name)) {
          var r3 = t5.args.map((t6) => z2(t6, n3));
          if (!r3.some(isNode$2)) try {
            return D(t5.name, r3, n3);
          } catch {
          }
          if (t5.name === `size` && r3.length === 1 && isArrayNode(r3[0])) {
            for (var o3 = [], s3 = r3[0]; isArrayNode(s3); ) o3.push(s3.items.length), s3 = s3.items[0];
            return a2(o3);
          }
          return new p2(t5.name, r3.map(j2));
        }
      case `OperatorNode`:
        var c3 = t5.fn.toString(), l3, d3, g3 = S2(t5);
        if (isOperatorNode(t5) && t5.isUnary()) l3 = [z2(t5.args[0], n3)], d3 = isNode$2(l3[0]) ? g3(l3) : D(c3, l3, n3);
        else if (b2(t5, n3.context)) if (l3 = x2(t5, n3.context), l3 = l3.map((t6) => z2(t6, n3)), y2(c3, n3.context)) {
          for (var v3 = [], E2 = [], O22 = 0; O22 < l3.length; O22++) isNode$2(l3[O22]) ? E2.push(l3[O22]) : v3.push(l3[O22]);
          v3.length > 1 ? (d3 = R2(c3, v3, g3, n3), E2.unshift(d3), d3 = R2(c3, E2, g3, n3)) : d3 = R2(c3, l3, g3, n3);
        } else d3 = R2(c3, l3, g3, n3);
        else l3 = t5.args.map((t6) => z2(t6, n3)), d3 = R2(c3, l3, g3, n3);
        return d3;
      case `ParenthesisNode`:
        return z2(t5.content, n3);
      case `AccessorNode`:
        return L2(z2(t5.object, n3), z2(t5.index, n3), n3);
      case `ArrayNode`:
        var M3 = t5.items.map((t6) => z2(t6, n3));
        return M3.some(isNode$2) ? new u2(M3.map(j2)) : a2(M3);
      case `IndexNode`:
        return new m2(t5.dimensions.map((t6) => w2(t6, n3)));
      case `ObjectNode`:
        var F2 = {};
        for (var I22 in t5.properties) F2[I22] = w2(t5.properties[I22], n3);
        return new h2(F2);
      default:
        throw Error(`Unimplemented node type in simplifyConstant: ${t5.type}`);
    }
  }
  return w2;
}), name$36 = `simplifyCore`, dependencies$36 = [`typed`, `parse`, `equal`, `isZero`, `add`, `subtract`, `multiply`, `divide`, `pow`, `AccessorNode`, `ArrayNode`, `ConstantNode`, `FunctionNode`, `IndexNode`, `ObjectNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createSimplifyCore = factory(name$36, dependencies$36, (t4) => {
  var { typed: n2, parse: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, AccessorNode: d2, ArrayNode: p2, ConstantNode: m2, FunctionNode: h2, IndexNode: g2, ObjectNode: v2, OperatorNode: y2, ParenthesisNode: b2, SymbolNode: x2 } = t4, S2 = new m2(0), w2 = new m2(1), E = new m2(true), D = new m2(false);
  function O2(t5) {
    return isOperatorNode(t5) && [`and`, `not`, `or`].includes(t5.op);
  }
  var { hasProperty: j2, isCommutative: M2 } = createUtil({ FunctionNode: h2, OperatorNode: y2, SymbolNode: x2 });
  function N2(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = n3 ? n3.context : void 0;
    if (j2(t5, `trivial`, r3)) {
      if (isFunctionNode(t5) && t5.args.length === 1) return N2(t5.args[0], n3);
      var o3 = false, s3 = 0;
      if (t5.forEach((t6) => {
        ++s3, s3 === 1 && (o3 = N2(t6, n3));
      }), s3 === 1) return o3;
    }
    var c3 = t5;
    if (isFunctionNode(c3)) {
      var l3 = getOperator(c3.name);
      if (l3) {
        if (c3.args.length > 2 && j2(c3, `associative`, r3)) for (; c3.args.length > 2; ) {
          var u3 = c3.args.pop(), m3 = c3.args.pop();
          c3.args.push(new y2(l3, c3.name, [u3, m3]));
        }
        c3 = new y2(l3, c3.name, c3.args);
      } else return new h2(N2(c3.fn), c3.args.map((t6) => N2(t6, n3)));
    }
    if (isOperatorNode(c3) && c3.isUnary()) {
      var b3 = N2(c3.args[0], n3);
      if (c3.op === `~` && isOperatorNode(b3) && b3.isUnary() && b3.op === `~` || c3.op === `not` && isOperatorNode(b3) && b3.isUnary() && b3.op === `not` && O2(b3.args[0])) return b3.args[0];
      var x3 = true;
      if (c3.op === `-` && isOperatorNode(b3) && (b3.isBinary() && b3.fn === `subtract` && (c3 = new y2(`-`, `subtract`, [b3.args[1], b3.args[0]]), x3 = false), b3.isUnary() && b3.op === `-`)) return b3.args[0];
      if (x3) return new y2(c3.op, c3.fn, [b3]);
    }
    if (isOperatorNode(c3) && c3.isBinary()) {
      var F = N2(c3.args[0], n3), I2 = N2(c3.args[1], n3);
      if (c3.op === `+`) {
        if (isConstantNode(F) && a2(F.value)) return I2;
        if (isConstantNode(I2) && a2(I2.value)) return F;
        isOperatorNode(I2) && I2.isUnary() && I2.op === `-` && (I2 = I2.args[0], c3 = new y2(`-`, `subtract`, [F, I2]));
      }
      if (c3.op === `-`) return isOperatorNode(I2) && I2.isUnary() && I2.op === `-` ? N2(new y2(`+`, `add`, [F, I2.args[0]]), n3) : isConstantNode(F) && a2(F.value) ? N2(new y2(`-`, `unaryMinus`, [I2])) : isConstantNode(I2) && a2(I2.value) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `*`) {
        if (isConstantNode(F)) {
          if (a2(F.value)) return S2;
          if (i2(F.value, 1)) return I2;
        }
        if (isConstantNode(I2)) {
          if (a2(I2.value)) return S2;
          if (i2(I2.value, 1)) return F;
          if (M2(c3, r3)) return new y2(c3.op, c3.fn, [I2, F], c3.implicit);
        }
        return new y2(c3.op, c3.fn, [F, I2], c3.implicit);
      }
      if (c3.op === `/`) return isConstantNode(F) && a2(F.value) ? S2 : isConstantNode(I2) && i2(I2.value, 1) ? F : new y2(c3.op, c3.fn, [F, I2]);
      if (c3.op === `^` && isConstantNode(I2)) {
        if (a2(I2.value)) return w2;
        if (i2(I2.value, 1)) return F;
      }
      if (c3.op === `and`) {
        if (isConstantNode(F)) if (F.value) {
          if (O2(I2)) return I2;
          if (isConstantNode(I2)) return I2.value ? E : D;
        } else return D;
        if (isConstantNode(I2)) if (I2.value) {
          if (O2(F)) return F;
        } else return D;
      }
      if (c3.op === `or`) {
        if (isConstantNode(F)) {
          if (F.value) return E;
          if (O2(I2)) return I2;
        }
        if (isConstantNode(I2)) {
          if (I2.value) return E;
          if (O2(F)) return F;
        }
      }
      return new y2(c3.op, c3.fn, [F, I2]);
    }
    if (isOperatorNode(c3)) return new y2(c3.op, c3.fn, c3.args.map((t6) => N2(t6, n3)));
    if (isArrayNode(c3)) return new p2(c3.items.map((t6) => N2(t6, n3)));
    if (isAccessorNode(c3)) return new d2(N2(c3.object, n3), N2(c3.index, n3));
    if (isIndexNode(c3)) return new g2(c3.dimensions.map((t6) => N2(t6, n3)));
    if (isObjectNode(c3)) {
      var L2 = {};
      for (var R2 in c3.properties) L2[R2] = N2(c3.properties[R2], n3);
      return new v2(L2);
    }
    return c3;
  }
  return n2(name$36, { Node: N2, "Node,Object": N2 });
}), name$35 = `resolve`, dependencies$35 = [`typed`, `parse`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`], createResolve = factory(name$35, dependencies$35, (t4) => {
  var { typed: n2, parse: r2, ConstantNode: i2, FunctionNode: a2, OperatorNode: o2, ParenthesisNode: s2 } = t4;
  function c2(t5, n3) {
    var l2 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : /* @__PURE__ */ new Set();
    if (!n3) return t5;
    if (isSymbolNode(t5)) {
      if (l2.has(t5.name)) {
        var u2 = Array.from(l2).join(`, `);
        throw ReferenceError(`recursive loop of variable definitions among {${u2}}`);
      }
      var d2 = n3.get(t5.name);
      if (isNode$2(d2)) {
        var p2 = new Set(l2);
        return p2.add(t5.name), c2(d2, n3, p2);
      } else if (typeof d2 == `number`) return r2(String(d2));
      else if (d2 !== void 0) return new i2(d2);
      else return t5;
    } else if (isOperatorNode(t5)) {
      var m2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new o2(t5.op, t5.fn, m2, t5.implicit);
    } else if (isParenthesisNode(t5)) return new s2(c2(t5.content, n3, l2));
    else if (isFunctionNode(t5)) {
      var h2 = t5.args.map(function(t6) {
        return c2(t6, n3, l2);
      });
      return new a2(t5.name, h2);
    }
    return t5.map((t6) => c2(t6, n3, l2));
  }
  return n2(`resolve`, { Node: c2, "Node, Map | null | undefined": c2, "Node, Object": (t5, n3) => c2(t5, createMap$1(n3)), "Array | Matrix": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array | Matrix, null | undefined": n2.referToSelf((t5) => (n3) => n3.map((n4) => t5(n4))), "Array, Object": n2.referTo(`Array,Map`, (t5) => (n3, r3) => t5(n3, createMap$1(r3))), "Matrix, Object": n2.referTo(`Matrix,Map`, (t5) => (n3, r3) => t5(n3, createMap$1(r3))), "Array | Matrix, Map": n2.referToSelf((t5) => (n3, r3) => n3.map((n4) => t5(n4, r3))) });
}), name$34 = `symbolicEqual`, dependencies$34 = [`parse`, `simplify`, `typed`, `OperatorNode`], createSymbolicEqual = factory(name$34, dependencies$34, (t4) => {
  var { parse: n2, simplify: r2, typed: i2, OperatorNode: a2 } = t4;
  function o2(t5, n3) {
    var i3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : {}, o3 = r2(new a2(`-`, `subtract`, [t5, n3]), {}, i3);
    return isConstantNode(o3) && !o3.value;
  }
  return i2(name$34, { "Node, Node": o2, "Node, Node, Object": o2 });
}), name$33 = `derivative`, dependencies$33 = [`typed`, `config`, `parse`, `simplify`, `equal`, `isZero`, `numeric`, `ConstantNode`, `FunctionNode`, `OperatorNode`, `ParenthesisNode`, `SymbolNode`], createDerivative = factory(name$33, dependencies$33, (t4) => {
  var { typed: n2, config: r2, parse: i2, simplify: a2, equal: o2, isZero: s2, numeric: c2, ConstantNode: l2, FunctionNode: u2, OperatorNode: d2, ParenthesisNode: p2, SymbolNode: m2 } = t4;
  function h2(t5, n3) {
    var r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : { simplify: true }, i3 = /* @__PURE__ */ new Map(), o3 = n3.name;
    function s3(t6) {
      var n4 = i3.get(t6);
      if (n4 !== void 0) return n4;
      var r4 = b2(s3, t6, o3);
      return i3.set(t6, r4), r4;
    }
    var c3 = x2(t5, s3);
    return r3.simplify ? a2(c3) : c3;
  }
  function g2(t5) {
    var n3 = i2(t5);
    if (!n3.isSymbolNode) throw TypeError(`Invalid variable. Cannot parse ${JSON.stringify(t5)} into a variable in function derivative`);
    return n3;
  }
  var v2 = n2(name$33, { "Node, SymbolNode": h2, "Node, SymbolNode, Object": h2, "Node, string": (t5, n3) => h2(t5, g2(n3)), "Node, string, Object": (t5, n3, r3) => h2(t5, g2(n3), r3) });
  v2._simplify = true, v2.toTex = function(t5) {
    return y2.apply(null, t5.args);
  };
  var y2 = n2(`_derivTex`, { "Node, SymbolNode": function(t5, n3) {
    return isConstantNode(t5) && typeOf(t5.value) === `string` ? y2(i2(t5.value).toString(), n3.toString(), 1) : y2(t5.toTex(), n3.toString(), 1);
  }, "Node, ConstantNode": function(t5, n3) {
    if (typeOf(n3.value) === `string`) return y2(t5, i2(n3.value));
    throw Error(`The second parameter to 'derivative' is a non-string constant`);
  }, "Node, SymbolNode, ConstantNode": function(t5, n3, r3) {
    return y2(t5.toString(), n3.name, r3.value);
  }, "string, string, number": function(t5, n3, r3) {
    return (r3 === 1 ? `{d\\over d` + n3 + `}` : `{d^{` + r3 + `}\\over d` + n3 + `^{` + r3 + `}}`) + `\\left[${t5}\\right]`;
  } }), b2 = n2(`_isConst`, { "function, ConstantNode, string": function() {
    return true;
  }, "function, SymbolNode, string": function(t5, n3, r3) {
    return n3.name !== r3;
  }, "function, ParenthesisNode, string": function(t5, n3, r3) {
    return t5(n3.content, r3);
  }, "function, FunctionAssignmentNode, string": function(t5, n3, r3) {
    return n3.params.includes(r3) ? t5(n3.expr, r3) : true;
  }, "function, FunctionNode | OperatorNode, string": function(t5, n3, r3) {
    return n3.args.every((n4) => t5(n4, r3));
  } }), x2 = n2(`_derivative`, { "ConstantNode, function": function() {
    return S2(0);
  }, "SymbolNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : S2(1);
  }, "ParenthesisNode, function": function(t5, n3) {
    return new p2(x2(t5.content, n3));
  }, "FunctionAssignmentNode, function": function(t5, n3) {
    return n3(t5) ? S2(0) : x2(t5.expr, n3);
  }, "FunctionNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    var r3 = t5.args[0], i3, a3 = false, o3 = false, s3;
    switch (t5.name) {
      case `cbrt`:
        a3 = true, s3 = new d2(`*`, `multiply`, [S2(3), new d2(`^`, `pow`, [r3, new d2(`/`, `divide`, [S2(2), S2(3)])])]);
        break;
      case `sqrt`:
      case `nthRoot`:
        if (t5.args.length === 1) a3 = true, s3 = new d2(`*`, `multiply`, [S2(2), new u2(`sqrt`, [r3])]);
        else if (t5.args.length === 2) return i3 = new d2(`/`, `divide`, [S2(1), t5.args[1]]), x2(new d2(`^`, `pow`, [r3, i3]), n3);
        break;
      case `log10`:
        i3 = S2(10);
      case `log`:
        if (!i3 && t5.args.length === 1) s3 = r3.clone(), a3 = true;
        else if (t5.args.length === 1 && i3 || t5.args.length === 2 && n3(t5.args[1])) s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`log`, [i3 || t5.args[1]])]), a3 = true;
        else if (t5.args.length === 2) return x2(new d2(`/`, `divide`, [new u2(`log`, [r3]), new u2(`log`, [t5.args[1]])]), n3);
        break;
      case `pow`:
        if (t5.args.length === 2) return x2(new d2(`^`, `pow`, [r3, t5.args[1]]), n3);
        break;
      case `exp`:
        s3 = new u2(`exp`, [r3.clone()]);
        break;
      case `sin`:
        s3 = new u2(`cos`, [r3.clone()]);
        break;
      case `cos`:
        s3 = new d2(`-`, `unaryMinus`, [new u2(`sin`, [r3.clone()])]);
        break;
      case `tan`:
        s3 = new d2(`^`, `pow`, [new u2(`sec`, [r3.clone()]), S2(2)]);
        break;
      case `sec`:
        s3 = new d2(`*`, `multiply`, [t5, new u2(`tan`, [r3.clone()])]);
        break;
      case `csc`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`cot`, [r3.clone()])]);
        break;
      case `cot`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csc`, [r3.clone()]), S2(2)]);
        break;
      case `asin`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `acos`:
        a3 = true, o3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])]);
        break;
      case `atan`:
        a3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `asec`:
        a3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acsc`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acot`:
        a3 = true, o3 = true, s3 = new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)]);
        break;
      case `sinh`:
        s3 = new u2(`cosh`, [r3.clone()]);
        break;
      case `cosh`:
        s3 = new u2(`sinh`, [r3.clone()]);
        break;
      case `tanh`:
        s3 = new d2(`^`, `pow`, [new u2(`sech`, [r3.clone()]), S2(2)]);
        break;
      case `sech`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`tanh`, [r3.clone()])]);
        break;
      case `csch`:
        o3 = true, s3 = new d2(`*`, `multiply`, [t5, new u2(`coth`, [r3.clone()])]);
        break;
      case `coth`:
        o3 = true, s3 = new d2(`^`, `pow`, [new u2(`csch`, [r3.clone()]), S2(2)]);
        break;
      case `asinh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `acosh`:
        a3 = true, s3 = new u2(`sqrt`, [new d2(`-`, `subtract`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])]);
        break;
      case `atanh`:
        a3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `asech`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [r3.clone(), new u2(`sqrt`, [new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])])])]);
        break;
      case `acsch`:
        a3 = true, o3 = true, s3 = new d2(`*`, `multiply`, [new u2(`abs`, [r3.clone()]), new u2(`sqrt`, [new d2(`+`, `add`, [new d2(`^`, `pow`, [r3.clone(), S2(2)]), S2(1)])])]);
        break;
      case `acoth`:
        a3 = true, o3 = true, s3 = new d2(`-`, `subtract`, [S2(1), new d2(`^`, `pow`, [r3.clone(), S2(2)])]);
        break;
      case `abs`:
        s3 = new d2(`/`, `divide`, [new u2(new m2(`abs`), [r3.clone()]), r3.clone()]);
        break;
      default:
        throw Error(`Cannot process function "` + t5.name + `" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported`);
    }
    var c3, l3;
    a3 ? (c3 = `/`, l3 = `divide`) : (c3 = `*`, l3 = `multiply`);
    var p3 = x2(r3, n3);
    return o3 && (p3 = new d2(`-`, `unaryMinus`, [p3])), new d2(c3, l3, [p3, s3]);
  }, "OperatorNode, function": function(t5, n3) {
    if (n3(t5)) return S2(0);
    if (t5.op === `+`) return new d2(t5.op, t5.fn, t5.args.map(function(t6) {
      return x2(t6, n3);
    }));
    if (t5.op === `-`) {
      if (t5.isUnary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3)]);
      if (t5.isBinary()) return new d2(t5.op, t5.fn, [x2(t5.args[0], n3), x2(t5.args[1], n3)]);
    }
    if (t5.op === `*`) {
      var r3 = t5.args.filter(function(t6) {
        return n3(t6);
      });
      if (r3.length > 0) {
        var i3 = t5.args.filter(function(t6) {
          return !n3(t6);
        }), a3 = i3.length === 1 ? i3[0] : new d2(`*`, `multiply`, i3);
        return new d2(`*`, `multiply`, r3.concat(x2(a3, n3)));
      }
      return new d2(`+`, `add`, t5.args.map(function(r4) {
        return new d2(`*`, `multiply`, t5.args.map(function(t6) {
          return t6 === r4 ? x2(t6, n3) : t6.clone();
        }));
      }));
    }
    if (t5.op === `/` && t5.isBinary()) {
      var c3 = t5.args[0], l3 = t5.args[1];
      return n3(l3) ? new d2(`/`, `divide`, [x2(c3, n3), l3]) : n3(c3) ? new d2(`*`, `multiply`, [new d2(`-`, `unaryMinus`, [c3]), new d2(`/`, `divide`, [x2(l3, n3), new d2(`^`, `pow`, [l3.clone(), S2(2)])])]) : new d2(`/`, `divide`, [new d2(`-`, `subtract`, [new d2(`*`, `multiply`, [x2(c3, n3), l3.clone()]), new d2(`*`, `multiply`, [c3.clone(), x2(l3, n3)])]), new d2(`^`, `pow`, [l3.clone(), S2(2)])]);
    }
    if (t5.op === `^` && t5.isBinary()) {
      var p3 = t5.args[0], m3 = t5.args[1];
      if (n3(p3)) return isConstantNode(p3) && (s2(p3.value) || o2(p3.value, 1)) ? S2(0) : new d2(`*`, `multiply`, [t5, new d2(`*`, `multiply`, [new u2(`log`, [p3.clone()]), x2(m3.clone(), n3)])]);
      if (n3(m3)) {
        if (isConstantNode(m3)) {
          if (s2(m3.value)) return S2(0);
          if (o2(m3.value, 1)) return x2(p3, n3);
        }
        var h3 = new d2(`^`, `pow`, [p3.clone(), new d2(`-`, `subtract`, [m3, S2(1)])]);
        return new d2(`*`, `multiply`, [m3.clone(), new d2(`*`, `multiply`, [x2(p3, n3), h3])]);
      }
      return new d2(`*`, `multiply`, [new d2(`^`, `pow`, [p3.clone(), m3.clone()]), new d2(`+`, `add`, [new d2(`*`, `multiply`, [x2(p3, n3), new d2(`/`, `divide`, [m3.clone(), p3.clone()])]), new d2(`*`, `multiply`, [x2(m3, n3), new u2(`log`, [p3.clone()])])])]);
    }
    throw Error(`Cannot process operator "` + t5.op + `" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported`);
  } });
  function S2(t5, n3) {
    return new l2(c2(t5, safeNumberType(String(t5), r2)));
  }
  return v2;
}), name$32 = `rationalize`, dependencies$32 = `config.typed.equal.isZero.add.subtract.multiply.divide.pow.parse.simplifyConstant.simplifyCore.simplify.?bignumber.?fraction.mathWithTransform.matrix.AccessorNode.ArrayNode.ConstantNode.FunctionNode.IndexNode.ObjectNode.OperatorNode.SymbolNode.ParenthesisNode`.split(`.`), createRationalize = factory(name$32, dependencies$32, (t4) => {
  var { config: n2, typed: r2, equal: i2, isZero: a2, add: o2, subtract: s2, multiply: c2, divide: l2, pow: u2, parse: d2, simplifyConstant: p2, simplifyCore: m2, simplify: h2, fraction: g2, bignumber: v2, mathWithTransform: y2, matrix: b2, AccessorNode: x2, ArrayNode: S2, ConstantNode: w2, FunctionNode: E, IndexNode: D, ObjectNode: O2, OperatorNode: j2, SymbolNode: M2, ParenthesisNode: N2 } = t4;
  function F(t5) {
    var n3 = arguments.length > 1 && arguments[1] !== void 0 ? arguments[1] : {}, r3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : false, i3 = L2(), a3 = I2(t5, n3, true, i3.firstRules), o3 = a3.variables.length, s3 = { exactFractions: false }, c3 = { exactFractions: true };
    if (t5 = a3.expression, o3 >= 1) {
      t5 = R2(t5);
      var l3, u3, d3 = true, p3 = false;
      t5 = h2(t5, i3.firstRules, {}, s3);
      for (var m3; u3 = d3 ? i3.distrDivRules : i3.sucDivRules, t5 = h2(t5, u3, {}, c3), d3 = !d3, m3 = t5.toString(), m3 !== l3; ) p3 = true, l3 = m3;
      p3 && (t5 = h2(t5, i3.firstRulesAgain, {}, s3)), t5 = h2(t5, i3.finalRules, {}, s3);
    }
    var g3 = [], v3 = {};
    return t5.type === `OperatorNode` && t5.isBinary() && t5.op === `/` ? (o3 === 1 && (t5.args[0] = z2(t5.args[0], g3), t5.args[1] = z2(t5.args[1])), r3 && (v3.numerator = t5.args[0], v3.denominator = t5.args[1])) : (o3 === 1 && (t5 = z2(t5, g3)), r3 && (v3.numerator = t5, v3.denominator = null)), r3 ? (v3.coefficients = g3, v3.variables = a3.variables, v3.expression = t5, v3) : t5;
  }
  return r2(name$32, { Node: F, "Node, boolean": (t5, n3) => F(t5, {}, n3), "Node, Object": F, "Node, Object, boolean": F });
  function I2(t5, n3, r3, i3) {
    var a3 = [], o3 = h2(t5, i3, n3, { exactFractions: false });
    r3 = !!r3;
    var s3 = `+-*` + (r3 ? `/` : ``);
    l3(o3);
    var c3 = {};
    return c3.expression = o3, c3.variables = a3, c3;
    function l3(t6) {
      var n4 = t6.type;
      if (n4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (n4 === `OperatorNode`) if (t6.op === `^`) {
        if (t6.args[1].type !== `ConstantNode` || !isInteger(parseFloat(t6.args[1].value))) throw Error(`There is a non-integer exponent`);
        l3(t6.args[0]);
      } else {
        if (!s3.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid in polynomial expression`);
        for (var r4 = 0; r4 < t6.args.length; r4++) l3(t6.args[r4]);
      }
      else if (n4 === `SymbolNode`) {
        var i4 = t6.name;
        a3.indexOf(i4) === -1 && a3.push(i4);
      } else if (n4 === `ParenthesisNode`) l3(t6.content);
      else if (n4 !== `ConstantNode`) throw Error(`type ` + n4 + ` is not allowed in polynomial expression`);
    }
  }
  function L2() {
    var t5 = [m2, { l: `n+n`, r: `2*n` }, { l: `n+-n`, r: `0` }, p2, { l: `n*(n1^-1)`, r: `n/n1` }, { l: `n*n1^-n2`, r: `n/n1^n2` }, { l: `n1^-1`, r: `1/n1` }, { l: `n*(n1/n2)`, r: `(n*n1)/n2` }, { l: `1*n`, r: `n` }], n3 = [{ l: `(-n1)/(-n2)`, r: `n1/n2` }, { l: `(-n1)*(-n2)`, r: `n1*n2` }, { l: `n1--n2`, r: `n1+n2` }, { l: `n1-n2`, r: `n1+(-n2)` }, { l: `(n1+n2)*n3`, r: `(n1*n3 + n2*n3)` }, { l: `n1*(n2+n3)`, r: `(n1*n2+n1*n3)` }, { l: `c1*n + c2*n`, r: `(c1+c2)*n` }, { l: `c1*n + n`, r: `(c1+1)*n` }, { l: `c1*n - c2*n`, r: `(c1-c2)*n` }, { l: `c1*n - n`, r: `(c1-1)*n` }, { l: `v/c`, r: `(1/c)*v` }, { l: `v/-c`, r: `-(1/c)*v` }, { l: `-v*-c`, r: `c*v` }, { l: `-v*c`, r: `-c*v` }, { l: `v*-c`, r: `-c*v` }, { l: `v*c`, r: `c*v` }, { l: `-(-n1*n2)`, r: `(n1*n2)` }, { l: `-(n1*n2)`, r: `(-n1*n2)` }, { l: `-(-n1+n2)`, r: `(n1-n2)` }, { l: `-(n1+n2)`, r: `(-n1-n2)` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }, { l: `-(-n1/n2)`, r: `(n1/n2)` }, { l: `-(n1/n2)`, r: `(-n1/n2)` }], r3 = [{ l: `(n1/n2 + n3/n4)`, r: `((n1*n4 + n3*n2)/(n2*n4))` }, { l: `(n1/n2 + n3)`, r: `((n1 + n3*n2)/n2)` }, { l: `(n1 + n2/n3)`, r: `((n1*n3 + n2)/n3)` }], i3 = [{ l: `(n1/(n2/n3))`, r: `((n1*n3)/n2)` }, { l: `(n1/n2/n3)`, r: `(n1/(n2*n3))` }], a3 = {};
    return a3.firstRules = t5.concat(n3, i3), a3.distrDivRules = r3, a3.sucDivRules = i3, a3.firstRulesAgain = t5.concat(n3), a3.finalRules = [m2, { l: `n*-n`, r: `-n^2` }, { l: `n*n`, r: `n^2` }, p2, { l: `n*-n^n1`, r: `-n^(n1+1)` }, { l: `n*n^n1`, r: `n^(n1+1)` }, { l: `n^n1*-n^n2`, r: `-n^(n1+n2)` }, { l: `n^n1*n^n2`, r: `n^(n1+n2)` }, { l: `n^n1*-n`, r: `-n^(n1+1)` }, { l: `n^n1*n`, r: `n^(n1+1)` }, { l: `n^n1/-n`, r: `-n^(n1-1)` }, { l: `n^n1/n`, r: `n^(n1-1)` }, { l: `n/-n^n1`, r: `-n^(1-n1)` }, { l: `n/n^n1`, r: `n^(1-n1)` }, { l: `n^n1/-n^n2`, r: `n^(n1-n2)` }, { l: `n^n1/n^n2`, r: `n^(n1-n2)` }, { l: `n1+(-n2*n3)`, r: `n1-n2*n3` }, { l: `v*(-c)`, r: `-c*v` }, { l: `n1+-n2`, r: `n1-n2` }, { l: `v*c`, r: `c*v` }, { l: `(n1^n2)^n3`, r: `(n1^(n2*n3))` }], a3;
  }
  function R2(t5, n3, r3) {
    var i3 = t5.type, a3 = arguments.length > 1;
    if (i3 === `OperatorNode` && t5.isBinary()) {
      var o3 = false, s3;
      if (t5.op === `^` && (t5.args[0].type === `ParenthesisNode` || t5.args[0].type === `OperatorNode`) && t5.args[1].type === `ConstantNode` && (s3 = parseFloat(t5.args[1].value), o3 = s3 >= 2 && isInteger(s3)), o3) {
        if (s3 > 2) {
          var c3 = t5.args[0];
          t5 = new j2(`*`, `multiply`, [c3, new j2(`^`, `pow`, [t5.args[0].cloneDeep(), new w2(s3 - 1)])]);
        } else t5 = new j2(`*`, `multiply`, [t5.args[0], t5.args[0].cloneDeep()]);
        a3 && (r3 === `content` ? n3.content = t5 : n3.args[r3] = t5);
      }
    }
    if (i3 === `ParenthesisNode`) R2(t5.content, t5, `content`);
    else if (i3 !== `ConstantNode` && i3 !== `SymbolNode`) for (var l3 = 0; l3 < t5.args.length; l3++) R2(t5.args[l3], t5, l3);
    if (!a3) return t5;
  }
  function z2(t5, n3) {
    n3 === void 0 && (n3 = []), n3[0] = 0;
    var r3 = {};
    r3.cte = 1, r3.oper = `+`, r3.fire = ``;
    var i3 = 0, a3 = ``;
    m3(t5, null, r3), i3 = n3.length - 1;
    for (var o3 = true, s3, c3 = i3; c3 >= 0; c3--) if (n3[c3] !== 0) {
      var l3 = new w2(o3 ? n3[c3] : Math.abs(n3[c3])), u3 = n3[c3] < 0 ? `-` : `+`;
      if (c3 > 0) {
        var d3 = new M2(a3);
        if (c3 > 1) {
          var p3 = new w2(c3);
          d3 = new j2(`^`, `pow`, [d3, p3]);
        }
        l3 = n3[c3] === -1 && o3 ? new j2(`-`, `unaryMinus`, [d3]) : Math.abs(n3[c3]) === 1 ? d3 : new j2(`*`, `multiply`, [l3, d3]);
      }
      s3 = o3 ? l3 : u3 === `+` ? new j2(`+`, `add`, [s3, l3]) : new j2(`-`, `subtract`, [s3, l3]), o3 = false;
    }
    if (o3) return new w2(0);
    return s3;
    function m3(t6, r4, o4) {
      var s4 = t6.type;
      if (s4 === `FunctionNode`) throw Error(`There is an unsolved function call`);
      if (s4 === `OperatorNode`) {
        if (!`+-*^`.includes(t6.op)) throw Error(`Operator ` + t6.op + ` invalid`);
        if (r4 !== null && ((t6.fn === `unaryMinus` || t6.fn === `pow`) && r4.fn !== `add` && r4.fn !== `subtract` && r4.fn !== `multiply` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `multiply`) && r4.fn !== `add` && r4.fn !== `subtract` || (t6.fn === `subtract` || t6.fn === `add` || t6.fn === `unaryMinus`) && o4.noFil !== 0)) throw Error(`Invalid ` + t6.op + ` placing`);
        (t6.op === `^` || t6.op === `*`) && (o4.fire = t6.op);
        for (var c4 = 0; c4 < t6.args.length; c4++) t6.fn === `unaryMinus` && (o4.oper = `-`), (t6.op === `+` || t6.fn === `subtract`) && (o4.fire = ``, o4.cte = 1, o4.oper = c4 === 0 ? `+` : t6.op), o4.noFil = c4, m3(t6.args[c4], t6, o4);
      } else if (s4 === `SymbolNode`) {
        if (t6.name !== a3 && a3 !== ``) throw Error(`There is more than one variable`);
        if (a3 = t6.name, r4 === null) {
          n3[1] = 1;
          return;
        }
        if (r4.op === `^` && o4.noFil !== 0) throw Error(`In power the variable should be the first parameter`);
        if (r4.op === `*` && o4.noFil !== 1) throw Error(`In multiply the variable should be the second parameter`);
        (o4.fire === `` || o4.fire === `*`) && (i3 < 1 && (n3[1] = 0), n3[1] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(1, i3));
      } else if (s4 === `ConstantNode`) {
        var l4 = parseFloat(t6.value);
        if (r4 === null) {
          n3[0] = l4;
          return;
        }
        if (r4.op === `^`) {
          if (o4.noFil !== 1) throw Error(`Constant cannot be powered`);
          if (!isInteger(l4) || l4 <= 0) throw Error(`Non-integer exponent is not allowed`);
          for (var u4 = i3 + 1; u4 < l4; u4++) n3[u4] = 0;
          l4 > i3 && (n3[l4] = 0), n3[l4] += o4.cte * (o4.oper === `+` ? 1 : -1), i3 = Math.max(l4, i3);
          return;
        }
        o4.cte = l4, o4.fire === `` && (n3[0] += o4.cte * (o4.oper === `+` ? 1 : -1));
      } else throw Error(`Type ` + s4 + ` is not allowed`);
    }
  }
}), name$31 = `zpk2tf`, dependencies$31 = [`typed`, `add`, `multiply`, `Complex`, `number`], createZpk2tf = factory(name$31, dependencies$31, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, number: o2 } = t4;
  return n2(name$31, { "Array,Array,number": function(t5, n3, r3) {
    return s2(t5, n3, r3);
  }, "Array,Array": function(t5, n3) {
    return s2(t5, n3, 1);
  }, "Matrix,Matrix,number": function(t5, n3, r3) {
    return s2(t5.valueOf(), n3.valueOf(), r3);
  }, "Matrix,Matrix": function(t5, n3) {
    return s2(t5.valueOf(), n3.valueOf(), 1);
  } });
  function s2(t5, n3, r3) {
    t5.some((t6) => t6.type === `BigNumber`) && (t5 = t5.map((t6) => o2(t6))), n3.some((t6) => t6.type === `BigNumber`) && (n3 = n3.map((t6) => o2(t6)));
    for (var s3 = [a2(1, 0)], l2 = [a2(1, 0)], u2 = 0; u2 < t5.length; u2++) {
      var d2 = t5[u2];
      typeof d2 == `number` && (d2 = a2(d2, 0)), s3 = c2(s3, [a2(1, 0), a2(-d2.re, -d2.im)]);
    }
    for (var p2 = 0; p2 < n3.length; p2++) {
      var m2 = n3[p2];
      typeof m2 == `number` && (m2 = a2(m2, 0)), l2 = c2(l2, [a2(1, 0), a2(-m2.re, -m2.im)]);
    }
    for (var h2 = 0; h2 < s3.length; h2++) s3[h2] = i2(s3[h2], r3);
    return [s3, l2];
  }
  function c2(t5, n3) {
    for (var o3 = [], s3 = 0; s3 < t5.length + n3.length - 1; s3++) {
      o3[s3] = a2(0, 0);
      for (var c3 = 0; c3 < t5.length; c3++) s3 - c3 >= 0 && s3 - c3 < n3.length && (o3[s3] = r2(o3[s3], i2(t5[c3], n3[s3 - c3])));
    }
    return o3;
  }
}), name$30 = `freqz`, dependencies$30 = [`typed`, `add`, `multiply`, `Complex`, `divide`, `matrix`], createFreqz = factory(name$30, dependencies$30, (t4) => {
  var { typed: n2, add: r2, multiply: i2, Complex: a2, divide: o2, matrix: s2 } = t4;
  return n2(name$30, { "Array, Array": function(t5, n3) {
    return c2(t5, n3, l2(512));
  }, "Array, Array, Array": function(t5, n3, r3) {
    return c2(t5, n3, r3);
  }, "Array, Array, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    return c2(t5, n3, l2(r3));
  }, "Matrix, Matrix": function(t5, n3) {
    var r3 = l2(512), { w: i3, h: a3 } = c2(t5.valueOf(), n3.valueOf(), r3);
    return { w: s2(i3), h: s2(a3) };
  }, "Matrix, Matrix, Matrix": function(t5, n3, r3) {
    var { h: i3 } = c2(t5.valueOf(), n3.valueOf(), r3.valueOf());
    return { h: s2(i3), w: s2(r3) };
  }, "Matrix, Matrix, number": function(t5, n3, r3) {
    if (r3 < 0) throw Error(`w must be a positive number`);
    var i3 = l2(r3), { h: a3 } = c2(t5.valueOf(), n3.valueOf(), i3);
    return { h: s2(a3), w: s2(i3) };
  } });
  function c2(t5, n3, s3) {
    for (var c3 = [], l3 = [], u2 = 0; u2 < s3.length; u2++) {
      for (var d2 = a2(0, 0), p2 = a2(0, 0), m2 = 0; m2 < t5.length; m2++) d2 = r2(d2, i2(t5[m2], a2(Math.cos(-m2 * s3[u2]), Math.sin(-m2 * s3[u2]))));
      for (var h2 = 0; h2 < n3.length; h2++) p2 = r2(p2, i2(n3[h2], a2(Math.cos(-h2 * s3[u2]), Math.sin(-h2 * s3[u2]))));
      c3.push(d2), l3.push(p2);
    }
    for (var g2 = [], v2 = 0; v2 < c3.length; v2++) g2.push(o2(c3[v2], l3[v2]));
    return { h: g2, w: s3 };
  }
  function l2(t5) {
    for (var n3 = [], r3 = 0; r3 < t5; r3++) n3.push(r3 / t5 * Math.PI);
    return n3;
  }
}), name$29 = `reviver`, dependencies$29 = [`classes`], createReviver = factory(name$29, dependencies$29, (t4) => {
  var { classes: n2 } = t4;
  return function(t5, r2) {
    var i2 = n2[r2 && r2.mathjs];
    return i2 && typeof i2.fromJSON == `function` ? i2.fromJSON(r2) : r2;
  };
}), name$28 = `replacer`, dependencies$28 = [], createReplacer = factory(name$28, dependencies$28, () => function(t4, n2) {
  return typeof n2 == `number` && (!Number.isFinite(n2) || isNaN(n2)) ? { mathjs: `number`, value: String(n2) } : typeof n2 == `bigint` ? { mathjs: `bigint`, value: String(n2) } : n2;
}), version = `15.2.0`, createTrue = factory(`true`, [], () => true), createFalse = factory(`false`, [], () => false), createNull = factory(`null`, [], () => null), createInfinity = recreateFactory(`Infinity`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1 / 0) : 1 / 0;
}), createNaN = recreateFactory(`NaN`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(NaN) : NaN;
}), createPi = recreateFactory(`pi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPi(r2) : pi$1;
}), createTau = recreateFactory(`tau`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberTau(r2) : tau;
}), createE = recreateFactory(`e`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberE(r2) : e;
}), createPhi = recreateFactory(`phi`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? createBigNumberPhi(r2) : phi;
}), createLN2 = recreateFactory(`LN2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).ln() : Math.LN2;
}), createLN10 = recreateFactory(`LN10`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(10).ln() : Math.LN10;
}), createLOG2E = recreateFactory(`LOG2E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(2).ln()) : Math.LOG2E;
}), createLOG10E = recreateFactory(`LOG10E`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(1).div(new r2(10).ln()) : Math.LOG10E;
}), createSQRT1_2 = recreateFactory(`SQRT1_2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(`0.5`).sqrt() : Math.SQRT1_2;
}), createSQRT2 = recreateFactory(`SQRT2`, [`config`, `?BigNumber`], (t4) => {
  var { config: n2, BigNumber: r2 } = t4;
  return n2.number === `BigNumber` ? new r2(2).sqrt() : Math.SQRT2;
}), createI = recreateFactory(`i`, [`Complex`], (t4) => {
  var { Complex: n2 } = t4;
  return n2.I;
}), createUppercasePi = factory(`PI`, [`pi`], (t4) => {
  var { pi: n2 } = t4;
  return n2;
}), createUppercaseE = factory(`E`, [`e`], (t4) => {
  var { e: n2 } = t4;
  return n2;
}), createVersion = factory(`version`, [], () => version);
function recreateFactory(t4, n2, r2) {
  return factory(t4, n2, r2, { recreateOnConfigChange: true });
}
var createSpeedOfLight = unitFactory(`speedOfLight`, `299792458`, `m s^-1`), createGravitationConstant = unitFactory(`gravitationConstant`, `6.67430e-11`, `m^3 kg^-1 s^-2`), createPlanckConstant = unitFactory(`planckConstant`, `6.62607015e-34`, `J s`), createReducedPlanckConstant = unitFactory(`reducedPlanckConstant`, `1.0545718176461565e-34`, `J s`), createMagneticConstant = unitFactory(`magneticConstant`, `1.25663706212e-6`, `N A^-2`), createElectricConstant = unitFactory(`electricConstant`, `8.8541878128e-12`, `F m^-1`), createVacuumImpedance = unitFactory(`vacuumImpedance`, `376.730313667`, `ohm`), createCoulomb = unitFactory(`coulomb`, `8.987551792261171e9`, `N m^2 C^-2`), createCoulombConstant = unitFactory(`coulombConstant`, `8.987551792261171e9`, `N m^2 C^-2`), createElementaryCharge = unitFactory(`elementaryCharge`, `1.602176634e-19`, `C`), createBohrMagneton = unitFactory(`bohrMagneton`, `9.2740100783e-24`, `J T^-1`), createConductanceQuantum = unitFactory(`conductanceQuantum`, `7.748091729863649e-5`, `S`), createInverseConductanceQuantum = unitFactory(`inverseConductanceQuantum`, `12906.403729652257`, `ohm`), createMagneticFluxQuantum = unitFactory(`magneticFluxQuantum`, `2.0678338484619295e-15`, `Wb`), createNuclearMagneton = unitFactory(`nuclearMagneton`, `5.0507837461e-27`, `J T^-1`), createKlitzing = unitFactory(`klitzing`, `25812.807459304513`, `ohm`), createBohrRadius = unitFactory(`bohrRadius`, `5.29177210903e-11`, `m`), createClassicalElectronRadius = unitFactory(`classicalElectronRadius`, `2.8179403262e-15`, `m`), createElectronMass = unitFactory(`electronMass`, `9.1093837015e-31`, `kg`), createFermiCoupling = unitFactory(`fermiCoupling`, `1.1663787e-5`, `GeV^-2`), createFineStructure = numberFactory(`fineStructure`, 0.0072973525693), createHartreeEnergy = unitFactory(`hartreeEnergy`, `4.3597447222071e-18`, `J`), createProtonMass = unitFactory(`protonMass`, `1.67262192369e-27`, `kg`), createDeuteronMass = unitFactory(`deuteronMass`, `3.3435830926e-27`, `kg`), createNeutronMass = unitFactory(`neutronMass`, `1.6749271613e-27`, `kg`), createQuantumOfCirculation = unitFactory(`quantumOfCirculation`, `3.6369475516e-4`, `m^2 s^-1`), createRydberg = unitFactory(`rydberg`, `10973731.568160`, `m^-1`), createThomsonCrossSection = unitFactory(`thomsonCrossSection`, `6.6524587321e-29`, `m^2`), createWeakMixingAngle = numberFactory(`weakMixingAngle`, 0.2229), createEfimovFactor = numberFactory(`efimovFactor`, 22.7), createAtomicMass = unitFactory(`atomicMass`, `1.66053906660e-27`, `kg`), createAvogadro = unitFactory(`avogadro`, `6.02214076e23`, `mol^-1`), createBoltzmann = unitFactory(`boltzmann`, `1.380649e-23`, `J K^-1`), createFaraday = unitFactory(`faraday`, `96485.33212331001`, `C mol^-1`), createFirstRadiation = unitFactory(`firstRadiation`, `3.7417718521927573e-16`, `W m^2`), createLoschmidt = unitFactory(`loschmidt`, `2.686780111798444e25`, `m^-3`), createGasConstant = unitFactory(`gasConstant`, `8.31446261815324`, `J K^-1 mol^-1`), createMolarPlanckConstant = unitFactory(`molarPlanckConstant`, `3.990312712893431e-10`, `J s mol^-1`), createMolarVolume = unitFactory(`molarVolume`, `0.022413969545014137`, `m^3 mol^-1`), createSackurTetrode = numberFactory(`sackurTetrode`, -1.16487052358), createSecondRadiation = unitFactory(`secondRadiation`, `0.014387768775039337`, `m K`), createStefanBoltzmann = unitFactory(`stefanBoltzmann`, `5.67037441918443e-8`, `W m^-2 K^-4`), createWienDisplacement = unitFactory(`wienDisplacement`, `2.897771955e-3`, `m K`), createMolarMass = unitFactory(`molarMass`, `0.99999999965e-3`, `kg mol^-1`), createMolarMassC12 = unitFactory(`molarMassC12`, `11.9999999958e-3`, `kg mol^-1`), createGravity = unitFactory(`gravity`, `9.80665`, `m s^-2`), createPlanckLength = unitFactory(`planckLength`, `1.616255e-35`, `m`), createPlanckMass = unitFactory(`planckMass`, `2.176435e-8`, `kg`), createPlanckTime = unitFactory(`planckTime`, `5.391245e-44`, `s`), createPlanckCharge = unitFactory(`planckCharge`, `1.87554603778e-18`, `C`), createPlanckTemperature = unitFactory(`planckTemperature`, `1.416785e+32`, `K`);
function unitFactory(t4, n2, r2) {
  return factory(t4, [`config`, `Unit`, `BigNumber`], (t5) => {
    var { config: i2, Unit: a2, BigNumber: o2 } = t5, s2 = new a2(i2.number === `BigNumber` ? new o2(n2) : parseFloat(n2), r2);
    return s2.fixPrefix = true, s2;
  });
}
function numberFactory(t4, n2) {
  return factory(t4, [`config`, `BigNumber`], (t5) => {
    var { config: r2, BigNumber: i2 } = t5;
    return r2.number === `BigNumber` ? new i2(n2) : n2;
  });
}
function ownKeys(t4, n2) {
  var r2 = Object.keys(t4);
  if (Object.getOwnPropertySymbols) {
    var i2 = Object.getOwnPropertySymbols(t4);
    n2 && (i2 = i2.filter(function(n3) {
      return Object.getOwnPropertyDescriptor(t4, n3).enumerable;
    })), r2.push.apply(r2, i2);
  }
  return r2;
}
function _objectSpread(t4) {
  for (var n2 = 1; n2 < arguments.length; n2++) {
    var r2 = arguments[n2] == null ? {} : arguments[n2];
    n2 % 2 ? ownKeys(Object(r2), true).forEach(function(n3) {
      _defineProperty(t4, n3, r2[n3]);
    }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(t4, Object.getOwnPropertyDescriptors(r2)) : ownKeys(Object(r2)).forEach(function(n3) {
      Object.defineProperty(t4, n3, Object.getOwnPropertyDescriptor(r2, n3));
    });
  }
  return t4;
}
var name$27 = `mapSlices`, dependencies$27 = [`typed`, `isInteger`], createMapSlicesTransform = factory(name$27, dependencies$27, (t4) => {
  var { typed: n2, isInteger: r2 } = t4, i2 = createMapSlices({ typed: n2, isInteger: r2 });
  return n2(`mapSlices`, { "...any": function(t5) {
    var n3 = t5[1];
    isNumber(n3) ? t5[1] = n3 - 1 : isBigNumber(n3) && (t5[1] = n3.minus(1));
    try {
      return i2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, _objectSpread({ isTransformFunction: true }, createMapSlices.meta)), name$26 = `column`, dependencies$26 = [`typed`, `Index`, `matrix`, `range`], createColumnTransform = factory(name$26, dependencies$26, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createColumn({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`column`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true });
function compileInlineExpression(t4, n2, r2) {
  var i2 = t4.filter(function(t5) {
    return isSymbolNode(t5) && !(t5.name in n2) && !r2.has(t5.name);
  })[0];
  if (!i2) throw Error(`No undefined variable found in inline expression "` + t4 + `"`);
  var a2 = i2.name, o2 = /* @__PURE__ */ new Map(), s2 = new PartitionedMap(r2, o2, /* @__PURE__ */ new Set([a2])), c2 = t4.compile();
  return function(t5) {
    return o2.set(a2, t5), c2.evaluate(s2);
  };
}
var name$25 = `transformCallback`, dependencies$25 = [`typed`], createTransformCallback = factory(name$25, dependencies$25, (t4) => {
  var { typed: n2 } = t4;
  return function(t5, i2) {
    return n2.isTypedFunction(t5) ? r2(t5, i2) : _transformCallbackFunction(t5, t5.length, i2);
  };
  function r2(t5, i2) {
    var a2 = Object.fromEntries(Object.entries(t5.signatures).map((t6) => {
      var [a3, o2] = t6, s2 = a3.split(`,`).length;
      return n2.isTypedFunction(o2) ? [a3, r2(o2, i2)] : [a3, _transformCallbackFunction(o2, s2, i2)];
    }));
    return typeof t5.name == `string` ? n2(t5.name, a2) : n2(a2);
  }
});
function _transformCallbackFunction(t4, n2, r2) {
  return n2 === r2 ? t4 : n2 === r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims(n3[r2]);
    return t4(...i2, a2);
  } : n2 > r2 + 1 ? function() {
    var n3 = [...arguments], i2 = n3.slice(0, r2), a2 = _transformDims(n3[r2]), o2 = n3.slice(r2 + 1);
    return t4(...i2, a2, ...o2);
  } : t4;
}
function _transformDims(t4) {
  return t4.map((t5) => t5 + 1);
}
var name$24 = `filter`, dependencies$24 = [`typed`], createFilterTransform = factory(name$24, dependencies$24, (t4) => {
  var { typed: n2 } = t4;
  function r2(t5, r3, a2) {
    var o2 = createFilter({ typed: n2 }), s2 = createTransformCallback({ typed: n2 });
    if (t5.length === 0) return o2();
    var c2 = t5[0];
    if (t5.length === 1) return o2(c2);
    var l2 = t5.length - 1, u2 = t5[l2];
    return c2 &&= i2(c2, a2), u2 &&= isSymbolNode(u2) || isFunctionAssignmentNode(u2) ? i2(u2, a2) : compileInlineExpression(u2, r3, a2), o2(c2, s2(u2, l2));
  }
  r2.rawArgs = true;
  function i2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return r2;
}, { isTransformFunction: true }), name$23 = `forEach`, dependencies$23 = [`typed`], createForEachTransform = factory(name$23, dependencies$23, (t4) => {
  var { typed: n2 } = t4, r2 = createForEach({ typed: n2 }), i2 = createTransformCallback({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    var s2 = t5[0];
    if (t5.length === 1) return r2(s2);
    var c2 = t5.length - 1, l2 = t5[c2];
    return s2 &&= o2(s2, a3), l2 &&= isSymbolNode(l2) || isFunctionAssignmentNode(l2) ? o2(l2, a3) : compileInlineExpression(l2, n3, a3), r2(s2, i2(l2, c2));
  }
  a2.rawArgs = true;
  function o2(t5, n3) {
    return t5.compile().evaluate(n3);
  }
  return a2;
}, { isTransformFunction: true }), name$22 = `index`, dependencies$22 = [`Index`, `getMatrixDataType`], createIndexTransform = factory(name$22, dependencies$22, (t4) => {
  var { Index: n2, getMatrixDataType: r2 } = t4;
  return function() {
    for (var t5 = [], i2 = 0, a2 = arguments.length; i2 < a2; i2++) {
      var o2 = arguments[i2];
      if (isRange(o2)) o2.start--, o2.end -= o2.step > 0 ? 0 : 2;
      else if (o2 && o2.isSet === true) o2 = o2.map(function(t6) {
        return t6 - 1;
      });
      else if (isArray(o2) || isMatrix(o2)) r2(o2) !== `boolean` && (o2 = o2.map(function(t6) {
        return t6 - 1;
      }));
      else if (isNumber(o2) || isBigInt(o2)) o2--;
      else if (isBigNumber(o2)) o2 = o2.toNumber() - 1;
      else if (typeof o2 != `string`) throw TypeError(`Dimension must be an Array, Matrix, number, bigint, string, or Range`);
      t5[i2] = o2;
    }
    var s2 = new n2();
    return n2.apply(s2, t5), s2;
  };
}, { isTransformFunction: true }), name$21 = `map`, dependencies$21 = [`typed`], createMapTransform = factory(name$21, dependencies$21, (t4) => {
  var { typed: n2 } = t4, r2 = createMap({ typed: n2 }), i2 = createTransformCallback({ typed: n2 });
  function a2(t5, n3, a3) {
    if (t5.length === 0) return r2();
    if (t5.length === 1) return r2(t5[0]);
    var o2 = t5.length - 1, s2 = t5.slice(0, o2), c2 = t5[o2];
    return s2 = s2.map((t6) => l2(t6, a3)), c2 &&= isSymbolNode(c2) || isFunctionAssignmentNode(c2) ? l2(c2, a3) : compileInlineExpression(c2, n3, a3), r2(...s2, i2(c2, o2));
    function l2(t6, n4) {
      return t6.compile().evaluate(n4);
    }
  }
  return a2.rawArgs = true, a2;
}, { isTransformFunction: true });
function dimToZeroBase(t4) {
  return isNumber(t4) ? t4 - 1 : isBigNumber(t4) ? t4.minus(1) : t4;
}
function isNumberOrBigNumber(t4) {
  return isNumber(t4) || isBigNumber(t4);
}
function lastDimToZeroBase(t4) {
  if (t4.length === 2 && isCollection(t4[0])) {
    t4 = t4.slice();
    var n2 = t4[1];
    isNumberOrBigNumber(n2) && (t4[1] = dimToZeroBase(n2));
  }
  return t4;
}
var name$20 = `max`, dependencies$20 = [`typed`, `config`, `numeric`, `larger`, `isNaN`], createMaxTransform = factory(name$20, dependencies$20, (t4) => {
  var { typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 } = t4, s2 = createMax({ typed: n2, config: r2, numeric: i2, larger: a2, isNaN: o2 });
  return n2(`max`, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$19 = `mean`, dependencies$19 = [`typed`, `add`, `divide`], createMeanTransform = factory(name$19, dependencies$19, (t4) => {
  var { typed: n2, add: r2, divide: i2 } = t4, a2 = createMean({ typed: n2, add: r2, divide: i2 });
  return n2(`mean`, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$18 = `min`, dependencies$18 = [`typed`, `config`, `numeric`, `smaller`, `isNaN`], createMinTransform = factory(name$18, dependencies$18, (t4) => {
  var { typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 } = t4, s2 = createMin({ typed: n2, config: r2, numeric: i2, smaller: a2, isNaN: o2 });
  return n2(`min`, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$17 = `range`, dependencies$17 = [`typed`, `config`, `?matrix`, `?bignumber`, `equal`, `smaller`, `smallerEq`, `larger`, `largerEq`, `add`, `isZero`, `isPositive`], createRangeTransform = factory(name$17, dependencies$17, (t4) => {
  var { typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 } = t4, h2 = createRange({ typed: n2, config: r2, matrix: i2, bignumber: a2, equal: o2, smaller: s2, smallerEq: c2, larger: l2, largerEq: u2, add: d2, isZero: p2, isPositive: m2 });
  return n2(`range`, { "...any": function(t5) {
    return typeof t5[t5.length - 1] != `boolean` && t5.push(true), h2.apply(null, t5);
  } });
}, { isTransformFunction: true }), name$16 = `row`, dependencies$16 = [`typed`, `Index`, `matrix`, `range`], createRowTransform = factory(name$16, dependencies$16, (t4) => {
  var { typed: n2, Index: r2, matrix: i2, range: a2 } = t4, o2 = createRow({ typed: n2, Index: r2, matrix: i2, range: a2 });
  return n2(`row`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber(r3) && (t5[n3] = r3 - 1);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$15 = `subset`, dependencies$15 = [`typed`, `matrix`, `zeros`, `add`], createSubsetTransform = factory(name$15, dependencies$15, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createSubset({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(`subset`, { "...any": function(t5) {
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$14 = `concat`, dependencies$14 = [`typed`, `matrix`, `isInteger`], createConcatTransform = factory(name$14, dependencies$14, (t4) => {
  var { typed: n2, matrix: r2, isInteger: i2 } = t4, a2 = createConcat({ typed: n2, matrix: r2, isInteger: i2 });
  return n2(`concat`, { "...any": function(t5) {
    var n3 = t5.length - 1, r3 = t5[n3];
    isNumber(r3) ? t5[n3] = r3 - 1 : isBigNumber(r3) && (t5[n3] = r3.minus(1));
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$13 = `diff`, dependencies$13 = [`typed`, `matrix`, `subtract`, `number`, `bignumber`], createDiffTransform = factory(name$13, dependencies$13, (t4) => {
  var { typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 } = t4, s2 = createDiff({ typed: n2, matrix: r2, subtract: i2, number: a2, bignumber: o2 });
  return n2(name$13, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return s2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$12 = `std`, dependencies$12 = [`typed`, `map`, `sqrt`, `variance`], createStdTransform = factory(name$12, dependencies$12, (t4) => {
  var { typed: n2, map: r2, sqrt: i2, variance: a2 } = t4, o2 = createStd({ typed: n2, map: r2, sqrt: i2, variance: a2 });
  return n2(`std`, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$11 = `sum`, dependencies$11 = [`typed`, `config`, `add`, `numeric`], createSumTransform = factory(name$11, dependencies$11, (t4) => {
  var { typed: n2, config: r2, add: i2, numeric: a2 } = t4, o2 = createSum({ typed: n2, config: r2, add: i2, numeric: a2 });
  return n2(name$11, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return o2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$10 = `quantileSeq`, dependencies$10 = [`typed`, `bignumber`, `add`, `subtract`, `divide`, `multiply`, `partitionSelect`, `compare`, `isInteger`, `smaller`, `smallerEq`, `larger`, `mapSlices`], createQuantileSeqTransform = factory(name$10, dependencies$10, (t4) => {
  var { typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 } = t4, g2 = createQuantileSeq({ typed: n2, bignumber: r2, add: i2, subtract: a2, divide: o2, multiply: s2, partitionSelect: c2, compare: l2, isInteger: u2, smaller: d2, smallerEq: p2, larger: m2, mapSlices: h2 });
  return n2(`quantileSeq`, { "Array | Matrix, number | BigNumber": g2, "Array | Matrix, number | BigNumber, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, number | BigNumber, boolean": g2, "Array | Matrix, number | BigNumber, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)), "Array | Matrix, Array | Matrix": g2, "Array | Matrix, Array | Matrix, number": (t5, n3, r3) => g2(t5, n3, v2(r3)), "Array | Matrix, Array | Matrix, boolean": g2, "Array | Matrix, Array | Matrix, boolean, number": (t5, n3, r3, i3) => g2(t5, n3, r3, v2(i3)) });
  function v2(t5) {
    return lastDimToZeroBase([[], t5])[1];
  }
}, { isTransformFunction: true }), name$9 = `cumsum`, dependencies$9 = [`typed`, `add`, `unaryPlus`], createCumSumTransform = factory(name$9, dependencies$9, (t4) => {
  var { typed: n2, add: r2, unaryPlus: i2 } = t4, a2 = createCumSum({ typed: n2, add: r2, unaryPlus: i2 });
  return n2(name$9, { "...any": function(t5) {
    if (t5.length === 2 && isCollection(t5[0])) {
      var n3 = t5[1];
      isNumber(n3) ? t5[1] = n3 - 1 : isBigNumber(n3) && (t5[1] = n3.minus(1));
    }
    try {
      return a2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$8 = `variance`, dependencies$8 = [`typed`, `add`, `subtract`, `multiply`, `divide`, `mapSlices`, `isNaN`], createVarianceTransform = factory(name$8, dependencies$8, (t4) => {
  var { typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 } = t4, l2 = createVariance({ typed: n2, add: r2, subtract: i2, multiply: a2, divide: o2, mapSlices: s2, isNaN: c2 });
  return n2(name$8, { "...any": function(t5) {
    t5 = lastDimToZeroBase(t5);
    try {
      return l2.apply(null, t5);
    } catch (t6) {
      throw errorTransform(t6);
    }
  } });
}, { isTransformFunction: true }), name$7 = `print`, dependencies$7 = [`typed`, `matrix`, `zeros`, `add`], createPrintTransform = factory(name$7, dependencies$7, (t4) => {
  var { typed: n2, matrix: r2, zeros: i2, add: a2 } = t4, o2 = createPrint({ typed: n2, matrix: r2, zeros: i2, add: a2 });
  return n2(name$7, { "string, Object | Array": function(t5, n3) {
    return o2(s2(t5), n3);
  }, "string, Object | Array, number | Object": function(t5, n3, r3) {
    return o2(s2(t5), n3, r3);
  } });
  function s2(t5) {
    return t5.replace(printTemplate, (t6) => `$` + t6.slice(1).split(`.`).map(function(t7) {
      return !isNaN(t7) && t7.length > 0 ? parseInt(t7) - 1 : t7;
    }).join(`.`));
  }
}, { isTransformFunction: true }), name$6 = `and`, dependencies$6 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createAndTransform = factory(name$6, dependencies$6, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createAnd({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection(i3) && !c2(i3, true) ? false : c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$5 = `or`, dependencies$5 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createOrTransform = factory(name$5, dependencies$5, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createOr({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection(i3) && s2(i3, false) ? true : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$4 = `nullish`, dependencies$4 = [`typed`, `matrix`, `size`, `flatten`, `deepEqual`], createNullishTransform = factory(name$4, dependencies$4, (t4) => {
  var { typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 } = t4, s2 = createNullish({ typed: n2, matrix: r2, size: i2, flatten: a2, deepEqual: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    return !isCollection(i3) && i3 != null && i3 !== void 0 ? i3 : s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$3 = `bitAnd`, dependencies$3 = [`typed`, `matrix`, `zeros`, `add`, `equalScalar`, `not`, `concat`], createBitAndTransform = factory(name$3, dependencies$3, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 } = t4, c2 = createBitAnd({ typed: n2, matrix: r2, equalScalar: i2, zeros: a2, not: o2, concat: s2 });
  function l2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === 0 || i3 === false) return 0;
    }
    return c2(i3, t5[1].compile().evaluate(r3));
  }
  return l2.rawArgs = true, l2;
}, { isTransformFunction: true }), name$2 = `bitOr`, dependencies$2 = [`typed`, `matrix`, `equalScalar`, `DenseMatrix`, `concat`], createBitOrTransform = factory(name$2, dependencies$2, (t4) => {
  var { typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 } = t4, s2 = createBitOr({ typed: n2, matrix: r2, equalScalar: i2, DenseMatrix: a2, concat: o2 });
  function c2(t5, n3, r3) {
    var i3 = t5[0].compile().evaluate(r3);
    if (!isCollection(i3)) {
      if (isNaN(i3)) return NaN;
      if (i3 === -1) return -1;
      if (i3 === true) return 1;
    }
    return s2(i3, t5[1].compile().evaluate(r3));
  }
  return c2.rawArgs = true, c2;
}, { isTransformFunction: true }), name$1 = `num`, dependencies$1 = [`typed`, `fraction`], createNum = factory(name$1, dependencies$1, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name$1, { Fraction: (t5) => t5.s * t5.n, BigNumber: (t5) => {
    var n3 = r2(t5);
    return n3.s * n3.n;
  }, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), name = `den`, dependencies = [`typed`, `fraction`], createDen = factory(name, dependencies, (t4) => {
  var { typed: n2, fraction: r2 } = t4;
  return n2(name, { Fraction: (t5) => t5.d, BigNumber: (t5) => r2(t5).d, "Array | Matrix": n2.referToSelf((t5) => (n3) => deepMap(n3, t5)) });
}), factoriesAny_exports = __exportAll({ createAbs: () => createAbs, createAccessorNode: () => createAccessorNode, createAcos: () => createAcos, createAcosh: () => createAcosh, createAcot: () => createAcot, createAcoth: () => createAcoth, createAcsc: () => createAcsc, createAcsch: () => createAcsch, createAdd: () => createAdd, createAddScalar: () => createAddScalar, createAnd: () => createAnd, createAndTransform: () => createAndTransform, createArg: () => createArg, createArrayNode: () => createArrayNode, createAsec: () => createAsec, createAsech: () => createAsech, createAsin: () => createAsin, createAsinh: () => createAsinh, createAssignmentNode: () => createAssignmentNode, createAtan: () => createAtan, createAtan2: () => createAtan2, createAtanh: () => createAtanh, createAtomicMass: () => createAtomicMass, createAvogadro: () => createAvogadro, createBellNumbers: () => createBellNumbers, createBernoulli: () => createBernoulli, createBigNumberClass: () => createBigNumberClass, createBigint: () => createBigint, createBignumber: () => createBignumber, createBin: () => createBin, createBitAnd: () => createBitAnd, createBitAndTransform: () => createBitAndTransform, createBitNot: () => createBitNot, createBitOr: () => createBitOr, createBitOrTransform: () => createBitOrTransform, createBitXor: () => createBitXor, createBlockNode: () => createBlockNode, createBohrMagneton: () => createBohrMagneton, createBohrRadius: () => createBohrRadius, createBoltzmann: () => createBoltzmann, createBoolean: () => createBoolean, createCatalan: () => createCatalan, createCbrt: () => createCbrt, createCeil: () => createCeil, createChain: () => createChain, createChainClass: () => createChainClass, createClassicalElectronRadius: () => createClassicalElectronRadius, createClone: () => createClone, createColumn: () => createColumn, createColumnTransform: () => createColumnTransform, createCombinations: () => createCombinations, createCombinationsWithRep: () => createCombinationsWithRep, createCompare: () => createCompare, createCompareNatural: () => createCompareNatural, createCompareText: () => createCompareText, createCompile: () => createCompile, createComplex: () => createComplex, createComplexClass: () => createComplexClass, createComposition: () => createComposition, createConcat: () => createConcat, createConcatTransform: () => createConcatTransform, createConditionalNode: () => createConditionalNode, createConductanceQuantum: () => createConductanceQuantum, createConj: () => createConj, createConstantNode: () => createConstantNode, createCorr: () => createCorr, createCos: () => createCos, createCosh: () => createCosh, createCot: () => createCot, createCoth: () => createCoth, createCoulomb: () => createCoulomb, createCoulombConstant: () => createCoulombConstant, createCount: () => createCount, createCreateUnit: () => createCreateUnit, createCross: () => createCross, createCsc: () => createCsc, createCsch: () => createCsch, createCtranspose: () => createCtranspose, createCube: () => createCube, createCumSum: () => createCumSum, createCumSumTransform: () => createCumSumTransform, createDeepEqual: () => createDeepEqual, createDen: () => createDen, createDenseMatrixClass: () => createDenseMatrixClass, createDerivative: () => createDerivative, createDet: () => createDet, createDeuteronMass: () => createDeuteronMass, createDiag: () => createDiag, createDiff: () => createDiff, createDiffTransform: () => createDiffTransform, createDistance: () => createDistance, createDivide: () => createDivide, createDivideScalar: () => createDivideScalar, createDot: () => createDot, createDotDivide: () => createDotDivide, createDotMultiply: () => createDotMultiply, createDotPow: () => createDotPow, createE: () => createE, createEfimovFactor: () => createEfimovFactor, createEigs: () => createEigs, createElectricConstant: () => createElectricConstant, createElectronMass: () => createElectronMass, createElementaryCharge: () => createElementaryCharge, createEqual: () => createEqual, createEqualScalar: () => createEqualScalar, createEqualText: () => createEqualText, createErf: () => createErf, createEvaluate: () => createEvaluate, createExp: () => createExp, createExpm: () => createExpm, createExpm1: () => createExpm1, createFactorial: () => createFactorial, createFalse: () => createFalse, createFaraday: () => createFaraday, createFermiCoupling: () => createFermiCoupling, createFft: () => createFft, createFibonacciHeapClass: () => createFibonacciHeapClass, createFilter: () => createFilter, createFilterTransform: () => createFilterTransform, createFineStructure: () => createFineStructure, createFirstRadiation: () => createFirstRadiation, createFix: () => createFix, createFlatten: () => createFlatten, createFloor: () => createFloor, createForEach: () => createForEach, createForEachTransform: () => createForEachTransform, createFormat: () => createFormat, createFraction: () => createFraction, createFractionClass: () => createFractionClass, createFreqz: () => createFreqz, createFunctionAssignmentNode: () => createFunctionAssignmentNode, createFunctionNode: () => createFunctionNode, createGamma: () => createGamma, createGasConstant: () => createGasConstant, createGcd: () => createGcd, createGetMatrixDataType: () => createGetMatrixDataType, createGravitationConstant: () => createGravitationConstant, createGravity: () => createGravity, createHartreeEnergy: () => createHartreeEnergy, createHasNumericValue: () => createHasNumericValue, createHelp: () => createHelp, createHelpClass: () => createHelpClass, createHex: () => createHex, createHypot: () => createHypot, createI: () => createI, createIdentity: () => createIdentity, createIfft: () => createIfft, createIm: () => createIm, createImmutableDenseMatrixClass: () => createImmutableDenseMatrixClass, createIndex: () => createIndex, createIndexClass: () => createIndexClass, createIndexNode: () => createIndexNode, createIndexTransform: () => createIndexTransform, createInfinity: () => createInfinity, createIntersect: () => createIntersect, createInv: () => createInv, createInverseConductanceQuantum: () => createInverseConductanceQuantum, createInvmod: () => createInvmod, createIsBounded: () => createIsBounded, createIsFinite: () => createIsFinite, createIsInteger: () => createIsInteger, createIsNaN: () => createIsNaN, createIsNegative: () => createIsNegative, createIsNumeric: () => createIsNumeric, createIsPositive: () => createIsPositive, createIsPrime: () => createIsPrime, createIsZero: () => createIsZero, createKldivergence: () => createKldivergence, createKlitzing: () => createKlitzing, createKron: () => createKron, createLN10: () => createLN10, createLN2: () => createLN2, createLOG10E: () => createLOG10E, createLOG2E: () => createLOG2E, createLarger: () => createLarger, createLargerEq: () => createLargerEq, createLcm: () => createLcm, createLeafCount: () => createLeafCount, createLeftShift: () => createLeftShift, createLgamma: () => createLgamma, createLog: () => createLog, createLog10: () => createLog10, createLog1p: () => createLog1p, createLog2: () => createLog2, createLoschmidt: () => createLoschmidt, createLsolve: () => createLsolve, createLsolveAll: () => createLsolveAll, createLup: () => createLup, createLusolve: () => createLusolve, createLyap: () => createLyap, createMad: () => createMad, createMagneticConstant: () => createMagneticConstant, createMagneticFluxQuantum: () => createMagneticFluxQuantum, createMap: () => createMap, createMapSlices: () => createMapSlices, createMapSlicesTransform: () => createMapSlicesTransform, createMapTransform: () => createMapTransform, createMatrix: () => createMatrix, createMatrixClass: () => createMatrixClass, createMatrixFromColumns: () => createMatrixFromColumns, createMatrixFromFunction: () => createMatrixFromFunction, createMatrixFromRows: () => createMatrixFromRows, createMax: () => createMax, createMaxTransform: () => createMaxTransform, createMean: () => createMean, createMeanTransform: () => createMeanTransform, createMedian: () => createMedian, createMin: () => createMin, createMinTransform: () => createMinTransform, createMod: () => createMod, createMode: () => createMode, createMolarMass: () => createMolarMass, createMolarMassC12: () => createMolarMassC12, createMolarPlanckConstant: () => createMolarPlanckConstant, createMolarVolume: () => createMolarVolume, createMultinomial: () => createMultinomial, createMultiply: () => createMultiply, createMultiplyScalar: () => createMultiplyScalar, createNaN: () => createNaN, createNeutronMass: () => createNeutronMass, createNode: () => createNode, createNorm: () => createNorm, createNot: () => createNot, createNthRoot: () => createNthRoot, createNthRoots: () => createNthRoots, createNuclearMagneton: () => createNuclearMagneton, createNull: () => createNull, createNullish: () => createNullish, createNullishTransform: () => createNullishTransform, createNum: () => createNum, createNumber: () => createNumber, createNumeric: () => createNumeric, createObjectNode: () => createObjectNode, createOct: () => createOct, createOnes: () => createOnes, createOperatorNode: () => createOperatorNode, createOr: () => createOr, createOrTransform: () => createOrTransform, createParenthesisNode: () => createParenthesisNode, createParse: () => createParse, createParser: () => createParser, createParserClass: () => createParserClass, createPartitionSelect: () => createPartitionSelect, createPermutations: () => createPermutations, createPhi: () => createPhi, createPi: () => createPi, createPickRandom: () => createPickRandom, createPinv: () => createPinv, createPlanckCharge: () => createPlanckCharge, createPlanckConstant: () => createPlanckConstant, createPlanckLength: () => createPlanckLength, createPlanckMass: () => createPlanckMass, createPlanckTemperature: () => createPlanckTemperature, createPlanckTime: () => createPlanckTime, createPolynomialRoot: () => createPolynomialRoot, createPow: () => createPow, createPrint: () => createPrint, createPrintTransform: () => createPrintTransform, createProd: () => createProd, createProtonMass: () => createProtonMass, createQr: () => createQr, createQuantileSeq: () => createQuantileSeq, createQuantileSeqTransform: () => createQuantileSeqTransform, createQuantumOfCirculation: () => createQuantumOfCirculation, createRandom: () => createRandom, createRandomInt: () => createRandomInt, createRange: () => createRange, createRangeClass: () => createRangeClass, createRangeNode: () => createRangeNode, createRangeTransform: () => createRangeTransform, createRationalize: () => createRationalize, createRe: () => createRe, createReducedPlanckConstant: () => createReducedPlanckConstant, createRelationalNode: () => createRelationalNode, createReplacer: () => createReplacer, createReshape: () => createReshape, createResize: () => createResize, createResolve: () => createResolve, createResultSet: () => createResultSet, createReviver: () => createReviver, createRightArithShift: () => createRightArithShift, createRightLogShift: () => createRightLogShift, createRotate: () => createRotate, createRotationMatrix: () => createRotationMatrix, createRound: () => createRound, createRow: () => createRow, createRowTransform: () => createRowTransform, createRydberg: () => createRydberg, createSQRT1_2: () => createSQRT1_2, createSQRT2: () => createSQRT2, createSackurTetrode: () => createSackurTetrode, createSchur: () => createSchur, createSec: () => createSec, createSech: () => createSech, createSecondRadiation: () => createSecondRadiation, createSetCartesian: () => createSetCartesian, createSetDifference: () => createSetDifference, createSetDistinct: () => createSetDistinct, createSetIntersect: () => createSetIntersect, createSetIsSubset: () => createSetIsSubset, createSetMultiplicity: () => createSetMultiplicity, createSetPowerset: () => createSetPowerset, createSetSize: () => createSetSize, createSetSymDifference: () => createSetSymDifference, createSetUnion: () => createSetUnion, createSign: () => createSign, createSimplify: () => createSimplify, createSimplifyConstant: () => createSimplifyConstant, createSimplifyCore: () => createSimplifyCore, createSin: () => createSin, createSinh: () => createSinh, createSize: () => createSize, createSlu: () => createSlu, createSmaller: () => createSmaller, createSmallerEq: () => createSmallerEq, createSolveODE: () => createSolveODE, createSort: () => createSort, createSpaClass: () => createSpaClass, createSparse: () => createSparse, createSparseMatrixClass: () => createSparseMatrixClass, createSpeedOfLight: () => createSpeedOfLight, createSplitUnit: () => createSplitUnit, createSqrt: () => createSqrt, createSqrtm: () => createSqrtm, createSquare: () => createSquare, createSqueeze: () => createSqueeze, createStd: () => createStd, createStdTransform: () => createStdTransform, createStefanBoltzmann: () => createStefanBoltzmann, createStirlingS2: () => createStirlingS2, createString: () => createString, createSubset: () => createSubset, createSubsetTransform: () => createSubsetTransform, createSubtract: () => createSubtract, createSubtractScalar: () => createSubtractScalar, createSum: () => createSum, createSumTransform: () => createSumTransform, createSylvester: () => createSylvester, createSymbolNode: () => createSymbolNode, createSymbolicEqual: () => createSymbolicEqual, createTan: () => createTan, createTanh: () => createTanh, createTau: () => createTau, createThomsonCrossSection: () => createThomsonCrossSection, createTo: () => createTo, createToBest: () => createToBest, createTrace: () => createTrace, createTranspose: () => createTranspose, createTrue: () => createTrue, createTypeOf: () => createTypeOf, createTyped: () => createTyped, createUnaryMinus: () => createUnaryMinus, createUnaryPlus: () => createUnaryPlus, createUnequal: () => createUnequal, createUnitClass: () => createUnitClass, createUnitFunction: () => createUnitFunction, createUppercaseE: () => createUppercaseE, createUppercasePi: () => createUppercasePi, createUsolve: () => createUsolve, createUsolveAll: () => createUsolveAll, createVacuumImpedance: () => createVacuumImpedance, createVariance: () => createVariance, createVarianceTransform: () => createVarianceTransform, createVersion: () => createVersion, createWeakMixingAngle: () => createWeakMixingAngle, createWienDisplacement: () => createWienDisplacement, createXgcd: () => createXgcd, createXor: () => createXor, createZeros: () => createZeros, createZeta: () => createZeta, createZpk2tf: () => createZpk2tf }), all = factoriesAny_exports, require_tiny_emitter = __commonJSMin(((t4, n2) => {
  function r2() {
  }
  r2.prototype = { on: function(t5, n3, r3) {
    var i2 = this.e ||= {};
    return (i2[t5] || (i2[t5] = [])).push({ fn: n3, ctx: r3 }), this;
  }, once: function(t5, n3, r3) {
    var i2 = this;
    function a2() {
      i2.off(t5, a2), n3.apply(r3, arguments);
    }
    return a2._ = n3, this.on(t5, a2, r3);
  }, emit: function(t5) {
    for (var n3 = [].slice.call(arguments, 1), r3 = ((this.e ||= {})[t5] || []).slice(), i2 = 0, a2 = r3.length; i2 < a2; i2++) r3[i2].fn.apply(r3[i2].ctx, n3);
    return this;
  }, off: function(t5, n3) {
    var r3 = this.e ||= {}, i2 = r3[t5], a2 = [];
    if (i2 && n3) for (var o2 = 0, s2 = i2.length; o2 < s2; o2++) i2[o2].fn !== n3 && i2[o2].fn._ !== n3 && a2.push(i2[o2]);
    return a2.length ? r3[t5] = a2 : delete r3[t5], this;
  } }, n2.exports = r2, n2.exports.TinyEmitter = r2;
})), import_tiny_emitter = __toESM(require_tiny_emitter());
function mixin$1(t4) {
  var n2 = new import_tiny_emitter.default();
  return t4.on = n2.on.bind(n2), t4.off = n2.off.bind(n2), t4.once = n2.once.bind(n2), t4.emit = n2.emit.bind(n2), t4;
}
function importFactory(t4, n2, r2, i2) {
  function a2(t5, n3) {
    var r3 = arguments.length;
    if (r3 !== 1 && r3 !== 2) throw new ArgumentsError(`import`, r3, 1, 2);
    n3 ||= {};
    function i3(t6, r4, a4) {
      if (Array.isArray(r4)) r4.forEach((n4) => i3(t6, n4));
      else if (isObject$1(r4) || p2(r4)) for (var o3 in r4) hasOwnProperty$1$1(r4, o3) && i3(t6, r4[o3], o3);
      else if (isFactory(r4) || a4 !== void 0) {
        var s4 = isFactory(r4) ? v2(r4) ? r4.fn + `.transform` : r4.fn : a4;
        if (hasOwnProperty$1$1(t6, s4) && t6[s4] !== r4 && !n3.silent) throw Error(`Cannot import "` + s4 + `" twice`);
        t6[s4] = r4;
      } else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
    var a3 = {};
    for (var s3 in i3(a3, t5), a3) if (hasOwnProperty$1$1(a3, s3)) {
      var c3 = a3[s3];
      if (isFactory(c3)) u2(c3, n3);
      else if (d2(c3)) o2(s3, c3, n3);
      else if (!n3.silent) throw TypeError(`Factory, Object, or Array expected`);
    }
  }
  function o2(n3, a3, o3) {
    if (o3.wrap && typeof a3 == `function` && (a3 = l2(a3)), m2(a3) && (a3 = t4(n3, { [a3.signature]: a3 })), t4.isTypedFunction(r2[n3]) && t4.isTypedFunction(a3)) {
      a3 = o3.override ? t4(n3, a3.signatures) : t4(r2[n3], a3), r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    var u3 = r2[n3] !== void 0, d3 = r2.Unit?.isValuelessUnit(n3);
    if (!u3 && !d3 || o3.override) {
      r2[n3] = a3, delete i2[n3], s2(n3, a3), r2.emit(`import`, n3, function() {
        return a3;
      });
      return;
    }
    if (!o3.silent) throw Error(`Cannot import "` + n3 + `": already exists`);
  }
  function s2(t5, n3) {
    n3 && typeof n3.transform == `function` ? (r2.expression.transform[t5] = n3.transform, h2(t5) && (r2.expression.mathWithTransform[t5] = n3.transform)) : (delete r2.expression.transform[t5], h2(t5) && (r2.expression.mathWithTransform[t5] = n3));
  }
  function c2(t5) {
    delete r2.expression.transform[t5], h2(t5) ? r2.expression.mathWithTransform[t5] = r2[t5] : delete r2.expression.mathWithTransform[t5];
  }
  function l2(t5) {
    var n3 = function() {
      for (var n4 = [], i3 = 0, a3 = arguments.length; i3 < a3; i3++) {
        var o3 = arguments[i3];
        n4[i3] = o3 && o3.valueOf();
      }
      return t5.apply(r2, n4);
    };
    return t5.transform && (n3.transform = t5.transform), n3;
  }
  function u2(n3, a3) {
    var l3 = arguments.length > 2 && arguments[2] !== void 0 ? arguments[2] : n3.fn;
    if (l3.includes(`.`)) throw Error(`Factory name should not contain a nested path. Name: ` + JSON.stringify(l3));
    var u3 = v2(n3) ? r2.expression.transform : r2, d3 = l3 in r2.expression.transform, p3 = hasOwnProperty$1$1(u3, l3) ? u3[l3] : void 0, m3 = function() {
      var i3 = {};
      n3.dependencies.map(stripOptionalNotation).forEach((t5) => {
        if (t5.includes(`.`)) throw Error(`Factory dependency should not contain a nested path. Name: ` + JSON.stringify(t5));
        t5 === `math` ? i3.math = r2 : t5 === `mathWithTransform` ? i3.mathWithTransform = r2.expression.mathWithTransform : t5 === `classes` ? i3.classes = r2 : i3[t5] = r2[t5];
      });
      var o3 = n3(i3);
      if (o3 && typeof o3.transform == `function`) throw Error(`Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"`);
      if (p3 === void 0 || a3.override) return o3;
      if (t4.isTypedFunction(p3) && t4.isTypedFunction(o3)) return t4(p3, o3);
      if (a3.silent) return p3;
      throw Error(`Cannot import "` + l3 + `": already exists`);
    }, h3 = n3.meta?.formerly ?? ``, y3 = v2(n3) || g2(n3), b2 = r2.expression.mathWithTransform;
    !n3.meta || n3.meta.lazy !== false ? (lazy(u3, l3, m3), h3 && lazy(u3, h3, m3), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy(b2, l3, () => u3[l3]), h3 && lazy(b2, h3, () => u3[l3]))) : (u3[l3] = m3(), h3 && (u3[h3] = u3[l3]), p3 && d3 ? (c2(l3), h3 && c2(h3)) : y3 && (lazy(b2, l3, () => u3[l3]), h3 && lazy(b2, h3, () => u3[l3]))), i2[l3] = n3, r2.emit(`import`, l3, m3);
  }
  function d2(t5) {
    return typeof t5 == `function` || typeof t5 == `number` || typeof t5 == `string` || typeof t5 == `boolean` || t5 === null || isUnit(t5) || isComplex(t5) || isBigNumber(t5) || isFraction(t5) || isMatrix(t5) || Array.isArray(t5);
  }
  function p2(t5) {
    return typeof t5 == `object` && t5[Symbol.toStringTag] === `Module`;
  }
  function m2(t5) {
    return typeof t5 == `function` && typeof t5.signature == `string`;
  }
  function h2(t5) {
    return !hasOwnProperty$1$1(y2, t5);
  }
  function g2(t5) {
    return !t5.fn.includes(`.`) && !hasOwnProperty$1$1(y2, t5.fn) && (!t5.meta || !t5.meta.isClass);
  }
  function v2(t5) {
    return t5 !== void 0 && t5.meta !== void 0 && t5.meta.isTransformFunction === true || false;
  }
  var y2 = { expression: true, type: true, docs: true, error: true, json: true, chain: true };
  return a2;
}
function create$1(t4, n2) {
  var r2 = _extends({}, DEFAULT_CONFIG, n2);
  if (typeof Object.create != `function`) throw Error(`ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.`);
  var i2 = mixin$1({ isNumber, isComplex, isBigNumber, isBigInt, isFraction, isUnit, isString, isArray, isMatrix, isCollection, isDenseMatrix, isSparseMatrix, isRange, isIndex, isBoolean: isBoolean$1, isResultSet, isHelp, isFunction: isFunction$1, isDate, isRegExp, isObject: isObject$1, isMap, isPartitionedMap, isObjectWrappingMap, isNull: isNull$1, isUndefined: isUndefined$1, isAccessorNode, isArrayNode, isAssignmentNode, isBlockNode, isConditionalNode, isConstantNode, isFunctionAssignmentNode, isFunctionNode, isIndexNode, isNode: isNode$2, isObjectNode, isOperatorNode, isParenthesisNode, isRangeNode, isRelationalNode, isSymbolNode, isChain });
  i2.config = configFactory(r2, i2.emit), i2.expression = { transform: {}, mathWithTransform: { config: i2.config } };
  var a2 = [], o2 = [];
  function s2(t5) {
    if (isFactory(t5)) return t5(i2);
    var n3 = t5[Object.keys(t5)[0]];
    if (isFactory(n3)) return n3(i2);
    if (!isLegacyFactory(t5)) throw console.warn("Factory object with properties `type`, `name`, and `factory` expected", t5), Error("Factory object with properties `type`, `name`, and `factory` expected");
    var c3 = a2.indexOf(t5), l3;
    return c3 === -1 ? (l3 = t5.math === true ? t5.factory(i2.type, r2, s2, i2.typed, i2) : t5.factory(i2.type, r2, s2, i2.typed), a2.push(t5), o2.push(l3)) : l3 = o2[c3], l3;
  }
  var c2 = {};
  function l2() {
    var t5 = [...arguments];
    return i2.typed.apply(i2.typed, t5);
  }
  l2.isTypedFunction = import_typed_function.default.isTypedFunction;
  var u2 = importFactory(l2, s2, i2, c2);
  return i2.import = u2, i2.on(`config`, () => {
    Object.values(c2).forEach((t5) => {
      t5 && t5.meta && t5.meta.recreateOnConfigChange && u2(t5, { override: true });
    });
  }), i2.create = create$1.bind(null, t4), i2.factory = factory, i2.import(Object.values(deepFlatten(t4))), i2.ArgumentsError = ArgumentsError, i2.DimensionError = DimensionError, i2.IndexError = IndexError, i2;
}
var require_numeric_1_2_6 = __commonJSMin(((exports) => {
  var numeric = exports === void 0 ? (function() {
  }) : exports;
  typeof global < `u` && (global.numeric = numeric), numeric.version = `1.2.6`, numeric.bench = function(t4, n2) {
    var r2, i2, a2, o2;
    for (n2 === void 0 && (n2 = 15), a2 = 0.5, r2 = /* @__PURE__ */ new Date(); ; ) {
      for (a2 *= 2, o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
      for (; o2 > 0; ) t4(), o2--;
      if (i2 = /* @__PURE__ */ new Date(), i2 - r2 > n2) break;
    }
    for (o2 = a2; o2 > 3; o2 -= 4) t4(), t4(), t4(), t4();
    for (; o2 > 0; ) t4(), o2--;
    return i2 = /* @__PURE__ */ new Date(), 1e3 * (3 * a2 - 1) / (i2 - r2);
  }, numeric._myIndexOf = (function(t4) {
    var n2 = this.length, r2;
    for (r2 = 0; r2 < n2; ++r2) if (this[r2] === t4) return r2;
    return -1;
  }), numeric.myIndexOf = Array.prototype.indexOf ? Array.prototype.indexOf : numeric._myIndexOf, numeric.Function = Function, numeric.precision = 4, numeric.largeArray = 50, numeric.prettyPrint = function(t4) {
    function n2(t5) {
      if (t5 === 0) return `0`;
      if (isNaN(t5)) return `NaN`;
      if (t5 < 0) return `-` + n2(-t5);
      if (isFinite(t5)) {
        var r3 = Math.floor(Math.log(t5) / Math.log(10)), i3 = t5 / 10 ** r3, a2 = i3.toPrecision(numeric.precision);
        return parseFloat(a2) === 10 && (r3++, i3 = 1, a2 = i3.toPrecision(numeric.precision)), parseFloat(a2).toString() + `e` + r3.toString();
      }
      return `Infinity`;
    }
    var r2 = [];
    function i2(t5) {
      var a2;
      if (t5 === void 0) return r2.push(Array(numeric.precision + 8).join(` `)), false;
      if (typeof t5 == `string`) return r2.push(`"` + t5 + `"`), false;
      if (typeof t5 == `boolean`) return r2.push(t5.toString()), false;
      if (typeof t5 == `number`) {
        var o2 = n2(t5), s2 = t5.toPrecision(numeric.precision), c2 = parseFloat(t5.toString()).toString(), l2 = [o2, s2, c2, parseFloat(s2).toString(), parseFloat(c2).toString()];
        for (a2 = 1; a2 < l2.length; a2++) l2[a2].length < o2.length && (o2 = l2[a2]);
        return r2.push(Array(numeric.precision + 8 - o2.length).join(` `) + o2), false;
      }
      if (t5 === null) return r2.push(`null`), false;
      if (typeof t5 == `function`) {
        r2.push(t5.toString());
        var u2 = false;
        for (a2 in t5) t5.hasOwnProperty(a2) && (u2 ? r2.push(`,
`) : r2.push(`
{`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
        return u2 && r2.push(`}
`), true;
      }
      if (t5 instanceof Array) {
        if (t5.length > numeric.largeArray) return r2.push(`...Large Array...`), true;
        var u2 = false;
        for (r2.push(`[`), a2 = 0; a2 < t5.length; a2++) a2 > 0 && (r2.push(`,`), u2 && r2.push(`
 `)), u2 = i2(t5[a2]);
        return r2.push(`]`), true;
      }
      r2.push(`{`);
      var u2 = false;
      for (a2 in t5) t5.hasOwnProperty(a2) && (u2 && r2.push(`,
`), u2 = true, r2.push(a2), r2.push(`: 
`), i2(t5[a2]));
      return r2.push(`}`), true;
    }
    return i2(t4), r2.join(``);
  }, numeric.parseDate = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return Date.parse(t5.replace(/-/g, `/`));
      if (!(t5 instanceof Array)) throw Error(`parseDate: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseFloat = function(t4) {
    function n2(t5) {
      if (typeof t5 == `string`) return parseFloat(t5);
      if (!(t5 instanceof Array)) throw Error(`parseFloat: parameter must be arrays of strings`);
      var r2 = [], i2;
      for (i2 = 0; i2 < t5.length; i2++) r2[i2] = n2(t5[i2]);
      return r2;
    }
    return n2(t4);
  }, numeric.parseCSV = function(t4) {
    var n2 = t4.split(`
`), r2, i2, a2 = [], o2 = /(([^'",]*)|('[^']*')|("[^"]*")),/g, s2 = /^\s*(([+-]?[0-9]+(\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\.[0-9]+)?(e[+-]?[0-9]+)?))\s*$/, c2 = function(t5) {
      return t5.substr(0, t5.length - 1);
    }, l2 = 0;
    for (i2 = 0; i2 < n2.length; i2++) {
      var u2 = (n2[i2] + `,`).match(o2), d2;
      if (u2.length > 0) {
        for (a2[l2] = [], r2 = 0; r2 < u2.length; r2++) d2 = c2(u2[r2]), s2.test(d2) ? a2[l2][r2] = parseFloat(d2) : a2[l2][r2] = d2;
        l2++;
      }
    }
    return a2;
  }, numeric.toCSV = function(t4) {
    var n2 = numeric.dim(t4), r2, i2, a2 = n2[0], s2, c2;
    for (n2[1], c2 = [], r2 = 0; r2 < a2; r2++) {
      for (s2 = [], i2 = 0; i2 < a2; i2++) s2[i2] = t4[r2][i2].toString();
      c2[r2] = s2.join(`, `);
    }
    return c2.join(`
`) + `
`;
  }, numeric.getURL = function(t4) {
    var n2 = new XMLHttpRequest();
    return n2.open(`GET`, t4, false), n2.send(), n2;
  }, numeric.imageURL = function(t4) {
    function n2(t5) {
      var n3 = t5.length, r3, i3, a3, o3, s3, c2, l3, u3, d3 = `ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=`, p3 = ``;
      for (r3 = 0; r3 < n3; r3 += 3) i3 = t5[r3], a3 = t5[r3 + 1], o3 = t5[r3 + 2], s3 = i3 >> 2, c2 = ((i3 & 3) << 4) + (a3 >> 4), l3 = ((a3 & 15) << 2) + (o3 >> 6), u3 = o3 & 63, r3 + 1 >= n3 ? l3 = u3 = 64 : r3 + 2 >= n3 && (u3 = 64), p3 += d3.charAt(s3) + d3.charAt(c2) + d3.charAt(l3) + d3.charAt(u3);
      return p3;
    }
    function r2(t5, n3, r3) {
      n3 === void 0 && (n3 = 0), r3 === void 0 && (r3 = t5.length);
      var i3 = [0, 1996959894, 3993919788, 2567524794, 124634137, 1886057615, 3915621685, 2657392035, 249268274, 2044508324, 3772115230, 2547177864, 162941995, 2125561021, 3887607047, 2428444049, 498536548, 1789927666, 4089016648, 2227061214, 450548861, 1843258603, 4107580753, 2211677639, 325883990, 1684777152, 4251122042, 2321926636, 335633487, 1661365465, 4195302755, 2366115317, 997073096, 1281953886, 3579855332, 2724688242, 1006888145, 1258607687, 3524101629, 2768942443, 901097722, 1119000684, 3686517206, 2898065728, 853044451, 1172266101, 3705015759, 2882616665, 651767980, 1373503546, 3369554304, 3218104598, 565507253, 1454621731, 3485111705, 3099436303, 671266974, 1594198024, 3322730930, 2970347812, 795835527, 1483230225, 3244367275, 3060149565, 1994146192, 31158534, 2563907772, 4023717930, 1907459465, 112637215, 2680153253, 3904427059, 2013776290, 251722036, 2517215374, 3775830040, 2137656763, 141376813, 2439277719, 3865271297, 1802195444, 476864866, 2238001368, 4066508878, 1812370925, 453092731, 2181625025, 4111451223, 1706088902, 314042704, 2344532202, 4240017532, 1658658271, 366619977, 2362670323, 4224994405, 1303535960, 984961486, 2747007092, 3569037538, 1256170817, 1037604311, 2765210733, 3554079995, 1131014506, 879679996, 2909243462, 3663771856, 1141124467, 855842277, 2852801631, 3708648649, 1342533948, 654459306, 3188396048, 3373015174, 1466479909, 544179635, 3110523913, 3462522015, 1591671054, 702138776, 2966460450, 3352799412, 1504918807, 783551873, 3082640443, 3233442989, 3988292384, 2596254646, 62317068, 1957810842, 3939845945, 2647816111, 81470997, 1943803523, 3814918930, 2489596804, 225274430, 2053790376, 3826175755, 2466906013, 167816743, 2097651377, 4027552580, 2265490386, 503444072, 1762050814, 4150417245, 2154129355, 426522225, 1852507879, 4275313526, 2312317920, 282753626, 1742555852, 4189708143, 2394877945, 397917763, 1622183637, 3604390888, 2714866558, 953729732, 1340076626, 3518719985, 2797360999, 1068828381, 1219638859, 3624741850, 2936675148, 906185462, 1090812512, 3747672003, 2825379669, 829329135, 1181335161, 3412177804, 3160834842, 628085408, 1382605366, 3423369109, 3138078467, 570562233, 1426400815, 3317316542, 2998733608, 733239954, 1555261956, 3268935591, 3050360625, 752459403, 1541320221, 2607071920, 3965973030, 1969922972, 40735498, 2617837225, 3943577151, 1913087877, 83908371, 2512341634, 3803740692, 2075208622, 213261112, 2463272603, 3855990285, 2094854071, 198958881, 2262029012, 4057260610, 1759359992, 534414190, 2176718541, 4139329115, 1873836001, 414664567, 2282248934, 4279200368, 1711684554, 285281116, 2405801727, 4167216745, 1634467795, 376229701, 2685067896, 3608007406, 1308918612, 956543938, 2808555105, 3495958263, 1231636301, 1047427035, 2932959818, 3654703836, 1088359270, 936918e3, 2847714899, 3736837829, 1202900863, 817233897, 3183342108, 3401237130, 1404277552, 615818150, 3134207493, 3453421203, 1423857449, 601450431, 3009837614, 3294710456, 1567103746, 711928724, 3020668471, 3272380065, 1510334235, 755167117], a3 = -1, o3 = 0;
      t5.length;
      var c2;
      for (c2 = n3; c2 < r3; c2++) o3 = (a3 ^ t5[c2]) & 255, a3 = a3 >>> 8 ^ i3[o3];
      return a3 ^ -1;
    }
    var i2 = t4[0].length, a2 = t4[0][0].length, o2, s2, l2, u2, d2, p2, m2, h2, g2, v2, y2 = [137, 80, 78, 71, 13, 10, 26, 10, 0, 0, 0, 13, 73, 72, 68, 82, a2 >> 24 & 255, a2 >> 16 & 255, a2 >> 8 & 255, a2 & 255, i2 >> 24 & 255, i2 >> 16 & 255, i2 >> 8 & 255, i2 & 255, 8, 2, 0, 0, 0, -1, -2, -3, -4, -5, -6, -7, -8, 73, 68, 65, 84, 8, 29];
    for (v2 = r2(y2, 12, 29), y2[29] = v2 >> 24 & 255, y2[30] = v2 >> 16 & 255, y2[31] = v2 >> 8 & 255, y2[32] = v2 & 255, o2 = 1, s2 = 0, m2 = 0; m2 < i2; m2++) {
      for (m2 < i2 - 1 ? y2.push(0) : y2.push(1), d2 = 3 * a2 + 1 + (m2 === 0) & 255, p2 = 3 * a2 + 1 + (m2 === 0) >> 8 & 255, y2.push(d2), y2.push(p2), y2.push(~d2 & 255), y2.push(~p2 & 255), m2 === 0 && y2.push(0), h2 = 0; h2 < a2; h2++) for (l2 = 0; l2 < 3; l2++) d2 = t4[l2][m2][h2], d2 = d2 > 255 ? 255 : d2 < 0 ? 0 : Math.round(d2), o2 = (o2 + d2) % 65521, s2 = (s2 + o2) % 65521, y2.push(d2);
      y2.push(0);
    }
    return g2 = (s2 << 16) + o2, y2.push(g2 >> 24 & 255), y2.push(g2 >> 16 & 255), y2.push(g2 >> 8 & 255), y2.push(g2 & 255), u2 = y2.length - 41, y2[33] = u2 >> 24 & 255, y2[34] = u2 >> 16 & 255, y2[35] = u2 >> 8 & 255, y2[36] = u2 & 255, v2 = r2(y2, 37), y2.push(v2 >> 24 & 255), y2.push(v2 >> 16 & 255), y2.push(v2 >> 8 & 255), y2.push(v2 & 255), y2.push(0), y2.push(0), y2.push(0), y2.push(0), y2.push(73), y2.push(69), y2.push(78), y2.push(68), y2.push(174), y2.push(66), y2.push(96), y2.push(130), `data:image/png;base64,` + n2(y2);
  }, numeric._dim = function(t4) {
    for (var n2 = []; typeof t4 == `object`; ) n2.push(t4.length), t4 = t4[0];
    return n2;
  }, numeric.dim = function(t4) {
    var n2, r2;
    return typeof t4 == `object` ? (n2 = t4[0], typeof n2 == `object` ? (r2 = n2[0], typeof r2 == `object` ? numeric._dim(t4) : [t4.length, n2.length]) : [t4.length]) : [];
  }, numeric.mapreduce = function(t4, n2) {
    return Function(`x`, `accum`, `_s`, `_k`, `if(typeof accum === "undefined") accum = ` + n2 + `;
if(typeof x === "number") { var xi = x; ` + t4 + `; return accum; }
if(typeof _s === "undefined") _s = numeric.dim(x);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i,xi;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) {
        accum = arguments.callee(x[i],accum,_s,_k+1);
    }    return accum;
}
for(i=_n-1;i>=1;i-=2) { 
    xi = x[i];
    ` + t4 + `;
    xi = x[i-1];
    ` + t4 + `;
}
if(i === 0) {
    xi = x[i];
    ` + t4 + `
}
return accum;`);
  }, numeric.mapreduce2 = function(t4, n2) {
    return Function(`x`, `var n = x.length;
var i,xi;
` + n2 + `;
for(i=n-1;i!==-1;--i) { 
    xi = x[i];
    ` + t4 + `;
}
return accum;`);
  }, numeric.same = function t4(n2, r2) {
    var i2, a2;
    if (!(n2 instanceof Array) || !(r2 instanceof Array) || (a2 = n2.length, a2 !== r2.length)) return false;
    for (i2 = 0; i2 < a2; i2++) if (n2[i2] !== r2[i2]) if (typeof n2[i2] == `object`) {
      if (!t4(n2[i2], r2[i2])) return false;
    } else return false;
    return true;
  }, numeric.rep = function(t4, n2, r2) {
    r2 === void 0 && (r2 = 0);
    var i2 = t4[r2], a2 = Array(i2), o2;
    if (r2 === t4.length - 1) {
      for (o2 = i2 - 2; o2 >= 0; o2 -= 2) a2[o2 + 1] = n2, a2[o2] = n2;
      return o2 === -1 && (a2[0] = n2), a2;
    }
    for (o2 = i2 - 1; o2 >= 0; o2--) a2[o2] = numeric.rep(t4, n2, r2 + 1);
    return a2;
  }, numeric.dotMMsmall = function(t4, n2) {
    var r2, i2, a2, o2 = t4.length, s2 = n2.length, c2 = n2[0].length, l2 = Array(o2), u2, d2, p2, m2;
    for (r2 = o2 - 1; r2 >= 0; r2--) {
      for (u2 = Array(c2), d2 = t4[r2], a2 = c2 - 1; a2 >= 0; a2--) {
        for (p2 = d2[s2 - 1] * n2[s2 - 1][a2], i2 = s2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += d2[i2] * n2[i2][a2] + d2[m2] * n2[m2][a2];
        i2 === 0 && (p2 += d2[0] * n2[0][a2]), u2[a2] = p2;
      }
      l2[r2] = u2;
    }
    return l2;
  }, numeric._getCol = function(t4, n2, r2) {
    var i2 = t4.length, a2;
    for (a2 = i2 - 1; a2 > 0; --a2) r2[a2] = t4[a2][n2], --a2, r2[a2] = t4[a2][n2];
    a2 === 0 && (r2[0] = t4[0][n2]);
  }, numeric.dotMMbig = function(t4, n2) {
    var r2 = numeric._getCol, i2 = n2.length, a2 = Array(i2), o2 = t4.length, s2 = n2[0].length, c2 = Array(o2), l2, u2 = numeric.dotVV, d2, p2;
    for (--i2, --o2, d2 = o2; d2 !== -1; --d2) c2[d2] = Array(s2);
    for (--s2, d2 = s2; d2 !== -1; --d2) for (r2(n2, d2, a2), p2 = o2; p2 !== -1; --p2) l2 = t4[p2], c2[p2][d2] = u2(l2, a2);
    return c2;
  }, numeric.dotMV = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2, o2 = Array(r2), s2 = numeric.dotVV;
    for (a2 = r2 - 1; a2 >= 0; a2--) o2[a2] = s2(t4[a2], n2);
    return o2;
  }, numeric.dotVM = function(t4, n2) {
    var i2, a2, o2 = t4.length, s2 = n2[0].length, l2 = Array(s2), p2, m2;
    for (a2 = s2 - 1; a2 >= 0; a2--) {
      for (p2 = t4[o2 - 1] * n2[o2 - 1][a2], i2 = o2 - 2; i2 >= 1; i2 -= 2) m2 = i2 - 1, p2 += t4[i2] * n2[i2][a2] + t4[m2] * n2[m2][a2];
      i2 === 0 && (p2 += t4[0] * n2[0][a2]), l2[a2] = p2;
    }
    return l2;
  }, numeric.dotVV = function(t4, n2) {
    var r2, i2 = t4.length, a2, o2 = t4[i2 - 1] * n2[i2 - 1];
    for (r2 = i2 - 2; r2 >= 1; r2 -= 2) a2 = r2 - 1, o2 += t4[r2] * n2[r2] + t4[a2] * n2[a2];
    return r2 === 0 && (o2 += t4[0] * n2[0]), o2;
  }, numeric.dot = function(t4, n2) {
    var r2 = numeric.dim;
    switch (r2(t4).length * 1e3 + r2(n2).length) {
      case 2002:
        return n2.length < 10 ? numeric.dotMMsmall(t4, n2) : numeric.dotMMbig(t4, n2);
      case 2001:
        return numeric.dotMV(t4, n2);
      case 1002:
        return numeric.dotVM(t4, n2);
      case 1001:
        return numeric.dotVV(t4, n2);
      case 1e3:
        return numeric.mulVS(t4, n2);
      case 1:
        return numeric.mulSV(t4, n2);
      case 0:
        return t4 * n2;
      default:
        throw Error(`numeric.dot only works on vectors and matrices`);
    }
  }, numeric.diag = function(t4) {
    var n2, r2, i2, a2 = t4.length, o2 = Array(a2), s2;
    for (n2 = a2 - 1; n2 >= 0; n2--) {
      for (s2 = Array(a2), r2 = n2 + 2, i2 = a2 - 1; i2 >= r2; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      for (i2 > n2 && (s2[i2] = 0), s2[n2] = t4[n2], i2 = n2 - 1; i2 >= 1; i2 -= 2) s2[i2] = 0, s2[i2 - 1] = 0;
      i2 === 0 && (s2[0] = 0), o2[n2] = s2;
    }
    return o2;
  }, numeric.getDiag = function(t4) {
    var n2 = Math.min(t4.length, t4[0].length), r2, i2 = Array(n2);
    for (r2 = n2 - 1; r2 >= 1; --r2) i2[r2] = t4[r2][r2], --r2, i2[r2] = t4[r2][r2];
    return r2 === 0 && (i2[0] = t4[0][0]), i2;
  }, numeric.identity = function(t4) {
    return numeric.diag(numeric.rep([t4], 1));
  }, numeric.pointwise = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `_s`, i2[t4.length + 1] = `_k`, i2[t4.length + 2] = `if(typeof _s === "undefined") _s = numeric.dim(` + c2 + `);
if(typeof _k === "undefined") _k = 0;
var _n = _s[_k];
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
if(_k < _s.length-1) {
    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(` + t4.join(`,`) + `,_s,_k+1);
    return ret;
}
` + r2 + `
for(i=_n-1;i!==-1;--i) {
    ` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric.pointwise2 = function(t4, n2, r2) {
    r2 === void 0 && (r2 = ``);
    var i2 = [], a2, o2 = /\[i\]$/, s2, c2 = ``, l2 = false;
    for (a2 = 0; a2 < t4.length; a2++) o2.test(t4[a2]) ? (s2 = t4[a2].substring(0, t4[a2].length - 3), c2 = s2) : s2 = t4[a2], s2 === `ret` && (l2 = true), i2.push(s2);
    return i2[t4.length] = `var _n = ` + c2 + `.length;
var i` + (l2 ? `` : `, ret = Array(_n)`) + `;
` + r2 + `
for(i=_n-1;i!==-1;--i) {
` + n2 + `
}
return ret;`, Function.apply(null, i2);
  }, numeric._biforeach = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) {
      o2(n2, r2);
      return;
    }
    var s2;
    for (s2 = i2[a2] - 1; s2 >= 0; s2--) t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
  }), numeric._biforeach2 = (function t4(n2, r2, i2, a2, o2) {
    if (a2 === i2.length - 1) return o2(n2, r2);
    var s2, c2 = i2[a2], l2 = Array(c2);
    for (s2 = c2 - 1; s2 >= 0; --s2) l2[s2] = t4(typeof n2 == `object` ? n2[s2] : n2, typeof r2 == `object` ? r2[s2] : r2, i2, a2 + 1, o2);
    return l2;
  }), numeric._foreach = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) {
      a2(n2);
      return;
    }
    var o2;
    for (o2 = r2[i2] - 1; o2 >= 0; o2--) t4(n2[o2], r2, i2 + 1, a2);
  }), numeric._foreach2 = (function t4(n2, r2, i2, a2) {
    if (i2 === r2.length - 1) return a2(n2);
    var o2, s2 = r2[i2], c2 = Array(s2);
    for (o2 = s2 - 1; o2 >= 0; o2--) c2[o2] = t4(n2[o2], r2, i2 + 1, a2);
    return c2;
  }), numeric.ops2 = { add: `+`, sub: `-`, mul: `*`, div: `/`, mod: `%`, and: `&&`, or: `||`, eq: `===`, neq: `!==`, lt: `<`, gt: `>`, leq: `<=`, geq: `>=`, band: `&`, bor: `|`, bxor: `^`, lshift: `<<`, rshift: `>>`, rrshift: `>>>` }, numeric.opseq = { addeq: `+=`, subeq: `-=`, muleq: `*=`, diveq: `/=`, modeq: `%=`, lshifteq: `<<=`, rshifteq: `>>=`, rrshifteq: `>>>=`, bandeq: `&=`, boreq: `|=`, bxoreq: `^=` }, numeric.mathfuns = [`abs`, `acos`, `asin`, `atan`, `ceil`, `cos`, `exp`, `floor`, `log`, `round`, `sin`, `sqrt`, `tan`, `isNaN`, `isFinite`], numeric.mathfuns2 = [`atan2`, `pow`, `max`, `min`], numeric.ops1 = { neg: `-`, not: `!`, bnot: `~`, clone: `` }, numeric.mapreducers = { any: [`if(xi) return true;`, `var accum = false;`], all: [`if(!xi) return false;`, `var accum = true;`], sum: [`accum += xi;`, `var accum = 0;`], prod: [`accum *= xi;`, `var accum = 1;`], norm2Squared: [`accum += xi*xi;`, `var accum = 0;`], norminf: [`accum = max(accum,abs(xi));`, `var accum = 0, max = Math.max, abs = Math.abs;`], norm1: [`accum += abs(xi)`, `var accum = 0, abs = Math.abs;`], sup: [`accum = max(accum,xi);`, `var accum = -Infinity, max = Math.max;`], inf: [`accum = min(accum,xi);`, `var accum = Infinity, min = Math.min;`] }, (function() {
    var t4, n2;
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], numeric.ops2[n2] = n2;
    for (t4 in numeric.ops2) if (numeric.ops2.hasOwnProperty(t4)) {
      n2 = numeric.ops2[t4];
      var r2, i2, a2 = ``;
      numeric.myIndexOf.call(numeric.mathfuns2, t4) === -1 ? (r2 = function(t5, r3, i3) {
        return t5 + ` = ` + r3 + ` ` + n2 + ` ` + i3;
      }, i2 = numeric.opseq.hasOwnProperty(t4 + `eq`) ? function(t5, r3) {
        return t5 + ` ` + n2 + `= ` + r3;
      } : function(t5, r3) {
        return t5 + ` = ` + t5 + ` ` + n2 + ` ` + r3;
      }) : (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`, r2 = function(t5, r3, i3) {
        return t5 + ` = ` + n2 + `(` + r3 + `,` + i3 + `)`;
      }, i2 = function(t5, r3) {
        return t5 + ` = ` + n2 + `(` + t5 + `,` + r3 + `)`;
      }), numeric[t4 + `VV`] = numeric.pointwise2([`x[i]`, `y[i]`], r2(`ret[i]`, `x[i]`, `y[i]`), a2), numeric[t4 + `SV`] = numeric.pointwise2([`x`, `y[i]`], r2(`ret[i]`, `x`, `y[i]`), a2), numeric[t4 + `VS`] = numeric.pointwise2([`x[i]`, `y`], r2(`ret[i]`, `x[i]`, `y`), a2), numeric[t4] = Function(`var n = arguments.length, i, x = arguments[0], y;
var VV = numeric.` + t4 + `VV, VS = numeric.` + t4 + `VS, SV = numeric.` + t4 + `SV;
var dim = numeric.dim;
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof x === "object") {
      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);
      else x = numeric._biforeach2(x,y,dim(x),0,VS);
  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);
  else ` + i2(`x`, `y`) + `
}
return x;
`), numeric[n2] = numeric[t4], numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`, `x[i]`], i2(`ret[i]`, `x[i]`), a2), numeric[t4 + `eqS`] = numeric.pointwise2([`ret[i]`, `x`], i2(`ret[i]`, `x`), a2), numeric[t4 + `eq`] = Function(`var n = arguments.length, i, x = arguments[0], y;
var V = numeric.` + t4 + `eqV, S = numeric.` + t4 + `eqS
var s = numeric.dim(x);
for(i=1;i!==n;++i) { 
  y = arguments[i];
  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);
  else numeric._biforeach(x,y,s,0,S);
}
return x;
`);
    }
    for (t4 = 0; t4 < numeric.mathfuns2.length; ++t4) n2 = numeric.mathfuns2[t4], delete numeric.ops2[n2];
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], numeric.ops1[n2] = n2;
    for (t4 in numeric.ops1) numeric.ops1.hasOwnProperty(t4) && (a2 = ``, n2 = numeric.ops1[t4], numeric.myIndexOf.call(numeric.mathfuns, t4) !== -1 && Math.hasOwnProperty(n2) && (a2 = `var ` + n2 + ` = Math.` + n2 + `;
`), numeric[t4 + `eqV`] = numeric.pointwise2([`ret[i]`], `ret[i] = ` + n2 + `(ret[i]);`, a2), numeric[t4 + `eq`] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `x
var i;
var V = numeric.` + t4 + `eqV;
var s = numeric.dim(x);
numeric._foreach(x,s,0,V);
return x;
`), numeric[t4 + `V`] = numeric.pointwise2([`x[i]`], `ret[i] = ` + n2 + `(x[i]);`, a2), numeric[t4] = Function(`x`, `if(typeof x !== "object") return ` + n2 + `(x)
var i;
var V = numeric.` + t4 + `V;
var s = numeric.dim(x);
return numeric._foreach2(x,s,0,V);
`));
    for (t4 = 0; t4 < numeric.mathfuns.length; ++t4) n2 = numeric.mathfuns[t4], delete numeric.ops1[n2];
    for (t4 in numeric.mapreducers) numeric.mapreducers.hasOwnProperty(t4) && (n2 = numeric.mapreducers[t4], numeric[t4 + `V`] = numeric.mapreduce2(n2[0], n2[1]), numeric[t4] = Function(`x`, `s`, `k`, n2[1] + `if(typeof x !== "object") {    xi = x;
` + n2[0] + `;
    return accum;
}if(typeof s === "undefined") s = numeric.dim(x);
if(typeof k === "undefined") k = 0;
if(k === s.length-1) return numeric.` + t4 + `V(x);
var xi;
var n = x.length, i;
for(i=n-1;i!==-1;--i) {
   xi = arguments.callee(x[i]);
` + n2[0] + `;
}
return accum;
`));
  })(), numeric.truncVV = numeric.pointwise([`x[i]`, `y[i]`], `ret[i] = round(x[i]/y[i])*y[i];`, `var round = Math.round;`), numeric.truncVS = numeric.pointwise([`x[i]`, `y`], `ret[i] = round(x[i]/y)*y;`, `var round = Math.round;`), numeric.truncSV = numeric.pointwise([`x`, `y[i]`], `ret[i] = round(x/y[i])*y[i];`, `var round = Math.round;`), numeric.trunc = function(t4, n2) {
    return typeof t4 == `object` ? typeof n2 == `object` ? numeric.truncVV(t4, n2) : numeric.truncVS(t4, n2) : typeof n2 == `object` ? numeric.truncSV(t4, n2) : Math.round(t4 / n2) * n2;
  }, numeric.inv = function(t4) {
    var n2 = numeric.dim(t4), r2 = Math.abs, i2 = n2[0], a2 = n2[1], o2 = numeric.clone(t4), s2, c2, l2 = numeric.identity(i2), u2, d2, p2, m2, h2, t4;
    for (m2 = 0; m2 < a2; ++m2) {
      var g2 = -1, v2 = -1;
      for (p2 = m2; p2 !== i2; ++p2) h2 = r2(o2[p2][m2]), h2 > v2 && (g2 = p2, v2 = h2);
      for (c2 = o2[g2], o2[g2] = o2[m2], o2[m2] = c2, d2 = l2[g2], l2[g2] = l2[m2], l2[m2] = d2, t4 = c2[m2], h2 = m2; h2 !== a2; ++h2) c2[h2] /= t4;
      for (h2 = a2 - 1; h2 !== -1; --h2) d2[h2] /= t4;
      for (p2 = i2 - 1; p2 !== -1; --p2) if (p2 !== m2) {
        for (s2 = o2[p2], u2 = l2[p2], t4 = s2[m2], h2 = m2 + 1; h2 !== a2; ++h2) s2[h2] -= c2[h2] * t4;
        for (h2 = a2 - 1; h2 > 0; --h2) u2[h2] -= d2[h2] * t4, --h2, u2[h2] -= d2[h2] * t4;
        h2 === 0 && (u2[0] -= d2[0] * t4);
      }
    }
    return l2;
  }, numeric.det = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: det() only works on square matrices`);
    var r2 = n2[0], i2 = 1, a2, o2, s2, c2 = numeric.clone(t4), l2, u2, d2, p2, m2;
    for (o2 = 0; o2 < r2 - 1; o2++) {
      for (s2 = o2, a2 = o2 + 1; a2 < r2; a2++) Math.abs(c2[a2][o2]) > Math.abs(c2[s2][o2]) && (s2 = a2);
      for (s2 !== o2 && (p2 = c2[s2], c2[s2] = c2[o2], c2[o2] = p2, i2 *= -1), l2 = c2[o2], a2 = o2 + 1; a2 < r2; a2++) {
        for (u2 = c2[a2], d2 = u2[o2] / l2[o2], s2 = o2 + 1; s2 < r2 - 1; s2 += 2) m2 = s2 + 1, u2[s2] -= l2[s2] * d2, u2[m2] -= l2[m2] * d2;
        s2 !== r2 && (u2[s2] -= l2[s2] * d2);
      }
      if (l2[o2] === 0) return 0;
      i2 *= l2[o2];
    }
    return i2 * c2[o2][o2];
  }, numeric.transpose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2], --r2, l2 = o2[r2], l2[n2] = c2[r2], l2[n2 - 1] = s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = c2[0], l2[n2 - 1] = s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = s2[r2], --r2, o2[r2][0] = s2[r2];
      r2 === 0 && (o2[0][0] = s2[0]);
    }
    return o2;
  }, numeric.negtranspose = function(t4) {
    var n2, r2, i2 = t4.length, a2 = t4[0].length, o2 = Array(a2), s2, c2, l2;
    for (r2 = 0; r2 < a2; r2++) o2[r2] = Array(i2);
    for (n2 = i2 - 1; n2 >= 1; n2 -= 2) {
      for (c2 = t4[n2], s2 = t4[n2 - 1], r2 = a2 - 1; r2 >= 1; --r2) l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2], --r2, l2 = o2[r2], l2[n2] = -c2[r2], l2[n2 - 1] = -s2[r2];
      r2 === 0 && (l2 = o2[0], l2[n2] = -c2[0], l2[n2 - 1] = -s2[0]);
    }
    if (n2 === 0) {
      for (s2 = t4[0], r2 = a2 - 1; r2 >= 1; --r2) o2[r2][0] = -s2[r2], --r2, o2[r2][0] = -s2[r2];
      r2 === 0 && (o2[0][0] = -s2[0]);
    }
    return o2;
  }, numeric._random = function t4(n2, r2) {
    var i2, a2 = n2[r2], o2 = Array(a2), s2;
    if (r2 === n2.length - 1) {
      for (s2 = Math.random, i2 = a2 - 1; i2 >= 1; i2 -= 2) o2[i2] = s2(), o2[i2 - 1] = s2();
      return i2 === 0 && (o2[0] = s2()), o2;
    }
    for (i2 = a2 - 1; i2 >= 0; i2--) o2[i2] = t4(n2, r2 + 1);
    return o2;
  }, numeric.random = function(t4) {
    return numeric._random(t4, 0);
  }, numeric.norm2 = function(t4) {
    return Math.sqrt(numeric.norm2Squared(t4));
  }, numeric.linspace = function(t4, n2, r2) {
    if (r2 === void 0 && (r2 = Math.max(Math.round(n2 - t4) + 1, 1)), r2 < 2) return r2 === 1 ? [t4] : [];
    var i2, a2 = Array(r2);
    for (r2--, i2 = r2; i2 >= 0; i2--) a2[i2] = (i2 * n2 + (r2 - i2) * t4) / r2;
    return a2;
  }, numeric.getBlock = function(t4, n2, r2) {
    var i2 = numeric.dim(t4);
    function a2(t5, o2) {
      var s2, c2 = n2[o2], l2 = r2[o2] - c2, u2 = Array(l2);
      if (o2 === i2.length - 1) {
        for (s2 = l2; s2 >= 0; s2--) u2[s2] = t5[s2 + c2];
        return u2;
      }
      for (s2 = l2; s2 >= 0; s2--) u2[s2] = a2(t5[s2 + c2], o2 + 1);
      return u2;
    }
    return a2(t4, 0);
  }, numeric.setBlock = function(t4, n2, r2, i2) {
    var a2 = numeric.dim(t4);
    function o2(t5, i3, s2) {
      var c2, l2 = n2[s2], u2 = r2[s2] - l2;
      if (s2 === a2.length - 1) for (c2 = u2; c2 >= 0; c2--) t5[c2 + l2] = i3[c2];
      for (c2 = u2; c2 >= 0; c2--) o2(t5[c2 + l2], i3[c2], s2 + 1);
    }
    return o2(t4, i2, 0), t4;
  }, numeric.getRange = function(t4, n2, r2) {
    var i2 = n2.length, a2 = r2.length, o2, s2, c2 = Array(i2), l2, u2;
    for (o2 = i2 - 1; o2 !== -1; --o2) for (c2[o2] = Array(a2), l2 = c2[o2], u2 = t4[n2[o2]], s2 = a2 - 1; s2 !== -1; --s2) l2[s2] = u2[r2[s2]];
    return c2;
  }, numeric.blockMatrix = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length < 4) return numeric.blockMatrix([t4]);
    var r2 = n2[0], i2 = n2[1], a2 = 0, o2 = 0, s2, c2, l2;
    for (s2 = 0; s2 < r2; ++s2) a2 += t4[s2][0].length;
    for (c2 = 0; c2 < i2; ++c2) o2 += t4[0][c2][0].length;
    var u2 = Array(a2);
    for (s2 = 0; s2 < a2; ++s2) u2[s2] = Array(o2);
    var d2 = 0, p2, m2, h2, g2, v2;
    for (s2 = 0; s2 < r2; ++s2) {
      for (p2 = o2, c2 = i2 - 1; c2 !== -1; --c2) for (l2 = t4[s2][c2], p2 -= l2[0].length, h2 = l2.length - 1; h2 !== -1; --h2) for (v2 = l2[h2], m2 = u2[d2 + h2], g2 = v2.length - 1; g2 !== -1; --g2) m2[p2 + g2] = v2[g2];
      d2 += t4[s2][0].length;
    }
    return u2;
  }, numeric.tensor = function(t4, n2) {
    if (typeof t4 == `number` || typeof n2 == `number`) return numeric.mul(t4, n2);
    var r2 = numeric.dim(t4), i2 = numeric.dim(n2);
    if (r2.length !== 1 || i2.length !== 1) throw Error(`numeric: tensor product is only defined for vectors`);
    var a2 = r2[0], o2 = i2[0], s2 = Array(a2), c2, l2, u2, d2;
    for (l2 = a2 - 1; l2 >= 0; l2--) {
      for (c2 = Array(o2), d2 = t4[l2], u2 = o2 - 1; u2 >= 3; --u2) c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2], --u2, c2[u2] = d2 * n2[u2];
      for (; u2 >= 0; ) c2[u2] = d2 * n2[u2], --u2;
      s2[l2] = c2;
    }
    return s2;
  }, numeric.T = function(t4, n2) {
    this.x = t4, this.y = n2;
  }, numeric.t = function(t4, n2) {
    return new numeric.T(t4, n2);
  }, numeric.Tbinop = function(t4, n2, r2, i2, a2) {
    numeric.indexOf;
    if (typeof a2 != `string`) for (var s2 in a2 = ``, numeric) numeric.hasOwnProperty(s2) && (t4.indexOf(s2) >= 0 || n2.indexOf(s2) >= 0 || r2.indexOf(s2) >= 0 || i2.indexOf(s2) >= 0) && s2.length > 1 && (a2 += `var ` + s2 + ` = numeric.` + s2 + `;
`);
    return Function([`y`], `var x = this;
if(!(y instanceof numeric.T)) { y = new numeric.T(y); }
` + a2 + `
if(x.y) {  if(y.y) {    return new numeric.T(` + i2 + `);
  }
  return new numeric.T(` + r2 + `);
}
if(y.y) {
  return new numeric.T(` + n2 + `);
}
return new numeric.T(` + t4 + `);
`);
  }, numeric.T.prototype.add = numeric.Tbinop(`add(x.x,y.x)`, `add(x.x,y.x),y.y`, `add(x.x,y.x),x.y`, `add(x.x,y.x),add(x.y,y.y)`), numeric.T.prototype.sub = numeric.Tbinop(`sub(x.x,y.x)`, `sub(x.x,y.x),neg(y.y)`, `sub(x.x,y.x),x.y`, `sub(x.x,y.x),sub(x.y,y.y)`), numeric.T.prototype.mul = numeric.Tbinop(`mul(x.x,y.x)`, `mul(x.x,y.x),mul(x.x,y.y)`, `mul(x.x,y.x),mul(x.y,y.x)`, `sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))`), numeric.T.prototype.reciprocal = function() {
    var t4 = numeric.mul, n2 = numeric.div;
    if (this.y) {
      var r2 = numeric.add(t4(this.x, this.x), t4(this.y, this.y));
      return new numeric.T(n2(this.x, r2), n2(numeric.neg(this.y), r2));
    }
    return new T(n2(1, this.x));
  }, numeric.T.prototype.div = function(t4) {
    if (t4 instanceof numeric.T || (t4 = new numeric.T(t4)), t4.y) return this.mul(t4.reciprocal());
    var n2 = numeric.div;
    return this.y ? new numeric.T(n2(this.x, t4.x), n2(this.y, t4.x)) : new numeric.T(n2(this.x, t4.x));
  }, numeric.T.prototype.dot = numeric.Tbinop(`dot(x.x,y.x)`, `dot(x.x,y.x),dot(x.x,y.y)`, `dot(x.x,y.x),dot(x.y,y.x)`, `sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))`), numeric.T.prototype.transpose = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), t4(r2)) : new numeric.T(t4(n2));
  }, numeric.T.prototype.transjugate = function() {
    var t4 = numeric.transpose, n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(t4(n2), numeric.negtranspose(r2)) : new numeric.T(t4(n2));
  }, numeric.Tunop = function(t4, n2, r2) {
    return typeof r2 != `string` && (r2 = ``), Function(`var x = this;
` + r2 + `
if(x.y) {  ` + n2 + `;
}
` + t4 + `;
`);
  }, numeric.T.prototype.exp = numeric.Tunop(`return new numeric.T(ex)`, `return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))`, `var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;`), numeric.T.prototype.conj = numeric.Tunop(`return new numeric.T(x.x);`, `return new numeric.T(x.x,numeric.neg(x.y));`), numeric.T.prototype.neg = numeric.Tunop(`return new numeric.T(neg(x.x));`, `return new numeric.T(neg(x.x),neg(x.y));`, `var neg = numeric.neg;`), numeric.T.prototype.sin = numeric.Tunop(`return new numeric.T(numeric.sin(x.x))`, `return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));`), numeric.T.prototype.cos = numeric.Tunop(`return new numeric.T(numeric.cos(x.x))`, `return x.exp().add(x.neg().exp()).div(2);`), numeric.T.prototype.abs = numeric.Tunop(`return new numeric.T(numeric.abs(x.x));`, `return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));`, `var mul = numeric.mul;`), numeric.T.prototype.log = numeric.Tunop(`return new numeric.T(numeric.log(x.x));`, `var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();
return new numeric.T(numeric.log(r.x),theta.x);`), numeric.T.prototype.norm2 = numeric.Tunop(`return numeric.norm2(x.x);`, `var f = numeric.norm2Squared;
return Math.sqrt(f(x.x)+f(x.y));`), numeric.T.prototype.inv = function() {
    var t4 = this;
    if (t4.y === void 0) return new numeric.T(numeric.inv(t4.x));
    var n2 = t4.x.length, r2, i2, a2, o2 = numeric.identity(n2), s2 = numeric.rep([n2, n2], 0), c2 = numeric.clone(t4.x), l2 = numeric.clone(t4.y), u2, d2, p2, m2, h2, g2, v2, y2, r2, i2, a2, b2, x2, S2, w2, E, D, O2;
    for (r2 = 0; r2 < n2; r2++) {
      for (S2 = c2[r2][r2], w2 = l2[r2][r2], b2 = S2 * S2 + w2 * w2, a2 = r2, i2 = r2 + 1; i2 < n2; i2++) S2 = c2[i2][r2], w2 = l2[i2][r2], x2 = S2 * S2 + w2 * w2, x2 > b2 && (a2 = i2, b2 = x2);
      for (a2 !== r2 && (O2 = c2[r2], c2[r2] = c2[a2], c2[a2] = O2, O2 = l2[r2], l2[r2] = l2[a2], l2[a2] = O2, O2 = o2[r2], o2[r2] = o2[a2], o2[a2] = O2, O2 = s2[r2], s2[r2] = s2[a2], s2[a2] = O2), u2 = c2[r2], d2 = l2[r2], h2 = o2[r2], g2 = s2[r2], S2 = u2[r2], w2 = d2[r2], i2 = r2 + 1; i2 < n2; i2++) E = u2[i2], D = d2[i2], u2[i2] = (E * S2 + D * w2) / b2, d2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = 0; i2 < n2; i2++) E = h2[i2], D = g2[i2], h2[i2] = (E * S2 + D * w2) / b2, g2[i2] = (D * S2 - E * w2) / b2;
      for (i2 = r2 + 1; i2 < n2; i2++) {
        for (p2 = c2[i2], m2 = l2[i2], v2 = o2[i2], y2 = s2[i2], S2 = p2[r2], w2 = m2[r2], a2 = r2 + 1; a2 < n2; a2++) E = u2[a2], D = d2[a2], p2[a2] -= E * S2 - D * w2, m2[a2] -= D * S2 + E * w2;
        for (a2 = 0; a2 < n2; a2++) E = h2[a2], D = g2[a2], v2[a2] -= E * S2 - D * w2, y2[a2] -= D * S2 + E * w2;
      }
    }
    for (r2 = n2 - 1; r2 > 0; r2--) for (h2 = o2[r2], g2 = s2[r2], i2 = r2 - 1; i2 >= 0; i2--) for (v2 = o2[i2], y2 = s2[i2], S2 = c2[i2][r2], w2 = l2[i2][r2], a2 = n2 - 1; a2 >= 0; a2--) E = h2[a2], D = g2[a2], v2[a2] -= S2 * E - w2 * D, y2[a2] -= S2 * D + w2 * E;
    return new numeric.T(o2, s2);
  }, numeric.T.prototype.get = function(t4) {
    var n2 = this.x, r2 = this.y, i2 = 0, a2, o2 = t4.length;
    if (r2) {
      for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], r2 = r2[a2], i2++;
      return new numeric.T(n2, r2);
    }
    for (; i2 < o2; ) a2 = t4[i2], n2 = n2[a2], i2++;
    return new numeric.T(n2);
  }, numeric.T.prototype.set = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = 0, o2, s2 = t4.length, c2 = n2.x, l2 = n2.y;
    if (s2 === 0) return l2 ? this.y = l2 : i2 && (this.y = void 0), this.x = r2, this;
    if (l2) {
      for (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2); a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, i2[o2] = l2, this;
    }
    if (i2) {
      for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], i2 = i2[o2], a2++;
      return o2 = t4[a2], r2[o2] = c2, c2 instanceof Array ? i2[o2] = numeric.rep(numeric.dim(c2), 0) : i2[o2] = 0, this;
    }
    for (; a2 < s2 - 1; ) o2 = t4[a2], r2 = r2[o2], a2++;
    return o2 = t4[a2], r2[o2] = c2, this;
  }, numeric.T.prototype.getRows = function(t4, n2) {
    var r2 = n2 - t4 + 1, i2, a2 = Array(r2), o2, s2 = this.x, c2 = this.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2 - t4] = s2[i2];
    if (c2) {
      for (o2 = Array(r2), i2 = t4; i2 <= n2; i2++) o2[i2 - t4] = c2[i2];
      return new numeric.T(a2, o2);
    }
    return new numeric.T(a2);
  }, numeric.T.prototype.setRows = function(t4, n2, r2) {
    var i2, a2 = this.x, o2 = this.y, s2 = r2.x, c2 = r2.y;
    for (i2 = t4; i2 <= n2; i2++) a2[i2] = s2[i2 - t4];
    if (c2) for (o2 || (o2 = numeric.rep(numeric.dim(a2), 0), this.y = o2), i2 = t4; i2 <= n2; i2++) o2[i2] = c2[i2 - t4];
    else if (o2) for (i2 = t4; i2 <= n2; i2++) o2[i2] = numeric.rep([s2[i2 - t4].length], 0);
    return this;
  }, numeric.T.prototype.getRow = function(t4) {
    var n2 = this.x, r2 = this.y;
    return r2 ? new numeric.T(n2[t4], r2[t4]) : new numeric.T(n2[t4]);
  }, numeric.T.prototype.setRow = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = n2.x, o2 = n2.y;
    return r2[t4] = a2, o2 ? (i2 || (i2 = numeric.rep(numeric.dim(r2), 0), this.y = i2), i2[t4] = o2) : i2 &&= numeric.rep([a2.length], 0), this;
  }, numeric.T.prototype.getBlock = function(t4, n2) {
    var r2 = this.x, i2 = this.y, a2 = numeric.getBlock;
    return i2 ? new numeric.T(a2(r2, t4, n2), a2(i2, t4, n2)) : new numeric.T(a2(r2, t4, n2));
  }, numeric.T.prototype.setBlock = function(t4, n2, r2) {
    r2 instanceof numeric.T || (r2 = new numeric.T(r2));
    var i2 = this.x, a2 = this.y, o2 = numeric.setBlock, s2 = r2.x, c2 = r2.y;
    if (c2) return a2 ||= (this.y = numeric.rep(numeric.dim(this), 0), this.y), o2(i2, t4, n2, s2), o2(a2, t4, n2, c2), this;
    o2(i2, t4, n2, s2), a2 && o2(a2, t4, n2, numeric.rep(numeric.dim(s2), 0));
  }, numeric.T.rep = function(t4, n2) {
    var r2 = numeric.T;
    n2 instanceof r2 || (n2 = new r2(n2));
    var i2 = n2.x, a2 = n2.y, o2 = numeric.rep;
    return a2 ? new r2(o2(t4, i2), o2(t4, a2)) : new r2(o2(t4, i2));
  }, numeric.T.diag = function(t4) {
    t4 instanceof numeric.T || (t4 = new numeric.T(t4));
    var n2 = t4.x, r2 = t4.y, i2 = numeric.diag;
    return r2 ? new numeric.T(i2(n2), i2(r2)) : new numeric.T(i2(n2));
  }, numeric.T.eig = function() {
    if (this.y) throw Error(`eig: not implemented for complex matrices.`);
    return numeric.eig(this.x);
  }, numeric.T.identity = function(t4) {
    return new numeric.T(numeric.identity(t4));
  }, numeric.T.prototype.getDiag = function() {
    var t4 = numeric, n2 = this.x, r2 = this.y;
    return r2 ? new t4.T(t4.getDiag(n2), t4.getDiag(r2)) : new t4.T(t4.getDiag(n2));
  }, numeric.house = function(t4) {
    var n2 = numeric.clone(t4), r2 = (t4[0] >= 0 ? 1 : -1) * numeric.norm2(t4);
    n2[0] += r2;
    var i2 = numeric.norm2(n2);
    if (i2 === 0) throw Error(`eig: internal error`);
    return numeric.div(n2, i2);
  }, numeric.toUpperHessenberg = function(t4) {
    var n2 = numeric.dim(t4);
    if (n2.length !== 2 || n2[0] !== n2[1]) throw Error(`numeric: toUpperHessenberg() only works on square matrices`);
    var r2 = n2[0], i2, a2, o2, s2, c2, l2 = numeric.clone(t4), u2, d2, p2, m2, h2 = numeric.identity(r2), g2;
    for (a2 = 0; a2 < r2 - 2; a2++) {
      for (s2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) s2[i2 - a2 - 1] = l2[i2][a2];
      if (numeric.norm2(s2) > 0) {
        for (c2 = numeric.house(s2), u2 = numeric.getBlock(l2, [a2 + 1, a2], [r2 - 1, r2 - 1]), d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2 - a2 - 1], o2 = a2; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2];
        for (u2 = numeric.getBlock(l2, [0, a2 + 1], [r2 - 1, r2 - 1]), d2 = numeric.tensor(numeric.dot(u2, c2), c2), i2 = 0; i2 < r2; i2++) for (p2 = l2[i2], m2 = d2[i2], o2 = a2 + 1; o2 < r2; o2++) p2[o2] -= 2 * m2[o2 - a2 - 1];
        for (u2 = Array(r2 - a2 - 1), i2 = a2 + 1; i2 < r2; i2++) u2[i2 - a2 - 1] = h2[i2];
        for (d2 = numeric.tensor(c2, numeric.dot(c2, u2)), i2 = a2 + 1; i2 < r2; i2++) for (g2 = h2[i2], m2 = d2[i2 - a2 - 1], o2 = 0; o2 < r2; o2++) g2[o2] -= 2 * m2[o2];
      }
    }
    return { H: l2, Q: h2 };
  }, numeric.epsilon = 2220446049250313e-31, numeric.QRFrancis = function(t4, n2) {
    n2 === void 0 && (n2 = 1e4), t4 = numeric.clone(t4);
    numeric.clone(t4);
    var i2 = numeric.dim(t4)[0], a2, o2, s2, c2, l2, u2, d2, p2, m2, h2 = numeric.identity(i2), g2, v2, y2, b2, x2, S2, w2, E, D;
    if (i2 < 3) return { Q: h2, B: [[0, i2 - 1]] };
    var O2 = numeric.epsilon;
    for (D = 0; D < n2; D++) {
      for (w2 = 0; w2 < i2 - 1; w2++) if (Math.abs(t4[w2 + 1][w2]) < O2 * (Math.abs(t4[w2][w2]) + Math.abs(t4[w2 + 1][w2 + 1]))) {
        var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [w2, w2]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [w2 + 1, w2 + 1], [i2 - 1, i2 - 1]), n2);
        for (y2 = Array(w2 + 1), S2 = 0; S2 <= w2; S2++) y2[S2] = h2[S2];
        for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= w2; S2++) h2[S2] = b2[S2];
        for (y2 = Array(i2 - w2 - 1), S2 = w2 + 1; S2 < i2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.dot(M2.Q, y2), S2 = w2 + 1; S2 < i2; S2++) h2[S2] = b2[S2 - w2 - 1];
        return { Q: h2, B: j2.B.concat(numeric.add(M2.B, w2 + 1)) };
      }
      if (s2 = t4[i2 - 2][i2 - 2], c2 = t4[i2 - 2][i2 - 1], l2 = t4[i2 - 1][i2 - 2], u2 = t4[i2 - 1][i2 - 1], p2 = s2 + u2, d2 = s2 * u2 - c2 * l2, m2 = numeric.getBlock(t4, [0, 0], [2, 2]), p2 * p2 >= 4 * d2) {
        var N2 = 0.5 * (p2 + Math.sqrt(p2 * p2 - 4 * d2)), F = 0.5 * (p2 - Math.sqrt(p2 * p2 - 4 * d2));
        m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, N2 + F)), numeric.diag(numeric.rep([3], N2 * F)));
      } else m2 = numeric.add(numeric.sub(numeric.dot(m2, m2), numeric.mul(m2, p2)), numeric.diag(numeric.rep([3], d2)));
      for (a2 = [m2[0][0], m2[1][0], m2[2][0]], o2 = numeric.house(a2), y2 = [t4[0], t4[1], t4[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < i2; E++) v2[E] -= 2 * x2[E];
      for (y2 = numeric.getBlock(t4, [0, 0], [i2 - 1, 2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = 0; E < 3; E++) v2[E] -= 2 * x2[E];
      for (y2 = [h2[0], h2[1], h2[2]], b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = 0; S2 < 3; S2++) for (g2 = h2[S2], x2 = b2[S2], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      var I2;
      for (w2 = 0; w2 < i2 - 2; w2++) {
        for (E = w2; E <= w2 + 1; E++) if (Math.abs(t4[E + 1][E]) < O2 * (Math.abs(t4[E][E]) + Math.abs(t4[E + 1][E + 1]))) {
          var j2 = numeric.QRFrancis(numeric.getBlock(t4, [0, 0], [E, E]), n2), M2 = numeric.QRFrancis(numeric.getBlock(t4, [E + 1, E + 1], [i2 - 1, i2 - 1]), n2);
          for (y2 = Array(E + 1), S2 = 0; S2 <= E; S2++) y2[S2] = h2[S2];
          for (b2 = numeric.dot(j2.Q, y2), S2 = 0; S2 <= E; S2++) h2[S2] = b2[S2];
          for (y2 = Array(i2 - E - 1), S2 = E + 1; S2 < i2; S2++) y2[S2 - E - 1] = h2[S2];
          for (b2 = numeric.dot(M2.Q, y2), S2 = E + 1; S2 < i2; S2++) h2[S2] = b2[S2 - E - 1];
          return { Q: h2, B: j2.B.concat(numeric.add(M2.B, E + 1)) };
        }
        for (I2 = Math.min(i2 - 1, w2 + 3), a2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) a2[S2 - w2 - 1] = t4[S2][w2];
        for (o2 = numeric.house(a2), y2 = numeric.getBlock(t4, [w2 + 1, w2], [I2, i2 - 1]), b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (v2 = t4[S2], x2 = b2[S2 - w2 - 1], E = w2; E < i2; E++) v2[E] -= 2 * x2[E - w2];
        for (y2 = numeric.getBlock(t4, [0, w2 + 1], [i2 - 1, I2]), b2 = numeric.tensor(numeric.dot(y2, o2), o2), S2 = 0; S2 < i2; S2++) for (v2 = t4[S2], x2 = b2[S2], E = w2 + 1; E <= I2; E++) v2[E] -= 2 * x2[E - w2 - 1];
        for (y2 = Array(I2 - w2), S2 = w2 + 1; S2 <= I2; S2++) y2[S2 - w2 - 1] = h2[S2];
        for (b2 = numeric.tensor(o2, numeric.dot(o2, y2)), S2 = w2 + 1; S2 <= I2; S2++) for (g2 = h2[S2], x2 = b2[S2 - w2 - 1], E = 0; E < i2; E++) g2[E] -= 2 * x2[E];
      }
    }
    throw Error(`numeric: eigenvalue iteration does not converge -- increase maxiter?`);
  }, numeric.eig = function(t4, n2) {
    var r2 = numeric.toUpperHessenberg(t4), i2 = numeric.QRFrancis(r2.H, n2), a2 = numeric.T, o2 = t4.length, s2, c2, u2 = i2.B, d2 = numeric.dot(i2.Q, numeric.dot(r2.H, numeric.transpose(i2.Q))), p2 = new a2(numeric.dot(i2.Q, r2.Q)), m2, h2 = u2.length, g2, v2, y2, b2, x2, S2, w2, E, D, O2, j2, M2, N2, F, I2 = Math.sqrt;
    for (c2 = 0; c2 < h2; c2++) if (s2 = u2[c2][0], s2 !== u2[c2][1]) {
      if (g2 = s2 + 1, v2 = d2[s2][s2], y2 = d2[s2][g2], b2 = d2[g2][s2], x2 = d2[g2][g2], y2 === 0 && b2 === 0) continue;
      S2 = -v2 - x2, w2 = v2 * x2 - y2 * b2, E = S2 * S2 - 4 * w2, E >= 0 ? (D = S2 < 0 ? -0.5 * (S2 - I2(E)) : -0.5 * (S2 + I2(E)), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2), j2 = (v2 - D) / N2, M2 = y2 / N2) : (F = I2(F), j2 = b2 / F, M2 = (x2 - D) / F), m2 = new a2([[M2, -j2], [j2, M2]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2)))) : (D = -0.5 * S2, O2 = 0.5 * I2(-E), N2 = (v2 - D) * (v2 - D) + y2 * y2, F = b2 * b2 + (x2 - D) * (x2 - D), N2 > F ? (N2 = I2(N2 + O2 * O2), j2 = (v2 - D) / N2, M2 = y2 / N2, D = 0, O2 /= N2) : (F = I2(F + O2 * O2), j2 = b2 / F, M2 = (x2 - D) / F, D = O2 / F, O2 = 0), m2 = new a2([[M2, -j2], [j2, M2]], [[D, O2], [O2, -D]]), p2.setRows(s2, g2, m2.dot(p2.getRows(s2, g2))));
    }
    var L2 = p2.dot(t4).dot(p2.transjugate()), o2 = t4.length, R2 = numeric.T.identity(o2);
    for (g2 = 0; g2 < o2; g2++) if (g2 > 0) for (c2 = g2 - 1; c2 >= 0; c2--) {
      var z2 = L2.get([c2, c2]), V2 = L2.get([g2, g2]);
      if (numeric.neq(z2.x, V2.x) || numeric.neq(z2.y, V2.y)) D = L2.getRow(c2).getBlock([c2], [g2 - 1]), O2 = R2.getRow(g2).getBlock([c2], [g2 - 1]), R2.set([g2, c2], L2.get([c2, g2]).neg().sub(D.dot(O2)).div(z2.sub(V2)));
      else {
        R2.setRow(g2, R2.getRow(c2));
        continue;
      }
    }
    for (g2 = 0; g2 < o2; g2++) D = R2.getRow(g2), R2.setRow(g2, D.div(D.norm2()));
    return R2 = R2.transpose(), R2 = p2.transjugate().dot(R2), { lambda: L2.getDiag(), E: R2 };
  }, numeric.ccsSparse = function(t4) {
    var n2 = t4.length, r2, i2, a2, o2, s2 = [];
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) {
      for (o2 = parseInt(o2); o2 >= s2.length; ) s2[s2.length] = 0;
      i2[o2] !== 0 && s2[o2]++;
    }
    var r2 = s2.length, c2 = Array(r2 + 1);
    for (c2[0] = 0, a2 = 0; a2 < r2; ++a2) c2[a2 + 1] = c2[a2] + s2[a2];
    var l2 = Array(c2[r2]), u2 = Array(c2[r2]);
    for (a2 = n2 - 1; a2 !== -1; --a2) for (o2 in i2 = t4[a2], i2) i2[o2] !== 0 && (s2[o2]--, l2[c2[o2] + s2[o2]] = a2, u2[c2[o2] + s2[o2]] = i2[o2]);
    return [c2, l2, u2];
  }, numeric.ccsFull = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.ccsDim(t4), o2 = a2[0], s2 = a2[1], c2, l2, u2, d2, m2 = numeric.rep([o2, s2], 0);
    for (c2 = 0; c2 < s2; c2++) for (u2 = n2[c2], d2 = n2[c2 + 1], l2 = u2; l2 < d2; ++l2) m2[r2[l2]][c2] = i2[l2];
    return m2;
  }, numeric.ccsTSolve = function(t4, n2, r2, i2, a2) {
    var o2 = t4[0], s2 = t4[1], c2 = t4[2], l2 = o2.length - 1, u2 = Math.max, d2 = 0;
    i2 === void 0 && (r2 = numeric.rep([l2], 0)), i2 === void 0 && (i2 = numeric.linspace(0, r2.length - 1)), a2 === void 0 && (a2 = []);
    function p2(t5) {
      var n3;
      if (r2[t5] === 0) {
        for (r2[t5] = 1, n3 = o2[t5]; n3 < o2[t5 + 1]; ++n3) p2(s2[n3]);
        a2[d2] = t5, ++d2;
      }
    }
    var m2, h2, g2, v2, y2, b2, w2;
    for (m2 = i2.length - 1; m2 !== -1; --m2) p2(i2[m2]);
    for (a2.length = d2, m2 = a2.length - 1; m2 !== -1; --m2) r2[a2[m2]] = 0;
    for (m2 = i2.length - 1; m2 !== -1; --m2) h2 = i2[m2], r2[h2] = n2[h2];
    for (m2 = a2.length - 1; m2 !== -1; --m2) {
      for (h2 = a2[m2], g2 = o2[h2], v2 = u2(o2[h2 + 1], g2), y2 = g2; y2 !== v2; ++y2) if (s2[y2] === h2) {
        r2[h2] /= c2[y2];
        break;
      }
      for (w2 = r2[h2], y2 = g2; y2 !== v2; ++y2) b2 = s2[y2], b2 !== h2 && (r2[b2] -= w2 * c2[y2]);
    }
    return r2;
  }, numeric.ccsDFS = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS.prototype.dfs = function(t4, n2, r2, i2, a2, o2) {
    var s2 = 0, c2, l2 = a2.length, u2 = this.k, d2 = this.k1, p2 = this.j, m2, h2;
    if (i2[t4] === 0) for (i2[t4] = 1, p2[0] = t4, u2[0] = m2 = n2[t4], d2[0] = h2 = n2[t4 + 1]; ; ) if (m2 >= h2) {
      if (a2[l2] = p2[s2], s2 === 0) return;
      ++l2, --s2, m2 = u2[s2], h2 = d2[s2];
    } else c2 = o2[r2[m2]], i2[c2] === 0 ? (i2[c2] = 1, u2[s2] = m2, ++s2, p2[s2] = c2, m2 = n2[c2], d2[s2] = h2 = n2[c2 + 1]) : ++m2;
  }, numeric.ccsLPSolve = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = t4[0], l2 = t4[1], u2 = t4[2];
    c2.length - 1;
    var m2 = n2[0], h2 = n2[1], g2 = n2[2], v2, y2 = m2[a2], b2 = m2[a2 + 1], x2, w2, E, D, O2, N2;
    for (i2.length = 0, v2 = y2; v2 < b2; ++v2) s2.dfs(o2[h2[v2]], c2, l2, r2, i2, o2);
    for (v2 = i2.length - 1; v2 !== -1; --v2) r2[i2[v2]] = 0;
    for (v2 = y2; v2 !== b2; ++v2) x2 = o2[h2[v2]], r2[x2] = g2[v2];
    for (v2 = i2.length - 1; v2 !== -1; --v2) {
      for (x2 = i2[v2], w2 = c2[x2], E = c2[x2 + 1], D = w2; D < E; ++D) if (o2[l2[D]] === x2) {
        r2[x2] /= u2[D];
        break;
      }
      for (N2 = r2[x2], D = w2; D < E; ++D) O2 = o2[l2[D]], O2 !== x2 && (r2[O2] -= N2 * u2[D]);
    }
    return r2;
  }, numeric.ccsLUP1 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[v2]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[h2]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2, x2 = p2[h2], p2[h2] = p2[S2], p2[S2] = x2), x2 = o2[h2], S2 = l2[h2], E = p2[h2], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[v2], m2[g2] = 0, p2[v2] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsDFS0 = function(t4) {
    this.k = Array(t4), this.k1 = Array(t4), this.j = Array(t4);
  }, numeric.ccsDFS0.prototype.dfs = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = 0, l2, u2 = a2.length, d2 = this.k, p2 = this.k1, m2 = this.j, h2, g2;
    if (i2[t4] === 0) for (i2[t4] = 1, m2[0] = t4, d2[0] = h2 = n2[o2[t4]], p2[0] = g2 = n2[o2[t4] + 1]; ; ) {
      if (isNaN(h2)) throw Error(`Ow!`);
      if (h2 >= g2) {
        if (a2[u2] = o2[m2[c2]], c2 === 0) return;
        ++u2, --c2, h2 = d2[c2], g2 = p2[c2];
      } else l2 = r2[h2], i2[l2] === 0 ? (i2[l2] = 1, d2[c2] = h2, ++c2, m2[c2] = l2, l2 = o2[l2], h2 = n2[l2], p2[c2] = g2 = n2[l2 + 1]) : ++h2;
    }
  }, numeric.ccsLPSolve0 = function(t4, n2, r2, i2, a2, o2, s2, c2) {
    var l2 = t4[0], u2 = t4[1], d2 = t4[2];
    l2.length - 1;
    var h2 = n2[0], g2 = n2[1], v2 = n2[2], y2, b2 = h2[a2], x2 = h2[a2 + 1], S2, E, D, O2, j2, F;
    for (i2.length = 0, y2 = b2; y2 < x2; ++y2) c2.dfs(g2[y2], l2, u2, r2, i2, o2, s2);
    for (y2 = i2.length - 1; y2 !== -1; --y2) S2 = i2[y2], r2[s2[S2]] = 0;
    for (y2 = b2; y2 !== x2; ++y2) S2 = g2[y2], r2[S2] = v2[y2];
    for (y2 = i2.length - 1; y2 !== -1; --y2) {
      for (S2 = i2[y2], j2 = s2[S2], E = l2[S2], D = l2[S2 + 1], O2 = E; O2 < D; ++O2) if (u2[O2] === j2) {
        r2[j2] /= d2[O2];
        break;
      }
      for (F = r2[j2], O2 = E; O2 < D; ++O2) r2[u2[O2]] -= F * d2[O2];
      r2[j2] = F;
    }
  }, numeric.ccsLUP0 = function(t4, n2) {
    var r2 = t4[0].length - 1, i2 = [numeric.rep([r2 + 1], 0), [], []], a2 = [numeric.rep([r2 + 1], 0), [], []], o2 = i2[0], s2 = i2[1], c2 = i2[2], l2 = a2[0], u2 = a2[1], d2 = a2[2], p2 = numeric.rep([r2], 0), m2 = numeric.rep([r2], 0), h2, g2, v2, x2, S2, w2, E, O2 = numeric.ccsLPSolve0, M2 = Math.abs, N2 = numeric.linspace(0, r2 - 1), F = numeric.linspace(0, r2 - 1), I2 = new numeric.ccsDFS0(r2);
    for (n2 === void 0 && (n2 = 1), h2 = 0; h2 < r2; ++h2) {
      for (O2(i2, t4, p2, m2, h2, F, N2, I2), x2 = -1, S2 = -1, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], !(v2 <= h2) && (w2 = M2(p2[N2[v2]]), w2 > x2 && (S2 = v2, x2 = w2));
      for (M2(p2[N2[h2]]) < n2 * x2 && (g2 = N2[h2], x2 = N2[S2], N2[h2] = x2, F[x2] = h2, N2[S2] = g2, F[g2] = S2), x2 = o2[h2], S2 = l2[h2], E = p2[N2[h2]], s2[x2] = N2[h2], c2[x2] = 1, ++x2, g2 = m2.length - 1; g2 !== -1; --g2) v2 = m2[g2], w2 = p2[N2[v2]], m2[g2] = 0, p2[N2[v2]] = 0, v2 <= h2 ? (u2[S2] = v2, d2[S2] = w2, ++S2) : (s2[x2] = N2[v2], c2[x2] = w2 / E, ++x2);
      o2[h2 + 1] = x2, l2[h2 + 1] = S2;
    }
    for (g2 = s2.length - 1; g2 !== -1; --g2) s2[g2] = F[s2[g2]];
    return { L: i2, U: a2, P: N2, Pinv: F };
  }, numeric.ccsLUP = numeric.ccsLUP0, numeric.ccsDim = function(t4) {
    return [numeric.sup(t4[1]) + 1, t4[0].length - 1];
  }, numeric.ccsGetBlock = function(t4, n2, r2) {
    var i2 = numeric.ccsDim(t4), a2 = i2[0], o2 = i2[1];
    n2 === void 0 ? n2 = numeric.linspace(0, a2 - 1) : typeof n2 == `number` && (n2 = [n2]), r2 === void 0 ? r2 = numeric.linspace(0, o2 - 1) : typeof r2 == `number` && (r2 = [r2]);
    var s2, u2 = n2.length, d2, p2 = r2.length, m2, h2, g2, v2 = numeric.rep([o2], 0), y2 = [], b2 = [], x2 = [v2, y2, b2], S2 = t4[0], w2 = t4[1], E = t4[2], D = numeric.rep([a2], 0), O2 = 0, j2 = numeric.rep([a2], 0);
    for (d2 = 0; d2 < p2; ++d2) {
      h2 = r2[d2];
      var M2 = S2[h2], N2 = S2[h2 + 1];
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 1, D[m2] = E[s2];
      for (s2 = 0; s2 < u2; ++s2) g2 = n2[s2], j2[g2] && (y2[O2] = s2, b2[O2] = D[n2[s2]], ++O2);
      for (s2 = M2; s2 < N2; ++s2) m2 = w2[s2], j2[m2] = 0;
      v2[d2 + 1] = O2;
    }
    return x2;
  }, numeric.ccsDot = function(t4, n2) {
    var r2 = t4[0], i2 = t4[1], a2 = t4[2], o2 = n2[0], s2 = n2[1], c2 = n2[2], l2 = numeric.ccsDim(t4), u2 = numeric.ccsDim(n2), d2 = l2[0];
    l2[1];
    var m2 = u2[1], h2 = numeric.rep([d2], 0), g2 = numeric.rep([d2], 0), v2 = Array(d2), y2 = numeric.rep([m2], 0), b2 = [], x2 = [], S2 = [y2, b2, x2], w2, E, D, O2, j2, M2, N2, F, I2, L2, R2;
    for (D = 0; D !== m2; ++D) {
      for (O2 = o2[D], j2 = o2[D + 1], I2 = 0, E = O2; E < j2; ++E) for (L2 = s2[E], R2 = c2[E], M2 = r2[L2], N2 = r2[L2 + 1], w2 = M2; w2 < N2; ++w2) F = i2[w2], g2[F] === 0 && (v2[I2] = F, g2[F] = 1, I2 += 1), h2[F] = h2[F] + a2[w2] * R2;
      for (O2 = y2[D], j2 = O2 + I2, y2[D + 1] = j2, E = I2 - 1; E !== -1; --E) R2 = O2 + E, w2 = v2[E], b2[R2] = w2, x2[R2] = h2[w2], g2[w2] = 0, h2[w2] = 0;
      y2[D + 1] = y2[D] + I2;
    }
    return S2;
  }, numeric.ccsLUPSolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U;
    t4.P;
    var o2 = n2[0], s2 = false;
    typeof o2 != `object` && (n2 = [[0, n2.length], numeric.linspace(0, n2.length - 1), n2], o2 = n2[0], s2 = true);
    var c2 = n2[1], l2 = n2[2], u2 = r2[0].length - 1, d2 = o2.length - 1, p2 = numeric.rep([u2], 0), m2 = Array(u2), h2 = numeric.rep([u2], 0), g2 = Array(u2), v2 = numeric.rep([d2 + 1], 0), y2 = [], b2 = [], x2 = numeric.ccsTSolve, S2, w2, E, D, O2, j2, M2 = 0;
    for (S2 = 0; S2 < d2; ++S2) {
      for (O2 = 0, E = o2[S2], D = o2[S2 + 1], w2 = E; w2 < D; ++w2) j2 = t4.Pinv[c2[w2]], g2[O2] = j2, h2[j2] = l2[w2], ++O2;
      for (g2.length = O2, x2(r2, h2, p2, g2, m2), w2 = g2.length - 1; w2 !== -1; --w2) h2[g2[w2]] = 0;
      if (x2(i2, p2, h2, m2, g2), s2) return h2;
      for (w2 = m2.length - 1; w2 !== -1; --w2) p2[m2[w2]] = 0;
      for (w2 = g2.length - 1; w2 !== -1; --w2) j2 = g2[w2], y2[M2] = j2, b2[M2] = h2[j2], h2[j2] = 0, ++M2;
      v2[S2 + 1] = M2;
    }
    return [v2, y2, b2];
  }, numeric.ccsbinop = function(t4, n2) {
    return n2 === void 0 && (n2 = ``), Function(`X`, `Y`, `var Xi = X[0], Xj = X[1], Xv = X[2];
var Yi = Y[0], Yj = Y[1], Yv = Y[2];
var n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;
var Zi = numeric.rep([n+1],0), Zj = [], Zv = [];
var x = numeric.rep([m],0),y = numeric.rep([m],0);
var xk,yk,zk;
var i,j,j0,j1,k,p=0;
` + n2 + `for(i=0;i<n;++i) {
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Xj[j];
    x[k] = 1;
    Zj[p] = k;
    ++p;
  }
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Yj[j];
    y[k] = Yv[j];
    if(x[k] === 0) {
      Zj[p] = k;
      ++p;
    }
  }
  Zi[i+1] = p;
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];
  j0 = Zi[i]; j1 = Zi[i+1];
  for(j=j0;j!==j1;++j) {
    k = Zj[j];
    xk = x[k];
    yk = y[k];
` + t4 + `
    Zv[j] = zk;
  }
  j0 = Xi[i]; j1 = Xi[i+1];
  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;
  j0 = Yi[i]; j1 = Yi[i+1];
  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;
}
return [Zi,Zj,Zv];`);
  }, (function() {
    var k, A, B, C;
    for (k in numeric.ops2) A = isFinite(eval(`1` + numeric.ops2[k] + `0`)) ? `[Y[0],Y[1],numeric.` + k + `(X,Y[2])]` : `NaN`, B = isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `[X[0],X[1],numeric.` + k + `(X[2],Y)]` : `NaN`, C = isFinite(eval(`1` + numeric.ops2[k] + `0`)) && isFinite(eval(`0` + numeric.ops2[k] + `1`)) ? `numeric.ccs` + k + `MM(X,Y)` : `NaN`, numeric[`ccs` + k + `MM`] = numeric.ccsbinop(`zk = xk ` + numeric.ops2[k] + `yk;`), numeric[`ccs` + k] = Function(`X`, `Y`, `if(typeof X === "number") return ` + A + `;
if(typeof Y === "number") return ` + B + `;
return ` + C + `;
`);
  })(), numeric.ccsScatter = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = numeric.sup(r2) + 1, o2 = n2.length, s2 = numeric.rep([a2], 0), c2 = Array(o2), l2 = Array(o2), u2 = numeric.rep([a2], 0), d2;
    for (d2 = 0; d2 < o2; ++d2) u2[r2[d2]]++;
    for (d2 = 0; d2 < a2; ++d2) s2[d2 + 1] = s2[d2] + u2[d2];
    var p2 = s2.slice(0), m2, h2;
    for (d2 = 0; d2 < o2; ++d2) h2 = r2[d2], m2 = p2[h2], c2[m2] = n2[d2], l2[m2] = i2[d2], p2[h2] = p2[h2] + 1;
    return [s2, c2, l2];
  }, numeric.ccsGather = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length - 1, o2 = r2.length, s2 = Array(o2), c2 = Array(o2), l2 = Array(o2), u2, d2, p2, m2, h2 = 0;
    for (u2 = 0; u2 < a2; ++u2) for (p2 = n2[u2], m2 = n2[u2 + 1], d2 = p2; d2 !== m2; ++d2) c2[h2] = u2, s2[h2] = r2[d2], l2[h2] = i2[d2], ++h2;
    return [s2, c2, l2];
  }, numeric.sdim = function t4(n2, r2, i2) {
    if (r2 === void 0 && (r2 = []), typeof n2 != `object`) return r2;
    for (var a2 in i2 === void 0 && (i2 = 0), i2 in r2 || (r2[i2] = 0), n2.length > r2[i2] && (r2[i2] = n2.length), n2) n2.hasOwnProperty(a2) && t4(n2[a2], r2, i2 + 1);
    return r2;
  }, numeric.sclone = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = 0), i2 === void 0 && (i2 = numeric.sdim(n2).length);
    var a2, o2 = Array(n2.length);
    if (r2 === i2 - 1) {
      for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = n2[a2]);
      return o2;
    }
    for (a2 in n2) n2.hasOwnProperty(a2) && (o2[a2] = t4(n2[a2], r2 + 1, i2));
    return o2;
  }, numeric.sdiag = function(t4) {
    var n2 = t4.length, r2, i2 = Array(n2), a2;
    for (r2 = n2 - 1; r2 >= 1; r2 -= 2) a2 = r2 - 1, i2[r2] = [], i2[r2][r2] = t4[r2], i2[a2] = [], i2[a2][a2] = t4[a2];
    return r2 === 0 && (i2[0] = [], i2[0][0] = t4[r2]), i2;
  }, numeric.sidentity = function(t4) {
    return numeric.sdiag(numeric.rep([t4], 1));
  }, numeric.stranspose = function(t4) {
    var n2 = [];
    t4.length;
    var i2, a2, o2;
    for (i2 in t4) if (t4.hasOwnProperty(i2)) for (a2 in o2 = t4[i2], o2) o2.hasOwnProperty(a2) && (typeof n2[a2] != `object` && (n2[a2] = []), n2[a2][i2] = o2[a2]);
    return n2;
  }, numeric.sLUP = function(t4, n2) {
    throw Error(`The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.`);
  }, numeric.sdotMM = function(t4, n2) {
    var r2 = t4.length;
    n2.length;
    var a2 = numeric.stranspose(n2), o2 = a2.length, s2, c2, l2, u2, d2, p2, m2 = Array(r2), h2;
    for (l2 = r2 - 1; l2 >= 0; l2--) {
      for (h2 = [], s2 = t4[l2], d2 = o2 - 1; d2 >= 0; d2--) {
        for (u2 in p2 = 0, c2 = a2[d2], s2) s2.hasOwnProperty(u2) && u2 in c2 && (p2 += s2[u2] * c2[u2]);
        p2 && (h2[d2] = p2);
      }
      m2[l2] = h2;
    }
    return m2;
  }, numeric.sdotMV = function(t4, n2) {
    var r2 = t4.length, i2, a2, o2, s2 = Array(r2), c2;
    for (a2 = r2 - 1; a2 >= 0; a2--) {
      for (o2 in i2 = t4[a2], c2 = 0, i2) i2.hasOwnProperty(o2) && n2[o2] && (c2 += i2[o2] * n2[o2]);
      c2 && (s2[a2] = c2);
    }
    return s2;
  }, numeric.sdotVM = function(t4, n2) {
    var r2, i2, a2, o2, s2 = [];
    for (r2 in t4) if (t4.hasOwnProperty(r2)) for (i2 in a2 = n2[r2], o2 = t4[r2], a2) a2.hasOwnProperty(i2) && (s2[i2] || (s2[i2] = 0), s2[i2] += o2 * a2[i2]);
    return s2;
  }, numeric.sdotVV = function(t4, n2) {
    var r2, i2 = 0;
    for (r2 in t4) t4[r2] && n2[r2] && (i2 += t4[r2] * n2[r2]);
    return i2;
  }, numeric.sdot = function(t4, n2) {
    var r2 = numeric.sdim(t4).length, i2 = numeric.sdim(n2).length;
    switch (r2 * 1e3 + i2) {
      case 0:
        return t4 * n2;
      case 1001:
        return numeric.sdotVV(t4, n2);
      case 2001:
        return numeric.sdotMV(t4, n2);
      case 1002:
        return numeric.sdotVM(t4, n2);
      case 2002:
        return numeric.sdotMM(t4, n2);
      default:
        throw Error(`numeric.sdot not implemented for tensors of order ` + r2 + ` and ` + i2);
    }
  }, numeric.sscatter = function(t4) {
    var n2 = t4[0].length, r2, i2, a2, o2 = t4.length, s2 = [], c2;
    for (i2 = n2 - 1; i2 >= 0; --i2) if (t4[o2 - 1][i2]) {
      for (c2 = s2, a2 = 0; a2 < o2 - 2; a2++) r2 = t4[a2][i2], c2[r2] || (c2[r2] = []), c2 = c2[r2];
      c2[t4[a2][i2]] = t4[a2 + 1][i2];
    }
    return s2;
  }, numeric.sgather = function t4(n2, r2, i2) {
    r2 === void 0 && (r2 = []), i2 === void 0 && (i2 = []);
    var a2 = i2.length, o2, s2;
    for (o2 in n2) if (n2.hasOwnProperty(o2)) if (i2[a2] = parseInt(o2), s2 = n2[o2], typeof s2 == `number`) {
      if (s2) {
        if (r2.length === 0) for (o2 = a2 + 1; o2 >= 0; --o2) r2[o2] = [];
        for (o2 = a2; o2 >= 0; --o2) r2[o2].push(i2[o2]);
        r2[a2 + 1].push(s2);
      }
    } else t4(s2, r2, i2);
    return i2.length > a2 && i2.pop(), r2;
  }, numeric.cLU = function(t4) {
    var n2 = t4[0], r2 = t4[1], i2 = t4[2], a2 = n2.length, o2 = 0, s2, c2, l2, u2, d2, p2;
    for (s2 = 0; s2 < a2; s2++) n2[s2] > o2 && (o2 = n2[s2]);
    o2++;
    var m2 = Array(o2), h2 = Array(o2), g2 = numeric.rep([o2], 1 / 0), v2 = numeric.rep([o2], -1 / 0), y2, b2, x2;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], c2 = r2[l2], c2 < g2[s2] && (g2[s2] = c2), c2 > v2[s2] && (v2[s2] = c2);
    for (s2 = 0; s2 < o2 - 1; s2++) v2[s2] > v2[s2 + 1] && (v2[s2 + 1] = v2[s2]);
    for (s2 = o2 - 1; s2 >= 1; s2--) g2[s2] < g2[s2 - 1] && (g2[s2 - 1] = g2[s2]);
    var S2 = 0, w2 = 0;
    for (s2 = 0; s2 < o2; s2++) h2[s2] = numeric.rep([v2[s2] - g2[s2] + 1], 0), m2[s2] = numeric.rep([s2 - g2[s2]], 0), S2 += s2 - g2[s2] + 1, w2 += v2[s2] - s2 + 1;
    for (l2 = 0; l2 < a2; l2++) s2 = n2[l2], h2[s2][r2[l2] - g2[s2]] = i2[l2];
    for (s2 = 0; s2 < o2 - 1; s2++) for (u2 = s2 - g2[s2], y2 = h2[s2], c2 = s2 + 1; g2[c2] <= s2 && c2 < o2; c2++) if (d2 = s2 - g2[c2], p2 = v2[s2] - s2, b2 = h2[c2], x2 = b2[d2] / y2[u2], x2) {
      for (l2 = 1; l2 <= p2; l2++) b2[l2 + d2] -= x2 * y2[l2 + u2];
      m2[c2][s2 - g2[c2]] = x2;
    }
    var y2 = [], b2 = [], E = [], D = [], O2 = [], j2 = [], a2 = 0, M2 = 0, N2;
    for (s2 = 0; s2 < o2; s2++) {
      for (u2 = g2[s2], d2 = v2[s2], N2 = h2[s2], c2 = s2; c2 <= d2; c2++) N2[c2 - u2] && (y2[a2] = s2, b2[a2] = c2, E[a2] = N2[c2 - u2], a2++);
      for (N2 = m2[s2], c2 = u2; c2 < s2; c2++) N2[c2 - u2] && (D[M2] = s2, O2[M2] = c2, j2[M2] = N2[c2 - u2], M2++);
      D[M2] = s2, O2[M2] = s2, j2[M2] = 1, M2++;
    }
    return { U: [y2, b2, E], L: [D, O2, j2] };
  }, numeric.cLUsolve = function(t4, n2) {
    var r2 = t4.L, i2 = t4.U, a2 = numeric.clone(n2), o2 = r2[0], s2 = r2[1], c2 = r2[2], l2 = i2[0], u2 = i2[1], d2 = i2[2], p2 = l2.length;
    o2.length;
    var h2 = a2.length, g2, y2 = 0;
    for (g2 = 0; g2 < h2; g2++) {
      for (; s2[y2] < g2; ) a2[g2] -= c2[y2] * a2[s2[y2]], y2++;
      y2++;
    }
    for (y2 = p2 - 1, g2 = h2 - 1; g2 >= 0; g2--) {
      for (; u2[y2] > g2; ) a2[g2] -= d2[y2] * a2[u2[y2]], y2--;
      a2[g2] /= d2[y2], y2--;
    }
    return a2;
  }, numeric.cgrid = function(t4, n2) {
    typeof t4 == `number` && (t4 = [t4, t4]);
    var r2 = numeric.rep(t4, -1), i2, a2, o2;
    if (typeof n2 != `function`) switch (n2) {
      case `L`:
        n2 = function(n3, r3) {
          return n3 >= t4[0] / 2 || r3 < t4[1] / 2;
        };
        break;
      default:
        n2 = function(t5, n3) {
          return true;
        };
        break;
    }
    for (o2 = 0, i2 = 1; i2 < t4[0] - 1; i2++) for (a2 = 1; a2 < t4[1] - 1; a2++) n2(i2, a2) && (r2[i2][a2] = o2, o2++);
    return r2;
  }, numeric.cdelsq = function(t4) {
    var n2 = [[-1, 0], [0, -1], [0, 1], [1, 0]], r2 = numeric.dim(t4), i2 = r2[0], a2 = r2[1], o2, s2, c2, l2, u2, d2 = [], p2 = [], m2 = [];
    for (o2 = 1; o2 < i2 - 1; o2++) for (s2 = 1; s2 < a2 - 1; s2++) if (!(t4[o2][s2] < 0)) {
      for (c2 = 0; c2 < 4; c2++) l2 = o2 + n2[c2][0], u2 = s2 + n2[c2][1], !(t4[l2][u2] < 0) && (d2.push(t4[o2][s2]), p2.push(t4[l2][u2]), m2.push(-1));
      d2.push(t4[o2][s2]), p2.push(t4[o2][s2]), m2.push(4);
    }
    return [d2, p2, m2];
  }, numeric.cdotMV = function(t4, n2) {
    var r2, i2 = t4[0], a2 = t4[1], o2 = t4[2], s2, c2 = i2.length, l2 = 0;
    for (s2 = 0; s2 < c2; s2++) i2[s2] > l2 && (l2 = i2[s2]);
    for (l2++, r2 = numeric.rep([l2], 0), s2 = 0; s2 < c2; s2++) r2[i2[s2]] += o2[s2] * n2[a2[s2]];
    return r2;
  }, numeric.Spline = function(t4, n2, r2, i2, a2) {
    this.x = t4, this.yl = n2, this.yr = r2, this.kl = i2, this.kr = a2;
  }, numeric.Spline.prototype._at = function(t4, n2) {
    var r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr, t4, c2, l2, u2, d2 = numeric.add, p2 = numeric.sub, m2 = numeric.mul;
    c2 = p2(m2(o2[n2], r2[n2 + 1] - r2[n2]), p2(a2[n2 + 1], i2[n2])), l2 = d2(m2(s2[n2 + 1], r2[n2] - r2[n2 + 1]), p2(a2[n2 + 1], i2[n2])), u2 = (t4 - r2[n2]) / (r2[n2 + 1] - r2[n2]);
    var h2 = u2 * (1 - u2);
    return d2(d2(d2(m2(1 - u2, i2[n2]), m2(u2, a2[n2 + 1])), m2(c2, h2 * (1 - u2))), m2(l2, h2 * u2));
  }, numeric.Spline.prototype.at = function(t4) {
    if (typeof t4 == `number`) {
      var n2 = this.x, r2 = n2.length, i2, a2, o2, s2 = Math.floor;
      for (i2 = 0, a2 = r2 - 1; a2 - i2 > 1; ) o2 = s2((i2 + a2) / 2), n2[o2] <= t4 ? i2 = o2 : a2 = o2;
      return this._at(t4, i2);
    }
    var r2 = t4.length, d2, p2 = Array(r2);
    for (d2 = r2 - 1; d2 !== -1; --d2) p2[d2] = this.at(t4[d2]);
    return p2;
  }, numeric.Spline.prototype.diff = function() {
    var t4 = this.x, n2 = this.yl, r2 = this.yr, i2 = this.kl, a2 = this.kr, o2 = n2.length, s2, c2, l2, u2 = i2, d2 = a2, p2 = Array(o2), m2 = Array(o2), h2 = numeric.add, g2 = numeric.mul, v2 = numeric.div, y2 = numeric.sub;
    for (s2 = o2 - 1; s2 !== -1; --s2) c2 = t4[s2 + 1] - t4[s2], l2 = y2(r2[s2 + 1], n2[s2]), p2[s2] = v2(h2(g2(l2, 6), g2(i2[s2], -4 * c2), g2(a2[s2 + 1], -2 * c2)), c2 * c2), m2[s2 + 1] = v2(h2(g2(l2, -6), g2(i2[s2], 2 * c2), g2(a2[s2 + 1], 4 * c2)), c2 * c2);
    return new numeric.Spline(t4, u2, d2, p2, m2);
  }, numeric.Spline.prototype.roots = function() {
    function t4(t5) {
      return t5 * t5;
    }
    var n2 = [], r2 = this.x, i2 = this.yl, a2 = this.yr, o2 = this.kl, s2 = this.kr;
    typeof i2[0] == `number` && (i2 = [i2], a2 = [a2], o2 = [o2], s2 = [s2]);
    var c2 = i2.length, l2 = r2.length - 1, u2, d2, p2, v2, y2, b2, x2, n2 = Array(c2), S2, w2, E, D, O2, j2, M2, N2, F, L2, R2, z2, V2, H2, U2, W2, G2 = Math.sqrt;
    for (u2 = 0; u2 !== c2; ++u2) {
      for (v2 = i2[u2], y2 = a2[u2], b2 = o2[u2], x2 = s2[u2], S2 = [], d2 = 0; d2 !== l2; d2++) {
        for (d2 > 0 && y2[d2] * v2[d2] < 0 && S2.push(r2[d2]), F = r2[d2 + 1] - r2[d2], r2[d2], D = v2[d2], O2 = y2[d2 + 1], w2 = b2[d2] / F, E = x2[d2 + 1] / F, N2 = t4(w2 - E + 3 * (D - O2)) + 12 * E * D, j2 = E + 3 * D + 2 * w2 - 3 * O2, M2 = 3 * (E + w2 + 2 * (D - O2)), N2 <= 0 ? (R2 = j2 / M2, L2 = R2 > r2[d2] && R2 < r2[d2 + 1] ? [r2[d2], R2, r2[d2 + 1]] : [r2[d2], r2[d2 + 1]]) : (R2 = (j2 - G2(N2)) / M2, z2 = (j2 + G2(N2)) / M2, L2 = [r2[d2]], R2 > r2[d2] && R2 < r2[d2 + 1] && L2.push(R2), z2 > r2[d2] && z2 < r2[d2 + 1] && L2.push(z2), L2.push(r2[d2 + 1])), H2 = L2[0], R2 = this._at(H2, d2), p2 = 0; p2 < L2.length - 1; p2++) {
          if (U2 = L2[p2 + 1], z2 = this._at(U2, d2), R2 === 0) {
            S2.push(H2), H2 = U2, R2 = z2;
            continue;
          }
          if (z2 === 0 || R2 * z2 > 0) {
            H2 = U2, R2 = z2;
            continue;
          }
          for (var K2 = 0; W2 = (R2 * U2 - z2 * H2) / (R2 - z2), !(W2 <= H2 || W2 >= U2); ) if (V2 = this._at(W2, d2), V2 * z2 > 0) U2 = W2, z2 = V2, K2 === -1 && (R2 *= 0.5), K2 = -1;
          else if (V2 * R2 > 0) H2 = W2, R2 = V2, K2 === 1 && (z2 *= 0.5), K2 = 1;
          else break;
          S2.push(W2), H2 = L2[p2 + 1], R2 = this._at(H2, d2);
        }
        z2 === 0 && S2.push(U2);
      }
      n2[u2] = S2;
    }
    return typeof this.yl[0] == `number` ? n2[0] : n2;
  }, numeric.spline = function(t4, n2, r2, i2) {
    var a2 = t4.length, o2 = [], s2 = [], c2 = [], l2, u2 = numeric.sub, d2 = numeric.mul, p2 = numeric.add;
    for (l2 = a2 - 2; l2 >= 0; l2--) s2[l2] = t4[l2 + 1] - t4[l2], c2[l2] = u2(n2[l2 + 1], n2[l2]);
    (typeof r2 == `string` || typeof i2 == `string`) && (r2 = i2 = `periodic`);
    var m2 = [[], [], []];
    switch (typeof r2) {
      case `undefined`:
        o2[0] = d2(3 / (s2[0] * s2[0]), c2[0]), m2[0].push(0, 0), m2[1].push(0, 1), m2[2].push(2 / s2[0], 1 / s2[0]);
        break;
      case `string`:
        o2[0] = p2(d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), d2(3 / (s2[0] * s2[0]), c2[0])), m2[0].push(0, 0, 0), m2[1].push(a2 - 2, 0, 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2] + 2 / s2[0], 1 / s2[0]);
        break;
      default:
        o2[0] = r2, m2[0].push(0), m2[1].push(0), m2[2].push(1);
        break;
    }
    for (l2 = 1; l2 < a2 - 1; l2++) o2[l2] = p2(d2(3 / (s2[l2 - 1] * s2[l2 - 1]), c2[l2 - 1]), d2(3 / (s2[l2] * s2[l2]), c2[l2])), m2[0].push(l2, l2, l2), m2[1].push(l2 - 1, l2, l2 + 1), m2[2].push(1 / s2[l2 - 1], 2 / s2[l2 - 1] + 2 / s2[l2], 1 / s2[l2]);
    switch (typeof i2) {
      case `undefined`:
        o2[a2 - 1] = d2(3 / (s2[a2 - 2] * s2[a2 - 2]), c2[a2 - 2]), m2[0].push(a2 - 1, a2 - 1), m2[1].push(a2 - 2, a2 - 1), m2[2].push(1 / s2[a2 - 2], 2 / s2[a2 - 2]);
        break;
      case `string`:
        m2[1][m2[1].length - 1] = 0;
        break;
      default:
        o2[a2 - 1] = i2, m2[0].push(a2 - 1), m2[1].push(a2 - 1), m2[2].push(1);
        break;
    }
    o2 = typeof o2[0] == `number` ? [o2] : numeric.transpose(o2);
    var h2 = Array(o2.length);
    if (typeof r2 == `string`) for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(m2)), o2[l2]), h2[l2][a2 - 1] = h2[l2][0];
    else for (l2 = h2.length - 1; l2 !== -1; --l2) h2[l2] = numeric.cLUsolve(numeric.cLU(m2), o2[l2]);
    return h2 = typeof n2[0] == `number` ? h2[0] : numeric.transpose(h2), new numeric.Spline(t4, n2, n2, h2, h2);
  }, numeric.fftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = -6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric._ifftpow2 = function t4(n2, r2) {
    var i2 = n2.length;
    if (i2 !== 1) {
      var a2 = Math.cos, o2 = Math.sin, s2, c2, l2 = Array(i2 / 2), u2 = Array(i2 / 2), d2 = Array(i2 / 2), p2 = Array(i2 / 2);
      for (c2 = i2 / 2, s2 = i2 - 1; s2 !== -1; --s2) --c2, d2[c2] = n2[s2], p2[c2] = r2[s2], --s2, l2[c2] = n2[s2], u2[c2] = r2[s2];
      t4(l2, u2), t4(d2, p2), c2 = i2 / 2;
      var m2, h2 = 6.283185307179586 / i2, g2, v2;
      for (s2 = i2 - 1; s2 !== -1; --s2) --c2, c2 === -1 && (c2 = i2 / 2 - 1), m2 = h2 * s2, g2 = a2(m2), v2 = o2(m2), n2[s2] = l2[c2] + g2 * d2[c2] - v2 * p2[c2], r2[s2] = u2[c2] + g2 * p2[c2] + v2 * d2[c2];
    }
  }, numeric.ifftpow2 = function(t4, n2) {
    numeric._ifftpow2(t4, n2), numeric.diveq(t4, t4.length), numeric.diveq(n2, n2.length);
  }, numeric.convpow2 = function(t4, n2, r2, i2) {
    numeric.fftpow2(t4, n2), numeric.fftpow2(r2, i2);
    var a2, o2 = t4.length, s2, c2, l2, u2;
    for (a2 = o2 - 1; a2 !== -1; --a2) s2 = t4[a2], l2 = n2[a2], c2 = r2[a2], u2 = i2[a2], t4[a2] = s2 * c2 - l2 * u2, n2[a2] = s2 * u2 + l2 * c2;
    numeric.ifftpow2(t4, n2);
  }, numeric.T.prototype.fft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = -3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2;
  }, numeric.T.prototype.ifft = function() {
    var t4 = this.x, n2 = this.y, r2 = t4.length, i2 = Math.log, a2 = i2(2), o2 = 2 ** Math.ceil(i2(2 * r2 - 1) / a2), s2 = numeric.rep([o2], 0), c2 = numeric.rep([o2], 0), l2 = Math.cos, u2 = Math.sin, d2, p2 = 3.141592653589793 / r2, m2, h2 = numeric.rep([o2], 0), g2 = numeric.rep([o2], 0);
    for (d2 = 0; d2 < r2; d2++) h2[d2] = t4[d2];
    if (n2 !== void 0) for (d2 = 0; d2 < r2; d2++) g2[d2] = n2[d2];
    for (s2[0] = 1, d2 = 1; d2 <= o2 / 2; d2++) m2 = p2 * d2 * d2, s2[d2] = l2(m2), c2[d2] = u2(m2), s2[o2 - d2] = l2(m2), c2[o2 - d2] = u2(m2);
    var y2 = new numeric.T(h2, g2), b2 = new numeric.T(s2, c2);
    return y2 = y2.mul(b2), numeric.convpow2(y2.x, y2.y, numeric.clone(b2.x), numeric.neg(b2.y)), y2 = y2.mul(b2), y2.x.length = r2, y2.y.length = r2, y2.div(r2);
  }, numeric.gradient = function(t4, n2) {
    var r2 = n2.length, i2 = t4(n2);
    if (isNaN(i2)) throw Error(`gradient: f(x) is a NaN!`);
    var a2 = Math.max, o2, s2 = numeric.clone(n2), c2, l2, u2 = Array(r2);
    numeric.div;
    numeric.sub;
    var m2, a2 = Math.max, g2 = 1e-3, v2 = Math.abs, y2 = Math.min, b2, x2, S2, w2 = 0, E, D, O2;
    for (o2 = 0; o2 < r2; o2++) for (var j2 = a2(1e-6 * i2, 1e-8); ; ) {
      if (++w2, w2 > 20) throw Error(`Numerical gradient fails`);
      if (s2[o2] = n2[o2] + j2, c2 = t4(s2), s2[o2] = n2[o2] - j2, l2 = t4(s2), s2[o2] = n2[o2], isNaN(c2) || isNaN(l2)) {
        j2 /= 16;
        continue;
      }
      if (u2[o2] = (c2 - l2) / (2 * j2), b2 = n2[o2] - j2, x2 = n2[o2], S2 = n2[o2] + j2, E = (c2 - i2) / j2, D = (i2 - l2) / j2, O2 = a2(v2(u2[o2]), v2(i2), v2(c2), v2(l2), v2(b2), v2(x2), v2(S2), 1e-8), m2 = y2(a2(v2(E - u2[o2]), v2(D - u2[o2]), v2(E - D)) / O2, j2 / O2), m2 > g2) j2 /= 16;
      else break;
    }
    return u2;
  }, numeric.uncmin = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.gradient;
    s2 === void 0 && (s2 = {}), r2 === void 0 && (r2 = 1e-8), i2 === void 0 && (i2 = function(n3) {
      return c2(t4, n3);
    }), a2 === void 0 && (a2 = 1e3), n2 = numeric.clone(n2);
    var l2 = n2.length, u2 = t4(n2), d2, p2;
    if (isNaN(u2)) throw Error(`uncmin: f(x0) is a NaN!`);
    var m2 = Math.max, h2 = numeric.norm2;
    r2 = m2(r2, numeric.epsilon);
    var g2, v2, y2, b2 = s2.Hinv || numeric.identity(l2), x2 = numeric.dot;
    numeric.inv;
    var w2 = numeric.sub, E = numeric.add, D = numeric.tensor, O2 = numeric.div, j2 = numeric.mul, M2 = numeric.all, N2 = numeric.isFinite, F = numeric.neg, I2 = 0, R2, z2, V2, H2, W2, K2, q2, Y2 = ``;
    for (v2 = i2(n2); I2 < a2; ) {
      if (typeof o2 == `function` && o2(I2, n2, u2, v2, b2)) {
        Y2 = `Callback returned true`;
        break;
      }
      if (!M2(N2(v2))) {
        Y2 = `Gradient has Infinity or NaN`;
        break;
      }
      if (g2 = F(x2(b2, v2)), !M2(N2(g2))) {
        Y2 = `Search direction has Infinity or NaN`;
        break;
      }
      if (q2 = h2(g2), q2 < r2) {
        Y2 = `Newton step smaller than tol`;
        break;
      }
      for (K2 = 1, p2 = x2(v2, g2), z2 = n2; I2 < a2 && !(K2 * q2 < r2); ) {
        if (R2 = j2(g2, K2), z2 = E(n2, R2), d2 = t4(z2), d2 - u2 >= 0.1 * K2 * p2 || isNaN(d2)) {
          K2 *= 0.5, ++I2;
          continue;
        }
        break;
      }
      if (K2 * q2 < r2) {
        Y2 = `Line search step size smaller than tol`;
        break;
      }
      if (I2 === a2) {
        Y2 = `maxit reached during line search`;
        break;
      }
      y2 = i2(z2), V2 = w2(y2, v2), W2 = x2(V2, R2), H2 = x2(b2, V2), b2 = w2(E(b2, j2((W2 + x2(V2, H2)) / (W2 * W2), D(R2, R2))), O2(E(D(H2, R2), D(R2, H2)), W2)), n2 = z2, u2 = d2, v2 = y2, ++I2;
    }
    return { solution: n2, f: u2, gradient: v2, invHessian: b2, iterations: I2, message: Y2 };
  }, numeric.Dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    this.x = t4, this.y = n2, this.f = r2, this.ymid = i2, this.iterations = a2, this.events = s2, this.message = o2;
  }, numeric.Dopri.prototype._at = function(t4, n2) {
    function r2(t5) {
      return t5 * t5;
    }
    var i2 = this, a2 = i2.x, o2 = i2.y, s2 = i2.f, c2 = i2.ymid;
    a2.length;
    var u2, d2, p2, m2, h2, g2, t4, y2, b2 = 0.5, x2 = numeric.add, S2 = numeric.mul, w2 = numeric.sub, E, D, O2;
    return u2 = a2[n2], d2 = a2[n2 + 1], m2 = o2[n2], h2 = o2[n2 + 1], y2 = d2 - u2, p2 = u2 + b2 * y2, g2 = c2[n2], E = w2(s2[n2], S2(m2, 1 / (u2 - p2) + 2 / (u2 - d2))), D = w2(s2[n2 + 1], S2(h2, 1 / (d2 - p2) + 2 / (d2 - u2))), O2 = [r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), r2(t4 - u2) * r2(t4 - d2) / r2(u2 - p2) / r2(d2 - p2), r2(t4 - u2) * (t4 - p2) / r2(d2 - u2) / (d2 - p2), (t4 - u2) * r2(t4 - d2) * (t4 - p2) / r2(u2 - d2) / (u2 - p2), (t4 - d2) * r2(t4 - u2) * (t4 - p2) / r2(u2 - d2) / (d2 - p2)], x2(x2(x2(x2(S2(m2, O2[0]), S2(g2, O2[1])), S2(h2, O2[2])), S2(E, O2[3])), S2(D, O2[4]));
  }, numeric.Dopri.prototype.at = function(t4) {
    var n2, r2, i2, a2 = Math.floor;
    if (typeof t4 != `number`) {
      var o2 = t4.length, s2 = Array(o2);
      for (n2 = o2 - 1; n2 !== -1; --n2) s2[n2] = this.at(t4[n2]);
      return s2;
    }
    var c2 = this.x;
    for (n2 = 0, r2 = c2.length - 1; r2 - n2 > 1; ) i2 = a2(0.5 * (n2 + r2)), c2[i2] <= t4 ? n2 = i2 : r2 = i2;
    return this._at(t4, n2);
  }, numeric.dopri = function(t4, n2, r2, i2, a2, o2, s2) {
    a2 === void 0 && (a2 = 1e-6), o2 === void 0 && (o2 = 1e3);
    var c2 = [t4], l2 = [r2], u2 = [i2(t4, r2)], d2, p2, m2, h2, g2, v2, y2 = [], b2 = 1 / 5, x2 = [3 / 40, 9 / 40], S2 = [44 / 45, -56 / 15, 32 / 9], w2 = [19372 / 6561, -25360 / 2187, 64448 / 6561, -212 / 729], E = [9017 / 3168, -355 / 33, 46732 / 5247, 49 / 176, -5103 / 18656], D = [35 / 384, 0, 500 / 1113, 125 / 192, -2187 / 6784, 11 / 84], O2 = [0.5 * 6025192743 / 30085553152, 0, 0.5 * 51252292925 / 65400821598, 0.5 * -2691868925 / 45128329728, 0.5 * 187940372067 / 1594534317056, 0.5 * -1776094331 / 19743644256, 0.5 * 11237099 / 235043384], j2 = [1 / 5, 3 / 10, 4 / 5, 8 / 9, 1, 1], M2 = [-71 / 57600, 0, 71 / 16695, -71 / 1920, 17253 / 339200, -22 / 525, 1 / 40], N2 = 0, F, I2, L2 = (n2 - t4) / 10, R2 = 0, z2 = numeric.add, V2 = numeric.mul, H2, U2, G2 = Math.min, K2 = Math.abs, q2 = numeric.norminf, J = Math.pow, ee2 = numeric.any, Y2 = numeric.lt, te2 = numeric.and;
    numeric.sub;
    var X2, ie2, ae2, Z2 = new numeric.Dopri(c2, l2, u2, y2, -1, ``);
    for (typeof s2 == `function` && (X2 = s2(t4, r2)); t4 < n2 && R2 < o2; ) {
      if (++R2, t4 + L2 > n2 && (L2 = n2 - t4), d2 = i2(t4 + j2[0] * L2, z2(r2, V2(b2 * L2, u2[N2]))), p2 = i2(t4 + j2[1] * L2, z2(z2(r2, V2(x2[0] * L2, u2[N2])), V2(x2[1] * L2, d2))), m2 = i2(t4 + j2[2] * L2, z2(z2(z2(r2, V2(S2[0] * L2, u2[N2])), V2(S2[1] * L2, d2)), V2(S2[2] * L2, p2))), h2 = i2(t4 + j2[3] * L2, z2(z2(z2(z2(r2, V2(w2[0] * L2, u2[N2])), V2(w2[1] * L2, d2)), V2(w2[2] * L2, p2)), V2(w2[3] * L2, m2))), g2 = i2(t4 + j2[4] * L2, z2(z2(z2(z2(z2(r2, V2(E[0] * L2, u2[N2])), V2(E[1] * L2, d2)), V2(E[2] * L2, p2)), V2(E[3] * L2, m2)), V2(E[4] * L2, h2))), H2 = z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * D[0])), V2(p2, L2 * D[2])), V2(m2, L2 * D[3])), V2(h2, L2 * D[4])), V2(g2, L2 * D[5])), v2 = i2(t4 + L2, H2), F = z2(z2(z2(z2(z2(V2(u2[N2], L2 * M2[0]), V2(p2, L2 * M2[2])), V2(m2, L2 * M2[3])), V2(h2, L2 * M2[4])), V2(g2, L2 * M2[5])), V2(v2, L2 * M2[6])), U2 = typeof F == `number` ? K2(F) : q2(F), U2 > a2) {
        if (L2 = 0.2 * L2 * J(a2 / U2, 0.25), t4 + L2 === t4) {
          Z2.msg = `Step size became too small`;
          break;
        }
        continue;
      }
      if (y2[N2] = z2(z2(z2(z2(z2(z2(r2, V2(u2[N2], L2 * O2[0])), V2(p2, L2 * O2[2])), V2(m2, L2 * O2[3])), V2(h2, L2 * O2[4])), V2(g2, L2 * O2[5])), V2(v2, L2 * O2[6])), ++N2, c2[N2] = t4 + L2, l2[N2] = H2, u2[N2] = v2, typeof s2 == `function`) {
        var oe2, $2 = t4, se2 = t4 + 0.5 * L2, ce2;
        if (ie2 = s2(se2, y2[N2 - 1]), ae2 = te2(Y2(X2, 0), Y2(0, ie2)), ee2(ae2) || ($2 = se2, se2 = t4 + L2, X2 = ie2, ie2 = s2(se2, H2), ae2 = te2(Y2(X2, 0), Y2(0, ie2))), ee2(ae2)) {
          for (var le2, ue2, de2, fe2, pe2 = 0, me2 = 1, he2 = 1; ; ) {
            if (typeof X2 == `number`) ce2 = (he2 * ie2 * $2 - me2 * X2 * se2) / (he2 * ie2 - me2 * X2);
            else for (ce2 = se2, I2 = X2.length - 1; I2 !== -1; --I2) X2[I2] < 0 && ie2[I2] > 0 && (ce2 = G2(ce2, (he2 * ie2[I2] * $2 - me2 * X2[I2] * se2) / (he2 * ie2[I2] - me2 * X2[I2])));
            if (ce2 <= $2 || ce2 >= se2) break;
            oe2 = Z2._at(ce2, N2 - 1), fe2 = s2(ce2, oe2), de2 = te2(Y2(X2, 0), Y2(0, fe2)), ee2(de2) ? (se2 = ce2, ie2 = fe2, ae2 = de2, he2 = 1, pe2 === -1 ? me2 *= 0.5 : me2 = 1, pe2 = -1) : ($2 = ce2, X2 = fe2, me2 = 1, pe2 === 1 ? he2 *= 0.5 : he2 = 1, pe2 = 1);
          }
          return H2 = Z2._at(0.5 * (t4 + ce2), N2 - 1), Z2.f[N2] = i2(ce2, oe2), Z2.x[N2] = ce2, Z2.y[N2] = oe2, Z2.ymid[N2 - 1] = H2, Z2.events = ae2, Z2.iterations = R2, Z2;
        }
      }
      t4 += L2, r2 = H2, X2 = ie2, L2 = G2(0.8 * L2 * J(a2 / U2, 0.25), 4 * L2);
    }
    return Z2.iterations = R2, Z2;
  }, numeric.LU = function(t4, n2) {
    n2 ||= false;
    var r2 = Math.abs, i2, a2, o2, s2, c2, l2, u2, d2, p2, m2 = t4.length, h2 = m2 - 1, g2 = Array(m2);
    for (n2 || (t4 = numeric.clone(t4)), o2 = 0; o2 < m2; ++o2) {
      for (u2 = o2, l2 = t4[o2], p2 = r2(l2[o2]), a2 = o2 + 1; a2 < m2; ++a2) s2 = r2(t4[a2][o2]), p2 < s2 && (p2 = s2, u2 = a2);
      for (g2[o2] = u2, u2 != o2 && (t4[o2] = t4[u2], t4[u2] = l2, l2 = t4[o2]), c2 = l2[o2], i2 = o2 + 1; i2 < m2; ++i2) t4[i2][o2] /= c2;
      for (i2 = o2 + 1; i2 < m2; ++i2) {
        for (d2 = t4[i2], a2 = o2 + 1; a2 < h2; ++a2) d2[a2] -= d2[o2] * l2[a2], ++a2, d2[a2] -= d2[o2] * l2[a2];
        a2 === h2 && (d2[a2] -= d2[o2] * l2[a2]);
      }
    }
    return { LU: t4, P: g2 };
  }, numeric.LUsolve = function(t4, n2) {
    var r2, i2, a2 = t4.LU, o2 = a2.length, s2 = numeric.clone(n2), c2 = t4.P, l2, u2, p2;
    for (r2 = o2 - 1; r2 !== -1; --r2) s2[r2] = n2[r2];
    for (r2 = 0; r2 < o2; ++r2) for (l2 = c2[r2], c2[r2] !== r2 && (p2 = s2[r2], s2[r2] = s2[l2], s2[l2] = p2), u2 = a2[r2], i2 = 0; i2 < r2; ++i2) s2[r2] -= s2[i2] * u2[i2];
    for (r2 = o2 - 1; r2 >= 0; --r2) {
      for (u2 = a2[r2], i2 = r2 + 1; i2 < o2; ++i2) s2[r2] -= s2[i2] * u2[i2];
      s2[r2] /= u2[r2];
    }
    return s2;
  }, numeric.solve = function(t4, n2, r2) {
    return numeric.LUsolve(numeric.LU(t4, r2), n2);
  }, numeric.echelonize = function(t4) {
    var n2 = numeric.dim(t4), r2 = n2[0], i2 = n2[1], a2 = numeric.identity(r2), o2 = Array(r2), s2, c2, l2, u2, d2, p2, m2, h2, g2 = Math.abs, v2 = numeric.diveq;
    for (t4 = numeric.clone(t4), s2 = 0; s2 < r2; ++s2) {
      for (l2 = 0, d2 = t4[s2], p2 = a2[s2], c2 = 1; c2 < i2; ++c2) g2(d2[l2]) < g2(d2[c2]) && (l2 = c2);
      for (o2[s2] = l2, v2(p2, d2[l2]), v2(d2, d2[l2]), c2 = 0; c2 < r2; ++c2) if (c2 !== s2) {
        for (m2 = t4[c2], h2 = m2[l2], u2 = i2 - 1; u2 !== -1; --u2) m2[u2] -= d2[u2] * h2;
        for (m2 = a2[c2], u2 = r2 - 1; u2 !== -1; --u2) m2[u2] -= p2[u2] * h2;
      }
    }
    return { I: a2, A: t4, P: o2 };
  }, numeric.__solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    var c2 = numeric.sum;
    numeric.log;
    var u2 = numeric.mul, d2 = numeric.sub, p2 = numeric.dot, m2 = numeric.div, h2 = numeric.add, g2 = t4.length, v2 = r2.length, y2, b2 = false, S2 = 0, w2 = 1;
    numeric.transpose(n2);
    numeric.svd;
    var M2 = numeric.transpose;
    numeric.leq;
    var F = Math.sqrt, I2 = Math.abs;
    numeric.muleq;
    numeric.norminf;
    numeric.any;
    var V2 = Math.min, H2 = numeric.all, U2 = numeric.gt, W2 = Array(g2), G2 = Array(v2);
    numeric.rep([v2], 1);
    var q2, J = numeric.solve, ee2 = d2(r2, p2(n2, o2)), Y2, te2 = p2(t4, t4), ne2;
    for (Y2 = S2; Y2 < a2; ++Y2) {
      var X2, ae2;
      for (X2 = v2 - 1; X2 !== -1; --X2) G2[X2] = m2(n2[X2], ee2[X2]);
      var Z2 = M2(G2);
      for (X2 = g2 - 1; X2 !== -1; --X2) W2[X2] = c2(Z2[X2]);
      w2 = 0.25 * I2(te2 / p2(t4, W2));
      var oe2 = 100 * F(te2 / p2(W2, W2));
      for ((!isFinite(w2) || w2 > oe2) && (w2 = oe2), ne2 = h2(t4, u2(w2, W2)), q2 = p2(Z2, G2), X2 = g2 - 1; X2 !== -1; --X2) q2[X2][X2] += 1;
      ae2 = J(q2, m2(ne2, w2), true);
      var $2 = m2(ee2, p2(n2, ae2)), se2 = 1;
      for (X2 = v2 - 1; X2 !== -1; --X2) $2[X2] < 0 && (se2 = V2(se2, -0.999 * $2[X2]));
      if (y2 = d2(o2, u2(ae2, se2)), ee2 = d2(r2, p2(n2, y2)), !H2(U2(ee2, 0))) return { solution: o2, message: ``, iterations: Y2 };
      if (o2 = y2, w2 < i2) return { solution: y2, message: ``, iterations: Y2 };
      if (s2) {
        var ce2 = p2(t4, ne2), le2 = p2(n2, ne2);
        for (b2 = true, X2 = v2 - 1; X2 !== -1; --X2) if (ce2 * le2[X2] < 0) {
          b2 = false;
          break;
        }
      } else b2 = !(o2[g2 - 1] >= 0);
      if (b2) return { solution: y2, message: `Unbounded`, iterations: Y2 };
    }
    return { solution: o2, message: `maximum iteration count exceeded`, iterations: Y2 };
  }, numeric._solveLP = function(t4, n2, r2, i2, a2) {
    var o2 = t4.length, s2 = r2.length, c2;
    numeric.sum;
    numeric.log;
    numeric.mul;
    var p2 = numeric.sub, m2 = numeric.dot;
    numeric.div;
    numeric.add;
    var v2 = numeric.rep([o2], 0).concat([1]), y2 = numeric.rep([s2, 1], -1), b2 = numeric.blockMatrix([[n2, y2]]), x2 = r2, c2 = numeric.rep([o2], 0).concat(Math.max(0, numeric.sup(numeric.neg(r2))) + 1), S2 = numeric.__solveLP(v2, b2, x2, i2, a2, c2, false), w2 = numeric.clone(S2.solution);
    if (w2.length = o2, numeric.inf(p2(r2, m2(n2, w2))) < 0) return { solution: NaN, message: `Infeasible`, iterations: S2.iterations };
    var E = numeric.__solveLP(t4, n2, r2, i2, a2 - S2.iterations, w2, true);
    return E.iterations += S2.iterations, E;
  }, numeric.solveLP = function(t4, n2, r2, i2, a2, o2, s2) {
    if (s2 === void 0 && (s2 = 1e3), o2 === void 0 && (o2 = numeric.epsilon), i2 === void 0) return numeric._solveLP(t4, n2, r2, o2, s2);
    var c2 = i2.length, l2 = i2[0].length, u2 = n2.length, d2 = numeric.echelonize(i2), p2 = numeric.rep([l2], 0), m2 = d2.P, h2 = [], g2;
    for (g2 = m2.length - 1; g2 !== -1; --g2) p2[m2[g2]] = 1;
    for (g2 = l2 - 1; g2 !== -1; --g2) p2[g2] === 0 && h2.push(g2);
    var v2 = numeric.getRange, y2 = numeric.linspace(0, c2 - 1), b2 = numeric.linspace(0, u2 - 1), x2 = v2(i2, y2, h2), S2 = v2(n2, b2, m2), w2 = v2(n2, b2, h2), E = numeric.dot, D = numeric.sub, O2 = E(S2, d2.I), j2 = D(w2, E(O2, x2)), M2 = D(r2, E(O2, a2)), N2 = Array(m2.length), F = Array(h2.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) N2[g2] = t4[m2[g2]];
    for (g2 = h2.length - 1; g2 !== -1; --g2) F[g2] = t4[h2[g2]];
    var I2 = D(F, E(N2, E(d2.I, x2))), L2 = numeric._solveLP(I2, j2, M2, o2, s2), R2 = L2.solution;
    if (R2 !== R2) return L2;
    var z2 = E(d2.I, D(a2, E(x2, R2))), V2 = Array(t4.length);
    for (g2 = m2.length - 1; g2 !== -1; --g2) V2[m2[g2]] = z2[g2];
    for (g2 = h2.length - 1; g2 !== -1; --g2) V2[h2[g2]] = R2[g2];
    return { solution: V2, message: L2.message, iterations: L2.iterations };
  }, numeric.MPStoLP = function(t4) {
    t4 instanceof String && t4.split(`
`);
    var n2 = 0, r2 = [`Initial state`, `NAME`, `ROWS`, `COLUMNS`, `RHS`, `BOUNDS`, `ENDATA`], i2 = t4.length, a2, o2, s2, c2 = 0, l2 = {}, u2 = [], d2 = 0, p2 = {}, m2 = 0, h2, g2 = [], v2 = [], y2 = [];
    function b2(i3) {
      throw Error(`MPStoLP: ` + i3 + `
Line ` + a2 + `: ` + t4[a2] + `
Current state: ` + r2[n2] + `
`);
    }
    for (a2 = 0; a2 < i2; ++a2) {
      s2 = t4[a2];
      var x2 = s2.match(/\S*/g), S2 = [];
      for (o2 = 0; o2 < x2.length; ++o2) x2[o2] !== `` && S2.push(x2[o2]);
      if (S2.length !== 0) {
        for (o2 = 0; o2 < r2.length && s2.substr(0, r2[o2].length) !== r2[o2]; ++o2) ;
        if (o2 < r2.length) {
          if (n2 = o2, o2 === 1 && (h2 = S2[1]), o2 === 6) return { name: h2, c: g2, A: numeric.transpose(v2), b: y2, rows: l2, vars: p2 };
          continue;
        }
        switch (n2) {
          case 0:
          case 1:
            b2(`Unexpected line`);
          case 2:
            switch (S2[0]) {
              case `N`:
                c2 === 0 ? c2 = S2[1] : b2(`Two or more N rows`);
                break;
              case `L`:
                l2[S2[1]] = d2, u2[d2] = 1, y2[d2] = 0, ++d2;
                break;
              case `G`:
                l2[S2[1]] = d2, u2[d2] = -1, y2[d2] = 0, ++d2;
                break;
              case `E`:
                l2[S2[1]] = d2, u2[d2] = 0, y2[d2] = 0, ++d2;
                break;
              default:
                b2(`Parse error ` + numeric.prettyPrint(S2));
            }
            break;
          case 3:
            p2.hasOwnProperty(S2[0]) || (p2[S2[0]] = m2, g2[m2] = 0, v2[m2] = numeric.rep([d2], 0), ++m2);
            var w2 = p2[S2[0]];
            for (o2 = 1; o2 < S2.length; o2 += 2) {
              if (S2[o2] === c2) {
                g2[w2] = parseFloat(S2[o2 + 1]);
                continue;
              }
              var E = l2[S2[o2]];
              v2[w2][E] = (u2[E] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            }
            break;
          case 4:
            for (o2 = 1; o2 < S2.length; o2 += 2) y2[l2[S2[o2]]] = (u2[l2[S2[o2]]] < 0 ? -1 : 1) * parseFloat(S2[o2 + 1]);
            break;
          case 5:
            break;
          case 6:
            b2(`Internal error`);
        }
      }
    }
    b2(`Reached end of file without ENDATA`);
  }, numeric.seedrandom = { pow: Math.pow, random: Math.random }, (function(t4, n2, r2, i2, a2, o2, s2) {
    n2.seedrandom = function(d3, p2) {
      var m2 = [], h2;
      return d3 = u2(l2(p2 ? [d3, t4] : arguments.length ? d3 : [(/* @__PURE__ */ new Date()).getTime(), t4, window], 3), m2), h2 = new c2(m2), u2(h2.S, t4), n2.random = function() {
        for (var t5 = h2.g(i2), n3 = s2, c3 = 0; t5 < a2; ) t5 = (t5 + c3) * r2, n3 *= r2, c3 = h2.g(1);
        for (; t5 >= o2; ) t5 /= 2, n3 /= 2, c3 >>>= 1;
        return (t5 + c3) / n3;
      }, d3;
    };
    function c2(t5) {
      var n3, i3, a3 = this, o3 = t5.length, s3 = 0, c3 = a3.i = a3.j = a3.m = 0;
      for (a3.S = [], a3.c = [], o3 || (t5 = [o3++]); s3 < r2; ) a3.S[s3] = s3++;
      for (s3 = 0; s3 < r2; s3++) n3 = a3.S[s3], c3 = d2(c3 + n3 + t5[s3 % o3]), i3 = a3.S[c3], a3.S[s3] = i3, a3.S[c3] = n3;
      a3.g = function(t6) {
        var n4 = a3.S, i4 = d2(a3.i + 1), o4 = n4[i4], s4 = d2(a3.j + o4), c4 = n4[s4];
        n4[i4] = c4, n4[s4] = o4;
        for (var l3 = n4[d2(o4 + c4)]; --t6; ) i4 = d2(i4 + 1), o4 = n4[i4], s4 = d2(s4 + o4), c4 = n4[s4], n4[i4] = c4, n4[s4] = o4, l3 = l3 * r2 + n4[d2(o4 + c4)];
        return a3.i = i4, a3.j = s4, l3;
      }, a3.g(r2);
    }
    function l2(t5, n3, r3, i3, a3) {
      if (r3 = [], a3 = typeof t5, n3 && a3 == `object`) {
        for (i3 in t5) if (i3.indexOf(`S`) < 5) try {
          r3.push(l2(t5[i3], n3 - 1));
        } catch {
        }
      }
      return r3.length ? r3 : t5 + (a3 == `string` ? `` : `\0`);
    }
    function u2(t5, n3, r3, i3) {
      for (t5 += ``, r3 = 0, i3 = 0; i3 < t5.length; i3++) n3[d2(i3)] = d2((r3 ^= n3[d2(i3)] * 19) + t5.charCodeAt(i3));
      for (i3 in t5 = ``, n3) t5 += String.fromCharCode(n3[i3]);
      return t5;
    }
    function d2(t5) {
      return t5 & r2 - 1;
    }
    s2 = n2.pow(r2, i2), a2 = n2.pow(2, a2), o2 = a2 * 2, u2(n2.random(), t4);
  })([], numeric.seedrandom, 256, 6, 52), (function(t4) {
    function n2(t5) {
      if (typeof t5 != `object`) return t5;
      var r3 = [], i3, a3 = t5.length;
      for (i3 = 0; i3 < a3; i3++) r3[i3 + 1] = n2(t5[i3]);
      return r3;
    }
    function r2(t5) {
      if (typeof t5 != `object`) return t5;
      var n3 = [], i3, a3 = t5.length;
      for (i3 = 1; i3 < a3; i3++) n3[i3 - 1] = r2(t5[i3]);
      return n3;
    }
    function i2(t5, n3, r3) {
      var i3, a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (t5[o3][o3] = 1 / t5[o3][o3], c3 = -t5[o3][o3], i3 = 1; i3 < o3; i3 += 1) t5[i3][o3] = c3 * t5[i3][o3];
        if (s3 = o3 + 1, r3 < s3) break;
        for (a3 = s3; a3 <= r3; a3 += 1) for (c3 = t5[o3][a3], t5[o3][a3] = 0, i3 = 1; i3 <= o3; i3 += 1) t5[i3][a3] = t5[i3][a3] + c3 * t5[i3][o3];
      }
    }
    function a2(t5, n3, r3, i3) {
      var a3, o3, s3, c3;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        for (c3 = 0, a3 = 1; a3 < o3; a3 += 1) c3 += t5[a3][o3] * i3[a3];
        i3[o3] = (i3[o3] - c3) / t5[o3][o3];
      }
      for (s3 = 1; s3 <= r3; s3 += 1) for (o3 = r3 + 1 - s3, i3[o3] = i3[o3] / t5[o3][o3], c3 = -i3[o3], a3 = 1; a3 < o3; a3 += 1) i3[a3] = i3[a3] + c3 * t5[a3][o3];
    }
    function o2(t5, n3, r3, i3) {
      var a3, o3, s3, c3, l2, u2;
      for (o3 = 1; o3 <= r3; o3 += 1) {
        if (i3[1] = o3, u2 = 0, s3 = o3 - 1, s3 < 1) {
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        } else {
          for (c3 = 1; c3 <= s3; c3 += 1) {
            for (l2 = t5[c3][o3], a3 = 1; a3 < c3; a3 += 1) l2 -= t5[a3][o3] * t5[a3][c3];
            l2 /= t5[c3][c3], t5[c3][o3] = l2, u2 += l2 * l2;
          }
          if (u2 = t5[o3][o3] - u2, u2 <= 0) break;
          t5[o3][o3] = Math.sqrt(u2);
        }
        i3[1] = 0;
      }
    }
    function s2(t5, n3, r3, s3, c3, l2, u2, d2, p2, m2, h2, g2, v2, y2, b2, x2) {
      var S2, w2, E, D, O2, j2, M2, N2, F, I2, L2, R2, z2 = Math.min(s3, m2), V2, H2, U2, W2, G2, K2, q2, J, ee2, Y2, te2, ne2, X2, ie2;
      E = 2 * s3 + z2 * (z2 + 5) / 2 + 2 * m2 + 1, te2 = 1e-60;
      do
        te2 += te2, ne2 = 1 + 0.1 * te2, X2 = 1 + 0.2 * te2;
      while (ne2 <= 1 || X2 <= 1);
      for (S2 = 1; S2 <= s3; S2 += 1) b2[S2] = n3[S2];
      for (S2 = s3 + 1; S2 <= E; S2 += 1) b2[S2] = 0;
      for (S2 = 1; S2 <= m2; S2 += 1) g2[S2] = 0;
      if (O2 = [], x2[1] === 0) {
        if (o2(t5, r3, s3, O2), O2[1] !== 0) {
          x2[1] = 2;
          return;
        }
        a2(t5, r3, s3, n3), i2(t5, r3, s3);
      } else {
        for (w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = 0, S2 = 1; S2 <= w2; S2 += 1) c3[w2] = c3[w2] + t5[S2][w2] * n3[S2];
        for (w2 = 1; w2 <= s3; w2 += 1) for (n3[w2] = 0, S2 = w2; S2 <= s3; S2 += 1) n3[w2] = n3[w2] + t5[w2][S2] * c3[S2];
      }
      for (l2[1] = 0, w2 = 1; w2 <= s3; w2 += 1) for (c3[w2] = n3[w2], l2[1] += b2[w2] * c3[w2], b2[w2] = 0, S2 = w2 + 1; S2 <= s3; S2 += 1) t5[S2][w2] = 0;
      for (l2[1] = -l2[1] / 2, x2[1] = 0, M2 = s3, N2 = M2 + s3, L2 = N2 + z2, F = L2 + z2 + 1, I2 = F + z2 * (z2 + 1) / 2, V2 = I2 + m2, S2 = 1; S2 <= m2; S2 += 1) {
        for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * u2[w2][S2];
        b2[V2 + S2] = Math.sqrt(U2);
      }
      v2 = 0, y2[1] = 0, y2[2] = 0;
      function ae2() {
        for (y2[1] += 1, E = I2, S2 = 1; S2 <= m2; S2 += 1) {
          for (E += 1, U2 = -d2[S2], w2 = 1; w2 <= s3; w2 += 1) U2 += u2[w2][S2] * c3[w2];
          if (Math.abs(U2) < te2 && (U2 = 0), S2 > h2) b2[E] = U2;
          else if (b2[E] = -Math.abs(U2), U2 > 0) {
            for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][S2] = -u2[w2][S2];
            d2[S2] = -d2[S2];
          }
        }
        for (S2 = 1; S2 <= v2; S2 += 1) b2[I2 + g2[S2]] = 0;
        for (R2 = 0, H2 = 0, S2 = 1; S2 <= m2; S2 += 1) b2[I2 + S2] < H2 * b2[V2 + S2] && (R2 = S2, H2 = b2[I2 + S2] / b2[V2 + S2]);
        return R2 === 0 ? 999 : 0;
      }
      function Z2() {
        for (S2 = 1; S2 <= s3; S2 += 1) {
          for (U2 = 0, w2 = 1; w2 <= s3; w2 += 1) U2 += t5[w2][S2] * u2[w2][R2];
          b2[S2] = U2;
        }
        for (D = M2, S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = 0;
        for (w2 = v2 + 1; w2 <= s3; w2 += 1) for (S2 = 1; S2 <= s3; S2 += 1) b2[D + S2] = b2[D + S2] + t5[S2][w2] * b2[w2];
        for (ee2 = true, S2 = v2; S2 >= 1; --S2) {
          for (U2 = b2[S2], E = F + S2 * (S2 + 3) / 2, D = E - S2, w2 = S2 + 1; w2 <= v2; w2 += 1) U2 -= b2[E] * b2[N2 + w2], E += w2;
          if (U2 /= b2[D], b2[N2 + S2] = U2, g2[S2] < h2 || U2 < 0) break;
          ee2 = false, j2 = S2;
        }
        if (!ee2) for (W2 = b2[L2 + j2] / b2[N2 + j2], S2 = 1; S2 <= v2 && !(g2[S2] < h2 || b2[N2 + S2] < 0); S2 += 1) H2 = b2[L2 + S2] / b2[N2 + S2], H2 < W2 && (W2 = H2, j2 = S2);
        for (U2 = 0, S2 = M2 + 1; S2 <= M2 + s3; S2 += 1) U2 += b2[S2] * b2[S2];
        if (Math.abs(U2) <= te2) {
          if (ee2) return x2[1] = 1, 999;
          for (S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - W2 * b2[N2 + S2];
          return b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + W2, 700;
        } else {
          for (U2 = 0, S2 = 1; S2 <= s3; S2 += 1) U2 += b2[M2 + S2] * u2[S2][R2];
          for (G2 = -b2[I2 + R2] / U2, Y2 = true, ee2 || W2 < G2 && (G2 = W2, Y2 = false), S2 = 1; S2 <= s3; S2 += 1) c3[S2] = c3[S2] + G2 * b2[M2 + S2], Math.abs(c3[S2]) < te2 && (c3[S2] = 0);
          for (l2[1] += G2 * U2 * (G2 / 2 + b2[L2 + v2 + 1]), S2 = 1; S2 <= v2; S2 += 1) b2[L2 + S2] = b2[L2 + S2] - G2 * b2[N2 + S2];
          if (b2[L2 + v2 + 1] = b2[L2 + v2 + 1] + G2, Y2) {
            for (v2 += 1, g2[v2] = R2, E = F + (v2 - 1) * v2 / 2 + 1, S2 = 1; S2 <= v2 - 1; S2 += 1) b2[E] = b2[S2], E += 1;
            if (v2 === s3) b2[E] = b2[s3];
            else {
              for (S2 = s3; S2 >= v2 + 1 && !(b2[S2] === 0 || (K2 = Math.max(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), q2 = Math.min(Math.abs(b2[S2 - 1]), Math.abs(b2[S2])), H2 = b2[S2 - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[S2 - 1] / H2, q2 = b2[S2] / H2, K2 === 1)); --S2) if (K2 === 0) for (b2[S2 - 1] = q2 * H2, w2 = 1; w2 <= s3; w2 += 1) H2 = t5[w2][S2 - 1], t5[w2][S2 - 1] = t5[w2][S2], t5[w2][S2] = H2;
              else for (b2[S2 - 1] = H2, J = q2 / (1 + K2), w2 = 1; w2 <= s3; w2 += 1) H2 = K2 * t5[w2][S2 - 1] + q2 * t5[w2][S2], t5[w2][S2] = J * (t5[w2][S2 - 1] + H2) - t5[w2][S2], t5[w2][S2 - 1] = H2;
              b2[E] = b2[v2];
            }
          } else {
            for (U2 = -d2[R2], w2 = 1; w2 <= s3; w2 += 1) U2 += c3[w2] * u2[w2][R2];
            if (R2 > h2) b2[I2 + R2] = U2;
            else if (b2[I2 + R2] = -Math.abs(U2), U2 > 0) {
              for (w2 = 1; w2 <= s3; w2 += 1) u2[w2][R2] = -u2[w2][R2];
              d2[R2] = -d2[R2];
            }
            return 700;
          }
        }
        return 0;
      }
      function oe2() {
        if (E = F + j2 * (j2 + 1) / 2 + 1, D = E + j2, b2[D] === 0 || (K2 = Math.max(Math.abs(b2[D - 1]), Math.abs(b2[D])), q2 = Math.min(Math.abs(b2[D - 1]), Math.abs(b2[D])), H2 = b2[D - 1] >= 0 ? Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))) : -Math.abs(K2 * Math.sqrt(1 + q2 * q2 / (K2 * K2))), K2 = b2[D - 1] / H2, q2 = b2[D] / H2, K2 === 1)) return 798;
        if (K2 === 0) {
          for (S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = b2[D - 1], b2[D - 1] = b2[D], b2[D] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = t5[S2][j2], t5[S2][j2] = t5[S2][j2 + 1], t5[S2][j2 + 1] = H2;
        } else {
          for (J = q2 / (1 + K2), S2 = j2 + 1; S2 <= v2; S2 += 1) H2 = K2 * b2[D - 1] + q2 * b2[D], b2[D] = J * (b2[D - 1] + H2) - b2[D], b2[D - 1] = H2, D += S2;
          for (S2 = 1; S2 <= s3; S2 += 1) H2 = K2 * t5[S2][j2] + q2 * t5[S2][j2 + 1], t5[S2][j2 + 1] = J * (t5[S2][j2] + H2) - t5[S2][j2 + 1], t5[S2][j2] = H2;
        }
        return 0;
      }
      function $2() {
        for (D = E - j2, S2 = 1; S2 <= j2; S2 += 1) b2[D] = b2[E], E += 1, D += 1;
        return b2[L2 + j2] = b2[L2 + j2 + 1], g2[j2] = g2[j2 + 1], j2 += 1, j2 < v2 ? 797 : 0;
      }
      function se2() {
        return b2[L2 + v2] = b2[L2 + v2 + 1], b2[L2 + v2 + 1] = 0, g2[v2] = 0, --v2, y2[2] += 1, 0;
      }
      for (ie2 = 0; ; ) {
        if (ie2 = ae2(), ie2 === 999) return;
        for (; ie2 = Z2(), ie2 !== 0; ) {
          if (ie2 === 999) return;
          if (ie2 === 700) if (j2 === v2) se2();
          else {
            for (; oe2(), ie2 = $2(), ie2 === 797; ) ;
            se2();
          }
        }
      }
    }
    function c2(t5, i3, a3, o3, c3, l2) {
      t5 = n2(t5), i3 = n2(i3), a3 = n2(a3);
      var u2, d2, p2, m2, h2, g2 = [], v2 = [], y2 = [], b2 = [], x2 = [], S2;
      if (c3 ||= 0, l2 = l2 ? n2(l2) : [void 0, 0], o3 = o3 ? n2(o3) : [], d2 = t5.length - 1, p2 = a3[1].length - 1, !o3) for (u2 = 1; u2 <= p2; u2 += 1) o3[u2] = 0;
      for (u2 = 1; u2 <= p2; u2 += 1) v2[u2] = 0;
      for (m2 = 0, h2 = Math.min(d2, p2), u2 = 1; u2 <= d2; u2 += 1) y2[u2] = 0;
      for (g2[1] = 0, u2 = 1; u2 <= 2 * d2 + h2 * (h2 + 5) / 2 + 2 * p2 + 1; u2 += 1) b2[u2] = 0;
      for (u2 = 1; u2 <= 2; u2 += 1) x2[u2] = 0;
      return s2(t5, i3, d2, d2, y2, g2, a3, o3, d2, p2, c3, v2, m2, x2, b2, l2), S2 = ``, l2[1] === 1 && (S2 = `constraints are inconsistent, no solution!`), l2[1] === 2 && (S2 = `matrix D in quadratic function is not positive definite!`), { solution: r2(y2), value: r2(g2), unconstrained_solution: r2(i3), iterations: r2(x2), iact: r2(v2), message: S2 };
    }
    t4.solveQP = c2;
  })(numeric), numeric.svd = function(t4) {
    var n2, r2 = numeric.epsilon, i2 = 1e-64 / r2, a2 = 50, o2 = 0, s2 = 0, c2 = 0, l2 = 0, u2 = 0, d2 = numeric.clone(t4), p2 = d2.length, m2 = d2[0].length;
    if (p2 < m2) throw `Need more rows than columns`;
    var h2 = Array(m2), g2 = Array(m2);
    for (s2 = 0; s2 < m2; s2++) h2[s2] = g2[s2] = 0;
    var v2 = numeric.rep([m2, m2], 0);
    function y2(t5, n3) {
      return t5 = Math.abs(t5), n3 = Math.abs(n3), t5 > n3 ? t5 * Math.sqrt(1 + n3 * n3 / t5 / t5) : n3 == 0 ? t5 : n3 * Math.sqrt(1 + t5 * t5 / n3 / n3);
    }
    var b2 = 0, x2 = 0, S2 = 0, w2 = 0, E = 0, D = 0, O2 = 0;
    for (s2 = 0; s2 < m2; s2++) {
      for (h2[s2] = x2, O2 = 0, u2 = s2 + 1, c2 = s2; c2 < p2; c2++) O2 += d2[c2][s2] * d2[c2][s2];
      if (O2 <= i2) x2 = 0;
      else for (b2 = d2[s2][s2], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2] = b2 - x2, c2 = u2; c2 < m2; c2++) {
        for (O2 = 0, l2 = s2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
        for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
      }
      for (g2[s2] = x2, O2 = 0, c2 = u2; c2 < m2; c2++) O2 += d2[s2][c2] * d2[s2][c2];
      if (O2 <= i2) x2 = 0;
      else {
        for (b2 = d2[s2][s2 + 1], x2 = Math.sqrt(O2), b2 >= 0 && (x2 = -x2), S2 = b2 * x2 - O2, d2[s2][s2 + 1] = b2 - x2, c2 = u2; c2 < m2; c2++) h2[c2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < p2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[c2][l2] * d2[s2][l2];
          for (l2 = u2; l2 < m2; l2++) d2[c2][l2] += O2 * h2[l2];
        }
      }
      E = Math.abs(g2[s2]) + Math.abs(h2[s2]), E > w2 && (w2 = E);
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      if (x2 != 0) {
        for (S2 = x2 * d2[s2][s2 + 1], c2 = u2; c2 < m2; c2++) v2[c2][s2] = d2[s2][c2] / S2;
        for (c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < m2; l2++) O2 += d2[s2][l2] * v2[l2][c2];
          for (l2 = u2; l2 < m2; l2++) v2[l2][c2] += O2 * v2[l2][s2];
        }
      }
      for (c2 = u2; c2 < m2; c2++) v2[s2][c2] = 0, v2[c2][s2] = 0;
      v2[s2][s2] = 1, x2 = h2[s2], u2 = s2;
    }
    for (s2 = m2 - 1; s2 != -1; s2 += -1) {
      for (u2 = s2 + 1, x2 = g2[s2], c2 = u2; c2 < m2; c2++) d2[s2][c2] = 0;
      if (x2 != 0) {
        for (S2 = d2[s2][s2] * x2, c2 = u2; c2 < m2; c2++) {
          for (O2 = 0, l2 = u2; l2 < p2; l2++) O2 += d2[l2][s2] * d2[l2][c2];
          for (b2 = O2 / S2, l2 = s2; l2 < p2; l2++) d2[l2][c2] += b2 * d2[l2][s2];
        }
        for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = d2[c2][s2] / x2;
      } else for (c2 = s2; c2 < p2; c2++) d2[c2][s2] = 0;
      d2[s2][s2] += 1;
    }
    for (r2 *= w2, l2 = m2 - 1; l2 != -1; l2 += -1) for (var j2 = 0; j2 < a2; j2++) {
      var M2 = false;
      for (u2 = l2; u2 != -1; u2 += -1) {
        if (Math.abs(h2[u2]) <= r2) {
          M2 = true;
          break;
        }
        if (Math.abs(g2[u2 - 1]) <= r2) break;
      }
      if (!M2) {
        o2 = 0, O2 = 1;
        var N2 = u2 - 1;
        for (s2 = u2; s2 < l2 + 1 && (b2 = O2 * h2[s2], h2[s2] = o2 * h2[s2], !(Math.abs(b2) <= r2)); s2++) for (x2 = g2[s2], S2 = y2(b2, x2), g2[s2] = S2, o2 = x2 / S2, O2 = -b2 / S2, c2 = 0; c2 < p2; c2++) E = d2[c2][N2], D = d2[c2][s2], d2[c2][N2] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      if (D = g2[l2], u2 == l2) {
        if (D < 0) for (g2[l2] = -D, c2 = 0; c2 < m2; c2++) v2[c2][l2] = -v2[c2][l2];
        break;
      }
      if (j2 >= a2 - 1) throw `Error: no convergence.`;
      for (w2 = g2[u2], E = g2[l2 - 1], x2 = h2[l2 - 1], S2 = h2[l2], b2 = ((E - D) * (E + D) + (x2 - S2) * (x2 + S2)) / (2 * S2 * E), x2 = y2(b2, 1), b2 = b2 < 0 ? ((w2 - D) * (w2 + D) + S2 * (E / (b2 - x2) - S2)) / w2 : ((w2 - D) * (w2 + D) + S2 * (E / (b2 + x2) - S2)) / w2, o2 = 1, O2 = 1, s2 = u2 + 1; s2 < l2 + 1; s2++) {
        for (x2 = h2[s2], E = g2[s2], S2 = O2 * x2, x2 = o2 * x2, D = y2(b2, S2), h2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = w2 * o2 + x2 * O2, x2 = -w2 * O2 + x2 * o2, S2 = E * O2, E *= o2, c2 = 0; c2 < m2; c2++) w2 = v2[c2][s2 - 1], D = v2[c2][s2], v2[c2][s2 - 1] = w2 * o2 + D * O2, v2[c2][s2] = -w2 * O2 + D * o2;
        for (D = y2(b2, S2), g2[s2 - 1] = D, o2 = b2 / D, O2 = S2 / D, b2 = o2 * x2 + O2 * E, w2 = -O2 * x2 + o2 * E, c2 = 0; c2 < p2; c2++) E = d2[c2][s2 - 1], D = d2[c2][s2], d2[c2][s2 - 1] = E * o2 + D * O2, d2[c2][s2] = -E * O2 + D * o2;
      }
      h2[u2] = 0, h2[l2] = b2, g2[l2] = w2;
    }
    for (s2 = 0; s2 < g2.length; s2++) g2[s2] < r2 && (g2[s2] = 0);
    for (s2 = 0; s2 < m2; s2++) for (c2 = s2 - 1; c2 >= 0; c2--) if (g2[c2] < g2[s2]) {
      for (o2 = g2[c2], g2[c2] = g2[s2], g2[s2] = o2, l2 = 0; l2 < d2.length; l2++) n2 = d2[l2][s2], d2[l2][s2] = d2[l2][c2], d2[l2][c2] = n2;
      for (l2 = 0; l2 < v2.length; l2++) n2 = v2[l2][s2], v2[l2][s2] = v2[l2][c2], v2[l2][c2] = n2;
      s2 = c2;
    }
    return { U: d2, S: g2, V: v2 };
  };
})), import_numeric_1_2_6 = __toESM(require_numeric_1_2_6());
function createInstance({ define_e: t4 = true, define_pi: n2 = true, define_i: r2 = true, pow_strict: i2 = true } = {}) {
  let a2 = { ...all };
  delete a2.createTau, delete a2.createPhi, t4 || delete a2.createE, n2 || delete a2.createPi, r2 || delete a2.createI;
  let o2 = create$1(a2);
  o2.import(import_numeric_1_2_6.default, { wrap: true, silent: true });
  var s2 = o2.pow;
  function c2(t5, n3) {
    return n3 === 0 && typeof t5 == `number` && (t5 === 0 || !Number.isFinite(t5)) ? NaN : s2(t5, n3);
  }
  return i2 ? o2.import({ pow: c2 }, { override: true }) : o2.import({ pow: s2 }, { override: true }), o2.define_e = t4, o2.define_pi = n2, o2.define_i = r2, o2.pow_strict = i2, o2;
}
var mathjs_default = createInstance(), function_normalizations = { ln: `log`, arccos: `acos`, arccosh: `acosh`, arcsin: `asin`, arcsinh: `asinh`, arctan: `atan`, arctanh: `atanh`, arcsec: `asec`, arcsech: `asech`, arccsc: `acsc`, arccsch: `acsch`, arccot: `acot`, arccoth: `acoth`, cosec: `csc` }, create_trig_inverses_for = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`], move_exponents_outside_for = [`cos`, `cosh`, `sin`, `sinh`, `tan`, `tanh`, `sec`, `sech`, `csc`, `csch`, `cot`, `coth`, `log`, `ln`];
function normalize_function_names(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    if (i2[0] === `sqrt`) return [`^`, normalize_function_names(i2[1]), 0.5];
    if (i2[0] === `cbrt`) return [`^`, normalize_function_names(i2[1]), [`/`, 1, 3]];
    if (i2[0] === `nthroot`) return i2.length !== 2 || i2[1][0] !== `tuple` || i2[1].length !== 3 ? [`^`, normalize_function_names(i2[1]), 0.5] : [`^`, normalize_function_names(i2[1][1]), [`/`, 1, normalize_function_names(i2[1][2])]];
    var a2 = normalize_function_names_sub(i2[0]);
    a2 = [`apply`, a2];
    var o2 = i2.slice(1).map(function(t5) {
      return normalize_function_names(t5);
    });
    return o2 = o2.length > 1 ? [`tuple`].concat(o2) : o2[0], a2.push(o2), a2;
  }
  return r2 === `^` && i2[0] === `e` && mathjs_default.define_e ? [`apply`, `exp`, normalize_function_names(i2[1])] : r2 === `binom` ? [`apply`, `nCr`, [`tuple`, normalize_function_names(i2[0]), normalize_function_names(i2[1])]] : [r2].concat(i2.map(function(t5) {
    return normalize_function_names(t5);
  }));
}
function normalize_function_names_sub(t4) {
  if (typeof t4 == `string`) return t4 in function_normalizations ? function_normalizations[t4] : t4;
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `^` && r2.length === 2 && r2[1] === -1) {
    let t5 = normalize_function_names_sub(r2[0]);
    if (create_trig_inverses_for.includes(t5)) return `a` + t5;
  }
  return [n2].concat(r2.map(function(t5) {
    return normalize_function_names_sub(t5);
  }));
}
function normalize_applied_functions(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply`) {
    let t5 = i2[0];
    if (t5[0] === `^`) {
      let n4 = t5[1], r4 = t5[2];
      return r4 !== -1 && move_exponents_outside_for.includes(n4) ? [`^`, [`apply`, n4, normalize_applied_functions(i2[1])], r4] : [`apply`, t5, normalize_applied_functions(i2[1])];
    }
    let n3 = 0;
    for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
    let r3 = [`apply`, t5, normalize_applied_functions(i2[1])];
    for (let t6 = 0; t6 < n3; t6++) r3 = [`prime`, r3];
    return r3;
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return normalize_applied_functions(t5);
  }));
}
function log_subscript_to_two_arg_log(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `apply` && i2.length === 2) {
    let t5 = i2[0];
    if (Array.isArray(t5) && t5.length === 3 && t5[0] === `_` && t5[1] === `log`) return [`apply`, `log`, [`tuple`, i2[1], t5[2]]];
  }
  return [r2, ...i2.map(log_subscript_to_two_arg_log)];
}
function substitute_abs(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `apply` && i2[0] === `abs` ? [`^`, [`^`, substitute_abs(i2[1]), 2], 0.5] : [r2].concat(i2.map(function(t5) {
    return substitute_abs(t5);
  }));
}
function constants_to_floats(t4) {
  var n2 = get_tree(t4);
  if (!(mathjs_default.define_e || mathjs_default.define_pi)) return n2;
  if (typeof n2 == `string`) {
    if (n2 === `e`) {
      if (mathjs_default.define_e) return mathjs_default.e;
    } else if (n2 === `pi` && mathjs_default.define_pi) return mathjs_default.pi;
    return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `^` && i2[0] === `e` ? [`^`, `e`, constants_to_floats(i2[1])] : [r2, ...i2.map(constants_to_floats)];
}
function normalize_angle_linesegment_arg_order(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return r2 === `angle` && i2.length === 3 && compare_function(i2[0], i2[2]) === 1 || r2 === `linesegment` && i2.length === 2 && compare_function(i2[0], i2[1]) === 1 ? (i2.reverse(), [r2, ...i2]) : [r2, ...i2.map(normalize_angle_linesegment_arg_order)];
}
function normalize_negative_numbers(t4) {
  var n2 = get_tree(t4);
  function r2(t5) {
    if (typeof t5 == `number` && t5 >= 0) return [-t5, true];
    if (!Array.isArray(t5)) return [t5, false];
    if (t5[0] === `*` && typeof t5[1] == `number` && t5[1] >= 0) return [[`*`, -t5[1], ...t5.slice(2).map(normalize_negative_numbers)], true];
    if (t5[0] === `/` && t5.length === 3) {
      let [n3, i3] = r2(t5[1]);
      if (i3) return [[`/`, n3, normalize_negative_numbers(t5[2])], true];
    }
    return [t5, false];
  }
  if (!Array.isArray(n2)) return n2;
  let i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `-` && a2.length === 1) {
    if (typeof a2[0] == `number` && a2[0] >= 0) return -a2[0];
    if (Array.isArray(a2[0]) && a2[0][0] === `*`) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`*`, t5, ...a2[0].slice(2).map(normalize_negative_numbers)];
    }
    if (Array.isArray(a2[0]) && a2[0][0] === `/` && a2[0].length === 3) {
      let [t5, n3] = r2(a2[0][1]);
      if (n3) return [`/`, t5, normalize_negative_numbers(a2[0][2])];
    }
  }
  return [i2, ...a2.map(normalize_negative_numbers)];
}
function tuples_to_vectors(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple`) return [`vector`].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors(t5);
  }));
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = tuples_to_vectors(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return tuples_to_vectors(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return tuples_to_vectors(t6);
    })), n3];
  } else if (r2 === `matrix`) {
    let t5 = i2[0], n3 = i2[1];
    return t5 = [`tuple`].concat(t5.slice(1).map(tuples_to_vectors)), n3 = [`tuple`].concat(n3.slice(1).map((t6) => [`tuple`].concat(t6.slice(1).map(tuples_to_vectors)))), [`matrix`, t5, n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return tuples_to_vectors(t5);
  }));
}
function to_intervals(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `tuple` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, false, false]], t5;
  }
  if (r2 === `array` && i2.length === 2) {
    let t5 = [`tuple`].concat(i2.map(function(t6, n3) {
      return to_intervals(t6);
    }));
    return t5 = [`interval`, t5, [`tuple`, true, true]], t5;
  }
  if (r2 === `apply`) {
    if (i2[1][0] === `tuple`) {
      let t5 = to_intervals(i2[0]), n3 = i2[1].slice(1);
      return [`apply`, t5, [`tuple`].concat(n3.map(function(t6, n4) {
        return to_intervals(t6);
      }))];
    }
  } else if (r2 === `gts` || r2 === `lts` || r2 === `interval`) {
    let t5 = i2[0], n3 = i2[1];
    if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
    return [r2, [`tuple`].concat(t5.slice(1).map(function(t6, n4) {
      return to_intervals(t6);
    })), n3];
  }
  return [r2].concat(i2.map(function(t5, n3) {
    return to_intervals(t5);
  }));
}
function altvectors_to_vectors(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  return r2 === `altvector` ? [`vector`].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors(t5);
  })) : [r2].concat(i2.map(function(t5, n3) {
    return altvectors_to_vectors(t5);
  }));
}
function padNumberStringToDigits(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) {
    if (t4.includes(`.`)) {
      if (t4[0] === `0` ? r2 += t4.match(/^0\.0*/)[0].length : r2++, t4.length < r2) {
        let n3 = r2 - t4.length;
        t4 += `0`.repeat(n3);
      }
    } else if (t4.length < r2) {
      let n3 = r2 - t4.length;
      t4 += `.` + `0`.repeat(n3);
    }
  }
  return t4;
}
function padNumberStringToDecimals(t4, n2) {
  let r2 = Math.floor(n2);
  if (r2 > 0) if (t4.includes(`.`)) {
    let n3 = t4.match(/\.\d*$/)[0].length - 1;
    if (n3 < r2) {
      let i2 = r2 - n3;
      t4 += `0`.repeat(i2);
    }
  } else t4 += `.` + `0`.repeat(r2);
  return t4;
}
function padNumberStringToDigitsAndDecimals(t4, n2, r2) {
  let i2 = Math.floor(n2);
  if (!(i2 > 0)) return padNumberStringToDecimals(t4, r2);
  let a2 = Math.floor(r2);
  if (!(a2 > 0)) return padNumberStringToDigits(t4, n2);
  if (t4.includes(`.`)) {
    t4[0] === `0` ? i2 += t4.match(/^0\.0*/)[0].length : i2++;
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length);
    let r3 = t4.match(/\.\d*$/)[0].length - 1;
    r3 < a2 && (n3 = Math.max(n3, a2 - r3)), n3 > 0 && (t4 += `0`.repeat(n3));
  } else {
    let n3 = 0;
    t4.length < i2 && (n3 = i2 - t4.length), n3 = Math.max(n3, a2), t4 += `.` + `0`.repeat(n3);
  }
  return t4;
}
function remove_leading_negative_factor(t4) {
  if (typeof t4 == `number` && t4 < 0) return [-t4, true];
  if (!Array.isArray(t4)) return [t4, false];
  if (t4[0] === `-` && t4.length === 2) return [t4[1], true];
  if (t4[0] === `*` && t4.length >= 2) {
    let n2 = t4[1];
    if (typeof n2 == `number` && n2 < 0) return [[`*`, -n2, ...t4.slice(2)], true];
    if (Array.isArray(n2) && n2[0] === `-` && n2.length === 2) return [[`*`, n2[1], ...t4.slice(2)], true];
  }
  return [t4, false];
}
function normalize_display_negative_fractions_sub(t4, { inside_unary_minus: n2 = false } = {}) {
  if (!Array.isArray(t4)) return t4;
  let r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `-` && i2.length === 1) return [`-`, normalize_display_negative_fractions_sub(i2[0], { inside_unary_minus: true })];
  if (r2 === `+`) return [`+`, ...i2.map((t5) => normalize_display_negative_fractions_sub(t5, { inside_unary_minus: false }))];
  if (r2 === `*`) {
    if (i2.length === 0) return t4;
    let n3 = [normalize_display_negative_fractions_sub(i2[0], { inside_unary_minus: false })];
    for (let t5 = 1; t5 < i2.length; t5 += 1) n3.push(normalize_display_negative_fractions_sub(i2[t5], { inside_unary_minus: false }));
    return [`*`, ...n3];
  }
  if (r2 === `/` && i2.length === 2) {
    let t5 = i2[0], r3 = i2[1];
    if (!n2) {
      let [n3, i3] = remove_leading_negative_factor(t5);
      if (i3) return [`-`, [`/`, normalize_display_negative_fractions_sub(n3, { inside_unary_minus: false }), normalize_display_negative_fractions_sub(r3, { inside_unary_minus: false })]];
    }
    return [`/`, normalize_display_negative_fractions_sub(t5, { inside_unary_minus: false }), normalize_display_negative_fractions_sub(r3, { inside_unary_minus: false })];
  }
  return [r2, ...i2.map((t5) => normalize_display_negative_fractions_sub(t5, { inside_unary_minus: false }))];
}
function normalize_display_negative_fractions(t4) {
  return normalize_display_negative_fractions_sub(t4, { inside_unary_minus: false });
}
function expandScientificNotation(t4) {
  let n2 = t4.indexOf(`e`);
  if (n2 === -1) return t4;
  let r2 = t4.substring(0, n2), i2 = Number(t4.substring(n2 + 1)), a2 = ``;
  (r2[0] === `-` || r2[0] === `+`) && (a2 = r2[0] === `-` ? `-` : ``, r2 = r2.substring(1));
  let o2 = r2.indexOf(`.`);
  o2 === -1 && (o2 = r2.length);
  let s2 = r2.replace(`.`, ``), c2 = o2 + i2;
  return c2 <= 0 ? a2 + `0.` + `0`.repeat(-c2) + s2 : c2 >= s2.length ? a2 + s2 + `0`.repeat(c2 - s2.length) : a2 + s2.substring(0, c2) + `.` + s2.substring(c2);
}
var unicode_operators = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `± ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `⟨ ` + t4.join(`, `) + ` ⟩`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` ≤ `);
}, ge: function(t4) {
  return t4.join(` ≥ `);
}, ne: function(t4) {
  return t4.join(` ≠ `);
}, forall: function(t4) {
  return `∀ ` + t4[0];
}, exists: function(t4) {
  return `∃ ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` ∈ ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` ∉ ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` ∋ ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` ∌ ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` ⊂ ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` ⊆ ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` ⊄ ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` ⊈ ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` ⊃ ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` ⊇ ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` ⊅ ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` ⊉ ` + t4[1];
}, union: function(t4) {
  return t4.join(` ∪ `);
}, intersect: function(t4) {
  return t4.join(` ∩ `);
}, rightarrow: function(t4) {
  return t4.join(` → `);
}, leftarrow: function(t4) {
  return t4.join(` ← `);
}, leftrightarrow: function(t4) {
  return t4.join(` ↔ `);
}, implies: function(t4) {
  return t4.join(` ⟹ `);
}, impliedby: function(t4) {
  return t4.join(` ⟸ `);
}, iff: function(t4) {
  return t4.join(` ⟺ `);
}, perp: function(t4) {
  return t4.join(` ⟂ `);
}, parallel: function(t4) {
  return t4.join(` ∥ `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `∠` + t4.join(``) : `∠( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, nonunicode_operators = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `plusminus ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return t4[0] + `/` + t4[1];
}, _: function(t4) {
  return t4[0] + `_` + t4[1];
}, "^": function(t4) {
  return t4[0] + `^` + t4[1];
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, array: function(t4) {
  return `[ ` + t4.join(`, `) + ` ]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `{ ` + t4.join(`, `) + ` }`;
}, vector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, altvector: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, interval: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, matrix: function(t4) {
  return `( ` + t4.join(`, `) + ` )`;
}, and: function(t4) {
  return t4.join(` and `);
}, or: function(t4) {
  return t4.join(` or `);
}, not: function(t4) {
  return `not ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` <= `);
}, ge: function(t4) {
  return t4.join(` >= `);
}, ne: function(t4) {
  return t4.join(` ne `);
}, forall: function(t4) {
  return `forall ` + t4[0];
}, exists: function(t4) {
  return `exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` elementof ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` notelementof ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` containselement ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` notcontainselement ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` notsubset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` notsubseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` superset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` superseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` notsuperset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` notsuperseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` union `);
}, intersect: function(t4) {
  return t4.join(` intersect `);
}, rightarrow: function(t4) {
  return t4.join(` rightarrow `);
}, leftarrow: function(t4) {
  return t4.join(` leftarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` leftrightarrow `);
}, implies: function(t4) {
  return t4.join(` implies `);
}, impliedby: function(t4) {
  return t4.join(` impliedby `);
}, iff: function(t4) {
  return t4.join(` iff `);
}, perp: function(t4) {
  return t4.join(` perp `);
}, parallel: function(t4) {
  return t4.join(` parallel `);
}, derivative_leibniz: function(t4) {
  return `d` + t4[0] + `/d` + t4[1];
}, partial_derivative_leibniz: function(t4) {
  return `∂` + t4[0] + `/∂` + t4[1];
}, "|": function(t4) {
  return t4[0] + ` | ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `binom( ` + t4[0] + `, ` + t4[1] + ` )`;
}, vec: function(t4) {
  return `vec(` + t4[0] + `)`;
}, linesegment: function(t4) {
  return `linesegment( ` + t4.join(`, `) + ` )`;
}, angle: function(t4, n2) {
  return n2 ? `angle ` + t4.join(``) : `angle( ` + t4.join(`, `) + ` )`;
}, unit: function(t4) {
  return t4[0] + ` ` + t4[1];
} }, output_unicodeDefault = true, astToText$2 = class {
  constructor({ output_unicode: t4 = output_unicodeDefault, padToDigits: n2 = null, padToDecimals: r2 = null, avoidScientificNotation: i2 = false, showBlanks: a2 = true, explicitMultiplicationSymbols: o2 = false } = {}) {
    this.output_unicode = t4, this.operators = unicode_operators, t4 || (this.operators = nonunicode_operators), this.padToDigits = n2, this.padToDecimals = r2, this.avoidScientificNotation = i2, this.showBlanks = a2, this.explicitMultiplicationSymbols = o2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `...`;
    if (!(n2 in this.operators) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? this.operators[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\(.*\)$/) ? `(` + r3 + `)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return this.operators[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? this.output_unicode ? a2 += ` ≤ ` : a2 += ` <= ` : this.output_unicode ? a2 += ` ≥ ` : a2 += ` >= `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : this.operators[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `-` || n2 === `pm`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    if (n2 === `*`) {
      let t5 = r2.map((function(t6, n3) {
        let i2;
        return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedOrExplicitPlus(t6), !this.explicitMultiplicationSymbols && i2.match(/^[0-9]/) ? `* ` + i2 : t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2) : (i2 = this.factor(t6), t6[0] === `angle` && r2.length > 1 ? `( ` + i2 + ` )` : i2);
      }).bind(this));
      return this.explicitMultiplicationSymbols ? t5.join(`*`) : this.operators[n2](t5);
    }
    if (n2 === `/`) {
      let t5 = this.factor(r2[0]), i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `(` + t5 + `)`), this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2 + `)`), this.operators[n2]([t5, i2]);
    }
    return n2 === `unit` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  symbolConvert(t4) {
    let n2 = { alpha: `α`, beta: `β`, Gamma: `Γ`, gamma: `γ`, Delta: `Δ`, delta: `δ`, epsilon: `ε`, zeta: `ζ`, eta: `η`, Theta: `ϴ`, theta: `θ`, iota: `ι`, kappa: `κ`, Lambda: `Λ`, lambda: `λ`, mu: `μ`, nu: `ν`, Xi: `Ξ`, xi: `ξ`, Pi: `Π`, pi: `π`, rho: `ρ`, Sigma: `Σ`, sigma: `σ`, tau: `τ`, Upsilon: `Υ`, upsilon: `υ`, Phi: `Φ`, phi: `ϕ`, Psi: `Ψ`, psi: `ψ`, Omega: `Ω`, omega: `ω`, perp: `⟂`, int: `∫`, emptyset: `∅` };
    return this.output_unicode && t4 in n2 ? n2[t4] : !this.showBlanks && t4 === `＿` ? `` : t4;
  }
  simple_factor_or_function_or_parens(t4) {
    let n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` || n2.match(/^\(.*\)$/) || n2.match(/^⟨.*⟩$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.symbolConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return this.output_unicode ? `∞` : `infinity`;
      if (t4 === -1 / 0) return this.output_unicode ? `-∞` : `-infinity`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals(i2, this.padToDigits, t5);
          }
        }
        return a2[0] === `+` ? i2 + ` * 10^` + a2.substring(1) : i2 + ` * 10^(` + a2 + `)`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) {
        let t6;
        return t6 = r2[0] < 0 ? `(` + r2[0].toString() + `)` : r2[0].toString(), r2[1] < 0 ? t6 + `^(` + r2[1].toString() + `)` : t6 + `^` + r2[1].toString();
      }
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `(` + t5.toString() + `)`);
      let i2 = this.factor(r2[1]);
      return this.simple_factor_or_function_or_parens(r2[1]) || (i2 = `(` + i2.toString() + `)`), t5 + `^` + i2;
    } else if (n2 === `_`) return this.operators[n2](r2.map((function(t5, n3) {
      let r3 = this.factor(t5);
      return this.simple_factor_or_function_or_parens(t5) ? r3 : `(` + r3 + `)`;
    }).bind(this)));
    else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `(` + i2 + `)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `-`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return this.operators[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `[ ` + i2 : `( ` + i2, n3[2] ? i2 += ` ]` : i2 += ` )`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `[ `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        i2 += `[ `;
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += `,`), i2 += ` `;
        i2 += `]`, r3 < t5[1] - 1 && (i2 += `,`), i2 += ` `;
      }
      return i2 += `]`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `∂`);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 && (c2 = c2 + `^` + o2), c2 = c2 + this.symbolConvert(s2) + `/`;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.symbolConvert(o3), i3 > 1 && (c2 = c2 + `^` + i3);
      }
      return c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `|` + this.statement(r2[1]) + `|`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `(` + t6 + `)!`;
      }
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3 += ` ` + t7.map((t8) => `d` + this.factor(t8[1])).join(` `));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3 = this.factor(r2[0]), i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `(` + i2 + `)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return this.operators[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `(` + this.statement(t4) + `)`;
  }
  factorWithParenthesesIfNegatedOrExplicitPlus(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) ? `(` + n2 + `)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    let n2 = this.term(t4);
    return n2.match(/^± /) || n2.match(/^plusminus /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, astToText$1 = new astToText$2();
function subscripts_to_strings(t4, n2 = false) {
  var r2 = get_tree(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  return i2 === `_` && (n2 || a2.every((t5) => [`number`, `string`].includes(typeof t5))) ? astToText$1.convert(r2) : [i2].concat(a2.map((t5) => subscripts_to_strings(t5, n2)));
}
function strings_to_subscripts(t4) {
  var n2 = get_tree(t4);
  if (typeof n2 == `string`) {
    let t5 = n2.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);
    if (t5) {
      let n3 = Number(t5[1]);
      isNaN(n3) && (n3 = t5[1]);
      let r3 = Number(t5[2]);
      return isNaN(r3) && (r3 = t5[2]), [`_`, n3, r3];
    } else return n2;
  }
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  return [r2].concat(i2.map(strings_to_subscripts));
}
var normalization_exports = __exportAll({ altvectors_to_vectors: () => altvectors_to_vectors, constants_to_floats: () => constants_to_floats, default_order: () => default_order, log_subscript_to_two_arg_log: () => log_subscript_to_two_arg_log, normalize_angle_linesegment_arg_order: () => normalize_angle_linesegment_arg_order, normalize_applied_functions: () => normalize_applied_functions, normalize_function_names: () => normalize_function_names, normalize_negative_numbers: () => normalize_negative_numbers, strings_to_subscripts: () => strings_to_subscripts, subscripts_to_strings: () => subscripts_to_strings, substitute_abs: () => substitute_abs, to_intervals: () => to_intervals, tuples_to_vectors: () => tuples_to_vectors });
function get_all_units() {
  return { "%": { scale: (t4) => [`/`, t4, 100], only_scales: true }, $: { prefix: true, scale: (t4) => t4 }, deg: { scale: (t4) => [`/`, [`*`, t4, `pi`], 180], only_scales: true } };
}
var all_units$1 = get_all_units();
function get_unit_of_tree(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1) if (all_units$1[n2].prefix) {
      if (t4[1] === n2) return n2;
    } else if (t4[2] === n2) return n2;
  }
  return null;
}
function get_unit_value_of_tree(t4) {
  if (t4[0] === `unit`) {
    for (let n2 in all_units$1) if (all_units$1[n2].prefix) {
      if (t4[1] === n2) return [n2, t4[2]];
    } else if (t4[2] === n2) return [n2, t4[1]];
  }
  return null;
}
function remove_duplicate_negatives(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `-` && Array.isArray(r2[0]) && r2[0][0] === `-` ? remove_duplicate_negatives(r2[0][1]) : n2 === `-` && typeof r2[0] == `number` && r2[0] < 0 ? -r2[0] : (r2 = r2.map(remove_duplicate_negatives), [n2].concat(r2));
}
function normalize_negatives_in_factors(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(normalize_negatives_in_factors), n2 !== `*` && n2 !== `/`) return [n2].concat(r2);
  for (var i2 = 1, a2 = [], o2 = 0; o2 < r2.length; o2++) Array.isArray(r2[o2]) && r2[o2][0] === `-` ? (i2 *= -1, a2.push(r2[o2][1])) : typeof r2[o2] == `number` && r2[o2] < 0 ? (i2 *= -1, a2.push(-r2[o2])) : a2.push(r2[o2]);
  var s2 = [n2].concat(a2);
  return i2 === -1 && (s2 = [`-`, s2]), s2;
}
function normalize_negatives(t4) {
  var n2 = get_tree(t4);
  return n2 = remove_duplicate_negatives(n2), n2 = normalize_negatives_in_factors(n2), n2 = remove_duplicate_negatives(n2), n2 = normalize_negative_numbers(n2), n2;
}
function sort_key(t4, n2 = {}) {
  if (typeof t4 == `number`) return n2.ignore_negatives ? [0, `number`, Math.abs(t4)] : [0, `number`, t4];
  if (typeof t4 == `string`) return t4 === `-` || t4 === `+` ? [8, `plus_minus_string`, t4] : [1, `symbol`, t4];
  if (typeof t4 == `boolean`) return [1, `boolean`, t4];
  if (!Array.isArray(t4)) return [-1, `unknown`, t4];
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `^` && i2.length === 2) return [...sort_key(i2[0], n2), `power`, ...sort_key(i2[1], n2)];
  if (r2 === `apply`) {
    var a2 = [2, `function`, i2[0]];
    (i2[0] === `sqrt` || i2[0] === `cbrt` || i2[0] === `nthroot`) && (a2 = [5, `root`, i2[0] === `sqrt` ? 2 : i2[0] === `cbrt` ? 3 : i2[1][2] ?? 2]);
    var o2 = i2[1], s2 = 1, c2 = [];
    return Array.isArray(o2) ? (o2 = o2.slice(1), s2 = o2.length, c2 = o2.map((t5) => sort_key(t5, n2))) : c2 = [sort_key(o2, n2)], a2.push([s2, c2]), a2;
  } else if (r2 === `unit`) {
    let [r3, i3] = get_unit_value_of_tree(t4);
    if (r3) {
      let t5 = sort_key(i3, n2);
      return t5[1] += `_` + r3, t5;
    }
  }
  var l2 = i2.length, u2 = i2.map(sort_key, n2);
  return r2 === `*` ? [4, `product`, l2, u2] : r2 === `/` ? [4, `quotient`, l2, u2] : r2 === `+` ? [5, `sum`, l2, u2] : r2 === `-` ? n2.ignore_negatives ? u2[0] : [6, `minus`, l2, u2] : r2 === `pm` ? n2.ignore_negatives ? u2[0] : [6, `pm`, l2, u2] : [`tuple`, `vector`, `altvector`].includes(r2) ? [7, l2, u2] : r2 === `interval` ? i2[1][1] === false ? i2[1][2] === false ? [7, ...u2[0].slice(1)] : [8, l2, u2] : i2[1][2] === false ? [8, l2, u2] : [9, ...u2[0].slice(1)] : r2 === `array` ? [9, l2, u2] : [10, r2, l2, u2];
}
function arrayCompare(t4, n2) {
  if (Array.isArray(t4)) if (Array.isArray(n2)) {
    let r2 = Math.min(t4.length, n2.length);
    for (let i2 = 0; i2 < r2; i2++) {
      let r3 = arrayCompare(t4[i2], n2[i2]);
      if (r3 !== 0) return r3;
    }
    return t4.length < n2.length ? -1 : +(t4.length > n2.length);
  } else return 1;
  else if (Array.isArray(n2)) return -1;
  else return t4 < n2 ? -1 : +(t4 > n2);
}
function compare_function(t4, n2, r2 = {}) {
  return arrayCompare(sort_key(t4, r2), sort_key(n2, r2));
}
function coeff_factors_from_term(t4, n2) {
  if (typeof t4 == `string`) {
    let r2 = n2.indexOf(t4);
    r2 === -1 && (n2.push(t4), r2 = n2.length - 1);
    let i2 = [];
    return i2[r2] = 1, { factor_contains: i2, coeff: 1 };
  } else if (Array.isArray(t4)) {
    let r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `*`) {
      let t5 = [], r3 = [];
      for (let a2 of i2) {
        if (typeof a2 == `string`) {
          let t6 = n2.indexOf(a2);
          t6 === -1 && (n2.push(a2), t6 = n2.length - 1), r3[t6] === void 0 && (r3[t6] = 0), r3[t6]++;
          continue;
        } else if (Array.isArray(a2) && (a2[0] === `^` || a2[0] === `-`)) {
          let i3 = coeff_factors_from_term(a2, n2);
          for (let t6 in i3.factor_contains) r3[t6] === void 0 && (r3[t6] = 0), r3[t6] += i3.factor_contains[t6];
          i3.coeff !== 1 && t5.push(i3.coeff);
          continue;
        }
        t5.push(a2);
      }
      return t5 = t5.length === 0 ? 1 : t5.length === 1 ? t5[0] : [`*`, ...t5], { factor_contains: r3, coeff: t5 };
    } else if (r2 === `^`) {
      let t5 = i2[0], r3 = i2[1], a2 = [];
      if (typeof t5 == `string` && Number.isFinite(r3)) {
        let i3 = n2.indexOf(t5);
        return i3 === -1 && (n2.push(t5), i3 = n2.length - 1), a2[i3] = r3, { factor_contains: a2, coeff: 1 };
      }
    } else if (r2 === `-`) {
      let t5 = coeff_factors_from_term(i2[0], n2), r3 = -1;
      return typeof t5.coeff == `number` ? r3 *= t5.coeff : r3 = [`-`, t5.coeff], { factor_contains: t5.factor_contains, coeff: r3 };
    } else if (r2 === `/`) {
      let t5 = coeff_factors_from_term(i2[0], n2), r3 = [`/`, t5.coeff, i2[1]];
      return { factor_contains: t5.factor_contains, coeff: r3 };
    }
  }
  return { factor_contains: [], coeff: t4 };
}
function default_order(t4, n2) {
  n2 === void 0 && (n2 = {});
  var r2 = get_tree(t4);
  r2 = flatten$5(r2), r2 = normalize_negatives(r2);
  function i2(t5) {
    if (!Array.isArray(t5)) return t5;
    var r3 = t5[0], a2 = t5.slice(1);
    if (a2 = a2.map(i2), r3 === `+`) {
      let t6 = [], r4 = [], i3 = [];
      for (let n3 of a2) {
        let a3 = coeff_factors_from_term(n3, t6);
        r4.push(a3.factor_contains), i3.push(a3.coeff);
      }
      let o3 = [];
      for (let [n3, i4] of t6.entries()) {
        let t7 = { varname: i4, exponents_in_term: [] };
        for (let i5 = 0; i5 < r4.length; i5++) t7.exponents_in_term.push(r4[i5][n3] || 0);
        o3.push(t7);
      }
      o3.sort((t7, n3) => t7.varname < n3.varname ? -1 : 1);
      let s3 = [];
      for (let t7 = 0; t7 < i3.length; t7++) {
        let r5 = o3.reduce((n3, r6) => [...n3, -r6.exponents_in_term[t7]], []);
        r5.push(sort_key(i3[t7], n2)), s3.push(r5);
      }
      let c2 = [];
      for (let [t7, n3] of a2.entries()) c2.push({ term: n3, sort_key: s3[t7] });
      c2.sort((t7, n3) => arrayCompare(t7.sort_key, n3.sort_key)), a2 = c2.map((t7) => t7.term);
    } else if (r3 === `*`) {
      let t6 = [], r4 = [];
      for (let n3 of a2) [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n3[0]) ? r4.push(n3) : t6.push(n3);
      t6.sort((t7, r5) => compare_function(t7, r5, n2)), a2 = [...t6, ...r4];
    } else if (r3 === `=` || r3 === `and` || r3 === `or` || r3 === `ne` || r3 === `union` || r3 === `intersect`) a2.sort((t6, r4) => compare_function(t6, r4, n2));
    else if (r3 === `>` || r3 === `ge`) a2 = a2.reverse(), r3 = r3 === `>` ? `<` : `le`;
    else if (r3 === `gts`) {
      var o2 = a2[0], s2 = a2[1];
      if (o2[0] !== `tuple` || s2[0] !== `tuple`) throw Error(`Badly formed ast`);
      o2 = [`tuple`].concat(o2.slice(1).reverse()), s2 = [`tuple`].concat(s2.slice(1).reverse()), r3 = `lts`, a2 = [o2, s2];
    } else if (r3 === `ni` || r3 === `notni` || r3 === `superset` || r3 === `notsuperset` || r3 === `superseteq` || r3 === `notsuperseteq`) a2 = a2.reverse(), r3 === `ni` ? r3 = `in` : r3 === `notni` ? r3 = `notin` : r3 === `superset` ? r3 = `subset` : r3 === `notsuperset` ? r3 = `notsubset` : r3 === `superseteq` ? r3 = `subseteq` : r3 === `notsuperseteq` && (r3 = `notsubseteq`);
    else if (r3 === `-` && a2[0][0] === `*`) return a2[0][1] = [`-`, a2[0][1]], a2[0];
    return [r3].concat(a2);
  }
  return normalize_negatives(i2(r2));
}
var variables_exports = __exportAll({ functions: () => functions$2, operators: () => operators$3, variables: () => variables });
function leaves(t4, n2) {
  if (!Array.isArray(t4)) return [t4];
  var r2 = t4[0], i2 = t4.slice(1);
  return n2 && r2 === `_` && typeof i2[0] == `string` && (typeof i2[1] == `string` || typeof i2[1] == `number`) ? [i2[0] + `_` + i2[1]] : (r2 === `apply` && (i2 = t4.slice(2)), i2.length === 0 ? [] : i2.map(function(t5, r3) {
    return leaves(t5, n2);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function variables(t4, n2 = false) {
  var r2 = leaves(get_tree(t4), n2);
  return r2 = r2.filter(function(t5, n3) {
    return typeof t5 == `string` && (mathjs_default.define_e || t5 !== `e`) && (mathjs_default.define_pi || t5 !== `pi`) && (mathjs_default.define_i || t5 !== `i`);
  }), r2 = r2.filter(function(t5, n3, i2) {
    return n3 === r2.indexOf(t5);
  }), r2;
}
function operators_list(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1);
  return n2 === `apply` && (r2 = t4.slice(2)), r2.length === 0 ? [n2] : [n2].concat(r2.map(function(t5, n3) {
    return operators_list(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }));
}
function operators$3(t4) {
  var n2 = operators_list(get_tree(t4));
  return n2 = n2.filter(function(t5, n3) {
    return t5 !== `apply`;
  }), n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
function functions_list(t4) {
  if (!Array.isArray(t4)) return [];
  var n2 = t4[0], r2 = t4.slice(1), i2 = [];
  return n2 === `apply` && (i2 = [r2[0]], r2 = t4.slice(2)), i2.concat(r2.map(function(t5, n3) {
    return functions_list(t5);
  }).reduce(function(t5, n3) {
    return t5.concat(n3);
  }, []));
}
function functions$2(t4) {
  var n2 = functions_list(get_tree(t4));
  return n2 = n2.filter(function(t5, r2, i2) {
    return r2 === n2.indexOf(t5);
  }), n2;
}
var VERSION, root, ArrayProto, ObjProto, SymbolProto, push$1, slice, toString$1, hasOwnProperty$2$1, supportsArrayBuffer, supportsDataView, nativeIsArray, nativeKeys, nativeCreate, nativeIsView, _isNaN, _isFinite, hasEnumBug, nonEnumerableProps, MAX_ARRAY_INDEX, init__setup = __esmMin((() => {
  VERSION = `1.13.6`, root = typeof self == `object` && self.self === self && self || typeof global == `object` && global.global === global && global || Function(`return this`)() || {}, ArrayProto = Array.prototype, ObjProto = Object.prototype, SymbolProto = typeof Symbol < `u` ? Symbol.prototype : null, push$1 = ArrayProto.push, slice = ArrayProto.slice, toString$1 = ObjProto.toString, hasOwnProperty$2$1 = ObjProto.hasOwnProperty, supportsArrayBuffer = typeof ArrayBuffer < `u`, supportsDataView = typeof DataView < `u`, nativeIsArray = Array.isArray, nativeKeys = Object.keys, nativeCreate = Object.create, nativeIsView = supportsArrayBuffer && ArrayBuffer.isView, _isNaN = isNaN, _isFinite = isFinite, hasEnumBug = !{ toString: null }.propertyIsEnumerable(`toString`), nonEnumerableProps = [`valueOf`, `isPrototypeOf`, `toString`, `propertyIsEnumerable`, `hasOwnProperty`, `toLocaleString`], MAX_ARRAY_INDEX = 2 ** 53 - 1;
}));
function restArguments(t4, n2) {
  return n2 = n2 == null ? t4.length - 1 : +n2, function() {
    for (var r2 = Math.max(arguments.length - n2, 0), i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = arguments[a2 + n2];
    switch (n2) {
      case 0:
        return t4.call(this, i2);
      case 1:
        return t4.call(this, arguments[0], i2);
      case 2:
        return t4.call(this, arguments[0], arguments[1], i2);
    }
    var o2 = Array(n2 + 1);
    for (a2 = 0; a2 < n2; a2++) o2[a2] = arguments[a2];
    return o2[n2] = i2, t4.apply(this, o2);
  };
}
var init_restArguments = __esmMin((() => {
}));
function isObject(t4) {
  var n2 = typeof t4;
  return n2 === `function` || n2 === `object` && !!t4;
}
var init_isObject = __esmMin((() => {
}));
function isNull(t4) {
  return t4 === null;
}
var init_isNull = __esmMin((() => {
}));
function isUndefined(t4) {
  return t4 === void 0;
}
var init_isUndefined = __esmMin((() => {
}));
function isBoolean(t4) {
  return t4 === true || t4 === false || toString$1.call(t4) === `[object Boolean]`;
}
var init_isBoolean = __esmMin((() => {
  init__setup();
}));
function isElement$3(t4) {
  return !!(t4 && t4.nodeType === 1);
}
var init_isElement = __esmMin((() => {
}));
function tagTester(t4) {
  var n2 = `[object ` + t4 + `]`;
  return function(t5) {
    return toString$1.call(t5) === n2;
  };
}
var init__tagTester = __esmMin((() => {
  init__setup();
})), isString_default, init_isString = __esmMin((() => {
  init__tagTester(), isString_default = tagTester(`String`);
})), isNumber_default, init_isNumber = __esmMin((() => {
  init__tagTester(), isNumber_default = tagTester(`Number`);
})), isDate_default, init_isDate = __esmMin((() => {
  init__tagTester(), isDate_default = tagTester(`Date`);
})), isRegExp_default, init_isRegExp = __esmMin((() => {
  init__tagTester(), isRegExp_default = tagTester(`RegExp`);
})), isError_default, init_isError = __esmMin((() => {
  init__tagTester(), isError_default = tagTester(`Error`);
})), isSymbol_default, init_isSymbol = __esmMin((() => {
  init__tagTester(), isSymbol_default = tagTester(`Symbol`);
})), isArrayBuffer_default, init_isArrayBuffer = __esmMin((() => {
  init__tagTester(), isArrayBuffer_default = tagTester(`ArrayBuffer`);
})), isFunction, nodelist, isFunction_default, init_isFunction = __esmMin((() => {
  init__tagTester(), init__setup(), isFunction = tagTester(`Function`), nodelist = root.document && root.document.childNodes, typeof /./ != `function` && typeof Int8Array != `object` && typeof nodelist != `function` && (isFunction = function(t4) {
    return typeof t4 == `function` || false;
  }), isFunction_default = isFunction;
})), _hasObjectTag_default, init__hasObjectTag = __esmMin((() => {
  init__tagTester(), _hasObjectTag_default = tagTester(`Object`);
})), hasStringTagBug, isIE11, init__stringTagBug = __esmMin((() => {
  init__setup(), init__hasObjectTag(), hasStringTagBug = supportsDataView && _hasObjectTag_default(new DataView(new ArrayBuffer(8))), isIE11 = typeof Map < `u` && _hasObjectTag_default(/* @__PURE__ */ new Map());
}));
function ie10IsDataView(t4) {
  return t4 != null && isFunction_default(t4.getInt8) && isArrayBuffer_default(t4.buffer);
}
var isDataView, isDataView_default, init_isDataView = __esmMin((() => {
  init__tagTester(), init_isFunction(), init_isArrayBuffer(), init__stringTagBug(), isDataView = tagTester(`DataView`), isDataView_default = hasStringTagBug ? ie10IsDataView : isDataView;
})), isArray_default, init_isArray = __esmMin((() => {
  init__setup(), init__tagTester(), isArray_default = nativeIsArray || tagTester(`Array`);
}));
function has$1(t4, n2) {
  return t4 != null && hasOwnProperty$2$1.call(t4, n2);
}
var init__has = __esmMin((() => {
  init__setup();
})), isArguments, isArguments_default, init_isArguments = __esmMin((() => {
  init__tagTester(), init__has(), isArguments = tagTester(`Arguments`), (function() {
    isArguments(arguments) || (isArguments = function(t4) {
      return has$1(t4, `callee`);
    });
  })(), isArguments_default = isArguments;
}));
function isFinite$1(t4) {
  return !isSymbol_default(t4) && _isFinite(t4) && !isNaN(parseFloat(t4));
}
var init_isFinite = __esmMin((() => {
  init__setup(), init_isSymbol();
}));
function isNaN$1(t4) {
  return isNumber_default(t4) && _isNaN(t4);
}
var init_isNaN = __esmMin((() => {
  init__setup(), init_isNumber();
}));
function constant(t4) {
  return function() {
    return t4;
  };
}
var init_constant = __esmMin((() => {
}));
function createSizePropertyCheck(t4) {
  return function(n2) {
    var r2 = t4(n2);
    return typeof r2 == `number` && r2 >= 0 && r2 <= MAX_ARRAY_INDEX;
  };
}
var init__createSizePropertyCheck = __esmMin((() => {
  init__setup();
}));
function shallowProperty(t4) {
  return function(n2) {
    return n2?.[t4];
  };
}
var init__shallowProperty = __esmMin((() => {
})), _getByteLength_default, init__getByteLength = __esmMin((() => {
  init__shallowProperty(), _getByteLength_default = shallowProperty(`byteLength`);
})), _isBufferLike_default, init__isBufferLike = __esmMin((() => {
  init__createSizePropertyCheck(), init__getByteLength(), _isBufferLike_default = createSizePropertyCheck(_getByteLength_default);
}));
function isTypedArray(t4) {
  return nativeIsView ? nativeIsView(t4) && !isDataView_default(t4) : _isBufferLike_default(t4) && typedArrayPattern.test(toString$1.call(t4));
}
var typedArrayPattern, isTypedArray_default, init_isTypedArray = __esmMin((() => {
  init__setup(), init_isDataView(), init_constant(), init__isBufferLike(), typedArrayPattern = /\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\]/, isTypedArray_default = supportsArrayBuffer ? isTypedArray : constant(false);
})), _getLength_default, init__getLength = __esmMin((() => {
  init__shallowProperty(), _getLength_default = shallowProperty(`length`);
}));
function emulatedSet(t4) {
  for (var n2 = {}, r2 = t4.length, i2 = 0; i2 < r2; ++i2) n2[t4[i2]] = true;
  return { contains: function(t5) {
    return n2[t5] === true;
  }, push: function(r3) {
    return n2[r3] = true, t4.push(r3);
  } };
}
function collectNonEnumProps(t4, n2) {
  n2 = emulatedSet(n2);
  var r2 = nonEnumerableProps.length, i2 = t4.constructor, a2 = isFunction_default(i2) && i2.prototype || ObjProto, o2 = `constructor`;
  for (has$1(t4, o2) && !n2.contains(o2) && n2.push(o2); r2--; ) o2 = nonEnumerableProps[r2], o2 in t4 && t4[o2] !== a2[o2] && !n2.contains(o2) && n2.push(o2);
}
var init__collectNonEnumProps = __esmMin((() => {
  init__setup(), init_isFunction(), init__has();
}));
function keys(t4) {
  if (!isObject(t4)) return [];
  if (nativeKeys) return nativeKeys(t4);
  var n2 = [];
  for (var r2 in t4) has$1(t4, r2) && n2.push(r2);
  return hasEnumBug && collectNonEnumProps(t4, n2), n2;
}
var init_keys = __esmMin((() => {
  init_isObject(), init__setup(), init__has(), init__collectNonEnumProps();
}));
function isEmpty(t4) {
  if (t4 == null) return true;
  var n2 = _getLength_default(t4);
  return typeof n2 == `number` && (isArray_default(t4) || isString_default(t4) || isArguments_default(t4)) ? n2 === 0 : _getLength_default(keys(t4)) === 0;
}
var init_isEmpty = __esmMin((() => {
  init__getLength(), init_isArray(), init_isString(), init_isArguments(), init_keys();
}));
function isMatch(t4, n2) {
  var r2 = keys(n2), i2 = r2.length;
  if (t4 == null) return !i2;
  for (var a2 = Object(t4), o2 = 0; o2 < i2; o2++) {
    var s2 = r2[o2];
    if (n2[s2] !== a2[s2] || !(s2 in a2)) return false;
  }
  return true;
}
var init_isMatch = __esmMin((() => {
  init_keys();
}));
function _$1(t4) {
  if (t4 instanceof _$1) return t4;
  if (!(this instanceof _$1)) return new _$1(t4);
  this._wrapped = t4;
}
var init_underscore = __esmMin((() => {
  init__setup(), _$1.VERSION = VERSION, _$1.prototype.value = function() {
    return this._wrapped;
  }, _$1.prototype.valueOf = _$1.prototype.toJSON = _$1.prototype.value, _$1.prototype.toString = function() {
    return String(this._wrapped);
  };
}));
function toBufferView(t4) {
  return new Uint8Array(t4.buffer || t4, t4.byteOffset || 0, _getByteLength_default(t4));
}
var init__toBufferView = __esmMin((() => {
  init__getByteLength();
}));
function eq(t4, n2, r2, i2) {
  if (t4 === n2) return t4 !== 0 || 1 / t4 == 1 / n2;
  if (t4 == null || n2 == null) return false;
  if (t4 !== t4) return n2 !== n2;
  var a2 = typeof t4;
  return a2 !== `function` && a2 !== `object` && typeof n2 != `object` ? false : deepEq(t4, n2, r2, i2);
}
function deepEq(t4, n2, r2, i2) {
  t4 instanceof _$1 && (t4 = t4._wrapped), n2 instanceof _$1 && (n2 = n2._wrapped);
  var a2 = toString$1.call(t4);
  if (a2 !== toString$1.call(n2)) return false;
  if (hasStringTagBug && a2 == `[object Object]` && isDataView_default(t4)) {
    if (!isDataView_default(n2)) return false;
    a2 = tagDataView;
  }
  switch (a2) {
    case `[object RegExp]`:
    case `[object String]`:
      return `` + t4 == `` + n2;
    case `[object Number]`:
      return +t4 == +t4 ? +t4 == 0 ? 1 / t4 == 1 / n2 : +t4 == +n2 : +n2 != +n2;
    case `[object Date]`:
    case `[object Boolean]`:
      return +t4 == +n2;
    case `[object Symbol]`:
      return SymbolProto.valueOf.call(t4) === SymbolProto.valueOf.call(n2);
    case `[object ArrayBuffer]`:
    case tagDataView:
      return deepEq(toBufferView(t4), toBufferView(n2), r2, i2);
  }
  var o2 = a2 === `[object Array]`;
  if (!o2 && isTypedArray_default(t4)) {
    if (_getByteLength_default(t4) !== _getByteLength_default(n2)) return false;
    if (t4.buffer === n2.buffer && t4.byteOffset === n2.byteOffset) return true;
    o2 = true;
  }
  if (!o2) {
    if (typeof t4 != `object` || typeof n2 != `object`) return false;
    var s2 = t4.constructor, c2 = n2.constructor;
    if (s2 !== c2 && !(isFunction_default(s2) && s2 instanceof s2 && isFunction_default(c2) && c2 instanceof c2) && `constructor` in t4 && `constructor` in n2) return false;
  }
  r2 ||= [], i2 ||= [];
  for (var l2 = r2.length; l2--; ) if (r2[l2] === t4) return i2[l2] === n2;
  if (r2.push(t4), i2.push(n2), o2) {
    if (l2 = t4.length, l2 !== n2.length) return false;
    for (; l2--; ) if (!eq(t4[l2], n2[l2], r2, i2)) return false;
  } else {
    var u2 = keys(t4), d2;
    if (l2 = u2.length, keys(n2).length !== l2) return false;
    for (; l2--; ) if (d2 = u2[l2], !(has$1(n2, d2) && eq(t4[d2], n2[d2], r2, i2))) return false;
  }
  return r2.pop(), i2.pop(), true;
}
function isEqual(t4, n2) {
  return eq(t4, n2);
}
var tagDataView, init_isEqual = __esmMin((() => {
  init_underscore(), init__setup(), init__getByteLength(), init_isTypedArray(), init_isFunction(), init__stringTagBug(), init_isDataView(), init_keys(), init__has(), init__toBufferView(), tagDataView = `[object DataView]`;
}));
function allKeys(t4) {
  if (!isObject(t4)) return [];
  var n2 = [];
  for (var r2 in t4) n2.push(r2);
  return hasEnumBug && collectNonEnumProps(t4, n2), n2;
}
var init_allKeys = __esmMin((() => {
  init_isObject(), init__setup(), init__collectNonEnumProps();
}));
function ie11fingerprint(t4) {
  var n2 = _getLength_default(t4);
  return function(r2) {
    if (r2 == null || _getLength_default(allKeys(r2))) return false;
    for (var i2 = 0; i2 < n2; i2++) if (!isFunction_default(r2[t4[i2]])) return false;
    return t4 !== weakMapMethods || !isFunction_default(r2[forEachName]);
  };
}
var forEachName, hasName, commonInit, mapTail, mapMethods, weakMapMethods, setMethods, init__methodFingerprint = __esmMin((() => {
  init__getLength(), init_isFunction(), init_allKeys(), forEachName = `forEach`, hasName = `has`, commonInit = [`clear`, `delete`], mapTail = [`get`, hasName, `set`], mapMethods = commonInit.concat(forEachName, mapTail), weakMapMethods = commonInit.concat(mapTail), setMethods = [`add`].concat(commonInit, forEachName, hasName);
})), isMap_default, init_isMap = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isMap_default = isIE11 ? ie11fingerprint(mapMethods) : tagTester(`Map`);
})), isWeakMap_default, init_isWeakMap = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isWeakMap_default = isIE11 ? ie11fingerprint(weakMapMethods) : tagTester(`WeakMap`);
})), isSet_default, init_isSet = __esmMin((() => {
  init__tagTester(), init__stringTagBug(), init__methodFingerprint(), isSet_default = isIE11 ? ie11fingerprint(setMethods) : tagTester(`Set`);
})), isWeakSet_default, init_isWeakSet = __esmMin((() => {
  init__tagTester(), isWeakSet_default = tagTester(`WeakSet`);
}));
function values(t4) {
  for (var n2 = keys(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = t4[n2[a2]];
  return i2;
}
var init_values = __esmMin((() => {
  init_keys();
}));
function pairs(t4) {
  for (var n2 = keys(t4), r2 = n2.length, i2 = Array(r2), a2 = 0; a2 < r2; a2++) i2[a2] = [n2[a2], t4[n2[a2]]];
  return i2;
}
var init_pairs = __esmMin((() => {
  init_keys();
}));
function invert(t4) {
  for (var n2 = {}, r2 = keys(t4), i2 = 0, a2 = r2.length; i2 < a2; i2++) n2[t4[r2[i2]]] = r2[i2];
  return n2;
}
var init_invert = __esmMin((() => {
  init_keys();
}));
function functions$1(t4) {
  var n2 = [];
  for (var r2 in t4) isFunction_default(t4[r2]) && n2.push(r2);
  return n2.sort();
}
var init_functions = __esmMin((() => {
  init_isFunction();
}));
function createAssigner(t4, n2) {
  return function(r2) {
    var i2 = arguments.length;
    if (n2 && (r2 = Object(r2)), i2 < 2 || r2 == null) return r2;
    for (var a2 = 1; a2 < i2; a2++) for (var o2 = arguments[a2], s2 = t4(o2), c2 = s2.length, l2 = 0; l2 < c2; l2++) {
      var u2 = s2[l2];
      (!n2 || r2[u2] === void 0) && (r2[u2] = o2[u2]);
    }
    return r2;
  };
}
var init__createAssigner = __esmMin((() => {
})), extend_default, init_extend = __esmMin((() => {
  init__createAssigner(), init_allKeys(), extend_default = createAssigner(allKeys);
})), extendOwn_default, init_extendOwn = __esmMin((() => {
  init__createAssigner(), init_keys(), extendOwn_default = createAssigner(keys);
})), defaults_default, init_defaults = __esmMin((() => {
  init__createAssigner(), init_allKeys(), defaults_default = createAssigner(allKeys, true);
}));
function ctor() {
  return function() {
  };
}
function baseCreate(t4) {
  if (!isObject(t4)) return {};
  if (nativeCreate) return nativeCreate(t4);
  var n2 = ctor();
  n2.prototype = t4;
  var r2 = new n2();
  return n2.prototype = null, r2;
}
var init__baseCreate = __esmMin((() => {
  init_isObject(), init__setup();
}));
function create(t4, n2) {
  var r2 = baseCreate(t4);
  return n2 && extendOwn_default(r2, n2), r2;
}
var init_create = __esmMin((() => {
  init__baseCreate(), init_extendOwn();
}));
function clone(t4) {
  return isObject(t4) ? isArray_default(t4) ? t4.slice() : extend_default({}, t4) : t4;
}
var init_clone = __esmMin((() => {
  init_isObject(), init_isArray(), init_extend();
}));
function tap(t4, n2) {
  return n2(t4), t4;
}
var init_tap = __esmMin((() => {
}));
function toPath$1(t4) {
  return isArray_default(t4) ? t4 : [t4];
}
var init_toPath = __esmMin((() => {
  init_underscore(), init_isArray(), _$1.toPath = toPath$1;
}));
function toPath(t4) {
  return _$1.toPath(t4);
}
var init__toPath = __esmMin((() => {
  init_underscore(), init_toPath();
}));
function deepGet(t4, n2) {
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    if (t4 == null) return;
    t4 = t4[n2[i2]];
  }
  return r2 ? t4 : void 0;
}
var init__deepGet = __esmMin((() => {
}));
function get(t4, n2, r2) {
  var i2 = deepGet(t4, toPath(n2));
  return isUndefined(i2) ? r2 : i2;
}
var init_get = __esmMin((() => {
  init__toPath(), init__deepGet(), init_isUndefined();
}));
function has(t4, n2) {
  n2 = toPath(n2);
  for (var r2 = n2.length, i2 = 0; i2 < r2; i2++) {
    var a2 = n2[i2];
    if (!has$1(t4, a2)) return false;
    t4 = t4[a2];
  }
  return !!r2;
}
var init_has = __esmMin((() => {
  init__has(), init__toPath();
}));
function identity$1(t4) {
  return t4;
}
var init_identity = __esmMin((() => {
}));
function matcher(t4) {
  return t4 = extendOwn_default({}, t4), function(n2) {
    return isMatch(n2, t4);
  };
}
var init_matcher = __esmMin((() => {
  init_extendOwn(), init_isMatch();
}));
function property(t4) {
  return t4 = toPath(t4), function(n2) {
    return deepGet(n2, t4);
  };
}
var init_property = __esmMin((() => {
  init__deepGet(), init__toPath();
}));
function optimizeCb(t4, n2, r2) {
  if (n2 === void 0) return t4;
  switch (r2 ?? 3) {
    case 1:
      return function(r3) {
        return t4.call(n2, r3);
      };
    case 3:
      return function(r3, i2, a2) {
        return t4.call(n2, r3, i2, a2);
      };
    case 4:
      return function(r3, i2, a2, o2) {
        return t4.call(n2, r3, i2, a2, o2);
      };
  }
  return function() {
    return t4.apply(n2, arguments);
  };
}
var init__optimizeCb = __esmMin((() => {
}));
function baseIteratee(t4, n2, r2) {
  return t4 == null ? identity$1 : isFunction_default(t4) ? optimizeCb(t4, n2, r2) : isObject(t4) && !isArray_default(t4) ? matcher(t4) : property(t4);
}
var init__baseIteratee = __esmMin((() => {
  init_identity(), init_isFunction(), init_isObject(), init_isArray(), init_matcher(), init_property(), init__optimizeCb();
}));
function iteratee(t4, n2) {
  return baseIteratee(t4, n2, 1 / 0);
}
var init_iteratee = __esmMin((() => {
  init_underscore(), init__baseIteratee(), _$1.iteratee = iteratee;
}));
function cb(t4, n2, r2) {
  return _$1.iteratee === iteratee ? baseIteratee(t4, n2, r2) : _$1.iteratee(t4, n2);
}
var init__cb = __esmMin((() => {
  init_underscore(), init__baseIteratee(), init_iteratee();
}));
function mapObject(t4, n2, r2) {
  n2 = cb(n2, r2);
  for (var i2 = keys(t4), a2 = i2.length, o2 = {}, s2 = 0; s2 < a2; s2++) {
    var c2 = i2[s2];
    o2[c2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_mapObject = __esmMin((() => {
  init__cb(), init_keys();
}));
function noop$2() {
}
var init_noop = __esmMin((() => {
}));
function propertyOf(t4) {
  return t4 == null ? noop$2 : function(n2) {
    return get(t4, n2);
  };
}
var init_propertyOf = __esmMin((() => {
  init_noop(), init_get();
}));
function times(t4, n2, r2) {
  var i2 = Array(Math.max(0, t4));
  n2 = optimizeCb(n2, r2, 1);
  for (var a2 = 0; a2 < t4; a2++) i2[a2] = n2(a2);
  return i2;
}
var init_times = __esmMin((() => {
  init__optimizeCb();
}));
function random(t4, n2) {
  return n2 ?? (n2 = t4, t4 = 0), t4 + Math.floor(Math.random() * (n2 - t4 + 1));
}
var init_random = __esmMin((() => {
})), now_default, init_now = __esmMin((() => {
  now_default = Date.now || function() {
    return (/* @__PURE__ */ new Date()).getTime();
  };
}));
function createEscaper(t4) {
  var n2 = function(n3) {
    return t4[n3];
  }, r2 = `(?:` + keys(t4).join(`|`) + `)`, i2 = RegExp(r2), a2 = RegExp(r2, `g`);
  return function(t5) {
    return t5 = t5 == null ? `` : `` + t5, i2.test(t5) ? t5.replace(a2, n2) : t5;
  };
}
var init__createEscaper = __esmMin((() => {
  init_keys();
})), _escapeMap_default, init__escapeMap = __esmMin((() => {
  _escapeMap_default = { "&": `&amp;`, "<": `&lt;`, ">": `&gt;`, '"': `&quot;`, "'": `&#x27;`, "`": `&#x60;` };
})), escape_default, init_escape = __esmMin((() => {
  init__createEscaper(), init__escapeMap(), escape_default = createEscaper(_escapeMap_default);
})), _unescapeMap_default, init__unescapeMap = __esmMin((() => {
  init_invert(), init__escapeMap(), _unescapeMap_default = invert(_escapeMap_default);
})), unescape_default, init_unescape = __esmMin((() => {
  init__createEscaper(), init__unescapeMap(), unescape_default = createEscaper(_unescapeMap_default);
})), templateSettings_default, init_templateSettings = __esmMin((() => {
  init_underscore(), templateSettings_default = _$1.templateSettings = { evaluate: /<%([\s\S]+?)%>/g, interpolate: /<%=([\s\S]+?)%>/g, escape: /<%-([\s\S]+?)%>/g };
}));
function escapeChar(t4) {
  return `\\` + escapes[t4];
}
function template(t4, n2, r2) {
  !n2 && r2 && (n2 = r2), n2 = defaults_default({}, n2, _$1.templateSettings);
  var i2 = RegExp([(n2.escape || noMatch).source, (n2.interpolate || noMatch).source, (n2.evaluate || noMatch).source].join(`|`) + `|$`, `g`), a2 = 0, o2 = `__p+='`;
  t4.replace(i2, function(n3, r3, i3, s3, c3) {
    return o2 += t4.slice(a2, c3).replace(escapeRegExp, escapeChar), a2 = c3 + n3.length, r3 ? o2 += `'+
((__t=(` + r3 + `))==null?'':_.escape(__t))+
'` : i3 ? o2 += `'+
((__t=(` + i3 + `))==null?'':__t)+
'` : s3 && (o2 += `';
` + s3 + `
__p+='`), n3;
  }), o2 += `';
`;
  var s2 = n2.variable;
  if (s2) {
    if (!bareIdentifier.test(s2)) throw Error(`variable is not a bare identifier: ` + s2);
  } else o2 = `with(obj||{}){
` + o2 + `}
`, s2 = `obj`;
  o2 = `var __t,__p='',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,'');};
` + o2 + `return __p;
`;
  var c2;
  try {
    c2 = Function(s2, `_`, o2);
  } catch (t5) {
    throw t5.source = o2, t5;
  }
  var l2 = function(t5) {
    return c2.call(this, t5, _$1);
  };
  return l2.source = `function(` + s2 + `){
` + o2 + `}`, l2;
}
var noMatch, escapes, escapeRegExp, bareIdentifier, init_template = __esmMin((() => {
  init_defaults(), init_underscore(), init_templateSettings(), noMatch = /(.)^/, escapes = { "'": `'`, "\\": `\\`, "\r": `r`, "\n": `n`, "\u2028": `u2028`, "\u2029": `u2029` }, escapeRegExp = /\\|'|\r|\n|\u2028|\u2029/g, bareIdentifier = /^\s*(\w|\$)+\s*$/;
}));
function result(t4, n2, r2) {
  n2 = toPath(n2);
  var i2 = n2.length;
  if (!i2) return isFunction_default(r2) ? r2.call(t4) : r2;
  for (var a2 = 0; a2 < i2; a2++) {
    var o2 = t4?.[n2[a2]];
    o2 === void 0 && (o2 = r2, a2 = i2), t4 = isFunction_default(o2) ? o2.call(t4) : o2;
  }
  return t4;
}
var init_result = __esmMin((() => {
  init_isFunction(), init__toPath();
}));
function uniqueId(t4) {
  var n2 = ++idCounter + ``;
  return t4 ? t4 + n2 : n2;
}
var idCounter, init_uniqueId = __esmMin((() => {
  idCounter = 0;
}));
function chain$1(t4) {
  var n2 = _$1(t4);
  return n2._chain = true, n2;
}
var init_chain = __esmMin((() => {
  init_underscore();
}));
function executeBound(t4, n2, r2, i2, a2) {
  if (!(i2 instanceof n2)) return t4.apply(r2, a2);
  var o2 = baseCreate(t4.prototype), s2 = t4.apply(o2, a2);
  return isObject(s2) ? s2 : o2;
}
var init__executeBound = __esmMin((() => {
  init__baseCreate(), init_isObject();
})), partial, init_partial = __esmMin((() => {
  init_restArguments(), init__executeBound(), init_underscore(), partial = restArguments(function(t4, n2) {
    var r2 = partial.placeholder, i2 = function() {
      for (var a2 = 0, o2 = n2.length, s2 = Array(o2), c2 = 0; c2 < o2; c2++) s2[c2] = n2[c2] === r2 ? arguments[a2++] : n2[c2];
      for (; a2 < arguments.length; ) s2.push(arguments[a2++]);
      return executeBound(t4, i2, this, this, s2);
    };
    return i2;
  }), partial.placeholder = _$1;
})), bind_default, init_bind = __esmMin((() => {
  init_restArguments(), init_isFunction(), init__executeBound(), bind_default = restArguments(function(t4, n2, r2) {
    if (!isFunction_default(t4)) throw TypeError(`Bind must be called on a function`);
    var i2 = restArguments(function(a2) {
      return executeBound(t4, i2, n2, this, r2.concat(a2));
    });
    return i2;
  });
})), _isArrayLike_default, init__isArrayLike = __esmMin((() => {
  init__createSizePropertyCheck(), init__getLength(), _isArrayLike_default = createSizePropertyCheck(_getLength_default);
}));
function flatten$3(t4, n2, r2, i2) {
  if (i2 ||= [], !n2 && n2 !== 0) n2 = 1 / 0;
  else if (n2 <= 0) return i2.concat(t4);
  for (var a2 = i2.length, o2 = 0, s2 = _getLength_default(t4); o2 < s2; o2++) {
    var c2 = t4[o2];
    if (_isArrayLike_default(c2) && (isArray_default(c2) || isArguments_default(c2))) if (n2 > 1) flatten$3(c2, n2 - 1, r2, i2), a2 = i2.length;
    else for (var l2 = 0, u2 = c2.length; l2 < u2; ) i2[a2++] = c2[l2++];
    else r2 || (i2[a2++] = c2);
  }
  return i2;
}
var init__flatten = __esmMin((() => {
  init__getLength(), init__isArrayLike(), init_isArray(), init_isArguments();
})), bindAll_default, init_bindAll = __esmMin((() => {
  init_restArguments(), init__flatten(), init_bind(), bindAll_default = restArguments(function(t4, n2) {
    n2 = flatten$3(n2, false, false);
    var r2 = n2.length;
    if (r2 < 1) throw Error(`bindAll must be passed function names`);
    for (; r2--; ) {
      var i2 = n2[r2];
      t4[i2] = bind_default(t4[i2], t4);
    }
    return t4;
  });
}));
function memoize(t4, n2) {
  var r2 = function(i2) {
    var a2 = r2.cache, o2 = `` + (n2 ? n2.apply(this, arguments) : i2);
    return has$1(a2, o2) || (a2[o2] = t4.apply(this, arguments)), a2[o2];
  };
  return r2.cache = {}, r2;
}
var init_memoize = __esmMin((() => {
  init__has();
})), delay_default, init_delay = __esmMin((() => {
  init_restArguments(), delay_default = restArguments(function(t4, n2, r2) {
    return setTimeout(function() {
      return t4.apply(null, r2);
    }, n2);
  });
})), defer_default, init_defer = __esmMin((() => {
  init_partial(), init_delay(), init_underscore(), defer_default = partial(delay_default, _$1, 1);
}));
function throttle(t4, n2, r2) {
  var i2, a2, o2, s2, c2 = 0;
  r2 ||= {};
  var l2 = function() {
    c2 = r2.leading === false ? 0 : now_default(), i2 = null, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null);
  }, u2 = function() {
    var u3 = now_default();
    !c2 && r2.leading === false && (c2 = u3);
    var d2 = n2 - (u3 - c2);
    return a2 = this, o2 = arguments, d2 <= 0 || d2 > n2 ? (i2 &&= (clearTimeout(i2), null), c2 = u3, s2 = t4.apply(a2, o2), i2 || (a2 = o2 = null)) : !i2 && r2.trailing !== false && (i2 = setTimeout(l2, d2)), s2;
  };
  return u2.cancel = function() {
    clearTimeout(i2), c2 = 0, i2 = a2 = o2 = null;
  }, u2;
}
var init_throttle = __esmMin((() => {
  init_now();
}));
function debounce(t4, n2, r2) {
  var i2, a2, o2, s2, c2, l2 = function() {
    var u3 = now_default() - a2;
    n2 > u3 ? i2 = setTimeout(l2, n2 - u3) : (i2 = null, r2 || (s2 = t4.apply(c2, o2)), i2 || (o2 = c2 = null));
  }, u2 = restArguments(function(u3) {
    return c2 = this, o2 = u3, a2 = now_default(), i2 || (i2 = setTimeout(l2, n2), r2 && (s2 = t4.apply(c2, o2))), s2;
  });
  return u2.cancel = function() {
    clearTimeout(i2), i2 = o2 = c2 = null;
  }, u2;
}
var init_debounce = __esmMin((() => {
  init_restArguments(), init_now();
}));
function wrap(t4, n2) {
  return partial(n2, t4);
}
var init_wrap = __esmMin((() => {
  init_partial();
}));
function negate(t4) {
  return function() {
    return !t4.apply(this, arguments);
  };
}
var init_negate = __esmMin((() => {
}));
function compose() {
  var t4 = arguments, n2 = t4.length - 1;
  return function() {
    for (var r2 = n2, i2 = t4[n2].apply(this, arguments); r2--; ) i2 = t4[r2].call(this, i2);
    return i2;
  };
}
var init_compose = __esmMin((() => {
}));
function after(t4, n2) {
  return function() {
    if (--t4 < 1) return n2.apply(this, arguments);
  };
}
var init_after = __esmMin((() => {
}));
function before(t4, n2) {
  var r2;
  return function() {
    return --t4 > 0 && (r2 = n2.apply(this, arguments)), t4 <= 1 && (n2 = null), r2;
  };
}
var init_before = __esmMin((() => {
})), once_default, init_once = __esmMin((() => {
  init_partial(), init_before(), once_default = partial(before, 2);
}));
function findKey(t4, n2, r2) {
  n2 = cb(n2, r2);
  for (var i2 = keys(t4), a2, o2 = 0, s2 = i2.length; o2 < s2; o2++) if (a2 = i2[o2], n2(t4[a2], a2, t4)) return a2;
}
var init_findKey = __esmMin((() => {
  init__cb(), init_keys();
}));
function createPredicateIndexFinder(t4) {
  return function(n2, r2, i2) {
    r2 = cb(r2, i2);
    for (var a2 = _getLength_default(n2), o2 = t4 > 0 ? 0 : a2 - 1; o2 >= 0 && o2 < a2; o2 += t4) if (r2(n2[o2], o2, n2)) return o2;
    return -1;
  };
}
var init__createPredicateIndexFinder = __esmMin((() => {
  init__cb(), init__getLength();
})), findIndex_default, init_findIndex = __esmMin((() => {
  init__createPredicateIndexFinder(), findIndex_default = createPredicateIndexFinder(1);
})), findLastIndex_default, init_findLastIndex = __esmMin((() => {
  init__createPredicateIndexFinder(), findLastIndex_default = createPredicateIndexFinder(-1);
}));
function sortedIndex(t4, n2, r2, i2) {
  r2 = cb(r2, i2, 1);
  for (var a2 = r2(n2), o2 = 0, s2 = _getLength_default(t4); o2 < s2; ) {
    var c2 = Math.floor((o2 + s2) / 2);
    r2(t4[c2]) < a2 ? o2 = c2 + 1 : s2 = c2;
  }
  return o2;
}
var init_sortedIndex = __esmMin((() => {
  init__cb(), init__getLength();
}));
function createIndexFinder(t4, n2, r2) {
  return function(i2, a2, o2) {
    var s2 = 0, c2 = _getLength_default(i2);
    if (typeof o2 == `number`) t4 > 0 ? s2 = o2 >= 0 ? o2 : Math.max(o2 + c2, s2) : c2 = o2 >= 0 ? Math.min(o2 + 1, c2) : o2 + c2 + 1;
    else if (r2 && o2 && c2) return o2 = r2(i2, a2), i2[o2] === a2 ? o2 : -1;
    if (a2 !== a2) return o2 = n2(slice.call(i2, s2, c2), isNaN$1), o2 >= 0 ? o2 + s2 : -1;
    for (o2 = t4 > 0 ? s2 : c2 - 1; o2 >= 0 && o2 < c2; o2 += t4) if (i2[o2] === a2) return o2;
    return -1;
  };
}
var init__createIndexFinder = __esmMin((() => {
  init__getLength(), init__setup(), init_isNaN();
})), indexOf_default, init_indexOf = __esmMin((() => {
  init_sortedIndex(), init_findIndex(), init__createIndexFinder(), indexOf_default = createIndexFinder(1, findIndex_default, sortedIndex);
})), lastIndexOf_default, init_lastIndexOf = __esmMin((() => {
  init_findLastIndex(), init__createIndexFinder(), lastIndexOf_default = createIndexFinder(-1, findLastIndex_default);
}));
function find(t4, n2, r2) {
  var i2 = (_isArrayLike_default(t4) ? findIndex_default : findKey)(t4, n2, r2);
  if (i2 !== void 0 && i2 !== -1) return t4[i2];
}
var init_find = __esmMin((() => {
  init__isArrayLike(), init_findIndex(), init_findKey();
}));
function findWhere(t4, n2) {
  return find(t4, matcher(n2));
}
var init_findWhere = __esmMin((() => {
  init_find(), init_matcher();
}));
function each(t4, n2, r2) {
  n2 = optimizeCb(n2, r2);
  var i2, a2;
  if (_isArrayLike_default(t4)) for (i2 = 0, a2 = t4.length; i2 < a2; i2++) n2(t4[i2], i2, t4);
  else {
    var o2 = keys(t4);
    for (i2 = 0, a2 = o2.length; i2 < a2; i2++) n2(t4[o2[i2]], o2[i2], t4);
  }
  return t4;
}
var init_each = __esmMin((() => {
  init__optimizeCb(), init__isArrayLike(), init_keys();
}));
function map(t4, n2, r2) {
  n2 = cb(n2, r2);
  for (var i2 = !_isArrayLike_default(t4) && keys(t4), a2 = (i2 || t4).length, o2 = Array(a2), s2 = 0; s2 < a2; s2++) {
    var c2 = i2 ? i2[s2] : s2;
    o2[s2] = n2(t4[c2], c2, t4);
  }
  return o2;
}
var init_map = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function createReduce(t4) {
  var n2 = function(n3, r2, i2, a2) {
    var o2 = !_isArrayLike_default(n3) && keys(n3), s2 = (o2 || n3).length, c2 = t4 > 0 ? 0 : s2 - 1;
    for (a2 || (i2 = n3[o2 ? o2[c2] : c2], c2 += t4); c2 >= 0 && c2 < s2; c2 += t4) {
      var l2 = o2 ? o2[c2] : c2;
      i2 = r2(i2, n3[l2], l2, n3);
    }
    return i2;
  };
  return function(t5, r2, i2, a2) {
    var o2 = arguments.length >= 3;
    return n2(t5, optimizeCb(r2, a2, 4), i2, o2);
  };
}
var init__createReduce = __esmMin((() => {
  init__isArrayLike(), init_keys(), init__optimizeCb();
})), reduce_default, init_reduce = __esmMin((() => {
  init__createReduce(), reduce_default = createReduce(1);
})), reduceRight_default, init_reduceRight = __esmMin((() => {
  init__createReduce(), reduceRight_default = createReduce(-1);
}));
function filter(t4, n2, r2) {
  var i2 = [];
  return n2 = cb(n2, r2), each(t4, function(t5, r3, a2) {
    n2(t5, r3, a2) && i2.push(t5);
  }), i2;
}
var init_filter = __esmMin((() => {
  init__cb(), init_each();
}));
function reject(t4, n2, r2) {
  return filter(t4, negate(cb(n2)), r2);
}
var init_reject = __esmMin((() => {
  init_filter(), init_negate(), init__cb();
}));
function every(t4, n2, r2) {
  n2 = cb(n2, r2);
  for (var i2 = !_isArrayLike_default(t4) && keys(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (!n2(t4[s2], s2, t4)) return false;
  }
  return true;
}
var init_every = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function some(t4, n2, r2) {
  n2 = cb(n2, r2);
  for (var i2 = !_isArrayLike_default(t4) && keys(t4), a2 = (i2 || t4).length, o2 = 0; o2 < a2; o2++) {
    var s2 = i2 ? i2[o2] : o2;
    if (n2(t4[s2], s2, t4)) return true;
  }
  return false;
}
var init_some = __esmMin((() => {
  init__cb(), init__isArrayLike(), init_keys();
}));
function contains$2(t4, n2, r2, i2) {
  return _isArrayLike_default(t4) || (t4 = values(t4)), (typeof r2 != `number` || i2) && (r2 = 0), indexOf_default(t4, n2, r2) >= 0;
}
var init_contains = __esmMin((() => {
  init__isArrayLike(), init_values(), init_indexOf();
})), invoke_default, init_invoke = __esmMin((() => {
  init_restArguments(), init_isFunction(), init_map(), init__deepGet(), init__toPath(), invoke_default = restArguments(function(t4, n2, r2) {
    var i2, a2;
    return isFunction_default(n2) ? a2 = n2 : (n2 = toPath(n2), i2 = n2.slice(0, -1), n2 = n2[n2.length - 1]), map(t4, function(t5) {
      var o2 = a2;
      if (!o2) {
        if (i2 && i2.length && (t5 = deepGet(t5, i2)), t5 == null) return;
        o2 = t5[n2];
      }
      return o2 == null ? o2 : o2.apply(t5, r2);
    });
  });
}));
function pluck(t4, n2) {
  return map(t4, property(n2));
}
var init_pluck = __esmMin((() => {
  init_map(), init_property();
}));
function where(t4, n2) {
  return filter(t4, matcher(n2));
}
var init_where = __esmMin((() => {
  init_filter(), init_matcher();
}));
function max$2(t4, n2, r2) {
  var i2 = -1 / 0, a2 = -1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default(t4) ? t4 : values(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 > i2 && (i2 = o2);
  } else n2 = cb(n2, r2), each(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 > a2 || s2 === -1 / 0 && i2 === -1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_max = __esmMin((() => {
  init__isArrayLike(), init_values(), init__cb(), init_each();
}));
function min$2(t4, n2, r2) {
  var i2 = 1 / 0, a2 = 1 / 0, o2, s2;
  if (n2 == null || typeof n2 == `number` && typeof t4[0] != `object` && t4 != null) {
    t4 = _isArrayLike_default(t4) ? t4 : values(t4);
    for (var c2 = 0, l2 = t4.length; c2 < l2; c2++) o2 = t4[c2], o2 != null && o2 < i2 && (i2 = o2);
  } else n2 = cb(n2, r2), each(t4, function(t5, r3, o3) {
    s2 = n2(t5, r3, o3), (s2 < a2 || s2 === 1 / 0 && i2 === 1 / 0) && (i2 = t5, a2 = s2);
  });
  return i2;
}
var init_min = __esmMin((() => {
  init__isArrayLike(), init_values(), init__cb(), init_each();
}));
function toArray$1(t4) {
  return t4 ? isArray_default(t4) ? slice.call(t4) : isString_default(t4) ? t4.match(reStrSymbol) : _isArrayLike_default(t4) ? map(t4, identity$1) : values(t4) : [];
}
var reStrSymbol, init_toArray = __esmMin((() => {
  init_isArray(), init__setup(), init_isString(), init__isArrayLike(), init_map(), init_identity(), init_values(), reStrSymbol = /[^\ud800-\udfff]|[\ud800-\udbff][\udc00-\udfff]|[\ud800-\udfff]/g;
}));
function sample(t4, n2, r2) {
  if (n2 == null || r2) return _isArrayLike_default(t4) || (t4 = values(t4)), t4[random(t4.length - 1)];
  var i2 = toArray$1(t4), a2 = _getLength_default(i2);
  n2 = Math.max(Math.min(n2, a2), 0);
  for (var o2 = a2 - 1, s2 = 0; s2 < n2; s2++) {
    var c2 = random(s2, o2), l2 = i2[s2];
    i2[s2] = i2[c2], i2[c2] = l2;
  }
  return i2.slice(0, n2);
}
var init_sample = __esmMin((() => {
  init__isArrayLike(), init_values(), init__getLength(), init_random(), init_toArray();
}));
function shuffle(t4) {
  return sample(t4, 1 / 0);
}
var init_shuffle = __esmMin((() => {
  init_sample();
}));
function sortBy(t4, n2, r2) {
  var i2 = 0;
  return n2 = cb(n2, r2), pluck(map(t4, function(t5, r3, a2) {
    return { value: t5, index: i2++, criteria: n2(t5, r3, a2) };
  }).sort(function(t5, n3) {
    var r3 = t5.criteria, i3 = n3.criteria;
    if (r3 !== i3) {
      if (r3 > i3 || r3 === void 0) return 1;
      if (r3 < i3 || i3 === void 0) return -1;
    }
    return t5.index - n3.index;
  }), `value`);
}
var init_sortBy = __esmMin((() => {
  init__cb(), init_pluck(), init_map();
}));
function group$2(t4, n2) {
  return function(r2, i2, a2) {
    var o2 = n2 ? [[], []] : {};
    return i2 = cb(i2, a2), each(r2, function(n3, a3) {
      t4(o2, n3, i2(n3, a3, r2));
    }), o2;
  };
}
var init__group = __esmMin((() => {
  init__cb(), init_each();
})), groupBy_default, init_groupBy = __esmMin((() => {
  init__group(), init__has(), groupBy_default = group$2(function(t4, n2, r2) {
    has$1(t4, r2) ? t4[r2].push(n2) : t4[r2] = [n2];
  });
})), indexBy_default, init_indexBy = __esmMin((() => {
  init__group(), indexBy_default = group$2(function(t4, n2, r2) {
    t4[r2] = n2;
  });
})), countBy_default, init_countBy = __esmMin((() => {
  init__group(), init__has(), countBy_default = group$2(function(t4, n2, r2) {
    has$1(t4, r2) ? t4[r2]++ : t4[r2] = 1;
  });
})), partition_default, init_partition = __esmMin((() => {
  init__group(), partition_default = group$2(function(t4, n2, r2) {
    t4[+!r2].push(n2);
  }, true);
}));
function size$2(t4) {
  return t4 == null ? 0 : _isArrayLike_default(t4) ? t4.length : keys(t4).length;
}
var init_size = __esmMin((() => {
  init__isArrayLike(), init_keys();
}));
function keyInObj(t4, n2, r2) {
  return n2 in r2;
}
var init__keyInObj = __esmMin((() => {
})), pick_default, init_pick = __esmMin((() => {
  init_restArguments(), init_isFunction(), init__optimizeCb(), init_allKeys(), init__keyInObj(), init__flatten(), pick_default = restArguments(function(t4, n2) {
    var r2 = {}, i2 = n2[0];
    if (t4 == null) return r2;
    isFunction_default(i2) ? (n2.length > 1 && (i2 = optimizeCb(i2, n2[1])), n2 = allKeys(t4)) : (i2 = keyInObj, n2 = flatten$3(n2, false, false), t4 = Object(t4));
    for (var a2 = 0, o2 = n2.length; a2 < o2; a2++) {
      var s2 = n2[a2], c2 = t4[s2];
      i2(c2, s2, t4) && (r2[s2] = c2);
    }
    return r2;
  });
})), omit_default, init_omit = __esmMin((() => {
  init_restArguments(), init_isFunction(), init_negate(), init_map(), init__flatten(), init_contains(), init_pick(), omit_default = restArguments(function(t4, n2) {
    var r2 = n2[0], i2;
    return isFunction_default(r2) ? (r2 = negate(r2), n2.length > 1 && (i2 = n2[1])) : (n2 = map(flatten$3(n2, false, false), String), r2 = function(t5, r3) {
      return !contains$2(n2, r3);
    }), pick_default(t4, r2, i2);
  });
}));
function initial(t4, n2, r2) {
  return slice.call(t4, 0, Math.max(0, t4.length - (n2 == null || r2 ? 1 : n2)));
}
var init_initial = __esmMin((() => {
  init__setup();
}));
function first(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[0] : initial(t4, t4.length - n2);
}
var init_first = __esmMin((() => {
  init_initial();
}));
function rest(t4, n2, r2) {
  return slice.call(t4, n2 == null || r2 ? 1 : n2);
}
var init_rest = __esmMin((() => {
  init__setup();
}));
function last(t4, n2, r2) {
  return t4 == null || t4.length < 1 ? n2 == null || r2 ? void 0 : [] : n2 == null || r2 ? t4[t4.length - 1] : rest(t4, Math.max(0, t4.length - n2));
}
var init_last = __esmMin((() => {
  init_rest();
}));
function compact(t4) {
  return filter(t4, Boolean);
}
var init_compact = __esmMin((() => {
  init_filter();
}));
function flatten$2(t4, n2) {
  return flatten$3(t4, n2, false);
}
var init_flatten = __esmMin((() => {
  init__flatten();
})), difference_default, init_difference = __esmMin((() => {
  init_restArguments(), init__flatten(), init_filter(), init_contains(), difference_default = restArguments(function(t4, n2) {
    return n2 = flatten$3(n2, true, true), filter(t4, function(t5) {
      return !contains$2(n2, t5);
    });
  });
})), without_default, init_without = __esmMin((() => {
  init_restArguments(), init_difference(), without_default = restArguments(function(t4, n2) {
    return difference_default(t4, n2);
  });
}));
function uniq(t4, n2, r2, i2) {
  isBoolean(n2) || (i2 = r2, r2 = n2, n2 = false), r2 != null && (r2 = cb(r2, i2));
  for (var a2 = [], o2 = [], s2 = 0, c2 = _getLength_default(t4); s2 < c2; s2++) {
    var l2 = t4[s2], u2 = r2 ? r2(l2, s2, t4) : l2;
    n2 && !r2 ? ((!s2 || o2 !== u2) && a2.push(l2), o2 = u2) : r2 ? contains$2(o2, u2) || (o2.push(u2), a2.push(l2)) : contains$2(a2, l2) || a2.push(l2);
  }
  return a2;
}
var init_uniq = __esmMin((() => {
  init_isBoolean(), init__cb(), init__getLength(), init_contains();
})), union_default, init_union = __esmMin((() => {
  init_restArguments(), init_uniq(), init__flatten(), union_default = restArguments(function(t4) {
    return uniq(flatten$3(t4, true, true));
  });
}));
function intersection(t4) {
  for (var n2 = [], r2 = arguments.length, i2 = 0, a2 = _getLength_default(t4); i2 < a2; i2++) {
    var o2 = t4[i2];
    if (!contains$2(n2, o2)) {
      var s2;
      for (s2 = 1; s2 < r2 && contains$2(arguments[s2], o2); s2++) ;
      s2 === r2 && n2.push(o2);
    }
  }
  return n2;
}
var init_intersection = __esmMin((() => {
  init__getLength(), init_contains();
}));
function unzip(t4) {
  for (var n2 = t4 && max$2(t4, _getLength_default).length || 0, r2 = Array(n2), i2 = 0; i2 < n2; i2++) r2[i2] = pluck(t4, i2);
  return r2;
}
var init_unzip = __esmMin((() => {
  init_max(), init__getLength(), init_pluck();
})), zip_default, init_zip = __esmMin((() => {
  init_restArguments(), init_unzip(), zip_default = restArguments(unzip);
}));
function object(t4, n2) {
  for (var r2 = {}, i2 = 0, a2 = _getLength_default(t4); i2 < a2; i2++) n2 ? r2[t4[i2]] = n2[i2] : r2[t4[i2][0]] = t4[i2][1];
  return r2;
}
var init_object = __esmMin((() => {
  init__getLength();
}));
function range(t4, n2, r2) {
  n2 ?? (n2 = t4 || 0, t4 = 0), r2 ||= n2 < t4 ? -1 : 1;
  for (var i2 = Math.max(Math.ceil((n2 - t4) / r2), 0), a2 = Array(i2), o2 = 0; o2 < i2; o2++, t4 += r2) a2[o2] = t4;
  return a2;
}
var init_range = __esmMin((() => {
}));
function chunk(t4, n2) {
  if (n2 == null || n2 < 1) return [];
  for (var r2 = [], i2 = 0, a2 = t4.length; i2 < a2; ) r2.push(slice.call(t4, i2, i2 += n2));
  return r2;
}
var init_chunk = __esmMin((() => {
  init__setup();
}));
function chainResult(t4, n2) {
  return t4._chain ? _$1(n2).chain() : n2;
}
var init__chainResult = __esmMin((() => {
  init_underscore();
}));
function mixin(t4) {
  return each(functions$1(t4), function(n2) {
    var r2 = _$1[n2] = t4[n2];
    _$1.prototype[n2] = function() {
      var t5 = [this._wrapped];
      return push$1.apply(t5, arguments), chainResult(this, r2.apply(_$1, t5));
    };
  }), _$1;
}
var init_mixin = __esmMin((() => {
  init_underscore(), init_each(), init_functions(), init__setup(), init__chainResult();
})), underscore_array_methods_default, init_underscore_array_methods = __esmMin((() => {
  init_underscore(), init_each(), init__setup(), init__chainResult(), each([`pop`, `push`, `reverse`, `shift`, `sort`, `splice`, `unshift`], function(t4) {
    var n2 = ArrayProto[t4];
    _$1.prototype[t4] = function() {
      var r2 = this._wrapped;
      return r2 != null && (n2.apply(r2, arguments), (t4 === `shift` || t4 === `splice`) && r2.length === 0 && delete r2[0]), chainResult(this, r2);
    };
  }), each([`concat`, `join`, `slice`], function(t4) {
    var n2 = ArrayProto[t4];
    _$1.prototype[t4] = function() {
      var t5 = this._wrapped;
      return t5 != null && (t5 = n2.apply(t5, arguments)), chainResult(this, t5);
    };
  }), underscore_array_methods_default = _$1;
})), modules_exports = __exportAll({ VERSION: () => VERSION, after: () => after, all: () => every, allKeys: () => allKeys, any: () => some, assign: () => extendOwn_default, before: () => before, bind: () => bind_default, bindAll: () => bindAll_default, chain: () => chain$1, chunk: () => chunk, clone: () => clone, collect: () => map, compact: () => compact, compose: () => compose, constant: () => constant, contains: () => contains$2, countBy: () => countBy_default, create: () => create, debounce: () => debounce, default: () => underscore_array_methods_default, defaults: () => defaults_default, defer: () => defer_default, delay: () => delay_default, detect: () => find, difference: () => difference_default, drop: () => rest, each: () => each, escape: () => escape_default, every: () => every, extend: () => extend_default, extendOwn: () => extendOwn_default, filter: () => filter, find: () => find, findIndex: () => findIndex_default, findKey: () => findKey, findLastIndex: () => findLastIndex_default, findWhere: () => findWhere, first: () => first, flatten: () => flatten$2, foldl: () => reduce_default, foldr: () => reduceRight_default, forEach: () => each, functions: () => functions$1, get: () => get, groupBy: () => groupBy_default, has: () => has, head: () => first, identity: () => identity$1, include: () => contains$2, includes: () => contains$2, indexBy: () => indexBy_default, indexOf: () => indexOf_default, initial: () => initial, inject: () => reduce_default, intersection: () => intersection, invert: () => invert, invoke: () => invoke_default, isArguments: () => isArguments_default, isArray: () => isArray_default, isArrayBuffer: () => isArrayBuffer_default, isBoolean: () => isBoolean, isDataView: () => isDataView_default, isDate: () => isDate_default, isElement: () => isElement$3, isEmpty: () => isEmpty, isEqual: () => isEqual, isError: () => isError_default, isFinite: () => isFinite$1, isFunction: () => isFunction_default, isMap: () => isMap_default, isMatch: () => isMatch, isNaN: () => isNaN$1, isNull: () => isNull, isNumber: () => isNumber_default, isObject: () => isObject, isRegExp: () => isRegExp_default, isSet: () => isSet_default, isString: () => isString_default, isSymbol: () => isSymbol_default, isTypedArray: () => isTypedArray_default, isUndefined: () => isUndefined, isWeakMap: () => isWeakMap_default, isWeakSet: () => isWeakSet_default, iteratee: () => iteratee, keys: () => keys, last: () => last, lastIndexOf: () => lastIndexOf_default, map: () => map, mapObject: () => mapObject, matcher: () => matcher, matches: () => matcher, max: () => max$2, memoize: () => memoize, methods: () => functions$1, min: () => min$2, mixin: () => mixin, negate: () => negate, noop: () => noop$2, now: () => now_default, object: () => object, omit: () => omit_default, once: () => once_default, pairs: () => pairs, partial: () => partial, partition: () => partition_default, pick: () => pick_default, pluck: () => pluck, property: () => property, propertyOf: () => propertyOf, random: () => random, range: () => range, reduce: () => reduce_default, reduceRight: () => reduceRight_default, reject: () => reject, rest: () => rest, restArguments: () => restArguments, result: () => result, sample: () => sample, select: () => filter, shuffle: () => shuffle, size: () => size$2, some: () => some, sortBy: () => sortBy, sortedIndex: () => sortedIndex, tail: () => rest, take: () => first, tap: () => tap, template: () => template, templateSettings: () => templateSettings_default, throttle: () => throttle, times: () => times, toArray: () => toArray$1, toPath: () => toPath$1, transpose: () => unzip, unescape: () => unescape_default, union: () => union_default, uniq: () => uniq, unique: () => uniq, uniqueId: () => uniqueId, unzip: () => unzip, values: () => values, where: () => where, without: () => without_default, wrap: () => wrap, zip: () => zip_default }), init_modules = __esmMin((() => {
  init__setup(), init_restArguments(), init_isObject(), init_isNull(), init_isUndefined(), init_isBoolean(), init_isElement(), init_isString(), init_isNumber(), init_isDate(), init_isRegExp(), init_isError(), init_isSymbol(), init_isArrayBuffer(), init_isDataView(), init_isArray(), init_isFunction(), init_isArguments(), init_isFinite(), init_isNaN(), init_isTypedArray(), init_isEmpty(), init_isMatch(), init_isEqual(), init_isMap(), init_isWeakMap(), init_isSet(), init_isWeakSet(), init_keys(), init_allKeys(), init_values(), init_pairs(), init_invert(), init_functions(), init_extend(), init_extendOwn(), init_defaults(), init_create(), init_clone(), init_tap(), init_get(), init_has(), init_mapObject(), init_identity(), init_constant(), init_noop(), init_toPath(), init_property(), init_propertyOf(), init_matcher(), init_times(), init_random(), init_now(), init_escape(), init_unescape(), init_templateSettings(), init_template(), init_result(), init_uniqueId(), init_chain(), init_iteratee(), init_partial(), init_bind(), init_bindAll(), init_memoize(), init_delay(), init_defer(), init_throttle(), init_debounce(), init_wrap(), init_negate(), init_compose(), init_after(), init_before(), init_once(), init_findKey(), init_findIndex(), init_findLastIndex(), init_sortedIndex(), init_indexOf(), init_lastIndexOf(), init_find(), init_findWhere(), init_each(), init_map(), init_reduce(), init_reduceRight(), init_filter(), init_reject(), init_every(), init_some(), init_contains(), init_invoke(), init_pluck(), init_where(), init_max(), init_min(), init_shuffle(), init_sample(), init_sortBy(), init_groupBy(), init_indexBy(), init_countBy(), init_partition(), init_toArray(), init_size(), init_pick(), init_omit(), init_first(), init_initial(), init_last(), init_rest(), init_compact(), init_flatten(), init_without(), init_uniq(), init_union(), init_intersection(), init_difference(), init_unzip(), init_zip(), init_object(), init_range(), init_chunk(), init_mixin(), init_underscore_array_methods();
})), _, init_index_default = __esmMin((() => {
  init_modules(), _ = mixin(modules_exports), _._ = _;
})), index_all_exports = __exportAll({ VERSION: () => VERSION, after: () => after, all: () => every, allKeys: () => allKeys, any: () => some, assign: () => extendOwn_default, before: () => before, bind: () => bind_default, bindAll: () => bindAll_default, chain: () => chain$1, chunk: () => chunk, clone: () => clone, collect: () => map, compact: () => compact, compose: () => compose, constant: () => constant, contains: () => contains$2, countBy: () => countBy_default, create: () => create, debounce: () => debounce, default: () => _, defaults: () => defaults_default, defer: () => defer_default, delay: () => delay_default, detect: () => find, difference: () => difference_default, drop: () => rest, each: () => each, escape: () => escape_default, every: () => every, extend: () => extend_default, extendOwn: () => extendOwn_default, filter: () => filter, find: () => find, findIndex: () => findIndex_default, findKey: () => findKey, findLastIndex: () => findLastIndex_default, findWhere: () => findWhere, first: () => first, flatten: () => flatten$2, foldl: () => reduce_default, foldr: () => reduceRight_default, forEach: () => each, functions: () => functions$1, get: () => get, groupBy: () => groupBy_default, has: () => has, head: () => first, identity: () => identity$1, include: () => contains$2, includes: () => contains$2, indexBy: () => indexBy_default, indexOf: () => indexOf_default, initial: () => initial, inject: () => reduce_default, intersection: () => intersection, invert: () => invert, invoke: () => invoke_default, isArguments: () => isArguments_default, isArray: () => isArray_default, isArrayBuffer: () => isArrayBuffer_default, isBoolean: () => isBoolean, isDataView: () => isDataView_default, isDate: () => isDate_default, isElement: () => isElement$3, isEmpty: () => isEmpty, isEqual: () => isEqual, isError: () => isError_default, isFinite: () => isFinite$1, isFunction: () => isFunction_default, isMap: () => isMap_default, isMatch: () => isMatch, isNaN: () => isNaN$1, isNull: () => isNull, isNumber: () => isNumber_default, isObject: () => isObject, isRegExp: () => isRegExp_default, isSet: () => isSet_default, isString: () => isString_default, isSymbol: () => isSymbol_default, isTypedArray: () => isTypedArray_default, isUndefined: () => isUndefined, isWeakMap: () => isWeakMap_default, isWeakSet: () => isWeakSet_default, iteratee: () => iteratee, keys: () => keys, last: () => last, lastIndexOf: () => lastIndexOf_default, map: () => map, mapObject: () => mapObject, matcher: () => matcher, matches: () => matcher, max: () => max$2, memoize: () => memoize, methods: () => functions$1, min: () => min$2, mixin: () => mixin, negate: () => negate, noop: () => noop$2, now: () => now_default, object: () => object, omit: () => omit_default, once: () => once_default, pairs: () => pairs, partial: () => partial, partition: () => partition_default, pick: () => pick_default, pluck: () => pluck, property: () => property, propertyOf: () => propertyOf, random: () => random, range: () => range, reduce: () => reduce_default, reduceRight: () => reduceRight_default, reject: () => reject, rest: () => rest, restArguments: () => restArguments, result: () => result, sample: () => sample, select: () => filter, shuffle: () => shuffle, size: () => size$2, some: () => some, sortBy: () => sortBy, sortedIndex: () => sortedIndex, tail: () => rest, take: () => first, tap: () => tap, template: () => template, templateSettings: () => templateSettings_default, throttle: () => throttle, times: () => times, toArray: () => toArray$1, toPath: () => toPath$1, transpose: () => unzip, unescape: () => unescape_default, union: () => union_default, uniq: () => uniq, unique: () => uniq, uniqueId: () => uniqueId, unzip: () => unzip, values: () => values, where: () => where, without: () => without_default, wrap: () => wrap, zip: () => zip_default }), init_index_all = __esmMin((() => {
  init_index_default(), init_modules();
}));
init_index_all();
var nonTupleVectorOperators = [`vector`, `altvector`];
function coerce_tuple_array_vectors({ operator1: t4, operator2: n2, operands1: r2, operands2: i2, coerce_tuples_arrays: a2, coerce_vectors: o2 }) {
  let s2 = t4 === n2;
  if (!s2) {
    if (a2) {
      if (t4 === `tuple`) {
        if (nonTupleVectorOperators.includes(n2)) t4 = n2, s2 = true;
        else if (n2 === `interval` && r2.length === 2) {
          let n3 = i2[1];
          n3[1] || n3[2] || (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, false, false]]);
        }
      } else if (n2 === `tuple`) {
        if (nonTupleVectorOperators.includes(t4)) n2 = t4, s2 = true;
        else if (t4 === `interval` && i2.length === 2) {
          let t5 = r2[1];
          t5[1] || t5[2] || (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, false, false]]);
        }
      }
      if (!s2) {
        if (t4 === `array` && r2.length === 2) {
          if (n2 === `interval`) {
            let n3 = i2[1];
            n3[1] && n3[2] && (s2 = true, t4 = `interval`, r2 = [[`tuple`, ...r2], [`tuple`, true, true]]);
          }
        } else if (n2 === `array` && i2.length === 2 && t4 === `interval`) {
          let t5 = r2[1];
          t5[1] && t5[2] && (s2 = true, n2 = `interval`, i2 = [[`tuple`, ...i2], [`tuple`, true, true]]);
        }
      }
    }
    !s2 && o2 && nonTupleVectorOperators.includes(t4) && nonTupleVectorOperators.includes(n2) && (s2 = true, t4 = n2 = `vector`);
  }
  return { operator1: t4, operator2: n2, operands1: r2, operands2: i2 };
}
function handleNaNInfinityStringify(t4, n2) {
  return n2 === n2 ? n2 === 1 / 0 ? `1/0` : n2 === -1 / 0 ? `-1/0` : n2 : `0/0`;
}
function handleNaNInfinityParse(t4, n2) {
  return n2 === `0/0` ? NaN : n2 === `1/0` ? 1 / 0 : n2 === `-1/0` ? -1 / 0 : n2;
}
function deepClone(t4) {
  return JSON.parse(JSON.stringify(t4, handleNaNInfinityStringify), handleNaNInfinityParse);
}
var equal = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, coerce_tuples_arrays: o2 = true, coerce_vectors: s2 = true } = {}) {
  if (!(Array.isArray(t4) && Array.isArray(n2))) {
    if (typeof t4 != typeof n2) return false;
    if (typeof t4 == `number` && Number.isFinite(t4)) {
      let i3 = 1e-14, o3 = Math.min(Math.abs(t4), Math.abs(n2));
      return a2 ? (i3 *= o3, r2 > i3 && (i3 = r2)) : (r2 > i3 && (i3 = r2), i3 *= o3), Math.abs(t4 - n2) <= i3;
    }
    return t4 === n2;
  }
  var c2 = t4[0], l2 = t4.slice(1), u2 = n2[0], d2 = n2.slice(1);
  return c2 !== u2 && ({ operator1: c2, operator2: u2, operands1: l2, operands2: d2 } = coerce_tuple_array_vectors({ operator1: c2, operator2: u2, operands1: l2, operands2: d2, coerce_tuples_arrays: o2, coerce_vectors: s2 })), c2 !== u2 || l2.length !== d2.length ? false : r2 > 0 && !i2 && c2 === `^` ? equal(l2[0], d2[0], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 }) ? equal(l2[1], d2[1], { coerce_tuples_arrays: o2, coerce_vectors: s2 }) : false : _.every(_.zip(l2, d2), function(t5) {
    return equal(t5[0], t5[1], { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: o2, coerce_vectors: s2 });
  });
}, match$1 = function(t4, n2, r2) {
  var i2 = false;
  r2 === void 0 ? r2 = {} : r2.allow_extended_match && (i2 = true, r2 = Object.assign({}, r2), delete r2.allow_extended_match);
  var a2 = r2.variables;
  if (a2 === void 0) {
    a2 = {};
    let t5 = variables(n2);
    for (let n3 = 0; n3 < t5.length; n3++) a2[t5[n3]] = true;
    r2 = Object.assign({}, r2), r2.variables = a2;
  }
  if (n2 in a2) {
    let r3 = a2[n2];
    if (r3 !== true) if (r3 instanceof RegExp) {
      if (typeof t4 == `string`) {
        if (!t4.match(r3)) return false;
      } else if (!JSON.stringify(t4).match(r3)) return false;
    } else if (typeof a2[n2] == `function`) {
      if (!a2[n2](t4)) return false;
    } else return false;
    let i3 = {};
    return i3[n2] = t4, i3;
  }
  if (r2.allow_permutations && (t4 = default_order(t4), n2 = default_order(n2)), !Array.isArray(n2)) return t4 === n2 ? {} : false;
  var o2 = allChildren(t4), s2 = n2[0], c2 = n2.slice(1);
  if (!Array.isArray(t4) || t4[0] !== s2 || o2.length < c2.length) {
    if (Array.isArray(r2.allow_implicit_identities)) {
      let i3 = matchImplicitIdentity(t4, n2, r2);
      if (i3) return i3;
    }
    if (s2 === `*` && Array.isArray(t4) && t4[0] === `-` && Array.isArray(t4[1]) && t4[1][0] === `*`) o2 = allChildren(t4[1]), o2[0] = [`-`, o2[0]];
    else return false;
  }
  return matchOperands(s2, o2, c2, r2, i2) || (Array.isArray(r2.allow_implicit_identities) ? matchImplicitIdentity([s2].concat(o2), n2, r2) : false);
};
function matchOperands(t4, n2, r2, i2, a2) {
  var o2 = r2.map((t5) => ({})), s2 = r2.length, c2 = false;
  i2.allow_permutations && (t4 === `*` ? c2 = ![...n2, ...r2].some((t5) => [`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t5[0])) : (t4 === `+` || t4 === `=` || t4 === `and` || t4 === `or` || t4 === `ne` || t4 === `union` || t4 === `intersect`) && (c2 = true));
  function l2(u3, d3, p2) {
    let m2 = 1, h2 = 1;
    (is_associative$1[t4] || [`tuple`, `vector`, `altvector`].includes(t4)) && (m2 = u3.length - (s2 - d3 - 1), h2 = u3.length), i2.max_group !== void 0 && (m2 = i2.max_group < m2 ? i2.max_group : m2), i2.max_last_group !== void 0 && (h2 = i2.max_last_group < h2 ? i2.max_last_group : h2);
    let g2;
    if (!a2 && d3 === s2 - 1) if (u3.length <= h2) g2 = [u3];
    else return false;
    else if (c2) g2 = subsets(u3, m2);
    else {
      g2 = [];
      for (let t5 = 1; t5 <= m2; t5++) g2.push(u3.slice(0, t5));
    }
    for (let a3 of g2) {
      let c3 = o2[d3][a3];
      if (c3 === void 0) {
        let s3 = a3.reduce(function(t5, r3) {
          return t5.concat([n2[r3]]);
        }, []);
        s3 = s3.length > 1 ? [t4].concat(s3) : s3[0], c3 = match$1(s3, r2[d3], i2), o2[d3][a3] = c3;
      }
      if (!c3 || !_.every(_.intersection(Object.keys(p2), Object.keys(c3)), function(t5) {
        return equal(p2[t5], c3[t5]);
      })) continue;
      let m3 = Object.assign({}, c3);
      Object.assign(m3, p2);
      let h3 = u3.filter((t5) => !a3.includes(t5));
      if (d3 === s2 - 1) return { matches: m3, skipped: h3.reduce(function(t5, r3) {
        return t5.concat([n2[r3]]);
      }, []) };
      let g3 = l2(h3, d3 + 1, m3);
      if (g3) return g3;
    }
    return false;
  }
  var u2 = {}, d2 = [...Array(n2.length).keys()];
  if (c2) {
    let t5 = l2(d2, 0, {});
    return t5 ? (u2 = t5.matches, t5.skipped.length > 0 && (u2._skipped = t5.skipped), u2) : false;
  } else {
    let t5 = a2 ? n2.length - s2 : 0, r3 = [], i3;
    for (let a3 = 0; a3 <= t5 && (i3 = l2(d2, 0, {}), !i3); a3++) d2 = d2.slice(1), r3.push(n2[a3]);
    return i3 ? (u2 = i3.matches, i3.skipped.length > 0 && (u2._skipped = i3.skipped), r3.length > 0 && (u2._skipped_before = r3), u2) : false;
  }
}
function matchImplicitIdentity(t4, n2, r2) {
  var i2 = n2[0], a2 = n2.slice(1);
  if (!(i2 === `+` || i2 === `*` || i2 === `^`)) return false;
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) {
    let n3 = a2[t5];
    typeof n3 == `string` && r2.allow_implicit_identities.includes(n3) && o2.push(n3);
  }
  if (o2.length === 0) return false;
  for (let i3 of o2) {
    let a3 = match_one_implicit_identity(t4, n2, r2, i3);
    if (a3) return a3;
  }
  return false;
}
function match_one_implicit_identity(t4, n2, r2, i2) {
  var a2 = n2[0], o2 = n2.slice(1), s2 = {};
  a2 === `+` ? s2[i2] = 0 : s2[i2] = 1, a2 === `*` && o2.includes(i2) && Array.isArray(t4) && t4[0] === `-` && (s2[i2] = -1, t4 = t4[1]);
  var c2 = o2.indexOf(i2);
  if (o2.splice(c2, 1), a2 === `^` && c2 === 0) return false;
  n2 = o2.length === 1 ? o2[0] : [a2].concat(o2);
  var l2 = match$1(t4, n2, r2);
  if (l2) {
    if (i2 in l2 && !equal(l2[i2], s2[i2])) return false;
    Object.assign(s2, l2);
  } else return false;
  return s2;
}
var substitute$1 = function(t4, n2) {
  return typeof t4 == `number` || typeof t4 == `boolean` ? t4 : typeof t4 == `string` ? n2[t4] === void 0 ? t4 : deepClone(n2[t4]) : Array.isArray(t4) ? [t4[0]].concat(t4.slice(1).map(function(t5) {
    return substitute$1(t5, n2);
  })) : [];
}, transform = function(t4, n2) {
  if (Array.isArray(t4)) {
    let r2 = [t4[0]];
    for (let i2 = 1; i2 < t4.length; i2++) r2.push(transform(t4[i2], n2));
    return n2(r2);
  }
  return n2(t4);
}, applyAllTransformations = function(t4, n2, r2) {
  r2 === void 0 && (r2 = 5);
  for (var i2 = t4, a2; r2 > 0; r2--) {
    a2 = i2;
    for (let t5 = 0; t5 < n2.length; t5++) {
      let r3 = n2[t5][0], a3 = n2[t5][1], o2 = n2[t5][2];
      o2 === void 0 && (o2 = {}), i2 = transform(i2, function(t6) {
        let n3 = match$1(t6, r3, o2);
        if (n3) {
          let t7 = substitute$1(a3, n3), i3 = o2.assumptions ? substitute$1(o2.assumptions, n3) : void 0;
          o2.evaluate_numbers && (t7 = evaluate_numbers(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 }));
          let s2 = [], c2 = [];
          return n3._skipped && (s2 = n3._skipped), n3._skipped_before && (c2 = n3._skipped_before), (c2.length > 0 || s2.length > 0) && (Array.isArray(t7) && (t7 = t7[0] === r3[0] ? t7.slice(1) : [t7]), t7 = [r3[0]].concat(c2, t7, s2)), o2.evaluate_numbers && (t7 = evaluate_numbers(t7, { max_digits: o2.max_digits, evaluate_functions: o2.evaluate_functions, assumptions: i3 })), t7;
        } else return t6;
      });
    }
    if (equal(a2, i2)) return i2;
  }
  return i2;
}, math = mathjs_default, operators$2 = { "+": function(t4) {
  return t4.length === 1 ? t4[0] : new math.OperatorNode(`+`, `add`, t4);
}, "*": function(t4) {
  return new math.OperatorNode(`*`, `multiply`, t4);
}, "/": function(t4) {
  return new math.OperatorNode(`/`, `divide`, t4);
}, "-": function(t4) {
  return new math.OperatorNode(`-`, `unaryMinus`, [t4[0]]);
}, "^": function(t4) {
  return new math.OperatorNode(`^`, `pow`, t4);
}, vector: function(t4) {
  return new math.ArrayNode(t4);
}, altvector: function(t4) {
  return new math.ArrayNode(t4);
}, and: function(t4) {
  return new math.OperatorNode(`and`, `and`, t4);
}, or: function(t4) {
  return new math.OperatorNode(`or`, `or`, t4);
}, not: function(t4) {
  return new math.OperatorNode(`not`, `not`, [t4[0]]);
}, "<": function(t4) {
  return new math.OperatorNode(`<`, `smaller`, t4);
}, ">": function(t4) {
  return new math.OperatorNode(`>`, `larger`, t4);
}, le: function(t4) {
  return new math.OperatorNode(`<=`, `smallerEq`, t4);
}, ge: function(t4) {
  return new math.OperatorNode(`>=`, `largerEq`, t4);
}, ne: function(t4) {
  return new math.OperatorNode(`!=`, `unequal`, t4);
}, binom: function(t4) {
  let n2 = new math.SymbolNode(`combinations`);
  return new math.FunctionNode(n2, t4);
} }, functionConversions = { nCr: `combinations`, nPr: `permutations`, binom: `combinations` }, astToMathjs$2 = class {
  constructor({ mathjs: t4 = null } = {}) {
    t4 && (math = t4);
  }
  convert(t4) {
    if (typeof t4 == `number`) return Number.isFinite(t4) ? new math.ConstantNode(t4) : Number.isNaN(t4) ? new math.SymbolNode(`NaN`) : t4 < 0 ? operators$2[`-`]([new math.SymbolNode(`Infinity`)]) : new math.SymbolNode(`Infinity`);
    if (typeof t4 == `string`) return new math.SymbolNode(t4);
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to mathjs`);
      if (r2[0] === `factorial`) return new math.OperatorNode(`!`, `factorial`, [this.convert(r2[1])]);
      let t5 = functionConversions[r2[0]];
      t5 ||= r2[0];
      let n3 = new math.SymbolNode(t5), i2 = r2[1], a2;
      return a2 = i2[0] === `tuple` ? i2.slice(1).map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)) : [this.convert(i2)], r2[0] === `count` && (a2.length > 2 || !(a2[0] instanceof math.ArrayNode)) && (a2 = [new math.ArrayNode(a2)]), new math.FunctionNode(n3, a2);
    }
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = t5.slice(1).map((function(t6, n3) {
        return this.convert(t6);
      }).bind(this)), o2 = [];
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? o2.push(new math.OperatorNode(`<`, `smaller`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math.OperatorNode(`>`, `larger`, a2.slice(r3 - 1, r3 + 1))) : n2 === `lts` ? o2.push(new math.OperatorNode(`<=`, `smallerEq`, a2.slice(r3 - 1, r3 + 1))) : o2.push(new math.OperatorNode(`>=`, `largerEq`, a2.slice(r3 - 1, r3 + 1)));
      let s2 = new math.OperatorNode(`and`, `and`, o2.slice(0, 2));
      for (let t6 = 2; t6 < o2.length; t6++) s2 = new math.OperatorNode(`and`, `and`, [s2, o2[t6]]);
      return s2;
    }
    if (n2 === `=`) {
      let t5 = r2.map((function(t6, n4) {
        return this.convert(t6);
      }).bind(this)), n3 = [];
      for (let r3 = 1; r3 < t5.length; r3++) n3.push(new math.OperatorNode(`==`, `equal`, t5.slice(r3 - 1, r3 + 1)));
      if (n3.length === 1) return n3[0];
      let i2 = new math.OperatorNode(`and`, `and`, n3.slice(0, 2));
      for (let t6 = 2; t6 < n3.length; t6++) i2 = new math.OperatorNode(`and`, `and`, [i2, n3[t6]]);
      return i2;
    }
    if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
      let t5, i2;
      if (n2 === `in` || n2 === `notin` ? (t5 = r2[0], i2 = r2[1]) : (t5 = r2[1], i2 = r2[0]), typeof t5 != `number` && typeof t5 != `string`) throw Error(`Set membership non-string variables not implemented for conversion to mathjs`);
      if (t5 = this.convert(t5), i2[0] !== `interval`) throw Error(`Set membership in non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let s2 = this.convert(a2[1]), c2 = this.convert(a2[2]), l2 = [];
      o2[1] ? l2.push(new math.OperatorNode(`>=`, `largerEq`, [t5, s2])) : l2.push(new math.OperatorNode(`>`, `larger`, [t5, s2])), o2[2] ? l2.push(new math.OperatorNode(`<=`, `smallerEq`, [t5, c2])) : l2.push(new math.OperatorNode(`<`, `smaller`, [t5, c2]));
      let u2 = new math.OperatorNode(`and`, `and`, l2);
      return (n2 === `notin` || n2 === `notni`) && (u2 = new math.OperatorNode(`not`, `not`, [u2])), u2;
    }
    if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
      let t5, i2;
      if (n2 === `subset` || n2 === `notsubset` ? (i2 = r2[0], t5 = r2[1]) : (i2 = r2[1], t5 = r2[0]), i2[0] !== `interval` || t5[0] !== `interval`) throw Error(`Set containment of non-intervals not implemented for conversion to mathjs`);
      let a2 = i2[1], o2 = i2[2], s2 = t5[1], c2 = t5[2];
      if (a2[0] !== `tuple` || o2[0] !== `tuple` || s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let l2 = this.convert(a2[1]), u2 = this.convert(a2[2]), d2 = this.convert(s2[1]), p2 = this.convert(s2[2]), m2 = [];
      o2[1] && !c2[1] ? m2.push(new math.OperatorNode(`>`, `larger`, [l2, d2])) : m2.push(new math.OperatorNode(`>=`, `largerEq`, [l2, d2])), o2[2] && !c2[2] ? m2.push(new math.OperatorNode(`<`, `smaller`, [u2, p2])) : m2.push(new math.OperatorNode(`<=`, `smallerEq`, [u2, p2]));
      let h2 = new math.OperatorNode(`and`, `and`, m2);
      return (n2 === `notsubset` || n2 === `notsuperset`) && (h2 = new math.OperatorNode(`not`, `not`, [h2])), h2;
    }
    if (n2 === `matrix`) {
      let t5 = r2[0], n3 = t5[1], i2 = t5[2], a2 = r2[1];
      if (!Number.isInteger(n3) || !Number.isInteger(i2)) throw Error(`Matrix must have integer dimensions`);
      let o2 = [];
      for (let t6 = 1; t6 <= n3; t6++) {
        let n4 = [];
        for (let r3 = 1; r3 <= i2; r3++) n4.push(this.convert(a2[t6][r3]));
        o2.push(new math.ArrayNode(n4));
      }
      return new math.ArrayNode(o2);
    }
    if (n2 === `array`) {
      let t5 = r2.map((t6) => this.convert(t6));
      return new math.ArrayNode(t5);
    }
    if (n2 in operators$2) return operators$2[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, require_sieve = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    for (var n3 = Array(t5), r2 = 0; r2 < t5; r2++) n3[r2] = true;
    for (var r2 = 2; r2 < Math.sqrt(t5); r2++) for (var i2 = r2 * r2; i2 < t5; i2 += r2) n3[i2] = false;
    for (var a2 = [], r2 = 2; r2 < t5; r2++) n3[r2] && a2.push(r2);
    return a2;
  };
})), require_factor = __commonJSMin(((t4, n2) => {
  var r2 = require_sieve(), i2 = r2(1e5);
  n2.exports = function(t5) {
    (!i2 || i2[i2.length - 1] < t5) && (i2 = r2(t5));
    for (var n3 = [], a2 = 0; a2 < i2.length && t5 > 1; a2++) {
      var o2 = i2[a2];
      if (t5 % o2 === 0) {
        for (var s2 = { prime: o2, power: 0 }; t5 % o2 === 0; ) s2.power++, t5 /= o2;
        n3.push(s2);
      }
    }
    return t5 > 1 && n3.push({ prime: t5, power: 1 }), n3;
  };
})), require_inc_mixed = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5, n3) {
    var r2 = t5.map(function(t6) {
      return t6;
    });
    r2[0]++;
    for (var i2 = 0; i2 < t5.length && !(r2[i2] <= n3[i2]); i2++) i2 === t5.length - 1 ? r2[i2] = 0 : (r2[i2] = 0, r2[i2 + 1]++);
    return r2;
  };
})), require_divisors = __commonJSMin(((t4, n2) => {
  var r2 = require_factor(), i2 = require_inc_mixed();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), a2 = n3.map(function(t6) {
      return 0;
    }), o2 = n3.map(function(t6) {
      return t6.power;
    }), s2 = [1]; ; ) {
      a2 = i2(a2, o2);
      var c2 = a2.map(function(t6, r3) {
        return n3[r3].prime ** +t6;
      }).reduce(function(t6, n4) {
        return t6 * n4;
      }, 1);
      if (c2 === 1) break;
      s2.push(c2);
    }
    return s2.sort(function(t6, n4) {
      return parseInt(t6) - parseInt(n4);
    }), s2;
  };
})), require_prime_factors = __commonJSMin(((t4, n2) => {
  var r2 = require_factor();
  n2.exports = function(t5) {
    return r2(t5).map(function(t6) {
      return t6.prime;
    });
  };
})), require_euler_phi = __commonJSMin(((t4, n2) => {
  var r2 = require_prime_factors();
  n2.exports = function(t5) {
    var n3 = function(t6) {
      return t6.reduce(function(t7, n4) {
        return t7 * n4;
      }, 1);
    }, i2 = r2(t5), a2 = n3(i2.map(function(t6) {
      return t6 - 1;
    })), o2 = n3(i2);
    return t5 * a2 / o2;
  };
})), require_gcd = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5, n3) {
    for (t5 < 0 && (t5 = -t5), n3 < 0 && (n3 = -n3); ; ) {
      if (n3 === 0) return t5;
      if (t5 %= n3, t5 === 0) return n3;
      n3 %= t5;
    }
  };
})), require_find_divisor = __commonJSMin(((t4, n2) => {
  var r2 = require_gcd();
  n2.exports = function(t5) {
    for (var n3 = 2 * Math.floor(Math.sqrt(Math.sqrt(t5))), i2 = 2, a2 = i2, o2, s2 = 1; s2 < n3; s2++) if (i2 = (i2 * i2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, a2 = (a2 * a2 + 1) % t5, o2 = r2(a2 - i2, t5), o2 != 1) return o2;
    return 1;
  };
})), require_inverse_mod = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5, n3) {
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0, i2 = 1, a2 = n3, o2 = t5; o2 !== 0; ) {
      var s2 = Math.floor(a2 / o2), c2 = r2;
      r2 = i2, i2 = c2 - s2 * i2;
      var l2 = a2;
      a2 = o2, o2 = l2 - s2 * o2;
    }
    return a2 > 1 ? NaN : r2 > 0 ? r2 : r2 + n3;
  };
})), require_is_abundant = __commonJSMin(((t4, n2) => {
  var r2 = require_divisors();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 < n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_deficient = __commonJSMin(((t4, n2) => {
  var r2 = require_divisors();
  n2.exports = function(t5) {
    if (t5 === 1) return true;
    var n3 = r2(t5);
    return n3.pop(), t5 > n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_heptagonal = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(40 * t5 + 9) + 3) / 10 % 1 == 0;
  };
})), require_is_hexagonal = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(8 * t5 + 1) + 1) / 4 % 1 == 0;
  };
})), require_is_octagonal = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(3 * t5 + 1) + 1) / 3 % 1 == 0;
  };
})), require_is_pentagonal = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return (Math.sqrt(24 * t5 + 1) + 1) / 6 % 1 == 0;
  };
})), require_is_perfect = __commonJSMin(((t4, n2) => {
  var r2 = require_divisors();
  n2.exports = function(t5) {
    if (t5 === 1) return false;
    var n3 = r2(t5);
    return n3.pop(), t5 === n3.reduce(function(t6, n4) {
      return t6 + n4;
    });
  };
})), require_is_prime = __commonJSMin(((t4, n2) => {
  var r2 = require_factor();
  n2.exports = function(t5) {
    var n3 = r2(t5);
    return n3.length == 1 ? n3[0].power === 1 : false;
  };
})), require_multiply_mod = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5, n3, r2) {
    if (t5 < 94906265 && n3 < 94906265) return t5 * n3 % r2;
    var i2 = 0, a2 = r2 / 2;
    t5 >= r2 && (t5 %= r2), n3 >= r2 && (n3 %= r2);
    for (var o2 = 0; o2 < 53; o2++) i2 = i2 >= a2 ? 2 * i2 - r2 : 2 * i2, t5 >= 4503599627370496 && (i2 += n3, t5 -= 4503599627370495), i2 > r2 && (i2 -= r2), t5 *= 2;
    return i2;
  };
})), require_power_mod = __commonJSMin(((t4, n2) => {
  var r2 = require_multiply_mod(), i2 = require_inverse_mod();
  n2.exports = function t5(n3, a2, o2) {
    if (a2 < 0) return i2(t5(n3, -a2, o2), o2);
    var s2 = 1;
    for (n3 %= o2; a2 > 0; ) a2 % 2 == 1 && (s2 = r2(s2, n3, o2), --a2), a2 /= 2, n3 = r2(n3, n3, o2);
    return s2;
  };
})), require_miller = __commonJSMin(((t4, n2) => {
  var r2 = require_multiply_mod(), i2 = require_power_mod();
  n2.exports = function(t5) {
    if (t5 < 2) return false;
    if (t5 == 2 || t5 == 3) return true;
    if (!(t5 & 1) || t5 % 3 == 0) return false;
    for (var n3 = t5 - 1, a2 = 0; n3 % 2 == 0; ) n3 /= 2, a2 += 1;
    for (var o2 = t5 < 1373653 ? [2, 3] : t5 < 9080191 ? [31, 73] : t5 < 4759123141 ? [2, 7, 61] : t5 < 1122004669633 ? [2, 13, 23, 1662803] : t5 < 2152302898747 ? [2, 3, 5, 7, 11] : t5 < 3474749660383 ? [2, 3, 5, 7, 11, 13] : [2, 3, 5, 7, 11, 13, 17], s2 = 0; s2 < o2.length; s2++) {
      for (var c2 = o2[s2], l2 = i2(c2, n3, t5), u2 = 0, d2 = a2; d2 > 0; ) {
        if (u2 = r2(l2, l2, t5), u2 === 1 && l2 !== 1 && l2 !== t5 - 1) return false;
        l2 = u2, --d2;
      }
      if (u2 !== 1) return false;
    }
    return true;
  };
})), require_is_square = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(t5) % 1 == 0;
  };
})), require_is_triangular = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5) {
    return Math.sqrt(8 * t5 + 1) % 1 == 0;
  };
})), require_jacobi_symbol = __commonJSMin(((t4, n2) => {
  n2.exports = function(t5, n3) {
    if (n3 % 2 == 0 || n3 < 0) return NaN;
    t5 < 0 && (t5 = t5 % n3 + n3);
    for (var r2 = 0; ; ) {
      if (t5 %= n3, t5 === 0) return 0;
      for (; t5 % 2 == 0; ) r2 ^= (n3 % 8 * (n3 % 8) - 1) / 8, t5 /= 2;
      if (t5 == 1) return r2 & 1 ? -1 : 1;
      r2 ^= (t5 % 4 - 1) * (n3 % 4 - 1) / 4;
      var i2 = t5;
      t5 = n3, n3 = i2;
    }
    return NaN;
  };
})), require_log_mod = __commonJSMin(((t4, n2) => {
  var r2 = require_power_mod(), i2 = require_multiply_mod(), a2 = {};
  n2.exports = function(t5, n3, o2) {
    t5 = (t5 % o2 + o2) % o2;
    var s2 = Math.ceil(Math.sqrt(o2)), c2 = {};
    if (a2[o2] === void 0 && (a2[o2] = {}), a2[o2][n3] === void 0) {
      a2[o2][n3] = {}, c2 = a2[o2][n3];
      for (var l2 = 0; l2 < s2; l2++) c2[r2(n3, l2, o2)] = l2;
    } else c2 = a2[o2][n3];
    for (var u2 = r2(n3, -s2, o2), d2 = t5, p2 = 0; p2 < s2; p2++) if (c2[d2] !== void 0) return (i2(p2, s2, o2) + c2[d2]) % o2;
    else d2 = i2(d2, u2, o2);
    return NaN;
  };
})), require_primitive_root = __commonJSMin(((t4, n2) => {
  var r2 = (init_index_all(), __toCommonJS(index_all_exports)), i2 = require_euler_phi(), a2 = require_prime_factors(), o2 = require_power_mod();
  n2.exports = function(t5) {
    for (var n3 = i2(t5), s2 = a2(n3), c2 = 2; c2 < t5; c2++) if (r2.every(s2, function(r3) {
      return o2(c2, n3 / r3, t5) != 1;
    })) return c2;
    return NaN;
  };
})), require_quadratic_nonresidue = __commonJSMin(((t4, n2) => {
  var r2 = require_jacobi_symbol();
  n2.exports = function(t5) {
    for (var n3 = 2; n3 < t5; n3++) if (r2(n3, t5) == -1) return n3;
    return NaN;
  };
})), require_random_primitive_root = __commonJSMin(((t4, n2) => {
  var r2 = require_primitive_root(), i2 = require_euler_phi(), a2 = require_gcd(), o2 = require_power_mod();
  n2.exports = function(t5) {
    for (var n3 = r2(t5), s2 = i2(t5), c2 = 0; c2 < 100; c2++) {
      var l2 = Math.floor(Math.random() * s2);
      if (a2(l2, s2) == 1) return o2(n3, l2, t5);
    }
    return n3;
  };
})), require_square_root_mod_prime = __commonJSMin(((t4, n2) => {
  var r2 = require_jacobi_symbol(), i2 = require_power_mod(), a2 = require_quadratic_nonresidue();
  n2.exports = function(t5, n3) {
    if (r2(t5, n3) != 1) return NaN;
    for (var o2 = n3 - 1, s2 = 0; o2 % 2 == 0; ) o2 /= 2, s2++;
    if (n3 % 4 == 3) return i2(t5, (n3 + 1) / 4, n3);
    for (var c2 = i2(a2(n3), o2, n3), l2 = i2(t5, (o2 + 1) / 2, n3), u2 = i2(t5, o2, n3), d2 = s2; ; ) {
      if (u2 % n3 == 1) return l2;
      for (var p2 = u2, m2 = 1; m2 < d2 && (p2 = p2 * p2 % n3, p2 != 1); m2++) ;
      var h2 = m2;
      m2++;
      for (var g2 = c2; m2 < d2; ) g2 = g2 * g2 % n3, m2++;
      d2 = h2, l2 = l2 * g2 % n3, u2 = u2 * g2 * g2 % n3, c2 = g2 * g2 % n3;
    }
    return NaN;
  };
})), require_square_root_mod = __commonJSMin(((t4, n2) => {
  var r2 = (init_index_all(), __toCommonJS(index_all_exports)), i2 = require_factor(), a2 = require_square_root_mod_prime(), o2 = require_jacobi_symbol(), s2 = require_inverse_mod(), c2 = require_multiply_mod();
  n2.exports = function(t5, n3) {
    var l2 = 1, u2 = [0];
    return i2(n3).forEach(function(n4) {
      var i3 = n4.prime, d2 = n4.power, p2 = a2(t5, i3), m2 = [];
      if (o2(t5, i3) != 1) return [];
      u2.forEach(function(t6) {
        m2.unshift(t6 * i3 * s2(i3, l2) + p2 * l2 * s2(l2, i3)), m2.unshift(t6 * i3 * s2(i3, l2) - p2 * l2 * s2(l2, i3));
      }), m2.sort(), u2 = r2.unique(m2), l2 *= i3;
      var h2 = 1;
      for (d2--; d2 > 0; ) {
        var g2 = i3 ** +Math.min(h2, d2);
        d2 -= Math.min(h2, d2), u2 = u2.map(function(n5) {
          var r3 = -((n5 * n5 - t5) / l2), i4 = s2(2 * n5, g2);
          return n5 + l2 * c2(r3, i4, g2);
        }), l2 *= g2;
      }
    }), u2.map(function(t6) {
      return (t6 % n3 + n3) % n3;
    });
  };
})), require_number_theory = __commonJSMin(((t4, n2) => {
  n2.exports = { divisors: require_divisors(), eulerPhi: require_euler_phi(), factor: require_factor(), findDivisor: require_find_divisor(), gcd: require_gcd(), incMixed: require_inc_mixed(), inverseMod: require_inverse_mod(), isAbundant: require_is_abundant(), isDeficient: require_is_deficient(), isHeptagonal: require_is_heptagonal(), isHexagonal: require_is_hexagonal(), isOctagonal: require_is_octagonal(), isPentagonal: require_is_pentagonal(), isPerfect: require_is_perfect(), isPrime: require_is_prime(), isProbablyPrime: require_miller(), isSquare: require_is_square(), isTriangular: require_is_triangular(), jacobiSymbol: require_jacobi_symbol(), logMod: require_log_mod(), miller: require_miller(), multiplyMod: require_multiply_mod(), powerMod: require_power_mod(), primeFactors: require_prime_factors(), primitiveRoot: require_primitive_root(), quadraticNonresidue: require_quadratic_nonresidue(), randomPrimitiveRoot: require_random_primitive_root(), sieve: require_sieve(), squareRootMod: require_square_root_mod(), squareRootModPrime: require_square_root_mod_prime(), totient: require_euler_phi() };
})), import_number_theory = __toESM(require_number_theory());
function gcd$2(t4, n2) {
  return Number.isNaN(t4) || Number.isNaN(n2) ? NaN : import_number_theory.default.gcd(t4, n2);
}
function flatten$1(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.concat(n2);
  }, []);
}
function positiveModulo(t4, n2) {
  return (t4 % n2 + n2) % n2;
}
var ZmodN = class t23 {
  constructor(t4, n2, r2 = false) {
    this.values = t4.map(function(t5) {
      return positiveModulo(t5, n2);
    }), this.modulus = n2, this.approximate = r2;
  }
  apply(n2, r2, i2) {
    if (i2 == null || Number.isNaN(i2)) {
      if (Number.isNaN(this.modulus) || Number.isNaN(n2.modulus)) return new t23([NaN], NaN, this.approximate || n2.approximate);
      i2 = gcd$2(this.modulus, n2.modulus);
    }
    return new t23(flatten$1(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        return Number.isNaN(t4) || Number.isNaN(n3) ? NaN : (i2 + r2(t4, n3)) % i2;
      });
    })), i2, this.approximate || n2.approximate);
  }
  add(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 + n2;
    });
  }
  power(n2) {
    var r2 = this.modulus;
    return n2.modulus == import_number_theory.default.eulerPhi(r2) ? this.apply(n2, function(t4, n3) {
      return import_number_theory.default.powerMod(t4, n3, r2);
    }, r2) : new t23([NaN], NaN, this.approximate || n2.approximate);
  }
  isNaN() {
    for (var t4 of this.values) if (isNaN(t4)) return true;
    return false;
  }
  subtract(t4) {
    return this.apply(t4, function(t5, n2) {
      return t5 - n2;
    });
  }
  multiply(t4) {
    var n2 = gcd$2(this.modulus, t4.modulus);
    return this.apply(t4, function(t5, r2) {
      return import_number_theory.default.multiplyMod(t5, r2, n2);
    });
  }
  inverse() {
    var n2 = this.modulus;
    return new t23(this.values.map(function(t4) {
      return import_number_theory.default.inverseMod(t4, n2);
    }), this.modulus, this.approximate);
  }
  negate() {
    var n2 = this.modulus;
    return new t23(this.values.map(function(t4) {
      return n2 - t4;
    }), this.modulus, this.approximate);
  }
  divide(n2) {
    var r2 = gcd$2(this.modulus, n2.modulus);
    return new t23(flatten$1(flatten$1(this.values.map(function(t4) {
      return n2.values.map(function(n3) {
        if (t4 % n3 == 0) return [t4 / n3];
        var i2 = gcd$2(n3, r2);
        if (t4 % i2 != 0) return [];
        var a2 = n3 / i2, o2 = t4 / i2, s2 = import_number_theory.default.multiplyMod(o2, import_number_theory.default.inverseMod(a2, r2), r2), c2 = [], l2;
        for (l2 = 0; l2 < i2; l2++) c2.unshift(s2 + import_number_theory.default.multiplyMod(l2, r2 / i2, r2));
        return c2;
      });
    }))), r2, this.approximate || n2.approximate);
  }
  sqrt() {
    var n2 = this.modulus;
    return new t23(flatten$1(this.values.map(function(t4) {
      return import_number_theory.default.squareRootMod(t4, n2);
    })), this.modulus, this.approximate);
  }
  toString = function() {
    return `{` + this.values.sort().toString() + `}/` + this.modulus.toString();
  };
  equals(t4) {
    return this.toString() == t4.toString();
  }
}, PRIME = 10739999, levelFunctions = { "+": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.add(n2);
  });
}, "*": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.multiply(n2);
  });
}, "/": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.divide(n2);
  });
}, "-": function(t4) {
  return t4[0].negate();
}, "~": function(t4) {
  return t4.reduce(function(t5, n2) {
    return t5.subtract(n2);
  }, new ZmodN([0], t4[0].modulus));
}, factorial: function(t4) {
  return ZmodN([NaN], 1);
}, gamma: function(t4) {
  return ZmodN([NaN], 1);
} };
function rationalApproximation(t4, n2 = 1e15) {
  let r2 = [[1, 0], [0, 1]], i2;
  for (; r2[1][0] * (i2 = Math.floor(t4)) + r2[1][1] <= n2; ) {
    let n3;
    if (n3 = r2[0][0] * i2 + r2[0][1], r2[0][1] = r2[0][0], r2[0][0] = n3, n3 = r2[1][0] * i2 + r2[1][1], r2[1][1] = r2[1][0], r2[1][0] = n3, t4 == i2 || (t4 = 1 / (t4 - i2), t4 > 2147483647)) break;
  }
  let a2 = r2[1][0] * i2 + r2[1][1] > n2;
  return { numerator: r2[0][0], denominator: r2[1][0], approximate: a2 };
}
function finite_field_evaluate_ast(t4, n2, r2, i2) {
  if (typeof t4 == `string`) return t4 === `e` ? new ZmodN([import_number_theory.default.primitiveRoot(r2)], r2) : t4 === `pi` ? r2 % 2 == 0 ? new ZmodN([r2 / 2], r2) : new ZmodN([NaN], r2) : t4 === `i` ? new ZmodN([0], 1) : t4 in n2 ? new ZmodN([n2[t4]], r2) : t4;
  if (typeof t4 == `number`) {
    if (Number.isInteger(t4)) return new ZmodN([t4], r2);
    {
      let n3 = rationalApproximation(t4), i3 = new ZmodN([n3.numerator], r2, n3.approximate), a3 = new ZmodN([n3.denominator], r2, n3.approximate);
      return i3.divide(a3);
    }
  }
  var a2 = t4[0], o2 = t4.slice(1);
  if (a2 === `apply`) {
    if (typeof o2[0] != `string`) throw Error(`Non string functions not implemented for finite fields`);
    if (o2[0] === `exp`) {
      var s2 = finite_field_evaluate_ast(`e`, {}, r2), c2 = finite_field_evaluate_ast(o2[1], n2, import_number_theory.default.eulerPhi(r2));
      return s2.power(c2);
    }
    if (o2[0] === `sec`) return finite_field_evaluate_ast([`/`, 1, [`apply`, `cos`, o2[1]]], n2, r2);
    if (o2[0] === `csc`) return finite_field_evaluate_ast([`/`, 1, [`apply`, `sin`, o2[1]]], n2, r2);
    if (o2[0] === `cot`) return finite_field_evaluate_ast([`/`, 1, [`apply`, `tan`, o2[1]]], n2, r2);
    if (o2[0] === `tan`) {
      var l2 = import_number_theory.default.eulerPhi(r2);
      return finite_field_evaluate_ast([`/`, [`apply`, `sin`, o2[1]], [`apply`, `cos`, o2[1]]], n2, r2);
    }
    if (o2[0] === `sin`) {
      var u2 = import_number_theory.default.primitiveRoot(r2), d2 = new ZmodN([u2], r2), l2 = import_number_theory.default.eulerPhi(r2);
      if (l2 % 4 != 0) return new ZmodN([NaN], r2);
      var p2 = new ZmodN([import_number_theory.default.powerMod(u2, l2 / 4, r2)], r2), m2 = finite_field_evaluate_ast(o2[1], n2, l2);
      return d2.power(m2).subtract(d2.power(m2.negate())).divide(p2.add(p2));
    }
    if (o2[0] === `cos`) {
      var d2 = new ZmodN([import_number_theory.default.primitiveRoot(r2)], r2), m2 = finite_field_evaluate_ast(o2[1], n2, import_number_theory.default.eulerPhi(r2));
      return d2.power(m2).add(d2.power(m2.negate())).divide(new ZmodN([2], r2));
    }
    if (o2[0] === `log`) return new ZmodN([NaN], NaN);
    if (o2[0] === `sqrt`) return finite_field_evaluate_ast(o2[1], n2, r2).sqrt();
    if (o2[0] === `abs`) {
      let t5 = finite_field_evaluate_ast(o2[1], n2, r2);
      return t5.multiply(t5).sqrt();
    }
  }
  if (a2 == `^`) {
    var s2 = finite_field_evaluate_ast(o2[0], n2, r2), c2 = finite_field_evaluate_ast(o2[1], n2, import_number_theory.default.eulerPhi(r2));
    return s2.power(c2);
  }
  return a2 in levelFunctions ? levelFunctions[a2](o2.map(function(t5, a3) {
    return finite_field_evaluate_ast(t5, n2, r2);
  })) : new ZmodN([NaN], r2);
}
var astToFiniteField$1 = class {
  constructor() {
  }
  convert(t4, n2, r2 = PRIME) {
    return finite_field_evaluate_ast(t4, n2, r2);
  }
}, evaluation_exports = __exportAll({ evaluate: () => evaluate$1, evaluate_to_constant: () => evaluate_to_constant, f: () => f, finite_field_evaluate: () => finite_field_evaluate }), astToMathjs$1 = new astToMathjs$2({ mathjs: mathjs_default }), astToFiniteField = new astToFiniteField$1(), f = function(t4) {
  var n2 = get_tree(t4), r2 = factorial_to_gamma_function(astToMathjs$1.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(n2)))));
  return r2.evaluate.bind(r2);
}, evaluate$1 = function(t4, n2) {
  return f(t4)(n2);
}, finite_field_evaluate = function(t4, n2, r2) {
  return astToFiniteField.convert(t4.tree, n2, r2);
}, evaluate_to_constant = function(t4, { remove_units_first: n2 = true, scale_based_on_unit: r2 = true, nan_for_non_numeric: i2 = true } = {}) {
  var a2 = get_tree(t4);
  if (n2 && (a2 = remove_units(a2, r2)), typeof a2 == `number`) return a2;
  if (typeof a2 == `string`) return a2 === `pi` && mathjs_default.define_pi ? Math.PI : a2 === `e` && mathjs_default.define_e ? Math.E : a2 === `i` && mathjs_default.define_i ? { re: 0, im: 1 } : i2 ? NaN : null;
  if (!Array.isArray(a2)) return i2 ? NaN : null;
  var o2 = [];
  o2.push([[`^`, `x`, [`/`, `m`, `n`]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], `m`], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), o2.push([[`^`, `x`, [`-`, [`/`, `m`, `n`]]], [`^`, [`apply`, `nthRoot`, [`tuple`, `x`, `n`]], [`-`, `m`]], { variables: { x: (t5) => t5 < 0, n: (t5) => Number.isInteger(t5) && Number.isInteger((t5 - 1) / 2), m: (t5) => Number.isInteger(t5) } }]), a2 = applyAllTransformations(a2, o2, 40);
  var s2 = i2 ? NaN : null;
  try {
    var c2 = f(a2);
    s2 = c2();
  } catch {
  }
  if (!Number.isNaN(s2) && (typeof s2 == `number` || typeof s2?.re == `number` && typeof s2?.im == `number`)) {
    if (s2.re === 1 / 0 || s2.re === -1 / 0 || s2.im === 1 / 0 || s2.im === -1 / 0) {
      let t5;
      if (typeof s2?.re == `number` && typeof s2?.im == `number`) if (s2.im === 0) t5 = s2.re;
      else {
        let n3;
        n3 = s2.im === 1 ? `i` : s2.im === -1 ? [`-`, `i`] : [`*`, s2.im, `i`], t5 = s2.re === 0 ? n3 : [`+`, s2.re, n3];
      }
      else t5 = s2;
      s2 = i2 ? NaN : null;
      try {
        var c2 = f(t5);
        s2 = c2();
      } catch {
      }
    } else s2.im === 0 && (s2 = s2.re);
    return s2;
  }
  return typeof s2 == `object` && (s2 = i2 ? NaN : null), s2;
};
function factorial_to_gamma_function(t4) {
  return t4.transform(function(t5, n2, r2) {
    if (t5.isOperatorNode && t5.op === `!` && t5.fn === `factorial`) {
      var i2 = [new mathjs_default.OperatorNode(`+`, `add`, [t5.args[0], new mathjs_default.ConstantNode(1)])];
      return new mathjs_default.FunctionNode(new mathjs_default.SymbolNode(`gamma`), i2);
    } else return t5;
  });
}
var functions = { C: {}, R: {}, nonzeroC: {}, nonneg: {}, pos: {} };
functions.C.nonneg = [`abs`], functions.C.nonzero = [`exp`], functions.C.R = [`abs`, `arg`], functions.C.C = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`, `sqrt`, `log`, `ln`, `log10`], functions.R.pos = [`exp`], functions.R.nonneg = [`abs`, `exp`, `arg`], functions.R.R = [`abs`, `arg`, `exp`, `sign`, `cos`, `cosh`, `sin`, `sinh`, `erf`], functions.R.Z = [`sign`], functions.nonzeroC.pos = [`abs`], functions.nonneg.nonneg = [`abs`, `exp`, `arg`, `sqrt`, `erf`], functions.nonzeroC.nonzero = [`abs`], functions.nonneg.R = [...new Set(functions.R.R.concat(functions.nonneg.nonneg))], functions.pos.pos = [`abs`, `exp`, `sqrt`, `erf`], functions.pos.nonneg = functions.pos.pos, functions.pos.nonzero = [`abs`, `exp`, `sqrt`, `erf`], functions.pos.R = functions.nonneg.R.concat([`log`, `ln`, `log10`]);
function negate_adjust(t4, n2) {
  if (t4) return !n2;
  if (t4 === false) return n2;
}
function narrow_assumptions(t4, n2) {
  if (!Array.isArray(n2)) return [];
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 !== `and`) return [];
  for (var a2 = [], o2 = 0; o2 < i2.length; o2++) equal(i2[o2], t4) || a2.push(i2[o2]);
  return a2.length === 0 ? [] : a2.legnth === 1 ? a2[0] : [r2].concat(a2);
}
function simple_assumption_combination(t4, n2, r2) {
  return t4 === `and` ? n2 === void 0 ? r2 : r2 === void 0 ? n2 : n2 || r2 : n2 === void 0 || r2 === void 0 || n2 !== r2 ? void 0 : n2;
}
function is_integer_ast(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isInteger(t4);
  var i2 = evaluate_to_constant(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return Number.isInteger(i2);
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return negate_adjust(false, c2);
    if (c2 === false) {
      if (o2 === `notin` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `C`)) return false;
    } else if (o2 === `in` && (s2[0] === t4 && s2[1] === `R` || s2[0] === t4 && s2[1] === `Z`)) return false;
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions(a2, r2);
      if (s2[0] === t4) return is_integer_ast(s2[1], n3);
      if (s2[1] === t4) return is_integer_ast(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight(i3), s2 = i3.slice(1));
    let l2 = is_integer_ast(t4, s2[0], r2), u2 = is_integer_ast(t4, s2[1], r2);
    return simple_assumption_combination(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_integer_ast(o2[0], i3, r2);
    if (a2 === `*`) return o2.every(function(t5) {
      return is_integer_ast(t5, i3, r2);
    }) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast(o2[0], i3, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (is_positive_ast(o2[1], i3, true, r2)) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let n3 = is_integer_ast(o2[0], i3, r2), a3 = is_integer_ast(o2[1], i3, r2);
      return n3 && (a3 && is_positive_ast(o2[1], i3, false, r2) ? true : void 0);
    }
    if (a2 === `+`) {
      let t5 = 0;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_integer_ast(o2[n3], i3, r2);
        if (a3 === false) {
          if (t5 > 0) return;
          t5 += 1;
        }
        if (a3 === void 0) return;
      }
      return t5 === 0;
    }
    return a2 === `apply` ? functions.C.Z && functions.C.Z.includes(o2[0]) && is_complex_ast(o2[1], i3, r2) || functions.R.Z && functions.R.Z.includes(o2[0]) && is_real_ast(o2[1], i3, r2) || functions.nonzeroC.Z && functions.nonzeroC.Z.includes(o2[0]) && is_nonzero_ast(o2[1], i3, r2) && is_complex_ast(o2[1], i3, r2) || functions.nonneg.Z && functions.nonneg.Z.includes(o2[0]) && is_positive_ast(o2[1], i3, false, r2) || functions.pos.Z && functions.pos.Z.includes(o2[0]) && is_positive_ast(o2[1], i3, true, r2) ? true : void 0 : a2 === `/` || a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_real_ast(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : false;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `R`) return negate_adjust(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `R`) return negate_adjust(false, c2);
    if (c2 === false) {
      if (o2 === `in` && s2[0] === t4 && s2[1] === `Z`) return true;
    } else if (o2 === `notin` && s2[0] === t4 && s2[1] === `Z`) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables(i3), r3 = functions$2(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions(a2, r2);
      if (s2[0] === t4) return is_real_ast(s2[1], n3);
      if (s2[1] === t4) return is_real_ast(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight(i3), s2 = i3.slice(1));
    let l2 = is_real_ast(t4, s2[0], r2), u2 = is_real_ast(t4, s2[1], r2);
    return simple_assumption_combination(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_real_ast(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight(t4), o2 = t4.slice(1)), a2 === `*` && (is_nonzero_ast(o2[0], i3, r2) === false || is_nonzero_ast(o2[1], i3, r2) === false)) return true;
      let n3 = is_real_ast(o2[0], i3, r2), s2 = is_real_ast(o2[1], i3, r2);
      return n3 && s2 ? true : n3 && s2 === false || s2 && n3 === false ? false : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast(o2[0], i3, r2), n3 = is_positive_ast(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_real_ast(o2[0], i3, r2), s2 = is_real_ast(o2[1], i3, r2);
      return a3 && s2 ? is_positive_ast(o2[0], i3, false, r2) ? is_positive_ast(o2[0], i3, true, r2) || n3 ? true : void 0 : is_integer_ast(o2[1], i3, r2) ? true : void 0 : void 0;
    }
    return a2 === `/` ? is_nonzero_ast(o2[1], i3, r2) && (is_nonzero_ast(o2[0], i3, r2) === false || is_real_ast(o2[0], i3, r2) && is_real_ast(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions.C.R && functions.C.R.includes(o2[0]) && is_complex_ast(o2[1], i3, r2) || functions.R.R && functions.R.R.includes(o2[0]) && is_real_ast(o2[1], i3, r2) || functions.nonzeroC.R && functions.nonzeroC.R.includes(o2[0]) && is_nonzero_ast(o2[1], i3, r2) && is_complex_ast(o2[1], i3, r2) || functions.nonneg.R && functions.nonneg.R.includes(o2[0]) && is_positive_ast(o2[1], i3, false, r2) || functions.pos.R && functions.pos.R.includes(o2[0]) && is_positive_ast(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_complex_ast(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4);
  var i2 = evaluate_to_constant(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) : !!(i2.re !== void 0 && Number.isFinite(i2.re) && i2.im !== void 0 && Number.isFinite(i2.im));
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    if (o2 === `in` && s2[0] === t4 && s2[1] === `C`) return negate_adjust(true, c2);
    if (o2 === `notin` && s2[0] === t4 && s2[1] === `C`) return negate_adjust(false, c2);
    if (c2 === false) {
      if (o2 === `in` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    } else if (o2 === `notin` && (s2[0] === t4 && s2[1] === `Z` || s2[0] === t4 && s2[1] === `R`)) return true;
    if (o2 === `<` || o2 === `le`) {
      let n3 = variables(i3), r3 = functions$2(i3);
      if (n3.indexOf(t4) !== -1 && r3.length === 0) return true;
    }
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      let n3 = narrow_assumptions(a2, r2);
      if (s2[0] === t4) return is_complex_ast(s2[1], n3);
      if (s2[1] === t4) return is_complex_ast(s2[0], n3);
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight(i3), s2 = i3.slice(1));
    let l2 = is_complex_ast(t4, s2[0], r2), u2 = is_complex_ast(t4, s2[1], r2);
    return simple_assumption_combination(o2, l2, u2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_complex_ast(o2[0], i3, r2);
    if (a2 === `*` || a2 === `+`) return a2 === `*` && !o2.every((t5) => is_nonzero_ast(t5, i3, r2) !== false) || o2.every((t5) => is_complex_ast(t5, i3, r2)) ? true : void 0;
    if (a2 === `^`) {
      let t5 = is_nonzero_ast(o2[0], i3, r2), n3 = is_positive_ast(o2[1], i3, true, r2);
      if (!t5) {
        if (Number.isNaN(o2[0])) return false;
        if (n3) {
          if (t5 === false) return true;
        } else return;
      } else if (is_nonzero_ast(o2[1], i3, r2) === false) return !(o2[0] === 1 / 0 || o2[0] === -1 / 0);
      let a3 = is_complex_ast(o2[0], i3, r2), s2 = is_complex_ast(o2[1], i3, r2);
      return a3 && s2 ? true : void 0;
    }
    return a2 === `/` ? is_nonzero_ast(o2[1], i3, r2) && (is_nonzero_ast(o2[0], i3, r2) === false || is_complex_ast(o2[0], i3, r2) && is_complex_ast(o2[1], i3, r2)) ? true : void 0 : a2 === `apply` ? functions.C.C && functions.C.C.includes(o2[0]) && is_complex_ast(o2[1], i3, r2) || functions.R.C && functions.R.C.includes(o2[0]) && is_real_ast(o2[1], i3, r2) || functions.nonzeroC.C && functions.nonzeroC.C.includes(o2[0]) && is_nonzero_ast(o2[1], i3, r2) && is_complex_ast(o2[1], i3, r2) || functions.nonneg.C && functions.nonneg.C.includes(o2[0]) && is_positive_ast(o2[1], i3, false, r2) || functions.pos.C && functions.pos.C.includes(o2[0]) && is_positive_ast(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_nonzero_ast(t4, n2, r2) {
  if (typeof n2 != `object` && (n2 = []), r2 === void 0 && (r2 = n2), typeof t4 == `number`) return Number.isFinite(t4) ? t4 !== 0 : Number.isNaN(t4) ? void 0 : true;
  var i2 = evaluate_to_constant(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (i2 !== null) return typeof i2 == `number` ? Number.isFinite(i2) ? i2 !== 0 : Number.isNaN(i2) ? void 0 : true : i2.re !== void 0 && i2.im !== void 0 && (i2.re !== 0 || i2.im !== 0) ? true : void 0;
  if (typeof t4 == `string`) {
    let i3;
    if (i3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(i3)) return;
    let a2 = i3, o2 = i3[0], s2 = i3.slice(1), c2 = false;
    for (; o2 === `not`; ) {
      if (c2 = !c2, i3 = s2[0], !Array.isArray(i3)) return;
      o2 = i3[0], s2 = i3.slice(1);
    }
    let l2 = narrow_assumptions(a2, r2);
    if (o2 === `=` && !c2 || o2 === `ne` && c2) {
      if (s2[0] === t4) return is_nonzero_ast(s2[1], l2);
      if (s2[1] === t4) return is_nonzero_ast(s2[0], l2);
    }
    if ((o2 === `ne` && !c2 || o2 === `=` && c2) && (s2[0] === t4 && is_nonzero_ast(s2[1], l2) === false || s2[1] === t4 && is_nonzero_ast(s2[0], l2) === false)) return true;
    if (o2 === `<`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast(s2[1], l2, false) || s2[1] === t4 && is_positive_ast(s2[0], l2, false)) return true;
      } else if (s2[0] === t4 && is_positive_ast(s2[1], l2, true) || s2[1] === t4 && is_negative_ast(s2[0], l2, true)) return true;
    }
    if (o2 === `le`) {
      if (!c2) {
        if (s2[0] === t4 && is_negative_ast(s2[1], l2, true) || s2[1] === t4 && is_positive_ast(s2[0], l2, true)) return true;
      } else if (s2[0] === t4 && is_positive_ast(s2[1], l2, false) || s2[1] === t4 && is_negative_ast(s2[0], l2, false)) return true;
    }
    if (o2 !== `and` && o2 !== `or` || c2) return;
    s2.length > 2 && (i3 = unflattenRight(i3), s2 = i3.slice(1));
    let u2 = is_nonzero_ast(t4, s2[0], r2), d2 = is_nonzero_ast(t4, s2[1], r2);
    return simple_assumption_combination(o2, u2, d2);
  }
  if (Array.isArray(t4)) {
    let i3;
    i3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables(t4)]);
    let a2 = t4[0], o2 = t4.slice(1);
    if (a2 === `-`) return is_nonzero_ast(o2[0], i3, r2);
    if (a2 === `+`) {
      if (o2.length > 2 && (t4 = unflattenRight(t4), o2 = t4.slice(1)), equal(o2[0], simplify([`-`, o2[1]], r2))) return false;
      let n3 = is_nonzero_ast(o2[0], i3, r2), a3 = is_nonzero_ast(o2[1], i3, r2);
      if (n3 === false) return a3;
      if (a3 === false) return n3;
      let s2 = is_real_ast(o2[0], i3, r2), c2 = is_real_ast(o2[1], i3, r2);
      if (!s2 || !c2) return s2 === true ? c2 === false ? true : void 0 : c2 === true && s2 === false ? true : void 0;
      let l2 = is_positive_ast(o2[0], i3, false, r2), u2 = is_positive_ast(o2[1], i3, false, r2), d2 = is_positive_ast(o2[0], i3, true, r2), p2 = is_positive_ast(o2[1], i3, true, r2);
      return l2 && p2 || d2 && u2 || l2 === false && p2 === false || d2 === false && u2 === false ? true : void 0;
    }
    if (a2 === `*`) {
      let t5 = true;
      for (let n3 = 0; n3 < o2.length; n3++) {
        let a3 = is_nonzero_ast(o2[n3], i3, r2);
        if (a3 === false) return false;
        a3 === void 0 && (t5 = false);
      }
      return t5 ? true : void 0;
    }
    if (a2 === `/`) {
      let t5 = is_nonzero_ast(o2[0], i3, r2);
      return is_nonzero_ast(o2[1], i3, r2) ? t5 : void 0;
    }
    if (a2 === `^`) {
      let t5 = is_nonzero_ast(o2[0], i3, r2);
      return t5 ? (o2[0] === 1 / 0 || o2[0] === -1 / 0) && is_nonzero_ast(o2[1], i3, r2) === false ? void 0 : true : is_positive_ast(o2[1], i3, true, r2) && t5 === false ? false : void 0;
    }
    return a2 === `apply` ? functions.C.nonzero && functions.C.nonzero.includes(o2[0]) && is_complex_ast(o2[1], i3, r2) || functions.R.nonzero && functions.R.nonzero.includes(o2[0]) && is_real_ast(o2[1], i3, r2) || functions.nonzeroC.nonzero && functions.nonzeroC.nonzero.includes(o2[0]) && is_nonzero_ast(o2[1], i3, r2) || functions.nonneg.nonzero && functions.nonneg.nonzero.includes(o2[0]) && is_positive_ast(o2[1], i3, false, r2) || functions.pos.nonzero && functions.pos.nonzero.includes(o2[0]) && is_positive_ast(o2[1], i3, true, r2) ? true : void 0 : a2 === `prime` ? void 0 : false;
  }
  return false;
}
function is_positive_ast(t4, n2, r2, i2) {
  if (typeof n2 != `object` && (n2 = []), i2 === void 0 && (i2 = n2), r2 === void 0 && (r2 = true), typeof t4 == `number`) return Number.isFinite(t4) ? r2 ? t4 > 0 : t4 >= 0 : false;
  var a2 = is_real_ast(t4, n2, i2);
  if (!a2) return a2;
  var o2 = evaluate_to_constant(t4, { remove_units_first: false, nan_for_non_numeric: false });
  if (o2 !== null) return typeof o2 == `number` && Number.isFinite(o2) ? r2 ? o2 > 0 : o2 >= 0 : false;
  if (typeof t4 == `string`) {
    let a3;
    if (a3 = Array.isArray(n2) ? n2 : n2.get_assumptions(t4), !Array.isArray(a3)) return;
    let o3 = a3, s2 = a3[0], c2 = a3.slice(1), l2 = false;
    for (; s2 === `not`; ) {
      if (l2 = !l2, a3 = c2[0], !Array.isArray(a3)) return;
      s2 = a3[0], c2 = a3.slice(1);
    }
    let u2 = narrow_assumptions(o3, i2);
    if (s2 === `=` && !l2 || s2 === `ne` && l2) {
      if (c2[0] === t4) return is_positive_ast(c2[1], u2, r2);
      if (c2[1] === t4) return is_positive_ast(c2[0], u2, r2);
    }
    if (s2 === `<`) if (l2) {
      if (c2[0] === t4 && is_positive_ast(c2[1], u2, r2)) return true;
      if (c2[1] === t4 && is_negative_ast(c2[0], u2, !r2)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast(c2[1], u2, false)) return false;
      if (c2[1] === t4 && is_positive_ast(c2[0], u2, false)) return true;
    }
    if (s2 === `le`) if (l2) {
      if (c2[0] === t4 && is_positive_ast(c2[1], u2, false)) return true;
      if (c2[1] === t4 && is_negative_ast(c2[0], u2, false)) return false;
    } else {
      if (c2[0] === t4 && is_negative_ast(c2[1], u2, !r2)) return false;
      if (c2[1] === t4 && is_positive_ast(c2[0], u2, r2)) return true;
    }
    if (s2 !== `and` && s2 !== `or` || l2) return;
    c2.length > 2 && (a3 = unflattenRight(a3), c2 = a3.slice(1));
    let d2 = is_positive_ast(t4, c2[0], r2, i2), p2 = is_positive_ast(t4, c2[1], r2, i2);
    return simple_assumption_combination(s2, d2, p2);
  }
  if (Array.isArray(t4)) {
    let a3;
    a3 = Array.isArray(n2) ? n2 : n2.get_assumptions([variables(t4)]);
    let o3 = t4[0], s2 = t4.slice(1);
    if (o3 === `-`) return is_negative_ast(s2[0], a3, r2, i2);
    if (o3 === `+`) {
      s2.length > 2 && (t4 = unflattenRight(t4), s2 = t4.slice(1));
      let n3 = is_positive_ast(s2[0], a3, false, i2), o4 = is_positive_ast(s2[1], a3, false, i2), c2 = is_positive_ast(s2[0], a3, true, i2), l2 = is_positive_ast(s2[1], a3, true, i2);
      if (r2) {
        if (n3 && l2 || c2 && o4) return true;
      } else if (n3 && o4) return true;
      if (r2) {
        if (c2 === false && l2 === false) return false;
      } else if (n3 === false && l2 === false || c2 === false && o4 === false) return false;
      return;
    }
    if (o3 === `*`) {
      if (!s2.every((t5) => is_nonzero_ast(t5, a3, i2) !== false)) return !r2;
      s2.length > 2 && (t4 = unflattenRight(t4), s2 = t4.slice(1));
      let n3 = is_real_ast(s2[0], a3, i2), o4 = is_real_ast(s2[1], a3, i2);
      if (n3 === void 0 || o4 === void 0) return;
      if (n3 === false) return o4 === false ? void 0 : false;
      if (o4 === false) return false;
      let c2 = is_positive_ast(s2[0], a3, false, i2), l2 = is_positive_ast(s2[1], a3, false, i2), u2 = is_positive_ast(s2[0], a3, true, i2), d2 = is_positive_ast(s2[1], a3, true, i2);
      if (r2) {
        if (u2 && d2 || c2 === false && l2 === false) return true;
        if (u2 === false && l2 || c2 && d2 === false) return false;
      } else {
        if (c2 && l2 || u2 === false && d2 === false) return true;
        if (u2 && l2 === false || c2 === false && d2) return false;
      }
      return;
    }
    if (o3 === `/`) {
      if (!is_nonzero_ast(s2[1], a3, i2)) return;
      if (is_nonzero_ast(s2[0], a3, i2) === false) return !r2;
      let t5 = is_positive_ast(s2[1], a3, true, i2);
      if (t5 === void 0) return;
      let n3 = t5 ? r2 : !r2, o4 = is_positive_ast(s2[0], a3, n3, i2);
      return o4 === void 0 ? void 0 : o4 === true ? t5 === true : t5 !== true;
    }
    if (o3 === `^`) {
      let t5 = is_nonzero_ast(s2[0], a3, i2);
      if (!t5) if (is_positive_ast(s2[1], a3, true, i2)) {
        if (t5 === false) return !r2;
        if (r2) return;
      } else return;
      else if (is_nonzero_ast(s2[1], a3, i2) === false) return s2[0] === 1 / 0 || s2[0] === -1 / 0 ? void 0 : true;
      return is_real_ast(s2[0], a3, i2) === true ? is_positive_ast(s2[0], a3, r2, i2) ? is_real_ast(s2[1], a3, i2) ? true : void 0 : is_integer_ast(simplify([`/`, s2[1], 2], i2), a3, i2) ? true : void 0 : void 0;
    }
    return o3 === `apply` && !r2 ? functions.C.nonneg && functions.C.nonneg.includes(s2[0]) && is_complex_ast(s2[1], a3, i2) || functions.R.nonneg && functions.R.nonneg.includes(s2[0]) && is_real_ast(s2[1], a3, i2) || functions.nonzeroC.nonneg && functions.nonzeroC.nonneg.includes(s2[0]) && is_nonzero_ast(s2[1], a3, i2) && is_complex_ast(s2[1], a3, i2) || functions.nonneg.nonneg && functions.nonneg.nonneg.includes(s2[0]) && is_positive_ast(s2[1], a3, false, i2) || functions.pos.nonneg && functions.pos.nonneg.includes(s2[0]) && is_positive_ast(s2[1], a3, true, i2) ? true : void 0 : o3 === `apply` && r2 ? functions.C.pos && functions.C.pos.includes(s2[0]) && is_complex_ast(s2[1], a3, i2) || functions.R.pos && functions.R.pos.includes(s2[0]) && is_real_ast(s2[1], a3, i2) || functions.nonzeroC.pos && functions.nonzeroC.pos.includes(s2[0]) && is_nonzero_ast(s2[1], a3, i2) && is_complex_ast(s2[1], a3, i2) || functions.nonneg.pos && functions.nonneg.pos.includes(s2[0]) && is_positive_ast(s2[1], a3, false, i2) || functions.pos.pos && functions.pos.pos.includes(s2[0]) && is_positive_ast(s2[1], a3, true, i2) ? true : void 0 : o3 === `prime` ? void 0 : false;
  }
  return false;
}
function is_negative_ast(t4, n2, r2, i2) {
  r2 === void 0 && (r2 = true);
  var a2 = is_real_ast(t4, n2, i2);
  if (a2 === true) {
    let a3 = is_positive_ast(t4, n2, !r2, i2);
    return a3 === false ? true : a3 === true ? false : void 0;
  }
  return a2;
}
function ParseError(t4, n2) {
  this.name = `ParseError`, this.message = t4 || `Error parsing input`, this.stack = Error().stack, this.location = n2;
}
ParseError.prototype = Object.create(Error.prototype), ParseError.prototype.constructor = ParseError;
var lexer = class {
  constructor(t4, n2 = `\\s`) {
    this.input = ``, this.location = 0, this.token_rules = [], this.initial_whitespace = RegExp(`^(` + n2 + `)+`);
    for (let n3 of t4) this.token_rules.push([RegExp(`^` + n3[0])].concat(n3.slice(1)));
  }
  set_input(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.input = t4, this.location = 0;
  }
  return_state() {
    return { input: this.input, location: this.location };
  }
  set_state({ input: t4 = null, location: n2 = 0 } = {}) {
    t4 !== null && (this.input = t4, this.location = n2);
  }
  advance({ remove_initial_space: t4 = true } = {}) {
    let n2 = this.initial_whitespace.exec(this.input);
    if (n2) {
      let r3 = n2[0].length;
      if (this.input = this.input.slice(r3), this.location += r3, !t4) return { token_type: `SPACE`, token_text: n2[0], original_text: n2[0] };
    }
    if (this.input.length === 0) return { token_type: `EOF`, token_text: ``, original_text: `` };
    n2 = null;
    for (var r2 of this.token_rules) if (n2 = r2[0].exec(this.input), n2) {
      let t5 = n2[0].length;
      this.input = this.input.slice(t5), this.location += t5;
      break;
    }
    return n2 === null ? { token_type: `INVALID`, token_text: this.input[0], original_text: this.input[0] } : r2.length > 2 ? { token_type: r2[1], token_text: r2[2], original_text: n2[0] } : { token_type: r2[1], token_text: n2[0], original_text: n2[0] };
  }
  unput(t4) {
    if (typeof t4 != `string`) throw Error(`Input must be a string`);
    this.location -= t4.length, this.input = t4 + this.input;
  }
}, is_associative = { "+": true, "*": true, and: true, or: true, union: true, intersect: true };
function flatten(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (r2 = r2.map(function(t5, n3) {
    return flatten(t5);
  }), is_associative[n2]) {
    for (var i2 = [], a2 = 0; a2 < r2.length; a2++) Array.isArray(r2[a2]) && r2[a2][0] === n2 && r2[a2].length > 2 ? i2 = i2.concat(r2[a2].slice(1)) : i2.push(r2[a2]);
    r2 = i2;
  }
  return [n2].concat(r2);
}
var number_rules_sci$1 = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|\\||\\)|\\}|\\])))?`, `NUMBER`]], number_rules_non_sci$1 = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_text_rules = [[`\\*\\*`, `^`], [`\\*`, `*`], [`\\xB7`, `*`], [`·`, `*`], [`•`, `*`], [`⋅`, `*`], [`×`, `*`], [`/`, `/`], [`-`, `-`], [`֊`, `-`], [`־`, `-`], [`᠆`, `-`], [`‐`, `-`], [`‑`, `-`], [`‒`, `-`], [`–`, `-`], [`—`, `-`], [`―`, `-`], [`⁻`, `-`], [`₋`, `-`], [`−`, `-`], [`⸺`, `-`], [`⸻`, `-`], [`﹘`, `-`], [`﹣`, `-`], [`－`, `-`], [`\\+`, `+`], [`plusminus(?![a-zA-Z0-9])`, `PM`], [`±`, `PM`], [`\\^`, `^`], [`‸`, `^`], [`ʌ`, `^`], [`′`, `'`], [`\\|`, `|`], [`\\(`, `(`], [`\\)`, `)`], [`\\[`, `[`], [`\\]`, `]`], [`\\{`, `{`], [`\\}`, `}`], [`⟨`, `LANGLE`], [`⟩`, `RANGLE`], [`〈`, `LANGLE`], [`〉`, `RANGLE`], [`,`, `,`], [`:`, `:`], [`α`, `VARMULTICHAR`, `alpha`], [`β`, `VARMULTICHAR`, `beta`], [`ϐ`, `VARMULTICHAR`, `beta`], [`Γ`, `VARMULTICHAR`, `Gamma`], [`γ`, `VARMULTICHAR`, `gamma`], [`Δ`, `VARMULTICHAR`, `Delta`], [`δ`, `VARMULTICHAR`, `delta`], [`ε`, `VARMULTICHAR`, `epsilon`], [`ϵ`, `VARMULTICHAR`, `epsilon`], [`ζ`, `VARMULTICHAR`, `zeta`], [`η`, `VARMULTICHAR`, `eta`], [`Θ`, `VARMULTICHAR`, `Theta`], [`ϴ`, `VARMULTICHAR`, `Theta`], [`θ`, `VARMULTICHAR`, `theta`], [`ᶿ`, `VARMULTICHAR`, `theta`], [`ϑ`, `VARMULTICHAR`, `theta`], [`ι`, `VARMULTICHAR`, `iota`], [`κ`, `VARMULTICHAR`, `kappa`], [`Λ`, `VARMULTICHAR`, `Lambda`], [`λ`, `VARMULTICHAR`, `lambda`], [`μ`, `VARMULTICHAR`, `mu`], [`µ`, `VARMULTICHAR`, `mu`], [`ν`, `VARMULTICHAR`, `nu`], [`Ξ`, `VARMULTICHAR`, `Xi`], [`ξ`, `VARMULTICHAR`, `xi`], [`Π`, `VARMULTICHAR`, `Pi`], [`π`, `VARMULTICHAR`, `pi`], [`ϖ`, `VARMULTICHAR`, `pi`], [`ρ`, `VARMULTICHAR`, `rho`], [`ϱ`, `VARMULTICHAR`, `rho`], [`Σ`, `VARMULTICHAR`, `Sigma`], [`σ`, `VARMULTICHAR`, `sigma`], [`ς`, `VARMULTICHAR`, `sigma`], [`τ`, `VARMULTICHAR`, `tau`], [`Υ`, `VARMULTICHAR`, `Upsilon`], [`υ`, `VARMULTICHAR`, `upsilon`], [`Φ`, `VARMULTICHAR`, `Phi`], [`φ`, `VARMULTICHAR`, `phi`], [`ϕ`, `VARMULTICHAR`, `phi`], [`Ψ`, `VARMULTICHAR`, `Psi`], [`ψ`, `VARMULTICHAR`, `psi`], [`Ω`, `VARMULTICHAR`, `Omega`], [`ω`, `VARMULTICHAR`, `omega`], [`∅`, `VARMULTICHAR`, `emptyset`], [`oo(?![a-zA-Z0-9])`, `INFINITY`], [`OO(?![a-zA-Z0-9])`, `INFINITY`], [`infty(?![a-zA-Z0-9])`, `INFINITY`], [`infinity(?![a-zA-Z0-9])`, `INFINITY`], [`Infinity(?![a-zA-Z0-9])`, `INFINITY`], [`∞`, `INFINITY`], [`ℯ`, `VAR`, `e`], [`♠`, `VARMULTICHAR`, `spade`], [`♡`, `VARMULTICHAR`, `heart`], [`♢`, `VARMULTICHAR`, `diamond`], [`♣`, `VARMULTICHAR`, `club`], [`★`, `VARMULTICHAR`, `bigstar`], [`◯`, `VARMULTICHAR`, `bigcirc`], [`◊`, `VARMULTICHAR`, `lozenge`], [`△`, `VARMULTICHAR`, `bigtriangleup`], [`▽`, `VARMULTICHAR`, `bigtriangledown`], [`⧫`, `VARMULTICHAR`, `blacklozenge`], [`■`, `VARMULTICHAR`, `blacksquare`], [`▲`, `VARMULTICHAR`, `blacktriangle`], [`▼`, `VARMULTICHAR`, `blacktriangledown`], [`◀`, `VARMULTICHAR`, `blacktriangleleft`], [`▶`, `VARMULTICHAR`, `blacktriangleright`], [`□`, `VARMULTICHAR`, `Box`], [`∘`, `VARMULTICHAR`, `circ`], [`⋆`, `VARMULTICHAR`, `star`], [`and(?![a-zA-Z0-9])`, `AND`], [`\\&\\&?`, `AND`], [`∧`, `AND`], [`or(?![a-zA-Z0-9])`, `OR`], [`∨`, `OR`], [`not(?![a-zA-Z0-9])`, `NOT`], [`¬`, `NOT`], [`=`, `=`], [`᐀`, `=`], [`゠`, `=`], [`!=`, `NE`], [`≠`, `NE`], [`<=`, `LE`], [`≤`, `LE`], [`>=`, `GE`], [`≥`, `GE`], [`<`, `<`], [`>`, `>`], [`forall(?![a-zA-Z0-9])`, `FORALL`], [`∀`, `FORALL`], [`exists(?![a-zA-Z0-9])`, `EXISTS`], [`∃`, `EXISTS`], [`elementof(?![a-zA-Z0-9])`, `IN`], [`∈`, `IN`], [`notelementof(?![a-zA-Z0-9])`, `NOTIN`], [`∉`, `NOTIN`], [`containselement(?![a-zA-Z0-9])`, `NI`], [`∋`, `NI`], [`notcontainselement(?![a-zA-Z0-9])`, `NOTNI`], [`∌`, `NOTNI`], [`subset(?![a-zA-Z0-9])`, `SUBSET`], [`⊂`, `SUBSET`], [`subseteq(?![a-zA-Z0-9])`, `SUBSETEQ`], [`⊆`, `SUBSETEQ`], [`notsubset(?![a-zA-Z0-9])`, `NOTSUBSET`], [`⊄`, `NOTSUBSET`], [`notsubseteq(?![a-zA-Z0-9])`, `NOTSUBSETEQ`], [`⊈`, `NOTSUBSETEQ`], [`superset(?![a-zA-Z0-9])`, `SUPERSET`], [`⊃`, `SUPERSET`], [`superseteq(?![a-zA-Z0-9])`, `SUPERSETEQ`], [`⊇`, `SUPERSETEQ`], [`notsuperset(?![a-zA-Z0-9])`, `NOTSUPERSET`], [`⊅`, `NOTSUPERSET`], [`notsuperseteq(?![a-zA-Z0-9])`, `NOTSUPERSETEQ`], [`⊉`, `NOTSUPERSETEQ`], [`union(?![a-zA-Z0-9])`, `UNION`], [`∪`, `UNION`], [`intersect(?![a-zA-Z0-9])`, `INTERSECT`], [`∩`, `INTERSECT`], [`rightarrow(?![a-zA-Z0-9])`, `RIGHTARROW`], [`→`, `RIGHTARROW`], [`⟶`, `RIGHTARROW`], [`leftarrow(?![a-zA-Z0-9])`, `LEFTARROW`], [`←`, `LEFTARROW`], [`⟵`, `LEFTARROW`], [`leftrightarrow(?![a-zA-Z0-9])`, `LEFTRIGHTARROW`], [`↔`, `LEFTRIGHTARROW`], [`⟷`, `LEFTRIGHTARROW`], [`implies(?![a-zA-Z0-9])`, `IMPLIES`], [`⇒`, `IMPLIES`], [`⟹`, `IMPLIES`], [`impliedby(?![a-zA-Z0-9])`, `IMPLIEDBY`], [`⇐`, `IMPLIEDBY`], [`⟸`, `IMPLIEDBY`], [`iff(?![a-zA-Z0-9])`, `IFF`], [`⇔`, `IFF`], [`⟺`, `IFF`], [`perp(?![a-zA-Z0-9])`, `PERP`], [`⟂`, `PERP`], [`parallel(?![a-zA-Z0-9])`, `PARALLEL`], [`∥`, `PARALLEL`], [`angle(?![a-zA-Z0-9])`, `ANGLE`], [`∠`, `ANGLE`], [`int(?![a-zA-Z0-9])`, `INT`], [`∫`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`\\.\\.\\.`, `LDOTS`], [`[a-zA-Z∂][a-zA-Z∂0-9]*`, `VAR`], [`[＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault$1 = true, splitSymbolsDefault = true, unsplitSymbolsDefault = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.angle.deg.emptyset`.split(`.`), appliedFunctionSymbolsDefault$1 = `abs.exp.log.ln.log10.sign.sqrt.cbrt.nthroot.mod.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.re.im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault$1 = [`f`, `g`], operatorSymbolsDefault$1 = [`binom`, `vec`, `linesegment`], unitsDefault$1 = get_all_units(), parseLeibnizNotationDefault$1 = true, textToAst$4 = class {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault$1, splitSymbols: n2 = splitSymbolsDefault, unsplitSymbols: r2 = unsplitSymbolsDefault, appliedFunctionSymbols: i2 = appliedFunctionSymbolsDefault$1, functionSymbols: a2 = functionSymbolsDefault$1, operatorSymbols: o2 = operatorSymbolsDefault$1, units: s2 = unitsDefault$1, parseLeibnizNotation: c2 = parseLeibnizNotationDefault$1, parseScientificNotation: l2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.splitSymbols = n2, this.unsplitSymbols = r2, this.appliedFunctionSymbols = i2, this.functionSymbols = a2, this.operatorSymbols = o2, this.units = s2, this.parseLeibnizNotation = c2;
    let u2 = base_text_rules;
    u2 = l2 ? [...number_rules_sci$1, ...u2] : [...number_rules_non_sci$1, ...u2], this.lexer = new lexer(u2);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      return this.token.token_type === `:` ? (this.advance(), [`:`, r2, this.statement_a()]) : r2;
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let n3 = r2.length;
      for (let [t5, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && t5 < n3 - 1) {
            let o2;
            o2 = t5 === n3 - 2 ? r2[n3 - 1] : this.convert_units_in_term([`*`, ...r2.slice(t5 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return t5 === 0 ? c2 : [`*`, ...r2.slice(0, t5), c2];
          } else if (!a2.prefix && t5 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = t5 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, t5)], o2], t5 === n3 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(t5 + 1)]);
          }
        }
      }
      return t4;
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    return t4;
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n2 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n2 === false && (n2 = `＿`), n2;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`) if (a2 = this.token.token_text, this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
      let t5 = false;
      if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), this.advance(), this.token.token_type === `_`) {
        this.advance();
        let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
        a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
      }
      if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
      else {
        for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
        for (; this.token.token_type === `^`; ) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = [`^`, a2, t6];
        }
        if (this.token.token_type === `(`) {
          this.advance();
          let t6 = this.statement_list();
          if (this.token.token_type !== `)`) throw new ParseError(`Expecting )`, this.lexer.location);
          this.advance(), t6[0] === `list` && (t6[0] = `tuple`), a2 = [`apply`, a2, t6];
        } else if (t5) {
          if (!this.allowSimplifiedFunctionApplication) throw new ParseError(`Expecting ( after function`, this.lexer.location);
          let t6 = this.factor({ parse_absolute_value: n2 });
          t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
        }
      }
      return a2;
    } else if (this.operatorSymbols.includes(a2)) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError(`Expecting )`, this.lexer.location);
      this.advance(), a2 = t5[0] === `list` ? [a2, ...t5.slice(1)] : [a2, t5];
    } else {
      let t5 = this.factor({ parse_absolute_value: n2 });
      t5 === false && (t5 = `＿`), a2 = [a2, t5];
    }
    else {
      if (this.parseLeibnizNotation) {
        let t5 = this.return_state(), n3 = this.leibniz_notation();
        if (n3) return n3;
        this.set_state(t5);
      }
      let i3 = this.splitSymbols;
      if (i3 && (this.token.token_type === `VARMULTICHAR` || this.unsplitSymbols.includes(a2) || a2.length === 1 || a2.match(/[\d]/g)) && (i3 = false), i3) {
        for (let t5 = a2.length - 1; t5 >= 0; t5--) this.lexer.unput(` `), this.lexer.unput(a2[t5]);
        return this.advance(), this.baseFactor({ inside_absolute_value: t4, parse_absolute_value: n2, allow_absolute_value_closing: r2 });
      } else this.advance();
    }
    else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `{` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `{` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type === `|` && n2 && (t4 === 0 || !r2)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `(`) {
      this.advance();
      let t5 = this.statement_list();
      if (this.token.token_type !== `)`) throw new ParseError(`Expecting )`, this.lexer.location);
      this.advance(), t5[0] === `list` ? a2 = [`angle`, ...t5.slice(1)] : t5[0] === `*` && (a2 = [`angle`, t5]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    var t4 = this.token.token_text;
    if (!(this.token.token_type === `VAR` && (t4[0] === `d` || t4[0] === `∂`) && (t4.length === 1 || t4.length === 2 && /[a-zA-Z]/.exec(t4[1])))) return false;
    let n2 = t4[0], r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (t4.length === 2) i2 = t4[1];
    else if (this.advance(), this.token.token_type === `VARMULTICHAR` || this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`)) i2 = this.token.token_text;
    else {
      if (this.token.token_type !== `^` || (this.advance(), this.token.token_type !== `NUMBER`) || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2))) return false;
      if (this.advance(), this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`) i2 = this.token.token_text;
      else return false;
    }
    if (this.advance(), this.token.token_type !== `/`) return false;
    let s2 = 0;
    for (this.advance(); ; ) {
      if (this.token.token_type !== `VAR` || this.token.token_text[0] !== n2) return false;
      this.token.token_text.length > 2 && (this.lexer.unput(this.token.token_text.slice(2)), this.token.token_text = this.token.token_text.slice(0, 2));
      let c2 = this.token.token_text;
      if (c2.length === 2) if (/[a-zA-Z]/.exec(c2[1])) a2.push(c2[1]);
      else return false;
      else {
        if (this.advance(), !(this.token.token_type === `VAR` && !this.token.token_text.includes(`∂`) || this.token.token_type === `VARMULTICHAR`)) return false;
        a2.push(this.token.token_text);
      }
      let l2 = 1, u2 = false;
      if (this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance()), this.token.token_type === `^`) {
        if (this.advance(), this.token.token_type !== `NUMBER` || (l2 = parseFloat(this.token.token_text), !Number.isInteger(l2))) return false;
        u2 = false, this.advance({ remove_initial_space: false }), this.token.token_type === `SPACE` && (u2 = true, this.advance());
      }
      if (o2.push(l2), s2 += l2, s2 > r2) return false;
      if (s2 === r2) {
        if (!u2 && (this.token.token_type === `VAR` || this.token.token_type === `VARMULTICHAR`)) return false;
        this.token.token_type === `SPACE` && this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, MAX_PM_COUNT = 10, MAX_PM_EXPANSIONS = 1 << MAX_PM_COUNT;
function contains_pm(t4) {
  if (!Array.isArray(t4)) return false;
  if (t4[0] === `pm`) return true;
  for (let n2 = 1; n2 < t4.length; n2++) if (contains_pm(t4[n2])) return true;
  return false;
}
function count_pm(t4) {
  if (!Array.isArray(t4)) return 0;
  let n2 = +(t4[0] === `pm`);
  for (let r2 = 1; r2 < t4.length; r2++) n2 += count_pm(t4[r2]);
  return n2;
}
function expand_pm_signs(t4) {
  let n2 = count_pm(t4);
  if (n2 === 0) return [t4];
  if (n2 > MAX_PM_COUNT) throw Error(`pm: cannot expand ${n2} plus-minus operators (limit is ${MAX_PM_COUNT} → ${MAX_PM_EXPANSIONS} combinations)`);
  let r2 = 1 << n2, i2 = [];
  for (let n3 = 0; n3 < r2; n3++) i2.push(replace_pm(t4, n3, { idx: 0 }));
  return i2;
}
function replace_pm(t4, n2, r2) {
  if (!Array.isArray(t4)) return t4;
  if (t4[0] === `pm`) {
    let i3 = n2 >> r2.idx & 1;
    r2.idx += 1;
    let a2 = replace_pm(t4[1], n2, r2);
    return i3 === 0 ? a2 : [`-`, a2];
  }
  let i2 = [t4[0]];
  for (let a2 = 1; a2 < t4.length; a2++) i2.push(replace_pm(t4[a2], n2, r2));
  return i2;
}
var transformation_exports = __exportAll({ expand: () => expand, expand_relations: () => expand_relations, get_component: () => get_component, perform_matrix_multiplications: () => perform_matrix_multiplications, perform_matrix_scalar_multiplications: () => perform_matrix_scalar_multiplications, perform_vector_scalar_multiplications: () => perform_vector_scalar_multiplications, substitute: () => substitute, substitute_component: () => substitute_component }), textToAst$3 = new textToAst$4();
function expand(t4, n2) {
  var r2 = get_tree(t4);
  r2 = perform_matrix_multiplications(r2), r2 = perform_vector_matrix_additions_scalar_multiplications(r2);
  let i2 = (t5) => !Array.isArray(t5) || ![`d`, `*`].includes(t5[0]) || t5[0] === `*` && t5.slice(1).every((t6) => !Array.isArray(t6) || t6[0] !== `d`), a2 = (t5) => i2(t5) && !contains_pm(t5), o2 = (t5) => !contains_pm(t5);
  var s2 = [];
  return s2.push([textToAst$3.convert(`a*(b+c)`), textToAst$3.convert(`a*b+a*c`), { variables: { a: a2, b: true, c: true }, allow_extended_match: true }]), s2.push([textToAst$3.convert(`(a+b)*c`), textToAst$3.convert(`a*c+b*c`), { variables: { a: true, b: true, c: a2 }, allow_extended_match: true }]), n2 || s2.push([textToAst$3.convert(`(a+b)/c`), textToAst$3.convert(`a/c+b/c`), { variables: { a: true, b: true, c: o2 } }]), s2.push([textToAst$3.convert(`-(a+b)`), textToAst$3.convert(`-a-b`)]), s2.push([textToAst$3.convert(`a(-b)`), textToAst$3.convert(`-ab`)]), s2.push([textToAst$3.convert(`(a+b)^2`), textToAst$3.convert(`a^2+2ab+b^2`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3.convert(`(a+b)^3`), textToAst$3.convert(`a^3+3a^2b+3ab^2+b^3`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3.convert(`(a+b)^4`), textToAst$3.convert(`a^4+4a^3b+6a^2b^2+4ab^3+b^4`), { variables: { a: o2, b: o2 } }]), s2.push([textToAst$3.convert(`a*(b+c)*d`), textToAst$3.convert(`(a*b+a*c)*d`), { variables: { a: o2, b: true, c: true, d: true } }]), r2 = applyAllTransformations(r2, s2, 20), r2 = flatten$5(r2), r2 = evaluate_numbers(r2), r2 = collect_like_terms_factors(r2), r2 = normalize_negatives(r2), r2;
}
function perform_matrix_multiplications(t4, n2 = true, r2 = true) {
  var i2 = get_tree(t4);
  function a2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = n3[1][2];
    if (n3[1][1] !== i3) return { success: false };
    let o3 = t5[2], s3 = n3[2], c3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let n4 = o3[t6 + 1].slice(1), r4 = [`tuple`];
      for (let t7 = 0; t7 < a3; t7++) {
        let a4 = s3.slice(1).map((n5) => n5[t7 + 1]);
        if (n4.length !== i3 || a4.length !== i3) return subtree;
        let o4 = [`+`, ...n4.map((t8, n5) => [`*`, t8, a4[n5]])];
        r4.push(o4);
      }
      c3.push(r4);
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, a3], c3] };
  }
  function o2(t5, n3) {
    if (!Number.isInteger(n3) || n3 < 1) return { success: false };
    if (n3 === 1) return { success: true, newMatrix: t5 };
    let r3 = t5[1][1];
    if (t5[1][2] !== r3) return { success: false };
    let i3 = t5[2], a3 = JSON.parse(JSON.stringify(i3));
    for (let t6 = 1; t6 < n3; t6++) {
      let t7 = a3;
      a3 = [`tuple`];
      for (let n4 = 0; n4 < r3; n4++) {
        let o3 = t7[n4 + 1].slice(1), s3 = [`tuple`];
        for (let t8 = 0; t8 < r3; t8++) {
          let n5 = i3.slice(1).map((n6) => n6[t8 + 1]);
          if (o3.length !== r3 || n5.length !== r3) return subtree;
          let a4 = [`+`, ...o3.map((t9, r4) => [`*`, t9, n5[r4]])];
          s3.push(a4);
        }
        a3.push(s3);
      }
    }
    return { success: true, newMatrix: [`matrix`, [`tuple`, r3, r3], a3] };
  }
  function s2(t5, n3) {
    let r3 = t5[1][1], i3 = t5[1][2], a3 = t5[2], o3 = [`tuple`];
    for (let t6 = 0; t6 < r3; t6++) {
      let r4 = [`tuple`], s3 = a3[t6 + 1];
      for (let t7 = 0; t7 < i3; t7++) r4.push([`*`, n3, s3[t7 + 1]]);
      o3.push(r4);
    }
    return [`matrix`, [`tuple`, r3, i3], o3];
  }
  function c2() {
    let t5 = [`^`, [`matrix`, `size`, `matrixData`], `p`], n3 = { variables: { p: (t6) => Number.isInteger(t6) && t6 > 0, size: true, matrixData: true } };
    i2 = transform(i2, function(r3) {
      let i3 = match$1(r3, t5, n3);
      if (i3) {
        let t6 = o2([`matrix`, i3.size, i3.matrixData], i3.p);
        return t6.success ? t6.newMatrix : r3;
      } else return r3;
    });
  }
  function l2() {
    let t5 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], n3 = { variables: { a: true, b: true, size: true, matrixData: true }, allow_implicit_identities: [`a`, `b`] };
    i2 = transform(i2, function(r3) {
      let i3 = match$1(r3, t5, n3);
      if (i3) {
        let t6 = [`matrix`, i3.size, i3.matrixData], n4 = [], r4 = [];
        Array.isArray(i3.a) && i3.a[0] === `*` ? n4.push(...i3.a.slice(1)) : n4.push(i3.a), Array.isArray(i3.b) && i3.b[0] === `*` ? r4.push(...i3.b.slice(1)) : r4.push(i3.b);
        let o3 = n4.length;
        for (let r5 = o3 - 1; r5 >= 0; r5--) {
          let i4 = n4[r5][0];
          if (i4 === `matrix`) {
            let i5 = a2(n4[r5], t6);
            if (i5.success) t6 = i5.newMatrix, n4.pop();
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(i4)) break;
          else n4[r5] !== 1 && (t6 = s2(t6, n4[r5])), n4.pop();
        }
        for (; r4.length > 0; ) {
          let n5 = r4[0][0];
          if (n5 === `matrix`) {
            let n6 = a2(t6, r4[0]);
            if (n6.success) t6 = n6.newMatrix, r4.splice(0, 1);
            else break;
          } else if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`].includes(n5)) break;
          else r4[0] !== 1 && (t6 = s2(t6, r4[0])), r4.splice(0, 1);
        }
        return n4.length > 0 || r4.length > 0 ? [`*`, ...n4, t6, ...r4] : t6;
      } else return r3;
    });
  }
  function u2() {
    let t5 = [`*`, [`matrix`, [`tuple`, `m`, `n`], `matrixData`], `b`], a3 = { variables: { n: Number.isInteger, m: Number.isInteger, matrixData: true, b: true } };
    i2 = transform(i2, function(i3) {
      let o3 = match$1(i3, t5, a3);
      if (o3) {
        let t6 = o3.m, a4 = o3.n, s3 = o3.b, c3 = o3.matrixData, l3 = [];
        n2 && (l3.push(`vector`), l3.push(`altvector`)), r2 && l3.push(`tuple`);
        let u3, d2 = [];
        if (l3.includes(s3[0])) u3 = s3;
        else if (Array.isArray(s3) && s3[0] === `*` && l3.includes(s3[1][0])) u3 = s3[1], d2 = s3.slice(2);
        else return i3;
        let p2 = u3.slice(1);
        if (p2.length !== a4) return i3;
        let m2 = [u3[0]];
        for (let n3 = 0; n3 < t6; n3++) {
          let t7 = [`+`, ...c3[n3 + 1].slice(1).map((t8, n4) => [`*`, t8, p2[n4]])];
          m2.push(t7);
        }
        return d2.length > 0 ? [`*`, m2, ...d2] : m2;
      } else return i3;
    });
  }
  return c2(), l2(), (n2 || r2) && u2(), i2;
}
function perform_vector_scalar_multiplications(t4, n2 = true) {
  var r2 = get_tree(t4);
  let i2 = function(t5, n3) {
    let r3 = [`*`, `a`, [n3, `vectorData`], `b`], i3 = { allow_implicit_identities: [`a`, `b`] };
    return t5 = transform(t5, function(t6) {
      let a2 = match$1(t6, r3, i3);
      if (a2) {
        if (a2.a === 1 && a2.b === 1) return t6;
        let r4 = a2.vectorData;
        r4 = Array.isArray(r4) && r4[0] === n3 ? r4.slice(1) : [r4];
        let i4 = [], o2 = [];
        Array.isArray(a2.a) && a2.a[0] === `*` ? i4.push(...a2.a.slice(1)) : i4.push(a2.a), Array.isArray(a2.b) && a2.b[0] === `*` ? o2.push(...a2.b.slice(1)) : o2.push(a2.b);
        let s2 = i4.length;
        for (let t7 = s2 - 1; t7 >= 0; t7--) {
          let n4 = i4[t7][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
          i4[t7] !== 1 && (r4 = r4.map((n5) => [`*`, n5, i4[t7]])), i4.pop();
        }
        for (; o2.length > 0; ) {
          let t7 = o2[0][0];
          if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t7)) break;
          o2[0] !== 1 && (r4 = r4.map((t8) => [`*`, t8, o2[0]])), o2.splice(0, 1);
        }
        let c2 = [n3, ...r4];
        return i4.length > 0 || o2.length > 0 ? [`*`, ...i4, c2, ...o2] : c2;
      } else return t6;
    }), t5;
  };
  return r2 = i2(r2, `vector`), r2 = i2(r2, `altvector`), n2 && (r2 = i2(r2, `tuple`)), r2;
}
function perform_matrix_scalar_multiplications(t4) {
  var n2 = get_tree(t4);
  let r2 = [`*`, `a`, [`matrix`, `size`, `matrixData`], `b`], i2 = { allow_implicit_identities: [`a`, `b`] };
  return n2 = transform(n2, function(t5) {
    let n3 = match$1(t5, r2, i2);
    if (n3) {
      if (n3.a === 1 && n3.b === 1) return t5;
      let r3 = n3.matrixData, i3 = [], a2 = [];
      Array.isArray(n3.a) && n3.a[0] === `*` ? i3.push(...n3.a.slice(1)) : i3.push(n3.a), Array.isArray(n3.b) && n3.b[0] === `*` ? a2.push(...n3.b.slice(1)) : a2.push(n3.b);
      let o2 = i3.length;
      for (let t6 = o2 - 1; t6 >= 0; t6--) {
        let n4 = i3[t6][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(n4)) break;
        i3[t6] !== 1 && (r3 = r3.map((n5) => n5 === `tuple` ? n5 : n5.map((n6) => n6 === `tuple` ? n6 : [`*`, n6, i3[t6]]))), i3.pop();
      }
      for (; a2.length > 0; ) {
        let t6 = a2[0][0];
        if ([`tuple`, `list`, `vector`, `altvector`, `interval`, `set`, `array`, `matrix`].includes(t6)) break;
        a2[0] !== 1 && (r3 = r3.map((t7) => t7 === `tuple` ? t7 : t7.map((t8) => t8 === `tuple` ? t8 : [`*`, t8, a2[0]]))), a2.splice(0, 1);
      }
      let s2 = [`matrix`, n3.size, r3];
      return i3.length > 0 || a2.length > 0 ? [`*`, ...i3, s2, ...a2] : s2;
    } else return t5;
  }), n2;
}
function expand_relations(t4) {
  return transform(get_tree(t4), expand_relations_transform);
}
function expand_relations_transform(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `=`) {
    if (r2.length <= 2) return t4;
    let n3 = [`and`];
    for (let t5 = 0; t5 < r2.length - 1; t5++) n3.push([`=`, r2[t5], r2[t5 + 1]]);
    return n3;
  }
  if (n2 === `gts` || n2 === `lts`) {
    let t5 = r2[0], i2 = r2[1];
    if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let a2 = [];
    for (let r3 = 1; r3 < t5.length - 1; r3++) {
      let o3;
      o3 = i2[r3] ? n2 === `lts` ? `<` : `>` : n2 === `lts` ? `le` : `ge`, a2.push([o3, t5[r3], t5[r3 + 1]]);
    }
    let o2 = [`and`, a2[0], a2[1]];
    for (let t6 = 2; t6 < a2.length; t6++) o2 = [`and`, o2, a2[t6]];
    return o2;
  }
  if (n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni`) {
    let i2 = false;
    (n2 === `notin` || n2 === `notni`) && (i2 = true);
    let a2, o2;
    if (n2 === `in` || n2 === `notin` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), o2 = to_intervals(o2), o2[0] !== `interval`) return t4;
    let s2 = o2[1], c2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let l2 = s2[1], u2 = s2[2], d2 = [];
    c2[1] ? i2 ? d2.push([`<`, a2, l2]) : d2.push([`ge`, a2, l2]) : i2 ? d2.push([`le`, a2, l2]) : d2.push([`>`, a2, l2]), c2[2] ? i2 ? d2.push([`>`, a2, u2]) : d2.push([`le`, a2, u2]) : i2 ? d2.push([`ge`, a2, u2]) : d2.push([`<`, a2, u2]);
    let p2;
    return p2 = i2 ? [`or`].concat(d2) : [`and`].concat(d2), p2;
  }
  if (n2 === `subset` || n2 === `notsubset` || n2 === `superset` || n2 === `notsuperset`) {
    let i2 = false;
    (n2 === `notsubset` || n2 === `notsuperset`) && (i2 = true);
    let a2, o2;
    if (n2 === `subset` || n2 === `notsubset` ? (a2 = r2[0], o2 = r2[1]) : (a2 = r2[1], o2 = r2[0]), a2 = to_intervals(a2), o2 = to_intervals(o2), a2[0] !== `interval` || o2[0] !== `interval`) return t4;
    let s2 = a2[1], c2 = a2[2], l2 = o2[1], u2 = o2[2];
    if (s2[0] !== `tuple` || c2[0] !== `tuple` || l2[0] !== `tuple` || u2[0] !== `tuple`) throw Error(`Badly formed ast`);
    let d2 = s2[1], p2 = s2[2], m2 = l2[1], h2 = l2[2], g2 = [];
    c2[1] && !u2[1] ? i2 ? g2.push([`le`, d2, m2]) : g2.push([`>`, d2, m2]) : i2 ? g2.push([`<`, d2, m2]) : g2.push([`ge`, d2, m2]), c2[2] && !u2[2] ? i2 ? g2.push([`ge`, p2, h2]) : g2.push([`<`, p2, h2]) : i2 ? g2.push([`>`, p2, h2]) : g2.push([`le`, p2, h2]);
    let v2;
    return v2 = i2 ? [`or`].concat(g2) : [`and`].concat(g2), v2;
  }
  return t4;
}
function substitute(t4, n2) {
  var r2 = get_tree(t4), i2 = {};
  for (let t5 in n2) i2[t5] = get_tree(n2[t5]);
  return substitute$1(r2, i2);
}
function substitute_component(t4, n2, r2) {
  let i2 = get_tree(t4);
  get_tree(r2);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid substitute_component: ` + n2);
  let o2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return s2(i2, n2);
  function s2(t5, n3, i3) {
    if (n3.length === 0) return r2;
    if (!Array.isArray(t5)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let a2 = t5[0], c2 = t5.slice(1);
    if (!o2.includes(a2)) throw Error(`Invalid substitute_component: expected list, tuple, vector, or array`);
    let l2 = n3[0];
    if (l2 < 0 || l2 > c2.length - 1) throw Error(`Invalid substitute_component: component out of range`);
    let u2 = n3.slice(1), d2 = s2(c2[l2], u2);
    return [a2, ...c2.slice(0, l2), d2, ...c2.slice(l2 + 1)];
  }
}
function get_component(t4, n2) {
  let r2 = get_tree(t4);
  if (typeof n2 == `number`) n2 = [n2];
  else if (!Array.isArray(n2)) throw Error(`Invalid get_component: ` + n2);
  let i2 = [`list`, `tuple`, `vector`, `altvector`, `array`];
  return a2(r2, n2);
  function a2(t5, n3) {
    if (n3.length === 0) return t5;
    if (!Array.isArray(t5)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let r3 = t5[0], o2 = t5.slice(1);
    if (!i2.includes(r3)) throw Error(`Invalid get_component: expected list, tuple, vector, or array`);
    let s2 = n3[0];
    if (s2 < 0 || s2 > o2.length - 1) throw Error(`Invalid get_component: component out of range`);
    let c2 = n3.slice(1);
    return a2(o2[s2], c2);
  }
}
function apply_root(t4, n2) {
  return n2 === 2 ? [`apply`, `sqrt`, t4] : n2 === 3 ? [`apply`, `cbrt`, t4] : [`apply`, `nthroot`, [`tuple`, t4, n2]];
}
function pull_number_outside_root(t4, n2 = 2) {
  let r2 = t4, i2 = 1, a2 = 2, o2 = mathjs_default.pow(a2, n2);
  for (; o2 <= Math.abs(r2); ) r2 % o2 === 0 ? (r2 /= o2, i2 *= a2) : (a2++, o2 = mathjs_default.pow(a2, n2));
  return { n_outside: i2, n_inside: r2 };
}
function make_power(t4, n2) {
  return n2 === 0 ? 1 : n2 === 1 ? t4 : [`^`, t4, n2];
}
function collect_radicand_factors(t4, n2) {
  let r2 = 1, i2 = (t5) => {
    if (Array.isArray(t5) && t5[0] === `*`) for (let n3 of t5.slice(1)) i2(n3);
    else Array.isArray(t5) && t5[0] === `-` ? (r2 = -r2, i2(t5[1])) : typeof t5 == `number` && t5 < 0 ? (r2 = -r2, n2.push(-t5)) : n2.push(t5);
  };
  return i2(t4), r2;
}
function combine_factors(t4, n2) {
  let r2 = 1, i2 = /* @__PURE__ */ new Map(), a2 = /* @__PURE__ */ new Map(), o2 = [], s2 = [];
  for (let c2 of t4) {
    if (typeof c2 == `number`) {
      r2 *= c2;
      continue;
    }
    let t5, l2;
    if (typeof c2 == `string`) t5 = c2, l2 = 1;
    else if (Array.isArray(c2) && c2[0] === `^` && typeof c2[1] == `string` && Number.isInteger(c2[2])) t5 = c2[1], l2 = c2[2];
    else {
      s2.push(c2);
      continue;
    }
    if (a2.has(t5) || a2.set(t5, is_nonzero_ast(t5, n2) === true), l2 < 1 && !a2.get(t5)) {
      s2.push(c2);
      continue;
    }
    i2.has(t5) ? i2.set(t5, i2.get(t5) + l2) : (o2.push(t5), i2.set(t5, l2));
  }
  return { numberFactor: r2, expByVar: i2, varOrder: o2, others: s2 };
}
function pull_factor_into_root(t4, n2, r2, i2, a2, o2) {
  let s2 = n2 >= 1 ? Math.floor(n2 / r2) : 0;
  if (s2 === 0) {
    o2.push(make_power(t4, n2));
    return;
  }
  let c2;
  if (is_positive_ast(t4, i2, false)) c2 = t4;
  else if (r2 % 2 == 1 && is_real_ast(t4, i2)) c2 = t4;
  else if (r2 % 2 == 0 && is_real_ast(t4, i2)) c2 = s2 % 2 == 0 ? t4 : [`apply`, `abs`, t4];
  else {
    o2.push(make_power(t4, n2));
    return;
  }
  a2.push(make_power(c2, s2)), o2.push(make_power(t4, n2 % r2));
}
function simplify_powers_in_roots(t4, n2) {
  if (!Array.isArray(t4)) return t4;
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `*`) {
    let t5 = [];
    for (let r4 of i2) {
      let i3 = simplify_powers_in_roots(r4, n2);
      Array.isArray(i3) && i3[0] === `*` ? t5.push(...i3.slice(1)) : t5.push(i3);
    }
    let { numberFactor: r3, expByVar: a2, varOrder: o2, others: s2 } = combine_factors(t5, n2), c2 = [];
    r3 !== 1 && c2.push(r3);
    for (let t6 of o2) {
      let n3 = make_power(t6, a2.get(t6));
      n3 !== 1 && c2.push(n3);
    }
    return c2.push(...s2), c2.length === 0 ? 1 : c2.length === 1 ? c2[0] : [`*`, ...c2];
  }
  if (r2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(i2[0])) {
    let t5 = i2[0], r3 = 2, a2 = i2[1];
    if (t5 === `cbrt`) r3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(i2[1]) && i2[1][0] === `tuple`) if (Number.isInteger(i2[1][2]) && i2[1][2] > 0) r3 = i2[1][2], a2 = i2[1][1];
    else return [`apply`, `nthroot`, ...i2.slice(1).map((t6) => simplify_powers_in_roots(t6, n2))];
    else r3 = 2;
    a2 = simplify_powers_in_roots(a2, n2);
    let o2 = [], s2 = collect_radicand_factors(a2, o2), { numberFactor: c2, expByVar: l2, varOrder: u2, others: d2 } = combine_factors(o2, n2);
    if (c2 === 0) return 0;
    let p2 = [], m2 = [];
    if (Number.isInteger(c2)) {
      let { n_outside: t6, n_inside: n3 } = pull_number_outside_root(c2, r3);
      t6 !== 1 && p2.push(t6), n3 !== 1 && m2.push(n3);
    } else c2 !== 1 && m2.push(c2);
    for (let t6 of u2) pull_factor_into_root(t6, l2.get(t6), r3, n2, p2, m2);
    for (let t6 of d2) Array.isArray(t6) && t6[0] === `^` && Number.isInteger(t6[2]) ? pull_factor_into_root(t6[1], t6[2], r3, n2, p2, m2) : m2.push(t6);
    let h2 = m2.filter((t6) => t6 !== 1), g2;
    if (h2.length === 0) g2 = s2 < 0 ? -1 : 1;
    else {
      let t6 = h2.length === 1 ? h2[0] : [`*`, ...h2];
      g2 = s2 < 0 ? [`-`, t6] : t6;
    }
    let v2 = p2.filter((t6) => t6 !== 1);
    return g2 !== 1 && v2.push(apply_root(g2, r3)), v2.length === 0 ? 1 : v2.length === 1 ? v2[0] : [`*`, ...v2];
  }
  return [r2, ...i2.map((t5) => simplify_powers_in_roots(t5, n2))];
}
var simplify_exports = __exportAll({ add_unit: () => add_unit, clean: () => clean, collapse_unary_minus: () => collapse_unary_minus, collect_like_terms_factors: () => collect_like_terms_factors, default_order: () => default_order, evaluate_numbers: () => evaluate_numbers, perform_vector_matrix_additions_scalar_multiplications: () => perform_vector_matrix_additions_scalar_multiplications, remove_scaling_units: () => remove_scaling_units, remove_units: () => remove_units, set_small_zero: () => set_small_zero, simplify: () => simplify, simplify_logical: () => simplify_logical, simplify_ratios: () => simplify_ratios });
function clean(t4) {
  return flatten$5(get_tree(t4));
}
function evalf(t4, n2) {
  return parseFloat(mathjs_default.format(t4, { notation: `exponential`, precision: n2 }));
}
function collapse_unary_minus(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  var r2 = n2[0], i2 = n2.slice(1);
  if (i2 = i2.map((t5) => collapse_unary_minus(t5)), r2 === `-`) {
    if (typeof i2[0] == `number`) return -i2[0];
    if (Array.isArray(i2[0]) && i2[0][0] === `*` && typeof i2[0][1] == `number`) return [`*`, -i2[0][1]].concat(i2[0].slice(2));
    if (Array.isArray(i2[0]) && i2[0][0] === `/`) {
      if (typeof i2[0][1] == `number`) return [`/`, -i2[0][1], i2[0][2]];
      if (Array.isArray(i2[0][1]) && i2[0][1][0] === `*` && typeof i2[0][1][1] == `number`) return [`/`, [`*`, -i2[0][1][1]].concat(i2[0][1].slice(2)), i2[0][2]];
    }
  }
  return [r2].concat(i2);
}
function simplify(t4, n2, r2) {
  var i2 = get_tree(t4);
  return contains_blank(i2) || (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2 = evaluate_numbers(i2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), !Array.isArray(i2)) ? i2 : (i2 = simplify_logical(i2, n2), i2 = perform_vector_matrix_additions_scalar_multiplications(i2), i2 = simplify_integers_in_roots(i2), i2 = collect_like_terms_factors(i2, n2, r2), i2);
}
function simplify_logical(t4, n2) {
  var r2 = get_tree(t4);
  if (contains_blank(r2)) return r2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), r2 = evaluate_numbers(r2, { assumptions: n2 }), r2 = unflattenRight(r2);
  var i2 = [];
  return i2.push([[`not`, [`not`, `a`]], `a`]), i2.push([[`not`, [`and`, `a`, `b`]], [`or`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`or`, `a`, `b`]], [`and`, [`not`, `a`], [`not`, `b`]]]), i2.push([[`not`, [`=`, `a`, `b`]], [`ne`, `a`, `b`]]), i2.push([[`not`, [`ne`, `a`, `b`]], [`=`, `a`, `b`]]), i2.push([[`not`, [`<`, `a`, `b`]], [`le`, `b`, `a`]]), i2.push([[`not`, [`le`, `a`, `b`]], [`not`, [`le`, `a`, `b`]]]), i2.push([[`not`, [`in`, `a`, `b`]], [`notin`, `a`, `b`]]), i2.push([[`not`, [`subset`, `a`, `b`]], [`notsubset`, `a`, `b`]]), r2 = applyAllTransformations(r2, i2, 20), r2 = flatten$5(r2), r2;
}
function simplify_integers_in_roots(t4) {
  if (!Array.isArray(t4)) return t4;
  var n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = 1, n3 = [];
    for (let i2 of r2) if (typeof i2 == `number`) t5 *= i2;
    else {
      let r3 = simplify_integers_in_roots(i2);
      Array.isArray(r3) && r3[0] === `*` ? typeof r3[1] == `number` ? (t5 *= r3[1], n3.push(...r3.slice(2))) : n3.push(...r3.slice(1)) : n3.push(r3);
    }
    return t5 !== 1 && n3.unshift(t5), [`*`, ...n3];
  }
  if (n2 === `apply` && [`sqrt`, `cbrt`, `nthroot`].includes(r2[0])) {
    let t5 = r2[0], n3 = 2, i2 = r2[1];
    if (t5 === `cbrt`) n3 = 3;
    else if (t5 === `nthroot`) if (Array.isArray(r2[1]) && r2[1][0] === `tuple`) if (Number.isInteger(r2[1][2]) && r2[1][2] > 0) n3 = r2[1][2], i2 = r2[1][1];
    else return [`apply`, `nthroot`, ...r2.slice(1).map(simplify_integers_in_roots)];
    else n3 = 2;
    if (i2 = simplify_integers_in_roots(i2), Number.isInteger(i2)) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root(i2, n3);
      if (t6 !== 1) return [`*`, t6, apply_root(r3, n3)];
    } else if (Array.isArray(i2) && i2[0] === `*` && typeof i2[1] == `number`) {
      let { n_outside: t6, n_inside: r3 } = pull_number_outside_root(i2[1], n3);
      if (t6 !== 1) return [`*`, t6, apply_root([`*`, r3, ...i2.slice(2)], n3)];
    }
    return apply_root(i2, n3);
  }
  return [n2, ...r2.map(simplify_integers_in_roots)];
}
function perform_vector_matrix_additions_scalar_multiplications(t4, n2 = true) {
  var r2 = get_tree(t4);
  r2 = perform_matrix_scalar_multiplications(r2), r2 = perform_vector_scalar_multiplications(r2, n2);
  let i2 = [`+`, `a`, `b`];
  return r2 = transform(r2, function(t5) {
    let r3 = match$1(t5, i2, { allow_permutations: true });
    if (r3) {
      let i3 = [`vector`, `altvector`];
      n2 && i3.push(`tuple`);
      let a2 = {}, o2 = {}, s2 = [];
      if (i3.includes(r3.a[0])) {
        let t6 = r3.a.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.a);
      } else if (r3.a[0] === `matrix`) {
        let t6 = r3.a[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.a);
      } else s2.push(r3.a);
      if (i3.includes(r3.b[0])) {
        let t6 = r3.b.length - 1;
        a2[t6] || (a2[t6] = []), a2[t6].push(r3.b);
      } else if (r3.b[0] === `matrix`) {
        let t6 = r3.b[1].slice(1).toString();
        o2[t6] || (o2[t6] = []), o2[t6].push(r3.b);
      } else if (r3.b[0] === `+`) for (let t6 of r3.b.slice(1)) if (i3.includes(t6[0])) {
        let n3 = t6.length - 1;
        a2[n3] || (a2[n3] = []), a2[n3].push(t6);
      } else if (t6[0] === `matrix`) {
        let n3 = t6[1].slice(1).toString();
        o2[n3] || (o2[n3] = []), o2[n3].push(t6);
      } else s2.push(t6);
      else s2.push(r3.b);
      if (Object.values(a2).every((t6) => t6.length < 2) && Object.values(o2).every((t6) => t6.length < 2)) return t5;
      let c2 = s2;
      for (let t6 in a2) if (a2[t6].length < 2) c2.push(...a2[t6]);
      else {
        let n3 = a2[t6].some((t7) => t7[0] === `vector`), r4 = a2[t6].some((t7) => t7[0] === `tuple`), i4 = a2[t6].some((t7) => t7[0] === `altvector`), o3;
        o3 = n3 || r4 && i4 ? [`vector`] : i4 ? [`altvector`] : [`tuple`];
        for (let n4 = 0; n4 < t6; n4++) o3.push([`+`, ...a2[t6].map((t7) => t7[n4 + 1])]);
        c2.push(o3);
      }
      for (let t6 in o2) if (o2[t6].length < 2) c2.push(...o2[t6]);
      else {
        let [n3, r4] = t6.split(`,`).map(Number), i4 = [`tuple`];
        for (let a4 = 0; a4 < n3; a4++) {
          let n4 = [`tuple`];
          for (let i5 = 0; i5 < r4; i5++) n4.push([`+`, ...o2[t6].map((t7) => t7[2][a4 + 1][i5 + 1])]);
          i4.push(n4);
        }
        let a3 = [`matrix`, [`tuple`, n3, r4], i4];
        c2.push(a3);
      }
      return c2.length === 1 ? c2[0] : [`+`, ...c2];
    } else return t5;
  }), r2;
}
function contains_decimal_number(t4) {
  return typeof t4 == `string` ? false : typeof t4 == `number` ? !!(Number.isFinite(t4) && !Number.isInteger(t4)) : Array.isArray(t4) ? t4.slice(1).some((t5) => contains_decimal_number(t5)) : false;
}
function contains_only_numbers(t4, { include_number_symbols: n2 = false, evaluate_functions: r2 = false } = {}) {
  return typeof t4 == `string` ? !!(n2 && (t4 === `e` && mathjs_default.define_e || t4 === `pi` && mathjs_default.define_pi) || t4 === `i` && mathjs_default.define_i) : typeof t4 == `number` ? true : Array.isArray(t4) ? r2 && t4[0] === `apply` ? t4.slice(2).every((t5) => contains_only_numbers(t5, { include_number_symbols: n2 })) : t4.slice(1).every((t5) => contains_only_numbers(t5, { include_number_symbols: n2 })) : false;
}
function try_evaluate_sum_of_numbers(t4, n2, r2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) return n2;
    if (typeof n2 == `number`) return t4 + n2;
    if (Array.isArray(n2) && n2[0] === `+` && typeof n2[1] == `number`) return [`+`, t4 + n2[1], n2[2]];
    if (!r2 && Array.isArray(n2) && n2[0] === `+` && typeof n2[2] == `number`) return [`+`, t4 + n2[2], n2[1]];
  }
  return typeof n2 == `number` && n2 === 0 ? t4 : null;
}
function try_evaluate_negate_number(t4) {
  if (typeof t4 == `number`) return -t4;
  if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return [`*`, -t4[1]].concat(t4.slice(2));
  if (Array.isArray(t4) && t4[0] === `/`) {
    if (typeof t4[1] == `number`) return [`/`, -t4[1], t4[2]];
    if (Array.isArray(t4[1]) && t4[1][0] === `*` && typeof t4[1][1] == `number`) return [`/`, [`*`, -t4[1][1]].concat(t4[1].slice(2)), t4[2]];
  }
  return null;
}
function try_evaluate_product_of_numbers(t4, n2) {
  if (typeof t4 == `number`) {
    if (isNaN(t4)) return NaN;
    if (typeof n2 == `number`) return t4 * n2;
    if (!isFinite(t4)) return t4 === 1 / 0 && is_negative_ast(n2) || t4 === -1 / 0 && is_positive_ast(n2) ? -1 / 0 : is_nonzero_ast(n2) === false ? NaN : 1 / 0;
    if (t4 === 0) return 0;
    if (t4 === 1) return n2;
    if (t4 === -1) return [`-`, n2];
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) return t4 *= n2[1], n2 = n2[2], t4 === 1 ? n2 : t4 === -1 ? [`-`, n2] : [`*`, t4, n2];
  }
  if (typeof n2 == `number`) {
    if (isNaN(n2)) return NaN;
    if (!isFinite(n2)) return n2 === 1 / 0 && is_negative_ast(t4) || n2 === -1 / 0 && is_positive_ast(t4) ? -1 / 0 : is_nonzero_ast(t4) === false ? NaN : 1 / 0;
    if (n2 === 0) return 0;
    if (n2 === 1) return t4;
    if (n2 === -1) return [`-`, t4];
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) return n2 *= t4[1], t4 = t4[2], n2 === 1 ? t4 : n2 === -1 ? [`-`, t4] : [`*`, t4, n2];
  }
  if (mathjs_default.define_i && t4 === `i`) {
    if (n2 === `i`) return -1;
    if (Array.isArray(n2) && n2[0] === `*` && n2[1] === `i`) return [`-`, n2[2]];
  } else if (mathjs_default.define_i && n2 === `i` && Array.isArray(t4) && t4[0] === `*` && t4[1] === `i`) return [`-`, t4[2]];
  return null;
}
function try_evaluate_quotient_of_numbers(t4, n2, r2, i2) {
  if (typeof t4 == `number`) {
    if (t4 === 0) {
      let t5 = is_nonzero_ast(n2, r2);
      if (t5) return 0;
      if (t5 === false) return NaN;
    }
    if (typeof n2 == `number`) {
      let r3 = t4 / n2;
      if (i2 === 1 / 0 || mathjs_default.round(r3, i2) === r3) return r3;
      if (n2 < 0) return [`/`, -t4, -n2];
    }
    if (Array.isArray(n2) && n2[0] === `*` && typeof n2[1] == `number`) {
      let r3 = t4 / n2[1];
      if (i2 === 1 / 0 || mathjs_default.round(r3, i2) === r3) return [`/`, r3, n2[2]];
    }
  } else if (typeof n2 == `number`) {
    if (Array.isArray(t4) && t4[0] === `*` && typeof t4[1] == `number`) {
      let r4 = t4[1] / n2;
      if (i2 === 1 / 0 || mathjs_default.round(r4, i2) === r4) return r4 === 1 ? t4[2] : [`*`, r4, t4[2]];
      if (n2 < 0) return [`/`, [`*`, -t4[1], t4[2]], -n2];
    }
    let r3 = 1 / n2;
    if (i2 === 1 / 0 || mathjs_default.round(r3, i2) === r3) return [`*`, r3, t4];
    if (n2 < 0) return Array.isArray(t4) && t4[0] === `-` ? [`/`, t4[1], -n2] : [`-`, [`/`, t4, -n2]];
  }
  return null;
}
function set_small_zero(t4, n2 = 1e-14) {
  var r2 = get_tree(t4);
  return typeof r2 == `number` ? mathjs_default.abs(r2) < n2 ? 0 : r2 : Array.isArray(r2) ? [r2[0], ...r2.slice(1).map((t5) => set_small_zero(t5, n2))] : r2;
}
function evaluate_numbers_sub(t4, n2, r2, i2, a2, o2) {
  if (t4 === void 0) return t4;
  if (typeof t4 == `number`) return o2 > 0 && mathjs_default.abs(t4) < o2 ? 0 : t4;
  if (contains_only_numbers(t4, { include_number_symbols: true, evaluate_functions: a2 })) {
    let n3 = function(n4) {
      if (o2 > 0 && mathjs_default.abs(n4) < o2) return 0;
      if (r2 === 1 / 0 || Number.isInteger(n4)) return n4;
      let i3 = evalf(n4, 14), s3 = evalf(n4, r2);
      if (r2 === 0 && (s3 = mathjs_default.round(n4)), s3 === i3 || contains_decimal_number(t4) && contains_only_numbers(t4, { include_number_symbols: true, evaluate_functions: a2 })) return n4;
      let c3 = mathjs_default.fraction(n4), l3 = { n: mathjs_default.number(c3.n), d: mathjs_default.number(c3.d), s: mathjs_default.number(c3.s) }, u2 = evalf(l3.d, 3);
      return (l3.n < 1e4 || u2 === l3.d) && evalf(l3.s * l3.n / l3.d, 14) === i3 ? l3.d === 1 ? l3.s * l3.n : [`/`, l3.s * l3.n, l3.d] : null;
    };
    var s2 = evaluate_to_constant(t4, { remove_units_first: false });
    if (!Number.isNaN(s2)) {
      if (typeof s2 == `number`) {
        if (Number.isFinite(s2)) {
          let t5 = n3(s2);
          if (t5 !== null) return t5;
        }
      } else if (s2 && Number.isFinite(s2.re) && Number.isFinite(s2.im)) {
        let t5 = n3(s2.re), r3 = n3(s2.im);
        if (t5 !== null && r3 !== null) {
          if (r3 === 0) return t5;
          {
            let n4;
            return n4 = r3 === 1 ? `i` : r3 === -1 ? [`-`, `i`] : [`*`, r3, `i`], t5 === 0 ? n4 : [`+`, t5, n4];
          }
        }
      }
    }
  }
  if (!Array.isArray(t4)) return t4;
  var c2 = t4[0], l2 = t4.slice(1).map((t5) => evaluate_numbers_sub(t5, n2, r2, i2, a2, o2));
  if (c2 === `+`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_sum_of_numbers(t5, n3, i2);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree(t5), a3 = get_unit_of_tree(n3);
      if (r4 && r4 === a3) {
        let a4 = try_evaluate_sum_of_numbers(remove_units(t5, false), remove_units(n3, false), i2);
        if (a4 !== null) return add_unit(a4, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `-`) {
    let t5 = try_evaluate_negate_number(l2[0]);
    if (t5 !== null) return t5;
    if (l2[0][0] === `unit`) {
      let t6 = get_unit_of_tree(l2[0]);
      if (t6) {
        let n3 = try_evaluate_negate_number(remove_units(l2[0], false));
        if (n3 !== null) return add_unit(n3, t6);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `*`) {
    let t5 = l2[0], n3 = l2[1];
    if (n3 === void 0) return t5;
    let r3 = try_evaluate_product_of_numbers(t5, n3);
    if (r3 !== null) return r3;
    if (t5[0] === `unit` && n3[0] !== `unit`) {
      let r4 = get_unit_of_tree(t5);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers(remove_units(t5, false), n3);
        if (i3 !== null) return add_unit(i3, r4);
      }
    }
    if (t5[0] !== `unit` && n3[0] === `unit`) {
      let r4 = get_unit_of_tree(n3);
      if (r4) {
        let i3 = try_evaluate_product_of_numbers(t5, remove_units(n3, false));
        if (i3 !== null) return add_unit(i3, r4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `/`) {
    let t5 = l2[0], i3 = l2[1], a3 = try_evaluate_quotient_of_numbers(t5, i3, n2, r2);
    if (a3 !== null) return a3;
    if (t5[0] === `unit` && i3[0] !== `unit`) {
      let a4 = get_unit_of_tree(t5);
      if (a4) {
        let o3 = try_evaluate_quotient_of_numbers(remove_units(t5, false), i3, n2, r2);
        if (o3 !== null) return add_unit(o3, a4);
      }
    }
    return [c2].concat(l2);
  }
  if (c2 === `^`) {
    let t5 = l2[0], i3 = l2[1];
    if (typeof i3 == `number`) {
      if (i3 === 0) {
        if (!mathjs_default.pow_strict) return 1;
        let r3 = is_nonzero_ast(t5, n2);
        if (r3 && t5 !== 1 / 0 && t5 !== -1 / 0) return 1;
        if (r3 === false) return NaN;
      } else if (i3 === 1) return t5;
      else if (typeof t5 == `number`) {
        let n3 = mathjs_default.pow(t5, i3);
        if (r2 === 1 / 0 || mathjs_default.round(n3, r2) === n3) return n3;
      }
    } else if (t5 === 1) return 1;
    return [c2].concat(l2);
  }
  return [c2].concat(l2);
}
function evaluate_numbers(t4, { assumptions: n2, max_digits: r2, skip_ordering: i2 = false, evaluate_functions: a2 = false, set_small_zero: o2 = 0 } = {}) {
  (r2 === void 0 || !(Number.isInteger(r2) || r2 === 1 / 0)) && (r2 = 0), o2 === true && (o2 = 1e-14);
  var s2 = get_tree(t4);
  if (contains_blank(s2)) return s2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()]));
  var c2;
  return i2 ? (s2 = unflattenRight(flatten$5(s2)), c2 = evaluate_numbers_sub(s2, n2, r2, i2, a2, o2)) : (s2 = move_units_outside_products(s2), s2 = unflattenRight(default_order(flatten$5(s2))), c2 = default_order(evaluate_numbers_sub(s2, n2, r2, i2, a2, o2)), c2 = default_order(evaluate_numbers_sub(unflattenRight(c2), n2, r2, i2, a2, o2))), c2 = set_negative_zeros_to_zero(c2), flatten$5(c2);
}
function set_negative_zeros_to_zero(t4) {
  return t4 === 0 ? 0 : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map(set_negative_zeros_to_zero)] : t4;
}
function collect_like_terms_factors(t4, n2, r2) {
  function i2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  function a2(t5) {
    return !!(typeof t5 == `number` && t5 < 0 || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number` && t5 > 0);
  }
  function o2(t5) {
    if (typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`) return true;
    var n3 = evaluate_to_constant(t5, { remove_units_first: false });
    return !!Number.isFinite(n3);
  }
  let s2 = (t5) => !contains_pm(t5);
  var c2 = get_tree(t4);
  if (contains_blank(c2)) return c2;
  n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), c2 = evaluate_numbers(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true });
  var l2 = [];
  l2.push([[`/`, `x`, [`^`, `y`, `a`]], [`*`, `x`, [`^`, `y`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2 }]), l2.push([[`/`, `x`, [`apply`, `exp`, `a`]], [`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], { evaluate_numbers: true, max_digits: r2, variables: { x: true, a: true } }]), l2.push([[`/`, `x`, `y`], [`*`, `x`, [`^`, `y`, [`-`, 1]]], { evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations(c2, l2, 40), l2 = [];
  for (let t5 in all_units) all_units[t5].prefix ? (l2.push([[`+`, [`unit`, t5, `x`], [`unit`, t5, `y`]], [`unit`, t5, [`+`, `x`, `y`]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, t5, `x`], [`-`, [`unit`, t5, `y`]]], [`unit`, t5, [`+`, `x`, [`-`, `y`]]], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }])) : (l2.push([[`+`, [`unit`, `x`, t5], [`unit`, `y`, t5]], [`unit`, [`+`, `x`, `y`], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`unit`, `x`, t5], [`-`, [`unit`, `y`, t5]]], [`unit`, [`+`, `x`, [`-`, `y`]], t5], { variables: { x: true, y: true }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]));
  return l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: (t5) => is_nonzero_ast(t5, n2) && s2(t5), n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_positive_ast(t5, n2), m: (t5) => i2(t5) && is_positive_ast(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`^`, [`-`, `x`], `n`], [`-`, [`^`, `x`, `n`]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, max_group: 1 }]), l2.push([[`*`, [`^`, `x`, `n`], [`^`, `x`, `m`]], [`^`, `x`, [`+`, `n`, `m`]], { variables: { x: s2, n: (t5) => i2(t5) && is_negative_ast(t5, n2), m: (t5) => i2(t5) && is_negative_ast(t5, n2) }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, [`apply`, `exp`, `n`], [`apply`, `exp`, `m`]], [`apply`, `exp`, [`+`, `n`, `m`]], { variables: { n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`*`, `m`, `x`]], [`*`, [`+`, `n`, `m`], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, `n1`, [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n1`, `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, `n1`, [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`/`, `n2`, `m2`], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`/`, `n2`, `m2`]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, [`/`, `n1`, `m1`], `x`], [`*`, [`-`, [`/`, `n2`, `m2`]], `x`]], [`*`, [`+`, [`/`, `n1`, `m1`], [`-`, [`/`, `n2`, `m2`]]], `x`], { variables: { x: s2, n1: i2, m1: i2, n2: i2, m2: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m1`, `m2`, `n1`, `n2`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`+`, [`*`, `n`, `x`], [`-`, [`*`, `m`, `x`]]], [`*`, [`+`, `n`, [`-`, `m`]], `x`], { variables: { x: s2, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`m`, `n`], allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`-`, [`pm`, `x`]], [`pm`, `x`], { variables: { x: true } }]), l2.push([[`*`, `c`, [`pm`, `x`]], [`pm`, [`*`, `c`, `x`]], { variables: { c: (t5) => !contains_pm(t5), x: true }, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`^`, [`*`, `x`, `y`], `a`], [`*`, [`^`, `x`, `a`], [`^`, `y`, `a`]], { allow_permutations: true }]), l2.push([[`^`, [`^`, `x`, `n`], `m`], [`^`, `x`, [`*`, `n`, `m`]], { variables: { x: true, n: i2, m: i2 }, evaluate_numbers: true, max_digits: r2, allow_permutations: true }]), l2.push([[`-`, [`+`, `a`, `b`]], [`+`, [`-`, `a`], [`-`, `b`]]]), l2.push([[`apply`, `cbrt`, [`*`, `a`, `x`]], [`-`, [`apply`, `cbrt`, [`-`, [`*`, `a`, `x`]]]], { variables: { a: (t5) => is_negative_ast(t5, n2), x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `cbrt`, [`-`, `x`]], [`-`, [`apply`, `cbrt`, `x`]], { variables: { x: true }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`*`, `a`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, [`-`, [`*`, `a`, `x`]], `n`]]], { variables: { a: (t5) => is_negative_ast(t5, n2), x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`apply`, `nthroot`, [`tuple`, [`-`, `x`], `n`]], [`-`, [`apply`, `nthroot`, [`tuple`, `x`, `n`]]], { variables: { x: true, n: (t5) => Number.isInteger(t5) && !Number.isInteger(t5 / 2) && t5 > 1 }, evaluate_numbers: true, max_digits: r2, allow_implicit_identities: [`x`] }]), l2.push([[`^`, [`apply`, `abs`, `x`], `n`], [`^`, `x`, `n`], { variables: { x: true, n: (t5) => Number.isInteger(t5) && Number.isInteger(t5 / 2) }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`*`, `x`, `y`], [`*`, `x`, `y`], { variables: { x: o2, y: o2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations(c2, l2, 40), c2 = simplify_powers_in_roots(c2, n2), l2 = [], l2.push([[`*`, `x`, [`^`, `y`, [`-`, `a`]]], [`/`, `x`, [`^`, `y`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, [`-`, `a`]]], [`/`, `x`, [`apply`, `exp`, `a`]], { allow_extended_match: true, allow_permutations: true, evaluate_numbers: true, max_digits: r2, max_group: 1, variables: { x: true, a: true } }]), l2.push([[`*`, `x`, [`^`, `y`, `n`]], [`/`, `x`, [`^`, `y`, [`-`, `n`]]], { variables: { x: true, y: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`*`, `x`, [`apply`, `exp`, `n`]], [`/`, `x`, [`apply`, `exp`, [`-`, `n`]]], { variables: { x: true, n: a2 }, evaluate_numbers: true, max_digits: r2, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), c2 = applyAllTransformations(c2, l2, 40), l2 = [], l2.push([[`^`, `y`, `n`], [`/`, 1, [`^`, `y`, [`-`, `n`]]], { variables: { y: true, n: a2 }, evaluate_numbers: true, max_digits: r2 }]), l2.push([[`apply`, `exp`, `n`], [`/`, 1, [`apply`, `exp`, [`-`, `n`]]], { variables: { n: a2 }, evaluate_numbers: true, max_digits: r2 }]), c2 = applyAllTransformations(c2, l2, 40), l2 = [], l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations(c2, l2, 40), l2 = [], l2.push([[`*`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `y`], `z`], { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), l2.push([[`/`, [`/`, `x`, `y`], `z`], [`/`, `x`, [`*`, `y`, `z`]], { allow_extended_match: true, allow_permutations: true }]), l2.push([[`/`, `x`, [`/`, `y`, `z`]], [`/`, [`*`, `x`, `z`], `y`], { allow_extended_match: true, allow_permutations: true }]), c2 = applyAllTransformations(c2, l2, 40), c2 = evaluate_numbers(c2, { assumptions: n2, max_digits: r2, evaluate_functions: true }), c2;
}
function simplify_ratios(t4, n2) {
  function r2(t5) {
    var n3 = 1;
    return t5 = t5.map(function(t6) {
      if (typeof t6 == `number`) return t6 < 0 ? (n3 *= -1, -t6) : t6;
      if (!Array.isArray(t6)) return t6;
      if (t6[0] === `-`) return n3 *= -1, t6[1];
      if (t6[0] !== `+`) return t6;
      var r3 = false;
      if ((typeof t6[1] == `number` && t6[1] < 0 || Array.isArray(t6[1]) && t6[1][0] === `-` || Array.isArray(t6[1]) && t6[1][0] === `*` && Number(t6[1][1]) < 0) && (r3 = true), r3) {
        n3 *= -1;
        var i3 = t6.slice(1).map((t7) => [`-`, t7]);
        return evaluate_numbers([`+`].concat(i3));
      } else return t6;
    }), { factors: t5, sign_change: n3 };
  }
  function i2(t5, n3) {
    if (!Array.isArray(t5)) return n3 ? [`-`, t5] : t5;
    var a3 = t5[0];
    if (a3 === `-`) return i2(t5[1], n3 = true);
    var o2 = t5.slice(1).map((t6) => i2(t6));
    if (a3 !== `/`) return n3 ? [`-`, [a3, ...o2]] : [a3, ...o2];
    var s2 = o2[0], c2 = o2[1];
    s2 = default_order(s2, { ignore_negatives: true });
    var l2 = Array.isArray(s2) && s2[0] === `*` ? s2.slice(1) : [s2], u2 = r2(l2);
    l2 = u2.factors, n3 && (u2.sign_change *= -1), c2 = default_order(c2, { ignore_negatives: true });
    var d2 = Array.isArray(c2) && c2[0] === `*` ? c2.slice(1) : [c2], p2 = r2(d2);
    return d2 = p2.factors, u2.sign_change * p2.sign_change < 0 && (l2[0] = [`-`, l2[0]]), s2 = l2.length === 1 ? l2[0] : [`*`].concat(l2), c2 = d2.length === 1 ? d2[0] : [`*`].concat(d2), [`/`, s2, c2];
  }
  var a2 = get_tree(t4);
  return contains_blank(a2) ? a2 : (n2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (n2 = t4.context.get_assumptions([t4.variables()])), i2(a2));
}
function contains_blank(t4) {
  return t4 === `＿` ? true : Array.isArray(t4) ? t4.some(contains_blank) : false;
}
var all_units = get_all_units();
function remove_units(t4, n2 = true) {
  var r2 = get_tree(t4);
  if (!Array.isArray(r2)) return r2;
  let i2 = r2[0], a2 = r2.slice(1);
  if (i2 === `unit`) {
    let t5 = all_units[get_unit_of_tree(r2)];
    if (!t5) return r2;
    let i3 = remove_units(t5.prefix ? a2[1] : a2[0], n2);
    return n2 ? t5.scale(i3) : i3;
  } else return [i2, ...a2.map((t5) => remove_units(t5, n2))];
}
function remove_scaling_units(t4) {
  var n2 = get_tree(t4);
  if (!Array.isArray(n2)) return n2;
  let r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `unit`) {
    let t5 = all_units[get_unit_of_tree(n2)];
    if (!(t5 && t5.only_scales)) return n2;
    let r3 = remove_scaling_units(t5.prefix ? i2[1] : i2[0]);
    return t5.scale(r3);
  } else return [r2, ...i2.map((t5) => remove_scaling_units(t5))];
}
function add_unit(t4, n2) {
  var r2 = get_tree(t4);
  let i2 = all_units[n2];
  return i2 ? i2.prefix ? [`unit`, n2, r2] : [`unit`, r2, n2] : r2;
}
function move_units_outside_products(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `*`) {
    let t5 = [], n3 = [];
    for (let i3 of r2) {
      let r3 = get_unit_value_of_tree(i3);
      r3 ? (t5.push(r3[0]), n3.push(r3[1])) : n3.push(i3);
    }
    let i2 = [`*`, ...n3];
    for (let n4 of t5) i2 = add_unit(i2, n4);
    return i2;
  } else return [n2, ...r2.map(move_units_outside_products)];
}
var solve_exports = __exportAll({ solve_linear: () => solve_linear });
function solve_linear(t4, n2, r2) {
  if (typeof n2 == `string`) {
    r2 === void 0 && t4.context !== void 0 && t4.context.get_assumptions !== void 0 && (r2 = t4.context.get_assumptions([t4.variables()]));
    var i2 = simplify(get_tree(t4), r2);
    if (Array.isArray(i2)) {
      var a2 = i2[0], o2 = i2.slice(1);
      if (a2 === `=` || a2 === `ne` || a2 === `<` || a2 === `le` || a2 === `>` || a2 === `ge`) {
        var s2 = simplify([`+`, o2[0], [`-`, o2[1]]], r2), c2 = (t5) => !variables(t5).includes(n2);
        if (s2 = simplify(applyAllTransformations(s2, [[[`+`, [`*`, `_a`, n2], [`*`, `_b`, n2]], [`*`, [`+`, `_a`, `_b`], n2], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_extended_match: true, allow_implicit_identities: [`_a`, `_b`], evaluate_numbers: true }]], 20)), variables(s2).includes(n2)) {
          var l2 = match$1(s2, [`+`, [`*`, `_a`, n2], `_b`], { variables: { _a: c2, _b: c2 }, allow_permutations: true, allow_implicit_identities: [`_a`, `_b`] });
          if (l2) {
            var u2 = simplify(l2._a), d2 = simplify(l2._b);
            if (is_nonzero_ast(u2, r2)) {
              if (a2 === `=` || a2 === `ne` || is_positive_ast(u2, r2)) {
                let t5 = simplify([`/`, [`-`, d2], u2]);
                return [a2, n2, t5];
              }
              if (is_negative_ast(u2, r2)) {
                var p2 = simplify([`/`, [`-`, d2], u2]);
                return a2 = a2 === `<` ? `>` : a2 === `le` ? `ge` : a2 === `>` ? `<` : `le`, [a2, n2, p2];
              }
            }
          }
        }
      }
    }
  }
}
function clean_assumptions(t4, n2) {
  if (!Array.isArray(t4) || t4.length === 0) return t4;
  t4 = flatten$5(default_order(simplify_logical(expand_relations(t4))));
  var r2 = t4[0], i2 = t4.slice(1);
  if (r2 === `and` || r2 === `or`) {
    if (i2 = i2.reduce(function(t5, n3) {
      return t5.every(function(t6) {
        return !equal(t6, n3);
      }) && t5.push(n3), t5;
    }, []), r2 === `and` && n2 && Array.isArray(n2)) {
      let t5;
      t5 = n2[0] === `and` ? n2.slice(1) : [n2], i2 = i2.filter((n3) => t5.every((t6) => !equal(t6, n3)));
    }
    t4 = i2.length === 1 ? i2[0] : [r2].concat(i2);
  }
  if (r2 !== `and` && n2 && Array.isArray(n2)) {
    let r3;
    if (r3 = n2[0] === `and` ? n2.slice(1) : [n2], !r3.every((n3) => !equal(n3, t4))) return;
  }
  return t4;
}
function calculate_derived_assumptions(t4, n2) {
  if (n2 === void 0) {
    n2 = [];
    for (let r3 in t4.byvar) {
      let i3 = t4.byvar[r3];
      i3.length > 0 && n2.push(i3);
    }
    if (n2.length === 0) return {};
    n2 = n2.length === 1 ? n2[0] : [`and`].concat(n2), n2 = clean_assumptions(n2);
  }
  if (!Array.isArray(n2) || n2.length === 0) return {};
  var r2 = n2[0], i2 = n2.slice(1);
  if (r2 === `and` || r2 === `or`) {
    let n3 = i2.map(function(n4) {
      return calculate_derived_assumptions(t4, n4);
    }), a3 = [...new Set(n3.reduce((t5, n4) => [...t5, ...Object.keys(n4)], []))], o3 = {};
    for (let i3 of a3) {
      let a4 = n3.reduce(function(t5, n4) {
        return n4[i3] !== void 0 && t5.push(n4[i3]), t5;
      }, []);
      if (r2 === `and` || a4.length === n3.length) {
        let n4 = o3[i3];
        n4 = n4 === void 0 ? a4.length > 1 ? [r2].concat(a4) : a4[0] : a4.length > 1 ? [`and`, n4, [r2].concat(a4)] : [`and`, n4, a4[0]], o3[i3] = clean_assumptions(n4, get_assumptions(t4, i3, { omit_derived: true }));
      }
    }
    return o3;
  }
  let a2 = {};
  if (r2 === `=` || r2 === `ne` || r2 === `<` || r2 === `le` || r2 === `in` || r2 === `subset` || r2 === `notin` || r2 === `notsubset`) {
    var o2 = false;
    for (let n3 = 0; n3 < 2; n3++) {
      let c3 = i2[n3], l2 = i2[1 - n3], u2 = variables(l2);
      if (typeof c3 != `string` || u2.length === 0 || u2.includes(c3)) continue;
      o2 = true;
      var s2 = r2;
      n3 === 1 && (r2 === `<` ? s2 = `>` : r2 === `le` ? s2 = `ge` : r2 === `in` ? s2 = `ni` : r2 === `subset` ? s2 = `superset` : r2 === `notin` ? s2 = `notni` : r2 === `notsubset` && (s2 = `notsuperset`));
      let d2 = get_assumptions_for_expr(t4, l2, [c3]);
      if (d2 = combine_assumptions(c3, s2, l2, d2), d2 !== void 0) {
        let n4 = a2[c3];
        n4 = n4 === void 0 ? d2 : [`and`, n4, d2], a2[c3] = clean_assumptions(n4, get_assumptions(t4, c3, { omit_derived: true }));
      }
    }
    if (o2) return a2;
  }
  let c2 = [];
  for (let n3 of i2) {
    let r3 = get_assumptions_for_expr(t4, n3, []);
    r3 !== void 0 && c2.push(r3);
  }
  if (c2.length === 0) return {};
  c2 = c2.length === 1 ? c2[0] : [`and`].concat(c2);
  for (let r3 of variables(n2)) a2[r3] = clean_assumptions(c2, get_assumptions(t4, r3, { omit_derived: true }));
  return a2;
}
function get_assumptions_for_expr(t4, n2, r2) {
  let i2 = variables(n2);
  if (i2 = i2.filter((t5) => !r2.includes(t5)), i2.length === 0) return;
  function a2(t5) {
    return !!(typeof t5 == `number` || Array.isArray(t5) && t5[0] === `-` && typeof t5[1] == `number`);
  }
  var o2 = [`_b`], s2 = [`_b`], c2 = { _b: a2 }, l2 = {};
  for (let t5 = 0; t5 < i2.length; t5++) {
    let n3 = `_a` + t5;
    l2[i2[t5]] = n3, o2.push([`*`, n3, i2[t5]]), s2.push(n3), c2[n3] = a2;
  }
  o2 = [`+`].concat(o2);
  var u2 = match$1(n2, o2, { variables: c2, allow_permutations: true, allow_extended_match: false, allow_implicit_identities: s2, max_group: 1 });
  if (!u2) {
    let i3 = [];
    for (let a3 of variables(n2)) {
      let n3 = get_assumptions_for_expr(t4, a3, r2);
      n3 !== void 0 && i3.push(n3);
    }
    return i3.length === 0 ? void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
  }
  for (let t5 of i2) l2[t5] = u2[l2[t5]];
  let d2 = false;
  u2._b === 0 && u2._a0 === 1 && i2.length === 1 && (d2 = true);
  var p2 = get_assumptions(t4, [i2], { exclude_variables: r2 });
  if (p2 === void 0) return;
  return clean_assumptions(m2(p2));
  function m2(a3) {
    if (!Array.isArray(a3)) return;
    var o3 = a3[0], s3 = a3.slice(1);
    if (o3 === `and` || o3 === `or`) {
      let t5 = s3.map(m2).filter((t6) => t6 !== void 0);
      return t5.length === 0 ? void 0 : o3 === `or` ? t5.length === s3.length ? [`or`].concat(t5) : void 0 : t5.length === 1 ? t5[0] : [`and`].concat(t5);
    }
    if (!([`=`, `ne`, `<`, `le`].includes(o3) || [`in`, `notin`, `subset`, `notsubset`].includes(o3) && d2)) {
      let i3 = r2.concat(variables(n2)), o4 = [];
      for (let n3 of variables(a3)) {
        if (i3.includes(n3)) continue;
        let r3 = get_assumptions_for_expr(t4, n3, i3);
        r3 !== void 0 && o4.push(r3);
      }
      return o4.length === 0 ? a3 : o4.length === 1 ? [`and`, a3, o4[0]] : [`and`, a3].concat(o4);
    }
    let c3 = [];
    for (let a4 = 0; a4 <= 1; a4++) {
      let d3 = s3[a4], m3 = s3[1 - a4];
      if (typeof d3 == `string` && i2.includes(d3)) {
        var u3 = {};
        u3[d3] = m3;
        var p3 = simplify(substitute$1(n2, u3)), h2 = false, g2 = o3;
        (a4 === 1 && l2[d3] > 0 || a4 === 0 && l2[d3] < 0) && (o3 === `<` ? (h2 = true, g2 = `>`) : o3 === `le` ? (h2 = true, g2 = `ge`) : o3 === `in` ? (h2 = true, g2 = `ni`) : o3 === `subset` ? (h2 = true, g2 = `superset`) : o3 === `notin` ? (h2 = true, g2 = `notni`) : o3 === `notsubset` && (h2 = true, g2 = `notsuperset`)), h2 ? c3.push([o3, p3, n2]) : c3.push([o3, n2, p3]);
        let i3 = get_assumptions_for_expr(t4, p3, r2.concat([d3]));
        i3 = combine_assumptions(n2, g2, p3, i3), i3 !== void 0 && c3.push(i3);
      }
    }
    if (c3.length === 1) return c3[0];
    if (c3.length > 1) return [`and`].concat(c3);
    let v2 = r2.concat(variables(n2));
    c3 = [];
    for (let n3 of variables(a3)) {
      if (v2.includes(n3)) continue;
      let r3 = get_assumptions_for_expr(t4, n3, v2);
      r3 !== void 0 && c3.push(r3);
    }
    return c3.length === 0 ? a3 : c3.length === 1 ? [`and`, a3, c3[0]] : [`and`, a3].concat(c3);
  }
}
function combine_assumptions(t4, n2, r2, i2) {
  if (![`=`, `ne`, `<`, `le`, `>`, `ge`, `in`, `notin`, `ni`, `notni`, `subset`, `notsubset`, `superset`, `notsuperset`].includes(n2)) return i2;
  if (Array.isArray(i2)) {
    var a2 = i2[0], o2 = i2.slice(1);
    if (a2 === `and` || a2 === `or`) {
      let i3 = o2.map((i4) => combine_assumptions(t4, n2, r2, i4)).filter((t5) => t5 !== void 0);
      return i3.length === 0 ? void 0 : a2 === `or` ? i3.length === o2.length ? [[`or`].concat(i3)] : void 0 : i3.length === 1 ? i3[0] : [`and`].concat(i3);
    }
    if (![`=`, `ne`, `<`, `le`, `in`, `notin`, `subset`, `notsubset`].includes(a2)) return i2;
    var s2 = a2, c2;
    if (equal(o2[0], r2)) c2 = o2[1];
    else if (equal(o2[1], r2)) c2 = o2[0], a2 === `<` ? s2 = `>` : a2 === `le` ? s2 = `ge` : a2 === `in` ? s2 = `ni` : a2 === `notin` ? s2 = `notni` : a2 === `subset` ? s2 = `superset` : a2 === `notsubset` && (s2 = `notsuperset`);
    else return i2;
    var l2;
    if (n2 === `=`) l2 = s2;
    else if (s2 === `=`) l2 = n2;
    else if (n2 === `<`) if (s2 === `<` || s2 === `le`) l2 = `<`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `le`) if (s2 === `<`) l2 = `<`;
    else if (s2 === `le`) l2 = `le`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `>`) if (s2 === `>` || s2 === `ge`) l2 = `>`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `ge`) if (s2 === `>`) l2 = `>`;
    else if (s2 === `ge`) l2 = `ge`;
    else if (s2 === `in` || s2 === `notin`) return i2;
    else return;
    else if (n2 === `in`) if (s2 === `subset`) l2 = `in`;
    else return;
    else if (n2 === `notin`) if (s2 === `superset`) l2 = `notin`;
    else return;
    else if (n2 === `ni`) if (s2 === `notin`) l2 = `notsubset`;
    else return;
    else if (n2 === `notni`) if (s2 === `in`) l2 = `notsuperset`;
    else return;
    else if (n2 === `subset`) if (s2 === `subset`) l2 = `subset`;
    else if (s2 === `notni`) l2 = `notni`;
    else if (s2 === `notsuperset`) l2 = `notsuperset`;
    else return;
    else if (n2 === `notsubset`) if (s2 === `superset`) l2 = `notsubset`;
    else return;
    else if (n2 === `superset`) if (s2 === `superset`) l2 = `superset`;
    else if (s2 === `ni`) l2 = `ni`;
    else if (s2 === `notsubset`) l2 = `notsubset`;
    else return;
    else if (n2 === `notsuperset`) if (s2 === `subset`) l2 = `notsuperset`;
    else return;
    else return;
    return l2 === `>` ? [`<`, c2, t4] : l2 === `ge` ? [`le`, c2, t4] : l2 === `ni` ? [`in`, c2, t4] : l2 === `notni` ? [`notin`, c2, t4] : l2 === `superset` ? [`subset`, c2, t4] : l2 === `notsuperset` ? [`notsubset`, c2, t4] : [l2, t4, c2];
  }
}
function filter_assumptions_from_tree(t4, n2) {
  if (!(!Array.isArray(t4) || t4.length === 0)) {
    Array.isArray(n2) || (n2 = [n2]);
    var r2 = t4[0], i2 = t4.slice(1);
    if (r2 === `and`) {
      var a2 = i2.map(function(t5) {
        return filter_assumptions_from_tree(t5, n2);
      });
      return a2 = a2.filter((t5) => t5 !== void 0), a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : [`and`].concat(a2);
    }
    var o2 = variables(t4);
    if (!(n2.filter((t5) => o2.includes(t5)).length > 0)) return t4;
  }
}
function get_assumptions_sub(t4, n2, r2, i2) {
  Array.isArray(n2) || (n2 = [n2]);
  var a2 = [];
  if (n2.forEach(function(n3) {
    if (t4.byvar[n3] || t4.derived[n3]) {
      if (t4.byvar[n3] && t4.byvar[n3].length > 0) {
        var o2 = filter_assumptions_from_tree(t4.byvar[n3], r2);
        o2 !== void 0 && a2.push(o2);
      }
      if (t4.derived[n3] && t4.derived[n3].length > 0 && !i2) {
        var s2 = filter_assumptions_from_tree(t4.derived[n3], r2);
        s2 !== void 0 && a2.push(s2);
      }
    } else t4.generic.length > 0 && (n3 === `x` || !variables(t4.generic).includes(n3)) && a2.push(substitute$1(t4.generic, { x: n3 }));
  }), a2.length === 1 ? a2 = a2[0] : a2.length > 1 && (a2 = [`and`].concat(a2)), a2.length > 0) return clean_assumptions(a2);
}
function get_assumptions(t4, n2, r2) {
  r2 === void 0 && (r2 = {});
  var i2 = r2.exclude_variables;
  i2 === void 0 ? i2 = [] : Array.isArray(i2) || (i2 = [i2]);
  var a2, o2 = get_tree(n2);
  if (typeof o2 == `string`) a2 = [o2];
  else if (Array.isArray(o2)) Array.isArray(o2[0]) && (a2 = o2[0]);
  else return;
  return a2 ? get_assumptions_sub(t4, a2, i2, r2.omit_derived) : get_assumptions_for_expr(t4, o2, i2);
}
function add_assumption(t4, n2, r2) {
  var i2 = get_tree(n2);
  if (!Array.isArray(i2)) return 0;
  i2 = clean_assumptions(simplify(i2, t4));
  var a2 = add_assumption_sub(t4, i2, r2);
  return a2 && (t4.derived = calculate_derived_assumptions(t4)), a2;
}
function add_assumption_sub(t4, n2, r2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_assumption_sub(t4, n3, r2)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var i2 = variables(n2);
  if (i2.length === 0) return 0;
  let a2 = 0;
  !r2 && t4.generic.length > 0 && i2.forEach(function(n3) {
    t4.byvar[n3] === void 0 && (n3 === `x` || !variables(t4.generic).includes(n3)) && (add_assumption_sub(t4, substitute$1(t4.generic, { x: n3 }), true), a2 += 1);
  });
  for (let r3 of i2) {
    let i3 = solve_linear(n2, r3, t4), o2 = n2;
    i3 && (o2 = i3);
    let s2 = t4.byvar[r3];
    s2 !== void 0 && s2.length !== 0 && (o2 = [`and`, s2, o2]), o2 = clean_assumptions(o2), equal(o2, s2) || (t4.byvar[r3] = o2, a2 += 1);
  }
  return a2;
}
function add_generic_assumption(t4, n2) {
  var r2 = get_tree(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions(simplify(r2, t4));
  var i2 = add_generic_assumption_sub(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions(t4)), i2;
}
function add_generic_assumption_sub(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => add_generic_assumption_sub(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables(n2).includes(`x`)) return 0;
  let r2 = solve_linear(n2, `x`, t4), i2 = n2;
  r2 && (i2 = r2);
  let a2 = t4.generic;
  return a2.length !== 0 && (i2 = [`and`, a2, i2]), i2 = clean_assumptions(i2), equal(i2, a2) ? 0 : (t4.generic = i2, 1);
}
function remove_assumption(t4, n2) {
  var r2 = get_tree(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions(simplify(r2, t4));
  var i2 = remove_assumption_sub(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions(t4)), i2;
}
function remove_assumption_sub(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_assumption_sub(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  var r2 = variables(n2);
  if (r2.length === 0) return 0;
  var i2 = 0;
  for (let a2 of r2) {
    let r3 = solve_linear(n2, a2, t4), o2 = t4.byvar[a2];
    if (!o2 || o2.length === 0) continue;
    let s2 = o2[0], c2 = o2.slice(1), l2 = c2.length, u2;
    if (s2 === `and`) if (c2 = c2.filter((t5) => !(equal(t5, n2) || equal(t5, r3))), c2.length === 0) u2 = [];
    else if (c2.length === 1) u2 = c2[0];
    else if (c2.length < l2) u2 = [s2].concat(c2);
    else continue;
    else if (equal(o2, n2) || equal(o2, r3)) u2 = [];
    else continue;
    i2 += 1, t4.byvar[a2] = u2;
  }
  return i2;
}
function remove_generic_assumption(t4, n2) {
  var r2 = get_tree(n2);
  if (!Array.isArray(r2)) return 0;
  r2 = clean_assumptions(simplify(r2, t4));
  var i2 = remove_generic_assumption_sub(t4, r2);
  return i2 && (t4.derived = calculate_derived_assumptions(t4)), i2;
}
function remove_generic_assumption_sub(t4, n2) {
  if (n2[0] === `and`) return n2.slice(1).map((n3) => remove_generic_assumption_sub(t4, n3)).reduce(function(t5, n3) {
    return t5 + n3;
  });
  if (!variables(n2).includes(`x`)) return 0;
  var r2 = t4.generic;
  if (r2.length === 0) return 0;
  let i2 = solve_linear(n2, `x`, t4);
  var a2 = r2[0], o2 = r2.slice(1), s2 = o2.length, c2;
  if (a2 === `and`) if (o2 = o2.filter((t5) => !(equal(t5, n2) || equal(t5, i2))), o2.length === 0) c2 = [];
  else if (o2.length === 1) c2 = o2[0];
  else if (o2.length < s2) c2 = [a2].concat(o2);
  else return 0;
  else if (equal(r2, n2) || equal(r2, i2)) c2 = [];
  else return 0;
  return t4.generic = c2, 1;
}
function initialize_assumptions() {
  var t4 = {};
  return t4.byvar = {}, t4.derived = {}, t4.generic = [], t4.not_commutative = [], t4.get_assumptions = function(n2, r2) {
    return get_assumptions(t4, n2, r2);
  }, t4.add_assumption = function(n2, r2) {
    return add_assumption(t4, n2, r2);
  }, t4.add_generic_assumption = function(n2) {
    return add_generic_assumption(t4, n2);
  }, t4.remove_assumption = function(n2) {
    return remove_assumption(t4, n2);
  }, t4.remove_generic_assumption = function(n2) {
    return remove_generic_assumption(t4, n2);
  }, t4;
}
var operators$1 = { "+": function(t4) {
  return t4.join(` `);
}, "-": function(t4) {
  return `-` + t4[0];
}, pm: function(t4) {
  return `\\pm ` + t4[0];
}, "*": function(t4) {
  return t4.join(` `);
}, "/": function(t4) {
  return `\\frac{` + t4[0] + `}{` + t4[1] + `}`;
}, _: function(t4) {
  return t4[0] + `_{` + t4[1] + `}`;
}, "^": function(t4) {
  return t4[0] + `^{` + t4[1] + `}`;
}, prime: function(t4) {
  return t4[0] + `'`;
}, tuple: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, array: function(t4) {
  return `\\left[ ` + t4.join(`, `) + ` \\right]`;
}, list: function(t4) {
  return t4.join(`, `);
}, set: function(t4) {
  return `\\left\\{ ` + t4.join(`, `) + ` \\right\\}`;
}, vector: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, altvector: function(t4) {
  return `\\left\\langle ` + t4.join(`, `) + ` \\right\\rangle`;
}, interval: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, matrix: function(t4) {
  return `\\left( ` + t4.join(`, `) + ` \\right)`;
}, and: function(t4) {
  return t4.join(` \\land `);
}, or: function(t4) {
  return t4.join(` \\lor `);
}, not: function(t4) {
  return `\\lnot ` + t4[0];
}, "=": function(t4) {
  return t4.join(` = `);
}, "<": function(t4) {
  return t4.join(` < `);
}, ">": function(t4) {
  return t4.join(` > `);
}, lts: function(t4) {
  return t4.join(` < `);
}, gts: function(t4) {
  return t4.join(` > `);
}, le: function(t4) {
  return t4.join(` \\le `);
}, ge: function(t4) {
  return t4.join(` \\ge `);
}, ne: function(t4) {
  return t4.join(` \\ne `);
}, forall: function(t4) {
  return `\\forall ` + t4[0];
}, exists: function(t4) {
  return `\\exists ` + t4[0];
}, in: function(t4) {
  return t4[0] + ` \\in ` + t4[1];
}, notin: function(t4) {
  return t4[0] + ` \\notin ` + t4[1];
}, ni: function(t4) {
  return t4[0] + ` \\ni ` + t4[1];
}, notni: function(t4) {
  return t4[0] + ` \\not\\ni ` + t4[1];
}, subset: function(t4) {
  return t4[0] + ` \\subset ` + t4[1];
}, subseteq: function(t4) {
  return t4[0] + ` \\subseteq ` + t4[1];
}, notsubset: function(t4) {
  return t4[0] + ` \\not\\subset ` + t4[1];
}, notsubseteq: function(t4) {
  return t4[0] + ` \\not\\subseteq ` + t4[1];
}, superset: function(t4) {
  return t4[0] + ` \\supset ` + t4[1];
}, superseteq: function(t4) {
  return t4[0] + ` \\supseteq ` + t4[1];
}, notsuperset: function(t4) {
  return t4[0] + ` \\not\\supset ` + t4[1];
}, notsuperseteq: function(t4) {
  return t4[0] + ` \\not\\supseteq ` + t4[1];
}, union: function(t4) {
  return t4.join(` \\cup `);
}, intersect: function(t4) {
  return t4.join(` \\cap `);
}, implies: function(t4) {
  return t4.join(` \\implies `);
}, impliedby: function(t4) {
  return t4.join(` \\impliedby `);
}, iff: function(t4) {
  return t4.join(` \\iff `);
}, leftarrow: function(t4) {
  return t4.join(` \\leftarrow `);
}, rightarrow: function(t4) {
  return t4.join(` \\rightarrow `);
}, leftrightarrow: function(t4) {
  return t4.join(` \\leftrightarrow `);
}, perp: function(t4) {
  return t4.join(` \\perp `);
}, parallel: function(t4) {
  return t4.join(` \\parallel `);
}, derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, partial_derivative_leibniz: function(t4) {
  return `\\frac{d` + t4[0] + `}{d` + t4[1] + `}`;
}, "|": function(t4) {
  return t4[0] + ` \\mid ` + t4[1];
}, ":": function(t4) {
  return t4[0] + ` : ` + t4[1];
}, binom: function(t4) {
  return `\\binom{` + t4[0] + `}{` + t4[1] + `}`;
}, vec: function(t4) {
  return `\\vec{` + t4[0] + `}`;
}, linesegment: function(t4) {
  return `\\overline{` + t4.join(` `) + `}`;
}, angle: function(t4, n2) {
  return n2 ? `\\angle ` + t4.join(``) : `\\angle\\left( ` + t4.join(`, `) + ` \\right)`;
}, unit: function(t4) {
  return t4[1] === `\\circ` ? t4[0] + `^{\\circ}` : t4[0] + ` ` + t4[1];
} }, allowedLatexSymbolsDefault$1 = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.cot.coth.csc.csch.sec.sech.sin.sinh.tan.tanh.arcsin.arccos.arctan.arccsc.arcsec.arccot.arg.Re.Im.det.angle.perp.circ.%.$.int.varnothing`.split(`.`), convertLatexSymbolsDefault = { acos: `arccos`, acosh: `arccosh`, acot: `arccot`, acoth: `arccoth`, acsc: `arccsc`, acsch: `arccsch`, asec: `arcsec`, asech: `arcsech`, asin: `arcsin`, asinh: `arcsinh`, atan: `arctan`, atanh: `arctanh`, deg: `circ`, emptyset: `varnothing` }, matrixEnvironmentDefault = `bmatrix`, astToLatex$1 = class {
  constructor({ allowedLatexSymbols: t4 = allowedLatexSymbolsDefault$1, convertLatexSymbols: n2 = convertLatexSymbolsDefault, matrixEnvironment: r2 = matrixEnvironmentDefault, padToDigits: i2 = null, padToDecimals: a2 = null, avoidScientificNotation: o2 = false, showBlanks: s2 = true } = {}) {
    this.allowedLatexSymbols = t4, this.convertLatexSymbols = n2, this.matrixEnvironment = r2, this.padToDigits = i2, this.padToDecimals = a2, this.avoidScientificNotation = o2, this.showBlanks = s2;
  }
  convert(t4) {
    return this.statement(normalize_display_negative_fractions(t4));
  }
  statement(t4) {
    if (!Array.isArray(t4)) return this.single_statement(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `ldots`) return `\\ldots`;
    if (!(n2 in operators$1) && n2 !== `apply`) throw Error(`Badly formed ast: operator ` + n2 + ` not recognized.`);
    return [`implies`, `impliedby`, `iff`, `rightarrow`, `leftarrow`, `leftrightarrow`].includes(n2) ? operators$1[n2](r2.map((t5) => this.statement(t5))) : n2 === `and` || n2 === `or` ? operators$1[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this))) : this.single_statement(t4);
  }
  single_statement(t4) {
    if (!Array.isArray(t4)) return this.expression(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `not`) return operators$1[n2](r2.map((function(t5, n3) {
      let r3 = this.single_statement(t5);
      return r3.match(/ /) && !r3.match(/^\\left\(.*\\right\)$/) ? `\\left(` + r3 + `\\right)` : r3;
    }).bind(this)));
    if (n2 === `exists` || n2 === `forall`) return operators$1[n2]([this.single_statement(r2[0])]);
    if (n2 === `=` || n2 === `ne` || n2 === `<` || n2 === `>` || n2 === `le` || n2 === `ge` || n2 === `in` || n2 === `notin` || n2 === `ni` || n2 === `notni` || n2 === `subset` || n2 === `notsubset` || n2 === `subseteq` || n2 === `notsubseteq` || n2 === `superset` || n2 === `notsuperset` || n2 === `superseteq` || n2 === `notsuperseteq`) return operators$1[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this)));
    if (n2 === `lts` || n2 === `gts`) {
      let t5 = r2[0], i2 = r2[1];
      if (t5[0] !== `tuple` || i2[0] !== `tuple`) throw Error(`Badly formed ast`);
      let a2 = this.expression(t5[1]);
      for (let r3 = 1; r3 < t5.length - 1; r3++) i2[r3] ? n2 === `lts` ? a2 += ` < ` : a2 += ` > ` : n2 === `lts` ? a2 += ` \\le ` : a2 += ` \\ge `, a2 += this.expression(t5[r3 + 1]);
      return a2;
    }
    return this.expression(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` ? r2.length === 1 ? `+` + this.term(r2[0]) : operators$1[n2](r2.map((function(t5, n3) {
      return n3 > 0 ? this.termWithPlusIfNotNegated(t5) : this.term(t5);
    }).bind(this))) : [`union`, `intersect`, `perp`, `parallel`].includes(n2) ? operators$1[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : this.term(t4);
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `-` || n2 === `pm` ? operators$1[n2](r2.map((function(t5, n3) {
      return this.term(t5);
    }).bind(this))) : n2 === `*` ? operators$1[n2](r2.map((function(t5, n3) {
      let i2;
      return n3 > 0 ? (i2 = this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(t5), i2.match(/^[0-9]/) ? `\\cdot ` + i2 : t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2) : (i2 = this.factor(t5), t5[0] === `angle` && r2.length > 1 ? `\\left( ` + i2 + ` \\right)` : i2);
    }).bind(this))) : n2 === `/` || n2 === `unit` ? operators$1[n2](r2.map((function(t5, n3) {
      return this.expression(t5);
    }).bind(this))) : this.factor(t4);
  }
  simple_factor_or_function_or_parens(t4) {
    var n2 = this.factor(t4);
    return n2.length <= 1 || typeof t4 == `string` && t4.match(/^\w+$/) || Array.isArray(t4) && t4[0] === `apply` && ![`sqrt`, `cbrt`, `nthroot`].includes(t4[1]) || n2.match(/^\\left\(.*\\right\)$/) || n2.match(/^\\left\\langle.*\\right\\rangle$/) ? true : typeof t4 == `number` ? !!(t4 >= 0 && (this.avoidScientificNotation || !t4.toString().includes(`e`))) : false;
  }
  stringConvert(t4) {
    return t4.length > 1 ? (this.convertLatexSymbols[t4] && (t4 = this.convertLatexSymbols[t4]), this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : `\\operatorname{` + t4 + `}`) : this.allowedLatexSymbols.includes(t4) ? `\\` + t4 : t4 === `＿` && !this.showBlanks ? `` : t4;
  }
  factor(t4) {
    if (typeof t4 == `string`) return this.stringConvert(t4);
    if (typeof t4 == `number`) {
      if (t4 === 1 / 0) return `\\infty`;
      if (t4 === -1 / 0) return `-\\infty`;
      if (Number.isNaN(t4)) return `NaN`;
      {
        let n3 = t4.toString(), r3 = n3.indexOf(`e`);
        if (r3 === -1 || this.avoidScientificNotation) return r3 !== -1 && this.avoidScientificNotation && (n3 = expandScientificNotation(n3)), (this.padToDigits !== null || this.padToDecimals !== null) && (n3 = padNumberStringToDigitsAndDecimals(n3, this.padToDigits, this.padToDecimals)), n3;
        let i2 = n3.substring(0, r3), a2 = n3.substring(r3 + 1);
        if (a2[0] === `+` && (a2 = a2.slice(1)), this.padToDigits !== null || this.padToDecimals !== null) {
          let r4 = Number(a2);
          if (r4 > 0 && this.padToDecimals !== null) return n3 = t4.toLocaleString(`fullwide`, { useGrouping: false }), padNumberStringToDigitsAndDecimals(n3, this.padToDigits, this.padToDecimals);
          {
            let t5 = null;
            this.padToDecimals !== null && (t5 = this.padToDecimals + r4), i2 = padNumberStringToDigitsAndDecimals(i2, this.padToDigits, t5);
          }
        }
        return i2 + ` \\cdot 10^{` + a2 + `}`;
      }
    }
    if (!Array.isArray(t4)) return ``;
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `^`) {
      if (Number.isInteger(r2[0]) && Number.isInteger(r2[1])) return r2[0] < 0 ? `\\left(` + r2[0].toString() + `\\right)^{` + r2[1].toString() + `}` : r2[0].toString() + `^{` + r2[1].toString() + `}`;
      let t5 = this.factor(r2[0]), n3 = r2[0];
      for (; n3[0] === `prime`; ) n3 = n3[1];
      return this.simple_factor_or_function_or_parens(n3) || n3[0] === `_` && typeof n3[1] == `string` || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `^{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `_`) {
      let t5 = this.factor(r2[0]);
      return this.simple_factor_or_function_or_parens(r2[0]) || (t5 = `\\left(` + t5.toString() + `\\right)`), t5 + `_{` + this.statement(r2[1]) + `}`;
    } else if (n2 === `prime`) {
      let t5 = r2[0], n3 = 1;
      for (; t5[0] === `prime`; ) n3 += 1, t5 = t5[1];
      let i2 = this.factor(t5);
      this.simple_factor_or_function_or_parens(t5) || t5[0] === `_` && typeof t5[1] == `string` || (i2 = `\\left(` + i2 + `\\right)`);
      for (let t6 = 0; t6 < n3; t6++) i2 += `'`;
      return i2;
    } else if (n2 === `/`) return this.term(t4);
    else if (n2 === `-`) return operators$1[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this)));
    else if (n2 === `tuple` || n2 === `array` || n2 === `list` || n2 === `set` || n2 === `vector` || n2 === `altvector` || n2 === `|` || n2 === `:` || n2 === `binom` || n2 === `vec` || n2 === `linesegment`) return operators$1[n2](r2.map((function(t5, n3) {
      return this.statement(t5);
    }).bind(this)));
    else if (n2 === `interval`) {
      let t5 = r2[0], n3 = r2[1];
      if (t5[0] !== `tuple` || n3[0] !== `tuple`) throw Error(`Badly formed ast`);
      let i2 = this.statement(t5[1]) + `, ` + this.statement(t5[2]);
      return i2 = n3[1] ? `\\left[ ` + i2 : `\\left( ` + i2, n3[2] ? i2 += ` \\right]` : i2 += ` \\right)`, i2;
    } else if (n2 === `matrix`) {
      let t5 = r2[0], n3 = r2[1], i2 = `\\begin{` + this.matrixEnvironment + `} `;
      for (let r3 = 0; r3 < t5[1]; r3 += 1) {
        for (let a2 = 0; a2 < t5[2]; a2 += 1) i2 += this.statement(n3[r3 + 1][a2 + 1]), a2 < t5[2] - 1 && (i2 += ` & `);
        r3 < t5[1] - 1 && (i2 += ` \\\\ `);
      }
      return i2 = i2 + ` \\end{` + this.matrixEnvironment + `}`, i2;
    } else if (n2 === `derivative_leibniz` || n2 === `partial_derivative_leibniz`) {
      let t5 = `d`;
      n2 === `partial_derivative_leibniz` && (t5 = `\\partial `);
      let i2 = r2[0], a2 = r2[1], o2 = 1, s2 = ``;
      Array.isArray(i2) ? (s2 = i2[1], o2 = i2[2]) : s2 = i2;
      let c2 = t5;
      o2 > 1 ? c2 = c2.trimRight() + `^{` + o2 + `}` + this.stringConvert(s2) : c2 += this.stringConvert(s2), c2 = `\\frac{ ` + c2 + ` }{ `;
      let l2 = 1;
      Array.isArray(a2) && (l2 = a2.length - 1);
      for (let n3 = 1; n3 <= l2; n3++) {
        let r3 = a2[n3], i3 = 1, o3 = ``;
        Array.isArray(r3) ? (o3 = r3[1], i3 = r3[2]) : o3 = r3, c2 = c2 + t5 + this.stringConvert(o3), i3 > 1 && (c2 = c2 + `^{` + i3 + `}`), c2 += ` `;
      }
      return c2 += `}`, c2;
    } else if (n2 === `apply`) {
      if (r2[0] === `abs`) return `\\left|` + this.statement(r2[1]) + `\\right|`;
      if (r2[0] === `floor`) return `\\left\\lfloor ` + this.statement(r2[1]) + ` \\right\\rfloor`;
      if (r2[0] === `ceil`) return `\\left\\lceil ` + this.statement(r2[1]) + ` \\right\\rceil`;
      if (r2[0] === `factorial`) {
        let t6 = this.factor(r2[1]);
        return this.simple_factor_or_function_or_parens(r2[1]) || r2[1][0] === `_` && typeof r2[1][1] == `string` ? t6 + `!` : `\\left(` + t6 + `\\right)!`;
      } else if (r2[0] === `sqrt`) return `\\sqrt{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `cbrt`) return `\\sqrt[3]{` + this.statement(r2[1]) + `}`;
      else if (r2[0] === `nthroot`) return Array.isArray(r2[1]) && r2[1][0] === `tuple` && r2[1].length === 3 ? `\\sqrt[` + this.statement(r2[1][2]) + `]{` + this.statement(r2[1][1]) + `}` : `\\sqrt{` + this.statement(r2[1]) + `}`;
      let t5 = r2[0];
      if (t5[0] === `^` && (t5 = t5[1]), t5[0] === `_` && (t5 = t5[1]), t5 === `int`) {
        let t6 = this.factor(r2[0]), n4 = r2[1], i3;
        if (Array.isArray(n4) && n4[0] === `*`) {
          let t7 = [], r3 = [`*`];
          for (let i4 = 1; i4 < n4.length; i4++) {
            let a2 = n4[i4];
            Array.isArray(a2) && a2[0] === `d` ? t7.push(a2) : r3.push(a2);
          }
          i3 = this.term(r3), t7.length > 0 && (i3[i3.length - 1].match(/[a-zA-Z]/) && (i3 += `\\,`), i3 += t7.map((t8) => `d` + this.factor(t8[1])).join(`\\,`));
        }
        return i3 ||= this.term(r2[1]), t6 + ` ` + i3;
      }
      let n3;
      n3 = r2[0] === `log10` ? `\\log_{10}` : r2[0] === `re` ? `\\Re` : r2[0] === `im` ? `\\Im` : this.factor(r2[0]);
      let i2 = this.statement(r2[1]);
      return r2[1][0] !== `tuple` && (i2 = `\\left(` + i2 + `\\right)`), n3 + i2;
    } else if (n2 === `angle`) {
      let t5 = r2.every((t6) => {
        if (typeof t6 == `string` && t6.length === 1) return true;
        if (!Array.isArray(t6)) return false;
        let n3 = t6[0];
        return n3 === `_` || n3 === `^` || n3 === `prime`;
      });
      return operators$1[n2](r2.map((function(t6, n3) {
        return this.statement(t6);
      }).bind(this)), t5);
    } else if (n2 === `+` && t4.length === 2) return `+ ` + this.factor(t4[1]);
    else return `\\left(` + this.statement(t4) + `\\right)`;
  }
  factorWithParenthesesIfNegatedExplicitPlusOrFraction(t4) {
    var n2 = this.factor(t4);
    return n2.match(/^-/) || n2.match(/^\+/) || t4[0] === `/` ? `\\left(` + n2 + `\\right)` : n2;
  }
  termWithPlusIfNotNegated(t4) {
    var n2 = this.term(t4);
    return n2.match(/^\\pm /) ? n2 : n2.match(/^-/) ? n2.match(/^-[^ ]/) ? `- ` + n2.slice(1) : n2 : `+ ` + n2;
  }
}, operators = { "+,add": function(t4) {
  return [`+`].concat(t4);
}, "*,multiply": function(t4) {
  return [`*`].concat(t4);
}, "/,divide": function(t4) {
  return [`/`, t4[0], t4[1]];
}, "-,unaryMinus": function(t4) {
  return [`-`, t4[0]];
}, "-,subtract": function(t4) {
  return [`+`, t4[0], [`-`, t4[1]]];
}, "^,pow": function(t4) {
  return [`^`, t4[0], t4[1]];
}, "and,and": function(t4) {
  return [`and`].concat(t4);
}, "or,or": function(t4) {
  return [`or`].concat(t4);
}, "not,not": function(t4) {
  return [`not`, t4[0]];
}, "==,equal": function(t4) {
  return [`=`].concat(t4);
}, "<,smaller": function(t4) {
  return [`<`, t4[0], t4[1]];
}, ">,larger": function(t4) {
  return [`>`, t4[0], t4[1]];
}, "<=,smallerEq": function(t4) {
  return [`le`, t4[0], t4[1]];
}, ">=,largerEq": function(t4) {
  return [`ge`, t4[0], t4[1]];
}, "!=,unequal": function(t4) {
  return [`ne`, t4[0], t4[1]];
}, "!,factorial": function(t4) {
  return [`apply`, `factorial`, t4[0]];
} }, mathjsToAst$1 = class {
  convert(t4) {
    if (t4.isConstantNode) return t4.value;
    if (t4.isSymbolNode) return t4.name;
    if (t4.isOperatorNode) {
      var n2 = [t4.op, t4.fn].join(`,`);
      if (n2 in operators) return operators[n2](t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
      throw Error(`Unsupported operator: ` + t4.op + `, ` + t4.fn);
    }
    if (t4.isFunctionNode) {
      var r2 = t4.args.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this));
      r2 = r2.length > 1 ? [`tuple`].concat(r2) : r2[0];
      var i2 = [`apply`, t4.name];
      return i2.push(r2), i2;
    }
    if (t4.isArrayNode) return [`vector`].concat(t4.args.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    if (t4.isParenthesisNode) return this.convert(t4.content);
    throw Error(`Unsupported node type: ` + t4.type);
  }
}, differentiation_exports = __exportAll({ derivative: () => derivative, derivativeStory: () => derivativeStory, derivative_story: () => derivative_story, derivative_with_story: () => derivative_with_story }), astToMathjs = new astToMathjs$2({ mathjs: mathjs_default }), mathjsToAst = new mathjsToAst$1(), textToAst$2 = new textToAst$4(), astToLatex = new astToLatex$1(), derivatives = { sin: textToAst$2.convert(`cos x`), cos: textToAst$2.convert(`-(sin x)`), tan: textToAst$2.convert(`(sec x)^2`), cot: textToAst$2.convert(`-((csc x)^2)`), sec: textToAst$2.convert(`(sec x)*(tan x)`), csc: textToAst$2.convert(`-(csc x)*(cot x)`), sqrt: textToAst$2.convert(`1/(2*sqrt(x))`), cbrt: textToAst$2.convert(`1/(3*x^(2/3))`), log: textToAst$2.convert(`1/x`), ln: textToAst$2.convert(`1/x`), exp: textToAst$2.convert(`exp(x)`), arcsin: textToAst$2.convert(`1/sqrt(1 - x^2)`), arccos: textToAst$2.convert(`-1/sqrt(1 - x^2)`), arctan: textToAst$2.convert(`1/(1 + x^2)`), arccsc: textToAst$2.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), arcsec: textToAst$2.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), arccot: textToAst$2.convert(`-1/(1 + x^2)`), asin: textToAst$2.convert(`1/sqrt(1 - x^2)`), acos: textToAst$2.convert(`-1/sqrt(1 - x^2)`), atan: textToAst$2.convert(`1/(1 + x^2)`), acsc: textToAst$2.convert(`-1/(sqrt(-1/x^2 + 1)*x^2)`), asec: textToAst$2.convert(`1/(sqrt(-1/x^2 + 1)*x^2)`), acot: textToAst$2.convert(`-1/(1 + x^2)`), abs: textToAst$2.convert(`abs(x)/x`) };
function derivative_with_story(t4, n2, r2 = []) {
  var i2 = get_tree(t4), a2 = `\\frac{d}{d` + n2 + `} `;
  if (typeof i2 == `number` || variables(i2).indexOf(n2) < 0) return r2.push(`The derivative of a constant is zero, that is, \\(` + a2 + astToLatex.convert(i2) + ` = 0\\).`), 0;
  if (typeof i2 == `string`) return n2 === i2 ? (r2.push(`We know the derivative of the identity function is one, that is, \\(` + a2 + astToLatex.convert(i2) + ` = 1\\).`), 1) : (r2.push(`As far as \\(` + astToLatex.convert(n2) + `\\) is concerned, \\(` + astToLatex.convert(i2) + `\\) is constant, so ` + a2 + astToLatex.convert(i2) + ` = 0\\).`), 0);
  if (!Array.isArray(i2)) return null;
  var o2 = i2[0], s2 = i2.slice(1);
  if (o2 === `apply` && s2[0] === `nthroot`) if (s2[1].length !== 3 || s2[1][0] !== `tuple`) s2[0] = `sqrt`;
  else {
    let t5 = s2[1][2];
    o2 = `^`, s2 = [s2[1][1], [`/`, 1, t5]];
  }
  if (o2 === `+` || o2 === `-` || o2 === `~`) {
    r2.push(`Using the sum rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return a2 + astToLatex.convert(t6);
    }).join(` + `) + `\\).`);
    let t5 = [o2].concat(s2.map(function(t6, i3) {
      return derivative_with_story(t6, n2, r2);
    }));
    return t5 = simplify(t5), r2.push(`So using the sum rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(t5) + `\\).`), t5;
  }
  if (o2 === `*`) {
    let t5 = [], o3 = [];
    for (let r3 = 0; r3 < s2.length; r3++) typeof s2[r3] == `number` || variables(s2[r3]).indexOf(n2) < 0 ? o3.push(s2[r3]) : t5.push(s2[r3]);
    if (o3.length > 0) {
      if (t5.length === 0) return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex.convert(i2) + ` = 0.\\)`), 0;
      let s3 = [`*`].concat(t5);
      if (t5.length === 1 && (s3 = t5[0]), s3 === n2) {
        r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + o3.map(function(t7, n3) {
          return astToLatex.convert(t7);
        }).join(` \\cdot `) + `\\).`);
        let t6 = [`*`].concat(o3);
        return t6 = simplify(t6), t6;
      }
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + o3.map(function(t6, n3) {
        return astToLatex.convert(t6);
      }).join(` \\cdot `) + ` \\cdot ` + a2 + `\\left(` + astToLatex.convert(s3) + `\\right)\\).`);
      let c3 = derivative_with_story(s3, n2, r2), l3 = [`*`].concat(o3.concat([c3]));
      return l3 = simplify(l3), r2.push(`And so \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(l3) + `\\).`), l3;
    }
    r2.push(`Using the product rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + s2.map(function(t6, n3) {
      return s2.map(function(r3, i3) {
        return n3 === i3 ? a2 + `\\left(` + astToLatex.convert(t6) + `\\right)` : astToLatex.convert(r3);
      }).join(` \\cdot `);
    }).join(` + `) + `\\).`);
    let c2 = s2.slice(), l2 = [`+`].concat(s2.map(function(t6, i3) {
      return [`*`].concat(c2.map(function(t7, a3) {
        if (i3 === a3) {
          let i4 = derivative_with_story(t7, n2, r2);
          return i4 === 1 ? null : i4;
        } else return t7;
      }).filter(function(t7) {
        return t7 != null;
      }));
    }));
    return l2 = simplify(l2), r2.push(`So using the product rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(l2) + `\\).`), l2;
  }
  if (o2 === `/`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables(o3).indexOf(n2) < 0) {
      r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert([`/`, 1, o3]) + ` \\cdot ` + a2 + `\\left(` + astToLatex.convert(t5) + `\\right)\\).`);
      let s3 = derivative_with_story(t5, n2, r2), c3 = substitute$1(textToAst$2.convert(`(1/g)*d`), { d: s3, g: o3 });
      return c3 = simplify(c3), r2.push(`So \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(c3) + `\\).`), c3;
    }
    if (variables(t5).indexOf(n2) < 0) {
      t5 !== 1 && r2.push(`By the constant multiple rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(t5) + ` \\cdot ` + a2 + `\\left(` + astToLatex.convert([`/`, 1, o3]) + `\\right)\\).`), r2.push(`Since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(t5) + `\\cdot \\frac{-1}{ ` + astToLatex.convert(o3) + `^2} \\cdot ` + a2 + astToLatex.convert(o3) + `\\).`);
      let s3 = derivative_with_story(o3, n2, r2), c3 = substitute$1(textToAst$2.convert(`f * (-a/(g^2))`), { f: t5, a: s3, g: o3 });
      return c3 = simplify(c3), r2.push(`So since \\(\\frac{d}{du} \\frac{1}{u}\\) is \\(\\frac{-1}{u^2}\\), the chain rule gives \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(c3) + `\\).`), c3;
    }
    r2.push(`Using the quotient rule, \\(` + a2 + astToLatex.convert(i2) + ` = \\frac{` + a2 + `\\left(` + astToLatex.convert(t5) + `\\right) \\cdot ` + astToLatex.convert(o3) + ` - ` + astToLatex.convert(t5) + `\\cdot ` + a2 + `\\left(` + astToLatex.convert(o3) + `\\right)}{ \\left( ` + astToLatex.convert(o3) + ` \\right)^2} \\).`);
    let c2 = derivative_with_story(t5, n2, r2), l2 = derivative_with_story(o3, n2, r2), u2 = substitute$1(textToAst$2.convert(`(a * g - f * b)/(g^2)`), { a: c2, b: l2, f: t5, g: o3 });
    return u2 = simplify(u2), r2.push(`So using the quotient rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(u2) + `\\).`), u2;
  }
  if (o2 === `^`) {
    let t5 = s2[0], o3 = s2[1];
    if (variables(o3).indexOf(n2) < 0) {
      if (typeof t5 == `string` && t5 === `x`) {
        if (typeof o3 == `number`) {
          let n4 = substitute$1(textToAst$2.convert(`n * (f^m)`), { n: o3, m: o3 - 1, f: t5 });
          return n4 = simplify(n4), r2.push(`By the power rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(o3) + ` \\cdot \\left(` + astToLatex.convert(t5) + `\\right)^{` + astToLatex.convert([`-`, o3, 1]) + `}\\).`), n4;
        }
        let n3 = substitute$1(textToAst$2.convert(`n * (f^(n-1))`), { n: o3, f: t5 });
        return n3 = simplify(n3), r2.push(`By the power rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(o3) + ` \\cdot \\left(` + astToLatex.convert(t5) + `\\right)^{` + astToLatex.convert([`-`, o3, 1]) + `}\\).`), n3;
      }
      o3 !== 1 && r2.push(`By the power rule and the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(o3) + ` \\cdot \\left(` + astToLatex.convert(t5) + `\\right)^{` + astToLatex.convert([`-`, o3, 1]) + `} \\cdot ` + a2 + astToLatex.convert(t5) + `\\).`);
      let s3 = derivative_with_story(t5, n2, r2);
      if (o3 === 1) return s3;
      if (typeof o3 == `number`) {
        let n3 = substitute$1(textToAst$2.convert(`n * (f^m) * a`), { n: o3, m: o3 - 1, f: t5, a: s3 });
        return n3 = simplify(n3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(n3) + `\\).`), n3;
      }
      let c3 = substitute$1(textToAst$2.convert(`n * (f^(n-1)) * a`), { n: o3, f: t5, a: s3 });
      return c3 = simplify(c3), r2.push(`So by the power rule and the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(c3) + `\\).`), c3;
    }
    if (t5 === `e` && mathjs_default.define_e) {
      if (typeof o3 == `string` && o3 === n2) {
        let t7 = substitute$1(textToAst$2.convert(`e^(f)`), { f: o3 });
        return t7 = simplify(t7), r2.push(`The derivative of \\(e^` + astToLatex.convert(n2) + `\\) is itself, that is, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(i2) + `\\).`), t7;
      }
      r2.push(`Using the rule for \\(e^x\\) and the chain rule, we know \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(i2) + ` \\cdot ` + a2 + astToLatex.convert(o3) + `\\).`);
      let t6 = substitute$1(textToAst$2.convert(`e^(f)*d`), { f: o3, d: derivative_with_story(o3, n2, r2) });
      return t6 = simplify(t6), r2.push(`So using the rule for \\(e^x\\) and the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(t6) + `\\).`), t6;
    }
    if (typeof t5 == `number`) {
      if (typeof o3 == `string` && o3 === n2) {
        let s4 = substitute$1(textToAst$2.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
        return s4 = simplify(s4), r2.push(`The derivative of \\(a^` + astToLatex.convert(n2) + `\\) is \\(a^{` + astToLatex.convert(n2) + `} \\, \\log a\\), that is, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(s4) + `\\).`), s4;
      }
      let s3 = substitute$1(textToAst$2.convert(`a^(f) * log(a)`), { a: t5, f: o3 });
      r2.push(`Using the rule for \\(a^x\\) and the chain rule, we know \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(s3) + ` \\cdot ` + a2 + astToLatex.convert(o3) + `\\).`);
      let c3 = substitute$1(textToAst$2.convert(`a^(b)*log(a)*d`), { a: t5, b: o3, d: derivative_with_story(o3, n2, r2) });
      return c3 = simplify(c3), r2.push(`So using the rule for \\(a^x\\) and the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(c3) + `\\).`), c3;
    }
    let c2 = t5, l2 = o3;
    r2.push(`Recall the general rule for exponents, namely that \\(\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\cdot \\left( v'(x) \\cdot \\log u(x) + \\frac{v(x) \\cdot u'(x)}{u(x)} \\right)\\).  In this case, \\(u(x) = ` + astToLatex.convert(c2) + `\\) and \\(v(x) = ` + astToLatex.convert(l2) + `\\).`);
    let u2 = derivative_with_story(c2, n2, r2), d2 = derivative_with_story(l2, n2, r2), p2 = substitute$1(textToAst$2.convert(`(f^g)*(b * log(f) + (g * a)/f)`), { a: u2, b: d2, f: c2, g: l2 });
    return p2 = simplify(p2), r2.push(`So by the general rule for exponents, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(p2) + `\\).`), p2;
  }
  if (o2 === `apply` && !(s2[0] in derivatives)) {
    let t5 = s2[1];
    r2.push(`By the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(substitute$1([`apply`, s2[0] + `'`, `x`], { x: t5 })) + ` \\cdot ` + a2 + astToLatex.convert(t5) + `\\).`);
    let o3 = [`*`, substitute$1([`apply`, s2[0] + `'`, `x`], { x: t5 }), derivative_with_story(t5, n2, r2)];
    return o3 = simplify(o3), r2.push(`So by the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(o3) + `\\).`), o3;
  }
  if (o2 === `apply` && s2[0] in derivatives || o2 in derivatives) {
    let t5 = false;
    o2 === `apply` && (o2 = s2[0], s2 = s2.slice(1), t5 = true);
    let c2 = s2[0];
    if (typeof c2 == `number`) {
      return r2.push(`The derivative of a constant is zero so \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(0) + `\\).`), 0;
    } else if (typeof c2 == `string` && c2 === n2) {
      let t6 = [`*`, substitute$1(derivatives[o2], { x: c2 })];
      return t6 = simplify(t6), r2.push(`It is the case that \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(t6) + `\\).`), t6;
    } else if (typeof c2 == `string` && c2 !== n2) {
      return r2.push(`Since the derivative of a constant is zero, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(0) + `\\).`), 0;
    } else {
      let s3 = [o2, `u`];
      t5 && (s3 = [`apply`].concat(s3)), r2.push(`Recall \\(\\frac{d}{du}` + astToLatex.convert(s3) + ` = ` + astToLatex.convert(derivative_with_story(s3, `u`, [])) + `\\).`), r2.push(`By the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(substitute$1(derivatives[o2], { x: c2 })) + ` \\cdot ` + a2 + astToLatex.convert(c2) + `\\).`);
      let l2 = [`*`, substitute$1(derivatives[o2], { x: c2 }), derivative_with_story(c2, n2, r2)];
      return l2 = simplify(l2), r2.push(`So by the chain rule, \\(` + a2 + astToLatex.convert(i2) + ` = ` + astToLatex.convert(l2) + `\\).`), l2;
    }
  }
  return 0;
}
function lowercaseFirstLetter(t4) {
  return t4.charAt(0).toLowerCase() + t4.slice(1);
}
function simplify_story(t4) {
  for (let n2 = t4.length - 1; n2 >= 1; n2--) t4[n2] === t4[n2 - 1] && t4.splice(n2, 1);
  for (let n2 = 0; n2 < t4.length; n2++) for (let r2 = n2 + 1; r2 < t4.length; r2++) t4[n2] === t4[r2] && (t4[r2] = `Again, ` + lowercaseFirstLetter(t4[r2]));
  return t4;
}
function derivative_story(t4, n2) {
  var r2 = [];
  return derivative_with_story(t4, n2, r2), r2 = simplify_story(r2), r2;
}
var derivativeStory = derivative_story;
function derivative(t4, n2) {
  var r2 = get_tree(t4);
  let i2 = astToMathjs.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(r2)))), a2 = mathjs_default.derivative(i2, n2);
  return mathjsToAst.convert(a2);
}
function pm_equals_numerical({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, rng: p2 }) {
  let m2, h2, g2, v2, y2;
  try {
    ({ variables: m2, integer_variables: h2, functions: g2, expr: v2, other: y2 } = prepare_exprs_numerical_eval(t4, n2, i2, a2));
  } catch {
    return false;
  }
  let b2, x2;
  try {
    b2 = expand_pm_signs(v2.tree), x2 = expand_pm_signs(y2.tree);
  } catch {
    return false;
  }
  let S2, w2;
  try {
    S2 = b2.map((t5) => i2.fromAst(t5).f()), w2 = x2.map((t5) => a2.fromAst(t5).f());
  } catch {
    return false;
  }
  let E, D;
  if (l2 > 0 && b2.length > 0) try {
    let t5 = replace_numbers_with_parameters({ expr: v2, variables: m2, include_exponents: u2 });
    E = t5.parameters;
    let n3 = Object.keys(E);
    if (n3.length > 0) {
      let r3;
      try {
        r3 = expand_pm_signs(t5.expr_with_params);
      } catch {
        r3 = null;
      }
      r3 && r3.length === b2.length && (D = r3.map((t6) => {
        try {
          let r4 = i2.fromAst(t6), a3 = r4.derivative(n3[0]);
          d2 || (a3 = a3.multiply(E[n3[0]]));
          for (let t7 of n3.slice(1)) {
            let n4 = r4.derivative(t7);
            d2 || (n4 = n4.multiply(E[t7])), a3 = a3.add(n4);
          }
          return a3.multiply(l2).f();
        } catch {
          return;
        }
      }));
    }
  } catch {
  }
  let M2 = Number.MAX_VALUE * 1e-20, N2 = [10, 1, 100, 0.1, 1e3, 0.01], F = 0;
  for (let t5 = 0; t5 < 1e3; t5++) {
    let n3 = N2[Math.floor(t5 / 20) % N2.length], i3;
    try {
      i3 = r2(p2, m2, n3);
    } catch {
      continue;
    }
    for (let t6 = 0; t6 < h2.length; t6++) i3[h2[t6]] = generate_random_integer(-10, 10, p2);
    for (let t6 = 0; t6 < g2.length; t6++) i3[g2[t6]] = random_cubic(p2);
    let a3;
    if (D) {
      let t6 = Object.assign({}, i3, E);
      a3 = Array(D.length).fill(0);
      let n4 = false;
      for (let r3 = 0; r3 < D.length; r3++) {
        let i4 = D[r3];
        if (!i4) continue;
        let o3;
        try {
          o3 = mathjs_default.abs(i4(t6));
        } catch {
          n4 = true;
          break;
        }
        if (!Number.isFinite(o3)) {
          n4 = true;
          break;
        }
        a3[r3] = o3;
      }
      if (n4) continue;
    }
    let l3, u3;
    try {
      l3 = S2.map((t6) => t6(i3)), u3 = w2.map((t6) => t6(i3));
    } catch {
      continue;
    }
    if (!(!l3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default.abs(t6)) && mathjs_default.abs(t6) < M2) || !u3.every((t6) => typeof t6 != `boolean` && Number.isFinite(mathjs_default.abs(t6)) && mathjs_default.abs(t6) < M2))) {
      if (!value_multisets_match(l3, u3, o2, s2, c2, a3)) return false;
      if (F += 1, F >= 10) return true;
    }
  }
  return false;
}
function value_multisets_match(t4, n2, r2, i2, a2, o2) {
  let s2 = (t5) => o2 && o2[t5] !== void 0 ? o2[t5] : 0, c2 = (o3, c3) => values_close(t4[o3], n2[c3], r2, i2, a2, s2(o3));
  if (t4.length !== n2.length) return t4.every((t5, r3) => n2.some((t6, n3) => c2(r3, n3))) && n2.every((n3, r3) => t4.some((t5, n4) => c2(n4, r3)));
  let l2 = t4.length, u2 = Array(l2).fill(-1), d2 = (t5, n3) => {
    for (let r3 = 0; r3 < l2; r3++) if (!(n3[r3] || !c2(t5, r3)) && (n3[r3] = true, u2[r3] === -1 || d2(u2[r3], n3))) return u2[r3] = t5, true;
    return false;
  };
  for (let t5 = 0; t5 < l2; t5++) if (!d2(t5, Array(l2).fill(false))) return false;
  return true;
}
function values_close(t4, n2, r2, i2, a2, o2 = 0) {
  let s2 = mathjs_default.abs(t4), c2 = mathjs_default.abs(n2), l2 = Math.min(s2, c2), u2 = Math.max(s2, c2), d2 = o2;
  return d2 += l2 * r2, d2 = Math.min(d2, 0.1 * l2), d2 === 0 && (t4 === 0 || n2 === 0) ? d2 += a2 : d2 += i2, u2 === 0 || mathjs_default.abs(mathjs_default.subtract(t4, n2)) < d2;
}
var astToText = new astToText$2();
function generate_random_integer(t4, n2, r2) {
  return t4 = mathjs_default.ceil(t4), n2 = mathjs_default.floor(n2), mathjs_default.floor(r2() * (n2 - t4 + 1)) + t4;
}
function random_cubic(t4) {
  let n2 = (t4() - 0.5) * 1, r2 = (t4() - 0.5) * 2, i2 = (t4() - 0.5) * 6, a2 = (t4() - 0.5) * 24;
  return function(t5) {
    return mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(n2, t5), r2), t5), i2), t5), a2);
  };
}
var equals$6 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2 = 1e-12, absolute_tolerance: s2 = 0, tolerance_for_zero: c2 = 1e-15, allowed_error_in_numbers: l2 = 0, include_error_in_number_exponents: u2 = false, allowed_error_is_absolute: d2 = false, coerce_tuples_arrays: p2 = true, coerce_vectors: m2 = true, rng: h2 }) {
  if (i2 ||= t4.context, a2 ||= n2.context, Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let g2 = t4.tree[0], v2 = t4.tree.slice(1), y2 = n2.tree[0], b2 = n2.tree.slice(1);
    if (g2 === `tuple` || g2 === `vector` || g2 === `altvector` || g2 === `list` || g2 === `array` || g2 === `matrix` || g2 === `interval`) {
      if (y2 !== g2 && ({ operator1: g2, operator2: y2, operands1: v2, operands2: b2 } = coerce_tuple_array_vectors({ operator1: g2, operator2: y2, operands1: v2, operands2: b2, coerce_tuples_arrays: p2, coerce_vectors: m2 })), y2 !== g2 || b2.length !== v2.length) return false;
      for (let t5 = 0; t5 < v2.length; t5++) if (!equals$6({ expr: i2.fromAst(v2[t5]), other: a2.fromAst(b2[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 })) return false;
      return true;
    }
    if (v2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(g2)) {
      if (b2.length !== 2 || (g2 === `>` ? (g2 = `<`, v2 = [v2[1], v2[0]]) : g2 === `ge` && (g2 = `le`, v2 = [v2[1], v2[0]]), y2 === `>` ? (y2 = `<`, b2 = [b2[1], b2[0]]) : y2 === `ge` && (y2 = `le`, b2 = [b2[1], b2[0]]), g2 !== y2)) return false;
      let t5 = [`+`, v2[0], [`-`, v2[1]]], n3 = [`+`, b2[0], [`-`, b2[1]]], x2 = g2 !== `=`;
      if (contains_pm(t5) || contains_pm(n3)) {
        if (g2 === `=`) {
          let g3 = (t6, n4) => {
            let r3 = expand_pm_signs(t6), i3 = [];
            for (let t7 of r3) {
              let r4 = n4.fromAst(t7).simplify().tree;
              i3.some((t8) => equal(t8, r4)) || i3.push(r4);
            }
            return i3.length === 1 ? i3[0] : [`*`, ...i3];
          }, v3, y3;
          try {
            v3 = g3(t5, i2), y3 = g3(n3, a2);
          } catch {
            return false;
          }
          return component_equals$1({ expr: i2.fromAst(v3), other: a2.fromAst(y3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: false, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
        }
        return pm_equals_numerical({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 });
      }
      return component_equals$1({ expr: i2.fromAst(t5), other: a2.fromAst(n3), randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: true, require_positive_proportion: x2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
    }
  }
  return contains_pm(t4.tree) || contains_pm(n2.tree) ? pm_equals_numerical({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, rng: h2 }) : component_equals$1({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: o2, absolute_tolerance: s2, tolerance_for_zero: c2, allowed_error_in_numbers: l2, include_error_in_number_exponents: u2, allowed_error_is_absolute: d2, coerce_tuples_arrays: p2, coerce_vectors: m2, rng: h2 });
}, component_equals$1 = function({ expr: t4, other: n2, randomBindings: r2, expr_context: i2, other_context: a2, allow_proportional: o2 = false, require_positive_proportion: s2 = false, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 }) {
  var y2 = Number.MAX_VALUE * 1e-20, b2 = 0, x2 = 10, S2 = 100, w2, E, D;
  ({ variables: w2, integer_variables: E, functions: D, expr: t4, other: n2 } = prepare_exprs_numerical_eval(t4, n2, i2, a2));
  try {
    var O2 = t4.f(), j2 = n2.f();
  } catch {
    if (t4.equalsViaSyntax(n2, { allow_blanks: true, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2 })) return true;
    if (!(Array.isArray(t4.tree) && Array.isArray(n2.tree)) || t4.tree[0] !== n2.tree[0]) return false;
    let o3 = t4.tree.slice(1), s3 = n2.tree.slice(1);
    for (let t5 = 0; t5 < o3.length; t5++) if (!equals$6({ expr: i2.fromAst(o3[t5]), other: a2.fromAst(s3[t5]), randomBindings: r2, expr_context: i2, other_context: a2, relative_tolerance: c2, absolute_tolerance: l2, tolerance_for_zero: u2, allowed_error_in_numbers: d2, include_error_in_number_exponents: p2, allowed_error_is_absolute: m2, coerce_tuples_arrays: h2, coerce_vectors: g2, rng: v2 })) return false;
    return true;
  }
  let M2, N2, F;
  if (d2 > 0) {
    let n3 = replace_numbers_with_parameters({ expr: t4, variables: w2, include_exponents: p2 });
    M2 = i2.fromAst(n3.expr_with_params), N2 = n3.parameters;
    let r3 = Object.keys(N2);
    if (r3.length > 0) {
      let t5 = M2.derivative(r3[0]);
      if (m2 || (t5 = t5.multiply(N2[r3[0]])), r3.length > 1) for (let n5 of r3.slice(1)) {
        let r4 = M2.derivative(n5);
        m2 || (r4 = r4.multiply(N2[n5])), t5 = t5.add(r4);
      }
      let n4 = t5.multiply(d2);
      try {
        F = n4.f();
      } catch {
      }
    }
  }
  var I2 = 1, L2 = [10, 1, 100, 0.1, 1e3, 0.01], R2 = 0;
  let z2 = 0, V2 = true, H2 = 0;
  for (let t5 = 0; t5 < 10 * S2; t5++) {
    try {
      var U2 = W2(L2[R2], v2);
    } catch {
      continue;
    }
    if (U2.always_zero === false && (V2 = false), !U2.equal && !U2.out_of_bounds && !U2.always_zero && U2.sufficient_finite_values !== false && (H2++, H2 > S2)) return false;
    if (U2.equal) if (U2.always_zero) {
      if (!V2) continue;
      if (z2 += 1, z2 > 5 && (R2 += 1, z2 = 0), R2 >= L2.length) return true;
      continue;
    } else return true;
  }
  return false;
  function W2(t5, n3) {
    var i3 = r2(n3, w2, t5);
    for (let t6 = 0; t6 < E.length; t6++) i3[E[t6]] = generate_random_integer(-10, 10, n3);
    for (let t6 = 0; t6 < D.length; t6++) i3[D[t6]] = random_cubic(n3);
    var a3;
    F && (a3 = Object.assign({}, i3, N2));
    var d3 = O2(i3), p3 = j2(i3);
    if (typeof d3 == `boolean` || typeof p3 == `boolean`) return { out_of_bounds: true, always_zero: false };
    var m3 = mathjs_default.abs(d3), h3 = mathjs_default.abs(p3);
    if (!(m3 < y2 && h3 < y2) || !((m3 === 0 || m3 > b2) && (h3 === 0 || h3 > b2))) return { out_of_bounds: true, always_zero: false };
    var g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), S3 = 1;
    let M3 = 0;
    if (F) {
      try {
        M3 = mathjs_default.abs(F(a3));
      } catch {
        return { equal_at_start: false, always_zero: false };
      }
      if (!Number.isFinite(M3)) return { equal_at_start: false, always_zero: false };
    }
    if (M3 += g3 * c2, M3 = Math.min(M3, 0.1 * g3), M3 === 0 && (d3 === 0 || p3 === 0) ? M3 += u2 : M3 += l2, !(v3 === 0 || mathjs_default.abs(mathjs_default.subtract(d3, p3)) < M3) && (!o2 || m3 === 0 || h3 === 0 || (S3 = mathjs_default.divide(d3, p3), s2 && !(S3 > 0)))) return { equal_at_start: false, always_zero: false };
    var L22 = v3 === 0, R22 = 0;
    for (let t6 = 0; t6 < 100; t6++) {
      var z22 = r2(n3, w2, I2 / 100, i3);
      for (let t7 = 0; t7 < E.length; t7++) z22[E[t7]] = generate_random_integer(-10, 10, n3);
      for (let t7 = 0; t7 < D.length; t7++) z22[D[t7]] = random_cubic(n3);
      var V22;
      F && (V22 = Object.assign({}, z22, N2));
      try {
        d3 = O2(z22), p3 = mathjs_default.multiply(j2(z22), S3);
      } catch {
        continue;
      }
      if (m3 = mathjs_default.abs(d3), h3 = mathjs_default.abs(p3), m3 < y2 && h3 < y2) {
        g3 = Math.min(m3, h3), v3 = Math.max(m3, h3), R22++;
        let t7 = 0;
        if (F) {
          try {
            t7 = mathjs_default.abs(F(V22));
          } catch {
            continue;
          }
          if (!Number.isFinite(t7)) continue;
        }
        if (t7 += g3 * c2, t7 = Math.min(t7, 0.1 * g3), t7 === 0 && (d3 === 0 || p3 === 0) ? t7 += u2 : t7 += l2, !(v3 === 0 || mathjs_default.abs(mathjs_default.subtract(d3, p3)) < t7)) return { equality_in_middle: false, always_zero: false };
        if (L22 &&= v3 === 0, R22 >= x2) return { equal: true, always_zero: L22 };
      }
    }
    return { sufficient_finite_values: false, always_zero: L22 };
  }
};
function prepare_exprs_numerical_eval(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, { expr: t4, other: n2 } = normalize_for_equality_checking(t4, n2, r2, i2);
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  mathjs_default.define_pi && (a2 = a2.filter(function(t5) {
    return t5 !== `pi`;
  })), mathjs_default.define_i && (a2 = a2.filter(function(t5) {
    return t5 !== `i`;
  })), mathjs_default.define_e && (a2 = a2.filter(function(t5) {
    return t5 !== `e`;
  }));
  var o2 = [];
  for (let t5 = 0; t5 < a2.length; t5++) (is_integer_ast(a2[t5], r2.assumptions) || is_integer_ast(a2[t5], i2.assumptions)) && o2.push(a2[t5]);
  var s2 = [.../* @__PURE__ */ new Set([...t4.functions(), ...n2.functions()])].filter((t5) => t5.length === 1 || t5.includes(`_`) || t5.includes(`^`)), c2 = s2.filter((t5) => a2.includes(t5));
  if (s2 = s2.filter((t5) => !a2.includes(t5)), c2.length > 0) {
    let o3 = t4.tree, l2 = n2.tree, u2 = `x1`;
    for (; [...s2, ...a2].includes(u2); ) u2 += `x1`;
    let d2 = `x2`;
    for (; [...s2, ...a2].includes(d2); ) d2 += `x2`;
    for (let t5 of c2) {
      let n3 = t5 + t5;
      for (; [...s2, ...a2].includes(n3); ) n3 += t5;
      let r3 = [[[`apply`, t5, u2], [`apply`, n3, u2], { variables: { [u2]: true } }]];
      o3 = applyAllTransformations(o3, r3), l2 = applyAllTransformations(l2, r3), s2.push(n3);
    }
    t4 = r2.fromAst(o3), n2 = i2.fromAst(l2);
  }
  return { variables: a2, integer_variables: o2, functions: s2, expr: t4, other: n2 };
}
function normalize_for_equality_checking(t4, n2, r2, i2) {
  r2 ||= t4.context, i2 ||= n2.context, t4 = t4.normalize_function_names(), n2 = n2.normalize_function_names(), t4 = t4.log_subscript_to_two_arg_log(), n2 = n2.log_subscript_to_two_arg_log(), t4 = t4.subscripts_to_strings(), n2 = n2.subscripts_to_strings(), t4 = t4.normalize_applied_functions(), n2 = n2.normalize_applied_functions();
  let a2 = rename_functions_with_exponents(t4.tree), o2 = rename_functions_with_exponents(n2.tree);
  return t4 = r2.fromAst(rename_vecs(a2)), n2 = i2.fromAst(rename_vecs(o2)), { expr: t4, other: n2 };
}
function replace_numbers_with_parameters({ expr: t4, variables: n2, include_exponents: r2 = false }) {
  let i2 = {}, a2 = 0;
  function o2() {
    a2++;
    let t5 = `par` + a2;
    for (; n2.includes(t5); ) a2++, t5 = `par` + a2;
    return t5;
  }
  function s2(t5) {
    if (typeof t5 == `number`) {
      if (t5 === 0) return t5;
      {
        let n4 = o2();
        return i2[n4] = t5, n4;
      }
    }
    if (typeof t5 == `string`) {
      if (t5 === `pi`) {
        if (mathjs_default.define_pi) {
          let t6 = o2();
          return i2[t6] = mathjs_default.PI, t6;
        }
      } else if (t5 === `e` && mathjs_default.define_e) {
        let t6 = o2();
        return i2[t6] = mathjs_default.e, t6;
      }
      return t5;
    }
    if (!Array.isArray(t5)) return t5;
    let n3 = t5[0], a3 = t5.slice(1);
    return n3 === `^` && !r2 ? [n3, s2(a3[0]), a3[1]] : [n3, ...a3.map(s2)];
  }
  return t4 = t4.evaluate_numbers({ max_digits: 1 / 0 }), { expr_with_params: s2(t4.tree), parameters: i2 };
}
function rename_functions_with_exponents(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  if (n2 === `apply`) {
    let t5 = r2[0];
    return Array.isArray(t5) && t5[0] === `^` && t5.slice(1).every((t6) => [`number`, `string`].includes(typeof t6)) && (t5 = astToText.convert(t5)), [`apply`, t5, r2[1]];
  }
  return [n2, ...r2.map(rename_functions_with_exponents)];
}
function rename_vecs(t4) {
  if (!Array.isArray(t4)) return t4;
  let n2 = t4[0], r2 = t4.slice(1);
  return n2 === `vec` && r2.length === 1 ? `__vec_` + astToText.convert(r2[0]) : [n2, ...r2.map(rename_vecs)];
}
function randomComplexBindings(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = mathjs_default.complex(t4() * 2 * r2 - r2, t4() * 2 * r2 - r2);
  }) : n2.forEach(function(n3) {
    a2[n3] = mathjs_default.complex(i2[n3].re + t4() * 2 * r2 - r2, i2[n3].im + t4() * 2 * r2 - r2);
  }), a2;
}
var equals$5 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = (0, import_seedrandom.default)(`complex_seed`);
  return t4 = t4.remove_scaling_units(), n2 = n2.remove_scaling_units(), equals$6({ expr: t4, other: n2, randomBindings: randomComplexBindings, expr_context: t4.context, other_context: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, coerce_tuples_arrays: u2, coerce_vectors: d2, rng: p2 });
};
function randomRealBindings(t4, n2, r2, i2) {
  var a2 = {};
  return i2 === void 0 ? n2.forEach(function(n3) {
    a2[n3] = t4() * 2 * r2 - r2;
  }) : n2.forEach(function(n3) {
    a2[n3] = i2[n3] + t4() * 2 * r2 - r2;
  }), a2;
}
var equals$4 = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false } = {}) {
  if (!t4.isAnalytic() || !n2.isAnalytic()) return false;
  let l2 = seedrandom(`real_seed`);
  return equals$6({ expr: t4, other: n2, randomBindings: randomRealBindings, expr_context: t4.context, other_content: n2.context, relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, rng: l2 });
}, equals$3 = function(t4, n2, { allowed_error_in_numbers: r2 = 0, include_error_in_number_exponents: i2 = false, allowed_error_is_absolute: a2 = false, allow_blanks: o2 = false, coerce_tuples_arrays: s2 = true, coerce_vectors: c2 = true } = {}) {
  if (!o2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let l2 = t4.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(), u2 = n2.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();
  return equal(l2.tree, u2.tree, { allowed_error_in_numbers: r2, include_error_in_number_exponents: i2, allowed_error_is_absolute: a2, coerce_tuples_arrays: s2, coerce_vectors: c2 });
};
function randomFiniteFieldBindings(t4, n2, r2) {
  var i2 = {};
  return n2.forEach(function(n3) {
    i2[n3] = Math.floor(t4() * r2);
  }), i2;
}
var equals$2 = function(t4, n2, { allow_blanks: r2 = false, coerce_tuples_arrays: i2 = true, coerce_vectors: a2 = true } = {}) {
  if (!r2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let o2 = (0, import_seedrandom.default)(`finite_field_seed`);
  if (Array.isArray(t4.tree) && Array.isArray(n2.tree)) {
    let r3 = t4.tree[0], p2 = t4.tree.slice(1), m2 = n2.tree[0], h2 = n2.tree.slice(1);
    if (r3 === `tuple` || r3 === `vector` || r3 === `altvector` || r3 === `list` || r3 === `array` || r3 === `matrix` || r3 === `interval`) {
      if (m2 !== r3 && ({ operator1: r3, operator2: m2, operands1: p2, operands2: h2 } = coerce_tuple_array_vectors({ operator1: r3, operator2: m2, operands1: p2, operands2: h2, coerce_tuples_arrays: i2, coerce_vectors: a2 })), m2 !== r3 || h2.length !== p2.length) return false;
      for (let r4 = 0; r4 < p2.length; r4++) if (equals$2(t4.context.fromAst(p2[r4]), n2.context.fromAst(h2[r4]), o2) === false) return false;
      return;
    }
    if (p2.length === 2 && [`=`, `>`, `<`, `ge`, `le`].includes(r3)) {
      if (h2.length !== 2 || (r3 === `>` ? (r3 = `<`, p2 = [p2[1], p2[0]]) : r3 === `ge` && (r3 = `le`, p2 = [p2[1], p2[0]]), m2 === `>` ? (m2 = `<`, h2 = [h2[1], h2[0]]) : m2 === `ge` && (m2 = `le`, h2 = [h2[1], h2[0]]), r3 !== m2)) return false;
      let i3 = [`+`, p2[0], [`-`, p2[1]]], a3 = [`+`, h2[0], [`-`, h2[1]]], g2 = r3 !== `=`, v2 = t4.context.fromAst(i3), y2 = n2.context.fromAst(a3);
      try {
        let t5 = prepare_exprs_numerical_eval(v2, y2);
        if (t5.functions.length === 0) {
          var s2 = t5.expr.f(), c2 = t5.other.f();
          let r4 = Number.MAX_VALUE * 1e-20;
          for (let i4 = 0; i4 < 10; i4++) {
            var l2 = {};
            t5.variables.forEach(function(t6) {
              l2[t6] = o2() * 2 - 1;
            });
            for (let n3 = 0; n3 < t5.integer_variables.length; n3++) l2[t5.integer_variables[n3]] = mathjs_default.floor(o2() * 21) - 10;
            let i5 = s2(l2), p3 = c2(l2);
            var u2 = mathjs_default.abs(i5), d2 = mathjs_default.abs(p3);
            if (!(u2 < r4 && d2 < r4) || u2 == 0 || d2 === 0) continue;
            let m3 = mathjs_default.divide(i5, p3);
            if (g2 && !(m3 > 0)) return false;
            if (m3 !== 1) {
              let t6 = rationalApproximation(m3);
              y2 = n2.context.fromAst([`*`, [`/`, t6.numerator, t6.denominator], a3]);
            }
            break;
          }
        }
      } catch {
        return;
      }
      return component_equals(v2, y2, o2);
    }
  }
  return component_equals(t4, n2, o2);
}, component_equals = function(t4, n2, r2) {
  ({ expr: t4, other: n2 } = normalize_for_equality_checking(t4, n2));
  let i2 = [1181, 1187, 1193, 1201, 1213, 1217, 1223, 1229, 1231];
  var a2 = [.../* @__PURE__ */ new Set([...t4.variables(), ...n2.variables()])];
  for (let o2 of i2) {
    let i3 = randomFiniteFieldBindings(r2, a2, o2);
    try {
      let r3 = t4.finite_field_evaluate(i3, o2), a3 = n2.finite_field_evaluate(i3, o2);
      if (!r3.approximate && !a3.approximate && !r3.isNaN() && !a3.isNaN() && r3.values.length > 0 && a3.values.length > 0 && !r3.equals(a3)) return false;
    } catch {
      return;
    }
  }
}, equals$1 = function(t4, n2, { min_elements_match: r2 = 3, match_partial: i2 = false } = {}) {
  if (!is_discrete_infinite_set(t4)) return false;
  if (is_discrete_infinite_set(n2)) {
    var a2 = [];
    let r3 = t4.context.get_assumptions(t4);
    if (r3 !== void 0 && a2.push(r3), r3 = n2.context.get_assumptions(n2), r3 !== void 0 && a2.push(r3), a2 = a2.length === 0 ? void 0 : a2.length === 1 ? a2[0] : clean_assumptions([`and`].concat(a2)), i2) {
      let r4 = contained_in(t4.tree, n2.tree, a2, i2);
      if (r4 === false) return 0;
      let o2 = contained_in(n2.tree, t4.tree, a2, i2);
      return o2 === false ? 0 : r4 === true ? o2 === true ? 1 : o2 : o2 === true ? r4 : Math.min(r4, o2);
    } else return contained_in(t4.tree, n2.tree, a2, i2) && contained_in(n2.tree, t4.tree, a2, i2);
  } else {
    let i3 = n2.tree;
    if (i3[0] !== `list`) return false;
    let a3 = i3.length - 2;
    if (i3[a3 + 1][0] !== `ldots` || a3 < r2) return false;
    let o2 = i3.slice(0, a3 + 1), s2 = sequence_from_discrete_infinite(t4, a3);
    return s2 ? (s2 = [`list`].concat(s2), equals(t4.context.from(s2), n2.context.from(o2))) : false;
  }
};
function is_discrete_infinite_set(t4) {
  var n2 = t4.tree;
  if (!Array.isArray(n2) || n2[0] !== `discrete_infinite_set`) return false;
  for (var r2 of n2.slice(1)) if (!Array.isArray(r2) || r2[0] !== `tuple` || r2.length !== 5) return false;
  return true;
}
function contained_in(t4, n2, r2, i2) {
  if (t4[0] === `discrete_infinite_set`) if (i2) {
    let a3 = 0;
    for (let o4 of t4.slice(1)) {
      let t5 = contained_in(o4, n2, r2, i2);
      t5 === true ? a3++ : t5 !== false && (a3 += t5);
    }
    let o3 = t4.length - 1;
    return a3 === o3 ? true : a3 === 0 ? false : a3 / o3;
  } else return t4.slice(1).every((t5) => contained_in(t5, n2, r2));
  var a2 = t4[1], o2 = t4[2], s2 = evaluate_numbers(t4[3], r2), c2 = t4[4];
  if (s2 !== -1 / 0 || c2 !== 1 / 0) return false;
  a2 = simplify([`/`, a2, o2], r2, 1 / 0);
  var l2 = n2.slice(1), u2 = [];
  for (let t5 = 0; t5 < l2.length; t5++) {
    let n3 = evaluate_numbers(l2[t5][3]), i3 = l2[t5][4];
    if (n3 !== -1 / 0 || i3 !== 1 / 0) return false;
    let a3 = simplify([`/`, l2[t5][1], o2], r2, 1 / 0), s3 = simplify([`/`, l2[t5][2], o2], r2, 1 / 0);
    if (typeof s3 != `number`) return false;
    let c3 = mathjs_default.fraction(s3), d3 = mathjs_default.number(c3.n), p3 = mathjs_default.number(c3.d);
    u2.push([d3, p3, a3, s3]);
  }
  for (u2.sort(); u2[0][0] === 1; ) {
    let t5 = u2[0][2], n3 = u2[0][3], i3 = simplify(expand([`+`, t5, [`-`, a2]]), r2, 1 / 0);
    if (Number.isFinite(i3) && Number.isFinite(n3) && (i3 = mathjs_default.mod(i3, n3), mathjs_default.min(i3, n3 - i3) < 1e-10 * n3)) return true;
    if (u2.splice(0, 1), u2.length === 0) return false;
  }
  var d2 = [...new Set(u2.map((t5) => t5[0]))];
  let p2 = 0;
  for (let t5 of d2) {
    let n3 = u2.map(function(n4, r3) {
      if (mathjs_default.mod(t5, n4[0]) === 0) {
        let i3 = t5 / n4[0];
        return [n4[0], i3, r3];
      } else return;
    }).filter((t6) => t6), o3 = [];
    for (let i3 of n3) {
      let n4 = i3[0], s3 = i3[1], c3 = i3[2], l3 = u2[c3][2], d3 = u2[c3][3];
      for (let i4 = 0; i4 < n4; i4++) {
        let c4 = simplify(expand([`+`, l3, [`-`, [`+`, a2, i4]]]), r2, 1 / 0);
        if (Number.isFinite(c4) && Number.isFinite(d3) && (c4 = mathjs_default.mod(c4, d3), mathjs_default.min(c4, d3 - c4) < 1e-10 * d3)) {
          for (let t6 = 0; t6 < s3; t6++) o3[i4 + t6 * n4] = true;
          let r3 = true;
          for (let n5 = 0; n5 < t5; n5++) if (!o3[n5]) {
            r3 = false;
            break;
          }
          if (r3) return true;
          break;
        }
      }
    }
    if (i2) {
      let n4 = 0;
      for (let r3 = 0; r3 < t5; r3++) o3[r3] && n4++;
      n4 /= t5, n4 > p2 && (p2 = n4);
    }
  }
  return i2 && p2 > 0 ? p2 : false;
}
function sequence_from_discrete_infinite(t4, n2) {
  var r2 = t4.tree.slice(1);
  if (r2.length > 1) return;
  let i2 = r2[0][1], a2 = r2[0][2], o2 = evaluate_numbers(r2[0][3]), s2 = r2[0][4];
  if (!Number.isInteger(o2) || s2 !== 1 / 0) return;
  let c2 = [];
  for (let t5 = 0; t5 < n2; t5++) c2.push(evaluate_numbers([`+`, [`*`, a2, o2 + t5], i2]));
  return c2;
}
var equality_exports = __exportAll({ equals: () => equals, equalsDiscreteInfinite: () => equals$1, equalsViaComplex: () => equals$5, equalsViaFiniteField: () => equals$2, equalsViaReal: () => equals$4, equalsViaSyntax: () => equals$3 }), equals = function(t4, n2, { relative_tolerance: r2 = 1e-12, absolute_tolerance: i2 = 0, tolerance_for_zero: a2 = 1e-15, allowed_error_in_numbers: o2 = 0, include_error_in_number_exponents: s2 = false, allowed_error_is_absolute: c2 = false, allow_blanks: l2 = false, coerce_tuples_arrays: u2 = true, coerce_vectors: d2 = true } = {}) {
  if (!l2 && (t4.variables().includes(`＿`) || n2.variables().includes(`＿`))) return false;
  let p2 = t4.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(), m2 = n2.evaluate_numbers({ max_digits: 1 / 0 }).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();
  return p2.equalsViaSyntax(m2, { allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : o2 === 0 && t4.equalsViaFiniteField(n2, { allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) == 0 ? false : t4.equalsViaComplex(n2, { relative_tolerance: r2, absolute_tolerance: i2, tolerance_for_zero: a2, allowed_error_in_numbers: o2, include_error_in_number_exponents: s2, allowed_error_is_absolute: c2, allow_blanks: true, coerce_tuples_arrays: u2, coerce_vectors: d2 }) ? true : !!equals$1(t4, n2);
}, sign_error_exports = __exportAll({ equalSpecifiedSignErrors: () => equalSpecifiedSignErrors, equalWithSignErrors: () => equalWithSignErrors }), equalWithSignErrors = function(t4, n2, { equalityFunction: r2 = equals, max_sign_errors: i2 = 1 } = {}) {
  if (r2(t4, n2)) return { matched: true, n_sign_errors: 0 };
  for (let a2 = 1; a2 <= i2; a2++) if (equalSpecifiedSignErrors(t4, n2, { equalityFunction: r2, n_sign_errors: a2 })) return { matched: true, n_sign_errors: a2 };
  return { matched: false };
}, equalSpecifiedSignErrors = function(t4, n2, { equalityFunction: r2 = equals, n_sign_errors: i2 = 1 } = {}) {
  if (i2 === 0) return r2(t4, n2);
  if (!(Number.isInteger(i2) && i2 > 0)) throw Error(`Have not implemented equality check with ${i2} sign errors.`);
  if (i2 > 1) {
    let t5 = r2;
    r2 = function(n3, r3) {
      return equalSpecifiedSignErrors(n3, r3, { equalityFunction: t5, n_sign_errors: i2 - 1 });
    };
  }
  var a2 = t4.tree, o2 = [[a2]], s2 = 0, c2, l2;
  t4.tree = [`-`, a2];
  var u2 = r2(t4, n2);
  if (t4.tree = a2, u2) return true;
  for (; c2 = o2[s2++]; ) if (c2 = c2[0], Array.isArray(c2)) {
    for (l2 = 1; l2 < c2.length; l2++) if (o2.push([c2[l2]]), c2[l2] = [`-`, c2[l2]], u2 = r2(t4, n2), c2[l2] = c2[l2][1], u2) return true;
  }
  return false;
}, arithmetic_exports = __exportAll({ add: () => add, copy: () => copy, divide: () => divide, mod: () => mod$2, multiply: () => multiply, pow: () => pow, subtract: () => subtract });
function add(t4, n2) {
  return clean([`+`, get_tree(t4), get_tree(n2)]);
}
function subtract(t4, n2) {
  return clean([`+`, get_tree(t4), [`-`, get_tree(n2)]]);
}
function multiply(t4, n2) {
  return clean([`*`, get_tree(t4), get_tree(n2)]);
}
function divide(t4, n2) {
  return clean([`/`, get_tree(t4), get_tree(n2)]);
}
function pow(t4, n2) {
  return clean([`^`, get_tree(t4), get_tree(n2)]);
}
function mod$2(t4, n2) {
  return clean([`apply`, `mod`, [`tuple`, get_tree(t4), get_tree(n2)]]);
}
function copy(t4) {
  return get_tree(t4);
}
var analytic_exports = __exportAll({ isAnalytic: () => isAnalytic }), analytic_operators = [`+`, `-`, `*`, `/`, `^`, `tuple`, `vector`, `altvector`, `list`, `array`, `matrix`, `interval`, `vec`], non_analytic_functions = [`abs`, `sign`, `arg`], relation_operators = [`=`, `le`, `ge`, `<`, `>`];
function isAnalytic(t4, { allow_abs: n2 = false, allow_arg: r2 = false, allow_relation: i2 = false } = {}) {
  var a2 = normalize_applied_functions(normalize_function_names(t4));
  a2 = subscripts_to_strings(a2);
  var o2 = operators$3(a2);
  for (let t5 = 0; t5 < o2.length; t5++) {
    let n3 = o2[t5];
    if (analytic_operators.indexOf(n3) === -1) if (i2) {
      if (relation_operators.indexOf(n3) === -1) return false;
    } else return false;
  }
  var s2 = functions$2(a2);
  for (let t5 = 0; t5 < s2.length; t5++) {
    let i3 = s2[t5];
    if (non_analytic_functions.includes(i3) && !(n2 && i3 == `abs` || r2 && i3 == `arg`)) return false;
  }
  return true;
}
var sets_exports = __exportAll({ create_discrete_infinite_set: () => create_discrete_infinite_set });
function create_discrete_infinite_set({ offsets: t4, periods: n2, min_index: r2 = [`-`, 1 / 0], max_index: i2 = 1 / 0 } = {}) {
  if (t4 = get_tree(t4), n2 = get_tree(n2), r2 = get_tree(r2), i2 = get_tree(i2), t4 === void 0 || n2 === void 0) return;
  let a2 = [];
  if (t4[0] === `list`) if (n2[0] === `list`) {
    if (t4.length !== n2.length || t4.length === 1) return;
    for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2[o2], r2, i2]);
  } else for (let o2 = 1; o2 < t4.length; o2++) a2.push([`tuple`, t4[o2], n2, r2, i2]);
  else a2.push([`tuple`, t4, n2, r2, i2]);
  return [`discrete_infinite_set`].concat(a2);
}
var matrix_exports = __exportAll({ cross_prod: () => cross_prod, dot_prod: () => dot_prod, matrix: () => matrix, scalar_mul: () => scalar_mul, vector_add: () => vector_add, vector_sub: () => vector_sub });
function tuple(t4) {
  var n2 = [];
  n2.push(`tuple`);
  var r2 = t4.length;
  for (let i2 = 0; i2 < r2; i2++) n2.push(t4[i2]);
  return n2;
}
function matrix(t4) {
  var n2 = [];
  n2.push(`matrix`);
  var r2 = t4.length, i2 = t4[0].length;
  for (let n3 = 1; n3 < r2; n3++) if (t4[n3].length !== i2) throw Error(`Matrix dimensions mismatch`);
  n2.push(tuple([r2, i2]));
  let a2 = [];
  for (let n3 = 0; n3 < r2; n3++) a2.push(tuple(t4[n3].map(function(t5) {
    return t5.tree;
  })));
  return n2.push(tuple(a2)), n2;
}
function vector_add(t4, n2) {
  if (t4 = get_tree(t4), n2 = get_tree(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't add. Those aren't vectors, or the dimensions don't match`);
  var r2 = t4[0] === `altvector` && n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = t4.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`+`, t4[a2], n2[a2]]);
  return simplify(r2);
}
function scalar_mul(t4, n2) {
  if (n2 = get_tree(n2), n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't scalar multiply. Isn't a vector`);
  var r2 = n2[0] === `altvector` ? [`altvector`] : [`vector`], i2 = n2.length;
  for (let a2 = 1; a2 < i2; a2 += 1) r2.push([`*`, n2[a2], t4]);
  return simplify(r2);
}
function vector_sub(t4, n2) {
  return vector_add(t4, scalar_mul(-1, n2));
}
function dot_prod(t4, n2) {
  if (t4 = get_tree(t4), n2 = get_tree(n2), t4.length !== n2.length || t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take dot product. Those aren't vectors, or the dimensions don't match`);
  var r2 = 0, i2 = 0, a2 = t4.length;
  for (let o2 = 1; o2 < a2; o2 += 1) i2 = [`*`, t4[o2], n2[o2]], r2 = [`+`, r2, i2];
  return simplify(r2);
}
function cross_prod(t4, n2) {
  if (t4 = get_tree(t4), n2 = get_tree(n2), t4[0] !== `tuple` && t4[0] !== `vector` && t4[0] !== `altvector` || n2[0] !== `tuple` && n2[0] !== `vector` && n2[0] !== `altvector`) throw Error(`Can't take cross product. Those aren't vectors`);
  if (t4.length === 3 && n2.length === 3) return simplify([`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]]);
  if (t4.length === 4 && n2.length === 4) {
    var r2 = [`+`, [`*`, t4[2], n2[3]], [`-`, [`*`, t4[3], n2[2]]]], i2 = [`+`, [`*`, t4[3], n2[1]], [`-`, [`*`, t4[1], n2[3]]]], a2 = [`+`, [`*`, t4[1], n2[2]], [`-`, [`*`, t4[2], n2[1]]]];
    return simplify([t4[0] === `altvector` && n2[0] === `altvector` ? `altvector` : `vector`, r2, i2, a2]);
  }
  throw Error(`Can't take cross product. The dimensions aren't both 2 or 3.`);
}
var astToGuppy$1 = class t33 {
  constructor() {
    this.operators = { "+": function(t4) {
      return t4.join(`<e>+</e>`);
    }, "-": function(t4) {
      return `<e>-` + t4.join(`-`) + `</e>`;
    }, "*": function(t4) {
      return t4.join(`<f type="*" group="operations" c="yes"><b p="latex">\\cdot</b><b p="text">*</b></f>`);
    }, "/": function(n2) {
      return t33.dfrac(n2[0], n2[1]);
    }, "^": function(n2) {
      return t33.power(n2[0], n2[1]);
    }, sin: function(n2) {
      return t33.trig(`sin`, n2[0]);
    }, cos: function(n2) {
      return t33.trig(`cos`, n2[0]);
    }, tan: function(n2) {
      return t33.trig(`tan`, n2[0]);
    }, arcsin: function(n2) {
      return t33.trig(`arcsin`, n2[0]);
    }, arccos: function(n2) {
      return t33.trig(`arccos`, n2[0]);
    }, arctan: function(n2) {
      return t33.trig(`arctan`, n2[0]);
    }, arccsc: function(n2) {
      return t33.trig(`arccsc`, n2[0]);
    }, arcsec: function(n2) {
      return t33.trig(`arcsec`, n2[0]);
    }, arccot: function(n2) {
      return t33.trig(`arccot`, n2[0]);
    }, csc: function(n2) {
      return t33.trig(`csc`, n2[0]);
    }, sec: function(n2) {
      return t33.trig(`sec`, n2[0]);
    }, cot: function(n2) {
      return t33.trig(`cot`, n2[0]);
    }, log: function(n2) {
      return t33.trig(`log`, n2[0]);
    }, exp: function(n2) {
      return t33.trig(`exp`, n2[0]);
    }, ln: function(n2) {
      return t33.trig(`ln`, n2[0]);
    }, sqrt: function(n2) {
      return t33.sqrt(n2[0]);
    }, abs: function(n2) {
      return t33.abs(n2[0]);
    } };
  }
  static dfrac(t4, n2) {
    return `<f type="fraction" group="functions"><b p="latex">\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>` + t4 + `<e></e></c><c up="1" down="2" name="denominator"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static trig(t4, n2) {
    return `<f type="` + t4 + `" group="functions"><b p="latex">\\` + t4 + `\\left(<r ref="1"/>\\right)</b><b p="text"> ` + t4 + `(<r ref="1"/>)</b><c delete="1"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static sqrt(t4) {
    return `<f type="square_root" group="functions"><b p="latex">\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static power(t4, n2) {
    return `<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>` + t4 + `<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>` + n2 + `<e></e></c></f>`;
  }
  static abs(t4) {
    return `<f type="absolute_value" group="functions"><b p="latex">\\left|<r ref="1"/>\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static paren(t4) {
    return `<f type="bracket" group="functions"><b p="latex">\\left(<r ref="1"/>\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>` + t4 + `<e></e></c></f>`;
  }
  static isFunctionSymbol(t4) {
    return [`sin`, `cos`, `tan`, `csc`, `sec`, `cot`, `arcsin`, `arccos`, `arctan`, `arccsc`, `arcsec`, `arccot`, `log`, `ln`, `exp`, `sqrt`, `abs`, `this.factorial`].indexOf(t4) !== -1;
  }
  static isGreekLetterSymbol(t4) {
    return `pi.theta.theta.Theta.alpha.nu.beta.xi.Xi.gamma.Gamma.delta.Delta.pi.Pi.epsilon.epsilon.rho.rho.zeta.sigma.Sigma.eta.tau.upsilon.Upsilon.iota.phi.phi.Phi.kappa.chi.lambda.Lambda.psi.Psi.omega.Omega`.split(`.`).indexOf(t4) !== -1;
  }
  factorWithParenthesesIfNegated(n2) {
    var r2 = this.factor(n2);
    return r2.toString().match(/^<e>-/) ? t33.paren(r2.toString()) : r2;
  }
  factor(n2) {
    if (typeof n2 == `string`) return t33.isGreekLetterSymbol(n2) ? `<f type="` + n2 + `" group="greek" c="yes"><b p="latex">\\` + n2 + `</b><b p="text"> $` + n2 + `</b></f>` : `<e>` + n2 + `</e>`;
    if (typeof n2 == `number`) return `<e>` + n2 + `</e>`;
    if (!Array.isArray(n2)) return `<e></e>`;
    var r2 = n2[0], i2 = n2.slice(1);
    return r2 === `apply` && (r2 = n2[1], i2 = n2.slice(2)), r2 === `abs` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.expression(t4);
    }).bind(this))) : t33.isFunctionSymbol(r2) ? r2 === `this.factorial` && (i2[0].toString().length === 1 || i2[0].toString().match(/^[0-9]*$/)) ? this.operators[r2](i2) : this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : r2 === `^` || r2 === `~` ? this.operators[r2](i2.map((function(t4, n3) {
      return this.factor(t4);
    }).bind(this))) : t33.paren(this.expression(n2));
  }
  term(t4) {
    if (!Array.isArray(t4)) return this.factor(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `*` ? this.operators[n2](r2.map((function(t5, n3) {
      var r3 = this.factorWithParenthesesIfNegated(t5);
      return r3.toString().match(/^[0-9]/) && n3 > 0 ? ` * ` + r3 : r3;
    }).bind(this))) : n2 === `/` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factor(t5);
    }).bind(this))) : this.factor(t4);
  }
  expression(t4) {
    if (!Array.isArray(t4)) return this.term(t4);
    var n2 = t4[0], r2 = t4.slice(1);
    return n2 === `+` || n2 === `-` ? this.operators[n2](r2.map((function(t5, n3) {
      return this.factorWithParenthesesIfNegated(t5);
    }).bind(this))) : this.term(t4);
  }
  convert(t4) {
    return (`<m><e></e>` + this.expression(t4) + `<e></e></m>`).replace(/<\/e><e>/g, ``);
  }
}, glslOperators = { "+": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `+` + t5;
  }), n2;
}, "-": function(t4) {
  var n2 = `-` + t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "~": function(t4) {
  var n2 = `vec2(0.0,0.0)`;
  return t4.forEach(function(t5) {
    n2 = n2 + `-` + t5;
  }), n2;
}, "*": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cmul(` + n2 + `,` + t5 + `)`;
  }), n2;
}, "/": function(t4) {
  var n2 = t4[0];
  return t4.slice(1).forEach(function(t5) {
    n2 = `cdiv(` + n2 + `,` + t5 + `)`;
  }), n2;
}, sin: function(t4) {
  return `csin(` + t4[0] + `)`;
}, cos: function(t4) {
  return `ccos(` + t4[0] + `)`;
}, tan: function(t4) {
  return `ctan(` + t4[0] + `)`;
}, sinh: function(t4) {
  return `csinh(` + t4[0] + `)`;
}, cosh: function(t4) {
  return `ccosh(` + t4[0] + `)`;
}, arcsin: function(t4) {
  return `carcsin(` + t4[0] + `)`;
}, arccos: function(t4) {
  return `carccos(` + t4[0] + `)`;
}, arctan: function(t4) {
  return `carctan(` + t4[0] + `)`;
}, arccsc: function(t4) {
  return `carcsin(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arcsec: function(t4) {
  return `carccos(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, arccot: function(t4) {
  return `carctan(cdiv(vec2(1.0,0),` + t4[0] + `))`;
}, csc: function(t4) {
  return `ccsc(` + t4[0] + `)`;
}, sec: function(t4) {
  return `csec(` + t4[0] + `)`;
}, cot: function(t4) {
  return `ccot(` + t4[0] + `)`;
}, exp: function(t4) {
  return `cexp(` + t4[0] + `)`;
}, conj: function(t4) {
  return `conjugate(` + t4[0] + `)`;
}, sqrt: function(t4) {
  return `cpower(` + t4[0] + `,vec2(0.5,0.0))`;
}, log: function(t4) {
  return `clog(` + t4[0] + `)`;
}, ln: function(t4) {
  return `clog(` + t4[0] + `)`;
}, "^": function(t4) {
  return `cpower(` + t4[0] + `,` + t4[1] + `)`;
}, abs: function(t4) {
  return `cabs(` + t4[0] + `)`;
}, apply: function(t4) {
  return `vec2(NaN,NaN)`;
} }, astToGLSL$1 = class {
  constructor() {
  }
  convert(t4) {
    if (typeof t4 == `boolean`) throw Error(`no support for boolean`);
    if (typeof t4 == `string`) return t4 === `e` ? `vec2(2.71828182845905,0.0)` : t4 === `pi` ? `vec2(3.14159265358979,0.0)` : t4 === `i` ? `vec2(0.0,1.0)` : String(t4);
    if (typeof t4 == `number`) return `vec2(` + String(t4) + `,0.0)`;
    if (`real` in t4 && `imaginary` in t4) return t4;
    if (!Array.isArray(t4)) throw Error(`Invalid ast`);
    var n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `apply`) {
      if (typeof r2[0] != `string`) throw Error(`Non string functions not implemented for conversion to GLSL`);
      var n2 = r2[0], r2 = r2.slice(1);
      return glslOperators[n2](r2.map((function(t5, n3) {
        return this.convert(t5);
      }).bind(this)));
    }
    if (n2 in glslOperators) return glslOperators[n2](r2.map((function(t5, n3) {
      return this.convert(t5);
    }).bind(this)));
    throw Error(`Operator ` + n2 + ` not implemented for conversion to mathjs`);
  }
}, printing_exports = __exportAll({ tex: () => tex, toGLSL: () => toGLSL, toLatex: () => toLatex, toString: () => toString, toXML: () => toXML }), astToGuppy = new astToGuppy$1(), astToGLSL = new astToGLSL$1(), tex = function(t4, n2) {
  return new astToLatex$1(n2).convert(t4.tree);
}, toLatex = tex, toString = function(t4, n2) {
  return new astToText$2(n2).convert(t4.tree);
}, toGLSL = function(t4) {
  return astToGLSL.convert(t4.tree);
}, toXML = function(t4) {
  return astToGuppy.convert(t4.tree);
}, integration_exports = __exportAll({ integrateNumerically: () => integrateNumerically }), integrateNumerically = function(t4, n2, r2, i2) {
  for (var a2 = 100, o2 = 0, s2 = {}, c2 = 0; c2 < a2; c2++) s2[n2] = r2 + (i2 - r2) * (c2 + 0.5) / a2, o2 += t4.evaluate(s2);
  return o2 * (i2 - r2) / a2;
};
init_index_all(), init_index_all();
function expression_to_polynomial(t4) {
  var n2 = get_tree(t4);
  if (typeof n2 == `string`) return n2 === `pi` && mathjs_default.define_pi || n2 === `i` && mathjs_default.define_i || n2 === `e` && mathjs_default.define_e ? n2 : [`polynomial`, n2, [[1, 1]]];
  if (typeof n2 == `number`) return n2;
  var r2 = evaluate_to_constant(n2, { remove_units_first: false });
  if (Number.isFinite(r2)) return simplify(n2);
  if (!Array.isArray(n2) || !operators$3(n2).every((t5) => [`+`, `-`, `*`, `^`, `/`, `_`, `prime`].includes(t5))) return false;
  var i2 = n2[0], a2 = n2.slice(1);
  if (i2 === `+`) {
    let t5 = a2.map(expression_to_polynomial);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_add(t6, n3)) : false;
  } else if (i2 === `-`) {
    let t5 = expression_to_polynomial(a2[0]);
    return t5 ? polynomial_neg(t5) : false;
  } else if (i2 === `*`) {
    let t5 = a2.map(expression_to_polynomial);
    return t5.every((t6) => t6 !== false) ? t5.reduce((t6, n3) => polynomial_mul(t6, n3)) : false;
  } else if (i2 === `^`) {
    let t5 = a2[0], r3 = expression_to_polynomial(t5);
    if (r3 === false) return false;
    let i3 = simplify(a2[1]);
    if (typeof i3 != `number` || i3 < 0 || !Number.isInteger(i3)) {
      let r4 = evaluate_to_constant(i3, { remove_units_first: false });
      if (Number.isFinite(r4)) {
        let n3 = mathjs_default.fraction(r4), i4 = { n: mathjs_default.number(n3.n), d: mathjs_default.number(n3.d), s: mathjs_default.number(n3.s) };
        if (i4.d <= 100) {
          t5 = i4.s < 0 ? [`^`, t5, [`/`, -1, i4.d]] : [`^`, t5, [`/`, 1, i4.d]];
          var o2 = [`polynomial`, simplify(t5), []];
          return o2[2].push([i4.n, 1]), o2;
        }
      }
      return [`polynomial`, n2, [[1, 1]]];
    }
    return i3 === 0 ? 1 : i3 === 1 ? r3 : polynomial_pow(r3, i3);
  } else if (i2 === `/`) {
    var s2 = a2[1], c2 = evaluate_to_constant(s2, { remove_units_first: false });
    return Number.isFinite(c2) ? polynomial_mul(expression_to_polynomial(a2[0]), [`/`, 1, c2]) : [`polynomial`, n2, [[1, 1]]];
  } else return [`polynomial`, n2, [[1, 1]]];
}
function polynomials_in_same_leading_variable(t4, n2) {
  return t4[1] !== n2[1] && (compare_function(t4[1], n2[1]) < 0 ? n2 = [`polynomial`, t4[1], [[0, n2]]] : t4 = [`polynomial`, n2[1], [[0, t4]]]), [t4, n2];
}
function polynomial_add(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify([`+`, t4, n2]);
    t4 = [`polynomial`, n2[1], [[0, t4]]];
  } else if (n2[0] !== `polynomial`) n2 = [`polynomial`, t4[1], [[0, n2]]];
  else {
    let r3 = polynomials_in_same_leading_variable(t4, n2);
    t4 = r3[0], n2 = r3[1];
  }
  let r2 = [`polynomial`, t4[1], []], i2 = t4[2], a2 = n2[2], o2 = r2[2], s2 = i2.length, c2 = a2.length, l2 = 0, u2 = 0;
  for (; l2 < s2 || u2 < c2; ) if (l2 === s2) a2[u2][1] && o2.push(a2[u2]), u2 += 1;
  else if (u2 === c2) i2[l2][1] && o2.push(i2[l2]), l2 += 1;
  else if (i2[l2][0] === a2[u2][0]) {
    let t5 = polynomial_add(i2[l2][1], a2[u2][1]);
    t5 && o2.push([i2[l2][0], t5]), l2 += 1, u2 += 1;
  } else i2[l2][0] < a2[u2][0] ? (i2[l2][1] && o2.push(i2[l2]), l2 += 1) : (a2[u2][1] && o2.push(a2[u2]), u2 += 1);
  return o2.length === 0 ? 0 : o2.length === 1 && o2[0][0] === 0 ? o2[0][1] : r2;
}
function polynomial_neg(t4) {
  if (t4[0] !== `polynomial`) return simplify([`-`, t4]);
  let n2 = [`polynomial`, t4[1], []], r2 = t4[2], i2 = n2[2], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2.push([r2[o2][0], polynomial_neg(r2[o2][1])]);
  return n2;
}
function polynomial_sub(t4, n2) {
  return polynomial_add(t4, polynomial_neg(n2));
}
function polynomial_mul(t4, n2) {
  if (t4[0] !== `polynomial`) {
    if (n2[0] !== `polynomial`) return simplify([`*`, t4, n2]);
    if (t4) {
      let r3 = [`polynomial`, n2[1], []], i3 = n2[2], a3 = r3[2];
      for (let n3 of i3) n3[1] && a3.push([n3[0], polynomial_mul(t4, n3[1])]);
      return r3;
    }
  } else if (n2 && n2[0] !== `polynomial`) {
    let r3 = [`polynomial`, t4[1], []], i3 = t4[2], a3 = r3[2];
    for (let t5 of i3) t5[1] && a3.push([t5[0], polynomial_mul(t5[1], n2)]);
    return r3;
  }
  let r2 = polynomials_in_same_leading_variable(t4, n2);
  t4 = r2[0], n2 = r2[1];
  let i2 = t4[2], a2 = n2[2], o2 = [`polynomial`, t4[1], []], s2 = o2[2], c2 = i2.length, l2 = a2.length, u2 = [];
  for (let t5 of i2) for (let n3 of a2) {
    let r3 = false, i3 = t5[0] + n3[0];
    for (let t6 of u2) if (i3 === t6) {
      r3 = true;
      break;
    }
    r3 || u2.push(i3);
  }
  u2.sort(function(t5, n3) {
    return t5 - n3;
  });
  for (let t5 of u2) {
    let n3 = 0, r3 = 0;
    for (; r3 < c2 && i2[r3][0] <= t5; ) {
      let o3 = 0;
      for (; o3 < l2 && a2[o3][0] <= t5; ) {
        if (i2[r3][0] + a2[o3][0] === t5) {
          n3 = polynomial_add(n3, polynomial_mul(i2[r3][1], a2[o3][1]));
          break;
        }
        o3 += 1;
      }
      r3 += 1;
    }
    n3 && s2.push([t5, n3]);
  }
  return o2;
}
function polynomial_pow(t4, n2) {
  if (isNaN(n2) || n2 < 0 || !Number.isInteger(n2)) return;
  let r2 = 1;
  for (; n2 > 0; ) n2 & 1 && (r2 = polynomial_mul(r2, t4)), t4 = polynomial_mul(t4, t4), n2 >>= 1;
  return r2;
}
function polynomial_to_expression(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = t4[1], r2 = t4[2], i2 = [], a2 = r2.length;
  for (var o2 = 0; o2 < a2; o2 += 1) r2[o2][1] && (r2[o2][0] === 0 ? i2.push(polynomial_to_expression(r2[o2][1])) : r2[o2][0] === 1 ? i2.push([`*`, polynomial_to_expression(r2[o2][1]), n2]) : i2.push([`*`, polynomial_to_expression(r2[o2][1]), [`^`, n2, r2[o2][0]]]));
  return i2.length === 0 ? 0 : (i2.length === 1 ? i2 = i2[0] : i2.unshift(`+`), simplify(i2));
}
function initial_term(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  let n2 = [];
  for (; Array.isArray(t4) && t4[0] === `polynomial`; ) {
    let r2 = t4[1], i2 = t4[2], a2 = i2[i2.length - 1][0];
    t4 = i2[i2.length - 1][1], n2.push([r2, a2]);
  }
  return [`monomial`, t4, n2];
}
function mono_less_than(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return false;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return true;
  let r2 = t4[2], i2 = n2[2], a2 = r2.length, o2 = i2.length;
  for (var s2 = a2 < o2 ? a2 : o2, c2 = 0; c2 < s2; c2++) {
    if (r2[c2][0] !== i2[c2][0]) return !(compare_function(r2[c2][0], i2[c2][0]) < 0);
    if (r2[c2][1] < i2[c2][1]) return true;
    if (r2[c2][1] > i2[c2][1]) return false;
  }
  return !(a2 === o2 || s2 === o2);
}
function mono_gcd(t4, n2) {
  if (!Array.isArray(t4) || !Array.isArray(n2) || t4[0] !== `monomial` || n2[0] !== `monomial`) return 1;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) r2[c2][0] === i2[l2][0] ? (r2[c2][1] < i2[l2][1] ? a2.push(r2[c2]) : a2.push(i2[l2]), c2 += 1, l2 += 1) : compare_function(r2[c2][0], i2[l2][0]) < 0 ? c2 += 1 : compare_function(i2[l2][0], r2[c2][0]) < 0 && (l2 += 1);
  return a2.length === 0 ? 1 : [`monomial`, 1, a2];
}
function mono_div(t4, n2) {
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return n2 === 1 ? t4 : !Array.isArray(t4) || t4[0] !== `monomial` ? evaluate_numbers([`/`, t4, n2]) : [t4[0], evaluate_numbers([`/`, t4[1], n2]), t4[2]];
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function(i2[l2][0], r2[c2][0]) < 0) return;
  if (!(l2 < s2)) {
    for (; c2 < o2; ) a2.push(r2[c2]), c2 += 1;
    return a2.length === 0 ? n2[1] === 1 ? t4[1] : evaluate_numbers([`/`, t4[1], n2[1]]) : n2[1] === 1 ? [`monomial`, t4[1], a2] : [`monomial`, evaluate_numbers([`/`, t4[1], n2[1]]), a2];
  }
}
function mono_is_div(t4, n2) {
  if (n2 === 0) return false;
  if (!Array.isArray(n2) || n2[0] !== `monomial`) return true;
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return false;
  let r2 = t4[2], i2 = n2[2], a2 = [], o2 = r2.length, s2 = i2.length, c2 = 0, l2 = 0;
  for (; c2 < o2 && l2 < s2; ) if (r2[c2][0] === i2[l2][0]) {
    if (r2[c2][1] < i2[l2][1]) return false;
    {
      let t5 = r2[c2][1] - i2[l2][1];
      t5 !== 0 && a2.push([r2[c2][0], t5]);
    }
    c2 += 1, l2 += 1;
  } else if (compare_function(r2[c2][0], i2[l2][0]) < 0) a2.push(r2[c2]), c2 += 1;
  else if (compare_function(i2[l2][0], r2[c2][0]) < 0) return false;
  return !(l2 < s2);
}
function mono_to_poly(t4) {
  if (!Array.isArray(t4) || t4[0] !== `monomial`) return t4;
  let n2 = t4[2].length - 1, r2 = t4[1];
  for (; n2 >= 0; ) {
    var i2 = [];
    i2.push([t4[2][n2][1], r2]), r2 = [`polynomial`, t4[2][n2][0], i2], --n2;
  }
  return r2;
}
function max_div_init(t4, n2) {
  if (t4 === 0) return 0;
  let r2 = t4, i2 = [];
  for (; Array.isArray(r2) && r2[0] === `polynomial`; ) {
    let t5 = r2[1], n3 = r2[2], a3 = n3[n3.length - 1][0];
    r2 = n3[n3.length - 1][1], i2.push([t5, a3]);
  }
  let a2 = [`monomial`, r2, i2], o2 = n2.length;
  for (var s2 = 0; s2 < o2; s2 += 1) if (mono_is_div(a2, n2[s2])) return [a2, s2];
  return max_div_init(polynomial_sub(t4, mono_to_poly(a2)), n2);
}
function poly_div(t4, n2) {
  let r2 = [], i2 = [], a2 = [], o2 = [], s2 = t4;
  for (var c2 of n2) r2.push(initial_term(c2));
  let l2 = max_div_init(s2, r2);
  for (; l2 !== 0; ) a2 = l2[1], o2 = mono_div(l2[0], r2[a2]), i2.push([a2, o2]), s2 = polynomial_sub(s2, polynomial_mul(mono_to_poly(o2), n2[a2])), l2 = max_div_init(s2, r2);
  return [i2, s2];
}
function prereduce(t4) {
  let n2 = t4.length, r2 = [];
  for (var i2 = 0; i2 < n2; i2++) {
    if (t4[i2] !== 0 && (!Array.isArray(t4[i2]) || t4[i2][0] !== `polynomial`)) return [1];
    t4[i2] !== 0 && r2.push(t4[i2]);
  }
  return r2.length === 0 ? [0] : r2;
}
function reduce_ith(t4, n2) {
  let r2 = [], a2 = [], o2 = [], s2 = n2[t4], c2 = n2.length;
  for (var l2 = 0; l2 < c2; l2 += 1) l2 === t4 ? r2.push(0) : r2.push(initial_term(n2[l2]));
  let u2 = max_div_init(s2, r2);
  for (; u2 !== 0; ) a2 = u2[1], o2 = mono_div(u2[0], r2[a2]), s2 = polynomial_sub(s2, polynomial_mul(mono_to_poly(o2), n2[a2])), u2 = max_div_init(s2, r2);
  return s2;
}
function reduce(t4) {
  let n2 = 0, r2 = [], i2 = prereduce(t4), a2 = i2.length;
  if (a2 === 1) return i2;
  let o2 = true;
  for (; o2; ) for (o2 = false, i2 = prereduce(i2), a2 = i2.length, n2 = 0; n2 < a2; ) r2 = reduce_ith(n2, i2), _.isEqual(r2, i2[n2]) || (i2[n2] = r2, o2 = true), n2 += 1;
  n2 = 0;
  let s2 = [], c2 = 0;
  for (; n2 < a2; ) s2 = initial_term(i2[n2]), !Array.isArray(s2) || s2[0] !== `monomial` ? i2[n2] = 1 : (c2 = s2[1], c2 !== 1 && (i2[n2] = polynomial_mul(i2[n2], [`/`, 1, c2]))), n2 += 1;
  return i2;
}
function hij(t4, n2, r2) {
  let i2 = initial_term(r2[t4]), a2 = initial_term(r2[n2]), o2 = mono_gcd(i2, a2), s2 = mono_to_poly(mono_div(i2, o2));
  return poly_div(polynomial_sub(polynomial_mul(mono_to_poly(mono_div(a2, o2)), r2[t4]), polynomial_mul(s2, r2[n2])), r2)[1];
}
function build_hij_table(t4, n2) {
  let r2 = n2.length, i2 = 0, a2 = 1, o2 = [];
  for (; a2 < r2; ) {
    for (; i2 < a2; ) t4[[i2, a2]] = hij(i2, a2, n2), t4[[i2, a2]] !== 0 && o2.push(t4[[i2, a2]]), i2 += 1;
    i2 = 0, a2 += 1;
  }
  return o2.length > 0 ? choice_lowest_degree(o2) : 0;
}
function update_hij_table(t4, n2, r2) {
  let i2 = n2.length;
  n2.push(r2);
  let a2 = 0, o2 = 1, s2 = [];
  for (; o2 < i2; ) {
    for (; a2 < o2; ) t4[[a2, o2]] !== 0 && (t4[[a2, o2]] = hij(a2, o2, n2), t4[[a2, o2]] !== 0 && s2.push(t4[[a2, o2]])), a2 += 1;
    a2 = 0, o2 += 1;
  }
  for (; a2 < i2; ) t4[[a2, i2]] = hij(a2, i2, n2), t4[[a2, i2]] !== 0 && s2.push(t4[[a2, i2]]), a2 += 1;
  return s2.length > 0 ? choice_lowest_degree(s2) : 0;
}
function choice_lowest_degree(t4) {
  let n2 = [], r2 = t4.length;
  for (a2 = 0; a2 < r2; a2 += 1) n2.push(initial_term(t4[a2]));
  let i2 = 0;
  for (var a2 = 1; a2 < r2; a2 += 1) {
    if (n2[a2] === 1) return 1;
    mono_less_than(n2[a2], n2[i2]) && (i2 = a2);
  }
  return t4[i2];
}
function reduced_grobner(t4) {
  let n2 = reduce(t4), r2 = {}, i2 = build_hij_table(r2, n2);
  for (; i2 !== 0; ) i2 = update_hij_table(r2, n2, i2);
  return n2 = reduce(n2), n2;
}
function poly_lcm(t4, n2) {
  let r2 = reduced_grobner([polynomial_mul([`polynomial`, `_t`, [[1, 1]]], t4), polynomial_mul([`polynomial`, `_t`, [[0, 1], [1, -1]]], n2)]), i2 = r2.length;
  for (var a2 = 0; a2 < i2; a2 += 1) {
    if (!Array.isArray(r2[a2]) || r2[a2][0] !== `polynomial`) return 1;
    if (r2[a2][1] !== `_t`) return r2[a2];
  }
}
function poly_gcd(t4, n2) {
  let r2 = poly_lcm(t4, n2), i2 = poly_div(polynomial_mul(t4, n2), [r2]), a2 = 0, o2 = i2[0].length;
  for (var s2 = 0; s2 < o2; s2 += 1) a2 = polynomial_add(a2, mono_to_poly(i2[0][s2][1]));
  let c2 = initial_term(a2);
  if (!Array.isArray(c2) || c2[0] !== `monomial`) a2 = 1;
  else {
    let t5 = c2[1];
    t5 !== 1 && (a2 = polynomial_mul(a2, [`/`, 1, t5]));
  }
  return a2;
}
function poly_by_divisor(t4, n2) {
  let r2 = poly_div(t4, [n2]), i2 = 0, a2 = r2[0].length;
  for (var o2 = 0; o2 < a2; o2 += 1) i2 = polynomial_add(i2, mono_to_poly(r2[0][o2][1]));
  return i2;
}
function reduce_rational_expression(t4, n2) {
  let r2 = stringify_vars(t4), i2 = stringify_vars(n2);
  t4 = r2[0], n2 = i2[0];
  let a2 = poly_gcd(t4, n2), o2 = initial_term(n2)[1], s2 = polynomial_mul(a2, o2), c2 = poly_by_divisor(t4, s2), l2 = poly_by_divisor(n2, s2);
  return [destringify_vars(destringify_vars(c2, r2[1]), i2[1]), destringify_vars(destringify_vars(l2, r2[1]), i2[1])];
}
function stringify_vars(t4) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return [t4, {}];
  let n2 = {}, r2 = `z` + JSON.stringify(t4[1]);
  n2[r2] = t4[1], t4[1] = r2;
  let i2 = t4[2], a2 = [];
  for (let t5 of i2) {
    a2 = stringify_vars(t5[1]), t5[1] = a2[0];
    for (let t6 in a2[1]) n2[t6] = a2[1][t6];
  }
  return [t4, n2];
}
function destringify_vars(t4, n2) {
  if (!Array.isArray(t4) || t4[0] !== `polynomial`) return t4;
  n2[t4[1]] && (t4[1] = n2[t4[1]]);
  let r2 = t4[2];
  for (let t5 of r2) t5[1] = destringify_vars(t5[1], n2);
  return t4;
}
var rational_exports = __exportAll({ common_denominator: () => common_denominator, reduce_rational: () => reduce_rational }), textToAst$1 = new textToAst$4();
function common_denominator(t4, n2) {
  t4 = simplify(t4, n2);
  var r2 = [];
  return r2.push([textToAst$1.convert(`a/c+b/c`), textToAst$1.convert(`(a+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`a/c-b/c`), textToAst$1.convert(`(a-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`a+b/c`), textToAst$1.convert(`(ac+b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`a-b/c`), textToAst$1.convert(`(ac-b)/c`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`a/d+b/c`), textToAst$1.convert(`(ac+bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`a/d-b/c`), textToAst$1.convert(`(ac-bd)/(cd)`), { evaluate_numbers: true, allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`x*(y/z)`), textToAst$1.convert(`(x*y)/z`), { allow_extended_match: true, allow_permutations: true, max_group: 1 }]), r2.push([textToAst$1.convert(`(x/y)/z`), textToAst$1.convert(`x/(y*z)`), { allow_extended_match: true, allow_permutations: true }]), r2.push([textToAst$1.convert(`x/(y/z)`), textToAst$1.convert(`xz/y`), { allow_extended_match: true, allow_permutations: true }]), t4 = applyAllTransformations(t4, r2, 40), t4 = expand(t4, true), t4;
}
function as_num_denom(t4) {
  var n2 = get_tree(t4);
  return n2 = common_denominator(n2), n2[0] === `/` ? [n2[1], n2[2]] : [n2, 1];
}
function reduce_rational(t4) {
  var n2 = get_tree(t4), r2 = as_num_denom(n2);
  if (r2[1] === 1) return n2;
  var i2 = reduce_rational_expression(expression_to_polynomial(r2[0]), expression_to_polynomial(r2[1])), a2 = polynomial_to_expression(i2[0]), o2 = polynomial_to_expression(i2[1]);
  return o2 === 1 ? a2 : [`/`, a2, o2];
}
var round_exports = __exportAll({ round_numbers_to_decimals: () => round_numbers_to_decimals, round_numbers_to_precision: () => round_numbers_to_precision, round_numbers_to_precision_plus_decimals: () => round_numbers_to_precision_plus_decimals });
function toFixed(t4, n2) {
  return mathjs_default.format(t4, { notation: `fixed`, precision: n2 });
}
function round_numbers_to_precision(t4, n2 = 14) {
  var r2 = get_tree(t4);
  if (n2 < 1) throw Error(`For round_numbers_to_precision, digits must be positive`);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_precision, digits must be a number`);
  return n2 > 15 ? r2 : (n2 = Math.round(n2), round_numbers_to_precision_sub(r2, n2));
}
var round_numbers_to_precision_sub = function(t4, n2 = 14) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let r2 = n2 - mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(t4))) - 1;
    return parseFloat(r2 < 0 ? toFixed(t4, r2) + `0`.repeat(mathjs_default.abs(r2)) : toFixed(t4, r2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_sub(t5, n2))] : t4;
};
function round_numbers_to_decimals(t4, n2 = 14) {
  var r2 = get_tree(t4);
  if (!Number.isFinite(n2)) throw Error(`For round_numbers_to_decimals, ndecimals must be a number`);
  return n2 = Math.round(n2), n2 = Math.max(-330, Math.min(330, n2)), round_numbers_to_decimals_sub(r2, n2);
}
var round_numbers_to_decimals_sub = function(t4, n2 = 0) {
  return typeof t4 == `number` ? parseFloat(n2 < 0 ? toFixed(t4, n2) + `0`.repeat(mathjs_default.abs(n2)) : toFixed(t4, n2)) : Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_decimals_sub(t5, n2))] : t4;
};
function round_numbers_to_precision_plus_decimals(t4, n2 = 4, r2 = 2) {
  var i2 = get_tree(t4);
  let a2 = true, o2 = true;
  if (n2 >= 1) {
    if (n2 = Math.round(n2), n2 > 15) return i2;
  } else a2 = false;
  return Number.isFinite(r2) ? (r2 = Math.round(r2), r2 = Math.max(-330, Math.min(330, r2))) : o2 = false, a2 ? o2 ? round_numbers_to_precision_plus_decimals_sub(i2, n2, r2) : round_numbers_to_precision_sub(i2, n2) : o2 ? round_numbers_to_decimals_sub(i2, r2) : i2;
}
var round_numbers_to_precision_plus_decimals_sub = function(t4, n2 = 4, r2 = 2) {
  if (typeof t4 == `number` && Number.isFinite(t4) && t4 !== 0) {
    let i2 = mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(t4))), a2 = Math.max(n2 - i2 - 1, r2);
    return parseFloat(a2 < 0 ? toFixed(t4, a2) + `0`.repeat(mathjs_default.abs(a2)) : toFixed(t4, a2));
  }
  return Array.isArray(t4) ? [t4[0], ...t4.slice(1).map((t5) => round_numbers_to_precision_plus_decimals_sub(t5, n2, r2))] : t4;
}, match_exports = __exportAll({ match: () => match }), match = function(t4, n2, r2) {
  return match$1(get_tree(t4), get_tree(n2), r2);
}, expression_to_tree$1 = [simplify_exports, differentiation_exports, normalization_exports, arithmetic_exports, transformation_exports, solve_exports, sets_exports, matrix_exports, rational_exports, round_exports], expression_to_other = [variables_exports, printing_exports, equality_exports, integration_exports, evaluation_exports, analytic_exports, sign_error_exports, match_exports], standard_exports = __exportAll({ abs: () => abs, acos: () => acos, acosh: () => acosh, acot: () => acot, acoth: () => acoth, acsc: () => acsc, acsch: () => acsch, asec: () => asec, asech: () => asech, asin: () => asin, asinh: () => asinh, atan: () => atan, atan2: () => atan2, atanh: () => atanh, conj: () => conj, cos: () => cos, cosh: () => cosh, cot: () => cot, coth: () => coth, csc: () => csc, csch: () => csch, erf: () => erf, exp: () => exp, factorial: () => factorial, gamma: () => gamma, im: () => im, log: () => log, log10: () => log10, re: () => re$1, sec: () => sec, sech: () => sech, sign: () => sign, sin: () => sin, sinh: () => sinh, sqrt: () => sqrt, tan: () => tan, tanh: () => tanh });
function abs(t4) {
  return [`apply`, `abs`, get_tree(t4)];
}
function exp(t4) {
  return [`apply`, `exp`, get_tree(t4)];
}
function log(t4) {
  return [`apply`, `log`, get_tree(t4)];
}
function log10(t4) {
  return [`apply`, `log10`, get_tree(t4)];
}
function sign(t4) {
  return [`apply`, `sign`, get_tree(t4)];
}
function sqrt(t4) {
  return [`apply`, `sqrt`, get_tree(t4)];
}
function conj(t4) {
  return [`apply`, `conj`, get_tree(t4)];
}
function im(t4) {
  return [`apply`, `im`, get_tree(t4)];
}
function re$1(t4) {
  return [`apply`, `re`, get_tree(t4)];
}
function factorial(t4) {
  return [`apply`, `factorial`, get_tree(t4)];
}
function gamma(t4) {
  return [`apply`, `gamma`, get_tree(t4)];
}
function erf(t4) {
  return [`apply`, `erf`, get_tree(t4)];
}
function acos(t4) {
  return [`apply`, `acos`, get_tree(t4)];
}
function acosh(t4) {
  return [`apply`, `acosh`, get_tree(t4)];
}
function acot(t4) {
  return [`apply`, `acot`, get_tree(t4)];
}
function acoth(t4) {
  return [`apply`, `acoth`, get_tree(t4)];
}
function acsc(t4) {
  return [`apply`, `acsc`, get_tree(t4)];
}
function acsch(t4) {
  return [`apply`, `acsch`, get_tree(t4)];
}
function asec(t4) {
  return [`apply`, `asec`, get_tree(t4)];
}
function asech(t4) {
  return [`apply`, `asech`, get_tree(t4)];
}
function asin(t4) {
  return [`apply`, `asin`, get_tree(t4)];
}
function asinh(t4) {
  return [`apply`, `asinh`, get_tree(t4)];
}
function atan(t4) {
  return [`apply`, `atan`, get_tree(t4)];
}
function atanh(t4) {
  return [`apply`, `atanh`, get_tree(t4)];
}
function cos(t4) {
  return [`apply`, `cos`, get_tree(t4)];
}
function cosh(t4) {
  return [`apply`, `cosh`, get_tree(t4)];
}
function cot(t4) {
  return [`apply`, `cot`, get_tree(t4)];
}
function coth(t4) {
  return [`apply`, `coth`, get_tree(t4)];
}
function csc(t4) {
  return [`apply`, `csc`, get_tree(t4)];
}
function csch(t4) {
  return [`apply`, `csch`, get_tree(t4)];
}
function sec(t4) {
  return [`apply`, `sec`, get_tree(t4)];
}
function sech(t4) {
  return [`apply`, `sech`, get_tree(t4)];
}
function sin(t4) {
  return [`apply`, `sin`, get_tree(t4)];
}
function sinh(t4) {
  return [`apply`, `sinh`, get_tree(t4)];
}
function tan(t4) {
  return [`apply`, `tan`, get_tree(t4)];
}
function tanh(t4) {
  return [`apply`, `tanh`, get_tree(t4)];
}
function atan2(t4, n2) {
  return [`apply`, `atan2`, [`tuple`, get_tree(t4), get_tree(n2)]];
}
var expression_to_tree = [standard_exports], whitespace_rule = `\\s|\\\\,|\\\\!|\\\\ |\\\\>|\\\\;|\\\\:|\\\\quad\\b|\\\\qquad\\b`, number_rules_sci = [[`[0-9]+(\\.[0-9]*)?(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`], [`\\.[0-9]+(E[+\\-]?[0-9]+\\s*($|(?=\\,|&|\\||\\\\\\||\\)|\\}|\\\\}|\\]|\\\\\\\\|\\\\end)))?`, `NUMBER`]], number_rules_non_sci = [[`[0-9]+(\\.[0-9]*)?`, `NUMBER`], [`\\.[0-9]+`, `NUMBER`]], base_latex_rules = [[`\\*`, `*`], [`\\/`, `/`], [`-`, `-`], [`\\+`, `+`], [`\\\\pm(?![a-zA-Z])`, `PM`], [`\\^`, `^`], [`\\(`, `(`], [`\\\\left\\s*\\(`, `(`], [`\\\\bigl\\s*\\(`, `(`], [`\\\\Bigl\\s*\\(`, `(`], [`\\\\biggl\\s*\\(`, `(`], [`\\\\Biggl\\s*\\(`, `(`], [`\\)`, `)`], [`\\\\right\\s*\\)`, `)`], [`\\\\bigr\\s*\\)`, `)`], [`\\\\Bigr\\s*\\)`, `)`], [`\\\\biggr\\s*\\)`, `)`], [`\\\\Biggr\\s*\\)`, `)`], [`\\[`, `[`], [`\\\\left\\s*\\[`, `[`], [`\\\\bigl\\s*\\[`, `[`], [`\\\\Bigl\\s*\\[`, `[`], [`\\\\biggl\\s*\\[`, `[`], [`\\\\Biggl\\s*\\[`, `[`], [`\\]`, `]`], [`\\\\right\\s*\\]`, `]`], [`\\\\bigr\\s*\\]`, `]`], [`\\\\Bigr\\s*\\]`, `]`], [`\\\\biggr\\s*\\]`, `]`], [`\\\\Biggr\\s*\\]`, `]`], [`\\|`, `|`], [`\\\\left\\s*\\|`, `|L`], [`\\\\bigl\\s*\\|`, `|L`], [`\\\\Bigl\\s*\\|`, `|L`], [`\\\\biggl\\s*\\|`, `|L`], [`\\\\Biggl\\s*\\|`, `|L`], [`\\\\right\\s*\\|`, `|`], [`\\\\bigr\\s*\\|`, `|`], [`\\\\Bigr\\s*\\|`, `|`], [`\\\\biggr\\s*\\|`, `|`], [`\\\\Biggr\\s*\\|`, `|`], [`\\\\big\\s*\\|`, `|`], [`\\\\Big\\s*\\|`, `|`], [`\\\\bigg\\s*\\|`, `|`], [`\\\\Bigg\\s*\\|`, `|`], [`{`, `{`], [`}`, `}`], [`\\\\{`, `LBRACE`], [`\\\\left\\s*\\\\{`, `LBRACE`], [`\\\\bigl\\s*\\\\{`, `LBRACE`], [`\\\\Bigl\\s*\\\\{`, `LBRACE`], [`\\\\biggl\\s*\\\\{`, `LBRACE`], [`\\\\Biggl\\s*\\\\{`, `LBRACE`], [`\\\\}`, `RBRACE`], [`\\\\right\\s*\\\\}`, `RBRACE`], [`\\\\bigr\\s*\\\\}`, `RBRACE`], [`\\\\Bigr\\s*\\\\}`, `RBRACE`], [`\\\\biggr\\s*\\\\}`, `RBRACE`], [`\\\\Biggr\\s*\\\\}`, `RBRACE`], [`\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\left\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Bigl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\Biggl\\s*\\\\lfloor(?![a-zA-Z])`, `LFLOOR`], [`\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\right\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Bigr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\Biggr\\s*\\\\rfloor(?![a-zA-Z])`, `RFLOOR`], [`\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\left\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Bigl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\Biggl\\s*\\\\lceil(?![a-zA-Z])`, `LCEIL`], [`\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\right\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Bigr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\Biggr\\s*\\\\rceil(?![a-zA-Z])`, `RCEIL`], [`\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\left\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Bigl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\Biggl\\s*\\\\langle(?![a-zA-Z])`, `LANGLE`], [`\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\right\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Bigr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\Biggr\\s*\\\\rangle(?![a-zA-Z])`, `RANGLE`], [`\\\\cdot(?![a-zA-Z])`, `*`], [`\\\\div(?![a-zA-Z])`, `/`], [`\\\\times(?![a-zA-Z])`, `*`], [`,`, `,`], [`:`, `:`], [`\\\\mid(?![a-zA-Z])`, `MID`], [`\\\\varnothing(?![a-zA-Z])`, `LATEXCOMMAND`, `\\emptyset`], [`\\\\vartheta(?![a-zA-Z])`, `LATEXCOMMAND`, `\\theta`], [`\\\\varepsilon(?![a-zA-Z])`, `LATEXCOMMAND`, `\\epsilon`], [`\\\\varrho(?![a-zA-Z])`, `LATEXCOMMAND`, `\\rho`], [`\\\\varphi(?![a-zA-Z])`, `LATEXCOMMAND`, `\\phi`], [`\\\\infty(?![a-zA-Z])`, `INFINITY`], [`\\\\asin(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arcsin`], [`\\\\acos(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arccos`], [`\\\\atan(?![a-zA-Z])`, `LATEXCOMMAND`, `\\arctan`], [`\\\\sqrt(?![a-zA-Z])`, `SQRT`], [`\\\\land(?![a-zA-Z])`, `AND`], [`\\\\wedge(?![a-zA-Z])`, `AND`], [`\\\\lor(?![a-zA-Z])`, `OR`], [`\\\\vee(?![a-zA-Z])`, `OR`], [`\\\\lnot(?![a-zA-Z])`, `NOT`], [`\\\\neg(?![a-zA-Z])`, `NOT`], [`=`, `=`], [`\\\\neq(?![a-zA-Z])`, `NE`], [`\\\\ne(?![a-zA-Z])`, `NE`], [`\\\\not\\s*=`, `NE`], [`\\\\leq(?![a-zA-Z])`, `LE`], [`\\\\le(?![a-zA-Z])`, `LE`], [`\\\\geq(?![a-zA-Z])`, `GE`], [`\\\\ge(?![a-zA-Z])`, `GE`], [`<`, `<`], [`\\\\lt(?![a-zA-Z])`, `<`], [`>`, `>`], [`\\\\gt(?![a-zA-Z])`, `>`], [`\\\\forall(?![a-zA-Z])`, `FORALL`], [`\\\\exists(?![a-zA-Z])`, `EXISTS`], [`\\\\in(?![a-zA-Z])`, `IN`], [`\\\\notin(?![a-zA-Z])`, `NOTIN`], [`\\\\not\\s*\\\\in(?![a-zA-Z])`, `NOTIN`], [`\\\\ni(?![a-zA-Z])`, `NI`], [`\\\\not\\s*\\\\ni(?![a-zA-Z])`, `NOTNI`], [`\\\\subset(?![a-zA-Z])`, `SUBSET`], [`\\\\subseteq(?![a-zA-Z])`, `SUBSETEQ`], [`\\\\not\\s*\\\\subset(?![a-zA-Z])`, `NOTSUBSET`], [`\\\\not\\s*\\\\subseteq(?![a-zA-Z])`, `NOTSUBSETEQ`], [`\\\\supset(?![a-zA-Z])`, `SUPERSET`], [`\\\\supseteq(?![a-zA-Z])`, `SUPERSETEQ`], [`\\\\not\\s*\\\\supset(?![a-zA-Z])`, `NOTSUPERSET`], [`\\\\not\\s*\\\\supseteq(?![a-zA-Z])`, `NOTSUPERSETEQ`], [`\\\\cup(?![a-zA-Z])`, `UNION`], [`\\\\cap(?![a-zA-Z])`, `INTERSECT`], [`\\\\to(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\rightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\longrightarrow(?![a-zA-Z])`, `RIGHTARROW`], [`\\\\gets(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\longleftarrow(?![a-zA-Z])`, `LEFTARROW`], [`\\\\leftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\longleftrightarrow(?![a-zA-Z])`, `LEFTRIGHTARROW`], [`\\\\implies(?![a-zA-Z])`, `IMPLIES`], [`\\\\Longrightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\Rightarrow(?![a-zA-Z])`, `IMPLIES`], [`\\\\impliedby(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Longleftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\Leftarrow(?![a-zA-Z])`, `IMPLIEDBY`], [`\\\\iff(?![a-zA-Z])`, `IFF`], [`\\\\Longleftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\Leftrightarrow(?![a-zA-Z])`, `IFF`], [`\\\\perp(?![a-zA-Z])`, `PERP`], [`\\\\bot(?![a-zA-Z])`, `PERP`], [`\\\\parallel(?![a-zA-Z])`, `PARALLEL`], [`\\\\\\|`, `PARALLEL`], [`\\\\angle(?![a-zA-Z])`, `ANGLE`], [`\\\\int(?![a-zA-Z])`, `INT`], [`!`, `!`], [`'`, `'`], [`_`, `_`], [`&`, `&`], [`\\\\ldots(?![a-zA-Z])`, `LDOTS`], [`\\\\\\\\`, `LINEBREAK`], [`\\\\begin\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `BEGINENVIRONMENT`], [`\\\\end\\s*{\\s*[a-zA-Z0-9]+\\s*}`, `ENDENVIRONMENT`], [`\\\\operatorname\\s*{\\s*[a-zA-Z0-9\\+\\-]+\\s*}`, `VARMULTICHAR`], [`\\\\[a-zA-Z]+(?![a-zA-Z])`, `LATEXCOMMAND`], [`\\\\[$%]`, `LATEXCOMMAND`], [`[a-zA-Z＿$%]`, `VAR`]], allowSimplifiedFunctionApplicationDefault = true, allowedLatexSymbolsDefault = `alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.angle.circ.%.$.emptyset`.split(`.`), appliedFunctionSymbolsDefault = `abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.Re.Im.det.trace.nPr.nCr.floor.ceil.round`.split(`.`), functionSymbolsDefault = [`f`, `g`], operatorSymbolsDefault = { frac: { nargs: 2, substitute: `/` }, binom: { nargs: 2 }, vec: { nargs: 1 }, overline: { nargs: 1, substitute: `linesegment`, remove_products: true } }, unitsDefault = get_all_units();
unitsDefault.circ = unitsDefault.deg, unitsDefault.circ.substitute = `deg`, unitsDefault.circ.isExponent = true, delete unitsDefault.deg;
var parseLeibnizNotationDefault = true, latexToAst$1 = class {
  constructor({ allowSimplifiedFunctionApplication: t4 = allowSimplifiedFunctionApplicationDefault, allowedLatexSymbols: n2 = allowedLatexSymbolsDefault, appliedFunctionSymbols: r2 = appliedFunctionSymbolsDefault, functionSymbols: i2 = functionSymbolsDefault, operatorSymbols: a2 = operatorSymbolsDefault, units: o2 = unitsDefault, parseLeibnizNotation: s2 = parseLeibnizNotationDefault, parseScientificNotation: c2 = true } = {}) {
    this.allowSimplifiedFunctionApplication = t4, this.allowedLatexSymbols = n2, this.appliedFunctionSymbols = r2, this.functionSymbols = i2, this.operatorSymbols = a2, this.units = o2, this.parseLeibnizNotation = s2;
    let l2 = base_latex_rules;
    l2 = c2 ? [...number_rules_sci, ...l2] : [...number_rules_non_sci, ...l2], this.lexer = new lexer(l2, whitespace_rule);
  }
  advance(t4) {
    if (this.token = this.lexer.advance(t4), this.token.token_type === `INVALID`) throw new ParseError(`Invalid symbol '` + this.token.original_text + `'`, this.lexer.location);
  }
  return_state() {
    return { lexer_state: this.lexer.return_state(), token: Object.assign({}, this.token) };
  }
  set_state(t4) {
    this.lexer.set_state(t4.lexer_state), this.token = Object.assign({}, t4.token);
  }
  convert(t4) {
    this.lexer.set_input(t4), this.advance();
    var n2 = this.statement_list();
    if (this.token.token_type !== `EOF`) throw new ParseError(`Invalid location of '` + this.token.original_text + `'`, this.lexer.location);
    return flatten(n2);
  }
  statement_list() {
    for (var t4 = [this.statement()]; this.token.token_type === `,`; ) this.advance(), t4.push(this.statement());
    return t4 = t4.length > 1 ? [`list`].concat(t4) : t4[0], t4;
  }
  statement({ inside_absolute_value: t4 = 0 } = {}) {
    if (this.token.token_type === `LDOTS`) return this.advance(), [`ldots`];
    var n2;
    try {
      n2 = this.return_state();
      let r2 = this.statement_a({ inside_absolute_value: t4 });
      if (this.token.token_type !== `:` && this.token.token_type !== `MID`) return r2;
      let i2 = this.token.token_type === `:` ? `:` : `|`;
      return this.advance(), [i2, r2, this.statement_a()];
    } catch (t5) {
      try {
        this.set_state(n2);
        let r2 = this.statement_a({ parse_absolute_value: false });
        if (this.token.token_type[0] !== `|`) throw t5;
        return this.advance(), [`|`, r2, this.statement_a({ parse_absolute_value: false })];
      } catch {
        throw t5;
      }
    }
  }
  statement_a({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 }); [`IMPLIES`, `IMPLIEDBY`, `IFF`, `LEFTARROW`, `RIGHTARROW`, `LEFTRIGHTARROW`].includes(this.token.token_type); ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_b({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_b({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true } = {}) {
    for (var r2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 }); this.token.token_type === `OR`; ) {
      let i2 = this.token.token_type.toLowerCase();
      this.advance();
      let a2 = this.statement_c({ inside_absolute_value: t4, parse_absolute_value: n2 });
      r2 = [i2, r2, a2];
    }
    return r2;
  }
  statement_c(t4) {
    for (var n2 = this.relation(t4); this.token.token_type === `AND`; ) {
      let r2 = this.token.token_type.toLowerCase();
      this.advance();
      let i2 = this.relation(t4);
      n2 = [r2, n2, i2];
    }
    return n2;
  }
  relation(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.relation(t4)];
    if (this.token.token_type === `FORALL` || this.token.token_type === `EXISTS`) {
      let n3 = this.token.token_type.toLowerCase();
      return this.advance(), [n3, this.relation(t4)];
    }
    for (var n2 = this.expression(t4); this.token.token_type === `=` || this.token.token_type === `NE` || this.token.token_type === `<` || this.token.token_type === `>` || this.token.token_type === `LE` || this.token.token_type === `GE` || this.token.token_type === `IN` || this.token.token_type === `NOTIN` || this.token.token_type === `NI` || this.token.token_type === `NOTNI` || this.token.token_type === `SUBSET` || this.token.token_type === `NOTSUBSET` || this.token.token_type === `SUBSETEQ` || this.token.token_type === `NOTSUBSETEQ` || this.token.token_type === `SUPERSET` || this.token.token_type === `NOTSUPERSET` || this.token.token_type === `SUPERSETEQ` || this.token.token_type === `NOTSUPERSETEQ`; ) {
      let r2 = this.token.token_type.toLowerCase(), i2 = 0;
      this.token.token_type === `<` || this.token.token_type === `LE` ? i2 = -1 : (this.token.token_type === `>` || this.token.token_type === `GE`) && (i2 = 1), this.advance();
      let a2 = this.expression(t4);
      if (i2 === -1) if (this.token.token_type === `<` || this.token.token_type === `LE`) {
        let i3 = [`tuple`];
        r2 === `<` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `<` || this.token.token_type === `LE`; ) this.token.token_type === `<` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`lts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (i2 === 1) if (this.token.token_type === `>` || this.token.token_type === `GE`) {
        let i3 = [`tuple`];
        r2 === `>` ? i3.push(true) : i3.push(false);
        let o2 = [`tuple`, n2, a2];
        for (; this.token.token_type === `>` || this.token.token_type === `GE`; ) this.token.token_type === `>` ? i3.push(true) : i3.push(false), this.advance(), o2.push(this.expression(t4));
        n2 = [`gts`, o2, i3];
      } else n2 = [r2, n2, a2];
      else if (r2 === `=`) for (n2 = [`=`, n2, a2]; this.token.token_type === `=`; ) this.advance(), n2.push(this.expression(t4));
      else n2 = [r2, n2, a2];
    }
    return n2;
  }
  expression(t4) {
    if (this.token.token_type === `NOT` || this.token.token_type === `!`) return this.advance(), [`not`, this.expression(t4)];
    let n2 = false;
    this.token.token_type === `+` && (n2 = true, this.advance());
    let r2 = false;
    this.token.token_type === `-` && (r2 = true, this.advance());
    let i2 = false;
    this.token.token_type === `PM` && (i2 = true, this.advance());
    var a2 = this.term(t4);
    if (r2 || n2) {
      if (a2 === false) return (n2 ? `+` : ``) + (r2 ? `-` : ``);
      if (typeof a2 == `string` && [...a2].every((t5) => [`+`, `-`].includes(t5))) return (n2 ? `+` : ``) + (r2 ? `-` : ``) + a2;
    }
    for (a2 === false && (a2 = `＿`), r2 && (a2 = a2 > 0 ? -a2 : [`-`, a2]), i2 && (a2 = [`pm`, a2]), n2 && (a2 = [`+`, a2]); [`+`, `-`, `PM`, `UNION`, `INTERSECT`, `PERP`, `PARALLEL`].includes(this.token.token_type); ) {
      let n3 = this.token.token_type.toLowerCase(), r3 = false, i3 = false, o2 = false;
      this.token.token_type === `-` ? (n3 = `+`, r3 = true, this.advance()) : this.token.token_type === `PM` ? (n3 = `+`, i3 = true, this.advance()) : (this.advance(), n3 === `+` && (this.token.token_type === `-` ? (r3 = true, o2 = true, this.advance()) : this.token.token_type === `PM` && (i3 = true, this.advance())));
      let s2 = this.term(t4);
      if (n3 === `+`) {
        if (s2 === false && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-`;
          if (r3) return a2 + `-`;
          if (!i3) return a2 + `+`;
        } else if (typeof s2 == `string` && [...s2].every((t5) => [`+`, `-`].includes(t5)) && (typeof a2 == `number` || typeof a2 == `string`)) {
          if (o2) return a2 + `+-` + s2;
          if (r3) return a2 + `-` + s2;
          if (!i3) return a2 + `+` + s2;
        }
      }
      s2 === false && (s2 = `＿`), r3 && (s2 = s2 > 0 ? -s2 : [`-`, s2]), i3 && (s2 = [`pm`, s2]), a2 = [n3, a2, s2];
    }
    return a2;
  }
  term(t4) {
    var n2 = this.factor(t4), r2 = false;
    do
      if (r2 = false, this.token.token_type === `*`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`*`, n2, i2], r2 = true;
      } else if (this.token.token_type === `/`) {
        this.advance(), n2 === false && (n2 = `＿`);
        let i2 = this.factor(t4);
        i2 === false && (i2 = `＿`), n2 = [`/`, n2, i2], r2 = true;
      } else {
        let i2 = Object.assign({}, t4);
        i2.allow_absolute_value_closing = true;
        let a2 = this.nonMinusFactor(i2);
        a2 !== false && (n2 === false && (n2 = `＿`), n2 = [`*`, n2, a2], r2 = true);
      }
    while (r2);
    return this.convert_units_in_term(flatten(n2));
  }
  convert_units_in_term(t4) {
    if (!Array.isArray(t4)) return t4;
    let n2 = t4[0], r2 = t4.slice(1);
    if (n2 === `*`) {
      let t5 = r2.length;
      for (let [n3, i2] of r2.entries()) {
        let a2 = this.units[i2];
        if (a2) {
          if (a2.prefix && n3 < t5 - 1) {
            let o2;
            o2 = n3 === t5 - 2 ? r2[t5 - 1] : this.convert_units_in_term([`*`, ...r2.slice(n3 + 1)]);
            let s2 = i2;
            a2.substitute && (s2 = a2.substitute);
            let c2 = [`unit`, s2, o2];
            return n3 === 0 ? c2 : [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this)), c2];
          } else if (!a2.prefix && n3 > 0) {
            let o2 = i2;
            a2.substitute && (o2 = a2.substitute);
            let s2;
            return s2 = n3 === 1 ? [`unit`, r2[0], o2] : [`unit`, [`*`, ...r2.slice(0, n3).map(this.convert_units_in_term.bind(this))], o2], n3 === t5 - 1 ? s2 : this.convert_units_in_term([`*`, s2, ...r2.slice(n3 + 1)]);
          }
        }
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    } else if (n2 === `/`) return [`/`, this.convert_units_in_term(r2[0]), this.convert_units_in_term(r2[1])];
    else if (n2 === `^`) {
      let t5 = this.units[r2[1]];
      if (t5 && t5.isExponent) {
        let n3 = r2[1];
        return t5.substitute && (n3 = t5.substitute), [`unit`, r2[0], n3];
      }
      return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
    }
    return [n2, ...r2.map(this.convert_units_in_term.bind(this))];
  }
  factor(t4) {
    if (this.token.token_text === `+`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 === false ? `+` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `+` + n3 : [`+`, n3];
    }
    if (this.token.token_type === `-`) {
      this.advance();
      let n3 = this.factor(t4);
      return n3 > 0 ? -n3 : n3 === false ? `-` : typeof n3 == `string` && [...n3].every((t5) => [`+`, `-`].includes(t5)) ? `-` + n3 : [`-`, n3];
    }
    let n2 = this.nonMinusFactor(t4);
    return n2 === false && this.token.token_type === `PERP` && (n2 = `perp`, this.advance()), n2;
  }
  nonMinusFactor(t4) {
    for (var n2 = this.baseFactor(t4); this.token.token_type === `^` || this.token.token_type === `!` || this.token.token_type === `'`; ) if (n2 === false && (n2 = `＿`), this.token.token_type === `^`) {
      this.advance();
      let r2 = this.get_subsuperscript(t4);
      n2 = [`^`, n2, r2];
    } else this.token.token_type === `!` ? (n2 = [`apply`, `factorial`, n2], this.advance()) : (n2 = [`prime`, n2], this.advance());
    return n2;
  }
  get_single_digit_as_number() {
    if (this.token.token_type === `NUMBER` && this.token.token_text[0] !== `.`) {
      let t4 = Number(this.token.token_text[0]);
      return this.token.token_text.length > 1 && this.lexer.unput(this.token.token_text.slice(1)), this.advance(), t4;
    }
    return null;
  }
  get_subsuperscript({ parse_absolute_value: t4 }) {
    let n2 = this.get_single_digit_as_number();
    if (n2 !== null) return n2;
    if ([`+`, `-`, `PERP`].includes(this.token.token_type)) {
      let t5 = this.token.token_type.toLowerCase();
      return this.advance(), t5;
    } else {
      let n3 = this.baseFactor({ parse_absolute_value: t4, in_subsuperscript_with_no_delimiters: true });
      return n3 === false && (n3 = `＿`), n3;
    }
  }
  baseFactor({ inside_absolute_value: t4 = 0, parse_absolute_value: n2 = true, allow_absolute_value_closing: r2 = false, in_subsuperscript_with_no_delimiters: i2 = false } = {}) {
    var a2 = false;
    if (this.token.token_type === `BEGINENVIRONMENT`) {
      let t5 = /\\begin\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1];
      if ([`matrix`, `pmatrix`, `bmatrix`].includes(t5)) {
        let r3 = 0, i3 = 0, o2 = [], s2 = [], c2 = 0, l2 = this.token.token_type;
        for (this.advance(); this.token.token_type !== `ENDENVIRONMENT`; ) this.token.token_type === `&` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), l2 = this.token.token_type, this.advance()) : this.token.token_type === `LINEBREAK` ? ((l2 === `&` || l2 === `LINEBREAK`) && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, c2 = 0, s2 = [], l2 = this.token.token_type, this.advance()) : (s2.push(this.statement({ parse_absolute_value: n2 })), c2 += 1, l2 = ` `);
        if (/\\end\s*{\s*([a-zA-Z0-9]+)\s*}/.exec(this.token.token_text)[1] !== t5) throw new ParseError(`Expecting \\end{` + t5 + `}`, this.lexer.location);
        l2 === `&` && (s2.push(0), c2 += 1), o2.push(s2), c2 > i3 && (i3 = c2), r3 += 1, this.advance(), a2 = [`matrix`, [`tuple`, r3, i3]];
        let u2 = [`tuple`];
        for (let t6 of o2) {
          let n3 = [`tuple`].concat(t6);
          for (let r4 = t6.length; r4 < i3; r4 += 1) n3.push(0);
          u2.push(n3);
        }
        return a2.push(u2), a2;
      } else throw new ParseError(`Unrecognized environment ` + t5, this.lexer.location);
    }
    if (this.token.token_type === `NUMBER`) a2 = parseFloat(this.token.token_text), this.advance();
    else if (this.token.token_type === `INFINITY`) a2 = 1 / 0, this.advance();
    else if (this.token.token_type === `SQRT`) {
      this.advance();
      let t5 = 2;
      if (this.token.token_type === `[`) {
        this.advance();
        let r4 = this.statement({ parse_absolute_value: n2 });
        if (this.token.token_type !== `]`) throw new ParseError(`Expecting ]`, this.lexer.location);
        this.advance(), t5 = r4;
      }
      if (this.token.token_type !== `{`) throw new ParseError(`Expecting {`, this.lexer.location);
      this.advance();
      let r3 = this.statement({ parse_absolute_value: n2 });
      if (this.token.token_type !== `}`) throw new ParseError(`Expecting }`, this.lexer.location);
      this.advance(), a2 = t5 === 2 ? [`apply`, `sqrt`, r3] : t5 === 3 ? [`apply`, `cbrt`, r3] : [`apply`, `nthroot`, [`tuple`, r3, t5]];
    } else if (this.token.token_type === `VAR` || this.token.token_type === `LATEXCOMMAND` || this.token.token_type === `VARMULTICHAR`) {
      if (a2 = this.token.token_text, this.token.token_type === `LATEXCOMMAND`) {
        if (a2 = a2.slice(1), !(this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2) || this.allowedLatexSymbols.includes(a2) || a2 in this.operatorSymbols)) throw new ParseError(`Unrecognized latex command ` + this.token.original_text, this.lexer.location);
      } else this.token.token_type === `VARMULTICHAR` && (a2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(a2)[1]);
      if (this.appliedFunctionSymbols.includes(a2) || this.functionSymbols.includes(a2)) {
        let t5 = false;
        if (this.appliedFunctionSymbols.includes(a2) && (t5 = true), [`Re`, `Im`].includes(a2) && (a2 = a2.toLowerCase()), this.advance(), this.token.token_type === `_`) {
          this.advance();
          let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
          a2 = a2 === `log` && t6 === 10 ? `log10` : [`_`, a2, t6];
        }
        if (i2) t5 && (a2 = [`apply`, a2, `＿`]);
        else {
          for (; this.token.token_type === `'`; ) a2 = [`prime`, a2], this.advance();
          for (; this.token.token_type === `^`; ) {
            this.advance();
            let t6 = this.get_subsuperscript({ parse_absolute_value: n2 });
            a2 = [`^`, a2, t6];
          }
          if (this.token.token_type === `{` || this.token.token_type === `(`) {
            let t6;
            t6 = this.token.token_type === `{` ? `}` : `)`, this.advance();
            let n3 = this.statement_list();
            if (this.token.token_type !== t6) throw new ParseError(`Expecting ` + t6, this.lexer.location);
            this.advance(), n3[0] === `list` && (n3[0] = `tuple`), a2 = [`apply`, a2, n3];
          } else if (t5) {
            if (!this.allowSimplifiedFunctionApplication) throw new ParseError(`Expecting ( after function`, this.lexer.location);
            let t6 = this.factor({ parse_absolute_value: n2 });
            t6 === false && (t6 = `＿`), a2 = [`apply`, a2, t6];
          }
        }
        return a2;
      } else if (a2 in this.operatorSymbols) {
        if (this.advance(), a2 === `frac` && this.parseLeibnizNotation) {
          let t6 = this.return_state(), n3 = this.leibniz_notation();
          if (n3) return n3;
          this.set_state(t6);
        }
        let t5 = a2;
        this.operatorSymbols[a2].substitute && (t5 = this.operatorSymbols[a2].substitute);
        let r3 = this.operatorSymbols[a2].nargs, i3 = this.operatorSymbols[a2].remove_products, o2 = [];
        for (let t6 = 0; t6 < r3; t6++) if (this.token.token_type === `{`) {
          this.advance();
          let t7 = this.statement({ parse_absolute_value: n2 });
          if (i3 && Array.isArray(t7) && t7[0] === `*` ? o2.push(...t7.slice(1)) : o2.push(t7), this.token.token_type !== `}`) throw new ParseError(`Expecting }`, this.lexer.location);
          this.advance();
        } else {
          let t7 = this.get_single_digit_as_number();
          if (t7 === null) if (this.token.token_type === `VAR`) t7 = this.token.token_text, this.advance();
          else throw new ParseError(`Expecting {`, this.lexer.location);
          o2.push(t7);
        }
        a2 = [t5, ...o2];
      } else this.advance();
    } else if (this.token.token_type === `(` || this.token.token_type === `[` || this.token.token_type === `{` || this.token.token_type === `LBRACE` || this.token.token_type === `LANGLE`) {
      let t5 = this.token.token_type, n3, r3;
      this.token.token_type === `(` ? (n3 = `)`, r3 = `]`) : this.token.token_type === `[` ? (n3 = `]`, r3 = `)`) : this.token.token_type === `{` ? (n3 = `}`, r3 = null) : this.token.token_type === `LBRACE` ? (n3 = `RBRACE`, r3 = null) : (n3 = `RANGLE`, r3 = null), this.advance(), a2 = this.statement_list();
      let i3 = 1;
      if (a2[0] === `list` && (i3 = a2.length - 1), this.token.token_type !== n3) {
        if (i3 !== 2 || r3 === null) throw new ParseError(`Expecting ` + n3, this.lexer.location);
        if (this.token.token_type !== r3) throw new ParseError(`Expecting ) or ]`, this.lexer.location);
        a2[0] = `tuple`, a2 = [`interval`, a2];
        let o2;
        o2 = t5 === `(` ? [`tuple`, false, true] : [`tuple`, true, false], a2.push(o2);
      } else i3 >= 2 ? t5 === `(` || t5 === `{` ? a2[0] = `tuple` : t5 === `[` ? a2[0] = `array` : t5 === `LBRACE` ? a2[0] = `set` : a2[0] = `altvector` : t5 === `LBRACE` && (a2 = (a2[0] === `|` || a2[0], [`set`, a2]));
      this.advance();
    } else if (this.token.token_type[0] === `|` && n2 && (t4 === 0 || !r2 || this.token.token_type[1] === `L`)) {
      if (t4 += 1, this.advance(), a2 = this.statement({ inside_absolute_value: t4 }), a2 = [`apply`, `abs`, a2], this.token.token_type !== `|`) throw new ParseError(`Expecting |`, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `LFLOOR` || this.token.token_type === `LCEIL`) {
      let t5, n3;
      if (this.token.token_type === `LFLOOR` ? (t5 = `RFLOOR`, n3 = `floor`) : this.token.token_type === `LCEIL` && (t5 = `RCEIL`, n3 = `ceil`), this.advance(), a2 = this.statement(), a2 = [`apply`, n3, a2], this.token.token_type !== t5) throw new ParseError(`Expecting ` + t5, this.lexer.location);
      this.advance();
    } else if (this.token.token_type === `ANGLE`) if (this.advance(), this.token.token_type === `{` || this.token.token_type === `(`) {
      let t5;
      t5 = this.token.token_type === `{` ? `}` : `)`, this.advance();
      let n3 = this.statement_list();
      if (this.token.token_type !== t5) throw new ParseError(`Expecting ` + t5, this.lexer.location);
      this.advance(), n3[0] === `list` ? a2 = [`angle`, ...n3.slice(1)] : n3[0] === `*` && (a2 = [`angle`, n3]);
    } else {
      let t5 = [], r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      for (; r3 !== false; ) t5.push(r3), r3 = this.nonMinusFactor({ parse_absolute_value: n2 });
      a2 = t5.length === 0 ? `angle` : [`angle`, ...t5];
    }
    else if (this.token.token_type === `INT`) {
      this.advance();
      let t5 = `int`;
      if (this.token.token_type === `_`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`_`, t5, r4];
      }
      if (this.token.token_type === `^`) {
        this.advance();
        let r4 = this.get_subsuperscript({ parse_absolute_value: n2 });
        t5 = [`^`, t5, r4];
      }
      let r3 = flatten(this.term({ parse_absolute_value: n2 }));
      if (Array.isArray(r3) && r3[0] === `*`) {
        let t6 = [];
        for (let n3 = 0; n3 < r3.length - 1; n3++) if (r3[n3] === `d`) {
          let i3 = r3[n3 + 1];
          r3.splice(n3, 2), t6.push([`d`, i3]), n3--;
        }
        r3.push(...t6);
      }
      return [`apply`, t5, r3];
    }
    if (this.token.token_type === `_`) {
      a2 === false && (a2 = `＿`), this.advance();
      let t5 = this.get_subsuperscript({ parse_absolute_value: n2 });
      a2 = [`_`, a2, t5];
    }
    return a2;
  }
  leibniz_notation() {
    if (this.token.token_type !== `{`) return false;
    this.advance();
    var t4 = this.token.token_text;
    let n2 = ``, r2 = 1, i2 = ``, a2 = [], o2 = [];
    if (this.token.token_type === `LATEXCOMMAND` && t4.slice(1) === `partial`) n2 = `∂`;
    else if (this.token.token_type === `VAR` && t4 === `d`) n2 = `d`;
    else return false;
    if (this.advance(), this.token.token_type === `^`) {
      this.advance();
      let t5 = false;
      if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (r2 = parseFloat(this.token.token_text), !Number.isInteger(r2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
      this.advance();
    }
    if (this.token.token_type === `VAR`) i2 = this.token.token_text;
    else if (this.token.token_type === `VARMULTICHAR`) i2 = /\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1];
    else if (this.token.token_type === `LATEXCOMMAND`) if (t4 = this.token.token_text.slice(1), this.allowedLatexSymbols.includes(t4)) i2 = t4;
    else return false;
    if (this.advance(), this.token.token_type !== `}` || (this.advance(), this.token.token_type !== `{`)) return false;
    this.advance();
    let s2 = 0;
    for (; ; ) {
      if (!(n2 === `d` && this.token.token_type === `VAR` && this.token.token_text === `d` || n2 === `∂` && this.token.token_type === `LATEXCOMMAND` && this.token.token_text.slice(1) === `partial`)) return false;
      if (this.advance(), this.token.token_type === `VAR`) a2.push(this.token.token_text);
      else if (this.token.token_type === `VARMULTICHAR`) a2.push(/\\operatorname\s*\{\s*([a-zA-Z0-9\+\-]+)\s*\}/.exec(this.token.token_text)[1]);
      else if (this.token.token_type === `LATEXCOMMAND`) {
        let t5 = this.token.token_text.slice(1);
        if (this.allowedLatexSymbols.includes(t5)) a2.push(t5);
        else return false;
      } else return false;
      let c2 = 1;
      if (this.advance(), this.token.token_type === `^`) {
        this.advance();
        let t5 = false;
        if (this.token.token_type === `{` && (t5 = true, this.advance()), this.token.token_type !== `NUMBER` || (c2 = parseFloat(this.token.token_text), !Number.isInteger(c2)) || t5 && (this.advance(), this.token.token_type !== `}`)) return false;
        this.advance();
      }
      if (o2.push(c2), s2 += c2, s2 > r2) return false;
      if (s2 === r2) {
        if (this.token.token_type !== `}`) return false;
        this.advance();
        let s3 = `derivative_leibniz`;
        n2 === `∂` && (s3 = `partial_` + s3), t4 = [s3], r2 === 1 ? t4.push(i2) : t4.push([`tuple`, i2, r2]);
        let c3 = [];
        for (let t5 = 0; t5 < a2.length; t5 += 1) o2[t5] === 1 ? c3.push(a2[t5]) : c3.push([`tuple`, a2[t5], o2[t5]]);
        return c3 = [`tuple`].concat(c3), t4.push(c3), t4;
      }
    }
  }
}, latexToGuppy = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(t4));
  }
}, latexToMathjs = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(t4));
  }
}, latexToText = class {
  constructor() {
    this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(t4));
  }
}, mathjsToGuppy = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToLatex = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToLatex = new astToLatex$1();
  }
  convert(t4) {
    return this.astToLatex.convert(this.mathjsToAst.convert(t4));
  }
}, mathjsToText = class {
  constructor() {
    this.mathjsToAst = new mathjsToAst$1(), this.astToText = new astToText$2();
  }
  convert(t4) {
    return this.astToText.convert(this.mathjsToAst.convert(t4));
  }
}, require_ms = __commonJSMin(((t4, n2) => {
  var r2 = 1e3, i2 = r2 * 60, a2 = i2 * 60, o2 = a2 * 24, s2 = o2 * 365.25;
  n2.exports = function(t5, n3) {
    n3 ||= {};
    var r3 = typeof t5;
    if (r3 === `string` && t5.length > 0) return c2(t5);
    if (r3 === `number` && isNaN(t5) === false) return n3.long ? u2(t5) : l2(t5);
    throw Error(`val is not a non-empty string or a valid number. val=` + JSON.stringify(t5));
  };
  function c2(t5) {
    if (t5 = String(t5), !(t5.length > 100)) {
      var n3 = /^((?:\d+)?\.?\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(t5);
      if (n3) {
        var c3 = parseFloat(n3[1]);
        switch ((n3[2] || `ms`).toLowerCase()) {
          case `years`:
          case `year`:
          case `yrs`:
          case `yr`:
          case `y`:
            return c3 * s2;
          case `days`:
          case `day`:
          case `d`:
            return c3 * o2;
          case `hours`:
          case `hour`:
          case `hrs`:
          case `hr`:
          case `h`:
            return c3 * a2;
          case `minutes`:
          case `minute`:
          case `mins`:
          case `min`:
          case `m`:
            return c3 * i2;
          case `seconds`:
          case `second`:
          case `secs`:
          case `sec`:
          case `s`:
            return c3 * r2;
          case `milliseconds`:
          case `millisecond`:
          case `msecs`:
          case `msec`:
          case `ms`:
            return c3;
          default:
            return;
        }
      }
    }
  }
  function l2(t5) {
    return t5 >= o2 ? Math.round(t5 / o2) + `d` : t5 >= a2 ? Math.round(t5 / a2) + `h` : t5 >= i2 ? Math.round(t5 / i2) + `m` : t5 >= r2 ? Math.round(t5 / r2) + `s` : t5 + `ms`;
  }
  function u2(t5) {
    return d2(t5, o2, `day`) || d2(t5, a2, `hour`) || d2(t5, i2, `minute`) || d2(t5, r2, `second`) || t5 + ` ms`;
  }
  function d2(t5, n3, r3) {
    if (!(t5 < n3)) return t5 < n3 * 1.5 ? Math.floor(t5 / n3) + ` ` + r3 : Math.ceil(t5 / n3) + ` ` + r3 + `s`;
  }
})), require_debug = __commonJSMin(((t4, n2) => {
  t4 = n2.exports = a2.debug = a2.default = a2, t4.coerce = l2, t4.disable = s2, t4.enable = o2, t4.enabled = c2, t4.humanize = require_ms(), t4.names = [], t4.skips = [], t4.formatters = {};
  var r2;
  function i2(n3) {
    var r3 = 0, i3;
    for (i3 in n3) r3 = (r3 << 5) - r3 + n3.charCodeAt(i3), r3 |= 0;
    return t4.colors[Math.abs(r3) % t4.colors.length];
  }
  function a2(n3) {
    function a3() {
      if (a3.enabled) {
        var n4 = a3, i3 = +/* @__PURE__ */ new Date();
        n4.diff = i3 - (r2 || i3), n4.prev = r2, n4.curr = i3, r2 = i3;
        for (var o3 = Array(arguments.length), s3 = 0; s3 < o3.length; s3++) o3[s3] = arguments[s3];
        o3[0] = t4.coerce(o3[0]), typeof o3[0] != `string` && o3.unshift(`%O`);
        var c3 = 0;
        o3[0] = o3[0].replace(/%([a-zA-Z%])/g, function(r3, i4) {
          if (r3 === `%%`) return r3;
          c3++;
          var a4 = t4.formatters[i4];
          if (typeof a4 == `function`) {
            var s4 = o3[c3];
            r3 = a4.call(n4, s4), o3.splice(c3, 1), c3--;
          }
          return r3;
        }), t4.formatArgs.call(n4, o3), (a3.log || t4.log || console.log.bind(console)).apply(n4, o3);
      }
    }
    return a3.namespace = n3, a3.enabled = t4.enabled(n3), a3.useColors = t4.useColors(), a3.color = i2(n3), typeof t4.init == `function` && t4.init(a3), a3;
  }
  function o2(n3) {
    t4.save(n3), t4.names = [], t4.skips = [];
    for (var r3 = (typeof n3 == `string` ? n3 : ``).split(/[\s,]+/), i3 = r3.length, a3 = 0; a3 < i3; a3++) r3[a3] && (n3 = r3[a3].replace(/\*/g, `.*?`), n3[0] === `-` ? t4.skips.push(RegExp(`^` + n3.substr(1) + `$`)) : t4.names.push(RegExp(`^` + n3 + `$`)));
  }
  function s2() {
    t4.enable(``);
  }
  function c2(n3) {
    var r3, i3;
    for (r3 = 0, i3 = t4.skips.length; r3 < i3; r3++) if (t4.skips[r3].test(n3)) return false;
    for (r3 = 0, i3 = t4.names.length; r3 < i3; r3++) if (t4.names[r3].test(n3)) return true;
    return false;
  }
  function l2(t5) {
    return t5 instanceof Error ? t5.stack || t5.message : t5;
  }
})), require_browser = __commonJSMin(((t4, n2) => {
  t4 = n2.exports = require_debug(), t4.log = a2, t4.formatArgs = i2, t4.save = o2, t4.load = s2, t4.useColors = r2, t4.storage = typeof chrome < `u` && chrome.storage !== void 0 ? chrome.storage.local : c2(), t4.colors = [`lightseagreen`, `forestgreen`, `goldenrod`, `dodgerblue`, `darkorchid`, `crimson`];
  function r2() {
    return typeof window < `u` && window.process && window.process.type === `renderer` ? true : typeof document < `u` && document.documentElement && document.documentElement.style && document.documentElement.style.WebkitAppearance || typeof window < `u` && window.console && (window.console.firebug || window.console.exception && window.console.table) || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/firefox\/(\d+)/) && parseInt(RegExp.$1, 10) >= 31 || typeof navigator < `u` && navigator.userAgent && navigator.userAgent.toLowerCase().match(/applewebkit\/(\d+)/);
  }
  t4.formatters.j = function(t5) {
    try {
      return JSON.stringify(t5);
    } catch (t6) {
      return `[UnexpectedJSONParseError]: ` + t6.message;
    }
  };
  function i2(n3) {
    var r3 = this.useColors;
    if (n3[0] = (r3 ? `%c` : ``) + this.namespace + (r3 ? ` %c` : ` `) + n3[0] + (r3 ? `%c ` : ` `) + `+` + t4.humanize(this.diff), r3) {
      var i3 = `color: ` + this.color;
      n3.splice(1, 0, i3, `color: inherit`);
      var a3 = 0, o3 = 0;
      n3[0].replace(/%[a-zA-Z%]/g, function(t5) {
        t5 !== `%%` && (a3++, t5 === `%c` && (o3 = a3));
      }), n3.splice(o3, 0, i3);
    }
  }
  function a2() {
    return typeof console == `object` && console.log && Function.prototype.apply.call(console.log, console, arguments);
  }
  function o2(n3) {
    try {
      n3 == null ? t4.storage.removeItem(`debug`) : t4.storage.debug = n3;
    } catch {
    }
  }
  function s2() {
    var n3;
    try {
      n3 = t4.storage.debug;
    } catch {
    }
    return !n3 && typeof process < `u` && `env` in process && (n3 = process.env.DEBUG), n3;
  }
  t4.enable(s2());
  function c2() {
    try {
      return window.localStorage;
    } catch {
    }
  }
})), require_xml_parser = __commonJSMin(((t4, n2) => {
  var r2 = require_browser()(`xml-parser`);
  n2.exports = i2;
  function i2(t5) {
    return t5 = t5.trim(), t5 = t5.replace(/<!--[\s\S]*?-->/g, ``), n3();
    function n3() {
      return { declaration: i3(), root: a2() };
    }
    function i3() {
      if (l2(/^<\?xml\s*/)) {
        for (var t6 = { attributes: {} }; !(u2() || d2(`?>`)); ) {
          var n4 = s2();
          if (!n4) return t6;
          t6.attributes[n4.name] = n4.value;
        }
        return l2(/\?>\s*/), t6;
      }
    }
    function a2() {
      r2(`tag %j`, t5);
      var n4 = l2(/^<([\w-:.]+)\s*/);
      if (n4) {
        for (var i4 = { name: n4[1], attributes: {}, children: [] }; !(u2() || d2(`>`) || d2(`?>`) || d2(`/>`)); ) {
          var c3 = s2();
          if (!c3) return i4;
          i4.attributes[c3.name] = c3.value;
        }
        if (l2(/^\s*\/>\s*/)) return i4;
        l2(/\??>\s*/), i4.content = o2();
        for (var p2; p2 = a2(); ) i4.children.push(p2);
        return l2(/^<\/[\w-:.]+>\s*/), i4;
      }
    }
    function o2() {
      r2(`content %j`, t5);
      var n4 = l2(/^([^<]*)/);
      return n4 ? n4[1] : ``;
    }
    function s2() {
      r2(`attribute %j`, t5);
      var n4 = l2(/([\w:-]+)\s*=\s*("[^"]*"|'[^']*'|\w+)\s*/);
      if (n4) return { name: n4[1], value: c2(n4[2]) };
    }
    function c2(t6) {
      return t6.replace(/^['"]|['"]$/g, ``);
    }
    function l2(n4) {
      var r3 = t5.match(n4);
      if (r3) return t5 = t5.slice(r3[0].length), r3;
    }
    function u2() {
      return t5.length == 0;
    }
    function d2(n4) {
      return t5.indexOf(n4) == 0;
    }
  }
})), import_xml_parser = __toESM(require_xml_parser()), entities = { "&#913;": `\\Alpha`, "&Alpha;": `\\Alpha`, "&#x0391;": `\\Alpha`, "\\u0391;": `\\Alpha`, "&#914;": `\\Beta`, "&Beta;": `\\Beta`, "&#x0392;": `\\Beta`, "\\u0392;": `\\Beta`, "&#915;": `\\Gamma`, "&Gamma;": `\\Gamma`, "&#x0393;": `\\Gamma`, "\\u0393;": `\\Gamma`, "&#916;": `\\Delta`, "&Delta;": `\\Delta`, "&#x0394;": `\\Delta`, "\\u0394;": `\\Delta`, "&#917;": `\\Epsilon`, "&Epsilon;": `\\Epsilon`, "&#x0395;": `\\Epsilon`, "\\u0395;": `\\Epsilon`, "&#918;": `\\Zeta`, "&Zeta;": `\\Zeta`, "&#x0396;": `\\Zeta`, "\\u0396;": `\\Zeta`, "&#919;": `\\Eta`, "&Eta;": `\\Eta`, "&#x0397;": `\\Eta`, "\\u0397;": `\\Eta`, "&#920;": `\\Theta`, "&Theta;": `\\Theta`, "&#x0398;": `\\Theta`, "\\u0398;": `\\Theta`, "&#921;": `\\Iota`, "&Iota;": `\\Iota`, "&#x0399;": `\\Iota`, "\\u0399;": `\\Iota`, "&#922;": `\\Kappa`, "&Kappa;": `\\Kappa`, "&#x039A;": `\\Kappa`, "\\u039A;": `\\Kappa`, "&#923;": `\\Lambda`, "&Lambda;": `\\Lambda`, "&#x039B;": `\\Lambda`, "\\u039B;": `\\Lambda`, "&#924;": `\\Mu`, "&Mu;": `\\Mu`, "&#x039C;": `\\Mu`, "\\u039C;": `\\Mu`, "&#925;": `\\Nu`, "&Nu;": `\\Nu`, "&#x039D;": `\\Nu`, "\\u039D;": `\\Nu`, "&#926;": `\\Xi`, "&Xi;": `\\Xi`, "&#x039E;": `\\Xi`, "\\u039E;": `\\Xi`, "&#927;": `\\Omicron`, "&Omicron;": `\\Omicron`, "&#x039F;": `\\Omicron`, "\\u039F;": `\\Omicron`, "&#928;": `\\Pi`, "&Pi;": `\\Pi`, "&#x03A0;": `\\Pi`, "\\u03A0;": `\\Pi`, "&#929;": `\\Rho`, "&Rho;": `\\Rho`, "&#x03A1;": `\\Rho`, "\\u03A1;": `\\Rho`, "&#931;": `\\Sigma`, "&Sigma;": `\\Sigma`, "&#x03A3;": `\\Sigma`, "\\u03A3;": `\\Sigma`, "&#932;": `\\Tau`, "&Tau;": `\\Tau`, "&#x03A4;": `\\Tau`, "\\u03A4;": `\\Tau`, "&#933;": `\\Upsilon`, "&Upsilon;": `\\Upsilon`, "&#x03A5;": `\\Upsilon`, "\\u03A5;": `\\Upsilon`, "&#934;": `\\Phi`, "&Phi;": `\\Phi`, "&#x03A6;": `\\Phi`, "\\u03A6;": `\\Phi`, "&#935;": `\\Chi`, "&Chi;": `\\Chi`, "&#x03A7;": `\\Chi`, "\\u03A7;": `\\Chi`, "&#936;": `\\Psi`, "&Psi;": `\\Psi`, "&#x03A8;": `\\Psi`, "\\u03A8;": `\\Psi`, "&#937;": `\\Omega`, "&Omega;": `\\Omega`, "&#x03A9;": `\\Omega`, "\\u03A9;": `\\Omega`, "&#945;": `\\alpha`, "&alpha;": `\\alpha`, "&#x03B1;": `\\alpha`, "\\u03B1;": `\\alpha`, "&#946;": `\\beta`, "&beta;": `\\beta`, "&#x03B2;": `\\beta`, "\\u03B2;": `\\beta`, "&#947;": `\\gamma`, "&gamma;": `\\gamma`, "&#x03B3;": `\\gamma`, "\\u03B3;": `\\gamma`, "&#948;": `\\delta`, "&delta;": `\\delta`, "&#x03B4;": `\\delta`, "\\u03B4;": `\\delta`, "&#949;": `\\epsilon`, "&epsilon;": `\\epsilon`, "&#x03B5;": `\\epsilon`, "\\u03B5;": `\\epsilon`, "&#950;": `\\zeta`, "&zeta;": `\\zeta`, "&#x03B6;": `\\zeta`, "\\u03B6;": `\\zeta`, "&#951;": `\\eta`, "&eta;": `\\eta`, "&#x03B7;": `\\eta`, "\\u03B7;": `\\eta`, "&#952;": `\\theta`, "&theta;": `\\theta`, "&#x03B8;": `\\theta`, "\\u03B8;": `\\theta`, "&#953;": `\\iota`, "&iota;": `\\iota`, "&#x03B9;": `\\iota`, "\\u03B9;": `\\iota`, "&#954;": `\\kappa`, "&kappa;": `\\kappa`, "&#x03BA;": `\\kappa`, "\\u03BA;": `\\kappa`, "&#955;": `\\lambda`, "&lambda;": `\\lambda`, "&#x03BB;": `\\lambda`, "\\u03BB;": `\\lambda`, "&#956;": `\\mu`, "&mu;": `\\mu`, "&#x03BC;": `\\mu`, "\\u03BC;": `\\mu`, "&#957;": `\\nu`, "&nu;": `\\nu`, "&#x03BD;": `\\nu`, "\\u03BD;": `\\nu`, "&#958;": `\\xi`, "&xi;": `\\xi`, "&#x03BE;": `\\xi`, "\\u03BE;": `\\xi`, "&#959;": `\\omicron`, "&omicron;": `\\omicron`, "&#x03BF;": `\\omicron`, "\\u03BF;": `\\omicron`, "&#960;": `\\pi`, "&pi;": `\\pi`, "&#x03C0;": `\\pi`, "\\u03C0;": `\\pi`, "&#961;": `\\rho`, "&rho;": `\\rho`, "&#x03C1;": `\\rho`, "\\u03C1;": `\\rho`, "&#962;": `\\sigma`, ";": `\\sigma`, "&#x03C2;": `\\sigma`, "\\u03C2;": `\\sigma`, "&#963;": `\\sigma`, "&sigma;": `\\sigma`, "&#x03C3;": `\\sigma`, "\\u03C3;": `\\sigma`, "&#964;": `\\tau`, "&tau;": `\\tau`, "&#x03C4;": `\\tau`, "\\u03C4;": `\\tau`, "&#965;": `\\upsilon`, "&upsilon;": `\\upsilon`, "&#x03C5;": `\\upsilon`, "\\u03C5;": `\\upsilon`, "&#966;": `\\phi`, "&phi;": `\\phi`, "&#x03C6;": `\\phi`, "\\u03C6;": `\\phi`, "&#967;": `\\chi`, "&chi;": `\\chi`, "&#x03C7;": `\\chi`, "\\u03C7;": `\\chi`, "&#968;": `\\psi`, "&psi;": `\\psi`, "&#x03C8;": `\\psi`, "\\u03C8;": `\\psi`, "&#969;": `\\omega`, "&omega;": `\\omega`, "&#x03C9;": `\\omega`, "\\u03C9;": `\\omega`, "&#x2212;": `-`, "&minus;": `-`, "&#x221E;": `\\infty`, "&#8734;": `\\infty`, "&infin;": `\\infty`, "&sdot;": `\\cdot`, "&#x22C5;": `\\cdot`, "&#8901;": `\\cdot`, "&times;": `\\times`, "&#x00D7;": `\\times`, "&#215;": `\\times` }, mmlToLatex = class {
  parse(t4) {
    if (t4.name === `mi`) return entities[t4.content] ? entities[t4.content] : t4.content.length > 1 ? `\\` + t4.content : t4.content;
    if (t4.name === `mn`) return t4.content;
    if (t4.name === `msup`) return this.parse(t4.children[0]) + `^{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mroot`) return `\\sqrt[` + this.parse(t4.children[1]) + `]{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `mfrac`) return `\\frac{` + this.parse(t4.children[0]) + `}{` + this.parse(t4.children[1]) + `}`;
    if (t4.name === `msqrt`) return `\\sqrt{` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `}`;
    if (t4.name === `mo`) return entities[t4.content] ? entities[t4.content] : t4.content === `&#x2061;` ? ` ` : t4.content;
    if (t4.name === `mrow` && t4.attributes.class === `MJX-TeXAtom-ORD`) return t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `);
    if (t4.name === `math` || t4.name === `mrow`) return `(` + t4.children.map((function(t5, n2) {
      return this.parse(t5);
    }).bind(this)).join(` `) + `)`;
  }
  convert(t4) {
    return this.parse((0, import_xml_parser.default)(t4).root);
  }
}, mmlToAst$1 = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1();
  }
  convert(t4) {
    return this.latexToAst.convert(this.mmlToLatex.convert(t4));
  }
}, mmlToGuppy = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToGuppy = new astToGuppy$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToMathjs = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToMathjs = new astToMathjs$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, mmlToText = class {
  constructor() {
    this.mmlToLatex = new mmlToLatex(), this.latexToAst = new latexToAst$1(), this.astToText = new astToText$2();
  }
  convert(t4) {
    return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(t4)));
  }
}, textToGuppy = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToGuppy = new astToGuppy$1();
  }
  convert(t4) {
    return this.astToGuppy.convert(this.textToAst.convert(t4));
  }
}, textToLatex = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToLatex = new astToLatex$1();
  }
  convert(t4) {
    return this.astToLatex.convert(this.textToAst.convert(t4));
  }
}, textToMathjs = class {
  constructor() {
    this.textToAst = new textToAst$4(), this.astToMathjs = new astToMathjs$2();
  }
  convert(t4) {
    return this.astToMathjs.convert(this.textToAst.convert(t4));
  }
}, converters_exports = __exportAll({ astToFiniteFieldObj: () => astToFiniteField$1, astToGLSL: () => astToGLSL$1, astToGuppyObj: () => astToGuppy$1, astToLatexObj: () => astToLatex$1, astToMathjsObj: () => astToMathjs$2, astToTextObj: () => astToText$2, latexToAstObj: () => latexToAst$1, latexToGuppyObj: () => latexToGuppy, latexToMathjsObj: () => latexToMathjs, latexToTextObj: () => latexToText, mathjsToAstObj: () => mathjsToAst$1, mathjsToGuppyObj: () => mathjsToGuppy, mathjsToLatexObj: () => mathjsToLatex, mathjsToTextObj: () => mathjsToText, mmlToAstObj: () => mmlToAst$1, mmlToGuppyObj: () => mmlToGuppy, mmlToLatexObj: () => mmlToLatex, mmlToMathjsObj: () => mmlToMathjs, mmlToTextObj: () => mmlToText, textToAstObj: () => textToAst$4, textToGuppyObj: () => textToGuppy, textToLatexObj: () => textToLatex, textToMathjsObj: () => textToMathjs }), textToAst = new textToAst$4(), latexToAst = new latexToAst$1(), mmlToAst = new mmlToAst$1(), utils$1 = { match: match$1, flatten: flatten$5, unflattenLeft, unflattenRight };
function Expression(t4, n2) {
  this.tree = flatten$5(t4), this.context = n2, this.toJSON = function() {
    let t5 = { objectType: `math-expression`, tree: this.tree }, n3 = {};
    for (let t6 in this.context.assumptions) Object.keys(this.context.assumptions[t6]).length > 0 && (n3[t6] = this.context.assumptions[t6]);
    return Object.keys(n3).length > 0 && (t5.assumptions = n3), t5;
  };
}
function extend(t4, n2) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) n2 ? (function() {
      var n3 = i2;
      t4[n3] = function() {
        return this.fromAst(r2[n3].apply(null, arguments));
      };
    })() : t4[i2] = r2[i2];
  }), t4;
}
function extend_prototype(t4, n2) {
  return flatten_array(Array.prototype.slice.call(arguments, 2)).forEach(function(r2) {
    if (r2) for (var i2 in r2) (function() {
      var a2 = i2;
      t4[a2] = function() {
        var t5 = [this].concat(Array.prototype.slice.call(arguments));
        return n2 ? this.context.fromAst(r2[a2].apply(null, t5)) : r2[a2].apply(null, t5);
      };
    })();
  }), t4;
}
function create_from_multiple(t4, n2) {
  if (Array.isArray(t4) || typeof t4 == `number`) return new Expression(t4, Context);
  if (typeof t4 == `string`) try {
    return new Expression(textToAst.convert(t4), Context);
  } catch (n3) {
    try {
      return new Expression(latexToAst.convert(t4), Context);
    } catch (r2) {
      try {
        return new Expression(mmlToAst.convert(t4), Context);
      } catch (i2) {
        throw t4.indexOf(`\\`) === -1 ? t4.indexOf(`</`) === -1 ? n3 : i2 : r2;
      }
    }
  }
}
function parseText(t4, n2) {
  return new Expression(textToAst.convert(t4), Context);
}
function parseLatex(t4, n2) {
  return new Expression(latexToAst.convert(t4), Context);
}
function parseMml(t4, n2) {
  return new Expression(mmlToAst.convert(t4), Context);
}
var Context = { ZmodN, assumptions: initialize_assumptions(), parser_parameters: {}, from: create_from_multiple, fromText: parseText, parse: parseText, fromLaTeX: parseLatex, fromLatex: parseLatex, fromTeX: parseLatex, fromTex: parseLatex, fromMml: parseMml, parse_tex: parseLatex, converters: converters_exports, utils: utils$1, fromAst: function(t4) {
  return new Expression(t4, this);
}, set_to_default: function() {
  this.assumptions = initialize_assumptions();
}, get_assumptions: function(t4, n2) {
  return get_assumptions(this.assumptions, t4, n2);
}, add_assumption: function(t4, n2) {
  return add_assumption(this.assumptions, t4, n2);
}, add_generic_assumption: function(t4) {
  return add_generic_assumption(this.assumptions, t4);
}, remove_assumption: function(t4) {
  return remove_assumption(this.assumptions, t4);
}, remove_generic_assumption: function(t4) {
  return remove_generic_assumption(this.assumptions, t4);
}, clear_assumptions: function() {
  this.assumptions = initialize_assumptions();
}, math: mathjs_default, reviver: function(t4, n2) {
  if (n2 && n2.objectType === `math-expression` && n2.tree !== void 0) {
    let t5 = Context.fromAst(n2.tree);
    return n2.assumptions !== void 0 && (t5.assumptions = n2.assumptions), t5;
  }
  return n2;
}, class: Expression };
Context.set_to_default(), extend(Context, true, expression_to_tree$1, expression_to_tree), extend(Context, false, expression_to_other), extend_prototype(Expression.prototype, true, expression_to_tree$1), extend_prototype(Expression.prototype, false, expression_to_other);
function flatten_array(t4, n2) {
  n2 = n2 === void 0 ? [] : n2;
  for (var r2 = 0; r2 < t4.length; r2++) Array.isArray(t4[r2]) ? flatten_array(t4[r2], n2) : n2.push(t4[r2]);
  return n2;
}
var base32$1 = { exports: {} };
var hasRequiredBase32;
function requireBase32() {
  if (hasRequiredBase32) return base32$1.exports;
  hasRequiredBase32 = 1;
  (function(module) {
    (function() {
      var root2 = typeof window === "object" ? window : {};
      var NODE_JS = !root2.HI_BASE32_NO_NODE_JS && typeof process === "object" && process.versions && process.versions.node;
      if (NODE_JS) {
        root2 = commonjsGlobal;
      }
      var COMMON_JS = !root2.HI_BASE32_NO_COMMON_JS && true && module.exports;
      var BASE32_ENCODE_CHAR = "ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split("");
      var BASE32_DECODE_CHAR = {
        "A": 0,
        "B": 1,
        "C": 2,
        "D": 3,
        "E": 4,
        "F": 5,
        "G": 6,
        "H": 7,
        "I": 8,
        "J": 9,
        "K": 10,
        "L": 11,
        "M": 12,
        "N": 13,
        "O": 14,
        "P": 15,
        "Q": 16,
        "R": 17,
        "S": 18,
        "T": 19,
        "U": 20,
        "V": 21,
        "W": 22,
        "X": 23,
        "Y": 24,
        "Z": 25,
        "2": 26,
        "3": 27,
        "4": 28,
        "5": 29,
        "6": 30,
        "7": 31
      };
      var blocks = [0, 0, 0, 0, 0, 0, 0, 0];
      var throwInvalidUtf8 = function(position2, partial2) {
        if (partial2.length > 10) {
          partial2 = "..." + partial2.substr(-10);
        }
        var err = new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading " + position2 + " bytes: " + partial2 + " <-");
        err.position = position2;
        throw err;
      };
      var toUtf8String = function(bytes) {
        var str = "", length = bytes.length, i3 = 0, followingChars = 0, b2, c2;
        while (i3 < length) {
          b2 = bytes[i3++];
          if (b2 <= 127) {
            str += String.fromCharCode(b2);
            continue;
          } else if (b2 > 191 && b2 <= 223) {
            c2 = b2 & 31;
            followingChars = 1;
          } else if (b2 <= 239) {
            c2 = b2 & 15;
            followingChars = 2;
          } else if (b2 <= 247) {
            c2 = b2 & 7;
            followingChars = 3;
          } else {
            throwInvalidUtf8(i3, str);
          }
          for (var j2 = 0; j2 < followingChars; ++j2) {
            b2 = bytes[i3++];
            if (b2 < 128 || b2 > 191) {
              throwInvalidUtf8(i3, str);
            }
            c2 <<= 6;
            c2 += b2 & 63;
          }
          if (c2 >= 55296 && c2 <= 57343) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 > 1114111) {
            throwInvalidUtf8(i3, str);
          }
          if (c2 <= 65535) {
            str += String.fromCharCode(c2);
          } else {
            c2 -= 65536;
            str += String.fromCharCode((c2 >> 10) + 55296);
            str += String.fromCharCode((c2 & 1023) + 56320);
          }
        }
        return str;
      };
      var decodeAsBytes = function(base32Str) {
        if (base32Str === "") {
          return [];
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        base32Str = base32Str.replace(/=/g, "");
        var v1, v2, v3, v4, v5, v6, v7, v8, bytes = [], index2 = 0, length = base32Str.length;
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
          bytes[index2++] = (v7 << 5 | v8) & 255;
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          bytes[index2++] = (v1 << 3 | v2 >>> 2) & 255;
          bytes[index2++] = (v2 << 6 | v3 << 1 | v4 >>> 4) & 255;
          bytes[index2++] = (v4 << 4 | v5 >>> 1) & 255;
          bytes[index2++] = (v5 << 7 | v6 << 2 | v7 >>> 3) & 255;
        }
        return bytes;
      };
      var encodeAscii = function(str) {
        var v1, v2, v3, v4, v5, base32Str = "", length = str.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3++);
          v5 = str.charCodeAt(i3++);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = str.charCodeAt(i3++);
          v2 = str.charCodeAt(i3++);
          v3 = str.charCodeAt(i3++);
          v4 = str.charCodeAt(i3);
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encodeUtf8 = function(str) {
        var v1, v2, v3, v4, v5, code2, end = false, base32Str = "", index2 = 0, i3, start = 0, length = str.length;
        if (str === "") {
          return base32Str;
        }
        do {
          blocks[0] = blocks[5];
          blocks[1] = blocks[6];
          blocks[2] = blocks[7];
          for (i3 = start; index2 < length && i3 < 5; ++index2) {
            code2 = str.charCodeAt(index2);
            if (code2 < 128) {
              blocks[i3++] = code2;
            } else if (code2 < 2048) {
              blocks[i3++] = 192 | code2 >> 6;
              blocks[i3++] = 128 | code2 & 63;
            } else if (code2 < 55296 || code2 >= 57344) {
              blocks[i3++] = 224 | code2 >> 12;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            } else {
              code2 = 65536 + ((code2 & 1023) << 10 | str.charCodeAt(++index2) & 1023);
              blocks[i3++] = 240 | code2 >> 18;
              blocks[i3++] = 128 | code2 >> 12 & 63;
              blocks[i3++] = 128 | code2 >> 6 & 63;
              blocks[i3++] = 128 | code2 & 63;
            }
          }
          start = i3 - 5;
          if (index2 === length) {
            ++index2;
          }
          if (index2 > length && i3 < 6) {
            end = true;
          }
          v1 = blocks[0];
          if (i3 > 4) {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            v5 = blocks[4];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
          } else if (i3 === 1) {
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
          } else if (i3 === 2) {
            v2 = blocks[1];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
          } else if (i3 === 3) {
            v2 = blocks[1];
            v3 = blocks[2];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
          } else {
            v2 = blocks[1];
            v3 = blocks[2];
            v4 = blocks[3];
            base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
          }
        } while (!end);
        return base32Str;
      };
      var encodeBytes = function(bytes) {
        var v1, v2, v3, v4, v5, base32Str = "", length = bytes.length;
        for (var i3 = 0, count = parseInt(length / 5) * 5; i3 < count; ) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3++];
          v5 = bytes[i3++];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[(v4 << 3 | v5 >>> 5) & 31] + BASE32_ENCODE_CHAR[v5 & 31];
        }
        var remain = length - count;
        if (remain === 1) {
          v1 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[v1 << 2 & 31] + "======";
        } else if (remain === 2) {
          v1 = bytes[i3++];
          v2 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[v2 << 4 & 31] + "====";
        } else if (remain === 3) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[v3 << 1 & 31] + "===";
        } else if (remain === 4) {
          v1 = bytes[i3++];
          v2 = bytes[i3++];
          v3 = bytes[i3++];
          v4 = bytes[i3];
          base32Str += BASE32_ENCODE_CHAR[v1 >>> 3] + BASE32_ENCODE_CHAR[(v1 << 2 | v2 >>> 6) & 31] + BASE32_ENCODE_CHAR[v2 >>> 1 & 31] + BASE32_ENCODE_CHAR[(v2 << 4 | v3 >>> 4) & 31] + BASE32_ENCODE_CHAR[(v3 << 1 | v4 >>> 7) & 31] + BASE32_ENCODE_CHAR[v4 >>> 2 & 31] + BASE32_ENCODE_CHAR[v4 << 3 & 31] + "=";
        }
        return base32Str;
      };
      var encode2 = function(input, asciiOnly) {
        var notString = typeof input !== "string";
        if (notString && input.constructor === ArrayBuffer) {
          input = new Uint8Array(input);
        }
        if (notString) {
          return encodeBytes(input);
        } else if (asciiOnly) {
          return encodeAscii(input);
        } else {
          return encodeUtf8(input);
        }
      };
      var decode2 = function(base32Str, asciiOnly) {
        if (!asciiOnly) {
          return toUtf8String(decodeAsBytes(base32Str));
        }
        if (base32Str === "") {
          return "";
        } else if (!/^[A-Z2-7=]+$/.test(base32Str)) {
          throw new Error("Invalid base32 characters");
        }
        var v1, v2, v3, v4, v5, v6, v7, v8, str = "", length = base32Str.indexOf("=");
        if (length === -1) {
          length = base32Str.length;
        }
        for (var i3 = 0, count = length >> 3 << 3; i3 < count; ) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v8 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255) + String.fromCharCode((v7 << 5 | v8) & 255);
        }
        var remain = length - count;
        if (remain === 2) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255);
        } else if (remain === 4) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255);
        } else if (remain === 5) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255);
        } else if (remain === 7) {
          v1 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v2 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v3 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v4 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v5 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v6 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          v7 = BASE32_DECODE_CHAR[base32Str.charAt(i3++)];
          str += String.fromCharCode((v1 << 3 | v2 >>> 2) & 255) + String.fromCharCode((v2 << 6 | v3 << 1 | v4 >>> 4) & 255) + String.fromCharCode((v4 << 4 | v5 >>> 1) & 255) + String.fromCharCode((v5 << 7 | v6 << 2 | v7 >>> 3) & 255);
        }
        return str;
      };
      var exports2 = {
        encode: encode2,
        decode: decode2
      };
      decode2.asBytes = decodeAsBytes;
      if (COMMON_JS) {
        module.exports = exports2;
      } else {
        root2.base32 = exports2;
      }
    })();
  })(base32$1);
  return base32$1.exports;
}
requireBase32();
const { gcd, lcm } = Context.math;
const { mod } = Context.math;
const { dopri } = Context.math;
const defaultCreativeCommonsVersion = "4.0";
function creativeCommonsLicense(code2, name2, urlSlug, description) {
  return {
    code: code2,
    name: `Creative Commons ${name2}`,
    description,
    kind: "creative-commons",
    url: (version2 = defaultCreativeCommonsVersion) => `https://creativecommons.org/licenses/${urlSlug}/${version2}/`
  };
}
function fixedUrlLicense(code2, name2, url, description, kind) {
  return {
    code: code2,
    name: name2,
    description,
    kind,
    url: () => url
  };
}
const mediaLicenses = [
  creativeCommonsLicense(
    "CC-BY",
    "Attribution",
    "by",
    "Creative Commons Attribution: reuse with credit, including commercially."
  ),
  creativeCommonsLicense(
    "CC-BY-SA",
    "Attribution-ShareAlike",
    "by-sa",
    "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-ND",
    "Attribution-NoDerivatives",
    "by-nd",
    "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."
  ),
  creativeCommonsLicense(
    "CC-BY-NC",
    "Attribution-NonCommercial",
    "by-nc",
    "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-SA",
    "Attribution-NonCommercial-ShareAlike",
    "by-nc-sa",
    "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."
  ),
  creativeCommonsLicense(
    "CC-BY-NC-ND",
    "Attribution-NonCommercial-NoDerivatives",
    "by-nc-nd",
    "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."
  ),
  fixedUrlLicense(
    "CC0",
    "CC0 1.0 Public Domain Dedication",
    "https://creativecommons.org/publicdomain/zero/1.0/",
    "Creative Commons Zero: the creator has dedicated the work to the public domain.",
    "public-domain"
  ),
  fixedUrlLicense(
    "PDM",
    "Public Domain Mark 1.0",
    "https://creativecommons.org/publicdomain/mark/1.0/",
    "Public Domain Mark: the work is free of known copyright restrictions.",
    "public-domain"
  ),
  fixedUrlLicense(
    "GFDL",
    "GNU Free Documentation License",
    "https://www.gnu.org/licenses/fdl-1.3.html",
    "GNU Free Documentation License: copyleft license common on Wikimedia.",
    "license"
  ),
  fixedUrlLicense(
    "FAL",
    "Free Art License 1.3",
    "https://artlibre.org/licence/lal/en/",
    "Free Art License: copyleft license for artistic works.",
    "license"
  ),
  fixedUrlLicense(
    "OGL",
    "Open Government Licence v3.0 (UK)",
    "https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/",
    "UK Open Government Licence: reuse government material with attribution.",
    "license"
  ),
  fixedUrlLicense(
    "MIT",
    "MIT License",
    "https://opensource.org/license/mit",
    "MIT License: permissive license common for icon and illustration sets.",
    "license"
  ),
  fixedUrlLicense(
    "APACHE-2.0",
    "Apache License 2.0",
    "https://www.apache.org/licenses/LICENSE-2.0",
    "Apache License 2.0: permissive license common for icon and illustration sets.",
    "license"
  )
];
Object.fromEntries(
  mediaLicenses.map((info) => [info.code.toLowerCase(), info])
);
var cssesc_1;
var hasRequiredCssesc;
function requireCssesc() {
  if (hasRequiredCssesc) return cssesc_1;
  hasRequiredCssesc = 1;
  var object2 = {};
  var hasOwnProperty2 = object2.hasOwnProperty;
  var merge = function merge2(options2, defaults2) {
    if (!options2) {
      return defaults2;
    }
    var result2 = {};
    for (var key in defaults2) {
      result2[key] = hasOwnProperty2.call(options2, key) ? options2[key] : defaults2[key];
    }
    return result2;
  };
  var regexAnySingleEscape = /[ -,\.\/:-@\[-\^`\{-~]/;
  var regexSingleEscape = /[ -,\.\/:-@\[\]\^`\{-~]/;
  var regexExcessiveSpaces = /(^|\\+)?(\\[A-F0-9]{1,6})\x20(?![a-fA-F0-9\x20])/g;
  var cssesc2 = function cssesc3(string2, options2) {
    options2 = merge(options2, cssesc3.options);
    if (options2.quotes != "single" && options2.quotes != "double") {
      options2.quotes = "single";
    }
    var quote2 = options2.quotes == "double" ? '"' : "'";
    var isIdentifier = options2.isIdentifier;
    var firstChar = string2.charAt(0);
    var output = "";
    var counter2 = 0;
    var length = string2.length;
    while (counter2 < length) {
      var character = string2.charAt(counter2++);
      var codePoint = character.charCodeAt();
      var value = void 0;
      if (codePoint < 32 || codePoint > 126) {
        if (codePoint >= 55296 && codePoint <= 56319 && counter2 < length) {
          var extra = string2.charCodeAt(counter2++);
          if ((extra & 64512) == 56320) {
            codePoint = ((codePoint & 1023) << 10) + (extra & 1023) + 65536;
          } else {
            counter2--;
          }
        }
        value = "\\" + codePoint.toString(16).toUpperCase() + " ";
      } else {
        if (options2.escapeEverything) {
          if (regexAnySingleEscape.test(character)) {
            value = "\\" + character;
          } else {
            value = "\\" + codePoint.toString(16).toUpperCase() + " ";
          }
        } else if (/[\t\n\f\r\x0B]/.test(character)) {
          value = "\\" + codePoint.toString(16).toUpperCase() + " ";
        } else if (character == "\\" || !isIdentifier && (character == '"' && quote2 == character || character == "'" && quote2 == character) || isIdentifier && regexSingleEscape.test(character)) {
          value = "\\" + character;
        } else {
          value = character;
        }
      }
      output += value;
    }
    if (isIdentifier) {
      if (/^-[-\d]/.test(output)) {
        output = "\\-" + output.slice(1);
      } else if (/\d/.test(firstChar)) {
        output = "\\3" + firstChar + " " + output.slice(1);
      }
    }
    output = output.replace(regexExcessiveSpaces, function($0, $1, $2) {
      if ($1 && $1.length % 2) {
        return $0;
      }
      return ($1 || "") + $2;
    });
    if (!isIdentifier && options2.wrap) {
      return quote2 + output + quote2;
    }
    return output;
  };
  cssesc2.options = {
    "escapeEverything": false,
    "isIdentifier": false,
    "quotes": "single",
    "wrap": false
  };
  cssesc2.version = "3.0.0";
  cssesc_1 = cssesc2;
  return cssesc_1;
}
requireCssesc();
new Map(
  Object.keys(styleAttributes).map((k2) => [
    k2.toLowerCase(),
    k2
  ])
);
const STYLE_KEY_PREFIXES = coloredItemsForWords;
STYLE_KEY_PREFIXES.map((p2) => [p2.toLowerCase(), p2]);
new Set(
  coloredItemsForWords.flatMap((item) => [
    `${item}Color`,
    `${item}ColorDarkMode`
  ])
);
const DOENET_LSP_METHODS = {
  /**
   * Push externally-generated diagnostics into the LSP so the server
   * can re-emit them alongside its own.  Used to surface viewer-side
   * runtime errors (e.g. from a separately-running Core) in the editor's
   * diagnostics panel.
   */
  setAdditionalDiagnostics: "doenet/setAdditionalDiagnostics",
  /**
   * Compute the context-sensitive help payload for a cursor offset.
   * Server runs the schema walk + (when available) the Rust resolver,
   * so multi-part refs like `$rep[1].point1.x` resolve correctly even
   * though the editor itself has no resolver.
   */
  contextHelp: "doenet/contextHelp",
  /**
   * Compute the context-sensitive help payload for the highlighted
   * autocomplete row.  Used while the popup is open so the help panel
   * mirrors arrow-key navigation through completions.
   */
  contextHelpForCompletion: "doenet/contextHelpForCompletion"
};
function getAutoCloseTag(docText, cursorPos) {
  const hypotheticalDoc = docText.slice(0, cursorPos) + ">" + docText.slice(cursorPos);
  const source = new DoenetSourceObject();
  source.setSource(hypotheticalDoc);
  const context = source.elementAtOffsetWithContext(cursorPos);
  if (!context.node) {
    return null;
  }
  if (context.cursorPosition !== "openTagName" && context.cursorPosition !== "openTag" && context.cursorPosition !== "attributeName") {
    return null;
  }
  const element2 = context.node;
  const tagName = element2.name;
  if (!tagName) {
    return null;
  }
  const completionStatus2 = source.isCompleteElement(element2);
  if (completionStatus2.closed) {
    return null;
  } else {
    return `</${tagName}>`;
  }
}
const autoCloseTagExtension = EditorView.inputHandler.of(
  (view, from, to2, insertedText) => {
    if (insertedText !== ">" || from !== to2) {
      return false;
    }
    const docText = view.state.doc.toString();
    const closeTag = getAutoCloseTag(docText, from);
    if (!closeTag) {
      return false;
    }
    view.dispatch({
      changes: { from, to: to2, insert: `>${closeTag}` },
      selection: { anchor: from + 1 }
    });
    return true;
  }
);
const lspSource = '(function(){"use strict";function getAugmentedNamespace(D){if(Object.prototype.hasOwnProperty.call(D,"__esModule"))return D;var E=D.default;if(typeof E=="function"){var F=function J(){var $e=!1;try{$e=this instanceof J}catch{}return $e?Reflect.construct(E,arguments,this.constructor):E.apply(this,arguments)};F.prototype=E.prototype}else F={};return Object.defineProperty(F,"__esModule",{value:!0}),Object.keys(D).forEach(function(J){var $e=Object.getOwnPropertyDescriptor(D,J);Object.defineProperty(F,J,$e.get?$e:{enumerable:!0,get:function(){return D[J]}})}),F}var main$3={},api$2={},semanticTokens={},main$2={},main$1={},ril={},api$1={},messages$1={},is$2={},hasRequiredIs$2;function requireIs$2(){if(hasRequiredIs$2)return is$2;hasRequiredIs$2=1,Object.defineProperty(is$2,"__esModule",{value:!0}),is$2.stringArray=is$2.array=is$2.func=is$2.error=is$2.number=is$2.string=is$2.boolean=void 0;function D(mr){return mr===!0||mr===!1}is$2.boolean=D;function E(mr){return typeof mr=="string"||mr instanceof String}is$2.string=E;function F(mr){return typeof mr=="number"||mr instanceof Number}is$2.number=F;function J(mr){return mr instanceof Error}is$2.error=J;function $e(mr){return typeof mr=="function"}is$2.func=$e;function _t(mr){return Array.isArray(mr)}is$2.array=_t;function lr(mr){return _t(mr)&&mr.every(Or=>E(Or))}return is$2.stringArray=lr,is$2}var hasRequiredMessages$1;function requireMessages$1(){if(hasRequiredMessages$1)return messages$1;hasRequiredMessages$1=1,Object.defineProperty(messages$1,"__esModule",{value:!0}),messages$1.Message=messages$1.NotificationType9=messages$1.NotificationType8=messages$1.NotificationType7=messages$1.NotificationType6=messages$1.NotificationType5=messages$1.NotificationType4=messages$1.NotificationType3=messages$1.NotificationType2=messages$1.NotificationType1=messages$1.NotificationType0=messages$1.NotificationType=messages$1.RequestType9=messages$1.RequestType8=messages$1.RequestType7=messages$1.RequestType6=messages$1.RequestType5=messages$1.RequestType4=messages$1.RequestType3=messages$1.RequestType2=messages$1.RequestType1=messages$1.RequestType=messages$1.RequestType0=messages$1.AbstractMessageSignature=messages$1.ParameterStructures=messages$1.ResponseError=messages$1.ErrorCodes=void 0;const D=requireIs$2();var E;(function(sa){sa.ParseError=-32700,sa.InvalidRequest=-32600,sa.MethodNotFound=-32601,sa.InvalidParams=-32602,sa.InternalError=-32603,sa.jsonrpcReservedErrorRangeStart=-32099,sa.serverErrorStart=-32099,sa.MessageWriteError=-32099,sa.MessageReadError=-32098,sa.PendingResponseRejected=-32097,sa.ConnectionInactive=-32096,sa.ServerNotInitialized=-32002,sa.UnknownErrorCode=-32001,sa.jsonrpcReservedErrorRangeEnd=-32e3,sa.serverErrorEnd=-32e3})(E||(messages$1.ErrorCodes=E={}));class F extends Error{constructor(aa,pa,ma){super(pa),this.code=D.number(aa)?aa:E.UnknownErrorCode,this.data=ma,Object.setPrototypeOf(this,F.prototype)}toJson(){const aa={code:this.code,message:this.message};return this.data!==void 0&&(aa.data=this.data),aa}}messages$1.ResponseError=F;class J{constructor(aa){this.kind=aa}static is(aa){return aa===J.auto||aa===J.byName||aa===J.byPosition}toString(){return this.kind}}messages$1.ParameterStructures=J,J.auto=new J("auto"),J.byPosition=new J("byPosition"),J.byName=new J("byName");class $e{constructor(aa,pa){this.method=aa,this.numberOfParams=pa}get parameterStructures(){return J.auto}}messages$1.AbstractMessageSignature=$e;class _t extends $e{constructor(aa){super(aa,0)}}messages$1.RequestType0=_t;class lr extends $e{constructor(aa,pa=J.auto){super(aa,1),this._parameterStructures=pa}get parameterStructures(){return this._parameterStructures}}messages$1.RequestType=lr;class mr extends $e{constructor(aa,pa=J.auto){super(aa,1),this._parameterStructures=pa}get parameterStructures(){return this._parameterStructures}}messages$1.RequestType1=mr;class Or extends $e{constructor(aa){super(aa,2)}}messages$1.RequestType2=Or;class Pr extends $e{constructor(aa){super(aa,3)}}messages$1.RequestType3=Pr;class dn extends $e{constructor(aa){super(aa,4)}}messages$1.RequestType4=dn;class gi extends $e{constructor(aa){super(aa,5)}}messages$1.RequestType5=gi;class qi extends $e{constructor(aa){super(aa,6)}}messages$1.RequestType6=qi;class zi extends $e{constructor(aa){super(aa,7)}}messages$1.RequestType7=zi;class Hi extends $e{constructor(aa){super(aa,8)}}messages$1.RequestType8=Hi;class Qi extends $e{constructor(aa){super(aa,9)}}messages$1.RequestType9=Qi;class Gi extends $e{constructor(aa,pa=J.auto){super(aa,1),this._parameterStructures=pa}get parameterStructures(){return this._parameterStructures}}messages$1.NotificationType=Gi;class Zi extends $e{constructor(aa){super(aa,0)}}messages$1.NotificationType0=Zi;class Xi extends $e{constructor(aa,pa=J.auto){super(aa,1),this._parameterStructures=pa}get parameterStructures(){return this._parameterStructures}}messages$1.NotificationType1=Xi;class Ki extends $e{constructor(aa){super(aa,2)}}messages$1.NotificationType2=Ki;class ea extends $e{constructor(aa){super(aa,3)}}messages$1.NotificationType3=ea;class Ji extends $e{constructor(aa){super(aa,4)}}messages$1.NotificationType4=Ji;class ta extends $e{constructor(aa){super(aa,5)}}messages$1.NotificationType5=ta;class na extends $e{constructor(aa){super(aa,6)}}messages$1.NotificationType6=na;class ra extends $e{constructor(aa){super(aa,7)}}messages$1.NotificationType7=ra;class ia extends $e{constructor(aa){super(aa,8)}}messages$1.NotificationType8=ia;class oa extends $e{constructor(aa){super(aa,9)}}messages$1.NotificationType9=oa;var ua;return(function(sa){function aa(la){const ha=la;return ha&&D.string(ha.method)&&(D.string(ha.id)||D.number(ha.id))}sa.isRequest=aa;function pa(la){const ha=la;return ha&&D.string(ha.method)&&la.id===void 0}sa.isNotification=pa;function ma(la){const ha=la;return ha&&(ha.result!==void 0||!!ha.error)&&(D.string(ha.id)||D.number(ha.id)||ha.id===null)}sa.isResponse=ma})(ua||(messages$1.Message=ua={})),messages$1}var linkedMap={},hasRequiredLinkedMap;function requireLinkedMap(){if(hasRequiredLinkedMap)return linkedMap;hasRequiredLinkedMap=1;var D;Object.defineProperty(linkedMap,"__esModule",{value:!0}),linkedMap.LRUCache=linkedMap.LinkedMap=linkedMap.Touch=void 0;var E;(function($e){$e.None=0,$e.First=1,$e.AsOld=$e.First,$e.Last=2,$e.AsNew=$e.Last})(E||(linkedMap.Touch=E={}));class F{constructor(){this[D]="LinkedMap",this._map=new Map,this._head=void 0,this._tail=void 0,this._size=0,this._state=0}clear(){this._map.clear(),this._head=void 0,this._tail=void 0,this._size=0,this._state++}isEmpty(){return!this._head&&!this._tail}get size(){return this._size}get first(){return this._head?.value}get last(){return this._tail?.value}has(_t){return this._map.has(_t)}get(_t,lr=E.None){const mr=this._map.get(_t);if(mr)return lr!==E.None&&this.touch(mr,lr),mr.value}set(_t,lr,mr=E.None){let Or=this._map.get(_t);if(Or)Or.value=lr,mr!==E.None&&this.touch(Or,mr);else{switch(Or={key:_t,value:lr,next:void 0,previous:void 0},mr){case E.None:this.addItemLast(Or);break;case E.First:this.addItemFirst(Or);break;case E.Last:this.addItemLast(Or);break;default:this.addItemLast(Or);break}this._map.set(_t,Or),this._size++}return this}delete(_t){return!!this.remove(_t)}remove(_t){const lr=this._map.get(_t);if(lr)return this._map.delete(_t),this.removeItem(lr),this._size--,lr.value}shift(){if(!this._head&&!this._tail)return;if(!this._head||!this._tail)throw new Error("Invalid list");const _t=this._head;return this._map.delete(_t.key),this.removeItem(_t),this._size--,_t.value}forEach(_t,lr){const mr=this._state;let Or=this._head;for(;Or;){if(lr?_t.bind(lr)(Or.value,Or.key,this):_t(Or.value,Or.key,this),this._state!==mr)throw new Error("LinkedMap got modified during iteration.");Or=Or.next}}keys(){const _t=this._state;let lr=this._head;const mr={[Symbol.iterator]:()=>mr,next:()=>{if(this._state!==_t)throw new Error("LinkedMap got modified during iteration.");if(lr){const Or={value:lr.key,done:!1};return lr=lr.next,Or}else return{value:void 0,done:!0}}};return mr}values(){const _t=this._state;let lr=this._head;const mr={[Symbol.iterator]:()=>mr,next:()=>{if(this._state!==_t)throw new Error("LinkedMap got modified during iteration.");if(lr){const Or={value:lr.value,done:!1};return lr=lr.next,Or}else return{value:void 0,done:!0}}};return mr}entries(){const _t=this._state;let lr=this._head;const mr={[Symbol.iterator]:()=>mr,next:()=>{if(this._state!==_t)throw new Error("LinkedMap got modified during iteration.");if(lr){const Or={value:[lr.key,lr.value],done:!1};return lr=lr.next,Or}else return{value:void 0,done:!0}}};return mr}[(D=Symbol.toStringTag,Symbol.iterator)](){return this.entries()}trimOld(_t){if(_t>=this.size)return;if(_t===0){this.clear();return}let lr=this._head,mr=this.size;for(;lr&&mr>_t;)this._map.delete(lr.key),lr=lr.next,mr--;this._head=lr,this._size=mr,lr&&(lr.previous=void 0),this._state++}addItemFirst(_t){if(!this._head&&!this._tail)this._tail=_t;else if(this._head)_t.next=this._head,this._head.previous=_t;else throw new Error("Invalid list");this._head=_t,this._state++}addItemLast(_t){if(!this._head&&!this._tail)this._head=_t;else if(this._tail)_t.previous=this._tail,this._tail.next=_t;else throw new Error("Invalid list");this._tail=_t,this._state++}removeItem(_t){if(_t===this._head&&_t===this._tail)this._head=void 0,this._tail=void 0;else if(_t===this._head){if(!_t.next)throw new Error("Invalid list");_t.next.previous=void 0,this._head=_t.next}else if(_t===this._tail){if(!_t.previous)throw new Error("Invalid list");_t.previous.next=void 0,this._tail=_t.previous}else{const lr=_t.next,mr=_t.previous;if(!lr||!mr)throw new Error("Invalid list");lr.previous=mr,mr.next=lr}_t.next=void 0,_t.previous=void 0,this._state++}touch(_t,lr){if(!this._head||!this._tail)throw new Error("Invalid list");if(!(lr!==E.First&&lr!==E.Last)){if(lr===E.First){if(_t===this._head)return;const mr=_t.next,Or=_t.previous;_t===this._tail?(Or.next=void 0,this._tail=Or):(mr.previous=Or,Or.next=mr),_t.previous=void 0,_t.next=this._head,this._head.previous=_t,this._head=_t,this._state++}else if(lr===E.Last){if(_t===this._tail)return;const mr=_t.next,Or=_t.previous;_t===this._head?(mr.previous=void 0,this._head=mr):(mr.previous=Or,Or.next=mr),_t.next=void 0,_t.previous=this._tail,this._tail.next=_t,this._tail=_t,this._state++}}}toJSON(){const _t=[];return this.forEach((lr,mr)=>{_t.push([mr,lr])}),_t}fromJSON(_t){this.clear();for(const[lr,mr]of _t)this.set(lr,mr)}}linkedMap.LinkedMap=F;class J extends F{constructor(_t,lr=1){super(),this._limit=_t,this._ratio=Math.min(Math.max(0,lr),1)}get limit(){return this._limit}set limit(_t){this._limit=_t,this.checkTrim()}get ratio(){return this._ratio}set ratio(_t){this._ratio=Math.min(Math.max(0,_t),1),this.checkTrim()}get(_t,lr=E.AsNew){return super.get(_t,lr)}peek(_t){return super.get(_t,E.None)}set(_t,lr){return super.set(_t,lr,E.Last),this.checkTrim(),this}checkTrim(){this.size>this._limit&&this.trimOld(Math.round(this._limit*this._ratio))}}return linkedMap.LRUCache=J,linkedMap}var disposable={},hasRequiredDisposable;function requireDisposable(){if(hasRequiredDisposable)return disposable;hasRequiredDisposable=1,Object.defineProperty(disposable,"__esModule",{value:!0}),disposable.Disposable=void 0;var D;return(function(E){function F(J){return{dispose:J}}E.create=F})(D||(disposable.Disposable=D={})),disposable}var events={},ral={},hasRequiredRal;function requireRal(){if(hasRequiredRal)return ral;hasRequiredRal=1,Object.defineProperty(ral,"__esModule",{value:!0});let D;function E(){if(D===void 0)throw new Error("No runtime abstraction layer installed");return D}return(function(F){function J($e){if($e===void 0)throw new Error("No runtime abstraction layer provided");D=$e}F.install=J})(E||(E={})),ral.default=E,ral}var hasRequiredEvents;function requireEvents(){if(hasRequiredEvents)return events;hasRequiredEvents=1,Object.defineProperty(events,"__esModule",{value:!0}),events.Emitter=events.Event=void 0;const D=requireRal();var E;(function($e){const _t={dispose(){}};$e.None=function(){return _t}})(E||(events.Event=E={}));class F{add(_t,lr=null,mr){this._callbacks||(this._callbacks=[],this._contexts=[]),this._callbacks.push(_t),this._contexts.push(lr),Array.isArray(mr)&&mr.push({dispose:()=>this.remove(_t,lr)})}remove(_t,lr=null){if(!this._callbacks)return;let mr=!1;for(let Or=0,Pr=this._callbacks.length;Or<Pr;Or++)if(this._callbacks[Or]===_t)if(this._contexts[Or]===lr){this._callbacks.splice(Or,1),this._contexts.splice(Or,1);return}else mr=!0;if(mr)throw new Error("When adding a listener with a context, you should remove it with the same context")}invoke(..._t){if(!this._callbacks)return[];const lr=[],mr=this._callbacks.slice(0),Or=this._contexts.slice(0);for(let Pr=0,dn=mr.length;Pr<dn;Pr++)try{lr.push(mr[Pr].apply(Or[Pr],_t))}catch(gi){(0,D.default)().console.error(gi)}return lr}isEmpty(){return!this._callbacks||this._callbacks.length===0}dispose(){this._callbacks=void 0,this._contexts=void 0}}class J{constructor(_t){this._options=_t}get event(){return this._event||(this._event=(_t,lr,mr)=>{this._callbacks||(this._callbacks=new F),this._options&&this._options.onFirstListenerAdd&&this._callbacks.isEmpty()&&this._options.onFirstListenerAdd(this),this._callbacks.add(_t,lr);const Or={dispose:()=>{this._callbacks&&(this._callbacks.remove(_t,lr),Or.dispose=J._noop,this._options&&this._options.onLastListenerRemove&&this._callbacks.isEmpty()&&this._options.onLastListenerRemove(this))}};return Array.isArray(mr)&&mr.push(Or),Or}),this._event}fire(_t){this._callbacks&&this._callbacks.invoke.call(this._callbacks,_t)}dispose(){this._callbacks&&(this._callbacks.dispose(),this._callbacks=void 0)}}return events.Emitter=J,J._noop=function(){},events}var cancellation={},hasRequiredCancellation;function requireCancellation(){if(hasRequiredCancellation)return cancellation;hasRequiredCancellation=1,Object.defineProperty(cancellation,"__esModule",{value:!0}),cancellation.CancellationTokenSource=cancellation.CancellationToken=void 0;const D=requireRal(),E=requireIs$2(),F=requireEvents();var J;(function(mr){mr.None=Object.freeze({isCancellationRequested:!1,onCancellationRequested:F.Event.None}),mr.Cancelled=Object.freeze({isCancellationRequested:!0,onCancellationRequested:F.Event.None});function Or(Pr){const dn=Pr;return dn&&(dn===mr.None||dn===mr.Cancelled||E.boolean(dn.isCancellationRequested)&&!!dn.onCancellationRequested)}mr.is=Or})(J||(cancellation.CancellationToken=J={}));const $e=Object.freeze(function(mr,Or){const Pr=(0,D.default)().timer.setTimeout(mr.bind(Or),0);return{dispose(){Pr.dispose()}}});class _t{constructor(){this._isCancelled=!1}cancel(){this._isCancelled||(this._isCancelled=!0,this._emitter&&(this._emitter.fire(void 0),this.dispose()))}get isCancellationRequested(){return this._isCancelled}get onCancellationRequested(){return this._isCancelled?$e:(this._emitter||(this._emitter=new F.Emitter),this._emitter.event)}dispose(){this._emitter&&(this._emitter.dispose(),this._emitter=void 0)}}class lr{get token(){return this._token||(this._token=new _t),this._token}cancel(){this._token?this._token.cancel():this._token=J.Cancelled}dispose(){this._token?this._token instanceof _t&&this._token.dispose():this._token=J.None}}return cancellation.CancellationTokenSource=lr,cancellation}var sharedArrayCancellation={},hasRequiredSharedArrayCancellation;function requireSharedArrayCancellation(){if(hasRequiredSharedArrayCancellation)return sharedArrayCancellation;hasRequiredSharedArrayCancellation=1,Object.defineProperty(sharedArrayCancellation,"__esModule",{value:!0}),sharedArrayCancellation.SharedArrayReceiverStrategy=sharedArrayCancellation.SharedArraySenderStrategy=void 0;const D=requireCancellation();var E;(function(lr){lr.Continue=0,lr.Cancelled=1})(E||(E={}));class F{constructor(){this.buffers=new Map}enableCancellation(mr){if(mr.id===null)return;const Or=new SharedArrayBuffer(4),Pr=new Int32Array(Or,0,1);Pr[0]=E.Continue,this.buffers.set(mr.id,Or),mr.$cancellationData=Or}async sendCancellation(mr,Or){const Pr=this.buffers.get(Or);if(Pr===void 0)return;const dn=new Int32Array(Pr,0,1);Atomics.store(dn,0,E.Cancelled)}cleanup(mr){this.buffers.delete(mr)}dispose(){this.buffers.clear()}}sharedArrayCancellation.SharedArraySenderStrategy=F;class J{constructor(mr){this.data=new Int32Array(mr,0,1)}get isCancellationRequested(){return Atomics.load(this.data,0)===E.Cancelled}get onCancellationRequested(){throw new Error("Cancellation over SharedArrayBuffer doesn\'t support cancellation events")}}class $e{constructor(mr){this.token=new J(mr)}cancel(){}dispose(){}}class _t{constructor(){this.kind="request"}createCancellationTokenSource(mr){const Or=mr.$cancellationData;return Or===void 0?new D.CancellationTokenSource:new $e(Or)}}return sharedArrayCancellation.SharedArrayReceiverStrategy=_t,sharedArrayCancellation}var messageReader$1={},semaphore={},hasRequiredSemaphore;function requireSemaphore(){if(hasRequiredSemaphore)return semaphore;hasRequiredSemaphore=1,Object.defineProperty(semaphore,"__esModule",{value:!0}),semaphore.Semaphore=void 0;const D=requireRal();class E{constructor(J=1){if(J<=0)throw new Error("Capacity must be greater than 0");this._capacity=J,this._active=0,this._waiting=[]}lock(J){return new Promise(($e,_t)=>{this._waiting.push({thunk:J,resolve:$e,reject:_t}),this.runNext()})}get active(){return this._active}runNext(){this._waiting.length===0||this._active===this._capacity||(0,D.default)().timer.setImmediate(()=>this.doRunNext())}doRunNext(){if(this._waiting.length===0||this._active===this._capacity)return;const J=this._waiting.shift();if(this._active++,this._active>this._capacity)throw new Error("To many thunks active");try{const $e=J.thunk();$e instanceof Promise?$e.then(_t=>{this._active--,J.resolve(_t),this.runNext()},_t=>{this._active--,J.reject(_t),this.runNext()}):(this._active--,J.resolve($e),this.runNext())}catch($e){this._active--,J.reject($e),this.runNext()}}}return semaphore.Semaphore=E,semaphore}var hasRequiredMessageReader;function requireMessageReader(){if(hasRequiredMessageReader)return messageReader$1;hasRequiredMessageReader=1,Object.defineProperty(messageReader$1,"__esModule",{value:!0}),messageReader$1.ReadableStreamMessageReader=messageReader$1.AbstractMessageReader=messageReader$1.MessageReader=void 0;const D=requireRal(),E=requireIs$2(),F=requireEvents(),J=requireSemaphore();var $e;(function(Or){function Pr(dn){let gi=dn;return gi&&E.func(gi.listen)&&E.func(gi.dispose)&&E.func(gi.onError)&&E.func(gi.onClose)&&E.func(gi.onPartialMessage)}Or.is=Pr})($e||(messageReader$1.MessageReader=$e={}));class _t{constructor(){this.errorEmitter=new F.Emitter,this.closeEmitter=new F.Emitter,this.partialMessageEmitter=new F.Emitter}dispose(){this.errorEmitter.dispose(),this.closeEmitter.dispose()}get onError(){return this.errorEmitter.event}fireError(Pr){this.errorEmitter.fire(this.asError(Pr))}get onClose(){return this.closeEmitter.event}fireClose(){this.closeEmitter.fire(void 0)}get onPartialMessage(){return this.partialMessageEmitter.event}firePartialMessage(Pr){this.partialMessageEmitter.fire(Pr)}asError(Pr){return Pr instanceof Error?Pr:new Error(`Reader received error. Reason: ${E.string(Pr.message)?Pr.message:"unknown"}`)}}messageReader$1.AbstractMessageReader=_t;var lr;(function(Or){function Pr(dn){let gi,qi;const zi=new Map;let Hi;const Qi=new Map;if(dn===void 0||typeof dn=="string")gi=dn??"utf-8";else{if(gi=dn.charset??"utf-8",dn.contentDecoder!==void 0&&(qi=dn.contentDecoder,zi.set(qi.name,qi)),dn.contentDecoders!==void 0)for(const Gi of dn.contentDecoders)zi.set(Gi.name,Gi);if(dn.contentTypeDecoder!==void 0&&(Hi=dn.contentTypeDecoder,Qi.set(Hi.name,Hi)),dn.contentTypeDecoders!==void 0)for(const Gi of dn.contentTypeDecoders)Qi.set(Gi.name,Gi)}return Hi===void 0&&(Hi=(0,D.default)().applicationJson.decoder,Qi.set(Hi.name,Hi)),{charset:gi,contentDecoder:qi,contentDecoders:zi,contentTypeDecoder:Hi,contentTypeDecoders:Qi}}Or.fromOptions=Pr})(lr||(lr={}));class mr extends _t{constructor(Pr,dn){super(),this.readable=Pr,this.options=lr.fromOptions(dn),this.buffer=(0,D.default)().messageBuffer.create(this.options.charset),this._partialMessageTimeout=1e4,this.nextMessageLength=-1,this.messageToken=0,this.readSemaphore=new J.Semaphore(1)}set partialMessageTimeout(Pr){this._partialMessageTimeout=Pr}get partialMessageTimeout(){return this._partialMessageTimeout}listen(Pr){this.nextMessageLength=-1,this.messageToken=0,this.partialMessageTimer=void 0,this.callback=Pr;const dn=this.readable.onData(gi=>{this.onData(gi)});return this.readable.onError(gi=>this.fireError(gi)),this.readable.onClose(()=>this.fireClose()),dn}onData(Pr){try{for(this.buffer.append(Pr);;){if(this.nextMessageLength===-1){const gi=this.buffer.tryReadHeaders(!0);if(!gi)return;const qi=gi.get("content-length");if(!qi){this.fireError(new Error(`Header must provide a Content-Length property.\n${JSON.stringify(Object.fromEntries(gi))}`));return}const zi=parseInt(qi);if(isNaN(zi)){this.fireError(new Error(`Content-Length value must be a number. Got ${qi}`));return}this.nextMessageLength=zi}const dn=this.buffer.tryReadBody(this.nextMessageLength);if(dn===void 0){this.setPartialMessageTimer();return}this.clearPartialMessageTimer(),this.nextMessageLength=-1,this.readSemaphore.lock(async()=>{const gi=this.options.contentDecoder!==void 0?await this.options.contentDecoder.decode(dn):dn,qi=await this.options.contentTypeDecoder.decode(gi,this.options);this.callback(qi)}).catch(gi=>{this.fireError(gi)})}}catch(dn){this.fireError(dn)}}clearPartialMessageTimer(){this.partialMessageTimer&&(this.partialMessageTimer.dispose(),this.partialMessageTimer=void 0)}setPartialMessageTimer(){this.clearPartialMessageTimer(),!(this._partialMessageTimeout<=0)&&(this.partialMessageTimer=(0,D.default)().timer.setTimeout((Pr,dn)=>{this.partialMessageTimer=void 0,Pr===this.messageToken&&(this.firePartialMessage({messageToken:Pr,waitingTime:dn}),this.setPartialMessageTimer())},this._partialMessageTimeout,this.messageToken,this._partialMessageTimeout))}}return messageReader$1.ReadableStreamMessageReader=mr,messageReader$1}var messageWriter$1={},hasRequiredMessageWriter;function requireMessageWriter(){if(hasRequiredMessageWriter)return messageWriter$1;hasRequiredMessageWriter=1,Object.defineProperty(messageWriter$1,"__esModule",{value:!0}),messageWriter$1.WriteableStreamMessageWriter=messageWriter$1.AbstractMessageWriter=messageWriter$1.MessageWriter=void 0;const D=requireRal(),E=requireIs$2(),F=requireSemaphore(),J=requireEvents(),$e="Content-Length: ",_t=`\\r\n`;var lr;(function(dn){function gi(qi){let zi=qi;return zi&&E.func(zi.dispose)&&E.func(zi.onClose)&&E.func(zi.onError)&&E.func(zi.write)}dn.is=gi})(lr||(messageWriter$1.MessageWriter=lr={}));class mr{constructor(){this.errorEmitter=new J.Emitter,this.closeEmitter=new J.Emitter}dispose(){this.errorEmitter.dispose(),this.closeEmitter.dispose()}get onError(){return this.errorEmitter.event}fireError(gi,qi,zi){this.errorEmitter.fire([this.asError(gi),qi,zi])}get onClose(){return this.closeEmitter.event}fireClose(){this.closeEmitter.fire(void 0)}asError(gi){return gi instanceof Error?gi:new Error(`Writer received error. Reason: ${E.string(gi.message)?gi.message:"unknown"}`)}}messageWriter$1.AbstractMessageWriter=mr;var Or;(function(dn){function gi(qi){return qi===void 0||typeof qi=="string"?{charset:qi??"utf-8",contentTypeEncoder:(0,D.default)().applicationJson.encoder}:{charset:qi.charset??"utf-8",contentEncoder:qi.contentEncoder,contentTypeEncoder:qi.contentTypeEncoder??(0,D.default)().applicationJson.encoder}}dn.fromOptions=gi})(Or||(Or={}));class Pr extends mr{constructor(gi,qi){super(),this.writable=gi,this.options=Or.fromOptions(qi),this.errorCount=0,this.writeSemaphore=new F.Semaphore(1),this.writable.onError(zi=>this.fireError(zi)),this.writable.onClose(()=>this.fireClose())}async write(gi){return this.writeSemaphore.lock(async()=>this.options.contentTypeEncoder.encode(gi,this.options).then(zi=>this.options.contentEncoder!==void 0?this.options.contentEncoder.encode(zi):zi).then(zi=>{const Hi=[];return Hi.push($e,zi.byteLength.toString(),_t),Hi.push(_t),this.doWrite(gi,Hi,zi)},zi=>{throw this.fireError(zi),zi}))}async doWrite(gi,qi,zi){try{return await this.writable.write(qi.join(""),"ascii"),this.writable.write(zi)}catch(Hi){return this.handleError(Hi,gi),Promise.reject(Hi)}}handleError(gi,qi){this.errorCount++,this.fireError(gi,qi,this.errorCount)}end(){this.writable.end()}}return messageWriter$1.WriteableStreamMessageWriter=Pr,messageWriter$1}var messageBuffer={},hasRequiredMessageBuffer;function requireMessageBuffer(){if(hasRequiredMessageBuffer)return messageBuffer;hasRequiredMessageBuffer=1,Object.defineProperty(messageBuffer,"__esModule",{value:!0}),messageBuffer.AbstractMessageBuffer=void 0;const D=13,E=10,F=`\\r\n`;class J{constructor(_t="utf-8"){this._encoding=_t,this._chunks=[],this._totalLength=0}get encoding(){return this._encoding}append(_t){const lr=typeof _t=="string"?this.fromString(_t,this._encoding):_t;this._chunks.push(lr),this._totalLength+=lr.byteLength}tryReadHeaders(_t=!1){if(this._chunks.length===0)return;let lr=0,mr=0,Or=0,Pr=0;e:for(;mr<this._chunks.length;){const zi=this._chunks[mr];for(Or=0;Or<zi.length;){switch(zi[Or]){case D:switch(lr){case 0:lr=1;break;case 2:lr=3;break;default:lr=0}break;case E:switch(lr){case 1:lr=2;break;case 3:lr=4,Or++;break e;default:lr=0}break;default:lr=0}Or++}Pr+=zi.byteLength,mr++}if(lr!==4)return;const dn=this._read(Pr+Or),gi=new Map,qi=this.toString(dn,"ascii").split(F);if(qi.length<2)return gi;for(let zi=0;zi<qi.length-2;zi++){const Hi=qi[zi],Qi=Hi.indexOf(":");if(Qi===-1)throw new Error(`Message header must separate key and value using \':\'\n${Hi}`);const Gi=Hi.substr(0,Qi),Zi=Hi.substr(Qi+1).trim();gi.set(_t?Gi.toLowerCase():Gi,Zi)}return gi}tryReadBody(_t){if(!(this._totalLength<_t))return this._read(_t)}get numberOfBytes(){return this._totalLength}_read(_t){if(_t===0)return this.emptyBuffer();if(_t>this._totalLength)throw new Error("Cannot read so many bytes!");if(this._chunks[0].byteLength===_t){const Pr=this._chunks[0];return this._chunks.shift(),this._totalLength-=_t,this.asNative(Pr)}if(this._chunks[0].byteLength>_t){const Pr=this._chunks[0],dn=this.asNative(Pr,_t);return this._chunks[0]=Pr.slice(_t),this._totalLength-=_t,dn}const lr=this.allocNative(_t);let mr=0,Or=0;for(;_t>0;){const Pr=this._chunks[Or];if(Pr.byteLength>_t){const dn=Pr.slice(0,_t);lr.set(dn,mr),mr+=_t,this._chunks[Or]=Pr.slice(_t),this._totalLength-=_t,_t-=_t}else lr.set(Pr,mr),mr+=Pr.byteLength,this._chunks.shift(),this._totalLength-=Pr.byteLength,_t-=Pr.byteLength}return lr}}return messageBuffer.AbstractMessageBuffer=J,messageBuffer}var connection$2={},hasRequiredConnection$1;function requireConnection$1(){return hasRequiredConnection$1||(hasRequiredConnection$1=1,(function(D){Object.defineProperty(D,"__esModule",{value:!0}),D.createMessageConnection=D.ConnectionOptions=D.MessageStrategy=D.CancellationStrategy=D.CancellationSenderStrategy=D.CancellationReceiverStrategy=D.RequestCancellationReceiverStrategy=D.IdCancellationReceiverStrategy=D.ConnectionStrategy=D.ConnectionError=D.ConnectionErrors=D.LogTraceNotification=D.SetTraceNotification=D.TraceFormat=D.TraceValues=D.Trace=D.NullLogger=D.ProgressType=D.ProgressToken=void 0;const E=requireRal(),F=requireIs$2(),J=requireMessages$1(),$e=requireLinkedMap(),_t=requireEvents(),lr=requireCancellation();var mr;(function(aa){aa.type=new J.NotificationType("$/cancelRequest")})(mr||(mr={}));var Or;(function(aa){function pa(ma){return typeof ma=="string"||typeof ma=="number"}aa.is=pa})(Or||(D.ProgressToken=Or={}));var Pr;(function(aa){aa.type=new J.NotificationType("$/progress")})(Pr||(Pr={}));class dn{constructor(){}}D.ProgressType=dn;var gi;(function(aa){function pa(ma){return F.func(ma)}aa.is=pa})(gi||(gi={})),D.NullLogger=Object.freeze({error:()=>{},warn:()=>{},info:()=>{},log:()=>{}});var qi;(function(aa){aa[aa.Off=0]="Off",aa[aa.Messages=1]="Messages",aa[aa.Compact=2]="Compact",aa[aa.Verbose=3]="Verbose"})(qi||(D.Trace=qi={}));var zi;(function(aa){aa.Off="off",aa.Messages="messages",aa.Compact="compact",aa.Verbose="verbose"})(zi||(D.TraceValues=zi={})),(function(aa){function pa(la){if(!F.string(la))return aa.Off;switch(la=la.toLowerCase(),la){case"off":return aa.Off;case"messages":return aa.Messages;case"compact":return aa.Compact;case"verbose":return aa.Verbose;default:return aa.Off}}aa.fromString=pa;function ma(la){switch(la){case aa.Off:return"off";case aa.Messages:return"messages";case aa.Compact:return"compact";case aa.Verbose:return"verbose";default:return"off"}}aa.toString=ma})(qi||(D.Trace=qi={}));var Hi;(function(aa){aa.Text="text",aa.JSON="json"})(Hi||(D.TraceFormat=Hi={})),(function(aa){function pa(ma){return F.string(ma)?(ma=ma.toLowerCase(),ma==="json"?aa.JSON:aa.Text):aa.Text}aa.fromString=pa})(Hi||(D.TraceFormat=Hi={}));var Qi;(function(aa){aa.type=new J.NotificationType("$/setTrace")})(Qi||(D.SetTraceNotification=Qi={}));var Gi;(function(aa){aa.type=new J.NotificationType("$/logTrace")})(Gi||(D.LogTraceNotification=Gi={}));var Zi;(function(aa){aa[aa.Closed=1]="Closed",aa[aa.Disposed=2]="Disposed",aa[aa.AlreadyListening=3]="AlreadyListening"})(Zi||(D.ConnectionErrors=Zi={}));class Xi extends Error{constructor(pa,ma){super(ma),this.code=pa,Object.setPrototypeOf(this,Xi.prototype)}}D.ConnectionError=Xi;var Ki;(function(aa){function pa(ma){const la=ma;return la&&F.func(la.cancelUndispatched)}aa.is=pa})(Ki||(D.ConnectionStrategy=Ki={}));var ea;(function(aa){function pa(ma){const la=ma;return la&&(la.kind===void 0||la.kind==="id")&&F.func(la.createCancellationTokenSource)&&(la.dispose===void 0||F.func(la.dispose))}aa.is=pa})(ea||(D.IdCancellationReceiverStrategy=ea={}));var Ji;(function(aa){function pa(ma){const la=ma;return la&&la.kind==="request"&&F.func(la.createCancellationTokenSource)&&(la.dispose===void 0||F.func(la.dispose))}aa.is=pa})(Ji||(D.RequestCancellationReceiverStrategy=Ji={}));var ta;(function(aa){aa.Message=Object.freeze({createCancellationTokenSource(ma){return new lr.CancellationTokenSource}});function pa(ma){return ea.is(ma)||Ji.is(ma)}aa.is=pa})(ta||(D.CancellationReceiverStrategy=ta={}));var na;(function(aa){aa.Message=Object.freeze({sendCancellation(ma,la){return ma.sendNotification(mr.type,{id:la})},cleanup(ma){}});function pa(ma){const la=ma;return la&&F.func(la.sendCancellation)&&F.func(la.cleanup)}aa.is=pa})(na||(D.CancellationSenderStrategy=na={}));var ra;(function(aa){aa.Message=Object.freeze({receiver:ta.Message,sender:na.Message});function pa(ma){const la=ma;return la&&ta.is(la.receiver)&&na.is(la.sender)}aa.is=pa})(ra||(D.CancellationStrategy=ra={}));var ia;(function(aa){function pa(ma){const la=ma;return la&&F.func(la.handleMessage)}aa.is=pa})(ia||(D.MessageStrategy=ia={}));var oa;(function(aa){function pa(ma){const la=ma;return la&&(ra.is(la.cancellationStrategy)||Ki.is(la.connectionStrategy)||ia.is(la.messageStrategy))}aa.is=pa})(oa||(D.ConnectionOptions=oa={}));var ua;(function(aa){aa[aa.New=1]="New",aa[aa.Listening=2]="Listening",aa[aa.Closed=3]="Closed",aa[aa.Disposed=4]="Disposed"})(ua||(ua={}));function sa(aa,pa,ma,la){const ha=ma!==void 0?ma:D.NullLogger;let ga=0,Aa=0,Fa=0;const $a="2.0";let _a;const fa=new Map;let ka;const ba=new Map,Pa=new Map;let Ia,Da=new $e.LinkedMap,va=new Map,Ca=new Set,ya=new Map,Na=qi.Off,za=Hi.Text,Ta,es=ua.New;const ts=new _t.Emitter,Ka=new _t.Emitter,ps=new _t.Emitter,cs=new _t.Emitter,xa=new _t.Emitter,Ra=la&&la.cancellationStrategy?la.cancellationStrategy:ra.Message;function Va(da){if(da===null)throw new Error("Can\'t send requests with id null since the response can\'t be correlated.");return"req-"+da.toString()}function Ga(da){return da===null?"res-unknown-"+(++Fa).toString():"res-"+da.toString()}function as(){return"not-"+(++Aa).toString()}function rs(da,Qa){J.Message.isRequest(Qa)?da.set(Va(Qa.id),Qa):J.Message.isResponse(Qa)?da.set(Ga(Qa.id),Qa):da.set(as(),Qa)}function ss(da){}function ms(){return es===ua.Listening}function Ua(){return es===ua.Closed}function Wa(){return es===ua.Disposed}function wa(){(es===ua.New||es===ua.Listening)&&(es=ua.Closed,Ka.fire(void 0))}function qa(da){ts.fire([da,void 0,void 0])}function ja(da){ts.fire(da)}aa.onClose(wa),aa.onError(qa),pa.onClose(wa),pa.onError(ja);function Xa(){Ia||Da.size===0||(Ia=(0,E.default)().timer.setImmediate(()=>{Ia=void 0,Ja()}))}function Ya(da){J.Message.isRequest(da)?ns(da):J.Message.isNotification(da)?Sa(da):J.Message.isResponse(da)?ca(da):Ha(da)}function Ja(){if(Da.size===0)return;const da=Da.shift();try{const Qa=la?.messageStrategy;ia.is(Qa)?Qa.handleMessage(da,Ya):Ya(da)}finally{Xa()}}const os=da=>{try{if(J.Message.isNotification(da)&&da.method===mr.type.method){const Qa=da.params.id,us=Va(Qa),ds=Da.get(us);if(J.Message.isRequest(ds)){const ls=la?.connectionStrategy,Cs=ls&&ls.cancelUndispatched?ls.cancelUndispatched(ds,ss):void 0;if(Cs&&(Cs.error!==void 0||Cs.result!==void 0)){Da.delete(us),ya.delete(Qa),Cs.id=ds.id,ws(Cs,da.method,Date.now()),pa.write(Cs).catch(()=>ha.error("Sending response for canceled message failed."));return}}const Ts=ya.get(Qa);if(Ts!==void 0){Ts.cancel(),Rs(da);return}else Ca.add(Qa)}rs(Da,da)}finally{Xa()}};function ns(da){if(Wa())return;function Qa(_s,Ds,vs){const Fs={jsonrpc:$a,id:da.id};_s instanceof J.ResponseError?Fs.error=_s.toJson():Fs.result=_s===void 0?null:_s,ws(Fs,Ds,vs),pa.write(Fs).catch(()=>ha.error("Sending response failed."))}function us(_s,Ds,vs){const Fs={jsonrpc:$a,id:da.id,error:_s.toJson()};ws(Fs,Ds,vs),pa.write(Fs).catch(()=>ha.error("Sending response failed."))}function ds(_s,Ds,vs){_s===void 0&&(_s=null);const Fs={jsonrpc:$a,id:da.id,result:_s};ws(Fs,Ds,vs),pa.write(Fs).catch(()=>ha.error("Sending response failed."))}Os(da);const Ts=fa.get(da.method);let ls,Cs;Ts&&(ls=Ts.type,Cs=Ts.handler);const Ms=Date.now();if(Cs||_a){const _s=da.id??String(Date.now()),Ds=ea.is(Ra.receiver)?Ra.receiver.createCancellationTokenSource(_s):Ra.receiver.createCancellationTokenSource(da);da.id!==null&&Ca.has(da.id)&&Ds.cancel(),da.id!==null&&ya.set(_s,Ds);try{let vs;if(Cs)if(da.params===void 0){if(ls!==void 0&&ls.numberOfParams!==0){us(new J.ResponseError(J.ErrorCodes.InvalidParams,`Request ${da.method} defines ${ls.numberOfParams} params but received none.`),da.method,Ms);return}vs=Cs(Ds.token)}else if(Array.isArray(da.params)){if(ls!==void 0&&ls.parameterStructures===J.ParameterStructures.byName){us(new J.ResponseError(J.ErrorCodes.InvalidParams,`Request ${da.method} defines parameters by name but received parameters by position`),da.method,Ms);return}vs=Cs(...da.params,Ds.token)}else{if(ls!==void 0&&ls.parameterStructures===J.ParameterStructures.byPosition){us(new J.ResponseError(J.ErrorCodes.InvalidParams,`Request ${da.method} defines parameters by position but received parameters by name`),da.method,Ms);return}vs=Cs(da.params,Ds.token)}else _a&&(vs=_a(da.method,da.params,Ds.token));const Fs=vs;vs?Fs.then?Fs.then(ks=>{ya.delete(_s),Qa(ks,da.method,Ms)},ks=>{ya.delete(_s),ks instanceof J.ResponseError?us(ks,da.method,Ms):ks&&F.string(ks.message)?us(new J.ResponseError(J.ErrorCodes.InternalError,`Request ${da.method} failed with message: ${ks.message}`),da.method,Ms):us(new J.ResponseError(J.ErrorCodes.InternalError,`Request ${da.method} failed unexpectedly without providing any details.`),da.method,Ms)}):(ya.delete(_s),Qa(vs,da.method,Ms)):(ya.delete(_s),ds(vs,da.method,Ms))}catch(vs){ya.delete(_s),vs instanceof J.ResponseError?Qa(vs,da.method,Ms):vs&&F.string(vs.message)?us(new J.ResponseError(J.ErrorCodes.InternalError,`Request ${da.method} failed with message: ${vs.message}`),da.method,Ms):us(new J.ResponseError(J.ErrorCodes.InternalError,`Request ${da.method} failed unexpectedly without providing any details.`),da.method,Ms)}}else us(new J.ResponseError(J.ErrorCodes.MethodNotFound,`Unhandled method ${da.method}`),da.method,Ms)}function ca(da){if(!Wa())if(da.id===null)da.error?ha.error(`Received response message without id: Error is: \n${JSON.stringify(da.error,void 0,4)}`):ha.error("Received response message without id. No further error information provided.");else{const Qa=da.id,us=va.get(Qa);if(zs(da,us),us!==void 0){va.delete(Qa);try{if(da.error){const ds=da.error;us.reject(new J.ResponseError(ds.code,ds.message,ds.data))}else if(da.result!==void 0)us.resolve(da.result);else throw new Error("Should never happen.")}catch(ds){ds.message?ha.error(`Response handler \'${us.method}\' failed with message: ${ds.message}`):ha.error(`Response handler \'${us.method}\' failed unexpectedly.`)}}}}function Sa(da){if(Wa())return;let Qa,us;if(da.method===mr.type.method){const ds=da.params.id;Ca.delete(ds),Rs(da);return}else{const ds=ba.get(da.method);ds&&(us=ds.handler,Qa=ds.type)}if(us||ka)try{if(Rs(da),us)if(da.params===void 0)Qa!==void 0&&Qa.numberOfParams!==0&&Qa.parameterStructures!==J.ParameterStructures.byName&&ha.error(`Notification ${da.method} defines ${Qa.numberOfParams} params but received none.`),us();else if(Array.isArray(da.params)){const ds=da.params;da.method===Pr.type.method&&ds.length===2&&Or.is(ds[0])?us({token:ds[0],value:ds[1]}):(Qa!==void 0&&(Qa.parameterStructures===J.ParameterStructures.byName&&ha.error(`Notification ${da.method} defines parameters by name but received parameters by position`),Qa.numberOfParams!==da.params.length&&ha.error(`Notification ${da.method} defines ${Qa.numberOfParams} params but received ${ds.length} arguments`)),us(...ds))}else Qa!==void 0&&Qa.parameterStructures===J.ParameterStructures.byPosition&&ha.error(`Notification ${da.method} defines parameters by position but received parameters by name`),us(da.params);else ka&&ka(da.method,da.params)}catch(ds){ds.message?ha.error(`Notification handler \'${da.method}\' failed with message: ${ds.message}`):ha.error(`Notification handler \'${da.method}\' failed unexpectedly.`)}else ps.fire(da)}function Ha(da){if(!da){ha.error("Received empty message.");return}ha.error(`Received message which is neither a response nor a notification message:\n${JSON.stringify(da,null,4)}`);const Qa=da;if(F.string(Qa.id)||F.number(Qa.id)){const us=Qa.id,ds=va.get(us);ds&&ds.reject(new Error("The received response has neither a result nor an error property."))}}function Za(da){if(da!=null)switch(Na){case qi.Verbose:return JSON.stringify(da,null,4);case qi.Compact:return JSON.stringify(da);default:return}}function fs(da){if(!(Na===qi.Off||!Ta))if(za===Hi.Text){let Qa;(Na===qi.Verbose||Na===qi.Compact)&&da.params&&(Qa=`Params: ${Za(da.params)}\n\n`),Ta.log(`Sending request \'${da.method} - (${da.id})\'.`,Qa)}else $s("send-request",da)}function gs(da){if(!(Na===qi.Off||!Ta))if(za===Hi.Text){let Qa;(Na===qi.Verbose||Na===qi.Compact)&&(da.params?Qa=`Params: ${Za(da.params)}\n\n`:Qa=`No parameters provided.\n\n`),Ta.log(`Sending notification \'${da.method}\'.`,Qa)}else $s("send-notification",da)}function ws(da,Qa,us){if(!(Na===qi.Off||!Ta))if(za===Hi.Text){let ds;(Na===qi.Verbose||Na===qi.Compact)&&(da.error&&da.error.data?ds=`Error data: ${Za(da.error.data)}\n\n`:da.result?ds=`Result: ${Za(da.result)}\n\n`:da.error===void 0&&(ds=`No result returned.\n\n`)),Ta.log(`Sending response \'${Qa} - (${da.id})\'. Processing request took ${Date.now()-us}ms`,ds)}else $s("send-response",da)}function Os(da){if(!(Na===qi.Off||!Ta))if(za===Hi.Text){let Qa;(Na===qi.Verbose||Na===qi.Compact)&&da.params&&(Qa=`Params: ${Za(da.params)}\n\n`),Ta.log(`Received request \'${da.method} - (${da.id})\'.`,Qa)}else $s("receive-request",da)}function Rs(da){if(!(Na===qi.Off||!Ta||da.method===Gi.type.method))if(za===Hi.Text){let Qa;(Na===qi.Verbose||Na===qi.Compact)&&(da.params?Qa=`Params: ${Za(da.params)}\n\n`:Qa=`No parameters provided.\n\n`),Ta.log(`Received notification \'${da.method}\'.`,Qa)}else $s("receive-notification",da)}function zs(da,Qa){if(!(Na===qi.Off||!Ta))if(za===Hi.Text){let us;if((Na===qi.Verbose||Na===qi.Compact)&&(da.error&&da.error.data?us=`Error data: ${Za(da.error.data)}\n\n`:da.result?us=`Result: ${Za(da.result)}\n\n`:da.error===void 0&&(us=`No result returned.\n\n`)),Qa){const ds=da.error?` Request failed: ${da.error.message} (${da.error.code}).`:"";Ta.log(`Received response \'${Qa.method} - (${da.id})\' in ${Date.now()-Qa.timerStart}ms.${ds}`,us)}else Ta.log(`Received response ${da.id} without active response promise.`,us)}else $s("receive-response",da)}function $s(da,Qa){if(!Ta||Na===qi.Off)return;const us={isLSPMessage:!0,type:da,message:Qa,timestamp:Date.now()};Ta.log(us)}function js(){if(Ua())throw new Xi(Zi.Closed,"Connection is closed.");if(Wa())throw new Xi(Zi.Disposed,"Connection is disposed.")}function Qs(){if(ms())throw new Xi(Zi.AlreadyListening,"Connection is already listening")}function Gs(){if(!ms())throw new Error("Call listen() first.")}function Ws(da){return da===void 0?null:da}function Us(da){if(da!==null)return da}function Ma(da){return da!=null&&!Array.isArray(da)&&typeof da=="object"}function Es(da,Qa){switch(da){case J.ParameterStructures.auto:return Ma(Qa)?Us(Qa):[Ws(Qa)];case J.ParameterStructures.byName:if(!Ma(Qa))throw new Error("Received parameters by name but param is not an object literal.");return Us(Qa);case J.ParameterStructures.byPosition:return[Ws(Qa)];default:throw new Error(`Unknown parameter structure ${da.toString()}`)}}function Ns(da,Qa){let us;const ds=da.numberOfParams;switch(ds){case 0:us=void 0;break;case 1:us=Es(da.parameterStructures,Qa[0]);break;default:us=[];for(let Ts=0;Ts<Qa.length&&Ts<ds;Ts++)us.push(Ws(Qa[Ts]));if(Qa.length<ds)for(let Ts=Qa.length;Ts<ds;Ts++)us.push(null);break}return us}const bs={sendNotification:(da,...Qa)=>{js();let us,ds;if(F.string(da)){us=da;const ls=Qa[0];let Cs=0,Ms=J.ParameterStructures.auto;J.ParameterStructures.is(ls)&&(Cs=1,Ms=ls);let _s=Qa.length;const Ds=_s-Cs;switch(Ds){case 0:ds=void 0;break;case 1:ds=Es(Ms,Qa[Cs]);break;default:if(Ms===J.ParameterStructures.byName)throw new Error(`Received ${Ds} parameters for \'by Name\' notification parameter structure.`);ds=Qa.slice(Cs,_s).map(vs=>Ws(vs));break}}else{const ls=Qa;us=da.method,ds=Ns(da,ls)}const Ts={jsonrpc:$a,method:us,params:ds};return gs(Ts),pa.write(Ts).catch(ls=>{throw ha.error("Sending notification failed."),ls})},onNotification:(da,Qa)=>{js();let us;return F.func(da)?ka=da:Qa&&(F.string(da)?(us=da,ba.set(da,{type:void 0,handler:Qa})):(us=da.method,ba.set(da.method,{type:da,handler:Qa}))),{dispose:()=>{us!==void 0?ba.delete(us):ka=void 0}}},onProgress:(da,Qa,us)=>{if(Pa.has(Qa))throw new Error(`Progress handler for token ${Qa} already registered`);return Pa.set(Qa,us),{dispose:()=>{Pa.delete(Qa)}}},sendProgress:(da,Qa,us)=>bs.sendNotification(Pr.type,{token:Qa,value:us}),onUnhandledProgress:cs.event,sendRequest:(da,...Qa)=>{js(),Gs();let us,ds,Ts;if(F.string(da)){us=da;const _s=Qa[0],Ds=Qa[Qa.length-1];let vs=0,Fs=J.ParameterStructures.auto;J.ParameterStructures.is(_s)&&(vs=1,Fs=_s);let ks=Qa.length;lr.CancellationToken.is(Ds)&&(ks=ks-1,Ts=Ds);const Bs=ks-vs;switch(Bs){case 0:ds=void 0;break;case 1:ds=Es(Fs,Qa[vs]);break;default:if(Fs===J.ParameterStructures.byName)throw new Error(`Received ${Bs} parameters for \'by Name\' request parameter structure.`);ds=Qa.slice(vs,ks).map(Zs=>Ws(Zs));break}}else{const _s=Qa;us=da.method,ds=Ns(da,_s);const Ds=da.numberOfParams;Ts=lr.CancellationToken.is(_s[Ds])?_s[Ds]:void 0}const ls=ga++;let Cs;Ts&&(Cs=Ts.onCancellationRequested(()=>{const _s=Ra.sender.sendCancellation(bs,ls);return _s===void 0?(ha.log(`Received no promise from cancellation strategy when cancelling id ${ls}`),Promise.resolve()):_s.catch(()=>{ha.log(`Sending cancellation messages for id ${ls} failed`)})}));const Ms={jsonrpc:$a,id:ls,method:us,params:ds};return fs(Ms),typeof Ra.sender.enableCancellation=="function"&&Ra.sender.enableCancellation(Ms),new Promise(async(_s,Ds)=>{const vs=Bs=>{_s(Bs),Ra.sender.cleanup(ls),Cs?.dispose()},Fs=Bs=>{Ds(Bs),Ra.sender.cleanup(ls),Cs?.dispose()},ks={method:us,timerStart:Date.now(),resolve:vs,reject:Fs};try{va.set(ls,ks),await pa.write(Ms)}catch(Bs){throw va.delete(ls),ks.reject(new J.ResponseError(J.ErrorCodes.MessageWriteError,Bs.message?Bs.message:"Unknown reason")),ha.error("Sending request failed."),Bs}})},onRequest:(da,Qa)=>{js();let us=null;return gi.is(da)?(us=void 0,_a=da):F.string(da)?(us=null,Qa!==void 0&&(us=da,fa.set(da,{handler:Qa,type:void 0}))):Qa!==void 0&&(us=da.method,fa.set(da.method,{type:da,handler:Qa})),{dispose:()=>{us!==null&&(us!==void 0?fa.delete(us):_a=void 0)}}},hasPendingResponse:()=>va.size>0,trace:async(da,Qa,us)=>{let ds=!1,Ts=Hi.Text;us!==void 0&&(F.boolean(us)?ds=us:(ds=us.sendNotification||!1,Ts=us.traceFormat||Hi.Text)),Na=da,za=Ts,Na===qi.Off?Ta=void 0:Ta=Qa,ds&&!Ua()&&!Wa()&&await bs.sendNotification(Qi.type,{value:qi.toString(da)})},onError:ts.event,onClose:Ka.event,onUnhandledNotification:ps.event,onDispose:xa.event,end:()=>{pa.end()},dispose:()=>{if(Wa())return;es=ua.Disposed,xa.fire(void 0);const da=new J.ResponseError(J.ErrorCodes.PendingResponseRejected,"Pending response rejected since connection got disposed");for(const Qa of va.values())Qa.reject(da);va=new Map,ya=new Map,Ca=new Set,Da=new $e.LinkedMap,F.func(pa.dispose)&&pa.dispose(),F.func(aa.dispose)&&aa.dispose()},listen:()=>{js(),Qs(),es=ua.Listening,aa.listen(os)},inspect:()=>{(0,E.default)().console.log("inspect")}};return bs.onNotification(Gi.type,da=>{if(Na===qi.Off||!Ta)return;const Qa=Na===qi.Verbose||Na===qi.Compact;Ta.log(da.message,Qa?da.verbose:void 0)}),bs.onNotification(Pr.type,da=>{const Qa=Pa.get(da.token);Qa?Qa(da.value):cs.fire(da)}),bs}D.createMessageConnection=sa})(connection$2)),connection$2}var hasRequiredApi$2;function requireApi$2(){return hasRequiredApi$2||(hasRequiredApi$2=1,(function(D){Object.defineProperty(D,"__esModule",{value:!0}),D.ProgressType=D.ProgressToken=D.createMessageConnection=D.NullLogger=D.ConnectionOptions=D.ConnectionStrategy=D.AbstractMessageBuffer=D.WriteableStreamMessageWriter=D.AbstractMessageWriter=D.MessageWriter=D.ReadableStreamMessageReader=D.AbstractMessageReader=D.MessageReader=D.SharedArrayReceiverStrategy=D.SharedArraySenderStrategy=D.CancellationToken=D.CancellationTokenSource=D.Emitter=D.Event=D.Disposable=D.LRUCache=D.Touch=D.LinkedMap=D.ParameterStructures=D.NotificationType9=D.NotificationType8=D.NotificationType7=D.NotificationType6=D.NotificationType5=D.NotificationType4=D.NotificationType3=D.NotificationType2=D.NotificationType1=D.NotificationType0=D.NotificationType=D.ErrorCodes=D.ResponseError=D.RequestType9=D.RequestType8=D.RequestType7=D.RequestType6=D.RequestType5=D.RequestType4=D.RequestType3=D.RequestType2=D.RequestType1=D.RequestType0=D.RequestType=D.Message=D.RAL=void 0,D.MessageStrategy=D.CancellationStrategy=D.CancellationSenderStrategy=D.CancellationReceiverStrategy=D.ConnectionError=D.ConnectionErrors=D.LogTraceNotification=D.SetTraceNotification=D.TraceFormat=D.TraceValues=D.Trace=void 0;const E=requireMessages$1();Object.defineProperty(D,"Message",{enumerable:!0,get:function(){return E.Message}}),Object.defineProperty(D,"RequestType",{enumerable:!0,get:function(){return E.RequestType}}),Object.defineProperty(D,"RequestType0",{enumerable:!0,get:function(){return E.RequestType0}}),Object.defineProperty(D,"RequestType1",{enumerable:!0,get:function(){return E.RequestType1}}),Object.defineProperty(D,"RequestType2",{enumerable:!0,get:function(){return E.RequestType2}}),Object.defineProperty(D,"RequestType3",{enumerable:!0,get:function(){return E.RequestType3}}),Object.defineProperty(D,"RequestType4",{enumerable:!0,get:function(){return E.RequestType4}}),Object.defineProperty(D,"RequestType5",{enumerable:!0,get:function(){return E.RequestType5}}),Object.defineProperty(D,"RequestType6",{enumerable:!0,get:function(){return E.RequestType6}}),Object.defineProperty(D,"RequestType7",{enumerable:!0,get:function(){return E.RequestType7}}),Object.defineProperty(D,"RequestType8",{enumerable:!0,get:function(){return E.RequestType8}}),Object.defineProperty(D,"RequestType9",{enumerable:!0,get:function(){return E.RequestType9}}),Object.defineProperty(D,"ResponseError",{enumerable:!0,get:function(){return E.ResponseError}}),Object.defineProperty(D,"ErrorCodes",{enumerable:!0,get:function(){return E.ErrorCodes}}),Object.defineProperty(D,"NotificationType",{enumerable:!0,get:function(){return E.NotificationType}}),Object.defineProperty(D,"NotificationType0",{enumerable:!0,get:function(){return E.NotificationType0}}),Object.defineProperty(D,"NotificationType1",{enumerable:!0,get:function(){return E.NotificationType1}}),Object.defineProperty(D,"NotificationType2",{enumerable:!0,get:function(){return E.NotificationType2}}),Object.defineProperty(D,"NotificationType3",{enumerable:!0,get:function(){return E.NotificationType3}}),Object.defineProperty(D,"NotificationType4",{enumerable:!0,get:function(){return E.NotificationType4}}),Object.defineProperty(D,"NotificationType5",{enumerable:!0,get:function(){return E.NotificationType5}}),Object.defineProperty(D,"NotificationType6",{enumerable:!0,get:function(){return E.NotificationType6}}),Object.defineProperty(D,"NotificationType7",{enumerable:!0,get:function(){return E.NotificationType7}}),Object.defineProperty(D,"NotificationType8",{enumerable:!0,get:function(){return E.NotificationType8}}),Object.defineProperty(D,"NotificationType9",{enumerable:!0,get:function(){return E.NotificationType9}}),Object.defineProperty(D,"ParameterStructures",{enumerable:!0,get:function(){return E.ParameterStructures}});const F=requireLinkedMap();Object.defineProperty(D,"LinkedMap",{enumerable:!0,get:function(){return F.LinkedMap}}),Object.defineProperty(D,"LRUCache",{enumerable:!0,get:function(){return F.LRUCache}}),Object.defineProperty(D,"Touch",{enumerable:!0,get:function(){return F.Touch}});const J=requireDisposable();Object.defineProperty(D,"Disposable",{enumerable:!0,get:function(){return J.Disposable}});const $e=requireEvents();Object.defineProperty(D,"Event",{enumerable:!0,get:function(){return $e.Event}}),Object.defineProperty(D,"Emitter",{enumerable:!0,get:function(){return $e.Emitter}});const _t=requireCancellation();Object.defineProperty(D,"CancellationTokenSource",{enumerable:!0,get:function(){return _t.CancellationTokenSource}}),Object.defineProperty(D,"CancellationToken",{enumerable:!0,get:function(){return _t.CancellationToken}});const lr=requireSharedArrayCancellation();Object.defineProperty(D,"SharedArraySenderStrategy",{enumerable:!0,get:function(){return lr.SharedArraySenderStrategy}}),Object.defineProperty(D,"SharedArrayReceiverStrategy",{enumerable:!0,get:function(){return lr.SharedArrayReceiverStrategy}});const mr=requireMessageReader();Object.defineProperty(D,"MessageReader",{enumerable:!0,get:function(){return mr.MessageReader}}),Object.defineProperty(D,"AbstractMessageReader",{enumerable:!0,get:function(){return mr.AbstractMessageReader}}),Object.defineProperty(D,"ReadableStreamMessageReader",{enumerable:!0,get:function(){return mr.ReadableStreamMessageReader}});const Or=requireMessageWriter();Object.defineProperty(D,"MessageWriter",{enumerable:!0,get:function(){return Or.MessageWriter}}),Object.defineProperty(D,"AbstractMessageWriter",{enumerable:!0,get:function(){return Or.AbstractMessageWriter}}),Object.defineProperty(D,"WriteableStreamMessageWriter",{enumerable:!0,get:function(){return Or.WriteableStreamMessageWriter}});const Pr=requireMessageBuffer();Object.defineProperty(D,"AbstractMessageBuffer",{enumerable:!0,get:function(){return Pr.AbstractMessageBuffer}});const dn=requireConnection$1();Object.defineProperty(D,"ConnectionStrategy",{enumerable:!0,get:function(){return dn.ConnectionStrategy}}),Object.defineProperty(D,"ConnectionOptions",{enumerable:!0,get:function(){return dn.ConnectionOptions}}),Object.defineProperty(D,"NullLogger",{enumerable:!0,get:function(){return dn.NullLogger}}),Object.defineProperty(D,"createMessageConnection",{enumerable:!0,get:function(){return dn.createMessageConnection}}),Object.defineProperty(D,"ProgressToken",{enumerable:!0,get:function(){return dn.ProgressToken}}),Object.defineProperty(D,"ProgressType",{enumerable:!0,get:function(){return dn.ProgressType}}),Object.defineProperty(D,"Trace",{enumerable:!0,get:function(){return dn.Trace}}),Object.defineProperty(D,"TraceValues",{enumerable:!0,get:function(){return dn.TraceValues}}),Object.defineProperty(D,"TraceFormat",{enumerable:!0,get:function(){return dn.TraceFormat}}),Object.defineProperty(D,"SetTraceNotification",{enumerable:!0,get:function(){return dn.SetTraceNotification}}),Object.defineProperty(D,"LogTraceNotification",{enumerable:!0,get:function(){return dn.LogTraceNotification}}),Object.defineProperty(D,"ConnectionErrors",{enumerable:!0,get:function(){return dn.ConnectionErrors}}),Object.defineProperty(D,"ConnectionError",{enumerable:!0,get:function(){return dn.ConnectionError}}),Object.defineProperty(D,"CancellationReceiverStrategy",{enumerable:!0,get:function(){return dn.CancellationReceiverStrategy}}),Object.defineProperty(D,"CancellationSenderStrategy",{enumerable:!0,get:function(){return dn.CancellationSenderStrategy}}),Object.defineProperty(D,"CancellationStrategy",{enumerable:!0,get:function(){return dn.CancellationStrategy}}),Object.defineProperty(D,"MessageStrategy",{enumerable:!0,get:function(){return dn.MessageStrategy}});const gi=requireRal();D.RAL=gi.default})(api$1)),api$1}var hasRequiredRil;function requireRil(){if(hasRequiredRil)return ril;hasRequiredRil=1,Object.defineProperty(ril,"__esModule",{value:!0});const D=requireApi$2();class E extends D.AbstractMessageBuffer{constructor(Or="utf-8"){super(Or),this.asciiDecoder=new TextDecoder("ascii")}emptyBuffer(){return E.emptyBuffer}fromString(Or,Pr){return new TextEncoder().encode(Or)}toString(Or,Pr){return Pr==="ascii"?this.asciiDecoder.decode(Or):new TextDecoder(Pr).decode(Or)}asNative(Or,Pr){return Pr===void 0?Or:Or.slice(0,Pr)}allocNative(Or){return new Uint8Array(Or)}}E.emptyBuffer=new Uint8Array(0);class F{constructor(Or){this.socket=Or,this._onData=new D.Emitter,this._messageListener=Pr=>{Pr.data.arrayBuffer().then(gi=>{this._onData.fire(new Uint8Array(gi))},()=>{(0,D.RAL)().console.error("Converting blob to array buffer failed.")})},this.socket.addEventListener("message",this._messageListener)}onClose(Or){return this.socket.addEventListener("close",Or),D.Disposable.create(()=>this.socket.removeEventListener("close",Or))}onError(Or){return this.socket.addEventListener("error",Or),D.Disposable.create(()=>this.socket.removeEventListener("error",Or))}onEnd(Or){return this.socket.addEventListener("end",Or),D.Disposable.create(()=>this.socket.removeEventListener("end",Or))}onData(Or){return this._onData.event(Or)}}class J{constructor(Or){this.socket=Or}onClose(Or){return this.socket.addEventListener("close",Or),D.Disposable.create(()=>this.socket.removeEventListener("close",Or))}onError(Or){return this.socket.addEventListener("error",Or),D.Disposable.create(()=>this.socket.removeEventListener("error",Or))}onEnd(Or){return this.socket.addEventListener("end",Or),D.Disposable.create(()=>this.socket.removeEventListener("end",Or))}write(Or,Pr){if(typeof Or=="string"){if(Pr!==void 0&&Pr!=="utf-8")throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${Pr}`);this.socket.send(Or)}else this.socket.send(Or);return Promise.resolve()}end(){this.socket.close()}}const $e=new TextEncoder,_t=Object.freeze({messageBuffer:Object.freeze({create:mr=>new E(mr)}),applicationJson:Object.freeze({encoder:Object.freeze({name:"application/json",encode:(mr,Or)=>{if(Or.charset!=="utf-8")throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${Or.charset}`);return Promise.resolve($e.encode(JSON.stringify(mr,void 0,0)))}}),decoder:Object.freeze({name:"application/json",decode:(mr,Or)=>{if(!(mr instanceof Uint8Array))throw new Error("In a Browser environments only Uint8Arrays are supported.");return Promise.resolve(JSON.parse(new TextDecoder(Or.charset).decode(mr)))}})}),stream:Object.freeze({asReadableStream:mr=>new F(mr),asWritableStream:mr=>new J(mr)}),console,timer:Object.freeze({setTimeout(mr,Or,...Pr){const dn=setTimeout(mr,Or,...Pr);return{dispose:()=>clearTimeout(dn)}},setImmediate(mr,...Or){const Pr=setTimeout(mr,0,...Or);return{dispose:()=>clearTimeout(Pr)}},setInterval(mr,Or,...Pr){const dn=setInterval(mr,Or,...Pr);return{dispose:()=>clearInterval(dn)}}})});function lr(){return _t}return(function(mr){function Or(){D.RAL.install(_t)}mr.install=Or})(lr||(lr={})),ril.default=lr,ril}var hasRequiredMain$2;function requireMain$2(){return hasRequiredMain$2||(hasRequiredMain$2=1,(function(D){var E=main$1&&main$1.__createBinding||(Object.create?(function(Or,Pr,dn,gi){gi===void 0&&(gi=dn);var qi=Object.getOwnPropertyDescriptor(Pr,dn);(!qi||("get"in qi?!Pr.__esModule:qi.writable||qi.configurable))&&(qi={enumerable:!0,get:function(){return Pr[dn]}}),Object.defineProperty(Or,gi,qi)}):(function(Or,Pr,dn,gi){gi===void 0&&(gi=dn),Or[gi]=Pr[dn]})),F=main$1&&main$1.__exportStar||function(Or,Pr){for(var dn in Or)dn!=="default"&&!Object.prototype.hasOwnProperty.call(Pr,dn)&&E(Pr,Or,dn)};Object.defineProperty(D,"__esModule",{value:!0}),D.createMessageConnection=D.BrowserMessageWriter=D.BrowserMessageReader=void 0,requireRil().default.install();const $e=requireApi$2();F(requireApi$2(),D);class _t extends $e.AbstractMessageReader{constructor(Pr){super(),this._onData=new $e.Emitter,this._messageListener=dn=>{this._onData.fire(dn.data)},Pr.addEventListener("error",dn=>this.fireError(dn)),Pr.onmessage=this._messageListener}listen(Pr){return this._onData.event(Pr)}}D.BrowserMessageReader=_t;class lr extends $e.AbstractMessageWriter{constructor(Pr){super(),this.port=Pr,this.errorCount=0,Pr.addEventListener("error",dn=>this.fireError(dn))}write(Pr){try{return this.port.postMessage(Pr),Promise.resolve()}catch(dn){return this.handleError(dn,Pr),Promise.reject(dn)}}handleError(Pr,dn){this.errorCount++,this.fireError(Pr,dn,this.errorCount)}end(){}}D.BrowserMessageWriter=lr;function mr(Or,Pr,dn,gi){return dn===void 0&&(dn=$e.NullLogger),$e.ConnectionStrategy.is(gi)&&(gi={connectionStrategy:gi}),(0,$e.createMessageConnection)(Or,Pr,dn,gi)}D.createMessageConnection=mr})(main$1)),main$1}var browser$2,hasRequiredBrowser$2;function requireBrowser$2(){return hasRequiredBrowser$2||(hasRequiredBrowser$2=1,browser$2=requireMain$2()),browser$2}var api={},DocumentUri;(function(D){function E(F){return typeof F=="string"}D.is=E})(DocumentUri||(DocumentUri={}));var URI;(function(D){function E(F){return typeof F=="string"}D.is=E})(URI||(URI={}));var integer;(function(D){D.MIN_VALUE=-2147483648,D.MAX_VALUE=2147483647;function E(F){return typeof F=="number"&&D.MIN_VALUE<=F&&F<=D.MAX_VALUE}D.is=E})(integer||(integer={}));var uinteger;(function(D){D.MIN_VALUE=0,D.MAX_VALUE=2147483647;function E(F){return typeof F=="number"&&D.MIN_VALUE<=F&&F<=D.MAX_VALUE}D.is=E})(uinteger||(uinteger={}));var Position;(function(D){function E(J,$e){return J===Number.MAX_VALUE&&(J=uinteger.MAX_VALUE),$e===Number.MAX_VALUE&&($e=uinteger.MAX_VALUE),{line:J,character:$e}}D.create=E;function F(J){let $e=J;return Is.objectLiteral($e)&&Is.uinteger($e.line)&&Is.uinteger($e.character)}D.is=F})(Position||(Position={}));var Range$1;(function(D){function E(J,$e,_t,lr){if(Is.uinteger(J)&&Is.uinteger($e)&&Is.uinteger(_t)&&Is.uinteger(lr))return{start:Position.create(J,$e),end:Position.create(_t,lr)};if(Position.is(J)&&Position.is($e))return{start:J,end:$e};throw new Error(`Range#create called with invalid arguments[${J}, ${$e}, ${_t}, ${lr}]`)}D.create=E;function F(J){let $e=J;return Is.objectLiteral($e)&&Position.is($e.start)&&Position.is($e.end)}D.is=F})(Range$1||(Range$1={}));var Location;(function(D){function E(J,$e){return{uri:J,range:$e}}D.create=E;function F(J){let $e=J;return Is.objectLiteral($e)&&Range$1.is($e.range)&&(Is.string($e.uri)||Is.undefined($e.uri))}D.is=F})(Location||(Location={}));var LocationLink;(function(D){function E(J,$e,_t,lr){return{targetUri:J,targetRange:$e,targetSelectionRange:_t,originSelectionRange:lr}}D.create=E;function F(J){let $e=J;return Is.objectLiteral($e)&&Range$1.is($e.targetRange)&&Is.string($e.targetUri)&&Range$1.is($e.targetSelectionRange)&&(Range$1.is($e.originSelectionRange)||Is.undefined($e.originSelectionRange))}D.is=F})(LocationLink||(LocationLink={}));var Color;(function(D){function E(J,$e,_t,lr){return{red:J,green:$e,blue:_t,alpha:lr}}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Is.numberRange($e.red,0,1)&&Is.numberRange($e.green,0,1)&&Is.numberRange($e.blue,0,1)&&Is.numberRange($e.alpha,0,1)}D.is=F})(Color||(Color={}));var ColorInformation;(function(D){function E(J,$e){return{range:J,color:$e}}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Range$1.is($e.range)&&Color.is($e.color)}D.is=F})(ColorInformation||(ColorInformation={}));var ColorPresentation;(function(D){function E(J,$e,_t){return{label:J,textEdit:$e,additionalTextEdits:_t}}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Is.string($e.label)&&(Is.undefined($e.textEdit)||TextEdit.is($e))&&(Is.undefined($e.additionalTextEdits)||Is.typedArray($e.additionalTextEdits,TextEdit.is))}D.is=F})(ColorPresentation||(ColorPresentation={}));var FoldingRangeKind;(function(D){D.Comment="comment",D.Imports="imports",D.Region="region"})(FoldingRangeKind||(FoldingRangeKind={}));var FoldingRange;(function(D){function E(J,$e,_t,lr,mr,Or){const Pr={startLine:J,endLine:$e};return Is.defined(_t)&&(Pr.startCharacter=_t),Is.defined(lr)&&(Pr.endCharacter=lr),Is.defined(mr)&&(Pr.kind=mr),Is.defined(Or)&&(Pr.collapsedText=Or),Pr}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Is.uinteger($e.startLine)&&Is.uinteger($e.startLine)&&(Is.undefined($e.startCharacter)||Is.uinteger($e.startCharacter))&&(Is.undefined($e.endCharacter)||Is.uinteger($e.endCharacter))&&(Is.undefined($e.kind)||Is.string($e.kind))}D.is=F})(FoldingRange||(FoldingRange={}));var DiagnosticRelatedInformation;(function(D){function E(J,$e){return{location:J,message:$e}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Location.is($e.location)&&Is.string($e.message)}D.is=F})(DiagnosticRelatedInformation||(DiagnosticRelatedInformation={}));var DiagnosticSeverity;(function(D){D.Error=1,D.Warning=2,D.Information=3,D.Hint=4})(DiagnosticSeverity||(DiagnosticSeverity={}));var DiagnosticTag;(function(D){D.Unnecessary=1,D.Deprecated=2})(DiagnosticTag||(DiagnosticTag={}));var CodeDescription;(function(D){function E(F){const J=F;return Is.objectLiteral(J)&&Is.string(J.href)}D.is=E})(CodeDescription||(CodeDescription={}));var Diagnostic;(function(D){function E(J,$e,_t,lr,mr,Or){let Pr={range:J,message:$e};return Is.defined(_t)&&(Pr.severity=_t),Is.defined(lr)&&(Pr.code=lr),Is.defined(mr)&&(Pr.source=mr),Is.defined(Or)&&(Pr.relatedInformation=Or),Pr}D.create=E;function F(J){var $e;let _t=J;return Is.defined(_t)&&Range$1.is(_t.range)&&Is.string(_t.message)&&(Is.number(_t.severity)||Is.undefined(_t.severity))&&(Is.integer(_t.code)||Is.string(_t.code)||Is.undefined(_t.code))&&(Is.undefined(_t.codeDescription)||Is.string(($e=_t.codeDescription)===null||$e===void 0?void 0:$e.href))&&(Is.string(_t.source)||Is.undefined(_t.source))&&(Is.undefined(_t.relatedInformation)||Is.typedArray(_t.relatedInformation,DiagnosticRelatedInformation.is))}D.is=F})(Diagnostic||(Diagnostic={}));var Command;(function(D){function E(J,$e,..._t){let lr={title:J,command:$e};return Is.defined(_t)&&_t.length>0&&(lr.arguments=_t),lr}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.string($e.title)&&Is.string($e.command)}D.is=F})(Command||(Command={}));var TextEdit;(function(D){function E(_t,lr){return{range:_t,newText:lr}}D.replace=E;function F(_t,lr){return{range:{start:_t,end:_t},newText:lr}}D.insert=F;function J(_t){return{range:_t,newText:""}}D.del=J;function $e(_t){const lr=_t;return Is.objectLiteral(lr)&&Is.string(lr.newText)&&Range$1.is(lr.range)}D.is=$e})(TextEdit||(TextEdit={}));var ChangeAnnotation;(function(D){function E(J,$e,_t){const lr={label:J};return $e!==void 0&&(lr.needsConfirmation=$e),_t!==void 0&&(lr.description=_t),lr}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Is.string($e.label)&&(Is.boolean($e.needsConfirmation)||$e.needsConfirmation===void 0)&&(Is.string($e.description)||$e.description===void 0)}D.is=F})(ChangeAnnotation||(ChangeAnnotation={}));var ChangeAnnotationIdentifier;(function(D){function E(F){const J=F;return Is.string(J)}D.is=E})(ChangeAnnotationIdentifier||(ChangeAnnotationIdentifier={}));var AnnotatedTextEdit;(function(D){function E(_t,lr,mr){return{range:_t,newText:lr,annotationId:mr}}D.replace=E;function F(_t,lr,mr){return{range:{start:_t,end:_t},newText:lr,annotationId:mr}}D.insert=F;function J(_t,lr){return{range:_t,newText:"",annotationId:lr}}D.del=J;function $e(_t){const lr=_t;return TextEdit.is(lr)&&(ChangeAnnotation.is(lr.annotationId)||ChangeAnnotationIdentifier.is(lr.annotationId))}D.is=$e})(AnnotatedTextEdit||(AnnotatedTextEdit={}));var TextDocumentEdit;(function(D){function E(J,$e){return{textDocument:J,edits:$e}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&OptionalVersionedTextDocumentIdentifier.is($e.textDocument)&&Array.isArray($e.edits)}D.is=F})(TextDocumentEdit||(TextDocumentEdit={}));var CreateFile;(function(D){function E(J,$e,_t){let lr={kind:"create",uri:J};return $e!==void 0&&($e.overwrite!==void 0||$e.ignoreIfExists!==void 0)&&(lr.options=$e),_t!==void 0&&(lr.annotationId=_t),lr}D.create=E;function F(J){let $e=J;return $e&&$e.kind==="create"&&Is.string($e.uri)&&($e.options===void 0||($e.options.overwrite===void 0||Is.boolean($e.options.overwrite))&&($e.options.ignoreIfExists===void 0||Is.boolean($e.options.ignoreIfExists)))&&($e.annotationId===void 0||ChangeAnnotationIdentifier.is($e.annotationId))}D.is=F})(CreateFile||(CreateFile={}));var RenameFile;(function(D){function E(J,$e,_t,lr){let mr={kind:"rename",oldUri:J,newUri:$e};return _t!==void 0&&(_t.overwrite!==void 0||_t.ignoreIfExists!==void 0)&&(mr.options=_t),lr!==void 0&&(mr.annotationId=lr),mr}D.create=E;function F(J){let $e=J;return $e&&$e.kind==="rename"&&Is.string($e.oldUri)&&Is.string($e.newUri)&&($e.options===void 0||($e.options.overwrite===void 0||Is.boolean($e.options.overwrite))&&($e.options.ignoreIfExists===void 0||Is.boolean($e.options.ignoreIfExists)))&&($e.annotationId===void 0||ChangeAnnotationIdentifier.is($e.annotationId))}D.is=F})(RenameFile||(RenameFile={}));var DeleteFile;(function(D){function E(J,$e,_t){let lr={kind:"delete",uri:J};return $e!==void 0&&($e.recursive!==void 0||$e.ignoreIfNotExists!==void 0)&&(lr.options=$e),_t!==void 0&&(lr.annotationId=_t),lr}D.create=E;function F(J){let $e=J;return $e&&$e.kind==="delete"&&Is.string($e.uri)&&($e.options===void 0||($e.options.recursive===void 0||Is.boolean($e.options.recursive))&&($e.options.ignoreIfNotExists===void 0||Is.boolean($e.options.ignoreIfNotExists)))&&($e.annotationId===void 0||ChangeAnnotationIdentifier.is($e.annotationId))}D.is=F})(DeleteFile||(DeleteFile={}));var WorkspaceEdit;(function(D){function E(F){let J=F;return J&&(J.changes!==void 0||J.documentChanges!==void 0)&&(J.documentChanges===void 0||J.documentChanges.every($e=>Is.string($e.kind)?CreateFile.is($e)||RenameFile.is($e)||DeleteFile.is($e):TextDocumentEdit.is($e)))}D.is=E})(WorkspaceEdit||(WorkspaceEdit={}));class TextEditChangeImpl{constructor(E,F){this.edits=E,this.changeAnnotations=F}insert(E,F,J){let $e,_t;if(J===void 0?$e=TextEdit.insert(E,F):ChangeAnnotationIdentifier.is(J)?(_t=J,$e=AnnotatedTextEdit.insert(E,F,J)):(this.assertChangeAnnotations(this.changeAnnotations),_t=this.changeAnnotations.manage(J),$e=AnnotatedTextEdit.insert(E,F,_t)),this.edits.push($e),_t!==void 0)return _t}replace(E,F,J){let $e,_t;if(J===void 0?$e=TextEdit.replace(E,F):ChangeAnnotationIdentifier.is(J)?(_t=J,$e=AnnotatedTextEdit.replace(E,F,J)):(this.assertChangeAnnotations(this.changeAnnotations),_t=this.changeAnnotations.manage(J),$e=AnnotatedTextEdit.replace(E,F,_t)),this.edits.push($e),_t!==void 0)return _t}delete(E,F){let J,$e;if(F===void 0?J=TextEdit.del(E):ChangeAnnotationIdentifier.is(F)?($e=F,J=AnnotatedTextEdit.del(E,F)):(this.assertChangeAnnotations(this.changeAnnotations),$e=this.changeAnnotations.manage(F),J=AnnotatedTextEdit.del(E,$e)),this.edits.push(J),$e!==void 0)return $e}add(E){this.edits.push(E)}all(){return this.edits}clear(){this.edits.splice(0,this.edits.length)}assertChangeAnnotations(E){if(E===void 0)throw new Error("Text edit change is not configured to manage change annotations.")}}class ChangeAnnotations{constructor(E){this._annotations=E===void 0?Object.create(null):E,this._counter=0,this._size=0}all(){return this._annotations}get size(){return this._size}manage(E,F){let J;if(ChangeAnnotationIdentifier.is(E)?J=E:(J=this.nextId(),F=E),this._annotations[J]!==void 0)throw new Error(`Id ${J} is already in use.`);if(F===void 0)throw new Error(`No annotation provided for id ${J}`);return this._annotations[J]=F,this._size++,J}nextId(){return this._counter++,this._counter.toString()}}class WorkspaceChange{constructor(E){this._textEditChanges=Object.create(null),E!==void 0?(this._workspaceEdit=E,E.documentChanges?(this._changeAnnotations=new ChangeAnnotations(E.changeAnnotations),E.changeAnnotations=this._changeAnnotations.all(),E.documentChanges.forEach(F=>{if(TextDocumentEdit.is(F)){const J=new TextEditChangeImpl(F.edits,this._changeAnnotations);this._textEditChanges[F.textDocument.uri]=J}})):E.changes&&Object.keys(E.changes).forEach(F=>{const J=new TextEditChangeImpl(E.changes[F]);this._textEditChanges[F]=J})):this._workspaceEdit={}}get edit(){return this.initDocumentChanges(),this._changeAnnotations!==void 0&&(this._changeAnnotations.size===0?this._workspaceEdit.changeAnnotations=void 0:this._workspaceEdit.changeAnnotations=this._changeAnnotations.all()),this._workspaceEdit}getTextEditChange(E){if(OptionalVersionedTextDocumentIdentifier.is(E)){if(this.initDocumentChanges(),this._workspaceEdit.documentChanges===void 0)throw new Error("Workspace edit is not configured for document changes.");const F={uri:E.uri,version:E.version};let J=this._textEditChanges[F.uri];if(!J){const $e=[],_t={textDocument:F,edits:$e};this._workspaceEdit.documentChanges.push(_t),J=new TextEditChangeImpl($e,this._changeAnnotations),this._textEditChanges[F.uri]=J}return J}else{if(this.initChanges(),this._workspaceEdit.changes===void 0)throw new Error("Workspace edit is not configured for normal text edit changes.");let F=this._textEditChanges[E];if(!F){let J=[];this._workspaceEdit.changes[E]=J,F=new TextEditChangeImpl(J),this._textEditChanges[E]=F}return F}}initDocumentChanges(){this._workspaceEdit.documentChanges===void 0&&this._workspaceEdit.changes===void 0&&(this._changeAnnotations=new ChangeAnnotations,this._workspaceEdit.documentChanges=[],this._workspaceEdit.changeAnnotations=this._changeAnnotations.all())}initChanges(){this._workspaceEdit.documentChanges===void 0&&this._workspaceEdit.changes===void 0&&(this._workspaceEdit.changes=Object.create(null))}createFile(E,F,J){if(this.initDocumentChanges(),this._workspaceEdit.documentChanges===void 0)throw new Error("Workspace edit is not configured for document changes.");let $e;ChangeAnnotation.is(F)||ChangeAnnotationIdentifier.is(F)?$e=F:J=F;let _t,lr;if($e===void 0?_t=CreateFile.create(E,J):(lr=ChangeAnnotationIdentifier.is($e)?$e:this._changeAnnotations.manage($e),_t=CreateFile.create(E,J,lr)),this._workspaceEdit.documentChanges.push(_t),lr!==void 0)return lr}renameFile(E,F,J,$e){if(this.initDocumentChanges(),this._workspaceEdit.documentChanges===void 0)throw new Error("Workspace edit is not configured for document changes.");let _t;ChangeAnnotation.is(J)||ChangeAnnotationIdentifier.is(J)?_t=J:$e=J;let lr,mr;if(_t===void 0?lr=RenameFile.create(E,F,$e):(mr=ChangeAnnotationIdentifier.is(_t)?_t:this._changeAnnotations.manage(_t),lr=RenameFile.create(E,F,$e,mr)),this._workspaceEdit.documentChanges.push(lr),mr!==void 0)return mr}deleteFile(E,F,J){if(this.initDocumentChanges(),this._workspaceEdit.documentChanges===void 0)throw new Error("Workspace edit is not configured for document changes.");let $e;ChangeAnnotation.is(F)||ChangeAnnotationIdentifier.is(F)?$e=F:J=F;let _t,lr;if($e===void 0?_t=DeleteFile.create(E,J):(lr=ChangeAnnotationIdentifier.is($e)?$e:this._changeAnnotations.manage($e),_t=DeleteFile.create(E,J,lr)),this._workspaceEdit.documentChanges.push(_t),lr!==void 0)return lr}}var TextDocumentIdentifier;(function(D){function E(J){return{uri:J}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.string($e.uri)}D.is=F})(TextDocumentIdentifier||(TextDocumentIdentifier={}));var VersionedTextDocumentIdentifier;(function(D){function E(J,$e){return{uri:J,version:$e}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.string($e.uri)&&Is.integer($e.version)}D.is=F})(VersionedTextDocumentIdentifier||(VersionedTextDocumentIdentifier={}));var OptionalVersionedTextDocumentIdentifier;(function(D){function E(J,$e){return{uri:J,version:$e}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.string($e.uri)&&($e.version===null||Is.integer($e.version))}D.is=F})(OptionalVersionedTextDocumentIdentifier||(OptionalVersionedTextDocumentIdentifier={}));var TextDocumentItem;(function(D){function E(J,$e,_t,lr){return{uri:J,languageId:$e,version:_t,text:lr}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.string($e.uri)&&Is.string($e.languageId)&&Is.integer($e.version)&&Is.string($e.text)}D.is=F})(TextDocumentItem||(TextDocumentItem={}));var MarkupKind;(function(D){D.PlainText="plaintext",D.Markdown="markdown";function E(F){const J=F;return J===D.PlainText||J===D.Markdown}D.is=E})(MarkupKind||(MarkupKind={}));var MarkupContent;(function(D){function E(F){const J=F;return Is.objectLiteral(F)&&MarkupKind.is(J.kind)&&Is.string(J.value)}D.is=E})(MarkupContent||(MarkupContent={}));var CompletionItemKind;(function(D){D.Text=1,D.Method=2,D.Function=3,D.Constructor=4,D.Field=5,D.Variable=6,D.Class=7,D.Interface=8,D.Module=9,D.Property=10,D.Unit=11,D.Value=12,D.Enum=13,D.Keyword=14,D.Snippet=15,D.Color=16,D.File=17,D.Reference=18,D.Folder=19,D.EnumMember=20,D.Constant=21,D.Struct=22,D.Event=23,D.Operator=24,D.TypeParameter=25})(CompletionItemKind||(CompletionItemKind={}));var InsertTextFormat;(function(D){D.PlainText=1,D.Snippet=2})(InsertTextFormat||(InsertTextFormat={}));var CompletionItemTag;(function(D){D.Deprecated=1})(CompletionItemTag||(CompletionItemTag={}));var InsertReplaceEdit;(function(D){function E(J,$e,_t){return{newText:J,insert:$e,replace:_t}}D.create=E;function F(J){const $e=J;return $e&&Is.string($e.newText)&&Range$1.is($e.insert)&&Range$1.is($e.replace)}D.is=F})(InsertReplaceEdit||(InsertReplaceEdit={}));var InsertTextMode;(function(D){D.asIs=1,D.adjustIndentation=2})(InsertTextMode||(InsertTextMode={}));var CompletionItemLabelDetails;(function(D){function E(F){const J=F;return J&&(Is.string(J.detail)||J.detail===void 0)&&(Is.string(J.description)||J.description===void 0)}D.is=E})(CompletionItemLabelDetails||(CompletionItemLabelDetails={}));var CompletionItem;(function(D){function E(F){return{label:F}}D.create=E})(CompletionItem||(CompletionItem={}));var CompletionList;(function(D){function E(F,J){return{items:F||[],isIncomplete:!!J}}D.create=E})(CompletionList||(CompletionList={}));var MarkedString;(function(D){function E(J){return J.replace(/[\\\\`*_{}[\\]()#+\\-.!]/g,"\\\\$&")}D.fromPlainText=E;function F(J){const $e=J;return Is.string($e)||Is.objectLiteral($e)&&Is.string($e.language)&&Is.string($e.value)}D.is=F})(MarkedString||(MarkedString={}));var Hover;(function(D){function E(F){let J=F;return!!J&&Is.objectLiteral(J)&&(MarkupContent.is(J.contents)||MarkedString.is(J.contents)||Is.typedArray(J.contents,MarkedString.is))&&(F.range===void 0||Range$1.is(F.range))}D.is=E})(Hover||(Hover={}));var ParameterInformation;(function(D){function E(F,J){return J?{label:F,documentation:J}:{label:F}}D.create=E})(ParameterInformation||(ParameterInformation={}));var SignatureInformation;(function(D){function E(F,J,...$e){let _t={label:F};return Is.defined(J)&&(_t.documentation=J),Is.defined($e)?_t.parameters=$e:_t.parameters=[],_t}D.create=E})(SignatureInformation||(SignatureInformation={}));var DocumentHighlightKind;(function(D){D.Text=1,D.Read=2,D.Write=3})(DocumentHighlightKind||(DocumentHighlightKind={}));var DocumentHighlight;(function(D){function E(F,J){let $e={range:F};return Is.number(J)&&($e.kind=J),$e}D.create=E})(DocumentHighlight||(DocumentHighlight={}));var SymbolKind;(function(D){D.File=1,D.Module=2,D.Namespace=3,D.Package=4,D.Class=5,D.Method=6,D.Property=7,D.Field=8,D.Constructor=9,D.Enum=10,D.Interface=11,D.Function=12,D.Variable=13,D.Constant=14,D.String=15,D.Number=16,D.Boolean=17,D.Array=18,D.Object=19,D.Key=20,D.Null=21,D.EnumMember=22,D.Struct=23,D.Event=24,D.Operator=25,D.TypeParameter=26})(SymbolKind||(SymbolKind={}));var SymbolTag;(function(D){D.Deprecated=1})(SymbolTag||(SymbolTag={}));var SymbolInformation;(function(D){function E(F,J,$e,_t,lr){let mr={name:F,kind:J,location:{uri:_t,range:$e}};return lr&&(mr.containerName=lr),mr}D.create=E})(SymbolInformation||(SymbolInformation={}));var WorkspaceSymbol;(function(D){function E(F,J,$e,_t){return _t!==void 0?{name:F,kind:J,location:{uri:$e,range:_t}}:{name:F,kind:J,location:{uri:$e}}}D.create=E})(WorkspaceSymbol||(WorkspaceSymbol={}));var DocumentSymbol;(function(D){function E(J,$e,_t,lr,mr,Or){let Pr={name:J,detail:$e,kind:_t,range:lr,selectionRange:mr};return Or!==void 0&&(Pr.children=Or),Pr}D.create=E;function F(J){let $e=J;return $e&&Is.string($e.name)&&Is.number($e.kind)&&Range$1.is($e.range)&&Range$1.is($e.selectionRange)&&($e.detail===void 0||Is.string($e.detail))&&($e.deprecated===void 0||Is.boolean($e.deprecated))&&($e.children===void 0||Array.isArray($e.children))&&($e.tags===void 0||Array.isArray($e.tags))}D.is=F})(DocumentSymbol||(DocumentSymbol={}));var CodeActionKind;(function(D){D.Empty="",D.QuickFix="quickfix",D.Refactor="refactor",D.RefactorExtract="refactor.extract",D.RefactorInline="refactor.inline",D.RefactorRewrite="refactor.rewrite",D.Source="source",D.SourceOrganizeImports="source.organizeImports",D.SourceFixAll="source.fixAll"})(CodeActionKind||(CodeActionKind={}));var CodeActionTriggerKind;(function(D){D.Invoked=1,D.Automatic=2})(CodeActionTriggerKind||(CodeActionTriggerKind={}));var CodeActionContext;(function(D){function E(J,$e,_t){let lr={diagnostics:J};return $e!=null&&(lr.only=$e),_t!=null&&(lr.triggerKind=_t),lr}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.typedArray($e.diagnostics,Diagnostic.is)&&($e.only===void 0||Is.typedArray($e.only,Is.string))&&($e.triggerKind===void 0||$e.triggerKind===CodeActionTriggerKind.Invoked||$e.triggerKind===CodeActionTriggerKind.Automatic)}D.is=F})(CodeActionContext||(CodeActionContext={}));var CodeAction;(function(D){function E(J,$e,_t){let lr={title:J},mr=!0;return typeof $e=="string"?(mr=!1,lr.kind=$e):Command.is($e)?lr.command=$e:lr.edit=$e,mr&&_t!==void 0&&(lr.kind=_t),lr}D.create=E;function F(J){let $e=J;return $e&&Is.string($e.title)&&($e.diagnostics===void 0||Is.typedArray($e.diagnostics,Diagnostic.is))&&($e.kind===void 0||Is.string($e.kind))&&($e.edit!==void 0||$e.command!==void 0)&&($e.command===void 0||Command.is($e.command))&&($e.isPreferred===void 0||Is.boolean($e.isPreferred))&&($e.edit===void 0||WorkspaceEdit.is($e.edit))}D.is=F})(CodeAction||(CodeAction={}));var CodeLens;(function(D){function E(J,$e){let _t={range:J};return Is.defined($e)&&(_t.data=$e),_t}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Range$1.is($e.range)&&(Is.undefined($e.command)||Command.is($e.command))}D.is=F})(CodeLens||(CodeLens={}));var FormattingOptions;(function(D){function E(J,$e){return{tabSize:J,insertSpaces:$e}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Is.uinteger($e.tabSize)&&Is.boolean($e.insertSpaces)}D.is=F})(FormattingOptions||(FormattingOptions={}));var DocumentLink;(function(D){function E(J,$e,_t){return{range:J,target:$e,data:_t}}D.create=E;function F(J){let $e=J;return Is.defined($e)&&Range$1.is($e.range)&&(Is.undefined($e.target)||Is.string($e.target))}D.is=F})(DocumentLink||(DocumentLink={}));var SelectionRange;(function(D){function E(J,$e){return{range:J,parent:$e}}D.create=E;function F(J){let $e=J;return Is.objectLiteral($e)&&Range$1.is($e.range)&&($e.parent===void 0||D.is($e.parent))}D.is=F})(SelectionRange||(SelectionRange={}));var SemanticTokenTypes;(function(D){D.namespace="namespace",D.type="type",D.class="class",D.enum="enum",D.interface="interface",D.struct="struct",D.typeParameter="typeParameter",D.parameter="parameter",D.variable="variable",D.property="property",D.enumMember="enumMember",D.event="event",D.function="function",D.method="method",D.macro="macro",D.keyword="keyword",D.modifier="modifier",D.comment="comment",D.string="string",D.number="number",D.regexp="regexp",D.operator="operator",D.decorator="decorator"})(SemanticTokenTypes||(SemanticTokenTypes={}));var SemanticTokenModifiers;(function(D){D.declaration="declaration",D.definition="definition",D.readonly="readonly",D.static="static",D.deprecated="deprecated",D.abstract="abstract",D.async="async",D.modification="modification",D.documentation="documentation",D.defaultLibrary="defaultLibrary"})(SemanticTokenModifiers||(SemanticTokenModifiers={}));var SemanticTokens;(function(D){function E(F){const J=F;return Is.objectLiteral(J)&&(J.resultId===void 0||typeof J.resultId=="string")&&Array.isArray(J.data)&&(J.data.length===0||typeof J.data[0]=="number")}D.is=E})(SemanticTokens||(SemanticTokens={}));var InlineValueText;(function(D){function E(J,$e){return{range:J,text:$e}}D.create=E;function F(J){const $e=J;return $e!=null&&Range$1.is($e.range)&&Is.string($e.text)}D.is=F})(InlineValueText||(InlineValueText={}));var InlineValueVariableLookup;(function(D){function E(J,$e,_t){return{range:J,variableName:$e,caseSensitiveLookup:_t}}D.create=E;function F(J){const $e=J;return $e!=null&&Range$1.is($e.range)&&Is.boolean($e.caseSensitiveLookup)&&(Is.string($e.variableName)||$e.variableName===void 0)}D.is=F})(InlineValueVariableLookup||(InlineValueVariableLookup={}));var InlineValueEvaluatableExpression;(function(D){function E(J,$e){return{range:J,expression:$e}}D.create=E;function F(J){const $e=J;return $e!=null&&Range$1.is($e.range)&&(Is.string($e.expression)||$e.expression===void 0)}D.is=F})(InlineValueEvaluatableExpression||(InlineValueEvaluatableExpression={}));var InlineValueContext;(function(D){function E(J,$e){return{frameId:J,stoppedLocation:$e}}D.create=E;function F(J){const $e=J;return Is.defined($e)&&Range$1.is(J.stoppedLocation)}D.is=F})(InlineValueContext||(InlineValueContext={}));var InlayHintKind;(function(D){D.Type=1,D.Parameter=2;function E(F){return F===1||F===2}D.is=E})(InlayHintKind||(InlayHintKind={}));var InlayHintLabelPart;(function(D){function E(J){return{value:J}}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&($e.tooltip===void 0||Is.string($e.tooltip)||MarkupContent.is($e.tooltip))&&($e.location===void 0||Location.is($e.location))&&($e.command===void 0||Command.is($e.command))}D.is=F})(InlayHintLabelPart||(InlayHintLabelPart={}));var InlayHint;(function(D){function E(J,$e,_t){const lr={position:J,label:$e};return _t!==void 0&&(lr.kind=_t),lr}D.create=E;function F(J){const $e=J;return Is.objectLiteral($e)&&Position.is($e.position)&&(Is.string($e.label)||Is.typedArray($e.label,InlayHintLabelPart.is))&&($e.kind===void 0||InlayHintKind.is($e.kind))&&$e.textEdits===void 0||Is.typedArray($e.textEdits,TextEdit.is)&&($e.tooltip===void 0||Is.string($e.tooltip)||MarkupContent.is($e.tooltip))&&($e.paddingLeft===void 0||Is.boolean($e.paddingLeft))&&($e.paddingRight===void 0||Is.boolean($e.paddingRight))}D.is=F})(InlayHint||(InlayHint={}));var StringValue;(function(D){function E(F){return{kind:"snippet",value:F}}D.createSnippet=E})(StringValue||(StringValue={}));var InlineCompletionItem;(function(D){function E(F,J,$e,_t){return{insertText:F,filterText:J,range:$e,command:_t}}D.create=E})(InlineCompletionItem||(InlineCompletionItem={}));var InlineCompletionList;(function(D){function E(F){return{items:F}}D.create=E})(InlineCompletionList||(InlineCompletionList={}));var InlineCompletionTriggerKind;(function(D){D.Invoked=0,D.Automatic=1})(InlineCompletionTriggerKind||(InlineCompletionTriggerKind={}));var SelectedCompletionInfo;(function(D){function E(F,J){return{range:F,text:J}}D.create=E})(SelectedCompletionInfo||(SelectedCompletionInfo={}));var InlineCompletionContext;(function(D){function E(F,J){return{triggerKind:F,selectedCompletionInfo:J}}D.create=E})(InlineCompletionContext||(InlineCompletionContext={}));var WorkspaceFolder;(function(D){function E(F){const J=F;return Is.objectLiteral(J)&&URI.is(J.uri)&&Is.string(J.name)}D.is=E})(WorkspaceFolder||(WorkspaceFolder={}));const EOL=[`\n`,`\\r\n`,"\\r"];var TextDocument$1;(function(D){function E(_t,lr,mr,Or){return new FullTextDocument$1(_t,lr,mr,Or)}D.create=E;function F(_t){let lr=_t;return!!(Is.defined(lr)&&Is.string(lr.uri)&&(Is.undefined(lr.languageId)||Is.string(lr.languageId))&&Is.uinteger(lr.lineCount)&&Is.func(lr.getText)&&Is.func(lr.positionAt)&&Is.func(lr.offsetAt))}D.is=F;function J(_t,lr){let mr=_t.getText(),Or=$e(lr,(dn,gi)=>{let qi=dn.range.start.line-gi.range.start.line;return qi===0?dn.range.start.character-gi.range.start.character:qi}),Pr=mr.length;for(let dn=Or.length-1;dn>=0;dn--){let gi=Or[dn],qi=_t.offsetAt(gi.range.start),zi=_t.offsetAt(gi.range.end);if(zi<=Pr)mr=mr.substring(0,qi)+gi.newText+mr.substring(zi,mr.length);else throw new Error("Overlapping edit");Pr=qi}return mr}D.applyEdits=J;function $e(_t,lr){if(_t.length<=1)return _t;const mr=_t.length/2|0,Or=_t.slice(0,mr),Pr=_t.slice(mr);$e(Or,lr),$e(Pr,lr);let dn=0,gi=0,qi=0;for(;dn<Or.length&&gi<Pr.length;)lr(Or[dn],Pr[gi])<=0?_t[qi++]=Or[dn++]:_t[qi++]=Pr[gi++];for(;dn<Or.length;)_t[qi++]=Or[dn++];for(;gi<Pr.length;)_t[qi++]=Pr[gi++];return _t}})(TextDocument$1||(TextDocument$1={}));let FullTextDocument$1=class{constructor(E,F,J,$e){this._uri=E,this._languageId=F,this._version=J,this._content=$e,this._lineOffsets=void 0}get uri(){return this._uri}get languageId(){return this._languageId}get version(){return this._version}getText(E){if(E){let F=this.offsetAt(E.start),J=this.offsetAt(E.end);return this._content.substring(F,J)}return this._content}update(E,F){this._content=E.text,this._version=F,this._lineOffsets=void 0}getLineOffsets(){if(this._lineOffsets===void 0){let E=[],F=this._content,J=!0;for(let $e=0;$e<F.length;$e++){J&&(E.push($e),J=!1);let _t=F.charAt($e);J=_t==="\\r"||_t===`\n`,_t==="\\r"&&$e+1<F.length&&F.charAt($e+1)===`\n`&&$e++}J&&F.length>0&&E.push(F.length),this._lineOffsets=E}return this._lineOffsets}positionAt(E){E=Math.max(Math.min(E,this._content.length),0);let F=this.getLineOffsets(),J=0,$e=F.length;if($e===0)return Position.create(0,E);for(;J<$e;){let lr=Math.floor((J+$e)/2);F[lr]>E?$e=lr:J=lr+1}let _t=J-1;return Position.create(_t,E-F[_t])}offsetAt(E){let F=this.getLineOffsets();if(E.line>=F.length)return this._content.length;if(E.line<0)return 0;let J=F[E.line],$e=E.line+1<F.length?F[E.line+1]:this._content.length;return Math.max(Math.min(J+E.character,$e),J)}get lineCount(){return this.getLineOffsets().length}};var Is;(function(D){const E=Object.prototype.toString;function F(zi){return typeof zi<"u"}D.defined=F;function J(zi){return typeof zi>"u"}D.undefined=J;function $e(zi){return zi===!0||zi===!1}D.boolean=$e;function _t(zi){return E.call(zi)==="[object String]"}D.string=_t;function lr(zi){return E.call(zi)==="[object Number]"}D.number=lr;function mr(zi,Hi,Qi){return E.call(zi)==="[object Number]"&&Hi<=zi&&zi<=Qi}D.numberRange=mr;function Or(zi){return E.call(zi)==="[object Number]"&&-2147483648<=zi&&zi<=2147483647}D.integer=Or;function Pr(zi){return E.call(zi)==="[object Number]"&&0<=zi&&zi<=2147483647}D.uinteger=Pr;function dn(zi){return E.call(zi)==="[object Function]"}D.func=dn;function gi(zi){return zi!==null&&typeof zi=="object"}D.objectLiteral=gi;function qi(zi,Hi){return Array.isArray(zi)&&zi.every(Hi)}D.typedArray=qi})(Is||(Is={}));const main=Object.freeze(Object.defineProperty({__proto__:null,get AnnotatedTextEdit(){return AnnotatedTextEdit},get ChangeAnnotation(){return ChangeAnnotation},get ChangeAnnotationIdentifier(){return ChangeAnnotationIdentifier},get CodeAction(){return CodeAction},get CodeActionContext(){return CodeActionContext},get CodeActionKind(){return CodeActionKind},get CodeActionTriggerKind(){return CodeActionTriggerKind},get CodeDescription(){return CodeDescription},get CodeLens(){return CodeLens},get Color(){return Color},get ColorInformation(){return ColorInformation},get ColorPresentation(){return ColorPresentation},get Command(){return Command},get CompletionItem(){return CompletionItem},get CompletionItemKind(){return CompletionItemKind},get CompletionItemLabelDetails(){return CompletionItemLabelDetails},get CompletionItemTag(){return CompletionItemTag},get CompletionList(){return CompletionList},get CreateFile(){return CreateFile},get DeleteFile(){return DeleteFile},get Diagnostic(){return Diagnostic},get DiagnosticRelatedInformation(){return DiagnosticRelatedInformation},get DiagnosticSeverity(){return DiagnosticSeverity},get DiagnosticTag(){return DiagnosticTag},get DocumentHighlight(){return DocumentHighlight},get DocumentHighlightKind(){return DocumentHighlightKind},get DocumentLink(){return DocumentLink},get DocumentSymbol(){return DocumentSymbol},get DocumentUri(){return DocumentUri},EOL,get FoldingRange(){return FoldingRange},get FoldingRangeKind(){return FoldingRangeKind},get FormattingOptions(){return FormattingOptions},get Hover(){return Hover},get InlayHint(){return InlayHint},get InlayHintKind(){return InlayHintKind},get InlayHintLabelPart(){return InlayHintLabelPart},get InlineCompletionContext(){return InlineCompletionContext},get InlineCompletionItem(){return InlineCompletionItem},get InlineCompletionList(){return InlineCompletionList},get InlineCompletionTriggerKind(){return InlineCompletionTriggerKind},get InlineValueContext(){return InlineValueContext},get InlineValueEvaluatableExpression(){return InlineValueEvaluatableExpression},get InlineValueText(){return InlineValueText},get InlineValueVariableLookup(){return InlineValueVariableLookup},get InsertReplaceEdit(){return InsertReplaceEdit},get InsertTextFormat(){return InsertTextFormat},get InsertTextMode(){return InsertTextMode},get Location(){return Location},get LocationLink(){return LocationLink},get MarkedString(){return MarkedString},get MarkupContent(){return MarkupContent},get MarkupKind(){return MarkupKind},get OptionalVersionedTextDocumentIdentifier(){return OptionalVersionedTextDocumentIdentifier},get ParameterInformation(){return ParameterInformation},get Position(){return Position},get Range(){return Range$1},get RenameFile(){return RenameFile},get SelectedCompletionInfo(){return SelectedCompletionInfo},get SelectionRange(){return SelectionRange},get SemanticTokenModifiers(){return SemanticTokenModifiers},get SemanticTokenTypes(){return SemanticTokenTypes},get SemanticTokens(){return SemanticTokens},get SignatureInformation(){return SignatureInformation},get StringValue(){return StringValue},get SymbolInformation(){return SymbolInformation},get SymbolKind(){return SymbolKind},get SymbolTag(){return SymbolTag},get TextDocument(){return TextDocument$1},get TextDocumentEdit(){return TextDocumentEdit},get TextDocumentIdentifier(){return TextDocumentIdentifier},get TextDocumentItem(){return TextDocumentItem},get TextEdit(){return TextEdit},get URI(){return URI},get VersionedTextDocumentIdentifier(){return VersionedTextDocumentIdentifier},WorkspaceChange,get WorkspaceEdit(){return WorkspaceEdit},get WorkspaceFolder(){return WorkspaceFolder},get WorkspaceSymbol(){return WorkspaceSymbol},get integer(){return integer},get uinteger(){return uinteger}},Symbol.toStringTag,{value:"Module"})),require$$1=getAugmentedNamespace(main);var messages={},hasRequiredMessages;function requireMessages(){if(hasRequiredMessages)return messages;hasRequiredMessages=1,Object.defineProperty(messages,"__esModule",{value:!0}),messages.ProtocolNotificationType=messages.ProtocolNotificationType0=messages.ProtocolRequestType=messages.ProtocolRequestType0=messages.RegistrationType=messages.MessageDirection=void 0;const D=requireMain$2();var E;(function(mr){mr.clientToServer="clientToServer",mr.serverToClient="serverToClient",mr.both="both"})(E||(messages.MessageDirection=E={}));class F{constructor(Or){this.method=Or}}messages.RegistrationType=F;class J extends D.RequestType0{constructor(Or){super(Or)}}messages.ProtocolRequestType0=J;class $e extends D.RequestType{constructor(Or){super(Or,D.ParameterStructures.byName)}}messages.ProtocolRequestType=$e;class _t extends D.NotificationType0{constructor(Or){super(Or)}}messages.ProtocolNotificationType0=_t;class lr extends D.NotificationType{constructor(Or){super(Or,D.ParameterStructures.byName)}}return messages.ProtocolNotificationType=lr,messages}var protocol={},is$1={},hasRequiredIs$1;function requireIs$1(){if(hasRequiredIs$1)return is$1;hasRequiredIs$1=1,Object.defineProperty(is$1,"__esModule",{value:!0}),is$1.objectLiteral=is$1.typedArray=is$1.stringArray=is$1.array=is$1.func=is$1.error=is$1.number=is$1.string=is$1.boolean=void 0;function D(Pr){return Pr===!0||Pr===!1}is$1.boolean=D;function E(Pr){return typeof Pr=="string"||Pr instanceof String}is$1.string=E;function F(Pr){return typeof Pr=="number"||Pr instanceof Number}is$1.number=F;function J(Pr){return Pr instanceof Error}is$1.error=J;function $e(Pr){return typeof Pr=="function"}is$1.func=$e;function _t(Pr){return Array.isArray(Pr)}is$1.array=_t;function lr(Pr){return _t(Pr)&&Pr.every(dn=>E(dn))}is$1.stringArray=lr;function mr(Pr,dn){return Array.isArray(Pr)&&Pr.every(dn)}is$1.typedArray=mr;function Or(Pr){return Pr!==null&&typeof Pr=="object"}return is$1.objectLiteral=Or,is$1}var protocol_implementation={},hasRequiredProtocol_implementation;function requireProtocol_implementation(){if(hasRequiredProtocol_implementation)return protocol_implementation;hasRequiredProtocol_implementation=1,Object.defineProperty(protocol_implementation,"__esModule",{value:!0}),protocol_implementation.ImplementationRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/implementation",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_implementation.ImplementationRequest=E={})),protocol_implementation}var protocol_typeDefinition={},hasRequiredProtocol_typeDefinition;function requireProtocol_typeDefinition(){if(hasRequiredProtocol_typeDefinition)return protocol_typeDefinition;hasRequiredProtocol_typeDefinition=1,Object.defineProperty(protocol_typeDefinition,"__esModule",{value:!0}),protocol_typeDefinition.TypeDefinitionRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/typeDefinition",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_typeDefinition.TypeDefinitionRequest=E={})),protocol_typeDefinition}var protocol_workspaceFolder={},hasRequiredProtocol_workspaceFolder;function requireProtocol_workspaceFolder(){if(hasRequiredProtocol_workspaceFolder)return protocol_workspaceFolder;hasRequiredProtocol_workspaceFolder=1,Object.defineProperty(protocol_workspaceFolder,"__esModule",{value:!0}),protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification=protocol_workspaceFolder.WorkspaceFoldersRequest=void 0;const D=requireMessages();var E;(function(J){J.method="workspace/workspaceFolders",J.messageDirection=D.MessageDirection.serverToClient,J.type=new D.ProtocolRequestType0(J.method)})(E||(protocol_workspaceFolder.WorkspaceFoldersRequest=E={}));var F;return(function(J){J.method="workspace/didChangeWorkspaceFolders",J.messageDirection=D.MessageDirection.clientToServer,J.type=new D.ProtocolNotificationType(J.method)})(F||(protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification=F={})),protocol_workspaceFolder}var protocol_configuration={},hasRequiredProtocol_configuration;function requireProtocol_configuration(){if(hasRequiredProtocol_configuration)return protocol_configuration;hasRequiredProtocol_configuration=1,Object.defineProperty(protocol_configuration,"__esModule",{value:!0}),protocol_configuration.ConfigurationRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="workspace/configuration",F.messageDirection=D.MessageDirection.serverToClient,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_configuration.ConfigurationRequest=E={})),protocol_configuration}var protocol_colorProvider={},hasRequiredProtocol_colorProvider;function requireProtocol_colorProvider(){if(hasRequiredProtocol_colorProvider)return protocol_colorProvider;hasRequiredProtocol_colorProvider=1,Object.defineProperty(protocol_colorProvider,"__esModule",{value:!0}),protocol_colorProvider.ColorPresentationRequest=protocol_colorProvider.DocumentColorRequest=void 0;const D=requireMessages();var E;(function(J){J.method="textDocument/documentColor",J.messageDirection=D.MessageDirection.clientToServer,J.type=new D.ProtocolRequestType(J.method)})(E||(protocol_colorProvider.DocumentColorRequest=E={}));var F;return(function(J){J.method="textDocument/colorPresentation",J.messageDirection=D.MessageDirection.clientToServer,J.type=new D.ProtocolRequestType(J.method)})(F||(protocol_colorProvider.ColorPresentationRequest=F={})),protocol_colorProvider}var protocol_foldingRange={},hasRequiredProtocol_foldingRange;function requireProtocol_foldingRange(){if(hasRequiredProtocol_foldingRange)return protocol_foldingRange;hasRequiredProtocol_foldingRange=1,Object.defineProperty(protocol_foldingRange,"__esModule",{value:!0}),protocol_foldingRange.FoldingRangeRefreshRequest=protocol_foldingRange.FoldingRangeRequest=void 0;const D=requireMessages();var E;(function(J){J.method="textDocument/foldingRange",J.messageDirection=D.MessageDirection.clientToServer,J.type=new D.ProtocolRequestType(J.method)})(E||(protocol_foldingRange.FoldingRangeRequest=E={}));var F;return(function(J){J.method="workspace/foldingRange/refresh",J.messageDirection=D.MessageDirection.serverToClient,J.type=new D.ProtocolRequestType0(J.method)})(F||(protocol_foldingRange.FoldingRangeRefreshRequest=F={})),protocol_foldingRange}var protocol_declaration={},hasRequiredProtocol_declaration;function requireProtocol_declaration(){if(hasRequiredProtocol_declaration)return protocol_declaration;hasRequiredProtocol_declaration=1,Object.defineProperty(protocol_declaration,"__esModule",{value:!0}),protocol_declaration.DeclarationRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/declaration",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_declaration.DeclarationRequest=E={})),protocol_declaration}var protocol_selectionRange={},hasRequiredProtocol_selectionRange;function requireProtocol_selectionRange(){if(hasRequiredProtocol_selectionRange)return protocol_selectionRange;hasRequiredProtocol_selectionRange=1,Object.defineProperty(protocol_selectionRange,"__esModule",{value:!0}),protocol_selectionRange.SelectionRangeRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/selectionRange",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_selectionRange.SelectionRangeRequest=E={})),protocol_selectionRange}var protocol_progress={},hasRequiredProtocol_progress;function requireProtocol_progress(){if(hasRequiredProtocol_progress)return protocol_progress;hasRequiredProtocol_progress=1,Object.defineProperty(protocol_progress,"__esModule",{value:!0}),protocol_progress.WorkDoneProgressCancelNotification=protocol_progress.WorkDoneProgressCreateRequest=protocol_progress.WorkDoneProgress=void 0;const D=requireMain$2(),E=requireMessages();var F;(function(_t){_t.type=new D.ProgressType;function lr(mr){return mr===_t.type}_t.is=lr})(F||(protocol_progress.WorkDoneProgress=F={}));var J;(function(_t){_t.method="window/workDoneProgress/create",_t.messageDirection=E.MessageDirection.serverToClient,_t.type=new E.ProtocolRequestType(_t.method)})(J||(protocol_progress.WorkDoneProgressCreateRequest=J={}));var $e;return(function(_t){_t.method="window/workDoneProgress/cancel",_t.messageDirection=E.MessageDirection.clientToServer,_t.type=new E.ProtocolNotificationType(_t.method)})($e||(protocol_progress.WorkDoneProgressCancelNotification=$e={})),protocol_progress}var protocol_callHierarchy={},hasRequiredProtocol_callHierarchy;function requireProtocol_callHierarchy(){if(hasRequiredProtocol_callHierarchy)return protocol_callHierarchy;hasRequiredProtocol_callHierarchy=1,Object.defineProperty(protocol_callHierarchy,"__esModule",{value:!0}),protocol_callHierarchy.CallHierarchyOutgoingCallsRequest=protocol_callHierarchy.CallHierarchyIncomingCallsRequest=protocol_callHierarchy.CallHierarchyPrepareRequest=void 0;const D=requireMessages();var E;(function($e){$e.method="textDocument/prepareCallHierarchy",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(E||(protocol_callHierarchy.CallHierarchyPrepareRequest=E={}));var F;(function($e){$e.method="callHierarchy/incomingCalls",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(F||(protocol_callHierarchy.CallHierarchyIncomingCallsRequest=F={}));var J;return(function($e){$e.method="callHierarchy/outgoingCalls",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(J||(protocol_callHierarchy.CallHierarchyOutgoingCallsRequest=J={})),protocol_callHierarchy}var protocol_semanticTokens={},hasRequiredProtocol_semanticTokens;function requireProtocol_semanticTokens(){if(hasRequiredProtocol_semanticTokens)return protocol_semanticTokens;hasRequiredProtocol_semanticTokens=1,Object.defineProperty(protocol_semanticTokens,"__esModule",{value:!0}),protocol_semanticTokens.SemanticTokensRefreshRequest=protocol_semanticTokens.SemanticTokensRangeRequest=protocol_semanticTokens.SemanticTokensDeltaRequest=protocol_semanticTokens.SemanticTokensRequest=protocol_semanticTokens.SemanticTokensRegistrationType=protocol_semanticTokens.TokenFormat=void 0;const D=requireMessages();var E;(function(mr){mr.Relative="relative"})(E||(protocol_semanticTokens.TokenFormat=E={}));var F;(function(mr){mr.method="textDocument/semanticTokens",mr.type=new D.RegistrationType(mr.method)})(F||(protocol_semanticTokens.SemanticTokensRegistrationType=F={}));var J;(function(mr){mr.method="textDocument/semanticTokens/full",mr.messageDirection=D.MessageDirection.clientToServer,mr.type=new D.ProtocolRequestType(mr.method),mr.registrationMethod=F.method})(J||(protocol_semanticTokens.SemanticTokensRequest=J={}));var $e;(function(mr){mr.method="textDocument/semanticTokens/full/delta",mr.messageDirection=D.MessageDirection.clientToServer,mr.type=new D.ProtocolRequestType(mr.method),mr.registrationMethod=F.method})($e||(protocol_semanticTokens.SemanticTokensDeltaRequest=$e={}));var _t;(function(mr){mr.method="textDocument/semanticTokens/range",mr.messageDirection=D.MessageDirection.clientToServer,mr.type=new D.ProtocolRequestType(mr.method),mr.registrationMethod=F.method})(_t||(protocol_semanticTokens.SemanticTokensRangeRequest=_t={}));var lr;return(function(mr){mr.method="workspace/semanticTokens/refresh",mr.messageDirection=D.MessageDirection.serverToClient,mr.type=new D.ProtocolRequestType0(mr.method)})(lr||(protocol_semanticTokens.SemanticTokensRefreshRequest=lr={})),protocol_semanticTokens}var protocol_showDocument={},hasRequiredProtocol_showDocument;function requireProtocol_showDocument(){if(hasRequiredProtocol_showDocument)return protocol_showDocument;hasRequiredProtocol_showDocument=1,Object.defineProperty(protocol_showDocument,"__esModule",{value:!0}),protocol_showDocument.ShowDocumentRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="window/showDocument",F.messageDirection=D.MessageDirection.serverToClient,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_showDocument.ShowDocumentRequest=E={})),protocol_showDocument}var protocol_linkedEditingRange={},hasRequiredProtocol_linkedEditingRange;function requireProtocol_linkedEditingRange(){if(hasRequiredProtocol_linkedEditingRange)return protocol_linkedEditingRange;hasRequiredProtocol_linkedEditingRange=1,Object.defineProperty(protocol_linkedEditingRange,"__esModule",{value:!0}),protocol_linkedEditingRange.LinkedEditingRangeRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/linkedEditingRange",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_linkedEditingRange.LinkedEditingRangeRequest=E={})),protocol_linkedEditingRange}var protocol_fileOperations={},hasRequiredProtocol_fileOperations;function requireProtocol_fileOperations(){if(hasRequiredProtocol_fileOperations)return protocol_fileOperations;hasRequiredProtocol_fileOperations=1,Object.defineProperty(protocol_fileOperations,"__esModule",{value:!0}),protocol_fileOperations.WillDeleteFilesRequest=protocol_fileOperations.DidDeleteFilesNotification=protocol_fileOperations.DidRenameFilesNotification=protocol_fileOperations.WillRenameFilesRequest=protocol_fileOperations.DidCreateFilesNotification=protocol_fileOperations.WillCreateFilesRequest=protocol_fileOperations.FileOperationPatternKind=void 0;const D=requireMessages();var E;(function(Or){Or.file="file",Or.folder="folder"})(E||(protocol_fileOperations.FileOperationPatternKind=E={}));var F;(function(Or){Or.method="workspace/willCreateFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolRequestType(Or.method)})(F||(protocol_fileOperations.WillCreateFilesRequest=F={}));var J;(function(Or){Or.method="workspace/didCreateFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolNotificationType(Or.method)})(J||(protocol_fileOperations.DidCreateFilesNotification=J={}));var $e;(function(Or){Or.method="workspace/willRenameFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolRequestType(Or.method)})($e||(protocol_fileOperations.WillRenameFilesRequest=$e={}));var _t;(function(Or){Or.method="workspace/didRenameFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolNotificationType(Or.method)})(_t||(protocol_fileOperations.DidRenameFilesNotification=_t={}));var lr;(function(Or){Or.method="workspace/didDeleteFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolNotificationType(Or.method)})(lr||(protocol_fileOperations.DidDeleteFilesNotification=lr={}));var mr;return(function(Or){Or.method="workspace/willDeleteFiles",Or.messageDirection=D.MessageDirection.clientToServer,Or.type=new D.ProtocolRequestType(Or.method)})(mr||(protocol_fileOperations.WillDeleteFilesRequest=mr={})),protocol_fileOperations}var protocol_moniker={},hasRequiredProtocol_moniker;function requireProtocol_moniker(){if(hasRequiredProtocol_moniker)return protocol_moniker;hasRequiredProtocol_moniker=1,Object.defineProperty(protocol_moniker,"__esModule",{value:!0}),protocol_moniker.MonikerRequest=protocol_moniker.MonikerKind=protocol_moniker.UniquenessLevel=void 0;const D=requireMessages();var E;(function($e){$e.document="document",$e.project="project",$e.group="group",$e.scheme="scheme",$e.global="global"})(E||(protocol_moniker.UniquenessLevel=E={}));var F;(function($e){$e.$import="import",$e.$export="export",$e.local="local"})(F||(protocol_moniker.MonikerKind=F={}));var J;return(function($e){$e.method="textDocument/moniker",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(J||(protocol_moniker.MonikerRequest=J={})),protocol_moniker}var protocol_typeHierarchy={},hasRequiredProtocol_typeHierarchy;function requireProtocol_typeHierarchy(){if(hasRequiredProtocol_typeHierarchy)return protocol_typeHierarchy;hasRequiredProtocol_typeHierarchy=1,Object.defineProperty(protocol_typeHierarchy,"__esModule",{value:!0}),protocol_typeHierarchy.TypeHierarchySubtypesRequest=protocol_typeHierarchy.TypeHierarchySupertypesRequest=protocol_typeHierarchy.TypeHierarchyPrepareRequest=void 0;const D=requireMessages();var E;(function($e){$e.method="textDocument/prepareTypeHierarchy",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(E||(protocol_typeHierarchy.TypeHierarchyPrepareRequest=E={}));var F;(function($e){$e.method="typeHierarchy/supertypes",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(F||(protocol_typeHierarchy.TypeHierarchySupertypesRequest=F={}));var J;return(function($e){$e.method="typeHierarchy/subtypes",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(J||(protocol_typeHierarchy.TypeHierarchySubtypesRequest=J={})),protocol_typeHierarchy}var protocol_inlineValue={},hasRequiredProtocol_inlineValue;function requireProtocol_inlineValue(){if(hasRequiredProtocol_inlineValue)return protocol_inlineValue;hasRequiredProtocol_inlineValue=1,Object.defineProperty(protocol_inlineValue,"__esModule",{value:!0}),protocol_inlineValue.InlineValueRefreshRequest=protocol_inlineValue.InlineValueRequest=void 0;const D=requireMessages();var E;(function(J){J.method="textDocument/inlineValue",J.messageDirection=D.MessageDirection.clientToServer,J.type=new D.ProtocolRequestType(J.method)})(E||(protocol_inlineValue.InlineValueRequest=E={}));var F;return(function(J){J.method="workspace/inlineValue/refresh",J.messageDirection=D.MessageDirection.serverToClient,J.type=new D.ProtocolRequestType0(J.method)})(F||(protocol_inlineValue.InlineValueRefreshRequest=F={})),protocol_inlineValue}var protocol_inlayHint={},hasRequiredProtocol_inlayHint;function requireProtocol_inlayHint(){if(hasRequiredProtocol_inlayHint)return protocol_inlayHint;hasRequiredProtocol_inlayHint=1,Object.defineProperty(protocol_inlayHint,"__esModule",{value:!0}),protocol_inlayHint.InlayHintRefreshRequest=protocol_inlayHint.InlayHintResolveRequest=protocol_inlayHint.InlayHintRequest=void 0;const D=requireMessages();var E;(function($e){$e.method="textDocument/inlayHint",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(E||(protocol_inlayHint.InlayHintRequest=E={}));var F;(function($e){$e.method="inlayHint/resolve",$e.messageDirection=D.MessageDirection.clientToServer,$e.type=new D.ProtocolRequestType($e.method)})(F||(protocol_inlayHint.InlayHintResolveRequest=F={}));var J;return(function($e){$e.method="workspace/inlayHint/refresh",$e.messageDirection=D.MessageDirection.serverToClient,$e.type=new D.ProtocolRequestType0($e.method)})(J||(protocol_inlayHint.InlayHintRefreshRequest=J={})),protocol_inlayHint}var protocol_diagnostic={},hasRequiredProtocol_diagnostic;function requireProtocol_diagnostic(){if(hasRequiredProtocol_diagnostic)return protocol_diagnostic;hasRequiredProtocol_diagnostic=1,Object.defineProperty(protocol_diagnostic,"__esModule",{value:!0}),protocol_diagnostic.DiagnosticRefreshRequest=protocol_diagnostic.WorkspaceDiagnosticRequest=protocol_diagnostic.DocumentDiagnosticRequest=protocol_diagnostic.DocumentDiagnosticReportKind=protocol_diagnostic.DiagnosticServerCancellationData=void 0;const D=requireMain$2(),E=requireIs$1(),F=requireMessages();var J;(function(Or){function Pr(dn){const gi=dn;return gi&&E.boolean(gi.retriggerRequest)}Or.is=Pr})(J||(protocol_diagnostic.DiagnosticServerCancellationData=J={}));var $e;(function(Or){Or.Full="full",Or.Unchanged="unchanged"})($e||(protocol_diagnostic.DocumentDiagnosticReportKind=$e={}));var _t;(function(Or){Or.method="textDocument/diagnostic",Or.messageDirection=F.MessageDirection.clientToServer,Or.type=new F.ProtocolRequestType(Or.method),Or.partialResult=new D.ProgressType})(_t||(protocol_diagnostic.DocumentDiagnosticRequest=_t={}));var lr;(function(Or){Or.method="workspace/diagnostic",Or.messageDirection=F.MessageDirection.clientToServer,Or.type=new F.ProtocolRequestType(Or.method),Or.partialResult=new D.ProgressType})(lr||(protocol_diagnostic.WorkspaceDiagnosticRequest=lr={}));var mr;return(function(Or){Or.method="workspace/diagnostic/refresh",Or.messageDirection=F.MessageDirection.serverToClient,Or.type=new F.ProtocolRequestType0(Or.method)})(mr||(protocol_diagnostic.DiagnosticRefreshRequest=mr={})),protocol_diagnostic}var protocol_notebook={},hasRequiredProtocol_notebook;function requireProtocol_notebook(){if(hasRequiredProtocol_notebook)return protocol_notebook;hasRequiredProtocol_notebook=1,Object.defineProperty(protocol_notebook,"__esModule",{value:!0}),protocol_notebook.DidCloseNotebookDocumentNotification=protocol_notebook.DidSaveNotebookDocumentNotification=protocol_notebook.DidChangeNotebookDocumentNotification=protocol_notebook.NotebookCellArrayChange=protocol_notebook.DidOpenNotebookDocumentNotification=protocol_notebook.NotebookDocumentSyncRegistrationType=protocol_notebook.NotebookDocument=protocol_notebook.NotebookCell=protocol_notebook.ExecutionSummary=protocol_notebook.NotebookCellKind=void 0;const D=require$$1,E=requireIs$1(),F=requireMessages();var J;(function(zi){zi.Markup=1,zi.Code=2;function Hi(Qi){return Qi===1||Qi===2}zi.is=Hi})(J||(protocol_notebook.NotebookCellKind=J={}));var $e;(function(zi){function Hi(Zi,Xi){const Ki={executionOrder:Zi};return(Xi===!0||Xi===!1)&&(Ki.success=Xi),Ki}zi.create=Hi;function Qi(Zi){const Xi=Zi;return E.objectLiteral(Xi)&&D.uinteger.is(Xi.executionOrder)&&(Xi.success===void 0||E.boolean(Xi.success))}zi.is=Qi;function Gi(Zi,Xi){return Zi===Xi?!0:Zi==null||Xi===null||Xi===void 0?!1:Zi.executionOrder===Xi.executionOrder&&Zi.success===Xi.success}zi.equals=Gi})($e||(protocol_notebook.ExecutionSummary=$e={}));var _t;(function(zi){function Hi(Xi,Ki){return{kind:Xi,document:Ki}}zi.create=Hi;function Qi(Xi){const Ki=Xi;return E.objectLiteral(Ki)&&J.is(Ki.kind)&&D.DocumentUri.is(Ki.document)&&(Ki.metadata===void 0||E.objectLiteral(Ki.metadata))}zi.is=Qi;function Gi(Xi,Ki){const ea=new Set;return Xi.document!==Ki.document&&ea.add("document"),Xi.kind!==Ki.kind&&ea.add("kind"),Xi.executionSummary!==Ki.executionSummary&&ea.add("executionSummary"),(Xi.metadata!==void 0||Ki.metadata!==void 0)&&!Zi(Xi.metadata,Ki.metadata)&&ea.add("metadata"),(Xi.executionSummary!==void 0||Ki.executionSummary!==void 0)&&!$e.equals(Xi.executionSummary,Ki.executionSummary)&&ea.add("executionSummary"),ea}zi.diff=Gi;function Zi(Xi,Ki){if(Xi===Ki)return!0;if(Xi==null||Ki===null||Ki===void 0||typeof Xi!=typeof Ki||typeof Xi!="object")return!1;const ea=Array.isArray(Xi),Ji=Array.isArray(Ki);if(ea!==Ji)return!1;if(ea&&Ji){if(Xi.length!==Ki.length)return!1;for(let ta=0;ta<Xi.length;ta++)if(!Zi(Xi[ta],Ki[ta]))return!1}if(E.objectLiteral(Xi)&&E.objectLiteral(Ki)){const ta=Object.keys(Xi),na=Object.keys(Ki);if(ta.length!==na.length||(ta.sort(),na.sort(),!Zi(ta,na)))return!1;for(let ra=0;ra<ta.length;ra++){const ia=ta[ra];if(!Zi(Xi[ia],Ki[ia]))return!1}}return!0}})(_t||(protocol_notebook.NotebookCell=_t={}));var lr;(function(zi){function Hi(Gi,Zi,Xi,Ki){return{uri:Gi,notebookType:Zi,version:Xi,cells:Ki}}zi.create=Hi;function Qi(Gi){const Zi=Gi;return E.objectLiteral(Zi)&&E.string(Zi.uri)&&D.integer.is(Zi.version)&&E.typedArray(Zi.cells,_t.is)}zi.is=Qi})(lr||(protocol_notebook.NotebookDocument=lr={}));var mr;(function(zi){zi.method="notebookDocument/sync",zi.messageDirection=F.MessageDirection.clientToServer,zi.type=new F.RegistrationType(zi.method)})(mr||(protocol_notebook.NotebookDocumentSyncRegistrationType=mr={}));var Or;(function(zi){zi.method="notebookDocument/didOpen",zi.messageDirection=F.MessageDirection.clientToServer,zi.type=new F.ProtocolNotificationType(zi.method),zi.registrationMethod=mr.method})(Or||(protocol_notebook.DidOpenNotebookDocumentNotification=Or={}));var Pr;(function(zi){function Hi(Gi){const Zi=Gi;return E.objectLiteral(Zi)&&D.uinteger.is(Zi.start)&&D.uinteger.is(Zi.deleteCount)&&(Zi.cells===void 0||E.typedArray(Zi.cells,_t.is))}zi.is=Hi;function Qi(Gi,Zi,Xi){const Ki={start:Gi,deleteCount:Zi};return Xi!==void 0&&(Ki.cells=Xi),Ki}zi.create=Qi})(Pr||(protocol_notebook.NotebookCellArrayChange=Pr={}));var dn;(function(zi){zi.method="notebookDocument/didChange",zi.messageDirection=F.MessageDirection.clientToServer,zi.type=new F.ProtocolNotificationType(zi.method),zi.registrationMethod=mr.method})(dn||(protocol_notebook.DidChangeNotebookDocumentNotification=dn={}));var gi;(function(zi){zi.method="notebookDocument/didSave",zi.messageDirection=F.MessageDirection.clientToServer,zi.type=new F.ProtocolNotificationType(zi.method),zi.registrationMethod=mr.method})(gi||(protocol_notebook.DidSaveNotebookDocumentNotification=gi={}));var qi;return(function(zi){zi.method="notebookDocument/didClose",zi.messageDirection=F.MessageDirection.clientToServer,zi.type=new F.ProtocolNotificationType(zi.method),zi.registrationMethod=mr.method})(qi||(protocol_notebook.DidCloseNotebookDocumentNotification=qi={})),protocol_notebook}var protocol_inlineCompletion={},hasRequiredProtocol_inlineCompletion;function requireProtocol_inlineCompletion(){if(hasRequiredProtocol_inlineCompletion)return protocol_inlineCompletion;hasRequiredProtocol_inlineCompletion=1,Object.defineProperty(protocol_inlineCompletion,"__esModule",{value:!0}),protocol_inlineCompletion.InlineCompletionRequest=void 0;const D=requireMessages();var E;return(function(F){F.method="textDocument/inlineCompletion",F.messageDirection=D.MessageDirection.clientToServer,F.type=new D.ProtocolRequestType(F.method)})(E||(protocol_inlineCompletion.InlineCompletionRequest=E={})),protocol_inlineCompletion}var hasRequiredProtocol;function requireProtocol(){return hasRequiredProtocol||(hasRequiredProtocol=1,(function(D){Object.defineProperty(D,"__esModule",{value:!0}),D.WorkspaceSymbolRequest=D.CodeActionResolveRequest=D.CodeActionRequest=D.DocumentSymbolRequest=D.DocumentHighlightRequest=D.ReferencesRequest=D.DefinitionRequest=D.SignatureHelpRequest=D.SignatureHelpTriggerKind=D.HoverRequest=D.CompletionResolveRequest=D.CompletionRequest=D.CompletionTriggerKind=D.PublishDiagnosticsNotification=D.WatchKind=D.RelativePattern=D.FileChangeType=D.DidChangeWatchedFilesNotification=D.WillSaveTextDocumentWaitUntilRequest=D.WillSaveTextDocumentNotification=D.TextDocumentSaveReason=D.DidSaveTextDocumentNotification=D.DidCloseTextDocumentNotification=D.DidChangeTextDocumentNotification=D.TextDocumentContentChangeEvent=D.DidOpenTextDocumentNotification=D.TextDocumentSyncKind=D.TelemetryEventNotification=D.LogMessageNotification=D.ShowMessageRequest=D.ShowMessageNotification=D.MessageType=D.DidChangeConfigurationNotification=D.ExitNotification=D.ShutdownRequest=D.InitializedNotification=D.InitializeErrorCodes=D.InitializeRequest=D.WorkDoneProgressOptions=D.TextDocumentRegistrationOptions=D.StaticRegistrationOptions=D.PositionEncodingKind=D.FailureHandlingKind=D.ResourceOperationKind=D.UnregistrationRequest=D.RegistrationRequest=D.DocumentSelector=D.NotebookCellTextDocumentFilter=D.NotebookDocumentFilter=D.TextDocumentFilter=void 0,D.MonikerRequest=D.MonikerKind=D.UniquenessLevel=D.WillDeleteFilesRequest=D.DidDeleteFilesNotification=D.WillRenameFilesRequest=D.DidRenameFilesNotification=D.WillCreateFilesRequest=D.DidCreateFilesNotification=D.FileOperationPatternKind=D.LinkedEditingRangeRequest=D.ShowDocumentRequest=D.SemanticTokensRegistrationType=D.SemanticTokensRefreshRequest=D.SemanticTokensRangeRequest=D.SemanticTokensDeltaRequest=D.SemanticTokensRequest=D.TokenFormat=D.CallHierarchyPrepareRequest=D.CallHierarchyOutgoingCallsRequest=D.CallHierarchyIncomingCallsRequest=D.WorkDoneProgressCancelNotification=D.WorkDoneProgressCreateRequest=D.WorkDoneProgress=D.SelectionRangeRequest=D.DeclarationRequest=D.FoldingRangeRefreshRequest=D.FoldingRangeRequest=D.ColorPresentationRequest=D.DocumentColorRequest=D.ConfigurationRequest=D.DidChangeWorkspaceFoldersNotification=D.WorkspaceFoldersRequest=D.TypeDefinitionRequest=D.ImplementationRequest=D.ApplyWorkspaceEditRequest=D.ExecuteCommandRequest=D.PrepareRenameRequest=D.RenameRequest=D.PrepareSupportDefaultBehavior=D.DocumentOnTypeFormattingRequest=D.DocumentRangesFormattingRequest=D.DocumentRangeFormattingRequest=D.DocumentFormattingRequest=D.DocumentLinkResolveRequest=D.DocumentLinkRequest=D.CodeLensRefreshRequest=D.CodeLensResolveRequest=D.CodeLensRequest=D.WorkspaceSymbolResolveRequest=void 0,D.InlineCompletionRequest=D.DidCloseNotebookDocumentNotification=D.DidSaveNotebookDocumentNotification=D.DidChangeNotebookDocumentNotification=D.NotebookCellArrayChange=D.DidOpenNotebookDocumentNotification=D.NotebookDocumentSyncRegistrationType=D.NotebookDocument=D.NotebookCell=D.ExecutionSummary=D.NotebookCellKind=D.DiagnosticRefreshRequest=D.WorkspaceDiagnosticRequest=D.DocumentDiagnosticRequest=D.DocumentDiagnosticReportKind=D.DiagnosticServerCancellationData=D.InlayHintRefreshRequest=D.InlayHintResolveRequest=D.InlayHintRequest=D.InlineValueRefreshRequest=D.InlineValueRequest=D.TypeHierarchySupertypesRequest=D.TypeHierarchySubtypesRequest=D.TypeHierarchyPrepareRequest=void 0;const E=requireMessages(),F=require$$1,J=requireIs$1(),$e=requireProtocol_implementation();Object.defineProperty(D,"ImplementationRequest",{enumerable:!0,get:function(){return $e.ImplementationRequest}});const _t=requireProtocol_typeDefinition();Object.defineProperty(D,"TypeDefinitionRequest",{enumerable:!0,get:function(){return _t.TypeDefinitionRequest}});const lr=requireProtocol_workspaceFolder();Object.defineProperty(D,"WorkspaceFoldersRequest",{enumerable:!0,get:function(){return lr.WorkspaceFoldersRequest}}),Object.defineProperty(D,"DidChangeWorkspaceFoldersNotification",{enumerable:!0,get:function(){return lr.DidChangeWorkspaceFoldersNotification}});const mr=requireProtocol_configuration();Object.defineProperty(D,"ConfigurationRequest",{enumerable:!0,get:function(){return mr.ConfigurationRequest}});const Or=requireProtocol_colorProvider();Object.defineProperty(D,"DocumentColorRequest",{enumerable:!0,get:function(){return Or.DocumentColorRequest}}),Object.defineProperty(D,"ColorPresentationRequest",{enumerable:!0,get:function(){return Or.ColorPresentationRequest}});const Pr=requireProtocol_foldingRange();Object.defineProperty(D,"FoldingRangeRequest",{enumerable:!0,get:function(){return Pr.FoldingRangeRequest}}),Object.defineProperty(D,"FoldingRangeRefreshRequest",{enumerable:!0,get:function(){return Pr.FoldingRangeRefreshRequest}});const dn=requireProtocol_declaration();Object.defineProperty(D,"DeclarationRequest",{enumerable:!0,get:function(){return dn.DeclarationRequest}});const gi=requireProtocol_selectionRange();Object.defineProperty(D,"SelectionRangeRequest",{enumerable:!0,get:function(){return gi.SelectionRangeRequest}});const qi=requireProtocol_progress();Object.defineProperty(D,"WorkDoneProgress",{enumerable:!0,get:function(){return qi.WorkDoneProgress}}),Object.defineProperty(D,"WorkDoneProgressCreateRequest",{enumerable:!0,get:function(){return qi.WorkDoneProgressCreateRequest}}),Object.defineProperty(D,"WorkDoneProgressCancelNotification",{enumerable:!0,get:function(){return qi.WorkDoneProgressCancelNotification}});const zi=requireProtocol_callHierarchy();Object.defineProperty(D,"CallHierarchyIncomingCallsRequest",{enumerable:!0,get:function(){return zi.CallHierarchyIncomingCallsRequest}}),Object.defineProperty(D,"CallHierarchyOutgoingCallsRequest",{enumerable:!0,get:function(){return zi.CallHierarchyOutgoingCallsRequest}}),Object.defineProperty(D,"CallHierarchyPrepareRequest",{enumerable:!0,get:function(){return zi.CallHierarchyPrepareRequest}});const Hi=requireProtocol_semanticTokens();Object.defineProperty(D,"TokenFormat",{enumerable:!0,get:function(){return Hi.TokenFormat}}),Object.defineProperty(D,"SemanticTokensRequest",{enumerable:!0,get:function(){return Hi.SemanticTokensRequest}}),Object.defineProperty(D,"SemanticTokensDeltaRequest",{enumerable:!0,get:function(){return Hi.SemanticTokensDeltaRequest}}),Object.defineProperty(D,"SemanticTokensRangeRequest",{enumerable:!0,get:function(){return Hi.SemanticTokensRangeRequest}}),Object.defineProperty(D,"SemanticTokensRefreshRequest",{enumerable:!0,get:function(){return Hi.SemanticTokensRefreshRequest}}),Object.defineProperty(D,"SemanticTokensRegistrationType",{enumerable:!0,get:function(){return Hi.SemanticTokensRegistrationType}});const Qi=requireProtocol_showDocument();Object.defineProperty(D,"ShowDocumentRequest",{enumerable:!0,get:function(){return Qi.ShowDocumentRequest}});const Gi=requireProtocol_linkedEditingRange();Object.defineProperty(D,"LinkedEditingRangeRequest",{enumerable:!0,get:function(){return Gi.LinkedEditingRangeRequest}});const Zi=requireProtocol_fileOperations();Object.defineProperty(D,"FileOperationPatternKind",{enumerable:!0,get:function(){return Zi.FileOperationPatternKind}}),Object.defineProperty(D,"DidCreateFilesNotification",{enumerable:!0,get:function(){return Zi.DidCreateFilesNotification}}),Object.defineProperty(D,"WillCreateFilesRequest",{enumerable:!0,get:function(){return Zi.WillCreateFilesRequest}}),Object.defineProperty(D,"DidRenameFilesNotification",{enumerable:!0,get:function(){return Zi.DidRenameFilesNotification}}),Object.defineProperty(D,"WillRenameFilesRequest",{enumerable:!0,get:function(){return Zi.WillRenameFilesRequest}}),Object.defineProperty(D,"DidDeleteFilesNotification",{enumerable:!0,get:function(){return Zi.DidDeleteFilesNotification}}),Object.defineProperty(D,"WillDeleteFilesRequest",{enumerable:!0,get:function(){return Zi.WillDeleteFilesRequest}});const Xi=requireProtocol_moniker();Object.defineProperty(D,"UniquenessLevel",{enumerable:!0,get:function(){return Xi.UniquenessLevel}}),Object.defineProperty(D,"MonikerKind",{enumerable:!0,get:function(){return Xi.MonikerKind}}),Object.defineProperty(D,"MonikerRequest",{enumerable:!0,get:function(){return Xi.MonikerRequest}});const Ki=requireProtocol_typeHierarchy();Object.defineProperty(D,"TypeHierarchyPrepareRequest",{enumerable:!0,get:function(){return Ki.TypeHierarchyPrepareRequest}}),Object.defineProperty(D,"TypeHierarchySubtypesRequest",{enumerable:!0,get:function(){return Ki.TypeHierarchySubtypesRequest}}),Object.defineProperty(D,"TypeHierarchySupertypesRequest",{enumerable:!0,get:function(){return Ki.TypeHierarchySupertypesRequest}});const ea=requireProtocol_inlineValue();Object.defineProperty(D,"InlineValueRequest",{enumerable:!0,get:function(){return ea.InlineValueRequest}}),Object.defineProperty(D,"InlineValueRefreshRequest",{enumerable:!0,get:function(){return ea.InlineValueRefreshRequest}});const Ji=requireProtocol_inlayHint();Object.defineProperty(D,"InlayHintRequest",{enumerable:!0,get:function(){return Ji.InlayHintRequest}}),Object.defineProperty(D,"InlayHintResolveRequest",{enumerable:!0,get:function(){return Ji.InlayHintResolveRequest}}),Object.defineProperty(D,"InlayHintRefreshRequest",{enumerable:!0,get:function(){return Ji.InlayHintRefreshRequest}});const ta=requireProtocol_diagnostic();Object.defineProperty(D,"DiagnosticServerCancellationData",{enumerable:!0,get:function(){return ta.DiagnosticServerCancellationData}}),Object.defineProperty(D,"DocumentDiagnosticReportKind",{enumerable:!0,get:function(){return ta.DocumentDiagnosticReportKind}}),Object.defineProperty(D,"DocumentDiagnosticRequest",{enumerable:!0,get:function(){return ta.DocumentDiagnosticRequest}}),Object.defineProperty(D,"WorkspaceDiagnosticRequest",{enumerable:!0,get:function(){return ta.WorkspaceDiagnosticRequest}}),Object.defineProperty(D,"DiagnosticRefreshRequest",{enumerable:!0,get:function(){return ta.DiagnosticRefreshRequest}});const na=requireProtocol_notebook();Object.defineProperty(D,"NotebookCellKind",{enumerable:!0,get:function(){return na.NotebookCellKind}}),Object.defineProperty(D,"ExecutionSummary",{enumerable:!0,get:function(){return na.ExecutionSummary}}),Object.defineProperty(D,"NotebookCell",{enumerable:!0,get:function(){return na.NotebookCell}}),Object.defineProperty(D,"NotebookDocument",{enumerable:!0,get:function(){return na.NotebookDocument}}),Object.defineProperty(D,"NotebookDocumentSyncRegistrationType",{enumerable:!0,get:function(){return na.NotebookDocumentSyncRegistrationType}}),Object.defineProperty(D,"DidOpenNotebookDocumentNotification",{enumerable:!0,get:function(){return na.DidOpenNotebookDocumentNotification}}),Object.defineProperty(D,"NotebookCellArrayChange",{enumerable:!0,get:function(){return na.NotebookCellArrayChange}}),Object.defineProperty(D,"DidChangeNotebookDocumentNotification",{enumerable:!0,get:function(){return na.DidChangeNotebookDocumentNotification}}),Object.defineProperty(D,"DidSaveNotebookDocumentNotification",{enumerable:!0,get:function(){return na.DidSaveNotebookDocumentNotification}}),Object.defineProperty(D,"DidCloseNotebookDocumentNotification",{enumerable:!0,get:function(){return na.DidCloseNotebookDocumentNotification}});const ra=requireProtocol_inlineCompletion();Object.defineProperty(D,"InlineCompletionRequest",{enumerable:!0,get:function(){return ra.InlineCompletionRequest}});var ia;(function(Ma){function Es(Ns){const bs=Ns;return J.string(bs)||J.string(bs.language)||J.string(bs.scheme)||J.string(bs.pattern)}Ma.is=Es})(ia||(D.TextDocumentFilter=ia={}));var oa;(function(Ma){function Es(Ns){const bs=Ns;return J.objectLiteral(bs)&&(J.string(bs.notebookType)||J.string(bs.scheme)||J.string(bs.pattern))}Ma.is=Es})(oa||(D.NotebookDocumentFilter=oa={}));var ua;(function(Ma){function Es(Ns){const bs=Ns;return J.objectLiteral(bs)&&(J.string(bs.notebook)||oa.is(bs.notebook))&&(bs.language===void 0||J.string(bs.language))}Ma.is=Es})(ua||(D.NotebookCellTextDocumentFilter=ua={}));var sa;(function(Ma){function Es(Ns){if(!Array.isArray(Ns))return!1;for(let bs of Ns)if(!J.string(bs)&&!ia.is(bs)&&!ua.is(bs))return!1;return!0}Ma.is=Es})(sa||(D.DocumentSelector=sa={}));var aa;(function(Ma){Ma.method="client/registerCapability",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolRequestType(Ma.method)})(aa||(D.RegistrationRequest=aa={}));var pa;(function(Ma){Ma.method="client/unregisterCapability",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolRequestType(Ma.method)})(pa||(D.UnregistrationRequest=pa={}));var ma;(function(Ma){Ma.Create="create",Ma.Rename="rename",Ma.Delete="delete"})(ma||(D.ResourceOperationKind=ma={}));var la;(function(Ma){Ma.Abort="abort",Ma.Transactional="transactional",Ma.TextOnlyTransactional="textOnlyTransactional",Ma.Undo="undo"})(la||(D.FailureHandlingKind=la={}));var ha;(function(Ma){Ma.UTF8="utf-8",Ma.UTF16="utf-16",Ma.UTF32="utf-32"})(ha||(D.PositionEncodingKind=ha={}));var ga;(function(Ma){function Es(Ns){const bs=Ns;return bs&&J.string(bs.id)&&bs.id.length>0}Ma.hasId=Es})(ga||(D.StaticRegistrationOptions=ga={}));var Aa;(function(Ma){function Es(Ns){const bs=Ns;return bs&&(bs.documentSelector===null||sa.is(bs.documentSelector))}Ma.is=Es})(Aa||(D.TextDocumentRegistrationOptions=Aa={}));var Fa;(function(Ma){function Es(bs){const da=bs;return J.objectLiteral(da)&&(da.workDoneProgress===void 0||J.boolean(da.workDoneProgress))}Ma.is=Es;function Ns(bs){const da=bs;return da&&J.boolean(da.workDoneProgress)}Ma.hasWorkDoneProgress=Ns})(Fa||(D.WorkDoneProgressOptions=Fa={}));var $a;(function(Ma){Ma.method="initialize",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})($a||(D.InitializeRequest=$a={}));var _a;(function(Ma){Ma.unknownProtocolVersion=1})(_a||(D.InitializeErrorCodes=_a={}));var fa;(function(Ma){Ma.method="initialized",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(fa||(D.InitializedNotification=fa={}));var ka;(function(Ma){Ma.method="shutdown",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType0(Ma.method)})(ka||(D.ShutdownRequest=ka={}));var ba;(function(Ma){Ma.method="exit",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType0(Ma.method)})(ba||(D.ExitNotification=ba={}));var Pa;(function(Ma){Ma.method="workspace/didChangeConfiguration",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(Pa||(D.DidChangeConfigurationNotification=Pa={}));var Ia;(function(Ma){Ma.Error=1,Ma.Warning=2,Ma.Info=3,Ma.Log=4,Ma.Debug=5})(Ia||(D.MessageType=Ia={}));var Da;(function(Ma){Ma.method="window/showMessage",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolNotificationType(Ma.method)})(Da||(D.ShowMessageNotification=Da={}));var va;(function(Ma){Ma.method="window/showMessageRequest",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolRequestType(Ma.method)})(va||(D.ShowMessageRequest=va={}));var Ca;(function(Ma){Ma.method="window/logMessage",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolNotificationType(Ma.method)})(Ca||(D.LogMessageNotification=Ca={}));var ya;(function(Ma){Ma.method="telemetry/event",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolNotificationType(Ma.method)})(ya||(D.TelemetryEventNotification=ya={}));var Na;(function(Ma){Ma.None=0,Ma.Full=1,Ma.Incremental=2})(Na||(D.TextDocumentSyncKind=Na={}));var za;(function(Ma){Ma.method="textDocument/didOpen",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(za||(D.DidOpenTextDocumentNotification=za={}));var Ta;(function(Ma){function Es(bs){let da=bs;return da!=null&&typeof da.text=="string"&&da.range!==void 0&&(da.rangeLength===void 0||typeof da.rangeLength=="number")}Ma.isIncremental=Es;function Ns(bs){let da=bs;return da!=null&&typeof da.text=="string"&&da.range===void 0&&da.rangeLength===void 0}Ma.isFull=Ns})(Ta||(D.TextDocumentContentChangeEvent=Ta={}));var es;(function(Ma){Ma.method="textDocument/didChange",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(es||(D.DidChangeTextDocumentNotification=es={}));var ts;(function(Ma){Ma.method="textDocument/didClose",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(ts||(D.DidCloseTextDocumentNotification=ts={}));var Ka;(function(Ma){Ma.method="textDocument/didSave",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(Ka||(D.DidSaveTextDocumentNotification=Ka={}));var ps;(function(Ma){Ma.Manual=1,Ma.AfterDelay=2,Ma.FocusOut=3})(ps||(D.TextDocumentSaveReason=ps={}));var cs;(function(Ma){Ma.method="textDocument/willSave",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(cs||(D.WillSaveTextDocumentNotification=cs={}));var xa;(function(Ma){Ma.method="textDocument/willSaveWaitUntil",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(xa||(D.WillSaveTextDocumentWaitUntilRequest=xa={}));var Ra;(function(Ma){Ma.method="workspace/didChangeWatchedFiles",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolNotificationType(Ma.method)})(Ra||(D.DidChangeWatchedFilesNotification=Ra={}));var Va;(function(Ma){Ma.Created=1,Ma.Changed=2,Ma.Deleted=3})(Va||(D.FileChangeType=Va={}));var Ga;(function(Ma){function Es(Ns){const bs=Ns;return J.objectLiteral(bs)&&(F.URI.is(bs.baseUri)||F.WorkspaceFolder.is(bs.baseUri))&&J.string(bs.pattern)}Ma.is=Es})(Ga||(D.RelativePattern=Ga={}));var as;(function(Ma){Ma.Create=1,Ma.Change=2,Ma.Delete=4})(as||(D.WatchKind=as={}));var rs;(function(Ma){Ma.method="textDocument/publishDiagnostics",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolNotificationType(Ma.method)})(rs||(D.PublishDiagnosticsNotification=rs={}));var ss;(function(Ma){Ma.Invoked=1,Ma.TriggerCharacter=2,Ma.TriggerForIncompleteCompletions=3})(ss||(D.CompletionTriggerKind=ss={}));var ms;(function(Ma){Ma.method="textDocument/completion",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(ms||(D.CompletionRequest=ms={}));var Ua;(function(Ma){Ma.method="completionItem/resolve",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Ua||(D.CompletionResolveRequest=Ua={}));var Wa;(function(Ma){Ma.method="textDocument/hover",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Wa||(D.HoverRequest=Wa={}));var wa;(function(Ma){Ma.Invoked=1,Ma.TriggerCharacter=2,Ma.ContentChange=3})(wa||(D.SignatureHelpTriggerKind=wa={}));var qa;(function(Ma){Ma.method="textDocument/signatureHelp",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(qa||(D.SignatureHelpRequest=qa={}));var ja;(function(Ma){Ma.method="textDocument/definition",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(ja||(D.DefinitionRequest=ja={}));var Xa;(function(Ma){Ma.method="textDocument/references",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Xa||(D.ReferencesRequest=Xa={}));var Ya;(function(Ma){Ma.method="textDocument/documentHighlight",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Ya||(D.DocumentHighlightRequest=Ya={}));var Ja;(function(Ma){Ma.method="textDocument/documentSymbol",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Ja||(D.DocumentSymbolRequest=Ja={}));var os;(function(Ma){Ma.method="textDocument/codeAction",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(os||(D.CodeActionRequest=os={}));var ns;(function(Ma){Ma.method="codeAction/resolve",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(ns||(D.CodeActionResolveRequest=ns={}));var ca;(function(Ma){Ma.method="workspace/symbol",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(ca||(D.WorkspaceSymbolRequest=ca={}));var Sa;(function(Ma){Ma.method="workspaceSymbol/resolve",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Sa||(D.WorkspaceSymbolResolveRequest=Sa={}));var Ha;(function(Ma){Ma.method="textDocument/codeLens",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Ha||(D.CodeLensRequest=Ha={}));var Za;(function(Ma){Ma.method="codeLens/resolve",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Za||(D.CodeLensResolveRequest=Za={}));var fs;(function(Ma){Ma.method="workspace/codeLens/refresh",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolRequestType0(Ma.method)})(fs||(D.CodeLensRefreshRequest=fs={}));var gs;(function(Ma){Ma.method="textDocument/documentLink",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(gs||(D.DocumentLinkRequest=gs={}));var ws;(function(Ma){Ma.method="documentLink/resolve",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(ws||(D.DocumentLinkResolveRequest=ws={}));var Os;(function(Ma){Ma.method="textDocument/formatting",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Os||(D.DocumentFormattingRequest=Os={}));var Rs;(function(Ma){Ma.method="textDocument/rangeFormatting",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Rs||(D.DocumentRangeFormattingRequest=Rs={}));var zs;(function(Ma){Ma.method="textDocument/rangesFormatting",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(zs||(D.DocumentRangesFormattingRequest=zs={}));var $s;(function(Ma){Ma.method="textDocument/onTypeFormatting",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})($s||(D.DocumentOnTypeFormattingRequest=$s={}));var js;(function(Ma){Ma.Identifier=1})(js||(D.PrepareSupportDefaultBehavior=js={}));var Qs;(function(Ma){Ma.method="textDocument/rename",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Qs||(D.RenameRequest=Qs={}));var Gs;(function(Ma){Ma.method="textDocument/prepareRename",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Gs||(D.PrepareRenameRequest=Gs={}));var Ws;(function(Ma){Ma.method="workspace/executeCommand",Ma.messageDirection=E.MessageDirection.clientToServer,Ma.type=new E.ProtocolRequestType(Ma.method)})(Ws||(D.ExecuteCommandRequest=Ws={}));var Us;(function(Ma){Ma.method="workspace/applyEdit",Ma.messageDirection=E.MessageDirection.serverToClient,Ma.type=new E.ProtocolRequestType("workspace/applyEdit")})(Us||(D.ApplyWorkspaceEditRequest=Us={}))})(protocol)),protocol}var connection$1={},hasRequiredConnection;function requireConnection(){if(hasRequiredConnection)return connection$1;hasRequiredConnection=1,Object.defineProperty(connection$1,"__esModule",{value:!0}),connection$1.createProtocolConnection=void 0;const D=requireMain$2();function E(F,J,$e,_t){return D.ConnectionStrategy.is(_t)&&(_t={connectionStrategy:_t}),(0,D.createMessageConnection)(F,J,$e,_t)}return connection$1.createProtocolConnection=E,connection$1}var hasRequiredApi$1;function requireApi$1(){return hasRequiredApi$1||(hasRequiredApi$1=1,(function(D){var E=api&&api.__createBinding||(Object.create?(function(_t,lr,mr,Or){Or===void 0&&(Or=mr);var Pr=Object.getOwnPropertyDescriptor(lr,mr);(!Pr||("get"in Pr?!lr.__esModule:Pr.writable||Pr.configurable))&&(Pr={enumerable:!0,get:function(){return lr[mr]}}),Object.defineProperty(_t,Or,Pr)}):(function(_t,lr,mr,Or){Or===void 0&&(Or=mr),_t[Or]=lr[mr]})),F=api&&api.__exportStar||function(_t,lr){for(var mr in _t)mr!=="default"&&!Object.prototype.hasOwnProperty.call(lr,mr)&&E(lr,_t,mr)};Object.defineProperty(D,"__esModule",{value:!0}),D.LSPErrorCodes=D.createProtocolConnection=void 0,F(requireMain$2(),D),F(require$$1,D),F(requireMessages(),D),F(requireProtocol(),D);var J=requireConnection();Object.defineProperty(D,"createProtocolConnection",{enumerable:!0,get:function(){return J.createProtocolConnection}});var $e;(function(_t){_t.lspReservedErrorRangeStart=-32899,_t.RequestFailed=-32803,_t.ServerCancelled=-32802,_t.ContentModified=-32801,_t.RequestCancelled=-32800,_t.lspReservedErrorRangeEnd=-32800})($e||(D.LSPErrorCodes=$e={}))})(api)),api}var hasRequiredMain$1;function requireMain$1(){return hasRequiredMain$1||(hasRequiredMain$1=1,(function(D){var E=main$2&&main$2.__createBinding||(Object.create?(function(_t,lr,mr,Or){Or===void 0&&(Or=mr);var Pr=Object.getOwnPropertyDescriptor(lr,mr);(!Pr||("get"in Pr?!lr.__esModule:Pr.writable||Pr.configurable))&&(Pr={enumerable:!0,get:function(){return lr[mr]}}),Object.defineProperty(_t,Or,Pr)}):(function(_t,lr,mr,Or){Or===void 0&&(Or=mr),_t[Or]=lr[mr]})),F=main$2&&main$2.__exportStar||function(_t,lr){for(var mr in _t)mr!=="default"&&!Object.prototype.hasOwnProperty.call(lr,mr)&&E(lr,_t,mr)};Object.defineProperty(D,"__esModule",{value:!0}),D.createProtocolConnection=void 0;const J=requireBrowser$2();F(requireBrowser$2(),D),F(requireApi$1(),D);function $e(_t,lr,mr,Or){return(0,J.createMessageConnection)(_t,lr,mr,Or)}D.createProtocolConnection=$e})(main$2)),main$2}var hasRequiredSemanticTokens;function requireSemanticTokens(){if(hasRequiredSemanticTokens)return semanticTokens;hasRequiredSemanticTokens=1,Object.defineProperty(semanticTokens,"__esModule",{value:!0}),semanticTokens.SemanticTokensBuilder=semanticTokens.SemanticTokensDiff=semanticTokens.SemanticTokensFeature=void 0;const D=requireMain$1(),E=$e=>class extends $e{get semanticTokens(){return{refresh:()=>this.connection.sendRequest(D.SemanticTokensRefreshRequest.type),on:_t=>{const lr=D.SemanticTokensRequest.type;return this.connection.onRequest(lr,(mr,Or)=>_t(mr,Or,this.attachWorkDoneProgress(mr),this.attachPartialResultProgress(lr,mr)))},onDelta:_t=>{const lr=D.SemanticTokensDeltaRequest.type;return this.connection.onRequest(lr,(mr,Or)=>_t(mr,Or,this.attachWorkDoneProgress(mr),this.attachPartialResultProgress(lr,mr)))},onRange:_t=>{const lr=D.SemanticTokensRangeRequest.type;return this.connection.onRequest(lr,(mr,Or)=>_t(mr,Or,this.attachWorkDoneProgress(mr),this.attachPartialResultProgress(lr,mr)))}}}};semanticTokens.SemanticTokensFeature=E;class F{constructor(_t,lr){this.originalSequence=_t,this.modifiedSequence=lr}computeDiff(){const _t=this.originalSequence.length,lr=this.modifiedSequence.length;let mr=0;for(;mr<lr&&mr<_t&&this.originalSequence[mr]===this.modifiedSequence[mr];)mr++;if(mr<lr&&mr<_t){let Or=_t-1,Pr=lr-1;for(;Or>=mr&&Pr>=mr&&this.originalSequence[Or]===this.modifiedSequence[Pr];)Or--,Pr--;(Or<mr||Pr<mr)&&(Or++,Pr++);const dn=Or-mr+1,gi=this.modifiedSequence.slice(mr,Pr+1);return gi.length===1&&gi[0]===this.originalSequence[Or]?[{start:mr,deleteCount:dn-1}]:[{start:mr,deleteCount:dn,data:gi}]}else return mr<lr?[{start:mr,deleteCount:0,data:this.modifiedSequence.slice(mr)}]:mr<_t?[{start:mr,deleteCount:_t-mr}]:[]}}semanticTokens.SemanticTokensDiff=F;class J{constructor(){this._prevData=void 0,this.initialize()}initialize(){this._id=Date.now(),this._prevLine=0,this._prevChar=0,this._data=[],this._dataLen=0}push(_t,lr,mr,Or,Pr){let dn=_t,gi=lr;this._dataLen>0&&(dn-=this._prevLine,dn===0&&(gi-=this._prevChar)),this._data[this._dataLen++]=dn,this._data[this._dataLen++]=gi,this._data[this._dataLen++]=mr,this._data[this._dataLen++]=Or,this._data[this._dataLen++]=Pr,this._prevLine=_t,this._prevChar=lr}get id(){return this._id.toString()}previousResult(_t){this.id===_t&&(this._prevData=this._data),this.initialize()}build(){return this._prevData=void 0,{resultId:this.id,data:this._data}}canBuildEdits(){return this._prevData!==void 0}buildEdits(){return this._prevData!==void 0?{resultId:this.id,edits:new F(this._prevData,this._data).computeDiff()}:this.build()}}return semanticTokens.SemanticTokensBuilder=J,semanticTokens}var inlineCompletion_proposed={},hasRequiredInlineCompletion_proposed;function requireInlineCompletion_proposed(){if(hasRequiredInlineCompletion_proposed)return inlineCompletion_proposed;hasRequiredInlineCompletion_proposed=1,Object.defineProperty(inlineCompletion_proposed,"__esModule",{value:!0}),inlineCompletion_proposed.InlineCompletionFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get inlineCompletion(){return{on:J=>this.connection.onRequest(D.InlineCompletionRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e)))}}};return inlineCompletion_proposed.InlineCompletionFeature=E,inlineCompletion_proposed}var textDocuments={},hasRequiredTextDocuments;function requireTextDocuments(){if(hasRequiredTextDocuments)return textDocuments;hasRequiredTextDocuments=1,Object.defineProperty(textDocuments,"__esModule",{value:!0}),textDocuments.TextDocuments=void 0;const D=requireMain$1();class E{constructor(J){this._configuration=J,this._syncedDocuments=new Map,this._onDidChangeContent=new D.Emitter,this._onDidOpen=new D.Emitter,this._onDidClose=new D.Emitter,this._onDidSave=new D.Emitter,this._onWillSave=new D.Emitter}get onDidOpen(){return this._onDidOpen.event}get onDidChangeContent(){return this._onDidChangeContent.event}get onWillSave(){return this._onWillSave.event}onWillSaveWaitUntil(J){this._willSaveWaitUntil=J}get onDidSave(){return this._onDidSave.event}get onDidClose(){return this._onDidClose.event}get(J){return this._syncedDocuments.get(J)}all(){return Array.from(this._syncedDocuments.values())}keys(){return Array.from(this._syncedDocuments.keys())}listen(J){J.__textDocumentSync=D.TextDocumentSyncKind.Incremental;const $e=[];return $e.push(J.onDidOpenTextDocument(_t=>{const lr=_t.textDocument,mr=this._configuration.create(lr.uri,lr.languageId,lr.version,lr.text);this._syncedDocuments.set(lr.uri,mr);const Or=Object.freeze({document:mr});this._onDidOpen.fire(Or),this._onDidChangeContent.fire(Or)})),$e.push(J.onDidChangeTextDocument(_t=>{const lr=_t.textDocument,mr=_t.contentChanges;if(mr.length===0)return;const{version:Or}=lr;if(Or==null)throw new Error(`Received document change event for ${lr.uri} without valid version identifier`);let Pr=this._syncedDocuments.get(lr.uri);Pr!==void 0&&(Pr=this._configuration.update(Pr,mr,Or),this._syncedDocuments.set(lr.uri,Pr),this._onDidChangeContent.fire(Object.freeze({document:Pr})))})),$e.push(J.onDidCloseTextDocument(_t=>{let lr=this._syncedDocuments.get(_t.textDocument.uri);lr!==void 0&&(this._syncedDocuments.delete(_t.textDocument.uri),this._onDidClose.fire(Object.freeze({document:lr})))})),$e.push(J.onWillSaveTextDocument(_t=>{let lr=this._syncedDocuments.get(_t.textDocument.uri);lr!==void 0&&this._onWillSave.fire(Object.freeze({document:lr,reason:_t.reason}))})),$e.push(J.onWillSaveTextDocumentWaitUntil((_t,lr)=>{let mr=this._syncedDocuments.get(_t.textDocument.uri);return mr!==void 0&&this._willSaveWaitUntil?this._willSaveWaitUntil(Object.freeze({document:mr,reason:_t.reason}),lr):[]})),$e.push(J.onDidSaveTextDocument(_t=>{let lr=this._syncedDocuments.get(_t.textDocument.uri);lr!==void 0&&this._onDidSave.fire(Object.freeze({document:lr}))})),D.Disposable.create(()=>{$e.forEach(_t=>_t.dispose())})}}return textDocuments.TextDocuments=E,textDocuments}var notebook={},hasRequiredNotebook;function requireNotebook(){if(hasRequiredNotebook)return notebook;hasRequiredNotebook=1,Object.defineProperty(notebook,"__esModule",{value:!0}),notebook.NotebookDocuments=notebook.NotebookSyncFeature=void 0;const D=requireMain$1(),E=requireTextDocuments(),F=_t=>class extends _t{get synchronization(){return{onDidOpenNotebookDocument:lr=>this.connection.onNotification(D.DidOpenNotebookDocumentNotification.type,mr=>{lr(mr)}),onDidChangeNotebookDocument:lr=>this.connection.onNotification(D.DidChangeNotebookDocumentNotification.type,mr=>{lr(mr)}),onDidSaveNotebookDocument:lr=>this.connection.onNotification(D.DidSaveNotebookDocumentNotification.type,mr=>{lr(mr)}),onDidCloseNotebookDocument:lr=>this.connection.onNotification(D.DidCloseNotebookDocumentNotification.type,mr=>{lr(mr)})}}};notebook.NotebookSyncFeature=F;class J{onDidOpenTextDocument(lr){return this.openHandler=lr,D.Disposable.create(()=>{this.openHandler=void 0})}openTextDocument(lr){this.openHandler&&this.openHandler(lr)}onDidChangeTextDocument(lr){return this.changeHandler=lr,D.Disposable.create(()=>{this.changeHandler=lr})}changeTextDocument(lr){this.changeHandler&&this.changeHandler(lr)}onDidCloseTextDocument(lr){return this.closeHandler=lr,D.Disposable.create(()=>{this.closeHandler=void 0})}closeTextDocument(lr){this.closeHandler&&this.closeHandler(lr)}onWillSaveTextDocument(){return J.NULL_DISPOSE}onWillSaveTextDocumentWaitUntil(){return J.NULL_DISPOSE}onDidSaveTextDocument(){return J.NULL_DISPOSE}}J.NULL_DISPOSE=Object.freeze({dispose:()=>{}});class $e{constructor(lr){lr instanceof E.TextDocuments?this._cellTextDocuments=lr:this._cellTextDocuments=new E.TextDocuments(lr),this.notebookDocuments=new Map,this.notebookCellMap=new Map,this._onDidOpen=new D.Emitter,this._onDidChange=new D.Emitter,this._onDidSave=new D.Emitter,this._onDidClose=new D.Emitter}get cellTextDocuments(){return this._cellTextDocuments}getCellTextDocument(lr){return this._cellTextDocuments.get(lr.document)}getNotebookDocument(lr){return this.notebookDocuments.get(lr)}getNotebookCell(lr){const mr=this.notebookCellMap.get(lr);return mr&&mr[0]}findNotebookDocumentForCell(lr){const mr=typeof lr=="string"?lr:lr.document,Or=this.notebookCellMap.get(mr);return Or&&Or[1]}get onDidOpen(){return this._onDidOpen.event}get onDidSave(){return this._onDidSave.event}get onDidChange(){return this._onDidChange.event}get onDidClose(){return this._onDidClose.event}listen(lr){const mr=new J,Or=[];return Or.push(this.cellTextDocuments.listen(mr)),Or.push(lr.notebooks.synchronization.onDidOpenNotebookDocument(Pr=>{this.notebookDocuments.set(Pr.notebookDocument.uri,Pr.notebookDocument);for(const dn of Pr.cellTextDocuments)mr.openTextDocument({textDocument:dn});this.updateCellMap(Pr.notebookDocument),this._onDidOpen.fire(Pr.notebookDocument)})),Or.push(lr.notebooks.synchronization.onDidChangeNotebookDocument(Pr=>{const dn=this.notebookDocuments.get(Pr.notebookDocument.uri);if(dn===void 0)return;dn.version=Pr.notebookDocument.version;const gi=dn.metadata;let qi=!1;const zi=Pr.change;zi.metadata!==void 0&&(qi=!0,dn.metadata=zi.metadata);const Hi=[],Qi=[],Gi=[],Zi=[];if(zi.cells!==void 0){const ta=zi.cells;if(ta.structure!==void 0){const na=ta.structure.array;if(dn.cells.splice(na.start,na.deleteCount,...na.cells!==void 0?na.cells:[]),ta.structure.didOpen!==void 0)for(const ra of ta.structure.didOpen)mr.openTextDocument({textDocument:ra}),Hi.push(ra.uri);if(ta.structure.didClose)for(const ra of ta.structure.didClose)mr.closeTextDocument({textDocument:ra}),Qi.push(ra.uri)}if(ta.data!==void 0){const na=new Map(ta.data.map(ra=>[ra.document,ra]));for(let ra=0;ra<=dn.cells.length;ra++){const ia=na.get(dn.cells[ra].document);if(ia!==void 0){const oa=dn.cells.splice(ra,1,ia);if(Gi.push({old:oa[0],new:ia}),na.delete(ia.document),na.size===0)break}}}if(ta.textContent!==void 0)for(const na of ta.textContent)mr.changeTextDocument({textDocument:na.document,contentChanges:na.changes}),Zi.push(na.document.uri)}this.updateCellMap(dn);const Xi={notebookDocument:dn};qi&&(Xi.metadata={old:gi,new:dn.metadata});const Ki=[];for(const ta of Hi)Ki.push(this.getNotebookCell(ta));const ea=[];for(const ta of Qi)ea.push(this.getNotebookCell(ta));const Ji=[];for(const ta of Zi)Ji.push(this.getNotebookCell(ta));(Ki.length>0||ea.length>0||Gi.length>0||Ji.length>0)&&(Xi.cells={added:Ki,removed:ea,changed:{data:Gi,textContent:Ji}}),(Xi.metadata!==void 0||Xi.cells!==void 0)&&this._onDidChange.fire(Xi)})),Or.push(lr.notebooks.synchronization.onDidSaveNotebookDocument(Pr=>{const dn=this.notebookDocuments.get(Pr.notebookDocument.uri);dn!==void 0&&this._onDidSave.fire(dn)})),Or.push(lr.notebooks.synchronization.onDidCloseNotebookDocument(Pr=>{const dn=this.notebookDocuments.get(Pr.notebookDocument.uri);if(dn!==void 0){this._onDidClose.fire(dn);for(const gi of Pr.cellTextDocuments)mr.closeTextDocument({textDocument:gi});this.notebookDocuments.delete(Pr.notebookDocument.uri);for(const gi of dn.cells)this.notebookCellMap.delete(gi.document)}})),D.Disposable.create(()=>{Or.forEach(Pr=>Pr.dispose())})}updateCellMap(lr){for(const mr of lr.cells)this.notebookCellMap.set(mr.document,[mr,lr])}}return notebook.NotebookDocuments=$e,notebook}var server={},is={},hasRequiredIs;function requireIs(){if(hasRequiredIs)return is;hasRequiredIs=1,Object.defineProperty(is,"__esModule",{value:!0}),is.thenable=is.typedArray=is.stringArray=is.array=is.func=is.error=is.number=is.string=is.boolean=void 0;function D(Pr){return Pr===!0||Pr===!1}is.boolean=D;function E(Pr){return typeof Pr=="string"||Pr instanceof String}is.string=E;function F(Pr){return typeof Pr=="number"||Pr instanceof Number}is.number=F;function J(Pr){return Pr instanceof Error}is.error=J;function $e(Pr){return typeof Pr=="function"}is.func=$e;function _t(Pr){return Array.isArray(Pr)}is.array=_t;function lr(Pr){return _t(Pr)&&Pr.every(dn=>E(dn))}is.stringArray=lr;function mr(Pr,dn){return Array.isArray(Pr)&&Pr.every(dn)}is.typedArray=mr;function Or(Pr){return Pr&&$e(Pr.then)}return is.thenable=Or,is}var uuid={},hasRequiredUuid;function requireUuid(){if(hasRequiredUuid)return uuid;hasRequiredUuid=1,Object.defineProperty(uuid,"__esModule",{value:!0}),uuid.generateUuid=uuid.parse=uuid.isUUID=uuid.v4=uuid.empty=void 0;class D{constructor(Or){this._value=Or}asHex(){return this._value}equals(Or){return this.asHex()===Or.asHex()}}class E extends D{static _oneOf(Or){return Or[Math.floor(Or.length*Math.random())]}static _randomHex(){return E._oneOf(E._chars)}constructor(){super([E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),"-",E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),"-","4",E._randomHex(),E._randomHex(),E._randomHex(),"-",E._oneOf(E._timeHighBits),E._randomHex(),E._randomHex(),E._randomHex(),"-",E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex(),E._randomHex()].join(""))}}E._chars=["0","1","2","3","4","5","6","6","7","8","9","a","b","c","d","e","f"],E._timeHighBits=["8","9","a","b"],uuid.empty=new D("00000000-0000-0000-0000-000000000000");function F(){return new E}uuid.v4=F;const J=/^[0-9a-f]{8}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{4}-[0-9a-f]{12}$/i;function $e(mr){return J.test(mr)}uuid.isUUID=$e;function _t(mr){if(!$e(mr))throw new Error("invalid uuid");return new D(mr)}uuid.parse=_t;function lr(){return F().asHex()}return uuid.generateUuid=lr,uuid}var progress={},hasRequiredProgress;function requireProgress(){if(hasRequiredProgress)return progress;hasRequiredProgress=1,Object.defineProperty(progress,"__esModule",{value:!0}),progress.attachPartialResult=progress.ProgressFeature=progress.attachWorkDone=void 0;const D=requireMain$1(),E=requireUuid();class F{constructor(qi,zi){this._connection=qi,this._token=zi,F.Instances.set(this._token,this)}begin(qi,zi,Hi,Qi){let Gi={kind:"begin",title:qi,percentage:zi,message:Hi,cancellable:Qi};this._connection.sendProgress(D.WorkDoneProgress.type,this._token,Gi)}report(qi,zi){let Hi={kind:"report"};typeof qi=="number"?(Hi.percentage=qi,zi!==void 0&&(Hi.message=zi)):Hi.message=qi,this._connection.sendProgress(D.WorkDoneProgress.type,this._token,Hi)}done(){F.Instances.delete(this._token),this._connection.sendProgress(D.WorkDoneProgress.type,this._token,{kind:"end"})}}F.Instances=new Map;class J extends F{constructor(qi,zi){super(qi,zi),this._source=new D.CancellationTokenSource}get token(){return this._source.token}done(){this._source.dispose(),super.done()}cancel(){this._source.cancel()}}class $e{constructor(){}begin(){}report(){}done(){}}class _t extends $e{constructor(){super(),this._source=new D.CancellationTokenSource}get token(){return this._source.token}done(){this._source.dispose()}cancel(){this._source.cancel()}}function lr(gi,qi){if(qi===void 0||qi.workDoneToken===void 0)return new $e;const zi=qi.workDoneToken;return delete qi.workDoneToken,new F(gi,zi)}progress.attachWorkDone=lr;const mr=gi=>class extends gi{constructor(){super(),this._progressSupported=!1}initialize(qi){super.initialize(qi),qi?.window?.workDoneProgress===!0&&(this._progressSupported=!0,this.connection.onNotification(D.WorkDoneProgressCancelNotification.type,zi=>{let Hi=F.Instances.get(zi.token);(Hi instanceof J||Hi instanceof _t)&&Hi.cancel()}))}attachWorkDoneProgress(qi){return qi===void 0?new $e:new F(this.connection,qi)}createWorkDoneProgress(){if(this._progressSupported){const qi=(0,E.generateUuid)();return this.connection.sendRequest(D.WorkDoneProgressCreateRequest.type,{token:qi}).then(()=>new J(this.connection,qi))}else return Promise.resolve(new _t)}};progress.ProgressFeature=mr;var Or;(function(gi){gi.type=new D.ProgressType})(Or||(Or={}));class Pr{constructor(qi,zi){this._connection=qi,this._token=zi}report(qi){this._connection.sendProgress(Or.type,this._token,qi)}}function dn(gi,qi){if(qi===void 0||qi.partialResultToken===void 0)return;const zi=qi.partialResultToken;return delete qi.partialResultToken,new Pr(gi,zi)}return progress.attachPartialResult=dn,progress}var configuration={},hasRequiredConfiguration;function requireConfiguration(){if(hasRequiredConfiguration)return configuration;hasRequiredConfiguration=1,Object.defineProperty(configuration,"__esModule",{value:!0}),configuration.ConfigurationFeature=void 0;const D=requireMain$1(),E=requireIs(),F=J=>class extends J{getConfiguration($e){return $e?E.string($e)?this._getConfiguration({section:$e}):this._getConfiguration($e):this._getConfiguration({})}_getConfiguration($e){let _t={items:Array.isArray($e)?$e:[$e]};return this.connection.sendRequest(D.ConfigurationRequest.type,_t).then(lr=>Array.isArray(lr)?Array.isArray($e)?lr:lr[0]:Array.isArray($e)?[]:null)}};return configuration.ConfigurationFeature=F,configuration}var workspaceFolder={},hasRequiredWorkspaceFolder;function requireWorkspaceFolder(){if(hasRequiredWorkspaceFolder)return workspaceFolder;hasRequiredWorkspaceFolder=1,Object.defineProperty(workspaceFolder,"__esModule",{value:!0}),workspaceFolder.WorkspaceFoldersFeature=void 0;const D=requireMain$1(),E=F=>class extends F{constructor(){super(),this._notificationIsAutoRegistered=!1}initialize(J){super.initialize(J);let $e=J.workspace;$e&&$e.workspaceFolders&&(this._onDidChangeWorkspaceFolders=new D.Emitter,this.connection.onNotification(D.DidChangeWorkspaceFoldersNotification.type,_t=>{this._onDidChangeWorkspaceFolders.fire(_t.event)}))}fillServerCapabilities(J){super.fillServerCapabilities(J);const $e=J.workspace?.workspaceFolders?.changeNotifications;this._notificationIsAutoRegistered=$e===!0||typeof $e=="string"}getWorkspaceFolders(){return this.connection.sendRequest(D.WorkspaceFoldersRequest.type)}get onDidChangeWorkspaceFolders(){if(!this._onDidChangeWorkspaceFolders)throw new Error("Client doesn\'t support sending workspace folder change events.");return!this._notificationIsAutoRegistered&&!this._unregistration&&(this._unregistration=this.connection.client.register(D.DidChangeWorkspaceFoldersNotification.type)),this._onDidChangeWorkspaceFolders.event}};return workspaceFolder.WorkspaceFoldersFeature=E,workspaceFolder}var callHierarchy={},hasRequiredCallHierarchy;function requireCallHierarchy(){if(hasRequiredCallHierarchy)return callHierarchy;hasRequiredCallHierarchy=1,Object.defineProperty(callHierarchy,"__esModule",{value:!0}),callHierarchy.CallHierarchyFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get callHierarchy(){return{onPrepare:J=>this.connection.onRequest(D.CallHierarchyPrepareRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e),void 0)),onIncomingCalls:J=>{const $e=D.CallHierarchyIncomingCallsRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))},onOutgoingCalls:J=>{const $e=D.CallHierarchyOutgoingCallsRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))}}}};return callHierarchy.CallHierarchyFeature=E,callHierarchy}var showDocument={},hasRequiredShowDocument;function requireShowDocument(){if(hasRequiredShowDocument)return showDocument;hasRequiredShowDocument=1,Object.defineProperty(showDocument,"__esModule",{value:!0}),showDocument.ShowDocumentFeature=void 0;const D=requireMain$1(),E=F=>class extends F{showDocument(J){return this.connection.sendRequest(D.ShowDocumentRequest.type,J)}};return showDocument.ShowDocumentFeature=E,showDocument}var fileOperations={},hasRequiredFileOperations;function requireFileOperations(){if(hasRequiredFileOperations)return fileOperations;hasRequiredFileOperations=1,Object.defineProperty(fileOperations,"__esModule",{value:!0}),fileOperations.FileOperationsFeature=void 0;const D=requireMain$1(),E=F=>class extends F{onDidCreateFiles(J){return this.connection.onNotification(D.DidCreateFilesNotification.type,$e=>{J($e)})}onDidRenameFiles(J){return this.connection.onNotification(D.DidRenameFilesNotification.type,$e=>{J($e)})}onDidDeleteFiles(J){return this.connection.onNotification(D.DidDeleteFilesNotification.type,$e=>{J($e)})}onWillCreateFiles(J){return this.connection.onRequest(D.WillCreateFilesRequest.type,($e,_t)=>J($e,_t))}onWillRenameFiles(J){return this.connection.onRequest(D.WillRenameFilesRequest.type,($e,_t)=>J($e,_t))}onWillDeleteFiles(J){return this.connection.onRequest(D.WillDeleteFilesRequest.type,($e,_t)=>J($e,_t))}};return fileOperations.FileOperationsFeature=E,fileOperations}var linkedEditingRange={},hasRequiredLinkedEditingRange;function requireLinkedEditingRange(){if(hasRequiredLinkedEditingRange)return linkedEditingRange;hasRequiredLinkedEditingRange=1,Object.defineProperty(linkedEditingRange,"__esModule",{value:!0}),linkedEditingRange.LinkedEditingRangeFeature=void 0;const D=requireMain$1(),E=F=>class extends F{onLinkedEditingRange(J){return this.connection.onRequest(D.LinkedEditingRangeRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e),void 0))}};return linkedEditingRange.LinkedEditingRangeFeature=E,linkedEditingRange}var typeHierarchy={},hasRequiredTypeHierarchy;function requireTypeHierarchy(){if(hasRequiredTypeHierarchy)return typeHierarchy;hasRequiredTypeHierarchy=1,Object.defineProperty(typeHierarchy,"__esModule",{value:!0}),typeHierarchy.TypeHierarchyFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get typeHierarchy(){return{onPrepare:J=>this.connection.onRequest(D.TypeHierarchyPrepareRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e),void 0)),onSupertypes:J=>{const $e=D.TypeHierarchySupertypesRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))},onSubtypes:J=>{const $e=D.TypeHierarchySubtypesRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))}}}};return typeHierarchy.TypeHierarchyFeature=E,typeHierarchy}var inlineValue={},hasRequiredInlineValue;function requireInlineValue(){if(hasRequiredInlineValue)return inlineValue;hasRequiredInlineValue=1,Object.defineProperty(inlineValue,"__esModule",{value:!0}),inlineValue.InlineValueFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get inlineValue(){return{refresh:()=>this.connection.sendRequest(D.InlineValueRefreshRequest.type),on:J=>this.connection.onRequest(D.InlineValueRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e)))}}};return inlineValue.InlineValueFeature=E,inlineValue}var foldingRange={},hasRequiredFoldingRange;function requireFoldingRange(){if(hasRequiredFoldingRange)return foldingRange;hasRequiredFoldingRange=1,Object.defineProperty(foldingRange,"__esModule",{value:!0}),foldingRange.FoldingRangeFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get foldingRange(){return{refresh:()=>this.connection.sendRequest(D.FoldingRangeRefreshRequest.type),on:J=>{const $e=D.FoldingRangeRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))}}}};return foldingRange.FoldingRangeFeature=E,foldingRange}var inlayHint={},hasRequiredInlayHint;function requireInlayHint(){if(hasRequiredInlayHint)return inlayHint;hasRequiredInlayHint=1,Object.defineProperty(inlayHint,"__esModule",{value:!0}),inlayHint.InlayHintFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get inlayHint(){return{refresh:()=>this.connection.sendRequest(D.InlayHintRefreshRequest.type),on:J=>this.connection.onRequest(D.InlayHintRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e))),resolve:J=>this.connection.onRequest(D.InlayHintResolveRequest.type,($e,_t)=>J($e,_t))}}};return inlayHint.InlayHintFeature=E,inlayHint}var diagnostic={},hasRequiredDiagnostic;function requireDiagnostic(){if(hasRequiredDiagnostic)return diagnostic;hasRequiredDiagnostic=1,Object.defineProperty(diagnostic,"__esModule",{value:!0}),diagnostic.DiagnosticFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get diagnostics(){return{refresh:()=>this.connection.sendRequest(D.DiagnosticRefreshRequest.type),on:J=>this.connection.onRequest(D.DocumentDiagnosticRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e),this.attachPartialResultProgress(D.DocumentDiagnosticRequest.partialResult,$e))),onWorkspace:J=>this.connection.onRequest(D.WorkspaceDiagnosticRequest.type,($e,_t)=>J($e,_t,this.attachWorkDoneProgress($e),this.attachPartialResultProgress(D.WorkspaceDiagnosticRequest.partialResult,$e)))}}};return diagnostic.DiagnosticFeature=E,diagnostic}var moniker={},hasRequiredMoniker;function requireMoniker(){if(hasRequiredMoniker)return moniker;hasRequiredMoniker=1,Object.defineProperty(moniker,"__esModule",{value:!0}),moniker.MonikerFeature=void 0;const D=requireMain$1(),E=F=>class extends F{get moniker(){return{on:J=>{const $e=D.MonikerRequest.type;return this.connection.onRequest($e,(_t,lr)=>J(_t,lr,this.attachWorkDoneProgress(_t),this.attachPartialResultProgress($e,_t)))}}}};return moniker.MonikerFeature=E,moniker}var hasRequiredServer;function requireServer(){if(hasRequiredServer)return server;hasRequiredServer=1,Object.defineProperty(server,"__esModule",{value:!0}),server.createConnection=server.combineFeatures=server.combineNotebooksFeatures=server.combineLanguagesFeatures=server.combineWorkspaceFeatures=server.combineWindowFeatures=server.combineClientFeatures=server.combineTracerFeatures=server.combineTelemetryFeatures=server.combineConsoleFeatures=server._NotebooksImpl=server._LanguagesImpl=server.BulkUnregistration=server.BulkRegistration=server.ErrorMessageTracker=void 0;const D=requireMain$1(),E=requireIs(),F=requireUuid(),J=requireProgress(),$e=requireConfiguration(),_t=requireWorkspaceFolder(),lr=requireCallHierarchy(),mr=requireSemanticTokens(),Or=requireShowDocument(),Pr=requireFileOperations(),dn=requireLinkedEditingRange(),gi=requireTypeHierarchy(),qi=requireInlineValue(),zi=requireFoldingRange(),Hi=requireInlayHint(),Qi=requireDiagnostic(),Gi=requireNotebook(),Zi=requireMoniker();function Xi(Ca){if(Ca!==null)return Ca}class Ki{constructor(){this._messages=Object.create(null)}add(ya){let Na=this._messages[ya];Na||(Na=0),Na++,this._messages[ya]=Na}sendErrors(ya){Object.keys(this._messages).forEach(Na=>{ya.window.showErrorMessage(Na)})}}server.ErrorMessageTracker=Ki;class ea{constructor(){}rawAttach(ya){this._rawConnection=ya}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}fillServerCapabilities(ya){}initialize(ya){}error(ya){this.send(D.MessageType.Error,ya)}warn(ya){this.send(D.MessageType.Warning,ya)}info(ya){this.send(D.MessageType.Info,ya)}log(ya){this.send(D.MessageType.Log,ya)}debug(ya){this.send(D.MessageType.Debug,ya)}send(ya,Na){this._rawConnection&&this._rawConnection.sendNotification(D.LogMessageNotification.type,{type:ya,message:Na}).catch(()=>{(0,D.RAL)().console.error("Sending log message failed")})}}class Ji{constructor(){}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}showErrorMessage(ya,...Na){let za={type:D.MessageType.Error,message:ya,actions:Na};return this.connection.sendRequest(D.ShowMessageRequest.type,za).then(Xi)}showWarningMessage(ya,...Na){let za={type:D.MessageType.Warning,message:ya,actions:Na};return this.connection.sendRequest(D.ShowMessageRequest.type,za).then(Xi)}showInformationMessage(ya,...Na){let za={type:D.MessageType.Info,message:ya,actions:Na};return this.connection.sendRequest(D.ShowMessageRequest.type,za).then(Xi)}}const ta=(0,Or.ShowDocumentFeature)((0,J.ProgressFeature)(Ji));var na;(function(Ca){function ya(){return new ra}Ca.create=ya})(na||(server.BulkRegistration=na={}));class ra{constructor(){this._registrations=[],this._registered=new Set}add(ya,Na){const za=E.string(ya)?ya:ya.method;if(this._registered.has(za))throw new Error(`${za} is already added to this registration`);const Ta=F.generateUuid();this._registrations.push({id:Ta,method:za,registerOptions:Na||{}}),this._registered.add(za)}asRegistrationParams(){return{registrations:this._registrations}}}var ia;(function(Ca){function ya(){return new oa(void 0,[])}Ca.create=ya})(ia||(server.BulkUnregistration=ia={}));class oa{constructor(ya,Na){this._connection=ya,this._unregistrations=new Map,Na.forEach(za=>{this._unregistrations.set(za.method,za)})}get isAttached(){return!!this._connection}attach(ya){this._connection=ya}add(ya){this._unregistrations.set(ya.method,ya)}dispose(){let ya=[];for(let za of this._unregistrations.values())ya.push(za);let Na={unregisterations:ya};this._connection.sendRequest(D.UnregistrationRequest.type,Na).catch(()=>{this._connection.console.info("Bulk unregistration failed.")})}disposeSingle(ya){const Na=E.string(ya)?ya:ya.method,za=this._unregistrations.get(Na);if(!za)return!1;let Ta={unregisterations:[za]};return this._connection.sendRequest(D.UnregistrationRequest.type,Ta).then(()=>{this._unregistrations.delete(Na)},es=>{this._connection.console.info(`Un-registering request handler for ${za.id} failed.`)}),!0}}class ua{attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}register(ya,Na,za){return ya instanceof ra?this.registerMany(ya):ya instanceof oa?this.registerSingle1(ya,Na,za):this.registerSingle2(ya,Na)}registerSingle1(ya,Na,za){const Ta=E.string(Na)?Na:Na.method,es=F.generateUuid();let ts={registrations:[{id:es,method:Ta,registerOptions:za||{}}]};return ya.isAttached||ya.attach(this.connection),this.connection.sendRequest(D.RegistrationRequest.type,ts).then(Ka=>(ya.add({id:es,method:Ta}),ya),Ka=>(this.connection.console.info(`Registering request handler for ${Ta} failed.`),Promise.reject(Ka)))}registerSingle2(ya,Na){const za=E.string(ya)?ya:ya.method,Ta=F.generateUuid();let es={registrations:[{id:Ta,method:za,registerOptions:Na||{}}]};return this.connection.sendRequest(D.RegistrationRequest.type,es).then(ts=>D.Disposable.create(()=>{this.unregisterSingle(Ta,za).catch(()=>{this.connection.console.info(`Un-registering capability with id ${Ta} failed.`)})}),ts=>(this.connection.console.info(`Registering request handler for ${za} failed.`),Promise.reject(ts)))}unregisterSingle(ya,Na){let za={unregisterations:[{id:ya,method:Na}]};return this.connection.sendRequest(D.UnregistrationRequest.type,za).catch(()=>{this.connection.console.info(`Un-registering request handler for ${ya} failed.`)})}registerMany(ya){let Na=ya.asRegistrationParams();return this.connection.sendRequest(D.RegistrationRequest.type,Na).then(()=>new oa(this._connection,Na.registrations.map(za=>({id:za.id,method:za.method}))),za=>(this.connection.console.info("Bulk registration failed."),Promise.reject(za)))}}class sa{constructor(){}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}applyEdit(ya){function Na(Ta){return Ta&&!!Ta.edit}let za=Na(ya)?ya:{edit:ya};return this.connection.sendRequest(D.ApplyWorkspaceEditRequest.type,za)}}const aa=(0,Pr.FileOperationsFeature)((0,_t.WorkspaceFoldersFeature)((0,$e.ConfigurationFeature)(sa)));class pa{constructor(){this._trace=D.Trace.Off}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}set trace(ya){this._trace=ya}log(ya,Na){this._trace!==D.Trace.Off&&this.connection.sendNotification(D.LogTraceNotification.type,{message:ya,verbose:this._trace===D.Trace.Verbose?Na:void 0}).catch(()=>{})}}class ma{constructor(){}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}logEvent(ya){this.connection.sendNotification(D.TelemetryEventNotification.type,ya).catch(()=>{this.connection.console.log("Sending TelemetryEventNotification failed")})}}class la{constructor(){}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}attachWorkDoneProgress(ya){return(0,J.attachWorkDone)(this.connection,ya)}attachPartialResultProgress(ya,Na){return(0,J.attachPartialResult)(this.connection,Na)}}server._LanguagesImpl=la;const ha=(0,zi.FoldingRangeFeature)((0,Zi.MonikerFeature)((0,Qi.DiagnosticFeature)((0,Hi.InlayHintFeature)((0,qi.InlineValueFeature)((0,gi.TypeHierarchyFeature)((0,dn.LinkedEditingRangeFeature)((0,mr.SemanticTokensFeature)((0,lr.CallHierarchyFeature)(la)))))))));class ga{constructor(){}attach(ya){this._connection=ya}get connection(){if(!this._connection)throw new Error("Remote is not attached to a connection yet.");return this._connection}initialize(ya){}fillServerCapabilities(ya){}attachWorkDoneProgress(ya){return(0,J.attachWorkDone)(this.connection,ya)}attachPartialResultProgress(ya,Na){return(0,J.attachPartialResult)(this.connection,Na)}}server._NotebooksImpl=ga;const Aa=(0,Gi.NotebookSyncFeature)(ga);function Fa(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineConsoleFeatures=Fa;function $a(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineTelemetryFeatures=$a;function _a(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineTracerFeatures=_a;function fa(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineClientFeatures=fa;function ka(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineWindowFeatures=ka;function ba(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineWorkspaceFeatures=ba;function Pa(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineLanguagesFeatures=Pa;function Ia(Ca,ya){return function(Na){return ya(Ca(Na))}}server.combineNotebooksFeatures=Ia;function Da(Ca,ya){function Na(Ta,es,ts){return Ta&&es?ts(Ta,es):Ta||es}return{__brand:"features",console:Na(Ca.console,ya.console,Fa),tracer:Na(Ca.tracer,ya.tracer,_a),telemetry:Na(Ca.telemetry,ya.telemetry,$a),client:Na(Ca.client,ya.client,fa),window:Na(Ca.window,ya.window,ka),workspace:Na(Ca.workspace,ya.workspace,ba),languages:Na(Ca.languages,ya.languages,Pa),notebooks:Na(Ca.notebooks,ya.notebooks,Ia)}}server.combineFeatures=Da;function va(Ca,ya,Na){const za=Na&&Na.console?new(Na.console(ea)):new ea,Ta=Ca(za);za.rawAttach(Ta);const es=Na&&Na.tracer?new(Na.tracer(pa)):new pa,ts=Na&&Na.telemetry?new(Na.telemetry(ma)):new ma,Ka=Na&&Na.client?new(Na.client(ua)):new ua,ps=Na&&Na.window?new(Na.window(ta)):new ta,cs=Na&&Na.workspace?new(Na.workspace(aa)):new aa,xa=Na&&Na.languages?new(Na.languages(ha)):new ha,Ra=Na&&Na.notebooks?new(Na.notebooks(Aa)):new Aa,Va=[za,es,ts,Ka,ps,cs,xa,Ra];function Ga(Ua){return Ua instanceof Promise?Ua:E.thenable(Ua)?new Promise((Wa,wa)=>{Ua.then(qa=>Wa(qa),qa=>wa(qa))}):Promise.resolve(Ua)}let as,rs,ss,ms={listen:()=>Ta.listen(),sendRequest:(Ua,...Wa)=>Ta.sendRequest(E.string(Ua)?Ua:Ua.method,...Wa),onRequest:(Ua,Wa)=>Ta.onRequest(Ua,Wa),sendNotification:(Ua,Wa)=>{const wa=E.string(Ua)?Ua:Ua.method;return Ta.sendNotification(wa,Wa)},onNotification:(Ua,Wa)=>Ta.onNotification(Ua,Wa),onProgress:Ta.onProgress,sendProgress:Ta.sendProgress,onInitialize:Ua=>(rs=Ua,{dispose:()=>{rs=void 0}}),onInitialized:Ua=>Ta.onNotification(D.InitializedNotification.type,Ua),onShutdown:Ua=>(as=Ua,{dispose:()=>{as=void 0}}),onExit:Ua=>(ss=Ua,{dispose:()=>{ss=void 0}}),get console(){return za},get telemetry(){return ts},get tracer(){return es},get client(){return Ka},get window(){return ps},get workspace(){return cs},get languages(){return xa},get notebooks(){return Ra},onDidChangeConfiguration:Ua=>Ta.onNotification(D.DidChangeConfigurationNotification.type,Ua),onDidChangeWatchedFiles:Ua=>Ta.onNotification(D.DidChangeWatchedFilesNotification.type,Ua),__textDocumentSync:void 0,onDidOpenTextDocument:Ua=>Ta.onNotification(D.DidOpenTextDocumentNotification.type,Ua),onDidChangeTextDocument:Ua=>Ta.onNotification(D.DidChangeTextDocumentNotification.type,Ua),onDidCloseTextDocument:Ua=>Ta.onNotification(D.DidCloseTextDocumentNotification.type,Ua),onWillSaveTextDocument:Ua=>Ta.onNotification(D.WillSaveTextDocumentNotification.type,Ua),onWillSaveTextDocumentWaitUntil:Ua=>Ta.onRequest(D.WillSaveTextDocumentWaitUntilRequest.type,Ua),onDidSaveTextDocument:Ua=>Ta.onNotification(D.DidSaveTextDocumentNotification.type,Ua),sendDiagnostics:Ua=>Ta.sendNotification(D.PublishDiagnosticsNotification.type,Ua),onHover:Ua=>Ta.onRequest(D.HoverRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),onCompletion:Ua=>Ta.onRequest(D.CompletionRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onCompletionResolve:Ua=>Ta.onRequest(D.CompletionResolveRequest.type,Ua),onSignatureHelp:Ua=>Ta.onRequest(D.SignatureHelpRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),onDeclaration:Ua=>Ta.onRequest(D.DeclarationRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onDefinition:Ua=>Ta.onRequest(D.DefinitionRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onTypeDefinition:Ua=>Ta.onRequest(D.TypeDefinitionRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onImplementation:Ua=>Ta.onRequest(D.ImplementationRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onReferences:Ua=>Ta.onRequest(D.ReferencesRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onDocumentHighlight:Ua=>Ta.onRequest(D.DocumentHighlightRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onDocumentSymbol:Ua=>Ta.onRequest(D.DocumentSymbolRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onWorkspaceSymbol:Ua=>Ta.onRequest(D.WorkspaceSymbolRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onWorkspaceSymbolResolve:Ua=>Ta.onRequest(D.WorkspaceSymbolResolveRequest.type,Ua),onCodeAction:Ua=>Ta.onRequest(D.CodeActionRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onCodeActionResolve:Ua=>Ta.onRequest(D.CodeActionResolveRequest.type,(Wa,wa)=>Ua(Wa,wa)),onCodeLens:Ua=>Ta.onRequest(D.CodeLensRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onCodeLensResolve:Ua=>Ta.onRequest(D.CodeLensResolveRequest.type,(Wa,wa)=>Ua(Wa,wa)),onDocumentFormatting:Ua=>Ta.onRequest(D.DocumentFormattingRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),onDocumentRangeFormatting:Ua=>Ta.onRequest(D.DocumentRangeFormattingRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),onDocumentOnTypeFormatting:Ua=>Ta.onRequest(D.DocumentOnTypeFormattingRequest.type,(Wa,wa)=>Ua(Wa,wa)),onRenameRequest:Ua=>Ta.onRequest(D.RenameRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),onPrepareRename:Ua=>Ta.onRequest(D.PrepareRenameRequest.type,(Wa,wa)=>Ua(Wa,wa)),onDocumentLinks:Ua=>Ta.onRequest(D.DocumentLinkRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onDocumentLinkResolve:Ua=>Ta.onRequest(D.DocumentLinkResolveRequest.type,(Wa,wa)=>Ua(Wa,wa)),onDocumentColor:Ua=>Ta.onRequest(D.DocumentColorRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onColorPresentation:Ua=>Ta.onRequest(D.ColorPresentationRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onFoldingRanges:Ua=>Ta.onRequest(D.FoldingRangeRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onSelectionRanges:Ua=>Ta.onRequest(D.SelectionRangeRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),(0,J.attachPartialResult)(Ta,Wa))),onExecuteCommand:Ua=>Ta.onRequest(D.ExecuteCommandRequest.type,(Wa,wa)=>Ua(Wa,wa,(0,J.attachWorkDone)(Ta,Wa),void 0)),dispose:()=>Ta.dispose()};for(let Ua of Va)Ua.attach(ms);return Ta.onRequest(D.InitializeRequest.type,Ua=>{ya.initialize(Ua),E.string(Ua.trace)&&(es.trace=D.Trace.fromString(Ua.trace));for(let Wa of Va)Wa.initialize(Ua.capabilities);if(rs){let Wa=rs(Ua,new D.CancellationTokenSource().token,(0,J.attachWorkDone)(Ta,Ua),void 0);return Ga(Wa).then(wa=>{if(wa instanceof D.ResponseError)return wa;let qa=wa;qa||(qa={capabilities:{}});let ja=qa.capabilities;ja||(ja={},qa.capabilities=ja),ja.textDocumentSync===void 0||ja.textDocumentSync===null?ja.textDocumentSync=E.number(ms.__textDocumentSync)?ms.__textDocumentSync:D.TextDocumentSyncKind.None:!E.number(ja.textDocumentSync)&&!E.number(ja.textDocumentSync.change)&&(ja.textDocumentSync.change=E.number(ms.__textDocumentSync)?ms.__textDocumentSync:D.TextDocumentSyncKind.None);for(let Xa of Va)Xa.fillServerCapabilities(ja);return qa})}else{let Wa={capabilities:{textDocumentSync:D.TextDocumentSyncKind.None}};for(let wa of Va)wa.fillServerCapabilities(Wa.capabilities);return Wa}}),Ta.onRequest(D.ShutdownRequest.type,()=>{if(ya.shutdownReceived=!0,as)return as(new D.CancellationTokenSource().token)}),Ta.onNotification(D.ExitNotification.type,()=>{try{ss&&ss()}finally{ya.shutdownReceived?ya.exit(0):ya.exit(1)}}),Ta.onNotification(D.SetTraceNotification.type,Ua=>{es.trace=D.Trace.fromString(Ua.value)}),ms}return server.createConnection=va,server}var hasRequiredApi;function requireApi(){return hasRequiredApi||(hasRequiredApi=1,(function(D){var E=api$2&&api$2.__createBinding||(Object.create?(function(Or,Pr,dn,gi){gi===void 0&&(gi=dn);var qi=Object.getOwnPropertyDescriptor(Pr,dn);(!qi||("get"in qi?!Pr.__esModule:qi.writable||qi.configurable))&&(qi={enumerable:!0,get:function(){return Pr[dn]}}),Object.defineProperty(Or,gi,qi)}):(function(Or,Pr,dn,gi){gi===void 0&&(gi=dn),Or[gi]=Pr[dn]})),F=api$2&&api$2.__exportStar||function(Or,Pr){for(var dn in Or)dn!=="default"&&!Object.prototype.hasOwnProperty.call(Pr,dn)&&E(Pr,Or,dn)};Object.defineProperty(D,"__esModule",{value:!0}),D.ProposedFeatures=D.NotebookDocuments=D.TextDocuments=D.SemanticTokensBuilder=void 0;const J=requireSemanticTokens();Object.defineProperty(D,"SemanticTokensBuilder",{enumerable:!0,get:function(){return J.SemanticTokensBuilder}});const $e=requireInlineCompletion_proposed();F(requireMain$1(),D);const _t=requireTextDocuments();Object.defineProperty(D,"TextDocuments",{enumerable:!0,get:function(){return _t.TextDocuments}});const lr=requireNotebook();Object.defineProperty(D,"NotebookDocuments",{enumerable:!0,get:function(){return lr.NotebookDocuments}}),F(requireServer(),D);var mr;(function(Or){Or.all={__brand:"features",languages:$e.InlineCompletionFeature}})(mr||(D.ProposedFeatures=mr={}))})(api$2)),api$2}var browser$1,hasRequiredBrowser$1;function requireBrowser$1(){return hasRequiredBrowser$1||(hasRequiredBrowser$1=1,browser$1=requireMain$1()),browser$1}var hasRequiredMain;function requireMain(){return hasRequiredMain||(hasRequiredMain=1,(function(D){var E=main$3&&main$3.__createBinding||(Object.create?(function(mr,Or,Pr,dn){dn===void 0&&(dn=Pr);var gi=Object.getOwnPropertyDescriptor(Or,Pr);(!gi||("get"in gi?!Or.__esModule:gi.writable||gi.configurable))&&(gi={enumerable:!0,get:function(){return Or[Pr]}}),Object.defineProperty(mr,dn,gi)}):(function(mr,Or,Pr,dn){dn===void 0&&(dn=Pr),mr[dn]=Or[Pr]})),F=main$3&&main$3.__exportStar||function(mr,Or){for(var Pr in mr)Pr!=="default"&&!Object.prototype.hasOwnProperty.call(Or,Pr)&&E(Or,mr,Pr)};Object.defineProperty(D,"__esModule",{value:!0}),D.createConnection=void 0;const J=requireApi();F(requireBrowser$1(),D),F(requireApi(),D);let $e=!1;const _t={initialize:mr=>{},get shutdownReceived(){return $e},set shutdownReceived(mr){$e=mr},exit:mr=>{}};function lr(mr,Or,Pr,dn){let gi,qi,zi,Hi;mr!==void 0&&mr.__brand==="features"&&(gi=mr,mr=Or,Or=Pr,Pr=dn),J.ConnectionStrategy.is(mr)||J.ConnectionOptions.is(mr)?Hi=mr:(qi=mr,zi=Or,Hi=Pr);const Qi=Gi=>(0,J.createProtocolConnection)(qi,zi,Gi,Hi);return(0,J.createConnection)(Qi,_t,gi)}D.createConnection=lr})(main$3)),main$3}var browser,hasRequiredBrowser;function requireBrowser(){return hasRequiredBrowser||(hasRequiredBrowser=1,browser=requireMain()),browser}var browserExports=requireBrowser();function ccount(D,E){const F=String(D);if(typeof E!="string")throw new TypeError("Expected character");let J=0,$e=F.indexOf(E);for(;$e!==-1;)J++,$e=F.indexOf(E,$e+E.length);return J}const defaultSubsetRegex=/["&\'<>`]/g,surrogatePairsRegex=/[\\uD800-\\uDBFF][\\uDC00-\\uDFFF]/g,controlCharactersRegex=/[\\x01-\\t\\v\\f\\x0E-\\x1F\\x7F\\x81\\x8D\\x8F\\x90\\x9D\\xA0-\\uFFFF]/g,regexEscapeRegex=/[|\\\\{}()[\\]^$+*?.]/g,subsetToRegexCache=new WeakMap;function core$2(D,E){if(D=D.replace(E.subset?charactersToExpressionCached(E.subset):defaultSubsetRegex,J),E.subset||E.escapeOnly)return D;return D.replace(surrogatePairsRegex,F).replace(controlCharactersRegex,J);function F($e,_t,lr){return E.format(($e.charCodeAt(0)-55296)*1024+$e.charCodeAt(1)-56320+65536,lr.charCodeAt(_t+2),E)}function J($e,_t,lr){return E.format($e.charCodeAt(0),lr.charCodeAt(_t+1),E)}}function charactersToExpressionCached(D){let E=subsetToRegexCache.get(D);return E||(E=charactersToExpression(D),subsetToRegexCache.set(D,E)),E}function charactersToExpression(D){const E=[];let F=-1;for(;++F<D.length;)E.push(D[F].replace(regexEscapeRegex,"\\\\$&"));return new RegExp("(?:"+E.join("|")+")","g")}function formatBasic(D){return"&#x"+D.toString(16).toUpperCase()+";"}function stringifyEntitiesLight(D,E){return core$2(D,Object.assign({format:formatBasic},E))}function escape$1(D,E,F){const J=clean$1(D);return F?J.replace(F,$e):$e(J);function $e(_t){return stringifyEntitiesLight(_t,{subset:E}).replace(/&#x3C;/g,"&lt;").replace(/&#x26;/g,"&amp;")}}const nonCharacter=/[\\u0000-\\u0008\\u000B\\u000C\\u000E-\\u001F]/g;function clean$1(D){return String(D||"").replace(nonCharacter,"")}function name$a(D){return escape$1(D,["	",`\n`," ",\'"\',"&","\'","/","<","=",">"])}function mergeAdjacentTextInArray(D){if(!D.some((J,$e)=>J.type==="text"&&D[$e+1]?.type==="text"))return D;const F=[];for(let J=0;J<D.length;J++){let $e=D[J],_t=D[J+1];if(!_t){F.push($e);continue}if($e.type==="text"&&_t.type==="text")for($e={...$e},F.push($e);_t?.type==="text";)$e.value+=_t.value,$e.position&&_t.position&&($e.position.end=_t.position.end),J++,_t=D[J+1];else F.push($e)}return F}function findNodesWithPositionInfo(D){if(typeof D!="object"||D===null)return[];if(Array.isArray(D))return D.flatMap(findNodesWithPositionInfo);if(!("type"in D))return[];const E="position"in D?[D]:[];for(const F of Object.values(D))Array.isArray(F)&&E.push(...findNodesWithPositionInfo(F));return E}function macroToString(D){if(Array.isArray(D))return D.map(E=>macroToString(E)).join("");switch(D.type){case"macro":{const E=unwrappedMacroToString$1(D);let F="$",J="";return macroNeedsParens$1(D)&&(F+="(",J+=")"),F+E+J}case"function":{const E=unwrappedMacroToString$1(D.macro);let F="$$",J="";macroNeedsParens$1(D)&&(F+="(",J+=")");const $e=D.input?`(${D.input.map(macroToString).join(", ")})`:"";return F+E+J+$e}case"text":return toXml(D);default:console.warn("Unhandled node type",D)}return"$ERROR"}function unwrappedMacroToString$1(D){const E=macroPathToString$1(D.path),F=Object.values(D.attributes||{}).map(attrToString$1).join(" ");let J=F.length>0?`{${F}}`:"",$e="";return D.accessedProp&&($e="."+unwrappedMacroToString$1(D.accessedProp)),E+J+$e}function macroPathToString$1(D){return D.map(macroPathPartToString$1).join("/")}function macroPathPartToString$1(D){return D.name+D.index.map(E=>`[${macroToString(E.value)}]`).join("")}function attrToString$1(D){const E=D.name;if(D.children.length===0)return E;const F=D.children.map(macroToString).join("");return`${E}=${quote(F)}`}function macroNeedsParens$1(D){return D.type==="function"?macroNeedsParens$1(D.macro):D.path.length>1?!0:D.path.some(E=>E.name.includes("-"))||D.accessedProp!=null&&macroNeedsParens$1(D.accessedProp)}function toXml(D,E){if(E=E||{},!D)return"";const F=Array.isArray(D)?{type:"root",children:D}:D;return nodesToXml(F,E)}function nodesToXml(D,E){if(Array.isArray(D))return D.some(J=>J.type==="pathPart")?D.map(J=>nodesToXml(J,E)).join("."):mergeAdjacentTextInArray(D).map(J=>nodesToXml(J,E)).join("");const F=D&&D.type;switch(D?.type){case"root":return nodesToXml(D.children,E);case"cdata":{const J=/]]>/g,$e=[">"];return"<![CDATA["+escape$1(D.value,$e,J)+"]]>"}case"comment":return"<!--"+escape$1(D.value,["-"])+"-->";case"doctype":{const J=name$a(D.name),$e=D.public,_t=D.system;let lr="<!DOCTYPE";return J!==""&&(lr+=" "+J),$e?lr+=" PUBLIC "+quote($e):_t&&(lr+=" SYSTEM"),_t&&(lr+=" "+quote(_t)),lr+">"}case"attribute":return attrToString(D,E);case"element":{const J=name$a(D.name),$e=nodesToXml(D.children,E),_t=D.attributes||[],lr=Object.values(_t).map(Or=>attrToString(Or,E)),mr=(lr.length>0?" ":"")+lr.join(" ");return D.children.length===0||!E.inlineErrors&&D.children.every(Or=>Or.type==="error")?`<${J}${mr} />`:`<${J}${mr}>${$e}</${J}>`}case"instruction":{const J=/\\?>/g,$e=[">"],_t=name$a(D.name),lr=escape$1(D.value,$e,J);return"<?"+_t+(lr?" "+lr:"")+"?>"}case"text":{let J=escape$1(D.value,["&","<"]);return E.doenetSyntax&&(J=J.replace(/&lt;(?=\\s|=)/g,"<"),J=J.replace(/&amp;(?!\\S*;)/g,"&")),J}case"error":{if(E.inlineErrors){const J={type:"element",name:"_error",attributes:{message:{type:"attribute",name:"message",children:[{type:"text",value:D.message}]}},children:[{type:"text",value:D.message}]};return nodesToXml(J,E)}return""}case"macro":{if(D.version==="0.6")return macroToString(D);const J=unwrappedMacroToString(D,E);let $e="$",_t="";return macroNeedsParens(D)&&($e+="(",_t+=")"),$e+J+_t}case"function":{if(D.version==="0.6")return macroToString(D);const J=unwrappedMacroToString(D,E);let $e="$$",_t="";macroNeedsParens(D)&&($e+="(",_t+=")");const lr=D.input?`(${D.input.map(mr=>nodesToXml(mr,E)).join(", ")})`:"";return $e+J+_t+lr}case"pathPart":return D.name+D.index.map(J=>`[${nodesToXml(J.value,E)}]`).join("")}throw F?new Error("Cannot compile unknown node `"+F+"`"):new Error("Expected node, not `"+D+"`")}function quote(D){const E=String(D);let F=\'"\';const J=F===\'"\'?"\'":\'"\';return ccount(E,F)>ccount(E,J)&&(F=J),F+escape$1(E,["<",F])+F}function unwrappedMacroToString(D,E){const F=macroPathToString(D.path,E);let J="";if(D.type==="macro"){const _t=Object.values(D.attributes||{}).map(lr=>attrToString(lr,E)).join(" ");J=_t.length>0?`{${_t}}`:""}return F+J+""}function macroPathToString(D,E){return D.map(F=>macroPathPartToString(F,E)).join(".")}function macroPathPartToString(D,E){return D.name+D.index.map(F=>`[${nodesToXml(F.value,E)}]`).join("")}function attrToString(D,E){return D.children.length===0?E.doenetSyntax?name$a(D.name):`${name$a(D.name)}="true"`:`${name$a(D.name)}=${quote(nodesToXml(D.children,E))}`}function macroNeedsParens(D){return D.path.some(E=>E.name.includes("-"))}const StartTag=1,StartCloseTag=2,MissingCloseTag=3,mismatchedStartCloseTag=4,incompleteStartCloseTag=5,commentContent$1=36,piContent$1=37,cdataContent$1=38,Text=7,Element=12,EndTag=13,OpenTag=14,TagName=15,Attribute=16,AttributeValue=19,CloseTag=20,SelfCloseEndTag=21,SelfClosingTag=22,MismatchedCloseTag=25,DefaultBufferLength=1024;let nextPropID=0;class Range{constructor(E,F){this.from=E,this.to=F}}class NodeProp{constructor(E={}){this.id=nextPropID++,this.perNode=!!E.perNode,this.deserialize=E.deserialize||(()=>{throw new Error("This node type doesn\'t define a deserialize function")}),this.combine=E.combine||null}add(E){if(this.perNode)throw new RangeError("Can\'t add per-node props to node types");return typeof E!="function"&&(E=NodeType.match(E)),F=>{let J=E(F);return J===void 0?null:[this,J]}}}NodeProp.closedBy=new NodeProp({deserialize:D=>D.split(" ")}),NodeProp.openedBy=new NodeProp({deserialize:D=>D.split(" ")}),NodeProp.group=new NodeProp({deserialize:D=>D.split(" ")}),NodeProp.isolate=new NodeProp({deserialize:D=>{if(D&&D!="rtl"&&D!="ltr"&&D!="auto")throw new RangeError("Invalid value for isolate: "+D);return D||"auto"}}),NodeProp.contextHash=new NodeProp({perNode:!0}),NodeProp.lookAhead=new NodeProp({perNode:!0}),NodeProp.mounted=new NodeProp({perNode:!0});class MountedTree{constructor(E,F,J,$e=!1){this.tree=E,this.overlay=F,this.parser=J,this.bracketed=$e}static get(E){return E&&E.props&&E.props[NodeProp.mounted.id]}}const noProps=Object.create(null);class NodeType{constructor(E,F,J,$e=0){this.name=E,this.props=F,this.id=J,this.flags=$e}static define(E){let F=E.props&&E.props.length?Object.create(null):noProps,J=(E.top?1:0)|(E.skipped?2:0)|(E.error?4:0)|(E.name==null?8:0),$e=new NodeType(E.name||"",F,E.id,J);if(E.props){for(let _t of E.props)if(Array.isArray(_t)||(_t=_t($e)),_t){if(_t[0].perNode)throw new RangeError("Can\'t store a per-node prop on a node type");F[_t[0].id]=_t[1]}}return $e}prop(E){return this.props[E.id]}get isTop(){return(this.flags&1)>0}get isSkipped(){return(this.flags&2)>0}get isError(){return(this.flags&4)>0}get isAnonymous(){return(this.flags&8)>0}is(E){if(typeof E=="string"){if(this.name==E)return!0;let F=this.prop(NodeProp.group);return F?F.indexOf(E)>-1:!1}return this.id==E}static match(E){let F=Object.create(null);for(let J in E)for(let $e of J.split(" "))F[$e]=E[J];return J=>{for(let $e=J.prop(NodeProp.group),_t=-1;_t<($e?$e.length:0);_t++){let lr=F[_t<0?J.name:$e[_t]];if(lr)return lr}}}}NodeType.none=new NodeType("",Object.create(null),0,8);class NodeSet{constructor(E){this.types=E;for(let F=0;F<E.length;F++)if(E[F].id!=F)throw new RangeError("Node type ids should correspond to array positions when creating a node set")}extend(...E){let F=[];for(let J of this.types){let $e=null;for(let _t of E){let lr=_t(J);if(lr){$e||($e=Object.assign({},J.props));let mr=lr[1],Or=lr[0];Or.combine&&Or.id in $e&&(mr=Or.combine($e[Or.id],mr)),$e[Or.id]=mr}}F.push($e?new NodeType(J.name,$e,J.id,J.flags):J)}return new NodeSet(F)}}const CachedNode=new WeakMap,CachedInnerNode=new WeakMap;var IterMode;(function(D){D[D.ExcludeBuffers=1]="ExcludeBuffers",D[D.IncludeAnonymous=2]="IncludeAnonymous",D[D.IgnoreMounts=4]="IgnoreMounts",D[D.IgnoreOverlays=8]="IgnoreOverlays",D[D.EnterBracketed=16]="EnterBracketed"})(IterMode||(IterMode={}));class Tree{constructor(E,F,J,$e,_t){if(this.type=E,this.children=F,this.positions=J,this.length=$e,this.props=null,_t&&_t.length){this.props=Object.create(null);for(let[lr,mr]of _t)this.props[typeof lr=="number"?lr:lr.id]=mr}}toString(){let E=MountedTree.get(this);if(E&&!E.overlay)return E.tree.toString();let F="";for(let J of this.children){let $e=J.toString();$e&&(F&&(F+=","),F+=$e)}return this.type.name?(/\\W/.test(this.type.name)&&!this.type.isError?JSON.stringify(this.type.name):this.type.name)+(F.length?"("+F+")":""):F}cursor(E=0){return new TreeCursor(this.topNode,E)}cursorAt(E,F=0,J=0){let $e=CachedNode.get(this)||this.topNode,_t=new TreeCursor($e);return _t.moveTo(E,F),CachedNode.set(this,_t._tree),_t}get topNode(){return new TreeNode(this,0,0,null)}resolve(E,F=0){let J=resolveNode(CachedNode.get(this)||this.topNode,E,F,!1);return CachedNode.set(this,J),J}resolveInner(E,F=0){let J=resolveNode(CachedInnerNode.get(this)||this.topNode,E,F,!0);return CachedInnerNode.set(this,J),J}resolveStack(E,F=0){return stackIterator(this,E,F)}iterate(E){let{enter:F,leave:J,from:$e=0,to:_t=this.length}=E,lr=E.mode||0,mr=(lr&IterMode.IncludeAnonymous)>0;for(let Or=this.cursor(lr|IterMode.IncludeAnonymous);;){let Pr=!1;if(Or.from<=_t&&Or.to>=$e&&(!mr&&Or.type.isAnonymous||F(Or)!==!1)){if(Or.firstChild())continue;Pr=!0}for(;Pr&&J&&(mr||!Or.type.isAnonymous)&&J(Or),!Or.nextSibling();){if(!Or.parent())return;Pr=!0}}}prop(E){return E.perNode?this.props?this.props[E.id]:void 0:this.type.prop(E)}get propValues(){let E=[];if(this.props)for(let F in this.props)E.push([+F,this.props[F]]);return E}balance(E={}){return this.children.length<=8?this:balanceRange(NodeType.none,this.children,this.positions,0,this.children.length,0,this.length,(F,J,$e)=>new Tree(this.type,F,J,$e,this.propValues),E.makeTree||((F,J,$e)=>new Tree(NodeType.none,F,J,$e)))}static build(E){return buildTree(E)}}Tree.empty=new Tree(NodeType.none,[],[],0);class FlatBufferCursor{constructor(E,F){this.buffer=E,this.index=F}get id(){return this.buffer[this.index-4]}get start(){return this.buffer[this.index-3]}get end(){return this.buffer[this.index-2]}get size(){return this.buffer[this.index-1]}get pos(){return this.index}next(){this.index-=4}fork(){return new FlatBufferCursor(this.buffer,this.index)}}class TreeBuffer{constructor(E,F,J){this.buffer=E,this.length=F,this.set=J}get type(){return NodeType.none}toString(){let E=[];for(let F=0;F<this.buffer.length;)E.push(this.childString(F)),F=this.buffer[F+3];return E.join(",")}childString(E){let F=this.buffer[E],J=this.buffer[E+3],$e=this.set.types[F],_t=$e.name;if(/\\W/.test(_t)&&!$e.isError&&(_t=JSON.stringify(_t)),E+=4,J==E)return _t;let lr=[];for(;E<J;)lr.push(this.childString(E)),E=this.buffer[E+3];return _t+"("+lr.join(",")+")"}findChild(E,F,J,$e,_t){let{buffer:lr}=this,mr=-1;for(let Or=E;Or!=F&&!(checkSide(_t,$e,lr[Or+1],lr[Or+2])&&(mr=Or,J>0));Or=lr[Or+3]);return mr}slice(E,F,J){let $e=this.buffer,_t=new Uint16Array(F-E),lr=0;for(let mr=E,Or=0;mr<F;){_t[Or++]=$e[mr++],_t[Or++]=$e[mr++]-J;let Pr=_t[Or++]=$e[mr++]-J;_t[Or++]=$e[mr++]-E,lr=Math.max(lr,Pr)}return new TreeBuffer(_t,lr,this.set)}}function checkSide(D,E,F,J){switch(D){case-2:return F<E;case-1:return J>=E&&F<E;case 0:return F<E&&J>E;case 1:return F<=E&&J>E;case 2:return J>E;case 4:return!0}}function resolveNode(D,E,F,J){for(var $e;D.from==D.to||(F<1?D.from>=E:D.from>E)||(F>-1?D.to<=E:D.to<E);){let lr=!J&&D instanceof TreeNode&&D.index<0?null:D.parent;if(!lr)return D;D=lr}let _t=J?0:IterMode.IgnoreOverlays;if(J)for(let lr=D,mr=lr.parent;mr;lr=mr,mr=lr.parent)lr instanceof TreeNode&&lr.index<0&&(($e=mr.enter(E,F,_t))===null||$e===void 0?void 0:$e.from)!=lr.from&&(D=mr);for(;;){let lr=D.enter(E,F,_t);if(!lr)return D;D=lr}}class BaseNode{cursor(E=0){return new TreeCursor(this,E)}getChild(E,F=null,J=null){let $e=getChildren(this,E,F,J);return $e.length?$e[0]:null}getChildren(E,F=null,J=null){return getChildren(this,E,F,J)}resolve(E,F=0){return resolveNode(this,E,F,!1)}resolveInner(E,F=0){return resolveNode(this,E,F,!0)}matchContext(E){return matchNodeContext(this.parent,E)}enterUnfinishedNodesBefore(E){let F=this.childBefore(E),J=this;for(;F;){let $e=F.lastChild;if(!$e||$e.to!=F.to)break;$e.type.isError&&$e.from==$e.to?(J=F,F=$e.prevSibling):F=$e}return J}get node(){return this}get next(){return this.parent}}class TreeNode extends BaseNode{constructor(E,F,J,$e){super(),this._tree=E,this.from=F,this.index=J,this._parent=$e}get type(){return this._tree.type}get name(){return this._tree.type.name}get to(){return this.from+this._tree.length}nextChild(E,F,J,$e,_t=0){for(let lr=this;;){for(let{children:mr,positions:Or}=lr._tree,Pr=F>0?mr.length:-1;E!=Pr;E+=F){let dn=mr[E],gi=Or[E]+lr.from,qi;if(!(!(_t&IterMode.EnterBracketed&&dn instanceof Tree&&(qi=MountedTree.get(dn))&&!qi.overlay&&qi.bracketed&&J>=gi&&J<=gi+dn.length)&&!checkSide($e,J,gi,gi+dn.length))){if(dn instanceof TreeBuffer){if(_t&IterMode.ExcludeBuffers)continue;let zi=dn.findChild(0,dn.buffer.length,F,J-gi,$e);if(zi>-1)return new BufferNode(new BufferContext(lr,dn,E,gi),null,zi)}else if(_t&IterMode.IncludeAnonymous||!dn.type.isAnonymous||hasChild(dn)){let zi;if(!(_t&IterMode.IgnoreMounts)&&(zi=MountedTree.get(dn))&&!zi.overlay)return new TreeNode(zi.tree,gi,E,lr);let Hi=new TreeNode(dn,gi,E,lr);return _t&IterMode.IncludeAnonymous||!Hi.type.isAnonymous?Hi:Hi.nextChild(F<0?dn.children.length-1:0,F,J,$e,_t)}}}if(_t&IterMode.IncludeAnonymous||!lr.type.isAnonymous||(lr.index>=0?E=lr.index+F:E=F<0?-1:lr._parent._tree.children.length,lr=lr._parent,!lr))return null}}get firstChild(){return this.nextChild(0,1,0,4)}get lastChild(){return this.nextChild(this._tree.children.length-1,-1,0,4)}childAfter(E){return this.nextChild(0,1,E,2)}childBefore(E){return this.nextChild(this._tree.children.length-1,-1,E,-2)}prop(E){return this._tree.prop(E)}enter(E,F,J=0){let $e;if(!(J&IterMode.IgnoreOverlays)&&($e=MountedTree.get(this._tree))&&$e.overlay){let _t=E-this.from,lr=J&IterMode.EnterBracketed&&$e.bracketed;for(let{from:mr,to:Or}of $e.overlay)if((F>0||lr?mr<=_t:mr<_t)&&(F<0||lr?Or>=_t:Or>_t))return new TreeNode($e.tree,$e.overlay[0].from+this.from,-1,this)}return this.nextChild(0,1,E,F,J)}nextSignificantParent(){let E=this;for(;E.type.isAnonymous&&E._parent;)E=E._parent;return E}get parent(){return this._parent?this._parent.nextSignificantParent():null}get nextSibling(){return this._parent&&this.index>=0?this._parent.nextChild(this.index+1,1,0,4):null}get prevSibling(){return this._parent&&this.index>=0?this._parent.nextChild(this.index-1,-1,0,4):null}get tree(){return this._tree}toTree(){return this._tree}toString(){return this._tree.toString()}}function getChildren(D,E,F,J){let $e=D.cursor(),_t=[];if(!$e.firstChild())return _t;if(F!=null){for(let lr=!1;!lr;)if(lr=$e.type.is(F),!$e.nextSibling())return _t}for(;;){if(J!=null&&$e.type.is(J))return _t;if($e.type.is(E)&&_t.push($e.node),!$e.nextSibling())return J==null?_t:[]}}function matchNodeContext(D,E,F=E.length-1){for(let J=D;F>=0;J=J.parent){if(!J)return!1;if(!J.type.isAnonymous){if(E[F]&&E[F]!=J.name)return!1;F--}}return!0}class BufferContext{constructor(E,F,J,$e){this.parent=E,this.buffer=F,this.index=J,this.start=$e}}class BufferNode extends BaseNode{get name(){return this.type.name}get from(){return this.context.start+this.context.buffer.buffer[this.index+1]}get to(){return this.context.start+this.context.buffer.buffer[this.index+2]}constructor(E,F,J){super(),this.context=E,this._parent=F,this.index=J,this.type=E.buffer.set.types[E.buffer.buffer[J]]}child(E,F,J){let{buffer:$e}=this.context,_t=$e.findChild(this.index+4,$e.buffer[this.index+3],E,F-this.context.start,J);return _t<0?null:new BufferNode(this.context,this,_t)}get firstChild(){return this.child(1,0,4)}get lastChild(){return this.child(-1,0,4)}childAfter(E){return this.child(1,E,2)}childBefore(E){return this.child(-1,E,-2)}prop(E){return this.type.prop(E)}enter(E,F,J=0){if(J&IterMode.ExcludeBuffers)return null;let{buffer:$e}=this.context,_t=$e.findChild(this.index+4,$e.buffer[this.index+3],F>0?1:-1,E-this.context.start,F);return _t<0?null:new BufferNode(this.context,this,_t)}get parent(){return this._parent||this.context.parent.nextSignificantParent()}externalSibling(E){return this._parent?null:this.context.parent.nextChild(this.context.index+E,E,0,4)}get nextSibling(){let{buffer:E}=this.context,F=E.buffer[this.index+3];return F<(this._parent?E.buffer[this._parent.index+3]:E.buffer.length)?new BufferNode(this.context,this._parent,F):this.externalSibling(1)}get prevSibling(){let{buffer:E}=this.context,F=this._parent?this._parent.index+4:0;return this.index==F?this.externalSibling(-1):new BufferNode(this.context,this._parent,E.findChild(F,this.index,-1,0,4))}get tree(){return null}toTree(){let E=[],F=[],{buffer:J}=this.context,$e=this.index+4,_t=J.buffer[this.index+3];if(_t>$e){let lr=J.buffer[this.index+1];E.push(J.slice($e,_t,lr)),F.push(0)}return new Tree(this.type,E,F,this.to-this.from)}toString(){return this.context.buffer.childString(this.index)}}function iterStack(D){if(!D.length)return null;let E=0,F=D[0];for(let _t=1;_t<D.length;_t++){let lr=D[_t];(lr.from>F.from||lr.to<F.to)&&(F=lr,E=_t)}let J=F instanceof TreeNode&&F.index<0?null:F.parent,$e=D.slice();return J?$e[E]=J:$e.splice(E,1),new StackIterator($e,F)}class StackIterator{constructor(E,F){this.heads=E,this.node=F}get next(){return iterStack(this.heads)}}function stackIterator(D,E,F){let J=D.resolveInner(E,F),$e=null;for(let _t=J instanceof TreeNode?J:J.context.parent;_t;_t=_t.parent)if(_t.index<0){let lr=_t.parent;($e||($e=[J])).push(lr.resolve(E,F)),_t=lr}else{let lr=MountedTree.get(_t.tree);if(lr&&lr.overlay&&lr.overlay[0].from<=E&&lr.overlay[lr.overlay.length-1].to>=E){let mr=new TreeNode(lr.tree,lr.overlay[0].from+_t.from,-1,_t);($e||($e=[J])).push(resolveNode(mr,E,F,!1))}}return $e?iterStack($e):J}class TreeCursor{get name(){return this.type.name}constructor(E,F=0){if(this.buffer=null,this.stack=[],this.index=0,this.bufferNode=null,this.mode=F&~IterMode.EnterBracketed,E instanceof TreeNode)this.yieldNode(E);else{this._tree=E.context.parent,this.buffer=E.context;for(let J=E._parent;J;J=J._parent)this.stack.unshift(J.index);this.bufferNode=E,this.yieldBuf(E.index)}}yieldNode(E){return E?(this._tree=E,this.type=E.type,this.from=E.from,this.to=E.to,!0):!1}yieldBuf(E,F){this.index=E;let{start:J,buffer:$e}=this.buffer;return this.type=F||$e.set.types[$e.buffer[E]],this.from=J+$e.buffer[E+1],this.to=J+$e.buffer[E+2],!0}yield(E){return E?E instanceof TreeNode?(this.buffer=null,this.yieldNode(E)):(this.buffer=E.context,this.yieldBuf(E.index,E.type)):!1}toString(){return this.buffer?this.buffer.buffer.childString(this.index):this._tree.toString()}enterChild(E,F,J){if(!this.buffer)return this.yield(this._tree.nextChild(E<0?this._tree._tree.children.length-1:0,E,F,J,this.mode));let{buffer:$e}=this.buffer,_t=$e.findChild(this.index+4,$e.buffer[this.index+3],E,F-this.buffer.start,J);return _t<0?!1:(this.stack.push(this.index),this.yieldBuf(_t))}firstChild(){return this.enterChild(1,0,4)}lastChild(){return this.enterChild(-1,0,4)}childAfter(E){return this.enterChild(1,E,2)}childBefore(E){return this.enterChild(-1,E,-2)}enter(E,F,J=this.mode){return this.buffer?J&IterMode.ExcludeBuffers?!1:this.enterChild(1,E,F):this.yield(this._tree.enter(E,F,J))}parent(){if(!this.buffer)return this.yieldNode(this.mode&IterMode.IncludeAnonymous?this._tree._parent:this._tree.parent);if(this.stack.length)return this.yieldBuf(this.stack.pop());let E=this.mode&IterMode.IncludeAnonymous?this.buffer.parent:this.buffer.parent.nextSignificantParent();return this.buffer=null,this.yieldNode(E)}sibling(E){if(!this.buffer)return this._tree._parent?this.yield(this._tree.index<0?null:this._tree._parent.nextChild(this._tree.index+E,E,0,4,this.mode)):!1;let{buffer:F}=this.buffer,J=this.stack.length-1;if(E<0){let $e=J<0?0:this.stack[J]+4;if(this.index!=$e)return this.yieldBuf(F.findChild($e,this.index,-1,0,4))}else{let $e=F.buffer[this.index+3];if($e<(J<0?F.buffer.length:F.buffer[this.stack[J]+3]))return this.yieldBuf($e)}return J<0?this.yield(this.buffer.parent.nextChild(this.buffer.index+E,E,0,4,this.mode)):!1}nextSibling(){return this.sibling(1)}prevSibling(){return this.sibling(-1)}atLastNode(E){let F,J,{buffer:$e}=this;if($e){if(E>0){if(this.index<$e.buffer.buffer.length)return!1}else for(let _t=0;_t<this.index;_t++)if($e.buffer.buffer[_t+3]<this.index)return!1;({index:F,parent:J}=$e)}else({index:F,_parent:J}=this._tree);for(;J;{index:F,_parent:J}=J)if(F>-1)for(let _t=F+E,lr=E<0?-1:J._tree.children.length;_t!=lr;_t+=E){let mr=J._tree.children[_t];if(this.mode&IterMode.IncludeAnonymous||mr instanceof TreeBuffer||!mr.type.isAnonymous||hasChild(mr))return!1}return!0}move(E,F){if(F&&this.enterChild(E,0,4))return!0;for(;;){if(this.sibling(E))return!0;if(this.atLastNode(E)||!this.parent())return!1}}next(E=!0){return this.move(1,E)}prev(E=!0){return this.move(-1,E)}moveTo(E,F=0){for(;(this.from==this.to||(F<1?this.from>=E:this.from>E)||(F>-1?this.to<=E:this.to<E))&&this.parent(););for(;this.enterChild(1,E,F););return this}get node(){if(!this.buffer)return this._tree;let E=this.bufferNode,F=null,J=0;if(E&&E.context==this.buffer)e:for(let $e=this.index,_t=this.stack.length;_t>=0;){for(let lr=E;lr;lr=lr._parent)if(lr.index==$e){if($e==this.index)return lr;F=lr,J=_t+1;break e}$e=this.stack[--_t]}for(let $e=J;$e<this.stack.length;$e++)F=new BufferNode(this.buffer,F,this.stack[$e]);return this.bufferNode=new BufferNode(this.buffer,F,this.index)}get tree(){return this.buffer?null:this._tree._tree}iterate(E,F){for(let J=0;;){let $e=!1;if(this.type.isAnonymous||E(this)!==!1){if(this.firstChild()){J++;continue}this.type.isAnonymous||($e=!0)}for(;;){if($e&&F&&F(this),$e=this.type.isAnonymous,!J)return;if(this.nextSibling())break;this.parent(),J--,$e=!0}}}matchContext(E){if(!this.buffer)return matchNodeContext(this.node.parent,E);let{buffer:F}=this.buffer,{types:J}=F.set;for(let $e=E.length-1,_t=this.stack.length-1;$e>=0;_t--){if(_t<0)return matchNodeContext(this._tree,E,$e);let lr=J[F.buffer[this.stack[_t]]];if(!lr.isAnonymous){if(E[$e]&&E[$e]!=lr.name)return!1;$e--}}return!0}}function hasChild(D){return D.children.some(E=>E instanceof TreeBuffer||!E.type.isAnonymous||hasChild(E))}function buildTree(D){var E;let{buffer:F,nodeSet:J,maxBufferLength:$e=DefaultBufferLength,reused:_t=[],minRepeatType:lr=J.types.length}=D,mr=Array.isArray(F)?new FlatBufferCursor(F,F.length):F,Or=J.types,Pr=0,dn=0;function gi(Ji,ta,na,ra,ia,oa){let{id:ua,start:sa,end:aa,size:pa}=mr,ma=dn,la=Pr;if(pa<0)if(mr.next(),pa==-1){let $a=_t[ua];na.push($a),ra.push(sa-Ji);return}else if(pa==-3){Pr=ua;return}else if(pa==-4){dn=ua;return}else throw new RangeError(`Unrecognized record size: ${pa}`);let ha=Or[ua],ga,Aa,Fa=sa-Ji;if(aa-sa<=$e&&(Aa=Gi(mr.pos-ta,ia))){let $a=new Uint16Array(Aa.size-Aa.skip),_a=mr.pos-Aa.size,fa=$a.length;for(;mr.pos>_a;)fa=Zi(Aa.start,$a,fa);ga=new TreeBuffer($a,aa-Aa.start,J),Fa=Aa.start-Ji}else{let $a=mr.pos-pa;mr.next();let _a=[],fa=[],ka=ua>=lr?ua:-1,ba=0,Pa=aa;for(;mr.pos>$a;)ka>=0&&mr.id==ka&&mr.size>=0?(mr.end<=Pa-$e&&(Hi(_a,fa,sa,ba,mr.end,Pa,ka,ma,la),ba=_a.length,Pa=mr.end),mr.next()):oa>2500?qi(sa,$a,_a,fa):gi(sa,$a,_a,fa,ka,oa+1);if(ka>=0&&ba>0&&ba<_a.length&&Hi(_a,fa,sa,ba,sa,Pa,ka,ma,la),_a.reverse(),fa.reverse(),ka>-1&&ba>0){let Ia=zi(ha,la);ga=balanceRange(ha,_a,fa,0,_a.length,0,aa-sa,Ia,Ia)}else ga=Qi(ha,_a,fa,aa-sa,ma-aa,la)}na.push(ga),ra.push(Fa)}function qi(Ji,ta,na,ra){let ia=[],oa=0,ua=-1;for(;mr.pos>ta;){let{id:sa,start:aa,end:pa,size:ma}=mr;if(ma>4)mr.next();else{if(ua>-1&&aa<ua)break;ua<0&&(ua=pa-$e),ia.push(sa,aa,pa),oa++,mr.next()}}if(oa){let sa=new Uint16Array(oa*4),aa=ia[ia.length-2];for(let pa=ia.length-3,ma=0;pa>=0;pa-=3)sa[ma++]=ia[pa],sa[ma++]=ia[pa+1]-aa,sa[ma++]=ia[pa+2]-aa,sa[ma++]=ma;na.push(new TreeBuffer(sa,ia[2]-aa,J)),ra.push(aa-Ji)}}function zi(Ji,ta){return(na,ra,ia)=>{let oa=0,ua=na.length-1,sa,aa;if(ua>=0&&(sa=na[ua])instanceof Tree){if(!ua&&sa.type==Ji&&sa.length==ia)return sa;(aa=sa.prop(NodeProp.lookAhead))&&(oa=ra[ua]+sa.length+aa)}return Qi(Ji,na,ra,ia,oa,ta)}}function Hi(Ji,ta,na,ra,ia,oa,ua,sa,aa){let pa=[],ma=[];for(;Ji.length>ra;)pa.push(Ji.pop()),ma.push(ta.pop()+na-ia);Ji.push(Qi(J.types[ua],pa,ma,oa-ia,sa-oa,aa)),ta.push(ia-na)}function Qi(Ji,ta,na,ra,ia,oa,ua){if(oa){let sa=[NodeProp.contextHash,oa];ua=ua?[sa].concat(ua):[sa]}if(ia>25){let sa=[NodeProp.lookAhead,ia];ua=ua?[sa].concat(ua):[sa]}return new Tree(Ji,ta,na,ra,ua)}function Gi(Ji,ta){let na=mr.fork(),ra=0,ia=0,oa=0,ua=na.end-$e,sa={size:0,start:0,skip:0};e:for(let aa=na.pos-Ji;na.pos>aa;){let pa=na.size;if(na.id==ta&&pa>=0){sa.size=ra,sa.start=ia,sa.skip=oa,oa+=4,ra+=4,na.next();continue}let ma=na.pos-pa;if(pa<0||ma<aa||na.start<ua)break;let la=na.id>=lr?4:0,ha=na.start;for(na.next();na.pos>ma;){if(na.size<0)if(na.size==-3||na.size==-4)la+=4;else break e;else na.id>=lr&&(la+=4);na.next()}ia=ha,ra+=pa,oa+=la}return(ta<0||ra==Ji)&&(sa.size=ra,sa.start=ia,sa.skip=oa),sa.size>4?sa:void 0}function Zi(Ji,ta,na){let{id:ra,start:ia,end:oa,size:ua}=mr;if(mr.next(),ua>=0&&ra<lr){let sa=na;if(ua>4){let aa=mr.pos-(ua-4);for(;mr.pos>aa;)na=Zi(Ji,ta,na)}ta[--na]=sa,ta[--na]=oa-Ji,ta[--na]=ia-Ji,ta[--na]=ra}else ua==-3?Pr=ra:ua==-4&&(dn=ra);return na}let Xi=[],Ki=[];for(;mr.pos>0;)gi(D.start||0,D.bufferStart||0,Xi,Ki,-1,0);let ea=(E=D.length)!==null&&E!==void 0?E:Xi.length?Ki[0]+Xi[0].length:0;return new Tree(Or[D.topID],Xi.reverse(),Ki.reverse(),ea)}const nodeSizeCache=new WeakMap;function nodeSize(D,E){if(!D.isAnonymous||E instanceof TreeBuffer||E.type!=D)return 1;let F=nodeSizeCache.get(E);if(F==null){F=1;for(let J of E.children){if(J.type!=D||!(J instanceof Tree)){F=1;break}F+=nodeSize(D,J)}nodeSizeCache.set(E,F)}return F}function balanceRange(D,E,F,J,$e,_t,lr,mr,Or){let Pr=0;for(let Hi=J;Hi<$e;Hi++)Pr+=nodeSize(D,E[Hi]);let dn=Math.ceil(Pr*1.5/8),gi=[],qi=[];function zi(Hi,Qi,Gi,Zi,Xi){for(let Ki=Gi;Ki<Zi;){let ea=Ki,Ji=Qi[Ki],ta=nodeSize(D,Hi[Ki]);for(Ki++;Ki<Zi;Ki++){let na=nodeSize(D,Hi[Ki]);if(ta+na>=dn)break;ta+=na}if(Ki==ea+1){if(ta>dn){let na=Hi[ea];zi(na.children,na.positions,0,na.children.length,Qi[ea]+Xi);continue}gi.push(Hi[ea])}else{let na=Qi[Ki-1]+Hi[Ki-1].length-Ji;gi.push(balanceRange(D,Hi,Qi,ea,Ki,Ji,na,null,Or))}qi.push(Ji+Xi-_t)}}return zi(E,F,J,$e,0),(mr||Or)(gi,qi,lr)}class Parser{startParse(E,F,J){return typeof E=="string"&&(E=new StringInput(E)),J=J?J.length?J.map($e=>new Range($e.from,$e.to)):[new Range(0,0)]:[new Range(0,E.length)],this.createParse(E,F||[],J)}parse(E,F,J){let $e=this.startParse(E,F,J);for(;;){let _t=$e.advance();if(_t)return _t}}}class StringInput{constructor(E){this.string=E}get length(){return this.string.length}chunk(E){return this.string.slice(E)}get lineChunks(){return!1}read(E,F){return this.string.slice(E,F)}}new NodeProp({perNode:!0});class Stack{constructor(E,F,J,$e,_t,lr,mr,Or,Pr,dn=0,gi){this.p=E,this.stack=F,this.state=J,this.reducePos=$e,this.pos=_t,this.score=lr,this.buffer=mr,this.bufferBase=Or,this.curContext=Pr,this.lookAhead=dn,this.parent=gi}toString(){return`[${this.stack.filter((E,F)=>F%3==0).concat(this.state)}]@${this.pos}${this.score?"!"+this.score:""}`}static start(E,F,J=0){let $e=E.parser.context;return new Stack(E,[],F,J,J,0,[],0,$e?new StackContext($e,$e.start):null,0,null)}get context(){return this.curContext?this.curContext.context:null}pushState(E,F){this.stack.push(this.state,F,this.bufferBase+this.buffer.length),this.state=E}reduce(E){var F;let J=E>>19,$e=E&65535,{parser:_t}=this.p,lr=this.reducePos<this.pos-25&&this.setLookAhead(this.pos),mr=_t.dynamicPrecedence($e);if(mr&&(this.score+=mr),J==0){$e<_t.minRepeatTerm&&this.reducePos<this.pos&&(this.reducePos=this.pos),this.pushState(_t.getGoto(this.state,$e,!0),this.reducePos),$e<_t.minRepeatTerm&&this.storeNode($e,this.reducePos,this.reducePos,lr?8:4,!0),this.reduceContext($e,this.reducePos);return}let Or=this.stack.length-(J-1)*3-(E&262144?6:0),Pr=Or?this.stack[Or-2]:this.p.ranges[0].from;$e<_t.minRepeatTerm&&Pr==this.reducePos&&this.reducePos<this.pos&&(this.reducePos=this.pos);let dn=this.reducePos-Pr;dn>=2e3&&!(!((F=this.p.parser.nodeSet.types[$e])===null||F===void 0)&&F.isAnonymous)&&(Pr==this.p.lastBigReductionStart?(this.p.bigReductionCount++,this.p.lastBigReductionSize=dn):this.p.lastBigReductionSize<dn&&(this.p.bigReductionCount=1,this.p.lastBigReductionStart=Pr,this.p.lastBigReductionSize=dn));let gi=Or?this.stack[Or-1]:0,qi=this.bufferBase+this.buffer.length-gi;if($e<_t.minRepeatTerm||E&131072){let zi=_t.stateFlag(this.state,1)?this.pos:this.reducePos;this.storeNode($e,Pr,zi,qi+4,!0)}if(E&262144)this.state=this.stack[Or];else{let zi=this.stack[Or-3];this.state=_t.getGoto(zi,$e,!0)}for(;this.stack.length>Or;)this.stack.pop();this.reduceContext($e,Pr)}storeNode(E,F,J,$e=4,_t=!1){if(E==0&&(!this.stack.length||this.stack[this.stack.length-1]<this.buffer.length+this.bufferBase)){let lr=this.buffer.length;if(lr>0&&this.buffer[lr-4]==0&&this.buffer[lr-1]>-1){if(F==J)return;if(this.buffer[lr-2]>=F){this.buffer[lr-2]=J;return}}}if(!_t||this.pos==J)this.buffer.push(E,F,J,$e);else{let lr=this.buffer.length;if(lr>0&&(this.buffer[lr-4]!=0||this.buffer[lr-1]<0)){let mr=!1;for(let Or=lr;Or>0&&this.buffer[Or-2]>J;Or-=4)if(this.buffer[Or-1]>=0){mr=!0;break}if(mr)for(;lr>0&&this.buffer[lr-2]>J;)this.buffer[lr]=this.buffer[lr-4],this.buffer[lr+1]=this.buffer[lr-3],this.buffer[lr+2]=this.buffer[lr-2],this.buffer[lr+3]=this.buffer[lr-1],lr-=4,$e>4&&($e-=4)}this.buffer[lr]=E,this.buffer[lr+1]=F,this.buffer[lr+2]=J,this.buffer[lr+3]=$e}}shift(E,F,J,$e){if(E&131072)this.pushState(E&65535,this.pos);else if((E&262144)==0){let _t=E,{parser:lr}=this.p;this.pos=$e;let mr=lr.stateFlag(_t,1);!mr&&($e>J||F<=lr.maxNode)&&(this.reducePos=$e),this.pushState(_t,mr?J:Math.min(J,this.reducePos)),this.shiftContext(F,J),F<=lr.maxNode&&this.buffer.push(F,J,$e,4)}else this.pos=$e,this.shiftContext(F,J),F<=this.p.parser.maxNode&&this.buffer.push(F,J,$e,4)}apply(E,F,J,$e){E&65536?this.reduce(E):this.shift(E,F,J,$e)}useNode(E,F){let J=this.p.reused.length-1;(J<0||this.p.reused[J]!=E)&&(this.p.reused.push(E),J++);let $e=this.pos;this.reducePos=this.pos=$e+E.length,this.pushState(F,$e),this.buffer.push(J,$e,this.reducePos,-1),this.curContext&&this.updateContext(this.curContext.tracker.reuse(this.curContext.context,E,this,this.p.stream.reset(this.pos-E.length)))}split(){let E=this,F=E.buffer.length;for(F&&E.buffer[F-4]==0&&(F-=4);F>0&&E.buffer[F-2]>E.reducePos;)F-=4;let J=E.buffer.slice(F),$e=E.bufferBase+F;for(;E&&$e==E.bufferBase;)E=E.parent;return new Stack(this.p,this.stack.slice(),this.state,this.reducePos,this.pos,this.score,J,$e,this.curContext,this.lookAhead,E)}recoverByDelete(E,F){let J=E<=this.p.parser.maxNode;J&&this.storeNode(E,this.pos,F,4),this.storeNode(0,this.pos,F,J?8:4),this.pos=this.reducePos=F,this.score-=190}canShift(E){for(let F=new SimulatedStack(this);;){let J=this.p.parser.stateSlot(F.state,4)||this.p.parser.hasAction(F.state,E);if(J==0)return!1;if((J&65536)==0)return!0;F.reduce(J)}}recoverByInsert(E){if(this.stack.length>=300)return[];let F=this.p.parser.nextStates(this.state);if(F.length>8||this.stack.length>=120){let $e=[];for(let _t=0,lr;_t<F.length;_t+=2)(lr=F[_t+1])!=this.state&&this.p.parser.hasAction(lr,E)&&$e.push(F[_t],lr);if(this.stack.length<120)for(let _t=0;$e.length<8&&_t<F.length;_t+=2){let lr=F[_t+1];$e.some((mr,Or)=>Or&1&&mr==lr)||$e.push(F[_t],lr)}F=$e}let J=[];for(let $e=0;$e<F.length&&J.length<4;$e+=2){let _t=F[$e+1];if(_t==this.state)continue;let lr=this.split();lr.pushState(_t,this.pos),lr.storeNode(0,lr.pos,lr.pos,4,!0),lr.shiftContext(F[$e],this.pos),lr.reducePos=this.pos,lr.score-=200,J.push(lr)}return J}forceReduce(){let{parser:E}=this.p,F=E.stateSlot(this.state,5);if((F&65536)==0)return!1;if(!E.validAction(this.state,F)){let J=F>>19,$e=F&65535,_t=this.stack.length-J*3;if(_t<0||E.getGoto(this.stack[_t],$e,!1)<0){let lr=this.findForcedReduction();if(lr==null)return!1;F=lr}this.storeNode(0,this.pos,this.pos,4,!0),this.score-=100}return this.reducePos=this.pos,this.reduce(F),!0}findForcedReduction(){let{parser:E}=this.p,F=[],J=($e,_t)=>{if(!F.includes($e))return F.push($e),E.allActions($e,lr=>{if(!(lr&393216))if(lr&65536){let mr=(lr>>19)-_t;if(mr>1){let Or=lr&65535,Pr=this.stack.length-mr*3;if(Pr>=0&&E.getGoto(this.stack[Pr],Or,!1)>=0)return mr<<19|65536|Or}}else{let mr=J(lr,_t+1);if(mr!=null)return mr}})};return J(this.state,0)}forceAll(){for(;!this.p.parser.stateFlag(this.state,2);)if(!this.forceReduce()){this.storeNode(0,this.pos,this.pos,4,!0);break}return this}get deadEnd(){if(this.stack.length!=3)return!1;let{parser:E}=this.p;return E.data[E.stateSlot(this.state,1)]==65535&&!E.stateSlot(this.state,4)}restart(){this.storeNode(0,this.pos,this.pos,4,!0),this.state=this.stack[0],this.stack.length=0}sameState(E){if(this.state!=E.state||this.stack.length!=E.stack.length)return!1;for(let F=0;F<this.stack.length;F+=3)if(this.stack[F]!=E.stack[F])return!1;return!0}get parser(){return this.p.parser}dialectEnabled(E){return this.p.parser.dialect.flags[E]}shiftContext(E,F){this.curContext&&this.updateContext(this.curContext.tracker.shift(this.curContext.context,E,this,this.p.stream.reset(F)))}reduceContext(E,F){this.curContext&&this.updateContext(this.curContext.tracker.reduce(this.curContext.context,E,this,this.p.stream.reset(F)))}emitContext(){let E=this.buffer.length-1;(E<0||this.buffer[E]!=-3)&&this.buffer.push(this.curContext.hash,this.pos,this.pos,-3)}emitLookAhead(){let E=this.buffer.length-1;(E<0||this.buffer[E]!=-4)&&this.buffer.push(this.lookAhead,this.pos,this.pos,-4)}updateContext(E){if(E!=this.curContext.context){let F=new StackContext(this.curContext.tracker,E);F.hash!=this.curContext.hash&&this.emitContext(),this.curContext=F}}setLookAhead(E){return E<=this.lookAhead?!1:(this.emitLookAhead(),this.lookAhead=E,!0)}close(){this.curContext&&this.curContext.tracker.strict&&this.emitContext(),this.lookAhead>0&&this.emitLookAhead()}}class StackContext{constructor(E,F){this.tracker=E,this.context=F,this.hash=E.strict?E.hash(F):0}}class SimulatedStack{constructor(E){this.start=E,this.state=E.state,this.stack=E.stack,this.base=this.stack.length}reduce(E){let F=E&65535,J=E>>19;J==0?(this.stack==this.start.stack&&(this.stack=this.stack.slice()),this.stack.push(this.state,0,0),this.base+=3):this.base-=(J-1)*3;let $e=this.start.p.parser.getGoto(this.stack[this.base-3],F,!0);this.state=$e}}class StackBufferCursor{constructor(E,F,J){this.stack=E,this.pos=F,this.index=J,this.buffer=E.buffer,this.index==0&&this.maybeNext()}static create(E,F=E.bufferBase+E.buffer.length){return new StackBufferCursor(E,F,F-E.bufferBase)}maybeNext(){let E=this.stack.parent;E!=null&&(this.index=this.stack.bufferBase-E.bufferBase,this.stack=E,this.buffer=E.buffer)}get id(){return this.buffer[this.index-4]}get start(){return this.buffer[this.index-3]}get end(){return this.buffer[this.index-2]}get size(){return this.buffer[this.index-1]}next(){this.index-=4,this.pos-=4,this.index==0&&this.maybeNext()}fork(){return new StackBufferCursor(this.stack,this.pos,this.index)}}function decodeArray(D,E=Uint16Array){if(typeof D!="string")return D;let F=null;for(let J=0,$e=0;J<D.length;){let _t=0;for(;;){let lr=D.charCodeAt(J++),mr=!1;if(lr==126){_t=65535;break}lr>=92&&lr--,lr>=34&&lr--;let Or=lr-32;if(Or>=46&&(Or-=46,mr=!0),_t+=Or,mr)break;_t*=46}F?F[$e++]=_t:F=new E(_t)}return F}class CachedToken{constructor(){this.start=-1,this.value=-1,this.end=-1,this.extended=-1,this.lookAhead=0,this.mask=0,this.context=0}}const nullToken=new CachedToken;class InputStream{constructor(E,F){this.input=E,this.ranges=F,this.chunk="",this.chunkOff=0,this.chunk2="",this.chunk2Pos=0,this.next=-1,this.token=nullToken,this.rangeIndex=0,this.pos=this.chunkPos=F[0].from,this.range=F[0],this.end=F[F.length-1].to,this.readNext()}resolveOffset(E,F){let J=this.range,$e=this.rangeIndex,_t=this.pos+E;for(;_t<J.from;){if(!$e)return null;let lr=this.ranges[--$e];_t-=J.from-lr.to,J=lr}for(;F<0?_t>J.to:_t>=J.to;){if($e==this.ranges.length-1)return null;let lr=this.ranges[++$e];_t+=lr.from-J.to,J=lr}return _t}clipPos(E){if(E>=this.range.from&&E<this.range.to)return E;for(let F of this.ranges)if(F.to>E)return Math.max(E,F.from);return this.end}peek(E){let F=this.chunkOff+E,J,$e;if(F>=0&&F<this.chunk.length)J=this.pos+E,$e=this.chunk.charCodeAt(F);else{let _t=this.resolveOffset(E,1);if(_t==null)return-1;if(J=_t,J>=this.chunk2Pos&&J<this.chunk2Pos+this.chunk2.length)$e=this.chunk2.charCodeAt(J-this.chunk2Pos);else{let lr=this.rangeIndex,mr=this.range;for(;mr.to<=J;)mr=this.ranges[++lr];this.chunk2=this.input.chunk(this.chunk2Pos=J),J+this.chunk2.length>mr.to&&(this.chunk2=this.chunk2.slice(0,mr.to-J)),$e=this.chunk2.charCodeAt(0)}}return J>=this.token.lookAhead&&(this.token.lookAhead=J+1),$e}acceptToken(E,F=0){let J=F?this.resolveOffset(F,-1):this.pos;if(J==null||J<this.token.start)throw new RangeError("Token end out of bounds");this.token.value=E,this.token.end=J}acceptTokenTo(E,F){this.token.value=E,this.token.end=F}getChunk(){if(this.pos>=this.chunk2Pos&&this.pos<this.chunk2Pos+this.chunk2.length){let{chunk:E,chunkPos:F}=this;this.chunk=this.chunk2,this.chunkPos=this.chunk2Pos,this.chunk2=E,this.chunk2Pos=F,this.chunkOff=this.pos-this.chunkPos}else{this.chunk2=this.chunk,this.chunk2Pos=this.chunkPos;let E=this.input.chunk(this.pos),F=this.pos+E.length;this.chunk=F>this.range.to?E.slice(0,this.range.to-this.pos):E,this.chunkPos=this.pos,this.chunkOff=0}}readNext(){return this.chunkOff>=this.chunk.length&&(this.getChunk(),this.chunkOff==this.chunk.length)?this.next=-1:this.next=this.chunk.charCodeAt(this.chunkOff)}advance(E=1){for(this.chunkOff+=E;this.pos+E>=this.range.to;){if(this.rangeIndex==this.ranges.length-1)return this.setDone();E-=this.range.to-this.pos,this.range=this.ranges[++this.rangeIndex],this.pos=this.range.from}return this.pos+=E,this.pos>=this.token.lookAhead&&(this.token.lookAhead=this.pos+1),this.readNext()}setDone(){return this.pos=this.chunkPos=this.end,this.range=this.ranges[this.rangeIndex=this.ranges.length-1],this.chunk="",this.next=-1}reset(E,F){if(F?(this.token=F,F.start=E,F.lookAhead=E+1,F.value=F.extended=-1):this.token=nullToken,this.pos!=E){if(this.pos=E,E==this.end)return this.setDone(),this;for(;E<this.range.from;)this.range=this.ranges[--this.rangeIndex];for(;E>=this.range.to;)this.range=this.ranges[++this.rangeIndex];E>=this.chunkPos&&E<this.chunkPos+this.chunk.length?this.chunkOff=E-this.chunkPos:(this.chunk="",this.chunkOff=0),this.readNext()}return this}read(E,F){if(E>=this.chunkPos&&F<=this.chunkPos+this.chunk.length)return this.chunk.slice(E-this.chunkPos,F-this.chunkPos);if(E>=this.chunk2Pos&&F<=this.chunk2Pos+this.chunk2.length)return this.chunk2.slice(E-this.chunk2Pos,F-this.chunk2Pos);if(E>=this.range.from&&F<=this.range.to)return this.input.read(E,F);let J="";for(let $e of this.ranges){if($e.from>=F)break;$e.to>E&&(J+=this.input.read(Math.max($e.from,E),Math.min($e.to,F)))}return J}}class TokenGroup{constructor(E,F){this.data=E,this.id=F}token(E,F){let{parser:J}=F.p;readToken(this.data,E,F,this.id,J.data,J.tokenPrecTable)}}TokenGroup.prototype.contextual=TokenGroup.prototype.fallback=TokenGroup.prototype.extend=!1,TokenGroup.prototype.fallback=TokenGroup.prototype.extend=!1;class ExternalTokenizer{constructor(E,F={}){this.token=E,this.contextual=!!F.contextual,this.fallback=!!F.fallback,this.extend=!!F.extend}}function readToken(D,E,F,J,$e,_t){let lr=0,mr=1<<J,{dialect:Or}=F.p.parser;e:for(;(mr&D[lr])!=0;){let Pr=D[lr+1];for(let zi=lr+3;zi<Pr;zi+=2)if((D[zi+1]&mr)>0){let Hi=D[zi];if(Or.allows(Hi)&&(E.token.value==-1||E.token.value==Hi||overrides(Hi,E.token.value,$e,_t))){E.acceptToken(Hi);break}}let dn=E.next,gi=0,qi=D[lr+2];if(E.next<0&&qi>gi&&D[Pr+qi*3-3]==65535){lr=D[Pr+qi*3-1];continue e}for(;gi<qi;){let zi=gi+qi>>1,Hi=Pr+zi+(zi<<1),Qi=D[Hi],Gi=D[Hi+1]||65536;if(dn<Qi)qi=zi;else if(dn>=Gi)gi=zi+1;else{lr=D[Hi+2],E.advance();continue e}}break}}function findOffset(D,E,F){for(let J=E,$e;($e=D[J])!=65535;J++)if($e==F)return J-E;return-1}function overrides(D,E,F,J){let $e=findOffset(F,J,E);return $e<0||findOffset(F,J,D)<$e}const verbose=typeof process<"u"&&process.env&&/\\bparse\\b/.test(process.env.LOG);let stackIDs=null;function cutAt(D,E,F){let J=D.cursor(IterMode.IncludeAnonymous);for(J.moveTo(E);;)if(!(F<0?J.childBefore(E):J.childAfter(E)))for(;;){if((F<0?J.to<E:J.from>E)&&!J.type.isError)return F<0?Math.max(0,Math.min(J.to-1,E-25)):Math.min(D.length,Math.max(J.from+1,E+25));if(F<0?J.prevSibling():J.nextSibling())break;if(!J.parent())return F<0?0:D.length}}class FragmentCursor{constructor(E,F){this.fragments=E,this.nodeSet=F,this.i=0,this.fragment=null,this.safeFrom=-1,this.safeTo=-1,this.trees=[],this.start=[],this.index=[],this.nextFragment()}nextFragment(){let E=this.fragment=this.i==this.fragments.length?null:this.fragments[this.i++];if(E){for(this.safeFrom=E.openStart?cutAt(E.tree,E.from+E.offset,1)-E.offset:E.from,this.safeTo=E.openEnd?cutAt(E.tree,E.to+E.offset,-1)-E.offset:E.to;this.trees.length;)this.trees.pop(),this.start.pop(),this.index.pop();this.trees.push(E.tree),this.start.push(-E.offset),this.index.push(0),this.nextStart=this.safeFrom}else this.nextStart=1e9}nodeAt(E){if(E<this.nextStart)return null;for(;this.fragment&&this.safeTo<=E;)this.nextFragment();if(!this.fragment)return null;for(;;){let F=this.trees.length-1;if(F<0)return this.nextFragment(),null;let J=this.trees[F],$e=this.index[F];if($e==J.children.length){this.trees.pop(),this.start.pop(),this.index.pop();continue}let _t=J.children[$e],lr=this.start[F]+J.positions[$e];if(lr>E)return this.nextStart=lr,null;if(_t instanceof Tree){if(lr==E){if(lr<this.safeFrom)return null;let mr=lr+_t.length;if(mr<=this.safeTo){let Or=_t.prop(NodeProp.lookAhead);if(!Or||mr+Or<this.fragment.to)return _t}}this.index[F]++,lr+_t.length>=Math.max(this.safeFrom,E)&&(this.trees.push(_t),this.start.push(lr),this.index.push(0))}else this.index[F]++,this.nextStart=lr+_t.length}}}class TokenCache{constructor(E,F){this.stream=F,this.tokens=[],this.mainToken=null,this.actions=[],this.tokens=E.tokenizers.map(J=>new CachedToken)}getActions(E){let F=0,J=null,{parser:$e}=E.p,{tokenizers:_t}=$e,lr=$e.stateSlot(E.state,3),mr=E.curContext?E.curContext.hash:0,Or=0;for(let Pr=0;Pr<_t.length;Pr++){if((1<<Pr&lr)==0)continue;let dn=_t[Pr],gi=this.tokens[Pr];if(!(J&&!dn.fallback)&&((dn.contextual||gi.start!=E.pos||gi.mask!=lr||gi.context!=mr)&&(this.updateCachedToken(gi,dn,E),gi.mask=lr,gi.context=mr),gi.lookAhead>gi.end+25&&(Or=Math.max(gi.lookAhead,Or)),gi.value!=0)){let qi=F;if(gi.extended>-1&&(F=this.addActions(E,gi.extended,gi.end,F)),F=this.addActions(E,gi.value,gi.end,F),!dn.extend&&(J=gi,F>qi))break}}for(;this.actions.length>F;)this.actions.pop();return Or&&E.setLookAhead(Or),!J&&E.pos==this.stream.end&&(J=new CachedToken,J.value=E.p.parser.eofTerm,J.start=J.end=E.pos,F=this.addActions(E,J.value,J.end,F)),this.mainToken=J,this.actions}getMainToken(E){if(this.mainToken)return this.mainToken;let F=new CachedToken,{pos:J,p:$e}=E;return F.start=J,F.end=Math.min(J+1,$e.stream.end),F.value=J==$e.stream.end?$e.parser.eofTerm:0,F}updateCachedToken(E,F,J){let $e=this.stream.clipPos(J.pos);if(F.token(this.stream.reset($e,E),J),E.value>-1){let{parser:_t}=J.p;for(let lr=0;lr<_t.specialized.length;lr++)if(_t.specialized[lr]==E.value){let mr=_t.specializers[lr](this.stream.read(E.start,E.end),J);if(mr>=0&&J.p.parser.dialect.allows(mr>>1)){(mr&1)==0?E.value=mr>>1:E.extended=mr>>1;break}}}else E.value=0,E.end=this.stream.clipPos($e+1)}putAction(E,F,J,$e){for(let _t=0;_t<$e;_t+=3)if(this.actions[_t]==E)return $e;return this.actions[$e++]=E,this.actions[$e++]=F,this.actions[$e++]=J,$e}addActions(E,F,J,$e){let{state:_t}=E,{parser:lr}=E.p,{data:mr}=lr;for(let Or=0;Or<2;Or++)for(let Pr=lr.stateSlot(_t,Or?2:1);;Pr+=3){if(mr[Pr]==65535)if(mr[Pr+1]==1)Pr=pair(mr,Pr+2);else{$e==0&&mr[Pr+1]==2&&($e=this.putAction(pair(mr,Pr+2),F,J,$e));break}mr[Pr]==F&&($e=this.putAction(pair(mr,Pr+1),F,J,$e))}return $e}}class Parse{constructor(E,F,J,$e){this.parser=E,this.input=F,this.ranges=$e,this.recovering=0,this.nextStackID=9812,this.minStackPos=0,this.reused=[],this.stoppedAt=null,this.lastBigReductionStart=-1,this.lastBigReductionSize=0,this.bigReductionCount=0,this.stream=new InputStream(F,$e),this.tokens=new TokenCache(E,this.stream),this.topTerm=E.top[1];let{from:_t}=$e[0];this.stacks=[Stack.start(this,E.top[0],_t)],this.fragments=J.length&&this.stream.end-_t>E.bufferLength*4?new FragmentCursor(J,E.nodeSet):null}get parsedPos(){return this.minStackPos}advance(){let E=this.stacks,F=this.minStackPos,J=this.stacks=[],$e,_t;if(this.bigReductionCount>300&&E.length==1){let[lr]=E;for(;lr.forceReduce()&&lr.stack.length&&lr.stack[lr.stack.length-2]>=this.lastBigReductionStart;);this.bigReductionCount=this.lastBigReductionSize=0}for(let lr=0;lr<E.length;lr++){let mr=E[lr];for(;;){if(this.tokens.mainToken=null,mr.pos>F)J.push(mr);else{if(this.advanceStack(mr,J,E))continue;{$e||($e=[],_t=[]),$e.push(mr);let Or=this.tokens.getMainToken(mr);_t.push(Or.value,Or.end)}}break}}if(!J.length){let lr=$e&&findFinished($e);if(lr)return verbose&&console.log("Finish with "+this.stackID(lr)),this.stackToTree(lr);if(this.parser.strict)throw verbose&&$e&&console.log("Stuck with token "+(this.tokens.mainToken?this.parser.getName(this.tokens.mainToken.value):"none")),new SyntaxError("No parse at "+F);this.recovering||(this.recovering=5)}if(this.recovering&&$e){let lr=this.stoppedAt!=null&&$e[0].pos>this.stoppedAt?$e[0]:this.runRecovery($e,_t,J);if(lr)return verbose&&console.log("Force-finish "+this.stackID(lr)),this.stackToTree(lr.forceAll())}if(this.recovering){let lr=this.recovering==1?1:this.recovering*3;if(J.length>lr)for(J.sort((mr,Or)=>Or.score-mr.score);J.length>lr;)J.pop();J.some(mr=>mr.reducePos>F)&&this.recovering--}else if(J.length>1){e:for(let lr=0;lr<J.length-1;lr++){let mr=J[lr];for(let Or=lr+1;Or<J.length;Or++){let Pr=J[Or];if(mr.sameState(Pr)||mr.buffer.length>500&&Pr.buffer.length>500)if((mr.score-Pr.score||mr.buffer.length-Pr.buffer.length)>0)J.splice(Or--,1);else{J.splice(lr--,1);continue e}}}J.length>12&&(J.sort((lr,mr)=>mr.score-lr.score),J.splice(12,J.length-12))}this.minStackPos=J[0].pos;for(let lr=1;lr<J.length;lr++)J[lr].pos<this.minStackPos&&(this.minStackPos=J[lr].pos);return null}stopAt(E){if(this.stoppedAt!=null&&this.stoppedAt<E)throw new RangeError("Can\'t move stoppedAt forward");this.stoppedAt=E}advanceStack(E,F,J){let $e=E.pos,{parser:_t}=this,lr=verbose?this.stackID(E)+" -> ":"";if(this.stoppedAt!=null&&$e>this.stoppedAt)return E.forceReduce()?E:null;if(this.fragments){let Pr=E.curContext&&E.curContext.tracker.strict,dn=Pr?E.curContext.hash:0;for(let gi=this.fragments.nodeAt($e);gi;){let qi=this.parser.nodeSet.types[gi.type.id]==gi.type?_t.getGoto(E.state,gi.type.id):-1;if(qi>-1&&gi.length&&(!Pr||(gi.prop(NodeProp.contextHash)||0)==dn))return E.useNode(gi,qi),verbose&&console.log(lr+this.stackID(E)+` (via reuse of ${_t.getName(gi.type.id)})`),!0;if(!(gi instanceof Tree)||gi.children.length==0||gi.positions[0]>0)break;let zi=gi.children[0];if(zi instanceof Tree&&gi.positions[0]==0)gi=zi;else break}}let mr=_t.stateSlot(E.state,4);if(mr>0)return E.reduce(mr),verbose&&console.log(lr+this.stackID(E)+` (via always-reduce ${_t.getName(mr&65535)})`),!0;if(E.stack.length>=8400)for(;E.stack.length>6e3&&E.forceReduce(););let Or=this.tokens.getActions(E);for(let Pr=0;Pr<Or.length;){let dn=Or[Pr++],gi=Or[Pr++],qi=Or[Pr++],zi=Pr==Or.length||!J,Hi=zi?E:E.split(),Qi=this.tokens.mainToken;if(Hi.apply(dn,gi,Qi?Qi.start:Hi.pos,qi),verbose&&console.log(lr+this.stackID(Hi)+` (via ${(dn&65536)==0?"shift":`reduce of ${_t.getName(dn&65535)}`} for ${_t.getName(gi)} @ ${$e}${Hi==E?"":", split"})`),zi)return!0;Hi.pos>$e?F.push(Hi):J.push(Hi)}return!1}advanceFully(E,F){let J=E.pos;for(;;){if(!this.advanceStack(E,null,null))return!1;if(E.pos>J)return pushStackDedup(E,F),!0}}runRecovery(E,F,J){let $e=null,_t=!1;for(let lr=0;lr<E.length;lr++){let mr=E[lr],Or=F[lr<<1],Pr=F[(lr<<1)+1],dn=verbose?this.stackID(mr)+" -> ":"";if(mr.deadEnd&&(_t||(_t=!0,mr.restart(),verbose&&console.log(dn+this.stackID(mr)+" (restarted)"),this.advanceFully(mr,J))))continue;let gi=mr.split(),qi=dn;for(let zi=0;zi<10&&gi.forceReduce()&&(verbose&&console.log(qi+this.stackID(gi)+" (via force-reduce)"),!this.advanceFully(gi,J));zi++)verbose&&(qi=this.stackID(gi)+" -> ");for(let zi of mr.recoverByInsert(Or))verbose&&console.log(dn+this.stackID(zi)+" (via recover-insert)"),this.advanceFully(zi,J);this.stream.end>mr.pos?(Pr==mr.pos&&(Pr++,Or=0),mr.recoverByDelete(Or,Pr),verbose&&console.log(dn+this.stackID(mr)+` (via recover-delete ${this.parser.getName(Or)})`),pushStackDedup(mr,J)):(!$e||$e.score<gi.score)&&($e=gi)}return $e}stackToTree(E){return E.close(),Tree.build({buffer:StackBufferCursor.create(E),nodeSet:this.parser.nodeSet,topID:this.topTerm,maxBufferLength:this.parser.bufferLength,reused:this.reused,start:this.ranges[0].from,length:E.pos-this.ranges[0].from,minRepeatType:this.parser.minRepeatTerm})}stackID(E){let F=(stackIDs||(stackIDs=new WeakMap)).get(E);return F||stackIDs.set(E,F=String.fromCodePoint(this.nextStackID++)),F+E}}function pushStackDedup(D,E){for(let F=0;F<E.length;F++){let J=E[F];if(J.pos==D.pos&&J.sameState(D)){E[F].score<D.score&&(E[F]=D);return}}E.push(D)}class Dialect{constructor(E,F,J){this.source=E,this.flags=F,this.disabled=J}allows(E){return!this.disabled||this.disabled[E]==0}}const id=D=>D;class ContextTracker{constructor(E){this.start=E.start,this.shift=E.shift||id,this.reduce=E.reduce||id,this.reuse=E.reuse||id,this.hash=E.hash||(()=>0),this.strict=E.strict!==!1}}class LRParser extends Parser{constructor(E){if(super(),this.wrappers=[],E.version!=14)throw new RangeError(`Parser version (${E.version}) doesn\'t match runtime version (14)`);let F=E.nodeNames.split(" ");this.minRepeatTerm=F.length;for(let mr=0;mr<E.repeatNodeCount;mr++)F.push("");let J=Object.keys(E.topRules).map(mr=>E.topRules[mr][1]),$e=[];for(let mr=0;mr<F.length;mr++)$e.push([]);function _t(mr,Or,Pr){$e[mr].push([Or,Or.deserialize(String(Pr))])}if(E.nodeProps)for(let mr of E.nodeProps){let Or=mr[0];typeof Or=="string"&&(Or=NodeProp[Or]);for(let Pr=1;Pr<mr.length;){let dn=mr[Pr++];if(dn>=0)_t(dn,Or,mr[Pr++]);else{let gi=mr[Pr+-dn];for(let qi=-dn;qi>0;qi--)_t(mr[Pr++],Or,gi);Pr++}}}this.nodeSet=new NodeSet(F.map((mr,Or)=>NodeType.define({name:Or>=this.minRepeatTerm?void 0:mr,id:Or,props:$e[Or],top:J.indexOf(Or)>-1,error:Or==0,skipped:E.skippedNodes&&E.skippedNodes.indexOf(Or)>-1}))),E.propSources&&(this.nodeSet=this.nodeSet.extend(...E.propSources)),this.strict=!1,this.bufferLength=DefaultBufferLength;let lr=decodeArray(E.tokenData);this.context=E.context,this.specializerSpecs=E.specialized||[],this.specialized=new Uint16Array(this.specializerSpecs.length);for(let mr=0;mr<this.specializerSpecs.length;mr++)this.specialized[mr]=this.specializerSpecs[mr].term;this.specializers=this.specializerSpecs.map(getSpecializer),this.states=decodeArray(E.states,Uint32Array),this.data=decodeArray(E.stateData),this.goto=decodeArray(E.goto),this.maxTerm=E.maxTerm,this.tokenizers=E.tokenizers.map(mr=>typeof mr=="number"?new TokenGroup(lr,mr):mr),this.topRules=E.topRules,this.dialects=E.dialects||{},this.dynamicPrecedences=E.dynamicPrecedences||null,this.tokenPrecTable=E.tokenPrec,this.termNames=E.termNames||null,this.maxNode=this.nodeSet.types.length-1,this.dialect=this.parseDialect(),this.top=this.topRules[Object.keys(this.topRules)[0]]}createParse(E,F,J){let $e=new Parse(this,E,F,J);for(let _t of this.wrappers)$e=_t($e,E,F,J);return $e}getGoto(E,F,J=!1){let $e=this.goto;if(F>=$e[0])return-1;for(let _t=$e[F+1];;){let lr=$e[_t++],mr=lr&1,Or=$e[_t++];if(mr&&J)return Or;for(let Pr=_t+(lr>>1);_t<Pr;_t++)if($e[_t]==E)return Or;if(mr)return-1}}hasAction(E,F){let J=this.data;for(let $e=0;$e<2;$e++)for(let _t=this.stateSlot(E,$e?2:1),lr;;_t+=3){if((lr=J[_t])==65535)if(J[_t+1]==1)lr=J[_t=pair(J,_t+2)];else{if(J[_t+1]==2)return pair(J,_t+2);break}if(lr==F||lr==0)return pair(J,_t+1)}return 0}stateSlot(E,F){return this.states[E*6+F]}stateFlag(E,F){return(this.stateSlot(E,0)&F)>0}validAction(E,F){return!!this.allActions(E,J=>J==F?!0:null)}allActions(E,F){let J=this.stateSlot(E,4),$e=J?F(J):void 0;for(let _t=this.stateSlot(E,1);$e==null;_t+=3){if(this.data[_t]==65535)if(this.data[_t+1]==1)_t=pair(this.data,_t+2);else break;$e=F(pair(this.data,_t+1))}return $e}nextStates(E){let F=[];for(let J=this.stateSlot(E,1);;J+=3){if(this.data[J]==65535)if(this.data[J+1]==1)J=pair(this.data,J+2);else break;if((this.data[J+2]&1)==0){let $e=this.data[J+1];F.some((_t,lr)=>lr&1&&_t==$e)||F.push(this.data[J],$e)}}return F}configure(E){let F=Object.assign(Object.create(LRParser.prototype),this);if(E.props&&(F.nodeSet=this.nodeSet.extend(...E.props)),E.top){let J=this.topRules[E.top];if(!J)throw new RangeError(`Invalid top rule name ${E.top}`);F.top=J}return E.tokenizers&&(F.tokenizers=this.tokenizers.map(J=>{let $e=E.tokenizers.find(_t=>_t.from==J);return $e?$e.to:J})),E.specializers&&(F.specializers=this.specializers.slice(),F.specializerSpecs=this.specializerSpecs.map((J,$e)=>{let _t=E.specializers.find(mr=>mr.from==J.external);if(!_t)return J;let lr=Object.assign(Object.assign({},J),{external:_t.to});return F.specializers[$e]=getSpecializer(lr),lr})),E.contextTracker&&(F.context=E.contextTracker),E.dialect&&(F.dialect=this.parseDialect(E.dialect)),E.strict!=null&&(F.strict=E.strict),E.wrap&&(F.wrappers=F.wrappers.concat(E.wrap)),E.bufferLength!=null&&(F.bufferLength=E.bufferLength),F}hasWrappers(){return this.wrappers.length>0}getName(E){return this.termNames?this.termNames[E]:String(E<=this.maxNode&&this.nodeSet.types[E].name||E)}get eofTerm(){return this.maxNode+1}get topNode(){return this.nodeSet.types[this.top[1]]}dynamicPrecedence(E){let F=this.dynamicPrecedences;return F==null?0:F[E]||0}parseDialect(E){let F=Object.keys(this.dialects),J=F.map(()=>!1);if(E)for(let _t of E.split(" ")){let lr=F.indexOf(_t);lr>=0&&(J[lr]=!0)}let $e=null;for(let _t=0;_t<F.length;_t++)if(!J[_t])for(let lr=this.dialects[F[_t]],mr;(mr=this.data[lr++])!=65535;)($e||($e=new Uint8Array(this.maxTerm+1)))[mr]=1;return new Dialect(E,J,$e)}static deserialize(E){return new LRParser(E)}}function pair(D,E){return D[E]|D[E+1]<<16}function findFinished(D){let E=null;for(let F of D){let J=F.p.stoppedAt;(F.pos==F.p.stream.end||J!=null&&F.pos>J)&&F.p.parser.stateFlag(F.state,2)&&(!E||E.score<F.score)&&(E=F)}return E}function getSpecializer(D){if(D.external){let E=D.extend?1:0;return(F,J)=>D.external(F,J)<<1|E}return D.get}function nameChar(D){return D==45||D==46||D==58||D>=65&&D<=90||D==95||D>=97&&D<=122||D>=161}function isSpace(D){return D==9||D==10||D==13||D==32}let cachedName=null,cachedInput=null,cachedPos=0;function tagNameAfter(D,E){let F=D.pos+E;if(cachedInput==D&&cachedPos==F)return cachedName;for(;isSpace(D.peek(E));)E++;let J="";for(;;){let $e=D.peek(E);if(!nameChar($e))break;J+=String.fromCharCode($e),E++}return cachedInput=D,cachedPos=F,cachedName=J||null}class ElementContext{constructor(E,F){this.name=E,this.parent=F??null,this.hash=F?F.hash:0;for(let J=0;J<E.length;J++)this.hash+=(this.hash<<4)+E.charCodeAt(J)+(E.charCodeAt(J)<<8)}}const elementContext=new ContextTracker({start:null,shift(D,E,F,J){return E==StartTag?new ElementContext(tagNameAfter(J,1)||"",D):D},reduce(D,E){return E==Element&&D?D.parent:D},reuse(D,E,F,J){let $e=E.type.id;return $e==StartTag||$e==OpenTag?new ElementContext(tagNameAfter(J,1)||"",D):D},hash(D){return D?D.hash:0},strict:!1}),startTag=new ExternalTokenizer((D,E)=>{if(!(D.next!==60||D.peek(1)===61)){if(D.advance(),D.next===47){D.advance();let J=tagNameAfter(D,0);if(!J)return D.acceptToken(incompleteStartCloseTag);if(E.context&&J.toLowerCase()==E.context.name.toLowerCase())return D.acceptToken(StartCloseTag);for(let $e=E.context;$e;$e=$e.parent)if($e.name===J)return D.acceptToken(MissingCloseTag,-2);D.acceptToken(mismatchedStartCloseTag)}else if(D.next!==33&&D.next!==63&&!isSpace(D.next))return D.acceptToken(StartTag)}},{contextual:!0}),textLessThan=new ExternalTokenizer(D=>{if(D.next!==60)return;if(D.peek(1)===60)return D.acceptToken(Text,1)});function scanTo(D,E){return new ExternalTokenizer(F=>{for(let J=0,$e=0;;$e++){if(F.next<0){$e&&F.acceptToken(D);break}if(F.next==E.charCodeAt(J)){if(J++,J==E.length){$e>E.length&&F.acceptToken(D,1-E.length);break}}else J=0;F.advance()}})}const commentContent=scanTo(commentContent$1,"-->"),piContent=scanTo(piContent$1,"?>"),cdataContent=scanTo(cdataContent$1,"]]>"),parser=LRParser.deserialize({version:14,states:"(jOVOqOOOzO!jO\'#CgO!SQ!bO\'#CjO!|OqO\'#ChOOOP\'#Ch\'#ChO#TO!dO\'#CsO#]O!fO\'#CtO#eQ!bO\'#CuOOOP\'#DW\'#DWOOOP\'#Cw\'#CwQVOqOOOOOW\'#Cx\'#CxO#jO!jO,59ROOOP,59R,59RO#rQ#tO,59UOOOP\'#C|\'#C|O#}OqO,59SO$UQ!bO\'#CpOOOP,59S,59SOOOQ\'#C}\'#C}O$ZO!dO,59_OOOP,59_,59_OOOS\'#DO\'#DOO$cO!fO,59`OOOP,59`,59`O$kQ!bO,59aOOOP-E6u-E6uOOOW-E6v-E6vOOOP1G.m1G.mO$pQ#tO\'#ClOOQO\'#Cy\'#CyO%OQ#tO1G.pOOOP1G.p1G.pOOOP1G.x1G.xOOOP-E6z-E6zOOOP1G.n1G.nO%ZQ!bO,59[OOOQ-E6{-E6{OOOP1G.y1G.yOOOS-E6|-E6|OOOP1G.z1G.zOOOP1G.{1G.{O%`Q!bO,59WOOQO-E6w-E6wOOOP7+$[7+$[OOOP7+$d7+$dOOOP1G.v1G.vO%hO&jO\'#CoO%yO,UO\'#CoOOQO1G.r1G.rOOOO\'#Cz\'#CzO&[O&jO,59ZOOQO,59Z,59ZOOOO\'#C{\'#C{O&mO,UO,59ZOOOO-E6x-E6xOOQO1G.u1G.uOOOO-E6y-E6y",stateData:"\'T~OyOS~OPQOSVOTWOVWOWWOXWOYWOjXO|PO!STO!UUO~OvZO{]O~O_^O~OPQOQaOSVOTWOVWOWWOXWOYWO|PO!STO!UUO~ORbO~P!XOtcO!ReO~OufO!ThO~O_iO~OvZO{lO~O]pOamOeqO~ORsO~P!XO_tO~OtcO!RvO~OufO!TxO~O]yO~ObzO]`Xa`Xe`X~O]|OamOe}O~O]!OO~O}!PO!P!QO~OW!SOX!SOY!SO}!UO!O!SO~OW!VOX!VOY!VO!P!UO!Q!VO~OW!SOX!SOY!SO}!YO!O!SO~OW!VOX!VOY!VO!P!YO!Q!VO~OXWYW~",goto:"#w{PPPPPPPPPPP||P!SP!YPP!^!aP!g|||P!m!s!y#P#V#]#c#iPPPPPPP#oXWORY`XRORY`Tn^oR!RzQbRRs`XSORY`QYORjYQ[PRk[Qo^R{oQ!T!PR!X!TQ!W!QR!Z!WQ`RRr`QdTRudQgURwgSXOYT_R`",nodeNames:"⚠ StartTag StartCloseTag MissingCloseTag StartCloseTag StartCloseTag Document Text EntityReference CharacterReference Ampersand Cdata Element EndTag OpenTag TagName Attribute AttributeName Is AttributeValue CloseTag SelfCloseEndTag SelfClosingTag Comment ProcessingInst MismatchedCloseTag DoctypeDecl",maxTerm:52,context:elementContext,nodeProps:[["closedBy",1,"SelfCloseEndTag EndTag",14,"CloseTag MissingCloseTag"],["openedBy",13,"StartTag StartCloseTag",20,"OpenTag",21,"StartTag"]],skippedNodes:[0],repeatNodeCount:8,tokenData:"!2c~R!YOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs2wsv$qvw3gwx7lx}$q}!O8_!O!P$q!P!Q:}!Q![$q![!]<q!]!^$q!^!_@X!_!`!,a!`!a!-X!a!b!.P!b!c$q!c!}<q!}#P$q#P#Q!/s#Q#R$q#R#S<q#S#T$q#T#o<q#o%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U$q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;\'S<q;\'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qi$zXVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qa%nVVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;\'S%g;\'S;=`*l<%lO%gP&YUVPOv&Tw!^&T!^!_&l!_;\'S&T;\'S;=`\'|<%lO&TP&oTXY\'OYZ\'O]^\'Opq\'O!_!`&TP\'T]VPOX&TXY\'OYZ\'OZ]&T]^\'O^p&Tpq\'Oqv&Tw!^&T!^!_&l!_;\'S&T;\'S;=`\'|<%lO&TP(PP;=`<%l&Ta(X]!Q`OX)QXY)iYZ)iZ])Q]^)i^p)Qpq)iqv)Qx!_)Q!_!`%g!`;\'S)Q;\'S;=`)c<%lO)Q`)VS!Q`Ov)Qx;\'S)Q;\'S;=`)c<%lO)Q`)fP;=`<%l)Qa)p^VP!Q`OX%gXY)iYZ)iZ]%g]^)i^p%gpq)iqv%gwx&Tx!^%g!^!_(S!_;\'S%g;\'S;=`*l<%lO%ga*oP;=`<%l%gX*yWVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;\'S*r;\'S;=`.U<%lO*rX+h^!OWOX,dXY-OYZ-OZ],d]^-O^p,dpq-Oqr,dsv,dw!_,d!_!`*r!`;\'S,d;\'S;=`,x<%lO,dW,iT!OWOr,dsv,dw;\'S,d;\'S;=`,x<%lO,dW,{P;=`<%l,dX-V_VP!OWOX*rXY-OYZ-OZ]*r]^-O^p*rpq-Oqr*rrs&Tsv*rw!^*r!^!_+c!_;\'S*r;\'S;=`.U<%lO*rX.XP;=`<%l*ri.c`!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0Xqr/ers)Qsv/ewx,dx!_/e!_!`$q!`;\'S/e;\'S;=`0R<%lO/eh/lV!OW!Q`Or/ers)Qsv/ewx,dx;\'S/e;\'S;=`0R<%lO/eh0UP;=`<%l/ei0b`VP!OW!Q`OX$qXY0XYZ0XZ]$q]^0X^p$qpq0Xqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qi1gP;=`<%l$qo1u`VP!OW!Q`yUOX$qXY1jYZ1jZ]$q]^1j^p$qpq1jqr$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qk3QV}YVP!Q`Ov%gwx&Tx!^%g!^!_(S!_;\'S%g;\'S;=`*l<%lO%g~3laY~st4q![!]5u!c!}5u#R#S5u#T#o5u%W%o5u%p&a5u&b1p5u4U4d5u4e$IS5u$I`$Ib5u$Kh%#t5u&/x&Et5u&FV;\'S5u;\'S;:j7f?&r?Ah5u?BY?Mn5u~4tQ!Q![4z#l#m5Y~4}Q!Q![4z!]!^5T~5YOX~~5]R!Q![5f!c!i5f#T#Z5f~5iS!Q![5f!]!^5T!c!i5f#T#Z5f~5xg}!O5u!O!P5u!Q![5u![!]5u!]!^7a!c!}5u#R#S5u#T#o5u$}%O5u%W%o5u%p&a5u&b1p5u1p4U5u4U4d5u4e$IS5u$I`$Ib5u$Je$Jg5u$Kh%#t5u&/x&Et5u&FV;\'S5u;\'S;:j7f?&r?Ah5u?BY?Mn5u~7fOW~~7iP;=`<%l5uk7uW!PbVP!OWOr*rrs&Tsv*rw!^*r!^!_+c!_;\'S*r;\'S;=`.U<%lO*rk8hZVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O9Z!O!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qk9dZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a:V!a;\'S$q;\'S;=`1d<%lO$qk:bX!RQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qm;WZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a;y!a;\'S$q;\'S;=`1d<%lO$qm<UXeSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qo=O!PaS_QVP!OW!Q`Or$qrs%gsv$qwx*rx}$q}!O<q!O!P<q!P!Q$q!Q![<q![!]<q!]!^$q!^!_.[!_!c$q!c!}<q!}#R$q#R#S<q#S#T$q#T#o<q#o$}$q$}%O<q%O%W$q%W%o<q%o%p$q%p&a<q&a&b$q&b1p<q1p4U<q4U4d<q4d4e$q4e$IS<q$IS$I`$q$I`$Ib<q$Ib$Je$q$Je$Jg<q$Jg$Kh$q$Kh%#t<q%#t&/x$q&/x&Et<q&Et&FV$q&FV;\'S<q;\'S;:j@R;:j;=`1d<%l?&r$q?&r?Ah<q?Ah?BY$q?BY?Mn<q?MnO$qo@UP;=`<%l<qi@`b!OW!Q`OX/eXY0XYZ0XZ]/e]^0X^p/epq0XqrAhrs)Qsv/ewx,dx!_/e!_!`$q!`!a/e!a!b!+q!b;\'S/e;\'S;=`0R<%lO/eiAo_!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OBn!O!f/e!f!gDQ!g!}/e!}#OMT#O#W/e#W#X!\']#X;\'S/e;\'S;=`0R<%lO/eiBuX!OW!Q`Or/ers)Qsv/ewx,dx}/e}!OCb!O;\'S/e;\'S;=`0R<%lO/eiCkV!SP!OW!Q`Or/ers)Qsv/ewx,dx;\'S/e;\'S;=`0R<%lO/eiDXX!OW!Q`Or/ers)Qsv/ewx,dx!q/e!q!rDt!r;\'S/e;\'S;=`0R<%lO/eiD{X!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fEh!f;\'S/e;\'S;=`0R<%lO/eiEoX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!wF[!w;\'S/e;\'S;=`0R<%lO/eiFcX!OW!Q`Or/ers)Qsv/ewx,dx!{/e!{!|GO!|;\'S/e;\'S;=`0R<%lO/eiGVX!OW!Q`Or/ers)Qsv/ewx,dx!r/e!r!sGr!s;\'S/e;\'S;=`0R<%lO/eiGyX!OW!Q`Or/ers)Qsv/ewx,dx!g/e!g!hHf!h;\'S/e;\'S;=`0R<%lO/eiHmY!OW!Q`OrHfrsI]svHfvwIwwxKPx!`Hf!`!aL_!a;\'SHf;\'S;=`L}<%lOHfaIbV!Q`OvI]vxIwx!`I]!`!aJf!a;\'SI];\'S;=`Jy<%lOI]PIzTO!`Iw!`!aJZ!a;\'SIw;\'S;=`J`<%lOIwPJ`OjPPJcP;=`<%lIwaJmSjP!Q`Ov)Qx;\'S)Q;\'S;=`)c<%lO)QaJ|P;=`<%lI]XKUX!OWOrKPrsIwsvKPvwIww!`KP!`!aKq!a;\'SKP;\'S;=`LX<%lOKPXKxTjP!OWOr,dsv,dw;\'S,d;\'S;=`,x<%lO,dXL[P;=`<%lKPiLhVjP!OW!Q`Or/ers)Qsv/ewx,dx;\'S/e;\'S;=`0R<%lO/eiMQP;=`<%lHfiM[Z!OW!Q`Or/ers)Qsv/ewx,dx!e/e!e!fM}!f#V/e#V#W!$_#W;\'S/e;\'S;=`0R<%lO/eiNUX!OW!Q`Or/ers)Qsv/ewx,dx!f/e!f!gNq!g;\'S/e;\'S;=`0R<%lO/eiNxX!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d! e!d;\'S/e;\'S;=`0R<%lO/ei! lX!OW!Q`Or/ers)Qsv/ewx,dx!v/e!v!w!!X!w;\'S/e;\'S;=`0R<%lO/ei!!`X!OW!Q`Or/ers)Qsv/ewx,dx!c/e!c!d!!{!d;\'S/e;\'S;=`0R<%lO/ei!#SX!OW!Q`Or/ers)Qsv/ewx,dx!}/e!}#O!#o#O;\'S/e;\'S;=`0R<%lO/ei!#xV|P!OW!Q`Or/ers)Qsv/ewx,dx;\'S/e;\'S;=`0R<%lO/ei!$fX!OW!Q`Or/ers)Qsv/ewx,dx#W/e#W#X!%R#X;\'S/e;\'S;=`0R<%lO/ei!%YX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!%u#U;\'S/e;\'S;=`0R<%lO/ei!%|X!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!&i#i;\'S/e;\'S;=`0R<%lO/ei!&pX!OW!Q`Or/ers)Qsv/ewx,dx#T/e#T#U!!{#U;\'S/e;\'S;=`0R<%lO/ei!\'dX!OW!Q`Or/ers)Qsv/ewx,dx#c/e#c#d!(P#d;\'S/e;\'S;=`0R<%lO/ei!(WX!OW!Q`Or/ers)Qsv/ewx,dx#V/e#V#W!(s#W;\'S/e;\'S;=`0R<%lO/ei!(zX!OW!Q`Or/ers)Qsv/ewx,dx#h/e#h#i!)g#i;\'S/e;\'S;=`0R<%lO/ei!)nX!OW!Q`Or/ers)Qsv/ewx,dx#m/e#m#n!*Z#n;\'S/e;\'S;=`0R<%lO/ei!*bX!OW!Q`Or/ers)Qsv/ewx,dx#d/e#d#e!*}#e;\'S/e;\'S;=`0R<%lO/ei!+UX!OW!Q`Or/ers)Qsv/ewx,dx#X/e#X#YHf#Y;\'S/e;\'S;=`0R<%lO/ei!+zV!UP!OW!Q`Or/ers)Qsv/ewx,dx;\'S/e;\'S;=`0R<%lO/em!,lXbSVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qo!-dX]UVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qk!.YZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!.{!a;\'S$q;\'S;=`1d<%lO$qk!/WX!TQVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$qk!/|ZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_#P$q#P#Q!0o#Q;\'S$q;\'S;=`1d<%lO$qk!0xZVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_!`$q!`!a!1k!a;\'S$q;\'S;=`1d<%lO$qk!1vX{QVP!OW!Q`Or$qrs%gsv$qwx*rx!^$q!^!_.[!_;\'S$q;\'S;=`1d<%lO$q",tokenizers:[startTag,commentContent,piContent,cdataContent,textLessThan,0,1,2,3,4],topRules:{Document:[0,6]},tokenPrec:276}),_ENTITY_MAP={AEli:"Æ",AElig:"Æ",AM:"&",AMP:"&",Aacut:"Á",Aacute:"Á",Abreve:"Ă",Acir:"Â",Acirc:"Â",Acy:"А",Afr:"𝔄",Agrav:"À",Agrave:"À",Alpha:"Α",Amacr:"Ā",And:"⩓",Aogon:"Ą",Aopf:"𝔸",ApplyFunction:"⁡",Arin:"Å",Aring:"Å",Ascr:"𝒜",Assign:"≔",Atild:"Ã",Atilde:"Ã",Aum:"Ä",Auml:"Ä",Backslash:"∖",Barv:"⫧",Barwed:"⌆",Bcy:"Б",Because:"∵",Bernoullis:"ℬ",Beta:"Β",Bfr:"𝔅",Bopf:"𝔹",Breve:"˘",Bscr:"ℬ",Bumpeq:"≎",CHcy:"Ч",COP:"©",COPY:"©",Cacute:"Ć",Cap:"⋒",CapitalDifferentialD:"ⅅ",Cayleys:"ℭ",Ccaron:"Č",Ccedi:"Ç",Ccedil:"Ç",Ccirc:"Ĉ",Cconint:"∰",Cdot:"Ċ",Cedilla:"¸",CenterDot:"·",Cfr:"ℭ",Chi:"Χ",CircleDot:"⊙",CircleMinus:"⊖",CirclePlus:"⊕",CircleTimes:"⊗",ClockwiseContourIntegral:"∲",CloseCurlyDoubleQuote:"”",CloseCurlyQuote:"’",Colon:"∷",Colone:"⩴",Congruent:"≡",Conint:"∯",ContourIntegral:"∮",Copf:"ℂ",Coproduct:"∐",CounterClockwiseContourIntegral:"∳",Cross:"⨯",Cscr:"𝒞",Cup:"⋓",CupCap:"≍",DD:"ⅅ",DDotrahd:"⤑",DJcy:"Ђ",DScy:"Ѕ",DZcy:"Џ",Dagger:"‡",Darr:"↡",Dashv:"⫤",Dcaron:"Ď",Dcy:"Д",Del:"∇",Delta:"Δ",Dfr:"𝔇",DiacriticalAcute:"´",DiacriticalDot:"˙",DiacriticalDoubleAcute:"˝",DiacriticalGrave:"`",DiacriticalTilde:"˜",Diamond:"⋄",DifferentialD:"ⅆ",Dopf:"𝔻",Dot:"¨",DotDot:"⃜",DotEqual:"≐",DoubleContourIntegral:"∯",DoubleDot:"¨",DoubleDownArrow:"⇓",DoubleLeftArrow:"⇐",DoubleLeftRightArrow:"⇔",DoubleLeftTee:"⫤",DoubleLongLeftArrow:"⟸",DoubleLongLeftRightArrow:"⟺",DoubleLongRightArrow:"⟹",DoubleRightArrow:"⇒",DoubleRightTee:"⊨",DoubleUpArrow:"⇑",DoubleUpDownArrow:"⇕",DoubleVerticalBar:"∥",DownArrow:"↓",DownArrowBar:"⤓",DownArrowUpArrow:"⇵",DownBreve:"̑",DownLeftRightVector:"⥐",DownLeftTeeVector:"⥞",DownLeftVector:"↽",DownLeftVectorBar:"⥖",DownRightTeeVector:"⥟",DownRightVector:"⇁",DownRightVectorBar:"⥗",DownTee:"⊤",DownTeeArrow:"↧",Downarrow:"⇓",Dscr:"𝒟",Dstrok:"Đ",ENG:"Ŋ",ET:"Ð",ETH:"Ð",Eacut:"É",Eacute:"É",Ecaron:"Ě",Ecir:"Ê",Ecirc:"Ê",Ecy:"Э",Edot:"Ė",Efr:"𝔈",Egrav:"È",Egrave:"È",Element:"∈",Emacr:"Ē",EmptySmallSquare:"◻",EmptyVerySmallSquare:"▫",Eogon:"Ę",Eopf:"𝔼",Epsilon:"Ε",Equal:"⩵",EqualTilde:"≂",Equilibrium:"⇌",Escr:"ℰ",Esim:"⩳",Eta:"Η",Eum:"Ë",Euml:"Ë",Exists:"∃",ExponentialE:"ⅇ",Fcy:"Ф",Ffr:"𝔉",FilledSmallSquare:"◼",FilledVerySmallSquare:"▪",Fopf:"𝔽",ForAll:"∀",Fouriertrf:"ℱ",Fscr:"ℱ",GJcy:"Ѓ",G:">",GT:">",Gamma:"Γ",Gammad:"Ϝ",Gbreve:"Ğ",Gcedil:"Ģ",Gcirc:"Ĝ",Gcy:"Г",Gdot:"Ġ",Gfr:"𝔊",Gg:"⋙",Gopf:"𝔾",GreaterEqual:"≥",GreaterEqualLess:"⋛",GreaterFullEqual:"≧",GreaterGreater:"⪢",GreaterLess:"≷",GreaterSlantEqual:"⩾",GreaterTilde:"≳",Gscr:"𝒢",Gt:"≫",HARDcy:"Ъ",Hacek:"ˇ",Hat:"^",Hcirc:"Ĥ",Hfr:"ℌ",HilbertSpace:"ℋ",Hopf:"ℍ",HorizontalLine:"─",Hscr:"ℋ",Hstrok:"Ħ",HumpDownHump:"≎",HumpEqual:"≏",IEcy:"Е",IJlig:"Ĳ",IOcy:"Ё",Iacut:"Í",Iacute:"Í",Icir:"Î",Icirc:"Î",Icy:"И",Idot:"İ",Ifr:"ℑ",Igrav:"Ì",Igrave:"Ì",Im:"ℑ",Imacr:"Ī",ImaginaryI:"ⅈ",Implies:"⇒",Int:"∬",Integral:"∫",Intersection:"⋂",InvisibleComma:"⁣",InvisibleTimes:"⁢",Iogon:"Į",Iopf:"𝕀",Iota:"Ι",Iscr:"ℐ",Itilde:"Ĩ",Iukcy:"І",Ium:"Ï",Iuml:"Ï",Jcirc:"Ĵ",Jcy:"Й",Jfr:"𝔍",Jopf:"𝕁",Jscr:"𝒥",Jsercy:"Ј",Jukcy:"Є",KHcy:"Х",KJcy:"Ќ",Kappa:"Κ",Kcedil:"Ķ",Kcy:"К",Kfr:"𝔎",Kopf:"𝕂",Kscr:"𝒦",LJcy:"Љ",L:"<",LT:"<",Lacute:"Ĺ",Lambda:"Λ",Lang:"⟪",Laplacetrf:"ℒ",Larr:"↞",Lcaron:"Ľ",Lcedil:"Ļ",Lcy:"Л",LeftAngleBracket:"⟨",LeftArrow:"←",LeftArrowBar:"⇤",LeftArrowRightArrow:"⇆",LeftCeiling:"⌈",LeftDoubleBracket:"⟦",LeftDownTeeVector:"⥡",LeftDownVector:"⇃",LeftDownVectorBar:"⥙",LeftFloor:"⌊",LeftRightArrow:"↔",LeftRightVector:"⥎",LeftTee:"⊣",LeftTeeArrow:"↤",LeftTeeVector:"⥚",LeftTriangle:"⊲",LeftTriangleBar:"⧏",LeftTriangleEqual:"⊴",LeftUpDownVector:"⥑",LeftUpTeeVector:"⥠",LeftUpVector:"↿",LeftUpVectorBar:"⥘",LeftVector:"↼",LeftVectorBar:"⥒",Leftarrow:"⇐",Leftrightarrow:"⇔",LessEqualGreater:"⋚",LessFullEqual:"≦",LessGreater:"≶",LessLess:"⪡",LessSlantEqual:"⩽",LessTilde:"≲",Lfr:"𝔏",Ll:"⋘",Lleftarrow:"⇚",Lmidot:"Ŀ",LongLeftArrow:"⟵",LongLeftRightArrow:"⟷",LongRightArrow:"⟶",Longleftarrow:"⟸",Longleftrightarrow:"⟺",Longrightarrow:"⟹",Lopf:"𝕃",LowerLeftArrow:"↙",LowerRightArrow:"↘",Lscr:"ℒ",Lsh:"↰",Lstrok:"Ł",Lt:"≪",Map:"⤅",Mcy:"М",MediumSpace:" ",Mellintrf:"ℳ",Mfr:"𝔐",MinusPlus:"∓",Mopf:"𝕄",Mscr:"ℳ",Mu:"Μ",NJcy:"Њ",Nacute:"Ń",Ncaron:"Ň",Ncedil:"Ņ",Ncy:"Н",NegativeMediumSpace:"​",NegativeThickSpace:"​",NegativeThinSpace:"​",NegativeVeryThinSpace:"​",NestedGreaterGreater:"≫",NestedLessLess:"≪",NewLine:`\n`,Nfr:"𝔑",NoBreak:"⁠",NonBreakingSpace:" ",Nopf:"ℕ",Not:"⫬",NotCongruent:"≢",NotCupCap:"≭",NotDoubleVerticalBar:"∦",NotElement:"∉",NotEqual:"≠",NotEqualTilde:"≂̸",NotExists:"∄",NotGreater:"≯",NotGreaterEqual:"≱",NotGreaterFullEqual:"≧̸",NotGreaterGreater:"≫̸",NotGreaterLess:"≹",NotGreaterSlantEqual:"⩾̸",NotGreaterTilde:"≵",NotHumpDownHump:"≎̸",NotHumpEqual:"≏̸",NotLeftTriangle:"⋪",NotLeftTriangleBar:"⧏̸",NotLeftTriangleEqual:"⋬",NotLess:"≮",NotLessEqual:"≰",NotLessGreater:"≸",NotLessLess:"≪̸",NotLessSlantEqual:"⩽̸",NotLessTilde:"≴",NotNestedGreaterGreater:"⪢̸",NotNestedLessLess:"⪡̸",NotPrecedes:"⊀",NotPrecedesEqual:"⪯̸",NotPrecedesSlantEqual:"⋠",NotReverseElement:"∌",NotRightTriangle:"⋫",NotRightTriangleBar:"⧐̸",NotRightTriangleEqual:"⋭",NotSquareSubset:"⊏̸",NotSquareSubsetEqual:"⋢",NotSquareSuperset:"⊐̸",NotSquareSupersetEqual:"⋣",NotSubset:"⊂⃒",NotSubsetEqual:"⊈",NotSucceeds:"⊁",NotSucceedsEqual:"⪰̸",NotSucceedsSlantEqual:"⋡",NotSucceedsTilde:"≿̸",NotSuperset:"⊃⃒",NotSupersetEqual:"⊉",NotTilde:"≁",NotTildeEqual:"≄",NotTildeFullEqual:"≇",NotTildeTilde:"≉",NotVerticalBar:"∤",Nscr:"𝒩",Ntild:"Ñ",Ntilde:"Ñ",Nu:"Ν",OElig:"Œ",Oacut:"Ó",Oacute:"Ó",Ocir:"Ô",Ocirc:"Ô",Ocy:"О",Odblac:"Ő",Ofr:"𝔒",Ograv:"Ò",Ograve:"Ò",Omacr:"Ō",Omega:"Ω",Omicron:"Ο",Oopf:"𝕆",OpenCurlyDoubleQuote:"“",OpenCurlyQuote:"‘",Or:"⩔",Oscr:"𝒪",Oslas:"Ø",Oslash:"Ø",Otild:"Õ",Otilde:"Õ",Otimes:"⨷",Oum:"Ö",Ouml:"Ö",OverBar:"‾",OverBrace:"⏞",OverBracket:"⎴",OverParenthesis:"⏜",PartialD:"∂",Pcy:"П",Pfr:"𝔓",Phi:"Φ",Pi:"Π",PlusMinus:"±",Poincareplane:"ℌ",Popf:"ℙ",Pr:"⪻",Precedes:"≺",PrecedesEqual:"⪯",PrecedesSlantEqual:"≼",PrecedesTilde:"≾",Prime:"″",Product:"∏",Proportion:"∷",Proportional:"∝",Pscr:"𝒫",Psi:"Ψ",QUO:\'"\',QUOT:\'"\',Qfr:"𝔔",Qopf:"ℚ",Qscr:"𝒬",RBarr:"⤐",RE:"®",REG:"®",Racute:"Ŕ",Rang:"⟫",Rarr:"↠",Rarrtl:"⤖",Rcaron:"Ř",Rcedil:"Ŗ",Rcy:"Р",Re:"ℜ",ReverseElement:"∋",ReverseEquilibrium:"⇋",ReverseUpEquilibrium:"⥯",Rfr:"ℜ",Rho:"Ρ",RightAngleBracket:"⟩",RightArrow:"→",RightArrowBar:"⇥",RightArrowLeftArrow:"⇄",RightCeiling:"⌉",RightDoubleBracket:"⟧",RightDownTeeVector:"⥝",RightDownVector:"⇂",RightDownVectorBar:"⥕",RightFloor:"⌋",RightTee:"⊢",RightTeeArrow:"↦",RightTeeVector:"⥛",RightTriangle:"⊳",RightTriangleBar:"⧐",RightTriangleEqual:"⊵",RightUpDownVector:"⥏",RightUpTeeVector:"⥜",RightUpVector:"↾",RightUpVectorBar:"⥔",RightVector:"⇀",RightVectorBar:"⥓",Rightarrow:"⇒",Ropf:"ℝ",RoundImplies:"⥰",Rrightarrow:"⇛",Rscr:"ℛ",Rsh:"↱",RuleDelayed:"⧴",SHCHcy:"Щ",SHcy:"Ш",SOFTcy:"Ь",Sacute:"Ś",Sc:"⪼",Scaron:"Š",Scedil:"Ş",Scirc:"Ŝ",Scy:"С",Sfr:"𝔖",ShortDownArrow:"↓",ShortLeftArrow:"←",ShortRightArrow:"→",ShortUpArrow:"↑",Sigma:"Σ",SmallCircle:"∘",Sopf:"𝕊",Sqrt:"√",Square:"□",SquareIntersection:"⊓",SquareSubset:"⊏",SquareSubsetEqual:"⊑",SquareSuperset:"⊐",SquareSupersetEqual:"⊒",SquareUnion:"⊔",Sscr:"𝒮",Star:"⋆",Sub:"⋐",Subset:"⋐",SubsetEqual:"⊆",Succeeds:"≻",SucceedsEqual:"⪰",SucceedsSlantEqual:"≽",SucceedsTilde:"≿",SuchThat:"∋",Sum:"∑",Sup:"⋑",Superset:"⊃",SupersetEqual:"⊇",Supset:"⋑",THOR:"Þ",THORN:"Þ",TRADE:"™",TSHcy:"Ћ",TScy:"Ц",Tab:"	",Tau:"Τ",Tcaron:"Ť",Tcedil:"Ţ",Tcy:"Т",Tfr:"𝔗",Therefore:"∴",Theta:"Θ",ThickSpace:"  ",ThinSpace:" ",Tilde:"∼",TildeEqual:"≃",TildeFullEqual:"≅",TildeTilde:"≈",Topf:"𝕋",TripleDot:"⃛",Tscr:"𝒯",Tstrok:"Ŧ",Uacut:"Ú",Uacute:"Ú",Uarr:"↟",Uarrocir:"⥉",Ubrcy:"Ў",Ubreve:"Ŭ",Ucir:"Û",Ucirc:"Û",Ucy:"У",Udblac:"Ű",Ufr:"𝔘",Ugrav:"Ù",Ugrave:"Ù",Umacr:"Ū",UnderBar:"_",UnderBrace:"⏟",UnderBracket:"⎵",UnderParenthesis:"⏝",Union:"⋃",UnionPlus:"⊎",Uogon:"Ų",Uopf:"𝕌",UpArrow:"↑",UpArrowBar:"⤒",UpArrowDownArrow:"⇅",UpDownArrow:"↕",UpEquilibrium:"⥮",UpTee:"⊥",UpTeeArrow:"↥",Uparrow:"⇑",Updownarrow:"⇕",UpperLeftArrow:"↖",UpperRightArrow:"↗",Upsi:"ϒ",Upsilon:"Υ",Uring:"Ů",Uscr:"𝒰",Utilde:"Ũ",Uum:"Ü",Uuml:"Ü",VDash:"⊫",Vbar:"⫫",Vcy:"В",Vdash:"⊩",Vdashl:"⫦",Vee:"⋁",Verbar:"‖",Vert:"‖",VerticalBar:"∣",VerticalLine:"|",VerticalSeparator:"❘",VerticalTilde:"≀",VeryThinSpace:" ",Vfr:"𝔙",Vopf:"𝕍",Vscr:"𝒱",Vvdash:"⊪",Wcirc:"Ŵ",Wedge:"⋀",Wfr:"𝔚",Wopf:"𝕎",Wscr:"𝒲",Xfr:"𝔛",Xi:"Ξ",Xopf:"𝕏",Xscr:"𝒳",YAcy:"Я",YIcy:"Ї",YUcy:"Ю",Yacut:"Ý",Yacute:"Ý",Ycirc:"Ŷ",Ycy:"Ы",Yfr:"𝔜",Yopf:"𝕐",Yscr:"𝒴",Yuml:"Ÿ",ZHcy:"Ж",Zacute:"Ź",Zcaron:"Ž",Zcy:"З",Zdot:"Ż",ZeroWidthSpace:"​",Zeta:"Ζ",Zfr:"ℨ",Zopf:"ℤ",Zscr:"𝒵",aacut:"á",aacute:"á",abreve:"ă",ac:"∾",acE:"∾̳",acd:"∿",acir:"â",acirc:"â",acut:"´",acute:"´",acy:"а",aeli:"æ",aelig:"æ",af:"⁡",afr:"𝔞",agrav:"à",agrave:"à",alefsym:"ℵ",aleph:"ℵ",alpha:"α",amacr:"ā",amalg:"⨿",am:"&",amp:"&",and:"∧",andand:"⩕",andd:"⩜",andslope:"⩘",andv:"⩚",ang:"∠",ange:"⦤",angle:"∠",angmsd:"∡",angmsdaa:"⦨",angmsdab:"⦩",angmsdac:"⦪",angmsdad:"⦫",angmsdae:"⦬",angmsdaf:"⦭",angmsdag:"⦮",angmsdah:"⦯",angrt:"∟",angrtvb:"⊾",angrtvbd:"⦝",angsph:"∢",angst:"Å",angzarr:"⍼",aogon:"ą",aopf:"𝕒",ap:"≈",apE:"⩰",apacir:"⩯",ape:"≊",apid:"≋",apos:"\'",approx:"≈",approxeq:"≊",arin:"å",aring:"å",ascr:"𝒶",ast:"*",asymp:"≈",asympeq:"≍",atild:"ã",atilde:"ã",aum:"ä",auml:"ä",awconint:"∳",awint:"⨑",bNot:"⫭",backcong:"≌",backepsilon:"϶",backprime:"‵",backsim:"∽",backsimeq:"⋍",barvee:"⊽",barwed:"⌅",barwedge:"⌅",bbrk:"⎵",bbrktbrk:"⎶",bcong:"≌",bcy:"б",bdquo:"„",becaus:"∵",because:"∵",bemptyv:"⦰",bepsi:"϶",bernou:"ℬ",beta:"β",beth:"ℶ",between:"≬",bfr:"𝔟",bigcap:"⋂",bigcirc:"◯",bigcup:"⋃",bigodot:"⨀",bigoplus:"⨁",bigotimes:"⨂",bigsqcup:"⨆",bigstar:"★",bigtriangledown:"▽",bigtriangleup:"△",biguplus:"⨄",bigvee:"⋁",bigwedge:"⋀",bkarow:"⤍",blacklozenge:"⧫",blacksquare:"▪",blacktriangle:"▴",blacktriangledown:"▾",blacktriangleleft:"◂",blacktriangleright:"▸",blank:"␣",blk12:"▒",blk14:"░",blk34:"▓",block:"█",bne:"=⃥",bnequiv:"≡⃥",bnot:"⌐",bopf:"𝕓",bot:"⊥",bottom:"⊥",bowtie:"⋈",boxDL:"╗",boxDR:"╔",boxDl:"╖",boxDr:"╓",boxH:"═",boxHD:"╦",boxHU:"╩",boxHd:"╤",boxHu:"╧",boxUL:"╝",boxUR:"╚",boxUl:"╜",boxUr:"╙",boxV:"║",boxVH:"╬",boxVL:"╣",boxVR:"╠",boxVh:"╫",boxVl:"╢",boxVr:"╟",boxbox:"⧉",boxdL:"╕",boxdR:"╒",boxdl:"┐",boxdr:"┌",boxh:"─",boxhD:"╥",boxhU:"╨",boxhd:"┬",boxhu:"┴",boxminus:"⊟",boxplus:"⊞",boxtimes:"⊠",boxuL:"╛",boxuR:"╘",boxul:"┘",boxur:"└",boxv:"│",boxvH:"╪",boxvL:"╡",boxvR:"╞",boxvh:"┼",boxvl:"┤",boxvr:"├",bprime:"‵",breve:"˘",brvba:"¦",brvbar:"¦",bscr:"𝒷",bsemi:"⁏",bsim:"∽",bsime:"⋍",bsol:"\\\\",bsolb:"⧅",bsolhsub:"⟈",bull:"•",bullet:"•",bump:"≎",bumpE:"⪮",bumpe:"≏",bumpeq:"≏",cacute:"ć",cap:"∩",capand:"⩄",capbrcup:"⩉",capcap:"⩋",capcup:"⩇",capdot:"⩀",caps:"∩︀",caret:"⁁",caron:"ˇ",ccaps:"⩍",ccaron:"č",ccedi:"ç",ccedil:"ç",ccirc:"ĉ",ccups:"⩌",ccupssm:"⩐",cdot:"ċ",cedi:"¸",cedil:"¸",cemptyv:"⦲",cen:"¢",cent:"¢",centerdot:"·",cfr:"𝔠",chcy:"ч",check:"✓",checkmark:"✓",chi:"χ",cir:"○",cirE:"⧃",circ:"ˆ",circeq:"≗",circlearrowleft:"↺",circlearrowright:"↻",circledR:"®",circledS:"Ⓢ",circledast:"⊛",circledcirc:"⊚",circleddash:"⊝",cire:"≗",cirfnint:"⨐",cirmid:"⫯",cirscir:"⧂",clubs:"♣",clubsuit:"♣",colon:":",colone:"≔",coloneq:"≔",comma:",",commat:"@",comp:"∁",compfn:"∘",complement:"∁",complexes:"ℂ",cong:"≅",congdot:"⩭",conint:"∮",copf:"𝕔",coprod:"∐",cop:"©",copy:"©",copysr:"℗",crarr:"↵",cross:"✗",cscr:"𝒸",csub:"⫏",csube:"⫑",csup:"⫐",csupe:"⫒",ctdot:"⋯",cudarrl:"⤸",cudarrr:"⤵",cuepr:"⋞",cuesc:"⋟",cularr:"↶",cularrp:"⤽",cup:"∪",cupbrcap:"⩈",cupcap:"⩆",cupcup:"⩊",cupdot:"⊍",cupor:"⩅",cups:"∪︀",curarr:"↷",curarrm:"⤼",curlyeqprec:"⋞",curlyeqsucc:"⋟",curlyvee:"⋎",curlywedge:"⋏",curre:"¤",curren:"¤",curvearrowleft:"↶",curvearrowright:"↷",cuvee:"⋎",cuwed:"⋏",cwconint:"∲",cwint:"∱",cylcty:"⌭",dArr:"⇓",dHar:"⥥",dagger:"†",daleth:"ℸ",darr:"↓",dash:"‐",dashv:"⊣",dbkarow:"⤏",dblac:"˝",dcaron:"ď",dcy:"д",dd:"ⅆ",ddagger:"‡",ddarr:"⇊",ddotseq:"⩷",de:"°",deg:"°",delta:"δ",demptyv:"⦱",dfisht:"⥿",dfr:"𝔡",dharl:"⇃",dharr:"⇂",diam:"⋄",diamond:"⋄",diamondsuit:"♦",diams:"♦",die:"¨",digamma:"ϝ",disin:"⋲",div:"÷",divid:"÷",divide:"÷",divideontimes:"⋇",divonx:"⋇",djcy:"ђ",dlcorn:"⌞",dlcrop:"⌍",dollar:"$",dopf:"𝕕",dot:"˙",doteq:"≐",doteqdot:"≑",dotminus:"∸",dotplus:"∔",dotsquare:"⊡",doublebarwedge:"⌆",downarrow:"↓",downdownarrows:"⇊",downharpoonleft:"⇃",downharpoonright:"⇂",drbkarow:"⤐",drcorn:"⌟",drcrop:"⌌",dscr:"𝒹",dscy:"ѕ",dsol:"⧶",dstrok:"đ",dtdot:"⋱",dtri:"▿",dtrif:"▾",duarr:"⇵",duhar:"⥯",dwangle:"⦦",dzcy:"џ",dzigrarr:"⟿",eDDot:"⩷",eDot:"≑",eacut:"é",eacute:"é",easter:"⩮",ecaron:"ě",ecir:"ê",ecirc:"ê",ecolon:"≕",ecy:"э",edot:"ė",ee:"ⅇ",efDot:"≒",efr:"𝔢",eg:"⪚",egrav:"è",egrave:"è",egs:"⪖",egsdot:"⪘",el:"⪙",elinters:"⏧",ell:"ℓ",els:"⪕",elsdot:"⪗",emacr:"ē",empty:"∅",emptyset:"∅",emptyv:"∅",emsp13:" ",emsp14:" ",emsp:" ",eng:"ŋ",ensp:" ",eogon:"ę",eopf:"𝕖",epar:"⋕",eparsl:"⧣",eplus:"⩱",epsi:"ε",epsilon:"ε",epsiv:"ϵ",eqcirc:"≖",eqcolon:"≕",eqsim:"≂",eqslantgtr:"⪖",eqslantless:"⪕",equals:"=",equest:"≟",equiv:"≡",equivDD:"⩸",eqvparsl:"⧥",erDot:"≓",erarr:"⥱",escr:"ℯ",esdot:"≐",esim:"≂",eta:"η",et:"ð",eth:"ð",eum:"ë",euml:"ë",euro:"€",excl:"!",exist:"∃",expectation:"ℰ",exponentiale:"ⅇ",fallingdotseq:"≒",fcy:"ф",female:"♀",ffilig:"ﬃ",fflig:"ﬀ",ffllig:"ﬄ",ffr:"𝔣",filig:"ﬁ",fjlig:"fj",flat:"♭",fllig:"ﬂ",fltns:"▱",fnof:"ƒ",fopf:"𝕗",forall:"∀",fork:"⋔",forkv:"⫙",fpartint:"⨍",frac1:"¼",frac12:"½",frac13:"⅓",frac14:"¼",frac15:"⅕",frac16:"⅙",frac18:"⅛",frac23:"⅔",frac25:"⅖",frac3:"¾",frac34:"¾",frac35:"⅗",frac38:"⅜",frac45:"⅘",frac56:"⅚",frac58:"⅝",frac78:"⅞",frasl:"⁄",frown:"⌢",fscr:"𝒻",gE:"≧",gEl:"⪌",gacute:"ǵ",gamma:"γ",gammad:"ϝ",gap:"⪆",gbreve:"ğ",gcirc:"ĝ",gcy:"г",gdot:"ġ",ge:"≥",gel:"⋛",geq:"≥",geqq:"≧",geqslant:"⩾",ges:"⩾",gescc:"⪩",gesdot:"⪀",gesdoto:"⪂",gesdotol:"⪄",gesl:"⋛︀",gesles:"⪔",gfr:"𝔤",gg:"≫",ggg:"⋙",gimel:"ℷ",gjcy:"ѓ",gl:"≷",glE:"⪒",gla:"⪥",glj:"⪤",gnE:"≩",gnap:"⪊",gnapprox:"⪊",gne:"⪈",gneq:"⪈",gneqq:"≩",gnsim:"⋧",gopf:"𝕘",grave:"`",gscr:"ℊ",gsim:"≳",gsime:"⪎",gsiml:"⪐",g:">",gt:">",gtcc:"⪧",gtcir:"⩺",gtdot:"⋗",gtlPar:"⦕",gtquest:"⩼",gtrapprox:"⪆",gtrarr:"⥸",gtrdot:"⋗",gtreqless:"⋛",gtreqqless:"⪌",gtrless:"≷",gtrsim:"≳",gvertneqq:"≩︀",gvnE:"≩︀",hArr:"⇔",hairsp:" ",half:"½",hamilt:"ℋ",hardcy:"ъ",harr:"↔",harrcir:"⥈",harrw:"↭",hbar:"ℏ",hcirc:"ĥ",hearts:"♥",heartsuit:"♥",hellip:"…",hercon:"⊹",hfr:"𝔥",hksearow:"⤥",hkswarow:"⤦",hoarr:"⇿",homtht:"∻",hookleftarrow:"↩",hookrightarrow:"↪",hopf:"𝕙",horbar:"―",hscr:"𝒽",hslash:"ℏ",hstrok:"ħ",hybull:"⁃",hyphen:"‐",iacut:"í",iacute:"í",ic:"⁣",icir:"î",icirc:"î",icy:"и",iecy:"е",iexc:"¡",iexcl:"¡",iff:"⇔",ifr:"𝔦",igrav:"ì",igrave:"ì",ii:"ⅈ",iiiint:"⨌",iiint:"∭",iinfin:"⧜",iiota:"℩",ijlig:"ĳ",imacr:"ī",image:"ℑ",imagline:"ℐ",imagpart:"ℑ",imath:"ı",imof:"⊷",imped:"Ƶ",in:"∈",incare:"℅",infin:"∞",infintie:"⧝",inodot:"ı",int:"∫",intcal:"⊺",integers:"ℤ",intercal:"⊺",intlarhk:"⨗",intprod:"⨼",iocy:"ё",iogon:"į",iopf:"𝕚",iota:"ι",iprod:"⨼",iques:"¿",iquest:"¿",iscr:"𝒾",isin:"∈",isinE:"⋹",isindot:"⋵",isins:"⋴",isinsv:"⋳",isinv:"∈",it:"⁢",itilde:"ĩ",iukcy:"і",ium:"ï",iuml:"ï",jcirc:"ĵ",jcy:"й",jfr:"𝔧",jmath:"ȷ",jopf:"𝕛",jscr:"𝒿",jsercy:"ј",jukcy:"є",kappa:"κ",kappav:"ϰ",kcedil:"ķ",kcy:"к",kfr:"𝔨",kgreen:"ĸ",khcy:"х",kjcy:"ќ",kopf:"𝕜",kscr:"𝓀",lAarr:"⇚",lArr:"⇐",lAtail:"⤛",lBarr:"⤎",lE:"≦",lEg:"⪋",lHar:"⥢",lacute:"ĺ",laemptyv:"⦴",lagran:"ℒ",lambda:"λ",lang:"⟨",langd:"⦑",langle:"⟨",lap:"⪅",laqu:"«",laquo:"«",larr:"←",larrb:"⇤",larrbfs:"⤟",larrfs:"⤝",larrhk:"↩",larrlp:"↫",larrpl:"⤹",larrsim:"⥳",larrtl:"↢",lat:"⪫",latail:"⤙",late:"⪭",lates:"⪭︀",lbarr:"⤌",lbbrk:"❲",lbrace:"{",lbrack:"[",lbrke:"⦋",lbrksld:"⦏",lbrkslu:"⦍",lcaron:"ľ",lcedil:"ļ",lceil:"⌈",lcub:"{",lcy:"л",ldca:"⤶",ldquo:"“",ldquor:"„",ldrdhar:"⥧",ldrushar:"⥋",ldsh:"↲",le:"≤",leftarrow:"←",leftarrowtail:"↢",leftharpoondown:"↽",leftharpoonup:"↼",leftleftarrows:"⇇",leftrightarrow:"↔",leftrightarrows:"⇆",leftrightharpoons:"⇋",leftrightsquigarrow:"↭",leftthreetimes:"⋋",leg:"⋚",leq:"≤",leqq:"≦",leqslant:"⩽",les:"⩽",lescc:"⪨",lesdot:"⩿",lesdoto:"⪁",lesdotor:"⪃",lesg:"⋚︀",lesges:"⪓",lessapprox:"⪅",lessdot:"⋖",lesseqgtr:"⋚",lesseqqgtr:"⪋",lessgtr:"≶",lesssim:"≲",lfisht:"⥼",lfloor:"⌊",lfr:"𝔩",lg:"≶",lgE:"⪑",lhard:"↽",lharu:"↼",lharul:"⥪",lhblk:"▄",ljcy:"љ",ll:"≪",llarr:"⇇",llcorner:"⌞",llhard:"⥫",lltri:"◺",lmidot:"ŀ",lmoust:"⎰",lmoustache:"⎰",lnE:"≨",lnap:"⪉",lnapprox:"⪉",lne:"⪇",lneq:"⪇",lneqq:"≨",lnsim:"⋦",loang:"⟬",loarr:"⇽",lobrk:"⟦",longleftarrow:"⟵",longleftrightarrow:"⟷",longmapsto:"⟼",longrightarrow:"⟶",looparrowleft:"↫",looparrowright:"↬",lopar:"⦅",lopf:"𝕝",loplus:"⨭",lotimes:"⨴",lowast:"∗",lowbar:"_",loz:"◊",lozenge:"◊",lozf:"⧫",lpar:"(",lparlt:"⦓",lrarr:"⇆",lrcorner:"⌟",lrhar:"⇋",lrhard:"⥭",lrm:"‎",lrtri:"⊿",lsaquo:"‹",lscr:"𝓁",lsh:"↰",lsim:"≲",lsime:"⪍",lsimg:"⪏",lsqb:"[",lsquo:"‘",lsquor:"‚",lstrok:"ł",l:"<",lt:"<",ltcc:"⪦",ltcir:"⩹",ltdot:"⋖",lthree:"⋋",ltimes:"⋉",ltlarr:"⥶",ltquest:"⩻",ltrPar:"⦖",ltri:"◃",ltrie:"⊴",ltrif:"◂",lurdshar:"⥊",luruhar:"⥦",lvertneqq:"≨︀",lvnE:"≨︀",mDDot:"∺",mac:"¯",macr:"¯",male:"♂",malt:"✠",maltese:"✠",map:"↦",mapsto:"↦",mapstodown:"↧",mapstoleft:"↤",mapstoup:"↥",marker:"▮",mcomma:"⨩",mcy:"м",mdash:"—",measuredangle:"∡",mfr:"𝔪",mho:"℧",micr:"µ",micro:"µ",mid:"∣",midast:"*",midcir:"⫰",middo:"·",middot:"·",minus:"−",minusb:"⊟",minusd:"∸",minusdu:"⨪",mlcp:"⫛",mldr:"…",mnplus:"∓",models:"⊧",mopf:"𝕞",mp:"∓",mscr:"𝓂",mstpos:"∾",mu:"μ",multimap:"⊸",mumap:"⊸",nGg:"⋙̸",nGt:"≫⃒",nGtv:"≫̸",nLeftarrow:"⇍",nLeftrightarrow:"⇎",nLl:"⋘̸",nLt:"≪⃒",nLtv:"≪̸",nRightarrow:"⇏",nVDash:"⊯",nVdash:"⊮",nabla:"∇",nacute:"ń",nang:"∠⃒",nap:"≉",napE:"⩰̸",napid:"≋̸",napos:"ŉ",napprox:"≉",natur:"♮",natural:"♮",naturals:"ℕ",nbs:" ",nbsp:" ",nbump:"≎̸",nbumpe:"≏̸",ncap:"⩃",ncaron:"ň",ncedil:"ņ",ncong:"≇",ncongdot:"⩭̸",ncup:"⩂",ncy:"н",ndash:"–",ne:"≠",neArr:"⇗",nearhk:"⤤",nearr:"↗",nearrow:"↗",nedot:"≐̸",nequiv:"≢",nesear:"⤨",nesim:"≂̸",nexist:"∄",nexists:"∄",nfr:"𝔫",ngE:"≧̸",nge:"≱",ngeq:"≱",ngeqq:"≧̸",ngeqslant:"⩾̸",nges:"⩾̸",ngsim:"≵",ngt:"≯",ngtr:"≯",nhArr:"⇎",nharr:"↮",nhpar:"⫲",ni:"∋",nis:"⋼",nisd:"⋺",niv:"∋",njcy:"њ",nlArr:"⇍",nlE:"≦̸",nlarr:"↚",nldr:"‥",nle:"≰",nleftarrow:"↚",nleftrightarrow:"↮",nleq:"≰",nleqq:"≦̸",nleqslant:"⩽̸",nles:"⩽̸",nless:"≮",nlsim:"≴",nlt:"≮",nltri:"⋪",nltrie:"⋬",nmid:"∤",nopf:"𝕟",no:"¬",not:"¬",notin:"∉",notinE:"⋹̸",notindot:"⋵̸",notinva:"∉",notinvb:"⋷",notinvc:"⋶",notni:"∌",notniva:"∌",notnivb:"⋾",notnivc:"⋽",npar:"∦",nparallel:"∦",nparsl:"⫽⃥",npart:"∂̸",npolint:"⨔",npr:"⊀",nprcue:"⋠",npre:"⪯̸",nprec:"⊀",npreceq:"⪯̸",nrArr:"⇏",nrarr:"↛",nrarrc:"⤳̸",nrarrw:"↝̸",nrightarrow:"↛",nrtri:"⋫",nrtrie:"⋭",nsc:"⊁",nsccue:"⋡",nsce:"⪰̸",nscr:"𝓃",nshortmid:"∤",nshortparallel:"∦",nsim:"≁",nsime:"≄",nsimeq:"≄",nsmid:"∤",nspar:"∦",nsqsube:"⋢",nsqsupe:"⋣",nsub:"⊄",nsubE:"⫅̸",nsube:"⊈",nsubset:"⊂⃒",nsubseteq:"⊈",nsubseteqq:"⫅̸",nsucc:"⊁",nsucceq:"⪰̸",nsup:"⊅",nsupE:"⫆̸",nsupe:"⊉",nsupset:"⊃⃒",nsupseteq:"⊉",nsupseteqq:"⫆̸",ntgl:"≹",ntild:"ñ",ntilde:"ñ",ntlg:"≸",ntriangleleft:"⋪",ntrianglelefteq:"⋬",ntriangleright:"⋫",ntrianglerighteq:"⋭",nu:"ν",num:"#",numero:"№",numsp:" ",nvDash:"⊭",nvHarr:"⤄",nvap:"≍⃒",nvdash:"⊬",nvge:"≥⃒",nvgt:">⃒",nvinfin:"⧞",nvlArr:"⤂",nvle:"≤⃒",nvlt:"<⃒",nvltrie:"⊴⃒",nvrArr:"⤃",nvrtrie:"⊵⃒",nvsim:"∼⃒",nwArr:"⇖",nwarhk:"⤣",nwarr:"↖",nwarrow:"↖",nwnear:"⤧",oS:"Ⓢ",oacut:"ó",oacute:"ó",oast:"⊛",ocir:"ô",ocirc:"ô",ocy:"о",odash:"⊝",odblac:"ő",odiv:"⨸",odot:"⊙",odsold:"⦼",oelig:"œ",ofcir:"⦿",ofr:"𝔬",ogon:"˛",ograv:"ò",ograve:"ò",ogt:"⧁",ohbar:"⦵",ohm:"Ω",oint:"∮",olarr:"↺",olcir:"⦾",olcross:"⦻",oline:"‾",olt:"⧀",omacr:"ō",omega:"ω",omicron:"ο",omid:"⦶",ominus:"⊖",oopf:"𝕠",opar:"⦷",operp:"⦹",oplus:"⊕",or:"∨",orarr:"↻",ord:"º",order:"ℴ",orderof:"ℴ",ordf:"ª",ordm:"º",origof:"⊶",oror:"⩖",orslope:"⩗",orv:"⩛",oscr:"ℴ",oslas:"ø",oslash:"ø",osol:"⊘",otild:"õ",otilde:"õ",otimes:"⊗",otimesas:"⨶",oum:"ö",ouml:"ö",ovbar:"⌽",par:"¶",para:"¶",parallel:"∥",parsim:"⫳",parsl:"⫽",part:"∂",pcy:"п",percnt:"%",period:".",permil:"‰",perp:"⊥",pertenk:"‱",pfr:"𝔭",phi:"φ",phiv:"ϕ",phmmat:"ℳ",phone:"☎",pi:"π",pitchfork:"⋔",piv:"ϖ",planck:"ℏ",planckh:"ℎ",plankv:"ℏ",plus:"+",plusacir:"⨣",plusb:"⊞",pluscir:"⨢",plusdo:"∔",plusdu:"⨥",pluse:"⩲",plusm:"±",plusmn:"±",plussim:"⨦",plustwo:"⨧",pm:"±",pointint:"⨕",popf:"𝕡",poun:"£",pound:"£",pr:"≺",prE:"⪳",prap:"⪷",prcue:"≼",pre:"⪯",prec:"≺",precapprox:"⪷",preccurlyeq:"≼",preceq:"⪯",precnapprox:"⪹",precneqq:"⪵",precnsim:"⋨",precsim:"≾",prime:"′",primes:"ℙ",prnE:"⪵",prnap:"⪹",prnsim:"⋨",prod:"∏",profalar:"⌮",profline:"⌒",profsurf:"⌓",prop:"∝",propto:"∝",prsim:"≾",prurel:"⊰",pscr:"𝓅",psi:"ψ",puncsp:" ",qfr:"𝔮",qint:"⨌",qopf:"𝕢",qprime:"⁗",qscr:"𝓆",quaternions:"ℍ",quatint:"⨖",quest:"?",questeq:"≟",quo:\'"\',quot:\'"\',rAarr:"⇛",rArr:"⇒",rAtail:"⤜",rBarr:"⤏",rHar:"⥤",race:"∽̱",racute:"ŕ",radic:"√",raemptyv:"⦳",rang:"⟩",rangd:"⦒",range:"⦥",rangle:"⟩",raqu:"»",raquo:"»",rarr:"→",rarrap:"⥵",rarrb:"⇥",rarrbfs:"⤠",rarrc:"⤳",rarrfs:"⤞",rarrhk:"↪",rarrlp:"↬",rarrpl:"⥅",rarrsim:"⥴",rarrtl:"↣",rarrw:"↝",ratail:"⤚",ratio:"∶",rationals:"ℚ",rbarr:"⤍",rbbrk:"❳",rbrace:"}",rbrack:"]",rbrke:"⦌",rbrksld:"⦎",rbrkslu:"⦐",rcaron:"ř",rcedil:"ŗ",rceil:"⌉",rcub:"}",rcy:"р",rdca:"⤷",rdldhar:"⥩",rdquo:"”",rdquor:"”",rdsh:"↳",real:"ℜ",realine:"ℛ",realpart:"ℜ",reals:"ℝ",rect:"▭",re:"®",reg:"®",rfisht:"⥽",rfloor:"⌋",rfr:"𝔯",rhard:"⇁",rharu:"⇀",rharul:"⥬",rho:"ρ",rhov:"ϱ",rightarrow:"→",rightarrowtail:"↣",rightharpoondown:"⇁",rightharpoonup:"⇀",rightleftarrows:"⇄",rightleftharpoons:"⇌",rightrightarrows:"⇉",rightsquigarrow:"↝",rightthreetimes:"⋌",ring:"˚",risingdotseq:"≓",rlarr:"⇄",rlhar:"⇌",rlm:"‏",rmoust:"⎱",rmoustache:"⎱",rnmid:"⫮",roang:"⟭",roarr:"⇾",robrk:"⟧",ropar:"⦆",ropf:"𝕣",roplus:"⨮",rotimes:"⨵",rpar:")",rpargt:"⦔",rppolint:"⨒",rrarr:"⇉",rsaquo:"›",rscr:"𝓇",rsh:"↱",rsqb:"]",rsquo:"’",rsquor:"’",rthree:"⋌",rtimes:"⋊",rtri:"▹",rtrie:"⊵",rtrif:"▸",rtriltri:"⧎",ruluhar:"⥨",rx:"℞",sacute:"ś",sbquo:"‚",sc:"≻",scE:"⪴",scap:"⪸",scaron:"š",sccue:"≽",sce:"⪰",scedil:"ş",scirc:"ŝ",scnE:"⪶",scnap:"⪺",scnsim:"⋩",scpolint:"⨓",scsim:"≿",scy:"с",sdot:"⋅",sdotb:"⊡",sdote:"⩦",seArr:"⇘",searhk:"⤥",searr:"↘",searrow:"↘",sec:"§",sect:"§",semi:";",seswar:"⤩",setminus:"∖",setmn:"∖",sext:"✶",sfr:"𝔰",sfrown:"⌢",sharp:"♯",shchcy:"щ",shcy:"ш",shortmid:"∣",shortparallel:"∥",sh:"­",shy:"­",sigma:"σ",sigmaf:"ς",sigmav:"ς",sim:"∼",simdot:"⩪",sime:"≃",simeq:"≃",simg:"⪞",simgE:"⪠",siml:"⪝",simlE:"⪟",simne:"≆",simplus:"⨤",simrarr:"⥲",slarr:"←",smallsetminus:"∖",smashp:"⨳",smeparsl:"⧤",smid:"∣",smile:"⌣",smt:"⪪",smte:"⪬",smtes:"⪬︀",softcy:"ь",sol:"/",solb:"⧄",solbar:"⌿",sopf:"𝕤",spades:"♠",spadesuit:"♠",spar:"∥",sqcap:"⊓",sqcaps:"⊓︀",sqcup:"⊔",sqcups:"⊔︀",sqsub:"⊏",sqsube:"⊑",sqsubset:"⊏",sqsubseteq:"⊑",sqsup:"⊐",sqsupe:"⊒",sqsupset:"⊐",sqsupseteq:"⊒",squ:"□",square:"□",squarf:"▪",squf:"▪",srarr:"→",sscr:"𝓈",ssetmn:"∖",ssmile:"⌣",sstarf:"⋆",star:"☆",starf:"★",straightepsilon:"ϵ",straightphi:"ϕ",strns:"¯",sub:"⊂",subE:"⫅",subdot:"⪽",sube:"⊆",subedot:"⫃",submult:"⫁",subnE:"⫋",subne:"⊊",subplus:"⪿",subrarr:"⥹",subset:"⊂",subseteq:"⊆",subseteqq:"⫅",subsetneq:"⊊",subsetneqq:"⫋",subsim:"⫇",subsub:"⫕",subsup:"⫓",succ:"≻",succapprox:"⪸",succcurlyeq:"≽",succeq:"⪰",succnapprox:"⪺",succneqq:"⪶",succnsim:"⋩",succsim:"≿",sum:"∑",sung:"♪",sup:"⊃",sup1:"¹",sup2:"²",sup3:"³",supE:"⫆",supdot:"⪾",supdsub:"⫘",supe:"⊇",supedot:"⫄",suphsol:"⟉",suphsub:"⫗",suplarr:"⥻",supmult:"⫂",supnE:"⫌",supne:"⊋",supplus:"⫀",supset:"⊃",supseteq:"⊇",supseteqq:"⫆",supsetneq:"⊋",supsetneqq:"⫌",supsim:"⫈",supsub:"⫔",supsup:"⫖",swArr:"⇙",swarhk:"⤦",swarr:"↙",swarrow:"↙",swnwar:"⤪",szli:"ß",szlig:"ß",target:"⌖",tau:"τ",tbrk:"⎴",tcaron:"ť",tcedil:"ţ",tcy:"т",tdot:"⃛",telrec:"⌕",tfr:"𝔱",there4:"∴",therefore:"∴",theta:"θ",thetasym:"ϑ",thetav:"ϑ",thickapprox:"≈",thicksim:"∼",thinsp:" ",thkap:"≈",thksim:"∼",thor:"þ",thorn:"þ",tilde:"˜",time:"×",times:"×",timesb:"⊠",timesbar:"⨱",timesd:"⨰",tint:"∭",toea:"⤨",top:"⊤",topbot:"⌶",topcir:"⫱",topf:"𝕥",topfork:"⫚",tosa:"⤩",tprime:"‴",trade:"™",triangle:"▵",triangledown:"▿",triangleleft:"◃",trianglelefteq:"⊴",triangleq:"≜",triangleright:"▹",trianglerighteq:"⊵",tridot:"◬",trie:"≜",triminus:"⨺",triplus:"⨹",trisb:"⧍",tritime:"⨻",trpezium:"⏢",tscr:"𝓉",tscy:"ц",tshcy:"ћ",tstrok:"ŧ",twixt:"≬",twoheadleftarrow:"↞",twoheadrightarrow:"↠",uArr:"⇑",uHar:"⥣",uacut:"ú",uacute:"ú",uarr:"↑",ubrcy:"ў",ubreve:"ŭ",ucir:"û",ucirc:"û",ucy:"у",udarr:"⇅",udblac:"ű",udhar:"⥮",ufisht:"⥾",ufr:"𝔲",ugrav:"ù",ugrave:"ù",uharl:"↿",uharr:"↾",uhblk:"▀",ulcorn:"⌜",ulcorner:"⌜",ulcrop:"⌏",ultri:"◸",umacr:"ū",um:"¨",uml:"¨",uogon:"ų",uopf:"𝕦",uparrow:"↑",updownarrow:"↕",upharpoonleft:"↿",upharpoonright:"↾",uplus:"⊎",upsi:"υ",upsih:"ϒ",upsilon:"υ",upuparrows:"⇈",urcorn:"⌝",urcorner:"⌝",urcrop:"⌎",uring:"ů",urtri:"◹",uscr:"𝓊",utdot:"⋰",utilde:"ũ",utri:"▵",utrif:"▴",uuarr:"⇈",uum:"ü",uuml:"ü",uwangle:"⦧",vArr:"⇕",vBar:"⫨",vBarv:"⫩",vDash:"⊨",vangrt:"⦜",varepsilon:"ϵ",varkappa:"ϰ",varnothing:"∅",varphi:"ϕ",varpi:"ϖ",varpropto:"∝",varr:"↕",varrho:"ϱ",varsigma:"ς",varsubsetneq:"⊊︀",varsubsetneqq:"⫋︀",varsupsetneq:"⊋︀",varsupsetneqq:"⫌︀",vartheta:"ϑ",vartriangleleft:"⊲",vartriangleright:"⊳",vcy:"в",vdash:"⊢",vee:"∨",veebar:"⊻",veeeq:"≚",vellip:"⋮",verbar:"|",vert:"|",vfr:"𝔳",vltri:"⊲",vnsub:"⊂⃒",vnsup:"⊃⃒",vopf:"𝕧",vprop:"∝",vrtri:"⊳",vscr:"𝓋",vsubnE:"⫋︀",vsubne:"⊊︀",vsupnE:"⫌︀",vsupne:"⊋︀",vzigzag:"⦚",wcirc:"ŵ",wedbar:"⩟",wedge:"∧",wedgeq:"≙",weierp:"℘",wfr:"𝔴",wopf:"𝕨",wp:"℘",wr:"≀",wreath:"≀",wscr:"𝓌",xcap:"⋂",xcirc:"◯",xcup:"⋃",xdtri:"▽",xfr:"𝔵",xhArr:"⟺",xharr:"⟷",xi:"ξ",xlArr:"⟸",xlarr:"⟵",xmap:"⟼",xnis:"⋻",xodot:"⨀",xopf:"𝕩",xoplus:"⨁",xotime:"⨂",xrArr:"⟹",xrarr:"⟶",xscr:"𝓍",xsqcup:"⨆",xuplus:"⨄",xutri:"△",xvee:"⋁",xwedge:"⋀",yacut:"ý",yacute:"ý",yacy:"я",ycirc:"ŷ",ycy:"ы",ye:"¥",yen:"¥",yfr:"𝔶",yicy:"ї",yopf:"𝕪",yscr:"𝓎",yucy:"ю",yum:"ÿ",yuml:"ÿ",zacute:"ź",zcaron:"ž",zcy:"з",zdot:"ż",zeetrf:"ℨ",zeta:"ζ",zfr:"𝔷",zhcy:"ж",zigrarr:"⇝",zopf:"𝕫",zscr:"𝓏",zwj:"‍",zwnj:"‌"},ENTITY_MAP=_ENTITY_MAP;function entityStringToRawString(D){D.startsWith("&")||(D="&"+D),D.endsWith(";")||(D+=";");try{if(D.charAt(1)==="#"){const F=D.charAt(2)==="x"?parseInt(D.slice(3,D.length-1),16):parseInt(D.slice(2,D.length-1),10);return String.fromCharCode(F)}const E=D.slice(1,D.length-1);if(E in ENTITY_MAP)return ENTITY_MAP[E]}catch(E){console.warn(`Encountered error when converting entity "${D}": ${E.message}`)}return console.warn(`Cannot convert XML entity "${D}"`),D}function entityToString(D,E){switch(D.name){case"CharacterReference":case"EntityReference":{const F=extractContent(D,E),J=entityStringToRawString(F);return J==="$"&&/[a-zA-Z_]/.test(E.charAt(D.to))?J+"​":J}}throw new Error(`Cannot use entityToString to convert a node of type ${D.name}`)}function removeQuotes(D){return(D.startsWith("\'")||D.startsWith(\'"\'))&&(D=D.slice(1)),(D.endsWith("\'")||D.endsWith(\'"\'))&&(D=D.slice(0,D.length-1)),D}function unescapeEntities(D,E){const F=extractContent(D,E),J=D.getChildren("EntityReference");if(J.length===0)return F;let $e=0,_t="";for(const lr of J)_t+=F.slice($e,lr.from-D.from),_t+=entityToString(lr,E),$e=lr.to-D.from;return _t+=F.slice($e),_t}function textNodeToText(D,E){if(D.name!=="Text")throw new Error(`Can only convert node of type "Text", not the passed-in type of "${D.name}"`);return unescapeEntities(D,E)}function attributeValueText(D,E){if(D.name!=="AttributeValue")throw new Error(`Can only get the text of an "AttributeValue" type node, not "${D.name}"`);return removeQuotes(unescapeEntities(D,E))}function lezerNodeToPosition(D,E,F=!1){const{rowMap:J,columnMap:$e}=E;let{from:_t,to:lr}=D;return F&&(_t+=1,lr-=1),{start:{line:J[_t]+1,column:$e[_t]+1,offset:_t},end:{line:J[lr]+1,column:$e[lr]+1,offset:lr}}}function extractContent(D,E){return E.slice(D.from,D.to)}function createOffsetToPositionMap$1(D){const E=new Uint32Array(D.length+1),F=new Uint32Array(D.length+1),J=D.length;let $e=0,_t=0;for(let lr=0;lr<J;lr++)E[lr]=$e,F[lr]=_t,D.charAt(lr)===`\n`?($e+=1,_t=0):_t+=1;return E[J]=$e,F[J]=_t,{rowMap:E,columnMap:F}}function extractDoctypeInfo(D){D.startsWith("<!DOCTYPE")&&(D=D.slice(10)),D.endsWith(">")&&(D=D.slice(0,D.length-1)),D=D.trim();const F=D.match(/^[\\w-]*/)?.[0]||"";F&&(D=D.slice(F.length).trim());let J=null,$e=null;if(D.startsWith("PUBLIC")){D=D.slice(6);const _t=D.match(/(["\'])(.*?)\\1/g);_t&&(_t[0]&&(J=_t[0].slice(1,_t[0].length-1)),_t[1]&&($e=_t[1].slice(1,_t[1].length-1)))}if(D.startsWith("SYSTEM")){D=D.slice(6);const _t=D.match(/(["\'])(.*?)\\1/g);_t&&_t[0]&&($e=_t[0].slice(1,_t[0].length-1))}return{name:F,public:J,system:$e}}function findFirstErrorInChild(D){if(D.type.name==="⚠")return D;let E=D.firstChild;for(;E;){const F=findFirstErrorInChild(E);if(F)return F;E=E.nextSibling}return null}function getLezerChildren(D){const E=[];let F=D.firstChild;for(;F;)E.push(F),F=F.nextSibling;return E}function updateNodePositionData(D,E,F){if(!D.position||!E.position)return;const J=E.position.start.offset;D.position.start.offset!=null&&J!=null&&(D.position.start.offset+=J),D.position.end.offset!=null&&J!=null&&(D.position.end.offset+=J);const $e=D.position.start.offset,_t=D.position.end.offset;$e!=null&&_t!=null&&(D.position.start.line=F.rowMap[$e]+1,D.position.start.column=F.columnMap[$e]+1,D.position.end.line=F.rowMap[_t]+1,D.position.end.column=F.columnMap[_t]+1)}function createErrorNode(D,E,F){if(!D.type.isError&&!D.type.is(MissingCloseTag))throw new Error("Function can only be called on a node of type error.");function J(_t,lr){const{startNode:mr=D,endNode:Or=D}=lr??{},Pr=lezerNodeToPosition(mr,F),dn=mr!==Or?lezerNodeToPosition(Or,F):Pr;return{type:"error",message:_t,position:{start:Pr.start,end:dn.end}}}const $e=D.parent;if(!$e)return{type:"error",message:`Invalid DoenetML: ${extractContent(D,E)}`,position:lezerNodeToPosition(D,F)};switch($e.type.id){case Element:{const _t=$e.getChild(OpenTag),lr=$e.getChild(CloseTag),mr=(_t||$e.getChild(SelfClosingTag)||lr)?.getChild(TagName),Or=mr?extractContent(mr,E):"";if(_t&&!lr){const Pr=mr?extractContent(mr,E):"",dn=`Invalid DoenetML: The tag \\`${extractContent(_t,E)}\\` has no closing tag. Expected a self-closing tag or a \\`</${Pr}>\\` tag.`;return J(dn,{startNode:_t,endNode:_t})}return J(`Invalid DoenetML: Error in tag \\`<${Or}>\\``)}case Attribute:{const _t=extractContent($e,E),lr=$e.getChild("AttributeName"),mr=$e.getChild("Is");return J(lr&&mr?`Invalid DoenetML: Invalid attribute \\`${_t}\\` appears to be missing a value.`:`Invalid DoenetML: Invalid attribute \\`${_t}\\``)}case AttributeValue:{const _t=$e.parent,lr=extractContent($e,E),mr=lr[0],Or=lr[lr.length-1];if(!_t||mr===Or)return J(`Invalid DoenetML: Invalid attribute value \\`${lr}\\``);const Pr=mr.match(/[\'"]/)?mr:Or.match(/[\'"]/)?Or:\'"\';return J(`Invalid DoenetML: Invalid attribute value \\`${lr}\\`. The quote marks do not match. You appear to be missing a \\`${Pr}\\``)}case OpenTag:{const _t=$e.getChild(TagName);if(!_t)return J("Invalid DoenetML: Found a tag without a tag name, e.g. `<`");if(!$e.getChild(EndTag))return J(`Invalid DoenetML: Tag \\`${extractContent($e,E)}\\` was not closed (a \\`>\\` appears to be missing).`,{startNode:$e,endNode:_t})}case SelfClosingTag:return $e.getChild(TagName)?$e.getChild(SelfCloseEndTag)?J(`Invalid DoenetML: Tag \\`${extractContent($e,E)}\\` is not valid. It may have incorrect attributes.`):J(`Invalid DoenetML: Tag \\`${extractContent($e,E)}\\` was not closed (\\`/>\\` appears to be missing).`):J(`Invalid DoenetML: Found a tag without a tag name \\`<${extractContent(D,E)}>\\``);case MismatchedCloseTag:case CloseTag:{const _t=$e.getChild(TagName);if(!_t)return J("Invalid DoenetML: Found a closing tag without a tag name, e.g. `</`");if(!$e.getChild(EndTag))return J(`Invalid DoenetML: Tag \\`${extractContent($e,E)}\\` was not closed (a \\`>\\` appears to be missing).`,{startNode:$e,endNode:_t})}}return J(`Could not convert node ${D} to Dast node.`)}function unquotedAttributeValueMessage(D,E){return`Attribute values must be enclosed in quotes: \\`${D}="${E}"\\``}function findBareAttributeValuePairs(D,E){if(D.length<2)return[];const F=D.filter($e=>$e.position?.start.offset!=null&&$e.position?.end.offset!=null).sort(($e,_t)=>($e.position?.start.offset??0)-(_t.position?.start.offset??0)),J=[];for(let $e=1;$e<F.length;$e++){const _t=F[$e-1],lr=F[$e];if(_t.children.length!==0||lr.children.length!==0)continue;const mr=E.slice(_t.position?.start.offset??0,_t.position?.end.offset??0);/=\\s*$/.test(mr)&&J.push({assignAttr:_t,valueAttr:lr})}return J}const _MacroParser=(function(){class D extends SyntaxError{constructor(J,$e,_t,lr){super(J),this.expected=$e,this.found=_t,this.location=lr,this.name="SyntaxError"}format(J){let $e="Error: "+this.message;if(this.location){let _t=null;const lr=J.find(dn=>dn.source===this.location.source);lr&&(_t=lr.text.split(/\\r\\n|\\n|\\r/g));const mr=this.location.start,Or=this.location.source&&typeof this.location.source.offset=="function"?this.location.source.offset(mr):mr,Pr=this.location.source+":"+Or.line+":"+Or.column;if(_t){const dn=this.location.end,gi="".padEnd(Or.line.toString().length," "),qi=_t[mr.line-1],Hi=(mr.line===dn.line?dn.column:qi.length+1)-mr.column||1;$e+=`\n --> `+Pr+`\n`+gi+` |\n`+Or.line+" | "+qi+`\n`+gi+" | "+"".padEnd(mr.column-1," ")+"".padEnd(Hi,"^")}else $e+=`\n at `+Pr}return $e}static buildMessage(J,$e){function _t(Hi){return Hi.codePointAt(0).toString(16).toUpperCase()}const lr=Object.prototype.hasOwnProperty.call(RegExp.prototype,"unicode")?new RegExp("[\\\\p{C}\\\\p{Mn}\\\\p{Mc}]","gu"):null;function mr(Hi){return lr?Hi.replace(lr,Qi=>"\\\\u{"+_t(Qi)+"}"):Hi}function Or(Hi){return mr(Hi.replace(/\\\\/g,"\\\\\\\\").replace(/"/g,\'\\\\"\').replace(/\\0/g,"\\\\0").replace(/\\t/g,"\\\\t").replace(/\\n/g,"\\\\n").replace(/\\r/g,"\\\\r").replace(/[\\x00-\\x0F]/g,Qi=>"\\\\x0"+_t(Qi)).replace(/[\\x10-\\x1F\\x7F-\\x9F]/g,Qi=>"\\\\x"+_t(Qi)))}function Pr(Hi){return mr(Hi.replace(/\\\\/g,"\\\\\\\\").replace(/\\]/g,"\\\\]").replace(/\\^/g,"\\\\^").replace(/-/g,"\\\\-").replace(/\\0/g,"\\\\0").replace(/\\t/g,"\\\\t").replace(/\\n/g,"\\\\n").replace(/\\r/g,"\\\\r").replace(/[\\x00-\\x0F]/g,Qi=>"\\\\x0"+_t(Qi)).replace(/[\\x10-\\x1F\\x7F-\\x9F]/g,Qi=>"\\\\x"+_t(Qi)))}const dn={literal(Hi){return\'"\'+Or(Hi.text)+\'"\'},class(Hi){const Qi=Hi.parts.map(Gi=>Array.isArray(Gi)?Pr(Gi[0])+"-"+Pr(Gi[1]):Pr(Gi));return"["+(Hi.inverted?"^":"")+Qi.join("")+"]"+(Hi.unicode?"u":"")},any(){return"any character"},end(){return"end of input"},other(Hi){return Hi.description}};function gi(Hi){return dn[Hi.type](Hi)}function qi(Hi){const Qi=Hi.map(gi);if(Qi.sort(),Qi.length>0){let Gi=1;for(let Zi=1;Zi<Qi.length;Zi++)Qi[Zi-1]!==Qi[Zi]&&(Qi[Gi]=Qi[Zi],Gi++);Qi.length=Gi}switch(Qi.length){case 1:return Qi[0];case 2:return Qi[0]+" or "+Qi[1];default:return Qi.slice(0,-1).join(", ")+", or "+Qi[Qi.length-1]}}function zi(Hi){return Hi?\'"\'+Or(Hi)+\'"\':"end of input"}return"Expected "+qi(J)+" but "+zi($e)+" found."}}function E(F,J){J=J!==void 0?J:{};const $e={},_t=J.grammarSource,lr={top:Js};let mr=Js;const Or=".",Pr="$",dn="(",gi=")",qi="$$",zi=",",Hi="{",Qi="}",Gi="[",Zi="]",Xi="=",Ki=\'"\',ea="\'",Ji=/^[a-zA-Z_]/,ta=/^[a-zA-Z0-9_]/,na=/^[a-zA-Z0-9_\\-]/,ra=/^[a-zA-Z0-9_:\\-]/,ia=/^[^$]/,oa=/^[^(),$]/,ua=/^[^(),]/,sa=/^[^()$]/,aa=/^[^()]/,pa=/^[^\'$]/,ma=/^[^\']/,la=/^[^\\]$]/,ha=/^[^\\]]/,ga=/^[^"$]/,Aa=/^[^"]/,Fa=/^[ \\t\\r\\n]/,$a=vs([["a","z"],["A","Z"],"_"],!1,!1,!1),_a=vs([["a","z"],["A","Z"],["0","9"],"_"],!1,!1,!1),fa=vs([["a","z"],["A","Z"],["0","9"],"_","-"],!1,!1,!1),ka=Ds(".",!1),ba=Ds("$",!1),Pa=Ds("(",!1),Ia=Ds(")",!1),Da=Ds("$$",!1),va=Ds(",",!1),Ca=Ds("{",!1),ya=Ds("}",!1),Na=Ds("[",!1),za=Ds("]",!1),Ta=Ds("=",!1),es=vs([["a","z"],["A","Z"],["0","9"],"_",":","-"],!1,!1,!1),ts=Ds(\'"\',!1),Ka=Ds("\'",!1),ps=vs(["$"],!0,!1,!1),cs=Fs(),xa=vs(["(",")",",","$"],!0,!1,!1),Ra=vs(["(",")",","],!0,!1,!1),Va=vs(["(",")","$"],!0,!1,!1),Ga=vs(["(",")"],!0,!1,!1),as=vs(["\'","$"],!0,!1,!1),rs=vs(["\'"],!0,!1,!1),ss=vs(["]","$"],!0,!1,!1),ms=vs(["]"],!0,!1,!1),Ua=vs([\'"\',"$"],!0,!1,!1),Wa=vs([\'"\'],!0,!1,!1),wa=vs([" ","	","\\r",`\n`],!1,!1,!1);function qa(Ea,Oa){return Ps({type:"pathPart",name:Ea,index:Oa})}function ja(Ea,Oa){return Ps({type:"pathPart",name:Ea,index:Oa})}function Xa(Ea,Oa){return[Ea,...Oa]}function Ya(Ea,Oa){return[Ea,...Oa]}function Ja(Ea){return Ps(Ea)}function os(Ea){return Ps(Ea)}function ns(Ea,Oa){return Ps({type:"macro",path:Ea,attributes:Oa||{}})}function ca(Ea,Oa){return Ps({type:"macro",path:Ea,attributes:Oa||{}})}function Sa(Ea,Oa){return Ps({type:"function",path:Ea,input:Oa})}function Ha(Ea,Oa){return Ps({type:"function",path:Ea,input:Oa})}function Za(Ea,Oa){return[Ea,...Oa]}function fs(Ea,Oa,La){return[Ea,...Oa,La]}function gs(Ea){return Ea.flat()}function ws(Ea,Oa,La){return[Ea,...Oa,La]}function Os(Ea){return Ea.flat()}function Rs(Ea){return Object.fromEntries(Ea.map(Oa=>[Oa.name,Oa]))}function zs(Ea){return Ps({type:"index",value:Ea})}function $s(Ea,Oa){return Ps({type:"attribute",name:Ea,children:Oa})}function js(Ea){return Ps({type:"attribute",name:Ea,children:[]})}function Qs(Ea){return Ps({type:"text",value:Ea})}function Gs(){return Ps({type:"text",value:"("})}function Ws(){return Ps({type:"text",value:")"})}function Us(Ea){return Ps({type:"text",value:Ea})}function Ma(Ea){return Ps({type:"text",value:Ea})}function Es(Ea){return Ps({type:"text",value:Ea})}function Ns(Ea){return Ps({type:"text",value:Ea})}function bs(Ea){return Ps({type:"text",value:Ea})}let da=J.peg$currPos|0,Qa=da;const us=[{line:1,column:1}];let ds=da,Ts=J.peg$maxFailExpected||[],ls=J.peg$silentFails|0,Cs;if(J.startRule){if(!(J.startRule in lr))throw new Error(`Can\'t start parsing from rule "`+J.startRule+\'".\');mr=lr[J.startRule]}function Ms(){return Zs(Qa,da)}function _s(Ea=da){const Oa=F.codePointAt(Ea);return Oa===void 0?"":String.fromCodePoint(Oa)}function Ds(Ea,Oa){return{type:"literal",text:Ea,ignoreCase:Oa}}function vs(Ea,Oa,La,Ba){return{type:"class",parts:Ea,inverted:Oa,ignoreCase:La,unicode:Ba}}function Fs(){return{type:"any"}}function ks(){return{type:"end"}}function Bs(Ea){let Oa=us[Ea],La;if(Oa)return Oa;if(Ea>=us.length)La=us.length-1;else for(La=Ea;!us[--La];);for(Oa=us[La],Oa={line:Oa.line,column:Oa.column};La<Ea;)F.charCodeAt(La)===10?(Oa.line++,Oa.column=1):Oa.column++,La++;return us[Ea]=Oa,Oa}function Zs(Ea,Oa,La){const Ba=Bs(Ea),hs=Bs(Oa);return{source:_t,start:{offset:Ea,line:Ba.line,column:Ba.column},end:{offset:Oa,line:hs.line,column:hs.column}}}function ys(Ea){da<ds||(da>ds&&(ds=da,Ts=[]),Ts.push(Ea))}function rl(Ea,Oa,La){return new D(D.buildMessage(Ea,Oa),Ea,Oa,La)}function Js(){let Ea,Oa;for(Ea=[],Oa=Ls(),Oa===$e&&(Oa=Hs(),Oa===$e&&(Oa=fl()));Oa!==$e;)Ea.push(Oa),Oa=Ls(),Oa===$e&&(Oa=Hs(),Oa===$e&&(Oa=fl()));return Ea}function nl(){let Ea,Oa,La,Ba,hs;if(Ea=da,Oa=da,La=F.charAt(da),Ji.test(La)?da++:(La=$e,ls===0&&ys($a)),La!==$e){for(Ba=[],hs=F.charAt(da),ta.test(hs)?da++:(hs=$e,ls===0&&ys(_a));hs!==$e;)Ba.push(hs),hs=F.charAt(da),ta.test(hs)?da++:(hs=$e,ls===0&&ys(_a));La=[La,Ba],Oa=La}else da=Oa,Oa=$e;return Oa!==$e?Ea=F.substring(Ea,da):Ea=Oa,Ea}function Ks(){let Ea,Oa,La;if(Ea=da,Oa=[],La=F.charAt(da),na.test(La)?da++:(La=$e,ls===0&&ys(fa)),La!==$e)for(;La!==$e;)Oa.push(La),La=F.charAt(da),na.test(La)?da++:(La=$e,ls===0&&ys(fa));else Oa=$e;return Oa!==$e?Ea=F.substring(Ea,da):Ea=Oa,Ea}function As(){let Ea,Oa,La,Ba;if(Ea=da,Oa=nl(),Oa!==$e){for(La=[],Ba=Iu();Ba!==$e;)La.push(Ba),Ba=Iu();Qa=Ea,Ea=qa(Oa,La)}else da=Ea,Ea=$e;return Ea}function Vs(){let Ea,Oa,La,Ba;if(Ea=da,Oa=Ks(),Oa!==$e){for(La=[],Ba=Iu();Ba!==$e;)La.push(Ba),Ba=Iu();Qa=Ea,Ea=ja(Oa,La)}else da=Ea,Ea=$e;return Ea}function bu(){let Ea,Oa,La,Ba,hs,xs;if(Ea=da,Oa=As(),Oa!==$e){for(La=[],Ba=da,F.charCodeAt(da)===46?(hs=Or,da++):(hs=$e,ls===0&&ys(ka)),hs!==$e?(xs=As(),xs!==$e?Ba=xs:(da=Ba,Ba=$e)):(da=Ba,Ba=$e);Ba!==$e;)La.push(Ba),Ba=da,F.charCodeAt(da)===46?(hs=Or,da++):(hs=$e,ls===0&&ys(ka)),hs!==$e?(xs=As(),xs!==$e?Ba=xs:(da=Ba,Ba=$e)):(da=Ba,Ba=$e);Qa=Ea,Ea=Xa(Oa,La)}else da=Ea,Ea=$e;return Ea}function Ys(){let Ea,Oa,La,Ba,hs,xs;if(Ea=da,Oa=Vs(),Oa!==$e){for(La=[],Ba=da,F.charCodeAt(da)===46?(hs=Or,da++):(hs=$e,ls===0&&ys(ka)),hs!==$e?(xs=Vs(),xs!==$e?Ba=xs:(da=Ba,Ba=$e)):(da=Ba,Ba=$e);Ba!==$e;)La.push(Ba),Ba=da,F.charCodeAt(da)===46?(hs=Or,da++):(hs=$e,ls===0&&ys(ka)),hs!==$e?(xs=Vs(),xs!==$e?Ba=xs:(da=Ba,Ba=$e)):(da=Ba,Ba=$e);Qa=Ea,Ea=Ya(Oa,La)}else da=Ea,Ea=$e;return Ea}function Ls(){let Ea,Oa,La,Ba,hs;return Ea=da,F.charCodeAt(da)===36?(Oa=Pr,da++):(Oa=$e,ls===0&&ys(ba)),Oa!==$e?(F.charCodeAt(da)===40?(La=dn,da++):(La=$e,ls===0&&ys(Pa)),La!==$e?(Ba=bl(),Ba!==$e?(F.charCodeAt(da)===41?(hs=gi,da++):(hs=$e,ls===0&&ys(Ia)),hs!==$e?(Qa=Ea,Ea=Ja(Ba)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e),Ea===$e&&(Ea=da,F.charCodeAt(da)===36?(Oa=Pr,da++):(Oa=$e,ls===0&&ys(ba)),Oa!==$e?(La=il(),La!==$e?(Qa=Ea,Ea=os(La)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)),Ea}function il(){let Ea,Oa,La;return Ea=da,Oa=bu(),Oa!==$e?(La=ul(),La===$e&&(La=null),Qa=Ea,Ea=ns(Oa,La)):(da=Ea,Ea=$e),Ea}function bl(){let Ea,Oa,La;return Ea=da,Oa=Ys(),Oa!==$e?(La=ul(),La===$e&&(La=null),Qa=Ea,Ea=ca(Oa,La)):(da=Ea,Ea=$e),Ea}function Hs(){let Ea,Oa,La,Ba,hs,xs;return Ea=da,F.substr(da,2)===qi?(Oa=qi,da+=2):(Oa=$e,ls===0&&ys(Da)),Oa!==$e?(F.charCodeAt(da)===40?(La=dn,da++):(La=$e,ls===0&&ys(Pa)),La!==$e?(Ba=Ys(),Ba!==$e?(F.charCodeAt(da)===41?(hs=gi,da++):(hs=$e,ls===0&&ys(Ia)),hs!==$e?(xs=sl(),xs===$e&&(xs=null),Qa=Ea,Ea=Sa(Ba,xs)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e),Ea===$e&&(Ea=da,F.substr(da,2)===qi?(Oa=qi,da+=2):(Oa=$e,ls===0&&ys(Da)),Oa!==$e?(La=bu(),La!==$e?(Ba=sl(),Ba===$e&&(Ba=null),Qa=Ea,Ea=Ha(La,Ba)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)),Ea}function sl(){let Ea,Oa,La,Ba;return Ea=da,F.charCodeAt(da)===40?(Oa=dn,da++):(Oa=$e,ls===0&&ys(Pa)),Oa!==$e?(qs(),La=vl(),qs(),F.charCodeAt(da)===41?(Ba=gi,da++):(Ba=$e,ls===0&&ys(Ia)),Ba!==$e?Ea=La:(da=Ea,Ea=$e)):(da=Ea,Ea=$e),Ea}function vl(){let Ea,Oa,La,Ba,hs,xs;for(Ea=da,Oa=ol(),La=[],Ba=da,qs(),F.charCodeAt(da)===44?(hs=zi,da++):(hs=$e,ls===0&&ys(va)),hs!==$e?(qs(),xs=ol(),Ba=xs):(da=Ba,Ba=$e);Ba!==$e;)La.push(Ba),Ba=da,qs(),F.charCodeAt(da)===44?(hs=zi,da++):(hs=$e,ls===0&&ys(va)),hs!==$e?(qs(),xs=ol(),Ba=xs):(da=Ba,Ba=$e);return Qa=Ea,Ea=Za(Oa,La),Ea}function ol(){let Ea,Oa,La,Ba,hs,xs;for(Ea=da,Oa=[],La=Ls(),La===$e&&(La=Hs(),La===$e&&(La=pl(),La===$e&&(La=da,Ba=el(),Ba!==$e?(hs=ku(),xs=tl(),xs!==$e?(Qa=La,La=fs(Ba,hs,xs)):(da=La,La=$e)):(da=La,La=$e))));La!==$e;)Oa.push(La),La=Ls(),La===$e&&(La=Hs(),La===$e&&(La=pl(),La===$e&&(La=da,Ba=el(),Ba!==$e?(hs=ku(),xs=tl(),xs!==$e?(Qa=La,La=fs(Ba,hs,xs)):(da=La,La=$e)):(da=La,La=$e))));return Qa=Ea,Oa=gs(Oa),Ea=Oa,Ea}function ku(){let Ea,Oa,La,Ba,hs,xs;for(Ea=da,Oa=[],La=Ls(),La===$e&&(La=Hs(),La===$e&&(La=dl(),La===$e&&(La=da,Ba=el(),Ba!==$e?(hs=ku(),xs=tl(),xs!==$e?(Qa=La,La=ws(Ba,hs,xs)):(da=La,La=$e)):(da=La,La=$e))));La!==$e;)Oa.push(La),La=Ls(),La===$e&&(La=Hs(),La===$e&&(La=dl(),La===$e&&(La=da,Ba=el(),Ba!==$e?(hs=ku(),xs=tl(),xs!==$e?(Qa=La,La=ws(Ba,hs,xs)):(da=La,La=$e)):(da=La,La=$e))));return Qa=Ea,Oa=Os(Oa),Ea=Oa,Ea}function ul(){let Ea,Oa,La,Ba,hs;if(Ea=da,F.charCodeAt(da)===123?(Oa=Hi,da++):(Oa=$e,ls===0&&ys(Ca)),Oa!==$e){for(qs(),La=[],Ba=da,hs=ll(),hs!==$e?(qs(),Ba=hs):(da=Ba,Ba=$e);Ba!==$e;)La.push(Ba),Ba=da,hs=ll(),hs!==$e?(qs(),Ba=hs):(da=Ba,Ba=$e);F.charCodeAt(da)===125?(Ba=Qi,da++):(Ba=$e,ls===0&&ys(ya)),Ba!==$e?(Qa=Ea,Ea=Rs(La)):(da=Ea,Ea=$e)}else da=Ea,Ea=$e;return Ea}function Iu(){let Ea,Oa,La,Ba,hs;if(Ea=da,F.charCodeAt(da)===91?(Oa=Gi,da++):(Oa=$e,ls===0&&ys(Na)),Oa!==$e){for(qs(),La=[],Ba=da,hs=Hs(),hs===$e&&(hs=Ls(),hs===$e&&(hs=ml())),hs!==$e?(qs(),Ba=hs):(da=Ba,Ba=$e);Ba!==$e;)La.push(Ba),Ba=da,hs=Hs(),hs===$e&&(hs=Ls(),hs===$e&&(hs=ml())),hs!==$e?(qs(),Ba=hs):(da=Ba,Ba=$e);F.charCodeAt(da)===93?(Ba=Zi,da++):(Ba=$e,ls===0&&ys(za)),Ba!==$e?(Qa=Ea,Ea=zs(La)):(da=Ea,Ea=$e)}else da=Ea,Ea=$e;return Ea}function ll(){let Ea,Oa,La,Ba;return Ea=da,Oa=cl(),Oa!==$e?(qs(),F.charCodeAt(da)===61?(La=Xi,da++):(La=$e,ls===0&&ys(Ta)),La!==$e?(qs(),Ba=Dl(),Ba!==$e?(Qa=Ea,Ea=$s(Oa,Ba)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e)):(da=Ea,Ea=$e),Ea===$e&&(Ea=da,Oa=cl(),Oa!==$e&&(Qa=Ea,Oa=js(Oa)),Ea=Oa),Ea}function cl(){let Ea,Oa,La;if(Ea=da,Oa=[],La=F.charAt(da),ra.test(La)?da++:(La=$e,ls===0&&ys(es)),La!==$e)for(;La!==$e;)Oa.push(La),La=F.charAt(da),ra.test(La)?da++:(La=$e,ls===0&&ys(es));else Oa=$e;return Oa!==$e?Ea=F.substring(Ea,da):Ea=Oa,Ea}function Dl(){let Ea,Oa,La,Ba;if(Ea=da,F.charCodeAt(da)===34?(Oa=Ki,da++):(Oa=$e,ls===0&&ys(ts)),Oa!==$e){for(La=[],Ba=Ls(),Ba===$e&&(Ba=Hs(),Ba===$e&&(Ba=gl()));Ba!==$e;)La.push(Ba),Ba=Ls(),Ba===$e&&(Ba=Hs(),Ba===$e&&(Ba=gl()));F.charCodeAt(da)===34?(Ba=Ki,da++):(Ba=$e,ls===0&&ys(ts)),Ba!==$e?Ea=La:(da=Ea,Ea=$e)}else da=Ea,Ea=$e;if(Ea===$e)if(Ea=da,F.charCodeAt(da)===39?(Oa=ea,da++):(Oa=$e,ls===0&&ys(Ka)),Oa!==$e){for(La=[],Ba=Ls(),Ba===$e&&(Ba=Hs(),Ba===$e&&(Ba=hl()));Ba!==$e;)La.push(Ba),Ba=Ls(),Ba===$e&&(Ba=Hs(),Ba===$e&&(Ba=hl()));F.charCodeAt(da)===39?(Ba=ea,da++):(Ba=$e,ls===0&&ys(Ka)),Ba!==$e?Ea=La:(da=Ea,Ea=$e)}else da=Ea,Ea=$e;return Ea}function fl(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),ia.test(Ba)?da++:(Ba=$e,ls===0&&ys(ps)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),ia.test(Ba)?da++:(Ba=$e,ls===0&&ys(ps));else La=$e;return La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa===$e&&(F.length>da?(Oa=F.charAt(da),da++):(Oa=$e,ls===0&&ys(cs))),Oa!==$e&&(Qa=Ea,Oa=Qs(Oa)),Ea=Oa,Ea}function el(){let Ea,Oa;return Ea=da,F.charCodeAt(da)===40?(Oa=dn,da++):(Oa=$e,ls===0&&ys(Pa)),Oa!==$e&&(Qa=Ea,Oa=Gs()),Ea=Oa,Ea}function tl(){let Ea,Oa;return Ea=da,F.charCodeAt(da)===41?(Oa=gi,da++):(Oa=$e,ls===0&&ys(Ia)),Oa!==$e&&(Qa=Ea,Oa=Ws()),Ea=Oa,Ea}function pl(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),oa.test(Ba)?da++:(Ba=$e,ls===0&&ys(xa)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),oa.test(Ba)?da++:(Ba=$e,ls===0&&ys(xa));else La=$e;return La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa===$e&&(Oa=F.charAt(da),ua.test(Oa)?da++:(Oa=$e,ls===0&&ys(Ra))),Oa!==$e&&(Qa=Ea,Oa=Us(Oa)),Ea=Oa,Ea}function dl(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),sa.test(Ba)?da++:(Ba=$e,ls===0&&ys(Va)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),sa.test(Ba)?da++:(Ba=$e,ls===0&&ys(Va));else La=$e;return La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa===$e&&(Oa=F.charAt(da),aa.test(Oa)?da++:(Oa=$e,ls===0&&ys(Ga))),Oa!==$e&&(Qa=Ea,Oa=Ma(Oa)),Ea=Oa,Ea}function hl(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),pa.test(Ba)?da++:(Ba=$e,ls===0&&ys(as)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),pa.test(Ba)?da++:(Ba=$e,ls===0&&ys(as));else La=$e;return La===$e&&(La=F.charAt(da),ma.test(La)?da++:(La=$e,ls===0&&ys(rs))),La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa!==$e&&(Qa=Ea,Oa=Es(Oa)),Ea=Oa,Ea}function ml(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),la.test(Ba)?da++:(Ba=$e,ls===0&&ys(ss)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),la.test(Ba)?da++:(Ba=$e,ls===0&&ys(ss));else La=$e;return La===$e&&(La=F.charAt(da),ha.test(La)?da++:(La=$e,ls===0&&ys(ms))),La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa!==$e&&(Qa=Ea,Oa=Ns(Oa)),Ea=Oa,Ea}function gl(){let Ea,Oa,La,Ba;if(Ea=da,Oa=da,La=[],Ba=F.charAt(da),ga.test(Ba)?da++:(Ba=$e,ls===0&&ys(Ua)),Ba!==$e)for(;Ba!==$e;)La.push(Ba),Ba=F.charAt(da),ga.test(Ba)?da++:(Ba=$e,ls===0&&ys(Ua));else La=$e;return La!==$e?Oa=F.substring(Oa,da):Oa=La,Oa===$e&&(Oa=F.charAt(da),Aa.test(Oa)?da++:(Oa=$e,ls===0&&ys(Wa))),Oa!==$e&&(Qa=Ea,Oa=bs(Oa)),Ea=Oa,Ea}function qs(){let Ea,Oa,La;if(Ea=da,Oa=[],La=F.charAt(da),Fa.test(La)?da++:(La=$e,ls===0&&ys(wa)),La!==$e)for(;La!==$e;)Oa.push(La),La=F.charAt(da),Fa.test(La)?da++:(La=$e,ls===0&&ys(wa));else Oa=$e;return Oa!==$e?Ea=F.substring(Ea,da):Ea=Oa,Ea}function Ps(Ea){const{start:Oa,end:La}=Ms();return{...Ea,position:{start:Oa,end:La}}}Cs=mr();const al=Cs!==$e&&da===F.length;function yl(){throw Cs!==$e&&da<F.length&&ys(ks()),rl(Ts,ds<F.length?_s(ds):null,ds<F.length?Zs(ds,ds+1):Zs(ds,ds))}if(J.peg$library)return{peg$result:Cs,peg$currPos:da,peg$FAILED:$e,peg$maxFailExpected:Ts,peg$maxFailPos:ds,peg$success:al,peg$throw:al?void 0:yl};if(al)return Cs;yl()}return{StartRules:["top"],SyntaxError:D,parse:E}})(),MacroParser=_MacroParser;function parseMacros(D){return MacroParser.parse(D)}function gobbleFunctionArguments(D){if(!D.some(J=>J.type==="function"&&J.input==null))return D;D=D.map(J=>J.type==="text"?splitTextAtSpecialChars(J):J).flat();const E=[];let F=null;for(let J=0;J<D.length;J++){const $e=D[J];if($e.type==="function"&&$e.input==null){F=$e,E.push($e);continue}if(!F){E.push($e);continue}if(!($e.type==="text"&&$e.value==="(")||!hasClosingParen(D.slice(J))){F=null,E.push($e);continue}let _t=[];F.input=[];let lr=1;for(J++;F;){const mr=D[J];if(!mr)throw new Error("Failed to find next node when search for function arguments");if(mr.type!=="text"){_t.push(mr),J++;continue}if(mr.value==="("&&lr++,mr.value===","&&lr<=1){F.input.push(trimWhitespace(_t)),_t=[],J++;continue}if(mr.value===")"&&(lr--,lr===0)){F.input.push(trimWhitespace(gobbleFunctionArguments(_t))),_t=[],mr.position&&(F.position.end={...mr.position.end}),F=null,J++;continue}J++,_t.push(mr)}J--}return E}function splitTextAtSpecialChars(D){const E=D.value.search(/[\\(\\),]/);if(E<0)return[D];const[F,J,$e]=splitTextNodeAt(D,E);return[F,J,...splitTextAtSpecialChars($e)].filter(lr=>lr.value!=="")}const DEFAULT_POSITION={start:{offset:0,line:1,column:1},end:{offset:0,line:1,column:1}};function splitTextNodeAt(D,E){const{value:F,position:J=DEFAULT_POSITION}=D;if(E<0||E>F.length)throw new Error(`Cannot split a string at a value larger than its length (got pos:${E} for text node "${F}")`);const{rowMap:$e,columnMap:_t}=createOffsetToPositionMap$1(F),lr=F.slice(0,E),mr={type:"text",value:lr,position:{start:{...J.start},end:{offset:(J.start.offset||0)+lr.length,line:$e[E]+J.start.line,column:_t[E]+J.start.column}}},Pr={type:"text",value:F.slice(E,E+1),position:{start:{offset:(J.start.offset||0)+E,line:$e[E]+J.start.line,column:_t[E]+J.start.column},end:{offset:(J.start.offset||0)+E+1,line:$e[E+1]+J.start.line,column:_t[E+1]+J.start.column}}},gi={type:"text",value:F.slice(E+1),position:{end:{...J.end},start:{offset:(J.start.offset||0)+E+1,line:$e[E+1]+J.start.line,column:_t[E+1]+J.start.column}}};return[mr,Pr,gi]}function hasClosingParen(D){return D.some(E=>E.type==="text"&&E.value.includes(")"))}function trimWhitespace(D){const E=D[0],F=D[D.length-1];return!E||!F||(E.type==="text"&&(E.value=E.value.trimStart(),E.value===""&&D.shift()),F.type==="text"&&(F.value=F.value.trimEnd(),F.value===""&&D.pop())),D}function stringToLezer(D){return parser.parse(D).topNode}function lezerToDast(D,E){if(typeof D=="string"){const F=parser.parse(D);return E=D,_lezerToDast(F.topNode,E)}if(E==null)throw new Error("If you provide a SyntaxNode, you must also provide the source string");return _lezerToDast(D,E)}function _lezerToDast(D,E){const F=createOffsetToPositionMap$1(E);return{type:"root",children:gobbleFunctionArguments(J(D)),position:lezerNodeToPosition(D,F),sources:[E]};function J($e){if(!$e)throw new Error(`Expecting node but got ${JSON.stringify($e)}`);const _t=$e.type.name;switch(_t){case"Document":return getLezerChildren($e).flatMap(J);case"Element":{const mr=$e.getChild("OpenTag")||$e.getChild("SelfClosingTag");if(!mr)return console.warn(`Could not find open tag for element ${extractContent($e,E)}`),[];let Or=[];const Pr=findFirstErrorInChild(mr);if(Pr&&!isInsideAttribute(Pr,mr)){const Xi=createErrorNode(Pr,E,F);Or.push(Xi)}let dn=$e.getChild("⚠")||$e.getChild(MissingCloseTag);if(mr.type.name==="OpenTag"&&!$e.getChild("CloseTag")&&!Pr&&dn){const Xi=createErrorNode(dn,E,F);Or.push(Xi)}const gi=mr.getChild("TagName"),qi=gi?extractContent(gi,E):"",zi=[];for(const Xi of mr.getChildren("Attribute")){const Ki=Xi.getChild("AttributeName"),ea=Xi.getChild("AttributeValue");if(!Ki){const ta=findFirstErrorInChild(Xi);ta&&Or.push(createErrorNode(ta,E,F));continue}let Ji=ea?[...reprocessTextForMacros({type:"text",value:attributeValueText(ea,E),position:lezerNodeToPosition(ea,F,!0)},F)]:[];zi.push({attrTag:Xi,dastAttr:{type:"attribute",name:extractContent(Ki,E),children:Ji,position:lezerNodeToPosition(Xi,F)}})}const Hi=findBareAttributeValuePairs(zi.map(Xi=>Xi.dastAttr),E),Qi=new Set(Hi.map(Xi=>Xi.assignAttr)),Gi=new Map(Hi.map(Xi=>[Xi.valueAttr,Xi])),Zi=[];for(const{attrTag:Xi,dastAttr:Ki}of zi){const ea=Gi.get(Ki);if(ea){Or.push({type:"error",message:unquotedAttributeValueMessage(ea.assignAttr.name,ea.valueAttr.name),position:ea.valueAttr.position});continue}if(Qi.has(Ki))continue;const Ji=findFirstErrorInChild(Xi);if(Ji){const ta=createErrorNode(Ji,E,F);Or.push(ta)}Zi.push(Ki)}return Or.push(...getLezerChildren($e).flatMap(Xi=>J(Xi))),Or=gobbleFunctionArguments(Or),[{type:"element",name:qi,attributes:Object.fromEntries(Zi.map(Xi=>[Xi.name,Xi])),children:Or,position:lezerNodeToPosition($e,F)}]}case"Text":{const mr={type:"text",value:textNodeToText($e,E),position:lezerNodeToPosition($e,F)};return reprocessTextForMacros(mr,F)}case"Ampersand":return[{type:"text",value:"&",position:lezerNodeToPosition($e,F)}];case"CharacterReference":case"EntityReference":return[{type:"text",value:entityToString($e,E),position:lezerNodeToPosition($e,F)}];case"ProcessingInst":{const mr=extractContent($e,E);let Or=mr.slice(2,mr.length-2);const dn=Or.match(/^[\\w-]*/)?.[0]||"";return dn&&(Or=Or.slice(dn.length).trim()),[{type:"instruction",name:dn,value:Or,position:lezerNodeToPosition($e,F)}]}case"Comment":{const mr=extractContent($e,E);return[{type:"comment",value:mr.slice(4,mr.length-3),position:lezerNodeToPosition($e,F)}]}case"Cdata":{const mr=extractContent($e,E);return[{type:"cdata",value:mr.slice(9,mr.length-3),position:lezerNodeToPosition($e,F)}]}case"DoctypeDecl":{const mr=extractContent($e,E);let Or=mr.slice(10,mr.length-1);return[{type:"doctype",...extractDoctypeInfo(Or),position:lezerNodeToPosition($e,F)}]}case"Attribute":case"AttributeName":case"AttributeValue":case"EndTag":case"Is":case"OpenTag":case"SelfCloseEndTag":case"SelfClosingTag":case"TagName":case"StartTag":case"StartCloseTag":return[];case"CloseTag":{const mr=findFirstErrorInChild($e);return mr?[createErrorNode(mr,E,F)]:[]}case"MismatchedCloseTag":{const mr=findFirstErrorInChild($e);if(mr)return[createErrorNode(mr,E,F)];const Or=$e.parent,Pr=Or?.getChild(OpenTag),dn=Or?.getChild(CloseTag);if(!Or||!Pr)return[{type:"error",message:`Invalid DoenetML: Found closing tag \\`${extractContent($e,E)}\\`, but no corresponding opening tag`,position:lezerNodeToPosition($e,F)}];if(dn)return[{type:"error",message:`Invalid DoenetML: Found closing tag \\`${extractContent($e,E)}\\`, but no corresponding opening tag`,position:lezerNodeToPosition($e,F)}];const gi=Pr.getChild(TagName);return[{type:"error",message:`Invalid DoenetML: Mismatched closing tag. Expected \\`</${gi?extractContent(gi,E):""}>\\`. Found \\`${extractContent($e,E)}\\``,position:lezerNodeToPosition($e,F)}]}case"MissingCloseTag":case"⚠":return[];default:console.log(`Encountered Lezer node of unknown type ${_t}`)}return[]}}function isInsideAttribute(D,E){let F=D.parent;for(;F&&F!==E;){if(F.type.name==="Attribute"&&F.parent===E)return!0;F=F.parent}return!1}function reprocessTextForMacros(D,E){if(!D.value.includes("$"))return[D];const F=parseMacros(D.value);return findNodesWithPositionInfo(F).forEach($e=>{updateNodePositionData($e,D,E)}),F}const CONTINUE$1=Symbol("continue"),SKIP$1=Symbol("skip"),EXIT$1=Symbol("exit"),DEFAULT_CONTEXT={};function visit$1(D,E,F){const{startingContext:J=DEFAULT_CONTEXT,test:$e=()=>!0,includeArrays:_t=!1}={};let lr,mr;typeof E=="function"?lr=E:E&&typeof E=="object"&&(lr=E.enter,mr=E.leave),Or(D,{key:void 0,index:void 0,parents:[],containingArray:void 0,context:{...J}});function Or(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi}){const Qi=_t?$e(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi}):!Array.isArray(Pr)&&$e(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi}),Gi=lr&&Qi?toResult$1(lr(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi})):[CONTINUE$1];if(Gi[0]===EXIT$1)return Gi;if(Gi[0]===SKIP$1)return mr&&Qi?toResult$1(mr(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi})):Gi;if(Array.isArray(Pr))for(let Zi=0;Zi>-1&&Zi<Pr.length;Zi++){const Xi=Pr[Zi],Ki=Or(Xi,{key:dn,index:Zi,parents:qi,context:zi,containingArray:Pr});if(Ki[0]===EXIT$1)return Ki;typeof Ki[1]=="number"&&(Zi=Ki[1]-1)}else if(Pr.type==="function"&&Pr.input)for(let Zi=0;Zi>-1&&Zi<Pr.input.length;Zi++){const Xi=Pr.input[Zi],Ki=Or(Xi,{key:dn,index:Zi,parents:qi,context:zi,containingArray:void 0});if(Ki[0]===EXIT$1)return Ki;typeof Ki[1]=="number"&&(Zi=Ki[1]-1)}else{const Zi="children";if(Zi in Pr){const Xi=Pr.type==="root"?qi:[Pr,...qi],Ki=Or(Pr.children,{key:Zi,index:void 0,parents:Xi,context:zi,containingArray:void 0});if(Ki[0]===EXIT$1)return Ki}}return mr&&Qi?toResult$1(mr(Pr,{key:dn,index:gi,parents:qi,context:zi,containingArray:Hi})):Gi}}function toResult$1(D){return D==null?[CONTINUE$1]:Array.isArray(D)?D:typeof D=="number"?[CONTINUE$1,D]:[D]}function replaceNode(D,E){visit$1(D,{leave:(F,J)=>{let $e=E(F,J);if(!(typeof $e>"u"||$e===F)){if(!J.containingArray||J.index==null)throw new Error("Trying to replace node, but cannot find containing array");return $e===null||Array.isArray($e)&&$e.length===0?(J.containingArray.splice(J.index,1),J.index):(Array.isArray($e)||($e=[$e]),J.containingArray.splice(J.index,1,...$e),J.index+$e.length)}}})}function bail(D){if(D)throw D}function getDefaultExportFromCjs$1(D){return D&&D.__esModule&&Object.prototype.hasOwnProperty.call(D,"default")?D.default:D}var extend$1$1,hasRequiredExtend;function requireExtend(){if(hasRequiredExtend)return extend$1$1;hasRequiredExtend=1;var D=Object.prototype.hasOwnProperty,E=Object.prototype.toString,F=Object.defineProperty,J=Object.getOwnPropertyDescriptor,$e=function(Pr){return typeof Array.isArray=="function"?Array.isArray(Pr):E.call(Pr)==="[object Array]"},_t=function(Pr){if(!Pr||E.call(Pr)!=="[object Object]")return!1;var dn=D.call(Pr,"constructor"),gi=Pr.constructor&&Pr.constructor.prototype&&D.call(Pr.constructor.prototype,"isPrototypeOf");if(Pr.constructor&&!dn&&!gi)return!1;var qi;for(qi in Pr);return typeof qi>"u"||D.call(Pr,qi)},lr=function(Pr,dn){F&&dn.name==="__proto__"?F(Pr,dn.name,{enumerable:!0,configurable:!0,value:dn.newValue,writable:!0}):Pr[dn.name]=dn.newValue},mr=function(Pr,dn){if(dn==="__proto__")if(D.call(Pr,dn)){if(J)return J(Pr,dn).value}else return;return Pr[dn]};return extend$1$1=function Or(){var Pr,dn,gi,qi,zi,Hi,Qi=arguments[0],Gi=1,Zi=arguments.length,Xi=!1;for(typeof Qi=="boolean"&&(Xi=Qi,Qi=arguments[1]||{},Gi=2),(Qi==null||typeof Qi!="object"&&typeof Qi!="function")&&(Qi={});Gi<Zi;++Gi)if(Pr=arguments[Gi],Pr!=null)for(dn in Pr)gi=mr(Qi,dn),qi=mr(Pr,dn),Qi!==qi&&(Xi&&qi&&(_t(qi)||(zi=$e(qi)))?(zi?(zi=!1,Hi=gi&&$e(gi)?gi:[]):Hi=gi&&_t(gi)?gi:{},lr(Qi,{name:dn,newValue:Or(Xi,Hi,qi)})):typeof qi<"u"&&lr(Qi,{name:dn,newValue:qi}));return Qi},extend$1$1}var extendExports=requireExtend();const extend$2=getDefaultExportFromCjs$1(extendExports);function isPlainObject$1(D){if(typeof D!="object"||D===null)return!1;const E=Object.getPrototypeOf(D);return(E===null||E===Object.prototype||Object.getPrototypeOf(E)===null)&&!(Symbol.toStringTag in D)&&!(Symbol.iterator in D)}function trough(){const D=[],E={run:F,use:J};return E;function F(...$e){let _t=-1;const lr=$e.pop();if(typeof lr!="function")throw new TypeError("Expected function as last argument, not "+lr);mr(null,...$e);function mr(Or,...Pr){const dn=D[++_t];let gi=-1;if(Or){lr(Or);return}for(;++gi<$e.length;)(Pr[gi]===null||Pr[gi]===void 0)&&(Pr[gi]=$e[gi]);$e=Pr,dn?wrap$2(dn,mr)(...Pr):lr(null,...Pr)}}function J($e){if(typeof $e!="function")throw new TypeError("Expected `middelware` to be a function, not "+$e);return D.push($e),E}}function wrap$2(D,E){let F;return J;function J(...lr){const mr=D.length>lr.length;let Or;mr&&lr.push($e);try{Or=D.apply(this,lr)}catch(Pr){const dn=Pr;if(mr&&F)throw dn;return $e(dn)}mr||(Or&&Or.then&&typeof Or.then=="function"?Or.then(_t,$e):Or instanceof Error?$e(Or):_t(Or))}function $e(lr,...mr){F||(F=!0,E(lr,...mr))}function _t(lr){$e(null,lr)}}function stringifyPosition(D){return!D||typeof D!="object"?"":"position"in D||"type"in D?position(D.position):"start"in D||"end"in D?position(D):"line"in D||"column"in D?point(D):""}function point(D){return index(D&&D.line)+":"+index(D&&D.column)}function position(D){return point(D&&D.start)+"-"+point(D&&D.end)}function index(D){return D&&typeof D=="number"?D:1}class VFileMessage extends Error{constructor(E,F,J){super(),typeof F=="string"&&(J=F,F=void 0);let $e="",_t={},lr=!1;if(F&&("line"in F&&"column"in F?_t={place:F}:"start"in F&&"end"in F?_t={place:F}:"type"in F?_t={ancestors:[F],place:F.position}:_t={...F}),typeof E=="string"?$e=E:!_t.cause&&E&&(lr=!0,$e=E.message,_t.cause=E),!_t.ruleId&&!_t.source&&typeof J=="string"){const Or=J.indexOf(":");Or===-1?_t.ruleId=J:(_t.source=J.slice(0,Or),_t.ruleId=J.slice(Or+1))}if(!_t.place&&_t.ancestors&&_t.ancestors){const Or=_t.ancestors[_t.ancestors.length-1];Or&&(_t.place=Or.position)}const mr=_t.place&&"start"in _t.place?_t.place.start:_t.place;this.ancestors=_t.ancestors||void 0,this.cause=_t.cause||void 0,this.column=mr?mr.column:void 0,this.fatal=void 0,this.file="",this.message=$e,this.line=mr?mr.line:void 0,this.name=stringifyPosition(_t.place)||"1:1",this.place=_t.place||void 0,this.reason=this.message,this.ruleId=_t.ruleId||void 0,this.source=_t.source||void 0,this.stack=lr&&_t.cause&&typeof _t.cause.stack=="string"?_t.cause.stack:"",this.actual=void 0,this.expected=void 0,this.note=void 0,this.url=void 0}}VFileMessage.prototype.file="",VFileMessage.prototype.name="",VFileMessage.prototype.reason="",VFileMessage.prototype.message="",VFileMessage.prototype.stack="",VFileMessage.prototype.column=void 0,VFileMessage.prototype.line=void 0,VFileMessage.prototype.ancestors=void 0,VFileMessage.prototype.cause=void 0,VFileMessage.prototype.fatal=void 0,VFileMessage.prototype.place=void 0,VFileMessage.prototype.ruleId=void 0,VFileMessage.prototype.source=void 0;const minpath={basename,dirname,extname,join:join$3,sep:"/"};function basename(D,E){if(E!==void 0&&typeof E!="string")throw new TypeError(\'"ext" argument must be a string\');assertPath$1(D);let F=0,J=-1,$e=D.length,_t;if(E===void 0||E.length===0||E.length>D.length){for(;$e--;)if(D.codePointAt($e)===47){if(_t){F=$e+1;break}}else J<0&&(_t=!0,J=$e+1);return J<0?"":D.slice(F,J)}if(E===D)return"";let lr=-1,mr=E.length-1;for(;$e--;)if(D.codePointAt($e)===47){if(_t){F=$e+1;break}}else lr<0&&(_t=!0,lr=$e+1),mr>-1&&(D.codePointAt($e)===E.codePointAt(mr--)?mr<0&&(J=$e):(mr=-1,J=lr));return F===J?J=lr:J<0&&(J=D.length),D.slice(F,J)}function dirname(D){if(assertPath$1(D),D.length===0)return".";let E=-1,F=D.length,J;for(;--F;)if(D.codePointAt(F)===47){if(J){E=F;break}}else J||(J=!0);return E<0?D.codePointAt(0)===47?"/":".":E===1&&D.codePointAt(0)===47?"//":D.slice(0,E)}function extname(D){assertPath$1(D);let E=D.length,F=-1,J=0,$e=-1,_t=0,lr;for(;E--;){const mr=D.codePointAt(E);if(mr===47){if(lr){J=E+1;break}continue}F<0&&(lr=!0,F=E+1),mr===46?$e<0?$e=E:_t!==1&&(_t=1):$e>-1&&(_t=-1)}return $e<0||F<0||_t===0||_t===1&&$e===F-1&&$e===J+1?"":D.slice($e,F)}function join$3(...D){let E=-1,F;for(;++E<D.length;)assertPath$1(D[E]),D[E]&&(F=F===void 0?D[E]:F+"/"+D[E]);return F===void 0?".":normalize$1(F)}function normalize$1(D){assertPath$1(D);const E=D.codePointAt(0)===47;let F=normalizeString(D,!E);return F.length===0&&!E&&(F="."),F.length>0&&D.codePointAt(D.length-1)===47&&(F+="/"),E?"/"+F:F}function normalizeString(D,E){let F="",J=0,$e=-1,_t=0,lr=-1,mr,Or;for(;++lr<=D.length;){if(lr<D.length)mr=D.codePointAt(lr);else{if(mr===47)break;mr=47}if(mr===47){if(!($e===lr-1||_t===1))if($e!==lr-1&&_t===2){if(F.length<2||J!==2||F.codePointAt(F.length-1)!==46||F.codePointAt(F.length-2)!==46){if(F.length>2){if(Or=F.lastIndexOf("/"),Or!==F.length-1){Or<0?(F="",J=0):(F=F.slice(0,Or),J=F.length-1-F.lastIndexOf("/")),$e=lr,_t=0;continue}}else if(F.length>0){F="",J=0,$e=lr,_t=0;continue}}E&&(F=F.length>0?F+"/..":"..",J=2)}else F.length>0?F+="/"+D.slice($e+1,lr):F=D.slice($e+1,lr),J=lr-$e-1;$e=lr,_t=0}else mr===46&&_t>-1?_t++:_t=-1}return F}function assertPath$1(D){if(typeof D!="string")throw new TypeError("Path must be a string. Received "+JSON.stringify(D))}const minproc={cwd};function cwd(){return"/"}function isUrl(D){return!!(D!==null&&typeof D=="object"&&"href"in D&&D.href&&"protocol"in D&&D.protocol&&D.auth===void 0)}function urlToPath(D){if(typeof D=="string")D=new URL(D);else if(!isUrl(D)){const E=new TypeError(\'The "path" argument must be of type string or an instance of URL. Received `\'+D+"`");throw E.code="ERR_INVALID_ARG_TYPE",E}if(D.protocol!=="file:"){const E=new TypeError("The URL must be of scheme file");throw E.code="ERR_INVALID_URL_SCHEME",E}return getPathFromURLPosix(D)}function getPathFromURLPosix(D){if(D.hostname!==""){const J=new TypeError(\'File URL host must be "localhost" or empty on darwin\');throw J.code="ERR_INVALID_FILE_URL_HOST",J}const E=D.pathname;let F=-1;for(;++F<E.length;)if(E.codePointAt(F)===37&&E.codePointAt(F+1)===50){const J=E.codePointAt(F+2);if(J===70||J===102){const $e=new TypeError("File URL path must not include encoded / characters");throw $e.code="ERR_INVALID_FILE_URL_PATH",$e}}return decodeURIComponent(E)}const order=["history","path","basename","stem","extname","dirname"];class VFile{constructor(E){let F;E?isUrl(E)?F={path:E}:typeof E=="string"||isUint8Array$1(E)?F={value:E}:F=E:F={},this.cwd="cwd"in F?"":minproc.cwd(),this.data={},this.history=[],this.messages=[],this.value,this.map,this.result,this.stored;let J=-1;for(;++J<order.length;){const _t=order[J];_t in F&&F[_t]!==void 0&&F[_t]!==null&&(this[_t]=_t==="history"?[...F[_t]]:F[_t])}let $e;for($e in F)order.includes($e)||(this[$e]=F[$e])}get basename(){return typeof this.path=="string"?minpath.basename(this.path):void 0}set basename(E){assertNonEmpty(E,"basename"),assertPart(E,"basename"),this.path=minpath.join(this.dirname||"",E)}get dirname(){return typeof this.path=="string"?minpath.dirname(this.path):void 0}set dirname(E){assertPath(this.basename,"dirname"),this.path=minpath.join(E||"",this.basename)}get extname(){return typeof this.path=="string"?minpath.extname(this.path):void 0}set extname(E){if(assertPart(E,"extname"),assertPath(this.dirname,"extname"),E){if(E.codePointAt(0)!==46)throw new Error("`extname` must start with `.`");if(E.includes(".",1))throw new Error("`extname` cannot contain multiple dots")}this.path=minpath.join(this.dirname,this.stem+(E||""))}get path(){return this.history[this.history.length-1]}set path(E){isUrl(E)&&(E=urlToPath(E)),assertNonEmpty(E,"path"),this.path!==E&&this.history.push(E)}get stem(){return typeof this.path=="string"?minpath.basename(this.path,this.extname):void 0}set stem(E){assertNonEmpty(E,"stem"),assertPart(E,"stem"),this.path=minpath.join(this.dirname||"",E+(this.extname||""))}fail(E,F,J){const $e=this.message(E,F,J);throw $e.fatal=!0,$e}info(E,F,J){const $e=this.message(E,F,J);return $e.fatal=void 0,$e}message(E,F,J){const $e=new VFileMessage(E,F,J);return this.path&&($e.name=this.path+":"+$e.name,$e.file=this.path),$e.fatal=!1,this.messages.push($e),$e}toString(E){return this.value===void 0?"":typeof this.value=="string"?this.value:new TextDecoder(E||void 0).decode(this.value)}}function assertPart(D,E){if(D&&D.includes(minpath.sep))throw new Error("`"+E+"` cannot be a path: did not expect `"+minpath.sep+"`")}function assertNonEmpty(D,E){if(!D)throw new Error("`"+E+"` cannot be empty")}function assertPath(D,E){if(!D)throw new Error("Setting `"+E+"` requires `path` to be set too")}function isUint8Array$1(D){return!!(D&&typeof D=="object"&&"byteLength"in D&&"byteOffset"in D)}const CallableInstance=(function(D){const J=this.constructor.prototype,$e=J[D],_t=function(){return $e.apply(_t,arguments)};return Object.setPrototypeOf(_t,J),_t}),own$3={}.hasOwnProperty;class Processor extends CallableInstance{constructor(){super("copy"),this.Compiler=void 0,this.Parser=void 0,this.attachers=[],this.compiler=void 0,this.freezeIndex=-1,this.frozen=void 0,this.namespace={},this.parser=void 0,this.transformers=trough()}copy(){const E=new Processor;let F=-1;for(;++F<this.attachers.length;){const J=this.attachers[F];E.use(...J)}return E.data(extend$2(!0,{},this.namespace)),E}data(E,F){return typeof E=="string"?arguments.length===2?(assertUnfrozen("data",this.frozen),this.namespace[E]=F,this):own$3.call(this.namespace,E)&&this.namespace[E]||void 0:E?(assertUnfrozen("data",this.frozen),this.namespace=E,this):this.namespace}freeze(){if(this.frozen)return this;const E=this;for(;++this.freezeIndex<this.attachers.length;){const[F,...J]=this.attachers[this.freezeIndex];if(J[0]===!1)continue;J[0]===!0&&(J[0]=void 0);const $e=F.call(E,...J);typeof $e=="function"&&this.transformers.use($e)}return this.frozen=!0,this.freezeIndex=Number.POSITIVE_INFINITY,this}parse(E){this.freeze();const F=vfile(E),J=this.parser||this.Parser;return assertParser("parse",J),J(String(F),F)}process(E,F){const J=this;return this.freeze(),assertParser("process",this.parser||this.Parser),assertCompiler("process",this.compiler||this.Compiler),F?$e(void 0,F):new Promise($e);function $e(_t,lr){const mr=vfile(E),Or=J.parse(mr);J.run(Or,mr,function(dn,gi,qi){if(dn||!gi||!qi)return Pr(dn);const zi=gi,Hi=J.stringify(zi,qi);looksLikeAValue(Hi)?qi.value=Hi:qi.result=Hi,Pr(dn,qi)});function Pr(dn,gi){dn||!gi?lr(dn):_t?_t(gi):F(void 0,gi)}}}processSync(E){let F=!1,J;return this.freeze(),assertParser("processSync",this.parser||this.Parser),assertCompiler("processSync",this.compiler||this.Compiler),this.process(E,$e),assertDone("processSync","process",F),J;function $e(_t,lr){F=!0,bail(_t),J=lr}}run(E,F,J){assertNode(E),this.freeze();const $e=this.transformers;return!J&&typeof F=="function"&&(J=F,F=void 0),J?_t(void 0,J):new Promise(_t);function _t(lr,mr){const Or=vfile(F);$e.run(E,Or,Pr);function Pr(dn,gi,qi){const zi=gi||E;dn?mr(dn):lr?lr(zi):J(void 0,zi,qi)}}}runSync(E,F){let J=!1,$e;return this.run(E,F,_t),assertDone("runSync","run",J),$e;function _t(lr,mr){bail(lr),$e=mr,J=!0}}stringify(E,F){this.freeze();const J=vfile(F),$e=this.compiler||this.Compiler;return assertCompiler("stringify",$e),assertNode(E),$e(E,J)}use(E,...F){const J=this.attachers,$e=this.namespace;if(assertUnfrozen("use",this.frozen),E!=null)if(typeof E=="function")Or(E,F);else if(typeof E=="object")Array.isArray(E)?mr(E):lr(E);else throw new TypeError("Expected usable value, not `"+E+"`");return this;function _t(Pr){if(typeof Pr=="function")Or(Pr,[]);else if(typeof Pr=="object")if(Array.isArray(Pr)){const[dn,...gi]=Pr;Or(dn,gi)}else lr(Pr);else throw new TypeError("Expected usable value, not `"+Pr+"`")}function lr(Pr){if(!("plugins"in Pr)&&!("settings"in Pr))throw new Error("Expected usable value but received an empty preset, which is probably a mistake: presets typically come with `plugins` and sometimes with `settings`, but this has neither");mr(Pr.plugins),Pr.settings&&($e.settings=extend$2(!0,$e.settings,Pr.settings))}function mr(Pr){let dn=-1;if(Pr!=null)if(Array.isArray(Pr))for(;++dn<Pr.length;){const gi=Pr[dn];_t(gi)}else throw new TypeError("Expected a list of plugins, not `"+Pr+"`")}function Or(Pr,dn){let gi=-1,qi=-1;for(;++gi<J.length;)if(J[gi][0]===Pr){qi=gi;break}if(qi===-1)J.push([Pr,...dn]);else if(dn.length>0){let[zi,...Hi]=dn;const Qi=J[qi][1];isPlainObject$1(Qi)&&isPlainObject$1(zi)&&(zi=extend$2(!0,Qi,zi)),J[qi]=[Pr,zi,...Hi]}}}}const unified=new Processor().freeze();function assertParser(D,E){if(typeof E!="function")throw new TypeError("Cannot `"+D+"` without `parser`")}function assertCompiler(D,E){if(typeof E!="function")throw new TypeError("Cannot `"+D+"` without `compiler`")}function assertUnfrozen(D,E){if(E)throw new Error("Cannot call `"+D+"` on a frozen processor.\\nCreate a new processor first, by calling it: use `processor()` instead of `processor`.")}function assertNode(D){if(!isPlainObject$1(D)||typeof D.type!="string")throw new TypeError("Expected node, got `"+D+"`")}function assertDone(D,E,F){if(!F)throw new Error("`"+D+"` finished async. Use `"+E+"` instead")}function vfile(D){return looksLikeAVFile(D)?D:new VFile(D)}function looksLikeAVFile(D){return!!(D&&typeof D=="object"&&"message"in D&&"messages"in D)}function looksLikeAValue(D){return typeof D=="string"||isUint8Array(D)}function isUint8Array(D){return!!(D&&typeof D=="object"&&"byteLength"in D&&"byteOffset"in D)}function extractDastErrors(D){return Array.isArray(D)?D.flatMap(extractDastErrors):D.type==="error"?[D]:D.type==="root"||D.type==="element"?extractDastErrors(D.children):[]}const SCORED_SECTION_COMPONENT_TYPES=["document","section","subsection","subsubsection","paragraphs","aside","objectives","problem","exercise","question","activity","example","definition","note","theorem","part","task","proof","problems","exercises","standinForFutureLayoutTag","externalContent","cascade","div","span","ol","ul","li","p"];function renamedScoredSectionAttribute(D,E){const F={to:E,warningMessage:`[deprecation] Attribute \\`${D}\\` is deprecated; use \\`${E}\\` instead.`,conflictWarningMessage:`[deprecation] Attribute \\`${D}\\` is deprecated and ignored because \\`${E}\\` is also specified.`};return Object.fromEntries(SCORED_SECTION_COMPONENT_TYPES.map(J=>[J,{[D]:F}]))}function ignoredAttributes(D,E){return Object.fromEntries(E.map(F=>[F,{warningMessage:`[deprecation] Attribute \\`${F}\\` on \\`<${D}>\\` is deprecated and ignored.`}]))}const SCORED_SECTION_COLORING_RENAMES=renamedScoredSectionAttribute("forceIndividualAnswerColoring","colorAnswersSeparately"),DEPRECATION_REGISTRY={attributeRenames:{...SCORED_SECTION_COLORING_RENAMES,document:{...SCORED_SECTION_COLORING_RENAMES.document,documentWideCheckWork:{to:"sectionWideCheckWork",warningMessage:"[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated; use `sectionWideCheckWork` instead.",conflictWarningMessage:"[deprecation] Attribute `documentWideCheckWork` on `<document>` is deprecated and ignored because `sectionWideCheckWork` is also specified."}},selectFromSequence:{sortResults:{to:"sort",warningMessage:"[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated; use `sort` instead.",conflictWarningMessage:"[deprecation] Attribute `sortResults` on `<selectFromSequence>` is deprecated and ignored because `sort` is also specified."}},selectPrimeNumbers:{minValue:{to:"from",warningMessage:"[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated; use `from` instead.",conflictWarningMessage:"[deprecation] Attribute `minValue` on `<selectPrimeNumbers>` is deprecated and ignored because `from` is also specified."},maxValue:{to:"to",warningMessage:"[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated; use `to` instead.",conflictWarningMessage:"[deprecation] Attribute `maxValue` on `<selectPrimeNumbers>` is deprecated and ignored because `to` is also specified."},sortResults:{to:"sort",warningMessage:"[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated; use `sort` instead.",conflictWarningMessage:"[deprecation] Attribute `sortResults` on `<selectPrimeNumbers>` is deprecated and ignored because `sort` is also specified."}},samplePrimeNumbers:{minValue:{to:"from",warningMessage:"[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated; use `from` instead.",conflictWarningMessage:"[deprecation] Attribute `minValue` on `<samplePrimeNumbers>` is deprecated and ignored because `from` is also specified."},maxValue:{to:"to",warningMessage:"[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated; use `to` instead.",conflictWarningMessage:"[deprecation] Attribute `maxValue` on `<samplePrimeNumbers>` is deprecated and ignored because `to` is also specified."}}},attributeRemovals:{description:ignoredAttributes("description",["aggregateScores","weight","sectionWideCheckWork","showCorrectness","colorCorrectness","forceIndividualAnswerColoring","submitLabel","submitLabelNoCorrectness","displayDigitsForCreditAchieved"]),shortDescription:ignoredAttributes("shortDescription",["draggable","layer","isLatex","anchor","positionFromAnchor"])},componentRenames:{}};function lowerKeys(D){return Object.fromEntries(Object.entries(D).map(([E,F])=>[E.toLowerCase(),F]))}function buildDeprecationIndex(D){return{attributeRenames:Object.fromEntries(Object.entries(D.attributeRenames).map(([E,F])=>[E,lowerKeys(F)])),attributeRemovals:Object.fromEntries(Object.entries(D.attributeRemovals).map(([E,F])=>[E,lowerKeys(F)])),componentRenames:Object.fromEntries(Object.entries(D.componentRenames).map(([E,F])=>[E,F.attributeRenames?{...F,attributeRenames:lowerKeys(F.attributeRenames)}:F]))}}buildDeprecationIndex(DEPRECATION_REGISTRY);function addFoldingRangeSupport(D,E){D.onFoldingRanges(F=>{const J=E.get(F.textDocument.uri);if(!J)return[];const $e=[];return visit$1(J.autoCompleter.sourceObj.dast,_t=>{const lr=_t.position??{start:{line:1,column:1},end:{line:1,column:1}};switch(_t.type){case"comment":{$e.push({startLine:lr.start.line-1,endLine:lr.end.line-1,startCharacter:lr.start.column-1,endCharacter:lr.end.column-1,kind:browserExports.FoldingRangeKind.Comment});break}case"element":{if(_t.children.length===0)return;const mr=lr.start.line,Or=lr.end.line;if(mr===Or)return;$e.push({startLine:mr-1,endLine:Or-1,startCharacter:lr.start.column-1,endCharacter:lr.end.column-1,kind:browserExports.FoldingRangeKind.Region});break}}}),$e})}function addDocumentSymbolsSupport(D,E){D.onDocumentSymbol(F=>{const J=E.get(F.textDocument.uri);if(!J)return[];const $e=[],_t=J.autoCompleter.sourceObj;return $e.push(...getChildrenSymbols(_t.dast,_t)),$e})}function nodeToSymbol(D,E){switch(D.type){case"element":{const F=D.attributes,J=D.name;for(const $e of Object.values(F))if($e.name==="name"){const _t=toXml($e.children);if(!_t)continue;const lr=E.getNodeRange($e.children,"lsp");return J==="function"?{name:_t,kind:browserExports.SymbolKind.Function,range:lr,selectionRange:lr,detail:`${_t}(...)`}:{name:_t,kind:browserExports.SymbolKind.Namespace,range:lr,selectionRange:lr,detail:`<${J}>`}}break}}}function getChildrenSymbols(D,E){const F=[];if(D.type!=="element"&&D.type!=="root")return F;for(const J of D.children){const $e=nodeToSymbol(J,E),_t=getChildrenSymbols(J,E);$e?(F.push($e),_t.length>0&&($e.children=_t)):F.push(..._t)}return F}class FullTextDocument{constructor(E,F,J,$e){this._uri=E,this._languageId=F,this._version=J,this._content=$e,this._lineOffsets=void 0}get uri(){return this._uri}get languageId(){return this._languageId}get version(){return this._version}getText(E){if(E){const F=this.offsetAt(E.start),J=this.offsetAt(E.end);return this._content.substring(F,J)}return this._content}update(E,F){for(const J of E)if(FullTextDocument.isIncremental(J)){const $e=getWellformedRange(J.range),_t=this.offsetAt($e.start),lr=this.offsetAt($e.end);this._content=this._content.substring(0,_t)+J.text+this._content.substring(lr,this._content.length);const mr=Math.max($e.start.line,0),Or=Math.max($e.end.line,0);let Pr=this._lineOffsets;const dn=computeLineOffsets(J.text,!1,_t);if(Or-mr===dn.length)for(let qi=0,zi=dn.length;qi<zi;qi++)Pr[qi+mr+1]=dn[qi];else dn.length<1e4?Pr.splice(mr+1,Or-mr,...dn):this._lineOffsets=Pr=Pr.slice(0,mr+1).concat(dn,Pr.slice(Or+1));const gi=J.text.length-(lr-_t);if(gi!==0)for(let qi=mr+1+dn.length,zi=Pr.length;qi<zi;qi++)Pr[qi]=Pr[qi]+gi}else if(FullTextDocument.isFull(J))this._content=J.text,this._lineOffsets=void 0;else throw new Error("Unknown change event received");this._version=F}getLineOffsets(){return this._lineOffsets===void 0&&(this._lineOffsets=computeLineOffsets(this._content,!0)),this._lineOffsets}positionAt(E){E=Math.max(Math.min(E,this._content.length),0);const F=this.getLineOffsets();let J=0,$e=F.length;if($e===0)return{line:0,character:E};for(;J<$e;){const lr=Math.floor((J+$e)/2);F[lr]>E?$e=lr:J=lr+1}const _t=J-1;return E=this.ensureBeforeEOL(E,F[_t]),{line:_t,character:E-F[_t]}}offsetAt(E){const F=this.getLineOffsets();if(E.line>=F.length)return this._content.length;if(E.line<0)return 0;const J=F[E.line];if(E.character<=0)return J;const $e=E.line+1<F.length?F[E.line+1]:this._content.length,_t=Math.min(J+E.character,$e);return this.ensureBeforeEOL(_t,J)}ensureBeforeEOL(E,F){for(;E>F&&isEOL(this._content.charCodeAt(E-1));)E--;return E}get lineCount(){return this.getLineOffsets().length}static isIncremental(E){const F=E;return F!=null&&typeof F.text=="string"&&F.range!==void 0&&(F.rangeLength===void 0||typeof F.rangeLength=="number")}static isFull(E){const F=E;return F!=null&&typeof F.text=="string"&&F.range===void 0&&F.rangeLength===void 0}}var TextDocument;(function(D){function E($e,_t,lr,mr){return new FullTextDocument($e,_t,lr,mr)}D.create=E;function F($e,_t,lr){if($e instanceof FullTextDocument)return $e.update(_t,lr),$e;throw new Error("TextDocument.update: document must be created by TextDocument.create")}D.update=F;function J($e,_t){const lr=$e.getText(),mr=mergeSort(_t.map(getWellformedEdit),(dn,gi)=>{const qi=dn.range.start.line-gi.range.start.line;return qi===0?dn.range.start.character-gi.range.start.character:qi});let Or=0;const Pr=[];for(const dn of mr){const gi=$e.offsetAt(dn.range.start);if(gi<Or)throw new Error("Overlapping edit");gi>Or&&Pr.push(lr.substring(Or,gi)),dn.newText.length&&Pr.push(dn.newText),Or=$e.offsetAt(dn.range.end)}return Pr.push(lr.substr(Or)),Pr.join("")}D.applyEdits=J})(TextDocument||(TextDocument={}));function mergeSort(D,E){if(D.length<=1)return D;const F=D.length/2|0,J=D.slice(0,F),$e=D.slice(F);mergeSort(J,E),mergeSort($e,E);let _t=0,lr=0,mr=0;for(;_t<J.length&&lr<$e.length;)E(J[_t],$e[lr])<=0?D[mr++]=J[_t++]:D[mr++]=$e[lr++];for(;_t<J.length;)D[mr++]=J[_t++];for(;lr<$e.length;)D[mr++]=$e[lr++];return D}function computeLineOffsets(D,E,F=0){const J=E?[F]:[];for(let $e=0;$e<D.length;$e++){const _t=D.charCodeAt($e);isEOL(_t)&&(_t===13&&$e+1<D.length&&D.charCodeAt($e+1)===10&&$e++,J.push(F+$e+1))}return J}function isEOL(D){return D===13||D===10}function getWellformedRange(D){const E=D.start,F=D.end;return E.line>F.line||E.line===F.line&&E.character>F.character?{start:F,end:E}:D}function getWellformedEdit(D){const E=getWellformedRange(D.range);return E!==D.range?{newText:D.newText,range:E}:D}const defaultSettings={formatMode:"doenet"},config$3={hasConfigurationCapability:!1,hasWorkspaceFolderCapability:!1,hasDiagnosticRelatedInformationCapability:!1,globalSettings:defaultSettings},documentSettings=new Map,documentInfo=new Map;async function getDocumentSettings(D,E){if(!config$3.hasConfigurationCapability)return Promise.resolve(config$3.globalSettings);let F=documentSettings.get(E);return F||(F=D.workspace.getConfiguration({scopeUri:E,section:"doenet"}),documentSettings.set(E,F)),F}const documents=new browserExports.TextDocuments(TextDocument);var Ru=Object.defineProperty,yt=(D,E)=>{for(var F in E)Ru(D,F,{get:E[F],enumerable:!0})},Su={};yt(Su,{__debug:()=>$i,check:()=>Vi,doc:()=>ar,format:()=>Pu,formatWithCursor:()=>Ou,getSupportInfo:()=>Wi,util:()=>fr,version:()=>gu});var X=(D,E)=>(F,J,...$e)=>F|1&&J==null?void 0:(E.call(J)??J[D]).apply(J,$e),vu=String.prototype.replaceAll??function(D,E){return D.global?this.replace(D,E):this.split(D).join(E)},Lu=X("replaceAll",function(){if(typeof this=="string")return vu}),ne=Lu,Ne=class{diff(D,E,F={}){let J;typeof F=="function"?(J=F,F={}):"callback"in F&&(J=F.callback);let $e=this.castInput(D,F),_t=this.castInput(E,F),lr=this.removeEmpty(this.tokenize($e,F)),mr=this.removeEmpty(this.tokenize(_t,F));return this.diffWithOptionsObj(lr,mr,F,J)}diffWithOptionsObj(D,E,F,J){var $e;let _t=Zi=>{if(Zi=this.postProcess(Zi,F),J){setTimeout(function(){J(Zi)},0);return}else return Zi},lr=E.length,mr=D.length,Or=1,Pr=lr+mr;F.maxEditLength!=null&&(Pr=Math.min(Pr,F.maxEditLength));let dn=($e=F.timeout)!==null&&$e!==void 0?$e:1/0,gi=Date.now()+dn,qi=[{oldPos:-1,lastComponent:void 0}],zi=this.extractCommon(qi[0],E,D,0,F);if(qi[0].oldPos+1>=mr&&zi+1>=lr)return _t(this.buildValues(qi[0].lastComponent,E,D));let Hi=-1/0,Qi=1/0,Gi=()=>{for(let Zi=Math.max(Hi,-Or);Zi<=Math.min(Qi,Or);Zi+=2){let Xi,Ki=qi[Zi-1],ea=qi[Zi+1];Ki&&(qi[Zi-1]=void 0);let Ji=!1;if(ea){let na=ea.oldPos-Zi;Ji=ea&&0<=na&&na<lr}let ta=Ki&&Ki.oldPos+1<mr;if(!Ji&&!ta){qi[Zi]=void 0;continue}if(!ta||Ji&&Ki.oldPos<ea.oldPos?Xi=this.addToPath(ea,!0,!1,0,F):Xi=this.addToPath(Ki,!1,!0,1,F),zi=this.extractCommon(Xi,E,D,Zi,F),Xi.oldPos+1>=mr&&zi+1>=lr)return _t(this.buildValues(Xi.lastComponent,E,D))||!0;qi[Zi]=Xi,Xi.oldPos+1>=mr&&(Qi=Math.min(Qi,Zi-1)),zi+1>=lr&&(Hi=Math.max(Hi,Zi+1))}Or++};if(J)(function Zi(){setTimeout(function(){if(Or>Pr||Date.now()>gi)return J(void 0);Gi()||Zi()},0)})();else for(;Or<=Pr&&Date.now()<=gi;){let Zi=Gi();if(Zi)return Zi}}addToPath(D,E,F,J,$e){let _t=D.lastComponent;return _t&&!$e.oneChangePerToken&&_t.added===E&&_t.removed===F?{oldPos:D.oldPos+J,lastComponent:{count:_t.count+1,added:E,removed:F,previousComponent:_t.previousComponent}}:{oldPos:D.oldPos+J,lastComponent:{count:1,added:E,removed:F,previousComponent:_t}}}extractCommon(D,E,F,J,$e){let _t=E.length,lr=F.length,mr=D.oldPos,Or=mr-J,Pr=0;for(;Or+1<_t&&mr+1<lr&&this.equals(F[mr+1],E[Or+1],$e);)Or++,mr++,Pr++,$e.oneChangePerToken&&(D.lastComponent={count:1,previousComponent:D.lastComponent,added:!1,removed:!1});return Pr&&!$e.oneChangePerToken&&(D.lastComponent={count:Pr,previousComponent:D.lastComponent,added:!1,removed:!1}),D.oldPos=mr,Or}equals(D,E,F){return F.comparator?F.comparator(D,E):D===E||!!F.ignoreCase&&D.toLowerCase()===E.toLowerCase()}removeEmpty(D){let E=[];for(let F=0;F<D.length;F++)D[F]&&E.push(D[F]);return E}castInput(D,E){return D}tokenize(D,E){return Array.from(D)}join(D){return D.join("")}postProcess(D,E){return D}get useLongestToken(){return!1}buildValues(D,E,F){let J=[],$e;for(;D;)J.push(D),$e=D.previousComponent,delete D.previousComponent,D=$e;J.reverse();let _t=J.length,lr=0,mr=0,Or=0;for(;lr<_t;lr++){let Pr=J[lr];if(Pr.removed)Pr.value=this.join(F.slice(Or,Or+Pr.count)),Or+=Pr.count;else{if(!Pr.added&&this.useLongestToken){let dn=E.slice(mr,mr+Pr.count);dn=dn.map(function(gi,qi){let zi=F[Or+qi];return zi.length>gi.length?zi:gi}),Pr.value=this.join(dn)}else Pr.value=this.join(E.slice(mr,mr+Pr.count));mr+=Pr.count,Pr.added||(Or+=Pr.count)}}return J}},At=class extends Ne{tokenize(D){return D.slice()}join(D){return D}removeEmpty(D){return D}},pr=new At;function xt(D,E,F){return pr.diff(D,E,F)}var Mu=()=>{},k$1=Mu,dr="cr",Fr="crlf",Yu="lf",ju=Yu,Bt="\\r",Er=`\\r\n`,ze=`\n`,Uu=ze;function Cr(D){let E=D.indexOf(Bt);return E!==-1?D.charAt(E+1)===ze?Fr:dr:ju}function we(D){return D===dr?Bt:D===Fr?Er:Uu}var Vu=new Map([[ze,/\\n/g],[Bt,/\\r/g],[Er,/\\r\\n/g]]);function Tt(D,E){let F=Vu.get(E);return D.match(F)?.length??0}var Wu=/\\r\\n?/g;function hr(D){return ne(0,D,Wu,ze)}var ue=Symbol.for("comments");function $u(D){return this[D<0?this.length+D:D]}var zu=X("at",function(){if(Array.isArray(this)||typeof this=="string")return $u}),y$1=zu,G="string",U="array",V="cursor",I="indent",R="align",v$1="trim",x$1="group",S$1="fill",T$1="if-break",L="indent-if-break",M$1="line-suffix",Y="line-suffix-boundary",g$1="line",b$1="label",N$1="break-parent",Ge=new Set([V,I,R,v$1,x$1,S$1,T$1,L,M$1,Y,g$1,b$1,N$1]);function gr(D){let E=D.length;for(;E>0&&(D[E-1]==="\\r"||D[E-1]===`\n`);)E--;return E<D.length?D.slice(0,E):D}function Fe(D,E,F){if(!D.has(E)){let J=F(E);D.set(E,J)}return D.get(E)}function Gu(D){if(typeof D=="string")return G;if(Array.isArray(D))return U;if(!D)return;let{type:E}=D;if(Ge.has(E))return E}var q=Gu,Ku=D=>new Intl.ListFormat("en-US",{type:"disjunction"}).format(D);function Hu(D){let E=D===null?"null":typeof D;if(E!=="string"&&E!=="object")return`Unexpected doc \'${E}\', \nExpected it to be \'string\' or \'object\'.`;if(q(D))throw new Error("doc is valid.");let F=Object.prototype.toString.call(D);if(F!=="[object Object]")return`Unexpected doc \'${F}\'.`;let J=Ku([...Ge].map($e=>`\'${$e}\'`));return`Unexpected doc.type \'${D.type}\'.\nExpected it to be ${J}.`}var Nt=class extends Error{name="InvalidDocError";constructor(D){super(Hu(D)),this.doc=D}},Z=Nt,_r={};function Ju(D,E,F,J){let $e=[D];for(;$e.length>0;){let _t=$e.pop();if(_t===_r){F($e.pop());continue}F&&$e.push(_t,_r);let lr=q(_t);if(!lr)throw new Z(_t);if(E?.(_t)!==!1)switch(lr){case U:case S$1:{let mr=lr===U?_t:_t.parts;for(let Or=mr.length,Pr=Or-1;Pr>=0;--Pr)$e.push(mr[Pr]);break}case T$1:$e.push(_t.flatContents,_t.breakContents);break;case x$1:if(J&&_t.expandedStates)for(let mr=_t.expandedStates.length,Or=mr-1;Or>=0;--Or)$e.push(_t.expandedStates[Or]);else $e.push(_t.contents);break;case R:case I:case L:case b$1:case M$1:$e.push(_t.contents);break;case G:case V:case v$1:case Y:case g$1:case N$1:break;default:throw new Z(_t)}}}var Oe=Ju;function Se(D,E){if(typeof D=="string")return E(D);let F=new Map;return J(D);function J(_t){return Fe(F,_t,$e)}function $e(_t){switch(q(_t)){case U:return E(_t.map(J));case S$1:return E({..._t,parts:_t.parts.map(J)});case T$1:return E({..._t,breakContents:J(_t.breakContents),flatContents:J(_t.flatContents)});case x$1:{let{expandedStates:lr,contents:mr}=_t;return lr?(lr=lr.map(J),mr=lr[0]):mr=J(mr),E({..._t,contents:mr,expandedStates:lr})}case R:case I:case L:case b$1:case M$1:return E({..._t,contents:J(_t.contents)});case G:case V:case v$1:case Y:case g$1:case N$1:return E(_t);default:throw new Z(_t)}}}function Ke(D,E,F){let J=F,$e=!1;function _t(lr){if($e)return!1;let mr=E(lr);mr!==void 0&&($e=!0,J=mr)}return Oe(D,_t),J}function qu(D){if(D.type===x$1&&D.break||D.type===g$1&&D.hard||D.type===N$1)return!0}function xr(D){return Ke(D,qu,!1)}function yr(D){if(D.length>0){let E=y$1(0,D,-1);!E.expandedStates&&!E.break&&(E.break="propagated")}return null}function Br(D){let E=new Set,F=[];function J(_t){if(_t.type===N$1&&yr(F),_t.type===x$1){if(F.push(_t),E.has(_t))return!1;E.add(_t)}}function $e(_t){_t.type===x$1&&F.pop().break&&yr(F)}Oe(D,J,$e,!0)}function Xu(D){return D.type===g$1&&!D.hard?D.soft?"":" ":D.type===T$1?D.flatContents:D}function Tr(D){return Se(D,Xu)}function Ar(D){for(D=[...D];D.length>=2&&y$1(0,D,-2).type===g$1&&y$1(0,D,-1).type===N$1;)D.length-=2;if(D.length>0){let E=Pe(y$1(0,D,-1));D[D.length-1]=E}return D}function Pe(D){switch(q(D)){case I:case L:case x$1:case M$1:case b$1:{let E=Pe(D.contents);return{...D,contents:E}}case T$1:return{...D,breakContents:Pe(D.breakContents),flatContents:Pe(D.flatContents)};case S$1:return{...D,parts:Ar(D.parts)};case U:return Ar(D);case G:return gr(D);case R:case V:case v$1:case Y:case g$1:case N$1:break;default:throw new Z(D)}return D}function He(D){return Pe(Zu(D))}function Qu(D){switch(q(D)){case S$1:{let{parts:E}=D;if(E.every(F=>F===""))return"";if(E.length===1)return E[0];break}case x$1:if(!D.contents&&!D.id&&!D.break&&!D.expandedStates)return"";if(D.contents.type===x$1&&D.contents.id===D.id&&D.contents.break===D.break&&D.contents.expandedStates===D.expandedStates)return D.contents;break;case R:case I:case L:case M$1:if(!D.contents)return"";break;case T$1:if(!D.flatContents&&!D.breakContents)return"";break;case U:{let E=[];for(let F of D){if(!F)continue;let[J,...$e]=Array.isArray(F)?F:[F];typeof J=="string"&&typeof y$1(0,E,-1)=="string"?E[E.length-1]+=J:E.push(J),E.push(...$e)}return E.length===0?"":E.length===1?E[0]:E}case G:case V:case v$1:case Y:case g$1:case b$1:case N$1:break;default:throw new Z(D)}return D}function Zu(D){return Se(D,E=>Qu(E))}function Nr(D,E=Je){return Se(D,F=>typeof F=="string"?be(E,F.split(`\n`)):F)}function eo(D){if(D.type===g$1)return!0}function wr(D){return Ke(D,eo,!1)}function Ee(D,E){return D.type===b$1?{...D,contents:E(D.contents)}:E(D)}var qe=k$1;function oe(D){return{type:I,contents:D}}function De(D,E){return{type:R,contents:E,n:D}}function Sr(D){return De(Number.NEGATIVE_INFINITY,D)}function Xe(D){return De({type:"root"},D)}function br(D){return De(-1,D)}function Qe(D,E,F){let J=D;if(E>0){for(let $e=0;$e<Math.floor(E/F);++$e)J=oe(J);J=De(E%F,J),J=De(Number.NEGATIVE_INFINITY,J)}return J}var ae={type:N$1},ee={type:V};function kr(D){return{type:S$1,parts:D}}function wt(D,E={}){return qe(E.expandedStates),{type:x$1,id:E.id,contents:D,break:!!E.shouldBreak,expandedStates:E.expandedStates}}function Ir(D,E){return wt(D[0],{...E,expandedStates:D})}function Rr(D,E="",F={}){return{type:T$1,breakContents:D,flatContents:E,groupId:F.groupId}}function vr(D,E){return{type:L,contents:D,groupId:E.groupId,negate:E.negate}}function be(D,E){let F=[];for(let J=0;J<E.length;J++)J!==0&&F.push(D),F.push(E[J]);return F}function Lr(D,E){return D?{type:b$1,label:D,contents:E}:E}var Ze={type:g$1},Mr={type:g$1,soft:!0},ke={type:g$1,hard:!0},W=[ke,ae],Ot={type:g$1,hard:!0,literal:!0},Je=[Ot,ae];function Ie(D){return{type:M$1,contents:D}}var Yr={type:Y},jr={type:v$1};function te(D){if(!D)return"";if(Array.isArray(D)){let E=[];for(let F of D)if(Array.isArray(F))E.push(...te(F));else{let J=te(F);J!==""&&E.push(J)}return E}return D.type===T$1?{...D,breakContents:te(D.breakContents),flatContents:te(D.flatContents)}:D.type===x$1?{...D,contents:te(D.contents),expandedStates:D.expandedStates?.map(te)}:D.type===S$1?{type:"fill",parts:D.parts.map(te)}:D.contents?{...D,contents:te(D.contents)}:D}function Ur(D){let E=Object.create(null),F=new Set;return J(te(D));function J(_t,lr,mr){if(typeof _t=="string")return JSON.stringify(_t);if(Array.isArray(_t)){let Or=_t.map(J).filter(Boolean);return Or.length===1?Or[0]:`[${Or.join(", ")}]`}if(_t.type===g$1){let Or=mr?.[lr+1]?.type===N$1;return _t.literal?Or?"literalline":"literallineWithoutBreakParent":_t.hard?Or?"hardline":"hardlineWithoutBreakParent":_t.soft?"softline":"line"}if(_t.type===N$1)return mr?.[lr-1]?.type===g$1&&mr[lr-1].hard?void 0:"breakParent";if(_t.type===v$1)return"trim";if(_t.type===I)return"indent("+J(_t.contents)+")";if(_t.type===R)return _t.n===Number.NEGATIVE_INFINITY?"dedentToRoot("+J(_t.contents)+")":_t.n<0?"dedent("+J(_t.contents)+")":_t.n.type==="root"?"markAsRoot("+J(_t.contents)+")":"align("+JSON.stringify(_t.n)+", "+J(_t.contents)+")";if(_t.type===T$1)return"ifBreak("+J(_t.breakContents)+(_t.flatContents?", "+J(_t.flatContents):"")+(_t.groupId?(_t.flatContents?"":\', ""\')+`, { groupId: ${$e(_t.groupId)} }`:"")+")";if(_t.type===L){let Or=[];_t.negate&&Or.push("negate: true"),_t.groupId&&Or.push(`groupId: ${$e(_t.groupId)}`);let Pr=Or.length>0?`, { ${Or.join(", ")} }`:"";return`indentIfBreak(${J(_t.contents)}${Pr})`}if(_t.type===x$1){let Or=[];_t.break&&_t.break!=="propagated"&&Or.push("shouldBreak: true"),_t.id&&Or.push(`id: ${$e(_t.id)}`);let Pr=Or.length>0?`, { ${Or.join(", ")} }`:"";return _t.expandedStates?`conditionalGroup([${_t.expandedStates.map(dn=>J(dn)).join(",")}]${Pr})`:`group(${J(_t.contents)}${Pr})`}if(_t.type===S$1)return`fill([${_t.parts.map(Or=>J(Or)).join(", ")}])`;if(_t.type===M$1)return"lineSuffix("+J(_t.contents)+")";if(_t.type===Y)return"lineSuffixBoundary";if(_t.type===b$1)return`label(${JSON.stringify(_t.label)}, ${J(_t.contents)})`;if(_t.type===V)return"cursor";throw new Error("Unknown doc type "+_t.type)}function $e(_t){if(typeof _t!="symbol")return JSON.stringify(String(_t));if(_t in E)return E[_t];let lr=_t.description||"symbol";for(let mr=0;;mr++){let Or=lr+(mr>0?` #${mr}`:"");if(!F.has(Or))return F.add(Or),E[_t]=`Symbol.for(${JSON.stringify(Or)})`}}}var Vr=()=>/[#*0-9]\\uFE0F?\\u20E3|[\\xA9\\xAE\\u203C\\u2049\\u2122\\u2139\\u2194-\\u2199\\u21A9\\u21AA\\u231A\\u231B\\u2328\\u23CF\\u23ED-\\u23EF\\u23F1\\u23F2\\u23F8-\\u23FA\\u24C2\\u25AA\\u25AB\\u25B6\\u25C0\\u25FB\\u25FC\\u25FE\\u2600-\\u2604\\u260E\\u2611\\u2614\\u2615\\u2618\\u2620\\u2622\\u2623\\u2626\\u262A\\u262E\\u262F\\u2638-\\u263A\\u2640\\u2642\\u2648-\\u2653\\u265F\\u2660\\u2663\\u2665\\u2666\\u2668\\u267B\\u267E\\u267F\\u2692\\u2694-\\u2697\\u2699\\u269B\\u269C\\u26A0\\u26A7\\u26AA\\u26B0\\u26B1\\u26BD\\u26BE\\u26C4\\u26C8\\u26CF\\u26D1\\u26E9\\u26F0-\\u26F5\\u26F7\\u26F8\\u26FA\\u2702\\u2708\\u2709\\u270F\\u2712\\u2714\\u2716\\u271D\\u2721\\u2733\\u2734\\u2744\\u2747\\u2757\\u2763\\u27A1\\u2934\\u2935\\u2B05-\\u2B07\\u2B1B\\u2B1C\\u2B55\\u3030\\u303D\\u3297\\u3299]\\uFE0F?|[\\u261D\\u270C\\u270D](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?|[\\u270A\\u270B](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\u23E9-\\u23EC\\u23F0\\u23F3\\u25FD\\u2693\\u26A1\\u26AB\\u26C5\\u26CE\\u26D4\\u26EA\\u26FD\\u2705\\u2728\\u274C\\u274E\\u2753-\\u2755\\u2795-\\u2797\\u27B0\\u27BF\\u2B50]|\\u26D3\\uFE0F?(?:\\u200D\\uD83D\\uDCA5)?|\\u26F9(?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|\\u2764\\uFE0F?(?:\\u200D(?:\\uD83D\\uDD25|\\uD83E\\uDE79))?|\\uD83C(?:[\\uDC04\\uDD70\\uDD71\\uDD7E\\uDD7F\\uDE02\\uDE37\\uDF21\\uDF24-\\uDF2C\\uDF36\\uDF7D\\uDF96\\uDF97\\uDF99-\\uDF9B\\uDF9E\\uDF9F\\uDFCD\\uDFCE\\uDFD4-\\uDFDF\\uDFF5\\uDFF7]\\uFE0F?|[\\uDF85\\uDFC2\\uDFC7](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDFC4\\uDFCA](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDFCB\\uDFCC](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDCCF\\uDD8E\\uDD91-\\uDD9A\\uDE01\\uDE1A\\uDE2F\\uDE32-\\uDE36\\uDE38-\\uDE3A\\uDE50\\uDE51\\uDF00-\\uDF20\\uDF2D-\\uDF35\\uDF37-\\uDF43\\uDF45-\\uDF4A\\uDF4C-\\uDF7C\\uDF7E-\\uDF84\\uDF86-\\uDF93\\uDFA0-\\uDFC1\\uDFC5\\uDFC6\\uDFC8\\uDFC9\\uDFCF-\\uDFD3\\uDFE0-\\uDFF0\\uDFF8-\\uDFFF]|\\uDDE6\\uD83C[\\uDDE8-\\uDDEC\\uDDEE\\uDDF1\\uDDF2\\uDDF4\\uDDF6-\\uDDFA\\uDDFC\\uDDFD\\uDDFF]|\\uDDE7\\uD83C[\\uDDE6\\uDDE7\\uDDE9-\\uDDEF\\uDDF1-\\uDDF4\\uDDF6-\\uDDF9\\uDDFB\\uDDFC\\uDDFE\\uDDFF]|\\uDDE8\\uD83C[\\uDDE6\\uDDE8\\uDDE9\\uDDEB-\\uDDEE\\uDDF0-\\uDDF7\\uDDFA-\\uDDFF]|\\uDDE9\\uD83C[\\uDDEA\\uDDEC\\uDDEF\\uDDF0\\uDDF2\\uDDF4\\uDDFF]|\\uDDEA\\uD83C[\\uDDE6\\uDDE8\\uDDEA\\uDDEC\\uDDED\\uDDF7-\\uDDFA]|\\uDDEB\\uD83C[\\uDDEE-\\uDDF0\\uDDF2\\uDDF4\\uDDF7]|\\uDDEC\\uD83C[\\uDDE6\\uDDE7\\uDDE9-\\uDDEE\\uDDF1-\\uDDF3\\uDDF5-\\uDDFA\\uDDFC\\uDDFE]|\\uDDED\\uD83C[\\uDDF0\\uDDF2\\uDDF3\\uDDF7\\uDDF9\\uDDFA]|\\uDDEE\\uD83C[\\uDDE8-\\uDDEA\\uDDF1-\\uDDF4\\uDDF6-\\uDDF9]|\\uDDEF\\uD83C[\\uDDEA\\uDDF2\\uDDF4\\uDDF5]|\\uDDF0\\uD83C[\\uDDEA\\uDDEC-\\uDDEE\\uDDF2\\uDDF3\\uDDF5\\uDDF7\\uDDFC\\uDDFE\\uDDFF]|\\uDDF1\\uD83C[\\uDDE6-\\uDDE8\\uDDEE\\uDDF0\\uDDF7-\\uDDFB\\uDDFE]|\\uDDF2\\uD83C[\\uDDE6\\uDDE8-\\uDDED\\uDDF0-\\uDDFF]|\\uDDF3\\uD83C[\\uDDE6\\uDDE8\\uDDEA-\\uDDEC\\uDDEE\\uDDF1\\uDDF4\\uDDF5\\uDDF7\\uDDFA\\uDDFF]|\\uDDF4\\uD83C\\uDDF2|\\uDDF5\\uD83C[\\uDDE6\\uDDEA-\\uDDED\\uDDF0-\\uDDF3\\uDDF7-\\uDDF9\\uDDFC\\uDDFE]|\\uDDF6\\uD83C\\uDDE6|\\uDDF7\\uD83C[\\uDDEA\\uDDF4\\uDDF8\\uDDFA\\uDDFC]|\\uDDF8\\uD83C[\\uDDE6-\\uDDEA\\uDDEC-\\uDDF4\\uDDF7-\\uDDF9\\uDDFB\\uDDFD-\\uDDFF]|\\uDDF9\\uD83C[\\uDDE6\\uDDE8\\uDDE9\\uDDEB-\\uDDED\\uDDEF-\\uDDF4\\uDDF7\\uDDF9\\uDDFB\\uDDFC\\uDDFF]|\\uDDFA\\uD83C[\\uDDE6\\uDDEC\\uDDF2\\uDDF3\\uDDF8\\uDDFE\\uDDFF]|\\uDDFB\\uD83C[\\uDDE6\\uDDE8\\uDDEA\\uDDEC\\uDDEE\\uDDF3\\uDDFA]|\\uDDFC\\uD83C[\\uDDEB\\uDDF8]|\\uDDFD\\uD83C\\uDDF0|\\uDDFE\\uD83C[\\uDDEA\\uDDF9]|\\uDDFF\\uD83C[\\uDDE6\\uDDF2\\uDDFC]|\\uDF44(?:\\u200D\\uD83D\\uDFEB)?|\\uDF4B(?:\\u200D\\uD83D\\uDFE9)?|\\uDFC3(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?|\\uDFF3\\uFE0F?(?:\\u200D(?:\\u26A7\\uFE0F?|\\uD83C\\uDF08))?|\\uDFF4(?:\\u200D\\u2620\\uFE0F?|\\uDB40\\uDC67\\uDB40\\uDC62\\uDB40(?:\\uDC65\\uDB40\\uDC6E\\uDB40\\uDC67|\\uDC73\\uDB40\\uDC63\\uDB40\\uDC74|\\uDC77\\uDB40\\uDC6C\\uDB40\\uDC73)\\uDB40\\uDC7F)?)|\\uD83D(?:[\\uDC3F\\uDCFD\\uDD49\\uDD4A\\uDD6F\\uDD70\\uDD73\\uDD76-\\uDD79\\uDD87\\uDD8A-\\uDD8D\\uDDA5\\uDDA8\\uDDB1\\uDDB2\\uDDBC\\uDDC2-\\uDDC4\\uDDD1-\\uDDD3\\uDDDC-\\uDDDE\\uDDE1\\uDDE3\\uDDE8\\uDDEF\\uDDF3\\uDDFA\\uDECB\\uDECD-\\uDECF\\uDEE0-\\uDEE5\\uDEE9\\uDEF0\\uDEF3]\\uFE0F?|[\\uDC42\\uDC43\\uDC46-\\uDC50\\uDC66\\uDC67\\uDC6B-\\uDC6D\\uDC72\\uDC74-\\uDC76\\uDC78\\uDC7C\\uDC83\\uDC85\\uDC8F\\uDC91\\uDCAA\\uDD7A\\uDD95\\uDD96\\uDE4C\\uDE4F\\uDEC0\\uDECC](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDC6E-\\uDC71\\uDC73\\uDC77\\uDC81\\uDC82\\uDC86\\uDC87\\uDE45-\\uDE47\\uDE4B\\uDE4D\\uDE4E\\uDEA3\\uDEB4\\uDEB5](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDD74\\uDD90](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?|[\\uDC00-\\uDC07\\uDC09-\\uDC14\\uDC16-\\uDC25\\uDC27-\\uDC3A\\uDC3C-\\uDC3E\\uDC40\\uDC44\\uDC45\\uDC51-\\uDC65\\uDC6A\\uDC79-\\uDC7B\\uDC7D-\\uDC80\\uDC84\\uDC88-\\uDC8E\\uDC90\\uDC92-\\uDCA9\\uDCAB-\\uDCFC\\uDCFF-\\uDD3D\\uDD4B-\\uDD4E\\uDD50-\\uDD67\\uDDA4\\uDDFB-\\uDE2D\\uDE2F-\\uDE34\\uDE37-\\uDE41\\uDE43\\uDE44\\uDE48-\\uDE4A\\uDE80-\\uDEA2\\uDEA4-\\uDEB3\\uDEB7-\\uDEBF\\uDEC1-\\uDEC5\\uDED0-\\uDED2\\uDED5-\\uDED8\\uDEDC-\\uDEDF\\uDEEB\\uDEEC\\uDEF4-\\uDEFC\\uDFE0-\\uDFEB\\uDFF0]|\\uDC08(?:\\u200D\\u2B1B)?|\\uDC15(?:\\u200D\\uD83E\\uDDBA)?|\\uDC26(?:\\u200D(?:\\u2B1B|\\uD83D\\uDD25))?|\\uDC3B(?:\\u200D\\u2744\\uFE0F?)?|\\uDC41\\uFE0F?(?:\\u200D\\uD83D\\uDDE8\\uFE0F?)?|\\uDC68(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDC68\\uDC69]\\u200D\\uD83D(?:\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?)|[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?)|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFC-\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFE]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?))?|\\uDC69(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?[\\uDC68\\uDC69]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?|\\uDC69\\u200D\\uD83D(?:\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?))|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFC-\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFC-\\uDFFF])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB-\\uDFFE]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFE])))?))?|\\uDD75(?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|\\uDE2E(?:\\u200D\\uD83D\\uDCA8)?|\\uDE35(?:\\u200D\\uD83D\\uDCAB)?|\\uDE36(?:\\u200D\\uD83C\\uDF2B\\uFE0F?)?|\\uDE42(?:\\u200D[\\u2194\\u2195]\\uFE0F?)?|\\uDEB6(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?)|\\uD83E(?:[\\uDD0C\\uDD0F\\uDD18-\\uDD1F\\uDD30-\\uDD34\\uDD36\\uDD77\\uDDB5\\uDDB6\\uDDBB\\uDDD2\\uDDD3\\uDDD5\\uDEC3-\\uDEC5\\uDEF0\\uDEF2-\\uDEF8](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDD26\\uDD35\\uDD37-\\uDD39\\uDD3C-\\uDD3E\\uDDB8\\uDDB9\\uDDCD\\uDDCF\\uDDD4\\uDDD6-\\uDDDD](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDDDE\\uDDDF](?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDD0D\\uDD0E\\uDD10-\\uDD17\\uDD20-\\uDD25\\uDD27-\\uDD2F\\uDD3A\\uDD3F-\\uDD45\\uDD47-\\uDD76\\uDD78-\\uDDB4\\uDDB7\\uDDBA\\uDDBC-\\uDDCC\\uDDD0\\uDDE0-\\uDDFF\\uDE70-\\uDE7C\\uDE80-\\uDE8A\\uDE8E-\\uDEC2\\uDEC6\\uDEC8\\uDECD-\\uDEDC\\uDEDF-\\uDEEA\\uDEEF]|\\uDDCE(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?|\\uDDD1(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1|\\uDDD1\\u200D\\uD83E\\uDDD2(?:\\u200D\\uD83E\\uDDD2)?|\\uDDD2(?:\\u200D\\uD83E\\uDDD2)?))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE])))?))?|\\uDEF1(?:\\uD83C(?:\\uDFFB(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFC-\\uDFFF])?|\\uDFFC(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])?|\\uDFFD(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])?|\\uDFFE(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])?|\\uDFFF(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB-\\uDFFE])?))?)/g,Wr=12288,$r=65510,zr=[12288,12288,65281,65376,65504,65510],Gr=4352,Kr=262141,Pt=[4352,4447,8986,8987,9001,9002,9193,9196,9200,9200,9203,9203,9725,9726,9748,9749,9776,9783,9800,9811,9855,9855,9866,9871,9875,9875,9889,9889,9898,9899,9917,9918,9924,9925,9934,9934,9940,9940,9962,9962,9970,9971,9973,9973,9978,9978,9981,9981,9989,9989,9994,9995,10024,10024,10060,10060,10062,10062,10067,10069,10071,10071,10133,10135,10160,10160,10175,10175,11035,11036,11088,11088,11093,11093,11904,11929,11931,12019,12032,12245,12272,12287,12289,12350,12353,12438,12441,12543,12549,12591,12593,12686,12688,12773,12783,12830,12832,12871,12880,42124,42128,42182,43360,43388,44032,55203,63744,64255,65040,65049,65072,65106,65108,65126,65128,65131,94176,94180,94192,94198,94208,101589,101631,101662,101760,101874,110576,110579,110581,110587,110589,110590,110592,110882,110898,110898,110928,110930,110933,110933,110948,110951,110960,111355,119552,119638,119648,119670,126980,126980,127183,127183,127374,127374,127377,127386,127488,127490,127504,127547,127552,127560,127568,127569,127584,127589,127744,127776,127789,127797,127799,127868,127870,127891,127904,127946,127951,127955,127968,127984,127988,127988,127992,128062,128064,128064,128066,128252,128255,128317,128331,128334,128336,128359,128378,128378,128405,128406,128420,128420,128507,128591,128640,128709,128716,128716,128720,128722,128725,128728,128732,128735,128747,128748,128756,128764,128992,129003,129008,129008,129292,129338,129340,129349,129351,129535,129648,129660,129664,129674,129678,129734,129736,129736,129741,129756,129759,129770,129775,129784,131072,196605,196608,262141],St=(D,E)=>{let F=0,J=Math.floor(D.length/2)-1;for(;F<=J;){let $e=Math.floor((F+J)/2),_t=$e*2;if(E<D[_t])J=$e-1;else if(E>D[_t+1])F=$e+1;else return!0}return!1},Hr=19968,[to,ro]=no(Pt);function no(D){let E=D[0],F=D[1];for(let J=0;J<D.length;J+=2){let $e=D[J],_t=D[J+1];if(Hr>=$e&&Hr<=_t)return[$e,_t];_t-$e>F-E&&(E=$e,F=_t)}return[E,F]}var bt=D=>D<Wr||D>$r?!1:St(zr,D),kt=D=>D>=to&&D<=ro?!0:D<Gr||D>Kr?!1:St(Pt,D),uo=/^(?:[\\xA9\\xAE\\u203C\\u2049\\u2122\\u2139\\u2194-\\u2199\\u21A9\\u21AA\\u2328\\u23CF\\u23ED-\\u23EF\\u23F1\\u23F2\\u23F8-\\u23FA\\u24C2\\u25AA\\u25AB\\u25B6\\u25C0\\u25FB\\u25FC\\u2600-\\u2604\\u260E\\u2611\\u2618\\u2620\\u2622\\u2623\\u2626\\u262A\\u262E\\u262F\\u2638-\\u263A\\u2640\\u2642\\u265F\\u2660\\u2663\\u2665\\u2666\\u2668\\u267B\\u267E\\u2692\\u2694-\\u2697\\u2699\\u269B\\u269C\\u26A0\\u26A7\\u26B0\\u26B1\\u26C8\\u26CF\\u26D1\\u26D3\\u26E9\\u26F0\\u26F1\\u26F4\\u26F7\\u26F8\\u2702\\u2708\\u2709\\u270F\\u2712\\u2714\\u2716\\u271D\\u2721\\u2733\\u2734\\u2744\\u2747\\u2763\\u2764\\u27A1\\u2934\\u2935\\u2B05-\\u2B07]|\\uD83C[\\uDD70\\uDD71\\uDD7E\\uDD7F\\uDF21\\uDF24-\\uDF2C\\uDF36\\uDF7D\\uDF96\\uDF97\\uDF99-\\uDF9B\\uDF9E\\uDF9F\\uDFCD\\uDFCE\\uDFD4-\\uDFDF\\uDFF3\\uDFF5\\uDFF7]|\\uD83D[\\uDC3F\\uDC41\\uDCFD\\uDD49\\uDD4A\\uDD6F\\uDD70\\uDD73\\uDD76-\\uDD79\\uDD87\\uDD8A-\\uDD8D\\uDDA5\\uDDA8\\uDDB1\\uDDB2\\uDDBC\\uDDC2-\\uDDC4\\uDDD1-\\uDDD3\\uDDDC-\\uDDDE\\uDDE1\\uDDE3\\uDDE8\\uDDEF\\uDDF3\\uDDFA\\uDECB\\uDECD-\\uDECF\\uDEE0-\\uDEE5\\uDEE9\\uDEF0\\uDEF3])$/,Jr=D=>uo.test(D),oo=/[^\\x20-\\x7F]/;function io(D){if(!D)return 0;if(!oo.test(D))return D.length;let E=0;D=D.replace(Vr(),F=>(E+=Jr(F)?1:2,""));for(let F of D){let J=F.codePointAt(0);J<=31||J>=127&&J<=159||J>=768&&J<=879||J>=65024&&J<=65039||(E+=bt(J)||kt(J)?2:1)}return E}var Re=io,so={type:0},Do={type:1},It={value:"",length:0,queue:[],get root(){return It}};function qr(D,E,F){let J=E.type===1?D.queue.slice(0,-1):[...D.queue,E],$e="",_t=0,lr=0,mr=0;for(let Hi of J)switch(Hi.type){case 0:dn(),F.useTabs?Or(1):Pr(F.tabWidth);break;case 3:{let{string:Qi}=Hi;dn(),$e+=Qi,_t+=Qi.length;break}case 2:{let{width:Qi}=Hi;lr+=1,mr+=Qi;break}default:throw new Error(`Unexpected indent comment \'${Hi.type}\'.`)}return qi(),{...D,value:$e,length:_t,queue:J};function Or(Hi){$e+="	".repeat(Hi),_t+=F.tabWidth*Hi}function Pr(Hi){$e+=" ".repeat(Hi),_t+=Hi}function dn(){F.useTabs?gi():qi()}function gi(){lr>0&&Or(lr),zi()}function qi(){mr>0&&Pr(mr),zi()}function zi(){lr=0,mr=0}}function Xr(D,E,F){if(!E)return D;if(E.type==="root")return{...D,root:D};if(E===Number.NEGATIVE_INFINITY)return D.root;let J;return typeof E=="number"?E<0?J=Do:J={type:2,width:E}:J={type:3,string:E},qr(D,J,F)}function Qr(D,E){return qr(D,so,E)}function ao(D){let E=0;for(let F=D.length-1;F>=0;F--){let J=D[F];if(J===" "||J==="	")E++;else break}return E}function et(D){let E=ao(D);return{text:E===0?D:D.slice(0,D.length-E),count:E}}var Rt=class{#r=[];#e="";#n=0;#i=[];#t=[];#o(){let D=this.#e;D!==""&&(this.#r.push(D),this.#n+=D.length,this.#e="");for(let E of this.#t)this.#i.push(Math.min(E,this.#n));this.#t.length=0}markPosition(){if(this.#i.length+this.#t.length>=2)throw new Error("There are too many \'cursor\' in doc.");this.#t.push(this.#n+this.#e.length)}write(D){this.#e+=D}trim(){let{text:D,count:E}=et(this.#e);return this.#e=D,this.#o(),E}finish(){return this.#o(),{text:this.#r.join(""),positions:this.#i}}},Zr=Rt,K=Symbol("MODE_BREAK"),Q$1=Symbol("MODE_FLAT"),vt=Symbol("DOC_FILL_PRINTED_LENGTH");function tt(D,E,F,J,$e,_t){if(F===Number.POSITIVE_INFINITY)return!0;let lr=E.length,mr=!1,Or=[D],Pr="";for(;F>=0;){if(Or.length===0){if(lr===0)return!0;Or.push(E[--lr]);continue}let{mode:dn,doc:gi}=Or.pop(),qi=q(gi);switch(qi){case G:gi&&(mr&&(Pr+=" ",F-=1,mr=!1),Pr+=gi,F-=Re(gi));break;case U:case S$1:{let zi=qi===U?gi:gi.parts,Hi=gi[vt]??0;for(let Qi=zi.length-1;Qi>=Hi;Qi--)Or.push({mode:dn,doc:zi[Qi]});break}case I:case R:case L:case b$1:Or.push({mode:dn,doc:gi.contents});break;case v$1:{let{text:zi,count:Hi}=et(Pr);Pr=zi,F+=Hi;break}case x$1:{if(_t&&gi.break)return!1;let zi=gi.break?K:dn,Hi=gi.expandedStates&&zi===K?y$1(0,gi.expandedStates,-1):gi.contents;Or.push({mode:zi,doc:Hi});break}case T$1:{let zi=(gi.groupId?$e[gi.groupId]||Q$1:dn)===K?gi.breakContents:gi.flatContents;zi&&Or.push({mode:dn,doc:zi});break}case g$1:if(dn===K||gi.hard)return!0;gi.soft||(mr=!0);break;case M$1:J=!0;break;case Y:if(J)return!1;break}}return!1}function Ce(D,E){let F=Object.create(null),J=E.printWidth,$e=we(E.endOfLine),_t=0,lr=[{indent:It,mode:K,doc:D}],mr=!1,Or=[],Pr=new Zr;for(Br(D);lr.length>0;){let{indent:Hi,mode:Qi,doc:Gi}=lr.pop();switch(q(Gi)){case G:{let Zi=$e!==`\n`?ne(0,Gi,`\n`,$e):Gi;Zi&&(Pr.write(Zi),lr.length>0&&(_t+=Re(Zi)));break}case U:for(let Zi=Gi.length-1;Zi>=0;Zi--)lr.push({indent:Hi,mode:Qi,doc:Gi[Zi]});break;case V:Pr.markPosition();break;case I:lr.push({indent:Qr(Hi,E),mode:Qi,doc:Gi.contents});break;case R:lr.push({indent:Xr(Hi,Gi.n,E),mode:Qi,doc:Gi.contents});break;case v$1:_t-=Pr.trim();break;case x$1:{let Zi=(function(){if(Qi===Q$1&&!mr)return{indent:Hi,mode:Gi.break?K:Q$1,doc:Gi.contents};mr=!1;let Xi=J-_t,Ki=Or.length>0,ea={indent:Hi,mode:Q$1,doc:Gi.contents};if(!Gi.break&&tt(ea,lr,Xi,Ki,F))return ea;if(!Gi.expandedStates)return{indent:Hi,mode:K,doc:Gi.contents};if(!Gi.break)for(let Ji=1;Ji<Gi.expandedStates.length-1;Ji++){let ta={indent:Hi,mode:Q$1,doc:Gi.expandedStates[Ji]};if(tt(ta,lr,Xi,Ki,F))return ta}return{indent:Hi,mode:K,doc:y$1(0,Gi.expandedStates,-1)}})();lr.push(Zi),Gi.id&&(F[Gi.id]=Zi.mode);break}case S$1:{let Zi=J-_t,Xi=Gi[vt]??0,{parts:Ki}=Gi,ea=Ki.length-Xi;if(ea===0)break;let Ji=Ki[Xi+0],ta=Ki[Xi+1],na={indent:Hi,mode:Q$1,doc:Ji},ra={indent:Hi,mode:K,doc:Ji},ia=tt(na,[],Zi,Or.length>0,F,!0);if(ea===1){ia?lr.push(na):lr.push(ra);break}let oa={indent:Hi,mode:Q$1,doc:ta},ua={indent:Hi,mode:K,doc:ta};if(ea===2){ia?lr.push(oa,na):lr.push(ua,ra);break}let sa=Ki[Xi+2],aa={indent:Hi,mode:Qi,doc:{...Gi,[vt]:Xi+2}},pa=tt({indent:Hi,mode:Q$1,doc:[Ji,ta,sa]},[],Zi,Or.length>0,F,!0);lr.push(aa),pa?lr.push(oa,na):ia?lr.push(ua,na):lr.push(ua,ra);break}case T$1:case L:{let Zi=Gi.groupId?F[Gi.groupId]:Qi;if(Zi===K){let Xi=Gi.type===T$1?Gi.breakContents:Gi.negate?Gi.contents:oe(Gi.contents);Xi&&lr.push({indent:Hi,mode:Qi,doc:Xi})}if(Zi===Q$1){let Xi=Gi.type===T$1?Gi.flatContents:Gi.negate?oe(Gi.contents):Gi.contents;Xi&&lr.push({indent:Hi,mode:Qi,doc:Xi})}break}case M$1:Or.push({indent:Hi,mode:Qi,doc:Gi.contents});break;case Y:Or.length>0&&lr.push({indent:Hi,mode:Qi,doc:ke});break;case g$1:switch(Qi){case Q$1:if(!Gi.hard){Gi.soft||(Pr.write(" "),_t+=1);break}mr=!0;case K:if(Or.length>0){lr.push({indent:Hi,mode:Qi,doc:Gi},...Or.reverse()),Or.length=0;break}Gi.literal?(Pr.write($e),_t=0,Hi.root&&(Hi.root.value&&Pr.write(Hi.root.value),_t=Hi.root.length)):(Pr.trim(),Pr.write($e+Hi.value),_t=Hi.length);break}break;case b$1:lr.push({indent:Hi,mode:Qi,doc:Gi.contents});break;case N$1:break;default:throw new Z(Gi)}lr.length===0&&Or.length>0&&(lr.push(...Or.reverse()),Or.length=0)}let{text:dn,positions:gi}=Pr.finish();if(gi.length!==2)return{formatted:dn};let[qi,zi]=gi;return{formatted:dn,cursorNodeStart:qi,cursorNodeText:dn.slice(qi,zi)}}function co(D,E,F=0){let J=0;for(let $e=F;$e<D.length;++$e)D[$e]==="	"?J=J+E-J%E:J++;return J}var he=co,Lt=class{constructor(D){this.stack=[D]}get key(){let{stack:D,siblings:E}=this;return y$1(0,D,E===null?-2:-4)??null}get index(){return this.siblings===null?null:y$1(0,this.stack,-2)}get node(){return y$1(0,this.stack,-1)}get parent(){return this.getNode(1)}get grandparent(){return this.getNode(2)}get isInArray(){return this.siblings!==null}get siblings(){let{stack:D}=this,E=y$1(0,D,-3);return Array.isArray(E)?E:null}get next(){let{siblings:D}=this;return D===null?null:D[this.index+1]}get previous(){let{siblings:D}=this;return D===null?null:D[this.index-1]}get isFirst(){return this.index===0}get isLast(){let{siblings:D,index:E}=this;return D!==null&&E===D.length-1}get isRoot(){return this.stack.length===1}get root(){return this.stack[0]}get ancestors(){return[...this.#e()]}getName(){let{stack:D}=this,{length:E}=D;return E>1?y$1(0,D,-2):null}getValue(){return y$1(0,this.stack,-1)}getNode(D=0){let E=this.#r(D);return E===-1?null:this.stack[E]}getParentNode(D=0){return this.getNode(D+1)}#r(D){let{stack:E}=this;for(let F=E.length-1;F>=0;F-=2)if(!Array.isArray(E[F])&&--D<0)return F;return-1}call(D,...E){let{stack:F}=this,{length:J}=F,$e=y$1(0,F,-1);for(let _t of E)$e=$e?.[_t],F.push(_t,$e);try{return D(this)}finally{F.length=J}}callParent(D,E=0){let F=this.#r(E+1),J=this.stack.splice(F+1);try{return D(this)}finally{this.stack.push(...J)}}each(D,...E){let{stack:F}=this,{length:J}=F,$e=y$1(0,F,-1);for(let _t of E)$e=$e[_t],F.push(_t,$e);try{for(let _t=0;_t<$e.length;++_t)F.push(_t,$e[_t]),D(this,_t,$e),F.length-=2}finally{F.length=J}}map(D,...E){let F=[];return this.each((J,$e,_t)=>{F[$e]=D(J,$e,_t)},...E),F}match(...D){let E=this.stack.length-1,F=null,J=this.stack[E--];for(let $e of D){if(J===void 0)return!1;let _t=null;if(typeof F=="number"&&(_t=F,F=this.stack[E--],J=this.stack[E--]),$e&&!$e(J,F,_t))return!1;F=this.stack[E--],J=this.stack[E--]}return!0}findAncestor(D){for(let E of this.#e())if(D(E))return E}hasAncestor(D){for(let E of this.#e())if(D(E))return!0;return!1}*#e(){let{stack:D}=this;for(let E=D.length-3;E>=0;E-=2){let F=D[E];Array.isArray(F)||(yield F)}}},en=Lt;function fo(D){return Array.isArray(D)&&D.length>0}var rt=fo;function lo(D){return D!==null&&typeof D=="object"}var ge=lo;function _e(D){return(E,F,J)=>{if(F===!1)return!1;let $e=!!J?.backwards,{length:_t}=E,lr=F;for(;lr>=0&&lr<_t;){let mr=E.charAt(lr);if(D instanceof RegExp){if(!D.test(mr))return lr}else if(!D.includes(mr))return lr;$e?lr--:lr++}return lr===-1||lr===_t?lr:!1}}var tn=_e(/\\s/),j$1=_e(" 	"),nt=_e(",; 	"),ut=_e(/[^\\n\\r]/),rn=D=>D===`\n`||D==="\\r"||D==="\\u2028"||D==="\\u2029";function po(D,E,F){if(E===!1)return!1;let J=!!F?.backwards,$e=D.charAt(E);if(J){if(D.charAt(E-1)==="\\r"&&$e===`\n`)return E-2;if(rn($e))return E-1}else{if($e==="\\r"&&D.charAt(E+1)===`\n`)return E+2;if(rn($e))return E+1}return E}var $$1=po;function mo(D,E,F={}){let J=j$1(D,F.backwards?E-1:E,F),$e=$$1(D,J,F);return J!==$e}var H$1=mo;function*ye(D,E){let{getVisitorKeys:F,filter:J=()=>!0}=E,$e=_t=>ge(_t)&&J(_t);for(let _t of F(D)){let lr=D[_t];if(Array.isArray(lr))for(let mr of lr)$e(mr)&&(yield mr);else $e(lr)&&(yield lr)}}function*nn(D,E){let F=[D];for(let J=0;J<F.length;J++){let $e=F[J];for(let _t of ye($e,E))yield _t,F.push(_t)}}function un(D,E){return ye(D,E).next().done}function Fo(D,E,F){let{filter:J}=F;if(!J)return[];let $e,_t=(F.getChildren?.(D,F)??[...ye(D,{getVisitorKeys:F.getVisitorKeys})]).flatMap(Or=>($e??($e=[D,...E]),J(Or,$e)?[Or]:on(Or,$e,F))),{locStart:lr,locEnd:mr}=F;return _t.sort((Or,Pr)=>lr(Or)-lr(Pr)||mr(Or)-mr(Pr)),_t}function on(D,E,F){return Fe(F.cache,D,J=>Fo(J,E,F))}var ot=on;function Eo(D){let E=D.type||D.kind||"(unknown type)",F=String(D.name||D.id&&(typeof D.id=="object"?D.id.name:D.id)||D.key&&(typeof D.key=="object"?D.key.name:D.key)||D.value&&(typeof D.value=="object"?"":String(D.value))||D.operator||"");return F.length>20&&(F=F.slice(0,19)+"…"),E+(F?" "+F:"")}function Mt(D,E){(D.comments??(D.comments=[])).push(E),E.printed=!1,E.nodeDescription=Eo(D)}function ce(D,E){E.leading=!0,E.trailing=!1,Mt(D,E)}function re$1(D,E,F){E.leading=!1,E.trailing=!1,F&&(E.marker=F),Mt(D,E)}function fe(D,E){E.leading=!1,E.trailing=!0,Mt(D,E)}var Ut=new WeakMap;function Dn(D,E,F,J,$e=[]){let{locStart:_t,locEnd:lr}=F,mr=_t(E),Or=lr(E),Pr=ot(D,$e,{cache:Ut,locStart:_t,locEnd:lr,getVisitorKeys:F.getVisitorKeys,filter:F.printer.canAttachComment,getChildren:F.printer.getCommentChildNodes}),dn,gi,qi=0,zi=Pr.length;for(;qi<zi;){let Hi=qi+zi>>1,Qi=Pr[Hi],Gi=_t(Qi),Zi=lr(Qi);if(Gi<=mr&&Or<=Zi)return Dn(Qi,E,F,Qi,[Qi,...$e]);if(Zi<=mr){dn=Qi,qi=Hi+1;continue}if(Or<=Gi){gi=Qi,zi=Hi;continue}throw new Error("Comment location overlaps with node location")}if(J?.type==="TemplateLiteral"){let{quasis:Hi}=J,Qi=jt(Hi,E,F);dn&&jt(Hi,dn,F)!==Qi&&(dn=null),gi&&jt(Hi,gi,F)!==Qi&&(gi=null)}return{enclosingNode:J,precedingNode:dn,followingNode:gi}}var Yt=()=>!1;function an(D,E){let{comments:F}=D;if(delete D.comments,!rt(F)||!E.printer.canAttachComment)return;let J=[],{printer:{features:{experimental_avoidAstMutation:$e},handleComments:_t={}},originalText:lr}=E,{ownLine:mr=Yt,endOfLine:Or=Yt,remaining:Pr=Yt}=_t,dn=F.map((qi,zi)=>({...Dn(D,qi,E),comment:qi,text:lr,options:E,ast:D,isLastComment:F.length-1===zi,placement:void 0})),gi=!$e;for(let[qi,zi]of dn.entries()){let{comment:Hi,precedingNode:Qi,enclosingNode:Gi,followingNode:Zi,text:Xi,options:Ki,ast:ea,isLastComment:Ji}=zi,ta=Co(Xi,Ki,dn,qi)?"ownLine":ho(Xi,Ki,dn,qi)?"endOfLine":"remaining",na;if($e?(zi.placement=ta,na=[zi]):na=[Hi,Xi,Ki,ea,Ji],gi&&(Hi.placement=ta,Hi.enclosingNode=Gi,Hi.precedingNode=Qi,Hi.followingNode=Zi),ta==="ownLine")mr(...na)||(Zi?ce(Zi,Hi):Qi?fe(Qi,Hi):re$1(Gi||ea,Hi));else if(ta==="endOfLine")Or(...na)||(Qi?fe(Qi,Hi):Zi?ce(Zi,Hi):re$1(Gi||ea,Hi));else if(!Pr(...na))if(Qi&&Zi){let ra=J.length;ra>0&&J[ra-1].followingNode!==Zi&&sn(J,Ki),J.push(zi)}else Qi?fe(Qi,Hi):Zi?ce(Zi,Hi):re$1(Gi||ea,Hi)}if(sn(J,E),gi)for(let qi of F)delete qi.precedingNode,delete qi.enclosingNode,delete qi.followingNode,delete qi.placement}var cn=D=>!/[\\S\\n\\u2028\\u2029]/.test(D);function Co(D,E,F,J){let{comment:$e,precedingNode:_t}=F[J],{locStart:lr,locEnd:mr}=E,Or=lr($e);if(_t)for(let Pr=J-1;Pr>=0;Pr--){let{comment:dn,precedingNode:gi}=F[Pr];if(gi!==_t||!cn(D.slice(mr(dn),Or)))break;Or=lr(dn)}return H$1(D,Or,{backwards:!0})}function ho(D,E,F,J){let{comment:$e,followingNode:_t}=F[J],{locStart:lr,locEnd:mr}=E,Or=mr($e);if(_t)for(let Pr=J+1;Pr<F.length;Pr++){let{comment:dn,followingNode:gi}=F[Pr];if(gi!==_t||!cn(D.slice(Or,lr(dn))))break;Or=mr(dn)}return H$1(D,Or)}function sn(D,E){let F=D.length;if(F===0)return;let{precedingNode:J,followingNode:$e}=D[0],_t=E.locStart($e),lr;for(lr=F;lr>0;--lr){let{comment:mr,precedingNode:Or,followingNode:Pr}=D[lr-1],dn=E.originalText.slice(E.locEnd(mr),_t);if(E.printer.isGap?.(dn,E)??/^[\\s(]*$/.test(dn))_t=E.locStart(mr);else break}for(let[mr,{comment:Or}]of D.entries())mr<lr?fe(J,Or):ce($e,Or);for(let mr of[J,$e])mr.comments&&mr.comments.length>1&&mr.comments.sort((Or,Pr)=>E.locStart(Or)-E.locStart(Pr));D.length=0}function jt(D,E,F){let J=F.locStart(E)-1;for(let $e=1;$e<D.length;++$e)if(J<F.locStart(D[$e]))return $e-1;return 0}function go(D,E){let F=E-1;F=j$1(D,F,{backwards:!0}),F=$$1(D,F,{backwards:!0}),F=j$1(D,F,{backwards:!0});let J=$$1(D,F,{backwards:!0});return F!==J}var ve=go,fn=()=>!0;function ln$1(D,E){let F=D.node;return F.printed=!0,E.printer.printComment(D,E)}function _o(D,E){let F=D.node,J=[ln$1(D,E)],{printer:$e,originalText:_t,locStart:lr,locEnd:mr}=E;if($e.isBlockComment?.(F)){let Pr=" ";H$1(_t,mr(F))&&(H$1(_t,lr(F),{backwards:!0})?Pr=W:Pr=Ze),J.push(Pr)}else J.push(W);let Or=$$1(_t,j$1(_t,mr(F)));return Or!==!1&&H$1(_t,Or)&&J.push(W),J}function yo(D,E,F){let J=D.node,$e=ln$1(D,E),{printer:_t,originalText:lr,locStart:mr}=E,Or=_t.isBlockComment?.(J);if(F?.hasLineSuffix&&!F?.isBlock||H$1(lr,mr(J),{backwards:!0})){let Pr=ve(lr,mr(J));return{doc:Ie([W,Pr?W:"",$e]),isBlock:Or,hasLineSuffix:!0}}return!Or||F?.hasLineSuffix?{doc:[Ie([" ",$e]),ae],isBlock:Or,hasLineSuffix:!0}:{doc:[" ",$e],isBlock:Or,hasLineSuffix:!1}}function Ao(D,E,F){let J=E[Symbol.for("printedComments")],$e=fn,_t=new Set(D.node?.comments?.filter(lr=>!J?.has(lr)&&lr.leading&&$e()));return _t.size===0?"":D.map(({node:lr})=>_t.has(lr)?_o(D,E):"","comments").filter(Boolean)}function xo(D,E,F){let J=D.node?.comments,$e=new Set(J?.filter(dn=>dn.trailing)),_t=E[Symbol.for("printedComments")],lr=fn,mr=new Set(J?.filter(dn=>$e.has(dn)&&!_t?.has(dn)&&lr()));if(mr.size===0)return"";let Or=[],Pr;return D.each(({node:dn})=>{$e.has(dn)&&(Pr=yo(D,E,Pr),mr.has(dn)&&Or.push(Pr.doc))},"comments"),Or}function pn(D,E,F,J){let $e=Ao(D,F),_t=xo(D,F);return $e||_t?Ee(E,lr=>[$e,lr,_t]):E}function mn(D){let{[ue]:E,[Symbol.for("printedComments")]:F}=D;for(let J of E){if(!J.printed&&!F.has(J))throw new Error(\'Comment "\'+J.value.trim()+\'" was not printed. Please report this error!\');delete J.printed}}var Le=class extends Error{name="ConfigError"},Me=class extends Error{name="UndefinedParserError"},Bo=Object.hasOwn??Function.prototype.call.bind(Object.prototype.hasOwnProperty),le=Bo,Fn={checkIgnorePragma:{category:"Special",type:"boolean",default:!1,description:"Check whether the file\'s first docblock comment contains \'@noprettier\' or \'@noformat\' to determine if it should be formatted.",cliCategory:"Other"},cursorOffset:{category:"Special",type:"int",default:-1,range:{start:-1,end:1/0,step:1},description:"Print (to stderr) where a cursor at the given position would move to after formatting.",cliCategory:"Editor"},endOfLine:{category:"Global",type:"choice",default:"lf",description:"Which end of line characters to apply.",choices:[{value:"lf",description:"Line Feed only (\\\\n), common on Linux and macOS as well as inside git repos"},{value:"crlf",description:"Carriage Return + Line Feed characters (\\\\r\\\\n), common on Windows"},{value:"cr",description:"Carriage Return character only (\\\\r), used very rarely"},{value:"auto",description:`Maintain existing\n(mixed values within one file are normalised by looking at what\'s used after the first line)`}]},filepath:{category:"Special",type:"path",description:"Specify the input filepath. This will be used to do parser inference.",cliName:"stdin-filepath",cliCategory:"Other",cliDescription:"Path to the file to pretend that stdin comes from."},insertPragma:{category:"Special",type:"boolean",default:!1,description:"Insert @format pragma into file\'s first docblock comment.",cliCategory:"Other"},parser:{category:"Global",type:"choice",default:void 0,description:"Which parser to use.",exception:D=>typeof D=="string"||typeof D=="function",choices:[{value:"flow",description:"Flow"},{value:"babel",description:"JavaScript"},{value:"babel-flow",description:"Flow"},{value:"babel-ts",description:"TypeScript"},{value:"typescript",description:"TypeScript"},{value:"acorn",description:"JavaScript"},{value:"espree",description:"JavaScript"},{value:"meriyah",description:"JavaScript"},{value:"css",description:"CSS"},{value:"less",description:"Less"},{value:"scss",description:"SCSS"},{value:"json",description:"JSON"},{value:"json5",description:"JSON5"},{value:"jsonc",description:"JSON with Comments"},{value:"json-stringify",description:"JSON.stringify"},{value:"graphql",description:"GraphQL"},{value:"markdown",description:"Markdown"},{value:"mdx",description:"MDX"},{value:"vue",description:"Vue"},{value:"yaml",description:"YAML"},{value:"glimmer",description:"Ember / Handlebars"},{value:"html",description:"HTML"},{value:"angular",description:"Angular"},{value:"lwc",description:"Lightning Web Components"},{value:"mjml",description:"MJML"}]},plugins:{type:"path",array:!0,default:[{value:[]}],category:"Global",description:"Add a plugin. Multiple plugins can be passed as separate `--plugin`s.",exception:D=>typeof D=="string"||typeof D=="object",cliName:"plugin",cliCategory:"Config"},printWidth:{category:"Global",type:"int",default:80,description:"The line length where Prettier will try wrap.",range:{start:0,end:1/0,step:1}},rangeEnd:{category:"Special",type:"int",default:1/0,range:{start:0,end:1/0,step:1},description:`Format code ending at a given character offset (exclusive).\nThe range will extend forwards to the end of the selected statement.`,cliCategory:"Editor"},rangeStart:{category:"Special",type:"int",default:0,range:{start:0,end:1/0,step:1},description:`Format code starting at a given character offset.\nThe range will extend backwards to the start of the first line containing the selected statement.`,cliCategory:"Editor"},requirePragma:{category:"Special",type:"boolean",default:!1,description:"Require either \'@prettier\' or \'@format\' to be present in the file\'s first docblock comment in order for it to be formatted.",cliCategory:"Other"},tabWidth:{type:"int",category:"Global",default:2,description:"Number of spaces per indentation level.",range:{start:0,end:1/0,step:1}},useTabs:{category:"Global",type:"boolean",default:!1,description:"Indent with tabs instead of spaces."},embeddedLanguageFormatting:{category:"Global",type:"choice",default:"auto",description:"Control how Prettier formats quoted code embedded in the file.",choices:[{value:"auto",description:"Format embedded code if Prettier can automatically identify it."},{value:"off",description:"Never automatically format embedded code."}]}};function it({plugins:D=[],showDeprecated:E=!1}={}){let F=D.flatMap($e=>$e.languages??[]),J=[];for(let $e of No(Object.assign({},...D.map(({options:_t})=>_t),Fn)))!E&&$e.deprecated||(Array.isArray($e.choices)&&(E||($e.choices=$e.choices.filter(_t=>!_t.deprecated)),$e.name==="parser"&&($e.choices=[...$e.choices,...To($e.choices,F,D)])),$e.pluginDefaults=Object.fromEntries(D.filter(_t=>_t.defaultOptions?.[$e.name]!==void 0).map(_t=>[_t.name,_t.defaultOptions[$e.name]])),J.push($e));return{languages:F,options:J}}function*To(D,E,F){let J=new Set(D.map($e=>$e.value));for(let $e of E)if($e.parsers){for(let _t of $e.parsers)if(!J.has(_t)){J.add(_t);let lr=F.find(Or=>Or.parsers&&le(Or.parsers,_t)),mr=$e.name;lr?.name&&(mr+=` (plugin: ${lr.name})`),yield{value:_t,description:mr}}}}function No(D){let E=[];for(let[F,J]of Object.entries(D)){let $e={name:F,...J};Array.isArray($e.default)&&($e.default=y$1(0,$e.default,-1).value),E.push($e)}return E}var wo=Array.prototype.toReversed??function(){return[...this].reverse()},Oo=X("toReversed",function(){if(Array.isArray(this))return wo}),En=Oo;function Po(){let D=globalThis,E=D.process?.platform;if(typeof E=="string")return E.startsWith("win");let F=D.Deno?.build?.os;return typeof F=="string"?F==="windows":D.navigator?.platform?.startsWith("Win")??!1}var So=Po();function Cn(D){if(D=D instanceof URL?D:new URL(D),D.protocol!=="file:")throw new TypeError(`URL must be a file URL: received "${D.protocol}"`);return D}function bo(D){return D=Cn(D),decodeURIComponent(D.pathname.replace(/%(?![0-9A-Fa-f]{2})/g,"%25"))}function ko(D){D=Cn(D);let E=decodeURIComponent(D.pathname.replace(/\\//g,"\\\\").replace(/%(?![0-9A-Fa-f]{2})/g,"%25")).replace(/^\\\\*([A-Za-z]:)(\\\\|$)/,"$1\\\\");return D.hostname!==""&&(E=`\\\\\\\\${D.hostname}${E}`),E}function Vt(D){return So?ko(D):bo(D)}var hn=D=>String(D).split(/[/\\\\]/).pop(),gn=D=>String(D).startsWith("file:");function _n(D,E){if(!E)return;let F=hn(E).toLowerCase();return D.find(({filenames:J})=>J?.some($e=>$e.toLowerCase()===F))??D.find(({extensions:J})=>J?.some($e=>F.endsWith($e)))}function Io(D,E){if(E)return D.find(({name:F})=>F.toLowerCase()===E)??D.find(({aliases:F})=>F?.includes(E))??D.find(({extensions:F})=>F?.includes(`.${E}`))}var Ro=void 0;function yn(D,E){if(E){if(gn(E))try{E=Vt(E)}catch{return}if(typeof E=="string")return D.find(({isSupported:F})=>F?.({filepath:E}))}}function vo(D,E){let F=En(0,D.plugins).flatMap(J=>J.languages??[]);return(Io(F,E.language)??_n(F,E.physicalFile)??_n(F,E.file)??yn(F,E.physicalFile)??yn(F,E.file)??Ro?.(F,E.physicalFile))?.parsers[0]}var st=vo,ie={key:D=>/^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(D)?D:JSON.stringify(D),value(D){if(D===null||typeof D!="object")return JSON.stringify(D);if(Array.isArray(D))return`[${D.map(F=>ie.value(F)).join(", ")}]`;let E=Object.keys(D);return E.length===0?"{}":`{ ${E.map(F=>`${ie.key(F)}: ${ie.value(D[F])}`).join(", ")} }`},pair:({key:D,value:E})=>ie.value({[D]:E})},An=new Proxy(String,{get:()=>An}),z=An,xn=(D,E,{descriptor:F})=>{let J=[`${z.yellow(typeof D=="string"?F.key(D):F.pair(D))} is deprecated`];return E&&J.push(`we now treat it as ${z.blue(typeof E=="string"?F.key(E):F.pair(E))}`),J.join("; ")+"."},Dt=Symbol.for("vnopts.VALUE_NOT_EXIST"),Ae=Symbol.for("vnopts.VALUE_UNCHANGED"),Bn=" ".repeat(2),Nn=(D,E,F)=>{let{text:J,list:$e}=F.normalizeExpectedResult(F.schemas[D].expected(F)),_t=[];return J&&_t.push(Tn(D,E,J,F.descriptor)),$e&&_t.push([Tn(D,E,$e.title,F.descriptor)].concat($e.values.map(lr=>wn(lr,F.loggerPrintWidth))).join(`\n`)),On(_t,F.loggerPrintWidth)};function Tn(D,E,F,J){return[`Invalid ${z.red(J.key(D))} value.`,`Expected ${z.blue(F)},`,`but received ${E===Dt?z.gray("nothing"):z.red(J.value(E))}.`].join(" ")}function wn({text:D,list:E},F){let J=[];return D&&J.push(`- ${z.blue(D)}`),E&&J.push([`- ${z.blue(E.title)}:`].concat(E.values.map($e=>wn($e,F-Bn.length).replace(/^|\\n/g,`$&${Bn}`))).join(`\n`)),On(J,F)}function On(D,E){if(D.length===1)return D[0];let[F,J]=D,[$e,_t]=D.map(lr=>lr.split(`\n`,1)[0].length);return $e>E&&$e>_t?J:F}var xe=[],Wt=[];function at$1(D,E,F){if(D===E)return 0;let J=F?.maxDistance,$e=D;D.length>E.length&&(D=E,E=$e);let _t=D.length,lr=E.length;for(;_t>0&&D.charCodeAt(~-_t)===E.charCodeAt(~-lr);)_t--,lr--;let mr=0;for(;mr<_t&&D.charCodeAt(mr)===E.charCodeAt(mr);)mr++;if(_t-=mr,lr-=mr,J!==void 0&&lr-_t>J)return J;if(_t===0)return J!==void 0&&lr>J?J:lr;let Or,Pr,dn,gi,qi=0,zi=0;for(;qi<_t;)Wt[qi]=D.charCodeAt(mr+qi),xe[qi]=++qi;for(;zi<lr;){for(Or=E.charCodeAt(mr+zi),dn=zi++,Pr=zi,qi=0;qi<_t;qi++)gi=Or===Wt[qi]?dn:dn+1,dn=xe[qi],Pr=xe[qi]=dn>Pr?gi>Pr?Pr+1:gi:gi>dn?dn+1:gi;if(J!==void 0){let Hi=Pr;for(qi=0;qi<_t;qi++)xe[qi]<Hi&&(Hi=xe[qi]);if(Hi>J)return J}}return xe.length=_t,Wt.length=_t,J!==void 0&&Pr>J?J:Pr}function Pn(D,E,F){if(!Array.isArray(E)||E.length===0)return;let J=F?.maxDistance,$e=D.length;for(let Or of E)if(Or===D)return Or;let _t,lr=Number.POSITIVE_INFINITY,mr=new Set;for(let Or of E){if(mr.has(Or))continue;mr.add(Or);let Pr=Math.abs(Or.length-$e);if(Pr>=lr||Pr>J)continue;let dn=Number.isFinite(lr)?Math.min(lr,J):J,gi=dn===void 0?at$1(D,Or):at$1(D,Or,{maxDistance:dn});if(gi>J)continue;let qi=gi;if(dn!==void 0&&gi===dn&&dn===J&&(qi=at$1(D,Or)),qi<lr&&(lr=qi,_t=Or,lr===0))break}if(!(lr>J))return _t}var ct=(D,E,{descriptor:F,logger:J,schemas:$e})=>{let _t=[`Ignored unknown option ${z.yellow(F.pair({key:D,value:E}))}.`],lr=Pn(D,Object.keys($e),{maxDistance:3});lr&&_t.push(`Did you mean ${z.blue(F.key(lr))}?`),J.warn(_t.join(" "))},Lo=["default","expected","validate","deprecated","forward","redirect","overlap","preprocess","postprocess"];function Mo(D,E){let F=new D(E),J=Object.create(F);for(let $e of Lo)$e in E&&(J[$e]=Yo(E[$e],F,O.prototype[$e].length));return J}var O=class{static create(D){return Mo(this,D)}constructor(D){this.name=D.name}default(D){}expected(D){return"nothing"}validate(D,E){return!1}deprecated(D,E){return!1}forward(D,E){}redirect(D,E){}overlap(D,E,F){return D}preprocess(D,E){return D}postprocess(D,E){return Ae}};function Yo(D,E,F){return typeof D=="function"?(...J)=>D(...J.slice(0,F-1),E,...J.slice(F-1)):()=>D}var ft=class extends O{constructor(D){super(D),this._sourceName=D.sourceName}expected(D){return D.schemas[this._sourceName].expected(D)}validate(D,E){return E.schemas[this._sourceName].validate(D,E)}redirect(D,E){return this._sourceName}},lt=class extends O{expected(){return"anything"}validate(){return!0}},pt=class extends O{constructor({valueSchema:D,name:E=D.name,...F}){super({...F,name:E}),this._valueSchema=D}expected(D){let{text:E,list:F}=D.normalizeExpectedResult(this._valueSchema.expected(D));return{text:E&&`an array of ${E}`,list:F&&{title:"an array of the following values",values:[{list:F}]}}}validate(D,E){if(!Array.isArray(D))return!1;let F=[];for(let J of D){let $e=E.normalizeValidateResult(this._valueSchema.validate(J,E),J);$e!==!0&&F.push($e.value)}return F.length===0?!0:{value:F}}deprecated(D,E){let F=[];for(let J of D){let $e=E.normalizeDeprecatedResult(this._valueSchema.deprecated(J,E),J);$e!==!1&&F.push(...$e.map(({value:_t})=>({value:[_t]})))}return F}forward(D,E){let F=[];for(let J of D){let $e=E.normalizeForwardResult(this._valueSchema.forward(J,E),J);F.push(...$e.map(Sn))}return F}redirect(D,E){let F=[],J=[];for(let $e of D){let _t=E.normalizeRedirectResult(this._valueSchema.redirect($e,E),$e);"remain"in _t&&F.push(_t.remain),J.push(..._t.redirect.map(Sn))}return F.length===0?{redirect:J}:{redirect:J,remain:F}}overlap(D,E){return D.concat(E)}};function Sn({from:D,to:E}){return{from:[D],to:E}}var mt=class extends O{expected(){return"true or false"}validate(D){return typeof D=="boolean"}};function kn(D,E){let F=Object.create(null);for(let J of D){let $e=J[E];if(F[$e])throw new Error(`Duplicate ${E} ${JSON.stringify($e)}`);F[$e]=J}return F}function In(D,E){let F=new Map;for(let J of D){let $e=J[E];if(F.has($e))throw new Error(`Duplicate ${E} ${JSON.stringify($e)}`);F.set($e,J)}return F}function Rn(){let D=Object.create(null);return E=>{let F=JSON.stringify(E);return D[F]?!0:(D[F]=!0,!1)}}function vn(D,E){let F=[],J=[];for(let $e of D)E($e)?F.push($e):J.push($e);return[F,J]}function Ln(D){return D===Math.floor(D)}function Mn(D,E){if(D===E)return 0;let F=typeof D,J=typeof E,$e=["undefined","object","boolean","number","string"];return F!==J?$e.indexOf(F)-$e.indexOf(J):F!=="string"?Number(D)-Number(E):D.localeCompare(E)}function Yn(D){return(...E)=>{let F=D(...E);return typeof F=="string"?new Error(F):F}}function $t(D){return D===void 0?{}:D}function zt(D){if(typeof D=="string")return{text:D};let{text:E,list:F}=D;return jo((E||F)!==void 0,"Unexpected `expected` result, there should be at least one field."),F?{text:E,list:{title:F.title,values:F.values.map(zt)}}:{text:E}}function Gt(D,E){return D===!0?!0:D===!1?{value:E}:D}function Kt(D,E,F=!1){return D===!1?!1:D===!0?F?!0:[{value:E}]:"value"in D?[D]:D.length===0?!1:D}function bn(D,E){return typeof D=="string"||"key"in D?{from:E,to:D}:"from"in D?{from:D.from,to:D.to}:{from:E,to:D.to}}function dt(D,E){return D===void 0?[]:Array.isArray(D)?D.map(F=>bn(F,E)):[bn(D,E)]}function Ht(D,E){let F=dt(typeof D=="object"&&"redirect"in D?D.redirect:D,E);return F.length===0?{remain:E,redirect:F}:typeof D=="object"&&"remain"in D?{remain:D.remain,redirect:F}:{redirect:F}}function jo(D,E){if(!D)throw new Error(E)}var Ft=class extends O{constructor(D){super(D),this._choices=In(D.choices.map(E=>E&&typeof E=="object"?E:{value:E}),"value")}expected({descriptor:D}){let E=Array.from(this._choices.keys()).map($e=>this._choices.get($e)).filter(({hidden:$e})=>!$e).map($e=>$e.value).sort(Mn).map(D.value),F=E.slice(0,-2),J=E.slice(-2);return{text:F.concat(J.join(" or ")).join(", "),list:{title:"one of the following values",values:E}}}validate(D){return this._choices.has(D)}deprecated(D){let E=this._choices.get(D);return E&&E.deprecated?{value:D}:!1}forward(D){let E=this._choices.get(D);return E?E.forward:void 0}redirect(D){let E=this._choices.get(D);return E?E.redirect:void 0}},Et=class extends O{expected(){return"a number"}validate(D,E){return typeof D=="number"}},Ct=class extends Et{expected(){return"an integer"}validate(D,E){return E.normalizeValidateResult(super.validate(D,E),D)===!0&&Ln(D)}},Ye=class extends O{expected(){return"a string"}validate(D){return typeof D=="string"}},jn=ie,Un=ct,Vn=Nn,Wn=xn,ht=class{constructor(D,E){let{logger:F=console,loggerPrintWidth:J=80,descriptor:$e=jn,unknown:_t=Un,invalid:lr=Vn,deprecated:mr=Wn,missing:Or=()=>!1,required:Pr=()=>!1,preprocess:dn=qi=>qi,postprocess:gi=()=>Ae}=E||{};this._utils={descriptor:$e,logger:F||{warn:()=>{}},loggerPrintWidth:J,schemas:kn(D,"name"),normalizeDefaultResult:$t,normalizeExpectedResult:zt,normalizeDeprecatedResult:Kt,normalizeForwardResult:dt,normalizeRedirectResult:Ht,normalizeValidateResult:Gt},this._unknownHandler=_t,this._invalidHandler=Yn(lr),this._deprecatedHandler=mr,this._identifyMissing=(qi,zi)=>!(qi in zi)||Or(qi,zi),this._identifyRequired=Pr,this._preprocess=dn,this._postprocess=gi,this.cleanHistory()}cleanHistory(){this._hasDeprecationWarned=Rn()}normalize(D){let E={},F=[this._preprocess(D,this._utils)],J=()=>{for(;F.length!==0;){let $e=F.shift(),_t=this._applyNormalization($e,E);F.push(..._t)}};J();for(let $e of Object.keys(this._utils.schemas)){let _t=this._utils.schemas[$e];if(!($e in E)){let lr=$t(_t.default(this._utils));"value"in lr&&F.push({[$e]:lr.value})}}J();for(let $e of Object.keys(this._utils.schemas)){if(!($e in E))continue;let _t=this._utils.schemas[$e],lr=E[$e],mr=_t.postprocess(lr,this._utils);mr!==Ae&&(this._applyValidation(mr,$e,_t),E[$e]=mr)}return this._applyPostprocess(E),this._applyRequiredCheck(E),E}_applyNormalization(D,E){let F=[],{knownKeys:J,unknownKeys:$e}=this._partitionOptionKeys(D);for(let _t of J){let lr=this._utils.schemas[_t],mr=lr.preprocess(D[_t],this._utils);this._applyValidation(mr,_t,lr);let Or=({from:gi,to:qi})=>{F.push(typeof qi=="string"?{[qi]:gi}:{[qi.key]:qi.value})},Pr=({value:gi,redirectTo:qi})=>{let zi=Kt(lr.deprecated(gi,this._utils),mr,!0);if(zi!==!1)if(zi===!0)this._hasDeprecationWarned(_t)||this._utils.logger.warn(this._deprecatedHandler(_t,qi,this._utils));else for(let{value:Hi}of zi){let Qi={key:_t,value:Hi};if(!this._hasDeprecationWarned(Qi)){let Gi=typeof qi=="string"?{key:qi,value:Hi}:qi;this._utils.logger.warn(this._deprecatedHandler(Qi,Gi,this._utils))}}};dt(lr.forward(mr,this._utils),mr).forEach(Or);let dn=Ht(lr.redirect(mr,this._utils),mr);if(dn.redirect.forEach(Or),"remain"in dn){let gi=dn.remain;E[_t]=_t in E?lr.overlap(E[_t],gi,this._utils):gi,Pr({value:gi})}for(let{from:gi,to:qi}of dn.redirect)Pr({value:gi,redirectTo:qi})}for(let _t of $e){let lr=D[_t];this._applyUnknownHandler(_t,lr,E,(mr,Or)=>{F.push({[mr]:Or})})}return F}_applyRequiredCheck(D){for(let E of Object.keys(this._utils.schemas))if(this._identifyMissing(E,D)&&this._identifyRequired(E))throw this._invalidHandler(E,Dt,this._utils)}_partitionOptionKeys(D){let[E,F]=vn(Object.keys(D).filter(J=>!this._identifyMissing(J,D)),J=>J in this._utils.schemas);return{knownKeys:E,unknownKeys:F}}_applyValidation(D,E,F){let J=Gt(F.validate(D,this._utils),D);if(J!==!0)throw this._invalidHandler(E,J.value,this._utils)}_applyUnknownHandler(D,E,F,J){let $e=this._unknownHandler(D,E,this._utils);if($e)for(let _t of Object.keys($e)){if(this._identifyMissing(_t,$e))continue;let lr=$e[_t];_t in this._utils.schemas?J(_t,lr):F[_t]=lr}}_applyPostprocess(D){let E=this._postprocess(D,this._utils);if(E!==Ae){if(E.delete)for(let F of E.delete)delete D[F];if(E.override){let{knownKeys:F,unknownKeys:J}=this._partitionOptionKeys(E.override);for(let $e of F){let _t=E.override[$e];this._applyValidation(_t,$e,this._utils.schemas[$e]),D[$e]=_t}for(let $e of J){let _t=E.override[$e];this._applyUnknownHandler($e,_t,D,(lr,mr)=>{let Or=this._utils.schemas[lr];this._applyValidation(mr,lr,Or),D[lr]=mr})}}}}},Jt;function Uo(D,E,{logger:F=!1,isCLI:J=!1,passThrough:$e=!1,FlagSchema:_t,descriptor:lr}={}){if(J){if(!_t)throw new Error("\'FlagSchema\' option is required.");if(!lr)throw new Error("\'descriptor\' option is required.")}else lr=ie;let mr=$e?Array.isArray($e)?(qi,zi)=>$e.includes(qi)?{[qi]:zi}:void 0:(qi,zi)=>({[qi]:zi}):(qi,zi,Hi)=>{let{_:Qi,...Gi}=Hi.schemas;return ct(qi,zi,{...Hi,schemas:Gi})},Or=Vo(E,{isCLI:J,FlagSchema:_t}),Pr=new ht(Or,{logger:F,unknown:mr,descriptor:lr}),dn=F!==!1;dn&&Jt&&(Pr._hasDeprecationWarned=Jt);let gi=Pr.normalize(D);return dn&&(Jt=Pr._hasDeprecationWarned),gi}function Vo(D,{isCLI:E,FlagSchema:F}){let J=[];E&&J.push(lt.create({name:"_"}));for(let $e of D)J.push(Wo($e,{isCLI:E,optionInfos:D,FlagSchema:F})),$e.alias&&E&&J.push(ft.create({name:$e.alias,sourceName:$e.name}));return J}function Wo(D,{isCLI:E,optionInfos:F,FlagSchema:J}){let{name:$e}=D,_t={name:$e},lr,mr={};switch(D.type){case"int":lr=Ct,E&&(_t.preprocess=Number);break;case"string":lr=Ye;break;case"choice":lr=Ft,_t.choices=D.choices.map(Or=>Or?.redirect?{...Or,redirect:{to:{key:D.name,value:Or.redirect}}}:Or);break;case"boolean":lr=mt;break;case"flag":lr=J,_t.flags=F.flatMap(Or=>[Or.alias,Or.description&&Or.name,Or.oppositeDescription&&`no-${Or.name}`].filter(Boolean));break;case"path":lr=Ye;break;default:throw new Error(`Unexpected type ${D.type}`)}if(D.exception?_t.validate=(Or,Pr,dn)=>D.exception(Or)||Pr.validate(Or,dn):_t.validate=(Or,Pr,dn)=>Or===void 0||Pr.validate(Or,dn),D.redirect&&(mr.redirect=Or=>Or?{to:typeof D.redirect=="string"?D.redirect:{key:D.redirect.option,value:D.redirect.value}}:void 0),D.deprecated&&(mr.deprecated=!0),E&&!D.array){let Or=_t.preprocess||(Pr=>Pr);_t.preprocess=(Pr,dn,gi)=>dn.preprocess(Or(Array.isArray(Pr)?y$1(0,Pr,-1):Pr),gi)}return D.array?pt.create({...E?{preprocess:Or=>Array.isArray(Or)?Or:[Or]}:{},...mr,valueSchema:lr.create(_t)}):lr.create({..._t,...mr})}var $n=Uo,$o=Array.prototype.findLast??function(D){for(let E=this.length-1;E>=0;E--){let F=this[E];if(D(F,E,this))return F}},zo=X("findLast",function(){if(Array.isArray(this))return $o}),qt=zo,zn=Symbol.for("PRETTIER_IS_FRONT_MATTER"),Xt=[];function Go(D){return!!D?.[zn]}var pe=Go,Gn=new Set(["yaml","toml"]),je=({node:D})=>pe(D)&&Gn.has(D.language);async function Qt(D,E,F,J){let{node:$e}=F,{language:_t}=$e;if(!Gn.has(_t))return;let lr=$e.value.trim(),mr;if(lr){let Or=_t==="yaml"?_t:st(J,{language:_t});if(!Or)return;mr=lr?await D(lr,{parser:Or}):""}else mr=lr;return Xe([$e.startDelimiter,$e.explicitLanguage??"",W,mr,mr?W:"",$e.endDelimiter])}function Ko(D,E){return je({node:D})&&(delete E.end,delete E.raw,delete E.value),E}var Zt=Ko;function Ho({node:D}){return D.raw}var er=Ho,Kn=new Set(["tokens","comments","parent","enclosingNode","precedingNode","followingNode"]),Jo=D=>Object.keys(D).filter(E=>!Kn.has(E));function qo(D,E){let F=D?J=>D(J,Kn):Jo;return E?new Proxy(F,{apply:(J,$e,_t)=>pe(_t[0])?Xt:Reflect.apply(J,$e,_t)}):F}var tr=qo;function rr(D,E){if(!E)throw new Error("parserName is required.");let F=qt(0,D,$e=>$e.parsers&&le($e.parsers,E));if(F)return F;let J=`Couldn\'t resolve parser "${E}".`;throw J+=" Plugins must be explicitly added to the standalone bundle.",new Le(J)}function Hn(D,E){if(!E)throw new Error("astFormat is required.");let F=qt(0,D,$e=>$e.printers&&le($e.printers,E));if(F)return F;let J=`Couldn\'t find plugin for AST format "${E}".`;throw J+=" Plugins must be explicitly added to the standalone bundle.",new Le(J)}function Ue({plugins:D,parser:E}){let F=rr(D,E);return nr(F,E)}function nr(D,E){let F=D.parsers[E];return typeof F=="function"?F():F}async function Jn(D,E){let F=D.printers[E],J=typeof F=="function"?await F():F;return Zo(J)}function Xo(D){let{features:E,getVisitorKeys:F,embed:J,massageAstNode:$e,print:_t,...lr}=D;E=ni(E);let mr=E.experimental_frontMatterSupport;F=tr(F,mr.massageAstNode||mr.embed||mr.print);let Or=$e;$e&&mr.massageAstNode&&(Or=new Proxy($e,{apply(gi,qi,zi){return Zt(...zi),Reflect.apply(gi,qi,zi)}}));let Pr=J;if(J){let gi;Pr=new Proxy(J,{get(qi,zi,Hi){return zi==="getVisitorKeys"?(gi??(gi=J.getVisitorKeys?tr(J.getVisitorKeys,mr.massageAstNode||mr.embed):F),gi):Reflect.get(qi,zi,Hi)},apply:(qi,zi,Hi)=>mr.embed&&je(...Hi)?Qt:Reflect.apply(qi,zi,Hi)})}let dn=_t;return mr.print&&(dn=new Proxy(_t,{apply(gi,qi,zi){let[Hi]=zi;return pe(Hi.node)?er(Hi):Reflect.apply(gi,qi,zi)}})),{features:E,getVisitorKeys:F,embed:Pr,massageAstNode:Or,print:dn,...lr}}var Qo=new WeakMap;function Zo(D){return Fe(Qo,D,Xo)}var ei=["clean","embed","print"],ti=Object.fromEntries(ei.map(D=>[D,!1]));function ri(D){return{...ti,...D}}function ni(D){return{experimental_avoidAstMutation:!1,...D,experimental_frontMatterSupport:ri(D?.experimental_frontMatterSupport)}}var qn={astFormat:"estree",printer:{},originalText:void 0,locStart:null,locEnd:null,getVisitorKeys:null};async function ui(D,E={}){let F={...D};if(!F.parser){if(!F.filepath)throw new Me("No parser and no file path given, couldn\'t infer a parser.");if(F.parser=st(F,{physicalFile:F.filepath}),!F.parser)throw new Me(`No parser could be inferred for file "${F.filepath}".`)}let J=it({plugins:D.plugins,showDeprecated:!0}).options,$e={...qn,...Object.fromEntries(J.filter(gi=>gi.default!==void 0).map(gi=>[gi.name,gi.default]))},_t=rr(F.plugins,F.parser),lr=await nr(_t,F.parser);F.astFormat=lr.astFormat,F.locEnd=lr.locEnd,F.locStart=lr.locStart;let mr=_t.printers?.[lr.astFormat]?_t:Hn(F.plugins,lr.astFormat),Or=await Jn(mr,lr.astFormat);F.printer=Or,F.getVisitorKeys=Or.getVisitorKeys;let Pr=mr.defaultOptions?Object.fromEntries(Object.entries(mr.defaultOptions).filter(([,gi])=>gi!==void 0)):{},dn={...$e,...Pr};for(let[gi,qi]of Object.entries(dn))F[gi]??(F[gi]=qi);return F.parser==="json"&&(F.trailingComma="none"),$n(F,J,{passThrough:Object.keys(qn),...E})}var se=ui,Xn=/\\r\\n|[\\n\\r\\u2028\\u2029]/;function oi(D,E,F,J){let $e={column:null,line:-1,...D.start},_t={...$e,...D.end},{linesAbove:lr=2,linesBelow:mr=3}=F||{},Or=$e.line-J,Pr=$e.column,dn=_t.line-J,gi=_t.column,qi=Math.max(Or-(lr+1),0),zi=Math.min(E.length,dn+mr);Or===-1&&(qi=0),dn===-1&&(zi=E.length);let Hi=dn-Or,Qi={};if(Hi)for(let Gi=0;Gi<=Hi;Gi++){let Zi=Gi+Or;if(Pr==null)Qi[Zi]=!0;else if(Gi===0){let Xi=E[Zi-1].length;Qi[Zi]=[Pr,Xi-Pr]}else if(Gi===Hi)Qi[Zi]=[0,gi];else{let Xi=E[Zi-1].length;Qi[Zi]=[0,Xi]}}else if(Pr===gi)Pr!=null?Qi[Or]=[Pr,0]:Qi[Or]=!0;else{let Gi=Pr??0,Zi=gi??Gi;Qi[Or]=[Gi,Zi-Gi]}return{start:qi,end:zi,markerLines:Qi}}function Qn(D,E,F={},J){let{defs:$e,highlight:_t}={defs:{gutter:String,marker:String,message:String,reset:String},highlight:String},lr=(F.startLine||1)-1,mr=D.split(Xn),{start:Or,end:Pr,markerLines:dn}=oi(E,mr,F,lr),gi=E.start&&typeof E.start.column=="number",qi=String(Pr+lr).length,zi=_t(D).split(Xn,Pr).slice(Or,Pr).map((Hi,Qi)=>{let Gi=Or+1+Qi,Zi=` ${` ${Gi+lr}`.slice(-qi)} |`,Xi=dn[Gi],Ki=!dn[Gi+1];if(Xi){let ea="";if(Array.isArray(Xi)){let Ji=Hi.slice(0,Xi[0]).replace(/[^\\t]/g," "),ta=Xi[1]||1;ea=[`\n `,$e.gutter(Zi.replace(/\\d/g," "))," ",Ji,$e.marker("^").repeat(ta)].join(""),Ki&&F.message&&(ea+=" "+$e.message(F.message))}return[$e.marker(">"),$e.gutter(Zi),Hi.length>0?` ${Hi}`:"",ea].join("")}else return` ${$e.gutter(Zi)}${Hi.length>0?` ${Hi}`:""}`}).join(`\n`);return F.message&&!gi&&(zi=`${" ".repeat(qi+1)}${F.message}\n${zi}`),$e.reset(zi)}function Zn(D,E,F={}){return Qn(D,E,F)}async function ii(D,E){let F=await Ue(E),J=F.preprocess?await F.preprocess(D,E):D;E.originalText=J;let $e;try{$e=await F.parse(J,E,E)}catch(_t){si(_t,D)}return{text:J,ast:$e}}function si(D,E){let{loc:F}=D;if(F){let{start:J,end:$e}=F;J&&(J={line:J.line,column:J.column-1}),$e&&($e={line:$e.line,column:$e.column-1});let _t=Zn(E,{start:J,end:$e},{});D.message+=`\n`+_t,D.codeFrame=_t}throw D}var me=ii;async function eu(D,E,F,J,$e){if(F.embeddedLanguageFormatting!=="auto")return;let{printer:_t}=F,{embed:lr}=_t;if(!lr)return;if(lr.length>2)throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/plugins#optional-embed");let{hasPrettierIgnore:mr}=_t,{getVisitorKeys:Or}=lr,Pr=[];qi();let dn=D.stack;for(let{print:zi,node:Hi,pathStack:Qi}of Pr)try{D.stack=Qi;let Gi=await zi(gi,E,D,F);Gi&&$e.set(Hi,Gi)}catch(Gi){if(globalThis.PRETTIER_DEBUG)throw Gi}D.stack=dn;function gi(zi,Hi){return Di(zi,Hi,F,J)}function qi(){let{node:zi}=D;if(zi===null||typeof zi!="object"||mr?.(D))return;for(let Qi of Or(zi))Array.isArray(zi[Qi])?D.each(qi,Qi):D.call(qi,Qi);let Hi=lr(D,F);if(Hi){if(typeof Hi=="function"){Pr.push({print:Hi,node:zi,pathStack:[...D.stack]});return}$e.set(zi,Hi)}}}async function Di(D,E,F,J){let $e=await se({...F,...E,parentParser:F.parser,originalText:D,cursorOffset:void 0,rangeStart:void 0,rangeEnd:void 0},{passThrough:!0}),{ast:_t}=await me(D,$e),lr=await J(_t,$e);return He(lr)}function ai(D,E,F,J){let{originalText:$e,[ue]:_t,locStart:lr,locEnd:mr,[Symbol.for("printedComments")]:Or}=E,{node:Pr}=D,dn=lr(Pr),gi=mr(Pr);for(let zi of _t)lr(zi)>=dn&&mr(zi)<=gi&&Or.add(zi);let{printPrettierIgnored:qi}=E.printer;return qi?qi(D,E,F,J):$e.slice(dn,gi)}var tu=ai;async function Ve(D,E){({ast:D}=await ur(D,E));let F=new Map,J=new en(D),$e=new Map;await eu(J,lr,E,Ve,$e);let _t=await ru(J,E,lr,void 0,$e);if(mn(E),E.cursorOffset>=0){if(E.nodeAfterCursor&&!E.nodeBeforeCursor)return[ee,_t];if(E.nodeBeforeCursor&&!E.nodeAfterCursor)return[_t,ee]}return _t;function lr(Or,Pr){return Or===void 0||Or===J?mr(Pr):Array.isArray(Or)?J.call(()=>mr(Pr),...Or):J.call(()=>mr(Pr),Or)}function mr(Or){let Pr=J.node;if(Pr==null)return"";let dn=ge(Pr)&&Or===void 0;if(dn&&F.has(Pr))return F.get(Pr);let gi=ru(J,E,lr,Or,$e);return dn&&F.set(Pr,gi),gi}}function ru(D,E,F,J,$e){let{node:_t}=D,{printer:lr}=E,mr;switch(lr.hasPrettierIgnore?.(D)?mr=tu(D,E,F,J):$e.has(_t)?mr=$e.get(_t):mr=lr.print(D,E,F,J),_t){case E.cursorNode:mr=Ee(mr,Or=>[ee,Or,ee]);break;case E.nodeBeforeCursor:mr=Ee(mr,Or=>[Or,ee]);break;case E.nodeAfterCursor:mr=Ee(mr,Or=>[ee,Or]);break}return lr.printComment&&rt(_t.comments)&&!lr.willPrintOwnComments?.(D,E)&&(mr=pn(D,mr,E)),mr}async function ur(D,E){let F=D.comments??[];E[ue]=F,E[Symbol.for("printedComments")]=new Set,an(D,E);let{printer:{preprocess:J}}=E;return D=J?await J(D,E):D,{ast:D,comments:F}}function ci(D,E){let{cursorOffset:F,locStart:J,locEnd:$e,getVisitorKeys:_t}=E,lr=zi=>J(zi)<=F&&$e(zi)>=F,mr=D,Or=[D];for(let zi of nn(D,{getVisitorKeys:_t,filter:lr}))Or.push(zi),mr=zi;if(un(mr,{getVisitorKeys:_t}))return{cursorNode:mr};let Pr,dn,gi=-1,qi=Number.POSITIVE_INFINITY;for(;Or.length>0&&(Pr===void 0||dn===void 0);){mr=Or.pop();let zi=Pr!==void 0,Hi=dn!==void 0;for(let Qi of ye(mr,{getVisitorKeys:_t})){if(!zi){let Gi=$e(Qi);Gi<=F&&Gi>gi&&(Pr=Qi,gi=Gi)}if(!Hi){let Gi=J(Qi);Gi>=F&&Gi<qi&&(dn=Qi,qi=Gi)}}}return{nodeBeforeCursor:Pr,nodeAfterCursor:dn}}var or=ci;function fi(D,E){let{printer:F}=E,J=F.massageAstNode;if(!J)return D;let{getVisitorKeys:$e}=F,{ignoredProperties:_t}=J;return lr(D);function lr(mr,Or){if(!ge(mr))return mr;if(Array.isArray(mr))return mr.map(qi=>lr(qi,Or)).filter(Boolean);let Pr={},dn=new Set($e(mr));for(let qi in mr)!le(mr,qi)||_t?.has(qi)||(dn.has(qi)?Pr[qi]=lr(mr[qi],mr):Pr[qi]=mr[qi]);let gi=J(mr,Pr,Or);if(gi!==null)return gi??Pr}}var nu=fi,li=Array.prototype.findLastIndex??function(D){for(let E=this.length-1;E>=0;E--){let F=this[E];if(D(F,E,this))return E}return-1},pi$1=X("findLastIndex",function(){if(Array.isArray(this))return li}),uu=pi$1;function mi(D,E){return E=new Set(E),D.find(F=>su.has(F.type)&&E.has(F))}function ou(D){let E=uu(0,D,F=>F.type!=="Program"&&F.type!=="File");return E===-1?D:D.slice(0,E+1)}function di(D,E,{locStart:F,locEnd:J}){let[$e,..._t]=D,[lr,...mr]=E;if($e===lr)return[$e,lr];let Or=F($e);for(let dn of ou(mr))if(F(dn)>=Or)lr=dn;else break;let Pr=J(lr);for(let dn of ou(_t)){if(J(dn)<=Pr)$e=dn;else break;if($e===lr)break}return[$e,lr]}function ir(D,E,F,J,$e=[],_t,lr){let{locStart:mr,locEnd:Or}=lr,Pr=mr(D),dn=Or(D);if(E>dn||E<Pr||_t==="rangeEnd"&&E===Pr||_t==="rangeStart"&&E===dn)return;let gi=[D,...$e],qi=ot(D,gi,{cache:Ut,locStart:mr,locEnd:Or,getVisitorKeys:F.getVisitorKeys,filter:F.printer.canAttachComment,getChildren:F.printer.getCommentChildNodes});for(let zi of qi){let Hi=ir(zi,E,F,J,gi,_t,lr);if(Hi)return Hi}if(J(D,$e[0]))return gi}function Fi(D,E){return E!=="DeclareExportDeclaration"&&D!=="TypeParameterDeclaration"&&(D==="Directive"||D==="TypeAlias"||D==="TSExportAssignment"||D.startsWith("Declare")||D.startsWith("TSDeclare")||D.endsWith("Statement")||D.endsWith("Declaration"))}var su=new Set(["JsonRoot","ObjectExpression","ArrayExpression","StringLiteral","NumericLiteral","BooleanLiteral","NullLiteral","UnaryExpression","TemplateLiteral"]),Ei=new Set(["OperationDefinition","FragmentDefinition","VariableDefinition","TypeExtensionDefinition","ObjectTypeDefinition","FieldDefinition","DirectiveDefinition","EnumTypeDefinition","EnumValueDefinition","InputValueDefinition","InputObjectTypeDefinition","SchemaDefinition","OperationTypeDefinition","InterfaceTypeDefinition","UnionTypeDefinition","ScalarTypeDefinition"]);function iu(D,E,F){if(!E)return!1;switch(D.parser){case"flow":case"hermes":case"babel":case"babel-flow":case"babel-ts":case"typescript":case"acorn":case"espree":case"meriyah":case"oxc":case"oxc-ts":case"__babel_estree":return Fi(E.type,F?.type);case"json":case"json5":case"jsonc":case"json-stringify":return su.has(E.type);case"graphql":return Ei.has(E.kind);case"vue":return E.tag!=="root"}return!1}function Du(D,E,F){let{rangeStart:J,rangeEnd:$e}=E,_t=D.slice(J,$e).search(/\\S/),lr=_t===-1;if(!lr)for(J+=_t;$e>J&&!/\\S/.test(D[$e-1]);--$e);let mr=E.printer.features?.experimental_locForRangeFormat??E,Or=ir(F,J,E,(Hi,Qi)=>iu(E,Hi,Qi),[],"rangeStart",mr);if(!Or)return;let Pr=lr?Or:ir(F,$e,E,Hi=>iu(E,Hi),[],"rangeEnd",mr);if(!Pr)return;let dn,gi;if(F.type==="JsonRoot"){let Hi=mi(Or,Pr);dn=Hi,gi=Hi}else[dn,gi]=di(Or,Pr,E);let{locStart:qi,locEnd:zi}=mr;return[Math.min(qi(dn),qi(gi)),Math.max(zi(dn),zi(gi))]}var lu="\\uFEFF",au=Symbol("cursor");async function pu(D,E,F=0){if(!D||D.trim().length===0)return{formatted:"",cursorOffset:-1,comments:[]};let{ast:J,text:$e}=await me(D,E);E.cursorOffset>=0&&(E={...E,...or(J,E)});let _t=await Ve(J,E);F>0&&(_t=Qe([W,_t],F,E.tabWidth));let lr=Ce(_t,E);if(F>0){let Or=lr.formatted.trim();lr.cursorNodeStart!==void 0&&(lr.cursorNodeStart-=lr.formatted.indexOf(Or),lr.cursorNodeStart<0&&(lr.cursorNodeStart=0,lr.cursorNodeText=lr.cursorNodeText.trimStart()),lr.cursorNodeStart+lr.cursorNodeText.length>Or.length&&(lr.cursorNodeText=lr.cursorNodeText.trimEnd())),lr.formatted=Or+we(E.endOfLine)}let mr=E[ue];if(E.cursorOffset>=0){let Or,Pr,dn,gi;if((E.cursorNode||E.nodeBeforeCursor||E.nodeAfterCursor)&&lr.cursorNodeText)if(dn=lr.cursorNodeStart,gi=lr.cursorNodeText,E.cursorNode)Or=E.locStart(E.cursorNode),Pr=$e.slice(Or,E.locEnd(E.cursorNode));else{if(!E.nodeBeforeCursor&&!E.nodeAfterCursor)throw new Error("Cursor location must contain at least one of cursorNode, nodeBeforeCursor, nodeAfterCursor");Or=E.nodeBeforeCursor?E.locEnd(E.nodeBeforeCursor):0;let Zi=E.nodeAfterCursor?E.locStart(E.nodeAfterCursor):$e.length;Pr=$e.slice(Or,Zi)}else Or=0,Pr=$e,dn=0,gi=lr.formatted;let qi=E.cursorOffset-Or;if(Pr===gi)return{formatted:lr.formatted,cursorOffset:dn+qi,comments:mr};let zi=Pr.split("");zi.splice(qi,0,au);let Hi=gi.split(""),Qi=xt(zi,Hi),Gi=dn;for(let Zi of Qi)if(Zi.removed){if(Zi.value.includes(au))break}else Gi+=Zi.count;return{formatted:lr.formatted,cursorOffset:Gi,comments:mr}}return{formatted:lr.formatted,cursorOffset:-1,comments:mr}}async function Ci(D,E){let{ast:F,text:J}=await me(D,E),[$e,_t]=Du(J,E,F)??[0,0],lr=J.slice($e,_t),mr=Math.min($e,J.lastIndexOf(`\n`,$e)+1),Or=J.slice(mr,$e).match(/^\\s*/)[0],Pr=he(Or,E.tabWidth),dn=await pu(lr,{...E,rangeStart:0,rangeEnd:Number.POSITIVE_INFINITY,cursorOffset:E.cursorOffset>$e&&E.cursorOffset<=_t?E.cursorOffset-$e:-1,endOfLine:"lf"},Pr),gi=dn.formatted.trimEnd(),{cursorOffset:qi}=E;qi>_t?qi+=gi.length-lr.length:dn.cursorOffset>=0&&(qi=dn.cursorOffset+$e);let zi=J.slice(0,$e)+gi+J.slice(_t);if(E.endOfLine!=="lf"){let Hi=we(E.endOfLine);qi>=0&&Hi===`\\r\n`&&(qi+=Tt(zi.slice(0,qi),`\n`)),zi=ne(0,zi,`\n`,Hi)}return{formatted:zi,cursorOffset:qi,comments:dn.comments}}function sr(D,E,F){return typeof E!="number"||Number.isNaN(E)||E<0||E>D.length?F:E}function cu(D,E){let{cursorOffset:F,rangeStart:J,rangeEnd:$e}=E;return F=sr(D,F,-1),J=sr(D,J,0),$e=sr(D,$e,D.length),{...E,cursorOffset:F,rangeStart:J,rangeEnd:$e}}function mu(D,E){let{cursorOffset:F,rangeStart:J,rangeEnd:$e,endOfLine:_t}=cu(D,E),lr=D.charAt(0)===lu;if(lr&&(D=D.slice(1),F--,J--,$e--),_t==="auto"&&(_t=Cr(D)),D.includes("\\r")){let mr=Or=>Tt(D.slice(0,Math.max(Or,0)),`\\r\n`);F-=mr(F),J-=mr(J),$e-=mr($e),D=hr(D)}return{hasBOM:lr,text:D,options:cu(D,{...E,cursorOffset:F,rangeStart:J,rangeEnd:$e,endOfLine:_t})}}async function fu(D,E){let F=await Ue(E);return!F.hasPragma||F.hasPragma(D)}async function hi(D,E){return(await Ue(E)).hasIgnorePragma?.(D)}async function Dr(D,E){let{hasBOM:F,text:J,options:$e}=mu(D,await se(E));if($e.rangeStart>=$e.rangeEnd&&J!==""||$e.requirePragma&&!await fu(J,$e)||$e.checkIgnorePragma&&await hi(J,$e))return{formatted:D,cursorOffset:E.cursorOffset,comments:[]};let _t;return $e.rangeStart>0||$e.rangeEnd<J.length?_t=await Ci(J,$e):(!$e.requirePragma&&$e.insertPragma&&$e.printer.insertPragma&&!await fu(J,$e)&&(J=$e.printer.insertPragma(J)),_t=await pu(J,$e)),F&&(_t.formatted=lu+_t.formatted,_t.cursorOffset>=0&&_t.cursorOffset++),_t}async function du(D,E,F){let{text:J,options:$e}=mu(D,await se(E)),_t=await me(J,$e);return F&&(F.preprocessForPrint&&(_t.ast=await ur(_t.ast,$e)),F.massage&&(_t.ast=nu(_t.ast,$e))),_t}async function Fu(D,E){E=await se(E);let F=await Ve(D,E);return Ce(F,E)}async function Eu(D,E){let F=Ur(D),{formatted:J}=await Dr(F,{...E,parser:"__js_expression"});return J}async function Cu(D,E){E=await se(E);let{ast:F}=await me(D,E);return E.cursorOffset>=0&&(E={...E,...or(F,E)}),Ve(F,E)}async function hu(D,E){return Ce(D,await se(E))}var ar={};yt(ar,{builders:()=>_i,printer:()=>yi,utils:()=>Ai});var _i={join:be,line:Ze,softline:Mr,hardline:W,literalline:Je,group:wt,conditionalGroup:Ir,fill:kr,lineSuffix:Ie,lineSuffixBoundary:Yr,cursor:ee,breakParent:ae,ifBreak:Rr,trim:jr,indent:oe,indentIfBreak:vr,align:De,addAlignmentToDoc:Qe,markAsRoot:Xe,dedentToRoot:Sr,dedent:br,hardlineWithoutBreakParent:ke,literallineWithoutBreakParent:Ot,label:Lr,concat:D=>D},yi={printDocToString:Ce},Ai={willBreak:xr,traverseDoc:Oe,findInDoc:Ke,mapDoc:Se,removeLines:Tr,stripTrailingHardline:He,replaceEndOfLine:Nr,canBreak:wr},gu="3.9.4",fr={};yt(fr,{addDanglingComment:()=>re$1,addLeadingComment:()=>ce,addTrailingComment:()=>fe,getAlignmentSize:()=>he,getIndentSize:()=>_u,getMaxContinuousCount:()=>yu,getNextNonSpaceNonCommentCharacter:()=>Au,getNextNonSpaceNonCommentCharacterIndex:()=>vi,getPreferredQuote:()=>Tu,getStringWidth:()=>Re,hasNewline:()=>H$1,hasNewlineInRange:()=>Nu,hasSpaces:()=>wu,isNextLineEmpty:()=>Ui,isNextLineEmptyAfterIndex:()=>gt,isPreviousLineEmpty:()=>Mi,makeString:()=>ji,skip:()=>_e,skipEverythingButNewLine:()=>ut,skipInlineComment:()=>Be,skipNewline:()=>$$1,skipSpaces:()=>j$1,skipToLineEnd:()=>nt,skipTrailingComment:()=>Te,skipWhitespace:()=>tn});function xi(D,E){if(E===!1)return!1;if(D.charAt(E)==="/"&&D.charAt(E+1)==="*"){for(let F=E+2;F<D.length;++F)if(D.charAt(F)==="*"&&D.charAt(F+1)==="/")return F+2}return E}var Be=xi;function Bi(D,E){return E===!1?!1:D.charAt(E)==="/"&&D.charAt(E+1)==="/"?ut(D,E):E}var Te=Bi;function Ti(D,E){let F=null,J=E;for(;J!==F;)F=J,J=j$1(D,J),J=Be(D,J),J=Te(D,J),J=$$1(D,J);return J}var We=Ti;function Ni(D,E){let F=null,J=E;for(;J!==F;)F=J,J=nt(D,J),J=Be(D,J),J=j$1(D,J);return J=Te(D,J),J=$$1(D,J),J!==!1&&H$1(D,J)}var gt=Ni;function wi(D,E){let F=D.lastIndexOf(`\n`);return F===-1?0:he(D.slice(F+1).match(/^[\\t ]*/)[0],E)}var _u=wi;function cr(D){if(typeof D!="string")throw new TypeError("Expected a string");return D.replace(/[|\\\\{}()[\\]^$+*?.]/g,"\\\\$&").replace(/-/g,"\\\\x2d")}function Oi(D,E){let F=D.matchAll(new RegExp(`(?:${cr(E)})+`,"g"));return F.reduce||(F=[...F]),F.reduce((J,[$e])=>Math.max(J,$e.length),0)/E.length}var yu=Oi;function Pi(D,E){let F=We(D,E);return F===!1?"":D.charAt(F)}var Au=Pi,xu=Object.freeze({character:"\'",codePoint:39}),Bu=Object.freeze({character:\'"\',codePoint:34}),Si=Object.freeze({preferred:xu,alternate:Bu}),bi=Object.freeze({preferred:Bu,alternate:xu});function Tu(D,E){let{preferred:F,alternate:J}=E===!0||E==="\'"?Si:bi,{length:$e}=D,_t=0,lr=0;for(let mr=0;mr<$e;mr++){let Or=D.charCodeAt(mr);Or===F.codePoint?_t++:Or===J.codePoint&&lr++}return(_t>lr?J:F).character}function ki(D,E,F){for(let J=E;J<F;++J)if(D.charAt(J)===`\n`)return!0;return!1}var Nu=ki;function Ii(D,E,F={}){return j$1(D,F.backwards?E-1:E,F)!==E}var wu=Ii;function Ri(D,E,F){return We(D,F(E))}function vi(D,E){return arguments.length===2||typeof E=="number"?We(D,E):Ri(...arguments)}function Li(D,E,F){return ve(D,F(E))}function Mi(D,E){return arguments.length===2||typeof E=="number"?ve(D,E):Li(...arguments)}function Yi(D,E,F){return gt(D,F(E))}function ji(D,E,F){let J=E===\'"\'?"\'":\'"\',$e=ne(0,D,/\\\\(.)|(["\'])/gs,(_t,lr,mr)=>lr===J?lr:mr===E?"\\\\"+mr:mr||(F&&/^[^\\n\\r"\'0-7\\\\bfnrt-vx\\u2028\\u2029]$/.test(lr)?lr:"\\\\"+lr));return E+$e+E}function Ui(D,E){return arguments.length===2||typeof E=="number"?gt(D,E):Yi(...arguments)}function de(D,E=1){return async(...F)=>{let J=F[E]??{},$e=J.plugins??[];return F[E]={...J,plugins:Array.isArray($e)?$e:Object.values($e)},await D(...F)}}var Ou=de(Dr);async function Pu(D,E){let{formatted:F}=await Ou(D,{...E,cursorOffset:-1});return F}async function Vi(D,E){return await Pu(D,E)===D}var Wi=de(it,0),$i={parse:de(du),formatAST:de(Fu),formatDoc:de(Eu),printToDoc:de(Cu),printDocToString:de(hu)};const expandCdataPlugin=function(){return D=>{replaceNode(D,E=>{if(!Array.isArray(E)&&E.type==="cdata")return{type:"text",value:E.value}})}};var dist$1={},core$1={},debug$1={},hasRequiredDebug$1;function requireDebug$1(){if(hasRequiredDebug$1)return debug$1;hasRequiredDebug$1=1,Object.defineProperty(debug$1,"__esModule",{value:!0}),debug$1.getType=D,debug$1.throwUnknownDataType=E,debug$1.throwUnsupportedData=F;function D(J){return Object.prototype.toString.call(J)}function E(J){throw new TypeError("unsupported data type: "+D(J))}function F(J){throw new TypeError("unsupported data type: "+J)}return debug$1}var encode$1={},number$1={},hasRequiredNumber$1;function requireNumber$1(){if(hasRequiredNumber$1)return number$1;hasRequiredNumber$1=1,Object.defineProperty(number$1,"__esModule",{value:!0}),number$1.s_to_int=J,number$1.s_to_big_int=$e,number$1.int_to_s=_t,number$1.big_int_to_s=lr,number$1.num_to_s=Or,number$1.int_str_to_s=Pr,number$1.s_to_num=gi;let D="";for(let qi=0;qi<10;qi++){const zi=String.fromCharCode(48+qi);D+=zi}for(let qi=0;qi<26;qi++){const zi=String.fromCharCode(65+qi);D+=zi}for(let qi=0;qi<26;qi++){const zi=String.fromCharCode(97+qi);D+=zi}const E=D.length,F={};for(let qi=0;qi<E;qi++){const zi=D[qi];F[zi]=qi}function J(qi){let zi=0,Hi=1;for(let Qi=qi.length-1;Qi>=0;Qi--){const Gi=qi[Qi];let Zi=F[Gi];Zi*=Hi,zi+=Zi,Hi*=E}return zi}function $e(qi){let zi=BigInt(0),Hi=BigInt(1);const Qi=BigInt(E);for(let Gi=qi.length-1;Gi>=0;Gi--){const Zi=qi[Gi];let Xi=BigInt(F[Zi]);Xi*=Hi,zi+=Xi,Hi*=Qi}return zi}function _t(qi){if(qi===0)return D[0];const zi=[];for(;qi!==0;){const Hi=qi%E,Qi=D[Hi];zi.push(Qi),qi-=Hi,qi/=E}return zi.reverse().join("")}function lr(qi){const zi=BigInt(0),Hi=BigInt(E);if(qi===zi)return D[0];const Qi=[];for(;qi!==zi;){const Gi=qi%Hi,Zi=D[Number(Gi)];Qi.push(Zi),qi/=Hi}return Qi.reverse().join("")}function mr(qi){return qi.split("").reverse().join("")}function Or(qi){if(qi<0)return"-"+Or(-qi);let[zi,Hi]=qi.toString().split(".");if(!Hi)if(zi.includes("e")){const[Zi,Xi]=zi.split("e");zi=Zi,Hi="0e"+Xi}else return _t(qi);let Qi;Hi&&([Hi,Qi]=Hi.split("e")),zi=Pr(zi),Hi=mr(Hi),Hi=Pr(Hi);let Gi=zi+"."+Hi;if(Qi){switch(Gi+=".",Qi[0]){case"+":Qi=Qi.slice(1);break;case"-":Gi+="-",Qi=Qi.slice(1);break}Qi=Pr(Qi),Gi+=Qi}return Gi}function Pr(qi){const zi=+qi;return zi.toString()===qi&&zi+1!==zi&&zi-1!==zi?_t(zi):":"+lr(BigInt(qi))}function dn(qi){return qi[0]===":"?$e(qi.substring(1)).toString():J(qi).toString()}function gi(qi){if(qi[0]==="-")return-gi(qi.substr(1));let[zi,Hi,Qi]=qi.split(".");if(!Hi)return J(zi);zi=dn(zi),Hi=dn(Hi),Hi=mr(Hi);let Gi=zi+"."+Hi;if(Qi){Gi+="e";let Zi=!1;Qi[0]==="-"&&(Zi=!0,Qi=Qi.slice(1)),Qi=dn(Qi),Gi+=Zi?-Qi:+Qi}return+Gi}return number$1}var hasRequiredEncode$1;function requireEncode$1(){if(hasRequiredEncode$1)return encode$1;hasRequiredEncode$1=1,Object.defineProperty(encode$1,"__esModule",{value:!0}),encode$1.encodeNum=E,encode$1.decodeNum=F,encode$1.decodeKey=J,encode$1.encodeBool=$e,encode$1.decodeBool=_t,encode$1.encodeStr=lr,encode$1.decodeStr=mr;const D=requireNumber$1();function E(Or){return Or===1/0?"N|+":Or===-1/0?"N|-":Number.isNaN(Or)?"N|0":"n|"+(0,D.num_to_s)(Or)}function F(Or){if(Or.length===3&&Or[0]==="N"&&Or[1]==="|")switch(Or[2]){case"+":return 1/0;case"-":return-1/0;case"0":return NaN}return(0,D.s_to_num)(Or.slice(2))}function J(Or){return typeof Or=="number"?Or:(0,D.s_to_int)(Or)}function $e(Or){return Or?"b|T":"b|F"}function _t(Or){if(Or.length===3&&Or[0]==="b"&&Or[1]==="|")switch(Or[2]){case"T":return!0;case"F":return!1}return!!Or}function lr(Or){if(Or[1]==="|")switch(Or[0]){case"b":case"o":case"n":case"a":case"s":return"s|"+Or}return Or}function mr(Or){return Or[0]==="s"&&Or[1]==="|"?Or.substr(2):Or}return encode$1}var memory$1={},config$2={},hasRequiredConfig$1;function requireConfig$1(){return hasRequiredConfig$1||(hasRequiredConfig$1=1,Object.defineProperty(config$2,"__esModule",{value:!0}),config$2.config=void 0,config$2.config={sort_key:!1,preserve_nan:!1,error_on_nan:!1,preserve_infinite:!1,error_on_infinite:!1}),config$2}var hasRequiredMemory$1;function requireMemory$1(){if(hasRequiredMemory$1)return memory$1;hasRequiredMemory$1=1,Object.defineProperty(memory$1,"__esModule",{value:!0}),memory$1.memToValues=$e,memory$1.makeInMemoryStore=_t,memory$1.makeInMemoryCache=lr,memory$1.makeInMemoryMemory=mr,memory$1.addValue=dn;const D=requireConfig$1(),E=requireDebug$1(),F=requireEncode$1(),J=requireNumber$1();function $e(gi){return gi.store.toArray()}function _t(){const gi=[];return{forEach(qi){for(let zi=0;zi<gi.length;zi++)if(qi(gi[zi])==="break")return},add(qi){gi.push(qi)},toArray(){return gi}}}function lr(){const gi=Object.create(null),qi=Object.create(null);return{getValue(zi){return gi[zi]},getSchema(zi){return qi[zi]},forEachValue(zi){for(const[Hi,Qi]of Object.entries(gi))if(zi(Hi,Qi)==="break")return},forEachSchema(zi){for(const[Hi,Qi]of Object.entries(qi))if(zi(Hi,Qi)==="break")return},setValue(zi,Hi){gi[zi]=Hi},setSchema(zi,Hi){qi[zi]=Hi},hasValue(zi){return zi in gi},hasSchema(zi){return zi in qi}}}function mr(){return{store:_t(),cache:lr(),keyCount:0}}function Or(gi,qi){if(gi.cache.hasValue(qi))return gi.cache.getValue(qi);const zi=gi.keyCount++,Hi=(0,J.num_to_s)(zi);return gi.store.add(qi),gi.cache.setValue(qi,Hi),Hi}function Pr(gi,qi){D.config.sort_key&&qi.sort();const zi=qi.join(",");if(gi.cache.hasSchema(zi))return gi.cache.getSchema(zi);const Hi=dn(gi,qi,void 0);return gi.cache.setSchema(zi,Hi),Hi}function dn(gi,qi,zi){if(qi===null)return"";switch(typeof qi){case"undefined":if(Array.isArray(zi))return dn(gi,null,zi);break;case"object":if(qi===null)return Or(gi,null);if(Array.isArray(qi)){let Hi="a";for(let Qi=0;Qi<qi.length;Qi++){const Gi=qi[Qi],Zi=Gi===null?"_":dn(gi,Gi,qi);Hi+="|"+Zi}return Hi==="a"&&(Hi="a|"),Or(gi,Hi)}else{const Hi=Object.keys(qi);if(Hi.length===0)return Or(gi,"o|");let Qi="o";const Gi=Pr(gi,Hi);Qi+="|"+Gi;for(const Zi of Hi){const Xi=qi[Zi],Ki=dn(gi,Xi,qi);Qi+="|"+Ki}return Or(gi,Qi)}case"boolean":return Or(gi,(0,F.encodeBool)(qi));case"number":return Number.isNaN(qi)?D.config.preserve_nan?Or(gi,"N|0"):(D.config.error_on_nan&&(0,E.throwUnsupportedData)("[number NaN]"),""):Number.POSITIVE_INFINITY===qi?D.config.preserve_infinite?Or(gi,"N|+"):(D.config.error_on_infinite&&(0,E.throwUnsupportedData)("[number Infinity]"),""):Number.NEGATIVE_INFINITY===qi?D.config.preserve_infinite?Or(gi,"N|-"):(D.config.error_on_infinite&&(0,E.throwUnsupportedData)("[number -Infinity]"),""):Or(gi,(0,F.encodeNum)(qi));case"string":return Or(gi,(0,F.encodeStr)(qi))}return(0,E.throwUnknownDataType)(qi)}return memory$1}var hasRequiredCore$1;function requireCore$1(){if(hasRequiredCore$1)return core$1;hasRequiredCore$1=1,Object.defineProperty(core$1,"__esModule",{value:!0}),core$1.compress=$e,core$1.decode=mr,core$1.decompress=Or;const D=requireDebug$1(),E=requireEncode$1(),F=requireMemory$1(),J=requireNumber$1();function $e(Pr){const dn=(0,F.makeInMemoryMemory)(),gi=(0,F.addValue)(dn,Pr,void 0);return[(0,F.memToValues)(dn),gi]}function _t(Pr,dn){if(dn==="o|")return{};const gi={},qi=dn.split("|"),zi=qi[1];let Hi=mr(Pr,zi);const Qi=qi.length;Qi-2===1&&!Array.isArray(Hi)&&(Hi=[Hi]);for(let Gi=2;Gi<Qi;Gi++){const Zi=Hi[Gi-2];let Xi=qi[Gi];Xi=mr(Pr,Xi),gi[Zi]=Xi}return gi}function lr(Pr,dn){if(dn==="a|")return[];const gi=dn.split("|"),qi=gi.length-1,zi=new Array(qi);for(let Hi=0;Hi<qi;Hi++){let Qi=gi[Hi+1];Qi=mr(Pr,Qi),zi[Hi]=Qi}return zi}function mr(Pr,dn){if(dn===""||dn==="_")return null;const gi=(0,E.decodeKey)(dn),qi=Pr[gi];if(qi===null)return qi;switch(typeof qi){case"undefined":return qi;case"number":return qi;case"string":if(qi[1]==="|")switch(qi[0]){case"b":switch(qi[2]){case"T":return!0;case"F":return!1;default:return(0,D.throwUnknownDataType)(qi)}case"o":return _t(Pr,qi);case"n":return(0,J.s_to_num)(qi.slice(2));case"N":switch(qi[2]){case"+":return 1/0;case"-":return-1/0;case"0":return NaN;default:return(0,D.throwUnknownDataType)(qi)}case"a":return lr(Pr,qi)}return(0,E.decodeStr)(qi)}return(0,D.throwUnknownDataType)(qi)}function Or(Pr){const[dn,gi]=Pr;return mr(dn,gi)}return core$1}var helpers$1={},hasRequiredHelpers$1;function requireHelpers$1(){if(hasRequiredHelpers$1)return helpers$1;hasRequiredHelpers$1=1,Object.defineProperty(helpers$1,"__esModule",{value:!0}),helpers$1.trimUndefined=D,helpers$1.trimUndefinedRecursively=E;function D(J){for(const $e in J)J[$e]===void 0&&delete J[$e]}function E(J){F(J,new Set)}function F(J,$e){$e.add(J);for(const _t in J)if(J[_t]===void 0)delete J[_t];else{const lr=J[_t];lr&&typeof lr=="object"&&!$e.has(lr)&&F(lr,$e)}}return helpers$1}var hasRequiredDist$1;function requireDist$1(){return hasRequiredDist$1||(hasRequiredDist$1=1,(function(D){Object.defineProperty(D,"__esModule",{value:!0}),D.config=D.trimUndefinedRecursively=D.trimUndefined=D.addValue=D.decode=D.decompress=D.compress=void 0;var E=requireCore$1();Object.defineProperty(D,"compress",{enumerable:!0,get:function(){return E.compress}}),Object.defineProperty(D,"decompress",{enumerable:!0,get:function(){return E.decompress}});var F=requireCore$1();Object.defineProperty(D,"decode",{enumerable:!0,get:function(){return F.decode}});var J=requireMemory$1();Object.defineProperty(D,"addValue",{enumerable:!0,get:function(){return J.addValue}});var $e=requireHelpers$1();Object.defineProperty(D,"trimUndefined",{enumerable:!0,get:function(){return $e.trimUndefined}}),Object.defineProperty(D,"trimUndefinedRecursively",{enumerable:!0,get:function(){return $e.trimUndefinedRecursively}});var _t=requireConfig$1();Object.defineProperty(D,"config",{enumerable:!0,get:function(){return _t.config}})})(dist$1)),dist$1}var distExports$1=requireDist$1();const doenetSchema$1=distExports$1.decompress([["elements","aliasedElements","a|0|1","name","children","childBuckets","abstractAncestors","attributes","properties","top","acceptsStringChildren","takesIndex","docsSlug","summary","layoutCategory","a|3|4|5|6|7|8|9|A|B|C|D|E","title","rightHandSide","xLabel","yLabel","br","m","me","men","md","mdn","mrow","not","and","or","xor","iff","implies","isInteger","isNumber","isBetween","sum","product","clampNumber","wrapNumberPeriodic","round","setSmallToZero","convertSetToList","ceil","floor","abs","sign","mean","median","variance","standardDeviation","count","min","max","mod","gcd","lcm","extractMath","clampFunction","wrapFunctionPeriodic","derivative","extractMathOperator","em","alert","q","sq","term","c","tag","tage","tagc","attr","ndash","mdash","nbsp","ellipsis","lq","rq","lsq","rsq","odeSystem","equilibriumPoint","equilibriumLine","atom","ion","ionicCompound","electronConfiguration","span","displayDoenetML","matrixInput","fractionInput","text","textList","boolean","booleanList","math","mathList","tupleList","numberList","collect","ref","point","coords","line","bezierControls","vector","angle","answer","mathInput","textInput","booleanInput","choiceInput","choice","number","integer","function","piecewiseFunction","interval","sequence","cell","repeat","repeatForSequence","intersection","conditionalContent","asList","selectFromSequence","select","group","evaluate","selectRandomNumbers","sampleRandomNumbers","selectPrimeNumbers","samplePrimeNumbers","substitute","periodicSet","intComma","pluralize","lorem","updateValue","callAction","triggerSet","functionIterates","module","footnote","endpoint","sort","shuffle","solveEquations","subsetOfReals","split","bestFitLine","hasSameFactoring","label","matchesPattern","matrix","latex","pointList","intervalList","vectorList","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y","11111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222212221222221112111121222112211111222","_textOrInline","_inline","_base","a|2b|2c|2d","description","type","a|3|2f|2g","The name used to reference this component from elsewhere in the document.","o|2h|3|2i|1T","defaultValue","values","a|3|2f|2k|2l|2g","hide","Whether to hide this component from the rendered output.","b|F","true","false","a|2q|2r","o|2m|2n|2o|2p|2s|1V","disabled","Whether this component is disabled and cannot be interacted with.","o|2m|2u|2v|2p|2s|1V","fixed","Whether this component\'s value is fixed and cannot be modified.","o|2m|2x|2y|2p|2s|1V","fixLocation","Whether this component\'s location is fixed (preventing it from being moved while still allowing other modifications).","o|2m|30|31|2p|2s|1V","a|3|2f|2k|2g","styleNumber","The style number used to select this component\'s visual styling from the available style definitions.","n|1","o|33|34|35|36|1q","isResponse","Whether this component is treated as a response for the purposes of assessment.","o|2m|38|39|2p|2s|1V","extend","Extend another component by reference, inheriting its children and attributes. Enter a reference as `$name`.","reference","o|2h|3B|3C|3D","copy","Create an independent copy of another component by reference. Enter a references a `$name`.","o|2h|3F|3G|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H","isArray","fromAttribute","a|3|2g|3J|2f|3K","b|T","o|3L|2n|1V|2p|2o|3M","o|3L|34|1q|2p|35|3M","o|3L|38|1V|2p|39|3M","a|3|2g|3J|2f","hidden","Whether this component is hidden from the rendered output.","o|3Q|3R|1V|2p|3S","o|3Q|2u|1V|2p|2v","o|3Q|2x|1V|2p|2y","o|3Q|30|1V|2p|31","doenetML","The DoenetML source code that produced this component.","o|3Q|3X|1T|2p|3Y","value","The combined content of this component\'s children.","o|3Q|3a|G|2p|3b","The combined content of this component\'s children, as a plain text string.","o|3Q|1T|1T|2p|3d","a|3N|3O|3P|3T|3U|3V|3W|3Z|3c|3e","Creates a title within a document, section, or other block component","inline","o|F|G|2Z|2a|2e|3I|3f|3M|3M|2p|G|3g|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","1222211111111111111111111112222222221222202222122222222212222122222122221212222","a|2c|2d","highlighted","autocompleteValues","a|3|2f|3m|2k|2l|3n|2g","format","Input format.","a|1T|2V","a|3a|2f","Plain-text math notation (e.g., `x^2 + 1`).","o|3s|1T|3t","LaTeX-formatted math (e.g., `x^{2} + 1`).","o|3s|2V|3v","a|3u|3w","keyword","o|3o|3p|3q|3M|1T|3r|3x|3y","simplify","Level of simplification applied to the expression.","none","full","numbers","numbersPreserveOrder","normalizeOrder","a|42|43|44|45|46|2q|2r","No simplification is applied.","o|3s|42|48","Fully simplify the expression.","o|3s|43|4A","Simplify numeric subexpressions only, leaving symbolic structure intact.","o|3s|44|4C","Like `numbers`, but does not reorder commutative operands.","o|3s|45|4E","Reorder commutative operands into a canonical form without simplifying values.","o|3s|46|4G","a|49|4B|4D|4F|4H","o|3o|40|41|3M|42|47|4I|3y","expand","Whether to expand the expression.","o|2m|4K|4L|2p|2s|1V","groupName","a|3|2f|4N|3m|2k|2g","displayDigits","Number of significant digits to display when rendering this number.","number-display","n|3","o|4O|4P|4Q|4R|3M|4S|1q","a|3|2f|4N|2k|2g","displayDecimals","Number of decimal places to display when rendering this number.","n|2","o|4U|4V|4W|4R|4X|1q","displaySmallAsZero","Threshold below which numbers are displayed as zero.","n|1.0.-E","o|4U|4Z|4a|4R|4b|1p","a|3|2f|4N|2k|2l|2g","padZeros","Whether to pad displayed numbers with trailing zeros to fill the requested digits/decimals.","o|4d|4e|4f|4R|2p|2s|1V","avoidScientificNotation","Whether to render numbers in full decimal form rather than scientific notation.","o|4d|4h|4i|4R|2p|2s|1V","renderMode",\'How the math is rendered (e.g. "inline", "display").\',"o|33|4k|4l|3h|1T","unordered","Whether tuple- or list-like math expressions should be treated as unordered for comparison.","o|2m|4n|4o|2p|2s|1V","createVectors","Whether tuple-like expressions are interpreted as vectors.","o|2m|4q|4r|2p|2s|1V","createIntervals","Whether range expressions are interpreted as intervals.","o|2m|4t|4u|2p|2s|1V","functionSymbols","Symbols treated as function names when parsing.","f","g","a|4y|4z","o|33|4w|4x|50|1U","referencesAreFunctionSymbols","References whose names should be treated as function symbols when parsing.","a|","o|33|52|53|54|3D","splitSymbols","Whether multi-character symbols are split into a product of variables.","o|2m|56|57|3M|2s|1V","parseScientificNotation","Whether to parse expressions like 1e3 as scientific notation.","o|2m|59|5A|2p|2s|1V","displayBlanks","Whether blanks (placeholders) are visibly rendered.","o|2m|5C|5D|3M|2s|1V","assumptions","Assumptions applied when simplifying or comparing.","a|2g|2V","＿","o|5H|1X|5I","o|33|5F|5G|5J|1X","draggable","Whether the math component can be dragged on a graph.","o|2m|5L|5M|3M|2s|1V","layer","Z-order layer index when shown on a graph.","n|0","o|33|5O|5P|5Q|1p","anchor","Coordinates of the anchor point used to position this component on a graph.","positioning","\\\\left( 0, 0 \\\\right)","o|5H|1X|5V","o|4U|5S|5T|5U|5W|1d","a|3|2f|4N|2k|2l|3n|2g","positionFromAnchor","Where this component sits relative to its anchor point.","center","upperRight","upperLeft","lowerRight","lowerLeft","bottom","left","right","a|5c|5d|5e|5f|9|5g|5h|5i|5b","Place the component above and to the right of the anchor point.","o|3s|5c|5k","Place the component above and to the left of the anchor point.","o|3s|5d|5m","Place the component below and to the right of the anchor point.","o|3s|5e|5o","Place the component below and to the left of the anchor point.","o|3s|5f|5q","Place the component directly above the anchor point.","o|3s|9|5s","Place the component directly below the anchor point.","o|3s|5g|5u","Place the component directly to the left of the anchor point.","o|3s|5h|5w","Place the component directly to the right of the anchor point.","o|3s|5i|5y","Center the component on the anchor point.","o|3s|5b|60","a|5l|5n|5p|5r|5t|5v|5x|5z|61","o|5Y|5Z|5a|5U|5b|5j|62|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","a|3|2g|3J|2f|3K|3m","o|65|3p|1T|2p|3q|3M|3M","o|65|40|1T|2p|41|3M|3M","o|3L|4K|1V|2p|4L|3M","o|3L|4k|1T|2p|4l|3M","o|3L|4q|1V|2p|4r|3M","o|3L|4t|1V|2p|4u|3M","o|3L|4w|1U|2p|4x|3M","o|3L|56|1V|2p|57|3M","o|3L|59|1V|2p|5A|3M","o|3L|5C|1V|2p|5D|3M","o|3L|5F|1X|2p|5G|3M","o|3L|5L|1V|2p|5M|3M","o|3L|5O|1p|2p|5P|3M","a|3|2g|3J|2f|3K|4N","o|6J|5Z|1T|2p|5a|3M|5U","textColor","Human-readable name for this component\'s text color, derived from the active style and theme.","o|3Q|6L|1T|2p|6M","backgroundColor","Human-readable name for this component\'s background color, derived from the active style and theme.","o|3Q|6O|1T|2p|6P","textStyleDescription","Human-readable description of this component\'s text styling (color and any background color).","o|3Q|6R|1T|2p|6S","a|3|2g|3J|2f|4N","The coordinates where this component is anchored on the graph.","o|6U|5S|1d|2p|6V|5U","o|3Q|4P|1q|2p|4Q","o|3Q|4V|1q|2p|4W","o|3Q|4Z|1p|2p|4a","o|3Q|4e|1V|2p|4f","o|3Q|4h|1V|2p|4i","Whether list-like values are treated as unordered.","o|3Q|4n|1V|2p|6c","The math expression value.","o|3Q|3a|H|2p|6e","The numeric value of the expression (NaN if not a number).","o|3Q|1p|1p|2p|6g","Whether the expression evaluates to a finite number.","o|3Q|Y|1V|2p|6i","isNumeric","Whether the expression evaluates to any number (including infinities).","o|3Q|6k|1V|2p|6l","The expression rendered as a LaTeX string.","o|3Q|2V|2V|2p|6n","The expression rendered as a plain text string.","o|3Q|1T|1T|2p|6p","numDimensions","The number of dimensions if the math expression is interpreted as a vector or matrix.","o|3Q|6r|1q|2p|6s","indexedArrayDescription","a|3|2g|3J|2f|6r|6u","The math expression interpreted as a vector (its components).","a|3J|2g","o|6x|2p|1h","a|6y","o|6v|1h|1X|3M|6w|36|6z","list","The math expression interpreted as a list (its elements).","a|3J|2g|6r","o|73|3M|1X|36","a|74","o|6v|71|1X|3M|72|36|75","matrixSize","The size of the math expression as a matrix, as a [numRows, numColumns] list.","o|3Q|77|1a|2p|78","numRows","The number of rows when the math expression is interpreted as a matrix.","o|3Q|7A|1q|2p|7B","numColumns","The number of columns when the math expression is interpreted as a matrix.","o|3Q|7D|1q|2p|7E","The math expression interpreted as a matrix (its entries by row and column).","o|6x|2p|2U","a|7H|7H","o|6v|2U|1X|3M|7G|4X|7I","rows","The matrix\'s entries grouped by row.","o|6v|7K|1X|3M|7L|4X|7I","columns","The matrix\'s entries grouped by column.","o|6v|7N|1X|3M|7O|4X|7I","x","The first component of the math expression when interpreted as a vector.","o|3Q|7Q|1X|2p|7R","y","The second component of the math expression when interpreted as a vector.","o|3Q|7T|1X|2p|7U","z","The third component of the math expression when interpreted as a vector.","o|3Q|7W|1X|2p|7X","numListItems","The number of items when the math expression is interpreted as a list.","o|3Q|7Z|1q|2p|7a","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|6f|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A right-hand-side expression of an equation in an ODE system","o|F|H|3j|3k|3l|64|7c|3M|3M|2p|H|7d|3h","for","Reference to the component this label is for (e.g., an input).","o|2h|7f|7g|3D","forObject","Reference to the graphical object this label is attached to.","o|2h|7i|7j|3D","Whether the label can be dragged on a graph.","o|2m|5L|7l|3M|2s|1V","maskLabel","Whether to give the label an opaque background so it stays legible when it overlaps an axis, grid line, or another object.","o|2m|7n|7o|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|7h|7k|7m|5R|7p|5X|63","o|3L|5L|1V|2p|7l|3M","o|3L|7n|1V|2p|7o|3M","hasLatex","Whether the label contains LaTeX content.","o|3Q|7t|1V|2p|7u","The label\'s text content.","o|3Q|1T|1T|2p|7w","The label\'s content as a LaTeX string.","o|3Q|2V|2V|2p|7y","The label\'s content as a label-typed value.","o|3Q|3a|I|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|81","A label for the x-axis of a graph","o|F|I|2Z|2a|3l|7q|82|3M|3M|2p|I|83|3h","o|3Q|3a|J|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|85","A label for the y-axis of a graph","o|F|J|2Z|2a|3l|7q|86|3M|3M|2p|J|87|3h","statement","introduction","conclusion","hr","section","subsection","subsubsection","paragraphs","aside","objectives","problem","exercise","question","activity","example","definition","note","theorem","part","task","proof","problems","exercises","ol","ul","cobwebPolyline","equilibriumCurve","orbitalDiagram","orbitalDiagramInput","sideBySide","sbsGroup","stack","div","pre","paginator","paginatorControls","solution","givenAnswer","document","p","lineSegment","ray","polyline","polygon","triangle","rectangle","regularPolygon","circle","parabola","curve","award","graph","annotations","annotation","slider","spreadsheet","row","column","cellBlock","tabular","table","figure","pegboard","variantControl","animateFromSequence","image","video","hint","feedback","moduleAttributes","setup","caption","subsetOfRealsInput","regionBetweenCurveXAxis","regionBetweenCurves","regionHalfPlane","codeEditor","legend","eigenDecomposition","blockQuote","stickyGroup","pretzel","cascade","a|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|1z|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","_block","a|9W|2d","aggregateScores","Whether to aggregate scores of scored descendants into a section credit-achieved value.","scoring","o|4d|9Y|9Z|9a|2p|2s|1V","weight","Relative weight of this section when aggregated by an enclosing scored section.","o|4U|9c|9d|9a|36|1p","sectionWideCheckWork","Whether to show a single section-wide check-work button instead of per-answer buttons.","o|4d|9f|9g|9a|2p|2s|1V","maxNumAttempts","Maximum number of times the section-wide check-work button can be submitted. Once reached, all enclosed answers are disabled.","Infinity","o|4U|9i|9j|9a|9k|1q","showCorrectness","Whether to display correctness indicators for the answers it contains.","o|4d|9m|9n|9a|3M|2s|1V","colorCorrectness","Whether to color-code the answers it contains based on correctness.","o|4d|9p|9q|9a|3M|2s|1V","colorAnswersSeparately","When section-wide check work is enabled, color each answer based on its own correctness rather than the section\'s overall credit.","o|4d|9s|9t|9a|2p|2s|1V","submitLabel","Label for the section-wide submit button when correctness is shown.","Check Work","o|4U|9v|9w|9a|9x|1T","submitLabelNoCorrectness","Label for the section-wide submit button when correctness is not shown.","Submit Response","o|4U|9z|A0|9a|A1|1T","displayDigitsForCreditAchieved","Number of significant digits to display for the credit achieved value.","o|4U|A3|A4|9a|4S|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5","o|6J|9c|1p|2p|9d|3M|9a","o|6J|9f|1V|2p|9g|3M|9a","o|6J|9i|1q|2p|9j|3M|9a","o|6J|9v|1T|2p|9w|3M|9a","o|6J|9z|1T|2p|A0|3M|9a","o|6J|A3|1q|2p|A4|3M|9a","numSubmissions","Number of times the section-wide check-work button has been submitted.","o|3Q|AD|1q|2p|AE","numAttemptsLeft","Remaining number of section-wide submissions before the maximum is reached.","o|3Q|AG|1q|2p|AH","Whether scores of scored descendants are aggregated into this section\'s credit value.","o|3Q|9Y|1V|2p|AJ","creditAchieved","Aggregate credit achieved (between 0 and 1) for scored descendants of this section.","o|3Q|AL|1p|2p|AM","percentCreditAchieved","Aggregate credit achieved as a percentage (between 0 and 100).","o|3Q|AO|1p|2p|AP","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ","A block container for the statement of a problem, theorem, or similar","block","o|F|89|9U|9V|9X|A6|AR|3M|3M|2p|89|AS|AT","A block container for the introduction of a section","o|F|8A|9U|9V|9X|A6|AR|3M|3M|2p|8A|AV|AT","A block container for the conclusion of a section","o|F|8B|9U|9V|9X|A6|AR|3M|3M|2p|8B|AX|AT","","a|3N|3O|3P|3T|3U|3V|3W|3Z","A line break","o|F|K|54|AZ|3l|3I|Aa|3M|2p|2p|K|Ab|3h","A horizontal rule used to separate content","o|F|8C|54|AZ|9X|3I|Aa|3M|2p|2p|8C|Ad|AT","cascadeMessage","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|8W|8X","1111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222221222122222111211112122211221111122200","The paragraph\'s text content.","o|3Q|1T|1T|2p|Ai","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|Aj","Placeholder shown inside a `<cascade>` in place of a not-yet-revealed entry","o|F|Af|Ag|Ah|9X|A6|Ak|2p|3M|2p|Af|Al|AT","else","a|2d","a|3|2f|2l|2g","condition","Boolean expression; this case is selected when the condition is true.","o|Ap|Aq|Ar|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|As","conditionSatisfied","Whether this case\'s condition is currently satisfied.","o|3Q|Au|1V|2p|Av","a|3N|3O|3P|3T|3U|3V|3W|3Z|Aw","Default branch within a `<conditionalContent>`; matched when no `<case>` condition is true","other","o|F|An|9U|9V|Ao|At|Ax|2p|3M|2p|An|Ay|Az","Whether the math display can be dragged on a graph.","o|2m|5L|B1|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63","o|3L|5L|1V|2p|B1|3M","The math content rendered as a LaTeX string.","o|3Q|2V|2V|2p|B5","The math content rendered as a plain text string.","o|3Q|1T|1T|2p|B7","The math content as a math expression.","o|3Q|1X|1X|2p|B9","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA","Inline math rendered with LaTeX","o|F|L|2Z|2a|3l|B3|BB|3M|3M|2p|L|BC|3h","Display math rendered with LaTeX","o|F|M|2Z|2a|3l|B3|BB|3M|3M|2p|M|BE|3h","equationTag","The equation number (when numbered).","o|3Q|BG|1T|2p|BH","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA|BI","Numbered display math rendered with LaTeX","o|F|N|2Z|2a|3l|B3|BJ|3M|3M|2p|N|BK|3h","a|Q|1z","02","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8","Display math with multiple aligned rows","o|F|O|BM|BN|3l|B3|BO|3M|2p|2p|O|BP|3h","Numbered display math with multiple aligned rows","o|F|P|BM|BN|3l|B3|BO|3M|2p|2p|P|BR|3h","Whether to attach an equation number to this row.","o|Ap|1p|BT|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63|BU","A row of math within an aligned display","o|F|Q|2Z|2a|3l|BV|BJ|3M|3M|2p|Q|BW|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a","1222211111111111111111111112221222221220202222122222012212222122222111221211222221111111110212120","_booleanOperatorOneInput","a|Ba|2c|2d","symbolicEquality","Whether children compared via this boolean use symbolic equality.","o|2m|Bc|Bd|2p|2s|1V","expandOnCompare","Whether to expand math expressions before comparing.","o|2m|Bf|Bg|2p|2s|1V","a|3|2f|2k|2l|3n|2g","simplifyOnCompare","Level of simplification applied to math expressions before comparing.","No simplification is applied before comparing.","o|3s|42|Bl","Fully simplify both expressions before comparing.","o|3s|43|Bn","a|Bm|Bo|4D|4F|4H","o|Bi|Bj|Bk|42|47|Bp|3y","unorderedCompare","Whether order is ignored when comparing list-like values.","o|2m|Br|Bs|2p|2s|1V","matchByExactPositions","Whether to match list values by exact position rather than by content.","o|2m|Bu|Bv|2p|2s|1V","allowedErrorInNumbers","Maximum allowed numeric error when comparing numbers.","o|33|Bx|By|5Q|1p","includeErrorInNumberExponents","Whether the allowed numeric error also applies to numbers in exponents.","o|2m|C0|C1|2p|2s|1V","allowedErrorIsAbsolute","Whether allowedErrorInNumbers is interpreted as an absolute (rather than relative) tolerance.","o|2m|C3|C4|2p|2s|1V","numSignErrorsMatched","Maximum number of sign errors that still count as a match.","o|33|C6|C7|5Q|1p","numPeriodicSetMatchesRequired","Number of consecutive elements of a periodic set required to count as a match.","o|33|C9|CA|4S|1q","caseInsensitiveMatch","Whether text comparisons ignore letter case.","o|2m|CC|CD|2p|2s|1V","matchBlanks","Whether unfilled blanks in a math expression count as a match.","o|2m|CF|CG|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH","o|3L|Bc|1V|2p|Bd|3M","o|3L|Bf|1V|2p|Bg|3M","o|3L|Bj|1T|2p|Bk|3M","o|3L|Br|1V|2p|Bs|3M","o|3L|Bu|1V|2p|Bv|3M","o|3L|Bx|1p|2p|By|3M","o|3L|C0|1V|2p|C1|3M","o|3L|C3|1V|2p|C4|3M","o|3L|C6|1p|2p|C7|3M","o|3L|C9|1q|2p|CA|3M","o|3L|CC|1V|2p|CD|3M","o|3L|CF|1V|2p|CG|3M",\'The boolean rendered as a text string ("true" or "false").\',"o|3Q|1T|1T|2p|CV","The boolean result of applying this operator to its single boolean input.","o|3Q|3a|1V|2p|CX","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|CW|CY","Logical negation of a boolean value","o|F|R|BY|BZ|Bb|CI|CZ|3M|3M|2p|R|Ca|3h","a|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|1z|2R|2T","111111111022211","_booleanOperator","a|Ce|2c|2d","The boolean result of applying this operator to its child boolean values.","o|3Q|3a|1V|2p|Cg","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Ch|CW","Logical AND: true only when all child boolean values are true","o|F|S|Cc|Cd|Cf|CI|Ci|3M|3M|2p|S|Cj|3h","Logical OR: true when at least one child boolean value is true","o|F|T|Cc|Cd|Cf|CI|Ci|3M|3M|2p|T|Cl|3h","Logical exclusive OR: true when exactly one child boolean value is true","o|F|U|Cc|Cd|Cf|CI|Ci|3M|3M|2p|U|Cn|3h","IF and only iF: Logical bicondition (IFF): true when all child boolean values are the same","o|F|V|Cc|Cd|Cf|CI|Ci|3M|3M|2p|V|Cp|3h","Logical implication (binary): true when the first value is false or the second value is true","o|F|W|Cc|Cd|Cf|CI|Ci|3M|3M|2p|W|Cr|3h","_booleanOperatorOfMath","a|Ct|2c|2d","The boolean result of applying this operator to its child math values.","o|3Q|3a|1V|2p|Cv","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Cw|CW","True when the math child evaluates to an integer","o|F|X|3j|3k|Cu|CI|Cx|3M|3M|2p|X|Cy|3h","True when the math child evaluates to a finite number","o|F|Y|3j|3k|Cu|CI|Cx|3M|3M|2p|Y|D0|3h","limits","Numeric limits used by the boolean operator (e.g. bounds for isBetween).","o|33|D2|D3|54|1a","strict","Whether the comparison is strict (e.g. uses < instead of ≤).","o|2m|D5|D6|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|D4|D7","o|3L|D2|1a|2p|D3|3M","o|3L|D5|1V|2p|D6|3M","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|D9|DA|3T|3U|3V|3W|3Z|Cw|CW","True when a math value is between two given bounds","o|F|Z|3j|3k|Cu|D8|DB|3M|3M|2p|Z|DC|3h","1222211111111111111111111112222222221222202222122222012212222122222122221212222","_mathOperator","a|DF|2c|2d","forceSymbolic","Whether to force the operator to evaluate symbolically rather than numerically.","o|2m|DH|DI|2p|2s|1V","forceNumeric","Whether to force the operator to evaluate numerically rather than symbolically.","o|2m|DK|DL|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM","o|3L|DH|1V|2p|DI|3M","o|3L|DK|1V|2p|DL|3M","o|3Q|3a|a|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DQ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Sum of the child math or number values","o|F|a|3j|DE|DG|DN|DR|3M|3M|2p|a|DS|3h","o|3Q|3a|b|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DU|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Product of the child math or number values","o|F|b|3j|DE|DG|DN|DV|3M|3M|2p|b|DW|3h","_mathOperatorOneInput","a|DY|2c|2d","lowerValue","Lower bound used by the operator.","o|33|Da|Db|5Q|1p","upperValue","Upper bound used by the operator.","o|33|Dd|De|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dc|Df","o|3L|Da|1p|2p|Db|3M","o|3L|Dd|1p|2p|De|3M","o|3Q|3a|c|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Clamps a number to a specified range","o|F|c|3j|3k|DZ|Dg|Dk|3M|3M|2p|c|Dl|3h","o|3Q|3a|d|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dn|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Wraps a number into a periodic range","o|F|d|3j|3k|DZ|Dg|Do|3M|3M|2p|d|Dp|3h","n|E","o|4O|4P|4Q|4R|3M|Dr|1q","numDecimals","Number of decimal places (for round-style operators).","o|33|Dt|Du|5Q|1p","numDigits","Number of significant digits (for round-style operators).","o|33|Dw|Dx||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|Ds|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dv|Dy","o|3L|Dt|1p|2p|Du|3M","o|3L|Dw|1p|2p|Dx|3M","o|3Q|3a|e|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|E0|E1|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|E2|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Rounds a number to a specified precision","o|F|e|3j|3k|DZ|Dz|E3|3M|3M|2p|e|E4|3h","threshold","Threshold value used by the operator.","o|33|E6|E7|4b|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|E8","o|3L|E6|1p|2p|E7|3M","o|3Q|3a|f|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|EA|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Replaces values with magnitude below a threshold with zero","o|F|f|3j|3k|DZ|E9|EC|3M|3M|2p|f|ED|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|g|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|EG|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Converts a math set expression into a list expression","o|F|g|3j|3k|DZ|EF|EH|3M|3M|2p|g|EI|3h","o|3Q|3a|h|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EK|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Smallest integer ≥ the input value","o|F|h|3j|3k|DZ|64|EL|3M|3M|2p|h|EM|3h","o|3Q|3a|i|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EO|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Largest integer ≤ the input value","o|F|i|3j|3k|DZ|64|EP|3M|3M|2p|i|EQ|3h","o|3Q|3a|j|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ES|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Absolute value of an expression","o|F|j|3j|3k|DZ|64|ET|3M|3M|2p|j|EU|3h","o|3Q|3a|k|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EW|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Sign of the input (-1, 0, or 1)","o|F|k|3j|3k|DZ|64|EX|3M|3M|2p|k|EY|3h","o|3Q|3a|l|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ea|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Arithmetic mean of the child math or number values","o|F|l|3j|DE|DG|DN|Eb|3M|3M|2p|l|Ec|3h","o|3Q|3a|m|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ee|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Median of the child math or number values","o|F|m|3j|DE|DG|DN|Ef|3M|3M|2p|m|Eg|3h","population","Whether to use the population formula (rather than sample).","o|2m|Ei|Ej|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM|Ek","o|3L|Ei|1V|2p|Ej|3M","o|3Q|3a|n|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|En|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Variance of the child math or number values","o|F|n|3j|DE|DG|El|Eo|3M|3M|2p|n|Ep|3h","o|3Q|3a|o|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Er|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Standard deviation of the child math or number values","o|F|o|3j|DE|DG|El|Es|3M|3M|2p|o|Et|3h","o|3Q|3a|p|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ev|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","The number of the child math or number values","o|F|p|3j|DE|DG|DN|Ew|3M|3M|2p|p|Ex|3h","o|3Q|3a|q|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ez|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Minimum of the child math or number values","o|F|q|3j|DE|DG|DN|F0|3M|3M|2p|q|F1|3h","o|3Q|3a|r|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F3|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Maximum of the child math or number values","o|F|r|3j|DE|DG|DN|F4|3M|3M|2p|r|F5|3h","o|3Q|3a|s|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F7|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Modulo (remainder) of two values","o|F|s|3j|DE|DG|DN|F8|3M|3M|2p|s|F9|3h","o|3Q|3a|t|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Greatest common divisor of integer inputs","o|F|t|3j|DE|DG|DN|FC|3M|3M|2p|t|FD|3h","o|3Q|3a|u|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FF|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Least common multiple of integer inputs","o|F|u|3j|DE|DG|DN|FG|3M|3M|2p|u|FH|3h","What kind of sub-expression to extract.","operand","functionArgument","numOperands","recursiveOperands","a|FK|1r|FL|FM|FN","Extract a single operand of the top-level operation.","o|3s|FK|FP","Extract the function being applied (for a function call).","o|3s|1r|FR","Extract an argument of the function being called.","o|3s|FL|FT","Extract the count of operands at the top level.","o|3s|FM|FV","Extract all operands found recursively through nested operations.","o|3s|FN|FX","a|FQ|FS|FU|FW|FY","o|Bi|2g|FJ||FO|FZ|3y","operandNumber","1-based index of the operand to extract.","o|33|Fb|Fc||1p","argumentNumber","1-based index of the argument to extract.","o|33|Fe|Ff||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Fa|Fd|Fg","o|3L|Fb|1p|2p|Fc|3M","o|3L|Fe|1p|2p|Ff|3M","o|3Q|3a|v|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Fi|Fj|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Fk|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Extracts a sub-expression from a math expression by name or index","o|F|v|3j|3k|DZ|Fh|Fl|3M|3M|2p|v|Fm|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|2S","1222211111111111111111111111112222221222202222122222220112222122222122221212222110","_functionOperator","a|Fq|2c|2d","Level of simplification applied to the function\'s formula.","Fully simplify the function\'s formula.","o|3s|43|Ft","a|49|Fu|4D|4F|4H","o|Bi|40|Fs|43|47|Fv|3y","Whether to expand the function\'s formula.","o|2m|4K|Fx|2p|2s|1V","xscale","Scale factor used along the x-axis.","o|33|Fz|G0|36|1p","yscale","Scale factor used along the y-axis.","o|33|G2|G3|36|1p","numInputs","Number of input arguments the function accepts.","o|2h|G5|G6|1q","numOutputs","Number of output values the function produces.","o|33|G8|G9|36|1q","domain","Restriction of the function\'s domain to a list of intervals.","o|2h|GB|GC|2X","labelIsName","Whether to use this component\'s name as its rendered label.","labels","o|4d|GE|GF|GG|2p|2s|1V","applyStyleToLabel","Whether to apply the function\'s style to its label.","o|2m|GI|GJ|2p|2s|1V","labelPosition","Position of the function\'s label.","a|5c|5d|5e|5f|9|5g|5h|5i","Place the label above and to the right of the function curve.","o|3s|5c|GO","Place the label above and to the left of the function curve.","o|3s|5d|GQ","Place the label below and to the right of the function curve.","o|3s|5e|GS","Place the label below and to the left of the function curve.","o|3s|5f|GU","Place the label directly above the function curve.","o|3s|9|GW","Place the label directly below the function curve.","o|3s|5g|GY","Place the label directly to the left of the function curve.","o|3s|5h|Ga","Place the label directly to the right of the function curve.","o|3s|5i|Gc","a|GP|GR|GT|GV|GX|GZ|Gb|Gd","o|Bi|GL|GM|5c|GN|Ge|3y","Z-order layer index for stacking the function on a graph.","o|33|5O|Gg|5Q|1p","minima","Local minima of an interpolated function.","extrema","o|2h|Gi|Gj|Gk","maxima","Local maxima of an interpolated function.","o|2h|Gm|Gn|Gk","Local extrema (combined minima and maxima) of an interpolated function.","o|2h|Gk|Gp|Gk","through","Points the interpolated function should pass through.","o|2h|Gr|Gs|2W","throughSlopes","Slopes the interpolated function should have at each through-point.","o|2h|Gu|Gv|1Y","variables","Names of the function\'s input variables.","_variableNameList","o|2h|Gx|Gy|Gz","variable","Name of the function\'s single input variable.","_variableName","o|2h|H1|H2|H3","symbolic","Whether the function should be evaluated symbolically rather than numerically.","o|2m|H5|H6|3M|2s|1V","o|4U|4P|4Q|4R|4S|1q","nearestPointAsCurve","Whether nearest-point queries should treat the function as a curve in the plane rather than a graph y = f(x).","o|2m|H9|HA|2p|2s|1V","a|3|2f|2l|3n|2g","lineStyle","Stroke style for lines.","solid","dashed","dotted","a|HF|HG|HH","Continuous, unbroken stroke.","o|3s|HF|HJ","Stroke composed of evenly-spaced dashes.","o|3s|HG|HL","Stroke composed of evenly-spaced dots.","o|3s|HH|HN","a|HK|HM|HO","o|HC|HD|HE|HI|HP|3y","lineWidth","Stroke width for lines, in pixels.","o|2h|HR|HS|1p","Lower bound for the operator\'s range.","o|33|Da|HU|5Q|1p","Upper bound for the operator\'s range.","o|33|Dd|HW|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|HV|HX","expandSpecified","o|3Q|HZ|1V|2p|Fx","o|3L|Fz|1p|2p|G0|3M","o|3L|G2|1p|2p|G3|3M","o|6J|GE|1V|2p|GF|3M|GG","o|3L|GI|1V|2p|GJ|3M","o|3L|GL|1T|2p|GM|3M","o|3L|5O|1p|2p|Gg|3M","o|3L|Da|1p|2p|HU|3M","o|3L|Dd|1p|2p|HW|3M","The label rendered with this component.","o|6U|2S|2S|2p|Hj|GG","styleDescription","A textual description of the function\'s style.","o|3Q|Hl|1T|2p|Hm","styleDescriptionWithNoun",\'Style description including the word "function".\',"o|3Q|Ho|1T|2p|Hp","Number of input variables of the function.","o|3Q|G5|1q|2p|Hr","Number of output values of the function.","o|3Q|G8|1q|2p|Ht","Domain interval(s) of the function.","o|73|3M|1t|36","a|Hw","o|6v|GB|1t|3M|Hv|36|Hx","Level of simplification applied when displaying the formula.","o|3Q|40|1T|2p|Hz","Whether to expand the formula.","o|3Q|4K|1T|2p|I1","Whether the function is treated symbolically.","o|3Q|H5|1V|2p|I3","The names of the function\'s input variables.","o|73|3M|H3|36","a|I6","o|6v|Gx|H3|3M|I5|36|I7","formula","The symbolic formula of the function produced by this operator.","o|3Q|I9|1X|2p|IA","The function rendered as a LaTeX string.","o|3Q|2V|2V|2p|IC","The function rendered as a plain text string.","o|3Q|1T|1T|2p|IE","numMinima","Number of local minima of the function.","o|3Q|IG|1p|2p|IH","Local minima of the function.","o|73|3M|1d|36","o|6x|2p|1d","a|IK|IL","o|6v|Gi|1p|3M|IJ|4X|IM","minimumLocations","The x-coordinates of the function\'s local minima.","o|73|3M|1p|36","a|IQ","o|6v|IO|1p|3M|IP|36|IR","minimumValues","The values of the function\'s local minima.","o|6v|IT|1p|3M|IU|36|IR","globalMinimum","The global minimum of the function (if attained).","a|IL","o|6v|IW|1p|3M|IX|36|IY","globalInfimum","The global infimum of the function.","o|6v|Ia|1p|3M|Ib|36|IY","numMaxima","Number of local maxima of the function.","o|3Q|Id|1p|2p|Ie","Local maxima of the function.","o|6v|Gm|1p|3M|Ig|4X|IM","maximumLocations","The x-coordinates of the function\'s local maxima.","o|6v|Ii|1p|3M|Ij|36|IR","maximumValues","The values of the function\'s local maxima.","o|6v|Il|1p|3M|Im|36|IR","globalMaximum","The global maximum of the function (if attained).","o|6v|Io|1p|3M|Ip|36|IY","globalSupremum","The global supremum of the function.","o|6v|Ir|1p|3M|Is|36|IY","numExtrema","Number of local extrema (minima + maxima) of the function.","o|3Q|Iu|1p|2p|Iv","Local extrema (minima + maxima) of the function.","o|6v|Gk|1p|3M|Ix|4X|IM","extremumLocations","The x-coordinates of the function\'s local extrema.","o|6v|Iz|1p|3M|J0|36|IR","extremumValues","The values of the function\'s local extrema.","o|6v|J2|1p|3M|J3|36|IR","The function\'s first input variable name.","o|3Q|H1|H3|2p|J5","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|Hh|Hi|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A function clamped to a specified output range","o|F|w|Fo|Fp|Fr|HY|J7|3M|3M|2p|w|J8|3h","A function wrapped into a periodic output range","o|F|x|Fo|Fp|Fr|HY|J7|3M|3M|2p|x|JA|3h","derivVariables","Names of variables to differentiate with respect to.","o|2h|JC|JD|Gz","derivVariable","Name of the variable to differentiate with respect to.","o|2h|JF|JG|H3","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|JE|JH","Number of input variables.","o|3Q|G5|1q|2p|JJ","Names of the input variables.","o|6v|Gx|H3|3M|JL|36|I7","numDerivatives","Number of derivatives applied.","o|3Q|JN|1q|2p|JO","Variables with respect to which derivatives are taken.","o|6v|JC|H3|3M|JQ|36|I7","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|Hu|Hy|I0|I2|I4|JM|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|JP|JR|J6","The derivative of a function","o|F|y|Fo|Fp|Fr|JI|JS|3M|3M|2p|y|JT|3h","_textOperatorOfMath","a|JV|2c|2d","Whether the text can be dragged on a graph.","o|2m|5L|JX|3M|2s|1V","isLatex","Whether the text content is treated as LaTeX.","o|2m|JZ|Ja|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63","o|3L|5L|1V|2p|JX|3M","o|3L|JZ|1V|2p|Ja|3M","The text result of applying this operator to its child math values.","o|3Q|3a|1T|2p|Jf","The text rendered as a plain text string.","o|3Q|1T|1T|2p|Jh","The text parsed as a math expression.","o|3Q|1X|1X|2p|Jj","The text parsed as a number.","o|3Q|1p|1p|2p|Jl","numWords","The number of words in the text value.","o|3Q|Jn|1q|2p|Jo","words","The text value split into words.","o|73|3M|1T|36","a|Js","o|6v|Jq|1T|3M|Jr|36|Jt","numCharacters","The number of characters (graphemes) in the text value.","o|3Q|Jv|1q|2p|Jw","characters","The text value split into characters (graphemes).","o|6v|Jy|1T|3M|Jz|36|Jt","The number of comma-separated items when the text is interpreted as a list.","o|3Q|7Z|1q|2p|K1","The text value split into items at commas.","o|6v|71|1T|3M|K3|36|Jt","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|Jg|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4",\'Returns the top-level operator of a math expression as text (e.g. "+", "vector")\',"o|F|z|3j|3k|JW|Jc|K5|3M|2p|2p|z|K6|3h","_inlineRenderInlineChildren","a|K8|2c|2d","The combined text content of this component\'s children, with optional begin/end delimiters.","o|3Q|1T|1T|2p|KA","a|3N|3O|3P|3T|3U|3V|3W|3Z|KB","Emphasized inline text (italic by default)","o|F|10|2Z|2a|K9|3I|KC|3M|3M|2p|10|KD|3h","Bold text","o|F|11|2Z|2a|K9|3I|KC|3M|3M|2p|11|KF|3h","Inline double-quoted text","o|F|12|2Z|2a|K9|3I|KC|3M|3M|2p|12|KH|3h","Inline single-quoted text","o|F|13|2Z|2a|K9|3I|KC|3M|3M|2p|13|KJ|3h","An inline term, styled distinctively","o|F|14|2Z|2a|K9|3I|KC|3M|3M|2p|14|KL|3h","Inline code text","o|F|15|2Z|2a|K9|3I|KC|3M|3M|2p|15|KN|3h","Renders enclosed text as an opening tag, `< >`","o|F|16|2Z|2a|K9|3I|KC|3M|3M|2p|16|KP|3h","Renders enclosed text as a self-closing tag, `< />`","o|F|17|2Z|2a|K9|3I|KC|3M|3M|2p|17|KR|3h","Renders enclosed text as a closing tag, `</ >`","o|F|18|2Z|2a|K9|3I|KC|3M|3M|2p|18|KT|3h","Renders a styled attribute name","o|F|19|2Z|2a|K9|3I|KC|3M|3M|2p|19|KV|3h","_singleCharacterInline","a|KX|2c|2d","The unicode character rendered by this component.","o|3Q|1T|1T|2p|KZ","a|3N|3O|3P|3T|3U|3V|3W|3Z|Ka","Renders an en-dash (–) character","o|F|1A|54|AZ|KY|3I|Kb|3M|2p|2p|1A|Kc|3h","Renders an em-dash (—) character","o|F|1B|54|AZ|KY|3I|Kb|3M|2p|2p|1B|Ke|3h","Renders a non-breaking space character","o|F|1C|54|AZ|KY|3I|Kb|3M|2p|2p|1C|Kg|3h","Renders a horizontal ellipsis (…) character","o|F|1D|54|AZ|KY|3I|Kb|3M|2p|2p|1D|Ki|3h","Renders a left double quotation mark (“)","o|F|1E|54|AZ|KY|3I|Kb|3M|2p|2p|1E|Kk|3h","Renders a right double quotation mark (”)","o|F|1F|54|AZ|KY|3I|Kb|3M|2p|2p|1F|Km|3h","Renders a left single quotation mark (‘)","o|F|1G|54|AZ|KY|3I|Kb|3M|2p|2p|1G|Ko|3h","Renders a right single quotation mark (’)","o|F|1H|54|AZ|KY|3I|Kb|3M|2p|2p|1H|Kq|3h","styleDefinition","feedbackDefinition","a|1z|9A|G|9H|Ks|Kt|Af|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1000000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","_sectioningComponentNumberWithSiblings","_sectioningComponent","a|Kw|Kx|9W|2d","boxed","Whether to render this section with a visible box around it.","o|2m|Kz|L0|2p|2s|1V","includeAutoName",\'Whether to include the auto-generated section name (e.g. "Section") in the rendered title.\',"o|2m|L2|L3|2p|2s|1V","includeAutoNumber","Whether to include the auto-generated section number in the rendered title.","o|2m|L5|L6|2p|2s|1V","noAutoTitle","Whether to suppress the auto-generated title entirely.","o|2m|L8|L9|2p|2s|1V","includeAutoNameIfNoTitle","Whether to include the auto-generated name when no explicit title is provided.","o|2m|LB|LC|3M|2s|1V","includeAutoNumberIfNoTitle","Whether to include the auto-generated number when no explicit title is provided.","o|2m|LE|LF|3M|2s|1V","Whether to render this section\'s children as a list.","o|2m|20|LH|2p|2s|1V","collapsible","Whether the section can be collapsed and expanded.","o|2m|LJ|LK|2p|2s|1V","startOpen","Whether the collapsible section starts in the open state.","o|2m|LM|LN|3M|2s|1V","level","The heading level for this section (overrides the default level inferred from nesting).","o|2h|LP|LQ|1q","completedColor","Color used to indicate this section has been completed.","var(--lightGreen)","o|33|LS|LT|LU|1T","inProgressColor","Color used to indicate this section is in progress.","var(--mainGray)","o|33|LW|LX|LY|1T","notStartedColor","Color used to indicate this section has not been started.","o|33|La|Lb|LY|1T","completedColorDarkMode","Color used to indicate this section has been completed (dark mode). If omitted, the dark-mode color is derived from `completedColor` when that attribute is explicitly set; otherwise falls back to a dark green that meets WCAG AA contrast for white text.","#1a5e20","o|33|Ld|Le|Lf|1T","inProgressColorDarkMode","Color used to indicate this section is in progress (dark mode). If omitted, the dark-mode color is derived from `inProgressColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.","#3a3a3a","o|33|Lh|Li|Lj|1T","notStartedColorDarkMode","Color used to indicate this section has not been started (dark mode). If omitted, the dark-mode color is derived from `notStartedColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.","o|33|Ll|Lm|Lj|1T","includeParentNumber","Whether to prefix this section\'s number with the parent section\'s number.","o|2m|Lo|Lp|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|Lq","o|3L|L2|1V|2p|L3|3M","o|3L|L5|1V|2p|L6|3M","o|3L|L8|1V|2p|L9|3M","o|3L|LB|1V|2p|LC|3M","o|3L|LE|1V|2p|LF|3M","o|3L|20|1V|2p|LH|3M","o|3L|LJ|1V|2p|LK|3M","o|3L|Lo|1V|2p|Lp|3M","Whether this section is rendered with a visible box around it.","o|3Q|Kz|1V|2p|M0","sectionNumber","The displayed number for this section.","o|3Q|M2|1T|2p|M3","The displayed title text for this section.","o|3Q|G|1T|2p|M5","open","Whether this section is currently open (for collapsible sections).","o|3Q|M7|1V|2p|M8","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|Lz|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9","A section of a document, with a title (auto-generated or custom) and content","o|F|8D|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8D|MB|AT","A sectional component nested one heading level deeper than `<section>`","o|F|8E|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8E|MD|AT","A sectional component nested one heading level deeper than `<subsection>`","o|F|8F|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8F|MF|AT","o|2m|Lo|Lp|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH","A subsection of paragraphs (rendered at heading level 4)","o|F|8G|Ku|Kv|Ky|MI|MA|3M|3M|2p|8G|MJ|AT","o|2m|LJ|LK|3M|2s|1V","o|2m|LM|LN|2p|2s|1V","postponeRendering","Whether to delay rendering this section\'s contents until expanded.","o|Ap|MN|MO|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|ML|MM|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|MP","A note set off from the main flow of the document","o|F|8H|Ku|Kv|Ky|MQ|MA|3M|3M|2p|8H|MR|AT","o|2m|Kz|L0|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|MT|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH","A section listing learning objectives","o|F|8I|Ku|Kv|Ky|MU|MA|3M|3M|2p|8I|MV|AT","o|4d|9Y|9Z|9a|3M|2s|1V","isDistractor","Whether this section is a distractor (e.g. a wrong-answer choice for matching).","o|Ap|MY|MZ|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|MX|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|Ma","A sectional component that defines a scored problem","o|F|8J|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8J|Mc|AT","A sectional component that defines a scored exercise","o|F|8K|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8K|Me|AT","A sectional component that defines a scored question; similar to a `<problem>`","o|F|8L|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8L|Mg|AT","A sectional component with score aggregation, similar to `<problem>`","o|F|8M|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8M|Mi|AT","A sectional component that defines an example","o|F|8N|Ku|Kv|Ky|MI|MA|3M|3M|2p|8N|Mk|AT","A sectional component for defining a term or concept","o|F|8O|Ku|Kv|Ky|MI|MA|3M|3M|2p|8O|Mm|AT","A note section, set off from the main flow of the document","o|F|8P|Ku|Kv|Ky|MI|MA|3M|3M|2p|8P|Mo|AT","A sectional component for the statement of a theorem (or similar formal statement)","o|F|8Q|Ku|Kv|Ky|MI|MA|3M|3M|2p|8Q|Mq|AT","A subsection-style block rendered as a list item (a part of an exercise or problem)","o|F|8R|Ku|Kv|Ky|MI|MA|3M|3M|2p|8R|Ms|AT","A task of a multi-task activity or problem (alias for `<part>`)","o|F|8S|Ku|Kv|Ky|MI|MA|3M|3M|2p|8S|Mu|AT","_unnumberedSectioningComponent","a|Mw|Kx|9W|2d","o|2m|LE|LF|2p|2s|1V","renameTo",\'Override the auto-generated section name (e.g. rename "Section" to a custom label).\',"o|2h|Mz|N0|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|My|LI|ML|MM|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|MP","The displayed number for this section (always null for unnumbered sections).","o|3Q|M2|1T|2p|N3","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|N4|M6|M9","A proof section","o|F|8T|Ku|Kv|Mx|N2|N5|3M|3M|2p|8T|N6|AT","a|Kx|9W|2d","o|2m|20|LH|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|N9|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9","A container element grouping `<problem>` components, which are rendered as a list by default","o|F|8U|Ku|Kv|N8|NA|NB|3M|3M|2p|8U|NC|AT","A container element grouping `<exercise>` components, which are rendered as a list by default","o|F|8V|Ku|Kv|N8|NA|NB|3M|3M|2p|8V|NE|AT","li","a|NG|1z","Nesting level of this list (1-based).","o|2h|LP|NI|1q","marker","Marker style for list items (e.g. \'disc\', \'circle\', \'1\', \'a\').","o|33|NK|NL||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|NJ|NM|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5","An ordered list","o|F|8W|NH|BN|9X|NN|AR|3M|2p|2p|8W|NO|AT","An unordered list","o|F|8X|NH|BN|9X|NN|AR|3M|2p|2p|8X|NQ|AT","The list\'s content rendered as plain text.","o|3Q|1T|1T|2p|NS","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|NT","A list item within `<ol>` / `<ul>`","o|F|NG|9U|9V|Ao|A6|NU|2p|3M|2p|NG|NV|Az","a|H|1z","independentVariable","The independent variable of the ODE system.","t","o|5H|1X|Na","o|33|NY|NZ|Nb|H3","initialIndependentVariableValue","The value of the independent variable at which the initial conditions are specified.","0","o|5H|1X|Nf","o|33|Nd|Ne|Ng|1X",\'How to format the rendered system of equations (e.g. "align").\',"align","o|33|4k|Ni|Nj|1T","chunkSize","Step-size chunk used when numerically integrating the system.","n|A","o|33|Nl|Nm|Nn|1p","tolerance","Numerical tolerance used by the integrator.","n|0.Q0u","o|33|Np|Nq|Nr|1p","maxIterations","Maximum number of iterations the integrator may perform.","n|G8","o|33|Nt|Nu|Nv|1p","hideInitialCondition","Whether to hide the initial condition from the rendered output.","o|2m|Nx|Ny|2p|2s|1V","initialConditions","The initial values of each dependent variable, in order.","o|2h|O0|O1|1Y","The dependent variables of the system, in the same order as the right-hand sides.","o|2h|Gx|O3|Gz","Whether to display equation numbers next to each equation.","o|2m|1p|O5|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Nc|Nh|H8|4Y|4c|4g|4j|Nk|No|Ns|Nw|Nz|O2|O4|O6","o|3L|NY|H3|2p|NZ|3M","o|3L|Nd|1X|2p|Ne|3M","o|3L|4k|1T|2p|Ni|3M","o|3L|Nl|1p|2p|Nm|3M","o|3L|Np|1p|2p|Nq|3M","o|3L|Nt|1p|2p|Nu|3M","o|3L|Nx|1V|2p|Ny|3M","o|3L|1p|1V|2p|O5|3M","The dependent variables of the system, in order matching the right-hand sides.","o|6v|Gx|H3|3M|OG|36|I7","rhss","The right-hand-side expressions of each ODE in the system.","o|6v|OI|1X|3M|OJ|36|75","The initial values of each dependent variable at the initial independent variable value.","o|6v|O0|1X|3M|OL|36|75","The displayed equation number tag (when equation numbering is enabled).","o|3Q|BG|1T|2p|ON","The full ODE system rendered as a LaTeX string.","o|3Q|2V|2V|2p|OP","numericalSolutions","Numerical solution functions for each dependent variable, as functions of the independent variable.","o|73|3M|1r|36","a|OT","o|6v|OR|1r|3M|OS|36|OU","rhs","The right-hand-side expression of the first ODE in the system.","o|3Q|OW|1X|2p|OX","righthandside","o|3Q|OZ|1X|2p|OX","righthandsides","o|6v|Ob|1X|3M|OJ|36|75","initialCondition","The initial value of the first dependent variable at the initial independent-variable value.","o|3Q|Od|1X|2p|Oe","numericalSolution","Numerical solution function for the first dependent variable, as a function of the independent variable.","o|3Q|Og|1r|2p|Oh","a|3N|3O|3P|O8|O9|OA|OB|OC|OD|OE|OF|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|OH|OK|OM|OO|OQ|OV|OY|Oa|Oc|Of|Oi","A system of first-order ordinary differential equations with initial conditions, rendered as math and numerically integrable","o|F|1I|NX|BN|3l|O7|Oj|3M|2p|2p|1I|Ok|3h","a|I|J|1z|2S","1120","_graphical","a|Oo|2d","Whether to apply this component\'s selected style to its label.","o|2m|GI|Oq|2p|2s|1V","Z-order layer index used to stack graphical components (higher values render on top).","o|33|5O|Os|5Q|1q","Whether the polyline can be dragged on a graph.","o|2m|5L|Ou|3M|2s|1V","verticesDraggable","Whether individual vertices may be dragged independently.","o|Ap|Ow|Ox|2s|1V","vertices","The list of vertex points that define the shape.","o|2h|Oz|P0|2W","showCoordsWhenDragging","Whether to show coordinate labels while dragging.","o|2m|P2|P3|3M|2s|1V","rigid","Whether the polyline is treated as rigid (preserves shape under drag).","o|2m|P5|P6|2p|2s|1V","preserveSimilarity","Whether the shape is preserved up to similarity (uniform scaling) under drag.","o|2m|P8|P9|2p|2s|1V","rotationHandleVertices","Vertex indices that should display rotation handles when the shape is rigid or preserves similarity.","a|36","o|33|PB|PC|PD|1a","rotateAround","What point to rotate the shape around.","centroid","vertex","a|PH|PI|1d","Rotate around the centroid of the shape.","o|3s|PH|PK","Rotate around the vertex specified by `rotationVertex`.","o|3s|PI|PM","Rotate around the explicit point given by `rotationCenter`.","o|3s|1d|PO","a|PL|PN|PP","o|Bi|PF|PG|PH|PJ|PQ|3y","rotationCenter","The point to rotate around when rotateAround is \'point\'.","o|33|PS|PT||1d","rotationVertex","The vertex index to rotate around when rotateAround is \'vertex\'.","o|33|PV|PW|36|1q","allowRotation","Whether the polyline can be rotated under drag.","o|2m|PY|PZ|3M|2s|1V","allowTranslation","Whether the polyline can be translated under drag.","o|2m|Pb|Pc|3M|2s|1V","allowDilation","Whether the shape can be dilated (scaled) under drag.","o|2m|Pe|Pf|3M|2s|1V","minShrink","Minimum scaling factor allowed when dilating.","n|0.1","o|33|Ph|Pi|Pj|1p","allowReflection","Whether the polyline can be reflected under drag.","o|2m|Pl|Pm|3M|2s|1V","attractThreshold","Distance within which a dragged vertex snaps to the function curve or diagonal.","n|0.5","o|33|Po|Pp|Pq|1p","numPoints","Number of points (iterations) currently shown on the cobweb diagram.","o|33|Ps|Pt|36|1p","Symbol used as the independent variable when displaying iterate values.","o|5H|1X|7Q","o|33|H1|Pv|Pw|H3","numIterationsRequired","Minimum number of iterations the user is required to perform.","o|33|Py|Pz|5Q|1p","initialPoint","The starting point on the diagonal where iteration begins.","o|2h|Q1|Q2|1d","The function being iterated.","o|2h|1r|Q4|1r","lockToSolution","Whether to constrain dragged vertices to the correct cobweb solution.","o|2m|Q6|Q7|2p|2s|1V","defaultPoint","The default location for newly added points on the cobweb diagram.","o|2h|Q9|QA|1d","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|Pr|Pu|Px|Q0|Q3|Q5|Q8|QB","o|3L|GI|1V|2p|Oq|3M","o|3L|5O|1q|2p|Os|3M","o|3L|5L|1V|2p|Ou|3M","o|3L|P2|1V|2p|P3|3M","o|3L|P5|1V|2p|P6|3M","o|3L|PY|1V|2p|PZ|3M","o|3L|Pb|1V|2p|Pc|3M","o|3L|Pl|1V|2p|Pm|3M","o|3L|Po|1p|2p|Pp|3M","o|3L|Ps|1p|2p|Pt|3M","o|3L|H1|H3|2p|Pv|3M","o|3L|Py|1p|2p|Pz|3M","A textual description of the polyline\'s style.","o|3Q|Hl|1T|2p|QP",\'Style description including the word "polyline".\',"o|3Q|Ho|1T|2p|QR","Whether the polyline preserves its shape (up to similarity).","o|3Q|P8|1V|2p|QT","Whether the polyline can be dilated under drag.","o|3Q|Pe|1V|2p|QV","Whether each vertex can be dragged independently.","o|3Q|Ow|1V|2p|QX","The number of dimensions the polyline lives in.","o|3Q|6r|1p|2p|QZ","indexAliases","a|3|2g|3J|2f|6r|6u|Qb","The vertices of the polyline.","a|7Q|7T|7W","a|54|Qe","o|Qc|Oz|1X|3M|Qd|4X|IM|Qf","length","The total length of the polyline.","o|3Q|Qh|1p|2p|Qi","The centroid of the polyline\'s vertices.","o|6v|5b|1X|3M|Qk|36|IY","o|6v|Q1|1X|3M|Q2|36|IY","correctVertices","Per-vertex flags indicating whether each vertex is positioned at the correct cobweb solution.","o|73|3M|1V|36","a|Qp","o|6v|Qn|1V|3M|Qo|36|Qq","fractionCorrectVertices","The fraction of vertices placed at correct cobweb positions.","o|3Q|Qs|1p|2p|Qt","numGradedVertices","The number of cobweb vertices that were evaluated for correctness.","o|3Q|Qv|1p|2p|Qw","numCorrectVertices","The number of cobweb vertices placed at correct positions.","o|3Q|Qy|1p|2p|Qz","fractionCorrectVerticesAdjusted","The fraction of correct vertices, scaled by the required minimum number of iterations.","o|3Q|R1|1p|2p|R2","numGradedVerticesAdjusted","The effective number of graded vertices after adjusting for the required minimum number of iterations.","o|3Q|R4|1p|2p|R5","numIterateValues","The number of iterate values produced by the cobweb diagram.","o|3Q|R7|1p|2p|R8","iterateValues","The list of iterate values shown by the cobweb diagram.","o|6v|RA|1X|3M|RB|36|75","numVertices","Number of cobweb vertices currently shown (alias for numPoints).","o|3Q|RD|1p|2p|RE","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|Qa|Qg|Qj|Ql|Qm|Qr|Qu|Qx|R0|R3|R6|R9|RC|RF","An interactive cobweb diagram for visualizing iteration of a one-variable function","o|F|8Y|Om|On|Op|QC|RG|3M|2p|2p|8Y|RH|Az","constrainToGrid","constrainToGraph","attractToGrid","constrainTo","attractTo","constraintUnion","attractToConstraint","constrainToInterior","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|RJ|RK|RL|RM|RN|RO|RP|RQ|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q","112011111111111111111111111110220101221211112221111111122220122222222222222222222222222222","markerStyle","Marker shape.","square","triangleUp","triangleDown","triangleLeft","triangleRight","diamond","a|8u|RV|8r|RW|RX|RY|RZ|Ra","Circular marker.","o|3s|8u|Rc","Square marker.","o|3s|RV|Re",\'Triangular marker pointing up (alias for "triangleUp").\',"o|3s|8r|Rg","Triangular marker pointing up.","o|3s|RW|Ri","Triangular marker pointing down.","o|3s|RX|Rk","Triangular marker pointing left.","o|3s|RY|Rm","Triangular marker pointing right.","o|3s|RZ|Ro","Diamond-shaped marker.","o|3s|Ra|Rq","a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr","o|HC|RT|RU|Rb|Rs|3y","markerSize","Marker size in pixels.","o|2h|Ru|Rv|1p","Whether the point can be dragged on a graph.","o|2m|5L|Rx|3M|2s|1V","The first coordinate (x) of the point.","o|2h|7Q|Rz|1X","The second coordinate (y) of the point.","o|2h|7T|S1|1X","The third coordinate (z) of the point.","o|2h|7W|S3|1X","xs","The point\'s coordinates as a list.","o|2h|S5|S6|1Y","The point\'s coordinates as a single math expression.","o|2h|1e|S8|1e","Position of the point\'s label.","Place the label above and to the right of the point.","o|3s|5c|SB","Place the label above and to the left of the point.","o|3s|5d|SD","Place the label below and to the right of the point.","o|3s|5e|SF","Place the label below and to the left of the point.","o|3s|5f|SH","Place the label directly above the point.","o|3s|9|SJ","Place the label directly below the point.","o|3s|5g|SL","Place the label directly to the left of the point.","o|3s|5h|SN","Place the label directly to the right of the point.","o|3s|5i|SP","a|SC|SE|SG|SI|SK|SM|SO|SQ","o|Bi|GL|SA|5c|GN|SR|3y","addControls","Whether to render interactive control handles.","both","xOnly","yOnly","a|42|SV|SW|SX|2q|2r","Show no control handles.","o|3s|42|SZ","Show control handles for moving the point in both x and y.","o|3s|SV|Sb","Show a control handle that constrains motion to the x direction.","o|3s|SW|Sd","Show a control handle that constrains motion to the y direction.","o|3s|SX|Sf","a|Sa|Sc|Se|Sg","o|Bi|ST|SU|SV|SY|Sh|3y","hideOffGraphIndicator","Whether to suppress the indicator drawn at the edge when the point is off-screen.","o|Ap|Sj|Sk|2s|1V","controlOrder","Slot order for graph controls (1-indexed; 0 means no explicit slot request).","o|33|Sm|Sn|5Q|1q","stable","Whether the equilibrium is stable (rendered filled) or unstable (rendered open).","o|2m|Sp|Sq|3M|2s|1V","switchable","Whether the user can toggle the stability of this equilibrium by clicking it.","o|2m|Ss|St|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|Sr|Su","o|3L|5L|1V|2p|Rx|3M","o|3L|GL|1T|2p|SA|3M","o|3L|ST|1T|2p|SU|3M","o|3L|Sm|1q|2p|Sn|3M","o|3L|Sp|1V|2p|Sq|3M","o|3L|Ss|1V|2p|St|3M","scales","The graph axis scales (x and y) used when applying this constraint.","o|3Q|T2|1p|2p|T3","constraintUsed","Whether this constraint was applied to the component.","o|3Q|T5|1V|2p|T6","A textual description of the point\'s style.","o|3Q|Hl|1T|2p|T8",\'Style description including the word "point".\',"o|3Q|Ho|1T|2p|TA","Whether to suppress the off-graph indicator when out of view.","o|3Q|Sj|1V|2p|TC","Number of dimensions of the point.","o|3Q|6r|1p|2p|TE","o|6v|S5|1X|3M|S6|36|75","The point\'s coordinates as a math expression.","o|3Q|1e|1e|2p|TH","The point rendered as a LaTeX string.","o|3Q|2V|2V|2p|TJ","numDimensionsForConstraints","Number of dimensions exposed to constraint computations (alias for numDimensions).","o|3Q|TL|1p|2p|TM","o|3Q|7Q|1X|2p|Rz","o|3Q|7T|1X|2p|S1","o|3Q|7W|1X|2p|S3","o|3Q|3a|1e|2p|S8","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|T0|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","An equilibrium point of a dynamical system, rendered as a filled point if stable or open if unstable","o|F|1J|RR|RS|Op|Sv|TS|3M|3M|2p|1J|TT|Az","a|I|J|1z|2S|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","1120122221111111111111111111111222222222122220222212222201221222122222122221212222","Whether the line can be dragged on a graph.","o|2m|5L|TX|3M|2s|1V","equation","Implicit equation defining the line.","o|2h|TZ|Ta|1X","Points the line passes through.","o|2h|Gr|Tc|2W","slope","Slope of the line.","o|2h|Te|Tf|1p","perpendicularTo","Direction the line should be perpendicular to (e.g. another line or vector).","_directionComponent","o|2h|Th|Ti|Tj","parallelTo","Direction the line should be parallel to (e.g. another line or vector).","o|2h|Tl|Tm|Tj","Names of the variables used in the line equation.","o|2h|Gx|To|Gz","Where the label sits along this line/curve.","a|5c|5d|5e|5f|5b|9|5g|5h|5i","Place the label above and to the right of the line.","o|3s|5c|Ts","Place the label above and to the left of the line.","o|3s|5d|Tu","Place the label below and to the right of the line.","o|3s|5e|Tw","Place the label below and to the left of the line.","o|3s|5f|Ty","Place the label at the midpoint of the line.","o|3s|5b|U0","Place the label directly above the line.","o|3s|9|U2","Place the label directly below the line.","o|3s|5g|U4","Place the label directly to the left of the line.","o|3s|5h|U6","Place the label directly to the right of the line.","o|3s|5i|U8","a|Tt|Tv|Tx|Tz|U1|U3|U5|U7|U9","o|Bi|GL|Tq|5b|Tr|UA|3y","Whether the equilibrium is stable (rendered solid) or unstable (rendered dashed).","o|2m|Sp|UC|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|UD|Su","o|3L|5L|1V|2p|TX|3M","o|3L|GL|1T|2p|Tq|3M","o|3L|Sp|1V|2p|UC|3M","A textual description of the line\'s style.","o|3Q|Hl|1T|2p|UI",\'Style description including the word "line".\',"o|3Q|Ho|1T|2p|UK","Number of dimensions the line lives in.","o|3Q|6r|1p|2p|UM","Variable names used in the line\'s equation.","o|6v|Gx|H3|3M|UO|36|I7","points","Two points the line passes through.","o|Qc|UQ|1X|3M|UR|4X|IM|Qf","The line\'s equation as a math expression.","o|3Q|TZ|1X|2p|UT","coeff0","The constant term in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|UV|1X|2p|UW","coeffvar1","The coefficient of the first variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|UY|1X|2p|UZ","coeffvar2","The coefficient of the second variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|Ub|1X|2p|Uc","The slope of the line (2D only).","o|3Q|Te|1X|2p|Ue","xintercept","The x-intercept of the line.","o|3Q|Ug|1X|2p|Uh","yintercept","The y-intercept of the line.","o|3Q|Uj|1X|2p|Uk","The line\'s equation rendered as LaTeX.","o|3Q|2V|2V|2p|Um","The line\'s equation rendered as plain text.","o|3Q|1T|1T|2p|Uo","a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up","An equilibrium line of a dynamical system, rendered solid if stable or dashed if unstable","o|F|1K|TV|TW|Op|UE|Uq|3M|3M|2p|1K|Ur|Az","a|I|J|1z|2S|w|x|y|1r|1s|1g|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","11201110101222211111111111111111111112222221222202222122222011222122222122221212222","fillOpacity","Opacity of solid fills, 0 to 1.","o|2h|Uv|Uw|1p","fillPatternOpacity","Opacity of pattern fills (non-solid fillStyle), 0 to 1.","o|2h|Uy|Uz|1p","fillStyle","Fill pattern used inside closed shapes.","horizontal","vertical","diagonal","backDiagonal","dots","diamonds","a|HF|V3|V4|V5|V6|V7|V8","Solid fill.","o|3s|HF|VA","Horizontal line pattern.","o|3s|V3|VC","Vertical line pattern.","o|3s|V4|VE","Diagonal line pattern (/).","o|3s|V5|VG","Back-diagonal line pattern (\\\\).","o|3s|V6|VI","Dots pattern.","o|3s|V7|VK","Filled diamonds pattern.","o|3s|V8|VM","a|VB|VD|VF|VH|VJ|VL|VN","o|HC|V1|V2|V9|VO|3y","Whether the curve can be dragged on a graph.","o|2m|5L|VQ|3M|2s|1V","Position of the curve\'s label relative to the curve.","Place the label above and to the right of the curve.","o|3s|5c|VT","Place the label above and to the left of the curve.","o|3s|5d|VV","Place the label below and to the right of the curve.","o|3s|5e|VX","Place the label below and to the left of the curve.","o|3s|5f|VZ","Place the label directly above the curve.","o|3s|9|Vb","Place the label directly below the curve.","o|3s|5g|Vd","Place the label directly to the left of the curve.","o|3s|5h|Vf","Place the label directly to the right of the curve.","o|3s|5i|Vh","a|VU|VW|VY|Va|Vc|Ve|Vg|Vi","o|Bi|GL|VS|5c|GN|Vj|3y","flipFunction","Whether to swap the function and its argument (i.e., reflect across y=x).","o|2m|Vl|Vm|2p|2s|1V","numDiscretizationPoints","Number of points used when discretizing the curve for rendering.","o|33|Vo|Vp|Nv|1p","periodic","Whether the curve is treated as periodic when interpolating between control points.","o|2m|Vr|Vs|2p|2s|1V","splineTension","Tension parameter used when fitting a spline through control points.","n|0.8","o|33|Vu|Vv|Vw|1p","extrapolateBackward","Whether to extrapolate the curve before its first defined point.","o|2m|Vy|Vz|2p|2s|1V","extrapolateForward","Whether to extrapolate the curve beyond its last defined point.","o|2m|W1|W2|2p|2s|1V","splineForm","Form of spline used to interpolate between control points.","centripetal","uniform","a|W6|W7","Centripetal Catmull-Rom spline (avoids self-intersection at sharp turns).","o|3s|W6|W9","Uniform Catmull-Rom spline with evenly spaced parameterization.","o|3s|W7|WB","a|WA|WC","o|Bi|W4|W5|W6|W8|WD|3y","Name of the curve\'s parameter or independent variable.","o|33|H1|WF|Pw|H3","Points the interpolated curve passes through.","o|2h|Gr|WH|2W","parMin","Minimum value of the curve\'s parameter (for parametric curves).","o|2h|WJ|WK|1X","parMax","Maximum value of the curve\'s parameter (for parametric curves).","o|2h|WM|WN|1X","Whether to show coordinate labels while dragging the curve.","o|2m|P2|WP|3M|2s|1V","Whether nearest-point queries should treat this as a curve in the plane rather than a graph y = f(x).","o|2m|H9|WR|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j|UD|Su","o|3L|5L|1V|2p|VQ|3M","o|3L|GL|1T|2p|VS|3M","o|3L|Vl|1V|2p|Vm|3M","o|3L|Vo|1p|2p|Vp|3M","o|3L|Vr|1V|2p|Vs|3M","o|3L|Vu|1p|2p|Vv|3M","o|3L|Vy|1V|2p|Vz|3M","o|3L|W1|1V|2p|W2|3M","o|3L|W4|1T|2p|W5|3M","o|3L|P2|1V|2p|WP|3M","A textual description of the curve\'s style.","o|3Q|Hl|1T|2p|We",\'Style description including the word "curve".\',"o|3Q|Ho|1T|2p|Wg","Maximum value of the curve\'s parameter.","o|3Q|WM|1p|2p|Wi","Minimum value of the curve\'s parameter.","o|3Q|WJ|1p|2p|Wk","Number of dimensions the curve lives in.","o|3Q|6r|1p|2p|Wm","throughPoints","Points the curve is constrained to pass through.","o|6v|Wo|1X|3M|Wp|4X|IM","vectorControlDirections","Direction symmetry of each control vector pair.","o|6v|Wr|1T|3M|Ws|36|Jt","hiddenControls","Whether each control vector is currently hidden.","o|6v|Wu|1V|3M|Wv|36|Qq","controlVectors","The Bezier control vectors at each through-point.","o|73|3M|1h|4X","o|73|3M|1h|36","a|Wz|X0|6y","a|54|54|Qe","o|Qc|Wx|1X|3M|Wy|4S|X1|X2","controlPoints","The Bezier control points (vertex + offset) for each through-point.","o|73|3M|1d|4X","a|X6|IK|IL","o|6v|X4|1X|3M|X5|4S|X7","extrapolateBackwardMode","The extrapolation style used before the first through-point (e.g., \'line\', \'parabolaHorizontal\', \'parabolaVertical\').","o|3Q|X9|1T|2p|XA","extrapolateForwardMode","The extrapolation style used beyond the last through-point (e.g., \'line\', \'parabolaHorizontal\', \'parabolaVertical\').","o|3Q|XC|1T|2p|XD","fs","The component functions of the curve as functions of its parameter.","o|6v|XF|1r|3M|XG|36|OU","numXCriticalPoints","The number of x-critical points (horizontal tangents) on the curve.","o|3Q|XI|1q|2p|XJ","xCriticalPoints","The x-critical points (horizontal tangents) on the curve.","o|6v|XL|1p|3M|XM|4X|IM","numYCriticalPoints","The number of y-critical points (vertical tangents) on the curve.","o|3Q|XO|1q|2p|XP","yCriticalPoints","The y-critical points (vertical tangents) on the curve.","o|6v|XR|1p|3M|XS|4X|IM","numCurvatureChangePoints","The number of points where the curve\'s curvature changes sign.","o|3Q|XU|1q|2p|XV","curvatureChangePoints","Points where the curve\'s curvature changes sign (inflection points).","o|6v|XX|1p|3M|XY|4X|IM","The first component function of the curve as a function of its parameter.","o|3Q|4y|1r|2p|Xa","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb","An equilibrium curve of a dynamical system, rendered solid if stable or dashed if unstable","o|F|8Z|Ut|Uu|Op|WT|Xc|3M|3M|2p|8Z|Xd|Az","symbol",\'The chemical symbol of the atom (e.g. "H", "He", "Li").\',"o|2h|Xf|Xg|1T","atomicNumber","The atomic number of the atom (number of protons).","o|2h|Xi|Xj|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|Xh|Xk|H8|4Y|4c|4g|4j","The atomic number of the element.","o|3Q|Xi|1q|2p|Xm","The chemical symbol of the element.","o|3Q|Xf|1T|2p|Xo","The full name of the element.","o|3Q|3|1T|2p|Xq","The group number of the element in the periodic table.","o|3Q|23|1q|2p|Xs","atomicMass","The atomic mass of the element.","o|3Q|Xu|1p|2p|Xv","phaseAtSTP","The phase (solid, liquid, or gas) of the element at standard temperature and pressure.","o|3Q|Xx|1T|2p|Xy","chargeOfCommonIon","The charge of the most common ion of this element.","o|3Q|Y0|1q|2p|Y1","metalCategory","The metal category of the element (e.g. alkali metal, transition metal, nonmetal).","o|3Q|Y3|1T|2p|Y4",`The descriptive name of the element\'s periodic group (e.g. "Alkali metals").`,"o|3Q|4N|1T|2p|Y6","period","The period number of the element in the periodic table.","o|3Q|Y8|1q|2p|Y9","ionizationEnergy","The first ionization energy of the element.","o|3Q|YB|1p|2p|YC","meltingPoint","The melting point of the element.","o|3Q|YE|1p|2p|YF","boilingPoint","The boiling point of the element.","o|3Q|YH|1p|2p|YI","atomicRadius","The atomic radius of the element.","o|3Q|YK|1q|2p|YL","density","The density of the element at standard conditions.","o|3Q|YN|1p|2p|YO","electronegativity","The Pauling electronegativity of the element.","o|3Q|YQ|1p|2p|YR","The electron configuration of the element as a math expression.","o|3Q|1O|1O|2p|YT","The orbital diagram of the element.","o|3Q|8a|8a|2p|YV","The atom rendered as a math expression with the element symbol.","o|3Q|1X|1X|2p|YX","The atom rendered as a LaTeX string.","o|3Q|2V|2V|2p|YZ","The atom rendered as a plain text string.","o|3Q|1T|1T|2p|Yb","a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|Xn|Xp|Xr|Xt|Xw|Xz|Y2|Y5|Y7|YA|YD|YG|YJ|YM|YP|YS|YU|YW|YY|Ya|Yc","Represents a chemical element by symbol or atomic number, exposing its periodic-table properties","o|F|1L|54|AZ|3l|Xl|Yd|3M|2p|2p|1L|Ye|3h","a|1L|1z",\'The chemical symbol of the element (e.g. "Na", "Cl").\',"o|2h|Xf|Yh|1T","o|2h|Xi|Xm|1q","charge","The charge of the ion (positive for cations, negative for anions).","o|2h|Yk|Yl|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|Yi|Yj|Ym","The charge of the ion.","o|3Q|Yk|1q|2p|Yo",\'The full name of the ion (e.g. "sodium ion").\',"o|3Q|3|1T|2p|Yq","The group number of the underlying element in the periodic table.","o|3Q|23|1q|2p|Ys","The metal category of the underlying element (e.g. alkali metal, transition metal, nonmetal).","o|3Q|Y3|1T|2p|Yu","The descriptive name of the underlying element\'s periodic group.","o|3Q|4N|1T|2p|Yw","The period number of the underlying element in the periodic table.","o|3Q|Y8|1q|2p|Yy","The ion rendered as a math expression (element symbol with charge).","o|3Q|1X|1X|2p|Z0","The ion rendered as a LaTeX string.","o|3Q|2V|2V|2p|Z2","The ion rendered as a plain text string.","o|3Q|1T|1T|2p|Z4","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|Xn|Xp|Yp|Yr|Yt|Yv|Yx|Yz|Z1|Z3|Z5","Represents a charged ion specified by element and charge, rendered with its chemical formula","o|F|1M|Yg|BN|3l|Yn|Z6|3M|2p|2p|1M|Z7|3h","a|1L|1M|1z","202","The chemical symbol of an element in the compound.","o|2h|Xf|ZB|1T","The atomic number of an element in the compound.","o|2h|Xi|ZD|1q","The charge of an ion in the compound.","o|2h|Yk|ZF|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|ZC|ZE|ZG","The ionic compound rendered as a math expression of its chemical formula.","o|3Q|1X|1X|2p|ZI","The ionic compound rendered as a LaTeX string.","o|3Q|2V|2V|2p|ZK","The ionic compound rendered as a plain text string.","o|3Q|1T|1T|2p|ZM","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|ZJ|ZL|ZN","Forms a balanced ionic compound from constituent ions and renders its chemical formula","o|F|1N|Z9|ZA|3l|ZH|ZO|3M|2p|2p|1N|ZP|3h","o|3Q|3a|1O|2p|6e","The electron configuration rendered as a LaTeX string.","o|3Q|2V|2V|2p|ZS","The electron configuration rendered as a unicode text string.","o|3Q|1T|1T|2p|ZU","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ZR|6h|6j|6m|ZT|ZV|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Renders an electron configuration with sublevel labels and superscripted electron counts","o|F|1O|3j|3k|3l|64|ZW|3M|3M|2p|1O|ZX|3h","a|1Z|1z|8a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","02012222111111111111111111111122222222212222022212222201221222122222122221212222","Text labels for each orbital row.","o|33|GG|Zb|54|1U","a|2j|2t|2w|2z|32|37|3A|3E|3H|Zc","The orbital diagram value as a list of rows, each with a label and boxes containing up/down arrows.","o|3Q|3a|8a|2p|Ze","a|3N|3O|3P|3T|3U|3V|3W|3Z|Zf","Renders an orbital diagram showing electrons in atomic orbitals as up/down arrows in boxes","o|F|8a|ZZ|Za|9X|Zd|Zg|3M|3M|2p|8a|Zh|AT","prefill","An orbital diagram used to prefill the input before the student begins.","o|33|Zj|Zk|54|8a","prefillLabel","Text labels to prefill for each orbital row.","o|33|Zm|Zn|54|1U","a|2j|2t|2w|2z|32|37|3A|3E|3H|Zl|Zo","The current orbital diagram entered by the student.","o|3Q|3a|8a|2p|Zq","The orbital diagram rows in display order (reversed from the underlying value).","o|3Q|7K|8a|2p|Zs","The number of orbital rows in the diagram.","o|3Q|7A|1q|2p|Zu","selectedRowIndex","Index of the currently selected orbital row (1-based; 0 if none selected).","o|3Q|Zw|1q|2p|Zx","selectedBoxIndex","Index of the currently selected box within the selected row (1-based; 0 if none selected).","o|3Q|Zz|1q|2p|a0","a|3N|3O|3P|3T|3U|3V|3W|3Z|Zr|Zt|Zv|Zy|a1","An interactive widget where students fill in an orbital diagram by adding boxes, rows, and up/down arrows (block-level; does not inherit from Input)","o|F|8b|54|AZ|9X|Zp|a2|3M|2p|2p|8b|a3|AT","code","Identifier used to reference this feedback definition.","o|2h|a5|a6|1T","Default feedback text for this code.","o|2h|1T|a8|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|a7|a9","A reusable feedback definition referenced by other components","o|F|Kt|54|AZ|Ao|aA|Aa|3M|2p|2p|Kt|aB|Az","Index identifying which style this definition applies to.","o|33|34|aD|36|1q","lineColor","Color used for line strokes (light mode).","o|2h|aF|aG|1T","lineColorWord","Human-readable name of the line color (light mode).","o|2h|aI|aJ|1T","lineColorDarkMode","Color used for line strokes (dark mode).","o|2h|aL|aM|1T","lineColorWordDarkMode","Human-readable name of the line color (dark mode).","o|2h|aO|aP|1T","lineOpacity","Opacity of line strokes, 0 to 1.","o|2h|aR|aS|1p","lineWidthWord","Human-readable name of the line width.","o|2h|aU|aV|1T","lineStyleWord","Human-readable name of the line style.","o|2h|aX|aY|1T","markerColor","Color used for markers/points (light mode).","o|2h|aa|ab|1T","markerColorWord","Human-readable name of the marker color (light mode).","o|2h|ad|ae|1T","markerColorDarkMode","Color used for markers/points (dark mode).","o|2h|ag|ah|1T","markerColorWordDarkMode","Human-readable name of the marker color (dark mode).","o|2h|aj|ak|1T","markerOpacity","Opacity of markers/points, 0 to 1.","o|2h|am|an|1p","cross","plus","a|8u|RV|8r|RW|RX|RY|RZ|Ra|ap|aq","Cross-shaped marker (×).","o|3s|ap|as","Plus-shaped marker (+).","o|3s|aq|au","a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr|at|av","o|HC|RT|RU|ar|aw|3y","markerStyleWord","Human-readable name of the marker style.","o|2h|ay|az|1T","markerFilled","Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior.","o|Ap|b1|b2|2s|1V","fillColor","Fill color used inside closed shapes (light mode).","o|2h|b4|b5|1T","fillColorWord","Human-readable name of the fill color (light mode).","o|2h|b7|b8|1T","fillColorDarkMode","Fill color used inside closed shapes (dark mode).","o|2h|bA|bB|1T","fillColorWordDarkMode","Human-readable name of the fill color (dark mode).","o|2h|bD|bE|1T","fillStyleWord","Human-readable name of the fill style.","o|2h|bG|bH|1T","Text color (light mode).","o|2h|6L|bJ|1T","textColorWord","Human-readable name of the text color (light mode).","o|2h|bL|bM|1T","textColorDarkMode","Text color (dark mode).","o|2h|bO|bP|1T","textColorWordDarkMode","Human-readable name of the text color (dark mode).","o|2h|bR|bS|1T","highContrastColor","High-contrast accent color (light mode).","o|2h|bU|bV|1T","highContrastColorWord","Human-readable name of the high-contrast accent color (light mode).","o|2h|bX|bY|1T","highContrastColorDarkMode","High-contrast accent color (dark mode).","o|2h|ba|bb|1T","highContrastColorWordDarkMode","Human-readable name of the high-contrast accent color (dark mode).","o|2h|bd|be|1T","Background color (light mode).","o|2h|6O|bg|1T","backgroundColorWord","Human-readable name of the background color (light mode).","o|2h|bi|bj|1T","backgroundColorDarkMode","Background color (dark mode).","o|2h|bl|bm|1T","backgroundColorWordDarkMode","Human-readable name of the background color (dark mode).","o|2h|bo|bp|1T","a|2j|2t|2w|2z|32|aE|3A|3E|3H|aH|aK|aN|aQ|aT|HT|aW|HQ|aZ|ac|af|ai|al|ao|ax|b0|Rw|b3|b6|b9|bC|bF|Ux|V0|VP|bI|bK|bN|bQ|bT|bW|bZ|bc|bf|bh|bk|bn|bq","a|3N|3P|3T|3U|3V|3W|3Z","A reusable style definition referenced by other components","o|F|Ks|54|AZ|Ao|br|bs|3M|2p|2p|Ks|bt|Az","a|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|1b|8y|92|96|97|98|1w|1x|1y|1z|22|23|9C|9D|9E|9F|2D|2I|9I|2L|2M|9J|2P|9N|9Q|9S|9T","1111111111111111111111111111111111111211111222222111122122121111","width","Total rendered width of the side-by-side container.","componentSize","o|2h|bx|by|bz","widths","List of widths for each panel.","_componentSizeList","o|2h|c1|c2|c3","margins","List of margin widths between panels.","o|2h|c5|c6|c3","valign","Default vertical alignment for all panels.","middle","a|9|cA|5g","Align panels to the top.","o|3s|9|cC","Vertically center panels.","o|3s|cA|cE","Align panels to the bottom.","o|3s|5g|cG","a|cD|cF|cH","o|HC|c8|c9|cB|cI|3y","isList","a|3|2f|2l|3n|cK|2g","valigns","Per-panel vertical alignment values.","Align the panel to the top.","o|3s|9|cO","Vertically center the panel.","o|3s|cA|cQ","Align the panel to the bottom.","o|3s|5g|cS","a|cP|cR|cT","o|cL|cM|cN|cB|cU|3M|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|c0|c4|c7|cJ|cV","absoluteMeasurements","Whether children\'s widths are interpreted in absolute units.","o|3Q|cX|1V|2p|cY","gapWidth","The gap width between panels as a percentage of the total container width.","o|3Q|ca|1p|2p|cb","The list of child widths.","o|6v|c1|1p|3M|cd|36|IR","Margins between adjacent children.","o|6v|c5|1p|3M|cf|36|IR","Vertical alignment of each child.","o|6v|cM|1T|3M|ch|36|Jt","a|3N|3O|3P|3T|3U|3V|3W|3Z|cZ|cc|ce|cg|ci","Renders children in a side-by-side horizontal layout","o|F|8c|bv|bw|9X|cW|cj|3M|2p|2p|8c|ck|AT","a|8c|1z","A group of `<sideBySide>` components that share alignment and spacing","o|F|8d|cm|BN|9X|cW|cj|3M|2p|2p|8d|cn|AT","A vertical container element for organizing content within a `<sideBySide>`","o|F|8e|9U|9V|9X|3I|Aa|3M|3M|2p|8e|cp|AT","A generic block-level container","o|F|8f|9U|9V|9X|A6|AR|3M|3M|2p|8f|cr|AT","A generic inline container","o|F|1P|9U|9V|3l|A6|AR|3M|3M|2p|1P|ct|3h","A preformatted block preserving whitespace","o|F|8g|9U|9V|9X|3I|Aa|3M|3M|2p|8g|cv|AT","The verbatim text content.","o|3Q|1T|1T|2p|cx","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|cy","Displays a DoenetML source string verbatim","o|F|1Q|9U|9V|3l|3I|cz|3M|3M|2p|1Q|d0|3h","initialPage","1-based page index shown on first render.","o|33|d2|d3|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|d4","numPages","The total number of pages.","o|3Q|d6|1q|2p|d7","currentPage","The currently displayed page (1-based).","o|3Q|d9|1q|2p|dA","a|3N|3O|3P|3T|3U|3V|3W|3Z|d8|dB","Defines a paginated section of content","o|F|8h|9U|9V|9X|d5|dC|3M|3M|2p|8h|dD|AT","previousLabel",\'Label for the "previous page" button.\',"Previous","o|33|dF|dG|dH|1T","nextLabel",\'Label for the "next page" button.\',"Next","o|33|dJ|dK|dL|1T","pageLabel","Label format for the current page indicator.","Page","o|33|dN|dO|dP|1T","Reference to the `<paginator>` these controls operate on.","o|2h|8h|dR|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H|dI|dM|dQ|dS","o|3L|dF|1T|2p|dG|3M","o|3L|dJ|1T|2p|dK|3M","o|3L|dN|1T|2p|dO|3M","disabledDirectly","Whether the controls are disabled directly (rather than via inheritance).","o|3Q|dX|1V|2p|dY","a|3N|3O|3P|dU|dV|dW|3T|3U|3V|3W|3Z|dZ","Previous/next page controls referencing a paginator elsewhere in the document","o|F|8i|54|AZ|9X|dT|da|3M|2p|2p|8i|db|AT","shortDescription","a|I|J|1z|2S|2f|dd|2U","1120000","_input","a|dg|2c|2d","Position of the label relative to the input.","a|5h|5i","Place the label to the left of the input.","o|3s|5h|dk","Place the label to the right of the input.","o|3s|5i|dm","a|dl|dn","o|Bi|GL|di|5h|dj|do|3y","forAnswer","References to `<answer>` elements that this input should submit to.","o|2h|dq|dr|3D","Number of rows in the matrix input.","o|33|7A|dt|36|1q","Number of columns in the matrix input.","o|33|7D|dv|36|1q","showSizeControls","Whether to render controls for resizing the matrix.","o|2m|dx|dy|3M|2s|1V","defaultEntry","Default value used for empty matrix cells.","o|33|e0|e1|5J|1X","Initial matrix value displayed in the input.","o|33|Zj|e3|5J|1X","Input format for the math entered.","o|Bi|3p|e5|1T|3r|3x|3y","o|4U|4P|4Q|4R|Nn|1q","o|4U|4Z|4a|4R|5Q|1p","bindValueTo","Two-way binding target for the input\'s value.","o|2h|e9|eA|1X","unionFromU",\'Whether "U" between sets is parsed as union.\',"o|2m|eC|eD|2p|2s|1V","minComponentWidth","Minimum rendered width for each cell, in pixels.","o|33|eF|eG|5Q|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|du|dw|dz|e2|e4|e6|51|58|5B|e7|4Y|e8|4g|4j|eB|eE|eH","o|3L|GL|1T|2p|di|3M","o|3L|dx|1V|2p|dy|3M","o|3L|Zj|1X|2p|e3|3M","o|3L|3p|1T|2p|e5|3M","o|3L|eC|1V|2p|eD|3M","A short accessibility description of this input; it is visible to screen readers but not rendered visually.","o|3Q|dd|1T|2p|eO","focused","Whether the matrix input currently has keyboard focus.","o|3Q|eQ|1V|2p|eR","valueChanged","Whether the value has been changed from its initial state.","o|3Q|eT|1V|2p|eU","immediateValueChanged","Whether the value, including in-progress edits, has been changed from its initial state.","o|3Q|eW|1V|2p|eX","The number of rows of the matrix.","o|3Q|7A|1q|2p|eZ","The number of columns of the matrix.","o|3Q|7D|1q|2p|eb","The matrix value of the input.","o|3Q|3a|1X|2p|ed","immediateValue","The matrix value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|eg","The current matrix as a text string.","o|3Q|1T|1T|2p|ei","The matrix as a math expression.","o|6v|2U|1X|3M|ek|4X|7I","a|3N|3O|3P|eJ|Hd|eK|eL|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|eS|6X|6Y|6Z|6a|6b|eV|eY|ea|ec|ee|eh|ej|el|7P|7M","An interactive matrix input where each cell accepts a math value","o|F|1R|de|df|dh|eI|em|3M|2p|2p|1R|en|3h","a|I|J|1z|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","112000122221111111111111111111111222222222122220222212222222221222122222122221212222","prefillNumerator","Initial value displayed in the numerator input.","o|33|er|es|5J|1X","prefillDenominator","Initial value displayed in the denominator input.","o|33|eu|ev|5J|1X","Minimum rendered width for the numerator and denominator, in pixels.","o|33|eF|ex|5Q|1q","Two-way binding target for the fraction\'s value.","o|2h|e9|ez|1X","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|et|ew|e6|51|58|5B|e7|4Y|e8|4g|4j|eE|ey|f0","o|3L|er|1X|2p|es|3M","o|3L|eu|1X|2p|ev|3M","Whether the fraction input currently has keyboard focus.","o|3Q|eQ|1V|2p|f4","The fraction value of the input (numerator divided by denominator).","o|3Q|3a|1X|2p|f6","The fraction value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|f8","numerator","The numerator of the fraction.","o|3Q|fA|1X|2p|fB","denominator","The denominator of the fraction.","o|3Q|fD|1X|2p|fE","The current fraction as a text string.","o|3Q|1T|1T|2p|fG","a|3N|3O|3P|eJ|Hd|f2|f3|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|f5|6X|6Y|6Z|6a|6b|eV|f7|eY|f9|fC|fF|fH","An interactive fraction input with a numerator and a denominator, each accepting a math value.","o|F|1S|ep|eq|dh|f1|fI|3M|2p|2p|1S|fJ|3h","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T","111111111111111111111111111111111111111111111111111111111111111112211111111121212222121212211111111111222222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111","Whether the solution is initially hidden.","o|2m|2n|fN|2p|2s|1V","a|2j|fO|2w|2z|32|37|3A|3E|3H","Whether the solution is currently hidden.","o|3Q|2n|1V|2p|fQ","Whether the solution is currently open (revealed).","o|3Q|M7|1V|2p|fS","a|3O|3P|3T|3U|3V|3W|3Z|fR|fT","A solution to an exercise, shown on demand","o|F|8j|fL|fM|9X|fP|fU|3M|3M|2p|8j|fV|AT",\'A sectional component that renders an expandable block labeled "Answer"\',"o|F|8k|fL|fM|9X|fP|fU|3M|3M|2p|8k|fX|AT","a|1z|9A|G|9H|Ks|Kt|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","100000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","xmlns","XML namespace declaration (accepted for compatibility; not used).","o|2h|fb|fc|1T","Document type identifier.","o|2h|2g|fe|1T","a|2j|32|3E|3H|9h|9l|9o|9r|9u|9y|A2|A5|fd|ff","Aggregate credit achieved (0 to 1) for scored content in the document.","o|3Q|AL|1p|2p|fh","Aggregate credit achieved as a percentage (0 to 100) for scored content in the document.","o|3Q|AO|1p|2p|fj","The document\'s title.","o|3Q|G|1T|2p|fl","a|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|fi|fk|fm","The top-level container for a DoenetML document (added implicitly if not present)","o|F|8l|fZ|fa|Ao|fg|fn|3M|3M|2p|8l|fo|Az","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19","2222222222222222222222222222222222222212220222222222222222222222221122222212111111111111111111","The text value.","o|3Q|3a|1T|2p|fs","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|ft|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4","A text string","o|F|1T|fq|fr|3l|Jc|fu|3M|3M|2p|1T|fv|3h","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X","2222222222222222222222222222222222222212220222222222222222222222221122222212","_composite","a|fz|2d","a|3|2f|2k","o|g1|2x|2y|2p","a|3|2f","o|g3|38|39","Whether the order of items should be treated as unordered.","o|2m|4n|g5|2p|2s|1V","maxNumber","Maximum number of items to retain in the list.","o|33|g7|g8|9k|1p","Whether to render the items separated by commas (true) or with no separator (false).","o|2m|20|gA|3M|2s|1V","a|2j|2t|2w|g2|32|37|g4|3E|3H|g6|g9|gB","o|3L|4n|1V|2p|g5|3M","o|3L|g7|1p|2p|g8|3M","numComponents","The number of items in the text list.","o|3Q|gF|1p|2p|gG","numValues","The number of text values in the list.","o|3Q|gI|1p|2p|gJ","a|3N|3O|gD|gE|3Z|gH|gK","A list of texts","o|F|1U|fx|fy|g0|gC|gL|3M|3M|3M|1U|gM|Az","A paragraph of inline content","o|F|8m|Ag|Ah|9X|A6|Ak|3M|3M|2p|8m|gO|AT","The boolean value (true or false).","o|3Q|3a|1V|2p|gQ","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|gR|CW","A boolean value","o|F|1V|BY|BZ|3l|CI|gS|3M|3M|2p|1V|gT|3h","Whether the order of items in this list should be treated as unordered (e.g. for matching).","o|2m|4n|gV|2p|2s|1V","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB","o|3L|4n|1V|2p|gV|3M","The number of items in the boolean list.","o|3Q|gF|1p|2p|gZ","The number of booleans in the list.","o|3Q|gI|1p|2p|gb","a|3N|3O|gY|gE|3Z|ga|gc","A list of booleans","o|F|1W|Cc|Cd|g0|gX|gd|3M|3M|3M|1W|ge|Az","o|3Q|3a|1X|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A math expression","o|F|1X|3j|3k|3l|64|gh|3M|3M|2p|1X|gi|3h","mergeMathLists","Whether nested math-list children should be flattened into this list.","o|Ap|gk|gl|2s|1V","o|g3|4P|4Q","o|g3|4V|4W","o|g3|4Z|4a","o|g3|4e|4f","o|g3|4h|4i","Symbols treated as function names when parsing items.","o|33|4w|gs|50|1U","References whose names should be treated as function symbols when parsing items.","o|33|52|gu|54|3D","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gm|gB|gn|go|gp|gq|gr|gt|gv|58|5B","o|3L|4w|1U|2p|gs|3M","o|3Q|4n|1V|2p|gV","Whether nested math lists are merged into the parent list.","o|3Q|gk|1V|2p|gz","The number of items in the math list.","o|3Q|gF|1p|2p|h1","The number of math expressions in the list.","o|3Q|gI|1p|2p|h3","a|3N|3O|gE|gx|6D|6E|3Z|gy|h0|h2|h4","A list of math expressions","o|F|1Y|3j|3k|g0|gw|h5|3M|3M|3M|1Y|h6|Az","A list of math tuples, parsed from parenthesized comma-separated pieces","o|F|1Z|3j|3k|g0|gw|h5|3M|3M|3M|1Z|h8|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y","1111111111111111111111121220222101122221222221222112222222222222222222222222222","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB|gn|go|gp|gq|gr","The number of items in the number list.","o|3Q|gF|1p|2p|hD","The number of numbers in the list.","o|3Q|gI|1p|2p|hF","a|3N|3O|gE|3Z|gy|hE|hG","A list of numbers","o|F|1a|hA|hB|g0|hC|hH|3M|3M|3M|1a|hI|Az","Maximum number of descendants to collect.","o|33|g7|hK||1p","from","Component subtree(s) to collect descendants from.","o|2h|hM|hN|3D","componentType","Component type of descendants to collect.","o|2h|hP|hQ|1T","a|2j|32|3E|3H|hL|hO|hR|gB","o|3L|g7|1p|2p|hK|3M","a|hT|3Z","Collects descendants of a component matching a specified component type","o|F|1b|54|AZ|g0|hS|hU|3M|2p|3M|1b|hV|Az","to","The target that the reference points to (component reference or URL string).","referenceOrText","o|2h|hX|hY|hZ","textType","Type of text to use for the reference label.","type-global","o|33|hb|hc|hd|1T","createButton","Whether to render this reference as a clickable button.","o|2m|hf|hg|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|ha|he|hh","o|3L|hb|1T|2p|hc|3M","url","The resolved URL of the referenced component.","o|3Q|hk|1T|2p|hl","linkText","The display text used for the link.","o|3Q|hn|1T|2p|ho","The text used as the link label.","o|3Q|1T|1T|2p|hq","a|3N|3O|3P|hj|3T|3U|3V|3W|3Z|hm|hp|hr","A link to a component reference or to a URL","o|F|1c|9U|9V|3l|hi|hs|3M|3M|2p|1c|ht|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|ax|Rw|b3|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","A point with coordinates that can be displayed and dragged on a graph","o|F|1d|RR|RS|Op|hv|hw|3M|3M|2p|1d|hx|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|1e|2p|6e","Whether tuple-like expressions render as vectors (always true for `<coords>`).","o|3Q|4q|1V|2p|i1","a|3N|3O|3P|66|67|68|69|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|i0|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|i2|7S|7V|7Y|7b","A math expression treated as a vector of coordinates","o|F|1e|3j|3k|3l|hz|i3|3M|3M|2p|1e|i4|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB","a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up","A line through two points or defined by an equation","o|F|1f|TV|TW|Op|i6|i7|3M|3M|2p|1f|i8|Az","Whether the line segment can be dragged on a graph.","o|2m|5L|iA|3M|2s|1V","endpointsDraggable","Whether the line segment\'s endpoints can be dragged.","o|Ap|iC|iD|2s|1V","endpoints","The two endpoints of the line segment.","o|2h|iF|iG|2W","a|iF|42|2q|2r","Show control handles for both endpoints of the segment.","o|3s|iF|iJ","a|iK|Sa","o|Bi|ST|SU|iF|iI|iL|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|iB|iE|iH|iM|P4|UB|H8|4Y|4c|4g|4j|So","o|3L|5L|1V|2p|iA|3M","A textual description of the line segment\'s style.","o|3Q|Hl|1T|2p|iP",\'Style description including "line segment".\',"o|3Q|Ho|1T|2p|iR","Whether each endpoint can be dragged independently.","o|3Q|iC|1V|2p|iT","Number of dimensions the segment lives in.","o|3Q|6r|1p|2p|iV","The endpoints of the line segment.","o|Qc|iF|1X|3M|iX|4X|IM|Qf","The length of the line segment.","o|3Q|Qh|1X|2p|iZ","The slope of the line segment (2D only).","o|3Q|Te|1p|2p|ib","a|3N|3O|3P|Hd|QD|7s|QE|iO|Sy|QG|UG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|iQ|iS|iU|iW|iY|ia|ic","A line segment between two endpoints","o|F|8n|Om|On|Op|iN|id|3M|2p|2p|8n|ie|Az","Whether the ray can be dragged on a graph.","o|2m|5L|ig|3M|2s|1V","The starting point (endpoint) of the ray.","o|2h|2K|ii|1d","A point the ray passes through (used with endpoint or direction).","o|2h|Gr|ik|1d","direction","The direction the ray points in.","o|2h|im|in|1h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|ih|ij|il|io|UB|H8|4Y|4c|4g|4j","o|3L|5L|1V|2p|ig|3M","A textual description of the ray\'s style.","o|3Q|Hl|1T|2p|ir",\'Style description including the word "ray".\',"o|3Q|Ho|1T|2p|it","Number of dimensions the ray lives in.","o|3Q|6r|1p|2p|iv","The direction vector of the ray.","o|6v|im|1X|3M|ix|36|6z","A point the ray passes through.","a|Qe","o|Qc|Gr|1X|3M|iz|36|IY|j0","The starting endpoint of the ray.","o|Qc|2K|1X|3M|j2|36|IY|j0","a|3N|3O|3P|Hd|QD|7s|QE|iq|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|is|iu|iw|iy|j1|j3","A ray starting at one point passing through another","o|F|8o|Om|On|Op|ip|j4|3M|2p|2p|8o|j5|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j","The number of vertices in the polyline.","o|3Q|RD|1p|2p|j8","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|j9|Qa|Qg|Qj|Ql","A polyline (open polygon) defined by a list of vertices","o|F|8p|Om|On|Op|j7|jA|3M|2p|2p|8p|jB|Az","Whether to render interactive vertex control handles.","a|5b|42|2q|2r","Show a control handle for moving the polygon\'s center.","o|3s|5b|jF","a|jG|Sa","o|Bi|ST|jD|5b|jE|jH|3y","filled","Whether to fill the interior of the polygon.","o|2m|jJ|jK|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|jI|jL|So","o|3L|ST|1T|2p|jD|3M","o|3L|jJ|1V|2p|jK|3M","A textual description of the polygon\'s style.","o|3Q|Hl|1T|2p|jP",\'Style description including the word "polygon".\',"o|3Q|Ho|1T|2p|jR","borderStyleDescription","A textual description of the polygon\'s border style.","o|3Q|jT|1T|2p|jU","fillStyleDescription","A textual description of the polygon\'s fill style.","o|3Q|jW|1T|2p|jX","perimeter","The perimeter of the polygon.","o|3Q|jZ|1p|2p|ja","area","The area enclosed by the polygon.","o|3Q|jc|1p|2p|jd","numSides","The number of sides of the polygon.","o|3Q|jf|1p|2p|jg","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|j9|Qa|Qg|Ql|jV|jY|jb|je|jh","A polygon defined by a list of vertices","o|F|8q|Om|On|Op|jM|ji|3M|2p|2p|8q|jj|Az","The number of vertices (always 3 for a triangle).","o|3Q|RD|1p|2p|jl","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|jm|Qa|Qg|Ql|jV|jY|jb|je|jh","A triangle defined by three vertices","o|F|8r|Om|On|Op|jM|jn|3M|2p|2p|8r|jo|Az","centerWidthAndHeight","widthAndHeight","a|5b|jr|jq|42|2q|2r","Show a single control handle for moving the rectangle\'s center.","o|3s|5b|jt","Show control handles for resizing width and height.","o|3s|jr|jv","Show control handles for both moving the center and resizing.","o|3s|jq|jx","a|ju|jw|jy|Sa","o|Bi|ST|SU|jq|js|jz|3y","The rectangle\'s center point.","o|2h|5b|k1|1d","The rectangle\'s width.","o|2h|bx|k3|1p","height","The rectangle\'s height.","o|2h|k5|k6|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|k0|jL|So|k2|k4|k7","The number of vertices (always 4 for a rectangle).","o|3Q|RD|1p|2p|k9","The four corner vertices of the rectangle.","o|Qc|Oz|1X|3M|kB|4X|IM|Qf","The rectangle\'s center coordinates.","o|6v|5b|1X|3M|kD|36|IY","o|3Q|bx|1p|2p|k3","o|3Q|k5|1p|2p|k6","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|kA|Qa|kC|kE|jV|jY|jb|je|kF|kG|jh","A rectangle, potentially defined by width, height, center and/or corner vertices","o|F|8s|Om|On|Op|k8|kH|3M|2p|2p|8s|kI|Az","centerAndRadius","radius","a|5b|kL|kK|42|2q|2r","Show a control handle for resizing the polygon\'s radius.","o|3s|kL|kN","Show control handles for both moving the center and resizing the radius.","o|3s|kK|kP","a|jG|kO|kQ|Sa","o|Bi|ST|SU|kK|kM|kR|3y","Number of vertices in the regular polygon.","o|33|RD|kT|4S|1q","Number of sides in the regular polygon (alias for numVertices).","o|2h|jf|kV|1q","Center of the regular polygon.","o|2h|5b|kX|1d","circumradius","Distance from center to a vertex (circumscribed-circle radius).","o|2h|kZ|ka|1p","Alias for circumradius.","o|2h|kL|kc|1p","inradius","Distance from center to the midpoint of a side (inscribed-circle radius).","o|2h|ke|kf|1p","apothem","Alias for inradius.","o|2h|kh|ki|1p","sideLength","Length of each side of the regular polygon.","o|2h|kk|kl|1p","Total perimeter of the regular polygon.","o|2h|jZ|kn|1p","Total area enclosed by the regular polygon.","o|2h|jc|kp|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|kS|jL|So|kU|kW|kY|kb|kd|kg|kj|km|ko|kq","Whether to preserve similarity when dragging.","o|3Q|P8|1V|2p|ks","The number of vertices (sides) of the regular polygon.","o|3Q|RD|1q|2p|ku","The center coordinates of the regular polygon.","o|6v|5b|1X|3M|kw|36|IY","The radius of the circumscribed circle.","o|3Q|kZ|1p|2p|ky","The radius of the inscribed circle.","o|3Q|ke|1p|2p|l0","The length of each side.","o|3Q|kk|1p|2p|l2","The number of sides of the regular polygon.","o|3Q|jf|1q|2p|l4","Distance from center to a vertex (alias for circumradius).","o|3Q|kL|1p|2p|l6","Distance from center to the midpoint of a side (alias for inradius).","o|3Q|kh|1p|2p|l8","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|kt|QW|QY|kv|Qa|Qg|kx|jV|jY|jb|je|kz|l1|l3|l5|l7|l9","A regular polygon with a given number of sides","o|F|8t|Om|On|Op|kr|lA|3M|2p|2p|8t|lB|Az","Points the circle passes through.","o|2h|Gr|lD|2W","The circle\'s center point.","o|2h|5b|lF|1d","The circle\'s radius.","o|2h|kL|lH|1X","Whether to render interactive control handles on the circle.","Show a control handle for moving the circle\'s center.","o|3s|5b|lK","Show a control handle for resizing the circle\'s radius.","o|3s|kL|lM","a|lL|lN|kQ|Sa","o|Bi|ST|lJ|kK|kM|lO|3y","Whether to fill the interior of the circle.","o|2m|jJ|lQ|2p|2s|1V","Whether to suppress the indicator drawn at the edge when the component is off-screen.","o|Ap|Sj|lS|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|lE|WQ|WS|H8|4Y|4c|4g|4j|lG|lI|lP|lR|lT|So","o|3L|ST|1T|2p|lJ|3M","o|3L|jJ|1V|2p|lQ|3M","A textual description of the circle\'s style.","o|3Q|Hl|1T|2p|lX",\'Style description including the word "circle".\',"o|3Q|Ho|1T|2p|lZ","A textual description of the circle\'s border style.","o|3Q|jT|1T|2p|lb","A textual description of the circle\'s fill style.","o|3Q|jW|1T|2p|ld","Whether to suppress the off-graph indicator when the circle is outside the visible area.","o|3Q|Sj|1V|2p|lf","Maximum value of the curve parameter (always 2π for a circle).","o|3Q|WM|1p|2p|lh","Minimum value of the curve parameter (always 0 for a circle).","o|3Q|WJ|1p|2p|lj","Points the circle is constrained to pass through.","o|Qc|Wo|1X|3M|ll|4X|IM|Qf","The radius of the circle.","o|3Q|kL|1X|2p|ln","diameter","The diameter of the circle.","o|3Q|lp|1X|2p|lq","circumference","The circumference of the circle.","o|3Q|ls|1X|2p|lt","The area enclosed by the circle.","o|3Q|jc|1X|2p|lv","The center coordinates of the circle.","o|Qc|5b|1X|3M|lx|36|IY|j0","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|lV|lW|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|lY|la|lc|le|lg|li|lk|lm|lo|lr|lu|lw|ly","A circle, potentially defined by center, radius, and/or points on the circle","o|F|8u|TV|TW|Op|lU|lz|3M|3M|2p|8u|m0|Az","Points the parabola passes through.","o|2h|Gr|m2|2W","The vertex of the parabola.","o|33|PI|m4||1d","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|m3|WQ|WS|H8|4Y|4c|4g|4j|m5",\'Style description including the word "parabola".\',"o|3Q|Ho|1T|2p|m7","Maximum value of the parabola\'s parameter.","o|3Q|WM|1p|2p|m9","Minimum value of the parabola\'s parameter.","o|3Q|WJ|1p|2p|mB","o|6v|Wo|1X|3M|m2|4X|IM","a","The leading coefficient of the parabola (in y = a x^2 + b x + c).","o|3Q|mE|1p|2p|mF","b","The linear coefficient in y = a x^2 + b x + c.","o|3Q|mH|1p|2p|mI","The constant term in y = a x^2 + b x + c.","o|3Q|15|1p|2p|mK","The vertex coordinates of the parabola.","o|6v|PI|1X|3M|mM|36|IY","The parabola\'s equation as a math expression.","o|3Q|TZ|1X|2p|mO","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|m8|mA|mC|mD|mG|mJ|mL|mN|mP","A parabola defined by formula or geometric parameters","o|F|8v|TV|TW|Op|m6|mQ|3M|3M|2p|8v|mR|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb","A curve defined by a function, parametric formulas, or control points","o|F|8w|Ut|Uu|Op|mT|mU|3M|3M|2p|8w|mV|Az","a|Wx|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","02122221111111111111111111111222222222122220222212222201221222122222122221212222","alwaysVisible","Whether Bezier control handles are always shown (rather than only when the curve is selected).","o|2m|mZ|ma|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|mb","o|3L|mZ|1V|2p|ma|3M","a|3N|3O|3P|md|3T|3U|3V|3W|3Z","Defines Bezier control vectors at points along a curve","o|F|1g|mX|mY|3l|mc|me|3M|3M|2p|1g|mf|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1O|1X|1Y|1Z|1e|1h|1t|1u|1z|21|24|29|2A|2O|2U|2X|2Y|L|M|N|Q|w|x|y|z|1J|1K|1L|1M|1N|1R|1S|1T|1U|1a|1d|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2K|2Q|2V|2W","1111111111111111111111110221012221211122222222222222222222222222222222222222222","Whether the order of vectors in this list should be treated as unordered (e.g. for matching).","o|2m|4n|mj|2p|2s|1V","Maximum number of vectors to retain in the list.","o|33|g7|ml|9k|1p","Direction in which the control vectors apply at the vertex.","symmetric","previous","next","a|mo|mp|mq|SV|42","Mirror the control vector on both sides of the vertex.","o|3s|mo|ms","Apply the control vector toward the previous segment only.","o|3s|mp|mu","Apply the control vector toward the next segment only.","o|3s|mq|mw","Apply independent control vectors to both adjacent segments.","o|3s|SV|my","No control vector at this vertex.","o|3s|42|n0","a|mt|mv|mx|mz|n1","o|Bi|im|mn|mo|mr|n2|3y","pointNumber","1-based index of the vertex these control vectors attach to.","o|33|n4|n5||1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr|n3|n6","o|3L|g7|1p|2p|ml|3M","o|3L|im|1T|2p|mn|3M","o|3L|n4|1p|2p|n5|3M","numVectors","The number of vectors in the list.","o|3Q|nB|1p|2p|nC","o|3Q|gI|1p|2p|nC","a|3N|3O|n8|n9|nA|3Z|gy|nD|nE","Bezier control vectors at points defining a curve (used inside `<bezierControls>`)","o|F|Wx|mh|mi|g0|n7|nF|2p|3M|2p|Wx|nG|Az","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q","1120111111111111111111111111102201012212111122222220122222222222222222222222222222","Whether the vector can be dragged on a graph.","o|2m|5L|nK|3M|2s|1V","headDraggable","Whether the vector\'s head can be dragged.","o|Ap|nM|nN|2s|1V","tailDraggable","Whether the vector\'s tail can be dragged.","o|Ap|nP|nQ|2s|1V","The first component (x) of the vector\'s displacement.","o|2h|7Q|nS|1X","The second component (y) of the vector\'s displacement.","o|2h|7T|nU|1X","The third component (z) of the vector\'s displacement.","o|2h|7W|nW|1X","The vector\'s displacement components as a list.","o|2h|S5|nY|1Y","displacement","The vector\'s displacement (head minus tail).","o|2h|na|nb|1e","head","The head (tip) point of the vector.","o|2h|nd|ne|1d","tail","The tail (base) point of the vector.","o|2h|ng|nh|1d","headAndTail","headOnly","tailOnly","a|na|nj|nk|nl|42|2q|2r","Show a control handle for translating the whole vector.","o|3s|na|nn","Show control handles for both the head and the tail.","o|3s|nj|np","Show a control handle only at the head.","o|3s|nk|nr","Show a control handle only at the tail.","o|3s|nl|nt","a|no|nq|ns|nu|Sa","o|Bi|ST|SU|na|nm|nv|3y","displayWithAngleBrackets","Whether to display the vector with angle brackets (e.g. ⟨1,2⟩).","o|2m|nx|ny|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|nL|nO|nR|nT|nV|nX|nZ|nc|nf|ni|nw|UB|H8|4Y|4c|4g|4j|nz|P4|So","o|3L|5L|1V|2p|nK|3M","o|3L|nx|1V|2p|ny|3M","A textual description of the vector\'s style.","o|3Q|Hl|1T|2p|o3",\'Style description including the word "vector".\',"o|3Q|Ho|1T|2p|o5","Whether the vector\'s tail can be dragged independently.","o|3Q|nP|1V|2p|o7","Whether the vector\'s head can be dragged independently.","o|3Q|nM|1V|2p|o9","Number of dimensions of the vector.","o|3Q|6r|1p|2p|oB","The displacement (head − tail) of the vector.","o|Qc|na|1X|3M|oD|36|6z|j0","Coordinates of the vector\'s head.","o|Qc|nd|1X|3M|oF|36|IY|j0","Coordinates of the vector\'s tail.","o|Qc|ng|1X|3M|oH|36|IY|j0","magnitude","The magnitude (length) of the vector.","o|3Q|oJ|1X|2p|oK","The vector rendered as a LaTeX string.","o|3Q|2V|2V|2p|oM","o|3Q|7Q|1X|2p|nS","o|3Q|7T|1X|2p|nU","o|3Q|7W|1X|2p|nW","a|3N|3O|3P|Hd|QD|7s|QE|o1|Sy|UG|o2|QG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|o4|o6|o8|oA|oC|oE|oG|oI|oL|oN|oO|oP|oQ","A geometric vector with tail and head","o|F|1h|nI|nJ|Op|o0|oR|3M|3M|2p|1h|oS|Az","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y","1120111111111111111111111112122022210112221222221222112222222222222222222222222222","Radius of the rendered angle arc.","1","o|5H|1X|oX","o|33|kL|oW|oY|1X","chooseReflexAngle","How to handle reflex angles.","never","allowed","always","a|oc|od|oe","Always normalize to the non-reflex angle (less than 180°).","o|3s|oc|og","Use a reflex angle (greater than 180°) if it matches the input.","o|3s|od|oi","Always render the angle as a reflex angle.","o|3s|oe|ok","a|oh|oj|ol","o|Bi|oa|ob|oc|of|om|3y","inDegrees","Whether to interpret and display the angle in degrees rather than radians.","o|2m|oo|op|2p|2s|1V","radians","The angle measure in radians.","o|2h|or|os|1X","degrees","The angle measure in degrees.","o|2h|ou|ov|1X","Three points (vertex in the middle) defining the angle.","o|2h|Gr|ox|2W","betweenLines","Two lines whose intersection forms the angle.","_lineListComponent","o|2h|oz|p0|p1","emphasizeRightAngle","Whether to render right angles with the conventional square symbol.","o|2m|p3|p4|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|oZ|on|oq|ot|ow|oy|p2|H8|4Y|4c|4g|4j|p5","o|3L|kL|1X|2p|oW|3M","o|3L|oa|1T|2p|ob|3M","o|3L|oo|1V|2p|op|3M","o|3L|p3|1V|2p|p4|3M","o|3Q|or|1X|2p|os","o|3Q|ou|1X|2p|ov","o|3Q|3a|1X|2p|os","o|3Q|1i|1X|2p|os","a|3N|3O|3P|Hd|QD|7s|QE|p7|p8|p9|pA|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|pB|pC|pD|pE","An angle defined by three points or a measure","o|F|1i|oU|oV|Op|p6|pF|3M|3M|2p|1i|pG|Az","considerAsResponses","a|8x|1z|1R|1S|1k|1l|1m|1n|pI|I|J|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2T","021111110110001222211111111111111111111112221222221000010212220012212221222221112212112221111111110011","Relative weight of this answer when aggregating credit across multiple answers.","answer-grading","o|4U|9c|pL|pM|36|1p","handGraded","Whether this answer is graded by hand rather than automatically.","o|4d|pO|pP|pM|2p|2s|1V","matchPartial","Whether to award partial credit when the response is partially correct.","o|4d|pR|pS|pM|2p|2s|1V","Maximum number of times the response can be submitted.","o|4U|9i|pU|pM|9k|1q","Whether to display whether the submitted response is correct.","o|4d|9m|pW|pM|3M|2s|1V","Whether to color-code the response based on its correctness.","o|4d|9p|pY|pM|3M|2s|1V","disableAfterCorrect","Whether to disable the answer after a fully correct response has been submitted.","o|4d|pa|pb|pM|2p|2s|1V","Label for the submit button when correctness is shown.","o|4U|9v|pd|pM|9x|1T","Label for the submit button when correctness is not shown.","o|4U|9z|pf|pM|A1|1T","displayDigitsForResponses","Number of significant digits to display when rendering numeric responses.","o|4U|ph|pi|pM|Nn|1q","o|4U|A3|A4|pM|4S|1q","a|3|2f|3m|2k|2l|2g","Whether to render the answer\'s input inline rather than as a block.","o|pl|3h|pm|3M|2p|2s|1V","Whether comparison uses symbolic equality (rather than numeric evaluation).","o|pl|Bc|po|3M|2p|2s|1V","forceFullCheckWorkButton","Whether to always render a full-size check-work button.","o|2m|pq|pr|2p|2s|1V","forceSmallCheckWorkButton","Whether to always render a small check-work button.","o|2m|pt|pu|2p|2s|1V","Level of simplification applied to math expressions before comparing them.","o|Bi|Bj|pw|42|47|Bp|3y","Whether to expand math expressions before comparing them.","o|2m|Bf|py|2p|2s|1V","Whether order is ignored when comparing list-like responses.","o|2m|Br|q0|2p|2s|1V","Whether to match list responses by exact position rather than by content.","o|2m|Bu|q2|2p|2s|1V","numAwardsCredited","Maximum number of matching awards whose credits are summed.","o|33|q4|q5|36|1q","colorInputsSeparately","Attempt to color each input separately based on the awards that reference it, rather than all inputs sharing the same overall credit color.","o|2m|q7|q8|2p|2s|1V","Maximum allowed numeric error when comparing numbers (relative or absolute).","o|33|Bx|qA|5Q|1p","Type of input the answer expects.","videoWatched","a|1X|1T|1V|qD","Expect a math expression answer.","o|3s|1X|qF","Expect a text answer.","o|3s|1T|qH","Expect a boolean answer.","o|3s|1V|qJ","Mark correct when the associated video has been watched.","o|3s|qD|qL","a|qG|qI|qK|qM","o|Bi|2g|qC||qE|qN|3y","selectMultiple","For choice answers: whether multiple choices may be selected.","o|2m|qP|qQ|2p|2s|1V","shuffleOrder","For choice answers: whether to display choices in randomized order.","o|2m|qS|qT|2p|2s|1V","preserveLastChoice","For choice answers: whether the last-rendered choice keeps its position when shuffling.","o|2m|qV|qW|2p|2s|1V","disableWrongChoices","Whether incorrect choices are disabled after being submitted.","o|2m|qY|qZ|2p|2s|1V","creditByAttempt",\'Per-attempt credit multipliers (e.g. "1 0.7 0.5" for full/70%/50% on attempts 1/2/3+).\',"o|33|qb|qc|54|1a","Whether multi-character symbols should be split into a product of single-character variables when parsing.","o|2m|56|qe|3M|2s|1V","expanded","Whether the answer\'s submitted-response panel is expanded by default.","o|2m|qg|qh|2p|2s|1V","showPreview","Whether to display a preview of the response as the student types.","o|2m|qj|qk|2p|2s|1V","Reference to a video; when watched, this answer\'s videoWatched type marks credit.","o|2h|9D|qm|3D","videoCreditLabel","Label shown next to the credit indicator for a video-watched answer.","o|2h|qo|qp|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|pn|pp|ps|pv|px|pz|q1|q3|q6|q9|qB|C2|C5|C8|CB|CE|CH|qO|qR|qU|qX|qa|qd|qf|5B|qi|ql|qn|qq|GH","o|6J|9c|1p|2p|pL|3M|pM","o|6J|pO|1V|2p|pP|3M|pM","o|6J|pR|1V|2p|pS|3M|pM","o|6J|9i|1q|2p|pU|3M|pM","o|6J|pa|1V|2p|pb|3M|pM","o|6J|9v|1T|2p|pd|3M|pM","o|6J|9z|1T|2p|pf|3M|pM","o|6J|ph|1q|2p|pi|3M|pM","o|6J|A3|1q|2p|A4|3M|pM","o|65|3h|1V|2p|pm|3M|3M","o|65|Bc|1V|2p|po|3M|3M","o|3L|pq|1V|2p|pr|3M","o|3L|pt|1V|2p|pu|3M","o|3L|Bj|1T|2p|pw|3M","o|3L|Bf|1V|2p|py|3M","o|3L|Br|1V|2p|q0|3M","o|3L|Bu|1V|2p|q2|3M","o|3L|q4|1q|2p|q5|3M","o|3L|q7|1V|2p|q8|3M","o|3L|Bx|1p|2p|qA|3M","o|3L|qP|1V|2p|qQ|3M","o|3L|qS|1V|2p|qT|3M","o|3L|qV|1V|2p|qW|3M","o|3L|qY|1V|2p|qZ|3M","o|3L|qb|1a|2p|qc|3M","o|3L|56|1V|2p|qe|3M","o|3L|qg|1V|2p|qh|3M","o|3L|qj|1V|2p|qk|3M","The fraction of credit achieved on the most recent submission (between 0 and 1).","o|3Q|AL|1p|2p|rK","responseHasBeenSubmitted","Whether a response has ever been submitted for this answer.","o|3Q|rM|1V|2p|rN","justSubmitted","Whether the most recent submission for this answer has not yet been changed.","o|3Q|rP|1V|2p|rQ","Total number of times a response has been submitted.","o|3Q|AD|1q|2p|rS","Remaining number of submission attempts before the maximum is reached.","o|3Q|AG|1q|2p|rU","Whether this answer is disabled and is no longer accepting submissions.","o|3Q|2u|1V|2p|rW","Whether any input within this answer currently has keyboard focus.","o|3Q|eQ|1V|2p|rY","numResponses","The number of current (unsubmitted) response values from this answer\'s inputs.","o|3Q|ra|1p|2p|rb","a|3|3J|2f|6r|6u","currentResponses","The current (unsubmitted) response values from this answer\'s inputs.","a|3J|6r","o|rg|3M|36","a|rh","o|rd|re|3M|rf|36|ri","numSubmittedResponses","The number of response values from the most recent submission.","o|3Q|rk|1p|2p|rl","submittedResponses","The response values from the most recent submission.","o|rd|rn|3M|ro|36|ri","numFeedbacks","The number of feedback messages produced by matched awards or applicable feedback definitions.","o|3Q|rq|1p|2p|rr","feedbacks","The feedback messages produced by matched awards or applicable feedback definitions.","o|73|3M|9F|36","a|rv","o|6v|rt|9F|3M|ru|36|rw","a|3|3J|2f","currentResponse","The current (unsubmitted) response value from the answer\'s first input.","o|ry|rz|2p|s0","submittedResponse","The first response value from the most recent submission.","o|ry|s2|2p|s3","a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|r1|r2|r3|r4|r5|r6|r7|r8|r9|rA|rB|CP|CQ|CR|CS|CT|CU|rC|rD|rE|rF|rG|rH|6E|rI|rJ|Hd|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|Hk|rZ|rc|rj|rm|rp|rs|rx|s1|s4","answer1","Assigns credit to student responses based on matches or logical rules","o|F|1j|pJ|pK|3l|qr|s5|3M|2p|2p|s6|s7|3h","when","a|s9|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a","02122221111111111111111111111222122222122020222212222201221222122222111221211222221111111110212120","credit","Fraction of credit (0 to 1) granted when this award matches.","o|33|sC|sD|36|1p","o|2m|pR|pS|2p|2s|1V","o|2m|Bc|po|2p|2s|1V","feedbackCodes","Codes that select reusable feedback messages when this award matches.","o|33|sH|sI|54|1U","feedbackText","Custom feedback text shown when this award matches.","o|33|sK|sL||1T","referencesAreResponses","References to components whose values should be treated as responses for this award.","o|2h|sN|sO|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H|sE|sF|sG|pz|px|q1|q3|qB|C2|C5|C8|CB|CE|CH|sJ|sM|sP|qf|5B","o|3L|sC|1p|2p|sD|3M","o|3L|pR|1V|2p|pS|3M","o|3L|Bc|1V|2p|po|3M","o|3L|sH|1U|2p|sI|3M","o|3L|sK|1T|2p|sL|3M","creditAchievedIfSubmit","Credit (0 to 1) this award would grant if submitted with the current response.","o|3Q|sW|1p|2p|sX","fractionSatisfiedIfSubmit","Fraction (0 to 1) by which this award\'s match condition is currently satisfied.","o|3Q|sZ|1p|2p|sa","fractionSatisfied","Fraction (0 to 1) by which this award\'s match condition was satisfied at last submission.","o|3Q|sc|1p|2p|sd","Credit (0 to 1) this award granted at the last submission.","o|3Q|AL|1p|2p|sf","awarded","Whether this award was matched at the last submission.","o|3Q|sh|1V|2p|si","The number of feedback messages associated with this award.","o|3Q|rq|1p|2p|sk","The feedback messages produced by this award.","o|6v|rt|9F|3M|sm|36|rw","The first feedback message produced by this award.","o|3Q|9F|9F|2p|so","a|3N|3O|3P|sR|sS|sT|r6|r5|r7|r8|rB|CP|CQ|CR|CS|CT|CU|sU|sV|rH|6E|3T|3U|3V|3W|3Z|sY|sb|se|sg|sj|sl|sn|sp","Specifies conditions for awarding credit in an answer","o|F|8x|sA|sB|Ao|sQ|sq|3M|3M|2p|8x|sr|Az","Whether to match partial conditions for partial credit.","o|2m|pR|st|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|su","o|3L|pR|1V|2p|st|3M","Whether the condition is currently true.","o|3Q|3a|1V|2p|sx","Fraction of the boolean condition that is satisfied (0 to 1).","o|3Q|sc|1p|2p|sz","Whether the condition is currently satisfied; equivalent to value.","o|3Q|Au|1V|2p|t1","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|sw|3T|3U|3V|3W|3Z|sy|t0|t2|CW","Defines logical conditions within an `<award>`","o|F|s9|BY|BZ|3l|sv|t3|2p|3M|2p|s9|t4|3h","Initial value displayed in the input.","o|33|Zj|t6|5J|1X","prefillLatex","Initial value as a LaTeX string.","o|33|t8|t9|AZ|2V","o|Bi|3p|3q|1T|3r|3x|3y","additionalFunctionNames","Extra identifiers to auto-format as function names in the editor (e.g., \'erf\'). Entries that also appear in `removedFunctionNames` are dropped.","o|33|tC|tD|54|1U","removedFunctionNames","Built-in function names to stop auto-formatting in the editor (e.g., \'min\' so \'kg/min\' can be typed as a unit).","o|33|tF|tG|54|1U","resetFunctionNames","When set, replaces the entire auto-formatted function name list (defaults, `additionalFunctionNames`, and `removedFunctionNames` are all ignored). Set to an empty value to disable auto-formatting entirely.","o|33|tI|tJ||1U","Whether multi-character symbols are split into a product of single-character variables.","o|2m|56|tL|3M|2s|1V","hideNaN","Whether to hide NaN values when displaying the input.","o|2m|tN|tO|3M|2s|1V","removeStrings","Substrings to strip from the input before parsing.","o|33|tQ|tR||1U","minWidth","Minimum rendered width of the input.","n|o","o|33|tT|tU|tV|1q","Whether to display a preview of the parsed math.","o|2m|qj|tX|2p|2s|1V","Whether the input can be dragged on a graph.","o|2m|5L|tZ|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|t7|tA|tB|51|tE|tH|tK|tM|5B|e7|4Y|e8|4g|4j|eB|eE|tP|tS|tW|tY|ta|5X|63","o|3L|Zj|1X|2p|t6|3M","o|3L|t8|2V|2p|t9|3M","o|3L|3p|1T|2p|3q|3M","o|3L|tC|1U|2p|tD|3M","o|3L|tF|1U|2p|tG|3M","o|3L|tI|1U|2p|tJ|3M","o|3L|56|1V|2p|tL|3M","o|3L|tN|1V|2p|tO|3M","o|3L|tT|1q|2p|tU|3M","o|3L|5L|1V|2p|tZ|3M","Whether this input currently has keyboard focus.","o|3Q|eQ|1V|2p|tm","o|3Q|qj|1V|2p|tX","The math value of the input.","o|3Q|3a|1X|2p|tp","The math value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|tr","The current input as a text string.","o|3Q|1T|1T|2p|tt","rawRendererValue","The raw value used by the renderer (e.g. LaTeX string).","o|3Q|tv|2V|2p|tw","a|3N|3O|3P|eJ|Hd|tc|td|te|6C|tf|tg|th|ti|6E|eN|tj|tk|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6X|6Y|6Z|6a|6b|6W|to|eV|tq|eY|ts|tu|tx|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","An interactive math input","o|F|1k|ep|eq|dh|tb|ty|3M|3M|2p|1k|tz|3h","a|I|J|1z|2S|2f|dd|H|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2T|2U|2V|2X","112000222222222222222222222222222222222222122202222222222222222222222112222212","Initial text shown in the input before the user types.","o|33|Zj|u3|AZ|1T","o|2h|e9|eA|1T","Whether the input renders as a multi-line text area.","o|2m|qg|u6|2p|2s|1V","Display width of the input.","o|2h|bx|u8|bz","Display height of the input.","size","isAbsolute","a|uB|uC","n|1w","o|uD|uE|3M","o|33|k5|uA|uF|bz","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|u4|u5|u7|u9|uG|ta|5X|63","o|3L|Zj|1T|2p|u3|3M","o|3L|qg|1V|2p|u6|3M","o|3L|k5|bz|2p|uA|3M","o|3Q|bx|bz|2p|u8","The text value of the input.","o|3Q|3a|1T|2p|uM","The text value reflecting the user\'s in-progress edits.","o|3Q|ef|1T|2p|uO","The current text as a plain text string.","o|3Q|1T|1T|2p|uQ","a|3N|3O|3P|eJ|Hd|uI|uJ|uK|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|eV|eY|6W|uL|uN|uP|uR|Jp|Ju|Jx|K0|K2|K4","An interactive text input","o|F|1l|u1|u2|dh|uH|uS|3M|3M|2p|1l|uT|3h","a|I|J|1z|2S|2f|dd|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|2R|2T|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","11200011111111102211122221111111111111111111111222222222122220222212222201221222122222122221212222","o|Bi|GL|di|5i|dj|do|3y","The initial value of the input before the student interacts.","o|2m|Zj|uY|2p|2s|1V","asToggleButton","Whether to render the input as a toggle button rather than a checkbox.","o|2m|ua|ub|2p|2s|1V","o|Ap|e9|eA|2s|1V","Whether the input can be dragged on a graph by its anchor.","o|2m|5L|ue|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|uX|ds|GH|uZ|uc|ud|uf|5X|63","o|3L|Zj|1V|2p|uY|3M","o|3L|ua|1V|2p|ub|3M","o|3L|5L|1V|2p|ue|3M","Whether the input\'s value has been changed from its prefill value.","o|3Q|eT|1V|2p|uk","The current boolean value of the input.","o|3Q|3a|1V|2p|um",\'The current value rendered as a text string ("true" or "false").\',"o|3Q|1T|1T|2p|uo","a|3N|3O|3P|eJ|Hd|uh|ui|uj|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6W|ul|un|up","An interactive boolean (toggle/checkbox) input","o|F|1m|uV|uW|dh|ug|uq|3M|3M|2p|1m|ur|3h","a|I|J|1z|2S|2f|dd|1o","Whether multiple choices may be selected.","o|2m|qP|uu|2p|2s|1V","Whether to award partial credit when only some correct choices are selected.","o|2m|pR|uw|2p|2s|1V","Whether to render the input inline (as a dropdown) rather than as a list of choices.","o|2m|3h|uy|2p|2s|1V","Whether to display the choices in randomized order.","o|2m|qS|v0|2p|2s|1V","Whether the last-rendered choice keeps its position when shuffling.","o|2m|qV|v2|2p|2s|1V","preselectChoice","Index of a choice to pre-select on initial render.","o|33|v4|v5||1p","placeHolder","Placeholder text shown when no choice is selected.","o|33|v7|v8|AZ|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|uv|ux|uz|v1|v3|v6|u5|v9","o|3L|qP|1V|2p|uu|3M","o|3L|pR|1V|2p|uw|3M","o|3L|qS|1V|2p|v0|3M","o|3L|qV|1V|2p|v2|3M","Whether the input is rendered inline (as a dropdown).","o|3Q|3h|1V|2p|vF","numChoices","The number of choices available in the input.","o|3Q|vH|1p|2p|vI","choiceTexts","The text contents of all choices in displayed order.","o|6v|vK|1T|3M|vL|36|Jt","choiceMaths","The math expressions of all choices in displayed order.","o|6v|vN|1X|3M|vO|36|75","Whether the input\'s selection has been changed from its initial state.","o|3Q|eT|1V|2p|vQ","selectedIndices","Indices (1-based) of the currently selected choices.","o|6v|vS|1p|3M|vT|36|IR","selectedValues","Text values of the currently selected choices.","o|rd|vV|3M|vW|36|ri","The number of feedback messages produced by selected choices.","o|3Q|rq|1p|2p|vY","Feedback messages produced by selected choices.","o|6v|rt|9F|3M|va|36|rw","selectedIndex","The 1-based index of the first currently selected choice.","o|3Q|vc|1p|2p|vd","selectedValue","The text value of the first currently selected choice.","o|ry|vf|2p|vg","The text values of the currently selected choices.","o|rd|2l|3M|vi|36|ri","valueToRecordOnSubmit","Indices of the currently selected choices (recorded when the answer is submitted).","o|6v|vk|1p|3M|vl|36|IR","a|3N|3O|3P|eJ|Hd|vB|vC|vD|vE|3T|3U|3V|3W|3Z|Hk|eP|tn|vG|vJ|vM|vP|vR|vU|vX|vZ|vb|ve|vh|vj|vm","A multiple-choice input, allowing selection from a list of choices","o|F|1n|ut|df|dh|vA|vn|3M|2p|2p|1n|vo|3h","Fraction of credit (0 to 1) granted when this choice is selected.","o|33|sC|vq|5Q|1p","Codes that select reusable feedback messages when this choice is selected.","o|33|sH|vs|54|1U","Custom feedback text shown when this choice is selected.","o|33|sK|vu||1T","preSelect","Whether this choice is pre-selected on initial render.","o|2m|vw|vx|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|vr|vt|vv|vy","o|3L|sC|1p|2p|vq|3M","o|3L|sH|1U|2p|vs|3M","o|3L|sK|1T|2p|vu|3M","The choice\'s content as a text string.","o|3Q|1T|1T|2p|w3","The choice\'s content interpreted as a math expression.","o|3Q|1X|1X|2p|w5","selected","Whether this choice is currently selected.","o|3Q|w7|1V|2p|w8","submitted","Whether this choice was selected at the most recent submission.","o|3Q|wA|1V|2p|wB","Whether this choice is disabled (cannot be selected).","o|3Q|2u|1V|2p|wD","feedbacktext","Feedback messages shown when this choice is selected.","o|3Q|rt|wF|2p|wG","a|3N|3O|3P|w0|w1|w2|3T|3V|3W|3Z|w4|w6|w9|wC|wE|wH","A single choice within a `<choiceInput>` or an `<answer>`.","o|F|1o|9U|9V|3l|vz|wI|3M|3M|2p|1o|wJ|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m","111111111111111111111111102022210112222122222111211122222222222222222222222222222111111111021212","renderAsMath","Whether to render the number using math typography.","o|2m|wN|wO|2p|2s|1V","convertBoolean","Whether to convert boolean inputs to 1/0 instead of NaN.","o|2m|wQ|wR|2p|2s|1V","valueOnNaN","Numeric value to use when the input cannot be parsed.","NaN","o|33|wT|wU|wV|1p","Whether the number can be dragged on a graph.","o|2m|5L|wX|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j|wP|wS|wW|wY|5R|5X|63","o|3L|wN|1V|2p|wO|3M","o|3L|5L|1V|2p|wX|3M","The numeric value.","o|3Q|3a|1p|2p|wc","The number rendered as plain text.","o|3Q|1T|1T|2p|we","The number\'s value as a math expression.","o|3Q|1X|1X|2p|wg","The number rendered as LaTeX.","o|3Q|2V|2V|2p|wi","a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wd|wf|wh|wj","A numeric floating point value","o|F|1p|wL|wM|3l|wZ|wk|3M|3M|2p|1p|wl|3h","The integer value.","o|3Q|3a|1q|2p|wn","a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wf|wh|wj|wo","An integer value","o|F|1q|wL|wM|3l|wZ|wp|3M|3M|2p|1q|wq|3h","a|I|1z|J|dd|2f|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y|9C|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|z|1L|1M|1T|1U|1V|1W|1a|1o|1p|1q|1v|25|26|27|28|2B|2C|2D|2R|2S|2T|2V|1N|1R|1S|1k|O|P|2E|2F|2G|1m|1l|8y|8z","020001111111111111111111111122211111022211111111111111122122212222121212212111111122200111222222222122022222012222211220212220010000000","xMin","Minimum value displayed on the x axis.","n|-A","o|33|wu|wv|ww|1p","xMax","Maximum value displayed on the x axis.","o|33|wy|wz|Nn|1p","yMin","Minimum value displayed on the y axis.","o|33|x1|x2|ww|1p","yMax","Maximum value displayed on the y axis.","o|33|x4|x5|Nn|1p","Explicit width of the graph (overrides size).","o|2h|bx|x7|bz","Named size preset for the graph.","medium","tiny","small","large","a|xB|xC|xA|xD|43","About 1/12 the full width.","o|3s|xB|xF","About 30% of the full width.","o|3s|xC|xH","About half the full width.","o|3s|xA|xJ","About 70% of the full width.","o|3s|xD|xL","The full available width.","o|3s|43|xN","a|xG|xI|xK|xM|xO","o|Bi|uB|x9|xA|xE|xP|3y","aspectRatio","Aspect ratio (width / height) for the graph.","o|33|xR|xS|36|1p","displayMode","How to size the graph.","a|AT|3h","Display as a block element on its own line.","o|3s|AT|xX","Render inline with surrounding text.","o|3s|3h|xZ","a|xY|xa","o|Bi|xU|xV|AT|xW|xb|3y","horizontalAlign","Horizontal alignment of the graph within its container.","a|5b|5h|5i","Center the graph horizontally.","o|3s|5b|xg","Align the graph to the left edge.","o|3s|5h|xi","Align the graph to the right edge.","o|3s|5i|xk","a|xh|xj|xl","o|Bi|xd|xe|5b|xf|xm|3y","identicalAxisScales","Whether to force the x and y axis scales to be equal.","o|2m|xo|xp|2p|2s|1V","displayXAxis","Whether to display the x axis.","o|2m|xr|xs|3M|2s|1V","displayYAxis","Whether to display the y axis.","o|2m|xu|xv|3M|2s|1V","Whether to render interactive zoom/pan controls.","all","slidersOnly","inputsOnly","a|xy|xz|y0|42|2q|2r","Render both sliders and input boxes.","o|3s|xy|y2","Render only slider controls.","o|3s|xz|y4","Render only input-box controls.","o|3s|y0|y6","Render no interactive controls.","o|3s|42|y8","a|y3|y5|y7|y9","o|Bi|ST|xx|42|y1|yA|3y","controlsPosition","Position of the graph controls.","a|5g|5h|5i|9","Place controls below the graph.","o|3s|5g|yF","Place controls to the left of the graph.","o|3s|5h|yH","Place controls to the right of the graph.","o|3s|5i|yJ","Place controls above the graph.","o|3s|9|yL","a|yG|yI|yK|yM","o|Bi|yC|yD|5h|yE|yN|3y","displayXAxisTicks","Whether to display tick marks on the x axis.","o|2m|yP|yQ|3M|2s|1V","displayYAxisTicks","Whether to display tick marks on the y axis.","o|2m|yS|yT|3M|2s|1V","displayXAxisTickLabels","Whether to display labels on x-axis ticks.","o|2m|yV|yW|3M|2s|1V","displayYAxisTickLabels","Whether to display labels on y-axis ticks.","o|2m|yY|yZ|3M|2s|1V","xLabelPosition","Position of the x-axis label.","a|5i|5h","Place the x-axis label at the right end of the axis.","o|3s|5i|ye","Place the x-axis label at the left end of the axis.","o|3s|5h|yg","a|yf|yh","o|Bi|yb|yc|5i|yd|yi|3y","xTickScaleFactor","Scale factor applied to x-axis tick spacing.","o|33|yk|yl||1X","yLabelPosition","Position of the y-axis label.","a|9|5g","Place the y-axis label at the top of the axis.","o|3s|9|yq","Place the y-axis label at the bottom of the axis.","o|3s|5g|ys","a|yr|yt","o|Bi|yn|yo|9|yp|yu|3y","yLabelAlignment","Alignment of the y-axis label.","Align the y-axis label to the left of the axis.","o|3s|5h|yy","Align the y-axis label to the right of the axis.","o|3s|5i|z0","a|yz|z1","o|Bi|yw|yx|5h|dj|z2|3y","yTickScaleFactor","Scale factor applied to y-axis tick spacing.","o|33|z4|z5||1X","showNavigation","Whether to show navigation controls (pan/zoom).","o|2m|z7|z8|3M|2s|1V","fixAxes","Whether the axis limits are locked (preventing zoom/pan).","o|2m|zA|zB|2p|2s|1V","grid","Grid density to render on the graph (off, minor, medium, or major).","o|2h|zD|zE|1T","showBorder","Whether to render a border around the graph.","o|2m|zG|zH|3M|2s|1V","hideOffGraphIndicators","Whether to suppress indicators for objects outside the visible region.","o|2m|zJ|zK|2p|2s|1V","decorative","Whether the graph is purely decorative (excluded from a11y tree).","o|2m|zM|zN|2p|2s|1V","renderer","Which renderer to use for the graph.","doenet","prefigure","a|zR|zS","Render using the built-in Doenet graph renderer.","o|3s|zR|zU","Render using the PreFigure SVG-based renderer.","o|3s|zS|zW","a|zV|zX","o|Bi|zP|zQ|zR|zT|zY|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|wx|x0|x3|x6|x8|xQ|xT|xc|xn|xq|xt|xw|yB|yO|yR|yU|yX|ya|yj|ym|yv|z3|z6|z9|zC|zF|H8|4Y|4c|4g|4j|zI|zL|zO|zZ","o|3L|xU|1T|2p|xV|3M","o|3L|xd|1T|2p|xe|3M","o|3L|xo|1V|2p|xp|3M","o|3L|xr|1V|2p|xs|3M","o|3L|xu|1V|2p|xv|3M","o|3L|ST|1T|2p|xx|3M","o|3L|yC|1T|2p|yD|3M","o|3L|yP|1V|2p|yQ|3M","o|3L|yS|1V|2p|yT|3M","o|3L|yb|1T|2p|yc|3M","o|3L|yk|1X|2p|yl|3M","o|3L|yn|1T|2p|yo|3M","o|3L|yw|1T|2p|yx|3M","o|3L|z4|1X|2p|z5|3M","o|3L|z7|1V|2p|z8|3M","o|3L|zG|1V|2p|zH|3M","o|3L|zJ|1V|2p|zK|3M","o|3L|zM|1V|2p|zN|3M","o|3L|zP|1T|2p|zQ|3M","A short accessibility description of the graph.","o|3Q|dd|1T|2p|zu","Whether the visible axes range is locked.","o|3Q|zA|1V|2p|zw","The x-axis label text.","o|3Q|I|2S|2p|zy","The y-axis label text.","o|3Q|J|2S|2p|100","hasAuthorAnnotations","Whether the graph contains any author-provided `<annotations>` child.","o|3Q|102|1V|2p|103","prefigureXML","The Prefigure-formatted XML rendered for this graph, or null if not using the Prefigure renderer.","o|3Q|105|1T|2p|106","The size of the graph.","o|3Q|uB|1T|2p|108","The width of the graph.","o|3Q|bx|bz|2p|10A","The aspect ratio (width / height) of the graph.","o|3Q|xR|1p|2p|10C","effectiveRenderer","The renderer actually used after resolving fallbacks.","o|3Q|10E|1T|2p|10F","Whether x-axis tick labels are displayed.","o|3Q|yV|1V|2p|10H","Whether y-axis tick labels are displayed.","o|3Q|yY|1V|2p|10J","Minimum x value displayed.","o|3Q|wu|1p|2p|10L","Maximum x value displayed.","o|3Q|wy|1p|2p|10N","Minimum y value displayed.","o|3Q|x1|1p|2p|10P","Maximum y value displayed.","o|3Q|x4|1p|2p|10R","xScale","Scale used along the x axis (xMax − xMin).","o|3Q|10T|1p|2p|10U","yScale","Scale used along the y axis (yMax − yMin).","o|3Q|10W|1p|2p|10X","Grid line spacing on the graph.","o|ry|zD|2p|10Z","a|3N|3O|3P|zb|zc|zd|ze|zf|zg|zh|zi|zj|zk|zl|zm|zn|zo|zp|zq|zr|zs|zt|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|zv|zx|zz|101|104|107|109|10B|10D|10G|10I|10K|10M|10O|10Q|10S|10V|10Y|10a","A 2D coordinate-axis graph","o|F|8y|ws|wt|9X|za|10b|3M|2p|2p|8y|10c|AT","a|90|1z","A container of annotation children for screen reader navigation of a graph","o|F|8z|10e|BN|Ao|3I|Aa|3M|2p|2p|8z|10f|Az","Reference to the component this annotation is attached to.","o|2h|1c|10h|3D","The annotation text read by screen readers.","o|33|1T|10j|AZ|1T","speech","More detailed spoken text used by screen readers; used if expert mode is activated or extra details are requested.","o|33|10l|10m|AZ|1T","sonify","Whether to play a tone when this annotation is focused and it references a function.","o|2m|10o|10p|2p|2s|1V","circular","Whether navigation through this annotation\'s children wraps around.","o|2m|10r|10s|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|10i|10k|10n|10q|10t","o|3L|1T|1T|2p|10j|3M","o|3L|10l|1T|2p|10m|3M","o|3L|10o|1V|2p|10p|3M","o|3L|10r|1V|2p|10s|3M","a|3N|3O|3P|10v|10w|10x|10y|3T|3U|3V|3W|3Z","An annotation for screen reader navigation of a graph","o|F|90|10e|BN|Ao|10u|10z|3M|2p|2p|90|110|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT","The symbolic formula of the function.","o|3Q|I9|1X|2p|113","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|114|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A mathematical function, defined by formula or interpolation","o|F|1r|Fo|Fp|3l|112|115|3M|3M|2p|1r|116|3h","a|w|x|y|1r|1s|1z|I|J|2S","111012110","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|GD|GH|GK|Gf|Gh|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT","Number of output values.","o|3Q|G8|1q|2p|11B","The piecewise formula of the function.","o|3Q|I9|1X|2p|11D","The piecewise function rendered as a LaTeX string.","o|3Q|2V|2V|2p|11F","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|11C|I0|I2|I4|I8|11E|11G|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A function defined piecewise from sub-functions on intervals","o|F|1s|118|119|3l|11A|11H|3M|2p|2p|1s|11I|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|1t|2p|6e","Whether this math component renders intervals as intervals (always true for `<interval>`).","o|3Q|4t|1V|2p|11M","a|3N|3O|3P|66|67|68|69|6A|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|11L|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|11N|7S|7V|7Y|7b","A math expression treated as an interval of real numbers","o|F|1t|3j|3k|3l|11K|11O|3M|3M|2p|1t|11P|3h","option","selectForVariants","Variant indices for which this option is selected.","textListFromString","o|33|11S|11T|54|11U","selectWeight","Relative weight when randomly selecting an option.","o|33|11W|11X|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|11V|11Y","o|3L|11S|11U|2p|11T|3M","o|3L|11W|1p|2p|11X|3M","a|3N|3O|3P|11a|11b|3T|3U|3V|3W|3Z","A single option within a `<select>` block","o|F|11R|9U|9V|Ao|11Z|11c|2p|3M|2p|11R|11d|Az","The kind of values in the sequence.","letters","a|1p|1X|11g","A sequence of numeric values.","o|3s|1p|11i","A sequence of math expressions (allows symbolic from/to/step).","o|3s|1X|11k","A sequence of letters (single-letter or multi-letter labels).","o|3s|11g|11m","a|11j|11l|11n","o|HC|2g|11f|11h|11o|3y","The first value in the sequence.","_componentWithSelectableType","o|2h|hM|11q|11r","The last value in the sequence. Used together with from to determine length when length is not specified.","o|2h|hX|11t|11r","step","The increment between successive values in the sequence.","o|2h|11v|11w|1X","The number of values in the sequence.","o|2h|Qh|11y|1q","exclude","Values to exclude from the sequence.","_componentListWithSelectableType","o|2h|120|121|122","a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB","a|3N|3O|3P|3Z","Generates a sequence of numbers, math expressions, or letters","o|F|1u|54|AZ|g0|124|125|3M|2p|3M|1u|126|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|1L|1M|1V|1W|1o|2R|2S|2T","2222222222222222222222212022222201222222222222112221211222222222222222222202","Type of value the slider produces.","a|1p|1T","Slider produces numeric values between `from` and `to`.","o|3s|1p|12C","Slider produces text values, one per child of the slider.","o|3s|1T|12E","a|12D|12F","o|3o|2g|12A|3M|1p|12B|12G|3y","Display width of the slider.","n|4q","o|uD|12J|3M","o|33|bx|12I|12K|bz","Display height of the slider.","n|1c","o|uD|12N|3M","o|33|k5|12M|12O|bz","initialValue","Initial value of the slider before any user interaction.","o|33|12Q|12R||11r","showControls","Whether to render play/pause controls alongside the slider.","o|2m|12T|12U|2p|2s|1V","showTicks","Whether to render tick marks on the slider.","o|2m|12W|12X|3M|2s|1V","rotateTickLabels","Whether to rotate the tick labels.","o|2m|12Z|12a|2p|2s|1V","showValue","Whether to display the current value next to the slider.","o|2m|12c|12d|3M|2s|1V","a|3|2f|3m|2k|2g","Minimum value of the slider\'s range.","o|12f|hM|12g|3M|5Q|1p","Maximum value of the slider\'s range.","o|12f|hX|12i|3M|Nn|1p","Increment between successive slider positions.","o|12f|11v|12k|3M|36|1p","o|2h|e9|eA|11r","a|2j|2t|2w|2z|32|37|3A|3E|3H|12H|12L|12P|12S|12V|12Y|12b|12e|12h|12j|12l|GH|H8|4Y|4c|4g|4j|12m","o|3L|bx|bz|2p|12I|3M","o|3L|k5|bz|2p|12M|3M","o|3L|12T|1V|2p|12U|3M","o|3L|12W|1V|2p|12X|3M","o|3L|12Z|1V|2p|12a|3M","o|3L|12c|1V|2p|12d|3M","o|65|hM|1p|2p|12g|3M|3M","o|65|hX|1p|2p|12i|3M|3M","o|65|11v|1p|2p|12k|3M|3M","items","The values the slider can take.","o|ry|12x|2p|12y","numItems","The total number of values.","o|3Q|130|1q|2p|131","The current value of the slider.","o|ry|3a|2p|133","a|3N|3O|3P|12o|12p|12q|12r|12s|12t|12u|12v|12w|Hd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|12z|132|134","An interactive slider input","o|F|91|128|129|Ao|12n|135|3M|2p|2p|91|136|Az","a|1v|1z|93|94|95","02000","Display width of the spreadsheet.","o|uD|12N|2p","o|33|bx|13A|13B|bz","minNumRows","Minimum number of rows displayed.","n|4","o|33|13D|13E|13F|1p","minNumColumns","Minimum number of columns displayed.","o|33|13H|13I|13F|1p","Display height of the spreadsheet.","o|2h|k5|13K|bz","columnHeaders","Header labels for the columns.","o|2m|13M|13N|3M|2s|1V","rowHeaders","Header labels for the rows.","o|2m|13P|13Q|3M|2s|1V","fixedRowsTop","Number of top rows fixed in place when scrolling.","o|33|13S|13T|5Q|1q","fixedColumnsLeft","Number of left columns fixed in place when scrolling.","o|33|13V|13W|5Q|1q","hiddenColumns","Indices of columns to hide.","o|33|13Y|13Z|54|1a","hiddenRows","Indices of rows to hide.","o|33|13b|13c|54|1a","a|2j|2t|2w|2z|32|37|3A|3E|3H|13C|13G|13J|13L|13O|13R|13U|13X|13a|13d","o|3L|bx|bz|2p|13A|3M","o|3L|13D|1p|2p|13E|3M","o|3L|13H|1p|2p|13I|3M","o|3L|13M|1V|2p|13N|3M","o|3L|13P|1V|2p|13Q|3M","o|3L|13S|1q|2p|13T|3M","o|3L|13V|1q|2p|13W|3M","o|3L|13Y|1a|2p|13Z|3M","o|3L|13b|1a|2p|13c|3M","The number of rows.","o|3Q|7A|1p|2p|13o","The number of columns.","o|3Q|7D|1p|2p|13q","o|3Q|k5|bz|2p|13K","cells","The raw text contents of all cells.","o|6x|2p|95","o|6x|2p|93","a|13v|13w","o|6v|13t|1v|3M|13u|4X|13x","The cells grouped by row.","o|6v|7K|1v|3M|13z|4X|13x","The cells grouped by column.","o|6x|2p|94","a|13v|142","o|6v|7N|1v|3M|141|4X|143","evaluatedCells","The evaluated values of all cells.","o|6v|145|1v|3M|146|4X|13x","evaluatedRows","The evaluated cell values grouped by row.","o|6v|148|1v|3M|149|4X|13x","evaluatedColumns","The evaluated cell values grouped by column.","o|6v|14B|1v|3M|14C|4X|143","pointsInCells","Cells whose values are interpreted as points.","a|X6|IK","o|6v|14E|1d|3M|14F|4X|14G","pointsInRows","Cell-derived points grouped by row.","o|6v|14I|1d|3M|14J|4X|14G","pointsInColumns","Cell-derived points grouped by column.","o|6v|14L|1d|3M|14M|4X|14G","a|3N|3O|3P|13f|13g|13h|13i|13j|13k|13l|13m|13n|3T|3U|3V|3W|3Z|13p|13r|13s|13y|140|144|147|14A|14D|14H|14K|14N","An interactive spreadsheet","o|F|92|138|139|9X|13e|14O|3M|2p|2p|92|14P|AT","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|G|I|J|89|8A|8B|K|8C|O|P|R|S|T|U|V|W|X|Y|Z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|8Z|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|8j|8k|8l|8m|1V|1W|1b|1c|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1j|8x|1l|1m|1n|8y|8z|90|91|92|93|94|95|96|97|98|1w|1x|99|1y|20|9A|22|23|9B|9C|9D|9E|9F|2E|2F|2G|2H|2I|9G|9H|2J|9I|2L|2M|2N|9J|2P|9K|9L|9M|9N|2R|9O|2S|2T|9P|9Q|9R|9S|9T","1111111111111111111111111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","rowNum","Row number where this cell is placed (1-based).","o|33|14T|14U||1T","colNum","Column number where this cell is placed (1-based).","o|33|14W|14X||1T","colSpan","Number of columns this cell spans.","o|33|14Z|14a|36|1q","halign","Horizontal alignment for the cell\'s content (left, center, or right).","o|33|14c|14d|5h|1T","Border style for the bottom edge of the cell.","o|33|5g|14f|42|1T","Border style for the right edge of the cell.","o|33|5i|14h|42|1T","Initial text content of the cell.","o|33|Zj|14j|AZ|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|14V|14Y|14b|14e|14g|14i|14k","o|3L|14T|1T|2p|14U|3M","o|3L|14W|1T|2p|14X|3M","o|3L|14Z|1q|2p|14a|3M","o|3L|Zj|1T|2p|14j|3M","Horizontal alignment of the cell\'s content (left, center, or right).","o|3Q|14c|1T|2p|14q","o|3Q|5g|1T|2p|14f","o|3Q|5i|1T|2p|14h","inHeader","Whether this cell is in a header row of the table.","o|3Q|14u|1V|2p|14v","The cell\'s content as a text string.","o|3Q|1T|1T|2p|14x","The cell\'s content interpreted as a math expression.","o|3Q|1X|1X|2p|14z","The cell\'s content interpreted as a number.","o|3Q|1p|1p|2p|151","a|3N|3O|3P|14m|14n|14o|14p|3T|3U|3V|3W|3Z|14r|14s|14t|14w|14y|150|152","A single cell within a tabular layout or spreadsheet","o|F|1v|14R|14S|Ao|14l|153|3M|3M|2p|1v|154|Az","displayContext","a|3|4|5|6|7|8|9|A|B|C|D|E|156","a|1v|1z","Row number where this row is placed (1-based).","o|33|14T|159||1T","header","Whether this row is a header row.","o|2m|15B|15C|2p|2s|1V","Default horizontal alignment for cells in this row.","o|33|14c|15E|5h|1T","Default vertical alignment for cells in this row.","o|33|c8|15G|cA|1T","Border style for the left edge of this row.","o|33|5h|15I|42|1T","Border style for the bottom edge of this row.","o|33|5g|15K|42|1T","o|2h|4w|4x|1U","o|2h|52|53|3D","o|Ap|56|57|2s|1V","o|Ap|59|5A|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|15A|15D|15F|15H|15J|15L|15M|15N|15O|15P","o|3L|14T|1T|2p|159|3M","o|3L|15B|1V|2p|15C|3M","o|3Q|14c|1T|2p|15E","o|3Q|c8|1T|2p|15G","Border style for the left edge of the row.","o|3Q|5h|1T|2p|15V","Border style for the bottom edge of the row.","o|3Q|5g|1T|2p|15X","a|3N|3O|3P|15R|15S|3T|3U|3V|3W|3Z|15T|15U|15W|15Y","row_table","A row within a tabular layout","in a table","o|157|93|158|BN|Ao|15Q|15Z|3M|2p|2p|15a|15b|Az|15c","Column number where this column is placed (1-based).","o|33|14W|15e||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|15f|15M|15N|15O|15P","o|3L|14W|1T|2p|15e|3M","a|3N|3O|3P|15h|3T|3U|3V|3W|3Z","column_table","A column of cells within a `<spreadsheet>`","o|157|94|158|BN|Ao|15g|15i|3M|2p|2p|15j|15k|Az|15c","Row number where this block starts (1-based; can be a letter or number).","o|33|14T|15m||1T","Column number where this block starts (1-based; can be a letter or number).","o|33|14W|15o||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|15n|15p","o|3L|14T|1T|2p|15m|3M","o|3L|14W|1T|2p|15o|3M","a|3N|3O|3P|15r|15s|3T|3U|3V|3W|3Z","Container for grouping `<cell>`, `<row>`, and `<column>` children inside a `<spreadsheet>`","o|F|95|138|139|Ao|15q|15t|3M|2p|2p|95|15u|Az","a|93|1z","Display width of the tabular layout.","o|33|bx|15x|13B|bz","Display height of the tabular layout.","o|33|k5|15z||bz","Default horizontal alignment for cells.","justify","a|5h|5b|5i|162","Left-align cell content.","o|3s|5h|164","Center cell content horizontally.","o|3s|5b|166","Right-align cell content.","o|3s|5i|168","Justify cell content across the full cell width.","o|3s|162|16A","a|165|167|169|16B","o|Bi|14c|161|5h|163|16C|3y","Default vertical alignment for cells.","Align cell content to the top.","o|3s|9|16F","Center cell content vertically.","o|3s|cA|16H","Align cell content to the bottom.","o|3s|5g|16J","a|16G|16I|16K","o|Bi|c8|16E|cA|cB|16L|3y","Border style for the top edge of the layout.","minor","major","a|42|16O|xA|16P","Do not render a border.","o|3s|42|16R","Render a thin border line.","o|3s|16O|16T","Render a medium-weight border line.","o|3s|xA|16V","Render a thick border line.","o|3s|16P|16X","a|16S|16U|16W|16Y","o|Bi|9|16N|42|16Q|16Z|3y","Border style for the left edge of the layout.","o|Bi|5h|16b|42|16Q|16Z|3y","Border style for the bottom edge of the layout.","o|Bi|5g|16d|42|16Q|16Z|3y","Border style for the right edge of the layout.","o|Bi|5i|16f|42|16Q|16Z|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|15y|160|16D|16M|16a|16c|16e|16g","o|3L|bx|bz|2p|15x|3M","o|3L|k5|bz|2p|15z|3M","o|3L|14c|1T|2p|161|3M","o|3L|c8|1T|2p|16E|3M","o|3L|9|1T|2p|16N|3M","o|3L|5h|1T|2p|16b|3M","o|3L|5g|1T|2p|16d|3M","o|3L|5i|1T|2p|16f|3M","a|3N|3O|3P|16i|16j|16k|16l|16m|16n|16o|16p|3T|3U|3V|3W|3Z","A simple tabular layout of cells","o|F|96|15w|BN|9X|16h|16q|3M|2p|2p|96|16r|AT","a|G|1z|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T","021111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111","suppressTableNameInTitle","Whether to omit the auto-generated table name from the title.","o|2m|16v|16w|2p|2s|1V","Whether to display an auto-generated table number.","o|2m|1p|16y|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|16x|16z","tableEnumeration","Auto-generated number for this table.","o|3Q|171|1T|2p|172","tableName","The full display name of the table (e.g., \'Table 2\').","o|3Q|174|1T|2p|175","The table\'s title.","o|3Q|G|1T|2p|177","a|3N|3O|3P|3T|3U|3V|3W|3Z|173|176|178","A container element for a `<tabular>`","o|F|97|16t|16u|9X|170|179|3M|3M|2p|97|17A|AT","a|1z|9I|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9J|9N|9Q|9S|9T","201111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222212221222221112111121222112211111222111111111111111111111111111111111111111111111111111","suppressFigureNameInCaption","Whether to omit the auto-generated figure name from the caption.","o|2m|17E|17F|2p|2s|1V","Whether to display an auto-generated figure number.","o|2m|1p|17H|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|17G|17I","figureEnumeration","Auto-generated number for this figure.","o|3Q|17K|1T|2p|17L","figureName","The full display name of the figure (e.g., \'Figure 3\').","o|3Q|17N|1T|2p|17O","The figure\'s caption text.","o|3Q|9I|1T|2p|17Q","a|3N|3O|3P|3T|3U|3V|3W|3Z|17M|17P|17R","A figure container holding graphical content with a caption","o|F|98|17C|17D|9X|17J|17S|3M|3M|2p|98|17T|AT","Whether the generated repeats should be treated as responses for assessment.","o|g3|38|17V","valueName","Name to bind the current item to inside the repeat template.","o|33|17X|17Y||1T","indexName","Name to bind the current 1-based index to inside the repeat template.","o|33|17a|17b||1T","The collection of items to iterate over when generating repeats.","o|2h|7f|17d|23","Component type used to wrap each item in the source.","o|2h|2g|17f|1T","a|2j|2t|2w|2z|32|37|17W|3E|3H|17Z|17c|17e|17g|gB","a|3N|3O|3Z","Repeats template content for each item in a source","o|F|1w|9U|9V|g0|17h|17i|3M|3M|3M|1w|17j|Az","a|2j|2t|2w|2z|32|37|17W|3E|3H|11p|11s|11u|11x|11z|123|17Z|17c|gB","Repeats template content for each value in an arithmetic sequence","o|F|1x|9U|9V|g0|17l|17i|3M|3M|3M|1x|17m|Az","dx","Horizontal spacing between pegs.","o|33|17o|17p|36|1p","dy","Vertical spacing between pegs.","o|33|17r|17s|36|1p","xoffset","Horizontal offset of the peg grid origin.","o|33|17u|17v|5Q|1p","yoffset","Vertical offset of the peg grid origin.","o|33|17x|17y|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|17q|17t|17w|17z","o|3L|17o|1p|2p|17p|3M","o|3L|17r|1p|2p|17s|3M","o|3L|17u|1p|2p|17v|3M","o|3L|17x|1p|2p|17y|3M","a|3N|3O|3P|Hd|QD|7s|QE|181|182|183|184|3T|3U|3V|3W|3Z|Hk","Renders a grid of pegs on a graph","o|F|99|Om|On|Op|180|185|3M|2p|2p|99|186|Az","_constraint","a|188|2d","Horizontal grid spacing.","o|33|17o|18A|36|1p","Vertical grid spacing.","o|33|17r|18C|36|1p","dz","Depth-wise grid spacing.","o|33|18E|18F|36|1p","Horizontal offset of the grid origin.","o|33|17u|18H|5Q|1p","Vertical offset of the grid origin.","o|33|17x|18J|5Q|1p","zoffset","Depth-wise offset of the grid origin.","o|33|18L|18M|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N","o|3L|17o|1p|2p|18A|3M","o|3L|17r|1p|2p|18C|3M","o|3L|18E|1p|2p|18F|3M","o|3L|17u|1p|2p|18H|3M","o|3L|17x|1p|2p|18J|3M","o|3L|18L|1p|2p|18M|3M","a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to lie on a grid","o|F|RJ|54|AZ|189|18O|18V|2p|2p|2p|RJ|18W|Az","buffer","Distance from the graph edge inside which the position is still considered constrained.","n|0.A","o|33|18Y|18Z|18a|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|18b","o|3L|18Y|1p|2p|18Z|3M","a|3N|3O|3P|18d|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to lie within a graph\'s bounds","o|F|RK|54|AZ|189|18c|18e|2p|2p|2p|RK|18f|Az","xthreshold","Horizontal distance within which the position attracts to a grid line.","n|0.2","o|33|18h|18i|18j|1p","ythreshold","Vertical distance within which the position attracts to a grid line.","o|33|18l|18m|18j|1p","zthreshold","Depth-wise distance within which the position attracts to a grid line.","o|33|18o|18p|18j|1p","includeGridlines","Whether to attract to entire grid lines (in addition to grid intersection points).","o|2m|18r|18s|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N|18k|18n|18q|18t","o|3L|18h|1p|2p|18i|3M","o|3L|18l|1p|2p|18m|3M","o|3L|18o|1p|2p|18p|3M","o|3L|18r|1V|2p|18s|3M","a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|18v|18w|18x|18y|3T|3U|3V|3W|3Z","Attracts a graphical component\'s position to grid lines when nearby","o|F|RL|54|AZ|189|18u|18z|2p|2p|2p|RL|190|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|1z|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y","222222222222222222222222221111222221211111111111112222221222222222122221111121222","relativeToGraphScales","Whether the constraint is interpreted relative to the enclosing graph\'s scales.","o|2m|194|195|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|196","o|3L|194|1V|2p|195|3M","a|3N|3O|3P|198|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to be within another component or components","o|F|RM|192|193|189|197|199|2p|2p|2p|RM|19A|Az","Whether the attraction threshold is interpreted relative to the enclosing graph\'s scales rather than absolute coordinates.","o|2m|194|19C|2p|2s|1V","Distance within which the position attracts to a target.","o|2h|E6|19E|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|19D|19F","o|3L|194|1V|2p|19C|3M","o|3Q|E6|1p|2p|19E","a|3N|3O|3P|19H|3T|3U|3V|3W|3Z|19I","Attracts a graphical component\'s position to another component when nearby","o|F|RN|192|193|189|19G|19J|2p|2p|2p|RN|19K|Az","a|RJ|RK|RL|RM|RN|RO|RP|RQ|1z","111111112","A constraint that is satisfied if any of its child constraints are satisfied","o|F|RO|19M|19N|189|3I|Aa|2p|2p|2p|RO|19O|Az","Distance within which the position attracts to the constraint location.","o|33|E6|19Q|Pq|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|19R","o|3L|E6|1p|2p|19Q|3M","a|3N|3O|3P|19T|3T|3U|3V|3W|3Z","Wraps another constraint so it acts as a soft attraction within a threshold","o|F|RP|19M|19N|189|19S|19U|2p|2p|2p|RP|19V|Az","Constrains a graphical component\'s position to lie inside a region","o|F|RQ|192|193|189|197|199|2p|2p|2p|RQ|19X|Az","a|1K|1f|1z|2Q|8n|8u|8q|8r|8s|8t|8Y|8p","102100011110","Style number applied to the resulting intersection components.","o|g3|34|19b","a|2j|2t|2w|2z|32|19c|3A|3E|3H|gB","a|3N|3P|3Z","Renders intersections between graphical objects","o|F|1y|19Z|19a|g0|19d|19e|3M|2p|2p|1y|19f|Az","case","a|1z|19h|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y|An","101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111110","Convenience for a single-case form: the boolean condition for which the children are rendered.","o|Ap|Aq|19k|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|19l","Renders content conditionally based on its `<case>` or `<else>` children","o|F|1z|19i|19j|g0|19m|125|3M|3M|2p|1z|19n|Az","The children rendered as a comma-separated text string.","o|3Q|1T|1T|2p|19p","The children rendered as a comma-separated LaTeX string.","o|3Q|2V|2V|2p|19r","a|3N|3O|3P|3T|3U|3V|3W|3Z|19q|19s","Renders its children as a comma-separated list","o|F|20|2Z|2a|3l|3I|19t|3M|3M|2p|20|19u|3h","numVariants","The total number of variants to generate.","o|2h|19w|19x|1q","uniqueVariants","Whether to require generated variants to be uniquely distinguishable.","o|Ap|19z|1A0|2s|1V","variantsToInclude","Restrict the available variants to this list (by name or index).","o|2h|1A2|1A3|11U","variantsToExclude","Variants to exclude from those generated.","o|2h|1A5|1A6|11U","variantNames","Names assigned to the generated variants.","o|2h|1A8|1A9|11U","seeds","Random seeds used when generating variants.","o|2h|1AB|1AC|11U","a|2j|2t|2w|2z|32|37|3A|3E|3H|19y|1A1|1A4|1A7|1AA|1AD","Configures how variants are generated for the enclosing document or section","o|F|9A|54|AZ|Ao|1AE|Aa|3M|2p|2p|9A|1AF|Az","numToSelect","How many values to select from the sequence.","o|33|1AH|1AI|36|1q","withReplacement","Whether the same value can be selected more than once.","o|2m|1AK|1AL|2p|2s|1V","Whether and how to sort the selected values.","unsorted","increasing","decreasing","a|1AO|1AP|1AQ|2q|2r","Preserve the random selection order.","o|3s|1AO|1AS","Sort the selected values in increasing order.","o|3s|1AP|1AU","Sort the selected values in decreasing order.","o|3s|1AQ|1AW","a|1AT|1AV|1AX","o|Bi|2L|1AN|1AO|1AR|1AY|3y","excludeCombinations","Lists of value combinations to exclude from the selection.","_componentListOfListsWithSelectableType","o|2h|1Aa|1Ab|1Ac","coprime","Require the selected numbers to be pairwise coprime (numbers only).","o|2m|1Ae|1Af|2p|2s|1V","a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB|1AJ|1AM|1AZ|1Ad|1Ag","o|3L|1AH|1q|2p|1AI|3M","o|3L|1AK|1V|2p|1AL|3M","o|3L|2L|1T|2p|1AN|3M","o|3L|1Ae|1V|2p|1Af|3M","a|3N|3O|3P|1Ai|1Aj|1Ak|1Al|3Z","Randomly selects values from a sequence of numbers, math expressions, or letters to create document variants","o|F|21|54|AZ|g0|1Ah|1Am|3M|2p|3M|21|1An|Az","a|11R|1z","How many child components to select.","o|33|1AH|1Aq|36|1q","Whether the same child can be selected more than once.","o|2m|1AK|1As|2p|2s|1V","Component type to select from.","o|2h|2g|1Au|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ar|1At|1Av|gB","o|3L|1AH|1q|2p|1Aq|3M","o|3L|1AK|1V|2p|1As|3M","a|3N|3O|3P|1Ax|1Ay|3Z","Randomly selects components from a list of children to create document variants","o|F|22|1Ap|BN|g0|1Aw|1Az|3M|3M|3M|22|1B0|Az","Whether this group\'s children should be treated as responses for assessment.","o|g3|38|1B2","rendered","Whether the group\'s children are rendered.","o|2m|1B4|1B5|3M|2s|1V","createComponentOfType","Component type to wrap each child as when expanding the group.","o|2h|1B7|1B8|1T","Number of components to create when expanding (used with createComponentOfType).","o|2h|gF|1BA|1p","Whether to render the group\'s children separated by commas (true) or with no separator (false).","o|2m|20|1BC|2p|2s|1V","a|2j|2t|2w|2z|32|37|1B3|3E|3H|1B6|1B9|1BB|1BD","o|3L|1B4|1V|2p|1B5|3M","a|3N|3O|1BF|3Z","A logical grouping of components","o|F|23|9U|9V|g0|1BE|1BG|3M|3M|2p|23|1BH|Az","target","Reference to the state variable that will be animated.","o|2h|1BJ|1BK|3D","animationOn","Whether the animation is currently playing.","o|2m|1BM|1BN|2p|2s|1V","animationMode","How the animation steps through the sequence.","increase","decrease","increase once","decrease once","oscillate","a|1BR|1BS|1BT|1BU|1BV","Step through values from first to last, looping back to the start.","o|3s|1BR|1BX","Step through values from last to first, looping back to the end.","o|3s|1BS|1BZ","Step from first to last and stop without looping.","o|3s|1BT|1Bb","Step from last to first and stop without looping.","o|3s|1BU|1Bd","Step from first to last, then reverse direction at each end.","o|3s|1BV|1Bf","a|1BY|1Ba|1Bc|1Be|1Bg","o|Bi|1BP|1BQ|1BR|1BW|1Bh|3y","animationInterval","Time in milliseconds between successive animation steps.","o|33|1Bj|1Bk|Nv|1p","allowAdjustmentsWhileRunning","Whether sequence parameters can be adjusted while the animation is running.","o|2m|1Bm|1Bn|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|11p|11s|11u|11x|11z|123|1BL|1BO|1Bi|1Bl|1Bo","o|3L|1BM|1V|2p|1BN|3M","o|3L|1BP|1T|2p|1BQ|3M","o|3L|1Bj|1p|2p|1Bk|3M","o|3L|1Bm|1V|2p|1Bn|3M","Index of the currently selected value in the sequence (1-based).","o|3Q|vc|1p|2p|1Bu","The currently selected value of the animation.","o|ry|3a|2p|1Bw","currentAnimationDirection",\'Current direction of the animation ("increase" or "decrease"; flips during oscillation).\',"o|3Q|1By|1T|2p|1Bz","a|3N|3O|3P|1Bq|1Br|1Bs|1Bt|3T|3U|3V|3W|3Z|1Bv|1Bx|1C0","Animates a value through a sequence over time","o|F|9B|54|AZ|Ao|1Bp|1C1|3M|2p|2p|9B|1C2|Az","Whether to treat the inputs as unordered.","o|2m|4n|1C4|2p|2s|1V","Whether to force symbolic evaluation.","o|2m|DH|1C6|2p|2s|1V","Whether to force numeric evaluation.","o|2m|DK|1C8|2p|2s|1V","The function to evaluate.","o|2h|1r|1CA|1r","input","Input value(s) at which to evaluate the function.","o|2h|1CC|1CD|1Y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1C5|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1C7|1C9|1CB|1CE","o|3L|4n|1V|2p|1C4|3M","o|3L|DH|1V|2p|1C6|3M","o|3L|DK|1V|2p|1C8|3M","o|3Q|3a|24|2p|6e","The function evaluated at the inputs as a math expression.","o|3Q|I9|1X|2p|1CK","a|3N|3O|3P|66|67|68|69|1CG|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1CH|1CI|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1CJ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1CL|7S|7V|7Y|7b","Evaluates a function at a math value","o|F|24|54|AZ|3l|1CF|1CM|3M|2p|2p|24|1CN|3h","Distribution from which to sample.","discreteUniform","gaussian","a|W7|1CQ|1CR","Continuous uniform distribution over `[from, to]`.","o|3s|W7|1CT","Discrete uniform distribution over integers in `[from, to]`.","o|3s|1CQ|1CV","Normal (Gaussian) distribution with the specified mean and standard deviation.","o|3s|1CR|1CX","a|1CU|1CW|1CY","o|Bi|2g|1CP|W7|1CS|1CZ|3y","Mean of the sampling distribution (Gaussian).","o|33|l|1Cb|5Q|1p","Standard deviation of the sampling distribution (Gaussian).","o|33|o|1Cd|36|1p","Variance of the sampling distribution (Gaussian).","o|33|n|1Cf|36|1p","Lower bound of the sampling range.","o|33|hM|1Ch||1p","Upper bound of the sampling range.","o|33|hX|1Cj||1p","Step size between samples for the discrete-uniform distribution.","o|33|11v|1Cl|36|1p","Values to exclude from the sample space.","o|33|120|1Cn|54|1a","How many random numbers to select.","o|33|1AH|1Cp|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|gB|1Cq","o|3L|2g|1T|2p|1CP|3M","o|3L|1AH|1q|2p|1Cp|3M","Step size between sample values (for discrete distributions).","o|3Q|11v|1p|2p|1Cu","o|3Q|hM|1p|2p|1Ch","o|3Q|hX|1p|2p|1Cj","Mean of the sampling distribution.","o|3Q|l|1p|2p|1Cy","Variance of the sampling distribution.","o|3Q|n|1p|2p|1D0","Standard deviation of the sampling distribution.","o|3Q|o|1p|2p|1D2","a|3N|3O|3P|1Cs|1Ct|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3","Selects a fixed set of random numbers to create document variants","o|F|25|54|AZ|g0|1Cr|1D4|3M|2p|3M|25|1D5|Az","numSamples","Number of samples to draw.","o|33|1D7|1D8|36|1p","variantDeterminesSeed","Whether the document\'s variant index determines the random seed.","o|Ap|1DA|1DB|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1D9|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|1DC|gB","o|3L|1D7|1p|2p|1D8|3M","o|3L|1DA|1V|2p|1DB|3M","a|3N|3O|3P|1DE|1Cs|1DF|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3","Samples random numbers from a distribution","o|F|26|54|AZ|g0|1DD|1DG|3M|2p|3M|26|1DH|Az","Lower bound (inclusive) of the prime range to select from.","o|33|hM|1DJ|4X|1q","Upper bound (inclusive) of the prime range to select from.","o|33|hX|1DL|12N|1q","Primes to exclude from the selection.","o|33|120|1DN|54|1a","How many prime numbers to select.","o|33|1AH|1DP|36|1q","Whether the same prime can be selected more than once.","o|2m|1AK|1DR|2p|2s|1V","Sort order applied to the selected primes.","Sort the selected primes in increasing order.","o|3s|1AP|1DU","Sort the selected primes in decreasing order.","o|3s|1AQ|1DW","a|1AT|1DV|1DX","o|Bi|2L|1DT|1AO|1AR|1DY|3y","Combinations of values that should not be selected together.","_listOfNumberLists","o|2h|1Aa|1Da|1Db","a|2j|2t|2w|2z|32|37|3A|3E|3H|1DK|1DM|1DO|1DQ|1DS|1DZ|1Dc|gB","o|3L|hM|1q|2p|1DJ|3M","o|3L|hX|1q|2p|1DL|3M","o|3L|120|1a|2p|1DN|3M","o|3L|1AH|1q|2p|1DP|3M","o|3L|1AK|1V|2p|1DR|3M","o|3L|2L|1T|2p|1DT|3M","a|3N|3O|3P|1De|1Df|1Dg|1Dh|1Di|1Dj|3Z","Randomly selects prime numbers from a range to create document variants","o|F|27|54|AZ|g0|1Dd|1Dk|3M|2p|3M|27|1Dl|Az","Number of prime samples to draw.","o|33|1D7|1Dn|36|1p","Lower bound (inclusive) of the prime range to sample from.","o|33|hM|1Dp|4X|1q","Upper bound (inclusive) of the prime range to sample from.","o|33|hX|1Dr|12N|1q","Primes to exclude from the sample.","o|33|120|1Dt|54|1a","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Do|1Dq|1Ds|1Du|1DC|gB","o|3L|1D7|1p|2p|1Dn|3M","o|3L|hM|1q|2p|1Dp|3M","o|3L|hX|1q|2p|1Dr|3M","o|3L|120|1a|2p|1Dt|3M","a|3N|3O|3P|1Dw|1Dx|1Dy|1Dz|1DF|3Z","Samples random prime numbers","o|F|28|54|AZ|g0|1Dv|1E0|3M|2p|3M|28|1E1|Az","Type of values being substituted.","a|1X|1T","Substitute within math expressions.","o|3s|1X|1E5","Substitute within text values.","o|3s|1T|1E7","a|1E6|1E8","o|HC|2g|1E3|1E4|1E9|3y","match","Pattern to match in the source value.","o|33|1EB|1EC||11r","replacement","Value to substitute in place of each match.","o|33|1EE|1EF||11r","Level of simplification applied after substitution.","Fully simplify the resulting expression.","o|3s|43|1EI","a|49|1EJ|4D|4F|4H","o|Bi|40|1EH|42|47|1EK|3y","matchWholeWord","Whether matching is restricted to whole words (text mode).","o|2m|1EM|1EN|2p|2s|1V","matchCase","Whether matching is case-sensitive (text mode).","o|2m|1EP|1EQ|2p|2s|1V","preserveCase","Whether the case of the original is preserved when substituting.","o|2m|1ES|1ET|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1EA|1ED|1EG|1EL|H8|4Y|4c|4g|4j|1EO|1ER|1EU","o|3L|2g|1T|2p|1E3|3M","o|3L|40|1T|2p|1EH|3M","o|3L|1EM|1V|2p|1EN|3M","o|3L|1EP|1V|2p|1EQ|3M","o|3L|1ES|1V|2p|1ET|3M","a|3N|3O|3P|1EW|1EX|1EY|1EZ|1Ea|3Z|6X|6Y|6Z|6a|6b","Substitutes math expressions into another expression","o|F|29|9U|9V|g0|1EV|1Eb|3M|3M|3M|29|1Ec|Az","o|Ap|4n|4o|2s|1V","minIndex","Smallest period index considered when listing offsets.","-Infinity","o|33|1Ef|1Eg|1Eh|1q","maxIndex","Largest period index considered when listing offsets.","o|33|1Ej|1Ek|9k|1q","offsets","Offsets within one period.","o|33|1Em|1En||1Y","The period of the set.","o|33|Y8|1Ep||1X","minIndexAsList","Smallest period index when rendered as a list.","n|-1","o|33|1Er|1Es|1Et|1q","maxIndexAsList","Largest period index when rendered as a list.","o|33|1Ev|1Ew|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Ei|1El|1Eo|1Eq|1Eu|1Ex","o|3L|1Ef|1q|2p|1Eg|3M","o|3L|1Ej|1q|2p|1Ek|3M","o|3L|1Em|1Y|2p|1En|3M","o|3L|Y8|1X|2p|1Ep|3M","o|3L|1Er|1q|2p|1Es|3M","o|3L|1Ev|1q|2p|1Ew|3M","o|3Q|3a|2A|2p|6e","numOffsets","The number of distinct offsets within one period.","o|3Q|1F6|1q|2p|1F7","redundantOffsets","Offsets that are redundant given the period.","o|3Q|1F9|1V|2p|1FA","The periodic set rendered as a list of explicit values.","o|3Q|20|1Y|2p|1FC","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1Ez|1F0|1F1|1F2|1F3|1F4|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1F5|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1F8|1FB|1FD|7S|7V|7Y|7b","A periodic set of real numbers","o|F|2A|54|AZ|3l|1Ey|1FE|3M|2p|2p|2A|1FF|3h","a|1z|dd|2f","200","Explicit width of the image (overrides size).","o|33|bx|1FJ||bz","Named size preset for the image.","o|Bi|uB|1FL|xA|xE|xP|3y","Aspect ratio (width / height) for the image.","o|33|xR|1FN||1p","How to size the image.","o|Bi|xU|1FP|AT|xW|xb|3y","Horizontal alignment of the image within its container.","Center the image horizontally.","o|3s|5b|1FS","Align the image to the left edge.","o|3s|5h|1FU","Align the image to the right edge.","o|3s|5i|1FW","a|1FT|1FV|1FX","o|Bi|xd|1FR|5b|xf|1FY|3y","Whether the image is purely decorative.","o|2m|zM|1Fa|2p|2s|1V","source","URL or path of the image source.","o|33|1Fc|1Fd|AZ|1T","authorName","Name of the author of the image.","o|33|1Ff|1Fg||1T","authorUrl","URL to link the author\'s name to in the attribution (e.g. the author\'s profile page).","o|33|1Fi|1Fj||1T","imageName","Name of the image, used in place of the generic word “Image” in the attribution.","o|33|1Fl|1Fm||1T","originalUrl","Original URL where the image can be found, used to link the image name in the attribution.","o|33|1Fo|1Fp||1T","licenseName","Name of the license for the image.","o|33|1Fr|1Fs||1T","licenseUrl","URL for the license of the image.","o|33|1Fu|1Fv||1T","a|3|2f|2k|2l|3n|cK|2g","licenseCodes","License code(s) for the image. Specify two codes to indicate the image is dual licensed.","CC-BY","CC-BY-SA","CC-BY-ND","CC-BY-NC","CC-BY-NC-SA","CC-BY-NC-ND","CC0","PDM","GFDL","FAL","OGL","MIT","APACHE-2.0","a|1G0|1G1|1G2|1G3|1G4|1G5|1G6|1G7|1G8|1G9|1GA|1GB|1GC","Creative Commons Attribution: reuse with credit, including commercially.","o|3s|1G0|1GE","Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license.","o|3s|1G1|1GG","Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit.","o|3s|1G2|1GI","Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes.","o|3s|1G3|1GK","Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license.","o|3s|1G4|1GM","Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit.","o|3s|1G5|1GO","Creative Commons Zero: the creator has dedicated the work to the public domain.","o|3s|1G6|1GQ","Public Domain Mark: the work is free of known copyright restrictions.","o|3s|1G7|1GS","GNU Free Documentation License: copyleft license common on Wikimedia.","o|3s|1G8|1GU","Free Art License: copyleft license for artistic works.","o|3s|1G9|1GW","UK Open Government Licence: reuse government material with attribution.","o|3s|1GA|1GY","MIT License: permissive license common for icon and illustration sets.","o|3s|1GB|1Ga","Apache License 2.0: permissive license common for icon and illustration sets.","o|3s|1GC|1Gc","a|1GF|1GH|1GJ|1GL|1GN|1GP|1GR|1GT|1GV|1GX|1GZ|1Gb|1Gd","o|1Fx|1Fy|1Fz||1GD|1Ge|3M|3y","licenseVersion","Version of the Creative Commons license(s) given in `licenseCodes` (ignored by non-Creative-Commons licenses).","4.0","1.0","2.0","2.5","3.0","a|1Gj|1Gk|1Gl|1Gm|1Gi","Creative Commons version 1.0.","o|3s|1Gj|1Go","Creative Commons version 2.0.","o|3s|1Gk|1Gq","Creative Commons version 2.5.","o|3s|1Gl|1Gs","Creative Commons version 3.0.","o|3s|1Gm|1Gu","Creative Commons version 4.0.","o|3s|1Gi|1Gw","a|1Gp|1Gr|1Gt|1Gv|1Gx","o|Bi|1Gg|1Gh|1Gi|1Gn|1Gy|3y","asFileName","File name to use when downloading the image.","o|33|1H0|1H1||1T","mimeType","MIME type of the image.","o|33|1H3|1H4||1T","Whether the image can be dragged on a graph.","o|2m|5L|1H6|3M|2s|1V","rotate","Rotation angle (radians) applied to the image.","o|33|1H8|1H9|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1FK|1FM|1FO|1FQ|1FZ|1Fb|1Fe|1Fh|1Fk|1Fn|1Fq|1Ft|1Fw|1Gf|1Gz|1H2|1H5|1H7|5R|5X|63|1HA","o|3L|xU|1T|2p|1FP|3M","o|3L|xd|1T|2p|1FR|3M","o|3L|zM|1V|2p|1Fa|3M","o|3L|1Fc|1T|2p|1Fd|3M","o|3L|1Ff|1T|2p|1Fg|3M","o|3L|1Fi|1T|2p|1Fj|3M","o|3L|1Fl|1T|2p|1Fm|3M","o|3L|1Fo|1T|2p|1Fp|3M","o|3L|1Fy|1U|2p|1Fz|3M","o|3L|1Gg|1T|2p|1Gh|3M","o|3L|1H0|1T|2p|1H1|3M","o|3L|1H3|1T|2p|1H4|3M","o|3L|5L|1V|2p|1H6|3M","o|3L|1H8|1p|2p|1H9|3M","A short accessibility description of the image.","o|3Q|dd|1T|2p|1HQ","The size of the image.","o|3Q|uB|1T|2p|1HS","The display width of the image.","o|3Q|bx|bz|2p|1HU","The aspect ratio (width / height) of the image.","o|3Q|xR|1p|2p|1HW","licenseNames","The license name(s) for the image. Derived from `licenseCodes` when given; otherwise from the `licenseName` attribute.","o|3Q|1HY|1U|2p|1HZ","licenseUrls","The license URL(s) for the image. Derived from `licenseCodes` (and `licenseVersion`) when given; otherwise from the `licenseUrl` attribute.","o|3Q|1Hb|1U|2p|1Hc","a|3N|3O|3P|1HC|1HD|1HE|1HF|1HG|1HH|1HI|1HJ|1HK|1HL|1HM|1HN|1HO|6I|6K|1HP|3T|3U|3V|3W|3Z|6W|1HR|1HT|1HV|1HX|1Ha|1Hd","Displays a static image","o|F|9C|1FH|1FI|9X|1HB|1He|3M|2p|2p|9C|1Hf|AT","Explicit width of the video player (overrides size).","o|2h|bx|1Hh|bz","Named size preset for the video player.","o|Bi|uB|1Hj|43|xE|xP|3y","Aspect ratio (width / height) for the video player.","16 / 9","o|33|xR|1Hl|1Hm|1p","How to size the video player.","o|Bi|xU|1Ho|AT|xW|xb|3y","Horizontal alignment of the video within its container.","Center the video horizontally.","o|3s|5b|1Hr","Align the video to the left edge.","o|3s|5h|1Ht","Align the video to the right edge.","o|3s|5i|1Hv","a|1Hs|1Hu|1Hw","o|Bi|xd|1Hq|5b|xf|1Hx|3y","youtube","YouTube video ID to embed.","o|33|1Hz|1I0||1T","URL of the video source.","o|33|1Fc|1I2||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Hi|1Hk|1Hn|1Hp|1Hy|1I1|1I3","o|3L|xU|1T|2p|1Ho|3M","o|3L|xd|1T|2p|1Hq|3M","o|3L|1Hz|1T|2p|1I0|3M","o|3L|1Fc|1T|2p|1I2|3M","A short accessibility description of the video.","o|3Q|dd|1T|2p|1I9","The size of the video player.","o|3Q|uB|1T|2p|1IB","The display width of the video player.","o|3Q|bx|bz|2p|1ID","The aspect ratio (width / height) of the video player.","o|3Q|xR|1p|2p|1IF","state","The video\'s current playback state (e.g. playing, paused).","o|3Q|1IH|1T|2p|1II","time","The current playback time in seconds.","o|3Q|1IK|1p|2p|1IL","duration","The total duration of the video in seconds.","o|3Q|1IN|1p|2p|1IO","secondsWatched","Total seconds the viewer has watched.","o|3Q|1IQ|1p|2p|1IR","fractionWatched","Fraction of the video the viewer has watched (0 to 1).","o|3Q|1IT|1p|2p|1IU","a|3N|3O|3P|1I5|1I6|1I7|1I8|3T|3U|3V|3W|3Z|1IA|1IC|1IE|1IG|1IJ|1IM|1IP|1IS|1IV","Embeds a video player","o|F|9D|1FH|1FI|9X|1I4|1IW|3M|2p|2p|9D|1IX|AT","a|G|1z|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","0111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Whether the hint is currently open (revealed).","o|3Q|M7|1V|2p|1Ib","The hint\'s title text.","o|3Q|G|1T|2p|1Id","a|3N|3O|3P|3T|3U|3V|3W|3Z|1Ic|1Ie","Hint shown on demand to help with an exercise","o|F|9E|1IZ|1Ia|9X|3I|1If|3M|3M|2p|9E|1Ig|AT","The formatted value rendered as a text string.","o|3Q|1T|1T|2p|1Ii","The numeric value with thousands separators.","o|3Q|3a|2B|2p|1Ik","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Ij|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1Il","Renders a numeric value with thousands separators (e.g. 1,000,000)","o|F|2B|fq|fr|3l|Jc|1Im|3M|3M|2p|2B|1In|3h","pluralForm","Custom plural form to use (overrides automatic pluralization).","o|33|1Ip|1Iq||1T","basedOnNumber","Number that determines whether to use the singular or plural form.","o|33|1Is|1It||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63|1Ir|1Iu","o|3L|1Ip|1T|2p|1Iq|3M","o|3L|1Is|1p|2p|1It|3M","The selected word as a text string.","o|3Q|1T|1T|2p|1Iy","The selected (singular or plural) word.","o|3Q|3a|1T|2p|1J0","a|3N|3O|3P|Jd|6I|Je|6K|1Iw|1Ix|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Iz|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1J1","Renders a word in its singular or plural form based on a count","o|F|2C|fq|fr|3l|1Iv|1J2|3M|3M|2p|2C|1J3|3h","Boolean expression; the feedback is shown when the condition is true.","o|Ap|Aq|1J5|2s|1V","updateWith","References whose changes trigger re-evaluation of the feedback.","o|2h|1J7|1J8|3D","a|2j|2w|2z|32|37|3A|3E|3H|1J6|1J9","a|3O|3P|3T|3U|3V|3W|3Z","Targeted feedback shown when conditions are met","o|F|9F|9U|9V|9X|1JA|1JB|3M|3M|2p|9F|1JC|AT","Marks its children as response components for an enclosing answer","o|F|pI|9U|9V|Ao|3I|Aa|2p|3M|2p|pI|1JE|Az","A single conditional branch within `<conditionalContent>`","o|F|19h|9U|9V|Ao|At|Ax|2p|3M|2p|19h|1JG|Az","minSentencesPerParagraph","Minimum number of sentences per generated paragraph.","o|33|1JI|1JJ|13F|1p","maxSentencesPerParagraph","Maximum number of sentences per generated paragraph.","n|8","o|33|1JL|1JM|1JN|1p","minWordsPerSentence","Minimum number of words per generated sentence.","o|33|1JP|1JQ|13F|1p","maxWordsPerSentence","Maximum number of words per generated sentence.","o|33|1JS|1JT|1JN|1p","generateWords","Number of words of lorem-ipsum to generate.","o|33|1JV|1JW||1p","generateSentences","Number of sentences of lorem-ipsum to generate.","o|33|1JY|1JZ||1p","generateParagraphs","Number of paragraphs of lorem-ipsum to generate.","o|33|1Jb|1Jc||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1JK|1JO|1JR|1JU|1JX|1Ja|1Jd","o|3L|1JI|1p|2p|1JJ|3M","o|3L|1JL|1p|2p|1JM|3M","o|3L|1JP|1p|2p|1JQ|3M","o|3L|1JS|1p|2p|1JT|3M","a|3N|3O|3P|1Jf|1Jg|1Jh|1Ji|3Z","Generates lorem ipsum placeholder text","o|F|2D|54|AZ|g0|1Je|1Jj|3M|2p|2p|2D|1Jk|Az","Reference to the state variable that will be updated.","o|2h|1BJ|1Jm|3D","Component type used to interpret the new value.","a|1X|1p|1V|1T","Treat the new value as a math expression.","o|3s|1X|1Jq","Treat the new value as a number.","o|3s|1p|1Js","Treat the new value as a boolean.","o|3s|1V|1Ju","Treat the new value as text.","o|3s|1T|1Jw","a|1Jr|1Jt|1Jv|1Jx","o|HC|2g|1Jo|1Jp|1Jy|3y","newValue","New value to assign to the target.","o|2h|1K0|1K1|11r","Whether the update button can be dragged on a graph.","o|2m|5L|1K3|3M|2s|1V","triggerWhen","Boolean expression that fires the action whenever it transitions to true.","triggering","o|4d|1K5|1K6|1K7|2p|2s|1V","a|3|2f|4N|2g","triggerWith","References to components whose value changes should fire this action.","o|1K9|1KA|1KB|1K7|3D","triggerWhenObjectsClicked","References to components whose click events should fire this action.","o|1K9|1KD|1KE|1K7|3D","triggerWhenObjectsFocused","References to components whose focus events should fire this action.","o|1K9|1KG|1KH|1K7|3D","Level of simplification applied to the new value.","Fully simplify the new value.","o|3s|43|1KK","a|49|1KL|4D|4F|4H","o|Bi|40|1KJ|42|47|1KM|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Jn|1Jz|1K2|1K4|5X|63|GH|1K8|1KC|1KF|1KI|1KN","o|3L|5L|1V|2p|1K3|3M","o|3L|40|1T|2p|1KJ|3M","a|3N|3O|3P|1KP|6K|Hd|1KQ|3T|3U|3V|3W|3Z|Hk|6W","Updates one or more state variables on a target component","o|F|2E|Om|On|3l|1KO|1KR|3M|2p|2p|2E|1KS|3h","a|I|J|1z|2S|G|H|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1110111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Reference to the component whose action will be invoked.","o|2h|1BJ|1KW|3D","actionName","Name of the action to invoke on the target component.","o|33|1KY|1KZ||1T","Whether the action button can be dragged on a graph.","o|2m|5L|1Kb|3M|2s|1V","Numeric arguments passed to the invoked action.","o|2h|44|1Kd|1a","Numeric argument passed to the invoked action.","o|2h|1p|1Kf|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1KX|1Ka|1Kc|GH|5X|63|1K8|1KC|1KF|1KI|1Ke|1Kg","o|3L|1KY|1T|2p|1KZ|3M","o|3L|5L|1V|2p|1Kb|3M","a|3N|3O|3P|1Ki|1Kj|Hd|6K|3T|3U|3V|3W|3Z|Hk|6W","Triggers an action when clicked or in response to a specified user interaction","o|F|2F|1KU|1KV|3l|1Kh|1Kk|3M|3M|2p|2F|1Kl|3h","a|1z|2E|2F|I|J|2S","200110","Whether the trigger set\'s button can be dragged on a graph.","o|2m|5L|1Kp|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Kq|5X|63|GH|1K8|1KC|1KF|1KI","o|3L|5L|1V|2p|1Kp|3M","a|3N|3O|3P|1Ks|6K|Hd|3T|3U|3V|3W|3Z|Hk|6W","Groups a set of `<updateValue>` or `<callAction>` components which share a single trigger condition","o|F|2G|1Kn|1Ko|3l|1Kr|1Kt|3M|2p|2p|2G|1Ku|3h","numIterates","Number of iterations to compute.","o|33|1Kw|1Kx|5Q|1q","Starting value passed to the function on the first iteration.","o|33|12Q|1Kz|5J|1X","The function to iterate.","o|2h|1r|1L1|1r","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ky|1C7|1C9|1L0|1L2|H8|4Y|4c|4g|4j","o|3L|1Kw|1q|2p|1Kx|3M","Number of dimensions of each iterate.","o|3Q|6r|1q|2p|1L5","allIterates","All computed iterates of the function.","o|3Q|1L7|1Y|2p|1L8","allIteratesWithInitial","All iterates including the initial value.","o|3Q|1LA|1Y|2p|1LB","iterates","The list of iterate values.","o|6v|1LD|1X|3M|1LE|36|75","finalIterate","The last iterate value.","o|3Q|1LG|1X|2p|1LH","a|3N|3O|3P|1L4|1CH|1CI|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1L6|1L9|1LC|1LF|1LI","List of values produced by iterating a function","o|F|2H|54|AZ|3l|1L3|1LJ|3M|2p|2p|2H|1LK|3h","a|2j|2t|2w|2z|32|1B3|3E|3H|1B6|1B9|1BB|1BD","a|3N|1BF|3Z","A reusable group with parameterized attributes; can be copied elsewhere with new parameter values","o|F|2I|9U|9V|g0|1LM|1LN|3M|3M|2p|2I|1LO|Az","Declares attributes accepted by an enclosing `<module>`","o|F|9G|9U|9V|g0|3I|125|3M|3M|2p|9G|1LQ|Az","a|Ks|1z|Kt|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","010111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Container for components used for setup but not rendered","o|F|9H|1LS|1LT|g0|3I|125|3M|3M|2p|9H|1LU|Az","The footnote\'s body as plain text.","o|3Q|1T|1T|2p|1LW","footnoteTag","The auto-generated marker (number) used to reference this footnote.","o|3Q|1LY|1T|2p|1LZ","a|3N|3O|3P|3T|3U|3V|3W|3Z|1LX|1La","Inline footnote whose body is shown on demand and is auto-numbered in the document","o|F|2J|2Z|2a|3l|3I|1Lb|3M|3M|2p|2J|1Lc|3h","The caption rendered as a plain text string.","o|3Q|1T|1T|2p|1Le","a|3N|3O|3P|3T|3U|3V|3W|3Z|1Lf","A caption attached to a figure or table","o|F|9I|fL|fM|9X|3I|1Lg|3M|3M|2p|9I|1Lh|AT","Whether the endpoint is open (excluded) rather than closed (included).","o|2m|M7|1Lj|2p|2s|1V","Whether the user can toggle the endpoint between open and closed by clicking it.","o|2m|Ss|1Ll|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|1Lk|1Lm","o|3L|M7|1V|2p|1Lj|3M","o|3L|Ss|1V|2p|1Ll|3M","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|1Lo|1Lp|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","A point that marks the endpoint of an interval, rendered open or closed","o|F|2K|RR|RS|Op|1Ln|1Lq|3M|3M|2p|2K|1Lr|Az","sortVectorsBy","Whether to sort vectors by component or by magnitude.","a|na|ng","Sort vectors by their displacement components.","o|3s|na|1Lw","Sort vectors by the position of their tail point.","o|3s|ng|1Ly","a|1Lx|1Lz","o|Bi|1Lt|1Lu|na|1Lv|1M0|3y","sortByComponent","Index of the component to sort by (when sorting vectors).","o|33|1M2|1M3|oX|1q","sortByProp",\'Name of a property to sort by (e.g. "x" for sorting points by x-coordinate).\',"o|2h|1M5|1M6|1T","Component type to sort children as.","o|2h|2g|1M8|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1M1|1M4|1M7|1M9|gB","o|3L|1Lt|1T|2p|1Lu|3M","o|3L|1M2|1q|2p|1M3|3M","a|3N|3O|3P|1MB|1MC|3Z","Sorts a list according to a comparison function","o|F|2L|9U|9V|g0|1MA|1MD|3M|3M|3M|2L|1ME|Az","Component type to shuffle children as.","o|2h|2g|1MG|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1MH|gB","Randomly shuffles its children","o|F|2M|9U|9V|g0|1MI|125|3M|3M|3M|2M|1MJ|Az","Names of the variables to solve for.","o|2h|Gx|1ML|Gz","Number of points used when searching for solutions numerically.","o|33|Vo|1MN|12N|1p","minVar","Lower bound of the variable\'s search range.","o|33|1MP|1MQ||1p","maxVar","Upper bound of the variable\'s search range.","o|33|1MS|1MT||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1MM|1MO|1MR|1MU","o|3L|Vo|1p|2p|1MN|3M","The variables of the equations.","o|6v|Gx|H3|3M|1MX|36|I7","numSolutions","The number of numerical solutions found.","o|3Q|1MZ|1q|2p|1Ma","solutions","The numerical solutions of the equations.","o|6v|1Mc|1X|3M|1Md|36|75","The first variable being solved for.","o|3Q|H1|H3|2p|1Mf","a|3N|3O|3P|1MW|3T|3U|3V|3W|3Z|1MY|1Mb|1Me|1Mg","Numerically solves a system of equations","o|F|2N|3j|3k|3l|1MV|1Mh|3M|3M|2p|2N|1Mi|3h","Variable name displayed on the number line.","o|33|H1|1Mk|Pw|H3","Input format used for parsing entered subsets.","Parse entered subsets as plain-text notation.","o|3s|1T|1Mn","Parse entered subsets as LaTeX notation.","o|3s|2V|1Mp","a|1Mo|1Mq","o|Bi|3p|1Mm|1T|3r|1Mr|3y","Initial subset displayed in the input.","o|33|Zj|1Mt|AZ|1T","o|2h|e9|eA|2O","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ml|1Ms|1Mu|1Mv","o|3L|H1|H3|2p|1Mk|3M","o|3L|3p|1T|2p|1Mm|3M","o|3L|Zj|1T|2p|1Mt|3M","subsetValue","The current subset of the reals entered by the user.","o|3Q|1N0|2O|2p|1N1","The boundary points that delimit the subset.","o|6v|UQ|1X|3M|1N3|36|75","pointsClosed","Whether each boundary point of the subset is a closed (included) endpoint.","o|6v|1N5|1V|3M|1N6|36|Qq","intervals","The intervals (non-degenerate components) of the subset.","o|6v|1N8|1X|3M|1N9|36|75","isolatedPoints","The isolated (non-interval) points of the subset.","o|6v|1NB|1X|3M|1NC|36|75","a|3N|3O|3P|1Mx|1My|1Mz|3T|3U|3V|3W|3Z|1N2|1N4|1N7|1NA|1ND","An interactive number-line widget for entering a subset of real numbers (block-level; does not inherit from Input)","o|F|9J|54|AZ|9X|1Mw|1NE|3M|2p|2p|9J|1NF|AT","o|2m|4t|4u|3M|2s|1V","Name of the variable used when expressing the subset.","o|33|H1|1NI|Pw|H3","How the subset is displayed.","inequalities","a|1N8|1NL","Display the subset using interval notation (e.g., `(0, 1]`).","o|3s|1N8|1NN","Display the subset using inequalities (e.g., `0 < x ≤ 1`).","o|3s|1NL|1NP","a|1NO|1NQ","o|Bi|xU|1NK|1N8|1NM|1NR|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|1NH|51|55|58|5B|5E|5K|5N|5R|5X|63|1NJ|1NS","o|3L|xU|1T|2p|1NK|3M","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1NU|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1N4|1N7|1NA|1ND|7S|7V|7Y|7b","A subset of the real numbers, defined by intervals and points","o|F|2O|3j|3k|3l|1NT|1NV|3M|3M|2p|2O|1NW|3h","Type of value being split.","a|1T","Split text values.","o|3s|1T|1Na","a|1Nb","o|HC|2g|1NY|1NZ|1Nc|3y","splitBy","How to break the input string into pieces.","letter","word","comma","a|1Ng|1Nh|1Ni","Split into individual characters.","o|3s|1Ng|1Nk","Split into whitespace-separated words.","o|3s|1Nh|1Nm","Split on comma boundaries.","o|3s|1Ni|1No","a|1Nl|1Nn|1Np","o|Bi|1Ne|1Nf|1Ng|1Nj|1Nq|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Nd|1Nr|gB","Splits a string or list into pieces","o|F|2P|9U|9V|g0|1Ns|125|3M|3M|2p|2P|1Nt|Az","data","The data points to fit a line to.","o|2h|1Nv|1Nw|2W","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|1Nx","Number of dimensions of the line (always 2 for a best-fit line).","o|3Q|6r|1p|2p|1Nz","Whether the line can be dragged (always false for a best-fit line).","o|3Q|5L|1V|2p|1O1","The data points used to compute the best-fit line.","o|6v|1Nv|1X|3M|1O3|4X|IM","a|3N|3O|3P|Hd|QD|7s|QE|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|1O0|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up|1O2|1O4","The best-fit line for a set of points","o|F|2Q|Om|On|Op|1Ny|1O5|3M|2p|2p|2Q|1O6|Az","boundaryValues","Boundary values defining the region\'s left/right edges.","a|5Q|36","o|33|1O8|1O9|1OA|1a","The function whose graph bounds the region.","o|2h|1r|1OC|1r","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OB|1OD","o|3L|1O8|1a|2p|1O9|3M","A textual description of the region\'s style.","o|3Q|Hl|1T|2p|1OG",\'Style description including the word "region".\',"o|3Q|Ho|1T|2p|1OI","a|3N|3O|3P|Hd|QD|7s|QE|1OF|3T|3U|3V|3W|3Z|Hk|1OH|1OJ","A region bounded between a curve and the x-axis","o|F|9K|Om|On|Op|1OE|1OK|3M|2p|2p|9K|1OL|Az","a|I|J|1z|2S|w|x|y|1r|1s","112011101","Boundary values defining the region\'s edges.","o|33|1O8|1OP|1OA|1a","flipFunctions","Whether to swap the role of x and y for the input functions.","o|2m|1OR|1OS|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OQ|1OT","o|3L|1O8|1a|2p|1OP|3M","o|3L|1OR|1V|2p|1OS|3M","a|3N|3O|3P|Hd|QD|7s|QE|1OV|1OW|3T|3U|3V|3W|3Z|Hk|1OH|1OJ","A region bounded between two curves","o|F|9L|1ON|1OO|Op|1OU|1OX|3M|2p|2p|9L|1OY|Az","Whether the half-plane extends horizontally, bounded by the vertical line x = boundaryValue. If false, the half-plane extends vertically, bounded by the horizontal line y = boundaryValue.","o|2m|V3|1Oa|3M|2s|1V","boundaryValue","Position of the bounding line: x = boundaryValue when horizontal is true, y = boundaryValue when horizontal is false.","o|33|1Oc|1Od|5Q|1p","greaterThan","Whether the region is the side where the inequality is greater than the boundary.","o|2m|1Of|1Og|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Ob|1Oe|1Oh","o|3L|V3|1V|2p|1Oa|3M","o|3L|1Oc|1p|2p|1Od|3M","o|3L|1Of|1V|2p|1Og|3M","a|3N|3O|3P|Hd|QD|7s|QE|1Oj|1Ok|1Ol|3T|3U|3V|3W|3Z|Hk","A half-plane region bounded by a line","o|F|9M|Om|On|Op|1Oi|1Om|3M|2p|2p|9M|1On|Az","Initial code shown in the editor before the user types.","o|33|Zj|1Op|AZ|1T",\'Editor width (e.g. "100%" or "600px").\',"100","o|uD|1Os|2p","o|33|bx|1Or|1Ot|bz",\'Editor height (e.g. "500px").\',"n|6S","o|uD|1Ow|3M","o|33|k5|1Ov|1Ox|bz","viewerRatio","Fraction of the editor area allotted to the live viewer.","o|2h|1Oz|1P0|1p","showResults","Whether to render the results panel alongside the editor.","o|2m|1P2|1P3|2p|2s|1V","showFormatter","Whether to show a code formatter button.","o|2m|1P5|1P6|2p|2s|1V","resultsLocation","Position of the results panel relative to the editor.","a|5g|5h|5i","Place the results panel below the editor.","o|3s|5g|1PB","Place the results panel to the left of the editor.","o|3s|5h|1PD","Place the results panel to the right of the editor.","o|3s|5i|1PF","a|1PC|1PE|1PG","o|Bi|1P8|1P9|5g|1PA|1PH|3y","readOnly","Whether the editor is read-only.","o|2m|1PJ|1PK|2p|2s|1V","initialOpenTab","Which diagnostics/responses tab to open initially.","first","errors","warnings","info","accessibility","responses","help","a|42|1PO|1PP|1PQ|1PR|1PS|1PT|1PU","Panel starts closed.","o|3s|42|1PW","Open the first available tab.","o|3s|1PO|1PY","Open the errors tab.","o|3s|1PP|1Pa","Open the warnings tab.","o|3s|1PQ|1Pc","Open the info tab.","o|3s|1PR|1Pe","Open the accessibility tab.","o|3s|1PS|1Pg","Open the responses tab.","o|3s|1PT|1Pi","Open the help tab.","o|3s|1PU|1Pk","a|1PX|1PZ|1Pb|1Pd|1Pf|1Ph|1Pj|1Pl","o|Bi|1PM|1PN|1PO|1PV|1Pm|3y","renderedName","Name to assign to the dynamically-rendered DoenetML output.","o|2h|1Po|1Pp|1T","staticName","Name to assign to the static DoenetML source.","o|2h|1Pr|1Ps|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Oq|u5|1Ou|1Oy|1P1|1P4|1P7|1PI|1PL|1Pn|1Pq|1Pt","o|3L|Zj|1T|2p|1Op|3M","o|3L|bx|bz|2p|1Or|3M","o|3L|k5|bz|2p|1Ov|3M","o|3L|1P2|1V|2p|1P3|3M","o|3L|1P5|1V|2p|1P6|3M","o|3L|1P8|1T|2p|1P9|3M","o|3L|1PJ|1V|2p|1PK|3M","o|3L|1PM|1T|2p|1PN|3M","The code value of the input.","o|3Q|3a|1T|2p|1Q3","The code value reflecting the user\'s in-progress edits.","o|3Q|ef|1T|2p|1Q5","The current code as a plain text string.","o|3Q|1T|1T|2p|1Q7","a|3N|3O|3P|1Pv|1Pw|1Px|1Py|1Pz|1Q0|1Q1|1Q2|3T|3U|3V|3W|3Z|eV|eY|1Q4|1Q6|1Q8","An interactive DoenetML code editor","o|F|9N|9U|9V|9X|1Pu|1Q9|3M|3M|2p|9N|1QA|AT","Variable used when comparing factored expressions.","o|33|H1|1QC|Pw|H3","restrictDivision","Whether to disallow dividing through to match factored forms.","o|2m|1QE|1QF|2p|2s|1V","monomialFactorMustMatch","Whether monomial factors must match exactly (implies restrictDivision).","o|2m|1QH|1QI|2p|2s|1V","allowOnlySignDifferences","Whether to count factorizations as equivalent when they differ only by sign.","o|2m|1QK|1QL|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1QD|1QG|1QJ|1QM","Whether the input math expressions share the same factoring.","o|3Q|3a|1V|2p|1QO","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|1QP|CW","Boolean condition that tests for equivalent factoring","o|F|2R|3j|3k|3l|1QN|1QQ|3M|2p|2p|2R|1QR|3h","position","Position of the legend on the graph.","a|5c|5d|5e|5f","Place the legend in the upper-right corner.","o|3s|5c|1QW","Place the legend in the upper-left corner.","o|3s|5d|1QY","Place the legend in the lower-right corner.","o|3s|5e|1Qa","Place the legend in the lower-left corner.","o|3s|5f|1Qc","a|1QX|1QZ|1Qb|1Qd","o|Bi|1QT|1QU|5c|1QV|1Qe|3y","displayClosedSwatches","Whether to render closed/filled swatches in the legend.","o|2m|1Qg|1Qh|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Qf|1Qi","o|3L|1QT|1T|2p|1QU|3M","o|3L|1Qg|1V|2p|1Qh|3M","a|3N|3O|3P|Hd|QD|7s|QE|1Qk|1Ql|3T|3U|3V|3W|3Z|Hk","A legend describing the contents of a graph","o|F|9O|Om|On|Op|1Qj|1Qm|3M|2p|2p|9O|1Qn|Az","o|3Q|3a|2S|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|1Qp","A label for an input, answer, button, or graphical object","o|F|2S|2Z|2a|3l|7q|1Qq|3M|3M|2p|2S|1Qr|3h","pattern","Math expression pattern to match against.","o|2h|1Qt|1Qu|1X","allowImplicitIdentities","Whether to allow implicit identity transformations when matching.","o|2m|1Qw|1Qx|2p|2s|1V","allowPermutations","Whether to allow permutations of operands when matching.","o|2m|1Qz|1R0|3M|2s|1V","requireNumericMatches","Whether numeric placeholders must match numbers.","o|2m|1R2|1R3|2p|2s|1V","requireVariableMatches","Whether variable placeholders must match variables.","o|2m|1R5|1R6|2p|2s|1V","excludeMatches","Patterns whose matches are excluded.","o|33|1R8|1R9|54|1Y","matchExpressionWithBlanks","Whether to allow expressions with blanks to match.","o|2m|1RB|1RC|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1Qv|1Qy|1R1|1R4|1R7|1RA|1RD","o|3L|1Qw|1V|2p|1Qx|3M","o|3L|1Qz|1V|2p|1R0|3M","o|3L|1R2|1V|2p|1R3|3M","o|3L|1R5|1V|2p|1R6|3M","o|3L|1R8|1Y|2p|1R9|3M","o|3L|1RB|1V|2p|1RC|3M","Whether the input matches the pattern.","o|3Q|3a|1V|2p|1RL","numMatches","The number of matches found.","o|3Q|1RN|1p|2p|1RO","patternMatches","The list of matched sub-expressions.","o|6v|1RQ|1X|3M|1RR|36|75","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|1RF|1RG|1RH|1RI|1RJ|1RK|3T|3U|3V|3W|3Z|1RM|CW|1RP|1RS","Boolean condition that tests whether input matches a math pattern","o|F|2T|3j|3k|3l|1RE|1RT|3M|3M|2p|2T|1RU|3h","childContextHelp","a|3|4|5|6|7|8|9|A|B|C|D|E|1RW","a|93|1z|94","020","Value used for entries that aren\'t explicitly specified.","o|33|e0|1Ra|Ng|1X","Number of rows in the matrix.","o|2h|7A|1Rc|1q","Number of columns in the matrix.","o|2h|7D|1Re|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Rb|1Rd|1Rf","Whether matrix entries should be treated as unordered.","o|3Q|4n|1V|2p|1Rh","o|3Q|3a|2U|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1Ri|1Rj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A matrix of math values","a|93|94","matrixRow","matrixColumn","o|1Rm|1Rn|1Ro","o|1RX|2U|1RY|1RZ|3l|1Rg|1Rk|3M|2p|2p|2U|1Rl|3h|1Rp","a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j","numEigenvectors","The number of eigenvectors found in the decomposition.","o|3Q|1Rs|1q|2p|1Rt","eigenvalues","The eigenvalues of the matrix.","o|6v|1Rv|1p|3M|1Rw|36|IR","eigenvectors","The eigenvectors of the matrix, as a 2D array (one column per eigenvalue).","a|X0|6y","o|Qc|1Ry|1p|3M|1Rz|4X|1S0|Qf","a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1Ru|1Rx|1S1","Computes the eigenvalues and eigenvectors of a square matrix","o|F|9P|3j|3k|Ao|1Rr|1S2|3M|2p|2p|9P|1S3|Az","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19|w|x|y|1J|1K|1N|1R|1S|1d|1f|1h|1i|1k|1r|1s|2K|2Q|2W|2Y|O|P","1220111222222222111111111111111111111112210222022212221222212222211121222112111111111111111111222222222222222222201","o|2m|JZ|Ja|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|1S7|5X|63","o|3Q|3a|2V|2p|fs","The LaTeX content as a string.","o|3Q|2V|2V|2p|1SA","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1S9|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1SB","A snippet of LaTeX that can be rendered as math","o|F|2V|1S5|1S6|3l|1S8|1SC|3M|3M|2p|2V|1SD|3h","A block-level quotation","o|F|9Q|9U|9V|9X|3I|Aa|3M|3M|2p|9Q|1SF|AT","Extra information about an enclosing component, shown to all users in a popup or disclosure","o|F|2f|9U|9V|9X|3I|Aa|2p|3M|2p|2f|1SH|AT","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y","112022222222222222222222222222111122222121111111111111222222122222222122221111121222","Whether the snapping threshold is interpreted relative to graph scales.","o|2m|194|1SL|2p|2s|1V","Distance threshold within which group members snap together.","o|2h|E6|1SN|1p","angleThreshold","Angular distance within which group members snap together.","n|0.:7C4pdy2qXy","o|33|1SP|1SQ|1SR|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1SM|1SO|1SS","o|3L|194|1V|2p|1SL|3M","o|3L|1SP|1p|2p|1SQ|3M","Distance within which group members attract each other.","o|3Q|E6|1p|2p|1SW","a|3N|3O|3P|Hd|QD|7s|QE|1SU|1SV|3T|3U|3V|3W|3Z|Hk|T4|1SX","Constrains group members to attract to each other when nearby","o|F|9R|1SJ|1SK|Op|1ST|1SY|3M|2p|2p|9R|1SZ|Az","a|8J","_blockScoredComponent","a|1Sc|9W|2d","maxNumColumns","Maximum number of columns when arranging child problems.","o|33|1Se|1Sf|4X|1q","mode","Arrangement mode for the child problems.","circuit","a|9S|1Sj","Interleaved arrangement where each problem\'s answer feeds the next and one can start with any problem.","o|3s|9S|1Sl","A variant of the pretzel where one must start with the first problem.","o|3s|1Sj|1Sn","a|1Sm|1So","o|Bi|1Sh|1Si|9S|1Sk|1Sp|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|1Sg|1Sq","o|3L|1Se|1q|2p|1Sf|3M","o|3L|1Sh|1T|2p|1Si|3M","numProblems","The number of child problems.","o|3Q|1Su|1q|2p|1Sv","The current responses across all child problems.","o|6v|re|1T|3M|1Sx|36|Jt","The number of responses submitted.","o|3Q|rk|1p|2p|1Sz","The most recently submitted responses.","o|6v|rn|1T|3M|1T1|36|Jt","a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|1Ss|1St|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|1Sw|1Sy|1T0|1T2","A response-matching component where students enter a sequence to match statements and answers","o|F|9S|1Sb|Nf|1Sd|1Sr|1T3|3M|2p|2p|9S|1T4|AT","o|2m|L8|L9|3M|2s|1V","hideFutureSections","Whether to hide later cascade sections until previous ones are completed.","o|2m|1T7|1T8|2p|2s|1V","revealAll","Whether all cascade entries should be revealed regardless of progress.","o|2m|1TA|1TB|2p|2s|1V","boxAll","Whether to draw boxes around all cascade entries regardless of progress.","o|2m|1TD|1TE|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|1T6|LD|LG|LI|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|1T9|1TC|1TF","o|3L|1T7|1V|2p|1T8|3M","o|3Q|20|1V|2p|LH","numCompleted","The number of cascade sections currently completed.","o|3Q|1TJ|1q|2p|1TK","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Ly|1TH|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9|1TI|1TL","Sectional component that reveals its children step-by-step","o|F|9T|Ku|Kv|N8|1TG|1TM|3M|3M|2p|9T|1TN|AT","The short description text.","o|3Q|3a|dd|2p|1TP","a|3N|3O|3P|3T|3U|3V|3W|3Z|1TQ|3e","A short accessibility description (e.g. for a `<graph>`) read by screen readers","o|F|dd|2Z|2a|2e|3I|1TR|2p|3M|2p|dd|1TS|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|1z|21|24|29|2A|2K|2O|2U|2W|2X|2Y|L|M|N|Q|w|x|y|z|1K|1L|1M|1N|1R|1S|1T|1U|1a|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2Q|2V","1111111111111111111111111022012122212111122222222222222222222222222222222222222","Whether the order of points in this list should be treated as unordered (e.g. for matching).","o|2m|4n|1TW|2p|2s|1V","Maximum number of points to retain in the list.","o|33|g7|1TY|9k|1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|1TX|1TZ|gB|gn|go|gp|gq|gr","o|3L|g7|1p|2p|1TY|3M","The number of points in the list.","o|3Q|Ps|1p|2p|1Tc","o|3Q|gI|1p|2p|1Tc","a|3N|3O|1Tb|3Z|gy|1Td|1Te","A list of points","o|F|2W|1TU|1TV|g0|1Ta|1Tf|3M|3M|2p|2W|1Tg|Az","a|1t|1z|2X|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2Y","0221222211111111111111111111112222222221222202222122222222222212222212222121222","Whether the order of intervals in this list should be treated as unordered (e.g. for matching).","o|2m|4n|1Tk|2p|2s|1V","Maximum number of intervals to retain in the list.","o|33|g7|1Tm|9k|1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|1Tl|1Tn|gB|gn|go|gp|gq|gr","o|3L|g7|1p|2p|1Tm|3M","numIntervals","The number of intervals in the list.","o|3Q|1Tq|1p|2p|1Tr","o|3Q|gI|1p|2p|1Tr","a|3N|3O|1Tp|3Z|gy|1Ts|1Tt","A list of intervals","o|F|2X|1Ti|1Tj|g0|1To|1Tu|3M|3M|2p|2X|1Tv|Az","a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr","a|3N|3O|n8|3Z|gy|nD|nE","A list of vectors","o|F|2Y|mh|mi|g0|1Tx|1Ty|3M|3M|2p|2Y|1Tz|Az","a|3i|7e|84|88|AU|AW|AY|Ac|Ae|Am|B0|BD|BF|BL|BQ|BS|BX|Cb|Ck|Cm|Co|Cq|Cs|Cz|D1|DD|DT|DX|Dm|Dq|E5|EE|EJ|EN|ER|EV|EZ|Ed|Eh|Eq|Eu|Ey|F2|F6|FA|FE|FI|Fn|J9|JB|JU|K7|KE|KG|KI|KK|KM|KO|KQ|KS|KU|KW|Kd|Kf|Kh|Kj|Kl|Kn|Kp|Kr|MC|ME|MG|MK|MS|MW|Md|Mf|Mh|Mj|Ml|Mn|Mp|Mr|Mt|Mv|N7|ND|NF|NP|NR|NW|Ol|RI|TU|Us|Xe|Yf|Z8|ZQ|ZY|Zi|a4|aC|bu|cl|co|cq|cs|cu|cw|d1|dE|dc|eo|fK|fW|fY|fp|fw|gN|gP|gU|gf|gj|h7|h9|hJ|hW|hu|hy|i5|i9|if|j6|jC|jk|jp|kJ|lC|m1|mS|mW|mg|nH|oT|pH|s8|ss|t5|u0|uU|us|vp|wK|wm|wr|10d|10g|111|117|11J|11Q|11e|127|137|14Q|155|15d|15l|15v|16s|17B|17U|17k|17n|187|18X|18g|191|19B|19L|19P|19W|19Y|19g|19o|19v|1AG|1Ao|1B1|1BI|1C3|1CO|1D6|1DI|1Dm|1E2|1Ed|1FG|1Hg|1IY|1Ih|1Io|1J4|1JD|1JF|1JH|1Jl|1KT|1Km|1Kv|1LL|1LP|1LR|1LV|1Ld|1Li|1Ls|1MF|1MK|1Mj|1NG|1NX|1Nu|1O7|1OM|1OZ|1Oo|1QB|1QS|1Qo|1Qs|1RV|1Rq|1S4|1SE|1SG|1SI|1Sa|1T5|1TO|1TT|1Th|1Tw|1U0","a|1Rn|1Ro","displayName","a|3|7|8|C|D|4|5|6|A|1U3|156","row_matrix","A list of math values defining the row of a matrix","in a matrix","o|1U4|1Rn|gw|h5|1U5|1U6|3j|3k|g0|3M|93|1U7","column_matrix","A list of math values defining the column of a matrix","o|1U4|1Ro|gw|h5|1U9|1UA|3j|3k|g0|3M|94|1U7","o|1U2|1U8|1UB","o|2|1U1|1UC"],"1UD"]),elements=doenetSchema$1.elements,BLOCK_OVERRIDES=new Set(["title","choice"]),OTHER_BLOCK_NAMES=new Set(["li","row","cell","cellBlock","column","case","else","award","option","document","module","moduleAttributes","setup","feedbackDefinition","styleDefinition","variantControl","considerAsResponses","conditionalContent","legend","point","line","lineSegment","ray","vector","curve","polygon","polyline","regularPolygon","circle","parabola","rectangle","angle","triangle","endpoint","controlVectors","pegboard","stickyGroup","bestFitLine","cobwebPolyline","equilibriumCurve","equilibriumLine","equilibriumPoint","regionBetweenCurveXAxis","regionBetweenCurves","regionHalfPlane"]),BLOCK_ELEMENTS_LOWER=new Set([...elements.filter(D=>D.layoutCategory==="block"||D.layoutCategory==="other"&&OTHER_BLOCK_NAMES.has(D.name)).map(D=>D.name),...BLOCK_OVERRIDES].map(D=>D.toLowerCase())),ALWAYS_BREAK_PARENTS_LOWER=new Set(["document","module","section","subsection","subsubsection","problem","exercise","exercises","problems","ol","ul","dl","graph","table","tabular","figure","spreadsheet","codeEditor","paragraphs","setup","moduleAttributes"].map(D=>D.toLowerCase()));function isBlock(D){return BLOCK_ELEMENTS_LOWER.has(D.toLowerCase())}function isAlwaysBreakParent(D){return ALWAYS_BREAK_PARENTS_LOWER.has(D.toLowerCase())}const DEFINITIONAL_CONTAINERS_LOWER=new Set(["setup","moduleAttributes"].map(D=>D.toLowerCase()));function isDefinitionalContainer(D){return DEFINITIONAL_CONTAINERS_LOWER.has(D.toLowerCase())}function isElement$1(D){return D&&D.type==="element"}function isText(D){return D&&D.type==="text"}function hasBlankLineBefore(D){return!!D?.data?.prettyBlankLineBefore}function mark(D){(D.data??={}).prettyBlankLineBefore=!0}const TRAILING_BLANK_LINE=/\\n[^\\S\\n]*\\n[^\\S\\n]*$/,LEADING_BLANK_LINE=/^[^\\S\\n]*\\n[^\\S\\n]*\\n/,markBlankLinesPlugin=function(){return D=>{visit$1(D,E=>{if(!isElement$1(E)&&E.type!=="root")return;const F=E.children;if(F)for(let J=1;J<F.length;J++){const $e=F[J-1],_t=F[J];if(isText($e)&&$e.value.trim().length===0&&/\\n[^\\S\\n]*\\n/.test($e.value)){mark(_t);continue}if(isText($e)&&$e.value.trim().length>0&&isElement$1(_t)&&isBlock(_t.name)&&TRAILING_BLANK_LINE.test($e.value)){mark(_t),$e.value=$e.value.replace(TRAILING_BLANK_LINE,"");continue}if(isText(_t)&&_t.value.trim().length>0&&isElement$1($e)&&isBlock($e.name)&&LEADING_BLANK_LINE.test(_t.value)){mark(_t),_t.value=_t.value.replace(LEADING_BLANK_LINE,"");continue}}})}},mergeAdjacentTextPlugin=function(){return D=>{replaceNode(D,E=>{if(!("children"in E))return;const F=E.children;let J=null,$e=!1;for(const lr of F){if(J&&J.type==="text"&&lr.type==="text"){$e=!0;break}J=lr}if(!$e)return;J=null;const _t=[];for(const lr of F){if(!J){_t.push(lr),J=lr;continue}if(J.type==="text"&&lr.type==="text"){J.value+=lr.value;continue}_t.push(lr),J=lr}return E.children=_t,E})}},PRE_ELEMENTS=new Set(["cline","input","output","prompt","pre"]),INDENTABLE_PRE_ELEMENTS=new Set(["latex-image","latex-image-preamble","macros","asymptote"]),mergeWhitespacePlugin=function(){return D=>{visit$1(D,(E,F)=>{if(isElement$1(E)&&(PRE_ELEMENTS.has(E.name)||INDENTABLE_PRE_ELEMENTS.has(E.name)))return SKIP$1;isText(E)&&(E.value=normalizeWhitespace(E.value))})}};function normalizeWhitespace(D){D=D.replace(/[^\\S\\r\\n]*\\n[^\\S\\r\\n]*/g,`\n`);let E=D.split(/\\n\\n+/);return E=E.map(F=>F.replace(/([^\\S\\r\\n]|\\n(?!\\n))+/g," ")),D=E.join(`\n\n`),D}const removeEmptyTextNodesPlugin=function(){return D=>{replaceNode(D,E=>{if(isText(E)&&!E.value)return null})}},removeInternodeWhitespacePlugin=function(){return D=>{replaceNode(D,(E,F)=>{const J=F.parents[0];if(!isText(E)||E.value.trim().length>0||PRE_ELEMENTS.has(J?.name))return;const $e=F.containingArray,_t=F.index;if(!$e||_t==null)return;const lr=$e[_t-1],mr=$e[_t+1];if(isElement$1(lr)&&isBlock(lr.name)||isElement$1(mr)&&isBlock(mr.name))return null})}},trimWhitespacePlugin=function(){return D=>{visit$1(D,E=>{if(E.type==="element"){if(!isBlock(E.name)||PRE_ELEMENTS.has(E.name)||INDENTABLE_PRE_ELEMENTS.has(E.name))return}else if(E.type!=="root")return;const F=E.children[0],J=E.children[E.children.length-1];F?.type==="text"&&(F.value=F.value.trimStart()),J?.type==="text"&&(J.value=J.value.trimEnd())})}},normalizeDoenetMlPlugin=function(){const D=unified().use(expandCdataPlugin).use(mergeAdjacentTextPlugin).use(mergeWhitespacePlugin).use(markBlankLinesPlugin).use(removeInternodeWhitespacePlugin).use(trimWhitespacePlugin).use(removeEmptyTextNodesPlugin);return(E,F)=>D.runSync(E,F)};function normalize(D){return unified().use(normalizeDoenetMlPlugin).runSync(D)}var __defProp$1=Object.defineProperty,__export=(D,E)=>{for(var F in E)__defProp$1(D,F,{get:E[F],enumerable:!0})},public_exports={};__export(public_exports,{builders:()=>builders,printer:()=>printer,utils:()=>utils$1});var OPTIONAL_OBJECT=1,createMethodShim=(D,E)=>(F,J,...$e)=>F|OPTIONAL_OBJECT&&J==null?void 0:(E.call(J)??J[D]).apply(J,$e);function stringOrArrayAt(D){return this[D<0?this.length+D:D]}var at=createMethodShim("at",function(){if(Array.isArray(this)||typeof this=="string")return stringOrArrayAt}),method_at_default=at,noop$1=()=>{},noop_default=noop$1,DOC_TYPE_STRING="string",DOC_TYPE_ARRAY="array",DOC_TYPE_CURSOR="cursor",DOC_TYPE_INDENT="indent",DOC_TYPE_ALIGN="align",DOC_TYPE_TRIM="trim",DOC_TYPE_GROUP="group",DOC_TYPE_FILL="fill",DOC_TYPE_IF_BREAK="if-break",DOC_TYPE_INDENT_IF_BREAK="indent-if-break",DOC_TYPE_LINE_SUFFIX="line-suffix",DOC_TYPE_LINE_SUFFIX_BOUNDARY="line-suffix-boundary",DOC_TYPE_LINE="line",DOC_TYPE_LABEL="label",DOC_TYPE_BREAK_PARENT="break-parent",VALID_OBJECT_DOC_TYPES=new Set([DOC_TYPE_CURSOR,DOC_TYPE_INDENT,DOC_TYPE_ALIGN,DOC_TYPE_TRIM,DOC_TYPE_GROUP,DOC_TYPE_FILL,DOC_TYPE_IF_BREAK,DOC_TYPE_INDENT_IF_BREAK,DOC_TYPE_LINE_SUFFIX,DOC_TYPE_LINE_SUFFIX_BOUNDARY,DOC_TYPE_LINE,DOC_TYPE_LABEL,DOC_TYPE_BREAK_PARENT]);function trimNewlinesEnd(D){let E=D.length;for(;E>0&&(D[E-1]==="\\r"||D[E-1]===`\n`);)E--;return E<D.length?D.slice(0,E):D}function getOrInsertComputed(D,E,F){if(!D.has(E)){const J=F(E);D.set(E,J)}return D.get(E)}function getDocType(D){if(typeof D=="string")return DOC_TYPE_STRING;if(Array.isArray(D))return DOC_TYPE_ARRAY;if(!D)return;const{type:E}=D;if(VALID_OBJECT_DOC_TYPES.has(E))return E}var get_doc_type_default=getDocType,disjunctionListFormat=D=>new Intl.ListFormat("en-US",{type:"disjunction"}).format(D);function getDocErrorMessage(D){const E=D===null?"null":typeof D;if(E!=="string"&&E!=="object")return`Unexpected doc \'${E}\', \nExpected it to be \'string\' or \'object\'.`;if(get_doc_type_default(D))throw new Error("doc is valid.");const F=Object.prototype.toString.call(D);if(F!=="[object Object]")return`Unexpected doc \'${F}\'.`;const J=disjunctionListFormat([...VALID_OBJECT_DOC_TYPES].map($e=>`\'${$e}\'`));return`Unexpected doc.type \'${D.type}\'.\nExpected it to be ${J}.`}var InvalidDocError=class extends Error{name="InvalidDocError";constructor(D){super(getDocErrorMessage(D)),this.doc=D}},invalid_doc_error_default=InvalidDocError,traverseDocOnExitStackMarker={};function traverseDoc(D,E,F,J){const $e=[D];for(;$e.length>0;){const _t=$e.pop();if(_t===traverseDocOnExitStackMarker){F($e.pop());continue}F&&$e.push(_t,traverseDocOnExitStackMarker);const lr=get_doc_type_default(_t);if(!lr)throw new invalid_doc_error_default(_t);if(E?.(_t)!==!1)switch(lr){case DOC_TYPE_ARRAY:case DOC_TYPE_FILL:{const mr=lr===DOC_TYPE_ARRAY?_t:_t.parts;for(let Or=mr.length,Pr=Or-1;Pr>=0;--Pr)$e.push(mr[Pr]);break}case DOC_TYPE_IF_BREAK:$e.push(_t.flatContents,_t.breakContents);break;case DOC_TYPE_GROUP:if(J&&_t.expandedStates)for(let mr=_t.expandedStates.length,Or=mr-1;Or>=0;--Or)$e.push(_t.expandedStates[Or]);else $e.push(_t.contents);break;case DOC_TYPE_ALIGN:case DOC_TYPE_INDENT:case DOC_TYPE_INDENT_IF_BREAK:case DOC_TYPE_LABEL:case DOC_TYPE_LINE_SUFFIX:$e.push(_t.contents);break;case DOC_TYPE_STRING:case DOC_TYPE_CURSOR:case DOC_TYPE_TRIM:case DOC_TYPE_LINE_SUFFIX_BOUNDARY:case DOC_TYPE_LINE:case DOC_TYPE_BREAK_PARENT:break;default:throw new invalid_doc_error_default(_t)}}}var traverse_doc_default=traverseDoc;function mapDoc(D,E){if(typeof D=="string")return E(D);const F=new Map;return J(D);function J(_t){return getOrInsertComputed(F,_t,$e)}function $e(_t){switch(get_doc_type_default(_t)){case DOC_TYPE_ARRAY:return E(_t.map(J));case DOC_TYPE_FILL:return E({..._t,parts:_t.parts.map(J)});case DOC_TYPE_IF_BREAK:return E({..._t,breakContents:J(_t.breakContents),flatContents:J(_t.flatContents)});case DOC_TYPE_GROUP:{let{expandedStates:lr,contents:mr}=_t;return lr?(lr=lr.map(J),mr=lr[0]):mr=J(mr),E({..._t,contents:mr,expandedStates:lr})}case DOC_TYPE_ALIGN:case DOC_TYPE_INDENT:case DOC_TYPE_INDENT_IF_BREAK:case DOC_TYPE_LABEL:case DOC_TYPE_LINE_SUFFIX:return E({..._t,contents:J(_t.contents)});case DOC_TYPE_STRING:case DOC_TYPE_CURSOR:case DOC_TYPE_TRIM:case DOC_TYPE_LINE_SUFFIX_BOUNDARY:case DOC_TYPE_LINE:case DOC_TYPE_BREAK_PARENT:return E(_t);default:throw new invalid_doc_error_default(_t)}}}function findInDoc(D,E,F){let J=F,$e=!1;function _t(lr){if($e)return!1;const mr=E(lr);mr!==void 0&&($e=!0,J=mr)}return traverse_doc_default(D,_t),J}function willBreakFn(D){if(D.type===DOC_TYPE_GROUP&&D.break||D.type===DOC_TYPE_LINE&&D.hard||D.type===DOC_TYPE_BREAK_PARENT)return!0}function willBreak(D){return findInDoc(D,willBreakFn,!1)}function breakParentGroup(D){if(D.length>0){const E=method_at_default(0,D,-1);!E.expandedStates&&!E.break&&(E.break="propagated")}return null}function propagateBreaks(D){const E=new Set,F=[];function J(_t){if(_t.type===DOC_TYPE_BREAK_PARENT&&breakParentGroup(F),_t.type===DOC_TYPE_GROUP){if(F.push(_t),E.has(_t))return!1;E.add(_t)}}function $e(_t){_t.type===DOC_TYPE_GROUP&&F.pop().break&&breakParentGroup(F)}traverse_doc_default(D,J,$e,!0)}function removeLinesFn(D){return D.type===DOC_TYPE_LINE&&!D.hard?D.soft?"":" ":D.type===DOC_TYPE_IF_BREAK?D.flatContents:D}function removeLines(D){return mapDoc(D,removeLinesFn)}function stripTrailingHardlineFromParts(D){for(D=[...D];D.length>=2&&method_at_default(0,D,-2).type===DOC_TYPE_LINE&&method_at_default(0,D,-1).type===DOC_TYPE_BREAK_PARENT;)D.length-=2;if(D.length>0){const E=stripTrailingHardlineFromDoc(method_at_default(0,D,-1));D[D.length-1]=E}return D}function stripTrailingHardlineFromDoc(D){switch(get_doc_type_default(D)){case DOC_TYPE_INDENT:case DOC_TYPE_INDENT_IF_BREAK:case DOC_TYPE_GROUP:case DOC_TYPE_LINE_SUFFIX:case DOC_TYPE_LABEL:{const E=stripTrailingHardlineFromDoc(D.contents);return{...D,contents:E}}case DOC_TYPE_IF_BREAK:return{...D,breakContents:stripTrailingHardlineFromDoc(D.breakContents),flatContents:stripTrailingHardlineFromDoc(D.flatContents)};case DOC_TYPE_FILL:return{...D,parts:stripTrailingHardlineFromParts(D.parts)};case DOC_TYPE_ARRAY:return stripTrailingHardlineFromParts(D);case DOC_TYPE_STRING:return trimNewlinesEnd(D);case DOC_TYPE_ALIGN:case DOC_TYPE_CURSOR:case DOC_TYPE_TRIM:case DOC_TYPE_LINE_SUFFIX_BOUNDARY:case DOC_TYPE_LINE:case DOC_TYPE_BREAK_PARENT:break;default:throw new invalid_doc_error_default(D)}return D}function stripTrailingHardline(D){return stripTrailingHardlineFromDoc(cleanDoc(D))}function cleanDocFn(D){switch(get_doc_type_default(D)){case DOC_TYPE_FILL:{const{parts:E}=D;if(E.every(F=>F===""))return"";if(E.length===1)return E[0];break}case DOC_TYPE_GROUP:if(!D.contents&&!D.id&&!D.break&&!D.expandedStates)return"";if(D.contents.type===DOC_TYPE_GROUP&&D.contents.id===D.id&&D.contents.break===D.break&&D.contents.expandedStates===D.expandedStates)return D.contents;break;case DOC_TYPE_ALIGN:case DOC_TYPE_INDENT:case DOC_TYPE_INDENT_IF_BREAK:case DOC_TYPE_LINE_SUFFIX:if(!D.contents)return"";break;case DOC_TYPE_IF_BREAK:if(!D.flatContents&&!D.breakContents)return"";break;case DOC_TYPE_ARRAY:{const E=[];for(const F of D){if(!F)continue;const[J,...$e]=Array.isArray(F)?F:[F];typeof J=="string"&&typeof method_at_default(0,E,-1)=="string"?E[E.length-1]+=J:E.push(J),E.push(...$e)}return E.length===0?"":E.length===1?E[0]:E}case DOC_TYPE_STRING:case DOC_TYPE_CURSOR:case DOC_TYPE_TRIM:case DOC_TYPE_LINE_SUFFIX_BOUNDARY:case DOC_TYPE_LINE:case DOC_TYPE_LABEL:case DOC_TYPE_BREAK_PARENT:break;default:throw new invalid_doc_error_default(D)}return D}function cleanDoc(D){return mapDoc(D,E=>cleanDocFn(E))}function replaceEndOfLine(D,E=literalline){return mapDoc(D,F=>typeof F=="string"?join$1$1(E,F.split(`\n`)):F)}function canBreakFn(D){if(D.type===DOC_TYPE_LINE)return!0}function canBreak(D){return findInDoc(D,canBreakFn,!1)}var assertDocArray=noop_default;function indent$1(D){return{type:DOC_TYPE_INDENT,contents:D}}function align(D,E){return{type:DOC_TYPE_ALIGN,contents:E,n:D}}function dedentToRoot(D){return align(Number.NEGATIVE_INFINITY,D)}function markAsRoot(D){return align({type:"root"},D)}function dedent(D){return align(-1,D)}function addAlignmentToDoc(D,E,F){let J=D;if(E>0){for(let $e=0;$e<Math.floor(E/F);++$e)J=indent$1(J);J=align(E%F,J),J=align(Number.NEGATIVE_INFINITY,J)}return J}var breakParent$1={type:DOC_TYPE_BREAK_PARENT},cursor={type:DOC_TYPE_CURSOR};function fill$1(D){return{type:DOC_TYPE_FILL,parts:D}}function group$1(D,E={}){return assertDocArray(E.expandedStates),{type:DOC_TYPE_GROUP,id:E.id,contents:D,break:!!E.shouldBreak,expandedStates:E.expandedStates}}function conditionalGroup(D,E){return group$1(D[0],{...E,expandedStates:D})}function ifBreak(D,E="",F={}){return{type:DOC_TYPE_IF_BREAK,breakContents:D,flatContents:E,groupId:F.groupId}}function indentIfBreak(D,E){return{type:DOC_TYPE_INDENT_IF_BREAK,contents:D,groupId:E.groupId,negate:E.negate}}function join$1$1(D,E){const F=[];for(let J=0;J<E.length;J++)J!==0&&F.push(D),F.push(E[J]);return F}function label(D,E){return D?{type:DOC_TYPE_LABEL,label:D,contents:E}:E}var line$1={type:DOC_TYPE_LINE},softline$1={type:DOC_TYPE_LINE,soft:!0},hardlineWithoutBreakParent={type:DOC_TYPE_LINE,hard:!0},hardline$1=[hardlineWithoutBreakParent,breakParent$1],literallineWithoutBreakParent={type:DOC_TYPE_LINE,hard:!0,literal:!0},literalline=[literallineWithoutBreakParent,breakParent$1];function lineSuffix(D){return{type:DOC_TYPE_LINE_SUFFIX,contents:D}}var lineSuffixBoundary={type:DOC_TYPE_LINE_SUFFIX_BOUNDARY},trim={type:DOC_TYPE_TRIM},stringReplaceAll=String.prototype.replaceAll??function(D,E){return D.global?this.replace(D,E):this.split(D).join(E)},replaceAll=createMethodShim("replaceAll",function(){if(typeof this=="string")return stringReplaceAll}),method_replace_all_default=replaceAll,OPTION_CR="cr",OPTION_CRLF="crlf",CHARACTER_CR="\\r",CHARACTER_CRLF=`\\r\n`,CHARACTER_LF=`\n`,DEFAULT_EOL=CHARACTER_LF;function convertEndOfLineOptionToCharacter(D){return D===OPTION_CR?CHARACTER_CR:D===OPTION_CRLF?CHARACTER_CRLF:DEFAULT_EOL}var emoji_regex_default=()=>/[#*0-9]\\uFE0F?\\u20E3|[\\xA9\\xAE\\u203C\\u2049\\u2122\\u2139\\u2194-\\u2199\\u21A9\\u21AA\\u231A\\u231B\\u2328\\u23CF\\u23ED-\\u23EF\\u23F1\\u23F2\\u23F8-\\u23FA\\u24C2\\u25AA\\u25AB\\u25B6\\u25C0\\u25FB\\u25FC\\u25FE\\u2600-\\u2604\\u260E\\u2611\\u2614\\u2615\\u2618\\u2620\\u2622\\u2623\\u2626\\u262A\\u262E\\u262F\\u2638-\\u263A\\u2640\\u2642\\u2648-\\u2653\\u265F\\u2660\\u2663\\u2665\\u2666\\u2668\\u267B\\u267E\\u267F\\u2692\\u2694-\\u2697\\u2699\\u269B\\u269C\\u26A0\\u26A7\\u26AA\\u26B0\\u26B1\\u26BD\\u26BE\\u26C4\\u26C8\\u26CF\\u26D1\\u26E9\\u26F0-\\u26F5\\u26F7\\u26F8\\u26FA\\u2702\\u2708\\u2709\\u270F\\u2712\\u2714\\u2716\\u271D\\u2721\\u2733\\u2734\\u2744\\u2747\\u2757\\u2763\\u27A1\\u2934\\u2935\\u2B05-\\u2B07\\u2B1B\\u2B1C\\u2B55\\u3030\\u303D\\u3297\\u3299]\\uFE0F?|[\\u261D\\u270C\\u270D](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?|[\\u270A\\u270B](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\u23E9-\\u23EC\\u23F0\\u23F3\\u25FD\\u2693\\u26A1\\u26AB\\u26C5\\u26CE\\u26D4\\u26EA\\u26FD\\u2705\\u2728\\u274C\\u274E\\u2753-\\u2755\\u2795-\\u2797\\u27B0\\u27BF\\u2B50]|\\u26D3\\uFE0F?(?:\\u200D\\uD83D\\uDCA5)?|\\u26F9(?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|\\u2764\\uFE0F?(?:\\u200D(?:\\uD83D\\uDD25|\\uD83E\\uDE79))?|\\uD83C(?:[\\uDC04\\uDD70\\uDD71\\uDD7E\\uDD7F\\uDE02\\uDE37\\uDF21\\uDF24-\\uDF2C\\uDF36\\uDF7D\\uDF96\\uDF97\\uDF99-\\uDF9B\\uDF9E\\uDF9F\\uDFCD\\uDFCE\\uDFD4-\\uDFDF\\uDFF5\\uDFF7]\\uFE0F?|[\\uDF85\\uDFC2\\uDFC7](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDFC4\\uDFCA](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDFCB\\uDFCC](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDCCF\\uDD8E\\uDD91-\\uDD9A\\uDE01\\uDE1A\\uDE2F\\uDE32-\\uDE36\\uDE38-\\uDE3A\\uDE50\\uDE51\\uDF00-\\uDF20\\uDF2D-\\uDF35\\uDF37-\\uDF43\\uDF45-\\uDF4A\\uDF4C-\\uDF7C\\uDF7E-\\uDF84\\uDF86-\\uDF93\\uDFA0-\\uDFC1\\uDFC5\\uDFC6\\uDFC8\\uDFC9\\uDFCF-\\uDFD3\\uDFE0-\\uDFF0\\uDFF8-\\uDFFF]|\\uDDE6\\uD83C[\\uDDE8-\\uDDEC\\uDDEE\\uDDF1\\uDDF2\\uDDF4\\uDDF6-\\uDDFA\\uDDFC\\uDDFD\\uDDFF]|\\uDDE7\\uD83C[\\uDDE6\\uDDE7\\uDDE9-\\uDDEF\\uDDF1-\\uDDF4\\uDDF6-\\uDDF9\\uDDFB\\uDDFC\\uDDFE\\uDDFF]|\\uDDE8\\uD83C[\\uDDE6\\uDDE8\\uDDE9\\uDDEB-\\uDDEE\\uDDF0-\\uDDF7\\uDDFA-\\uDDFF]|\\uDDE9\\uD83C[\\uDDEA\\uDDEC\\uDDEF\\uDDF0\\uDDF2\\uDDF4\\uDDFF]|\\uDDEA\\uD83C[\\uDDE6\\uDDE8\\uDDEA\\uDDEC\\uDDED\\uDDF7-\\uDDFA]|\\uDDEB\\uD83C[\\uDDEE-\\uDDF0\\uDDF2\\uDDF4\\uDDF7]|\\uDDEC\\uD83C[\\uDDE6\\uDDE7\\uDDE9-\\uDDEE\\uDDF1-\\uDDF3\\uDDF5-\\uDDFA\\uDDFC\\uDDFE]|\\uDDED\\uD83C[\\uDDF0\\uDDF2\\uDDF3\\uDDF7\\uDDF9\\uDDFA]|\\uDDEE\\uD83C[\\uDDE8-\\uDDEA\\uDDF1-\\uDDF4\\uDDF6-\\uDDF9]|\\uDDEF\\uD83C[\\uDDEA\\uDDF2\\uDDF4\\uDDF5]|\\uDDF0\\uD83C[\\uDDEA\\uDDEC-\\uDDEE\\uDDF2\\uDDF3\\uDDF5\\uDDF7\\uDDFC\\uDDFE\\uDDFF]|\\uDDF1\\uD83C[\\uDDE6-\\uDDE8\\uDDEE\\uDDF0\\uDDF7-\\uDDFB\\uDDFE]|\\uDDF2\\uD83C[\\uDDE6\\uDDE8-\\uDDED\\uDDF0-\\uDDFF]|\\uDDF3\\uD83C[\\uDDE6\\uDDE8\\uDDEA-\\uDDEC\\uDDEE\\uDDF1\\uDDF4\\uDDF5\\uDDF7\\uDDFA\\uDDFF]|\\uDDF4\\uD83C\\uDDF2|\\uDDF5\\uD83C[\\uDDE6\\uDDEA-\\uDDED\\uDDF0-\\uDDF3\\uDDF7-\\uDDF9\\uDDFC\\uDDFE]|\\uDDF6\\uD83C\\uDDE6|\\uDDF7\\uD83C[\\uDDEA\\uDDF4\\uDDF8\\uDDFA\\uDDFC]|\\uDDF8\\uD83C[\\uDDE6-\\uDDEA\\uDDEC-\\uDDF4\\uDDF7-\\uDDF9\\uDDFB\\uDDFD-\\uDDFF]|\\uDDF9\\uD83C[\\uDDE6\\uDDE8\\uDDE9\\uDDEB-\\uDDED\\uDDEF-\\uDDF4\\uDDF7\\uDDF9\\uDDFB\\uDDFC\\uDDFF]|\\uDDFA\\uD83C[\\uDDE6\\uDDEC\\uDDF2\\uDDF3\\uDDF8\\uDDFE\\uDDFF]|\\uDDFB\\uD83C[\\uDDE6\\uDDE8\\uDDEA\\uDDEC\\uDDEE\\uDDF3\\uDDFA]|\\uDDFC\\uD83C[\\uDDEB\\uDDF8]|\\uDDFD\\uD83C\\uDDF0|\\uDDFE\\uD83C[\\uDDEA\\uDDF9]|\\uDDFF\\uD83C[\\uDDE6\\uDDF2\\uDDFC]|\\uDF44(?:\\u200D\\uD83D\\uDFEB)?|\\uDF4B(?:\\u200D\\uD83D\\uDFE9)?|\\uDFC3(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?|\\uDFF3\\uFE0F?(?:\\u200D(?:\\u26A7\\uFE0F?|\\uD83C\\uDF08))?|\\uDFF4(?:\\u200D\\u2620\\uFE0F?|\\uDB40\\uDC67\\uDB40\\uDC62\\uDB40(?:\\uDC65\\uDB40\\uDC6E\\uDB40\\uDC67|\\uDC73\\uDB40\\uDC63\\uDB40\\uDC74|\\uDC77\\uDB40\\uDC6C\\uDB40\\uDC73)\\uDB40\\uDC7F)?)|\\uD83D(?:[\\uDC3F\\uDCFD\\uDD49\\uDD4A\\uDD6F\\uDD70\\uDD73\\uDD76-\\uDD79\\uDD87\\uDD8A-\\uDD8D\\uDDA5\\uDDA8\\uDDB1\\uDDB2\\uDDBC\\uDDC2-\\uDDC4\\uDDD1-\\uDDD3\\uDDDC-\\uDDDE\\uDDE1\\uDDE3\\uDDE8\\uDDEF\\uDDF3\\uDDFA\\uDECB\\uDECD-\\uDECF\\uDEE0-\\uDEE5\\uDEE9\\uDEF0\\uDEF3]\\uFE0F?|[\\uDC42\\uDC43\\uDC46-\\uDC50\\uDC66\\uDC67\\uDC6B-\\uDC6D\\uDC72\\uDC74-\\uDC76\\uDC78\\uDC7C\\uDC83\\uDC85\\uDC8F\\uDC91\\uDCAA\\uDD7A\\uDD95\\uDD96\\uDE4C\\uDE4F\\uDEC0\\uDECC](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDC6E-\\uDC71\\uDC73\\uDC77\\uDC81\\uDC82\\uDC86\\uDC87\\uDE45-\\uDE47\\uDE4B\\uDE4D\\uDE4E\\uDEA3\\uDEB4\\uDEB5](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDD74\\uDD90](?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?|[\\uDC00-\\uDC07\\uDC09-\\uDC14\\uDC16-\\uDC25\\uDC27-\\uDC3A\\uDC3C-\\uDC3E\\uDC40\\uDC44\\uDC45\\uDC51-\\uDC65\\uDC6A\\uDC79-\\uDC7B\\uDC7D-\\uDC80\\uDC84\\uDC88-\\uDC8E\\uDC90\\uDC92-\\uDCA9\\uDCAB-\\uDCFC\\uDCFF-\\uDD3D\\uDD4B-\\uDD4E\\uDD50-\\uDD67\\uDDA4\\uDDFB-\\uDE2D\\uDE2F-\\uDE34\\uDE37-\\uDE41\\uDE43\\uDE44\\uDE48-\\uDE4A\\uDE80-\\uDEA2\\uDEA4-\\uDEB3\\uDEB7-\\uDEBF\\uDEC1-\\uDEC5\\uDED0-\\uDED2\\uDED5-\\uDED8\\uDEDC-\\uDEDF\\uDEEB\\uDEEC\\uDEF4-\\uDEFC\\uDFE0-\\uDFEB\\uDFF0]|\\uDC08(?:\\u200D\\u2B1B)?|\\uDC15(?:\\u200D\\uD83E\\uDDBA)?|\\uDC26(?:\\u200D(?:\\u2B1B|\\uD83D\\uDD25))?|\\uDC3B(?:\\u200D\\u2744\\uFE0F?)?|\\uDC41\\uFE0F?(?:\\u200D\\uD83D\\uDDE8\\uFE0F?)?|\\uDC68(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDC68\\uDC69]\\u200D\\uD83D(?:\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?)|[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?)|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFC-\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?\\uDC68\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDD1D\\uDEEF]\\u200D\\uD83D\\uDC68\\uD83C[\\uDFFB-\\uDFFE]|[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3])))?))?|\\uDC69(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:\\uDC8B\\u200D\\uD83D)?[\\uDC68\\uDC69]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?|\\uDC69\\u200D\\uD83D(?:\\uDC66(?:\\u200D\\uD83D\\uDC66)?|\\uDC67(?:\\u200D\\uD83D[\\uDC66\\uDC67])?))|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFC-\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFC-\\uDFFF])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D\\uD83D(?:[\\uDC68\\uDC69]|\\uDC8B\\u200D\\uD83D[\\uDC68\\uDC69])\\uD83C[\\uDFFB-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3]|\\uDD1D\\u200D\\uD83D[\\uDC68\\uDC69]\\uD83C[\\uDFFB-\\uDFFE]|\\uDEEF\\u200D\\uD83D\\uDC69\\uD83C[\\uDFFB-\\uDFFE])))?))?|\\uDD75(?:\\uD83C[\\uDFFB-\\uDFFF]|\\uFE0F)?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|\\uDE2E(?:\\u200D\\uD83D\\uDCA8)?|\\uDE35(?:\\u200D\\uD83D\\uDCAB)?|\\uDE36(?:\\u200D\\uD83C\\uDF2B\\uFE0F?)?|\\uDE42(?:\\u200D[\\u2194\\u2195]\\uFE0F?)?|\\uDEB6(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?)|\\uD83E(?:[\\uDD0C\\uDD0F\\uDD18-\\uDD1F\\uDD30-\\uDD34\\uDD36\\uDD77\\uDDB5\\uDDB6\\uDDBB\\uDDD2\\uDDD3\\uDDD5\\uDEC3-\\uDEC5\\uDEF0\\uDEF2-\\uDEF8](?:\\uD83C[\\uDFFB-\\uDFFF])?|[\\uDD26\\uDD35\\uDD37-\\uDD39\\uDD3C-\\uDD3E\\uDDB8\\uDDB9\\uDDCD\\uDDCF\\uDDD4\\uDDD6-\\uDDDD](?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDDDE\\uDDDF](?:\\u200D[\\u2640\\u2642]\\uFE0F?)?|[\\uDD0D\\uDD0E\\uDD10-\\uDD17\\uDD20-\\uDD25\\uDD27-\\uDD2F\\uDD3A\\uDD3F-\\uDD45\\uDD47-\\uDD76\\uDD78-\\uDDB4\\uDDB7\\uDDBA\\uDDBC-\\uDDCC\\uDDD0\\uDDE0-\\uDDFF\\uDE70-\\uDE7C\\uDE80-\\uDE8A\\uDE8E-\\uDEC2\\uDEC6\\uDEC8\\uDECD-\\uDEDC\\uDEDF-\\uDEEA\\uDEEF]|\\uDDCE(?:\\uD83C[\\uDFFB-\\uDFFF])?(?:\\u200D(?:[\\u2640\\u2642]\\uFE0F?(?:\\u200D\\u27A1\\uFE0F?)?|\\u27A1\\uFE0F?))?|\\uDDD1(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1|\\uDDD1\\u200D\\uD83E\\uDDD2(?:\\u200D\\uD83E\\uDDD2)?|\\uDDD2(?:\\u200D\\uD83E\\uDDD2)?))|\\uD83C(?:\\uDFFB(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFC-\\uDFFF])))?|\\uDFFC(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])))?|\\uDFFD(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])))?|\\uDFFE(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])))?|\\uDFFF(?:\\u200D(?:[\\u2695\\u2696\\u2708]\\uFE0F?|\\u2764\\uFE0F?\\u200D(?:\\uD83D\\uDC8B\\u200D)?\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE]|\\uD83C[\\uDF3E\\uDF73\\uDF7C\\uDF84\\uDF93\\uDFA4\\uDFA8\\uDFEB\\uDFED]|\\uD83D(?:[\\uDCBB\\uDCBC\\uDD27\\uDD2C\\uDE80\\uDE92]|\\uDC30\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE])|\\uD83E(?:[\\uDDAF\\uDDBC\\uDDBD](?:\\u200D\\u27A1\\uFE0F?)?|[\\uDDB0-\\uDDB3\\uDE70]|\\uDD1D\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFF]|\\uDEEF\\u200D\\uD83E\\uDDD1\\uD83C[\\uDFFB-\\uDFFE])))?))?|\\uDEF1(?:\\uD83C(?:\\uDFFB(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFC-\\uDFFF])?|\\uDFFC(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB\\uDFFD-\\uDFFF])?|\\uDFFD(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB\\uDFFC\\uDFFE\\uDFFF])?|\\uDFFE(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB-\\uDFFD\\uDFFF])?|\\uDFFF(?:\\u200D\\uD83E\\uDEF2\\uD83C[\\uDFFB-\\uDFFE])?))?)/g,fullwidthMinimalCodePoint=12288,fullwidthMaximumCodePoint=65510,fullwidthRanges=[12288,12288,65281,65376,65504,65510],wideMinimalCodePoint=4352,wideMaximumCodePoint=262141,wideRanges=[4352,4447,8986,8987,9001,9002,9193,9196,9200,9200,9203,9203,9725,9726,9748,9749,9776,9783,9800,9811,9855,9855,9866,9871,9875,9875,9889,9889,9898,9899,9917,9918,9924,9925,9934,9934,9940,9940,9962,9962,9970,9971,9973,9973,9978,9978,9981,9981,9989,9989,9994,9995,10024,10024,10060,10060,10062,10062,10067,10069,10071,10071,10133,10135,10160,10160,10175,10175,11035,11036,11088,11088,11093,11093,11904,11929,11931,12019,12032,12245,12272,12287,12289,12350,12353,12438,12441,12543,12549,12591,12593,12686,12688,12773,12783,12830,12832,12871,12880,42124,42128,42182,43360,43388,44032,55203,63744,64255,65040,65049,65072,65106,65108,65126,65128,65131,94176,94180,94192,94198,94208,101589,101631,101662,101760,101874,110576,110579,110581,110587,110589,110590,110592,110882,110898,110898,110928,110930,110933,110933,110948,110951,110960,111355,119552,119638,119648,119670,126980,126980,127183,127183,127374,127374,127377,127386,127488,127490,127504,127547,127552,127560,127568,127569,127584,127589,127744,127776,127789,127797,127799,127868,127870,127891,127904,127946,127951,127955,127968,127984,127988,127988,127992,128062,128064,128064,128066,128252,128255,128317,128331,128334,128336,128359,128378,128378,128405,128406,128420,128420,128507,128591,128640,128709,128716,128716,128720,128722,128725,128728,128732,128735,128747,128748,128756,128764,128992,129003,129008,129008,129292,129338,129340,129349,129351,129535,129648,129660,129664,129674,129678,129734,129736,129736,129741,129756,129759,129770,129775,129784,131072,196605,196608,262141],isInRange=(D,E)=>{let F=0,J=Math.floor(D.length/2)-1;for(;F<=J;){const $e=Math.floor((F+J)/2),_t=$e*2;if(E<D[_t])J=$e-1;else if(E>D[_t+1])F=$e+1;else return!0}return!1},commonCjkCodePoint=19968,[wideFastPathStart,wideFastPathEnd]=findWideFastPathRange(wideRanges);function findWideFastPathRange(D){let E=D[0],F=D[1];for(let J=0;J<D.length;J+=2){const $e=D[J],_t=D[J+1];if(commonCjkCodePoint>=$e&&commonCjkCodePoint<=_t)return[$e,_t];_t-$e>F-E&&(E=$e,F=_t)}return[E,F]}var isFullWidth=D=>D<fullwidthMinimalCodePoint||D>fullwidthMaximumCodePoint?!1:isInRange(fullwidthRanges,D),isWide=D=>D>=wideFastPathStart&&D<=wideFastPathEnd?!0:D<wideMinimalCodePoint||D>wideMaximumCodePoint?!1:isInRange(wideRanges,D),narrowEmojiRegexp=/^(?:[\\xA9\\xAE\\u203C\\u2049\\u2122\\u2139\\u2194-\\u2199\\u21A9\\u21AA\\u2328\\u23CF\\u23ED-\\u23EF\\u23F1\\u23F2\\u23F8-\\u23FA\\u24C2\\u25AA\\u25AB\\u25B6\\u25C0\\u25FB\\u25FC\\u2600-\\u2604\\u260E\\u2611\\u2618\\u2620\\u2622\\u2623\\u2626\\u262A\\u262E\\u262F\\u2638-\\u263A\\u2640\\u2642\\u265F\\u2660\\u2663\\u2665\\u2666\\u2668\\u267B\\u267E\\u2692\\u2694-\\u2697\\u2699\\u269B\\u269C\\u26A0\\u26A7\\u26B0\\u26B1\\u26C8\\u26CF\\u26D1\\u26D3\\u26E9\\u26F0\\u26F1\\u26F4\\u26F7\\u26F8\\u2702\\u2708\\u2709\\u270F\\u2712\\u2714\\u2716\\u271D\\u2721\\u2733\\u2734\\u2744\\u2747\\u2763\\u2764\\u27A1\\u2934\\u2935\\u2B05-\\u2B07]|\\uD83C[\\uDD70\\uDD71\\uDD7E\\uDD7F\\uDF21\\uDF24-\\uDF2C\\uDF36\\uDF7D\\uDF96\\uDF97\\uDF99-\\uDF9B\\uDF9E\\uDF9F\\uDFCD\\uDFCE\\uDFD4-\\uDFDF\\uDFF3\\uDFF5\\uDFF7]|\\uD83D[\\uDC3F\\uDC41\\uDCFD\\uDD49\\uDD4A\\uDD6F\\uDD70\\uDD73\\uDD76-\\uDD79\\uDD87\\uDD8A-\\uDD8D\\uDDA5\\uDDA8\\uDDB1\\uDDB2\\uDDBC\\uDDC2-\\uDDC4\\uDDD1-\\uDDD3\\uDDDC-\\uDDDE\\uDDE1\\uDDE3\\uDDE8\\uDDEF\\uDDF3\\uDDFA\\uDECB\\uDECD-\\uDECF\\uDEE0-\\uDEE5\\uDEE9\\uDEF0\\uDEF3])$/,isNarrowEmojiCharacter=D=>narrowEmojiRegexp.test(D),notAsciiRegex=/[^\\x20-\\x7F]/;function getStringWidth(D){if(!D)return 0;if(!notAsciiRegex.test(D))return D.length;let E=0;D=D.replace(emoji_regex_default(),F=>(E+=isNarrowEmojiCharacter(F)?1:2,""));for(const F of D){const J=F.codePointAt(0);J<=31||J>=127&&J<=159||J>=768&&J<=879||J>=65024&&J<=65039||(E+=isFullWidth(J)||isWide(J)?2:1)}return E}var get_string_width_default=getStringWidth,INDENT_COMMAND_TYPE_INDENT=0,INDENT_COMMAND_TYPE_DEDENT=1,INDENT_COMMAND_TYPE_WIDTH=2,INDENT_COMMAND_TYPE_STRING=3,INDENT_COMMAND_INDENT={type:INDENT_COMMAND_TYPE_INDENT},INDENT_COMMAND_DEDENT={type:INDENT_COMMAND_TYPE_DEDENT},ROOT_INDENT={value:"",length:0,queue:[],get root(){return ROOT_INDENT}};function generateIndent(D,E,F){const J=E.type===INDENT_COMMAND_TYPE_DEDENT?D.queue.slice(0,-1):[...D.queue,E];let $e="",_t=0,lr=0,mr=0;for(const Hi of J)switch(Hi.type){case INDENT_COMMAND_TYPE_INDENT:dn(),F.useTabs?Or(1):Pr(F.tabWidth);break;case INDENT_COMMAND_TYPE_STRING:{const{string:Qi}=Hi;dn(),$e+=Qi,_t+=Qi.length;break}case INDENT_COMMAND_TYPE_WIDTH:{const{width:Qi}=Hi;lr+=1,mr+=Qi;break}default:throw new Error(`Unexpected indent comment \'${Hi.type}\'.`)}return qi(),{...D,value:$e,length:_t,queue:J};function Or(Hi){$e+="	".repeat(Hi),_t+=F.tabWidth*Hi}function Pr(Hi){$e+=" ".repeat(Hi),_t+=Hi}function dn(){F.useTabs?gi():qi()}function gi(){lr>0&&Or(lr),zi()}function qi(){mr>0&&Pr(mr),zi()}function zi(){lr=0,mr=0}}function makeAlign(D,E,F){if(!E)return D;if(E.type==="root")return{...D,root:D};if(E===Number.NEGATIVE_INFINITY)return D.root;let J;return typeof E=="number"?E<0?J=INDENT_COMMAND_DEDENT:J={type:INDENT_COMMAND_TYPE_WIDTH,width:E}:J={type:INDENT_COMMAND_TYPE_STRING,string:E},generateIndent(D,J,F)}function makeIndent(D,E){return generateIndent(D,INDENT_COMMAND_INDENT,E)}function getTrailingIndentionLength(D){let E=0;for(let F=D.length-1;F>=0;F--){const J=D[F];if(J===" "||J==="	")E++;else break}return E}function trimIndentation(D){const E=getTrailingIndentionLength(D);return{text:E===0?D:D.slice(0,D.length-E),count:E}}var printResult=class{#r=[];#e="";#n=0;#i=[];#t=[];#o(){const D=this.#e;D!==""&&(this.#r.push(D),this.#n+=D.length,this.#e="");for(const E of this.#t)this.#i.push(Math.min(E,this.#n));this.#t.length=0}markPosition(){if(this.#i.length+this.#t.length>=2)throw new Error("There are too many \'cursor\' in doc.");this.#t.push(this.#n+this.#e.length)}write(D){this.#e+=D}trim(){const{text:D,count:E}=trimIndentation(this.#e);return this.#e=D,this.#o(),E}finish(){return this.#o(),{text:this.#r.join(""),positions:this.#i}}},print_result_default=printResult,MODE_BREAK=Symbol("MODE_BREAK"),MODE_FLAT=Symbol("MODE_FLAT"),DOC_FILL_PRINTED_LENGTH=Symbol("DOC_FILL_PRINTED_LENGTH");function fits(D,E,F,J,$e,_t){if(F===Number.POSITIVE_INFINITY)return!0;let lr=E.length,mr=!1;const Or=[D];let Pr="";for(;F>=0;){if(Or.length===0){if(lr===0)return!0;Or.push(E[--lr]);continue}const{mode:dn,doc:gi}=Or.pop(),qi=get_doc_type_default(gi);switch(qi){case DOC_TYPE_STRING:gi&&(mr&&(Pr+=" ",F-=1,mr=!1),Pr+=gi,F-=get_string_width_default(gi));break;case DOC_TYPE_ARRAY:case DOC_TYPE_FILL:{const zi=qi===DOC_TYPE_ARRAY?gi:gi.parts,Hi=gi[DOC_FILL_PRINTED_LENGTH]??0;for(let Qi=zi.length-1;Qi>=Hi;Qi--)Or.push({mode:dn,doc:zi[Qi]});break}case DOC_TYPE_INDENT:case DOC_TYPE_ALIGN:case DOC_TYPE_INDENT_IF_BREAK:case DOC_TYPE_LABEL:Or.push({mode:dn,doc:gi.contents});break;case DOC_TYPE_TRIM:{const{text:zi,count:Hi}=trimIndentation(Pr);Pr=zi,F+=Hi;break}case DOC_TYPE_GROUP:{if(_t&&gi.break)return!1;const zi=gi.break?MODE_BREAK:dn,Hi=gi.expandedStates&&zi===MODE_BREAK?method_at_default(0,gi.expandedStates,-1):gi.contents;Or.push({mode:zi,doc:Hi});break}case DOC_TYPE_IF_BREAK:{const Hi=(gi.groupId?$e[gi.groupId]||MODE_FLAT:dn)===MODE_BREAK?gi.breakContents:gi.flatContents;Hi&&Or.push({mode:dn,doc:Hi});break}case DOC_TYPE_LINE:if(dn===MODE_BREAK||gi.hard)return!0;gi.soft||(mr=!0);break;case DOC_TYPE_LINE_SUFFIX:J=!0;break;case DOC_TYPE_LINE_SUFFIX_BOUNDARY:if(J)return!1;break}}return!1}function printDocToString(D,E){const F=Object.create(null),J=E.printWidth,$e=convertEndOfLineOptionToCharacter(E.endOfLine);let _t=0;const lr=[{indent:ROOT_INDENT,mode:MODE_BREAK,doc:D}];let mr=!1;const Or=[],Pr=new print_result_default;for(propagateBreaks(D);lr.length>0;){const{indent:Hi,mode:Qi,doc:Gi}=lr.pop();switch(get_doc_type_default(Gi)){case DOC_TYPE_STRING:{const Zi=$e!==`\n`?method_replace_all_default(0,Gi,`\n`,$e):Gi;Zi&&(Pr.write(Zi),lr.length>0&&(_t+=get_string_width_default(Zi)));break}case DOC_TYPE_ARRAY:for(let Zi=Gi.length-1;Zi>=0;Zi--)lr.push({indent:Hi,mode:Qi,doc:Gi[Zi]});break;case DOC_TYPE_CURSOR:Pr.markPosition();break;case DOC_TYPE_INDENT:lr.push({indent:makeIndent(Hi,E),mode:Qi,doc:Gi.contents});break;case DOC_TYPE_ALIGN:lr.push({indent:makeAlign(Hi,Gi.n,E),mode:Qi,doc:Gi.contents});break;case DOC_TYPE_TRIM:_t-=Pr.trim();break;case DOC_TYPE_GROUP:{const Zi=(function(){if(Qi===MODE_FLAT&&!mr)return{indent:Hi,mode:Gi.break?MODE_BREAK:MODE_FLAT,doc:Gi.contents};mr=!1;const Ki=J-_t,ea=Or.length>0,Ji={indent:Hi,mode:MODE_FLAT,doc:Gi.contents};if(!Gi.break&&fits(Ji,lr,Ki,ea,F))return Ji;if(!Gi.expandedStates)return{indent:Hi,mode:MODE_BREAK,doc:Gi.contents};if(!Gi.break)for(let ta=1;ta<Gi.expandedStates.length-1;ta++){const na={indent:Hi,mode:MODE_FLAT,doc:Gi.expandedStates[ta]};if(fits(na,lr,Ki,ea,F))return na}return{indent:Hi,mode:MODE_BREAK,doc:method_at_default(0,Gi.expandedStates,-1)}})();lr.push(Zi),Gi.id&&(F[Gi.id]=Zi.mode);break}case DOC_TYPE_FILL:{const Zi=J-_t,Xi=Gi[DOC_FILL_PRINTED_LENGTH]??0,{parts:Ki}=Gi,ea=Ki.length-Xi;if(ea===0)break;const Ji=Ki[Xi+0],ta=Ki[Xi+1],na={indent:Hi,mode:MODE_FLAT,doc:Ji},ra={indent:Hi,mode:MODE_BREAK,doc:Ji},ia=fits(na,[],Zi,Or.length>0,F,!0);if(ea===1){ia?lr.push(na):lr.push(ra);break}const oa={indent:Hi,mode:MODE_FLAT,doc:ta},ua={indent:Hi,mode:MODE_BREAK,doc:ta};if(ea===2){ia?lr.push(oa,na):lr.push(ua,ra);break}const sa=Ki[Xi+2],aa={indent:Hi,mode:Qi,doc:{...Gi,[DOC_FILL_PRINTED_LENGTH]:Xi+2}},ma=fits({indent:Hi,mode:MODE_FLAT,doc:[Ji,ta,sa]},[],Zi,Or.length>0,F,!0);lr.push(aa),ma?lr.push(oa,na):ia?lr.push(ua,na):lr.push(ua,ra);break}case DOC_TYPE_IF_BREAK:case DOC_TYPE_INDENT_IF_BREAK:{const Zi=Gi.groupId?F[Gi.groupId]:Qi;if(Zi===MODE_BREAK){const Xi=Gi.type===DOC_TYPE_IF_BREAK?Gi.breakContents:Gi.negate?Gi.contents:indent$1(Gi.contents);Xi&&lr.push({indent:Hi,mode:Qi,doc:Xi})}if(Zi===MODE_FLAT){const Xi=Gi.type===DOC_TYPE_IF_BREAK?Gi.flatContents:Gi.negate?indent$1(Gi.contents):Gi.contents;Xi&&lr.push({indent:Hi,mode:Qi,doc:Xi})}break}case DOC_TYPE_LINE_SUFFIX:Or.push({indent:Hi,mode:Qi,doc:Gi.contents});break;case DOC_TYPE_LINE_SUFFIX_BOUNDARY:Or.length>0&&lr.push({indent:Hi,mode:Qi,doc:hardlineWithoutBreakParent});break;case DOC_TYPE_LINE:switch(Qi){case MODE_FLAT:if(!Gi.hard){Gi.soft||(Pr.write(" "),_t+=1);break}mr=!0;case MODE_BREAK:if(Or.length>0){lr.push({indent:Hi,mode:Qi,doc:Gi},...Or.reverse()),Or.length=0;break}Gi.literal?(Pr.write($e),_t=0,Hi.root&&(Hi.root.value&&Pr.write(Hi.root.value),_t=Hi.root.length)):(Pr.trim(),Pr.write($e+Hi.value),_t=Hi.length);break}break;case DOC_TYPE_LABEL:lr.push({indent:Hi,mode:Qi,doc:Gi.contents});break;case DOC_TYPE_BREAK_PARENT:break;default:throw new invalid_doc_error_default(Gi)}lr.length===0&&Or.length>0&&(lr.push(...Or.reverse()),Or.length=0)}const{text:dn,positions:gi}=Pr.finish();if(gi.length!==2)return{formatted:dn};const[qi,zi]=gi;return{formatted:dn,cursorNodeStart:qi,cursorNodeText:dn.slice(qi,zi)}}var builders={join:join$1$1,line:line$1,softline:softline$1,hardline:hardline$1,literalline,group:group$1,conditionalGroup,fill:fill$1,lineSuffix,lineSuffixBoundary,cursor,breakParent:breakParent$1,ifBreak,trim,indent:indent$1,indentIfBreak,align,addAlignmentToDoc,markAsRoot,dedentToRoot,dedent,hardlineWithoutBreakParent,literallineWithoutBreakParent,label,concat:D=>D},printer={printDocToString},utils$1={willBreak,traverseDoc:traverse_doc_default,findInDoc,mapDoc,removeLines,stripTrailingHardline,replaceEndOfLine,canBreak};const{line,indent,softline,join:join$2,fill,group:group$2,hardline,breakParent}=builders;function classifyContentMode(D){return PRE_ELEMENTS.has(D.name)?"pre":D.children.length===0?"empty":isAlwaysBreakParent(D.name)||D.children.some(isBlockChildNode)?"block":"inline"}function isBlockChildNode(D){switch(D.type){case"element":return isBlock(D.name);case"comment":case"cdata":case"doctype":case"instruction":return!0;default:return!1}}const print=function(D,E,F){const J=E,$e=D.node;switch($e.type){case"root":{const _t=D.map(F,"children");return printChildSequenceAsBlock($e.children,_t)}case"cdata":{const _t=/]]>/g,lr=[">"];return["<![CDATA[",escape$1($e.value,lr,_t),"]]>"]}case"comment":return["<!--",$e.value,"-->"];case"doctype":{const _t=name$a($e.name),lr=$e.public,mr=$e.system;let Or=["<!DOCTYPE"];return _t!==""&&Or.push(" ",_t),lr?Or.push(" ","PUBLIC"," ",quote(lr)):mr&&Or.push(" ","SYSTEM"),mr&&Or.push(" ",quote(mr)),Or.push(">"),Or}case"element":{const _t=name$a($e.name),lr=["<",_t],mr=$e.attributes||[],Or=[];for(const qi of Object.values(mr)){const zi=name$a(qi.name);qi.children.length===0?J.doenetSyntax?Or.push(line,zi):Or.push(line,zi,"=",\'"true"\'):Or.push(line,zi,"=",quote(nodesToXml(qi.children,J)))}Or.length>0&&lr.push(indent(Or));const Pr=classifyContentMode($e);if(Pr==="empty")return lr.push(Or.length>0?line:" ","/>"),group$2(lr);lr.push(Or.length>0?softline:"",">");const dn=["</",_t,">"];if(Pr==="pre")return[group$2(lr),toXml($e.children,J),dn];if(Pr==="inline"){const qi=flattenForFill(D.map(F,"children"));return group$2([group$2(lr),indent([softline,fill(qi)]),softline,dn])}const gi=printChildSequenceAsBlock($e.children,D.map(F,"children"),isDefinitionalContainer($e.name));return[group$2(lr),indent([hardline,gi]),hardline,dn,breakParent]}case"error":return"";case"instruction":{const _t=/\\?>/g,lr=[">"],mr=name$a($e.name),Or=escape$1($e.value,lr,_t);return["<?",mr,Or?" "+Or:"","?>"]}case"text":{let _t=escape$1($e.value,["&","<"]);return J.doenetSyntax&&(_t=_t.replace(/&lt;(?=\\s|=)/g,"<"),_t=_t.replace(/&amp;(?!\\S*;)/g,"&")),join$2([hardline,hardline],_t.split(/\\n\\n+/).map(lr=>join$2(line,lr.split(/\\s+/)))).flat()}case"macro":case"function":return toXml($e,J);default:console.warn(`Unhandled node type when pretty-printing: ${$e}`)}return""};function printChildSequenceAsBlock(D,E,F=!1){const J=[];let $e=null;function _t(){if(!$e)return;const mr=flattenForFill($e.printed);mr.length>0&&J.push({firstNode:$e.firstNode,doc:fill(mr)}),$e=null}for(let mr=0;mr<D.length;mr++){const Or=D[mr],Pr=E[mr];isBlockChildNode(Or)||F&&Or.type==="element"?(_t(),J.push({firstNode:Or,doc:Pr})):($e||($e={firstNode:Or,printed:[]}),$e.printed.push(Pr))}_t();const lr=[];for(let mr=0;mr<J.length;mr++){const Or=J[mr];mr>0&&lr.push(hasBlankLineBefore(Or.firstNode)?[hardline,hardline]:hardline),lr.push(Or.doc)}return lr}function flattenForFill(D){const E=[];for(const F of D.flat())F!==""&&(isSoftLine(F)&&(E.length===0||isSoftLine(E[E.length-1]))||E.push(F));for(;E.length>0&&isSoftLine(E[E.length-1]);)E.pop();return E}function isSoftLine(D){return D===line||D===softline}const languages=[{name:"doenet",extensions:[".doenet"],parsers:["doenet-parser"]}],parsers={"doenet-parser":{parse(D,E){return normalize(lezerToDast(D))},astFormat:"dast",locStart:D=>(D.position||{start:{offset:0}}).start.offset||0,locEnd:D=>(D.position||{end:{offset:0}}).end.offset||0}},printers={dast:{print}},options={doenetSyntax:{category:"Global",type:"boolean",default:!1,description:"Whether to render with the DoenetML syntax rather than true XML. That means `<` and `&` characters are allowed unescaped in the output."},inlineErrors:{category:"Global",type:"boolean",default:!1,description:"Whether to output XML error nodes when there are processing errors."}},prettierPluginDoenet={languages,parsers,printers,options},prettierPluginDoenet$1=Object.freeze(Object.defineProperty({__proto__:null,default:prettierPluginDoenet,languages,options,parsers,printers},Symbol.toStringTag,{value:"Module"}));async function prettyPrint(D="",E={}){const F=E.plugins||[];return F.push(prettierPluginDoenet$1),await Pu(D,{printWidth:80,useTabs:!1,tabWidth:4,...E,parser:"doenet-parser",plugins:F})}var dist={},core={},debug={},hasRequiredDebug;function requireDebug(){if(hasRequiredDebug)return debug;hasRequiredDebug=1,Object.defineProperty(debug,"__esModule",{value:!0}),debug.getType=D,debug.throwUnknownDataType=E,debug.throwUnsupportedData=F;function D(J){return Object.prototype.toString.call(J)}function E(J){throw new TypeError("unsupported data type: "+D(J))}function F(J){throw new TypeError("unsupported data type: "+J)}return debug}var encode={},number={},hasRequiredNumber;function requireNumber(){if(hasRequiredNumber)return number;hasRequiredNumber=1,Object.defineProperty(number,"__esModule",{value:!0}),number.s_to_int=J,number.s_to_big_int=$e,number.int_to_s=_t,number.big_int_to_s=lr,number.num_to_s=Or,number.int_str_to_s=Pr,number.s_to_num=gi;let D="";for(let qi=0;qi<10;qi++){const zi=String.fromCharCode(48+qi);D+=zi}for(let qi=0;qi<26;qi++){const zi=String.fromCharCode(65+qi);D+=zi}for(let qi=0;qi<26;qi++){const zi=String.fromCharCode(97+qi);D+=zi}const E=D.length,F={};for(let qi=0;qi<E;qi++){const zi=D[qi];F[zi]=qi}function J(qi){let zi=0,Hi=1;for(let Qi=qi.length-1;Qi>=0;Qi--){const Gi=qi[Qi];let Zi=F[Gi];Zi*=Hi,zi+=Zi,Hi*=E}return zi}function $e(qi){let zi=BigInt(0),Hi=BigInt(1);const Qi=BigInt(E);for(let Gi=qi.length-1;Gi>=0;Gi--){const Zi=qi[Gi];let Xi=BigInt(F[Zi]);Xi*=Hi,zi+=Xi,Hi*=Qi}return zi}function _t(qi){if(qi===0)return D[0];const zi=[];for(;qi!==0;){const Hi=qi%E,Qi=D[Hi];zi.push(Qi),qi-=Hi,qi/=E}return zi.reverse().join("")}function lr(qi){const zi=BigInt(0),Hi=BigInt(E);if(qi===zi)return D[0];const Qi=[];for(;qi!==zi;){const Gi=qi%Hi,Zi=D[Number(Gi)];Qi.push(Zi),qi/=Hi}return Qi.reverse().join("")}function mr(qi){return qi.split("").reverse().join("")}function Or(qi){if(qi<0)return"-"+Or(-qi);let[zi,Hi]=qi.toString().split(".");if(!Hi)if(zi.includes("e")){const[Zi,Xi]=zi.split("e");zi=Zi,Hi="0e"+Xi}else return _t(qi);let Qi;Hi&&([Hi,Qi]=Hi.split("e")),zi=Pr(zi),Hi=mr(Hi),Hi=Pr(Hi);let Gi=zi+"."+Hi;if(Qi){switch(Gi+=".",Qi[0]){case"+":Qi=Qi.slice(1);break;case"-":Gi+="-",Qi=Qi.slice(1);break}Qi=Pr(Qi),Gi+=Qi}return Gi}function Pr(qi){const zi=+qi;return zi.toString()===qi&&zi+1!==zi&&zi-1!==zi?_t(zi):":"+lr(BigInt(qi))}function dn(qi){return qi[0]===":"?$e(qi.substring(1)).toString():J(qi).toString()}function gi(qi){if(qi[0]==="-")return-gi(qi.substr(1));let[zi,Hi,Qi]=qi.split(".");if(!Hi)return J(zi);zi=dn(zi),Hi=dn(Hi),Hi=mr(Hi);let Gi=zi+"."+Hi;if(Qi){Gi+="e";let Zi=!1;Qi[0]==="-"&&(Zi=!0,Qi=Qi.slice(1)),Qi=dn(Qi),Gi+=Zi?-Qi:+Qi}return+Gi}return number}var hasRequiredEncode;function requireEncode(){if(hasRequiredEncode)return encode;hasRequiredEncode=1,Object.defineProperty(encode,"__esModule",{value:!0}),encode.encodeNum=E,encode.decodeNum=F,encode.decodeKey=J,encode.encodeBool=$e,encode.decodeBool=_t,encode.encodeStr=lr,encode.decodeStr=mr;const D=requireNumber();function E(Or){return Or===1/0?"N|+":Or===-1/0?"N|-":Number.isNaN(Or)?"N|0":"n|"+(0,D.num_to_s)(Or)}function F(Or){if(Or.length===3&&Or[0]==="N"&&Or[1]==="|")switch(Or[2]){case"+":return 1/0;case"-":return-1/0;case"0":return NaN}return(0,D.s_to_num)(Or.slice(2))}function J(Or){return typeof Or=="number"?Or:(0,D.s_to_int)(Or)}function $e(Or){return Or?"b|T":"b|F"}function _t(Or){if(Or.length===3&&Or[0]==="b"&&Or[1]==="|")switch(Or[2]){case"T":return!0;case"F":return!1}return!!Or}function lr(Or){if(Or[1]==="|")switch(Or[0]){case"b":case"o":case"n":case"a":case"s":return"s|"+Or}return Or}function mr(Or){return Or[0]==="s"&&Or[1]==="|"?Or.substr(2):Or}return encode}var memory={},config$1={},hasRequiredConfig;function requireConfig(){return hasRequiredConfig||(hasRequiredConfig=1,Object.defineProperty(config$1,"__esModule",{value:!0}),config$1.config=void 0,config$1.config={sort_key:!1,preserve_nan:!1,error_on_nan:!1,preserve_infinite:!1,error_on_infinite:!1}),config$1}var hasRequiredMemory;function requireMemory(){if(hasRequiredMemory)return memory;hasRequiredMemory=1,Object.defineProperty(memory,"__esModule",{value:!0}),memory.memToValues=$e,memory.makeInMemoryStore=_t,memory.makeInMemoryCache=lr,memory.makeInMemoryMemory=mr,memory.addValue=dn;const D=requireConfig(),E=requireDebug(),F=requireEncode(),J=requireNumber();function $e(gi){return gi.store.toArray()}function _t(){const gi=[];return{forEach(qi){for(let zi=0;zi<gi.length;zi++)if(qi(gi[zi])==="break")return},add(qi){gi.push(qi)},toArray(){return gi}}}function lr(){const gi=Object.create(null),qi=Object.create(null);return{getValue(zi){return gi[zi]},getSchema(zi){return qi[zi]},forEachValue(zi){for(const[Hi,Qi]of Object.entries(gi))if(zi(Hi,Qi)==="break")return},forEachSchema(zi){for(const[Hi,Qi]of Object.entries(qi))if(zi(Hi,Qi)==="break")return},setValue(zi,Hi){gi[zi]=Hi},setSchema(zi,Hi){qi[zi]=Hi},hasValue(zi){return zi in gi},hasSchema(zi){return zi in qi}}}function mr(){return{store:_t(),cache:lr(),keyCount:0}}function Or(gi,qi){if(gi.cache.hasValue(qi))return gi.cache.getValue(qi);const zi=gi.keyCount++,Hi=(0,J.num_to_s)(zi);return gi.store.add(qi),gi.cache.setValue(qi,Hi),Hi}function Pr(gi,qi){D.config.sort_key&&qi.sort();const zi=qi.join(",");if(gi.cache.hasSchema(zi))return gi.cache.getSchema(zi);const Hi=dn(gi,qi,void 0);return gi.cache.setSchema(zi,Hi),Hi}function dn(gi,qi,zi){if(qi===null)return"";switch(typeof qi){case"undefined":if(Array.isArray(zi))return dn(gi,null,zi);break;case"object":if(qi===null)return Or(gi,null);if(Array.isArray(qi)){let Hi="a";for(let Qi=0;Qi<qi.length;Qi++){const Gi=qi[Qi],Zi=Gi===null?"_":dn(gi,Gi,qi);Hi+="|"+Zi}return Hi==="a"&&(Hi="a|"),Or(gi,Hi)}else{const Hi=Object.keys(qi);if(Hi.length===0)return Or(gi,"o|");let Qi="o";const Gi=Pr(gi,Hi);Qi+="|"+Gi;for(const Zi of Hi){const Xi=qi[Zi],Ki=dn(gi,Xi,qi);Qi+="|"+Ki}return Or(gi,Qi)}case"boolean":return Or(gi,(0,F.encodeBool)(qi));case"number":return Number.isNaN(qi)?D.config.preserve_nan?Or(gi,"N|0"):(D.config.error_on_nan&&(0,E.throwUnsupportedData)("[number NaN]"),""):Number.POSITIVE_INFINITY===qi?D.config.preserve_infinite?Or(gi,"N|+"):(D.config.error_on_infinite&&(0,E.throwUnsupportedData)("[number Infinity]"),""):Number.NEGATIVE_INFINITY===qi?D.config.preserve_infinite?Or(gi,"N|-"):(D.config.error_on_infinite&&(0,E.throwUnsupportedData)("[number -Infinity]"),""):Or(gi,(0,F.encodeNum)(qi));case"string":return Or(gi,(0,F.encodeStr)(qi))}return(0,E.throwUnknownDataType)(qi)}return memory}var hasRequiredCore;function requireCore(){if(hasRequiredCore)return core;hasRequiredCore=1,Object.defineProperty(core,"__esModule",{value:!0}),core.compress=$e,core.decode=mr,core.decompress=Or;const D=requireDebug(),E=requireEncode(),F=requireMemory(),J=requireNumber();function $e(Pr){const dn=(0,F.makeInMemoryMemory)(),gi=(0,F.addValue)(dn,Pr,void 0);return[(0,F.memToValues)(dn),gi]}function _t(Pr,dn){if(dn==="o|")return{};const gi={},qi=dn.split("|"),zi=qi[1];let Hi=mr(Pr,zi);const Qi=qi.length;Qi-2===1&&!Array.isArray(Hi)&&(Hi=[Hi]);for(let Gi=2;Gi<Qi;Gi++){const Zi=Hi[Gi-2];let Xi=qi[Gi];Xi=mr(Pr,Xi),gi[Zi]=Xi}return gi}function lr(Pr,dn){if(dn==="a|")return[];const gi=dn.split("|"),qi=gi.length-1,zi=new Array(qi);for(let Hi=0;Hi<qi;Hi++){let Qi=gi[Hi+1];Qi=mr(Pr,Qi),zi[Hi]=Qi}return zi}function mr(Pr,dn){if(dn===""||dn==="_")return null;const gi=(0,E.decodeKey)(dn),qi=Pr[gi];if(qi===null)return qi;switch(typeof qi){case"undefined":return qi;case"number":return qi;case"string":if(qi[1]==="|")switch(qi[0]){case"b":switch(qi[2]){case"T":return!0;case"F":return!1;default:return(0,D.throwUnknownDataType)(qi)}case"o":return _t(Pr,qi);case"n":return(0,J.s_to_num)(qi.slice(2));case"N":switch(qi[2]){case"+":return 1/0;case"-":return-1/0;case"0":return NaN;default:return(0,D.throwUnknownDataType)(qi)}case"a":return lr(Pr,qi)}return(0,E.decodeStr)(qi)}return(0,D.throwUnknownDataType)(qi)}function Or(Pr){const[dn,gi]=Pr;return mr(dn,gi)}return core}var helpers={},hasRequiredHelpers;function requireHelpers(){if(hasRequiredHelpers)return helpers;hasRequiredHelpers=1,Object.defineProperty(helpers,"__esModule",{value:!0}),helpers.trimUndefined=D,helpers.trimUndefinedRecursively=E;function D(J){for(const $e in J)J[$e]===void 0&&delete J[$e]}function E(J){F(J,new Set)}function F(J,$e){$e.add(J);for(const _t in J)if(J[_t]===void 0)delete J[_t];else{const lr=J[_t];lr&&typeof lr=="object"&&!$e.has(lr)&&F(lr,$e)}}return helpers}var hasRequiredDist;function requireDist(){return hasRequiredDist||(hasRequiredDist=1,(function(D){Object.defineProperty(D,"__esModule",{value:!0}),D.config=D.trimUndefinedRecursively=D.trimUndefined=D.addValue=D.decode=D.decompress=D.compress=void 0;var E=requireCore();Object.defineProperty(D,"compress",{enumerable:!0,get:function(){return E.compress}}),Object.defineProperty(D,"decompress",{enumerable:!0,get:function(){return E.decompress}});var F=requireCore();Object.defineProperty(D,"decode",{enumerable:!0,get:function(){return F.decode}});var J=requireMemory();Object.defineProperty(D,"addValue",{enumerable:!0,get:function(){return J.addValue}});var $e=requireHelpers();Object.defineProperty(D,"trimUndefined",{enumerable:!0,get:function(){return $e.trimUndefined}}),Object.defineProperty(D,"trimUndefinedRecursively",{enumerable:!0,get:function(){return $e.trimUndefinedRecursively}});var _t=requireConfig();Object.defineProperty(D,"config",{enumerable:!0,get:function(){return _t.config}})})(dist)),dist}var distExports=requireDist();const doenetSchema=distExports.decompress([["elements","aliasedElements","a|0|1","name","children","childBuckets","abstractAncestors","attributes","properties","top","acceptsStringChildren","takesIndex","docsSlug","summary","layoutCategory","a|3|4|5|6|7|8|9|A|B|C|D|E","title","rightHandSide","xLabel","yLabel","br","m","me","men","md","mdn","mrow","not","and","or","xor","iff","implies","isInteger","isNumber","isBetween","sum","product","clampNumber","wrapNumberPeriodic","round","setSmallToZero","convertSetToList","ceil","floor","abs","sign","mean","median","variance","standardDeviation","count","min","max","mod","gcd","lcm","extractMath","clampFunction","wrapFunctionPeriodic","derivative","extractMathOperator","em","alert","q","sq","term","c","tag","tage","tagc","attr","ndash","mdash","nbsp","ellipsis","lq","rq","lsq","rsq","odeSystem","equilibriumPoint","equilibriumLine","atom","ion","ionicCompound","electronConfiguration","span","displayDoenetML","matrixInput","fractionInput","text","textList","boolean","booleanList","math","mathList","tupleList","numberList","collect","ref","point","coords","line","bezierControls","vector","angle","answer","mathInput","textInput","booleanInput","choiceInput","choice","number","integer","function","piecewiseFunction","interval","sequence","cell","repeat","repeatForSequence","intersection","conditionalContent","asList","selectFromSequence","select","group","evaluate","selectRandomNumbers","sampleRandomNumbers","selectPrimeNumbers","samplePrimeNumbers","substitute","periodicSet","intComma","pluralize","lorem","updateValue","callAction","triggerSet","functionIterates","module","footnote","endpoint","sort","shuffle","solveEquations","subsetOfReals","split","bestFitLine","hasSameFactoring","label","matchesPattern","matrix","latex","pointList","intervalList","vectorList","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y","11111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222212221222221112111121222112211111222","_textOrInline","_inline","_base","a|2b|2c|2d","description","type","a|3|2f|2g","The name used to reference this component from elsewhere in the document.","o|2h|3|2i|1T","defaultValue","values","a|3|2f|2k|2l|2g","hide","Whether to hide this component from the rendered output.","b|F","true","false","a|2q|2r","o|2m|2n|2o|2p|2s|1V","disabled","Whether this component is disabled and cannot be interacted with.","o|2m|2u|2v|2p|2s|1V","fixed","Whether this component\'s value is fixed and cannot be modified.","o|2m|2x|2y|2p|2s|1V","fixLocation","Whether this component\'s location is fixed (preventing it from being moved while still allowing other modifications).","o|2m|30|31|2p|2s|1V","a|3|2f|2k|2g","styleNumber","The style number used to select this component\'s visual styling from the available style definitions.","n|1","o|33|34|35|36|1q","isResponse","Whether this component is treated as a response for the purposes of assessment.","o|2m|38|39|2p|2s|1V","extend","Extend another component by reference, inheriting its children and attributes. Enter a reference as `$name`.","reference","o|2h|3B|3C|3D","copy","Create an independent copy of another component by reference. Enter a references a `$name`.","o|2h|3F|3G|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H","isArray","fromAttribute","a|3|2g|3J|2f|3K","b|T","o|3L|2n|1V|2p|2o|3M","o|3L|34|1q|2p|35|3M","o|3L|38|1V|2p|39|3M","a|3|2g|3J|2f","hidden","Whether this component is hidden from the rendered output.","o|3Q|3R|1V|2p|3S","o|3Q|2u|1V|2p|2v","o|3Q|2x|1V|2p|2y","o|3Q|30|1V|2p|31","doenetML","The DoenetML source code that produced this component.","o|3Q|3X|1T|2p|3Y","value","The combined content of this component\'s children.","o|3Q|3a|G|2p|3b","The combined content of this component\'s children, as a plain text string.","o|3Q|1T|1T|2p|3d","a|3N|3O|3P|3T|3U|3V|3W|3Z|3c|3e","Creates a title within a document, section, or other block component","inline","o|F|G|2Z|2a|2e|3I|3f|3M|3M|2p|G|3g|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","1222211111111111111111111112222222221222202222122222222212222122222122221212222","a|2c|2d","highlighted","autocompleteValues","a|3|2f|3m|2k|2l|3n|2g","format","Input format.","a|1T|2V","a|3a|2f","Plain-text math notation (e.g., `x^2 + 1`).","o|3s|1T|3t","LaTeX-formatted math (e.g., `x^{2} + 1`).","o|3s|2V|3v","a|3u|3w","keyword","o|3o|3p|3q|3M|1T|3r|3x|3y","simplify","Level of simplification applied to the expression.","none","full","numbers","numbersPreserveOrder","normalizeOrder","a|42|43|44|45|46|2q|2r","No simplification is applied.","o|3s|42|48","Fully simplify the expression.","o|3s|43|4A","Simplify numeric subexpressions only, leaving symbolic structure intact.","o|3s|44|4C","Like `numbers`, but does not reorder commutative operands.","o|3s|45|4E","Reorder commutative operands into a canonical form without simplifying values.","o|3s|46|4G","a|49|4B|4D|4F|4H","o|3o|40|41|3M|42|47|4I|3y","expand","Whether to expand the expression.","o|2m|4K|4L|2p|2s|1V","groupName","a|3|2f|4N|3m|2k|2g","displayDigits","Number of significant digits to display when rendering this number.","number-display","n|3","o|4O|4P|4Q|4R|3M|4S|1q","a|3|2f|4N|2k|2g","displayDecimals","Number of decimal places to display when rendering this number.","n|2","o|4U|4V|4W|4R|4X|1q","displaySmallAsZero","Threshold below which numbers are displayed as zero.","n|1.0.-E","o|4U|4Z|4a|4R|4b|1p","a|3|2f|4N|2k|2l|2g","padZeros","Whether to pad displayed numbers with trailing zeros to fill the requested digits/decimals.","o|4d|4e|4f|4R|2p|2s|1V","avoidScientificNotation","Whether to render numbers in full decimal form rather than scientific notation.","o|4d|4h|4i|4R|2p|2s|1V","renderMode",\'How the math is rendered (e.g. "inline", "display").\',"o|33|4k|4l|3h|1T","unordered","Whether tuple- or list-like math expressions should be treated as unordered for comparison.","o|2m|4n|4o|2p|2s|1V","createVectors","Whether tuple-like expressions are interpreted as vectors.","o|2m|4q|4r|2p|2s|1V","createIntervals","Whether range expressions are interpreted as intervals.","o|2m|4t|4u|2p|2s|1V","functionSymbols","Symbols treated as function names when parsing.","f","g","a|4y|4z","o|33|4w|4x|50|1U","referencesAreFunctionSymbols","References whose names should be treated as function symbols when parsing.","a|","o|33|52|53|54|3D","splitSymbols","Whether multi-character symbols are split into a product of variables.","o|2m|56|57|3M|2s|1V","parseScientificNotation","Whether to parse expressions like 1e3 as scientific notation.","o|2m|59|5A|2p|2s|1V","displayBlanks","Whether blanks (placeholders) are visibly rendered.","o|2m|5C|5D|3M|2s|1V","assumptions","Assumptions applied when simplifying or comparing.","a|2g|2V","＿","o|5H|1X|5I","o|33|5F|5G|5J|1X","draggable","Whether the math component can be dragged on a graph.","o|2m|5L|5M|3M|2s|1V","layer","Z-order layer index when shown on a graph.","n|0","o|33|5O|5P|5Q|1p","anchor","Coordinates of the anchor point used to position this component on a graph.","positioning","\\\\left( 0, 0 \\\\right)","o|5H|1X|5V","o|4U|5S|5T|5U|5W|1d","a|3|2f|4N|2k|2l|3n|2g","positionFromAnchor","Where this component sits relative to its anchor point.","center","upperRight","upperLeft","lowerRight","lowerLeft","bottom","left","right","a|5c|5d|5e|5f|9|5g|5h|5i|5b","Place the component above and to the right of the anchor point.","o|3s|5c|5k","Place the component above and to the left of the anchor point.","o|3s|5d|5m","Place the component below and to the right of the anchor point.","o|3s|5e|5o","Place the component below and to the left of the anchor point.","o|3s|5f|5q","Place the component directly above the anchor point.","o|3s|9|5s","Place the component directly below the anchor point.","o|3s|5g|5u","Place the component directly to the left of the anchor point.","o|3s|5h|5w","Place the component directly to the right of the anchor point.","o|3s|5i|5y","Center the component on the anchor point.","o|3s|5b|60","a|5l|5n|5p|5r|5t|5v|5x|5z|61","o|5Y|5Z|5a|5U|5b|5j|62|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","a|3|2g|3J|2f|3K|3m","o|65|3p|1T|2p|3q|3M|3M","o|65|40|1T|2p|41|3M|3M","o|3L|4K|1V|2p|4L|3M","o|3L|4k|1T|2p|4l|3M","o|3L|4q|1V|2p|4r|3M","o|3L|4t|1V|2p|4u|3M","o|3L|4w|1U|2p|4x|3M","o|3L|56|1V|2p|57|3M","o|3L|59|1V|2p|5A|3M","o|3L|5C|1V|2p|5D|3M","o|3L|5F|1X|2p|5G|3M","o|3L|5L|1V|2p|5M|3M","o|3L|5O|1p|2p|5P|3M","a|3|2g|3J|2f|3K|4N","o|6J|5Z|1T|2p|5a|3M|5U","textColor","Human-readable name for this component\'s text color, derived from the active style and theme.","o|3Q|6L|1T|2p|6M","backgroundColor","Human-readable name for this component\'s background color, derived from the active style and theme.","o|3Q|6O|1T|2p|6P","textStyleDescription","Human-readable description of this component\'s text styling (color and any background color).","o|3Q|6R|1T|2p|6S","a|3|2g|3J|2f|4N","The coordinates where this component is anchored on the graph.","o|6U|5S|1d|2p|6V|5U","o|3Q|4P|1q|2p|4Q","o|3Q|4V|1q|2p|4W","o|3Q|4Z|1p|2p|4a","o|3Q|4e|1V|2p|4f","o|3Q|4h|1V|2p|4i","Whether list-like values are treated as unordered.","o|3Q|4n|1V|2p|6c","The math expression value.","o|3Q|3a|H|2p|6e","The numeric value of the expression (NaN if not a number).","o|3Q|1p|1p|2p|6g","Whether the expression evaluates to a finite number.","o|3Q|Y|1V|2p|6i","isNumeric","Whether the expression evaluates to any number (including infinities).","o|3Q|6k|1V|2p|6l","The expression rendered as a LaTeX string.","o|3Q|2V|2V|2p|6n","The expression rendered as a plain text string.","o|3Q|1T|1T|2p|6p","numDimensions","The number of dimensions if the math expression is interpreted as a vector or matrix.","o|3Q|6r|1q|2p|6s","indexedArrayDescription","a|3|2g|3J|2f|6r|6u","The math expression interpreted as a vector (its components).","a|3J|2g","o|6x|2p|1h","a|6y","o|6v|1h|1X|3M|6w|36|6z","list","The math expression interpreted as a list (its elements).","a|3J|2g|6r","o|73|3M|1X|36","a|74","o|6v|71|1X|3M|72|36|75","matrixSize","The size of the math expression as a matrix, as a [numRows, numColumns] list.","o|3Q|77|1a|2p|78","numRows","The number of rows when the math expression is interpreted as a matrix.","o|3Q|7A|1q|2p|7B","numColumns","The number of columns when the math expression is interpreted as a matrix.","o|3Q|7D|1q|2p|7E","The math expression interpreted as a matrix (its entries by row and column).","o|6x|2p|2U","a|7H|7H","o|6v|2U|1X|3M|7G|4X|7I","rows","The matrix\'s entries grouped by row.","o|6v|7K|1X|3M|7L|4X|7I","columns","The matrix\'s entries grouped by column.","o|6v|7N|1X|3M|7O|4X|7I","x","The first component of the math expression when interpreted as a vector.","o|3Q|7Q|1X|2p|7R","y","The second component of the math expression when interpreted as a vector.","o|3Q|7T|1X|2p|7U","z","The third component of the math expression when interpreted as a vector.","o|3Q|7W|1X|2p|7X","numListItems","The number of items when the math expression is interpreted as a list.","o|3Q|7Z|1q|2p|7a","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|6f|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A right-hand-side expression of an equation in an ODE system","o|F|H|3j|3k|3l|64|7c|3M|3M|2p|H|7d|3h","for","Reference to the component this label is for (e.g., an input).","o|2h|7f|7g|3D","forObject","Reference to the graphical object this label is attached to.","o|2h|7i|7j|3D","Whether the label can be dragged on a graph.","o|2m|5L|7l|3M|2s|1V","maskLabel","Whether to give the label an opaque background so it stays legible when it overlaps an axis, grid line, or another object.","o|2m|7n|7o|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|7h|7k|7m|5R|7p|5X|63","o|3L|5L|1V|2p|7l|3M","o|3L|7n|1V|2p|7o|3M","hasLatex","Whether the label contains LaTeX content.","o|3Q|7t|1V|2p|7u","The label\'s text content.","o|3Q|1T|1T|2p|7w","The label\'s content as a LaTeX string.","o|3Q|2V|2V|2p|7y","The label\'s content as a label-typed value.","o|3Q|3a|I|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|81","A label for the x-axis of a graph","o|F|I|2Z|2a|3l|7q|82|3M|3M|2p|I|83|3h","o|3Q|3a|J|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|85","A label for the y-axis of a graph","o|F|J|2Z|2a|3l|7q|86|3M|3M|2p|J|87|3h","statement","introduction","conclusion","hr","section","subsection","subsubsection","paragraphs","aside","objectives","problem","exercise","question","activity","example","definition","note","theorem","part","task","proof","problems","exercises","ol","ul","cobwebPolyline","equilibriumCurve","orbitalDiagram","orbitalDiagramInput","sideBySide","sbsGroup","stack","div","pre","paginator","paginatorControls","solution","givenAnswer","document","p","lineSegment","ray","polyline","polygon","triangle","rectangle","regularPolygon","circle","parabola","curve","award","graph","annotations","annotation","slider","spreadsheet","row","column","cellBlock","tabular","table","figure","pegboard","variantControl","animateFromSequence","image","video","hint","feedback","moduleAttributes","setup","caption","subsetOfRealsInput","regionBetweenCurveXAxis","regionBetweenCurves","regionHalfPlane","codeEditor","legend","eigenDecomposition","blockQuote","stickyGroup","pretzel","cascade","a|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|1z|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","_block","a|9W|2d","aggregateScores","Whether to aggregate scores of scored descendants into a section credit-achieved value.","scoring","o|4d|9Y|9Z|9a|2p|2s|1V","weight","Relative weight of this section when aggregated by an enclosing scored section.","o|4U|9c|9d|9a|36|1p","sectionWideCheckWork","Whether to show a single section-wide check-work button instead of per-answer buttons.","o|4d|9f|9g|9a|2p|2s|1V","maxNumAttempts","Maximum number of times the section-wide check-work button can be submitted. Once reached, all enclosed answers are disabled.","Infinity","o|4U|9i|9j|9a|9k|1q","showCorrectness","Whether to display correctness indicators for the answers it contains.","o|4d|9m|9n|9a|3M|2s|1V","colorCorrectness","Whether to color-code the answers it contains based on correctness.","o|4d|9p|9q|9a|3M|2s|1V","colorAnswersSeparately","When section-wide check work is enabled, color each answer based on its own correctness rather than the section\'s overall credit.","o|4d|9s|9t|9a|2p|2s|1V","submitLabel","Label for the section-wide submit button when correctness is shown.","Check Work","o|4U|9v|9w|9a|9x|1T","submitLabelNoCorrectness","Label for the section-wide submit button when correctness is not shown.","Submit Response","o|4U|9z|A0|9a|A1|1T","displayDigitsForCreditAchieved","Number of significant digits to display for the credit achieved value.","o|4U|A3|A4|9a|4S|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5","o|6J|9c|1p|2p|9d|3M|9a","o|6J|9f|1V|2p|9g|3M|9a","o|6J|9i|1q|2p|9j|3M|9a","o|6J|9v|1T|2p|9w|3M|9a","o|6J|9z|1T|2p|A0|3M|9a","o|6J|A3|1q|2p|A4|3M|9a","numSubmissions","Number of times the section-wide check-work button has been submitted.","o|3Q|AD|1q|2p|AE","numAttemptsLeft","Remaining number of section-wide submissions before the maximum is reached.","o|3Q|AG|1q|2p|AH","Whether scores of scored descendants are aggregated into this section\'s credit value.","o|3Q|9Y|1V|2p|AJ","creditAchieved","Aggregate credit achieved (between 0 and 1) for scored descendants of this section.","o|3Q|AL|1p|2p|AM","percentCreditAchieved","Aggregate credit achieved as a percentage (between 0 and 100).","o|3Q|AO|1p|2p|AP","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ","A block container for the statement of a problem, theorem, or similar","block","o|F|89|9U|9V|9X|A6|AR|3M|3M|2p|89|AS|AT","A block container for the introduction of a section","o|F|8A|9U|9V|9X|A6|AR|3M|3M|2p|8A|AV|AT","A block container for the conclusion of a section","o|F|8B|9U|9V|9X|A6|AR|3M|3M|2p|8B|AX|AT","","a|3N|3O|3P|3T|3U|3V|3W|3Z","A line break","o|F|K|54|AZ|3l|3I|Aa|3M|2p|2p|K|Ab|3h","A horizontal rule used to separate content","o|F|8C|54|AZ|9X|3I|Aa|3M|2p|2p|8C|Ad|AT","cascadeMessage","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|8W|8X","1111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222221222122222111211112122211221111122200","The paragraph\'s text content.","o|3Q|1T|1T|2p|Ai","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|Aj","Placeholder shown inside a `<cascade>` in place of a not-yet-revealed entry","o|F|Af|Ag|Ah|9X|A6|Ak|2p|3M|2p|Af|Al|AT","else","a|2d","a|3|2f|2l|2g","condition","Boolean expression; this case is selected when the condition is true.","o|Ap|Aq|Ar|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|As","conditionSatisfied","Whether this case\'s condition is currently satisfied.","o|3Q|Au|1V|2p|Av","a|3N|3O|3P|3T|3U|3V|3W|3Z|Aw","Default branch within a `<conditionalContent>`; matched when no `<case>` condition is true","other","o|F|An|9U|9V|Ao|At|Ax|2p|3M|2p|An|Ay|Az","Whether the math display can be dragged on a graph.","o|2m|5L|B1|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63","o|3L|5L|1V|2p|B1|3M","The math content rendered as a LaTeX string.","o|3Q|2V|2V|2p|B5","The math content rendered as a plain text string.","o|3Q|1T|1T|2p|B7","The math content as a math expression.","o|3Q|1X|1X|2p|B9","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA","Inline math rendered with LaTeX","o|F|L|2Z|2a|3l|B3|BB|3M|3M|2p|L|BC|3h","Display math rendered with LaTeX","o|F|M|2Z|2a|3l|B3|BB|3M|3M|2p|M|BE|3h","equationTag","The equation number (when numbered).","o|3Q|BG|1T|2p|BH","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA|BI","Numbered display math rendered with LaTeX","o|F|N|2Z|2a|3l|B3|BJ|3M|3M|2p|N|BK|3h","a|Q|1z","02","a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8","Display math with multiple aligned rows","o|F|O|BM|BN|3l|B3|BO|3M|2p|2p|O|BP|3h","Numbered display math with multiple aligned rows","o|F|P|BM|BN|3l|B3|BO|3M|2p|2p|P|BR|3h","Whether to attach an equation number to this row.","o|Ap|1p|BT|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63|BU","A row of math within an aligned display","o|F|Q|2Z|2a|3l|BV|BJ|3M|3M|2p|Q|BW|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a","1222211111111111111111111112221222221220202222122222012212222122222111221211222221111111110212120","_booleanOperatorOneInput","a|Ba|2c|2d","symbolicEquality","Whether children compared via this boolean use symbolic equality.","o|2m|Bc|Bd|2p|2s|1V","expandOnCompare","Whether to expand math expressions before comparing.","o|2m|Bf|Bg|2p|2s|1V","a|3|2f|2k|2l|3n|2g","simplifyOnCompare","Level of simplification applied to math expressions before comparing.","No simplification is applied before comparing.","o|3s|42|Bl","Fully simplify both expressions before comparing.","o|3s|43|Bn","a|Bm|Bo|4D|4F|4H","o|Bi|Bj|Bk|42|47|Bp|3y","unorderedCompare","Whether order is ignored when comparing list-like values.","o|2m|Br|Bs|2p|2s|1V","matchByExactPositions","Whether to match list values by exact position rather than by content.","o|2m|Bu|Bv|2p|2s|1V","allowedErrorInNumbers","Maximum allowed numeric error when comparing numbers.","o|33|Bx|By|5Q|1p","includeErrorInNumberExponents","Whether the allowed numeric error also applies to numbers in exponents.","o|2m|C0|C1|2p|2s|1V","allowedErrorIsAbsolute","Whether allowedErrorInNumbers is interpreted as an absolute (rather than relative) tolerance.","o|2m|C3|C4|2p|2s|1V","numSignErrorsMatched","Maximum number of sign errors that still count as a match.","o|33|C6|C7|5Q|1p","numPeriodicSetMatchesRequired","Number of consecutive elements of a periodic set required to count as a match.","o|33|C9|CA|4S|1q","caseInsensitiveMatch","Whether text comparisons ignore letter case.","o|2m|CC|CD|2p|2s|1V","matchBlanks","Whether unfilled blanks in a math expression count as a match.","o|2m|CF|CG|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH","o|3L|Bc|1V|2p|Bd|3M","o|3L|Bf|1V|2p|Bg|3M","o|3L|Bj|1T|2p|Bk|3M","o|3L|Br|1V|2p|Bs|3M","o|3L|Bu|1V|2p|Bv|3M","o|3L|Bx|1p|2p|By|3M","o|3L|C0|1V|2p|C1|3M","o|3L|C3|1V|2p|C4|3M","o|3L|C6|1p|2p|C7|3M","o|3L|C9|1q|2p|CA|3M","o|3L|CC|1V|2p|CD|3M","o|3L|CF|1V|2p|CG|3M",\'The boolean rendered as a text string ("true" or "false").\',"o|3Q|1T|1T|2p|CV","The boolean result of applying this operator to its single boolean input.","o|3Q|3a|1V|2p|CX","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|CW|CY","Logical negation of a boolean value","o|F|R|BY|BZ|Bb|CI|CZ|3M|3M|2p|R|Ca|3h","a|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|1z|2R|2T","111111111022211","_booleanOperator","a|Ce|2c|2d","The boolean result of applying this operator to its child boolean values.","o|3Q|3a|1V|2p|Cg","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Ch|CW","Logical AND: true only when all child boolean values are true","o|F|S|Cc|Cd|Cf|CI|Ci|3M|3M|2p|S|Cj|3h","Logical OR: true when at least one child boolean value is true","o|F|T|Cc|Cd|Cf|CI|Ci|3M|3M|2p|T|Cl|3h","Logical exclusive OR: true when exactly one child boolean value is true","o|F|U|Cc|Cd|Cf|CI|Ci|3M|3M|2p|U|Cn|3h","IF and only iF: Logical bicondition (IFF): true when all child boolean values are the same","o|F|V|Cc|Cd|Cf|CI|Ci|3M|3M|2p|V|Cp|3h","Logical implication (binary): true when the first value is false or the second value is true","o|F|W|Cc|Cd|Cf|CI|Ci|3M|3M|2p|W|Cr|3h","_booleanOperatorOfMath","a|Ct|2c|2d","The boolean result of applying this operator to its child math values.","o|3Q|3a|1V|2p|Cv","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Cw|CW","True when the math child evaluates to an integer","o|F|X|3j|3k|Cu|CI|Cx|3M|3M|2p|X|Cy|3h","True when the math child evaluates to a finite number","o|F|Y|3j|3k|Cu|CI|Cx|3M|3M|2p|Y|D0|3h","limits","Numeric limits used by the boolean operator (e.g. bounds for isBetween).","o|33|D2|D3|54|1a","strict","Whether the comparison is strict (e.g. uses < instead of ≤).","o|2m|D5|D6|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|D4|D7","o|3L|D2|1a|2p|D3|3M","o|3L|D5|1V|2p|D6|3M","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|D9|DA|3T|3U|3V|3W|3Z|Cw|CW","True when a math value is between two given bounds","o|F|Z|3j|3k|Cu|D8|DB|3M|3M|2p|Z|DC|3h","1222211111111111111111111112222222221222202222122222012212222122222122221212222","_mathOperator","a|DF|2c|2d","forceSymbolic","Whether to force the operator to evaluate symbolically rather than numerically.","o|2m|DH|DI|2p|2s|1V","forceNumeric","Whether to force the operator to evaluate numerically rather than symbolically.","o|2m|DK|DL|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM","o|3L|DH|1V|2p|DI|3M","o|3L|DK|1V|2p|DL|3M","o|3Q|3a|a|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DQ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Sum of the child math or number values","o|F|a|3j|DE|DG|DN|DR|3M|3M|2p|a|DS|3h","o|3Q|3a|b|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DU|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Product of the child math or number values","o|F|b|3j|DE|DG|DN|DV|3M|3M|2p|b|DW|3h","_mathOperatorOneInput","a|DY|2c|2d","lowerValue","Lower bound used by the operator.","o|33|Da|Db|5Q|1p","upperValue","Upper bound used by the operator.","o|33|Dd|De|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dc|Df","o|3L|Da|1p|2p|Db|3M","o|3L|Dd|1p|2p|De|3M","o|3Q|3a|c|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Clamps a number to a specified range","o|F|c|3j|3k|DZ|Dg|Dk|3M|3M|2p|c|Dl|3h","o|3Q|3a|d|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dn|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Wraps a number into a periodic range","o|F|d|3j|3k|DZ|Dg|Do|3M|3M|2p|d|Dp|3h","n|E","o|4O|4P|4Q|4R|3M|Dr|1q","numDecimals","Number of decimal places (for round-style operators).","o|33|Dt|Du|5Q|1p","numDigits","Number of significant digits (for round-style operators).","o|33|Dw|Dx||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|Ds|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dv|Dy","o|3L|Dt|1p|2p|Du|3M","o|3L|Dw|1p|2p|Dx|3M","o|3Q|3a|e|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|E0|E1|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|E2|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Rounds a number to a specified precision","o|F|e|3j|3k|DZ|Dz|E3|3M|3M|2p|e|E4|3h","threshold","Threshold value used by the operator.","o|33|E6|E7|4b|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|E8","o|3L|E6|1p|2p|E7|3M","o|3Q|3a|f|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|EA|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Replaces values with magnitude below a threshold with zero","o|F|f|3j|3k|DZ|E9|EC|3M|3M|2p|f|ED|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|g|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|EG|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Converts a math set expression into a list expression","o|F|g|3j|3k|DZ|EF|EH|3M|3M|2p|g|EI|3h","o|3Q|3a|h|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EK|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Smallest integer ≥ the input value","o|F|h|3j|3k|DZ|64|EL|3M|3M|2p|h|EM|3h","o|3Q|3a|i|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EO|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Largest integer ≤ the input value","o|F|i|3j|3k|DZ|64|EP|3M|3M|2p|i|EQ|3h","o|3Q|3a|j|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ES|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Absolute value of an expression","o|F|j|3j|3k|DZ|64|ET|3M|3M|2p|j|EU|3h","o|3Q|3a|k|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EW|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Sign of the input (-1, 0, or 1)","o|F|k|3j|3k|DZ|64|EX|3M|3M|2p|k|EY|3h","o|3Q|3a|l|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ea|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Arithmetic mean of the child math or number values","o|F|l|3j|DE|DG|DN|Eb|3M|3M|2p|l|Ec|3h","o|3Q|3a|m|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ee|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Median of the child math or number values","o|F|m|3j|DE|DG|DN|Ef|3M|3M|2p|m|Eg|3h","population","Whether to use the population formula (rather than sample).","o|2m|Ei|Ej|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM|Ek","o|3L|Ei|1V|2p|Ej|3M","o|3Q|3a|n|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|En|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Variance of the child math or number values","o|F|n|3j|DE|DG|El|Eo|3M|3M|2p|n|Ep|3h","o|3Q|3a|o|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Er|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Standard deviation of the child math or number values","o|F|o|3j|DE|DG|El|Es|3M|3M|2p|o|Et|3h","o|3Q|3a|p|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ev|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","The number of the child math or number values","o|F|p|3j|DE|DG|DN|Ew|3M|3M|2p|p|Ex|3h","o|3Q|3a|q|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ez|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Minimum of the child math or number values","o|F|q|3j|DE|DG|DN|F0|3M|3M|2p|q|F1|3h","o|3Q|3a|r|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F3|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Maximum of the child math or number values","o|F|r|3j|DE|DG|DN|F4|3M|3M|2p|r|F5|3h","o|3Q|3a|s|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F7|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Modulo (remainder) of two values","o|F|s|3j|DE|DG|DN|F8|3M|3M|2p|s|F9|3h","o|3Q|3a|t|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Greatest common divisor of integer inputs","o|F|t|3j|DE|DG|DN|FC|3M|3M|2p|t|FD|3h","o|3Q|3a|u|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FF|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Least common multiple of integer inputs","o|F|u|3j|DE|DG|DN|FG|3M|3M|2p|u|FH|3h","What kind of sub-expression to extract.","operand","functionArgument","numOperands","recursiveOperands","a|FK|1r|FL|FM|FN","Extract a single operand of the top-level operation.","o|3s|FK|FP","Extract the function being applied (for a function call).","o|3s|1r|FR","Extract an argument of the function being called.","o|3s|FL|FT","Extract the count of operands at the top level.","o|3s|FM|FV","Extract all operands found recursively through nested operations.","o|3s|FN|FX","a|FQ|FS|FU|FW|FY","o|Bi|2g|FJ||FO|FZ|3y","operandNumber","1-based index of the operand to extract.","o|33|Fb|Fc||1p","argumentNumber","1-based index of the argument to extract.","o|33|Fe|Ff||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Fa|Fd|Fg","o|3L|Fb|1p|2p|Fc|3M","o|3L|Fe|1p|2p|Ff|3M","o|3Q|3a|v|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Fi|Fj|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Fk|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Extracts a sub-expression from a math expression by name or index","o|F|v|3j|3k|DZ|Fh|Fl|3M|3M|2p|v|Fm|3h","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|2S","1222211111111111111111111111112222221222202222122222220112222122222122221212222110","_functionOperator","a|Fq|2c|2d","Level of simplification applied to the function\'s formula.","Fully simplify the function\'s formula.","o|3s|43|Ft","a|49|Fu|4D|4F|4H","o|Bi|40|Fs|43|47|Fv|3y","Whether to expand the function\'s formula.","o|2m|4K|Fx|2p|2s|1V","xscale","Scale factor used along the x-axis.","o|33|Fz|G0|36|1p","yscale","Scale factor used along the y-axis.","o|33|G2|G3|36|1p","numInputs","Number of input arguments the function accepts.","o|2h|G5|G6|1q","numOutputs","Number of output values the function produces.","o|33|G8|G9|36|1q","domain","Restriction of the function\'s domain to a list of intervals.","o|2h|GB|GC|2X","labelIsName","Whether to use this component\'s name as its rendered label.","labels","o|4d|GE|GF|GG|2p|2s|1V","applyStyleToLabel","Whether to apply the function\'s style to its label.","o|2m|GI|GJ|2p|2s|1V","labelPosition","Position of the function\'s label.","a|5c|5d|5e|5f|9|5g|5h|5i","Place the label above and to the right of the function curve.","o|3s|5c|GO","Place the label above and to the left of the function curve.","o|3s|5d|GQ","Place the label below and to the right of the function curve.","o|3s|5e|GS","Place the label below and to the left of the function curve.","o|3s|5f|GU","Place the label directly above the function curve.","o|3s|9|GW","Place the label directly below the function curve.","o|3s|5g|GY","Place the label directly to the left of the function curve.","o|3s|5h|Ga","Place the label directly to the right of the function curve.","o|3s|5i|Gc","a|GP|GR|GT|GV|GX|GZ|Gb|Gd","o|Bi|GL|GM|5c|GN|Ge|3y","Z-order layer index for stacking the function on a graph.","o|33|5O|Gg|5Q|1p","minima","Local minima of an interpolated function.","extrema","o|2h|Gi|Gj|Gk","maxima","Local maxima of an interpolated function.","o|2h|Gm|Gn|Gk","Local extrema (combined minima and maxima) of an interpolated function.","o|2h|Gk|Gp|Gk","through","Points the interpolated function should pass through.","o|2h|Gr|Gs|2W","throughSlopes","Slopes the interpolated function should have at each through-point.","o|2h|Gu|Gv|1Y","variables","Names of the function\'s input variables.","_variableNameList","o|2h|Gx|Gy|Gz","variable","Name of the function\'s single input variable.","_variableName","o|2h|H1|H2|H3","symbolic","Whether the function should be evaluated symbolically rather than numerically.","o|2m|H5|H6|3M|2s|1V","o|4U|4P|4Q|4R|4S|1q","nearestPointAsCurve","Whether nearest-point queries should treat the function as a curve in the plane rather than a graph y = f(x).","o|2m|H9|HA|2p|2s|1V","a|3|2f|2l|3n|2g","lineStyle","Stroke style for lines.","solid","dashed","dotted","a|HF|HG|HH","Continuous, unbroken stroke.","o|3s|HF|HJ","Stroke composed of evenly-spaced dashes.","o|3s|HG|HL","Stroke composed of evenly-spaced dots.","o|3s|HH|HN","a|HK|HM|HO","o|HC|HD|HE|HI|HP|3y","lineWidth","Stroke width for lines, in pixels.","o|2h|HR|HS|1p","Lower bound for the operator\'s range.","o|33|Da|HU|5Q|1p","Upper bound for the operator\'s range.","o|33|Dd|HW|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|HV|HX","expandSpecified","o|3Q|HZ|1V|2p|Fx","o|3L|Fz|1p|2p|G0|3M","o|3L|G2|1p|2p|G3|3M","o|6J|GE|1V|2p|GF|3M|GG","o|3L|GI|1V|2p|GJ|3M","o|3L|GL|1T|2p|GM|3M","o|3L|5O|1p|2p|Gg|3M","o|3L|Da|1p|2p|HU|3M","o|3L|Dd|1p|2p|HW|3M","The label rendered with this component.","o|6U|2S|2S|2p|Hj|GG","styleDescription","A textual description of the function\'s style.","o|3Q|Hl|1T|2p|Hm","styleDescriptionWithNoun",\'Style description including the word "function".\',"o|3Q|Ho|1T|2p|Hp","Number of input variables of the function.","o|3Q|G5|1q|2p|Hr","Number of output values of the function.","o|3Q|G8|1q|2p|Ht","Domain interval(s) of the function.","o|73|3M|1t|36","a|Hw","o|6v|GB|1t|3M|Hv|36|Hx","Level of simplification applied when displaying the formula.","o|3Q|40|1T|2p|Hz","Whether to expand the formula.","o|3Q|4K|1T|2p|I1","Whether the function is treated symbolically.","o|3Q|H5|1V|2p|I3","The names of the function\'s input variables.","o|73|3M|H3|36","a|I6","o|6v|Gx|H3|3M|I5|36|I7","formula","The symbolic formula of the function produced by this operator.","o|3Q|I9|1X|2p|IA","The function rendered as a LaTeX string.","o|3Q|2V|2V|2p|IC","The function rendered as a plain text string.","o|3Q|1T|1T|2p|IE","numMinima","Number of local minima of the function.","o|3Q|IG|1p|2p|IH","Local minima of the function.","o|73|3M|1d|36","o|6x|2p|1d","a|IK|IL","o|6v|Gi|1p|3M|IJ|4X|IM","minimumLocations","The x-coordinates of the function\'s local minima.","o|73|3M|1p|36","a|IQ","o|6v|IO|1p|3M|IP|36|IR","minimumValues","The values of the function\'s local minima.","o|6v|IT|1p|3M|IU|36|IR","globalMinimum","The global minimum of the function (if attained).","a|IL","o|6v|IW|1p|3M|IX|36|IY","globalInfimum","The global infimum of the function.","o|6v|Ia|1p|3M|Ib|36|IY","numMaxima","Number of local maxima of the function.","o|3Q|Id|1p|2p|Ie","Local maxima of the function.","o|6v|Gm|1p|3M|Ig|4X|IM","maximumLocations","The x-coordinates of the function\'s local maxima.","o|6v|Ii|1p|3M|Ij|36|IR","maximumValues","The values of the function\'s local maxima.","o|6v|Il|1p|3M|Im|36|IR","globalMaximum","The global maximum of the function (if attained).","o|6v|Io|1p|3M|Ip|36|IY","globalSupremum","The global supremum of the function.","o|6v|Ir|1p|3M|Is|36|IY","numExtrema","Number of local extrema (minima + maxima) of the function.","o|3Q|Iu|1p|2p|Iv","Local extrema (minima + maxima) of the function.","o|6v|Gk|1p|3M|Ix|4X|IM","extremumLocations","The x-coordinates of the function\'s local extrema.","o|6v|Iz|1p|3M|J0|36|IR","extremumValues","The values of the function\'s local extrema.","o|6v|J2|1p|3M|J3|36|IR","The function\'s first input variable name.","o|3Q|H1|H3|2p|J5","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|Hh|Hi|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A function clamped to a specified output range","o|F|w|Fo|Fp|Fr|HY|J7|3M|3M|2p|w|J8|3h","A function wrapped into a periodic output range","o|F|x|Fo|Fp|Fr|HY|J7|3M|3M|2p|x|JA|3h","derivVariables","Names of variables to differentiate with respect to.","o|2h|JC|JD|Gz","derivVariable","Name of the variable to differentiate with respect to.","o|2h|JF|JG|H3","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|JE|JH","Number of input variables.","o|3Q|G5|1q|2p|JJ","Names of the input variables.","o|6v|Gx|H3|3M|JL|36|I7","numDerivatives","Number of derivatives applied.","o|3Q|JN|1q|2p|JO","Variables with respect to which derivatives are taken.","o|6v|JC|H3|3M|JQ|36|I7","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|Hu|Hy|I0|I2|I4|JM|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|JP|JR|J6","The derivative of a function","o|F|y|Fo|Fp|Fr|JI|JS|3M|3M|2p|y|JT|3h","_textOperatorOfMath","a|JV|2c|2d","Whether the text can be dragged on a graph.","o|2m|5L|JX|3M|2s|1V","isLatex","Whether the text content is treated as LaTeX.","o|2m|JZ|Ja|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63","o|3L|5L|1V|2p|JX|3M","o|3L|JZ|1V|2p|Ja|3M","The text result of applying this operator to its child math values.","o|3Q|3a|1T|2p|Jf","The text rendered as a plain text string.","o|3Q|1T|1T|2p|Jh","The text parsed as a math expression.","o|3Q|1X|1X|2p|Jj","The text parsed as a number.","o|3Q|1p|1p|2p|Jl","numWords","The number of words in the text value.","o|3Q|Jn|1q|2p|Jo","words","The text value split into words.","o|73|3M|1T|36","a|Js","o|6v|Jq|1T|3M|Jr|36|Jt","numCharacters","The number of characters (graphemes) in the text value.","o|3Q|Jv|1q|2p|Jw","characters","The text value split into characters (graphemes).","o|6v|Jy|1T|3M|Jz|36|Jt","The number of comma-separated items when the text is interpreted as a list.","o|3Q|7Z|1q|2p|K1","The text value split into items at commas.","o|6v|71|1T|3M|K3|36|Jt","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|Jg|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4",\'Returns the top-level operator of a math expression as text (e.g. "+", "vector")\',"o|F|z|3j|3k|JW|Jc|K5|3M|2p|2p|z|K6|3h","_inlineRenderInlineChildren","a|K8|2c|2d","The combined text content of this component\'s children, with optional begin/end delimiters.","o|3Q|1T|1T|2p|KA","a|3N|3O|3P|3T|3U|3V|3W|3Z|KB","Emphasized inline text (italic by default)","o|F|10|2Z|2a|K9|3I|KC|3M|3M|2p|10|KD|3h","Bold text","o|F|11|2Z|2a|K9|3I|KC|3M|3M|2p|11|KF|3h","Inline double-quoted text","o|F|12|2Z|2a|K9|3I|KC|3M|3M|2p|12|KH|3h","Inline single-quoted text","o|F|13|2Z|2a|K9|3I|KC|3M|3M|2p|13|KJ|3h","An inline term, styled distinctively","o|F|14|2Z|2a|K9|3I|KC|3M|3M|2p|14|KL|3h","Inline code text","o|F|15|2Z|2a|K9|3I|KC|3M|3M|2p|15|KN|3h","Renders enclosed text as an opening tag, `< >`","o|F|16|2Z|2a|K9|3I|KC|3M|3M|2p|16|KP|3h","Renders enclosed text as a self-closing tag, `< />`","o|F|17|2Z|2a|K9|3I|KC|3M|3M|2p|17|KR|3h","Renders enclosed text as a closing tag, `</ >`","o|F|18|2Z|2a|K9|3I|KC|3M|3M|2p|18|KT|3h","Renders a styled attribute name","o|F|19|2Z|2a|K9|3I|KC|3M|3M|2p|19|KV|3h","_singleCharacterInline","a|KX|2c|2d","The unicode character rendered by this component.","o|3Q|1T|1T|2p|KZ","a|3N|3O|3P|3T|3U|3V|3W|3Z|Ka","Renders an en-dash (–) character","o|F|1A|54|AZ|KY|3I|Kb|3M|2p|2p|1A|Kc|3h","Renders an em-dash (—) character","o|F|1B|54|AZ|KY|3I|Kb|3M|2p|2p|1B|Ke|3h","Renders a non-breaking space character","o|F|1C|54|AZ|KY|3I|Kb|3M|2p|2p|1C|Kg|3h","Renders a horizontal ellipsis (…) character","o|F|1D|54|AZ|KY|3I|Kb|3M|2p|2p|1D|Ki|3h","Renders a left double quotation mark (“)","o|F|1E|54|AZ|KY|3I|Kb|3M|2p|2p|1E|Kk|3h","Renders a right double quotation mark (”)","o|F|1F|54|AZ|KY|3I|Kb|3M|2p|2p|1F|Km|3h","Renders a left single quotation mark (‘)","o|F|1G|54|AZ|KY|3I|Kb|3M|2p|2p|1G|Ko|3h","Renders a right single quotation mark (’)","o|F|1H|54|AZ|KY|3I|Kb|3M|2p|2p|1H|Kq|3h","styleDefinition","feedbackDefinition","a|1z|9A|G|9H|Ks|Kt|Af|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1000000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","_sectioningComponentNumberWithSiblings","_sectioningComponent","a|Kw|Kx|9W|2d","boxed","Whether to render this section with a visible box around it.","o|2m|Kz|L0|2p|2s|1V","includeAutoName",\'Whether to include the auto-generated section name (e.g. "Section") in the rendered title.\',"o|2m|L2|L3|2p|2s|1V","includeAutoNumber","Whether to include the auto-generated section number in the rendered title.","o|2m|L5|L6|2p|2s|1V","noAutoTitle","Whether to suppress the auto-generated title entirely.","o|2m|L8|L9|2p|2s|1V","includeAutoNameIfNoTitle","Whether to include the auto-generated name when no explicit title is provided.","o|2m|LB|LC|3M|2s|1V","includeAutoNumberIfNoTitle","Whether to include the auto-generated number when no explicit title is provided.","o|2m|LE|LF|3M|2s|1V","Whether to render this section\'s children as a list.","o|2m|20|LH|2p|2s|1V","collapsible","Whether the section can be collapsed and expanded.","o|2m|LJ|LK|2p|2s|1V","startOpen","Whether the collapsible section starts in the open state.","o|2m|LM|LN|3M|2s|1V","level","The heading level for this section (overrides the default level inferred from nesting).","o|2h|LP|LQ|1q","completedColor","Color used to indicate this section has been completed.","var(--lightGreen)","o|33|LS|LT|LU|1T","inProgressColor","Color used to indicate this section is in progress.","var(--mainGray)","o|33|LW|LX|LY|1T","notStartedColor","Color used to indicate this section has not been started.","o|33|La|Lb|LY|1T","completedColorDarkMode","Color used to indicate this section has been completed (dark mode). If omitted, the dark-mode color is derived from `completedColor` when that attribute is explicitly set; otherwise falls back to a dark green that meets WCAG AA contrast for white text.","#1a5e20","o|33|Ld|Le|Lf|1T","inProgressColorDarkMode","Color used to indicate this section is in progress (dark mode). If omitted, the dark-mode color is derived from `inProgressColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.","#3a3a3a","o|33|Lh|Li|Lj|1T","notStartedColorDarkMode","Color used to indicate this section has not been started (dark mode). If omitted, the dark-mode color is derived from `notStartedColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.","o|33|Ll|Lm|Lj|1T","includeParentNumber","Whether to prefix this section\'s number with the parent section\'s number.","o|2m|Lo|Lp|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|Lq","o|3L|L2|1V|2p|L3|3M","o|3L|L5|1V|2p|L6|3M","o|3L|L8|1V|2p|L9|3M","o|3L|LB|1V|2p|LC|3M","o|3L|LE|1V|2p|LF|3M","o|3L|20|1V|2p|LH|3M","o|3L|LJ|1V|2p|LK|3M","o|3L|Lo|1V|2p|Lp|3M","Whether this section is rendered with a visible box around it.","o|3Q|Kz|1V|2p|M0","sectionNumber","The displayed number for this section.","o|3Q|M2|1T|2p|M3","The displayed title text for this section.","o|3Q|G|1T|2p|M5","open","Whether this section is currently open (for collapsible sections).","o|3Q|M7|1V|2p|M8","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|Lz|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9","A section of a document, with a title (auto-generated or custom) and content","o|F|8D|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8D|MB|AT","A sectional component nested one heading level deeper than `<section>`","o|F|8E|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8E|MD|AT","A sectional component nested one heading level deeper than `<subsection>`","o|F|8F|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8F|MF|AT","o|2m|Lo|Lp|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH","A subsection of paragraphs (rendered at heading level 4)","o|F|8G|Ku|Kv|Ky|MI|MA|3M|3M|2p|8G|MJ|AT","o|2m|LJ|LK|3M|2s|1V","o|2m|LM|LN|2p|2s|1V","postponeRendering","Whether to delay rendering this section\'s contents until expanded.","o|Ap|MN|MO|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|ML|MM|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|MP","A note set off from the main flow of the document","o|F|8H|Ku|Kv|Ky|MQ|MA|3M|3M|2p|8H|MR|AT","o|2m|Kz|L0|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|MT|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH","A section listing learning objectives","o|F|8I|Ku|Kv|Ky|MU|MA|3M|3M|2p|8I|MV|AT","o|4d|9Y|9Z|9a|3M|2s|1V","isDistractor","Whether this section is a distractor (e.g. a wrong-answer choice for matching).","o|Ap|MY|MZ|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|MX|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|Ma","A sectional component that defines a scored problem","o|F|8J|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8J|Mc|AT","A sectional component that defines a scored exercise","o|F|8K|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8K|Me|AT","A sectional component that defines a scored question; similar to a `<problem>`","o|F|8L|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8L|Mg|AT","A sectional component with score aggregation, similar to `<problem>`","o|F|8M|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8M|Mi|AT","A sectional component that defines an example","o|F|8N|Ku|Kv|Ky|MI|MA|3M|3M|2p|8N|Mk|AT","A sectional component for defining a term or concept","o|F|8O|Ku|Kv|Ky|MI|MA|3M|3M|2p|8O|Mm|AT","A note section, set off from the main flow of the document","o|F|8P|Ku|Kv|Ky|MI|MA|3M|3M|2p|8P|Mo|AT","A sectional component for the statement of a theorem (or similar formal statement)","o|F|8Q|Ku|Kv|Ky|MI|MA|3M|3M|2p|8Q|Mq|AT","A subsection-style block rendered as a list item (a part of an exercise or problem)","o|F|8R|Ku|Kv|Ky|MI|MA|3M|3M|2p|8R|Ms|AT","A task of a multi-task activity or problem (alias for `<part>`)","o|F|8S|Ku|Kv|Ky|MI|MA|3M|3M|2p|8S|Mu|AT","_unnumberedSectioningComponent","a|Mw|Kx|9W|2d","o|2m|LE|LF|2p|2s|1V","renameTo",\'Override the auto-generated section name (e.g. rename "Section" to a custom label).\',"o|2h|Mz|N0|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|My|LI|ML|MM|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|MP","The displayed number for this section (always null for unnumbered sections).","o|3Q|M2|1T|2p|N3","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|N4|M6|M9","A proof section","o|F|8T|Ku|Kv|Mx|N2|N5|3M|3M|2p|8T|N6|AT","a|Kx|9W|2d","o|2m|20|LH|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|N9|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9","A container element grouping `<problem>` components, which are rendered as a list by default","o|F|8U|Ku|Kv|N8|NA|NB|3M|3M|2p|8U|NC|AT","A container element grouping `<exercise>` components, which are rendered as a list by default","o|F|8V|Ku|Kv|N8|NA|NB|3M|3M|2p|8V|NE|AT","li","a|NG|1z","Nesting level of this list (1-based).","o|2h|LP|NI|1q","marker","Marker style for list items (e.g. \'disc\', \'circle\', \'1\', \'a\').","o|33|NK|NL||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|NJ|NM|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5","An ordered list","o|F|8W|NH|BN|9X|NN|AR|3M|2p|2p|8W|NO|AT","An unordered list","o|F|8X|NH|BN|9X|NN|AR|3M|2p|2p|8X|NQ|AT","The list\'s content rendered as plain text.","o|3Q|1T|1T|2p|NS","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|NT","A list item within `<ol>` / `<ul>`","o|F|NG|9U|9V|Ao|A6|NU|2p|3M|2p|NG|NV|Az","a|H|1z","independentVariable","The independent variable of the ODE system.","t","o|5H|1X|Na","o|33|NY|NZ|Nb|H3","initialIndependentVariableValue","The value of the independent variable at which the initial conditions are specified.","0","o|5H|1X|Nf","o|33|Nd|Ne|Ng|1X",\'How to format the rendered system of equations (e.g. "align").\',"align","o|33|4k|Ni|Nj|1T","chunkSize","Step-size chunk used when numerically integrating the system.","n|A","o|33|Nl|Nm|Nn|1p","tolerance","Numerical tolerance used by the integrator.","n|0.Q0u","o|33|Np|Nq|Nr|1p","maxIterations","Maximum number of iterations the integrator may perform.","n|G8","o|33|Nt|Nu|Nv|1p","hideInitialCondition","Whether to hide the initial condition from the rendered output.","o|2m|Nx|Ny|2p|2s|1V","initialConditions","The initial values of each dependent variable, in order.","o|2h|O0|O1|1Y","The dependent variables of the system, in the same order as the right-hand sides.","o|2h|Gx|O3|Gz","Whether to display equation numbers next to each equation.","o|2m|1p|O5|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Nc|Nh|H8|4Y|4c|4g|4j|Nk|No|Ns|Nw|Nz|O2|O4|O6","o|3L|NY|H3|2p|NZ|3M","o|3L|Nd|1X|2p|Ne|3M","o|3L|4k|1T|2p|Ni|3M","o|3L|Nl|1p|2p|Nm|3M","o|3L|Np|1p|2p|Nq|3M","o|3L|Nt|1p|2p|Nu|3M","o|3L|Nx|1V|2p|Ny|3M","o|3L|1p|1V|2p|O5|3M","The dependent variables of the system, in order matching the right-hand sides.","o|6v|Gx|H3|3M|OG|36|I7","rhss","The right-hand-side expressions of each ODE in the system.","o|6v|OI|1X|3M|OJ|36|75","The initial values of each dependent variable at the initial independent variable value.","o|6v|O0|1X|3M|OL|36|75","The displayed equation number tag (when equation numbering is enabled).","o|3Q|BG|1T|2p|ON","The full ODE system rendered as a LaTeX string.","o|3Q|2V|2V|2p|OP","numericalSolutions","Numerical solution functions for each dependent variable, as functions of the independent variable.","o|73|3M|1r|36","a|OT","o|6v|OR|1r|3M|OS|36|OU","rhs","The right-hand-side expression of the first ODE in the system.","o|3Q|OW|1X|2p|OX","righthandside","o|3Q|OZ|1X|2p|OX","righthandsides","o|6v|Ob|1X|3M|OJ|36|75","initialCondition","The initial value of the first dependent variable at the initial independent-variable value.","o|3Q|Od|1X|2p|Oe","numericalSolution","Numerical solution function for the first dependent variable, as a function of the independent variable.","o|3Q|Og|1r|2p|Oh","a|3N|3O|3P|O8|O9|OA|OB|OC|OD|OE|OF|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|OH|OK|OM|OO|OQ|OV|OY|Oa|Oc|Of|Oi","A system of first-order ordinary differential equations with initial conditions, rendered as math and numerically integrable","o|F|1I|NX|BN|3l|O7|Oj|3M|2p|2p|1I|Ok|3h","a|I|J|1z|2S","1120","_graphical","a|Oo|2d","Whether to apply this component\'s selected style to its label.","o|2m|GI|Oq|2p|2s|1V","Z-order layer index used to stack graphical components (higher values render on top).","o|33|5O|Os|5Q|1q","Whether the polyline can be dragged on a graph.","o|2m|5L|Ou|3M|2s|1V","verticesDraggable","Whether individual vertices may be dragged independently.","o|Ap|Ow|Ox|2s|1V","vertices","The list of vertex points that define the shape.","o|2h|Oz|P0|2W","showCoordsWhenDragging","Whether to show coordinate labels while dragging.","o|2m|P2|P3|3M|2s|1V","rigid","Whether the polyline is treated as rigid (preserves shape under drag).","o|2m|P5|P6|2p|2s|1V","preserveSimilarity","Whether the shape is preserved up to similarity (uniform scaling) under drag.","o|2m|P8|P9|2p|2s|1V","rotationHandleVertices","Vertex indices that should display rotation handles when the shape is rigid or preserves similarity.","a|36","o|33|PB|PC|PD|1a","rotateAround","What point to rotate the shape around.","centroid","vertex","a|PH|PI|1d","Rotate around the centroid of the shape.","o|3s|PH|PK","Rotate around the vertex specified by `rotationVertex`.","o|3s|PI|PM","Rotate around the explicit point given by `rotationCenter`.","o|3s|1d|PO","a|PL|PN|PP","o|Bi|PF|PG|PH|PJ|PQ|3y","rotationCenter","The point to rotate around when rotateAround is \'point\'.","o|33|PS|PT||1d","rotationVertex","The vertex index to rotate around when rotateAround is \'vertex\'.","o|33|PV|PW|36|1q","allowRotation","Whether the polyline can be rotated under drag.","o|2m|PY|PZ|3M|2s|1V","allowTranslation","Whether the polyline can be translated under drag.","o|2m|Pb|Pc|3M|2s|1V","allowDilation","Whether the shape can be dilated (scaled) under drag.","o|2m|Pe|Pf|3M|2s|1V","minShrink","Minimum scaling factor allowed when dilating.","n|0.1","o|33|Ph|Pi|Pj|1p","allowReflection","Whether the polyline can be reflected under drag.","o|2m|Pl|Pm|3M|2s|1V","attractThreshold","Distance within which a dragged vertex snaps to the function curve or diagonal.","n|0.5","o|33|Po|Pp|Pq|1p","numPoints","Number of points (iterations) currently shown on the cobweb diagram.","o|33|Ps|Pt|36|1p","Symbol used as the independent variable when displaying iterate values.","o|5H|1X|7Q","o|33|H1|Pv|Pw|H3","numIterationsRequired","Minimum number of iterations the user is required to perform.","o|33|Py|Pz|5Q|1p","initialPoint","The starting point on the diagonal where iteration begins.","o|2h|Q1|Q2|1d","The function being iterated.","o|2h|1r|Q4|1r","lockToSolution","Whether to constrain dragged vertices to the correct cobweb solution.","o|2m|Q6|Q7|2p|2s|1V","defaultPoint","The default location for newly added points on the cobweb diagram.","o|2h|Q9|QA|1d","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|Pr|Pu|Px|Q0|Q3|Q5|Q8|QB","o|3L|GI|1V|2p|Oq|3M","o|3L|5O|1q|2p|Os|3M","o|3L|5L|1V|2p|Ou|3M","o|3L|P2|1V|2p|P3|3M","o|3L|P5|1V|2p|P6|3M","o|3L|PY|1V|2p|PZ|3M","o|3L|Pb|1V|2p|Pc|3M","o|3L|Pl|1V|2p|Pm|3M","o|3L|Po|1p|2p|Pp|3M","o|3L|Ps|1p|2p|Pt|3M","o|3L|H1|H3|2p|Pv|3M","o|3L|Py|1p|2p|Pz|3M","A textual description of the polyline\'s style.","o|3Q|Hl|1T|2p|QP",\'Style description including the word "polyline".\',"o|3Q|Ho|1T|2p|QR","Whether the polyline preserves its shape (up to similarity).","o|3Q|P8|1V|2p|QT","Whether the polyline can be dilated under drag.","o|3Q|Pe|1V|2p|QV","Whether each vertex can be dragged independently.","o|3Q|Ow|1V|2p|QX","The number of dimensions the polyline lives in.","o|3Q|6r|1p|2p|QZ","indexAliases","a|3|2g|3J|2f|6r|6u|Qb","The vertices of the polyline.","a|7Q|7T|7W","a|54|Qe","o|Qc|Oz|1X|3M|Qd|4X|IM|Qf","length","The total length of the polyline.","o|3Q|Qh|1p|2p|Qi","The centroid of the polyline\'s vertices.","o|6v|5b|1X|3M|Qk|36|IY","o|6v|Q1|1X|3M|Q2|36|IY","correctVertices","Per-vertex flags indicating whether each vertex is positioned at the correct cobweb solution.","o|73|3M|1V|36","a|Qp","o|6v|Qn|1V|3M|Qo|36|Qq","fractionCorrectVertices","The fraction of vertices placed at correct cobweb positions.","o|3Q|Qs|1p|2p|Qt","numGradedVertices","The number of cobweb vertices that were evaluated for correctness.","o|3Q|Qv|1p|2p|Qw","numCorrectVertices","The number of cobweb vertices placed at correct positions.","o|3Q|Qy|1p|2p|Qz","fractionCorrectVerticesAdjusted","The fraction of correct vertices, scaled by the required minimum number of iterations.","o|3Q|R1|1p|2p|R2","numGradedVerticesAdjusted","The effective number of graded vertices after adjusting for the required minimum number of iterations.","o|3Q|R4|1p|2p|R5","numIterateValues","The number of iterate values produced by the cobweb diagram.","o|3Q|R7|1p|2p|R8","iterateValues","The list of iterate values shown by the cobweb diagram.","o|6v|RA|1X|3M|RB|36|75","numVertices","Number of cobweb vertices currently shown (alias for numPoints).","o|3Q|RD|1p|2p|RE","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|Qa|Qg|Qj|Ql|Qm|Qr|Qu|Qx|R0|R3|R6|R9|RC|RF","An interactive cobweb diagram for visualizing iteration of a one-variable function","o|F|8Y|Om|On|Op|QC|RG|3M|2p|2p|8Y|RH|Az","constrainToGrid","constrainToGraph","attractToGrid","constrainTo","attractTo","constraintUnion","attractToConstraint","constrainToInterior","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|RJ|RK|RL|RM|RN|RO|RP|RQ|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q","112011111111111111111111111110220101221211112221111111122220122222222222222222222222222222","markerStyle","Marker shape.","square","triangleUp","triangleDown","triangleLeft","triangleRight","diamond","a|8u|RV|8r|RW|RX|RY|RZ|Ra","Circular marker.","o|3s|8u|Rc","Square marker.","o|3s|RV|Re",\'Triangular marker pointing up (alias for "triangleUp").\',"o|3s|8r|Rg","Triangular marker pointing up.","o|3s|RW|Ri","Triangular marker pointing down.","o|3s|RX|Rk","Triangular marker pointing left.","o|3s|RY|Rm","Triangular marker pointing right.","o|3s|RZ|Ro","Diamond-shaped marker.","o|3s|Ra|Rq","a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr","o|HC|RT|RU|Rb|Rs|3y","markerSize","Marker size in pixels.","o|2h|Ru|Rv|1p","Whether the point can be dragged on a graph.","o|2m|5L|Rx|3M|2s|1V","The first coordinate (x) of the point.","o|2h|7Q|Rz|1X","The second coordinate (y) of the point.","o|2h|7T|S1|1X","The third coordinate (z) of the point.","o|2h|7W|S3|1X","xs","The point\'s coordinates as a list.","o|2h|S5|S6|1Y","The point\'s coordinates as a single math expression.","o|2h|1e|S8|1e","Position of the point\'s label.","Place the label above and to the right of the point.","o|3s|5c|SB","Place the label above and to the left of the point.","o|3s|5d|SD","Place the label below and to the right of the point.","o|3s|5e|SF","Place the label below and to the left of the point.","o|3s|5f|SH","Place the label directly above the point.","o|3s|9|SJ","Place the label directly below the point.","o|3s|5g|SL","Place the label directly to the left of the point.","o|3s|5h|SN","Place the label directly to the right of the point.","o|3s|5i|SP","a|SC|SE|SG|SI|SK|SM|SO|SQ","o|Bi|GL|SA|5c|GN|SR|3y","addControls","Whether to render interactive control handles.","both","xOnly","yOnly","a|42|SV|SW|SX|2q|2r","Show no control handles.","o|3s|42|SZ","Show control handles for moving the point in both x and y.","o|3s|SV|Sb","Show a control handle that constrains motion to the x direction.","o|3s|SW|Sd","Show a control handle that constrains motion to the y direction.","o|3s|SX|Sf","a|Sa|Sc|Se|Sg","o|Bi|ST|SU|SV|SY|Sh|3y","hideOffGraphIndicator","Whether to suppress the indicator drawn at the edge when the point is off-screen.","o|Ap|Sj|Sk|2s|1V","controlOrder","Slot order for graph controls (1-indexed; 0 means no explicit slot request).","o|33|Sm|Sn|5Q|1q","stable","Whether the equilibrium is stable (rendered filled) or unstable (rendered open).","o|2m|Sp|Sq|3M|2s|1V","switchable","Whether the user can toggle the stability of this equilibrium by clicking it.","o|2m|Ss|St|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|Sr|Su","o|3L|5L|1V|2p|Rx|3M","o|3L|GL|1T|2p|SA|3M","o|3L|ST|1T|2p|SU|3M","o|3L|Sm|1q|2p|Sn|3M","o|3L|Sp|1V|2p|Sq|3M","o|3L|Ss|1V|2p|St|3M","scales","The graph axis scales (x and y) used when applying this constraint.","o|3Q|T2|1p|2p|T3","constraintUsed","Whether this constraint was applied to the component.","o|3Q|T5|1V|2p|T6","A textual description of the point\'s style.","o|3Q|Hl|1T|2p|T8",\'Style description including the word "point".\',"o|3Q|Ho|1T|2p|TA","Whether to suppress the off-graph indicator when out of view.","o|3Q|Sj|1V|2p|TC","Number of dimensions of the point.","o|3Q|6r|1p|2p|TE","o|6v|S5|1X|3M|S6|36|75","The point\'s coordinates as a math expression.","o|3Q|1e|1e|2p|TH","The point rendered as a LaTeX string.","o|3Q|2V|2V|2p|TJ","numDimensionsForConstraints","Number of dimensions exposed to constraint computations (alias for numDimensions).","o|3Q|TL|1p|2p|TM","o|3Q|7Q|1X|2p|Rz","o|3Q|7T|1X|2p|S1","o|3Q|7W|1X|2p|S3","o|3Q|3a|1e|2p|S8","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|T0|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","An equilibrium point of a dynamical system, rendered as a filled point if stable or open if unstable","o|F|1J|RR|RS|Op|Sv|TS|3M|3M|2p|1J|TT|Az","a|I|J|1z|2S|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","1120122221111111111111111111111222222222122220222212222201221222122222122221212222","Whether the line can be dragged on a graph.","o|2m|5L|TX|3M|2s|1V","equation","Implicit equation defining the line.","o|2h|TZ|Ta|1X","Points the line passes through.","o|2h|Gr|Tc|2W","slope","Slope of the line.","o|2h|Te|Tf|1p","perpendicularTo","Direction the line should be perpendicular to (e.g. another line or vector).","_directionComponent","o|2h|Th|Ti|Tj","parallelTo","Direction the line should be parallel to (e.g. another line or vector).","o|2h|Tl|Tm|Tj","Names of the variables used in the line equation.","o|2h|Gx|To|Gz","Where the label sits along this line/curve.","a|5c|5d|5e|5f|5b|9|5g|5h|5i","Place the label above and to the right of the line.","o|3s|5c|Ts","Place the label above and to the left of the line.","o|3s|5d|Tu","Place the label below and to the right of the line.","o|3s|5e|Tw","Place the label below and to the left of the line.","o|3s|5f|Ty","Place the label at the midpoint of the line.","o|3s|5b|U0","Place the label directly above the line.","o|3s|9|U2","Place the label directly below the line.","o|3s|5g|U4","Place the label directly to the left of the line.","o|3s|5h|U6","Place the label directly to the right of the line.","o|3s|5i|U8","a|Tt|Tv|Tx|Tz|U1|U3|U5|U7|U9","o|Bi|GL|Tq|5b|Tr|UA|3y","Whether the equilibrium is stable (rendered solid) or unstable (rendered dashed).","o|2m|Sp|UC|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|UD|Su","o|3L|5L|1V|2p|TX|3M","o|3L|GL|1T|2p|Tq|3M","o|3L|Sp|1V|2p|UC|3M","A textual description of the line\'s style.","o|3Q|Hl|1T|2p|UI",\'Style description including the word "line".\',"o|3Q|Ho|1T|2p|UK","Number of dimensions the line lives in.","o|3Q|6r|1p|2p|UM","Variable names used in the line\'s equation.","o|6v|Gx|H3|3M|UO|36|I7","points","Two points the line passes through.","o|Qc|UQ|1X|3M|UR|4X|IM|Qf","The line\'s equation as a math expression.","o|3Q|TZ|1X|2p|UT","coeff0","The constant term in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|UV|1X|2p|UW","coeffvar1","The coefficient of the first variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|UY|1X|2p|UZ","coeffvar2","The coefficient of the second variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.","o|3Q|Ub|1X|2p|Uc","The slope of the line (2D only).","o|3Q|Te|1X|2p|Ue","xintercept","The x-intercept of the line.","o|3Q|Ug|1X|2p|Uh","yintercept","The y-intercept of the line.","o|3Q|Uj|1X|2p|Uk","The line\'s equation rendered as LaTeX.","o|3Q|2V|2V|2p|Um","The line\'s equation rendered as plain text.","o|3Q|1T|1T|2p|Uo","a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up","An equilibrium line of a dynamical system, rendered solid if stable or dashed if unstable","o|F|1K|TV|TW|Op|UE|Uq|3M|3M|2p|1K|Ur|Az","a|I|J|1z|2S|w|x|y|1r|1s|1g|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","11201110101222211111111111111111111112222221222202222122222011222122222122221212222","fillOpacity","Opacity of solid fills, 0 to 1.","o|2h|Uv|Uw|1p","fillPatternOpacity","Opacity of pattern fills (non-solid fillStyle), 0 to 1.","o|2h|Uy|Uz|1p","fillStyle","Fill pattern used inside closed shapes.","horizontal","vertical","diagonal","backDiagonal","dots","diamonds","a|HF|V3|V4|V5|V6|V7|V8","Solid fill.","o|3s|HF|VA","Horizontal line pattern.","o|3s|V3|VC","Vertical line pattern.","o|3s|V4|VE","Diagonal line pattern (/).","o|3s|V5|VG","Back-diagonal line pattern (\\\\).","o|3s|V6|VI","Dots pattern.","o|3s|V7|VK","Filled diamonds pattern.","o|3s|V8|VM","a|VB|VD|VF|VH|VJ|VL|VN","o|HC|V1|V2|V9|VO|3y","Whether the curve can be dragged on a graph.","o|2m|5L|VQ|3M|2s|1V","Position of the curve\'s label relative to the curve.","Place the label above and to the right of the curve.","o|3s|5c|VT","Place the label above and to the left of the curve.","o|3s|5d|VV","Place the label below and to the right of the curve.","o|3s|5e|VX","Place the label below and to the left of the curve.","o|3s|5f|VZ","Place the label directly above the curve.","o|3s|9|Vb","Place the label directly below the curve.","o|3s|5g|Vd","Place the label directly to the left of the curve.","o|3s|5h|Vf","Place the label directly to the right of the curve.","o|3s|5i|Vh","a|VU|VW|VY|Va|Vc|Ve|Vg|Vi","o|Bi|GL|VS|5c|GN|Vj|3y","flipFunction","Whether to swap the function and its argument (i.e., reflect across y=x).","o|2m|Vl|Vm|2p|2s|1V","numDiscretizationPoints","Number of points used when discretizing the curve for rendering.","o|33|Vo|Vp|Nv|1p","periodic","Whether the curve is treated as periodic when interpolating between control points.","o|2m|Vr|Vs|2p|2s|1V","splineTension","Tension parameter used when fitting a spline through control points.","n|0.8","o|33|Vu|Vv|Vw|1p","extrapolateBackward","Whether to extrapolate the curve before its first defined point.","o|2m|Vy|Vz|2p|2s|1V","extrapolateForward","Whether to extrapolate the curve beyond its last defined point.","o|2m|W1|W2|2p|2s|1V","splineForm","Form of spline used to interpolate between control points.","centripetal","uniform","a|W6|W7","Centripetal Catmull-Rom spline (avoids self-intersection at sharp turns).","o|3s|W6|W9","Uniform Catmull-Rom spline with evenly spaced parameterization.","o|3s|W7|WB","a|WA|WC","o|Bi|W4|W5|W6|W8|WD|3y","Name of the curve\'s parameter or independent variable.","o|33|H1|WF|Pw|H3","Points the interpolated curve passes through.","o|2h|Gr|WH|2W","parMin","Minimum value of the curve\'s parameter (for parametric curves).","o|2h|WJ|WK|1X","parMax","Maximum value of the curve\'s parameter (for parametric curves).","o|2h|WM|WN|1X","Whether to show coordinate labels while dragging the curve.","o|2m|P2|WP|3M|2s|1V","Whether nearest-point queries should treat this as a curve in the plane rather than a graph y = f(x).","o|2m|H9|WR|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j|UD|Su","o|3L|5L|1V|2p|VQ|3M","o|3L|GL|1T|2p|VS|3M","o|3L|Vl|1V|2p|Vm|3M","o|3L|Vo|1p|2p|Vp|3M","o|3L|Vr|1V|2p|Vs|3M","o|3L|Vu|1p|2p|Vv|3M","o|3L|Vy|1V|2p|Vz|3M","o|3L|W1|1V|2p|W2|3M","o|3L|W4|1T|2p|W5|3M","o|3L|P2|1V|2p|WP|3M","A textual description of the curve\'s style.","o|3Q|Hl|1T|2p|We",\'Style description including the word "curve".\',"o|3Q|Ho|1T|2p|Wg","Maximum value of the curve\'s parameter.","o|3Q|WM|1p|2p|Wi","Minimum value of the curve\'s parameter.","o|3Q|WJ|1p|2p|Wk","Number of dimensions the curve lives in.","o|3Q|6r|1p|2p|Wm","throughPoints","Points the curve is constrained to pass through.","o|6v|Wo|1X|3M|Wp|4X|IM","vectorControlDirections","Direction symmetry of each control vector pair.","o|6v|Wr|1T|3M|Ws|36|Jt","hiddenControls","Whether each control vector is currently hidden.","o|6v|Wu|1V|3M|Wv|36|Qq","controlVectors","The Bezier control vectors at each through-point.","o|73|3M|1h|4X","o|73|3M|1h|36","a|Wz|X0|6y","a|54|54|Qe","o|Qc|Wx|1X|3M|Wy|4S|X1|X2","controlPoints","The Bezier control points (vertex + offset) for each through-point.","o|73|3M|1d|4X","a|X6|IK|IL","o|6v|X4|1X|3M|X5|4S|X7","extrapolateBackwardMode","The extrapolation style used before the first through-point (e.g., \'line\', \'parabolaHorizontal\', \'parabolaVertical\').","o|3Q|X9|1T|2p|XA","extrapolateForwardMode","The extrapolation style used beyond the last through-point (e.g., \'line\', \'parabolaHorizontal\', \'parabolaVertical\').","o|3Q|XC|1T|2p|XD","fs","The component functions of the curve as functions of its parameter.","o|6v|XF|1r|3M|XG|36|OU","numXCriticalPoints","The number of x-critical points (horizontal tangents) on the curve.","o|3Q|XI|1q|2p|XJ","xCriticalPoints","The x-critical points (horizontal tangents) on the curve.","o|6v|XL|1p|3M|XM|4X|IM","numYCriticalPoints","The number of y-critical points (vertical tangents) on the curve.","o|3Q|XO|1q|2p|XP","yCriticalPoints","The y-critical points (vertical tangents) on the curve.","o|6v|XR|1p|3M|XS|4X|IM","numCurvatureChangePoints","The number of points where the curve\'s curvature changes sign.","o|3Q|XU|1q|2p|XV","curvatureChangePoints","Points where the curve\'s curvature changes sign (inflection points).","o|6v|XX|1p|3M|XY|4X|IM","The first component function of the curve as a function of its parameter.","o|3Q|4y|1r|2p|Xa","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb","An equilibrium curve of a dynamical system, rendered solid if stable or dashed if unstable","o|F|8Z|Ut|Uu|Op|WT|Xc|3M|3M|2p|8Z|Xd|Az","symbol",\'The chemical symbol of the atom (e.g. "H", "He", "Li").\',"o|2h|Xf|Xg|1T","atomicNumber","The atomic number of the atom (number of protons).","o|2h|Xi|Xj|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|Xh|Xk|H8|4Y|4c|4g|4j","The atomic number of the element.","o|3Q|Xi|1q|2p|Xm","The chemical symbol of the element.","o|3Q|Xf|1T|2p|Xo","The full name of the element.","o|3Q|3|1T|2p|Xq","The group number of the element in the periodic table.","o|3Q|23|1q|2p|Xs","atomicMass","The atomic mass of the element.","o|3Q|Xu|1p|2p|Xv","phaseAtSTP","The phase (solid, liquid, or gas) of the element at standard temperature and pressure.","o|3Q|Xx|1T|2p|Xy","chargeOfCommonIon","The charge of the most common ion of this element.","o|3Q|Y0|1q|2p|Y1","metalCategory","The metal category of the element (e.g. alkali metal, transition metal, nonmetal).","o|3Q|Y3|1T|2p|Y4",`The descriptive name of the element\'s periodic group (e.g. "Alkali metals").`,"o|3Q|4N|1T|2p|Y6","period","The period number of the element in the periodic table.","o|3Q|Y8|1q|2p|Y9","ionizationEnergy","The first ionization energy of the element.","o|3Q|YB|1p|2p|YC","meltingPoint","The melting point of the element.","o|3Q|YE|1p|2p|YF","boilingPoint","The boiling point of the element.","o|3Q|YH|1p|2p|YI","atomicRadius","The atomic radius of the element.","o|3Q|YK|1q|2p|YL","density","The density of the element at standard conditions.","o|3Q|YN|1p|2p|YO","electronegativity","The Pauling electronegativity of the element.","o|3Q|YQ|1p|2p|YR","The electron configuration of the element as a math expression.","o|3Q|1O|1O|2p|YT","The orbital diagram of the element.","o|3Q|8a|8a|2p|YV","The atom rendered as a math expression with the element symbol.","o|3Q|1X|1X|2p|YX","The atom rendered as a LaTeX string.","o|3Q|2V|2V|2p|YZ","The atom rendered as a plain text string.","o|3Q|1T|1T|2p|Yb","a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|Xn|Xp|Xr|Xt|Xw|Xz|Y2|Y5|Y7|YA|YD|YG|YJ|YM|YP|YS|YU|YW|YY|Ya|Yc","Represents a chemical element by symbol or atomic number, exposing its periodic-table properties","o|F|1L|54|AZ|3l|Xl|Yd|3M|2p|2p|1L|Ye|3h","a|1L|1z",\'The chemical symbol of the element (e.g. "Na", "Cl").\',"o|2h|Xf|Yh|1T","o|2h|Xi|Xm|1q","charge","The charge of the ion (positive for cations, negative for anions).","o|2h|Yk|Yl|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|Yi|Yj|Ym","The charge of the ion.","o|3Q|Yk|1q|2p|Yo",\'The full name of the ion (e.g. "sodium ion").\',"o|3Q|3|1T|2p|Yq","The group number of the underlying element in the periodic table.","o|3Q|23|1q|2p|Ys","The metal category of the underlying element (e.g. alkali metal, transition metal, nonmetal).","o|3Q|Y3|1T|2p|Yu","The descriptive name of the underlying element\'s periodic group.","o|3Q|4N|1T|2p|Yw","The period number of the underlying element in the periodic table.","o|3Q|Y8|1q|2p|Yy","The ion rendered as a math expression (element symbol with charge).","o|3Q|1X|1X|2p|Z0","The ion rendered as a LaTeX string.","o|3Q|2V|2V|2p|Z2","The ion rendered as a plain text string.","o|3Q|1T|1T|2p|Z4","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|Xn|Xp|Yp|Yr|Yt|Yv|Yx|Yz|Z1|Z3|Z5","Represents a charged ion specified by element and charge, rendered with its chemical formula","o|F|1M|Yg|BN|3l|Yn|Z6|3M|2p|2p|1M|Z7|3h","a|1L|1M|1z","202","The chemical symbol of an element in the compound.","o|2h|Xf|ZB|1T","The atomic number of an element in the compound.","o|2h|Xi|ZD|1q","The charge of an ion in the compound.","o|2h|Yk|ZF|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|ZC|ZE|ZG","The ionic compound rendered as a math expression of its chemical formula.","o|3Q|1X|1X|2p|ZI","The ionic compound rendered as a LaTeX string.","o|3Q|2V|2V|2p|ZK","The ionic compound rendered as a plain text string.","o|3Q|1T|1T|2p|ZM","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|ZJ|ZL|ZN","Forms a balanced ionic compound from constituent ions and renders its chemical formula","o|F|1N|Z9|ZA|3l|ZH|ZO|3M|2p|2p|1N|ZP|3h","o|3Q|3a|1O|2p|6e","The electron configuration rendered as a LaTeX string.","o|3Q|2V|2V|2p|ZS","The electron configuration rendered as a unicode text string.","o|3Q|1T|1T|2p|ZU","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ZR|6h|6j|6m|ZT|ZV|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","Renders an electron configuration with sublevel labels and superscripted electron counts","o|F|1O|3j|3k|3l|64|ZW|3M|3M|2p|1O|ZX|3h","a|1Z|1z|8a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","02012222111111111111111111111122222222212222022212222201221222122222122221212222","Text labels for each orbital row.","o|33|GG|Zb|54|1U","a|2j|2t|2w|2z|32|37|3A|3E|3H|Zc","The orbital diagram value as a list of rows, each with a label and boxes containing up/down arrows.","o|3Q|3a|8a|2p|Ze","a|3N|3O|3P|3T|3U|3V|3W|3Z|Zf","Renders an orbital diagram showing electrons in atomic orbitals as up/down arrows in boxes","o|F|8a|ZZ|Za|9X|Zd|Zg|3M|3M|2p|8a|Zh|AT","prefill","An orbital diagram used to prefill the input before the student begins.","o|33|Zj|Zk|54|8a","prefillLabel","Text labels to prefill for each orbital row.","o|33|Zm|Zn|54|1U","a|2j|2t|2w|2z|32|37|3A|3E|3H|Zl|Zo","The current orbital diagram entered by the student.","o|3Q|3a|8a|2p|Zq","The orbital diagram rows in display order (reversed from the underlying value).","o|3Q|7K|8a|2p|Zs","The number of orbital rows in the diagram.","o|3Q|7A|1q|2p|Zu","selectedRowIndex","Index of the currently selected orbital row (1-based; 0 if none selected).","o|3Q|Zw|1q|2p|Zx","selectedBoxIndex","Index of the currently selected box within the selected row (1-based; 0 if none selected).","o|3Q|Zz|1q|2p|a0","a|3N|3O|3P|3T|3U|3V|3W|3Z|Zr|Zt|Zv|Zy|a1","An interactive widget where students fill in an orbital diagram by adding boxes, rows, and up/down arrows (block-level; does not inherit from Input)","o|F|8b|54|AZ|9X|Zp|a2|3M|2p|2p|8b|a3|AT","code","Identifier used to reference this feedback definition.","o|2h|a5|a6|1T","Default feedback text for this code.","o|2h|1T|a8|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|a7|a9","A reusable feedback definition referenced by other components","o|F|Kt|54|AZ|Ao|aA|Aa|3M|2p|2p|Kt|aB|Az","Index identifying which style this definition applies to.","o|33|34|aD|36|1q","lineColor","Color used for line strokes (light mode).","o|2h|aF|aG|1T","lineColorWord","Human-readable name of the line color (light mode).","o|2h|aI|aJ|1T","lineColorDarkMode","Color used for line strokes (dark mode).","o|2h|aL|aM|1T","lineColorWordDarkMode","Human-readable name of the line color (dark mode).","o|2h|aO|aP|1T","lineOpacity","Opacity of line strokes, 0 to 1.","o|2h|aR|aS|1p","lineWidthWord","Human-readable name of the line width.","o|2h|aU|aV|1T","lineStyleWord","Human-readable name of the line style.","o|2h|aX|aY|1T","markerColor","Color used for markers/points (light mode).","o|2h|aa|ab|1T","markerColorWord","Human-readable name of the marker color (light mode).","o|2h|ad|ae|1T","markerColorDarkMode","Color used for markers/points (dark mode).","o|2h|ag|ah|1T","markerColorWordDarkMode","Human-readable name of the marker color (dark mode).","o|2h|aj|ak|1T","markerOpacity","Opacity of markers/points, 0 to 1.","o|2h|am|an|1p","cross","plus","a|8u|RV|8r|RW|RX|RY|RZ|Ra|ap|aq","Cross-shaped marker (×).","o|3s|ap|as","Plus-shaped marker (+).","o|3s|aq|au","a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr|at|av","o|HC|RT|RU|ar|aw|3y","markerStyleWord","Human-readable name of the marker style.","o|2h|ay|az|1T","markerFilled","Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior.","o|Ap|b1|b2|2s|1V","fillColor","Fill color used inside closed shapes (light mode).","o|2h|b4|b5|1T","fillColorWord","Human-readable name of the fill color (light mode).","o|2h|b7|b8|1T","fillColorDarkMode","Fill color used inside closed shapes (dark mode).","o|2h|bA|bB|1T","fillColorWordDarkMode","Human-readable name of the fill color (dark mode).","o|2h|bD|bE|1T","fillStyleWord","Human-readable name of the fill style.","o|2h|bG|bH|1T","Text color (light mode).","o|2h|6L|bJ|1T","textColorWord","Human-readable name of the text color (light mode).","o|2h|bL|bM|1T","textColorDarkMode","Text color (dark mode).","o|2h|bO|bP|1T","textColorWordDarkMode","Human-readable name of the text color (dark mode).","o|2h|bR|bS|1T","highContrastColor","High-contrast accent color (light mode).","o|2h|bU|bV|1T","highContrastColorWord","Human-readable name of the high-contrast accent color (light mode).","o|2h|bX|bY|1T","highContrastColorDarkMode","High-contrast accent color (dark mode).","o|2h|ba|bb|1T","highContrastColorWordDarkMode","Human-readable name of the high-contrast accent color (dark mode).","o|2h|bd|be|1T","Background color (light mode).","o|2h|6O|bg|1T","backgroundColorWord","Human-readable name of the background color (light mode).","o|2h|bi|bj|1T","backgroundColorDarkMode","Background color (dark mode).","o|2h|bl|bm|1T","backgroundColorWordDarkMode","Human-readable name of the background color (dark mode).","o|2h|bo|bp|1T","a|2j|2t|2w|2z|32|aE|3A|3E|3H|aH|aK|aN|aQ|aT|HT|aW|HQ|aZ|ac|af|ai|al|ao|ax|b0|Rw|b3|b6|b9|bC|bF|Ux|V0|VP|bI|bK|bN|bQ|bT|bW|bZ|bc|bf|bh|bk|bn|bq","a|3N|3P|3T|3U|3V|3W|3Z","A reusable style definition referenced by other components","o|F|Ks|54|AZ|Ao|br|bs|3M|2p|2p|Ks|bt|Az","a|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|1b|8y|92|96|97|98|1w|1x|1y|1z|22|23|9C|9D|9E|9F|2D|2I|9I|2L|2M|9J|2P|9N|9Q|9S|9T","1111111111111111111111111111111111111211111222222111122122121111","width","Total rendered width of the side-by-side container.","componentSize","o|2h|bx|by|bz","widths","List of widths for each panel.","_componentSizeList","o|2h|c1|c2|c3","margins","List of margin widths between panels.","o|2h|c5|c6|c3","valign","Default vertical alignment for all panels.","middle","a|9|cA|5g","Align panels to the top.","o|3s|9|cC","Vertically center panels.","o|3s|cA|cE","Align panels to the bottom.","o|3s|5g|cG","a|cD|cF|cH","o|HC|c8|c9|cB|cI|3y","isList","a|3|2f|2l|3n|cK|2g","valigns","Per-panel vertical alignment values.","Align the panel to the top.","o|3s|9|cO","Vertically center the panel.","o|3s|cA|cQ","Align the panel to the bottom.","o|3s|5g|cS","a|cP|cR|cT","o|cL|cM|cN|cB|cU|3M|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|c0|c4|c7|cJ|cV","absoluteMeasurements","Whether children\'s widths are interpreted in absolute units.","o|3Q|cX|1V|2p|cY","gapWidth","The gap width between panels as a percentage of the total container width.","o|3Q|ca|1p|2p|cb","The list of child widths.","o|6v|c1|1p|3M|cd|36|IR","Margins between adjacent children.","o|6v|c5|1p|3M|cf|36|IR","Vertical alignment of each child.","o|6v|cM|1T|3M|ch|36|Jt","a|3N|3O|3P|3T|3U|3V|3W|3Z|cZ|cc|ce|cg|ci","Renders children in a side-by-side horizontal layout","o|F|8c|bv|bw|9X|cW|cj|3M|2p|2p|8c|ck|AT","a|8c|1z","A group of `<sideBySide>` components that share alignment and spacing","o|F|8d|cm|BN|9X|cW|cj|3M|2p|2p|8d|cn|AT","A vertical container element for organizing content within a `<sideBySide>`","o|F|8e|9U|9V|9X|3I|Aa|3M|3M|2p|8e|cp|AT","A generic block-level container","o|F|8f|9U|9V|9X|A6|AR|3M|3M|2p|8f|cr|AT","A generic inline container","o|F|1P|9U|9V|3l|A6|AR|3M|3M|2p|1P|ct|3h","A preformatted block preserving whitespace","o|F|8g|9U|9V|9X|3I|Aa|3M|3M|2p|8g|cv|AT","The verbatim text content.","o|3Q|1T|1T|2p|cx","a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|cy","Displays a DoenetML source string verbatim","o|F|1Q|9U|9V|3l|3I|cz|3M|3M|2p|1Q|d0|3h","initialPage","1-based page index shown on first render.","o|33|d2|d3|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|d4","numPages","The total number of pages.","o|3Q|d6|1q|2p|d7","currentPage","The currently displayed page (1-based).","o|3Q|d9|1q|2p|dA","a|3N|3O|3P|3T|3U|3V|3W|3Z|d8|dB","Defines a paginated section of content","o|F|8h|9U|9V|9X|d5|dC|3M|3M|2p|8h|dD|AT","previousLabel",\'Label for the "previous page" button.\',"Previous","o|33|dF|dG|dH|1T","nextLabel",\'Label for the "next page" button.\',"Next","o|33|dJ|dK|dL|1T","pageLabel","Label format for the current page indicator.","Page","o|33|dN|dO|dP|1T","Reference to the `<paginator>` these controls operate on.","o|2h|8h|dR|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H|dI|dM|dQ|dS","o|3L|dF|1T|2p|dG|3M","o|3L|dJ|1T|2p|dK|3M","o|3L|dN|1T|2p|dO|3M","disabledDirectly","Whether the controls are disabled directly (rather than via inheritance).","o|3Q|dX|1V|2p|dY","a|3N|3O|3P|dU|dV|dW|3T|3U|3V|3W|3Z|dZ","Previous/next page controls referencing a paginator elsewhere in the document","o|F|8i|54|AZ|9X|dT|da|3M|2p|2p|8i|db|AT","shortDescription","a|I|J|1z|2S|2f|dd|2U","1120000","_input","a|dg|2c|2d","Position of the label relative to the input.","a|5h|5i","Place the label to the left of the input.","o|3s|5h|dk","Place the label to the right of the input.","o|3s|5i|dm","a|dl|dn","o|Bi|GL|di|5h|dj|do|3y","forAnswer","References to `<answer>` elements that this input should submit to.","o|2h|dq|dr|3D","Number of rows in the matrix input.","o|33|7A|dt|36|1q","Number of columns in the matrix input.","o|33|7D|dv|36|1q","showSizeControls","Whether to render controls for resizing the matrix.","o|2m|dx|dy|3M|2s|1V","defaultEntry","Default value used for empty matrix cells.","o|33|e0|e1|5J|1X","Initial matrix value displayed in the input.","o|33|Zj|e3|5J|1X","Input format for the math entered.","o|Bi|3p|e5|1T|3r|3x|3y","o|4U|4P|4Q|4R|Nn|1q","o|4U|4Z|4a|4R|5Q|1p","bindValueTo","Two-way binding target for the input\'s value.","o|2h|e9|eA|1X","unionFromU",\'Whether "U" between sets is parsed as union.\',"o|2m|eC|eD|2p|2s|1V","minComponentWidth","Minimum rendered width for each cell, in pixels.","o|33|eF|eG|5Q|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|du|dw|dz|e2|e4|e6|51|58|5B|e7|4Y|e8|4g|4j|eB|eE|eH","o|3L|GL|1T|2p|di|3M","o|3L|dx|1V|2p|dy|3M","o|3L|Zj|1X|2p|e3|3M","o|3L|3p|1T|2p|e5|3M","o|3L|eC|1V|2p|eD|3M","A short accessibility description of this input; it is visible to screen readers but not rendered visually.","o|3Q|dd|1T|2p|eO","focused","Whether the matrix input currently has keyboard focus.","o|3Q|eQ|1V|2p|eR","valueChanged","Whether the value has been changed from its initial state.","o|3Q|eT|1V|2p|eU","immediateValueChanged","Whether the value, including in-progress edits, has been changed from its initial state.","o|3Q|eW|1V|2p|eX","The number of rows of the matrix.","o|3Q|7A|1q|2p|eZ","The number of columns of the matrix.","o|3Q|7D|1q|2p|eb","The matrix value of the input.","o|3Q|3a|1X|2p|ed","immediateValue","The matrix value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|eg","The current matrix as a text string.","o|3Q|1T|1T|2p|ei","The matrix as a math expression.","o|6v|2U|1X|3M|ek|4X|7I","a|3N|3O|3P|eJ|Hd|eK|eL|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|eS|6X|6Y|6Z|6a|6b|eV|eY|ea|ec|ee|eh|ej|el|7P|7M","An interactive matrix input where each cell accepts a math value","o|F|1R|de|df|dh|eI|em|3M|2p|2p|1R|en|3h","a|I|J|1z|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","112000122221111111111111111111111222222222122220222212222222221222122222122221212222","prefillNumerator","Initial value displayed in the numerator input.","o|33|er|es|5J|1X","prefillDenominator","Initial value displayed in the denominator input.","o|33|eu|ev|5J|1X","Minimum rendered width for the numerator and denominator, in pixels.","o|33|eF|ex|5Q|1q","Two-way binding target for the fraction\'s value.","o|2h|e9|ez|1X","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|et|ew|e6|51|58|5B|e7|4Y|e8|4g|4j|eE|ey|f0","o|3L|er|1X|2p|es|3M","o|3L|eu|1X|2p|ev|3M","Whether the fraction input currently has keyboard focus.","o|3Q|eQ|1V|2p|f4","The fraction value of the input (numerator divided by denominator).","o|3Q|3a|1X|2p|f6","The fraction value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|f8","numerator","The numerator of the fraction.","o|3Q|fA|1X|2p|fB","denominator","The denominator of the fraction.","o|3Q|fD|1X|2p|fE","The current fraction as a text string.","o|3Q|1T|1T|2p|fG","a|3N|3O|3P|eJ|Hd|f2|f3|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|f5|6X|6Y|6Z|6a|6b|eV|f7|eY|f9|fC|fF|fH","An interactive fraction input with a numerator and a denominator, each accepting a math value.","o|F|1S|ep|eq|dh|f1|fI|3M|2p|2p|1S|fJ|3h","a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T","111111111111111111111111111111111111111111111111111111111111111112211111111121212222121212211111111111222222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111","Whether the solution is initially hidden.","o|2m|2n|fN|2p|2s|1V","a|2j|fO|2w|2z|32|37|3A|3E|3H","Whether the solution is currently hidden.","o|3Q|2n|1V|2p|fQ","Whether the solution is currently open (revealed).","o|3Q|M7|1V|2p|fS","a|3O|3P|3T|3U|3V|3W|3Z|fR|fT","A solution to an exercise, shown on demand","o|F|8j|fL|fM|9X|fP|fU|3M|3M|2p|8j|fV|AT",\'A sectional component that renders an expandable block labeled "Answer"\',"o|F|8k|fL|fM|9X|fP|fU|3M|3M|2p|8k|fX|AT","a|1z|9A|G|9H|Ks|Kt|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","100000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","xmlns","XML namespace declaration (accepted for compatibility; not used).","o|2h|fb|fc|1T","Document type identifier.","o|2h|2g|fe|1T","a|2j|32|3E|3H|9h|9l|9o|9r|9u|9y|A2|A5|fd|ff","Aggregate credit achieved (0 to 1) for scored content in the document.","o|3Q|AL|1p|2p|fh","Aggregate credit achieved as a percentage (0 to 100) for scored content in the document.","o|3Q|AO|1p|2p|fj","The document\'s title.","o|3Q|G|1T|2p|fl","a|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|fi|fk|fm","The top-level container for a DoenetML document (added implicitly if not present)","o|F|8l|fZ|fa|Ao|fg|fn|3M|3M|2p|8l|fo|Az","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19","2222222222222222222222222222222222222212220222222222222222222222221122222212111111111111111111","The text value.","o|3Q|3a|1T|2p|fs","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|ft|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4","A text string","o|F|1T|fq|fr|3l|Jc|fu|3M|3M|2p|1T|fv|3h","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X","2222222222222222222222222222222222222212220222222222222222222222221122222212","_composite","a|fz|2d","a|3|2f|2k","o|g1|2x|2y|2p","a|3|2f","o|g3|38|39","Whether the order of items should be treated as unordered.","o|2m|4n|g5|2p|2s|1V","maxNumber","Maximum number of items to retain in the list.","o|33|g7|g8|9k|1p","Whether to render the items separated by commas (true) or with no separator (false).","o|2m|20|gA|3M|2s|1V","a|2j|2t|2w|g2|32|37|g4|3E|3H|g6|g9|gB","o|3L|4n|1V|2p|g5|3M","o|3L|g7|1p|2p|g8|3M","numComponents","The number of items in the text list.","o|3Q|gF|1p|2p|gG","numValues","The number of text values in the list.","o|3Q|gI|1p|2p|gJ","a|3N|3O|gD|gE|3Z|gH|gK","A list of texts","o|F|1U|fx|fy|g0|gC|gL|3M|3M|3M|1U|gM|Az","A paragraph of inline content","o|F|8m|Ag|Ah|9X|A6|Ak|3M|3M|2p|8m|gO|AT","The boolean value (true or false).","o|3Q|3a|1V|2p|gQ","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|gR|CW","A boolean value","o|F|1V|BY|BZ|3l|CI|gS|3M|3M|2p|1V|gT|3h","Whether the order of items in this list should be treated as unordered (e.g. for matching).","o|2m|4n|gV|2p|2s|1V","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB","o|3L|4n|1V|2p|gV|3M","The number of items in the boolean list.","o|3Q|gF|1p|2p|gZ","The number of booleans in the list.","o|3Q|gI|1p|2p|gb","a|3N|3O|gY|gE|3Z|ga|gc","A list of booleans","o|F|1W|Cc|Cd|g0|gX|gd|3M|3M|3M|1W|ge|Az","o|3Q|3a|1X|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A math expression","o|F|1X|3j|3k|3l|64|gh|3M|3M|2p|1X|gi|3h","mergeMathLists","Whether nested math-list children should be flattened into this list.","o|Ap|gk|gl|2s|1V","o|g3|4P|4Q","o|g3|4V|4W","o|g3|4Z|4a","o|g3|4e|4f","o|g3|4h|4i","Symbols treated as function names when parsing items.","o|33|4w|gs|50|1U","References whose names should be treated as function symbols when parsing items.","o|33|52|gu|54|3D","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gm|gB|gn|go|gp|gq|gr|gt|gv|58|5B","o|3L|4w|1U|2p|gs|3M","o|3Q|4n|1V|2p|gV","Whether nested math lists are merged into the parent list.","o|3Q|gk|1V|2p|gz","The number of items in the math list.","o|3Q|gF|1p|2p|h1","The number of math expressions in the list.","o|3Q|gI|1p|2p|h3","a|3N|3O|gE|gx|6D|6E|3Z|gy|h0|h2|h4","A list of math expressions","o|F|1Y|3j|3k|g0|gw|h5|3M|3M|3M|1Y|h6|Az","A list of math tuples, parsed from parenthesized comma-separated pieces","o|F|1Z|3j|3k|g0|gw|h5|3M|3M|3M|1Z|h8|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y","1111111111111111111111121220222101122221222221222112222222222222222222222222222","a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB|gn|go|gp|gq|gr","The number of items in the number list.","o|3Q|gF|1p|2p|hD","The number of numbers in the list.","o|3Q|gI|1p|2p|hF","a|3N|3O|gE|3Z|gy|hE|hG","A list of numbers","o|F|1a|hA|hB|g0|hC|hH|3M|3M|3M|1a|hI|Az","Maximum number of descendants to collect.","o|33|g7|hK||1p","from","Component subtree(s) to collect descendants from.","o|2h|hM|hN|3D","componentType","Component type of descendants to collect.","o|2h|hP|hQ|1T","a|2j|32|3E|3H|hL|hO|hR|gB","o|3L|g7|1p|2p|hK|3M","a|hT|3Z","Collects descendants of a component matching a specified component type","o|F|1b|54|AZ|g0|hS|hU|3M|2p|3M|1b|hV|Az","to","The target that the reference points to (component reference or URL string).","referenceOrText","o|2h|hX|hY|hZ","textType","Type of text to use for the reference label.","type-global","o|33|hb|hc|hd|1T","createButton","Whether to render this reference as a clickable button.","o|2m|hf|hg|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|ha|he|hh","o|3L|hb|1T|2p|hc|3M","url","The resolved URL of the referenced component.","o|3Q|hk|1T|2p|hl","linkText","The display text used for the link.","o|3Q|hn|1T|2p|ho","The text used as the link label.","o|3Q|1T|1T|2p|hq","a|3N|3O|3P|hj|3T|3U|3V|3W|3Z|hm|hp|hr","A link to a component reference or to a URL","o|F|1c|9U|9V|3l|hi|hs|3M|3M|2p|1c|ht|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|ax|Rw|b3|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","A point with coordinates that can be displayed and dragged on a graph","o|F|1d|RR|RS|Op|hv|hw|3M|3M|2p|1d|hx|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4v|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|1e|2p|6e","Whether tuple-like expressions render as vectors (always true for `<coords>`).","o|3Q|4q|1V|2p|i1","a|3N|3O|3P|66|67|68|69|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|i0|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|i2|7S|7V|7Y|7b","A math expression treated as a vector of coordinates","o|F|1e|3j|3k|3l|hz|i3|3M|3M|2p|1e|i4|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB","a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up","A line through two points or defined by an equation","o|F|1f|TV|TW|Op|i6|i7|3M|3M|2p|1f|i8|Az","Whether the line segment can be dragged on a graph.","o|2m|5L|iA|3M|2s|1V","endpointsDraggable","Whether the line segment\'s endpoints can be dragged.","o|Ap|iC|iD|2s|1V","endpoints","The two endpoints of the line segment.","o|2h|iF|iG|2W","a|iF|42|2q|2r","Show control handles for both endpoints of the segment.","o|3s|iF|iJ","a|iK|Sa","o|Bi|ST|SU|iF|iI|iL|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|iB|iE|iH|iM|P4|UB|H8|4Y|4c|4g|4j|So","o|3L|5L|1V|2p|iA|3M","A textual description of the line segment\'s style.","o|3Q|Hl|1T|2p|iP",\'Style description including "line segment".\',"o|3Q|Ho|1T|2p|iR","Whether each endpoint can be dragged independently.","o|3Q|iC|1V|2p|iT","Number of dimensions the segment lives in.","o|3Q|6r|1p|2p|iV","The endpoints of the line segment.","o|Qc|iF|1X|3M|iX|4X|IM|Qf","The length of the line segment.","o|3Q|Qh|1X|2p|iZ","The slope of the line segment (2D only).","o|3Q|Te|1p|2p|ib","a|3N|3O|3P|Hd|QD|7s|QE|iO|Sy|QG|UG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|iQ|iS|iU|iW|iY|ia|ic","A line segment between two endpoints","o|F|8n|Om|On|Op|iN|id|3M|2p|2p|8n|ie|Az","Whether the ray can be dragged on a graph.","o|2m|5L|ig|3M|2s|1V","The starting point (endpoint) of the ray.","o|2h|2K|ii|1d","A point the ray passes through (used with endpoint or direction).","o|2h|Gr|ik|1d","direction","The direction the ray points in.","o|2h|im|in|1h","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|ih|ij|il|io|UB|H8|4Y|4c|4g|4j","o|3L|5L|1V|2p|ig|3M","A textual description of the ray\'s style.","o|3Q|Hl|1T|2p|ir",\'Style description including the word "ray".\',"o|3Q|Ho|1T|2p|it","Number of dimensions the ray lives in.","o|3Q|6r|1p|2p|iv","The direction vector of the ray.","o|6v|im|1X|3M|ix|36|6z","A point the ray passes through.","a|Qe","o|Qc|Gr|1X|3M|iz|36|IY|j0","The starting endpoint of the ray.","o|Qc|2K|1X|3M|j2|36|IY|j0","a|3N|3O|3P|Hd|QD|7s|QE|iq|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|is|iu|iw|iy|j1|j3","A ray starting at one point passing through another","o|F|8o|Om|On|Op|ip|j4|3M|2p|2p|8o|j5|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j","The number of vertices in the polyline.","o|3Q|RD|1p|2p|j8","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|j9|Qa|Qg|Qj|Ql","A polyline (open polygon) defined by a list of vertices","o|F|8p|Om|On|Op|j7|jA|3M|2p|2p|8p|jB|Az","Whether to render interactive vertex control handles.","a|5b|42|2q|2r","Show a control handle for moving the polygon\'s center.","o|3s|5b|jF","a|jG|Sa","o|Bi|ST|jD|5b|jE|jH|3y","filled","Whether to fill the interior of the polygon.","o|2m|jJ|jK|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|jI|jL|So","o|3L|ST|1T|2p|jD|3M","o|3L|jJ|1V|2p|jK|3M","A textual description of the polygon\'s style.","o|3Q|Hl|1T|2p|jP",\'Style description including the word "polygon".\',"o|3Q|Ho|1T|2p|jR","borderStyleDescription","A textual description of the polygon\'s border style.","o|3Q|jT|1T|2p|jU","fillStyleDescription","A textual description of the polygon\'s fill style.","o|3Q|jW|1T|2p|jX","perimeter","The perimeter of the polygon.","o|3Q|jZ|1p|2p|ja","area","The area enclosed by the polygon.","o|3Q|jc|1p|2p|jd","numSides","The number of sides of the polygon.","o|3Q|jf|1p|2p|jg","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|j9|Qa|Qg|Ql|jV|jY|jb|je|jh","A polygon defined by a list of vertices","o|F|8q|Om|On|Op|jM|ji|3M|2p|2p|8q|jj|Az","The number of vertices (always 3 for a triangle).","o|3Q|RD|1p|2p|jl","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|jm|Qa|Qg|Ql|jV|jY|jb|je|jh","A triangle defined by three vertices","o|F|8r|Om|On|Op|jM|jn|3M|2p|2p|8r|jo|Az","centerWidthAndHeight","widthAndHeight","a|5b|jr|jq|42|2q|2r","Show a single control handle for moving the rectangle\'s center.","o|3s|5b|jt","Show control handles for resizing width and height.","o|3s|jr|jv","Show control handles for both moving the center and resizing.","o|3s|jq|jx","a|ju|jw|jy|Sa","o|Bi|ST|SU|jq|js|jz|3y","The rectangle\'s center point.","o|2h|5b|k1|1d","The rectangle\'s width.","o|2h|bx|k3|1p","height","The rectangle\'s height.","o|2h|k5|k6|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|k0|jL|So|k2|k4|k7","The number of vertices (always 4 for a rectangle).","o|3Q|RD|1p|2p|k9","The four corner vertices of the rectangle.","o|Qc|Oz|1X|3M|kB|4X|IM|Qf","The rectangle\'s center coordinates.","o|6v|5b|1X|3M|kD|36|IY","o|3Q|bx|1p|2p|k3","o|3Q|k5|1p|2p|k6","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|kA|Qa|kC|kE|jV|jY|jb|je|kF|kG|jh","A rectangle, potentially defined by width, height, center and/or corner vertices","o|F|8s|Om|On|Op|k8|kH|3M|2p|2p|8s|kI|Az","centerAndRadius","radius","a|5b|kL|kK|42|2q|2r","Show a control handle for resizing the polygon\'s radius.","o|3s|kL|kN","Show control handles for both moving the center and resizing the radius.","o|3s|kK|kP","a|jG|kO|kQ|Sa","o|Bi|ST|SU|kK|kM|kR|3y","Number of vertices in the regular polygon.","o|33|RD|kT|4S|1q","Number of sides in the regular polygon (alias for numVertices).","o|2h|jf|kV|1q","Center of the regular polygon.","o|2h|5b|kX|1d","circumradius","Distance from center to a vertex (circumscribed-circle radius).","o|2h|kZ|ka|1p","Alias for circumradius.","o|2h|kL|kc|1p","inradius","Distance from center to the midpoint of a side (inscribed-circle radius).","o|2h|ke|kf|1p","apothem","Alias for inradius.","o|2h|kh|ki|1p","sideLength","Length of each side of the regular polygon.","o|2h|kk|kl|1p","Total perimeter of the regular polygon.","o|2h|jZ|kn|1p","Total area enclosed by the regular polygon.","o|2h|jc|kp|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|kS|jL|So|kU|kW|kY|kb|kd|kg|kj|km|ko|kq","Whether to preserve similarity when dragging.","o|3Q|P8|1V|2p|ks","The number of vertices (sides) of the regular polygon.","o|3Q|RD|1q|2p|ku","The center coordinates of the regular polygon.","o|6v|5b|1X|3M|kw|36|IY","The radius of the circumscribed circle.","o|3Q|kZ|1p|2p|ky","The radius of the inscribed circle.","o|3Q|ke|1p|2p|l0","The length of each side.","o|3Q|kk|1p|2p|l2","The number of sides of the regular polygon.","o|3Q|jf|1q|2p|l4","Distance from center to a vertex (alias for circumradius).","o|3Q|kL|1p|2p|l6","Distance from center to the midpoint of a side (alias for inradius).","o|3Q|kh|1p|2p|l8","a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|kt|QW|QY|kv|Qa|Qg|kx|jV|jY|jb|je|kz|l1|l3|l5|l7|l9","A regular polygon with a given number of sides","o|F|8t|Om|On|Op|kr|lA|3M|2p|2p|8t|lB|Az","Points the circle passes through.","o|2h|Gr|lD|2W","The circle\'s center point.","o|2h|5b|lF|1d","The circle\'s radius.","o|2h|kL|lH|1X","Whether to render interactive control handles on the circle.","Show a control handle for moving the circle\'s center.","o|3s|5b|lK","Show a control handle for resizing the circle\'s radius.","o|3s|kL|lM","a|lL|lN|kQ|Sa","o|Bi|ST|lJ|kK|kM|lO|3y","Whether to fill the interior of the circle.","o|2m|jJ|lQ|2p|2s|1V","Whether to suppress the indicator drawn at the edge when the component is off-screen.","o|Ap|Sj|lS|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|lE|WQ|WS|H8|4Y|4c|4g|4j|lG|lI|lP|lR|lT|So","o|3L|ST|1T|2p|lJ|3M","o|3L|jJ|1V|2p|lQ|3M","A textual description of the circle\'s style.","o|3Q|Hl|1T|2p|lX",\'Style description including the word "circle".\',"o|3Q|Ho|1T|2p|lZ","A textual description of the circle\'s border style.","o|3Q|jT|1T|2p|lb","A textual description of the circle\'s fill style.","o|3Q|jW|1T|2p|ld","Whether to suppress the off-graph indicator when the circle is outside the visible area.","o|3Q|Sj|1V|2p|lf","Maximum value of the curve parameter (always 2π for a circle).","o|3Q|WM|1p|2p|lh","Minimum value of the curve parameter (always 0 for a circle).","o|3Q|WJ|1p|2p|lj","Points the circle is constrained to pass through.","o|Qc|Wo|1X|3M|ll|4X|IM|Qf","The radius of the circle.","o|3Q|kL|1X|2p|ln","diameter","The diameter of the circle.","o|3Q|lp|1X|2p|lq","circumference","The circumference of the circle.","o|3Q|ls|1X|2p|lt","The area enclosed by the circle.","o|3Q|jc|1X|2p|lv","The center coordinates of the circle.","o|Qc|5b|1X|3M|lx|36|IY|j0","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|lV|lW|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|lY|la|lc|le|lg|li|lk|lm|lo|lr|lu|lw|ly","A circle, potentially defined by center, radius, and/or points on the circle","o|F|8u|TV|TW|Op|lU|lz|3M|3M|2p|8u|m0|Az","Points the parabola passes through.","o|2h|Gr|m2|2W","The vertex of the parabola.","o|33|PI|m4||1d","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|m3|WQ|WS|H8|4Y|4c|4g|4j|m5",\'Style description including the word "parabola".\',"o|3Q|Ho|1T|2p|m7","Maximum value of the parabola\'s parameter.","o|3Q|WM|1p|2p|m9","Minimum value of the parabola\'s parameter.","o|3Q|WJ|1p|2p|mB","o|6v|Wo|1X|3M|m2|4X|IM","a","The leading coefficient of the parabola (in y = a x^2 + b x + c).","o|3Q|mE|1p|2p|mF","b","The linear coefficient in y = a x^2 + b x + c.","o|3Q|mH|1p|2p|mI","The constant term in y = a x^2 + b x + c.","o|3Q|15|1p|2p|mK","The vertex coordinates of the parabola.","o|6v|PI|1X|3M|mM|36|IY","The parabola\'s equation as a math expression.","o|3Q|TZ|1X|2p|mO","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|m8|mA|mC|mD|mG|mJ|mL|mN|mP","A parabola defined by formula or geometric parameters","o|F|8v|TV|TW|Op|m6|mQ|3M|3M|2p|8v|mR|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j","a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb","A curve defined by a function, parametric formulas, or control points","o|F|8w|Ut|Uu|Op|mT|mU|3M|3M|2p|8w|mV|Az","a|Wx|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","02122221111111111111111111111222222222122220222212222201221222122222122221212222","alwaysVisible","Whether Bezier control handles are always shown (rather than only when the curve is selected).","o|2m|mZ|ma|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|mb","o|3L|mZ|1V|2p|ma|3M","a|3N|3O|3P|md|3T|3U|3V|3W|3Z","Defines Bezier control vectors at points along a curve","o|F|1g|mX|mY|3l|mc|me|3M|3M|2p|1g|mf|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1O|1X|1Y|1Z|1e|1h|1t|1u|1z|21|24|29|2A|2O|2U|2X|2Y|L|M|N|Q|w|x|y|z|1J|1K|1L|1M|1N|1R|1S|1T|1U|1a|1d|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2K|2Q|2V|2W","1111111111111111111111110221012221211122222222222222222222222222222222222222222","Whether the order of vectors in this list should be treated as unordered (e.g. for matching).","o|2m|4n|mj|2p|2s|1V","Maximum number of vectors to retain in the list.","o|33|g7|ml|9k|1p","Direction in which the control vectors apply at the vertex.","symmetric","previous","next","a|mo|mp|mq|SV|42","Mirror the control vector on both sides of the vertex.","o|3s|mo|ms","Apply the control vector toward the previous segment only.","o|3s|mp|mu","Apply the control vector toward the next segment only.","o|3s|mq|mw","Apply independent control vectors to both adjacent segments.","o|3s|SV|my","No control vector at this vertex.","o|3s|42|n0","a|mt|mv|mx|mz|n1","o|Bi|im|mn|mo|mr|n2|3y","pointNumber","1-based index of the vertex these control vectors attach to.","o|33|n4|n5||1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr|n3|n6","o|3L|g7|1p|2p|ml|3M","o|3L|im|1T|2p|mn|3M","o|3L|n4|1p|2p|n5|3M","numVectors","The number of vectors in the list.","o|3Q|nB|1p|2p|nC","o|3Q|gI|1p|2p|nC","a|3N|3O|n8|n9|nA|3Z|gy|nD|nE","Bezier control vectors at points defining a curve (used inside `<bezierControls>`)","o|F|Wx|mh|mi|g0|n7|nF|2p|3M|2p|Wx|nG|Az","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q","1120111111111111111111111111102201012212111122222220122222222222222222222222222222","Whether the vector can be dragged on a graph.","o|2m|5L|nK|3M|2s|1V","headDraggable","Whether the vector\'s head can be dragged.","o|Ap|nM|nN|2s|1V","tailDraggable","Whether the vector\'s tail can be dragged.","o|Ap|nP|nQ|2s|1V","The first component (x) of the vector\'s displacement.","o|2h|7Q|nS|1X","The second component (y) of the vector\'s displacement.","o|2h|7T|nU|1X","The third component (z) of the vector\'s displacement.","o|2h|7W|nW|1X","The vector\'s displacement components as a list.","o|2h|S5|nY|1Y","displacement","The vector\'s displacement (head minus tail).","o|2h|na|nb|1e","head","The head (tip) point of the vector.","o|2h|nd|ne|1d","tail","The tail (base) point of the vector.","o|2h|ng|nh|1d","headAndTail","headOnly","tailOnly","a|na|nj|nk|nl|42|2q|2r","Show a control handle for translating the whole vector.","o|3s|na|nn","Show control handles for both the head and the tail.","o|3s|nj|np","Show a control handle only at the head.","o|3s|nk|nr","Show a control handle only at the tail.","o|3s|nl|nt","a|no|nq|ns|nu|Sa","o|Bi|ST|SU|na|nm|nv|3y","displayWithAngleBrackets","Whether to display the vector with angle brackets (e.g. ⟨1,2⟩).","o|2m|nx|ny|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|nL|nO|nR|nT|nV|nX|nZ|nc|nf|ni|nw|UB|H8|4Y|4c|4g|4j|nz|P4|So","o|3L|5L|1V|2p|nK|3M","o|3L|nx|1V|2p|ny|3M","A textual description of the vector\'s style.","o|3Q|Hl|1T|2p|o3",\'Style description including the word "vector".\',"o|3Q|Ho|1T|2p|o5","Whether the vector\'s tail can be dragged independently.","o|3Q|nP|1V|2p|o7","Whether the vector\'s head can be dragged independently.","o|3Q|nM|1V|2p|o9","Number of dimensions of the vector.","o|3Q|6r|1p|2p|oB","The displacement (head − tail) of the vector.","o|Qc|na|1X|3M|oD|36|6z|j0","Coordinates of the vector\'s head.","o|Qc|nd|1X|3M|oF|36|IY|j0","Coordinates of the vector\'s tail.","o|Qc|ng|1X|3M|oH|36|IY|j0","magnitude","The magnitude (length) of the vector.","o|3Q|oJ|1X|2p|oK","The vector rendered as a LaTeX string.","o|3Q|2V|2V|2p|oM","o|3Q|7Q|1X|2p|nS","o|3Q|7T|1X|2p|nU","o|3Q|7W|1X|2p|nW","a|3N|3O|3P|Hd|QD|7s|QE|o1|Sy|UG|o2|QG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|o4|o6|o8|oA|oC|oE|oG|oI|oL|oN|oO|oP|oQ","A geometric vector with tail and head","o|F|1h|nI|nJ|Op|o0|oR|3M|3M|2p|1h|oS|Az","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y","1120111111111111111111111112122022210112221222221222112222222222222222222222222222","Radius of the rendered angle arc.","1","o|5H|1X|oX","o|33|kL|oW|oY|1X","chooseReflexAngle","How to handle reflex angles.","never","allowed","always","a|oc|od|oe","Always normalize to the non-reflex angle (less than 180°).","o|3s|oc|og","Use a reflex angle (greater than 180°) if it matches the input.","o|3s|od|oi","Always render the angle as a reflex angle.","o|3s|oe|ok","a|oh|oj|ol","o|Bi|oa|ob|oc|of|om|3y","inDegrees","Whether to interpret and display the angle in degrees rather than radians.","o|2m|oo|op|2p|2s|1V","radians","The angle measure in radians.","o|2h|or|os|1X","degrees","The angle measure in degrees.","o|2h|ou|ov|1X","Three points (vertex in the middle) defining the angle.","o|2h|Gr|ox|2W","betweenLines","Two lines whose intersection forms the angle.","_lineListComponent","o|2h|oz|p0|p1","emphasizeRightAngle","Whether to render right angles with the conventional square symbol.","o|2m|p3|p4|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|oZ|on|oq|ot|ow|oy|p2|H8|4Y|4c|4g|4j|p5","o|3L|kL|1X|2p|oW|3M","o|3L|oa|1T|2p|ob|3M","o|3L|oo|1V|2p|op|3M","o|3L|p3|1V|2p|p4|3M","o|3Q|or|1X|2p|os","o|3Q|ou|1X|2p|ov","o|3Q|3a|1X|2p|os","o|3Q|1i|1X|2p|os","a|3N|3O|3P|Hd|QD|7s|QE|p7|p8|p9|pA|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|pB|pC|pD|pE","An angle defined by three points or a measure","o|F|1i|oU|oV|Op|p6|pF|3M|3M|2p|1i|pG|Az","considerAsResponses","a|8x|1z|1R|1S|1k|1l|1m|1n|pI|I|J|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2T","021111110110001222211111111111111111111112221222221000010212220012212221222221112212112221111111110011","Relative weight of this answer when aggregating credit across multiple answers.","answer-grading","o|4U|9c|pL|pM|36|1p","handGraded","Whether this answer is graded by hand rather than automatically.","o|4d|pO|pP|pM|2p|2s|1V","matchPartial","Whether to award partial credit when the response is partially correct.","o|4d|pR|pS|pM|2p|2s|1V","Maximum number of times the response can be submitted.","o|4U|9i|pU|pM|9k|1q","Whether to display whether the submitted response is correct.","o|4d|9m|pW|pM|3M|2s|1V","Whether to color-code the response based on its correctness.","o|4d|9p|pY|pM|3M|2s|1V","disableAfterCorrect","Whether to disable the answer after a fully correct response has been submitted.","o|4d|pa|pb|pM|2p|2s|1V","Label for the submit button when correctness is shown.","o|4U|9v|pd|pM|9x|1T","Label for the submit button when correctness is not shown.","o|4U|9z|pf|pM|A1|1T","displayDigitsForResponses","Number of significant digits to display when rendering numeric responses.","o|4U|ph|pi|pM|Nn|1q","o|4U|A3|A4|pM|4S|1q","a|3|2f|3m|2k|2l|2g","Whether to render the answer\'s input inline rather than as a block.","o|pl|3h|pm|3M|2p|2s|1V","Whether comparison uses symbolic equality (rather than numeric evaluation).","o|pl|Bc|po|3M|2p|2s|1V","forceFullCheckWorkButton","Whether to always render a full-size check-work button.","o|2m|pq|pr|2p|2s|1V","forceSmallCheckWorkButton","Whether to always render a small check-work button.","o|2m|pt|pu|2p|2s|1V","Level of simplification applied to math expressions before comparing them.","o|Bi|Bj|pw|42|47|Bp|3y","Whether to expand math expressions before comparing them.","o|2m|Bf|py|2p|2s|1V","Whether order is ignored when comparing list-like responses.","o|2m|Br|q0|2p|2s|1V","Whether to match list responses by exact position rather than by content.","o|2m|Bu|q2|2p|2s|1V","numAwardsCredited","Maximum number of matching awards whose credits are summed.","o|33|q4|q5|36|1q","colorInputsSeparately","Attempt to color each input separately based on the awards that reference it, rather than all inputs sharing the same overall credit color.","o|2m|q7|q8|2p|2s|1V","Maximum allowed numeric error when comparing numbers (relative or absolute).","o|33|Bx|qA|5Q|1p","Type of input the answer expects.","videoWatched","a|1X|1T|1V|qD","Expect a math expression answer.","o|3s|1X|qF","Expect a text answer.","o|3s|1T|qH","Expect a boolean answer.","o|3s|1V|qJ","Mark correct when the associated video has been watched.","o|3s|qD|qL","a|qG|qI|qK|qM","o|Bi|2g|qC||qE|qN|3y","selectMultiple","For choice answers: whether multiple choices may be selected.","o|2m|qP|qQ|2p|2s|1V","shuffleOrder","For choice answers: whether to display choices in randomized order.","o|2m|qS|qT|2p|2s|1V","preserveLastChoice","For choice answers: whether the last-rendered choice keeps its position when shuffling.","o|2m|qV|qW|2p|2s|1V","disableWrongChoices","Whether incorrect choices are disabled after being submitted.","o|2m|qY|qZ|2p|2s|1V","creditByAttempt",\'Per-attempt credit multipliers (e.g. "1 0.7 0.5" for full/70%/50% on attempts 1/2/3+).\',"o|33|qb|qc|54|1a","Whether multi-character symbols should be split into a product of single-character variables when parsing.","o|2m|56|qe|3M|2s|1V","expanded","Whether the answer\'s submitted-response panel is expanded by default.","o|2m|qg|qh|2p|2s|1V","showPreview","Whether to display a preview of the response as the student types.","o|2m|qj|qk|2p|2s|1V","Reference to a video; when watched, this answer\'s videoWatched type marks credit.","o|2h|9D|qm|3D","videoCreditLabel","Label shown next to the credit indicator for a video-watched answer.","o|2h|qo|qp|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|pn|pp|ps|pv|px|pz|q1|q3|q6|q9|qB|C2|C5|C8|CB|CE|CH|qO|qR|qU|qX|qa|qd|qf|5B|qi|ql|qn|qq|GH","o|6J|9c|1p|2p|pL|3M|pM","o|6J|pO|1V|2p|pP|3M|pM","o|6J|pR|1V|2p|pS|3M|pM","o|6J|9i|1q|2p|pU|3M|pM","o|6J|pa|1V|2p|pb|3M|pM","o|6J|9v|1T|2p|pd|3M|pM","o|6J|9z|1T|2p|pf|3M|pM","o|6J|ph|1q|2p|pi|3M|pM","o|6J|A3|1q|2p|A4|3M|pM","o|65|3h|1V|2p|pm|3M|3M","o|65|Bc|1V|2p|po|3M|3M","o|3L|pq|1V|2p|pr|3M","o|3L|pt|1V|2p|pu|3M","o|3L|Bj|1T|2p|pw|3M","o|3L|Bf|1V|2p|py|3M","o|3L|Br|1V|2p|q0|3M","o|3L|Bu|1V|2p|q2|3M","o|3L|q4|1q|2p|q5|3M","o|3L|q7|1V|2p|q8|3M","o|3L|Bx|1p|2p|qA|3M","o|3L|qP|1V|2p|qQ|3M","o|3L|qS|1V|2p|qT|3M","o|3L|qV|1V|2p|qW|3M","o|3L|qY|1V|2p|qZ|3M","o|3L|qb|1a|2p|qc|3M","o|3L|56|1V|2p|qe|3M","o|3L|qg|1V|2p|qh|3M","o|3L|qj|1V|2p|qk|3M","The fraction of credit achieved on the most recent submission (between 0 and 1).","o|3Q|AL|1p|2p|rK","responseHasBeenSubmitted","Whether a response has ever been submitted for this answer.","o|3Q|rM|1V|2p|rN","justSubmitted","Whether the most recent submission for this answer has not yet been changed.","o|3Q|rP|1V|2p|rQ","Total number of times a response has been submitted.","o|3Q|AD|1q|2p|rS","Remaining number of submission attempts before the maximum is reached.","o|3Q|AG|1q|2p|rU","Whether this answer is disabled and is no longer accepting submissions.","o|3Q|2u|1V|2p|rW","Whether any input within this answer currently has keyboard focus.","o|3Q|eQ|1V|2p|rY","numResponses","The number of current (unsubmitted) response values from this answer\'s inputs.","o|3Q|ra|1p|2p|rb","a|3|3J|2f|6r|6u","currentResponses","The current (unsubmitted) response values from this answer\'s inputs.","a|3J|6r","o|rg|3M|36","a|rh","o|rd|re|3M|rf|36|ri","numSubmittedResponses","The number of response values from the most recent submission.","o|3Q|rk|1p|2p|rl","submittedResponses","The response values from the most recent submission.","o|rd|rn|3M|ro|36|ri","numFeedbacks","The number of feedback messages produced by matched awards or applicable feedback definitions.","o|3Q|rq|1p|2p|rr","feedbacks","The feedback messages produced by matched awards or applicable feedback definitions.","o|73|3M|9F|36","a|rv","o|6v|rt|9F|3M|ru|36|rw","a|3|3J|2f","currentResponse","The current (unsubmitted) response value from the answer\'s first input.","o|ry|rz|2p|s0","submittedResponse","The first response value from the most recent submission.","o|ry|s2|2p|s3","a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|r1|r2|r3|r4|r5|r6|r7|r8|r9|rA|rB|CP|CQ|CR|CS|CT|CU|rC|rD|rE|rF|rG|rH|6E|rI|rJ|Hd|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|Hk|rZ|rc|rj|rm|rp|rs|rx|s1|s4","answer1","Assigns credit to student responses based on matches or logical rules","o|F|1j|pJ|pK|3l|qr|s5|3M|2p|2p|s6|s7|3h","when","a|s9|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a","02122221111111111111111111111222122222122020222212222201221222122222111221211222221111111110212120","credit","Fraction of credit (0 to 1) granted when this award matches.","o|33|sC|sD|36|1p","o|2m|pR|pS|2p|2s|1V","o|2m|Bc|po|2p|2s|1V","feedbackCodes","Codes that select reusable feedback messages when this award matches.","o|33|sH|sI|54|1U","feedbackText","Custom feedback text shown when this award matches.","o|33|sK|sL||1T","referencesAreResponses","References to components whose values should be treated as responses for this award.","o|2h|sN|sO|3D","a|2j|2t|2w|2z|32|37|3A|3E|3H|sE|sF|sG|pz|px|q1|q3|qB|C2|C5|C8|CB|CE|CH|sJ|sM|sP|qf|5B","o|3L|sC|1p|2p|sD|3M","o|3L|pR|1V|2p|pS|3M","o|3L|Bc|1V|2p|po|3M","o|3L|sH|1U|2p|sI|3M","o|3L|sK|1T|2p|sL|3M","creditAchievedIfSubmit","Credit (0 to 1) this award would grant if submitted with the current response.","o|3Q|sW|1p|2p|sX","fractionSatisfiedIfSubmit","Fraction (0 to 1) by which this award\'s match condition is currently satisfied.","o|3Q|sZ|1p|2p|sa","fractionSatisfied","Fraction (0 to 1) by which this award\'s match condition was satisfied at last submission.","o|3Q|sc|1p|2p|sd","Credit (0 to 1) this award granted at the last submission.","o|3Q|AL|1p|2p|sf","awarded","Whether this award was matched at the last submission.","o|3Q|sh|1V|2p|si","The number of feedback messages associated with this award.","o|3Q|rq|1p|2p|sk","The feedback messages produced by this award.","o|6v|rt|9F|3M|sm|36|rw","The first feedback message produced by this award.","o|3Q|9F|9F|2p|so","a|3N|3O|3P|sR|sS|sT|r6|r5|r7|r8|rB|CP|CQ|CR|CS|CT|CU|sU|sV|rH|6E|3T|3U|3V|3W|3Z|sY|sb|se|sg|sj|sl|sn|sp","Specifies conditions for awarding credit in an answer","o|F|8x|sA|sB|Ao|sQ|sq|3M|3M|2p|8x|sr|Az","Whether to match partial conditions for partial credit.","o|2m|pR|st|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|su","o|3L|pR|1V|2p|st|3M","Whether the condition is currently true.","o|3Q|3a|1V|2p|sx","Fraction of the boolean condition that is satisfied (0 to 1).","o|3Q|sc|1p|2p|sz","Whether the condition is currently satisfied; equivalent to value.","o|3Q|Au|1V|2p|t1","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|sw|3T|3U|3V|3W|3Z|sy|t0|t2|CW","Defines logical conditions within an `<award>`","o|F|s9|BY|BZ|3l|sv|t3|2p|3M|2p|s9|t4|3h","Initial value displayed in the input.","o|33|Zj|t6|5J|1X","prefillLatex","Initial value as a LaTeX string.","o|33|t8|t9|AZ|2V","o|Bi|3p|3q|1T|3r|3x|3y","additionalFunctionNames","Extra identifiers to auto-format as function names in the editor (e.g., \'erf\'). Entries that also appear in `removedFunctionNames` are dropped.","o|33|tC|tD|54|1U","removedFunctionNames","Built-in function names to stop auto-formatting in the editor (e.g., \'min\' so \'kg/min\' can be typed as a unit).","o|33|tF|tG|54|1U","resetFunctionNames","When set, replaces the entire auto-formatted function name list (defaults, `additionalFunctionNames`, and `removedFunctionNames` are all ignored). Set to an empty value to disable auto-formatting entirely.","o|33|tI|tJ||1U","Whether multi-character symbols are split into a product of single-character variables.","o|2m|56|tL|3M|2s|1V","hideNaN","Whether to hide NaN values when displaying the input.","o|2m|tN|tO|3M|2s|1V","removeStrings","Substrings to strip from the input before parsing.","o|33|tQ|tR||1U","minWidth","Minimum rendered width of the input.","n|o","o|33|tT|tU|tV|1q","Whether to display a preview of the parsed math.","o|2m|qj|tX|2p|2s|1V","Whether the input can be dragged on a graph.","o|2m|5L|tZ|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|t7|tA|tB|51|tE|tH|tK|tM|5B|e7|4Y|e8|4g|4j|eB|eE|tP|tS|tW|tY|ta|5X|63","o|3L|Zj|1X|2p|t6|3M","o|3L|t8|2V|2p|t9|3M","o|3L|3p|1T|2p|3q|3M","o|3L|tC|1U|2p|tD|3M","o|3L|tF|1U|2p|tG|3M","o|3L|tI|1U|2p|tJ|3M","o|3L|56|1V|2p|tL|3M","o|3L|tN|1V|2p|tO|3M","o|3L|tT|1q|2p|tU|3M","o|3L|5L|1V|2p|tZ|3M","Whether this input currently has keyboard focus.","o|3Q|eQ|1V|2p|tm","o|3Q|qj|1V|2p|tX","The math value of the input.","o|3Q|3a|1X|2p|tp","The math value reflecting the user\'s in-progress edits.","o|3Q|ef|1X|2p|tr","The current input as a text string.","o|3Q|1T|1T|2p|tt","rawRendererValue","The raw value used by the renderer (e.g. LaTeX string).","o|3Q|tv|2V|2p|tw","a|3N|3O|3P|eJ|Hd|tc|td|te|6C|tf|tg|th|ti|6E|eN|tj|tk|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6X|6Y|6Z|6a|6b|6W|to|eV|tq|eY|ts|tu|tx|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","An interactive math input","o|F|1k|ep|eq|dh|tb|ty|3M|3M|2p|1k|tz|3h","a|I|J|1z|2S|2f|dd|H|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2T|2U|2V|2X","112000222222222222222222222222222222222222122202222222222222222222222112222212","Initial text shown in the input before the user types.","o|33|Zj|u3|AZ|1T","o|2h|e9|eA|1T","Whether the input renders as a multi-line text area.","o|2m|qg|u6|2p|2s|1V","Display width of the input.","o|2h|bx|u8|bz","Display height of the input.","size","isAbsolute","a|uB|uC","n|1w","o|uD|uE|3M","o|33|k5|uA|uF|bz","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|u4|u5|u7|u9|uG|ta|5X|63","o|3L|Zj|1T|2p|u3|3M","o|3L|qg|1V|2p|u6|3M","o|3L|k5|bz|2p|uA|3M","o|3Q|bx|bz|2p|u8","The text value of the input.","o|3Q|3a|1T|2p|uM","The text value reflecting the user\'s in-progress edits.","o|3Q|ef|1T|2p|uO","The current text as a plain text string.","o|3Q|1T|1T|2p|uQ","a|3N|3O|3P|eJ|Hd|uI|uJ|uK|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|eV|eY|6W|uL|uN|uP|uR|Jp|Ju|Jx|K0|K2|K4","An interactive text input","o|F|1l|u1|u2|dh|uH|uS|3M|3M|2p|1l|uT|3h","a|I|J|1z|2S|2f|dd|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|2R|2T|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y","11200011111111102211122221111111111111111111111222222222122220222212222201221222122222122221212222","o|Bi|GL|di|5i|dj|do|3y","The initial value of the input before the student interacts.","o|2m|Zj|uY|2p|2s|1V","asToggleButton","Whether to render the input as a toggle button rather than a checkbox.","o|2m|ua|ub|2p|2s|1V","o|Ap|e9|eA|2s|1V","Whether the input can be dragged on a graph by its anchor.","o|2m|5L|ue|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|uX|ds|GH|uZ|uc|ud|uf|5X|63","o|3L|Zj|1V|2p|uY|3M","o|3L|ua|1V|2p|ub|3M","o|3L|5L|1V|2p|ue|3M","Whether the input\'s value has been changed from its prefill value.","o|3Q|eT|1V|2p|uk","The current boolean value of the input.","o|3Q|3a|1V|2p|um",\'The current value rendered as a text string ("true" or "false").\',"o|3Q|1T|1T|2p|uo","a|3N|3O|3P|eJ|Hd|uh|ui|uj|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6W|ul|un|up","An interactive boolean (toggle/checkbox) input","o|F|1m|uV|uW|dh|ug|uq|3M|3M|2p|1m|ur|3h","a|I|J|1z|2S|2f|dd|1o","Whether multiple choices may be selected.","o|2m|qP|uu|2p|2s|1V","Whether to award partial credit when only some correct choices are selected.","o|2m|pR|uw|2p|2s|1V","Whether to render the input inline (as a dropdown) rather than as a list of choices.","o|2m|3h|uy|2p|2s|1V","Whether to display the choices in randomized order.","o|2m|qS|v0|2p|2s|1V","Whether the last-rendered choice keeps its position when shuffling.","o|2m|qV|v2|2p|2s|1V","preselectChoice","Index of a choice to pre-select on initial render.","o|33|v4|v5||1p","placeHolder","Placeholder text shown when no choice is selected.","o|33|v7|v8|AZ|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|uv|ux|uz|v1|v3|v6|u5|v9","o|3L|qP|1V|2p|uu|3M","o|3L|pR|1V|2p|uw|3M","o|3L|qS|1V|2p|v0|3M","o|3L|qV|1V|2p|v2|3M","Whether the input is rendered inline (as a dropdown).","o|3Q|3h|1V|2p|vF","numChoices","The number of choices available in the input.","o|3Q|vH|1p|2p|vI","choiceTexts","The text contents of all choices in displayed order.","o|6v|vK|1T|3M|vL|36|Jt","choiceMaths","The math expressions of all choices in displayed order.","o|6v|vN|1X|3M|vO|36|75","Whether the input\'s selection has been changed from its initial state.","o|3Q|eT|1V|2p|vQ","selectedIndices","Indices (1-based) of the currently selected choices.","o|6v|vS|1p|3M|vT|36|IR","selectedValues","Text values of the currently selected choices.","o|rd|vV|3M|vW|36|ri","The number of feedback messages produced by selected choices.","o|3Q|rq|1p|2p|vY","Feedback messages produced by selected choices.","o|6v|rt|9F|3M|va|36|rw","selectedIndex","The 1-based index of the first currently selected choice.","o|3Q|vc|1p|2p|vd","selectedValue","The text value of the first currently selected choice.","o|ry|vf|2p|vg","The text values of the currently selected choices.","o|rd|2l|3M|vi|36|ri","valueToRecordOnSubmit","Indices of the currently selected choices (recorded when the answer is submitted).","o|6v|vk|1p|3M|vl|36|IR","a|3N|3O|3P|eJ|Hd|vB|vC|vD|vE|3T|3U|3V|3W|3Z|Hk|eP|tn|vG|vJ|vM|vP|vR|vU|vX|vZ|vb|ve|vh|vj|vm","A multiple-choice input, allowing selection from a list of choices","o|F|1n|ut|df|dh|vA|vn|3M|2p|2p|1n|vo|3h","Fraction of credit (0 to 1) granted when this choice is selected.","o|33|sC|vq|5Q|1p","Codes that select reusable feedback messages when this choice is selected.","o|33|sH|vs|54|1U","Custom feedback text shown when this choice is selected.","o|33|sK|vu||1T","preSelect","Whether this choice is pre-selected on initial render.","o|2m|vw|vx|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|vr|vt|vv|vy","o|3L|sC|1p|2p|vq|3M","o|3L|sH|1U|2p|vs|3M","o|3L|sK|1T|2p|vu|3M","The choice\'s content as a text string.","o|3Q|1T|1T|2p|w3","The choice\'s content interpreted as a math expression.","o|3Q|1X|1X|2p|w5","selected","Whether this choice is currently selected.","o|3Q|w7|1V|2p|w8","submitted","Whether this choice was selected at the most recent submission.","o|3Q|wA|1V|2p|wB","Whether this choice is disabled (cannot be selected).","o|3Q|2u|1V|2p|wD","feedbacktext","Feedback messages shown when this choice is selected.","o|3Q|rt|wF|2p|wG","a|3N|3O|3P|w0|w1|w2|3T|3V|3W|3Z|w4|w6|w9|wC|wE|wH","A single choice within a `<choiceInput>` or an `<answer>`.","o|F|1o|9U|9V|3l|vz|wI|3M|3M|2p|1o|wJ|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m","111111111111111111111111102022210112222122222111211122222222222222222222222222222111111111021212","renderAsMath","Whether to render the number using math typography.","o|2m|wN|wO|2p|2s|1V","convertBoolean","Whether to convert boolean inputs to 1/0 instead of NaN.","o|2m|wQ|wR|2p|2s|1V","valueOnNaN","Numeric value to use when the input cannot be parsed.","NaN","o|33|wT|wU|wV|1p","Whether the number can be dragged on a graph.","o|2m|5L|wX|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j|wP|wS|wW|wY|5R|5X|63","o|3L|wN|1V|2p|wO|3M","o|3L|5L|1V|2p|wX|3M","The numeric value.","o|3Q|3a|1p|2p|wc","The number rendered as plain text.","o|3Q|1T|1T|2p|we","The number\'s value as a math expression.","o|3Q|1X|1X|2p|wg","The number rendered as LaTeX.","o|3Q|2V|2V|2p|wi","a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wd|wf|wh|wj","A numeric floating point value","o|F|1p|wL|wM|3l|wZ|wk|3M|3M|2p|1p|wl|3h","The integer value.","o|3Q|3a|1q|2p|wn","a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wf|wh|wj|wo","An integer value","o|F|1q|wL|wM|3l|wZ|wp|3M|3M|2p|1q|wq|3h","a|I|1z|J|dd|2f|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y|9C|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|z|1L|1M|1T|1U|1V|1W|1a|1o|1p|1q|1v|25|26|27|28|2B|2C|2D|2R|2S|2T|2V|1N|1R|1S|1k|O|P|2E|2F|2G|1m|1l|8y|8z","020001111111111111111111111122211111022211111111111111122122212222121212212111111122200111222222222122022222012222211220212220010000000","xMin","Minimum value displayed on the x axis.","n|-A","o|33|wu|wv|ww|1p","xMax","Maximum value displayed on the x axis.","o|33|wy|wz|Nn|1p","yMin","Minimum value displayed on the y axis.","o|33|x1|x2|ww|1p","yMax","Maximum value displayed on the y axis.","o|33|x4|x5|Nn|1p","Explicit width of the graph (overrides size).","o|2h|bx|x7|bz","Named size preset for the graph.","medium","tiny","small","large","a|xB|xC|xA|xD|43","About 1/12 the full width.","o|3s|xB|xF","About 30% of the full width.","o|3s|xC|xH","About half the full width.","o|3s|xA|xJ","About 70% of the full width.","o|3s|xD|xL","The full available width.","o|3s|43|xN","a|xG|xI|xK|xM|xO","o|Bi|uB|x9|xA|xE|xP|3y","aspectRatio","Aspect ratio (width / height) for the graph.","o|33|xR|xS|36|1p","displayMode","How to size the graph.","a|AT|3h","Display as a block element on its own line.","o|3s|AT|xX","Render inline with surrounding text.","o|3s|3h|xZ","a|xY|xa","o|Bi|xU|xV|AT|xW|xb|3y","horizontalAlign","Horizontal alignment of the graph within its container.","a|5b|5h|5i","Center the graph horizontally.","o|3s|5b|xg","Align the graph to the left edge.","o|3s|5h|xi","Align the graph to the right edge.","o|3s|5i|xk","a|xh|xj|xl","o|Bi|xd|xe|5b|xf|xm|3y","identicalAxisScales","Whether to force the x and y axis scales to be equal.","o|2m|xo|xp|2p|2s|1V","displayXAxis","Whether to display the x axis.","o|2m|xr|xs|3M|2s|1V","displayYAxis","Whether to display the y axis.","o|2m|xu|xv|3M|2s|1V","Whether to render interactive zoom/pan controls.","all","slidersOnly","inputsOnly","a|xy|xz|y0|42|2q|2r","Render both sliders and input boxes.","o|3s|xy|y2","Render only slider controls.","o|3s|xz|y4","Render only input-box controls.","o|3s|y0|y6","Render no interactive controls.","o|3s|42|y8","a|y3|y5|y7|y9","o|Bi|ST|xx|42|y1|yA|3y","controlsPosition","Position of the graph controls.","a|5g|5h|5i|9","Place controls below the graph.","o|3s|5g|yF","Place controls to the left of the graph.","o|3s|5h|yH","Place controls to the right of the graph.","o|3s|5i|yJ","Place controls above the graph.","o|3s|9|yL","a|yG|yI|yK|yM","o|Bi|yC|yD|5h|yE|yN|3y","displayXAxisTicks","Whether to display tick marks on the x axis.","o|2m|yP|yQ|3M|2s|1V","displayYAxisTicks","Whether to display tick marks on the y axis.","o|2m|yS|yT|3M|2s|1V","displayXAxisTickLabels","Whether to display labels on x-axis ticks.","o|2m|yV|yW|3M|2s|1V","displayYAxisTickLabels","Whether to display labels on y-axis ticks.","o|2m|yY|yZ|3M|2s|1V","xLabelPosition","Position of the x-axis label.","a|5i|5h","Place the x-axis label at the right end of the axis.","o|3s|5i|ye","Place the x-axis label at the left end of the axis.","o|3s|5h|yg","a|yf|yh","o|Bi|yb|yc|5i|yd|yi|3y","xTickScaleFactor","Scale factor applied to x-axis tick spacing.","o|33|yk|yl||1X","yLabelPosition","Position of the y-axis label.","a|9|5g","Place the y-axis label at the top of the axis.","o|3s|9|yq","Place the y-axis label at the bottom of the axis.","o|3s|5g|ys","a|yr|yt","o|Bi|yn|yo|9|yp|yu|3y","yLabelAlignment","Alignment of the y-axis label.","Align the y-axis label to the left of the axis.","o|3s|5h|yy","Align the y-axis label to the right of the axis.","o|3s|5i|z0","a|yz|z1","o|Bi|yw|yx|5h|dj|z2|3y","yTickScaleFactor","Scale factor applied to y-axis tick spacing.","o|33|z4|z5||1X","showNavigation","Whether to show navigation controls (pan/zoom).","o|2m|z7|z8|3M|2s|1V","fixAxes","Whether the axis limits are locked (preventing zoom/pan).","o|2m|zA|zB|2p|2s|1V","grid","Grid density to render on the graph (off, minor, medium, or major).","o|2h|zD|zE|1T","showBorder","Whether to render a border around the graph.","o|2m|zG|zH|3M|2s|1V","hideOffGraphIndicators","Whether to suppress indicators for objects outside the visible region.","o|2m|zJ|zK|2p|2s|1V","decorative","Whether the graph is purely decorative (excluded from a11y tree).","o|2m|zM|zN|2p|2s|1V","renderer","Which renderer to use for the graph.","doenet","prefigure","a|zR|zS","Render using the built-in Doenet graph renderer.","o|3s|zR|zU","Render using the PreFigure SVG-based renderer.","o|3s|zS|zW","a|zV|zX","o|Bi|zP|zQ|zR|zT|zY|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|wx|x0|x3|x6|x8|xQ|xT|xc|xn|xq|xt|xw|yB|yO|yR|yU|yX|ya|yj|ym|yv|z3|z6|z9|zC|zF|H8|4Y|4c|4g|4j|zI|zL|zO|zZ","o|3L|xU|1T|2p|xV|3M","o|3L|xd|1T|2p|xe|3M","o|3L|xo|1V|2p|xp|3M","o|3L|xr|1V|2p|xs|3M","o|3L|xu|1V|2p|xv|3M","o|3L|ST|1T|2p|xx|3M","o|3L|yC|1T|2p|yD|3M","o|3L|yP|1V|2p|yQ|3M","o|3L|yS|1V|2p|yT|3M","o|3L|yb|1T|2p|yc|3M","o|3L|yk|1X|2p|yl|3M","o|3L|yn|1T|2p|yo|3M","o|3L|yw|1T|2p|yx|3M","o|3L|z4|1X|2p|z5|3M","o|3L|z7|1V|2p|z8|3M","o|3L|zG|1V|2p|zH|3M","o|3L|zJ|1V|2p|zK|3M","o|3L|zM|1V|2p|zN|3M","o|3L|zP|1T|2p|zQ|3M","A short accessibility description of the graph.","o|3Q|dd|1T|2p|zu","Whether the visible axes range is locked.","o|3Q|zA|1V|2p|zw","The x-axis label text.","o|3Q|I|2S|2p|zy","The y-axis label text.","o|3Q|J|2S|2p|100","hasAuthorAnnotations","Whether the graph contains any author-provided `<annotations>` child.","o|3Q|102|1V|2p|103","prefigureXML","The Prefigure-formatted XML rendered for this graph, or null if not using the Prefigure renderer.","o|3Q|105|1T|2p|106","The size of the graph.","o|3Q|uB|1T|2p|108","The width of the graph.","o|3Q|bx|bz|2p|10A","The aspect ratio (width / height) of the graph.","o|3Q|xR|1p|2p|10C","effectiveRenderer","The renderer actually used after resolving fallbacks.","o|3Q|10E|1T|2p|10F","Whether x-axis tick labels are displayed.","o|3Q|yV|1V|2p|10H","Whether y-axis tick labels are displayed.","o|3Q|yY|1V|2p|10J","Minimum x value displayed.","o|3Q|wu|1p|2p|10L","Maximum x value displayed.","o|3Q|wy|1p|2p|10N","Minimum y value displayed.","o|3Q|x1|1p|2p|10P","Maximum y value displayed.","o|3Q|x4|1p|2p|10R","xScale","Scale used along the x axis (xMax − xMin).","o|3Q|10T|1p|2p|10U","yScale","Scale used along the y axis (yMax − yMin).","o|3Q|10W|1p|2p|10X","Grid line spacing on the graph.","o|ry|zD|2p|10Z","a|3N|3O|3P|zb|zc|zd|ze|zf|zg|zh|zi|zj|zk|zl|zm|zn|zo|zp|zq|zr|zs|zt|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|zv|zx|zz|101|104|107|109|10B|10D|10G|10I|10K|10M|10O|10Q|10S|10V|10Y|10a","A 2D coordinate-axis graph","o|F|8y|ws|wt|9X|za|10b|3M|2p|2p|8y|10c|AT","a|90|1z","A container of annotation children for screen reader navigation of a graph","o|F|8z|10e|BN|Ao|3I|Aa|3M|2p|2p|8z|10f|Az","Reference to the component this annotation is attached to.","o|2h|1c|10h|3D","The annotation text read by screen readers.","o|33|1T|10j|AZ|1T","speech","More detailed spoken text used by screen readers; used if expert mode is activated or extra details are requested.","o|33|10l|10m|AZ|1T","sonify","Whether to play a tone when this annotation is focused and it references a function.","o|2m|10o|10p|2p|2s|1V","circular","Whether navigation through this annotation\'s children wraps around.","o|2m|10r|10s|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|10i|10k|10n|10q|10t","o|3L|1T|1T|2p|10j|3M","o|3L|10l|1T|2p|10m|3M","o|3L|10o|1V|2p|10p|3M","o|3L|10r|1V|2p|10s|3M","a|3N|3O|3P|10v|10w|10x|10y|3T|3U|3V|3W|3Z","An annotation for screen reader navigation of a graph","o|F|90|10e|BN|Ao|10u|10z|3M|2p|2p|90|110|Az","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT","The symbolic formula of the function.","o|3Q|I9|1X|2p|113","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|114|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A mathematical function, defined by formula or interpolation","o|F|1r|Fo|Fp|3l|112|115|3M|3M|2p|1r|116|3h","a|w|x|y|1r|1s|1z|I|J|2S","111012110","a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|GD|GH|GK|Gf|Gh|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT","Number of output values.","o|3Q|G8|1q|2p|11B","The piecewise formula of the function.","o|3Q|I9|1X|2p|11D","The piecewise function rendered as a LaTeX string.","o|3Q|2V|2V|2p|11F","a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|11C|I0|I2|I4|I8|11E|11G|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6","A function defined piecewise from sub-functions on intervals","o|F|1s|118|119|3l|11A|11H|3M|2p|2p|1s|11I|3h","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|51|55|58|5B|5E|5K|5N|5R|5X|63","o|3Q|3a|1t|2p|6e","Whether this math component renders intervals as intervals (always true for `<interval>`).","o|3Q|4t|1V|2p|11M","a|3N|3O|3P|66|67|68|69|6A|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|11L|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|11N|7S|7V|7Y|7b","A math expression treated as an interval of real numbers","o|F|1t|3j|3k|3l|11K|11O|3M|3M|2p|1t|11P|3h","option","selectForVariants","Variant indices for which this option is selected.","textListFromString","o|33|11S|11T|54|11U","selectWeight","Relative weight when randomly selecting an option.","o|33|11W|11X|36|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|11V|11Y","o|3L|11S|11U|2p|11T|3M","o|3L|11W|1p|2p|11X|3M","a|3N|3O|3P|11a|11b|3T|3U|3V|3W|3Z","A single option within a `<select>` block","o|F|11R|9U|9V|Ao|11Z|11c|2p|3M|2p|11R|11d|Az","The kind of values in the sequence.","letters","a|1p|1X|11g","A sequence of numeric values.","o|3s|1p|11i","A sequence of math expressions (allows symbolic from/to/step).","o|3s|1X|11k","A sequence of letters (single-letter or multi-letter labels).","o|3s|11g|11m","a|11j|11l|11n","o|HC|2g|11f|11h|11o|3y","The first value in the sequence.","_componentWithSelectableType","o|2h|hM|11q|11r","The last value in the sequence. Used together with from to determine length when length is not specified.","o|2h|hX|11t|11r","step","The increment between successive values in the sequence.","o|2h|11v|11w|1X","The number of values in the sequence.","o|2h|Qh|11y|1q","exclude","Values to exclude from the sequence.","_componentListWithSelectableType","o|2h|120|121|122","a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB","a|3N|3O|3P|3Z","Generates a sequence of numbers, math expressions, or letters","o|F|1u|54|AZ|g0|124|125|3M|2p|3M|1u|126|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|1L|1M|1V|1W|1o|2R|2S|2T","2222222222222222222222212022222201222222222222112221211222222222222222222202","Type of value the slider produces.","a|1p|1T","Slider produces numeric values between `from` and `to`.","o|3s|1p|12C","Slider produces text values, one per child of the slider.","o|3s|1T|12E","a|12D|12F","o|3o|2g|12A|3M|1p|12B|12G|3y","Display width of the slider.","n|4q","o|uD|12J|3M","o|33|bx|12I|12K|bz","Display height of the slider.","n|1c","o|uD|12N|3M","o|33|k5|12M|12O|bz","initialValue","Initial value of the slider before any user interaction.","o|33|12Q|12R||11r","showControls","Whether to render play/pause controls alongside the slider.","o|2m|12T|12U|2p|2s|1V","showTicks","Whether to render tick marks on the slider.","o|2m|12W|12X|3M|2s|1V","rotateTickLabels","Whether to rotate the tick labels.","o|2m|12Z|12a|2p|2s|1V","showValue","Whether to display the current value next to the slider.","o|2m|12c|12d|3M|2s|1V","a|3|2f|3m|2k|2g","Minimum value of the slider\'s range.","o|12f|hM|12g|3M|5Q|1p","Maximum value of the slider\'s range.","o|12f|hX|12i|3M|Nn|1p","Increment between successive slider positions.","o|12f|11v|12k|3M|36|1p","o|2h|e9|eA|11r","a|2j|2t|2w|2z|32|37|3A|3E|3H|12H|12L|12P|12S|12V|12Y|12b|12e|12h|12j|12l|GH|H8|4Y|4c|4g|4j|12m","o|3L|bx|bz|2p|12I|3M","o|3L|k5|bz|2p|12M|3M","o|3L|12T|1V|2p|12U|3M","o|3L|12W|1V|2p|12X|3M","o|3L|12Z|1V|2p|12a|3M","o|3L|12c|1V|2p|12d|3M","o|65|hM|1p|2p|12g|3M|3M","o|65|hX|1p|2p|12i|3M|3M","o|65|11v|1p|2p|12k|3M|3M","items","The values the slider can take.","o|ry|12x|2p|12y","numItems","The total number of values.","o|3Q|130|1q|2p|131","The current value of the slider.","o|ry|3a|2p|133","a|3N|3O|3P|12o|12p|12q|12r|12s|12t|12u|12v|12w|Hd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|12z|132|134","An interactive slider input","o|F|91|128|129|Ao|12n|135|3M|2p|2p|91|136|Az","a|1v|1z|93|94|95","02000","Display width of the spreadsheet.","o|uD|12N|2p","o|33|bx|13A|13B|bz","minNumRows","Minimum number of rows displayed.","n|4","o|33|13D|13E|13F|1p","minNumColumns","Minimum number of columns displayed.","o|33|13H|13I|13F|1p","Display height of the spreadsheet.","o|2h|k5|13K|bz","columnHeaders","Header labels for the columns.","o|2m|13M|13N|3M|2s|1V","rowHeaders","Header labels for the rows.","o|2m|13P|13Q|3M|2s|1V","fixedRowsTop","Number of top rows fixed in place when scrolling.","o|33|13S|13T|5Q|1q","fixedColumnsLeft","Number of left columns fixed in place when scrolling.","o|33|13V|13W|5Q|1q","hiddenColumns","Indices of columns to hide.","o|33|13Y|13Z|54|1a","hiddenRows","Indices of rows to hide.","o|33|13b|13c|54|1a","a|2j|2t|2w|2z|32|37|3A|3E|3H|13C|13G|13J|13L|13O|13R|13U|13X|13a|13d","o|3L|bx|bz|2p|13A|3M","o|3L|13D|1p|2p|13E|3M","o|3L|13H|1p|2p|13I|3M","o|3L|13M|1V|2p|13N|3M","o|3L|13P|1V|2p|13Q|3M","o|3L|13S|1q|2p|13T|3M","o|3L|13V|1q|2p|13W|3M","o|3L|13Y|1a|2p|13Z|3M","o|3L|13b|1a|2p|13c|3M","The number of rows.","o|3Q|7A|1p|2p|13o","The number of columns.","o|3Q|7D|1p|2p|13q","o|3Q|k5|bz|2p|13K","cells","The raw text contents of all cells.","o|6x|2p|95","o|6x|2p|93","a|13v|13w","o|6v|13t|1v|3M|13u|4X|13x","The cells grouped by row.","o|6v|7K|1v|3M|13z|4X|13x","The cells grouped by column.","o|6x|2p|94","a|13v|142","o|6v|7N|1v|3M|141|4X|143","evaluatedCells","The evaluated values of all cells.","o|6v|145|1v|3M|146|4X|13x","evaluatedRows","The evaluated cell values grouped by row.","o|6v|148|1v|3M|149|4X|13x","evaluatedColumns","The evaluated cell values grouped by column.","o|6v|14B|1v|3M|14C|4X|143","pointsInCells","Cells whose values are interpreted as points.","a|X6|IK","o|6v|14E|1d|3M|14F|4X|14G","pointsInRows","Cell-derived points grouped by row.","o|6v|14I|1d|3M|14J|4X|14G","pointsInColumns","Cell-derived points grouped by column.","o|6v|14L|1d|3M|14M|4X|14G","a|3N|3O|3P|13f|13g|13h|13i|13j|13k|13l|13m|13n|3T|3U|3V|3W|3Z|13p|13r|13s|13y|140|144|147|14A|14D|14H|14K|14N","An interactive spreadsheet","o|F|92|138|139|9X|13e|14O|3M|2p|2p|92|14P|AT","a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|G|I|J|89|8A|8B|K|8C|O|P|R|S|T|U|V|W|X|Y|Z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|8Z|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|8j|8k|8l|8m|1V|1W|1b|1c|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1j|8x|1l|1m|1n|8y|8z|90|91|92|93|94|95|96|97|98|1w|1x|99|1y|20|9A|22|23|9B|9C|9D|9E|9F|2E|2F|2G|2H|2I|9G|9H|2J|9I|2L|2M|2N|9J|2P|9K|9L|9M|9N|2R|9O|2S|2T|9P|9Q|9R|9S|9T","1111111111111111111111111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","rowNum","Row number where this cell is placed (1-based).","o|33|14T|14U||1T","colNum","Column number where this cell is placed (1-based).","o|33|14W|14X||1T","colSpan","Number of columns this cell spans.","o|33|14Z|14a|36|1q","halign","Horizontal alignment for the cell\'s content (left, center, or right).","o|33|14c|14d|5h|1T","Border style for the bottom edge of the cell.","o|33|5g|14f|42|1T","Border style for the right edge of the cell.","o|33|5i|14h|42|1T","Initial text content of the cell.","o|33|Zj|14j|AZ|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|14V|14Y|14b|14e|14g|14i|14k","o|3L|14T|1T|2p|14U|3M","o|3L|14W|1T|2p|14X|3M","o|3L|14Z|1q|2p|14a|3M","o|3L|Zj|1T|2p|14j|3M","Horizontal alignment of the cell\'s content (left, center, or right).","o|3Q|14c|1T|2p|14q","o|3Q|5g|1T|2p|14f","o|3Q|5i|1T|2p|14h","inHeader","Whether this cell is in a header row of the table.","o|3Q|14u|1V|2p|14v","The cell\'s content as a text string.","o|3Q|1T|1T|2p|14x","The cell\'s content interpreted as a math expression.","o|3Q|1X|1X|2p|14z","The cell\'s content interpreted as a number.","o|3Q|1p|1p|2p|151","a|3N|3O|3P|14m|14n|14o|14p|3T|3U|3V|3W|3Z|14r|14s|14t|14w|14y|150|152","A single cell within a tabular layout or spreadsheet","o|F|1v|14R|14S|Ao|14l|153|3M|3M|2p|1v|154|Az","displayContext","a|3|4|5|6|7|8|9|A|B|C|D|E|156","a|1v|1z","Row number where this row is placed (1-based).","o|33|14T|159||1T","header","Whether this row is a header row.","o|2m|15B|15C|2p|2s|1V","Default horizontal alignment for cells in this row.","o|33|14c|15E|5h|1T","Default vertical alignment for cells in this row.","o|33|c8|15G|cA|1T","Border style for the left edge of this row.","o|33|5h|15I|42|1T","Border style for the bottom edge of this row.","o|33|5g|15K|42|1T","o|2h|4w|4x|1U","o|2h|52|53|3D","o|Ap|56|57|2s|1V","o|Ap|59|5A|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|15A|15D|15F|15H|15J|15L|15M|15N|15O|15P","o|3L|14T|1T|2p|159|3M","o|3L|15B|1V|2p|15C|3M","o|3Q|14c|1T|2p|15E","o|3Q|c8|1T|2p|15G","Border style for the left edge of the row.","o|3Q|5h|1T|2p|15V","Border style for the bottom edge of the row.","o|3Q|5g|1T|2p|15X","a|3N|3O|3P|15R|15S|3T|3U|3V|3W|3Z|15T|15U|15W|15Y","row_table","A row within a tabular layout","in a table","o|157|93|158|BN|Ao|15Q|15Z|3M|2p|2p|15a|15b|Az|15c","Column number where this column is placed (1-based).","o|33|14W|15e||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|15f|15M|15N|15O|15P","o|3L|14W|1T|2p|15e|3M","a|3N|3O|3P|15h|3T|3U|3V|3W|3Z","column_table","A column of cells within a `<spreadsheet>`","o|157|94|158|BN|Ao|15g|15i|3M|2p|2p|15j|15k|Az|15c","Row number where this block starts (1-based; can be a letter or number).","o|33|14T|15m||1T","Column number where this block starts (1-based; can be a letter or number).","o|33|14W|15o||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|15n|15p","o|3L|14T|1T|2p|15m|3M","o|3L|14W|1T|2p|15o|3M","a|3N|3O|3P|15r|15s|3T|3U|3V|3W|3Z","Container for grouping `<cell>`, `<row>`, and `<column>` children inside a `<spreadsheet>`","o|F|95|138|139|Ao|15q|15t|3M|2p|2p|95|15u|Az","a|93|1z","Display width of the tabular layout.","o|33|bx|15x|13B|bz","Display height of the tabular layout.","o|33|k5|15z||bz","Default horizontal alignment for cells.","justify","a|5h|5b|5i|162","Left-align cell content.","o|3s|5h|164","Center cell content horizontally.","o|3s|5b|166","Right-align cell content.","o|3s|5i|168","Justify cell content across the full cell width.","o|3s|162|16A","a|165|167|169|16B","o|Bi|14c|161|5h|163|16C|3y","Default vertical alignment for cells.","Align cell content to the top.","o|3s|9|16F","Center cell content vertically.","o|3s|cA|16H","Align cell content to the bottom.","o|3s|5g|16J","a|16G|16I|16K","o|Bi|c8|16E|cA|cB|16L|3y","Border style for the top edge of the layout.","minor","major","a|42|16O|xA|16P","Do not render a border.","o|3s|42|16R","Render a thin border line.","o|3s|16O|16T","Render a medium-weight border line.","o|3s|xA|16V","Render a thick border line.","o|3s|16P|16X","a|16S|16U|16W|16Y","o|Bi|9|16N|42|16Q|16Z|3y","Border style for the left edge of the layout.","o|Bi|5h|16b|42|16Q|16Z|3y","Border style for the bottom edge of the layout.","o|Bi|5g|16d|42|16Q|16Z|3y","Border style for the right edge of the layout.","o|Bi|5i|16f|42|16Q|16Z|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|15y|160|16D|16M|16a|16c|16e|16g","o|3L|bx|bz|2p|15x|3M","o|3L|k5|bz|2p|15z|3M","o|3L|14c|1T|2p|161|3M","o|3L|c8|1T|2p|16E|3M","o|3L|9|1T|2p|16N|3M","o|3L|5h|1T|2p|16b|3M","o|3L|5g|1T|2p|16d|3M","o|3L|5i|1T|2p|16f|3M","a|3N|3O|3P|16i|16j|16k|16l|16m|16n|16o|16p|3T|3U|3V|3W|3Z","A simple tabular layout of cells","o|F|96|15w|BN|9X|16h|16q|3M|2p|2p|96|16r|AT","a|G|1z|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T","021111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111","suppressTableNameInTitle","Whether to omit the auto-generated table name from the title.","o|2m|16v|16w|2p|2s|1V","Whether to display an auto-generated table number.","o|2m|1p|16y|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|16x|16z","tableEnumeration","Auto-generated number for this table.","o|3Q|171|1T|2p|172","tableName","The full display name of the table (e.g., \'Table 2\').","o|3Q|174|1T|2p|175","The table\'s title.","o|3Q|G|1T|2p|177","a|3N|3O|3P|3T|3U|3V|3W|3Z|173|176|178","A container element for a `<tabular>`","o|F|97|16t|16u|9X|170|179|3M|3M|2p|97|17A|AT","a|1z|9I|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9J|9N|9Q|9S|9T","201111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222212221222221112111121222112211111222111111111111111111111111111111111111111111111111111","suppressFigureNameInCaption","Whether to omit the auto-generated figure name from the caption.","o|2m|17E|17F|2p|2s|1V","Whether to display an auto-generated figure number.","o|2m|1p|17H|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|17G|17I","figureEnumeration","Auto-generated number for this figure.","o|3Q|17K|1T|2p|17L","figureName","The full display name of the figure (e.g., \'Figure 3\').","o|3Q|17N|1T|2p|17O","The figure\'s caption text.","o|3Q|9I|1T|2p|17Q","a|3N|3O|3P|3T|3U|3V|3W|3Z|17M|17P|17R","A figure container holding graphical content with a caption","o|F|98|17C|17D|9X|17J|17S|3M|3M|2p|98|17T|AT","Whether the generated repeats should be treated as responses for assessment.","o|g3|38|17V","valueName","Name to bind the current item to inside the repeat template.","o|33|17X|17Y||1T","indexName","Name to bind the current 1-based index to inside the repeat template.","o|33|17a|17b||1T","The collection of items to iterate over when generating repeats.","o|2h|7f|17d|23","Component type used to wrap each item in the source.","o|2h|2g|17f|1T","a|2j|2t|2w|2z|32|37|17W|3E|3H|17Z|17c|17e|17g|gB","a|3N|3O|3Z","Repeats template content for each item in a source","o|F|1w|9U|9V|g0|17h|17i|3M|3M|3M|1w|17j|Az","a|2j|2t|2w|2z|32|37|17W|3E|3H|11p|11s|11u|11x|11z|123|17Z|17c|gB","Repeats template content for each value in an arithmetic sequence","o|F|1x|9U|9V|g0|17l|17i|3M|3M|3M|1x|17m|Az","dx","Horizontal spacing between pegs.","o|33|17o|17p|36|1p","dy","Vertical spacing between pegs.","o|33|17r|17s|36|1p","xoffset","Horizontal offset of the peg grid origin.","o|33|17u|17v|5Q|1p","yoffset","Vertical offset of the peg grid origin.","o|33|17x|17y|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|17q|17t|17w|17z","o|3L|17o|1p|2p|17p|3M","o|3L|17r|1p|2p|17s|3M","o|3L|17u|1p|2p|17v|3M","o|3L|17x|1p|2p|17y|3M","a|3N|3O|3P|Hd|QD|7s|QE|181|182|183|184|3T|3U|3V|3W|3Z|Hk","Renders a grid of pegs on a graph","o|F|99|Om|On|Op|180|185|3M|2p|2p|99|186|Az","_constraint","a|188|2d","Horizontal grid spacing.","o|33|17o|18A|36|1p","Vertical grid spacing.","o|33|17r|18C|36|1p","dz","Depth-wise grid spacing.","o|33|18E|18F|36|1p","Horizontal offset of the grid origin.","o|33|17u|18H|5Q|1p","Vertical offset of the grid origin.","o|33|17x|18J|5Q|1p","zoffset","Depth-wise offset of the grid origin.","o|33|18L|18M|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N","o|3L|17o|1p|2p|18A|3M","o|3L|17r|1p|2p|18C|3M","o|3L|18E|1p|2p|18F|3M","o|3L|17u|1p|2p|18H|3M","o|3L|17x|1p|2p|18J|3M","o|3L|18L|1p|2p|18M|3M","a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to lie on a grid","o|F|RJ|54|AZ|189|18O|18V|2p|2p|2p|RJ|18W|Az","buffer","Distance from the graph edge inside which the position is still considered constrained.","n|0.A","o|33|18Y|18Z|18a|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|18b","o|3L|18Y|1p|2p|18Z|3M","a|3N|3O|3P|18d|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to lie within a graph\'s bounds","o|F|RK|54|AZ|189|18c|18e|2p|2p|2p|RK|18f|Az","xthreshold","Horizontal distance within which the position attracts to a grid line.","n|0.2","o|33|18h|18i|18j|1p","ythreshold","Vertical distance within which the position attracts to a grid line.","o|33|18l|18m|18j|1p","zthreshold","Depth-wise distance within which the position attracts to a grid line.","o|33|18o|18p|18j|1p","includeGridlines","Whether to attract to entire grid lines (in addition to grid intersection points).","o|2m|18r|18s|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N|18k|18n|18q|18t","o|3L|18h|1p|2p|18i|3M","o|3L|18l|1p|2p|18m|3M","o|3L|18o|1p|2p|18p|3M","o|3L|18r|1V|2p|18s|3M","a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|18v|18w|18x|18y|3T|3U|3V|3W|3Z","Attracts a graphical component\'s position to grid lines when nearby","o|F|RL|54|AZ|189|18u|18z|2p|2p|2p|RL|190|Az","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|1z|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y","222222222222222222222222221111222221211111111111112222221222222222122221111121222","relativeToGraphScales","Whether the constraint is interpreted relative to the enclosing graph\'s scales.","o|2m|194|195|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|196","o|3L|194|1V|2p|195|3M","a|3N|3O|3P|198|3T|3U|3V|3W|3Z","Constrains a graphical component\'s position to be within another component or components","o|F|RM|192|193|189|197|199|2p|2p|2p|RM|19A|Az","Whether the attraction threshold is interpreted relative to the enclosing graph\'s scales rather than absolute coordinates.","o|2m|194|19C|2p|2s|1V","Distance within which the position attracts to a target.","o|2h|E6|19E|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|19D|19F","o|3L|194|1V|2p|19C|3M","o|3Q|E6|1p|2p|19E","a|3N|3O|3P|19H|3T|3U|3V|3W|3Z|19I","Attracts a graphical component\'s position to another component when nearby","o|F|RN|192|193|189|19G|19J|2p|2p|2p|RN|19K|Az","a|RJ|RK|RL|RM|RN|RO|RP|RQ|1z","111111112","A constraint that is satisfied if any of its child constraints are satisfied","o|F|RO|19M|19N|189|3I|Aa|2p|2p|2p|RO|19O|Az","Distance within which the position attracts to the constraint location.","o|33|E6|19Q|Pq|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|19R","o|3L|E6|1p|2p|19Q|3M","a|3N|3O|3P|19T|3T|3U|3V|3W|3Z","Wraps another constraint so it acts as a soft attraction within a threshold","o|F|RP|19M|19N|189|19S|19U|2p|2p|2p|RP|19V|Az","Constrains a graphical component\'s position to lie inside a region","o|F|RQ|192|193|189|197|199|2p|2p|2p|RQ|19X|Az","a|1K|1f|1z|2Q|8n|8u|8q|8r|8s|8t|8Y|8p","102100011110","Style number applied to the resulting intersection components.","o|g3|34|19b","a|2j|2t|2w|2z|32|19c|3A|3E|3H|gB","a|3N|3P|3Z","Renders intersections between graphical objects","o|F|1y|19Z|19a|g0|19d|19e|3M|2p|2p|1y|19f|Az","case","a|1z|19h|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y|An","101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111110","Convenience for a single-case form: the boolean condition for which the children are rendered.","o|Ap|Aq|19k|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|19l","Renders content conditionally based on its `<case>` or `<else>` children","o|F|1z|19i|19j|g0|19m|125|3M|3M|2p|1z|19n|Az","The children rendered as a comma-separated text string.","o|3Q|1T|1T|2p|19p","The children rendered as a comma-separated LaTeX string.","o|3Q|2V|2V|2p|19r","a|3N|3O|3P|3T|3U|3V|3W|3Z|19q|19s","Renders its children as a comma-separated list","o|F|20|2Z|2a|3l|3I|19t|3M|3M|2p|20|19u|3h","numVariants","The total number of variants to generate.","o|2h|19w|19x|1q","uniqueVariants","Whether to require generated variants to be uniquely distinguishable.","o|Ap|19z|1A0|2s|1V","variantsToInclude","Restrict the available variants to this list (by name or index).","o|2h|1A2|1A3|11U","variantsToExclude","Variants to exclude from those generated.","o|2h|1A5|1A6|11U","variantNames","Names assigned to the generated variants.","o|2h|1A8|1A9|11U","seeds","Random seeds used when generating variants.","o|2h|1AB|1AC|11U","a|2j|2t|2w|2z|32|37|3A|3E|3H|19y|1A1|1A4|1A7|1AA|1AD","Configures how variants are generated for the enclosing document or section","o|F|9A|54|AZ|Ao|1AE|Aa|3M|2p|2p|9A|1AF|Az","numToSelect","How many values to select from the sequence.","o|33|1AH|1AI|36|1q","withReplacement","Whether the same value can be selected more than once.","o|2m|1AK|1AL|2p|2s|1V","Whether and how to sort the selected values.","unsorted","increasing","decreasing","a|1AO|1AP|1AQ|2q|2r","Preserve the random selection order.","o|3s|1AO|1AS","Sort the selected values in increasing order.","o|3s|1AP|1AU","Sort the selected values in decreasing order.","o|3s|1AQ|1AW","a|1AT|1AV|1AX","o|Bi|2L|1AN|1AO|1AR|1AY|3y","excludeCombinations","Lists of value combinations to exclude from the selection.","_componentListOfListsWithSelectableType","o|2h|1Aa|1Ab|1Ac","coprime","Require the selected numbers to be pairwise coprime (numbers only).","o|2m|1Ae|1Af|2p|2s|1V","a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB|1AJ|1AM|1AZ|1Ad|1Ag","o|3L|1AH|1q|2p|1AI|3M","o|3L|1AK|1V|2p|1AL|3M","o|3L|2L|1T|2p|1AN|3M","o|3L|1Ae|1V|2p|1Af|3M","a|3N|3O|3P|1Ai|1Aj|1Ak|1Al|3Z","Randomly selects values from a sequence of numbers, math expressions, or letters to create document variants","o|F|21|54|AZ|g0|1Ah|1Am|3M|2p|3M|21|1An|Az","a|11R|1z","How many child components to select.","o|33|1AH|1Aq|36|1q","Whether the same child can be selected more than once.","o|2m|1AK|1As|2p|2s|1V","Component type to select from.","o|2h|2g|1Au|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ar|1At|1Av|gB","o|3L|1AH|1q|2p|1Aq|3M","o|3L|1AK|1V|2p|1As|3M","a|3N|3O|3P|1Ax|1Ay|3Z","Randomly selects components from a list of children to create document variants","o|F|22|1Ap|BN|g0|1Aw|1Az|3M|3M|3M|22|1B0|Az","Whether this group\'s children should be treated as responses for assessment.","o|g3|38|1B2","rendered","Whether the group\'s children are rendered.","o|2m|1B4|1B5|3M|2s|1V","createComponentOfType","Component type to wrap each child as when expanding the group.","o|2h|1B7|1B8|1T","Number of components to create when expanding (used with createComponentOfType).","o|2h|gF|1BA|1p","Whether to render the group\'s children separated by commas (true) or with no separator (false).","o|2m|20|1BC|2p|2s|1V","a|2j|2t|2w|2z|32|37|1B3|3E|3H|1B6|1B9|1BB|1BD","o|3L|1B4|1V|2p|1B5|3M","a|3N|3O|1BF|3Z","A logical grouping of components","o|F|23|9U|9V|g0|1BE|1BG|3M|3M|2p|23|1BH|Az","target","Reference to the state variable that will be animated.","o|2h|1BJ|1BK|3D","animationOn","Whether the animation is currently playing.","o|2m|1BM|1BN|2p|2s|1V","animationMode","How the animation steps through the sequence.","increase","decrease","increase once","decrease once","oscillate","a|1BR|1BS|1BT|1BU|1BV","Step through values from first to last, looping back to the start.","o|3s|1BR|1BX","Step through values from last to first, looping back to the end.","o|3s|1BS|1BZ","Step from first to last and stop without looping.","o|3s|1BT|1Bb","Step from last to first and stop without looping.","o|3s|1BU|1Bd","Step from first to last, then reverse direction at each end.","o|3s|1BV|1Bf","a|1BY|1Ba|1Bc|1Be|1Bg","o|Bi|1BP|1BQ|1BR|1BW|1Bh|3y","animationInterval","Time in milliseconds between successive animation steps.","o|33|1Bj|1Bk|Nv|1p","allowAdjustmentsWhileRunning","Whether sequence parameters can be adjusted while the animation is running.","o|2m|1Bm|1Bn|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|11p|11s|11u|11x|11z|123|1BL|1BO|1Bi|1Bl|1Bo","o|3L|1BM|1V|2p|1BN|3M","o|3L|1BP|1T|2p|1BQ|3M","o|3L|1Bj|1p|2p|1Bk|3M","o|3L|1Bm|1V|2p|1Bn|3M","Index of the currently selected value in the sequence (1-based).","o|3Q|vc|1p|2p|1Bu","The currently selected value of the animation.","o|ry|3a|2p|1Bw","currentAnimationDirection",\'Current direction of the animation ("increase" or "decrease"; flips during oscillation).\',"o|3Q|1By|1T|2p|1Bz","a|3N|3O|3P|1Bq|1Br|1Bs|1Bt|3T|3U|3V|3W|3Z|1Bv|1Bx|1C0","Animates a value through a sequence over time","o|F|9B|54|AZ|Ao|1Bp|1C1|3M|2p|2p|9B|1C2|Az","Whether to treat the inputs as unordered.","o|2m|4n|1C4|2p|2s|1V","Whether to force symbolic evaluation.","o|2m|DH|1C6|2p|2s|1V","Whether to force numeric evaluation.","o|2m|DK|1C8|2p|2s|1V","The function to evaluate.","o|2h|1r|1CA|1r","input","Input value(s) at which to evaluate the function.","o|2h|1CC|1CD|1Y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1C5|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1C7|1C9|1CB|1CE","o|3L|4n|1V|2p|1C4|3M","o|3L|DH|1V|2p|1C6|3M","o|3L|DK|1V|2p|1C8|3M","o|3Q|3a|24|2p|6e","The function evaluated at the inputs as a math expression.","o|3Q|I9|1X|2p|1CK","a|3N|3O|3P|66|67|68|69|1CG|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1CH|1CI|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1CJ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1CL|7S|7V|7Y|7b","Evaluates a function at a math value","o|F|24|54|AZ|3l|1CF|1CM|3M|2p|2p|24|1CN|3h","Distribution from which to sample.","discreteUniform","gaussian","a|W7|1CQ|1CR","Continuous uniform distribution over `[from, to]`.","o|3s|W7|1CT","Discrete uniform distribution over integers in `[from, to]`.","o|3s|1CQ|1CV","Normal (Gaussian) distribution with the specified mean and standard deviation.","o|3s|1CR|1CX","a|1CU|1CW|1CY","o|Bi|2g|1CP|W7|1CS|1CZ|3y","Mean of the sampling distribution (Gaussian).","o|33|l|1Cb|5Q|1p","Standard deviation of the sampling distribution (Gaussian).","o|33|o|1Cd|36|1p","Variance of the sampling distribution (Gaussian).","o|33|n|1Cf|36|1p","Lower bound of the sampling range.","o|33|hM|1Ch||1p","Upper bound of the sampling range.","o|33|hX|1Cj||1p","Step size between samples for the discrete-uniform distribution.","o|33|11v|1Cl|36|1p","Values to exclude from the sample space.","o|33|120|1Cn|54|1a","How many random numbers to select.","o|33|1AH|1Cp|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|gB|1Cq","o|3L|2g|1T|2p|1CP|3M","o|3L|1AH|1q|2p|1Cp|3M","Step size between sample values (for discrete distributions).","o|3Q|11v|1p|2p|1Cu","o|3Q|hM|1p|2p|1Ch","o|3Q|hX|1p|2p|1Cj","Mean of the sampling distribution.","o|3Q|l|1p|2p|1Cy","Variance of the sampling distribution.","o|3Q|n|1p|2p|1D0","Standard deviation of the sampling distribution.","o|3Q|o|1p|2p|1D2","a|3N|3O|3P|1Cs|1Ct|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3","Selects a fixed set of random numbers to create document variants","o|F|25|54|AZ|g0|1Cr|1D4|3M|2p|3M|25|1D5|Az","numSamples","Number of samples to draw.","o|33|1D7|1D8|36|1p","variantDeterminesSeed","Whether the document\'s variant index determines the random seed.","o|Ap|1DA|1DB|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1D9|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|1DC|gB","o|3L|1D7|1p|2p|1D8|3M","o|3L|1DA|1V|2p|1DB|3M","a|3N|3O|3P|1DE|1Cs|1DF|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3","Samples random numbers from a distribution","o|F|26|54|AZ|g0|1DD|1DG|3M|2p|3M|26|1DH|Az","Lower bound (inclusive) of the prime range to select from.","o|33|hM|1DJ|4X|1q","Upper bound (inclusive) of the prime range to select from.","o|33|hX|1DL|12N|1q","Primes to exclude from the selection.","o|33|120|1DN|54|1a","How many prime numbers to select.","o|33|1AH|1DP|36|1q","Whether the same prime can be selected more than once.","o|2m|1AK|1DR|2p|2s|1V","Sort order applied to the selected primes.","Sort the selected primes in increasing order.","o|3s|1AP|1DU","Sort the selected primes in decreasing order.","o|3s|1AQ|1DW","a|1AT|1DV|1DX","o|Bi|2L|1DT|1AO|1AR|1DY|3y","Combinations of values that should not be selected together.","_listOfNumberLists","o|2h|1Aa|1Da|1Db","a|2j|2t|2w|2z|32|37|3A|3E|3H|1DK|1DM|1DO|1DQ|1DS|1DZ|1Dc|gB","o|3L|hM|1q|2p|1DJ|3M","o|3L|hX|1q|2p|1DL|3M","o|3L|120|1a|2p|1DN|3M","o|3L|1AH|1q|2p|1DP|3M","o|3L|1AK|1V|2p|1DR|3M","o|3L|2L|1T|2p|1DT|3M","a|3N|3O|3P|1De|1Df|1Dg|1Dh|1Di|1Dj|3Z","Randomly selects prime numbers from a range to create document variants","o|F|27|54|AZ|g0|1Dd|1Dk|3M|2p|3M|27|1Dl|Az","Number of prime samples to draw.","o|33|1D7|1Dn|36|1p","Lower bound (inclusive) of the prime range to sample from.","o|33|hM|1Dp|4X|1q","Upper bound (inclusive) of the prime range to sample from.","o|33|hX|1Dr|12N|1q","Primes to exclude from the sample.","o|33|120|1Dt|54|1a","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Do|1Dq|1Ds|1Du|1DC|gB","o|3L|1D7|1p|2p|1Dn|3M","o|3L|hM|1q|2p|1Dp|3M","o|3L|hX|1q|2p|1Dr|3M","o|3L|120|1a|2p|1Dt|3M","a|3N|3O|3P|1Dw|1Dx|1Dy|1Dz|1DF|3Z","Samples random prime numbers","o|F|28|54|AZ|g0|1Dv|1E0|3M|2p|3M|28|1E1|Az","Type of values being substituted.","a|1X|1T","Substitute within math expressions.","o|3s|1X|1E5","Substitute within text values.","o|3s|1T|1E7","a|1E6|1E8","o|HC|2g|1E3|1E4|1E9|3y","match","Pattern to match in the source value.","o|33|1EB|1EC||11r","replacement","Value to substitute in place of each match.","o|33|1EE|1EF||11r","Level of simplification applied after substitution.","Fully simplify the resulting expression.","o|3s|43|1EI","a|49|1EJ|4D|4F|4H","o|Bi|40|1EH|42|47|1EK|3y","matchWholeWord","Whether matching is restricted to whole words (text mode).","o|2m|1EM|1EN|2p|2s|1V","matchCase","Whether matching is case-sensitive (text mode).","o|2m|1EP|1EQ|2p|2s|1V","preserveCase","Whether the case of the original is preserved when substituting.","o|2m|1ES|1ET|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1EA|1ED|1EG|1EL|H8|4Y|4c|4g|4j|1EO|1ER|1EU","o|3L|2g|1T|2p|1E3|3M","o|3L|40|1T|2p|1EH|3M","o|3L|1EM|1V|2p|1EN|3M","o|3L|1EP|1V|2p|1EQ|3M","o|3L|1ES|1V|2p|1ET|3M","a|3N|3O|3P|1EW|1EX|1EY|1EZ|1Ea|3Z|6X|6Y|6Z|6a|6b","Substitutes math expressions into another expression","o|F|29|9U|9V|g0|1EV|1Eb|3M|3M|3M|29|1Ec|Az","o|Ap|4n|4o|2s|1V","minIndex","Smallest period index considered when listing offsets.","-Infinity","o|33|1Ef|1Eg|1Eh|1q","maxIndex","Largest period index considered when listing offsets.","o|33|1Ej|1Ek|9k|1q","offsets","Offsets within one period.","o|33|1Em|1En||1Y","The period of the set.","o|33|Y8|1Ep||1X","minIndexAsList","Smallest period index when rendered as a list.","n|-1","o|33|1Er|1Es|1Et|1q","maxIndexAsList","Largest period index when rendered as a list.","o|33|1Ev|1Ew|36|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Ei|1El|1Eo|1Eq|1Eu|1Ex","o|3L|1Ef|1q|2p|1Eg|3M","o|3L|1Ej|1q|2p|1Ek|3M","o|3L|1Em|1Y|2p|1En|3M","o|3L|Y8|1X|2p|1Ep|3M","o|3L|1Er|1q|2p|1Es|3M","o|3L|1Ev|1q|2p|1Ew|3M","o|3Q|3a|2A|2p|6e","numOffsets","The number of distinct offsets within one period.","o|3Q|1F6|1q|2p|1F7","redundantOffsets","Offsets that are redundant given the period.","o|3Q|1F9|1V|2p|1FA","The periodic set rendered as a list of explicit values.","o|3Q|20|1Y|2p|1FC","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1Ez|1F0|1F1|1F2|1F3|1F4|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1F5|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1F8|1FB|1FD|7S|7V|7Y|7b","A periodic set of real numbers","o|F|2A|54|AZ|3l|1Ey|1FE|3M|2p|2p|2A|1FF|3h","a|1z|dd|2f","200","Explicit width of the image (overrides size).","o|33|bx|1FJ||bz","Named size preset for the image.","o|Bi|uB|1FL|xA|xE|xP|3y","Aspect ratio (width / height) for the image.","o|33|xR|1FN||1p","How to size the image.","o|Bi|xU|1FP|AT|xW|xb|3y","Horizontal alignment of the image within its container.","Center the image horizontally.","o|3s|5b|1FS","Align the image to the left edge.","o|3s|5h|1FU","Align the image to the right edge.","o|3s|5i|1FW","a|1FT|1FV|1FX","o|Bi|xd|1FR|5b|xf|1FY|3y","Whether the image is purely decorative.","o|2m|zM|1Fa|2p|2s|1V","source","URL or path of the image source.","o|33|1Fc|1Fd|AZ|1T","authorName","Name of the author of the image.","o|33|1Ff|1Fg||1T","authorUrl","URL to link the author\'s name to in the attribution (e.g. the author\'s profile page).","o|33|1Fi|1Fj||1T","imageName","Name of the image, used in place of the generic word “Image” in the attribution.","o|33|1Fl|1Fm||1T","originalUrl","Original URL where the image can be found, used to link the image name in the attribution.","o|33|1Fo|1Fp||1T","licenseName","Name of the license for the image.","o|33|1Fr|1Fs||1T","licenseUrl","URL for the license of the image.","o|33|1Fu|1Fv||1T","a|3|2f|2k|2l|3n|cK|2g","licenseCodes","License code(s) for the image. Specify two codes to indicate the image is dual licensed.","CC-BY","CC-BY-SA","CC-BY-ND","CC-BY-NC","CC-BY-NC-SA","CC-BY-NC-ND","CC0","PDM","GFDL","FAL","OGL","MIT","APACHE-2.0","a|1G0|1G1|1G2|1G3|1G4|1G5|1G6|1G7|1G8|1G9|1GA|1GB|1GC","Creative Commons Attribution: reuse with credit, including commercially.","o|3s|1G0|1GE","Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license.","o|3s|1G1|1GG","Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit.","o|3s|1G2|1GI","Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes.","o|3s|1G3|1GK","Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license.","o|3s|1G4|1GM","Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit.","o|3s|1G5|1GO","Creative Commons Zero: the creator has dedicated the work to the public domain.","o|3s|1G6|1GQ","Public Domain Mark: the work is free of known copyright restrictions.","o|3s|1G7|1GS","GNU Free Documentation License: copyleft license common on Wikimedia.","o|3s|1G8|1GU","Free Art License: copyleft license for artistic works.","o|3s|1G9|1GW","UK Open Government Licence: reuse government material with attribution.","o|3s|1GA|1GY","MIT License: permissive license common for icon and illustration sets.","o|3s|1GB|1Ga","Apache License 2.0: permissive license common for icon and illustration sets.","o|3s|1GC|1Gc","a|1GF|1GH|1GJ|1GL|1GN|1GP|1GR|1GT|1GV|1GX|1GZ|1Gb|1Gd","o|1Fx|1Fy|1Fz||1GD|1Ge|3M|3y","licenseVersion","Version of the Creative Commons license(s) given in `licenseCodes` (ignored by non-Creative-Commons licenses).","4.0","1.0","2.0","2.5","3.0","a|1Gj|1Gk|1Gl|1Gm|1Gi","Creative Commons version 1.0.","o|3s|1Gj|1Go","Creative Commons version 2.0.","o|3s|1Gk|1Gq","Creative Commons version 2.5.","o|3s|1Gl|1Gs","Creative Commons version 3.0.","o|3s|1Gm|1Gu","Creative Commons version 4.0.","o|3s|1Gi|1Gw","a|1Gp|1Gr|1Gt|1Gv|1Gx","o|Bi|1Gg|1Gh|1Gi|1Gn|1Gy|3y","asFileName","File name to use when downloading the image.","o|33|1H0|1H1||1T","mimeType","MIME type of the image.","o|33|1H3|1H4||1T","Whether the image can be dragged on a graph.","o|2m|5L|1H6|3M|2s|1V","rotate","Rotation angle (radians) applied to the image.","o|33|1H8|1H9|5Q|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1FK|1FM|1FO|1FQ|1FZ|1Fb|1Fe|1Fh|1Fk|1Fn|1Fq|1Ft|1Fw|1Gf|1Gz|1H2|1H5|1H7|5R|5X|63|1HA","o|3L|xU|1T|2p|1FP|3M","o|3L|xd|1T|2p|1FR|3M","o|3L|zM|1V|2p|1Fa|3M","o|3L|1Fc|1T|2p|1Fd|3M","o|3L|1Ff|1T|2p|1Fg|3M","o|3L|1Fi|1T|2p|1Fj|3M","o|3L|1Fl|1T|2p|1Fm|3M","o|3L|1Fo|1T|2p|1Fp|3M","o|3L|1Fy|1U|2p|1Fz|3M","o|3L|1Gg|1T|2p|1Gh|3M","o|3L|1H0|1T|2p|1H1|3M","o|3L|1H3|1T|2p|1H4|3M","o|3L|5L|1V|2p|1H6|3M","o|3L|1H8|1p|2p|1H9|3M","A short accessibility description of the image.","o|3Q|dd|1T|2p|1HQ","The size of the image.","o|3Q|uB|1T|2p|1HS","The display width of the image.","o|3Q|bx|bz|2p|1HU","The aspect ratio (width / height) of the image.","o|3Q|xR|1p|2p|1HW","licenseNames","The license name(s) for the image. Derived from `licenseCodes` when given; otherwise from the `licenseName` attribute.","o|3Q|1HY|1U|2p|1HZ","licenseUrls","The license URL(s) for the image. Derived from `licenseCodes` (and `licenseVersion`) when given; otherwise from the `licenseUrl` attribute.","o|3Q|1Hb|1U|2p|1Hc","a|3N|3O|3P|1HC|1HD|1HE|1HF|1HG|1HH|1HI|1HJ|1HK|1HL|1HM|1HN|1HO|6I|6K|1HP|3T|3U|3V|3W|3Z|6W|1HR|1HT|1HV|1HX|1Ha|1Hd","Displays a static image","o|F|9C|1FH|1FI|9X|1HB|1He|3M|2p|2p|9C|1Hf|AT","Explicit width of the video player (overrides size).","o|2h|bx|1Hh|bz","Named size preset for the video player.","o|Bi|uB|1Hj|43|xE|xP|3y","Aspect ratio (width / height) for the video player.","16 / 9","o|33|xR|1Hl|1Hm|1p","How to size the video player.","o|Bi|xU|1Ho|AT|xW|xb|3y","Horizontal alignment of the video within its container.","Center the video horizontally.","o|3s|5b|1Hr","Align the video to the left edge.","o|3s|5h|1Ht","Align the video to the right edge.","o|3s|5i|1Hv","a|1Hs|1Hu|1Hw","o|Bi|xd|1Hq|5b|xf|1Hx|3y","youtube","YouTube video ID to embed.","o|33|1Hz|1I0||1T","URL of the video source.","o|33|1Fc|1I2||1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Hi|1Hk|1Hn|1Hp|1Hy|1I1|1I3","o|3L|xU|1T|2p|1Ho|3M","o|3L|xd|1T|2p|1Hq|3M","o|3L|1Hz|1T|2p|1I0|3M","o|3L|1Fc|1T|2p|1I2|3M","A short accessibility description of the video.","o|3Q|dd|1T|2p|1I9","The size of the video player.","o|3Q|uB|1T|2p|1IB","The display width of the video player.","o|3Q|bx|bz|2p|1ID","The aspect ratio (width / height) of the video player.","o|3Q|xR|1p|2p|1IF","state","The video\'s current playback state (e.g. playing, paused).","o|3Q|1IH|1T|2p|1II","time","The current playback time in seconds.","o|3Q|1IK|1p|2p|1IL","duration","The total duration of the video in seconds.","o|3Q|1IN|1p|2p|1IO","secondsWatched","Total seconds the viewer has watched.","o|3Q|1IQ|1p|2p|1IR","fractionWatched","Fraction of the video the viewer has watched (0 to 1).","o|3Q|1IT|1p|2p|1IU","a|3N|3O|3P|1I5|1I6|1I7|1I8|3T|3U|3V|3W|3Z|1IA|1IC|1IE|1IG|1IJ|1IM|1IP|1IS|1IV","Embeds a video player","o|F|9D|1FH|1FI|9X|1I4|1IW|3M|2p|2p|9D|1IX|AT","a|G|1z|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","0111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Whether the hint is currently open (revealed).","o|3Q|M7|1V|2p|1Ib","The hint\'s title text.","o|3Q|G|1T|2p|1Id","a|3N|3O|3P|3T|3U|3V|3W|3Z|1Ic|1Ie","Hint shown on demand to help with an exercise","o|F|9E|1IZ|1Ia|9X|3I|1If|3M|3M|2p|9E|1Ig|AT","The formatted value rendered as a text string.","o|3Q|1T|1T|2p|1Ii","The numeric value with thousands separators.","o|3Q|3a|2B|2p|1Ik","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Ij|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1Il","Renders a numeric value with thousands separators (e.g. 1,000,000)","o|F|2B|fq|fr|3l|Jc|1Im|3M|3M|2p|2B|1In|3h","pluralForm","Custom plural form to use (overrides automatic pluralization).","o|33|1Ip|1Iq||1T","basedOnNumber","Number that determines whether to use the singular or plural form.","o|33|1Is|1It||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63|1Ir|1Iu","o|3L|1Ip|1T|2p|1Iq|3M","o|3L|1Is|1p|2p|1It|3M","The selected word as a text string.","o|3Q|1T|1T|2p|1Iy","The selected (singular or plural) word.","o|3Q|3a|1T|2p|1J0","a|3N|3O|3P|Jd|6I|Je|6K|1Iw|1Ix|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Iz|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1J1","Renders a word in its singular or plural form based on a count","o|F|2C|fq|fr|3l|1Iv|1J2|3M|3M|2p|2C|1J3|3h","Boolean expression; the feedback is shown when the condition is true.","o|Ap|Aq|1J5|2s|1V","updateWith","References whose changes trigger re-evaluation of the feedback.","o|2h|1J7|1J8|3D","a|2j|2w|2z|32|37|3A|3E|3H|1J6|1J9","a|3O|3P|3T|3U|3V|3W|3Z","Targeted feedback shown when conditions are met","o|F|9F|9U|9V|9X|1JA|1JB|3M|3M|2p|9F|1JC|AT","Marks its children as response components for an enclosing answer","o|F|pI|9U|9V|Ao|3I|Aa|2p|3M|2p|pI|1JE|Az","A single conditional branch within `<conditionalContent>`","o|F|19h|9U|9V|Ao|At|Ax|2p|3M|2p|19h|1JG|Az","minSentencesPerParagraph","Minimum number of sentences per generated paragraph.","o|33|1JI|1JJ|13F|1p","maxSentencesPerParagraph","Maximum number of sentences per generated paragraph.","n|8","o|33|1JL|1JM|1JN|1p","minWordsPerSentence","Minimum number of words per generated sentence.","o|33|1JP|1JQ|13F|1p","maxWordsPerSentence","Maximum number of words per generated sentence.","o|33|1JS|1JT|1JN|1p","generateWords","Number of words of lorem-ipsum to generate.","o|33|1JV|1JW||1p","generateSentences","Number of sentences of lorem-ipsum to generate.","o|33|1JY|1JZ||1p","generateParagraphs","Number of paragraphs of lorem-ipsum to generate.","o|33|1Jb|1Jc||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1JK|1JO|1JR|1JU|1JX|1Ja|1Jd","o|3L|1JI|1p|2p|1JJ|3M","o|3L|1JL|1p|2p|1JM|3M","o|3L|1JP|1p|2p|1JQ|3M","o|3L|1JS|1p|2p|1JT|3M","a|3N|3O|3P|1Jf|1Jg|1Jh|1Ji|3Z","Generates lorem ipsum placeholder text","o|F|2D|54|AZ|g0|1Je|1Jj|3M|2p|2p|2D|1Jk|Az","Reference to the state variable that will be updated.","o|2h|1BJ|1Jm|3D","Component type used to interpret the new value.","a|1X|1p|1V|1T","Treat the new value as a math expression.","o|3s|1X|1Jq","Treat the new value as a number.","o|3s|1p|1Js","Treat the new value as a boolean.","o|3s|1V|1Ju","Treat the new value as text.","o|3s|1T|1Jw","a|1Jr|1Jt|1Jv|1Jx","o|HC|2g|1Jo|1Jp|1Jy|3y","newValue","New value to assign to the target.","o|2h|1K0|1K1|11r","Whether the update button can be dragged on a graph.","o|2m|5L|1K3|3M|2s|1V","triggerWhen","Boolean expression that fires the action whenever it transitions to true.","triggering","o|4d|1K5|1K6|1K7|2p|2s|1V","a|3|2f|4N|2g","triggerWith","References to components whose value changes should fire this action.","o|1K9|1KA|1KB|1K7|3D","triggerWhenObjectsClicked","References to components whose click events should fire this action.","o|1K9|1KD|1KE|1K7|3D","triggerWhenObjectsFocused","References to components whose focus events should fire this action.","o|1K9|1KG|1KH|1K7|3D","Level of simplification applied to the new value.","Fully simplify the new value.","o|3s|43|1KK","a|49|1KL|4D|4F|4H","o|Bi|40|1KJ|42|47|1KM|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Jn|1Jz|1K2|1K4|5X|63|GH|1K8|1KC|1KF|1KI|1KN","o|3L|5L|1V|2p|1K3|3M","o|3L|40|1T|2p|1KJ|3M","a|3N|3O|3P|1KP|6K|Hd|1KQ|3T|3U|3V|3W|3Z|Hk|6W","Updates one or more state variables on a target component","o|F|2E|Om|On|3l|1KO|1KR|3M|2p|2p|2E|1KS|3h","a|I|J|1z|2S|G|H|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","1110111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Reference to the component whose action will be invoked.","o|2h|1BJ|1KW|3D","actionName","Name of the action to invoke on the target component.","o|33|1KY|1KZ||1T","Whether the action button can be dragged on a graph.","o|2m|5L|1Kb|3M|2s|1V","Numeric arguments passed to the invoked action.","o|2h|44|1Kd|1a","Numeric argument passed to the invoked action.","o|2h|1p|1Kf|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1KX|1Ka|1Kc|GH|5X|63|1K8|1KC|1KF|1KI|1Ke|1Kg","o|3L|1KY|1T|2p|1KZ|3M","o|3L|5L|1V|2p|1Kb|3M","a|3N|3O|3P|1Ki|1Kj|Hd|6K|3T|3U|3V|3W|3Z|Hk|6W","Triggers an action when clicked or in response to a specified user interaction","o|F|2F|1KU|1KV|3l|1Kh|1Kk|3M|3M|2p|2F|1Kl|3h","a|1z|2E|2F|I|J|2S","200110","Whether the trigger set\'s button can be dragged on a graph.","o|2m|5L|1Kp|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Kq|5X|63|GH|1K8|1KC|1KF|1KI","o|3L|5L|1V|2p|1Kp|3M","a|3N|3O|3P|1Ks|6K|Hd|3T|3U|3V|3W|3Z|Hk|6W","Groups a set of `<updateValue>` or `<callAction>` components which share a single trigger condition","o|F|2G|1Kn|1Ko|3l|1Kr|1Kt|3M|2p|2p|2G|1Ku|3h","numIterates","Number of iterations to compute.","o|33|1Kw|1Kx|5Q|1q","Starting value passed to the function on the first iteration.","o|33|12Q|1Kz|5J|1X","The function to iterate.","o|2h|1r|1L1|1r","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ky|1C7|1C9|1L0|1L2|H8|4Y|4c|4g|4j","o|3L|1Kw|1q|2p|1Kx|3M","Number of dimensions of each iterate.","o|3Q|6r|1q|2p|1L5","allIterates","All computed iterates of the function.","o|3Q|1L7|1Y|2p|1L8","allIteratesWithInitial","All iterates including the initial value.","o|3Q|1LA|1Y|2p|1LB","iterates","The list of iterate values.","o|6v|1LD|1X|3M|1LE|36|75","finalIterate","The last iterate value.","o|3Q|1LG|1X|2p|1LH","a|3N|3O|3P|1L4|1CH|1CI|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1L6|1L9|1LC|1LF|1LI","List of values produced by iterating a function","o|F|2H|54|AZ|3l|1L3|1LJ|3M|2p|2p|2H|1LK|3h","a|2j|2t|2w|2z|32|1B3|3E|3H|1B6|1B9|1BB|1BD","a|3N|1BF|3Z","A reusable group with parameterized attributes; can be copied elsewhere with new parameter values","o|F|2I|9U|9V|g0|1LM|1LN|3M|3M|2p|2I|1LO|Az","Declares attributes accepted by an enclosing `<module>`","o|F|9G|9U|9V|g0|3I|125|3M|3M|2p|9G|1LQ|Az","a|Ks|1z|Kt|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y","010111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111","Container for components used for setup but not rendered","o|F|9H|1LS|1LT|g0|3I|125|3M|3M|2p|9H|1LU|Az","The footnote\'s body as plain text.","o|3Q|1T|1T|2p|1LW","footnoteTag","The auto-generated marker (number) used to reference this footnote.","o|3Q|1LY|1T|2p|1LZ","a|3N|3O|3P|3T|3U|3V|3W|3Z|1LX|1La","Inline footnote whose body is shown on demand and is auto-numbered in the document","o|F|2J|2Z|2a|3l|3I|1Lb|3M|3M|2p|2J|1Lc|3h","The caption rendered as a plain text string.","o|3Q|1T|1T|2p|1Le","a|3N|3O|3P|3T|3U|3V|3W|3Z|1Lf","A caption attached to a figure or table","o|F|9I|fL|fM|9X|3I|1Lg|3M|3M|2p|9I|1Lh|AT","Whether the endpoint is open (excluded) rather than closed (included).","o|2m|M7|1Lj|2p|2s|1V","Whether the user can toggle the endpoint between open and closed by clicking it.","o|2m|Ss|1Ll|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|1Lk|1Lm","o|3L|M7|1V|2p|1Lj|3M","o|3L|Ss|1V|2p|1Ll|3M","a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|1Lo|1Lp|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR","A point that marks the endpoint of an interval, rendered open or closed","o|F|2K|RR|RS|Op|1Ln|1Lq|3M|3M|2p|2K|1Lr|Az","sortVectorsBy","Whether to sort vectors by component or by magnitude.","a|na|ng","Sort vectors by their displacement components.","o|3s|na|1Lw","Sort vectors by the position of their tail point.","o|3s|ng|1Ly","a|1Lx|1Lz","o|Bi|1Lt|1Lu|na|1Lv|1M0|3y","sortByComponent","Index of the component to sort by (when sorting vectors).","o|33|1M2|1M3|oX|1q","sortByProp",\'Name of a property to sort by (e.g. "x" for sorting points by x-coordinate).\',"o|2h|1M5|1M6|1T","Component type to sort children as.","o|2h|2g|1M8|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1M1|1M4|1M7|1M9|gB","o|3L|1Lt|1T|2p|1Lu|3M","o|3L|1M2|1q|2p|1M3|3M","a|3N|3O|3P|1MB|1MC|3Z","Sorts a list according to a comparison function","o|F|2L|9U|9V|g0|1MA|1MD|3M|3M|3M|2L|1ME|Az","Component type to shuffle children as.","o|2h|2g|1MG|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1MH|gB","Randomly shuffles its children","o|F|2M|9U|9V|g0|1MI|125|3M|3M|3M|2M|1MJ|Az","Names of the variables to solve for.","o|2h|Gx|1ML|Gz","Number of points used when searching for solutions numerically.","o|33|Vo|1MN|12N|1p","minVar","Lower bound of the variable\'s search range.","o|33|1MP|1MQ||1p","maxVar","Upper bound of the variable\'s search range.","o|33|1MS|1MT||1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|1MM|1MO|1MR|1MU","o|3L|Vo|1p|2p|1MN|3M","The variables of the equations.","o|6v|Gx|H3|3M|1MX|36|I7","numSolutions","The number of numerical solutions found.","o|3Q|1MZ|1q|2p|1Ma","solutions","The numerical solutions of the equations.","o|6v|1Mc|1X|3M|1Md|36|75","The first variable being solved for.","o|3Q|H1|H3|2p|1Mf","a|3N|3O|3P|1MW|3T|3U|3V|3W|3Z|1MY|1Mb|1Me|1Mg","Numerically solves a system of equations","o|F|2N|3j|3k|3l|1MV|1Mh|3M|3M|2p|2N|1Mi|3h","Variable name displayed on the number line.","o|33|H1|1Mk|Pw|H3","Input format used for parsing entered subsets.","Parse entered subsets as plain-text notation.","o|3s|1T|1Mn","Parse entered subsets as LaTeX notation.","o|3s|2V|1Mp","a|1Mo|1Mq","o|Bi|3p|1Mm|1T|3r|1Mr|3y","Initial subset displayed in the input.","o|33|Zj|1Mt|AZ|1T","o|2h|e9|eA|2O","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ml|1Ms|1Mu|1Mv","o|3L|H1|H3|2p|1Mk|3M","o|3L|3p|1T|2p|1Mm|3M","o|3L|Zj|1T|2p|1Mt|3M","subsetValue","The current subset of the reals entered by the user.","o|3Q|1N0|2O|2p|1N1","The boundary points that delimit the subset.","o|6v|UQ|1X|3M|1N3|36|75","pointsClosed","Whether each boundary point of the subset is a closed (included) endpoint.","o|6v|1N5|1V|3M|1N6|36|Qq","intervals","The intervals (non-degenerate components) of the subset.","o|6v|1N8|1X|3M|1N9|36|75","isolatedPoints","The isolated (non-interval) points of the subset.","o|6v|1NB|1X|3M|1NC|36|75","a|3N|3O|3P|1Mx|1My|1Mz|3T|3U|3V|3W|3Z|1N2|1N4|1N7|1NA|1ND","An interactive number-line widget for entering a subset of real numbers (block-level; does not inherit from Input)","o|F|9J|54|AZ|9X|1Mw|1NE|3M|2p|2p|9J|1NF|AT","o|2m|4t|4u|3M|2s|1V","Name of the variable used when expressing the subset.","o|33|H1|1NI|Pw|H3","How the subset is displayed.","inequalities","a|1N8|1NL","Display the subset using interval notation (e.g., `(0, 1]`).","o|3s|1N8|1NN","Display the subset using inequalities (e.g., `0 < x ≤ 1`).","o|3s|1NL|1NP","a|1NO|1NQ","o|Bi|xU|1NK|1N8|1NM|1NR|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|1NH|51|55|58|5B|5E|5K|5N|5R|5X|63|1NJ|1NS","o|3L|xU|1T|2p|1NK|3M","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1NU|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1N4|1N7|1NA|1ND|7S|7V|7Y|7b","A subset of the real numbers, defined by intervals and points","o|F|2O|3j|3k|3l|1NT|1NV|3M|3M|2p|2O|1NW|3h","Type of value being split.","a|1T","Split text values.","o|3s|1T|1Na","a|1Nb","o|HC|2g|1NY|1NZ|1Nc|3y","splitBy","How to break the input string into pieces.","letter","word","comma","a|1Ng|1Nh|1Ni","Split into individual characters.","o|3s|1Ng|1Nk","Split into whitespace-separated words.","o|3s|1Nh|1Nm","Split on comma boundaries.","o|3s|1Ni|1No","a|1Nl|1Nn|1Np","o|Bi|1Ne|1Nf|1Ng|1Nj|1Nq|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Nd|1Nr|gB","Splits a string or list into pieces","o|F|2P|9U|9V|g0|1Ns|125|3M|3M|2p|2P|1Nt|Az","data","The data points to fit a line to.","o|2h|1Nv|1Nw|2W","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|1Nx","Number of dimensions of the line (always 2 for a best-fit line).","o|3Q|6r|1p|2p|1Nz","Whether the line can be dragged (always false for a best-fit line).","o|3Q|5L|1V|2p|1O1","The data points used to compute the best-fit line.","o|6v|1Nv|1X|3M|1O3|4X|IM","a|3N|3O|3P|Hd|QD|7s|QE|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|1O0|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up|1O2|1O4","The best-fit line for a set of points","o|F|2Q|Om|On|Op|1Ny|1O5|3M|2p|2p|2Q|1O6|Az","boundaryValues","Boundary values defining the region\'s left/right edges.","a|5Q|36","o|33|1O8|1O9|1OA|1a","The function whose graph bounds the region.","o|2h|1r|1OC|1r","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OB|1OD","o|3L|1O8|1a|2p|1O9|3M","A textual description of the region\'s style.","o|3Q|Hl|1T|2p|1OG",\'Style description including the word "region".\',"o|3Q|Ho|1T|2p|1OI","a|3N|3O|3P|Hd|QD|7s|QE|1OF|3T|3U|3V|3W|3Z|Hk|1OH|1OJ","A region bounded between a curve and the x-axis","o|F|9K|Om|On|Op|1OE|1OK|3M|2p|2p|9K|1OL|Az","a|I|J|1z|2S|w|x|y|1r|1s","112011101","Boundary values defining the region\'s edges.","o|33|1O8|1OP|1OA|1a","flipFunctions","Whether to swap the role of x and y for the input functions.","o|2m|1OR|1OS|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OQ|1OT","o|3L|1O8|1a|2p|1OP|3M","o|3L|1OR|1V|2p|1OS|3M","a|3N|3O|3P|Hd|QD|7s|QE|1OV|1OW|3T|3U|3V|3W|3Z|Hk|1OH|1OJ","A region bounded between two curves","o|F|9L|1ON|1OO|Op|1OU|1OX|3M|2p|2p|9L|1OY|Az","Whether the half-plane extends horizontally, bounded by the vertical line x = boundaryValue. If false, the half-plane extends vertically, bounded by the horizontal line y = boundaryValue.","o|2m|V3|1Oa|3M|2s|1V","boundaryValue","Position of the bounding line: x = boundaryValue when horizontal is true, y = boundaryValue when horizontal is false.","o|33|1Oc|1Od|5Q|1p","greaterThan","Whether the region is the side where the inequality is greater than the boundary.","o|2m|1Of|1Og|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Ob|1Oe|1Oh","o|3L|V3|1V|2p|1Oa|3M","o|3L|1Oc|1p|2p|1Od|3M","o|3L|1Of|1V|2p|1Og|3M","a|3N|3O|3P|Hd|QD|7s|QE|1Oj|1Ok|1Ol|3T|3U|3V|3W|3Z|Hk","A half-plane region bounded by a line","o|F|9M|Om|On|Op|1Oi|1Om|3M|2p|2p|9M|1On|Az","Initial code shown in the editor before the user types.","o|33|Zj|1Op|AZ|1T",\'Editor width (e.g. "100%" or "600px").\',"100","o|uD|1Os|2p","o|33|bx|1Or|1Ot|bz",\'Editor height (e.g. "500px").\',"n|6S","o|uD|1Ow|3M","o|33|k5|1Ov|1Ox|bz","viewerRatio","Fraction of the editor area allotted to the live viewer.","o|2h|1Oz|1P0|1p","showResults","Whether to render the results panel alongside the editor.","o|2m|1P2|1P3|2p|2s|1V","showFormatter","Whether to show a code formatter button.","o|2m|1P5|1P6|2p|2s|1V","resultsLocation","Position of the results panel relative to the editor.","a|5g|5h|5i","Place the results panel below the editor.","o|3s|5g|1PB","Place the results panel to the left of the editor.","o|3s|5h|1PD","Place the results panel to the right of the editor.","o|3s|5i|1PF","a|1PC|1PE|1PG","o|Bi|1P8|1P9|5g|1PA|1PH|3y","readOnly","Whether the editor is read-only.","o|2m|1PJ|1PK|2p|2s|1V","initialOpenTab","Which diagnostics/responses tab to open initially.","first","errors","warnings","info","accessibility","responses","help","a|42|1PO|1PP|1PQ|1PR|1PS|1PT|1PU","Panel starts closed.","o|3s|42|1PW","Open the first available tab.","o|3s|1PO|1PY","Open the errors tab.","o|3s|1PP|1Pa","Open the warnings tab.","o|3s|1PQ|1Pc","Open the info tab.","o|3s|1PR|1Pe","Open the accessibility tab.","o|3s|1PS|1Pg","Open the responses tab.","o|3s|1PT|1Pi","Open the help tab.","o|3s|1PU|1Pk","a|1PX|1PZ|1Pb|1Pd|1Pf|1Ph|1Pj|1Pl","o|Bi|1PM|1PN|1PO|1PV|1Pm|3y","renderedName","Name to assign to the dynamically-rendered DoenetML output.","o|2h|1Po|1Pp|1T","staticName","Name to assign to the static DoenetML source.","o|2h|1Pr|1Ps|1T","a|2j|2t|2w|2z|32|37|3A|3E|3H|1Oq|u5|1Ou|1Oy|1P1|1P4|1P7|1PI|1PL|1Pn|1Pq|1Pt","o|3L|Zj|1T|2p|1Op|3M","o|3L|bx|bz|2p|1Or|3M","o|3L|k5|bz|2p|1Ov|3M","o|3L|1P2|1V|2p|1P3|3M","o|3L|1P5|1V|2p|1P6|3M","o|3L|1P8|1T|2p|1P9|3M","o|3L|1PJ|1V|2p|1PK|3M","o|3L|1PM|1T|2p|1PN|3M","The code value of the input.","o|3Q|3a|1T|2p|1Q3","The code value reflecting the user\'s in-progress edits.","o|3Q|ef|1T|2p|1Q5","The current code as a plain text string.","o|3Q|1T|1T|2p|1Q7","a|3N|3O|3P|1Pv|1Pw|1Px|1Py|1Pz|1Q0|1Q1|1Q2|3T|3U|3V|3W|3Z|eV|eY|1Q4|1Q6|1Q8","An interactive DoenetML code editor","o|F|9N|9U|9V|9X|1Pu|1Q9|3M|3M|2p|9N|1QA|AT","Variable used when comparing factored expressions.","o|33|H1|1QC|Pw|H3","restrictDivision","Whether to disallow dividing through to match factored forms.","o|2m|1QE|1QF|2p|2s|1V","monomialFactorMustMatch","Whether monomial factors must match exactly (implies restrictDivision).","o|2m|1QH|1QI|2p|2s|1V","allowOnlySignDifferences","Whether to count factorizations as equivalent when they differ only by sign.","o|2m|1QK|1QL|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1QD|1QG|1QJ|1QM","Whether the input math expressions share the same factoring.","o|3Q|3a|1V|2p|1QO","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|1QP|CW","Boolean condition that tests for equivalent factoring","o|F|2R|3j|3k|3l|1QN|1QQ|3M|2p|2p|2R|1QR|3h","position","Position of the legend on the graph.","a|5c|5d|5e|5f","Place the legend in the upper-right corner.","o|3s|5c|1QW","Place the legend in the upper-left corner.","o|3s|5d|1QY","Place the legend in the lower-right corner.","o|3s|5e|1Qa","Place the legend in the lower-left corner.","o|3s|5f|1Qc","a|1QX|1QZ|1Qb|1Qd","o|Bi|1QT|1QU|5c|1QV|1Qe|3y","displayClosedSwatches","Whether to render closed/filled swatches in the legend.","o|2m|1Qg|1Qh|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Qf|1Qi","o|3L|1QT|1T|2p|1QU|3M","o|3L|1Qg|1V|2p|1Qh|3M","a|3N|3O|3P|Hd|QD|7s|QE|1Qk|1Ql|3T|3U|3V|3W|3Z|Hk","A legend describing the contents of a graph","o|F|9O|Om|On|Op|1Qj|1Qm|3M|2p|2p|9O|1Qn|Az","o|3Q|3a|2S|2p|80","a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|1Qp","A label for an input, answer, button, or graphical object","o|F|2S|2Z|2a|3l|7q|1Qq|3M|3M|2p|2S|1Qr|3h","pattern","Math expression pattern to match against.","o|2h|1Qt|1Qu|1X","allowImplicitIdentities","Whether to allow implicit identity transformations when matching.","o|2m|1Qw|1Qx|2p|2s|1V","allowPermutations","Whether to allow permutations of operands when matching.","o|2m|1Qz|1R0|3M|2s|1V","requireNumericMatches","Whether numeric placeholders must match numbers.","o|2m|1R2|1R3|2p|2s|1V","requireVariableMatches","Whether variable placeholders must match variables.","o|2m|1R5|1R6|2p|2s|1V","excludeMatches","Patterns whose matches are excluded.","o|33|1R8|1R9|54|1Y","matchExpressionWithBlanks","Whether to allow expressions with blanks to match.","o|2m|1RB|1RC|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1Qv|1Qy|1R1|1R4|1R7|1RA|1RD","o|3L|1Qw|1V|2p|1Qx|3M","o|3L|1Qz|1V|2p|1R0|3M","o|3L|1R2|1V|2p|1R3|3M","o|3L|1R5|1V|2p|1R6|3M","o|3L|1R8|1Y|2p|1R9|3M","o|3L|1RB|1V|2p|1RC|3M","Whether the input matches the pattern.","o|3Q|3a|1V|2p|1RL","numMatches","The number of matches found.","o|3Q|1RN|1p|2p|1RO","patternMatches","The list of matched sub-expressions.","o|6v|1RQ|1X|3M|1RR|36|75","a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|1RF|1RG|1RH|1RI|1RJ|1RK|3T|3U|3V|3W|3Z|1RM|CW|1RP|1RS","Boolean condition that tests whether input matches a math pattern","o|F|2T|3j|3k|3l|1RE|1RT|3M|3M|2p|2T|1RU|3h","childContextHelp","a|3|4|5|6|7|8|9|A|B|C|D|E|1RW","a|93|1z|94","020","Value used for entries that aren\'t explicitly specified.","o|33|e0|1Ra|Ng|1X","Number of rows in the matrix.","o|2h|7A|1Rc|1q","Number of columns in the matrix.","o|2h|7D|1Re|1q","a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Rb|1Rd|1Rf","Whether matrix entries should be treated as unordered.","o|3Q|4n|1V|2p|1Rh","o|3Q|3a|2U|2p|6e","a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1Ri|1Rj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b","A matrix of math values","a|93|94","matrixRow","matrixColumn","o|1Rm|1Rn|1Ro","o|1RX|2U|1RY|1RZ|3l|1Rg|1Rk|3M|2p|2p|2U|1Rl|3h|1Rp","a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j","numEigenvectors","The number of eigenvectors found in the decomposition.","o|3Q|1Rs|1q|2p|1Rt","eigenvalues","The eigenvalues of the matrix.","o|6v|1Rv|1p|3M|1Rw|36|IR","eigenvectors","The eigenvectors of the matrix, as a 2D array (one column per eigenvalue).","a|X0|6y","o|Qc|1Ry|1p|3M|1Rz|4X|1S0|Qf","a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1Ru|1Rx|1S1","Computes the eigenvalues and eigenvectors of a square matrix","o|F|9P|3j|3k|Ao|1Rr|1S2|3M|2p|2p|9P|1S3|Az","a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19|w|x|y|1J|1K|1N|1R|1S|1d|1f|1h|1i|1k|1r|1s|2K|2Q|2W|2Y|O|P","1220111222222222111111111111111111111112210222022212221222212222211121222112111111111111111111222222222222222222201","o|2m|JZ|Ja|3M|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|1S7|5X|63","o|3Q|3a|2V|2p|fs","The LaTeX content as a string.","o|3Q|2V|2V|2p|1SA","a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1S9|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1SB","A snippet of LaTeX that can be rendered as math","o|F|2V|1S5|1S6|3l|1S8|1SC|3M|3M|2p|2V|1SD|3h","A block-level quotation","o|F|9Q|9U|9V|9X|3I|Aa|3M|3M|2p|9Q|1SF|AT","Extra information about an enclosing component, shown to all users in a popup or disclosure","o|F|2f|9U|9V|9X|3I|Aa|2p|3M|2p|2f|1SH|AT","a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y","112022222222222222222222222222111122222121111111111111222222122222222122221111121222","Whether the snapping threshold is interpreted relative to graph scales.","o|2m|194|1SL|2p|2s|1V","Distance threshold within which group members snap together.","o|2h|E6|1SN|1p","angleThreshold","Angular distance within which group members snap together.","n|0.:7C4pdy2qXy","o|33|1SP|1SQ|1SR|1p","a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1SM|1SO|1SS","o|3L|194|1V|2p|1SL|3M","o|3L|1SP|1p|2p|1SQ|3M","Distance within which group members attract each other.","o|3Q|E6|1p|2p|1SW","a|3N|3O|3P|Hd|QD|7s|QE|1SU|1SV|3T|3U|3V|3W|3Z|Hk|T4|1SX","Constrains group members to attract to each other when nearby","o|F|9R|1SJ|1SK|Op|1ST|1SY|3M|2p|2p|9R|1SZ|Az","a|8J","_blockScoredComponent","a|1Sc|9W|2d","maxNumColumns","Maximum number of columns when arranging child problems.","o|33|1Se|1Sf|4X|1q","mode","Arrangement mode for the child problems.","circuit","a|9S|1Sj","Interleaved arrangement where each problem\'s answer feeds the next and one can start with any problem.","o|3s|9S|1Sl","A variant of the pretzel where one must start with the first problem.","o|3s|1Sj|1Sn","a|1Sm|1So","o|Bi|1Sh|1Si|9S|1Sk|1Sp|3y","a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|1Sg|1Sq","o|3L|1Se|1q|2p|1Sf|3M","o|3L|1Sh|1T|2p|1Si|3M","numProblems","The number of child problems.","o|3Q|1Su|1q|2p|1Sv","The current responses across all child problems.","o|6v|re|1T|3M|1Sx|36|Jt","The number of responses submitted.","o|3Q|rk|1p|2p|1Sz","The most recently submitted responses.","o|6v|rn|1T|3M|1T1|36|Jt","a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|1Ss|1St|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|1Sw|1Sy|1T0|1T2","A response-matching component where students enter a sequence to match statements and answers","o|F|9S|1Sb|Nf|1Sd|1Sr|1T3|3M|2p|2p|9S|1T4|AT","o|2m|L8|L9|3M|2s|1V","hideFutureSections","Whether to hide later cascade sections until previous ones are completed.","o|2m|1T7|1T8|2p|2s|1V","revealAll","Whether all cascade entries should be revealed regardless of progress.","o|2m|1TA|1TB|2p|2s|1V","boxAll","Whether to draw boxes around all cascade entries regardless of progress.","o|2m|1TD|1TE|2p|2s|1V","a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|1T6|LD|LG|LI|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|1T9|1TC|1TF","o|3L|1T7|1V|2p|1T8|3M","o|3Q|20|1V|2p|LH","numCompleted","The number of cascade sections currently completed.","o|3Q|1TJ|1q|2p|1TK","a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Ly|1TH|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9|1TI|1TL","Sectional component that reveals its children step-by-step","o|F|9T|Ku|Kv|N8|1TG|1TM|3M|3M|2p|9T|1TN|AT","The short description text.","o|3Q|3a|dd|2p|1TP","a|3N|3O|3P|3T|3U|3V|3W|3Z|1TQ|3e","A short accessibility description (e.g. for a `<graph>`) read by screen readers","o|F|dd|2Z|2a|2e|3I|1TR|2p|3M|2p|dd|1TS|3h","a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|1z|21|24|29|2A|2K|2O|2U|2W|2X|2Y|L|M|N|Q|w|x|y|z|1K|1L|1M|1N|1R|1S|1T|1U|1a|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2Q|2V","1111111111111111111111111022012122212111122222222222222222222222222222222222222","Whether the order of points in this list should be treated as unordered (e.g. for matching).","o|2m|4n|1TW|2p|2s|1V","Maximum number of points to retain in the list.","o|33|g7|1TY|9k|1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|1TX|1TZ|gB|gn|go|gp|gq|gr","o|3L|g7|1p|2p|1TY|3M","The number of points in the list.","o|3Q|Ps|1p|2p|1Tc","o|3Q|gI|1p|2p|1Tc","a|3N|3O|1Tb|3Z|gy|1Td|1Te","A list of points","o|F|2W|1TU|1TV|g0|1Ta|1Tf|3M|3M|2p|2W|1Tg|Az","a|1t|1z|2X|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2Y","0221222211111111111111111111112222222221222202222122222222222212222212222121222","Whether the order of intervals in this list should be treated as unordered (e.g. for matching).","o|2m|4n|1Tk|2p|2s|1V","Maximum number of intervals to retain in the list.","o|33|g7|1Tm|9k|1p","a|2j|2t|2w|g2|32|37|g4|3E|3H|1Tl|1Tn|gB|gn|go|gp|gq|gr","o|3L|g7|1p|2p|1Tm|3M","numIntervals","The number of intervals in the list.","o|3Q|1Tq|1p|2p|1Tr","o|3Q|gI|1p|2p|1Tr","a|3N|3O|1Tp|3Z|gy|1Ts|1Tt","A list of intervals","o|F|2X|1Ti|1Tj|g0|1To|1Tu|3M|3M|2p|2X|1Tv|Az","a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr","a|3N|3O|n8|3Z|gy|nD|nE","A list of vectors","o|F|2Y|mh|mi|g0|1Tx|1Ty|3M|3M|2p|2Y|1Tz|Az","a|3i|7e|84|88|AU|AW|AY|Ac|Ae|Am|B0|BD|BF|BL|BQ|BS|BX|Cb|Ck|Cm|Co|Cq|Cs|Cz|D1|DD|DT|DX|Dm|Dq|E5|EE|EJ|EN|ER|EV|EZ|Ed|Eh|Eq|Eu|Ey|F2|F6|FA|FE|FI|Fn|J9|JB|JU|K7|KE|KG|KI|KK|KM|KO|KQ|KS|KU|KW|Kd|Kf|Kh|Kj|Kl|Kn|Kp|Kr|MC|ME|MG|MK|MS|MW|Md|Mf|Mh|Mj|Ml|Mn|Mp|Mr|Mt|Mv|N7|ND|NF|NP|NR|NW|Ol|RI|TU|Us|Xe|Yf|Z8|ZQ|ZY|Zi|a4|aC|bu|cl|co|cq|cs|cu|cw|d1|dE|dc|eo|fK|fW|fY|fp|fw|gN|gP|gU|gf|gj|h7|h9|hJ|hW|hu|hy|i5|i9|if|j6|jC|jk|jp|kJ|lC|m1|mS|mW|mg|nH|oT|pH|s8|ss|t5|u0|uU|us|vp|wK|wm|wr|10d|10g|111|117|11J|11Q|11e|127|137|14Q|155|15d|15l|15v|16s|17B|17U|17k|17n|187|18X|18g|191|19B|19L|19P|19W|19Y|19g|19o|19v|1AG|1Ao|1B1|1BI|1C3|1CO|1D6|1DI|1Dm|1E2|1Ed|1FG|1Hg|1IY|1Ih|1Io|1J4|1JD|1JF|1JH|1Jl|1KT|1Km|1Kv|1LL|1LP|1LR|1LV|1Ld|1Li|1Ls|1MF|1MK|1Mj|1NG|1NX|1Nu|1O7|1OM|1OZ|1Oo|1QB|1QS|1Qo|1Qs|1RV|1Rq|1S4|1SE|1SG|1SI|1Sa|1T5|1TO|1TT|1Th|1Tw|1U0","a|1Rn|1Ro","displayName","a|3|7|8|C|D|4|5|6|A|1U3|156","row_matrix","A list of math values defining the row of a matrix","in a matrix","o|1U4|1Rn|gw|h5|1U5|1U6|3j|3k|g0|3M|93|1U7","column_matrix","A list of math values defining the column of a matrix","o|1U4|1Ro|gw|h5|1U9|1UA|3j|3k|g0|3M|94|1U7","o|1U2|1U8|1UB","o|2|1U1|1UC"],"1UD"]),_COMPLETION_SNIPPETS=distExports.decompress([["multiple-choice-answer","multiple-choice-select-multiple-answer","if-at-(immediate-feedback-assessment-technique)-answer","answer-labeled","pretzel-06","pretzel-08","pretzel-10","pretzel-12","table-with-tabular","video-watched-credit","a|0|1|2|3|4|5|6|7|8|9","element","snippet","description","cursor","a|B|C|D|E","answer",`\n<answer name="mcq" inline="false" shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>`,"Multiple choice answer template","selectionStartOffset","selectionEndOffset","a|J|K","n|F","n|I","o|L|M|N","o|F|G|H|I|O",`\n<answer name="mcq" selectMultiple inline="false" shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>`,"Multiple choice select-multiple answer template","o|F|G|Q|R|O",`\n<answer name="ifat" disableWrongChoices creditByAttempt="1 0.7 0.5" disableAfterCorrect shuffleOrder="false">\n  <label></label>\n  <choice credit="1"></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n  <choice></choice>\n</answer>`,"IF-AT (Immediate Feedback Assessment Technique) answer template","n|J","o|L|M|V","o|F|G|T|U|W",`\n<answer name="answer1">\n  <label></label>\n</answer>`,"answer with label (for accessibility)","n|M","o|L|M|a","o|F|G|Y|Z|b","pretzel",`\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>`,"Pretzel template with 6 problems","n|G","n|O","o|L|g|h","o|F|d|e|f|i",`\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>`,"Pretzel template with 8 problems","o|F|d|k|l|i",`\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 9 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 10 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>`,"Pretzel template with 10 problems","o|F|d|n|o|i",`\n<pretzel name="pretzel1" maxNumColumns="2">\n\n  <!-- problem 1 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 2 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 3 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 4 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 5 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 6 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 7 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 8 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 9 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 10 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 11 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n\n  <!-- problem 12 -->\n  <problem>\n    <statement>\n      \n    </statement>\n    <answer>\n      \n    </answer>\n  </problem>\n  \n</pretzel>`,"Pretzel template with 12 problems","o|F|d|q|r|i","table",`\n<table name="table1">\n  <title></title>\n  <tabular>\n    <row header>\n      <cell></cell>\n      <cell></cell>\n    </row>\n    <row>\n      <cell></cell>\n      <cell></cell>\n    </row>\n  </tabular>\n</table>`,"Table with tabular template","n|E","n|K","o|L|w|x","o|F|t|u|v|y","video",`\n<video name="video1" youtube="" >\n  <shortDescription></shortDescription>\n</video>\n<answer name="video1Watched" type="videoWatched" video="$video1" />\n`,"Video that gives credit when watched","o|F|10|11|12|y","o|A|P|S|X|c|j|m|p|s|z|13"],"14"]),COMPLETION_SNIPPETS=_COMPLETION_SNIPPETS;function initOffsetToRowCache(){return createOffsetToPositionMap(this.source)}function initRowToOffsetCache(){const D=this.source||"",E=(String(D).match(/\\n/g)||"").length+1,F=new Uint32Array(E),J=D.length;let $e=0;F[0]=0;for(let _t=0;_t<J;_t++)D.charAt(_t)===`\n`&&($e+=1,F[$e]=_t+1);return F}function initLezer(){return stringToLezer(this.source||"")}function initLezerCursor(){return this._lezer().cursor()}function initDast(){return lezerToDast(this._lezer(),this.source)}function initParentMap(){const D=new Map;for(const E of this.dast.children)D.set(E,this.dast);return visit$1(this.dast,E=>{const F=E;if(F.type==="element")for(const J of F.children)D.set(J,F)}),D}function initOffsetToNodeMapRight(){const D=this.dast,E=new Array(this.source.length).fill(null);return visit$1(D,F=>{const J=F;if(J.type==="error"||!J.position)return;const{start:$e,end:_t}=J.position;if(!($e.offset==null||_t.offset==null))for(let lr=$e.offset;lr<_t.offset;lr++)E[lr]=J}),E}function initOffsetToNodeMapLeft(){const E=[this.dast,...this._offsetToNodeMapRight()];return E.pop(),E}function initOffsetToNodeIndexMap(){const D=new Map,E=new Map,F=this.dast;let J=0;const $e=(mr,Or)=>{const Pr=mr.type==="element"?mr:Or;if(E.set(mr,Pr),mr.type==="element"){D.set(mr,J++);for(const dn of mr.children)$e(dn,mr)}};D.set(F,J++);for(const mr of F.children)$e(mr,F);return this._offsetToNodeMapRight().map(mr=>{if(!mr)return null;const Or=mr.type==="element"?mr:E.get(mr)??F;return D.get(Or)??null})}function initDescendantNamesMap(){const D=this.dast,E=new Map,F=[];return E.set(D,F),visit$1(D,(J,$e)=>{const _t=J;if(_t.type!=="element")return;E.has(_t)||E.set(_t,[]);const lr=_t.attributes.name;if(!lr)return;const mr=toXml(lr.children);for(const Or of $e.parents){const Pr=Or;E.has(Pr)||E.set(Pr,[]),E.get(Pr).push({name:mr,element:_t})}F.push({name:mr,element:_t})}),E}function createOffsetToPositionMap(D){D||(D="");const E=new Uint32Array(D.length+1),F=new Uint32Array(D.length+1),J=D.length;let $e=0,_t=0;for(let lr=0;lr<J;lr++)E[lr]=$e,F[lr]=_t,D.charAt(lr)===`\n`?($e+=1,_t=0):_t+=1;return E[J]=$e,F[J]=_t,{rowMap:E,columnMap:F}}function uninitializedLazyData(){return{type:"lazy-data",init:!1,data:null}}function initializedLazyData(D){return{type:"lazy-data",init:!0,data:D}}function resetLazyData(D){D.init=!1,D.data=null}function isLazyData(D){return typeof D=="object"&&D!=null&&D.type==="lazy-data"}class LazyDataObject{constructor(){this._lazyData={}}_clearLazyData(){for(const[E,F]of Object.entries(this._lazyData))resetLazyData(F)}_lazyDataGetter(E){const F=generateNameFromInitializer(E,this._lazyData);return this._lazyData[F]=uninitializedLazyData(),function J(){if(!(F in this._lazyData))throw new Error(`Lazy data cache object named "${F}" not found`);const $e=this._lazyData[F];if(!isLazyData($e))throw new Error(`Asked to treat "${F}" as a lazy data but it appears not to be`);return $e.init?$e.data:(this._lazyData[F]=initializedLazyData(E.call(this)),J.call(this))}}}function generateNameFromInitializer(D,E){let J=(D.toString().replace("function ","").replace(/\\(.*/,"").split(`\n`)[0]||"").replace(/^(_?)init/,"");for(;J in E;)J+="_";return J}function elementAtOffsetWithContext(D){typeof D!="number"&&(D=this.rowColToOffset(D));let E="unknown",F=!1;const J=this.source.charAt(D-1),$e=this.nodeAtOffset(D),_t=$e?this.getParent($e):null;let lr=this.nodeAtOffset(D,{type:"element"});const mr=this._lezerCursor();mr.moveTo(D,-1);const Or=mr.node.parent?.type?.name,Pr=mr.node.type.name==="TagName"&&(Or==="OpenTag"||Or==="SelfClosingTag");if(($e&&$e!==lr||!$e||!_t||lr?.type==="element"&&lr.name===""&&_t.type==="root")&&(E="body"),lr?.type==="element"&&lr.position?.start?.offset===D&&!Pr){E="body";const zi=lr.name!=="";_t?.type==="element"?lr=_t:(lr=null,F=_t?.type==="root"&&zi)}if(!lr&&!F&&(E="unknown"),lr&&E==="unknown"){const zi=this._lezerCursor();zi.moveTo(D,-1);const Hi=zi.node;zi.moveTo(D,1);const Qi=zi.node,Gi=Hi.index!==Qi.index,Zi=Gi?J.match(/\\w/)?Hi:Qi:Hi,Xi=Qi.type.name;if(Gi&&Xi==="StartCloseTag"&&!Pr){E="body";const Ki=this.nodeAtOffset(Hi.from,{type:"element"}),ea=Hi.parent?.type?.name;if(Ki&&(ea==="CloseTag"||ea==="SelfClosingTag")){const Ji=this.getParent(Ki);lr=Ji?.type==="element"?Ji:null}else lr=Ki}else{const Ki=Zi.type.name,ea=Zi.parent?.type?.name;switch(Ki){case"TagName":{if(ea==="OpenTag"||ea==="SelfClosingTag"){E="openTagName";const Ji=this.nodeAtOffset(Zi.from,{type:"element"});Ji&&(lr=Ji)}else E="closeTagName";break}case"AttributeName":E="attributeName";break;case"AttributeValue":{const Ji=this.source.charAt(Zi.from);E=Ji===\'"\'||Ji==="\'"?"attributeValue":"attributeName";break}case"OpenTag":case"SelfClosingTag":case"SelfCloseEndTag":E="openTag";break;case"EndTag":ea==="OpenTag"||ea==="SelfClosingTag"?E="openTag":J.match(/(\\s|\\n)/)?E="unknown":E="closeTagName";break;case"StartCloseTag":E="closeTagName";break}}}if(!lr&&J.match(/(\\w|<)/))return this.elementAtOffsetWithContext(D-1);const dn=!!J.match(/(\\s|\\n)/);let gi=D-1;for(;this.source.charAt(gi).match(/(\\s|\\n)/);)gi-=1;const qi=this.source.charAt(gi);if(E==="body"&&dn){const zi=this.nodeAtOffset(D-1);zi&&zi.type==="element"&&(lr=zi)}if(!lr&&E==="unknown"&&dn&&qi!==">"){const zi=this.nodeAtOffset(gi);zi&&zi.type==="element"&&(lr=zi)}if(lr&&E==="unknown"&&dn){const zi=this._lezerCursor();zi.moveTo(gi,1);const Hi=zi.node.type.name,Qi=zi.node.parent?.type?.name;switch(Hi){case"TagName":if(Qi==="CloseTag")break;case"Attribute":case"AttributeName":case"AttributeValue":E="openTag";break}}if(lr?.type!=="element"&&(lr=null),lr&&lr.name==="")if(E==="body"){const zi=this.getParent(lr);zi?.type==="element"?lr=zi:(lr=null,E="unknown")}else return D>0?this.elementAtOffsetWithContext(D-1):{node:null,cursorPosition:"unknown"};return{node:lr,cursorPosition:E}}function getMacroReferentAtOffset(D,E){const[F,...J]=E.path;if(!F)return null;if(F.index.length>0)throw new Error(`The first part of a macro path must be just a name without an index. Failed to resolve "${toXml(E)}"`);let $e=this.getReferentAtOffset(D,F.name);if(!$e)return null;if(J.length===0)return{node:$e,unresolvedPath:[]};let _t=$e;for(let lr=0;lr<J.length;lr++){const mr=J[lr];if(mr.index.length>0)return{node:$e,unresolvedPath:J.slice(lr)};const Or=this.getNamedDescendant(_t,mr.name);if(!Or)return{node:$e,unresolvedPath:J.slice(lr)};$e=Or,_t=Or}return{node:$e,unresolvedPath:[]}}function getAddressableNamesAtOffset(D){const E=this.elementAtOffsetWithContext(D).node||this.dast,F=this._descendantNamesMap(),J=getMacroAddressableChildrenAtElement(E,F),_t=this.getParents(E).map(lr=>getMacroAddressableChildrenAtElement(lr,F));return mergeLeftUniquePrefixes(J,_t)}function getMacroAddressableChildrenAtElement(D,E){const F=E.get(D);if(!F)throw new Error(`Expected accessList to be defined for ${D.type==="root"?"root":D.name}`);const J=[],$e=new Set(filterUnique(F.map(_t=>_t.name)));for(const _t of $e)J.push([_t]);for(const{name:_t,element:lr}of F.filter(mr=>$e.has(mr.name))){const mr=getMacroAddressableChildrenAtElement(lr,E);J.push(...mr.map(Or=>[_t,...Or]))}return J}function filterUnique(D){const E=new Map;for(const F of D)E.set(F,(E.get(F)||0)+1);return D.filter(F=>E.get(F)===1)}function mergeLeftUniquePrefixes(D,E){const F=[...D],J=new Set(D.flatMap(getPrefixes).map($e=>$e.join(",")));for(const $e of E){const _t=[];for(const lr of $e)getPrefixes(lr).some(mr=>J.has(mr.join(",")))||(F.push(lr),_t.push(...getPrefixes(lr).map(mr=>mr.join(","))));for(const lr of _t)J.add(lr)}return F}function getPrefixes(D){return D.map((E,F)=>D.slice(0,F+1))}function nodeAtOffset(D,E){let{type:F,side:J="right"}=E||{};if(typeof D!="number"&&(D=this.rowColToOffset(D)),D<0||D>this.source.length)return null;D>0&&D===this.source.length&&J==="left"&&(J="right",D-=1);let _t=(J==="right"?this._offsetToNodeMapRight():this._offsetToNodeMapLeft())[D]||null;if(F!=null){for(;_t&&_t.type!=="root"&&_t.type!==F;)_t=this.getParent(_t);if(_t&&_t.type!==F)return null}return _t}function elementAtOffset(D,E){const{side:F="right"}=E||{};return typeof D!="number"&&(D=this.rowColToOffset(D)),this.nodeAtOffset(D,{type:"element",side:F})}const ATTR_VALUE_CHAR=/[A-Za-z0-9_-]/;function scanBareValueRun(D,E){let F=E;for(;F>0&&ATTR_VALUE_CHAR.test(D.charAt(F-1));)F--;let J=F;for(;J>0&&/\\s/.test(D.charAt(J-1));)J--;const $e=J>0&&D.charAt(J-1)==="="?J-1:null;return{valueStartOffset:F,equalsOffset:$e}}function findPrecedingEqualsForBareValue(D,E){return scanBareValueRun(D,E).equalsOffset}function synthesizeStrippedAttribute(D,E,F,J){if(F<=E)return null;const $e=J(E),_t=J(F);return{type:"attribute",name:D.slice(E,F),children:[],position:{start:{line:$e.line,column:$e.column,offset:E},end:{line:_t.line,column:_t.column,offset:F}}}}function scanIdentifierBackward(D,E){let F=E;for(;F>0&&ATTR_VALUE_CHAR.test(D.charAt(F-1));)F--;return F}function scanIdentifierForward(D,E){let F=E;for(;F<D.length&&ATTR_VALUE_CHAR.test(D.charAt(F));)F++;return F}function nonTagIdentifierSpan(D,E,F){return E===F||E>0&&D.charAt(E-1)==="<"?null:{start:E,end:F}}function identifierAtOffset(D,E){return nonTagIdentifierSpan(D,scanIdentifierBackward(D,E),scanIdentifierForward(D,E))}function identifierPrecedingOffset(D,E){let F=E;for(;F>0&&/\\s/.test(D.charAt(F-1));)F--;return nonTagIdentifierSpan(D,scanIdentifierBackward(D,F),F)}function findAttributeContainingOffset(D,E,F){const J=F?.endInclusive??!0,$e=F?.exclude;return D.find(lr=>{if(lr===$e)return!1;const mr=lr.position?.start.offset,Or=lr.position?.end.offset;return mr==null||Or==null?!1:mr<=E&&(J?Or>=E:Or>E)})??null}class DoenetSourceObject extends LazyDataObject{constructor(E){super(),this.source="",this._lezer=this._lazyDataGetter(initLezer),this._lezerCursor=this._lazyDataGetter(initLezerCursor),this._dast=this._lazyDataGetter(initDast),this._offsetToRowCache=this._lazyDataGetter(initOffsetToRowCache),this._rowToOffsetCache=this._lazyDataGetter(initRowToOffsetCache),this._parentMap=this._lazyDataGetter(initParentMap),this._offsetToNodeMapRight=this._lazyDataGetter(initOffsetToNodeMapRight),this._offsetToNodeMapLeft=this._lazyDataGetter(initOffsetToNodeMapLeft),this._offsetToNodeIndexMap=this._lazyDataGetter(initOffsetToNodeIndexMap),this._descendantNamesMap=this._lazyDataGetter(initDescendantNamesMap),this.nodeAtOffset=nodeAtOffset,this.elementAtOffsetWithContext=elementAtOffsetWithContext,this.elementAtOffset=elementAtOffset,this.getMacroReferentAtOffset=getMacroReferentAtOffset,this.getAddressableNamesAtOffset=getAddressableNamesAtOffset,E!=null&&this.setSource(E)}setSource(E){return this.source===E?this:(this._clearLazyData(),this.source=E,this)}offsetToRowCol(E){const F=this._offsetToRowCache();return{line:F.rowMap[E]+1,column:F.columnMap[E]+1}}offsetToLSPPosition(E){const F=this._offsetToRowCache();return{line:F.rowMap[E],character:F.columnMap[E]}}rowColToOffset(E){const F=this._rowToOffsetCache();let J=("row"in E?E.row:E.line)-1,$e=("col"in E?E.col:"column"in E?E.column:E.character)-1;return"character"in E&&(J+=1,$e+=1),F[J]+$e}getNodeIndexAtOffset(E){const F=this._offsetToNodeIndexMap();return E<0||E>this.source.length?null:E===this.source.length?this.source.length===0?null:F[this.source.length-1]??null:F[E]??null}attributeAtOffset(E){typeof E!="number"&&(E=this.rowColToOffset(E));const F=E,J=this.elementAtOffsetWithContext(E);if(!J.node||J.cursorPosition!=="attributeName"&&J.cursorPosition!=="attributeValue"&&J.cursorPosition!=="openTag"&&J.cursorPosition!=="unknown")return null;const $e=Object.values(J.node.attributes),_t=findAttributeContainingOffset($e,F);if(!_t){const mr=findPrecedingEqualsForBareValue(this.source,F);if(mr!=null){const Pr=findAttributeContainingOffset($e,mr,{endInclusive:!1});if(Pr)return Pr;const dn=identifierPrecedingOffset(this.source,mr);return dn?synthesizeStrippedAttribute(this.source,dn.start,dn.end,gi=>this.offsetToRowCol(gi)):null}const Or=identifierAtOffset(this.source,F);return Or?synthesizeStrippedAttribute(this.source,Or.start,Or.end,Pr=>this.offsetToRowCol(Pr)):null}const lr=_t.position?.start.offset;if(lr!=null&&lr>0){const mr=findPrecedingEqualsForBareValue(this.source,lr);if(mr!=null){const Or=findAttributeContainingOffset($e,mr,{endInclusive:!1,exclude:_t});if(Or)return Or}}return _t}isCompleteElement(E){if(E.type!=="element")throw new Error(`Node ${toXml(E)} is not an element. Only elements maybe passed to this function.`);if(!E.position||E.position.start.offset==null)throw new Error(`Node ${JSON.stringify(E)} is missing position information`);const F=this._lezerCursor();F.moveTo(E.position.start.offset+1,0);const J=F.node,$e=J.parent,_t=J.type.name;let lr=!0,mr=!0;switch(_t){case"OpenTag":{J.getChild("EndTag")||(lr=!1),$e?.getChild("CloseTag")?this._isCloseTagStolenFromAncestor($e)&&(mr=!1):mr=!1;break}case"SelfClosingTag":{J.getChild("SelfCloseEndTag")||(lr=!1);break}default:console.warn("Could not find OpenTag or SelfClosingTag for node",E)}return{tagComplete:lr,closed:mr}}_isCloseTagStolenFromAncestor(E){const J=E.getChild("OpenTag")?.getChild("TagName");if(!J)return!1;const $e=this.source.slice(J.from,J.to);if(!$e)return!1;let _t=E.parent;for(;_t;){if(_t.type.name!=="Element")return!1;const mr=_t.getChild("OpenTag")?.getChild("TagName");if(!mr||this.source.slice(mr.from,mr.to)!==$e)return!1;if(!_t.getChild("CloseTag"))return!0;_t=_t.parent}return!1}getElementTagRanges(E){const F=E.position?.start?.offset||0,J=E.position?.end?.offset||0,$e=E.children[0]?.position?.start?.offset,_t=E.children[E.children.length-1]?.position?.end?.offset;return $e==null||_t==null?[{start:F,end:J}]:[{start:F,end:$e},{start:_t,end:J}]}getParent(E){return this._parentMap().get(E)||null}getParentElementName(E){const F=this.getParent(E);return F&&"name"in F?F.name:void 0}getParents(E){const F=[];let J=this.getParent(E);for(;J&&J.type!=="root";)F.push(J),J=this.getParent(J);return F.push(this.dast),F}getNamedDescendant(E,F){if(!E)return null;const $e=(this._descendantNamesMap().get(E)||[]).filter(_t=>_t.name===F);return $e.length===1?$e[0].element:null}getDescendantNamesForNode(E){return E?(this._descendantNamesMap().get(E)||[]).map(({name:F})=>F):[]}getUniqueDescendantNamesForNode(E){const F=this.getDescendantNamesForNode(E),J=new Map;for(const $e of F)J.set($e,(J.get($e)||0)+1);return F.filter($e=>J.get($e)===1)}getReferentAtOffset(E,F){const{node:J}=this.elementAtOffsetWithContext(E);let $e=J,_t=this.getNamedDescendant($e,F);for(;$e&&$e.type!=="root"&&!_t;)$e=this._parentMap().get($e),_t=this.getNamedDescendant($e,F);return!$e&&!_t&&(_t=this.getNamedDescendant(this.dast,F)),_t||null}getNodeRange(E,F){Array.isArray(E)||(E=[E]);let J=Math.min(1/0,...E.map(_t=>_t.position?.start?.offset||0));J===1/0&&(J=0);const $e=Math.max(0,...E.map(_t=>_t.position?.end?.offset||0));return F==="lsp"?{start:this.offsetToLSPPosition(J),end:this.offsetToLSPPosition($e)}:{start:this.offsetToRowCol(J),end:this.offsetToRowCol($e)}}get dast(){return this._dast()}get lezerCursor(){return this._lezerCursor()}}function walkIndexAliases(D,E){if(!D.isArray)return null;const F=D.numDimensions??1,J=D.indexAliases;if(!J||J.length===0||E.length===0)return null;let $e=E[0].numIndices;if($e>F)return null;const _t=[];for(let lr=1;lr<E.length;lr++){const mr=E[lr];if(mr.numIndices>0){if($e+=mr.numIndices,$e>F)return null;continue}if($e>=F||!(J[$e]??[]).includes(mr.name))return null;_t.push(mr.name),$e++}return{dim:$e,numDims:F,aliasPath:_t}}function chaseIndexAliases(D,E){const F=walkIndexAliases(D,E);return!F||F.dim!==F.numDims?null:{aliasPath:F.aliasPath}}function deepestArrayEntryType(D){const E=D.indexedArrayDescription;if(!(!E||E.length===0))return E[E.length-1]?.type}function findAttributeKey(D,E){const F=E.toLowerCase();return Object.keys(D.attributes).find(J=>J.toLowerCase()===F)}function getElementAttributeValue(D,E){const F=findAttributeKey(D,E);if(F===void 0)return;const J=D.attributes[F];if(!J)return;const $e=toXml(J.children).trim();return $e.length>0?$e:void 0}const SELECT_FAMILY_COUNT_ATTRIBUTE={select:"numToSelect",selectFromSequence:"numToSelect",selectRandomNumbers:"numToSelect",selectPrimeNumbers:"numToSelect",samplePrimeNumbers:"numSamples",sampleRandomNumbers:"numSamples"},SELECT_FAMILY_COUNT_ATTRIBUTE_BY_LOWER=Object.fromEntries(Object.entries(SELECT_FAMILY_COUNT_ATTRIBUTE).map(([D,E])=>[D.toLowerCase(),E]));function hasImplicitSingleIndex(D){const E=SELECT_FAMILY_COUNT_ATTRIBUTE_BY_LOWER[D.name.toLowerCase()];return E===void 0?!1:findAttributeKey(D,E)===void 0?!0:getElementAttributeValue(D,E)==="1"}const RESERVED_MODULE_ATTRIBUTE_NAMES=new Set(["name","hide","disabled","fixed","fixlocation","isresponse","extend","copy","rendered","createcomponentoftype","numcomponents","aslist"]);function readPrimitiveNameAttribute(D){const E=findAttributeKey(D,"name");if(E===void 0)return;const F=D.attributes[E]?.children;if(!F||F.length!==1)return;const J=F[0];if(J.type!=="text")return;const $e=J.value.trim();return $e.length>0?$e:void 0}function readDeclaredDefaultValueText(D){if(D.children.length===0)return;const F=toXml(D.children).trim();return F.length>0?F:void 0}function getModuleDeclaredAttributes(D){if(D.name.toLowerCase()!=="module")return new Map;const E=D.children.find(J=>J.type==="element"&&J.name.toLowerCase()==="moduleattributes");if(!E)return new Map;const F=new Map;for(const J of E.children){if(J.type!=="element")continue;const $e=readPrimitiveNameAttribute(J);if($e===void 0)continue;const _t=$e.toLowerCase();if(RESERVED_MODULE_ATTRIBUTE_NAMES.has(_t)||F.has(_t))continue;const lr={componentType:J.name.toLowerCase()},mr=readDeclaredDefaultValueText(J);mr!==void 0&&(lr.defaultValueText=mr),F.set(_t,lr)}return F}function mergeDeclaredIntoSchemaAttributes(D,E){if(E.size===0)return D;const F=new Set(D.map($e=>$e.name.toLowerCase())),J=D.slice();for(const[$e,_t]of E){if(F.has($e))continue;const lr={name:$e,description:describeDeclaredModuleAttribute(_t)};_t.defaultValueText!==void 0&&(lr.defaultValue=_t.defaultValueText),J.push(lr)}return J}function describeDeclaredModuleAttribute(D){return`Author-declared module attribute (\\`<${D.componentType}>\\`)`}function readBareReferencePath(D,E){const F=findAttributeKey(D,E);if(F===void 0)return;const J=D.attributes[F]?.children;if(!J||J.length!==1)return;const $e=J[0];if($e.type!=="macro"||$e.path.length===0)return;const _t=[];for(const lr of $e.path){if(lr.index.length!==0||!lr.name)return;_t.push(lr.name)}return _t}async function resolveCopyExtendReference(D,E){if(D.name.toLowerCase()!=="module")return null;const F=readBareReferencePath(D,"copy")??readBareReferencePath(D,"extend");if(!F)return null;const J=await E.resolveBarePathAtOrigin(D,F);return!J||J===D||J.name.toLowerCase()!=="module"?null:J}async function getEffectiveModuleAttributes(D,E){const F=await resolveCopyExtendReference(D,E);if(!F)return null;const J=getModuleDeclaredAttributes(F);return J.size===0?null:J}function collectModuleInstancesWithCopyOrExtend(D){const E=[],F=J=>{if(J.type==="element"){J.name.toLowerCase()==="module"&&(findAttributeKey(J,"copy")!==void 0||findAttributeKey(J,"extend")!==void 0)&&E.push(J);for(const $e of J.children)F($e)}};for(const J of D.children)F(J);return E}const CURSOR_MARKER="__ANNOTATION_SKELETON_CURSOR__",GRAPHICAL_COMPONENT_TYPES=new Set(["point","line","linesegment","ray","vector","circle","function","polyline","polygon","angle","curve","endpoint","equilibriumpoint","triangle","rectangle"]);function escapeXmlAttributeValue(D){return D.replace(/&/g,"&amp;").replace(/</g,"&lt;").replace(/>/g,"&gt;").replace(/\\"/g,"&quot;")}function capitalize(D){return D.length===0?D:D.charAt(0).toUpperCase()+D.slice(1)}const SIMPLE_IDENTIFIER_REGEX$2=/^[A-Za-z_][A-Za-z0-9_]*$/;function macroBase(D){return SIMPLE_IDENTIFIER_REGEX$2.test(D)?`$${D}`:`$(${D})`}const COMPONENT_LABELS={linesegment:{singular:"line segment",refStem:"LineSegment"},equilibriumpoint:{singular:"equilibrium point",refStem:"EquilibriumPoint"}};function getComponentLabelInfo(D){return COMPONENT_LABELS[D]??{singular:D,refStem:capitalize(D)}}function extractGraphicalChildren(D){const E=[];function F(J){const $e=J.name.toLowerCase();$e!=="annotations"&&(GRAPHICAL_COMPONENT_TYPES.has($e)&&E.push({type:$e,name:getElementAttributeValue(J,"name")}),J.children.forEach(_t=>{_t.type==="element"&&F(_t)}))}return D.children.forEach(J=>{J.type==="element"&&F(J)}),E}function getDescriptionTemplate(D,E,F=!1){const J=capitalize(getComponentLabelInfo(D).singular),$e=F?` (${J} requires a name for the ref to work.)`:"",_t=D.toLowerCase(),lr=macroBase(E);switch(_t){case"point":return`A point with x-coordinate ${lr}.x and y-coordinate ${lr}.y.${$e}`;case"endpoint":return`An endpoint with x-coordinate ${lr}.x and y-coordinate ${lr}.y.${$e}`;case"equilibriumpoint":return`An equilibrium point with x-coordinate ${lr}.x and y-coordinate ${lr}.y.${$e}`;case"circle":return`A circle with radius ${lr}.radius centered at x-coordinate ${lr}.center.x and y-coordinate ${lr}.center.y.${$e}`;case"function":return`A function.${$e}`;case"line":return`A line.${$e}`;case"linesegment":return`A line segment from a point with x-coordinate ${lr}.endpoints[1].x and y-coordinate ${lr}.endpoints[1].y to a point with x-coordinate ${lr}.endpoints[2].x and y-coordinate ${lr}.endpoints[2].y.${$e}`;case"ray":return`A ray starting at a point with x-coordinate ${lr}.endpoint.x and y-coordinate ${lr}.endpoint.y, passing through a point with x-coordinate ${lr}.through.x and y-coordinate ${lr}.through.y.${$e}`;case"vector":return`A vector with tail at x-coordinate ${lr}.tail.x and y-coordinate ${lr}.tail.y, and head at x-coordinate ${lr}.head.x and y-coordinate ${lr}.head.y.${$e}`;case"polyline":return`A polyline with ${lr}.numVertices vertices.${$e}`;case"polygon":return`A polygon with ${lr}.numVertices vertices.${$e}`;case"triangle":return`A triangle.${$e}`;case"rectangle":return`A rectangle of width ${lr}.width and height ${lr}.height.${$e}`;case"angle":return`An angle.${$e}`;case"curve":return`A curve.${$e}`;default:return`${J}.${$e||" (Add a name for this component to enable annotation refs.)"}`}}const NUMBER_WORDS=["","a","two","three","four","five","six","seven","eight","nine","ten"];function getGraphLevelTypeDescriptor(D,E){switch(D){case"line":return E===1?"a line":`${countAsWord(E)} lines`;case"linesegment":return E===1?"a line segment":`${countAsWord(E)} line segments`;case"endpoint":return E===1?"an endpoint":`${countAsWord(E)} endpoints`;case"equilibriumpoint":return E===1?"an equilibrium point":`${countAsWord(E)} equilibrium points`;case"angle":return E===1?"an angle":`${countAsWord(E)} angles`;default:{const F=E===1?D:`${D}s`;return E===1?`a ${F}`:`${countAsWord(E)} ${F}`}}}function countAsWord(D){return D<NUMBER_WORDS.length?NUMBER_WORDS[D]:String(D)}function buildGraphLevelAnnotationText(D){const E=new Map,F=[];for(const $e of D)E.has($e.type)||(F.push($e.type),E.set($e.type,0)),E.set($e.type,(E.get($e.type)??0)+1);const J=F.map($e=>{const _t=E.get($e)??1;return getGraphLevelTypeDescriptor($e,_t)});if(J.length===0)return"A graph.";if(J.length===1)return`A graph of ${J[0]}.`;if(J.length===2)return`A graph of ${J[0]} and ${J[1]}.`;{const $e=J[J.length-1];return`A graph of ${J.slice(0,-1).join(", ")}, and ${$e}.`}}function buildAnnotationTree(D){const E=new Map,F=D.map($e=>{let _t,lr;if($e.name)lr=!1,_t=$e.name;else{lr=!0;const mr=(E.get($e.type)??0)+1;E.set($e.type,mr),_t=`unnamed${getComponentLabelInfo($e.type).refStem}${mr}`}return{type:"annotation",ref:macroBase(_t),text:getDescriptionTemplate($e.type,_t,lr)}});return{type:"annotations",children:[{type:"annotation",text:`${buildGraphLevelAnnotationText(D)}${CURSOR_MARKER}`,children:F}]}}function renderAnnotationNodeToSnippetXml(D,E=0){const F="  ".repeat(E);if(D.type==="annotations"){const mr=(D.children??[]).map(Or=>renderAnnotationNodeToSnippetXml(Or,E+1));return[`${F}<annotations>`,...mr,`${F}</annotations>`].join(`\n`)}const J=[];D.ref&&J.push(`ref="${escapeXmlAttributeValue(D.ref)}"`),D.text&&J.push(`text="${escapeXmlAttributeValue(D.text)}"`);const $e=J.length?` ${J.join(" ")}`:"",_t=D.children??[];if(_t.length===0)return`${F}<annotation${$e} />`;const lr=_t.map(mr=>renderAnnotationNodeToSnippetXml(mr,E+1));return[`${F}<annotation${$e}>`,...lr,`${F}</annotation>`].join(`\n`)}function generateAnnotationSkeletonSnippet(D){const E=extractGraphicalChildren(D);if(E.length===0)return null;const F=buildAnnotationTree(E),J=renderAnnotationNodeToSnippetXml(F),$e=J.indexOf(CURSOR_MARKER);return{key:"annotations-skeleton",element:"annotations",snippet:J.replace(CURSOR_MARKER,""),description:"Auto-generated annotation structure for graph components",cursor:$e>=0?{caretOffset:$e}:void 0}}const CONTAINER_SUGGESTION_OVERRIDES_RAW={module:["moduleAttributes","section","graph","p","function"],moduleAttributes:["number","math","text","boolean","point","function"],setup:["select","selectFromSequence","selectPrimeNumbers","selectRandomNumbers","repeat","repeatForSequence","number","math","text","boolean","point","function"],document:["title","setup"],_sectioningComponent:["title","setup"],answer:["label","award","choice","shortDescription","description","considerAsResponses"],award:["when","math","number","text","boolean","point"],boolean:["math","number","text","boolean","point","function"],when:["math","number","text","boolean","point","function"],_input:["label","shortDescription","description"],choiceInput:["choice","label","shortDescription","description"],graph:["shortDescription","point","function","xLabel","yLabel","_graphical","description"],conditionalContent:["case","else"],math:["math","number","m","round","mean","mod","ceil","floor","abs","median","standardDeviation","variance"],sort:["math","number","text","point","vector","mathList","numberList","textList","pointList","vectorList"],shuffle:["math","number","text","point","vector","mathList","numberList","textList","pointList","vectorList"],sideBySide:["stack"]},FAVORITE_COMPONENTS=["p","math","graph","answer","example","image","section","m","point","mathInput","hint","ol","sequence","me","line","choice","problem","video","repeat","number","vector","choiceInput","ul","repeatForSequence","function","circle","feedback","label"],FAVORITE_INDEX=new Map(FAVORITE_COMPONENTS.map((D,E)=>[D.toLowerCase(),E])),CONTAINER_SUGGESTION_OVERRIDES=new Map(Object.entries(CONTAINER_SUGGESTION_OVERRIDES_RAW).map(([D,E])=>[D.toLowerCase(),E])),ADAPTER_CHILD_RANK=2,NO_HANDPICK=999;function lookupOverrides(D,E){const F=CONTAINER_SUGGESTION_OVERRIDES.get(E.toLowerCase());if(F)return F;const J=D.findSchemaElement(E)?.abstractAncestors??[];for(const $e of J){const _t=CONTAINER_SUGGESTION_OVERRIDES.get($e.toLowerCase());if(_t)return _t}return[]}function indexOverrides(D){const E=new Map,F=new Map,J=new Map;return D.forEach(($e,_t)=>{if(typeof $e=="string"){const lr=$e.toLowerCase();$e.startsWith("_")?F.set(lr,_t):E.set(lr,_t)}else J.set($e.snippet.toLowerCase(),_t)}),{elementIndex:E,abstractIndex:F,snippetIndex:J}}function elementHandpickIndex(D,E,F,J){let $e=E.get(D.toLowerCase())??NO_HANDPICK;if(F.size>0){const _t=J.findSchemaElement(D)?.abstractAncestors??[];for(const lr of _t){const mr=F.get(lr.toLowerCase());mr!==void 0&&mr<$e&&($e=mr)}}return $e}function buildSortText(D){const E=D.handpickedIndex<NO_HANDPICK?"0":"1",F=String(D.handpickedIndex).padStart(3,"0"),J=D.favoriteIndex<NO_HANDPICK?"0":"1",$e=String(D.favoriteIndex).padStart(3,"0"),_t=String(D.intraIndex).padStart(3,"0");return[E,F,J,$e,String(D.bucket),D.clusterElementName.toLowerCase(),String(D.kindPriority),_t,D.label.toLowerCase()].join("-")}function rankedChildSuggestions(D,E,F){const J=D._getAllowedChildren(E,F),$e=D._getChildRanks(E,F),_t=lookupOverrides(D,E),{elementIndex:lr,abstractIndex:mr,snippetIndex:Or}=indexOverrides(_t),Pr=new Map;for(const[Zi,Xi]of Object.entries($e))Pr.set(Zi.toLowerCase(),Xi);const dn=Zi=>Pr.get(Zi.toLowerCase())??0,gi=new Set(J),qi=D._getSnippetsForElements(gi),zi=[],Hi=Zi=>FAVORITE_INDEX.get(Zi.toLowerCase())??NO_HANDPICK,Qi=new Map,Gi=Zi=>{const Xi=Zi.toLowerCase(),Ki=Qi.get(Xi);if(Ki!==void 0)return Ki;const ea=elementHandpickIndex(Zi,lr,mr,D);return Qi.set(Xi,ea),ea};for(const Zi of J){const Xi=dn(Zi),Ki=Gi(Zi),ea=Ki<NO_HANDPICK;if(Xi>=ADAPTER_CHILD_RANK&&!ea)continue;const Ji=buildSortText({handpickedIndex:Ki,favoriteIndex:Hi(Zi),bucket:Xi,clusterElementName:Zi,kindPriority:0,intraIndex:NO_HANDPICK,label:Zi});zi.push({kind:"element",name:Zi,bucket:Xi,sortText:Ji})}for(const Zi of qi){const Xi=Zi.element,Ki=dn(Xi),ea=Or.get(Zi.key.toLowerCase())??NO_HANDPICK,Ji=Gi(Xi),ta=ea<NO_HANDPICK;if(Ki>=ADAPTER_CHILD_RANK&&Ji>=NO_HANDPICK&&!ta)continue;const na=buildSortText({handpickedIndex:Ji,favoriteIndex:Hi(Xi),bucket:Ki,clusterElementName:Xi,kindPriority:1,intraIndex:ea,label:Zi.key});zi.push({kind:"snippet",snippetKey:Zi.key,element:Xi,description:Zi.description,bucket:Ki,sortText:na})}return zi.sort((Zi,Xi)=>Zi.sortText<Xi.sortText?-1:Zi.sortText>Xi.sortText?1:0),zi}function sortTextLookup(D){const E=new Map;for(const F of D){const J=F.kind==="element"?`elem:${F.name.toLowerCase()}`:`snippet:${F.snippetKey.toLowerCase()}`;E.set(J,F.sortText)}return E}const SIMPLE_IDENTIFIER_REGEX$1=/^[A-Za-z_][A-Za-z0-9_]*$/;function asMarkdown(D){return{kind:browserExports.MarkupKind.Markdown,value:D}}const BRACKET_INDEX_ALL_REGEX$1=/\\[[^\\]]*\\]/g;function countBracketIndices$1(D){return D?D.match(BRACKET_INDEX_ALL_REGEX$1)?.length??0:0}function createTextEditRange(D,E,F){const J=D.offsetToRowCol(E),$e=D.offsetToRowCol(F);return{start:{line:J.line-1,character:J.column-1},end:{line:$e.line-1,character:$e.column-1}}}function getPrefixAwareSortText(D,E,F){return E?`${D.toLowerCase().startsWith(E)?"0":"1"}:${F??D.toLowerCase()}`:F}function createCloseTagCompletionItem(D,E){const F={label:`/${D}>`,kind:browserExports.CompletionItemKind.Property};return E&&(F.textEdit={range:createTextEditRange(E.sourceObj,E.startOffset,E.endOffset),newText:`</${D}>`},F.filterText=`</${D}>`),F}function formatSnippetWithIndent(D,E,F){if(!F.includes(`\n`))return{formattedSnippet:F,indentSize:0};const J=D.offsetToRowCol(E),$e=Math.max(0,J.column-1);if($e===0)return{formattedSnippet:F,indentSize:0};const _t=" ".repeat($e),lr=F.split(`\n`);for(let mr=1;mr<lr.length;mr+=1)lr[mr]=_t+lr[mr];return{formattedSnippet:lr.join(`\n`),indentSize:$e}}function adjustOffsetForIndent(D,E,F){if(F<=0||!D.includes(`\n`))return E;let J=E;for(let $e=0;$e<D.length;$e+=1)if(D[$e]===`\n`){const _t=$e+1;E>=_t&&(J+=F)}return J}function adjustCursorForIndent(D,E,F){return"caretOffset"in E?{caretOffset:adjustOffsetForIndent(D,E.caretOffset,F)}:{selectionStartOffset:adjustOffsetForIndent(D,E.selectionStartOffset,F),selectionEndOffset:adjustOffsetForIndent(D,E.selectionEndOffset,F)}}function createSnippetCompletionItems(D,E,F,J,$e=""){return E.map(_t=>{const{formattedSnippet:lr,indentSize:mr}=formatSnippetWithIndent(D,F,_t.snippet),Or=_t.cursor?adjustCursorForIndent(_t.snippet,_t.cursor,mr):void 0,Pr=Or?{snippetCursor:Or}:void 0;return{label:_t.key,kind:browserExports.CompletionItemKind.Snippet,documentation:_t.description,textEdit:{range:createTextEditRange(D,F,J),newText:lr},filterText:$e+_t.key,...Pr?{data:Pr}:{}}})}function isPrefigureGraphElement(D,E){return D.normalizeElementName(E.name)==="graph"&&getElementAttributeValue(E,"renderer")?.toLowerCase()==="prefigure"}function isPrefigureGraph(D,E){return E!==null&&isPrefigureGraphElement(D,E)}function createDynamicSnippetCompletionItems(D,E,F,J,$e,_t="",lr=""){if(!E.includes("annotations"))return[];if(!isPrefigureGraph(D,F))return[];const mr=generateAnnotationSkeletonSnippet(F);return mr?_t&&!mr.key.toLowerCase().includes(_t.toLowerCase())?[]:createSnippetCompletionItems(D.sourceObj,[mr],J,$e,lr):[]}function createElementAndSnippetCompletionItems(D,E,F,J,$e="",_t=null,lr=!1){const mr=$e.toLowerCase(),Or=_t?.name,Pr=_t?D.sourceObj.getParentElementName(_t):void 0,dn=rankedChildSuggestions(D,Or??"document",Pr),gi=sortTextLookup(dn),qi=E.filter(Zi=>mr?Zi.toLowerCase().includes(mr):!0).map(Zi=>{const Xi={label:Zi,kind:browserExports.CompletionItemKind.Property};lr&&(Xi.textEdit={range:createTextEditRange(D.sourceObj,F,J),newText:`<${Zi}`},Xi.displayLabel=`<${Zi}>`);const Ki=D.schemaElementsByName[Zi],ea=D.resolveEffectiveSchemaElement(Ki,Or);ea?.summary&&(Xi.documentation=asMarkdown(ea.summary));const Ji=getPrefixAwareSortText(Zi,mr,gi.get(`elem:${Zi.toLowerCase()}`));return Ji&&(Xi.sortText=Ji),Xi}),zi=D._getSnippetsForElements(new Set(E),$e),Hi=lr?"":"<",Qi=createSnippetCompletionItems(D.sourceObj,zi,F,J,Hi);for(const Zi of Qi){const Xi=Zi.label,Ki=gi.get(`snippet:${Xi.toLowerCase()}`),ea=getPrefixAwareSortText(Xi,mr,Ki);ea&&(Zi.sortText=ea)}const Gi=createDynamicSnippetCompletionItems(D,E,_t,F,J,$e,Hi);return[...qi,...Qi,...Gi]}function createReferenceCompletionItems(D,E,F,J,$e,_t=mr=>mr,lr){return E.map(mr=>{const Or=lr?.get(mr),Pr={label:mr,kind:browserExports.CompletionItemKind.Reference,detail:Or?.detail??$e,textEdit:{range:createTextEditRange(D.sourceObj,F,J),newText:_t(mr)}};return Or?.documentation&&(Pr.documentation=asMarkdown(Or.documentation)),Pr})}function toRefSegmentInsertText(D){return SIMPLE_IDENTIFIER_REGEX$1.test(D)?D:`(${D})`}function determineVisibleNames(D,E,F,J,$e){const _t=D&&!E&&!F?new Set:new Set(J),lr=D&&E?[]:$e?.properties?.map(mr=>mr.name)||[];return{descendantNames:_t,propertyNames:lr}}function createPropertyCompletionItems(D,E,F,J,$e,_t=mr=>mr,lr){return E.map(mr=>{const Or={label:mr,kind:browserExports.CompletionItemKind.Property,detail:`Property on ${$e}`,textEdit:{range:createTextEditRange(D.sourceObj,F,J),newText:_t(mr)}},Pr=lr?.get(mr);return Pr&&(Or.documentation=asMarkdown(Pr)),Or})}function indexAliasCompletionItems(D,E,F,J,$e,_t){if(!E||F.length===0)return null;const lr=D.normalizeElementName(E.name),mr=D.schemaElementsByName[lr];if(!mr)return null;const Or=D.resolveEffectiveSchemaElement(mr,D.sourceObj.getParentElementName(E)),Pr=F[0],dn=Or?.properties?.find(Xi=>Xi.name.toLowerCase()===Pr.toLowerCase());if(!dn)return null;const gi=J.pathParts.length-1-F.length;if(gi<0)return null;const qi=[{name:Pr,numIndices:countBracketIndices$1(J.rawPathParts[gi])}];for(let Xi=1;Xi<F.length;Xi++)qi.push({name:F[Xi],numIndices:countBracketIndices$1(J.rawPathParts[gi+Xi])});const zi=walkIndexAliases(dn,qi);if(!zi)return[];if(zi.dim>=zi.numDims)return[];const Hi=dn.indexAliases?.[zi.dim]??[];if(Hi.length===0)return[];const Qi=J.typedPrefix.toLowerCase(),Gi=Hi.filter(Xi=>Qi?Xi.toLowerCase().startsWith(Qi):!0);if(Gi.length===0)return[];const Zi=`Alias for ${dn.name} (dim ${zi.dim+1} of ${zi.numDims})`;return Gi.map(Xi=>({label:Xi,kind:browserExports.CompletionItemKind.Reference,detail:Zi,textEdit:{range:createTextEditRange(D.sourceObj,J.replaceFromOffset,$e),newText:_t(Xi)}}))}async function getCompletionItems(D,E,F=!1){typeof D!="number"&&(D=this.sourceObj.rowColToOffset(D));const J=this.sourceObj.source.charAt(D-1),$e=this.sourceObj.source.charAt(D-2),_t=J==="<",lr=_t||F,mr=_t?D-1:D,Or=!_t,Pr={sourceObj:this.sourceObj,startOffset:mr,endOffset:D};let dn=D-1;for(;this.sourceObj.source.charAt(dn).match(/(\\s|\\n)/);)dn--;const gi=this.sourceObj.source.charAt(dn);let qi=this.sourceObj.nodeAtOffset(D),zi=this.sourceObj.elementAtOffsetWithContext(D);const Hi=zi.node;let Qi=zi.cursorPosition;const Gi=E??this.getCompletionContext(D),Zi=Qi==="body"||Qi==="attributeValue"||!Hi&&qi&&qi.type==="text";if(Zi&&Gi.cursorPos==="refName"){const sa=Gi.typedPrefix.toLowerCase(),aa=this.sourceObj.source,pa=aa.charAt(Gi.replaceFromOffset-1)==="("&&aa.charAt(Gi.replaceFromOffset-2)==="$",ma=ka=>pa?ka:toRefSegmentInsertText(ka),la=this.sourceObj.getAddressableNamesAtOffset(D).filter(ka=>ka.length===1).map(ka=>ka[0]),ha=this.getAdditionalRefNames(D),ga=[...new Set([...la,...ha])],Aa=await Promise.all(ga.map(ka=>this.isNameAddressable(D,ka))),Fa=ga.filter((ka,ba)=>(!sa||ka.toLowerCase().startsWith(sa))&&Aa[ba]),$a=new Map;for(const ka of Fa){const ba=this.resolveRefNameForHelp(D,ka);if(!ba)continue;const{referent:Pa,line:Ia,ownEntry:Da,effectiveEntry:va}=ba,ya={detail:Ia!==void 0?`(<${Pa.name}>, line ${Ia})`:`(<${Pa.name}>)`};va?.summary&&(ya.documentation=va.summary),$a.set(ka,{takesIndex:Da?.takesIndex??!1,labelInfo:ya})}const _a=createReferenceCompletionItems(this,Fa,Gi.replaceFromOffset,D,"Reference name",ma,new Map(Array.from($a,([ka,ba])=>[ka,ba.labelInfo]))),fa=createTextEditRange(this.sourceObj,Gi.replaceFromOffset,D);for(const ka of Fa){const ba=$a.get(ka);if(!ba?.takesIndex)continue;const Pa=pa?`${ka}[]`:`${toRefSegmentInsertText(ka)}[]`,Ia={label:`${ka}[]`,kind:browserExports.CompletionItemKind.Reference,detail:ba.labelInfo.detail,textEdit:{range:fa,newText:Pa},data:{snippetCursor:{caretOffset:Pa.length-1}}};ba.labelInfo.documentation&&(Ia.documentation=asMarkdown(ba.labelInfo.documentation)),_a.push(Ia)}return _a}if(Zi&&Gi.cursorPos==="refMember"){const sa=this.sourceObj.source,aa=sa.charAt(Gi.replaceFromOffset-1)==="("&&sa.charAt(Gi.replaceFromOffset-2)===".",pa=va=>aa?va:toRefSegmentInsertText(va),ma=await this.resolveRefMemberContainerAtOffset(D,Gi.pathParts,Gi.pathPartHasIndex),la=ma.node;if(!la){const va=indexAliasCompletionItems(this,ma.partiallyResolvedNode??null,ma.unresolvedPathParts,Gi,D,pa);return va||[]}const ha=this.normalizeElementName(la.name),ga=this.schemaElementsByName[ha],Aa=this.resolveEffectiveSchemaElement(ga,this.sourceObj.getParentElementName(la)),Fa=ga?.takesIndex??!1,$a=Gi.pathPartHasIndex?.[Gi.pathParts.length-2]??!1,_a=hasImplicitSingleIndex(la);if(!Fa&&$a)return[];const{descendantNames:fa,propertyNames:ka}=determineVisibleNames(Fa,$a,_a,ma.visibleDescendantNames,ga),ba=Gi.typedPrefix.toLowerCase(),Pa=[...fa].filter(va=>ba?va.toLowerCase().startsWith(ba):!0),Ia=ka.filter(va=>(!ba||va.toLowerCase().startsWith(ba))&&!fa.has(va)),Da=new Map;for(const va of Aa?.properties??[])va.description&&Da.set(va.name,va.description);return[...createReferenceCompletionItems(this,Pa,Gi.replaceFromOffset,D,"Descendant reference name",pa),...createPropertyCompletionItems(this,Ia,Gi.replaceFromOffset,D,la.name,pa,Da)]}if(!qi&&Qi==="unknown"&&lr)return createElementAndSnippetCompletionItems(this,this.schemaTopAllowedElements,mr,D,"",null,Or);const Xi=this.sourceObj.nodeAtOffset(D,{type:"element",side:"right"});if(lr&&Qi!=="openTagName"&&Xi&&Xi.position?.start?.offset===D){let sa=this.sourceObj.getParent(Xi);for(;sa?.type==="element"&&sa.name==="";)sa=this.sourceObj.getParent(sa);const aa=sa?.type==="element"?sa:null,pa=aa?this._getAllowedChildren(aa.name,this.sourceObj.getParentElementName(aa)):this.schemaTopAllowedElements,ma=createElementAndSnippetCompletionItems(this,pa,mr,D,"",aa,Or);return aa&&!this.sourceObj.isCompleteElement(aa).closed?[createCloseTagCompletionItem(aa.name,Pr),...ma]:ma}if(!Hi&&qi&&qi.type==="text")return lr?createElementAndSnippetCompletionItems(this,this.schemaTopAllowedElements,mr,D,"",null,Or):[];if(!Hi)return[];if(Qi==="closeTagName"){const sa=this.sourceObj.source;let aa=D-1;for(;aa>=0&&sa.charAt(aa)!=="<";)aa--;const pa=aa>=0?{sourceObj:this.sourceObj,startOffset:aa,endOffset:D}:void 0;return[createCloseTagCompletionItem(Hi.name,pa)]}const{tagComplete:Ki,closed:ea}=this.sourceObj.isCompleteElement(Hi);if(Qi==="body"&&zi.node&&lr){const sa=this._getAllowedChildren(zi.node.name,this.sourceObj.getParentElementName(zi.node)),aa=createElementAndSnippetCompletionItems(this,sa,mr,D,"",zi.node,Or);return ea?aa:[createCloseTagCompletionItem(Hi.name,Pr),...aa]}if($e==="<"&&J==="/"&&zi.node&&!ea&&(Qi==="body"||Qi==="unknown"&&this.sourceObj.source.charAt(D).match(/(\\s|\\n)/)))return[createCloseTagCompletionItem(Hi.name,{sourceObj:this.sourceObj,startOffset:D-2,endOffset:D})];if(Qi==="openTagName"){const sa=Hi.name.toLowerCase(),aa=this.sourceObj.getParent(Hi);let pa;!aa||aa.type==="root"?pa=this.schemaTopAllowedElements:pa=this._getAllowedChildren(aa.name,this.sourceObj.getParentElementName(aa));const ma=Hi.position?.start.offset??Math.max(0,D-sa.length-1);return createElementAndSnippetCompletionItems(this,pa,ma,D,sa,aa?.type==="element"?aa:null)}const Ji=this.sourceObj.source,{valueStartOffset:ta,equalsOffset:na}=scanBareValueRun(Ji,D),ra=na!=null&&ta<D,ia=na??-1,oa=Ji.slice(ta,D);if((Qi==="openTag"||Qi==="attributeName")&&!ra&&gi!=="="){await this._refreshModuleInstanceAttributes();const sa=this.normalizeElementName(Hi.name),aa=this.schemaElementsByName[sa],ma=this.resolveEffectiveSchemaElement(aa,this.sourceObj.getParentElementName(Hi))?.attributes??[],la=sa==="module"?this._moduleInstanceAttributeAllowlist.get(Hi):void 0;return(la?mergeDeclaredIntoSchemaAttributes(ma,la):ma).map(ga=>{const Aa={label:ga.name,kind:browserExports.CompletionItemKind.Enum};return ga.description&&(Aa.documentation=asMarkdown(ga.description)),Aa})}if(Qi==="attributeValue"||(Qi==="openTag"||Qi==="attributeName"||Qi==="attributeValue"||Qi==="unknown")&&(gi==="="||ra)){const sa=this.normalizeElementName(Hi.name),pa=(this._resolveEffectiveByName(sa,this.sourceObj.getParentElementName(Hi))??this.schemaElementsByName[sa])?.attributes||[],ma=this._getAttributeContainsOffset(Hi,D);let la=pa.find(fa=>fa.name===ma?.name);if(!la&&ra){let fa=ia;for(;fa>0&&/\\s/.test(Ji.charAt(fa-1));)fa--;let ka=fa;for(;ka>0&&ATTR_VALUE_CHAR.test(Ji.charAt(ka-1));)ka--;const ba=Ji.slice(ka,fa);ba&&(la=pa.find(Pa=>Pa.name===ba))}const ha=la?.autocompleteValues,ga=la?.values;if(!ha&&!ga){if(Qi!=="attributeValue"&&ra&&oa.length>0){const fa=createTextEditRange(this.sourceObj,ia+1,D);return[{label:oa,displayLabel:`"${oa}"`,kind:browserExports.CompletionItemKind.Value,filterText:oa,textEdit:{range:fa,newText:`"${oa}"`},data:{livePreviewQuoteWrap:{bareValueStartOffset:ta}}}]}return[]}const Aa=Qi!=="attributeValue"&&(gi==="="||ra),Fa=Aa?createTextEditRange(this.sourceObj,ia+1,D):void 0,$a=oa.toLowerCase(),_a=fa=>!Aa||!$a||fa.toLowerCase().startsWith($a);return ha?ha.filter(({value:fa})=>_a(fa)).map(({value:fa,description:ka})=>({label:fa,kind:browserExports.CompletionItemKind.Value,filterText:fa,documentation:asMarkdown(ka),...Fa?{displayLabel:`"${fa}"`,textEdit:{range:Fa,newText:`"${fa}"`}}:{}})):(ga??[]).filter(fa=>_a(fa)).map(fa=>({label:fa,kind:browserExports.CompletionItemKind.Value,filterText:fa,...Fa?{displayLabel:`"${fa}"`,textEdit:{range:Fa,newText:`"${fa}"`}}:{}}))}return[]}async function getSchemaViolations(){await this._refreshModuleInstanceAttributes();function D(J,$e=null){return J.children.flatMap(_t=>_t.type==="element"?[{node:_t,parent:J,grandparent:$e},...D(_t,J)]:[])}return D(this.sourceObj.dast).flatMap(({node:J,parent:$e,grandparent:_t})=>{const lr=[],mr=this.normalizeElementName(J.name);if(mr==="UNKNOWN_NAME"){const gi=this.sourceObj.getElementTagRanges(J);return{range:{start:this.sourceObj.offsetToLSPPosition(gi[0].start),end:this.sourceObj.offsetToLSPPosition(gi[0].end)},message:`Element \\`<${J.name}>\\` is not a recognized Doenet element.`,severity:browserExports.DiagnosticSeverity.Warning}}const Or=this.schemaElementsByName[mr];if($e.type==="root"){if(!Or)return[];if(!Or.top){const gi=this.sourceObj.getElementTagRanges(J);lr.push({range:{start:this.sourceObj.offsetToLSPPosition(gi[0].start),end:this.sourceObj.offsetToLSPPosition(gi[0].end)},message:`Element \\`<${mr}>\\` is not allowed at the root of the document.`,severity:browserExports.DiagnosticSeverity.Warning})}}else{const gi=this.normalizeElementName($e.name),qi=_t&&_t.type==="element"?_t.name:void 0;if(gi!=="UNKNOWN_NAME"&&!this.isAllowedChild(gi,mr,qi)){const zi=this.sourceObj.getElementTagRanges(J);lr.push({range:{start:this.sourceObj.offsetToLSPPosition(zi[0].start),end:this.sourceObj.offsetToLSPPosition(zi[0].end)},message:`Element \\`<${mr}>\\` is not allowed inside of \\`<${gi}>\\`.`,severity:browserExports.DiagnosticSeverity.Warning})}}const Pr=$e.type==="element"?$e.name:void 0,dn=this._moduleInstanceAttributeAllowlist.get(J)??null;for(const gi of Object.values(J.attributes)){const qi=this.normalizeAttributeName(gi.name);if(qi==="name"){const zi=toXml(gi.children);zi.charAt(0).match(/[a-zA-Z]/)||lr.push({range:{start:this.sourceObj.offsetToLSPPosition(gi.position?.start.offset||0),end:this.sourceObj.offsetToLSPPosition(gi.position?.end.offset||0)},message:`Invalid attribute name=\'${zi}\'. Names must start with a letter.`,severity:browserExports.DiagnosticSeverity.Error})}if(!(dn&&dn.has(gi.name.toLowerCase())))if(qi==="UNKNOWN_NAME")lr.push({range:{start:this.sourceObj.offsetToLSPPosition(gi.position?.start.offset||0),end:this.sourceObj.offsetToLSPPosition(gi.position?.end.offset||0)},message:`Element \\`<${mr}>\\` doesn\'t have an attribute called \\`${gi.name}\\`.`,severity:browserExports.DiagnosticSeverity.Warning});else if(!this.isAllowedAttribute(mr,qi,Pr,dn??void 0))lr.push({range:{start:this.sourceObj.offsetToLSPPosition(gi.position?.start.offset||0),end:this.sourceObj.offsetToLSPPosition(gi.position?.end.offset||0)},message:`Element \\`<${mr}>\\` doesn\'t have an attribute called \\`${qi}\\`.`,severity:browserExports.DiagnosticSeverity.Warning});else{const zi=this.getAttributeAllowedValues(mr,qi,Pr);if(!hasMacroOrFunctionChild(gi.children)&&zi){const Hi=gi.children.length===0?"true":toXml(gi.children),Qi=getAttributeValueRange(gi);if((zi.isList?Hi.split(/\\s+/).filter(Xi=>Xi.length>0):[Hi]).filter(Xi=>!zi.lowerCase.has(Xi.toLowerCase())).length>0){const Xi=[...zi.correctCase].map(Ki=>`"${Ki}"`).join(", ");lr.push({range:{start:this.sourceObj.offsetToLSPPosition(Qi.start),end:this.sourceObj.offsetToLSPPosition(Qi.end)},message:zi.isList?`Attribute \\`${qi}\\` of element \\`<${mr}>\\` must be a list whose items are each one of: ${Xi}`:`Attribute \\`${qi}\\` of element \\`<${mr}>\\` must be one of: ${Xi}`,severity:browserExports.DiagnosticSeverity.Warning})}}}}return lr})}function hasMacroOrFunctionChild(D){let E=!1;return visit$1(D,F=>{(F.type==="macro"||F.type==="function")&&(E=!0)}),E}function getAttributeValueRange(D){if(D.children.length===0)return{start:D.position?.end.offset||0,end:D.position?.end.offset||0};const E=D.children[0],F=D.children[D.children.length-1],J=E.position?.start.offset||0,$e=F.position?.end.offset||0,_t=D.position?.start.offset,lr=D.position?.end.offset;return{start:_t==null?Math.max(0,J-1):Math.max(_t,J-1),end:lr==null?$e+1:Math.min(lr,$e+1)}}const SIMPLE_IDENTIFIER_CHAR_REGEX=/[A-Za-z0-9_]/,SIMPLE_IDENTIFIER_REGEX=/^[A-Za-z_][A-Za-z0-9_]*$/,MACRO_IDENTIFIER_CHAR_REGEX=/[A-Za-z0-9_-]/,MACRO_PATH_CHAR_REGEX$1=/[A-Za-z0-9_.[\\]-]/,BRACKET_INDEX_SUFFIX_REGEX$1=/(\\[[^\\]]*\\])+$/;function stripIndicesFromPathParts(D){const E=[];return{parts:D.map(J=>{const $e=BRACKET_INDEX_SUFFIX_REGEX$1.test(J);return E.push($e),$e?J.replace(BRACKET_INDEX_SUFFIX_REGEX$1,""):J}),pathPartHasIndex:E}}function makeRefMemberContext(D,E,F){const{parts:J,pathPartHasIndex:$e}=stripIndicesFromPathParts(F);return{cursorPos:"refMember",typedPrefix:D,replaceFromOffset:E,pathParts:J,pathPartHasIndex:$e,rawPathParts:F}}function hasValidRefMemberPathSyntax(D){if(D.length===0)return!1;for(let E=0;E<D.length-1;E++){const F=D[E];if(F.length===0||F.trim()!==F)return!1}return!0}function makeValidatedRefMemberContext(D,E,F){return hasValidRefMemberPathSyntax(F)?makeRefMemberContext(D,E,F):{cursorPos:"body"}}function getIdentifierPrefixInfo(D,E,F=SIMPLE_IDENTIFIER_CHAR_REGEX){let J=E;for(;J>0&&F.test(D.charAt(J-1));)J--;return{tokenStart:J,typedPrefix:D.slice(J,E)}}function normalizeMacroPathForMemberResolution(D){let E=D.replace(/\\)\\.\\(/g,".").replace(/\\)\\./g,".").replace(/\\.\\(/g,".");return E.startsWith("(")&&(E=E.slice(1)),E.endsWith(")")&&(E=E.slice(0,-1)),E}function getCompletionContext(D){typeof D!="number"&&(D=this.sourceObj.rowColToOffset(D));const E=this.sourceObj.source,F=E.charAt(D-1),J=E.charAt(D-2),{tokenStart:$e,typedPrefix:_t}=getIdentifierPrefixInfo(E,D),{tokenStart:lr,typedPrefix:mr}=getIdentifierPrefixInfo(E,D,MACRO_IDENTIFIER_CHAR_REGEX),Or=this.sourceObj.nodeAtOffset(D,{side:"left"});let Pr=this.sourceObj.nodeAtOffset(D,{type:"macro",side:"left"});if(!Pr&&(F==="."||F==="[")&&J!==")"&&(Pr=this.sourceObj.nodeAtOffset(D-1,{type:"macro",side:"left"})),Pr){const dn=Pr.position?.start.offset??D,gi=E.charAt(dn+1)==="(",qi=gi?lr:$e,zi=gi?mr:_t;if(F==="."||E.charAt(qi-1)==="."||E.charAt(qi-1)==="("&&E.charAt(qi-2)==="."){const Qi=normalizeMacroPathForMemberResolution(E.slice(dn+(gi?2:1),D));return makeValidatedRefMemberContext(zi,qi,Qi.split("."))}return gi&&(F==="("&&J==="$"||E.charAt(qi-1)==="("&&E.charAt(qi-2)==="$")||!gi&&(F==="$"||E.charAt(qi-1)==="$")?{cursorPos:"refName",typedPrefix:zi,replaceFromOffset:qi}:{cursorPos:"macro",complete:Or?.type==="macro",node:Pr}}if(F==="("&&J==="$"||E.charAt(lr-1)==="("&&E.charAt(lr-2)==="$")return{cursorPos:"refName",typedPrefix:mr,replaceFromOffset:lr};if(F==="."||E.charAt(lr-1)==="."||E.charAt(lr-1)==="("&&E.charAt(lr-2)==="."){let dn=lr-1;for(;dn>0&&MACRO_PATH_CHAR_REGEX$1.test(E.charAt(dn-1));)dn--;if(E.charAt(dn-1)==="$"||E.charAt(dn-1)==="("&&E.charAt(dn-2)==="$")return makeValidatedRefMemberContext(mr,lr,E.slice(dn,D).split("."));if(E.charAt(dn-1)===")"){const gi=E.lastIndexOf("(",dn-1);if(gi>0&&E.charAt(gi-1)==="$"){const qi=E.slice(gi+1,dn-1),zi=E.slice(dn,D);return makeValidatedRefMemberContext(mr,lr,`${qi}${zi}`.split("."))}}if(E.charAt(dn-1)==="("&&E.charAt(dn-2)==="."){let gi=dn-2;for(;gi>0&&MACRO_PATH_CHAR_REGEX$1.test(E.charAt(gi-1));)gi--;if(E.charAt(gi-1)==="$"){const qi=E.slice(gi,dn-2);return makeValidatedRefMemberContext(mr,lr,`${qi}.${E.slice(dn,D).replace(/^\\(/,"")}`.split("."))}if(E.charAt(gi-1)===")"){const qi=E.lastIndexOf("(",gi-1);if(qi>0&&E.charAt(qi-1)==="$"){const zi=E.slice(qi+1,gi-1);return makeValidatedRefMemberContext(mr,lr,`${zi}.${E.slice(dn,D).replace(/^\\(/,"")}`.split("."))}}}}if((F==="$"||E.charAt($e-1)==="$")&&(F==="$"||SIMPLE_IDENTIFIER_REGEX.test(_t)))return{cursorPos:"refName",typedPrefix:_t,replaceFromOffset:$e};if(F==="."&&E.charAt($e-1)==="."&&$e>1){let dn=$e-2;for(;dn>0&&/[A-Za-z0-9_.[\\]-]/.test(E.charAt(dn-1));)dn--;if(E.charAt(dn-1)==="$"){const gi=dn,qi=E.slice(gi,D).trim(),zi=qi.split(".");if(zi.length>0&&/^[A-Za-z0-9_]/.test(qi))return makeValidatedRefMemberContext(_t,$e,zi)}}return{cursorPos:"body"}}const REPEAT_LIKE_ELEMENT_NAMES=new Set(["repeat","repeatForSequence"]);function isRepeatLikeElementName(D){return REPEAT_LIKE_ELEMENT_NAMES.has(D)}function isRepeatLikeElement(D){return isRepeatLikeElementName(D.name)}const COMPOSITE_WRAPPER_NAMES=new Set(["case","else","option"]);function getElementNameAttributeValue(D){const E=D.attributes?.name;return E&&E.children?.length===1&&E.children[0].type==="text"?E.children[0].value:null}function classifyResolutionError(D){const F=([typeof D=="string"?D:void 0,D?.message,D?.value,D?.name].filter(J=>typeof J=="string").join(" ")||String(D??"")).toString();return F.includes("NonUniqueReferent")?"multiple":F.includes("NoReferent")?"notFound":"indeterminate"}function collectAllNamedDescendants(D){const E=[];function F(J){if(J.type==="element"){const $e=getElementNameAttributeValue(J);$e&&E.push({name:$e,element:J});for(const _t of J.children)F(_t)}}for(const J of D.children)F(J);return E}function addUniqueNamesFromDescendants(D,E){const F=new Map;for(const{name:J}of D)F.set(J,(F.get(J)??0)+1);for(const[J,$e]of F)$e===1&&E.add(J)}function collectNamesFromCompositeChildren(D){const E=new Set,F=new Map;for(const J of D.children){if(J.type!=="element"||COMPOSITE_WRAPPER_NAMES.has(J.name))continue;const $e=getElementNameAttributeValue(J);$e&&F.set($e,(F.get($e)??0)+1)}for(const J of D.children)if(J.type==="element")if(COMPOSITE_WRAPPER_NAMES.has(J.name))addUniqueNamesFromDescendants(collectAllNamedDescendants(J),E);else{const $e=getElementNameAttributeValue(J);$e&&F.get($e)===1&&E.add($e),addUniqueNamesFromDescendants(collectAllNamedDescendants(J),E)}return E}function getDerivedRepeatNamesFromElement(D){if(!isRepeatLikeElement(D))return[];const E=[];for(const F of["valueName","indexName"]){const J=D.attributes[F];J&&J.children.length===1&&J.children[0].type==="text"&&E.push(J.children[0].value)}return E}class RustResolverAdapter{constructor(E,F){this._core=null,this._enabled=!1,this._takesIndexComponentTypes=null,this._rustIndexToDastElement=new Map,this._dastElementToRustIndex=new Map,this._sourceRevision=0,this._visibleDescendantNamesCache=new Map,this._pendingSync=Promise.resolve(),this._coreSource=null,this._sourceObj=E,this._takesIndexComponentTypes=F?.takesIndexComponentTypes?new Set(F.takesIndexComponentTypes):null,F?.core&&(this._core=F.core)}init(){return this._pendingSync=this._pendingSync.then(()=>this._syncSource()),this._pendingSync}_componentTakesIndex(E){return this._takesIndexComponentTypes?.has(E)??!1}async _syncSource(){if(this._sourceObj.source===this._coreSource)return;if(this._coreSource=this._sourceObj.source,this._sourceRevision+=1,this._visibleDescendantNamesCache.clear(),!this._core){this._disableAdapterState();return}if(!this._sourceObj.source.trim()){this._disableAdapterState();return}if(!this._sourceObj.dast.children.some(F=>F.type==="element")){this._disableAdapterState();return}try{await this._core.setSource({source:this._sourceObj.source,dast:this._sourceObj.dast}),await this._core.setFlags({flags:{}});const F=await this._core.returnDast(),J=this._core.returnNormalizedDastRoot?(await this._core.returnNormalizedDastRoot()).nodes:null;this._buildMappings(F,J),this._enabled=!0}catch(F){console.warn("RustResolverAdapter: failed to sync source:",F),this._disableAdapterState()}}_getCachedVisibleDescendantNames(E){const F=`${this._sourceRevision}:${E}`;return this._visibleDescendantNamesCache.get(F)}_setCachedVisibleDescendantNames(E,F){const J=`${this._sourceRevision}:${E}`;this._visibleDescendantNamesCache.set(J,F)}_disableAdapterState(){this._enabled=!1,this._rustIndexToDastElement.clear(),this._dastElementToRustIndex.clear()}_buildMappings(E,F){this._rustIndexToDastElement.clear(),this._dastElementToRustIndex.clear();const J=new Map,$e=_t=>{if(_t.type==="element"){const lr=_t.position?.start?.offset;lr!=null&&J.set(lr,_t);for(const mr of _t.children)$e(mr)}};for(const _t of this._sourceObj.dast.children)$e(_t);if(F){for(const _t of F){if(_t.name==null)continue;const lr=_t.position?.start?.offset;if(lr==null)continue;const mr=J.get(lr);mr&&(this._rustIndexToDastElement.set(_t.idx,mr),this._dastElementToRustIndex.set(mr,_t.idx))}return}for(const _t of E.elements){const lr=_t.position?.start?.offset;if(lr==null)continue;const mr=_t.data?.id;if(mr==null)continue;const Or=J.get(lr);Or&&(this._rustIndexToDastElement.set(mr,Or),this._dastElementToRustIndex.set(Or,mr))}}async resolveRefMemberContainerAtOffset(E,F,J){return this._resolveRefMemberContainer({offset:E,pathParts:F,pathPartHasIndex:J,nodeIndex:this._sourceObj.getNodeIndexAtOffset(E)})}createResolver(){return E=>this._resolveRefMemberContainer(E)}async resolveBarePathAtOrigin(E,F){if(await this._pendingSync,!this._enabled||!this._core||F.length===0||F.some(_t=>!_t))return null;const J=this._dastElementToRustIndex.get(E)??this._getRootOriginIndex();if(J==null)return null;const $e=F.map(_t=>({type:"flatPathPart",name:_t,index:[]}));try{const _t=await this._core.resolvePath({path:{path:$e},origin:J,skipParentSearch:!1});return _t.unresolvedPath&&_t.unresolvedPath.length>0?null:this._rustIndexToDastElement.get(_t.nodeIdx)??null}catch{return null}}async _resolveRefMemberContainer(E){if(await this._pendingSync,!this._enabled||!this._core)return null;const{offset:F,pathParts:J,pathPartHasIndex:$e}=E,{pathParts:_t,pathPartHasIndex:lr}=this._normalizePathParts(F,J,$e);if(_t.length===0)return null;const mr=_t.slice(0,-1);if(mr.length===0)return null;const Or=this._getOriginIndex(F);if(Or==null)return null;const Pr=lr??mr.map(()=>!1),dn=mr.map(gi=>({type:"flatPathPart",name:gi,index:[]}));try{const gi=await this._core.resolvePath({path:{path:dn},origin:Or,skipParentSearch:!1}),qi=this._rustIndexToDastElement.get(gi.nodeIdx);if(!qi)return null;const zi=(gi.unresolvedPath??[]).map(Ki=>Ki.name);if(zi.length>0)return{node:null,unresolvedPathParts:zi,partiallyResolvedNode:qi,visibleDescendantNames:[]};if(gi.nodesInResolvedPath.length>1){const ea=gi.nodesInResolvedPath.slice(-mr.length).slice(0,-1);for(let Ji=0;Ji<ea.length;Ji++){const ta=this._rustIndexToDastElement.get(ea[Ji]),na=Pr[Ji]??!1,ra=na||ta!=null&&hasImplicitSingleIndex(ta);if(ta&&this._componentTakesIndex(ta.name)&&!ra)return{node:null,unresolvedPathParts:mr.slice(Ji),visibleDescendantNames:[]};if(ta&&!this._componentTakesIndex(ta.name)&&na)return{node:null,unresolvedPathParts:mr.slice(Ji),visibleDescendantNames:[]}}}const Hi=mr.length-1,Qi=Pr[Hi]??!1,Gi=Qi||hasImplicitSingleIndex(qi);if(this._componentTakesIndex(qi.name)&&!Gi)return{node:qi,unresolvedPathParts:[],visibleDescendantNames:[]};if(!this._componentTakesIndex(qi.name)&&Qi)return{node:null,unresolvedPathParts:[],visibleDescendantNames:[]};if(qi.name==="conditionalContent"||Gi&&this._componentTakesIndex(qi.name)){const Ki=collectNamesFromCompositeChildren(qi),ea=getDerivedRepeatNamesFromElement(qi);return{node:qi,unresolvedPathParts:[],visibleDescendantNames:[...Ki,...ea]}}const Zi=gi.nodeIdx;let Xi=this._getCachedVisibleDescendantNames(Zi);if(!Xi){const Ki=this._sourceObj.getUniqueDescendantNamesForNode(qi),ea=await Promise.all(Ki.map(async Ji=>{try{const ta=await this._core.resolvePath({path:{path:[{type:"flatPathPart",name:Ji,index:[]}]},origin:Zi,skipParentSearch:!0});if(ta.unresolvedPath&&ta.unresolvedPath.length>0)return!1;const na=this._rustIndexToDastElement.get(ta.nodeIdx);return(na?getElementNameAttributeValue(na):null)===Ji}catch{return!1}}));Xi=Ki.filter((Ji,ta)=>ea[ta]),this._setCachedVisibleDescendantNames(Zi,Xi)}return{node:qi,unresolvedPathParts:[],visibleDescendantNames:Xi}}catch{return null}}_getOriginIndex(E){const F=this._sourceObj.elementAtOffset(E);if(F){const J=this._dastElementToRustIndex.get(F);if(J!=null)return J}return this._getRootOriginIndex()}_normalizePathParts(E,F,J){if(F.length===0)return{pathParts:F,pathPartHasIndex:J};const _t=(E>0?this._sourceObj.source.charAt(E-1):"")===".",lr=F[F.length-1]==="";return!_t||lr?{pathParts:F,pathPartHasIndex:J}:{pathParts:[...F,""],pathPartHasIndex:J&&[...J,!1]}}_getRootOriginIndex(){const E=[];for(const J of this._sourceObj.dast.children){if(J.type!=="element")continue;const $e=this._dastElementToRustIndex.get(J);$e!=null&&E.push($e)}if(E.length>0)return Math.min(...E);const F=[...this._rustIndexToDastElement.keys()];return F.length>0?Math.min(...F):null}async isNameAddressableFromOffset(E,F){if(await this._pendingSync,!this._enabled||!this._core)return!1;if(this.getDerivedRepeatNames(E).includes(F))return!0;const $e=this._referenceOriginIndex(E);if($e==null)return!1;try{const _t=await this._core.resolvePath({path:{path:[{type:"flatPathPart",name:F,index:[]}]},origin:$e,skipParentSearch:!1}),lr=this._rustIndexToDastElement.get(_t.nodeIdx);return!((lr?getElementNameAttributeValue(lr):null)!==F||this._isHiddenBySugar(_t.nodeIdx,E))}catch{return!1}}_referenceOriginIndex(E){const F=this._sourceObj.elementAtOffset(E);if(!F)return this._getRootOriginIndex();for(const J of F.children)if(J.type==="element"){const $e=this._dastElementToRustIndex.get(J);if($e!=null)return $e}return this._dastElementToRustIndex.get(F)??null}async classifyReferenceFromOffset(E,F){if(await this._pendingSync,!this._enabled||!this._core||F.length===0||F.some(_t=>!_t))return"indeterminate";if(F.length===1&&this.getDerivedRepeatNames(E).includes(F[0]))return"found";const J=this._referenceOriginIndex(E);if(J==null)return"indeterminate";const $e=F.map(_t=>({type:"flatPathPart",name:_t,index:[]}));try{const _t=await this._core.resolvePath({path:{path:$e},origin:J,skipParentSearch:!1});if(_t.unresolvedPath&&_t.unresolvedPath.length>0)return"indeterminate";if(F.length===1){const lr=this._rustIndexToDastElement.get(_t.nodeIdx);if((lr?getElementNameAttributeValue(lr):null)!==F[0]||this._isHiddenBySugar(_t.nodeIdx,E))return"indeterminate"}return"found"}catch(_t){return classifyResolutionError(_t)}}_isHiddenBySugar(E,F){const J=this._rustIndexToDastElement.get(E);if(!J)return!1;let $e=this._sourceObj.getParent(J);for(;$e&&$e.type!=="root";){if($e.type==="element"&&($e.name==="conditionalContent"||$e.name==="select")){const _t=$e.position?.start?.offset,lr=$e.position?.end?.offset;if(_t!=null&&lr!=null&&(F<_t||F>=lr)){const mr=this._sourceObj.getParent(J);if(!(mr&&mr.type==="element"&&mr===$e&&COMPOSITE_WRAPPER_NAMES.has(J.name)))return!0}}$e=this._sourceObj.getParent($e)}return!1}isEnabled(){return this._enabled}getDerivedRepeatNames(E){const F=[];let J=this._sourceObj.elementAtOffset(E)??void 0;for(;J;){F.push(...getDerivedRepeatNamesFromElement(J));const $e=this._sourceObj.getParent(J);J=$e&&$e.type==="element"?$e:void 0}return F}updateSource(E){return this._sourceObj=E,this._pendingSync=this._pendingSync.then(()=>this._syncSource()),this._pendingSync}}function findNamedDescendant(D,E){for(const F of D.children){if(F.type!=="element")continue;if(getElementNameAttributeValue(F)===E)return F;const J=findNamedDescendant(F,E);if(J)return J}return null}function findDescendantViaCompositeWrappers(D,E){const F=[];for(const $e of D.children){if($e.type!=="element"||!COMPOSITE_WRAPPER_NAMES.has($e.name))continue;const _t=findNamedDescendant($e,E);_t&&F.push(_t)}if(F.length===0)return null;const J=F[0].name;for(let $e=1;$e<F.length;$e++)if(F[$e].name!==J)return null;return F[0]}function adjustCursorForTrimStart(D,E){return"caretOffset"in D?{caretOffset:Math.max(0,D.caretOffset-E)}:{selectionStartOffset:Math.max(0,D.selectionStartOffset-E),selectionEndOffset:Math.max(0,D.selectionEndOffset-E)}}const BUNDLED_SCHEMA_ELEMENTS=doenetSchema.elements;class AutoCompleter{constructor(E,F=BUNDLED_SCHEMA_ELEMENTS,J){this.sourceObj=new DoenetSourceObject,this.schema=[],this.schemaLowerToUpper={},this.schemaAttributesLowerToUpper={},this.schemaTopAllowedElements=[],this.schemaElementsByName={},this.schemaAliasedElementsByName={},this.schemaAliasedElementsByLowerName=new Map,this.parentChildMap=new Map,this.nodeAttributeMap=new Map,this.snippetsByNormalizedElement=new Map,this.snippetsByKey=new Map,this._moduleInstanceAttributeAllowlist=new Map,this._moduleInstanceAllowlistSourceRevision=-1,this._moduleInstanceAllowlistRefreshInFlight=null,this.getCompletionItems=($e,_t,lr=!1)=>getCompletionItems.call(this,$e,_t,lr),this.getSchemaViolations=getSchemaViolations,this.getCompletionContext=getCompletionContext,this.sourceObj=J?.sourceObj??new DoenetSourceObject,E!=null&&this.sourceObj.setSource(E+" "),this._rustResolverAdapter=J?.rustResolverAdapter,this._getAdditionalRefNamesImpl=J?.getAdditionalRefNames,F&&this.setSchema(F)}getAdditionalRefNames(E){return this._getAdditionalRefNamesImpl?.(E)??[]}setRustResolverAdapter(E){this._rustResolverAdapter=E,this._getAdditionalRefNamesImpl=F=>E.getDerivedRepeatNames(F)}async isNameAddressable(E,F){return this._rustResolverAdapter?this._rustResolverAdapter.isNameAddressableFromOffset(E,F):!1}async classifyReference(E,F){return this._rustResolverAdapter&&typeof this._rustResolverAdapter.classifyReferenceFromOffset=="function"?this._rustResolverAdapter.classifyReferenceFromOffset(E,F):"indeterminate"}async resolveRefMemberContainerAtOffset(E,F,J){if(this._rustResolverAdapter){const _t=await this._rustResolverAdapter.resolveRefMemberContainerAtOffset(E,F,J);if(_t)return _t}return{node:null,unresolvedPathParts:F.length>0?F.slice(0,-1):[],visibleDescendantNames:[]}}async _refreshModuleInstanceAttributes(){if(!this._rustResolverAdapter){this._moduleInstanceAttributeAllowlist.clear(),this._moduleInstanceAllowlistSourceRevision=-1;return}const E=this._rustResolverAdapter._sourceRevision;if(E===this._moduleInstanceAllowlistSourceRevision)return;if(this._moduleInstanceAllowlistRefreshInFlight)return this._moduleInstanceAllowlistRefreshInFlight;const F=this._rustResolverAdapter,J=(async()=>{const $e=collectModuleInstancesWithCopyOrExtend(this.sourceObj.dast),_t=await Promise.all($e.map(async lr=>{const mr=await getEffectiveModuleAttributes(lr,F);return[lr,mr]}));this._moduleInstanceAttributeAllowlist.clear();for(const[lr,mr]of _t)mr&&this._moduleInstanceAttributeAllowlist.set(lr,mr);this._moduleInstanceAllowlistSourceRevision=E})();return this._moduleInstanceAllowlistRefreshInFlight=J.finally(()=>{this._moduleInstanceAllowlistRefreshInFlight=null}),this._moduleInstanceAllowlistRefreshInFlight}setSchema(E,F){this.schema=E,this.schemaAliasedElementsByName=F??(E===BUNDLED_SCHEMA_ELEMENTS?doenetSchema.aliasedElements:{}),this.schemaAliasedElementsByLowerName=new Map(Object.entries(this.schemaAliasedElementsByName).map(([J,$e])=>[J.toLowerCase(),$e])),this.schemaLowerToUpper=Object.fromEntries(this.schema.map(J=>[J.name.toLowerCase(),J.name])),this.schemaAttributesLowerToUpper=Object.fromEntries([...Object.values(this.schemaAliasedElementsByName).flatMap(J=>J.attributes.map($e=>[$e.name.toLowerCase(),$e.name])),...this.schema.flatMap(J=>J.attributes.map($e=>[$e.name.toLowerCase(),$e.name]))]),this.schemaElementsByName=Object.fromEntries(this.schema.map(J=>[J.name,J])),this.schemaTopAllowedElements=this.schema.filter(J=>J.top).map(J=>J.name),this.parentChildMap=new Map(this.schema.map(J=>[J.name,new Set(J.children)])),this.nodeAttributeMap=new Map(this.schema.map(J=>[J.name,new Map(J.attributes.map($e=>[$e.name,$e.values?{correctCase:new Set($e.values),lowerCase:new Set($e.values.map(_t=>_t.toLowerCase())),isList:!!$e.isList}:null]))])),this._initializeSnippets()}_getAllowedChildren(E,F){const J=this._resolveEffectiveByName(E,F);if(J?.children)return J.children;const $e=this.normalizeElementName(E);return this.schemaElementsByName[$e]?.children||[]}_getChildRanks(E,F){const J=this._resolveEffectiveByName(E,F),$e=J?.children?J:this.schemaElementsByName[this.normalizeElementName(E)],_t=$e?.children,lr=$e?.childBuckets;if(!_t||!lr)return{};const mr={};for(let Or=0;Or<_t.length;Or++){const Pr=lr.charCodeAt(Or)-48;mr[_t[Or]]=Pr>=0&&Pr<=9?Pr:0}return mr}_getAcceptsStringChildren(E,F){const J=this._resolveEffectiveByName(E,F);if(J?.children&&typeof J.acceptsStringChildren=="boolean")return J.acceptsStringChildren;const $e=this.normalizeElementName(E);return this.schemaElementsByName[$e]?.acceptsStringChildren??!1}_resolveEffectiveByName(E,F){const J=this.normalizeElementName(E);if(J==="UNKNOWN_NAME")return;const $e=this.schemaElementsByName[J];return this.resolveEffectiveSchemaElement($e,F)}findSchemaElement(E){const F=this.schemaLowerToUpper[E.toLowerCase()];return F?this.schemaElementsByName[F]:void 0}findAliasedSchemaElement(E){return this.schemaAliasedElementsByName[E]??this.schemaAliasedElementsByLowerName.get(E.toLowerCase())}resolveEffectiveSchemaElement(E,F){if(!E)return;if(!F)return E;const $e=this.findSchemaElement(F)?.childContextHelp?.[E.name];return $e?this.findAliasedSchemaElement($e)??E:E}resolveRefNameForHelp(E,F){const J=this.sourceObj.getReferentAtOffset(E,F);return J?this._buildRefHelpInfo(J):null}resolveDerivedRepeatNameForHelp(E,F){let J=this.sourceObj.elementAtOffset(E)??void 0;for(;J;){const $e=this.resolveDerivedRepeatNameOnElement(J,F);if($e)return $e;const _t=this.sourceObj.getParent(J);J=_t&&_t.type==="element"?_t:void 0}return null}resolveDerivedRepeatNameOnElement(E,F){if(!isRepeatLikeElement(E))return null;for(const J of["valueName","indexName"]){const $e=E.attributes[J];if($e&&$e.children.length===1&&$e.children[0].type==="text"&&$e.children[0].value===F){const _t=E.position?.start.offset,lr=_t!=null&&_t<this.sourceObj.source.length?this.sourceObj.offsetToRowCol(_t).line:void 0;return{owner:E,role:J,line:lr}}}return null}resolveRefMemberDescendantHelp(E,F){const J=this.sourceObj.getNamedDescendant(E,F);if(J)return this._buildRefHelpInfo(J);const $e=findDescendantViaCompositeWrappers(E,F);return $e?this._buildRefHelpInfo($e):null}_buildRefHelpInfo(E){const F=E.position?.start.offset,J=F!=null&&F<this.sourceObj.source.length?this.sourceObj.offsetToRowCol(F).line:void 0,$e=this.normalizeElementName(E.name),_t=this.schemaElementsByName[$e],lr=this.resolveEffectiveSchemaElement(_t,this.sourceObj.getParentElementName(E));return{referent:E,line:J,ownEntry:_t,effectiveEntry:lr}}_getAttributeContainsOffset(E,F){return findAttributeContainingOffset(Object.values(E.attributes),F)}setSource(E){return this.sourceObj.setSource(E+" "),this}get source(){return this.sourceObj.source}normalizeElementName(E){return this.schemaLowerToUpper[E.toLowerCase()]||"UNKNOWN_NAME"}normalizeAttributeName(E){return this.schemaAttributesLowerToUpper[E.toLowerCase()]||"UNKNOWN_NAME"}isAllowedChild(E,F,J){const $e=this.normalizeElementName(E),_t=this.normalizeElementName(F);if($e==="UNKNOWN_NAME"||_t==="UNKNOWN_NAME")return!1;if(J){const lr=this._resolveEffectiveByName($e,J);if(lr&&lr.name!==$e&&lr.children)return lr.children.includes(_t)}return this.parentChildMap.get($e)?.has(_t)||!1}isAllowedAttribute(E,F,J,$e){if($e&&$e.has(F.toLowerCase()))return!0;const _t=this.normalizeElementName(E),lr=this.normalizeAttributeName(F);if(_t==="UNKNOWN_NAME"||lr==="UNKNOWN_NAME")return!1;if(J){const mr=this._resolveEffectiveByName(_t,J);if(mr&&mr.name!==_t){const Or=lr.toLowerCase();return mr.attributes.some(Pr=>Pr.name.toLowerCase()===Or)}}return this.nodeAttributeMap.get(_t)?.has(lr)||!1}getAttributeAllowedValues(E,F,J){const $e=this.normalizeElementName(E),_t=this.normalizeAttributeName(F);if($e==="UNKNOWN_NAME"||_t==="UNKNOWN_NAME")return null;if(J){const lr=this._resolveEffectiveByName($e,J);if(lr&&lr.name!==$e){const mr=_t.toLowerCase(),Or=lr.attributes.find(Pr=>Pr.name.toLowerCase()===mr);return Or&&Or.values?{correctCase:new Set(Or.values),lowerCase:new Set(Or.values.map(Pr=>Pr.toLowerCase())),isList:!!Or.isList}:null}}return this.nodeAttributeMap.get($e)?.get(_t)||null}_initializeSnippets(){this.snippetsByNormalizedElement.clear(),this.snippetsByKey.clear(),Object.entries(COMPLETION_SNIPPETS).forEach(([E,F])=>{const J=F.snippet??"",$e=J.trimStart(),_t=J.length-$e.length,lr=this.normalizeElementName(F.element);if(lr==="UNKNOWN_NAME")return;const mr={key:E,element:F.element,normalizedElement:lr,snippet:$e,description:F.description,cursor:F.cursor?adjustCursorForTrimStart(F.cursor,_t):void 0};this.snippetsByNormalizedElement.has(lr)||this.snippetsByNormalizedElement.set(lr,[]),this.snippetsByNormalizedElement.get(lr).push(mr),this.snippetsByKey.set(E,mr)})}findSnippet(E){return this.snippetsByKey.get(E)}_getSnippetsForElements(E,F=""){const J=[];for(const $e of E){const _t=this.snippetsByNormalizedElement.get($e)||[];J.push(..._t)}if(F){const $e=F.toLowerCase();return J.filter(_t=>_t.key.toLowerCase().includes($e))}return J}}const own$2={}.hasOwnProperty;function zwitch(D,E){const F=E||{};function J($e,..._t){let lr=J.invalid;const mr=J.handlers;if($e&&own$2.call($e,D)){const Or=String($e[D]);lr=own$2.call(mr,Or)?mr[Or]:J.unknown}if(lr)return lr.call(this,$e,..._t)}return J.handlers=F.handlers||{},J.invalid=F.invalid,J.unknown=F.unknown,J}const own$1={}.hasOwnProperty;function configure(D,E){let F=-1,J;if(E.extensions)for(;++F<E.extensions.length;)configure(D,E.extensions[F]);for(J in E)if(own$1.call(E,J))switch(J){case"extensions":break;case"unsafe":{list$1(D[J],E[J]);break}case"join":{list$1(D[J],E[J]);break}case"handlers":{map$4(D[J],E[J]);break}default:D.options[J]=E[J]}return D}function list$1(D,E){E&&D.push(...E)}function map$4(D,E){E&&Object.assign(D,E)}function blockquote(D,E,F,J){const $e=F.enter("blockquote"),_t=F.createTracker(J);_t.move("> "),_t.shift(2);const lr=F.indentLines(F.containerFlow(D,_t.current()),map$3);return $e(),lr}function map$3(D,E,F){return">"+(F?"":" ")+D}function patternInScope(D,E){return listInScope(D,E.inConstruct,!0)&&!listInScope(D,E.notInConstruct,!1)}function listInScope(D,E,F){if(typeof E=="string"&&(E=[E]),!E||E.length===0)return F;let J=-1;for(;++J<E.length;)if(D.includes(E[J]))return!0;return!1}function hardBreak(D,E,F,J){let $e=-1;for(;++$e<F.unsafe.length;)if(F.unsafe[$e].character===`\n`&&patternInScope(F.stack,F.unsafe[$e]))return/[ \\t]/.test(J.before)?"":" ";return`\\\\\n`}function longestStreak(D,E){const F=String(D);let J=F.indexOf(E),$e=J,_t=0,lr=0;if(typeof E!="string")throw new TypeError("Expected substring");for(;J!==-1;)J===$e?++_t>lr&&(lr=_t):_t=1,$e=J+E.length,J=F.indexOf(E,$e);return lr}function formatCodeAsIndented(D,E){return!!(E.options.fences===!1&&D.value&&!D.lang&&/[^ \\r\\n]/.test(D.value)&&!/^[\\t ]*(?:[\\r\\n]|$)|(?:^|[\\r\\n])[\\t ]*$/.test(D.value))}function checkFence(D){const E=D.options.fence||"`";if(E!=="`"&&E!=="~")throw new Error("Cannot serialize code with `"+E+"` for `options.fence`, expected `` ` `` or `~`");return E}function code(D,E,F,J){const $e=checkFence(F),_t=D.value||"",lr=$e==="`"?"GraveAccent":"Tilde";if(formatCodeAsIndented(D,F)){const gi=F.enter("codeIndented"),qi=F.indentLines(_t,map$2);return gi(),qi}const mr=F.createTracker(J),Or=$e.repeat(Math.max(longestStreak(_t,$e)+1,3)),Pr=F.enter("codeFenced");let dn=mr.move(Or);if(D.lang){const gi=F.enter(`codeFencedLang${lr}`);dn+=mr.move(F.safe(D.lang,{before:dn,after:" ",encode:["`"],...mr.current()})),gi()}if(D.lang&&D.meta){const gi=F.enter(`codeFencedMeta${lr}`);dn+=mr.move(" "),dn+=mr.move(F.safe(D.meta,{before:dn,after:`\n`,encode:["`"],...mr.current()})),gi()}return dn+=mr.move(`\n`),_t&&(dn+=mr.move(_t+`\n`)),dn+=mr.move(Or),Pr(),dn}function map$2(D,E,F){return(F?"":"    ")+D}function checkQuote(D){const E=D.options.quote||\'"\';if(E!==\'"\'&&E!=="\'")throw new Error("Cannot serialize title with `"+E+"` for `options.quote`, expected `\\"`, or `\'`");return E}function definition(D,E,F,J){const $e=checkQuote(F),_t=$e===\'"\'?"Quote":"Apostrophe",lr=F.enter("definition");let mr=F.enter("label");const Or=F.createTracker(J);let Pr=Or.move("[");return Pr+=Or.move(F.safe(F.associationId(D),{before:Pr,after:"]",...Or.current()})),Pr+=Or.move("]: "),mr(),!D.url||/[\\0- \\u007F]/.test(D.url)?(mr=F.enter("destinationLiteral"),Pr+=Or.move("<"),Pr+=Or.move(F.safe(D.url,{before:Pr,after:">",...Or.current()})),Pr+=Or.move(">")):(mr=F.enter("destinationRaw"),Pr+=Or.move(F.safe(D.url,{before:Pr,after:D.title?" ":`\n`,...Or.current()}))),mr(),D.title&&(mr=F.enter(`title${_t}`),Pr+=Or.move(" "+$e),Pr+=Or.move(F.safe(D.title,{before:Pr,after:$e,...Or.current()})),Pr+=Or.move($e),mr()),lr(),Pr}function checkEmphasis(D){const E=D.options.emphasis||"*";if(E!=="*"&&E!=="_")throw new Error("Cannot serialize emphasis with `"+E+"` for `options.emphasis`, expected `*`, or `_`");return E}function encodeCharacterReference(D){return"&#x"+D.toString(16).toUpperCase()+";"}function markdownLineEndingOrSpace(D){return D!==null&&(D<0||D===32)}const unicodePunctuation=regexCheck(new RegExp("\\\\p{P}|\\\\p{S}","u")),unicodeWhitespace=regexCheck(/\\s/);function regexCheck(D){return E;function E(F){return F!==null&&F>-1&&D.test(String.fromCharCode(F))}}function classifyCharacter(D){if(D===null||markdownLineEndingOrSpace(D)||unicodeWhitespace(D))return 1;if(unicodePunctuation(D))return 2}function encodeInfo(D,E,F){const J=classifyCharacter(D),$e=classifyCharacter(E);return J===void 0?$e===void 0?F==="_"?{inside:!0,outside:!0}:{inside:!1,outside:!1}:$e===1?{inside:!0,outside:!0}:{inside:!1,outside:!0}:J===1?$e===void 0?{inside:!1,outside:!1}:$e===1?{inside:!0,outside:!0}:{inside:!1,outside:!1}:$e===void 0?{inside:!1,outside:!1}:$e===1?{inside:!0,outside:!1}:{inside:!1,outside:!1}}emphasis.peek=emphasisPeek;function emphasis(D,E,F,J){const $e=checkEmphasis(F),_t=F.enter("emphasis"),lr=F.createTracker(J),mr=lr.move($e);let Or=lr.move(F.containerPhrasing(D,{after:$e,before:mr,...lr.current()}));const Pr=Or.charCodeAt(0),dn=encodeInfo(J.before.charCodeAt(J.before.length-1),Pr,$e);dn.inside&&(Or=encodeCharacterReference(Pr)+Or.slice(1));const gi=Or.charCodeAt(Or.length-1),qi=encodeInfo(J.after.charCodeAt(0),gi,$e);qi.inside&&(Or=Or.slice(0,-1)+encodeCharacterReference(gi));const zi=lr.move($e);return _t(),F.attentionEncodeSurroundingInfo={after:qi.outside,before:dn.outside},mr+Or+zi}function emphasisPeek(D,E,F){return F.options.emphasis||"*"}const convert=(function(D){if(D==null)return ok;if(typeof D=="function")return castFactory(D);if(typeof D=="object")return Array.isArray(D)?anyFactory(D):propertiesFactory(D);if(typeof D=="string")return typeFactory(D);throw new Error("Expected function, string, or object as test")});function anyFactory(D){const E=[];let F=-1;for(;++F<D.length;)E[F]=convert(D[F]);return castFactory(J);function J(...$e){let _t=-1;for(;++_t<E.length;)if(E[_t].apply(this,$e))return!0;return!1}}function propertiesFactory(D){const E=D;return castFactory(F);function F(J){const $e=J;let _t;for(_t in D)if($e[_t]!==E[_t])return!1;return!0}}function typeFactory(D){return castFactory(E);function E(F){return F&&F.type===D}}function castFactory(D){return E;function E(F,J,$e){return!!(looksLikeANode(F)&&D.call(this,F,typeof J=="number"?J:void 0,$e||void 0))}}function ok(){return!0}function looksLikeANode(D){return D!==null&&typeof D=="object"&&"type"in D}function color(D){return D}const empty=[],CONTINUE=!0,EXIT=!1,SKIP="skip";function visitParents(D,E,F,J){let $e;typeof E=="function"&&typeof F!="function"?(J=F,F=E):$e=E;const _t=convert($e),lr=J?-1:1;mr(D,void 0,[])();function mr(Or,Pr,dn){const gi=Or&&typeof Or=="object"?Or:{};if(typeof gi.type=="string"){const zi=typeof gi.tagName=="string"?gi.tagName:typeof gi.name=="string"?gi.name:void 0;Object.defineProperty(qi,"name",{value:"node ("+(Or.type+(zi?"<"+zi+">":""))+")"})}return qi;function qi(){let zi=empty,Hi,Qi,Gi;if((!E||_t(Or,Pr,dn[dn.length-1]||void 0))&&(zi=toResult(F(Or,dn)),zi[0]===EXIT))return zi;if("children"in Or&&Or.children){const Zi=Or;if(Zi.children&&zi[0]!==SKIP)for(Qi=(J?Zi.children.length:-1)+lr,Gi=dn.concat(Zi);Qi>-1&&Qi<Zi.children.length;){const Xi=Zi.children[Qi];if(Hi=mr(Xi,Qi,Gi)(),Hi[0]===EXIT)return Hi;Qi=typeof Hi[1]=="number"?Hi[1]:Qi+lr}}return zi}}}function toResult(D){return Array.isArray(D)?D:typeof D=="number"?[CONTINUE,D]:D==null?empty:[D]}function visit(D,E,F,J){let $e,_t,lr;typeof E=="function"&&typeof F!="function"?(_t=void 0,lr=E,$e=F):(_t=E,lr=F,$e=J),visitParents(D,_t,mr,$e);function mr(Or,Pr){const dn=Pr[Pr.length-1],gi=dn?dn.children.indexOf(Or):void 0;return lr(Or,gi,dn)}}const emptyOptions={};function toString$2(D,E){const F=emptyOptions,J=typeof F.includeImageAlt=="boolean"?F.includeImageAlt:!0,$e=typeof F.includeHtml=="boolean"?F.includeHtml:!0;return one(D,J,$e)}function one(D,E,F){if(node(D)){if("value"in D)return D.type==="html"&&!F?"":D.value;if(E&&"alt"in D&&D.alt)return D.alt;if("children"in D)return all$1(D.children,E,F)}return Array.isArray(D)?all$1(D,E,F):""}function all$1(D,E,F){const J=[];let $e=-1;for(;++$e<D.length;)J[$e]=one(D[$e],E,F);return J.join("")}function node(D){return!!(D&&typeof D=="object")}function formatHeadingAsSetext(D,E){let F=!1;return visit(D,function(J){if("value"in J&&/\\r?\\n|\\r/.test(J.value)||J.type==="break")return F=!0,EXIT}),!!((!D.depth||D.depth<3)&&toString$2(D)&&(E.options.setext||F))}function heading(D,E,F,J){const $e=Math.max(Math.min(6,D.depth||1),1),_t=F.createTracker(J);if(formatHeadingAsSetext(D,F)){const dn=F.enter("headingSetext"),gi=F.enter("phrasing"),qi=F.containerPhrasing(D,{..._t.current(),before:`\n`,after:`\n`});return gi(),dn(),qi+`\n`+($e===1?"=":"-").repeat(qi.length-(Math.max(qi.lastIndexOf("\\r"),qi.lastIndexOf(`\n`))+1))}const lr="#".repeat($e),mr=F.enter("headingAtx"),Or=F.enter("phrasing");_t.move(lr+" ");let Pr=F.containerPhrasing(D,{before:"# ",after:`\n`,..._t.current()});return/^[\\t ]/.test(Pr)&&(Pr=encodeCharacterReference(Pr.charCodeAt(0))+Pr.slice(1)),Pr=Pr?lr+" "+Pr:lr,F.options.closeAtx&&(Pr+=" "+lr),Or(),mr(),Pr}html.peek=htmlPeek;function html(D){return D.value||""}function htmlPeek(){return"<"}image.peek=imagePeek;function image(D,E,F,J){const $e=checkQuote(F),_t=$e===\'"\'?"Quote":"Apostrophe",lr=F.enter("image");let mr=F.enter("label");const Or=F.createTracker(J);let Pr=Or.move("![");return Pr+=Or.move(F.safe(D.alt,{before:Pr,after:"]",...Or.current()})),Pr+=Or.move("]("),mr(),!D.url&&D.title||/[\\0- \\u007F]/.test(D.url)?(mr=F.enter("destinationLiteral"),Pr+=Or.move("<"),Pr+=Or.move(F.safe(D.url,{before:Pr,after:">",...Or.current()})),Pr+=Or.move(">")):(mr=F.enter("destinationRaw"),Pr+=Or.move(F.safe(D.url,{before:Pr,after:D.title?" ":")",...Or.current()}))),mr(),D.title&&(mr=F.enter(`title${_t}`),Pr+=Or.move(" "+$e),Pr+=Or.move(F.safe(D.title,{before:Pr,after:$e,...Or.current()})),Pr+=Or.move($e),mr()),Pr+=Or.move(")"),lr(),Pr}function imagePeek(){return"!"}imageReference.peek=imageReferencePeek;function imageReference(D,E,F,J){const $e=D.referenceType,_t=F.enter("imageReference");let lr=F.enter("label");const mr=F.createTracker(J);let Or=mr.move("![");const Pr=F.safe(D.alt,{before:Or,after:"]",...mr.current()});Or+=mr.move(Pr+"]["),lr();const dn=F.stack;F.stack=[],lr=F.enter("reference");const gi=F.safe(F.associationId(D),{before:Or,after:"]",...mr.current()});return lr(),F.stack=dn,_t(),$e==="full"||!Pr||Pr!==gi?Or+=mr.move(gi+"]"):$e==="shortcut"?Or=Or.slice(0,-1):Or+=mr.move("]"),Or}function imageReferencePeek(){return"!"}inlineCode.peek=inlineCodePeek;function inlineCode(D,E,F){let J=D.value||"",$e="`",_t=-1;for(;new RegExp("(^|[^`])"+$e+"([^`]|$)").test(J);)$e+="`";for(/[^ \\r\\n]/.test(J)&&(/^[ \\r\\n]/.test(J)&&/[ \\r\\n]$/.test(J)||/^`|`$/.test(J))&&(J=" "+J+" ");++_t<F.unsafe.length;){const lr=F.unsafe[_t],mr=F.compilePattern(lr);let Or;if(lr.atBreak)for(;Or=mr.exec(J);){let Pr=Or.index;J.charCodeAt(Pr)===10&&J.charCodeAt(Pr-1)===13&&Pr--,J=J.slice(0,Pr)+" "+J.slice(Or.index+1)}}return $e+J+$e}function inlineCodePeek(){return"`"}function formatLinkAsAutolink(D,E){const F=toString$2(D);return!!(!E.options.resourceLink&&D.url&&!D.title&&D.children&&D.children.length===1&&D.children[0].type==="text"&&(F===D.url||"mailto:"+F===D.url)&&/^[a-z][a-z+.-]+:/i.test(D.url)&&!/[\\0- <>\\u007F]/.test(D.url))}link.peek=linkPeek;function link(D,E,F,J){const $e=checkQuote(F),_t=$e===\'"\'?"Quote":"Apostrophe",lr=F.createTracker(J);let mr,Or;if(formatLinkAsAutolink(D,F)){const dn=F.stack;F.stack=[],mr=F.enter("autolink");let gi=lr.move("<");return gi+=lr.move(F.containerPhrasing(D,{before:gi,after:">",...lr.current()})),gi+=lr.move(">"),mr(),F.stack=dn,gi}mr=F.enter("link"),Or=F.enter("label");let Pr=lr.move("[");return Pr+=lr.move(F.containerPhrasing(D,{before:Pr,after:"](",...lr.current()})),Pr+=lr.move("]("),Or(),!D.url&&D.title||/[\\0- \\u007F]/.test(D.url)?(Or=F.enter("destinationLiteral"),Pr+=lr.move("<"),Pr+=lr.move(F.safe(D.url,{before:Pr,after:">",...lr.current()})),Pr+=lr.move(">")):(Or=F.enter("destinationRaw"),Pr+=lr.move(F.safe(D.url,{before:Pr,after:D.title?" ":")",...lr.current()}))),Or(),D.title&&(Or=F.enter(`title${_t}`),Pr+=lr.move(" "+$e),Pr+=lr.move(F.safe(D.title,{before:Pr,after:$e,...lr.current()})),Pr+=lr.move($e),Or()),Pr+=lr.move(")"),mr(),Pr}function linkPeek(D,E,F){return formatLinkAsAutolink(D,F)?"<":"["}linkReference.peek=linkReferencePeek;function linkReference(D,E,F,J){const $e=D.referenceType,_t=F.enter("linkReference");let lr=F.enter("label");const mr=F.createTracker(J);let Or=mr.move("[");const Pr=F.containerPhrasing(D,{before:Or,after:"]",...mr.current()});Or+=mr.move(Pr+"]["),lr();const dn=F.stack;F.stack=[],lr=F.enter("reference");const gi=F.safe(F.associationId(D),{before:Or,after:"]",...mr.current()});return lr(),F.stack=dn,_t(),$e==="full"||!Pr||Pr!==gi?Or+=mr.move(gi+"]"):$e==="shortcut"?Or=Or.slice(0,-1):Or+=mr.move("]"),Or}function linkReferencePeek(){return"["}function checkBullet(D){const E=D.options.bullet||"*";if(E!=="*"&&E!=="+"&&E!=="-")throw new Error("Cannot serialize items with `"+E+"` for `options.bullet`, expected `*`, `+`, or `-`");return E}function checkBulletOther(D){const E=checkBullet(D),F=D.options.bulletOther;if(!F)return E==="*"?"-":"*";if(F!=="*"&&F!=="+"&&F!=="-")throw new Error("Cannot serialize items with `"+F+"` for `options.bulletOther`, expected `*`, `+`, or `-`");if(F===E)throw new Error("Expected `bullet` (`"+E+"`) and `bulletOther` (`"+F+"`) to be different");return F}function checkBulletOrdered(D){const E=D.options.bulletOrdered||".";if(E!=="."&&E!==")")throw new Error("Cannot serialize items with `"+E+"` for `options.bulletOrdered`, expected `.` or `)`");return E}function checkRule(D){const E=D.options.rule||"*";if(E!=="*"&&E!=="-"&&E!=="_")throw new Error("Cannot serialize rules with `"+E+"` for `options.rule`, expected `*`, `-`, or `_`");return E}function list(D,E,F,J){const $e=F.enter("list"),_t=F.bulletCurrent;let lr=D.ordered?checkBulletOrdered(F):checkBullet(F);const mr=D.ordered?lr==="."?")":".":checkBulletOther(F);let Or=E&&F.bulletLastUsed?lr===F.bulletLastUsed:!1;if(!D.ordered){const dn=D.children?D.children[0]:void 0;if((lr==="*"||lr==="-")&&dn&&(!dn.children||!dn.children[0])&&F.stack[F.stack.length-1]==="list"&&F.stack[F.stack.length-2]==="listItem"&&F.stack[F.stack.length-3]==="list"&&F.stack[F.stack.length-4]==="listItem"&&F.indexStack[F.indexStack.length-1]===0&&F.indexStack[F.indexStack.length-2]===0&&F.indexStack[F.indexStack.length-3]===0&&(Or=!0),checkRule(F)===lr&&dn){let gi=-1;for(;++gi<D.children.length;){const qi=D.children[gi];if(qi&&qi.type==="listItem"&&qi.children&&qi.children[0]&&qi.children[0].type==="thematicBreak"){Or=!0;break}}}}Or&&(lr=mr),F.bulletCurrent=lr;const Pr=F.containerFlow(D,J);return F.bulletLastUsed=lr,F.bulletCurrent=_t,$e(),Pr}function checkListItemIndent(D){const E=D.options.listItemIndent||"one";if(E!=="tab"&&E!=="one"&&E!=="mixed")throw new Error("Cannot serialize items with `"+E+"` for `options.listItemIndent`, expected `tab`, `one`, or `mixed`");return E}function listItem(D,E,F,J){const $e=checkListItemIndent(F);let _t=F.bulletCurrent||checkBullet(F);E&&E.type==="list"&&E.ordered&&(_t=(typeof E.start=="number"&&E.start>-1?E.start:1)+(F.options.incrementListMarker===!1?0:E.children.indexOf(D))+_t);let lr=_t.length+1;($e==="tab"||$e==="mixed"&&(E&&E.type==="list"&&E.spread||D.spread))&&(lr=Math.ceil(lr/4)*4);const mr=F.createTracker(J);mr.move(_t+" ".repeat(lr-_t.length)),mr.shift(lr);const Or=F.enter("listItem"),Pr=F.indentLines(F.containerFlow(D,mr.current()),dn);return Or(),Pr;function dn(gi,qi,zi){return qi?(zi?"":" ".repeat(lr))+gi:(zi?_t:_t+" ".repeat(lr-_t.length))+gi}}function paragraph(D,E,F,J){const $e=F.enter("paragraph"),_t=F.enter("phrasing"),lr=F.containerPhrasing(D,J);return _t(),$e(),lr}const phrasing=convert(["break","delete","emphasis","footnote","footnoteReference","image","imageReference","inlineCode","inlineMath","link","linkReference","mdxJsxTextElement","mdxTextExpression","strong","text","textDirective"]);function root$1(D,E,F,J){return(D.children.some(function(lr){return phrasing(lr)})?F.containerPhrasing:F.containerFlow).call(F,D,J)}function checkStrong(D){const E=D.options.strong||"*";if(E!=="*"&&E!=="_")throw new Error("Cannot serialize strong with `"+E+"` for `options.strong`, expected `*`, or `_`");return E}strong.peek=strongPeek;function strong(D,E,F,J){const $e=checkStrong(F),_t=F.enter("strong"),lr=F.createTracker(J),mr=lr.move($e+$e);let Or=lr.move(F.containerPhrasing(D,{after:$e,before:mr,...lr.current()}));const Pr=Or.charCodeAt(0),dn=encodeInfo(J.before.charCodeAt(J.before.length-1),Pr,$e);dn.inside&&(Or=encodeCharacterReference(Pr)+Or.slice(1));const gi=Or.charCodeAt(Or.length-1),qi=encodeInfo(J.after.charCodeAt(0),gi,$e);qi.inside&&(Or=Or.slice(0,-1)+encodeCharacterReference(gi));const zi=lr.move($e+$e);return _t(),F.attentionEncodeSurroundingInfo={after:qi.outside,before:dn.outside},mr+Or+zi}function strongPeek(D,E,F){return F.options.strong||"*"}function text(D,E,F,J){return F.safe(D.value,J)}function checkRuleRepetition(D){const E=D.options.ruleRepetition||3;if(E<3)throw new Error("Cannot serialize rules with repetition `"+E+"` for `options.ruleRepetition`, expected `3` or more");return E}function thematicBreak(D,E,F){const J=(checkRule(F)+(F.options.ruleSpaces?" ":"")).repeat(checkRuleRepetition(F));return F.options.ruleSpaces?J.slice(0,-1):J}const handle={blockquote,break:hardBreak,code,definition,emphasis,hardBreak,heading,html,image,imageReference,inlineCode,link,linkReference,list,listItem,paragraph,root:root$1,strong,text,thematicBreak},join$1=[joinDefaults];function joinDefaults(D,E,F,J){if(E.type==="code"&&formatCodeAsIndented(E,J)&&(D.type==="list"||D.type===E.type&&formatCodeAsIndented(D,J)))return!1;if("spread"in F&&typeof F.spread=="boolean")return D.type==="paragraph"&&(D.type===E.type||E.type==="definition"||E.type==="heading"&&formatHeadingAsSetext(E,J))?void 0:F.spread?1:0}const fullPhrasingSpans=["autolink","destinationLiteral","destinationRaw","reference","titleQuote","titleApostrophe"],unsafe=[{character:"	",after:"[\\\\r\\\\n]",inConstruct:"phrasing"},{character:"	",before:"[\\\\r\\\\n]",inConstruct:"phrasing"},{character:"	",inConstruct:["codeFencedLangGraveAccent","codeFencedLangTilde"]},{character:"\\r",inConstruct:["codeFencedLangGraveAccent","codeFencedLangTilde","codeFencedMetaGraveAccent","codeFencedMetaTilde","destinationLiteral","headingAtx"]},{character:`\n`,inConstruct:["codeFencedLangGraveAccent","codeFencedLangTilde","codeFencedMetaGraveAccent","codeFencedMetaTilde","destinationLiteral","headingAtx"]},{character:" ",after:"[\\\\r\\\\n]",inConstruct:"phrasing"},{character:" ",before:"[\\\\r\\\\n]",inConstruct:"phrasing"},{character:" ",inConstruct:["codeFencedLangGraveAccent","codeFencedLangTilde"]},{character:"!",after:"\\\\[",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{character:\'"\',inConstruct:"titleQuote"},{atBreak:!0,character:"#"},{character:"#",inConstruct:"headingAtx",after:`(?:[\\r\n]|$)`},{character:"&",after:"[#A-Za-z]",inConstruct:"phrasing"},{character:"\'",inConstruct:"titleApostrophe"},{character:"(",inConstruct:"destinationRaw"},{before:"\\\\]",character:"(",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{atBreak:!0,before:"\\\\d+",character:")"},{character:")",inConstruct:"destinationRaw"},{atBreak:!0,character:"*",after:`(?:[ 	\\r\n*])`},{character:"*",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{atBreak:!0,character:"+",after:`(?:[ 	\\r\n])`},{atBreak:!0,character:"-",after:`(?:[ 	\\r\n-])`},{atBreak:!0,before:"\\\\d+",character:".",after:`(?:[ 	\\r\n]|$)`},{atBreak:!0,character:"<",after:"[!/?A-Za-z]"},{character:"<",after:"[!/?A-Za-z]",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{character:"<",inConstruct:"destinationLiteral"},{atBreak:!0,character:"="},{atBreak:!0,character:">"},{character:">",inConstruct:"destinationLiteral"},{atBreak:!0,character:"["},{character:"[",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{character:"[",inConstruct:["label","reference"]},{character:"\\\\",after:"[\\\\r\\\\n]",inConstruct:"phrasing"},{character:"]",inConstruct:["label","reference"]},{atBreak:!0,character:"_"},{character:"_",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{atBreak:!0,character:"`"},{character:"`",inConstruct:["codeFencedLangGraveAccent","codeFencedMetaGraveAccent"]},{character:"`",inConstruct:"phrasing",notInConstruct:fullPhrasingSpans},{atBreak:!0,character:"~"}],characterEntities={AElig:"Æ",AMP:"&",Aacute:"Á",Abreve:"Ă",Acirc:"Â",Acy:"А",Afr:"𝔄",Agrave:"À",Alpha:"Α",Amacr:"Ā",And:"⩓",Aogon:"Ą",Aopf:"𝔸",ApplyFunction:"⁡",Aring:"Å",Ascr:"𝒜",Assign:"≔",Atilde:"Ã",Auml:"Ä",Backslash:"∖",Barv:"⫧",Barwed:"⌆",Bcy:"Б",Because:"∵",Bernoullis:"ℬ",Beta:"Β",Bfr:"𝔅",Bopf:"𝔹",Breve:"˘",Bscr:"ℬ",Bumpeq:"≎",CHcy:"Ч",COPY:"©",Cacute:"Ć",Cap:"⋒",CapitalDifferentialD:"ⅅ",Cayleys:"ℭ",Ccaron:"Č",Ccedil:"Ç",Ccirc:"Ĉ",Cconint:"∰",Cdot:"Ċ",Cedilla:"¸",CenterDot:"·",Cfr:"ℭ",Chi:"Χ",CircleDot:"⊙",CircleMinus:"⊖",CirclePlus:"⊕",CircleTimes:"⊗",ClockwiseContourIntegral:"∲",CloseCurlyDoubleQuote:"”",CloseCurlyQuote:"’",Colon:"∷",Colone:"⩴",Congruent:"≡",Conint:"∯",ContourIntegral:"∮",Copf:"ℂ",Coproduct:"∐",CounterClockwiseContourIntegral:"∳",Cross:"⨯",Cscr:"𝒞",Cup:"⋓",CupCap:"≍",DD:"ⅅ",DDotrahd:"⤑",DJcy:"Ђ",DScy:"Ѕ",DZcy:"Џ",Dagger:"‡",Darr:"↡",Dashv:"⫤",Dcaron:"Ď",Dcy:"Д",Del:"∇",Delta:"Δ",Dfr:"𝔇",DiacriticalAcute:"´",DiacriticalDot:"˙",DiacriticalDoubleAcute:"˝",DiacriticalGrave:"`",DiacriticalTilde:"˜",Diamond:"⋄",DifferentialD:"ⅆ",Dopf:"𝔻",Dot:"¨",DotDot:"⃜",DotEqual:"≐",DoubleContourIntegral:"∯",DoubleDot:"¨",DoubleDownArrow:"⇓",DoubleLeftArrow:"⇐",DoubleLeftRightArrow:"⇔",DoubleLeftTee:"⫤",DoubleLongLeftArrow:"⟸",DoubleLongLeftRightArrow:"⟺",DoubleLongRightArrow:"⟹",DoubleRightArrow:"⇒",DoubleRightTee:"⊨",DoubleUpArrow:"⇑",DoubleUpDownArrow:"⇕",DoubleVerticalBar:"∥",DownArrow:"↓",DownArrowBar:"⤓",DownArrowUpArrow:"⇵",DownBreve:"̑",DownLeftRightVector:"⥐",DownLeftTeeVector:"⥞",DownLeftVector:"↽",DownLeftVectorBar:"⥖",DownRightTeeVector:"⥟",DownRightVector:"⇁",DownRightVectorBar:"⥗",DownTee:"⊤",DownTeeArrow:"↧",Downarrow:"⇓",Dscr:"𝒟",Dstrok:"Đ",ENG:"Ŋ",ETH:"Ð",Eacute:"É",Ecaron:"Ě",Ecirc:"Ê",Ecy:"Э",Edot:"Ė",Efr:"𝔈",Egrave:"È",Element:"∈",Emacr:"Ē",EmptySmallSquare:"◻",EmptyVerySmallSquare:"▫",Eogon:"Ę",Eopf:"𝔼",Epsilon:"Ε",Equal:"⩵",EqualTilde:"≂",Equilibrium:"⇌",Escr:"ℰ",Esim:"⩳",Eta:"Η",Euml:"Ë",Exists:"∃",ExponentialE:"ⅇ",Fcy:"Ф",Ffr:"𝔉",FilledSmallSquare:"◼",FilledVerySmallSquare:"▪",Fopf:"𝔽",ForAll:"∀",Fouriertrf:"ℱ",Fscr:"ℱ",GJcy:"Ѓ",GT:">",Gamma:"Γ",Gammad:"Ϝ",Gbreve:"Ğ",Gcedil:"Ģ",Gcirc:"Ĝ",Gcy:"Г",Gdot:"Ġ",Gfr:"𝔊",Gg:"⋙",Gopf:"𝔾",GreaterEqual:"≥",GreaterEqualLess:"⋛",GreaterFullEqual:"≧",GreaterGreater:"⪢",GreaterLess:"≷",GreaterSlantEqual:"⩾",GreaterTilde:"≳",Gscr:"𝒢",Gt:"≫",HARDcy:"Ъ",Hacek:"ˇ",Hat:"^",Hcirc:"Ĥ",Hfr:"ℌ",HilbertSpace:"ℋ",Hopf:"ℍ",HorizontalLine:"─",Hscr:"ℋ",Hstrok:"Ħ",HumpDownHump:"≎",HumpEqual:"≏",IEcy:"Е",IJlig:"Ĳ",IOcy:"Ё",Iacute:"Í",Icirc:"Î",Icy:"И",Idot:"İ",Ifr:"ℑ",Igrave:"Ì",Im:"ℑ",Imacr:"Ī",ImaginaryI:"ⅈ",Implies:"⇒",Int:"∬",Integral:"∫",Intersection:"⋂",InvisibleComma:"⁣",InvisibleTimes:"⁢",Iogon:"Į",Iopf:"𝕀",Iota:"Ι",Iscr:"ℐ",Itilde:"Ĩ",Iukcy:"І",Iuml:"Ï",Jcirc:"Ĵ",Jcy:"Й",Jfr:"𝔍",Jopf:"𝕁",Jscr:"𝒥",Jsercy:"Ј",Jukcy:"Є",KHcy:"Х",KJcy:"Ќ",Kappa:"Κ",Kcedil:"Ķ",Kcy:"К",Kfr:"𝔎",Kopf:"𝕂",Kscr:"𝒦",LJcy:"Љ",LT:"<",Lacute:"Ĺ",Lambda:"Λ",Lang:"⟪",Laplacetrf:"ℒ",Larr:"↞",Lcaron:"Ľ",Lcedil:"Ļ",Lcy:"Л",LeftAngleBracket:"⟨",LeftArrow:"←",LeftArrowBar:"⇤",LeftArrowRightArrow:"⇆",LeftCeiling:"⌈",LeftDoubleBracket:"⟦",LeftDownTeeVector:"⥡",LeftDownVector:"⇃",LeftDownVectorBar:"⥙",LeftFloor:"⌊",LeftRightArrow:"↔",LeftRightVector:"⥎",LeftTee:"⊣",LeftTeeArrow:"↤",LeftTeeVector:"⥚",LeftTriangle:"⊲",LeftTriangleBar:"⧏",LeftTriangleEqual:"⊴",LeftUpDownVector:"⥑",LeftUpTeeVector:"⥠",LeftUpVector:"↿",LeftUpVectorBar:"⥘",LeftVector:"↼",LeftVectorBar:"⥒",Leftarrow:"⇐",Leftrightarrow:"⇔",LessEqualGreater:"⋚",LessFullEqual:"≦",LessGreater:"≶",LessLess:"⪡",LessSlantEqual:"⩽",LessTilde:"≲",Lfr:"𝔏",Ll:"⋘",Lleftarrow:"⇚",Lmidot:"Ŀ",LongLeftArrow:"⟵",LongLeftRightArrow:"⟷",LongRightArrow:"⟶",Longleftarrow:"⟸",Longleftrightarrow:"⟺",Longrightarrow:"⟹",Lopf:"𝕃",LowerLeftArrow:"↙",LowerRightArrow:"↘",Lscr:"ℒ",Lsh:"↰",Lstrok:"Ł",Lt:"≪",Map:"⤅",Mcy:"М",MediumSpace:" ",Mellintrf:"ℳ",Mfr:"𝔐",MinusPlus:"∓",Mopf:"𝕄",Mscr:"ℳ",Mu:"Μ",NJcy:"Њ",Nacute:"Ń",Ncaron:"Ň",Ncedil:"Ņ",Ncy:"Н",NegativeMediumSpace:"​",NegativeThickSpace:"​",NegativeThinSpace:"​",NegativeVeryThinSpace:"​",NestedGreaterGreater:"≫",NestedLessLess:"≪",NewLine:`\n`,Nfr:"𝔑",NoBreak:"⁠",NonBreakingSpace:" ",Nopf:"ℕ",Not:"⫬",NotCongruent:"≢",NotCupCap:"≭",NotDoubleVerticalBar:"∦",NotElement:"∉",NotEqual:"≠",NotEqualTilde:"≂̸",NotExists:"∄",NotGreater:"≯",NotGreaterEqual:"≱",NotGreaterFullEqual:"≧̸",NotGreaterGreater:"≫̸",NotGreaterLess:"≹",NotGreaterSlantEqual:"⩾̸",NotGreaterTilde:"≵",NotHumpDownHump:"≎̸",NotHumpEqual:"≏̸",NotLeftTriangle:"⋪",NotLeftTriangleBar:"⧏̸",NotLeftTriangleEqual:"⋬",NotLess:"≮",NotLessEqual:"≰",NotLessGreater:"≸",NotLessLess:"≪̸",NotLessSlantEqual:"⩽̸",NotLessTilde:"≴",NotNestedGreaterGreater:"⪢̸",NotNestedLessLess:"⪡̸",NotPrecedes:"⊀",NotPrecedesEqual:"⪯̸",NotPrecedesSlantEqual:"⋠",NotReverseElement:"∌",NotRightTriangle:"⋫",NotRightTriangleBar:"⧐̸",NotRightTriangleEqual:"⋭",NotSquareSubset:"⊏̸",NotSquareSubsetEqual:"⋢",NotSquareSuperset:"⊐̸",NotSquareSupersetEqual:"⋣",NotSubset:"⊂⃒",NotSubsetEqual:"⊈",NotSucceeds:"⊁",NotSucceedsEqual:"⪰̸",NotSucceedsSlantEqual:"⋡",NotSucceedsTilde:"≿̸",NotSuperset:"⊃⃒",NotSupersetEqual:"⊉",NotTilde:"≁",NotTildeEqual:"≄",NotTildeFullEqual:"≇",NotTildeTilde:"≉",NotVerticalBar:"∤",Nscr:"𝒩",Ntilde:"Ñ",Nu:"Ν",OElig:"Œ",Oacute:"Ó",Ocirc:"Ô",Ocy:"О",Odblac:"Ő",Ofr:"𝔒",Ograve:"Ò",Omacr:"Ō",Omega:"Ω",Omicron:"Ο",Oopf:"𝕆",OpenCurlyDoubleQuote:"“",OpenCurlyQuote:"‘",Or:"⩔",Oscr:"𝒪",Oslash:"Ø",Otilde:"Õ",Otimes:"⨷",Ouml:"Ö",OverBar:"‾",OverBrace:"⏞",OverBracket:"⎴",OverParenthesis:"⏜",PartialD:"∂",Pcy:"П",Pfr:"𝔓",Phi:"Φ",Pi:"Π",PlusMinus:"±",Poincareplane:"ℌ",Popf:"ℙ",Pr:"⪻",Precedes:"≺",PrecedesEqual:"⪯",PrecedesSlantEqual:"≼",PrecedesTilde:"≾",Prime:"″",Product:"∏",Proportion:"∷",Proportional:"∝",Pscr:"𝒫",Psi:"Ψ",QUOT:\'"\',Qfr:"𝔔",Qopf:"ℚ",Qscr:"𝒬",RBarr:"⤐",REG:"®",Racute:"Ŕ",Rang:"⟫",Rarr:"↠",Rarrtl:"⤖",Rcaron:"Ř",Rcedil:"Ŗ",Rcy:"Р",Re:"ℜ",ReverseElement:"∋",ReverseEquilibrium:"⇋",ReverseUpEquilibrium:"⥯",Rfr:"ℜ",Rho:"Ρ",RightAngleBracket:"⟩",RightArrow:"→",RightArrowBar:"⇥",RightArrowLeftArrow:"⇄",RightCeiling:"⌉",RightDoubleBracket:"⟧",RightDownTeeVector:"⥝",RightDownVector:"⇂",RightDownVectorBar:"⥕",RightFloor:"⌋",RightTee:"⊢",RightTeeArrow:"↦",RightTeeVector:"⥛",RightTriangle:"⊳",RightTriangleBar:"⧐",RightTriangleEqual:"⊵",RightUpDownVector:"⥏",RightUpTeeVector:"⥜",RightUpVector:"↾",RightUpVectorBar:"⥔",RightVector:"⇀",RightVectorBar:"⥓",Rightarrow:"⇒",Ropf:"ℝ",RoundImplies:"⥰",Rrightarrow:"⇛",Rscr:"ℛ",Rsh:"↱",RuleDelayed:"⧴",SHCHcy:"Щ",SHcy:"Ш",SOFTcy:"Ь",Sacute:"Ś",Sc:"⪼",Scaron:"Š",Scedil:"Ş",Scirc:"Ŝ",Scy:"С",Sfr:"𝔖",ShortDownArrow:"↓",ShortLeftArrow:"←",ShortRightArrow:"→",ShortUpArrow:"↑",Sigma:"Σ",SmallCircle:"∘",Sopf:"𝕊",Sqrt:"√",Square:"□",SquareIntersection:"⊓",SquareSubset:"⊏",SquareSubsetEqual:"⊑",SquareSuperset:"⊐",SquareSupersetEqual:"⊒",SquareUnion:"⊔",Sscr:"𝒮",Star:"⋆",Sub:"⋐",Subset:"⋐",SubsetEqual:"⊆",Succeeds:"≻",SucceedsEqual:"⪰",SucceedsSlantEqual:"≽",SucceedsTilde:"≿",SuchThat:"∋",Sum:"∑",Sup:"⋑",Superset:"⊃",SupersetEqual:"⊇",Supset:"⋑",THORN:"Þ",TRADE:"™",TSHcy:"Ћ",TScy:"Ц",Tab:"	",Tau:"Τ",Tcaron:"Ť",Tcedil:"Ţ",Tcy:"Т",Tfr:"𝔗",Therefore:"∴",Theta:"Θ",ThickSpace:"  ",ThinSpace:" ",Tilde:"∼",TildeEqual:"≃",TildeFullEqual:"≅",TildeTilde:"≈",Topf:"𝕋",TripleDot:"⃛",Tscr:"𝒯",Tstrok:"Ŧ",Uacute:"Ú",Uarr:"↟",Uarrocir:"⥉",Ubrcy:"Ў",Ubreve:"Ŭ",Ucirc:"Û",Ucy:"У",Udblac:"Ű",Ufr:"𝔘",Ugrave:"Ù",Umacr:"Ū",UnderBar:"_",UnderBrace:"⏟",UnderBracket:"⎵",UnderParenthesis:"⏝",Union:"⋃",UnionPlus:"⊎",Uogon:"Ų",Uopf:"𝕌",UpArrow:"↑",UpArrowBar:"⤒",UpArrowDownArrow:"⇅",UpDownArrow:"↕",UpEquilibrium:"⥮",UpTee:"⊥",UpTeeArrow:"↥",Uparrow:"⇑",Updownarrow:"⇕",UpperLeftArrow:"↖",UpperRightArrow:"↗",Upsi:"ϒ",Upsilon:"Υ",Uring:"Ů",Uscr:"𝒰",Utilde:"Ũ",Uuml:"Ü",VDash:"⊫",Vbar:"⫫",Vcy:"В",Vdash:"⊩",Vdashl:"⫦",Vee:"⋁",Verbar:"‖",Vert:"‖",VerticalBar:"∣",VerticalLine:"|",VerticalSeparator:"❘",VerticalTilde:"≀",VeryThinSpace:" ",Vfr:"𝔙",Vopf:"𝕍",Vscr:"𝒱",Vvdash:"⊪",Wcirc:"Ŵ",Wedge:"⋀",Wfr:"𝔚",Wopf:"𝕎",Wscr:"𝒲",Xfr:"𝔛",Xi:"Ξ",Xopf:"𝕏",Xscr:"𝒳",YAcy:"Я",YIcy:"Ї",YUcy:"Ю",Yacute:"Ý",Ycirc:"Ŷ",Ycy:"Ы",Yfr:"𝔜",Yopf:"𝕐",Yscr:"𝒴",Yuml:"Ÿ",ZHcy:"Ж",Zacute:"Ź",Zcaron:"Ž",Zcy:"З",Zdot:"Ż",ZeroWidthSpace:"​",Zeta:"Ζ",Zfr:"ℨ",Zopf:"ℤ",Zscr:"𝒵",aacute:"á",abreve:"ă",ac:"∾",acE:"∾̳",acd:"∿",acirc:"â",acute:"´",acy:"а",aelig:"æ",af:"⁡",afr:"𝔞",agrave:"à",alefsym:"ℵ",aleph:"ℵ",alpha:"α",amacr:"ā",amalg:"⨿",amp:"&",and:"∧",andand:"⩕",andd:"⩜",andslope:"⩘",andv:"⩚",ang:"∠",ange:"⦤",angle:"∠",angmsd:"∡",angmsdaa:"⦨",angmsdab:"⦩",angmsdac:"⦪",angmsdad:"⦫",angmsdae:"⦬",angmsdaf:"⦭",angmsdag:"⦮",angmsdah:"⦯",angrt:"∟",angrtvb:"⊾",angrtvbd:"⦝",angsph:"∢",angst:"Å",angzarr:"⍼",aogon:"ą",aopf:"𝕒",ap:"≈",apE:"⩰",apacir:"⩯",ape:"≊",apid:"≋",apos:"\'",approx:"≈",approxeq:"≊",aring:"å",ascr:"𝒶",ast:"*",asymp:"≈",asympeq:"≍",atilde:"ã",auml:"ä",awconint:"∳",awint:"⨑",bNot:"⫭",backcong:"≌",backepsilon:"϶",backprime:"‵",backsim:"∽",backsimeq:"⋍",barvee:"⊽",barwed:"⌅",barwedge:"⌅",bbrk:"⎵",bbrktbrk:"⎶",bcong:"≌",bcy:"б",bdquo:"„",becaus:"∵",because:"∵",bemptyv:"⦰",bepsi:"϶",bernou:"ℬ",beta:"β",beth:"ℶ",between:"≬",bfr:"𝔟",bigcap:"⋂",bigcirc:"◯",bigcup:"⋃",bigodot:"⨀",bigoplus:"⨁",bigotimes:"⨂",bigsqcup:"⨆",bigstar:"★",bigtriangledown:"▽",bigtriangleup:"△",biguplus:"⨄",bigvee:"⋁",bigwedge:"⋀",bkarow:"⤍",blacklozenge:"⧫",blacksquare:"▪",blacktriangle:"▴",blacktriangledown:"▾",blacktriangleleft:"◂",blacktriangleright:"▸",blank:"␣",blk12:"▒",blk14:"░",blk34:"▓",block:"█",bne:"=⃥",bnequiv:"≡⃥",bnot:"⌐",bopf:"𝕓",bot:"⊥",bottom:"⊥",bowtie:"⋈",boxDL:"╗",boxDR:"╔",boxDl:"╖",boxDr:"╓",boxH:"═",boxHD:"╦",boxHU:"╩",boxHd:"╤",boxHu:"╧",boxUL:"╝",boxUR:"╚",boxUl:"╜",boxUr:"╙",boxV:"║",boxVH:"╬",boxVL:"╣",boxVR:"╠",boxVh:"╫",boxVl:"╢",boxVr:"╟",boxbox:"⧉",boxdL:"╕",boxdR:"╒",boxdl:"┐",boxdr:"┌",boxh:"─",boxhD:"╥",boxhU:"╨",boxhd:"┬",boxhu:"┴",boxminus:"⊟",boxplus:"⊞",boxtimes:"⊠",boxuL:"╛",boxuR:"╘",boxul:"┘",boxur:"└",boxv:"│",boxvH:"╪",boxvL:"╡",boxvR:"╞",boxvh:"┼",boxvl:"┤",boxvr:"├",bprime:"‵",breve:"˘",brvbar:"¦",bscr:"𝒷",bsemi:"⁏",bsim:"∽",bsime:"⋍",bsol:"\\\\",bsolb:"⧅",bsolhsub:"⟈",bull:"•",bullet:"•",bump:"≎",bumpE:"⪮",bumpe:"≏",bumpeq:"≏",cacute:"ć",cap:"∩",capand:"⩄",capbrcup:"⩉",capcap:"⩋",capcup:"⩇",capdot:"⩀",caps:"∩︀",caret:"⁁",caron:"ˇ",ccaps:"⩍",ccaron:"č",ccedil:"ç",ccirc:"ĉ",ccups:"⩌",ccupssm:"⩐",cdot:"ċ",cedil:"¸",cemptyv:"⦲",cent:"¢",centerdot:"·",cfr:"𝔠",chcy:"ч",check:"✓",checkmark:"✓",chi:"χ",cir:"○",cirE:"⧃",circ:"ˆ",circeq:"≗",circlearrowleft:"↺",circlearrowright:"↻",circledR:"®",circledS:"Ⓢ",circledast:"⊛",circledcirc:"⊚",circleddash:"⊝",cire:"≗",cirfnint:"⨐",cirmid:"⫯",cirscir:"⧂",clubs:"♣",clubsuit:"♣",colon:":",colone:"≔",coloneq:"≔",comma:",",commat:"@",comp:"∁",compfn:"∘",complement:"∁",complexes:"ℂ",cong:"≅",congdot:"⩭",conint:"∮",copf:"𝕔",coprod:"∐",copy:"©",copysr:"℗",crarr:"↵",cross:"✗",cscr:"𝒸",csub:"⫏",csube:"⫑",csup:"⫐",csupe:"⫒",ctdot:"⋯",cudarrl:"⤸",cudarrr:"⤵",cuepr:"⋞",cuesc:"⋟",cularr:"↶",cularrp:"⤽",cup:"∪",cupbrcap:"⩈",cupcap:"⩆",cupcup:"⩊",cupdot:"⊍",cupor:"⩅",cups:"∪︀",curarr:"↷",curarrm:"⤼",curlyeqprec:"⋞",curlyeqsucc:"⋟",curlyvee:"⋎",curlywedge:"⋏",curren:"¤",curvearrowleft:"↶",curvearrowright:"↷",cuvee:"⋎",cuwed:"⋏",cwconint:"∲",cwint:"∱",cylcty:"⌭",dArr:"⇓",dHar:"⥥",dagger:"†",daleth:"ℸ",darr:"↓",dash:"‐",dashv:"⊣",dbkarow:"⤏",dblac:"˝",dcaron:"ď",dcy:"д",dd:"ⅆ",ddagger:"‡",ddarr:"⇊",ddotseq:"⩷",deg:"°",delta:"δ",demptyv:"⦱",dfisht:"⥿",dfr:"𝔡",dharl:"⇃",dharr:"⇂",diam:"⋄",diamond:"⋄",diamondsuit:"♦",diams:"♦",die:"¨",digamma:"ϝ",disin:"⋲",div:"÷",divide:"÷",divideontimes:"⋇",divonx:"⋇",djcy:"ђ",dlcorn:"⌞",dlcrop:"⌍",dollar:"$",dopf:"𝕕",dot:"˙",doteq:"≐",doteqdot:"≑",dotminus:"∸",dotplus:"∔",dotsquare:"⊡",doublebarwedge:"⌆",downarrow:"↓",downdownarrows:"⇊",downharpoonleft:"⇃",downharpoonright:"⇂",drbkarow:"⤐",drcorn:"⌟",drcrop:"⌌",dscr:"𝒹",dscy:"ѕ",dsol:"⧶",dstrok:"đ",dtdot:"⋱",dtri:"▿",dtrif:"▾",duarr:"⇵",duhar:"⥯",dwangle:"⦦",dzcy:"џ",dzigrarr:"⟿",eDDot:"⩷",eDot:"≑",eacute:"é",easter:"⩮",ecaron:"ě",ecir:"≖",ecirc:"ê",ecolon:"≕",ecy:"э",edot:"ė",ee:"ⅇ",efDot:"≒",efr:"𝔢",eg:"⪚",egrave:"è",egs:"⪖",egsdot:"⪘",el:"⪙",elinters:"⏧",ell:"ℓ",els:"⪕",elsdot:"⪗",emacr:"ē",empty:"∅",emptyset:"∅",emptyv:"∅",emsp13:" ",emsp14:" ",emsp:" ",eng:"ŋ",ensp:" ",eogon:"ę",eopf:"𝕖",epar:"⋕",eparsl:"⧣",eplus:"⩱",epsi:"ε",epsilon:"ε",epsiv:"ϵ",eqcirc:"≖",eqcolon:"≕",eqsim:"≂",eqslantgtr:"⪖",eqslantless:"⪕",equals:"=",equest:"≟",equiv:"≡",equivDD:"⩸",eqvparsl:"⧥",erDot:"≓",erarr:"⥱",escr:"ℯ",esdot:"≐",esim:"≂",eta:"η",eth:"ð",euml:"ë",euro:"€",excl:"!",exist:"∃",expectation:"ℰ",exponentiale:"ⅇ",fallingdotseq:"≒",fcy:"ф",female:"♀",ffilig:"ﬃ",fflig:"ﬀ",ffllig:"ﬄ",ffr:"𝔣",filig:"ﬁ",fjlig:"fj",flat:"♭",fllig:"ﬂ",fltns:"▱",fnof:"ƒ",fopf:"𝕗",forall:"∀",fork:"⋔",forkv:"⫙",fpartint:"⨍",frac12:"½",frac13:"⅓",frac14:"¼",frac15:"⅕",frac16:"⅙",frac18:"⅛",frac23:"⅔",frac25:"⅖",frac34:"¾",frac35:"⅗",frac38:"⅜",frac45:"⅘",frac56:"⅚",frac58:"⅝",frac78:"⅞",frasl:"⁄",frown:"⌢",fscr:"𝒻",gE:"≧",gEl:"⪌",gacute:"ǵ",gamma:"γ",gammad:"ϝ",gap:"⪆",gbreve:"ğ",gcirc:"ĝ",gcy:"г",gdot:"ġ",ge:"≥",gel:"⋛",geq:"≥",geqq:"≧",geqslant:"⩾",ges:"⩾",gescc:"⪩",gesdot:"⪀",gesdoto:"⪂",gesdotol:"⪄",gesl:"⋛︀",gesles:"⪔",gfr:"𝔤",gg:"≫",ggg:"⋙",gimel:"ℷ",gjcy:"ѓ",gl:"≷",glE:"⪒",gla:"⪥",glj:"⪤",gnE:"≩",gnap:"⪊",gnapprox:"⪊",gne:"⪈",gneq:"⪈",gneqq:"≩",gnsim:"⋧",gopf:"𝕘",grave:"`",gscr:"ℊ",gsim:"≳",gsime:"⪎",gsiml:"⪐",gt:">",gtcc:"⪧",gtcir:"⩺",gtdot:"⋗",gtlPar:"⦕",gtquest:"⩼",gtrapprox:"⪆",gtrarr:"⥸",gtrdot:"⋗",gtreqless:"⋛",gtreqqless:"⪌",gtrless:"≷",gtrsim:"≳",gvertneqq:"≩︀",gvnE:"≩︀",hArr:"⇔",hairsp:" ",half:"½",hamilt:"ℋ",hardcy:"ъ",harr:"↔",harrcir:"⥈",harrw:"↭",hbar:"ℏ",hcirc:"ĥ",hearts:"♥",heartsuit:"♥",hellip:"…",hercon:"⊹",hfr:"𝔥",hksearow:"⤥",hkswarow:"⤦",hoarr:"⇿",homtht:"∻",hookleftarrow:"↩",hookrightarrow:"↪",hopf:"𝕙",horbar:"―",hscr:"𝒽",hslash:"ℏ",hstrok:"ħ",hybull:"⁃",hyphen:"‐",iacute:"í",ic:"⁣",icirc:"î",icy:"и",iecy:"е",iexcl:"¡",iff:"⇔",ifr:"𝔦",igrave:"ì",ii:"ⅈ",iiiint:"⨌",iiint:"∭",iinfin:"⧜",iiota:"℩",ijlig:"ĳ",imacr:"ī",image:"ℑ",imagline:"ℐ",imagpart:"ℑ",imath:"ı",imof:"⊷",imped:"Ƶ",in:"∈",incare:"℅",infin:"∞",infintie:"⧝",inodot:"ı",int:"∫",intcal:"⊺",integers:"ℤ",intercal:"⊺",intlarhk:"⨗",intprod:"⨼",iocy:"ё",iogon:"į",iopf:"𝕚",iota:"ι",iprod:"⨼",iquest:"¿",iscr:"𝒾",isin:"∈",isinE:"⋹",isindot:"⋵",isins:"⋴",isinsv:"⋳",isinv:"∈",it:"⁢",itilde:"ĩ",iukcy:"і",iuml:"ï",jcirc:"ĵ",jcy:"й",jfr:"𝔧",jmath:"ȷ",jopf:"𝕛",jscr:"𝒿",jsercy:"ј",jukcy:"є",kappa:"κ",kappav:"ϰ",kcedil:"ķ",kcy:"к",kfr:"𝔨",kgreen:"ĸ",khcy:"х",kjcy:"ќ",kopf:"𝕜",kscr:"𝓀",lAarr:"⇚",lArr:"⇐",lAtail:"⤛",lBarr:"⤎",lE:"≦",lEg:"⪋",lHar:"⥢",lacute:"ĺ",laemptyv:"⦴",lagran:"ℒ",lambda:"λ",lang:"⟨",langd:"⦑",langle:"⟨",lap:"⪅",laquo:"«",larr:"←",larrb:"⇤",larrbfs:"⤟",larrfs:"⤝",larrhk:"↩",larrlp:"↫",larrpl:"⤹",larrsim:"⥳",larrtl:"↢",lat:"⪫",latail:"⤙",late:"⪭",lates:"⪭︀",lbarr:"⤌",lbbrk:"❲",lbrace:"{",lbrack:"[",lbrke:"⦋",lbrksld:"⦏",lbrkslu:"⦍",lcaron:"ľ",lcedil:"ļ",lceil:"⌈",lcub:"{",lcy:"л",ldca:"⤶",ldquo:"“",ldquor:"„",ldrdhar:"⥧",ldrushar:"⥋",ldsh:"↲",le:"≤",leftarrow:"←",leftarrowtail:"↢",leftharpoondown:"↽",leftharpoonup:"↼",leftleftarrows:"⇇",leftrightarrow:"↔",leftrightarrows:"⇆",leftrightharpoons:"⇋",leftrightsquigarrow:"↭",leftthreetimes:"⋋",leg:"⋚",leq:"≤",leqq:"≦",leqslant:"⩽",les:"⩽",lescc:"⪨",lesdot:"⩿",lesdoto:"⪁",lesdotor:"⪃",lesg:"⋚︀",lesges:"⪓",lessapprox:"⪅",lessdot:"⋖",lesseqgtr:"⋚",lesseqqgtr:"⪋",lessgtr:"≶",lesssim:"≲",lfisht:"⥼",lfloor:"⌊",lfr:"𝔩",lg:"≶",lgE:"⪑",lhard:"↽",lharu:"↼",lharul:"⥪",lhblk:"▄",ljcy:"љ",ll:"≪",llarr:"⇇",llcorner:"⌞",llhard:"⥫",lltri:"◺",lmidot:"ŀ",lmoust:"⎰",lmoustache:"⎰",lnE:"≨",lnap:"⪉",lnapprox:"⪉",lne:"⪇",lneq:"⪇",lneqq:"≨",lnsim:"⋦",loang:"⟬",loarr:"⇽",lobrk:"⟦",longleftarrow:"⟵",longleftrightarrow:"⟷",longmapsto:"⟼",longrightarrow:"⟶",looparrowleft:"↫",looparrowright:"↬",lopar:"⦅",lopf:"𝕝",loplus:"⨭",lotimes:"⨴",lowast:"∗",lowbar:"_",loz:"◊",lozenge:"◊",lozf:"⧫",lpar:"(",lparlt:"⦓",lrarr:"⇆",lrcorner:"⌟",lrhar:"⇋",lrhard:"⥭",lrm:"‎",lrtri:"⊿",lsaquo:"‹",lscr:"𝓁",lsh:"↰",lsim:"≲",lsime:"⪍",lsimg:"⪏",lsqb:"[",lsquo:"‘",lsquor:"‚",lstrok:"ł",lt:"<",ltcc:"⪦",ltcir:"⩹",ltdot:"⋖",lthree:"⋋",ltimes:"⋉",ltlarr:"⥶",ltquest:"⩻",ltrPar:"⦖",ltri:"◃",ltrie:"⊴",ltrif:"◂",lurdshar:"⥊",luruhar:"⥦",lvertneqq:"≨︀",lvnE:"≨︀",mDDot:"∺",macr:"¯",male:"♂",malt:"✠",maltese:"✠",map:"↦",mapsto:"↦",mapstodown:"↧",mapstoleft:"↤",mapstoup:"↥",marker:"▮",mcomma:"⨩",mcy:"м",mdash:"—",measuredangle:"∡",mfr:"𝔪",mho:"℧",micro:"µ",mid:"∣",midast:"*",midcir:"⫰",middot:"·",minus:"−",minusb:"⊟",minusd:"∸",minusdu:"⨪",mlcp:"⫛",mldr:"…",mnplus:"∓",models:"⊧",mopf:"𝕞",mp:"∓",mscr:"𝓂",mstpos:"∾",mu:"μ",multimap:"⊸",mumap:"⊸",nGg:"⋙̸",nGt:"≫⃒",nGtv:"≫̸",nLeftarrow:"⇍",nLeftrightarrow:"⇎",nLl:"⋘̸",nLt:"≪⃒",nLtv:"≪̸",nRightarrow:"⇏",nVDash:"⊯",nVdash:"⊮",nabla:"∇",nacute:"ń",nang:"∠⃒",nap:"≉",napE:"⩰̸",napid:"≋̸",napos:"ŉ",napprox:"≉",natur:"♮",natural:"♮",naturals:"ℕ",nbsp:" ",nbump:"≎̸",nbumpe:"≏̸",ncap:"⩃",ncaron:"ň",ncedil:"ņ",ncong:"≇",ncongdot:"⩭̸",ncup:"⩂",ncy:"н",ndash:"–",ne:"≠",neArr:"⇗",nearhk:"⤤",nearr:"↗",nearrow:"↗",nedot:"≐̸",nequiv:"≢",nesear:"⤨",nesim:"≂̸",nexist:"∄",nexists:"∄",nfr:"𝔫",ngE:"≧̸",nge:"≱",ngeq:"≱",ngeqq:"≧̸",ngeqslant:"⩾̸",nges:"⩾̸",ngsim:"≵",ngt:"≯",ngtr:"≯",nhArr:"⇎",nharr:"↮",nhpar:"⫲",ni:"∋",nis:"⋼",nisd:"⋺",niv:"∋",njcy:"њ",nlArr:"⇍",nlE:"≦̸",nlarr:"↚",nldr:"‥",nle:"≰",nleftarrow:"↚",nleftrightarrow:"↮",nleq:"≰",nleqq:"≦̸",nleqslant:"⩽̸",nles:"⩽̸",nless:"≮",nlsim:"≴",nlt:"≮",nltri:"⋪",nltrie:"⋬",nmid:"∤",nopf:"𝕟",not:"¬",notin:"∉",notinE:"⋹̸",notindot:"⋵̸",notinva:"∉",notinvb:"⋷",notinvc:"⋶",notni:"∌",notniva:"∌",notnivb:"⋾",notnivc:"⋽",npar:"∦",nparallel:"∦",nparsl:"⫽⃥",npart:"∂̸",npolint:"⨔",npr:"⊀",nprcue:"⋠",npre:"⪯̸",nprec:"⊀",npreceq:"⪯̸",nrArr:"⇏",nrarr:"↛",nrarrc:"⤳̸",nrarrw:"↝̸",nrightarrow:"↛",nrtri:"⋫",nrtrie:"⋭",nsc:"⊁",nsccue:"⋡",nsce:"⪰̸",nscr:"𝓃",nshortmid:"∤",nshortparallel:"∦",nsim:"≁",nsime:"≄",nsimeq:"≄",nsmid:"∤",nspar:"∦",nsqsube:"⋢",nsqsupe:"⋣",nsub:"⊄",nsubE:"⫅̸",nsube:"⊈",nsubset:"⊂⃒",nsubseteq:"⊈",nsubseteqq:"⫅̸",nsucc:"⊁",nsucceq:"⪰̸",nsup:"⊅",nsupE:"⫆̸",nsupe:"⊉",nsupset:"⊃⃒",nsupseteq:"⊉",nsupseteqq:"⫆̸",ntgl:"≹",ntilde:"ñ",ntlg:"≸",ntriangleleft:"⋪",ntrianglelefteq:"⋬",ntriangleright:"⋫",ntrianglerighteq:"⋭",nu:"ν",num:"#",numero:"№",numsp:" ",nvDash:"⊭",nvHarr:"⤄",nvap:"≍⃒",nvdash:"⊬",nvge:"≥⃒",nvgt:">⃒",nvinfin:"⧞",nvlArr:"⤂",nvle:"≤⃒",nvlt:"<⃒",nvltrie:"⊴⃒",nvrArr:"⤃",nvrtrie:"⊵⃒",nvsim:"∼⃒",nwArr:"⇖",nwarhk:"⤣",nwarr:"↖",nwarrow:"↖",nwnear:"⤧",oS:"Ⓢ",oacute:"ó",oast:"⊛",ocir:"⊚",ocirc:"ô",ocy:"о",odash:"⊝",odblac:"ő",odiv:"⨸",odot:"⊙",odsold:"⦼",oelig:"œ",ofcir:"⦿",ofr:"𝔬",ogon:"˛",ograve:"ò",ogt:"⧁",ohbar:"⦵",ohm:"Ω",oint:"∮",olarr:"↺",olcir:"⦾",olcross:"⦻",oline:"‾",olt:"⧀",omacr:"ō",omega:"ω",omicron:"ο",omid:"⦶",ominus:"⊖",oopf:"𝕠",opar:"⦷",operp:"⦹",oplus:"⊕",or:"∨",orarr:"↻",ord:"⩝",order:"ℴ",orderof:"ℴ",ordf:"ª",ordm:"º",origof:"⊶",oror:"⩖",orslope:"⩗",orv:"⩛",oscr:"ℴ",oslash:"ø",osol:"⊘",otilde:"õ",otimes:"⊗",otimesas:"⨶",ouml:"ö",ovbar:"⌽",par:"∥",para:"¶",parallel:"∥",parsim:"⫳",parsl:"⫽",part:"∂",pcy:"п",percnt:"%",period:".",permil:"‰",perp:"⊥",pertenk:"‱",pfr:"𝔭",phi:"φ",phiv:"ϕ",phmmat:"ℳ",phone:"☎",pi:"π",pitchfork:"⋔",piv:"ϖ",planck:"ℏ",planckh:"ℎ",plankv:"ℏ",plus:"+",plusacir:"⨣",plusb:"⊞",pluscir:"⨢",plusdo:"∔",plusdu:"⨥",pluse:"⩲",plusmn:"±",plussim:"⨦",plustwo:"⨧",pm:"±",pointint:"⨕",popf:"𝕡",pound:"£",pr:"≺",prE:"⪳",prap:"⪷",prcue:"≼",pre:"⪯",prec:"≺",precapprox:"⪷",preccurlyeq:"≼",preceq:"⪯",precnapprox:"⪹",precneqq:"⪵",precnsim:"⋨",precsim:"≾",prime:"′",primes:"ℙ",prnE:"⪵",prnap:"⪹",prnsim:"⋨",prod:"∏",profalar:"⌮",profline:"⌒",profsurf:"⌓",prop:"∝",propto:"∝",prsim:"≾",prurel:"⊰",pscr:"𝓅",psi:"ψ",puncsp:" ",qfr:"𝔮",qint:"⨌",qopf:"𝕢",qprime:"⁗",qscr:"𝓆",quaternions:"ℍ",quatint:"⨖",quest:"?",questeq:"≟",quot:\'"\',rAarr:"⇛",rArr:"⇒",rAtail:"⤜",rBarr:"⤏",rHar:"⥤",race:"∽̱",racute:"ŕ",radic:"√",raemptyv:"⦳",rang:"⟩",rangd:"⦒",range:"⦥",rangle:"⟩",raquo:"»",rarr:"→",rarrap:"⥵",rarrb:"⇥",rarrbfs:"⤠",rarrc:"⤳",rarrfs:"⤞",rarrhk:"↪",rarrlp:"↬",rarrpl:"⥅",rarrsim:"⥴",rarrtl:"↣",rarrw:"↝",ratail:"⤚",ratio:"∶",rationals:"ℚ",rbarr:"⤍",rbbrk:"❳",rbrace:"}",rbrack:"]",rbrke:"⦌",rbrksld:"⦎",rbrkslu:"⦐",rcaron:"ř",rcedil:"ŗ",rceil:"⌉",rcub:"}",rcy:"р",rdca:"⤷",rdldhar:"⥩",rdquo:"”",rdquor:"”",rdsh:"↳",real:"ℜ",realine:"ℛ",realpart:"ℜ",reals:"ℝ",rect:"▭",reg:"®",rfisht:"⥽",rfloor:"⌋",rfr:"𝔯",rhard:"⇁",rharu:"⇀",rharul:"⥬",rho:"ρ",rhov:"ϱ",rightarrow:"→",rightarrowtail:"↣",rightharpoondown:"⇁",rightharpoonup:"⇀",rightleftarrows:"⇄",rightleftharpoons:"⇌",rightrightarrows:"⇉",rightsquigarrow:"↝",rightthreetimes:"⋌",ring:"˚",risingdotseq:"≓",rlarr:"⇄",rlhar:"⇌",rlm:"‏",rmoust:"⎱",rmoustache:"⎱",rnmid:"⫮",roang:"⟭",roarr:"⇾",robrk:"⟧",ropar:"⦆",ropf:"𝕣",roplus:"⨮",rotimes:"⨵",rpar:")",rpargt:"⦔",rppolint:"⨒",rrarr:"⇉",rsaquo:"›",rscr:"𝓇",rsh:"↱",rsqb:"]",rsquo:"’",rsquor:"’",rthree:"⋌",rtimes:"⋊",rtri:"▹",rtrie:"⊵",rtrif:"▸",rtriltri:"⧎",ruluhar:"⥨",rx:"℞",sacute:"ś",sbquo:"‚",sc:"≻",scE:"⪴",scap:"⪸",scaron:"š",sccue:"≽",sce:"⪰",scedil:"ş",scirc:"ŝ",scnE:"⪶",scnap:"⪺",scnsim:"⋩",scpolint:"⨓",scsim:"≿",scy:"с",sdot:"⋅",sdotb:"⊡",sdote:"⩦",seArr:"⇘",searhk:"⤥",searr:"↘",searrow:"↘",sect:"§",semi:";",seswar:"⤩",setminus:"∖",setmn:"∖",sext:"✶",sfr:"𝔰",sfrown:"⌢",sharp:"♯",shchcy:"щ",shcy:"ш",shortmid:"∣",shortparallel:"∥",shy:"­",sigma:"σ",sigmaf:"ς",sigmav:"ς",sim:"∼",simdot:"⩪",sime:"≃",simeq:"≃",simg:"⪞",simgE:"⪠",siml:"⪝",simlE:"⪟",simne:"≆",simplus:"⨤",simrarr:"⥲",slarr:"←",smallsetminus:"∖",smashp:"⨳",smeparsl:"⧤",smid:"∣",smile:"⌣",smt:"⪪",smte:"⪬",smtes:"⪬︀",softcy:"ь",sol:"/",solb:"⧄",solbar:"⌿",sopf:"𝕤",spades:"♠",spadesuit:"♠",spar:"∥",sqcap:"⊓",sqcaps:"⊓︀",sqcup:"⊔",sqcups:"⊔︀",sqsub:"⊏",sqsube:"⊑",sqsubset:"⊏",sqsubseteq:"⊑",sqsup:"⊐",sqsupe:"⊒",sqsupset:"⊐",sqsupseteq:"⊒",squ:"□",square:"□",squarf:"▪",squf:"▪",srarr:"→",sscr:"𝓈",ssetmn:"∖",ssmile:"⌣",sstarf:"⋆",star:"☆",starf:"★",straightepsilon:"ϵ",straightphi:"ϕ",strns:"¯",sub:"⊂",subE:"⫅",subdot:"⪽",sube:"⊆",subedot:"⫃",submult:"⫁",subnE:"⫋",subne:"⊊",subplus:"⪿",subrarr:"⥹",subset:"⊂",subseteq:"⊆",subseteqq:"⫅",subsetneq:"⊊",subsetneqq:"⫋",subsim:"⫇",subsub:"⫕",subsup:"⫓",succ:"≻",succapprox:"⪸",succcurlyeq:"≽",succeq:"⪰",succnapprox:"⪺",succneqq:"⪶",succnsim:"⋩",succsim:"≿",sum:"∑",sung:"♪",sup1:"¹",sup2:"²",sup3:"³",sup:"⊃",supE:"⫆",supdot:"⪾",supdsub:"⫘",supe:"⊇",supedot:"⫄",suphsol:"⟉",suphsub:"⫗",suplarr:"⥻",supmult:"⫂",supnE:"⫌",supne:"⊋",supplus:"⫀",supset:"⊃",supseteq:"⊇",supseteqq:"⫆",supsetneq:"⊋",supsetneqq:"⫌",supsim:"⫈",supsub:"⫔",supsup:"⫖",swArr:"⇙",swarhk:"⤦",swarr:"↙",swarrow:"↙",swnwar:"⤪",szlig:"ß",target:"⌖",tau:"τ",tbrk:"⎴",tcaron:"ť",tcedil:"ţ",tcy:"т",tdot:"⃛",telrec:"⌕",tfr:"𝔱",there4:"∴",therefore:"∴",theta:"θ",thetasym:"ϑ",thetav:"ϑ",thickapprox:"≈",thicksim:"∼",thinsp:" ",thkap:"≈",thksim:"∼",thorn:"þ",tilde:"˜",times:"×",timesb:"⊠",timesbar:"⨱",timesd:"⨰",tint:"∭",toea:"⤨",top:"⊤",topbot:"⌶",topcir:"⫱",topf:"𝕥",topfork:"⫚",tosa:"⤩",tprime:"‴",trade:"™",triangle:"▵",triangledown:"▿",triangleleft:"◃",trianglelefteq:"⊴",triangleq:"≜",triangleright:"▹",trianglerighteq:"⊵",tridot:"◬",trie:"≜",triminus:"⨺",triplus:"⨹",trisb:"⧍",tritime:"⨻",trpezium:"⏢",tscr:"𝓉",tscy:"ц",tshcy:"ћ",tstrok:"ŧ",twixt:"≬",twoheadleftarrow:"↞",twoheadrightarrow:"↠",uArr:"⇑",uHar:"⥣",uacute:"ú",uarr:"↑",ubrcy:"ў",ubreve:"ŭ",ucirc:"û",ucy:"у",udarr:"⇅",udblac:"ű",udhar:"⥮",ufisht:"⥾",ufr:"𝔲",ugrave:"ù",uharl:"↿",uharr:"↾",uhblk:"▀",ulcorn:"⌜",ulcorner:"⌜",ulcrop:"⌏",ultri:"◸",umacr:"ū",uml:"¨",uogon:"ų",uopf:"𝕦",uparrow:"↑",updownarrow:"↕",upharpoonleft:"↿",upharpoonright:"↾",uplus:"⊎",upsi:"υ",upsih:"ϒ",upsilon:"υ",upuparrows:"⇈",urcorn:"⌝",urcorner:"⌝",urcrop:"⌎",uring:"ů",urtri:"◹",uscr:"𝓊",utdot:"⋰",utilde:"ũ",utri:"▵",utrif:"▴",uuarr:"⇈",uuml:"ü",uwangle:"⦧",vArr:"⇕",vBar:"⫨",vBarv:"⫩",vDash:"⊨",vangrt:"⦜",varepsilon:"ϵ",varkappa:"ϰ",varnothing:"∅",varphi:"ϕ",varpi:"ϖ",varpropto:"∝",varr:"↕",varrho:"ϱ",varsigma:"ς",varsubsetneq:"⊊︀",varsubsetneqq:"⫋︀",varsupsetneq:"⊋︀",varsupsetneqq:"⫌︀",vartheta:"ϑ",vartriangleleft:"⊲",vartriangleright:"⊳",vcy:"в",vdash:"⊢",vee:"∨",veebar:"⊻",veeeq:"≚",vellip:"⋮",verbar:"|",vert:"|",vfr:"𝔳",vltri:"⊲",vnsub:"⊂⃒",vnsup:"⊃⃒",vopf:"𝕧",vprop:"∝",vrtri:"⊳",vscr:"𝓋",vsubnE:"⫋︀",vsubne:"⊊︀",vsupnE:"⫌︀",vsupne:"⊋︀",vzigzag:"⦚",wcirc:"ŵ",wedbar:"⩟",wedge:"∧",wedgeq:"≙",weierp:"℘",wfr:"𝔴",wopf:"𝕨",wp:"℘",wr:"≀",wreath:"≀",wscr:"𝓌",xcap:"⋂",xcirc:"◯",xcup:"⋃",xdtri:"▽",xfr:"𝔵",xhArr:"⟺",xharr:"⟷",xi:"ξ",xlArr:"⟸",xlarr:"⟵",xmap:"⟼",xnis:"⋻",xodot:"⨀",xopf:"𝕩",xoplus:"⨁",xotime:"⨂",xrArr:"⟹",xrarr:"⟶",xscr:"𝓍",xsqcup:"⨆",xuplus:"⨄",xutri:"△",xvee:"⋁",xwedge:"⋀",yacute:"ý",yacy:"я",ycirc:"ŷ",ycy:"ы",yen:"¥",yfr:"𝔶",yicy:"ї",yopf:"𝕪",yscr:"𝓎",yucy:"ю",yuml:"ÿ",zacute:"ź",zcaron:"ž",zcy:"з",zdot:"ż",zeetrf:"ℨ",zeta:"ζ",zfr:"𝔷",zhcy:"ж",zigrarr:"⇝",zopf:"𝕫",zscr:"𝓏",zwj:"‍",zwnj:"‌"},own={}.hasOwnProperty;function decodeNamedCharacterReference(D){return own.call(characterEntities,D)?characterEntities[D]:!1}function decodeNumericCharacterReference(D,E){const F=Number.parseInt(D,E);return F<9||F===11||F>13&&F<32||F>126&&F<160||F>55295&&F<57344||F>64975&&F<65008||(F&65535)===65535||(F&65535)===65534||F>1114111?"�":String.fromCodePoint(F)}const characterEscapeOrReference=/\\\\([!-/:-@[-`{-~])|&(#(?:\\d{1,7}|x[\\da-f]{1,6})|[\\da-z]{1,31});/gi;function decodeString(D){return D.replace(characterEscapeOrReference,decode)}function decode(D,E,F){if(E)return E;if(F.charCodeAt(0)===35){const $e=F.charCodeAt(1),_t=$e===120||$e===88;return decodeNumericCharacterReference(F.slice(_t?2:1),_t?16:10)}return decodeNamedCharacterReference(F)||D}function association(D){return D.label||!D.identifier?D.label||"":decodeString(D.identifier)}function compilePattern(D){if(!D._compiled){const E=(D.atBreak?"[\\\\r\\\\n][\\\\t ]*":"")+(D.before?"(?:"+D.before+")":"");D._compiled=new RegExp((E?"("+E+")":"")+(/[|\\\\{}()[\\]^$+*?.-]/.test(D.character)?"\\\\":"")+D.character+(D.after?"(?:"+D.after+")":""),"g")}return D._compiled}function containerPhrasing(D,E,F){const J=E.indexStack,$e=D.children||[],_t=[];let lr=-1,mr=F.before,Or;J.push(-1);let Pr=E.createTracker(F);for(;++lr<$e.length;){const dn=$e[lr];let gi;if(J[J.length-1]=lr,lr+1<$e.length){let Hi=E.handle.handlers[$e[lr+1].type];Hi&&Hi.peek&&(Hi=Hi.peek),gi=Hi?Hi($e[lr+1],D,E,{before:"",after:"",...Pr.current()}).charAt(0):""}else gi=F.after;_t.length>0&&(mr==="\\r"||mr===`\n`)&&dn.type==="html"&&(_t[_t.length-1]=_t[_t.length-1].replace(/(\\r?\\n|\\r)$/," "),mr=" ",Pr=E.createTracker(F),Pr.move(_t.join("")));let qi=E.handle(dn,D,E,{...Pr.current(),after:gi,before:mr});Or&&Or===qi.slice(0,1)&&(qi=encodeCharacterReference(Or.charCodeAt(0))+qi.slice(1));const zi=E.attentionEncodeSurroundingInfo;E.attentionEncodeSurroundingInfo=void 0,Or=void 0,zi&&(_t.length>0&&zi.before&&mr===_t[_t.length-1].slice(-1)&&(_t[_t.length-1]=_t[_t.length-1].slice(0,-1)+encodeCharacterReference(mr.charCodeAt(0))),zi.after&&(Or=gi)),Pr.move(qi),_t.push(qi),mr=qi.slice(-1)}return J.pop(),_t.join("")}function containerFlow(D,E,F){const J=E.indexStack,$e=D.children||[],_t=E.createTracker(F),lr=[];let mr=-1;for(J.push(-1);++mr<$e.length;){const Or=$e[mr];J[J.length-1]=mr,lr.push(_t.move(E.handle(Or,D,E,{before:`\n`,after:`\n`,..._t.current()}))),Or.type!=="list"&&(E.bulletLastUsed=void 0),mr<$e.length-1&&lr.push(_t.move(between(Or,$e[mr+1],D,E)))}return J.pop(),lr.join("")}function between(D,E,F,J){let $e=J.join.length;for(;$e--;){const _t=J.join[$e](D,E,F,J);if(_t===!0||_t===1)break;if(typeof _t=="number")return`\n`.repeat(1+_t);if(_t===!1)return`\n\n<!---->\n\n`}return`\n\n`}const eol=/\\r?\\n|\\r/g;function indentLines(D,E){const F=[];let J=0,$e=0,_t;for(;_t=eol.exec(D);)lr(D.slice(J,_t.index)),F.push(_t[0]),J=_t.index+_t[0].length,$e++;return lr(D.slice(J)),F.join("");function lr(mr){F.push(E(mr,$e,!mr))}}function safe(D,E,F){const J=(F.before||"")+(E||"")+(F.after||""),$e=[],_t=[],lr={};let mr=-1;for(;++mr<D.unsafe.length;){const dn=D.unsafe[mr];if(!patternInScope(D.stack,dn))continue;const gi=D.compilePattern(dn);let qi;for(;qi=gi.exec(J);){const zi="before"in dn||!!dn.atBreak,Hi="after"in dn,Qi=qi.index+(zi?qi[1].length:0);$e.includes(Qi)?(lr[Qi].before&&!zi&&(lr[Qi].before=!1),lr[Qi].after&&!Hi&&(lr[Qi].after=!1)):($e.push(Qi),lr[Qi]={before:zi,after:Hi})}}$e.sort(numerical);let Or=F.before?F.before.length:0;const Pr=J.length-(F.after?F.after.length:0);for(mr=-1;++mr<$e.length;){const dn=$e[mr];dn<Or||dn>=Pr||dn+1<Pr&&$e[mr+1]===dn+1&&lr[dn].after&&!lr[dn+1].before&&!lr[dn+1].after||$e[mr-1]===dn-1&&lr[dn].before&&!lr[dn-1].before&&!lr[dn-1].after||(Or!==dn&&_t.push(escapeBackslashes(J.slice(Or,dn),"\\\\")),Or=dn,/[!-/:-@[-`{-~]/.test(J.charAt(dn))&&(!F.encode||!F.encode.includes(J.charAt(dn)))?_t.push("\\\\"):(_t.push(encodeCharacterReference(J.charCodeAt(dn))),Or++))}return _t.push(escapeBackslashes(J.slice(Or,Pr),F.after)),_t.join("")}function numerical(D,E){return D-E}function escapeBackslashes(D,E){const F=/\\\\(?=[!-/:-@[-`{-~])/g,J=[],$e=[],_t=D+E;let lr=-1,mr=0,Or;for(;Or=F.exec(_t);)J.push(Or.index);for(;++lr<J.length;)mr!==J[lr]&&$e.push(D.slice(mr,J[lr])),$e.push("\\\\"),mr=J[lr];return $e.push(D.slice(mr)),$e.join("")}function track(D){const E=D||{},F=E.now||{};let J=E.lineShift||0,$e=F.line||1,_t=F.column||1;return{move:Or,current:lr,shift:mr};function lr(){return{now:{line:$e,column:_t},lineShift:J}}function mr(Pr){J+=Pr}function Or(Pr){const dn=Pr||"",gi=dn.split(/\\r?\\n|\\r/g),qi=gi[gi.length-1];return $e+=gi.length-1,_t=gi.length===1?_t+qi.length:1+qi.length+J,dn}}function toMarkdown(D,E){const F={},J={associationId:association,containerPhrasing:containerPhrasingBound,containerFlow:containerFlowBound,createTracker:track,compilePattern,enter:_t,handlers:{...handle},handle:void 0,indentLines,indexStack:[],join:[...join$1],options:{},safe:safeBound,stack:[],unsafe:[...unsafe]};configure(J,F),J.options.tightDefinitions&&J.join.push(joinDefinition),J.handle=zwitch("type",{invalid,unknown,handlers:J.handlers});let $e=J.handle(D,void 0,J,{before:`\n`,after:`\n`,now:{line:1,column:1},lineShift:0});return $e&&$e.charCodeAt($e.length-1)!==10&&$e.charCodeAt($e.length-1)!==13&&($e+=`\n`),$e;function _t(lr){return J.stack.push(lr),mr;function mr(){J.stack.pop()}}}function invalid(D){throw new Error("Cannot handle value `"+D+"`, expected node")}function unknown(D){const E=D;throw new Error("Cannot handle unknown node `"+E.type+"`")}function joinDefinition(D,E){if(D.type==="definition"&&D.type===E.type)return 0}function containerPhrasingBound(D,E){return containerPhrasing(D,this,E)}function containerFlowBound(D,E){return containerFlow(D,this,E)}function safeBound(D,E){return safe(this,D,E)}function condenseBlankPars(D){let E=null;return D.flatMap((F,J)=>F.type==="paragraph"&&E?.type==="paragraph"&&toString$2(F.children).trim()===""&&toString$2(E.children).trim()===""?[]:(E=F,[F]))}function trimLeadingWhitespace(D,E){const{tabWidth:F=4,omitFirstLine:J=!1}=E??{},$e=D.split(`\n`),lr=$e.flatMap(Or=>Or.length===0?[]:Or.match(/^(\\s*)/)?.[0]??"").map(Or=>Or.split("").reduce((Pr,dn)=>Pr+(dn==="	"?F:1),0)),mr=Math.min(...J?lr.slice(1):lr);return $e.map(Or=>trimLine(Or,mr,F)).join(`\n`)}function trimLine(D,E,F){let[J,$e,_t]=D.match(/^(\\s*)(.*)/)??["","",""];return $e=$e.replace(/\\t/g," ".repeat(F)),$e.slice(E)+_t}function sum$1(D){let E=0;for(const F of D)typeof F=="number"&&(E+=F);return E}const DIVISIONS=["part","chapter","section","subsection","subsubsection","paragraphs","example","aside"];function doenetToMarkdown(D){const E=typeof D=="string"?new DoenetSourceObject(D):D,F=E.dast;let J=condenseBlankPars(doenetToMdast(F,E));J=J.flatMap((_t,lr)=>{const mr=J[lr+1];return _t.type==="heading"&&mr?.type==="heading"?[_t,{type:"paragraph",children:[{type:"text",value:`\n\n`}]}]:_t.type==="heading"&&mr?.type!=="paragraph"?[_t,{type:"paragraph",children:[{type:"text",value:`\n\n`}]}]:[_t]});let $e=toMarkdown({type:"root",children:J});return $e=$e.replace(/^&#x20;/gm,""),$e=$e.trim()+`\n`,$e}function textContent(D){switch(D.type){case"cdata":return D.value;case"comment":case"doctype":case"instruction":case"error":return"";case"function":case"macro":return toXml(D);case"root":case"element":return D.children.map(textContent).join("");case"text":return D.value}return""}function doenetToMdast(D,E){function F(J){return J.flatMap($e=>doenetToMdast($e,E))}switch(D.type){case"cdata":return[{type:"text",value:D.value}];case"comment":case"doctype":case"instruction":case"error":return[];case"function":case"macro":return[{type:"inlineCode",value:toXml(D)}];case"root":return D.children.flatMap(J=>doenetToMdast(J,E));case"element":switch(D.name){case"graph":return[{type:"code",lang:"doenet",value:trimLeadingWhitespace(toXml(D),{tabWidth:2,omitFirstLine:!0})}];case"codeEditor":return[{type:"code",lang:"doenet",value:trimLeadingWhitespace(toXml(D.children).trim(),{tabWidth:2,omitFirstLine:!0})}];case"tag":return[{type:"inlineCode",value:`<${textContent(D)}>`}];case"c":return[{type:"inlineCode",value:textContent(D)}];case"ol":return[{type:"list",ordered:!0,children:F(D.children).filter(J=>J.type==="listItem")}];case"li":return[{type:"listItem",children:F(D.children)}];case"m":case"math":return[{type:"text",value:`$${textContent(D)}$`}];case"p":return[{type:"paragraph",children:F(D.children)}];case"title":{const J=sum$1(E.getParents(D).map($e=>$e.type==="element"&&DIVISIONS.includes($e.name)?1:0));return[{type:"heading",depth:clampToHeadingNumber(J),children:F(D.children)}]}}return F(D.children);case"text":return D.value.trim()===""?[]:E.getParents(D).some($e=>$e.type==="element"&&$e.name==="p")?[{type:"text",value:D.value}]:[{type:"paragraph",children:[{type:"text",value:D.value}]}]}return[]}function clampToHeadingNumber(D){return Math.min(6,Math.max(1,Math.round(D)))}const COMPLETION_TYPES={component:"component",referenceProperty:"refproperty",closeTag:"closetag",snippet:"snippet",attributeName:"enum",attributeValue:"value",reference:"reference"};new Map(Object.entries(browserExports.CompletionItemKind).filter(([,D])=>typeof D=="number").map(([D,E])=>[E,D]));var commonjsGlobal=typeof globalThis<"u"?globalThis:typeof window<"u"?window:typeof global<"u"?global:typeof self<"u"?self:{};function getDefaultExportFromCjs(D){return D&&D.__esModule&&Object.prototype.hasOwnProperty.call(D,"default")?D.default:D}var colorName$1,hasRequiredColorName;function requireColorName(){return hasRequiredColorName||(hasRequiredColorName=1,colorName$1={aliceblue:[240,248,255],antiquewhite:[250,235,215],aqua:[0,255,255],aquamarine:[127,255,212],azure:[240,255,255],beige:[245,245,220],bisque:[255,228,196],black:[0,0,0],blanchedalmond:[255,235,205],blue:[0,0,255],blueviolet:[138,43,226],brown:[165,42,42],burlywood:[222,184,135],cadetblue:[95,158,160],chartreuse:[127,255,0],chocolate:[210,105,30],coral:[255,127,80],cornflowerblue:[100,149,237],cornsilk:[255,248,220],crimson:[220,20,60],cyan:[0,255,255],darkblue:[0,0,139],darkcyan:[0,139,139],darkgoldenrod:[184,134,11],darkgray:[169,169,169],darkgreen:[0,100,0],darkgrey:[169,169,169],darkkhaki:[189,183,107],darkmagenta:[139,0,139],darkolivegreen:[85,107,47],darkorange:[255,140,0],darkorchid:[153,50,204],darkred:[139,0,0],darksalmon:[233,150,122],darkseagreen:[143,188,143],darkslateblue:[72,61,139],darkslategray:[47,79,79],darkslategrey:[47,79,79],darkturquoise:[0,206,209],darkviolet:[148,0,211],deeppink:[255,20,147],deepskyblue:[0,191,255],dimgray:[105,105,105],dimgrey:[105,105,105],dodgerblue:[30,144,255],firebrick:[178,34,34],floralwhite:[255,250,240],forestgreen:[34,139,34],fuchsia:[255,0,255],gainsboro:[220,220,220],ghostwhite:[248,248,255],gold:[255,215,0],goldenrod:[218,165,32],gray:[128,128,128],green:[0,128,0],greenyellow:[173,255,47],grey:[128,128,128],honeydew:[240,255,240],hotpink:[255,105,180],indianred:[205,92,92],indigo:[75,0,130],ivory:[255,255,240],khaki:[240,230,140],lavender:[230,230,250],lavenderblush:[255,240,245],lawngreen:[124,252,0],lemonchiffon:[255,250,205],lightblue:[173,216,230],lightcoral:[240,128,128],lightcyan:[224,255,255],lightgoldenrodyellow:[250,250,210],lightgray:[211,211,211],lightgreen:[144,238,144],lightgrey:[211,211,211],lightpink:[255,182,193],lightsalmon:[255,160,122],lightseagreen:[32,178,170],lightskyblue:[135,206,250],lightslategray:[119,136,153],lightslategrey:[119,136,153],lightsteelblue:[176,196,222],lightyellow:[255,255,224],lime:[0,255,0],limegreen:[50,205,50],linen:[250,240,230],magenta:[255,0,255],maroon:[128,0,0],mediumaquamarine:[102,205,170],mediumblue:[0,0,205],mediumorchid:[186,85,211],mediumpurple:[147,112,219],mediumseagreen:[60,179,113],mediumslateblue:[123,104,238],mediumspringgreen:[0,250,154],mediumturquoise:[72,209,204],mediumvioletred:[199,21,133],midnightblue:[25,25,112],mintcream:[245,255,250],mistyrose:[255,228,225],moccasin:[255,228,181],navajowhite:[255,222,173],navy:[0,0,128],oldlace:[253,245,230],olive:[128,128,0],olivedrab:[107,142,35],orange:[255,165,0],orangered:[255,69,0],orchid:[218,112,214],palegoldenrod:[238,232,170],palegreen:[152,251,152],paleturquoise:[175,238,238],palevioletred:[219,112,147],papayawhip:[255,239,213],peachpuff:[255,218,185],peru:[205,133,63],pink:[255,192,203],plum:[221,160,221],powderblue:[176,224,230],purple:[128,0,128],rebeccapurple:[102,51,153],red:[255,0,0],rosybrown:[188,143,143],royalblue:[65,105,225],saddlebrown:[139,69,19],salmon:[250,128,114],sandybrown:[244,164,96],seagreen:[46,139,87],seashell:[255,245,238],sienna:[160,82,45],silver:[192,192,192],skyblue:[135,206,235],slateblue:[106,90,205],slategray:[112,128,144],slategrey:[112,128,144],snow:[255,250,250],springgreen:[0,255,127],steelblue:[70,130,180],tan:[210,180,140],teal:[0,128,128],thistle:[216,191,216],tomato:[255,99,71],turquoise:[64,224,208],violet:[238,130,238],wheat:[245,222,179],white:[255,255,255],whitesmoke:[245,245,245],yellow:[255,255,0],yellowgreen:[154,205,50]}),colorName$1}var colorNameExports=requireColorName();const colorName=getDefaultExportFromCjs(colorNameExports);var nearestColor$2={exports:{}},nearestColor$1=nearestColor$2.exports,hasRequiredNearestColor;function requireNearestColor(){return hasRequiredNearestColor||(hasRequiredNearestColor=1,(function(D){(function(E){function F(Pr,dn){if(Pr=$e(Pr),!Pr)return null;var gi,qi=1/0,zi,Hi;dn||(dn=F.DEFAULT_COLORS);for(var Qi=0;Qi<dn.length;++Qi)zi=dn[Qi].rgb,gi=Math.pow(Pr.r-zi.r,2)+Math.pow(Pr.g-zi.g,2)+Math.pow(Pr.b-zi.b,2),gi<qi&&(qi=gi,Hi=dn[Qi]);return Hi.name?{name:Hi.name,value:Hi.source,rgb:Hi.rgb,distance:Math.sqrt(qi)}:Hi.source}F.from=function Pr(dn){var gi=J(dn),qi=F,zi=function(Qi){return qi(Qi,gi)};return zi.from=Pr,zi.or=function(Qi){var Gi=gi.concat(J(Qi));return F.from(Gi)},zi};function J(Pr){return Pr instanceof Array?Pr.map(function(dn){return _t(dn)}):Object.keys(Pr).map(function(dn){return _t(Pr[dn],dn)})}function $e(Pr){var dn,gi,qi;if(typeof Pr=="object")return Pr;if(Pr in F.STANDARD_COLORS)return $e(F.STANDARD_COLORS[Pr]);var zi=Pr.match(/^#?((?:[0-9a-f]{3}){1,2})$/i);if(zi)return zi=zi[1],zi.length===3?zi=[zi.charAt(0)+zi.charAt(0),zi.charAt(1)+zi.charAt(1),zi.charAt(2)+zi.charAt(2)]:zi=[zi.substring(0,2),zi.substring(2,4),zi.substring(4,6)],dn=parseInt(zi[0],16),gi=parseInt(zi[1],16),qi=parseInt(zi[2],16),{r:dn,g:gi,b:qi};var Hi=Pr.match(/^rgb\\(\\s*(\\d{1,3}%?),\\s*(\\d{1,3}%?),\\s*(\\d{1,3}%?)\\s*\\)$/i);if(Hi)return dn=lr(Hi[1]),gi=lr(Hi[2]),qi=lr(Hi[3]),{r:dn,g:gi,b:qi};throw Error(\'"\'+Pr+\'" is not a valid color\')}function _t(Pr,dn){var gi={};if(dn&&(gi.name=dn),typeof Pr=="string")gi.source=Pr,gi.rgb=$e(Pr);else if(typeof Pr=="object"){if(Pr.source)return _t(Pr.source,Pr.name);gi.rgb=Pr,gi.source=mr(Pr)}return gi}function lr(Pr){return Pr.charAt(Pr.length-1)==="%"?Math.round(parseInt(Pr,10)*255/100):Number(Pr)}function mr(Pr){return"#"+Or(Pr.r.toString(16))+Or(Pr.g.toString(16))+Or(Pr.b.toString(16))}function Or(Pr){return Pr.length===1&&(Pr="0"+Pr),Pr}F.STANDARD_COLORS={aqua:"#0ff",black:"#000",blue:"#00f",fuchsia:"#f0f",gray:"#808080",green:"#008000",lime:"#0f0",maroon:"#800000",navy:"#000080",olive:"#808000",orange:"#ffa500",purple:"#800080",red:"#f00",silver:"#c0c0c0",teal:"#008080",white:"#fff",yellow:"#ff0"},F.DEFAULT_COLORS=J(["#f00","#f80","#ff0","#0f0","#00f","#008","#808"]),F.VERSION="0.4.4",D&&D.exports?D.exports=F:E.nearestColor=F})(nearestColor$1)})(nearestColor$2)),nearestColor$2.exports}var nearestColorExports=requireNearestColor();const nearestColor=getDefaultExportFromCjs(nearestColorExports),canonicalColorHexByKey={black:"#000000",white:"#ffffff",gray:"#808080",red:"#ff0000",orange:"#ffa500",yellow:"#ffff00",green:"#008000",cyan:"#00ffff",blue:"#0000ff",purple:"#800080",pink:"#ffc0cb",brown:"#a52a2a"},canonicalAnchorDefinitions=Object.fromEntries(Object.entries(canonicalColorHexByKey).map(([D,E])=>[D,{hex:E,canonical:D}])),extraAnchorDefinitions={silver:{hex:"#c0c0c0",canonical:"gray"},grayDark:{hex:"#4d4d4d",canonical:"gray"},grayCustom:{hex:"#757575",canonical:"gray"},grayLight:{hex:"#c8c8c8",canonical:"gray"},grayLighter:{hex:"#dcdcdc",canonical:"gray"},maroon:{hex:"#800000",canonical:"red"},redLight:{hex:"#f08080",canonical:"red"},redCustom:{hex:"#D4042D",canonical:"red"},redDark:{hex:"#8b0000",canonical:"red"},orangeLight:{hex:"#ffa07a",canonical:"orange"},orangeCustom:{hex:"#F19143",canonical:"orange"},orangePresetAccessible:{hex:"#a6510c",canonical:"orange"},orangeDark:{hex:"#ff8c00",canonical:"orange"},yellowLight:{hex:"#ffffe0",canonical:"yellow"},yellowDark:{hex:"#bdb76b",canonical:"yellow"},yellowgreen:{hex:"#9acd32",canonical:"green"},olive:{hex:"#808000",canonical:"green"},lime:{hex:"#00ff00",canonical:"green"},greenLight:{hex:"#90ee90",canonical:"green"},greenCustom:{hex:"#2ca02c",canonical:"green"},greenDark:{hex:"#006400",canonical:"green"},teal:{hex:"#008080",canonical:"green"},aqua:{hex:"#00ffff",canonical:"cyan"},cyanLight:{hex:"#e0ffff",canonical:"cyan"},cyanDark:{hex:"#008b8b",canonical:"cyan"},navy:{hex:"#000080",canonical:"blue"},blueCustom:{hex:"#648FFF",canonical:"blue"},bluePresetAccessible:{hex:"#1f5dff",canonical:"blue"},blueLight:{hex:"#add8e6",canonical:"blue"},blueDark:{hex:"#00008b",canonical:"blue"},fuchsia:{hex:"#ff00ff",canonical:"purple"},purpleCustom:{hex:"#644CD6",canonical:"purple"},purpleLight:{hex:"#dda0dd",canonical:"purple"},purpleDark:{hex:"#8b008b",canonical:"purple"},hotpink:{hex:"#ff69b4",canonical:"pink"},pinkDark:{hex:"#ff1493",canonical:"pink"},brownLight:{hex:"#deb887",canonical:"brown"},brownDark:{hex:"#8b4513",canonical:"brown"}},anchorDefinitions={...canonicalAnchorDefinitions,...extraAnchorDefinitions},matchColorHexByName=Object.fromEntries(Object.entries(anchorDefinitions).map(([D,E])=>[D,E.hex])),canonicalKeyByMatchName=Object.fromEntries(Object.entries(anchorDefinitions).map(([D,E])=>[D,E.canonical])),nearestCanonicalColor=nearestColor.from(matchColorHexByName),cssNamedColorSet=new Set([...Object.keys(colorName),"transparent","currentcolor"]);function isCssNamedColorKeyword(D){return cssNamedColorSet.has(D.trim().toLowerCase())}function resolveColorWord(D,E={}){const F=E.preserveCssNamedColor??!0,J=E.invalidFallback??"original",$e=D.trim();if($e.length===0)return{englishWord:"",localizedWord:"",source:"invalid"};if(F&&isCssNamedColorKeyword($e)){const lr=`cssColor.${$e.toLowerCase()}`,mr=$e,Or=E.translate?E.translate(lr,mr):mr;return{key:lr,englishWord:mr,localizedWord:Or,source:"named-css"}}try{const _t=nearestCanonicalColor($e),lr=_t?canonicalKeyByMatchName[_t.name]:void 0;if(!lr)throw Error("No nearest canonical color resolved");const mr=`color.${lr}`,Or=lr,Pr=E.translate?E.translate(mr,Or):Or;return{key:mr,englishWord:Or,localizedWord:Pr,source:"nearest-palette"}}catch{const lr=J==="empty"?"":$e;return{englishWord:lr,localizedWord:lr,source:"invalid"}}}function colorValueToWord(D,E={}){return resolveColorWord(D,E).localizedWord}function isStyleValueWithPosition(D){return typeof D=="object"&&D!==null&&"style"in D}function getStyleValueString(D,E){const F=D[E]?.style;return typeof F=="string"?F:void 0}function getStyleValueNumber(D,E){const F=D[E]?.style;return typeof F=="number"?F:void 0}function setStyleValue(D,E,F,J){D[E]={style:F,position:J}}function normalizeStyleDefinitionValues(D){const E={};for(const F in D){const J=F,$e=D[J];$e!==void 0&&(isStyleValueWithPosition($e)?setStyleValue(E,J,$e.style,$e.position):setStyleValue(E,J,$e))}return E}function normalizeStyleDefinitionsValues(D){const E={};for(const F in D)E[F]=normalizeStyleDefinitionValues(D[F]);return E}function unwrapStyleDefinition(D){const E={};for(const F in D){const J=F,$e=D[J]?.style;$e!==void 0&&(E[J]=$e)}return E}const DEFAULT_STYLE_VALUES={lineOpacity:.7,lineWidth:4,lineWidthWord:"thick",lineStyle:"solid",lineStyleWord:"",markerOpacity:.7,markerStyle:"circle",markerStyleWord:"point",markerSize:5,markerFilled:!0,fillOpacity:.3,fillPatternOpacity:1,fillStyle:"solid",fillStyleWord:"",lineColor:"#1f5dff",lineColorDarkMode:"#648FFF",markerColor:"#1f5dff",markerColorDarkMode:"#648FFF",fillColor:"#1f5dff",fillColorDarkMode:"#648FFF",textColor:"black",textColorDarkMode:"white",highContrastColor:"#2963FF",highContrastColorDarkMode:"#92B4FF"},RESOLVED_STYLE_FALLBACKS={...DEFAULT_STYLE_VALUES,lineColorWord:"",lineColorWordDarkMode:"",markerColorWord:"",markerColorWordDarkMode:"",fillColorWord:"",fillColorWordDarkMode:"",textColorWord:"",textColorWordDarkMode:"",highContrastColorWord:"",highContrastColorWordDarkMode:"",backgroundColor:"",backgroundColorWord:"",backgroundColorDarkMode:"",backgroundColorWordDarkMode:""};function resolveStyleDefinition(D){const E={...RESOLVED_STYLE_FALLBACKS},F=E;for(const J of Object.keys(RESOLVED_STYLE_FALLBACKS)){const $e=D[J];$e!==void 0&&(F[J]=$e)}return E}var r={grad:.9,turn:360,rad:360/(2*Math.PI)},t$1=function(D){return typeof D=="string"?D.length>0:typeof D=="number"},n=function(D,E,F){return E===void 0&&(E=0),F===void 0&&(F=Math.pow(10,E)),Math.round(F*D)/F+0},e$1=function(D,E,F){return E===void 0&&(E=0),F===void 0&&(F=1),D>F?F:D>E?D:E},u=function(D){return(D=isFinite(D)?D%360:0)>0?D:D+360},a=function(D){return{r:e$1(D.r,0,255),g:e$1(D.g,0,255),b:e$1(D.b,0,255),a:e$1(D.a)}},o$1=function(D){return{r:n(D.r),g:n(D.g),b:n(D.b),a:n(D.a,3)}},i=/^#([0-9a-f]{3,8})$/i,s=function(D){var E=D.toString(16);return E.length<2?"0"+E:E},h=function(D){var E=D.r,F=D.g,J=D.b,$e=D.a,_t=Math.max(E,F,J),lr=_t-Math.min(E,F,J),mr=lr?_t===E?(F-J)/lr:_t===F?2+(J-E)/lr:4+(E-F)/lr:0;return{h:60*(mr<0?mr+6:mr),s:_t?lr/_t*100:0,v:_t/255*100,a:$e}},b=function(D){var E=D.h,F=D.s,J=D.v,$e=D.a;E=E/360*6,F/=100,J/=100;var _t=Math.floor(E),lr=J*(1-F),mr=J*(1-(E-_t)*F),Or=J*(1-(1-E+_t)*F),Pr=_t%6;return{r:255*[J,mr,lr,lr,Or,J][Pr],g:255*[Or,J,J,mr,lr,lr][Pr],b:255*[lr,lr,Or,J,J,mr][Pr],a:$e}},g=function(D){return{h:u(D.h),s:e$1(D.s,0,100),l:e$1(D.l,0,100),a:e$1(D.a)}},d=function(D){return{h:n(D.h),s:n(D.s),l:n(D.l),a:n(D.a,3)}},f$1=function(D){return b((F=(E=D).s,{h:E.h,s:(F*=((J=E.l)<50?J:100-J)/100)>0?2*F/(J+F)*100:0,v:J+F,a:E.a}));var E,F,J},c=function(D){return{h:(E=h(D)).h,s:($e=(200-(F=E.s))*(J=E.v)/100)>0&&$e<200?F*J/100/($e<=100?$e:200-$e)*100:0,l:$e/2,a:E.a};var E,F,J,$e},l=/^hsla?\\(\\s*([+-]?\\d*\\.?\\d+)(deg|rad|grad|turn)?\\s*,\\s*([+-]?\\d*\\.?\\d+)%\\s*,\\s*([+-]?\\d*\\.?\\d+)%\\s*(?:,\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*)?\\)$/i,p=/^hsla?\\(\\s*([+-]?\\d*\\.?\\d+)(deg|rad|grad|turn)?\\s+([+-]?\\d*\\.?\\d+)%\\s+([+-]?\\d*\\.?\\d+)%\\s*(?:\\/\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*)?\\)$/i,v=/^rgba?\\(\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*,\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*,\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*(?:,\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*)?\\)$/i,m=/^rgba?\\(\\s*([+-]?\\d*\\.?\\d+)(%)?\\s+([+-]?\\d*\\.?\\d+)(%)?\\s+([+-]?\\d*\\.?\\d+)(%)?\\s*(?:\\/\\s*([+-]?\\d*\\.?\\d+)(%)?\\s*)?\\)$/i,y={string:[[function(D){var E=i.exec(D);return E?(D=E[1]).length<=4?{r:parseInt(D[0]+D[0],16),g:parseInt(D[1]+D[1],16),b:parseInt(D[2]+D[2],16),a:D.length===4?n(parseInt(D[3]+D[3],16)/255,2):1}:D.length===6||D.length===8?{r:parseInt(D.substr(0,2),16),g:parseInt(D.substr(2,2),16),b:parseInt(D.substr(4,2),16),a:D.length===8?n(parseInt(D.substr(6,2),16)/255,2):1}:null:null},"hex"],[function(D){var E=v.exec(D)||m.exec(D);return E?E[2]!==E[4]||E[4]!==E[6]?null:a({r:Number(E[1])/(E[2]?100/255:1),g:Number(E[3])/(E[4]?100/255:1),b:Number(E[5])/(E[6]?100/255:1),a:E[7]===void 0?1:Number(E[7])/(E[8]?100:1)}):null},"rgb"],[function(D){var E=l.exec(D)||p.exec(D);if(!E)return null;var F,J,$e=g({h:(F=E[1],J=E[2],J===void 0&&(J="deg"),Number(F)*(r[J]||1)),s:Number(E[3]),l:Number(E[4]),a:E[5]===void 0?1:Number(E[5])/(E[6]?100:1)});return f$1($e)},"hsl"]],object:[[function(D){var E=D.r,F=D.g,J=D.b,$e=D.a,_t=$e===void 0?1:$e;return t$1(E)&&t$1(F)&&t$1(J)?a({r:Number(E),g:Number(F),b:Number(J),a:Number(_t)}):null},"rgb"],[function(D){var E=D.h,F=D.s,J=D.l,$e=D.a,_t=$e===void 0?1:$e;if(!t$1(E)||!t$1(F)||!t$1(J))return null;var lr=g({h:Number(E),s:Number(F),l:Number(J),a:Number(_t)});return f$1(lr)},"hsl"],[function(D){var E=D.h,F=D.s,J=D.v,$e=D.a,_t=$e===void 0?1:$e;if(!t$1(E)||!t$1(F)||!t$1(J))return null;var lr=(function(mr){return{h:u(mr.h),s:e$1(mr.s,0,100),v:e$1(mr.v,0,100),a:e$1(mr.a)}})({h:Number(E),s:Number(F),v:Number(J),a:Number(_t)});return b(lr)},"hsv"]]},N=function(D,E){for(var F=0;F<E.length;F++){var J=E[F][0](D);if(J)return[J,E[F][1]]}return[null,void 0]},x=function(D){return typeof D=="string"?N(D.trim(),y.string):typeof D=="object"&&D!==null?N(D,y.object):[null,void 0]},M=function(D,E){var F=c(D);return{h:F.h,s:e$1(F.s+100*E,0,100),l:F.l,a:F.a}},H=function(D){return(299*D.r+587*D.g+114*D.b)/1e3/255},$=function(D,E){var F=c(D);return{h:F.h,s:F.s,l:e$1(F.l+100*E,0,100),a:F.a}},j=(function(){function D(E){this.parsed=x(E)[0],this.rgba=this.parsed||{r:0,g:0,b:0,a:1}}return D.prototype.isValid=function(){return this.parsed!==null},D.prototype.brightness=function(){return n(H(this.rgba),2)},D.prototype.isDark=function(){return H(this.rgba)<.5},D.prototype.isLight=function(){return H(this.rgba)>=.5},D.prototype.toHex=function(){return E=o$1(this.rgba),F=E.r,J=E.g,$e=E.b,lr=(_t=E.a)<1?s(n(255*_t)):"","#"+s(F)+s(J)+s($e)+lr;var E,F,J,$e,_t,lr},D.prototype.toRgb=function(){return o$1(this.rgba)},D.prototype.toRgbString=function(){return E=o$1(this.rgba),F=E.r,J=E.g,$e=E.b,(_t=E.a)<1?"rgba("+F+", "+J+", "+$e+", "+_t+")":"rgb("+F+", "+J+", "+$e+")";var E,F,J,$e,_t},D.prototype.toHsl=function(){return d(c(this.rgba))},D.prototype.toHslString=function(){return E=d(c(this.rgba)),F=E.h,J=E.s,$e=E.l,(_t=E.a)<1?"hsla("+F+", "+J+"%, "+$e+"%, "+_t+")":"hsl("+F+", "+J+"%, "+$e+"%)";var E,F,J,$e,_t},D.prototype.toHsv=function(){return E=h(this.rgba),{h:n(E.h),s:n(E.s),v:n(E.v),a:n(E.a,3)};var E},D.prototype.invert=function(){return w({r:255-(E=this.rgba).r,g:255-E.g,b:255-E.b,a:E.a});var E},D.prototype.saturate=function(E){return E===void 0&&(E=.1),w(M(this.rgba,E))},D.prototype.desaturate=function(E){return E===void 0&&(E=.1),w(M(this.rgba,-E))},D.prototype.grayscale=function(){return w(M(this.rgba,-1))},D.prototype.lighten=function(E){return E===void 0&&(E=.1),w($(this.rgba,E))},D.prototype.darken=function(E){return E===void 0&&(E=.1),w($(this.rgba,-E))},D.prototype.rotate=function(E){return E===void 0&&(E=15),this.hue(this.hue()+E)},D.prototype.alpha=function(E){return typeof E=="number"?w({r:(F=this.rgba).r,g:F.g,b:F.b,a:E}):n(this.rgba.a,3);var F},D.prototype.hue=function(E){var F=c(this.rgba);return typeof E=="number"?w({h:E,s:F.s,l:F.l,a:F.a}):n(F.h)},D.prototype.isEqual=function(E){return this.toHex()===w(E).toHex()},D})(),w=function(D){return D instanceof j?D:new j(D)},S=[],k=function(D){D.forEach(function(E){S.indexOf(E)<0&&(E(j,y),S.push(E))})},o=function(D){var E=D/255;return E<.04045?E/12.92:Math.pow((E+.055)/1.055,2.4)},t=function(D){return .2126*o(D.r)+.7152*o(D.g)+.0722*o(D.b)};function a11yPlugin(D){D.prototype.luminance=function(){return E=t(this.rgba),(F=2)===void 0&&(F=0),J===void 0&&(J=Math.pow(10,F)),Math.round(J*E)/J+0;var E,F,J},D.prototype.contrast=function(E){E===void 0&&(E="#FFF");var F,J,$e,_t,lr,mr,Or,Pr=E instanceof D?E:new D(E);return _t=this.rgba,lr=Pr.toRgb(),mr=t(_t),Or=t(lr),F=mr>Or?(mr+.05)/(Or+.05):(Or+.05)/(mr+.05),(J=2)===void 0&&(J=0),$e===void 0&&($e=Math.pow(10,J)),Math.floor($e*F)/$e+0},D.prototype.isReadable=function(E,F){return E===void 0&&(E="#FFF"),F===void 0&&(F={}),this.contrast(E)>=(mr=(lr=(J=F).size)===void 0?"normal":lr,(_t=($e=J.level)===void 0?"AA":$e)==="AAA"&&mr==="normal"?7:_t==="AA"&&mr==="large"?3:4.5);var J,$e,_t,lr,mr}}function namesPlugin(D,E){var F={white:"#ffffff",bisque:"#ffe4c4",blue:"#0000ff",cadetblue:"#5f9ea0",chartreuse:"#7fff00",chocolate:"#d2691e",coral:"#ff7f50",antiquewhite:"#faebd7",aqua:"#00ffff",azure:"#f0ffff",whitesmoke:"#f5f5f5",papayawhip:"#ffefd5",plum:"#dda0dd",blanchedalmond:"#ffebcd",black:"#000000",gold:"#ffd700",goldenrod:"#daa520",gainsboro:"#dcdcdc",cornsilk:"#fff8dc",cornflowerblue:"#6495ed",burlywood:"#deb887",aquamarine:"#7fffd4",beige:"#f5f5dc",crimson:"#dc143c",cyan:"#00ffff",darkblue:"#00008b",darkcyan:"#008b8b",darkgoldenrod:"#b8860b",darkkhaki:"#bdb76b",darkgray:"#a9a9a9",darkgreen:"#006400",darkgrey:"#a9a9a9",peachpuff:"#ffdab9",darkmagenta:"#8b008b",darkred:"#8b0000",darkorchid:"#9932cc",darkorange:"#ff8c00",darkslateblue:"#483d8b",gray:"#808080",darkslategray:"#2f4f4f",darkslategrey:"#2f4f4f",deeppink:"#ff1493",deepskyblue:"#00bfff",wheat:"#f5deb3",firebrick:"#b22222",floralwhite:"#fffaf0",ghostwhite:"#f8f8ff",darkviolet:"#9400d3",magenta:"#ff00ff",green:"#008000",dodgerblue:"#1e90ff",grey:"#808080",honeydew:"#f0fff0",hotpink:"#ff69b4",blueviolet:"#8a2be2",forestgreen:"#228b22",lawngreen:"#7cfc00",indianred:"#cd5c5c",indigo:"#4b0082",fuchsia:"#ff00ff",brown:"#a52a2a",maroon:"#800000",mediumblue:"#0000cd",lightcoral:"#f08080",darkturquoise:"#00ced1",lightcyan:"#e0ffff",ivory:"#fffff0",lightyellow:"#ffffe0",lightsalmon:"#ffa07a",lightseagreen:"#20b2aa",linen:"#faf0e6",mediumaquamarine:"#66cdaa",lemonchiffon:"#fffacd",lime:"#00ff00",khaki:"#f0e68c",mediumseagreen:"#3cb371",limegreen:"#32cd32",mediumspringgreen:"#00fa9a",lightskyblue:"#87cefa",lightblue:"#add8e6",midnightblue:"#191970",lightpink:"#ffb6c1",mistyrose:"#ffe4e1",moccasin:"#ffe4b5",mintcream:"#f5fffa",lightslategray:"#778899",lightslategrey:"#778899",navajowhite:"#ffdead",navy:"#000080",mediumvioletred:"#c71585",powderblue:"#b0e0e6",palegoldenrod:"#eee8aa",oldlace:"#fdf5e6",paleturquoise:"#afeeee",mediumturquoise:"#48d1cc",mediumorchid:"#ba55d3",rebeccapurple:"#663399",lightsteelblue:"#b0c4de",mediumslateblue:"#7b68ee",thistle:"#d8bfd8",tan:"#d2b48c",orchid:"#da70d6",mediumpurple:"#9370db",purple:"#800080",pink:"#ffc0cb",skyblue:"#87ceeb",springgreen:"#00ff7f",palegreen:"#98fb98",red:"#ff0000",yellow:"#ffff00",slateblue:"#6a5acd",lavenderblush:"#fff0f5",peru:"#cd853f",palevioletred:"#db7093",violet:"#ee82ee",teal:"#008080",slategray:"#708090",slategrey:"#708090",aliceblue:"#f0f8ff",darkseagreen:"#8fbc8f",darkolivegreen:"#556b2f",greenyellow:"#adff2f",seagreen:"#2e8b57",seashell:"#fff5ee",tomato:"#ff6347",silver:"#c0c0c0",sienna:"#a0522d",lavender:"#e6e6fa",lightgreen:"#90ee90",orange:"#ffa500",orangered:"#ff4500",steelblue:"#4682b4",royalblue:"#4169e1",turquoise:"#40e0d0",yellowgreen:"#9acd32",salmon:"#fa8072",saddlebrown:"#8b4513",sandybrown:"#f4a460",rosybrown:"#bc8f8f",darksalmon:"#e9967a",lightgoldenrodyellow:"#fafad2",snow:"#fffafa",lightgrey:"#d3d3d3",lightgray:"#d3d3d3",dimgray:"#696969",dimgrey:"#696969",olivedrab:"#6b8e23",olive:"#808000"},J={};for(var $e in F)J[F[$e]]=$e;var _t={};D.prototype.toName=function(lr){if(!(this.rgba.a||this.rgba.r||this.rgba.g||this.rgba.b))return"transparent";var mr,Or,Pr=J[this.toHex()];if(Pr)return Pr;if(lr?.closest){var dn=this.toRgb(),gi=1/0,qi="black";if(!_t.length)for(var zi in F)_t[zi]=new D(F[zi]).toRgb();for(var Hi in F){var Qi=(mr=dn,Or=_t[Hi],Math.pow(mr.r-Or.r,2)+Math.pow(mr.g-Or.g,2)+Math.pow(mr.b-Or.b,2));Qi<gi&&(gi=Qi,qi=Hi)}return qi}},E.string.push([function(lr){var mr=lr.toLowerCase(),Or=mr==="transparent"?"#0000":F[mr];return Or?new D(Or).toRgb():null},"name"])}k([a11yPlugin,namesPlugin]);const CANVAS_DARK_MODE_COLOR="#121212",GRAPHIC_CONTRAST_THRESHOLD=3,TEXT_CONTRAST_THRESHOLD=4.5;function clamp01(D){return Number.isFinite(D)?D<0?0:D>1?1:D:1}function compositeOver(D,E){const F=clamp01(D.a);return{r:D.r*F+E.r*(1-F),g:D.g*F+E.g*(1-F),b:D.b*F+E.b*(1-F)}}function hexWithLightness(D,E){return w({...D,l:E}).toHex()}function compositedContrastRatio({foreground:D,canvas:E,background:F,opacityMultiplier:J=1}){const $e=w(D),_t=w(E);if(!$e.isValid()||!_t.isValid())return null;const lr=_t.toRgb(),mr={r:lr.r,g:lr.g,b:lr.b};let Or=mr;if(F!==void 0){const gi=w(F);if(!gi.isValid())return null;Or=compositeOver(gi.toRgb(),mr)}const Pr=$e.toRgb(),dn=compositeOver({...Pr,a:clamp01(Pr.a*J)},Or);return w(dn).contrast(w(Or))}function deriveAccessibleDarkModeColor({lightColor:D,threshold:E,opacityMultiplier:F=1}){const J=w(D);if(!J.isValid())return D;const $e=compositedContrastRatio({foreground:D,canvas:CANVAS_DARK_MODE_COLOR,opacityMultiplier:F});if($e!==null&&$e>=E)return D;const{h:_t,s:lr,l:mr,a:Or}=J.toHsl();for(let Pr=Math.ceil(mr);Pr<=100;Pr++){const dn=hexWithLightness({h:_t,s:lr,a:Or},Pr),gi=compositedContrastRatio({foreground:dn,canvas:CANVAS_DARK_MODE_COLOR,opacityMultiplier:F});if(gi!==null&&gi>=E)return dn}return hexWithLightness({h:_t,s:lr,a:Or},100)}function invertLightness(D){const E=w(D);if(!E.isValid())return D;const{h:F,s:J,l:$e,a:_t}=E.toHsl();return w({h:F,s:J,l:100-$e,a:_t}).toHex()}function deriveAccessibleDarkModeBackground(D){return invertLightness(D)}let styleAttributes={lineColor:{componentType:"text",description:"Color used for line strokes (light mode)."},lineColorWord:{componentType:"text",description:"Human-readable name of the line color (light mode)."},lineColorDarkMode:{componentType:"text",description:"Color used for line strokes (dark mode)."},lineColorWordDarkMode:{componentType:"text",description:"Human-readable name of the line color (dark mode)."},lineOpacity:{componentType:"number",description:"Opacity of line strokes, 0 to 1."},lineWidth:{componentType:"number",description:"Stroke width for lines, in pixels."},lineWidthWord:{componentType:"text",description:"Human-readable name of the line width."},lineStyle:{componentType:"text",description:"Stroke style for lines.",toLowerCase:!0,validValues:[{value:"solid",description:"Continuous, unbroken stroke."},{value:"dashed",description:"Stroke composed of evenly-spaced dashes."},{value:"dotted",description:"Stroke composed of evenly-spaced dots."}]},lineStyleWord:{componentType:"text",description:"Human-readable name of the line style."},markerColor:{componentType:"text",description:"Color used for markers/points (light mode)."},markerColorWord:{componentType:"text",description:"Human-readable name of the marker color (light mode)."},markerColorDarkMode:{componentType:"text",description:"Color used for markers/points (dark mode)."},markerColorWordDarkMode:{componentType:"text",description:"Human-readable name of the marker color (dark mode)."},markerOpacity:{componentType:"number",description:"Opacity of markers/points, 0 to 1."},markerStyle:{componentType:"text",description:"Marker shape.",toLowerCase:!0,validValues:[{value:"circle",description:"Circular marker."},{value:"square",description:"Square marker."},{value:"triangle",description:\'Triangular marker pointing up (alias for "triangleUp").\'},{value:"triangleUp",description:"Triangular marker pointing up."},{value:"triangleDown",description:"Triangular marker pointing down."},{value:"triangleLeft",description:"Triangular marker pointing left."},{value:"triangleRight",description:"Triangular marker pointing right."},{value:"diamond",description:"Diamond-shaped marker."},{value:"cross",description:"Cross-shaped marker (×)."},{value:"plus",description:"Plus-shaped marker (+)."}]},markerStyleWord:{componentType:"text",description:"Human-readable name of the marker style."},markerSize:{componentType:"number",description:"Marker size in pixels."},markerFilled:{componentType:"boolean",description:"Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior."},fillColor:{componentType:"text",description:"Fill color used inside closed shapes (light mode)."},fillColorWord:{componentType:"text",description:"Human-readable name of the fill color (light mode)."},fillColorDarkMode:{componentType:"text",description:"Fill color used inside closed shapes (dark mode)."},fillColorWordDarkMode:{componentType:"text",description:"Human-readable name of the fill color (dark mode)."},fillOpacity:{componentType:"number",description:"Opacity of solid fills, 0 to 1."},fillPatternOpacity:{componentType:"number",description:"Opacity of pattern fills (non-solid fillStyle), 0 to 1."},fillStyle:{componentType:"text",description:"Fill pattern used inside closed shapes.",toLowerCase:!0,validValues:[{value:"solid",description:"Solid fill."},{value:"horizontal",description:"Horizontal line pattern."},{value:"vertical",description:"Vertical line pattern."},{value:"diagonal",description:"Diagonal line pattern (/)."},{value:"backDiagonal",description:"Back-diagonal line pattern (\\\\)."},{value:"dots",description:"Dots pattern."},{value:"diamonds",description:"Filled diamonds pattern."}]},fillStyleWord:{componentType:"text",description:"Human-readable name of the fill style."},textColor:{componentType:"text",description:"Text color (light mode)."},textColorWord:{componentType:"text",description:"Human-readable name of the text color (light mode)."},textColorDarkMode:{componentType:"text",description:"Text color (dark mode)."},textColorWordDarkMode:{componentType:"text",description:"Human-readable name of the text color (dark mode)."},highContrastColor:{componentType:"text",description:"High-contrast accent color (light mode)."},highContrastColorWord:{componentType:"text",description:"Human-readable name of the high-contrast accent color (light mode)."},highContrastColorDarkMode:{componentType:"text",description:"High-contrast accent color (dark mode)."},highContrastColorWordDarkMode:{componentType:"text",description:"Human-readable name of the high-contrast accent color (dark mode)."},backgroundColor:{componentType:"text",description:"Background color (light mode)."},backgroundColorWord:{componentType:"text",description:"Human-readable name of the background color (light mode)."},backgroundColorDarkMode:{componentType:"text",description:"Background color (dark mode)."},backgroundColorWordDarkMode:{componentType:"text",description:"Human-readable name of the background color (dark mode)."}};styleAttributes.markerStyle.validValues.filter(D=>D.value!=="cross"&&D.value!=="plus");const MARKER_OVERRIDE_KEYS=["markerStyle","markerSize","markerFilled"],LINE_OVERRIDE_KEYS=["lineStyle","lineWidth"],FILL_OVERRIDE_KEYS=["fillOpacity","fillPatternOpacity","fillStyle"],markerOverrideAttributes=Object.fromEntries(MARKER_OVERRIDE_KEYS.map(D=>[D,styleAttributes[D]])),lineOverrideAttributes=Object.fromEntries(LINE_OVERRIDE_KEYS.map(D=>[D,styleAttributes[D]])),fillOverrideAttributes=Object.fromEntries(FILL_OVERRIDE_KEYS.map(D=>[D,styleAttributes[D]]));({...markerOverrideAttributes,...lineOverrideAttributes,...fillOverrideAttributes});const STYLE_OVERRIDE_CATEGORIES={marker:markerOverrideAttributes,line:lineOverrideAttributes,fill:fillOverrideAttributes};for(const[D,E]of Object.entries(STYLE_OVERRIDE_CATEGORIES))for(const[F,J]of Object.entries(E)){if(F.toLowerCase().includes("color"))throw new Error(`Style override category "${D}" contains color-related key "${F}"; colors stay <styleDefinition>-only so per-styleNumber WCAG contrast diagnostics remain authoritative. If this is intentional, also reconcile the lowercase asymmetry in returnSelectedStyleStateVariableDefinition.`);if(F.endsWith("Opacity")&&F!=="fillOpacity"&&F!=="fillPatternOpacity")throw new Error(`Style override category "${D}" contains contrast-feeding opacity key "${F}"; lineOpacity and markerOpacity feed the WCAG contrast diagnostic as an opacityMultiplier on the foreground alpha, so they stay <styleDefinition>-only alongside colors. Only fillOpacity and fillPatternOpacity are contrast-irrelevant and overridable.`);if(J.componentType==="text"&&!J.toLowerCase)throw new Error(`Style override key "${F}" in category "${D}" is text-typed but missing toLowerCase: true. Add toLowerCase: true to its styleAttributes entry, or move it out of the override surface.`)}const coloredItemsForWords=["line","marker","fill","text","highContrast","background"];function addMissingColorWordsToStyleDefinition(D){for(const E of coloredItemsForWords){const F=`${E}Color`,J=`${F}Word`,$e=`${F}DarkMode`,_t=`${J}DarkMode`,lr=getStyleValueString(D,F);!(J in D)&&lr&&setStyleValue(D,J,colorValueToWord(lr));const mr=getStyleValueString(D,$e);!(_t in D)&&mr&&setStyleValue(D,_t,colorValueToWord(mr))}return D}function addMissingColorWordsToStyleDefinitions(D){for(const E of Object.values(D))addMissingColorWordsToStyleDefinition(E);return D}function deriveDarkModeColorForItem(D,E,F){if(D==="background")return deriveAccessibleDarkModeBackground(E);if(D==="text")return invertLightness(E);if(D==="highContrast")return deriveAccessibleDarkModeColor({lightColor:E,threshold:TEXT_CONTRAST_THRESHOLD});if(D==="line"||D==="marker"){const J=`${D}Opacity`,$e=DEFAULT_STYLE_VALUES[J],_t=getStyleValueNumber(F,J)??$e??1;return deriveAccessibleDarkModeColor({lightColor:E,threshold:GRAPHIC_CONTRAST_THRESHOLD,opacityMultiplier:_t})}return deriveAccessibleDarkModeColor({lightColor:E,threshold:GRAPHIC_CONTRAST_THRESHOLD})}function addMissingChildStyleColorFields(D){for(const E of coloredItemsForWords)deriveMissingDarkModeColor(D,E);return addMissingColorWordsToStyleDefinition(D)}function deriveMissingDarkModeColor(D,E){const F=`${E}Color`,J=`${F}DarkMode`;if(!(F in D)||J in D)return;const $e=getStyleValueString(D,F);if($e===void 0)return;const _t=deriveDarkModeColorForItem(E,$e,D);setStyleValue(D,J,_t)}function deriveMissingStyleWords(D){if("lineWidth"in D&&!("lineWidthWord"in D)){const E=getStyleValueNumber(D,"lineWidth");if(E!==void 0){const F=D.lineWidth?.position,J=E>=4?"thick":E<=1?"thin":"";setStyleValue(D,"lineWidthWord",J,F)}}if("lineStyle"in D&&!("lineStyleWord"in D)){const E=getStyleValueString(D,"lineStyle");if(E){const F=D.lineStyle?.position;setStyleValue(D,"lineStyleWord",E==="dashed"?"dashed":E==="dotted"?"dotted":"",F)}}if("markerStyle"in D&&!("markerStyleWord"in D)){const E=getStyleValueString(D,"markerStyle"),F=D.markerStyle?.position;E&&setStyleValue(D,"markerStyleWord",E,F);const J=getStyleValueString(D,"markerStyleWord");J==="circle"?setStyleValue(D,"markerStyleWord","point",F):J&&J.slice(0,8)==="triangle"&&setStyleValue(D,"markerStyleWord","triangle",F)}if("fillStyle"in D&&!("fillStyleWord"in D)){const E=getStyleValueString(D,"fillStyle");if(E){const F=D.fillStyle?.position,$e={solid:"",horizontal:"horizontal lines",vertical:"vertical lines",diagonal:"diagonal lines",backdiagonal:"reverse diagonal lines",dots:"dots",diamonds:"diamonds"}[E]??"";setStyleValue(D,"fillStyleWord",$e,F)}}}function returnDefaultStyleDefinitions(){return addMissingColorWordsToStyleDefinitions(normalizeStyleDefinitionsValues({1:{...DEFAULT_STYLE_VALUES},2:{lineColor:"#D4042D",lineColorDarkMode:"#F1466A",lineOpacity:.7,lineWidth:2,lineWidthWord:"",lineStyle:"solid",lineStyleWord:"",markerColor:"#D4042D",markerColorDarkMode:"#F1466A",markerOpacity:.7,markerStyle:"square",markerStyleWord:"square",markerSize:5,fillColor:"#D4042D",fillColorDarkMode:"#F1466A",fillOpacity:.3,textColor:"#D4042D",textColorDarkMode:"#FF7A7A",highContrastColor:"#D4042D",highContrastColorDarkMode:"#FF7A7A"},3:{lineColor:"#a6510c",lineColorDarkMode:"#F19143",lineOpacity:.7,lineWidth:3,lineWidthWord:"",lineStyle:"solid",lineStyleWord:"",markerColor:"#a6510c",markerColorDarkMode:"#F19143",markerOpacity:.7,markerStyle:"triangle",markerStyleWord:"triangle",markerSize:5,fillColor:"#a6510c",fillColorDarkMode:"#F19143",fillOpacity:.3,textColor:"#BE5A0E",textColorDarkMode:"#FFA94D",highContrastColor:"#BE5A0E",highContrastColorDarkMode:"#FFA94D"},4:{lineColor:"#644CD6",lineColorDarkMode:"#9F8FE8",lineOpacity:.7,lineWidth:2,lineWidthWord:"",lineStyle:"solid",lineStyleWord:"",markerColor:"#644CD6",markerColorDarkMode:"#9F8FE8",markerOpacity:.7,markerStyle:"diamond",markerStyleWord:"diamond",markerSize:5,fillColor:"#644CD6",fillColorDarkMode:"#9F8FE8",fillOpacity:.3,textColor:"#644CD6",textColorDarkMode:"#B0A4EE",highContrastColor:"#644CD6",highContrastColorDarkMode:"#B0A4EE"},5:{lineColor:"black",lineColorDarkMode:"white",lineOpacity:1,lineWidth:1,lineWidthWord:"thin",lineStyle:"solid",lineStyleWord:"",markerColor:"black",markerColorDarkMode:"white",markerOpacity:1,markerStyle:"circle",markerStyleWord:"point",markerSize:5,fillColor:"black",fillColorDarkMode:"white",fillOpacity:.7,textColor:"black",textColorDarkMode:"white",highContrastColor:"black",highContrastColorDarkMode:"white"},6:{lineColor:"#636363",lineColorDarkMode:"#CCCCCC",lineOpacity:.7,lineWidth:1,lineWidthWord:"thin",lineStyle:"dotted",lineStyleWord:"dotted",markerColor:"#636363",markerColorDarkMode:"#CCCCCC",markerOpacity:.7,markerStyle:"circle",markerStyleWord:"point",markerSize:5,fillColor:"#636363",fillColorDarkMode:"#CCCCCC",fillOpacity:.3,textColor:"#757575",textColorDarkMode:"#B0B0B0",highContrastColor:"#757575",highContrastColorDarkMode:"#B0B0B0"}}))}var __create=Object.create,__defProp=Object.defineProperty,__getOwnPropDesc=Object.getOwnPropertyDescriptor,__getOwnPropNames=Object.getOwnPropertyNames,__getProtoOf=Object.getPrototypeOf,__hasOwnProp=Object.prototype.hasOwnProperty,__esmMin=(D,E)=>()=>(D&&(E=D(D=0)),E),__commonJSMin=(D,E)=>()=>(E||(D((E={exports:{}}).exports,E),D=null),E.exports),__exportAll=(D,E)=>{let F={};for(var J in D)__defProp(F,J,{get:D[J],enumerable:!0});return __defProp(F,Symbol.toStringTag,{value:"Module"}),F},__copyProps=(D,E,F,J)=>{if(E&&typeof E=="object"||typeof E=="function")for(var $e=__getOwnPropNames(E),_t=0,lr=$e.length,mr;_t<lr;_t++)mr=$e[_t],!__hasOwnProp.call(D,mr)&&mr!==F&&__defProp(D,mr,{get:(Or=>E[Or]).bind(null,mr),enumerable:!(J=__getOwnPropDesc(E,mr))||J.enumerable});return D},__toESM=(D,E,F)=>(F=D==null?{}:__create(__getProtoOf(D)),__copyProps(__defProp(F,"default",{value:D,enumerable:!0}),D)),__toCommonJS=D=>__hasOwnProp.call(D,"module.exports")?D["module.exports"]:__copyProps(__defProp({},"__esModule",{value:!0}),D),get_tree=function(D){if(D!=null)return D.tree===void 0?D:D.tree};function*subsets(D,E){var F=D.length;if(E===void 0&&(E=F),E!==0){for(let J=0;J<F;J++)yield[D[J]];if(E!==1)for(let J=0;J<F;J++){let $e=subsets(D.slice(J+1),E-1);for(let _t of $e)yield[D[J]].concat(_t)}}}var is_associative$1={"+":!0,"*":!0,and:!0,or:!0,union:!0,intersect:!0};function flatten$5(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(J=J.map(function(lr,mr){return flatten$5(lr)}),is_associative$1[F]){for(var $e=[],_t=0;_t<J.length;_t++)Array.isArray(J[_t])&&J[_t][0]===F&&J[_t].length>2?$e=$e.concat(J[_t].slice(1)):$e.push(J[_t]);J=$e}return[F].concat(J)}var unflattenRight=function(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(J=J.map(function(mr,Or){return unflattenRight(mr)}),J.length>2&&is_associative$1[F]){for(var $e=[F,J[0],void 0],_t=$e,lr=1;lr<J.length-1;lr++)_t[2]=[F,J[lr],void 0],_t=_t[2];return _t[2]=J[J.length-1],$e}return[F].concat(J)},unflattenLeft=function(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(J=J.map(function(mr,Or){return unflattenLeft(mr)}),J.length>2&&is_associative$1[F]){for(var $e=[F,void 0,J[J.length-1]],_t=$e,lr=J.length-2;lr>0;lr--)_t[1]=[F,void 0,J[lr]],_t=_t[1];return _t[1]=J[0],$e}return[F].concat(J)},allChildren=function(D){if(!Array.isArray(D))return[];var E=D[0],F=D.slice(1);return is_associative$1[E]?F.reduce(function(J,$e){return Array.isArray($e)&&$e[0]===E?J.concat(allChildren($e)):J.concat([$e])},[]):F};function _extends(){return _extends=Object.assign?Object.assign.bind():function(D){for(var E=1;E<arguments.length;E++){var F=arguments[E];for(var J in F)({}).hasOwnProperty.call(F,J)&&(D[J]=F[J])}return D},_extends.apply(null,arguments)}var DEFAULT_CONFIG={relTol:1e-12,absTol:1e-15,matrix:"Matrix",number:"number",numberFallback:"number",precision:64,predictable:!1,randomSeed:null,legacySubset:!1};function getSafeProperty(D,E){if(isSafeObjectProperty(D,E)||isSafeArrayProperty(D,E))return D[E];throw isSafeMethod(D,E)?Error(`Cannot access method "${E}" as a property`):D==null?TypeError(`Cannot access property "${E}": object is ${D}`):Error(\'No access to property "\'+E+\'"\')}function setSafeProperty(D,E,F){if(isSafeObjectProperty(D,E)||isSafeArrayProperty(D,E))return D[E]=F,F;throw Error(`No access to property "${E}"`)}function isSafeObjectProperty(D,E){return isPlainObject(D)?!(E in Object.prototype):!1}function isSafeArrayProperty(D,E){return Array.isArray(D)?typeof E=="number"||typeof E=="string"&&isInteger$1(E)||E==="length":!1}function isInteger$1(D){return/^\\d+$/.test(D)}function getSafeMethod(D,E){if(!isSafeMethod(D,E))throw Error(\'No access to method "\'+E+\'"\');return D[E]}function isSafeMethod(D,E){return D==null||typeof D[E]!="function"||hasOwnProperty$1(D,E)&&Object.getPrototypeOf&&E in Object.getPrototypeOf(D)?!1:safeNativeMethods.has(E)?!0:!(E in Object.prototype||E in Function.prototype)}function isPlainObject(D){return typeof D=="object"&&D&&D.constructor===Object}var safeNativeMethods=new Set(["toString","valueOf","toLocaleString"]),ObjectWrappingMap=class{constructor(D){this.wrappedObject=D,this[Symbol.iterator]=this.entries}keys(){return Object.keys(this.wrappedObject).filter(D=>this.has(D)).values()}get(D){return getSafeProperty(this.wrappedObject,D)}set(D,E){return setSafeProperty(this.wrappedObject,D,E),this}has(D){return isSafeObjectProperty(this.wrappedObject,D)&&D in this.wrappedObject}entries(){return mapIterator(this.keys(),D=>[D,this.get(D)])}forEach(D){for(var E of this.keys())D(this.get(E),E,this)}delete(D){isSafeObjectProperty(this.wrappedObject,D)&&delete this.wrappedObject[D]}clear(){for(var D of this.keys())this.delete(D)}get size(){return Object.keys(this.wrappedObject).length}},PartitionedMap=class{constructor(D,E,F){this.a=D,this.b=E,this.bKeys=F,this[Symbol.iterator]=this.entries}get(D){return this.bKeys.has(D)?this.b.get(D):this.a.get(D)}set(D,E){return this.bKeys.has(D)?this.b.set(D,E):this.a.set(D,E),this}has(D){return this.b.has(D)||this.a.has(D)}keys(){return new Set([...this.a.keys(),...this.b.keys()])[Symbol.iterator]()}entries(){return mapIterator(this.keys(),D=>[D,this.get(D)])}forEach(D){for(var E of this.keys())D(this.get(E),E,this)}delete(D){return this.bKeys.has(D)?this.b.delete(D):this.a.delete(D)}clear(){this.a.clear(),this.b.clear()}get size(){return[...this.keys()].length}};function mapIterator(D,E){return{next:()=>{var F=D.next();return F.done?F:{value:E(F.value),done:!1}}}}function createEmptyMap(){return new Map}function createMap$1(D){if(!D)return createEmptyMap();if(isMap(D))return D;if(isObject$1(D))return new ObjectWrappingMap(D);throw Error("createMap can create maps from objects or Maps")}function toObject(D){if(D instanceof ObjectWrappingMap)return D.wrappedObject;var E={};for(var F of D.keys())setSafeProperty(E,F,D.get(F));return E}function isNumber(D){return typeof D=="number"}function isBigNumber(D){return!D||typeof D!="object"||typeof D.constructor!="function"?!1:D.isBigNumber===!0&&typeof D.constructor.prototype=="object"&&D.constructor.prototype.isBigNumber===!0||typeof D.constructor.isDecimal=="function"&&D.constructor.isDecimal(D)===!0}function isBigInt(D){return typeof D=="bigint"}function isComplex(D){return D&&typeof D=="object"&&Object.getPrototypeOf(D).isComplex===!0||!1}function isFraction(D){return D&&typeof D=="object"&&Object.getPrototypeOf(D).isFraction===!0||!1}function isUnit(D){return D&&D.constructor.prototype.isUnit===!0||!1}function isString(D){return typeof D=="string"}var isArray=Array.isArray;function isMatrix(D){return D&&D.constructor.prototype.isMatrix===!0||!1}function isCollection(D){return Array.isArray(D)||isMatrix(D)}function isDenseMatrix(D){return D&&D.isDenseMatrix&&D.constructor.prototype.isMatrix===!0||!1}function isSparseMatrix(D){return D&&D.isSparseMatrix&&D.constructor.prototype.isMatrix===!0||!1}function isRange(D){return D&&D.constructor.prototype.isRange===!0||!1}function isIndex(D){return D&&D.constructor.prototype.isIndex===!0||!1}function isBoolean$1(D){return typeof D=="boolean"}function isResultSet(D){return D&&D.constructor.prototype.isResultSet===!0||!1}function isHelp(D){return D&&D.constructor.prototype.isHelp===!0||!1}function isFunction$1(D){return typeof D=="function"}function isDate(D){return D instanceof Date}function isRegExp(D){return D instanceof RegExp}function isObject$1(D){return!!(D&&typeof D=="object"&&D.constructor===Object&&!isComplex(D)&&!isFraction(D))}function isMap(D){return D?D instanceof Map||D instanceof ObjectWrappingMap||typeof D.set=="function"&&typeof D.get=="function"&&typeof D.keys=="function"&&typeof D.has=="function":!1}function isPartitionedMap(D){return isMap(D)&&isMap(D.a)&&isMap(D.b)}function isObjectWrappingMap(D){return isMap(D)&&isObject$1(D.wrappedObject)}function isNull$1(D){return D===null}function isUndefined$1(D){return D===void 0}function isAccessorNode(D){return D&&D.isAccessorNode===!0&&D.constructor.prototype.isNode===!0||!1}function isArrayNode(D){return D&&D.isArrayNode===!0&&D.constructor.prototype.isNode===!0||!1}function isAssignmentNode(D){return D&&D.isAssignmentNode===!0&&D.constructor.prototype.isNode===!0||!1}function isBlockNode(D){return D&&D.isBlockNode===!0&&D.constructor.prototype.isNode===!0||!1}function isConditionalNode(D){return D&&D.isConditionalNode===!0&&D.constructor.prototype.isNode===!0||!1}function isConstantNode(D){return D&&D.isConstantNode===!0&&D.constructor.prototype.isNode===!0||!1}function rule2Node(D){return isConstantNode(D)||isOperatorNode(D)&&D.args.length===1&&isConstantNode(D.args[0])&&"-+~".includes(D.op)}function isFunctionAssignmentNode(D){return D&&D.isFunctionAssignmentNode===!0&&D.constructor.prototype.isNode===!0||!1}function isFunctionNode(D){return D&&D.isFunctionNode===!0&&D.constructor.prototype.isNode===!0||!1}function isIndexNode(D){return D&&D.isIndexNode===!0&&D.constructor.prototype.isNode===!0||!1}function isNode(D){return D&&D.isNode===!0&&D.constructor.prototype.isNode===!0||!1}function isObjectNode(D){return D&&D.isObjectNode===!0&&D.constructor.prototype.isNode===!0||!1}function isOperatorNode(D){return D&&D.isOperatorNode===!0&&D.constructor.prototype.isNode===!0||!1}function isParenthesisNode(D){return D&&D.isParenthesisNode===!0&&D.constructor.prototype.isNode===!0||!1}function isRangeNode(D){return D&&D.isRangeNode===!0&&D.constructor.prototype.isNode===!0||!1}function isRelationalNode(D){return D&&D.isRelationalNode===!0&&D.constructor.prototype.isNode===!0||!1}function isSymbolNode(D){return D&&D.isSymbolNode===!0&&D.constructor.prototype.isNode===!0||!1}function isChain(D){return D&&D.constructor.prototype.isChain===!0||!1}function typeOf(D){var E=typeof D;return E==="object"?D===null?"null":isBigNumber(D)?"BigNumber":D.constructor&&D.constructor.name?D.constructor.name:"Object":E}function clone$3(D){var E=typeof D;if(E==="number"||E==="bigint"||E==="string"||E==="boolean"||D==null)return D;if(typeof D.clone=="function")return D.clone();if(Array.isArray(D))return D.map(function(F){return clone$3(F)});if(D instanceof Date)return new Date(D.valueOf());if(isBigNumber(D))return D;if(isObject$1(D))return mapObject$1(D,clone$3);if(E==="function")return D;throw TypeError(`Cannot clone: unknown type of value (value: ${D})`)}function mapObject$1(D,E){var F={};for(var J in D)hasOwnProperty$1(D,J)&&(F[J]=E(D[J]));return F}function extend$1(D,E){for(var F in E)hasOwnProperty$1(E,F)&&(D[F]=E[F]);return D}function deepExtend(D,E){if(Array.isArray(E))throw TypeError("Arrays are not supported by deepExtend");for(var F in E)if(hasOwnProperty$1(E,F)&&!(F in Object.prototype)&&!(F in Function.prototype))if(E[F]&&E[F].constructor===Object)D[F]===void 0&&(D[F]={}),D[F]&&D[F].constructor===Object?deepExtend(D[F],E[F]):D[F]=E[F];else{if(Array.isArray(E[F]))throw TypeError("Arrays are not supported by deepExtend");D[F]=E[F]}return D}function deepStrictEqual(D,E){var F,J,$e;if(Array.isArray(D)){if(!Array.isArray(E)||D.length!==E.length)return!1;for(J=0,$e=D.length;J<$e;J++)if(!deepStrictEqual(D[J],E[J]))return!1;return!0}else{if(typeof D=="function")return D===E;if(D instanceof Object){if(Array.isArray(E)||!(E instanceof Object))return!1;for(F in D)if(!(F in E)||!deepStrictEqual(D[F],E[F]))return!1;for(F in E)if(!(F in D))return!1;return!0}else return D===E}}function deepFlatten(D){var E={};return _deepFlatten(D,E),E}function _deepFlatten(D,E){for(var F in D)if(hasOwnProperty$1(D,F)){var J=D[F];typeof J=="object"&&J?_deepFlatten(J,E):E[F]=J}}function lazy(D,E,F){var J=!0,$e;Object.defineProperty(D,E,{get:function(){return J&&=($e=F(),!1),$e},set:function(_t){$e=_t,J=!1},configurable:!0,enumerable:!0})}function hasOwnProperty$1(D,E){return D&&Object.hasOwnProperty.call(D,E)}function isLegacyFactory(D){return D&&typeof D.factory=="function"}function pickShallow(D,E){for(var F={},J=0;J<E.length;J++){var $e=E[J],_t=D[$e];_t!==void 0&&(F[$e]=_t)}return F}var MATRIX_OPTIONS=["Matrix","Array"],NUMBER_OPTIONS=["number","BigNumber","bigint","Fraction"];function configFactory(D,E){function F(J){if(J){if(J.epsilon!==void 0){console.warn(\'Warning: The configuration option "epsilon" is deprecated. Use "relTol" and "absTol" instead.\');var $e=clone$3(J);return $e.relTol=J.epsilon,$e.absTol=J.epsilon*.001,delete $e.epsilon,F($e)}J.legacySubset===!0&&console.warn(\'Warning: The configuration option "legacySubset" is for compatibility only and might be deprecated in the future.\');var _t=clone$3(D);validateOption(J,"matrix",MATRIX_OPTIONS),validateOption(J,"number",NUMBER_OPTIONS),deepExtend(D,J);var lr=clone$3(D);return E("config",lr,_t,clone$3(J)),lr}else return clone$3(D)}return F.MATRIX_OPTIONS=MATRIX_OPTIONS,F.NUMBER_OPTIONS=NUMBER_OPTIONS,Object.keys(DEFAULT_CONFIG).forEach(J=>{Object.defineProperty(F,J,{get:()=>D[J],enumerable:!0,configurable:!0})}),F}function validateOption(D,E,F){D[E]!==void 0&&!F.includes(D[E])&&console.warn(\'Warning: Unknown value "\'+D[E]+\'" for configuration option "\'+E+\'". Available options: \'+F.map(J=>JSON.stringify(J)).join(", ")+".")}var require_typed_function=__commonJSMin(((D,E)=>{(function(F,J){typeof D=="object"&&E!==void 0?E.exports=J():typeof define=="function"&&define.amd?define(J):(F=typeof globalThis<"u"?globalThis:F||self,F["\'typed\'"]=J())})(D,(function(){function F(){return!0}function J(){return!1}function $e(){}let _t="Argument is not a typed-function.";function lr(){function mr(wa){return typeof wa=="object"&&!!wa&&wa.constructor===Object}let Or=[{name:"number",test:function(wa){return typeof wa=="number"}},{name:"string",test:function(wa){return typeof wa=="string"}},{name:"boolean",test:function(wa){return typeof wa=="boolean"}},{name:"Function",test:function(wa){return typeof wa=="function"}},{name:"Array",test:Array.isArray},{name:"Date",test:function(wa){return wa instanceof Date}},{name:"RegExp",test:function(wa){return wa instanceof RegExp}},{name:"Object",test:mr},{name:"null",test:function(wa){return wa===null}},{name:"undefined",test:function(wa){return wa===void 0}}],Pr={name:"any",test:F,isAny:!0},dn,gi,qi=0,zi={createCount:0};function Hi(wa){let qa=dn.get(wa);if(qa)return qa;let ja=\'Unknown type "\'+wa+\'"\',Xa=wa.toLowerCase(),Ya;for(Ya of gi)if(Ya.toLowerCase()===Xa){ja+=\'. Did you mean "\'+Ya+\'" ?\';break}throw TypeError(ja)}function Qi(wa){let qa=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"any",ja=qa?Hi(qa).index:gi.length,Xa=[];for(let Ja=0;Ja<wa.length;++Ja){if(!wa[Ja]||typeof wa[Ja].name!="string"||typeof wa[Ja].test!="function")throw TypeError("Object with properties {name: string, test: function} expected");let os=wa[Ja].name;if(dn.has(os))throw TypeError(\'Duplicate type name "\'+os+\'"\');Xa.push(os),dn.set(os,{name:os,test:wa[Ja].test,isAny:wa[Ja].isAny,index:ja+Ja,conversionsTo:[]})}let Ya=gi.slice(ja);gi=gi.slice(0,ja).concat(Xa).concat(Ya);for(let Ja=ja+Xa.length;Ja<gi.length;++Ja)dn.get(gi[Ja]).index=Ja}function Gi(){dn=new Map,gi=[],qi=0,Qi([Pr],!1)}Gi(),Qi(Or);function Zi(){let wa;for(wa of gi)dn.get(wa).conversionsTo=[];qi=0}function Xi(wa){let qa=gi.filter(ja=>{let Xa=dn.get(ja);return!Xa.isAny&&Xa.test(wa)});return qa.length?qa:["any"]}function Ki(wa){return wa&&typeof wa=="function"&&"_typedFunctionData"in wa}function ea(wa,qa,ja){if(!Ki(wa))throw TypeError(_t);let Xa=ja&&ja.exact,Ya=ua(Array.isArray(qa)?qa.join(","):qa),Ja=na(Ya);if(!Xa||Ja in wa.signatures){let Sa=wa._typedFunctionData.signatureMap.get(Ja);if(Sa)return Sa}let os=Ya.length,ns;if(Xa){ns=[];let Sa;for(Sa in wa.signatures)ns.push(wa._typedFunctionData.signatureMap.get(Sa))}else ns=wa._typedFunctionData.signatures;for(let Sa=0;Sa<os;++Sa){let Ha=Ya[Sa],Za=[],fs;for(fs of ns){let gs=ma(fs.params,Sa);if(!(!gs||Ha.restParam&&!gs.restParam)){if(!gs.hasAny){let ws=oa(gs);if(Ha.types.some(Os=>!ws.has(Os.name)))continue}Za.push(fs)}}if(ns=Za,ns.length===0)break}let ca;for(ca of ns)if(ca.params.length<=os)return ca;throw TypeError("Signature not found (signature: "+(wa.name||"unnamed")+"("+na(Ya,", ")+"))")}function Ji(wa,qa,ja){return ea(wa,qa,ja).implementation}function ta(wa,qa){let ja=Hi(qa);if(ja.test(wa))return wa;let Xa=ja.conversionsTo;if(Xa.length===0)throw Error("There are no conversions to "+qa+" defined.");for(let Ya=0;Ya<Xa.length;Ya++)if(Hi(Xa[Ya].from).test(wa))return Xa[Ya].convert(wa);throw Error("Cannot convert "+wa+" to "+qa)}function na(wa){let qa=arguments.length>1&&arguments[1]!==void 0?arguments[1]:",";return wa.map(ja=>ja.name).join(qa)}function ra(wa){let qa=wa.indexOf("...")===0,ja=(qa?wa.length>3?wa.slice(3):"any":wa).split("|").map(Ja=>Hi(Ja.trim())),Xa=!1,Ya=qa?"...":"";return{types:ja.map(function(Ja){return Xa=Ja.isAny||Xa,Ya+=Ja.name+"|",{name:Ja.name,typeIndex:Ja.index,test:Ja.test,isAny:Ja.isAny,conversion:null,conversionIndex:-1}}),name:Ya.slice(0,-1),hasAny:Xa,hasConversion:!1,restParam:qa}}function ia(wa){let qa=ka(wa.types.map(Ja=>Ja.name)),ja=wa.hasAny,Xa=wa.name,Ya=qa.map(function(Ja){let os=Hi(Ja.from);return ja=os.isAny||ja,Xa+="|"+Ja.from,{name:Ja.from,typeIndex:os.index,test:os.test,isAny:os.isAny,conversion:Ja,conversionIndex:Ja.index}});return{types:wa.types.concat(Ya),name:Xa,hasAny:ja,hasConversion:Ya.length>0,restParam:wa.restParam}}function oa(wa){return wa.typeSet||(wa.typeSet=new Set,wa.types.forEach(qa=>wa.typeSet.add(qa.name))),wa.typeSet}function ua(wa){let qa=[];if(typeof wa!="string")throw TypeError("Signatures must be strings");let ja=wa.trim();if(ja==="")return qa;let Xa=ja.split(",");for(let Ya=0;Ya<Xa.length;++Ya){let Ja=ra(Xa[Ya].trim());if(Ja.restParam&&Ya!==Xa.length-1)throw SyntaxError(\'Unexpected rest parameter "\'+Xa[Ya]+\'": only allowed for the last parameter\');if(Ja.types.length===0)return null;qa.push(Ja)}return qa}function sa(wa){let qa=ts(wa);return qa?qa.restParam:!1}function aa(wa){if(!wa||wa.types.length===0)return F;if(wa.types.length===1)return Hi(wa.types[0].name).test;if(wa.types.length===2){let qa=Hi(wa.types[0].name).test,ja=Hi(wa.types[1].name).test;return function(Xa){return qa(Xa)||ja(Xa)}}else{let qa=wa.types.map(function(ja){return Hi(ja.name).test});return function(ja){for(let Xa=0;Xa<qa.length;Xa++)if(qa[Xa](ja))return!0;return!1}}}function pa(wa){let qa,ja,Xa;if(sa(wa)){qa=es(wa).map(aa);let Ya=qa.length,Ja=aa(ts(wa)),os=function(ns){for(let ca=Ya;ca<ns.length;ca++)if(!Ja(ns[ca]))return!1;return!0};return function(ns){for(let ca=0;ca<qa.length;ca++)if(!qa[ca](ns[ca]))return!1;return os(ns)&&ns.length>=Ya+1}}else return wa.length===0?function(Ya){return Ya.length===0}:wa.length===1?(ja=aa(wa[0]),function(Ya){return ja(Ya[0])&&Ya.length===1}):wa.length===2?(ja=aa(wa[0]),Xa=aa(wa[1]),function(Ya){return ja(Ya[0])&&Xa(Ya[1])&&Ya.length===2}):(qa=wa.map(aa),function(Ya){for(let Ja=0;Ja<qa.length;Ja++)if(!qa[Ja](Ya[Ja]))return!1;return Ya.length===qa.length})}function ma(wa,qa){return qa<wa.length?wa[qa]:sa(wa)?ts(wa):null}function la(wa,qa){let ja=ma(wa,qa);return ja?oa(ja):new Set}function ha(wa){return wa.conversion===null||wa.conversion===void 0}function ga(wa,qa){let ja=new Set;return wa.forEach(Xa=>{let Ya=la(Xa.params,qa),Ja;for(Ja of Ya)ja.add(Ja)}),ja.has("any")?["any"]:Array.from(ja)}function Aa(wa,qa,ja){let Xa,Ya,Ja=wa||"unnamed",os=ja,ns;for(ns=0;ns<qa.length;ns++){let Za=[];if(os.forEach(fs=>{let gs=aa(ma(fs.params,ns));(ns<fs.params.length||sa(fs.params))&&gs(qa[ns])&&Za.push(fs)}),Za.length===0){if(Ya=ga(os,ns),Ya.length>0){let fs=Xi(qa[ns]);return Xa=TypeError("Unexpected type of argument in function "+Ja+" (expected: "+Ya.join(" or ")+", actual: "+fs.join(" | ")+", index: "+ns+")"),Xa.data={category:"wrongType",fn:Ja,index:ns,actual:fs,expected:Ya},Xa}}else os=Za}let ca=os.map(function(Za){return sa(Za.params)?1/0:Za.params.length});if(qa.length<Math.min.apply(null,ca))return Ya=ga(os,ns),Xa=TypeError("Too few arguments in function "+Ja+" (expected: "+Ya.join(" or ")+", index: "+qa.length+")"),Xa.data={category:"tooFewArgs",fn:Ja,index:qa.length,expected:Ya},Xa;let Sa=Math.max.apply(null,ca);if(qa.length>Sa)return Xa=TypeError("Too many arguments in function "+Ja+" (expected: "+Sa+", actual: "+qa.length+")"),Xa.data={category:"tooManyArgs",fn:Ja,index:qa.length,expectedLength:Sa},Xa;let Ha=[];for(let Za=0;Za<qa.length;++Za)Ha.push(Xi(qa[Za]).join("|"));return Xa=TypeError(\'Arguments of type "\'+Ha.join(", ")+\'" do not match any of the defined signatures of function \'+Ja+"."),Xa.data={category:"mismatch",actual:Ha},Xa}function Fa(wa){let qa=gi.length+1;for(let ja=0;ja<wa.types.length;ja++)ha(wa.types[ja])&&(qa=Math.min(qa,wa.types[ja].typeIndex));return qa}function $a(wa){let qa=qi+1;for(let ja=0;ja<wa.types.length;ja++)ha(wa.types[ja])||(qa=Math.min(qa,wa.types[ja].conversionIndex));return qa}function _a(wa,qa){if(wa.hasAny){if(!qa.hasAny)return 1}else if(qa.hasAny)return-1;if(wa.restParam){if(!qa.restParam)return 1}else if(qa.restParam)return-1;if(wa.hasConversion){if(!qa.hasConversion)return 1}else if(qa.hasConversion)return-1;let ja=Fa(wa)-Fa(qa);if(ja<0)return-1;if(ja>0)return 1;let Xa=$a(wa)-$a(qa);return Xa<0?-1:+(Xa>0)}function fa(wa,qa){let ja=wa.params,Xa=qa.params,Ya=ts(ja),Ja=ts(Xa),os=sa(ja),ns=sa(Xa);if(os&&Ya.hasAny){if(!ns||!Ja.hasAny)return 1}else if(ns&&Ja.hasAny)return-1;let ca=0,Sa=0,Ha;for(Ha of ja)Ha.hasAny&&++ca,Ha.hasConversion&&++Sa;let Za=0,fs=0;for(Ha of Xa)Ha.hasAny&&++Za,Ha.hasConversion&&++fs;if(ca!==Za)return ca-Za;if(os&&Ya.hasConversion){if(!ns||!Ja.hasConversion)return 1}else if(ns&&Ja.hasConversion)return-1;if(Sa!==fs)return Sa-fs;if(os){if(!ns)return 1}else if(ns)return-1;let gs=(ja.length-Xa.length)*(os?-1:1);if(gs!==0)return gs;let ws=[],Os=0;for(let zs=0;zs<ja.length;++zs){let $s=_a(ja[zs],Xa[zs]);ws.push($s),Os+=$s}if(Os!==0)return Os;let Rs;for(Rs of ws)if(Rs!==0)return Rs;return 0}function ka(wa){if(wa.length===0)return[];let qa=wa.map(Hi);wa.length>1&&qa.sort((Ya,Ja)=>Ya.index-Ja.index);let ja=qa[0].conversionsTo;if(wa.length===1)return ja;ja=ja.concat([]);let Xa=new Set(wa);for(let Ya=1;Ya<qa.length;++Ya){let Ja;for(Ja of qa[Ya].conversionsTo)Xa.has(Ja.from)||(ja.push(Ja),Xa.add(Ja.from))}return ja}function ba(wa,qa){let ja=qa;if(wa.some(Ya=>Ya.hasConversion)){let Ya=sa(wa),Ja=wa.map(Pa);ja=function(){let os=[],ns=Ya?arguments.length-1:arguments.length;for(let ca=0;ca<ns;ca++)os[ca]=Ja[ca](arguments[ca]);return Ya&&(os[ns]=arguments[ns].map(Ja[ns])),qa.apply(this,os)}}let Xa=ja;if(sa(wa)){let Ya=wa.length-1;Xa=function(){return ja.apply(this,Ka(arguments,0,Ya).concat([Ka(arguments,Ya)]))}}return Xa}function Pa(wa){let qa,ja,Xa,Ya,Ja=[],os=[];switch(wa.types.forEach(function(ns){ns.conversion&&(Ja.push(Hi(ns.conversion.from).test),os.push(ns.conversion.convert))}),os.length){case 0:return function(ns){return ns};case 1:return qa=Ja[0],Xa=os[0],function(ns){return qa(ns)?Xa(ns):ns};case 2:return qa=Ja[0],ja=Ja[1],Xa=os[0],Ya=os[1],function(ns){return qa(ns)?Xa(ns):ja(ns)?Ya(ns):ns};default:return function(ns){for(let ca=0;ca<os.length;ca++)if(Ja[ca](ns))return os[ca](ns);return ns}}}function Ia(wa){function qa(ja,Xa,Ya){if(Xa<ja.length){let Ja=ja[Xa],os=[];if(Ja.restParam){let ns=Ja.types.filter(ha);ns.length<Ja.types.length&&os.push({types:ns,name:"..."+ns.map(ca=>ca.name).join("|"),hasAny:ns.some(ca=>ca.isAny),hasConversion:!1,restParam:!0}),os.push(Ja)}else os=Ja.types.map(function(ns){return{types:[ns],name:ns.name,hasAny:ns.isAny,hasConversion:ns.conversion,restParam:!1}});return cs(os,function(ns){return qa(ja,Xa+1,Ya.concat([ns]))})}else return[Ya]}return qa(wa,0,[])}function Da(wa,qa){let ja=Math.max(wa.length,qa.length);for(let ns=0;ns<ja;ns++){let ca=la(wa,ns),Sa=la(qa,ns),Ha=!1,Za;for(Za of Sa)if(ca.has(Za)){Ha=!0;break}if(!Ha)return!1}let Xa=wa.length,Ya=qa.length,Ja=sa(wa),os=sa(qa);return Ja?os?Xa===Ya:Ya>=Xa:os?Xa>=Ya:Xa===Ya}function va(wa){return wa.map(qa=>as(qa)?Va(qa.referToSelf.callback):Ga(qa)?Ra(qa.referTo.references,qa.referTo.callback):qa)}function Ca(wa,qa,ja){let Xa=[],Ya;for(Ya of wa){let Ja=ja[Ya];if(typeof Ja!="number")throw TypeError(\'No definition for referenced signature "\'+Ya+\'"\');if(Ja=qa[Ja],typeof Ja!="function")return!1;Xa.push(Ja)}return Xa}function ya(wa,qa,ja){let Xa=va(wa),Ya=Array(Xa.length).fill(!1),Ja=!0;for(;Ja;){Ja=!1;let os=!0;for(let ns=0;ns<Xa.length;++ns){if(Ya[ns])continue;let ca=Xa[ns];if(as(ca))Xa[ns]=ca.referToSelf.callback(ja),Xa[ns].referToSelf=ca.referToSelf,Ya[ns]=!0,os=!1;else if(Ga(ca)){let Sa=Ca(ca.referTo.references,Xa,qa);Sa?(Xa[ns]=ca.referTo.callback.apply(this,Sa),Xa[ns].referTo=ca.referTo,Ya[ns]=!0,os=!1):Ja=!0}}if(os&&Ja)throw SyntaxError("Circular reference detected in resolving typed.referTo")}return Xa}function Na(wa){let qa=/\\bthis(\\(|\\.signatures\\b)/;Object.keys(wa).forEach(ja=>{let Xa=wa[ja];if(qa.test(Xa.toString()))throw SyntaxError("Using `this` to self-reference a function is deprecated since typed-function@3. Use typed.referTo and typed.referToSelf instead.")})}function za(wa,qa){if(zi.createCount++,Object.keys(qa).length===0)throw SyntaxError("No signatures provided");zi.warnAgainstDeprecatedThis&&Na(qa);let ja=[],Xa=[],Ya={},Ja=[],os;for(os in qa){if(!Object.prototype.hasOwnProperty.call(qa,os))continue;let As=ua(os);if(!As)continue;ja.forEach(function(Ls){if(Da(Ls,As))throw TypeError(\'Conflicting signatures "\'+na(Ls)+\'" and "\'+na(As)+\'".\')}),ja.push(As);let Vs=Xa.length;Xa.push(qa[os]);let bu=As.map(ia),Ys;for(Ys of Ia(bu)){let Ls=na(Ys);Ja.push({params:Ys,name:Ls,fn:Vs}),Ys.every(il=>!il.hasConversion)&&(Ya[Ls]=Vs)}}Ja.sort(fa);let ns=ya(Xa,Ya,Ks),ca;for(ca in Ya)Object.prototype.hasOwnProperty.call(Ya,ca)&&(Ya[ca]=ns[Ya[ca]]);let Sa=[],Ha=new Map;for(ca of Ja)Ha.has(ca.name)||(ca.fn=ns[ca.fn],Sa.push(ca),Ha.set(ca.name,ca));let Za=Sa[0]&&Sa[0].params.length<=2&&!sa(Sa[0].params),fs=Sa[1]&&Sa[1].params.length<=2&&!sa(Sa[1].params),gs=Sa[2]&&Sa[2].params.length<=2&&!sa(Sa[2].params),ws=Sa[3]&&Sa[3].params.length<=2&&!sa(Sa[3].params),Os=Sa[4]&&Sa[4].params.length<=2&&!sa(Sa[4].params),Rs=Sa[5]&&Sa[5].params.length<=2&&!sa(Sa[5].params),zs=Za&&fs&&gs&&ws&&Os&&Rs;for(let As=0;As<Sa.length;++As)Sa[As].test=pa(Sa[As].params);let $s=Za?aa(Sa[0].params[0]):J,js=fs?aa(Sa[1].params[0]):J,Qs=gs?aa(Sa[2].params[0]):J,Gs=ws?aa(Sa[3].params[0]):J,Ws=Os?aa(Sa[4].params[0]):J,Us=Rs?aa(Sa[5].params[0]):J,Ma=Za?aa(Sa[0].params[1]):J,Es=fs?aa(Sa[1].params[1]):J,Ns=gs?aa(Sa[2].params[1]):J,bs=ws?aa(Sa[3].params[1]):J,da=Os?aa(Sa[4].params[1]):J,Qa=Rs?aa(Sa[5].params[1]):J;for(let As=0;As<Sa.length;++As)Sa[As].implementation=ba(Sa[As].params,Sa[As].fn);let us=Za?Sa[0].implementation:$e,ds=fs?Sa[1].implementation:$e,Ts=gs?Sa[2].implementation:$e,ls=ws?Sa[3].implementation:$e,Cs=Os?Sa[4].implementation:$e,Ms=Rs?Sa[5].implementation:$e,_s=Za?Sa[0].params.length:-1,Ds=fs?Sa[1].params.length:-1,vs=gs?Sa[2].params.length:-1,Fs=ws?Sa[3].params.length:-1,ks=Os?Sa[4].params.length:-1,Bs=Rs?Sa[5].params.length:-1,Zs=zs?6:0,ys=Sa.length,rl=Sa.map(As=>As.test),Js=Sa.map(As=>As.implementation),nl=function(){for(let As=Zs;As<ys;As++)if(rl[As](arguments))return Js[As].apply(this,arguments);return zi.onMismatch(wa,arguments,Sa)};function Ks(As,Vs){return arguments.length===_s&&$s(As)&&Ma(Vs)?us.apply(this,arguments):arguments.length===Ds&&js(As)&&Es(Vs)?ds.apply(this,arguments):arguments.length===vs&&Qs(As)&&Ns(Vs)?Ts.apply(this,arguments):arguments.length===Fs&&Gs(As)&&bs(Vs)?ls.apply(this,arguments):arguments.length===ks&&Ws(As)&&da(Vs)?Cs.apply(this,arguments):arguments.length===Bs&&Us(As)&&Qa(Vs)?Ms.apply(this,arguments):nl.apply(this,arguments)}try{Object.defineProperty(Ks,"name",{value:wa})}catch{}return Ks.signatures=Ya,Ks._typedFunctionData={signatures:Sa,signatureMap:Ha},Ks}function Ta(wa,qa,ja){throw Aa(wa,qa,ja)}function es(wa){return Ka(wa,0,wa.length-1)}function ts(wa){return wa[wa.length-1]}function Ka(wa,qa,ja){return Array.prototype.slice.call(wa,qa,ja)}function ps(wa,qa){for(let ja=0;ja<wa.length;ja++)if(qa(wa[ja]))return wa[ja]}function cs(wa,qa){return Array.prototype.concat.apply([],wa.map(qa))}function xa(){let wa=es(arguments).map(ja=>na(ua(ja))),qa=ts(arguments);if(typeof qa!="function")throw TypeError("Callback function expected as last argument");return Ra(wa,qa)}function Ra(wa,qa){return{referTo:{references:wa,callback:qa}}}function Va(wa){if(typeof wa!="function")throw TypeError("Callback function expected as first argument");return{referToSelf:{callback:wa}}}function Ga(wa){return wa&&typeof wa.referTo=="object"&&Array.isArray(wa.referTo.references)&&typeof wa.referTo.callback=="function"}function as(wa){return wa&&typeof wa.referToSelf=="object"&&typeof wa.referToSelf.callback=="function"}function rs(wa,qa){if(!wa)return qa;if(qa&&qa!==wa){let ja=Error("Function names do not match (expected: "+wa+", actual: "+qa+")");throw ja.data={actual:qa,expected:wa},ja}return wa}function ss(wa){let qa;for(let ja in wa)Object.prototype.hasOwnProperty.call(wa,ja)&&(Ki(wa[ja])||typeof wa[ja].signature=="string")&&(qa=rs(qa,wa[ja].name));return qa}function ms(wa,qa){let ja;for(ja in qa)if(Object.prototype.hasOwnProperty.call(qa,ja)){if(ja in wa&&qa[ja]!==wa[ja]){let Xa=Error(\'Signature "\'+ja+\'" is defined twice\');throw Xa.data={signature:ja,sourceFunction:qa[ja],destFunction:wa[ja]},Xa}wa[ja]=qa[ja]}}let Ua=zi;zi=function(wa){let qa=typeof wa=="string",ja=+!!qa,Xa=qa?wa:"",Ya={};for(let Ja=ja;Ja<arguments.length;++Ja){let os=arguments[Ja],ns={},ca;if(typeof os=="function"?(ca=os.name,typeof os.signature=="string"?ns[os.signature]=os:Ki(os)&&(ns=os.signatures)):mr(os)&&(ns=os,qa||(ca=ss(os))),Object.keys(ns).length===0){let Sa=TypeError("Argument to \'typed\' at index "+Ja+" is not a (typed) function, nor an object with signatures as keys and functions as values.");throw Sa.data={index:Ja,argument:os},Sa}qa||(Xa=rs(Xa,ca)),ms(Ya,ns)}return za(Xa||"",Ya)},zi.create=lr,zi.createCount=Ua.createCount,zi.onMismatch=Ta,zi.throwMismatchError=Ta,zi.createError=Aa,zi.clear=Gi,zi.clearConversions=Zi,zi.addTypes=Qi,zi._findType=Hi,zi.referTo=xa,zi.referToSelf=Va,zi.convert=ta,zi.findSignature=ea,zi.find=Ji,zi.isTypedFunction=Ki,zi.warnAgainstDeprecatedThis=!0,zi.addType=function(wa,qa){let ja="any";qa!==!1&&dn.has("Object")&&(ja="Object"),zi.addTypes([wa],ja)};function Wa(wa){if(!wa||typeof wa.from!="string"||typeof wa.to!="string"||typeof wa.convert!="function")throw TypeError("Object with properties {from: string, to: string, convert: function} expected");if(wa.to===wa.from)throw SyntaxError(\'Illegal to define conversion from "\'+wa.from+\'" to itself.\')}return zi.addConversion=function(wa){let qa=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{override:!1};Wa(wa);let ja=Hi(wa.to),Xa=ja.conversionsTo.find(Ya=>Ya.from===wa.from);if(Xa)if(qa&&qa.override)zi.removeConversion({from:Xa.from,to:wa.to,convert:Xa.convert});else throw Error(\'There is already a conversion from "\'+wa.from+\'" to "\'+ja.name+\'"\');ja.conversionsTo.push({from:wa.from,convert:wa.convert,index:qi++})},zi.addConversions=function(wa,qa){wa.forEach(ja=>zi.addConversion(ja,qa))},zi.removeConversion=function(wa){Wa(wa);let qa=Hi(wa.to),ja=ps(qa.conversionsTo,Ya=>Ya.from===wa.from);if(!ja)throw Error("Attempt to remove nonexistent conversion from "+wa.from+" to "+wa.to);if(ja.convert!==wa.convert)throw Error("Conversion to remove does not match existing conversion");let Xa=qa.conversionsTo.indexOf(ja);qa.conversionsTo.splice(Xa,1)},zi.resolve=function(wa,qa){if(!Ki(wa))throw TypeError(_t);let ja=wa._typedFunctionData.signatures;for(let Xa=0;Xa<ja.length;++Xa)if(ja[Xa].test(qa))return ja[Xa];return null},zi}return lr()}))}));function factory(D,E,F,J){function $e(_t){var lr=pickShallow(_t,E.map(stripOptionalNotation));return assertDependencies(D,E,_t),F(lr)}return $e.isFactory=!0,$e.fn=D,$e.dependencies=E.slice().sort(),J&&($e.meta=J),$e}function isFactory(D){return typeof D=="function"&&typeof D.fn=="string"&&Array.isArray(D.dependencies)}function assertDependencies(D,E,F){if(!E.filter($e=>!isOptionalDependency($e)).every($e=>F[$e]!==void 0)){var J=E.filter($e=>F[$e]===void 0);throw Error(`Cannot create function "${D}", some dependencies are missing: ${J.map($e=>`"${$e}"`).join(", ")}.`)}}function isOptionalDependency(D){return D&&D[0]==="?"}function stripOptionalNotation(D){return D&&D[0]==="?"?D.slice(1):D}function isInteger(D){return typeof D=="boolean"?!0:Number.isFinite(D)?D===Math.round(D):!1}function safeNumberType(D,E){if(E.number==="bigint")try{BigInt(D)}catch{return E.numberFallback}return E.number}var sign$2=Math.sign||function(D){return D>0?1:D<0?-1:0},log2$1=Math.log2||function(D){return Math.log(D)/Math.LN2},log10$2=Math.log10||function(D){return Math.log(D)/Math.LN10},log1p=Math.log1p||function(D){return Math.log(D+1)},cbrt$1=Math.cbrt||function(D){if(D===0)return D;var E=D<0,F;return E&&(D=-D),Number.isFinite(D)?(F=Math.exp(Math.log(D)/3),F=(D/(F*F)+2*F)/3):F=D,E?-F:F},expm1=Math.expm1||function(D){return D>=2e-4||D<=-2e-4?Math.exp(D)-1:D+D*D/2+D*D*D/6};function formatNumberToBase(D,E,F){var J={2:"0b",8:"0o",16:"0x"}[E],$e="";if(F){if(F<1)throw Error("size must be in greater than 0");if(!isInteger(F))throw Error("size must be an integer");if(D>2**(F-1)-1||D<-(2**(F-1)))throw Error(`Value must be in range [-2^${F-1}, 2^${F-1}-1]`);if(!isInteger(D))throw Error("Value must be an integer");D<0&&(D+=2**F),$e=`i${F}`}var _t="";return D<0&&(D=-D,_t="-"),`${_t}${J}${D.toString(E)}${$e}`}function format$2(D,E){if(typeof E=="function")return E(D);if(D===1/0)return"Infinity";if(D===-1/0)return"-Infinity";if(isNaN(D))return"NaN";var{notation:F,precision:J,wordSize:$e}=normalizeFormatOptions(E);switch(F){case"fixed":return toFixed$2(D,J);case"exponential":return toExponential$1(D,J);case"engineering":return toEngineering$1(D,J);case"bin":return formatNumberToBase(D,2,$e);case"oct":return formatNumberToBase(D,8,$e);case"hex":return formatNumberToBase(D,16,$e);case"auto":return toPrecision(D,J,E).replace(/((\\.\\d*?)(0+))($|e)/,function(){var _t=arguments[2],lr=arguments[4];return _t==="."?lr:_t+lr});default:throw Error(\'Unknown notation "\'+F+\'". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.\')}}function normalizeFormatOptions(D){var E="auto",F,J;if(D!==void 0)if(isNumber(D))F=D;else if(isBigNumber(D))F=D.toNumber();else if(isObject$1(D))D.precision!==void 0&&(F=_toNumberOrThrow(D.precision,()=>{throw Error(\'Option "precision" must be a number or BigNumber\')})),D.wordSize!==void 0&&(J=_toNumberOrThrow(D.wordSize,()=>{throw Error(\'Option "wordSize" must be a number or BigNumber\')})),D.notation&&(E=D.notation);else throw Error("Unsupported type of options, number, BigNumber, or object expected");return{notation:E,precision:F,wordSize:J}}function splitNumber(D){var E=String(D).toLowerCase().match(/^(-?)(\\d+\\.?\\d*)(e([+-]?\\d+))?$/);if(!E)throw SyntaxError("Invalid number "+D);var F=E[1],J=E[2],$e=parseFloat(E[4]||"0"),_t=J.indexOf(".");$e+=_t===-1?J.length-1:_t-1;var lr=J.replace(".","").replace(/^0*/,function(mr){return $e-=mr.length,""}).replace(/0*$/,"").split("").map(function(mr){return parseInt(mr)});return lr.length===0&&(lr.push(0),$e++),{sign:F,coefficients:lr,exponent:$e}}function toEngineering$1(D,E){if(isNaN(D)||!Number.isFinite(D))return String(D);var F=roundDigits(splitNumber(D),E),J=F.exponent,$e=F.coefficients,_t=J%3==0?J:J<0?J-3-J%3:J-J%3;if(isNumber(E))for(;E>$e.length||J-_t+1>$e.length;)$e.push(0);else for(var lr=Math.abs(J-_t)-($e.length-1),mr=0;mr<lr;mr++)$e.push(0);for(var Or=Math.abs(J-_t),Pr=1;Or>0;)Pr++,Or--;var dn=$e.slice(Pr).join(""),gi=isNumber(E)&&dn.length||dn.match(/[1-9]/)?"."+dn:"",qi=$e.slice(0,Pr).join("")+gi+"e"+(J>=0?"+":"")+_t.toString();return F.sign+qi}function toFixed$2(D,E){if(isNaN(D)||!Number.isFinite(D))return String(D);var F=splitNumber(D),J=typeof E=="number"?roundDigits(F,F.exponent+1+E):F,$e=J.coefficients,_t=J.exponent+1,lr=_t+(E||0);return $e.length<lr&&($e=$e.concat(zeros(lr-$e.length))),_t<0&&($e=zeros(-_t+1).concat($e),_t=1),_t<$e.length&&$e.splice(_t,0,_t===0?"0.":"."),J.sign+$e.join("")}function toExponential$1(D,E){if(isNaN(D)||!Number.isFinite(Number(D)))return String(D);var F=splitNumber(D),J=E?roundDigits(F,E):F,$e=J.coefficients,_t=J.exponent;$e.length<E&&($e=$e.concat(zeros(E-$e.length)));var lr=$e.shift();return J.sign+lr+($e.length>0?"."+$e.join(""):"")+"e"+(_t>=0?"+":"")+_t}function toPrecision(D,E,F){if(isNaN(D)||!Number.isFinite(D))return String(D);var J=_toNumberOrDefault$1(F?.lowerExp,-3),$e=_toNumberOrDefault$1(F?.upperExp,5),_t=splitNumber(D),lr=E?roundDigits(_t,E):_t;if(lr.exponent<J||lr.exponent>=$e)return toExponential$1(D,E);var mr=lr.coefficients,Or=lr.exponent;mr.length<E&&(mr=mr.concat(zeros(E-mr.length))),mr=mr.concat(zeros(Or-mr.length+1+(mr.length<E?E-mr.length:0))),mr=zeros(-Or).concat(mr);var Pr=Or>0?Or:0;return Pr<mr.length-1&&mr.splice(Pr+1,0,"."),lr.sign+mr.join("")}function roundDigits(D,E){for(var F={sign:D.sign,coefficients:D.coefficients,exponent:D.exponent},J=F.coefficients;E<=0;)J.unshift(0),F.exponent++,E++;if(J.length>E&&J.splice(E,J.length-E)[0]>=5){var $e=E-1;for(J[$e]++;J[$e]===10;)J.pop(),$e===0&&(J.unshift(0),F.exponent++,$e++),$e--,J[$e]++}return F}function zeros(D){for(var E=[],F=0;F<D;F++)E.push(0);return E}function digits(D){return D.toExponential().replace(/e.*$/,"").replace(/^0\\.?0*|\\./,"").length}function nearlyEqual$1(D,E){var F=arguments.length>2&&arguments[2]!==void 0?arguments[2]:1e-8,J=arguments.length>3&&arguments[3]!==void 0?arguments[3]:0;if(F<=0)throw Error("Relative tolerance must be greater than 0");if(J<0)throw Error("Absolute tolerance must be at least 0");return isNaN(D)||isNaN(E)?!1:!Number.isFinite(D)||!Number.isFinite(E)?D===E:D===E?!0:Math.abs(D-E)<=Math.max(F*Math.max(Math.abs(D),Math.abs(E)),J)}var acosh$2=Math.acosh||function(D){return Math.log(Math.sqrt(D*D-1)+D)},asinh$2=Math.asinh||function(D){return Math.log(Math.sqrt(D*D+1)+D)},atanh$2=Math.atanh||function(D){return Math.log((1+D)/(1-D))/2},cosh$3=Math.cosh||function(D){return(Math.exp(D)+Math.exp(-D))/2},sinh$3=Math.sinh||function(D){return(Math.exp(D)-Math.exp(-D))/2},tanh$2=Math.tanh||function(D){var E=Math.exp(2*D);return(E-1)/(E+1)};function copysign(D,E){return!0^(E>0?!0:E<0?!1:1/E==1/0)?-D:D}function _toNumberOrThrow(D,E){if(isNumber(D))return D;if(isBigNumber(D))return D.toNumber();E()}function _toNumberOrDefault$1(D,E){return isNumber(D)?D:isBigNumber(D)?D.toNumber():E}var import_typed_function=__toESM(require_typed_function()),_createTyped2=function(){return _createTyped2=import_typed_function.default.create,import_typed_function.default},dependencies$322=["?BigNumber","?Complex","?DenseMatrix","?Fraction"],createTyped=factory("typed",dependencies$322,function(D){var{BigNumber:E,Complex:F,DenseMatrix:J,Fraction:$e}=D,_t=_createTyped2();return _t.clear(),_t.addTypes([{name:"number",test:isNumber},{name:"Complex",test:isComplex},{name:"BigNumber",test:isBigNumber},{name:"bigint",test:isBigInt},{name:"Fraction",test:isFraction},{name:"Unit",test:isUnit},{name:"identifier",test:lr=>isString&&/^(?:[A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0560-\\u0588\\u05D0-\\u05EA\\u05EF-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u0860-\\u086A\\u0870-\\u0887\\u0889-\\u088F\\u08A0-\\u08C9\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u09FC\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0AF9\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58-\\u0C5A\\u0C5C\\u0C5D\\u0C60\\u0C61\\u0C80\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDC-\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D04-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D54-\\u0D56\\u0D5F-\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E86-\\u0E8A\\u0E8C-\\u0EA3\\u0EA5\\u0EA7-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F5\\u13F8-\\u13FD\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16F1-\\u16F8\\u1700-\\u1711\\u171F-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1878\\u1880-\\u1884\\u1887-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4C\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1C80-\\u1C8A\\u1C90-\\u1CBA\\u1CBD-\\u1CBF\\u1CE9-\\u1CEC\\u1CEE-\\u1CF3\\u1CF5\\u1CF6\\u1CFA\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2183\\u2184\\u2C00-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005\\u3006\\u3031-\\u3035\\u303B\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312F\\u3131-\\u318E\\u31A0-\\u31BF\\u31F0-\\u31FF\\u3400-\\u4DBF\\u4E00-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6E5\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA7DC\\uA7F1-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA8FD\\uA8FE\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB69\\uAB70-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]|\\uD800[\\uDC00-\\uDC0B\\uDC0D-\\uDC26\\uDC28-\\uDC3A\\uDC3C\\uDC3D\\uDC3F-\\uDC4D\\uDC50-\\uDC5D\\uDC80-\\uDCFA\\uDE80-\\uDE9C\\uDEA0-\\uDED0\\uDF00-\\uDF1F\\uDF2D-\\uDF40\\uDF42-\\uDF49\\uDF50-\\uDF75\\uDF80-\\uDF9D\\uDFA0-\\uDFC3\\uDFC8-\\uDFCF]|\\uD801[\\uDC00-\\uDC9D\\uDCB0-\\uDCD3\\uDCD8-\\uDCFB\\uDD00-\\uDD27\\uDD30-\\uDD63\\uDD70-\\uDD7A\\uDD7C-\\uDD8A\\uDD8C-\\uDD92\\uDD94\\uDD95\\uDD97-\\uDDA1\\uDDA3-\\uDDB1\\uDDB3-\\uDDB9\\uDDBB\\uDDBC\\uDDC0-\\uDDF3\\uDE00-\\uDF36\\uDF40-\\uDF55\\uDF60-\\uDF67\\uDF80-\\uDF85\\uDF87-\\uDFB0\\uDFB2-\\uDFBA]|\\uD802[\\uDC00-\\uDC05\\uDC08\\uDC0A-\\uDC35\\uDC37\\uDC38\\uDC3C\\uDC3F-\\uDC55\\uDC60-\\uDC76\\uDC80-\\uDC9E\\uDCE0-\\uDCF2\\uDCF4\\uDCF5\\uDD00-\\uDD15\\uDD20-\\uDD39\\uDD40-\\uDD59\\uDD80-\\uDDB7\\uDDBE\\uDDBF\\uDE00\\uDE10-\\uDE13\\uDE15-\\uDE17\\uDE19-\\uDE35\\uDE60-\\uDE7C\\uDE80-\\uDE9C\\uDEC0-\\uDEC7\\uDEC9-\\uDEE4\\uDF00-\\uDF35\\uDF40-\\uDF55\\uDF60-\\uDF72\\uDF80-\\uDF91]|\\uD803[\\uDC00-\\uDC48\\uDC80-\\uDCB2\\uDCC0-\\uDCF2\\uDD00-\\uDD23\\uDD4A-\\uDD65\\uDD6F-\\uDD85\\uDE80-\\uDEA9\\uDEB0\\uDEB1\\uDEC2-\\uDEC7\\uDF00-\\uDF1C\\uDF27\\uDF30-\\uDF45\\uDF70-\\uDF81\\uDFB0-\\uDFC4\\uDFE0-\\uDFF6]|\\uD804[\\uDC03-\\uDC37\\uDC71\\uDC72\\uDC75\\uDC83-\\uDCAF\\uDCD0-\\uDCE8\\uDD03-\\uDD26\\uDD44\\uDD47\\uDD50-\\uDD72\\uDD76\\uDD83-\\uDDB2\\uDDC1-\\uDDC4\\uDDDA\\uDDDC\\uDE00-\\uDE11\\uDE13-\\uDE2B\\uDE3F\\uDE40\\uDE80-\\uDE86\\uDE88\\uDE8A-\\uDE8D\\uDE8F-\\uDE9D\\uDE9F-\\uDEA8\\uDEB0-\\uDEDE\\uDF05-\\uDF0C\\uDF0F\\uDF10\\uDF13-\\uDF28\\uDF2A-\\uDF30\\uDF32\\uDF33\\uDF35-\\uDF39\\uDF3D\\uDF50\\uDF5D-\\uDF61\\uDF80-\\uDF89\\uDF8B\\uDF8E\\uDF90-\\uDFB5\\uDFB7\\uDFD1\\uDFD3]|\\uD805[\\uDC00-\\uDC34\\uDC47-\\uDC4A\\uDC5F-\\uDC61\\uDC80-\\uDCAF\\uDCC4\\uDCC5\\uDCC7\\uDD80-\\uDDAE\\uDDD8-\\uDDDB\\uDE00-\\uDE2F\\uDE44\\uDE80-\\uDEAA\\uDEB8\\uDF00-\\uDF1A\\uDF40-\\uDF46]|\\uD806[\\uDC00-\\uDC2B\\uDCA0-\\uDCDF\\uDCFF-\\uDD06\\uDD09\\uDD0C-\\uDD13\\uDD15\\uDD16\\uDD18-\\uDD2F\\uDD3F\\uDD41\\uDDA0-\\uDDA7\\uDDAA-\\uDDD0\\uDDE1\\uDDE3\\uDE00\\uDE0B-\\uDE32\\uDE3A\\uDE50\\uDE5C-\\uDE89\\uDE9D\\uDEB0-\\uDEF8\\uDFC0-\\uDFE0]|\\uD807[\\uDC00-\\uDC08\\uDC0A-\\uDC2E\\uDC40\\uDC72-\\uDC8F\\uDD00-\\uDD06\\uDD08\\uDD09\\uDD0B-\\uDD30\\uDD46\\uDD60-\\uDD65\\uDD67\\uDD68\\uDD6A-\\uDD89\\uDD98\\uDDB0-\\uDDDB\\uDEE0-\\uDEF2\\uDF02\\uDF04-\\uDF10\\uDF12-\\uDF33\\uDFB0]|\\uD808[\\uDC00-\\uDF99]|\\uD809[\\uDC80-\\uDD43]|\\uD80B[\\uDF90-\\uDFF0]|[\\uD80C\\uD80E\\uD80F\\uD81C-\\uD822\\uD840-\\uD868\\uD86A-\\uD86D\\uD86F-\\uD872\\uD874-\\uD879\\uD880-\\uD883\\uD885-\\uD88C][\\uDC00-\\uDFFF]|\\uD80D[\\uDC00-\\uDC2F\\uDC41-\\uDC46\\uDC60-\\uDFFF]|\\uD810[\\uDC00-\\uDFFA]|\\uD811[\\uDC00-\\uDE46]|\\uD818[\\uDD00-\\uDD1D]|\\uD81A[\\uDC00-\\uDE38\\uDE40-\\uDE5E\\uDE70-\\uDEBE\\uDED0-\\uDEED\\uDF00-\\uDF2F\\uDF40-\\uDF43\\uDF63-\\uDF77\\uDF7D-\\uDF8F]|\\uD81B[\\uDD40-\\uDD6C\\uDE40-\\uDE7F\\uDEA0-\\uDEB8\\uDEBB-\\uDED3\\uDF00-\\uDF4A\\uDF50\\uDF93-\\uDF9F\\uDFE0\\uDFE1\\uDFE3\\uDFF2\\uDFF3]|\\uD823[\\uDC00-\\uDCD5\\uDCFF-\\uDD1E\\uDD80-\\uDDF2]|\\uD82B[\\uDFF0-\\uDFF3\\uDFF5-\\uDFFB\\uDFFD\\uDFFE]|\\uD82C[\\uDC00-\\uDD22\\uDD32\\uDD50-\\uDD52\\uDD55\\uDD64-\\uDD67\\uDD70-\\uDEFB]|\\uD82F[\\uDC00-\\uDC6A\\uDC70-\\uDC7C\\uDC80-\\uDC88\\uDC90-\\uDC99]|\\uD835[\\uDC00-\\uDC54\\uDC56-\\uDC9C\\uDC9E\\uDC9F\\uDCA2\\uDCA5\\uDCA6\\uDCA9-\\uDCAC\\uDCAE-\\uDCB9\\uDCBB\\uDCBD-\\uDCC3\\uDCC5-\\uDD05\\uDD07-\\uDD0A\\uDD0D-\\uDD14\\uDD16-\\uDD1C\\uDD1E-\\uDD39\\uDD3B-\\uDD3E\\uDD40-\\uDD44\\uDD46\\uDD4A-\\uDD50\\uDD52-\\uDEA5\\uDEA8-\\uDEC0\\uDEC2-\\uDEDA\\uDEDC-\\uDEFA\\uDEFC-\\uDF14\\uDF16-\\uDF34\\uDF36-\\uDF4E\\uDF50-\\uDF6E\\uDF70-\\uDF88\\uDF8A-\\uDFA8\\uDFAA-\\uDFC2\\uDFC4-\\uDFCB]|\\uD837[\\uDF00-\\uDF1E\\uDF25-\\uDF2A]|\\uD838[\\uDC30-\\uDC6D\\uDD00-\\uDD2C\\uDD37-\\uDD3D\\uDD4E\\uDE90-\\uDEAD\\uDEC0-\\uDEEB]|\\uD839[\\uDCD0-\\uDCEB\\uDDD0-\\uDDED\\uDDF0\\uDEC0-\\uDEDE\\uDEE0-\\uDEE2\\uDEE4\\uDEE5\\uDEE7-\\uDEED\\uDEF0-\\uDEF4\\uDEFE\\uDEFF\\uDFE0-\\uDFE6\\uDFE8-\\uDFEB\\uDFED\\uDFEE\\uDFF0-\\uDFFE]|\\uD83A[\\uDC00-\\uDCC4\\uDD00-\\uDD43\\uDD4B]|\\uD83B[\\uDE00-\\uDE03\\uDE05-\\uDE1F\\uDE21\\uDE22\\uDE24\\uDE27\\uDE29-\\uDE32\\uDE34-\\uDE37\\uDE39\\uDE3B\\uDE42\\uDE47\\uDE49\\uDE4B\\uDE4D-\\uDE4F\\uDE51\\uDE52\\uDE54\\uDE57\\uDE59\\uDE5B\\uDE5D\\uDE5F\\uDE61\\uDE62\\uDE64\\uDE67-\\uDE6A\\uDE6C-\\uDE72\\uDE74-\\uDE77\\uDE79-\\uDE7C\\uDE7E\\uDE80-\\uDE89\\uDE8B-\\uDE9B\\uDEA1-\\uDEA3\\uDEA5-\\uDEA9\\uDEAB-\\uDEBB]|\\uD869[\\uDC00-\\uDEDF\\uDF00-\\uDFFF]|\\uD86E[\\uDC00-\\uDC1D\\uDC20-\\uDFFF]|\\uD873[\\uDC00-\\uDEAD\\uDEB0-\\uDFFF]|\\uD87A[\\uDC00-\\uDFE0\\uDFF0-\\uDFFF]|\\uD87B[\\uDC00-\\uDE5D]|\\uD87E[\\uDC00-\\uDE1D]|\\uD884[\\uDC00-\\uDF4A\\uDF50-\\uDFFF]|\\uD88D[\\uDC00-\\uDC79])(?:[0-9A-Za-z\\xAA\\xB5\\xBA\\xC0-\\xD6\\xD8-\\xF6\\xF8-\\u02C1\\u02C6-\\u02D1\\u02E0-\\u02E4\\u02EC\\u02EE\\u0370-\\u0374\\u0376\\u0377\\u037A-\\u037D\\u037F\\u0386\\u0388-\\u038A\\u038C\\u038E-\\u03A1\\u03A3-\\u03F5\\u03F7-\\u0481\\u048A-\\u052F\\u0531-\\u0556\\u0559\\u0560-\\u0588\\u05D0-\\u05EA\\u05EF-\\u05F2\\u0620-\\u064A\\u066E\\u066F\\u0671-\\u06D3\\u06D5\\u06E5\\u06E6\\u06EE\\u06EF\\u06FA-\\u06FC\\u06FF\\u0710\\u0712-\\u072F\\u074D-\\u07A5\\u07B1\\u07CA-\\u07EA\\u07F4\\u07F5\\u07FA\\u0800-\\u0815\\u081A\\u0824\\u0828\\u0840-\\u0858\\u0860-\\u086A\\u0870-\\u0887\\u0889-\\u088F\\u08A0-\\u08C9\\u0904-\\u0939\\u093D\\u0950\\u0958-\\u0961\\u0971-\\u0980\\u0985-\\u098C\\u098F\\u0990\\u0993-\\u09A8\\u09AA-\\u09B0\\u09B2\\u09B6-\\u09B9\\u09BD\\u09CE\\u09DC\\u09DD\\u09DF-\\u09E1\\u09F0\\u09F1\\u09FC\\u0A05-\\u0A0A\\u0A0F\\u0A10\\u0A13-\\u0A28\\u0A2A-\\u0A30\\u0A32\\u0A33\\u0A35\\u0A36\\u0A38\\u0A39\\u0A59-\\u0A5C\\u0A5E\\u0A72-\\u0A74\\u0A85-\\u0A8D\\u0A8F-\\u0A91\\u0A93-\\u0AA8\\u0AAA-\\u0AB0\\u0AB2\\u0AB3\\u0AB5-\\u0AB9\\u0ABD\\u0AD0\\u0AE0\\u0AE1\\u0AF9\\u0B05-\\u0B0C\\u0B0F\\u0B10\\u0B13-\\u0B28\\u0B2A-\\u0B30\\u0B32\\u0B33\\u0B35-\\u0B39\\u0B3D\\u0B5C\\u0B5D\\u0B5F-\\u0B61\\u0B71\\u0B83\\u0B85-\\u0B8A\\u0B8E-\\u0B90\\u0B92-\\u0B95\\u0B99\\u0B9A\\u0B9C\\u0B9E\\u0B9F\\u0BA3\\u0BA4\\u0BA8-\\u0BAA\\u0BAE-\\u0BB9\\u0BD0\\u0C05-\\u0C0C\\u0C0E-\\u0C10\\u0C12-\\u0C28\\u0C2A-\\u0C39\\u0C3D\\u0C58-\\u0C5A\\u0C5C\\u0C5D\\u0C60\\u0C61\\u0C80\\u0C85-\\u0C8C\\u0C8E-\\u0C90\\u0C92-\\u0CA8\\u0CAA-\\u0CB3\\u0CB5-\\u0CB9\\u0CBD\\u0CDC-\\u0CDE\\u0CE0\\u0CE1\\u0CF1\\u0CF2\\u0D04-\\u0D0C\\u0D0E-\\u0D10\\u0D12-\\u0D3A\\u0D3D\\u0D4E\\u0D54-\\u0D56\\u0D5F-\\u0D61\\u0D7A-\\u0D7F\\u0D85-\\u0D96\\u0D9A-\\u0DB1\\u0DB3-\\u0DBB\\u0DBD\\u0DC0-\\u0DC6\\u0E01-\\u0E30\\u0E32\\u0E33\\u0E40-\\u0E46\\u0E81\\u0E82\\u0E84\\u0E86-\\u0E8A\\u0E8C-\\u0EA3\\u0EA5\\u0EA7-\\u0EB0\\u0EB2\\u0EB3\\u0EBD\\u0EC0-\\u0EC4\\u0EC6\\u0EDC-\\u0EDF\\u0F00\\u0F40-\\u0F47\\u0F49-\\u0F6C\\u0F88-\\u0F8C\\u1000-\\u102A\\u103F\\u1050-\\u1055\\u105A-\\u105D\\u1061\\u1065\\u1066\\u106E-\\u1070\\u1075-\\u1081\\u108E\\u10A0-\\u10C5\\u10C7\\u10CD\\u10D0-\\u10FA\\u10FC-\\u1248\\u124A-\\u124D\\u1250-\\u1256\\u1258\\u125A-\\u125D\\u1260-\\u1288\\u128A-\\u128D\\u1290-\\u12B0\\u12B2-\\u12B5\\u12B8-\\u12BE\\u12C0\\u12C2-\\u12C5\\u12C8-\\u12D6\\u12D8-\\u1310\\u1312-\\u1315\\u1318-\\u135A\\u1380-\\u138F\\u13A0-\\u13F5\\u13F8-\\u13FD\\u1401-\\u166C\\u166F-\\u167F\\u1681-\\u169A\\u16A0-\\u16EA\\u16F1-\\u16F8\\u1700-\\u1711\\u171F-\\u1731\\u1740-\\u1751\\u1760-\\u176C\\u176E-\\u1770\\u1780-\\u17B3\\u17D7\\u17DC\\u1820-\\u1878\\u1880-\\u1884\\u1887-\\u18A8\\u18AA\\u18B0-\\u18F5\\u1900-\\u191E\\u1950-\\u196D\\u1970-\\u1974\\u1980-\\u19AB\\u19B0-\\u19C9\\u1A00-\\u1A16\\u1A20-\\u1A54\\u1AA7\\u1B05-\\u1B33\\u1B45-\\u1B4C\\u1B83-\\u1BA0\\u1BAE\\u1BAF\\u1BBA-\\u1BE5\\u1C00-\\u1C23\\u1C4D-\\u1C4F\\u1C5A-\\u1C7D\\u1C80-\\u1C8A\\u1C90-\\u1CBA\\u1CBD-\\u1CBF\\u1CE9-\\u1CEC\\u1CEE-\\u1CF3\\u1CF5\\u1CF6\\u1CFA\\u1D00-\\u1DBF\\u1E00-\\u1F15\\u1F18-\\u1F1D\\u1F20-\\u1F45\\u1F48-\\u1F4D\\u1F50-\\u1F57\\u1F59\\u1F5B\\u1F5D\\u1F5F-\\u1F7D\\u1F80-\\u1FB4\\u1FB6-\\u1FBC\\u1FBE\\u1FC2-\\u1FC4\\u1FC6-\\u1FCC\\u1FD0-\\u1FD3\\u1FD6-\\u1FDB\\u1FE0-\\u1FEC\\u1FF2-\\u1FF4\\u1FF6-\\u1FFC\\u2071\\u207F\\u2090-\\u209C\\u2102\\u2107\\u210A-\\u2113\\u2115\\u2119-\\u211D\\u2124\\u2126\\u2128\\u212A-\\u212D\\u212F-\\u2139\\u213C-\\u213F\\u2145-\\u2149\\u214E\\u2183\\u2184\\u2C00-\\u2CE4\\u2CEB-\\u2CEE\\u2CF2\\u2CF3\\u2D00-\\u2D25\\u2D27\\u2D2D\\u2D30-\\u2D67\\u2D6F\\u2D80-\\u2D96\\u2DA0-\\u2DA6\\u2DA8-\\u2DAE\\u2DB0-\\u2DB6\\u2DB8-\\u2DBE\\u2DC0-\\u2DC6\\u2DC8-\\u2DCE\\u2DD0-\\u2DD6\\u2DD8-\\u2DDE\\u2E2F\\u3005\\u3006\\u3031-\\u3035\\u303B\\u303C\\u3041-\\u3096\\u309D-\\u309F\\u30A1-\\u30FA\\u30FC-\\u30FF\\u3105-\\u312F\\u3131-\\u318E\\u31A0-\\u31BF\\u31F0-\\u31FF\\u3400-\\u4DBF\\u4E00-\\uA48C\\uA4D0-\\uA4FD\\uA500-\\uA60C\\uA610-\\uA61F\\uA62A\\uA62B\\uA640-\\uA66E\\uA67F-\\uA69D\\uA6A0-\\uA6E5\\uA717-\\uA71F\\uA722-\\uA788\\uA78B-\\uA7DC\\uA7F1-\\uA801\\uA803-\\uA805\\uA807-\\uA80A\\uA80C-\\uA822\\uA840-\\uA873\\uA882-\\uA8B3\\uA8F2-\\uA8F7\\uA8FB\\uA8FD\\uA8FE\\uA90A-\\uA925\\uA930-\\uA946\\uA960-\\uA97C\\uA984-\\uA9B2\\uA9CF\\uA9E0-\\uA9E4\\uA9E6-\\uA9EF\\uA9FA-\\uA9FE\\uAA00-\\uAA28\\uAA40-\\uAA42\\uAA44-\\uAA4B\\uAA60-\\uAA76\\uAA7A\\uAA7E-\\uAAAF\\uAAB1\\uAAB5\\uAAB6\\uAAB9-\\uAABD\\uAAC0\\uAAC2\\uAADB-\\uAADD\\uAAE0-\\uAAEA\\uAAF2-\\uAAF4\\uAB01-\\uAB06\\uAB09-\\uAB0E\\uAB11-\\uAB16\\uAB20-\\uAB26\\uAB28-\\uAB2E\\uAB30-\\uAB5A\\uAB5C-\\uAB69\\uAB70-\\uABE2\\uAC00-\\uD7A3\\uD7B0-\\uD7C6\\uD7CB-\\uD7FB\\uF900-\\uFA6D\\uFA70-\\uFAD9\\uFB00-\\uFB06\\uFB13-\\uFB17\\uFB1D\\uFB1F-\\uFB28\\uFB2A-\\uFB36\\uFB38-\\uFB3C\\uFB3E\\uFB40\\uFB41\\uFB43\\uFB44\\uFB46-\\uFBB1\\uFBD3-\\uFD3D\\uFD50-\\uFD8F\\uFD92-\\uFDC7\\uFDF0-\\uFDFB\\uFE70-\\uFE74\\uFE76-\\uFEFC\\uFF21-\\uFF3A\\uFF41-\\uFF5A\\uFF66-\\uFFBE\\uFFC2-\\uFFC7\\uFFCA-\\uFFCF\\uFFD2-\\uFFD7\\uFFDA-\\uFFDC]|\\uD800[\\uDC00-\\uDC0B\\uDC0D-\\uDC26\\uDC28-\\uDC3A\\uDC3C\\uDC3D\\uDC3F-\\uDC4D\\uDC50-\\uDC5D\\uDC80-\\uDCFA\\uDE80-\\uDE9C\\uDEA0-\\uDED0\\uDF00-\\uDF1F\\uDF2D-\\uDF40\\uDF42-\\uDF49\\uDF50-\\uDF75\\uDF80-\\uDF9D\\uDFA0-\\uDFC3\\uDFC8-\\uDFCF]|\\uD801[\\uDC00-\\uDC9D\\uDCB0-\\uDCD3\\uDCD8-\\uDCFB\\uDD00-\\uDD27\\uDD30-\\uDD63\\uDD70-\\uDD7A\\uDD7C-\\uDD8A\\uDD8C-\\uDD92\\uDD94\\uDD95\\uDD97-\\uDDA1\\uDDA3-\\uDDB1\\uDDB3-\\uDDB9\\uDDBB\\uDDBC\\uDDC0-\\uDDF3\\uDE00-\\uDF36\\uDF40-\\uDF55\\uDF60-\\uDF67\\uDF80-\\uDF85\\uDF87-\\uDFB0\\uDFB2-\\uDFBA]|\\uD802[\\uDC00-\\uDC05\\uDC08\\uDC0A-\\uDC35\\uDC37\\uDC38\\uDC3C\\uDC3F-\\uDC55\\uDC60-\\uDC76\\uDC80-\\uDC9E\\uDCE0-\\uDCF2\\uDCF4\\uDCF5\\uDD00-\\uDD15\\uDD20-\\uDD39\\uDD40-\\uDD59\\uDD80-\\uDDB7\\uDDBE\\uDDBF\\uDE00\\uDE10-\\uDE13\\uDE15-\\uDE17\\uDE19-\\uDE35\\uDE60-\\uDE7C\\uDE80-\\uDE9C\\uDEC0-\\uDEC7\\uDEC9-\\uDEE4\\uDF00-\\uDF35\\uDF40-\\uDF55\\uDF60-\\uDF72\\uDF80-\\uDF91]|\\uD803[\\uDC00-\\uDC48\\uDC80-\\uDCB2\\uDCC0-\\uDCF2\\uDD00-\\uDD23\\uDD4A-\\uDD65\\uDD6F-\\uDD85\\uDE80-\\uDEA9\\uDEB0\\uDEB1\\uDEC2-\\uDEC7\\uDF00-\\uDF1C\\uDF27\\uDF30-\\uDF45\\uDF70-\\uDF81\\uDFB0-\\uDFC4\\uDFE0-\\uDFF6]|\\uD804[\\uDC03-\\uDC37\\uDC71\\uDC72\\uDC75\\uDC83-\\uDCAF\\uDCD0-\\uDCE8\\uDD03-\\uDD26\\uDD44\\uDD47\\uDD50-\\uDD72\\uDD76\\uDD83-\\uDDB2\\uDDC1-\\uDDC4\\uDDDA\\uDDDC\\uDE00-\\uDE11\\uDE13-\\uDE2B\\uDE3F\\uDE40\\uDE80-\\uDE86\\uDE88\\uDE8A-\\uDE8D\\uDE8F-\\uDE9D\\uDE9F-\\uDEA8\\uDEB0-\\uDEDE\\uDF05-\\uDF0C\\uDF0F\\uDF10\\uDF13-\\uDF28\\uDF2A-\\uDF30\\uDF32\\uDF33\\uDF35-\\uDF39\\uDF3D\\uDF50\\uDF5D-\\uDF61\\uDF80-\\uDF89\\uDF8B\\uDF8E\\uDF90-\\uDFB5\\uDFB7\\uDFD1\\uDFD3]|\\uD805[\\uDC00-\\uDC34\\uDC47-\\uDC4A\\uDC5F-\\uDC61\\uDC80-\\uDCAF\\uDCC4\\uDCC5\\uDCC7\\uDD80-\\uDDAE\\uDDD8-\\uDDDB\\uDE00-\\uDE2F\\uDE44\\uDE80-\\uDEAA\\uDEB8\\uDF00-\\uDF1A\\uDF40-\\uDF46]|\\uD806[\\uDC00-\\uDC2B\\uDCA0-\\uDCDF\\uDCFF-\\uDD06\\uDD09\\uDD0C-\\uDD13\\uDD15\\uDD16\\uDD18-\\uDD2F\\uDD3F\\uDD41\\uDDA0-\\uDDA7\\uDDAA-\\uDDD0\\uDDE1\\uDDE3\\uDE00\\uDE0B-\\uDE32\\uDE3A\\uDE50\\uDE5C-\\uDE89\\uDE9D\\uDEB0-\\uDEF8\\uDFC0-\\uDFE0]|\\uD807[\\uDC00-\\uDC08\\uDC0A-\\uDC2E\\uDC40\\uDC72-\\uDC8F\\uDD00-\\uDD06\\uDD08\\uDD09\\uDD0B-\\uDD30\\uDD46\\uDD60-\\uDD65\\uDD67\\uDD68\\uDD6A-\\uDD89\\uDD98\\uDDB0-\\uDDDB\\uDEE0-\\uDEF2\\uDF02\\uDF04-\\uDF10\\uDF12-\\uDF33\\uDFB0]|\\uD808[\\uDC00-\\uDF99]|\\uD809[\\uDC80-\\uDD43]|\\uD80B[\\uDF90-\\uDFF0]|[\\uD80C\\uD80E\\uD80F\\uD81C-\\uD822\\uD840-\\uD868\\uD86A-\\uD86D\\uD86F-\\uD872\\uD874-\\uD879\\uD880-\\uD883\\uD885-\\uD88C][\\uDC00-\\uDFFF]|\\uD80D[\\uDC00-\\uDC2F\\uDC41-\\uDC46\\uDC60-\\uDFFF]|\\uD810[\\uDC00-\\uDFFA]|\\uD811[\\uDC00-\\uDE46]|\\uD818[\\uDD00-\\uDD1D]|\\uD81A[\\uDC00-\\uDE38\\uDE40-\\uDE5E\\uDE70-\\uDEBE\\uDED0-\\uDEED\\uDF00-\\uDF2F\\uDF40-\\uDF43\\uDF63-\\uDF77\\uDF7D-\\uDF8F]|\\uD81B[\\uDD40-\\uDD6C\\uDE40-\\uDE7F\\uDEA0-\\uDEB8\\uDEBB-\\uDED3\\uDF00-\\uDF4A\\uDF50\\uDF93-\\uDF9F\\uDFE0\\uDFE1\\uDFE3\\uDFF2\\uDFF3]|\\uD823[\\uDC00-\\uDCD5\\uDCFF-\\uDD1E\\uDD80-\\uDDF2]|\\uD82B[\\uDFF0-\\uDFF3\\uDFF5-\\uDFFB\\uDFFD\\uDFFE]|\\uD82C[\\uDC00-\\uDD22\\uDD32\\uDD50-\\uDD52\\uDD55\\uDD64-\\uDD67\\uDD70-\\uDEFB]|\\uD82F[\\uDC00-\\uDC6A\\uDC70-\\uDC7C\\uDC80-\\uDC88\\uDC90-\\uDC99]|\\uD835[\\uDC00-\\uDC54\\uDC56-\\uDC9C\\uDC9E\\uDC9F\\uDCA2\\uDCA5\\uDCA6\\uDCA9-\\uDCAC\\uDCAE-\\uDCB9\\uDCBB\\uDCBD-\\uDCC3\\uDCC5-\\uDD05\\uDD07-\\uDD0A\\uDD0D-\\uDD14\\uDD16-\\uDD1C\\uDD1E-\\uDD39\\uDD3B-\\uDD3E\\uDD40-\\uDD44\\uDD46\\uDD4A-\\uDD50\\uDD52-\\uDEA5\\uDEA8-\\uDEC0\\uDEC2-\\uDEDA\\uDEDC-\\uDEFA\\uDEFC-\\uDF14\\uDF16-\\uDF34\\uDF36-\\uDF4E\\uDF50-\\uDF6E\\uDF70-\\uDF88\\uDF8A-\\uDFA8\\uDFAA-\\uDFC2\\uDFC4-\\uDFCB]|\\uD837[\\uDF00-\\uDF1E\\uDF25-\\uDF2A]|\\uD838[\\uDC30-\\uDC6D\\uDD00-\\uDD2C\\uDD37-\\uDD3D\\uDD4E\\uDE90-\\uDEAD\\uDEC0-\\uDEEB]|\\uD839[\\uDCD0-\\uDCEB\\uDDD0-\\uDDED\\uDDF0\\uDEC0-\\uDEDE\\uDEE0-\\uDEE2\\uDEE4\\uDEE5\\uDEE7-\\uDEED\\uDEF0-\\uDEF4\\uDEFE\\uDEFF\\uDFE0-\\uDFE6\\uDFE8-\\uDFEB\\uDFED\\uDFEE\\uDFF0-\\uDFFE]|\\uD83A[\\uDC00-\\uDCC4\\uDD00-\\uDD43\\uDD4B]|\\uD83B[\\uDE00-\\uDE03\\uDE05-\\uDE1F\\uDE21\\uDE22\\uDE24\\uDE27\\uDE29-\\uDE32\\uDE34-\\uDE37\\uDE39\\uDE3B\\uDE42\\uDE47\\uDE49\\uDE4B\\uDE4D-\\uDE4F\\uDE51\\uDE52\\uDE54\\uDE57\\uDE59\\uDE5B\\uDE5D\\uDE5F\\uDE61\\uDE62\\uDE64\\uDE67-\\uDE6A\\uDE6C-\\uDE72\\uDE74-\\uDE77\\uDE79-\\uDE7C\\uDE7E\\uDE80-\\uDE89\\uDE8B-\\uDE9B\\uDEA1-\\uDEA3\\uDEA5-\\uDEA9\\uDEAB-\\uDEBB]|\\uD869[\\uDC00-\\uDEDF\\uDF00-\\uDFFF]|\\uD86E[\\uDC00-\\uDC1D\\uDC20-\\uDFFF]|\\uD873[\\uDC00-\\uDEAD\\uDEB0-\\uDFFF]|\\uD87A[\\uDC00-\\uDFE0\\uDFF0-\\uDFFF]|\\uD87B[\\uDC00-\\uDE5D]|\\uD87E[\\uDC00-\\uDE1D]|\\uD884[\\uDC00-\\uDF4A\\uDF50-\\uDFFF]|\\uD88D[\\uDC00-\\uDC79])*$/.test(lr)},{name:"string",test:isString},{name:"Chain",test:isChain},{name:"Array",test:isArray},{name:"Matrix",test:isMatrix},{name:"DenseMatrix",test:isDenseMatrix},{name:"SparseMatrix",test:isSparseMatrix},{name:"Range",test:isRange},{name:"Index",test:isIndex},{name:"boolean",test:isBoolean$1},{name:"ResultSet",test:isResultSet},{name:"Help",test:isHelp},{name:"function",test:isFunction$1},{name:"Date",test:isDate},{name:"RegExp",test:isRegExp},{name:"null",test:isNull$1},{name:"undefined",test:isUndefined$1},{name:"AccessorNode",test:isAccessorNode},{name:"ArrayNode",test:isArrayNode},{name:"AssignmentNode",test:isAssignmentNode},{name:"BlockNode",test:isBlockNode},{name:"ConditionalNode",test:isConditionalNode},{name:"ConstantNode",test:isConstantNode},{name:"FunctionNode",test:isFunctionNode},{name:"FunctionAssignmentNode",test:isFunctionAssignmentNode},{name:"IndexNode",test:isIndexNode},{name:"Node",test:isNode},{name:"ObjectNode",test:isObjectNode},{name:"OperatorNode",test:isOperatorNode},{name:"ParenthesisNode",test:isParenthesisNode},{name:"RangeNode",test:isRangeNode},{name:"RelationalNode",test:isRelationalNode},{name:"SymbolNode",test:isSymbolNode},{name:"Map",test:isMap},{name:"Object",test:isObject$1}]),_t.addConversions([{from:"number",to:"BigNumber",convert:function(lr){if(E||throwNoBignumber(lr),digits(lr)>15)throw TypeError("Cannot implicitly convert a number with >15 significant digits to BigNumber (value: "+lr+"). Use function bignumber(x) to convert to BigNumber.");return new E(lr)}},{from:"number",to:"Complex",convert:function(lr){return F||throwNoComplex(lr),new F(lr,0)}},{from:"BigNumber",to:"Complex",convert:function(lr){return F||throwNoComplex(lr),new F(lr.toNumber(),0)}},{from:"bigint",to:"number",convert:function(lr){if(lr>2**53-1)throw TypeError("Cannot implicitly convert bigint to number: value exceeds the max safe integer value (value: "+lr+")");return Number(lr)}},{from:"bigint",to:"BigNumber",convert:function(lr){return E||throwNoBignumber(lr),new E(lr.toString())}},{from:"bigint",to:"Fraction",convert:function(lr){return $e||throwNoFraction(lr),new $e(lr)}},{from:"Fraction",to:"BigNumber",convert:function(lr){throw TypeError("Cannot implicitly convert a Fraction to BigNumber or vice versa. Use function bignumber(x) to convert to BigNumber or fraction(x) to convert to Fraction.")}},{from:"Fraction",to:"Complex",convert:function(lr){return F||throwNoComplex(lr),new F(lr.valueOf(),0)}},{from:"number",to:"Fraction",convert:function(lr){$e||throwNoFraction(lr);var mr=new $e(lr);if(mr.valueOf()!==lr)throw TypeError("Cannot implicitly convert a number to a Fraction when there will be a loss of precision (value: "+lr+"). Use function fraction(x) to convert to Fraction.");return mr}},{from:"string",to:"number",convert:function(lr){var mr=Number(lr);if(isNaN(mr))throw Error(\'Cannot convert "\'+lr+\'" to a number\');return mr}},{from:"string",to:"BigNumber",convert:function(lr){E||throwNoBignumber(lr);try{return new E(lr)}catch{throw Error(\'Cannot convert "\'+lr+\'" to BigNumber\')}}},{from:"string",to:"bigint",convert:function(lr){try{return BigInt(lr)}catch{throw Error(\'Cannot convert "\'+lr+\'" to BigInt\')}}},{from:"string",to:"Fraction",convert:function(lr){$e||throwNoFraction(lr);try{return new $e(lr)}catch{throw Error(\'Cannot convert "\'+lr+\'" to Fraction\')}}},{from:"string",to:"Complex",convert:function(lr){F||throwNoComplex(lr);try{return new F(lr)}catch{throw Error(\'Cannot convert "\'+lr+\'" to Complex\')}}},{from:"boolean",to:"number",convert:function(lr){return+lr}},{from:"boolean",to:"BigNumber",convert:function(lr){return E||throwNoBignumber(lr),new E(+lr)}},{from:"boolean",to:"bigint",convert:function(lr){return BigInt(+lr)}},{from:"boolean",to:"Fraction",convert:function(lr){return $e||throwNoFraction(lr),new $e(+lr)}},{from:"boolean",to:"string",convert:function(lr){return String(lr)}},{from:"Array",to:"Matrix",convert:function(lr){return J||throwNoMatrix(),new J(lr)}},{from:"Matrix",to:"Array",convert:function(lr){return lr.valueOf()}}]),_t.onMismatch=(lr,mr,Or)=>{var Pr=_t.createError(lr,mr,Or);if(["wrongType","mismatch"].includes(Pr.data.category)&&mr.length===1&&isCollection(mr[0])&&Or.some(gi=>!gi.params.includes(","))){var dn=TypeError(`Function \'${lr}\' doesn\'t apply to matrices. To call it elementwise on a matrix \'M\', try \'map(M, ${lr})\'.`);throw dn.data=Pr.data,dn}throw Pr},_t.onMismatch=(lr,mr,Or)=>{var Pr=_t.createError(lr,mr,Or);if(["wrongType","mismatch"].includes(Pr.data.category)&&mr.length===1&&isCollection(mr[0])&&Or.some(gi=>!gi.params.includes(","))){var dn=TypeError(`Function \'${lr}\' doesn\'t apply to matrices. To call it elementwise on a matrix \'M\', try \'map(M, ${lr})\'.`);throw dn.data=Pr.data,dn}throw Pr},_t});function throwNoBignumber(D){throw Error(`Cannot convert value ${D} into a BigNumber: no class \'BigNumber\' provided`)}function throwNoComplex(D){throw Error(`Cannot convert value ${D} into a Complex number: no class \'Complex\' provided`)}function throwNoMatrix(){throw Error("Cannot convert array into a Matrix: no class \'DenseMatrix\' provided")}function throwNoFraction(D){throw Error(`Cannot convert value ${D} into a Fraction, no class \'Fraction\' provided.`)}var name$321="ResultSet",dependencies$321=[],createResultSet=factory(name$321,dependencies$321,()=>{function D(E){if(!(this instanceof D))throw SyntaxError("Constructor must be called with the new operator");this.entries=E||[]}return D.prototype.type="ResultSet",D.prototype.isResultSet=!0,D.prototype.valueOf=function(){return this.entries},D.prototype.toString=function(){return"["+this.entries.map(String).join(", ")+"]"},D.prototype.toJSON=function(){return{mathjs:"ResultSet",entries:this.entries}},D.fromJSON=function(E){return new D(E.entries)},D},{isClass:!0}),EXP_LIMIT=9e15,MAX_DIGITS=1e9,NUMERALS="0123456789abcdef",LN10="2.3025850929940456840179914546843642076011014886287729760333279009675726096773524802359972050895982983419677840422862486334095254650828067566662873690987816894829072083255546808437998948262331985283935053089653777326288461633662222876982198867465436674744042432743651550489343149393914796194044002221051017141748003688084012647080685567743216228355220114804663715659121373450747856947683463616792101806445070648000277502684916746550586856935673420670581136429224554405758925724208241314695689016758940256776311356919292033376587141660230105703089634572075440370847469940168269282808481184289314848524948644871927809676271275775397027668605952496716674183485704422507197965004714951050492214776567636938662976979522110718264549734772662425709429322582798502585509785265383207606726317164309505995087807523710333101197857547331541421808427543863591778117054309827482385045648019095610299291824318237525357709750539565187697510374970888692180205189339507238539205144634197265287286965110862571492198849978748873771345686209167058",PI="3.1415926535897932384626433832795028841971693993751058209749445923078164062862089986280348253421170679821480865132823066470938446095505822317253594081284811174502841027019385211055596446229489549303819644288109756659334461284756482337867831652712019091456485669234603486104543266482133936072602491412737245870066063155881748815209209628292540917153643678925903600113305305488204665213841469519415116094330572703657595919530921861173819326117931051185480744623799627495673518857527248912279381830119491298336733624406566430860213949463952247371907021798609437027705392171762931767523846748184676694051320005681271452635608277857713427577896091736371787214684409012249534301465495853710507922796892589235420199561121290219608640344181598136297747713099605187072113499999983729780499510597317328160963185950244594553469083026425223082533446850352619311881710100031378387528865875332083814206171776691473035982534904287554687311595628638823537875937519577818577805321712268066130019278766111959092164201989380952572010654858632789",DEFAULTS={precision:20,rounding:4,modulo:1,toExpNeg:-7,toExpPos:21,minE:-EXP_LIMIT,maxE:EXP_LIMIT,crypto:!1},inexact,quadrant,external=!0,decimalError="[DecimalError] ",invalidArgument=decimalError+"Invalid argument: ",precisionLimitExceeded=decimalError+"Precision limit exceeded",cryptoUnavailable=decimalError+"crypto unavailable",tag="[object Decimal]",mathfloor=Math.floor,mathpow=Math.pow,isBinary=/^0b([01]+(\\.[01]*)?|\\.[01]+)(p[+-]?\\d+)?$/i,isHex=/^0x([0-9a-f]+(\\.[0-9a-f]*)?|\\.[0-9a-f]+)(p[+-]?\\d+)?$/i,isOctal=/^0o([0-7]+(\\.[0-7]*)?|\\.[0-7]+)(p[+-]?\\d+)?$/i,isDecimal=/^(\\d+(\\.\\d*)?|\\.\\d+)(e[+-]?\\d+)?$/i,BASE=1e7,LOG_BASE=7,MAX_SAFE_INTEGER=9007199254740991,LN10_PRECISION=LN10.length-1,PI_PRECISION=PI.length-1,P$3={toStringTag:tag};P$3.absoluteValue=P$3.abs=function(){var D=new this.constructor(this);return D.s<0&&(D.s=1),finalise(D)},P$3.ceil=function(){return finalise(new this.constructor(this),this.e+1,2)},P$3.clampedTo=P$3.clamp=function(D,E){var F,J=this,$e=J.constructor;if(D=new $e(D),E=new $e(E),!D.s||!E.s)return new $e(NaN);if(D.gt(E))throw Error(invalidArgument+E);return F=J.cmp(D),F<0?D:J.cmp(E)>0?E:new $e(J)},P$3.comparedTo=P$3.cmp=function(D){var E,F,J,$e,_t=this,lr=_t.d,mr=(D=new _t.constructor(D)).d,Or=_t.s,Pr=D.s;if(!lr||!mr)return!Or||!Pr?NaN:Or===Pr?lr===mr?0:!lr^Or<0?1:-1:Or;if(!lr[0]||!mr[0])return lr[0]?Or:mr[0]?-Pr:0;if(Or!==Pr)return Or;if(_t.e!==D.e)return _t.e>D.e^Or<0?1:-1;for(J=lr.length,$e=mr.length,E=0,F=J<$e?J:$e;E<F;++E)if(lr[E]!==mr[E])return lr[E]>mr[E]^Or<0?1:-1;return J===$e?0:J>$e^Or<0?1:-1},P$3.cosine=P$3.cos=function(){var D,E,F=this,J=F.constructor;return F.d?F.d[0]?(D=J.precision,E=J.rounding,J.precision=D+Math.max(F.e,F.sd())+LOG_BASE,J.rounding=1,F=cosine(J,toLessThanHalfPi(J,F)),J.precision=D,J.rounding=E,finalise(quadrant==2||quadrant==3?F.neg():F,D,E,!0)):new J(1):new J(NaN)},P$3.cubeRoot=P$3.cbrt=function(){var D,E,F,J,$e,_t,lr,mr,Or,Pr,dn=this,gi=dn.constructor;if(!dn.isFinite()||dn.isZero())return new gi(dn);for(external=!1,_t=dn.s*mathpow(dn.s*dn,1/3),!_t||Math.abs(_t)==1/0?(F=digitsToString(dn.d),D=dn.e,(_t=(D-F.length+1)%3)&&(F+=_t==1||_t==-2?"0":"00"),_t=mathpow(F,1/3),D=mathfloor((D+1)/3)-(D%3==(D<0?-1:2)),_t==1/0?F="5e"+D:(F=_t.toExponential(),F=F.slice(0,F.indexOf("e")+1)+D),J=new gi(F),J.s=dn.s):J=new gi(_t.toString()),lr=(D=gi.precision)+3;;)if(mr=J,Or=mr.times(mr).times(mr),Pr=Or.plus(dn),J=divide$1(Pr.plus(dn).times(mr),Pr.plus(Or),lr+2,1),digitsToString(mr.d).slice(0,lr)===(F=digitsToString(J.d)).slice(0,lr))if(F=F.slice(lr-3,lr+1),F=="9999"||!$e&&F=="4999"){if(!$e&&(finalise(mr,D+1,0),mr.times(mr).times(mr).eq(dn))){J=mr;break}lr+=4,$e=1}else{(!+F||!+F.slice(1)&&F.charAt(0)=="5")&&(finalise(J,D+1,1),E=!J.times(J).times(J).eq(dn));break}return external=!0,finalise(J,D,gi.rounding,E)},P$3.decimalPlaces=P$3.dp=function(){var D,E=this.d,F=NaN;if(E){if(D=E.length-1,F=(D-mathfloor(this.e/LOG_BASE))*LOG_BASE,D=E[D],D)for(;D%10==0;D/=10)F--;F<0&&(F=0)}return F},P$3.dividedBy=P$3.div=function(D){return divide$1(this,new this.constructor(D))},P$3.dividedToIntegerBy=P$3.divToInt=function(D){var E=this,F=E.constructor;return finalise(divide$1(E,new F(D),0,1,1),F.precision,F.rounding)},P$3.equals=P$3.eq=function(D){return this.cmp(D)===0},P$3.floor=function(){return finalise(new this.constructor(this),this.e+1,3)},P$3.greaterThan=P$3.gt=function(D){return this.cmp(D)>0},P$3.greaterThanOrEqualTo=P$3.gte=function(D){var E=this.cmp(D);return E==1||E===0},P$3.hyperbolicCosine=P$3.cosh=function(){var D,E,F,J,$e,_t=this,lr=_t.constructor,mr=new lr(1);if(!_t.isFinite())return new lr(_t.s?1/0:NaN);if(_t.isZero())return mr;F=lr.precision,J=lr.rounding,lr.precision=F+Math.max(_t.e,_t.sd())+4,lr.rounding=1,$e=_t.d.length,$e<32?(D=Math.ceil($e/3),E=(1/tinyPow(4,D)).toString()):(D=16,E="2.3283064365386962890625e-10"),_t=taylorSeries(lr,1,_t.times(E),new lr(1),!0);for(var Or,Pr=D,dn=new lr(8);Pr--;)Or=_t.times(_t),_t=mr.minus(Or.times(dn.minus(Or.times(dn))));return finalise(_t,lr.precision=F,lr.rounding=J,!0)},P$3.hyperbolicSine=P$3.sinh=function(){var D,E,F,J,$e=this,_t=$e.constructor;if(!$e.isFinite()||$e.isZero())return new _t($e);if(E=_t.precision,F=_t.rounding,_t.precision=E+Math.max($e.e,$e.sd())+4,_t.rounding=1,J=$e.d.length,J<3)$e=taylorSeries(_t,2,$e,$e,!0);else{D=1.4*Math.sqrt(J),D=D>16?16:D|0,$e=$e.times(1/tinyPow(5,D)),$e=taylorSeries(_t,2,$e,$e,!0);for(var lr,mr=new _t(5),Or=new _t(16),Pr=new _t(20);D--;)lr=$e.times($e),$e=$e.times(mr.plus(lr.times(Or.times(lr).plus(Pr))))}return _t.precision=E,_t.rounding=F,finalise($e,E,F,!0)},P$3.hyperbolicTangent=P$3.tanh=function(){var D,E,F=this,J=F.constructor;return F.isFinite()?F.isZero()?new J(F):(D=J.precision,E=J.rounding,J.precision=D+7,J.rounding=1,divide$1(F.sinh(),F.cosh(),J.precision=D,J.rounding=E)):new J(F.s)},P$3.inverseCosine=P$3.acos=function(){var D,E=this,F=E.constructor,J=E.abs().cmp(1),$e=F.precision,_t=F.rounding;return J===-1?E.isZero()?getPi(F,$e+4,_t).times(.5):(F.precision=$e+6,F.rounding=1,E=E.asin(),D=getPi(F,$e+4,_t).times(.5),F.precision=$e,F.rounding=_t,D.minus(E)):J===0?E.isNeg()?getPi(F,$e,_t):new F(0):new F(NaN)},P$3.inverseHyperbolicCosine=P$3.acosh=function(){var D,E,F=this,J=F.constructor;return F.lte(1)?new J(F.eq(1)?0:NaN):F.isFinite()?(D=J.precision,E=J.rounding,J.precision=D+Math.max(Math.abs(F.e),F.sd())+4,J.rounding=1,external=!1,F=F.times(F).minus(1).sqrt().plus(F),external=!0,J.precision=D,J.rounding=E,F.ln()):new J(F)},P$3.inverseHyperbolicSine=P$3.asinh=function(){var D,E,F=this,J=F.constructor;return!F.isFinite()||F.isZero()?new J(F):(D=J.precision,E=J.rounding,J.precision=D+2*Math.max(Math.abs(F.e),F.sd())+6,J.rounding=1,external=!1,F=F.times(F).plus(1).sqrt().plus(F),external=!0,J.precision=D,J.rounding=E,F.ln())},P$3.inverseHyperbolicTangent=P$3.atanh=function(){var D,E,F,J,$e=this,_t=$e.constructor;return $e.isFinite()?$e.e>=0?new _t($e.abs().eq(1)?$e.s/0:$e.isZero()?$e:NaN):(D=_t.precision,E=_t.rounding,J=$e.sd(),Math.max(J,D)<2*-$e.e-1?finalise(new _t($e),D,E,!0):(_t.precision=F=J-$e.e,$e=divide$1($e.plus(1),new _t(1).minus($e),F+D,1),_t.precision=D+4,_t.rounding=1,$e=$e.ln(),_t.precision=D,_t.rounding=E,$e.times(.5))):new _t(NaN)},P$3.inverseSine=P$3.asin=function(){var D,E,F,J,$e=this,_t=$e.constructor;return $e.isZero()?new _t($e):(E=$e.abs().cmp(1),F=_t.precision,J=_t.rounding,E===-1?(_t.precision=F+6,_t.rounding=1,$e=$e.div(new _t(1).minus($e.times($e)).sqrt().plus(1)).atan(),_t.precision=F,_t.rounding=J,$e.times(2)):E===0?(D=getPi(_t,F+4,J).times(.5),D.s=$e.s,D):new _t(NaN))},P$3.inverseTangent=P$3.atan=function(){var D,E,F,J,$e,_t,lr,mr,Or,Pr=this,dn=Pr.constructor,gi=dn.precision,qi=dn.rounding;if(Pr.isFinite()){if(Pr.isZero())return new dn(Pr);if(Pr.abs().eq(1)&&gi+4<=PI_PRECISION)return lr=getPi(dn,gi+4,qi).times(.25),lr.s=Pr.s,lr}else{if(!Pr.s)return new dn(NaN);if(gi+4<=PI_PRECISION)return lr=getPi(dn,gi+4,qi).times(.5),lr.s=Pr.s,lr}for(dn.precision=mr=gi+10,dn.rounding=1,F=Math.min(28,mr/LOG_BASE+2|0),D=F;D;--D)Pr=Pr.div(Pr.times(Pr).plus(1).sqrt().plus(1));for(external=!1,E=Math.ceil(mr/LOG_BASE),J=1,Or=Pr.times(Pr),lr=new dn(Pr),$e=Pr;D!==-1;)if($e=$e.times(Or),_t=lr.minus($e.div(J+=2)),$e=$e.times(Or),lr=_t.plus($e.div(J+=2)),lr.d[E]!==void 0)for(D=E;lr.d[D]===_t.d[D]&&D--;);return F&&(lr=lr.times(2<<F-1)),external=!0,finalise(lr,dn.precision=gi,dn.rounding=qi,!0)},P$3.isFinite=function(){return!!this.d},P$3.isInteger=P$3.isInt=function(){return!!this.d&&mathfloor(this.e/LOG_BASE)>this.d.length-2},P$3.isNaN=function(){return!this.s},P$3.isNegative=P$3.isNeg=function(){return this.s<0},P$3.isPositive=P$3.isPos=function(){return this.s>0},P$3.isZero=function(){return!!this.d&&this.d[0]===0},P$3.lessThan=P$3.lt=function(D){return this.cmp(D)<0},P$3.lessThanOrEqualTo=P$3.lte=function(D){return this.cmp(D)<1},P$3.logarithm=P$3.log=function(D){var E,F,J,$e,_t,lr,mr,Or,Pr=this,dn=Pr.constructor,gi=dn.precision,qi=dn.rounding,zi=5;if(D==null)D=new dn(10),E=!0;else{if(D=new dn(D),F=D.d,D.s<0||!F||!F[0]||D.eq(1))return new dn(NaN);E=D.eq(10)}if(F=Pr.d,Pr.s<0||!F||!F[0]||Pr.eq(1))return new dn(F&&!F[0]?-1/0:Pr.s==1?F?0:1/0:NaN);if(E)if(F.length>1)_t=!0;else{for($e=F[0];$e%10==0;)$e/=10;_t=$e!==1}if(external=!1,mr=gi+zi,lr=naturalLogarithm(Pr,mr),J=E?getLn10(dn,mr+10):naturalLogarithm(D,mr),Or=divide$1(lr,J,mr,1),checkRoundingDigits(Or.d,$e=gi,qi))do if(mr+=10,lr=naturalLogarithm(Pr,mr),J=E?getLn10(dn,mr+10):naturalLogarithm(D,mr),Or=divide$1(lr,J,mr,1),!_t){+digitsToString(Or.d).slice($e+1,$e+15)+1==1e14&&(Or=finalise(Or,gi+1,0));break}while(checkRoundingDigits(Or.d,$e+=10,qi));return external=!0,finalise(Or,gi,qi)},P$3.minus=P$3.sub=function(D){var E,F,J,$e,_t,lr,mr,Or,Pr,dn,gi,qi,zi=this,Hi=zi.constructor;if(D=new Hi(D),!zi.d||!D.d)return!zi.s||!D.s?D=new Hi(NaN):zi.d?D.s=-D.s:D=new Hi(D.d||zi.s!==D.s?zi:NaN),D;if(zi.s!=D.s)return D.s=-D.s,zi.plus(D);if(Pr=zi.d,qi=D.d,mr=Hi.precision,Or=Hi.rounding,!Pr[0]||!qi[0]){if(qi[0])D.s=-D.s;else if(Pr[0])D=new Hi(zi);else return new Hi(Or===3?-0:0);return external?finalise(D,mr,Or):D}if(F=mathfloor(D.e/LOG_BASE),dn=mathfloor(zi.e/LOG_BASE),Pr=Pr.slice(),_t=dn-F,_t){for(gi=_t<0,gi?(E=Pr,_t=-_t,lr=qi.length):(E=qi,F=dn,lr=Pr.length),J=Math.max(Math.ceil(mr/LOG_BASE),lr)+2,_t>J&&(_t=J,E.length=1),E.reverse(),J=_t;J--;)E.push(0);E.reverse()}else{for(J=Pr.length,lr=qi.length,gi=J<lr,gi&&(lr=J),J=0;J<lr;J++)if(Pr[J]!=qi[J]){gi=Pr[J]<qi[J];break}_t=0}for(gi&&(E=Pr,Pr=qi,qi=E,D.s=-D.s),lr=Pr.length,J=qi.length-lr;J>0;--J)Pr[lr++]=0;for(J=qi.length;J>_t;){if(Pr[--J]<qi[J]){for($e=J;$e&&Pr[--$e]===0;)Pr[$e]=BASE-1;--Pr[$e],Pr[J]+=BASE}Pr[J]-=qi[J]}for(;Pr[--lr]===0;)Pr.pop();for(;Pr[0]===0;Pr.shift())--F;return Pr[0]?(D.d=Pr,D.e=getBase10Exponent(Pr,F),external?finalise(D,mr,Or):D):new Hi(Or===3?-0:0)},P$3.modulo=P$3.mod=function(D){var E,F=this,J=F.constructor;return D=new J(D),!F.d||!D.s||D.d&&!D.d[0]?new J(NaN):!D.d||F.d&&!F.d[0]?finalise(new J(F),J.precision,J.rounding):(external=!1,J.modulo==9?(E=divide$1(F,D.abs(),0,3,1),E.s*=D.s):E=divide$1(F,D,0,J.modulo,1),E=E.times(D),external=!0,F.minus(E))},P$3.naturalExponential=P$3.exp=function(){return naturalExponential(this)},P$3.naturalLogarithm=P$3.ln=function(){return naturalLogarithm(this)},P$3.negated=P$3.neg=function(){var D=new this.constructor(this);return D.s=-D.s,finalise(D)},P$3.plus=P$3.add=function(D){var E,F,J,$e,_t,lr,mr,Or,Pr,dn,gi=this,qi=gi.constructor;if(D=new qi(D),!gi.d||!D.d)return!gi.s||!D.s?D=new qi(NaN):gi.d||(D=new qi(D.d||gi.s===D.s?gi:NaN)),D;if(gi.s!=D.s)return D.s=-D.s,gi.minus(D);if(Pr=gi.d,dn=D.d,mr=qi.precision,Or=qi.rounding,!Pr[0]||!dn[0])return dn[0]||(D=new qi(gi)),external?finalise(D,mr,Or):D;if(_t=mathfloor(gi.e/LOG_BASE),J=mathfloor(D.e/LOG_BASE),Pr=Pr.slice(),$e=_t-J,$e){for($e<0?(F=Pr,$e=-$e,lr=dn.length):(F=dn,J=_t,lr=Pr.length),_t=Math.ceil(mr/LOG_BASE),lr=_t>lr?_t+1:lr+1,$e>lr&&($e=lr,F.length=1),F.reverse();$e--;)F.push(0);F.reverse()}for(lr=Pr.length,$e=dn.length,lr-$e<0&&($e=lr,F=dn,dn=Pr,Pr=F),E=0;$e;)E=(Pr[--$e]=Pr[$e]+dn[$e]+E)/BASE|0,Pr[$e]%=BASE;for(E&&(Pr.unshift(E),++J),lr=Pr.length;Pr[--lr]==0;)Pr.pop();return D.d=Pr,D.e=getBase10Exponent(Pr,J),external?finalise(D,mr,Or):D},P$3.precision=P$3.sd=function(D){var E,F=this;if(D!==void 0&&D!==!!D&&D!==1&&D!==0)throw Error(invalidArgument+D);return F.d?(E=getPrecision(F.d),D&&F.e+1>E&&(E=F.e+1)):E=NaN,E},P$3.round=function(){var D=this,E=D.constructor;return finalise(new E(D),D.e+1,E.rounding)},P$3.sine=P$3.sin=function(){var D,E,F=this,J=F.constructor;return F.isFinite()?F.isZero()?new J(F):(D=J.precision,E=J.rounding,J.precision=D+Math.max(F.e,F.sd())+LOG_BASE,J.rounding=1,F=sine(J,toLessThanHalfPi(J,F)),J.precision=D,J.rounding=E,finalise(quadrant>2?F.neg():F,D,E,!0)):new J(NaN)},P$3.squareRoot=P$3.sqrt=function(){var D,E,F,J,$e,_t,lr=this,mr=lr.d,Or=lr.e,Pr=lr.s,dn=lr.constructor;if(Pr!==1||!mr||!mr[0])return new dn(!Pr||Pr<0&&(!mr||mr[0])?NaN:mr?lr:1/0);for(external=!1,Pr=Math.sqrt(+lr),Pr==0||Pr==1/0?(E=digitsToString(mr),(E.length+Or)%2==0&&(E+="0"),Pr=Math.sqrt(E),Or=mathfloor((Or+1)/2)-(Or<0||Or%2),Pr==1/0?E="5e"+Or:(E=Pr.toExponential(),E=E.slice(0,E.indexOf("e")+1)+Or),J=new dn(E)):J=new dn(Pr.toString()),F=(Or=dn.precision)+3;;)if(_t=J,J=_t.plus(divide$1(lr,_t,F+2,1)).times(.5),digitsToString(_t.d).slice(0,F)===(E=digitsToString(J.d)).slice(0,F))if(E=E.slice(F-3,F+1),E=="9999"||!$e&&E=="4999"){if(!$e&&(finalise(_t,Or+1,0),_t.times(_t).eq(lr))){J=_t;break}F+=4,$e=1}else{(!+E||!+E.slice(1)&&E.charAt(0)=="5")&&(finalise(J,Or+1,1),D=!J.times(J).eq(lr));break}return external=!0,finalise(J,Or,dn.rounding,D)},P$3.tangent=P$3.tan=function(){var D,E,F=this,J=F.constructor;return F.isFinite()?F.isZero()?new J(F):(D=J.precision,E=J.rounding,J.precision=D+10,J.rounding=1,F=F.sin(),F.s=1,F=divide$1(F,new J(1).minus(F.times(F)).sqrt(),D+10,0),J.precision=D,J.rounding=E,finalise(quadrant==2||quadrant==4?F.neg():F,D,E,!0)):new J(NaN)},P$3.times=P$3.mul=function(D){var E,F,J,$e,_t,lr,mr,Or,Pr,dn=this,gi=dn.constructor,qi=dn.d,zi=(D=new gi(D)).d;if(D.s*=dn.s,!qi||!qi[0]||!zi||!zi[0])return new gi(!D.s||qi&&!qi[0]&&!zi||zi&&!zi[0]&&!qi?NaN:!qi||!zi?D.s/0:D.s*0);for(F=mathfloor(dn.e/LOG_BASE)+mathfloor(D.e/LOG_BASE),Or=qi.length,Pr=zi.length,Or<Pr&&(_t=qi,qi=zi,zi=_t,lr=Or,Or=Pr,Pr=lr),_t=[],lr=Or+Pr,J=lr;J--;)_t.push(0);for(J=Pr;--J>=0;){for(E=0,$e=Or+J;$e>J;)mr=_t[$e]+zi[J]*qi[$e-J-1]+E,_t[$e--]=mr%BASE|0,E=mr/BASE|0;_t[$e]=(_t[$e]+E)%BASE|0}for(;!_t[--lr];)_t.pop();return E?++F:_t.shift(),D.d=_t,D.e=getBase10Exponent(_t,F),external?finalise(D,gi.precision,gi.rounding):D},P$3.toBinary=function(D,E){return toStringBinary(this,2,D,E)},P$3.toDecimalPlaces=P$3.toDP=function(D,E){var F=this,J=F.constructor;return F=new J(F),D===void 0?F:(checkInt32(D,0,MAX_DIGITS),E===void 0?E=J.rounding:checkInt32(E,0,8),finalise(F,D+F.e+1,E))},P$3.toExponential=function(D,E){var F,J=this,$e=J.constructor;return D===void 0?F=finiteToString(J,!0):(checkInt32(D,0,MAX_DIGITS),E===void 0?E=$e.rounding:checkInt32(E,0,8),J=finalise(new $e(J),D+1,E),F=finiteToString(J,!0,D+1)),J.isNeg()&&!J.isZero()?"-"+F:F},P$3.toFixed=function(D,E){var F,J,$e=this,_t=$e.constructor;return D===void 0?F=finiteToString($e):(checkInt32(D,0,MAX_DIGITS),E===void 0?E=_t.rounding:checkInt32(E,0,8),J=finalise(new _t($e),D+$e.e+1,E),F=finiteToString(J,!1,D+J.e+1)),$e.isNeg()&&!$e.isZero()?"-"+F:F},P$3.toFraction=function(D){var E,F,J,$e,_t,lr,mr,Or,Pr,dn,gi,qi,zi=this,Hi=zi.d,Qi=zi.constructor;if(!Hi)return new Qi(zi);if(Pr=F=new Qi(1),J=Or=new Qi(0),E=new Qi(J),_t=E.e=getPrecision(Hi)-zi.e-1,lr=_t%LOG_BASE,E.d[0]=mathpow(10,lr<0?LOG_BASE+lr:lr),D==null)D=_t>0?E:Pr;else{if(mr=new Qi(D),!mr.isInt()||mr.lt(Pr))throw Error(invalidArgument+mr);D=mr.gt(E)?_t>0?E:Pr:mr}for(external=!1,mr=new Qi(digitsToString(Hi)),dn=Qi.precision,Qi.precision=_t=Hi.length*LOG_BASE*2;gi=divide$1(mr,E,0,1,1),$e=F.plus(gi.times(J)),$e.cmp(D)!=1;)F=J,J=$e,$e=Pr,Pr=Or.plus(gi.times($e)),Or=$e,$e=E,E=mr.minus(gi.times($e)),mr=$e;return $e=divide$1(D.minus(F),J,0,1,1),Or=Or.plus($e.times(Pr)),F=F.plus($e.times(J)),Or.s=Pr.s=zi.s,qi=divide$1(Pr,J,_t,1).minus(zi).abs().cmp(divide$1(Or,F,_t,1).minus(zi).abs())<1?[Pr,J]:[Or,F],Qi.precision=dn,external=!0,qi},P$3.toHexadecimal=P$3.toHex=function(D,E){return toStringBinary(this,16,D,E)},P$3.toNearest=function(D,E){var F=this,J=F.constructor;if(F=new J(F),D==null){if(!F.d)return F;D=new J(1),E=J.rounding}else{if(D=new J(D),E===void 0?E=J.rounding:checkInt32(E,0,8),!F.d)return D.s?F:D;if(!D.d)return D.s&&=F.s,D}return D.d[0]?(external=!1,F=divide$1(F,D,0,E,1).times(D),external=!0,finalise(F)):(D.s=F.s,F=D),F},P$3.toNumber=function(){return+this},P$3.toOctal=function(D,E){return toStringBinary(this,8,D,E)},P$3.toPower=P$3.pow=function(D){var E,F,J,$e,_t,lr,mr=this,Or=mr.constructor,Pr=+(D=new Or(D));if(!mr.d||!D.d||!mr.d[0]||!D.d[0])return new Or(mathpow(+mr,Pr));if(mr=new Or(mr),mr.eq(1))return mr;if(J=Or.precision,_t=Or.rounding,D.eq(1))return finalise(mr,J,_t);if(E=mathfloor(D.e/LOG_BASE),E>=D.d.length-1&&(F=Pr<0?-Pr:Pr)<=MAX_SAFE_INTEGER)return $e=intPow(Or,mr,F,J),D.s<0?new Or(1).div($e):finalise($e,J,_t);if(lr=mr.s,lr<0){if(E<D.d.length-1)return new Or(NaN);if(D.d[E]&1||(lr=1),mr.e==0&&mr.d[0]==1&&mr.d.length==1)return mr.s=lr,mr}return F=mathpow(+mr,Pr),E=F==0||!isFinite(F)?mathfloor(Pr*(Math.log("0."+digitsToString(mr.d))/Math.LN10+mr.e+1)):new Or(F+"").e,E>Or.maxE+1||E<Or.minE-1?new Or(E>0?lr/0:0):(external=!1,Or.rounding=mr.s=1,F=Math.min(12,(E+"").length),$e=naturalExponential(D.times(naturalLogarithm(mr,J+F)),J),$e.d&&($e=finalise($e,J+5,1),checkRoundingDigits($e.d,J,_t)&&(E=J+10,$e=finalise(naturalExponential(D.times(naturalLogarithm(mr,E+F)),E),E+5,1),+digitsToString($e.d).slice(J+1,J+15)+1==1e14&&($e=finalise($e,J+1,0)))),$e.s=lr,external=!0,Or.rounding=_t,finalise($e,J,_t))},P$3.toPrecision=function(D,E){var F,J=this,$e=J.constructor;return D===void 0?F=finiteToString(J,J.e<=$e.toExpNeg||J.e>=$e.toExpPos):(checkInt32(D,1,MAX_DIGITS),E===void 0?E=$e.rounding:checkInt32(E,0,8),J=finalise(new $e(J),D,E),F=finiteToString(J,D<=J.e||J.e<=$e.toExpNeg,D)),J.isNeg()&&!J.isZero()?"-"+F:F},P$3.toSignificantDigits=P$3.toSD=function(D,E){var F=this,J=F.constructor;return D===void 0?(D=J.precision,E=J.rounding):(checkInt32(D,1,MAX_DIGITS),E===void 0?E=J.rounding:checkInt32(E,0,8)),finalise(new J(F),D,E)},P$3.toString=function(){var D=this,E=D.constructor,F=finiteToString(D,D.e<=E.toExpNeg||D.e>=E.toExpPos);return D.isNeg()&&!D.isZero()?"-"+F:F},P$3.truncated=P$3.trunc=function(){return finalise(new this.constructor(this),this.e+1,1)},P$3.valueOf=P$3.toJSON=function(){var D=this,E=D.constructor,F=finiteToString(D,D.e<=E.toExpNeg||D.e>=E.toExpPos);return D.isNeg()?"-"+F:F};function digitsToString(D){var E,F,J,$e=D.length-1,_t="",lr=D[0];if($e>0){for(_t+=lr,E=1;E<$e;E++)J=D[E]+"",F=LOG_BASE-J.length,F&&(_t+=getZeroString(F)),_t+=J;lr=D[E],J=lr+"",F=LOG_BASE-J.length,F&&(_t+=getZeroString(F))}else if(lr===0)return"0";for(;lr%10==0;)lr/=10;return _t+lr}function checkInt32(D,E,F){if(D!==~~D||D<E||D>F)throw Error(invalidArgument+D)}function checkRoundingDigits(D,E,F,J){var $e,_t,lr,mr;for(_t=D[0];_t>=10;_t/=10)--E;return--E<0?(E+=LOG_BASE,$e=0):($e=Math.ceil((E+1)/LOG_BASE),E%=LOG_BASE),_t=mathpow(10,LOG_BASE-E),mr=D[$e]%_t|0,J==null?E<3?(E==0?mr=mr/100|0:E==1&&(mr=mr/10|0),lr=F<4&&mr==99999||F>3&&mr==49999||mr==5e4||mr==0):lr=(F<4&&mr+1==_t||F>3&&mr+1==_t/2)&&(D[$e+1]/_t/100|0)==mathpow(10,E-2)-1||(mr==_t/2||mr==0)&&(D[$e+1]/_t/100|0)==0:E<4?(E==0?mr=mr/1e3|0:E==1?mr=mr/100|0:E==2&&(mr=mr/10|0),lr=(J||F<4)&&mr==9999||!J&&F>3&&mr==4999):lr=((J||F<4)&&mr+1==_t||!J&&F>3&&mr+1==_t/2)&&(D[$e+1]/_t/1e3|0)==mathpow(10,E-3)-1,lr}function convertBase(D,E,F){for(var J,$e=[0],_t,lr=0,mr=D.length;lr<mr;){for(_t=$e.length;_t--;)$e[_t]*=E;for($e[0]+=NUMERALS.indexOf(D.charAt(lr++)),J=0;J<$e.length;J++)$e[J]>F-1&&($e[J+1]===void 0&&($e[J+1]=0),$e[J+1]+=$e[J]/F|0,$e[J]%=F)}return $e.reverse()}function cosine(D,E){var F,J,$e;if(E.isZero())return E;J=E.d.length,J<32?(F=Math.ceil(J/3),$e=(1/tinyPow(4,F)).toString()):(F=16,$e="2.3283064365386962890625e-10"),D.precision+=F,E=taylorSeries(D,1,E.times($e),new D(1));for(var _t=F;_t--;){var lr=E.times(E);E=lr.times(lr).minus(lr).times(8).plus(1)}return D.precision-=F,E}var divide$1=(function(){function D(J,$e,_t){var lr,mr=0,Or=J.length;for(J=J.slice();Or--;)lr=J[Or]*$e+mr,J[Or]=lr%_t|0,mr=lr/_t|0;return mr&&J.unshift(mr),J}function E(J,$e,_t,lr){var mr,Or;if(_t!=lr)Or=_t>lr?1:-1;else for(mr=Or=0;mr<_t;mr++)if(J[mr]!=$e[mr]){Or=J[mr]>$e[mr]?1:-1;break}return Or}function F(J,$e,_t,lr){for(var mr=0;_t--;)J[_t]-=mr,mr=+(J[_t]<$e[_t]),J[_t]=mr*lr+J[_t]-$e[_t];for(;!J[0]&&J.length>1;)J.shift()}return function(J,$e,_t,lr,mr,Or){var Pr,dn,gi,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki,ea,Ji,ta,na,ra,ia,oa,ua,sa,aa=J.constructor,pa=J.s==$e.s?1:-1,ma=J.d,la=$e.d;if(!ma||!ma[0]||!la||!la[0])return new aa(!J.s||!$e.s||(ma?la&&ma[0]==la[0]:!la)?NaN:ma&&ma[0]==0||!la?pa*0:pa/0);for(Or?(zi=1,dn=J.e-$e.e):(Or=BASE,zi=LOG_BASE,dn=mathfloor(J.e/zi)-mathfloor($e.e/zi)),ua=la.length,ia=ma.length,Zi=new aa(pa),Xi=Zi.d=[],gi=0;la[gi]==(ma[gi]||0);gi++);if(la[gi]>(ma[gi]||0)&&dn--,_t==null?(ta=_t=aa.precision,lr=aa.rounding):ta=mr?_t+(J.e-$e.e)+1:_t,ta<0)Xi.push(1),Hi=!0;else{if(ta=ta/zi+2|0,gi=0,ua==1){for(qi=0,la=la[0],ta++;(gi<ia||qi)&&ta--;gi++)na=qi*Or+(ma[gi]||0),Xi[gi]=na/la|0,qi=na%la|0;Hi=qi||gi<ia}else{for(qi=Or/(la[0]+1)|0,qi>1&&(la=D(la,qi,Or),ma=D(ma,qi,Or),ua=la.length,ia=ma.length),ra=ua,Ki=ma.slice(0,ua),ea=Ki.length;ea<ua;)Ki[ea++]=0;sa=la.slice(),sa.unshift(0),oa=la[0],la[1]>=Or/2&&++oa;do qi=0,Pr=E(la,Ki,ua,ea),Pr<0?(Ji=Ki[0],ua!=ea&&(Ji=Ji*Or+(Ki[1]||0)),qi=Ji/oa|0,qi>1?(qi>=Or&&(qi=Or-1),Qi=D(la,qi,Or),Gi=Qi.length,ea=Ki.length,Pr=E(Qi,Ki,Gi,ea),Pr==1&&(qi--,F(Qi,ua<Gi?sa:la,Gi,Or))):(qi==0&&(Pr=qi=1),Qi=la.slice()),Gi=Qi.length,Gi<ea&&Qi.unshift(0),F(Ki,Qi,ea,Or),Pr==-1&&(ea=Ki.length,Pr=E(la,Ki,ua,ea),Pr<1&&(qi++,F(Ki,ua<ea?sa:la,ea,Or))),ea=Ki.length):Pr===0&&(qi++,Ki=[0]),Xi[gi++]=qi,Pr&&Ki[0]?Ki[ea++]=ma[ra]||0:(Ki=[ma[ra]],ea=1);while((ra++<ia||Ki[0]!==void 0)&&ta--);Hi=Ki[0]!==void 0}Xi[0]||Xi.shift()}if(zi==1)Zi.e=dn,inexact=Hi;else{for(gi=1,qi=Xi[0];qi>=10;qi/=10)gi++;Zi.e=gi+dn*zi-1,finalise(Zi,mr?_t+Zi.e+1:_t,lr,Hi)}return Zi}})();function finalise(D,E,F,J){var $e,_t,lr,mr,Or,Pr,dn,gi,qi,zi=D.constructor;e:if(E!=null){if(gi=D.d,!gi)return D;for($e=1,mr=gi[0];mr>=10;mr/=10)$e++;if(_t=E-$e,_t<0)_t+=LOG_BASE,lr=E,dn=gi[qi=0],Or=dn/mathpow(10,$e-lr-1)%10|0;else if(qi=Math.ceil((_t+1)/LOG_BASE),mr=gi.length,qi>=mr)if(J){for(;mr++<=qi;)gi.push(0);dn=Or=0,$e=1,_t%=LOG_BASE,lr=_t-LOG_BASE+1}else break e;else{for(dn=mr=gi[qi],$e=1;mr>=10;mr/=10)$e++;_t%=LOG_BASE,lr=_t-LOG_BASE+$e,Or=lr<0?0:dn/mathpow(10,$e-lr-1)%10|0}if(J=J||E<0||gi[qi+1]!==void 0||(lr<0?dn:dn%mathpow(10,$e-lr-1)),Pr=F<4?(Or||J)&&(F==0||F==(D.s<0?3:2)):Or>5||Or==5&&(F==4||J||F==6&&(_t>0?lr>0?dn/mathpow(10,$e-lr):0:gi[qi-1])%10&1||F==(D.s<0?8:7)),E<1||!gi[0])return gi.length=0,Pr?(E-=D.e+1,gi[0]=mathpow(10,(LOG_BASE-E%LOG_BASE)%LOG_BASE),D.e=-E||0):gi[0]=D.e=0,D;if(_t==0?(gi.length=qi,mr=1,qi--):(gi.length=qi+1,mr=mathpow(10,LOG_BASE-_t),gi[qi]=lr>0?(dn/mathpow(10,$e-lr)%mathpow(10,lr)|0)*mr:0),Pr)for(;;)if(qi==0){for(_t=1,lr=gi[0];lr>=10;lr/=10)_t++;for(lr=gi[0]+=mr,mr=1;lr>=10;lr/=10)mr++;_t!=mr&&(D.e++,gi[0]==BASE&&(gi[0]=1));break}else{if(gi[qi]+=mr,gi[qi]!=BASE)break;gi[qi--]=0,mr=1}for(_t=gi.length;gi[--_t]===0;)gi.pop()}return external&&(D.e>zi.maxE?(D.d=null,D.e=NaN):D.e<zi.minE&&(D.e=0,D.d=[0])),D}function finiteToString(D,E,F){if(!D.isFinite())return nonFiniteToString(D);var J,$e=D.e,_t=digitsToString(D.d),lr=_t.length;return E?(F&&(J=F-lr)>0?_t=_t.charAt(0)+"."+_t.slice(1)+getZeroString(J):lr>1&&(_t=_t.charAt(0)+"."+_t.slice(1)),_t=_t+(D.e<0?"e":"e+")+D.e):$e<0?(_t="0."+getZeroString(-$e-1)+_t,F&&(J=F-lr)>0&&(_t+=getZeroString(J))):$e>=lr?(_t+=getZeroString($e+1-lr),F&&(J=F-$e-1)>0&&(_t=_t+"."+getZeroString(J))):((J=$e+1)<lr&&(_t=_t.slice(0,J)+"."+_t.slice(J)),F&&(J=F-lr)>0&&($e+1===lr&&(_t+="."),_t+=getZeroString(J))),_t}function getBase10Exponent(D,E){var F=D[0];for(E*=LOG_BASE;F>=10;F/=10)E++;return E}function getLn10(D,E,F){if(E>LN10_PRECISION)throw external=!0,F&&(D.precision=F),Error(precisionLimitExceeded);return finalise(new D(LN10),E,1,!0)}function getPi(D,E,F){if(E>PI_PRECISION)throw Error(precisionLimitExceeded);return finalise(new D(PI),E,F,!0)}function getPrecision(D){var E=D.length-1,F=E*LOG_BASE+1;if(E=D[E],E){for(;E%10==0;E/=10)F--;for(E=D[0];E>=10;E/=10)F++}return F}function getZeroString(D){for(var E="";D--;)E+="0";return E}function intPow(D,E,F,J){var $e,_t=new D(1),lr=Math.ceil(J/LOG_BASE+4);for(external=!1;;){if(F%2&&(_t=_t.times(E),truncate(_t.d,lr)&&($e=!0)),F=mathfloor(F/2),F===0){F=_t.d.length-1,$e&&_t.d[F]===0&&++_t.d[F];break}E=E.times(E),truncate(E.d,lr)}return external=!0,_t}function isOdd(D){return D.d[D.d.length-1]&1}function maxOrMin(D,E,F){for(var J,$e=new D(E[0]),_t=0;++_t<E.length;)if(J=new D(E[_t]),J.s)$e[F](J)&&($e=J);else{$e=J;break}return $e}function naturalExponential(D,E){var F,J,$e,_t,lr,mr,Or,Pr=0,dn=0,gi=0,qi=D.constructor,zi=qi.rounding,Hi=qi.precision;if(!D.d||!D.d[0]||D.e>17)return new qi(D.d?D.d[0]?D.s<0?0:1/0:1:D.s?D.s<0?0:D:NaN);for(E==null?(external=!1,Or=Hi):Or=E,mr=new qi(.03125);D.e>-2;)D=D.times(mr),gi+=5;for(J=Math.log(mathpow(2,gi))/Math.LN10*2+5|0,Or+=J,F=_t=lr=new qi(1),qi.precision=Or;;){if(_t=finalise(_t.times(D),Or,1),F=F.times(++dn),mr=lr.plus(divide$1(_t,F,Or,1)),digitsToString(mr.d).slice(0,Or)===digitsToString(lr.d).slice(0,Or)){for($e=gi;$e--;)lr=finalise(lr.times(lr),Or,1);if(E==null)if(Pr<3&&checkRoundingDigits(lr.d,Or-J,zi,Pr))qi.precision=Or+=10,F=_t=mr=new qi(1),dn=0,Pr++;else return finalise(lr,qi.precision=Hi,zi,external=!0);else return qi.precision=Hi,lr}lr=mr}}function naturalLogarithm(D,E){var F,J,$e,_t,lr,mr,Or,Pr,dn,gi,qi,zi=1,Hi=10,Qi=D,Gi=Qi.d,Zi=Qi.constructor,Xi=Zi.rounding,Ki=Zi.precision;if(Qi.s<0||!Gi||!Gi[0]||!Qi.e&&Gi[0]==1&&Gi.length==1)return new Zi(Gi&&!Gi[0]?-1/0:Qi.s==1?Gi?0:Qi:NaN);if(E==null?(external=!1,dn=Ki):dn=E,Zi.precision=dn+=Hi,F=digitsToString(Gi),J=F.charAt(0),Math.abs(_t=Qi.e)<15e14){for(;J<7&&J!=1||J==1&&F.charAt(1)>3;)Qi=Qi.times(D),F=digitsToString(Qi.d),J=F.charAt(0),zi++;_t=Qi.e,J>1?(Qi=new Zi("0."+F),_t++):Qi=new Zi(J+"."+F.slice(1))}else return Pr=getLn10(Zi,dn+2,Ki).times(_t+""),Qi=naturalLogarithm(new Zi(J+"."+F.slice(1)),dn-Hi).plus(Pr),Zi.precision=Ki,E==null?finalise(Qi,Ki,Xi,external=!0):Qi;for(gi=Qi,Or=lr=Qi=divide$1(Qi.minus(1),Qi.plus(1),dn,1),qi=finalise(Qi.times(Qi),dn,1),$e=3;;){if(lr=finalise(lr.times(qi),dn,1),Pr=Or.plus(divide$1(lr,new Zi($e),dn,1)),digitsToString(Pr.d).slice(0,dn)===digitsToString(Or.d).slice(0,dn))if(Or=Or.times(2),_t!==0&&(Or=Or.plus(getLn10(Zi,dn+2,Ki).times(_t+""))),Or=divide$1(Or,new Zi(zi),dn,1),E==null)if(checkRoundingDigits(Or.d,dn-Hi,Xi,mr))Zi.precision=dn+=Hi,Pr=lr=Qi=divide$1(gi.minus(1),gi.plus(1),dn,1),qi=finalise(Qi.times(Qi),dn,1),$e=mr=1;else return finalise(Or,Zi.precision=Ki,Xi,external=!0);else return Zi.precision=Ki,Or;Or=Pr,$e+=2}}function nonFiniteToString(D){return String(D.s*D.s/0)}function parseDecimal(D,E){var F,J,$e;for((F=E.indexOf("."))>-1&&(E=E.replace(".","")),(J=E.search(/e/i))>0?(F<0&&(F=J),F+=+E.slice(J+1),E=E.substring(0,J)):F<0&&(F=E.length),J=0;E.charCodeAt(J)===48;J++);for($e=E.length;E.charCodeAt($e-1)===48;--$e);if(E=E.slice(J,$e),E){if($e-=J,D.e=F=F-J-1,D.d=[],J=(F+1)%LOG_BASE,F<0&&(J+=LOG_BASE),J<$e){for(J&&D.d.push(+E.slice(0,J)),$e-=LOG_BASE;J<$e;)D.d.push(+E.slice(J,J+=LOG_BASE));E=E.slice(J),J=LOG_BASE-E.length}else J-=$e;for(;J--;)E+="0";D.d.push(+E),external&&(D.e>D.constructor.maxE?(D.d=null,D.e=NaN):D.e<D.constructor.minE&&(D.e=0,D.d=[0]))}else D.e=0,D.d=[0];return D}function parseOther(D,E){var F,J,$e,_t,lr,mr,Or,Pr,dn;if(E.indexOf("_")>-1){if(E=E.replace(/(\\d)_(?=\\d)/g,"$1"),isDecimal.test(E))return parseDecimal(D,E)}else if(E==="Infinity"||E==="NaN")return+E||(D.s=NaN),D.e=NaN,D.d=null,D;if(isHex.test(E))F=16,E=E.toLowerCase();else if(isBinary.test(E))F=2;else if(isOctal.test(E))F=8;else throw Error(invalidArgument+E);for(_t=E.search(/p/i),_t>0?(Or=+E.slice(_t+1),E=E.substring(2,_t)):E=E.slice(2),_t=E.indexOf("."),lr=_t>=0,J=D.constructor,lr&&(E=E.replace(".",""),mr=E.length,_t=mr-_t,$e=intPow(J,new J(F),_t,_t*2)),Pr=convertBase(E,F,BASE),dn=Pr.length-1,_t=dn;Pr[_t]===0;--_t)Pr.pop();return _t<0?new J(D.s*0):(D.e=getBase10Exponent(Pr,dn),D.d=Pr,external=!1,lr&&(D=divide$1(D,$e,mr*4)),Or&&(D=D.times(Math.abs(Or)<54?mathpow(2,Or):Decimal.pow(2,Or))),external=!0,D)}function sine(D,E){var F,J=E.d.length;if(J<3)return E.isZero()?E:taylorSeries(D,2,E,E);F=1.4*Math.sqrt(J),F=F>16?16:F|0,E=E.times(1/tinyPow(5,F)),E=taylorSeries(D,2,E,E);for(var $e,_t=new D(5),lr=new D(16),mr=new D(20);F--;)$e=E.times(E),E=E.times(_t.plus($e.times(lr.times($e).minus(mr))));return E}function taylorSeries(D,E,F,J,$e){var _t,lr,mr,Or,Pr=D.precision,dn=Math.ceil(Pr/LOG_BASE);for(external=!1,Or=F.times(F),mr=new D(J);;){if(lr=divide$1(mr.times(Or),new D(E++*E++),Pr,1),mr=$e?J.plus(lr):J.minus(lr),J=divide$1(lr.times(Or),new D(E++*E++),Pr,1),lr=mr.plus(J),lr.d[dn]!==void 0){for(_t=dn;lr.d[_t]===mr.d[_t]&&_t--;);if(_t==-1)break}_t=mr,mr=J,J=lr,lr=_t}return external=!0,lr.d.length=dn+1,lr}function tinyPow(D,E){for(var F=D;--E;)F*=D;return F}function toLessThanHalfPi(D,E){var F,J=E.s<0,$e=getPi(D,D.precision,1),_t=$e.times(.5);if(E=E.abs(),E.lte(_t))return quadrant=J?4:1,E;if(F=E.divToInt($e),F.isZero())quadrant=J?3:2;else{if(E=E.minus(F.times($e)),E.lte(_t))return quadrant=isOdd(F)?J?2:3:J?4:1,E;quadrant=isOdd(F)?J?1:4:J?3:2}return E.minus($e).abs()}function toStringBinary(D,E,F,J){var $e,_t,lr,mr,Or,Pr,dn,gi,qi,zi=D.constructor,Hi=F!==void 0;if(Hi?(checkInt32(F,1,MAX_DIGITS),J===void 0?J=zi.rounding:checkInt32(J,0,8)):(F=zi.precision,J=zi.rounding),!D.isFinite())dn=nonFiniteToString(D);else{for(dn=finiteToString(D),lr=dn.indexOf("."),Hi?($e=2,E==16?F=F*4-3:E==8&&(F=F*3-2)):$e=E,lr>=0&&(dn=dn.replace(".",""),qi=new zi(1),qi.e=dn.length-lr,qi.d=convertBase(finiteToString(qi),10,$e),qi.e=qi.d.length),gi=convertBase(dn,10,$e),_t=Or=gi.length;gi[--Or]==0;)gi.pop();if(!gi[0])dn=Hi?"0p+0":"0";else{if(lr<0?_t--:(D=new zi(D),D.d=gi,D.e=_t,D=divide$1(D,qi,F,J,0,$e),gi=D.d,_t=D.e,Pr=inexact),lr=gi[F],mr=$e/2,Pr||=gi[F+1]!==void 0,Pr=J<4?(lr!==void 0||Pr)&&(J===0||J===(D.s<0?3:2)):lr>mr||lr===mr&&(J===4||Pr||J===6&&gi[F-1]&1||J===(D.s<0?8:7)),gi.length=F,Pr)for(;++gi[--F]>$e-1;)gi[F]=0,F||(++_t,gi.unshift(1));for(Or=gi.length;!gi[Or-1];--Or);for(lr=0,dn="";lr<Or;lr++)dn+=NUMERALS.charAt(gi[lr]);if(Hi){if(Or>1)if(E==16||E==8){for(lr=E==16?4:3,--Or;Or%lr;Or++)dn+="0";for(gi=convertBase(dn,$e,E),Or=gi.length;!gi[Or-1];--Or);for(lr=1,dn="1.";lr<Or;lr++)dn+=NUMERALS.charAt(gi[lr])}else dn=dn.charAt(0)+"."+dn.slice(1);dn=dn+(_t<0?"p":"p+")+_t}else if(_t<0){for(;++_t;)dn="0"+dn;dn="0."+dn}else if(++_t>Or)for(_t-=Or;_t--;)dn+="0";else _t<Or&&(dn=dn.slice(0,_t)+"."+dn.slice(_t))}dn=(E==16?"0x":E==2?"0b":E==8?"0o":"")+dn}return D.s<0?"-"+dn:dn}function truncate(D,E){if(D.length>E)return D.length=E,!0}function abs$1(D){return new this(D).abs()}function acos$1(D){return new this(D).acos()}function acosh$1(D){return new this(D).acosh()}function add$1(D,E){return new this(D).plus(E)}function asin$1(D){return new this(D).asin()}function asinh$1(D){return new this(D).asinh()}function atan$1(D){return new this(D).atan()}function atanh$1(D){return new this(D).atanh()}function atan2$1(D,E){D=new this(D),E=new this(E);var F,J=this.precision,$e=this.rounding,_t=J+4;return!D.s||!E.s?F=new this(NaN):!D.d&&!E.d?(F=getPi(this,_t,1).times(E.s>0?.25:.75),F.s=D.s):!E.d||D.isZero()?(F=E.s<0?getPi(this,J,$e):new this(0),F.s=D.s):!D.d||E.isZero()?(F=getPi(this,_t,1).times(.5),F.s=D.s):E.s<0?(this.precision=_t,this.rounding=1,F=this.atan(divide$1(D,E,_t,1)),E=getPi(this,_t,1),this.precision=J,this.rounding=$e,F=D.s<0?F.minus(E):F.plus(E)):F=this.atan(divide$1(D,E,_t,1)),F}function cbrt(D){return new this(D).cbrt()}function ceil(D){return finalise(D=new this(D),D.e+1,2)}function clamp(D,E,F){return new this(D).clamp(E,F)}function config(D){if(!D||typeof D!="object")throw Error(decimalError+"Object expected");var E,F,J,$e=D.defaults===!0,_t=["precision",1,MAX_DIGITS,"rounding",0,8,"toExpNeg",-EXP_LIMIT,0,"toExpPos",0,EXP_LIMIT,"maxE",0,EXP_LIMIT,"minE",-EXP_LIMIT,0,"modulo",0,9];for(E=0;E<_t.length;E+=3)if(F=_t[E],$e&&(this[F]=DEFAULTS[F]),(J=D[F])!==void 0)if(mathfloor(J)===J&&J>=_t[E+1]&&J<=_t[E+2])this[F]=J;else throw Error(invalidArgument+F+": "+J);if(F="crypto",$e&&(this[F]=DEFAULTS[F]),(J=D[F])!==void 0)if(J===!0||J===!1||J===0||J===1)if(J)if(typeof crypto<"u"&&crypto&&(crypto.getRandomValues||crypto.randomBytes))this[F]=!0;else throw Error(cryptoUnavailable);else this[F]=!1;else throw Error(invalidArgument+F+": "+J);return this}function cos$1(D){return new this(D).cos()}function cosh$2(D){return new this(D).cosh()}function clone$2(D){var E,F,J;function $e(_t){var lr,mr,Or,Pr=this;if(!(Pr instanceof $e))return new $e(_t);if(Pr.constructor=$e,isDecimalInstance(_t)){Pr.s=_t.s,external?!_t.d||_t.e>$e.maxE?(Pr.e=NaN,Pr.d=null):_t.e<$e.minE?(Pr.e=0,Pr.d=[0]):(Pr.e=_t.e,Pr.d=_t.d.slice()):(Pr.e=_t.e,Pr.d=_t.d?_t.d.slice():_t.d);return}if(Or=typeof _t,Or==="number"){if(_t===0){Pr.s=1/_t<0?-1:1,Pr.e=0,Pr.d=[0];return}if(_t<0?(_t=-_t,Pr.s=-1):Pr.s=1,_t===~~_t&&_t<1e7){for(lr=0,mr=_t;mr>=10;mr/=10)lr++;external?lr>$e.maxE?(Pr.e=NaN,Pr.d=null):lr<$e.minE?(Pr.e=0,Pr.d=[0]):(Pr.e=lr,Pr.d=[_t]):(Pr.e=lr,Pr.d=[_t]);return}else if(_t*0!=0){_t||(Pr.s=NaN),Pr.e=NaN,Pr.d=null;return}return parseDecimal(Pr,_t.toString())}else if(Or!=="string")throw Error(invalidArgument+_t);return(mr=_t.charCodeAt(0))===45?(_t=_t.slice(1),Pr.s=-1):(mr===43&&(_t=_t.slice(1)),Pr.s=1),isDecimal.test(_t)?parseDecimal(Pr,_t):parseOther(Pr,_t)}if($e.prototype=P$3,$e.ROUND_UP=0,$e.ROUND_DOWN=1,$e.ROUND_CEIL=2,$e.ROUND_FLOOR=3,$e.ROUND_HALF_UP=4,$e.ROUND_HALF_DOWN=5,$e.ROUND_HALF_EVEN=6,$e.ROUND_HALF_CEIL=7,$e.ROUND_HALF_FLOOR=8,$e.EUCLID=9,$e.config=$e.set=config,$e.clone=clone$2,$e.isDecimal=isDecimalInstance,$e.abs=abs$1,$e.acos=acos$1,$e.acosh=acosh$1,$e.add=add$1,$e.asin=asin$1,$e.asinh=asinh$1,$e.atan=atan$1,$e.atanh=atanh$1,$e.atan2=atan2$1,$e.cbrt=cbrt,$e.ceil=ceil,$e.clamp=clamp,$e.cos=cos$1,$e.cosh=cosh$2,$e.div=div,$e.exp=exp$1,$e.floor=floor,$e.hypot=hypot$1,$e.ln=ln,$e.log=log$1,$e.log10=log10$1,$e.log2=log2,$e.max=max$1,$e.min=min$1,$e.mod=mod$1,$e.mul=mul,$e.pow=pow$1,$e.random=random$1,$e.round=round,$e.sign=sign$1,$e.sin=sin$1,$e.sinh=sinh$2,$e.sqrt=sqrt$1,$e.sub=sub,$e.sum=sum,$e.tan=tan$1,$e.tanh=tanh$1,$e.trunc=trunc$1,D===void 0&&(D={}),D&&D.defaults!==!0)for(J=["precision","rounding","toExpNeg","toExpPos","maxE","minE","modulo","crypto"],E=0;E<J.length;)D.hasOwnProperty(F=J[E++])||(D[F]=this[F]);return $e.config(D),$e}function div(D,E){return new this(D).div(E)}function exp$1(D){return new this(D).exp()}function floor(D){return finalise(D=new this(D),D.e+1,3)}function hypot$1(){var D,E,F=new this(0);for(external=!1,D=0;D<arguments.length;)if(E=new this(arguments[D++]),E.d)F.d&&(F=F.plus(E.times(E)));else{if(E.s)return external=!0,new this(1/0);F=E}return external=!0,F.sqrt()}function isDecimalInstance(D){return D instanceof Decimal||D&&D.toStringTag===tag||!1}function ln(D){return new this(D).ln()}function log$1(D,E){return new this(D).log(E)}function log2(D){return new this(D).log(2)}function log10$1(D){return new this(D).log(10)}function max$1(){return maxOrMin(this,arguments,"lt")}function min$1(){return maxOrMin(this,arguments,"gt")}function mod$1(D,E){return new this(D).mod(E)}function mul(D,E){return new this(D).mul(E)}function pow$1(D,E){return new this(D).pow(E)}function random$1(D){var E,F,J,$e,_t=0,lr=new this(1),mr=[];if(D===void 0?D=this.precision:checkInt32(D,1,MAX_DIGITS),J=Math.ceil(D/LOG_BASE),!this.crypto)for(;_t<J;)mr[_t++]=Math.random()*1e7|0;else if(crypto.getRandomValues)for(E=crypto.getRandomValues(new Uint32Array(J));_t<J;)$e=E[_t],$e>=429e7?E[_t]=crypto.getRandomValues(new Uint32Array(1))[0]:mr[_t++]=$e%1e7;else if(crypto.randomBytes){for(E=crypto.randomBytes(J*=4);_t<J;)$e=E[_t]+(E[_t+1]<<8)+(E[_t+2]<<16)+((E[_t+3]&127)<<24),$e>=214e7?crypto.randomBytes(4).copy(E,_t):(mr.push($e%1e7),_t+=4);_t=J/4}else throw Error(cryptoUnavailable);for(J=mr[--_t],D%=LOG_BASE,J&&D&&($e=mathpow(10,LOG_BASE-D),mr[_t]=(J/$e|0)*$e);mr[_t]===0;_t--)mr.pop();if(_t<0)F=0,mr=[0];else{for(F=-1;mr[0]===0;F-=LOG_BASE)mr.shift();for(J=1,$e=mr[0];$e>=10;$e/=10)J++;J<LOG_BASE&&(F-=LOG_BASE-J)}return lr.e=F,lr.d=mr,lr}function round(D){return finalise(D=new this(D),D.e+1,this.rounding)}function sign$1(D){return D=new this(D),D.d?D.d[0]?D.s:0*D.s:D.s||NaN}function sin$1(D){return new this(D).sin()}function sinh$2(D){return new this(D).sinh()}function sqrt$1(D){return new this(D).sqrt()}function sub(D,E){return new this(D).sub(E)}function sum(){var D=0,E=arguments,F=new this(E[D]);for(external=!1;F.s&&++D<E.length;)F=F.plus(E[D]);return external=!0,finalise(F,this.precision,this.rounding)}function tan$1(D){return new this(D).tan()}function tanh$1(D){return new this(D).tanh()}function trunc$1(D){return finalise(D=new this(D),D.e+1,1)}P$3[Symbol.for("nodejs.util.inspect.custom")]=P$3.toString,P$3[Symbol.toStringTag]="Decimal";var Decimal=P$3.constructor=clone$2(DEFAULTS);LN10=new Decimal(LN10),PI=new Decimal(PI);var name$320="BigNumber",dependencies$320=["?on","config"],createBigNumberClass=factory(name$320,dependencies$320,D=>{var{on:E,config:F}=D,J=Decimal.clone({precision:F.precision,modulo:Decimal.EUCLID});return J.prototype=Object.create(J.prototype),J.prototype.type="BigNumber",J.prototype.isBigNumber=!0,J.prototype.toJSON=function(){return{mathjs:"BigNumber",value:this.toString()}},J.fromJSON=function($e){return new J($e.value)},E&&E("config",function($e,_t){$e.precision!==_t.precision&&J.config({precision:$e.precision})}),J},{isClass:!0}),cosh$1=Math.cosh||function(D){return Math.abs(D)<1e-9?1-D:(Math.exp(D)+Math.exp(-D))*.5},sinh$1=Math.sinh||function(D){return Math.abs(D)<1e-9?D:(Math.exp(D)-Math.exp(-D))*.5},cosm1=function(D){let E=Math.PI/4;if(-E>D||D>E)return Math.cos(D)-1;let F=D*D;return F*(F*(F*(F*(F*(F*(F*(F/20922789888e3-1/87178291200)+1/479001600)-1/3628800)+1/40320)-1/720)+1/24)-1/2)},hypot=function(D,E){return D=Math.abs(D),E=Math.abs(E),D<E&&([D,E]=[E,D]),D<1e8?Math.sqrt(D*D+E*E):(E/=D,D*Math.sqrt(1+E*E))},parser_exit=function(){throw SyntaxError("Invalid Param")};function logHypot(D,E){let F=Math.abs(D),J=Math.abs(E);return D===0?Math.log(J):E===0?Math.log(F):F<3e3&&J<3e3?Math.log(D*D+E*E)*.5:(D*=.5,E*=.5,.5*Math.log(D*D+E*E)+Math.LN2)}var P$2={re:0,im:0},parse$1=function(D,E){let F=P$2;if(D==null)F.re=F.im=0;else if(E!==void 0)F.re=D,F.im=E;else switch(typeof D){case"object":if("im"in D&&"re"in D)F.re=D.re,F.im=D.im;else if("abs"in D&&"arg"in D){if(!isFinite(D.abs)&&isFinite(D.arg))return Complex.INFINITY;F.re=D.abs*Math.cos(D.arg),F.im=D.abs*Math.sin(D.arg)}else if("r"in D&&"phi"in D){if(!isFinite(D.r)&&isFinite(D.phi))return Complex.INFINITY;F.re=D.r*Math.cos(D.phi),F.im=D.r*Math.sin(D.phi)}else D.length===2?(F.re=D[0],F.im=D[1]):parser_exit();break;case"string":F.im=F.re=0;let J=D.replace(/_/g,"").match(/\\d+\\.?\\d*e[+-]?\\d+|\\d+\\.?\\d*|\\.\\d+|./g),$e=1,_t=0;J===null&&parser_exit();for(let lr=0;lr<J.length;lr++){let mr=J[lr];mr===" "||mr==="	"||mr===`\n`||(mr==="+"?$e++:mr==="-"?_t++:mr==="i"||mr==="I"?($e+_t===0&&parser_exit(),J[lr+1]!==" "&&!isNaN(J[lr+1])?(F.im+=parseFloat((_t%2?"-":"")+J[lr+1]),lr++):F.im+=parseFloat((_t%2?"-":"")+"1"),$e=_t=0):(($e+_t===0||isNaN(mr))&&parser_exit(),J[lr+1]==="i"||J[lr+1]==="I"?(F.im+=parseFloat((_t%2?"-":"")+mr),lr++):F.re+=parseFloat((_t%2?"-":"")+mr),$e=_t=0))}$e+_t>0&&parser_exit();break;case"number":F.im=0,F.re=D;break;default:parser_exit()}return isNaN(F.re)||isNaN(F.im),F};function Complex(D,E){if(!(this instanceof Complex))return new Complex(D,E);let F=parse$1(D,E);this.re=F.re,this.im=F.im}Complex.prototype={re:0,im:0,sign:function(){let D=hypot(this.re,this.im);return new Complex(this.re/D,this.im/D)},add:function(D,E){let F=parse$1(D,E),J=this.isInfinite(),$e=!(isFinite(F.re)&&isFinite(F.im));return J||$e?J&&$e?Complex.NAN:Complex.INFINITY:new Complex(this.re+F.re,this.im+F.im)},sub:function(D,E){let F=parse$1(D,E),J=this.isInfinite(),$e=!(isFinite(F.re)&&isFinite(F.im));return J||$e?J&&$e?Complex.NAN:Complex.INFINITY:new Complex(this.re-F.re,this.im-F.im)},mul:function(D,E){let F=parse$1(D,E),J=this.isInfinite(),$e=!(isFinite(F.re)&&isFinite(F.im)),_t=this.re===0&&this.im===0,lr=F.re===0&&F.im===0;return J&&lr||$e&&_t?Complex.NAN:J||$e?Complex.INFINITY:F.im===0&&this.im===0?new Complex(this.re*F.re,0):new Complex(this.re*F.re-this.im*F.im,this.re*F.im+this.im*F.re)},div:function(D,E){let F=parse$1(D,E),J=this.isInfinite(),$e=!(isFinite(F.re)&&isFinite(F.im)),_t=this.re===0&&this.im===0,lr=F.re===0&&F.im===0;if(_t&&lr||J&&$e)return Complex.NAN;if(lr||J)return Complex.INFINITY;if(_t||$e)return Complex.ZERO;if(F.im===0)return new Complex(this.re/F.re,this.im/F.re);if(Math.abs(F.re)<Math.abs(F.im)){let mr=F.re/F.im,Or=F.re*mr+F.im;return new Complex((this.re*mr+this.im)/Or,(this.im*mr-this.re)/Or)}else{let mr=F.im/F.re,Or=F.im*mr+F.re;return new Complex((this.re+this.im*mr)/Or,(this.im-this.re*mr)/Or)}},pow:function(D,E){let F=parse$1(D,E),J=this.re===0&&this.im===0;if(F.re===0&&F.im===0)return Complex.ONE;if(F.im===0){if(this.im===0&&this.re>0)return new Complex(this.re**+F.re,0);if(this.re===0)switch((F.re%4+4)%4){case 0:return new Complex(this.im**+F.re,0);case 1:return new Complex(0,this.im**+F.re);case 2:return new Complex(-(this.im**+F.re),0);case 3:return new Complex(0,-(this.im**+F.re))}}if(J&&F.re>0)return Complex.ZERO;let $e=Math.atan2(this.im,this.re),_t=logHypot(this.re,this.im),lr=Math.exp(F.re*_t-F.im*$e),mr=F.im*_t+F.re*$e;return new Complex(lr*Math.cos(mr),lr*Math.sin(mr))},sqrt:function(){let D=this.re,E=this.im;if(E===0)return D>=0?new Complex(Math.sqrt(D),0):new Complex(0,Math.sqrt(-D));let F=hypot(D,E),J=Math.sqrt(.5*(F+Math.abs(D))),$e=Math.abs(E)/(2*J);return D>=0?new Complex(J,E<0?-$e:$e):new Complex($e,E<0?-J:J)},exp:function(){let D=Math.exp(this.re);return this.im===0?new Complex(D,0):new Complex(D*Math.cos(this.im),D*Math.sin(this.im))},expm1:function(){let D=this.re,E=this.im;return new Complex(Math.expm1(D)*Math.cos(E)+cosm1(E),Math.exp(D)*Math.sin(E))},log:function(){let D=this.re,E=this.im;return E===0&&D>0?new Complex(Math.log(D),0):new Complex(logHypot(D,E),Math.atan2(E,D))},abs:function(){return hypot(this.re,this.im)},arg:function(){return Math.atan2(this.im,this.re)},sin:function(){let D=this.re,E=this.im;return new Complex(Math.sin(D)*cosh$1(E),Math.cos(D)*sinh$1(E))},cos:function(){let D=this.re,E=this.im;return new Complex(Math.cos(D)*cosh$1(E),-Math.sin(D)*sinh$1(E))},tan:function(){let D=2*this.re,E=2*this.im,F=Math.cos(D)+cosh$1(E);return new Complex(Math.sin(D)/F,sinh$1(E)/F)},cot:function(){let D=2*this.re,E=2*this.im,F=Math.cos(D)-cosh$1(E);return new Complex(-Math.sin(D)/F,sinh$1(E)/F)},sec:function(){let D=this.re,E=this.im,F=.5*cosh$1(2*E)+.5*Math.cos(2*D);return new Complex(Math.cos(D)*cosh$1(E)/F,Math.sin(D)*sinh$1(E)/F)},csc:function(){let D=this.re,E=this.im,F=.5*cosh$1(2*E)-.5*Math.cos(2*D);return new Complex(Math.sin(D)*cosh$1(E)/F,-Math.cos(D)*sinh$1(E)/F)},asin:function(){let D=this.re,E=this.im,F=new Complex(E*E-D*D+1,-2*D*E).sqrt(),J=new Complex(F.re-E,F.im+D).log();return new Complex(J.im,-J.re)},acos:function(){let D=this.re,E=this.im,F=new Complex(E*E-D*D+1,-2*D*E).sqrt(),J=new Complex(F.re-E,F.im+D).log();return new Complex(Math.PI/2-J.im,J.re)},atan:function(){let D=this.re,E=this.im;if(D===0){if(E===1)return new Complex(0,1/0);if(E===-1)return new Complex(0,-1/0)}let F=D*D+(1-E)*(1-E),J=new Complex((1-E*E-D*D)/F,-2*D/F).log();return new Complex(-.5*J.im,.5*J.re)},acot:function(){let D=this.re,E=this.im;if(E===0)return new Complex(Math.atan2(1,D),0);let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).atan():new Complex(D/F,-E/F).atan()},asec:function(){let D=this.re,E=this.im;if(D===0&&E===0)return new Complex(0,1/0);let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).acos():new Complex(D/F,-E/F).acos()},acsc:function(){let D=this.re,E=this.im;if(D===0&&E===0)return new Complex(Math.PI/2,1/0);let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).asin():new Complex(D/F,-E/F).asin()},sinh:function(){let D=this.re,E=this.im;return new Complex(sinh$1(D)*Math.cos(E),cosh$1(D)*Math.sin(E))},cosh:function(){let D=this.re,E=this.im;return new Complex(cosh$1(D)*Math.cos(E),sinh$1(D)*Math.sin(E))},tanh:function(){let D=2*this.re,E=2*this.im,F=cosh$1(D)+Math.cos(E);return new Complex(sinh$1(D)/F,Math.sin(E)/F)},coth:function(){let D=2*this.re,E=2*this.im,F=cosh$1(D)-Math.cos(E);return new Complex(sinh$1(D)/F,-Math.sin(E)/F)},csch:function(){let D=this.re,E=this.im,F=Math.cos(2*E)-cosh$1(2*D);return new Complex(-2*sinh$1(D)*Math.cos(E)/F,2*cosh$1(D)*Math.sin(E)/F)},sech:function(){let D=this.re,E=this.im,F=Math.cos(2*E)+cosh$1(2*D);return new Complex(2*cosh$1(D)*Math.cos(E)/F,-2*sinh$1(D)*Math.sin(E)/F)},asinh:function(){let D=this.im;this.im=-this.re,this.re=D;let E=this.asin();return this.re=-this.im,this.im=D,D=E.re,E.re=-E.im,E.im=D,E},acosh:function(){let D=this.acos();if(D.im<=0){let E=D.re;D.re=-D.im,D.im=E}else{let E=D.im;D.im=-D.re,D.re=E}return D},atanh:function(){let D=this.re,E=this.im,F=D>1&&E===0,J=1-D,$e=1+D,_t=J*J+E*E,lr=_t===0?new Complex(D===-1?0:D/0,E===0?0:E/0):new Complex(($e*J-E*E)/_t,(E*J+$e*E)/_t),mr=lr.re;return lr.re=logHypot(lr.re,lr.im)/2,lr.im=Math.atan2(lr.im,mr)/2,F&&(lr.im=-lr.im),lr},acoth:function(){let D=this.re,E=this.im;if(D===0&&E===0)return new Complex(0,Math.PI/2);let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).atanh():new Complex(D/F,-E/F).atanh()},acsch:function(){let D=this.re,E=this.im;if(E===0)return new Complex(D===0?1/0:Math.log(D+Math.sqrt(D*D+1)),0);let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).asinh():new Complex(D/F,-E/F).asinh()},asech:function(){let D=this.re,E=this.im;if(this.isZero())return Complex.INFINITY;let F=D*D+E*E;return F===0?new Complex(D===0?0:D/0,E===0?0:-E/0).acosh():new Complex(D/F,-E/F).acosh()},inverse:function(){if(this.isZero())return Complex.INFINITY;if(this.isInfinite())return Complex.ZERO;let D=this.re,E=this.im,F=D*D+E*E;return new Complex(D/F,-E/F)},conjugate:function(){return new Complex(this.re,-this.im)},neg:function(){return new Complex(-this.re,-this.im)},ceil:function(D){return D=10**(D||0),new Complex(Math.ceil(this.re*D)/D,Math.ceil(this.im*D)/D)},floor:function(D){return D=10**(D||0),new Complex(Math.floor(this.re*D)/D,Math.floor(this.im*D)/D)},round:function(D){return D=10**(D||0),new Complex(Math.round(this.re*D)/D,Math.round(this.im*D)/D)},equals:function(D,E){let F=parse$1(D,E);return Math.abs(F.re-this.re)<=Complex.EPSILON&&Math.abs(F.im-this.im)<=Complex.EPSILON},clone:function(){return new Complex(this.re,this.im)},toString:function(){let D=this.re,E=this.im,F="";return this.isNaN()?"NaN":this.isInfinite()?"Infinity":(Math.abs(D)<Complex.EPSILON&&(D=0),Math.abs(E)<Complex.EPSILON&&(E=0),E===0?F+D:(D===0?E<0&&(E=-E,F+="-"):(F+=D,F+=" ",E<0?(E=-E,F+="-"):F+="+",F+=" "),E!==1&&(F+=E),F+"i"))},toVector:function(){return[this.re,this.im]},valueOf:function(){return this.im===0?this.re:null},isNaN:function(){return isNaN(this.re)||isNaN(this.im)},isZero:function(){return this.im===0&&this.re===0},isFinite:function(){return isFinite(this.re)&&isFinite(this.im)},isInfinite:function(){return!this.isFinite()}},Complex.ZERO=new Complex(0,0),Complex.ONE=new Complex(1,0),Complex.I=new Complex(0,1),Complex.PI=new Complex(Math.PI,0),Complex.E=new Complex(Math.E,0),Complex.INFINITY=new Complex(1/0,1/0),Complex.NAN=new Complex(NaN,NaN),Complex.EPSILON=1e-15;var name$319="Complex",dependencies$319=[],createComplexClass=factory(name$319,dependencies$319,()=>(Object.defineProperty(Complex,"name",{value:"Complex"}),Complex.prototype.constructor=Complex,Complex.prototype.type="Complex",Complex.prototype.isComplex=!0,Complex.prototype.toJSON=function(){return{mathjs:"Complex",re:this.re,im:this.im}},Complex.prototype.toPolar=function(){return{r:this.abs(),phi:this.arg()}},Complex.prototype.format=function(D){var E="",F=this.im,J=this.re,$e=format$2(this.re,D),_t=format$2(this.im,D),lr=isNumber(D)?D:D?D.precision:null;if(lr!==null){var mr=10**-lr;Math.abs(J/F)<mr&&(J=0),Math.abs(F/J)<mr&&(F=0)}return E=F===0?$e:J===0?F===1?"i":F===-1?"-i":_t+"i":F<0?F===-1?$e+" - i":$e+" - "+_t.substring(1)+"i":F===1?$e+" + i":$e+" + "+_t+"i",E},Complex.fromPolar=function(D){switch(arguments.length){case 1:var E=arguments[0];if(typeof E=="object")return Complex(E);throw TypeError("Input has to be an object with r and phi keys.");case 2:var F=arguments[0],J=arguments[1];if(isNumber(F)){if(isUnit(J)&&J.hasBase("ANGLE")&&(J=J.toNumber("rad")),isNumber(J))return new Complex({r:F,phi:J});throw TypeError("Phi is not a number nor an angle unit.")}else throw TypeError("Radius r is not a number.");default:throw SyntaxError("Wrong number of arguments in function fromPolar")}},Complex.prototype.valueOf=Complex.prototype.toString,Complex.fromJSON=function(D){return new Complex(D)},Complex.compare=function(D,E){return D.re>E.re?1:D.re<E.re?-1:D.im>E.im?1:D.im<E.im?-1:0},Complex),{isClass:!0});typeof BigInt>"u"&&(BigInt=function(D){if(isNaN(D))throw Error("");return D});var C_ZERO=BigInt(0),C_ONE=BigInt(1),C_TWO=BigInt(2),C_FIVE=BigInt(5),C_TEN=BigInt(10),MAX_CYCLE_LEN=2e3,P$1={s:C_ONE,n:C_ZERO,d:C_ONE};function assign(D,E){try{D=BigInt(D)}catch{throw InvalidParameter()}return D*E}function trunc(D){return typeof D=="bigint"?D:Math.floor(D)}function newFraction(D,E){if(E===C_ZERO)throw DivisionByZero();let F=Object.create(Fraction.prototype);F.s=D<C_ZERO?-C_ONE:C_ONE,D=D<C_ZERO?-D:D;let J=gcd$1(D,E);return F.n=D/J,F.d=E/J,F}function factorize(D){let E={},F=D,J=C_TWO,$e=C_FIVE-C_ONE;for(;$e<=F;){for(;F%J===C_ZERO;)F/=J,E[J]=(E[J]||C_ZERO)+C_ONE;$e+=C_ONE+C_TWO*J++}return F===D?E[D]=(E[D]||C_ZERO)+C_ONE:F>1&&(E[F]=(E[F]||C_ZERO)+C_ONE),E}var parse=function(D,E){let F=C_ZERO,J=C_ONE,$e=C_ONE;if(D!=null)if(E!==void 0){if(typeof D=="bigint")F=D;else{if(isNaN(D))throw InvalidParameter();if(D%1!=0)throw NonIntegerParameter();F=BigInt(D)}if(typeof E=="bigint")J=E;else{if(isNaN(E))throw InvalidParameter();if(E%1!=0)throw NonIntegerParameter();J=BigInt(E)}$e=F*J}else if(typeof D=="object"){if("d"in D&&"n"in D)F=BigInt(D.n),J=BigInt(D.d),"s"in D&&(F*=BigInt(D.s));else if(0 in D)F=BigInt(D[0]),1 in D&&(J=BigInt(D[1]));else if(typeof D=="bigint")F=D;else throw InvalidParameter();$e=F*J}else if(typeof D=="number"){if(isNaN(D))throw InvalidParameter();if(D<0&&($e=-C_ONE,D=-D),D%1==0)F=BigInt(D);else{let _t=1,lr=0,mr=1,Or=1,Pr=1,dn=1e7;for(D>=1&&(_t=10**Math.floor(1+Math.log10(D)),D/=_t);mr<=dn&&Pr<=dn;){let gi=(lr+Or)/(mr+Pr);if(D===gi){mr+Pr<=dn?(F=lr+Or,J=mr+Pr):Pr>mr?(F=Or,J=Pr):(F=lr,J=mr);break}else D>gi?(lr+=Or,mr+=Pr):(Or+=lr,Pr+=mr),mr>dn?(F=Or,J=Pr):(F=lr,J=mr)}F=BigInt(F)*BigInt(_t),J=BigInt(J)}}else if(typeof D=="string"){let _t=0,lr=C_ZERO,mr=C_ZERO,Or=C_ZERO,Pr=C_ONE,dn=C_ONE,gi=D.replace(/_/g,"").match(/\\d+|./g);if(gi===null)throw InvalidParameter();if(gi[_t]==="-"?($e=-C_ONE,_t++):gi[_t]==="+"&&_t++,gi.length===_t+1?mr=assign(gi[_t++],$e):gi[_t+1]==="."||gi[_t]==="."?(gi[_t]!=="."&&(lr=assign(gi[_t++],$e)),_t++,(_t+1===gi.length||gi[_t+1]==="("&&gi[_t+3]===")"||gi[_t+1]==="\'"&&gi[_t+3]==="\'")&&(mr=assign(gi[_t],$e),Pr=C_TEN**BigInt(gi[_t].length),_t++),(gi[_t]==="("&&gi[_t+2]===")"||gi[_t]==="\'"&&gi[_t+2]==="\'")&&(Or=assign(gi[_t+1],$e),dn=C_TEN**BigInt(gi[_t+1].length)-C_ONE,_t+=3)):gi[_t+1]==="/"||gi[_t+1]===":"?(mr=assign(gi[_t],$e),Pr=assign(gi[_t+2],C_ONE),_t+=3):gi[_t+3]==="/"&&gi[_t+1]===" "&&(lr=assign(gi[_t],$e),mr=assign(gi[_t+2],$e),Pr=assign(gi[_t+4],C_ONE),_t+=5),gi.length<=_t)J=Pr*dn,$e=F=Or+J*lr+dn*mr;else throw InvalidParameter()}else if(typeof D=="bigint")F=D,$e=D,J=C_ONE;else throw InvalidParameter();if(J===C_ZERO)throw DivisionByZero();P$1.s=$e<C_ZERO?-C_ONE:C_ONE,P$1.n=F<C_ZERO?-F:F,P$1.d=J<C_ZERO?-J:J};function modpow(D,E,F){let J=C_ONE;for(;E>C_ZERO;D=D*D%F,E>>=C_ONE)E&C_ONE&&(J=J*D%F);return J}function cycleLen(D,E){for(;E%C_TWO===C_ZERO;E/=C_TWO);for(;E%C_FIVE===C_ZERO;E/=C_FIVE);if(E===C_ONE)return C_ZERO;let F=C_TEN%E,J=1;for(;F!==C_ONE;J++)if(F=F*C_TEN%E,J>MAX_CYCLE_LEN)return C_ZERO;return BigInt(J)}function cycleStart(D,E,F){let J=C_ONE,$e=modpow(C_TEN,F,E);for(let _t=0;_t<300;_t++){if(J===$e)return BigInt(_t);J=J*C_TEN%E,$e=$e*C_TEN%E}return 0}function gcd$1(D,E){if(!D)return E;if(!E)return D;for(;;){if(D%=E,!D)return E;if(E%=D,!E)return D}}function Fraction(D,E){if(parse(D,E),this instanceof Fraction)D=gcd$1(P$1.d,P$1.n),this.s=P$1.s,this.n=P$1.n/D,this.d=P$1.d/D;else return newFraction(P$1.s*P$1.n,P$1.d)}var DivisionByZero=function(){return Error("Division by Zero")},InvalidParameter=function(){return Error("Invalid argument")},NonIntegerParameter=function(){return Error("Parameters must be integer")};Fraction.prototype={s:C_ONE,n:C_ZERO,d:C_ONE,abs:function(){return newFraction(this.n,this.d)},neg:function(){return newFraction(-this.s*this.n,this.d)},add:function(D,E){return parse(D,E),newFraction(this.s*this.n*P$1.d+P$1.s*this.d*P$1.n,this.d*P$1.d)},sub:function(D,E){return parse(D,E),newFraction(this.s*this.n*P$1.d-P$1.s*this.d*P$1.n,this.d*P$1.d)},mul:function(D,E){return parse(D,E),newFraction(this.s*P$1.s*this.n*P$1.n,this.d*P$1.d)},div:function(D,E){return parse(D,E),newFraction(this.s*P$1.s*this.n*P$1.d,this.d*P$1.n)},clone:function(){return newFraction(this.s*this.n,this.d)},mod:function(D,E){if(D===void 0)return newFraction(this.s*this.n%this.d,C_ONE);if(parse(D,E),C_ZERO===P$1.n*this.d)throw DivisionByZero();return newFraction(this.s*(P$1.d*this.n)%(P$1.n*this.d),P$1.d*this.d)},gcd:function(D,E){return parse(D,E),newFraction(gcd$1(P$1.n,this.n)*gcd$1(P$1.d,this.d),P$1.d*this.d)},lcm:function(D,E){return parse(D,E),P$1.n===C_ZERO&&this.n===C_ZERO?newFraction(C_ZERO,C_ONE):newFraction(P$1.n*this.n,gcd$1(P$1.n,this.n)*gcd$1(P$1.d,this.d))},inverse:function(){return newFraction(this.s*this.d,this.n)},pow:function(D,E){if(parse(D,E),P$1.d===C_ONE)return P$1.s<C_ZERO?newFraction((this.s*this.d)**P$1.n,this.n**P$1.n):newFraction((this.s*this.n)**P$1.n,this.d**P$1.n);if(this.s<C_ZERO)return null;let F=factorize(this.n),J=factorize(this.d),$e=C_ONE,_t=C_ONE;for(let lr in F)if(lr!=="1"){if(lr==="0"){$e=C_ZERO;break}if(F[lr]*=P$1.n,F[lr]%P$1.d===C_ZERO)F[lr]/=P$1.d;else return null;$e*=BigInt(lr)**F[lr]}for(let lr in J)if(lr!=="1"){if(J[lr]*=P$1.n,J[lr]%P$1.d===C_ZERO)J[lr]/=P$1.d;else return null;_t*=BigInt(lr)**J[lr]}return P$1.s<C_ZERO?newFraction(_t,$e):newFraction($e,_t)},log:function(D,E){if(parse(D,E),this.s<=C_ZERO||P$1.s<=C_ZERO)return null;let F={},J=factorize(P$1.n),$e=factorize(P$1.d),_t=factorize(this.n),lr=factorize(this.d);for(let Pr in $e)J[Pr]=(J[Pr]||C_ZERO)-$e[Pr];for(let Pr in lr)_t[Pr]=(_t[Pr]||C_ZERO)-lr[Pr];for(let Pr in J)Pr!=="1"&&(F[Pr]=!0);for(let Pr in _t)Pr!=="1"&&(F[Pr]=!0);let mr=null,Or=null;for(let Pr in F){let dn=J[Pr]||C_ZERO,gi=_t[Pr]||C_ZERO;if(dn===C_ZERO){if(gi!==C_ZERO)return null;continue}let qi=gi,zi=dn,Hi=gcd$1(qi,zi);if(qi/=Hi,zi/=Hi,mr===null&&Or===null)mr=qi,Or=zi;else if(qi*Or!==mr*zi)return null}return mr!==null&&Or!==null?newFraction(mr,Or):null},equals:function(D,E){return parse(D,E),this.s*this.n*P$1.d===P$1.s*P$1.n*this.d},lt:function(D,E){return parse(D,E),this.s*this.n*P$1.d<P$1.s*P$1.n*this.d},lte:function(D,E){return parse(D,E),this.s*this.n*P$1.d<=P$1.s*P$1.n*this.d},gt:function(D,E){return parse(D,E),this.s*this.n*P$1.d>P$1.s*P$1.n*this.d},gte:function(D,E){return parse(D,E),this.s*this.n*P$1.d>=P$1.s*P$1.n*this.d},compare:function(D,E){parse(D,E);let F=this.s*this.n*P$1.d-P$1.s*P$1.n*this.d;return(C_ZERO<F)-(F<C_ZERO)},ceil:function(D){return D=C_TEN**BigInt(D||0),newFraction(trunc(this.s*D*this.n/this.d)+(D*this.n%this.d>C_ZERO&&this.s>=C_ZERO?C_ONE:C_ZERO),D)},floor:function(D){return D=C_TEN**BigInt(D||0),newFraction(trunc(this.s*D*this.n/this.d)-(D*this.n%this.d>C_ZERO&&this.s<C_ZERO?C_ONE:C_ZERO),D)},round:function(D){return D=C_TEN**BigInt(D||0),newFraction(trunc(this.s*D*this.n/this.d)+this.s*((this.s>=C_ZERO?C_ONE:C_ZERO)+C_TWO*(D*this.n%this.d)>this.d?C_ONE:C_ZERO),D)},roundTo:function(D,E){parse(D,E);let F=this.n*P$1.d,J=this.d*P$1.n,$e=F%J,_t=trunc(F/J);return $e+$e>=J&&_t++,newFraction(this.s*_t*P$1.n,P$1.d)},divisible:function(D,E){return parse(D,E),!(!(P$1.n*this.d)||this.n*P$1.d%(P$1.n*this.d))},valueOf:function(){return Number(this.s*this.n)/Number(this.d)},toString:function(D){let E=this.n,F=this.d;D||=15;let J=cycleLen(E,F),$e=cycleStart(E,F,J),_t=this.s<C_ZERO?"-":"";if(_t+=trunc(E/F),E%=F,E*=C_TEN,E&&(_t+="."),J){for(let lr=$e;lr--;)_t+=trunc(E/F),E%=F,E*=C_TEN;_t+="(";for(let lr=J;lr--;)_t+=trunc(E/F),E%=F,E*=C_TEN;_t+=")"}else for(let lr=D;E&&lr--;)_t+=trunc(E/F),E%=F,E*=C_TEN;return _t},toFraction:function(D){let E=this.n,F=this.d,J=this.s<C_ZERO?"-":"";if(F===C_ONE)J+=E;else{let $e=trunc(E/F);D&&$e>C_ZERO&&(J+=$e,J+=" ",E%=F),J+=E,J+="/",J+=F}return J},toLatex:function(D){let E=this.n,F=this.d,J=this.s<C_ZERO?"-":"";if(F===C_ONE)J+=E;else{let $e=trunc(E/F);D&&$e>C_ZERO&&(J+=$e,E%=F),J+="\\\\frac{",J+=E,J+="}{",J+=F,J+="}"}return J},toContinued:function(){let D=this.n,E=this.d,F=[];do{F.push(trunc(D/E));let J=D%E;D=E,E=J}while(D!==C_ONE);return F},simplify:function(D){let E=BigInt(1/(D||.001)|0),F=this.abs(),J=F.toContinued();for(let $e=1;$e<J.length;$e++){let _t=newFraction(J[$e-1],C_ONE);for(let mr=$e-2;mr>=0;mr--)_t=_t.inverse().add(J[mr]);let lr=_t.sub(F);if(lr.n*E<lr.d)return _t.mul(this.s)}return this}};var name$318="Fraction",dependencies$318=[],createFractionClass=factory(name$318,dependencies$318,()=>(Object.defineProperty(Fraction,"name",{value:"Fraction"}),Fraction.prototype.constructor=Fraction,Fraction.prototype.type="Fraction",Fraction.prototype.isFraction=!0,Fraction.prototype.toJSON=function(){return{mathjs:"Fraction",n:String(this.s*this.n),d:String(this.d)}},Fraction.fromJSON=function(D){return new Fraction(D)},Fraction),{isClass:!0}),name$317="Range",dependencies$317=[],createRangeClass=factory(name$317,dependencies$317,()=>{function D(E,F,J){if(!(this instanceof D))throw SyntaxError("Constructor must be called with the new operator");var $e=E!=null,_t=F!=null,lr=J!=null;if($e){if(isBigNumber(E))E=E.toNumber();else if(typeof E!="number"&&!isBigInt(E))throw TypeError("Parameter start must be a number or bigint")}if(_t){if(isBigNumber(F))F=F.toNumber();else if(typeof F!="number"&&!isBigInt(F))throw TypeError("Parameter end must be a number or bigint")}if(lr){if(isBigNumber(J))J=J.toNumber();else if(typeof J!="number"&&!isBigInt(J))throw TypeError("Parameter step must be a number or bigint")}if(this.start=$e?parseFloat(E):0,this.end=_t?parseFloat(F):0,this.step=lr?parseFloat(J):1,lr&&nearlyEqual$1(this.step,0))throw Error("Step must not be zero")}return D.prototype.type="Range",D.prototype.isRange=!0,D.parse=function(E){if(typeof E!="string")return null;var F=E.split(":").map(function(J){return parseFloat(J)});if(F.some(function(J){return isNaN(J)}))return null;switch(F.length){case 2:return new D(F[0],F[1]);case 3:return new D(F[0],F[2],F[1]);default:return null}},D.prototype.clone=function(){return new D(this.start,this.end,this.step)},D.prototype.size=function(){var E=0,F=this.start,J=this.step,$e=this.end-F;return sign$2(J)===sign$2($e)?E=Math.ceil($e/J):$e===0&&(E=0),isNaN(E)&&(E=0),[E]},D.prototype.min=function(){var E=this.size()[0];if(E>0)return this.step>0?this.start:this.start+(E-1)*this.step},D.prototype.max=function(){var E=this.size()[0];if(E>0)return this.step>0?this.start+(E-1)*this.step:this.start},D.prototype.forEach=function(E){var F=this.start,J=this.step,$e=this.end,_t=0;if(J>0)for(;F<$e;)E(F,[_t],this),F+=J,_t++;else if(J<0)for(;F>$e;)E(F,[_t],this),F+=J,_t++},D.prototype.map=function(E){var F=[];return this.forEach(function(J,$e,_t){F[$e[0]]=E(J,$e,_t)}),F},D.prototype.toArray=function(){var E=[];return this.forEach(function(F,J){E[J[0]]=F}),E},D.prototype.valueOf=function(){return this.toArray()},D.prototype.format=function(E){var F=format$2(this.start,E);return this.step!==1&&(F+=":"+format$2(this.step,E)),F+=":"+format$2(this.end,E),F},D.prototype.toString=function(){return this.format()},D.prototype.toJSON=function(){return{mathjs:"Range",start:this.start,end:this.end,step:this.step}},D.fromJSON=function(E){return new D(E.start,E.end,E.step)},D},{isClass:!0}),name$316="Matrix",dependencies$316=[],createMatrixClass=factory(name$316,dependencies$316,()=>{function D(){if(!(this instanceof D))throw SyntaxError("Constructor must be called with the new operator")}return D.prototype.type="Matrix",D.prototype.isMatrix=!0,D.prototype.storage=function(){throw Error("Cannot invoke storage on a Matrix interface")},D.prototype.datatype=function(){throw Error("Cannot invoke datatype on a Matrix interface")},D.prototype.create=function(E,F){throw Error("Cannot invoke create on a Matrix interface")},D.prototype.subset=function(E,F,J){throw Error("Cannot invoke subset on a Matrix interface")},D.prototype.get=function(E){throw Error("Cannot invoke get on a Matrix interface")},D.prototype.set=function(E,F,J){throw Error("Cannot invoke set on a Matrix interface")},D.prototype.resize=function(E,F){throw Error("Cannot invoke resize on a Matrix interface")},D.prototype.reshape=function(E,F){throw Error("Cannot invoke reshape on a Matrix interface")},D.prototype.clone=function(){throw Error("Cannot invoke clone on a Matrix interface")},D.prototype.size=function(){throw Error("Cannot invoke size on a Matrix interface")},D.prototype.map=function(E,F){throw Error("Cannot invoke map on a Matrix interface")},D.prototype.forEach=function(E){throw Error("Cannot invoke forEach on a Matrix interface")},D.prototype[Symbol.iterator]=function(){throw Error("Cannot iterate a Matrix interface")},D.prototype.toArray=function(){throw Error("Cannot invoke toArray on a Matrix interface")},D.prototype.valueOf=function(){throw Error("Cannot invoke valueOf on a Matrix interface")},D.prototype.format=function(E){throw Error("Cannot invoke format on a Matrix interface")},D.prototype.toString=function(){throw Error("Cannot invoke toString on a Matrix interface")},D},{isClass:!0});function formatBigNumberToBase(D,E,F){var J=D.constructor,$e=new J(2),_t="";if(F){if(F<1)throw Error("size must be in greater than 0");if(!isInteger(F))throw Error("size must be an integer");if(D.greaterThan($e.pow(F-1).sub(1))||D.lessThan($e.pow(F-1).mul(-1)))throw Error(`Value must be in range [-2^${F-1}, 2^${F-1}-1]`);if(!D.isInteger())throw Error("Value must be an integer");D.lessThan(0)&&(D=D.add($e.pow(F))),_t=`i${F}`}switch(E){case 2:return`${D.toBinary()}${_t}`;case 8:return`${D.toOctal()}${_t}`;case 16:return`${D.toHexadecimal()}${_t}`;default:throw Error(`Base ${E} not supported `)}}function format$1(D,E){if(typeof E=="function")return E(D);if(!D.isFinite())return D.isNaN()?"NaN":D.gt(0)?"Infinity":"-Infinity";var{notation:F,precision:J,wordSize:$e}=normalizeFormatOptions(E);switch(F){case"fixed":return toFixed$1(D,J);case"exponential":return toExponential(D,J);case"engineering":return toEngineering(D,J);case"bin":return formatBigNumberToBase(D,2,$e);case"oct":return formatBigNumberToBase(D,8,$e);case"hex":return formatBigNumberToBase(D,16,$e);case"auto":var _t=_toNumberOrDefault(E?.lowerExp,-3),lr=_toNumberOrDefault(E?.upperExp,5);if(D.isZero())return"0";var mr,Or=D.toSignificantDigits(J),Pr=Or.e;return mr=Pr>=_t&&Pr<lr?Or.toFixed():toExponential(D,J),mr.replace(/((\\.\\d*?)(0+))($|e)/,function(){var dn=arguments[2],gi=arguments[4];return dn==="."?gi:dn+gi});default:throw Error(\'Unknown notation "\'+F+\'". Choose "auto", "exponential", "fixed", "bin", "oct", or "hex.\')}}function toEngineering(D,E){var F=D.e,J=F%3==0?F:F<0?F-3-F%3:F-F%3,$e=D.mul(10**-J).toPrecision(E);if($e.includes("e")){var _t=D.constructor;$e=new _t($e).toFixed()}return $e+"e"+(F>=0?"+":"")+J.toString()}function toExponential(D,E){return E===void 0?D.toExponential():D.toExponential(E-1)}function toFixed$1(D,E){return D.toFixed(E)}function _toNumberOrDefault(D,E){return isNumber(D)?D:isBigNumber(D)?D.toNumber():E}function endsWith(D,E){var F=D.length-E.length,J=D.length;return D.substring(F,J)===E}function format(D,E){var F=_format(D,E);return E&&typeof E=="object"&&"truncate"in E&&F.length>E.truncate?F.substring(0,E.truncate-3)+"...":F}function _format(D,E){return typeof D=="number"?format$2(D,E):isBigNumber(D)?format$1(D,E):looksLikeFraction(D)?!E||E.fraction!=="decimal"?`${D.s*D.n}/${D.d}`:D.toString():Array.isArray(D)?formatArray(D,E):isString(D)?stringify(D):typeof D=="function"?D.syntax?String(D.syntax):"function":D&&typeof D=="object"?typeof D.format=="function"?D.format(E):D&&D.toString(E)!=={}.toString()?D.toString(E):"{"+Object.keys(D).map(F=>stringify(F)+": "+format(D[F],E)).join(", ")+"}":String(D)}function stringify(D){for(var E=String(D),F="",J=0;J<E.length;){var $e=E.charAt(J);F+=$e in controlCharacters?controlCharacters[$e]:$e,J++}return\'"\'+F+\'"\'}var controlCharacters={\'"\':\'\\\\"\',"\\\\":"\\\\\\\\","\\b":"\\\\b","\\f":"\\\\f","\\n":"\\\\n","\\r":"\\\\r","	":"\\\\t"};function escape(D){var E=String(D);return E=E.replace(/&/g,"&amp;").replace(/"/g,"&quot;").replace(/\'/g,"&#39;").replace(/</g,"&lt;").replace(/>/g,"&gt;"),E}function formatArray(D,E){if(Array.isArray(D)){for(var F="[",J=D.length,$e=0;$e<J;$e++)$e!==0&&(F+=", "),F+=formatArray(D[$e],E);return F+="]",F}else return format(D,E)}function looksLikeFraction(D){return D&&typeof D=="object"&&typeof D.s=="bigint"&&typeof D.n=="bigint"&&typeof D.d=="bigint"||!1}function compareText(D,E){if(!isString(D))throw TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: "+typeOf(D)+", index: 0)");if(!isString(E))throw TypeError("Unexpected type of argument in function compareText (expected: string or Array or Matrix, actual: "+typeOf(E)+", index: 1)");return D===E?0:D>E?1:-1}function DimensionError(D,E,F){if(!(this instanceof DimensionError))throw SyntaxError("Constructor must be called with the new operator");this.actual=D,this.expected=E,this.relation=F,this.message="Dimension mismatch ("+(Array.isArray(D)?"["+D.join(", ")+"]":D)+" "+(this.relation||"!=")+" "+(Array.isArray(E)?"["+E.join(", ")+"]":E)+")",this.stack=Error().stack}DimensionError.prototype=RangeError(),DimensionError.prototype.constructor=RangeError,DimensionError.prototype.name="DimensionError",DimensionError.prototype.isDimensionError=!0;function IndexError(D,E,F){if(!(this instanceof IndexError))throw SyntaxError("Constructor must be called with the new operator");this.index=D,arguments.length<3?(this.min=0,this.max=E):(this.min=E,this.max=F),this.min!==void 0&&this.index<this.min?this.message="Index out of range ("+this.index+" < "+this.min+")":this.max!==void 0&&this.index>=this.max?this.message="Index out of range ("+this.index+" > "+(this.max-1)+")":this.message="Index out of range ("+this.index+")",this.stack=Error().stack}IndexError.prototype=RangeError(),IndexError.prototype.constructor=RangeError,IndexError.prototype.name="IndexError",IndexError.prototype.isIndexError=!0;function arraySize(D){for(var E=[];Array.isArray(D);)E.push(D.length),D=D[0];return E}function _validate(D,E,F){var J,$e=D.length;if($e!==E[F])throw new DimensionError($e,E[F]);if(F<E.length-1){var _t=F+1;for(J=0;J<$e;J++){var lr=D[J];if(!Array.isArray(lr))throw new DimensionError(E.length-1,E.length,"<");_validate(D[J],E,_t)}}else for(J=0;J<$e;J++)if(Array.isArray(D[J]))throw new DimensionError(E.length+1,E.length,">")}function validate(D,E){if(E.length===0){if(Array.isArray(D))throw new DimensionError(D.length,0)}else _validate(D,E,0)}function validateIndexSourceSize(D,E){var F=D.isMatrix?D._size:arraySize(D);E._sourceSize.forEach((J,$e)=>{if(J!==null&&J!==F[$e])throw new DimensionError(J,F[$e])})}function validateIndex(D,E){if(D!==void 0){if(!isNumber(D)||!isInteger(D))throw TypeError("Index must be an integer (value: "+D+")");if(D<0||typeof E=="number"&&D>=E)throw new IndexError(D,E)}}function isEmptyIndex(D){for(var E=0;E<D._dimensions.length;++E){var F=D._dimensions[E];if(F._data&&isArray(F._data)){if(F._size[0]===0)return!0}else if(F.isRange){if(F.start===F.end)return!0}else if(isString(F)&&F.length===0)return!0}return!1}function resize(D,E,F){if(!Array.isArray(E))throw TypeError("Array expected");if(E.length===0)throw Error("Resizing to scalar is not supported");return E.forEach(function(J){if(!isNumber(J)||!isInteger(J)||J<0)throw TypeError("Invalid size, must contain positive integers (size: "+format(E)+")")}),(isNumber(D)||isBigNumber(D))&&(D=[D]),_resize(D,E,0,F===void 0?0:F),D}function _resize(D,E,F,J){var $e,_t,lr=D.length,mr=E[F],Or=Math.min(lr,mr);if(D.length=mr,F<E.length-1){var Pr=F+1;for($e=0;$e<Or;$e++)_t=D[$e],Array.isArray(_t)||(_t=[_t],D[$e]=_t),_resize(_t,E,Pr,J);for($e=Or;$e<mr;$e++)_t=[],D[$e]=_t,_resize(_t,E,Pr,J)}else{for($e=0;$e<Or;$e++)for(;Array.isArray(D[$e]);)D[$e]=D[$e][0];for($e=Or;$e<mr;$e++)D[$e]=J}}function reshape(D,E){var F=flatten$4(D,!0),J=F.length;if(!Array.isArray(D)||!Array.isArray(E))throw TypeError("Array expected");if(E.length===0)throw new DimensionError(0,J,"!=");E=processSizesWildcard(E,J);var $e=product$1(E);if(J!==$e)throw new DimensionError($e,J,"!=");try{return _reshape(F,E)}catch(_t){throw _t instanceof DimensionError?new DimensionError($e,J,"!="):_t}}function processSizesWildcard(D,E){var F=product$1(D),J=D.slice(),$e=-1,_t=D.indexOf($e);if(D.indexOf($e,_t+1)>=0)throw Error("More than one wildcard in sizes");var lr=_t>=0,mr=E%F===0;if(lr)if(mr)J[_t]=-E/F;else throw Error("Could not replace wildcard, since "+E+" is no multiple of "+-F);return J}function product$1(D){return D.reduce((E,F)=>E*F,1)}function _reshape(D,E){for(var F=D,J,$e=E.length-1;$e>0;$e--){var _t=E[$e];J=[];for(var lr=F.length/_t,mr=0;mr<lr;mr++)J.push(F.slice(mr*_t,(mr+1)*_t));F=J}return F}function squeeze(D,E){for(var F=arraySize(D);Array.isArray(D)&&D.length===1;)D=D[0],F.shift();for(var J=F.length;F[J-1]===1;)J--;return J<F.length&&(D=_squeeze(D,J,0),F.length=J),D}function _squeeze(D,E,F){var J,$e;if(F<E){var _t=F+1;for(J=0,$e=D.length;J<$e;J++)D[J]=_squeeze(D[J],E,_t)}else for(;Array.isArray(D);)D=D[0];return D}function unsqueeze(D,E,F,J){var $e=J||arraySize(D);if(F)for(var _t=0;_t<F;_t++)D=[D],$e.unshift(1);for(D=_unsqueeze(D,E,0);$e.length<E;)$e.push(1);return D}function _unsqueeze(D,E,F){var J,$e;if(Array.isArray(D)){var _t=F+1;for(J=0,$e=D.length;J<$e;J++)D[J]=_unsqueeze(D[J],E,_t)}else for(var lr=F;lr<E;lr++)D=[D];return D}function flatten$4(D){var E=arguments.length>1&&arguments[1]!==void 0?arguments[1]:!1;if(!Array.isArray(D))return D;if(typeof E!="boolean")throw TypeError("Boolean expected for second argument of flatten");var F=[];return E?$e(D):J(D),F;function J(_t){for(var lr=0;lr<_t.length;lr++){var mr=_t[lr];Array.isArray(mr)?J(mr):F.push(mr)}}function $e(_t){if(Array.isArray(_t[0]))for(var lr=0;lr<_t.length;lr++)$e(_t[lr]);else for(var mr=0;mr<_t.length;mr++)F.push(_t[mr])}}function map$1(D,E){return Array.prototype.map.call(D,E)}function forEach(D,E){Array.prototype.forEach.call(D,E)}function filter$1(D,E){if(arraySize(D).length!==1)throw Error("Only one dimensional matrices supported");return Array.prototype.filter.call(D,E)}function filterRegExp(D,E){if(arraySize(D).length!==1)throw Error("Only one dimensional matrices supported");return Array.prototype.filter.call(D,F=>E.test(F))}function join(D,E){return Array.prototype.join.call(D,E)}function identify(D){if(!Array.isArray(D))throw TypeError("Array input expected");if(D.length===0)return D;var E=[],F=0;E[0]={value:D[0],identifier:0};for(var J=1;J<D.length;J++)D[J]===D[J-1]?F++:F=0,E.push({value:D[J],identifier:F});return E}function generalize(D){if(!Array.isArray(D))throw TypeError("Array input expected");if(D.length===0)return D;for(var E=[],F=0;F<D.length;F++)E.push(D[F].value);return E}function getArrayDataType(D,E){for(var F,J=0,$e=0;$e<D.length;$e++){var _t=D[$e],lr=Array.isArray(_t);if($e===0&&lr&&(J=_t.length),lr&&_t.length!==J)return;var mr=lr?getArrayDataType(_t,E):E(_t);if(F===void 0)F=mr;else if(F!==mr)return"mixed"}return F}function concatRecursive(D,E,F,J){if(J<F){if(D.length!==E.length)throw new DimensionError(D.length,E.length);for(var $e=[],_t=0;_t<D.length;_t++)$e[_t]=concatRecursive(D[_t],E[_t],F,J+1);return $e}else return D.concat(E)}function concat(){var D=Array.prototype.slice.call(arguments,0,-1),E=Array.prototype.slice.call(arguments,-1);if(D.length===1)return D[0];if(D.length>1)return D.slice(1).reduce(function(F,J){return concatRecursive(F,J,E,0)},D[0]);throw Error("Wrong number of arguments in function concat")}function broadcastSizes(){for(var D=[...arguments],E=D.map(dn=>dn.length),F=Math.max(...E),J=Array(F).fill(null),$e=0;$e<D.length;$e++)for(var _t=D[$e],lr=E[$e],mr=0;mr<lr;mr++){var Or=F-lr+mr;_t[mr]>J[Or]&&(J[Or]=_t[mr])}for(var Pr=0;Pr<D.length;Pr++)checkBroadcastingRules(D[Pr],J);return J}function checkBroadcastingRules(D,E){for(var F=E.length,J=D.length,$e=0;$e<J;$e++){var _t=F-J+$e;if(D[$e]<E[_t]&&D[$e]>1||D[$e]>E[_t])throw Error(`shape mismatch: mismatch is found in arg with shape (${D}) not possible to broadcast dimension ${J} with size ${D[$e]} to size ${E[_t]}`)}}function broadcastTo(D,E){var F=arraySize(D);if(deepStrictEqual(F,E))return D;checkBroadcastingRules(F,E);var J=broadcastSizes(F,E),$e=J.length,_t=[...Array($e-F.length).fill(1),...F],lr=clone$1(D);F.length<$e&&(lr=reshape(lr,_t),F=arraySize(lr));for(var mr=0;mr<$e;mr++)F[mr]<J[mr]&&(lr=stretch(lr,J[mr],mr),F=arraySize(lr));return lr}function stretch(D,E,F){return concat(...Array(E).fill(D),F)}function get$1(D,E){if(!Array.isArray(D))throw Error("Array expected");if(!Array.isArray(E))throw Error("Array expected for index");var F=arraySize(D);if(E.length!==F.length)throw new DimensionError(E.length,F.length);for(var J=0;J<E.length;J++)validateIndex(E[J],F[J]);return E.reduce(($e,_t)=>$e[_t],D)}function deepMap$1(D,E){var F=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1;if(D.length===0)return[];if(F)return _t(D);var J=[];return $e(D,0);function $e(lr,mr){if(Array.isArray(lr)){for(var Or=lr.length,Pr=Array(Or),dn=0;dn<Or;dn++)J[mr]=dn,Pr[dn]=$e(lr[dn],mr+1);return Pr}else return E(lr,J.slice(0,mr),D)}function _t(lr){if(Array.isArray(lr)){for(var mr=lr.length,Or=Array(mr),Pr=0;Pr<mr;Pr++)Or[Pr]=_t(lr[Pr]);return Or}else return E(lr)}}function deepForEach$1(D,E){var F=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1;if(D.length===0)return;if(F){_t(D);return}var J=[];$e(D,0);function $e(lr,mr){if(Array.isArray(lr))for(var Or=lr.length,Pr=0;Pr<Or;Pr++)J[mr]=Pr,$e(lr[Pr],mr+1);else E(lr,J.slice(0,mr),D)}function _t(lr){if(Array.isArray(lr))for(var mr=lr.length,Or=0;Or<mr;Or++)_t(lr[Or]);else E(lr)}}function clone$1(D){return _extends([],D)}function optimizeCallback(D,E,F,J){if(import_typed_function.default.isTypedFunction(D)){var $e;if(J)$e=1;else{var _t=E.isMatrix?E.size():arraySize(E);if(!_t.length||_t[_t.length-1]===0)return{isUnary:J,fn:D};var lr=_t.map(()=>0);$e=_findNumberOfArgumentsTyped(D,E.isMatrix?E.get(lr):get$1(E,lr),lr,E)}var mr;if(E.isMatrix&&E.dataType!=="mixed"&&E.dataType!==void 0){var Or=_findSingleSignatureWithArity(D,$e);mr=Or===void 0?D:Or}else mr=D;return $e>=1&&$e<=3?{isUnary:$e===1,fn:function(){return _tryFunctionWithArgs(mr,[...arguments].slice(0,$e),F,D.name)}}:{isUnary:!1,fn:function(){return _tryFunctionWithArgs(mr,[...arguments],F,D.name)}}}return J===void 0?{isUnary:_findIfCallbackIsUnary(D),fn:D}:{isUnary:J,fn:D}}function _findSingleSignatureWithArity(D,E){var F=[];if(Object.entries(D.signatures).forEach(J=>{var[$e,_t]=J;$e.split(",").length===E&&F.push(_t)}),F.length===1)return F[0]}function _findIfCallbackIsUnary(D){if(D.length!==1)return!1;var E=D.toString();if(/arguments/.test(E))return!1;var F=E.match(/\\(.*?\\)/);return!/\\.\\.\\./.test(F)}function _findNumberOfArgumentsTyped(D,E,F,J){for(var $e=[E,F,J],_t=3;_t>0;_t--){var lr=$e.slice(0,_t);if(import_typed_function.default.resolve(D,lr)!==null)return _t}}function _tryFunctionWithArgs(D,E,F,J){try{return D(...E)}catch($e){_createCallbackError($e,E,F,J)}}function _createCallbackError(D,E,F,J){if(D instanceof TypeError&&D.data?.category==="wrongType"){var $e=[];throw $e.push(`value: ${typeOf(E[0])}`),E.length>=2&&$e.push(`index: ${typeOf(E[1])}`),E.length>=3&&$e.push(`array: ${typeOf(E[2])}`),TypeError(`Function ${F} cannot apply callback arguments ${J}(${$e.join(", ")}) at index ${JSON.stringify(E[1])}`)}else throw TypeError(`Function ${F} cannot apply callback arguments to function ${J}: ${D.message}`)}var name$315="DenseMatrix",dependencies$315=["Matrix","config"],createDenseMatrixClass=factory(name$315,dependencies$315,D=>{var{Matrix:E,config:F}=D;function J(gi,qi){if(!(this instanceof J))throw SyntaxError("Constructor must be called with the new operator");if(qi&&!isString(qi))throw Error("Invalid datatype: "+qi);if(isMatrix(gi))gi.type==="DenseMatrix"?(this._data=clone$3(gi._data),this._size=clone$3(gi._size),this._datatype=qi||gi._datatype):(this._data=gi.toArray(),this._size=gi.size(),this._datatype=qi||gi._datatype);else if(gi&&isArray(gi.data)&&isArray(gi.size))this._data=gi.data,this._size=gi.size,validate(this._data,this._size),this._datatype=qi||gi.datatype;else if(isArray(gi))this._data=dn(gi),this._size=arraySize(this._data),validate(this._data,this._size),this._datatype=qi;else{if(gi)throw TypeError("Unsupported type of data ("+typeOf(gi)+")");this._data=[],this._size=[0],this._datatype=qi}}J.prototype=new E,J.prototype.createDenseMatrix=function(gi,qi){return new J(gi,qi)},Object.defineProperty(J,"name",{value:"DenseMatrix"}),J.prototype.constructor=J,J.prototype.type="DenseMatrix",J.prototype.isDenseMatrix=!0,J.prototype.getDataType=function(){return getArrayDataType(this._data,typeOf)},J.prototype.storage=function(){return"dense"},J.prototype.datatype=function(){return this._datatype},J.prototype.create=function(gi,qi){return new J(gi,qi)},J.prototype.subset=function(gi,qi,zi){switch(arguments.length){case 1:return $e(this,gi);case 2:case 3:return lr(this,gi,qi,zi);default:throw SyntaxError("Wrong number of arguments")}},J.prototype.get=function(gi){return get$1(this._data,gi)},J.prototype.set=function(gi,qi,zi){if(!isArray(gi))throw TypeError("Array expected");if(gi.length<this._size.length)throw new DimensionError(gi.length,this._size.length,"<");var Hi,Qi,Gi,Zi=gi.map(function(Ki){return Ki+1});Pr(this,Zi,zi);var Xi=this._data;for(Hi=0,Qi=gi.length-1;Hi<Qi;Hi++)Gi=gi[Hi],validateIndex(Gi,Xi.length),Xi=Xi[Gi];return Gi=gi[gi.length-1],validateIndex(Gi,Xi.length),Xi[Gi]=qi,this};function $e(gi,qi){if(!isIndex(qi))throw TypeError("Invalid index");if(F.legacySubset?qi.size().every(ea=>ea===1):qi.isScalar())return gi.get(qi.min());var zi=qi.size();if(zi.length!==gi._size.length)throw new DimensionError(zi.length,gi._size.length);for(var Hi=qi.min(),Qi=qi.max(),Gi=0,Zi=gi._size.length;Gi<Zi;Gi++)validateIndex(Hi[Gi],gi._size[Gi]),validateIndex(Qi[Gi],gi._size[Gi]);var Xi=new J,Ki=_t(gi._data,qi);return Xi._size=Ki.size,Xi._datatype=gi._datatype,Xi._data=Ki.data,F.legacySubset?Xi.reshape(qi.size()):Xi}function _t(gi,qi){var zi=qi.size().length-1,Hi=Array(zi);return{data:Qi(gi),size:Hi.filter(Gi=>Gi!==null)};function Qi(Gi){var Zi=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,Xi=qi.dimension(Zi);function Ki(ea,Ji){return isNumber(ea)?Ji(ea):ea.map(Ji).valueOf()}return isNumber(Xi)?Hi[Zi]=null:Hi[Zi]=Xi.size()[0],Zi<zi?Ki(Xi,ea=>(validateIndex(ea,Gi.length),Qi(Gi[ea],Zi+1))):Ki(Xi,ea=>(validateIndex(ea,Gi.length),Gi[ea]))}}function lr(gi,qi,zi,Hi){if(!qi||qi.isIndex!==!0)throw TypeError("Invalid index");var Qi=qi.size(),Gi=qi.isScalar(),Zi;if(isMatrix(zi)?(Zi=zi.size(),zi=zi.valueOf()):Zi=arraySize(zi),Gi){if(Zi.length!==0)throw TypeError("Scalar expected");gi.set(qi.min(),zi,Hi)}else{if(!deepStrictEqual(Zi,Qi)){if(Zi.length===0)zi=broadcastTo([zi],Qi);else try{zi=broadcastTo(zi,Qi)}catch{}Zi=arraySize(zi)}if(Qi.length<gi._size.length)throw new DimensionError(Qi.length,gi._size.length,"<");if(Zi.length<Qi.length){for(var Xi=0,Ki=0;Qi[Xi]===1&&Zi[Xi]===1;)Xi++;for(;Qi[Xi]===1;)Ki++,Xi++;zi=unsqueeze(zi,Qi.length,Ki,Zi)}if(!deepStrictEqual(Qi,Zi))throw new DimensionError(Qi,Zi,">");Pr(gi,qi.max().map(function(ea){return ea+1}),Hi),mr(gi._data,qi,zi)}return gi}function mr(gi,qi,zi){var Hi=qi.size().length-1;Qi(gi,zi);function Qi(Gi,Zi){var Xi=arguments.length>2&&arguments[2]!==void 0?arguments[2]:0,Ki=qi.dimension(Xi),ea=(ta,na)=>{validateIndex(ta,Gi.length),Qi(Gi[ta],Zi[na[0]],Xi+1)},Ji=(ta,na)=>{validateIndex(ta,Gi.length),Gi[ta]=Zi[na[0]]};Xi<Hi?isNumber(Ki)?ea(Ki,[0]):Ki.forEach(ea):isNumber(Ki)?Ji(Ki,[0]):Ki.forEach(Ji)}}J.prototype.resize=function(gi,qi,zi){if(!isCollection(gi))throw TypeError("Array or Matrix expected");var Hi=gi.valueOf().map(Qi=>Array.isArray(Qi)&&Qi.length===1?Qi[0]:Qi);return Or(zi?this.clone():this,Hi,qi)};function Or(gi,qi,zi){if(qi.length===0){for(var Hi=gi._data;isArray(Hi);)Hi=Hi[0];return Hi}return gi._size=qi.slice(0),gi._data=resize(gi._data,gi._size,zi),gi}J.prototype.reshape=function(gi,qi){var zi=qi?this.clone():this;return zi._data=reshape(zi._data,gi),zi._size=processSizesWildcard(gi,zi._size.reduce((Hi,Qi)=>Hi*Qi)),zi};function Pr(gi,qi,zi){for(var Hi=gi._size.slice(0),Qi=!1;Hi.length<qi.length;)Hi.push(0),Qi=!0;for(var Gi=0,Zi=qi.length;Gi<Zi;Gi++)qi[Gi]>Hi[Gi]&&(Hi[Gi]=qi[Gi],Qi=!0);Qi&&Or(gi,Hi,zi)}J.prototype.clone=function(){return new J({data:clone$3(this._data),size:clone$3(this._size),datatype:this._datatype})},J.prototype.size=function(){return this._size.slice(0)},J.prototype.map=function(gi){var qi=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1,zi=this,Hi=zi._size.length-1;if(Hi<0)return zi.clone();var Qi=optimizeCallback(gi,zi,"map",qi),Gi=Qi.fn,Zi=zi.create(void 0,zi._datatype);if(Zi._size=zi._size,qi||Qi.isUnary)return Zi._data=na(zi._data),Zi;if(Hi===0){for(var Xi=zi.valueOf(),Ki=Array(Xi.length),ea=0;ea<Xi.length;ea++)Ki[ea]=Gi(Xi[ea],[ea],zi);return Zi._data=Ki,Zi}var Ji=[];return Zi._data=ta(zi._data),Zi;function ta(ra){var ia=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,oa=Array(ra.length);if(ia<Hi)for(var ua=0;ua<ra.length;ua++)Ji[ia]=ua,oa[ua]=ta(ra[ua],ia+1);else for(var sa=0;sa<ra.length;sa++)Ji[ia]=sa,oa[sa]=Gi(ra[sa],Ji.slice(),zi);return oa}function na(ra){var ia=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,oa=Array(ra.length);if(ia<Hi)for(var ua=0;ua<ra.length;ua++)oa[ua]=na(ra[ua],ia+1);else for(var sa=0;sa<ra.length;sa++)oa[sa]=Gi(ra[sa]);return oa}},J.prototype.forEach=function(gi){var qi=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1,zi=this,Hi=zi._size.length-1;if(Hi<0)return;var Qi=optimizeCallback(gi,zi,"map",qi),Gi=Qi.fn;if(qi||Qi.isUnary){ea(zi._data);return}if(Hi===0){for(var Zi=0;Zi<zi._data.length;Zi++)Gi(zi._data[Zi],[Zi],zi);return}var Xi=[];Ki(zi._data);function Ki(Ji){var ta=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;if(ta<Hi)for(var na=0;na<Ji.length;na++)Xi[ta]=na,Ki(Ji[na],ta+1);else for(var ra=0;ra<Ji.length;ra++)Xi[ta]=ra,Gi(Ji[ra],Xi.slice(),zi)}function ea(Ji){var ta=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;if(ta<Hi)for(var na=0;na<Ji.length;na++)ea(Ji[na],ta+1);else for(var ra=0;ra<Ji.length;ra++)Gi(Ji[ra])}},J.prototype[Symbol.iterator]=function*(){var gi=this._size.length-1;if(!(gi<0)){if(gi===0){for(var qi=0;qi<this._data.length;qi++)yield{value:this._data[qi],index:[qi]};return}for(var zi=Array(gi+1).fill(0),Hi=this._size.reduce((Ki,ea)=>Ki*ea,1),Qi=0;Qi<Hi;Qi++){for(var Gi=this._data,Zi=0;Zi<gi;Zi++)Gi=Gi[zi[Zi]];yield{value:Gi[zi[gi]],index:zi.slice()};for(var Xi=gi;Xi>=0&&(zi[Xi]++,!(zi[Xi]<this._size[Xi]));Xi--)zi[Xi]=0}}},J.prototype.rows=function(){var gi=[];if(this.size().length!==2)throw TypeError("Rows can only be returned for a 2D matrix.");for(var qi of this._data)gi.push(new J([qi],this._datatype));return gi},J.prototype.columns=function(){var gi=this,qi=[],zi=this.size();if(zi.length!==2)throw TypeError("Rows can only be returned for a 2D matrix.");for(var Hi=this._data,Qi=function(Zi){var Xi=Hi.map(Ki=>[Ki[Zi]]);qi.push(new J(Xi,gi._datatype))},Gi=0;Gi<zi[1];Gi++)Qi(Gi);return qi},J.prototype.toArray=function(){return clone$3(this._data)},J.prototype.valueOf=function(){return this._data},J.prototype.format=function(gi){return format(this._data,gi)},J.prototype.toString=function(){return format(this._data)},J.prototype.toJSON=function(){return{mathjs:"DenseMatrix",data:this._data,size:this._size,datatype:this._datatype}},J.prototype.diagonal=function(gi){if(gi){if(isBigNumber(gi)&&(gi=gi.toNumber()),!isNumber(gi)||!isInteger(gi))throw TypeError("The parameter k must be an integer number")}else gi=0;for(var qi=gi>0?gi:0,zi=gi<0?-gi:0,Hi=this._size[0],Qi=this._size[1],Gi=Math.min(Hi-zi,Qi-qi),Zi=[],Xi=0;Xi<Gi;Xi++)Zi[Xi]=this._data[Xi+zi][Xi+qi];return new J({data:Zi,size:[Gi],datatype:this._datatype})},J.diagonal=function(gi,qi,zi,Hi){if(!isArray(gi))throw TypeError("Array expected, size parameter");if(gi.length!==2)throw Error("Only two dimensions matrix are supported");if(gi=gi.map(function(ra){if(isBigNumber(ra)&&(ra=ra.toNumber()),!isNumber(ra)||!isInteger(ra)||ra<1)throw Error("Size values must be positive integers");return ra}),zi){if(isBigNumber(zi)&&(zi=zi.toNumber()),!isNumber(zi)||!isInteger(zi))throw TypeError("The parameter k must be an integer number")}else zi=0;var Qi=zi>0?zi:0,Gi=zi<0?-zi:0,Zi=gi[0],Xi=gi[1],Ki=Math.min(Zi-Gi,Xi-Qi),ea;if(isArray(qi)){if(qi.length!==Ki)throw Error("Invalid value array length");ea=function(ra){return qi[ra]}}else if(isMatrix(qi)){var Ji=qi.size();if(Ji.length!==1||Ji[0]!==Ki)throw Error("Invalid matrix length");ea=function(ra){return qi.get([ra])}}else ea=function(){return qi};Hi||=isBigNumber(ea(0))?ea(0).mul(0):0;var ta=[];if(gi.length>0){ta=resize(ta,gi,Hi);for(var na=0;na<Ki;na++)ta[na+Gi][na+Qi]=ea(na)}return new J({data:ta,size:[Zi,Xi]})},J.fromJSON=function(gi){return new J(gi)},J.prototype.swapRows=function(gi,qi){if(!isNumber(gi)||!isInteger(gi)||!isNumber(qi)||!isInteger(qi))throw Error("Row index must be positive integers");if(this._size.length!==2)throw Error("Only two dimensional matrix is supported");return validateIndex(gi,this._size[0]),validateIndex(qi,this._size[0]),J._swapRows(gi,qi,this._data),this},J._swapRows=function(gi,qi,zi){var Hi=zi[gi];zi[gi]=zi[qi],zi[qi]=Hi};function dn(gi){return isMatrix(gi)?dn(gi.valueOf()):isArray(gi)?gi.map(dn):gi}return J},{isClass:!0}),name$314="clone",dependencies$314=["typed"],createClone=factory(name$314,dependencies$314,D=>{var{typed:E}=D;return E(name$314,{any:clone$3})});function _switch$1(D){var E=D.length,F=D[0].length,J,$e,_t=[];for($e=0;$e<F;$e++){var lr=[];for(J=0;J<E;J++)lr.push(D[J][$e]);_t.push(lr)}return _t}function containsCollections(D){for(var E=0;E<D.length;E++)if(isCollection(D[E]))return!0;return!1}function deepForEach(D,E){isMatrix(D)?D.forEach(F=>E(F),!1,!0):deepForEach$1(D,E,!0)}function deepMap(D,E,F){if(!F)return isMatrix(D)?D.map($e=>E($e),!1,!0):deepMap$1(D,E,!0);var J=$e=>$e===0?$e:E($e);return isMatrix(D)?D.map($e=>J($e),!1,!0):deepMap$1(D,J,!0)}function reduce$1(D,E,F){var J=Array.isArray(D)?arraySize(D):D.size();if(E<0||E>=J.length)throw new IndexError(E,J.length);return isMatrix(D)?D.create(_reduce(D.valueOf(),E,F),D.datatype()):_reduce(D,E,F)}function _reduce(D,E,F){var J,$e,_t,lr;if(E<=0)if(Array.isArray(D[0])){for(lr=_switch$1(D),$e=[],J=0;J<lr.length;J++)$e[J]=_reduce(lr[J],E-1,F);return $e}else{for(_t=D[0],J=1;J<D.length;J++)_t=F(_t,D[J]);return _t}else{for($e=[],J=0;J<D.length;J++)$e[J]=_reduce(D[J],E-1,F);return $e}}function scatter(D,E,F,J,$e,_t,lr,mr,Or,Pr,dn){var gi=D._values,qi=D._index,zi=D._ptr,Hi,Qi,Gi,Zi;if(J)for(Qi=zi[E],Gi=zi[E+1],Hi=Qi;Hi<Gi;Hi++)Zi=qi[Hi],F[Zi]===_t?(J[Zi]=mr(J[Zi],gi[Hi]),$e[Zi]=_t):(F[Zi]=_t,lr.push(Zi),J[Zi]=gi[Hi]);else for(Qi=zi[E],Gi=zi[E+1],Hi=Qi;Hi<Gi;Hi++)Zi=qi[Hi],F[Zi]===_t?$e[Zi]=_t:(F[Zi]=_t,lr.push(Zi))}var name$313="isInteger",dependencies$313=["typed","equal"],createIsInteger=factory(name$313,dependencies$313,D=>{var{typed:E,equal:F}=D;return E(name$313,{number:J=>Number.isFinite(J)?F(J,Math.round(J)):!1,BigNumber:J=>J.isFinite()?F(J.round(),J):!1,bigint:J=>!0,Fraction:J=>J.d===1n,"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),n1$4="number",n2$3="number, number";function absNumber(D){return Math.abs(D)}absNumber.signature=n1$4;function addNumber(D,E){return D+E}addNumber.signature=n2$3;function subtractNumber(D,E){return D-E}subtractNumber.signature=n2$3;function multiplyNumber(D,E){return D*E}multiplyNumber.signature=n2$3;function unaryMinusNumber(D){return-D}unaryMinusNumber.signature=n1$4;function unaryPlusNumber(D){return D}unaryPlusNumber.signature=n1$4;function cbrtNumber(D){return cbrt$1(D)}cbrtNumber.signature=n1$4;function cubeNumber(D){return D*D*D}cubeNumber.signature=n1$4;function expNumber(D){return Math.exp(D)}expNumber.signature=n1$4;function expm1Number(D){return expm1(D)}expm1Number.signature=n1$4;function lcmNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Parameters in function lcm must be integer numbers");if(D===0||E===0)return 0;for(var F,J=D*E;E!==0;)F=E,E=D%F,D=F;return Math.abs(J/D)}lcmNumber.signature=n2$3;function logNumber(D,E){return E?Math.log(D)/Math.log(E):Math.log(D)}function log10Number(D){return log10$2(D)}log10Number.signature=n1$4;function log2Number(D){return log2$1(D)}log2Number.signature=n1$4;function nthRootNumber(D){var E=arguments.length>1&&arguments[1]!==void 0?arguments[1]:2,F=E<0;if(F&&(E=-E),E===0)throw Error("Root must be non-zero");if(D<0&&Math.abs(E)%2!=1)throw Error("Root must be odd when a is negative.");if(D===0)return F?1/0:0;if(!isFinite(D))return F?0:D;var J=Math.abs(D)**(1/E);return J=D<0?-J:J,F?1/J:J}function signNumber(D){return sign$2(D)}signNumber.signature=n1$4;function squareNumber(D){return D*D}squareNumber.signature=n1$4;function xgcdNumber(D,E){var F,J,$e,_t=0,lr=1,mr=1,Or=0;if(!isInteger(D)||!isInteger(E))throw Error("Parameters in function xgcd must be integer numbers");for(;E;)J=Math.floor(D/E),$e=D-J*E,F=_t,_t=lr-J*_t,lr=F,F=mr,mr=Or-J*mr,Or=F,D=E,E=$e;return D<0?[-D,-lr,-Or]:[D,D?lr:0,Or]}xgcdNumber.signature=n2$3;function powNumber(D,E){return D*D<1&&E===1/0||D*D>1&&E===-1/0?0:D**+E}powNumber.signature=n2$3;function roundNumber(D){var E=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0;if(!isInteger(E)||E<0||E>15)throw Error("Number of decimals in function round must be an integer from 0 to 15 inclusive");return parseFloat(toFixed$2(D,E))}var n1$3="number",n2$2="number, number";function bitAndNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function bitAnd");return D&E}bitAndNumber.signature=n2$2;function bitNotNumber(D){if(!isInteger(D))throw Error("Integer expected in function bitNot");return~D}bitNotNumber.signature=n1$3;function bitOrNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function bitOr");return D|E}bitOrNumber.signature=n2$2;function bitXorNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function bitXor");return D^E}bitXorNumber.signature=n2$2;function leftShiftNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function leftShift");return D<<E}leftShiftNumber.signature=n2$2;function rightArithShiftNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function rightArithShift");return D>>E}rightArithShiftNumber.signature=n2$2;function rightLogShiftNumber(D,E){if(!isInteger(D)||!isInteger(E))throw Error("Integers expected in function rightLogShift");return D>>>E}rightLogShiftNumber.signature=n2$2;function product(D,E){if(E<D)return 1;if(E===D)return E;var F=E+D>>1;return product(D,F)*product(F+1,E)}function combinationsNumber(D,E){if(!isInteger(D)||D<0||!isInteger(E)||E<0)throw TypeError("Positive integer value expected in function combinations");if(E>D)throw TypeError("k must be less than or equal to n");for(var F=D-E,J=1,$e=E<F?F+1:E+1,_t=2,lr=E<F?E:F,mr=$e;mr<=D;++mr)for(J*=mr;_t<=lr&&J%_t===0;)J/=_t,++_t;return _t<=lr&&(J/=product(_t,lr)),J}combinationsNumber.signature="number, number";var pi=Math.PI,tau=2*Math.PI,e=Math.E,phi=1.618033988749895,n1$2="number",n2$1="number, number";function notNumber(D){return!D}notNumber.signature=n1$2;function orNumber(D,E){return!!(D||E)}orNumber.signature=n2$1;function xorNumber(D,E){return!!D!=!!E}xorNumber.signature=n2$1;function andNumber(D,E){return!!(D&&E)}andNumber.signature=n2$1;function gammaNumber(D){var E;if(isInteger(D))return D<=0?Number.isFinite(D)?1/0:NaN:D>171?1/0:product(1,D-1);if(D<.5)return Math.PI/(Math.sin(Math.PI*D)*gammaNumber(1-D));if(D>=171.35)return 1/0;if(D>85){var F=D*D,J=F*D,$e=J*D,_t=$e*D;return Math.sqrt(2*Math.PI/D)*(D/Math.E)**+D*(1+1/(12*D)+1/(288*F)-139/(51840*J)-571/(2488320*$e)+163879/(209018880*_t)+5246819/(75246796800*_t*D))}--D,E=gammaP[0];for(var lr=1;lr<gammaP.length;++lr)E+=gammaP[lr]/(D+lr);var mr=D+gammaG+.5;return Math.sqrt(2*Math.PI)*mr**+(D+.5)*Math.exp(-mr)*E}gammaNumber.signature="number";var gammaG=4.7421875,gammaP=[.9999999999999971,57.15623566586292,-59.59796035547549,14.136097974741746,-.4919138160976202,3399464998481189e-20,4652362892704858e-20,-9837447530487956e-20,.0001580887032249125,-.00021026444172410488,.00021743961811521265,-.0001643181065367639,8441822398385275e-20,-26190838401581408e-21,36899182659531625e-22],lnSqrt2PI=.9189385332046728,lgammaSeries=[1.000000000190015,76.18009172947146,-86.50532032941678,24.01409824083091,-1.231739572450155,.001208650973866179,-5395239384953e-18];function lgammaNumber(D){if(D<0)return NaN;if(D===0)return 1/0;if(!Number.isFinite(D))return D;if(D<.5)return Math.log(Math.PI/Math.sin(Math.PI*D))-lgammaNumber(1-D);--D;for(var E=D+5+.5,F=lgammaSeries[0],J=6;J>=1;J--)F+=lgammaSeries[J]/(D+J);return lnSqrt2PI+(D+.5)*Math.log(E)-E+Math.log(F)}lgammaNumber.signature="number";var n1$1="number";function acoshNumber(D){return acosh$2(D)}acoshNumber.signature=n1$1;function acotNumber(D){return Math.atan(1/D)}acotNumber.signature=n1$1;function acothNumber(D){return Number.isFinite(D)?(Math.log((D+1)/D)+Math.log(D/(D-1)))/2:0}acothNumber.signature=n1$1;function acscNumber(D){return Math.asin(1/D)}acscNumber.signature=n1$1;function acschNumber(D){var E=1/D;return Math.log(E+Math.sqrt(E*E+1))}acschNumber.signature=n1$1;function asecNumber(D){return Math.acos(1/D)}asecNumber.signature=n1$1;function asechNumber(D){var E=1/D,F=Math.sqrt(E*E-1);return Math.log(F+E)}asechNumber.signature=n1$1;function asinhNumber(D){return asinh$2(D)}asinhNumber.signature=n1$1;function atanhNumber(D){return atanh$2(D)}atanhNumber.signature=n1$1;function cotNumber(D){return 1/Math.tan(D)}cotNumber.signature=n1$1;function cothNumber(D){var E=Math.exp(2*D);return(E+1)/(E-1)}cothNumber.signature=n1$1;function cscNumber(D){return 1/Math.sin(D)}cscNumber.signature=n1$1;function cschNumber(D){return D===0?1/0:Math.abs(2/(Math.exp(D)-Math.exp(-D)))*sign$2(D)}cschNumber.signature=n1$1;function secNumber(D){return 1/Math.cos(D)}secNumber.signature=n1$1;function sechNumber(D){return 2/(Math.exp(D)+Math.exp(-D))}sechNumber.signature=n1$1;function sinhNumber(D){return sinh$3(D)}sinhNumber.signature=n1$1;var n1="number";function isNegativeNumber(D){return D<0}isNegativeNumber.signature=n1;function isPositiveNumber(D){return D>0}isPositiveNumber.signature=n1;function isNaNNumber(D){return Number.isNaN(D)}isNaNNumber.signature=n1;function nearlyEqual(D,E){var F=arguments.length>2&&arguments[2]!==void 0?arguments[2]:1e-9,J=arguments.length>3&&arguments[3]!==void 0?arguments[3]:0;if(F<=0)throw Error("Relative tolerance must be greater than 0");if(J<0)throw Error("Absolute tolerance must be at least 0");return D.isNaN()||E.isNaN()?!1:!D.isFinite()||!E.isFinite()?D.eq(E):D.eq(E)?!0:D.minus(E).abs().lte(D.constructor.max(D.constructor.max(D.abs(),E.abs()).mul(F),J))}var name$312="isNegative",dependencies$312=["typed","config"],createIsNegative=factory(name$312,dependencies$312,D=>{var{typed:E,config:F}=D;return E(name$312,{number:J=>nearlyEqual$1(J,0,F.relTol,F.absTol)?!1:isNegativeNumber(J),BigNumber:J=>nearlyEqual(J,new J.constructor(0),F.relTol,F.absTol)?!1:J.isNeg()&&!J.isZero()&&!J.isNaN(),bigint:J=>J<0n,Fraction:J=>J.s<0n,Unit:E.referToSelf(J=>$e=>E.find(J,$e.valueType())($e.value)),"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$311="isNumeric",dependencies$311=["typed"],createIsNumeric=factory(name$311,dependencies$311,D=>{var{typed:E}=D;return E(name$311,{"number | BigNumber | bigint | Fraction | boolean":()=>!0,"Complex | Unit | string | null | undefined | Node":()=>!1,"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$310="hasNumericValue",dependencies$310=["typed","isNumeric"],createHasNumericValue=factory(name$310,dependencies$310,D=>{var{typed:E,isNumeric:F}=D;return E(name$310,{boolean:()=>!0,string:function(J){return J.trim().length>0&&!isNaN(Number(J))},any:function(J){return F(J)}})}),name$309="isPositive",dependencies$309=["typed","config"],createIsPositive=factory(name$309,dependencies$309,D=>{var{typed:E,config:F}=D;return E(name$309,{number:J=>nearlyEqual$1(J,0,F.relTol,F.absTol)?!1:isPositiveNumber(J),BigNumber:J=>nearlyEqual(J,new J.constructor(0),F.relTol,F.absTol)?!1:!J.isNeg()&&!J.isZero()&&!J.isNaN(),bigint:J=>J>0n,Fraction:J=>J.s>0n&&J.n>0n,Unit:E.referToSelf(J=>$e=>E.find(J,$e.valueType())($e.value)),"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$308="isZero",dependencies$308=["typed","equalScalar"],createIsZero=factory(name$308,dependencies$308,D=>{var{typed:E,equalScalar:F}=D;return E(name$308,{"number | BigNumber | Complex | Fraction":J=>F(J,0),bigint:J=>J===0n,Unit:E.referToSelf(J=>$e=>E.find(J,$e.valueType())($e.value)),"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$307="isNaN",dependencies$307=["typed"],createIsNaN=factory(name$307,dependencies$307,D=>{var{typed:E}=D;return E(name$307,{number:isNaNNumber,BigNumber:function(F){return F.isNaN()},bigint:function(F){return!1},Fraction:function(F){return!1},Complex:function(F){return F.isNaN()},Unit:function(F){return Number.isNaN(F.value)},"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$306="isBounded",dependencies$306=["typed"],createIsBounded=factory(name$306,dependencies$306,D=>{var{typed:E}=D;return E(name$306,{number:F=>Number.isFinite(F),"BigNumber | Complex":F=>F.isFinite(),"bigint | Fraction":()=>!0,"null | undefined":()=>!1,Unit:E.referToSelf(F=>J=>F(J.value)),"Array | Matrix":E.referToSelf(F=>J=>(Array.isArray(J)||(J=J.valueOf()),J.every($e=>F($e))))})}),name$305="isFinite",dependencies$305=["typed","isBounded","map"],createIsFinite=factory(name$305,dependencies$305,D=>{var{typed:E,isBounded:F,map:J}=D;return E(name$305,{"Array | Matrix":$e=>J($e,F),any:$e=>F($e)})}),name$304="typeOf",dependencies$304=["typed"],createTypeOf=factory(name$304,dependencies$304,D=>{var{typed:E}=D;return E(name$304,{any:typeOf})});function complexEquals(D,E,F,J){return nearlyEqual$1(D.re,E.re,F,J)&&nearlyEqual$1(D.im,E.im,F,J)}var createCompareUnits=factory("compareUnits",["typed"],D=>{var{typed:E}=D;return{"Unit, Unit":E.referToSelf(F=>(J,$e)=>{if(!J.equalBase($e))throw Error("Cannot compare units with different base");return E.find(F,[J.valueType(),$e.valueType()])(J.value,$e.value)})}}),name$303="equalScalar",dependencies$303=["typed","config"],createEqualScalar=factory(name$303,dependencies$303,D=>{var{typed:E,config:F}=D;return E(name$303,{"boolean, boolean":function(J,$e){return J===$e},"number, number":function(J,$e){return nearlyEqual$1(J,$e,F.relTol,F.absTol)},"BigNumber, BigNumber":function(J,$e){return J.eq($e)||nearlyEqual(J,$e,F.relTol,F.absTol)},"bigint, bigint":function(J,$e){return J===$e},"Fraction, Fraction":function(J,$e){return J.equals($e)},"Complex, Complex":function(J,$e){return complexEquals(J,$e,F.relTol,F.absTol)}},createCompareUnits({typed:E}))});factory(name$303,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$303,{"number, number":function(J,$e){return nearlyEqual$1(J,$e,F.relTol,F.absTol)}})});var name$302="SparseMatrix",dependencies$302=["typed","equalScalar","Matrix"],createSparseMatrixClass=factory(name$302,dependencies$302,D=>{var{typed:E,equalScalar:F,Matrix:J}=D;function $e(Qi,Gi){if(!(this instanceof $e))throw SyntaxError("Constructor must be called with the new operator");if(Gi&&!isString(Gi))throw Error("Invalid datatype: "+Gi);if(isMatrix(Qi))_t(this,Qi,Gi);else if(Qi&&isArray(Qi.index)&&isArray(Qi.ptr)&&isArray(Qi.size))this._values=Qi.values,this._index=Qi.index,this._ptr=Qi.ptr,this._size=Qi.size,this._datatype=Gi||Qi.datatype;else if(isArray(Qi))lr(this,Qi,Gi);else{if(Qi)throw TypeError("Unsupported type of data ("+typeOf(Qi)+")");this._values=[],this._index=[],this._ptr=[0],this._size=[0,0],this._datatype=Gi}}function _t(Qi,Gi,Zi){Gi.type==="SparseMatrix"?(Qi._values=Gi._values?clone$3(Gi._values):void 0,Qi._index=clone$3(Gi._index),Qi._ptr=clone$3(Gi._ptr),Qi._size=clone$3(Gi._size),Qi._datatype=Zi||Gi._datatype):lr(Qi,Gi.valueOf(),Zi||Gi._datatype)}function lr(Qi,Gi,Zi){Qi._values=[],Qi._index=[],Qi._ptr=[],Qi._datatype=Zi;var Xi=Gi.length,Ki=0,ea=F,Ji=0;if(isString(Zi)&&(ea=E.find(F,[Zi,Zi])||F,Ji=E.convert(0,Zi)),Xi>0){var ta=0;do{Qi._ptr.push(Qi._index.length);for(var na=0;na<Xi;na++){var ra=Gi[na];if(isArray(ra)){if(ta===0&&Ki<ra.length&&(Ki=ra.length),ta<ra.length){var ia=ra[ta];ea(ia,Ji)||(Qi._values.push(ia),Qi._index.push(na))}}else ta===0&&Ki<1&&(Ki=1),ea(ra,Ji)||(Qi._values.push(ra),Qi._index.push(na))}ta++}while(ta<Ki)}for(;Qi._ptr.length<=Ki;)Qi._ptr.push(Qi._index.length);Qi._size=[Xi,Ki]}$e.prototype=new J,$e.prototype.createSparseMatrix=function(Qi,Gi){return new $e(Qi,Gi)},Object.defineProperty($e,"name",{value:"SparseMatrix"}),$e.prototype.constructor=$e,$e.prototype.type="SparseMatrix",$e.prototype.isSparseMatrix=!0,$e.prototype.getDataType=function(){return getArrayDataType(this._values,typeOf)},$e.prototype.storage=function(){return"sparse"},$e.prototype.datatype=function(){return this._datatype},$e.prototype.create=function(Qi,Gi){return new $e(Qi,Gi)},$e.prototype.density=function(){var Qi=this._size[0],Gi=this._size[1];return Qi!==0&&Gi!==0?this._index.length/(Qi*Gi):0},$e.prototype.subset=function(Qi,Gi,Zi){if(!this._values)throw Error("Cannot invoke subset on a Pattern only matrix");switch(arguments.length){case 1:return mr(this,Qi);case 2:case 3:return Or(this,Qi,Gi,Zi);default:throw SyntaxError("Wrong number of arguments")}};function mr(Qi,Gi){if(!isIndex(Gi))throw TypeError("Invalid index");if(Gi.isScalar())return Qi.get(Gi.min());var Zi=Gi.size();if(Zi.length!==Qi._size.length)throw new DimensionError(Zi.length,Qi._size.length);var Xi,Ki,ea,Ji,ta=Gi.min(),na=Gi.max();for(Xi=0,Ki=Qi._size.length;Xi<Ki;Xi++)validateIndex(ta[Xi],Qi._size[Xi]),validateIndex(na[Xi],Qi._size[Xi]);var ra=Qi._values,ia=Qi._index,oa=Qi._ptr,ua=Gi.dimension(0),sa=Gi.dimension(1),aa=[],pa=[];function ma(Fa,$a){pa[Fa]=$a[0],aa[Fa]=!0}Number.isInteger(ua)?ma(ua,[0]):ua.forEach(ma);var la=ra?[]:void 0,ha=[],ga=[];function Aa(Fa){for(ga.push(ha.length),ea=oa[Fa],Ji=oa[Fa+1];ea<Ji;ea++)Xi=ia[ea],aa[Xi]===!0&&(ha.push(pa[Xi]),la&&la.push(ra[ea]))}return Number.isInteger(sa)?Aa(sa):sa.forEach(Aa),ga.push(ha.length),new $e({values:la,index:ha,ptr:ga,size:Zi,datatype:Qi._datatype})}function Or(Qi,Gi,Zi,Xi){if(!Gi||Gi.isIndex!==!0)throw TypeError("Invalid index");var Ki=Gi.size(),ea=Gi.isScalar(),Ji;if(isMatrix(Zi)?(Ji=Zi.size(),Zi=Zi.toArray()):Ji=arraySize(Zi),ea){if(Ji.length!==0)throw TypeError("Scalar expected");Qi.set(Gi.min(),Zi,Xi)}else{if(Ki.length!==1&&Ki.length!==2)throw new DimensionError(Ki.length,Qi._size.length,"<");if(Ji.length<Ki.length){for(var ta=0,na=0;Ki[ta]===1&&Ji[ta]===1;)ta++;for(;Ki[ta]===1;)na++,ta++;Zi=unsqueeze(Zi,Ki.length,na,Ji)}if(!deepStrictEqual(Ki,Ji))throw new DimensionError(Ki,Ji,">");if(Ki.length===1)oa(Gi.dimension(0),(ua,sa)=>{validateIndex(ua),Qi.set([ua,0],Zi[sa[0]],Xi)});else{var ra=Gi.dimension(0),ia=Gi.dimension(1);oa(ra,(ua,sa)=>{validateIndex(ua),oa(ia,(aa,pa)=>{validateIndex(aa),Qi.set([ua,aa],Zi[sa[0]][pa[0]],Xi)})})}}return Qi;function oa(ua,sa){isNumber(ua)?sa(ua,[0]):ua.forEach(sa)}}$e.prototype.get=function(Qi){if(!isArray(Qi))throw TypeError("Array expected");if(Qi.length!==this._size.length)throw new DimensionError(Qi.length,this._size.length);if(!this._values)throw Error("Cannot invoke get on a Pattern only matrix");var Gi=Qi[0],Zi=Qi[1];validateIndex(Gi,this._size[0]),validateIndex(Zi,this._size[1]);var Xi=Pr(Gi,this._ptr[Zi],this._ptr[Zi+1],this._index);return Xi<this._ptr[Zi+1]&&this._index[Xi]===Gi?this._values[Xi]:0},$e.prototype.set=function(Qi,Gi,Zi){if(!isArray(Qi))throw TypeError("Array expected");if(Qi.length!==this._size.length)throw new DimensionError(Qi.length,this._size.length);if(!this._values)throw Error("Cannot invoke set on a Pattern only matrix");var Xi=Qi[0],Ki=Qi[1],ea=this._size[0],Ji=this._size[1],ta=F,na=0;isString(this._datatype)&&(ta=E.find(F,[this._datatype,this._datatype])||F,na=E.convert(0,this._datatype)),(Xi>ea-1||Ki>Ji-1)&&(qi(this,Math.max(Xi+1,ea),Math.max(Ki+1,Ji),Zi),ea=this._size[0],Ji=this._size[1]),validateIndex(Xi,ea),validateIndex(Ki,Ji);var ra=Pr(Xi,this._ptr[Ki],this._ptr[Ki+1],this._index);return ra<this._ptr[Ki+1]&&this._index[ra]===Xi?ta(Gi,na)?dn(ra,Ki,this._values,this._index,this._ptr):this._values[ra]=Gi:ta(Gi,na)||gi(ra,Xi,Ki,Gi,this._values,this._index,this._ptr),this};function Pr(Qi,Gi,Zi,Xi){if(Zi-Gi===0)return Zi;for(var Ki=Gi;Ki<Zi;Ki++)if(Xi[Ki]===Qi)return Ki;return Gi}function dn(Qi,Gi,Zi,Xi,Ki){Zi.splice(Qi,1),Xi.splice(Qi,1);for(var ea=Gi+1;ea<Ki.length;ea++)Ki[ea]--}function gi(Qi,Gi,Zi,Xi,Ki,ea,Ji){Ki.splice(Qi,0,Xi),ea.splice(Qi,0,Gi);for(var ta=Zi+1;ta<Ji.length;ta++)Ji[ta]++}$e.prototype.resize=function(Qi,Gi,Zi){if(!isCollection(Qi))throw TypeError("Array or Matrix expected");var Xi=Qi.valueOf().map(Ki=>Array.isArray(Ki)&&Ki.length===1?Ki[0]:Ki);if(Xi.length!==2)throw Error("Only two dimensions matrix are supported");return Xi.forEach(function(Ki){if(!isNumber(Ki)||!isInteger(Ki)||Ki<0)throw TypeError("Invalid size, must contain positive integers (size: "+format(Xi)+")")}),qi(Zi?this.clone():this,Xi[0],Xi[1],Gi)};function qi(Qi,Gi,Zi,Xi){var Ki=Xi||0,ea=F,Ji=0;isString(Qi._datatype)&&(ea=E.find(F,[Qi._datatype,Qi._datatype])||F,Ji=E.convert(0,Qi._datatype),Ki=E.convert(Ki,Qi._datatype));var ta=!ea(Ki,Ji),na=Qi._size[0],ra=Qi._size[1],ia,oa,ua;if(Zi>ra){for(oa=ra;oa<Zi;oa++)if(Qi._ptr[oa]=Qi._values.length,ta)for(ia=0;ia<na;ia++)Qi._values.push(Ki),Qi._index.push(ia);Qi._ptr[Zi]=Qi._values.length}else Zi<ra&&(Qi._ptr.splice(Zi+1,ra-Zi),Qi._values.splice(Qi._ptr[Zi],Qi._values.length),Qi._index.splice(Qi._ptr[Zi],Qi._index.length));if(ra=Zi,Gi>na){if(ta){var sa=0;for(oa=0;oa<ra;oa++){Qi._ptr[oa]=Qi._ptr[oa]+sa,ua=Qi._ptr[oa+1]+sa;var aa=0;for(ia=na;ia<Gi;ia++,aa++)Qi._values.splice(ua+aa,0,Ki),Qi._index.splice(ua+aa,0,ia),sa++}Qi._ptr[ra]=Qi._values.length}}else if(Gi<na){var pa=0;for(oa=0;oa<ra;oa++){Qi._ptr[oa]=Qi._ptr[oa]-pa;var ma=Qi._ptr[oa],la=Qi._ptr[oa+1]-pa;for(ua=ma;ua<la;ua++)ia=Qi._index[ua],ia>Gi-1&&(Qi._values.splice(ua,1),Qi._index.splice(ua,1),pa++)}Qi._ptr[oa]=Qi._values.length}return Qi._size[0]=Gi,Qi._size[1]=Zi,Qi}$e.prototype.reshape=function(Qi,Gi){if(!isArray(Qi))throw TypeError("Array expected");if(Qi.length!==2)throw Error("Sparse matrices can only be reshaped in two dimensions");Qi.forEach(function(ha){if(!isNumber(ha)||!isInteger(ha)||ha<=-2||ha===0)throw TypeError("Invalid size, must contain positive integers or -1 (size: "+format(Qi)+")")});var Zi=this._size[0]*this._size[1];if(Qi=processSizesWildcard(Qi,Zi),Zi!==Qi[0]*Qi[1])throw Error("Reshaping sparse matrix will result in the wrong number of elements");var Xi=Gi?this.clone():this;if(this._size[0]===Qi[0]&&this._size[1]===Qi[1])return Xi;for(var Ki=[],ea=0;ea<Xi._ptr.length;ea++)for(var Ji=0;Ji<Xi._ptr[ea+1]-Xi._ptr[ea];Ji++)Ki.push(ea);for(var ta=Xi._values.slice(),na=Xi._index.slice(),ra=0;ra<Xi._index.length;ra++){var ia=na[ra],oa=Ki[ra],ua=ia*Xi._size[1]+oa;Ki[ra]=ua%Qi[1],na[ra]=Math.floor(ua/Qi[1])}Xi._values.length=0,Xi._index.length=0,Xi._ptr.length=Qi[1]+1,Xi._size=Qi.slice();for(var sa=0;sa<Xi._ptr.length;sa++)Xi._ptr[sa]=0;for(var aa=0;aa<ta.length;aa++){var pa=na[aa],ma=Ki[aa],la=ta[aa];gi(Pr(pa,Xi._ptr[ma],Xi._ptr[ma+1],Xi._index),pa,ma,la,Xi._values,Xi._index,Xi._ptr)}return Xi},$e.prototype.clone=function(){return new $e({values:this._values?clone$3(this._values):void 0,index:clone$3(this._index),ptr:clone$3(this._ptr),size:clone$3(this._size),datatype:this._datatype})},$e.prototype.size=function(){return this._size.slice(0)},$e.prototype.map=function(Qi,Gi){if(!this._values)throw Error("Cannot invoke map on a Pattern only matrix");var Zi=this,Xi=this._size[0],Ki=this._size[1],ea=optimizeCallback(Qi,Zi,"map");return zi(this,0,Xi-1,0,Ki-1,function(Ji,ta,na){return ea.fn(Ji,[ta,na],Zi)},Gi)};function zi(Qi,Gi,Zi,Xi,Ki,ea,Ji){var ta=[],na=[],ra=[],ia=F,oa=0;isString(Qi._datatype)&&(ia=E.find(F,[Qi._datatype,Qi._datatype])||F,oa=E.convert(0,Qi._datatype));for(var ua=function($a,_a,fa){var ka=ea($a,_a,fa);ia(ka,oa)||(ta.push(ka),na.push(_a))},sa=Xi;sa<=Ki;sa++){ra.push(ta.length);var aa=Qi._ptr[sa],pa=Qi._ptr[sa+1];if(Ji)for(var ma=aa;ma<pa;ma++){var la=Qi._index[ma];la>=Gi&&la<=Zi&&ua(Qi._values[ma],la-Gi,sa-Xi)}else{for(var ha={},ga=aa;ga<pa;ga++){var Aa=Qi._index[ga];ha[Aa]=Qi._values[ga]}for(var Fa=Gi;Fa<=Zi;Fa++)ua(Fa in ha?ha[Fa]:0,Fa-Gi,sa-Xi)}}return ra.push(ta.length),new $e({values:ta,index:na,ptr:ra,size:[Zi-Gi+1,Ki-Xi+1]})}$e.prototype.forEach=function(Qi,Gi){if(!this._values)throw Error("Cannot invoke forEach on a Pattern only matrix");for(var Zi=this,Xi=this._size[0],Ki=this._size[1],ea=optimizeCallback(Qi,Zi,"forEach"),Ji=0;Ji<Ki;Ji++){var ta=this._ptr[Ji],na=this._ptr[Ji+1];if(Gi)for(var ra=ta;ra<na;ra++){var ia=this._index[ra];ea.fn(this._values[ra],[ia,Ji],Zi)}else{for(var oa={},ua=ta;ua<na;ua++){var sa=this._index[ua];oa[sa]=this._values[ua]}for(var aa=0;aa<Xi;aa++){var pa=aa in oa?oa[aa]:0;ea.fn(pa,[aa,Ji],Zi)}}}},$e.prototype[Symbol.iterator]=function*(){if(!this._values)throw Error("Cannot iterate a Pattern only matrix");for(var Qi=this._size[1],Gi=0;Gi<Qi;Gi++)for(var Zi=this._ptr[Gi],Xi=this._ptr[Gi+1],Ki=Zi;Ki<Xi;Ki++){var ea=this._index[Ki];yield{value:this._values[Ki],index:[ea,Gi]}}},$e.prototype.toArray=function(){return Hi(this._values,this._index,this._ptr,this._size,!0)},$e.prototype.valueOf=function(){return Hi(this._values,this._index,this._ptr,this._size,!1)};function Hi(Qi,Gi,Zi,Xi,Ki){var ea=Xi[0],Ji=Xi[1],ta=[],na,ra;for(na=0;na<ea;na++)for(ta[na]=[],ra=0;ra<Ji;ra++)ta[na][ra]=0;for(ra=0;ra<Ji;ra++)for(var ia=Zi[ra],oa=Zi[ra+1],ua=ia;ua<oa;ua++)na=Gi[ua],ta[na][ra]=Qi?Ki?clone$3(Qi[ua]):Qi[ua]:1;return ta}return $e.prototype.format=function(Qi){for(var Gi=this._size[0],Zi=this._size[1],Xi=this.density(),Ki="Sparse Matrix ["+format(Gi,Qi)+" x "+format(Zi,Qi)+"] density: "+format(Xi,Qi)+`\n`,ea=0;ea<Zi;ea++)for(var Ji=this._ptr[ea],ta=this._ptr[ea+1],na=Ji;na<ta;na++){var ra=this._index[na];Ki+=`\n    (`+format(ra,Qi)+", "+format(ea,Qi)+") ==> "+(this._values?format(this._values[na],Qi):"X")}return Ki},$e.prototype.toString=function(){return format(this.toArray())},$e.prototype.toJSON=function(){return{mathjs:"SparseMatrix",values:this._values,index:this._index,ptr:this._ptr,size:this._size,datatype:this._datatype}},$e.prototype.diagonal=function(Qi){if(Qi){if(isBigNumber(Qi)&&(Qi=Qi.toNumber()),!isNumber(Qi)||!isInteger(Qi))throw TypeError("The parameter k must be an integer number")}else Qi=0;var Gi=Qi>0?Qi:0,Zi=Qi<0?-Qi:0,Xi=this._size[0],Ki=this._size[1],ea=Math.min(Xi-Zi,Ki-Gi),Ji=[],ta=[],na=[];na[0]=0;for(var ra=Gi;ra<Ki&&Ji.length<ea;ra++)for(var ia=this._ptr[ra],oa=this._ptr[ra+1],ua=ia;ua<oa;ua++){var sa=this._index[ua];if(sa===ra-Gi+Zi){Ji.push(this._values[ua]),ta[Ji.length-1]=sa-Zi;break}}return na.push(Ji.length),new $e({values:Ji,index:ta,ptr:na,size:[ea,1]})},$e.fromJSON=function(Qi){return new $e(Qi)},$e.diagonal=function(Qi,Gi,Zi,Xi,Ki){if(!isArray(Qi))throw TypeError("Array expected, size parameter");if(Qi.length!==2)throw Error("Only two dimensions matrix are supported");if(Qi=Qi.map(function(Aa){if(isBigNumber(Aa)&&(Aa=Aa.toNumber()),!isNumber(Aa)||!isInteger(Aa)||Aa<1)throw Error("Size values must be positive integers");return Aa}),Zi){if(isBigNumber(Zi)&&(Zi=Zi.toNumber()),!isNumber(Zi)||!isInteger(Zi))throw TypeError("The parameter k must be an integer number")}else Zi=0;var ea=F,Ji=0;isString(Ki)&&(ea=E.find(F,[Ki,Ki])||F,Ji=E.convert(0,Ki));var ta=Zi>0?Zi:0,na=Zi<0?-Zi:0,ra=Qi[0],ia=Qi[1],oa=Math.min(ra-na,ia-ta),ua;if(isArray(Gi)){if(Gi.length!==oa)throw Error("Invalid value array length");ua=function(Aa){return Gi[Aa]}}else if(isMatrix(Gi)){var sa=Gi.size();if(sa.length!==1||sa[0]!==oa)throw Error("Invalid matrix length");ua=function(Aa){return Gi.get([Aa])}}else ua=function(){return Gi};for(var aa=[],pa=[],ma=[],la=0;la<ia;la++){ma.push(aa.length);var ha=la-ta;if(ha>=0&&ha<oa){var ga=ua(ha);ea(ga,Ji)||(pa.push(ha+na),aa.push(ga))}}return ma.push(aa.length),new $e({values:aa,index:pa,ptr:ma,size:[ra,ia]})},$e.prototype.swapRows=function(Qi,Gi){if(!isNumber(Qi)||!isInteger(Qi)||!isNumber(Gi)||!isInteger(Gi))throw Error("Row index must be positive integers");if(this._size.length!==2)throw Error("Only two dimensional matrix is supported");return validateIndex(Qi,this._size[0]),validateIndex(Gi,this._size[0]),$e._swapRows(Qi,Gi,this._size[1],this._values,this._index,this._ptr),this},$e._forEachRow=function(Qi,Gi,Zi,Xi,Ki){for(var ea=Xi[Qi],Ji=Xi[Qi+1],ta=ea;ta<Ji;ta++)Ki(Zi[ta],Gi[ta])},$e._swapRows=function(Qi,Gi,Zi,Xi,Ki,ea){for(var Ji=0;Ji<Zi;Ji++){var ta=ea[Ji],na=ea[Ji+1],ra=Pr(Qi,ta,na,Ki),ia=Pr(Gi,ta,na,Ki);if(ra<na&&ia<na&&Ki[ra]===Qi&&Ki[ia]===Gi){if(Xi){var oa=Xi[ra];Xi[ra]=Xi[ia],Xi[ia]=oa}continue}if(ra<na&&Ki[ra]===Qi&&(ia>=na||Ki[ia]!==Gi)){var ua=Xi?Xi[ra]:void 0;Ki.splice(ia,0,Gi),Xi&&Xi.splice(ia,0,ua),Ki.splice(ia<=ra?ra+1:ra,1),Xi&&Xi.splice(ia<=ra?ra+1:ra,1);continue}if(ia<na&&Ki[ia]===Gi&&(ra>=na||Ki[ra]!==Qi)){var sa=Xi?Xi[ia]:void 0;Ki.splice(ra,0,Qi),Xi&&Xi.splice(ra,0,sa),Ki.splice(ra<=ia?ia+1:ia,1),Xi&&Xi.splice(ra<=ia?ia+1:ia,1)}}},$e},{isClass:!0}),name$301="number",dependencies$301=["typed"];function getNonDecimalNumberParts(D){var E=D.match(/(0[box])([0-9a-fA-F]*)\\.([0-9a-fA-F]*)/);return E?{input:D,radix:{"0b":2,"0o":8,"0x":16}[E[1]],integerPart:E[2],fractionalPart:E[3]}:null}function makeNumberFromNonDecimalParts(D){for(var E=parseInt(D.integerPart,D.radix),F=0,J=0;J<D.fractionalPart.length;J++){var $e=parseInt(D.fractionalPart[J],D.radix);F+=$e/D.radix**+(J+1)}var _t=E+F;if(isNaN(_t))throw SyntaxError(\'String "\'+D.input+\'" is not a valid number\');return _t}var createNumber=factory(name$301,dependencies$301,D=>{var{typed:E}=D,F=E("number",{"":function(){return 0},number:function(J){return J},string:function(J){if(J==="NaN")return NaN;var $e=getNonDecimalNumberParts(J);if($e)return makeNumberFromNonDecimalParts($e);var _t=0,lr=J.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);lr&&(_t=Number(lr[2]),J=lr[1]);var mr=Number(J);if(isNaN(mr))throw SyntaxError(\'String "\'+J+\'" is not a valid number\');if(lr){if(mr>2**_t-1)throw SyntaxError(`String "${J}" is out of range`);mr>=2**(_t-1)&&(mr-=2**_t)}return mr},BigNumber:function(J){return J.toNumber()},bigint:function(J){return Number(J)},Fraction:function(J){return J.valueOf()},Unit:E.referToSelf(J=>$e=>{var _t=$e.clone();return _t.value=J($e.value),_t}),null:function(J){return 0},"Unit, string | Unit":function(J,$e){return J.toNumber($e)},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))});return F.fromJSON=function(J){return parseFloat(J.value)},F}),name$300="bigint",dependencies$300=["typed"],createBigint=factory(name$300,dependencies$300,D=>{var{typed:E}=D,F=E("bigint",{"":function(){return 0n},bigint:function(J){return J},number:function(J){return BigInt(J.toFixed())},BigNumber:function(J){return BigInt(J.round().toString())},Fraction:function(J){return BigInt(J.valueOf().toFixed())},"string | boolean":function(J){return BigInt(J)},null:function(J){return 0n},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))});return F.fromJSON=function(J){return BigInt(J.value)},F}),name$299="string",dependencies$299=["typed"],createString=factory(name$299,dependencies$299,D=>{var{typed:E}=D;return E(name$299,{"":function(){return""},number:format$2,null:function(F){return"null"},boolean:function(F){return F+""},string:function(F){return F},"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F)),any:function(F){return String(F)}})}),name$298="boolean",dependencies$298=["typed"],createBoolean=factory(name$298,dependencies$298,D=>{var{typed:E}=D;return E(name$298,{"":function(){return!1},boolean:function(F){return F},number:function(F){return!!F},null:function(F){return!1},BigNumber:function(F){return!F.isZero()},string:function(F){var J=F.toLowerCase();if(J==="true")return!0;if(J==="false")return!1;var $e=Number(F);if(F!==""&&!isNaN($e))return!!$e;throw Error(\'Cannot convert "\'+F+\'" to a boolean\')},"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$297="bignumber",dependencies$297=["typed","BigNumber"],createBignumber=factory(name$297,dependencies$297,D=>{var{typed:E,BigNumber:F}=D;return E("bignumber",{"":function(){return new F(0)},number:function(J){return new F(J+"")},string:function(J){var $e=J.match(/(0[box][0-9a-fA-F]*)i([0-9]*)/);if($e){var _t=$e[2],lr=F($e[1]),mr=new F(2).pow(Number(_t));if(lr.gt(mr.sub(1)))throw SyntaxError(`String "${J}" is out of range`);var Or=new F(2).pow(Number(_t)-1);return lr.gte(Or)?lr.sub(mr):lr}return new F(J)},BigNumber:function(J){return J},bigint:function(J){return new F(J.toString())},Unit:E.referToSelf(J=>$e=>{var _t=$e.clone();return _t.value=J($e.value),_t}),Fraction:function(J){return new F(String(J.n)).div(String(J.d)).times(String(J.s))},null:function(J){return new F(0)},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$296="complex",dependencies$296=["typed","Complex"],createComplex=factory(name$296,dependencies$296,D=>{var{typed:E,Complex:F}=D;return E("complex",{"":function(){return F.ZERO},number:function(J){return new F(J,0)},"number, number":function(J,$e){return new F(J,$e)},"BigNumber, BigNumber":function(J,$e){return new F(J.toNumber(),$e.toNumber())},Fraction:function(J){return new F(J.valueOf(),0)},Complex:function(J){return J.clone()},string:function(J){return F(J)},null:function(J){return F(0)},Object:function(J){if("re"in J&&"im"in J)return new F(J.re,J.im);if("r"in J&&"phi"in J||"abs"in J&&"arg"in J)return new F(J);throw Error("Expected object with properties (re and im) or (r and phi) or (abs and arg)")},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$295="fraction",dependencies$295=["typed","Fraction"],createFraction=factory(name$295,dependencies$295,D=>{var{typed:E,Fraction:F}=D;return E("fraction",{number:function(J){if(!Number.isFinite(J)||isNaN(J))throw Error(J+" cannot be represented as a fraction");return new F(J)},string:function(J){return new F(J)},"number, number":function(J,$e){return new F(J,$e)},"bigint, bigint":function(J,$e){return new F(J,$e)},null:function(J){return new F(0)},BigNumber:function(J){return new F(J.toString())},bigint:function(J){return new F(J.toString())},Fraction:function(J){return J},Unit:E.referToSelf(J=>$e=>{var _t=$e.clone();return _t.value=J($e.value),_t}),Object:function(J){return new F(J)},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$294="matrix",dependencies$294=["typed","Matrix","DenseMatrix","SparseMatrix"],createMatrix=factory(name$294,dependencies$294,D=>{var{typed:E,Matrix:F,DenseMatrix:J,SparseMatrix:$e}=D;return E(name$294,{"":function(){return _t([])},string:function(lr){return _t([],lr)},"string, string":function(lr,mr){return _t([],lr,mr)},Array:function(lr){return _t(lr)},Matrix:function(lr){return _t(lr,lr.storage())},"Array | Matrix, string":_t,"Array | Matrix, string, string":_t});function _t(lr,mr,Or){if(mr==="dense"||mr==="default"||mr===void 0)return new J(lr,Or);if(mr==="sparse")return new $e(lr,Or);throw TypeError("Unknown matrix type "+JSON.stringify(mr)+".")}}),name$293="matrixFromFunction",dependencies$293=["typed","matrix","isZero"],createMatrixFromFunction=factory(name$293,dependencies$293,D=>{var{typed:E,matrix:F,isZero:J}=D;return E(name$293,{"Array | Matrix, function, string, string":function(_t,lr,mr,Or){return $e(_t,lr,mr,Or)},"Array | Matrix, function, string":function(_t,lr,mr){return $e(_t,lr,mr)},"Matrix, function":function(_t,lr){return $e(_t,lr,"dense")},"Array, function":function(_t,lr){return $e(_t,lr,"dense").toArray()},"Array | Matrix, string, function":function(_t,lr,mr){return $e(_t,mr,lr)},"Array | Matrix, string, string, function":function(_t,lr,mr,Or){return $e(_t,Or,lr,mr)}});function $e(_t,lr,mr,Or){var Pr=Or===void 0?F(mr):F(mr,Or);return Pr.resize(_t),Pr.forEach(function(dn,gi){var qi=lr(gi);J(qi)||Pr.set(gi,qi)}),Pr}}),name$292="matrixFromRows",dependencies$292=["typed","matrix","flatten","size"],createMatrixFromRows=factory(name$292,dependencies$292,D=>{var{typed:E,matrix:F,flatten:J,size:$e}=D;return E(name$292,{"...Array":function(mr){return _t(mr)},"...Matrix":function(mr){return F(_t(mr.map(Or=>Or.toArray())))}});function _t(mr){if(mr.length===0)throw TypeError("At least one row is needed to construct a matrix.");var Or=lr(mr[0]),Pr=[];for(var dn of mr){var gi=lr(dn);if(gi!==Or)throw TypeError("The vectors had different length: "+(Or|0)+" ≠ "+(gi|0));Pr.push(J(dn))}return Pr}function lr(mr){var Or=$e(mr);if(Or.length===1)return Or[0];if(Or.length===2){if(Or[0]===1)return Or[1];if(Or[1]===1)return Or[0];throw TypeError("At least one of the arguments is not a vector.")}else throw TypeError("Only one- or two-dimensional vectors are supported.")}}),name$291="matrixFromColumns",dependencies$291=["typed","matrix","flatten","size"],createMatrixFromColumns=factory(name$291,dependencies$291,D=>{var{typed:E,matrix:F,flatten:J,size:$e}=D;return E(name$291,{"...Array":function(mr){return _t(mr)},"...Matrix":function(mr){return F(_t(mr.map(Or=>Or.toArray())))}});function _t(mr){if(mr.length===0)throw TypeError("At least one column is needed to construct a matrix.");for(var Or=lr(mr[0]),Pr=[],dn=0;dn<Or;dn++)Pr[dn]=[];for(var gi of mr){var qi=lr(gi);if(qi!==Or)throw TypeError("The vectors had different length: "+(Or|0)+" ≠ "+(qi|0));for(var zi=J(gi),Hi=0;Hi<Or;Hi++)Pr[Hi].push(zi[Hi])}return Pr}function lr(mr){var Or=$e(mr);if(Or.length===1)return Or[0];if(Or.length===2){if(Or[0]===1)return Or[1];if(Or[1]===1)return Or[0];throw TypeError("At least one of the arguments is not a vector.")}else throw TypeError("Only one- or two-dimensional vectors are supported.")}}),name$290="splitUnit",dependencies$290=["typed"],createSplitUnit=factory(name$290,dependencies$290,D=>{var{typed:E}=D;return E(name$290,{"Unit, Array":function(F,J){return F.splitUnit(J)}})}),name$289="unaryMinus",dependencies$289=["typed"],createUnaryMinus=factory(name$289,dependencies$289,D=>{var{typed:E}=D;return E(name$289,{number:unaryMinusNumber,"Complex | BigNumber | Fraction":F=>F.neg(),bigint:F=>-F,Unit:E.referToSelf(F=>J=>{var $e=J.clone();return $e.value=E.find(F,$e.valueType())(J.value),$e}),"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F,!0))})}),name$288="unaryPlus",dependencies$288=["typed","config","numeric"],createUnaryPlus=factory(name$288,dependencies$288,D=>{var{typed:E,config:F,numeric:J}=D;return E(name$288,{number:unaryPlusNumber,Complex:function($e){return $e},BigNumber:function($e){return $e},bigint:function($e){return $e},Fraction:function($e){return $e},Unit:function($e){return $e.clone()},"Array | Matrix":E.referToSelf($e=>_t=>deepMap(_t,$e,!0)),boolean:function($e){return J(+!!$e,F.number)},string:function($e){return J($e,safeNumberType($e,F))}})}),name$287="abs",dependencies$287=["typed"],createAbs=factory(name$287,dependencies$287,D=>{var{typed:E}=D;return E(name$287,{number:absNumber,"Complex | BigNumber | Fraction | Unit":F=>F.abs(),bigint:F=>F<0n?-F:F,"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F,!0))})}),name$286="mapSlices",dependencies$286=["typed","isInteger"],createMapSlices=factory(name$286,dependencies$286,D=>{var{typed:E,isInteger:F}=D;return E(name$286,{"Array | Matrix, number | BigNumber, function":function(J,$e,_t){if(!F($e))throw TypeError("Integer number expected for dimension");var lr=Array.isArray(J)?arraySize(J):J.size();if($e<0||$e>=lr.length)throw new IndexError($e,lr.length);return isMatrix(J)?J.create(_mapSlices(J.valueOf(),$e,_t),J.datatype()):_mapSlices(J,$e,_t)}})},{formerly:"apply"});function _mapSlices(D,E,F){var J,$e,_t;if(E<=0)if(Array.isArray(D[0])){for(_t=_switch(D),$e=[],J=0;J<_t.length;J++)$e[J]=_mapSlices(_t[J],E-1,F);return $e}else return F(D);else{for($e=[],J=0;J<D.length;J++)$e[J]=_mapSlices(D[J],E-1,F);return $e}}function _switch(D){var E=D.length,F=D[0].length,J,$e,_t=[];for($e=0;$e<F;$e++){var lr=[];for(J=0;J<E;J++)lr.push(D[J][$e]);_t.push(lr)}return _t}var name$285="addScalar",dependencies$285=["typed"],createAddScalar=factory(name$285,dependencies$285,D=>{var{typed:E}=D;return E(name$285,{"number, number":addNumber,"Complex, Complex":function(F,J){return F.add(J)},"BigNumber, BigNumber":function(F,J){return F.plus(J)},"bigint, bigint":function(F,J){return F+J},"Fraction, Fraction":function(F,J){return F.add(J)},"Unit, Unit":E.referToSelf(F=>(J,$e)=>{if(J.value===null||J.value===void 0)throw Error("Parameter x contains a unit with undefined value");if($e.value===null||$e.value===void 0)throw Error("Parameter y contains a unit with undefined value");if(!J.equalBase($e))throw Error("Units do not match");var _t=J.clone();return _t.value=E.find(F,[_t.valueType(),$e.valueType()])(_t.value,$e.value),_t.fixPrefix=!1,_t})})}),name$284="subtractScalar",dependencies$284=["typed"],createSubtractScalar=factory(name$284,dependencies$284,D=>{var{typed:E}=D;return E(name$284,{"number, number":subtractNumber,"Complex, Complex":function(F,J){return F.sub(J)},"BigNumber, BigNumber":function(F,J){return F.minus(J)},"bigint, bigint":function(F,J){return F-J},"Fraction, Fraction":function(F,J){return F.sub(J)},"Unit, Unit":E.referToSelf(F=>(J,$e)=>{if(J.value===null||J.value===void 0)throw Error("Parameter x contains a unit with undefined value");if($e.value===null||$e.value===void 0)throw Error("Parameter y contains a unit with undefined value");if(!J.equalBase($e))throw Error("Units do not match");var _t=J.clone();return _t.value=E.find(F,[_t.valueType(),$e.valueType()])(_t.value,$e.value),_t.fixPrefix=!1,_t})})}),name$283="cbrt",dependencies$283=["config","typed","isNegative","unaryMinus","matrix","Complex","BigNumber","Fraction"],createCbrt=factory(name$283,dependencies$283,D=>{var{config:E,typed:F,isNegative:J,unaryMinus:$e,matrix:_t,Complex:lr,BigNumber:mr,Fraction:Or}=D;return F(name$283,{number:cbrtNumber,Complex:Pr,"Complex, boolean":Pr,BigNumber:function(gi){return gi.cbrt()},Unit:dn});function Pr(gi,qi){var zi=gi.arg()/3,Hi=gi.abs(),Qi=new lr(cbrtNumber(Hi),0).mul(new lr(0,zi).exp());if(qi){var Gi=[Qi,new lr(cbrtNumber(Hi),0).mul(new lr(0,zi+Math.PI*2/3).exp()),new lr(cbrtNumber(Hi),0).mul(new lr(0,zi-Math.PI*2/3).exp())];return E.matrix==="Array"?Gi:_t(Gi)}else return Qi}function dn(gi){if(gi.value&&isComplex(gi.value)){var qi=gi.clone();return qi.value=1,qi=qi.pow(1/3),qi.value=Pr(gi.value),qi}else{var zi=J(gi.value);zi&&(gi.value=$e(gi.value));var Hi=isBigNumber(gi.value)?new mr(1).div(3):isFraction(gi.value)?new Or(1,3):1/3,Qi=gi.pow(Hi);return zi&&(Qi.value=$e(Qi.value)),Qi}}}),name$282="matAlgo11xS0s",dependencies$282=["typed","equalScalar"],createMatAlgo11xS0s=factory(name$282,dependencies$282,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t,lr){var mr=J._values,Or=J._index,Pr=J._ptr,dn=J._size,gi=J._datatype;if(!mr)throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var qi=dn[0],zi=dn[1],Hi,Qi=F,Gi=0,Zi=_t;typeof gi=="string"&&(Hi=gi,Qi=E.find(F,[Hi,Hi]),Gi=E.convert(0,Hi),$e=E.convert($e,Hi),Zi=E.find(_t,[Hi,Hi]));for(var Xi=[],Ki=[],ea=[],Ji=0;Ji<zi;Ji++){ea[Ji]=Ki.length;for(var ta=Pr[Ji],na=Pr[Ji+1],ra=ta;ra<na;ra++){var ia=Or[ra],oa=lr?Zi($e,mr[ra]):Zi(mr[ra],$e);Qi(oa,Gi)||(Ki.push(ia),Xi.push(oa))}}return ea[zi]=Ki.length,J.createSparseMatrix({values:Xi,index:Ki,ptr:ea,size:[qi,zi],datatype:Hi})}}),name$281="matAlgo12xSfs",dependencies$281=["typed","DenseMatrix"],createMatAlgo12xSfs=factory(name$281,dependencies$281,D=>{var{typed:E,DenseMatrix:F}=D;return function(J,$e,_t,lr){var mr=J._values,Or=J._index,Pr=J._ptr,dn=J._size,gi=J._datatype;if(!mr)throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var qi=dn[0],zi=dn[1],Hi,Qi=_t;typeof gi=="string"&&(Hi=gi,$e=E.convert($e,Hi),Qi=E.find(_t,[Hi,Hi]));for(var Gi=[],Zi=[],Xi=[],Ki=0;Ki<zi;Ki++){for(var ea=Ki+1,Ji=Pr[Ki],ta=Pr[Ki+1],na=Ji;na<ta;na++){var ra=Or[na];Zi[ra]=mr[na],Xi[ra]=ea}for(var ia=0;ia<qi;ia++)Ki===0&&(Gi[ia]=[]),Xi[ia]===ea?Gi[ia][Ki]=lr?Qi($e,Zi[ia]):Qi(Zi[ia],$e):Gi[ia][Ki]=lr?Qi($e,0):Qi(0,$e)}return new F({data:Gi,size:[qi,zi],datatype:Hi})}}),name$280="matAlgo14xDs",dependencies$280=["typed"],createMatAlgo14xDs=factory(name$280,dependencies$280,D=>{var{typed:E}=D;return function(J,$e,_t,lr){var mr=J._data,Or=J._size,Pr=J._datatype,dn,gi=_t;typeof Pr=="string"&&(dn=Pr,$e=E.convert($e,dn),gi=E.find(_t,[dn,dn]));var qi=Or.length>0?F(gi,0,Or,Or[0],mr,$e,lr):[];return J.createDenseMatrix({data:qi,size:clone$3(Or),datatype:dn})};function F(J,$e,_t,lr,mr,Or,Pr){var dn=[];if($e===_t.length-1)for(var gi=0;gi<lr;gi++)dn[gi]=Pr?J(Or,mr[gi]):J(mr[gi],Or);else for(var qi=0;qi<lr;qi++)dn[qi]=F(J,$e+1,_t,_t[$e+1],mr[qi],Or,Pr);return dn}}),name$279="ceil",dependencies$279=["typed","config","round","matrix","equalScalar","zeros","DenseMatrix"],bigTen$1=new Decimal(10),createCeilNumber=factory(name$279,["typed","config","round"],D=>{var{typed:E,config:F,round:J}=D;function $e(_t){var lr=Math.ceil(_t),mr=J(_t);return lr===mr?lr:nearlyEqual$1(_t,mr,F.relTol,F.absTol)&&!nearlyEqual$1(_t,lr,F.relTol,F.absTol)?mr:lr}return E(name$279,{number:$e,"number, number":function(_t,lr){if(!isInteger(lr))throw RangeError("number of decimals in function ceil must be an integer");if(lr<0||lr>15)throw RangeError("number of decimals in ceil number must be in range 0-15");var mr=10**lr;return $e(_t*mr)/mr}})}),createCeil=factory(name$279,dependencies$279,D=>{var{typed:E,config:F,round:J,matrix:$e,equalScalar:_t,zeros:lr,DenseMatrix:mr}=D,Or=createMatAlgo11xS0s({typed:E,equalScalar:_t}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:mr}),dn=createMatAlgo14xDs({typed:E}),gi=createCeilNumber({typed:E,config:F,round:J});function qi(zi){var Hi=(Zi,Xi)=>nearlyEqual(Zi,Xi,F.relTol,F.absTol),Qi=zi.ceil(),Gi=J(zi);return Qi.eq(Gi)?Qi:Hi(zi,Gi)&&!Hi(zi,Qi)?Gi:Qi}return E("ceil",{number:gi.signatures.number,"number,number":gi.signatures["number,number"],Complex:function(zi){return zi.ceil()},"Complex, number":function(zi,Hi){return zi.ceil(Hi)},"Complex, BigNumber":function(zi,Hi){return zi.ceil(Hi.toNumber())},BigNumber:qi,"BigNumber, BigNumber":function(zi,Hi){var Qi=bigTen$1.pow(Hi);return qi(zi.mul(Qi)).div(Qi)},bigint:zi=>zi,"bigint, number":(zi,Hi)=>zi,"bigint, BigNumber":(zi,Hi)=>zi,Fraction:function(zi){return zi.ceil()},"Fraction, number":function(zi,Hi){return zi.ceil(Hi)},"Fraction, BigNumber":function(zi,Hi){return zi.ceil(Hi.toNumber())},"Unit, number, Unit":E.referToSelf(zi=>function(Hi,Qi,Gi){var Zi=Hi.toNumeric(Gi);return Gi.multiply(zi(Zi,Qi))}),"Unit, BigNumber, Unit":E.referToSelf(zi=>(Hi,Qi,Gi)=>zi(Hi,Qi.toNumber(),Gi)),"Array | Matrix, number | BigNumber, Unit":E.referToSelf(zi=>(Hi,Qi,Gi)=>deepMap(Hi,Zi=>zi(Zi,Qi,Gi),!0)),"Array | Matrix | Unit, Unit":E.referToSelf(zi=>(Hi,Qi)=>zi(Hi,0,Qi)),"Array | Matrix":E.referToSelf(zi=>Hi=>deepMap(Hi,zi,!0)),"Array, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>deepMap(Hi,Gi=>zi(Gi,Qi),!0)),"SparseMatrix, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>Or(Hi,Qi,zi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>dn(Hi,Qi,zi,!1)),"number | Complex | Fraction | BigNumber, Array":E.referToSelf(zi=>(Hi,Qi)=>dn($e(Qi),Hi,zi,!0).valueOf()),"number | Complex | Fraction | BigNumber, Matrix":E.referToSelf(zi=>(Hi,Qi)=>_t(Hi,0)?lr(Qi.size(),Qi.storage()):Qi.storage()==="dense"?dn(Qi,Hi,zi,!0):Pr(Qi,Hi,zi,!0))})}),name$278="cube",dependencies$278=["typed"],createCube=factory(name$278,dependencies$278,D=>{var{typed:E}=D;return E(name$278,{number:cubeNumber,Complex:function(F){return F.mul(F).mul(F)},BigNumber:function(F){return F.times(F).times(F)},bigint:function(F){return F*F*F},Fraction:function(F){return F.pow(3)},Unit:function(F){return F.pow(3)}})}),name$277="exp",dependencies$277=["typed"],createExp=factory(name$277,dependencies$277,D=>{var{typed:E}=D;return E(name$277,{number:expNumber,Complex:function(F){return F.exp()},BigNumber:function(F){return F.exp()}})}),name$276="expm1",dependencies$276=["typed","Complex"],createExpm1=factory(name$276,dependencies$276,D=>{var{typed:E,Complex:F}=D;return E(name$276,{number:expm1Number,Complex:function(J){var $e=Math.exp(J.re);return new F($e*Math.cos(J.im)-1,$e*Math.sin(J.im))},BigNumber:function(J){return J.exp().minus(1)}})}),name$275="fix",dependencies$275=["typed","Complex","matrix","ceil","floor","equalScalar","zeros","DenseMatrix"],createFixNumber=factory(name$275,["typed","ceil","floor"],D=>{var{typed:E,ceil:F,floor:J}=D;return E(name$275,{number:function($e){return $e>0?J($e):F($e)},"number, number":function($e,_t){return $e>0?J($e,_t):F($e,_t)}})}),createFix=factory(name$275,dependencies$275,D=>{var{typed:E,Complex:F,matrix:J,ceil:$e,floor:_t,equalScalar:lr,zeros:mr,DenseMatrix:Or}=D,Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:Or}),dn=createMatAlgo14xDs({typed:E}),gi=createFixNumber({typed:E,ceil:$e,floor:_t});return E("fix",{number:gi.signatures.number,"number, number | BigNumber":gi.signatures["number,number"],Complex:function(qi){return new F(qi.re>0?Math.floor(qi.re):Math.ceil(qi.re),qi.im>0?Math.floor(qi.im):Math.ceil(qi.im))},"Complex, number":function(qi,zi){return new F(qi.re>0?_t(qi.re,zi):$e(qi.re,zi),qi.im>0?_t(qi.im,zi):$e(qi.im,zi))},"Complex, BigNumber":function(qi,zi){var Hi=zi.toNumber();return new F(qi.re>0?_t(qi.re,Hi):$e(qi.re,Hi),qi.im>0?_t(qi.im,Hi):$e(qi.im,Hi))},BigNumber:function(qi){return qi.isNegative()?$e(qi):_t(qi)},"BigNumber, number | BigNumber":function(qi,zi){return qi.isNegative()?$e(qi,zi):_t(qi,zi)},bigint:qi=>qi,"bigint, number":(qi,zi)=>qi,"bigint, BigNumber":(qi,zi)=>qi,Fraction:function(qi){return qi.s<0n?qi.ceil():qi.floor()},"Fraction, number | BigNumber":function(qi,zi){return qi.s<0n?$e(qi,zi):_t(qi,zi)},"Unit, number, Unit":E.referToSelf(qi=>function(zi,Hi,Qi){var Gi=zi.toNumeric(Qi);return Qi.multiply(qi(Gi,Hi))}),"Unit, BigNumber, Unit":E.referToSelf(qi=>(zi,Hi,Qi)=>qi(zi,Hi.toNumber(),Qi)),"Array | Matrix, number | BigNumber, Unit":E.referToSelf(qi=>(zi,Hi,Qi)=>deepMap(zi,Gi=>qi(Gi,Hi,Qi),!0)),"Array | Matrix | Unit, Unit":E.referToSelf(qi=>(zi,Hi)=>qi(zi,0,Hi)),"Array | Matrix":E.referToSelf(qi=>zi=>deepMap(zi,qi,!0)),"Array | Matrix, number | BigNumber":E.referToSelf(qi=>(zi,Hi)=>deepMap(zi,Qi=>qi(Qi,Hi),!0)),"number | Complex | Fraction | BigNumber, Array":E.referToSelf(qi=>(zi,Hi)=>dn(J(Hi),zi,qi,!0).valueOf()),"number | Complex | Fraction | BigNumber, Matrix":E.referToSelf(qi=>(zi,Hi)=>lr(zi,0)?mr(Hi.size(),Hi.storage()):Hi.storage()==="dense"?dn(Hi,zi,qi,!0):Pr(Hi,zi,qi,!0))})}),name$274="floor",dependencies$274=["typed","config","round","matrix","equalScalar","zeros","DenseMatrix"],bigTen=new Decimal(10),createFloorNumber=factory(name$274,["typed","config","round"],D=>{var{typed:E,config:F,round:J}=D;function $e(_t){var lr=Math.floor(_t),mr=J(_t);return lr===mr?lr:nearlyEqual$1(_t,mr,F.relTol,F.absTol)&&!nearlyEqual$1(_t,lr,F.relTol,F.absTol)?mr:lr}return E(name$274,{number:$e,"number, number":function(_t,lr){if(!isInteger(lr))throw RangeError("number of decimals in function floor must be an integer");if(lr<0||lr>15)throw RangeError("number of decimals in floor number must be in range 0 - 15");var mr=10**lr;return $e(_t*mr)/mr}})}),createFloor=factory(name$274,dependencies$274,D=>{var{typed:E,config:F,round:J,matrix:$e,equalScalar:_t,zeros:lr,DenseMatrix:mr}=D,Or=createMatAlgo11xS0s({typed:E,equalScalar:_t}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:mr}),dn=createMatAlgo14xDs({typed:E}),gi=createFloorNumber({typed:E,config:F,round:J});function qi(zi){var Hi=(Zi,Xi)=>nearlyEqual(Zi,Xi,F.relTol,F.absTol),Qi=zi.floor(),Gi=J(zi);return Qi.eq(Gi)?Qi:Hi(zi,Gi)&&!Hi(zi,Qi)?Gi:Qi}return E("floor",{number:gi.signatures.number,"number,number":gi.signatures["number,number"],Complex:function(zi){return zi.floor()},"Complex, number":function(zi,Hi){return zi.floor(Hi)},"Complex, BigNumber":function(zi,Hi){return zi.floor(Hi.toNumber())},BigNumber:qi,"BigNumber, BigNumber":function(zi,Hi){var Qi=bigTen.pow(Hi);return qi(zi.mul(Qi)).div(Qi)},bigint:zi=>zi,"bigint, number":(zi,Hi)=>zi,"bigint, BigNumber":(zi,Hi)=>zi,Fraction:function(zi){return zi.floor()},"Fraction, number":function(zi,Hi){return zi.floor(Hi)},"Fraction, BigNumber":function(zi,Hi){return zi.floor(Hi.toNumber())},"Unit, number, Unit":E.referToSelf(zi=>function(Hi,Qi,Gi){var Zi=Hi.toNumeric(Gi);return Gi.multiply(zi(Zi,Qi))}),"Unit, BigNumber, Unit":E.referToSelf(zi=>(Hi,Qi,Gi)=>zi(Hi,Qi.toNumber(),Gi)),"Array | Matrix, number | BigNumber, Unit":E.referToSelf(zi=>(Hi,Qi,Gi)=>deepMap(Hi,Zi=>zi(Zi,Qi,Gi),!0)),"Array | Matrix | Unit, Unit":E.referToSelf(zi=>(Hi,Qi)=>zi(Hi,0,Qi)),"Array | Matrix":E.referToSelf(zi=>Hi=>deepMap(Hi,zi,!0)),"Array, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>deepMap(Hi,Gi=>zi(Gi,Qi),!0)),"SparseMatrix, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>Or(Hi,Qi,zi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(zi=>(Hi,Qi)=>dn(Hi,Qi,zi,!1)),"number | Complex | Fraction | BigNumber, Array":E.referToSelf(zi=>(Hi,Qi)=>dn($e(Qi),Hi,zi,!0).valueOf()),"number | Complex | Fraction | BigNumber, Matrix":E.referToSelf(zi=>(Hi,Qi)=>_t(Hi,0)?lr(Qi.size(),Qi.storage()):Qi.storage()==="dense"?dn(Qi,Hi,zi,!0):Pr(Qi,Hi,zi,!0))})}),name$273="matAlgo02xDS0",dependencies$273=["typed","equalScalar"],createMatAlgo02xDS0=factory(name$273,dependencies$273,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t,lr){var mr=J._data,Or=J._size,Pr=J._datatype||J.getDataType(),dn=$e._values,gi=$e._index,qi=$e._ptr,zi=$e._size,Hi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(Or.length!==zi.length)throw new DimensionError(Or.length,zi.length);if(Or[0]!==zi[0]||Or[1]!==zi[1])throw RangeError("Dimension mismatch. Matrix A ("+Or+") must match Matrix B ("+zi+")");if(!dn)throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");var Qi=Or[0],Gi=Or[1],Zi,Xi=F,Ki=0,ea=_t;typeof Pr=="string"&&Pr===Hi&&Pr!=="mixed"&&(Zi=Pr,Xi=E.find(F,[Zi,Zi]),Ki=E.convert(0,Zi),ea=E.find(_t,[Zi,Zi]));for(var Ji=[],ta=[],na=[],ra=0;ra<Gi;ra++){na[ra]=ta.length;for(var ia=qi[ra],oa=qi[ra+1],ua=ia;ua<oa;ua++){var sa=gi[ua],aa=lr?ea(dn[ua],mr[sa][ra]):ea(mr[sa][ra],dn[ua]);Xi(aa,Ki)||(ta.push(sa),Ji.push(aa))}}return na[Gi]=ta.length,$e.createSparseMatrix({values:Ji,index:ta,ptr:na,size:[Qi,Gi],datatype:Pr===J._datatype&&Hi===$e._datatype?Zi:void 0})}}),name$272="matAlgo03xDSf",dependencies$272=["typed"],createMatAlgo03xDSf=factory(name$272,dependencies$272,D=>{var{typed:E}=D;return function(F,J,$e,_t){var lr=F._data,mr=F._size,Or=F._datatype||F.getDataType(),Pr=J._values,dn=J._index,gi=J._ptr,qi=J._size,zi=J._datatype||J._data===void 0?J._datatype:J.getDataType();if(mr.length!==qi.length)throw new DimensionError(mr.length,qi.length);if(mr[0]!==qi[0]||mr[1]!==qi[1])throw RangeError("Dimension mismatch. Matrix A ("+mr+") must match Matrix B ("+qi+")");if(!Pr)throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");var Hi=mr[0],Qi=mr[1],Gi,Zi=0,Xi=$e;typeof Or=="string"&&Or===zi&&Or!=="mixed"&&(Gi=Or,Zi=E.convert(0,Gi),Xi=E.find($e,[Gi,Gi]));for(var Ki=[],ea=0;ea<Hi;ea++)Ki[ea]=[];for(var Ji=[],ta=[],na=0;na<Qi;na++){for(var ra=na+1,ia=gi[na],oa=gi[na+1],ua=ia;ua<oa;ua++){var sa=dn[ua];Ji[sa]=_t?Xi(Pr[ua],lr[sa][na]):Xi(lr[sa][na],Pr[ua]),ta[sa]=ra}for(var aa=0;aa<Hi;aa++)ta[aa]===ra?Ki[aa][na]=Ji[aa]:Ki[aa][na]=_t?Xi(Zi,lr[aa][na]):Xi(lr[aa][na],Zi)}return F.createDenseMatrix({data:Ki,size:[Hi,Qi],datatype:Or===F._datatype&&zi===J._datatype?Gi:void 0})}}),name$271="matAlgo05xSfSf",dependencies$271=["typed","equalScalar"],createMatAlgo05xSfSf=factory(name$271,dependencies$271,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t){var lr=J._values,mr=J._index,Or=J._ptr,Pr=J._size,dn=J._datatype||J._data===void 0?J._datatype:J.getDataType(),gi=$e._values,qi=$e._index,zi=$e._ptr,Hi=$e._size,Qi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(Pr.length!==Hi.length)throw new DimensionError(Pr.length,Hi.length);if(Pr[0]!==Hi[0]||Pr[1]!==Hi[1])throw RangeError("Dimension mismatch. Matrix A ("+Pr+") must match Matrix B ("+Hi+")");var Gi=Pr[0],Zi=Pr[1],Xi,Ki=F,ea=0,Ji=_t;typeof dn=="string"&&dn===Qi&&dn!=="mixed"&&(Xi=dn,Ki=E.find(F,[Xi,Xi]),ea=E.convert(0,Xi),Ji=E.find(_t,[Xi,Xi]));var ta=lr&&gi?[]:void 0,na=[],ra=[],ia=ta?[]:void 0,oa=ta?[]:void 0,ua=[],sa=[],aa,pa,ma,la;for(pa=0;pa<Zi;pa++){ra[pa]=na.length;var ha=pa+1;for(ma=Or[pa],la=Or[pa+1];ma<la;ma++)aa=mr[ma],na.push(aa),ua[aa]=ha,ia&&(ia[aa]=lr[ma]);for(ma=zi[pa],la=zi[pa+1];ma<la;ma++)aa=qi[ma],ua[aa]!==ha&&na.push(aa),sa[aa]=ha,oa&&(oa[aa]=gi[ma]);if(ta)for(ma=ra[pa];ma<na.length;){aa=na[ma];var ga=ua[aa],Aa=sa[aa];if(ga===ha||Aa===ha){var Fa=ga===ha?ia[aa]:ea,$a=Aa===ha?oa[aa]:ea,_a=Ji(Fa,$a);Ki(_a,ea)?na.splice(ma,1):(ta.push(_a),ma++)}}}return ra[Zi]=na.length,J.createSparseMatrix({values:ta,index:na,ptr:ra,size:[Gi,Zi],datatype:dn===J._datatype&&Qi===$e._datatype?Xi:void 0})}}),name$270="matAlgo13xDD",dependencies$270=["typed"],createMatAlgo13xDD=factory(name$270,dependencies$270,D=>{var{typed:E}=D;return function(J,$e,_t){var lr=J._data,mr=J._size,Or=J._datatype,Pr=$e._data,dn=$e._size,gi=$e._datatype,qi=[];if(mr.length!==dn.length)throw new DimensionError(mr.length,dn.length);for(var zi=0;zi<mr.length;zi++){if(mr[zi]!==dn[zi])throw RangeError("Dimension mismatch. Matrix A ("+mr+") must match Matrix B ("+dn+")");qi[zi]=mr[zi]}var Hi,Qi=_t;typeof Or=="string"&&Or===gi&&(Hi=Or,Qi=E.find(_t,[Hi,Hi]));var Gi=qi.length>0?F(Qi,0,qi,qi[0],lr,Pr):[];return J.createDenseMatrix({data:Gi,size:qi,datatype:Hi})};function F(J,$e,_t,lr,mr,Or){var Pr=[];if($e===_t.length-1)for(var dn=0;dn<lr;dn++)Pr[dn]=J(mr[dn],Or[dn]);else for(var gi=0;gi<lr;gi++)Pr[gi]=F(J,$e+1,_t,_t[$e+1],mr[gi],Or[gi]);return Pr}});function broadcast(D,E){if(deepStrictEqual(D.size(),E.size()))return[D,E];var F=broadcastSizes(D.size(),E.size());return[D,E].map(J=>_broadcastTo(J,F))}function _broadcastTo(D,E){return deepStrictEqual(D.size(),E)?D:D.create(broadcastTo(D.valueOf(),E),D.datatype())}var name$269="matrixAlgorithmSuite",dependencies$269=["typed","matrix"],createMatrixAlgorithmSuite=factory(name$269,dependencies$269,D=>{var{typed:E,matrix:F}=D,J=createMatAlgo13xDD({typed:E}),$e=createMatAlgo14xDs({typed:E});return function(_t){var lr=_t.elop,mr=_t.SD||_t.DS,Or;lr?(Or={"DenseMatrix, DenseMatrix":(gi,qi)=>J(...broadcast(gi,qi),lr),"Array, Array":(gi,qi)=>J(...broadcast(F(gi),F(qi)),lr).valueOf(),"Array, DenseMatrix":(gi,qi)=>J(...broadcast(F(gi),qi),lr),"DenseMatrix, Array":(gi,qi)=>J(...broadcast(gi,F(qi)),lr)},_t.SS&&(Or["SparseMatrix, SparseMatrix"]=(gi,qi)=>_t.SS(...broadcast(gi,qi),lr,!1)),_t.DS&&(Or["DenseMatrix, SparseMatrix"]=(gi,qi)=>_t.DS(...broadcast(gi,qi),lr,!1),Or["Array, SparseMatrix"]=(gi,qi)=>_t.DS(...broadcast(F(gi),qi),lr,!1)),mr&&(Or["SparseMatrix, DenseMatrix"]=(gi,qi)=>mr(...broadcast(qi,gi),lr,!0),Or["SparseMatrix, Array"]=(gi,qi)=>mr(...broadcast(F(qi),gi),lr,!0))):(Or={"DenseMatrix, DenseMatrix":E.referToSelf(gi=>(qi,zi)=>J(...broadcast(qi,zi),gi)),"Array, Array":E.referToSelf(gi=>(qi,zi)=>J(...broadcast(F(qi),F(zi)),gi).valueOf()),"Array, DenseMatrix":E.referToSelf(gi=>(qi,zi)=>J(...broadcast(F(qi),zi),gi)),"DenseMatrix, Array":E.referToSelf(gi=>(qi,zi)=>J(...broadcast(qi,F(zi)),gi))},_t.SS&&(Or["SparseMatrix, SparseMatrix"]=E.referToSelf(gi=>(qi,zi)=>_t.SS(...broadcast(qi,zi),gi,!1))),_t.DS&&(Or["DenseMatrix, SparseMatrix"]=E.referToSelf(gi=>(qi,zi)=>_t.DS(...broadcast(qi,zi),gi,!1)),Or["Array, SparseMatrix"]=E.referToSelf(gi=>(qi,zi)=>_t.DS(...broadcast(F(qi),zi),gi,!1))),mr&&(Or["SparseMatrix, DenseMatrix"]=E.referToSelf(gi=>(qi,zi)=>mr(...broadcast(zi,qi),gi,!0)),Or["SparseMatrix, Array"]=E.referToSelf(gi=>(qi,zi)=>mr(...broadcast(F(zi),qi),gi,!0))));var Pr=_t.scalar||"any";(_t.Ds||_t.Ss)&&(lr?(Or["DenseMatrix,"+Pr]=(gi,qi)=>$e(gi,qi,lr,!1),Or[Pr+", DenseMatrix"]=(gi,qi)=>$e(qi,gi,lr,!0),Or["Array,"+Pr]=(gi,qi)=>$e(F(gi),qi,lr,!1).valueOf(),Or[Pr+", Array"]=(gi,qi)=>$e(F(qi),gi,lr,!0).valueOf()):(Or["DenseMatrix,"+Pr]=E.referToSelf(gi=>(qi,zi)=>$e(qi,zi,gi,!1)),Or[Pr+", DenseMatrix"]=E.referToSelf(gi=>(qi,zi)=>$e(zi,qi,gi,!0)),Or["Array,"+Pr]=E.referToSelf(gi=>(qi,zi)=>$e(F(qi),zi,gi,!1).valueOf()),Or[Pr+", Array"]=E.referToSelf(gi=>(qi,zi)=>$e(F(zi),qi,gi,!0).valueOf())));var dn=_t.sS===void 0?_t.Ss:_t.sS;return lr?(_t.Ss&&(Or["SparseMatrix,"+Pr]=(gi,qi)=>_t.Ss(gi,qi,lr,!1)),dn&&(Or[Pr+", SparseMatrix"]=(gi,qi)=>dn(qi,gi,lr,!0))):(_t.Ss&&(Or["SparseMatrix,"+Pr]=E.referToSelf(gi=>(qi,zi)=>_t.Ss(qi,zi,gi,!1))),dn&&(Or[Pr+", SparseMatrix"]=E.referToSelf(gi=>(qi,zi)=>dn(zi,qi,gi,!0)))),lr&&lr.signatures&&extend$1(Or,lr.signatures),Or}}),name$268="mod",dependencies$268=["typed","config","round","matrix","equalScalar","zeros","DenseMatrix","concat"],createMod=factory(name$268,dependencies$268,D=>{var{typed:E,config:F,round:J,matrix:$e,equalScalar:_t,zeros:lr,DenseMatrix:mr,concat:Or}=D,Pr=createFloor({typed:E,config:F,round:J,matrix:$e,equalScalar:_t,zeros:lr,DenseMatrix:mr}),dn=createMatAlgo02xDS0({typed:E,equalScalar:_t}),gi=createMatAlgo03xDSf({typed:E}),qi=createMatAlgo05xSfSf({typed:E,equalScalar:_t}),zi=createMatAlgo11xS0s({typed:E,equalScalar:_t}),Hi=createMatAlgo12xSfs({typed:E,DenseMatrix:mr}),Qi=createMatrixAlgorithmSuite({typed:E,matrix:$e,concat:Or});return E(name$268,{"number, number":Gi,"BigNumber, BigNumber":function(Zi,Xi){return Xi.isZero()?Zi:Zi.sub(Xi.mul(Pr(Zi.div(Xi))))},"bigint, bigint":function(Zi,Xi){if(Xi===0n)return Zi;if(Zi<0){var Ki=Zi%Xi;return Ki===0n?Ki:Ki+Xi}return Zi%Xi},"Fraction, Fraction":function(Zi,Xi){return Xi.equals(0)?Zi:Zi.sub(Xi.mul(Pr(Zi.div(Xi))))}},Qi({SS:qi,DS:gi,SD:dn,Ss:zi,sS:Hi}));function Gi(Zi,Xi){return Xi===0?Zi:Zi-Xi*Pr(Zi/Xi)}}),name$267="matAlgo01xDSid",dependencies$267=["typed"],createMatAlgo01xDSid=factory(name$267,dependencies$267,D=>{var{typed:E}=D;return function(F,J,$e,_t){var lr=F._data,mr=F._size,Or=F._datatype||F.getDataType(),Pr=J._values,dn=J._index,gi=J._ptr,qi=J._size,zi=J._datatype||J._data===void 0?J._datatype:J.getDataType();if(mr.length!==qi.length)throw new DimensionError(mr.length,qi.length);if(mr[0]!==qi[0]||mr[1]!==qi[1])throw RangeError("Dimension mismatch. Matrix A ("+mr+") must match Matrix B ("+qi+")");if(!Pr)throw Error("Cannot perform operation on Dense Matrix and Pattern Sparse Matrix");var Hi=mr[0],Qi=mr[1],Gi=typeof Or=="string"&&Or!=="mixed"&&Or===zi?Or:void 0,Zi=Gi?E.find($e,[Gi,Gi]):$e,Xi,Ki,ea=[];for(Xi=0;Xi<Hi;Xi++)ea[Xi]=[];var Ji=[],ta=[];for(Ki=0;Ki<Qi;Ki++){for(var na=Ki+1,ra=gi[Ki],ia=gi[Ki+1],oa=ra;oa<ia;oa++)Xi=dn[oa],Ji[Xi]=_t?Zi(Pr[oa],lr[Xi][Ki]):Zi(lr[Xi][Ki],Pr[oa]),ta[Xi]=na;for(Xi=0;Xi<Hi;Xi++)ta[Xi]===na?ea[Xi][Ki]=Ji[Xi]:ea[Xi][Ki]=lr[Xi][Ki]}return F.createDenseMatrix({data:ea,size:[Hi,Qi],datatype:Or===F._datatype&&zi===J._datatype?Gi:void 0})}}),name$266="matAlgo04xSidSid",dependencies$266=["typed","equalScalar"],createMatAlgo04xSidSid=factory(name$266,dependencies$266,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t){var lr=J._values,mr=J._index,Or=J._ptr,Pr=J._size,dn=J._datatype||J._data===void 0?J._datatype:J.getDataType(),gi=$e._values,qi=$e._index,zi=$e._ptr,Hi=$e._size,Qi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(Pr.length!==Hi.length)throw new DimensionError(Pr.length,Hi.length);if(Pr[0]!==Hi[0]||Pr[1]!==Hi[1])throw RangeError("Dimension mismatch. Matrix A ("+Pr+") must match Matrix B ("+Hi+")");var Gi=Pr[0],Zi=Pr[1],Xi,Ki=F,ea=0,Ji=_t;typeof dn=="string"&&dn===Qi&&dn!=="mixed"&&(Xi=dn,Ki=E.find(F,[Xi,Xi]),ea=E.convert(0,Xi),Ji=E.find(_t,[Xi,Xi]));var ta=lr&&gi?[]:void 0,na=[],ra=[],ia=lr&&gi?[]:void 0,oa=lr&&gi?[]:void 0,ua=[],sa=[],aa,pa,ma,la,ha;for(pa=0;pa<Zi;pa++){ra[pa]=na.length;var ga=pa+1;for(la=Or[pa],ha=Or[pa+1],ma=la;ma<ha;ma++)aa=mr[ma],na.push(aa),ua[aa]=ga,ia&&(ia[aa]=lr[ma]);for(la=zi[pa],ha=zi[pa+1],ma=la;ma<ha;ma++)if(aa=qi[ma],ua[aa]===ga){if(ia){var Aa=Ji(ia[aa],gi[ma]);Ki(Aa,ea)?ua[aa]=null:ia[aa]=Aa}}else na.push(aa),sa[aa]=ga,oa&&(oa[aa]=gi[ma]);if(ia&&oa)for(ma=ra[pa];ma<na.length;)aa=na[ma],ua[aa]===ga?(ta[ma]=ia[aa],ma++):sa[aa]===ga?(ta[ma]=oa[aa],ma++):na.splice(ma,1)}return ra[Zi]=na.length,J.createSparseMatrix({values:ta,index:na,ptr:ra,size:[Gi,Zi],datatype:dn===J._datatype&&Qi===$e._datatype?Xi:void 0})}}),name$265="matAlgo10xSids",dependencies$265=["typed","DenseMatrix"],createMatAlgo10xSids=factory(name$265,dependencies$265,D=>{var{typed:E,DenseMatrix:F}=D;return function(J,$e,_t,lr){var mr=J._values,Or=J._index,Pr=J._ptr,dn=J._size,gi=J._datatype;if(!mr)throw Error("Cannot perform operation on Pattern Sparse Matrix and Scalar value");var qi=dn[0],zi=dn[1],Hi,Qi=_t;typeof gi=="string"&&(Hi=gi,$e=E.convert($e,Hi),Qi=E.find(_t,[Hi,Hi]));for(var Gi=[],Zi=[],Xi=[],Ki=0;Ki<zi;Ki++){for(var ea=Ki+1,Ji=Pr[Ki],ta=Pr[Ki+1],na=Ji;na<ta;na++){var ra=Or[na];Zi[ra]=mr[na],Xi[ra]=ea}for(var ia=0;ia<qi;ia++)Ki===0&&(Gi[ia]=[]),Xi[ia]===ea?Gi[ia][Ki]=lr?Qi($e,Zi[ia]):Qi(Zi[ia],$e):Gi[ia][Ki]=$e}return new F({data:Gi,size:[qi,zi],datatype:Hi})}});function ArgumentsError(D,E,F,J){if(!(this instanceof ArgumentsError))throw SyntaxError("Constructor must be called with the new operator");this.fn=D,this.count=E,this.min=F,this.max=J,this.message="Wrong number of arguments in function "+D+" ("+E+" provided, "+F+(J==null?"":"-"+J)+" expected)",this.stack=Error().stack}ArgumentsError.prototype=Error(),ArgumentsError.prototype.constructor=Error,ArgumentsError.prototype.name="ArgumentsError",ArgumentsError.prototype.isArgumentsError=!0;var name$264="gcd",dependencies$264=["typed","config","round","matrix","equalScalar","zeros","BigNumber","DenseMatrix","concat"],gcdTypes="number | BigNumber | Fraction | Matrix | Array",gcdManyTypesSignature=`${gcdTypes}, ${gcdTypes}, ...${gcdTypes}`;function is1d(D){return!D.some(E=>Array.isArray(E))}var createGcd=factory(name$264,dependencies$264,D=>{var{typed:E,matrix:F,config:J,round:$e,equalScalar:_t,zeros:lr,BigNumber:mr,DenseMatrix:Or,concat:Pr}=D,dn=createMod({typed:E,config:J,round:$e,matrix:F,equalScalar:_t,zeros:lr,DenseMatrix:Or,concat:Pr}),gi=createMatAlgo01xDSid({typed:E}),qi=createMatAlgo04xSidSid({typed:E,equalScalar:_t}),zi=createMatAlgo10xSids({typed:E,DenseMatrix:Or}),Hi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:Pr});return E(name$264,{"number, number":Qi,"BigNumber, BigNumber":Gi,"Fraction, Fraction":(Zi,Xi)=>Zi.gcd(Xi)},Hi({SS:qi,DS:gi,Ss:zi}),{[gcdManyTypesSignature]:E.referToSelf(Zi=>(Xi,Ki,ea)=>{for(var Ji=Zi(Xi,Ki),ta=0;ta<ea.length;ta++)Ji=Zi(Ji,ea[ta]);return Ji}),Array:E.referToSelf(Zi=>Xi=>{if(Xi.length===1&&Array.isArray(Xi[0])&&is1d(Xi[0]))return Zi(...Xi[0]);if(is1d(Xi))return Zi(...Xi);throw new ArgumentsError("gcd() supports only 1d matrices!")}),Matrix:E.referToSelf(Zi=>Xi=>Zi(Xi.toArray()))});function Qi(Zi,Xi){if(!isInteger(Zi)||!isInteger(Xi))throw Error("Parameters in function gcd must be integer numbers");for(var Ki;Xi!==0;)Ki=dn(Zi,Xi),Zi=Xi,Xi=Ki;return Zi<0?-Zi:Zi}function Gi(Zi,Xi){if(!Zi.isInt()||!Xi.isInt())throw Error("Parameters in function gcd must be integer numbers");for(var Ki=new mr(0);!Xi.isZero();){var ea=dn(Zi,Xi);Zi=Xi,Xi=ea}return Zi.lt(Ki)?Zi.neg():Zi}}),name$263="matAlgo06xS0S0",dependencies$263=["typed","equalScalar"],createMatAlgo06xS0S0=factory(name$263,dependencies$263,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t){var lr=J._values,mr=J._size,Or=J._datatype||J._data===void 0?J._datatype:J.getDataType(),Pr=$e._values,dn=$e._size,gi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(mr.length!==dn.length)throw new DimensionError(mr.length,dn.length);if(mr[0]!==dn[0]||mr[1]!==dn[1])throw RangeError("Dimension mismatch. Matrix A ("+mr+") must match Matrix B ("+dn+")");var qi=mr[0],zi=mr[1],Hi,Qi=F,Gi=0,Zi=_t;typeof Or=="string"&&Or===gi&&Or!=="mixed"&&(Hi=Or,Qi=E.find(F,[Hi,Hi]),Gi=E.convert(0,Hi),Zi=E.find(_t,[Hi,Hi]));for(var Xi=lr&&Pr?[]:void 0,Ki=[],ea=[],Ji=Xi?[]:void 0,ta=[],na=[],ra=0;ra<zi;ra++){ea[ra]=Ki.length;var ia=ra+1;if(scatter(J,ra,ta,Ji,na,ia,Ki,Zi),scatter($e,ra,ta,Ji,na,ia,Ki,Zi),Ji)for(var oa=ea[ra];oa<Ki.length;){var ua=Ki[oa];if(na[ua]===ia){var sa=Ji[ua];Qi(sa,Gi)?Ki.splice(oa,1):(Xi.push(sa),oa++)}else Ki.splice(oa,1)}else for(var aa=ea[ra];aa<Ki.length;)na[Ki[aa]]===ia?aa++:Ki.splice(aa,1)}return ea[zi]=Ki.length,J.createSparseMatrix({values:Xi,index:Ki,ptr:ea,size:[qi,zi],datatype:Or===J._datatype&&gi===$e._datatype?Hi:void 0})}}),name$262="lcm",dependencies$262=["typed","matrix","equalScalar","concat"],createLcm=factory(name$262,dependencies$262,D=>{var{typed:E,matrix:F,equalScalar:J,concat:$e}=D,_t=createMatAlgo02xDS0({typed:E,equalScalar:J}),lr=createMatAlgo06xS0S0({typed:E,equalScalar:J}),mr=createMatAlgo11xS0s({typed:E,equalScalar:J}),Or=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:$e}),Pr="number | BigNumber | Fraction | Matrix | Array",dn={};return dn[`${Pr}, ${Pr}, ...${Pr}`]=E.referToSelf(qi=>(zi,Hi,Qi)=>{for(var Gi=qi(zi,Hi),Zi=0;Zi<Qi.length;Zi++)Gi=qi(Gi,Qi[Zi]);return Gi}),E(name$262,{"number, number":lcmNumber,"BigNumber, BigNumber":gi,"Fraction, Fraction":(qi,zi)=>qi.lcm(zi)},Or({SS:lr,DS:_t,Ss:mr}),dn);function gi(qi,zi){if(!qi.isInt()||!zi.isInt())throw Error("Parameters in function lcm must be integer numbers");if(qi.isZero())return qi;if(zi.isZero())return zi;for(var Hi=qi.times(zi);!zi.isZero();){var Qi=zi;zi=qi.mod(Qi),qi=Qi}return Hi.div(qi).abs()}});function promoteLogarithm(D,E,F,J){return function($e){if($e>0||F.predictable){if($e<=0)return NaN;var _t=$e.toString(16),lr=_t.substring(0,15);return D*(_t.length-lr.length)+E(+("0x"+lr))}return J($e.toNumber())}}var name$261="log10",dependencies$261=["typed","config","Complex"],log16=log10Number(16),createLog10=factory(name$261,dependencies$261,D=>{var{typed:E,config:F,Complex:J}=D;function $e(lr){return lr.log().div(Math.LN10)}function _t(lr){return $e(new J(lr,0))}return E(name$261,{number:function(lr){return lr>=0||F.predictable?log10Number(lr):_t(lr)},bigint:promoteLogarithm(log16,log10Number,F,_t),Complex:$e,BigNumber:function(lr){return!lr.isNegative()||F.predictable?lr.log():_t(lr.toNumber())},"Array | Matrix":E.referToSelf(lr=>mr=>deepMap(mr,lr))})}),name$260="log2",dependencies$260=["typed","config","Complex"],createLog2=factory(name$260,dependencies$260,D=>{var{typed:E,config:F,Complex:J}=D;function $e(lr){return _t(new J(lr,0))}return E(name$260,{number:function(lr){return lr>=0||F.predictable?log2Number(lr):$e(lr)},bigint:promoteLogarithm(4,log2Number,F,$e),Complex:_t,BigNumber:function(lr){return!lr.isNegative()||F.predictable?lr.log(2):$e(lr.toNumber())},"Array | Matrix":E.referToSelf(lr=>mr=>deepMap(mr,lr))});function _t(lr){var mr=Math.sqrt(lr.re*lr.re+lr.im*lr.im);return new J(Math.log2?Math.log2(mr):Math.log(mr)/Math.LN2,Math.atan2(lr.im,lr.re)/Math.LN2)}}),name$259="multiplyScalar",dependencies$259=["typed"],createMultiplyScalar=factory(name$259,dependencies$259,D=>{var{typed:E}=D;return E("multiplyScalar",{"number, number":multiplyNumber,"Complex, Complex":function(F,J){return F.mul(J)},"BigNumber, BigNumber":function(F,J){return F.times(J)},"bigint, bigint":function(F,J){return F*J},"Fraction, Fraction":function(F,J){return F.mul(J)},"number | Fraction | BigNumber | Complex, Unit":(F,J)=>J.multiply(F),"Unit, number | Fraction | BigNumber | Complex | Unit":(F,J)=>F.multiply(J)})}),name$258="multiply",dependencies$258=["typed","matrix","addScalar","multiplyScalar","equalScalar","dot"],createMultiply=factory(name$258,dependencies$258,D=>{var{typed:E,matrix:F,addScalar:J,multiplyScalar:$e,equalScalar:_t,dot:lr}=D,mr=createMatAlgo11xS0s({typed:E,equalScalar:_t}),Or=createMatAlgo14xDs({typed:E});function Pr(Ji,ta){switch(Ji.length){case 1:switch(ta.length){case 1:if(Ji[0]!==ta[0])throw RangeError("Dimension mismatch in multiplication. Vectors must have the same length");break;case 2:if(Ji[0]!==ta[0])throw RangeError("Dimension mismatch in multiplication. Vector length ("+Ji[0]+") must match Matrix rows ("+ta[0]+")");break;default:throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has "+ta.length+" dimensions)")}break;case 2:switch(ta.length){case 1:if(Ji[1]!==ta[0])throw RangeError("Dimension mismatch in multiplication. Matrix columns ("+Ji[1]+") must match Vector length ("+ta[0]+")");break;case 2:if(Ji[1]!==ta[0])throw RangeError("Dimension mismatch in multiplication. Matrix A columns ("+Ji[1]+") must match Matrix B rows ("+ta[0]+")");break;default:throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix B has "+ta.length+" dimensions)")}break;default:throw Error("Can only multiply a 1 or 2 dimensional matrix (Matrix A has "+Ji.length+" dimensions)")}}function dn(Ji,ta,na){if(na===0)throw Error("Cannot multiply two empty vectors");return lr(Ji,ta)}function gi(Ji,ta){if(ta.storage()!=="dense")throw Error("Support for SparseMatrix not implemented");return qi(Ji,ta)}function qi(Ji,ta){var na=Ji._data,ra=Ji._size,ia=Ji._datatype||Ji.getDataType(),oa=ta._data,ua=ta._size,sa=ta._datatype||ta.getDataType(),aa=ra[0],pa=ua[1],ma,la=J,ha=$e;ia&&sa&&ia===sa&&typeof ia=="string"&&ia!=="mixed"&&(ma=ia,la=E.find(J,[ma,ma]),ha=E.find($e,[ma,ma]));for(var ga=[],Aa=0;Aa<pa;Aa++){for(var Fa=ha(na[0],oa[0][Aa]),$a=1;$a<aa;$a++)Fa=la(Fa,ha(na[$a],oa[$a][Aa]));ga[Aa]=Fa}return Ji.createDenseMatrix({data:ga,size:[pa],datatype:ia===Ji._datatype&&sa===ta._datatype?ma:void 0})}var zi=E("_multiplyMatrixVector",{"DenseMatrix, any":Qi,"SparseMatrix, any":Xi}),Hi=E("_multiplyMatrixMatrix",{"DenseMatrix, DenseMatrix":Gi,"DenseMatrix, SparseMatrix":Zi,"SparseMatrix, DenseMatrix":Ki,"SparseMatrix, SparseMatrix":ea});function Qi(Ji,ta){var na=Ji._data,ra=Ji._size,ia=Ji._datatype||Ji.getDataType(),oa=ta._data,ua=ta._datatype||ta.getDataType(),sa=ra[0],aa=ra[1],pa,ma=J,la=$e;ia&&ua&&ia===ua&&typeof ia=="string"&&ia!=="mixed"&&(pa=ia,ma=E.find(J,[pa,pa]),la=E.find($e,[pa,pa]));for(var ha=[],ga=0;ga<sa;ga++){for(var Aa=na[ga],Fa=la(Aa[0],oa[0]),$a=1;$a<aa;$a++)Fa=ma(Fa,la(Aa[$a],oa[$a]));ha[ga]=Fa}return Ji.createDenseMatrix({data:ha,size:[sa],datatype:ia===Ji._datatype&&ua===ta._datatype?pa:void 0})}function Gi(Ji,ta){var na=Ji._data,ra=Ji._size,ia=Ji._datatype||Ji.getDataType(),oa=ta._data,ua=ta._size,sa=ta._datatype||ta.getDataType(),aa=ra[0],pa=ra[1],ma=ua[1],la,ha=J,ga=$e;ia&&sa&&ia===sa&&typeof ia=="string"&&ia!=="mixed"&&ia!=="mixed"&&(la=ia,ha=E.find(J,[la,la]),ga=E.find($e,[la,la]));for(var Aa=[],Fa=0;Fa<aa;Fa++){var $a=na[Fa];Aa[Fa]=[];for(var _a=0;_a<ma;_a++){for(var fa=ga($a[0],oa[0][_a]),ka=1;ka<pa;ka++)fa=ha(fa,ga($a[ka],oa[ka][_a]));Aa[Fa][_a]=fa}}return Ji.createDenseMatrix({data:Aa,size:[aa,ma],datatype:ia===Ji._datatype&&sa===ta._datatype?la:void 0})}function Zi(Ji,ta){var na=Ji._data,ra=Ji._size,ia=Ji._datatype||Ji.getDataType(),oa=ta._values,ua=ta._index,sa=ta._ptr,aa=ta._size,pa=ta._datatype||ta._data===void 0?ta._datatype:ta.getDataType();if(!oa)throw Error("Cannot multiply Dense Matrix times Pattern only Matrix");var ma=ra[0],la=aa[1],ha,ga=J,Aa=$e,Fa=_t,$a=0;ia&&pa&&ia===pa&&typeof ia=="string"&&ia!=="mixed"&&(ha=ia,ga=E.find(J,[ha,ha]),Aa=E.find($e,[ha,ha]),Fa=E.find(_t,[ha,ha]),$a=E.convert(0,ha));for(var _a=[],fa=[],ka=[],ba=ta.createSparseMatrix({values:_a,index:fa,ptr:ka,size:[ma,la],datatype:ia===Ji._datatype&&pa===ta._datatype?ha:void 0}),Pa=0;Pa<la;Pa++){ka[Pa]=fa.length;var Ia=sa[Pa],Da=sa[Pa+1];if(Da>Ia)for(var va=0,Ca=0;Ca<ma;Ca++){for(var ya=Ca+1,Na=void 0,za=Ia;za<Da;za++){var Ta=ua[za];va===ya?Na=ga(Na,Aa(na[Ca][Ta],oa[za])):(Na=Aa(na[Ca][Ta],oa[za]),va=ya)}va===ya&&!Fa(Na,$a)&&(fa.push(Ca),_a.push(Na))}}return ka[la]=fa.length,ba}function Xi(Ji,ta){var na=Ji._values,ra=Ji._index,ia=Ji._ptr,oa=Ji._datatype||Ji._data===void 0?Ji._datatype:Ji.getDataType();if(!na)throw Error("Cannot multiply Pattern only Matrix times Dense Matrix");var ua=ta._data,sa=ta._datatype||ta.getDataType(),aa=Ji._size[0],pa=ta._size[0],ma=[],la=[],ha=[],ga,Aa=J,Fa=$e,$a=_t,_a=0;oa&&sa&&oa===sa&&typeof oa=="string"&&oa!=="mixed"&&(ga=oa,Aa=E.find(J,[ga,ga]),Fa=E.find($e,[ga,ga]),$a=E.find(_t,[ga,ga]),_a=E.convert(0,ga));var fa=[],ka=[];ha[0]=0;for(var ba=0;ba<pa;ba++){var Pa=ua[ba];if(!$a(Pa,_a))for(var Ia=ia[ba],Da=ia[ba+1],va=Ia;va<Da;va++){var Ca=ra[va];ka[Ca]?fa[Ca]=Aa(fa[Ca],Fa(Pa,na[va])):(ka[Ca]=!0,la.push(Ca),fa[Ca]=Fa(Pa,na[va]))}}for(var ya=la.length,Na=0;Na<ya;Na++)ma[Na]=fa[la[Na]];return ha[1]=la.length,Ji.createSparseMatrix({values:ma,index:la,ptr:ha,size:[aa,1],datatype:oa===Ji._datatype&&sa===ta._datatype?ga:void 0})}function Ki(Ji,ta){var na=Ji._values,ra=Ji._index,ia=Ji._ptr,oa=Ji._datatype||Ji._data===void 0?Ji._datatype:Ji.getDataType();if(!na)throw Error("Cannot multiply Pattern only Matrix times Dense Matrix");var ua=ta._data,sa=ta._datatype||ta.getDataType(),aa=Ji._size[0],pa=ta._size[0],ma=ta._size[1],la,ha=J,ga=$e,Aa=_t,Fa=0;oa&&sa&&oa===sa&&typeof oa=="string"&&oa!=="mixed"&&(la=oa,ha=E.find(J,[la,la]),ga=E.find($e,[la,la]),Aa=E.find(_t,[la,la]),Fa=E.convert(0,la));for(var $a=[],_a=[],fa=[],ka=Ji.createSparseMatrix({values:$a,index:_a,ptr:fa,size:[aa,ma],datatype:oa===Ji._datatype&&sa===ta._datatype?la:void 0}),ba=[],Pa=[],Ia=0;Ia<ma;Ia++){fa[Ia]=_a.length;for(var Da=Ia+1,va=0;va<pa;va++){var Ca=ua[va][Ia];if(!Aa(Ca,Fa))for(var ya=ia[va],Na=ia[va+1],za=ya;za<Na;za++){var Ta=ra[za];Pa[Ta]===Da?ba[Ta]=ha(ba[Ta],ga(Ca,na[za])):(Pa[Ta]=Da,_a.push(Ta),ba[Ta]=ga(Ca,na[za]))}}for(var es=fa[Ia],ts=_a.length,Ka=es;Ka<ts;Ka++)$a[Ka]=ba[_a[Ka]]}return fa[ma]=_a.length,ka}function ea(Ji,ta){var na=Ji._values,ra=Ji._index,ia=Ji._ptr,oa=Ji._datatype||Ji._data===void 0?Ji._datatype:Ji.getDataType(),ua=ta._values,sa=ta._index,aa=ta._ptr,pa=ta._datatype||ta._data===void 0?ta._datatype:ta.getDataType(),ma=Ji._size[0],la=ta._size[1],ha=na&&ua,ga,Aa=J,Fa=$e;oa&&pa&&oa===pa&&typeof oa=="string"&&oa!=="mixed"&&(ga=oa,Aa=E.find(J,[ga,ga]),Fa=E.find($e,[ga,ga]));for(var $a=ha?[]:void 0,_a=[],fa=[],ka=Ji.createSparseMatrix({values:$a,index:_a,ptr:fa,size:[ma,la],datatype:oa===Ji._datatype&&pa===ta._datatype?ga:void 0}),ba=ha?[]:void 0,Pa=[],Ia,Da,va,Ca,ya,Na,za,Ta,es=0;es<la;es++){fa[es]=_a.length;var ts=es+1;for(ya=aa[es],Na=aa[es+1],Ca=ya;Ca<Na;Ca++)if(Ta=sa[Ca],ha)for(Da=ia[Ta],va=ia[Ta+1],Ia=Da;Ia<va;Ia++)za=ra[Ia],Pa[za]===ts?ba[za]=Aa(ba[za],Fa(ua[Ca],na[Ia])):(Pa[za]=ts,_a.push(za),ba[za]=Fa(ua[Ca],na[Ia]));else for(Da=ia[Ta],va=ia[Ta+1],Ia=Da;Ia<va;Ia++)za=ra[Ia],Pa[za]!==ts&&(Pa[za]=ts,_a.push(za));if(ha)for(var Ka=fa[es],ps=_a.length,cs=Ka;cs<ps;cs++)$a[cs]=ba[_a[cs]]}return fa[la]=_a.length,ka}return E(name$258,$e,{"Array, Array":E.referTo("Matrix, Matrix",Ji=>(ta,na)=>{Pr(arraySize(ta),arraySize(na));var ra=Ji(F(ta),F(na));return isMatrix(ra)?ra.valueOf():ra}),"Matrix, Matrix":function(Ji,ta){var na=Ji.size(),ra=ta.size();return Pr(na,ra),na.length===1?ra.length===1?dn(Ji,ta,na[0]):gi(Ji,ta):ra.length===1?zi(Ji,ta):Hi(Ji,ta)},"Matrix, Array":E.referTo("Matrix,Matrix",Ji=>(ta,na)=>Ji(ta,F(na))),"Array, Matrix":E.referToSelf(Ji=>(ta,na)=>Ji(F(ta,na.storage()),na)),"SparseMatrix, any":function(Ji,ta){return mr(Ji,ta,$e,!1)},"DenseMatrix, any":function(Ji,ta){return Or(Ji,ta,$e,!1)},"any, SparseMatrix":function(Ji,ta){return mr(ta,Ji,$e,!0)},"any, DenseMatrix":function(Ji,ta){return Or(ta,Ji,$e,!0)},"Array, any":function(Ji,ta){return Or(F(Ji),ta,$e,!1).valueOf()},"any, Array":function(Ji,ta){return Or(F(ta),Ji,$e,!0).valueOf()},"any, any":$e,"any, any, ...any":E.referToSelf(Ji=>(ta,na,ra)=>{for(var ia=Ji(ta,na),oa=0;oa<ra.length;oa++)ia=Ji(ia,ra[oa]);return ia})})}),name$257="nthRoot",dependencies$257=["typed","matrix","equalScalar","BigNumber","concat"],createNthRoot=factory(name$257,dependencies$257,D=>{var{typed:E,matrix:F,equalScalar:J,BigNumber:$e,concat:_t}=D,lr=createMatAlgo01xDSid({typed:E}),mr=createMatAlgo02xDS0({typed:E,equalScalar:J}),Or=createMatAlgo06xS0S0({typed:E,equalScalar:J}),Pr=createMatAlgo11xS0s({typed:E,equalScalar:J}),dn=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:_t});function gi(){throw Error("Complex number not supported in function nthRoot. Use nthRoots instead.")}return E(name$257,{number:nthRootNumber,"number, number":nthRootNumber,BigNumber:zi=>qi(zi,new $e(2)),"BigNumber, BigNumber":qi,Complex:gi,"Complex, number":gi,Array:E.referTo("DenseMatrix,number",zi=>Hi=>zi(F(Hi),2).valueOf()),DenseMatrix:E.referTo("DenseMatrix,number",zi=>Hi=>zi(Hi,2)),SparseMatrix:E.referTo("SparseMatrix,number",zi=>Hi=>zi(Hi,2)),"SparseMatrix, SparseMatrix":E.referToSelf(zi=>(Hi,Qi)=>{if(Qi.density()===1)return Or(Hi,Qi,zi);throw Error("Root must be non-zero")}),"DenseMatrix, SparseMatrix":E.referToSelf(zi=>(Hi,Qi)=>{if(Qi.density()===1)return lr(Hi,Qi,zi,!1);throw Error("Root must be non-zero")}),"Array, SparseMatrix":E.referTo("DenseMatrix,SparseMatrix",zi=>(Hi,Qi)=>zi(F(Hi),Qi)),"number | BigNumber, SparseMatrix":E.referToSelf(zi=>(Hi,Qi)=>{if(Qi.density()===1)return Pr(Qi,Hi,zi,!0);throw Error("Root must be non-zero")})},dn({scalar:"number | BigNumber",SD:mr,Ss:Pr,sS:!1}));function qi(zi,Hi){var Qi=$e.precision,Gi=$e.clone({precision:Qi+2}),Zi=new $e(0),Xi=new Gi(1),Ki=Hi.isNegative();if(Ki&&(Hi=Hi.neg()),Hi.isZero())throw Error("Root must be non-zero");if(zi.isNegative()&&!Hi.abs().mod(2).equals(1))throw Error("Root must be odd when a is negative.");if(zi.isZero())return Ki?new Gi(1/0):0;if(!zi.isFinite())return Ki?Zi:zi;var ea=zi.abs().pow(Xi.div(Hi));return ea=zi.isNeg()?ea.neg():ea,new $e((Ki?Xi.div(ea):ea).toPrecision(Qi))}}),name$256="sign",dependencies$256=["typed","BigNumber","Fraction","complex"],createSign=factory(name$256,dependencies$256,D=>{var{typed:E,BigNumber:F,complex:J,Fraction:$e}=D;return E(name$256,{number:signNumber,Complex:function(_t){return _t.im===0?J(signNumber(_t.re)):_t.sign()},BigNumber:function(_t){return new F(_t.cmp(0))},bigint:function(_t){return _t>0n?1n:_t<0n?-1n:0n},Fraction:function(_t){return _t.n===0n?new $e(0):new $e(_t.s)},"Array | Matrix":E.referToSelf(_t=>lr=>deepMap(lr,_t,!0)),Unit:E.referToSelf(_t=>lr=>{if(!lr._isDerived()&&lr.units[0].unit.offset!==0)throw TypeError("sign is ambiguous for units with offset");return E.find(_t,lr.valueType())(lr.value)})})}),name$255="sqrt",dependencies$255=["config","typed","Complex"],createSqrt=factory(name$255,dependencies$255,D=>{var{config:E,typed:F,Complex:J}=D;return F("sqrt",{number:$e,Complex:function(_t){return _t.sqrt()},BigNumber:function(_t){return!_t.isNegative()||E.predictable?_t.sqrt():$e(_t.toNumber())},Unit:function(_t){return _t.pow(.5)}});function $e(_t){return isNaN(_t)?NaN:_t>=0||E.predictable?Math.sqrt(_t):new J(_t,0).sqrt()}}),name$254="square",dependencies$254=["typed"],createSquare=factory(name$254,dependencies$254,D=>{var{typed:E}=D;return E(name$254,{number:squareNumber,Complex:function(F){return F.mul(F)},BigNumber:function(F){return F.times(F)},bigint:function(F){return F*F},Fraction:function(F){return F.mul(F)},Unit:function(F){return F.pow(2)}})}),name$253="subtract",dependencies$253=["typed","matrix","equalScalar","subtractScalar","unaryMinus","DenseMatrix","concat"],createSubtract=factory(name$253,dependencies$253,D=>{var{typed:E,matrix:F,equalScalar:J,subtractScalar:$e,unaryMinus:_t,DenseMatrix:lr,concat:mr}=D,Or=createMatAlgo01xDSid({typed:E}),Pr=createMatAlgo03xDSf({typed:E}),dn=createMatAlgo05xSfSf({typed:E,equalScalar:J}),gi=createMatAlgo10xSids({typed:E,DenseMatrix:lr}),qi=createMatAlgo12xSfs({typed:E,DenseMatrix:lr}),zi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:mr});return E(name$253,{"any, any":$e},zi({elop:$e,SS:dn,DS:Or,SD:Pr,Ss:qi,sS:gi}))}),name$252="xgcd",dependencies$252=["typed","config","matrix","BigNumber"],createXgcd=factory(name$252,dependencies$252,D=>{var{typed:E,config:F,matrix:J,BigNumber:$e}=D;return E(name$252,{"number, number":function(lr,mr){var Or=xgcdNumber(lr,mr);return F.matrix==="Array"?Or:J(Or)},"BigNumber, BigNumber":_t});function _t(lr,mr){var Or,Pr,dn,gi=new $e(0),qi=new $e(1),zi=gi,Hi=qi,Qi=qi,Gi=gi;if(!lr.isInt()||!mr.isInt())throw Error("Parameters in function xgcd must be integer numbers");for(;!mr.isZero();)Pr=lr.div(mr).floor(),dn=lr.mod(mr),Or=zi,zi=Hi.minus(Pr.times(zi)),Hi=Or,Or=Qi,Qi=Gi.minus(Pr.times(Qi)),Gi=Or,lr=mr,mr=dn;var Zi=lr.lt(gi)?[lr.neg(),Hi.neg(),Gi.neg()]:[lr,lr.isZero()?0:Hi,Gi];return F.matrix==="Array"?Zi:J(Zi)}}),name$251="invmod",dependencies$251=["typed","config","BigNumber","xgcd","equal","smaller","mod","add","isInteger"],createInvmod=factory(name$251,dependencies$251,D=>{var{typed:E,config:F,BigNumber:J,xgcd:$e,equal:_t,smaller:lr,mod:mr,add:Or,isInteger:Pr}=D;return E(name$251,{"number, number":dn,"BigNumber, BigNumber":dn});function dn(gi,qi){if(!Pr(gi)||!Pr(qi))throw Error("Parameters in function invmod must be integer numbers");if(gi=mr(gi,qi),_t(qi,0))throw Error("Divisor must be non zero");var zi=$e(gi,qi);zi=zi.valueOf();var[Hi,Qi]=zi;return _t(Hi,J(1))?(Qi=mr(Qi,qi),lr(Qi,J(0))&&(Qi=Or(Qi,qi)),Qi):NaN}}),name$250="matAlgo09xS0Sf",dependencies$250=["typed","equalScalar"],createMatAlgo09xS0Sf=factory(name$250,dependencies$250,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t){var lr=J._values,mr=J._index,Or=J._ptr,Pr=J._size,dn=J._datatype||J._data===void 0?J._datatype:J.getDataType(),gi=$e._values,qi=$e._index,zi=$e._ptr,Hi=$e._size,Qi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(Pr.length!==Hi.length)throw new DimensionError(Pr.length,Hi.length);if(Pr[0]!==Hi[0]||Pr[1]!==Hi[1])throw RangeError("Dimension mismatch. Matrix A ("+Pr+") must match Matrix B ("+Hi+")");var Gi=Pr[0],Zi=Pr[1],Xi,Ki=F,ea=0,Ji=_t;typeof dn=="string"&&dn===Qi&&dn!=="mixed"&&(Xi=dn,Ki=E.find(F,[Xi,Xi]),ea=E.convert(0,Xi),Ji=E.find(_t,[Xi,Xi]));var ta=lr&&gi?[]:void 0,na=[],ra=[],ia=ta?[]:void 0,oa=[],ua,sa,aa,pa,ma;for(sa=0;sa<Zi;sa++){ra[sa]=na.length;var la=sa+1;if(ia)for(pa=zi[sa],ma=zi[sa+1],aa=pa;aa<ma;aa++)ua=qi[aa],oa[ua]=la,ia[ua]=gi[aa];for(pa=Or[sa],ma=Or[sa+1],aa=pa;aa<ma;aa++)if(ua=mr[aa],ia){var ha=oa[ua]===la?ia[ua]:ea,ga=Ji(lr[aa],ha);Ki(ga,ea)||(na.push(ua),ta.push(ga))}else na.push(ua)}return ra[Zi]=na.length,J.createSparseMatrix({values:ta,index:na,ptr:ra,size:[Gi,Zi],datatype:dn===J._datatype&&Qi===$e._datatype?Xi:void 0})}}),name$249="dotMultiply",dependencies$249=["typed","matrix","equalScalar","multiplyScalar","concat"],createDotMultiply=factory(name$249,dependencies$249,D=>{var{typed:E,matrix:F,equalScalar:J,multiplyScalar:$e,concat:_t}=D,lr=createMatAlgo02xDS0({typed:E,equalScalar:J}),mr=createMatAlgo09xS0Sf({typed:E,equalScalar:J}),Or=createMatAlgo11xS0s({typed:E,equalScalar:J});return E(name$249,createMatrixAlgorithmSuite({typed:E,matrix:F,concat:_t})({elop:$e,SS:mr,DS:lr,Ss:Or}))});function bitAndBigNumber(D,E){if(D.isFinite()&&!D.isInteger()||E.isFinite()&&!E.isInteger())throw Error("Integers expected in function bitAnd");var F=D.constructor;if(D.isNaN()||E.isNaN())return new F(NaN);if(D.isZero()||E.eq(-1)||D.eq(E))return D;if(E.isZero()||D.eq(-1))return E;if(!D.isFinite()||!E.isFinite()){if(!D.isFinite()&&!E.isFinite())return D.isNegative()===E.isNegative()?D:new F(0);if(!D.isFinite())return E.isNegative()?D:D.isNegative()?new F(0):E;if(!E.isFinite())return D.isNegative()?E:E.isNegative()?new F(0):D}return bitwise(D,E,function(J,$e){return J&$e})}function bitNotBigNumber(D){if(D.isFinite()&&!D.isInteger())throw Error("Integer expected in function bitNot");var E=D.constructor,F=E.precision;E.config({precision:1e9});var J=D.plus(new E(1));return J.s=-J.s||null,E.config({precision:F}),J}function bitOrBigNumber(D,E){if(D.isFinite()&&!D.isInteger()||E.isFinite()&&!E.isInteger())throw Error("Integers expected in function bitOr");var F=D.constructor;if(D.isNaN()||E.isNaN())return new F(NaN);var J=new F(-1);return D.isZero()||E.eq(J)||D.eq(E)?E:E.isZero()||D.eq(J)?D:!D.isFinite()||!E.isFinite()?!D.isFinite()&&!D.isNegative()&&E.isNegative()||D.isNegative()&&!E.isNegative()&&!E.isFinite()?J:D.isNegative()&&E.isNegative()?D.isFinite()?D:E:D.isFinite()?E:D:bitwise(D,E,function($e,_t){return $e|_t})}function bitwise(D,E,F){var J=D.constructor,$e,_t,lr=+(D.s<0),mr=+(E.s<0);if(lr){$e=decCoefficientToBinaryString(bitNotBigNumber(D));for(var Or=0;Or<$e.length;++Or)$e[Or]^=1}else $e=decCoefficientToBinaryString(D);if(mr){_t=decCoefficientToBinaryString(bitNotBigNumber(E));for(var Pr=0;Pr<_t.length;++Pr)_t[Pr]^=1}else _t=decCoefficientToBinaryString(E);var dn,gi,qi;$e.length<=_t.length?(dn=$e,gi=_t,qi=lr):(dn=_t,gi=$e,qi=mr);var zi=dn.length,Hi=gi.length,Qi=F(lr,mr)^1,Gi=new J(Qi^1),Zi=new J(1),Xi=new J(2),Ki=J.precision;for(J.config({precision:1e9});zi>0;)F(dn[--zi],gi[--Hi])===Qi&&(Gi=Gi.plus(Zi)),Zi=Zi.times(Xi);for(;Hi>0;)F(qi,gi[--Hi])===Qi&&(Gi=Gi.plus(Zi)),Zi=Zi.times(Xi);return J.config({precision:Ki}),Qi===0&&(Gi.s=-Gi.s),Gi}function decCoefficientToBinaryString(D){for(var E=D.d,F=E[0]+"",J=1;J<E.length;++J){for(var $e=E[J]+"",_t=7-$e.length;_t--;)$e="0"+$e;F+=$e}for(var lr=F.length;F.charAt(lr)==="0";)lr--;var mr=D.e,Or=F.slice(0,lr+1||1),Pr=Or.length;if(mr>0)if(++mr>Pr)for(mr-=Pr;mr--;)Or+="0";else mr<Pr&&(Or=Or.slice(0,mr)+"."+Or.slice(mr));for(var dn=[0],gi=0;gi<Or.length;){for(var qi=dn.length;qi--;)dn[qi]*=10;dn[0]+=parseInt(Or.charAt(gi++));for(var zi=0;zi<dn.length;++zi)dn[zi]>1&&((dn[zi+1]===null||dn[zi+1]===void 0)&&(dn[zi+1]=0),dn[zi+1]+=dn[zi]>>1,dn[zi]&=1)}return dn.reverse()}function bitXor(D,E){if(D.isFinite()&&!D.isInteger()||E.isFinite()&&!E.isInteger())throw Error("Integers expected in function bitXor");var F=D.constructor;if(D.isNaN()||E.isNaN())return new F(NaN);if(D.isZero())return E;if(E.isZero())return D;if(D.eq(E))return new F(0);var J=new F(-1);return D.eq(J)?bitNotBigNumber(E):E.eq(J)?bitNotBigNumber(D):!D.isFinite()||!E.isFinite()?!D.isFinite()&&!E.isFinite()?J:new F(D.isNegative()===E.isNegative()?1/0:-1/0):bitwise(D,E,function($e,_t){return $e^_t})}function leftShiftBigNumber(D,E){if(D.isFinite()&&!D.isInteger()||E.isFinite()&&!E.isInteger())throw Error("Integers expected in function leftShift");var F=D.constructor;return D.isNaN()||E.isNaN()||E.isNegative()&&!E.isZero()?new F(NaN):D.isZero()||E.isZero()?D:!D.isFinite()&&!E.isFinite()?new F(NaN):E.lt(55)?D.times(2**E.toNumber()+""):D.times(new F(2).pow(E))}function rightArithShiftBigNumber(D,E){if(D.isFinite()&&!D.isInteger()||E.isFinite()&&!E.isInteger())throw Error("Integers expected in function rightArithShift");var F=D.constructor;return D.isNaN()||E.isNaN()||E.isNegative()&&!E.isZero()?new F(NaN):D.isZero()||E.isZero()?D:E.isFinite()?E.lt(55)?D.div(2**E.toNumber()+"").floor():D.div(new F(2).pow(E)).floor():D.isNegative()?new F(-1):D.isFinite()?new F(0):new F(NaN)}var name$248="bitAnd",dependencies$248=["typed","matrix","equalScalar","concat"],createBitAnd=factory(name$248,dependencies$248,D=>{var{typed:E,matrix:F,equalScalar:J,concat:$e}=D,_t=createMatAlgo02xDS0({typed:E,equalScalar:J}),lr=createMatAlgo06xS0S0({typed:E,equalScalar:J}),mr=createMatAlgo11xS0s({typed:E,equalScalar:J}),Or=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:$e});return E(name$248,{"number, number":bitAndNumber,"BigNumber, BigNumber":bitAndBigNumber,"bigint, bigint":(Pr,dn)=>Pr&dn},Or({SS:lr,DS:_t,Ss:mr}))}),name$247="bitNot",dependencies$247=["typed"],createBitNot=factory(name$247,dependencies$247,D=>{var{typed:E}=D;return E(name$247,{number:bitNotNumber,BigNumber:bitNotBigNumber,bigint:F=>~F,"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$246="bitOr",dependencies$246=["typed","matrix","equalScalar","DenseMatrix","concat"],createBitOr=factory(name$246,dependencies$246,D=>{var{typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t}=D,lr=createMatAlgo01xDSid({typed:E}),mr=createMatAlgo04xSidSid({typed:E,equalScalar:J}),Or=createMatAlgo10xSids({typed:E,DenseMatrix:$e}),Pr=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:_t});return E(name$246,{"number, number":bitOrNumber,"BigNumber, BigNumber":bitOrBigNumber,"bigint, bigint":(dn,gi)=>dn|gi},Pr({SS:mr,DS:lr,Ss:Or}))}),name$245="matAlgo07xSSf",dependencies$245=["typed","SparseMatrix"],createMatAlgo07xSSf=factory(name$245,dependencies$245,D=>{var{typed:E,SparseMatrix:F}=D;return function($e,_t,lr){var mr=$e._size,Or=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType(),Pr=_t._size,dn=_t._datatype||_t._data===void 0?_t._datatype:_t.getDataType();if(mr.length!==Pr.length)throw new DimensionError(mr.length,Pr.length);if(mr[0]!==Pr[0]||mr[1]!==Pr[1])throw RangeError("Dimension mismatch. Matrix A ("+mr+") must match Matrix B ("+Pr+")");var gi=mr[0],qi=mr[1],zi,Hi=0,Qi=lr;typeof Or=="string"&&Or===dn&&Or!=="mixed"&&(zi=Or,Hi=E.convert(0,zi),Qi=E.find(lr,[zi,zi]));for(var Gi=[],Zi=[],Xi=Array(qi+1).fill(0),Ki=[],ea=[],Ji=[],ta=[],na=0;na<qi;na++){var ra=na+1,ia=0;J($e,na,Ji,Ki,ra),J(_t,na,ta,ea,ra);for(var oa=0;oa<gi;oa++){var ua=Ji[oa]===ra?Ki[oa]:Hi,sa=ta[oa]===ra?ea[oa]:Hi,aa=Qi(ua,sa);aa!==0&&aa!==!1&&(Zi.push(oa),Gi.push(aa),ia++)}Xi[na+1]=Xi[na]+ia}return new F({values:Gi,index:Zi,ptr:Xi,size:[gi,qi],datatype:Or===$e._datatype&&dn===_t._datatype?zi:void 0})};function J($e,_t,lr,mr,Or){for(var Pr=$e._values,dn=$e._index,gi=$e._ptr,qi=gi[_t],zi=gi[_t+1];qi<zi;qi++){var Hi=dn[qi];lr[Hi]=Or,mr[Hi]=Pr[qi]}}}),name$244="bitXor",dependencies$244=["typed","matrix","DenseMatrix","concat","SparseMatrix"],createBitXor=factory(name$244,dependencies$244,D=>{var{typed:E,matrix:F,DenseMatrix:J,concat:$e,SparseMatrix:_t}=D,lr=createMatAlgo03xDSf({typed:E}),mr=createMatAlgo07xSSf({typed:E,SparseMatrix:_t}),Or=createMatAlgo12xSfs({typed:E,DenseMatrix:J}),Pr=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:$e});return E(name$244,{"number, number":bitXorNumber,"BigNumber, BigNumber":bitXor,"bigint, bigint":(dn,gi)=>dn^gi},Pr({SS:mr,DS:lr,Ss:Or}))}),name$243="arg",dependencies$243=["typed"],createArg=factory(name$243,dependencies$243,D=>{var{typed:E}=D;return E(name$243,{number:function(F){return Math.atan2(0,F)},BigNumber:function(F){return F.constructor.atan2(0,F)},Complex:function(F){return F.arg()},"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$242="conj",dependencies$242=["typed"],createConj=factory(name$242,dependencies$242,D=>{var{typed:E}=D;return E(name$242,{"number | BigNumber | Fraction":F=>F,Complex:F=>F.conjugate(),Unit:E.referToSelf(F=>J=>new J.constructor(F(J.toNumeric()),J.formatUnits())),"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$241="im",dependencies$241=["typed"],createIm=factory(name$241,dependencies$241,D=>{var{typed:E}=D;return E(name$241,{number:()=>0,"BigNumber | Fraction":F=>F.mul(0),Complex:F=>F.im,"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$240="re",dependencies$240=["typed"],createRe=factory(name$240,dependencies$240,D=>{var{typed:E}=D;return E(name$240,{"number | BigNumber | Fraction":F=>F,Complex:F=>F.re,"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$239="not",dependencies$239=["typed"],createNot=factory(name$239,dependencies$239,D=>{var{typed:E}=D;return E(name$239,{"null | undefined":()=>!0,number:notNumber,Complex:function(F){return F.re===0&&F.im===0},BigNumber:function(F){return F.isZero()||F.isNaN()},bigint:F=>!F,Unit:E.referToSelf(F=>J=>E.find(F,J.valueType())(J.value)),"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$238="nullish",dependencies$238=["typed","matrix","size","flatten","deepEqual"],createNullish=factory(name$238,dependencies$238,D=>{var{typed:E,matrix:F,size:J,flatten:$e,deepEqual:_t}=D,lr=createMatAlgo03xDSf({typed:E}),mr=createMatAlgo14xDs({typed:E}),Or=createMatAlgo13xDD({typed:E});return E(name$238,{"number|bigint|Complex|BigNumber|Fraction|Unit|string|boolean|SparseMatrix, any":(Pr,dn)=>Pr,"null, any":(Pr,dn)=>dn,"undefined, any":(Pr,dn)=>dn,"SparseMatrix, Array | Matrix":(Pr,dn)=>{var gi=J(Pr),qi=J(dn);if(_t(gi,qi))return Pr;throw new DimensionError(gi,qi)},"DenseMatrix, DenseMatrix":E.referToSelf(Pr=>(dn,gi)=>Or(dn,gi,Pr)),"DenseMatrix, SparseMatrix":E.referToSelf(Pr=>(dn,gi)=>lr(dn,gi,Pr,!1)),"DenseMatrix, Array":E.referToSelf(Pr=>(dn,gi)=>Or(dn,F(gi),Pr)),"DenseMatrix, any":E.referToSelf(Pr=>(dn,gi)=>mr(dn,gi,Pr,!1)),"Array, Array":E.referToSelf(Pr=>(dn,gi)=>Or(F(dn),F(gi),Pr).valueOf()),"Array, DenseMatrix":E.referToSelf(Pr=>(dn,gi)=>Or(F(dn),gi,Pr)),"Array, SparseMatrix":E.referToSelf(Pr=>(dn,gi)=>lr(F(dn),gi,Pr,!1)),"Array, any":E.referToSelf(Pr=>(dn,gi)=>mr(F(dn),gi,Pr,!1).valueOf())})}),name$237="or",dependencies$237=["typed","matrix","equalScalar","DenseMatrix","concat"],createOr=factory(name$237,dependencies$237,D=>{var{typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t}=D,lr=createMatAlgo03xDSf({typed:E}),mr=createMatAlgo05xSfSf({typed:E,equalScalar:J}),Or=createMatAlgo12xSfs({typed:E,DenseMatrix:$e}),Pr=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:_t});return E(name$237,{"number, number":orNumber,"Complex, Complex":function(dn,gi){return dn.re!==0||dn.im!==0||gi.re!==0||gi.im!==0},"BigNumber, BigNumber":function(dn,gi){return!dn.isZero()&&!dn.isNaN()||!gi.isZero()&&!gi.isNaN()},"bigint, bigint":orNumber,"Unit, Unit":E.referToSelf(dn=>(gi,qi)=>dn(gi.value||0,qi.value||0))},Pr({SS:mr,DS:lr,Ss:Or}))}),name$236="xor",dependencies$236=["typed","matrix","DenseMatrix","concat","SparseMatrix"],createXor=factory(name$236,dependencies$236,D=>{var{typed:E,matrix:F,DenseMatrix:J,concat:$e,SparseMatrix:_t}=D,lr=createMatAlgo03xDSf({typed:E}),mr=createMatAlgo07xSSf({typed:E,SparseMatrix:_t}),Or=createMatAlgo12xSfs({typed:E,DenseMatrix:J}),Pr=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:$e});return E(name$236,{"number, number":xorNumber,"Complex, Complex":function(dn,gi){return(dn.re!==0||dn.im!==0)!=(gi.re!==0||gi.im!==0)},"bigint, bigint":xorNumber,"BigNumber, BigNumber":function(dn,gi){return(!dn.isZero()&&!dn.isNaN())!=(!gi.isZero()&&!gi.isNaN())},"Unit, Unit":E.referToSelf(dn=>(gi,qi)=>dn(gi.value||0,qi.value||0))},Pr({SS:mr,DS:lr,Ss:Or}))}),name$235="concat",dependencies$235=["typed","matrix","isInteger"],createConcat=factory(name$235,dependencies$235,D=>{var{typed:E,matrix:F,isInteger:J}=D;return E(name$235,{"...Array | Matrix | number | BigNumber":function($e){var _t,lr=$e.length,mr=-1,Or,Pr=!1,dn=[];for(_t=0;_t<lr;_t++){var gi=$e[_t];if(isMatrix(gi)&&(Pr=!0),isNumber(gi)||isBigNumber(gi)){if(_t!==lr-1)throw Error("Dimension must be specified as last argument");if(Or=mr,mr=gi.valueOf(),!J(mr))throw TypeError("Integer number expected for dimension");if(mr<0||_t>0&&mr>Or)throw new IndexError(mr,Or+1)}else{var qi=clone$3(gi).valueOf(),zi=arraySize(qi);if(dn[_t]=qi,Or=mr,mr=zi.length-1,_t>0&&mr!==Or)throw new DimensionError(Or+1,mr+1)}}if(dn.length===0)throw SyntaxError("At least one matrix expected");for(var Hi=dn.shift();dn.length;)Hi=concat(Hi,dn.shift(),mr);return Pr?F(Hi):Hi},"...string":function($e){return $e.join("")}})}),name$234="column",dependencies$234=["typed","Index","matrix","range"],createColumn=factory(name$234,dependencies$234,D=>{var{typed:E,Index:F,matrix:J,range:$e}=D;return E(name$234,{"Matrix, number":_t,"Array, number":function(lr,mr){return _t(J(clone$3(lr)),mr).valueOf()}});function _t(lr,mr){if(lr.size().length!==2)throw Error("Only two dimensional matrix is supported");validateIndex(mr,lr.size()[1]);var Or=new F($e(0,lr.size()[0]),[mr]),Pr=lr.subset(Or);return isMatrix(Pr)?Pr:J([[Pr]])}}),name$233="count",dependencies$233=["typed","size","prod"],createCount=factory(name$233,dependencies$233,D=>{var{typed:E,size:F,prod:J}=D;return E(name$233,{string:function($e){return $e.length},"Matrix | Array":function($e){return J(F($e))}})}),name$232="cross",dependencies$232=["typed","matrix","subtract","multiply"],createCross=factory(name$232,dependencies$232,D=>{var{typed:E,matrix:F,subtract:J,multiply:$e}=D;return E(name$232,{"Matrix, Matrix":function(lr,mr){return F(_t(lr.toArray(),mr.toArray()))},"Matrix, Array":function(lr,mr){return F(_t(lr.toArray(),mr))},"Array, Matrix":function(lr,mr){return F(_t(lr,mr.toArray()))},"Array, Array":_t});function _t(lr,mr){var Or=Math.max(arraySize(lr).length,arraySize(mr).length);lr=squeeze(lr),mr=squeeze(mr);var Pr=arraySize(lr),dn=arraySize(mr);if(Pr.length!==1||dn.length!==1||Pr[0]!==3||dn[0]!==3)throw RangeError("Vectors with length 3 expected (Size A = ["+Pr.join(", ")+"], B = ["+dn.join(", ")+"])");var gi=[J($e(lr[1],mr[2]),$e(lr[2],mr[1])),J($e(lr[2],mr[0]),$e(lr[0],mr[2])),J($e(lr[0],mr[1]),$e(lr[1],mr[0]))];return Or>1?[gi]:gi}}),name$231="diag",dependencies$231=["typed","matrix","DenseMatrix","SparseMatrix"],createDiag=factory(name$231,dependencies$231,D=>{var{typed:E,matrix:F,DenseMatrix:J,SparseMatrix:$e}=D;return E(name$231,{Array:function(Or){return _t(Or,0,arraySize(Or),null)},"Array, number":function(Or,Pr){return _t(Or,Pr,arraySize(Or),null)},"Array, BigNumber":function(Or,Pr){return _t(Or,Pr.toNumber(),arraySize(Or),null)},"Array, string":function(Or,Pr){return _t(Or,0,arraySize(Or),Pr)},"Array, number, string":function(Or,Pr,dn){return _t(Or,Pr,arraySize(Or),dn)},"Array, BigNumber, string":function(Or,Pr,dn){return _t(Or,Pr.toNumber(),arraySize(Or),dn)},Matrix:function(Or){return _t(Or,0,Or.size(),Or.storage())},"Matrix, number":function(Or,Pr){return _t(Or,Pr,Or.size(),Or.storage())},"Matrix, BigNumber":function(Or,Pr){return _t(Or,Pr.toNumber(),Or.size(),Or.storage())},"Matrix, string":function(Or,Pr){return _t(Or,0,Or.size(),Pr)},"Matrix, number, string":function(Or,Pr,dn){return _t(Or,Pr,Or.size(),dn)},"Matrix, BigNumber, string":function(Or,Pr,dn){return _t(Or,Pr.toNumber(),Or.size(),dn)}});function _t(Or,Pr,dn,gi){if(!isInteger(Pr))throw TypeError("Second parameter in function diag must be an integer");var qi=Pr>0?Pr:0,zi=Pr<0?-Pr:0;switch(dn.length){case 1:return lr(Or,Pr,gi,dn[0],zi,qi);case 2:return mr(Or,Pr,gi,dn,zi,qi)}throw RangeError("Matrix for function diag must be 2 dimensional")}function lr(Or,Pr,dn,gi,qi,zi){var Hi=[gi+qi,gi+zi];if(dn&&dn!=="sparse"&&dn!=="dense")throw TypeError(`Unknown matrix type ${dn}"`);var Qi=dn==="sparse"?$e.diagonal(Hi,Or,Pr):J.diagonal(Hi,Or,Pr);return dn===null?Qi.valueOf():Qi}function mr(Or,Pr,dn,gi,qi,zi){if(isMatrix(Or)){var Hi=Or.diagonal(Pr);return dn===null?Hi.valueOf():dn===Hi.storage()?Hi:F(Hi,dn)}for(var Qi=Math.min(gi[0]-qi,gi[1]-zi),Gi=[],Zi=0;Zi<Qi;Zi++)Gi[Zi]=Or[Zi+qi][Zi+zi];return dn===null?Gi:F(Gi)}}),name$230="filter",dependencies$230=["typed"],createFilter=factory(name$230,dependencies$230,D=>{var{typed:E}=D;return E("filter",{"Array, function":_filterCallback,"Matrix, function":function(F,J){return F.create(_filterCallback(F.valueOf(),J),F.datatype())},"Array, RegExp":filterRegExp,"Matrix, RegExp":function(F,J){return F.create(filterRegExp(F.valueOf(),J),F.datatype())}})});function _filterCallback(D,E){var F=optimizeCallback(E,D,"filter");return F.isUnary?filter$1(D,F.fn):filter$1(D,function(J,$e,_t){return F.fn(J,[$e],_t)})}var name$229="flatten",dependencies$229=["typed"],createFlatten=factory(name$229,dependencies$229,D=>{var{typed:E}=D;return E(name$229,{Array:function(F){return flatten$4(F)},DenseMatrix:function(F){return F.create(flatten$4(F.valueOf(),!0),F.datatype())},SparseMatrix:function(F){throw TypeError("SparseMatrix is not supported by function flatten because it does not support 1D vectors. Convert to a DenseMatrix or Array first. Example: flatten(x.toArray())")}})}),name$228="forEach",dependencies$228=["typed"],createForEach=factory(name$228,dependencies$228,D=>{var{typed:E}=D;return E(name$228,{"Array, function":_forEach,"Matrix, function":function(F,J){F.forEach(J)}})});function _forEach(D,E){var F=optimizeCallback(E,D,name$228);deepForEach$1(D,F.fn,F.isUnary)}var name$227="getMatrixDataType",dependencies$227=["typed"],createGetMatrixDataType=factory(name$227,dependencies$227,D=>{var{typed:E}=D;return E(name$227,{Array:function(F){return getArrayDataType(F,typeOf)},Matrix:function(F){return F.getDataType()}})}),name$226="identity",dependencies$226=["typed","config","matrix","BigNumber","DenseMatrix","SparseMatrix"],createIdentity=factory(name$226,dependencies$226,D=>{var{typed:E,config:F,matrix:J,BigNumber:$e,DenseMatrix:_t,SparseMatrix:lr}=D;return E(name$226,{"":function(){return F.matrix==="Matrix"?J([]):[]},string:function(Pr){return J(Pr)},"number | BigNumber":function(Pr){return Or(Pr,Pr,F.matrix==="Matrix"?"dense":void 0)},"number | BigNumber, string":function(Pr,dn){return Or(Pr,Pr,dn)},"number | BigNumber, number | BigNumber":function(Pr,dn){return Or(Pr,dn,F.matrix==="Matrix"?"dense":void 0)},"number | BigNumber, number | BigNumber, string":function(Pr,dn,gi){return Or(Pr,dn,gi)},Array:function(Pr){return mr(Pr)},"Array, string":function(Pr,dn){return mr(Pr,dn)},Matrix:function(Pr){return mr(Pr.valueOf(),Pr.storage())},"Matrix, string":function(Pr,dn){return mr(Pr.valueOf(),dn)}});function mr(Pr,dn){switch(Pr.length){case 0:return dn?J(dn):[];case 1:return Or(Pr[0],Pr[0],dn);case 2:return Or(Pr[0],Pr[1],dn);default:throw Error("Vector containing two values expected")}}function Or(Pr,dn,gi){var qi=isBigNumber(Pr)||isBigNumber(dn)?$e:null;if(isBigNumber(Pr)&&(Pr=Pr.toNumber()),isBigNumber(dn)&&(dn=dn.toNumber()),!isInteger(Pr)||Pr<1||!isInteger(dn)||dn<1)throw Error("Parameters in function identity must be positive integers");var zi=qi?new $e(1):1,Hi=qi?new qi(0):0,Qi=[Pr,dn];if(gi){if(gi==="sparse")return lr.diagonal(Qi,zi,0,Hi);if(gi==="dense")return _t.diagonal(Qi,zi,0,Hi);throw TypeError(`Unknown matrix type "${gi}"`)}for(var Gi=resize([],Qi,Hi),Zi=Pr<dn?Pr:dn,Xi=0;Xi<Zi;Xi++)Gi[Xi][Xi]=zi;return Gi}}),name$225="kron",dependencies$225=["typed","matrix","multiplyScalar"],createKron=factory(name$225,dependencies$225,D=>{var{typed:E,matrix:F,multiplyScalar:J}=D;return E(name$225,{"Matrix, Matrix":function(lr,mr){return F(_t(lr.toArray(),mr.toArray()))},"Matrix, Array":function(lr,mr){return F(_t(lr.toArray(),mr))},"Array, Matrix":function(lr,mr){return F(_t(lr,mr.toArray()))},"Array, Array":_t});function $e(lr,mr){return lr.flatMap(Or=>mr.map(Pr=>J(Or,Pr)))}function _t(lr,mr){var Or=arguments.length>2&&arguments[2]!==void 0?arguments[2]:-1;if(Or<0){var Pr=arraySize(lr).length,dn=arraySize(mr).length;for(Or=Math.max(Pr,dn);Pr++<Or;)lr=[lr];for(;dn++<Or;)mr=[mr]}return Or===1?$e(lr,mr):lr.flatMap(gi=>mr.map(qi=>_t(gi,qi,Or-1)))}}),name$224="map",dependencies$224=["typed"],createMap=factory(name$224,dependencies$224,D=>{var{typed:E}=D;return E(name$224,{"Array, function":mr,"Matrix, function":function(Or,Pr){return Or.map(Pr)},"Array|Matrix, Array|Matrix, ...Array|Matrix|function":(Or,Pr,dn)=>F([Or,Pr,...dn.slice(0,dn.length-1)],dn[dn.length-1])});function F(Or,Pr){if(typeof Pr!="function")throw Error("Last argument must be a callback function");var dn=Or[0].isMatrix,gi=Or.map(ea=>ea.isMatrix?ea.size():arraySize(ea)),qi=broadcastSizes(...gi),zi=Or.length,Hi=dn?(ea,Ji)=>ea.get(Ji):get$1,Qi=Or.map((ea,Ji)=>{var ta=gi[Ji].map(()=>0);return ea.isMatrix?ea.get(ta):get$1(ea,ta)}),Gi=E.isTypedFunction(Pr)?lr(Pr,Qi,qi.map(()=>0),Or):_t(Pr,zi);if(Gi<2)return J(Or,$e(Gi,Pr,null));var Zi=dn?Or.map(ea=>ea.isMatrix?ea.create(broadcastTo(ea.toArray(),qi),ea.datatype()):Or[0].create(broadcastTo(ea.valueOf(),qi))):Or.map(ea=>ea.isMatrix?broadcastTo(ea.toArray(),qi):broadcastTo(ea,qi)),Xi=$e(Gi,Pr,Zi),Ki=(ea,Ji)=>Xi([ea,...Zi.slice(1).map(ta=>Hi(ta,Ji))],Ji);return dn?Zi[0].map(Ki):mr(Zi[0],Ki)}function J(Or,Pr){var dn=Or[0],gi=Or.map(ea=>ea.isMatrix?ea.valueOf():ea),qi=Or.map(ea=>ea.isMatrix?ea.size():arraySize(ea)),zi=broadcastSizes(...qi),Hi=qi.map(ea=>zi.length-ea.length),Qi=zi.length-1,Gi=Pr.length>1?[]:null,Zi=Ki(gi,0);if(dn.isMatrix){var Xi=dn.create();return Xi._data=Zi,Xi._size=zi,Xi}else return Zi;function Ki(ea){var Ji=arguments.length>1&&arguments[1]!==void 0?arguments[1]:0,ta=zi[Ji],na=Array(ta);if(Ji<Qi)for(var ra=function(sa){Gi&&(Gi[Ji]=sa),na[sa]=Ki(ea.map((aa,pa)=>Hi[pa]>Ji?aa:aa.length===1?aa[0]:aa[sa]),Ji+1)},ia=0;ia<ta;ia++)ra(ia);else for(var oa=function(sa){Gi&&(Gi[Ji]=sa),na[sa]=Pr(ea.map(aa=>aa.length===1?aa[0]:aa[sa]),Gi?Gi.slice():void 0)},ua=0;ua<ta;ua++)oa(ua);return na}}function $e(Or,Pr,dn){switch(Or){case 0:return gi=>Pr(...gi);case 1:return(gi,qi)=>Pr(...gi,qi);case 2:return(gi,qi)=>Pr(...gi,qi,...dn)}}function _t(Or,Pr){var dn=Or.toString();if(/arguments/.test(dn))return 2;var gi=dn.match(/\\(.*?\\)/);return/\\.\\.\\./.test(gi)||Or.length>Pr+1?2:+(Or.length===Pr+1)}function lr(Or,Pr,dn,gi){return E.resolve(Or,[...Pr,dn,...gi])===null?E.resolve(Or,[...Pr,dn])===null?(E.resolve(Or,Pr),0):1:2}function mr(Or,Pr){var dn=optimizeCallback(Pr,Or,name$224);return deepMap$1(Or,dn.fn,dn.isUnary)}}),name$223="diff",dependencies$223=["typed","matrix","subtract","number"],createDiff=factory(name$223,dependencies$223,D=>{var{typed:E,matrix:F,subtract:J,number:$e}=D;return E(name$223,{"Array | Matrix":function(Pr){return isMatrix(Pr)?F(lr(Pr.toArray())):lr(Pr)},"Array | Matrix, number":function(Pr,dn){if(!isInteger(dn))throw RangeError("Dimension must be a whole number");return isMatrix(Pr)?F(_t(Pr.toArray(),dn)):_t(Pr,dn)},"Array, BigNumber":E.referTo("Array,number",Pr=>(dn,gi)=>Pr(dn,$e(gi))),"Matrix, BigNumber":E.referTo("Matrix,number",Pr=>(dn,gi)=>Pr(dn,$e(gi)))});function _t(Pr,dn){if(isMatrix(Pr)&&(Pr=Pr.toArray()),!Array.isArray(Pr))throw RangeError("Array/Matrix does not have that many dimensions");if(dn>0){var gi=[];return Pr.forEach(qi=>{gi.push(_t(qi,dn-1))}),gi}else{if(dn===0)return lr(Pr);throw RangeError("Cannot have negative dimension")}}function lr(Pr){for(var dn=[],gi=Pr.length,qi=1;qi<gi;qi++)dn.push(mr(Pr[qi-1],Pr[qi]));return dn}function mr(Pr,dn){isMatrix(Pr)&&(Pr=Pr.toArray()),isMatrix(dn)&&(dn=dn.toArray());var gi=Array.isArray(Pr),qi=Array.isArray(dn);if(gi&&qi)return Or(Pr,dn);if(!gi&&!qi)return J(dn,Pr);throw TypeError("Cannot calculate difference between 1 array and 1 non-array")}function Or(Pr,dn){if(Pr.length!==dn.length)throw RangeError("Not all sub-arrays have the same length");for(var gi=[],qi=Pr.length,zi=0;zi<qi;zi++)gi.push(mr(Pr[zi],dn[zi]));return gi}}),name$222="ones",dependencies$222=["typed","config","matrix","BigNumber"],createOnes=factory(name$222,dependencies$222,D=>{var{typed:E,config:F,matrix:J,BigNumber:$e}=D;return E("ones",{"":function(){return F.matrix==="Array"?_t([]):_t([],"default")},"...number | BigNumber | string":function(Or){return typeof Or[Or.length-1]=="string"?_t(Or,Or.pop()):F.matrix==="Array"?_t(Or):_t(Or,"default")},Array:_t,Matrix:function(Or){var Pr=Or.storage();return _t(Or.valueOf(),Pr)},"Array | Matrix, string":function(Or,Pr){return _t(Or.valueOf(),Pr)}});function _t(Or,Pr){var dn=lr(Or)?new $e(1):1;if(mr(Or),Pr){var gi=J(Pr);return Or.length>0?gi.resize(Or,dn):gi}else{var qi=[];return Or.length>0?resize(qi,Or,dn):qi}}function lr(Or){var Pr=!1;return Or.forEach(function(dn,gi,qi){isBigNumber(dn)&&(Pr=!0,qi[gi]=dn.toNumber())}),Pr}function mr(Or){Or.forEach(function(Pr){if(typeof Pr!="number"||!isInteger(Pr)||Pr<0)throw Error("Parameters in function ones must be positive integers")})}});function noBignumber(){throw Error(\'No "bignumber" implementation available\')}function noFraction(){throw Error(\'No "fraction" implementation available\')}function noMatrix(){throw Error(\'No "matrix" implementation available\')}var name$221="range",dependencies$221=["typed","config","?matrix","?bignumber","equal","smaller","smallerEq","larger","largerEq","add","isZero","isPositive"],createRange=factory(name$221,dependencies$221,D=>{var{typed:E,config:F,matrix:J,bignumber:$e,smaller:_t,smallerEq:lr,larger:mr,largerEq:Or,add:Pr,isZero:dn,isPositive:gi}=D;return E(name$221,{string:zi,"string, boolean":zi,number:function(Gi){throw TypeError(`Too few arguments to function range(): ${Gi}`)},boolean:function(Gi){throw TypeError(`Unexpected type of argument 1 to function range(): ${Gi}, number|bigint|BigNumber|Fraction`)},"number, number":function(Gi,Zi){return qi(Hi(Gi,Zi,1,!1))},"number, number, number":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,Xi,!1))},"number, number, boolean":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,1,Xi))},"number, number, number, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(Gi,Zi,Xi,Ki))},"bigint, bigint|number":function(Gi,Zi){return qi(Hi(Gi,Zi,1n,!1))},"number, bigint":function(Gi,Zi){return qi(Hi(BigInt(Gi),Zi,1n,!1))},"bigint, bigint|number, bigint|number":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,BigInt(Xi),!1))},"number, bigint, bigint|number":function(Gi,Zi,Xi){return qi(Hi(BigInt(Gi),Zi,BigInt(Xi),!1))},"bigint, bigint|number, boolean":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,1n,Xi))},"number, bigint, boolean":function(Gi,Zi,Xi){return qi(Hi(BigInt(Gi),Zi,1n,Xi))},"bigint, bigint|number, bigint|number, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(Gi,Zi,BigInt(Xi),Ki))},"number, bigint, bigint|number, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(BigInt(Gi),Zi,BigInt(Xi),Ki))},"BigNumber, BigNumber":function(Gi,Zi){var Xi=Gi.constructor;return qi(Hi(Gi,Zi,new Xi(1),!1))},"BigNumber, BigNumber, BigNumber":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,Xi,!1))},"BigNumber, BigNumber, boolean":function(Gi,Zi,Xi){var Ki=Gi.constructor;return qi(Hi(Gi,Zi,new Ki(1),Xi))},"BigNumber, BigNumber, BigNumber, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(Gi,Zi,Xi,Ki))},"Fraction, Fraction":function(Gi,Zi){return qi(Hi(Gi,Zi,1,!1))},"Fraction, Fraction, Fraction":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,Xi,!1))},"Fraction, Fraction, boolean":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,1,Xi))},"Fraction, Fraction, Fraction, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(Gi,Zi,Xi,Ki))},"Unit, Unit, Unit":function(Gi,Zi,Xi){return qi(Hi(Gi,Zi,Xi,!1))},"Unit, Unit, Unit, boolean":function(Gi,Zi,Xi,Ki){return qi(Hi(Gi,Zi,Xi,Ki))}});function qi(Gi){return F.matrix==="Matrix"?J?J(Gi):noMatrix():Gi}function zi(Gi,Zi){var Xi=Qi(Gi);if(!Xi)throw SyntaxError(\'String "\'+Gi+\'" is no valid range\');return F.number==="BigNumber"?($e===void 0&&noBignumber(),qi(Hi($e(Xi.start),$e(Xi.end),$e(Xi.step)))):qi(Hi(Xi.start,Xi.end,Xi.step,Zi))}function Hi(Gi,Zi,Xi,Ki){var ea=[];if(dn(Xi))throw Error("Step must be non-zero");for(var Ji=gi(Xi)?Ki?lr:_t:Ki?Or:mr,ta=Gi;Ji(ta,Zi);)ea.push(ta),ta=Pr(ta,Xi);return ea}function Qi(Gi){var Zi=Gi.split(":").map(function(Xi){return Number(Xi)});if(Zi.some(function(Xi){return isNaN(Xi)}))return null;switch(Zi.length){case 2:return{start:Zi[0],end:Zi[1],step:1};case 3:return{start:Zi[0],end:Zi[2],step:Zi[1]};default:return null}}}),name$220="reshape",dependencies$220=["typed","isInteger","matrix"],createReshape=factory(name$220,dependencies$220,D=>{var{typed:E,isInteger:F}=D;return E(name$220,{"Matrix, Array":function(J,$e){return J.reshape($e,!0)},"Array, Array":function(J,$e){return $e.forEach(function(_t){if(!F(_t))throw TypeError("Invalid size for dimension: "+_t)}),reshape(J,$e)}})}),name$219="resize",dependencies$219=["config","matrix"],createResize=factory(name$219,dependencies$219,D=>{var{config:E,matrix:F}=D;return function($e,_t,lr){if(arguments.length!==2&&arguments.length!==3)throw new ArgumentsError("resize",arguments.length,2,3);if(isMatrix(_t)&&(_t=_t.valueOf()),isBigNumber(_t[0])&&(_t=_t.map(function(Pr){return isBigNumber(Pr)?Pr.toNumber():Pr})),isMatrix($e))return $e.resize(_t,lr,!0);if(typeof $e=="string")return J($e,_t,lr);var mr=Array.isArray($e)?!1:E.matrix!=="Array";if(_t.length===0){for(;Array.isArray($e);)$e=$e[0];return clone$3($e)}else{Array.isArray($e)||($e=[$e]),$e=clone$3($e);var Or=resize($e,_t,lr);return mr?F(Or):Or}};function J($e,_t,lr){if(lr!==void 0){if(typeof lr!="string"||lr.length!==1)throw TypeError("Single character expected as defaultValue")}else lr=" ";if(_t.length!==1)throw new DimensionError(_t.length,1);var mr=_t[0];if(typeof mr!="number"||!isInteger(mr))throw TypeError("Invalid size, must contain positive integers (size: "+format(_t)+")");if($e.length>mr)return $e.substring(0,mr);if($e.length<mr){for(var Or=$e,Pr=0,dn=mr-$e.length;Pr<dn;Pr++)Or+=lr;return Or}else return $e}}),name$218="rotate",dependencies$218=["typed","multiply","rotationMatrix"],createRotate=factory(name$218,dependencies$218,D=>{var{typed:E,multiply:F,rotationMatrix:J}=D;return E(name$218,{"Array , number | BigNumber | Complex | Unit":function(_t,lr){return $e(_t,2),F(J(lr),_t).toArray()},"Matrix , number | BigNumber | Complex | Unit":function(_t,lr){return $e(_t,2),F(J(lr),_t)},"Array, number | BigNumber | Complex | Unit, Array | Matrix":function(_t,lr,mr){return $e(_t,3),F(J(lr,mr),_t)},"Matrix, number | BigNumber | Complex | Unit, Array | Matrix":function(_t,lr,mr){return $e(_t,3),F(J(lr,mr),_t)}});function $e(_t,lr){var mr=Array.isArray(_t)?arraySize(_t):_t.size();if(mr.length>2||mr.length===2&&mr[1]!==1||mr[0]!==lr)throw RangeError(`Vector must be of dimensions 1x${lr}`)}}),name$217="rotationMatrix",dependencies$217=["typed","config","multiplyScalar","addScalar","unaryMinus","norm","matrix","BigNumber","DenseMatrix","SparseMatrix","cos","sin"],createRotationMatrix=factory(name$217,dependencies$217,D=>{var{typed:E,config:F,multiplyScalar:J,addScalar:$e,unaryMinus:_t,norm:lr,BigNumber:mr,matrix:Or,DenseMatrix:Pr,SparseMatrix:dn,cos:gi,sin:qi}=D;return E(name$217,{"":function(){return F.matrix==="Matrix"?Or([]):[]},string:function(Xi){return Or(Xi)},"number | BigNumber | Complex | Unit":function(Xi){return zi(Xi,F.matrix==="Matrix"?"dense":void 0)},"number | BigNumber | Complex | Unit, string":function(Xi,Ki){return zi(Xi,Ki)},"number | BigNumber | Complex | Unit, Array":function(Xi,Ki){var ea=Or(Ki);return Hi(ea),Zi(Xi,ea,void 0)},"number | BigNumber | Complex | Unit, Matrix":function(Xi,Ki){return Hi(Ki),Zi(Xi,Ki,Ki.storage()||(F.matrix==="Matrix"?"dense":void 0))},"number | BigNumber | Complex | Unit, Array, string":function(Xi,Ki,ea){var Ji=Or(Ki);return Hi(Ji),Zi(Xi,Ji,ea)},"number | BigNumber | Complex | Unit, Matrix, string":function(Xi,Ki,ea){return Hi(Ki),Zi(Xi,Ki,ea)}});function zi(Xi,Ki){var ea=isBigNumber(Xi)?new mr(-1):-1,Ji=gi(Xi),ta=qi(Xi);return Gi([[Ji,J(ea,ta)],[ta,Ji]],Ki)}function Hi(Xi){var Ki=Xi.size();if(Ki.length<1||Ki[0]!==3)throw RangeError("Vector must be of dimensions 1x3")}function Qi(Xi){return Xi.reduce((Ki,ea)=>J(Ki,ea))}function Gi(Xi,Ki){if(Ki){if(Ki==="sparse")return new dn(Xi);if(Ki==="dense")return new Pr(Xi);throw TypeError(`Unknown matrix type "${Ki}"`)}return Xi}function Zi(Xi,Ki,ea){var Ji=lr(Ki);if(Ji===0)throw RangeError("Rotation around zero vector");var ta=isBigNumber(Xi)?mr:null,na=ta?new ta(1):1,ra=ta?new ta(-1):-1,ia=ta?new ta(Ki.get([0])/Ji):Ki.get([0])/Ji,oa=ta?new ta(Ki.get([1])/Ji):Ki.get([1])/Ji,ua=ta?new ta(Ki.get([2])/Ji):Ki.get([2])/Ji,sa=gi(Xi),aa=$e(na,_t(sa)),pa=qi(Xi),ma=$e(sa,Qi([ia,ia,aa])),la=$e(Qi([ia,oa,aa]),Qi([ra,ua,pa])),ha=$e(Qi([ia,ua,aa]),Qi([oa,pa])),ga=$e(Qi([ia,oa,aa]),Qi([ua,pa])),Aa=$e(sa,Qi([oa,oa,aa])),Fa=$e(Qi([oa,ua,aa]),Qi([ra,ia,pa])),$a=$e(Qi([ia,ua,aa]),Qi([ra,oa,pa])),_a=$e(Qi([oa,ua,aa]),Qi([ia,pa])),fa=$e(sa,Qi([ua,ua,aa]));return Gi([[ma,la,ha],[ga,Aa,Fa],[$a,_a,fa]],ea)}}),name$216="row",dependencies$216=["typed","Index","matrix","range"],createRow=factory(name$216,dependencies$216,D=>{var{typed:E,Index:F,matrix:J,range:$e}=D;return E(name$216,{"Matrix, number":_t,"Array, number":function(lr,mr){return _t(J(clone$3(lr)),mr).valueOf()}});function _t(lr,mr){if(lr.size().length!==2)throw Error("Only two dimensional matrix is supported");validateIndex(mr,lr.size()[0]);var Or=$e(0,lr.size()[1]),Pr=new F([mr],Or),dn=lr.subset(Pr);return isMatrix(dn)?dn:J([[dn]])}}),name$215="size",dependencies$215=["typed"],createSize=factory(name$215,dependencies$215,D=>{var{typed:E}=D;return E(name$215,{Matrix:F=>F.size(),Array:arraySize,string:F=>[F.length],"number | Complex | BigNumber | Unit | boolean | null":F=>[]})}),name$214="squeeze",dependencies$214=["typed"],createSqueeze=factory(name$214,dependencies$214,D=>{var{typed:E}=D;return E(name$214,{Array:function(F){return squeeze(clone$3(F))},Matrix:function(F){var J=squeeze(F.toArray());return Array.isArray(J)?F.create(J,F.datatype()):J},any:function(F){return clone$3(F)}})}),name$213="subset",dependencies$213=["typed","matrix","zeros","add"],createSubset=factory(name$213,dependencies$213,D=>{var{typed:E,matrix:F,zeros:J,add:$e}=D;return E(name$213,{"Matrix, Index":function(lr,mr){return isEmptyIndex(mr)?F():(validateIndexSourceSize(lr,mr),lr.subset(mr))},"Array, Index":E.referTo("Matrix, Index",function(lr){return function(mr,Or){var Pr=lr(F(mr),Or);return Or.isScalar()?Pr:Pr.valueOf()}}),"Object, Index":_getObjectProperty,"string, Index":_getSubstring,"Matrix, Index, any, any":function(lr,mr,Or,Pr){return isEmptyIndex(mr)?lr:(validateIndexSourceSize(lr,mr),lr.clone().subset(mr,_t(Or,mr),Pr))},"Array, Index, any, any":E.referTo("Matrix, Index, any, any",function(lr){return function(mr,Or,Pr,dn){var gi=lr(F(mr),Or,Pr,dn);return gi.isMatrix?gi.valueOf():gi}}),"Array, Index, any":E.referTo("Matrix, Index, any, any",function(lr){return function(mr,Or,Pr){return lr(F(mr),Or,Pr,void 0).valueOf()}}),"Matrix, Index, any":E.referTo("Matrix, Index, any, any",function(lr){return function(mr,Or,Pr){return lr(mr,Or,Pr,void 0)}}),"string, Index, string":_setSubstring,"string, Index, string, string":_setSubstring,"Object, Index, any":_setObjectProperty});function _t(lr,mr){if(typeof lr=="string")throw Error("can\'t boradcast a string");if(mr.isScalar())return lr;var Or=mr.size();if(Or.every(Pr=>Pr>0))try{return $e(lr,J(Or))}catch{return lr}else return lr}});function _getSubstring(D,E){if(!isIndex(E))throw TypeError("Index expected");if(isEmptyIndex(E))return"";if(validateIndexSourceSize(Array.from(D),E),E.size().length!==1)throw new DimensionError(E.size().length,1);var F=D.length;validateIndex(E.min()[0],F),validateIndex(E.max()[0],F);var J=E.dimension(0),$e="";function _t(lr){$e+=D.charAt(lr)}return Number.isInteger(J)?_t(J):J.forEach(_t),$e}function _setSubstring(D,E,F,J){if(!E||E.isIndex!==!0)throw TypeError("Index expected");if(isEmptyIndex(E))return D;if(validateIndexSourceSize(Array.from(D),E),E.size().length!==1)throw new DimensionError(E.size().length,1);if(J!==void 0){if(typeof J!="string"||J.length!==1)throw TypeError("Single character expected as defaultValue")}else J=" ";var $e=E.dimension(0);if((Number.isInteger($e)?1:$e.size()[0])!==F.length)throw new DimensionError($e.size()[0],F.length);var _t=D.length;validateIndex(E.min()[0]),validateIndex(E.max()[0]);for(var lr=[],mr=0;mr<_t;mr++)lr[mr]=D.charAt(mr);function Or(gi,qi){lr[gi]=F.charAt(qi[0])}if(Number.isInteger($e)?Or($e,[0]):$e.forEach(Or),lr.length>_t)for(var Pr=_t-1,dn=lr.length;Pr<dn;Pr++)lr[Pr]||(lr[Pr]=J);return lr.join("")}function _getObjectProperty(D,E){if(!isEmptyIndex(E)){if(E.size().length!==1)throw new DimensionError(E.size(),1);var F=E.dimension(0);if(typeof F!="string")throw TypeError("String expected as index to retrieve an object property");return getSafeProperty(D,F)}}function _setObjectProperty(D,E,F){if(isEmptyIndex(E))return D;if(E.size().length!==1)throw new DimensionError(E.size(),1);var J=E.dimension(0);if(typeof J!="string")throw TypeError("String expected as index to retrieve an object property");var $e=clone$3(D);return setSafeProperty($e,J,F),$e}var name$212="transpose",dependencies$212=["typed","matrix"],createTranspose=factory(name$212,dependencies$212,D=>{var{typed:E,matrix:F}=D;return E(name$212,{Array:lr=>J(F(lr)).valueOf(),Matrix:J,any:clone$3});function J(lr){var mr=lr.size(),Or;switch(mr.length){case 1:Or=lr.clone();break;case 2:var Pr=mr[0],dn=mr[1];if(dn===0)throw RangeError("Cannot transpose a 2D matrix with no columns (size: "+format(mr)+")");switch(lr.storage()){case"dense":Or=$e(lr,Pr,dn);break;case"sparse":Or=_t(lr,Pr,dn);break}break;default:throw RangeError("Matrix must be a vector or two dimensional (size: "+format(mr)+")")}return Or}function $e(lr,mr,Or){for(var Pr=lr._data,dn=[],gi,qi=0;qi<Or;qi++){gi=dn[qi]=[];for(var zi=0;zi<mr;zi++)gi[zi]=clone$3(Pr[zi][qi])}return lr.createDenseMatrix({data:dn,size:[Or,mr],datatype:lr._datatype})}function _t(lr,mr,Or){for(var Pr=lr._values,dn=lr._index,gi=lr._ptr,qi=Pr?[]:void 0,zi=[],Hi=[],Qi=[],Gi=0;Gi<mr;Gi++)Qi[Gi]=0;var Zi,Xi,Ki;for(Zi=0,Xi=dn.length;Zi<Xi;Zi++)Qi[dn[Zi]]++;for(var ea=0,Ji=0;Ji<mr;Ji++)Hi.push(ea),ea+=Qi[Ji],Qi[Ji]=Hi[Ji];for(Hi.push(ea),Ki=0;Ki<Or;Ki++)for(var ta=gi[Ki],na=gi[Ki+1],ra=ta;ra<na;ra++){var ia=Qi[dn[ra]]++;zi[ia]=Ki,Pr&&(qi[ia]=clone$3(Pr[ra]))}return lr.createSparseMatrix({values:qi,index:zi,ptr:Hi,size:[Or,mr],datatype:lr._datatype})}}),name$211="ctranspose",dependencies$211=["typed","transpose","conj"],createCtranspose=factory(name$211,dependencies$211,D=>{var{typed:E,transpose:F,conj:J}=D;return E(name$211,{any:function($e){return J(F($e))}})}),name$210="zeros",dependencies$210=["typed","config","matrix","BigNumber"],createZeros=factory(name$210,dependencies$210,D=>{var{typed:E,config:F,matrix:J,BigNumber:$e}=D;return E(name$210,{"":function(){return F.matrix==="Array"?_t([]):_t([],"default")},"...number | BigNumber | string":function(Or){return typeof Or[Or.length-1]=="string"?_t(Or,Or.pop()):F.matrix==="Array"?_t(Or):_t(Or,"default")},Array:_t,Matrix:function(Or){var Pr=Or.storage();return _t(Or.valueOf(),Pr)},"Array | Matrix, string":function(Or,Pr){return _t(Or.valueOf(),Pr)}});function _t(Or,Pr){var dn=lr(Or)?new $e(0):0;if(mr(Or),Pr){var gi=J(Pr);return Or.length>0?gi.resize(Or,dn):gi}else{var qi=[];return Or.length>0?resize(qi,Or,dn):qi}}function lr(Or){var Pr=!1;return Or.forEach(function(dn,gi,qi){isBigNumber(dn)&&(Pr=!0,qi[gi]=dn.toNumber())}),Pr}function mr(Or){Or.forEach(function(Pr){if(typeof Pr!="number"||!isInteger(Pr)||Pr<0)throw Error("Parameters in function zeros must be positive integers")})}}),name$209="fft",dependencies$209=["typed","matrix","addScalar","multiplyScalar","divideScalar","exp","tau","i","dotDivide","conj","pow","ceil","log2"],createFft=factory(name$209,dependencies$209,D=>{var{typed:E,matrix:F,addScalar:J,multiplyScalar:$e,divideScalar:_t,exp:lr,tau:mr,i:Or,dotDivide:Pr,conj:dn,pow:gi,ceil:qi,log2:zi}=D;return E(name$209,{Array:Hi,Matrix:function(Xi){return Xi.create(Hi(Xi.valueOf()),Xi.datatype())}});function Hi(Xi){var Ki=arraySize(Xi);return Ki.length===1?Zi(Xi,Ki[0]):Qi(Xi.map(ea=>Hi(ea,Ki.slice(1))),0)}function Qi(Xi,Ki){var ea=arraySize(Xi);if(Ki!==0)return Array(ea[0]).fill(0).map((ta,na)=>Qi(Xi[na],Ki-1));if(ea.length===1)return Zi(Xi);function Ji(ta){var na=arraySize(ta);return Array(na[1]).fill(0).map((ra,ia)=>Array(na[0]).fill(0).map((oa,ua)=>ta[ua][ia]))}return Ji(Qi(Ji(Xi),1))}function Gi(Xi){for(var Ki=Xi.length,ea=lr(_t($e(-1,$e(Or,mr)),Ki)),Ji=[],ta=1-Ki;ta<Ki;ta++)Ji.push(gi(ea,_t(gi(ta,2),2)));for(var na=gi(2,qi(zi(Ki+Ki-1))),ra=[...Array(Ki).fill(0).map((ma,la)=>$e(Xi[la],Ji[Ki-1+la])),...Array(na-Ki).fill(0)],ia=[...Array(Ki+Ki-1).fill(0).map((ma,la)=>_t(1,Ji[la])),...Array(na-(Ki+Ki-1)).fill(0)],oa=Zi(ra),ua=Zi(ia),sa=Pr(dn(Hi(dn(Array(na).fill(0).map((ma,la)=>$e(oa[la],ua[la]))))),na),aa=[],pa=Ki-1;pa<Ki+Ki-1;pa++)aa.push($e(sa[pa],Ji[pa]));return aa}function Zi(Xi){var Ki=Xi.length;if(Ki===1)return[Xi[0]];if(Ki%2==0){for(var ea=[...Zi(Xi.filter((ra,ia)=>ia%2==0)),...Zi(Xi.filter((ra,ia)=>ia%2==1))],Ji=0;Ji<Ki/2;Ji++){var ta=ea[Ji],na=$e(ea[Ji+Ki/2],lr($e($e(mr,Or),_t(-Ji,Ki))));ea[Ji]=J(ta,na),ea[Ji+Ki/2]=J(ta,$e(-1,na))}return ea}else return Gi(Xi)}}),name$208="ifft",dependencies$208=["typed","fft","dotDivide","conj"],createIfft=factory(name$208,dependencies$208,D=>{var{typed:E,fft:F,dotDivide:J,conj:$e}=D;return E(name$208,{"Array | Matrix":function(_t){var lr=isMatrix(_t)?_t.size():arraySize(_t);return J($e(F($e(_t))),lr.reduce((mr,Or)=>mr*Or,1))}})});function _typeof(D){"@babel/helpers - typeof";return _typeof=typeof Symbol=="function"&&typeof Symbol.iterator=="symbol"?function(E){return typeof E}:function(E){return E&&typeof Symbol=="function"&&E.constructor===Symbol&&E!==Symbol.prototype?"symbol":typeof E},_typeof(D)}function toPrimitive(D,E){if(_typeof(D)!="object"||!D)return D;var F=D[Symbol.toPrimitive];if(F!==void 0){var J=F.call(D,E);if(_typeof(J)!="object")return J;throw TypeError("@@toPrimitive must return a primitive value.")}return(E==="string"?String:Number)(D)}function toPropertyKey(D){var E=toPrimitive(D,"string");return _typeof(E)=="symbol"?E:E+""}function _defineProperty(D,E,F){return(E=toPropertyKey(E))in D?Object.defineProperty(D,E,{value:F,enumerable:!0,configurable:!0,writable:!0}):D[E]=F,D}function ownKeys$3(D,E){var F=Object.keys(D);if(Object.getOwnPropertySymbols){var J=Object.getOwnPropertySymbols(D);E&&(J=J.filter(function($e){return Object.getOwnPropertyDescriptor(D,$e).enumerable})),F.push.apply(F,J)}return F}function _objectSpread$3(D){for(var E=1;E<arguments.length;E++){var F=arguments[E]==null?{}:arguments[E];E%2?ownKeys$3(Object(F),!0).forEach(function(J){_defineProperty(D,J,F[J])}):Object.getOwnPropertyDescriptors?Object.defineProperties(D,Object.getOwnPropertyDescriptors(F)):ownKeys$3(Object(F)).forEach(function(J){Object.defineProperty(D,J,Object.getOwnPropertyDescriptor(F,J))})}return D}var name$207="solveODE",dependencies$207=["typed","add","subtract","multiply","divide","max","map","abs","isPositive","isNegative","larger","smaller","matrix","bignumber","unaryMinus"],createSolveODE=factory(name$207,dependencies$207,D=>{var{typed:E,add:F,subtract:J,multiply:$e,divide:_t,max:lr,map:mr,abs:Or,isPositive:Pr,isNegative:dn,larger:gi,smaller:qi,matrix:zi,bignumber:Hi,unaryMinus:Qi}=D;function Gi(ra){return function(ia,oa,ua,sa){if(!(oa.length===2&&(oa.every(ta)||oa.every(isUnit))))throw Error(\'"tspan" must be an Array of two numeric values or two units [tStart, tEnd]\');var aa=oa[0],pa=oa[1],ma=gi(pa,aa),la=sa.firstStep;if(la!==void 0&&!Pr(la))throw Error(\'"firstStep" must be positive\');var ha=sa.maxStep;if(ha!==void 0&&!Pr(ha))throw Error(\'"maxStep" must be positive\');var ga=sa.minStep;if(ga&&dn(ga))throw Error(\'"minStep" must be positive or zero\');var Aa=[aa,pa,la,ga,ha].filter(Va=>Va!==void 0);if(!(Aa.every(ta)||Aa.every(isUnit)))throw Error(\'Inconsistent type of "t" dependant variables\');for(var Fa=1,$a=sa.tol?sa.tol:1e-4,_a=sa.minDelta?sa.minDelta:.2,fa=sa.maxDelta?sa.maxDelta:5,ka=sa.maxIter?sa.maxIter:1e4,ba=[aa,pa,...ua,ha,ga].some(isBigNumber),[Pa,Ia,Da,va]=ba?[Hi(ra.a),Hi(ra.c),Hi(ra.b),Hi(ra.bp)]:[ra.a,ra.c,ra.b,ra.bp],Ca=la?ma?la:Qi(la):_t(J(pa,aa),Fa),ya=[aa],Na=[ua],za=J(Da,va),Ta=0,es=0,ts=ea(ma),Ka=Ji(ma);ts(ya[Ta],pa);){var ps=[];Ca=Ka(ya[Ta],pa,Ca),ps.push(ia(ya[Ta],Na[Ta]));for(var cs=1;cs<Ia.length;++cs)ps.push(ia(F(ya[Ta],$e(Ia[cs],Ca)),F(Na[Ta],$e(Ca,Pa[cs],ps))));var xa=lr(Or(mr($e(za,ps),Va=>isUnit(Va)?Va.value:Va)));xa<$a&&$a/xa>1/4&&(ya.push(F(ya[Ta],Ca)),Na.push(F(Na[Ta],$e(Ca,Da,ps))),Ta++);var Ra=.84*($a/xa)**(1/5);if(qi(Ra,_a)?Ra=_a:gi(Ra,fa)&&(Ra=fa),Ra=ba?Hi(Ra):Ra,Ca=$e(Ca,Ra),ha&&gi(Or(Ca),ha)?Ca=ma?ha:Qi(ha):ga&&qi(Or(Ca),ga)&&(Ca=ma?ga:Qi(ga)),es++,es>ka)throw Error("Maximum number of iterations reached, try changing options")}return{t:ya,y:Na}}}function Zi(ra,ia,oa,ua){return Gi({a:[[],[1/2],[0,3/4],[2/9,1/3,4/9]],c:[null,1/2,3/4,1],b:[2/9,1/3,4/9,0],bp:[7/24,1/4,1/3,1/8]})(ra,ia,oa,ua)}function Xi(ra,ia,oa,ua){return Gi({a:[[],[1/5],[3/40,9/40],[44/45,-56/15,32/9],[19372/6561,-25360/2187,64448/6561,-212/729],[9017/3168,-355/33,46732/5247,49/176,-5103/18656],[35/384,0,500/1113,125/192,-2187/6784,11/84]],c:[null,1/5,3/10,4/5,8/9,1,1],b:[35/384,0,500/1113,125/192,-2187/6784,11/84,0],bp:[5179/57600,0,7571/16695,393/640,-92097/339200,187/2100,1/40]})(ra,ia,oa,ua)}function Ki(ra,ia,oa,ua){var sa=ua.method?ua.method:"RK45",aa={RK23:Zi,RK45:Xi};if(sa.toUpperCase()in aa){var pa=_objectSpread$3({},ua);return delete pa.method,aa[sa.toUpperCase()](ra,ia,oa,pa)}else{var ma=Object.keys(aa).map(ha=>`"${ha}"`),la=`${ma.slice(0,-1).join(", ")} and ${ma.slice(-1)}`;throw Error(`Unavailable method "${sa}". Available methods are ${la}`)}}function ea(ra){return ra?qi:gi}function Ji(ra){var ia=ra?gi:qi;return function(oa,ua,sa){return ia(F(oa,sa),ua)?J(ua,oa):sa}}function ta(ra){return isBigNumber(ra)||isNumber(ra)}function na(ra,ia,oa,ua){var sa=Ki(ra,ia.toArray(),oa.toArray(),ua);return{t:zi(sa.t),y:zi(sa.y)}}return E("solveODE",{"function, Array, Array, Object":Ki,"function, Matrix, Matrix, Object":na,"function, Array, Array":(ra,ia,oa)=>Ki(ra,ia,oa,{}),"function, Matrix, Matrix":(ra,ia,oa)=>na(ra,ia,oa,{}),"function, Array, number | BigNumber | Unit":(ra,ia,oa)=>{var ua=Ki(ra,ia,[oa],{});return{t:ua.t,y:ua.y.map(sa=>sa[0])}},"function, Matrix, number | BigNumber | Unit":(ra,ia,oa)=>{var ua=Ki(ra,ia.toArray(),[oa],{});return{t:zi(ua.t),y:zi(ua.y.map(sa=>sa[0]))}},"function, Array, number | BigNumber | Unit, Object":(ra,ia,oa,ua)=>{var sa=Ki(ra,ia,[oa],ua);return{t:sa.t,y:sa.y.map(aa=>aa[0])}},"function, Matrix, number | BigNumber | Unit, Object":(ra,ia,oa,ua)=>{var sa=Ki(ra,ia.toArray(),[oa],ua);return{t:zi(sa.t),y:zi(sa.y.map(aa=>aa[0]))}}})}),name$206="erf",dependencies$206=["typed"],createErf=factory(name$206,dependencies$206,D=>{var{typed:E}=D;return E("name",{number:function(_t){var lr=Math.abs(_t);return lr>=MAX_NUM?sign$2(_t):lr<=THRESH?sign$2(_t)*F(lr):lr<=4?sign$2(_t)*(1-J(lr)):sign$2(_t)*(1-$e(lr))},"Array | Matrix":E.referToSelf(_t=>lr=>deepMap(lr,_t))});function F(_t){var lr=_t*_t,mr=P[0][4]*lr,Or=lr,Pr;for(Pr=0;Pr<3;Pr+=1)mr=(mr+P[0][Pr])*lr,Or=(Or+Q[0][Pr])*lr;return _t*(mr+P[0][3])/(Or+Q[0][3])}function J(_t){var lr=P[1][8]*_t,mr=_t,Or;for(Or=0;Or<7;Or+=1)lr=(lr+P[1][Or])*_t,mr=(mr+Q[1][Or])*_t;var Pr=(lr+P[1][7])/(mr+Q[1][7]),dn=parseInt(_t*16)/16,gi=(_t-dn)*(_t+dn);return Math.exp(-dn*dn)*Math.exp(-gi)*Pr}function $e(_t){var lr=1/(_t*_t),mr=P[2][5]*lr,Or=lr,Pr;for(Pr=0;Pr<4;Pr+=1)mr=(mr+P[2][Pr])*lr,Or=(Or+Q[2][Pr])*lr;var dn=lr*(mr+P[2][4])/(Or+Q[2][4]);dn=(SQRPI-dn)/_t,lr=parseInt(_t*16)/16;var gi=(_t-lr)*(_t+lr);return Math.exp(-lr*lr)*Math.exp(-gi)*dn}}),THRESH=.46875,SQRPI=.5641895835477563,P=[[3.1611237438705655,113.86415415105016,377.485237685302,3209.3775891384694,.18577770618460315],[.5641884969886701,8.883149794388377,66.11919063714163,298.6351381974001,881.952221241769,1712.0476126340707,2051.0783778260716,1230.3393547979972,21531153547440383e-24],[.30532663496123236,.36034489994980445,.12578172611122926,.016083785148742275,.0006587491615298378,.016315387137302097]],Q=[[23.601290952344122,244.02463793444417,1282.6165260773723,2844.236833439171],[15.744926110709835,117.6939508913125,537.1811018620099,1621.3895745666903,3290.7992357334597,4362.619090143247,3439.3676741437216,1230.3393548037495],[2.568520192289822,1.8729528499234604,.5279051029514285,.06051834131244132,.0023352049762686918]],MAX_NUM=2**53,name$205="zeta",dependencies$205=["typed","config","multiply","pow","divide","factorial","equal","smallerEq","isBounded","isNegative","gamma","sin","subtract","add","?Complex","?BigNumber","pi"],createZeta=factory(name$205,dependencies$205,D=>{var{typed:E,config:F,multiply:J,pow:$e,divide:_t,factorial:lr,equal:mr,smallerEq:Or,isBounded:Pr,isNegative:dn,gamma:gi,sin:qi,subtract:zi,add:Hi,Complex:Qi,BigNumber:Gi,pi:Zi}=D;return E(name$205,{number:na=>Xi(na,ra=>ra,()=>20),BigNumber:na=>Xi(na,ra=>new Gi(ra),()=>Math.abs(Math.log10(F.relTol))),Complex:Ki});function Xi(na,ra,ia){return mr(na,0)?ra(-.5):mr(na,1)?ra(NaN):Pr(na)?ea(na,ra,ia,oa=>oa):dn(na)?ra(NaN):ra(1)}function Ki(na){return na.re===0&&na.im===0?new Qi(-.5):na.re===1?new Qi(NaN,NaN):na.re===1/0&&na.im===0?new Qi(1):na.im===1/0||na.re===-1/0?new Qi(NaN,NaN):ea(na,ra=>ra,ra=>Math.round(1.3*15+.9*Math.abs(ra.im)),ra=>ra.re)}function ea(na,ra,ia,oa){var ua=ia(na);if(oa(na)>-(ua-1)/2)return ta(na,ra(ua),ra);var sa=J($e(2,na),$e(ra(Zi),zi(na,1)));return sa=J(sa,qi(J(_t(ra(Zi),2),na))),sa=J(sa,gi(zi(1,na))),J(sa,ea(zi(1,na),ra,ia,oa))}function Ji(na,ra){for(var ia=na,oa=na;Or(oa,ra);oa=Hi(oa,1)){var ua=_t(J(lr(Hi(ra,zi(oa,1))),$e(4,oa)),J(lr(zi(ra,oa)),lr(J(2,oa))));ia=Hi(ia,ua)}return J(ra,ia)}function ta(na,ra,ia){for(var oa=_t(1,J(Ji(ia(0),ra),zi(1,$e(2,zi(1,na))))),ua=ia(0),sa=ia(1);Or(sa,ra);sa=Hi(sa,1))ua=Hi(ua,_t(J((-1)**(sa-1),Ji(sa,ra)),$e(sa,na)));return J(oa,ua)}}),name$204="mode",dependencies$204=["typed","isNaN","isNumeric"],createMode=factory(name$204,dependencies$204,D=>{var{typed:E,isNaN:F,isNumeric:J}=D;return E(name$204,{"Array | Matrix":$e,"...":function(_t){return $e(_t)}});function $e(_t){if(_t=flatten$4(_t.valueOf()),_t.length===0)throw Error("Cannot calculate mode of an empty array");for(var lr={},mr=[],Or=0,Pr=0;Pr<_t.length;Pr++){var dn=_t[Pr];if(J(dn)&&F(dn))throw Error("Cannot calculate mode of an array containing NaN values");dn in lr||(lr[dn]=0),lr[dn]++,lr[dn]===Or?mr.push(dn):lr[dn]>Or&&(Or=lr[dn],mr=[dn])}return mr}});function improveErrorMessage(D,E,F){var J;return String(D).includes("Unexpected type")?(J=arguments.length>2?" (type: "+typeOf(F)+", value: "+JSON.stringify(F)+")":" (type: "+D.data.actual+")",TypeError("Cannot calculate "+E+", unexpected type of argument"+J)):String(D).includes("complex numbers")?(J=arguments.length>2?" (type: "+typeOf(F)+", value: "+JSON.stringify(F)+")":"",TypeError("Cannot calculate "+E+", no ordering relation is defined for complex numbers"+J)):D}var name$203="prod",dependencies$203=["typed","config","multiplyScalar","numeric"],createProd=factory(name$203,dependencies$203,D=>{var{typed:E,config:F,multiplyScalar:J,numeric:$e}=D;return E(name$203,{"Array | Matrix":_t,"Array | Matrix, number | BigNumber":function(lr,mr){throw Error("prod(A, dim) is not yet supported")},"...":function(lr){return _t(lr)}});function _t(lr){var mr;if(deepForEach(lr,function(Or){try{mr=mr===void 0?Or:J(mr,Or)}catch(Pr){throw improveErrorMessage(Pr,"prod",Or)}}),typeof mr=="string"&&(mr=$e(mr,safeNumberType(mr,F))),mr===void 0)throw Error("Cannot calculate prod of an empty array");return mr}}),name$202="format",dependencies$202=["typed"],createFormat=factory(name$202,dependencies$202,D=>{var{typed:E}=D;return E(name$202,{any:format,"any, Object | function | number | BigNumber":format})}),name$201="bin",dependencies$201=["typed","format"],createBin=factory(name$201,dependencies$201,D=>{var{typed:E,format:F}=D;return E(name$201,{"number | BigNumber":function(J){return F(J,{notation:"bin"})},"number | BigNumber, number | BigNumber":function(J,$e){return F(J,{notation:"bin",wordSize:$e})}})}),name$200="oct",dependencies$200=["typed","format"],createOct=factory(name$200,dependencies$200,D=>{var{typed:E,format:F}=D;return E(name$200,{"number | BigNumber":function(J){return F(J,{notation:"oct"})},"number | BigNumber, number | BigNumber":function(J,$e){return F(J,{notation:"oct",wordSize:$e})}})}),name$199="hex",dependencies$199=["typed","format"],createHex=factory(name$199,dependencies$199,D=>{var{typed:E,format:F}=D;return E(name$199,{"number | BigNumber":function(J){return F(J,{notation:"hex"})},"number | BigNumber, number | BigNumber":function(J,$e){return F(J,{notation:"hex",wordSize:$e})}})}),printTemplate=/\\$([\\w.]+)/g,name$198="print",dependencies$198=["typed"],createPrint=factory(name$198,dependencies$198,D=>{var{typed:E}=D;return E(name$198,{"string, Object | Array":_print,"string, Object | Array, number | Object":_print})});function _print(D,E,F){return D.replace(printTemplate,function(J,$e){var _t=$e.split("."),lr=E[_t.shift()];for(lr!==void 0&&lr.isMatrix&&(lr=lr.toArray());_t.length&&lr!==void 0;){var mr=_t.shift();lr=mr?lr[mr]:lr+"."}return lr===void 0?J:isString(lr)?lr:format(lr,F)})}var name$197="to",dependencies$197=["typed","matrix","concat"],createTo=factory(name$197,dependencies$197,D=>{var{typed:E,matrix:F,concat:J}=D;return E(name$197,{"Unit, Unit | string":($e,_t)=>$e.to(_t)},createMatrixAlgorithmSuite({typed:E,matrix:F,concat:J})({Ds:!0}))}),name$196="toBest",dependencies$196=["typed"],createToBest=factory(name$196,dependencies$196,D=>{var{typed:E}=D;return E(name$196,{Unit:F=>F.toBest(),"Unit, string":(F,J)=>F.toBest(J.split(",")),"Unit, string, Object":(F,J,$e)=>F.toBest(J.split(","),$e),"Unit, Array":(F,J)=>F.toBest(J),"Unit, Array, Object":(F,J,$e)=>F.toBest(J,$e)})}),name$195="isPrime",dependencies$195=["typed"],createIsPrime=factory(name$195,dependencies$195,D=>{var{typed:E}=D;return E(name$195,{number:function(F){if(F<=3)return F>1;if(F%2==0||F%3==0)return!1;for(var J=5;J*J<=F;J+=6)if(F%J===0||F%(J+2)===0)return!1;return!0},bigint:function(F){if(F<=3n)return F>1n;if(F%2n==0n||F%3n==0n)return!1;for(var J=5n;J*J<=F;J+=6n)if(F%J===0n||F%(J+2n)===0n)return!1;return!0},BigNumber:function(F){if(F.lte(3))return F.gt(1);if(F.mod(2).eq(0)||F.mod(3).eq(0))return!1;if(F.lt(2**32)){for(var J=F.toNumber(),$e=5;$e*$e<=J;$e+=6)if(J%$e===0||J%($e+2)===0)return!1;return!0}function _t(Gi,Zi,Xi){for(var Ki=1;!Zi.eq(0);)Zi.mod(2).eq(0)?(Zi=Zi.div(2),Gi=Gi.mul(Gi).mod(Xi)):(Zi=Zi.sub(1),Ki=Gi.mul(Ki).mod(Xi));return Ki}F=new(F.constructor.clone({precision:F.toFixed(0).length*2}))(F);for(var lr=0,mr=F.sub(1);mr.mod(2).eq(0);)mr=mr.div(2),lr+=1;var Or=null;if(F.lt("3317044064679887385961981"))Or=[2,3,5,7,11,13,17,19,23,29,31,37,41].filter(Gi=>Gi<F);else{var Pr=Math.min(F.toNumber()-2,Math.floor(2*(F.toFixed(0).length*Math.log(10))**2));Or=[];for(var dn=2;dn<=Pr;dn+=1)Or.push(Pr)}for(var gi=0;gi<Or.length;gi+=1){var qi=Or[gi],zi=_t(F.sub(F).add(qi),mr,F);if(!zi.eq(1)){for(var Hi=0,Qi=zi;!Qi.eq(F.sub(1));Hi+=1,Qi=Qi.mul(Qi).mod(F))if(Hi===lr-1)return!1}}return!0},"Array | Matrix":E.referToSelf(F=>J=>deepMap(J,F))})}),name$194="numeric",dependencies$194=["number","?bignumber","?fraction"],createNumeric=factory(name$194,dependencies$194,D=>{var{number:E,bignumber:F,fraction:J}=D,$e={string:!0,number:!0,BigNumber:!0,Fraction:!0},_t={number:lr=>E(lr),BigNumber:F?lr=>F(lr):noBignumber,bigint:lr=>BigInt(lr),Fraction:J?lr=>J(lr):noFraction};return function(lr){var mr=arguments.length>1&&arguments[1]!==void 0?arguments[1]:"number";if((arguments.length>2?arguments[2]:void 0)!==void 0)throw SyntaxError("numeric() takes one or two arguments");var Or=typeOf(lr);if(!(Or in $e))throw TypeError("Cannot convert "+lr+\' of type "\'+Or+\'"; valid input types are \'+Object.keys($e).join(", "));if(!(mr in _t))throw TypeError("Cannot convert "+lr+\' to type "\'+mr+\'"; valid output types are \'+Object.keys(_t).join(", "));return mr===Or?lr:_t[mr](lr)}}),name$193="divideScalar",dependencies$193=["typed","numeric"],createDivideScalar=factory(name$193,dependencies$193,D=>{var{typed:E,numeric:F}=D;return E(name$193,{"number, number":function(J,$e){return J/$e},"Complex, Complex":function(J,$e){return J.div($e)},"BigNumber, BigNumber":function(J,$e){return J.div($e)},"bigint, bigint":function(J,$e){return J/$e},"Fraction, Fraction":function(J,$e){return J.div($e)},"Unit, number | Complex | Fraction | BigNumber | Unit":(J,$e)=>J.divide($e),"number | Fraction | Complex | BigNumber, Unit":(J,$e)=>$e.divideInto(J)})}),name$192="pow",dependencies$192=["typed","config","identity","multiply","matrix","inv","fraction","number","Complex"],createPow=factory(name$192,dependencies$192,D=>{var{typed:E,config:F,identity:J,multiply:$e,matrix:_t,inv:lr,number:mr,fraction:Or,Complex:Pr}=D;return E(name$192,{"number, number":dn,"Complex, Complex":function(zi,Hi){return zi.pow(Hi)},"BigNumber, BigNumber":function(zi,Hi){return Hi.isInteger()||zi>=0||F.predictable?zi.pow(Hi):new Pr(zi.toNumber(),0).pow(Hi.toNumber(),0)},"bigint, bigint":(zi,Hi)=>zi**Hi,"Fraction, Fraction":function(zi,Hi){var Qi=zi.pow(Hi);if(Qi!=null)return Qi;if(F.predictable)throw Error("Result of pow is non-rational and cannot be expressed as a fraction");return dn(zi.valueOf(),Hi.valueOf())},"Array, number":gi,"Array, BigNumber":function(zi,Hi){return gi(zi,Hi.toNumber())},"Matrix, number":qi,"Matrix, BigNumber":function(zi,Hi){return qi(zi,Hi.toNumber())},"Unit, number | BigNumber":function(zi,Hi){return zi.pow(Hi)}});function dn(zi,Hi){if(F.predictable&&!isInteger(Hi)&&zi<0)try{var Qi=Or(Hi),Gi=mr(Qi);if((Hi===Gi||Math.abs((Hi-Gi)/Hi)<1e-14)&&Qi.d%2n==1n)return(Qi.n%2n==0n?1:-1)*(-zi)**+Hi}catch{}return F.predictable&&(zi<-1&&Hi===1/0||zi>-1&&zi<0&&Hi===-1/0)?NaN:isInteger(Hi)||zi>=0||F.predictable?powNumber(zi,Hi):zi*zi<1&&Hi===1/0||zi*zi>1&&Hi===-1/0?0:new Pr(zi,0).pow(Hi,0)}function gi(zi,Hi){if(!isInteger(Hi))throw TypeError("For A^b, b must be an integer (value is "+Hi+")");var Qi=arraySize(zi);if(Qi.length!==2)throw Error("For A^b, A must be 2 dimensional (A has "+Qi.length+" dimensions)");if(Qi[0]!==Qi[1])throw Error("For A^b, A must be square (size is "+Qi[0]+"x"+Qi[1]+")");if(Hi<0)try{return gi(lr(zi),-Hi)}catch(Xi){throw Xi.message==="Cannot calculate inverse, determinant is zero"?TypeError("For A^b, when A is not invertible, b must be a positive integer (value is "+Hi+")"):Xi}for(var Gi=J(Qi[0]).valueOf(),Zi=zi;Hi>=1;)(Hi&1)==1&&(Gi=$e(Zi,Gi)),Hi>>=1,Zi=$e(Zi,Zi);return Gi}function qi(zi,Hi){return _t(gi(zi.valueOf(),Hi))}}),NO_INT="Number of decimals in function round must be an integer",name$191="round",dependencies$191=["typed","config","matrix","equalScalar","zeros","BigNumber","DenseMatrix"],createRound=factory(name$191,dependencies$191,D=>{var{typed:E,config:F,matrix:J,equalScalar:$e,zeros:_t,BigNumber:lr,DenseMatrix:mr}=D,Or=createMatAlgo11xS0s({typed:E,equalScalar:$e}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:mr}),dn=createMatAlgo14xDs({typed:E});function gi(qi){return Math.abs(splitNumber(qi).exponent)}return E(name$191,{number:function(qi){var zi=roundNumber(qi,gi(F.relTol));return roundNumber(nearlyEqual$1(qi,zi,F.relTol,F.absTol)?zi:qi)},"number, number":function(qi,zi){var Hi=gi(F.relTol);if(zi>=Hi)return roundNumber(qi,zi);var Qi=roundNumber(qi,Hi);return roundNumber(nearlyEqual$1(qi,Qi,F.relTol,F.absTol)?Qi:qi,zi)},"number, BigNumber":function(qi,zi){if(!zi.isInteger())throw TypeError(NO_INT);return new lr(qi).toDecimalPlaces(zi.toNumber())},Complex:function(qi){return qi.round()},"Complex, number":function(qi,zi){if(zi%1)throw TypeError(NO_INT);return qi.round(zi)},"Complex, BigNumber":function(qi,zi){if(!zi.isInteger())throw TypeError(NO_INT);var Hi=zi.toNumber();return qi.round(Hi)},BigNumber:function(qi){var zi=new lr(qi).toDecimalPlaces(gi(F.relTol));return(nearlyEqual(qi,zi,F.relTol,F.absTol)?zi:qi).toDecimalPlaces(0)},"BigNumber, BigNumber":function(qi,zi){if(!zi.isInteger())throw TypeError(NO_INT);var Hi=gi(F.relTol);if(zi>=Hi)return qi.toDecimalPlaces(zi.toNumber());var Qi=qi.toDecimalPlaces(Hi);return(nearlyEqual(qi,Qi,F.relTol,F.absTol)?Qi:qi).toDecimalPlaces(zi.toNumber())},bigint:qi=>qi,"bigint, number":(qi,zi)=>qi,"bigint, BigNumber":(qi,zi)=>qi,Fraction:function(qi){return qi.round()},"Fraction, number":function(qi,zi){if(zi%1)throw TypeError(NO_INT);return qi.round(zi)},"Fraction, BigNumber":function(qi,zi){if(!zi.isInteger())throw TypeError(NO_INT);return qi.round(zi.toNumber())},"Unit, number, Unit":E.referToSelf(qi=>function(zi,Hi,Qi){var Gi=zi.toNumeric(Qi);return Qi.multiply(qi(Gi,Hi))}),"Unit, BigNumber, Unit":E.referToSelf(qi=>(zi,Hi,Qi)=>qi(zi,Hi.toNumber(),Qi)),"Array | Matrix, number | BigNumber, Unit":E.referToSelf(qi=>(zi,Hi,Qi)=>deepMap(zi,Gi=>qi(Gi,Hi,Qi),!0)),"Array | Matrix | Unit, Unit":E.referToSelf(qi=>(zi,Hi)=>qi(zi,0,Hi)),"Array | Matrix":E.referToSelf(qi=>zi=>deepMap(zi,qi,!0)),"SparseMatrix, number | BigNumber":E.referToSelf(qi=>(zi,Hi)=>Or(zi,Hi,qi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(qi=>(zi,Hi)=>dn(zi,Hi,qi,!1)),"Array, number | BigNumber":E.referToSelf(qi=>(zi,Hi)=>dn(J(zi),Hi,qi,!1).valueOf()),"number | Complex | BigNumber | Fraction, SparseMatrix":E.referToSelf(qi=>(zi,Hi)=>$e(zi,0)?_t(Hi.size(),Hi.storage()):Pr(Hi,zi,qi,!0)),"number | Complex | BigNumber | Fraction, DenseMatrix":E.referToSelf(qi=>(zi,Hi)=>$e(zi,0)?_t(Hi.size(),Hi.storage()):dn(Hi,zi,qi,!0)),"number | Complex | BigNumber | Fraction, Array":E.referToSelf(qi=>(zi,Hi)=>dn(J(Hi),zi,qi,!0).valueOf())})}),name$190="log",dependencies$190=["config","typed","typeOf","divideScalar","Complex"],nlg16=Math.log(16),createLog=factory(name$190,dependencies$190,D=>{var{typed:E,typeOf:F,config:J,divideScalar:$e,Complex:_t}=D;function lr(Or){return Or.log()}function mr(Or){return lr(new _t(Or,0))}return E(name$190,{number:function(Or){return Or>=0||J.predictable?logNumber(Or):mr(Or)},bigint:promoteLogarithm(nlg16,logNumber,J,mr),Complex:lr,BigNumber:function(Or){return!Or.isNegative()||J.predictable?Or.ln():mr(Or.toNumber())},"any, any":E.referToSelf(Or=>(Pr,dn)=>{if(F(Pr)==="Fraction"&&F(dn)==="Fraction"){var gi=Pr.log(dn);if(gi!==null)return gi}return $e(Or(Pr),Or(dn))})})}),name$189="log1p",dependencies$189=["typed","config","divideScalar","log","Complex"],createLog1p=factory(name$189,dependencies$189,D=>{var{typed:E,config:F,divideScalar:J,log:$e,Complex:_t}=D;return E(name$189,{number:function(mr){return mr>=-1||F.predictable?log1p(mr):lr(new _t(mr,0))},Complex:lr,BigNumber:function(mr){var Or=mr.plus(1);return!Or.isNegative()||F.predictable?Or.ln():lr(new _t(mr.toNumber(),0))},"Array | Matrix":E.referToSelf(mr=>Or=>deepMap(Or,mr)),"any, any":E.referToSelf(mr=>(Or,Pr)=>J(mr(Or),$e(Pr)))});function lr(mr){var Or=mr.re+1;return new _t(Math.log(Math.sqrt(Or*Or+mr.im*mr.im)),Math.atan2(mr.im,Or))}}),name$188="nthRoots",dependencies$188=["config","typed","divideScalar","Complex"],createNthRoots=factory(name$188,dependencies$188,D=>{var{typed:E,config:F,divideScalar:J,Complex:$e}=D,_t=[function(mr){return new $e(mr,0)},function(mr){return new $e(0,mr)},function(mr){return new $e(-mr,0)},function(mr){return new $e(0,-mr)}];function lr(mr,Or){if(Or<0)throw Error("Root must be greater than zero");if(Or===0)throw Error("Root must be non-zero");if(Or%1!=0)throw Error("Root must be an integer");if(mr===0||mr.abs()===0)return[new $e(0,0)];var Pr=typeof mr=="number",dn;(Pr||mr.re===0||mr.im===0)&&(dn=Pr?2*(mr<0):mr.im===0?2*(mr.re<0):2*(mr.im<0)+1);for(var gi=mr.arg(),qi=mr.abs(),zi=[],Hi=qi**(1/Or),Qi=0;Qi<Or;Qi++){var Gi=(dn+4*Qi)/Or;if(Gi===Math.round(Gi)){zi.push(_t[Gi%4](Hi));continue}zi.push(new $e({r:Hi,phi:(gi+2*Math.PI*Qi)/Or}))}return zi}return E(name$188,{Complex:function(mr){return lr(mr,2)},"Complex, number":lr})}),name$187="dotPow",dependencies$187=["typed","equalScalar","matrix","pow","DenseMatrix","concat","SparseMatrix"],createDotPow=factory(name$187,dependencies$187,D=>{var{typed:E,equalScalar:F,matrix:J,pow:$e,DenseMatrix:_t,concat:lr,SparseMatrix:mr}=D,Or=createMatAlgo03xDSf({typed:E}),Pr=createMatAlgo07xSSf({typed:E,SparseMatrix:mr}),dn=createMatAlgo11xS0s({typed:E,equalScalar:F}),gi=createMatAlgo12xSfs({typed:E,DenseMatrix:_t}),qi=createMatrixAlgorithmSuite({typed:E,matrix:J,concat:lr}),zi={};for(var Hi in $e.signatures)Object.prototype.hasOwnProperty.call($e.signatures,Hi)&&!Hi.includes("Matrix")&&!Hi.includes("Array")&&(zi[Hi]=$e.signatures[Hi]);return E(name$187,qi({elop:E(zi),SS:Pr,DS:Or,Ss:dn,sS:gi}))}),name$186="dotDivide",dependencies$186=["typed","matrix","equalScalar","divideScalar","DenseMatrix","concat","SparseMatrix"],createDotDivide=factory(name$186,dependencies$186,D=>{var{typed:E,matrix:F,equalScalar:J,divideScalar:$e,DenseMatrix:_t,concat:lr,SparseMatrix:mr}=D,Or=createMatAlgo02xDS0({typed:E,equalScalar:J}),Pr=createMatAlgo03xDSf({typed:E}),dn=createMatAlgo07xSSf({typed:E,SparseMatrix:mr}),gi=createMatAlgo11xS0s({typed:E,equalScalar:J}),qi=createMatAlgo12xSfs({typed:E,DenseMatrix:_t});return E(name$186,createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr})({elop:$e,SS:dn,DS:Pr,SD:Or,Ss:gi,sS:qi}))});function createSolveValidation(D){var{DenseMatrix:E}=D;return function(F,J,$e){var _t=F.size();if(_t.length!==2)throw RangeError("Matrix must be two dimensional (size: "+format(_t)+")");var lr=_t[0];if(lr!==_t[1])throw RangeError("Matrix must be square (size: "+format(_t)+")");var mr=[];if(isMatrix(J)){var Or=J.size(),Pr=J._data;if(Or.length===1){if(Or[0]!==lr)throw RangeError("Dimension mismatch. Matrix columns must match vector length.");for(var dn=0;dn<lr;dn++)mr[dn]=[Pr[dn]];return new E({data:mr,size:[lr,1],datatype:J._datatype})}if(Or.length===2){if(Or[0]!==lr||Or[1]!==1)throw RangeError("Dimension mismatch. Matrix columns must match vector length.");if(isDenseMatrix(J)){if($e){mr=[];for(var gi=0;gi<lr;gi++)mr[gi]=[Pr[gi][0]];return new E({data:mr,size:[lr,1],datatype:J._datatype})}return J}if(isSparseMatrix(J)){for(var qi=0;qi<lr;qi++)mr[qi]=[0];for(var zi=J._values,Hi=J._index,Qi=J._ptr,Gi=Qi[1],Zi=Qi[0];Zi<Gi;Zi++){var Xi=Hi[Zi];mr[Xi][0]=zi[Zi]}return new E({data:mr,size:[lr,1],datatype:J._datatype})}}throw RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.")}if(isArray(J)){var Ki=arraySize(J);if(Ki.length===1){if(Ki[0]!==lr)throw RangeError("Dimension mismatch. Matrix columns must match vector length.");for(var ea=0;ea<lr;ea++)mr[ea]=[J[ea]];return new E({data:mr,size:[lr,1]})}if(Ki.length===2){if(Ki[0]!==lr||Ki[1]!==1)throw RangeError("Dimension mismatch. Matrix columns must match vector length.");for(var Ji=0;Ji<lr;Ji++)mr[Ji]=[J[Ji][0]];return new E({data:mr,size:[lr,1]})}throw RangeError("Dimension mismatch. The right side has to be either 1- or 2-dimensional vector.")}}}var name$185="lsolve",dependencies$185=["typed","matrix","divideScalar","multiplyScalar","subtractScalar","equalScalar","DenseMatrix"],createLsolve=factory(name$185,dependencies$185,D=>{var{typed:E,matrix:F,divideScalar:J,multiplyScalar:$e,subtractScalar:_t,equalScalar:lr,DenseMatrix:mr}=D,Or=createSolveValidation({DenseMatrix:mr});return E(name$185,{"SparseMatrix, Array | Matrix":function(gi,qi){return dn(gi,qi)},"DenseMatrix, Array | Matrix":function(gi,qi){return Pr(gi,qi)},"Array, Array | Matrix":function(gi,qi){return Pr(F(gi),qi).valueOf()}});function Pr(gi,qi){qi=Or(gi,qi,!0);for(var zi=qi._data,Hi=gi._size[0],Qi=gi._size[1],Gi=[],Zi=gi._data,Xi=0;Xi<Qi;Xi++){var Ki=zi[Xi][0]||0,ea=void 0;if(lr(Ki,0))ea=0;else{var Ji=Zi[Xi][Xi];if(lr(Ji,0))throw Error("Linear system cannot be solved since matrix is singular");ea=J(Ki,Ji);for(var ta=Xi+1;ta<Hi;ta++)zi[ta]=[_t(zi[ta][0]||0,$e(ea,Zi[ta][Xi]))]}Gi[Xi]=[ea]}return new mr({data:Gi,size:[Hi,1]})}function dn(gi,qi){qi=Or(gi,qi,!0);for(var zi=qi._data,Hi=gi._size[0],Qi=gi._size[1],Gi=gi._values,Zi=gi._index,Xi=gi._ptr,Ki=[],ea=0;ea<Qi;ea++){var Ji=zi[ea][0]||0;if(lr(Ji,0))Ki[ea]=[0];else{for(var ta=0,na=[],ra=[],ia=Xi[ea],oa=Xi[ea+1],ua=ia;ua<oa;ua++){var sa=Zi[ua];sa===ea?ta=Gi[ua]:sa>ea&&(na.push(Gi[ua]),ra.push(sa))}if(lr(ta,0))throw Error("Linear system cannot be solved since matrix is singular");for(var aa=J(Ji,ta),pa=0,ma=ra.length;pa<ma;pa++){var la=ra[pa];zi[la]=[_t(zi[la][0]||0,$e(aa,na[pa]))]}Ki[ea]=[aa]}}return new mr({data:Ki,size:[Hi,1]})}}),name$184="usolve",dependencies$184=["typed","matrix","divideScalar","multiplyScalar","subtractScalar","equalScalar","DenseMatrix"],createUsolve=factory(name$184,dependencies$184,D=>{var{typed:E,matrix:F,divideScalar:J,multiplyScalar:$e,subtractScalar:_t,equalScalar:lr,DenseMatrix:mr}=D,Or=createSolveValidation({DenseMatrix:mr});return E(name$184,{"SparseMatrix, Array | Matrix":function(gi,qi){return dn(gi,qi)},"DenseMatrix, Array | Matrix":function(gi,qi){return Pr(gi,qi)},"Array, Array | Matrix":function(gi,qi){return Pr(F(gi),qi).valueOf()}});function Pr(gi,qi){qi=Or(gi,qi,!0);for(var zi=qi._data,Hi=gi._size[0],Qi=gi._size[1],Gi=[],Zi=gi._data,Xi=Qi-1;Xi>=0;Xi--){var Ki=zi[Xi][0]||0,ea=void 0;if(lr(Ki,0))ea=0;else{var Ji=Zi[Xi][Xi];if(lr(Ji,0))throw Error("Linear system cannot be solved since matrix is singular");ea=J(Ki,Ji);for(var ta=Xi-1;ta>=0;ta--)zi[ta]=[_t(zi[ta][0]||0,$e(ea,Zi[ta][Xi]))]}Gi[Xi]=[ea]}return new mr({data:Gi,size:[Hi,1]})}function dn(gi,qi){qi=Or(gi,qi,!0);for(var zi=qi._data,Hi=gi._size[0],Qi=gi._size[1],Gi=gi._values,Zi=gi._index,Xi=gi._ptr,Ki=[],ea=Qi-1;ea>=0;ea--){var Ji=zi[ea][0]||0;if(lr(Ji,0))Ki[ea]=[0];else{for(var ta=0,na=[],ra=[],ia=Xi[ea],oa=Xi[ea+1]-1;oa>=ia;oa--){var ua=Zi[oa];ua===ea?ta=Gi[oa]:ua<ea&&(na.push(Gi[oa]),ra.push(ua))}if(lr(ta,0))throw Error("Linear system cannot be solved since matrix is singular");for(var sa=J(Ji,ta),aa=0,pa=ra.length;aa<pa;aa++){var ma=ra[aa];zi[ma]=[_t(zi[ma][0],$e(sa,na[aa]))]}Ki[ea]=[sa]}}return new mr({data:Ki,size:[Hi,1]})}}),name$183="lsolveAll",dependencies$183=["typed","matrix","divideScalar","multiplyScalar","subtractScalar","equalScalar","DenseMatrix"],createLsolveAll=factory(name$183,dependencies$183,D=>{var{typed:E,matrix:F,divideScalar:J,multiplyScalar:$e,subtractScalar:_t,equalScalar:lr,DenseMatrix:mr}=D,Or=createSolveValidation({DenseMatrix:mr});return E(name$183,{"SparseMatrix, Array | Matrix":function(gi,qi){return dn(gi,qi)},"DenseMatrix, Array | Matrix":function(gi,qi){return Pr(gi,qi)},"Array, Array | Matrix":function(gi,qi){return Pr(F(gi),qi).map(zi=>zi.valueOf())}});function Pr(gi,qi){for(var zi=[Or(gi,qi,!0)._data.map(ra=>ra[0])],Hi=gi._data,Qi=gi._size[0],Gi=gi._size[1],Zi=0;Zi<Gi;Zi++)for(var Xi=zi.length,Ki=0;Ki<Xi;Ki++){var ea=zi[Ki];if(lr(Hi[Zi][Zi],0))if(lr(ea[Zi],0)){if(Ki===0){var ta=[...ea];ta[Zi]=1;for(var na=Zi+1;na<Gi;na++)ta[na]=_t(ta[na],Hi[na][Zi]);zi.push(ta)}}else{if(Ki===0)return[];zi.splice(Ki,1),--Ki,--Xi}else{ea[Zi]=J(ea[Zi],Hi[Zi][Zi]);for(var Ji=Zi+1;Ji<Gi;Ji++)ea[Ji]=_t(ea[Ji],$e(ea[Zi],Hi[Ji][Zi]))}}return zi.map(ra=>new mr({data:ra.map(ia=>[ia]),size:[Qi,1]}))}function dn(gi,qi){for(var zi=[Or(gi,qi,!0)._data.map($a=>$a[0])],Hi=gi._size[0],Qi=gi._size[1],Gi=gi._values,Zi=gi._index,Xi=gi._ptr,Ki=0;Ki<Qi;Ki++)for(var ea=zi.length,Ji=0;Ji<ea;Ji++){for(var ta=zi[Ji],na=[],ra=[],ia=Xi[Ki],oa=Xi[Ki+1],ua=0,sa=ia;sa<oa;sa++){var aa=Zi[sa];aa===Ki?ua=Gi[sa]:aa>Ki&&(na.push(Gi[sa]),ra.push(aa))}if(lr(ua,0))if(lr(ta[Ki],0)){if(Ji===0){var ha=[...ta];ha[Ki]=1;for(var ga=0,Aa=ra.length;ga<Aa;ga++){var Fa=ra[ga];ha[Fa]=_t(ha[Fa],na[ga])}zi.push(ha)}}else{if(Ji===0)return[];zi.splice(Ji,1),--Ji,--ea}else{ta[Ki]=J(ta[Ki],ua);for(var pa=0,ma=ra.length;pa<ma;pa++){var la=ra[pa];ta[la]=_t(ta[la],$e(ta[Ki],na[pa]))}}}return zi.map($a=>new mr({data:$a.map(_a=>[_a]),size:[Hi,1]}))}}),name$182="usolveAll",dependencies$182=["typed","matrix","divideScalar","multiplyScalar","subtractScalar","equalScalar","DenseMatrix"],createUsolveAll=factory(name$182,dependencies$182,D=>{var{typed:E,matrix:F,divideScalar:J,multiplyScalar:$e,subtractScalar:_t,equalScalar:lr,DenseMatrix:mr}=D,Or=createSolveValidation({DenseMatrix:mr});return E(name$182,{"SparseMatrix, Array | Matrix":function(gi,qi){return dn(gi,qi)},"DenseMatrix, Array | Matrix":function(gi,qi){return Pr(gi,qi)},"Array, Array | Matrix":function(gi,qi){return Pr(F(gi),qi).map(zi=>zi.valueOf())}});function Pr(gi,qi){for(var zi=[Or(gi,qi,!0)._data.map(na=>na[0])],Hi=gi._data,Qi=gi._size[0],Gi=gi._size[1]-1;Gi>=0;Gi--)for(var Zi=zi.length,Xi=0;Xi<Zi;Xi++){var Ki=zi[Xi];if(lr(Hi[Gi][Gi],0))if(lr(Ki[Gi],0)){if(Xi===0){var Ji=[...Ki];Ji[Gi]=1;for(var ta=Gi-1;ta>=0;ta--)Ji[ta]=_t(Ji[ta],Hi[ta][Gi]);zi.push(Ji)}}else{if(Xi===0)return[];zi.splice(Xi,1),--Xi,--Zi}else{Ki[Gi]=J(Ki[Gi],Hi[Gi][Gi]);for(var ea=Gi-1;ea>=0;ea--)Ki[ea]=_t(Ki[ea],$e(Ki[Gi],Hi[ea][Gi]))}}return zi.map(na=>new mr({data:na.map(ra=>[ra]),size:[Qi,1]}))}function dn(gi,qi){for(var zi=[Or(gi,qi,!0)._data.map($a=>$a[0])],Hi=gi._size[0],Qi=gi._size[1],Gi=gi._values,Zi=gi._index,Xi=gi._ptr,Ki=Qi-1;Ki>=0;Ki--)for(var ea=zi.length,Ji=0;Ji<ea;Ji++){for(var ta=zi[Ji],na=[],ra=[],ia=Xi[Ki],oa=Xi[Ki+1],ua=0,sa=oa-1;sa>=ia;sa--){var aa=Zi[sa];aa===Ki?ua=Gi[sa]:aa<Ki&&(na.push(Gi[sa]),ra.push(aa))}if(lr(ua,0))if(lr(ta[Ki],0)){if(Ji===0){var ha=[...ta];ha[Ki]=1;for(var ga=0,Aa=ra.length;ga<Aa;ga++){var Fa=ra[ga];ha[Fa]=_t(ha[Fa],na[ga])}zi.push(ha)}}else{if(Ji===0)return[];zi.splice(Ji,1),--Ji,--ea}else{ta[Ki]=J(ta[Ki],ua);for(var pa=0,ma=ra.length;pa<ma;pa++){var la=ra[pa];ta[la]=_t(ta[la],$e(ta[Ki],na[pa]))}}}return zi.map($a=>new mr({data:$a.map(_a=>[_a]),size:[Hi,1]}))}}),name$181="matAlgo08xS0Sid",dependencies$181=["typed","equalScalar"],createMatAlgo08xS0Sid=factory(name$181,dependencies$181,D=>{var{typed:E,equalScalar:F}=D;return function(J,$e,_t){var lr=J._values,mr=J._index,Or=J._ptr,Pr=J._size,dn=J._datatype||J._data===void 0?J._datatype:J.getDataType(),gi=$e._values,qi=$e._index,zi=$e._ptr,Hi=$e._size,Qi=$e._datatype||$e._data===void 0?$e._datatype:$e.getDataType();if(Pr.length!==Hi.length)throw new DimensionError(Pr.length,Hi.length);if(Pr[0]!==Hi[0]||Pr[1]!==Hi[1])throw RangeError("Dimension mismatch. Matrix A ("+Pr+") must match Matrix B ("+Hi+")");if(!lr||!gi)throw Error("Cannot perform operation on Pattern Sparse Matrices");var Gi=Pr[0],Zi=Pr[1],Xi,Ki=F,ea=0,Ji=_t;typeof dn=="string"&&dn===Qi&&dn!=="mixed"&&(Xi=dn,Ki=E.find(F,[Xi,Xi]),ea=E.convert(0,Xi),Ji=E.find(_t,[Xi,Xi]));for(var ta=[],na=[],ra=[],ia=[],oa=[],ua,sa,aa,pa,ma=0;ma<Zi;ma++){ra[ma]=na.length;var la=ma+1;for(sa=Or[ma],aa=Or[ma+1],ua=sa;ua<aa;ua++)pa=mr[ua],oa[pa]=la,ia[pa]=lr[ua],na.push(pa);for(sa=zi[ma],aa=zi[ma+1],ua=sa;ua<aa;ua++)pa=qi[ua],oa[pa]===la&&(ia[pa]=Ji(ia[pa],gi[ua]));for(ua=ra[ma];ua<na.length;){pa=na[ua];var ha=ia[pa];Ki(ha,ea)?na.splice(ua,1):(ta.push(ha),ua++)}}return ra[Zi]=na.length,J.createSparseMatrix({values:ta,index:na,ptr:ra,size:[Gi,Zi],datatype:dn===J._datatype&&Qi===$e._datatype?Xi:void 0})}}),createUseMatrixForArrayScalar=factory("useMatrixForArrayScalar",["typed","matrix"],D=>{var{typed:E,matrix:F}=D;return{"Array, number":E.referTo("DenseMatrix, number",J=>($e,_t)=>J(F($e),_t).valueOf()),"Array, BigNumber":E.referTo("DenseMatrix, BigNumber",J=>($e,_t)=>J(F($e),_t).valueOf()),"number, Array":E.referTo("number, DenseMatrix",J=>($e,_t)=>J($e,F(_t)).valueOf()),"BigNumber, Array":E.referTo("BigNumber, DenseMatrix",J=>($e,_t)=>J($e,F(_t)).valueOf())}}),name$180="leftShift",dependencies$180=["typed","matrix","equalScalar","zeros","DenseMatrix","concat"],createLeftShift=factory(name$180,dependencies$180,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,DenseMatrix:_t,concat:lr}=D,mr=createMatAlgo01xDSid({typed:E}),Or=createMatAlgo02xDS0({typed:E,equalScalar:J}),Pr=createMatAlgo08xS0Sid({typed:E,equalScalar:J}),dn=createMatAlgo10xSids({typed:E,DenseMatrix:_t}),gi=createMatAlgo11xS0s({typed:E,equalScalar:J}),qi=createMatAlgo14xDs({typed:E}),zi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr}),Hi=createUseMatrixForArrayScalar({typed:E,matrix:F});return E(name$180,{"number, number":leftShiftNumber,"BigNumber, BigNumber":leftShiftBigNumber,"bigint, bigint":(Qi,Gi)=>Qi<<Gi,"SparseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():gi(Gi,Zi,Qi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():qi(Gi,Zi,Qi,!1)),"number | BigNumber, SparseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):dn(Zi,Gi,Qi,!0)),"number | BigNumber, DenseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):qi(Zi,Gi,Qi,!0))},Hi,zi({SS:Pr,DS:mr,SD:Or}))}),name$179="rightArithShift",dependencies$179=["typed","matrix","equalScalar","zeros","DenseMatrix","concat"],createRightArithShift=factory(name$179,dependencies$179,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,DenseMatrix:_t,concat:lr}=D,mr=createMatAlgo01xDSid({typed:E}),Or=createMatAlgo02xDS0({typed:E,equalScalar:J}),Pr=createMatAlgo08xS0Sid({typed:E,equalScalar:J}),dn=createMatAlgo10xSids({typed:E,DenseMatrix:_t}),gi=createMatAlgo11xS0s({typed:E,equalScalar:J}),qi=createMatAlgo14xDs({typed:E}),zi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr}),Hi=createUseMatrixForArrayScalar({typed:E,matrix:F});return E(name$179,{"number, number":rightArithShiftNumber,"BigNumber, BigNumber":rightArithShiftBigNumber,"bigint, bigint":(Qi,Gi)=>Qi>>Gi,"SparseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():gi(Gi,Zi,Qi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():qi(Gi,Zi,Qi,!1)),"number | BigNumber, SparseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):dn(Zi,Gi,Qi,!0)),"number | BigNumber, DenseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):qi(Zi,Gi,Qi,!0))},Hi,zi({SS:Pr,DS:mr,SD:Or}))}),name$178="rightLogShift",dependencies$178=["typed","matrix","equalScalar","zeros","DenseMatrix","concat"],createRightLogShift=factory(name$178,dependencies$178,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,DenseMatrix:_t,concat:lr}=D,mr=createMatAlgo01xDSid({typed:E}),Or=createMatAlgo02xDS0({typed:E,equalScalar:J}),Pr=createMatAlgo08xS0Sid({typed:E,equalScalar:J}),dn=createMatAlgo10xSids({typed:E,DenseMatrix:_t}),gi=createMatAlgo11xS0s({typed:E,equalScalar:J}),qi=createMatAlgo14xDs({typed:E}),zi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr}),Hi=createUseMatrixForArrayScalar({typed:E,matrix:F});return E(name$178,{"number, number":rightLogShiftNumber,"SparseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():gi(Gi,Zi,Qi,!1)),"DenseMatrix, number | BigNumber":E.referToSelf(Qi=>(Gi,Zi)=>J(Zi,0)?Gi.clone():qi(Gi,Zi,Qi,!1)),"number | BigNumber, SparseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):dn(Zi,Gi,Qi,!0)),"number | BigNumber, DenseMatrix":E.referToSelf(Qi=>(Gi,Zi)=>J(Gi,0)?$e(Zi.size(),Zi.storage()):qi(Zi,Gi,Qi,!0))},Hi,zi({SS:Pr,DS:mr,SD:Or}))}),name$177="and",dependencies$177=["typed","matrix","equalScalar","zeros","not","concat"],createAnd=factory(name$177,dependencies$177,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,not:_t,concat:lr}=D,mr=createMatAlgo02xDS0({typed:E,equalScalar:J}),Or=createMatAlgo06xS0S0({typed:E,equalScalar:J}),Pr=createMatAlgo11xS0s({typed:E,equalScalar:J}),dn=createMatAlgo14xDs({typed:E}),gi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr});return E(name$177,{"number, number":andNumber,"Complex, Complex":function(qi,zi){return(qi.re!==0||qi.im!==0)&&(zi.re!==0||zi.im!==0)},"BigNumber, BigNumber":function(qi,zi){return!qi.isZero()&&!zi.isZero()&&!qi.isNaN()&&!zi.isNaN()},"bigint, bigint":andNumber,"Unit, Unit":E.referToSelf(qi=>(zi,Hi)=>qi(zi.value||0,Hi.value||0)),"SparseMatrix, any":E.referToSelf(qi=>(zi,Hi)=>_t(Hi)?$e(zi.size(),zi.storage()):Pr(zi,Hi,qi,!1)),"DenseMatrix, any":E.referToSelf(qi=>(zi,Hi)=>_t(Hi)?$e(zi.size(),zi.storage()):dn(zi,Hi,qi,!1)),"any, SparseMatrix":E.referToSelf(qi=>(zi,Hi)=>_t(zi)?$e(zi.size(),zi.storage()):Pr(Hi,zi,qi,!0)),"any, DenseMatrix":E.referToSelf(qi=>(zi,Hi)=>_t(zi)?$e(zi.size(),zi.storage()):dn(Hi,zi,qi,!0)),"Array, any":E.referToSelf(qi=>(zi,Hi)=>qi(F(zi),Hi).valueOf()),"any, Array":E.referToSelf(qi=>(zi,Hi)=>qi(zi,F(Hi)).valueOf())},gi({SS:Or,DS:mr}))}),name$176="compare",dependencies$176=["typed","config","matrix","equalScalar","BigNumber","Fraction","DenseMatrix","concat"],createCompare=factory(name$176,dependencies$176,D=>{var{typed:E,config:F,equalScalar:J,matrix:$e,BigNumber:_t,Fraction:lr,DenseMatrix:mr,concat:Or}=D,Pr=createMatAlgo03xDSf({typed:E}),dn=createMatAlgo05xSfSf({typed:E,equalScalar:J}),gi=createMatAlgo12xSfs({typed:E,DenseMatrix:mr}),qi=createMatrixAlgorithmSuite({typed:E,matrix:$e,concat:Or}),zi=createCompareUnits({typed:E});return E(name$176,createCompareNumber({typed:E,config:F}),{"boolean, boolean":function(Hi,Qi){return Hi===Qi?0:Hi>Qi?1:-1},"BigNumber, BigNumber":function(Hi,Qi){return nearlyEqual(Hi,Qi,F.relTol,F.absTol)?new _t(0):new _t(Hi.cmp(Qi))},"bigint, bigint":function(Hi,Qi){return Hi===Qi?0n:Hi>Qi?1n:-1n},"Fraction, Fraction":function(Hi,Qi){return new lr(Hi.compare(Qi))},"Complex, Complex":function(){throw TypeError("No ordering relation is defined for complex numbers")}},zi,qi({SS:dn,DS:Pr,Ss:gi}))}),createCompareNumber=factory(name$176,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$176,{"number, number":function(J,$e){return nearlyEqual$1(J,$e,F.relTol,F.absTol)?0:J>$e?1:-1}})}),require_naturalSort=__commonJSMin(((D,E)=>{E.exports=function F(J,$e){var _t=/(^([+\\-]?(?:0|[1-9]\\d*)(?:\\.\\d*)?(?:[eE][+\\-]?\\d+)?)?$|^0x[0-9a-f]+$|\\d+)/gi,lr=/(^[ ]*|[ ]*$)/g,mr=/(^([\\w ]+,?[\\w ]+)?[\\w ]+,?[\\w ]+\\d+:\\d+(:\\d+)?[\\w ]?|^\\d{1,4}[\\/\\-]\\d{1,4}[\\/\\-]\\d{1,4}|^\\w+, \\w+ \\d+, \\d{4})/,Or=/^0x[0-9a-f]+$/i,Pr=/^0/,dn=function(Ji){return F.insensitive&&(""+Ji).toLowerCase()||""+Ji},gi=dn(J).replace(lr,"")||"",qi=dn($e).replace(lr,"")||"",zi=gi.replace(_t,"\\0$1\\0").replace(/\\0$/,"").replace(/^\\0/,"").split("\\0"),Hi=qi.replace(_t,"\\0$1\\0").replace(/\\0$/,"").replace(/^\\0/,"").split("\\0"),Qi=parseInt(gi.match(Or),16)||zi.length!==1&&gi.match(mr)&&Date.parse(gi),Gi=parseInt(qi.match(Or),16)||Qi&&qi.match(mr)&&Date.parse(qi)||null,Zi,Xi;if(Gi){if(Qi<Gi)return-1;if(Qi>Gi)return 1}for(var Ki=0,ea=Math.max(zi.length,Hi.length);Ki<ea;Ki++){if(Zi=!(zi[Ki]||"").match(Pr)&&parseFloat(zi[Ki])||zi[Ki]||0,Xi=!(Hi[Ki]||"").match(Pr)&&parseFloat(Hi[Ki])||Hi[Ki]||0,isNaN(Zi)!==isNaN(Xi))return isNaN(Zi)?1:-1;if(typeof Zi!=typeof Xi&&(Zi+="",Xi+=""),Zi<Xi)return-1;if(Zi>Xi)return 1}return 0}})),import_naturalSort=__toESM(require_naturalSort()),name$175="compareNatural",dependencies$175=["typed","compare"],createCompareNatural=factory(name$175,dependencies$175,D=>{var{typed:E,compare:F}=D,J=F.signatures["boolean,boolean"];return E(name$175,{"any, any":$e});function $e(Or,Pr){var dn=typeOf(Or),gi=typeOf(Pr),qi;if((dn==="number"||dn==="BigNumber"||dn==="Fraction"||dn==="bigint")&&(gi==="number"||gi==="BigNumber"||gi==="Fraction"||gi==="bigint"))return qi=F(Or,Pr),qi.toString()==="0"?(0,import_naturalSort.default)(dn,gi):qi>0?1:-1;var zi=["Array","DenseMatrix","SparseMatrix"];if(zi.includes(dn)||zi.includes(gi))return qi=_t($e,Or,Pr),qi===0?(0,import_naturalSort.default)(dn,gi):qi;if(dn!==gi)return(0,import_naturalSort.default)(dn,gi);if(dn==="Complex")return compareComplexNumbers(Or,Pr);if(dn==="Unit")return Or.equalBase(Pr)?$e(Or.value,Pr.value):lr($e,Or.formatUnits(),Pr.formatUnits());if(dn==="boolean")return J(Or,Pr);if(dn==="string")return(0,import_naturalSort.default)(Or,Pr);if(dn==="Object")return mr($e,Or,Pr);if(dn==="null"||dn==="undefined")return 0;throw TypeError(\'Unsupported type of value "\'+dn+\'"\')}function _t(Or,Pr,dn){return isSparseMatrix(Pr)&&isSparseMatrix(dn)?lr(Or,Pr.toJSON().values,dn.toJSON().values):isSparseMatrix(Pr)?_t(Or,Pr.toArray(),dn):isSparseMatrix(dn)?_t(Or,Pr,dn.toArray()):isDenseMatrix(Pr)?_t(Or,Pr.toJSON().data,dn):isDenseMatrix(dn)?_t(Or,Pr,dn.toJSON().data):Array.isArray(Pr)?Array.isArray(dn)?lr(Or,Pr,dn):_t(Or,Pr,[dn]):_t(Or,[Pr],dn)}function lr(Or,Pr,dn){for(var gi=0,qi=Math.min(Pr.length,dn.length);gi<qi;gi++){var zi=Or(Pr[gi],dn[gi]);if(zi!==0)return zi}return Pr.length>dn.length?1:Pr.length<dn.length?-1:0}function mr(Or,Pr,dn){var gi=Object.keys(Pr),qi=Object.keys(dn);gi.sort(import_naturalSort.default),qi.sort(import_naturalSort.default);var zi=lr(Or,gi,qi);if(zi!==0)return zi;for(var Hi=0;Hi<gi.length;Hi++){var Qi=Or(Pr[gi[Hi]],dn[qi[Hi]]);if(Qi!==0)return Qi}return 0}});function compareComplexNumbers(D,E){return D.re>E.re?1:D.re<E.re?-1:D.im>E.im?1:D.im<E.im?-1:0}var name$174="compareText",dependencies$174=["typed","matrix","concat"];compareText.signature="any, any";var createCompareText=factory(name$174,dependencies$174,D=>{var{typed:E,matrix:F,concat:J}=D;return E(name$174,compareText,createMatrixAlgorithmSuite({typed:E,matrix:F,concat:J})({elop:compareText,Ds:!0}))}),name$173="equal",dependencies$173=["typed","matrix","equalScalar","DenseMatrix","SparseMatrix"],createEqual=factory(name$173,dependencies$173,D=>{var{typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t,SparseMatrix:lr}=D,mr=createMatAlgo03xDSf({typed:E}),Or=createMatAlgo07xSSf({typed:E,SparseMatrix:lr}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:$e}),dn=createMatrixAlgorithmSuite({typed:E,matrix:F});return E(name$173,createEqualNumber({typed:E,equalScalar:J}),dn({elop:J,SS:Or,DS:mr,Ss:Pr}))}),createEqualNumber=factory(name$173,["typed","equalScalar"],D=>{var{typed:E,equalScalar:F}=D;return E(name$173,{"any, any":function(J,$e){return J===null?$e===null:$e===null?J===null:J===void 0?$e===void 0:$e===void 0?J===void 0:F(J,$e)}})}),name$172="equalText",dependencies$172=["typed","compareText","isZero"],createEqualText=factory(name$172,dependencies$172,D=>{var{typed:E,compareText:F,isZero:J}=D;return E(name$172,{"any, any":function($e,_t){return J(F($e,_t))}})}),name$171="smaller",dependencies$171=["typed","config","bignumber","matrix","DenseMatrix","concat","SparseMatrix"],createSmaller=factory(name$171,dependencies$171,D=>{var{typed:E,config:F,bignumber:J,matrix:$e,DenseMatrix:_t,concat:lr,SparseMatrix:mr}=D,Or=createMatAlgo03xDSf({typed:E}),Pr=createMatAlgo07xSSf({typed:E,SparseMatrix:mr}),dn=createMatAlgo12xSfs({typed:E,DenseMatrix:_t}),gi=createMatrixAlgorithmSuite({typed:E,matrix:$e,concat:lr}),qi=createCompareUnits({typed:E});function zi(Hi,Qi){return Hi.lt(Qi)&&!nearlyEqual(Hi,Qi,F.relTol,F.absTol)}return E(name$171,createSmallerNumber({typed:E,config:F}),{"boolean, boolean":(Hi,Qi)=>Hi<Qi,"BigNumber, BigNumber":zi,"bigint, bigint":(Hi,Qi)=>Hi<Qi,"Fraction, Fraction":(Hi,Qi)=>Hi.compare(Qi)===-1,"Fraction, BigNumber":function(Hi,Qi){return zi(J(Hi),Qi)},"BigNumber, Fraction":function(Hi,Qi){return zi(Hi,J(Qi))},"Complex, Complex":function(Hi,Qi){throw TypeError("No ordering relation is defined for complex numbers")}},qi,gi({SS:Pr,DS:Or,Ss:dn}))}),createSmallerNumber=factory(name$171,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$171,{"number, number":function(J,$e){return J<$e&&!nearlyEqual$1(J,$e,F.relTol,F.absTol)}})}),name$170="smallerEq",dependencies$170=["typed","config","matrix","DenseMatrix","concat","SparseMatrix"],createSmallerEq=factory(name$170,dependencies$170,D=>{var{typed:E,config:F,matrix:J,DenseMatrix:$e,concat:_t,SparseMatrix:lr}=D,mr=createMatAlgo03xDSf({typed:E}),Or=createMatAlgo07xSSf({typed:E,SparseMatrix:lr}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:$e}),dn=createMatrixAlgorithmSuite({typed:E,matrix:J,concat:_t}),gi=createCompareUnits({typed:E});return E(name$170,createSmallerEqNumber({typed:E,config:F}),{"boolean, boolean":(qi,zi)=>qi<=zi,"BigNumber, BigNumber":function(qi,zi){return qi.lte(zi)||nearlyEqual(qi,zi,F.relTol,F.absTol)},"bigint, bigint":(qi,zi)=>qi<=zi,"Fraction, Fraction":(qi,zi)=>qi.compare(zi)!==1,"Complex, Complex":function(){throw TypeError("No ordering relation is defined for complex numbers")}},gi,dn({SS:Or,DS:mr,Ss:Pr}))}),createSmallerEqNumber=factory(name$170,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$170,{"number, number":function(J,$e){return J<=$e||nearlyEqual$1(J,$e,F.relTol,F.absTol)}})}),name$169="larger",dependencies$169=["typed","config","bignumber","matrix","DenseMatrix","concat","SparseMatrix"],createLarger=factory(name$169,dependencies$169,D=>{var{typed:E,config:F,bignumber:J,matrix:$e,DenseMatrix:_t,concat:lr,SparseMatrix:mr}=D,Or=createMatAlgo03xDSf({typed:E}),Pr=createMatAlgo07xSSf({typed:E,SparseMatrix:mr}),dn=createMatAlgo12xSfs({typed:E,DenseMatrix:_t}),gi=createMatrixAlgorithmSuite({typed:E,matrix:$e,concat:lr}),qi=createCompareUnits({typed:E});function zi(Hi,Qi){return Hi.gt(Qi)&&!nearlyEqual(Hi,Qi,F.relTol,F.absTol)}return E(name$169,createLargerNumber({typed:E,config:F}),{"boolean, boolean":(Hi,Qi)=>Hi>Qi,"BigNumber, BigNumber":zi,"bigint, bigint":(Hi,Qi)=>Hi>Qi,"Fraction, Fraction":(Hi,Qi)=>Hi.compare(Qi)===1,"Fraction, BigNumber":function(Hi,Qi){return zi(J(Hi),Qi)},"BigNumber, Fraction":function(Hi,Qi){return zi(Hi,J(Qi))},"Complex, Complex":function(){throw TypeError("No ordering relation is defined for complex numbers")}},qi,gi({SS:Pr,DS:Or,Ss:dn}))}),createLargerNumber=factory(name$169,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$169,{"number, number":function(J,$e){return J>$e&&!nearlyEqual$1(J,$e,F.relTol,F.absTol)}})}),name$168="largerEq",dependencies$168=["typed","config","matrix","DenseMatrix","concat","SparseMatrix"],createLargerEq=factory(name$168,dependencies$168,D=>{var{typed:E,config:F,matrix:J,DenseMatrix:$e,concat:_t,SparseMatrix:lr}=D,mr=createMatAlgo03xDSf({typed:E}),Or=createMatAlgo07xSSf({typed:E,SparseMatrix:lr}),Pr=createMatAlgo12xSfs({typed:E,DenseMatrix:$e}),dn=createMatrixAlgorithmSuite({typed:E,matrix:J,concat:_t}),gi=createCompareUnits({typed:E});return E(name$168,createLargerEqNumber({typed:E,config:F}),{"boolean, boolean":(qi,zi)=>qi>=zi,"BigNumber, BigNumber":function(qi,zi){return qi.gte(zi)||nearlyEqual(qi,zi,F.relTol,F.absTol)},"bigint, bigint":function(qi,zi){return qi>=zi},"Fraction, Fraction":(qi,zi)=>qi.compare(zi)!==-1,"Complex, Complex":function(){throw TypeError("No ordering relation is defined for complex numbers")}},gi,dn({SS:Or,DS:mr,Ss:Pr}))}),createLargerEqNumber=factory(name$168,["typed","config"],D=>{var{typed:E,config:F}=D;return E(name$168,{"number, number":function(J,$e){return J>=$e||nearlyEqual$1(J,$e,F.relTol,F.absTol)}})}),name$167="deepEqual",dependencies$167=["typed","equal"],createDeepEqual=factory(name$167,dependencies$167,D=>{var{typed:E,equal:F}=D;return E(name$167,{"any, any":function($e,_t){return J($e.valueOf(),_t.valueOf())}});function J($e,_t){if(Array.isArray($e))if(Array.isArray(_t)){var lr=$e.length;if(lr!==_t.length)return!1;for(var mr=0;mr<lr;mr++)if(!J($e[mr],_t[mr]))return!1;return!0}else return!1;else return Array.isArray(_t)?!1:F($e,_t)}}),name$166="unequal",dependencies$166=["typed","config","equalScalar","matrix","DenseMatrix","concat","SparseMatrix"],createUnequal=factory(name$166,dependencies$166,D=>{var{typed:E,config:F,equalScalar:J,matrix:$e,DenseMatrix:_t,concat:lr,SparseMatrix:mr}=D,Or=createMatAlgo03xDSf({typed:E}),Pr=createMatAlgo07xSSf({typed:E,SparseMatrix:mr}),dn=createMatAlgo12xSfs({typed:E,DenseMatrix:_t}),gi=createMatrixAlgorithmSuite({typed:E,matrix:$e,concat:lr});return E(name$166,createUnequalNumber({typed:E,equalScalar:J}),gi({elop:qi,SS:Pr,DS:Or,Ss:dn}));function qi(zi,Hi){return!J(zi,Hi)}}),createUnequalNumber=factory(name$166,["typed","equalScalar"],D=>{var{typed:E,equalScalar:F}=D;return E(name$166,{"any, any":function(J,$e){return J===null?$e!==null:$e===null?J!==null:J===void 0?$e!==void 0:$e===void 0?J!==void 0:!F(J,$e)}})}),name$165="partitionSelect",dependencies$165=["typed","isNumeric","isNaN","compare"],createPartitionSelect=factory(name$165,dependencies$165,D=>{var{typed:E,isNumeric:F,isNaN:J,compare:$e}=D,_t=$e,lr=(Pr,dn)=>-$e(Pr,dn);return E(name$165,{"Array | Matrix, number":function(Pr,dn){return mr(Pr,dn,_t)},"Array | Matrix, number, string":function(Pr,dn,gi){if(gi==="asc")return mr(Pr,dn,_t);if(gi==="desc")return mr(Pr,dn,lr);throw Error(\'Compare string must be "asc" or "desc"\')},"Array | Matrix, number, function":mr});function mr(Pr,dn,gi){if(!isInteger(dn)||dn<0)throw Error("k must be a non-negative integer");if(isMatrix(Pr)){if(Pr.size().length>1)throw Error("Only one dimensional matrices supported");return Or(Pr.valueOf(),dn,gi)}if(Array.isArray(Pr))return Or(Pr,dn,gi)}function Or(Pr,dn,gi){if(dn>=Pr.length)throw Error("k out of bounds");for(var qi=0;qi<Pr.length;qi++)if(F(Pr[qi])&&J(Pr[qi]))return Pr[qi];for(var zi=0,Hi=Pr.length-1;zi<Hi;){for(var Qi=zi,Gi=Hi,Zi=Pr[Math.floor(Math.random()*(Hi-zi+1))+zi];Qi<Gi;)if(gi(Pr[Qi],Zi)>=0){var Xi=Pr[Gi];Pr[Gi]=Pr[Qi],Pr[Qi]=Xi,--Gi}else++Qi;gi(Pr[Qi],Zi)>0&&--Qi,dn<=Qi?Hi=Qi:zi=Qi+1}return Pr[dn]}}),name$164="sort",dependencies$164=["typed","matrix","compare","compareNatural"],createSort=factory(name$164,dependencies$164,D=>{var{typed:E,matrix:F,compare:J,compareNatural:$e}=D,_t=J,lr=(dn,gi)=>-J(dn,gi);return E(name$164,{Array:function(dn){return Or(dn),dn.sort(_t)},Matrix:function(dn){return Pr(dn),F(dn.toArray().sort(_t),dn.storage())},"Array, function":function(dn,gi){return Or(dn),dn.sort(gi)},"Matrix, function":function(dn,gi){return Pr(dn),F(dn.toArray().sort(gi),dn.storage())},"Array, string":function(dn,gi){return Or(dn),dn.sort(mr(gi))},"Matrix, string":function(dn,gi){return Pr(dn),F(dn.toArray().sort(mr(gi)),dn.storage())}});function mr(dn){if(dn==="asc")return _t;if(dn==="desc")return lr;if(dn==="natural")return $e;throw Error(\'String "asc", "desc", or "natural" expected\')}function Or(dn){if(arraySize(dn).length!==1)throw Error("One dimensional array expected")}function Pr(dn){if(dn.size().length!==1)throw Error("One dimensional matrix expected")}}),name$163="max",dependencies$163=["typed","config","numeric","larger","isNaN"],createMax=factory(name$163,dependencies$163,D=>{var{typed:E,config:F,numeric:J,larger:$e,isNaN:_t}=D;return E(name$163,{"Array | Matrix":mr,"Array | Matrix, number | BigNumber":function(Or,Pr){return reduce$1(Or,Pr.valueOf(),lr)},"...":function(Or){if(containsCollections(Or))throw TypeError("Scalar values expected in function max");return mr(Or)}});function lr(Or,Pr){try{return $e(Or,Pr)?Or:Pr}catch(dn){throw improveErrorMessage(dn,"max",Pr)}}function mr(Or){var Pr;if(deepForEach(Or,function(dn){try{(_t(dn)||Pr===void 0||$e(dn,Pr))&&(Pr=dn)}catch(gi){throw improveErrorMessage(gi,"max",dn)}}),Pr===void 0)throw Error("Cannot calculate max of an empty array");return typeof Pr=="string"&&(Pr=J(Pr,safeNumberType(Pr,F))),Pr}}),name$162="min",dependencies$162=["typed","config","numeric","smaller","isNaN"],createMin=factory(name$162,dependencies$162,D=>{var{typed:E,config:F,numeric:J,smaller:$e,isNaN:_t}=D;return E(name$162,{"Array | Matrix":mr,"Array | Matrix, number | BigNumber":function(Or,Pr){return reduce$1(Or,Pr.valueOf(),lr)},"...":function(Or){if(containsCollections(Or))throw TypeError("Scalar values expected in function min");return mr(Or)}});function lr(Or,Pr){try{return $e(Or,Pr)?Or:Pr}catch(dn){throw improveErrorMessage(dn,"min",Pr)}}function mr(Or){var Pr;if(deepForEach(Or,function(dn){try{(_t(dn)||Pr===void 0||$e(dn,Pr))&&(Pr=dn)}catch(gi){throw improveErrorMessage(gi,"min",dn)}}),Pr===void 0)throw Error("Cannot calculate min of an empty array");return typeof Pr=="string"&&(Pr=J(Pr,safeNumberType(Pr,F))),Pr}}),name$161="ImmutableDenseMatrix",dependencies$161=["smaller","DenseMatrix"],createImmutableDenseMatrixClass=factory(name$161,dependencies$161,D=>{var{smaller:E,DenseMatrix:F}=D;function J($e,_t){if(!(this instanceof J))throw SyntaxError("Constructor must be called with the new operator");if(_t&&!isString(_t))throw Error("Invalid datatype: "+_t);if(isMatrix($e)||isArray($e)){var lr=new F($e,_t);this._data=lr._data,this._size=lr._size,this._datatype=lr._datatype,this._min=null,this._max=null}else if($e&&isArray($e.data)&&isArray($e.size))this._data=$e.data,this._size=$e.size,this._datatype=$e.datatype,this._min=$e.min===void 0?null:$e.min,this._max=$e.max===void 0?null:$e.max;else{if($e)throw TypeError("Unsupported type of data ("+typeOf($e)+")");this._data=[],this._size=[0],this._datatype=_t,this._min=null,this._max=null}}return J.prototype=new F,J.prototype.type="ImmutableDenseMatrix",J.prototype.isImmutableDenseMatrix=!0,J.prototype.subset=function($e){switch(arguments.length){case 1:var _t=F.prototype.subset.call(this,$e);return isMatrix(_t)?new J({data:_t._data,size:_t._size,datatype:_t._datatype}):_t;case 2:case 3:throw Error("Cannot invoke set subset on an Immutable Matrix instance");default:throw SyntaxError("Wrong number of arguments")}},J.prototype.set=function(){throw Error("Cannot invoke set on an Immutable Matrix instance")},J.prototype.resize=function(){throw Error("Cannot invoke resize on an Immutable Matrix instance")},J.prototype.reshape=function(){throw Error("Cannot invoke reshape on an Immutable Matrix instance")},J.prototype.clone=function(){return new J({data:clone$3(this._data),size:clone$3(this._size),datatype:this._datatype})},J.prototype.toJSON=function(){return{mathjs:"ImmutableDenseMatrix",data:this._data,size:this._size,datatype:this._datatype}},J.fromJSON=function($e){return new J($e)},J.prototype.swapRows=function(){throw Error("Cannot invoke swapRows on an Immutable Matrix instance")},J.prototype.min=function(){if(this._min===null){var $e=null;this.forEach(function(_t){($e===null||E(_t,$e))&&($e=_t)}),this._min=$e===null?void 0:$e}return this._min},J.prototype.max=function(){if(this._max===null){var $e=null;this.forEach(function(_t){($e===null||E($e,_t))&&($e=_t)}),this._max=$e===null?void 0:$e}return this._max},J},{isClass:!0}),name$160="Index",dependencies$160=["ImmutableDenseMatrix","getMatrixDataType"],createIndexClass=factory(name$160,dependencies$160,D=>{var{ImmutableDenseMatrix:E,getMatrixDataType:F}=D;function J(){if(!(this instanceof J))throw SyntaxError("Constructor must be called with the new operator");this._dimensions=[],this._sourceSize=[],this._isScalar=!0;for(var _t=0,lr=arguments.length;_t<lr;_t++){var mr=_t<0||arguments.length<=_t?void 0:arguments[_t],Or=isArray(mr),Pr=isMatrix(mr),dn=typeof mr,gi=null;if(isRange(mr))this._dimensions.push(mr),this._isScalar=!1;else if(Or||Pr){var qi=void 0;this._isScalar=!1,F(mr)==="boolean"?(Or&&(qi=$e(_booleansArrayToNumbersForIndex(mr).valueOf())),Pr&&(qi=$e(_booleansArrayToNumbersForIndex(mr._data).valueOf())),gi=mr.valueOf().length):qi=$e(mr.valueOf()),this._dimensions.push(qi)}else if(dn==="number")this._dimensions.push(mr);else if(dn==="bigint")this._dimensions.push(Number(mr));else if(dn==="string")this._dimensions.push(mr);else throw TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");this._sourceSize.push(gi)}}J.prototype.type="Index",J.prototype.isIndex=!0;function $e(_t){for(var lr=0,mr=_t.length;lr<mr;lr++)if(!isNumber(_t[lr])||!isInteger(_t[lr]))throw TypeError("Index parameters must be positive integer numbers");var Or=new E;return Or._data=_t,Or._size=[_t.length],Or}return J.prototype.clone=function(){var _t=new J;return _t._dimensions=clone$3(this._dimensions),_t._isScalar=this._isScalar,_t._sourceSize=this._sourceSize,_t},J.create=function(_t){var lr=new J;return J.apply(lr,_t),lr},J.prototype.size=function(){for(var _t=[],lr=0,mr=this._dimensions.length;lr<mr;lr++){var Or=this._dimensions[lr];_t[lr]=isString(Or)||isNumber(Or)?1:Or.size()[0]}return _t},J.prototype.max=function(){for(var _t=[],lr=0,mr=this._dimensions.length;lr<mr;lr++){var Or=this._dimensions[lr];_t[lr]=isString(Or)||isNumber(Or)?Or:Or.max()}return _t},J.prototype.min=function(){for(var _t=[],lr=0,mr=this._dimensions.length;lr<mr;lr++){var Or=this._dimensions[lr];_t[lr]=isString(Or)||isNumber(Or)?Or:Or.min()}return _t},J.prototype.forEach=function(_t){for(var lr=0,mr=this._dimensions.length;lr<mr;lr++)_t(this._dimensions[lr],lr,this)},J.prototype.dimension=function(_t){return isNumber(_t)?this._dimensions[_t]??null:null},J.prototype.isObjectProperty=function(){return this._dimensions.length===1&&isString(this._dimensions[0])},J.prototype.getObjectProperty=function(){return this.isObjectProperty()?this._dimensions[0]:null},J.prototype.isScalar=function(){return this._isScalar},J.prototype.toArray=function(){for(var _t=[],lr=0,mr=this._dimensions.length;lr<mr;lr++){var Or=this._dimensions[lr];_t.push(isString(Or)||isNumber(Or)?Or:Or.toArray())}return _t},J.prototype.valueOf=J.prototype.toArray,J.prototype.toString=function(){for(var _t=[],lr=0,mr=this._dimensions.length;lr<mr;lr++){var Or=this._dimensions[lr];isString(Or)?_t.push(JSON.stringify(Or)):_t.push(Or.toString())}return"["+_t.join(", ")+"]"},J.prototype.toJSON=function(){return{mathjs:"Index",dimensions:this._dimensions}},J.fromJSON=function(_t){return J.create(_t.dimensions)},J},{isClass:!0});function _booleansArrayToNumbersForIndex(D){var E=[];return D.forEach((F,J)=>{F&&E.push(J)}),E}var name$159="FibonacciHeap",dependencies$159=["smaller","larger"],createFibonacciHeapClass=factory(name$159,dependencies$159,D=>{var{smaller:E,larger:F}=D,J=1/Math.log((1+Math.sqrt(5))/2);function $e(){if(!(this instanceof $e))throw SyntaxError("Constructor must be called with the new operator");this._minimum=null,this._size=0}$e.prototype.type="FibonacciHeap",$e.prototype.isFibonacciHeap=!0,$e.prototype.insert=function(dn,gi){var qi={key:dn,value:gi,degree:0};if(this._minimum){var zi=this._minimum;qi.left=zi,qi.right=zi.right,zi.right=qi,qi.right.left=qi,E(dn,zi.key)&&(this._minimum=qi)}else qi.left=qi,qi.right=qi,this._minimum=qi;return this._size++,qi},$e.prototype.size=function(){return this._size},$e.prototype.clear=function(){this._minimum=null,this._size=0},$e.prototype.isEmpty=function(){return this._size===0},$e.prototype.extractMinimum=function(){var dn=this._minimum;if(dn===null)return dn;for(var gi=this._minimum,qi=dn.degree,zi=dn.child;qi>0;){var Hi=zi.right;zi.left.right=zi.right,zi.right.left=zi.left,zi.left=gi,zi.right=gi.right,gi.right=zi,zi.right.left=zi,zi.parent=null,zi=Hi,qi--}return dn.left.right=dn.right,dn.right.left=dn.left,dn===dn.right?gi=null:(gi=dn.right,gi=Pr(gi,this._size)),this._size--,this._minimum=gi,dn},$e.prototype.remove=function(dn){this._minimum=_t(this._minimum,dn,-1),this.extractMinimum()};function _t(dn,gi,qi){gi.key=qi;var zi=gi.parent;return zi&&E(gi.key,zi.key)&&(lr(dn,gi,zi),mr(dn,zi)),E(gi.key,dn.key)&&(dn=gi),dn}function lr(dn,gi,qi){gi.left.right=gi.right,gi.right.left=gi.left,qi.degree--,qi.child===gi&&(qi.child=gi.right),qi.degree===0&&(qi.child=null),gi.left=dn,gi.right=dn.right,dn.right=gi,gi.right.left=gi,gi.parent=null,gi.mark=!1}function mr(dn,gi){var qi=gi.parent;qi&&(gi.mark?(lr(dn,gi,qi),mr(qi)):gi.mark=!0)}var Or=function(dn,gi){dn.left.right=dn.right,dn.right.left=dn.left,dn.parent=gi,gi.child?(dn.left=gi.child,dn.right=gi.child.right,gi.child.right=dn,dn.right.left=dn):(gi.child=dn,dn.right=dn,dn.left=dn),gi.degree++,dn.mark=!1};function Pr(dn,gi){var qi=Math.floor(Math.log(gi)*J)+1,zi=Array(qi),Hi=0,Qi=dn;if(Qi)for(Hi++,Qi=Qi.right;Qi!==dn;)Hi++,Qi=Qi.right;for(var Gi;Hi>0;){for(var Zi=Qi.degree,Xi=Qi.right;Gi=zi[Zi],Gi;){if(F(Qi.key,Gi.key)){var Ki=Gi;Gi=Qi,Qi=Ki}Or(Gi,Qi),zi[Zi]=null,Zi++}zi[Zi]=Qi,Qi=Xi,Hi--}dn=null;for(var ea=0;ea<qi;ea++)Gi=zi[ea],Gi&&(dn?(Gi.left.right=Gi.right,Gi.right.left=Gi.left,Gi.left=dn,Gi.right=dn.right,dn.right=Gi,Gi.right.left=Gi,E(Gi.key,dn.key)&&(dn=Gi)):dn=Gi);return dn}return $e},{isClass:!0}),name$158="Spa",dependencies$158=["addScalar","equalScalar","FibonacciHeap"],createSpaClass=factory(name$158,dependencies$158,D=>{var{addScalar:E,equalScalar:F,FibonacciHeap:J}=D;function $e(){if(!(this instanceof $e))throw SyntaxError("Constructor must be called with the new operator");this._values=[],this._heap=new J}return $e.prototype.type="Spa",$e.prototype.isSpa=!0,$e.prototype.set=function(_t,lr){if(this._values[_t])this._values[_t].value=lr;else{var mr=this._heap.insert(_t,lr);this._values[_t]=mr}},$e.prototype.get=function(_t){var lr=this._values[_t];return lr?lr.value:0},$e.prototype.accumulate=function(_t,lr){var mr=this._values[_t];mr?mr.value=E(mr.value,lr):(mr=this._heap.insert(_t,lr),this._values[_t]=mr)},$e.prototype.forEach=function(_t,lr,mr){var Or=this._heap,Pr=this._values,dn=[],gi=Or.extractMinimum();for(gi&&dn.push(gi);gi&&gi.key<=lr;)gi.key>=_t&&(F(gi.value,0)||mr(gi.key,gi.value,this)),gi=Or.extractMinimum(),gi&&dn.push(gi);for(var qi=0;qi<dn.length;qi++){var zi=dn[qi];gi=Or.insert(zi.key,zi.value),Pr[gi.key]=gi}},$e.prototype.swap=function(_t,lr){var mr=this._values[_t],Or=this._values[lr];if(!mr&&Or)mr=this._heap.insert(_t,Or.value),this._heap.remove(Or),this._values[_t]=mr,this._values[lr]=void 0;else if(mr&&!Or)Or=this._heap.insert(lr,mr.value),this._heap.remove(mr),this._values[lr]=Or,this._values[_t]=void 0;else if(mr&&Or){var Pr=mr.value;mr.value=Or.value,Or.value=Pr}},$e},{isClass:!0});function lruQueue(D){var E=0,F=1,J=Object.create(null),$e=Object.create(null),_t=0,lr=function(mr){var Or=$e[mr];if(Or&&(delete J[Or],delete $e[mr],--E,F===Or)){if(!E){_t=0,F=1;return}for(;!Object.prototype.hasOwnProperty.call(J,++F););}};return D=Math.abs(D),{hit:function(mr){var Or=$e[mr],Pr=++_t;if(J[Pr]=mr,$e[mr]=Pr,!Or)return++E,E<=D?void 0:(mr=J[F],lr(mr),mr);if(delete J[Or],F===Or)for(;!Object.prototype.hasOwnProperty.call(J,++F););},delete:lr,clear:function(){E=_t=0,F=1,J=Object.create(null),$e=Object.create(null)}}}function memoize$1(D){var{hasher:E,limit:F}=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};return F??=1/0,E??=JSON.stringify,function J(){typeof J.cache!="object"&&(J.cache={values:new Map,lru:lruQueue(F||1/0)});var $e=[...arguments],_t=E($e);if(J.cache.values.has(_t))return J.cache.lru.hit(_t),J.cache.values.get(_t);var lr=D.apply(D,$e);return J.cache.values.set(_t,lr),J.cache.values.delete(J.cache.lru.hit(_t)),lr}}var createBigNumberE=memoize$1(function(D){return new D(1).exp()},{hasher}),createBigNumberPhi=memoize$1(function(D){return new D(1).plus(new D(5).sqrt()).div(2)},{hasher}),createBigNumberPi=memoize$1(function(D){return D.acos(-1)},{hasher}),createBigNumberTau=memoize$1(function(D){return createBigNumberPi(D).times(2)},{hasher});function hasher(D){return D[0].precision}function ownKeys$2(D,E){var F=Object.keys(D);if(Object.getOwnPropertySymbols){var J=Object.getOwnPropertySymbols(D);E&&(J=J.filter(function($e){return Object.getOwnPropertyDescriptor(D,$e).enumerable})),F.push.apply(F,J)}return F}function _objectSpread$2(D){for(var E=1;E<arguments.length;E++){var F=arguments[E]==null?{}:arguments[E];E%2?ownKeys$2(Object(F),!0).forEach(function(J){_defineProperty(D,J,F[J])}):Object.getOwnPropertyDescriptors?Object.defineProperties(D,Object.getOwnPropertyDescriptors(F)):ownKeys$2(Object(F)).forEach(function(J){Object.defineProperty(D,J,Object.getOwnPropertyDescriptor(F,J))})}return D}var name$157="Unit",dependencies$157=["?on","config","addScalar","subtractScalar","multiplyScalar","divideScalar","pow","abs","fix","round","equal","isNumeric","format","number","Complex","BigNumber","Fraction"],createUnitClass=factory(name$157,dependencies$157,D=>{var{on:E,config:F,addScalar:J,subtractScalar:$e,multiplyScalar:_t,divideScalar:lr,pow:mr,abs:Or,fix:Pr,round:dn,equal:gi,isNumeric:qi,format:zi,number:Hi,Complex:Qi,BigNumber:Gi,Fraction:Zi}=D,Xi=Hi,Ki=!1,ea=!0;function Ji(xa,Ra){if(!(this instanceof Ji))throw Error("Constructor must be called with the new operator");if(!(xa==null||qi(xa)||isComplex(xa)))throw TypeError("First parameter in Unit constructor must be number, BigNumber, Fraction, Complex, or undefined");if(this.fixPrefix=Ki,this.skipAutomaticSimplification=ea,Ra===void 0)this.units=[],this.dimensions=ka.map(Ga=>0);else if(typeof Ra=="string"){var Va=Ji.parse(Ra);this.units=Va.units,this.dimensions=Va.dimensions}else if(isUnit(Ra)&&Ra.value===null)this.fixPrefix=Ra.fixPrefix,this.skipAutomaticSimplification=Ra.skipAutomaticSimplification,this.dimensions=Ra.dimensions.slice(0),this.units=Ra.units.map(Ga=>_extends({},Ga));else throw TypeError("Second parameter in Unit constructor must be a string or valueless Unit");this.value=this._normalize(xa)}Object.defineProperty(Ji,"name",{value:"Unit"}),Ji.prototype.constructor=Ji,Ji.prototype.type="Unit",Ji.prototype.isUnit=!0;var ta,na,ra;function ia(){for(;ra===" "||ra==="	";)sa()}function oa(xa){return xa>="0"&&xa<="9"||xa==="."}function ua(xa){return xa>="0"&&xa<="9"}function sa(){na++,ra=ta.charAt(na)}function aa(xa){na=xa,ra=ta.charAt(na)}function pa(){var xa="",Ra=na;if(ra==="+"?sa():ra==="-"&&(xa+=ra,sa()),!oa(ra))return aa(Ra),null;if(ra==="."){if(xa+=ra,sa(),!ua(ra))return aa(Ra),null}else{for(;ua(ra);)xa+=ra,sa();ra==="."&&(xa+=ra,sa())}for(;ua(ra);)xa+=ra,sa();if(ra==="E"||ra==="e"){var Va="",Ga=na;if(Va+=ra,sa(),(ra==="+"||ra==="-")&&(Va+=ra,sa()),!ua(ra))return aa(Ga),xa;for(xa+=Va;ua(ra);)xa+=ra,sa()}return xa}function ma(){for(var xa="";ua(ra)||Ji.isValidAlpha(ra);)xa+=ra,sa();var Ra=xa.charAt(0);return Ji.isValidAlpha(Ra)?xa:null}function la(xa){return ra===xa?(sa(),xa):null}Ji.parse=function(xa,Ra){if(Ra||={},ta=xa,na=-1,ra="",typeof ta!="string")throw TypeError("Invalid argument in Unit.parse, string expected");var Va=new Ji;Va.units=[];var Ga=1,as=!1;sa(),ia();var rs=pa(),ss=null;if(rs){if(F.number==="BigNumber")ss=new Gi(rs);else if(F.number==="Fraction")try{ss=new Zi(rs)}catch{ss=parseFloat(rs)}else ss=parseFloat(rs);ia(),la("*")?(Ga=1,as=!0):la("/")&&(Ga=-1,as=!0)}for(var ms=[],Ua=1;;){for(ia();ra==="(";)ms.push(Ga),Ua*=Ga,Ga=1,sa(),ia();var Wa=void 0;if(ra){var wa=ra;if(Wa=ma(),Wa===null)throw SyntaxError(\'Unexpected "\'+wa+\'" in "\'+ta+\'" at index \'+na.toString())}else break;var qa=ha(Wa);if(qa===null)throw SyntaxError(\'Unit "\'+Wa+\'" not found.\');var ja=Ga*Ua;if(ia(),la("^")){ia();var Xa=pa();if(Xa===null)throw SyntaxError(\'In "\'+xa+\'", "^" must be followed by a floating-point number\');ja*=Xa}Va.units.push({unit:qa.unit,prefix:qa.prefix,power:ja});for(var Ya=0;Ya<ka.length;Ya++)Va.dimensions[Ya]+=(qa.unit.dimensions[Ya]||0)*ja;for(ia();ra===")";){if(ms.length===0)throw SyntaxError(\'Unmatched ")" in "\'+ta+\'" at index \'+na.toString());Ua/=ms.pop(),sa(),ia()}if(as=!1,la("*")?(Ga=1,as=!0):la("/")?(Ga=-1,as=!0):Ga=1,qa.unit.base){var Ja=qa.unit.base.key;ya.auto[Ja]={unit:qa.unit,prefix:qa.prefix}}}if(ia(),ra)throw SyntaxError(\'Could not parse: "\'+xa+\'"\');if(as)throw SyntaxError(\'Trailing characters: "\'+xa+\'"\');if(ms.length!==0)throw SyntaxError(\'Unmatched "(" in "\'+ta+\'"\');if(Va.units.length===0&&!Ra.allowNoUnits)throw SyntaxError(\'"\'+xa+\'" contains no units\');return Va.value=ss===void 0?null:Va._normalize(ss),Va},Ji.prototype.clone=function(){var xa=new Ji;xa.fixPrefix=this.fixPrefix,xa.skipAutomaticSimplification=this.skipAutomaticSimplification,xa.value=clone$3(this.value),xa.dimensions=this.dimensions.slice(0),xa.units=[];for(var Ra=0;Ra<this.units.length;Ra++)for(var Va in xa.units[Ra]={},this.units[Ra])hasOwnProperty$1(this.units[Ra],Va)&&(xa.units[Ra][Va]=this.units[Ra][Va]);return xa},Ji.prototype.valueType=function(){return typeOf(this.value)},Ji.prototype._isDerived=function(){return this.units.length===0?!1:this.units.length>1||Math.abs(this.units[0].power-1)>1e-15},Ji.prototype._normalize=function(xa){if(xa==null||this.units.length===0)return xa;for(var Ra=xa,Va=Ji._getNumberConverter(typeOf(xa)),Ga=0;Ga<this.units.length;Ga++){var as=Va(this.units[Ga].unit.value),rs=Va(this.units[Ga].prefix.value),ss=Va(this.units[Ga].power);Ra=_t(Ra,mr(_t(as,rs),ss))}return Ra},Ji.prototype._denormalize=function(xa,Ra){if(xa==null||this.units.length===0)return xa;for(var Va=xa,Ga=Ji._getNumberConverter(typeOf(xa)),as=0;as<this.units.length;as++){var rs=Ga(this.units[as].unit.value),ss=Ga(this.units[as].prefix.value),ms=Ga(this.units[as].power);Va=lr(Va,mr(_t(rs,ss),ms))}return Va};var ha=memoize$1(xa=>{if(hasOwnProperty$1(Da,xa)){var Ra=Da[xa];return{unit:Ra,prefix:Ra.prefixes[""]}}for(var Va in Da)if(hasOwnProperty$1(Da,Va)&&endsWith(xa,Va)){var Ga=Da[Va],as=xa.length-Va.length,rs=xa.substring(0,as),ss=hasOwnProperty$1(Ga.prefixes,rs)?Ga.prefixes[rs]:void 0;if(ss!==void 0)return{unit:Ga,prefix:ss}}return null},{hasher:xa=>xa[0],limit:100});Ji.isValuelessUnit=function(xa){return ha(xa)!==null},Ji.prototype.hasBase=function(xa){if(typeof xa=="string"&&(xa=ba[xa]),!xa)return!1;for(var Ra=0;Ra<ka.length;Ra++)if(Math.abs((this.dimensions[Ra]||0)-(xa.dimensions[Ra]||0))>1e-12)return!1;return!0},Ji.prototype.equalBase=function(xa){for(var Ra=0;Ra<ka.length;Ra++)if(Math.abs((this.dimensions[Ra]||0)-(xa.dimensions[Ra]||0))>1e-12)return!1;return!0},Ji.prototype.equals=function(xa){return this.equalBase(xa)&&gi(this.value,xa.value)},Ji.prototype.multiply=function(xa){for(var Ra=this.clone(),Va=isUnit(xa)?xa:new Ji(xa),Ga=0;Ga<ka.length;Ga++)Ra.dimensions[Ga]=(this.dimensions[Ga]||0)+(Va.dimensions[Ga]||0);for(var as=0;as<Va.units.length;as++){var rs=_objectSpread$2({},Va.units[as]);Ra.units.push(rs)}return this.value!==null||Va.value!==null?Ra.value=_t(this.value===null?this._normalize(Aa(Va.value)):this.value,Va.value===null?Va._normalize(Aa(this.value)):Va.value):Ra.value=null,isUnit(xa)&&(Ra.skipAutomaticSimplification=!1),ga(Ra)},Ji.prototype.divideInto=function(xa){return new Ji(xa).divide(this)},Ji.prototype.divide=function(xa){for(var Ra=this.clone(),Va=isUnit(xa)?xa:new Ji(xa),Ga=0;Ga<ka.length;Ga++)Ra.dimensions[Ga]=(this.dimensions[Ga]||0)-(Va.dimensions[Ga]||0);for(var as=0;as<Va.units.length;as++){var rs=_objectSpread$2(_objectSpread$2({},Va.units[as]),{},{power:-Va.units[as].power});Ra.units.push(rs)}return this.value!==null||Va.value!==null?Ra.value=lr(this.value===null?this._normalize(Aa(Va.value)):this.value,Va.value===null?Va._normalize(Aa(this.value)):Va.value):Ra.value=null,isUnit(xa)&&(Ra.skipAutomaticSimplification=!1),ga(Ra)},Ji.prototype.pow=function(xa){for(var Ra=this.clone(),Va=0;Va<ka.length;Va++)Ra.dimensions[Va]=(this.dimensions[Va]||0)*xa;for(var Ga=0;Ga<Ra.units.length;Ga++)Ra.units[Ga].power*=xa;return Ra.value===null?Ra.value=null:Ra.value=mr(Ra.value,xa),Ra.skipAutomaticSimplification=!1,ga(Ra)};function ga(xa){return xa.equalBase(ba.NONE)&&xa.value!==null&&!F.predictable?xa.value:xa}function Aa(xa){return Ji._getNumberConverter(typeOf(xa))(1)}Ji.prototype.abs=function(){var xa=this.clone();if(xa.value!==null)if(xa._isDerived()||xa.units.length===0||xa.units[0].unit.offset===0)xa.value=Or(xa.value);else{var Ra=xa._numberConverter(),Va=_t(Ra(xa.units[0].unit.value),Ra(xa.units[0].unit.offset));xa.value=$e(Or(J(xa.value,Va)),Va)}for(var Ga in xa.units)(xa.units[Ga].unit.name==="VA"||xa.units[Ga].unit.name==="VAR")&&(xa.units[Ga].unit=Da.W);return xa},Ji.prototype.to=function(xa){var Ra=this.value===null?this._normalize(1):this.value,Va;if(typeof xa=="string")Va=Ji.parse(xa);else if(isUnit(xa))Va=xa.clone();else throw Error("String or Unit expected as parameter");if(!this.equalBase(Va))throw Error(`Units do not match (\'${Va.toString()}\' != \'${this.toString()}\')`);if(Va.value!==null)throw Error("Cannot convert to a unit with a value");if(this.value===null||this._isDerived()||this.units.length===0||Va.units.length===0||this.units[0].unit.offset===Va.units[0].unit.offset)Va.value=clone$3(Ra);else{var Ga=Ji._getNumberConverter(typeOf(Ra)),as=this.units[0].unit.value,rs=this.units[0].unit.offset,ss=_t(as,rs),ms=Va.units[0].unit.value,Ua=Va.units[0].unit.offset,Wa=_t(ms,Ua);Va.value=J(Ra,Ga($e(ss,Wa)))}return Va.fixPrefix=!0,Va.skipAutomaticSimplification=!0,Va},Ji.prototype.toNumber=function(xa){return Xi(this.toNumeric(xa))},Ji.prototype.toNumeric=function(xa){var Ra=xa?this.to(xa):this.clone();return Ra._isDerived()||Ra.units.length===0?Ra._denormalize(Ra.value):Ra._denormalize(Ra.value,Ra.units[0].prefix.value)},Ji.prototype.toString=function(){return this.format()},Ji.prototype.toJSON=function(){return{mathjs:"Unit",value:this._denormalize(this.value),unit:this.units.length>0?this.formatUnits():null,fixPrefix:this.fixPrefix,skipSimp:this.skipAutomaticSimplification}},Ji.fromJSON=function(xa){var Ra=new Ji(xa.value,xa.unit??void 0);return Ra.fixPrefix=xa.fixPrefix??Ki,Ra.skipAutomaticSimplification=xa.skipSimp??ea,Ra},Ji.prototype.valueOf=Ji.prototype.toString,Ji.prototype.simplify=function(){var xa=this.clone(),Ra=[],Va;for(var Ga in Na)if(hasOwnProperty$1(Na,Ga)&&xa.hasBase(ba[Ga])){Va=Ga;break}if(Va==="NONE")xa.units=[];else{var as;if(Va&&hasOwnProperty$1(Na,Va)&&(as=Na[Va]),as)xa.units=[{unit:as.unit,prefix:as.prefix,power:1}];else{for(var rs=!1,ss=0;ss<ka.length;ss++){var ms=ka[ss];Math.abs(xa.dimensions[ss]||0)>1e-12&&(hasOwnProperty$1(Na,ms)?Ra.push({unit:Na[ms].unit,prefix:Na[ms].prefix,power:xa.dimensions[ss]||0}):rs=!0)}Ra.length<xa.units.length&&!rs&&(xa.units=Ra)}}return xa},Ji.prototype.toSI=function(){for(var xa=this.clone(),Ra=[],Va=0;Va<ka.length;Va++){var Ga=ka[Va];if(Math.abs(xa.dimensions[Va]||0)>1e-12)if(hasOwnProperty$1(ya.si,Ga))Ra.push({unit:ya.si[Ga].unit,prefix:ya.si[Ga].prefix,power:xa.dimensions[Va]||0});else throw Error("Cannot express custom unit "+Ga+" in SI units")}return xa.units=Ra,xa.fixPrefix=!0,xa.skipAutomaticSimplification=!0,this.value===null?xa:(xa.value=null,this.to(xa))},Ji.prototype.formatUnits=function(){for(var xa="",Ra="",Va=0,Ga=0,as=0;as<this.units.length;as++)this.units[as].power>0?(Va++,xa+=" "+this.units[as].prefix.name+this.units[as].unit.name,Math.abs(this.units[as].power-1)>1e-15&&(xa+="^"+this.units[as].power)):this.units[as].power<0&&Ga++;if(Ga>0)for(var rs=0;rs<this.units.length;rs++)this.units[rs].power<0&&(Va>0?(Ra+=" "+this.units[rs].prefix.name+this.units[rs].unit.name,Math.abs(this.units[rs].power+1)>1e-15&&(Ra+="^"+-this.units[rs].power)):(Ra+=" "+this.units[rs].prefix.name+this.units[rs].unit.name,Ra+="^"+this.units[rs].power));xa=xa.substr(1),Ra=Ra.substr(1),Va>1&&Ga>0&&(xa="("+xa+")"),Ga>1&&Va>0&&(Ra="("+Ra+")");var ss=xa;return Va>0&&Ga>0&&(ss+=" / "),ss+=Ra,ss},Ji.prototype.toBest=function(){var xa=arguments.length>0&&arguments[0]!==void 0?arguments[0]:[],Ra=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{};if(xa&&!Array.isArray(xa))throw Error("Invalid unit type. Expected string or Unit.");var Va=this.units[0].unit.prefixes;if(xa&&xa.length>0){var Ga=xa.map(rs=>{var ss=null;if(typeof rs=="string"){if(ss=Ji.parse(rs),!ss)throw Error("Invalid unit type. Expected compatible string or Unit.")}else if(!isUnit(rs))throw Error("Invalid unit type. Expected compatible string or Unit.");ss===null&&(ss=rs.clone());try{return this.to(ss.formatUnits()),ss}catch{throw Error("Invalid unit type. Expected compatible string or Unit.")}}).map(rs=>rs.units[0].prefix);this.units[0].unit.prefixes=Ga.reduce((rs,ss)=>(rs[ss.name]=ss,rs),{}),this.units[0].prefix=Ga[0]}var as=Fa(this,Ra).simp;return this.units[0].unit.prefixes=Va,as.fixPrefix=!0,as},Ji.prototype.format=function(xa){var{simp:Ra,valueStr:Va,unitStr:Ga}=Fa(this,xa),as=Va;return Ra.value&&isComplex(Ra.value)&&(as="("+as+")"),Ga.length>0&&as.length>0&&(as+=" "),as+=Ga,as};function Fa(xa){var Ra=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},Va=xa.skipAutomaticSimplification||xa.value===null?xa.clone():xa.simplify();$a(Va),_a(Va,Ra.offset);var Ga=Va._denormalize(Va.value);return{simp:Va,valueStr:Va.value===null?"":zi(Ga,Ra||{}),unitStr:Va.formatUnits()}}function $a(xa){var Ra=!1;for(var Va in xa.value!==void 0&&xa.value!==null&&isComplex(xa.value)&&(Ra=Math.abs(xa.value.re)<1e-14),xa.units)hasOwnProperty$1(xa.units,Va)&&xa.units[Va].unit&&(xa.units[Va].unit.name==="VA"&&Ra?xa.units[Va].unit=Da.VAR:xa.units[Va].unit.name==="VAR"&&!Ra&&(xa.units[Va].unit=Da.VA))}function _a(xa,Ra){xa.units.length===1&&!xa.fixPrefix&&Math.abs(xa.units[0].power-Math.round(xa.units[0].power))<1e-14&&(xa.units[0].prefix=xa._bestPrefix(Ra))}Ji.prototype._bestPrefix=function(){var xa=arguments.length>0&&arguments[0]!==void 0?arguments[0]:1.2;if(this.units.length!==1||Math.abs(this.units[0].power-Math.round(this.units[0].power))>=1e-14)throw Error("Can only compute the best prefix for single units with integer powers, like kg, s^2, N^-1, and so forth!");var Ra=this.value===null?0:Or(this.value),Va=Or(this.units[0].unit.value),Ga=this.units[0].prefix;if(Ra===0)return Ga;var as=this.units[0].power,rs=Math.log(Ra/(Ga.value*Va)**+as)/Math.LN10-xa;if(rs>-2.200001&&rs<1.800001)return Ga;rs=Math.abs(rs);var ss=this.units[0].unit.prefixes;for(var ms in ss)if(hasOwnProperty$1(ss,ms)){var Ua=ss[ms];if(Ua.scientific){var Wa=Math.abs(Math.log(Ra/(Ua.value*Va)**+as)/Math.LN10-xa);(Wa<rs||Wa===rs&&Ua.name.length<Ga.name.length)&&(Ga=Ua,rs=Wa)}}return Ga},Ji.prototype.splitUnit=function(xa){for(var Ra=this.clone(),Va=[],Ga=0;Ga<xa.length&&(Ra=Ra.to(xa[Ga]),Ga!==xa.length-1);Ga++){var as=Ra.toNumeric(),rs=dn(as),ss=void 0;ss=gi(rs,as)?rs:Pr(Ra.toNumeric());var ms=new Ji(ss,xa[Ga].toString());Va.push(ms),Ra=$e(Ra,ms)}for(var Ua=0,Wa=0;Wa<Va.length;Wa++)Ua=J(Ua,Va[Wa].value);return gi(Ua,this.value)&&(Ra.value=0),Va.push(Ra),Va};var fa={NONE:{"":{name:"",value:1,scientific:!0}},SHORT:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:10,scientific:!1},h:{name:"h",value:100,scientific:!1},k:{name:"k",value:1e3,scientific:!0},M:{name:"M",value:1e6,scientific:!0},G:{name:"G",value:1e9,scientific:!0},T:{name:"T",value:1e12,scientific:!0},P:{name:"P",value:1e15,scientific:!0},E:{name:"E",value:1e18,scientific:!0},Z:{name:"Z",value:1e21,scientific:!0},Y:{name:"Y",value:1e24,scientific:!0},R:{name:"R",value:1e27,scientific:!0},Q:{name:"Q",value:1e30,scientific:!0},d:{name:"d",value:.1,scientific:!1},c:{name:"c",value:.01,scientific:!1},m:{name:"m",value:.001,scientific:!0},u:{name:"u",value:1e-6,scientific:!0},n:{name:"n",value:1e-9,scientific:!0},p:{name:"p",value:1e-12,scientific:!0},f:{name:"f",value:1e-15,scientific:!0},a:{name:"a",value:1e-18,scientific:!0},z:{name:"z",value:1e-21,scientific:!0},y:{name:"y",value:1e-24,scientific:!0},r:{name:"r",value:1e-27,scientific:!0},q:{name:"q",value:1e-30,scientific:!0}},LONG:{"":{name:"",value:1,scientific:!0},deca:{name:"deca",value:10,scientific:!1},hecto:{name:"hecto",value:100,scientific:!1},kilo:{name:"kilo",value:1e3,scientific:!0},mega:{name:"mega",value:1e6,scientific:!0},giga:{name:"giga",value:1e9,scientific:!0},tera:{name:"tera",value:1e12,scientific:!0},peta:{name:"peta",value:1e15,scientific:!0},exa:{name:"exa",value:1e18,scientific:!0},zetta:{name:"zetta",value:1e21,scientific:!0},yotta:{name:"yotta",value:1e24,scientific:!0},ronna:{name:"ronna",value:1e27,scientific:!0},quetta:{name:"quetta",value:1e30,scientific:!0},deci:{name:"deci",value:.1,scientific:!1},centi:{name:"centi",value:.01,scientific:!1},milli:{name:"milli",value:.001,scientific:!0},micro:{name:"micro",value:1e-6,scientific:!0},nano:{name:"nano",value:1e-9,scientific:!0},pico:{name:"pico",value:1e-12,scientific:!0},femto:{name:"femto",value:1e-15,scientific:!0},atto:{name:"atto",value:1e-18,scientific:!0},zepto:{name:"zepto",value:1e-21,scientific:!0},yocto:{name:"yocto",value:1e-24,scientific:!0},ronto:{name:"ronto",value:1e-27,scientific:!0},quecto:{name:"quecto",value:1e-30,scientific:!0}},SQUARED:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:100,scientific:!1},h:{name:"h",value:1e4,scientific:!1},k:{name:"k",value:1e6,scientific:!0},M:{name:"M",value:1e12,scientific:!0},G:{name:"G",value:1e18,scientific:!0},T:{name:"T",value:1e24,scientific:!0},P:{name:"P",value:1e30,scientific:!0},E:{name:"E",value:1e36,scientific:!0},Z:{name:"Z",value:1e42,scientific:!0},Y:{name:"Y",value:1e48,scientific:!0},R:{name:"R",value:1e54,scientific:!0},Q:{name:"Q",value:1e60,scientific:!0},d:{name:"d",value:.01,scientific:!1},c:{name:"c",value:1e-4,scientific:!1},m:{name:"m",value:1e-6,scientific:!0},u:{name:"u",value:1e-12,scientific:!0},n:{name:"n",value:1e-18,scientific:!0},p:{name:"p",value:1e-24,scientific:!0},f:{name:"f",value:1e-30,scientific:!0},a:{name:"a",value:1e-36,scientific:!0},z:{name:"z",value:1e-42,scientific:!0},y:{name:"y",value:1e-48,scientific:!0},r:{name:"r",value:1e-54,scientific:!0},q:{name:"q",value:1e-60,scientific:!0}},CUBIC:{"":{name:"",value:1,scientific:!0},da:{name:"da",value:1e3,scientific:!1},h:{name:"h",value:1e6,scientific:!1},k:{name:"k",value:1e9,scientific:!0},M:{name:"M",value:1e18,scientific:!0},G:{name:"G",value:1e27,scientific:!0},T:{name:"T",value:1e36,scientific:!0},P:{name:"P",value:1e45,scientific:!0},E:{name:"E",value:1e54,scientific:!0},Z:{name:"Z",value:1e63,scientific:!0},Y:{name:"Y",value:1e72,scientific:!0},R:{name:"R",value:1e81,scientific:!0},Q:{name:"Q",value:1e90,scientific:!0},d:{name:"d",value:.001,scientific:!1},c:{name:"c",value:1e-6,scientific:!1},m:{name:"m",value:1e-9,scientific:!0},u:{name:"u",value:1e-18,scientific:!0},n:{name:"n",value:1e-27,scientific:!0},p:{name:"p",value:1e-36,scientific:!0},f:{name:"f",value:1e-45,scientific:!0},a:{name:"a",value:1e-54,scientific:!0},z:{name:"z",value:1e-63,scientific:!0},y:{name:"y",value:1e-72,scientific:!0},r:{name:"r",value:1e-81,scientific:!0},q:{name:"q",value:1e-90,scientific:!0}},BINARY_SHORT_SI:{"":{name:"",value:1,scientific:!0},k:{name:"k",value:1e3,scientific:!0},M:{name:"M",value:1e6,scientific:!0},G:{name:"G",value:1e9,scientific:!0},T:{name:"T",value:1e12,scientific:!0},P:{name:"P",value:1e15,scientific:!0},E:{name:"E",value:1e18,scientific:!0},Z:{name:"Z",value:1e21,scientific:!0},Y:{name:"Y",value:1e24,scientific:!0}},BINARY_SHORT_IEC:{"":{name:"",value:1,scientific:!0},Ki:{name:"Ki",value:1024,scientific:!0},Mi:{name:"Mi",value:1024**2,scientific:!0},Gi:{name:"Gi",value:1024**3,scientific:!0},Ti:{name:"Ti",value:1024**4,scientific:!0},Pi:{name:"Pi",value:1024**5,scientific:!0},Ei:{name:"Ei",value:1024**6,scientific:!0},Zi:{name:"Zi",value:1024**7,scientific:!0},Yi:{name:"Yi",value:1024**8,scientific:!0}},BINARY_LONG_SI:{"":{name:"",value:1,scientific:!0},kilo:{name:"kilo",value:1e3,scientific:!0},mega:{name:"mega",value:1e6,scientific:!0},giga:{name:"giga",value:1e9,scientific:!0},tera:{name:"tera",value:1e12,scientific:!0},peta:{name:"peta",value:1e15,scientific:!0},exa:{name:"exa",value:1e18,scientific:!0},zetta:{name:"zetta",value:1e21,scientific:!0},yotta:{name:"yotta",value:1e24,scientific:!0}},BINARY_LONG_IEC:{"":{name:"",value:1,scientific:!0},kibi:{name:"kibi",value:1024,scientific:!0},mebi:{name:"mebi",value:1024**2,scientific:!0},gibi:{name:"gibi",value:1024**3,scientific:!0},tebi:{name:"tebi",value:1024**4,scientific:!0},pebi:{name:"pebi",value:1024**5,scientific:!0},exi:{name:"exi",value:1024**6,scientific:!0},zebi:{name:"zebi",value:1024**7,scientific:!0},yobi:{name:"yobi",value:1024**8,scientific:!0}},BTU:{"":{name:"",value:1,scientific:!0},MM:{name:"MM",value:1e6,scientific:!0}}};fa.SHORTLONG=_extends({},fa.SHORT,fa.LONG),fa.BINARY_SHORT=_extends({},fa.BINARY_SHORT_SI,fa.BINARY_SHORT_IEC),fa.BINARY_LONG=_extends({},fa.BINARY_LONG_SI,fa.BINARY_LONG_IEC);var ka=["MASS","LENGTH","TIME","CURRENT","TEMPERATURE","LUMINOUS_INTENSITY","AMOUNT_OF_SUBSTANCE","ANGLE","BIT"],ba={NONE:{dimensions:[0,0,0,0,0,0,0,0,0]},MASS:{dimensions:[1,0,0,0,0,0,0,0,0]},LENGTH:{dimensions:[0,1,0,0,0,0,0,0,0]},TIME:{dimensions:[0,0,1,0,0,0,0,0,0]},CURRENT:{dimensions:[0,0,0,1,0,0,0,0,0]},TEMPERATURE:{dimensions:[0,0,0,0,1,0,0,0,0]},LUMINOUS_INTENSITY:{dimensions:[0,0,0,0,0,1,0,0,0]},AMOUNT_OF_SUBSTANCE:{dimensions:[0,0,0,0,0,0,1,0,0]},FORCE:{dimensions:[1,1,-2,0,0,0,0,0,0]},SURFACE:{dimensions:[0,2,0,0,0,0,0,0,0]},VOLUME:{dimensions:[0,3,0,0,0,0,0,0,0]},ENERGY:{dimensions:[1,2,-2,0,0,0,0,0,0]},POWER:{dimensions:[1,2,-3,0,0,0,0,0,0]},PRESSURE:{dimensions:[1,-1,-2,0,0,0,0,0,0]},ELECTRIC_CHARGE:{dimensions:[0,0,1,1,0,0,0,0,0]},ELECTRIC_CAPACITANCE:{dimensions:[-1,-2,4,2,0,0,0,0,0]},ELECTRIC_POTENTIAL:{dimensions:[1,2,-3,-1,0,0,0,0,0]},ELECTRIC_RESISTANCE:{dimensions:[1,2,-3,-2,0,0,0,0,0]},ELECTRIC_INDUCTANCE:{dimensions:[1,2,-2,-2,0,0,0,0,0]},ELECTRIC_CONDUCTANCE:{dimensions:[-1,-2,3,2,0,0,0,0,0]},MAGNETIC_FLUX:{dimensions:[1,2,-2,-1,0,0,0,0,0]},MAGNETIC_FLUX_DENSITY:{dimensions:[1,0,-2,-1,0,0,0,0,0]},FREQUENCY:{dimensions:[0,0,-1,0,0,0,0,0,0]},ANGLE:{dimensions:[0,0,0,0,0,0,0,1,0]},BIT:{dimensions:[0,0,0,0,0,0,0,0,1]}};for(var Pa in ba)hasOwnProperty$1(ba,Pa)&&(ba[Pa].key=Pa);var Ia={name:"",base:{},value:1,offset:0,dimensions:ka.map(xa=>0)},Da={meter:{name:"meter",base:ba.LENGTH,prefixes:fa.LONG,value:1,offset:0},inch:{name:"inch",base:ba.LENGTH,prefixes:fa.NONE,value:.0254,offset:0},foot:{name:"foot",base:ba.LENGTH,prefixes:fa.NONE,value:.3048,offset:0},yard:{name:"yard",base:ba.LENGTH,prefixes:fa.NONE,value:.9144,offset:0},mile:{name:"mile",base:ba.LENGTH,prefixes:fa.NONE,value:1609.344,offset:0},link:{name:"link",base:ba.LENGTH,prefixes:fa.NONE,value:.201168,offset:0},rod:{name:"rod",base:ba.LENGTH,prefixes:fa.NONE,value:5.0292,offset:0},chain:{name:"chain",base:ba.LENGTH,prefixes:fa.NONE,value:20.1168,offset:0},angstrom:{name:"angstrom",base:ba.LENGTH,prefixes:fa.NONE,value:1e-10,offset:0},m:{name:"m",base:ba.LENGTH,prefixes:fa.SHORT,value:1,offset:0},in:{name:"in",base:ba.LENGTH,prefixes:fa.NONE,value:.0254,offset:0},ft:{name:"ft",base:ba.LENGTH,prefixes:fa.NONE,value:.3048,offset:0},yd:{name:"yd",base:ba.LENGTH,prefixes:fa.NONE,value:.9144,offset:0},mi:{name:"mi",base:ba.LENGTH,prefixes:fa.NONE,value:1609.344,offset:0},li:{name:"li",base:ba.LENGTH,prefixes:fa.NONE,value:.201168,offset:0},rd:{name:"rd",base:ba.LENGTH,prefixes:fa.NONE,value:5.02921,offset:0},ch:{name:"ch",base:ba.LENGTH,prefixes:fa.NONE,value:20.1168,offset:0},mil:{name:"mil",base:ba.LENGTH,prefixes:fa.NONE,value:254e-7,offset:0},m2:{name:"m2",base:ba.SURFACE,prefixes:fa.SQUARED,value:1,offset:0},sqin:{name:"sqin",base:ba.SURFACE,prefixes:fa.NONE,value:64516e-8,offset:0},sqft:{name:"sqft",base:ba.SURFACE,prefixes:fa.NONE,value:.09290304,offset:0},sqyd:{name:"sqyd",base:ba.SURFACE,prefixes:fa.NONE,value:.83612736,offset:0},sqmi:{name:"sqmi",base:ba.SURFACE,prefixes:fa.NONE,value:2589988110336e-6,offset:0},sqrd:{name:"sqrd",base:ba.SURFACE,prefixes:fa.NONE,value:25.29295,offset:0},sqch:{name:"sqch",base:ba.SURFACE,prefixes:fa.NONE,value:404.6873,offset:0},sqmil:{name:"sqmil",base:ba.SURFACE,prefixes:fa.NONE,value:64516e-14,offset:0},acre:{name:"acre",base:ba.SURFACE,prefixes:fa.NONE,value:4046.86,offset:0},hectare:{name:"hectare",base:ba.SURFACE,prefixes:fa.NONE,value:1e4,offset:0},m3:{name:"m3",base:ba.VOLUME,prefixes:fa.CUBIC,value:1,offset:0},L:{name:"L",base:ba.VOLUME,prefixes:fa.SHORT,value:.001,offset:0},l:{name:"l",base:ba.VOLUME,prefixes:fa.SHORT,value:.001,offset:0},litre:{name:"litre",base:ba.VOLUME,prefixes:fa.LONG,value:.001,offset:0},cuin:{name:"cuin",base:ba.VOLUME,prefixes:fa.NONE,value:16387064e-12,offset:0},cuft:{name:"cuft",base:ba.VOLUME,prefixes:fa.NONE,value:.028316846592,offset:0},cuyd:{name:"cuyd",base:ba.VOLUME,prefixes:fa.NONE,value:.764554857984,offset:0},teaspoon:{name:"teaspoon",base:ba.VOLUME,prefixes:fa.NONE,value:5e-6,offset:0},tablespoon:{name:"tablespoon",base:ba.VOLUME,prefixes:fa.NONE,value:15e-6,offset:0},drop:{name:"drop",base:ba.VOLUME,prefixes:fa.NONE,value:5e-8,offset:0},gtt:{name:"gtt",base:ba.VOLUME,prefixes:fa.NONE,value:5e-8,offset:0},minim:{name:"minim",base:ba.VOLUME,prefixes:fa.NONE,value:61611519921875e-21,offset:0},fluiddram:{name:"fluiddram",base:ba.VOLUME,prefixes:fa.NONE,value:36966911953125e-19,offset:0},fluidounce:{name:"fluidounce",base:ba.VOLUME,prefixes:fa.NONE,value:295735295625e-16,offset:0},gill:{name:"gill",base:ba.VOLUME,prefixes:fa.NONE,value:.00011829411825,offset:0},cc:{name:"cc",base:ba.VOLUME,prefixes:fa.NONE,value:1e-6,offset:0},cup:{name:"cup",base:ba.VOLUME,prefixes:fa.NONE,value:.0002365882365,offset:0},pint:{name:"pint",base:ba.VOLUME,prefixes:fa.NONE,value:.000473176473,offset:0},quart:{name:"quart",base:ba.VOLUME,prefixes:fa.NONE,value:.000946352946,offset:0},gallon:{name:"gallon",base:ba.VOLUME,prefixes:fa.NONE,value:.003785411784,offset:0},beerbarrel:{name:"beerbarrel",base:ba.VOLUME,prefixes:fa.NONE,value:.117347765304,offset:0},oilbarrel:{name:"oilbarrel",base:ba.VOLUME,prefixes:fa.NONE,value:.158987294928,offset:0},hogshead:{name:"hogshead",base:ba.VOLUME,prefixes:fa.NONE,value:.238480942392,offset:0},g:{name:"g",base:ba.MASS,prefixes:fa.SHORT,value:.001,offset:0},gram:{name:"gram",base:ba.MASS,prefixes:fa.LONG,value:.001,offset:0},ton:{name:"ton",base:ba.MASS,prefixes:fa.SHORT,value:907.18474,offset:0},t:{name:"t",base:ba.MASS,prefixes:fa.SHORT,value:1e3,offset:0},tonne:{name:"tonne",base:ba.MASS,prefixes:fa.LONG,value:1e3,offset:0},grain:{name:"grain",base:ba.MASS,prefixes:fa.NONE,value:6479891e-11,offset:0},dram:{name:"dram",base:ba.MASS,prefixes:fa.NONE,value:.0017718451953125,offset:0},ounce:{name:"ounce",base:ba.MASS,prefixes:fa.NONE,value:.028349523125,offset:0},poundmass:{name:"poundmass",base:ba.MASS,prefixes:fa.NONE,value:.45359237,offset:0},hundredweight:{name:"hundredweight",base:ba.MASS,prefixes:fa.NONE,value:45.359237,offset:0},stick:{name:"stick",base:ba.MASS,prefixes:fa.NONE,value:.115,offset:0},stone:{name:"stone",base:ba.MASS,prefixes:fa.NONE,value:6.35029318,offset:0},gr:{name:"gr",base:ba.MASS,prefixes:fa.NONE,value:6479891e-11,offset:0},dr:{name:"dr",base:ba.MASS,prefixes:fa.NONE,value:.0017718451953125,offset:0},oz:{name:"oz",base:ba.MASS,prefixes:fa.NONE,value:.028349523125,offset:0},lbm:{name:"lbm",base:ba.MASS,prefixes:fa.NONE,value:.45359237,offset:0},cwt:{name:"cwt",base:ba.MASS,prefixes:fa.NONE,value:45.359237,offset:0},s:{name:"s",base:ba.TIME,prefixes:fa.SHORT,value:1,offset:0},min:{name:"min",base:ba.TIME,prefixes:fa.NONE,value:60,offset:0},h:{name:"h",base:ba.TIME,prefixes:fa.NONE,value:3600,offset:0},second:{name:"second",base:ba.TIME,prefixes:fa.LONG,value:1,offset:0},sec:{name:"sec",base:ba.TIME,prefixes:fa.LONG,value:1,offset:0},minute:{name:"minute",base:ba.TIME,prefixes:fa.NONE,value:60,offset:0},hour:{name:"hour",base:ba.TIME,prefixes:fa.NONE,value:3600,offset:0},day:{name:"day",base:ba.TIME,prefixes:fa.NONE,value:86400,offset:0},week:{name:"week",base:ba.TIME,prefixes:fa.NONE,value:7*86400,offset:0},month:{name:"month",base:ba.TIME,prefixes:fa.NONE,value:2629800,offset:0},year:{name:"year",base:ba.TIME,prefixes:fa.NONE,value:31557600,offset:0},decade:{name:"decade",base:ba.TIME,prefixes:fa.NONE,value:315576e3,offset:0},century:{name:"century",base:ba.TIME,prefixes:fa.NONE,value:315576e4,offset:0},millennium:{name:"millennium",base:ba.TIME,prefixes:fa.NONE,value:315576e5,offset:0},hertz:{name:"Hertz",base:ba.FREQUENCY,prefixes:fa.LONG,value:1,offset:0,reciprocal:!0},Hz:{name:"Hz",base:ba.FREQUENCY,prefixes:fa.SHORT,value:1,offset:0,reciprocal:!0},rad:{name:"rad",base:ba.ANGLE,prefixes:fa.SHORT,value:1,offset:0},radian:{name:"radian",base:ba.ANGLE,prefixes:fa.LONG,value:1,offset:0},deg:{name:"deg",base:ba.ANGLE,prefixes:fa.SHORT,value:null,offset:0},degree:{name:"degree",base:ba.ANGLE,prefixes:fa.LONG,value:null,offset:0},grad:{name:"grad",base:ba.ANGLE,prefixes:fa.SHORT,value:null,offset:0},gradian:{name:"gradian",base:ba.ANGLE,prefixes:fa.LONG,value:null,offset:0},cycle:{name:"cycle",base:ba.ANGLE,prefixes:fa.NONE,value:null,offset:0},arcsec:{name:"arcsec",base:ba.ANGLE,prefixes:fa.NONE,value:null,offset:0},arcmin:{name:"arcmin",base:ba.ANGLE,prefixes:fa.NONE,value:null,offset:0},A:{name:"A",base:ba.CURRENT,prefixes:fa.SHORT,value:1,offset:0},ampere:{name:"ampere",base:ba.CURRENT,prefixes:fa.LONG,value:1,offset:0},K:{name:"K",base:ba.TEMPERATURE,prefixes:fa.SHORT,value:1,offset:0},degC:{name:"degC",base:ba.TEMPERATURE,prefixes:fa.SHORT,value:1,offset:273.15},degF:{name:"degF",base:ba.TEMPERATURE,prefixes:fa.SHORT,value:new Zi(5,9),offset:459.67},degR:{name:"degR",base:ba.TEMPERATURE,prefixes:fa.SHORT,value:new Zi(5,9),offset:0},kelvin:{name:"kelvin",base:ba.TEMPERATURE,prefixes:fa.LONG,value:1,offset:0},celsius:{name:"celsius",base:ba.TEMPERATURE,prefixes:fa.LONG,value:1,offset:273.15},fahrenheit:{name:"fahrenheit",base:ba.TEMPERATURE,prefixes:fa.LONG,value:new Zi(5,9),offset:459.67},rankine:{name:"rankine",base:ba.TEMPERATURE,prefixes:fa.LONG,value:new Zi(5,9),offset:0},mol:{name:"mol",base:ba.AMOUNT_OF_SUBSTANCE,prefixes:fa.SHORT,value:1,offset:0},mole:{name:"mole",base:ba.AMOUNT_OF_SUBSTANCE,prefixes:fa.LONG,value:1,offset:0},cd:{name:"cd",base:ba.LUMINOUS_INTENSITY,prefixes:fa.SHORT,value:1,offset:0},candela:{name:"candela",base:ba.LUMINOUS_INTENSITY,prefixes:fa.LONG,value:1,offset:0},N:{name:"N",base:ba.FORCE,prefixes:fa.SHORT,value:1,offset:0},newton:{name:"newton",base:ba.FORCE,prefixes:fa.LONG,value:1,offset:0},dyn:{name:"dyn",base:ba.FORCE,prefixes:fa.SHORT,value:1e-5,offset:0},dyne:{name:"dyne",base:ba.FORCE,prefixes:fa.LONG,value:1e-5,offset:0},lbf:{name:"lbf",base:ba.FORCE,prefixes:fa.NONE,value:4.4482216152605,offset:0},poundforce:{name:"poundforce",base:ba.FORCE,prefixes:fa.NONE,value:4.4482216152605,offset:0},kip:{name:"kip",base:ba.FORCE,prefixes:fa.LONG,value:4448.2216,offset:0},kilogramforce:{name:"kilogramforce",base:ba.FORCE,prefixes:fa.NONE,value:9.80665,offset:0},J:{name:"J",base:ba.ENERGY,prefixes:fa.SHORT,value:1,offset:0},joule:{name:"joule",base:ba.ENERGY,prefixes:fa.LONG,value:1,offset:0},erg:{name:"erg",base:ba.ENERGY,prefixes:fa.SHORTLONG,value:1e-7,offset:0},Wh:{name:"Wh",base:ba.ENERGY,prefixes:fa.SHORT,value:3600,offset:0},BTU:{name:"BTU",base:ba.ENERGY,prefixes:fa.BTU,value:1055.05585262,offset:0},eV:{name:"eV",base:ba.ENERGY,prefixes:fa.SHORT,value:1602176565e-28,offset:0},electronvolt:{name:"electronvolt",base:ba.ENERGY,prefixes:fa.LONG,value:1602176565e-28,offset:0},W:{name:"W",base:ba.POWER,prefixes:fa.SHORT,value:1,offset:0},watt:{name:"watt",base:ba.POWER,prefixes:fa.LONG,value:1,offset:0},hp:{name:"hp",base:ba.POWER,prefixes:fa.NONE,value:745.6998715386,offset:0},VAR:{name:"VAR",base:ba.POWER,prefixes:fa.SHORT,value:Qi.I,offset:0},VA:{name:"VA",base:ba.POWER,prefixes:fa.SHORT,value:1,offset:0},Pa:{name:"Pa",base:ba.PRESSURE,prefixes:fa.SHORT,value:1,offset:0},psi:{name:"psi",base:ba.PRESSURE,prefixes:fa.NONE,value:6894.75729276459,offset:0},atm:{name:"atm",base:ba.PRESSURE,prefixes:fa.NONE,value:101325,offset:0},bar:{name:"bar",base:ba.PRESSURE,prefixes:fa.SHORTLONG,value:1e5,offset:0},torr:{name:"torr",base:ba.PRESSURE,prefixes:fa.NONE,value:133.322,offset:0},mmHg:{name:"mmHg",base:ba.PRESSURE,prefixes:fa.NONE,value:133.322,offset:0},mmH2O:{name:"mmH2O",base:ba.PRESSURE,prefixes:fa.NONE,value:9.80665,offset:0},cmH2O:{name:"cmH2O",base:ba.PRESSURE,prefixes:fa.NONE,value:98.0665,offset:0},coulomb:{name:"coulomb",base:ba.ELECTRIC_CHARGE,prefixes:fa.LONG,value:1,offset:0},C:{name:"C",base:ba.ELECTRIC_CHARGE,prefixes:fa.SHORT,value:1,offset:0},Ah:{name:"Ah",base:ba.ELECTRIC_CHARGE,prefixes:fa.SHORT,value:3600,offset:0},farad:{name:"farad",base:ba.ELECTRIC_CAPACITANCE,prefixes:fa.LONG,value:1,offset:0},F:{name:"F",base:ba.ELECTRIC_CAPACITANCE,prefixes:fa.SHORT,value:1,offset:0},volt:{name:"volt",base:ba.ELECTRIC_POTENTIAL,prefixes:fa.LONG,value:1,offset:0},V:{name:"V",base:ba.ELECTRIC_POTENTIAL,prefixes:fa.SHORT,value:1,offset:0},ohm:{name:"ohm",base:ba.ELECTRIC_RESISTANCE,prefixes:fa.SHORTLONG,value:1,offset:0},henry:{name:"henry",base:ba.ELECTRIC_INDUCTANCE,prefixes:fa.LONG,value:1,offset:0},H:{name:"H",base:ba.ELECTRIC_INDUCTANCE,prefixes:fa.SHORT,value:1,offset:0},siemens:{name:"siemens",base:ba.ELECTRIC_CONDUCTANCE,prefixes:fa.LONG,value:1,offset:0},S:{name:"S",base:ba.ELECTRIC_CONDUCTANCE,prefixes:fa.SHORT,value:1,offset:0},weber:{name:"weber",base:ba.MAGNETIC_FLUX,prefixes:fa.LONG,value:1,offset:0},Wb:{name:"Wb",base:ba.MAGNETIC_FLUX,prefixes:fa.SHORT,value:1,offset:0},tesla:{name:"tesla",base:ba.MAGNETIC_FLUX_DENSITY,prefixes:fa.LONG,value:1,offset:0},T:{name:"T",base:ba.MAGNETIC_FLUX_DENSITY,prefixes:fa.SHORT,value:1,offset:0},b:{name:"b",base:ba.BIT,prefixes:fa.BINARY_SHORT,value:1,offset:0},bits:{name:"bits",base:ba.BIT,prefixes:fa.BINARY_LONG,value:1,offset:0},B:{name:"B",base:ba.BIT,prefixes:fa.BINARY_SHORT,value:8,offset:0},bytes:{name:"bytes",base:ba.BIT,prefixes:fa.BINARY_LONG,value:8,offset:0}},va={meters:"meter",inches:"inch",feet:"foot",yards:"yard",miles:"mile",links:"link",rods:"rod",chains:"chain",angstroms:"angstrom",lt:"l",litres:"litre",liter:"litre",liters:"litre",teaspoons:"teaspoon",tablespoons:"tablespoon",minims:"minim",fldr:"fluiddram",fluiddrams:"fluiddram",floz:"fluidounce",fluidounces:"fluidounce",gi:"gill",gills:"gill",cp:"cup",cups:"cup",pt:"pint",pints:"pint",qt:"quart",quarts:"quart",gal:"gallon",gallons:"gallon",bbl:"beerbarrel",beerbarrels:"beerbarrel",obl:"oilbarrel",oilbarrels:"oilbarrel",hogsheads:"hogshead",gtts:"gtt",grams:"gram",tons:"ton",tonnes:"tonne",grains:"grain",drams:"dram",ounces:"ounce",poundmasses:"poundmass",hundredweights:"hundredweight",sticks:"stick",lb:"lbm",lbs:"lbm",kips:"kip",kgf:"kilogramforce",acres:"acre",hectares:"hectare",sqfeet:"sqft",sqyard:"sqyd",sqmile:"sqmi",sqmiles:"sqmi",mmhg:"mmHg",mmh2o:"mmH2O",cmh2o:"cmH2O",seconds:"second",secs:"second",minutes:"minute",mins:"minute",hours:"hour",hr:"hour",hrs:"hour",days:"day",weeks:"week",months:"month",years:"year",decades:"decade",centuries:"century",millennia:"millennium",hertz:"hertz",radians:"radian",degrees:"degree",gradians:"gradian",cycles:"cycle",arcsecond:"arcsec",arcseconds:"arcsec",arcminute:"arcmin",arcminutes:"arcmin",BTUs:"BTU",watts:"watt",joules:"joule",amperes:"ampere",amps:"ampere",amp:"ampere",coulombs:"coulomb",volts:"volt",ohms:"ohm",farads:"farad",webers:"weber",teslas:"tesla",electronvolts:"electronvolt",moles:"mole",bit:"bits",byte:"bytes"};function Ca(xa){if(xa.number==="BigNumber"){var Ra=createBigNumberPi(Gi);Da.rad.value=new Gi(1),Da.deg.value=Ra.div(180),Da.grad.value=Ra.div(200),Da.cycle.value=Ra.times(2),Da.arcsec.value=Ra.div(648e3),Da.arcmin.value=Ra.div(10800)}else Da.rad.value=1,Da.deg.value=Math.PI/180,Da.grad.value=Math.PI/200,Da.cycle.value=Math.PI*2,Da.arcsec.value=Math.PI/648e3,Da.arcmin.value=Math.PI/10800;Da.radian.value=Da.rad.value,Da.degree.value=Da.deg.value,Da.gradian.value=Da.grad.value}Ca(F),E&&E("config",function(xa,Ra){xa.number!==Ra.number&&Ca(xa)});var ya={si:{NONE:{unit:Ia,prefix:fa.NONE[""]},LENGTH:{unit:Da.m,prefix:fa.SHORT[""]},MASS:{unit:Da.g,prefix:fa.SHORT.k},TIME:{unit:Da.s,prefix:fa.SHORT[""]},CURRENT:{unit:Da.A,prefix:fa.SHORT[""]},TEMPERATURE:{unit:Da.K,prefix:fa.SHORT[""]},LUMINOUS_INTENSITY:{unit:Da.cd,prefix:fa.SHORT[""]},AMOUNT_OF_SUBSTANCE:{unit:Da.mol,prefix:fa.SHORT[""]},ANGLE:{unit:Da.rad,prefix:fa.SHORT[""]},BIT:{unit:Da.bits,prefix:fa.SHORT[""]},FORCE:{unit:Da.N,prefix:fa.SHORT[""]},ENERGY:{unit:Da.J,prefix:fa.SHORT[""]},POWER:{unit:Da.W,prefix:fa.SHORT[""]},PRESSURE:{unit:Da.Pa,prefix:fa.SHORT[""]},ELECTRIC_CHARGE:{unit:Da.C,prefix:fa.SHORT[""]},ELECTRIC_CAPACITANCE:{unit:Da.F,prefix:fa.SHORT[""]},ELECTRIC_POTENTIAL:{unit:Da.V,prefix:fa.SHORT[""]},ELECTRIC_RESISTANCE:{unit:Da.ohm,prefix:fa.SHORT[""]},ELECTRIC_INDUCTANCE:{unit:Da.H,prefix:fa.SHORT[""]},ELECTRIC_CONDUCTANCE:{unit:Da.S,prefix:fa.SHORT[""]},MAGNETIC_FLUX:{unit:Da.Wb,prefix:fa.SHORT[""]},MAGNETIC_FLUX_DENSITY:{unit:Da.T,prefix:fa.SHORT[""]},FREQUENCY:{unit:Da.Hz,prefix:fa.SHORT[""]}}};ya.cgs=JSON.parse(JSON.stringify(ya.si)),ya.cgs.LENGTH={unit:Da.m,prefix:fa.SHORT.c},ya.cgs.MASS={unit:Da.g,prefix:fa.SHORT[""]},ya.cgs.FORCE={unit:Da.dyn,prefix:fa.SHORT[""]},ya.cgs.ENERGY={unit:Da.erg,prefix:fa.NONE[""]},ya.us=JSON.parse(JSON.stringify(ya.si)),ya.us.LENGTH={unit:Da.ft,prefix:fa.NONE[""]},ya.us.MASS={unit:Da.lbm,prefix:fa.NONE[""]},ya.us.TEMPERATURE={unit:Da.degF,prefix:fa.NONE[""]},ya.us.FORCE={unit:Da.lbf,prefix:fa.NONE[""]},ya.us.ENERGY={unit:Da.BTU,prefix:fa.BTU[""]},ya.us.POWER={unit:Da.hp,prefix:fa.NONE[""]},ya.us.PRESSURE={unit:Da.psi,prefix:fa.NONE[""]},ya.auto=JSON.parse(JSON.stringify(ya.si));var Na=ya.auto;for(var za in Ji.setUnitSystem=function(xa){if(hasOwnProperty$1(ya,xa))Na=ya[xa];else throw Error("Unit system "+xa+" does not exist. Choices are: "+Object.keys(ya).join(", "))},Ji.getUnitSystem=function(){for(var xa in ya)if(hasOwnProperty$1(ya,xa)&&ya[xa]===Na)return xa},Ji.typeConverters={BigNumber:function(xa){return xa!=null&&xa.isFraction?new Gi(String(xa.n)).div(String(xa.d)).times(String(xa.s)):new Gi(xa+"")},Fraction:function(xa){return new Zi(xa)},Complex:function(xa){return xa},number:function(xa){return xa!=null&&xa.isFraction?Hi(xa):xa}},Ji.prototype._numberConverter=function(){var xa=Ji.typeConverters[this.valueType()];if(xa)return xa;throw TypeError(\'Unsupported Unit value type "\'+this.valueType()+\'"\')},Ji._getNumberConverter=function(xa){if(!Ji.typeConverters[xa])throw TypeError(\'Unsupported type "\'+xa+\'"\');return Ji.typeConverters[xa]},Da)if(hasOwnProperty$1(Da,za)){var Ta=Da[za];Ta.dimensions=Ta.base.dimensions}for(var es in va)if(hasOwnProperty$1(va,es)){var ts=Da[va[es]],Ka={};for(var ps in ts)hasOwnProperty$1(ts,ps)&&(Ka[ps]=ts[ps]);Ka.name=es,Da[es]=Ka}Ji.isValidAlpha=function(xa){return/^[a-zA-Z]$/.test(xa)};function cs(xa){for(var Ra=0;Ra<xa.length;Ra++){if(ra=xa.charAt(Ra),Ra===0&&!Ji.isValidAlpha(ra))throw Error(\'Invalid unit name (must begin with alpha character): "\'+xa+\'"\');if(Ra>0&&!(Ji.isValidAlpha(ra)||ua(ra)))throw Error(\'Invalid unit name (only alphanumeric characters are allowed): "\'+xa+\'"\')}}return Ji.createUnit=function(xa,Ra){if(typeof xa!="object")throw TypeError("createUnit expects first parameter to be of type \'Object\'");if(Ra&&Ra.override){for(var Va in xa)if(hasOwnProperty$1(xa,Va)&&Ji.deleteUnit(Va),xa[Va].aliases)for(var Ga=0;Ga<xa[Va].aliases.length;Ga++)Ji.deleteUnit(xa[Va].aliases[Ga])}var as;for(var rs in xa)hasOwnProperty$1(xa,rs)&&(as=Ji.createUnitSingle(rs,xa[rs]));return as},Ji.createUnitSingle=function(xa,Ra){if(Ra??={},typeof xa!="string")throw TypeError("createUnitSingle expects first parameter to be of type \'string\'");if(hasOwnProperty$1(Da,xa))throw Error(\'Cannot create unit "\'+xa+\'": a unit with that name already exists\');cs(xa);var Va=null,Ga=[],as=0,rs,ss,ms;if(Ra&&Ra.type==="Unit")Va=Ra.clone();else if(typeof Ra=="string")Ra!==""&&(rs=Ra);else if(typeof Ra=="object")rs=Ra.definition,ss=Ra.prefixes,as=Ra.offset,ms=Ra.baseName,Ra.aliases&&(Ga=Ra.aliases.valueOf());else throw TypeError(\'Cannot create unit "\'+xa+\'" from "\'+Ra.toString()+\'": expecting "string" or "Unit" or "Object"\');if(Ga){for(var Ua=0;Ua<Ga.length;Ua++)if(hasOwnProperty$1(Da,Ga[Ua]))throw Error(\'Cannot create alias "\'+Ga[Ua]+\'": a unit with that name already exists\')}if(rs&&typeof rs=="string"&&!Va)try{Va=Ji.parse(rs,{allowNoUnits:!0})}catch(fs){throw fs.message=\'Could not create unit "\'+xa+\'" from "\'+rs+\'": \'+fs.message,fs}else rs&&rs.type==="Unit"&&(Va=rs.clone());Ga||=[],as||=0,ss=ss&&ss.toUpperCase&&fa[ss.toUpperCase()]||fa.NONE;var Wa={};if(Va){Wa={name:xa,value:Va.value,dimensions:Va.dimensions.slice(0),prefixes:ss,offset:as};var wa=!1;for(var qa in ba)if(hasOwnProperty$1(ba,qa)){for(var ja=!0,Xa=0;Xa<ka.length;Xa++)if(Math.abs((Wa.dimensions[Xa]||0)-(ba[qa].dimensions[Xa]||0))>1e-12){ja=!1;break}if(ja){wa=!0,Wa.base=ba[qa];break}}if(!wa){ms||=xa+"_STUFF";var Ya={dimensions:Va.dimensions.slice(0)};Ya.key=ms,ba[ms]=Ya,Na[ms]={unit:Wa,prefix:fa.NONE[""]},Wa.base=ba[ms]}}else{if(ms||=xa+"_STUFF",ka.indexOf(ms)>=0)throw Error(\'Cannot create new base unit "\'+xa+\'": a base unit with that name already exists (and cannot be overridden)\');for(var Ja in ka.push(ms),ba)hasOwnProperty$1(ba,Ja)&&(ba[Ja].dimensions[ka.length-1]=0);for(var os={dimensions:[]},ns=0;ns<ka.length;ns++)os.dimensions[ns]=0;os.dimensions[ka.length-1]=1,os.key=ms,ba[ms]=os,Wa={name:xa,value:1,dimensions:ba[ms].dimensions.slice(0),prefixes:ss,offset:as,base:ba[ms]},Na[ms]={unit:Wa,prefix:fa.NONE[""]}}Ji.UNITS[xa]=Wa;for(var ca=0;ca<Ga.length;ca++){var Sa=Ga[ca],Ha={};for(var Za in Wa)hasOwnProperty$1(Wa,Za)&&(Ha[Za]=Wa[Za]);Ha.name=Sa,Ji.UNITS[Sa]=Ha}return delete ha.cache,new Ji(null,xa)},Ji.deleteUnit=function(xa){delete Ji.UNITS[xa],delete ha.cache},Ji.PREFIXES=fa,Ji.BASE_DIMENSIONS=ka,Ji.BASE_UNITS=ba,Ji.UNIT_SYSTEMS=ya,Ji.UNITS=Da,Ji},{isClass:!0}),name$156="unit",dependencies$156=["typed","Unit"],createUnitFunction=factory(name$156,dependencies$156,D=>{var{typed:E,Unit:F}=D;return E(name$156,{Unit:function(J){return J.clone()},string:function(J){return F.isValuelessUnit(J)?new F(null,J):F.parse(J,{allowNoUnits:!0})},"number | BigNumber | Fraction | Complex, string | Unit":function(J,$e){return new F(J,$e)},"number | BigNumber | Fraction":function(J){return new F(J)},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$155="sparse",dependencies$155=["typed","SparseMatrix"],createSparse=factory(name$155,dependencies$155,D=>{var{typed:E,SparseMatrix:F}=D;return E(name$155,{"":function(){return new F([])},string:function(J){return new F([],J)},"Array | Matrix":function(J){return new F(J)},"Array | Matrix, string":function(J,$e){return new F(J,$e)}})}),name$154="createUnit",dependencies$154=["typed","Unit"],createCreateUnit=factory(name$154,dependencies$154,D=>{var{typed:E,Unit:F}=D;return E(name$154,{"Object, Object":function(J,$e){return F.createUnit(J,$e)},Object:function(J){return F.createUnit(J,{})},"string, Unit | string | Object, Object":function(J,$e,_t){var lr={};return lr[J]=$e,F.createUnit(lr,_t)},"string, Unit | string | Object":function(J,$e){var _t={};return _t[J]=$e,F.createUnit(_t,{})},string:function(J){var $e={};return $e[J]={},F.createUnit($e,{})}})}),name$153="acos",dependencies$153=["typed","config","Complex"],createAcos=factory(name$153,dependencies$153,D=>{var{typed:E,config:F,Complex:J}=D;return E(name$153,{number:function($e){return $e>=-1&&$e<=1||F.predictable?Math.acos($e):new J($e,0).acos()},Complex:function($e){return $e.acos()},BigNumber:function($e){return $e.acos()}})}),name$152="acosh",dependencies$152=["typed","config","Complex"],createAcosh=factory(name$152,dependencies$152,D=>{var{typed:E,config:F,Complex:J}=D;return E(name$152,{number:function($e){return $e>=1||F.predictable?acoshNumber($e):$e<=-1?new J(Math.log(Math.sqrt($e*$e-1)-$e),Math.PI):new J($e,0).acosh()},Complex:function($e){return $e.acosh()},BigNumber:function($e){return $e.acosh()}})}),name$151="acot",dependencies$151=["typed","BigNumber"],createAcot=factory(name$151,dependencies$151,D=>{var{typed:E,BigNumber:F}=D;return E(name$151,{number:acotNumber,Complex:function(J){return J.acot()},BigNumber:function(J){return new F(1).div(J).atan()}})}),name$150="acoth",dependencies$150=["typed","config","Complex","BigNumber"],createAcoth=factory(name$150,dependencies$150,D=>{var{typed:E,config:F,Complex:J,BigNumber:$e}=D;return E(name$150,{number:function(_t){return _t>=1||_t<=-1||F.predictable?acothNumber(_t):new J(_t,0).acoth()},Complex:function(_t){return _t.acoth()},BigNumber:function(_t){return new $e(1).div(_t).atanh()}})}),name$149="acsc",dependencies$149=["typed","config","Complex","BigNumber"],createAcsc=factory(name$149,dependencies$149,D=>{var{typed:E,config:F,Complex:J,BigNumber:$e}=D;return E(name$149,{number:function(_t){return _t<=-1||_t>=1||F.predictable?acscNumber(_t):new J(_t,0).acsc()},Complex:function(_t){return _t.acsc()},BigNumber:function(_t){return new $e(1).div(_t).asin()}})}),name$148="acsch",dependencies$148=["typed","BigNumber"],createAcsch=factory(name$148,dependencies$148,D=>{var{typed:E,BigNumber:F}=D;return E(name$148,{number:acschNumber,Complex:function(J){return J.acsch()},BigNumber:function(J){return new F(1).div(J).asinh()}})}),name$147="asec",dependencies$147=["typed","config","Complex","BigNumber"],createAsec=factory(name$147,dependencies$147,D=>{var{typed:E,config:F,Complex:J,BigNumber:$e}=D;return E(name$147,{number:function(_t){return _t<=-1||_t>=1||F.predictable?asecNumber(_t):new J(_t,0).asec()},Complex:function(_t){return _t.asec()},BigNumber:function(_t){return new $e(1).div(_t).acos()}})}),name$146="asech",dependencies$146=["typed","config","Complex","BigNumber"],createAsech=factory(name$146,dependencies$146,D=>{var{typed:E,config:F,Complex:J,BigNumber:$e}=D;return E(name$146,{number:function(_t){if(_t<=1&&_t>=-1||F.predictable){var lr=1/_t;if(lr>0||F.predictable)return asechNumber(_t);var mr=Math.sqrt(lr*lr-1);return new J(Math.log(mr-lr),Math.PI)}return new J(_t,0).asech()},Complex:function(_t){return _t.asech()},BigNumber:function(_t){return new $e(1).div(_t).acosh()}})}),name$145="asin",dependencies$145=["typed","config","Complex"],createAsin=factory(name$145,dependencies$145,D=>{var{typed:E,config:F,Complex:J}=D;return E(name$145,{number:function($e){return $e>=-1&&$e<=1||F.predictable?Math.asin($e):new J($e,0).asin()},Complex:function($e){return $e.asin()},BigNumber:function($e){return $e.asin()}})}),name$144="asinh",dependencies$144=["typed"],createAsinh=factory(name$144,dependencies$144,D=>{var{typed:E}=D;return E("asinh",{number:asinhNumber,Complex:function(F){return F.asinh()},BigNumber:function(F){return F.asinh()}})}),name$143="atan",dependencies$143=["typed"],createAtan=factory(name$143,dependencies$143,D=>{var{typed:E}=D;return E("atan",{number:function(F){return Math.atan(F)},Complex:function(F){return F.atan()},BigNumber:function(F){return F.atan()}})}),name$142="atan2",dependencies$142=["typed","matrix","equalScalar","BigNumber","DenseMatrix","concat"],createAtan2=factory(name$142,dependencies$142,D=>{var{typed:E,matrix:F,equalScalar:J,BigNumber:$e,DenseMatrix:_t,concat:lr}=D,mr=createMatAlgo02xDS0({typed:E,equalScalar:J}),Or=createMatAlgo03xDSf({typed:E}),Pr=createMatAlgo09xS0Sf({typed:E,equalScalar:J}),dn=createMatAlgo11xS0s({typed:E,equalScalar:J}),gi=createMatAlgo12xSfs({typed:E,DenseMatrix:_t}),qi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:lr});return E(name$142,{"number, number":Math.atan2,"BigNumber, BigNumber":(zi,Hi)=>$e.atan2(zi,Hi)},qi({scalar:"number | BigNumber",SS:Pr,DS:Or,SD:mr,Ss:dn,sS:gi}))}),name$141="atanh",dependencies$141=["typed","config","Complex"],createAtanh=factory(name$141,dependencies$141,D=>{var{typed:E,config:F,Complex:J}=D;return E(name$141,{number:function($e){return $e<=1&&$e>=-1||F.predictable?atanhNumber($e):new J($e,0).atanh()},Complex:function($e){return $e.atanh()},BigNumber:function($e){return $e.atanh()}})}),createTrigUnit=factory("trigUnit",["typed"],D=>{var{typed:E}=D;return{Unit:E.referToSelf(F=>J=>{if(!J.hasBase(J.constructor.BASE_UNITS.ANGLE))throw TypeError("Unit in function cot is no angle");return E.find(F,J.valueType())(J.value)})}}),name$140="cos",dependencies$140=["typed"],createCos=factory(name$140,dependencies$140,D=>{var{typed:E}=D,F=createTrigUnit({typed:E});return E(name$140,{number:Math.cos,"Complex | BigNumber":J=>J.cos()},F)}),name$139="cosh",dependencies$139=["typed"],createCosh=factory(name$139,dependencies$139,D=>{var{typed:E}=D;return E(name$139,{number:cosh$3,"Complex | BigNumber":F=>F.cosh()})}),name$138="cot",dependencies$138=["typed","BigNumber"],createCot=factory(name$138,dependencies$138,D=>{var{typed:E,BigNumber:F}=D,J=createTrigUnit({typed:E});return E(name$138,{number:cotNumber,Complex:$e=>$e.cot(),BigNumber:$e=>new F(1).div($e.tan())},J)}),name$137="coth",dependencies$137=["typed","BigNumber"],createCoth=factory(name$137,dependencies$137,D=>{var{typed:E,BigNumber:F}=D;return E(name$137,{number:cothNumber,Complex:J=>J.coth(),BigNumber:J=>new F(1).div(J.tanh())})}),name$136="csc",dependencies$136=["typed","BigNumber"],createCsc=factory(name$136,dependencies$136,D=>{var{typed:E,BigNumber:F}=D,J=createTrigUnit({typed:E});return E(name$136,{number:cscNumber,Complex:$e=>$e.csc(),BigNumber:$e=>new F(1).div($e.sin())},J)}),name$135="csch",dependencies$135=["typed","BigNumber"],createCsch=factory(name$135,dependencies$135,D=>{var{typed:E,BigNumber:F}=D;return E(name$135,{number:cschNumber,Complex:J=>J.csch(),BigNumber:J=>new F(1).div(J.sinh())})}),name$134="sec",dependencies$134=["typed","BigNumber"],createSec=factory(name$134,dependencies$134,D=>{var{typed:E,BigNumber:F}=D,J=createTrigUnit({typed:E});return E(name$134,{number:secNumber,Complex:$e=>$e.sec(),BigNumber:$e=>new F(1).div($e.cos())},J)}),name$133="sech",dependencies$133=["typed","BigNumber"],createSech=factory(name$133,dependencies$133,D=>{var{typed:E,BigNumber:F}=D;return E(name$133,{number:sechNumber,Complex:J=>J.sech(),BigNumber:J=>new F(1).div(J.cosh())})}),name$132="sin",dependencies$132=["typed"],createSin=factory(name$132,dependencies$132,D=>{var{typed:E}=D,F=createTrigUnit({typed:E});return E(name$132,{number:Math.sin,"Complex | BigNumber":J=>J.sin()},F)}),name$131="sinh",dependencies$131=["typed"],createSinh=factory(name$131,dependencies$131,D=>{var{typed:E}=D;return E(name$131,{number:sinhNumber,"Complex | BigNumber":F=>F.sinh()})}),name$130="tan",dependencies$130=["typed"],createTan=factory(name$130,dependencies$130,D=>{var{typed:E}=D,F=createTrigUnit({typed:E});return E(name$130,{number:Math.tan,"Complex | BigNumber":J=>J.tan()},F)}),name$129="tanh",dependencies$129=["typed"],createTanh=factory(name$129,dependencies$129,D=>{var{typed:E}=D;return E("tanh",{number:tanh$2,"Complex | BigNumber":F=>F.tanh()})}),name$128="setCartesian",dependencies$128=["typed","size","subset","compareNatural","Index","DenseMatrix"],createSetCartesian=factory(name$128,dependencies$128,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t,DenseMatrix:lr}=D;return E(name$128,{"Array | Matrix, Array | Matrix":function(mr,Or){var Pr=[];if(J(F(mr),new _t(0))!==0&&J(F(Or),new _t(0))!==0){var dn=flatten$4(Array.isArray(mr)?mr:mr.toArray()).sort($e),gi=flatten$4(Array.isArray(Or)?Or:Or.toArray()).sort($e);Pr=[];for(var qi=0;qi<dn.length;qi++)for(var zi=0;zi<gi.length;zi++)Pr.push([dn[qi],gi[zi]])}return Array.isArray(mr)&&Array.isArray(Or)?Pr:new lr(Pr)}})}),name$127="setDifference",dependencies$127=["typed","size","subset","compareNatural","Index","DenseMatrix"],createSetDifference=factory(name$127,dependencies$127,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t,DenseMatrix:lr}=D;return E(name$127,{"Array | Matrix, Array | Matrix":function(mr,Or){var Pr;if(J(F(mr),new _t(0))===0)Pr=[];else{if(J(F(Or),new _t(0))===0)return flatten$4(mr.toArray());var dn=identify(flatten$4(Array.isArray(mr)?mr:mr.toArray()).sort($e)),gi=identify(flatten$4(Array.isArray(Or)?Or:Or.toArray()).sort($e));Pr=[];for(var qi,zi=0;zi<dn.length;zi++){qi=!1;for(var Hi=0;Hi<gi.length;Hi++)if($e(dn[zi].value,gi[Hi].value)===0&&dn[zi].identifier===gi[Hi].identifier){qi=!0;break}qi||Pr.push(dn[zi])}}return Array.isArray(mr)&&Array.isArray(Or)?generalize(Pr):new lr(generalize(Pr))}})}),name$126="setDistinct",dependencies$126=["typed","size","subset","compareNatural","Index","DenseMatrix"],createSetDistinct=factory(name$126,dependencies$126,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t,DenseMatrix:lr}=D;return E(name$126,{"Array | Matrix":function(mr){var Or;if(J(F(mr),new _t(0))===0)Or=[];else{var Pr=flatten$4(Array.isArray(mr)?mr:mr.toArray()).sort($e);Or=[],Or.push(Pr[0]);for(var dn=1;dn<Pr.length;dn++)$e(Pr[dn],Pr[dn-1])!==0&&Or.push(Pr[dn])}return Array.isArray(mr)?Or:new lr(Or)}})}),name$125="setIntersect",dependencies$125=["typed","size","subset","compareNatural","Index","DenseMatrix"],createSetIntersect=factory(name$125,dependencies$125,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t,DenseMatrix:lr}=D;return E(name$125,{"Array | Matrix, Array | Matrix":function(mr,Or){var Pr;if(J(F(mr),new _t(0))===0||J(F(Or),new _t(0))===0)Pr=[];else{var dn=identify(flatten$4(Array.isArray(mr)?mr:mr.toArray()).sort($e)),gi=identify(flatten$4(Array.isArray(Or)?Or:Or.toArray()).sort($e));Pr=[];for(var qi=0;qi<dn.length;qi++)for(var zi=0;zi<gi.length;zi++)if($e(dn[qi].value,gi[zi].value)===0&&dn[qi].identifier===gi[zi].identifier){Pr.push(dn[qi]);break}}return Array.isArray(mr)&&Array.isArray(Or)?generalize(Pr):new lr(generalize(Pr))}})}),name$124="setIsSubset",dependencies$124=["typed","size","subset","compareNatural","Index"],createSetIsSubset=factory(name$124,dependencies$124,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t}=D;return E(name$124,{"Array | Matrix, Array | Matrix":function(lr,mr){if(J(F(lr),new _t(0))===0)return!0;if(J(F(mr),new _t(0))===0)return!1;for(var Or=identify(flatten$4(Array.isArray(lr)?lr:lr.toArray()).sort($e)),Pr=identify(flatten$4(Array.isArray(mr)?mr:mr.toArray()).sort($e)),dn,gi=0;gi<Or.length;gi++){dn=!1;for(var qi=0;qi<Pr.length;qi++)if($e(Or[gi].value,Pr[qi].value)===0&&Or[gi].identifier===Pr[qi].identifier){dn=!0;break}if(dn===!1)return!1}return!0}})}),name$123="setMultiplicity",dependencies$123=["typed","size","subset","compareNatural","Index"],createSetMultiplicity=factory(name$123,dependencies$123,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t}=D;return E(name$123,{"number | BigNumber | Fraction | Complex, Array | Matrix":function(lr,mr){if(J(F(mr),new _t(0))===0)return 0;for(var Or=flatten$4(Array.isArray(mr)?mr:mr.toArray()),Pr=0,dn=0;dn<Or.length;dn++)$e(Or[dn],lr)===0&&Pr++;return Pr}})}),name$122="setPowerset",dependencies$122=["typed","size","subset","compareNatural","Index"],createSetPowerset=factory(name$122,dependencies$122,D=>{var{typed:E,size:F,subset:J,compareNatural:$e,Index:_t}=D;return E(name$122,{"Array | Matrix":function(Or){if(J(F(Or),new _t(0))===0)return[];for(var Pr=flatten$4(Array.isArray(Or)?Or:Or.toArray()).sort($e),dn=[],gi=0;gi.toString(2).length<=Pr.length;)dn.push(lr(Pr,gi.toString(2).split("").reverse())),gi++;return mr(dn)}});function lr(Or,Pr){for(var dn=[],gi=0;gi<Pr.length;gi++)Pr[gi]==="1"&&dn.push(Or[gi]);return dn}function mr(Or){for(var Pr=[],dn=Or.length-1;dn>0;dn--)for(var gi=0;gi<dn;gi++)Or[gi].length>Or[gi+1].length&&(Pr=Or[gi],Or[gi]=Or[gi+1],Or[gi+1]=Pr);return Or}}),name$121="setSize",dependencies$121=["typed","compareNatural"],createSetSize=factory(name$121,dependencies$121,D=>{var{typed:E,compareNatural:F}=D;return E(name$121,{"Array | Matrix":function(J){return Array.isArray(J)?flatten$4(J).length:flatten$4(J.toArray()).length},"Array | Matrix, boolean":function(J,$e){if($e===!1||J.length===0)return Array.isArray(J)?flatten$4(J).length:flatten$4(J.toArray()).length;for(var _t=flatten$4(Array.isArray(J)?J:J.toArray()).sort(F),lr=1,mr=1;mr<_t.length;mr++)F(_t[mr],_t[mr-1])!==0&&lr++;return lr}})}),name$120="setSymDifference",dependencies$120=["typed","size","concat","subset","setDifference","Index"],createSetSymDifference=factory(name$120,dependencies$120,D=>{var{typed:E,size:F,concat:J,subset:$e,setDifference:_t,Index:lr}=D;return E(name$120,{"Array | Matrix, Array | Matrix":function(mr,Or){if($e(F(mr),new lr(0))===0)return flatten$4(Or);if($e(F(Or),new lr(0))===0)return flatten$4(mr);var Pr=flatten$4(mr),dn=flatten$4(Or);return J(_t(Pr,dn),_t(dn,Pr))}})}),name$119="setUnion",dependencies$119=["typed","size","concat","subset","setIntersect","setSymDifference","Index"],createSetUnion=factory(name$119,dependencies$119,D=>{var{typed:E,size:F,concat:J,subset:$e,setIntersect:_t,setSymDifference:lr,Index:mr}=D;return E(name$119,{"Array | Matrix, Array | Matrix":function(Or,Pr){if($e(F(Or),new mr(0))===0)return flatten$4(Pr);if($e(F(Pr),new mr(0))===0)return flatten$4(Or);var dn=flatten$4(Or),gi=flatten$4(Pr);return J(lr(dn,gi),_t(dn,gi))}})}),name$118="add",dependencies$118=["typed","matrix","addScalar","equalScalar","DenseMatrix","SparseMatrix","concat"],createAdd=factory(name$118,dependencies$118,D=>{var{typed:E,matrix:F,addScalar:J,equalScalar:$e,DenseMatrix:_t,SparseMatrix:lr,concat:mr}=D,Or=createMatAlgo01xDSid({typed:E}),Pr=createMatAlgo04xSidSid({typed:E,equalScalar:$e}),dn=createMatAlgo10xSids({typed:E,DenseMatrix:_t}),gi=createMatrixAlgorithmSuite({typed:E,matrix:F,concat:mr});return E(name$118,{"any, any":J,"any, any, ...any":E.referToSelf(qi=>(zi,Hi,Qi)=>{for(var Gi=qi(zi,Hi),Zi=0;Zi<Qi.length;Zi++)Gi=qi(Gi,Qi[Zi]);return Gi})},gi({elop:J,DS:Or,SS:Pr,Ss:dn}))}),name$117="hypot",dependencies$117=["typed","abs","addScalar","divideScalar","multiplyScalar","sqrt","smaller","isPositive"],createHypot=factory(name$117,dependencies$117,D=>{var{typed:E,abs:F,addScalar:J,divideScalar:$e,multiplyScalar:_t,sqrt:lr,smaller:mr,isPositive:Or}=D;return E(name$117,{"... number | BigNumber":Pr,Array:Pr,Matrix:dn=>Pr(flatten$4(dn.toArray(),!0))});function Pr(dn){for(var gi=0,qi=0,zi=0;zi<dn.length;zi++){if(isComplex(dn[zi]))throw TypeError("Unexpected type of argument to hypot");var Hi=F(dn[zi]);mr(qi,Hi)?(gi=_t(gi,_t($e(qi,Hi),$e(qi,Hi))),gi=J(gi,1),qi=Hi):gi=J(gi,Or(Hi)?_t($e(Hi,qi),$e(Hi,qi)):Hi)}return _t(qi,lr(gi))}}),name$116="norm",dependencies$116=["typed","abs","add","pow","conj","sqrt","multiply","equalScalar","larger","smaller","matrix","ctranspose","eigs"],createNorm=factory(name$116,dependencies$116,D=>{var{typed:E,abs:F,add:J,pow:$e,conj:_t,sqrt:lr,multiply:mr,equalScalar:Or,larger:Pr,smaller:dn,matrix:gi,ctranspose:qi,eigs:zi}=D;return E(name$116,{number:Math.abs,Complex:function(na){return na.abs()},BigNumber:function(na){return na.abs()},boolean:function(na){return Math.abs(na)},Array:function(na){return ta(gi(na),2)},Matrix:function(na){return ta(na,2)},"Array, number | BigNumber | string":function(na,ra){return ta(gi(na),ra)},"Matrix, number | BigNumber | string":function(na,ra){return ta(na,ra)}});function Hi(na){var ra=0;return na.forEach(function(ia){var oa=F(ia);Pr(oa,ra)&&(ra=oa)},!0),ra}function Qi(na){var ra;return na.forEach(function(ia){var oa=F(ia);(!ra||dn(oa,ra))&&(ra=oa)},!0),ra||0}function Gi(na,ra){if(ra===1/0||ra==="inf")return Hi(na);if(ra===-1/0||ra==="-inf")return Qi(na);if(ra==="fro")return ta(na,2);if(typeof ra=="number"&&!isNaN(ra)){if(!Or(ra,0)){var ia=0;return na.forEach(function(oa){ia=J($e(F(oa),ra),ia)},!0),$e(ia,1/ra)}return 1/0}throw Error("Unsupported parameter value")}function Zi(na){var ra=0;return na.forEach(function(ia,oa){ra=J(ra,mr(ia,_t(ia)))}),F(lr(ra))}function Xi(na){var ra=[],ia=0;return na.forEach(function(oa,ua){var sa=ua[1],aa=J(ra[sa]||0,F(oa));Pr(aa,ia)&&(ia=aa),ra[sa]=aa},!0),ia}function Ki(na){var ra=na.size();if(ra[0]!==ra[1])throw RangeError("Invalid matrix dimensions");var ia=zi(mr(qi(na),na)).values.toArray(),oa=ia[ia.length-1];return F(lr(oa))}function ea(na){var ra=[],ia=0;return na.forEach(function(oa,ua){var sa=ua[0],aa=J(ra[sa]||0,F(oa));Pr(aa,ia)&&(ia=aa),ra[sa]=aa},!0),ia}function Ji(na,ra){if(ra===1)return Xi(na);if(ra===1/0||ra==="inf")return ea(na);if(ra==="fro")return Zi(na);if(ra===2)return Ki(na);throw Error("Unsupported parameter value "+ra)}function ta(na,ra){var ia=na.size();if(ia.length===1)return Gi(na,ra);if(ia.length===2){if(ia[0]&&ia[1])return Ji(na,ra);throw RangeError("Invalid matrix dimensions")}}}),name$115="dot",dependencies$115=["typed","addScalar","multiplyScalar","conj","size"],createDot=factory(name$115,dependencies$115,D=>{var{typed:E,addScalar:F,multiplyScalar:J,conj:$e,size:_t}=D;return E(name$115,{"Array | DenseMatrix, Array | DenseMatrix":mr,"SparseMatrix, SparseMatrix":Or});function lr(Pr,dn){var gi=_t(Pr),qi=_t(dn),zi,Hi;if(gi.length===1)zi=gi[0];else if(gi.length===2&&gi[1]===1)zi=gi[0];else throw RangeError("Expected a column vector, instead got a matrix of size ("+gi.join(", ")+")");if(qi.length===1)Hi=qi[0];else if(qi.length===2&&qi[1]===1)Hi=qi[0];else throw RangeError("Expected a column vector, instead got a matrix of size ("+qi.join(", ")+")");if(zi!==Hi)throw RangeError("Vectors must have equal length ("+zi+" != "+Hi+")");if(zi===0)throw RangeError("Cannot calculate the dot product of empty vectors");return zi}function mr(Pr,dn){var gi=lr(Pr,dn),qi=isMatrix(Pr)?Pr._data:Pr,zi=isMatrix(Pr)?Pr._datatype||Pr.getDataType():void 0,Hi=isMatrix(dn)?dn._data:dn,Qi=isMatrix(dn)?dn._datatype||dn.getDataType():void 0,Gi=_t(Pr).length===2,Zi=_t(dn).length===2,Xi=F,Ki=J;if(zi&&Qi&&zi===Qi&&typeof zi=="string"&&zi!=="mixed"){var ea=zi;Xi=E.find(F,[ea,ea]),Ki=E.find(J,[ea,ea])}if(!Gi&&!Zi){for(var Ji=Ki($e(qi[0]),Hi[0]),ta=1;ta<gi;ta++)Ji=Xi(Ji,Ki($e(qi[ta]),Hi[ta]));return Ji}if(!Gi&&Zi){for(var na=Ki($e(qi[0]),Hi[0][0]),ra=1;ra<gi;ra++)na=Xi(na,Ki($e(qi[ra]),Hi[ra][0]));return na}if(Gi&&!Zi){for(var ia=Ki($e(qi[0][0]),Hi[0]),oa=1;oa<gi;oa++)ia=Xi(ia,Ki($e(qi[oa][0]),Hi[oa]));return ia}if(Gi&&Zi){for(var ua=Ki($e(qi[0][0]),Hi[0][0]),sa=1;sa<gi;sa++)ua=Xi(ua,Ki($e(qi[sa][0]),Hi[sa][0]));return ua}}function Or(Pr,dn){lr(Pr,dn);for(var gi=Pr._index,qi=Pr._values,zi=dn._index,Hi=dn._values,Qi=0,Gi=F,Zi=J,Xi=0,Ki=0;Xi<gi.length&&Ki<zi.length;){var ea=gi[Xi],Ji=zi[Ki];if(ea<Ji){Xi++;continue}if(ea>Ji){Ki++;continue}ea===Ji&&(Qi=Gi(Qi,Zi(qi[Xi],Hi[Ki])),Xi++,Ki++)}return Qi}}),name$114="trace",dependencies$114=["typed","matrix","add"],createTrace=factory(name$114,dependencies$114,D=>{var{typed:E,matrix:F,add:J}=D;return E("trace",{Array:function(lr){return $e(F(lr))},SparseMatrix:_t,DenseMatrix:$e,any:clone$3});function $e(lr){var mr=lr._size,Or=lr._data;switch(mr.length){case 1:if(mr[0]===1)return clone$3(Or[0]);throw RangeError("Matrix must be square (size: "+format(mr)+")");case 2:var Pr=mr[0];if(Pr===mr[1]){for(var dn=0,gi=0;gi<Pr;gi++)dn=J(dn,Or[gi][gi]);return dn}else throw RangeError("Matrix must be square (size: "+format(mr)+")");default:throw RangeError("Matrix must be two dimensional (size: "+format(mr)+")")}}function _t(lr){var mr=lr._values,Or=lr._index,Pr=lr._ptr,dn=lr._size,gi=dn[0],qi=dn[1];if(gi===qi){var zi=0;if(mr.length>0)for(var Hi=0;Hi<qi;Hi++)for(var Qi=Pr[Hi],Gi=Pr[Hi+1],Zi=Qi;Zi<Gi;Zi++){var Xi=Or[Zi];if(Xi===Hi){zi=J(zi,mr[Zi]);break}if(Xi>Hi)break}return zi}throw RangeError("Matrix must be square (size: "+format(dn)+")")}}),name$113="index",dependencies$113=["typed","Index"],createIndex=factory(name$113,dependencies$113,D=>{var{typed:E,Index:F}=D;return E(name$113,{"...number | string | BigNumber | Range | Array | Matrix":function(J){var $e=J.map(function(lr){return isBigNumber(lr)?lr.toNumber():isArray(lr)||isMatrix(lr)?lr.map(function(mr){return isBigNumber(mr)?mr.toNumber():mr}):lr}),_t=new F;return F.apply(_t,$e),_t}})}),keywords=new Set(["end"]),name$112="Node",dependencies$112=["mathWithTransform"],createNode=factory(name$112,dependencies$112,D=>{var{mathWithTransform:E}=D;function F($e){for(var _t of[...keywords])if($e.has(_t))throw Error(\'Scope contains an illegal symbol, "\'+_t+\'" is a reserved keyword\')}class J{get type(){return"Node"}get isNode(){return!0}evaluate(_t){return this.compile().evaluate(_t)}compile(){var _t=this._compile(E,{}),lr={},mr=null;function Or(Pr){var dn=createMap$1(Pr);return F(dn),_t(dn,lr,mr)}return{evaluate:Or}}_compile(_t,lr){throw Error("Method _compile must be implemented by type "+this.type)}forEach(_t){throw Error("Cannot run forEach on a Node interface")}map(_t){throw Error("Cannot run map on a Node interface")}_ifNode(_t){if(!isNode(_t))throw TypeError("Callback function must return a Node");return _t}traverse(_t){_t(this,null,null);function lr(mr,Or){mr.forEach(function(Pr,dn,gi){Or(Pr,dn,gi),lr(Pr,Or)})}lr(this,_t)}transform(_t){function lr(mr,Or,Pr){var dn=_t(mr,Or,Pr);return dn===mr?mr.map(lr):dn}return lr(this,null,null)}filter(_t){var lr=[];return this.traverse(function(mr,Or,Pr){_t(mr,Or,Pr)&&lr.push(mr)}),lr}clone(){throw Error("Cannot clone a Node interface")}cloneDeep(){return this.map(function(_t){return _t.cloneDeep()})}equals(_t){return _t?this.type===_t.type&&deepStrictEqual(this,_t):!1}toString(_t){var lr=this._getCustomString(_t);return lr===void 0?this._toString(_t):lr}_toString(){throw Error("_toString not implemented for "+this.type)}toJSON(){throw Error("Cannot serialize object: toJSON not implemented by "+this.type)}toHTML(_t){var lr=this._getCustomString(_t);return lr===void 0?this._toHTML(_t):lr}_toHTML(){throw Error("_toHTML not implemented for "+this.type)}toTex(_t){var lr=this._getCustomString(_t);return lr===void 0?this._toTex(_t):lr}_toTex(_t){throw Error("_toTex not implemented for "+this.type)}_getCustomString(_t){if(_t&&typeof _t=="object")switch(typeof _t.handler){case"object":case"undefined":return;case"function":return _t.handler(this,_t);default:throw TypeError("Object or function expected as callback")}}getIdentifier(){return this.type}getContent(){return this}}return J},{isClass:!0,isNode:!0});function errorTransform(D){return D&&D.isIndexError?new IndexError(D.index+1,D.min+1,D.max===void 0?void 0:D.max+1):D}function accessFactory(D){var{subset:E}=D;return function(F,J){try{if(Array.isArray(F))return E(F,J);if(F&&typeof F.subset=="function")return F.subset(J);if(typeof F=="string")return E(F,J);if(typeof F=="object"){if(!J.isObjectProperty())throw TypeError("Cannot apply a numeric index as object property");return getSafeProperty(F,J.getObjectProperty())}else throw TypeError("Cannot apply index: unsupported type of object")}catch($e){throw errorTransform($e)}}}var name$111="AccessorNode",dependencies$111=["subset","Node"],createAccessorNode=factory(name$111,dependencies$111,D=>{var{subset:E,Node:F}=D,J=accessFactory({subset:E});function $e(lr){return!(isAccessorNode(lr)||isArrayNode(lr)||isConstantNode(lr)||isFunctionNode(lr)||isObjectNode(lr)||isParenthesisNode(lr)||isSymbolNode(lr))}class _t extends F{constructor(mr,Or){var Pr=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1;if(super(),!isNode(mr))throw TypeError(\'Node expected for parameter "object"\');if(!isIndexNode(Or))throw TypeError(\'IndexNode expected for parameter "index"\');this.object=mr,this.index=Or,this.optionalChaining=Pr}get name(){return this.index?this.index.isObjectProperty()?this.index.getObjectProperty():"":this.object.name||""}get type(){return name$111}get isAccessorNode(){return!0}_compile(mr,Or){var Pr=this.object._compile(mr,Or),dn=this.index._compile(mr,Or),gi=this.optionalChaining,qi=isAccessorNode(this.object)&&this.object.optionalChaining;if(this.index.isObjectProperty()){var zi=this.index.getObjectProperty();return function(Hi,Qi,Gi){var Zi=Gi||{},Xi=Pr(Hi,Qi,Zi);if(gi&&Xi==null){Zi.optionalShortCircuit=!0;return}if(!(qi&&Zi!=null&&Zi.optionalShortCircuit))return getSafeProperty(Xi,zi)}}else return function(Hi,Qi,Gi){var Zi=Gi||{},Xi=Pr(Hi,Qi,Zi);if(gi&&Xi==null){Zi.optionalShortCircuit=!0;return}if(!(qi&&Zi!=null&&Zi.optionalShortCircuit))return J(Xi,dn(Hi,Qi,Xi))}}forEach(mr){mr(this.object,"object",this),mr(this.index,"index",this)}map(mr){return new _t(this._ifNode(mr(this.object,"object",this)),this._ifNode(mr(this.index,"index",this)),this.optionalChaining)}clone(){return new _t(this.object,this.index,this.optionalChaining)}_toString(mr){var Or=this.object.toString(mr);$e(this.object)&&(Or="("+Or+")");var Pr=this.optionalChaining?this.index.dotNotation?"?":"?.":"";return Or+Pr+this.index.toString(mr)}_toHTML(mr){var Or=this.object.toHTML(mr);return $e(this.object)&&(Or=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+Or+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Or+this.index.toHTML(mr)}_toTex(mr){var Or=this.object.toTex(mr);return $e(this.object)&&(Or="\\\\left(\' + object + \'\\\\right)"),Or+this.index.toTex(mr)}toJSON(){return{mathjs:name$111,object:this.object,index:this.index,optionalChaining:this.optionalChaining}}static fromJSON(mr){return new _t(mr.object,mr.index,mr.optionalChaining)}}return _defineProperty(_t,"name",name$111),_t},{isClass:!0,isNode:!0}),name$110="ArrayNode",dependencies$110=["Node"],createArrayNode=factory(name$110,dependencies$110,D=>{var{Node:E}=D;class F extends E{constructor($e){if(super(),this.items=$e||[],!Array.isArray(this.items)||!this.items.every(isNode))throw TypeError("Array containing Nodes expected")}get type(){return name$110}get isArrayNode(){return!0}_compile($e,_t){var lr=map$1(this.items,function(Or){return Or._compile($e,_t)});if($e.config.matrix!=="Array"){var mr=$e.matrix;return function(Or,Pr,dn){return mr(map$1(lr,function(gi){return gi(Or,Pr,dn)}))}}else return function(Or,Pr,dn){return map$1(lr,function(gi){return gi(Or,Pr,dn)})}}forEach($e){for(var _t=0;_t<this.items.length;_t++){var lr=this.items[_t];$e(lr,"items["+_t+"]",this)}}map($e){for(var _t=[],lr=0;lr<this.items.length;lr++)_t[lr]=this._ifNode($e(this.items[lr],"items["+lr+"]",this));return new F(_t)}clone(){return new F(this.items.slice(0))}_toString($e){return"["+this.items.map(function(_t){return _t.toString($e)}).join(", ")+"]"}toJSON(){return{mathjs:name$110,items:this.items}}static fromJSON($e){return new F($e.items)}_toHTML($e){return\'<span class="math-parenthesis math-square-parenthesis">[</span>\'+this.items.map(function(_t){return _t.toHTML($e)}).join(\'<span class="math-separator">,</span>\')+\'<span class="math-parenthesis math-square-parenthesis">]</span>\'}_toTex($e){function _t(lr,mr){var Or=lr.some(isArrayNode)&&!lr.every(isArrayNode),Pr=mr||Or,dn=Pr?"&":"\\\\\\\\",gi=lr.map(function(qi){return qi.items?_t(qi.items,!mr):qi.toTex($e)}).join(dn);return Or||!Pr||Pr&&!mr?"\\\\begin{bmatrix}"+gi+"\\\\end{bmatrix}":gi}return _t(this.items,!1)}}return _defineProperty(F,"name",name$110),F},{isClass:!0,isNode:!0});function assignFactory(D){var{subset:E,matrix:F}=D;return function(J,$e,_t){try{if(Array.isArray(J))return F(J).subset($e,_t).valueOf().forEach((lr,mr)=>{J[mr]=lr}),J;if(J&&typeof J.subset=="function")return J.subset($e,_t);if(typeof J=="string")return E(J,$e,_t);if(typeof J=="object"){if(!$e.isObjectProperty())throw TypeError("Cannot apply a numeric index as object property");return setSafeProperty(J,$e.getObjectProperty(),_t),J}else throw TypeError("Cannot apply index: unsupported type of object")}catch(lr){throw errorTransform(lr)}}}var properties=[{AssignmentNode:{},FunctionAssignmentNode:{}},{ConditionalNode:{latexLeftParens:!1,latexRightParens:!1,latexParens:!1}},{"OperatorNode:or":{op:"or",associativity:"left",associativeWith:[]}},{"OperatorNode:xor":{op:"xor",associativity:"left",associativeWith:[]}},{"OperatorNode:and":{op:"and",associativity:"left",associativeWith:[]}},{"OperatorNode:bitOr":{op:"|",associativity:"left",associativeWith:[]}},{"OperatorNode:bitXor":{op:"^|",associativity:"left",associativeWith:[]}},{"OperatorNode:bitAnd":{op:"&",associativity:"left",associativeWith:[]}},{"OperatorNode:equal":{op:"==",associativity:"left",associativeWith:[]},"OperatorNode:unequal":{op:"!=",associativity:"left",associativeWith:[]},"OperatorNode:smaller":{op:"<",associativity:"left",associativeWith:[]},"OperatorNode:larger":{op:">",associativity:"left",associativeWith:[]},"OperatorNode:smallerEq":{op:"<=",associativity:"left",associativeWith:[]},"OperatorNode:largerEq":{op:">=",associativity:"left",associativeWith:[]},RelationalNode:{associativity:"left",associativeWith:[]}},{"OperatorNode:leftShift":{op:"<<",associativity:"left",associativeWith:[]},"OperatorNode:rightArithShift":{op:">>",associativity:"left",associativeWith:[]},"OperatorNode:rightLogShift":{op:">>>",associativity:"left",associativeWith:[]}},{"OperatorNode:to":{op:"to",associativity:"left",associativeWith:[]}},{RangeNode:{}},{"OperatorNode:add":{op:"+",associativity:"left",associativeWith:["OperatorNode:add","OperatorNode:subtract"]},"OperatorNode:subtract":{op:"-",associativity:"left",associativeWith:[]}},{"OperatorNode:multiply":{op:"*",associativity:"left",associativeWith:["OperatorNode:multiply","OperatorNode:divide","Operator:dotMultiply","Operator:dotDivide"]},"OperatorNode:divide":{op:"/",associativity:"left",associativeWith:[],latexLeftParens:!1,latexRightParens:!1,latexParens:!1},"OperatorNode:dotMultiply":{op:".*",associativity:"left",associativeWith:["OperatorNode:multiply","OperatorNode:divide","OperatorNode:dotMultiply","OperatorNode:doDivide"]},"OperatorNode:dotDivide":{op:"./",associativity:"left",associativeWith:[]},"OperatorNode:mod":{op:"mod",associativity:"left",associativeWith:[]}},{"OperatorNode:multiply":{associativity:"left",associativeWith:["OperatorNode:multiply","OperatorNode:divide","Operator:dotMultiply","Operator:dotDivide"]}},{"OperatorNode:unaryPlus":{op:"+",associativity:"right"},"OperatorNode:unaryMinus":{op:"-",associativity:"right"},"OperatorNode:bitNot":{op:"~",associativity:"right"},"OperatorNode:not":{op:"not",associativity:"right"}},{"OperatorNode:pow":{op:"^",associativity:"right",associativeWith:[],latexRightParens:!1},"OperatorNode:dotPow":{op:".^",associativity:"right",associativeWith:[]}},{"OperatorNode:nullish":{op:"??",associativity:"left",associativeWith:[]}},{"OperatorNode:factorial":{op:"!",associativity:"left"}},{"OperatorNode:ctranspose":{op:"\'",associativity:"left"}}];function unwrapParen(D,E){if(!E||E!=="auto")return D;for(var F=D;isParenthesisNode(F);)F=F.content;return F}function getPrecedence(D,E,F,J){var $e=D;E!=="keep"&&($e=D.getContent());for(var _t=$e.getIdentifier(),lr=null,mr=0;mr<properties.length;mr++)if(_t in properties[mr]){lr=mr;break}if(_t==="OperatorNode:multiply"&&$e.implicit&&F!=="show"){var Or=unwrapParen($e.args[0],E);!(isConstantNode(Or)&&J&&J.getIdentifier()==="OperatorNode:divide"&&rule2Node(unwrapParen(J.args[0],E)))&&!(Or.getIdentifier()==="OperatorNode:divide"&&rule2Node(unwrapParen(Or.args[0],E))&&isConstantNode(unwrapParen(Or.args[1])))&&(lr+=1)}return lr}function getAssociativity(D,E){var F=D;E!=="keep"&&(F=D.getContent());var J=F.getIdentifier(),$e=getPrecedence(F,E);if($e===null)return null;var _t=properties[$e][J];if(hasOwnProperty$1(_t,"associativity")){if(_t.associativity==="left")return"left";if(_t.associativity==="right")return"right";throw Error("\'"+J+"\' has the invalid associativity \'"+_t.associativity+"\'.")}return null}function isAssociativeWith(D,E,F){var J=F==="keep"?D:D.getContent(),$e=F==="keep"?E:D.getContent(),_t=J.getIdentifier(),lr=$e.getIdentifier(),mr=getPrecedence(J,F);if(mr===null)return null;var Or=properties[mr][_t];if(hasOwnProperty$1(Or,"associativeWith")&&Or.associativeWith instanceof Array){for(var Pr=0;Pr<Or.associativeWith.length;Pr++)if(Or.associativeWith[Pr]===lr)return!0;return!1}return null}function getOperator(D){var E="OperatorNode:"+D;for(var F of properties)if(E in F)return F[E].op;return null}var name$109="AssignmentNode",dependencies$109=["subset","?matrix","Node"],createAssignmentNode=factory(name$109,dependencies$109,D=>{var{subset:E,matrix:F,Node:J}=D,$e=accessFactory({subset:E}),_t=assignFactory({subset:E,matrix:F});function lr(Or,Pr,dn){Pr||="keep";var gi=getPrecedence(Or,Pr,dn),qi=getPrecedence(Or.value,Pr,dn);return Pr==="all"||qi!==null&&qi<=gi}class mr extends J{constructor(Pr,dn,gi){if(super(),this.object=Pr,this.index=gi?dn:null,this.value=gi||dn,!isSymbolNode(Pr)&&!isAccessorNode(Pr))throw TypeError(\'SymbolNode or AccessorNode expected as "object"\');if(isSymbolNode(Pr)&&Pr.name==="end")throw Error(\'Cannot assign to symbol "end"\');if(this.index&&!isIndexNode(this.index))throw TypeError(\'IndexNode expected as "index"\');if(!isNode(this.value))throw TypeError(\'Node expected as "value"\')}get name(){return this.index?this.index.isObjectProperty()?this.index.getObjectProperty():"":this.object.name||""}get type(){return name$109}get isAssignmentNode(){return!0}_compile(Pr,dn){var gi=this.object._compile(Pr,dn),qi=this.index?this.index._compile(Pr,dn):null,zi=this.value._compile(Pr,dn),Hi=this.object.name;if(this.index)if(this.index.isObjectProperty()){var Qi=this.index.getObjectProperty();return function(Ki,ea,Ji){var ta=gi(Ki,ea,Ji),na=zi(Ki,ea,Ji);return setSafeProperty(ta,Qi,na),na}}else{if(isSymbolNode(this.object))return function(Ki,ea,Ji){var ta=gi(Ki,ea,Ji),na=zi(Ki,ea,Ji),ra=qi(Ki,ea,ta);return Ki.set(Hi,_t(ta,ra,na)),na};var Gi=this.object.object._compile(Pr,dn);if(this.object.index.isObjectProperty()){var Zi=this.object.index.getObjectProperty();return function(Ki,ea,Ji){var ta=Gi(Ki,ea,Ji),na=getSafeProperty(ta,Zi),ra=qi(Ki,ea,na),ia=zi(Ki,ea,Ji);return setSafeProperty(ta,Zi,_t(na,ra,ia)),ia}}else{var Xi=this.object.index._compile(Pr,dn);return function(Ki,ea,Ji){var ta=Gi(Ki,ea,Ji),na=Xi(Ki,ea,ta),ra=$e(ta,na),ia=qi(Ki,ea,ra),oa=zi(Ki,ea,Ji);return _t(ta,na,_t(ra,ia,oa)),oa}}}else{if(!isSymbolNode(this.object))throw TypeError("SymbolNode expected as object");return function(Ki,ea,Ji){var ta=zi(Ki,ea,Ji);return Ki.set(Hi,ta),ta}}}forEach(Pr){Pr(this.object,"object",this),this.index&&Pr(this.index,"index",this),Pr(this.value,"value",this)}map(Pr){return new mr(this._ifNode(Pr(this.object,"object",this)),this.index?this._ifNode(Pr(this.index,"index",this)):null,this._ifNode(Pr(this.value,"value",this)))}clone(){return new mr(this.object,this.index,this.value)}_toString(Pr){var dn=this.object.toString(Pr),gi=this.index?this.index.toString(Pr):"",qi=this.value.toString(Pr);return lr(this,Pr&&Pr.parenthesis,Pr&&Pr.implicit)&&(qi="("+qi+")"),dn+gi+" = "+qi}toJSON(){return{mathjs:name$109,object:this.object,index:this.index,value:this.value}}static fromJSON(Pr){return new mr(Pr.object,Pr.index,Pr.value)}_toHTML(Pr){var dn=this.object.toHTML(Pr),gi=this.index?this.index.toHTML(Pr):"",qi=this.value.toHTML(Pr);return lr(this,Pr&&Pr.parenthesis,Pr&&Pr.implicit)&&(qi=\'<span class="math-paranthesis math-round-parenthesis">(</span>\'+qi+\'<span class="math-paranthesis math-round-parenthesis">)</span>\'),dn+gi+\'<span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>\'+qi}_toTex(Pr){var dn=this.object.toTex(Pr),gi=this.index?this.index.toTex(Pr):"",qi=this.value.toTex(Pr);return lr(this,Pr&&Pr.parenthesis,Pr&&Pr.implicit)&&(qi=`\\\\left(${qi}\\\\right)`),dn+gi+"="+qi}}return _defineProperty(mr,"name",name$109),mr},{isClass:!0,isNode:!0}),name$108="BlockNode",dependencies$108=["ResultSet","Node"],createBlockNode=factory(name$108,dependencies$108,D=>{var{ResultSet:E,Node:F}=D;class J extends F{constructor(_t){if(super(),!Array.isArray(_t))throw Error("Array expected");this.blocks=_t.map(function(lr){var mr=lr&&lr.node,Or=lr&&lr.visible!==void 0?lr.visible:!0;if(!isNode(mr))throw TypeError(\'Property "node" must be a Node\');if(typeof Or!="boolean")throw TypeError(\'Property "visible" must be a boolean\');return{node:mr,visible:Or}})}get type(){return name$108}get isBlockNode(){return!0}_compile(_t,lr){var mr=map$1(this.blocks,function(Or){return{evaluate:Or.node._compile(_t,lr),visible:Or.visible}});return function(Or,Pr,dn){var gi=[];return forEach(mr,function(qi){var zi=qi.evaluate(Or,Pr,dn);qi.visible&&gi.push(zi)}),new E(gi)}}forEach(_t){for(var lr=0;lr<this.blocks.length;lr++)_t(this.blocks[lr].node,"blocks["+lr+"].node",this)}map(_t){for(var lr=[],mr=0;mr<this.blocks.length;mr++){var Or=this.blocks[mr];lr[mr]={node:this._ifNode(_t(Or.node,"blocks["+mr+"].node",this)),visible:Or.visible}}return new J(lr)}clone(){return new J(this.blocks.map(function(_t){return{node:_t.node,visible:_t.visible}}))}_toString(_t){return this.blocks.map(function(lr){return lr.node.toString(_t)+(lr.visible?"":";")}).join(`\n`)}toJSON(){return{mathjs:name$108,blocks:this.blocks}}static fromJSON(_t){return new J(_t.blocks)}_toHTML(_t){return this.blocks.map(function(lr){return lr.node.toHTML(_t)+(lr.visible?"":\'<span class="math-separator">;</span>\')}).join(\'<span class="math-separator"><br /></span>\')}_toTex(_t){return this.blocks.map(function(lr){return lr.node.toTex(_t)+(lr.visible?"":";")}).join(`\\\\;\\\\;\n`)}}return _defineProperty(J,"name",name$108),J},{isClass:!0,isNode:!0}),name$107="ConditionalNode",dependencies$107=["Node"],createConditionalNode=factory(name$107,dependencies$107,D=>{var{Node:E}=D;function F($e){if(typeof $e=="number"||typeof $e=="boolean"||typeof $e=="string")return!!$e;if($e){if(isBigNumber($e))return!$e.isZero();if(isComplex($e))return!!($e.re||$e.im);if(isUnit($e))return!!$e.value}if($e==null)return!1;throw TypeError(\'Unsupported type of condition "\'+typeOf($e)+\'"\')}class J extends E{constructor(_t,lr,mr){if(super(),!isNode(_t))throw TypeError("Parameter condition must be a Node");if(!isNode(lr))throw TypeError("Parameter trueExpr must be a Node");if(!isNode(mr))throw TypeError("Parameter falseExpr must be a Node");this.condition=_t,this.trueExpr=lr,this.falseExpr=mr}get type(){return name$107}get isConditionalNode(){return!0}_compile(_t,lr){var mr=this.condition._compile(_t,lr),Or=this.trueExpr._compile(_t,lr),Pr=this.falseExpr._compile(_t,lr);return function(dn,gi,qi){return F(mr(dn,gi,qi))?Or(dn,gi,qi):Pr(dn,gi,qi)}}forEach(_t){_t(this.condition,"condition",this),_t(this.trueExpr,"trueExpr",this),_t(this.falseExpr,"falseExpr",this)}map(_t){return new J(this._ifNode(_t(this.condition,"condition",this)),this._ifNode(_t(this.trueExpr,"trueExpr",this)),this._ifNode(_t(this.falseExpr,"falseExpr",this)))}clone(){return new J(this.condition,this.trueExpr,this.falseExpr)}_toString(_t){var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=getPrecedence(this,lr,_t&&_t.implicit),Or=this.condition.toString(_t),Pr=getPrecedence(this.condition,lr,_t&&_t.implicit);(lr==="all"||this.condition.type==="OperatorNode"||Pr!==null&&Pr<=mr)&&(Or="("+Or+")");var dn=this.trueExpr.toString(_t),gi=getPrecedence(this.trueExpr,lr,_t&&_t.implicit);(lr==="all"||this.trueExpr.type==="OperatorNode"||gi!==null&&gi<=mr)&&(dn="("+dn+")");var qi=this.falseExpr.toString(_t),zi=getPrecedence(this.falseExpr,lr,_t&&_t.implicit);return(lr==="all"||this.falseExpr.type==="OperatorNode"||zi!==null&&zi<=mr)&&(qi="("+qi+")"),Or+" ? "+dn+" : "+qi}toJSON(){return{mathjs:name$107,condition:this.condition,trueExpr:this.trueExpr,falseExpr:this.falseExpr}}static fromJSON(_t){return new J(_t.condition,_t.trueExpr,_t.falseExpr)}_toHTML(_t){var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=getPrecedence(this,lr,_t&&_t.implicit),Or=this.condition.toHTML(_t),Pr=getPrecedence(this.condition,lr,_t&&_t.implicit);(lr==="all"||this.condition.type==="OperatorNode"||Pr!==null&&Pr<=mr)&&(Or=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+Or+\'<span class="math-parenthesis math-round-parenthesis">)</span>\');var dn=this.trueExpr.toHTML(_t),gi=getPrecedence(this.trueExpr,lr,_t&&_t.implicit);(lr==="all"||this.trueExpr.type==="OperatorNode"||gi!==null&&gi<=mr)&&(dn=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+dn+\'<span class="math-parenthesis math-round-parenthesis">)</span>\');var qi=this.falseExpr.toHTML(_t),zi=getPrecedence(this.falseExpr,lr,_t&&_t.implicit);return(lr==="all"||this.falseExpr.type==="OperatorNode"||zi!==null&&zi<=mr)&&(qi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+qi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Or+\'<span class="math-operator math-conditional-operator">?</span>\'+dn+\'<span class="math-operator math-conditional-operator">:</span>\'+qi}_toTex(_t){return"\\\\begin{cases} {"+this.trueExpr.toTex(_t)+"}, &\\\\quad{\\\\text{if }\\\\;"+this.condition.toTex(_t)+"}\\\\\\\\{"+this.falseExpr.toTex(_t)+"}, &\\\\quad{\\\\text{otherwise}}\\\\end{cases}"}}return _defineProperty(J,"name",name$107),J},{isClass:!0,isNode:!0}),require_dist=__commonJSMin(((D,E)=>{var F=Object.assign||function(lr){for(var mr=1;mr<arguments.length;mr++){var Or=arguments[mr];for(var Pr in Or)Object.prototype.hasOwnProperty.call(Or,Pr)&&(lr[Pr]=Or[Pr])}return lr},J={"{":"\\\\{","}":"\\\\}","\\\\":"\\\\textbackslash{}","#":"\\\\#",$:"\\\\$","%":"\\\\%","&":"\\\\&","^":"\\\\textasciicircum{}",_:"\\\\_","~":"\\\\textasciitilde{}"},$e={"–":"\\\\--","—":"\\\\---"," ":"~","	":"\\\\qquad{}","\\r\\n":"\\\\newline{}","\\n":"\\\\newline{}"},_t=function(lr,mr){return F({},lr,mr)};E.exports=function(lr){for(var mr=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},Or=mr.preserveFormatting,Pr=Or===void 0?!1:Or,dn=mr.escapeMapFn,gi=dn===void 0?_t:dn,qi=String(lr),zi="",Hi=gi(F({},J),Pr?F({},$e):{}),Qi=Object.keys(Hi),Gi=function(){var Zi=!1;Qi.forEach(function(Xi,Ki){Zi||qi.length>=Xi.length&&qi.slice(0,Xi.length)===Xi&&(zi+=Hi[Qi[Ki]],qi=qi.slice(Xi.length,qi.length),Zi=!0)}),Zi||(zi+=qi.slice(0,1),qi=qi.slice(1,qi.length))};qi;)Gi();return zi}})),import_dist=__toESM(require_dist()),latexSymbols={Alpha:"A",alpha:"\\\\alpha",Beta:"B",beta:"\\\\beta",Gamma:"\\\\Gamma",gamma:"\\\\gamma",Delta:"\\\\Delta",delta:"\\\\delta",Epsilon:"E",epsilon:"\\\\epsilon",varepsilon:"\\\\varepsilon",Zeta:"Z",zeta:"\\\\zeta",Eta:"H",eta:"\\\\eta",Theta:"\\\\Theta",theta:"\\\\theta",vartheta:"\\\\vartheta",Iota:"I",iota:"\\\\iota",Kappa:"K",kappa:"\\\\kappa",varkappa:"\\\\varkappa",Lambda:"\\\\Lambda",lambda:"\\\\lambda",Mu:"M",mu:"\\\\mu",Nu:"N",nu:"\\\\nu",Xi:"\\\\Xi",xi:"\\\\xi",Omicron:"O",omicron:"o",Pi:"\\\\Pi",pi:"\\\\pi",varpi:"\\\\varpi",Rho:"P",rho:"\\\\rho",varrho:"\\\\varrho",Sigma:"\\\\Sigma",sigma:"\\\\sigma",varsigma:"\\\\varsigma",Tau:"T",tau:"\\\\tau",Upsilon:"\\\\Upsilon",upsilon:"\\\\upsilon",Phi:"\\\\Phi",phi:"\\\\phi",varphi:"\\\\varphi",Chi:"X",chi:"\\\\chi",Psi:"\\\\Psi",psi:"\\\\psi",Omega:"\\\\Omega",omega:"\\\\omega",true:"\\\\mathrm{True}",false:"\\\\mathrm{False}",i:"i",inf:"\\\\infty",Inf:"\\\\infty",infinity:"\\\\infty",Infinity:"\\\\infty",oo:"\\\\infty",lim:"\\\\lim",undefined:"\\\\mathbf{?}"},latexOperators={transpose:"^\\\\top",ctranspose:"^H",factorial:"!",pow:"^",dotPow:".^\\\\wedge",unaryPlus:"+",unaryMinus:"-",bitNot:"\\\\~",not:"\\\\neg",multiply:"\\\\cdot",divide:"\\\\frac",dotMultiply:".\\\\cdot",dotDivide:".:",mod:"\\\\mod",add:"+",subtract:"-",to:"\\\\rightarrow",leftShift:"<<",rightArithShift:">>",rightLogShift:">>>",equal:"=",unequal:"\\\\neq",smaller:"<",larger:">",smallerEq:"\\\\leq",largerEq:"\\\\geq",bitAnd:"\\\\&",bitXor:"\\\\underline{|}",bitOr:"|",and:"\\\\wedge",xor:"\\\\veebar",or:"\\\\vee"},latexFunctions={abs:{1:"\\\\left|${args[0]}\\\\right|"},add:{2:`\\\\left(\\${args[0]}${latexOperators.add}\\${args[1]}\\\\right)`},cbrt:{1:"\\\\sqrt[3]{${args[0]}}"},ceil:{1:"\\\\left\\\\lceil${args[0]}\\\\right\\\\rceil"},cube:{1:"\\\\left(${args[0]}\\\\right)^3"},divide:{2:"\\\\frac{${args[0]}}{${args[1]}}"},dotDivide:{2:`\\\\left(\\${args[0]}${latexOperators.dotDivide}\\${args[1]}\\\\right)`},dotMultiply:{2:`\\\\left(\\${args[0]}${latexOperators.dotMultiply}\\${args[1]}\\\\right)`},dotPow:{2:`\\\\left(\\${args[0]}${latexOperators.dotPow}\\${args[1]}\\\\right)`},exp:{1:"\\\\exp\\\\left(${args[0]}\\\\right)"},expm1:`\\\\left(e${latexOperators.pow}{\\${args[0]}}-1\\\\right)`,fix:{1:"\\\\mathrm{${name}}\\\\left(${args[0]}\\\\right)"},floor:{1:"\\\\left\\\\lfloor${args[0]}\\\\right\\\\rfloor"},fraction:{2:"\\\\frac{${args[0]}}{${args[1]}}"},gcd:"\\\\gcd\\\\left(${args}\\\\right)",hypot:"\\\\hypot\\\\left(${args}\\\\right)",log:{1:"\\\\ln\\\\left(${args[0]}\\\\right)",2:"\\\\log_{${args[1]}}\\\\left(${args[0]}\\\\right)"},log10:{1:"\\\\log_{10}\\\\left(${args[0]}\\\\right)"},log1p:{1:"\\\\ln\\\\left(${args[0]}+1\\\\right)",2:"\\\\log_{${args[1]}}\\\\left(${args[0]}+1\\\\right)"},log2:"\\\\log_{2}\\\\left(${args[0]}\\\\right)",mod:{2:`\\\\left(\\${args[0]}${latexOperators.mod}\\${args[1]}\\\\right)`},multiply:{2:`\\\\left(\\${args[0]}${latexOperators.multiply}\\${args[1]}\\\\right)`},norm:{1:"\\\\left\\\\|${args[0]}\\\\right\\\\|",2:void 0},nthRoot:{2:"\\\\sqrt[${args[1]}]{${args[0]}}"},nthRoots:{2:"\\\\{y : y^${args[1]} = {${args[0]}}\\\\}"},pow:{2:`\\\\left(\\${args[0]}\\\\right)${latexOperators.pow}{\\${args[1]}}`},round:{1:"\\\\left\\\\lfloor${args[0]}\\\\right\\\\rceil",2:void 0},sign:{1:"\\\\mathrm{${name}}\\\\left(${args[0]}\\\\right)"},sqrt:{1:"\\\\sqrt{${args[0]}}"},square:{1:"\\\\left(${args[0]}\\\\right)^2"},subtract:{2:`\\\\left(\\${args[0]}${latexOperators.subtract}\\${args[1]}\\\\right)`},unaryMinus:{1:`${latexOperators.unaryMinus}\\\\left(\\${args[0]}\\\\right)`},unaryPlus:{1:`${latexOperators.unaryPlus}\\\\left(\\${args[0]}\\\\right)`},bitAnd:{2:`\\\\left(\\${args[0]}${latexOperators.bitAnd}\\${args[1]}\\\\right)`},bitNot:{1:latexOperators.bitNot+"\\\\left(${args[0]}\\\\right)"},bitOr:{2:`\\\\left(\\${args[0]}${latexOperators.bitOr}\\${args[1]}\\\\right)`},bitXor:{2:`\\\\left(\\${args[0]}${latexOperators.bitXor}\\${args[1]}\\\\right)`},leftShift:{2:`\\\\left(\\${args[0]}${latexOperators.leftShift}\\${args[1]}\\\\right)`},rightArithShift:{2:`\\\\left(\\${args[0]}${latexOperators.rightArithShift}\\${args[1]}\\\\right)`},rightLogShift:{2:`\\\\left(\\${args[0]}${latexOperators.rightLogShift}\\${args[1]}\\\\right)`},bellNumbers:{1:"\\\\mathrm{B}_{${args[0]}}"},catalan:{1:"\\\\mathrm{C}_{${args[0]}}"},stirlingS2:{2:"\\\\mathrm{S}\\\\left(${args}\\\\right)"},arg:{1:"\\\\arg\\\\left(${args[0]}\\\\right)"},conj:{1:"\\\\left(${args[0]}\\\\right)^*"},im:{1:"\\\\Im\\\\left\\\\lbrace${args[0]}\\\\right\\\\rbrace"},re:{1:"\\\\Re\\\\left\\\\lbrace${args[0]}\\\\right\\\\rbrace"},and:{2:`\\\\left(\\${args[0]}${latexOperators.and}\\${args[1]}\\\\right)`},not:{1:latexOperators.not+"\\\\left(${args[0]}\\\\right)"},or:{2:`\\\\left(\\${args[0]}${latexOperators.or}\\${args[1]}\\\\right)`},xor:{2:`\\\\left(\\${args[0]}${latexOperators.xor}\\${args[1]}\\\\right)`},cross:{2:"\\\\left(${args[0]}\\\\right)\\\\times\\\\left(${args[1]}\\\\right)"},ctranspose:{1:`\\\\left(\\${args[0]}\\\\right)${latexOperators.ctranspose}`},det:{1:"\\\\det\\\\left(${args[0]}\\\\right)"},dot:{2:"\\\\left(${args[0]}\\\\cdot${args[1]}\\\\right)"},expm:{1:"\\\\exp\\\\left(${args[0]}\\\\right)"},inv:{1:"\\\\left(${args[0]}\\\\right)^{-1}"},pinv:{1:"\\\\left(${args[0]}\\\\right)^{+}"},sqrtm:{1:`{\\${args[0]}}${latexOperators.pow}{\\\\frac{1}{2}}`},trace:{1:"\\\\mathrm{tr}\\\\left(${args[0]}\\\\right)"},transpose:{1:`\\\\left(\\${args[0]}\\\\right)${latexOperators.transpose}`},combinations:{2:"\\\\binom{${args[0]}}{${args[1]}}"},combinationsWithRep:{2:"\\\\left(\\\\!\\\\!{\\\\binom{${args[0]}}{${args[1]}}}\\\\!\\\\!\\\\right)"},factorial:{1:`\\\\left(\\${args[0]}\\\\right)${latexOperators.factorial}`},gamma:{1:"\\\\Gamma\\\\left(${args[0]}\\\\right)"},lgamma:{1:"\\\\ln\\\\Gamma\\\\left(${args[0]}\\\\right)"},equal:{2:`\\\\left(\\${args[0]}${latexOperators.equal}\\${args[1]}\\\\right)`},larger:{2:`\\\\left(\\${args[0]}${latexOperators.larger}\\${args[1]}\\\\right)`},largerEq:{2:`\\\\left(\\${args[0]}${latexOperators.largerEq}\\${args[1]}\\\\right)`},smaller:{2:`\\\\left(\\${args[0]}${latexOperators.smaller}\\${args[1]}\\\\right)`},smallerEq:{2:`\\\\left(\\${args[0]}${latexOperators.smallerEq}\\${args[1]}\\\\right)`},unequal:{2:`\\\\left(\\${args[0]}${latexOperators.unequal}\\${args[1]}\\\\right)`},erf:{1:"erf\\\\left(${args[0]}\\\\right)"},max:"\\\\max\\\\left(${args}\\\\right)",min:"\\\\min\\\\left(${args}\\\\right)",variance:"\\\\mathrm{Var}\\\\left(${args}\\\\right)",acos:{1:"\\\\cos^{-1}\\\\left(${args[0]}\\\\right)"},acosh:{1:"\\\\cosh^{-1}\\\\left(${args[0]}\\\\right)"},acot:{1:"\\\\cot^{-1}\\\\left(${args[0]}\\\\right)"},acoth:{1:"\\\\coth^{-1}\\\\left(${args[0]}\\\\right)"},acsc:{1:"\\\\csc^{-1}\\\\left(${args[0]}\\\\right)"},acsch:{1:"\\\\mathrm{csch}^{-1}\\\\left(${args[0]}\\\\right)"},asec:{1:"\\\\sec^{-1}\\\\left(${args[0]}\\\\right)"},asech:{1:"\\\\mathrm{sech}^{-1}\\\\left(${args[0]}\\\\right)"},asin:{1:"\\\\sin^{-1}\\\\left(${args[0]}\\\\right)"},asinh:{1:"\\\\sinh^{-1}\\\\left(${args[0]}\\\\right)"},atan:{1:"\\\\tan^{-1}\\\\left(${args[0]}\\\\right)"},atan2:{2:"\\\\mathrm{atan2}\\\\left(${args}\\\\right)"},atanh:{1:"\\\\tanh^{-1}\\\\left(${args[0]}\\\\right)"},cos:{1:"\\\\cos\\\\left(${args[0]}\\\\right)"},cosh:{1:"\\\\cosh\\\\left(${args[0]}\\\\right)"},cot:{1:"\\\\cot\\\\left(${args[0]}\\\\right)"},coth:{1:"\\\\coth\\\\left(${args[0]}\\\\right)"},csc:{1:"\\\\csc\\\\left(${args[0]}\\\\right)"},csch:{1:"\\\\mathrm{csch}\\\\left(${args[0]}\\\\right)"},sec:{1:"\\\\sec\\\\left(${args[0]}\\\\right)"},sech:{1:"\\\\mathrm{sech}\\\\left(${args[0]}\\\\right)"},sin:{1:"\\\\sin\\\\left(${args[0]}\\\\right)"},sinh:{1:"\\\\sinh\\\\left(${args[0]}\\\\right)"},tan:{1:"\\\\tan\\\\left(${args[0]}\\\\right)"},tanh:{1:"\\\\tanh\\\\left(${args[0]}\\\\right)"},to:{2:`\\\\left(\\${args[0]}${latexOperators.to}\\${args[1]}\\\\right)`},numeric:function(D,E){return D.args[0].toTex()},number:{0:"0",1:"\\\\left(${args[0]}\\\\right)",2:"\\\\left(\\\\left(${args[0]}\\\\right)${args[1]}\\\\right)"},string:{0:\'\\\\mathtt{""}\',1:"\\\\mathrm{string}\\\\left(${args[0]}\\\\right)"},bignumber:{0:"0",1:"\\\\left(${args[0]}\\\\right)"},bigint:{0:"0",1:"\\\\left(${args[0]}\\\\right)"},complex:{0:"0",1:"\\\\left(${args[0]}\\\\right)",2:`\\\\left(\\\\left(\\${args[0]}\\\\right)+${latexSymbols.i}\\\\cdot\\\\left(\\${args[1]}\\\\right)\\\\right)`},matrix:{0:"\\\\begin{bmatrix}\\\\end{bmatrix}",1:"\\\\left(${args[0]}\\\\right)",2:"\\\\left(${args[0]}\\\\right)"},sparse:{0:"\\\\begin{bsparse}\\\\end{bsparse}",1:"\\\\left(${args[0]}\\\\right)"},unit:{1:"\\\\left(${args[0]}\\\\right)",2:"\\\\left(\\\\left(${args[0]}\\\\right)${args[1]}\\\\right)"}},defaultTemplate="\\\\mathrm{${name}}\\\\left(${args}\\\\right)",latexUnits={deg:"^\\\\circ"};function escapeLatex(D){return(0,import_dist.default)(D,{preserveFormatting:!0})}function toSymbol(D,E){return E=E===void 0?!1:E,E?hasOwnProperty$1(latexUnits,D)?latexUnits[D]:"\\\\mathrm{"+escapeLatex(D)+"}":hasOwnProperty$1(latexSymbols,D)?latexSymbols[D]:escapeLatex(D)}var name$106="ConstantNode",dependencies$106=["Node","isBounded"],createConstantNode=factory(name$106,dependencies$106,D=>{var{Node:E,isBounded:F}=D;class J extends E{constructor(_t){super(),this.value=_t}get type(){return name$106}get isConstantNode(){return!0}_compile(_t,lr){var mr=this.value;return function(){return mr}}forEach(_t){}map(_t){return this.clone()}clone(){return new J(this.value)}_toString(_t){return format(this.value,_t)}_toHTML(_t){var lr=this._toString(_t);switch(typeOf(this.value)){case"number":case"bigint":case"BigNumber":case"Fraction":return\'<span class="math-number">\'+lr+"</span>";case"string":return\'<span class="math-string">\'+lr+"</span>";case"boolean":return\'<span class="math-boolean">\'+lr+"</span>";case"null":return\'<span class="math-null-symbol">\'+lr+"</span>";case"undefined":return\'<span class="math-undefined">\'+lr+"</span>";default:return\'<span class="math-symbol">\'+lr+"</span>"}}toJSON(){return{mathjs:name$106,value:this.value}}static fromJSON(_t){return new J(_t.value)}_toTex(_t){var lr=this._toString(_t);switch(typeOf(this.value)){case"string":return"\\\\mathtt{"+escapeLatex(lr)+"}";case"number":case"BigNumber":if(!F(this.value))return this.value.valueOf()<0?"-\\\\infty":"\\\\infty";var mr=lr.toLowerCase().indexOf("e");return mr===-1?lr:lr.substring(0,mr)+"\\\\cdot10^{"+lr.substring(mr+1)+"}";case"bigint":return lr.toString();case"Fraction":return this.value.toLatex();default:return lr}}}return _defineProperty(J,"name",name$106),J},{isClass:!0,isNode:!0}),name$105="FunctionAssignmentNode",dependencies$105=["typed","Node"],createFunctionAssignmentNode=factory(name$105,dependencies$105,D=>{var{typed:E,Node:F}=D;function J(_t,lr,mr){var Or=getPrecedence(_t,lr,mr),Pr=getPrecedence(_t.expr,lr,mr);return lr==="all"||Pr!==null&&Pr<=Or}class $e extends F{constructor(lr,mr,Or){if(super(),typeof lr!="string")throw TypeError(\'String expected for parameter "name"\');if(!Array.isArray(mr))throw TypeError(\'Array containing strings or objects expected for parameter "params"\');if(!isNode(Or))throw TypeError(\'Node expected for parameter "expr"\');if(keywords.has(lr))throw Error(\'Illegal function name, "\'+lr+\'" is a reserved keyword\');var Pr=new Set;for(var dn of mr){var gi=typeof dn=="string"?dn:dn.name;if(Pr.has(gi))throw Error(`Duplicate parameter name "${gi}"`);Pr.add(gi)}this.name=lr,this.params=mr.map(function(qi){return qi&&qi.name||qi}),this.types=mr.map(function(qi){return qi&&qi.type||"any"}),this.expr=Or}get type(){return name$105}get isFunctionAssignmentNode(){return!0}_compile(lr,mr){var Or=Object.create(mr);forEach(this.params,function(Qi){Or[Qi]=!0});var Pr=this.expr,dn=Pr._compile(lr,Or),gi=this.name,qi=this.params,zi=join(this.types,","),Hi=gi+"("+join(this.params,", ")+")";return function(Qi,Gi,Zi){var Xi={};Xi[zi]=function(){for(var ea=Object.create(Gi),Ji=0;Ji<qi.length;Ji++)ea[qi[Ji]]=arguments[Ji];return dn(Qi,ea,Zi)};var Ki=E(gi,Xi);return Ki.syntax=Hi,Ki.expr=Pr.toString(),Qi.set(gi,Ki),Ki}}forEach(lr){lr(this.expr,"expr",this)}map(lr){var mr=this._ifNode(lr(this.expr,"expr",this));return new $e(this.name,this.params.slice(0),mr)}clone(){return new $e(this.name,this.params.slice(0),this.expr)}_toString(lr){var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=this.expr.toString(lr);return J(this,mr,lr&&lr.implicit)&&(Or="("+Or+")"),this.name+"("+this.params.join(", ")+") = "+Or}toJSON(){var lr=this.types;return{mathjs:name$105,name:this.name,params:this.params.map(function(mr,Or){return{name:mr,type:lr[Or]}}),expr:this.expr}}static fromJSON(lr){return new $e(lr.name,lr.params,lr.expr)}_toHTML(lr){for(var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=[],Pr=0;Pr<this.params.length;Pr++)Or.push(\'<span class="math-symbol math-parameter">\'+escape(this.params[Pr])+"</span>");var dn=this.expr.toHTML(lr);return J(this,mr,lr&&lr.implicit)&&(dn=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+dn+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),\'<span class="math-function">\'+escape(this.name)+\'</span><span class="math-parenthesis math-round-parenthesis">(</span>\'+Or.join(\'<span class="math-separator">,</span>\')+\'<span class="math-parenthesis math-round-parenthesis">)</span><span class="math-operator math-assignment-operator math-variable-assignment-operator math-binary-operator">=</span>\'+dn}_toTex(lr){var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=this.expr.toTex(lr);return J(this,mr,lr&&lr.implicit)&&(Or=`\\\\left(${Or}\\\\right)`),"\\\\mathrm{"+this.name+"}\\\\left("+this.params.map(toSymbol).join(",")+"\\\\right)="+Or}}return _defineProperty($e,"name",name$105),$e},{isClass:!0,isNode:!0}),name$104="IndexNode",dependencies$104=["Node","size"],createIndexNode=factory(name$104,dependencies$104,D=>{var{Node:E,size:F}=D;class J extends E{constructor(_t,lr){if(super(),this.dimensions=_t,this.dotNotation=lr||!1,!Array.isArray(_t)||!_t.every(isNode))throw TypeError(\'Array containing Nodes expected for parameter "dimensions"\');if(this.dotNotation&&!this.isObjectProperty())throw Error("dotNotation only applicable for object properties")}get type(){return name$104}get isIndexNode(){return!0}_compile(_t,lr){var mr=map$1(this.dimensions,function(Pr,dn){if(Pr.filter(zi=>zi.isSymbolNode&&zi.name==="end").length>0){var gi=Object.create(lr);gi.end=!0;var qi=Pr._compile(_t,gi);return function(zi,Hi,Qi){if(!isMatrix(Qi)&&!isArray(Qi)&&!isString(Qi))throw TypeError(\'Cannot resolve "end": context must be a Matrix, Array, or string but is \'+typeOf(Qi));var Gi=F(Qi),Zi=Object.create(Hi);return Zi.end=Gi[dn],qi(zi,Zi,Qi)}}else return Pr._compile(_t,lr)}),Or=getSafeProperty(_t,"index");return function(Pr,dn,gi){return Or(...map$1(mr,function(qi){return qi(Pr,dn,gi)}))}}forEach(_t){for(var lr=0;lr<this.dimensions.length;lr++)_t(this.dimensions[lr],"dimensions["+lr+"]",this)}map(_t){for(var lr=[],mr=0;mr<this.dimensions.length;mr++)lr[mr]=this._ifNode(_t(this.dimensions[mr],"dimensions["+mr+"]",this));return new J(lr,this.dotNotation)}clone(){return new J(this.dimensions.slice(0),this.dotNotation)}isObjectProperty(){return this.dimensions.length===1&&isConstantNode(this.dimensions[0])&&typeof this.dimensions[0].value=="string"}getObjectProperty(){return this.isObjectProperty()?this.dimensions[0].value:null}_toString(_t){return this.dotNotation?"."+this.getObjectProperty():"["+this.dimensions.join(", ")+"]"}toJSON(){return{mathjs:name$104,dimensions:this.dimensions,dotNotation:this.dotNotation}}static fromJSON(_t){return new J(_t.dimensions,_t.dotNotation)}_toHTML(_t){for(var lr=[],mr=0;mr<this.dimensions.length;mr++)lr[mr]=this.dimensions[mr].toHTML();return this.dotNotation?\'<span class="math-operator math-accessor-operator">.</span><span class="math-symbol math-property">\'+escape(this.getObjectProperty())+"</span>":\'<span class="math-parenthesis math-square-parenthesis">[</span>\'+lr.join(\'<span class="math-separator">,</span>\')+\'<span class="math-parenthesis math-square-parenthesis">]</span>\'}_toTex(_t){var lr=this.dimensions.map(function(mr){return mr.toTex(_t)});return this.dotNotation?"."+this.getObjectProperty():"_{"+lr.join(",")+"}"}}return _defineProperty(J,"name",name$104),J},{isClass:!0,isNode:!0}),name$103="ObjectNode",dependencies$103=["Node"],createObjectNode=factory(name$103,dependencies$103,D=>{var{Node:E}=D;class F extends E{constructor($e){if(super(),this.properties=$e||{},$e&&(typeof $e!="object"||!Object.keys($e).every(function(_t){return isNode($e[_t])})))throw TypeError("Object containing Nodes expected")}get type(){return name$103}get isObjectNode(){return!0}_compile($e,_t){var lr={};for(var mr in this.properties)if(hasOwnProperty$1(this.properties,mr)){var Or=stringify(mr),Pr=JSON.parse(Or);lr[Pr]=getSafeProperty(this.properties,mr)._compile($e,_t)}return function(dn,gi,qi){var zi={};for(var Hi in lr)hasOwnProperty$1(lr,Hi)&&(zi[Hi]=lr[Hi](dn,gi,qi));return zi}}forEach($e){for(var _t in this.properties)hasOwnProperty$1(this.properties,_t)&&$e(this.properties[_t],"properties["+stringify(_t)+"]",this)}map($e){var _t={};for(var lr in this.properties)hasOwnProperty$1(this.properties,lr)&&(_t[lr]=this._ifNode($e(this.properties[lr],"properties["+stringify(lr)+"]",this)));return new F(_t)}clone(){var $e={};for(var _t in this.properties)hasOwnProperty$1(this.properties,_t)&&($e[_t]=this.properties[_t]);return new F($e)}_toString($e){var _t=[];for(var lr in this.properties)hasOwnProperty$1(this.properties,lr)&&_t.push(stringify(lr)+": "+this.properties[lr].toString($e));return"{"+_t.join(", ")+"}"}toJSON(){return{mathjs:name$103,properties:this.properties}}static fromJSON($e){return new F($e.properties)}_toHTML($e){var _t=[];for(var lr in this.properties)hasOwnProperty$1(this.properties,lr)&&_t.push(\'<span class="math-symbol math-property">\'+escape(lr)+\'</span><span class="math-operator math-assignment-operator math-property-assignment-operator math-binary-operator">:</span>\'+this.properties[lr].toHTML($e));return\'<span class="math-parenthesis math-curly-parenthesis">{</span>\'+_t.join(\'<span class="math-separator">,</span>\')+\'<span class="math-parenthesis math-curly-parenthesis">}</span>\'}_toTex($e){var _t=[];for(var lr in this.properties)hasOwnProperty$1(this.properties,lr)&&_t.push("\\\\mathbf{"+lr+":} & "+this.properties[lr].toTex($e)+"\\\\\\\\");return"\\\\left\\\\{\\\\begin{array}{ll}"+_t.join(`\n`)+"\\\\end{array}\\\\right\\\\}"}}return _defineProperty(F,"name",name$103),F},{isClass:!0,isNode:!0});function createSubScope(D,E){return new PartitionedMap(D,new ObjectWrappingMap(E),new Set(Object.keys(E)))}var name$102="OperatorNode",dependencies$102=["Node"],createOperatorNode=factory(name$102,dependencies$102,D=>{var{Node:E}=D;function F(_t,lr){var mr=_t;if(lr==="auto")for(;isParenthesisNode(mr);)mr=mr.content;return isConstantNode(mr)?!0:isOperatorNode(mr)?F(mr.args[0],lr):!1}function J(_t,lr,mr,Or,Pr){var dn=getPrecedence(_t,lr,mr),gi=getAssociativity(_t,lr);if(lr==="all"||Or.length>2&&_t.getIdentifier()!=="OperatorNode:add"&&_t.getIdentifier()!=="OperatorNode:multiply")return Or.map(function(oa){switch(oa.getContent().type){case"ArrayNode":case"ConstantNode":case"SymbolNode":case"ParenthesisNode":return!1;default:return!0}});var qi;switch(Or.length){case 0:qi=[];break;case 1:var zi=getPrecedence(Or[0],lr,mr,_t);if(Pr&&zi!==null){var Hi,Qi;if(lr==="keep"?(Hi=Or[0].getIdentifier(),Qi=_t.getIdentifier()):(Hi=Or[0].getContent().getIdentifier(),Qi=_t.getContent().getIdentifier()),properties[dn][Qi].latexLeftParens===!1){qi=[!1];break}if(properties[zi][Hi].latexParens===!1){qi=[!1];break}}if(zi===null){qi=[!1];break}if(zi<=dn){qi=[!0];break}qi=[!1];break;case 2:var Gi,Zi=getPrecedence(Or[0],lr,mr,_t),Xi=isAssociativeWith(_t,Or[0],lr);Gi=Zi===null?!1:Zi===dn&&gi==="right"&&!Xi?!0:Zi<dn;var Ki,ea=getPrecedence(Or[1],lr,mr,_t),Ji=isAssociativeWith(_t,Or[1],lr);if(Ki=ea===null?!1:ea===dn&&gi==="left"&&!Ji?!0:ea<dn,Pr){var ta,na,ra;lr==="keep"?(ta=_t.getIdentifier(),na=_t.args[0].getIdentifier(),ra=_t.args[1].getIdentifier()):(ta=_t.getContent().getIdentifier(),na=_t.args[0].getContent().getIdentifier(),ra=_t.args[1].getContent().getIdentifier()),Zi!==null&&(properties[dn][ta].latexLeftParens===!1&&(Gi=!1),properties[Zi][na].latexParens===!1&&(Gi=!1)),ea!==null&&(properties[dn][ta].latexRightParens===!1&&(Ki=!1),properties[ea][ra].latexParens===!1&&(Ki=!1))}qi=[Gi,Ki];break;default:(_t.getIdentifier()==="OperatorNode:add"||_t.getIdentifier()==="OperatorNode:multiply")&&(qi=Or.map(function(oa){var ua=getPrecedence(oa,lr,mr,_t),sa=isAssociativeWith(_t,oa,lr),aa=getAssociativity(oa,lr);return ua===null?!1:dn===ua&&gi===aa&&!sa?!0:ua<dn}));break}if(Or.length>=2&&_t.getIdentifier()==="OperatorNode:multiply"&&_t.implicit&&lr!=="all"&&mr==="hide")for(var ia=1;ia<qi.length;++ia)F(Or[ia],lr)&&!qi[ia-1]&&(lr!=="keep"||!isParenthesisNode(Or[ia-1]))&&(qi[ia]=!0);return qi}class $e extends E{constructor(lr,mr,Or,Pr,dn){if(super(),typeof lr!="string")throw TypeError(\'string expected for parameter "op"\');if(typeof mr!="string")throw TypeError(\'string expected for parameter "fn"\');if(!Array.isArray(Or)||!Or.every(isNode))throw TypeError(\'Array containing Nodes expected for parameter "args"\');this.implicit=Pr===!0,this.isPercentage=dn===!0,this.op=lr,this.fn=mr,this.args=Or||[]}get type(){return name$102}get isOperatorNode(){return!0}_compile(lr,mr){if(typeof this.fn!="string"||!isSafeMethod(lr,this.fn))throw lr[this.fn]?Error(\'No access to function "\'+this.fn+\'"\'):Error("Function "+this.fn+\' missing in provided namespace "math"\');var Or=getSafeProperty(lr,this.fn),Pr=map$1(this.args,function(Hi){return Hi._compile(lr,mr)});if(typeof Or=="function"&&Or.rawArgs===!0){var dn=this.args;return function(Hi,Qi,Gi){return Or(dn,lr,createSubScope(Hi,Qi))}}else if(Pr.length===1){var gi=Pr[0];return function(Hi,Qi,Gi){return Or(gi(Hi,Qi,Gi))}}else if(Pr.length===2){var qi=Pr[0],zi=Pr[1];return function(Hi,Qi,Gi){return Or(qi(Hi,Qi,Gi),zi(Hi,Qi,Gi))}}else return function(Hi,Qi,Gi){return Or.apply(null,map$1(Pr,function(Zi){return Zi(Hi,Qi,Gi)}))}}forEach(lr){for(var mr=0;mr<this.args.length;mr++)lr(this.args[mr],"args["+mr+"]",this)}map(lr){for(var mr=[],Or=0;Or<this.args.length;Or++)mr[Or]=this._ifNode(lr(this.args[Or],"args["+Or+"]",this));return new $e(this.op,this.fn,mr,this.implicit,this.isPercentage)}clone(){return new $e(this.op,this.fn,this.args.slice(0),this.implicit,this.isPercentage)}isUnary(){return this.args.length===1}isBinary(){return this.args.length===2}_toString(lr){var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=lr&&lr.implicit?lr.implicit:"hide",Pr=this.args,dn=J(this,mr,Or,Pr,!1);if(Pr.length===1){var gi=getAssociativity(this,mr),qi=Pr[0].toString(lr);dn[0]&&(qi="("+qi+")");var zi=/[a-zA-Z]+/.test(this.op);return gi==="right"?this.op+(zi?" ":"")+qi:gi==="left"?qi+(zi?" ":"")+this.op:qi+this.op}else if(Pr.length===2){var Hi=Pr[0].toString(lr),Qi=Pr[1].toString(lr);return dn[0]&&(Hi="("+Hi+")"),dn[1]&&(Qi="("+Qi+")"),this.implicit&&this.getIdentifier()==="OperatorNode:multiply"&&Or==="hide"?Hi+" "+Qi:Hi+" "+this.op+" "+Qi}else if(Pr.length>2&&(this.getIdentifier()==="OperatorNode:add"||this.getIdentifier()==="OperatorNode:multiply")){var Gi=Pr.map(function(Zi,Xi){return Zi=Zi.toString(lr),dn[Xi]&&(Zi="("+Zi+")"),Zi});return this.implicit&&this.getIdentifier()==="OperatorNode:multiply"&&Or==="hide"?Gi.join(" "):Gi.join(" "+this.op+" ")}else return this.fn+"("+this.args.join(", ")+")"}toJSON(){return{mathjs:name$102,op:this.op,fn:this.fn,args:this.args,implicit:this.implicit,isPercentage:this.isPercentage}}static fromJSON(lr){return new $e(lr.op,lr.fn,lr.args,lr.implicit,lr.isPercentage)}_toHTML(lr){var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=lr&&lr.implicit?lr.implicit:"hide",Pr=this.args,dn=J(this,mr,Or,Pr,!1);if(Pr.length===1){var gi=getAssociativity(this,mr),qi=Pr[0].toHTML(lr);return dn[0]&&(qi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+qi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),gi==="right"?\'<span class="math-operator math-unary-operator math-lefthand-unary-operator">\'+escape(this.op)+"</span>"+qi:qi+\'<span class="math-operator math-unary-operator math-righthand-unary-operator">\'+escape(this.op)+"</span>"}else if(Pr.length===2){var zi=Pr[0].toHTML(lr),Hi=Pr[1].toHTML(lr);return dn[0]&&(zi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+zi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),dn[1]&&(Hi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+Hi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),this.implicit&&this.getIdentifier()==="OperatorNode:multiply"&&Or==="hide"?zi+\'<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>\'+Hi:zi+\'<span class="math-operator math-binary-operator math-explicit-binary-operator">\'+escape(this.op)+"</span>"+Hi}else{var Qi=Pr.map(function(Gi,Zi){return Gi=Gi.toHTML(lr),dn[Zi]&&(Gi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+Gi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Gi});return Pr.length>2&&(this.getIdentifier()==="OperatorNode:add"||this.getIdentifier()==="OperatorNode:multiply")?this.implicit&&this.getIdentifier()==="OperatorNode:multiply"&&Or==="hide"?Qi.join(\'<span class="math-operator math-binary-operator math-implicit-binary-operator"></span>\'):Qi.join(\'<span class="math-operator math-binary-operator math-explicit-binary-operator">\'+escape(this.op)+"</span>"):\'<span class="math-function">\'+escape(this.fn)+\'</span><span class="math-paranthesis math-round-parenthesis">(</span>\'+Qi.join(\'<span class="math-separator">,</span>\')+\'<span class="math-paranthesis math-round-parenthesis">)</span>\'}}_toTex(lr){var mr=lr&&lr.parenthesis?lr.parenthesis:"keep",Or=lr&&lr.implicit?lr.implicit:"hide",Pr=this.args,dn=J(this,mr,Or,Pr,!0),gi=latexOperators[this.fn];if(gi=gi===void 0?this.op:gi,Pr.length===1){var qi=getAssociativity(this,mr),zi=Pr[0].toTex(lr);return dn[0]&&(zi=`\\\\left(${zi}\\\\right)`),qi==="right"?gi+zi:zi+gi}else if(Pr.length===2){var Hi=Pr[0],Qi=Hi.toTex(lr);dn[0]&&(Qi=`\\\\left(${Qi}\\\\right)`);var Gi=Pr[1].toTex(lr);dn[1]&&(Gi=`\\\\left(${Gi}\\\\right)`);var Zi=mr==="keep"?Hi.getIdentifier():Hi.getContent().getIdentifier();switch(this.getIdentifier()){case"OperatorNode:divide":return gi+"{"+Qi+"}{"+Gi+"}";case"OperatorNode:pow":switch(Qi="{"+Qi+"}",Gi="{"+Gi+"}",Zi){case"ConditionalNode":case"OperatorNode:divide":Qi=`\\\\left(${Qi}\\\\right)`}break;case"OperatorNode:multiply":if(this.implicit&&Or==="hide")return Qi+"~"+Gi}return Qi+gi+Gi}else if(Pr.length>2&&(this.getIdentifier()==="OperatorNode:add"||this.getIdentifier()==="OperatorNode:multiply")){var Xi=Pr.map(function(Ki,ea){return Ki=Ki.toTex(lr),dn[ea]&&(Ki=`\\\\left(${Ki}\\\\right)`),Ki});return this.getIdentifier()==="OperatorNode:multiply"&&this.implicit&&Or==="hide"?Xi.join("~"):Xi.join(gi)}else return"\\\\mathrm{"+this.fn+"}\\\\left("+Pr.map(function(Ki){return Ki.toTex(lr)}).join(",")+"\\\\right)"}getIdentifier(){return this.type+":"+this.fn}}return _defineProperty($e,"name",name$102),$e},{isClass:!0,isNode:!0}),name$101="ParenthesisNode",dependencies$101=["Node"],createParenthesisNode=factory(name$101,dependencies$101,D=>{var{Node:E}=D;class F extends E{constructor($e){if(super(),!isNode($e))throw TypeError(\'Node expected for parameter "content"\');this.content=$e}get type(){return name$101}get isParenthesisNode(){return!0}_compile($e,_t){return this.content._compile($e,_t)}getContent(){return this.content.getContent()}forEach($e){$e(this.content,"content",this)}map($e){return new F($e(this.content,"content",this))}clone(){return new F(this.content)}_toString($e){return!$e||$e&&!$e.parenthesis||$e&&$e.parenthesis==="keep"?"("+this.content.toString($e)+")":this.content.toString($e)}toJSON(){return{mathjs:name$101,content:this.content}}static fromJSON($e){return new F($e.content)}_toHTML($e){return!$e||$e&&!$e.parenthesis||$e&&$e.parenthesis==="keep"?\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+this.content.toHTML($e)+\'<span class="math-parenthesis math-round-parenthesis">)</span>\':this.content.toHTML($e)}_toTex($e){return!$e||$e&&!$e.parenthesis||$e&&$e.parenthesis==="keep"?`\\\\left(${this.content.toTex($e)}\\\\right)`:this.content.toTex($e)}}return _defineProperty(F,"name",name$101),F},{isClass:!0,isNode:!0}),name$100="RangeNode",dependencies$100=["Node"],createRangeNode=factory(name$100,dependencies$100,D=>{var{Node:E}=D;function F($e,_t,lr){var mr=getPrecedence($e,_t,lr),Or={},Pr=getPrecedence($e.start,_t,lr);if(Or.start=Pr!==null&&Pr<=mr||_t==="all",$e.step){var dn=getPrecedence($e.step,_t,lr);Or.step=dn!==null&&dn<=mr||_t==="all"}var gi=getPrecedence($e.end,_t,lr);return Or.end=gi!==null&&gi<=mr||_t==="all",Or}class J extends E{constructor(_t,lr,mr){if(super(),!isNode(_t)||!isNode(lr)||mr&&!isNode(mr))throw TypeError("Node expected");if(arguments.length>3)throw Error("Too many arguments");this.start=_t,this.end=lr,this.step=mr||null}get type(){return name$100}get isRangeNode(){return!0}needsEnd(){return this.filter(function(_t){return isSymbolNode(_t)&&_t.name==="end"}).length>0}_compile(_t,lr){var mr=_t.range,Or=this.start._compile(_t,lr),Pr=this.end._compile(_t,lr);if(this.step){var dn=this.step._compile(_t,lr);return function(gi,qi,zi){return mr(Or(gi,qi,zi),Pr(gi,qi,zi),dn(gi,qi,zi))}}else return function(gi,qi,zi){return mr(Or(gi,qi,zi),Pr(gi,qi,zi))}}forEach(_t){_t(this.start,"start",this),_t(this.end,"end",this),this.step&&_t(this.step,"step",this)}map(_t){return new J(this._ifNode(_t(this.start,"start",this)),this._ifNode(_t(this.end,"end",this)),this.step&&this._ifNode(_t(this.step,"step",this)))}clone(){return new J(this.start,this.end,this.step&&this.step)}_toString(_t){var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=F(this,lr,_t&&_t.implicit),Or,Pr=this.start.toString(_t);if(mr.start&&(Pr="("+Pr+")"),Or=Pr,this.step){var dn=this.step.toString(_t);mr.step&&(dn="("+dn+")"),Or+=":"+dn}var gi=this.end.toString(_t);return mr.end&&(gi="("+gi+")"),Or+=":"+gi,Or}toJSON(){return{mathjs:name$100,start:this.start,end:this.end,step:this.step}}static fromJSON(_t){return new J(_t.start,_t.end,_t.step)}_toHTML(_t){var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=F(this,lr,_t&&_t.implicit),Or,Pr=this.start.toHTML(_t);if(mr.start&&(Pr=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+Pr+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Or=Pr,this.step){var dn=this.step.toHTML(_t);mr.step&&(dn=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+dn+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Or+=\'<span class="math-operator math-range-operator">:</span>\'+dn}var gi=this.end.toHTML(_t);return mr.end&&(gi=\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+gi+\'<span class="math-parenthesis math-round-parenthesis">)</span>\'),Or+=\'<span class="math-operator math-range-operator">:</span>\'+gi,Or}_toTex(_t){var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=F(this,lr,_t&&_t.implicit),Or=this.start.toTex(_t);if(mr.start&&(Or=`\\\\left(${Or}\\\\right)`),this.step){var Pr=this.step.toTex(_t);mr.step&&(Pr=`\\\\left(${Pr}\\\\right)`),Or+=":"+Pr}var dn=this.end.toTex(_t);return mr.end&&(dn=`\\\\left(${dn}\\\\right)`),Or+=":"+dn,Or}}return _defineProperty(J,"name",name$100),J},{isClass:!0,isNode:!0}),name$99="RelationalNode",dependencies$99=["Node"],createRelationalNode=factory(name$99,dependencies$99,D=>{var{Node:E}=D,F={equal:"==",unequal:"!=",smaller:"<",larger:">",smallerEq:"<=",largerEq:">="};class J extends E{constructor(_t,lr){if(super(),!Array.isArray(_t))throw TypeError("Parameter conditionals must be an array");if(!Array.isArray(lr))throw TypeError("Parameter params must be an array");if(_t.length!==lr.length-1)throw TypeError("Parameter params must contain exactly one more element than parameter conditionals");this.conditionals=_t,this.params=lr}get type(){return name$99}get isRelationalNode(){return!0}_compile(_t,lr){var mr=this,Or=this.params.map(Pr=>Pr._compile(_t,lr));return function(Pr,dn,gi){for(var qi,zi=Or[0](Pr,dn,gi),Hi=0;Hi<mr.conditionals.length;Hi++)if(qi=zi,zi=Or[Hi+1](Pr,dn,gi),!getSafeProperty(_t,mr.conditionals[Hi])(qi,zi))return!1;return!0}}forEach(_t){this.params.forEach((lr,mr)=>_t(lr,"params["+mr+"]",this),this)}map(_t){return new J(this.conditionals.slice(),this.params.map((lr,mr)=>this._ifNode(_t(lr,"params["+mr+"]",this)),this))}clone(){return new J(this.conditionals,this.params)}_toString(_t){for(var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=getPrecedence(this,lr,_t&&_t.implicit),Or=this.params.map(function(gi,qi){var zi=getPrecedence(gi,lr,_t&&_t.implicit);return lr==="all"||zi!==null&&zi<=mr?"("+gi.toString(_t)+")":gi.toString(_t)}),Pr=Or[0],dn=0;dn<this.conditionals.length;dn++)Pr+=" "+F[this.conditionals[dn]],Pr+=" "+Or[dn+1];return Pr}toJSON(){return{mathjs:name$99,conditionals:this.conditionals,params:this.params}}static fromJSON(_t){return new J(_t.conditionals,_t.params)}_toHTML(_t){for(var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=getPrecedence(this,lr,_t&&_t.implicit),Or=this.params.map(function(gi,qi){var zi=getPrecedence(gi,lr,_t&&_t.implicit);return lr==="all"||zi!==null&&zi<=mr?\'<span class="math-parenthesis math-round-parenthesis">(</span>\'+gi.toHTML(_t)+\'<span class="math-parenthesis math-round-parenthesis">)</span>\':gi.toHTML(_t)}),Pr=Or[0],dn=0;dn<this.conditionals.length;dn++)Pr+=\'<span class="math-operator math-binary-operator math-explicit-binary-operator">\'+escape(F[this.conditionals[dn]])+"</span>"+Or[dn+1];return Pr}_toTex(_t){for(var lr=_t&&_t.parenthesis?_t.parenthesis:"keep",mr=getPrecedence(this,lr,_t&&_t.implicit),Or=this.params.map(function(gi,qi){var zi=getPrecedence(gi,lr,_t&&_t.implicit);return lr==="all"||zi!==null&&zi<=mr?"\\\\left("+gi.toTex(_t)+"\\right)":gi.toTex(_t)}),Pr=Or[0],dn=0;dn<this.conditionals.length;dn++)Pr+=latexOperators[this.conditionals[dn]]+Or[dn+1];return Pr}}return _defineProperty(J,"name",name$99),J},{isClass:!0,isNode:!0}),name$98="SymbolNode",dependencies$98=["math","?Unit","Node"],createSymbolNode=factory(name$98,dependencies$98,D=>{var{math:E,Unit:F,Node:J}=D;function $e(lr){return F?F.isValuelessUnit(lr):!1}class _t extends J{constructor(mr){if(super(),typeof mr!="string")throw TypeError(\'String expected for parameter "name"\');this.name=mr}get type(){return"SymbolNode"}get isSymbolNode(){return!0}_compile(mr,Or){var Pr=this.name;if(Or[Pr]===!0)return function(gi,qi,zi){return getSafeProperty(qi,Pr)};if(Pr in mr)return function(gi,qi,zi){return gi.has(Pr)?gi.get(Pr):getSafeProperty(mr,Pr)};var dn=$e(Pr);return function(gi,qi,zi){return gi.has(Pr)?gi.get(Pr):dn?new F(null,Pr):_t.onUndefinedSymbol(Pr)}}forEach(mr){}map(mr){return this.clone()}static onUndefinedSymbol(mr){throw Error("Undefined symbol "+mr)}clone(){return new _t(this.name)}_toString(mr){return this.name}_toHTML(mr){var Or=escape(this.name);return Or==="true"||Or==="false"?\'<span class="math-symbol math-boolean">\'+Or+"</span>":Or==="i"?\'<span class="math-symbol math-imaginary-symbol">\'+Or+"</span>":Or==="Infinity"?\'<span class="math-symbol math-infinity-symbol">\'+Or+"</span>":Or==="NaN"?\'<span class="math-symbol math-nan-symbol">\'+Or+"</span>":Or==="null"?\'<span class="math-symbol math-null-symbol">\'+Or+"</span>":Or==="undefined"?\'<span class="math-symbol math-undefined-symbol">\'+Or+"</span>":\'<span class="math-symbol">\'+Or+"</span>"}toJSON(){return{mathjs:"SymbolNode",name:this.name}}static fromJSON(mr){return new _t(mr.name)}_toTex(mr){var Or=!1;E[this.name]===void 0&&$e(this.name)&&(Or=!0);var Pr=toSymbol(this.name,Or);return Pr[0]==="\\\\"?Pr:" "+Pr}}return _t},{isClass:!0,isNode:!0}),name$97="FunctionNode",dependencies$97=["math","Node","SymbolNode"],createFunctionNode=factory(name$97,dependencies$97,D=>{var E,{math:F,Node:J,SymbolNode:$e}=D,_t=Or=>format(Or,{truncate:78});function lr(Or,Pr,dn){for(var gi="",qi=/\\$(?:\\{([a-z_][a-z_0-9]*)(?:\\[([0-9]+)\\])?\\}|\\$)/gi,zi=0,Hi;(Hi=qi.exec(Or))!==null;)if(gi+=Or.substring(zi,Hi.index),zi=Hi.index,Hi[0]==="$$")gi+="$",zi++;else{zi+=Hi[0].length;var Qi=Pr[Hi[1]];if(!Qi)throw ReferenceError("Template: Property "+Hi[1]+" does not exist.");if(Hi[2]===void 0)switch(typeof Qi){case"string":gi+=Qi;break;case"object":if(isNode(Qi))gi+=Qi.toTex(dn);else if(Array.isArray(Qi))gi+=Qi.map(function(Gi,Zi){if(isNode(Gi))return Gi.toTex(dn);throw TypeError("Template: "+Hi[1]+"["+Zi+"] is not a Node.")}).join(",");else throw TypeError("Template: "+Hi[1]+" has to be a Node, String or array of Nodes");break;default:throw TypeError("Template: "+Hi[1]+" has to be a Node, String or array of Nodes")}else if(isNode(Qi[Hi[2]]&&Qi[Hi[2]]))gi+=Qi[Hi[2]].toTex(dn);else throw TypeError("Template: "+Hi[1]+"["+Hi[2]+"] is not a Node.")}return gi+=Or.slice(zi),gi}class mr extends J{constructor(Pr,dn,gi){if(super(),typeof Pr=="string"&&(Pr=new $e(Pr)),!isNode(Pr))throw TypeError(\'Node expected as parameter "fn"\');if(!Array.isArray(dn)||!dn.every(isNode))throw TypeError(\'Array containing Nodes expected for parameter "args"\');var qi=typeof gi;if(!(qi==="undefined"||qi==="boolean"))throw TypeError("optional flag, if specified, must be boolean");this.fn=Pr,this.args=dn||[],this.optional=!!gi}get name(){return this.fn.name||""}get type(){return name$97}get isFunctionNode(){return!0}_compile(Pr,dn){var gi=this.args.map(ia=>ia._compile(Pr,dn)),qi=this.optional||isAccessorNode(this.fn)&&this.fn.optionalChaining;if(isSymbolNode(this.fn)){var zi=this.fn.name;if(dn[zi]){var Hi=this.args;return function(ia,oa,ua){var sa=getSafeProperty(oa,zi);if(!(qi&&sa===void 0)){if(typeof sa!="function")throw TypeError(`Argument \'${zi}\' was not a function; received: ${_t(sa)}`);if(sa.rawArgs)return sa(Hi,Pr,createSubScope(ia,oa));var aa=gi.map(pa=>pa(ia,oa,ua));return sa.apply(sa,aa)}}}else{var Qi=zi in Pr?getSafeProperty(Pr,zi):void 0,Gi=typeof Qi=="function"&&Qi.rawArgs===!0,Zi=ia=>{var oa;if(ia.has(zi))oa=ia.get(zi);else if(zi in Pr)oa=getSafeProperty(Pr,zi);else if(qi)oa=void 0;else return mr.onUndefinedFunction(zi);if(typeof oa=="function"||qi&&oa===void 0)return oa;throw TypeError(`\'${zi}\' is not a function; its value is:\n  ${_t(oa)}`)};if(Gi){var Xi=this.args;return function(ia,oa,ua){var sa=Zi(ia);return sa.rawArgs===!0?sa(Xi,Pr,createSubScope(ia,oa)):sa(...gi.map(aa=>aa(ia,oa,ua)))}}else switch(gi.length){case 0:return function(ia,oa,ua){var sa=Zi(ia);if(!(qi&&sa===void 0))return sa()};case 1:return function(ia,oa,ua){var sa=Zi(ia);if(!(qi&&sa===void 0)){var aa=gi[0];return sa(aa(ia,oa,ua))}};case 2:return function(ia,oa,ua){var sa=Zi(ia);if(!(qi&&sa===void 0)){var aa=gi[0],pa=gi[1];return sa(aa(ia,oa,ua),pa(ia,oa,ua))}};default:return function(ia,oa,ua){var sa=Zi(ia);if(!(qi&&sa===void 0))return sa(...gi.map(aa=>aa(ia,oa,ua)))}}}}else if(isAccessorNode(this.fn)&&isIndexNode(this.fn.index)&&this.fn.index.isObjectProperty()){var Ki=this.fn.object._compile(Pr,dn),ea=this.fn.index.getObjectProperty(),Ji=this.args;return function(ia,oa,ua){var sa=Ki(ia,oa,ua);if(!(qi&&(sa==null||sa[ea]===void 0))){var aa=getSafeMethod(sa,ea);if(aa!=null&&aa.rawArgs)return aa(Ji,Pr,createSubScope(ia,oa));var pa=gi.map(ma=>ma(ia,oa,ua));return aa.apply(sa,pa)}}}else{var ta=this.fn.toString(),na=this.fn._compile(Pr,dn),ra=this.args;return function(ia,oa,ua){var sa=na(ia,oa,ua);if(!(qi&&sa===void 0)){if(typeof sa!="function")throw TypeError(`Expression \'${ta}\' did not evaluate to a function; value is:\n  ${_t(sa)}`);if(sa.rawArgs)return sa(ra,Pr,createSubScope(ia,oa));var aa=gi.map(pa=>pa(ia,oa,ua));return sa.apply(sa,aa)}}}}forEach(Pr){Pr(this.fn,"fn",this);for(var dn=0;dn<this.args.length;dn++)Pr(this.args[dn],"args["+dn+"]",this)}map(Pr){for(var dn=this._ifNode(Pr(this.fn,"fn",this)),gi=[],qi=0;qi<this.args.length;qi++)gi[qi]=this._ifNode(Pr(this.args[qi],"args["+qi+"]",this));return new mr(dn,gi)}clone(){return new mr(this.fn,this.args.slice(0))}toString(Pr){var dn,gi=this.fn.toString(Pr);return Pr&&typeof Pr.handler=="object"&&hasOwnProperty$1(Pr.handler,gi)&&(dn=Pr.handler[gi](this,Pr)),dn===void 0?super.toString(Pr):dn}_toString(Pr){var dn=this.args.map(function(gi){return gi.toString(Pr)});return(isFunctionAssignmentNode(this.fn)?"("+this.fn.toString(Pr)+")":this.fn.toString(Pr))+"("+dn.join(", ")+")"}toJSON(){return{mathjs:name$97,fn:this.fn,args:this.args}}_toHTML(Pr){var dn=this.args.map(function(gi){return gi.toHTML(Pr)});return\'<span class="math-function">\'+escape(this.fn)+\'</span><span class="math-paranthesis math-round-parenthesis">(</span>\'+dn.join(\'<span class="math-separator">,</span>\')+\'<span class="math-paranthesis math-round-parenthesis">)</span>\'}toTex(Pr){var dn;return Pr&&typeof Pr.handler=="object"&&hasOwnProperty$1(Pr.handler,this.name)&&(dn=Pr.handler[this.name](this,Pr)),dn===void 0?super.toTex(Pr):dn}_toTex(Pr){var dn=this.args.map(function(zi){return zi.toTex(Pr)}),gi;latexFunctions[this.name]&&(gi=latexFunctions[this.name]),F[this.name]&&(typeof F[this.name].toTex=="function"||typeof F[this.name].toTex=="object"||typeof F[this.name].toTex=="string")&&(gi=F[this.name].toTex);var qi;switch(typeof gi){case"function":qi=gi(this,Pr);break;case"string":qi=lr(gi,this,Pr);break;case"object":switch(typeof gi[dn.length]){case"function":qi=gi[dn.length](this,Pr);break;case"string":qi=lr(gi[dn.length],this,Pr);break}}return qi===void 0?lr(defaultTemplate,this,Pr):qi}getIdentifier(){return this.type+":"+this.name}}return E=mr,_defineProperty(mr,"name",name$97),_defineProperty(mr,"onUndefinedFunction",function(Or){throw Error("Undefined function "+Or)}),_defineProperty(mr,"fromJSON",function(Or){return new E(Or.fn,Or.args)}),mr},{isClass:!0,isNode:!0}),name$96="parse",dependencies$96=["typed","numeric","config","AccessorNode","ArrayNode","AssignmentNode","BlockNode","ConditionalNode","ConstantNode","FunctionAssignmentNode","FunctionNode","IndexNode","ObjectNode","OperatorNode","ParenthesisNode","RangeNode","RelationalNode","SymbolNode"],createParse=factory(name$96,dependencies$96,D=>{var{typed:E,numeric:F,config:J,AccessorNode:$e,ArrayNode:_t,AssignmentNode:lr,BlockNode:mr,ConditionalNode:Or,ConstantNode:Pr,FunctionAssignmentNode:dn,FunctionNode:gi,IndexNode:qi,ObjectNode:zi,OperatorNode:Hi,ParenthesisNode:Qi,RangeNode:Gi,RelationalNode:Zi,SymbolNode:Xi}=D,Ki=E(name$96,{string:function(ca){return $a(ca,{})},"Array | Matrix":function(ca){return ea(ca,{})},"string, Object":function(ca,Sa){return $a(ca,Sa.nodes===void 0?{}:Sa.nodes)},"Array | Matrix, Object":ea});function ea(ca){var Sa=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},Ha=Sa.nodes===void 0?{}:Sa.nodes;return deepMap(ca,function(Za){if(typeof Za!="string")throw TypeError("String expected");return $a(Za,Ha)})}var Ji={NULL:0,DELIMITER:1,NUMBER:2,SYMBOL:3,UNKNOWN:4},ta={",":!0,"(":!0,")":!0,"[":!0,"]":!0,"{":!0,"}":!0,\'"\':!0,"\'":!0,";":!0,"+":!0,"-":!0,"*":!0,".*":!0,"/":!0,"./":!0,"%":!0,"^":!0,".^":!0,"~":!0,"!":!0,"&":!0,"|":!0,"^|":!0,"=":!0,":":!0,"?":!0,"?.":!0,"??":!0,"==":!0,"!=":!0,"<":!0,">":!0,"<=":!0,">=":!0,"<<":!0,">>":!0,">>>":!0},na={mod:!0,to:!0,in:!0,and:!0,xor:!0,or:!0,not:!0},ra={true:!0,false:!1,null:null,undefined:void 0},ia=["NaN","Infinity"],oa={\'"\':\'"\',"\'":"\'","\\\\":"\\\\","/":"/",b:"\\b",f:"\\f",n:`\n`,r:"\\r",t:"	"};function ua(){return{extraNodes:{},expression:"",comment:"",index:0,token:"",tokenType:Ji.NULL,nestingLevel:0,conditionalLevel:null}}function sa(ca,Sa){return ca.expression.substr(ca.index,Sa)}function aa(ca){return sa(ca,1)}function pa(ca){ca.index++}function ma(ca){return ca.expression.charAt(ca.index-1)}function la(ca){return ca.expression.charAt(ca.index+1)}function ha(ca){for(ca.tokenType=Ji.NULL,ca.token="",ca.comment="";;){if(aa(ca)==="#")for(;aa(ca)!==`\n`&&aa(ca)!=="";)ca.comment+=aa(ca),pa(ca);if(Ki.isWhitespace(aa(ca),ca.nestingLevel))pa(ca);else break}if(aa(ca)===""){ca.tokenType=Ji.DELIMITER;return}if(aa(ca)===`\n`&&!ca.nestingLevel){ca.tokenType=Ji.DELIMITER,ca.token=aa(ca),pa(ca);return}var Sa=aa(ca),Ha=sa(ca,2),Za=sa(ca,3);if(Za.length===3&&ta[Za]){ca.tokenType=Ji.DELIMITER,ca.token=Za,pa(ca),pa(ca),pa(ca);return}if(Ha.length===2&&ta[Ha]&&(Ha!=="?."||!Ki.isDigit(ca.expression.charAt(ca.index+2)))){ca.tokenType=Ji.DELIMITER,ca.token=Ha,pa(ca),pa(ca);return}if(ta[Sa]){ca.tokenType=Ji.DELIMITER,ca.token=Sa,pa(ca);return}if(Ki.isDigitDot(Sa)){ca.tokenType=Ji.NUMBER;var fs=sa(ca,2);if(fs==="0b"||fs==="0o"||fs==="0x"){for(ca.token+=aa(ca),pa(ca),ca.token+=aa(ca),pa(ca);Ki.isAlpha(aa(ca),ma(ca),la(ca))||Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);if(aa(ca)===".")for(ca.token+=".",pa(ca);Ki.isAlpha(aa(ca),ma(ca),la(ca))||Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);else if(aa(ca)==="i")for(ca.token+="i",pa(ca);Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);return}if(aa(ca)==="."){if(ca.token+=aa(ca),pa(ca),!Ki.isDigit(aa(ca))){ca.tokenType=Ji.DELIMITER;return}}else{for(;Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);Ki.isDecimalMark(aa(ca),la(ca))&&(ca.token+=aa(ca),pa(ca))}for(;Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);if(aa(ca)==="E"||aa(ca)==="e"){if(Ki.isDigit(la(ca))||la(ca)==="-"||la(ca)==="+"){if(ca.token+=aa(ca),pa(ca),(aa(ca)==="+"||aa(ca)==="-")&&(ca.token+=aa(ca),pa(ca)),!Ki.isDigit(aa(ca)))throw os(ca,\'Digit expected, got "\'+aa(ca)+\'"\');for(;Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);if(Ki.isDecimalMark(aa(ca),la(ca)))throw os(ca,\'Digit expected, got "\'+aa(ca)+\'"\')}else if(Ki.isDecimalMark(la(ca),ca.expression.charAt(ca.index+2)))throw pa(ca),os(ca,\'Digit expected, got "\'+aa(ca)+\'"\')}return}if(Ki.isAlpha(aa(ca),ma(ca),la(ca))){for(;Ki.isAlpha(aa(ca),ma(ca),la(ca))||Ki.isDigit(aa(ca));)ca.token+=aa(ca),pa(ca);hasOwnProperty$1(na,ca.token)?ca.tokenType=Ji.DELIMITER:ca.tokenType=Ji.SYMBOL;return}for(ca.tokenType=Ji.UNKNOWN;aa(ca)!=="";)ca.token+=aa(ca),pa(ca);throw os(ca,\'Syntax error in part "\'+ca.token+\'"\')}function ga(ca){do ha(ca);while(ca.token===`\n`)}function Aa(ca){ca.nestingLevel++}function Fa(ca){ca.nestingLevel--}Ki.isAlpha=function(ca,Sa,Ha){return Ki.isValidLatinOrGreek(ca)||Ki.isValidMathSymbol(ca,Ha)||Ki.isValidMathSymbol(Sa,ca)},Ki.isValidLatinOrGreek=function(ca){return/^[a-zA-Z_$\\u00C0-\\u02AF\\u0370-\\u03FF\\u2100-\\u214F]$/.test(ca)},Ki.isValidMathSymbol=function(ca,Sa){return/^[\\uD835]$/.test(ca)&&/^[\\uDC00-\\uDFFF]$/.test(Sa)&&/^[^\\uDC55\\uDC9D\\uDCA0\\uDCA1\\uDCA3\\uDCA4\\uDCA7\\uDCA8\\uDCAD\\uDCBA\\uDCBC\\uDCC4\\uDD06\\uDD0B\\uDD0C\\uDD15\\uDD1D\\uDD3A\\uDD3F\\uDD45\\uDD47-\\uDD49\\uDD51\\uDEA6\\uDEA7\\uDFCC\\uDFCD]$/.test(Sa)},Ki.isWhitespace=function(ca,Sa){return ca===" "||ca==="	"||ca===" "||ca===`\n`&&Sa>0},Ki.isDecimalMark=function(ca,Sa){return ca==="."&&Sa!=="/"&&Sa!=="*"&&Sa!=="^"},Ki.isDigitDot=function(ca){return ca>="0"&&ca<="9"||ca==="."},Ki.isDigit=function(ca){return ca>="0"&&ca<="9"};function $a(ca,Sa){var Ha=ua();_extends(Ha,{expression:ca,extraNodes:Sa}),ha(Ha);var Za=_a(Ha);if(Ha.token!=="")throw Ha.tokenType===Ji.DELIMITER?ns(Ha,"Unexpected operator "+Ha.token):os(Ha,\'Unexpected part "\'+Ha.token+\'"\');return Za}function _a(ca){var Sa,Ha=[],Za;for(ca.token!==""&&ca.token!==`\n`&&ca.token!==";"&&(Sa=fa(ca),ca.comment&&(Sa.comment=ca.comment));ca.token===`\n`||ca.token===";";)Ha.length===0&&Sa&&(Za=ca.token!==";",Ha.push({node:Sa,visible:Za})),ha(ca),ca.token!==`\n`&&ca.token!==";"&&ca.token!==""&&(Sa=fa(ca),ca.comment&&(Sa.comment=ca.comment),Za=ca.token!==";",Ha.push({node:Sa,visible:Za}));return Ha.length>0?new mr(Ha):(Sa||(Sa=new Pr(void 0),ca.comment&&(Sa.comment=ca.comment)),Sa)}function fa(ca){var Sa,Ha,Za,fs,gs=ka(ca);if(ca.token==="="){if(isSymbolNode(gs))return Sa=gs.name,ga(ca),Za=fa(ca),new lr(new Xi(Sa),Za);if(isAccessorNode(gs)){if(gs.optionalChaining)throw os(ca,"Cannot assign to optional chain");return ga(ca),Za=fa(ca),new lr(gs.object,gs.index,Za)}else if(isFunctionNode(gs)&&isSymbolNode(gs.fn)&&(fs=!0,Ha=[],Sa=gs.name,gs.args.forEach(function(ws,Os){isSymbolNode(ws)?Ha[Os]=ws.name:fs=!1}),fs))return ga(ca),Za=fa(ca),new dn(Sa,Ha,Za);throw os(ca,"Invalid left hand side of assignment operator =")}return gs}function ka(ca){for(var Sa=ba(ca);ca.token==="?";){var Ha=ca.conditionalLevel;ca.conditionalLevel=ca.nestingLevel,ga(ca);var Za=Sa,fs=fa(ca);if(ca.token!==":")throw os(ca,"False part of conditional expression expected");ca.conditionalLevel=null,ga(ca),Sa=new Or(Za,fs,fa(ca)),ca.conditionalLevel=Ha}return Sa}function ba(ca){for(var Sa=Pa(ca);ca.token==="or";)ga(ca),Sa=new Hi("or","or",[Sa,Pa(ca)]);return Sa}function Pa(ca){for(var Sa=Ia(ca);ca.token==="xor";)ga(ca),Sa=new Hi("xor","xor",[Sa,Ia(ca)]);return Sa}function Ia(ca){for(var Sa=Da(ca);ca.token==="and";)ga(ca),Sa=new Hi("and","and",[Sa,Da(ca)]);return Sa}function Da(ca){for(var Sa=va(ca);ca.token==="|";)ga(ca),Sa=new Hi("|","bitOr",[Sa,va(ca)]);return Sa}function va(ca){for(var Sa=Ca(ca);ca.token==="^|";)ga(ca),Sa=new Hi("^|","bitXor",[Sa,Ca(ca)]);return Sa}function Ca(ca){for(var Sa=ya(ca);ca.token==="&";)ga(ca),Sa=new Hi("&","bitAnd",[Sa,ya(ca)]);return Sa}function ya(ca){for(var Sa=[Na(ca)],Ha=[],Za={"==":"equal","!=":"unequal","<":"smaller",">":"larger","<=":"smallerEq",">=":"largerEq"};hasOwnProperty$1(Za,ca.token);){var fs={name:ca.token,fn:Za[ca.token]};Ha.push(fs),ga(ca),Sa.push(Na(ca))}return Sa.length===1?Sa[0]:Sa.length===2?new Hi(Ha[0].name,Ha[0].fn,Sa):new Zi(Ha.map(gs=>gs.fn),Sa)}function Na(ca){for(var Sa=za(ca),Ha,Za,fs,gs={"<<":"leftShift",">>":"rightArithShift",">>>":"rightLogShift"};hasOwnProperty$1(gs,ca.token);)Ha=ca.token,Za=gs[Ha],ga(ca),fs=[Sa,za(ca)],Sa=new Hi(Ha,Za,fs);return Sa}function za(ca){for(var Sa=Ta(ca),Ha,Za,fs,gs={to:"to",in:"to"};hasOwnProperty$1(gs,ca.token);)Ha=ca.token,Za=gs[Ha],ga(ca),Ha==="in"&&"])},;".includes(ca.token)?Sa=new Hi("*","multiply",[Sa,new Xi("in")],!0):(fs=[Sa,Ta(ca)],Sa=new Hi(Ha,Za,fs));return Sa}function Ta(ca){var Sa,Ha=[];if(ca.token===":"){if(ca.conditionalLevel===ca.nestingLevel)throw os(ca,"The true-expression of a conditional operator may not be empty");Sa=new Pr(1)}else Sa=es(ca);if(ca.token===":"&&ca.conditionalLevel!==ca.nestingLevel){for(Ha.push(Sa);ca.token===":"&&Ha.length<3;)ga(ca),ca.token===")"||ca.token==="]"||ca.token===","||ca.token===""?Ha.push(new Xi("end")):Ha.push(es(ca));Sa=Ha.length===3?new Gi(Ha[0],Ha[2],Ha[1]):new Gi(Ha[0],Ha[1])}return Sa}function es(ca){for(var Sa=ts(ca),Ha,Za,fs,gs={"+":"add","-":"subtract"};hasOwnProperty$1(gs,ca.token);){Ha=ca.token,Za=gs[Ha],ga(ca);var ws=ts(ca);fs=ws.isPercentage?[Sa,new Hi("*","multiply",[Sa,ws])]:[Sa,ws],Sa=new Hi(Ha,Za,fs)}return Sa}function ts(ca){for(var Sa=Ka(ca),Ha=Sa,Za,fs,gs={"*":"multiply",".*":"dotMultiply","/":"divide","./":"dotDivide","%":"mod",mod:"mod"};hasOwnProperty$1(gs,ca.token);)Za=ca.token,fs=gs[Za],ga(ca),Ha=Ka(ca),Sa=new Hi(Za,fs,[Sa,Ha]);return Sa}function Ka(ca){for(var Sa=ps(ca),Ha=Sa;ca.tokenType===Ji.SYMBOL||ca.token==="in"&&isConstantNode(Sa)||ca.token==="in"&&isOperatorNode(Sa)&&Sa.fn==="unaryMinus"&&isConstantNode(Sa.args[0])||ca.tokenType===Ji.NUMBER&&!isConstantNode(Ha)&&(!isOperatorNode(Ha)||Ha.op==="!")||ca.token==="(";)Ha=ps(ca),Sa=new Hi("*","multiply",[Sa,Ha],!0);return Sa}function ps(ca){for(var Sa=cs(ca),Ha=Sa,Za=[];ca.token==="/"&&rule2Node(Ha);)if(Za.push(_extends({},ca)),ga(ca),ca.tokenType===Ji.NUMBER)if(Za.push(_extends({},ca)),ga(ca),ca.tokenType===Ji.SYMBOL||ca.token==="("||ca.token==="in")_extends(ca,Za.pop()),Za.pop(),Ha=cs(ca),Sa=new Hi("/","divide",[Sa,Ha]);else{Za.pop(),_extends(ca,Za.pop());break}else{_extends(ca,Za.pop());break}return Sa}function cs(ca){var Sa=xa(ca);if(ca.token==="%"){var Ha=_extends({},ca);ga(ca);try{xa(ca),_extends(ca,Ha)}catch{Sa=new Hi("/","divide",[Sa,new Pr(100)],!1,!0)}}return Sa}function xa(ca){var Sa,Ha,Za,fs={"-":"unaryMinus","+":"unaryPlus","~":"bitNot",not:"not"};return hasOwnProperty$1(fs,ca.token)?(Za=fs[ca.token],Sa=ca.token,ga(ca),Ha=[xa(ca)],new Hi(Sa,Za,Ha)):Ra(ca)}function Ra(ca){var Sa=Va(ca),Ha,Za,fs;return(ca.token==="^"||ca.token===".^")&&(Ha=ca.token,Za=Ha==="^"?"pow":"dotPow",ga(ca),fs=[Sa,xa(ca)],Sa=new Hi(Ha,Za,fs)),Sa}function Va(ca){for(var Sa=Ga(ca);ca.token==="??";)ga(ca),Sa=new Hi("??","nullish",[Sa,Ga(ca)]);return Sa}function Ga(ca){for(var Sa=as(ca),Ha,Za,fs,gs={"!":"factorial","\'":"ctranspose"};hasOwnProperty$1(gs,ca.token);)Ha=ca.token,Za=gs[Ha],ha(ca),fs=[Sa],Sa=new Hi(Ha,Za,fs),Sa=ss(ca,Sa);return Sa}function as(ca){var Sa=[];if(ca.tokenType===Ji.SYMBOL&&hasOwnProperty$1(ca.extraNodes,ca.token)){var Ha=ca.extraNodes[ca.token];if(ha(ca),ca.token==="("){if(Sa=[],Aa(ca),ha(ca),ca.token!==")")for(Sa.push(fa(ca));ca.token===",";)ha(ca),Sa.push(fa(ca));if(ca.token!==")")throw os(ca,"Parenthesis ) expected");Fa(ca),ha(ca)}return new Ha(Sa)}return rs(ca)}function rs(ca){var Sa,Ha;return ca.tokenType===Ji.SYMBOL||ca.tokenType===Ji.DELIMITER&&ca.token in na?(Ha=ca.token,ha(ca),Sa=hasOwnProperty$1(ra,Ha)?new Pr(ra[Ha]):ia.includes(Ha)?new Pr(F(Ha,"number")):new Xi(Ha),Sa=ss(ca,Sa),Sa):ms(ca)}function ss(ca,Sa,Ha){for(var Za;;){var fs=!1;ca.token==="?."&&(fs=!0,ha(ca));var gs=(ca.token==="("||ca.token==="["||ca.token===".")&&!0;if(!(fs||gs))break;if(Za=[],ca.token==="(")if(fs||isSymbolNode(Sa)||isAccessorNode(Sa)){if(Aa(ca),ha(ca),ca.token!==")")for(Za.push(fa(ca));ca.token===",";)ha(ca),Za.push(fa(ca));if(ca.token!==")")throw os(ca,"Parenthesis ) expected");Fa(ca),ha(ca),Sa=new gi(Sa,Za,fs)}else return Sa;else if(ca.token==="["){if(Aa(ca),ha(ca),ca.token!=="]")for(Za.push(fa(ca));ca.token===",";)ha(ca),Za.push(fa(ca));if(ca.token!=="]")throw os(ca,"Parenthesis ] expected");Fa(ca),ha(ca),Sa=new $e(Sa,new qi(Za),fs)}else{if(fs||ha(ca),!(ca.tokenType===Ji.SYMBOL||ca.tokenType===Ji.DELIMITER&&ca.token in na)){var ws="Property name expected after ";throw ws+=fs?"optional chain":"dot",os(ca,ws)}Za.push(new Pr(ca.token)),ha(ca),Sa=new $e(Sa,new qi(Za,!0),fs)}}return Sa}function ms(ca){var Sa,Ha;return ca.token===\'"\'||ca.token==="\'"?(Ha=Ua(ca,ca.token),Sa=new Pr(Ha),Sa=ss(ca,Sa),Sa):Wa(ca)}function Ua(ca,Sa){for(var Ha="";aa(ca)!==""&&aa(ca)!==Sa;)if(aa(ca)==="\\\\"){pa(ca);var Za=aa(ca),fs=oa[Za];if(fs!==void 0)Ha+=fs,ca.index+=1;else if(Za==="u"){var gs=ca.expression.slice(ca.index+1,ca.index+5);if(/^[0-9A-Fa-f]{4}$/.test(gs))Ha+=String.fromCharCode(parseInt(gs,16)),ca.index+=5;else throw os(ca,`Invalid unicode character \\\\u${gs}`)}else throw os(ca,`Bad escape character \\\\${Za}`)}else Ha+=aa(ca),pa(ca);if(ha(ca),ca.token!==Sa)throw os(ca,`End of string ${Sa} expected`);return ha(ca),Ha}function Wa(ca){var Sa,Ha,Za,fs;if(ca.token==="["){if(Aa(ca),ha(ca),ca.token!=="]"){var gs=wa(ca);if(ca.token===";"){for(Za=1,Ha=[gs];ca.token===";";)ha(ca),ca.token!=="]"&&(Ha[Za]=wa(ca),Za++);if(ca.token!=="]")throw os(ca,"End of matrix ] expected");Fa(ca),ha(ca),fs=Ha[0].items.length;for(var ws=1;ws<Za;ws++)if(Ha[ws].items.length!==fs)throw ns(ca,"Column dimensions mismatch ("+Ha[ws].items.length+" !== "+fs+")");Sa=new _t(Ha)}else{if(ca.token!=="]")throw os(ca,"End of matrix ] expected");Fa(ca),ha(ca),Sa=gs}}else Fa(ca),ha(ca),Sa=new _t([]);return ss(ca,Sa)}return qa(ca)}function wa(ca){for(var Sa=[fa(ca)],Ha=1;ca.token===",";)ha(ca),ca.token!=="]"&&ca.token!==";"&&(Sa[Ha]=fa(ca),Ha++);return new _t(Sa)}function qa(ca){if(ca.token==="{"){Aa(ca);var Sa,Ha={};do if(ha(ca),ca.token!=="}"){if(ca.token===\'"\'||ca.token==="\'")Sa=Ua(ca,ca.token);else if(ca.tokenType===Ji.SYMBOL||ca.tokenType===Ji.DELIMITER&&ca.token in na)Sa=ca.token,ha(ca);else throw os(ca,"Symbol or string expected as object key");if(ca.token!==":")throw os(ca,"Colon : expected after object key");ha(ca),Ha[Sa]=fa(ca)}while(ca.token===",");if(ca.token!=="}")throw os(ca,"Comma , or bracket } expected after object value");Fa(ca),ha(ca);var Za=new zi(Ha);return Za=ss(ca,Za),Za}return ja(ca)}function ja(ca){var Sa;if(ca.tokenType===Ji.NUMBER){Sa=ca.token,ha(ca);var Ha=safeNumberType(Sa,J);return new Pr(F(Sa,Ha))}return Xa(ca)}function Xa(ca){var Sa;if(ca.token==="("){if(Aa(ca),ha(ca),Sa=fa(ca),ca.token!==")")throw os(ca,"Parenthesis ) expected");return Fa(ca),ha(ca),Sa=new Qi(Sa),Sa=ss(ca,Sa),Sa}return Ya(ca)}function Ya(ca){throw ca.token===""?os(ca,"Unexpected end of expression"):os(ca,"Value expected")}function Ja(ca){return ca.index-ca.token.length+1}function os(ca,Sa){var Ha=Ja(ca),Za=SyntaxError(Sa+" (char "+Ha+")");return Za.char=Ha,Za}function ns(ca,Sa){var Ha=Ja(ca),Za=SyntaxError(Sa+" (char "+Ha+")");return Za.char=Ha,Za}return E.addConversion({from:"string",to:"Node",convert:Ki}),Ki}),name$95="compile",dependencies$95=["typed","parse"],createCompile=factory(name$95,dependencies$95,D=>{var{typed:E,parse:F}=D;return E(name$95,{string:function(J){return F(J).compile()},"Array | Matrix":function(J){return deepMap(J,function($e){return F($e).compile()})}})}),name$94="evaluate",dependencies$94=["typed","parse"],createEvaluate=factory(name$94,dependencies$94,D=>{var{typed:E,parse:F}=D;return E(name$94,{string:function(J){var $e=createEmptyMap();return F(J).compile().evaluate($e)},"string, Map | Object":function(J,$e){return F(J).compile().evaluate($e)},"Array | Matrix":function(J){var $e=createEmptyMap();return deepMap(J,function(_t){return F(_t).compile().evaluate($e)})},"Array | Matrix, Map | Object":function(J,$e){return deepMap(J,function(_t){return F(_t).compile().evaluate($e)})}})}),name$93="Parser",dependencies$93=["evaluate","parse"],createParserClass=factory(name$93,dependencies$93,D=>{var{evaluate:E,parse:F}=D;function J(){if(!(this instanceof J))throw SyntaxError("Constructor must be called with the new operator");Object.defineProperty(this,"scope",{value:createEmptyMap(),writable:!1})}J.prototype.type="Parser",J.prototype.isParser=!0,J.prototype.evaluate=function(_t){return E(_t,this.scope)},J.prototype.get=function(_t){if(this.scope.has(_t))return this.scope.get(_t)},J.prototype.getAll=function(){return toObject(this.scope)},J.prototype.getAllAsMap=function(){return this.scope};function $e(_t){if(_t.length===0)return!1;for(var lr=0;lr<_t.length;lr++){var mr=_t.charAt(lr-1),Or=_t.charAt(lr),Pr=_t.charAt(lr+1);if(!(F.isAlpha(Or,mr,Pr)||lr>0&&F.isDigit(Or)))return!1}return!0}return J.prototype.set=function(_t,lr){if(!$e(_t))throw Error(`Invalid variable name: \'${_t}\'. Variable names must follow the specified rules.`);return this.scope.set(_t,lr),lr},J.prototype.remove=function(_t){this.scope.delete(_t)},J.prototype.clear=function(){this.scope.clear()},J.prototype.toJSON=function(){var _t={mathjs:"Parser",variables:{},functions:{}};for(var[lr,mr]of this.scope)if(isFunction$1(mr)){if(!isExpressionFunction(mr))throw Error(`Cannot serialize external function ${lr}`);_t.functions[lr]=`${mr.syntax} = ${mr.expr}`}else _t.variables[lr]=mr;return _t},J.fromJSON=function(_t){var lr=new J;return Object.entries(_t.variables).forEach(mr=>{var[Or,Pr]=mr;return lr.set(Or,Pr)}),Object.entries(_t.functions).forEach(mr=>{var[Or,Pr]=mr;return lr.evaluate(Pr)}),lr},J},{isClass:!0});function isExpressionFunction(D){return typeof D=="function"&&typeof D.syntax=="string"&&typeof D.expr=="string"}var name$92="parser",dependencies$92=["typed","Parser"],createParser=factory(name$92,dependencies$92,D=>{var{typed:E,Parser:F}=D;return E(name$92,{"":function(){return new F}})}),name$91="lup",dependencies$91=["typed","matrix","abs","addScalar","divideScalar","multiplyScalar","subtractScalar","larger","equalScalar","unaryMinus","DenseMatrix","SparseMatrix","Spa"],createLup=factory(name$91,dependencies$91,D=>{var{typed:E,matrix:F,abs:J,addScalar:$e,divideScalar:_t,multiplyScalar:lr,subtractScalar:mr,larger:Or,equalScalar:Pr,unaryMinus:dn,DenseMatrix:gi,SparseMatrix:qi,Spa:zi}=D;return E(name$91,{DenseMatrix:function(Gi){return Hi(Gi)},SparseMatrix:function(Gi){return Qi(Gi)},Array:function(Gi){var Zi=Hi(F(Gi));return{L:Zi.L.valueOf(),U:Zi.U.valueOf(),p:Zi.p}}});function Hi(Gi){var Zi=Gi._size[0],Xi=Gi._size[1],Ki=Math.min(Zi,Xi),ea=clone$3(Gi._data),Ji=[],ta=[Zi,Ki],na=[],ra=[Ki,Xi],ia,oa,ua,sa=[];for(ia=0;ia<Zi;ia++)sa[ia]=ia;for(oa=0;oa<Xi;oa++){if(oa>0)for(ia=0;ia<Zi;ia++){var aa=Math.min(ia,oa),pa=0;for(ua=0;ua<aa;ua++)pa=$e(pa,lr(ea[ia][ua],ea[ua][oa]));ea[ia][oa]=mr(ea[ia][oa],pa)}var ma=oa,la=0,ha=0;for(ia=oa;ia<Zi;ia++){var ga=ea[ia][oa],Aa=J(ga);Or(Aa,la)&&(ma=ia,la=Aa,ha=ga)}if(oa!==ma&&(sa[oa]=[sa[ma],sa[ma]=sa[oa]][0],gi._swapRows(oa,ma,ea)),oa<Zi)for(ia=oa+1;ia<Zi;ia++){var Fa=ea[ia][oa];Pr(Fa,0)||(ea[ia][oa]=_t(ea[ia][oa],ha))}}for(oa=0;oa<Xi;oa++)for(ia=0;ia<Zi;ia++){if(oa===0&&(ia<Xi&&(na[ia]=[]),Ji[ia]=[]),ia<oa){ia<Xi&&(na[ia][oa]=ea[ia][oa]),oa<Zi&&(Ji[ia][oa]=0);continue}if(ia===oa){ia<Xi&&(na[ia][oa]=ea[ia][oa]),oa<Zi&&(Ji[ia][oa]=1);continue}ia<Xi&&(na[ia][oa]=0),oa<Zi&&(Ji[ia][oa]=ea[ia][oa])}var $a=new gi({data:Ji,size:ta}),_a=new gi({data:na,size:ra}),fa=[];for(ia=0,Ki=sa.length;ia<Ki;ia++)fa[sa[ia]]=ia;return{L:$a,U:_a,p:fa,toString:function(){return"L: "+this.L.toString()+`\nU: `+this.U.toString()+`\nP: `+this.p}}}function Qi(Gi){var Zi=Gi._size[0],Xi=Gi._size[1],Ki=Math.min(Zi,Xi),ea=Gi._values,Ji=Gi._index,ta=Gi._ptr,na=[],ra=[],ia=[],oa=[Zi,Ki],ua=[],sa=[],aa=[],pa=[Ki,Xi],ma,la,ha,ga=[],Aa=[];for(ma=0;ma<Zi;ma++)ga[ma]=ma,Aa[ma]=ma;var Fa=function(_a,fa){var ka=Aa[_a],ba=Aa[fa];ga[ka]=fa,ga[ba]=_a,Aa[_a]=ba,Aa[fa]=ka},$a=function(){var _a=new zi;la<Zi&&(ia.push(na.length),na.push(1),ra.push(la)),aa.push(ua.length);var fa=ta[la],ka=ta[la+1];for(ha=fa;ha<ka;ha++)ma=Ji[ha],_a.set(ga[ma],ea[ha]);la>0&&_a.forEach(0,la-1,function(Da,va){qi._forEachRow(Da,na,ra,ia,function(Ca,ya){Ca>Da&&_a.accumulate(Ca,dn(lr(ya,va)))})});var ba=la,Pa=_a.get(la),Ia=J(Pa);_a.forEach(la+1,Zi-1,function(Da,va){var Ca=J(va);Or(Ca,Ia)&&(ba=Da,Ia=Ca,Pa=va)}),la!==ba&&(qi._swapRows(la,ba,oa[1],na,ra,ia),qi._swapRows(la,ba,pa[1],ua,sa,aa),_a.swap(la,ba),Fa(la,ba)),_a.forEach(0,Zi-1,function(Da,va){Da<=la?(ua.push(va),sa.push(Da)):(va=_t(va,Pa),Pr(va,0)||(na.push(va),ra.push(Da)))})};for(la=0;la<Xi;la++)$a();return aa.push(ua.length),ia.push(na.length),{L:new qi({values:na,index:ra,ptr:ia,size:oa}),U:new qi({values:ua,index:sa,ptr:aa,size:pa}),p:ga,toString:function(){return"L: "+this.L.toString()+`\nU: `+this.U.toString()+`\nP: `+this.p}}}}),name$90="qr",dependencies$90=["typed","matrix","zeros","identity","isZero","equal","sign","sqrt","conj","unaryMinus","addScalar","divideScalar","multiplyScalar","subtractScalar","complex"],createQr=factory(name$90,dependencies$90,D=>{var{typed:E,matrix:F,zeros:J,identity:$e,isZero:_t,equal:lr,sign:mr,sqrt:Or,conj:Pr,unaryMinus:dn,addScalar:gi,divideScalar:qi,multiplyScalar:zi,subtractScalar:Hi,complex:Qi}=D;return _extends(E(name$90,{DenseMatrix:function(Ki){return Zi(Ki)},SparseMatrix:function(Ki){return Xi()},Array:function(Ki){var ea=Zi(F(Ki));return{Q:ea.Q.valueOf(),R:ea.R.valueOf()}}}),{_denseQRimpl:Gi});function Gi(Ki){var ea=Ki._size[0],Ji=Ki._size[1],ta=$e([ea],"dense"),na=ta._data,ra=Ki.clone(),ia=ra._data,oa,ua,sa,aa=J([ea],"");for(sa=0;sa<Math.min(Ji,ea);++sa){var pa=ia[sa][sa],ma=dn(lr(pa,0)?1:mr(pa)),la=Pr(ma),ha=0;for(oa=sa;oa<ea;oa++)ha=gi(ha,zi(ia[oa][sa],Pr(ia[oa][sa])));var ga=zi(ma,Or(ha));if(!_t(ga)){var Aa=Hi(pa,ga);for(aa[sa]=1,oa=sa+1;oa<ea;oa++)aa[oa]=qi(ia[oa][sa],Aa);var Fa=dn(Pr(qi(Aa,ga))),$a=void 0;for(ua=sa;ua<Ji;ua++){for($a=0,oa=sa;oa<ea;oa++)$a=gi($a,zi(Pr(aa[oa]),ia[oa][ua]));for($a=zi($a,Fa),oa=sa;oa<ea;oa++)ia[oa][ua]=zi(Hi(ia[oa][ua],zi(aa[oa],$a)),la)}for(oa=0;oa<ea;oa++){for($a=0,ua=sa;ua<ea;ua++)$a=gi($a,zi(na[oa][ua],aa[ua]));for($a=zi($a,Fa),ua=sa;ua<ea;++ua)na[oa][ua]=qi(Hi(na[oa][ua],zi($a,Pr(aa[ua]))),la)}}}return{Q:ta,R:ra,toString:function(){return"Q: "+this.Q.toString()+`\nR: `+this.R.toString()}}}function Zi(Ki){var ea=Gi(Ki),Ji=ea.R._data;if(Ki._data.length>0)for(var ta=Ji[0][0].type==="Complex"?Qi(0):0,na=0;na<Ji.length;++na)for(var ra=0;ra<na&&ra<(Ji[0]||[]).length;++ra)Ji[na][ra]=ta;return ea}function Xi(Ki){throw Error("qr not implemented for sparse matrices yet")}});function csPermute(D,E,F,J){for(var $e=D._values,_t=D._index,lr=D._ptr,mr=D._size,Or=D._datatype,Pr=mr[0],dn=mr[1],gi=null,qi=[],zi=[],Hi=0,Qi=0;Qi<dn;Qi++){zi[Qi]=Hi;for(var Gi=F?F[Qi]:Qi,Zi=lr[Gi],Xi=lr[Gi+1],Ki=Zi;Ki<Xi;Ki++)qi[Hi]=_t[Ki],gi&&(gi[Hi]=$e[Ki]),Hi++}return zi[dn]=Hi,D.createSparseMatrix({values:gi,index:qi,ptr:zi,size:[Pr,dn],datatype:Or})}function csTdfs(D,E,F,J,$e,_t,lr){var mr=0;for(F[lr]=D;mr>=0;){var Or=F[lr+mr],Pr=F[J+Or];Pr===-1?(mr--,_t[E++]=Or):(F[J+Or]=F[$e+Pr],++mr,F[lr+mr]=Pr)}return E}function csPost(D,E){if(!D)return null;var F=0,J,$e=[],_t=[],lr=0,mr=E,Or=2*E;for(J=0;J<E;J++)_t[lr+J]=-1;for(J=E-1;J>=0;J--)D[J]!==-1&&(_t[mr+J]=_t[lr+D[J]],_t[lr+D[J]]=J);for(J=0;J<E;J++)D[J]===-1&&(F=csTdfs(J,F,_t,lr,mr,$e,Or));return $e}function csEtree(D,E){if(!D)return null;var F=D._index,J=D._ptr,$e=D._size,_t=$e[0],lr=$e[1],mr=[],Or=[],Pr=0,dn=lr,gi,qi;for(gi=0;gi<_t;gi++)Or[dn+gi]=-1;for(var zi=0;zi<lr;zi++){mr[zi]=-1,Or[Pr+zi]=-1;for(var Hi=J[zi],Qi=J[zi+1],Gi=Hi;Gi<Qi;Gi++){var Zi=F[Gi];for(gi=Or[dn+Zi];gi!==-1&&gi<zi;gi=qi)qi=Or[Pr+gi],Or[Pr+gi]=zi,qi===-1&&(mr[gi]=zi);Or[dn+Zi]=zi}}return mr}function csFkeep(D,E,F){for(var J=D._values,$e=D._index,_t=D._ptr,lr=D._size[1],mr=0,Or=0;Or<lr;Or++){var Pr=_t[Or];for(_t[Or]=mr;Pr<_t[Or+1];Pr++)E($e[Pr],Or,J?J[Pr]:1,F)&&($e[mr]=$e[Pr],J&&(J[mr]=J[Pr]),mr++)}return _t[lr]=mr,$e.splice(mr,$e.length-mr),J&&J.splice(mr,J.length-mr),mr}function csFlip(D){return-D-2}var name$89="csAmd",dependencies$89=["add","multiply","transpose"],createCsAmd=factory(name$89,dependencies$89,D=>{var{add:E,multiply:F,transpose:J}=D;return function(Pr,dn){if(!dn||Pr<=0||Pr>3)return null;var gi=dn._size,qi=gi[0],zi=gi[1],Hi=0,Qi=Math.max(16,10*Math.sqrt(zi));Qi=Math.min(zi-2,Qi);var Gi=$e(Pr,dn,qi,zi,Qi);csFkeep(Gi,Or,null);for(var Zi=Gi._index,Xi=Gi._ptr,Ki=Xi[zi],ea=[],Ji=[],ta=0,na=zi+1,ra=2*(zi+1),ia=3*(zi+1),oa=4*(zi+1),ua=5*(zi+1),sa=6*(zi+1),aa=7*(zi+1),pa=ea,ma=_t(zi,Xi,Ji,ta,ia,pa,ra,aa,na,sa,oa,ua),la=lr(zi,Xi,Ji,ua,oa,sa,Qi,na,ia,pa,ra),ha=0,ga,Aa,Fa,$a,_a,fa,ka,ba,Pa,Ia,Da,va,Ca,ya,Na,za;la<zi;){for(Fa=-1;ha<zi&&(Fa=Ji[ia+ha])===-1;ha++);Ji[ra+Fa]!==-1&&(pa[Ji[ra+Fa]]=-1),Ji[ia+ha]=Ji[ra+Fa];var Ta=Ji[oa+Fa],es=Ji[na+Fa];la+=es;var ts=0;Ji[na+Fa]=-es;var Ka=Xi[Fa],ps=Ta===0?Ka:Ki,cs=ps;for($a=1;$a<=Ta+1;$a++){for($a>Ta?(fa=Fa,ka=Ka,ba=Ji[ta+Fa]-Ta):(fa=Zi[Ka++],ka=Xi[fa],ba=Ji[ta+fa]),_a=1;_a<=ba;_a++)ga=Zi[ka++],!((Pa=Ji[na+ga])<=0)&&(ts+=Pa,Ji[na+ga]=-Pa,Zi[cs++]=ga,Ji[ra+ga]!==-1&&(pa[Ji[ra+ga]]=pa[ga]),pa[ga]===-1?Ji[ia+Ji[ua+ga]]=Ji[ra+ga]:Ji[ra+pa[ga]]=Ji[ra+ga]);fa!==Fa&&(Xi[fa]=csFlip(Fa),Ji[sa+fa]=0)}for(Ta!==0&&(Ki=cs),Ji[ua+Fa]=ts,Xi[Fa]=ps,Ji[ta+Fa]=cs-ps,Ji[oa+Fa]=-2,ma=mr(ma,Hi,Ji,sa,zi),Ia=ps;Ia<cs;Ia++)if(ga=Zi[Ia],!((Da=Ji[oa+ga])<=0)){Pa=-Ji[na+ga];var xa=ma-Pa;for(Ka=Xi[ga],va=Xi[ga]+Da-1;Ka<=va;Ka++)fa=Zi[Ka],Ji[sa+fa]>=ma?Ji[sa+fa]-=Pa:Ji[sa+fa]!==0&&(Ji[sa+fa]=Ji[ua+fa]+xa)}for(Ia=ps;Ia<cs;Ia++){for(ga=Zi[Ia],va=Xi[ga],Ca=va+Ji[oa+ga]-1,ya=va,Na=0,za=0,Ka=va;Ka<=Ca;Ka++)if(fa=Zi[Ka],Ji[sa+fa]!==0){var Ra=Ji[sa+fa]-ma;Ra>0?(za+=Ra,Zi[ya++]=fa,Na+=fa):(Xi[fa]=csFlip(Fa),Ji[sa+fa]=0)}Ji[oa+ga]=ya-va+1;var Va=ya,Ga=va+Ji[ta+ga];for(Ka=Ca+1;Ka<Ga;Ka++){Aa=Zi[Ka];var as=Ji[na+Aa];as<=0||(za+=as,Zi[ya++]=Aa,Na+=Aa)}za===0?(Xi[ga]=csFlip(Fa),Pa=-Ji[na+ga],ts-=Pa,es+=Pa,la+=Pa,Ji[na+ga]=0,Ji[oa+ga]=-1):(Ji[ua+ga]=Math.min(Ji[ua+ga],za),Zi[ya]=Zi[Va],Zi[Va]=Zi[va],Zi[va]=Fa,Ji[ta+ga]=ya-va+1,Na=(Na<0?-Na:Na)%zi,Ji[ra+ga]=Ji[aa+Na],Ji[aa+Na]=ga,pa[ga]=Na)}for(Ji[ua+Fa]=ts,Hi=Math.max(Hi,ts),ma=mr(ma+Hi,Hi,Ji,sa,zi),Ia=ps;Ia<cs;Ia++)if(ga=Zi[Ia],!(Ji[na+ga]>=0))for(Na=pa[ga],ga=Ji[aa+Na],Ji[aa+Na]=-1;ga!==-1&&Ji[ra+ga]!==-1;ga=Ji[ra+ga],ma++){for(ba=Ji[ta+ga],Da=Ji[oa+ga],Ka=Xi[ga]+1;Ka<=Xi[ga]+ba-1;Ka++)Ji[sa+Zi[Ka]]=ma;var rs=ga;for(Aa=Ji[ra+ga];Aa!==-1;){var ss=Ji[ta+Aa]===ba&&Ji[oa+Aa]===Da;for(Ka=Xi[Aa]+1;ss&&Ka<=Xi[Aa]+ba-1;Ka++)Ji[sa+Zi[Ka]]!==ma&&(ss=0);ss?(Xi[Aa]=csFlip(ga),Ji[na+ga]+=Ji[na+Aa],Ji[na+Aa]=0,Ji[oa+Aa]=-1,Aa=Ji[ra+Aa],Ji[ra+rs]=Aa):(rs=Aa,Aa=Ji[ra+Aa])}}for(Ka=ps,Ia=ps;Ia<cs;Ia++)ga=Zi[Ia],!((Pa=-Ji[na+ga])<=0)&&(Ji[na+ga]=Pa,za=Ji[ua+ga]+ts-Pa,za=Math.min(za,zi-la-Pa),Ji[ia+za]!==-1&&(pa[Ji[ia+za]]=ga),Ji[ra+ga]=Ji[ia+za],pa[ga]=-1,Ji[ia+za]=ga,ha=Math.min(ha,za),Ji[ua+ga]=za,Zi[Ka++]=ga);Ji[na+Fa]=es,(Ji[ta+Fa]=Ka-ps)===0&&(Xi[Fa]=-1,Ji[sa+Fa]=0),Ta!==0&&(Ki=Ka)}for(ga=0;ga<zi;ga++)Xi[ga]=csFlip(Xi[ga]);for(Aa=0;Aa<=zi;Aa++)Ji[ia+Aa]=-1;for(Aa=zi;Aa>=0;Aa--)Ji[na+Aa]>0||(Ji[ra+Aa]=Ji[ia+Xi[Aa]],Ji[ia+Xi[Aa]]=Aa);for(fa=zi;fa>=0;fa--)Ji[na+fa]<=0||Xi[fa]!==-1&&(Ji[ra+fa]=Ji[ia+Xi[fa]],Ji[ia+Xi[fa]]=fa);for(Fa=0,ga=0;ga<=zi;ga++)Xi[ga]===-1&&(Fa=csTdfs(ga,Fa,Ji,ia,ra,ea,sa));return ea.splice(ea.length-1,1),ea};function $e(Pr,dn,gi,qi,zi){var Hi=J(dn);if(Pr===1&&qi===gi)return E(dn,Hi);if(Pr===2){for(var Qi=Hi._index,Gi=Hi._ptr,Zi=0,Xi=0;Xi<gi;Xi++){var Ki=Gi[Xi];if(Gi[Xi]=Zi,!(Gi[Xi+1]-Ki>zi))for(var ea=Gi[Xi+1];Ki<ea;Ki++)Qi[Zi++]=Qi[Ki]}return Gi[gi]=Zi,dn=J(Hi),F(Hi,dn)}return F(Hi,dn)}function _t(Pr,dn,gi,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki,ea){for(var Ji=0;Ji<Pr;Ji++)gi[qi+Ji]=dn[Ji+1]-dn[Ji];gi[qi+Pr]=0;for(var ta=0;ta<=Pr;ta++)gi[zi+ta]=-1,Hi[ta]=-1,gi[Qi+ta]=-1,gi[Gi+ta]=-1,gi[Zi+ta]=1,gi[Xi+ta]=1,gi[Ki+ta]=0,gi[ea+ta]=gi[qi+ta];var na=mr(0,0,gi,Xi,Pr);return gi[Ki+Pr]=-2,dn[Pr]=-1,gi[Xi+Pr]=0,na}function lr(Pr,dn,gi,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki){for(var ea=0,Ji=0;Ji<Pr;Ji++){var ta=gi[qi+Ji];if(ta===0)gi[zi+Ji]=-2,ea++,dn[Ji]=-1,gi[Hi+Ji]=0;else if(ta>Qi)gi[Gi+Ji]=0,gi[zi+Ji]=-1,ea++,dn[Ji]=csFlip(Pr),gi[Gi+Pr]++;else{var na=gi[Zi+ta];na!==-1&&(Xi[na]=Ji),gi[Ki+Ji]=gi[Zi+ta],gi[Zi+ta]=Ji}}return ea}function mr(Pr,dn,gi,qi,zi){if(Pr<2||Pr+dn<0){for(var Hi=0;Hi<zi;Hi++)gi[qi+Hi]!==0&&(gi[qi+Hi]=1);Pr=2}return Pr}function Or(Pr,dn){return Pr!==dn}});function csLeaf(D,E,F,J,$e,_t,lr){var mr,Or,Pr=0,dn;if(D<=E||F[J+E]<=F[$e+D])return-1;F[$e+D]=F[J+E];var gi=F[_t+D];if(F[_t+D]=E,gi===-1)Pr=1,dn=D;else{for(Pr=2,dn=gi;dn!==F[lr+dn];dn=F[lr+dn]);for(mr=gi;mr!==dn;mr=Or)Or=F[lr+mr],F[lr+mr]=dn}return{jleaf:Pr,q:dn}}var name$88="csCounts",dependencies$88=["transpose"],createCsCounts=factory(name$88,dependencies$88,D=>{var{transpose:E}=D;return function(F,J,$e,_t){if(!F||!J||!$e)return null;var lr=F._size,mr=lr[0],Or=lr[1],Pr,dn,gi,qi,zi,Hi,Qi,Gi=4*Or+(_t?Or+mr+1:0),Zi=[],Xi=0,Ki=Or,ea=2*Or,Ji=3*Or,ta=4*Or,na=5*Or+1;for(gi=0;gi<Gi;gi++)Zi[gi]=-1;var ra=[],ia=E(F),oa=ia._index,ua=ia._ptr;for(gi=0;gi<Or;gi++)for(dn=$e[gi],ra[dn]=+(Zi[Ji+dn]===-1);dn!==-1&&Zi[Ji+dn]===-1;dn=J[dn])Zi[Ji+dn]=gi;if(_t){for(gi=0;gi<Or;gi++)Zi[$e[gi]]=gi;for(Pr=0;Pr<mr;Pr++){for(gi=Or,Hi=ua[Pr],Qi=ua[Pr+1],zi=Hi;zi<Qi;zi++)gi=Math.min(gi,Zi[oa[zi]]);Zi[na+Pr]=Zi[ta+gi],Zi[ta+gi]=Pr}}for(Pr=0;Pr<Or;Pr++)Zi[Xi+Pr]=Pr;for(gi=0;gi<Or;gi++){for(dn=$e[gi],J[dn]!==-1&&ra[J[dn]]--,qi=_t?Zi[ta+gi]:dn;qi!==-1;qi=_t?Zi[na+qi]:-1)for(zi=ua[qi];zi<ua[qi+1];zi++){Pr=oa[zi];var sa=csLeaf(Pr,dn,Zi,Ji,Ki,ea,Xi);sa.jleaf>=1&&ra[dn]++,sa.jleaf===2&&ra[sa.q]--}J[dn]!==-1&&(Zi[Xi+dn]=J[dn])}for(dn=0;dn<Or;dn++)J[dn]!==-1&&(ra[J[dn]]+=ra[dn]);return ra}}),name$87="csSqr",dependencies$87=["add","multiply","transpose"],createCsSqr=factory(name$87,dependencies$87,D=>{var{add:E,multiply:F,transpose:J}=D,$e=createCsAmd({add:E,multiply:F,transpose:J}),_t=createCsCounts({transpose:J});return function(mr,Or,Pr){var dn=Or._ptr,gi=Or._size[1],qi,zi={};if(zi.q=$e(mr,Or),mr&&!zi.q)return null;if(Pr){var Hi=mr?csPermute(Or,null,zi.q):Or;zi.parent=csEtree(Hi);var Qi=csPost(zi.parent,gi);if(zi.cp=_t(Hi,zi.parent,Qi,1),Hi&&zi.parent&&zi.cp&&lr(Hi,zi))for(zi.unz=0,qi=0;qi<gi;qi++)zi.unz+=zi.cp[qi]}else zi.unz=4*dn[gi]+gi,zi.lnz=zi.unz;return zi};function lr(mr,Or){var Pr=mr._ptr,dn=mr._index,gi=mr._size,qi=gi[0],zi=gi[1];Or.pinv=[],Or.leftmost=[];var Hi=Or.parent,Qi=Or.pinv,Gi=Or.leftmost,Zi=[],Xi=0,Ki=qi,ea=qi+zi,Ji=qi+2*zi,ta,na,ra,ia,oa;for(na=0;na<zi;na++)Zi[Ki+na]=-1,Zi[ea+na]=-1,Zi[Ji+na]=0;for(ta=0;ta<qi;ta++)Gi[ta]=-1;for(na=zi-1;na>=0;na--)for(ia=Pr[na],oa=Pr[na+1],ra=ia;ra<oa;ra++)Gi[dn[ra]]=na;for(ta=qi-1;ta>=0;ta--)Qi[ta]=-1,na=Gi[ta],na!==-1&&(Zi[Ji+na]++===0&&(Zi[ea+na]=ta),Zi[Xi+ta]=Zi[Ki+na],Zi[Ki+na]=ta);for(Or.lnz=0,Or.m2=qi,na=0;na<zi;na++)if(ta=Zi[Ki+na],Or.lnz++,ta<0&&(ta=Or.m2++),Qi[ta]=na,!(--Ji[na]<=0)){Or.lnz+=Zi[Ji+na];var ua=Hi[na];ua!==-1&&(Zi[Ji+ua]===0&&(Zi[ea+ua]=Zi[ea+na]),Zi[Xi+Zi[ea+na]]=Zi[Ki+ua],Zi[Ki+ua]=Zi[Xi+ta],Zi[Ji+ua]+=Zi[Ji+na])}for(ta=0;ta<qi;ta++)Qi[ta]<0&&(Qi[ta]=na++);return!0}});function csMarked(D,E){return D[E]<0}function csMark(D,E){D[E]=csFlip(D[E])}function csUnflip(D){return D<0?csFlip(D):D}function csDfs(D,E,F,J,$e){var _t=E._index,lr=E._ptr,mr=E._size[1],Or,Pr,dn,gi=0;for(J[0]=D;gi>=0;){D=J[gi];var qi=$e?$e[D]:D;csMarked(lr,D)||(csMark(lr,D),J[mr+gi]=qi<0?0:csUnflip(lr[qi]));var zi=1;for(Pr=J[mr+gi],dn=qi<0?0:csUnflip(lr[qi+1]);Pr<dn;Pr++)if(Or=_t[Pr],!csMarked(lr,Or)){J[mr+gi]=Pr,J[++gi]=Or,zi=0;break}zi&&(gi--,J[--F]=D)}return F}function csReach(D,E,F,J,$e){var _t=D._ptr,lr=D._size,mr=E._index,Or=E._ptr,Pr=lr[1],dn,gi,qi,zi=Pr;for(gi=Or[F],qi=Or[F+1],dn=gi;dn<qi;dn++){var Hi=mr[dn];csMarked(_t,Hi)||(zi=csDfs(Hi,D,zi,J,$e))}for(dn=zi;dn<Pr;dn++)csMark(_t,J[dn]);return zi}var name$86="csSpsolve",dependencies$86=["divideScalar","multiply","subtract"],createCsSpsolve=factory(name$86,dependencies$86,D=>{var{divideScalar:E,multiply:F,subtract:J}=D;return function($e,_t,lr,mr,Or,Pr,dn){var gi=$e._values,qi=$e._index,zi=$e._ptr,Hi=$e._size[1],Qi=_t._values,Gi=_t._index,Zi=_t._ptr,Xi,Ki,ea,Ji,ta=csReach($e,_t,lr,mr,Pr);for(Xi=ta;Xi<Hi;Xi++)Or[mr[Xi]]=0;for(Ki=Zi[lr],ea=Zi[lr+1],Xi=Ki;Xi<ea;Xi++)Or[Gi[Xi]]=Qi[Xi];for(var na=ta;na<Hi;na++){var ra=mr[na],ia=Pr?Pr[ra]:ra;if(!(ia<0))for(Ki=zi[ia],ea=zi[ia+1],Or[ra]=E(Or[ra],gi[dn?Ki:ea-1]),Xi=dn?Ki+1:Ki,Ji=dn?ea:ea-1;Xi<Ji;Xi++){var oa=qi[Xi];Or[oa]=J(Or[oa],F(gi[Xi],Or[ra]))}}return ta}}),name$85="csLu",dependencies$85=["abs","divideScalar","multiply","subtract","larger","largerEq","SparseMatrix"],createCsLu=factory(name$85,dependencies$85,D=>{var{abs:E,divideScalar:F,multiply:J,subtract:$e,larger:_t,largerEq:lr,SparseMatrix:mr}=D,Or=createCsSpsolve({divideScalar:F,multiply:J,subtract:$e});return function(Pr,dn,gi){if(!Pr)return null;var qi=Pr._size[1],zi,Hi=100,Qi=100;dn&&(zi=dn.q,Hi=dn.lnz||Hi,Qi=dn.unz||Qi);var Gi=[],Zi=[],Xi=[],Ki=new mr({values:Gi,index:Zi,ptr:Xi,size:[qi,qi]}),ea=[],Ji=[],ta=[],na=new mr({values:ea,index:Ji,ptr:ta,size:[qi,qi]}),ra=[],ia,oa,ua=[],sa=[];for(ia=0;ia<qi;ia++)ua[ia]=0,ra[ia]=-1,Xi[ia+1]=0;Hi=0,Qi=0;for(var aa=0;aa<qi;aa++){Xi[aa]=Hi,ta[aa]=Qi;var pa=zi?zi[aa]:aa,ma=Or(Ki,Pr,pa,sa,ua,ra,1),la=-1,ha=-1;for(oa=ma;oa<qi;oa++)if(ia=sa[oa],ra[ia]<0){var ga=E(ua[ia]);_t(ga,ha)&&(ha=ga,la=ia)}else Ji[Qi]=ra[ia],ea[Qi++]=ua[ia];if(la===-1||ha<=0)return null;ra[pa]<0&&lr(E(ua[pa]),J(ha,gi))&&(la=pa);var Aa=ua[la];for(Ji[Qi]=aa,ea[Qi++]=Aa,ra[la]=aa,Zi[Hi]=la,Gi[Hi++]=1,oa=ma;oa<qi;oa++)ia=sa[oa],ra[ia]<0&&(Zi[Hi]=ia,Gi[Hi++]=F(ua[ia],Aa)),ua[ia]=0}for(Xi[qi]=Hi,ta[qi]=Qi,oa=0;oa<Hi;oa++)Zi[oa]=ra[Zi[oa]];return Gi.splice(Hi,Gi.length-Hi),Zi.splice(Hi,Zi.length-Hi),ea.splice(Qi,ea.length-Qi),Ji.splice(Qi,Ji.length-Qi),{L:Ki,U:na,pinv:ra}}}),name$84="slu",dependencies$84=["typed","abs","add","multiply","transpose","divideScalar","subtract","larger","largerEq","SparseMatrix"],createSlu=factory(name$84,dependencies$84,D=>{var{typed:E,abs:F,add:J,multiply:$e,transpose:_t,divideScalar:lr,subtract:mr,larger:Or,largerEq:Pr,SparseMatrix:dn}=D,gi=createCsSqr({add:J,multiply:$e,transpose:_t}),qi=createCsLu({abs:F,divideScalar:lr,multiply:$e,subtract:mr,larger:Or,largerEq:Pr,SparseMatrix:dn});return E(name$84,{"SparseMatrix, number, number":function(zi,Hi,Qi){if(!isInteger(Hi)||Hi<0||Hi>3)throw Error("Symbolic Ordering and Analysis order must be an integer number in the interval [0, 3]");if(Qi<0||Qi>1)throw Error("Partial pivoting threshold must be a number from 0 to 1");var Gi=gi(Hi,zi,!1),Zi=qi(zi,Gi,Qi);return{L:Zi.L,U:Zi.U,p:Zi.pinv,q:Gi.q,toString:function(){return"L: "+this.L.toString()+`\nU: `+this.U.toString()+`\np: `+this.p.toString()+(this.q?`\nq: `+this.q.toString():"")+`\n`}}}})});function csIpvec(D,E){var F,J=E.length,$e=[];if(D)for(F=0;F<J;F++)$e[D[F]]=E[F];else for(F=0;F<J;F++)$e[F]=E[F];return $e}var name$83="lusolve",dependencies$83=["typed","matrix","lup","slu","usolve","lsolve","DenseMatrix"],createLusolve=factory(name$83,dependencies$83,D=>{var{typed:E,matrix:F,lup:J,slu:$e,usolve:_t,lsolve:lr,DenseMatrix:mr}=D,Or=createSolveValidation({DenseMatrix:mr});return E(name$83,{"Array, Array | Matrix":function(gi,qi){gi=F(gi);var zi=J(gi);return dn(zi.L,zi.U,zi.p,null,qi).valueOf()},"DenseMatrix, Array | Matrix":function(gi,qi){var zi=J(gi);return dn(zi.L,zi.U,zi.p,null,qi)},"SparseMatrix, Array | Matrix":function(gi,qi){var zi=J(gi);return dn(zi.L,zi.U,zi.p,null,qi)},"SparseMatrix, Array | Matrix, number, number":function(gi,qi,zi,Hi){var Qi=$e(gi,zi,Hi);return dn(Qi.L,Qi.U,Qi.p,Qi.q,qi)},"Object, Array | Matrix":function(gi,qi){return dn(gi.L,gi.U,gi.p,gi.q,qi)}});function Pr(gi){if(isMatrix(gi))return gi;if(isArray(gi))return F(gi);throw TypeError("Invalid Matrix LU decomposition")}function dn(gi,qi,zi,Hi,Qi){gi=Pr(gi),qi=Pr(qi),zi&&(Qi=Or(gi,Qi,!0),Qi._data=csIpvec(zi,Qi._data));var Gi=lr(gi,Qi),Zi=_t(qi,Gi);return Hi&&(Zi._data=csIpvec(Hi,Zi._data)),Zi}}),name$82="polynomialRoot",dependencies$82=["typed","isZero","equalScalar","add","subtract","multiply","divide","sqrt","unaryMinus","cbrt","typeOf","im","re"],createPolynomialRoot=factory(name$82,dependencies$82,D=>{var{typed:E,isZero:F,equalScalar:J,add:$e,subtract:_t,multiply:lr,divide:mr,sqrt:Or,unaryMinus:Pr,cbrt:dn,typeOf:gi,im:qi,re:zi}=D;return E(name$82,{"number|Complex, ...number|Complex":(Hi,Qi)=>{for(var Gi=[Hi,...Qi];Gi.length>0&&F(Gi[Gi.length-1]);)Gi.pop();if(Gi.length<2)throw RangeError(`Polynomial [${Hi}, ${Qi}] must have a non-zero non-constant coefficient`);switch(Gi.length){case 2:return[Pr(mr(Gi[0],Gi[1]))];case 3:var[Zi,Xi,Ki]=Gi,ea=lr(2,Ki),Ji=lr(Xi,Xi),ta=lr(4,Ki,Zi);if(J(Ji,ta))return[mr(Pr(Xi),ea)];var na=Or(_t(Ji,ta));return[mr(_t(na,Xi),ea),mr(_t(Pr(na),Xi),ea)];case 4:var[ra,ia,oa,ua]=Gi,sa=Pr(lr(3,ua)),aa=lr(oa,oa),pa=lr(3,ua,ia),ma=$e(lr(2,oa,oa,oa),lr(27,ua,ua,ra)),la=lr(9,ua,oa,ia);if(J(aa,pa)&&J(ma,la))return[mr(oa,sa)];var ha=_t(aa,pa),ga=_t(ma,la);return J($e(lr(18,ua,oa,ia,ra),lr(oa,oa,ia,ia)),$e(lr(4,oa,oa,oa,ra),lr(4,ua,ia,ia,ia),lr(27,ua,ua,ra,ra)))?[mr(_t(lr(4,ua,oa,ia),$e(lr(9,ua,ua,ra),lr(oa,oa,oa))),lr(ua,ha)),mr(_t(lr(9,ua,ra),lr(oa,ia)),lr(2,ha))]:dn(J(aa,pa)?ga:mr($e(ga,Or(_t(lr(ga,ga),lr(4,ha,ha,ha)))),2),!0).toArray().map(Aa=>mr($e(oa,Aa,mr(ha,Aa)),sa)).map(Aa=>gi(Aa)==="Complex"&&J(zi(Aa),zi(Aa)+qi(Aa))?zi(Aa):Aa);default:throw RangeError(`only implemented for cubic or lower-order polynomials, not ${Gi}`)}}})}),name$81="Help",dependencies$81=["evaluate"],createHelpClass=factory(name$81,dependencies$81,D=>{var{evaluate:E}=D;function F(J){if(!(this instanceof F))throw SyntaxError("Constructor must be called with the new operator");if(!J)throw Error(\'Argument "doc" missing\');this.doc=J}return F.prototype.type="Help",F.prototype.isHelp=!0,F.prototype.toString=function(){var J=this.doc||{},$e=`\n`;if(J.name&&($e+="Name: "+J.name+`\n\n`),J.category&&($e+="Category: "+J.category+`\n\n`),J.description&&($e+=`Description:\n    `+J.description+`\n\n`),J.syntax&&($e+=`Syntax:\n    `+J.syntax.join(`\n    `)+`\n\n`),J.examples){$e+=`Examples:\n`;for(var _t=!1,lr=E("config()"),mr={config:gi=>(_t=!0,E("config(newConfig)",{newConfig:gi}))},Or=0;Or<J.examples.length;Or++){var Pr=J.examples[Or];$e+="    "+Pr+`\n`;var dn=void 0;try{dn=E(Pr,mr)}catch(gi){dn=gi}dn!==void 0&&!isHelp(dn)&&($e+="        "+format(dn,{precision:14})+`\n`)}$e+=`\n`,_t&&E("config(originalConfig)",{originalConfig:lr})}return J.mayThrow&&J.mayThrow.length&&($e+="Throws: "+J.mayThrow.join(", ")+`\n\n`),J.seealso&&J.seealso.length&&($e+="See also: "+J.seealso.join(", ")+`\n`),$e},F.prototype.toJSON=function(){var J=clone$3(this.doc);return J.mathjs="Help",J},F.fromJSON=function(J){var $e={};return Object.keys(J).filter(_t=>_t!=="mathjs").forEach(_t=>{$e[_t]=J[_t]}),new F($e)},F.prototype.valueOf=F.prototype.toString,F},{isClass:!0}),name$80="Chain",dependencies$80=["?on","math","typed"],createChainClass=factory(name$80,dependencies$80,D=>{var{on:E,math:F,typed:J}=D;function $e(Pr){if(!(this instanceof $e))throw SyntaxError("Constructor must be called with the new operator");isChain(Pr)?this.value=Pr.value:this.value=Pr}$e.prototype.type="Chain",$e.prototype.isChain=!0,$e.prototype.done=function(){return this.value},$e.prototype.valueOf=function(){return this.value},$e.prototype.toString=function(){return format(this.value)},$e.prototype.toJSON=function(){return{mathjs:"Chain",value:this.value}},$e.fromJSON=function(Pr){return new $e(Pr.value)};function _t(Pr,dn){typeof dn=="function"&&($e.prototype[Pr]=mr(dn))}function lr(Pr,dn){lazy($e.prototype,Pr,function(){var gi=dn();if(typeof gi=="function")return mr(gi)})}function mr(Pr){return function(){if(arguments.length===0)return new $e(Pr(this.value));for(var dn=[this.value],gi=0;gi<arguments.length;gi++)dn[gi+1]=arguments[gi];if(J.isTypedFunction(Pr)){var qi=J.resolve(Pr,dn);if(qi.params.length===1)throw Error("chain function "+Pr.name+" cannot match rest parameter between chain value and additional arguments.");return new $e(qi.implementation.apply(Pr,dn))}return new $e(Pr.apply(Pr,dn))}}$e.createProxy=function(Pr,dn){if(typeof Pr=="string")_t(Pr,dn);else{var gi=function(zi){hasOwnProperty$1(Pr,zi)&&Or[zi]===void 0&&lr(zi,()=>Pr[zi])};for(var qi in Pr)gi(qi)}};var Or={expression:!0,docs:!0,type:!0,classes:!0,json:!0,error:!0,isChain:!0};return $e.createProxy(F),E&&E("import",function(Pr,dn,gi){gi||lr(Pr,dn)}),$e},{isClass:!0}),eDocs={name:"e",category:"Constants",syntax:["e"],description:"Euler\'s number, the base of the natural logarithm. Approximately equal to 2.71828",examples:["e","e ^ 2","exp(2)","log(e)"],seealso:["exp"]},falseDocs={name:"false",category:"Constants",syntax:["false"],description:"Boolean value false",examples:["false"],seealso:["true"]},iDocs={name:"i",category:"Constants",syntax:["i"],description:"Imaginary unit, defined as i*i=-1. A complex number is described as a + b*i, where a is the real part, and b is the imaginary part.",examples:["i","i * i","sqrt(-1)"],seealso:[]},InfinityDocs={name:"Infinity",category:"Constants",syntax:["Infinity"],description:"Infinity, a number which is larger than the maximum number that can be handled by a floating point number.",examples:["Infinity","1 / 0"],seealso:[]},LN10Docs={name:"LN10",category:"Constants",syntax:["LN10"],description:"Returns the natural logarithm of 10, approximately equal to 2.302",examples:["LN10","log(10)"],seealso:[]},LN2Docs={name:"LN2",category:"Constants",syntax:["LN2"],description:"Returns the natural logarithm of 2, approximately equal to 0.693",examples:["LN2","log(2)"],seealso:[]},LOG10EDocs={name:"LOG10E",category:"Constants",syntax:["LOG10E"],description:"Returns the base-10 logarithm of E, approximately equal to 0.434",examples:["LOG10E","log(e, 10)"],seealso:[]},LOG2EDocs={name:"LOG2E",category:"Constants",syntax:["LOG2E"],description:"Returns the base-2 logarithm of E, approximately equal to 1.442",examples:["LOG2E","log(e, 2)"],seealso:[]},NaNDocs={name:"NaN",category:"Constants",syntax:["NaN"],description:"Not a number",examples:["NaN","0 / 0"],seealso:[]},nullDocs={name:"null",category:"Constants",syntax:["null"],description:"Value null",examples:["null"],seealso:["true","false"]},phiDocs={name:"phi",category:"Constants",syntax:["phi"],description:"Phi is the golden ratio. Two quantities are in the golden ratio if their ratio is the same as the ratio of their sum to the larger of the two quantities. Phi is defined as `(1 + sqrt(5)) / 2` and is approximately 1.618034...",examples:["phi"],seealso:[]},piDocs={name:"pi",category:"Constants",syntax:["pi"],description:"The number pi is a mathematical constant that is the ratio of a circle\'s circumference to its diameter, and is approximately equal to 3.14159",examples:["pi","sin(pi/2)"],seealso:["tau"]},SQRT12Docs={name:"SQRT1_2",category:"Constants",syntax:["SQRT1_2"],description:"Returns the square root of 1/2, approximately equal to 0.707",examples:["SQRT1_2","sqrt(1/2)"],seealso:[]},SQRT2Docs={name:"SQRT2",category:"Constants",syntax:["SQRT2"],description:"Returns the square root of 2, approximately equal to 1.414",examples:["SQRT2","sqrt(2)"],seealso:[]},tauDocs={name:"tau",category:"Constants",syntax:["tau"],description:"Tau is the ratio constant of a circle\'s circumference to radius, equal to 2 * pi, approximately 6.2832.",examples:["tau","2 * pi"],seealso:["pi"]},trueDocs={name:"true",category:"Constants",syntax:["true"],description:"Boolean value true",examples:["true"],seealso:["false"]},versionDocs={name:"version",category:"Constants",syntax:["version"],description:"A string with the version number of math.js",examples:["version"],seealso:[]},bignumberDocs={name:"bignumber",category:"Construction",syntax:["bignumber(x)"],description:"Create a big number from a number or string.",examples:["0.1 + 0.2","bignumber(0.1) + bignumber(0.2)",\'bignumber("7.2")\',\'bignumber("7.2e500")\',"bignumber([0.1, 0.2, 0.3])"],seealso:["boolean","bigint","complex","fraction","index","matrix","string","unit"]},bigintDocs={name:"bigint",category:"Construction",syntax:["bigint(x)"],description:"Create a bigint, an integer with an arbitrary number of digits, from a number or string.",examples:["123123123123123123 # a large number will lose digits",\'bigint("123123123123123123")\',\'bignumber(["1", "3", "5"])\'],seealso:["boolean","bignumber","number","complex","fraction","index","matrix","string","unit"]},booleanDocs={name:"boolean",category:"Construction",syntax:["x","boolean(x)"],description:"Convert a string or number into a boolean.",examples:["boolean(0)","boolean(1)","boolean(3)",\'boolean("true")\',\'boolean("false")\',"boolean([1, 0, 1, 1])"],seealso:["bignumber","complex","index","matrix","number","string","unit"]},complexDocs={name:"complex",category:"Construction",syntax:["complex()","complex(re, im)","complex(string)"],description:"Create a complex number.",examples:["complex()","complex(2, 3)",\'complex("7 - 2i")\'],seealso:["bignumber","boolean","index","matrix","number","string","unit"]},createUnitDocs={name:"createUnit",category:"Construction",syntax:["createUnit(definitions)","createUnit(name, definition)"],description:"Create a user-defined unit and register it with the Unit type.",examples:[\'createUnit("foo")\',\'createUnit("knot", {definition: "0.514444444 m/s", aliases: ["knots", "kt", "kts"]})\',\'createUnit("mph", "1 mile/hour")\'],seealso:["unit","splitUnit"]},fractionDocs={name:"fraction",category:"Construction",syntax:["fraction(num)","fraction(matrix)","fraction(num,den)","fraction({n: num, d: den})"],description:"Create a fraction from a number or from integer numerator and denominator.",examples:["fraction(0.125)","fraction(1, 3) + fraction(2, 5)","fraction({n: 333, d: 53})","fraction([sqrt(9), sqrt(10), sqrt(11)])"],seealso:["bignumber","boolean","complex","index","matrix","string","unit"]},indexDocs={name:"index",category:"Construction",syntax:["[start]","[start:end]","[start:step:end]","[start1, start 2, ...]","[start1:end1, start2:end2, ...]","[start1:step1:end1, start2:step2:end2, ...]"],description:"Create an index to get or replace a subset of a matrix",examples:["A = [1, 2, 3; 4, 5, 6]","A[1, :]","A[1, 2] = 50","A[1:2, 1:2] = 1","B = [1, 2, 3]","B[B>1 and B<3]"],seealso:["bignumber","boolean","complex","matrix","number","range","string","unit"]},matrixDocs={name:"matrix",category:"Construction",syntax:["[]","[a1, b1, ...; a2, b2, ...]","matrix()",\'matrix("dense")\',"matrix([...])"],description:"Create a matrix.",examples:["[]","[1, 2, 3]","[1, 2, 3; 4, 5, 6]","matrix()","matrix([3, 4])",\'matrix([3, 4; 5, 6], "sparse")\',\'matrix([3, 4; 5, 6], "sparse", "number")\'],seealso:["bignumber","boolean","complex","index","number","string","unit","sparse"]},numberDocs={name:"number",category:"Construction",syntax:["x","number(x)","number(unit, valuelessUnit)"],description:"Create a number or convert a string or boolean into a number.",examples:["2","2e3","4.05","number(2)",\'number("7.2")\',"number(true)","number([true, false, true, true])",\'number(unit("52cm"), "m")\'],seealso:["bignumber","bigint","boolean","complex","fraction","index","matrix","string","unit"]},sparseDocs={name:"sparse",category:"Construction",syntax:["sparse()","sparse([a1, b1, ...; a1, b2, ...])",\'sparse([a1, b1, ...; a1, b2, ...], "number")\'],description:"Create a sparse matrix.",examples:["sparse()","sparse([3, 4; 5, 6])",\'sparse([3, 0; 5, 0], "number")\'],seealso:["bignumber","boolean","complex","index","number","string","unit","matrix"]},splitUnitDocs={name:"splitUnit",category:"Construction",syntax:["splitUnit(unit: Unit, parts: Unit[])"],description:"Split a unit in an array of units whose sum is equal to the original unit.",examples:[\'splitUnit(1 m, ["feet", "inch"])\'],seealso:["unit","createUnit"]},stringDocs={name:"string",category:"Construction",syntax:[\'"text"\',"string(x)"],description:"Create a string or convert a value to a string",examples:[\'"Hello World!"\',"string(4.2)","string(3 + 2i)"],seealso:["bignumber","boolean","complex","index","matrix","number","unit"]},unitDocs={name:"unit",category:"Construction",syntax:["value unit","unit(value, unit)","unit(string)"],description:"Create a unit.",examples:["5.5 mm","3 inch",\'unit(7.1, "kilogram")\',\'unit("23 deg")\'],seealso:["bignumber","boolean","complex","index","matrix","number","string"]},configDocs={name:"config",category:"Core",syntax:["config()","config(options)"],description:"Get configuration or change configuration.",examples:["config()","1/3 + 1/4",\'config({number: "Fraction"})\',"1/3 + 1/4"],seealso:[]},importDocs={name:"import",category:"Core",syntax:["import(functions)","import(functions, options)"],description:"Import functions or constants from an object.",examples:["import({myFn: f(x)=x^2, myConstant: 32 })","myFn(2)","myConstant"],seealso:[]},typedDocs={name:"typed",category:"Core",syntax:["typed(signatures)","typed(name, signatures)"],description:"Create a typed function.",examples:[\'double = typed({ "number": f(x)=x+x, "string": f(x)=concat(x,x) })\',"double(2)",\'double("hello")\'],seealso:[]},derivativeDocs={name:"derivative",category:"Algebra",syntax:["derivative(expr, variable)","derivative(expr, variable, {simplify: boolean})"],description:"Takes the derivative of an expression expressed in parser Nodes. The derivative will be taken over the supplied variable in the second parameter. If there are multiple variables in the expression, it will return a partial derivative.",examples:[\'derivative("2x^3", "x")\',\'derivative("2x^3", "x", {simplify: false})\',\'derivative("2x^2 + 3x + 4", "x")\',\'derivative("sin(2x)", "x")\',\'f = parse("x^2 + x")\',\'x = parse("x")\',"df = derivative(f, x)","df.evaluate({x: 3})"],seealso:["simplify","parse","evaluate"]},leafCountDocs={name:"leafCount",category:"Algebra",syntax:["leafCount(expr)"],description:"Computes the number of leaves in the parse tree of the given expression",examples:[\'leafCount("e^(i*pi)-1")\',\'leafCount(parse("{a: 22/7, b: 10^(1/2)}"))\'],seealso:["simplify"]},lsolveDocs={name:"lsolve",category:"Algebra",syntax:["x=lsolve(L, b)"],description:"Finds one solution of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",examples:["a = [-2, 3; 2, 1]","b = [11, 9]","x = lsolve(a, b)"],seealso:["lsolveAll","lup","lusolve","usolve","matrix","sparse"]},lsolveAllDocs={name:"lsolveAll",category:"Algebra",syntax:["x=lsolveAll(L, b)"],description:"Finds all solutions of the linear system L * x = b where L is an [n x n] lower triangular matrix and b is a [n] column vector.",examples:["a = [-2, 3; 2, 1]","b = [11, 9]","x = lsolve(a, b)"],seealso:["lsolve","lup","lusolve","usolve","matrix","sparse"]},lupDocs={name:"lup",category:"Algebra",syntax:["lup(m)"],description:"Calculate the Matrix LU decomposition with partial pivoting. Matrix A is decomposed in three matrices (L, U, P) where P * A = L * U",examples:["lup([[2, 1], [1, 4]])","lup(matrix([[2, 1], [1, 4]]))","lup(sparse([[2, 1], [1, 4]]))"],seealso:["lusolve","lsolve","usolve","matrix","sparse","slu","qr"]},lusolveDocs={name:"lusolve",category:"Algebra",syntax:["x=lusolve(A, b)","x=lusolve(lu, b)"],description:"Solves the linear system A * x = b where A is an [n x n] matrix and b is a [n] column vector.",examples:["a = [-2, 3; 2, 1]","b = [11, 9]","x = lusolve(a, b)"],seealso:["lup","slu","lsolve","usolve","matrix","sparse"]},polynomialRootDocs={name:"polynomialRoot",category:"Algebra",syntax:["x=polynomialRoot(-6, 3)","x=polynomialRoot(4, -4, 1)","x=polynomialRoot(-8, 12, -6, 1)"],description:"Finds the roots of a univariate polynomial given by its coefficients starting from constant, linear, and so on, increasing in degree.",examples:["a = polynomialRoot(-6, 11, -6, 1)"],seealso:["cbrt","sqrt"]},qrDocs={name:"qr",category:"Algebra",syntax:["qr(A)"],description:"Calculates the Matrix QR decomposition. Matrix `A` is decomposed in two matrices (`Q`, `R`) where `Q` is an orthogonal matrix and `R` is an upper triangular matrix.",examples:["qr([[1, -1,  4], [1,  4, -2], [1,  4,  2], [1,  -1, 0]])"],seealso:["lup","slu","matrix"]},rationalizeDocs={name:"rationalize",category:"Algebra",syntax:["rationalize(expr)","rationalize(expr, scope)","rationalize(expr, scope, detailed)"],description:"Transform a rationalizable expression in a rational fraction. If rational fraction is one variable polynomial then converts the numerator and denominator in canonical form, with decreasing exponents, returning the coefficients of numerator.",examples:[\'rationalize("2x/y - y/(x+1)")\',\'rationalize("2x/y - y/(x+1)", true)\'],seealso:["simplify"]},resolveDocs={name:"resolve",category:"Algebra",syntax:["resolve(node, scope)"],description:"Recursively substitute variables in an expression tree.",examples:[\'resolve(parse("1 + x"), { x: 7 })\',\'resolve(parse("size(text)"), { text: "Hello World" })\',\'resolve(parse("x + y"), { x: parse("3z") })\',\'resolve(parse("3x"), { x: parse("y+z"), z: parse("w^y") })\'],seealso:["simplify","evaluate"],mayThrow:["ReferenceError"]},simplifyDocs={name:"simplify",category:"Algebra",syntax:["simplify(expr)","simplify(expr, rules)"],description:"Simplify an expression tree.",examples:[\'simplify("3 + 2 / 4")\',\'simplify("2x + x")\',\'f = parse("x * (x + 2 + x)")\',"simplified = simplify(f)","simplified.evaluate({x: 2})"],seealso:["simplifyCore","derivative","evaluate","parse","rationalize","resolve"]},simplifyConstantDocs={name:"simplifyConstant",category:"Algebra",syntax:["simplifyConstant(expr)","simplifyConstant(expr, options)"],description:"Replace constant subexpressions of node with their values.",examples:[\'simplifyConstant("(3-3)*x")\',\'simplifyConstant(parse("z-cos(tau/8)"))\'],seealso:["simplify","simplifyCore","evaluate"]},simplifyCoreDocs={name:"simplifyCore",category:"Algebra",syntax:["simplifyCore(node)"],description:"Perform simple one-pass simplifications on an expression tree.",examples:[\'simplifyCore(parse("0*x"))\',\'simplifyCore(parse("(x+0)*2"))\'],seealso:["simplify","simplifyConstant","evaluate"]},sluDocs={name:"slu",category:"Algebra",syntax:["slu(A, order, threshold)"],description:"Calculate the Matrix LU decomposition with full pivoting. Matrix A is decomposed in two matrices (L, U) and two permutation vectors (pinv, q) where P * A * Q = L * U",examples:["slu(sparse([4.5, 0, 3.2, 0; 3.1, 2.9, 0, 0.9; 0, 1.7, 3, 0; 3.5, 0.4, 0, 1]), 1, 0.001)"],seealso:["lusolve","lsolve","usolve","matrix","sparse","lup","qr"]},symbolicEqualDocs={name:"symbolicEqual",category:"Algebra",syntax:["symbolicEqual(expr1, expr2)","symbolicEqual(expr1, expr2, options)"],description:"Returns true if the difference of the expressions simplifies to 0",examples:[\'symbolicEqual("x*y","y*x")\',\'symbolicEqual("abs(x^2)", "x^2")\',\'symbolicEqual("abs(x)", "x", {context: {abs: {trivial: true}}})\'],seealso:["simplify","evaluate"]},usolveDocs={name:"usolve",category:"Algebra",syntax:["x=usolve(U, b)"],description:"Finds one solution of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",examples:["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],seealso:["usolveAll","lup","lusolve","lsolve","matrix","sparse"]},usolveAllDocs={name:"usolveAll",category:"Algebra",syntax:["x=usolve(U, b)"],description:"Finds all solutions of the linear system U * x = b where U is an [n x n] upper triangular matrix and b is a [n] column vector.",examples:["x=usolve(sparse([1, 1, 1, 1; 0, 1, 1, 1; 0, 0, 1, 1; 0, 0, 0, 1]), [1; 2; 3; 4])"],seealso:["usolve","lup","lusolve","lsolve","matrix","sparse"]},absDocs={name:"abs",category:"Arithmetic",syntax:["abs(x)"],description:"Compute the absolute value.",examples:["abs(3.5)","abs(-4.2)"],seealso:["sign"]},addDocs={name:"add",category:"Operators",syntax:["x + y","add(x, y)"],description:"Add two values.",examples:["a = 2.1 + 3.6","a - 3.6","3 + 2i","3 cm + 2 inch",\'"2.3" + "4"\'],seealso:["subtract"]},cbrtDocs={name:"cbrt",category:"Arithmetic",syntax:["cbrt(x)","cbrt(x, allRoots)"],description:"Compute the cubic root value. If x = y * y * y, then y is the cubic root of x. When `x` is a number or complex number, an optional second argument `allRoots` can be provided to return all three cubic roots. If not provided, the principal root is returned",examples:["cbrt(64)","cube(4)","cbrt(-8)","cbrt(2 + 3i)","cbrt(8i)","cbrt(8i, true)","cbrt(27 m^3)"],seealso:["square","sqrt","cube","multiply"]},ceilDocs={name:"ceil",category:"Arithmetic",syntax:["ceil(x)","ceil(x, n)","ceil(unit, valuelessUnit)","ceil(unit, n, valuelessUnit)"],description:"Round a value towards plus infinity. If x is complex, both real and imaginary part are rounded towards plus infinity.",examples:["ceil(3.2)","ceil(3.8)","ceil(-4.2)","ceil(3.241cm, cm)","ceil(3.241cm, 2, cm)"],seealso:["floor","fix","round"]},cubeDocs={name:"cube",category:"Arithmetic",syntax:["cube(x)"],description:"Compute the cube of a value. The cube of x is x * x * x.",examples:["cube(2)","2^3","2 * 2 * 2"],seealso:["multiply","square","pow"]},divideDocs={name:"divide",category:"Operators",syntax:["x / y","divide(x, y)"],description:"Divide two values.",examples:["a = 2 / 3","a * 3","4.5 / 2","3 + 4 / 2","(3 + 4) / 2","18 km / 4.5"],seealso:["multiply"]},dotDivideDocs={name:"dotDivide",category:"Operators",syntax:["x ./ y","dotDivide(x, y)"],description:"Divide two values element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","b = [2, 1, 1; 3, 2, 5]","a ./ b"],seealso:["multiply","dotMultiply","divide"]},dotMultiplyDocs={name:"dotMultiply",category:"Operators",syntax:["x .* y","dotMultiply(x, y)"],description:"Multiply two values element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","b = [2, 1, 1; 3, 2, 5]","a .* b"],seealso:["multiply","divide","dotDivide"]},dotPowDocs={name:"dotPow",category:"Operators",syntax:["x .^ y","dotPow(x, y)"],description:"Calculates the power of x to y element wise.",examples:["a = [1, 2, 3; 4, 5, 6]","a .^ 2"],seealso:["pow"]},expDocs={name:"exp",category:"Arithmetic",syntax:["exp(x)"],description:"Calculate the exponent of a value.",examples:["exp(1.3)","e ^ 1.3","log(exp(1.3))","x = 2.4","(exp(i*x) == cos(x) + i*sin(x))   # Euler\'s formula"],seealso:["expm","expm1","pow","log"]},expmDocs={name:"expm",category:"Arithmetic",syntax:["exp(x)"],description:"Compute the matrix exponential, expm(A) = e^A. The matrix must be square. Not to be confused with exp(a), which performs element-wise exponentiation.",examples:["expm([[0,2],[0,0]])"],seealso:["exp"]},expm1Docs={name:"expm1",category:"Arithmetic",syntax:["expm1(x)"],description:"Calculate the value of subtracting 1 from the exponential value.",examples:["expm1(2)","pow(e, 2) - 1","log(expm1(2) + 1)"],seealso:["exp","pow","log"]},fixDocs={name:"fix",category:"Arithmetic",syntax:["fix(x)","fix(x, n)","fix(unit, valuelessUnit)","fix(unit, n, valuelessUnit)"],description:"Round a value towards zero. If x is complex, both real and imaginary part are rounded towards zero.",examples:["fix(3.2)","fix(3.8)","fix(-4.2)","fix(-4.8)","fix(3.241cm, cm)","fix(3.241cm, 2, cm)"],seealso:["ceil","floor","round"]},floorDocs={name:"floor",category:"Arithmetic",syntax:["floor(x)","floor(x, n)","floor(unit, valuelessUnit)","floor(unit, n, valuelessUnit)"],description:"Round a value towards minus infinity.If x is complex, both real and imaginary part are rounded towards minus infinity.",examples:["floor(3.2)","floor(3.8)","floor(-4.2)","floor(3.241cm, cm)","floor(3.241cm, 2, cm)"],seealso:["ceil","fix","round"]},gcdDocs={name:"gcd",category:"Arithmetic",syntax:["gcd(a, b)","gcd(a, b, c, ...)"],description:"Compute the greatest common divisor.",examples:["gcd(8, 12)","gcd(-4, 6)","gcd(25, 15, -10)"],seealso:["lcm","xgcd"]},hypotDocs={name:"hypot",category:"Arithmetic",syntax:["hypot(a, b, c, ...)","hypot([a, b, c, ...])"],description:"Calculate the hypotenuse of a list with values.",examples:["hypot(3, 4)","sqrt(3^2 + 4^2)","hypot(-2)","hypot([3, 4, 5])"],seealso:["abs","norm"]},invmodDocs={name:"invmod",category:"Arithmetic",syntax:["invmod(a, b)"],description:"Calculate the (modular) multiplicative inverse of a modulo b. Solution to the equation ax ≣ 1 (mod b)",examples:["invmod(8, 12)","invmod(7, 13)","invmod(15151, 15122)"],seealso:["gcd","xgcd"]},lcmDocs={name:"lcm",category:"Arithmetic",syntax:["lcm(x, y)"],description:"Compute the least common multiple.",examples:["lcm(4, 6)","lcm(6, 21)","lcm(6, 21, 5)"],seealso:["gcd"]},logDocs={name:"log",category:"Arithmetic",syntax:["log(x)","log(x, base)"],description:"Compute the logarithm of a value. If no base is provided, the natural logarithm of x is calculated. If base if provided, the logarithm is calculated for the specified base. log(x, base) is defined as log(x) / log(base).",examples:["log(3.5)","a = log(2.4)","exp(a)","10 ^ 4","log(10000, 10)","log(10000) / log(10)","b = log(1024, 2)","2 ^ b"],seealso:["exp","log1p","log2","log10"]},log10Docs={name:"log10",category:"Arithmetic",syntax:["log10(x)"],description:"Compute the 10-base logarithm of a value.",examples:["log10(0.00001)","log10(10000)","10 ^ 4","log(10000) / log(10)","log(10000, 10)"],seealso:["exp","log"]},log1pDocs={name:"log1p",category:"Arithmetic",syntax:["log1p(x)","log1p(x, base)"],description:"Calculate the logarithm of a `value+1`",examples:["log1p(2.5)","exp(log1p(1.4))","pow(10, 4)","log1p(9999, 10)","log1p(9999) / log(10)"],seealso:["exp","log","log2","log10"]},log2Docs={name:"log2",category:"Arithmetic",syntax:["log2(x)"],description:"Calculate the 2-base of a value. This is the same as calculating `log(x, 2)`.",examples:["log2(0.03125)","log2(16)","log2(16) / log2(2)","pow(2, 4)"],seealso:["exp","log1p","log","log10"]},modDocs={name:"mod",category:"Operators",syntax:["x % y","x mod y","mod(x, y)"],description:"Calculates the modulus, the remainder of an integer division.",examples:["7 % 3","11 % 2","10 mod 4","isOdd(x) = x % 2","isOdd(2)","isOdd(3)"],seealso:["divide"]},multiplyDocs={name:"multiply",category:"Operators",syntax:["x * y","multiply(x, y)"],description:"multiply two values.",examples:["a = 2.1 * 3.4","a / 3.4","2 * 3 + 4","2 * (3 + 4)","3 * 2.1 km"],seealso:["divide"]},normDocs={name:"norm",category:"Arithmetic",syntax:["norm(x)","norm(x, p)"],description:"Calculate the norm of a number, vector or matrix.",examples:["abs(-3.5)","norm(-3.5)","norm(3 - 4i)","norm([1, 2, -3], Infinity)","norm([1, 2, -3], -Infinity)","norm([3, 4], 2)","norm([[1, 2], [3, 4]], 1)",\'norm([[1, 2], [3, 4]], "inf")\',\'norm([[1, 2], [3, 4]], "fro")\']},nthRootDocs={name:"nthRoot",category:"Arithmetic",syntax:["nthRoot(a)","nthRoot(a, root)"],description:\'Calculate the nth root of a value. The principal nth root of a positive real number A, is the positive real solution of the equation "x^root = A".\',examples:["4 ^ 3","nthRoot(64, 3)","nthRoot(9, 2)","sqrt(9)"],seealso:["nthRoots","pow","sqrt"]},nthRootsDocs={name:"nthRoots",category:"Arithmetic",syntax:["nthRoots(A)","nthRoots(A, root)"],description:\'Calculate the nth roots of a value. An nth root of a positive real number A, is a positive real solution of the equation "x^root = A". This function returns an array of complex values.\',examples:["nthRoots(1)","nthRoots(1, 3)"],seealso:["sqrt","pow","nthRoot"]},powDocs={name:"pow",category:"Operators",syntax:["x ^ y","pow(x, y)"],description:"Calculates the power of x to y, x^y.",examples:["2^3","2*2*2","1 + e ^ (pi * i)","pow([[1, 2], [4, 3]], 2)","pow([[1, 2], [4, 3]], -1)"],seealso:["multiply","nthRoot","nthRoots","sqrt"]},roundDocs={name:"round",category:"Arithmetic",syntax:["round(x)","round(x, n)","round(unit, valuelessUnit)","round(unit, n, valuelessUnit)"],description:"round a value towards the nearest integer.If x is complex, both real and imaginary part are rounded towards the nearest integer. When n is specified, the value is rounded to n decimals.",examples:["round(3.2)","round(3.8)","round(-4.2)","round(-4.8)","round(pi, 3)","round(123.45678, 2)","round(3.241cm, 2, cm)","round([3.2, 3.8, -4.7])"],seealso:["ceil","floor","fix"]},signDocs={name:"sign",category:"Arithmetic",syntax:["sign(x)"],description:"Compute the sign of a value. The sign of a value x is 1 when x>0, -1 when x<0, and 0 when x=0.",examples:["sign(3.5)","sign(-4.2)","sign(0)"],seealso:["abs"]},sqrtDocs={name:"sqrt",category:"Arithmetic",syntax:["sqrt(x)"],description:"Compute the square root value. If x = y * y, then y is the square root of x.",examples:["sqrt(25)","5 * 5","sqrt(-1)"],seealso:["square","sqrtm","multiply","nthRoot","nthRoots","pow"]},sqrtmDocs={name:"sqrtm",category:"Arithmetic",syntax:["sqrtm(x)"],description:"Calculate the principal square root of a square matrix. The principal square root matrix `X` of another matrix `A` is such that `X * X = A`.",examples:["sqrtm([[33, 24], [48, 57]])"],seealso:["sqrt","abs","square","multiply"]},sylvesterDocs={name:"sylvester",category:"Algebra",syntax:["sylvester(A,B,C)"],description:"Solves the real-valued Sylvester equation AX+XB=C for X",examples:["sylvester([[-1, -2], [1, 1]], [[-2, 1], [-1, 2]], [[-3, 2], [3, 0]])","A = [[-1, -2], [1, 1]]; B = [[2, -1], [1, -2]]; C = [[-3, 2], [3, 0]]","sylvester(A, B, C)"],seealso:["schur","lyap"]},schurDocs={name:"schur",category:"Algebra",syntax:["schur(A)"],description:"Performs a real Schur decomposition of the real matrix A = UTU\'",examples:["schur([[1, 0], [-4, 3]])","A = [[1, 0], [-4, 3]]","schur(A)"],seealso:["lyap","sylvester"]},lyapDocs={name:"lyap",category:"Algebra",syntax:["lyap(A,Q)"],description:"Solves the Continuous-time Lyapunov equation AP+PA\'+Q=0 for P",examples:["lyap([[-2, 0], [1, -4]], [[3, 1], [1, 3]])","A = [[-2, 0], [1, -4]]","Q = [[3, 1], [1, 3]]","lyap(A,Q)"],seealso:["schur","sylvester"]},squareDocs={name:"square",category:"Arithmetic",syntax:["square(x)"],description:"Compute the square of a value. The square of x is x * x.",examples:["square(3)","sqrt(9)","3^2","3 * 3"],seealso:["multiply","pow","sqrt","cube"]},subtractDocs={name:"subtract",category:"Operators",syntax:["x - y","subtract(x, y)"],description:"subtract two values.",examples:["a = 5.3 - 2","a + 2","2/3 - 1/6","2 * 3 - 3","2.1 km - 500m"],seealso:["add"]},unaryMinusDocs={name:"unaryMinus",category:"Operators",syntax:["-x","unaryMinus(x)"],description:"Inverse the sign of a value. Converts booleans and strings to numbers.",examples:["-4.5","-(-5.6)",\'-"22"\'],seealso:["add","subtract","unaryPlus"]},unaryPlusDocs={name:"unaryPlus",category:"Operators",syntax:["+x","unaryPlus(x)"],description:"Converts booleans and strings to numbers.",examples:["+true",\'+"2"\'],seealso:["add","subtract","unaryMinus"]},xgcdDocs={name:"xgcd",category:"Arithmetic",syntax:["xgcd(a, b)"],description:"Calculate the extended greatest common divisor for two values. The result is an array [d, x, y] with 3 entries, where d is the greatest common divisor, and d = x * a + y * b.",examples:["xgcd(8, 12)","gcd(8, 12)","xgcd(36163, 21199)"],seealso:["gcd","lcm"]},numDocs={name:"num",category:"Fraction",syntax:["num(x)"],description:"Get the numerator of a fraction.",examples:["num(fraction(2, 3))","num(fraction(5, 8))"],seealso:["den","fraction"]},denDocs={name:"den",category:"Fraction",syntax:["den(x)"],description:"Get the denominator of a fraction.",examples:["den(fraction(2, 3))","den(fraction(5, 8))"],seealso:["num","fraction"]},bitAndDocs={name:"bitAnd",category:"Bitwise",syntax:["x & y","bitAnd(x, y)"],description:"Bitwise AND operation. Performs the logical AND operation on each pair of the corresponding bits of the two given values by multiplying them. If both bits in the compared position are 1, the bit in the resulting binary representation is 1, otherwise, the result is 0",examples:["5 & 3","bitAnd(53, 131)","[1, 12, 31] & 42"],seealso:["bitNot","bitOr","bitXor","leftShift","rightArithShift","rightLogShift"]},bitNotDocs={name:"bitNot",category:"Bitwise",syntax:["~x","bitNot(x)"],description:"Bitwise NOT operation. Performs a logical negation on each bit of the given value. Bits that are 0 become 1, and those that are 1 become 0.",examples:["~1","~2","bitNot([2, -3, 4])"],seealso:["bitAnd","bitOr","bitXor","leftShift","rightArithShift","rightLogShift"]},bitOrDocs={name:"bitOr",category:"Bitwise",syntax:["x | y","bitOr(x, y)"],description:"Bitwise OR operation. Performs the logical inclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if the first bit is 1 or the second bit is 1 or both bits are 1, otherwise, the result is 0.",examples:["5 | 3","bitOr([1, 2, 3], 4)"],seealso:["bitAnd","bitNot","bitXor","leftShift","rightArithShift","rightLogShift"]},bitXorDocs={name:"bitXor",category:"Bitwise",syntax:["bitXor(x, y)"],description:"Bitwise XOR operation, exclusive OR. Performs the logical exclusive OR operation on each pair of corresponding bits of the two given values. The result in each position is 1 if only the first bit is 1 or only the second bit is 1, but will be 0 if both are 0 or both are 1.",examples:["bitOr(1, 2)","bitXor([2, 3, 4], 4)"],seealso:["bitAnd","bitNot","bitOr","leftShift","rightArithShift","rightLogShift"]},leftShiftDocs={name:"leftShift",category:"Bitwise",syntax:["x << y","leftShift(x, y)"],description:"Bitwise left logical shift of a value x by y number of bits.",examples:["4 << 1","8 >> 1"],seealso:["bitAnd","bitNot","bitOr","bitXor","rightArithShift","rightLogShift"]},rightArithShiftDocs={name:"rightArithShift",category:"Bitwise",syntax:["x >> y","rightArithShift(x, y)"],description:"Bitwise right arithmetic shift of a value x by y number of bits.",examples:["8 >> 1","4 << 1","-12 >> 2"],seealso:["bitAnd","bitNot","bitOr","bitXor","leftShift","rightLogShift"]},rightLogShiftDocs={name:"rightLogShift",category:"Bitwise",syntax:["x >>> y","rightLogShift(x, y)"],description:"Bitwise right logical shift of a value x by y number of bits.",examples:["8 >>> 1","4 << 1","-12 >>> 2"],seealso:["bitAnd","bitNot","bitOr","bitXor","leftShift","rightArithShift"]},bellNumbersDocs={name:"bellNumbers",category:"Combinatorics",syntax:["bellNumbers(n)"],description:"The Bell Numbers count the number of partitions of a set. A partition is a pairwise disjoint subset of S whose union is S. `bellNumbers` only takes integer arguments. The following condition must be enforced: n >= 0.",examples:["bellNumbers(3)","bellNumbers(8)"],seealso:["stirlingS2"]},catalanDocs={name:"catalan",category:"Combinatorics",syntax:["catalan(n)"],description:"The Catalan Numbers enumerate combinatorial structures of many different types. catalan only takes integer arguments. The following condition must be enforced: n >= 0.",examples:["catalan(3)","catalan(8)"],seealso:["bellNumbers"]},compositionDocs={name:"composition",category:"Combinatorics",syntax:["composition(n, k)"],description:"The composition counts of n into k parts. composition only takes integer arguments. The following condition must be enforced: k <= n.",examples:["composition(5, 3)"],seealso:["combinations"]},stirlingS2Docs={name:"stirlingS2",category:"Combinatorics",syntax:["stirlingS2(n, k)"],description:"The Stirling numbers of the second kind, counts the number of ways to partition a set of n labelled objects into k nonempty unlabelled subsets. `stirlingS2` only takes integer arguments. The following condition must be enforced: k <= n. If n = k or k = 1, then s(n,k) = 1.",examples:["stirlingS2(5, 3)"],seealso:["bellNumbers","bernoulli"]},argDocs={name:"arg",category:"Complex",syntax:["arg(x)"],description:"Compute the argument of a complex value. If x = a+bi, the argument is computed as atan2(b, a).",examples:["arg(2 + 2i)","atan2(3, 2)","arg(2 + 3i)"],seealso:["re","im","conj","abs"]},conjDocs={name:"conj",category:"Complex",syntax:["conj(x)"],description:"Compute the complex conjugate of a complex value. If x = a+bi, the complex conjugate is a-bi.",examples:["conj(2 + 3i)","conj(2 - 3i)","conj(-5.2i)"],seealso:["re","im","abs","arg"]},imDocs={name:"im",category:"Complex",syntax:["im(x)"],description:"Get the imaginary part of a complex number.",examples:["im(2 + 3i)","re(2 + 3i)","im(-5.2i)","im(2.4)"],seealso:["re","conj","abs","arg"]},reDocs={name:"re",category:"Complex",syntax:["re(x)"],description:"Get the real part of a complex number.",examples:["re(2 + 3i)","im(2 + 3i)","re(-5.2i)","re(2.4)"],seealso:["im","conj","abs","arg"]},evaluateDocs={name:"evaluate",category:"Expression",syntax:["evaluate(expression)","evaluate(expression, scope)","evaluate([expr1, expr2, expr3, ...])","evaluate([expr1, expr2, expr3, ...], scope)"],description:"Evaluate an expression or an array with expressions.",examples:[\'evaluate("2 + 3")\',\'evaluate("sqrt(16)")\',\'evaluate("2 inch to cm")\',\'evaluate("sin(x * pi)", { "x": 1/2 })\',\'evaluate(["width=2", "height=4","width*height"])\'],seealso:["parser","parse","compile"]},parserDocs={name:"parser",category:"Expression",syntax:["parser()"],description:"Create a parser object that keeps a context of variables and their values, allowing the evaluation of expressions in that context.",examples:["myParser = parser()",\'myParser.evaluate("sqrt(3^2 + 4^2)")\',\'myParser.set("x", 3)\',\'myParser.evaluate("y = x + 3")\',\'myParser.evaluate(["y = x + 3", "y = y + 1"])\',\'myParser.get("y")\'],seealso:["evaluate","parse","compile"]},parseDocs={name:"parse",category:"Expression",syntax:["parse(expr)","parse(expr, options)","parse([expr1, expr2, expr3, ...])","parse([expr1, expr2, expr3, ...], options)"],description:"Parse an expression. Returns a node tree, which can be evaluated by invoking node.evaluate() or transformed into a functional object via node.compile().",examples:[\'node1 = parse("sqrt(3^2 + 4^2)")\',"node1.evaluate()","code1 = node1.compile()","code1.evaluate()","scope = {a: 3, b: 4}",\'node2 = parse("a * b")\',"node2.evaluate(scope)","code2 = node2.compile()","code2.evaluate(scope)"],seealso:["parser","evaluate","compile"]},compileDocs={name:"compile",category:"Expression",syntax:["compile(expr) ","compile([expr1, expr2, expr3, ...])"],description:"Parse and compile an expression. Returns a an object with a function evaluate([scope]) to evaluate the compiled expression.",examples:[\'code1 = compile("sqrt(3^2 + 4^2)")\',"code1.evaluate() ",\'code2 = compile("a * b")\',"code2.evaluate({a: 3, b: 4})"],seealso:["parser","parse","evaluate"]},helpDocs={name:"help",category:"Expression",syntax:["help(object)","help(string)"],description:"Display documentation on a function or data type.",examples:["help(sqrt)",\'help("complex")\'],seealso:[]},distanceDocs={name:"distance",category:"Geometry",syntax:["distance([x1, y1], [x2, y2])","distance([[x1, y1], [x2, y2]])"],description:"Calculates the Euclidean distance between two points.",examples:["distance([0,0], [4,4])","distance([[0,0], [4,4]])"],seealso:[]},intersectDocs={name:"intersect",category:"Geometry",syntax:["intersect(expr1, expr2, expr3, expr4)","intersect(expr1, expr2, expr3)"],description:"Computes the intersection point of lines and/or planes.",examples:["intersect([0, 0], [10, 10], [10, 0], [0, 10])","intersect([1, 0, 1],  [4, -2, 2], [1, 1, 1, 6])"],seealso:[]},andDocs={name:"and",category:"Logical",syntax:["x and y","and(x, y)"],description:"Logical and. Test whether two values are both defined with a nonzero/nonempty value.",examples:["true and false","true and true","2 and 4"],seealso:["not","or","xor"]},notDocs={name:"not",category:"Logical",syntax:["not x","not(x)"],description:"Logical not. Flips the boolean value of given argument.",examples:["not true","not false","not 2","not 0"],seealso:["and","or","xor"]},nullishDocs={name:"nullish",category:"Logical",syntax:["x ?? y","nullish(x, y)"],description:"Nullish coalescing operator. Returns the right-hand operand when the left-hand operand is null or undefined, and otherwise returns the left-hand operand.",examples:["null ?? 42","undefined ?? 42","0 ?? 42","false ?? 42","null ?? undefined ?? 42"],seealso:["and","or","not"]},orDocs={name:"or",category:"Logical",syntax:["x or y","or(x, y)"],description:"Logical or. Test if at least one value is defined with a nonzero/nonempty value.",examples:["true or false","false or false","0 or 4"],seealso:["not","and","xor"]},xorDocs={name:"xor",category:"Logical",syntax:["x xor y","xor(x, y)"],description:"Logical exclusive or, xor. Test whether one and only one value is defined with a nonzero/nonempty value.",examples:["true xor false","false xor false","true xor true","0 xor 4"],seealso:["not","and","or"]},mapSlicesDocs={name:"mapSlices",category:"Matrix",syntax:["mapSlices(A, dim, callback)"],description:"Generate a matrix one dimension less than A by applying callback to each slice of A along dimension dim.",examples:["A = [[1, 2], [3, 4]]","mapSlices(A, 1, sum)","mapSlices(A, 2, prod)"],seealso:["map","forEach"]},columnDocs={name:"column",category:"Matrix",syntax:["column(x, index)"],description:"Return a column from a matrix or array.",examples:["A = [[1, 2], [3, 4]]","column(A, 1)","column(A, 2)"],seealso:["row","matrixFromColumns"]},concatDocs={name:"concat",category:"Matrix",syntax:["concat(A, B, C, ...)","concat(A, B, C, ..., dim)"],description:"Concatenate matrices. By default, the matrices are concatenated by the last dimension. The dimension on which to concatenate can be provided as last argument.",examples:["A = [1, 2; 5, 6]","B = [3, 4; 7, 8]","concat(A, B)","concat(A, B, 1)","concat(A, B, 2)"],seealso:["det","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},countDocs={name:"count",category:"Matrix",syntax:["count(x)"],description:"Count the number of elements of a matrix, array or string.",examples:["a = [1, 2; 3, 4; 5, 6]","count(a)","size(a)",\'count("hello world")\'],seealso:["size"]},crossDocs={name:"cross",category:"Matrix",syntax:["cross(A, B)"],description:"Calculate the cross product for two vectors in three dimensional space.",examples:["cross([1, 1, 0],  [0, 1, 1])","cross([3, -3, 1], [4, 9, 2])","cross([2, 3, 4],  [5, 6, 7])"],seealso:["multiply","dot"]},ctransposeDocs={name:"ctranspose",category:"Matrix",syntax:["x\'","ctranspose(x)"],description:"Complex Conjugate and Transpose a matrix",examples:["a = [1, 2, 3; 4, 5, 6]","a\'","ctranspose(a)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","zeros"]},detDocs={name:"det",category:"Matrix",syntax:["det(x)"],description:"Calculate the determinant of a matrix",examples:["det([1, 2; 3, 4])","det([-2, 2, 3; -1, 1, 3; 2, 0, -1])"],seealso:["concat","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},diagDocs={name:"diag",category:"Matrix",syntax:["diag(x)","diag(x, k)"],description:"Create a diagonal matrix or retrieve the diagonal of a matrix. When x is a vector, a matrix with the vector values on the diagonal will be returned. When x is a matrix, a vector with the diagonal values of the matrix is returned. When k is provided, the k-th diagonal will be filled in or retrieved, if k is positive, the values are placed on the super diagonal. When k is negative, the values are placed on the sub diagonal.",examples:["diag(1:3)","diag(1:3, 1)","a = [1, 2, 3; 4, 5, 6; 7, 8, 9]","diag(a)"],seealso:["concat","det","identity","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},diffDocs={name:"diff",category:"Matrix",syntax:["diff(arr)","diff(arr, dim)"],description:["Create a new matrix or array with the difference of the passed matrix or array.","Dim parameter is optional and used to indicate the dimension of the array/matrix to apply the difference","If no dimension parameter is passed it is assumed as dimension 0","Dimension is zero-based in javascript and one-based in the parser","Arrays must be \'rectangular\' meaning arrays like [1, 2]","If something is passed as a matrix it will be returned as a matrix but other than that all matrices are converted to arrays"],examples:["A = [1, 2, 4, 7, 0]","diff(A)","diff(A, 1)","B = [[1, 2], [3, 4]]","diff(B)","diff(B, 1)","diff(B, 2)","diff(B, bignumber(2))","diff([[1, 2], matrix([3, 4])], 2)"],seealso:["subtract","partitionSelect"]},dotDocs={name:"dot",category:"Matrix",syntax:["dot(A, B)","A * B"],description:"Calculate the dot product of two vectors. The dot product of A = [a1, a2, a3, ..., an] and B = [b1, b2, b3, ..., bn] is defined as dot(A, B) = a1 * b1 + a2 * b2 + a3 * b3 + ... + an * bn",examples:["dot([2, 4, 1], [2, 2, 3])","[2, 4, 1] * [2, 2, 3]"],seealso:["multiply","cross"]},eigsDocs={name:"eigs",category:"Matrix",syntax:["eigs(x)"],description:"Calculate the eigenvalues and optionally eigenvectors of a square matrix",examples:["eigs([[5, 2.3], [2.3, 1]])","eigs([[1, 2, 3], [4, 5, 6], [7, 8, 9]], { precision: 1e-6, eigenvectors: false })"],seealso:["inv"]},filterDocs={name:"filter",category:"Matrix",syntax:["filter(x, test)"],description:"Filter items in a matrix.",examples:["isPositive(x) = x > 0","filter([6, -2, -1, 4, 3], isPositive)","filter([6, -2, 0, 1, 0], x != 0)"],seealso:["sort","map","forEach"]},flattenDocs={name:"flatten",category:"Matrix",syntax:["flatten(x)"],description:"Flatten a multi dimensional matrix into a single dimensional matrix.",examples:["a = [1, 2, 3; 4, 5, 6]","size(a)","b = flatten(a)","size(b)"],seealso:["concat","resize","size","squeeze"]},forEachDocs={name:"forEach",category:"Matrix",syntax:["forEach(x, callback)"],description:"Iterates over all elements of a matrix/array, and executes the given callback function.",examples:["numberOfPets = {}","addPet(n) = numberOfPets[n] = (numberOfPets[n] ? numberOfPets[n]:0 ) + 1;",\'forEach(["Dog","Cat","Cat"], addPet)\',"numberOfPets"],seealso:["map","sort","filter"]},getMatrixDataTypeDocs={name:"getMatrixDataType",category:"Matrix",syntax:["getMatrixDataType(x)"],description:\'Find the data type of all elements in a matrix or array, for example "number" if all items are a number and "Complex" if all values are complex numbers. If a matrix contains more than one data type, it will return "mixed".\',examples:["getMatrixDataType([1, 2, 3])","getMatrixDataType([[5 cm], [2 inch]])",\'getMatrixDataType([1, "text"])\',"getMatrixDataType([1, bignumber(4)])"],seealso:["matrix","sparse","typeOf"]},identityDocs={name:"identity",category:"Matrix",syntax:["identity(n)","identity(m, n)","identity([m, n])"],description:"Returns the identity matrix with size m-by-n. The matrix has ones on the diagonal and zeros elsewhere.",examples:["identity(3)","identity(3, 5)","a = [1, 2, 3; 4, 5, 6]","identity(size(a))"],seealso:["concat","det","diag","inv","ones","range","size","squeeze","subset","trace","transpose","zeros"]},invDocs={name:"inv",category:"Matrix",syntax:["inv(x)"],description:"Calculate the inverse of a matrix",examples:["inv([1, 2; 3, 4])","inv(4)","1 / 4"],seealso:["concat","det","diag","identity","ones","range","size","squeeze","subset","trace","transpose","zeros"]},pinvDocs={name:"pinv",category:"Matrix",syntax:["pinv(x)"],description:"Calculate the Moore–Penrose inverse of a matrix",examples:["pinv([1, 2; 3, 4])","pinv([[1, 0], [0, 1], [0, 1]])","pinv(4)"],seealso:["inv"]},kronDocs={name:"kron",category:"Matrix",syntax:["kron(x, y)"],description:"Calculates the Kronecker product of 2 matrices or vectors.",examples:["kron([[1, 0], [0, 1]], [[1, 2], [3, 4]])","kron([1,1], [2,3,4])"],seealso:["multiply","dot","cross"]},mapDocs={name:"map",category:"Matrix",syntax:["map(x, callback)","map(x, y, ..., callback)"],description:"Create a new matrix or array with the results of the callback function executed on each entry of the matrix/array or the matrices/arrays.",examples:["map([1, 2, 3], square)","map([1, 2], [3, 4], f(a,b) = a + b)"],seealso:["filter","forEach"]},matrixFromColumnsDocs={name:"matrixFromColumns",category:"Matrix",syntax:["matrixFromColumns(...arr)","matrixFromColumns(row1, row2)","matrixFromColumns(row1, row2, row3)"],description:"Create a dense matrix from vectors as individual columns.",examples:["matrixFromColumns([1, 2, 3], [[4],[5],[6]])"],seealso:["matrix","matrixFromRows","matrixFromFunction","zeros"]},matrixFromFunctionDocs={name:"matrixFromFunction",category:"Matrix",syntax:["matrixFromFunction(size, fn)","matrixFromFunction(size, fn, format)","matrixFromFunction(size, fn, format, datatype)","matrixFromFunction(size, format, fn)","matrixFromFunction(size, format, datatype, fn)"],description:"Create a matrix by evaluating a generating function at each index.",examples:["f(I) = I[1] - I[2]","matrixFromFunction([3,3], f)","g(I) = I[1] - I[2] == 1 ? 4 : 0",\'matrixFromFunction([100, 100], "sparse", g)\',"matrixFromFunction([5], random)"],seealso:["matrix","matrixFromRows","matrixFromColumns","zeros"]},matrixFromRowsDocs={name:"matrixFromRows",category:"Matrix",syntax:["matrixFromRows(...arr)","matrixFromRows(row1, row2)","matrixFromRows(row1, row2, row3)"],description:"Create a dense matrix from vectors as individual rows.",examples:["matrixFromRows([1, 2, 3], [[4],[5],[6]])"],seealso:["matrix","matrixFromColumns","matrixFromFunction","zeros"]},onesDocs={name:"ones",category:"Matrix",syntax:["ones(m)","ones(m, n)","ones(m, n, p, ...)","ones([m])","ones([m, n])","ones([m, n, p, ...])"],description:"Create a matrix containing ones.",examples:["ones(3)","ones(3, 5)","ones([2,3]) * 4.5","a = [1, 2, 3; 4, 5, 6]","ones(size(a))"],seealso:["concat","det","diag","identity","inv","range","size","squeeze","subset","trace","transpose","zeros"]},partitionSelectDocs={name:"partitionSelect",category:"Matrix",syntax:["partitionSelect(x, k)","partitionSelect(x, k, compare)"],description:"Partition-based selection of an array or 1D matrix. Will find the kth smallest value, and mutates the input array. Uses Quickselect.",examples:["partitionSelect([5, 10, 1], 2)",\'partitionSelect(["C", "B", "A", "D"], 1, compareText)\',"arr = [5, 2, 1]","partitionSelect(arr, 0) # returns 1, arr is now: [1, 2, 5]","arr","partitionSelect(arr, 1, \'desc\') # returns 2, arr is now: [5, 2, 1]","arr"],seealso:["sort"]},rangeDocs={name:"range",category:"Type",syntax:["start:end","start:step:end","range(start, end)","range(start, end, step)","range(string)"],description:"Create a range. Lower bound of the range is included, upper bound is excluded.",examples:["1:5","3:-1:-3","range(3, 7)","range(0, 12, 2)",\'range("4:10")\',"range(1m, 1m, 3m)","a = [1, 2, 3, 4; 5, 6, 7, 8]","a[1:2, 1:2]"],seealso:["concat","det","diag","identity","inv","ones","size","squeeze","subset","trace","transpose","zeros"]},reshapeDocs={name:"reshape",category:"Matrix",syntax:["reshape(x, sizes)"],description:"Reshape a multi dimensional array to fit the specified dimensions.",examples:["reshape([1, 2, 3, 4, 5, 6], [2, 3])","reshape([[1, 2], [3, 4]], [1, 4])","reshape([[1, 2], [3, 4]], [4])","reshape([1, 2, 3, 4], [-1, 2])"],seealso:["size","squeeze","resize"]},resizeDocs={name:"resize",category:"Matrix",syntax:["resize(x, size)","resize(x, size, defaultValue)"],description:"Resize a matrix.",examples:["resize([1,2,3,4,5], [3])","resize([1,2,3], [5])","resize([1,2,3], [5], -1)","resize(2, [2, 3])",\'resize("hello", [8], "!")\'],seealso:["size","subset","squeeze","reshape"]},rotateDocs={name:"rotate",category:"Matrix",syntax:["rotate(w, theta)","rotate(w, theta, v)"],description:"Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",examples:["rotate([1, 0], pi / 2)",\'rotate(matrix([1, 0]), unit("35deg"))\',\'rotate([1, 0, 0], unit("90deg"), [0, 0, 1])\',\'rotate(matrix([1, 0, 0]), unit("90deg"), matrix([0, 0, 1]))\'],seealso:["matrix","rotationMatrix"]},rotationMatrixDocs={name:"rotationMatrix",category:"Matrix",syntax:["rotationMatrix(theta)","rotationMatrix(theta, v)","rotationMatrix(theta, v, format)"],description:"Returns a 2-D rotation matrix (2x2) for a given angle (in radians). Returns a 2-D rotation matrix (3x3) of a given angle (in radians) around given axis.",examples:["rotationMatrix(pi / 2)",\'rotationMatrix(unit("45deg"), [0, 0, 1])\',\'rotationMatrix(1, matrix([0, 0, 1]), "sparse")\'],seealso:["cos","sin"]},rowDocs={name:"row",category:"Matrix",syntax:["row(x, index)"],description:"Return a row from a matrix or array.",examples:["A = [[1, 2], [3, 4]]","row(A, 1)","row(A, 2)"],seealso:["column","matrixFromRows"]},sizeDocs={name:"size",category:"Matrix",syntax:["size(x)"],description:"Calculate the size of a matrix.",examples:["size(2.3)",\'size("hello world")\',"a = [1, 2; 3, 4; 5, 6]","size(a)","size(1:6)"],seealso:["concat","count","det","diag","identity","inv","ones","range","squeeze","subset","trace","transpose","zeros"]},sortDocs={name:"sort",category:"Matrix",syntax:["sort(x)","sort(x, compare)"],description:\'Sort the items in a matrix. Compare can be a string "asc", "desc", "natural", or a custom sort function.\',examples:["sort([5, 10, 1])",\'sort(["C", "B", "A", "D"], "natural")\',"sortByLength(a, b) = size(a)[1] - size(b)[1]",\'sort(["Langdon", "Tom", "Sara"], sortByLength)\',\'sort(["10", "1", "2"], "natural")\'],seealso:["map","filter","forEach"]},squeezeDocs={name:"squeeze",category:"Matrix",syntax:["squeeze(x)"],description:"Remove inner and outer singleton dimensions from a matrix.",examples:["a = zeros(3,2,1)","size(squeeze(a))","b = zeros(1,1,3)","size(squeeze(b))"],seealso:["concat","det","diag","identity","inv","ones","range","size","subset","trace","transpose","zeros"]},subsetDocs={name:"subset",category:"Matrix",syntax:["value(index)","value(index) = replacement","subset(value, [index])","subset(value, [index], replacement)"],description:"Get or set a subset of the entries of a matrix or characters of a string. Indexes are one-based. There should be one index specification for each dimension of the target. Each specification can be a single index, a list of indices, or a range in colon notation `l:u`. In a range, both the lower bound l and upper bound u are included; and if a bound is omitted it defaults to the most extreme valid value. The cartesian product of the indices specified in each dimension determines the target of the operation.",examples:["d = [1, 2; 3, 4]","e = []","e[1, 1:2] = [5, 6]","e[2, :] = [7, 8]","f = d * e","f[2, 1]","f[:, 1]","f[[1,2], [1,3]] = [9, 10; 11, 12]","f"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","trace","transpose","zeros"]},traceDocs={name:"trace",category:"Matrix",syntax:["trace(A)"],description:"Calculate the trace of a matrix: the sum of the elements on the main diagonal of a square matrix.",examples:["A = [1, 2, 3; -1, 2, 3; 2, 0, 3]","trace(A)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","transpose","zeros"]},transposeDocs={name:"transpose",category:"Matrix",syntax:["x\'","transpose(x)"],description:"Transpose a matrix",examples:["a = [1, 2, 3; 4, 5, 6]","a\'","transpose(a)"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","zeros"]},zerosDocs={name:"zeros",category:"Matrix",syntax:["zeros(m)","zeros(m, n)","zeros(m, n, p, ...)","zeros([m])","zeros([m, n])","zeros([m, n, p, ...])"],description:"Create a matrix containing zeros.",examples:["zeros(3)","zeros(3, 5)","a = [1, 2, 3; 4, 5, 6]","zeros(size(a))"],seealso:["concat","det","diag","identity","inv","ones","range","size","squeeze","subset","trace","transpose"]},fftDocs={name:"fft",category:"Matrix",syntax:["fft(x)"],description:"Calculate N-dimensional Fourier transform",examples:["fft([[1, 0], [1, 0]])"],seealso:["ifft"]},ifftDocs={name:"ifft",category:"Matrix",syntax:["ifft(x)"],description:"Calculate N-dimensional inverse Fourier transform",examples:["ifft([[2, 2], [0, 0]])"],seealso:["fft"]},bernoulliDocs={name:"bernoulli",category:"Probability",syntax:["bernoulli(n)"],description:"The nth Bernoulli number",examples:["bernoulli(4)","bernoulli(fraction(12))"],seealso:["combinations","gamma","stirlingS2"]},combinationsDocs={name:"combinations",category:"Probability",syntax:["combinations(n, k)"],description:"Compute the number of combinations of n items taken k at a time",examples:["combinations(7, 5)"],seealso:["combinationsWithRep","permutations","factorial"]},combinationsWithRepDocs={name:"combinationsWithRep",category:"Probability",syntax:["combinationsWithRep(n, k)"],description:"Compute the number of combinations of n items taken k at a time with replacements.",examples:["combinationsWithRep(7, 5)"],seealso:["combinations","permutations","factorial"]},factorialDocs={name:"factorial",category:"Probability",syntax:["n!","factorial(n)"],description:"Compute the factorial of a value",examples:["5!","5 * 4 * 3 * 2 * 1","3!"],seealso:["combinations","combinationsWithRep","permutations","gamma"]},gammaDocs={name:"gamma",category:"Probability",syntax:["gamma(n)"],description:"Compute the gamma function. For small values, the Lanczos approximation is used, and for large values the extended Stirling approximation.",examples:["gamma(4)","3!","gamma(1/2)","sqrt(pi)"],seealso:["factorial"]},lgammaDocs={name:"lgamma",category:"Probability",syntax:["lgamma(n)"],description:"Logarithm of the gamma function for real, positive numbers and complex numbers, using Lanczos approximation for numbers and Stirling series for complex numbers.",examples:["lgamma(4)","lgamma(1/2)","lgamma(i)","lgamma(complex(1.1, 2))"],seealso:["gamma"]},kldivergenceDocs={name:"kldivergence",category:"Probability",syntax:["kldivergence(x, y)"],description:"Calculate the Kullback-Leibler (KL) divergence  between two distributions.",examples:["kldivergence([0.7,0.5,0.4], [0.2,0.9,0.5])"],seealso:[]},multinomialDocs={name:"multinomial",category:"Probability",syntax:["multinomial(A)"],description:"Multinomial Coefficients compute the number of ways of picking a1, a2, ..., ai unordered outcomes from `n` possibilities. multinomial takes one array of integers as an argument. The following condition must be enforced: every ai > 0.",examples:["multinomial([1, 2, 1])"],seealso:["combinations","factorial"]},permutationsDocs={name:"permutations",category:"Probability",syntax:["permutations(n)","permutations(n, k)"],description:"Compute the number of permutations of n items taken k at a time",examples:["permutations(5)","permutations(5, 3)"],seealso:["combinations","combinationsWithRep","factorial"]},pickRandomDocs={name:"pickRandom",category:"Probability",syntax:["pickRandom(array)","pickRandom(array, number)","pickRandom(array, weights)","pickRandom(array, number, weights)","pickRandom(array, weights, number)"],description:"Pick a random entry from a given array.",examples:["pickRandom(0:10)","pickRandom([1, 3, 1, 6])","pickRandom([1, 3, 1, 6], 2)","pickRandom([1, 3, 1, 6], [2, 3, 2, 1])","pickRandom([1, 3, 1, 6], 2, [2, 3, 2, 1])","pickRandom([1, 3, 1, 6], [2, 3, 2, 1], 2)"],seealso:["random","randomInt"]},randomDocs={name:"random",category:"Probability",syntax:["random()","random(max)","random(min, max)","random(size)","random(size, max)","random(size, min, max)"],description:"Return a random number.",examples:["random()","random(10, 20)","random([2, 3])"],seealso:["pickRandom","randomInt"]},randomIntDocs={name:"randomInt",category:"Probability",syntax:["randomInt(max)","randomInt(min, max)","randomInt(size)","randomInt(size, max)","randomInt(size, min, max)"],description:"Return a random integer number",examples:["randomInt(10, 20)","randomInt([2, 3], 10)"],seealso:["pickRandom","random"]},compareDocs={name:"compare",category:"Relational",syntax:["compare(x, y)"],description:"Compare two values. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:["compare(2, 3)","compare(3, 2)","compare(2, 2)","compare(5cm, 40mm)","compare(2, [1, 2, 3])"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compareNatural","compareText"]},compareNaturalDocs={name:"compareNatural",category:"Relational",syntax:["compareNatural(x, y)"],description:"Compare two values of any type in a deterministic, natural way. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:["compareNatural(2, 3)","compareNatural(3, 2)","compareNatural(2, 2)","compareNatural(5cm, 40mm)",\'compareNatural("2", "10")\',"compareNatural(2 + 3i, 2 + 4i)","compareNatural([1, 2, 4], [1, 2, 3])","compareNatural([1, 5], [1, 2, 3])","compareNatural([1, 2], [1, 2])","compareNatural({a: 2}, {a: 4})"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compare","compareText"]},compareTextDocs={name:"compareText",category:"Relational",syntax:["compareText(x, y)"],description:"Compare two strings lexically. Comparison is case sensitive. Returns 1 when x > y, -1 when x < y, and 0 when x == y.",examples:[\'compareText("B", "A")\',\'compareText("A", "B")\',\'compareText("A", "A")\',\'compareText("2", "10")\',\'compare("2", "10")\',"compare(2, 10)",\'compareNatural("2", "10")\',\'compareText("B", ["A", "B", "C"])\'],seealso:["compare","compareNatural"]},deepEqualDocs={name:"deepEqual",category:"Relational",syntax:["deepEqual(x, y)"],description:"Check equality of two matrices element wise. Returns true if the size of both matrices is equal and when and each of the elements are equal.",examples:["deepEqual([1,3,4], [1,3,4])","deepEqual([1,3,4], [1,3])"],seealso:["equal","unequal","smaller","larger","smallerEq","largerEq","compare"]},equalDocs={name:"equal",category:"Relational",syntax:["x == y","equal(x, y)"],description:"Check equality of two values. Returns true if the values are equal, and false if not.",examples:["2+2 == 3","2+2 == 4","a = 3.2","b = 6-2.8","a == b","50cm == 0.5m"],seealso:["unequal","smaller","larger","smallerEq","largerEq","compare","deepEqual","equalText"]},equalTextDocs={name:"equalText",category:"Relational",syntax:["equalText(x, y)"],description:"Check equality of two strings. Comparison is case sensitive. Returns true if the values are equal, and false if not.",examples:[\'equalText("Hello", "Hello")\',\'equalText("a", "A")\',\'equal("2e3", "2000")\',\'equalText("2e3", "2000")\',\'equalText("B", ["A", "B", "C"])\'],seealso:["compare","compareNatural","compareText","equal"]},largerDocs={name:"larger",category:"Relational",syntax:["x > y","larger(x, y)"],description:"Check if value x is larger than y. Returns true if x is larger than y, and false if not. Comparing a value with NaN returns false.",examples:["2 > 3","5 > 2*2","a = 3.3","b = 6-2.8","(a > b)","(b < a)","5 cm > 2 inch"],seealso:["equal","unequal","smaller","smallerEq","largerEq","compare"]},largerEqDocs={name:"largerEq",category:"Relational",syntax:["x >= y","largerEq(x, y)"],description:"Check if value x is larger or equal to y. Returns true if x is larger or equal to y, and false if not.",examples:["2 >= 1+1","2 > 1+1","a = 3.2","b = 6-2.8","(a >= b)"],seealso:["equal","unequal","smallerEq","smaller","compare"]},smallerDocs={name:"smaller",category:"Relational",syntax:["x < y","smaller(x, y)"],description:"Check if value x is smaller than value y. Returns true if x is smaller than y, and false if not. Comparing a value with NaN returns false.",examples:["2 < 3","5 < 2*2","a = 3.3","b = 6-2.8","(a < b)","5 cm < 2 inch"],seealso:["equal","unequal","larger","smallerEq","largerEq","compare"]},smallerEqDocs={name:"smallerEq",category:"Relational",syntax:["x <= y","smallerEq(x, y)"],description:"Check if value x is smaller or equal to value y. Returns true if x is smaller than y, and false if not.",examples:["2 <= 1+1","2 < 1+1","a = 3.2","b = 6-2.8","(a <= b)"],seealso:["equal","unequal","larger","smaller","largerEq","compare"]},unequalDocs={name:"unequal",category:"Relational",syntax:["x != y","unequal(x, y)"],description:"Check unequality of two values. Returns true if the values are unequal, and false if they are equal.",examples:["2+2 != 3","2+2 != 4","a = 3.2","b = 6-2.8","a != b","50cm != 0.5m","5 cm != 2 inch"],seealso:["equal","smaller","larger","smallerEq","largerEq","compare","deepEqual"]},setCartesianDocs={name:"setCartesian",category:"Set",syntax:["setCartesian(set1, set2)"],description:"Create the cartesian product of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays and the values will be sorted in ascending order before the operation.",examples:["setCartesian([1, 2], [3, 4])"],seealso:["setUnion","setIntersect","setDifference","setPowerset"]},setDifferenceDocs={name:"setDifference",category:"Set",syntax:["setDifference(set1, set2)"],description:"Create the difference of two (multi)sets: every element of set1, that is not the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setDifference([1, 2, 3, 4], [3, 4, 5, 6])","setDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setIntersect","setSymDifference"]},setDistinctDocs={name:"setDistinct",category:"Set",syntax:["setDistinct(set)"],description:"Collect the distinct elements of a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setDistinct([1, 1, 1, 2, 2, 3])"],seealso:["setMultiplicity"]},setIntersectDocs={name:"setIntersect",category:"Set",syntax:["setIntersect(set1, set2)"],description:"Create the intersection of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setIntersect([1, 2, 3, 4], [3, 4, 5, 6])","setIntersect([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setDifference"]},setIsSubsetDocs={name:"setIsSubset",category:"Set",syntax:["setIsSubset(set1, set2)"],description:"Check whether a (multi)set is a subset of another (multi)set: every element of set1 is the element of set2. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setIsSubset([1, 2], [3, 4, 5, 6])","setIsSubset([3, 4], [3, 4, 5, 6])"],seealso:["setUnion","setIntersect","setDifference"]},setMultiplicityDocs={name:"setMultiplicity",category:"Set",syntax:["setMultiplicity(element, set)"],description:"Count the multiplicity of an element in a multiset. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setMultiplicity(1, [1, 2, 2, 4])","setMultiplicity(2, [1, 2, 2, 4])"],seealso:["setDistinct","setSize"]},setPowersetDocs={name:"setPowerset",category:"Set",syntax:["setPowerset(set)"],description:"Create the powerset of a (multi)set: the powerset contains very possible subsets of a (multi)set. A multi-dimension array will be converted to a single-dimension array before the operation.",examples:["setPowerset([1, 2, 3])"],seealso:["setCartesian"]},setSizeDocs={name:"setSize",category:"Set",syntax:["setSize(set)","setSize(set, unique)"],description:\'Count the number of elements of a (multi)set. When the second parameter "unique" is true, count only the unique values. A multi-dimension array will be converted to a single-dimension array before the operation.\',examples:["setSize([1, 2, 2, 4])","setSize([1, 2, 2, 4], true)"],seealso:["setUnion","setIntersect","setDifference"]},setSymDifferenceDocs={name:"setSymDifference",category:"Set",syntax:["setSymDifference(set1, set2)"],description:"Create the symmetric difference of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setSymDifference([1, 2, 3, 4], [3, 4, 5, 6])","setSymDifference([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setUnion","setIntersect","setDifference"]},setUnionDocs={name:"setUnion",category:"Set",syntax:["setUnion(set1, set2)"],description:"Create the union of two (multi)sets. Multi-dimension arrays will be converted to single-dimension arrays before the operation.",examples:["setUnion([1, 2, 3, 4], [3, 4, 5, 6])","setUnion([[1, 2], [3, 4]], [[3, 4], [5, 6]])"],seealso:["setIntersect","setDifference"]},zpk2tfDocs={name:"zpk2tf",category:"Signal",syntax:["zpk2tf(z, p, k)"],description:"Compute the transfer function of a zero-pole-gain model.",examples:["zpk2tf([1, 2], [-1, -2], 1)","zpk2tf([1, 2], [-1, -2])","zpk2tf([1 - 3i, 2 + 2i], [-1, -2])"],seealso:[]},freqzDocs={name:"freqz",category:"Signal",syntax:["freqz(b, a)","freqz(b, a, w)"],description:"Calculates the frequency response of a filter given its numerator and denominator coefficients.",examples:["freqz([1, 2], [1, 2, 3])","freqz([1, 2], [1, 2, 3], [0, 1])","freqz([1, 2], [1, 2, 3], 512)"],seealso:[]},erfDocs={name:"erf",category:"Special",syntax:["erf(x)"],description:"Compute the erf function of a value using a rational Chebyshev approximations for different intervals of x",examples:["erf(0.2)","erf(-0.5)","erf(4)"],seealso:[]},zetaDocs={name:"zeta",category:"Special",syntax:["zeta(s)"],description:"Compute the Riemann Zeta Function using an infinite series and Riemann\'s Functional Equation for the entire complex plane",examples:["zeta(0.2)","zeta(-0.5)","zeta(4)"],seealso:[]},madDocs={name:"mad",category:"Statistics",syntax:["mad(a, b, c, ...)","mad(A)"],description:"Compute the median absolute deviation of a matrix or a list with values. The median absolute deviation is defined as the median of the absolute deviations from the median.",examples:["mad(10, 20, 30)","mad([1, 2, 3])"],seealso:["mean","median","std","abs"]},maxDocs={name:"max",category:"Statistics",syntax:["max(a, b, c, ...)","max(A)","max(A, dimension)"],description:"Compute the maximum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.",examples:["max(2, 3, 4, 1)","max([2, 3, 4, 1])","max([2, 5; 4, 3])","max([2, 5; 4, 3], 1)","max([2, 5; 4, 3], 2)","max(2.7, 7.1, -4.5, 2.0, 4.1)","min(2.7, 7.1, -4.5, 2.0, 4.1)"],seealso:["mean","median","min","prod","std","sum","variance"]},meanDocs={name:"mean",category:"Statistics",syntax:["mean(a, b, c, ...)","mean(A)","mean(A, dimension)"],description:"Compute the arithmetic mean of a list of values.",examples:["mean(2, 3, 4, 1)","mean([2, 3, 4, 1])","mean([2, 5; 4, 3])","mean([2, 5; 4, 3], 1)","mean([2, 5; 4, 3], 2)","mean([1.0, 2.7, 3.2, 4.0])"],seealso:["max","median","min","prod","std","sum","variance"]},medianDocs={name:"median",category:"Statistics",syntax:["median(a, b, c, ...)","median(A)"],description:"Compute the median of all values. The values are sorted and the middle value is returned. In case of an even number of values, the average of the two middle values is returned.",examples:["median(5, 2, 7)","median([3, -1, 5, 7])"],seealso:["max","mean","min","prod","std","sum","variance","quantileSeq"]},minDocs={name:"min",category:"Statistics",syntax:["min(a, b, c, ...)","min(A)","min(A, dimension)"],description:"Compute the minimum value of a list of values. If any NaN values are found, the function yields the last NaN in the input.",examples:["min(2, 3, 4, 1)","min([2, 3, 4, 1])","min([2, 5; 4, 3])","min([2, 5; 4, 3], 1)","min([2, 5; 4, 3], 2)","min(2.7, 7.1, -4.5, 2.0, 4.1)","max(2.7, 7.1, -4.5, 2.0, 4.1)"],seealso:["max","mean","median","prod","std","sum","variance"]},modeDocs={name:"mode",category:"Statistics",syntax:["mode(a, b, c, ...)","mode(A)","mode(A, a, b, B, c, ...)"],description:"Computes the mode of all values as an array. In case mode being more than one, multiple values are returned in an array.",examples:["mode(2, 1, 4, 3, 1)","mode([1, 2.7, 3.2, 4, 2.7])","mode(1, 4, 6, 1, 6)"],seealso:["max","mean","min","median","prod","std","sum","variance"]},prodDocs={name:"prod",category:"Statistics",syntax:["prod(a, b, c, ...)","prod(A)"],description:"Compute the product of all values.",examples:["prod(2, 3, 4)","prod([2, 3, 4])","prod([2, 5; 4, 3])"],seealso:["max","mean","min","median","min","std","sum","variance"]},quantileSeqDocs={name:"quantileSeq",category:"Statistics",syntax:["quantileSeq(A, prob[, sorted])","quantileSeq(A, [prob1, prob2, ...][, sorted])","quantileSeq(A, N[, sorted])"],description:`Compute the prob order quantile of a matrix or a list with values. The sequence is sorted and the middle value is returned. Supported types of sequence values are: Number, BigNumber, Unit Supported types of probability are: Number, BigNumber. \n\nIn case of a (multi dimensional) array or matrix, the prob order quantile of all elements will be calculated.`,examples:["quantileSeq([3, -1, 5, 7], 0.5)","quantileSeq([3, -1, 5, 7], [1/3, 2/3])","quantileSeq([3, -1, 5, 7], 2)","quantileSeq([-1, 3, 5, 7], 0.5, true)"],seealso:["mean","median","min","max","prod","std","sum","variance"]},stdDocs={name:"std",category:"Statistics",syntax:["std(a, b, c, ...)","std(A)","std(A, dimension)","std(A, normalization)","std(A, dimension, normalization)"],description:\'Compute the standard deviation of all values, defined as std(A) = sqrt(variance(A)). Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".\',examples:["std(2, 4, 6)","std([2, 4, 6, 8])",\'std([2, 4, 6, 8], "uncorrected")\',\'std([2, 4, 6, 8], "biased")\',"std([1, 2, 3; 4, 5, 6])"],seealso:["max","mean","min","median","prod","sum","variance"]},cumSumDocs={name:"cumsum",category:"Statistics",syntax:["cumsum(a, b, c, ...)","cumsum(A)"],description:"Compute the cumulative sum of all values.",examples:["cumsum(2, 3, 4, 1)","cumsum([2, 3, 4, 1])","cumsum([1, 2; 3, 4])","cumsum([1, 2; 3, 4], 1)","cumsum([1, 2; 3, 4], 2)"],seealso:["max","mean","median","min","prod","std","sum","variance"]},sumDocs={name:"sum",category:"Statistics",syntax:["sum(a, b, c, ...)","sum(A)","sum(A, dimension)"],description:"Compute the sum of all values.",examples:["sum(2, 3, 4, 1)","sum([2, 3, 4, 1])","sum([2, 5; 4, 3])"],seealso:["max","mean","median","min","prod","std","variance"]},varianceDocs={name:"variance",category:"Statistics",syntax:["variance(a, b, c, ...)","variance(A)","variance(A, dimension)","variance(A, normalization)","variance(A, dimension, normalization)"],description:\'Compute the variance of all values. Optional parameter normalization can be "unbiased" (default), "uncorrected", or "biased".\',examples:["variance(2, 4, 6)","variance([2, 4, 6, 8])",\'variance([2, 4, 6, 8], "uncorrected")\',\'variance([2, 4, 6, 8], "biased")\',"variance([1, 2, 3; 4, 5, 6])"],seealso:["max","mean","min","median","min","prod","std","sum"]},corrDocs={name:"corr",category:"Statistics",syntax:["corr(A,B)"],description:"Compute the correlation coefficient of a two list with values, For matrices, the matrix correlation coefficient is calculated.",examples:["corr([2, 4, 6, 8],[1, 2, 3, 6])","corr(matrix([[1, 2.2, 3, 4.8, 5], [1, 2, 3, 4, 5]]), matrix([[4, 5.3, 6.6, 7, 8], [1, 2, 3, 4, 5]]))"],seealso:["max","mean","min","median","min","prod","std","sum"]},acosDocs={name:"acos",category:"Trigonometry",syntax:["acos(x)"],description:"Compute the inverse cosine of a value in radians.",examples:["acos(0.5)","acos(cos(2.3))"],seealso:["cos","atan","asin"]},acoshDocs={name:"acosh",category:"Trigonometry",syntax:["acosh(x)"],description:"Calculate the hyperbolic arccos of a value, defined as `acosh(x) = ln(sqrt(x^2 - 1) + x)`.",examples:["acosh(1.5)"],seealso:["cosh","asinh","atanh"]},acotDocs={name:"acot",category:"Trigonometry",syntax:["acot(x)"],description:"Calculate the inverse cotangent of a value.",examples:["acot(0.5)","acot(cot(0.5))","acot(2)"],seealso:["cot","atan"]},acothDocs={name:"acoth",category:"Trigonometry",syntax:["acoth(x)"],description:"Calculate the inverse hyperbolic tangent of a value, defined as `acoth(x) = (ln((x+1)/x) + ln(x/(x-1))) / 2`.",examples:["acoth(2)","acoth(0.5)"],seealso:["acsch","asech"]},acscDocs={name:"acsc",category:"Trigonometry",syntax:["acsc(x)"],description:"Calculate the inverse cotangent of a value.",examples:["acsc(2)","acsc(csc(0.5))","acsc(0.5)"],seealso:["csc","asin","asec"]},acschDocs={name:"acsch",category:"Trigonometry",syntax:["acsch(x)"],description:"Calculate the inverse hyperbolic cosecant of a value, defined as `acsch(x) = ln(1/x + sqrt(1/x^2 + 1))`.",examples:["acsch(0.5)"],seealso:["asech","acoth"]},asecDocs={name:"asec",category:"Trigonometry",syntax:["asec(x)"],description:"Calculate the inverse secant of a value.",examples:["asec(0.5)","asec(sec(0.5))","asec(2)"],seealso:["acos","acot","acsc"]},asechDocs={name:"asech",category:"Trigonometry",syntax:["asech(x)"],description:"Calculate the inverse secant of a value.",examples:["asech(0.5)"],seealso:["acsch","acoth"]},asinDocs={name:"asin",category:"Trigonometry",syntax:["asin(x)"],description:"Compute the inverse sine of a value in radians.",examples:["asin(0.5)","asin(sin(0.5))"],seealso:["sin","acos","atan"]},asinhDocs={name:"asinh",category:"Trigonometry",syntax:["asinh(x)"],description:"Calculate the hyperbolic arcsine of a value, defined as `asinh(x) = ln(x + sqrt(x^2 + 1))`.",examples:["asinh(0.5)"],seealso:["acosh","atanh"]},atanDocs={name:"atan",category:"Trigonometry",syntax:["atan(x)"],description:"Compute the inverse tangent of a value in radians.",examples:["atan(0.5)","atan(tan(0.5))"],seealso:["tan","acos","asin"]},atan2Docs={name:"atan2",category:"Trigonometry",syntax:["atan2(y, x)"],description:"Computes the principal value of the arc tangent of y/x in radians.",examples:["atan2(2, 2) / pi","angle = 60 deg in rad","x = cos(angle)","y = sin(angle)","atan2(y, x)"],seealso:["sin","cos","tan"]},atanhDocs={name:"atanh",category:"Trigonometry",syntax:["atanh(x)"],description:"Calculate the hyperbolic arctangent of a value, defined as `atanh(x) = ln((1 + x)/(1 - x)) / 2`.",examples:["atanh(0.5)"],seealso:["acosh","asinh"]},cosDocs={name:"cos",category:"Trigonometry",syntax:["cos(x)"],description:"Compute the cosine of x in radians.",examples:["cos(2)","cos(pi / 4) ^ 2","cos(180 deg)","cos(60 deg)","sin(0.2)^2 + cos(0.2)^2"],seealso:["acos","sin","tan"]},coshDocs={name:"cosh",category:"Trigonometry",syntax:["cosh(x)"],description:"Compute the hyperbolic cosine of x in radians.",examples:["cosh(0.5)"],seealso:["sinh","tanh","coth"]},cotDocs={name:"cot",category:"Trigonometry",syntax:["cot(x)"],description:"Compute the cotangent of x in radians. Defined as 1/tan(x)",examples:["cot(2)","1 / tan(2)"],seealso:["sec","csc","tan"]},cothDocs={name:"coth",category:"Trigonometry",syntax:["coth(x)"],description:"Compute the hyperbolic cotangent of x in radians.",examples:["coth(2)","1 / tanh(2)"],seealso:["sech","csch","tanh"]},cscDocs={name:"csc",category:"Trigonometry",syntax:["csc(x)"],description:"Compute the cosecant of x in radians. Defined as 1/sin(x)",examples:["csc(2)","1 / sin(2)"],seealso:["sec","cot","sin"]},cschDocs={name:"csch",category:"Trigonometry",syntax:["csch(x)"],description:"Compute the hyperbolic cosecant of x in radians. Defined as 1/sinh(x)",examples:["csch(2)","1 / sinh(2)"],seealso:["sech","coth","sinh"]},secDocs={name:"sec",category:"Trigonometry",syntax:["sec(x)"],description:"Compute the secant of x in radians. Defined as 1/cos(x)",examples:["sec(2)","1 / cos(2)"],seealso:["cot","csc","cos"]},sechDocs={name:"sech",category:"Trigonometry",syntax:["sech(x)"],description:"Compute the hyperbolic secant of x in radians. Defined as 1/cosh(x)",examples:["sech(2)","1 / cosh(2)"],seealso:["coth","csch","cosh"]},sinDocs={name:"sin",category:"Trigonometry",syntax:["sin(x)"],description:"Compute the sine of x in radians.",examples:["sin(2)","sin(pi / 4) ^ 2","sin(90 deg)","sin(30 deg)","sin(0.2)^2 + cos(0.2)^2"],seealso:["asin","cos","tan"]},sinhDocs={name:"sinh",category:"Trigonometry",syntax:["sinh(x)"],description:"Compute the hyperbolic sine of x in radians.",examples:["sinh(0.5)"],seealso:["cosh","tanh"]},tanDocs={name:"tan",category:"Trigonometry",syntax:["tan(x)"],description:"Compute the tangent of x in radians.",examples:["tan(0.5)","sin(0.5) / cos(0.5)","tan(pi / 4)","tan(45 deg)"],seealso:["atan","sin","cos"]},tanhDocs={name:"tanh",category:"Trigonometry",syntax:["tanh(x)"],description:"Compute the hyperbolic tangent of x in radians.",examples:["tanh(0.5)","sinh(0.5) / cosh(0.5)"],seealso:["sinh","cosh"]},toDocs={name:"to",category:"Units",syntax:["x to unit","to(x, unit)"],description:"Change the unit of a value.",examples:["5 inch to cm","3.2kg to g","16 bytes in bits"],seealso:[]},toBestDocs={name:"toBest",category:"Units",syntax:["toBest(x)","toBest(x, unitList)","toBest(x, unitList, options)"],description:"Converts to the most appropriate display unit.",examples:[\'toBest(unit(5000, "m"))\',\'toBest(unit(3500000, "W"))\',\'toBest(unit(0.000000123, "A"))\',\'toBest(unit(10, "m"), "cm")\',\'toBest(unit(10, "m"), "mm,km", {offset: 1.5})\'],seealso:[]},binDocs={name:"bin",category:"Utils",syntax:["bin(value)"],description:"Format a number as binary",examples:["bin(2)"],seealso:["oct","hex"]},cloneDocs={name:"clone",category:"Utils",syntax:["clone(x)"],description:"Clone a variable. Creates a copy of primitive variables, and a deep copy of matrices",examples:["clone(3.5)","clone(2 - 4i)","clone(45 deg)","clone([1, 2; 3, 4])",\'clone("hello world")\'],seealso:[]},formatDocs={name:"format",category:"Utils",syntax:["format(value)","format(value, precision)"],description:"Format a value of any type as string.",examples:["format(2.3)","format(3 - 4i)","format([])","format(pi, 3)"],seealso:["print"]},hasNumericValueDocs={name:"hasNumericValue",category:"Utils",syntax:["hasNumericValue(x)"],description:"Test whether a value is an numeric value. In case of a string, true is returned if the string contains a numeric value.",examples:["hasNumericValue(2)",\'hasNumericValue("2")\',\'isNumeric("2")\',"hasNumericValue(0)","hasNumericValue(bignumber(500))","hasNumericValue(fraction(0.125))","hasNumericValue(2 + 3i)",\'hasNumericValue([2.3, "foo", false])\'],seealso:["isInteger","isZero","isNegative","isPositive","isNaN","isNumeric"]},hexDocs={name:"hex",category:"Utils",syntax:["hex(value)"],description:"Format a number as hexadecimal",examples:["hex(240)"],seealso:["bin","oct"]},isIntegerDocs={name:"isInteger",category:"Utils",syntax:["isInteger(x)"],description:"Test whether a value is an integer number.",examples:["isInteger(2)","isInteger(3.5)","isInteger([3, 0.5, -2])"],seealso:["isNegative","isNumeric","isPositive","isZero"]},isNaNDocs={name:"isNaN",category:"Utils",syntax:["isNaN(x)"],description:"Test whether a value is NaN (not a number)",examples:["isNaN(2)","isNaN(0 / 0)","isNaN(NaN)","isNaN(Infinity)"],seealso:["isNegative","isNumeric","isPositive","isZero","isFinite","isBounded"]},isBoundedDocs={name:"isBounded",category:"Utils",syntax:["isBounded(x)"],description:"Test whether a value or its entries are bounded.",examples:["isBounded(Infinity)","isBounded(bigint(3))","isBounded([3, -Infinity, -3])"],seealso:["isFinite","isNumeric","isNaN","isNegative","isPositive"]},isFiniteDocs={name:"isFinite",category:"Utils",syntax:["isFinite(x)"],description:"Test whether a value is finite, elementwise on collections.",examples:["isFinite(Infinity)","isFinite(bigint(3))","isFinite([3, -Infinity, -3])"],seealso:["isBounded","isNumeric","isNaN","isNegative","isPositive"]},isNegativeDocs={name:"isNegative",category:"Utils",syntax:["isNegative(x)"],description:"Test whether a value is negative: smaller than zero.",examples:["isNegative(2)","isNegative(0)","isNegative(-4)","isNegative([3, 0.5, -2])"],seealso:["isInteger","isNumeric","isPositive","isZero"]},isNumericDocs={name:"isNumeric",category:"Utils",syntax:["isNumeric(x)"],description:"Test whether a value is a numeric value. Returns true when the input is a number, BigNumber, Fraction, or boolean.",examples:["isNumeric(2)",\'isNumeric("2")\',\'hasNumericValue("2")\',"isNumeric(0)","isNumeric(bignumber(500))","isNumeric(fraction(0.125))","isNumeric(2 + 3i)",\'isNumeric([2.3, "foo", false])\'],seealso:["isInteger","isZero","isNegative","isPositive","isNaN","hasNumericValue","isFinite","isBounded"]},isPositiveDocs={name:"isPositive",category:"Utils",syntax:["isPositive(x)"],description:"Test whether a value is positive: larger than zero.",examples:["isPositive(2)","isPositive(0)","isPositive(-4)","isPositive([3, 0.5, -2])"],seealso:["isInteger","isNumeric","isNegative","isZero"]},isPrimeDocs={name:"isPrime",category:"Utils",syntax:["isPrime(x)"],description:"Test whether a value is prime: has no divisors other than itself and one.",examples:["isPrime(3)","isPrime(-2)","isPrime([2, 17, 100])"],seealso:["isInteger","isNumeric","isNegative","isZero"]},isZeroDocs={name:"isZero",category:"Utils",syntax:["isZero(x)"],description:"Test whether a value is zero.",examples:["isZero(2)","isZero(0)","isZero(-4)","isZero([3, 0, -2, 0])"],seealso:["isInteger","isNumeric","isNegative","isPositive"]},numericDocs={name:"numeric",category:"Utils",syntax:["numeric(x)"],description:"Convert a numeric input to a specific numeric type: number, BigNumber, bigint, or Fraction.",examples:[\'numeric("4")\',\'numeric("4", "number")\',\'numeric("4", "bigint")\',\'numeric("4", "BigNumber")\',\'numeric("4", "Fraction")\',\'numeric(4, "Fraction")\',\'numeric(fraction(2, 5), "number")\'],seealso:["number","bigint","fraction","bignumber","string","format"]},octDocs={name:"oct",category:"Utils",syntax:["oct(value)"],description:"Format a number as octal",examples:["oct(56)"],seealso:["bin","hex"]},printDocs={name:"print",category:"Utils",syntax:["print(template, values)","print(template, values, precision)"],description:"Interpolate values into a string template.",examples:[\'print("Lucy is $age years old", {age: 5})\',\'print("The value of pi is $pi", {pi: pi}, 3)\',\'print("Hello, $user.name!", {user: {name: "John"}})\',\'print("Values: $1, $2, $3", [6, 9, 4])\'],seealso:["format"]},typeOfDocs={name:"typeOf",category:"Utils",syntax:["typeOf(x)"],description:"Get the type of a variable.",examples:["typeOf(3.5)","typeOf(2 - 4i)","typeOf(45 deg)",\'typeOf("hello world")\'],seealso:["getMatrixDataType"]},solveODEDocs={name:"solveODE",category:"Numeric",syntax:["solveODE(func, tspan, y0)","solveODE(func, tspan, y0, options)"],description:"Numerical Integration of Ordinary Differential Equations.",examples:["f(t,y) = y","tspan = [0, 4]","solveODE(f, tspan, 1)","solveODE(f, tspan, [1, 2])",\'solveODE(f, tspan, 1, { method:"RK23", maxStep:0.1 })\'],seealso:["derivative","simplifyCore"]},embeddedDocs={bignumber:bignumberDocs,bigint:bigintDocs,boolean:booleanDocs,complex:complexDocs,createUnit:createUnitDocs,fraction:fractionDocs,index:indexDocs,matrix:matrixDocs,number:numberDocs,sparse:sparseDocs,splitUnit:splitUnitDocs,string:stringDocs,unit:unitDocs,e:eDocs,E:eDocs,false:falseDocs,i:iDocs,Infinity:InfinityDocs,LN2:LN2Docs,LN10:LN10Docs,LOG2E:LOG2EDocs,LOG10E:LOG10EDocs,NaN:NaNDocs,null:nullDocs,pi:piDocs,PI:piDocs,phi:phiDocs,SQRT1_2:SQRT12Docs,SQRT2:SQRT2Docs,tau:tauDocs,true:trueDocs,version:versionDocs,speedOfLight:{description:"Speed of light in vacuum",examples:["speedOfLight"]},gravitationConstant:{description:"Newtonian constant of gravitation",examples:["gravitationConstant"]},planckConstant:{description:"Planck constant",examples:["planckConstant"]},reducedPlanckConstant:{description:"Reduced Planck constant",examples:["reducedPlanckConstant"]},magneticConstant:{description:"Magnetic constant (vacuum permeability)",examples:["magneticConstant"]},electricConstant:{description:"Electric constant (vacuum permeability)",examples:["electricConstant"]},vacuumImpedance:{description:"Characteristic impedance of vacuum",examples:["vacuumImpedance"]},coulomb:{description:"Coulomb\'s constant. Deprecated in favor of coulombConstant",examples:["coulombConstant"]},coulombConstant:{description:"Coulomb\'s constant",examples:["coulombConstant"]},elementaryCharge:{description:"Elementary charge",examples:["elementaryCharge"]},bohrMagneton:{description:"Bohr magneton",examples:["bohrMagneton"]},conductanceQuantum:{description:"Conductance quantum",examples:["conductanceQuantum"]},inverseConductanceQuantum:{description:"Inverse conductance quantum",examples:["inverseConductanceQuantum"]},magneticFluxQuantum:{description:"Magnetic flux quantum",examples:["magneticFluxQuantum"]},nuclearMagneton:{description:"Nuclear magneton",examples:["nuclearMagneton"]},klitzing:{description:"Von Klitzing constant",examples:["klitzing"]},bohrRadius:{description:"Bohr radius",examples:["bohrRadius"]},classicalElectronRadius:{description:"Classical electron radius",examples:["classicalElectronRadius"]},electronMass:{description:"Electron mass",examples:["electronMass"]},fermiCoupling:{description:"Fermi coupling constant",examples:["fermiCoupling"]},fineStructure:{description:"Fine-structure constant",examples:["fineStructure"]},hartreeEnergy:{description:"Hartree energy",examples:["hartreeEnergy"]},protonMass:{description:"Proton mass",examples:["protonMass"]},deuteronMass:{description:"Deuteron Mass",examples:["deuteronMass"]},neutronMass:{description:"Neutron mass",examples:["neutronMass"]},quantumOfCirculation:{description:"Quantum of circulation",examples:["quantumOfCirculation"]},rydberg:{description:"Rydberg constant",examples:["rydberg"]},thomsonCrossSection:{description:"Thomson cross section",examples:["thomsonCrossSection"]},weakMixingAngle:{description:"Weak mixing angle",examples:["weakMixingAngle"]},efimovFactor:{description:"Efimov factor",examples:["efimovFactor"]},atomicMass:{description:"Atomic mass constant",examples:["atomicMass"]},avogadro:{description:"Avogadro\'s number",examples:["avogadro"]},boltzmann:{description:"Boltzmann constant",examples:["boltzmann"]},faraday:{description:"Faraday constant",examples:["faraday"]},firstRadiation:{description:"First radiation constant",examples:["firstRadiation"]},loschmidt:{description:"Loschmidt constant at T=273.15 K and p=101.325 kPa",examples:["loschmidt"]},gasConstant:{description:"Gas constant",examples:["gasConstant"]},molarPlanckConstant:{description:"Molar Planck constant",examples:["molarPlanckConstant"]},molarVolume:{description:"Molar volume of an ideal gas at T=273.15 K and p=101.325 kPa",examples:["molarVolume"]},sackurTetrode:{description:"Sackur-Tetrode constant at T=1 K and p=101.325 kPa",examples:["sackurTetrode"]},secondRadiation:{description:"Second radiation constant",examples:["secondRadiation"]},stefanBoltzmann:{description:"Stefan-Boltzmann constant",examples:["stefanBoltzmann"]},wienDisplacement:{description:"Wien displacement law constant",examples:["wienDisplacement"]},molarMass:{description:"Molar mass constant",examples:["molarMass"]},molarMassC12:{description:"Molar mass constant of carbon-12",examples:["molarMassC12"]},gravity:{description:"Standard acceleration of gravity (standard acceleration of free-fall on Earth)",examples:["gravity"]},planckLength:{description:"Planck length",examples:["planckLength"]},planckMass:{description:"Planck mass",examples:["planckMass"]},planckTime:{description:"Planck time",examples:["planckTime"]},planckCharge:{description:"Planck charge",examples:["planckCharge"]},planckTemperature:{description:"Planck temperature",examples:["planckTemperature"]},derivative:derivativeDocs,lsolve:lsolveDocs,lsolveAll:lsolveAllDocs,lup:lupDocs,lusolve:lusolveDocs,leafCount:leafCountDocs,polynomialRoot:polynomialRootDocs,resolve:resolveDocs,simplify:simplifyDocs,simplifyConstant:simplifyConstantDocs,simplifyCore:simplifyCoreDocs,symbolicEqual:symbolicEqualDocs,rationalize:rationalizeDocs,slu:sluDocs,usolve:usolveDocs,usolveAll:usolveAllDocs,qr:qrDocs,abs:absDocs,add:addDocs,cbrt:cbrtDocs,ceil:ceilDocs,cube:cubeDocs,divide:divideDocs,dotDivide:dotDivideDocs,dotMultiply:dotMultiplyDocs,dotPow:dotPowDocs,exp:expDocs,expm:expmDocs,expm1:expm1Docs,fix:fixDocs,floor:floorDocs,gcd:gcdDocs,hypot:hypotDocs,lcm:lcmDocs,log:logDocs,log2:log2Docs,log1p:log1pDocs,log10:log10Docs,mod:modDocs,multiply:multiplyDocs,norm:normDocs,nthRoot:nthRootDocs,nthRoots:nthRootsDocs,pow:powDocs,round:roundDocs,sign:signDocs,sqrt:sqrtDocs,sqrtm:sqrtmDocs,square:squareDocs,subtract:subtractDocs,unaryMinus:unaryMinusDocs,unaryPlus:unaryPlusDocs,xgcd:xgcdDocs,invmod:invmodDocs,num:numDocs,den:denDocs,bitAnd:bitAndDocs,bitNot:bitNotDocs,bitOr:bitOrDocs,bitXor:bitXorDocs,leftShift:leftShiftDocs,rightArithShift:rightArithShiftDocs,rightLogShift:rightLogShiftDocs,bellNumbers:bellNumbersDocs,catalan:catalanDocs,composition:compositionDocs,stirlingS2:stirlingS2Docs,config:configDocs,import:importDocs,typed:typedDocs,arg:argDocs,conj:conjDocs,re:reDocs,im:imDocs,evaluate:evaluateDocs,help:helpDocs,parse:parseDocs,parser:parserDocs,compile:compileDocs,distance:distanceDocs,intersect:intersectDocs,and:andDocs,not:notDocs,nullish:nullishDocs,or:orDocs,xor:xorDocs,mapSlices:mapSlicesDocs,concat:concatDocs,count:countDocs,cross:crossDocs,column:columnDocs,ctranspose:ctransposeDocs,det:detDocs,diag:diagDocs,diff:diffDocs,dot:dotDocs,getMatrixDataType:getMatrixDataTypeDocs,identity:identityDocs,filter:filterDocs,flatten:flattenDocs,forEach:forEachDocs,inv:invDocs,pinv:pinvDocs,eigs:eigsDocs,kron:kronDocs,matrixFromFunction:matrixFromFunctionDocs,matrixFromRows:matrixFromRowsDocs,matrixFromColumns:matrixFromColumnsDocs,map:mapDocs,ones:onesDocs,partitionSelect:partitionSelectDocs,range:rangeDocs,resize:resizeDocs,reshape:reshapeDocs,rotate:rotateDocs,rotationMatrix:rotationMatrixDocs,row:rowDocs,size:sizeDocs,sort:sortDocs,squeeze:squeezeDocs,subset:subsetDocs,trace:traceDocs,transpose:transposeDocs,zeros:zerosDocs,fft:fftDocs,ifft:ifftDocs,sylvester:sylvesterDocs,schur:schurDocs,lyap:lyapDocs,solveODE:solveODEDocs,bernoulli:bernoulliDocs,combinations:combinationsDocs,combinationsWithRep:combinationsWithRepDocs,factorial:factorialDocs,gamma:gammaDocs,kldivergence:kldivergenceDocs,lgamma:lgammaDocs,multinomial:multinomialDocs,permutations:permutationsDocs,pickRandom:pickRandomDocs,random:randomDocs,randomInt:randomIntDocs,compare:compareDocs,compareNatural:compareNaturalDocs,compareText:compareTextDocs,deepEqual:deepEqualDocs,equal:equalDocs,equalText:equalTextDocs,larger:largerDocs,largerEq:largerEqDocs,smaller:smallerDocs,smallerEq:smallerEqDocs,unequal:unequalDocs,setCartesian:setCartesianDocs,setDifference:setDifferenceDocs,setDistinct:setDistinctDocs,setIntersect:setIntersectDocs,setIsSubset:setIsSubsetDocs,setMultiplicity:setMultiplicityDocs,setPowerset:setPowersetDocs,setSize:setSizeDocs,setSymDifference:setSymDifferenceDocs,setUnion:setUnionDocs,zpk2tf:zpk2tfDocs,freqz:freqzDocs,erf:erfDocs,zeta:zetaDocs,cumsum:cumSumDocs,mad:madDocs,max:maxDocs,mean:meanDocs,median:medianDocs,min:minDocs,mode:modeDocs,prod:prodDocs,quantileSeq:quantileSeqDocs,std:stdDocs,sum:sumDocs,variance:varianceDocs,corr:corrDocs,acos:acosDocs,acosh:acoshDocs,acot:acotDocs,acoth:acothDocs,acsc:acscDocs,acsch:acschDocs,asec:asecDocs,asech:asechDocs,asin:asinDocs,asinh:asinhDocs,atan:atanDocs,atanh:atanhDocs,atan2:atan2Docs,cos:cosDocs,cosh:coshDocs,cot:cotDocs,coth:cothDocs,csc:cscDocs,csch:cschDocs,sec:secDocs,sech:sechDocs,sin:sinDocs,sinh:sinhDocs,tan:tanDocs,tanh:tanhDocs,to:toDocs,toBest:toBestDocs,clone:cloneDocs,format:formatDocs,bin:binDocs,oct:octDocs,hex:hexDocs,isNaN:isNaNDocs,isBounded:isBoundedDocs,isFinite:isFiniteDocs,isInteger:isIntegerDocs,isNegative:isNegativeDocs,isNumeric:isNumericDocs,hasNumericValue:hasNumericValueDocs,isPositive:isPositiveDocs,isPrime:isPrimeDocs,isZero:isZeroDocs,print:printDocs,typeOf:typeOfDocs,numeric:numericDocs},name$79="help",dependencies$79=["typed","mathWithTransform","Help"],createHelp=factory(name$79,dependencies$79,D=>{var{typed:E,mathWithTransform:F,Help:J}=D;return E(name$79,{any:function($e){var _t,lr=$e;if(typeof $e!="string"){for(_t in F)if(hasOwnProperty$1(F,_t)&&$e===F[_t]){lr=_t;break}}var mr=getSafeProperty(embeddedDocs,lr);if(!mr){var Or=typeof lr=="function"?lr.name:lr;throw Error(\'No documentation found on "\'+Or+\'"\')}return new J(mr)}})}),name$78="chain",dependencies$78=["typed","Chain"],createChain=factory(name$78,dependencies$78,D=>{var{typed:E,Chain:F}=D;return E(name$78,{"":function(){return new F},any:function(J){return new F(J)}})}),name$77="det",dependencies$77=["typed","matrix","subtractScalar","multiply","divideScalar","isZero","unaryMinus"],createDet=factory(name$77,dependencies$77,D=>{var{typed:E,matrix:F,subtractScalar:J,multiply:$e,divideScalar:_t,isZero:lr,unaryMinus:mr}=D;return E(name$77,{any:function(Pr){return clone$3(Pr)},"Array | Matrix":function(Pr){var dn;switch(isMatrix(Pr)?dn=Pr.size():Array.isArray(Pr)?(Pr=F(Pr),dn=Pr.size()):dn=[],dn.length){case 0:return clone$3(Pr);case 1:if(dn[0]===1)return clone$3(Pr.valueOf()[0]);if(dn[0]===0)return 1;throw RangeError("Matrix must be square (size: "+format(dn)+")");case 2:var gi=dn[0],qi=dn[1];if(gi===qi)return Or(Pr.clone().valueOf(),gi);if(qi===0)return 1;throw RangeError("Matrix must be square (size: "+format(dn)+")");default:throw RangeError("Matrix must be two dimensional (size: "+format(dn)+")")}}});function Or(Pr,dn,gi){if(dn===1)return clone$3(Pr[0][0]);if(dn===2)return J($e(Pr[0][0],Pr[1][1]),$e(Pr[1][0],Pr[0][1]));for(var qi=!1,zi=Array(dn).fill(0).map((na,ra)=>ra),Hi=0;Hi<dn;Hi++){var Qi=zi[Hi];if(lr(Pr[Qi][Hi])){var Gi=void 0;for(Gi=Hi+1;Gi<dn;Gi++)if(!lr(Pr[zi[Gi]][Hi])){Qi=zi[Gi],zi[Gi]=zi[Hi],zi[Hi]=Qi,qi=!qi;break}if(Gi===dn)return Pr[Qi][Hi]}for(var Zi=Pr[Qi][Hi],Xi=Hi===0?1:Pr[zi[Hi-1]][Hi-1],Ki=Hi+1;Ki<dn;Ki++)for(var ea=zi[Ki],Ji=Hi+1;Ji<dn;Ji++)Pr[ea][Ji]=_t(J($e(Pr[ea][Ji],Zi),$e(Pr[ea][Hi],Pr[Qi][Ji])),Xi)}var ta=Pr[zi[dn-1]][dn-1];return qi?mr(ta):ta}}),name$76="inv",dependencies$76=["typed","matrix","divideScalar","addScalar","multiply","unaryMinus","det","identity","abs"],createInv=factory(name$76,dependencies$76,D=>{var{typed:E,matrix:F,divideScalar:J,addScalar:$e,multiply:_t,unaryMinus:lr,det:mr,identity:Or,abs:Pr}=D;return E(name$76,{"Array | Matrix":function(gi){var qi=isMatrix(gi)?gi.size():arraySize(gi);switch(qi.length){case 1:if(qi[0]===1)return isMatrix(gi)?F([J(1,gi.valueOf()[0])]):[J(1,gi[0])];throw RangeError("Matrix must be square (size: "+format(qi)+")");case 2:var zi=qi[0],Hi=qi[1];if(zi===Hi)return isMatrix(gi)?F(dn(gi.valueOf(),zi,Hi),gi.storage()):dn(gi,zi,Hi);throw RangeError("Matrix must be square (size: "+format(qi)+")");default:throw RangeError("Matrix must be two dimensional (size: "+format(qi)+")")}},any:function(gi){return J(1,gi)}});function dn(gi,qi,zi){var Hi,Qi,Gi,Zi,Xi;if(qi===1){if(Zi=gi[0][0],Zi===0)throw Error("Cannot calculate inverse, determinant is zero");return[[J(1,Zi)]]}else if(qi===2){var Ki=mr(gi);if(Ki===0)throw Error("Cannot calculate inverse, determinant is zero");return[[J(gi[1][1],Ki),J(lr(gi[0][1]),Ki)],[J(lr(gi[1][0]),Ki),J(gi[0][0],Ki)]]}else{var ea=gi.concat();for(Hi=0;Hi<qi;Hi++)ea[Hi]=ea[Hi].concat();for(var Ji=Or(qi).valueOf(),ta=0;ta<zi;ta++){var na=Pr(ea[ta][ta]),ra=ta;for(Hi=ta+1;Hi<qi;)Pr(ea[Hi][ta])>na&&(na=Pr(ea[Hi][ta]),ra=Hi),Hi++;if(na===0)throw Error("Cannot calculate inverse, determinant is zero");Hi=ra,Hi!==ta&&(Xi=ea[ta],ea[ta]=ea[Hi],ea[Hi]=Xi,Xi=Ji[ta],Ji[ta]=Ji[Hi],Ji[Hi]=Xi);var ia=ea[ta],oa=Ji[ta];for(Hi=0;Hi<qi;Hi++){var ua=ea[Hi],sa=Ji[Hi];if(Hi!==ta){if(ua[ta]!==0){for(Gi=J(lr(ua[ta]),ia[ta]),Qi=ta;Qi<zi;Qi++)ua[Qi]=$e(ua[Qi],_t(Gi,ia[Qi]));for(Qi=0;Qi<zi;Qi++)sa[Qi]=$e(sa[Qi],_t(Gi,oa[Qi]))}}else{for(Gi=ia[ta],Qi=ta;Qi<zi;Qi++)ua[Qi]=J(ua[Qi],Gi);for(Qi=0;Qi<zi;Qi++)sa[Qi]=J(sa[Qi],Gi)}}}return Ji}}}),name$75="pinv",dependencies$75=["typed","matrix","inv","deepEqual","equal","dotDivide","dot","ctranspose","divideScalar","multiply","add","Complex"],createPinv=factory(name$75,dependencies$75,D=>{var{typed:E,matrix:F,inv:J,deepEqual:$e,equal:_t,dotDivide:lr,dot:mr,ctranspose:Or,divideScalar:Pr,multiply:dn,add:gi,Complex:qi}=D;return E(name$75,{"Array | Matrix":function(Xi){var Ki=isMatrix(Xi)?Xi.size():arraySize(Xi);switch(Ki.length){case 1:return Zi(Xi)?Or(Xi):Ki[0]===1?J(Xi):lr(Or(Xi),mr(Xi,Xi));case 2:if(Zi(Xi))return Or(Xi);var ea=Ki[0],Ji=Ki[1];if(ea===Ji)try{return J(Xi)}catch(ta){if(!(ta instanceof Error&&ta.message.match(/Cannot calculate inverse, determinant is zero/)))throw ta}return isMatrix(Xi)?F(zi(Xi.valueOf(),ea,Ji),Xi.storage()):zi(Xi,ea,Ji);default:throw RangeError("Matrix must be two dimensional (size: "+format(Ki)+")")}},any:function(Xi){return _t(Xi,0)?clone$3(Xi):Pr(1,Xi)}});function zi(Xi,Ki,ea){var{C:Ji,F:ta}=Qi(Xi,Ki,ea),na=dn(J(dn(Or(Ji),Ji)),Or(Ji));return dn(dn(Or(ta),J(dn(ta,Or(ta)))),na)}function Hi(Xi,Ki,ea){for(var Ji=clone$3(Xi),ta=0,na=0;na<Ki;na++){if(ea<=ta)return Ji;for(var ra=na;Gi(Ji[ra][ta]);)if(ra++,Ki===ra&&(ra=na,ta++,ea===ta))return Ji;[Ji[ra],Ji[na]]=[Ji[na],Ji[ra]];for(var ia=Ji[na][ta],oa=0;oa<ea;oa++)Ji[na][oa]=lr(Ji[na][oa],ia);for(var ua=0;ua<Ki;ua++)if(ua!==na){ia=Ji[ua][ta];for(var sa=0;sa<ea;sa++)Ji[ua][sa]=gi(Ji[ua][sa],dn(-1,dn(ia,Ji[na][sa])))}ta++}return Ji}function Qi(Xi,Ki,ea){var Ji=Hi(Xi,Ki,ea);return{C:Xi.map((ta,na)=>ta.filter((ra,ia)=>ia<Ki&&!Gi(mr(Ji[ia],Ji[ia])))),F:Ji.filter((ta,na)=>!Gi(mr(Ji[na],Ji[na])))}}function Gi(Xi){return _t(gi(Xi,qi(1,1)),gi(0,qi(1,1)))}function Zi(Xi){return $e(gi(Xi,qi(1,1)),gi(dn(Xi,0),qi(1,1)))}});function createComplexEigs(D){var{addScalar:E,subtract:F,flatten:J,multiply:$e,multiplyScalar:_t,divideScalar:lr,sqrt:mr,abs:Or,bignumber:Pr,diag:dn,size:gi,reshape:qi,inv:zi,qr:Hi,usolve:Qi,usolveAll:Gi,equal:Zi,complex:Xi,larger:Ki,smaller:ea,matrixFromColumns:Ji,dot:ta}=D;function na(_a,fa,ka,ba){var Pa=arguments.length>4&&arguments[4]!==void 0?arguments[4]:!0,Ia=ra(_a,fa,ka,ba,Pa);ia(_a,fa,ka,ba,Pa,Ia);var{values:Da,C:va}=oa(_a,fa,ka,ba,Pa);return Pa?{values:Da,eigenvectors:ua(_a,fa,va,Ia,Da,ka,ba)}:{values:Da}}function ra(_a,fa,ka,ba,Pa){var Ia=ba==="BigNumber",Da=ba==="Complex",va=Ia?Pr(0):0,Ca=Ia?Pr(1):Da?Xi(1):1,ya=Ia?Pr(1):1,Na=Ia?Pr(10):2,za=_t(Na,Na),Ta;Pa&&(Ta=Array(fa).fill(Ca));for(var es=!1;!es;){es=!0;for(var ts=0;ts<fa;ts++){for(var Ka=va,ps=va,cs=0;cs<fa;cs++)ts!==cs&&(Ka=E(Ka,Or(_a[cs][ts])),ps=E(ps,Or(_a[ts][cs])));if(!Zi(Ka,0)&&!Zi(ps,0)){for(var xa=ya,Ra=Ka,Va=lr(ps,Na),Ga=_t(ps,Na);ea(Ra,Va);)Ra=_t(Ra,za),xa=_t(xa,Na);for(;Ki(Ra,Ga);)Ra=lr(Ra,za),xa=lr(xa,Na);if(ea(lr(E(Ra,ps),xa),_t(E(Ka,ps),.95))){es=!1;for(var as=lr(1,xa),rs=0;rs<fa;rs++)ts!==rs&&(_a[ts][rs]=_t(_a[ts][rs],as),_a[rs][ts]=_t(_a[rs][ts],xa));Pa&&(Ta[ts]=_t(Ta[ts],as))}}}}return Pa?dn(Ta):null}function ia(_a,fa,ka,ba,Pa,Ia){var Da=ba==="BigNumber",va=Da?Pr(0):ba==="Complex"?Xi(0):0;Da&&(ka=Pr(ka));for(var Ca=0;Ca<fa-2;Ca++){for(var ya=0,Na=va,za=Ca+1;za<fa;za++){var Ta=_a[za][Ca];ea(Or(Na),Or(Ta))&&(Na=Ta,ya=za)}if(!ea(Or(Na),ka)){if(ya!==Ca+1){var es=_a[ya];_a[ya]=_a[Ca+1],_a[Ca+1]=es;for(var ts=0;ts<fa;ts++){var Ka=_a[ts][ya];_a[ts][ya]=_a[ts][Ca+1],_a[ts][Ca+1]=Ka}if(Pa){var ps=Ia[ya];Ia[ya]=Ia[Ca+1],Ia[Ca+1]=ps}}for(var cs=Ca+2;cs<fa;cs++){var xa=lr(_a[cs][Ca],Na);if(xa!==0){for(var Ra=0;Ra<fa;Ra++)_a[cs][Ra]=F(_a[cs][Ra],_t(xa,_a[Ca+1][Ra]));for(var Va=0;Va<fa;Va++)_a[Va][Ca+1]=E(_a[Va][Ca+1],_t(xa,_a[Va][cs]));if(Pa)for(var Ga=0;Ga<fa;Ga++)Ia[cs][Ga]=F(Ia[cs][Ga],_t(xa,Ia[Ca+1][Ga]))}}}}return Ia}function oa(_a,fa,ka,ba,Pa){var Ia=ba==="BigNumber",Da=Ia?Pr(1):ba==="Complex"?Xi(1):1;Ia&&(ka=Pr(ka));for(var va=clone$3(_a),Ca=[],ya=fa,Na=[],za=Pa?dn(Array(fa).fill(Da)):void 0,Ta=Pa?dn(Array(ya).fill(Da)):void 0,es=0;es<=100;){es+=1;for(var ts=va[ya-1][ya-1],Ka=0;Ka<ya;Ka++)va[Ka][Ka]=F(va[Ka][Ka],ts);var{Q:ps,R:cs}=Hi(va);va=$e(cs,ps);for(var xa=0;xa<ya;xa++)va[xa][xa]=E(va[xa][xa],ts);if(Pa&&(Ta=$e(Ta,ps)),ya===1||ea(Or(va[ya-1][ya-2]),ka)){es=0,Ca.push(va[ya-1][ya-1]),Pa&&(Na.unshift([[1]]),pa(Ta,fa),za=$e(za,Ta),ya>1&&(Ta=dn(Array(ya-1).fill(Da)))),--ya,va.pop();for(var Ra=0;Ra<ya;Ra++)va[Ra].pop()}else if(ya===2||ea(Or(va[ya-2][ya-3]),ka)){es=0;var Va=sa(va[ya-2][ya-2],va[ya-2][ya-1],va[ya-1][ya-2],va[ya-1][ya-1]);Ca.push(...Va),Pa&&(Na.unshift(aa(va[ya-2][ya-2],va[ya-2][ya-1],va[ya-1][ya-2],va[ya-1][ya-1],Va[0],Va[1],ka,ba)),pa(Ta,fa),za=$e(za,Ta),ya>2&&(Ta=dn(Array(ya-2).fill(Da)))),ya-=2,va.pop(),va.pop();for(var Ga=0;Ga<ya;Ga++)va[Ga].pop(),va[Ga].pop()}if(ya===0)break}if(Ca.sort((rs,ss)=>+F(Or(rs),Or(ss))),es>100){var as=Error("The eigenvalues failed to converge. Only found these eigenvalues: "+Ca.join(", "));throw as.values=Ca,as.vectors=[],as}return{values:Ca,C:Pa?$e(za,ma(Na,fa)):void 0}}function ua(_a,fa,ka,ba,Pa,Ia,Da){var va=$e(zi(ka),_a,ka),Ca=Da==="BigNumber",ya=Da==="Complex",Na=Ca?Pr(0):ya?Xi(0):0,za=Ca?Pr(1):ya?Xi(1):1,Ta=[],es=[];for(var ts of Pa){var Ka=la(Ta,ts,Zi);Ka===-1?(Ta.push(ts),es.push(1)):es[Ka]+=1}for(var ps=[],cs=Ta.length,xa=Array(fa).fill(Na),Ra=dn(Array(fa).fill(za)),Va=function(){var as=Ta[Ga],rs=F(va,$e(as,Ra)),ss=Gi(rs,xa);for(ss.shift();ss.length<es[Ga];){var ms=ha(rs,fa,ss,Ia,Da);if(ms===null)break;ss.push(ms)}var Ua=$e(zi(ba),ka);ss=ss.map(Wa=>$e(Ua,Wa)),ps.push(...ss.map(Wa=>({value:as,vector:J(Wa)})))},Ga=0;Ga<cs;Ga++)Va();return ps}function sa(_a,fa,ka,ba){var Pa=E(_a,ba),Ia=F(_t(_a,ba),_t(fa,ka)),Da=_t(Pa,.5),va=_t(mr(F(_t(Pa,Pa),_t(4,Ia))),.5);return[E(Da,va),F(Da,va)]}function aa(_a,fa,ka,ba,Pa,Ia,Da,va){var Ca=va==="BigNumber",ya=va==="Complex",Na=Ca?Pr(0):ya?Xi(0):0,za=Ca?Pr(1):ya?Xi(1):1;if(ea(Or(ka),Da))return[[za,Na],[Na,za]];if(Ki(Or(F(Pa,Ia)),Da))return[[F(Pa,ba),F(Ia,ba)],[ka,ka]];var Ta=F(_a,Pa),es=F(ba,Pa);return ea(Or(fa),Da)&&ea(Or(es),Da)?[[Ta,za],[ka,Na]]:[[fa,Na],[es,za]]}function pa(_a,fa){for(var ka=0;ka<_a.length;ka++)_a[ka].push(...Array(fa-_a[ka].length).fill(0));for(var ba=_a.length;ba<fa;ba++)_a.push(Array(fa).fill(0)),_a[ba][ba]=1;return _a}function ma(_a,fa){for(var ka=[],ba=0;ba<fa;ba++)ka[ba]=Array(fa).fill(0);var Pa=0;for(var Ia of _a){for(var Da=Ia.length,va=0;va<Da;va++)for(var Ca=0;Ca<Da;Ca++)ka[Pa+va][Pa+Ca]=Ia[va][Ca];Pa+=Da}return ka}function la(_a,fa,ka){for(var ba=0;ba<_a.length;ba++)if(ka(_a[ba],fa))return ba;return-1}function ha(_a,fa,ka,ba,Pa){for(var Ia=Pa==="BigNumber"?Pr(1e3):1e3,Da,va=0;va<5;++va){Da=ga(fa,ka,Pa);try{Da=Qi(_a,Da)}catch{continue}if(Ki(Fa(Da),Ia))break}if(va>=5)return null;for(va=0;;){var Ca=Qi(_a,Da);if(ea(Fa(Aa(Da,[Ca])),ba))break;if(++va>=10)return null;Da=$a(Ca)}return Da}function ga(_a,fa,ka){var ba=ka==="BigNumber",Pa=ka==="Complex",Ia=Array(_a).fill(0).map(Da=>2*Math.random()-1);return ba&&(Ia=Ia.map(Da=>Pr(Da))),Pa&&(Ia=Ia.map(Da=>Xi(Da))),Ia=Aa(Ia,fa),$a(Ia,ka)}function Aa(_a,fa){var ka=gi(_a);for(var ba of fa)ba=qi(ba,ka),_a=F(_a,$e(lr(ta(ba,_a),ta(ba,ba)),ba));return _a}function Fa(_a){return Or(mr(ta(_a,_a)))}function $a(_a,fa){return $e(lr(fa==="BigNumber"?Pr(1):fa==="Complex"?Xi(1):1,Fa(_a)),_a)}return na}function createRealSymmetric(D){var{config:E,addScalar:F,subtract:J,abs:$e,atan:_t,cos:lr,sin:mr,multiplyScalar:Or,inv:Pr,bignumber:dn,multiply:gi,add:qi}=D;function zi(ia,oa){var ua=arguments.length>2&&arguments[2]!==void 0?arguments[2]:E.relTol,sa=arguments.length>3?arguments[3]:void 0,aa=arguments.length>4?arguments[4]:void 0;if(sa==="number")return Hi(ia,ua,aa);if(sa==="BigNumber")return Qi(ia,ua,aa);throw TypeError("Unsupported data type: "+sa)}function Hi(ia,oa,ua){var sa=ia.length,aa=Math.abs(oa/sa),pa,ma;if(ua){ma=Array(sa);for(var la=0;la<sa;la++)ma[la]=Array(sa).fill(0),ma[la][la]=1}for(var ha=ta(ia);Math.abs(ha[1])>=Math.abs(aa);){var ga=ha[0][0],Aa=ha[0][1];pa=Gi(ia[ga][ga],ia[Aa][Aa],ia[ga][Aa]),ia=Ji(ia,pa,ga,Aa),ua&&(ma=Xi(ma,pa,ga,Aa)),ha=ta(ia)}for(var Fa=Array(sa).fill(0),$a=0;$a<sa;$a++)Fa[$a]=ia[$a][$a];return ra(clone$3(Fa),ma,ua)}function Qi(ia,oa,ua){var sa=ia.length,aa=$e(oa/sa),pa,ma;if(ua){ma=Array(sa);for(var la=0;la<sa;la++)ma[la]=Array(sa).fill(0),ma[la][la]=1}for(var ha=na(ia);$e(ha[1])>=$e(aa);){var ga=ha[0][0],Aa=ha[0][1];pa=Zi(ia[ga][ga],ia[Aa][Aa],ia[ga][Aa]),ia=ea(ia,pa,ga,Aa),ua&&(ma=Ki(ma,pa,ga,Aa)),ha=na(ia)}for(var Fa=Array(sa).fill(0),$a=0;$a<sa;$a++)Fa[$a]=ia[$a][$a];return ra(clone$3(Fa),ma,ua)}function Gi(ia,oa,ua){var sa=oa-ia;return Math.abs(sa)<=E.relTol?Math.PI/4:.5*Math.atan(2*ua/(oa-ia))}function Zi(ia,oa,ua){var sa=J(oa,ia);return $e(sa)<=E.relTol?dn(-1).acos().div(4):Or(.5,_t(gi(2,ua,Pr(sa))))}function Xi(ia,oa,ua,sa){for(var aa=ia.length,pa=Math.cos(oa),ma=Math.sin(oa),la=Array(aa).fill(0),ha=Array(aa).fill(0),ga=0;ga<aa;ga++)la[ga]=pa*ia[ga][ua]-ma*ia[ga][sa],ha[ga]=ma*ia[ga][ua]+pa*ia[ga][sa];for(var Aa=0;Aa<aa;Aa++)ia[Aa][ua]=la[Aa],ia[Aa][sa]=ha[Aa];return ia}function Ki(ia,oa,ua,sa){for(var aa=ia.length,pa=lr(oa),ma=mr(oa),la=Array(aa).fill(dn(0)),ha=Array(aa).fill(dn(0)),ga=0;ga<aa;ga++)la[ga]=J(Or(pa,ia[ga][ua]),Or(ma,ia[ga][sa])),ha[ga]=F(Or(ma,ia[ga][ua]),Or(pa,ia[ga][sa]));for(var Aa=0;Aa<aa;Aa++)ia[Aa][ua]=la[Aa],ia[Aa][sa]=ha[Aa];return ia}function ea(ia,oa,ua,sa){for(var aa=ia.length,pa=dn(lr(oa)),ma=dn(mr(oa)),la=Or(pa,pa),ha=Or(ma,ma),ga=Array(aa).fill(dn(0)),Aa=Array(aa).fill(dn(0)),Fa=gi(dn(2),pa,ma,ia[ua][sa]),$a=F(J(Or(la,ia[ua][ua]),Fa),Or(ha,ia[sa][sa])),_a=qi(Or(ha,ia[ua][ua]),Fa,Or(la,ia[sa][sa])),fa=0;fa<aa;fa++)ga[fa]=J(Or(pa,ia[ua][fa]),Or(ma,ia[sa][fa])),Aa[fa]=F(Or(ma,ia[ua][fa]),Or(pa,ia[sa][fa]));ia[ua][ua]=$a,ia[sa][sa]=_a,ia[ua][sa]=dn(0),ia[sa][ua]=dn(0);for(var ka=0;ka<aa;ka++)ka!==ua&&ka!==sa&&(ia[ua][ka]=ga[ka],ia[ka][ua]=ga[ka],ia[sa][ka]=Aa[ka],ia[ka][sa]=Aa[ka]);return ia}function Ji(ia,oa,ua,sa){for(var aa=ia.length,pa=Math.cos(oa),ma=Math.sin(oa),la=pa*pa,ha=ma*ma,ga=Array(aa).fill(0),Aa=Array(aa).fill(0),Fa=la*ia[ua][ua]-2*pa*ma*ia[ua][sa]+ha*ia[sa][sa],$a=ha*ia[ua][ua]+2*pa*ma*ia[ua][sa]+la*ia[sa][sa],_a=0;_a<aa;_a++)ga[_a]=pa*ia[ua][_a]-ma*ia[sa][_a],Aa[_a]=ma*ia[ua][_a]+pa*ia[sa][_a];ia[ua][ua]=Fa,ia[sa][sa]=$a,ia[ua][sa]=0,ia[sa][ua]=0;for(var fa=0;fa<aa;fa++)fa!==ua&&fa!==sa&&(ia[ua][fa]=ga[fa],ia[fa][ua]=ga[fa],ia[sa][fa]=Aa[fa],ia[fa][sa]=Aa[fa]);return ia}function ta(ia){for(var oa=ia.length,ua=0,sa=[0,1],aa=0;aa<oa;aa++)for(var pa=aa+1;pa<oa;pa++)Math.abs(ua)<Math.abs(ia[aa][pa])&&(ua=Math.abs(ia[aa][pa]),sa=[aa,pa]);return[sa,ua]}function na(ia){for(var oa=ia.length,ua=0,sa=[0,1],aa=0;aa<oa;aa++)for(var pa=aa+1;pa<oa;pa++)$e(ua)<$e(ia[aa][pa])&&(ua=$e(ia[aa][pa]),sa=[aa,pa]);return[sa,ua]}function ra(ia,oa,ua){var sa=ia.length,aa=Array(sa),pa;if(ua){pa=Array(sa);for(var ma=0;ma<sa;ma++)pa[ma]=Array(sa)}for(var la=0;la<sa;la++){for(var ha=0,ga=ia[0],Aa=0;Aa<ia.length;Aa++)$e(ia[Aa])<$e(ga)&&(ha=Aa,ga=ia[ha]);if(aa[la]=ia.splice(ha,1)[0],ua)for(var Fa=0;Fa<sa;Fa++)pa[la][Fa]=oa[Fa][ha],oa[Fa].splice(ha,1)}return ua?{values:aa,eigenvectors:pa.map(($a,_a)=>({value:aa[_a],vector:$a}))}:{values:aa}}return zi}var name$74="eigs",dependencies$74="config.typed.matrix.addScalar.equal.subtract.abs.atan.cos.sin.multiplyScalar.divideScalar.inv.bignumber.multiply.add.larger.column.flatten.number.complex.sqrt.diag.size.reshape.qr.usolve.usolveAll.im.re.smaller.matrixFromColumns.dot".split("."),createEigs=factory(name$74,dependencies$74,D=>{var{config:E,typed:F,matrix:J,addScalar:$e,subtract:_t,equal:lr,abs:mr,atan:Or,cos:Pr,sin:dn,multiplyScalar:gi,divideScalar:qi,inv:zi,bignumber:Hi,multiply:Qi,add:Gi,larger:Zi,column:Xi,flatten:Ki,number:ea,complex:Ji,sqrt:ta,diag:na,size:ra,reshape:ia,qr:oa,usolve:ua,usolveAll:sa,im:aa,re:pa,smaller:ma,matrixFromColumns:la,dot:ha}=D,ga=createRealSymmetric({config:E,addScalar:$e,subtract:_t,abs:mr,atan:Or,cos:Pr,sin:dn,multiplyScalar:gi,inv:zi,bignumber:Hi,multiply:Qi,add:Gi}),Aa=createComplexEigs({addScalar:$e,subtract:_t,multiply:Qi,multiplyScalar:gi,flatten:Ki,divideScalar:qi,sqrt:ta,abs:mr,bignumber:Hi,diag:na,size:ra,reshape:ia,qr:oa,inv:zi,usolve:ua,usolveAll:sa,equal:lr,complex:Ji,larger:Zi,smaller:ma,matrixFromColumns:la,dot:ha});return F("eigs",{Array:function(Pa){return Fa(J(Pa))},"Array, number|BigNumber":function(Pa,Ia){return Fa(J(Pa),{precision:Ia})},"Array, Object"(Pa,Ia){return Fa(J(Pa),Ia)},Matrix:function(Pa){return Fa(Pa,{matricize:!0})},"Matrix, number|BigNumber":function(Pa,Ia){return Fa(Pa,{precision:Ia,matricize:!0})},"Matrix, Object":function(Pa,Ia){var Da={matricize:!0};return _extends(Da,Ia),Fa(Pa,Da)}});function Fa(Pa){var Ia=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},Da="eigenvectors"in Ia?Ia.eigenvectors:!0,va=$a(Pa,Ia.precision??E.relTol,Da);return Ia.matricize&&(va.values=J(va.values),Da&&(va.eigenvectors=va.eigenvectors.map(Ca=>{var{value:ya,vector:Na}=Ca;return{value:ya,vector:J(Na)}}))),Da&&Object.defineProperty(va,"vectors",{enumerable:!1,get:()=>{throw Error("eigs(M).vectors replaced with eigs(M).eigenvectors")}}),va}function $a(Pa,Ia,Da){var va=Pa.toArray(),Ca=Pa.size();if(Ca.length!==2||Ca[0]!==Ca[1])throw RangeError(`Matrix must be square (size: ${format(Ca)})`);var ya=Ca[0];return fa(va,ya,Ia)&&(ka(va,ya),_a(va,ya,Ia))?ga(va,ya,Ia,ba(Pa,va,ya),Da):Aa(va,ya,Ia,ba(Pa,va,ya),Da)}function _a(Pa,Ia,Da){for(var va=0;va<Ia;va++)for(var Ca=va;Ca<Ia;Ca++)if(Zi(Hi(mr(_t(Pa[va][Ca],Pa[Ca][va]))),Da))return!1;return!0}function fa(Pa,Ia,Da){for(var va=0;va<Ia;va++)for(var Ca=0;Ca<Ia;Ca++)if(Zi(Hi(mr(aa(Pa[va][Ca]))),Da))return!1;return!0}function ka(Pa,Ia){for(var Da=0;Da<Ia;Da++)for(var va=0;va<Ia;va++)Pa[Da][va]=pa(Pa[Da][va])}function ba(Pa,Ia,Da){var va=Pa.datatype();if(va==="number"||va==="BigNumber"||va==="Complex")return va;for(var Ca=!1,ya=!1,Na=!1,za=0;za<Da;za++)for(var Ta=0;Ta<Da;Ta++){var es=Ia[za][Ta];if(isNumber(es)||isFraction(es))Ca=!0;else if(isBigNumber(es))ya=!0;else if(isComplex(es))Na=!0;else throw TypeError("Unsupported type in Matrix: "+typeOf(es))}if(ya&&Na&&console.warn("Complex BigNumbers not supported, this operation will lose precission."),Na){for(var ts=0;ts<Da;ts++)for(var Ka=0;Ka<Da;Ka++)Ia[ts][Ka]=Ji(Ia[ts][Ka]);return"Complex"}if(ya){for(var ps=0;ps<Da;ps++)for(var cs=0;cs<Da;cs++)Ia[ps][cs]=Hi(Ia[ps][cs]);return"BigNumber"}if(Ca){for(var xa=0;xa<Da;xa++)for(var Ra=0;Ra<Da;Ra++)Ia[xa][Ra]=ea(Ia[xa][Ra]);return"number"}else throw TypeError("Matrix contains unsupported types only.")}}),name$73="expm",dependencies$73=["typed","abs","add","identity","inv","multiply"],createExpm=factory(name$73,dependencies$73,D=>{var{typed:E,abs:F,add:J,identity:$e,inv:_t,multiply:lr}=D;return E(name$73,{Matrix:function(dn){var gi=dn.size();if(gi.length!==2||gi[0]!==gi[1])throw RangeError("Matrix must be square (size: "+format(gi)+")");for(var qi=gi[0],zi=Or(mr(dn),1e-15),Hi=zi.q,Qi=zi.j,Gi=lr(dn,2**-Qi),Zi=$e(qi),Xi=$e(qi),Ki=1,ea=Gi,Ji=-1,ta=1;ta<=Hi;ta++)ta>1&&(ea=lr(ea,Gi),Ji=-Ji),Ki=Ki*(Hi-ta+1)/((2*Hi-ta+1)*ta),Zi=J(Zi,lr(Ki,ea)),Xi=J(Xi,lr(Ki*Ji,ea));for(var na=lr(_t(Xi),Zi),ra=0;ra<Qi;ra++)na=lr(na,na);return isSparseMatrix(dn)?dn.createSparseMatrix(na):na}});function mr(dn){for(var gi=dn.size()[0],qi=0,zi=0;zi<gi;zi++){for(var Hi=0,Qi=0;Qi<gi;Qi++)Hi+=F(dn.get([zi,Qi]));qi=Math.max(Hi,qi)}return qi}function Or(dn,gi){for(var qi=30,zi=0;zi<qi;zi++)for(var Hi=0;Hi<=zi;Hi++){var Qi=zi-Hi;if(Pr(dn,Hi,Qi)<gi)return{q:Hi,j:Qi}}throw Error("Could not find acceptable parameters to compute the matrix exponential (try increasing maxSearchSize in expm.js)")}function Pr(dn,gi,qi){for(var zi=1,Hi=2;Hi<=gi;Hi++)zi*=Hi;for(var Qi=zi,Gi=gi+1;Gi<=2*gi;Gi++)Qi*=Gi;var Zi=Qi*(2*gi+1);return 8*(dn/2**qi)**(2*gi)*zi*zi/(Qi*Zi)}}),name$72="sqrtm",dependencies$72=["typed","abs","add","multiply","map","sqrt","subtract","inv","size","max","identity"],createSqrtm=factory(name$72,dependencies$72,D=>{var{typed:E,abs:F,add:J,multiply:$e,map:_t,sqrt:lr,subtract:mr,inv:Or,size:Pr,max:dn,identity:gi}=D,qi=1e3,zi=1e-6;function Hi(Qi){var Gi,Zi=0,Xi=Qi,Ki=gi(Pr(Qi));do{var ea=Xi;if(Xi=$e(.5,J(ea,Or(Ki))),Ki=$e(.5,J(Ki,Or(ea))),Gi=dn(F(mr(Xi,ea))),Gi>zi&&++Zi>qi)throw Error("computing square root of matrix: iterative method could not converge")}while(Gi>zi);return Xi}return E(name$72,{"Array | Matrix":function(Qi){var Gi=isMatrix(Qi)?Qi.size():arraySize(Qi);switch(Gi.length){case 1:if(Gi[0]===1)return _t(Qi,lr);throw RangeError("Matrix must be square (size: "+format(Gi)+")");case 2:if(Gi[0]===Gi[1])return Hi(Qi);throw RangeError("Matrix must be square (size: "+format(Gi)+")");default:throw RangeError("Matrix must be at most two dimensional (size: "+format(Gi)+")")}}})}),name$71="sylvester",dependencies$71=["typed","schur","matrixFromColumns","matrix","multiply","range","concat","transpose","index","subset","add","subtract","identity","lusolve","abs"],createSylvester=factory(name$71,dependencies$71,D=>{var{typed:E,schur:F,matrixFromColumns:J,matrix:$e,multiply:_t,range:lr,concat:mr,transpose:Or,index:Pr,subset:dn,add:gi,subtract:qi,identity:zi,lusolve:Hi,abs:Qi,config:Gi}=D;return E(name$71,{"Matrix, Matrix, Matrix":Zi,"Array, Matrix, Matrix":function(Xi,Ki,ea){return Zi($e(Xi),Ki,ea)},"Array, Array, Matrix":function(Xi,Ki,ea){return Zi($e(Xi),$e(Ki),ea)},"Array, Matrix, Array":function(Xi,Ki,ea){return Zi($e(Xi),Ki,$e(ea))},"Matrix, Array, Matrix":function(Xi,Ki,ea){return Zi(Xi,$e(Ki),ea)},"Matrix, Array, Array":function(Xi,Ki,ea){return Zi(Xi,$e(Ki),$e(ea))},"Matrix, Matrix, Array":function(Xi,Ki,ea){return Zi(Xi,Ki,$e(ea))},"Array, Array, Array":function(Xi,Ki,ea){return Zi($e(Xi),$e(Ki),$e(ea)).toArray()}});function Zi(Xi,Ki,ea){for(var Ji=Ki.size()[0],ta=Xi.size()[0],na=F(Xi),ra=na.T,ia=na.U,oa=F(_t(-1,Ki)),ua=oa.T,sa=oa.U,aa=_t(_t(Or(ia),ea),sa),pa=lr(0,ta),ma=[],la=(Da,va)=>mr(Da,va,1),ha=(Da,va)=>mr(Da,va,0),ga=0;ga<Ji;ga++)if(ga<Ji-1&&Qi(dn(ua,Pr(ga+1,ga)))>1e-5){for(var Aa=ha(dn(aa,Pr(pa,[ga])),dn(aa,Pr(pa,[ga+1]))),Fa=0;Fa<ga;Fa++)Aa=gi(Aa,ha(_t(ma[Fa],dn(ua,Pr(Fa,ga))),_t(ma[Fa],dn(ua,Pr(Fa,ga+1)))));var $a=_t(zi(ta),_t(-1,dn(ua,Pr(ga,ga)))),_a=_t(zi(ta),_t(-1,dn(ua,Pr(ga+1,ga)))),fa=_t(zi(ta),_t(-1,dn(ua,Pr(ga,ga+1)))),ka=_t(zi(ta),_t(-1,dn(ua,Pr(ga+1,ga+1)))),ba=Hi(ha(la(gi(ra,$a),_a),la(fa,gi(ra,ka))),Aa);ma[ga]=ba.subset(Pr(lr(0,ta),[0])),ma[ga+1]=ba.subset(Pr(lr(ta,2*ta),[0])),ga++}else{for(var Pa=dn(aa,Pr(pa,[ga])),Ia=0;Ia<ga;Ia++)Pa=gi(Pa,_t(ma[Ia],dn(ua,Pr(Ia,ga))));ma[ga]=Hi(qi(ra,_t(dn(ua,Pr(ga,ga)),zi(ta))),Pa)}return _t(ia,_t($e(J(...ma)),Or(sa)))}}),name$70="schur",dependencies$70=["typed","matrix","identity","multiply","qr","norm","subtract"],createSchur=factory(name$70,dependencies$70,D=>{var{typed:E,matrix:F,identity:J,multiply:$e,qr:_t,norm:lr,subtract:mr}=D;return E(name$70,{Array:function(Pr){var dn=Or(F(Pr));return{U:dn.U.valueOf(),T:dn.T.valueOf()}},Matrix:function(Pr){return Or(Pr)}});function Or(Pr){var dn=Pr.size()[0],gi=Pr,qi=J(dn),zi=0,Hi;do{Hi=gi;var Qi=_t(gi),Gi=Qi.Q,Zi=Qi.R;if(gi=$e(Zi,Gi),qi=$e(qi,Gi),zi++>100)break}while(lr(mr(gi,Hi))>1e-4);return{U:qi,T:gi}}}),name$69="lyap",dependencies$69=["typed","matrix","sylvester","multiply","transpose"],createLyap=factory(name$69,dependencies$69,D=>{var{typed:E,matrix:F,sylvester:J,multiply:$e,transpose:_t}=D;return E(name$69,{"Matrix, Matrix":function(lr,mr){return J(lr,_t(lr),$e(-1,mr))},"Array, Matrix":function(lr,mr){return J(F(lr),_t(F(lr)),$e(-1,mr))},"Matrix, Array":function(lr,mr){return J(lr,_t(F(lr)),F($e(-1,mr)))},"Array, Array":function(lr,mr){return J(F(lr),_t(F(lr)),F($e(-1,mr))).toArray()}})}),name$68="divide",dependencies$68=["typed","matrix","multiply","equalScalar","divideScalar","inv"],createDivide=factory(name$68,dependencies$68,D=>{var{typed:E,matrix:F,multiply:J,equalScalar:$e,divideScalar:_t,inv:lr}=D,mr=createMatAlgo11xS0s({typed:E,equalScalar:$e}),Or=createMatAlgo14xDs({typed:E});return E("divide",extend$1({"Array | Matrix, Array | Matrix":function(Pr,dn){return J(Pr,lr(dn))},"DenseMatrix, any":function(Pr,dn){return Or(Pr,dn,_t,!1)},"SparseMatrix, any":function(Pr,dn){return mr(Pr,dn,_t,!1)},"Array, any":function(Pr,dn){return Or(F(Pr),dn,_t,!1).valueOf()},"any, Array | Matrix":function(Pr,dn){return J(Pr,lr(dn))}},_t.signatures))}),name$67="distance",dependencies$67=["typed","addScalar","subtractScalar","divideScalar","multiplyScalar","deepEqual","sqrt","abs"],createDistance=factory(name$67,dependencies$67,D=>{var{typed:E,addScalar:F,subtractScalar:J,multiplyScalar:$e,divideScalar:_t,deepEqual:lr,sqrt:mr,abs:Or}=D;return E(name$67,{"Array, Array, Array":function(ea,Ji,ta){if(ea.length===2&&Ji.length===2&&ta.length===2){if(!dn(ea))throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!dn(Ji))throw TypeError("Array with 2 numbers or BigNumbers expected for second argument");if(!dn(ta))throw TypeError("Array with 2 numbers or BigNumbers expected for third argument");if(lr(Ji,ta))throw TypeError("LinePoint1 should not be same with LinePoint2");var na=J(ta[1],Ji[1]),ra=J(Ji[0],ta[0]),ia=J($e(ta[0],Ji[1]),$e(Ji[0],ta[1]));return Gi(ea[0],ea[1],na,ra,ia)}else throw TypeError("Invalid Arguments: Try again")},"Object, Object, Object":function(ea,Ji,ta){if(Object.keys(ea).length===2&&Object.keys(Ji).length===2&&Object.keys(ta).length===2){if(!dn(ea))throw TypeError("Values of pointX and pointY should be numbers or BigNumbers");if(!dn(Ji))throw TypeError("Values of lineOnePtX and lineOnePtY should be numbers or BigNumbers");if(!dn(ta))throw TypeError("Values of lineTwoPtX and lineTwoPtY should be numbers or BigNumbers");if(lr(Hi(Ji),Hi(ta)))throw TypeError("LinePoint1 should not be same with LinePoint2");if("pointX"in ea&&"pointY"in ea&&"lineOnePtX"in Ji&&"lineOnePtY"in Ji&&"lineTwoPtX"in ta&&"lineTwoPtY"in ta){var na=J(ta.lineTwoPtY,Ji.lineOnePtY),ra=J(Ji.lineOnePtX,ta.lineTwoPtX),ia=J($e(ta.lineTwoPtX,Ji.lineOnePtY),$e(Ji.lineOnePtX,ta.lineTwoPtY));return Gi(ea.pointX,ea.pointY,na,ra,ia)}else throw TypeError("Key names do not match")}else throw TypeError("Invalid Arguments: Try again")},"Array, Array":function(ea,Ji){if(ea.length===2&&Ji.length===3){if(!dn(ea))throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!gi(Ji))throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");return Gi(ea[0],ea[1],Ji[0],Ji[1],Ji[2])}else if(ea.length===3&&Ji.length===6){if(!gi(ea))throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!zi(Ji))throw TypeError("Array with 6 numbers or BigNumbers expected for second argument");return Zi(ea[0],ea[1],ea[2],Ji[0],Ji[1],Ji[2],Ji[3],Ji[4],Ji[5])}else if(ea.length===Ji.length&&ea.length>0){if(!qi(ea)||!qi(Ji))throw TypeError("All values of an array should be numbers or BigNumbers");return Xi(ea,Ji)}else throw TypeError("Invalid Arguments: Try again")},"Object, Object":function(ea,Ji){if(Object.keys(ea).length===2&&Object.keys(Ji).length===3){if(!dn(ea))throw TypeError("Values of pointX and pointY should be numbers or BigNumbers");if(!gi(Ji))throw TypeError("Values of xCoeffLine, yCoeffLine and constant should be numbers or BigNumbers");if("pointX"in ea&&"pointY"in ea&&"xCoeffLine"in Ji&&"yCoeffLine"in Ji&&"constant"in Ji)return Gi(ea.pointX,ea.pointY,Ji.xCoeffLine,Ji.yCoeffLine,Ji.constant);throw TypeError("Key names do not match")}else if(Object.keys(ea).length===3&&Object.keys(Ji).length===6){if(!gi(ea))throw TypeError("Values of pointX, pointY and pointZ should be numbers or BigNumbers");if(!zi(Ji))throw TypeError("Values of x0, y0, z0, a, b and c should be numbers or BigNumbers");if("pointX"in ea&&"pointY"in ea&&"x0"in Ji&&"y0"in Ji&&"z0"in Ji&&"a"in Ji&&"b"in Ji&&"c"in Ji)return Zi(ea.pointX,ea.pointY,ea.pointZ,Ji.x0,Ji.y0,Ji.z0,Ji.a,Ji.b,Ji.c);throw TypeError("Key names do not match")}else if(Object.keys(ea).length===2&&Object.keys(Ji).length===2){if(!dn(ea))throw TypeError("Values of pointOneX and pointOneY should be numbers or BigNumbers");if(!dn(Ji))throw TypeError("Values of pointTwoX and pointTwoY should be numbers or BigNumbers");if("pointOneX"in ea&&"pointOneY"in ea&&"pointTwoX"in Ji&&"pointTwoY"in Ji)return Xi([ea.pointOneX,ea.pointOneY],[Ji.pointTwoX,Ji.pointTwoY]);throw TypeError("Key names do not match")}else if(Object.keys(ea).length===3&&Object.keys(Ji).length===3){if(!gi(ea))throw TypeError("Values of pointOneX, pointOneY and pointOneZ should be numbers or BigNumbers");if(!gi(Ji))throw TypeError("Values of pointTwoX, pointTwoY and pointTwoZ should be numbers or BigNumbers");if("pointOneX"in ea&&"pointOneY"in ea&&"pointOneZ"in ea&&"pointTwoX"in Ji&&"pointTwoY"in Ji&&"pointTwoZ"in Ji)return Xi([ea.pointOneX,ea.pointOneY,ea.pointOneZ],[Ji.pointTwoX,Ji.pointTwoY,Ji.pointTwoZ]);throw TypeError("Key names do not match")}else throw TypeError("Invalid Arguments: Try again")},Array:function(ea){if(!Qi(ea))throw TypeError("Incorrect array format entered for pairwise distance calculation");return Ki(ea)}});function Pr(ea){return typeof ea=="number"||isBigNumber(ea)}function dn(ea){return ea.constructor!==Array&&(ea=Hi(ea)),Pr(ea[0])&&Pr(ea[1])}function gi(ea){return ea.constructor!==Array&&(ea=Hi(ea)),Pr(ea[0])&&Pr(ea[1])&&Pr(ea[2])}function qi(ea){return Array.isArray(ea)||(ea=Hi(ea)),ea.every(Pr)}function zi(ea){return ea.constructor!==Array&&(ea=Hi(ea)),Pr(ea[0])&&Pr(ea[1])&&Pr(ea[2])&&Pr(ea[3])&&Pr(ea[4])&&Pr(ea[5])}function Hi(ea){for(var Ji=Object.keys(ea),ta=[],na=0;na<Ji.length;na++)ta.push(ea[Ji[na]]);return ta}function Qi(ea){if(ea[0].length===2&&Pr(ea[0][0])&&Pr(ea[0][1])){if(ea.some(Ji=>Ji.length!==2||!Pr(Ji[0])||!Pr(Ji[1])))return!1}else if(ea[0].length===3&&Pr(ea[0][0])&&Pr(ea[0][1])&&Pr(ea[0][2])){if(ea.some(Ji=>Ji.length!==3||!Pr(Ji[0])||!Pr(Ji[1])||!Pr(Ji[2])))return!1}else return!1;return!0}function Gi(ea,Ji,ta,na,ra){return _t(Or(F(F($e(ta,ea),$e(na,Ji)),ra)),mr(F($e(ta,ta),$e(na,na))))}function Zi(ea,Ji,ta,na,ra,ia,oa,ua,sa){var aa=[J($e(J(ra,Ji),sa),$e(J(ia,ta),ua)),J($e(J(ia,ta),oa),$e(J(na,ea),sa)),J($e(J(na,ea),ua),$e(J(ra,Ji),oa))];aa=mr(F(F($e(aa[0],aa[0]),$e(aa[1],aa[1])),$e(aa[2],aa[2])));var pa=mr(F(F($e(oa,oa),$e(ua,ua)),$e(sa,sa)));return _t(aa,pa)}function Xi(ea,Ji){for(var ta=ea.length,na=0,ra=0,ia=0;ia<ta;ia++)ra=J(ea[ia],Ji[ia]),na=F($e(ra,ra),na);return mr(na)}function Ki(ea){for(var Ji=[],ta=[],na=[],ra=0;ra<ea.length-1;ra++)for(var ia=ra+1;ia<ea.length;ia++)ea[0].length===2?(ta=[ea[ra][0],ea[ra][1]],na=[ea[ia][0],ea[ia][1]]):ea[0].length===3&&(ta=[ea[ra][0],ea[ra][1],ea[ra][2]],na=[ea[ia][0],ea[ia][1],ea[ia][2]]),Ji.push(Xi(ta,na));return Ji}}),name$66="intersect",dependencies$66=["typed","config","abs","add","addScalar","matrix","multiply","multiplyScalar","divideScalar","subtract","smaller","equalScalar","flatten","isZero","isNumeric"],createIntersect=factory(name$66,dependencies$66,D=>{var{typed:E,config:F,abs:J,add:$e,addScalar:_t,matrix:lr,multiply:mr,multiplyScalar:Or,divideScalar:Pr,subtract:dn,smaller:gi,equalScalar:qi,flatten:zi,isZero:Hi,isNumeric:Qi}=D;return E("intersect",{"Array, Array, Array":Gi,"Array, Array, Array, Array":Zi,"Matrix, Matrix, Matrix":function(oa,ua,sa){var aa=Gi(oa.valueOf(),ua.valueOf(),sa.valueOf());return aa===null?null:lr(aa)},"Matrix, Matrix, Matrix, Matrix":function(oa,ua,sa,aa){var pa=Zi(oa.valueOf(),ua.valueOf(),sa.valueOf(),aa.valueOf());return pa===null?null:lr(pa)}});function Gi(oa,ua,sa){if(oa=Xi(oa),ua=Xi(ua),sa=Xi(sa),!ea(oa))throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!ea(ua))throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");if(!Ji(sa))throw TypeError("Array with 4 numbers expected as third argument");return ia(oa[0],oa[1],oa[2],ua[0],ua[1],ua[2],sa[0],sa[1],sa[2],sa[3])}function Zi(oa,ua,sa,aa){if(oa=Xi(oa),ua=Xi(ua),sa=Xi(sa),aa=Xi(aa),oa.length===2){if(!Ki(oa))throw TypeError("Array with 2 numbers or BigNumbers expected for first argument");if(!Ki(ua))throw TypeError("Array with 2 numbers or BigNumbers expected for second argument");if(!Ki(sa))throw TypeError("Array with 2 numbers or BigNumbers expected for third argument");if(!Ki(aa))throw TypeError("Array with 2 numbers or BigNumbers expected for fourth argument");return ta(oa,ua,sa,aa)}else if(oa.length===3){if(!ea(oa))throw TypeError("Array with 3 numbers or BigNumbers expected for first argument");if(!ea(ua))throw TypeError("Array with 3 numbers or BigNumbers expected for second argument");if(!ea(sa))throw TypeError("Array with 3 numbers or BigNumbers expected for third argument");if(!ea(aa))throw TypeError("Array with 3 numbers or BigNumbers expected for fourth argument");return ra(oa[0],oa[1],oa[2],ua[0],ua[1],ua[2],sa[0],sa[1],sa[2],aa[0],aa[1],aa[2])}else throw TypeError("Arrays with two or thee dimensional points expected")}function Xi(oa){return oa.length===1?oa[0]:oa.length>1&&Array.isArray(oa[0])&&oa.every(ua=>Array.isArray(ua)&&ua.length===1)?zi(oa):oa}function Ki(oa){return oa.length===2&&Qi(oa[0])&&Qi(oa[1])}function ea(oa){return oa.length===3&&Qi(oa[0])&&Qi(oa[1])&&Qi(oa[2])}function Ji(oa){return oa.length===4&&Qi(oa[0])&&Qi(oa[1])&&Qi(oa[2])&&Qi(oa[3])}function ta(oa,ua,sa,aa){var pa=oa,ma=sa,la=dn(pa,ua),ha=dn(ma,aa),ga=dn(Or(la[0],ha[1]),Or(ha[0],la[1]));if(Hi(ga)||gi(J(ga),F.relTol))return null;var Aa=Or(ha[0],pa[1]),Fa=Or(ha[1],pa[0]),$a=Or(ha[0],ma[1]),_a=Or(ha[1],ma[0]);return $e(mr(la,Pr(_t(dn(dn(Aa,Fa),$a),_a),ga)),pa)}function na(oa,ua,sa,aa,pa,ma,la,ha,ga,Aa,Fa,$a){var _a=Or(dn(oa,ua),dn(sa,aa)),fa=Or(dn(pa,ma),dn(la,ha)),ka=Or(dn(ga,Aa),dn(Fa,$a));return _t(_t(_a,fa),ka)}function ra(oa,ua,sa,aa,pa,ma,la,ha,ga,Aa,Fa,$a){var _a=na(oa,la,Aa,la,ua,ha,Fa,ha,sa,ga,$a,ga),fa=na(Aa,la,aa,oa,Fa,ha,pa,ua,$a,ga,ma,sa),ka=na(oa,la,aa,oa,ua,ha,pa,ua,sa,ga,ma,sa),ba=na(Aa,la,Aa,la,Fa,ha,Fa,ha,$a,ga,$a,ga),Pa=na(aa,oa,aa,oa,pa,ua,pa,ua,ma,sa,ma,sa),Ia=dn(Or(_a,fa),Or(ka,ba)),Da=dn(Or(Pa,ba),Or(fa,fa));if(Hi(Da))return null;var va=Pr(Ia,Da),Ca=Pr(_t(_a,Or(va,fa)),ba),ya=_t(oa,Or(va,dn(aa,oa))),Na=_t(ua,Or(va,dn(pa,ua))),za=_t(sa,Or(va,dn(ma,sa))),Ta=_t(la,Or(Ca,dn(Aa,la))),es=_t(ha,Or(Ca,dn(Fa,ha))),ts=_t(ga,Or(Ca,dn($a,ga)));return qi(ya,Ta)&&qi(Na,es)&&qi(za,ts)?[ya,Na,za]:null}function ia(oa,ua,sa,aa,pa,ma,la,ha,ga,Aa){var Fa=Or(oa,la),$a=Or(aa,la),_a=Or(ua,ha),fa=Or(pa,ha),ka=Or(sa,ga),ba=Or(ma,ga),Pa=Pr(dn(dn(dn(Aa,Fa),_a),ka),dn(dn(dn(_t(_t($a,fa),ba),Fa),_a),ka));return[_t(oa,Or(Pa,dn(aa,oa))),_t(ua,Or(Pa,dn(pa,ua))),_t(sa,Or(Pa,dn(ma,sa)))]}}),name$65="sum",dependencies$65=["typed","config","add","numeric"],createSum=factory(name$65,dependencies$65,D=>{var{typed:E,config:F,add:J,numeric:$e}=D;return E(name$65,{"Array | Matrix":_t,"Array | Matrix, number | BigNumber":lr,"...":function(mr){if(containsCollections(mr))throw TypeError("Scalar values expected in function sum");return _t(mr)}});function _t(mr){var Or;return deepForEach(mr,function(Pr){try{Or=Or===void 0?Pr:J(Or,Pr)}catch(dn){throw improveErrorMessage(dn,"sum",Pr)}}),Or===void 0&&(Or=$e(0,F.number)),typeof Or=="string"&&(Or=$e(Or,safeNumberType(Or,F))),Or}function lr(mr,Or){try{return reduce$1(mr,Or,J)}catch(Pr){throw improveErrorMessage(Pr,"sum")}}}),name$64="cumsum",dependencies$64=["typed","add","unaryPlus"],createCumSum=factory(name$64,dependencies$64,D=>{var{typed:E,add:F,unaryPlus:J}=D;return E(name$64,{Array:$e,Matrix:function(Or){return Or.create($e(Or.valueOf(),Or.datatype()))},"Array, number | BigNumber":lr,"Matrix, number | BigNumber":function(Or,Pr){return Or.create(lr(Or.valueOf(),Pr),Or.datatype())},"...":function(Or){if(containsCollections(Or))throw TypeError("All values expected to be scalar in function cumsum");return $e(Or)}});function $e(Or){try{return _t(Or)}catch(Pr){throw improveErrorMessage(Pr,name$64)}}function _t(Or){if(Or.length===0)return[];for(var Pr=[J(Or[0])],dn=1;dn<Or.length;++dn)Pr.push(F(Pr[dn-1],Or[dn]));return Pr}function lr(Or,Pr){var dn=arraySize(Or);if(Pr<0||Pr>=dn.length)throw new IndexError(Pr,dn.length);try{return mr(Or,Pr)}catch(gi){throw improveErrorMessage(gi,name$64)}}function mr(Or,Pr){var dn,gi,qi;if(Pr<=0){var zi=Or[0][0];if(Array.isArray(zi)){for(qi=_switch$1(Or),gi=[],dn=0;dn<qi.length;dn++)gi[dn]=mr(qi[dn],Pr-1);return gi}else return _t(Or)}else{for(gi=[],dn=0;dn<Or.length;dn++)gi[dn]=mr(Or[dn],Pr-1);return gi}}}),name$63="mean",dependencies$63=["typed","add","divide"],createMean=factory(name$63,dependencies$63,D=>{var{typed:E,add:F,divide:J}=D;return E(name$63,{"Array | Matrix":_t,"Array | Matrix, number | BigNumber":$e,"...":function(lr){if(containsCollections(lr))throw TypeError("Scalar values expected in function mean");return _t(lr)}});function $e(lr,mr){try{return J(reduce$1(lr,mr,F),(Array.isArray(lr)?arraySize(lr):lr.size())[mr])}catch(Or){throw improveErrorMessage(Or,"mean")}}function _t(lr){var mr,Or=0;if(deepForEach(lr,function(Pr){try{mr=mr===void 0?Pr:F(mr,Pr),Or++}catch(dn){throw improveErrorMessage(dn,"mean",Pr)}}),Or===0)throw Error("Cannot calculate the mean of an empty array");return J(mr,Or)}}),name$62="median",dependencies$62=["typed","add","divide","compare","partitionSelect"],createMedian=factory(name$62,dependencies$62,D=>{var{typed:E,add:F,divide:J,compare:$e,partitionSelect:_t}=D;function lr(Pr){try{Pr=flatten$4(Pr.valueOf());var dn=Pr.length;if(dn===0)throw Error("Cannot calculate median of an empty array");if(dn%2==0){for(var gi=dn/2-1,qi=_t(Pr,gi+1),zi=Pr[gi],Hi=0;Hi<gi;++Hi)$e(Pr[Hi],zi)>0&&(zi=Pr[Hi]);return Or(zi,qi)}else return mr(_t(Pr,(dn-1)/2))}catch(Qi){throw improveErrorMessage(Qi,"median")}}var mr=E({"number | BigNumber | Complex | Unit":function(Pr){return Pr}}),Or=E({"number | BigNumber | Complex | Unit, number | BigNumber | Complex | Unit":function(Pr,dn){return J(F(Pr,dn),2)}});return E(name$62,{"Array | Matrix":lr,"Array | Matrix, number | BigNumber":function(Pr,dn){throw Error("median(A, dim) is not yet supported")},"...":function(Pr){if(containsCollections(Pr))throw TypeError("Scalar values expected in function median");return lr(Pr)}})}),name$61="mad",dependencies$61=["typed","abs","map","median","subtract"],createMad=factory(name$61,dependencies$61,D=>{var{typed:E,abs:F,map:J,median:$e,subtract:_t}=D;return E(name$61,{"Array | Matrix":lr,"...":function(mr){return lr(mr)}});function lr(mr){if(mr=flatten$4(mr.valueOf()),mr.length===0)throw Error("Cannot calculate median absolute deviation (mad) of an empty array");try{var Or=$e(mr);return $e(J(mr,function(Pr){return F(_t(Pr,Or))}))}catch(Pr){throw Pr instanceof TypeError&&Pr.message.includes("median")?TypeError(Pr.message.replace("median","mad")):improveErrorMessage(Pr,"mad")}}}),DEFAULT_NORMALIZATION="unbiased",name$60="variance",dependencies$60=["typed","add","subtract","multiply","divide","mapSlices","isNaN"],createVariance=factory(name$60,dependencies$60,D=>{var{typed:E,add:F,subtract:J,multiply:$e,divide:_t,mapSlices:lr,isNaN:mr}=D;return E(name$60,{"Array | Matrix":function(dn){return Or(dn,DEFAULT_NORMALIZATION)},"Array | Matrix, string":Or,"Array | Matrix, number | BigNumber":function(dn,gi){return Pr(dn,gi,DEFAULT_NORMALIZATION)},"Array | Matrix, number | BigNumber, string":Pr,"...":function(dn){return Or(dn,DEFAULT_NORMALIZATION)}});function Or(dn,gi){var qi,zi=0;if(dn.length===0)throw SyntaxError("Function variance requires one or more parameters (0 provided)");if(deepForEach(dn,function(Gi){try{qi=qi===void 0?Gi:F(qi,Gi),zi++}catch(Zi){throw improveErrorMessage(Zi,"variance",Gi)}}),zi===0)throw Error("Cannot calculate variance of an empty array");var Hi=_t(qi,zi);if(qi=void 0,deepForEach(dn,function(Gi){var Zi=J(Gi,Hi);qi=qi===void 0?$e(Zi,Zi):F(qi,$e(Zi,Zi))}),mr(qi))return qi;switch(gi){case"uncorrected":return _t(qi,zi);case"biased":return _t(qi,zi+1);case"unbiased":var Qi=isBigNumber(qi)?qi.mul(0):0;return zi===1?Qi:_t(qi,zi-1);default:throw Error(\'Unknown normalization "\'+gi+\'". Choose "unbiased" (default), "uncorrected", or "biased".\')}}function Pr(dn,gi,qi){try{if(dn.length===0)throw SyntaxError("Function variance requires one or more parameters (0 provided)");return lr(dn,gi,zi=>Or(zi,qi))}catch(zi){throw improveErrorMessage(zi,"variance")}}}),name$59="quantileSeq",dependencies$59=["typed","?bignumber","add","subtract","divide","multiply","partitionSelect","compare","isInteger","smaller","smallerEq","larger","mapSlices"],createQuantileSeq=factory(name$59,dependencies$59,D=>{var{typed:E,bignumber:F,add:J,subtract:$e,divide:_t,multiply:lr,partitionSelect:mr,compare:Or,isInteger:Pr,smaller:dn,smallerEq:gi,larger:qi,mapSlices:zi}=D;return E(name$59,{"Array | Matrix, number | BigNumber":(Xi,Ki)=>Qi(Xi,Ki,!1),"Array | Matrix, number | BigNumber, number":(Xi,Ki,ea)=>Hi(Xi,Ki,!1,ea,Qi),"Array | Matrix, number | BigNumber, boolean":Qi,"Array | Matrix, number | BigNumber, boolean, number":(Xi,Ki,ea,Ji)=>Hi(Xi,Ki,ea,Ji,Qi),"Array | Matrix, Array | Matrix":(Xi,Ki)=>Gi(Xi,Ki,!1),"Array | Matrix, Array | Matrix, number":(Xi,Ki,ea)=>Hi(Xi,Ki,!1,ea,Gi),"Array | Matrix, Array | Matrix, boolean":Gi,"Array | Matrix, Array | Matrix, boolean, number":(Xi,Ki,ea,Ji)=>Hi(Xi,Ki,ea,Ji,Gi)});function Hi(Xi,Ki,ea,Ji,ta){return zi(Xi,Ji,na=>ta(na,Ki,ea))}function Qi(Xi,Ki,ea){var Ji,ta=Xi.valueOf();if(dn(Ki,0))throw Error("N/prob must be non-negative");if(gi(Ki,1))return isNumber(Ki)?Zi(ta,Ki,ea):F(Zi(ta,Ki,ea));if(qi(Ki,1)){if(!Pr(Ki))throw Error("N must be a positive integer");if(qi(Ki,4294967295))throw Error("N must be less than or equal to 2^32-1, as that is the maximum length of an Array");var na=J(Ki,1);Ji=[];for(var ra=0;dn(ra,Ki);ra++){var ia=_t(ra+1,na);Ji.push(Zi(ta,ia,ea))}return isNumber(Ki)?Ji:F(Ji)}}function Gi(Xi,Ki,ea){for(var Ji=Xi.valueOf(),ta=Ki.valueOf(),na=[],ra=0;ra<ta.length;++ra)na.push(Zi(Ji,ta[ra],ea));return na}function Zi(Xi,Ki,ea){var Ji=flatten$4(Xi),ta=Ji.length;if(ta===0)throw Error("Cannot calculate quantile of an empty sequence");var na=isNumber(Ki)?Ki*(ta-1):Ki.times(ta-1),ra=isNumber(Ki)?Math.floor(na):na.floor().toNumber(),ia=isNumber(Ki)?na%1:na.minus(ra);if(Pr(na))return ea?Ji[na]:mr(Ji,isNumber(Ki)?na:na.valueOf());var oa,ua;if(ea)oa=Ji[ra],ua=Ji[ra+1];else{ua=mr(Ji,ra+1),oa=Ji[ra];for(var sa=0;sa<ra;++sa)Or(Ji[sa],oa)>0&&(oa=Ji[sa])}return J(lr(oa,$e(1,ia)),lr(ua,ia))}}),name$58="std",dependencies$58=["typed","map","sqrt","variance"],createStd=factory(name$58,dependencies$58,D=>{var{typed:E,map:F,sqrt:J,variance:$e}=D;return E(name$58,{"Array | Matrix":_t,"Array | Matrix, string":_t,"Array | Matrix, number | BigNumber":_t,"Array | Matrix, number | BigNumber, string":_t,"...":function(lr){return _t(lr)}});function _t(lr,mr){if(lr.length===0)throw SyntaxError("Function std requires one or more parameters (0 provided)");try{var Or=$e.apply(null,arguments);return isCollection(Or)?F(Or,J):J(Or)}catch(Pr){throw Pr instanceof TypeError&&Pr.message.includes(" variance")?TypeError(Pr.message.replace(" variance"," std")):Pr}}}),name$57="corr",dependencies$57=["typed","matrix","mean","sqrt","sum","add","subtract","multiply","pow","divide"],createCorr=factory(name$57,dependencies$57,D=>{var{typed:E,matrix:F,sqrt:J,sum:$e,add:_t,subtract:lr,multiply:mr,pow:Or,divide:Pr}=D;return E(name$57,{"Array, Array":function(qi,zi){return dn(qi,zi)},"Matrix, Matrix":function(qi,zi){var Hi=dn(qi.toArray(),zi.toArray());return Array.isArray(Hi)?F(Hi):Hi}});function dn(qi,zi){var Hi=[];if(Array.isArray(qi[0])&&Array.isArray(zi[0])){if(qi.length!==zi.length)throw SyntaxError("Dimension mismatch. Array A and B must have the same length.");for(var Qi=0;Qi<qi.length;Qi++){if(qi[Qi].length!==zi[Qi].length)throw SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");Hi.push(gi(qi[Qi],zi[Qi]))}return Hi}else{if(qi.length!==zi.length)throw SyntaxError("Dimension mismatch. Array A and B must have the same number of elements.");return gi(qi,zi)}}function gi(qi,zi){var Hi=qi.length,Qi=$e(qi),Gi=$e(zi),Zi=qi.reduce((ea,Ji,ta)=>_t(ea,mr(Ji,zi[ta])),0),Xi=$e(qi.map(ea=>Or(ea,2))),Ki=$e(zi.map(ea=>Or(ea,2)));return Pr(lr(mr(Hi,Zi),mr(Qi,Gi)),J(mr(lr(mr(Hi,Xi),Or(Qi,2)),lr(mr(Hi,Ki),Or(Gi,2)))))}}),name$56="bernoulli",dependencies$56=["typed","config","isInteger","number","?BigNumber","?Fraction"],createBernoulli=factory(name$56,dependencies$56,D=>{var{typed:E,config:F,number:J,BigNumber:$e,Fraction:_t}=D,lr=[void 0],mr=[void 0],Or=[void 0],Pr=50;return E(name$56,{number:dn=>_bernoulli(dn,gi=>gi,lr,(gi,qi)=>gi+qi,(gi,qi)=>gi*qi,(gi,qi)=>gi/qi),"bigint | Fraction":dn=>_bernoulli(J(dn),gi=>new _t(gi),mr,(gi,qi)=>gi.add(qi),(gi,qi)=>gi.mul(qi),(gi,qi)=>gi.div(qi)),BigNumber:dn=>(F.precision!==Pr&&(Or=[void 0],Pr=F.precision),_bernoulli(J(dn),gi=>new $e(gi),Or,(gi,qi)=>gi.add(qi),(gi,qi)=>gi.mul(qi),(gi,qi)=>gi.div(qi)))})});function _bernoulli(D,E,F,J,$e,_t){if(D<0||!isInteger(D))throw RangeError("Bernoulli index must be nonnegative integer");if(D===0)return E(1);if(D===1)return _t(E(-1),E(2));if(D%2==1)return E(0);var lr=E(1);F.length===1&&F.push([_t(lr,E(-3)),_t(lr,E(-2)),_t(lr,E(6))]);for(var mr=D/2,Or=E(0),Pr=E(2);F.length<=mr;){for(var dn=F.length,gi=Math.floor((dn+1)/2),qi=Or,zi=1;zi<gi;++zi)qi=J(qi,$e(F[zi][0],F[dn-zi][0]));qi=$e(qi,Pr),dn%2==0&&(qi=J(qi,$e(F[gi][0],F[gi][0]))),qi=_t(qi,E(-(2*dn+1)));var Hi=_t($e(F[dn-1][1],E(-dn*(2*dn-1))),Pr);F.push([qi,Hi,$e(Hi,qi)])}return F[mr][2]}var name$55="combinations",dependencies$55=["typed"],createCombinations=factory(name$55,dependencies$55,D=>{var{typed:E}=D;return E(name$55,{"number, number":combinationsNumber,"BigNumber, BigNumber":function(F,J){var $e=F.constructor,_t,lr,mr=F.minus(J),Or=new $e(1);if(!isPositiveInteger$2(F)||!isPositiveInteger$2(J))throw TypeError("Positive integer value expected in function combinations");if(J.gt(F))throw TypeError("k must be less than n in function combinations");if(_t=Or,J.lt(mr))for(lr=Or;lr.lte(mr);lr=lr.plus(Or))_t=_t.times(J.plus(lr)).dividedBy(lr);else for(lr=Or;lr.lte(J);lr=lr.plus(Or))_t=_t.times(mr.plus(lr)).dividedBy(lr);return _t}})});function isPositiveInteger$2(D){return D.isInteger()&&D.gte(0)}var name$54="combinationsWithRep",dependencies$54=["typed"],createCombinationsWithRep=factory(name$54,dependencies$54,D=>{var{typed:E}=D;return E(name$54,{"number, number":function(F,J){if(!isInteger(F)||F<0||!isInteger(J)||J<0)throw TypeError("Positive integer value expected in function combinationsWithRep");if(F<1)throw TypeError("k must be less than or equal to n + k - 1");return J<F-1?product(F,F+J-1)/product(1,J):product(J+1,F+J-1)/product(1,F-1)},"BigNumber, BigNumber":function(F,J){var $e=F.constructor,_t,lr,mr=new $e(1),Or=F.minus(mr);if(!isPositiveInteger$1(F)||!isPositiveInteger$1(J))throw TypeError("Positive integer value expected in function combinationsWithRep");if(F.lt(mr))throw TypeError("k must be less than or equal to n + k - 1 in function combinationsWithRep");if(_t=mr,J.lt(Or))for(lr=mr;lr.lte(Or);lr=lr.plus(mr))_t=_t.times(J.plus(lr)).dividedBy(lr);else for(lr=mr;lr.lte(J);lr=lr.plus(mr))_t=_t.times(Or.plus(lr)).dividedBy(lr);return _t}})});function isPositiveInteger$1(D){return D.isInteger()&&D.gte(0)}var name$53="gamma",dependencies$53=["typed","config","multiplyScalar","pow","BigNumber","Complex"],createGamma=factory(name$53,dependencies$53,D=>{var{typed:E,config:F,multiplyScalar:J,pow:$e,BigNumber:_t,Complex:lr}=D;function mr(Pr){if(Pr.im===0)return gammaNumber(Pr.re);if(Pr.re<.5){var dn=new lr(1-Pr.re,-Pr.im),gi=new lr(Math.PI*Pr.re,Math.PI*Pr.im);return new lr(Math.PI).div(gi.sin()).div(mr(dn))}Pr=new lr(Pr.re-1,Pr.im);for(var qi=new lr(gammaP[0],0),zi=1;zi<gammaP.length;++zi){var Hi=new lr(gammaP[zi],0);qi=qi.add(Hi.div(Pr.add(zi)))}var Qi=new lr(Pr.re+gammaG+.5,Pr.im),Gi=Math.sqrt(2*Math.PI),Zi=Qi.pow(Pr.add(.5)),Xi=Qi.neg().exp();return qi.mul(Gi).mul(Zi).mul(Xi)}return E(name$53,{number:gammaNumber,Complex:mr,BigNumber:function(Pr){if(Pr.isInteger())return Pr.isNegative()||Pr.isZero()?new _t(1/0):Or(Pr.minus(1));if(!Pr.isFinite())return new _t(Pr.isNegative()?NaN:1/0);throw Error("Integer BigNumber expected")}});function Or(Pr){if(Pr<8)return new _t([1,1,2,6,24,120,720,5040][Pr]);var dn=F.precision+(Math.log(Pr.toNumber())|0),gi=_t.clone({precision:dn});if(Pr%2==1)return Pr.times(Or(new _t(Pr-1)));for(var qi=Pr,zi=new gi(Pr),Hi=Pr.toNumber();qi>2;)qi-=2,Hi+=qi,zi=zi.times(Hi);return new _t(zi.toPrecision(_t.precision))}}),name$52="lgamma",dependencies$52=["Complex","typed"],createLgamma=factory(name$52,dependencies$52,D=>{var{Complex:E,typed:F}=D,J=7,$e=7,_t=[-.029550653594771242,.00641025641025641,-.0019175269175269176,.0008417508417508417,-.0005952380952380953,.0007936507936507937,-.002777777777777778,.08333333333333333];return F(name$52,{number:lgammaNumber,Complex:lr,BigNumber:function(){throw Error("mathjs doesn\'t yet provide an implementation of the algorithm lgamma for BigNumber")}});function lr(Pr){var dn=6.283185307179586,gi=1.1447298858494002,qi=.1;if(Pr.isNaN())return new E(NaN,NaN);if(Pr.im===0)return new E(lgammaNumber(Pr.re),0);if(Pr.re>=J||Math.abs(Pr.im)>=$e)return mr(Pr);if(Pr.re<=qi){var zi=copysign(dn,Pr.im)*Math.floor(.5*Pr.re+.25),Hi=Pr.mul(Math.PI).sin().log(),Qi=lr(new E(1-Pr.re,-Pr.im));return new E(gi,zi).sub(Hi).sub(Qi)}else return Pr.im>=0?Or(Pr):Or(Pr.conjugate()).conjugate()}function mr(Pr){for(var dn=Pr.sub(.5).mul(Pr.log()).sub(Pr).add(lnSqrt2PI),gi=new E(1,0).div(Pr),qi=gi.div(Pr),zi=_t[0],Hi=_t[1],Qi=2*qi.re,Gi=qi.re*qi.re+qi.im*qi.im,Zi=2;Zi<8;Zi++){var Xi=Hi;Hi=-Gi*zi+_t[Zi],zi=Qi*zi+Xi}var Ki=gi.mul(qi.mul(zi).add(Hi));return dn.add(Ki)}function Or(Pr){var dn=0,gi=0,qi=Pr;for(Pr=Pr.add(1);Pr.re<=J;){qi=qi.mul(Pr);var zi=+(qi.im<0);zi!==0&&gi===0&&dn++,gi=zi,Pr=Pr.add(1)}return mr(Pr).sub(qi.log()).sub(new E(0,dn*2*Math.PI*1))}}),name$51="factorial",dependencies$51=["typed","gamma"],createFactorial=factory(name$51,dependencies$51,D=>{var{typed:E,gamma:F}=D;return E(name$51,{number:function(J){if(J<0)throw Error("Value must be non-negative");return F(J+1)},BigNumber:function(J){if(J.isNegative())throw Error("Value must be non-negative");return F(J.plus(1))},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name$50="kldivergence",dependencies$50=["typed","matrix","divide","sum","multiply","map","dotDivide","log","isNumeric"],createKldivergence=factory(name$50,dependencies$50,D=>{var{typed:E,matrix:F,divide:J,sum:$e,multiply:_t,map:lr,dotDivide:mr,log:Or,isNumeric:Pr}=D;return E(name$50,{"Array, Array":function(gi,qi){return dn(F(gi),F(qi))},"Matrix, Array":function(gi,qi){return dn(gi,F(qi))},"Array, Matrix":function(gi,qi){return dn(F(gi),qi)},"Matrix, Matrix":function(gi,qi){return dn(gi,qi)}});function dn(gi,qi){var zi=qi.size().length,Hi=gi.size().length;if(zi>1)throw Error("first object must be one dimensional");if(Hi>1)throw Error("second object must be one dimensional");if(zi!==Hi)throw Error("Length of two vectors must be equal");if($e(gi)===0)throw Error("Sum of elements in first object must be non zero");if($e(qi)===0)throw Error("Sum of elements in second object must be non zero");var Qi=J(gi,$e(gi)),Gi=$e(_t(Qi,lr(mr(Qi,J(qi,$e(qi))),Zi=>Or(Zi))));return Pr(Gi)?Gi:NaN}}),name$49="multinomial",dependencies$49=["typed","add","divide","multiply","factorial","isInteger","isPositive"],createMultinomial=factory(name$49,dependencies$49,D=>{var{typed:E,add:F,divide:J,multiply:$e,factorial:_t,isInteger:lr,isPositive:mr}=D;return E(name$49,{"Array | Matrix":function(Or){var Pr=0,dn=1;return deepForEach(Or,function(gi){if(!lr(gi)||!mr(gi))throw TypeError("Positive integer value expected in function multinomial");Pr=F(Pr,gi),dn=$e(dn,_t(gi))}),J(_t(Pr),dn)}})}),name$48="permutations",dependencies$48=["typed","factorial"],createPermutations=factory(name$48,dependencies$48,D=>{var{typed:E,factorial:F}=D;return E(name$48,{"number | BigNumber":F,"number, number":function(J,$e){if(!isInteger(J)||J<0||!isInteger($e)||$e<0)throw TypeError("Positive integer value expected in function permutations");if($e>J)throw TypeError("second argument k must be less than or equal to first argument n");return product(J-$e+1,J)},"BigNumber, BigNumber":function(J,$e){var _t,lr;if(!isPositiveInteger(J)||!isPositiveInteger($e))throw TypeError("Positive integer value expected in function permutations");if($e.gt(J))throw TypeError("second argument k must be less than or equal to first argument n");for(_t=J.mul(0).add(1),lr=J.minus($e).plus(1);lr.lte(J);lr=lr.plus(1))_t=_t.times(lr);return _t}})});function isPositiveInteger(D){return D.isInteger()&&D.gte(0)}var require_alea=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Pr){var dn=this,gi=Or();dn.next=function(){var qi=2091639*dn.s0+dn.c*23283064365386963e-26;return dn.s0=dn.s1,dn.s1=dn.s2,dn.s2=qi-(dn.c=qi|0)},dn.c=1,dn.s0=gi(" "),dn.s1=gi(" "),dn.s2=gi(" "),dn.s0-=gi(Pr),dn.s0<0&&(dn.s0+=1),dn.s1-=gi(Pr),dn.s1<0&&(dn.s1+=1),dn.s2-=gi(Pr),dn.s2<0&&(dn.s2+=1),gi=null}function lr(Pr,dn){return dn.c=Pr.c,dn.s0=Pr.s0,dn.s1=Pr.s1,dn.s2=Pr.s2,dn}function mr(Pr,dn){var gi=new _t(Pr),qi=dn&&dn.state,zi=gi.next;return zi.int32=function(){return gi.next()*4294967296|0},zi.double=function(){return zi()+(zi()*2097152|0)*11102230246251565e-32},zi.quick=zi,qi&&(typeof qi=="object"&&lr(qi,gi),zi.state=function(){return lr(gi,{})}),zi}function Or(){var Pr=4022871197;return function(dn){dn=String(dn);for(var gi=0;gi<dn.length;gi++){Pr+=dn.charCodeAt(gi);var qi=.02519603282416938*Pr;Pr=qi>>>0,qi-=Pr,qi*=Pr,Pr=qi>>>0,qi-=Pr,Pr+=qi*4294967296}return(Pr>>>0)*23283064365386963e-26}}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.alea=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require_xor128=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Or){var Pr=this,dn="";Pr.x=0,Pr.y=0,Pr.z=0,Pr.w=0,Pr.next=function(){var qi=Pr.x^Pr.x<<11;return Pr.x=Pr.y,Pr.y=Pr.z,Pr.z=Pr.w,Pr.w^=Pr.w>>>19^qi^qi>>>8},Or===(Or|0)?Pr.x=Or:dn+=Or;for(var gi=0;gi<dn.length+64;gi++)Pr.x^=dn.charCodeAt(gi)|0,Pr.next()}function lr(Or,Pr){return Pr.x=Or.x,Pr.y=Or.y,Pr.z=Or.z,Pr.w=Or.w,Pr}function mr(Or,Pr){var dn=new _t(Or),gi=Pr&&Pr.state,qi=function(){return(dn.next()>>>0)/4294967296};return qi.double=function(){do var zi=((dn.next()>>>11)+(dn.next()>>>0)/4294967296)/(1<<21);while(zi===0);return zi},qi.int32=dn.next,qi.quick=qi,gi&&(typeof gi=="object"&&lr(gi,dn),qi.state=function(){return lr(dn,{})}),qi}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.xor128=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require_xorwow=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Or){var Pr=this,dn="";Pr.next=function(){var qi=Pr.x^Pr.x>>>2;return Pr.x=Pr.y,Pr.y=Pr.z,Pr.z=Pr.w,Pr.w=Pr.v,(Pr.d=Pr.d+362437|0)+(Pr.v=Pr.v^Pr.v<<4^(qi^qi<<1))|0},Pr.x=0,Pr.y=0,Pr.z=0,Pr.w=0,Pr.v=0,Or===(Or|0)?Pr.x=Or:dn+=Or;for(var gi=0;gi<dn.length+64;gi++)Pr.x^=dn.charCodeAt(gi)|0,gi==dn.length&&(Pr.d=Pr.x<<10^Pr.x>>>4),Pr.next()}function lr(Or,Pr){return Pr.x=Or.x,Pr.y=Or.y,Pr.z=Or.z,Pr.w=Or.w,Pr.v=Or.v,Pr.d=Or.d,Pr}function mr(Or,Pr){var dn=new _t(Or),gi=Pr&&Pr.state,qi=function(){return(dn.next()>>>0)/4294967296};return qi.double=function(){do var zi=((dn.next()>>>11)+(dn.next()>>>0)/4294967296)/(1<<21);while(zi===0);return zi},qi.int32=dn.next,qi.quick=qi,gi&&(typeof gi=="object"&&lr(gi,dn),qi.state=function(){return lr(dn,{})}),qi}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.xorwow=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require_xorshift7=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Or){var Pr=this;Pr.next=function(){var gi=Pr.x,qi=Pr.i,zi=gi[qi],Hi;return zi^=zi>>>7,Hi=zi^zi<<24,zi=gi[qi+1&7],Hi^=zi^zi>>>10,zi=gi[qi+3&7],Hi^=zi^zi>>>3,zi=gi[qi+4&7],Hi^=zi^zi<<7,zi=gi[qi+7&7],zi^=zi<<13,Hi^=zi^zi<<9,gi[qi]=Hi,Pr.i=qi+1&7,Hi};function dn(gi,qi){var zi,Hi=[];if(qi===(qi|0))Hi[0]=qi;else for(qi=""+qi,zi=0;zi<qi.length;++zi)Hi[zi&7]=Hi[zi&7]<<15^qi.charCodeAt(zi)+Hi[zi+1&7]<<13;for(;Hi.length<8;)Hi.push(0);for(zi=0;zi<8&&Hi[zi]===0;++zi);for(zi==8?Hi[7]=-1:Hi[zi],gi.x=Hi,gi.i=0,zi=256;zi>0;--zi)gi.next()}dn(Pr,Or)}function lr(Or,Pr){return Pr.x=Or.x.slice(),Pr.i=Or.i,Pr}function mr(Or,Pr){Or??=+new Date;var dn=new _t(Or),gi=Pr&&Pr.state,qi=function(){return(dn.next()>>>0)/4294967296};return qi.double=function(){do var zi=((dn.next()>>>11)+(dn.next()>>>0)/4294967296)/(1<<21);while(zi===0);return zi},qi.int32=dn.next,qi.quick=qi,gi&&(gi.x&&lr(gi,dn),qi.state=function(){return lr(dn,{})}),qi}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.xorshift7=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require_xor4096=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Or){var Pr=this;Pr.next=function(){var gi=Pr.w,qi=Pr.X,zi=Pr.i,Hi,Qi;return Pr.w=gi=gi+1640531527|0,Qi=qi[zi+34&127],Hi=qi[zi=zi+1&127],Qi^=Qi<<13,Hi^=Hi<<17,Qi^=Qi>>>15,Hi^=Hi>>>12,Qi=qi[zi]=Qi^Hi,Pr.i=zi,Qi+(gi^gi>>>16)|0};function dn(gi,qi){var zi,Hi,Qi,Gi,Zi,Xi=[],Ki=128;for(qi===(qi|0)?(Hi=qi,qi=null):(qi+="\\0",Hi=0,Ki=Math.max(Ki,qi.length)),Qi=0,Gi=-32;Gi<Ki;++Gi)qi&&(Hi^=qi.charCodeAt((Gi+32)%qi.length)),Gi===0&&(Zi=Hi),Hi^=Hi<<10,Hi^=Hi>>>15,Hi^=Hi<<4,Hi^=Hi>>>13,Gi>=0&&(Zi=Zi+1640531527|0,zi=Xi[Gi&127]^=Hi+Zi,Qi=zi==0?Qi+1:0);for(Qi>=128&&(Xi[(qi&&qi.length||0)&127]=-1),Qi=127,Gi=512;Gi>0;--Gi)Hi=Xi[Qi+34&127],zi=Xi[Qi=Qi+1&127],Hi^=Hi<<13,zi^=zi<<17,Hi^=Hi>>>15,zi^=zi>>>12,Xi[Qi]=Hi^zi;gi.w=Zi,gi.X=Xi,gi.i=Qi}dn(Pr,Or)}function lr(Or,Pr){return Pr.i=Or.i,Pr.w=Or.w,Pr.X=Or.X.slice(),Pr}function mr(Or,Pr){Or??=+new Date;var dn=new _t(Or),gi=Pr&&Pr.state,qi=function(){return(dn.next()>>>0)/4294967296};return qi.double=function(){do var zi=((dn.next()>>>11)+(dn.next()>>>0)/4294967296)/(1<<21);while(zi===0);return zi},qi.int32=dn.next,qi.quick=qi,gi&&(gi.X&&lr(gi,dn),qi.state=function(){return lr(dn,{})}),qi}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.xor4096=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require_tychei=__commonJSMin(((D,E)=>{(function(F,J,$e){function _t(Or){var Pr=this,dn="";Pr.next=function(){var qi=Pr.b,zi=Pr.c,Hi=Pr.d,Qi=Pr.a;return qi=qi<<25^qi>>>7^zi,zi=zi-Hi|0,Hi=Hi<<24^Hi>>>8^Qi,Qi=Qi-qi|0,Pr.b=qi=qi<<20^qi>>>12^zi,Pr.c=zi=zi-Hi|0,Pr.d=Hi<<16^zi>>>16^Qi,Pr.a=Qi-qi|0},Pr.a=0,Pr.b=0,Pr.c=-1640531527,Pr.d=1367130551,Or===Math.floor(Or)?(Pr.a=Or/4294967296|0,Pr.b=Or|0):dn+=Or;for(var gi=0;gi<dn.length+20;gi++)Pr.b^=dn.charCodeAt(gi)|0,Pr.next()}function lr(Or,Pr){return Pr.a=Or.a,Pr.b=Or.b,Pr.c=Or.c,Pr.d=Or.d,Pr}function mr(Or,Pr){var dn=new _t(Or),gi=Pr&&Pr.state,qi=function(){return(dn.next()>>>0)/4294967296};return qi.double=function(){do var zi=((dn.next()>>>11)+(dn.next()>>>0)/4294967296)/(1<<21);while(zi===0);return zi},qi.int32=dn.next,qi.quick=qi,gi&&(typeof gi=="object"&&lr(gi,dn),qi.state=function(){return lr(dn,{})}),qi}J&&J.exports?J.exports=mr:$e&&$e.amd?$e(function(){return mr}):this.tychei=mr})(D,typeof E=="object"&&E,typeof define=="function"&&define)})),require___vite_browser_external=__commonJSMin(((D,E)=>{E.exports={}})),require_seedrandom$1=__commonJSMin(((D,E)=>{(function(F,J,$e){var _t=256,lr=6,mr=52,Or="random",Pr=$e.pow(_t,lr),dn=$e.pow(2,mr),gi=dn*2,qi=_t-1,zi;function Hi(Ji,ta,na){var ra=[];ta=ta==1?{entropy:!0}:ta||{};var ia=Xi(Zi(ta.entropy?[Ji,ea(J)]:Ji??Ki(),3),ra),oa=new Qi(ra),ua=function(){for(var sa=oa.g(lr),aa=Pr,pa=0;sa<dn;)sa=(sa+pa)*_t,aa*=_t,pa=oa.g(1);for(;sa>=gi;)sa/=2,aa/=2,pa>>>=1;return(sa+pa)/aa};return ua.int32=function(){return oa.g(4)|0},ua.quick=function(){return oa.g(4)/4294967296},ua.double=ua,Xi(ea(oa.S),J),(ta.pass||na||function(sa,aa,pa,ma){return ma&&(ma.S&&Gi(ma,oa),sa.state=function(){return Gi(oa,{})}),pa?($e[Or]=sa,aa):sa})(ua,ia,"global"in ta?ta.global:this==$e,ta.state)}function Qi(Ji){var ta,na=Ji.length,ra=this,ia=0,oa=ra.i=ra.j=0,ua=ra.S=[];for(na||(Ji=[na++]);ia<_t;)ua[ia]=ia++;for(ia=0;ia<_t;ia++)ua[ia]=ua[oa=qi&oa+Ji[ia%na]+(ta=ua[ia])],ua[oa]=ta;(ra.g=function(sa){for(var aa,pa=0,ma=ra.i,la=ra.j,ha=ra.S;sa--;)aa=ha[ma=qi&ma+1],pa=pa*_t+ha[qi&(ha[ma]=ha[la=qi&la+aa])+(ha[la]=aa)];return ra.i=ma,ra.j=la,pa})(_t)}function Gi(Ji,ta){return ta.i=Ji.i,ta.j=Ji.j,ta.S=Ji.S.slice(),ta}function Zi(Ji,ta){var na=[],ra=typeof Ji,ia;if(ta&&ra=="object")for(ia in Ji)try{na.push(Zi(Ji[ia],ta-1))}catch{}return na.length?na:ra=="string"?Ji:Ji+"\\0"}function Xi(Ji,ta){for(var na=Ji+"",ra,ia=0;ia<na.length;)ta[qi&ia]=qi&(ra^=ta[qi&ia]*19)+na.charCodeAt(ia++);return ea(ta)}function Ki(){try{var Ji;return zi&&(Ji=zi.randomBytes)?Ji=Ji(_t):(Ji=new Uint8Array(_t),(F.crypto||F.msCrypto).getRandomValues(Ji)),ea(Ji)}catch{var ta=F.navigator,na=ta&&ta.plugins;return[+new Date,F,na,F.screen,ea(J)]}}function ea(Ji){return String.fromCharCode.apply(0,Ji)}if(Xi($e.random(),J),typeof E=="object"&&E.exports){E.exports=Hi;try{zi=require___vite_browser_external()}catch{}}else typeof define=="function"&&define.amd?define(function(){return Hi}):$e["seed"+Or]=Hi})(typeof self<"u"?self:D,[],Math)})),require_seedrandom=__commonJSMin(((D,E)=>{var F=require_alea(),J=require_xor128(),$e=require_xorwow(),_t=require_xorshift7(),lr=require_xor4096(),mr=require_tychei(),Or=require_seedrandom$1();Or.alea=F,Or.xor128=J,Or.xorwow=$e,Or.xorshift7=_t,Or.xor4096=lr,Or.tychei=mr,E.exports=Or})),import_seedrandom=__toESM(require_seedrandom()),singletonRandom=(0,import_seedrandom.default)(Date.now());function createRng(D){var E;function F($e){E=$e===null?singletonRandom:(0,import_seedrandom.default)(String($e))}F(D);function J(){return E()}return J}var name$47="pickRandom",dependencies$47=["typed","config","?on"],createPickRandom=factory(name$47,dependencies$47,D=>{var{typed:E,config:F,on:J}=D,$e=createRng(F.randomSeed);return J&&J("config",function(lr,mr){lr.randomSeed!==mr.randomSeed&&($e=createRng(lr.randomSeed))}),E(name$47,{"Array | Matrix":function(lr){return _t(lr,{})},"Array | Matrix, Object":function(lr,mr){return _t(lr,mr)},"Array | Matrix, number":function(lr,mr){return _t(lr,{number:mr})},"Array | Matrix, Array | Matrix":function(lr,mr){return _t(lr,{weights:mr})},"Array | Matrix, Array | Matrix, number":function(lr,mr,Or){return _t(lr,{number:Or,weights:mr})},"Array | Matrix, number, Array | Matrix":function(lr,mr,Or){return _t(lr,{number:mr,weights:Or})}});function _t(lr,mr){var{number:Or,weights:Pr,elementWise:dn=!0}=mr,gi=Or===void 0;gi&&(Or=1);var qi=isMatrix(lr)?lr.create:isMatrix(Pr)?Pr.create:null;lr=lr.valueOf(),Pr&&=Pr.valueOf(),dn===!0&&(lr=flatten$4(lr),Pr=flatten$4(Pr));var zi=0;if(Pr!==void 0){if(Pr.length!==lr.length)throw Error("Weights must have the same length as possibles");for(var Hi=0,Qi=Pr.length;Hi<Qi;Hi++){if(!isNumber(Pr[Hi])||Pr[Hi]<0)throw Error("Weights must be an array of positive numbers");zi+=Pr[Hi]}}for(var Gi=lr.length,Zi=[],Xi;Zi.length<Or;){if(Pr===void 0)Xi=lr[Math.floor($e()*Gi)];else for(var Ki=$e()*zi,ea=0,Ji=lr.length;ea<Ji;ea++)if(Ki-=Pr[ea],Ki<0){Xi=lr[ea];break}Zi.push(Xi)}return gi?Zi[0]:qi?qi(Zi):Zi}});function randomMatrix(D,E){var F=[];if(D=D.slice(0),D.length>1)for(var J=0,$e=D.shift();J<$e;J++)F.push(randomMatrix(D,E));else for(var _t=0,lr=D.shift();_t<lr;_t++)F.push(E());return F}var name$46="random",dependencies$46=["typed","config","?on"],createRandom=factory(name$46,dependencies$46,D=>{var{typed:E,config:F,on:J}=D,$e=createRng(F.randomSeed);return J&&J("config",function(mr,Or){mr.randomSeed!==Or.randomSeed&&($e=createRng(mr.randomSeed))}),E(name$46,{"":()=>lr(0,1),number:mr=>lr(0,mr),"number, number":(mr,Or)=>lr(mr,Or),"Array | Matrix":mr=>_t(mr,0,1),"Array | Matrix, number":(mr,Or)=>_t(mr,0,Or),"Array | Matrix, number, number":(mr,Or,Pr)=>_t(mr,Or,Pr)});function _t(mr,Or,Pr){var dn=randomMatrix(mr.valueOf(),()=>lr(Or,Pr));return isMatrix(mr)?mr.create(dn,"number"):dn}function lr(mr,Or){return mr+$e()*(Or-mr)}}),name$45="randomInt",dependencies$45=["typed","config","log2","?on"],createRandomInt=factory(name$45,dependencies$45,D=>{var{typed:E,config:F,log2:J,on:$e}=D,_t=createRng(F.randomSeed);return $e&&$e("config",function(Pr,dn){Pr.randomSeed!==dn.randomSeed&&(_t=createRng(Pr.randomSeed))}),E(name$45,{"":()=>mr(0,2),number:Pr=>mr(0,Pr),"number, number":(Pr,dn)=>mr(Pr,dn),bigint:Pr=>Or(0n,Pr),"bigint, bigint":Or,"Array | Matrix":Pr=>lr(Pr,0,1),"Array | Matrix, number":(Pr,dn)=>lr(Pr,0,dn),"Array | Matrix, number, number":(Pr,dn,gi)=>lr(Pr,dn,gi)});function lr(Pr,dn,gi){var qi=randomMatrix(Pr.valueOf(),()=>mr(dn,gi));return isMatrix(Pr)?Pr.create(qi,"number"):qi}function mr(Pr,dn){return Math.floor(Pr+_t()*(dn-Pr))}function Or(Pr,dn){var gi=2n**30n,qi=dn-Pr;if(qi<=gi)return Pr+BigInt(mr(0,Number(qi)));for(var zi=J(qi),Hi=qi;Hi>=qi;){Hi=0n;for(var Qi=0;Qi<zi;++Qi)Hi=2n*Hi+(_t()<.5?0n:1n)}return Pr+Hi}}),name$44="stirlingS2",dependencies$44=["typed","addScalar","subtractScalar","multiplyScalar","divideScalar","pow","factorial","combinations","isNegative","isInteger","number","?bignumber","larger"],createStirlingS2=factory(name$44,dependencies$44,D=>{var{typed:E,addScalar:F,subtractScalar:J,multiplyScalar:$e,divideScalar:_t,pow:lr,factorial:mr,combinations:Or,isNegative:Pr,isInteger:dn,number:gi,bignumber:qi,larger:zi}=D,Hi=[],Qi=[];return E(name$44,{"number | BigNumber, number | BigNumber":function(Gi,Zi){if(!dn(Gi)||Pr(Gi)||!dn(Zi)||Pr(Zi))throw TypeError("Non-negative integer value expected in function stirlingS2");if(zi(Zi,Gi))throw TypeError("k must be less than or equal to n in function stirlingS2");var Xi=!(isNumber(Gi)&&isNumber(Zi)),Ki=Xi?Qi:Hi,ea=Xi?qi:gi,Ji=gi(Gi),ta=gi(Zi);if(Ki[Ji]&&Ki[Ji].length>ta)return Ki[Ji][ta];for(var na=0;na<=Ji;++na)if(Ki[na]||(Ki[na]=[ea(+(na===0))]),na!==0)for(var ra=Ki[na],ia=Ki[na-1],oa=ra.length;oa<=na&&oa<=ta;++oa)oa===na?ra[oa]=1:ra[oa]=F($e(ea(oa),ia[oa]),ia[oa-1]);return Ki[Ji][ta]}})}),name$43="bellNumbers",dependencies$43=["typed","addScalar","isNegative","isInteger","stirlingS2"],createBellNumbers=factory(name$43,dependencies$43,D=>{var{typed:E,addScalar:F,isNegative:J,isInteger:$e,stirlingS2:_t}=D;return E(name$43,{"number | BigNumber":function(lr){if(!$e(lr)||J(lr))throw TypeError("Non-negative integer value expected in function bellNumbers");for(var mr=0,Or=0;Or<=lr;Or++)mr=F(mr,_t(lr,Or));return mr}})}),name$42="catalan",dependencies$42=["typed","addScalar","divideScalar","multiplyScalar","combinations","isNegative","isInteger"],createCatalan=factory(name$42,dependencies$42,D=>{var{typed:E,addScalar:F,divideScalar:J,multiplyScalar:$e,combinations:_t,isNegative:lr,isInteger:mr}=D;return E(name$42,{"number | BigNumber":function(Or){if(!mr(Or)||lr(Or))throw TypeError("Non-negative integer value expected in function catalan");return J(_t($e(Or,2),Or),F(Or,1))}})}),name$41="composition",dependencies$41=["typed","addScalar","combinations","isNegative","isPositive","isInteger","larger"],createComposition=factory(name$41,dependencies$41,D=>{var{typed:E,addScalar:F,combinations:J,isPositive:$e,isNegative:_t,isInteger:lr,larger:mr}=D;return E(name$41,{"number | BigNumber, number | BigNumber":function(Or,Pr){if(!lr(Or)||!$e(Or)||!lr(Pr)||!$e(Pr))throw TypeError("Positive integer value expected in function composition");if(mr(Pr,Or))throw TypeError("k must be less than or equal to n in function composition");return J(F(Or,-1),F(Pr,-1))}})}),name$40="leafCount",dependencies$40=["parse","typed"],createLeafCount=factory(name$40,dependencies$40,D=>{var{parse:E,typed:F}=D;function J($e){var _t=0;return $e.forEach(lr=>{_t+=J(lr)}),_t||1}return F(name$40,{Node:function($e){return J($e)}})});function isNumericNode(D){return isConstantNode(D)||isOperatorNode(D)&&D.isUnary()&&isConstantNode(D.args[0])}function isConstantExpression(D){return!!(isConstantNode(D)||(isFunctionNode(D)||isOperatorNode(D))&&D.args.every(isConstantExpression)||isParenthesisNode(D)&&isConstantExpression(D.content))}function ownKeys$1(D,E){var F=Object.keys(D);if(Object.getOwnPropertySymbols){var J=Object.getOwnPropertySymbols(D);E&&(J=J.filter(function($e){return Object.getOwnPropertyDescriptor(D,$e).enumerable})),F.push.apply(F,J)}return F}function _objectSpread$1(D){for(var E=1;E<arguments.length;E++){var F=arguments[E]==null?{}:arguments[E];E%2?ownKeys$1(Object(F),!0).forEach(function(J){_defineProperty(D,J,F[J])}):Object.getOwnPropertyDescriptors?Object.defineProperties(D,Object.getOwnPropertyDescriptors(F)):ownKeys$1(Object(F)).forEach(function(J){Object.defineProperty(D,J,Object.getOwnPropertyDescriptor(F,J))})}return D}var name$39="simplifyUtil",dependencies$39=["FunctionNode","OperatorNode","SymbolNode"],createUtil=factory(name$39,dependencies$39,D=>{var{FunctionNode:E,OperatorNode:F,SymbolNode:J}=D,$e=!0,_t=!1,lr="defaultF",mr={add:{trivial:$e,total:$e,commutative:$e,associative:$e},unaryPlus:{trivial:$e,total:$e,commutative:$e,associative:$e},subtract:{trivial:_t,total:$e,commutative:_t,associative:_t},multiply:{trivial:$e,total:$e,commutative:$e,associative:$e},divide:{trivial:_t,total:$e,commutative:_t,associative:_t},paren:{trivial:$e,total:$e,commutative:$e,associative:_t},defaultF:{trivial:_t,total:$e,commutative:_t,associative:_t}},Or={divide:{total:_t},log:{total:_t}},Pr={subtract:{total:_t},abs:{trivial:$e},log:{total:$e}};function dn(Ki,ea){var Ji=arguments.length>2&&arguments[2]!==void 0?arguments[2]:mr,ta=lr;if(typeof Ki=="string"?ta=Ki:isOperatorNode(Ki)?ta=Ki.fn.toString():isFunctionNode(Ki)?ta=Ki.name:isParenthesisNode(Ki)&&(ta="paren"),hasOwnProperty$1(Ji,ta)){var na=Ji[ta];if(hasOwnProperty$1(na,ea))return na[ea];if(hasOwnProperty$1(mr,ta))return mr[ta][ea]}if(hasOwnProperty$1(Ji,lr)){var ra=Ji[lr];return hasOwnProperty$1(ra,ea)?ra[ea]:mr[lr][ea]}if(hasOwnProperty$1(mr,ta)){var ia=mr[ta];if(hasOwnProperty$1(ia,ea))return ia[ea]}return mr[lr][ea]}function gi(Ki){return dn(Ki,"commutative",arguments.length>1&&arguments[1]!==void 0?arguments[1]:mr)}function qi(Ki){return dn(Ki,"associative",arguments.length>1&&arguments[1]!==void 0?arguments[1]:mr)}function zi(Ki,ea){var Ji=_objectSpread$1({},Ki);for(var ta in ea)hasOwnProperty$1(Ki,ta)?Ji[ta]=_objectSpread$1(_objectSpread$1({},ea[ta]),Ki[ta]):Ji[ta]=ea[ta];return Ji}function Hi(Ki,ea){if(!Ki.args||Ki.args.length===0)return Ki;Ki.args=Qi(Ki,ea);for(var Ji=0;Ji<Ki.args.length;Ji++)Hi(Ki.args[Ji],ea)}function Qi(Ki,ea){var Ji,ta=[],na=function(ra){for(var ia=0;ia<ra.args.length;ia++){var oa=ra.args[ia];isOperatorNode(oa)&&Ji===oa.op?na(oa):ta.push(oa)}};return qi(Ki,ea)?(Ji=Ki.op,na(Ki),ta):Ki.args}function Gi(Ki,ea){if(!(!Ki.args||Ki.args.length===0)){for(var Ji=Xi(Ki),ta=Ki.args.length,na=0;na<ta;na++)Gi(Ki.args[na],ea);if(ta>2&&qi(Ki,ea)){for(var ra=Ki.args.pop();Ki.args.length>0;)ra=Ji([Ki.args.pop(),ra]);Ki.args=ra.args}}}function Zi(Ki,ea){if(!(!Ki.args||Ki.args.length===0)){for(var Ji=Xi(Ki),ta=Ki.args.length,na=0;na<ta;na++)Zi(Ki.args[na],ea);if(ta>2&&qi(Ki,ea)){for(var ra=Ki.args.shift();Ki.args.length>0;)ra=Ji([ra,Ki.args.shift()]);Ki.args=ra.args}}}function Xi(Ki){return isOperatorNode(Ki)?function(ea){try{return new F(Ki.op,Ki.fn,ea,Ki.implicit)}catch(Ji){return console.error(Ji),[]}}:function(ea){return new E(new J(Ki.name),ea)}}return{createMakeNodeFunction:Xi,hasProperty:dn,isCommutative:gi,isAssociative:qi,mergeContext:zi,flatten:Hi,allChildren:Qi,unflattenr:Gi,unflattenl:Zi,defaultContext:mr,realContext:Or,positiveContext:Pr}}),name$38="simplify",dependencies$38=["typed","parse","equal","resolve","simplifyConstant","simplifyCore","AccessorNode","ArrayNode","ConstantNode","FunctionNode","IndexNode","ObjectNode","OperatorNode","ParenthesisNode","SymbolNode","replacer"],createSimplify=factory(name$38,dependencies$38,D=>{var{typed:E,parse:F,equal:J,resolve:$e,simplifyConstant:_t,simplifyCore:lr,AccessorNode:mr,ArrayNode:Or,ConstantNode:Pr,FunctionNode:dn,IndexNode:gi,ObjectNode:qi,OperatorNode:zi,ParenthesisNode:Hi,SymbolNode:Qi,replacer:Gi}=D,{hasProperty:Zi,isCommutative:Xi,isAssociative:Ki,mergeContext:ea,flatten:Ji,unflattenr:ta,unflattenl:na,createMakeNodeFunction:ra,defaultContext:ia,realContext:oa,positiveContext:ua}=createUtil({FunctionNode:dn,OperatorNode:zi,SymbolNode:Qi});E.addConversion({from:"Object",to:"Map",convert:createMap$1});var sa=E("simplify",{Node:Aa,"Node, Map":(Da,va)=>Aa(Da,!1,va),"Node, Map, Object":(Da,va,Ca)=>Aa(Da,!1,va,Ca),"Node, Array":Aa,"Node, Array, Map":Aa,"Node, Array, Map, Object":Aa});E.removeConversion({from:"Object",to:"Map",convert:createMap$1}),sa.defaultContext=ia,sa.realContext=oa,sa.positiveContext=ua;function aa(Da){return Da.transform(function(va){return isParenthesisNode(va)?aa(va.content):va})}var pa={true:!0,false:!0,e:!0,i:!0,Infinity:!0,LN2:!0,LN10:!0,LOG2E:!0,LOG10E:!0,NaN:!0,phi:!0,pi:!0,SQRT1_2:!0,SQRT2:!0,tau:!0};sa.rules=[lr,{l:"log(e)",r:"1"},{s:"n-n1 -> n+-n1",assuming:{subtract:{total:!0}}},{s:"n-n -> 0",assuming:{subtract:{total:!1}}},{s:"-(cl*v) -> v * (-cl)",assuming:{multiply:{commutative:!0},subtract:{total:!0}}},{s:"-(cl*v) -> (-cl) * v",assuming:{multiply:{commutative:!1},subtract:{total:!0}}},{s:"-(v*cl) -> v * (-cl)",assuming:{multiply:{commutative:!1},subtract:{total:!0}}},{l:"-(n1/n2)",r:"-n1/n2"},{l:"-v",r:"v * (-1)"},{l:"(n1 + n2)*(-1)",r:"n1*(-1) + n2*(-1)",repeat:!0},{l:"n/n1^n2",r:"n*n1^-n2"},{l:"n/n1",r:"n*n1^-1"},{s:"(n1*n2)^n3 -> n1^n3 * n2^n3",assuming:{multiply:{commutative:!0}}},{s:"(n1*n2)^(-1) -> n2^(-1) * n1^(-1)",assuming:{multiply:{commutative:!1}}},{s:"(n ^ n1) ^ n2 -> n ^ (n1 * n2)",assuming:{divide:{total:!0}}},{l:" vd   * ( vd   * n1 + n2)",r:"vd^2       * n1 +  vd   * n2"},{s:" vd   * (vd^n4 * n1 + n2)   ->  vd^(1+n4)  * n1 +  vd   * n2",assuming:{divide:{total:!0}}},{s:"vd^n3 * ( vd   * n1 + n2)   ->  vd^(n3+1)  * n1 + vd^n3 * n2",assuming:{divide:{total:!0}}},{s:"vd^n3 * (vd^n4 * n1 + n2)   ->  vd^(n3+n4) * n1 + vd^n3 * n2",assuming:{divide:{total:!0}}},{l:"n*n",r:"n^2"},{s:"n * n^n1 -> n^(n1+1)",assuming:{divide:{total:!0}}},{s:"n^n1 * n^n2 -> n^(n1+n2)",assuming:{divide:{total:!0}}},_t,{s:"n+n -> 2*n",assuming:{add:{total:!0}}},{l:"n+-n",r:"0"},{l:"vd*n + vd",r:"vd*(n+1)"},{l:"n3*n1 + n3*n2",r:"n3*(n1+n2)"},{l:"n3^(-n4)*n1 +   n3  * n2",r:"n3^(-n4)*(n1 + n3^(n4+1) *n2)"},{l:"n3^(-n4)*n1 + n3^n5 * n2",r:"n3^(-n4)*(n1 + n3^(n4+n5)*n2)"},{s:"n*vd + vd -> (n+1)*vd",assuming:{multiply:{commutative:!1}}},{s:"vd + n*vd -> (1+n)*vd",assuming:{multiply:{commutative:!1}}},{s:"n1*n3 + n2*n3 -> (n1+n2)*n3",assuming:{multiply:{commutative:!1}}},{s:"n^n1 * n -> n^(n1+1)",assuming:{divide:{total:!0},multiply:{commutative:!1}}},{s:"n1*n3^(-n4) + n2 * n3    -> (n1 + n2*n3^(n4 +  1))*n3^(-n4)",assuming:{multiply:{commutative:!1}}},{s:"n1*n3^(-n4) + n2 * n3^n5 -> (n1 + n2*n3^(n4 + n5))*n3^(-n4)",assuming:{multiply:{commutative:!1}}},{l:"n*cd + cd",r:"(n+1)*cd"},{s:"cd*n + cd -> cd*(n+1)",assuming:{multiply:{commutative:!1}}},{s:"cd + cd*n -> cd*(1+n)",assuming:{multiply:{commutative:!1}}},_t,{s:"(-n)*n1 -> -(n*n1)",assuming:{subtract:{total:!0}}},{s:"n1*(-n) -> -(n1*n)",assuming:{subtract:{total:!0},multiply:{commutative:!1}}},{s:"ce+ve -> ve+ce",assuming:{add:{commutative:!0}},imposeContext:{add:{commutative:!1}}},{s:"vd*cd -> cd*vd",assuming:{multiply:{commutative:!0}},imposeContext:{multiply:{commutative:!1}}},{l:"n+-n1",r:"n-n1"},{l:"n+-(n1)",r:"n-(n1)"},{s:"n*(n1^-1) -> n/n1",assuming:{multiply:{commutative:!0}}},{s:"n*n1^-n2 -> n/n1^n2",assuming:{multiply:{commutative:!0}}},{s:"n^-1 -> 1/n",assuming:{multiply:{commutative:!0}}},{l:"n^1",r:"n"},{s:"n*(n1/n2) -> (n*n1)/n2",assuming:{multiply:{associative:!0}}},{s:"n-(n1+n2) -> n-n1-n2",assuming:{addition:{associative:!0,commutative:!0}}},{l:"1*n",r:"n",imposeContext:{multiply:{commutative:!0}}},{s:"n1/(n2/n3) -> (n1*n3)/n2",assuming:{multiply:{associative:!0}}},{l:"n1/(-n2)",r:"-n1/n2"}];function ma(Da,va){var Ca={};if(Da.s){var ya=Da.s.split("->");if(ya.length===2)Ca.l=ya[0],Ca.r=ya[1];else throw SyntaxError("Could not parse rule: "+Da.s)}else Ca.l=Da.l,Ca.r=Da.r;Ca.l=aa(F(Ca.l)),Ca.r=aa(F(Ca.r));for(var Na of["imposeContext","repeat","assuming"])Na in Da&&(Ca[Na]=Da[Na]);if(Da.evaluate&&(Ca.evaluate=F(Da.evaluate)),Ki(Ca.l,va)){var za=!Xi(Ca.l,va),Ta;za&&(Ta=ga());var es=ra(Ca.l),ts=ga();Ca.expanded={},Ca.expanded.l=es([Ca.l,ts]),Ji(Ca.expanded.l,va),ta(Ca.expanded.l,va),Ca.expanded.r=es([Ca.r,ts]),za&&(Ca.expandedNC1={},Ca.expandedNC1.l=es([Ta,Ca.l]),Ca.expandedNC1.r=es([Ta,Ca.r]),Ca.expandedNC2={},Ca.expandedNC2.l=es([Ta,Ca.expanded.l]),Ca.expandedNC2.r=es([Ta,Ca.expanded.r]))}return Ca}function la(Da,va){for(var Ca=[],ya=0;ya<Da.length;ya++){var Na=Da[ya],za=void 0,Ta=typeof Na;switch(Ta){case"string":Na={s:Na};case"object":za=ma(Na,va);break;case"function":za=Na;break;default:throw TypeError("Unsupported type of rule: "+Ta)}Ca.push(za)}return Ca}var ha=0;function ga(){return new Qi("_p"+ha++)}function Aa(Da,va){var Ca=arguments.length>2&&arguments[2]!==void 0?arguments[2]:createEmptyMap(),ya=arguments.length>3&&arguments[3]!==void 0?arguments[3]:{},Na=ya.consoleDebug;va=la(va||sa.rules,ya.context);var za=$e(Da,Ca);za=aa(za);for(var Ta={},es=za.toString({parenthesis:"all"});!Ta[es];){Ta[es]=!0,ha=0;var ts=es;Na&&console.log("Working on: ",es);for(var Ka=0;Ka<va.length;Ka++){var ps="";if(typeof va[Ka]=="function"?(za=va[Ka](za,ya),Na&&(ps=va[Ka].name)):(Ji(za,ya.context),za=$a(za,va[Ka],ya.context),Na&&(ps=`${va[Ka].l.toString()} -> ${va[Ka].r.toString()}`)),Na){var cs=za.toString({parenthesis:"all"});cs!==ts&&(console.log("Applying",ps,"produced",cs),ts=cs)}na(za,ya.context)}es=za.toString({parenthesis:"all"})}return za}function Fa(Da,va,Ca){var ya=Da;if(Da)for(var Na=0;Na<Da.length;++Na){var za=$a(Da[Na],va,Ca);za!==Da[Na]&&(ya===Da&&(ya=Da.slice()),ya[Na]=za)}return ya}function $a(Da,va,Ca){if(va.assuming){for(var ya in va.assuming)for(var Na in va.assuming[ya])if(Zi(ya,Na,Ca)!==va.assuming[ya][Na])return Da}var za=ea(va.imposeContext,Ca),Ta=Da;if(Ta instanceof zi||Ta instanceof dn){var es=Fa(Ta.args,va,Ca);es!==Ta.args&&(Ta=Ta.clone(),Ta.args=es)}else if(Ta instanceof Hi){if(Ta.content){var ts=$a(Ta.content,va,Ca);ts!==Ta.content&&(Ta=new Hi(ts))}}else if(Ta instanceof Or){var Ka=Fa(Ta.items,va,Ca);Ka!==Ta.items&&(Ta=new Or(Ka))}else if(Ta instanceof mr){var ps=Ta.object;Ta.object&&(ps=$a(Ta.object,va,Ca));var cs=Ta.index;Ta.index&&(cs=$a(Ta.index,va,Ca)),(ps!==Ta.object||cs!==Ta.index)&&(Ta=new mr(ps,cs))}else if(Ta instanceof gi){var xa=Fa(Ta.dimensions,va,Ca);xa!==Ta.dimensions&&(Ta=new gi(xa))}else if(Ta instanceof qi){var Ra=!1,Va={};for(var Ga in Ta.properties)Va[Ga]=$a(Ta.properties[Ga],va,Ca),Va[Ga]!==Ta.properties[Ga]&&(Ra=!0);Ra&&(Ta=new qi(Va))}var as=va.r,rs=Pa(va.l,Ta,za)[0];if(!rs&&va.expanded&&(as=va.expanded.r,rs=Pa(va.expanded.l,Ta,za)[0]),!rs&&va.expandedNC1&&(as=va.expandedNC1.r,rs=Pa(va.expandedNC1.l,Ta,za)[0],rs||=(as=va.expandedNC2.r,Pa(va.expandedNC2.l,Ta,za)[0])),rs){var ss=Ta.implicit;Ta=as.clone(),ss&&"implicit"in as&&(Ta.implicit=!0),Ta=Ta.transform(function(ms){return ms.isSymbolNode&&hasOwnProperty$1(rs.placeholders,ms.name)?rs.placeholders[ms.name].clone():ms})}return va.repeat&&Ta!==Da&&(Ta=$a(Ta,va,Ca)),Ta}function _a(Da,va){var Ca=[],ya,Na,za=ra(Da);if(Xi(Da,va))for(var Ta=0;Ta<Da.args.length;Ta++)Na=Da.args.slice(0),Na.splice(Ta,1),ya=Na.length===1?Na[0]:za(Na),Ca.push(za([Da.args[Ta],ya]));else for(var es=1;es<Da.args.length;es++){var ts=Da.args[0];es>1&&(ts=za(Da.args.slice(0,es))),Na=Da.args.slice(es),ya=Na.length===1?Na[0]:za(Na),Ca.push(za([ts,ya]))}return Ca}function fa(Da,va){var Ca={placeholders:{}};if(!Da.placeholders&&!va.placeholders)return Ca;if(!Da.placeholders)return va;if(!va.placeholders)return Da;for(var ya in Da.placeholders)if(hasOwnProperty$1(Da.placeholders,ya)&&(Ca.placeholders[ya]=Da.placeholders[ya],hasOwnProperty$1(va.placeholders,ya)&&!Ia(Da.placeholders[ya],va.placeholders[ya])))return null;for(var Na in va.placeholders)hasOwnProperty$1(va.placeholders,Na)&&(Ca.placeholders[Na]=va.placeholders[Na]);return Ca}function ka(Da,va){var Ca=[];if(Da.length===0||va.length===0)return Ca;for(var ya,Na=0;Na<Da.length;Na++)for(var za=0;za<va.length;za++)ya=fa(Da[Na],va[za]),ya&&Ca.push(ya);return Ca}function ba(Da){if(Da.length===0)return Da;for(var va=Da.reduce(ka),Ca=[],ya={},Na=0;Na<va.length;Na++){var za=JSON.stringify(va[Na],Gi);ya[za]||(ya[za]=!0,Ca.push(va[Na]))}return Ca}function Pa(Da,va,Ca,ya){var Na=[{placeholders:{}}];if(Da instanceof zi&&va instanceof zi||Da instanceof dn&&va instanceof dn){if(Da instanceof zi){if(Da.op!==va.op||Da.fn!==va.fn)return[]}else if(Da instanceof dn&&Da.name!==va.name)return[];if(va.args.length===1&&Da.args.length===1||!Ki(va,Ca)&&va.args.length===Da.args.length||ya){for(var za=[],Ta=0;Ta<Da.args.length;Ta++){var es=Pa(Da.args[Ta],va.args[Ta],Ca);if(es.length===0)break;za.push(es)}if(za.length!==Da.args.length){if(!Xi(va,Ca)||Da.args.length===1)return[];if(Da.args.length>2)throw Error("permuting >2 commutative non-associative rule arguments not yet implemented");var ts=Pa(Da.args[0],va.args[1],Ca);if(ts.length===0)return[];var Ka=Pa(Da.args[1],va.args[0],Ca);if(Ka.length===0)return[];za=[ts,Ka]}Na=ba(za)}else if(va.args.length>=2&&Da.args.length===2){for(var ps=_a(va,Ca),cs=[],xa=0;xa<ps.length;xa++){var Ra=Pa(Da,ps[xa],Ca,!0);cs=cs.concat(Ra)}return cs}else{if(Da.args.length>2)throw Error("Unexpected non-binary associative function: "+Da.toString());return[]}}else if(Da instanceof Qi){if(Da.name.length===0)throw Error("Symbol in rule has 0 length...!?");if(pa[Da.name]){if(Da.name!==va.name)return[]}else switch(Da.name[1]>="a"&&Da.name[1]<="z"?Da.name.substring(0,2):Da.name[0]){case"n":case"_p":Na[0].placeholders[Da.name]=va;break;case"c":case"cl":if(isConstantNode(va))Na[0].placeholders[Da.name]=va;else return[];break;case"v":if(!isConstantNode(va))Na[0].placeholders[Da.name]=va;else return[];break;case"vl":if(isSymbolNode(va))Na[0].placeholders[Da.name]=va;else return[];break;case"cd":if(isNumericNode(va))Na[0].placeholders[Da.name]=va;else return[];break;case"vd":if(!isNumericNode(va))Na[0].placeholders[Da.name]=va;else return[];break;case"ce":if(isConstantExpression(va))Na[0].placeholders[Da.name]=va;else return[];break;case"ve":if(!isConstantExpression(va))Na[0].placeholders[Da.name]=va;else return[];break;default:throw Error("Invalid symbol in rule: "+Da.name)}}else if(Da instanceof Pr){if(!J(Da.value,va.value))return[]}else return[];return Na}function Ia(Da,va){if(Da instanceof Pr&&va instanceof Pr){if(!J(Da.value,va.value))return!1}else if(Da instanceof Qi&&va instanceof Qi){if(Da.name!==va.name)return!1}else if(Da instanceof zi&&va instanceof zi||Da instanceof dn&&va instanceof dn){if(Da instanceof zi){if(Da.op!==va.op||Da.fn!==va.fn)return!1}else if(Da instanceof dn&&Da.name!==va.name)return!1;if(Da.args.length!==va.args.length)return!1;for(var Ca=0;Ca<Da.args.length;Ca++)if(!Ia(Da.args[Ca],va.args[Ca]))return!1}else return!1;return!0}return sa}),name$37="simplifyConstant",dependencies$37=["typed","config","mathWithTransform","matrix","isBounded","?fraction","?bignumber","AccessorNode","ArrayNode","ConstantNode","FunctionNode","IndexNode","ObjectNode","OperatorNode","SymbolNode"],createSimplifyConstant=factory(name$37,dependencies$37,D=>{var{typed:E,config:F,mathWithTransform:J,matrix:$e,isBounded:_t,fraction:lr,bignumber:mr,AccessorNode:Or,ArrayNode:Pr,ConstantNode:dn,FunctionNode:gi,IndexNode:qi,ObjectNode:zi,OperatorNode:Hi,SymbolNode:Qi}=D,{isCommutative:Gi,isAssociative:Zi,allChildren:Xi,createMakeNodeFunction:Ki}=createUtil({FunctionNode:gi,OperatorNode:Hi,SymbolNode:Qi}),ea=E("simplifyConstant",{Node:la=>ra(ma(la,{})),"Node, Object":function(la,ha){return ra(ma(la,ha))}});function Ji(la){return isFraction(la)?la.valueOf():la instanceof Array?la.map(Ji):isMatrix(la)?$e(Ji(la.valueOf())):la}function ta(la,ha,ga){try{return J[la].apply(null,ha)}catch{return ha=ha.map(Ji),oa(J[la].apply(null,ha),ga)}}var na=E({Fraction:sa,number:function(la){return la<0?ua(new dn(-la)):new dn(la)},BigNumber:function(la){return la<0?ua(new dn(-la)):new dn(la)},bigint:function(la){return la<0n?ua(new dn(-la)):new dn(la)},Complex:function(la){throw Error("Cannot convert Complex number to Node")},string:function(la){return new dn(la)},Matrix:function(la){return new Pr(la.valueOf().map(ha=>na(ha)))}});function ra(la){return isNode(la)?la:na(la)}function ia(la,ha){if(ha&&ha.exactFractions!==!1&&_t(la)&&lr){var ga=lr(la),Aa=ha&&typeof ha.fractionsLimit=="number"?ha.fractionsLimit:1/0;if(ga.valueOf()===la&&ga.n<Aa&&ga.d<Aa)return ga}return la}var oa=E({"string, Object":function(la,ha){var ga=safeNumberType(la,F);return ga==="BigNumber"?(mr===void 0&&noBignumber(),mr(la)):ga==="bigint"?BigInt(la):ga==="Fraction"?(lr===void 0&&noFraction(),lr(la)):ia(parseFloat(la),ha)},"Fraction, Object":function(la,ha){return la},"BigNumber, Object":function(la,ha){return la},"number, Object":function(la,ha){return ia(la,ha)},"bigint, Object":function(la,ha){return la},"Complex, Object":function(la,ha){return la.im===0?ia(la.re,ha):la},"Matrix, Object":function(la,ha){return $e(ia(la.valueOf()))},"Array, Object":function(la,ha){return la.map(ia)}});function ua(la){return new Hi("-","unaryMinus",[la])}function sa(la){var ha=Fa=>F.number==="BigNumber"&&mr?mr(Fa):Number(Fa),ga=la.s*la.n,Aa=ga<0n?new Hi("-","unaryMinus",[new dn(-ha(ga))]):new dn(ha(ga));return la.d===1n?Aa:new Hi("/","divide",[Aa,new dn(ha(la.d))])}function aa(la,ha,ga){if(!isIndexNode(ha))return new Or(ra(la),ra(ha));if(isArrayNode(la)||isMatrix(la)){for(var Aa=Array.from(ha.dimensions);Aa.length>0;)if(isConstantNode(Aa[0])&&typeof Aa[0].value!="string"){var Fa=oa(Aa.shift().value,ga);isArrayNode(la)?la=la.items[Fa-1]:(la=la.valueOf()[Fa-1],la instanceof Array&&(la=$e(la)))}else if(Aa.length>1&&isConstantNode(Aa[1])&&typeof Aa[1].value!="string"){var $a=oa(Aa[1].value,ga),_a=[],fa=isArrayNode(la)?la.items:la.valueOf();for(var ka of fa)if(isArrayNode(ka))_a.push(ka.items[$a-1]);else if(isMatrix(la))_a.push(ka[$a-1]);else break;if(_a.length===fa.length)la=isArrayNode(la)?new Pr(_a):$e(_a),Aa.splice(1,1);else break}else break;return Aa.length===ha.dimensions.length?new Or(ra(la),ha):Aa.length>0?(ha=new qi(Aa),new Or(ra(la),ha)):la}if(isObjectNode(la)&&ha.dimensions.length===1&&isConstantNode(ha.dimensions[0])){var ba=ha.dimensions[0].value;return ba in la.properties?la.properties[ba]:new dn}return new Or(ra(la),ha)}function pa(la,ha,ga,Aa){var Fa=ha.shift(),$a=ha.reduce((_a,fa)=>{if(!isNode(fa)){var ka=_a.pop();if(isNode(ka))return[ka,fa];try{return _a.push(ta(la,[ka,fa],Aa)),_a}catch{_a.push(ka)}}return _a.push(ra(_a.pop())),[ga([_a.length===1?_a[0]:ga(_a),ra(fa)])]},[Fa]);return $a.length===1?$a[0]:ga([$a[0],na($a[1])])}function ma(la,ha){switch(la.type){case"SymbolNode":return la;case"ConstantNode":switch(typeof la.value){case"number":return oa(la.value,ha);case"bigint":return oa(la.value,ha);case"string":return la.value;default:if(!isNaN(la.value))return oa(la.value,ha)}return la;case"FunctionNode":if(J[la.name]&&J[la.name].rawArgs)return la;if(!["add","multiply"].includes(la.name)){var ga=la.args.map(ya=>ma(ya,ha));if(!ga.some(isNode))try{return ta(la.name,ga,ha)}catch{}if(la.name==="size"&&ga.length===1&&isArrayNode(ga[0])){for(var Aa=[],Fa=ga[0];isArrayNode(Fa);)Aa.push(Fa.items.length),Fa=Fa.items[0];return $e(Aa)}return new gi(la.name,ga.map(ra))}case"OperatorNode":var $a=la.fn.toString(),_a,fa,ka=Ki(la);if(isOperatorNode(la)&&la.isUnary())_a=[ma(la.args[0],ha)],fa=isNode(_a[0])?ka(_a):ta($a,_a,ha);else if(Zi(la,ha.context))if(_a=Xi(la,ha.context),_a=_a.map(ya=>ma(ya,ha)),Gi($a,ha.context)){for(var ba=[],Pa=[],Ia=0;Ia<_a.length;Ia++)isNode(_a[Ia])?Pa.push(_a[Ia]):ba.push(_a[Ia]);ba.length>1?(fa=pa($a,ba,ka,ha),Pa.unshift(fa),fa=pa($a,Pa,ka,ha)):fa=pa($a,_a,ka,ha)}else fa=pa($a,_a,ka,ha);else _a=la.args.map(ya=>ma(ya,ha)),fa=pa($a,_a,ka,ha);return fa;case"ParenthesisNode":return ma(la.content,ha);case"AccessorNode":return aa(ma(la.object,ha),ma(la.index,ha),ha);case"ArrayNode":var Da=la.items.map(ya=>ma(ya,ha));return Da.some(isNode)?new Pr(Da.map(ra)):$e(Da);case"IndexNode":return new qi(la.dimensions.map(ya=>ea(ya,ha)));case"ObjectNode":var va={};for(var Ca in la.properties)va[Ca]=ea(la.properties[Ca],ha);return new zi(va);default:throw Error(`Unimplemented node type in simplifyConstant: ${la.type}`)}}return ea}),name$36="simplifyCore",dependencies$36=["typed","parse","equal","isZero","add","subtract","multiply","divide","pow","AccessorNode","ArrayNode","ConstantNode","FunctionNode","IndexNode","ObjectNode","OperatorNode","ParenthesisNode","SymbolNode"],createSimplifyCore=factory(name$36,dependencies$36,D=>{var{typed:E,parse:F,equal:J,isZero:$e,add:_t,subtract:lr,multiply:mr,divide:Or,pow:Pr,AccessorNode:dn,ArrayNode:gi,ConstantNode:qi,FunctionNode:zi,IndexNode:Hi,ObjectNode:Qi,OperatorNode:Gi,ParenthesisNode:Zi,SymbolNode:Xi}=D,Ki=new qi(0),ea=new qi(1),Ji=new qi(!0),ta=new qi(!1);function na(ua){return isOperatorNode(ua)&&["and","not","or"].includes(ua.op)}var{hasProperty:ra,isCommutative:ia}=createUtil({FunctionNode:zi,OperatorNode:Gi,SymbolNode:Xi});function oa(ua){var sa=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},aa=sa?sa.context:void 0;if(ra(ua,"trivial",aa)){if(isFunctionNode(ua)&&ua.args.length===1)return oa(ua.args[0],sa);var pa=!1,ma=0;if(ua.forEach(Pa=>{++ma,ma===1&&(pa=oa(Pa,sa))}),ma===1)return pa}var la=ua;if(isFunctionNode(la)){var ha=getOperator(la.name);if(ha){if(la.args.length>2&&ra(la,"associative",aa))for(;la.args.length>2;){var ga=la.args.pop(),Aa=la.args.pop();la.args.push(new Gi(ha,la.name,[ga,Aa]))}la=new Gi(ha,la.name,la.args)}else return new zi(oa(la.fn),la.args.map(Pa=>oa(Pa,sa)))}if(isOperatorNode(la)&&la.isUnary()){var Fa=oa(la.args[0],sa);if(la.op==="~"&&isOperatorNode(Fa)&&Fa.isUnary()&&Fa.op==="~"||la.op==="not"&&isOperatorNode(Fa)&&Fa.isUnary()&&Fa.op==="not"&&na(Fa.args[0]))return Fa.args[0];var $a=!0;if(la.op==="-"&&isOperatorNode(Fa)&&(Fa.isBinary()&&Fa.fn==="subtract"&&(la=new Gi("-","subtract",[Fa.args[1],Fa.args[0]]),$a=!1),Fa.isUnary()&&Fa.op==="-"))return Fa.args[0];if($a)return new Gi(la.op,la.fn,[Fa])}if(isOperatorNode(la)&&la.isBinary()){var _a=oa(la.args[0],sa),fa=oa(la.args[1],sa);if(la.op==="+"){if(isConstantNode(_a)&&$e(_a.value))return fa;if(isConstantNode(fa)&&$e(fa.value))return _a;isOperatorNode(fa)&&fa.isUnary()&&fa.op==="-"&&(fa=fa.args[0],la=new Gi("-","subtract",[_a,fa]))}if(la.op==="-")return isOperatorNode(fa)&&fa.isUnary()&&fa.op==="-"?oa(new Gi("+","add",[_a,fa.args[0]]),sa):isConstantNode(_a)&&$e(_a.value)?oa(new Gi("-","unaryMinus",[fa])):isConstantNode(fa)&&$e(fa.value)?_a:new Gi(la.op,la.fn,[_a,fa]);if(la.op==="*"){if(isConstantNode(_a)){if($e(_a.value))return Ki;if(J(_a.value,1))return fa}if(isConstantNode(fa)){if($e(fa.value))return Ki;if(J(fa.value,1))return _a;if(ia(la,aa))return new Gi(la.op,la.fn,[fa,_a],la.implicit)}return new Gi(la.op,la.fn,[_a,fa],la.implicit)}if(la.op==="/")return isConstantNode(_a)&&$e(_a.value)?Ki:isConstantNode(fa)&&J(fa.value,1)?_a:new Gi(la.op,la.fn,[_a,fa]);if(la.op==="^"&&isConstantNode(fa)){if($e(fa.value))return ea;if(J(fa.value,1))return _a}if(la.op==="and"){if(isConstantNode(_a))if(_a.value){if(na(fa))return fa;if(isConstantNode(fa))return fa.value?Ji:ta}else return ta;if(isConstantNode(fa))if(fa.value){if(na(_a))return _a}else return ta}if(la.op==="or"){if(isConstantNode(_a)){if(_a.value)return Ji;if(na(fa))return fa}if(isConstantNode(fa)){if(fa.value)return Ji;if(na(_a))return _a}}return new Gi(la.op,la.fn,[_a,fa])}if(isOperatorNode(la))return new Gi(la.op,la.fn,la.args.map(Pa=>oa(Pa,sa)));if(isArrayNode(la))return new gi(la.items.map(Pa=>oa(Pa,sa)));if(isAccessorNode(la))return new dn(oa(la.object,sa),oa(la.index,sa));if(isIndexNode(la))return new Hi(la.dimensions.map(Pa=>oa(Pa,sa)));if(isObjectNode(la)){var ka={};for(var ba in la.properties)ka[ba]=oa(la.properties[ba],sa);return new Qi(ka)}return la}return E(name$36,{Node:oa,"Node,Object":oa})}),name$35="resolve",dependencies$35=["typed","parse","ConstantNode","FunctionNode","OperatorNode","ParenthesisNode"],createResolve=factory(name$35,dependencies$35,D=>{var{typed:E,parse:F,ConstantNode:J,FunctionNode:$e,OperatorNode:_t,ParenthesisNode:lr}=D;function mr(Or,Pr){var dn=arguments.length>2&&arguments[2]!==void 0?arguments[2]:new Set;if(!Pr)return Or;if(isSymbolNode(Or)){if(dn.has(Or.name)){var gi=Array.from(dn).join(", ");throw ReferenceError(`recursive loop of variable definitions among {${gi}}`)}var qi=Pr.get(Or.name);if(isNode(qi)){var zi=new Set(dn);return zi.add(Or.name),mr(qi,Pr,zi)}else return typeof qi=="number"?F(String(qi)):qi!==void 0?new J(qi):Or}else if(isOperatorNode(Or)){var Hi=Or.args.map(function(Gi){return mr(Gi,Pr,dn)});return new _t(Or.op,Or.fn,Hi,Or.implicit)}else{if(isParenthesisNode(Or))return new lr(mr(Or.content,Pr,dn));if(isFunctionNode(Or)){var Qi=Or.args.map(function(Gi){return mr(Gi,Pr,dn)});return new $e(Or.name,Qi)}}return Or.map(Gi=>mr(Gi,Pr,dn))}return E("resolve",{Node:mr,"Node, Map | null | undefined":mr,"Node, Object":(Or,Pr)=>mr(Or,createMap$1(Pr)),"Array | Matrix":E.referToSelf(Or=>Pr=>Pr.map(dn=>Or(dn))),"Array | Matrix, null | undefined":E.referToSelf(Or=>Pr=>Pr.map(dn=>Or(dn))),"Array, Object":E.referTo("Array,Map",Or=>(Pr,dn)=>Or(Pr,createMap$1(dn))),"Matrix, Object":E.referTo("Matrix,Map",Or=>(Pr,dn)=>Or(Pr,createMap$1(dn))),"Array | Matrix, Map":E.referToSelf(Or=>(Pr,dn)=>Pr.map(gi=>Or(gi,dn)))})}),name$34="symbolicEqual",dependencies$34=["parse","simplify","typed","OperatorNode"],createSymbolicEqual=factory(name$34,dependencies$34,D=>{var{parse:E,simplify:F,typed:J,OperatorNode:$e}=D;function _t(lr,mr){var Or=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{},Pr=F(new $e("-","subtract",[lr,mr]),{},Or);return isConstantNode(Pr)&&!Pr.value}return J(name$34,{"Node, Node":_t,"Node, Node, Object":_t})}),name$33="derivative",dependencies$33=["typed","config","parse","simplify","equal","isZero","numeric","ConstantNode","FunctionNode","OperatorNode","ParenthesisNode","SymbolNode"],createDerivative=factory(name$33,dependencies$33,D=>{var{typed:E,config:F,parse:J,simplify:$e,equal:_t,isZero:lr,numeric:mr,ConstantNode:Or,FunctionNode:Pr,OperatorNode:dn,ParenthesisNode:gi,SymbolNode:qi}=D;function zi(ea,Ji){var ta=arguments.length>2&&arguments[2]!==void 0?arguments[2]:{simplify:!0},na=new Map,ra=Ji.name;function ia(ua){var sa=na.get(ua);if(sa!==void 0)return sa;var aa=Zi(ia,ua,ra);return na.set(ua,aa),aa}var oa=Xi(ea,ia);return ta.simplify?$e(oa):oa}function Hi(ea){var Ji=J(ea);if(!Ji.isSymbolNode)throw TypeError(`Invalid variable. Cannot parse ${JSON.stringify(ea)} into a variable in function derivative`);return Ji}var Qi=E(name$33,{"Node, SymbolNode":zi,"Node, SymbolNode, Object":zi,"Node, string":(ea,Ji)=>zi(ea,Hi(Ji)),"Node, string, Object":(ea,Ji,ta)=>zi(ea,Hi(Ji),ta)});Qi._simplify=!0,Qi.toTex=function(ea){return Gi.apply(null,ea.args)};var Gi=E("_derivTex",{"Node, SymbolNode":function(ea,Ji){return isConstantNode(ea)&&typeOf(ea.value)==="string"?Gi(J(ea.value).toString(),Ji.toString(),1):Gi(ea.toTex(),Ji.toString(),1)},"Node, ConstantNode":function(ea,Ji){if(typeOf(Ji.value)==="string")return Gi(ea,J(Ji.value));throw Error("The second parameter to \'derivative\' is a non-string constant")},"Node, SymbolNode, ConstantNode":function(ea,Ji,ta){return Gi(ea.toString(),Ji.name,ta.value)},"string, string, number":function(ea,Ji,ta){return(ta===1?"{d\\\\over d"+Ji+"}":"{d^{"+ta+"}\\\\over d"+Ji+"^{"+ta+"}}")+`\\\\left[${ea}\\\\right]`}}),Zi=E("_isConst",{"function, ConstantNode, string":function(){return!0},"function, SymbolNode, string":function(ea,Ji,ta){return Ji.name!==ta},"function, ParenthesisNode, string":function(ea,Ji,ta){return ea(Ji.content,ta)},"function, FunctionAssignmentNode, string":function(ea,Ji,ta){return Ji.params.includes(ta)?ea(Ji.expr,ta):!0},"function, FunctionNode | OperatorNode, string":function(ea,Ji,ta){return Ji.args.every(na=>ea(na,ta))}}),Xi=E("_derivative",{"ConstantNode, function":function(){return Ki(0)},"SymbolNode, function":function(ea,Ji){return Ji(ea)?Ki(0):Ki(1)},"ParenthesisNode, function":function(ea,Ji){return new gi(Xi(ea.content,Ji))},"FunctionAssignmentNode, function":function(ea,Ji){return Ji(ea)?Ki(0):Xi(ea.expr,Ji)},"FunctionNode, function":function(ea,Ji){if(Ji(ea))return Ki(0);var ta=ea.args[0],na,ra=!1,ia=!1,oa;switch(ea.name){case"cbrt":ra=!0,oa=new dn("*","multiply",[Ki(3),new dn("^","pow",[ta,new dn("/","divide",[Ki(2),Ki(3)])])]);break;case"sqrt":case"nthRoot":if(ea.args.length===1)ra=!0,oa=new dn("*","multiply",[Ki(2),new Pr("sqrt",[ta])]);else if(ea.args.length===2)return na=new dn("/","divide",[Ki(1),ea.args[1]]),Xi(new dn("^","pow",[ta,na]),Ji);break;case"log10":na=Ki(10);case"log":if(!na&&ea.args.length===1)oa=ta.clone(),ra=!0;else if(ea.args.length===1&&na||ea.args.length===2&&Ji(ea.args[1]))oa=new dn("*","multiply",[ta.clone(),new Pr("log",[na||ea.args[1]])]),ra=!0;else if(ea.args.length===2)return Xi(new dn("/","divide",[new Pr("log",[ta]),new Pr("log",[ea.args[1]])]),Ji);break;case"pow":if(ea.args.length===2)return Xi(new dn("^","pow",[ta,ea.args[1]]),Ji);break;case"exp":oa=new Pr("exp",[ta.clone()]);break;case"sin":oa=new Pr("cos",[ta.clone()]);break;case"cos":oa=new dn("-","unaryMinus",[new Pr("sin",[ta.clone()])]);break;case"tan":oa=new dn("^","pow",[new Pr("sec",[ta.clone()]),Ki(2)]);break;case"sec":oa=new dn("*","multiply",[ea,new Pr("tan",[ta.clone()])]);break;case"csc":ia=!0,oa=new dn("*","multiply",[ea,new Pr("cot",[ta.clone()])]);break;case"cot":ia=!0,oa=new dn("^","pow",[new Pr("csc",[ta.clone()]),Ki(2)]);break;case"asin":ra=!0,oa=new Pr("sqrt",[new dn("-","subtract",[Ki(1),new dn("^","pow",[ta.clone(),Ki(2)])])]);break;case"acos":ra=!0,ia=!0,oa=new Pr("sqrt",[new dn("-","subtract",[Ki(1),new dn("^","pow",[ta.clone(),Ki(2)])])]);break;case"atan":ra=!0,oa=new dn("+","add",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)]);break;case"asec":ra=!0,oa=new dn("*","multiply",[new Pr("abs",[ta.clone()]),new Pr("sqrt",[new dn("-","subtract",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)])])]);break;case"acsc":ra=!0,ia=!0,oa=new dn("*","multiply",[new Pr("abs",[ta.clone()]),new Pr("sqrt",[new dn("-","subtract",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)])])]);break;case"acot":ra=!0,ia=!0,oa=new dn("+","add",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)]);break;case"sinh":oa=new Pr("cosh",[ta.clone()]);break;case"cosh":oa=new Pr("sinh",[ta.clone()]);break;case"tanh":oa=new dn("^","pow",[new Pr("sech",[ta.clone()]),Ki(2)]);break;case"sech":ia=!0,oa=new dn("*","multiply",[ea,new Pr("tanh",[ta.clone()])]);break;case"csch":ia=!0,oa=new dn("*","multiply",[ea,new Pr("coth",[ta.clone()])]);break;case"coth":ia=!0,oa=new dn("^","pow",[new Pr("csch",[ta.clone()]),Ki(2)]);break;case"asinh":ra=!0,oa=new Pr("sqrt",[new dn("+","add",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)])]);break;case"acosh":ra=!0,oa=new Pr("sqrt",[new dn("-","subtract",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)])]);break;case"atanh":ra=!0,oa=new dn("-","subtract",[Ki(1),new dn("^","pow",[ta.clone(),Ki(2)])]);break;case"asech":ra=!0,ia=!0,oa=new dn("*","multiply",[ta.clone(),new Pr("sqrt",[new dn("-","subtract",[Ki(1),new dn("^","pow",[ta.clone(),Ki(2)])])])]);break;case"acsch":ra=!0,ia=!0,oa=new dn("*","multiply",[new Pr("abs",[ta.clone()]),new Pr("sqrt",[new dn("+","add",[new dn("^","pow",[ta.clone(),Ki(2)]),Ki(1)])])]);break;case"acoth":ra=!0,ia=!0,oa=new dn("-","subtract",[Ki(1),new dn("^","pow",[ta.clone(),Ki(2)])]);break;case"abs":oa=new dn("/","divide",[new Pr(new qi("abs"),[ta.clone()]),ta.clone()]);break;default:throw Error(\'Cannot process function "\'+ea.name+\'" in derivative: the function is not supported, undefined, or the number of arguments passed to it are not supported\')}var ua,sa;ra?(ua="/",sa="divide"):(ua="*",sa="multiply");var aa=Xi(ta,Ji);return ia&&(aa=new dn("-","unaryMinus",[aa])),new dn(ua,sa,[aa,oa])},"OperatorNode, function":function(ea,Ji){if(Ji(ea))return Ki(0);if(ea.op==="+")return new dn(ea.op,ea.fn,ea.args.map(function(pa){return Xi(pa,Ji)}));if(ea.op==="-"){if(ea.isUnary())return new dn(ea.op,ea.fn,[Xi(ea.args[0],Ji)]);if(ea.isBinary())return new dn(ea.op,ea.fn,[Xi(ea.args[0],Ji),Xi(ea.args[1],Ji)])}if(ea.op==="*"){var ta=ea.args.filter(function(pa){return Ji(pa)});if(ta.length>0){var na=ea.args.filter(function(pa){return!Ji(pa)}),ra=na.length===1?na[0]:new dn("*","multiply",na);return new dn("*","multiply",ta.concat(Xi(ra,Ji)))}return new dn("+","add",ea.args.map(function(pa){return new dn("*","multiply",ea.args.map(function(ma){return ma===pa?Xi(ma,Ji):ma.clone()}))}))}if(ea.op==="/"&&ea.isBinary()){var ia=ea.args[0],oa=ea.args[1];return Ji(oa)?new dn("/","divide",[Xi(ia,Ji),oa]):Ji(ia)?new dn("*","multiply",[new dn("-","unaryMinus",[ia]),new dn("/","divide",[Xi(oa,Ji),new dn("^","pow",[oa.clone(),Ki(2)])])]):new dn("/","divide",[new dn("-","subtract",[new dn("*","multiply",[Xi(ia,Ji),oa.clone()]),new dn("*","multiply",[ia.clone(),Xi(oa,Ji)])]),new dn("^","pow",[oa.clone(),Ki(2)])])}if(ea.op==="^"&&ea.isBinary()){var ua=ea.args[0],sa=ea.args[1];if(Ji(ua))return isConstantNode(ua)&&(lr(ua.value)||_t(ua.value,1))?Ki(0):new dn("*","multiply",[ea,new dn("*","multiply",[new Pr("log",[ua.clone()]),Xi(sa.clone(),Ji)])]);if(Ji(sa)){if(isConstantNode(sa)){if(lr(sa.value))return Ki(0);if(_t(sa.value,1))return Xi(ua,Ji)}var aa=new dn("^","pow",[ua.clone(),new dn("-","subtract",[sa,Ki(1)])]);return new dn("*","multiply",[sa.clone(),new dn("*","multiply",[Xi(ua,Ji),aa])])}return new dn("*","multiply",[new dn("^","pow",[ua.clone(),sa.clone()]),new dn("+","add",[new dn("*","multiply",[Xi(ua,Ji),new dn("/","divide",[sa.clone(),ua.clone()])]),new dn("*","multiply",[Xi(sa,Ji),new Pr("log",[ua.clone()])])])])}throw Error(\'Cannot process operator "\'+ea.op+\'" in derivative: the operator is not supported, undefined, or the number of arguments passed to it are not supported\')}});function Ki(ea,Ji){return new Or(mr(ea,safeNumberType(String(ea),F)))}return Qi}),name$32="rationalize",dependencies$32="config.typed.equal.isZero.add.subtract.multiply.divide.pow.parse.simplifyConstant.simplifyCore.simplify.?bignumber.?fraction.mathWithTransform.matrix.AccessorNode.ArrayNode.ConstantNode.FunctionNode.IndexNode.ObjectNode.OperatorNode.SymbolNode.ParenthesisNode".split("."),createRationalize=factory(name$32,dependencies$32,D=>{var{config:E,typed:F,equal:J,isZero:$e,add:_t,subtract:lr,multiply:mr,divide:Or,pow:Pr,parse:dn,simplifyConstant:gi,simplifyCore:qi,simplify:zi,fraction:Hi,bignumber:Qi,mathWithTransform:Gi,matrix:Zi,AccessorNode:Xi,ArrayNode:Ki,ConstantNode:ea,FunctionNode:Ji,IndexNode:ta,ObjectNode:na,OperatorNode:ra,SymbolNode:ia,ParenthesisNode:oa}=D;function ua(la){var ha=arguments.length>1&&arguments[1]!==void 0?arguments[1]:{},ga=arguments.length>2&&arguments[2]!==void 0?arguments[2]:!1,Aa=aa(),Fa=sa(la,ha,!0,Aa.firstRules),$a=Fa.variables.length,_a={exactFractions:!1},fa={exactFractions:!0};if(la=Fa.expression,$a>=1){la=pa(la);var ka,ba,Pa=!0,Ia=!1;la=zi(la,Aa.firstRules,{},_a);for(var Da;ba=Pa?Aa.distrDivRules:Aa.sucDivRules,la=zi(la,ba,{},fa),Pa=!Pa,Da=la.toString(),Da!==ka;)Ia=!0,ka=Da;Ia&&(la=zi(la,Aa.firstRulesAgain,{},_a)),la=zi(la,Aa.finalRules,{},_a)}var va=[],Ca={};return la.type==="OperatorNode"&&la.isBinary()&&la.op==="/"?($a===1&&(la.args[0]=ma(la.args[0],va),la.args[1]=ma(la.args[1])),ga&&(Ca.numerator=la.args[0],Ca.denominator=la.args[1])):($a===1&&(la=ma(la,va)),ga&&(Ca.numerator=la,Ca.denominator=null)),ga?(Ca.coefficients=va,Ca.variables=Fa.variables,Ca.expression=la,Ca):la}return F(name$32,{Node:ua,"Node, boolean":(la,ha)=>ua(la,{},ha),"Node, Object":ua,"Node, Object, boolean":ua});function sa(la,ha,ga,Aa){var Fa=[],$a=zi(la,Aa,ha,{exactFractions:!1});ga=!!ga;var _a="+-*"+(ga?"/":"");ka($a);var fa={};return fa.expression=$a,fa.variables=Fa,fa;function ka(ba){var Pa=ba.type;if(Pa==="FunctionNode")throw Error("There is an unsolved function call");if(Pa==="OperatorNode")if(ba.op==="^"){if(ba.args[1].type!=="ConstantNode"||!isInteger(parseFloat(ba.args[1].value)))throw Error("There is a non-integer exponent");ka(ba.args[0])}else{if(!_a.includes(ba.op))throw Error("Operator "+ba.op+" invalid in polynomial expression");for(var Ia=0;Ia<ba.args.length;Ia++)ka(ba.args[Ia])}else if(Pa==="SymbolNode"){var Da=ba.name;Fa.indexOf(Da)===-1&&Fa.push(Da)}else if(Pa==="ParenthesisNode")ka(ba.content);else if(Pa!=="ConstantNode")throw Error("type "+Pa+" is not allowed in polynomial expression")}}function aa(){var la=[qi,{l:"n+n",r:"2*n"},{l:"n+-n",r:"0"},gi,{l:"n*(n1^-1)",r:"n/n1"},{l:"n*n1^-n2",r:"n/n1^n2"},{l:"n1^-1",r:"1/n1"},{l:"n*(n1/n2)",r:"(n*n1)/n2"},{l:"1*n",r:"n"}],ha=[{l:"(-n1)/(-n2)",r:"n1/n2"},{l:"(-n1)*(-n2)",r:"n1*n2"},{l:"n1--n2",r:"n1+n2"},{l:"n1-n2",r:"n1+(-n2)"},{l:"(n1+n2)*n3",r:"(n1*n3 + n2*n3)"},{l:"n1*(n2+n3)",r:"(n1*n2+n1*n3)"},{l:"c1*n + c2*n",r:"(c1+c2)*n"},{l:"c1*n + n",r:"(c1+1)*n"},{l:"c1*n - c2*n",r:"(c1-c2)*n"},{l:"c1*n - n",r:"(c1-1)*n"},{l:"v/c",r:"(1/c)*v"},{l:"v/-c",r:"-(1/c)*v"},{l:"-v*-c",r:"c*v"},{l:"-v*c",r:"-c*v"},{l:"v*-c",r:"-c*v"},{l:"v*c",r:"c*v"},{l:"-(-n1*n2)",r:"(n1*n2)"},{l:"-(n1*n2)",r:"(-n1*n2)"},{l:"-(-n1+n2)",r:"(n1-n2)"},{l:"-(n1+n2)",r:"(-n1-n2)"},{l:"(n1^n2)^n3",r:"(n1^(n2*n3))"},{l:"-(-n1/n2)",r:"(n1/n2)"},{l:"-(n1/n2)",r:"(-n1/n2)"}],ga=[{l:"(n1/n2 + n3/n4)",r:"((n1*n4 + n3*n2)/(n2*n4))"},{l:"(n1/n2 + n3)",r:"((n1 + n3*n2)/n2)"},{l:"(n1 + n2/n3)",r:"((n1*n3 + n2)/n3)"}],Aa=[{l:"(n1/(n2/n3))",r:"((n1*n3)/n2)"},{l:"(n1/n2/n3)",r:"(n1/(n2*n3))"}],Fa={};return Fa.firstRules=la.concat(ha,Aa),Fa.distrDivRules=ga,Fa.sucDivRules=Aa,Fa.firstRulesAgain=la.concat(ha),Fa.finalRules=[qi,{l:"n*-n",r:"-n^2"},{l:"n*n",r:"n^2"},gi,{l:"n*-n^n1",r:"-n^(n1+1)"},{l:"n*n^n1",r:"n^(n1+1)"},{l:"n^n1*-n^n2",r:"-n^(n1+n2)"},{l:"n^n1*n^n2",r:"n^(n1+n2)"},{l:"n^n1*-n",r:"-n^(n1+1)"},{l:"n^n1*n",r:"n^(n1+1)"},{l:"n^n1/-n",r:"-n^(n1-1)"},{l:"n^n1/n",r:"n^(n1-1)"},{l:"n/-n^n1",r:"-n^(1-n1)"},{l:"n/n^n1",r:"n^(1-n1)"},{l:"n^n1/-n^n2",r:"n^(n1-n2)"},{l:"n^n1/n^n2",r:"n^(n1-n2)"},{l:"n1+(-n2*n3)",r:"n1-n2*n3"},{l:"v*(-c)",r:"-c*v"},{l:"n1+-n2",r:"n1-n2"},{l:"v*c",r:"c*v"},{l:"(n1^n2)^n3",r:"(n1^(n2*n3))"}],Fa}function pa(la,ha,ga){var Aa=la.type,Fa=arguments.length>1;if(Aa==="OperatorNode"&&la.isBinary()){var $a=!1,_a;if(la.op==="^"&&(la.args[0].type==="ParenthesisNode"||la.args[0].type==="OperatorNode")&&la.args[1].type==="ConstantNode"&&(_a=parseFloat(la.args[1].value),$a=_a>=2&&isInteger(_a)),$a){if(_a>2){var fa=la.args[0];la=new ra("*","multiply",[fa,new ra("^","pow",[la.args[0].cloneDeep(),new ea(_a-1)])])}else la=new ra("*","multiply",[la.args[0],la.args[0].cloneDeep()]);Fa&&(ga==="content"?ha.content=la:ha.args[ga]=la)}}if(Aa==="ParenthesisNode")pa(la.content,la,"content");else if(Aa!=="ConstantNode"&&Aa!=="SymbolNode")for(var ka=0;ka<la.args.length;ka++)pa(la.args[ka],la,ka);if(!Fa)return la}function ma(la,ha){ha===void 0&&(ha=[]),ha[0]=0;var ga={};ga.cte=1,ga.oper="+",ga.fire="";var Aa=0,Fa="";Da(la,null,ga),Aa=ha.length-1;for(var $a=!0,_a,fa=Aa;fa>=0;fa--)if(ha[fa]!==0){var ka=new ea($a?ha[fa]:Math.abs(ha[fa])),ba=ha[fa]<0?"-":"+";if(fa>0){var Pa=new ia(Fa);if(fa>1){var Ia=new ea(fa);Pa=new ra("^","pow",[Pa,Ia])}ka=ha[fa]===-1&&$a?new ra("-","unaryMinus",[Pa]):Math.abs(ha[fa])===1?Pa:new ra("*","multiply",[ka,Pa])}_a=$a?ka:ba==="+"?new ra("+","add",[_a,ka]):new ra("-","subtract",[_a,ka]),$a=!1}if($a)return new ea(0);return _a;function Da(va,Ca,ya){var Na=va.type;if(Na==="FunctionNode")throw Error("There is an unsolved function call");if(Na==="OperatorNode"){if(!"+-*^".includes(va.op))throw Error("Operator "+va.op+" invalid");if(Ca!==null&&((va.fn==="unaryMinus"||va.fn==="pow")&&Ca.fn!=="add"&&Ca.fn!=="subtract"&&Ca.fn!=="multiply"||(va.fn==="subtract"||va.fn==="add"||va.fn==="multiply")&&Ca.fn!=="add"&&Ca.fn!=="subtract"||(va.fn==="subtract"||va.fn==="add"||va.fn==="unaryMinus")&&ya.noFil!==0))throw Error("Invalid "+va.op+" placing");(va.op==="^"||va.op==="*")&&(ya.fire=va.op);for(var za=0;za<va.args.length;za++)va.fn==="unaryMinus"&&(ya.oper="-"),(va.op==="+"||va.fn==="subtract")&&(ya.fire="",ya.cte=1,ya.oper=za===0?"+":va.op),ya.noFil=za,Da(va.args[za],va,ya)}else if(Na==="SymbolNode"){if(va.name!==Fa&&Fa!=="")throw Error("There is more than one variable");if(Fa=va.name,Ca===null){ha[1]=1;return}if(Ca.op==="^"&&ya.noFil!==0)throw Error("In power the variable should be the first parameter");if(Ca.op==="*"&&ya.noFil!==1)throw Error("In multiply the variable should be the second parameter");(ya.fire===""||ya.fire==="*")&&(Aa<1&&(ha[1]=0),ha[1]+=ya.cte*(ya.oper==="+"?1:-1),Aa=Math.max(1,Aa))}else if(Na==="ConstantNode"){var Ta=parseFloat(va.value);if(Ca===null){ha[0]=Ta;return}if(Ca.op==="^"){if(ya.noFil!==1)throw Error("Constant cannot be powered");if(!isInteger(Ta)||Ta<=0)throw Error("Non-integer exponent is not allowed");for(var es=Aa+1;es<Ta;es++)ha[es]=0;Ta>Aa&&(ha[Ta]=0),ha[Ta]+=ya.cte*(ya.oper==="+"?1:-1),Aa=Math.max(Ta,Aa);return}ya.cte=Ta,ya.fire===""&&(ha[0]+=ya.cte*(ya.oper==="+"?1:-1))}else throw Error("Type "+Na+" is not allowed")}}}),name$31="zpk2tf",dependencies$31=["typed","add","multiply","Complex","number"],createZpk2tf=factory(name$31,dependencies$31,D=>{var{typed:E,add:F,multiply:J,Complex:$e,number:_t}=D;return E(name$31,{"Array,Array,number":function(Or,Pr,dn){return lr(Or,Pr,dn)},"Array,Array":function(Or,Pr){return lr(Or,Pr,1)},"Matrix,Matrix,number":function(Or,Pr,dn){return lr(Or.valueOf(),Pr.valueOf(),dn)},"Matrix,Matrix":function(Or,Pr){return lr(Or.valueOf(),Pr.valueOf(),1)}});function lr(Or,Pr,dn){Or.some(Xi=>Xi.type==="BigNumber")&&(Or=Or.map(Xi=>_t(Xi))),Pr.some(Xi=>Xi.type==="BigNumber")&&(Pr=Pr.map(Xi=>_t(Xi)));for(var gi=[$e(1,0)],qi=[$e(1,0)],zi=0;zi<Or.length;zi++){var Hi=Or[zi];typeof Hi=="number"&&(Hi=$e(Hi,0)),gi=mr(gi,[$e(1,0),$e(-Hi.re,-Hi.im)])}for(var Qi=0;Qi<Pr.length;Qi++){var Gi=Pr[Qi];typeof Gi=="number"&&(Gi=$e(Gi,0)),qi=mr(qi,[$e(1,0),$e(-Gi.re,-Gi.im)])}for(var Zi=0;Zi<gi.length;Zi++)gi[Zi]=J(gi[Zi],dn);return[gi,qi]}function mr(Or,Pr){for(var dn=[],gi=0;gi<Or.length+Pr.length-1;gi++){dn[gi]=$e(0,0);for(var qi=0;qi<Or.length;qi++)gi-qi>=0&&gi-qi<Pr.length&&(dn[gi]=F(dn[gi],J(Or[qi],Pr[gi-qi])))}return dn}}),name$30="freqz",dependencies$30=["typed","add","multiply","Complex","divide","matrix"],createFreqz=factory(name$30,dependencies$30,D=>{var{typed:E,add:F,multiply:J,Complex:$e,divide:_t,matrix:lr}=D;return E(name$30,{"Array, Array":function(Pr,dn){return mr(Pr,dn,Or(512))},"Array, Array, Array":function(Pr,dn,gi){return mr(Pr,dn,gi)},"Array, Array, number":function(Pr,dn,gi){if(gi<0)throw Error("w must be a positive number");return mr(Pr,dn,Or(gi))},"Matrix, Matrix":function(Pr,dn){var gi=Or(512),{w:qi,h:zi}=mr(Pr.valueOf(),dn.valueOf(),gi);return{w:lr(qi),h:lr(zi)}},"Matrix, Matrix, Matrix":function(Pr,dn,gi){var{h:qi}=mr(Pr.valueOf(),dn.valueOf(),gi.valueOf());return{h:lr(qi),w:lr(gi)}},"Matrix, Matrix, number":function(Pr,dn,gi){if(gi<0)throw Error("w must be a positive number");var qi=Or(gi),{h:zi}=mr(Pr.valueOf(),dn.valueOf(),qi);return{h:lr(zi),w:lr(qi)}}});function mr(Pr,dn,gi){for(var qi=[],zi=[],Hi=0;Hi<gi.length;Hi++){for(var Qi=$e(0,0),Gi=$e(0,0),Zi=0;Zi<Pr.length;Zi++)Qi=F(Qi,J(Pr[Zi],$e(Math.cos(-Zi*gi[Hi]),Math.sin(-Zi*gi[Hi]))));for(var Xi=0;Xi<dn.length;Xi++)Gi=F(Gi,J(dn[Xi],$e(Math.cos(-Xi*gi[Hi]),Math.sin(-Xi*gi[Hi]))));qi.push(Qi),zi.push(Gi)}for(var Ki=[],ea=0;ea<qi.length;ea++)Ki.push(_t(qi[ea],zi[ea]));return{h:Ki,w:gi}}function Or(Pr){for(var dn=[],gi=0;gi<Pr;gi++)dn.push(gi/Pr*Math.PI);return dn}}),name$29="reviver",dependencies$29=["classes"],createReviver=factory(name$29,dependencies$29,D=>{var{classes:E}=D;return function(F,J){var $e=E[J&&J.mathjs];return $e&&typeof $e.fromJSON=="function"?$e.fromJSON(J):J}}),name$28="replacer",dependencies$28=[],createReplacer=factory(name$28,dependencies$28,()=>function(D,E){return typeof E=="number"&&(!Number.isFinite(E)||isNaN(E))?{mathjs:"number",value:String(E)}:typeof E=="bigint"?{mathjs:"bigint",value:String(E)}:E}),version="15.2.0",createTrue=factory("true",[],()=>!0),createFalse=factory("false",[],()=>!1),createNull=factory("null",[],()=>null),createInfinity=recreateFactory("Infinity",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(1/0):1/0}),createNaN=recreateFactory("NaN",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(NaN):NaN}),createPi=recreateFactory("pi",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?createBigNumberPi(F):pi}),createTau=recreateFactory("tau",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?createBigNumberTau(F):tau}),createE=recreateFactory("e",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?createBigNumberE(F):e}),createPhi=recreateFactory("phi",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?createBigNumberPhi(F):phi}),createLN2=recreateFactory("LN2",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(2).ln():Math.LN2}),createLN10=recreateFactory("LN10",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(10).ln():Math.LN10}),createLOG2E=recreateFactory("LOG2E",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(1).div(new F(2).ln()):Math.LOG2E}),createLOG10E=recreateFactory("LOG10E",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(1).div(new F(10).ln()):Math.LOG10E}),createSQRT1_2=recreateFactory("SQRT1_2",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F("0.5").sqrt():Math.SQRT1_2}),createSQRT2=recreateFactory("SQRT2",["config","?BigNumber"],D=>{var{config:E,BigNumber:F}=D;return E.number==="BigNumber"?new F(2).sqrt():Math.SQRT2}),createI=recreateFactory("i",["Complex"],D=>{var{Complex:E}=D;return E.I}),createUppercasePi=factory("PI",["pi"],D=>{var{pi:E}=D;return E}),createUppercaseE=factory("E",["e"],D=>{var{e:E}=D;return E}),createVersion=factory("version",[],()=>version);function recreateFactory(D,E,F){return factory(D,E,F,{recreateOnConfigChange:!0})}var createSpeedOfLight=unitFactory("speedOfLight","299792458","m s^-1"),createGravitationConstant=unitFactory("gravitationConstant","6.67430e-11","m^3 kg^-1 s^-2"),createPlanckConstant=unitFactory("planckConstant","6.62607015e-34","J s"),createReducedPlanckConstant=unitFactory("reducedPlanckConstant","1.0545718176461565e-34","J s"),createMagneticConstant=unitFactory("magneticConstant","1.25663706212e-6","N A^-2"),createElectricConstant=unitFactory("electricConstant","8.8541878128e-12","F m^-1"),createVacuumImpedance=unitFactory("vacuumImpedance","376.730313667","ohm"),createCoulomb=unitFactory("coulomb","8.987551792261171e9","N m^2 C^-2"),createCoulombConstant=unitFactory("coulombConstant","8.987551792261171e9","N m^2 C^-2"),createElementaryCharge=unitFactory("elementaryCharge","1.602176634e-19","C"),createBohrMagneton=unitFactory("bohrMagneton","9.2740100783e-24","J T^-1"),createConductanceQuantum=unitFactory("conductanceQuantum","7.748091729863649e-5","S"),createInverseConductanceQuantum=unitFactory("inverseConductanceQuantum","12906.403729652257","ohm"),createMagneticFluxQuantum=unitFactory("magneticFluxQuantum","2.0678338484619295e-15","Wb"),createNuclearMagneton=unitFactory("nuclearMagneton","5.0507837461e-27","J T^-1"),createKlitzing=unitFactory("klitzing","25812.807459304513","ohm"),createBohrRadius=unitFactory("bohrRadius","5.29177210903e-11","m"),createClassicalElectronRadius=unitFactory("classicalElectronRadius","2.8179403262e-15","m"),createElectronMass=unitFactory("electronMass","9.1093837015e-31","kg"),createFermiCoupling=unitFactory("fermiCoupling","1.1663787e-5","GeV^-2"),createFineStructure=numberFactory("fineStructure",.0072973525693),createHartreeEnergy=unitFactory("hartreeEnergy","4.3597447222071e-18","J"),createProtonMass=unitFactory("protonMass","1.67262192369e-27","kg"),createDeuteronMass=unitFactory("deuteronMass","3.3435830926e-27","kg"),createNeutronMass=unitFactory("neutronMass","1.6749271613e-27","kg"),createQuantumOfCirculation=unitFactory("quantumOfCirculation","3.6369475516e-4","m^2 s^-1"),createRydberg=unitFactory("rydberg","10973731.568160","m^-1"),createThomsonCrossSection=unitFactory("thomsonCrossSection","6.6524587321e-29","m^2"),createWeakMixingAngle=numberFactory("weakMixingAngle",.2229),createEfimovFactor=numberFactory("efimovFactor",22.7),createAtomicMass=unitFactory("atomicMass","1.66053906660e-27","kg"),createAvogadro=unitFactory("avogadro","6.02214076e23","mol^-1"),createBoltzmann=unitFactory("boltzmann","1.380649e-23","J K^-1"),createFaraday=unitFactory("faraday","96485.33212331001","C mol^-1"),createFirstRadiation=unitFactory("firstRadiation","3.7417718521927573e-16","W m^2"),createLoschmidt=unitFactory("loschmidt","2.686780111798444e25","m^-3"),createGasConstant=unitFactory("gasConstant","8.31446261815324","J K^-1 mol^-1"),createMolarPlanckConstant=unitFactory("molarPlanckConstant","3.990312712893431e-10","J s mol^-1"),createMolarVolume=unitFactory("molarVolume","0.022413969545014137","m^3 mol^-1"),createSackurTetrode=numberFactory("sackurTetrode",-1.16487052358),createSecondRadiation=unitFactory("secondRadiation","0.014387768775039337","m K"),createStefanBoltzmann=unitFactory("stefanBoltzmann","5.67037441918443e-8","W m^-2 K^-4"),createWienDisplacement=unitFactory("wienDisplacement","2.897771955e-3","m K"),createMolarMass=unitFactory("molarMass","0.99999999965e-3","kg mol^-1"),createMolarMassC12=unitFactory("molarMassC12","11.9999999958e-3","kg mol^-1"),createGravity=unitFactory("gravity","9.80665","m s^-2"),createPlanckLength=unitFactory("planckLength","1.616255e-35","m"),createPlanckMass=unitFactory("planckMass","2.176435e-8","kg"),createPlanckTime=unitFactory("planckTime","5.391245e-44","s"),createPlanckCharge=unitFactory("planckCharge","1.87554603778e-18","C"),createPlanckTemperature=unitFactory("planckTemperature","1.416785e+32","K");function unitFactory(D,E,F){return factory(D,["config","Unit","BigNumber"],J=>{var{config:$e,Unit:_t,BigNumber:lr}=J,mr=new _t($e.number==="BigNumber"?new lr(E):parseFloat(E),F);return mr.fixPrefix=!0,mr})}function numberFactory(D,E){return factory(D,["config","BigNumber"],F=>{var{config:J,BigNumber:$e}=F;return J.number==="BigNumber"?new $e(E):E})}function ownKeys(D,E){var F=Object.keys(D);if(Object.getOwnPropertySymbols){var J=Object.getOwnPropertySymbols(D);E&&(J=J.filter(function($e){return Object.getOwnPropertyDescriptor(D,$e).enumerable})),F.push.apply(F,J)}return F}function _objectSpread(D){for(var E=1;E<arguments.length;E++){var F=arguments[E]==null?{}:arguments[E];E%2?ownKeys(Object(F),!0).forEach(function(J){_defineProperty(D,J,F[J])}):Object.getOwnPropertyDescriptors?Object.defineProperties(D,Object.getOwnPropertyDescriptors(F)):ownKeys(Object(F)).forEach(function(J){Object.defineProperty(D,J,Object.getOwnPropertyDescriptor(F,J))})}return D}var name$27="mapSlices",dependencies$27=["typed","isInteger"],createMapSlicesTransform=factory(name$27,dependencies$27,D=>{var{typed:E,isInteger:F}=D,J=createMapSlices({typed:E,isInteger:F});return E("mapSlices",{"...any":function($e){var _t=$e[1];isNumber(_t)?$e[1]=_t-1:isBigNumber(_t)&&($e[1]=_t.minus(1));try{return J.apply(null,$e)}catch(lr){throw errorTransform(lr)}}})},_objectSpread({isTransformFunction:!0},createMapSlices.meta)),name$26="column",dependencies$26=["typed","Index","matrix","range"],createColumnTransform=factory(name$26,dependencies$26,D=>{var{typed:E,Index:F,matrix:J,range:$e}=D,_t=createColumn({typed:E,Index:F,matrix:J,range:$e});return E("column",{"...any":function(lr){var mr=lr.length-1,Or=lr[mr];isNumber(Or)&&(lr[mr]=Or-1);try{return _t.apply(null,lr)}catch(Pr){throw errorTransform(Pr)}}})},{isTransformFunction:!0});function compileInlineExpression(D,E,F){var J=D.filter(function(Or){return isSymbolNode(Or)&&!(Or.name in E)&&!F.has(Or.name)})[0];if(!J)throw Error(\'No undefined variable found in inline expression "\'+D+\'"\');var $e=J.name,_t=new Map,lr=new PartitionedMap(F,_t,new Set([$e])),mr=D.compile();return function(Or){return _t.set($e,Or),mr.evaluate(lr)}}var name$25="transformCallback",dependencies$25=["typed"],createTransformCallback=factory(name$25,dependencies$25,D=>{var{typed:E}=D;return function(J,$e){return E.isTypedFunction(J)?F(J,$e):_transformCallbackFunction(J,J.length,$e)};function F(J,$e){var _t=Object.fromEntries(Object.entries(J.signatures).map(lr=>{var[mr,Or]=lr,Pr=mr.split(",").length;return E.isTypedFunction(Or)?[mr,F(Or,$e)]:[mr,_transformCallbackFunction(Or,Pr,$e)]}));return typeof J.name=="string"?E(J.name,_t):E(_t)}});function _transformCallbackFunction(D,E,F){return E===F?D:E===F+1?function(){var J=[...arguments],$e=J.slice(0,F),_t=_transformDims(J[F]);return D(...$e,_t)}:E>F+1?function(){var J=[...arguments],$e=J.slice(0,F),_t=_transformDims(J[F]),lr=J.slice(F+1);return D(...$e,_t,...lr)}:D}function _transformDims(D){return D.map(E=>E+1)}var name$24="filter",dependencies$24=["typed"],createFilterTransform=factory(name$24,dependencies$24,D=>{var{typed:E}=D;function F($e,_t,lr){var mr=createFilter({typed:E}),Or=createTransformCallback({typed:E});if($e.length===0)return mr();var Pr=$e[0];if($e.length===1)return mr(Pr);var dn=$e.length-1,gi=$e[dn];return Pr&&=J(Pr,lr),gi&&=isSymbolNode(gi)||isFunctionAssignmentNode(gi)?J(gi,lr):compileInlineExpression(gi,_t,lr),mr(Pr,Or(gi,dn))}F.rawArgs=!0;function J($e,_t){return $e.compile().evaluate(_t)}return F},{isTransformFunction:!0}),name$23="forEach",dependencies$23=["typed"],createForEachTransform=factory(name$23,dependencies$23,D=>{var{typed:E}=D,F=createForEach({typed:E}),J=createTransformCallback({typed:E});function $e(lr,mr,Or){if(lr.length===0)return F();var Pr=lr[0];if(lr.length===1)return F(Pr);var dn=lr.length-1,gi=lr[dn];return Pr&&=_t(Pr,Or),gi&&=isSymbolNode(gi)||isFunctionAssignmentNode(gi)?_t(gi,Or):compileInlineExpression(gi,mr,Or),F(Pr,J(gi,dn))}$e.rawArgs=!0;function _t(lr,mr){return lr.compile().evaluate(mr)}return $e},{isTransformFunction:!0}),name$22="index",dependencies$22=["Index","getMatrixDataType"],createIndexTransform=factory(name$22,dependencies$22,D=>{var{Index:E,getMatrixDataType:F}=D;return function(){for(var J=[],$e=0,_t=arguments.length;$e<_t;$e++){var lr=arguments[$e];if(isRange(lr))lr.start--,lr.end-=lr.step>0?0:2;else if(lr&&lr.isSet===!0)lr=lr.map(function(Or){return Or-1});else if(isArray(lr)||isMatrix(lr))F(lr)!=="boolean"&&(lr=lr.map(function(Or){return Or-1}));else if(isNumber(lr)||isBigInt(lr))lr--;else if(isBigNumber(lr))lr=lr.toNumber()-1;else if(typeof lr!="string")throw TypeError("Dimension must be an Array, Matrix, number, bigint, string, or Range");J[$e]=lr}var mr=new E;return E.apply(mr,J),mr}},{isTransformFunction:!0}),name$21="map",dependencies$21=["typed"],createMapTransform=factory(name$21,dependencies$21,D=>{var{typed:E}=D,F=createMap({typed:E}),J=createTransformCallback({typed:E});function $e(_t,lr,mr){if(_t.length===0)return F();if(_t.length===1)return F(_t[0]);var Or=_t.length-1,Pr=_t.slice(0,Or),dn=_t[Or];return Pr=Pr.map(qi=>gi(qi,mr)),dn&&=isSymbolNode(dn)||isFunctionAssignmentNode(dn)?gi(dn,mr):compileInlineExpression(dn,lr,mr),F(...Pr,J(dn,Or));function gi(qi,zi){return qi.compile().evaluate(zi)}}return $e.rawArgs=!0,$e},{isTransformFunction:!0});function dimToZeroBase(D){return isNumber(D)?D-1:isBigNumber(D)?D.minus(1):D}function isNumberOrBigNumber(D){return isNumber(D)||isBigNumber(D)}function lastDimToZeroBase(D){if(D.length===2&&isCollection(D[0])){D=D.slice();var E=D[1];isNumberOrBigNumber(E)&&(D[1]=dimToZeroBase(E))}return D}var name$20="max",dependencies$20=["typed","config","numeric","larger","isNaN"],createMaxTransform=factory(name$20,dependencies$20,D=>{var{typed:E,config:F,numeric:J,larger:$e,isNaN:_t}=D,lr=createMax({typed:E,config:F,numeric:J,larger:$e,isNaN:_t});return E("max",{"...any":function(mr){mr=lastDimToZeroBase(mr);try{return lr.apply(null,mr)}catch(Or){throw errorTransform(Or)}}})},{isTransformFunction:!0}),name$19="mean",dependencies$19=["typed","add","divide"],createMeanTransform=factory(name$19,dependencies$19,D=>{var{typed:E,add:F,divide:J}=D,$e=createMean({typed:E,add:F,divide:J});return E("mean",{"...any":function(_t){_t=lastDimToZeroBase(_t);try{return $e.apply(null,_t)}catch(lr){throw errorTransform(lr)}}})},{isTransformFunction:!0}),name$18="min",dependencies$18=["typed","config","numeric","smaller","isNaN"],createMinTransform=factory(name$18,dependencies$18,D=>{var{typed:E,config:F,numeric:J,smaller:$e,isNaN:_t}=D,lr=createMin({typed:E,config:F,numeric:J,smaller:$e,isNaN:_t});return E("min",{"...any":function(mr){mr=lastDimToZeroBase(mr);try{return lr.apply(null,mr)}catch(Or){throw errorTransform(Or)}}})},{isTransformFunction:!0}),name$17="range",dependencies$17=["typed","config","?matrix","?bignumber","equal","smaller","smallerEq","larger","largerEq","add","isZero","isPositive"],createRangeTransform=factory(name$17,dependencies$17,D=>{var{typed:E,config:F,matrix:J,bignumber:$e,equal:_t,smaller:lr,smallerEq:mr,larger:Or,largerEq:Pr,add:dn,isZero:gi,isPositive:qi}=D,zi=createRange({typed:E,config:F,matrix:J,bignumber:$e,equal:_t,smaller:lr,smallerEq:mr,larger:Or,largerEq:Pr,add:dn,isZero:gi,isPositive:qi});return E("range",{"...any":function(Hi){return typeof Hi[Hi.length-1]!="boolean"&&Hi.push(!0),zi.apply(null,Hi)}})},{isTransformFunction:!0}),name$16="row",dependencies$16=["typed","Index","matrix","range"],createRowTransform=factory(name$16,dependencies$16,D=>{var{typed:E,Index:F,matrix:J,range:$e}=D,_t=createRow({typed:E,Index:F,matrix:J,range:$e});return E("row",{"...any":function(lr){var mr=lr.length-1,Or=lr[mr];isNumber(Or)&&(lr[mr]=Or-1);try{return _t.apply(null,lr)}catch(Pr){throw errorTransform(Pr)}}})},{isTransformFunction:!0}),name$15="subset",dependencies$15=["typed","matrix","zeros","add"],createSubsetTransform=factory(name$15,dependencies$15,D=>{var{typed:E,matrix:F,zeros:J,add:$e}=D,_t=createSubset({typed:E,matrix:F,zeros:J,add:$e});return E("subset",{"...any":function(lr){try{return _t.apply(null,lr)}catch(mr){throw errorTransform(mr)}}})},{isTransformFunction:!0}),name$14="concat",dependencies$14=["typed","matrix","isInteger"],createConcatTransform=factory(name$14,dependencies$14,D=>{var{typed:E,matrix:F,isInteger:J}=D,$e=createConcat({typed:E,matrix:F,isInteger:J});return E("concat",{"...any":function(_t){var lr=_t.length-1,mr=_t[lr];isNumber(mr)?_t[lr]=mr-1:isBigNumber(mr)&&(_t[lr]=mr.minus(1));try{return $e.apply(null,_t)}catch(Or){throw errorTransform(Or)}}})},{isTransformFunction:!0}),name$13="diff",dependencies$13=["typed","matrix","subtract","number","bignumber"],createDiffTransform=factory(name$13,dependencies$13,D=>{var{typed:E,matrix:F,subtract:J,number:$e,bignumber:_t}=D,lr=createDiff({typed:E,matrix:F,subtract:J,number:$e,bignumber:_t});return E(name$13,{"...any":function(mr){mr=lastDimToZeroBase(mr);try{return lr.apply(null,mr)}catch(Or){throw errorTransform(Or)}}})},{isTransformFunction:!0}),name$12="std",dependencies$12=["typed","map","sqrt","variance"],createStdTransform=factory(name$12,dependencies$12,D=>{var{typed:E,map:F,sqrt:J,variance:$e}=D,_t=createStd({typed:E,map:F,sqrt:J,variance:$e});return E("std",{"...any":function(lr){lr=lastDimToZeroBase(lr);try{return _t.apply(null,lr)}catch(mr){throw errorTransform(mr)}}})},{isTransformFunction:!0}),name$11="sum",dependencies$11=["typed","config","add","numeric"],createSumTransform=factory(name$11,dependencies$11,D=>{var{typed:E,config:F,add:J,numeric:$e}=D,_t=createSum({typed:E,config:F,add:J,numeric:$e});return E(name$11,{"...any":function(lr){lr=lastDimToZeroBase(lr);try{return _t.apply(null,lr)}catch(mr){throw errorTransform(mr)}}})},{isTransformFunction:!0}),name$10="quantileSeq",dependencies$10=["typed","bignumber","add","subtract","divide","multiply","partitionSelect","compare","isInteger","smaller","smallerEq","larger","mapSlices"],createQuantileSeqTransform=factory(name$10,dependencies$10,D=>{var{typed:E,bignumber:F,add:J,subtract:$e,divide:_t,multiply:lr,partitionSelect:mr,compare:Or,isInteger:Pr,smaller:dn,smallerEq:gi,larger:qi,mapSlices:zi}=D,Hi=createQuantileSeq({typed:E,bignumber:F,add:J,subtract:$e,divide:_t,multiply:lr,partitionSelect:mr,compare:Or,isInteger:Pr,smaller:dn,smallerEq:gi,larger:qi,mapSlices:zi});return E("quantileSeq",{"Array | Matrix, number | BigNumber":Hi,"Array | Matrix, number | BigNumber, number":(Gi,Zi,Xi)=>Hi(Gi,Zi,Qi(Xi)),"Array | Matrix, number | BigNumber, boolean":Hi,"Array | Matrix, number | BigNumber, boolean, number":(Gi,Zi,Xi,Ki)=>Hi(Gi,Zi,Xi,Qi(Ki)),"Array | Matrix, Array | Matrix":Hi,"Array | Matrix, Array | Matrix, number":(Gi,Zi,Xi)=>Hi(Gi,Zi,Qi(Xi)),"Array | Matrix, Array | Matrix, boolean":Hi,"Array | Matrix, Array | Matrix, boolean, number":(Gi,Zi,Xi,Ki)=>Hi(Gi,Zi,Xi,Qi(Ki))});function Qi(Gi){return lastDimToZeroBase([[],Gi])[1]}},{isTransformFunction:!0}),name$9="cumsum",dependencies$9=["typed","add","unaryPlus"],createCumSumTransform=factory(name$9,dependencies$9,D=>{var{typed:E,add:F,unaryPlus:J}=D,$e=createCumSum({typed:E,add:F,unaryPlus:J});return E(name$9,{"...any":function(_t){if(_t.length===2&&isCollection(_t[0])){var lr=_t[1];isNumber(lr)?_t[1]=lr-1:isBigNumber(lr)&&(_t[1]=lr.minus(1))}try{return $e.apply(null,_t)}catch(mr){throw errorTransform(mr)}}})},{isTransformFunction:!0}),name$8="variance",dependencies$8=["typed","add","subtract","multiply","divide","mapSlices","isNaN"],createVarianceTransform=factory(name$8,dependencies$8,D=>{var{typed:E,add:F,subtract:J,multiply:$e,divide:_t,mapSlices:lr,isNaN:mr}=D,Or=createVariance({typed:E,add:F,subtract:J,multiply:$e,divide:_t,mapSlices:lr,isNaN:mr});return E(name$8,{"...any":function(Pr){Pr=lastDimToZeroBase(Pr);try{return Or.apply(null,Pr)}catch(dn){throw errorTransform(dn)}}})},{isTransformFunction:!0}),name$7="print",dependencies$7=["typed","matrix","zeros","add"],createPrintTransform=factory(name$7,dependencies$7,D=>{var{typed:E,matrix:F,zeros:J,add:$e}=D,_t=createPrint({typed:E,matrix:F,zeros:J,add:$e});return E(name$7,{"string, Object | Array":function(mr,Or){return _t(lr(mr),Or)},"string, Object | Array, number | Object":function(mr,Or,Pr){return _t(lr(mr),Or,Pr)}});function lr(mr){return mr.replace(printTemplate,Or=>"$"+Or.slice(1).split(".").map(function(Pr){return!isNaN(Pr)&&Pr.length>0?parseInt(Pr)-1:Pr}).join("."))}},{isTransformFunction:!0}),name$6="and",dependencies$6=["typed","matrix","zeros","add","equalScalar","not","concat"],createAndTransform=factory(name$6,dependencies$6,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,not:_t,concat:lr}=D,mr=createAnd({typed:E,matrix:F,equalScalar:J,zeros:$e,not:_t,concat:lr});function Or(Pr,dn,gi){var qi=Pr[0].compile().evaluate(gi);return!isCollection(qi)&&!mr(qi,!0)?!1:mr(qi,Pr[1].compile().evaluate(gi))}return Or.rawArgs=!0,Or},{isTransformFunction:!0}),name$5="or",dependencies$5=["typed","matrix","equalScalar","DenseMatrix","concat"],createOrTransform=factory(name$5,dependencies$5,D=>{var{typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t}=D,lr=createOr({typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t});function mr(Or,Pr,dn){var gi=Or[0].compile().evaluate(dn);return!isCollection(gi)&&lr(gi,!1)?!0:lr(gi,Or[1].compile().evaluate(dn))}return mr.rawArgs=!0,mr},{isTransformFunction:!0}),name$4="nullish",dependencies$4=["typed","matrix","size","flatten","deepEqual"],createNullishTransform=factory(name$4,dependencies$4,D=>{var{typed:E,matrix:F,size:J,flatten:$e,deepEqual:_t}=D,lr=createNullish({typed:E,matrix:F,size:J,flatten:$e,deepEqual:_t});function mr(Or,Pr,dn){var gi=Or[0].compile().evaluate(dn);return!isCollection(gi)&&gi!=null&&gi!==void 0?gi:lr(gi,Or[1].compile().evaluate(dn))}return mr.rawArgs=!0,mr},{isTransformFunction:!0}),name$3="bitAnd",dependencies$3=["typed","matrix","zeros","add","equalScalar","not","concat"],createBitAndTransform=factory(name$3,dependencies$3,D=>{var{typed:E,matrix:F,equalScalar:J,zeros:$e,not:_t,concat:lr}=D,mr=createBitAnd({typed:E,matrix:F,equalScalar:J,zeros:$e,not:_t,concat:lr});function Or(Pr,dn,gi){var qi=Pr[0].compile().evaluate(gi);if(!isCollection(qi)){if(isNaN(qi))return NaN;if(qi===0||qi===!1)return 0}return mr(qi,Pr[1].compile().evaluate(gi))}return Or.rawArgs=!0,Or},{isTransformFunction:!0}),name$2="bitOr",dependencies$2=["typed","matrix","equalScalar","DenseMatrix","concat"],createBitOrTransform=factory(name$2,dependencies$2,D=>{var{typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t}=D,lr=createBitOr({typed:E,matrix:F,equalScalar:J,DenseMatrix:$e,concat:_t});function mr(Or,Pr,dn){var gi=Or[0].compile().evaluate(dn);if(!isCollection(gi)){if(isNaN(gi))return NaN;if(gi===-1)return-1;if(gi===!0)return 1}return lr(gi,Or[1].compile().evaluate(dn))}return mr.rawArgs=!0,mr},{isTransformFunction:!0}),name$1="num",dependencies$1=["typed","fraction"],createNum=factory(name$1,dependencies$1,D=>{var{typed:E,fraction:F}=D;return E(name$1,{Fraction:J=>J.s*J.n,BigNumber:J=>{var $e=F(J);return $e.s*$e.n},"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),name="den",dependencies=["typed","fraction"],createDen=factory(name,dependencies,D=>{var{typed:E,fraction:F}=D;return E(name,{Fraction:J=>J.d,BigNumber:J=>F(J).d,"Array | Matrix":E.referToSelf(J=>$e=>deepMap($e,J))})}),factoriesAny_exports=__exportAll({createAbs:()=>createAbs,createAccessorNode:()=>createAccessorNode,createAcos:()=>createAcos,createAcosh:()=>createAcosh,createAcot:()=>createAcot,createAcoth:()=>createAcoth,createAcsc:()=>createAcsc,createAcsch:()=>createAcsch,createAdd:()=>createAdd,createAddScalar:()=>createAddScalar,createAnd:()=>createAnd,createAndTransform:()=>createAndTransform,createArg:()=>createArg,createArrayNode:()=>createArrayNode,createAsec:()=>createAsec,createAsech:()=>createAsech,createAsin:()=>createAsin,createAsinh:()=>createAsinh,createAssignmentNode:()=>createAssignmentNode,createAtan:()=>createAtan,createAtan2:()=>createAtan2,createAtanh:()=>createAtanh,createAtomicMass:()=>createAtomicMass,createAvogadro:()=>createAvogadro,createBellNumbers:()=>createBellNumbers,createBernoulli:()=>createBernoulli,createBigNumberClass:()=>createBigNumberClass,createBigint:()=>createBigint,createBignumber:()=>createBignumber,createBin:()=>createBin,createBitAnd:()=>createBitAnd,createBitAndTransform:()=>createBitAndTransform,createBitNot:()=>createBitNot,createBitOr:()=>createBitOr,createBitOrTransform:()=>createBitOrTransform,createBitXor:()=>createBitXor,createBlockNode:()=>createBlockNode,createBohrMagneton:()=>createBohrMagneton,createBohrRadius:()=>createBohrRadius,createBoltzmann:()=>createBoltzmann,createBoolean:()=>createBoolean,createCatalan:()=>createCatalan,createCbrt:()=>createCbrt,createCeil:()=>createCeil,createChain:()=>createChain,createChainClass:()=>createChainClass,createClassicalElectronRadius:()=>createClassicalElectronRadius,createClone:()=>createClone,createColumn:()=>createColumn,createColumnTransform:()=>createColumnTransform,createCombinations:()=>createCombinations,createCombinationsWithRep:()=>createCombinationsWithRep,createCompare:()=>createCompare,createCompareNatural:()=>createCompareNatural,createCompareText:()=>createCompareText,createCompile:()=>createCompile,createComplex:()=>createComplex,createComplexClass:()=>createComplexClass,createComposition:()=>createComposition,createConcat:()=>createConcat,createConcatTransform:()=>createConcatTransform,createConditionalNode:()=>createConditionalNode,createConductanceQuantum:()=>createConductanceQuantum,createConj:()=>createConj,createConstantNode:()=>createConstantNode,createCorr:()=>createCorr,createCos:()=>createCos,createCosh:()=>createCosh,createCot:()=>createCot,createCoth:()=>createCoth,createCoulomb:()=>createCoulomb,createCoulombConstant:()=>createCoulombConstant,createCount:()=>createCount,createCreateUnit:()=>createCreateUnit,createCross:()=>createCross,createCsc:()=>createCsc,createCsch:()=>createCsch,createCtranspose:()=>createCtranspose,createCube:()=>createCube,createCumSum:()=>createCumSum,createCumSumTransform:()=>createCumSumTransform,createDeepEqual:()=>createDeepEqual,createDen:()=>createDen,createDenseMatrixClass:()=>createDenseMatrixClass,createDerivative:()=>createDerivative,createDet:()=>createDet,createDeuteronMass:()=>createDeuteronMass,createDiag:()=>createDiag,createDiff:()=>createDiff,createDiffTransform:()=>createDiffTransform,createDistance:()=>createDistance,createDivide:()=>createDivide,createDivideScalar:()=>createDivideScalar,createDot:()=>createDot,createDotDivide:()=>createDotDivide,createDotMultiply:()=>createDotMultiply,createDotPow:()=>createDotPow,createE:()=>createE,createEfimovFactor:()=>createEfimovFactor,createEigs:()=>createEigs,createElectricConstant:()=>createElectricConstant,createElectronMass:()=>createElectronMass,createElementaryCharge:()=>createElementaryCharge,createEqual:()=>createEqual,createEqualScalar:()=>createEqualScalar,createEqualText:()=>createEqualText,createErf:()=>createErf,createEvaluate:()=>createEvaluate,createExp:()=>createExp,createExpm:()=>createExpm,createExpm1:()=>createExpm1,createFactorial:()=>createFactorial,createFalse:()=>createFalse,createFaraday:()=>createFaraday,createFermiCoupling:()=>createFermiCoupling,createFft:()=>createFft,createFibonacciHeapClass:()=>createFibonacciHeapClass,createFilter:()=>createFilter,createFilterTransform:()=>createFilterTransform,createFineStructure:()=>createFineStructure,createFirstRadiation:()=>createFirstRadiation,createFix:()=>createFix,createFlatten:()=>createFlatten,createFloor:()=>createFloor,createForEach:()=>createForEach,createForEachTransform:()=>createForEachTransform,createFormat:()=>createFormat,createFraction:()=>createFraction,createFractionClass:()=>createFractionClass,createFreqz:()=>createFreqz,createFunctionAssignmentNode:()=>createFunctionAssignmentNode,createFunctionNode:()=>createFunctionNode,createGamma:()=>createGamma,createGasConstant:()=>createGasConstant,createGcd:()=>createGcd,createGetMatrixDataType:()=>createGetMatrixDataType,createGravitationConstant:()=>createGravitationConstant,createGravity:()=>createGravity,createHartreeEnergy:()=>createHartreeEnergy,createHasNumericValue:()=>createHasNumericValue,createHelp:()=>createHelp,createHelpClass:()=>createHelpClass,createHex:()=>createHex,createHypot:()=>createHypot,createI:()=>createI,createIdentity:()=>createIdentity,createIfft:()=>createIfft,createIm:()=>createIm,createImmutableDenseMatrixClass:()=>createImmutableDenseMatrixClass,createIndex:()=>createIndex,createIndexClass:()=>createIndexClass,createIndexNode:()=>createIndexNode,createIndexTransform:()=>createIndexTransform,createInfinity:()=>createInfinity,createIntersect:()=>createIntersect,createInv:()=>createInv,createInverseConductanceQuantum:()=>createInverseConductanceQuantum,createInvmod:()=>createInvmod,createIsBounded:()=>createIsBounded,createIsFinite:()=>createIsFinite,createIsInteger:()=>createIsInteger,createIsNaN:()=>createIsNaN,createIsNegative:()=>createIsNegative,createIsNumeric:()=>createIsNumeric,createIsPositive:()=>createIsPositive,createIsPrime:()=>createIsPrime,createIsZero:()=>createIsZero,createKldivergence:()=>createKldivergence,createKlitzing:()=>createKlitzing,createKron:()=>createKron,createLN10:()=>createLN10,createLN2:()=>createLN2,createLOG10E:()=>createLOG10E,createLOG2E:()=>createLOG2E,createLarger:()=>createLarger,createLargerEq:()=>createLargerEq,createLcm:()=>createLcm,createLeafCount:()=>createLeafCount,createLeftShift:()=>createLeftShift,createLgamma:()=>createLgamma,createLog:()=>createLog,createLog10:()=>createLog10,createLog1p:()=>createLog1p,createLog2:()=>createLog2,createLoschmidt:()=>createLoschmidt,createLsolve:()=>createLsolve,createLsolveAll:()=>createLsolveAll,createLup:()=>createLup,createLusolve:()=>createLusolve,createLyap:()=>createLyap,createMad:()=>createMad,createMagneticConstant:()=>createMagneticConstant,createMagneticFluxQuantum:()=>createMagneticFluxQuantum,createMap:()=>createMap,createMapSlices:()=>createMapSlices,createMapSlicesTransform:()=>createMapSlicesTransform,createMapTransform:()=>createMapTransform,createMatrix:()=>createMatrix,createMatrixClass:()=>createMatrixClass,createMatrixFromColumns:()=>createMatrixFromColumns,createMatrixFromFunction:()=>createMatrixFromFunction,createMatrixFromRows:()=>createMatrixFromRows,createMax:()=>createMax,createMaxTransform:()=>createMaxTransform,createMean:()=>createMean,createMeanTransform:()=>createMeanTransform,createMedian:()=>createMedian,createMin:()=>createMin,createMinTransform:()=>createMinTransform,createMod:()=>createMod,createMode:()=>createMode,createMolarMass:()=>createMolarMass,createMolarMassC12:()=>createMolarMassC12,createMolarPlanckConstant:()=>createMolarPlanckConstant,createMolarVolume:()=>createMolarVolume,createMultinomial:()=>createMultinomial,createMultiply:()=>createMultiply,createMultiplyScalar:()=>createMultiplyScalar,createNaN:()=>createNaN,createNeutronMass:()=>createNeutronMass,createNode:()=>createNode,createNorm:()=>createNorm,createNot:()=>createNot,createNthRoot:()=>createNthRoot,createNthRoots:()=>createNthRoots,createNuclearMagneton:()=>createNuclearMagneton,createNull:()=>createNull,createNullish:()=>createNullish,createNullishTransform:()=>createNullishTransform,createNum:()=>createNum,createNumber:()=>createNumber,createNumeric:()=>createNumeric,createObjectNode:()=>createObjectNode,createOct:()=>createOct,createOnes:()=>createOnes,createOperatorNode:()=>createOperatorNode,createOr:()=>createOr,createOrTransform:()=>createOrTransform,createParenthesisNode:()=>createParenthesisNode,createParse:()=>createParse,createParser:()=>createParser,createParserClass:()=>createParserClass,createPartitionSelect:()=>createPartitionSelect,createPermutations:()=>createPermutations,createPhi:()=>createPhi,createPi:()=>createPi,createPickRandom:()=>createPickRandom,createPinv:()=>createPinv,createPlanckCharge:()=>createPlanckCharge,createPlanckConstant:()=>createPlanckConstant,createPlanckLength:()=>createPlanckLength,createPlanckMass:()=>createPlanckMass,createPlanckTemperature:()=>createPlanckTemperature,createPlanckTime:()=>createPlanckTime,createPolynomialRoot:()=>createPolynomialRoot,createPow:()=>createPow,createPrint:()=>createPrint,createPrintTransform:()=>createPrintTransform,createProd:()=>createProd,createProtonMass:()=>createProtonMass,createQr:()=>createQr,createQuantileSeq:()=>createQuantileSeq,createQuantileSeqTransform:()=>createQuantileSeqTransform,createQuantumOfCirculation:()=>createQuantumOfCirculation,createRandom:()=>createRandom,createRandomInt:()=>createRandomInt,createRange:()=>createRange,createRangeClass:()=>createRangeClass,createRangeNode:()=>createRangeNode,createRangeTransform:()=>createRangeTransform,createRationalize:()=>createRationalize,createRe:()=>createRe,createReducedPlanckConstant:()=>createReducedPlanckConstant,createRelationalNode:()=>createRelationalNode,createReplacer:()=>createReplacer,createReshape:()=>createReshape,createResize:()=>createResize,createResolve:()=>createResolve,createResultSet:()=>createResultSet,createReviver:()=>createReviver,createRightArithShift:()=>createRightArithShift,createRightLogShift:()=>createRightLogShift,createRotate:()=>createRotate,createRotationMatrix:()=>createRotationMatrix,createRound:()=>createRound,createRow:()=>createRow,createRowTransform:()=>createRowTransform,createRydberg:()=>createRydberg,createSQRT1_2:()=>createSQRT1_2,createSQRT2:()=>createSQRT2,createSackurTetrode:()=>createSackurTetrode,createSchur:()=>createSchur,createSec:()=>createSec,createSech:()=>createSech,createSecondRadiation:()=>createSecondRadiation,createSetCartesian:()=>createSetCartesian,createSetDifference:()=>createSetDifference,createSetDistinct:()=>createSetDistinct,createSetIntersect:()=>createSetIntersect,createSetIsSubset:()=>createSetIsSubset,createSetMultiplicity:()=>createSetMultiplicity,createSetPowerset:()=>createSetPowerset,createSetSize:()=>createSetSize,createSetSymDifference:()=>createSetSymDifference,createSetUnion:()=>createSetUnion,createSign:()=>createSign,createSimplify:()=>createSimplify,createSimplifyConstant:()=>createSimplifyConstant,createSimplifyCore:()=>createSimplifyCore,createSin:()=>createSin,createSinh:()=>createSinh,createSize:()=>createSize,createSlu:()=>createSlu,createSmaller:()=>createSmaller,createSmallerEq:()=>createSmallerEq,createSolveODE:()=>createSolveODE,createSort:()=>createSort,createSpaClass:()=>createSpaClass,createSparse:()=>createSparse,createSparseMatrixClass:()=>createSparseMatrixClass,createSpeedOfLight:()=>createSpeedOfLight,createSplitUnit:()=>createSplitUnit,createSqrt:()=>createSqrt,createSqrtm:()=>createSqrtm,createSquare:()=>createSquare,createSqueeze:()=>createSqueeze,createStd:()=>createStd,createStdTransform:()=>createStdTransform,createStefanBoltzmann:()=>createStefanBoltzmann,createStirlingS2:()=>createStirlingS2,createString:()=>createString,createSubset:()=>createSubset,createSubsetTransform:()=>createSubsetTransform,createSubtract:()=>createSubtract,createSubtractScalar:()=>createSubtractScalar,createSum:()=>createSum,createSumTransform:()=>createSumTransform,createSylvester:()=>createSylvester,createSymbolNode:()=>createSymbolNode,createSymbolicEqual:()=>createSymbolicEqual,createTan:()=>createTan,createTanh:()=>createTanh,createTau:()=>createTau,createThomsonCrossSection:()=>createThomsonCrossSection,createTo:()=>createTo,createToBest:()=>createToBest,createTrace:()=>createTrace,createTranspose:()=>createTranspose,createTrue:()=>createTrue,createTypeOf:()=>createTypeOf,createTyped:()=>createTyped,createUnaryMinus:()=>createUnaryMinus,createUnaryPlus:()=>createUnaryPlus,createUnequal:()=>createUnequal,createUnitClass:()=>createUnitClass,createUnitFunction:()=>createUnitFunction,createUppercaseE:()=>createUppercaseE,createUppercasePi:()=>createUppercasePi,createUsolve:()=>createUsolve,createUsolveAll:()=>createUsolveAll,createVacuumImpedance:()=>createVacuumImpedance,createVariance:()=>createVariance,createVarianceTransform:()=>createVarianceTransform,createVersion:()=>createVersion,createWeakMixingAngle:()=>createWeakMixingAngle,createWienDisplacement:()=>createWienDisplacement,createXgcd:()=>createXgcd,createXor:()=>createXor,createZeros:()=>createZeros,createZeta:()=>createZeta,createZpk2tf:()=>createZpk2tf}),all=factoriesAny_exports,require_tiny_emitter=__commonJSMin(((D,E)=>{function F(){}F.prototype={on:function(J,$e,_t){var lr=this.e||={};return(lr[J]||(lr[J]=[])).push({fn:$e,ctx:_t}),this},once:function(J,$e,_t){var lr=this;function mr(){lr.off(J,mr),$e.apply(_t,arguments)}return mr._=$e,this.on(J,mr,_t)},emit:function(J){for(var $e=[].slice.call(arguments,1),_t=((this.e||={})[J]||[]).slice(),lr=0,mr=_t.length;lr<mr;lr++)_t[lr].fn.apply(_t[lr].ctx,$e);return this},off:function(J,$e){var _t=this.e||={},lr=_t[J],mr=[];if(lr&&$e)for(var Or=0,Pr=lr.length;Or<Pr;Or++)lr[Or].fn!==$e&&lr[Or].fn._!==$e&&mr.push(lr[Or]);return mr.length?_t[J]=mr:delete _t[J],this}},E.exports=F,E.exports.TinyEmitter=F})),import_tiny_emitter=__toESM(require_tiny_emitter());function mixin$1(D){var E=new import_tiny_emitter.default;return D.on=E.on.bind(E),D.off=E.off.bind(E),D.once=E.once.bind(E),D.emit=E.emit.bind(E),D}function importFactory(D,E,F,J){function $e(Zi,Xi){var Ki=arguments.length;if(Ki!==1&&Ki!==2)throw new ArgumentsError("import",Ki,1,2);Xi||={};function ea(ra,ia,oa){if(Array.isArray(ia))ia.forEach(aa=>ea(ra,aa));else if(isObject$1(ia)||gi(ia))for(var ua in ia)hasOwnProperty$1(ia,ua)&&ea(ra,ia[ua],ua);else if(isFactory(ia)||oa!==void 0){var sa=isFactory(ia)?Qi(ia)?ia.fn+".transform":ia.fn:oa;if(hasOwnProperty$1(ra,sa)&&ra[sa]!==ia&&!Xi.silent)throw Error(\'Cannot import "\'+sa+\'" twice\');ra[sa]=ia}else if(!Xi.silent)throw TypeError("Factory, Object, or Array expected")}var Ji={};for(var ta in ea(Ji,Zi),Ji)if(hasOwnProperty$1(Ji,ta)){var na=Ji[ta];if(isFactory(na))Pr(na,Xi);else if(dn(na))_t(ta,na,Xi);else if(!Xi.silent)throw TypeError("Factory, Object, or Array expected")}}function _t(Zi,Xi,Ki){if(Ki.wrap&&typeof Xi=="function"&&(Xi=Or(Xi)),qi(Xi)&&(Xi=D(Zi,{[Xi.signature]:Xi})),D.isTypedFunction(F[Zi])&&D.isTypedFunction(Xi)){Xi=Ki.override?D(Zi,Xi.signatures):D(F[Zi],Xi),F[Zi]=Xi,delete J[Zi],lr(Zi,Xi),F.emit("import",Zi,function(){return Xi});return}var ea=F[Zi]!==void 0,Ji=F.Unit?.isValuelessUnit(Zi);if(!ea&&!Ji||Ki.override){F[Zi]=Xi,delete J[Zi],lr(Zi,Xi),F.emit("import",Zi,function(){return Xi});return}if(!Ki.silent)throw Error(\'Cannot import "\'+Zi+\'": already exists\')}function lr(Zi,Xi){Xi&&typeof Xi.transform=="function"?(F.expression.transform[Zi]=Xi.transform,zi(Zi)&&(F.expression.mathWithTransform[Zi]=Xi.transform)):(delete F.expression.transform[Zi],zi(Zi)&&(F.expression.mathWithTransform[Zi]=Xi))}function mr(Zi){delete F.expression.transform[Zi],zi(Zi)?F.expression.mathWithTransform[Zi]=F[Zi]:delete F.expression.mathWithTransform[Zi]}function Or(Zi){var Xi=function(){for(var Ki=[],ea=0,Ji=arguments.length;ea<Ji;ea++){var ta=arguments[ea];Ki[ea]=ta&&ta.valueOf()}return Zi.apply(F,Ki)};return Zi.transform&&(Xi.transform=Zi.transform),Xi}function Pr(Zi,Xi){var Ki=arguments.length>2&&arguments[2]!==void 0?arguments[2]:Zi.fn;if(Ki.includes("."))throw Error("Factory name should not contain a nested path. Name: "+JSON.stringify(Ki));var ea=Qi(Zi)?F.expression.transform:F,Ji=Ki in F.expression.transform,ta=hasOwnProperty$1(ea,Ki)?ea[Ki]:void 0,na=function(){var ua={};Zi.dependencies.map(stripOptionalNotation).forEach(aa=>{if(aa.includes("."))throw Error("Factory dependency should not contain a nested path. Name: "+JSON.stringify(aa));aa==="math"?ua.math=F:aa==="mathWithTransform"?ua.mathWithTransform=F.expression.mathWithTransform:aa==="classes"?ua.classes=F:ua[aa]=F[aa]});var sa=Zi(ua);if(sa&&typeof sa.transform=="function")throw Error(\'Transforms cannot be attached to factory functions. Please create a separate function for it with export const path = "expression.transform"\');if(ta===void 0||Xi.override)return sa;if(D.isTypedFunction(ta)&&D.isTypedFunction(sa))return D(ta,sa);if(Xi.silent)return ta;throw Error(\'Cannot import "\'+Ki+\'": already exists\')},ra=Zi.meta?.formerly??"",ia=Qi(Zi)||Hi(Zi),oa=F.expression.mathWithTransform;!Zi.meta||Zi.meta.lazy!==!1?(lazy(ea,Ki,na),ra&&lazy(ea,ra,na),ta&&Ji?(mr(Ki),ra&&mr(ra)):ia&&(lazy(oa,Ki,()=>ea[Ki]),ra&&lazy(oa,ra,()=>ea[Ki]))):(ea[Ki]=na(),ra&&(ea[ra]=ea[Ki]),ta&&Ji?(mr(Ki),ra&&mr(ra)):ia&&(lazy(oa,Ki,()=>ea[Ki]),ra&&lazy(oa,ra,()=>ea[Ki]))),J[Ki]=Zi,F.emit("import",Ki,na)}function dn(Zi){return typeof Zi=="function"||typeof Zi=="number"||typeof Zi=="string"||typeof Zi=="boolean"||Zi===null||isUnit(Zi)||isComplex(Zi)||isBigNumber(Zi)||isFraction(Zi)||isMatrix(Zi)||Array.isArray(Zi)}function gi(Zi){return typeof Zi=="object"&&Zi[Symbol.toStringTag]==="Module"}function qi(Zi){return typeof Zi=="function"&&typeof Zi.signature=="string"}function zi(Zi){return!hasOwnProperty$1(Gi,Zi)}function Hi(Zi){return!Zi.fn.includes(".")&&!hasOwnProperty$1(Gi,Zi.fn)&&(!Zi.meta||!Zi.meta.isClass)}function Qi(Zi){return Zi!==void 0&&Zi.meta!==void 0&&Zi.meta.isTransformFunction===!0||!1}var Gi={expression:!0,type:!0,docs:!0,error:!0,json:!0,chain:!0};return $e}function create$1(D,E){var F=_extends({},DEFAULT_CONFIG,E);if(typeof Object.create!="function")throw Error("ES5 not supported by this JavaScript engine. Please load the es5-shim and es5-sham library for compatibility.");var J=mixin$1({isNumber,isComplex,isBigNumber,isBigInt,isFraction,isUnit,isString,isArray,isMatrix,isCollection,isDenseMatrix,isSparseMatrix,isRange,isIndex,isBoolean:isBoolean$1,isResultSet,isHelp,isFunction:isFunction$1,isDate,isRegExp,isObject:isObject$1,isMap,isPartitionedMap,isObjectWrappingMap,isNull:isNull$1,isUndefined:isUndefined$1,isAccessorNode,isArrayNode,isAssignmentNode,isBlockNode,isConditionalNode,isConstantNode,isFunctionAssignmentNode,isFunctionNode,isIndexNode,isNode,isObjectNode,isOperatorNode,isParenthesisNode,isRangeNode,isRelationalNode,isSymbolNode,isChain});J.config=configFactory(F,J.emit),J.expression={transform:{},mathWithTransform:{config:J.config}};var $e=[],_t=[];function lr(dn){if(isFactory(dn))return dn(J);var gi=dn[Object.keys(dn)[0]];if(isFactory(gi))return gi(J);if(!isLegacyFactory(dn))throw console.warn("Factory object with properties `type`, `name`, and `factory` expected",dn),Error("Factory object with properties `type`, `name`, and `factory` expected");var qi=$e.indexOf(dn),zi;return qi===-1?(zi=dn.math===!0?dn.factory(J.type,F,lr,J.typed,J):dn.factory(J.type,F,lr,J.typed),$e.push(dn),_t.push(zi)):zi=_t[qi],zi}var mr={};function Or(){var dn=[...arguments];return J.typed.apply(J.typed,dn)}Or.isTypedFunction=import_typed_function.default.isTypedFunction;var Pr=importFactory(Or,lr,J,mr);return J.import=Pr,J.on("config",()=>{Object.values(mr).forEach(dn=>{dn&&dn.meta&&dn.meta.recreateOnConfigChange&&Pr(dn,{override:!0})})}),J.create=create$1.bind(null,D),J.factory=factory,J.import(Object.values(deepFlatten(D))),J.ArgumentsError=ArgumentsError,J.DimensionError=DimensionError,J.IndexError=IndexError,J}var require_numeric_1_2_6=__commonJSMin((exports=>{var numeric=exports===void 0?(function(){}):exports;typeof global<"u"&&(global.numeric=numeric),numeric.version="1.2.6",numeric.bench=function(D,E){var F,J,$e,_t;for(E===void 0&&(E=15),$e=.5,F=new Date;;){for($e*=2,_t=$e;_t>3;_t-=4)D(),D(),D(),D();for(;_t>0;)D(),_t--;if(J=new Date,J-F>E)break}for(_t=$e;_t>3;_t-=4)D(),D(),D(),D();for(;_t>0;)D(),_t--;return J=new Date,1e3*(3*$e-1)/(J-F)},numeric._myIndexOf=(function(D){var E=this.length,F;for(F=0;F<E;++F)if(this[F]===D)return F;return-1}),numeric.myIndexOf=Array.prototype.indexOf?Array.prototype.indexOf:numeric._myIndexOf,numeric.Function=Function,numeric.precision=4,numeric.largeArray=50,numeric.prettyPrint=function(D){function E($e){if($e===0)return"0";if(isNaN($e))return"NaN";if($e<0)return"-"+E(-$e);if(isFinite($e)){var _t=Math.floor(Math.log($e)/Math.log(10)),lr=$e/10**_t,mr=lr.toPrecision(numeric.precision);return parseFloat(mr)===10&&(_t++,lr=1,mr=lr.toPrecision(numeric.precision)),parseFloat(mr).toString()+"e"+_t.toString()}return"Infinity"}var F=[];function J($e){var _t;if($e===void 0)return F.push(Array(numeric.precision+8).join(" ")),!1;if(typeof $e=="string")return F.push(\'"\'+$e+\'"\'),!1;if(typeof $e=="boolean")return F.push($e.toString()),!1;if(typeof $e=="number"){var lr=E($e),mr=$e.toPrecision(numeric.precision),Or=parseFloat($e.toString()).toString(),Pr=[lr,mr,Or,parseFloat(mr).toString(),parseFloat(Or).toString()];for(_t=1;_t<Pr.length;_t++)Pr[_t].length<lr.length&&(lr=Pr[_t]);return F.push(Array(numeric.precision+8-lr.length).join(" ")+lr),!1}if($e===null)return F.push("null"),!1;if(typeof $e=="function"){F.push($e.toString());var dn=!1;for(_t in $e)$e.hasOwnProperty(_t)&&(dn?F.push(`,\n`):F.push(`\n{`),dn=!0,F.push(_t),F.push(`: \n`),J($e[_t]));return dn&&F.push(`}\n`),!0}if($e instanceof Array){if($e.length>numeric.largeArray)return F.push("...Large Array..."),!0;var dn=!1;for(F.push("["),_t=0;_t<$e.length;_t++)_t>0&&(F.push(","),dn&&F.push(`\n `)),dn=J($e[_t]);return F.push("]"),!0}F.push("{");var dn=!1;for(_t in $e)$e.hasOwnProperty(_t)&&(dn&&F.push(`,\n`),dn=!0,F.push(_t),F.push(`: \n`),J($e[_t]));return F.push("}"),!0}return J(D),F.join("")},numeric.parseDate=function(D){function E(F){if(typeof F=="string")return Date.parse(F.replace(/-/g,"/"));if(!(F instanceof Array))throw Error("parseDate: parameter must be arrays of strings");var J=[],$e;for($e=0;$e<F.length;$e++)J[$e]=E(F[$e]);return J}return E(D)},numeric.parseFloat=function(D){function E(F){if(typeof F=="string")return parseFloat(F);if(!(F instanceof Array))throw Error("parseFloat: parameter must be arrays of strings");var J=[],$e;for($e=0;$e<F.length;$e++)J[$e]=E(F[$e]);return J}return E(D)},numeric.parseCSV=function(D){var E=D.split(`\n`),F,J,$e=[],_t=/(([^\'",]*)|(\'[^\']*\')|("[^"]*")),/g,lr=/^\\s*(([+-]?[0-9]+(\\.[0-9]*)?(e[+-]?[0-9]+)?)|([+-]?[0-9]*(\\.[0-9]+)?(e[+-]?[0-9]+)?))\\s*$/,mr=function(gi){return gi.substr(0,gi.length-1)},Or=0;for(J=0;J<E.length;J++){var Pr=(E[J]+",").match(_t),dn;if(Pr.length>0){for($e[Or]=[],F=0;F<Pr.length;F++)dn=mr(Pr[F]),lr.test(dn)?$e[Or][F]=parseFloat(dn):$e[Or][F]=dn;Or++}}return $e},numeric.toCSV=function(D){var E=numeric.dim(D),F,J,$e=E[0],_t,lr;for(E[1],lr=[],F=0;F<$e;F++){for(_t=[],J=0;J<$e;J++)_t[J]=D[F][J].toString();lr[F]=_t.join(", ")}return lr.join(`\n`)+`\n`},numeric.getURL=function(D){var E=new XMLHttpRequest;return E.open("GET",D,!1),E.send(),E},numeric.imageURL=function(D){function E(Gi){var Zi=Gi.length,Xi,Ki,ea,Ji,ta,na,ra,ia,oa="ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=",ua="";for(Xi=0;Xi<Zi;Xi+=3)Ki=Gi[Xi],ea=Gi[Xi+1],Ji=Gi[Xi+2],ta=Ki>>2,na=((Ki&3)<<4)+(ea>>4),ra=((ea&15)<<2)+(Ji>>6),ia=Ji&63,Xi+1>=Zi?ra=ia=64:Xi+2>=Zi&&(ia=64),ua+=oa.charAt(ta)+oa.charAt(na)+oa.charAt(ra)+oa.charAt(ia);return ua}function F(Gi,Zi,Xi){Zi===void 0&&(Zi=0),Xi===void 0&&(Xi=Gi.length);var Ki=[0,1996959894,3993919788,2567524794,124634137,1886057615,3915621685,2657392035,249268274,2044508324,3772115230,2547177864,162941995,2125561021,3887607047,2428444049,498536548,1789927666,4089016648,2227061214,450548861,1843258603,4107580753,2211677639,325883990,1684777152,4251122042,2321926636,335633487,1661365465,4195302755,2366115317,997073096,1281953886,3579855332,2724688242,1006888145,1258607687,3524101629,2768942443,901097722,1119000684,3686517206,2898065728,853044451,1172266101,3705015759,2882616665,651767980,1373503546,3369554304,3218104598,565507253,1454621731,3485111705,3099436303,671266974,1594198024,3322730930,2970347812,795835527,1483230225,3244367275,3060149565,1994146192,31158534,2563907772,4023717930,1907459465,112637215,2680153253,3904427059,2013776290,251722036,2517215374,3775830040,2137656763,141376813,2439277719,3865271297,1802195444,476864866,2238001368,4066508878,1812370925,453092731,2181625025,4111451223,1706088902,314042704,2344532202,4240017532,1658658271,366619977,2362670323,4224994405,1303535960,984961486,2747007092,3569037538,1256170817,1037604311,2765210733,3554079995,1131014506,879679996,2909243462,3663771856,1141124467,855842277,2852801631,3708648649,1342533948,654459306,3188396048,3373015174,1466479909,544179635,3110523913,3462522015,1591671054,702138776,2966460450,3352799412,1504918807,783551873,3082640443,3233442989,3988292384,2596254646,62317068,1957810842,3939845945,2647816111,81470997,1943803523,3814918930,2489596804,225274430,2053790376,3826175755,2466906013,167816743,2097651377,4027552580,2265490386,503444072,1762050814,4150417245,2154129355,426522225,1852507879,4275313526,2312317920,282753626,1742555852,4189708143,2394877945,397917763,1622183637,3604390888,2714866558,953729732,1340076626,3518719985,2797360999,1068828381,1219638859,3624741850,2936675148,906185462,1090812512,3747672003,2825379669,829329135,1181335161,3412177804,3160834842,628085408,1382605366,3423369109,3138078467,570562233,1426400815,3317316542,2998733608,733239954,1555261956,3268935591,3050360625,752459403,1541320221,2607071920,3965973030,1969922972,40735498,2617837225,3943577151,1913087877,83908371,2512341634,3803740692,2075208622,213261112,2463272603,3855990285,2094854071,198958881,2262029012,4057260610,1759359992,534414190,2176718541,4139329115,1873836001,414664567,2282248934,4279200368,1711684554,285281116,2405801727,4167216745,1634467795,376229701,2685067896,3608007406,1308918612,956543938,2808555105,3495958263,1231636301,1047427035,2932959818,3654703836,1088359270,936918e3,2847714899,3736837829,1202900863,817233897,3183342108,3401237130,1404277552,615818150,3134207493,3453421203,1423857449,601450431,3009837614,3294710456,1567103746,711928724,3020668471,3272380065,1510334235,755167117],ea=-1,Ji=0;Gi.length;var ta;for(ta=Zi;ta<Xi;ta++)Ji=(ea^Gi[ta])&255,ea=ea>>>8^Ki[Ji];return ea^-1}var J=D[0].length,$e=D[0][0].length,_t,lr,mr,Or,Pr,dn,gi,qi,zi,Hi,Qi=[137,80,78,71,13,10,26,10,0,0,0,13,73,72,68,82,$e>>24&255,$e>>16&255,$e>>8&255,$e&255,J>>24&255,J>>16&255,J>>8&255,J&255,8,2,0,0,0,-1,-2,-3,-4,-5,-6,-7,-8,73,68,65,84,8,29];for(Hi=F(Qi,12,29),Qi[29]=Hi>>24&255,Qi[30]=Hi>>16&255,Qi[31]=Hi>>8&255,Qi[32]=Hi&255,_t=1,lr=0,gi=0;gi<J;gi++){for(gi<J-1?Qi.push(0):Qi.push(1),Pr=3*$e+1+(gi===0)&255,dn=3*$e+1+(gi===0)>>8&255,Qi.push(Pr),Qi.push(dn),Qi.push(~Pr&255),Qi.push(~dn&255),gi===0&&Qi.push(0),qi=0;qi<$e;qi++)for(mr=0;mr<3;mr++)Pr=D[mr][gi][qi],Pr=Pr>255?255:Pr<0?0:Math.round(Pr),_t=(_t+Pr)%65521,lr=(lr+_t)%65521,Qi.push(Pr);Qi.push(0)}return zi=(lr<<16)+_t,Qi.push(zi>>24&255),Qi.push(zi>>16&255),Qi.push(zi>>8&255),Qi.push(zi&255),Or=Qi.length-41,Qi[33]=Or>>24&255,Qi[34]=Or>>16&255,Qi[35]=Or>>8&255,Qi[36]=Or&255,Hi=F(Qi,37),Qi.push(Hi>>24&255),Qi.push(Hi>>16&255),Qi.push(Hi>>8&255),Qi.push(Hi&255),Qi.push(0),Qi.push(0),Qi.push(0),Qi.push(0),Qi.push(73),Qi.push(69),Qi.push(78),Qi.push(68),Qi.push(174),Qi.push(66),Qi.push(96),Qi.push(130),"data:image/png;base64,"+E(Qi)},numeric._dim=function(D){for(var E=[];typeof D=="object";)E.push(D.length),D=D[0];return E},numeric.dim=function(D){var E,F;return typeof D=="object"?(E=D[0],typeof E=="object"?(F=E[0],typeof F=="object"?numeric._dim(D):[D.length,E.length]):[D.length]):[]},numeric.mapreduce=function(D,E){return Function("x","accum","_s","_k",\'if(typeof accum === "undefined") accum = \'+E+`;\nif(typeof x === "number") { var xi = x; `+D+`; return accum; }\nif(typeof _s === "undefined") _s = numeric.dim(x);\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i,xi;\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) {\n        accum = arguments.callee(x[i],accum,_s,_k+1);\n    }    return accum;\n}\nfor(i=_n-1;i>=1;i-=2) { \n    xi = x[i];\n    `+D+`;\n    xi = x[i-1];\n    `+D+`;\n}\nif(i === 0) {\n    xi = x[i];\n    `+D+`\n}\nreturn accum;`)},numeric.mapreduce2=function(D,E){return Function("x",`var n = x.length;\nvar i,xi;\n`+E+`;\nfor(i=n-1;i!==-1;--i) { \n    xi = x[i];\n    `+D+`;\n}\nreturn accum;`)},numeric.same=function D(E,F){var J,$e;if(!(E instanceof Array)||!(F instanceof Array)||($e=E.length,$e!==F.length))return!1;for(J=0;J<$e;J++)if(E[J]!==F[J])if(typeof E[J]=="object"){if(!D(E[J],F[J]))return!1}else return!1;return!0},numeric.rep=function(D,E,F){F===void 0&&(F=0);var J=D[F],$e=Array(J),_t;if(F===D.length-1){for(_t=J-2;_t>=0;_t-=2)$e[_t+1]=E,$e[_t]=E;return _t===-1&&($e[0]=E),$e}for(_t=J-1;_t>=0;_t--)$e[_t]=numeric.rep(D,E,F+1);return $e},numeric.dotMMsmall=function(D,E){var F,J,$e,_t=D.length,lr=E.length,mr=E[0].length,Or=Array(_t),Pr,dn,gi,qi;for(F=_t-1;F>=0;F--){for(Pr=Array(mr),dn=D[F],$e=mr-1;$e>=0;$e--){for(gi=dn[lr-1]*E[lr-1][$e],J=lr-2;J>=1;J-=2)qi=J-1,gi+=dn[J]*E[J][$e]+dn[qi]*E[qi][$e];J===0&&(gi+=dn[0]*E[0][$e]),Pr[$e]=gi}Or[F]=Pr}return Or},numeric._getCol=function(D,E,F){var J=D.length,$e;for($e=J-1;$e>0;--$e)F[$e]=D[$e][E],--$e,F[$e]=D[$e][E];$e===0&&(F[0]=D[0][E])},numeric.dotMMbig=function(D,E){var F=numeric._getCol,J=E.length,$e=Array(J),_t=D.length,lr=E[0].length,mr=Array(_t),Or,Pr=numeric.dotVV,dn,gi;for(--J,--_t,dn=_t;dn!==-1;--dn)mr[dn]=Array(lr);for(--lr,dn=lr;dn!==-1;--dn)for(F(E,dn,$e),gi=_t;gi!==-1;--gi)Or=D[gi],mr[gi][dn]=Pr(Or,$e);return mr},numeric.dotMV=function(D,E){var F=D.length;E.length;var J,$e=Array(F),_t=numeric.dotVV;for(J=F-1;J>=0;J--)$e[J]=_t(D[J],E);return $e},numeric.dotVM=function(D,E){var F,J,$e=D.length,_t=E[0].length,lr=Array(_t),mr,Or;for(J=_t-1;J>=0;J--){for(mr=D[$e-1]*E[$e-1][J],F=$e-2;F>=1;F-=2)Or=F-1,mr+=D[F]*E[F][J]+D[Or]*E[Or][J];F===0&&(mr+=D[0]*E[0][J]),lr[J]=mr}return lr},numeric.dotVV=function(D,E){var F,J=D.length,$e,_t=D[J-1]*E[J-1];for(F=J-2;F>=1;F-=2)$e=F-1,_t+=D[F]*E[F]+D[$e]*E[$e];return F===0&&(_t+=D[0]*E[0]),_t},numeric.dot=function(D,E){var F=numeric.dim;switch(F(D).length*1e3+F(E).length){case 2002:return E.length<10?numeric.dotMMsmall(D,E):numeric.dotMMbig(D,E);case 2001:return numeric.dotMV(D,E);case 1002:return numeric.dotVM(D,E);case 1001:return numeric.dotVV(D,E);case 1e3:return numeric.mulVS(D,E);case 1:return numeric.mulSV(D,E);case 0:return D*E;default:throw Error("numeric.dot only works on vectors and matrices")}},numeric.diag=function(D){var E,F,J,$e=D.length,_t=Array($e),lr;for(E=$e-1;E>=0;E--){for(lr=Array($e),F=E+2,J=$e-1;J>=F;J-=2)lr[J]=0,lr[J-1]=0;for(J>E&&(lr[J]=0),lr[E]=D[E],J=E-1;J>=1;J-=2)lr[J]=0,lr[J-1]=0;J===0&&(lr[0]=0),_t[E]=lr}return _t},numeric.getDiag=function(D){var E=Math.min(D.length,D[0].length),F,J=Array(E);for(F=E-1;F>=1;--F)J[F]=D[F][F],--F,J[F]=D[F][F];return F===0&&(J[0]=D[0][0]),J},numeric.identity=function(D){return numeric.diag(numeric.rep([D],1))},numeric.pointwise=function(D,E,F){F===void 0&&(F="");var J=[],$e,_t=/\\[i\\]$/,lr,mr="",Or=!1;for($e=0;$e<D.length;$e++)_t.test(D[$e])?(lr=D[$e].substring(0,D[$e].length-3),mr=lr):lr=D[$e],lr==="ret"&&(Or=!0),J.push(lr);return J[D.length]="_s",J[D.length+1]="_k",J[D.length+2]=\'if(typeof _s === "undefined") _s = numeric.dim(\'+mr+`);\nif(typeof _k === "undefined") _k = 0;\nvar _n = _s[_k];\nvar i`+(Or?"":", ret = Array(_n)")+`;\nif(_k < _s.length-1) {\n    for(i=_n-1;i>=0;i--) ret[i] = arguments.callee(`+D.join(",")+`,_s,_k+1);\n    return ret;\n}\n`+F+`\nfor(i=_n-1;i!==-1;--i) {\n    `+E+`\n}\nreturn ret;`,Function.apply(null,J)},numeric.pointwise2=function(D,E,F){F===void 0&&(F="");var J=[],$e,_t=/\\[i\\]$/,lr,mr="",Or=!1;for($e=0;$e<D.length;$e++)_t.test(D[$e])?(lr=D[$e].substring(0,D[$e].length-3),mr=lr):lr=D[$e],lr==="ret"&&(Or=!0),J.push(lr);return J[D.length]="var _n = "+mr+`.length;\nvar i`+(Or?"":", ret = Array(_n)")+`;\n`+F+`\nfor(i=_n-1;i!==-1;--i) {\n`+E+`\n}\nreturn ret;`,Function.apply(null,J)},numeric._biforeach=(function D(E,F,J,$e,_t){if($e===J.length-1){_t(E,F);return}var lr;for(lr=J[$e]-1;lr>=0;lr--)D(typeof E=="object"?E[lr]:E,typeof F=="object"?F[lr]:F,J,$e+1,_t)}),numeric._biforeach2=(function D(E,F,J,$e,_t){if($e===J.length-1)return _t(E,F);var lr,mr=J[$e],Or=Array(mr);for(lr=mr-1;lr>=0;--lr)Or[lr]=D(typeof E=="object"?E[lr]:E,typeof F=="object"?F[lr]:F,J,$e+1,_t);return Or}),numeric._foreach=(function D(E,F,J,$e){if(J===F.length-1){$e(E);return}var _t;for(_t=F[J]-1;_t>=0;_t--)D(E[_t],F,J+1,$e)}),numeric._foreach2=(function D(E,F,J,$e){if(J===F.length-1)return $e(E);var _t,lr=F[J],mr=Array(lr);for(_t=lr-1;_t>=0;_t--)mr[_t]=D(E[_t],F,J+1,$e);return mr}),numeric.ops2={add:"+",sub:"-",mul:"*",div:"/",mod:"%",and:"&&",or:"||",eq:"===",neq:"!==",lt:"<",gt:">",leq:"<=",geq:">=",band:"&",bor:"|",bxor:"^",lshift:"<<",rshift:">>",rrshift:">>>"},numeric.opseq={addeq:"+=",subeq:"-=",muleq:"*=",diveq:"/=",modeq:"%=",lshifteq:"<<=",rshifteq:">>=",rrshifteq:">>>=",bandeq:"&=",boreq:"|=",bxoreq:"^="},numeric.mathfuns=["abs","acos","asin","atan","ceil","cos","exp","floor","log","round","sin","sqrt","tan","isNaN","isFinite"],numeric.mathfuns2=["atan2","pow","max","min"],numeric.ops1={neg:"-",not:"!",bnot:"~",clone:""},numeric.mapreducers={any:["if(xi) return true;","var accum = false;"],all:["if(!xi) return false;","var accum = true;"],sum:["accum += xi;","var accum = 0;"],prod:["accum *= xi;","var accum = 1;"],norm2Squared:["accum += xi*xi;","var accum = 0;"],norminf:["accum = max(accum,abs(xi));","var accum = 0, max = Math.max, abs = Math.abs;"],norm1:["accum += abs(xi)","var accum = 0, abs = Math.abs;"],sup:["accum = max(accum,xi);","var accum = -Infinity, max = Math.max;"],inf:["accum = min(accum,xi);","var accum = Infinity, min = Math.min;"]},(function(){var D,E;for(D=0;D<numeric.mathfuns2.length;++D)E=numeric.mathfuns2[D],numeric.ops2[E]=E;for(D in numeric.ops2)if(numeric.ops2.hasOwnProperty(D)){E=numeric.ops2[D];var F,J,$e="";numeric.myIndexOf.call(numeric.mathfuns2,D)===-1?(F=function(_t,lr,mr){return _t+" = "+lr+" "+E+" "+mr},J=numeric.opseq.hasOwnProperty(D+"eq")?function(_t,lr){return _t+" "+E+"= "+lr}:function(_t,lr){return _t+" = "+_t+" "+E+" "+lr}):($e="var "+E+" = Math."+E+`;\n`,F=function(_t,lr,mr){return _t+" = "+E+"("+lr+","+mr+")"},J=function(_t,lr){return _t+" = "+E+"("+_t+","+lr+")"}),numeric[D+"VV"]=numeric.pointwise2(["x[i]","y[i]"],F("ret[i]","x[i]","y[i]"),$e),numeric[D+"SV"]=numeric.pointwise2(["x","y[i]"],F("ret[i]","x","y[i]"),$e),numeric[D+"VS"]=numeric.pointwise2(["x[i]","y"],F("ret[i]","x[i]","y"),$e),numeric[D]=Function(`var n = arguments.length, i, x = arguments[0], y;\nvar VV = numeric.`+D+"VV, VS = numeric."+D+"VS, SV = numeric."+D+`SV;\nvar dim = numeric.dim;\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof x === "object") {\n      if(typeof y === "object") x = numeric._biforeach2(x,y,dim(x),0,VV);\n      else x = numeric._biforeach2(x,y,dim(x),0,VS);\n  } else if(typeof y === "object") x = numeric._biforeach2(x,y,dim(y),0,SV);\n  else `+J("x","y")+`\n}\nreturn x;\n`),numeric[E]=numeric[D],numeric[D+"eqV"]=numeric.pointwise2(["ret[i]","x[i]"],J("ret[i]","x[i]"),$e),numeric[D+"eqS"]=numeric.pointwise2(["ret[i]","x"],J("ret[i]","x"),$e),numeric[D+"eq"]=Function(`var n = arguments.length, i, x = arguments[0], y;\nvar V = numeric.`+D+"eqV, S = numeric."+D+`eqS\nvar s = numeric.dim(x);\nfor(i=1;i!==n;++i) { \n  y = arguments[i];\n  if(typeof y === "object") numeric._biforeach(x,y,s,0,V);\n  else numeric._biforeach(x,y,s,0,S);\n}\nreturn x;\n`)}for(D=0;D<numeric.mathfuns2.length;++D)E=numeric.mathfuns2[D],delete numeric.ops2[E];for(D=0;D<numeric.mathfuns.length;++D)E=numeric.mathfuns[D],numeric.ops1[E]=E;for(D in numeric.ops1)numeric.ops1.hasOwnProperty(D)&&($e="",E=numeric.ops1[D],numeric.myIndexOf.call(numeric.mathfuns,D)!==-1&&Math.hasOwnProperty(E)&&($e="var "+E+" = Math."+E+`;\n`),numeric[D+"eqV"]=numeric.pointwise2(["ret[i]"],"ret[i] = "+E+"(ret[i]);",$e),numeric[D+"eq"]=Function("x",\'if(typeof x !== "object") return \'+E+`x\nvar i;\nvar V = numeric.`+D+`eqV;\nvar s = numeric.dim(x);\nnumeric._foreach(x,s,0,V);\nreturn x;\n`),numeric[D+"V"]=numeric.pointwise2(["x[i]"],"ret[i] = "+E+"(x[i]);",$e),numeric[D]=Function("x",\'if(typeof x !== "object") return \'+E+`(x)\nvar i;\nvar V = numeric.`+D+`V;\nvar s = numeric.dim(x);\nreturn numeric._foreach2(x,s,0,V);\n`));for(D=0;D<numeric.mathfuns.length;++D)E=numeric.mathfuns[D],delete numeric.ops1[E];for(D in numeric.mapreducers)numeric.mapreducers.hasOwnProperty(D)&&(E=numeric.mapreducers[D],numeric[D+"V"]=numeric.mapreduce2(E[0],E[1]),numeric[D]=Function("x","s","k",E[1]+`if(typeof x !== "object") {    xi = x;\n`+E[0]+`;\n    return accum;\n}if(typeof s === "undefined") s = numeric.dim(x);\nif(typeof k === "undefined") k = 0;\nif(k === s.length-1) return numeric.`+D+`V(x);\nvar xi;\nvar n = x.length, i;\nfor(i=n-1;i!==-1;--i) {\n   xi = arguments.callee(x[i]);\n`+E[0]+`;\n}\nreturn accum;\n`))})(),numeric.truncVV=numeric.pointwise(["x[i]","y[i]"],"ret[i] = round(x[i]/y[i])*y[i];","var round = Math.round;"),numeric.truncVS=numeric.pointwise(["x[i]","y"],"ret[i] = round(x[i]/y)*y;","var round = Math.round;"),numeric.truncSV=numeric.pointwise(["x","y[i]"],"ret[i] = round(x/y[i])*y[i];","var round = Math.round;"),numeric.trunc=function(D,E){return typeof D=="object"?typeof E=="object"?numeric.truncVV(D,E):numeric.truncVS(D,E):typeof E=="object"?numeric.truncSV(D,E):Math.round(D/E)*E},numeric.inv=function(Hi){var E=numeric.dim(Hi),F=Math.abs,J=E[0],$e=E[1],_t=numeric.clone(Hi),lr,mr,Or=numeric.identity(J),Pr,dn,gi,qi,zi,Hi;for(qi=0;qi<$e;++qi){var Qi=-1,Gi=-1;for(gi=qi;gi!==J;++gi)zi=F(_t[gi][qi]),zi>Gi&&(Qi=gi,Gi=zi);for(mr=_t[Qi],_t[Qi]=_t[qi],_t[qi]=mr,dn=Or[Qi],Or[Qi]=Or[qi],Or[qi]=dn,Hi=mr[qi],zi=qi;zi!==$e;++zi)mr[zi]/=Hi;for(zi=$e-1;zi!==-1;--zi)dn[zi]/=Hi;for(gi=J-1;gi!==-1;--gi)if(gi!==qi){for(lr=_t[gi],Pr=Or[gi],Hi=lr[qi],zi=qi+1;zi!==$e;++zi)lr[zi]-=mr[zi]*Hi;for(zi=$e-1;zi>0;--zi)Pr[zi]-=dn[zi]*Hi,--zi,Pr[zi]-=dn[zi]*Hi;zi===0&&(Pr[0]-=dn[0]*Hi)}}return Or},numeric.det=function(D){var E=numeric.dim(D);if(E.length!==2||E[0]!==E[1])throw Error("numeric: det() only works on square matrices");var F=E[0],J=1,$e,_t,lr,mr=numeric.clone(D),Or,Pr,dn,gi,qi;for(_t=0;_t<F-1;_t++){for(lr=_t,$e=_t+1;$e<F;$e++)Math.abs(mr[$e][_t])>Math.abs(mr[lr][_t])&&(lr=$e);for(lr!==_t&&(gi=mr[lr],mr[lr]=mr[_t],mr[_t]=gi,J*=-1),Or=mr[_t],$e=_t+1;$e<F;$e++){for(Pr=mr[$e],dn=Pr[_t]/Or[_t],lr=_t+1;lr<F-1;lr+=2)qi=lr+1,Pr[lr]-=Or[lr]*dn,Pr[qi]-=Or[qi]*dn;lr!==F&&(Pr[lr]-=Or[lr]*dn)}if(Or[_t]===0)return 0;J*=Or[_t]}return J*mr[_t][_t]},numeric.transpose=function(D){var E,F,J=D.length,$e=D[0].length,_t=Array($e),lr,mr,Or;for(F=0;F<$e;F++)_t[F]=Array(J);for(E=J-1;E>=1;E-=2){for(mr=D[E],lr=D[E-1],F=$e-1;F>=1;--F)Or=_t[F],Or[E]=mr[F],Or[E-1]=lr[F],--F,Or=_t[F],Or[E]=mr[F],Or[E-1]=lr[F];F===0&&(Or=_t[0],Or[E]=mr[0],Or[E-1]=lr[0])}if(E===0){for(lr=D[0],F=$e-1;F>=1;--F)_t[F][0]=lr[F],--F,_t[F][0]=lr[F];F===0&&(_t[0][0]=lr[0])}return _t},numeric.negtranspose=function(D){var E,F,J=D.length,$e=D[0].length,_t=Array($e),lr,mr,Or;for(F=0;F<$e;F++)_t[F]=Array(J);for(E=J-1;E>=1;E-=2){for(mr=D[E],lr=D[E-1],F=$e-1;F>=1;--F)Or=_t[F],Or[E]=-mr[F],Or[E-1]=-lr[F],--F,Or=_t[F],Or[E]=-mr[F],Or[E-1]=-lr[F];F===0&&(Or=_t[0],Or[E]=-mr[0],Or[E-1]=-lr[0])}if(E===0){for(lr=D[0],F=$e-1;F>=1;--F)_t[F][0]=-lr[F],--F,_t[F][0]=-lr[F];F===0&&(_t[0][0]=-lr[0])}return _t},numeric._random=function D(E,F){var J,$e=E[F],_t=Array($e),lr;if(F===E.length-1){for(lr=Math.random,J=$e-1;J>=1;J-=2)_t[J]=lr(),_t[J-1]=lr();return J===0&&(_t[0]=lr()),_t}for(J=$e-1;J>=0;J--)_t[J]=D(E,F+1);return _t},numeric.random=function(D){return numeric._random(D,0)},numeric.norm2=function(D){return Math.sqrt(numeric.norm2Squared(D))},numeric.linspace=function(D,E,F){if(F===void 0&&(F=Math.max(Math.round(E-D)+1,1)),F<2)return F===1?[D]:[];var J,$e=Array(F);for(F--,J=F;J>=0;J--)$e[J]=(J*E+(F-J)*D)/F;return $e},numeric.getBlock=function(D,E,F){var J=numeric.dim(D);function $e(_t,lr){var mr,Or=E[lr],Pr=F[lr]-Or,dn=Array(Pr);if(lr===J.length-1){for(mr=Pr;mr>=0;mr--)dn[mr]=_t[mr+Or];return dn}for(mr=Pr;mr>=0;mr--)dn[mr]=$e(_t[mr+Or],lr+1);return dn}return $e(D,0)},numeric.setBlock=function(D,E,F,J){var $e=numeric.dim(D);function _t(lr,mr,Or){var Pr,dn=E[Or],gi=F[Or]-dn;if(Or===$e.length-1)for(Pr=gi;Pr>=0;Pr--)lr[Pr+dn]=mr[Pr];for(Pr=gi;Pr>=0;Pr--)_t(lr[Pr+dn],mr[Pr],Or+1)}return _t(D,J,0),D},numeric.getRange=function(D,E,F){var J=E.length,$e=F.length,_t,lr,mr=Array(J),Or,Pr;for(_t=J-1;_t!==-1;--_t)for(mr[_t]=Array($e),Or=mr[_t],Pr=D[E[_t]],lr=$e-1;lr!==-1;--lr)Or[lr]=Pr[F[lr]];return mr},numeric.blockMatrix=function(D){var E=numeric.dim(D);if(E.length<4)return numeric.blockMatrix([D]);var F=E[0],J=E[1],$e=0,_t=0,lr,mr,Or;for(lr=0;lr<F;++lr)$e+=D[lr][0].length;for(mr=0;mr<J;++mr)_t+=D[0][mr][0].length;var Pr=Array($e);for(lr=0;lr<$e;++lr)Pr[lr]=Array(_t);var dn=0,gi,qi,zi,Hi,Qi;for(lr=0;lr<F;++lr){for(gi=_t,mr=J-1;mr!==-1;--mr)for(Or=D[lr][mr],gi-=Or[0].length,zi=Or.length-1;zi!==-1;--zi)for(Qi=Or[zi],qi=Pr[dn+zi],Hi=Qi.length-1;Hi!==-1;--Hi)qi[gi+Hi]=Qi[Hi];dn+=D[lr][0].length}return Pr},numeric.tensor=function(D,E){if(typeof D=="number"||typeof E=="number")return numeric.mul(D,E);var F=numeric.dim(D),J=numeric.dim(E);if(F.length!==1||J.length!==1)throw Error("numeric: tensor product is only defined for vectors");var $e=F[0],_t=J[0],lr=Array($e),mr,Or,Pr,dn;for(Or=$e-1;Or>=0;Or--){for(mr=Array(_t),dn=D[Or],Pr=_t-1;Pr>=3;--Pr)mr[Pr]=dn*E[Pr],--Pr,mr[Pr]=dn*E[Pr],--Pr,mr[Pr]=dn*E[Pr],--Pr,mr[Pr]=dn*E[Pr];for(;Pr>=0;)mr[Pr]=dn*E[Pr],--Pr;lr[Or]=mr}return lr},numeric.T=function(D,E){this.x=D,this.y=E},numeric.t=function(D,E){return new numeric.T(D,E)},numeric.Tbinop=function(D,E,F,J,$e){if(numeric.indexOf,typeof $e!="string")for(var _t in $e="",numeric)numeric.hasOwnProperty(_t)&&(D.indexOf(_t)>=0||E.indexOf(_t)>=0||F.indexOf(_t)>=0||J.indexOf(_t)>=0)&&_t.length>1&&($e+="var "+_t+" = numeric."+_t+`;\n`);return Function(["y"],`var x = this;\nif(!(y instanceof numeric.T)) { y = new numeric.T(y); }\n`+$e+`\nif(x.y) {  if(y.y) {    return new numeric.T(`+J+`);\n  }\n  return new numeric.T(`+F+`);\n}\nif(y.y) {\n  return new numeric.T(`+E+`);\n}\nreturn new numeric.T(`+D+`);\n`)},numeric.T.prototype.add=numeric.Tbinop("add(x.x,y.x)","add(x.x,y.x),y.y","add(x.x,y.x),x.y","add(x.x,y.x),add(x.y,y.y)"),numeric.T.prototype.sub=numeric.Tbinop("sub(x.x,y.x)","sub(x.x,y.x),neg(y.y)","sub(x.x,y.x),x.y","sub(x.x,y.x),sub(x.y,y.y)"),numeric.T.prototype.mul=numeric.Tbinop("mul(x.x,y.x)","mul(x.x,y.x),mul(x.x,y.y)","mul(x.x,y.x),mul(x.y,y.x)","sub(mul(x.x,y.x),mul(x.y,y.y)),add(mul(x.x,y.y),mul(x.y,y.x))"),numeric.T.prototype.reciprocal=function(){var D=numeric.mul,E=numeric.div;if(this.y){var F=numeric.add(D(this.x,this.x),D(this.y,this.y));return new numeric.T(E(this.x,F),E(numeric.neg(this.y),F))}return new T(E(1,this.x))},numeric.T.prototype.div=function(D){if(D instanceof numeric.T||(D=new numeric.T(D)),D.y)return this.mul(D.reciprocal());var E=numeric.div;return this.y?new numeric.T(E(this.x,D.x),E(this.y,D.x)):new numeric.T(E(this.x,D.x))},numeric.T.prototype.dot=numeric.Tbinop("dot(x.x,y.x)","dot(x.x,y.x),dot(x.x,y.y)","dot(x.x,y.x),dot(x.y,y.x)","sub(dot(x.x,y.x),dot(x.y,y.y)),add(dot(x.x,y.y),dot(x.y,y.x))"),numeric.T.prototype.transpose=function(){var D=numeric.transpose,E=this.x,F=this.y;return F?new numeric.T(D(E),D(F)):new numeric.T(D(E))},numeric.T.prototype.transjugate=function(){var D=numeric.transpose,E=this.x,F=this.y;return F?new numeric.T(D(E),numeric.negtranspose(F)):new numeric.T(D(E))},numeric.Tunop=function(D,E,F){return typeof F!="string"&&(F=""),Function(`var x = this;\n`+F+`\nif(x.y) {  `+E+`;\n}\n`+D+`;\n`)},numeric.T.prototype.exp=numeric.Tunop("return new numeric.T(ex)","return new numeric.T(mul(cos(x.y),ex),mul(sin(x.y),ex))","var ex = numeric.exp(x.x), cos = numeric.cos, sin = numeric.sin, mul = numeric.mul;"),numeric.T.prototype.conj=numeric.Tunop("return new numeric.T(x.x);","return new numeric.T(x.x,numeric.neg(x.y));"),numeric.T.prototype.neg=numeric.Tunop("return new numeric.T(neg(x.x));","return new numeric.T(neg(x.x),neg(x.y));","var neg = numeric.neg;"),numeric.T.prototype.sin=numeric.Tunop("return new numeric.T(numeric.sin(x.x))","return x.exp().sub(x.neg().exp()).div(new numeric.T(0,2));"),numeric.T.prototype.cos=numeric.Tunop("return new numeric.T(numeric.cos(x.x))","return x.exp().add(x.neg().exp()).div(2);"),numeric.T.prototype.abs=numeric.Tunop("return new numeric.T(numeric.abs(x.x));","return new numeric.T(numeric.sqrt(numeric.add(mul(x.x,x.x),mul(x.y,x.y))));","var mul = numeric.mul;"),numeric.T.prototype.log=numeric.Tunop("return new numeric.T(numeric.log(x.x));",`var theta = new numeric.T(numeric.atan2(x.y,x.x)), r = x.abs();\nreturn new numeric.T(numeric.log(r.x),theta.x);`),numeric.T.prototype.norm2=numeric.Tunop("return numeric.norm2(x.x);",`var f = numeric.norm2Squared;\nreturn Math.sqrt(f(x.x)+f(x.y));`),numeric.T.prototype.inv=function(){var D=this;if(D.y===void 0)return new numeric.T(numeric.inv(D.x));var E=D.x.length,Hi,Qi,Gi,F=numeric.identity(E),J=numeric.rep([E,E],0),$e=numeric.clone(D.x),_t=numeric.clone(D.y),lr,mr,Or,Pr,dn,gi,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki,ea,Ji,ta,na;for(Hi=0;Hi<E;Hi++){for(Ki=$e[Hi][Hi],ea=_t[Hi][Hi],Zi=Ki*Ki+ea*ea,Gi=Hi,Qi=Hi+1;Qi<E;Qi++)Ki=$e[Qi][Hi],ea=_t[Qi][Hi],Xi=Ki*Ki+ea*ea,Xi>Zi&&(Gi=Qi,Zi=Xi);for(Gi!==Hi&&(na=$e[Hi],$e[Hi]=$e[Gi],$e[Gi]=na,na=_t[Hi],_t[Hi]=_t[Gi],_t[Gi]=na,na=F[Hi],F[Hi]=F[Gi],F[Gi]=na,na=J[Hi],J[Hi]=J[Gi],J[Gi]=na),lr=$e[Hi],mr=_t[Hi],dn=F[Hi],gi=J[Hi],Ki=lr[Hi],ea=mr[Hi],Qi=Hi+1;Qi<E;Qi++)Ji=lr[Qi],ta=mr[Qi],lr[Qi]=(Ji*Ki+ta*ea)/Zi,mr[Qi]=(ta*Ki-Ji*ea)/Zi;for(Qi=0;Qi<E;Qi++)Ji=dn[Qi],ta=gi[Qi],dn[Qi]=(Ji*Ki+ta*ea)/Zi,gi[Qi]=(ta*Ki-Ji*ea)/Zi;for(Qi=Hi+1;Qi<E;Qi++){for(Or=$e[Qi],Pr=_t[Qi],qi=F[Qi],zi=J[Qi],Ki=Or[Hi],ea=Pr[Hi],Gi=Hi+1;Gi<E;Gi++)Ji=lr[Gi],ta=mr[Gi],Or[Gi]-=Ji*Ki-ta*ea,Pr[Gi]-=ta*Ki+Ji*ea;for(Gi=0;Gi<E;Gi++)Ji=dn[Gi],ta=gi[Gi],qi[Gi]-=Ji*Ki-ta*ea,zi[Gi]-=ta*Ki+Ji*ea}}for(Hi=E-1;Hi>0;Hi--)for(dn=F[Hi],gi=J[Hi],Qi=Hi-1;Qi>=0;Qi--)for(qi=F[Qi],zi=J[Qi],Ki=$e[Qi][Hi],ea=_t[Qi][Hi],Gi=E-1;Gi>=0;Gi--)Ji=dn[Gi],ta=gi[Gi],qi[Gi]-=Ki*Ji-ea*ta,zi[Gi]-=Ki*ta+ea*Ji;return new numeric.T(F,J)},numeric.T.prototype.get=function(D){var E=this.x,F=this.y,J=0,$e,_t=D.length;if(F){for(;J<_t;)$e=D[J],E=E[$e],F=F[$e],J++;return new numeric.T(E,F)}for(;J<_t;)$e=D[J],E=E[$e],J++;return new numeric.T(E)},numeric.T.prototype.set=function(D,E){var F=this.x,J=this.y,$e=0,_t,lr=D.length,mr=E.x,Or=E.y;if(lr===0)return Or?this.y=Or:J&&(this.y=void 0),this.x=F,this;if(Or){for(J||(J=numeric.rep(numeric.dim(F),0),this.y=J);$e<lr-1;)_t=D[$e],F=F[_t],J=J[_t],$e++;return _t=D[$e],F[_t]=mr,J[_t]=Or,this}if(J){for(;$e<lr-1;)_t=D[$e],F=F[_t],J=J[_t],$e++;return _t=D[$e],F[_t]=mr,mr instanceof Array?J[_t]=numeric.rep(numeric.dim(mr),0):J[_t]=0,this}for(;$e<lr-1;)_t=D[$e],F=F[_t],$e++;return _t=D[$e],F[_t]=mr,this},numeric.T.prototype.getRows=function(D,E){var F=E-D+1,J,$e=Array(F),_t,lr=this.x,mr=this.y;for(J=D;J<=E;J++)$e[J-D]=lr[J];if(mr){for(_t=Array(F),J=D;J<=E;J++)_t[J-D]=mr[J];return new numeric.T($e,_t)}return new numeric.T($e)},numeric.T.prototype.setRows=function(D,E,F){var J,$e=this.x,_t=this.y,lr=F.x,mr=F.y;for(J=D;J<=E;J++)$e[J]=lr[J-D];if(mr)for(_t||(_t=numeric.rep(numeric.dim($e),0),this.y=_t),J=D;J<=E;J++)_t[J]=mr[J-D];else if(_t)for(J=D;J<=E;J++)_t[J]=numeric.rep([lr[J-D].length],0);return this},numeric.T.prototype.getRow=function(D){var E=this.x,F=this.y;return F?new numeric.T(E[D],F[D]):new numeric.T(E[D])},numeric.T.prototype.setRow=function(D,E){var F=this.x,J=this.y,$e=E.x,_t=E.y;return F[D]=$e,_t?(J||(J=numeric.rep(numeric.dim(F),0),this.y=J),J[D]=_t):J&&=numeric.rep([$e.length],0),this},numeric.T.prototype.getBlock=function(D,E){var F=this.x,J=this.y,$e=numeric.getBlock;return J?new numeric.T($e(F,D,E),$e(J,D,E)):new numeric.T($e(F,D,E))},numeric.T.prototype.setBlock=function(D,E,F){F instanceof numeric.T||(F=new numeric.T(F));var J=this.x,$e=this.y,_t=numeric.setBlock,lr=F.x,mr=F.y;if(mr)return $e||=(this.y=numeric.rep(numeric.dim(this),0),this.y),_t(J,D,E,lr),_t($e,D,E,mr),this;_t(J,D,E,lr),$e&&_t($e,D,E,numeric.rep(numeric.dim(lr),0))},numeric.T.rep=function(D,E){var F=numeric.T;E instanceof F||(E=new F(E));var J=E.x,$e=E.y,_t=numeric.rep;return $e?new F(_t(D,J),_t(D,$e)):new F(_t(D,J))},numeric.T.diag=function(D){D instanceof numeric.T||(D=new numeric.T(D));var E=D.x,F=D.y,J=numeric.diag;return F?new numeric.T(J(E),J(F)):new numeric.T(J(E))},numeric.T.eig=function(){if(this.y)throw Error("eig: not implemented for complex matrices.");return numeric.eig(this.x)},numeric.T.identity=function(D){return new numeric.T(numeric.identity(D))},numeric.T.prototype.getDiag=function(){var D=numeric,E=this.x,F=this.y;return F?new D.T(D.getDiag(E),D.getDiag(F)):new D.T(D.getDiag(E))},numeric.house=function(D){var E=numeric.clone(D),F=(D[0]>=0?1:-1)*numeric.norm2(D);E[0]+=F;var J=numeric.norm2(E);if(J===0)throw Error("eig: internal error");return numeric.div(E,J)},numeric.toUpperHessenberg=function(D){var E=numeric.dim(D);if(E.length!==2||E[0]!==E[1])throw Error("numeric: toUpperHessenberg() only works on square matrices");var F=E[0],J,$e,_t,lr,mr,Or=numeric.clone(D),Pr,dn,gi,qi,zi=numeric.identity(F),Hi;for($e=0;$e<F-2;$e++){for(lr=Array(F-$e-1),J=$e+1;J<F;J++)lr[J-$e-1]=Or[J][$e];if(numeric.norm2(lr)>0){for(mr=numeric.house(lr),Pr=numeric.getBlock(Or,[$e+1,$e],[F-1,F-1]),dn=numeric.tensor(mr,numeric.dot(mr,Pr)),J=$e+1;J<F;J++)for(gi=Or[J],qi=dn[J-$e-1],_t=$e;_t<F;_t++)gi[_t]-=2*qi[_t-$e];for(Pr=numeric.getBlock(Or,[0,$e+1],[F-1,F-1]),dn=numeric.tensor(numeric.dot(Pr,mr),mr),J=0;J<F;J++)for(gi=Or[J],qi=dn[J],_t=$e+1;_t<F;_t++)gi[_t]-=2*qi[_t-$e-1];for(Pr=Array(F-$e-1),J=$e+1;J<F;J++)Pr[J-$e-1]=zi[J];for(dn=numeric.tensor(mr,numeric.dot(mr,Pr)),J=$e+1;J<F;J++)for(Hi=zi[J],qi=dn[J-$e-1],_t=0;_t<F;_t++)Hi[_t]-=2*qi[_t]}}return{H:Or,Q:zi}},numeric.epsilon=2220446049250313e-31,numeric.QRFrancis=function(D,E){E===void 0&&(E=1e4),D=numeric.clone(D),numeric.clone(D);var F=numeric.dim(D)[0],J,$e,_t,lr,mr,Or,Pr,dn,gi,qi=numeric.identity(F),zi,Hi,Qi,Gi,Zi,Xi,Ki,ea,Ji;if(F<3)return{Q:qi,B:[[0,F-1]]};var ta=numeric.epsilon;for(Ji=0;Ji<E;Ji++){for(Ki=0;Ki<F-1;Ki++)if(Math.abs(D[Ki+1][Ki])<ta*(Math.abs(D[Ki][Ki])+Math.abs(D[Ki+1][Ki+1]))){var na=numeric.QRFrancis(numeric.getBlock(D,[0,0],[Ki,Ki]),E),ra=numeric.QRFrancis(numeric.getBlock(D,[Ki+1,Ki+1],[F-1,F-1]),E);for(Qi=Array(Ki+1),Xi=0;Xi<=Ki;Xi++)Qi[Xi]=qi[Xi];for(Gi=numeric.dot(na.Q,Qi),Xi=0;Xi<=Ki;Xi++)qi[Xi]=Gi[Xi];for(Qi=Array(F-Ki-1),Xi=Ki+1;Xi<F;Xi++)Qi[Xi-Ki-1]=qi[Xi];for(Gi=numeric.dot(ra.Q,Qi),Xi=Ki+1;Xi<F;Xi++)qi[Xi]=Gi[Xi-Ki-1];return{Q:qi,B:na.B.concat(numeric.add(ra.B,Ki+1))}}if(_t=D[F-2][F-2],lr=D[F-2][F-1],mr=D[F-1][F-2],Or=D[F-1][F-1],dn=_t+Or,Pr=_t*Or-lr*mr,gi=numeric.getBlock(D,[0,0],[2,2]),dn*dn>=4*Pr){var ia=.5*(dn+Math.sqrt(dn*dn-4*Pr)),oa=.5*(dn-Math.sqrt(dn*dn-4*Pr));gi=numeric.add(numeric.sub(numeric.dot(gi,gi),numeric.mul(gi,ia+oa)),numeric.diag(numeric.rep([3],ia*oa)))}else gi=numeric.add(numeric.sub(numeric.dot(gi,gi),numeric.mul(gi,dn)),numeric.diag(numeric.rep([3],Pr)));for(J=[gi[0][0],gi[1][0],gi[2][0]],$e=numeric.house(J),Qi=[D[0],D[1],D[2]],Gi=numeric.tensor($e,numeric.dot($e,Qi)),Xi=0;Xi<3;Xi++)for(Hi=D[Xi],Zi=Gi[Xi],ea=0;ea<F;ea++)Hi[ea]-=2*Zi[ea];for(Qi=numeric.getBlock(D,[0,0],[F-1,2]),Gi=numeric.tensor(numeric.dot(Qi,$e),$e),Xi=0;Xi<F;Xi++)for(Hi=D[Xi],Zi=Gi[Xi],ea=0;ea<3;ea++)Hi[ea]-=2*Zi[ea];for(Qi=[qi[0],qi[1],qi[2]],Gi=numeric.tensor($e,numeric.dot($e,Qi)),Xi=0;Xi<3;Xi++)for(zi=qi[Xi],Zi=Gi[Xi],ea=0;ea<F;ea++)zi[ea]-=2*Zi[ea];var ua;for(Ki=0;Ki<F-2;Ki++){for(ea=Ki;ea<=Ki+1;ea++)if(Math.abs(D[ea+1][ea])<ta*(Math.abs(D[ea][ea])+Math.abs(D[ea+1][ea+1]))){var na=numeric.QRFrancis(numeric.getBlock(D,[0,0],[ea,ea]),E),ra=numeric.QRFrancis(numeric.getBlock(D,[ea+1,ea+1],[F-1,F-1]),E);for(Qi=Array(ea+1),Xi=0;Xi<=ea;Xi++)Qi[Xi]=qi[Xi];for(Gi=numeric.dot(na.Q,Qi),Xi=0;Xi<=ea;Xi++)qi[Xi]=Gi[Xi];for(Qi=Array(F-ea-1),Xi=ea+1;Xi<F;Xi++)Qi[Xi-ea-1]=qi[Xi];for(Gi=numeric.dot(ra.Q,Qi),Xi=ea+1;Xi<F;Xi++)qi[Xi]=Gi[Xi-ea-1];return{Q:qi,B:na.B.concat(numeric.add(ra.B,ea+1))}}for(ua=Math.min(F-1,Ki+3),J=Array(ua-Ki),Xi=Ki+1;Xi<=ua;Xi++)J[Xi-Ki-1]=D[Xi][Ki];for($e=numeric.house(J),Qi=numeric.getBlock(D,[Ki+1,Ki],[ua,F-1]),Gi=numeric.tensor($e,numeric.dot($e,Qi)),Xi=Ki+1;Xi<=ua;Xi++)for(Hi=D[Xi],Zi=Gi[Xi-Ki-1],ea=Ki;ea<F;ea++)Hi[ea]-=2*Zi[ea-Ki];for(Qi=numeric.getBlock(D,[0,Ki+1],[F-1,ua]),Gi=numeric.tensor(numeric.dot(Qi,$e),$e),Xi=0;Xi<F;Xi++)for(Hi=D[Xi],Zi=Gi[Xi],ea=Ki+1;ea<=ua;ea++)Hi[ea]-=2*Zi[ea-Ki-1];for(Qi=Array(ua-Ki),Xi=Ki+1;Xi<=ua;Xi++)Qi[Xi-Ki-1]=qi[Xi];for(Gi=numeric.tensor($e,numeric.dot($e,Qi)),Xi=Ki+1;Xi<=ua;Xi++)for(zi=qi[Xi],Zi=Gi[Xi-Ki-1],ea=0;ea<F;ea++)zi[ea]-=2*Zi[ea]}}throw Error("numeric: eigenvalue iteration does not converge -- increase maxiter?")},numeric.eig=function(D,E){var F=numeric.toUpperHessenberg(D),J=numeric.QRFrancis(F.H,E),$e=numeric.T,sa=D.length,_t,lr,mr=J.B,Or=numeric.dot(J.Q,numeric.dot(F.H,numeric.transpose(J.Q))),Pr=new $e(numeric.dot(J.Q,F.Q)),dn,gi=mr.length,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki,ea,Ji,ta,na,ra,ia,oa=Math.sqrt;for(lr=0;lr<gi;lr++)if(_t=mr[lr][0],_t!==mr[lr][1]){if(qi=_t+1,zi=Or[_t][_t],Hi=Or[_t][qi],Qi=Or[qi][_t],Gi=Or[qi][qi],Hi===0&&Qi===0)continue;Zi=-zi-Gi,Xi=zi*Gi-Hi*Qi,Ki=Zi*Zi-4*Xi,Ki>=0?(ea=Zi<0?-.5*(Zi-oa(Ki)):-.5*(Zi+oa(Ki)),ra=(zi-ea)*(zi-ea)+Hi*Hi,ia=Qi*Qi+(Gi-ea)*(Gi-ea),ra>ia?(ra=oa(ra),ta=(zi-ea)/ra,na=Hi/ra):(ia=oa(ia),ta=Qi/ia,na=(Gi-ea)/ia),dn=new $e([[na,-ta],[ta,na]]),Pr.setRows(_t,qi,dn.dot(Pr.getRows(_t,qi)))):(ea=-.5*Zi,Ji=.5*oa(-Ki),ra=(zi-ea)*(zi-ea)+Hi*Hi,ia=Qi*Qi+(Gi-ea)*(Gi-ea),ra>ia?(ra=oa(ra+Ji*Ji),ta=(zi-ea)/ra,na=Hi/ra,ea=0,Ji/=ra):(ia=oa(ia+Ji*Ji),ta=Qi/ia,na=(Gi-ea)/ia,ea=Ji/ia,Ji=0),dn=new $e([[na,-ta],[ta,na]],[[ea,Ji],[Ji,-ea]]),Pr.setRows(_t,qi,dn.dot(Pr.getRows(_t,qi))))}var ua=Pr.dot(D).dot(Pr.transjugate()),sa=D.length,aa=numeric.T.identity(sa);for(qi=0;qi<sa;qi++)if(qi>0)for(lr=qi-1;lr>=0;lr--){var pa=ua.get([lr,lr]),ma=ua.get([qi,qi]);if(numeric.neq(pa.x,ma.x)||numeric.neq(pa.y,ma.y))ea=ua.getRow(lr).getBlock([lr],[qi-1]),Ji=aa.getRow(qi).getBlock([lr],[qi-1]),aa.set([qi,lr],ua.get([lr,qi]).neg().sub(ea.dot(Ji)).div(pa.sub(ma)));else{aa.setRow(qi,aa.getRow(lr));continue}}for(qi=0;qi<sa;qi++)ea=aa.getRow(qi),aa.setRow(qi,ea.div(ea.norm2()));return aa=aa.transpose(),aa=Pr.transjugate().dot(aa),{lambda:ua.getDiag(),E:aa}},numeric.ccsSparse=function(D){var E=D.length,lr,F,J,$e,_t=[];for(J=E-1;J!==-1;--J)for($e in F=D[J],F){for($e=parseInt($e);$e>=_t.length;)_t[_t.length]=0;F[$e]!==0&&_t[$e]++}var lr=_t.length,mr=Array(lr+1);for(mr[0]=0,J=0;J<lr;++J)mr[J+1]=mr[J]+_t[J];var Or=Array(mr[lr]),Pr=Array(mr[lr]);for(J=E-1;J!==-1;--J)for($e in F=D[J],F)F[$e]!==0&&(_t[$e]--,Or[mr[$e]+_t[$e]]=J,Pr[mr[$e]+_t[$e]]=F[$e]);return[mr,Or,Pr]},numeric.ccsFull=function(D){var E=D[0],F=D[1],J=D[2],$e=numeric.ccsDim(D),_t=$e[0],lr=$e[1],mr,Or,Pr,dn,gi=numeric.rep([_t,lr],0);for(mr=0;mr<lr;mr++)for(Pr=E[mr],dn=E[mr+1],Or=Pr;Or<dn;++Or)gi[F[Or]][mr]=J[Or];return gi},numeric.ccsTSolve=function(D,E,F,J,$e){var _t=D[0],lr=D[1],mr=D[2],Or=_t.length-1,Pr=Math.max,dn=0;J===void 0&&(F=numeric.rep([Or],0)),J===void 0&&(J=numeric.linspace(0,F.length-1)),$e===void 0&&($e=[]);function gi(Ki){var ea;if(F[Ki]===0){for(F[Ki]=1,ea=_t[Ki];ea<_t[Ki+1];++ea)gi(lr[ea]);$e[dn]=Ki,++dn}}var qi,zi,Hi,Qi,Gi,Zi,Xi;for(qi=J.length-1;qi!==-1;--qi)gi(J[qi]);for($e.length=dn,qi=$e.length-1;qi!==-1;--qi)F[$e[qi]]=0;for(qi=J.length-1;qi!==-1;--qi)zi=J[qi],F[zi]=E[zi];for(qi=$e.length-1;qi!==-1;--qi){for(zi=$e[qi],Hi=_t[zi],Qi=Pr(_t[zi+1],Hi),Gi=Hi;Gi!==Qi;++Gi)if(lr[Gi]===zi){F[zi]/=mr[Gi];break}for(Xi=F[zi],Gi=Hi;Gi!==Qi;++Gi)Zi=lr[Gi],Zi!==zi&&(F[Zi]-=Xi*mr[Gi])}return F},numeric.ccsDFS=function(D){this.k=Array(D),this.k1=Array(D),this.j=Array(D)},numeric.ccsDFS.prototype.dfs=function(D,E,F,J,$e,_t){var lr=0,mr,Or=$e.length,Pr=this.k,dn=this.k1,gi=this.j,qi,zi;if(J[D]===0)for(J[D]=1,gi[0]=D,Pr[0]=qi=E[D],dn[0]=zi=E[D+1];;)if(qi>=zi){if($e[Or]=gi[lr],lr===0)return;++Or,--lr,qi=Pr[lr],zi=dn[lr]}else mr=_t[F[qi]],J[mr]===0?(J[mr]=1,Pr[lr]=qi,++lr,gi[lr]=mr,qi=E[mr],dn[lr]=zi=E[mr+1]):++qi},numeric.ccsLPSolve=function(D,E,F,J,$e,_t,lr){var mr=D[0],Or=D[1],Pr=D[2];mr.length-1;var dn=E[0],gi=E[1],qi=E[2],zi,Hi=dn[$e],Qi=dn[$e+1],Gi,Zi,Xi,Ki,ea,Ji;for(J.length=0,zi=Hi;zi<Qi;++zi)lr.dfs(_t[gi[zi]],mr,Or,F,J,_t);for(zi=J.length-1;zi!==-1;--zi)F[J[zi]]=0;for(zi=Hi;zi!==Qi;++zi)Gi=_t[gi[zi]],F[Gi]=qi[zi];for(zi=J.length-1;zi!==-1;--zi){for(Gi=J[zi],Zi=mr[Gi],Xi=mr[Gi+1],Ki=Zi;Ki<Xi;++Ki)if(_t[Or[Ki]]===Gi){F[Gi]/=Pr[Ki];break}for(Ji=F[Gi],Ki=Zi;Ki<Xi;++Ki)ea=_t[Or[Ki]],ea!==Gi&&(F[ea]-=Ji*Pr[Ki])}return F},numeric.ccsLUP1=function(D,E){var F=D[0].length-1,J=[numeric.rep([F+1],0),[],[]],$e=[numeric.rep([F+1],0),[],[]],_t=J[0],lr=J[1],mr=J[2],Or=$e[0],Pr=$e[1],dn=$e[2],gi=numeric.rep([F],0),qi=numeric.rep([F],0),zi,Hi,Qi,Gi,Zi,Xi,Ki,ea=numeric.ccsLPSolve,Ji=Math.abs,ta=numeric.linspace(0,F-1),na=numeric.linspace(0,F-1),ra=new numeric.ccsDFS(F);for(E===void 0&&(E=1),zi=0;zi<F;++zi){for(ea(J,D,gi,qi,zi,na,ra),Gi=-1,Zi=-1,Hi=qi.length-1;Hi!==-1;--Hi)Qi=qi[Hi],!(Qi<=zi)&&(Xi=Ji(gi[Qi]),Xi>Gi&&(Zi=Qi,Gi=Xi));for(Ji(gi[zi])<E*Gi&&(Hi=ta[zi],Gi=ta[Zi],ta[zi]=Gi,na[Gi]=zi,ta[Zi]=Hi,na[Hi]=Zi,Gi=gi[zi],gi[zi]=gi[Zi],gi[Zi]=Gi),Gi=_t[zi],Zi=Or[zi],Ki=gi[zi],lr[Gi]=ta[zi],mr[Gi]=1,++Gi,Hi=qi.length-1;Hi!==-1;--Hi)Qi=qi[Hi],Xi=gi[Qi],qi[Hi]=0,gi[Qi]=0,Qi<=zi?(Pr[Zi]=Qi,dn[Zi]=Xi,++Zi):(lr[Gi]=ta[Qi],mr[Gi]=Xi/Ki,++Gi);_t[zi+1]=Gi,Or[zi+1]=Zi}for(Hi=lr.length-1;Hi!==-1;--Hi)lr[Hi]=na[lr[Hi]];return{L:J,U:$e,P:ta,Pinv:na}},numeric.ccsDFS0=function(D){this.k=Array(D),this.k1=Array(D),this.j=Array(D)},numeric.ccsDFS0.prototype.dfs=function(D,E,F,J,$e,_t,lr){var mr=0,Or,Pr=$e.length,dn=this.k,gi=this.k1,qi=this.j,zi,Hi;if(J[D]===0)for(J[D]=1,qi[0]=D,dn[0]=zi=E[_t[D]],gi[0]=Hi=E[_t[D]+1];;){if(isNaN(zi))throw Error("Ow!");if(zi>=Hi){if($e[Pr]=_t[qi[mr]],mr===0)return;++Pr,--mr,zi=dn[mr],Hi=gi[mr]}else Or=F[zi],J[Or]===0?(J[Or]=1,dn[mr]=zi,++mr,qi[mr]=Or,Or=_t[Or],zi=E[Or],gi[mr]=Hi=E[Or+1]):++zi}},numeric.ccsLPSolve0=function(D,E,F,J,$e,_t,lr,mr){var Or=D[0],Pr=D[1],dn=D[2];Or.length-1;var gi=E[0],qi=E[1],zi=E[2],Hi,Qi=gi[$e],Gi=gi[$e+1],Zi,Xi,Ki,ea,Ji,ta;for(J.length=0,Hi=Qi;Hi<Gi;++Hi)mr.dfs(qi[Hi],Or,Pr,F,J,_t,lr);for(Hi=J.length-1;Hi!==-1;--Hi)Zi=J[Hi],F[lr[Zi]]=0;for(Hi=Qi;Hi!==Gi;++Hi)Zi=qi[Hi],F[Zi]=zi[Hi];for(Hi=J.length-1;Hi!==-1;--Hi){for(Zi=J[Hi],Ji=lr[Zi],Xi=Or[Zi],Ki=Or[Zi+1],ea=Xi;ea<Ki;++ea)if(Pr[ea]===Ji){F[Ji]/=dn[ea];break}for(ta=F[Ji],ea=Xi;ea<Ki;++ea)F[Pr[ea]]-=ta*dn[ea];F[Ji]=ta}},numeric.ccsLUP0=function(D,E){var F=D[0].length-1,J=[numeric.rep([F+1],0),[],[]],$e=[numeric.rep([F+1],0),[],[]],_t=J[0],lr=J[1],mr=J[2],Or=$e[0],Pr=$e[1],dn=$e[2],gi=numeric.rep([F],0),qi=numeric.rep([F],0),zi,Hi,Qi,Gi,Zi,Xi,Ki,ea=numeric.ccsLPSolve0,Ji=Math.abs,ta=numeric.linspace(0,F-1),na=numeric.linspace(0,F-1),ra=new numeric.ccsDFS0(F);for(E===void 0&&(E=1),zi=0;zi<F;++zi){for(ea(J,D,gi,qi,zi,na,ta,ra),Gi=-1,Zi=-1,Hi=qi.length-1;Hi!==-1;--Hi)Qi=qi[Hi],!(Qi<=zi)&&(Xi=Ji(gi[ta[Qi]]),Xi>Gi&&(Zi=Qi,Gi=Xi));for(Ji(gi[ta[zi]])<E*Gi&&(Hi=ta[zi],Gi=ta[Zi],ta[zi]=Gi,na[Gi]=zi,ta[Zi]=Hi,na[Hi]=Zi),Gi=_t[zi],Zi=Or[zi],Ki=gi[ta[zi]],lr[Gi]=ta[zi],mr[Gi]=1,++Gi,Hi=qi.length-1;Hi!==-1;--Hi)Qi=qi[Hi],Xi=gi[ta[Qi]],qi[Hi]=0,gi[ta[Qi]]=0,Qi<=zi?(Pr[Zi]=Qi,dn[Zi]=Xi,++Zi):(lr[Gi]=ta[Qi],mr[Gi]=Xi/Ki,++Gi);_t[zi+1]=Gi,Or[zi+1]=Zi}for(Hi=lr.length-1;Hi!==-1;--Hi)lr[Hi]=na[lr[Hi]];return{L:J,U:$e,P:ta,Pinv:na}},numeric.ccsLUP=numeric.ccsLUP0,numeric.ccsDim=function(D){return[numeric.sup(D[1])+1,D[0].length-1]},numeric.ccsGetBlock=function(D,E,F){var J=numeric.ccsDim(D),$e=J[0],_t=J[1];E===void 0?E=numeric.linspace(0,$e-1):typeof E=="number"&&(E=[E]),F===void 0?F=numeric.linspace(0,_t-1):typeof F=="number"&&(F=[F]);var lr,mr=E.length,Or,Pr=F.length,dn,gi,qi,zi=numeric.rep([_t],0),Hi=[],Qi=[],Gi=[zi,Hi,Qi],Zi=D[0],Xi=D[1],Ki=D[2],ea=numeric.rep([$e],0),Ji=0,ta=numeric.rep([$e],0);for(Or=0;Or<Pr;++Or){gi=F[Or];var na=Zi[gi],ra=Zi[gi+1];for(lr=na;lr<ra;++lr)dn=Xi[lr],ta[dn]=1,ea[dn]=Ki[lr];for(lr=0;lr<mr;++lr)qi=E[lr],ta[qi]&&(Hi[Ji]=lr,Qi[Ji]=ea[E[lr]],++Ji);for(lr=na;lr<ra;++lr)dn=Xi[lr],ta[dn]=0;zi[Or+1]=Ji}return Gi},numeric.ccsDot=function(D,E){var F=D[0],J=D[1],$e=D[2],_t=E[0],lr=E[1],mr=E[2],Or=numeric.ccsDim(D),Pr=numeric.ccsDim(E),dn=Or[0];Or[1];var gi=Pr[1],qi=numeric.rep([dn],0),zi=numeric.rep([dn],0),Hi=Array(dn),Qi=numeric.rep([gi],0),Gi=[],Zi=[],Xi=[Qi,Gi,Zi],Ki,ea,Ji,ta,na,ra,ia,oa,ua,sa,aa;for(Ji=0;Ji!==gi;++Ji){for(ta=_t[Ji],na=_t[Ji+1],ua=0,ea=ta;ea<na;++ea)for(sa=lr[ea],aa=mr[ea],ra=F[sa],ia=F[sa+1],Ki=ra;Ki<ia;++Ki)oa=J[Ki],zi[oa]===0&&(Hi[ua]=oa,zi[oa]=1,ua+=1),qi[oa]=qi[oa]+$e[Ki]*aa;for(ta=Qi[Ji],na=ta+ua,Qi[Ji+1]=na,ea=ua-1;ea!==-1;--ea)aa=ta+ea,Ki=Hi[ea],Gi[aa]=Ki,Zi[aa]=qi[Ki],zi[Ki]=0,qi[Ki]=0;Qi[Ji+1]=Qi[Ji]+ua}return Xi},numeric.ccsLUPSolve=function(D,E){var F=D.L,J=D.U;D.P;var $e=E[0],_t=!1;typeof $e!="object"&&(E=[[0,E.length],numeric.linspace(0,E.length-1),E],$e=E[0],_t=!0);var lr=E[1],mr=E[2],Or=F[0].length-1,Pr=$e.length-1,dn=numeric.rep([Or],0),gi=Array(Or),qi=numeric.rep([Or],0),zi=Array(Or),Hi=numeric.rep([Pr+1],0),Qi=[],Gi=[],Zi=numeric.ccsTSolve,Xi,Ki,ea,Ji,ta,na,ra=0;for(Xi=0;Xi<Pr;++Xi){for(ta=0,ea=$e[Xi],Ji=$e[Xi+1],Ki=ea;Ki<Ji;++Ki)na=D.Pinv[lr[Ki]],zi[ta]=na,qi[na]=mr[Ki],++ta;for(zi.length=ta,Zi(F,qi,dn,zi,gi),Ki=zi.length-1;Ki!==-1;--Ki)qi[zi[Ki]]=0;if(Zi(J,dn,qi,gi,zi),_t)return qi;for(Ki=gi.length-1;Ki!==-1;--Ki)dn[gi[Ki]]=0;for(Ki=zi.length-1;Ki!==-1;--Ki)na=zi[Ki],Qi[ra]=na,Gi[ra]=qi[na],qi[na]=0,++ra;Hi[Xi+1]=ra}return[Hi,Qi,Gi]},numeric.ccsbinop=function(D,E){return E===void 0&&(E=""),Function("X","Y",`var Xi = X[0], Xj = X[1], Xv = X[2];\nvar Yi = Y[0], Yj = Y[1], Yv = Y[2];\nvar n = Xi.length-1,m = Math.max(numeric.sup(Xj),numeric.sup(Yj))+1;\nvar Zi = numeric.rep([n+1],0), Zj = [], Zv = [];\nvar x = numeric.rep([m],0),y = numeric.rep([m],0);\nvar xk,yk,zk;\nvar i,j,j0,j1,k,p=0;\n`+E+`for(i=0;i<n;++i) {\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Xj[j];\n    x[k] = 1;\n    Zj[p] = k;\n    ++p;\n  }\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Yj[j];\n    y[k] = Yv[j];\n    if(x[k] === 0) {\n      Zj[p] = k;\n      ++p;\n    }\n  }\n  Zi[i+1] = p;\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = Xv[j];\n  j0 = Zi[i]; j1 = Zi[i+1];\n  for(j=j0;j!==j1;++j) {\n    k = Zj[j];\n    xk = x[k];\n    yk = y[k];\n`+D+`\n    Zv[j] = zk;\n  }\n  j0 = Xi[i]; j1 = Xi[i+1];\n  for(j=j0;j!==j1;++j) x[Xj[j]] = 0;\n  j0 = Yi[i]; j1 = Yi[i+1];\n  for(j=j0;j!==j1;++j) y[Yj[j]] = 0;\n}\nreturn [Zi,Zj,Zv];`)},(function(){var k,A,B,C;for(k in numeric.ops2)A=isFinite(eval("1"+numeric.ops2[k]+"0"))?"[Y[0],Y[1],numeric."+k+"(X,Y[2])]":"NaN",B=isFinite(eval("0"+numeric.ops2[k]+"1"))?"[X[0],X[1],numeric."+k+"(X[2],Y)]":"NaN",C=isFinite(eval("1"+numeric.ops2[k]+"0"))&&isFinite(eval("0"+numeric.ops2[k]+"1"))?"numeric.ccs"+k+"MM(X,Y)":"NaN",numeric["ccs"+k+"MM"]=numeric.ccsbinop("zk = xk "+numeric.ops2[k]+"yk;"),numeric["ccs"+k]=Function("X","Y",\'if(typeof X === "number") return \'+A+`;\nif(typeof Y === "number") return `+B+`;\nreturn `+C+`;\n`)})(),numeric.ccsScatter=function(D){var E=D[0],F=D[1],J=D[2],$e=numeric.sup(F)+1,_t=E.length,lr=numeric.rep([$e],0),mr=Array(_t),Or=Array(_t),Pr=numeric.rep([$e],0),dn;for(dn=0;dn<_t;++dn)Pr[F[dn]]++;for(dn=0;dn<$e;++dn)lr[dn+1]=lr[dn]+Pr[dn];var gi=lr.slice(0),qi,zi;for(dn=0;dn<_t;++dn)zi=F[dn],qi=gi[zi],mr[qi]=E[dn],Or[qi]=J[dn],gi[zi]=gi[zi]+1;return[lr,mr,Or]},numeric.ccsGather=function(D){var E=D[0],F=D[1],J=D[2],$e=E.length-1,_t=F.length,lr=Array(_t),mr=Array(_t),Or=Array(_t),Pr,dn,gi,qi,zi=0;for(Pr=0;Pr<$e;++Pr)for(gi=E[Pr],qi=E[Pr+1],dn=gi;dn!==qi;++dn)mr[zi]=Pr,lr[zi]=F[dn],Or[zi]=J[dn],++zi;return[lr,mr,Or]},numeric.sdim=function D(E,F,J){if(F===void 0&&(F=[]),typeof E!="object")return F;for(var $e in J===void 0&&(J=0),J in F||(F[J]=0),E.length>F[J]&&(F[J]=E.length),E)E.hasOwnProperty($e)&&D(E[$e],F,J+1);return F},numeric.sclone=function D(E,F,J){F===void 0&&(F=0),J===void 0&&(J=numeric.sdim(E).length);var $e,_t=Array(E.length);if(F===J-1){for($e in E)E.hasOwnProperty($e)&&(_t[$e]=E[$e]);return _t}for($e in E)E.hasOwnProperty($e)&&(_t[$e]=D(E[$e],F+1,J));return _t},numeric.sdiag=function(D){var E=D.length,F,J=Array(E),$e;for(F=E-1;F>=1;F-=2)$e=F-1,J[F]=[],J[F][F]=D[F],J[$e]=[],J[$e][$e]=D[$e];return F===0&&(J[0]=[],J[0][0]=D[F]),J},numeric.sidentity=function(D){return numeric.sdiag(numeric.rep([D],1))},numeric.stranspose=function(D){var E=[];D.length;var F,J,$e;for(F in D)if(D.hasOwnProperty(F))for(J in $e=D[F],$e)$e.hasOwnProperty(J)&&(typeof E[J]!="object"&&(E[J]=[]),E[J][F]=$e[J]);return E},numeric.sLUP=function(D,E){throw Error("The function numeric.sLUP had a bug in it and has been removed. Please use the new numeric.ccsLUP function instead.")},numeric.sdotMM=function(D,E){var F=D.length;E.length;var J=numeric.stranspose(E),$e=J.length,_t,lr,mr,Or,Pr,dn,gi=Array(F),qi;for(mr=F-1;mr>=0;mr--){for(qi=[],_t=D[mr],Pr=$e-1;Pr>=0;Pr--){for(Or in dn=0,lr=J[Pr],_t)_t.hasOwnProperty(Or)&&Or in lr&&(dn+=_t[Or]*lr[Or]);dn&&(qi[Pr]=dn)}gi[mr]=qi}return gi},numeric.sdotMV=function(D,E){var F=D.length,J,$e,_t,lr=Array(F),mr;for($e=F-1;$e>=0;$e--){for(_t in J=D[$e],mr=0,J)J.hasOwnProperty(_t)&&E[_t]&&(mr+=J[_t]*E[_t]);mr&&(lr[$e]=mr)}return lr},numeric.sdotVM=function(D,E){var F,J,$e,_t,lr=[];for(F in D)if(D.hasOwnProperty(F))for(J in $e=E[F],_t=D[F],$e)$e.hasOwnProperty(J)&&(lr[J]||(lr[J]=0),lr[J]+=_t*$e[J]);return lr},numeric.sdotVV=function(D,E){var F,J=0;for(F in D)D[F]&&E[F]&&(J+=D[F]*E[F]);return J},numeric.sdot=function(D,E){var F=numeric.sdim(D).length,J=numeric.sdim(E).length;switch(F*1e3+J){case 0:return D*E;case 1001:return numeric.sdotVV(D,E);case 2001:return numeric.sdotMV(D,E);case 1002:return numeric.sdotVM(D,E);case 2002:return numeric.sdotMM(D,E);default:throw Error("numeric.sdot not implemented for tensors of order "+F+" and "+J)}},numeric.sscatter=function(D){var E=D[0].length,F,J,$e,_t=D.length,lr=[],mr;for(J=E-1;J>=0;--J)if(D[_t-1][J]){for(mr=lr,$e=0;$e<_t-2;$e++)F=D[$e][J],mr[F]||(mr[F]=[]),mr=mr[F];mr[D[$e][J]]=D[$e+1][J]}return lr},numeric.sgather=function D(E,F,J){F===void 0&&(F=[]),J===void 0&&(J=[]);var $e=J.length,_t,lr;for(_t in E)if(E.hasOwnProperty(_t))if(J[$e]=parseInt(_t),lr=E[_t],typeof lr=="number"){if(lr){if(F.length===0)for(_t=$e+1;_t>=0;--_t)F[_t]=[];for(_t=$e;_t>=0;--_t)F[_t].push(J[_t]);F[$e+1].push(lr)}}else D(lr,F,J);return J.length>$e&&J.pop(),F},numeric.cLU=function(D){var E=D[0],F=D[1],J=D[2],ra=E.length,$e=0,_t,lr,mr,Or,Pr,dn;for(_t=0;_t<ra;_t++)E[_t]>$e&&($e=E[_t]);$e++;var gi=Array($e),qi=Array($e),zi=numeric.rep([$e],1/0),Hi=numeric.rep([$e],-1/0),Xi,Ki,Qi;for(mr=0;mr<ra;mr++)_t=E[mr],lr=F[mr],lr<zi[_t]&&(zi[_t]=lr),lr>Hi[_t]&&(Hi[_t]=lr);for(_t=0;_t<$e-1;_t++)Hi[_t]>Hi[_t+1]&&(Hi[_t+1]=Hi[_t]);for(_t=$e-1;_t>=1;_t--)zi[_t]<zi[_t-1]&&(zi[_t-1]=zi[_t]);var Gi=0,Zi=0;for(_t=0;_t<$e;_t++)qi[_t]=numeric.rep([Hi[_t]-zi[_t]+1],0),gi[_t]=numeric.rep([_t-zi[_t]],0),Gi+=_t-zi[_t]+1,Zi+=Hi[_t]-_t+1;for(mr=0;mr<ra;mr++)_t=E[mr],qi[_t][F[mr]-zi[_t]]=J[mr];for(_t=0;_t<$e-1;_t++)for(Or=_t-zi[_t],Xi=qi[_t],lr=_t+1;zi[lr]<=_t&&lr<$e;lr++)if(Pr=_t-zi[lr],dn=Hi[_t]-_t,Ki=qi[lr],Qi=Ki[Pr]/Xi[Or],Qi){for(mr=1;mr<=dn;mr++)Ki[mr+Pr]-=Qi*Xi[mr+Or];gi[lr][_t-zi[lr]]=Qi}var Xi=[],Ki=[],ea=[],Ji=[],ta=[],na=[],ra=0,ia=0,oa;for(_t=0;_t<$e;_t++){for(Or=zi[_t],Pr=Hi[_t],oa=qi[_t],lr=_t;lr<=Pr;lr++)oa[lr-Or]&&(Xi[ra]=_t,Ki[ra]=lr,ea[ra]=oa[lr-Or],ra++);for(oa=gi[_t],lr=Or;lr<_t;lr++)oa[lr-Or]&&(Ji[ia]=_t,ta[ia]=lr,na[ia]=oa[lr-Or],ia++);Ji[ia]=_t,ta[ia]=_t,na[ia]=1,ia++}return{U:[Xi,Ki,ea],L:[Ji,ta,na]}},numeric.cLUsolve=function(D,E){var F=D.L,J=D.U,$e=numeric.clone(E),_t=F[0],lr=F[1],mr=F[2],Or=J[0],Pr=J[1],dn=J[2],gi=Or.length;_t.length;var qi=$e.length,zi,Hi=0;for(zi=0;zi<qi;zi++){for(;lr[Hi]<zi;)$e[zi]-=mr[Hi]*$e[lr[Hi]],Hi++;Hi++}for(Hi=gi-1,zi=qi-1;zi>=0;zi--){for(;Pr[Hi]>zi;)$e[zi]-=dn[Hi]*$e[Pr[Hi]],Hi--;$e[zi]/=dn[Hi],Hi--}return $e},numeric.cgrid=function(D,E){typeof D=="number"&&(D=[D,D]);var F=numeric.rep(D,-1),J,$e,_t;for(typeof E!="function"&&(E==="L"?E=function(lr,mr){return lr>=D[0]/2||mr<D[1]/2}:E=function(lr,mr){return!0}),_t=0,J=1;J<D[0]-1;J++)for($e=1;$e<D[1]-1;$e++)E(J,$e)&&(F[J][$e]=_t,_t++);return F},numeric.cdelsq=function(D){var E=[[-1,0],[0,-1],[0,1],[1,0]],F=numeric.dim(D),J=F[0],$e=F[1],_t,lr,mr,Or,Pr,dn=[],gi=[],qi=[];for(_t=1;_t<J-1;_t++)for(lr=1;lr<$e-1;lr++)if(!(D[_t][lr]<0)){for(mr=0;mr<4;mr++)Or=_t+E[mr][0],Pr=lr+E[mr][1],!(D[Or][Pr]<0)&&(dn.push(D[_t][lr]),gi.push(D[Or][Pr]),qi.push(-1));dn.push(D[_t][lr]),gi.push(D[_t][lr]),qi.push(4)}return[dn,gi,qi]},numeric.cdotMV=function(D,E){var F,J=D[0],$e=D[1],_t=D[2],lr,mr=J.length,Or=0;for(lr=0;lr<mr;lr++)J[lr]>Or&&(Or=J[lr]);for(Or++,F=numeric.rep([Or],0),lr=0;lr<mr;lr++)F[J[lr]]+=_t[lr]*E[$e[lr]];return F},numeric.Spline=function(D,E,F,J,$e){this.x=D,this.yl=E,this.yr=F,this.kl=J,this.kr=$e},numeric.Spline.prototype._at=function(mr,E){var F=this.x,J=this.yl,$e=this.yr,_t=this.kl,lr=this.kr,mr,Or,Pr,dn,gi=numeric.add,qi=numeric.sub,zi=numeric.mul;Or=qi(zi(_t[E],F[E+1]-F[E]),qi($e[E+1],J[E])),Pr=gi(zi(lr[E+1],F[E]-F[E+1]),qi($e[E+1],J[E])),dn=(mr-F[E])/(F[E+1]-F[E]);var Hi=dn*(1-dn);return gi(gi(gi(zi(1-dn,J[E]),zi(dn,$e[E+1])),zi(Or,Hi*(1-dn))),zi(Pr,Hi*dn))},numeric.Spline.prototype.at=function(D){if(typeof D=="number"){var E=this.x,lr=E.length,F,J,$e,_t=Math.floor;for(F=0,J=lr-1;J-F>1;)$e=_t((F+J)/2),E[$e]<=D?F=$e:J=$e;return this._at(D,F)}var lr=D.length,mr,Or=Array(lr);for(mr=lr-1;mr!==-1;--mr)Or[mr]=this.at(D[mr]);return Or},numeric.Spline.prototype.diff=function(){var D=this.x,E=this.yl,F=this.yr,J=this.kl,$e=this.kr,_t=E.length,lr,mr,Or,Pr=J,dn=$e,gi=Array(_t),qi=Array(_t),zi=numeric.add,Hi=numeric.mul,Qi=numeric.div,Gi=numeric.sub;for(lr=_t-1;lr!==-1;--lr)mr=D[lr+1]-D[lr],Or=Gi(F[lr+1],E[lr]),gi[lr]=Qi(zi(Hi(Or,6),Hi(J[lr],-4*mr),Hi($e[lr+1],-2*mr)),mr*mr),qi[lr+1]=Qi(zi(Hi(Or,-6),Hi(J[lr],2*mr),Hi($e[lr+1],4*mr)),mr*mr);return new numeric.Spline(D,Pr,dn,gi,qi)},numeric.Spline.prototype.roots=function(){function D(ga){return ga*ga}var Qi=[],E=this.x,F=this.yl,J=this.yr,$e=this.kl,_t=this.kr;typeof F[0]=="number"&&(F=[F],J=[J],$e=[$e],_t=[_t]);var lr=F.length,mr=E.length-1,Or,Pr,dn,gi,qi,zi,Hi,Qi=Array(lr),Gi,Zi,Xi,Ki,ea,Ji,ta,na,ra,ia,oa,ua,sa,aa,pa,ma,la=Math.sqrt;for(Or=0;Or!==lr;++Or){for(gi=F[Or],qi=J[Or],zi=$e[Or],Hi=_t[Or],Gi=[],Pr=0;Pr!==mr;Pr++){for(Pr>0&&qi[Pr]*gi[Pr]<0&&Gi.push(E[Pr]),ra=E[Pr+1]-E[Pr],E[Pr],Ki=gi[Pr],ea=qi[Pr+1],Zi=zi[Pr]/ra,Xi=Hi[Pr+1]/ra,na=D(Zi-Xi+3*(Ki-ea))+12*Xi*Ki,Ji=Xi+3*Ki+2*Zi-3*ea,ta=3*(Xi+Zi+2*(Ki-ea)),na<=0?(oa=Ji/ta,ia=oa>E[Pr]&&oa<E[Pr+1]?[E[Pr],oa,E[Pr+1]]:[E[Pr],E[Pr+1]]):(oa=(Ji-la(na))/ta,ua=(Ji+la(na))/ta,ia=[E[Pr]],oa>E[Pr]&&oa<E[Pr+1]&&ia.push(oa),ua>E[Pr]&&ua<E[Pr+1]&&ia.push(ua),ia.push(E[Pr+1])),aa=ia[0],oa=this._at(aa,Pr),dn=0;dn<ia.length-1;dn++){if(pa=ia[dn+1],ua=this._at(pa,Pr),oa===0){Gi.push(aa),aa=pa,oa=ua;continue}if(ua===0||oa*ua>0){aa=pa,oa=ua;continue}for(var ha=0;ma=(oa*pa-ua*aa)/(oa-ua),!(ma<=aa||ma>=pa);)if(sa=this._at(ma,Pr),sa*ua>0)pa=ma,ua=sa,ha===-1&&(oa*=.5),ha=-1;else if(sa*oa>0)aa=ma,oa=sa,ha===1&&(ua*=.5),ha=1;else break;Gi.push(ma),aa=ia[dn+1],oa=this._at(aa,Pr)}ua===0&&Gi.push(pa)}Qi[Or]=Gi}return typeof this.yl[0]=="number"?Qi[0]:Qi},numeric.spline=function(D,E,F,J){var $e=D.length,_t=[],lr=[],mr=[],Or,Pr=numeric.sub,dn=numeric.mul,gi=numeric.add;for(Or=$e-2;Or>=0;Or--)lr[Or]=D[Or+1]-D[Or],mr[Or]=Pr(E[Or+1],E[Or]);(typeof F=="string"||typeof J=="string")&&(F=J="periodic");var qi=[[],[],[]];switch(typeof F){case"undefined":_t[0]=dn(3/(lr[0]*lr[0]),mr[0]),qi[0].push(0,0),qi[1].push(0,1),qi[2].push(2/lr[0],1/lr[0]);break;case"string":_t[0]=gi(dn(3/(lr[$e-2]*lr[$e-2]),mr[$e-2]),dn(3/(lr[0]*lr[0]),mr[0])),qi[0].push(0,0,0),qi[1].push($e-2,0,1),qi[2].push(1/lr[$e-2],2/lr[$e-2]+2/lr[0],1/lr[0]);break;default:_t[0]=F,qi[0].push(0),qi[1].push(0),qi[2].push(1);break}for(Or=1;Or<$e-1;Or++)_t[Or]=gi(dn(3/(lr[Or-1]*lr[Or-1]),mr[Or-1]),dn(3/(lr[Or]*lr[Or]),mr[Or])),qi[0].push(Or,Or,Or),qi[1].push(Or-1,Or,Or+1),qi[2].push(1/lr[Or-1],2/lr[Or-1]+2/lr[Or],1/lr[Or]);switch(typeof J){case"undefined":_t[$e-1]=dn(3/(lr[$e-2]*lr[$e-2]),mr[$e-2]),qi[0].push($e-1,$e-1),qi[1].push($e-2,$e-1),qi[2].push(1/lr[$e-2],2/lr[$e-2]);break;case"string":qi[1][qi[1].length-1]=0;break;default:_t[$e-1]=J,qi[0].push($e-1),qi[1].push($e-1),qi[2].push(1);break}_t=typeof _t[0]=="number"?[_t]:numeric.transpose(_t);var zi=Array(_t.length);if(typeof F=="string")for(Or=zi.length-1;Or!==-1;--Or)zi[Or]=numeric.ccsLUPSolve(numeric.ccsLUP(numeric.ccsScatter(qi)),_t[Or]),zi[Or][$e-1]=zi[Or][0];else for(Or=zi.length-1;Or!==-1;--Or)zi[Or]=numeric.cLUsolve(numeric.cLU(qi),_t[Or]);return zi=typeof E[0]=="number"?zi[0]:numeric.transpose(zi),new numeric.Spline(D,E,E,zi,zi)},numeric.fftpow2=function D(E,F){var J=E.length;if(J!==1){var $e=Math.cos,_t=Math.sin,lr,mr,Or=Array(J/2),Pr=Array(J/2),dn=Array(J/2),gi=Array(J/2);for(mr=J/2,lr=J-1;lr!==-1;--lr)--mr,dn[mr]=E[lr],gi[mr]=F[lr],--lr,Or[mr]=E[lr],Pr[mr]=F[lr];D(Or,Pr),D(dn,gi),mr=J/2;var qi,zi=-6.283185307179586/J,Hi,Qi;for(lr=J-1;lr!==-1;--lr)--mr,mr===-1&&(mr=J/2-1),qi=zi*lr,Hi=$e(qi),Qi=_t(qi),E[lr]=Or[mr]+Hi*dn[mr]-Qi*gi[mr],F[lr]=Pr[mr]+Hi*gi[mr]+Qi*dn[mr]}},numeric._ifftpow2=function D(E,F){var J=E.length;if(J!==1){var $e=Math.cos,_t=Math.sin,lr,mr,Or=Array(J/2),Pr=Array(J/2),dn=Array(J/2),gi=Array(J/2);for(mr=J/2,lr=J-1;lr!==-1;--lr)--mr,dn[mr]=E[lr],gi[mr]=F[lr],--lr,Or[mr]=E[lr],Pr[mr]=F[lr];D(Or,Pr),D(dn,gi),mr=J/2;var qi,zi=6.283185307179586/J,Hi,Qi;for(lr=J-1;lr!==-1;--lr)--mr,mr===-1&&(mr=J/2-1),qi=zi*lr,Hi=$e(qi),Qi=_t(qi),E[lr]=Or[mr]+Hi*dn[mr]-Qi*gi[mr],F[lr]=Pr[mr]+Hi*gi[mr]+Qi*dn[mr]}},numeric.ifftpow2=function(D,E){numeric._ifftpow2(D,E),numeric.diveq(D,D.length),numeric.diveq(E,E.length)},numeric.convpow2=function(D,E,F,J){numeric.fftpow2(D,E),numeric.fftpow2(F,J);var $e,_t=D.length,lr,mr,Or,Pr;for($e=_t-1;$e!==-1;--$e)lr=D[$e],Or=E[$e],mr=F[$e],Pr=J[$e],D[$e]=lr*mr-Or*Pr,E[$e]=lr*Pr+Or*mr;numeric.ifftpow2(D,E)},numeric.T.prototype.fft=function(){var D=this.x,E=this.y,F=D.length,J=Math.log,$e=J(2),_t=2**Math.ceil(J(2*F-1)/$e),lr=numeric.rep([_t],0),mr=numeric.rep([_t],0),Or=Math.cos,Pr=Math.sin,dn,gi=-3.141592653589793/F,qi,zi=numeric.rep([_t],0),Hi=numeric.rep([_t],0);for(dn=0;dn<F;dn++)zi[dn]=D[dn];if(E!==void 0)for(dn=0;dn<F;dn++)Hi[dn]=E[dn];for(lr[0]=1,dn=1;dn<=_t/2;dn++)qi=gi*dn*dn,lr[dn]=Or(qi),mr[dn]=Pr(qi),lr[_t-dn]=Or(qi),mr[_t-dn]=Pr(qi);var Qi=new numeric.T(zi,Hi),Gi=new numeric.T(lr,mr);return Qi=Qi.mul(Gi),numeric.convpow2(Qi.x,Qi.y,numeric.clone(Gi.x),numeric.neg(Gi.y)),Qi=Qi.mul(Gi),Qi.x.length=F,Qi.y.length=F,Qi},numeric.T.prototype.ifft=function(){var D=this.x,E=this.y,F=D.length,J=Math.log,$e=J(2),_t=2**Math.ceil(J(2*F-1)/$e),lr=numeric.rep([_t],0),mr=numeric.rep([_t],0),Or=Math.cos,Pr=Math.sin,dn,gi=3.141592653589793/F,qi,zi=numeric.rep([_t],0),Hi=numeric.rep([_t],0);for(dn=0;dn<F;dn++)zi[dn]=D[dn];if(E!==void 0)for(dn=0;dn<F;dn++)Hi[dn]=E[dn];for(lr[0]=1,dn=1;dn<=_t/2;dn++)qi=gi*dn*dn,lr[dn]=Or(qi),mr[dn]=Pr(qi),lr[_t-dn]=Or(qi),mr[_t-dn]=Pr(qi);var Qi=new numeric.T(zi,Hi),Gi=new numeric.T(lr,mr);return Qi=Qi.mul(Gi),numeric.convpow2(Qi.x,Qi.y,numeric.clone(Gi.x),numeric.neg(Gi.y)),Qi=Qi.mul(Gi),Qi.x.length=F,Qi.y.length=F,Qi.div(F)},numeric.gradient=function(D,E){var F=E.length,J=D(E);if(isNaN(J))throw Error("gradient: f(x) is a NaN!");var dn=Math.max,$e,_t=numeric.clone(E),lr,mr,Or=Array(F);numeric.div,numeric.sub;var Pr,dn=Math.max,gi=.001,qi=Math.abs,zi=Math.min,Hi,Qi,Gi,Zi=0,Xi,Ki,ea;for($e=0;$e<F;$e++)for(var Ji=dn(1e-6*J,1e-8);;){if(++Zi,Zi>20)throw Error("Numerical gradient fails");if(_t[$e]=E[$e]+Ji,lr=D(_t),_t[$e]=E[$e]-Ji,mr=D(_t),_t[$e]=E[$e],isNaN(lr)||isNaN(mr)){Ji/=16;continue}if(Or[$e]=(lr-mr)/(2*Ji),Hi=E[$e]-Ji,Qi=E[$e],Gi=E[$e]+Ji,Xi=(lr-J)/Ji,Ki=(J-mr)/Ji,ea=dn(qi(Or[$e]),qi(J),qi(lr),qi(mr),qi(Hi),qi(Qi),qi(Gi),1e-8),Pr=zi(dn(qi(Xi-Or[$e]),qi(Ki-Or[$e]),qi(Xi-Ki))/ea,Ji/ea),Pr>gi)Ji/=16;else break}return Or},numeric.uncmin=function(D,E,F,J,$e,_t,lr){var mr=numeric.gradient;lr===void 0&&(lr={}),F===void 0&&(F=1e-8),J===void 0&&(J=function(Fa){return mr(D,Fa)}),$e===void 0&&($e=1e3),E=numeric.clone(E);var Or=E.length,Pr=D(E),dn,gi;if(isNaN(Pr))throw Error("uncmin: f(x0) is a NaN!");var qi=Math.max,zi=numeric.norm2;F=qi(F,numeric.epsilon);var Hi,Qi,Gi,Zi=lr.Hinv||numeric.identity(Or),Xi=numeric.dot;numeric.inv;var Ki=numeric.sub,ea=numeric.add,Ji=numeric.tensor,ta=numeric.div,na=numeric.mul,ra=numeric.all,ia=numeric.isFinite,oa=numeric.neg,ua=0,sa,aa,pa,ma,la,ha,ga,Aa="";for(Qi=J(E);ua<$e;){if(typeof _t=="function"&&_t(ua,E,Pr,Qi,Zi)){Aa="Callback returned true";break}if(!ra(ia(Qi))){Aa="Gradient has Infinity or NaN";break}if(Hi=oa(Xi(Zi,Qi)),!ra(ia(Hi))){Aa="Search direction has Infinity or NaN";break}if(ga=zi(Hi),ga<F){Aa="Newton step smaller than tol";break}for(ha=1,gi=Xi(Qi,Hi),aa=E;ua<$e&&!(ha*ga<F);){if(sa=na(Hi,ha),aa=ea(E,sa),dn=D(aa),dn-Pr>=.1*ha*gi||isNaN(dn)){ha*=.5,++ua;continue}break}if(ha*ga<F){Aa="Line search step size smaller than tol";break}if(ua===$e){Aa="maxit reached during line search";break}Gi=J(aa),pa=Ki(Gi,Qi),la=Xi(pa,sa),ma=Xi(Zi,pa),Zi=Ki(ea(Zi,na((la+Xi(pa,ma))/(la*la),Ji(sa,sa))),ta(ea(Ji(ma,sa),Ji(sa,ma)),la)),E=aa,Pr=dn,Qi=Gi,++ua}return{solution:E,f:Pr,gradient:Qi,invHessian:Zi,iterations:ua,message:Aa}},numeric.Dopri=function(D,E,F,J,$e,_t,lr){this.x=D,this.y=E,this.f=F,this.ymid=J,this.iterations=$e,this.events=lr,this.message=_t},numeric.Dopri.prototype._at=function(Hi,E){function F(na){return na*na}var J=this,$e=J.x,_t=J.y,lr=J.f,mr=J.ymid;$e.length;var Or,Pr,dn,gi,qi,zi,Hi,Qi,Gi=.5,Zi=numeric.add,Xi=numeric.mul,Ki=numeric.sub,ea,Ji,ta;return Or=$e[E],Pr=$e[E+1],gi=_t[E],qi=_t[E+1],Qi=Pr-Or,dn=Or+Gi*Qi,zi=mr[E],ea=Ki(lr[E],Xi(gi,1/(Or-dn)+2/(Or-Pr))),Ji=Ki(lr[E+1],Xi(qi,1/(Pr-dn)+2/(Pr-Or))),ta=[F(Hi-Pr)*(Hi-dn)/F(Or-Pr)/(Or-dn),F(Hi-Or)*F(Hi-Pr)/F(Or-dn)/F(Pr-dn),F(Hi-Or)*(Hi-dn)/F(Pr-Or)/(Pr-dn),(Hi-Or)*F(Hi-Pr)*(Hi-dn)/F(Or-Pr)/(Or-dn),(Hi-Pr)*F(Hi-Or)*(Hi-dn)/F(Or-Pr)/(Pr-dn)],Zi(Zi(Zi(Zi(Xi(gi,ta[0]),Xi(zi,ta[1])),Xi(qi,ta[2])),Xi(ea,ta[3])),Xi(Ji,ta[4]))},numeric.Dopri.prototype.at=function(D){var E,F,J,$e=Math.floor;if(typeof D!="number"){var _t=D.length,lr=Array(_t);for(E=_t-1;E!==-1;--E)lr[E]=this.at(D[E]);return lr}var mr=this.x;for(E=0,F=mr.length-1;F-E>1;)J=$e(.5*(E+F)),mr[J]<=D?E=J:F=J;return this._at(D,E)},numeric.dopri=function(D,E,F,J,$e,_t,lr){$e===void 0&&($e=1e-6),_t===void 0&&(_t=1e3);var mr=[D],Or=[F],Pr=[J(D,F)],dn,gi,qi,zi,Hi,Qi,Gi=[],Zi=1/5,Xi=[3/40,9/40],Ki=[44/45,-56/15,32/9],ea=[19372/6561,-25360/2187,64448/6561,-212/729],Ji=[9017/3168,-355/33,46732/5247,49/176,-5103/18656],ta=[35/384,0,500/1113,125/192,-2187/6784,11/84],na=[.5*6025192743/30085553152,0,.5*51252292925/65400821598,.5*-2691868925/45128329728,.5*187940372067/1594534317056,.5*-1776094331/19743644256,.5*11237099/235043384],ra=[1/5,3/10,4/5,8/9,1,1],ia=[-71/57600,0,71/16695,-71/1920,17253/339200,-22/525,1/40],oa=0,ua,sa,aa=(E-D)/10,pa=0,ma=numeric.add,la=numeric.mul,ha,ga,Aa=Math.min,Fa=Math.abs,$a=numeric.norminf,_a=Math.pow,fa=numeric.any,ka=numeric.lt,ba=numeric.and;numeric.sub;var Pa,Ia,Da,va=new numeric.Dopri(mr,Or,Pr,Gi,-1,"");for(typeof lr=="function"&&(Pa=lr(D,F));D<E&&pa<_t;){if(++pa,D+aa>E&&(aa=E-D),dn=J(D+ra[0]*aa,ma(F,la(Zi*aa,Pr[oa]))),gi=J(D+ra[1]*aa,ma(ma(F,la(Xi[0]*aa,Pr[oa])),la(Xi[1]*aa,dn))),qi=J(D+ra[2]*aa,ma(ma(ma(F,la(Ki[0]*aa,Pr[oa])),la(Ki[1]*aa,dn)),la(Ki[2]*aa,gi))),zi=J(D+ra[3]*aa,ma(ma(ma(ma(F,la(ea[0]*aa,Pr[oa])),la(ea[1]*aa,dn)),la(ea[2]*aa,gi)),la(ea[3]*aa,qi))),Hi=J(D+ra[4]*aa,ma(ma(ma(ma(ma(F,la(Ji[0]*aa,Pr[oa])),la(Ji[1]*aa,dn)),la(Ji[2]*aa,gi)),la(Ji[3]*aa,qi)),la(Ji[4]*aa,zi))),ha=ma(ma(ma(ma(ma(F,la(Pr[oa],aa*ta[0])),la(gi,aa*ta[2])),la(qi,aa*ta[3])),la(zi,aa*ta[4])),la(Hi,aa*ta[5])),Qi=J(D+aa,ha),ua=ma(ma(ma(ma(ma(la(Pr[oa],aa*ia[0]),la(gi,aa*ia[2])),la(qi,aa*ia[3])),la(zi,aa*ia[4])),la(Hi,aa*ia[5])),la(Qi,aa*ia[6])),ga=typeof ua=="number"?Fa(ua):$a(ua),ga>$e){if(aa=.2*aa*_a($e/ga,.25),D+aa===D){va.msg="Step size became too small";break}continue}if(Gi[oa]=ma(ma(ma(ma(ma(ma(F,la(Pr[oa],aa*na[0])),la(gi,aa*na[2])),la(qi,aa*na[3])),la(zi,aa*na[4])),la(Hi,aa*na[5])),la(Qi,aa*na[6])),++oa,mr[oa]=D+aa,Or[oa]=ha,Pr[oa]=Qi,typeof lr=="function"){var Ca,ya=D,Na=D+.5*aa,za;if(Ia=lr(Na,Gi[oa-1]),Da=ba(ka(Pa,0),ka(0,Ia)),fa(Da)||(ya=Na,Na=D+aa,Pa=Ia,Ia=lr(Na,ha),Da=ba(ka(Pa,0),ka(0,Ia))),fa(Da)){for(var Ta,es,ts,Ka,ps=0,cs=1,xa=1;;){if(typeof Pa=="number")za=(xa*Ia*ya-cs*Pa*Na)/(xa*Ia-cs*Pa);else for(za=Na,sa=Pa.length-1;sa!==-1;--sa)Pa[sa]<0&&Ia[sa]>0&&(za=Aa(za,(xa*Ia[sa]*ya-cs*Pa[sa]*Na)/(xa*Ia[sa]-cs*Pa[sa])));if(za<=ya||za>=Na)break;Ca=va._at(za,oa-1),Ka=lr(za,Ca),ts=ba(ka(Pa,0),ka(0,Ka)),fa(ts)?(Na=za,Ia=Ka,Da=ts,xa=1,ps===-1?cs*=.5:cs=1,ps=-1):(ya=za,Pa=Ka,cs=1,ps===1?xa*=.5:xa=1,ps=1)}return ha=va._at(.5*(D+za),oa-1),va.f[oa]=J(za,Ca),va.x[oa]=za,va.y[oa]=Ca,va.ymid[oa-1]=ha,va.events=Da,va.iterations=pa,va}}D+=aa,F=ha,Pa=Ia,aa=Aa(.8*aa*_a($e/ga,.25),4*aa)}return va.iterations=pa,va},numeric.LU=function(D,E){E||=!1;var F=Math.abs,J,$e,_t,lr,mr,Or,Pr,dn,gi,qi=D.length,zi=qi-1,Hi=Array(qi);for(E||(D=numeric.clone(D)),_t=0;_t<qi;++_t){for(Pr=_t,Or=D[_t],gi=F(Or[_t]),$e=_t+1;$e<qi;++$e)lr=F(D[$e][_t]),gi<lr&&(gi=lr,Pr=$e);for(Hi[_t]=Pr,Pr!=_t&&(D[_t]=D[Pr],D[Pr]=Or,Or=D[_t]),mr=Or[_t],J=_t+1;J<qi;++J)D[J][_t]/=mr;for(J=_t+1;J<qi;++J){for(dn=D[J],$e=_t+1;$e<zi;++$e)dn[$e]-=dn[_t]*Or[$e],++$e,dn[$e]-=dn[_t]*Or[$e];$e===zi&&(dn[$e]-=dn[_t]*Or[$e])}}return{LU:D,P:Hi}},numeric.LUsolve=function(D,E){var F,J,$e=D.LU,_t=$e.length,lr=numeric.clone(E),mr=D.P,Or,Pr,dn;for(F=_t-1;F!==-1;--F)lr[F]=E[F];for(F=0;F<_t;++F)for(Or=mr[F],mr[F]!==F&&(dn=lr[F],lr[F]=lr[Or],lr[Or]=dn),Pr=$e[F],J=0;J<F;++J)lr[F]-=lr[J]*Pr[J];for(F=_t-1;F>=0;--F){for(Pr=$e[F],J=F+1;J<_t;++J)lr[F]-=lr[J]*Pr[J];lr[F]/=Pr[F]}return lr},numeric.solve=function(D,E,F){return numeric.LUsolve(numeric.LU(D,F),E)},numeric.echelonize=function(D){var E=numeric.dim(D),F=E[0],J=E[1],$e=numeric.identity(F),_t=Array(F),lr,mr,Or,Pr,dn,gi,qi,zi,Hi=Math.abs,Qi=numeric.diveq;for(D=numeric.clone(D),lr=0;lr<F;++lr){for(Or=0,dn=D[lr],gi=$e[lr],mr=1;mr<J;++mr)Hi(dn[Or])<Hi(dn[mr])&&(Or=mr);for(_t[lr]=Or,Qi(gi,dn[Or]),Qi(dn,dn[Or]),mr=0;mr<F;++mr)if(mr!==lr){for(qi=D[mr],zi=qi[Or],Pr=J-1;Pr!==-1;--Pr)qi[Pr]-=dn[Pr]*zi;for(qi=$e[mr],Pr=F-1;Pr!==-1;--Pr)qi[Pr]-=gi[Pr]*zi}}return{I:$e,A:D,P:_t}},numeric.__solveLP=function(D,E,F,J,$e,_t,lr){var mr=numeric.sum;numeric.log;var Or=numeric.mul,Pr=numeric.sub,dn=numeric.dot,gi=numeric.div,qi=numeric.add,zi=D.length,Hi=F.length,Qi,Gi=!1,Zi=0,Xi=1;numeric.transpose(E),numeric.svd;var Ki=numeric.transpose;numeric.leq;var ea=Math.sqrt,Ji=Math.abs;numeric.muleq,numeric.norminf,numeric.any;var ta=Math.min,na=numeric.all,ra=numeric.gt,ia=Array(zi),oa=Array(Hi);numeric.rep([Hi],1);var ua,sa=numeric.solve,aa=Pr(F,dn(E,_t)),pa,ma=dn(D,D),la;for(pa=Zi;pa<$e;++pa){var ha,ga;for(ha=Hi-1;ha!==-1;--ha)oa[ha]=gi(E[ha],aa[ha]);var Aa=Ki(oa);for(ha=zi-1;ha!==-1;--ha)ia[ha]=mr(Aa[ha]);Xi=.25*Ji(ma/dn(D,ia));var Fa=100*ea(ma/dn(ia,ia));for((!isFinite(Xi)||Xi>Fa)&&(Xi=Fa),la=qi(D,Or(Xi,ia)),ua=dn(Aa,oa),ha=zi-1;ha!==-1;--ha)ua[ha][ha]+=1;ga=sa(ua,gi(la,Xi),!0);var $a=gi(aa,dn(E,ga)),_a=1;for(ha=Hi-1;ha!==-1;--ha)$a[ha]<0&&(_a=ta(_a,-.999*$a[ha]));if(Qi=Pr(_t,Or(ga,_a)),aa=Pr(F,dn(E,Qi)),!na(ra(aa,0)))return{solution:_t,message:"",iterations:pa};if(_t=Qi,Xi<J)return{solution:Qi,message:"",iterations:pa};if(lr){var fa=dn(D,la),ka=dn(E,la);for(Gi=!0,ha=Hi-1;ha!==-1;--ha)if(fa*ka[ha]<0){Gi=!1;break}}else Gi=!(_t[zi-1]>=0);if(Gi)return{solution:Qi,message:"Unbounded",iterations:pa}}return{solution:_t,message:"maximum iteration count exceeded",iterations:pa}},numeric._solveLP=function(D,E,F,J,$e){var _t=D.length,lr=F.length,zi;numeric.sum,numeric.log,numeric.mul;var mr=numeric.sub,Or=numeric.dot;numeric.div,numeric.add;var Pr=numeric.rep([_t],0).concat([1]),dn=numeric.rep([lr,1],-1),gi=numeric.blockMatrix([[E,dn]]),qi=F,zi=numeric.rep([_t],0).concat(Math.max(0,numeric.sup(numeric.neg(F)))+1),Hi=numeric.__solveLP(Pr,gi,qi,J,$e,zi,!1),Qi=numeric.clone(Hi.solution);if(Qi.length=_t,numeric.inf(mr(F,Or(E,Qi)))<0)return{solution:NaN,message:"Infeasible",iterations:Hi.iterations};var Gi=numeric.__solveLP(D,E,F,J,$e-Hi.iterations,Qi,!0);return Gi.iterations+=Hi.iterations,Gi},numeric.solveLP=function(D,E,F,J,$e,_t,lr){if(lr===void 0&&(lr=1e3),_t===void 0&&(_t=numeric.epsilon),J===void 0)return numeric._solveLP(D,E,F,_t,lr);var mr=J.length,Or=J[0].length,Pr=E.length,dn=numeric.echelonize(J),gi=numeric.rep([Or],0),qi=dn.P,zi=[],Hi;for(Hi=qi.length-1;Hi!==-1;--Hi)gi[qi[Hi]]=1;for(Hi=Or-1;Hi!==-1;--Hi)gi[Hi]===0&&zi.push(Hi);var Qi=numeric.getRange,Gi=numeric.linspace(0,mr-1),Zi=numeric.linspace(0,Pr-1),Xi=Qi(J,Gi,zi),Ki=Qi(E,Zi,qi),ea=Qi(E,Zi,zi),Ji=numeric.dot,ta=numeric.sub,na=Ji(Ki,dn.I),ra=ta(ea,Ji(na,Xi)),ia=ta(F,Ji(na,$e)),oa=Array(qi.length),ua=Array(zi.length);for(Hi=qi.length-1;Hi!==-1;--Hi)oa[Hi]=D[qi[Hi]];for(Hi=zi.length-1;Hi!==-1;--Hi)ua[Hi]=D[zi[Hi]];var sa=ta(ua,Ji(oa,Ji(dn.I,Xi))),aa=numeric._solveLP(sa,ra,ia,_t,lr),pa=aa.solution;if(pa!==pa)return aa;var ma=Ji(dn.I,ta($e,Ji(Xi,pa))),la=Array(D.length);for(Hi=qi.length-1;Hi!==-1;--Hi)la[qi[Hi]]=ma[Hi];for(Hi=zi.length-1;Hi!==-1;--Hi)la[zi[Hi]]=pa[Hi];return{solution:la,message:aa.message,iterations:aa.iterations}},numeric.MPStoLP=function(D){D instanceof String&&D.split(`\n`);var E=0,F=["Initial state","NAME","ROWS","COLUMNS","RHS","BOUNDS","ENDATA"],J=D.length,$e,_t,lr,mr=0,Or={},Pr=[],dn=0,gi={},qi=0,zi,Hi=[],Qi=[],Gi=[];function Zi(ta){throw Error("MPStoLP: "+ta+`\nLine `+$e+": "+D[$e]+`\nCurrent state: `+F[E]+`\n`)}for($e=0;$e<J;++$e){lr=D[$e];var Xi=lr.match(/\\S*/g),Ki=[];for(_t=0;_t<Xi.length;++_t)Xi[_t]!==""&&Ki.push(Xi[_t]);if(Ki.length!==0){for(_t=0;_t<F.length&&lr.substr(0,F[_t].length)!==F[_t];++_t);if(_t<F.length){if(E=_t,_t===1&&(zi=Ki[1]),_t===6)return{name:zi,c:Hi,A:numeric.transpose(Qi),b:Gi,rows:Or,vars:gi};continue}switch(E){case 0:case 1:Zi("Unexpected line");case 2:switch(Ki[0]){case"N":mr===0?mr=Ki[1]:Zi("Two or more N rows");break;case"L":Or[Ki[1]]=dn,Pr[dn]=1,Gi[dn]=0,++dn;break;case"G":Or[Ki[1]]=dn,Pr[dn]=-1,Gi[dn]=0,++dn;break;case"E":Or[Ki[1]]=dn,Pr[dn]=0,Gi[dn]=0,++dn;break;default:Zi("Parse error "+numeric.prettyPrint(Ki))}break;case 3:gi.hasOwnProperty(Ki[0])||(gi[Ki[0]]=qi,Hi[qi]=0,Qi[qi]=numeric.rep([dn],0),++qi);var ea=gi[Ki[0]];for(_t=1;_t<Ki.length;_t+=2){if(Ki[_t]===mr){Hi[ea]=parseFloat(Ki[_t+1]);continue}var Ji=Or[Ki[_t]];Qi[ea][Ji]=(Pr[Ji]<0?-1:1)*parseFloat(Ki[_t+1])}break;case 4:for(_t=1;_t<Ki.length;_t+=2)Gi[Or[Ki[_t]]]=(Pr[Or[Ki[_t]]]<0?-1:1)*parseFloat(Ki[_t+1]);break;case 5:break;case 6:Zi("Internal error")}}}Zi("Reached end of file without ENDATA")},numeric.seedrandom={pow:Math.pow,random:Math.random},(function(D,E,F,J,$e,_t,lr){E.seedrandom=function(gi,qi){var zi=[],Hi;return gi=Pr(Or(qi?[gi,D]:arguments.length?gi:[new Date().getTime(),D,window],3),zi),Hi=new mr(zi),Pr(Hi.S,D),E.random=function(){for(var Qi=Hi.g(J),Gi=lr,Zi=0;Qi<$e;)Qi=(Qi+Zi)*F,Gi*=F,Zi=Hi.g(1);for(;Qi>=_t;)Qi/=2,Gi/=2,Zi>>>=1;return(Qi+Zi)/Gi},gi};function mr(gi){var qi,zi,Hi=this,Qi=gi.length,Gi=0,Zi=Hi.i=Hi.j=Hi.m=0;for(Hi.S=[],Hi.c=[],Qi||(gi=[Qi++]);Gi<F;)Hi.S[Gi]=Gi++;for(Gi=0;Gi<F;Gi++)qi=Hi.S[Gi],Zi=dn(Zi+qi+gi[Gi%Qi]),zi=Hi.S[Zi],Hi.S[Gi]=zi,Hi.S[Zi]=qi;Hi.g=function(Xi){var Ki=Hi.S,ea=dn(Hi.i+1),Ji=Ki[ea],ta=dn(Hi.j+Ji),na=Ki[ta];Ki[ea]=na,Ki[ta]=Ji;for(var ra=Ki[dn(Ji+na)];--Xi;)ea=dn(ea+1),Ji=Ki[ea],ta=dn(ta+Ji),na=Ki[ta],Ki[ea]=na,Ki[ta]=Ji,ra=ra*F+Ki[dn(Ji+na)];return Hi.i=ea,Hi.j=ta,ra},Hi.g(F)}function Or(gi,qi,zi,Hi,Qi){if(zi=[],Qi=typeof gi,qi&&Qi=="object"){for(Hi in gi)if(Hi.indexOf("S")<5)try{zi.push(Or(gi[Hi],qi-1))}catch{}}return zi.length?zi:gi+(Qi=="string"?"":"\\0")}function Pr(gi,qi,zi,Hi){for(gi+="",zi=0,Hi=0;Hi<gi.length;Hi++)qi[dn(Hi)]=dn((zi^=qi[dn(Hi)]*19)+gi.charCodeAt(Hi));for(Hi in gi="",qi)gi+=String.fromCharCode(qi[Hi]);return gi}function dn(gi){return gi&F-1}lr=E.pow(F,J),$e=E.pow(2,$e),_t=$e*2,Pr(E.random(),D)})([],numeric.seedrandom,256,6,52),(function(D){function E(Or){if(typeof Or!="object")return Or;var Pr=[],dn,gi=Or.length;for(dn=0;dn<gi;dn++)Pr[dn+1]=E(Or[dn]);return Pr}function F(Or){if(typeof Or!="object")return Or;var Pr=[],dn,gi=Or.length;for(dn=1;dn<gi;dn++)Pr[dn-1]=F(Or[dn]);return Pr}function J(Or,Pr,dn){var gi,qi,zi,Hi,Qi;for(zi=1;zi<=dn;zi+=1){for(Or[zi][zi]=1/Or[zi][zi],Qi=-Or[zi][zi],gi=1;gi<zi;gi+=1)Or[gi][zi]=Qi*Or[gi][zi];if(Hi=zi+1,dn<Hi)break;for(qi=Hi;qi<=dn;qi+=1)for(Qi=Or[zi][qi],Or[zi][qi]=0,gi=1;gi<=zi;gi+=1)Or[gi][qi]=Or[gi][qi]+Qi*Or[gi][zi]}}function $e(Or,Pr,dn,gi){var qi,zi,Hi,Qi;for(zi=1;zi<=dn;zi+=1){for(Qi=0,qi=1;qi<zi;qi+=1)Qi+=Or[qi][zi]*gi[qi];gi[zi]=(gi[zi]-Qi)/Or[zi][zi]}for(Hi=1;Hi<=dn;Hi+=1)for(zi=dn+1-Hi,gi[zi]=gi[zi]/Or[zi][zi],Qi=-gi[zi],qi=1;qi<zi;qi+=1)gi[qi]=gi[qi]+Qi*Or[qi][zi]}function _t(Or,Pr,dn,gi){var qi,zi,Hi,Qi,Gi,Zi;for(zi=1;zi<=dn;zi+=1){if(gi[1]=zi,Zi=0,Hi=zi-1,Hi<1){if(Zi=Or[zi][zi]-Zi,Zi<=0)break;Or[zi][zi]=Math.sqrt(Zi)}else{for(Qi=1;Qi<=Hi;Qi+=1){for(Gi=Or[Qi][zi],qi=1;qi<Qi;qi+=1)Gi-=Or[qi][zi]*Or[qi][Qi];Gi/=Or[Qi][Qi],Or[Qi][zi]=Gi,Zi+=Gi*Gi}if(Zi=Or[zi][zi]-Zi,Zi<=0)break;Or[zi][zi]=Math.sqrt(Zi)}gi[1]=0}}function lr(Or,Pr,dn,gi,qi,zi,Hi,Qi,Gi,Zi,Xi,Ki,ea,Ji,ta,na){var ra,ia,oa,ua,sa,aa,pa,ma,la,ha,ga,Aa,Fa=Math.min(gi,Zi),$a,_a,fa,ka,ba,Pa,Ia,Da,va,Ca,ya,Na,za,Ta;oa=2*gi+Fa*(Fa+5)/2+2*Zi+1,ya=1e-60;do ya+=ya,Na=1+.1*ya,za=1+.2*ya;while(Na<=1||za<=1);for(ra=1;ra<=gi;ra+=1)ta[ra]=Pr[ra];for(ra=gi+1;ra<=oa;ra+=1)ta[ra]=0;for(ra=1;ra<=Zi;ra+=1)Ki[ra]=0;if(sa=[],na[1]===0){if(_t(Or,dn,gi,sa),sa[1]!==0){na[1]=2;return}$e(Or,dn,gi,Pr),J(Or,dn,gi)}else{for(ia=1;ia<=gi;ia+=1)for(qi[ia]=0,ra=1;ra<=ia;ra+=1)qi[ia]=qi[ia]+Or[ra][ia]*Pr[ra];for(ia=1;ia<=gi;ia+=1)for(Pr[ia]=0,ra=ia;ra<=gi;ra+=1)Pr[ia]=Pr[ia]+Or[ia][ra]*qi[ra]}for(zi[1]=0,ia=1;ia<=gi;ia+=1)for(qi[ia]=Pr[ia],zi[1]+=ta[ia]*qi[ia],ta[ia]=0,ra=ia+1;ra<=gi;ra+=1)Or[ra][ia]=0;for(zi[1]=-zi[1]/2,na[1]=0,pa=gi,ma=pa+gi,ga=ma+Fa,la=ga+Fa+1,ha=la+Fa*(Fa+1)/2,$a=ha+Zi,ra=1;ra<=Zi;ra+=1){for(fa=0,ia=1;ia<=gi;ia+=1)fa+=Hi[ia][ra]*Hi[ia][ra];ta[$a+ra]=Math.sqrt(fa)}ea=0,Ji[1]=0,Ji[2]=0;function es(){for(Ji[1]+=1,oa=ha,ra=1;ra<=Zi;ra+=1){for(oa+=1,fa=-Qi[ra],ia=1;ia<=gi;ia+=1)fa+=Hi[ia][ra]*qi[ia];if(Math.abs(fa)<ya&&(fa=0),ra>Xi)ta[oa]=fa;else if(ta[oa]=-Math.abs(fa),fa>0){for(ia=1;ia<=gi;ia+=1)Hi[ia][ra]=-Hi[ia][ra];Qi[ra]=-Qi[ra]}}for(ra=1;ra<=ea;ra+=1)ta[ha+Ki[ra]]=0;for(Aa=0,_a=0,ra=1;ra<=Zi;ra+=1)ta[ha+ra]<_a*ta[$a+ra]&&(Aa=ra,_a=ta[ha+ra]/ta[$a+ra]);return Aa===0?999:0}function ts(){for(ra=1;ra<=gi;ra+=1){for(fa=0,ia=1;ia<=gi;ia+=1)fa+=Or[ia][ra]*Hi[ia][Aa];ta[ra]=fa}for(ua=pa,ra=1;ra<=gi;ra+=1)ta[ua+ra]=0;for(ia=ea+1;ia<=gi;ia+=1)for(ra=1;ra<=gi;ra+=1)ta[ua+ra]=ta[ua+ra]+Or[ra][ia]*ta[ia];for(va=!0,ra=ea;ra>=1;--ra){for(fa=ta[ra],oa=la+ra*(ra+3)/2,ua=oa-ra,ia=ra+1;ia<=ea;ia+=1)fa-=ta[oa]*ta[ma+ia],oa+=ia;if(fa/=ta[ua],ta[ma+ra]=fa,Ki[ra]<Xi||fa<0)break;va=!1,aa=ra}if(!va)for(ka=ta[ga+aa]/ta[ma+aa],ra=1;ra<=ea&&!(Ki[ra]<Xi||ta[ma+ra]<0);ra+=1)_a=ta[ga+ra]/ta[ma+ra],_a<ka&&(ka=_a,aa=ra);for(fa=0,ra=pa+1;ra<=pa+gi;ra+=1)fa+=ta[ra]*ta[ra];if(Math.abs(fa)<=ya){if(va)return na[1]=1,999;for(ra=1;ra<=ea;ra+=1)ta[ga+ra]=ta[ga+ra]-ka*ta[ma+ra];return ta[ga+ea+1]=ta[ga+ea+1]+ka,700}else{for(fa=0,ra=1;ra<=gi;ra+=1)fa+=ta[pa+ra]*Hi[ra][Aa];for(ba=-ta[ha+Aa]/fa,Ca=!0,va||ka<ba&&(ba=ka,Ca=!1),ra=1;ra<=gi;ra+=1)qi[ra]=qi[ra]+ba*ta[pa+ra],Math.abs(qi[ra])<ya&&(qi[ra]=0);for(zi[1]+=ba*fa*(ba/2+ta[ga+ea+1]),ra=1;ra<=ea;ra+=1)ta[ga+ra]=ta[ga+ra]-ba*ta[ma+ra];if(ta[ga+ea+1]=ta[ga+ea+1]+ba,Ca){for(ea+=1,Ki[ea]=Aa,oa=la+(ea-1)*ea/2+1,ra=1;ra<=ea-1;ra+=1)ta[oa]=ta[ra],oa+=1;if(ea===gi)ta[oa]=ta[gi];else{for(ra=gi;ra>=ea+1&&!(ta[ra]===0||(Pa=Math.max(Math.abs(ta[ra-1]),Math.abs(ta[ra])),Ia=Math.min(Math.abs(ta[ra-1]),Math.abs(ta[ra])),_a=ta[ra-1]>=0?Math.abs(Pa*Math.sqrt(1+Ia*Ia/(Pa*Pa))):-Math.abs(Pa*Math.sqrt(1+Ia*Ia/(Pa*Pa))),Pa=ta[ra-1]/_a,Ia=ta[ra]/_a,Pa===1));--ra)if(Pa===0)for(ta[ra-1]=Ia*_a,ia=1;ia<=gi;ia+=1)_a=Or[ia][ra-1],Or[ia][ra-1]=Or[ia][ra],Or[ia][ra]=_a;else for(ta[ra-1]=_a,Da=Ia/(1+Pa),ia=1;ia<=gi;ia+=1)_a=Pa*Or[ia][ra-1]+Ia*Or[ia][ra],Or[ia][ra]=Da*(Or[ia][ra-1]+_a)-Or[ia][ra],Or[ia][ra-1]=_a;ta[oa]=ta[ea]}}else{for(fa=-Qi[Aa],ia=1;ia<=gi;ia+=1)fa+=qi[ia]*Hi[ia][Aa];if(Aa>Xi)ta[ha+Aa]=fa;else if(ta[ha+Aa]=-Math.abs(fa),fa>0){for(ia=1;ia<=gi;ia+=1)Hi[ia][Aa]=-Hi[ia][Aa];Qi[Aa]=-Qi[Aa]}return 700}}return 0}function Ka(){if(oa=la+aa*(aa+1)/2+1,ua=oa+aa,ta[ua]===0||(Pa=Math.max(Math.abs(ta[ua-1]),Math.abs(ta[ua])),Ia=Math.min(Math.abs(ta[ua-1]),Math.abs(ta[ua])),_a=ta[ua-1]>=0?Math.abs(Pa*Math.sqrt(1+Ia*Ia/(Pa*Pa))):-Math.abs(Pa*Math.sqrt(1+Ia*Ia/(Pa*Pa))),Pa=ta[ua-1]/_a,Ia=ta[ua]/_a,Pa===1))return 798;if(Pa===0){for(ra=aa+1;ra<=ea;ra+=1)_a=ta[ua-1],ta[ua-1]=ta[ua],ta[ua]=_a,ua+=ra;for(ra=1;ra<=gi;ra+=1)_a=Or[ra][aa],Or[ra][aa]=Or[ra][aa+1],Or[ra][aa+1]=_a}else{for(Da=Ia/(1+Pa),ra=aa+1;ra<=ea;ra+=1)_a=Pa*ta[ua-1]+Ia*ta[ua],ta[ua]=Da*(ta[ua-1]+_a)-ta[ua],ta[ua-1]=_a,ua+=ra;for(ra=1;ra<=gi;ra+=1)_a=Pa*Or[ra][aa]+Ia*Or[ra][aa+1],Or[ra][aa+1]=Da*(Or[ra][aa]+_a)-Or[ra][aa+1],Or[ra][aa]=_a}return 0}function ps(){for(ua=oa-aa,ra=1;ra<=aa;ra+=1)ta[ua]=ta[oa],oa+=1,ua+=1;return ta[ga+aa]=ta[ga+aa+1],Ki[aa]=Ki[aa+1],aa+=1,aa<ea?797:0}function cs(){return ta[ga+ea]=ta[ga+ea+1],ta[ga+ea+1]=0,Ki[ea]=0,--ea,Ji[2]+=1,0}for(Ta=0;;){if(Ta=es(),Ta===999)return;for(;Ta=ts(),Ta!==0;){if(Ta===999)return;if(Ta===700)if(aa===ea)cs();else{for(;Ka(),Ta=ps(),Ta===797;);cs()}}}}function mr(Or,Pr,dn,gi,qi,zi){Or=E(Or),Pr=E(Pr),dn=E(dn);var Hi,Qi,Gi,Zi,Xi,Ki=[],ea=[],Ji=[],ta=[],na=[],ra;if(qi||=0,zi=zi?E(zi):[void 0,0],gi=gi?E(gi):[],Qi=Or.length-1,Gi=dn[1].length-1,!gi)for(Hi=1;Hi<=Gi;Hi+=1)gi[Hi]=0;for(Hi=1;Hi<=Gi;Hi+=1)ea[Hi]=0;for(Zi=0,Xi=Math.min(Qi,Gi),Hi=1;Hi<=Qi;Hi+=1)Ji[Hi]=0;for(Ki[1]=0,Hi=1;Hi<=2*Qi+Xi*(Xi+5)/2+2*Gi+1;Hi+=1)ta[Hi]=0;for(Hi=1;Hi<=2;Hi+=1)na[Hi]=0;return lr(Or,Pr,Qi,Qi,Ji,Ki,dn,gi,Qi,Gi,qi,ea,Zi,na,ta,zi),ra="",zi[1]===1&&(ra="constraints are inconsistent, no solution!"),zi[1]===2&&(ra="matrix D in quadratic function is not positive definite!"),{solution:F(Ji),value:F(Ki),unconstrained_solution:F(Pr),iterations:F(na),iact:F(ea),message:ra}}D.solveQP=mr})(numeric),numeric.svd=function(D){var E,F=numeric.epsilon,J=1e-64/F,$e=50,_t=0,lr=0,mr=0,Or=0,Pr=0,dn=numeric.clone(D),gi=dn.length,qi=dn[0].length;if(gi<qi)throw"Need more rows than columns";var zi=Array(qi),Hi=Array(qi);for(lr=0;lr<qi;lr++)zi[lr]=Hi[lr]=0;var Qi=numeric.rep([qi,qi],0);function Gi(ua,sa){return ua=Math.abs(ua),sa=Math.abs(sa),ua>sa?ua*Math.sqrt(1+sa*sa/ua/ua):sa==0?ua:sa*Math.sqrt(1+ua*ua/sa/sa)}var Zi=0,Xi=0,Ki=0,ea=0,Ji=0,ta=0,na=0;for(lr=0;lr<qi;lr++){for(zi[lr]=Xi,na=0,Pr=lr+1,mr=lr;mr<gi;mr++)na+=dn[mr][lr]*dn[mr][lr];if(na<=J)Xi=0;else for(Zi=dn[lr][lr],Xi=Math.sqrt(na),Zi>=0&&(Xi=-Xi),Ki=Zi*Xi-na,dn[lr][lr]=Zi-Xi,mr=Pr;mr<qi;mr++){for(na=0,Or=lr;Or<gi;Or++)na+=dn[Or][lr]*dn[Or][mr];for(Zi=na/Ki,Or=lr;Or<gi;Or++)dn[Or][mr]+=Zi*dn[Or][lr]}for(Hi[lr]=Xi,na=0,mr=Pr;mr<qi;mr++)na+=dn[lr][mr]*dn[lr][mr];if(na<=J)Xi=0;else{for(Zi=dn[lr][lr+1],Xi=Math.sqrt(na),Zi>=0&&(Xi=-Xi),Ki=Zi*Xi-na,dn[lr][lr+1]=Zi-Xi,mr=Pr;mr<qi;mr++)zi[mr]=dn[lr][mr]/Ki;for(mr=Pr;mr<gi;mr++){for(na=0,Or=Pr;Or<qi;Or++)na+=dn[mr][Or]*dn[lr][Or];for(Or=Pr;Or<qi;Or++)dn[mr][Or]+=na*zi[Or]}}Ji=Math.abs(Hi[lr])+Math.abs(zi[lr]),Ji>ea&&(ea=Ji)}for(lr=qi-1;lr!=-1;lr+=-1){if(Xi!=0){for(Ki=Xi*dn[lr][lr+1],mr=Pr;mr<qi;mr++)Qi[mr][lr]=dn[lr][mr]/Ki;for(mr=Pr;mr<qi;mr++){for(na=0,Or=Pr;Or<qi;Or++)na+=dn[lr][Or]*Qi[Or][mr];for(Or=Pr;Or<qi;Or++)Qi[Or][mr]+=na*Qi[Or][lr]}}for(mr=Pr;mr<qi;mr++)Qi[lr][mr]=0,Qi[mr][lr]=0;Qi[lr][lr]=1,Xi=zi[lr],Pr=lr}for(lr=qi-1;lr!=-1;lr+=-1){for(Pr=lr+1,Xi=Hi[lr],mr=Pr;mr<qi;mr++)dn[lr][mr]=0;if(Xi!=0){for(Ki=dn[lr][lr]*Xi,mr=Pr;mr<qi;mr++){for(na=0,Or=Pr;Or<gi;Or++)na+=dn[Or][lr]*dn[Or][mr];for(Zi=na/Ki,Or=lr;Or<gi;Or++)dn[Or][mr]+=Zi*dn[Or][lr]}for(mr=lr;mr<gi;mr++)dn[mr][lr]=dn[mr][lr]/Xi}else for(mr=lr;mr<gi;mr++)dn[mr][lr]=0;dn[lr][lr]+=1}for(F*=ea,Or=qi-1;Or!=-1;Or+=-1)for(var ra=0;ra<$e;ra++){var ia=!1;for(Pr=Or;Pr!=-1;Pr+=-1){if(Math.abs(zi[Pr])<=F){ia=!0;break}if(Math.abs(Hi[Pr-1])<=F)break}if(!ia){_t=0,na=1;var oa=Pr-1;for(lr=Pr;lr<Or+1&&(Zi=na*zi[lr],zi[lr]=_t*zi[lr],!(Math.abs(Zi)<=F));lr++)for(Xi=Hi[lr],Ki=Gi(Zi,Xi),Hi[lr]=Ki,_t=Xi/Ki,na=-Zi/Ki,mr=0;mr<gi;mr++)Ji=dn[mr][oa],ta=dn[mr][lr],dn[mr][oa]=Ji*_t+ta*na,dn[mr][lr]=-Ji*na+ta*_t}if(ta=Hi[Or],Pr==Or){if(ta<0)for(Hi[Or]=-ta,mr=0;mr<qi;mr++)Qi[mr][Or]=-Qi[mr][Or];break}if(ra>=$e-1)throw"Error: no convergence.";for(ea=Hi[Pr],Ji=Hi[Or-1],Xi=zi[Or-1],Ki=zi[Or],Zi=((Ji-ta)*(Ji+ta)+(Xi-Ki)*(Xi+Ki))/(2*Ki*Ji),Xi=Gi(Zi,1),Zi=Zi<0?((ea-ta)*(ea+ta)+Ki*(Ji/(Zi-Xi)-Ki))/ea:((ea-ta)*(ea+ta)+Ki*(Ji/(Zi+Xi)-Ki))/ea,_t=1,na=1,lr=Pr+1;lr<Or+1;lr++){for(Xi=zi[lr],Ji=Hi[lr],Ki=na*Xi,Xi=_t*Xi,ta=Gi(Zi,Ki),zi[lr-1]=ta,_t=Zi/ta,na=Ki/ta,Zi=ea*_t+Xi*na,Xi=-ea*na+Xi*_t,Ki=Ji*na,Ji*=_t,mr=0;mr<qi;mr++)ea=Qi[mr][lr-1],ta=Qi[mr][lr],Qi[mr][lr-1]=ea*_t+ta*na,Qi[mr][lr]=-ea*na+ta*_t;for(ta=Gi(Zi,Ki),Hi[lr-1]=ta,_t=Zi/ta,na=Ki/ta,Zi=_t*Xi+na*Ji,ea=-na*Xi+_t*Ji,mr=0;mr<gi;mr++)Ji=dn[mr][lr-1],ta=dn[mr][lr],dn[mr][lr-1]=Ji*_t+ta*na,dn[mr][lr]=-Ji*na+ta*_t}zi[Pr]=0,zi[Or]=Zi,Hi[Or]=ea}for(lr=0;lr<Hi.length;lr++)Hi[lr]<F&&(Hi[lr]=0);for(lr=0;lr<qi;lr++)for(mr=lr-1;mr>=0;mr--)if(Hi[mr]<Hi[lr]){for(_t=Hi[mr],Hi[mr]=Hi[lr],Hi[lr]=_t,Or=0;Or<dn.length;Or++)E=dn[Or][lr],dn[Or][lr]=dn[Or][mr],dn[Or][mr]=E;for(Or=0;Or<Qi.length;Or++)E=Qi[Or][lr],Qi[Or][lr]=Qi[Or][mr],Qi[Or][mr]=E;lr=mr}return{U:dn,S:Hi,V:Qi}}})),import_numeric_1_2_6=__toESM(require_numeric_1_2_6());function createInstance({define_e:D=!0,define_pi:E=!0,define_i:F=!0,pow_strict:J=!0}={}){let $e={...all};delete $e.createTau,delete $e.createPhi,D||delete $e.createE,E||delete $e.createPi,F||delete $e.createI;let _t=create$1($e);_t.import(import_numeric_1_2_6.default,{wrap:!0,silent:!0});var lr=_t.pow;function mr(Or,Pr){return Pr===0&&typeof Or=="number"&&(Or===0||!Number.isFinite(Or))?NaN:lr(Or,Pr)}return J?_t.import({pow:mr},{override:!0}):_t.import({pow:lr},{override:!0}),_t.define_e=D,_t.define_pi=E,_t.define_i=F,_t.pow_strict=J,_t}var mathjs_default=createInstance(),function_normalizations={ln:"log",arccos:"acos",arccosh:"acosh",arcsin:"asin",arcsinh:"asinh",arctan:"atan",arctanh:"atanh",arcsec:"asec",arcsech:"asech",arccsc:"acsc",arccsch:"acsch",arccot:"acot",arccoth:"acoth",cosec:"csc"},create_trig_inverses_for=["cos","cosh","sin","sinh","tan","tanh","sec","sech","csc","csch","cot","coth"],move_exponents_outside_for=["cos","cosh","sin","sinh","tan","tanh","sec","sech","csc","csch","cot","coth","log","ln"];function normalize_function_names(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(F==="apply"){if(J[0]==="sqrt")return["^",normalize_function_names(J[1]),.5];if(J[0]==="cbrt")return["^",normalize_function_names(J[1]),["/",1,3]];if(J[0]==="nthroot")return J.length!==2||J[1][0]!=="tuple"||J[1].length!==3?["^",normalize_function_names(J[1]),.5]:["^",normalize_function_names(J[1][1]),["/",1,normalize_function_names(J[1][2])]];var $e=normalize_function_names_sub(J[0]);$e=["apply",$e];var _t=J.slice(1).map(function(lr){return normalize_function_names(lr)});return _t=_t.length>1?["tuple"].concat(_t):_t[0],$e.push(_t),$e}return F==="^"&&J[0]==="e"&&mathjs_default.define_e?["apply","exp",normalize_function_names(J[1])]:F==="binom"?["apply","nCr",["tuple",normalize_function_names(J[0]),normalize_function_names(J[1])]]:[F].concat(J.map(function(lr){return normalize_function_names(lr)}))}function normalize_function_names_sub(D){if(typeof D=="string")return D in function_normalizations?function_normalizations[D]:D;if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);if(E==="^"&&F.length===2&&F[1]===-1){let J=normalize_function_names_sub(F[0]);if(create_trig_inverses_for.includes(J))return"a"+J}return[E].concat(F.map(function(J){return normalize_function_names_sub(J)}))}function normalize_applied_functions(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(F==="apply"){let $e=J[0];if($e[0]==="^"){let mr=$e[1],Or=$e[2];return Or!==-1&&move_exponents_outside_for.includes(mr)?["^",["apply",mr,normalize_applied_functions(J[1])],Or]:["apply",$e,normalize_applied_functions(J[1])]}let _t=0;for(;$e[0]==="prime";)_t+=1,$e=$e[1];let lr=["apply",$e,normalize_applied_functions(J[1])];for(let mr=0;mr<_t;mr++)lr=["prime",lr];return lr}return[F].concat(J.map(function($e,_t){return normalize_applied_functions($e)}))}function log_subscript_to_two_arg_log(D){var E=get_tree(D);if(!Array.isArray(E))return E;let F=E[0],J=E.slice(1);if(F==="apply"&&J.length===2){let $e=J[0];if(Array.isArray($e)&&$e.length===3&&$e[0]==="_"&&$e[1]==="log")return["apply","log",["tuple",J[1],$e[2]]]}return[F,...J.map(log_subscript_to_two_arg_log)]}function substitute_abs(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);return F==="apply"&&J[0]==="abs"?["^",["^",substitute_abs(J[1]),2],.5]:[F].concat(J.map(function($e){return substitute_abs($e)}))}function constants_to_floats(D){var E=get_tree(D);if(!(mathjs_default.define_e||mathjs_default.define_pi))return E;if(typeof E=="string"){if(E==="e"){if(mathjs_default.define_e)return mathjs_default.e}else if(E==="pi"&&mathjs_default.define_pi)return mathjs_default.pi;return E}if(!Array.isArray(E))return E;let F=E[0],J=E.slice(1);return F==="^"&&J[0]==="e"?["^","e",constants_to_floats(J[1])]:[F,...J.map(constants_to_floats)]}function normalize_angle_linesegment_arg_order(D){var E=get_tree(D);if(!Array.isArray(E))return E;let F=E[0],J=E.slice(1);return F==="angle"&&J.length===3&&compare_function(J[0],J[2])===1||F==="linesegment"&&J.length===2&&compare_function(J[0],J[1])===1?(J.reverse(),[F,...J]):[F,...J.map(normalize_angle_linesegment_arg_order)]}function normalize_negative_numbers(D){var E=get_tree(D);function F(_t){if(typeof _t=="number"&&_t>=0)return[-_t,!0];if(!Array.isArray(_t))return[_t,!1];if(_t[0]==="*"&&typeof _t[1]=="number"&&_t[1]>=0)return[["*",-_t[1],..._t.slice(2).map(normalize_negative_numbers)],!0];if(_t[0]==="/"&&_t.length===3){let[lr,mr]=F(_t[1]);if(mr)return[["/",lr,normalize_negative_numbers(_t[2])],!0]}return[_t,!1]}if(!Array.isArray(E))return E;let J=E[0],$e=E.slice(1);if(J==="-"&&$e.length===1){if(typeof $e[0]=="number"&&$e[0]>=0)return-$e[0];if(Array.isArray($e[0])&&$e[0][0]==="*"){let[_t,lr]=F($e[0][1]);if(lr)return["*",_t,...$e[0].slice(2).map(normalize_negative_numbers)]}if(Array.isArray($e[0])&&$e[0][0]==="/"&&$e[0].length===3){let[_t,lr]=F($e[0][1]);if(lr)return["/",_t,normalize_negative_numbers($e[0][2])]}}return[J,...$e.map(normalize_negative_numbers)]}function tuples_to_vectors(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(F==="tuple")return["vector"].concat(J.map(function($e,_t){return tuples_to_vectors($e)}));if(F==="apply"){if(J[1][0]==="tuple"){let $e=tuples_to_vectors(J[0]),_t=J[1].slice(1);return["apply",$e,["tuple"].concat(_t.map(function(lr,mr){return tuples_to_vectors(lr)}))]}}else if(F==="gts"||F==="lts"||F==="interval"){let $e=J[0],_t=J[1];if($e[0]!=="tuple"||_t[0]!=="tuple")throw Error("Badly formed ast");return[F,["tuple"].concat($e.slice(1).map(function(lr,mr){return tuples_to_vectors(lr)})),_t]}else if(F==="matrix"){let $e=J[0],_t=J[1];return $e=["tuple"].concat($e.slice(1).map(tuples_to_vectors)),_t=["tuple"].concat(_t.slice(1).map(lr=>["tuple"].concat(lr.slice(1).map(tuples_to_vectors)))),["matrix",$e,_t]}return[F].concat(J.map(function($e,_t){return tuples_to_vectors($e)}))}function to_intervals(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(F==="tuple"&&J.length===2){let $e=["tuple"].concat(J.map(function(_t,lr){return to_intervals(_t)}));return $e=["interval",$e,["tuple",!1,!1]],$e}if(F==="array"&&J.length===2){let $e=["tuple"].concat(J.map(function(_t,lr){return to_intervals(_t)}));return $e=["interval",$e,["tuple",!0,!0]],$e}if(F==="apply"){if(J[1][0]==="tuple"){let $e=to_intervals(J[0]),_t=J[1].slice(1);return["apply",$e,["tuple"].concat(_t.map(function(lr,mr){return to_intervals(lr)}))]}}else if(F==="gts"||F==="lts"||F==="interval"){let $e=J[0],_t=J[1];if($e[0]!=="tuple"||_t[0]!=="tuple")throw Error("Badly formed ast");return[F,["tuple"].concat($e.slice(1).map(function(lr,mr){return to_intervals(lr)})),_t]}return[F].concat(J.map(function($e,_t){return to_intervals($e)}))}function altvectors_to_vectors(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);return F==="altvector"?["vector"].concat(J.map(function($e,_t){return altvectors_to_vectors($e)})):[F].concat(J.map(function($e,_t){return altvectors_to_vectors($e)}))}function padNumberStringToDigits(D,E){let F=Math.floor(E);if(F>0){if(D.includes(".")){if(D[0]==="0"?F+=D.match(/^0\\.0*/)[0].length:F++,D.length<F){let J=F-D.length;D+="0".repeat(J)}}else if(D.length<F){let J=F-D.length;D+="."+"0".repeat(J)}}return D}function padNumberStringToDecimals(D,E){let F=Math.floor(E);if(F>0)if(D.includes(".")){let J=D.match(/\\.\\d*$/)[0].length-1;if(J<F){let $e=F-J;D+="0".repeat($e)}}else D+="."+"0".repeat(F);return D}function padNumberStringToDigitsAndDecimals(D,E,F){let J=Math.floor(E);if(!(J>0))return padNumberStringToDecimals(D,F);let $e=Math.floor(F);if(!($e>0))return padNumberStringToDigits(D,E);if(D.includes(".")){D[0]==="0"?J+=D.match(/^0\\.0*/)[0].length:J++;let _t=0;D.length<J&&(_t=J-D.length);let lr=D.match(/\\.\\d*$/)[0].length-1;lr<$e&&(_t=Math.max(_t,$e-lr)),_t>0&&(D+="0".repeat(_t))}else{let _t=0;D.length<J&&(_t=J-D.length),_t=Math.max(_t,$e),D+="."+"0".repeat(_t)}return D}function remove_leading_negative_factor(D){if(typeof D=="number"&&D<0)return[-D,!0];if(!Array.isArray(D))return[D,!1];if(D[0]==="-"&&D.length===2)return[D[1],!0];if(D[0]==="*"&&D.length>=2){let E=D[1];if(typeof E=="number"&&E<0)return[["*",-E,...D.slice(2)],!0];if(Array.isArray(E)&&E[0]==="-"&&E.length===2)return[["*",E[1],...D.slice(2)],!0]}return[D,!1]}function normalize_display_negative_fractions_sub(D,{inside_unary_minus:E=!1}={}){if(!Array.isArray(D))return D;let F=D[0],J=D.slice(1);if(F==="-"&&J.length===1)return["-",normalize_display_negative_fractions_sub(J[0],{inside_unary_minus:!0})];if(F==="+")return["+",...J.map($e=>normalize_display_negative_fractions_sub($e,{inside_unary_minus:!1}))];if(F==="*"){if(J.length===0)return D;let $e=[normalize_display_negative_fractions_sub(J[0],{inside_unary_minus:!1})];for(let _t=1;_t<J.length;_t+=1)$e.push(normalize_display_negative_fractions_sub(J[_t],{inside_unary_minus:!1}));return["*",...$e]}if(F==="/"&&J.length===2){let $e=J[0],_t=J[1];if(!E){let[lr,mr]=remove_leading_negative_factor($e);if(mr)return["-",["/",normalize_display_negative_fractions_sub(lr,{inside_unary_minus:!1}),normalize_display_negative_fractions_sub(_t,{inside_unary_minus:!1})]]}return["/",normalize_display_negative_fractions_sub($e,{inside_unary_minus:!1}),normalize_display_negative_fractions_sub(_t,{inside_unary_minus:!1})]}return[F,...J.map($e=>normalize_display_negative_fractions_sub($e,{inside_unary_minus:!1}))]}function normalize_display_negative_fractions(D){return normalize_display_negative_fractions_sub(D,{inside_unary_minus:!1})}function expandScientificNotation(D){let E=D.indexOf("e");if(E===-1)return D;let F=D.substring(0,E),J=Number(D.substring(E+1)),$e="";(F[0]==="-"||F[0]==="+")&&($e=F[0]==="-"?"-":"",F=F.substring(1));let _t=F.indexOf(".");_t===-1&&(_t=F.length);let lr=F.replace(".",""),mr=_t+J;return mr<=0?$e+"0."+"0".repeat(-mr)+lr:mr>=lr.length?$e+lr+"0".repeat(mr-lr.length):$e+lr.substring(0,mr)+"."+lr.substring(mr)}var unicode_operators={"+":function(D){return D.join(" ")},"-":function(D){return"-"+D[0]},pm:function(D){return"± "+D[0]},"*":function(D){return D.join(" ")},"/":function(D){return D[0]+"/"+D[1]},_:function(D){return D[0]+"_"+D[1]},"^":function(D){return D[0]+"^"+D[1]},prime:function(D){return D[0]+"\'"},tuple:function(D){return"( "+D.join(", ")+" )"},array:function(D){return"[ "+D.join(", ")+" ]"},list:function(D){return D.join(", ")},set:function(D){return"{ "+D.join(", ")+" }"},vector:function(D){return"( "+D.join(", ")+" )"},altvector:function(D){return"⟨ "+D.join(", ")+" ⟩"},interval:function(D){return"( "+D.join(", ")+" )"},matrix:function(D){return"( "+D.join(", ")+" )"},and:function(D){return D.join(" and ")},or:function(D){return D.join(" or ")},not:function(D){return"not "+D[0]},"=":function(D){return D.join(" = ")},"<":function(D){return D.join(" < ")},">":function(D){return D.join(" > ")},lts:function(D){return D.join(" < ")},gts:function(D){return D.join(" > ")},le:function(D){return D.join(" ≤ ")},ge:function(D){return D.join(" ≥ ")},ne:function(D){return D.join(" ≠ ")},forall:function(D){return"∀ "+D[0]},exists:function(D){return"∃ "+D[0]},in:function(D){return D[0]+" ∈ "+D[1]},notin:function(D){return D[0]+" ∉ "+D[1]},ni:function(D){return D[0]+" ∋ "+D[1]},notni:function(D){return D[0]+" ∌ "+D[1]},subset:function(D){return D[0]+" ⊂ "+D[1]},subseteq:function(D){return D[0]+" ⊆ "+D[1]},notsubset:function(D){return D[0]+" ⊄ "+D[1]},notsubseteq:function(D){return D[0]+" ⊈ "+D[1]},superset:function(D){return D[0]+" ⊃ "+D[1]},superseteq:function(D){return D[0]+" ⊇ "+D[1]},notsuperset:function(D){return D[0]+" ⊅ "+D[1]},notsuperseteq:function(D){return D[0]+" ⊉ "+D[1]},union:function(D){return D.join(" ∪ ")},intersect:function(D){return D.join(" ∩ ")},rightarrow:function(D){return D.join(" → ")},leftarrow:function(D){return D.join(" ← ")},leftrightarrow:function(D){return D.join(" ↔ ")},implies:function(D){return D.join(" ⟹ ")},impliedby:function(D){return D.join(" ⟸ ")},iff:function(D){return D.join(" ⟺ ")},perp:function(D){return D.join(" ⟂ ")},parallel:function(D){return D.join(" ∥ ")},derivative_leibniz:function(D){return"d"+D[0]+"/d"+D[1]},partial_derivative_leibniz:function(D){return"∂"+D[0]+"/∂"+D[1]},"|":function(D){return D[0]+" | "+D[1]},":":function(D){return D[0]+" : "+D[1]},binom:function(D){return"binom( "+D[0]+", "+D[1]+" )"},vec:function(D){return"vec("+D[0]+")"},linesegment:function(D){return"linesegment( "+D.join(", ")+" )"},angle:function(D,E){return E?"∠"+D.join(""):"∠( "+D.join(", ")+" )"},unit:function(D){return D[0]+" "+D[1]}},nonunicode_operators={"+":function(D){return D.join(" ")},"-":function(D){return"-"+D[0]},pm:function(D){return"plusminus "+D[0]},"*":function(D){return D.join(" ")},"/":function(D){return D[0]+"/"+D[1]},_:function(D){return D[0]+"_"+D[1]},"^":function(D){return D[0]+"^"+D[1]},prime:function(D){return D[0]+"\'"},tuple:function(D){return"( "+D.join(", ")+" )"},array:function(D){return"[ "+D.join(", ")+" ]"},list:function(D){return D.join(", ")},set:function(D){return"{ "+D.join(", ")+" }"},vector:function(D){return"( "+D.join(", ")+" )"},altvector:function(D){return"( "+D.join(", ")+" )"},interval:function(D){return"( "+D.join(", ")+" )"},matrix:function(D){return"( "+D.join(", ")+" )"},and:function(D){return D.join(" and ")},or:function(D){return D.join(" or ")},not:function(D){return"not "+D[0]},"=":function(D){return D.join(" = ")},"<":function(D){return D.join(" < ")},">":function(D){return D.join(" > ")},lts:function(D){return D.join(" < ")},gts:function(D){return D.join(" > ")},le:function(D){return D.join(" <= ")},ge:function(D){return D.join(" >= ")},ne:function(D){return D.join(" ne ")},forall:function(D){return"forall "+D[0]},exists:function(D){return"exists "+D[0]},in:function(D){return D[0]+" elementof "+D[1]},notin:function(D){return D[0]+" notelementof "+D[1]},ni:function(D){return D[0]+" containselement "+D[1]},notni:function(D){return D[0]+" notcontainselement "+D[1]},subset:function(D){return D[0]+" subset "+D[1]},subseteq:function(D){return D[0]+" subseteq "+D[1]},notsubset:function(D){return D[0]+" notsubset "+D[1]},notsubseteq:function(D){return D[0]+" notsubseteq "+D[1]},superset:function(D){return D[0]+" superset "+D[1]},superseteq:function(D){return D[0]+" superseteq "+D[1]},notsuperset:function(D){return D[0]+" notsuperset "+D[1]},notsuperseteq:function(D){return D[0]+" notsuperseteq "+D[1]},union:function(D){return D.join(" union ")},intersect:function(D){return D.join(" intersect ")},rightarrow:function(D){return D.join(" rightarrow ")},leftarrow:function(D){return D.join(" leftarrow ")},leftrightarrow:function(D){return D.join(" leftrightarrow ")},implies:function(D){return D.join(" implies ")},impliedby:function(D){return D.join(" impliedby ")},iff:function(D){return D.join(" iff ")},perp:function(D){return D.join(" perp ")},parallel:function(D){return D.join(" parallel ")},derivative_leibniz:function(D){return"d"+D[0]+"/d"+D[1]},partial_derivative_leibniz:function(D){return"∂"+D[0]+"/∂"+D[1]},"|":function(D){return D[0]+" | "+D[1]},":":function(D){return D[0]+" : "+D[1]},binom:function(D){return"binom( "+D[0]+", "+D[1]+" )"},vec:function(D){return"vec("+D[0]+")"},linesegment:function(D){return"linesegment( "+D.join(", ")+" )"},angle:function(D,E){return E?"angle "+D.join(""):"angle( "+D.join(", ")+" )"},unit:function(D){return D[0]+" "+D[1]}},output_unicodeDefault=!0,astToText$2=class{constructor({output_unicode:D=output_unicodeDefault,padToDigits:E=null,padToDecimals:F=null,avoidScientificNotation:J=!1,showBlanks:$e=!0,explicitMultiplicationSymbols:_t=!1}={}){this.output_unicode=D,this.operators=unicode_operators,D||(this.operators=nonunicode_operators),this.padToDigits=E,this.padToDecimals=F,this.avoidScientificNotation=J,this.showBlanks=$e,this.explicitMultiplicationSymbols=_t}convert(D){return this.statement(normalize_display_negative_fractions(D))}statement(D){if(!Array.isArray(D))return this.single_statement(D);let E=D[0],F=D.slice(1);if(E==="ldots")return"...";if(!(E in this.operators)&&E!=="apply")throw Error("Badly formed ast: operator "+E+" not recognized.");return["implies","impliedby","iff","rightarrow","leftarrow","leftrightarrow"].includes(E)?this.operators[E](F.map(J=>this.statement(J))):E==="and"||E==="or"?this.operators[E](F.map((function(J,$e){let _t=this.single_statement(J);return _t.match(/ /)&&!_t.match(/^\\(.*\\)$/)?"("+_t+")":_t}).bind(this))):this.single_statement(D)}single_statement(D){if(!Array.isArray(D))return this.expression(D);let E=D[0],F=D.slice(1);if(E==="not")return this.operators[E](F.map((function(J,$e){let _t=this.single_statement(J);return _t.match(/ /)&&!_t.match(/^\\(.*\\)$/)?"("+_t+")":_t}).bind(this)));if(E==="exists"||E==="forall")return this.operators[E]([this.single_statement(F[0])]);if(E==="="||E==="ne"||E==="<"||E===">"||E==="le"||E==="ge"||E==="in"||E==="notin"||E==="ni"||E==="notni"||E==="subset"||E==="notsubset"||E==="subseteq"||E==="notsubseteq"||E==="superset"||E==="notsuperset"||E==="superseteq"||E==="notsuperseteq")return this.operators[E](F.map((function(J,$e){return this.expression(J)}).bind(this)));if(E==="lts"||E==="gts"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=this.expression(J[1]);for(let lr=1;lr<J.length-1;lr++)$e[lr]?E==="lts"?_t+=" < ":_t+=" > ":E==="lts"?this.output_unicode?_t+=" ≤ ":_t+=" <= ":this.output_unicode?_t+=" ≥ ":_t+=" >= ",_t+=this.expression(J[lr+1]);return _t}return this.expression(D)}expression(D){if(!Array.isArray(D))return this.term(D);let E=D[0],F=D.slice(1);return E==="+"?F.length===1?"+"+this.term(F[0]):this.operators[E](F.map((function(J,$e){return $e>0?this.termWithPlusIfNotNegated(J):this.term(J)}).bind(this))):["union","intersect","perp","parallel"].includes(E)?this.operators[E](F.map((function(J,$e){return this.term(J)}).bind(this))):this.term(D)}term(D){if(!Array.isArray(D))return this.factor(D);let E=D[0],F=D.slice(1);if(E==="-"||E==="pm")return this.operators[E](F.map((function(J,$e){return this.term(J)}).bind(this)));if(E==="*"){let J=F.map((function($e,_t){let lr;return _t>0?(lr=this.factorWithParenthesesIfNegatedOrExplicitPlus($e),!this.explicitMultiplicationSymbols&&lr.match(/^[0-9]/)?"* "+lr:$e[0]==="angle"&&F.length>1?"( "+lr+" )":lr):(lr=this.factor($e),$e[0]==="angle"&&F.length>1?"( "+lr+" )":lr)}).bind(this));return this.explicitMultiplicationSymbols?J.join("*"):this.operators[E](J)}if(E==="/"){let J=this.factor(F[0]),$e=this.factor(F[1]);return this.simple_factor_or_function_or_parens(F[0])||(J="("+J+")"),this.simple_factor_or_function_or_parens(F[1])||($e="("+$e+")"),this.operators[E]([J,$e])}return E==="unit"?this.operators[E](F.map((function(J,$e){return this.expression(J)}).bind(this))):this.factor(D)}symbolConvert(D){let E={alpha:"α",beta:"β",Gamma:"Γ",gamma:"γ",Delta:"Δ",delta:"δ",epsilon:"ε",zeta:"ζ",eta:"η",Theta:"ϴ",theta:"θ",iota:"ι",kappa:"κ",Lambda:"Λ",lambda:"λ",mu:"μ",nu:"ν",Xi:"Ξ",xi:"ξ",Pi:"Π",pi:"π",rho:"ρ",Sigma:"Σ",sigma:"σ",tau:"τ",Upsilon:"Υ",upsilon:"υ",Phi:"Φ",phi:"ϕ",Psi:"Ψ",psi:"ψ",Omega:"Ω",omega:"ω",perp:"⟂",int:"∫",emptyset:"∅"};return this.output_unicode&&D in E?E[D]:!this.showBlanks&&D==="＿"?"":D}simple_factor_or_function_or_parens(D){let E=this.factor(D);return E.length<=1||typeof D=="string"&&D.match(/^\\w+$/)||Array.isArray(D)&&D[0]==="apply"||E.match(/^\\(.*\\)$/)||E.match(/^⟨.*⟩$/)?!0:typeof D=="number"?!!(D>=0&&(this.avoidScientificNotation||!D.toString().includes("e"))):!1}factor(D){if(typeof D=="string")return this.symbolConvert(D);if(typeof D=="number"){if(D===1/0)return this.output_unicode?"∞":"infinity";if(D===-1/0)return this.output_unicode?"-∞":"-infinity";if(Number.isNaN(D))return"NaN";{let J=D.toString(),$e=J.indexOf("e");if($e===-1||this.avoidScientificNotation)return $e!==-1&&this.avoidScientificNotation&&(J=expandScientificNotation(J)),(this.padToDigits!==null||this.padToDecimals!==null)&&(J=padNumberStringToDigitsAndDecimals(J,this.padToDigits,this.padToDecimals)),J;let _t=J.substring(0,$e),lr=J.substring($e+1);if(this.padToDigits!==null||this.padToDecimals!==null){let mr=Number(lr);if(mr>0&&this.padToDecimals!==null)return J=D.toLocaleString("fullwide",{useGrouping:!1}),padNumberStringToDigitsAndDecimals(J,this.padToDigits,this.padToDecimals);{let Or=null;this.padToDecimals!==null&&(Or=this.padToDecimals+mr),_t=padNumberStringToDigitsAndDecimals(_t,this.padToDigits,Or)}}return lr[0]==="+"?_t+" * 10^"+lr.substring(1):_t+" * 10^("+lr+")"}}if(!Array.isArray(D))return"";let E=D[0],F=D.slice(1);if(E==="^"){if(Number.isInteger(F[0])&&Number.isInteger(F[1])){let lr;return lr=F[0]<0?"("+F[0].toString()+")":F[0].toString(),F[1]<0?lr+"^("+F[1].toString()+")":lr+"^"+F[1].toString()}let J=this.factor(F[0]),$e=F[0];for(;$e[0]==="prime";)$e=$e[1];this.simple_factor_or_function_or_parens($e)||$e[0]==="_"&&typeof $e[1]=="string"||(J="("+J.toString()+")");let _t=this.factor(F[1]);return this.simple_factor_or_function_or_parens(F[1])||(_t="("+_t.toString()+")"),J+"^"+_t}else{if(E==="_")return this.operators[E](F.map((function(J,$e){let _t=this.factor(J);return this.simple_factor_or_function_or_parens(J)?_t:"("+_t+")"}).bind(this)));if(E==="prime"){let J=F[0],$e=1;for(;J[0]==="prime";)$e+=1,J=J[1];let _t=this.factor(J);this.simple_factor_or_function_or_parens(J)||J[0]==="_"&&typeof J[1]=="string"||(_t="("+_t+")");for(let lr=0;lr<$e;lr++)_t+="\'";return _t}else{if(E==="-")return this.operators[E](F.map((function(J,$e){return this.term(J)}).bind(this)));if(E==="tuple"||E==="array"||E==="list"||E==="set"||E==="vector"||E==="altvector"||E==="|"||E===":"||E==="binom"||E==="vec"||E==="linesegment")return this.operators[E](F.map((function(J,$e){return this.statement(J)}).bind(this)));if(E==="interval"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=this.statement(J[1])+", "+this.statement(J[2]);return _t=$e[1]?"[ "+_t:"( "+_t,$e[2]?_t+=" ]":_t+=" )",_t}else if(E==="matrix"){let J=F[0],$e=F[1],_t="[ ";for(let lr=0;lr<J[1];lr+=1){_t+="[ ";for(let mr=0;mr<J[2];mr+=1)_t+=this.statement($e[lr+1][mr+1]),mr<J[2]-1&&(_t+=","),_t+=" ";_t+="]",lr<J[1]-1&&(_t+=","),_t+=" "}return _t+="]",_t}else if(E==="derivative_leibniz"||E==="partial_derivative_leibniz"){let J="d";E==="partial_derivative_leibniz"&&(J="∂");let $e=F[0],_t=F[1],lr=1,mr="";Array.isArray($e)?(mr=$e[1],lr=$e[2]):mr=$e;let Or=J;lr>1&&(Or=Or+"^"+lr),Or=Or+this.symbolConvert(mr)+"/";let Pr=1;Array.isArray(_t)&&(Pr=_t.length-1);for(let dn=1;dn<=Pr;dn++){let gi=_t[dn],qi=1,zi="";Array.isArray(gi)?(zi=gi[1],qi=gi[2]):zi=gi,Or=Or+J+this.symbolConvert(zi),qi>1&&(Or=Or+"^"+qi)}return Or}else if(E==="apply"){if(F[0]==="abs")return"|"+this.statement(F[1])+"|";if(F[0]==="factorial"){let lr=this.factor(F[1]);return this.simple_factor_or_function_or_parens(F[1])||F[1][0]==="_"&&typeof F[1][1]=="string"?lr+"!":"("+lr+")!"}let J=F[0];if(J[0]==="^"&&(J=J[1]),J[0]==="_"&&(J=J[1]),J==="int"){let lr=this.factor(F[0]),mr=F[1],Or;if(Array.isArray(mr)&&mr[0]==="*"){let Pr=[],dn=["*"];for(let gi=1;gi<mr.length;gi++){let qi=mr[gi];Array.isArray(qi)&&qi[0]==="d"?Pr.push(qi):dn.push(qi)}Or=this.term(dn),Pr.length>0&&(Or+=" "+Pr.map(gi=>"d"+this.factor(gi[1])).join(" "))}return Or||=this.term(F[1]),lr+" "+Or}let $e=this.factor(F[0]),_t=this.statement(F[1]);return F[1][0]!=="tuple"&&(_t="("+_t+")"),$e+_t}else if(E==="angle"){let J=F.every($e=>{if(typeof $e=="string"&&$e.length===1)return!0;if(!Array.isArray($e))return!1;let _t=$e[0];return _t==="_"||_t==="^"||_t==="prime"});return this.operators[E](F.map((function($e,_t){return this.statement($e)}).bind(this)),J)}else return E==="+"&&D.length===2?"+ "+this.factor(D[1]):"("+this.statement(D)+")"}}}factorWithParenthesesIfNegatedOrExplicitPlus(D){var E=this.factor(D);return E.match(/^-/)||E.match(/^\\+/)?"("+E+")":E}termWithPlusIfNotNegated(D){let E=this.term(D);return E.match(/^± /)||E.match(/^plusminus /)?E:E.match(/^-/)?E.match(/^-[^ ]/)?"- "+E.slice(1):E:"+ "+E}},astToText$1=new astToText$2;function subscripts_to_strings(D,E=!1){var F=get_tree(D);if(!Array.isArray(F))return F;let J=F[0],$e=F.slice(1);return J==="_"&&(E||$e.every(_t=>["number","string"].includes(typeof _t)))?astToText$1.convert(F):[J].concat($e.map(_t=>subscripts_to_strings(_t,E)))}function strings_to_subscripts(D){var E=get_tree(D);if(typeof E=="string"){let $e=E.match(/^([0-9a-zA-Z]+)_([a-zA-Z]+|[0-9]+)$/);if($e){let _t=Number($e[1]);isNaN(_t)&&(_t=$e[1]);let lr=Number($e[2]);return isNaN(lr)&&(lr=$e[2]),["_",_t,lr]}else return E}if(!Array.isArray(E))return E;let F=E[0],J=E.slice(1);return[F].concat(J.map(strings_to_subscripts))}var normalization_exports=__exportAll({altvectors_to_vectors:()=>altvectors_to_vectors,constants_to_floats:()=>constants_to_floats,default_order:()=>default_order,log_subscript_to_two_arg_log:()=>log_subscript_to_two_arg_log,normalize_angle_linesegment_arg_order:()=>normalize_angle_linesegment_arg_order,normalize_applied_functions:()=>normalize_applied_functions,normalize_function_names:()=>normalize_function_names,normalize_negative_numbers:()=>normalize_negative_numbers,strings_to_subscripts:()=>strings_to_subscripts,subscripts_to_strings:()=>subscripts_to_strings,substitute_abs:()=>substitute_abs,to_intervals:()=>to_intervals,tuples_to_vectors:()=>tuples_to_vectors});function get_all_units(){return{"%":{scale:D=>["/",D,100],only_scales:!0},$:{prefix:!0,scale:D=>D},deg:{scale:D=>["/",["*",D,"pi"],180],only_scales:!0}}}var all_units$1=get_all_units();function get_unit_of_tree(D){if(D[0]==="unit"){for(let E in all_units$1)if(all_units$1[E].prefix){if(D[1]===E)return E}else if(D[2]===E)return E}return null}function get_unit_value_of_tree(D){if(D[0]==="unit"){for(let E in all_units$1)if(all_units$1[E].prefix){if(D[1]===E)return[E,D[2]]}else if(D[2]===E)return[E,D[1]]}return null}function remove_duplicate_negatives(D){if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);return E==="-"&&Array.isArray(F[0])&&F[0][0]==="-"?remove_duplicate_negatives(F[0][1]):E==="-"&&typeof F[0]=="number"&&F[0]<0?-F[0]:(F=F.map(remove_duplicate_negatives),[E].concat(F))}function normalize_negatives_in_factors(D){if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);if(F=F.map(normalize_negatives_in_factors),E!=="*"&&E!=="/")return[E].concat(F);for(var J=1,$e=[],_t=0;_t<F.length;_t++)Array.isArray(F[_t])&&F[_t][0]==="-"?(J*=-1,$e.push(F[_t][1])):typeof F[_t]=="number"&&F[_t]<0?(J*=-1,$e.push(-F[_t])):$e.push(F[_t]);var lr=[E].concat($e);return J===-1&&(lr=["-",lr]),lr}function normalize_negatives(D){var E=get_tree(D);return E=remove_duplicate_negatives(E),E=normalize_negatives_in_factors(E),E=remove_duplicate_negatives(E),E=normalize_negative_numbers(E),E}function sort_key(D,E={}){if(typeof D=="number")return E.ignore_negatives?[0,"number",Math.abs(D)]:[0,"number",D];if(typeof D=="string")return D==="-"||D==="+"?[8,"plus_minus_string",D]:[1,"symbol",D];if(typeof D=="boolean")return[1,"boolean",D];if(!Array.isArray(D))return[-1,"unknown",D];var F=D[0],J=D.slice(1);if(F==="^"&&J.length===2)return[...sort_key(J[0],E),"power",...sort_key(J[1],E)];if(F==="apply"){var $e=[2,"function",J[0]];(J[0]==="sqrt"||J[0]==="cbrt"||J[0]==="nthroot")&&($e=[5,"root",J[0]==="sqrt"?2:J[0]==="cbrt"?3:J[1][2]??2]);var _t=J[1],lr=1,mr=[];return Array.isArray(_t)?(_t=_t.slice(1),lr=_t.length,mr=_t.map(dn=>sort_key(dn,E))):mr=[sort_key(_t,E)],$e.push([lr,mr]),$e}else if(F==="unit"){let[dn,gi]=get_unit_value_of_tree(D);if(dn){let qi=sort_key(gi,E);return qi[1]+="_"+dn,qi}}var Or=J.length,Pr=J.map(sort_key,E);return F==="*"?[4,"product",Or,Pr]:F==="/"?[4,"quotient",Or,Pr]:F==="+"?[5,"sum",Or,Pr]:F==="-"?E.ignore_negatives?Pr[0]:[6,"minus",Or,Pr]:F==="pm"?E.ignore_negatives?Pr[0]:[6,"pm",Or,Pr]:["tuple","vector","altvector"].includes(F)?[7,Or,Pr]:F==="interval"?J[1][1]===!1?J[1][2]===!1?[7,...Pr[0].slice(1)]:[8,Or,Pr]:J[1][2]===!1?[8,Or,Pr]:[9,...Pr[0].slice(1)]:F==="array"?[9,Or,Pr]:[10,F,Or,Pr]}function arrayCompare(D,E){if(Array.isArray(D))if(Array.isArray(E)){let F=Math.min(D.length,E.length);for(let J=0;J<F;J++){let $e=arrayCompare(D[J],E[J]);if($e!==0)return $e}return D.length<E.length?-1:+(D.length>E.length)}else return 1;else return Array.isArray(E)||D<E?-1:+(D>E)}function compare_function(D,E,F={}){return arrayCompare(sort_key(D,F),sort_key(E,F))}function coeff_factors_from_term(D,E){if(typeof D=="string"){let F=E.indexOf(D);F===-1&&(E.push(D),F=E.length-1);let J=[];return J[F]=1,{factor_contains:J,coeff:1}}else if(Array.isArray(D)){let F=D[0],J=D.slice(1);if(F==="*"){let $e=[],_t=[];for(let lr of J){if(typeof lr=="string"){let mr=E.indexOf(lr);mr===-1&&(E.push(lr),mr=E.length-1),_t[mr]===void 0&&(_t[mr]=0),_t[mr]++;continue}else if(Array.isArray(lr)&&(lr[0]==="^"||lr[0]==="-")){let mr=coeff_factors_from_term(lr,E);for(let Or in mr.factor_contains)_t[Or]===void 0&&(_t[Or]=0),_t[Or]+=mr.factor_contains[Or];mr.coeff!==1&&$e.push(mr.coeff);continue}$e.push(lr)}return $e=$e.length===0?1:$e.length===1?$e[0]:["*",...$e],{factor_contains:_t,coeff:$e}}else if(F==="^"){let $e=J[0],_t=J[1],lr=[];if(typeof $e=="string"&&Number.isFinite(_t)){let mr=E.indexOf($e);return mr===-1&&(E.push($e),mr=E.length-1),lr[mr]=_t,{factor_contains:lr,coeff:1}}}else if(F==="-"){let $e=coeff_factors_from_term(J[0],E),_t=-1;return typeof $e.coeff=="number"?_t*=$e.coeff:_t=["-",$e.coeff],{factor_contains:$e.factor_contains,coeff:_t}}else if(F==="/"){let $e=coeff_factors_from_term(J[0],E),_t=["/",$e.coeff,J[1]];return{factor_contains:$e.factor_contains,coeff:_t}}}return{factor_contains:[],coeff:D}}function default_order(D,E){E===void 0&&(E={});var F=get_tree(D);F=flatten$5(F),F=normalize_negatives(F);function J($e){if(!Array.isArray($e))return $e;var _t=$e[0],lr=$e.slice(1);if(lr=lr.map(J),_t==="+"){let Pr=[],dn=[],gi=[];for(let Qi of lr){let Gi=coeff_factors_from_term(Qi,Pr);dn.push(Gi.factor_contains),gi.push(Gi.coeff)}let qi=[];for(let[Qi,Gi]of Pr.entries()){let Zi={varname:Gi,exponents_in_term:[]};for(let Xi=0;Xi<dn.length;Xi++)Zi.exponents_in_term.push(dn[Xi][Qi]||0);qi.push(Zi)}qi.sort((Qi,Gi)=>Qi.varname<Gi.varname?-1:1);let zi=[];for(let Qi=0;Qi<gi.length;Qi++){let Gi=qi.reduce((Zi,Xi)=>[...Zi,-Xi.exponents_in_term[Qi]],[]);Gi.push(sort_key(gi[Qi],E)),zi.push(Gi)}let Hi=[];for(let[Qi,Gi]of lr.entries())Hi.push({term:Gi,sort_key:zi[Qi]});Hi.sort((Qi,Gi)=>arrayCompare(Qi.sort_key,Gi.sort_key)),lr=Hi.map(Qi=>Qi.term)}else if(_t==="*"){let Pr=[],dn=[];for(let gi of lr)["tuple","list","vector","altvector","interval","set","array","matrix"].includes(gi[0])?dn.push(gi):Pr.push(gi);Pr.sort((gi,qi)=>compare_function(gi,qi,E)),lr=[...Pr,...dn]}else if(_t==="="||_t==="and"||_t==="or"||_t==="ne"||_t==="union"||_t==="intersect")lr.sort((Pr,dn)=>compare_function(Pr,dn,E));else if(_t===">"||_t==="ge")lr=lr.reverse(),_t=_t===">"?"<":"le";else if(_t==="gts"){var mr=lr[0],Or=lr[1];if(mr[0]!=="tuple"||Or[0]!=="tuple")throw Error("Badly formed ast");mr=["tuple"].concat(mr.slice(1).reverse()),Or=["tuple"].concat(Or.slice(1).reverse()),_t="lts",lr=[mr,Or]}else if(_t==="ni"||_t==="notni"||_t==="superset"||_t==="notsuperset"||_t==="superseteq"||_t==="notsuperseteq")lr=lr.reverse(),_t==="ni"?_t="in":_t==="notni"?_t="notin":_t==="superset"?_t="subset":_t==="notsuperset"?_t="notsubset":_t==="superseteq"?_t="subseteq":_t==="notsuperseteq"&&(_t="notsubseteq");else if(_t==="-"&&lr[0][0]==="*")return lr[0][1]=["-",lr[0][1]],lr[0];return[_t].concat(lr)}return normalize_negatives(J(F))}var variables_exports=__exportAll({functions:()=>functions$2,operators:()=>operators$3,variables:()=>variables});function leaves(D,E){if(!Array.isArray(D))return[D];var F=D[0],J=D.slice(1);return E&&F==="_"&&typeof J[0]=="string"&&(typeof J[1]=="string"||typeof J[1]=="number")?[J[0]+"_"+J[1]]:(F==="apply"&&(J=D.slice(2)),J.length===0?[]:J.map(function($e,_t){return leaves($e,E)}).reduce(function($e,_t){return $e.concat(_t)}))}function variables(D,E=!1){var F=leaves(get_tree(D),E);return F=F.filter(function(J,$e){return typeof J=="string"&&(mathjs_default.define_e||J!=="e")&&(mathjs_default.define_pi||J!=="pi")&&(mathjs_default.define_i||J!=="i")}),F=F.filter(function(J,$e,_t){return $e===F.indexOf(J)}),F}function operators_list(D){if(!Array.isArray(D))return[];var E=D[0],F=D.slice(1);return E==="apply"&&(F=D.slice(2)),F.length===0?[E]:[E].concat(F.map(function(J,$e){return operators_list(J)}).reduce(function(J,$e){return J.concat($e)}))}function operators$3(D){var E=operators_list(get_tree(D));return E=E.filter(function(F,J){return F!=="apply"}),E=E.filter(function(F,J,$e){return J===E.indexOf(F)}),E}function functions_list(D){if(!Array.isArray(D))return[];var E=D[0],F=D.slice(1),J=[];return E==="apply"&&(J=[F[0]],F=D.slice(2)),J.concat(F.map(function($e,_t){return functions_list($e)}).reduce(function($e,_t){return $e.concat(_t)},[]))}function functions$2(D){var E=functions_list(get_tree(D));return E=E.filter(function(F,J,$e){return J===E.indexOf(F)}),E}var VERSION,root,ArrayProto,ObjProto,SymbolProto,push,slice,toString$1,hasOwnProperty,supportsArrayBuffer,supportsDataView,nativeIsArray,nativeKeys,nativeCreate,nativeIsView,_isNaN,_isFinite,hasEnumBug,nonEnumerableProps,MAX_ARRAY_INDEX,init__setup=__esmMin((()=>{VERSION="1.13.6",root=typeof self=="object"&&self.self===self&&self||typeof global=="object"&&global.global===global&&global||Function("return this")()||{},ArrayProto=Array.prototype,ObjProto=Object.prototype,SymbolProto=typeof Symbol<"u"?Symbol.prototype:null,push=ArrayProto.push,slice=ArrayProto.slice,toString$1=ObjProto.toString,hasOwnProperty=ObjProto.hasOwnProperty,supportsArrayBuffer=typeof ArrayBuffer<"u",supportsDataView=typeof DataView<"u",nativeIsArray=Array.isArray,nativeKeys=Object.keys,nativeCreate=Object.create,nativeIsView=supportsArrayBuffer&&ArrayBuffer.isView,_isNaN=isNaN,_isFinite=isFinite,hasEnumBug=!{toString:null}.propertyIsEnumerable("toString"),nonEnumerableProps=["valueOf","isPrototypeOf","toString","propertyIsEnumerable","hasOwnProperty","toLocaleString"],MAX_ARRAY_INDEX=2**53-1}));function restArguments(D,E){return E=E==null?D.length-1:+E,function(){for(var F=Math.max(arguments.length-E,0),J=Array(F),$e=0;$e<F;$e++)J[$e]=arguments[$e+E];switch(E){case 0:return D.call(this,J);case 1:return D.call(this,arguments[0],J);case 2:return D.call(this,arguments[0],arguments[1],J)}var _t=Array(E+1);for($e=0;$e<E;$e++)_t[$e]=arguments[$e];return _t[E]=J,D.apply(this,_t)}}var init_restArguments=__esmMin((()=>{}));function isObject$2(D){var E=typeof D;return E==="function"||E==="object"&&!!D}var init_isObject=__esmMin((()=>{}));function isNull(D){return D===null}var init_isNull=__esmMin((()=>{}));function isUndefined(D){return D===void 0}var init_isUndefined=__esmMin((()=>{}));function isBoolean(D){return D===!0||D===!1||toString$1.call(D)==="[object Boolean]"}var init_isBoolean=__esmMin((()=>{init__setup()}));function isElement(D){return!!(D&&D.nodeType===1)}var init_isElement=__esmMin((()=>{}));function tagTester(D){var E="[object "+D+"]";return function(F){return toString$1.call(F)===E}}var init__tagTester=__esmMin((()=>{init__setup()})),isString_default,init_isString=__esmMin((()=>{init__tagTester(),isString_default=tagTester("String")})),isNumber_default,init_isNumber=__esmMin((()=>{init__tagTester(),isNumber_default=tagTester("Number")})),isDate_default,init_isDate=__esmMin((()=>{init__tagTester(),isDate_default=tagTester("Date")})),isRegExp_default,init_isRegExp=__esmMin((()=>{init__tagTester(),isRegExp_default=tagTester("RegExp")})),isError_default,init_isError=__esmMin((()=>{init__tagTester(),isError_default=tagTester("Error")})),isSymbol_default,init_isSymbol=__esmMin((()=>{init__tagTester(),isSymbol_default=tagTester("Symbol")})),isArrayBuffer_default,init_isArrayBuffer=__esmMin((()=>{init__tagTester(),isArrayBuffer_default=tagTester("ArrayBuffer")})),isFunction,nodelist,isFunction_default,init_isFunction=__esmMin((()=>{init__tagTester(),init__setup(),isFunction=tagTester("Function"),nodelist=root.document&&root.document.childNodes,typeof/./!="function"&&typeof Int8Array!="object"&&typeof nodelist!="function"&&(isFunction=function(D){return typeof D=="function"||!1}),isFunction_default=isFunction})),_hasObjectTag_default,init__hasObjectTag=__esmMin((()=>{init__tagTester(),_hasObjectTag_default=tagTester("Object")})),hasStringTagBug,isIE11,init__stringTagBug=__esmMin((()=>{init__setup(),init__hasObjectTag(),hasStringTagBug=supportsDataView&&_hasObjectTag_default(new DataView(new ArrayBuffer(8))),isIE11=typeof Map<"u"&&_hasObjectTag_default(new Map)}));function ie10IsDataView(D){return D!=null&&isFunction_default(D.getInt8)&&isArrayBuffer_default(D.buffer)}var isDataView,isDataView_default,init_isDataView=__esmMin((()=>{init__tagTester(),init_isFunction(),init_isArrayBuffer(),init__stringTagBug(),isDataView=tagTester("DataView"),isDataView_default=hasStringTagBug?ie10IsDataView:isDataView})),isArray_default,init_isArray=__esmMin((()=>{init__setup(),init__tagTester(),isArray_default=nativeIsArray||tagTester("Array")}));function has$1(D,E){return D!=null&&hasOwnProperty.call(D,E)}var init__has=__esmMin((()=>{init__setup()})),isArguments,isArguments_default,init_isArguments=__esmMin((()=>{init__tagTester(),init__has(),isArguments=tagTester("Arguments"),(function(){isArguments(arguments)||(isArguments=function(D){return has$1(D,"callee")})})(),isArguments_default=isArguments}));function isFinite$1(D){return!isSymbol_default(D)&&_isFinite(D)&&!isNaN(parseFloat(D))}var init_isFinite=__esmMin((()=>{init__setup(),init_isSymbol()}));function isNaN$1(D){return isNumber_default(D)&&_isNaN(D)}var init_isNaN=__esmMin((()=>{init__setup(),init_isNumber()}));function constant(D){return function(){return D}}var init_constant=__esmMin((()=>{}));function createSizePropertyCheck(D){return function(E){var F=D(E);return typeof F=="number"&&F>=0&&F<=MAX_ARRAY_INDEX}}var init__createSizePropertyCheck=__esmMin((()=>{init__setup()}));function shallowProperty(D){return function(E){return E?.[D]}}var init__shallowProperty=__esmMin((()=>{})),_getByteLength_default,init__getByteLength=__esmMin((()=>{init__shallowProperty(),_getByteLength_default=shallowProperty("byteLength")})),_isBufferLike_default,init__isBufferLike=__esmMin((()=>{init__createSizePropertyCheck(),init__getByteLength(),_isBufferLike_default=createSizePropertyCheck(_getByteLength_default)}));function isTypedArray(D){return nativeIsView?nativeIsView(D)&&!isDataView_default(D):_isBufferLike_default(D)&&typedArrayPattern.test(toString$1.call(D))}var typedArrayPattern,isTypedArray_default,init_isTypedArray=__esmMin((()=>{init__setup(),init_isDataView(),init_constant(),init__isBufferLike(),typedArrayPattern=/\\[object ((I|Ui)nt(8|16|32)|Float(32|64)|Uint8Clamped|Big(I|Ui)nt64)Array\\]/,isTypedArray_default=supportsArrayBuffer?isTypedArray:constant(!1)})),_getLength_default,init__getLength=__esmMin((()=>{init__shallowProperty(),_getLength_default=shallowProperty("length")}));function emulatedSet(D){for(var E={},F=D.length,J=0;J<F;++J)E[D[J]]=!0;return{contains:function($e){return E[$e]===!0},push:function($e){return E[$e]=!0,D.push($e)}}}function collectNonEnumProps(D,E){E=emulatedSet(E);var F=nonEnumerableProps.length,J=D.constructor,$e=isFunction_default(J)&&J.prototype||ObjProto,_t="constructor";for(has$1(D,_t)&&!E.contains(_t)&&E.push(_t);F--;)_t=nonEnumerableProps[F],_t in D&&D[_t]!==$e[_t]&&!E.contains(_t)&&E.push(_t)}var init__collectNonEnumProps=__esmMin((()=>{init__setup(),init_isFunction(),init__has()}));function keys(D){if(!isObject$2(D))return[];if(nativeKeys)return nativeKeys(D);var E=[];for(var F in D)has$1(D,F)&&E.push(F);return hasEnumBug&&collectNonEnumProps(D,E),E}var init_keys=__esmMin((()=>{init_isObject(),init__setup(),init__has(),init__collectNonEnumProps()}));function isEmpty(D){if(D==null)return!0;var E=_getLength_default(D);return typeof E=="number"&&(isArray_default(D)||isString_default(D)||isArguments_default(D))?E===0:_getLength_default(keys(D))===0}var init_isEmpty=__esmMin((()=>{init__getLength(),init_isArray(),init_isString(),init_isArguments(),init_keys()}));function isMatch(D,E){var F=keys(E),J=F.length;if(D==null)return!J;for(var $e=Object(D),_t=0;_t<J;_t++){var lr=F[_t];if(E[lr]!==$e[lr]||!(lr in $e))return!1}return!0}var init_isMatch=__esmMin((()=>{init_keys()}));function _$1(D){if(D instanceof _$1)return D;if(!(this instanceof _$1))return new _$1(D);this._wrapped=D}var init_underscore=__esmMin((()=>{init__setup(),_$1.VERSION=VERSION,_$1.prototype.value=function(){return this._wrapped},_$1.prototype.valueOf=_$1.prototype.toJSON=_$1.prototype.value,_$1.prototype.toString=function(){return String(this._wrapped)}}));function toBufferView(D){return new Uint8Array(D.buffer||D,D.byteOffset||0,_getByteLength_default(D))}var init__toBufferView=__esmMin((()=>{init__getByteLength()}));function eq(D,E,F,J){if(D===E)return D!==0||1/D==1/E;if(D==null||E==null)return!1;if(D!==D)return E!==E;var $e=typeof D;return $e!=="function"&&$e!=="object"&&typeof E!="object"?!1:deepEq(D,E,F,J)}function deepEq(D,E,F,J){D instanceof _$1&&(D=D._wrapped),E instanceof _$1&&(E=E._wrapped);var $e=toString$1.call(D);if($e!==toString$1.call(E))return!1;if(hasStringTagBug&&$e=="[object Object]"&&isDataView_default(D)){if(!isDataView_default(E))return!1;$e=tagDataView}switch($e){case"[object RegExp]":case"[object String]":return""+D==""+E;case"[object Number]":return+D==+D?+D==0?1/D==1/E:+D==+E:+E!=+E;case"[object Date]":case"[object Boolean]":return+D==+E;case"[object Symbol]":return SymbolProto.valueOf.call(D)===SymbolProto.valueOf.call(E);case"[object ArrayBuffer]":case tagDataView:return deepEq(toBufferView(D),toBufferView(E),F,J)}var _t=$e==="[object Array]";if(!_t&&isTypedArray_default(D)){if(_getByteLength_default(D)!==_getByteLength_default(E))return!1;if(D.buffer===E.buffer&&D.byteOffset===E.byteOffset)return!0;_t=!0}if(!_t){if(typeof D!="object"||typeof E!="object")return!1;var lr=D.constructor,mr=E.constructor;if(lr!==mr&&!(isFunction_default(lr)&&lr instanceof lr&&isFunction_default(mr)&&mr instanceof mr)&&"constructor"in D&&"constructor"in E)return!1}F||=[],J||=[];for(var Or=F.length;Or--;)if(F[Or]===D)return J[Or]===E;if(F.push(D),J.push(E),_t){if(Or=D.length,Or!==E.length)return!1;for(;Or--;)if(!eq(D[Or],E[Or],F,J))return!1}else{var Pr=keys(D),dn;if(Or=Pr.length,keys(E).length!==Or)return!1;for(;Or--;)if(dn=Pr[Or],!(has$1(E,dn)&&eq(D[dn],E[dn],F,J)))return!1}return F.pop(),J.pop(),!0}function isEqual(D,E){return eq(D,E)}var tagDataView,init_isEqual=__esmMin((()=>{init_underscore(),init__setup(),init__getByteLength(),init_isTypedArray(),init_isFunction(),init__stringTagBug(),init_isDataView(),init_keys(),init__has(),init__toBufferView(),tagDataView="[object DataView]"}));function allKeys(D){if(!isObject$2(D))return[];var E=[];for(var F in D)E.push(F);return hasEnumBug&&collectNonEnumProps(D,E),E}var init_allKeys=__esmMin((()=>{init_isObject(),init__setup(),init__collectNonEnumProps()}));function ie11fingerprint(D){var E=_getLength_default(D);return function(F){if(F==null||_getLength_default(allKeys(F)))return!1;for(var J=0;J<E;J++)if(!isFunction_default(F[D[J]]))return!1;return D!==weakMapMethods||!isFunction_default(F[forEachName])}}var forEachName,hasName,commonInit,mapTail,mapMethods,weakMapMethods,setMethods,init__methodFingerprint=__esmMin((()=>{init__getLength(),init_isFunction(),init_allKeys(),forEachName="forEach",hasName="has",commonInit=["clear","delete"],mapTail=["get",hasName,"set"],mapMethods=commonInit.concat(forEachName,mapTail),weakMapMethods=commonInit.concat(mapTail),setMethods=["add"].concat(commonInit,forEachName,hasName)})),isMap_default,init_isMap=__esmMin((()=>{init__tagTester(),init__stringTagBug(),init__methodFingerprint(),isMap_default=isIE11?ie11fingerprint(mapMethods):tagTester("Map")})),isWeakMap_default,init_isWeakMap=__esmMin((()=>{init__tagTester(),init__stringTagBug(),init__methodFingerprint(),isWeakMap_default=isIE11?ie11fingerprint(weakMapMethods):tagTester("WeakMap")})),isSet_default,init_isSet=__esmMin((()=>{init__tagTester(),init__stringTagBug(),init__methodFingerprint(),isSet_default=isIE11?ie11fingerprint(setMethods):tagTester("Set")})),isWeakSet_default,init_isWeakSet=__esmMin((()=>{init__tagTester(),isWeakSet_default=tagTester("WeakSet")}));function values(D){for(var E=keys(D),F=E.length,J=Array(F),$e=0;$e<F;$e++)J[$e]=D[E[$e]];return J}var init_values=__esmMin((()=>{init_keys()}));function pairs(D){for(var E=keys(D),F=E.length,J=Array(F),$e=0;$e<F;$e++)J[$e]=[E[$e],D[E[$e]]];return J}var init_pairs=__esmMin((()=>{init_keys()}));function invert(D){for(var E={},F=keys(D),J=0,$e=F.length;J<$e;J++)E[D[F[J]]]=F[J];return E}var init_invert=__esmMin((()=>{init_keys()}));function functions$1(D){var E=[];for(var F in D)isFunction_default(D[F])&&E.push(F);return E.sort()}var init_functions=__esmMin((()=>{init_isFunction()}));function createAssigner(D,E){return function(F){var J=arguments.length;if(E&&(F=Object(F)),J<2||F==null)return F;for(var $e=1;$e<J;$e++)for(var _t=arguments[$e],lr=D(_t),mr=lr.length,Or=0;Or<mr;Or++){var Pr=lr[Or];(!E||F[Pr]===void 0)&&(F[Pr]=_t[Pr])}return F}}var init__createAssigner=__esmMin((()=>{})),extend_default,init_extend=__esmMin((()=>{init__createAssigner(),init_allKeys(),extend_default=createAssigner(allKeys)})),extendOwn_default,init_extendOwn=__esmMin((()=>{init__createAssigner(),init_keys(),extendOwn_default=createAssigner(keys)})),defaults_default,init_defaults=__esmMin((()=>{init__createAssigner(),init_allKeys(),defaults_default=createAssigner(allKeys,!0)}));function ctor(){return function(){}}function baseCreate(D){if(!isObject$2(D))return{};if(nativeCreate)return nativeCreate(D);var E=ctor();E.prototype=D;var F=new E;return E.prototype=null,F}var init__baseCreate=__esmMin((()=>{init_isObject(),init__setup()}));function create(D,E){var F=baseCreate(D);return E&&extendOwn_default(F,E),F}var init_create=__esmMin((()=>{init__baseCreate(),init_extendOwn()}));function clone(D){return isObject$2(D)?isArray_default(D)?D.slice():extend_default({},D):D}var init_clone=__esmMin((()=>{init_isObject(),init_isArray(),init_extend()}));function tap(D,E){return E(D),D}var init_tap=__esmMin((()=>{}));function toPath$1(D){return isArray_default(D)?D:[D]}var init_toPath=__esmMin((()=>{init_underscore(),init_isArray(),_$1.toPath=toPath$1}));function toPath(D){return _$1.toPath(D)}var init__toPath=__esmMin((()=>{init_underscore(),init_toPath()}));function deepGet(D,E){for(var F=E.length,J=0;J<F;J++){if(D==null)return;D=D[E[J]]}return F?D:void 0}var init__deepGet=__esmMin((()=>{}));function get(D,E,F){var J=deepGet(D,toPath(E));return isUndefined(J)?F:J}var init_get=__esmMin((()=>{init__toPath(),init__deepGet(),init_isUndefined()}));function has(D,E){E=toPath(E);for(var F=E.length,J=0;J<F;J++){var $e=E[J];if(!has$1(D,$e))return!1;D=D[$e]}return!!F}var init_has=__esmMin((()=>{init__has(),init__toPath()}));function identity(D){return D}var init_identity=__esmMin((()=>{}));function matcher(D){return D=extendOwn_default({},D),function(E){return isMatch(E,D)}}var init_matcher=__esmMin((()=>{init_extendOwn(),init_isMatch()}));function property(D){return D=toPath(D),function(E){return deepGet(E,D)}}var init_property=__esmMin((()=>{init__deepGet(),init__toPath()}));function optimizeCb(D,E,F){if(E===void 0)return D;switch(F??3){case 1:return function(J){return D.call(E,J)};case 3:return function(J,$e,_t){return D.call(E,J,$e,_t)};case 4:return function(J,$e,_t,lr){return D.call(E,J,$e,_t,lr)}}return function(){return D.apply(E,arguments)}}var init__optimizeCb=__esmMin((()=>{}));function baseIteratee(D,E,F){return D==null?identity:isFunction_default(D)?optimizeCb(D,E,F):isObject$2(D)&&!isArray_default(D)?matcher(D):property(D)}var init__baseIteratee=__esmMin((()=>{init_identity(),init_isFunction(),init_isObject(),init_isArray(),init_matcher(),init_property(),init__optimizeCb()}));function iteratee(D,E){return baseIteratee(D,E,1/0)}var init_iteratee=__esmMin((()=>{init_underscore(),init__baseIteratee(),_$1.iteratee=iteratee}));function cb(D,E,F){return _$1.iteratee===iteratee?baseIteratee(D,E,F):_$1.iteratee(D,E)}var init__cb=__esmMin((()=>{init_underscore(),init__baseIteratee(),init_iteratee()}));function mapObject(D,E,F){E=cb(E,F);for(var J=keys(D),$e=J.length,_t={},lr=0;lr<$e;lr++){var mr=J[lr];_t[mr]=E(D[mr],mr,D)}return _t}var init_mapObject=__esmMin((()=>{init__cb(),init_keys()}));function noop(){}var init_noop=__esmMin((()=>{}));function propertyOf(D){return D==null?noop:function(E){return get(D,E)}}var init_propertyOf=__esmMin((()=>{init_noop(),init_get()}));function times(D,E,F){var J=Array(Math.max(0,D));E=optimizeCb(E,F,1);for(var $e=0;$e<D;$e++)J[$e]=E($e);return J}var init_times=__esmMin((()=>{init__optimizeCb()}));function random(D,E){return E??(E=D,D=0),D+Math.floor(Math.random()*(E-D+1))}var init_random=__esmMin((()=>{})),now_default,init_now=__esmMin((()=>{now_default=Date.now||function(){return new Date().getTime()}}));function createEscaper(D){var E=function(_t){return D[_t]},F="(?:"+keys(D).join("|")+")",J=RegExp(F),$e=RegExp(F,"g");return function(_t){return _t=_t==null?"":""+_t,J.test(_t)?_t.replace($e,E):_t}}var init__createEscaper=__esmMin((()=>{init_keys()})),_escapeMap_default,init__escapeMap=__esmMin((()=>{_escapeMap_default={"&":"&amp;","<":"&lt;",">":"&gt;",\'"\':"&quot;","\'":"&#x27;","`":"&#x60;"}})),escape_default,init_escape=__esmMin((()=>{init__createEscaper(),init__escapeMap(),escape_default=createEscaper(_escapeMap_default)})),_unescapeMap_default,init__unescapeMap=__esmMin((()=>{init_invert(),init__escapeMap(),_unescapeMap_default=invert(_escapeMap_default)})),unescape_default,init_unescape=__esmMin((()=>{init__createEscaper(),init__unescapeMap(),unescape_default=createEscaper(_unescapeMap_default)})),templateSettings_default,init_templateSettings=__esmMin((()=>{init_underscore(),templateSettings_default=_$1.templateSettings={evaluate:/<%([\\s\\S]+?)%>/g,interpolate:/<%=([\\s\\S]+?)%>/g,escape:/<%-([\\s\\S]+?)%>/g}}));function escapeChar(D){return"\\\\"+escapes[D]}function template(D,E,F){!E&&F&&(E=F),E=defaults_default({},E,_$1.templateSettings);var J=RegExp([(E.escape||noMatch).source,(E.interpolate||noMatch).source,(E.evaluate||noMatch).source].join("|")+"|$","g"),$e=0,_t="__p+=\'";D.replace(J,function(Pr,dn,gi,qi,zi){return _t+=D.slice($e,zi).replace(escapeRegExp,escapeChar),$e=zi+Pr.length,dn?_t+=`\'+\n((__t=(`+dn+`))==null?\'\':_.escape(__t))+\n\'`:gi?_t+=`\'+\n((__t=(`+gi+`))==null?\'\':__t)+\n\'`:qi&&(_t+=`\';\n`+qi+`\n__p+=\'`),Pr}),_t+=`\';\n`;var lr=E.variable;if(lr){if(!bareIdentifier.test(lr))throw Error("variable is not a bare identifier: "+lr)}else _t=`with(obj||{}){\n`+_t+`}\n`,lr="obj";_t=`var __t,__p=\'\',__j=Array.prototype.join,print=function(){__p+=__j.call(arguments,\'\');};\n`+_t+`return __p;\n`;var mr;try{mr=Function(lr,"_",_t)}catch(Pr){throw Pr.source=_t,Pr}var Or=function(Pr){return mr.call(this,Pr,_$1)};return Or.source="function("+lr+`){\n`+_t+"}",Or}var noMatch,escapes,escapeRegExp,bareIdentifier,init_template=__esmMin((()=>{init_defaults(),init_underscore(),init_templateSettings(),noMatch=/(.)^/,escapes={"\'":"\'","\\\\":"\\\\","\\r":"r","\\n":"n","\\u2028":"u2028","\\u2029":"u2029"},escapeRegExp=/\\\\|\'|\\r|\\n|\\u2028|\\u2029/g,bareIdentifier=/^\\s*(\\w|\\$)+\\s*$/}));function result(D,E,F){E=toPath(E);var J=E.length;if(!J)return isFunction_default(F)?F.call(D):F;for(var $e=0;$e<J;$e++){var _t=D?.[E[$e]];_t===void 0&&(_t=F,$e=J),D=isFunction_default(_t)?_t.call(D):_t}return D}var init_result=__esmMin((()=>{init_isFunction(),init__toPath()}));function uniqueId(D){var E=++idCounter+"";return D?D+E:E}var idCounter,init_uniqueId=__esmMin((()=>{idCounter=0}));function chain(D){var E=_$1(D);return E._chain=!0,E}var init_chain=__esmMin((()=>{init_underscore()}));function executeBound(D,E,F,J,$e){if(!(J instanceof E))return D.apply(F,$e);var _t=baseCreate(D.prototype),lr=D.apply(_t,$e);return isObject$2(lr)?lr:_t}var init__executeBound=__esmMin((()=>{init__baseCreate(),init_isObject()})),partial,init_partial=__esmMin((()=>{init_restArguments(),init__executeBound(),init_underscore(),partial=restArguments(function(D,E){var F=partial.placeholder,J=function(){for(var $e=0,_t=E.length,lr=Array(_t),mr=0;mr<_t;mr++)lr[mr]=E[mr]===F?arguments[$e++]:E[mr];for(;$e<arguments.length;)lr.push(arguments[$e++]);return executeBound(D,J,this,this,lr)};return J}),partial.placeholder=_$1})),bind_default,init_bind=__esmMin((()=>{init_restArguments(),init_isFunction(),init__executeBound(),bind_default=restArguments(function(D,E,F){if(!isFunction_default(D))throw TypeError("Bind must be called on a function");var J=restArguments(function($e){return executeBound(D,J,E,this,F.concat($e))});return J})})),_isArrayLike_default,init__isArrayLike=__esmMin((()=>{init__createSizePropertyCheck(),init__getLength(),_isArrayLike_default=createSizePropertyCheck(_getLength_default)}));function flatten$3(D,E,F,J){if(J||=[],!E&&E!==0)E=1/0;else if(E<=0)return J.concat(D);for(var $e=J.length,_t=0,lr=_getLength_default(D);_t<lr;_t++){var mr=D[_t];if(_isArrayLike_default(mr)&&(isArray_default(mr)||isArguments_default(mr)))if(E>1)flatten$3(mr,E-1,F,J),$e=J.length;else for(var Or=0,Pr=mr.length;Or<Pr;)J[$e++]=mr[Or++];else F||(J[$e++]=mr)}return J}var init__flatten=__esmMin((()=>{init__getLength(),init__isArrayLike(),init_isArray(),init_isArguments()})),bindAll_default,init_bindAll=__esmMin((()=>{init_restArguments(),init__flatten(),init_bind(),bindAll_default=restArguments(function(D,E){E=flatten$3(E,!1,!1);var F=E.length;if(F<1)throw Error("bindAll must be passed function names");for(;F--;){var J=E[F];D[J]=bind_default(D[J],D)}return D})}));function memoize(D,E){var F=function(J){var $e=F.cache,_t=""+(E?E.apply(this,arguments):J);return has$1($e,_t)||($e[_t]=D.apply(this,arguments)),$e[_t]};return F.cache={},F}var init_memoize=__esmMin((()=>{init__has()})),delay_default,init_delay=__esmMin((()=>{init_restArguments(),delay_default=restArguments(function(D,E,F){return setTimeout(function(){return D.apply(null,F)},E)})})),defer_default,init_defer=__esmMin((()=>{init_partial(),init_delay(),init_underscore(),defer_default=partial(delay_default,_$1,1)}));function throttle(D,E,F){var J,$e,_t,lr,mr=0;F||={};var Or=function(){mr=F.leading===!1?0:now_default(),J=null,lr=D.apply($e,_t),J||($e=_t=null)},Pr=function(){var dn=now_default();!mr&&F.leading===!1&&(mr=dn);var gi=E-(dn-mr);return $e=this,_t=arguments,gi<=0||gi>E?(J&&=(clearTimeout(J),null),mr=dn,lr=D.apply($e,_t),J||($e=_t=null)):!J&&F.trailing!==!1&&(J=setTimeout(Or,gi)),lr};return Pr.cancel=function(){clearTimeout(J),mr=0,J=$e=_t=null},Pr}var init_throttle=__esmMin((()=>{init_now()}));function debounce(D,E,F){var J,$e,_t,lr,mr,Or=function(){var dn=now_default()-$e;E>dn?J=setTimeout(Or,E-dn):(J=null,F||(lr=D.apply(mr,_t)),J||(_t=mr=null))},Pr=restArguments(function(dn){return mr=this,_t=dn,$e=now_default(),J||(J=setTimeout(Or,E),F&&(lr=D.apply(mr,_t))),lr});return Pr.cancel=function(){clearTimeout(J),J=_t=mr=null},Pr}var init_debounce=__esmMin((()=>{init_restArguments(),init_now()}));function wrap$1(D,E){return partial(E,D)}var init_wrap=__esmMin((()=>{init_partial()}));function negate(D){return function(){return!D.apply(this,arguments)}}var init_negate=__esmMin((()=>{}));function compose(){var D=arguments,E=D.length-1;return function(){for(var F=E,J=D[E].apply(this,arguments);F--;)J=D[F].call(this,J);return J}}var init_compose=__esmMin((()=>{}));function after(D,E){return function(){if(--D<1)return E.apply(this,arguments)}}var init_after=__esmMin((()=>{}));function before(D,E){var F;return function(){return--D>0&&(F=E.apply(this,arguments)),D<=1&&(E=null),F}}var init_before=__esmMin((()=>{})),once_default,init_once=__esmMin((()=>{init_partial(),init_before(),once_default=partial(before,2)}));function findKey(D,E,F){E=cb(E,F);for(var J=keys(D),$e,_t=0,lr=J.length;_t<lr;_t++)if($e=J[_t],E(D[$e],$e,D))return $e}var init_findKey=__esmMin((()=>{init__cb(),init_keys()}));function createPredicateIndexFinder(D){return function(E,F,J){F=cb(F,J);for(var $e=_getLength_default(E),_t=D>0?0:$e-1;_t>=0&&_t<$e;_t+=D)if(F(E[_t],_t,E))return _t;return-1}}var init__createPredicateIndexFinder=__esmMin((()=>{init__cb(),init__getLength()})),findIndex_default,init_findIndex=__esmMin((()=>{init__createPredicateIndexFinder(),findIndex_default=createPredicateIndexFinder(1)})),findLastIndex_default,init_findLastIndex=__esmMin((()=>{init__createPredicateIndexFinder(),findLastIndex_default=createPredicateIndexFinder(-1)}));function sortedIndex(D,E,F,J){F=cb(F,J,1);for(var $e=F(E),_t=0,lr=_getLength_default(D);_t<lr;){var mr=Math.floor((_t+lr)/2);F(D[mr])<$e?_t=mr+1:lr=mr}return _t}var init_sortedIndex=__esmMin((()=>{init__cb(),init__getLength()}));function createIndexFinder(D,E,F){return function(J,$e,_t){var lr=0,mr=_getLength_default(J);if(typeof _t=="number")D>0?lr=_t>=0?_t:Math.max(_t+mr,lr):mr=_t>=0?Math.min(_t+1,mr):_t+mr+1;else if(F&&_t&&mr)return _t=F(J,$e),J[_t]===$e?_t:-1;if($e!==$e)return _t=E(slice.call(J,lr,mr),isNaN$1),_t>=0?_t+lr:-1;for(_t=D>0?lr:mr-1;_t>=0&&_t<mr;_t+=D)if(J[_t]===$e)return _t;return-1}}var init__createIndexFinder=__esmMin((()=>{init__getLength(),init__setup(),init_isNaN()})),indexOf_default,init_indexOf=__esmMin((()=>{init_sortedIndex(),init_findIndex(),init__createIndexFinder(),indexOf_default=createIndexFinder(1,findIndex_default,sortedIndex)})),lastIndexOf_default,init_lastIndexOf=__esmMin((()=>{init_findLastIndex(),init__createIndexFinder(),lastIndexOf_default=createIndexFinder(-1,findLastIndex_default)}));function find(D,E,F){var J=(_isArrayLike_default(D)?findIndex_default:findKey)(D,E,F);if(J!==void 0&&J!==-1)return D[J]}var init_find=__esmMin((()=>{init__isArrayLike(),init_findIndex(),init_findKey()}));function findWhere(D,E){return find(D,matcher(E))}var init_findWhere=__esmMin((()=>{init_find(),init_matcher()}));function each(D,E,F){E=optimizeCb(E,F);var J,$e;if(_isArrayLike_default(D))for(J=0,$e=D.length;J<$e;J++)E(D[J],J,D);else{var _t=keys(D);for(J=0,$e=_t.length;J<$e;J++)E(D[_t[J]],_t[J],D)}return D}var init_each=__esmMin((()=>{init__optimizeCb(),init__isArrayLike(),init_keys()}));function map(D,E,F){E=cb(E,F);for(var J=!_isArrayLike_default(D)&&keys(D),$e=(J||D).length,_t=Array($e),lr=0;lr<$e;lr++){var mr=J?J[lr]:lr;_t[lr]=E(D[mr],mr,D)}return _t}var init_map=__esmMin((()=>{init__cb(),init__isArrayLike(),init_keys()}));function createReduce(D){var E=function(F,J,$e,_t){var lr=!_isArrayLike_default(F)&&keys(F),mr=(lr||F).length,Or=D>0?0:mr-1;for(_t||($e=F[lr?lr[Or]:Or],Or+=D);Or>=0&&Or<mr;Or+=D){var Pr=lr?lr[Or]:Or;$e=J($e,F[Pr],Pr,F)}return $e};return function(F,J,$e,_t){var lr=arguments.length>=3;return E(F,optimizeCb(J,_t,4),$e,lr)}}var init__createReduce=__esmMin((()=>{init__isArrayLike(),init_keys(),init__optimizeCb()})),reduce_default,init_reduce=__esmMin((()=>{init__createReduce(),reduce_default=createReduce(1)})),reduceRight_default,init_reduceRight=__esmMin((()=>{init__createReduce(),reduceRight_default=createReduce(-1)}));function filter(D,E,F){var J=[];return E=cb(E,F),each(D,function($e,_t,lr){E($e,_t,lr)&&J.push($e)}),J}var init_filter=__esmMin((()=>{init__cb(),init_each()}));function reject(D,E,F){return filter(D,negate(cb(E)),F)}var init_reject=__esmMin((()=>{init_filter(),init_negate(),init__cb()}));function every(D,E,F){E=cb(E,F);for(var J=!_isArrayLike_default(D)&&keys(D),$e=(J||D).length,_t=0;_t<$e;_t++){var lr=J?J[_t]:_t;if(!E(D[lr],lr,D))return!1}return!0}var init_every=__esmMin((()=>{init__cb(),init__isArrayLike(),init_keys()}));function some(D,E,F){E=cb(E,F);for(var J=!_isArrayLike_default(D)&&keys(D),$e=(J||D).length,_t=0;_t<$e;_t++){var lr=J?J[_t]:_t;if(E(D[lr],lr,D))return!0}return!1}var init_some=__esmMin((()=>{init__cb(),init__isArrayLike(),init_keys()}));function contains(D,E,F,J){return _isArrayLike_default(D)||(D=values(D)),(typeof F!="number"||J)&&(F=0),indexOf_default(D,E,F)>=0}var init_contains=__esmMin((()=>{init__isArrayLike(),init_values(),init_indexOf()})),invoke_default,init_invoke=__esmMin((()=>{init_restArguments(),init_isFunction(),init_map(),init__deepGet(),init__toPath(),invoke_default=restArguments(function(D,E,F){var J,$e;return isFunction_default(E)?$e=E:(E=toPath(E),J=E.slice(0,-1),E=E[E.length-1]),map(D,function(_t){var lr=$e;if(!lr){if(J&&J.length&&(_t=deepGet(_t,J)),_t==null)return;lr=_t[E]}return lr==null?lr:lr.apply(_t,F)})})}));function pluck(D,E){return map(D,property(E))}var init_pluck=__esmMin((()=>{init_map(),init_property()}));function where(D,E){return filter(D,matcher(E))}var init_where=__esmMin((()=>{init_filter(),init_matcher()}));function max(D,E,F){var J=-1/0,$e=-1/0,_t,lr;if(E==null||typeof E=="number"&&typeof D[0]!="object"&&D!=null){D=_isArrayLike_default(D)?D:values(D);for(var mr=0,Or=D.length;mr<Or;mr++)_t=D[mr],_t!=null&&_t>J&&(J=_t)}else E=cb(E,F),each(D,function(Pr,dn,gi){lr=E(Pr,dn,gi),(lr>$e||lr===-1/0&&J===-1/0)&&(J=Pr,$e=lr)});return J}var init_max=__esmMin((()=>{init__isArrayLike(),init_values(),init__cb(),init_each()}));function min(D,E,F){var J=1/0,$e=1/0,_t,lr;if(E==null||typeof E=="number"&&typeof D[0]!="object"&&D!=null){D=_isArrayLike_default(D)?D:values(D);for(var mr=0,Or=D.length;mr<Or;mr++)_t=D[mr],_t!=null&&_t<J&&(J=_t)}else E=cb(E,F),each(D,function(Pr,dn,gi){lr=E(Pr,dn,gi),(lr<$e||lr===1/0&&J===1/0)&&(J=Pr,$e=lr)});return J}var init_min=__esmMin((()=>{init__isArrayLike(),init_values(),init__cb(),init_each()}));function toArray(D){return D?isArray_default(D)?slice.call(D):isString_default(D)?D.match(reStrSymbol):_isArrayLike_default(D)?map(D,identity):values(D):[]}var reStrSymbol,init_toArray=__esmMin((()=>{init_isArray(),init__setup(),init_isString(),init__isArrayLike(),init_map(),init_identity(),init_values(),reStrSymbol=/[^\\ud800-\\udfff]|[\\ud800-\\udbff][\\udc00-\\udfff]|[\\ud800-\\udfff]/g}));function sample(D,E,F){if(E==null||F)return _isArrayLike_default(D)||(D=values(D)),D[random(D.length-1)];var J=toArray(D),$e=_getLength_default(J);E=Math.max(Math.min(E,$e),0);for(var _t=$e-1,lr=0;lr<E;lr++){var mr=random(lr,_t),Or=J[lr];J[lr]=J[mr],J[mr]=Or}return J.slice(0,E)}var init_sample=__esmMin((()=>{init__isArrayLike(),init_values(),init__getLength(),init_random(),init_toArray()}));function shuffle(D){return sample(D,1/0)}var init_shuffle=__esmMin((()=>{init_sample()}));function sortBy(D,E,F){var J=0;return E=cb(E,F),pluck(map(D,function($e,_t,lr){return{value:$e,index:J++,criteria:E($e,_t,lr)}}).sort(function($e,_t){var lr=$e.criteria,mr=_t.criteria;if(lr!==mr){if(lr>mr||lr===void 0)return 1;if(lr<mr||mr===void 0)return-1}return $e.index-_t.index}),"value")}var init_sortBy=__esmMin((()=>{init__cb(),init_pluck(),init_map()}));function group(D,E){return function(F,J,$e){var _t=E?[[],[]]:{};return J=cb(J,$e),each(F,function(lr,mr){D(_t,lr,J(lr,mr,F))}),_t}}var init__group=__esmMin((()=>{init__cb(),init_each()})),groupBy_default,init_groupBy=__esmMin((()=>{init__group(),init__has(),groupBy_default=group(function(D,E,F){has$1(D,F)?D[F].push(E):D[F]=[E]})})),indexBy_default,init_indexBy=__esmMin((()=>{init__group(),indexBy_default=group(function(D,E,F){D[F]=E})})),countBy_default,init_countBy=__esmMin((()=>{init__group(),init__has(),countBy_default=group(function(D,E,F){has$1(D,F)?D[F]++:D[F]=1})})),partition_default,init_partition=__esmMin((()=>{init__group(),partition_default=group(function(D,E,F){D[+!F].push(E)},!0)}));function size(D){return D==null?0:_isArrayLike_default(D)?D.length:keys(D).length}var init_size=__esmMin((()=>{init__isArrayLike(),init_keys()}));function keyInObj(D,E,F){return E in F}var init__keyInObj=__esmMin((()=>{})),pick_default,init_pick=__esmMin((()=>{init_restArguments(),init_isFunction(),init__optimizeCb(),init_allKeys(),init__keyInObj(),init__flatten(),pick_default=restArguments(function(D,E){var F={},J=E[0];if(D==null)return F;isFunction_default(J)?(E.length>1&&(J=optimizeCb(J,E[1])),E=allKeys(D)):(J=keyInObj,E=flatten$3(E,!1,!1),D=Object(D));for(var $e=0,_t=E.length;$e<_t;$e++){var lr=E[$e],mr=D[lr];J(mr,lr,D)&&(F[lr]=mr)}return F})})),omit_default,init_omit=__esmMin((()=>{init_restArguments(),init_isFunction(),init_negate(),init_map(),init__flatten(),init_contains(),init_pick(),omit_default=restArguments(function(D,E){var F=E[0],J;return isFunction_default(F)?(F=negate(F),E.length>1&&(J=E[1])):(E=map(flatten$3(E,!1,!1),String),F=function($e,_t){return!contains(E,_t)}),pick_default(D,F,J)})}));function initial(D,E,F){return slice.call(D,0,Math.max(0,D.length-(E==null||F?1:E)))}var init_initial=__esmMin((()=>{init__setup()}));function first(D,E,F){return D==null||D.length<1?E==null||F?void 0:[]:E==null||F?D[0]:initial(D,D.length-E)}var init_first=__esmMin((()=>{init_initial()}));function rest(D,E,F){return slice.call(D,E==null||F?1:E)}var init_rest=__esmMin((()=>{init__setup()}));function last(D,E,F){return D==null||D.length<1?E==null||F?void 0:[]:E==null||F?D[D.length-1]:rest(D,Math.max(0,D.length-E))}var init_last=__esmMin((()=>{init_rest()}));function compact(D){return filter(D,Boolean)}var init_compact=__esmMin((()=>{init_filter()}));function flatten$2(D,E){return flatten$3(D,E,!1)}var init_flatten=__esmMin((()=>{init__flatten()})),difference_default,init_difference=__esmMin((()=>{init_restArguments(),init__flatten(),init_filter(),init_contains(),difference_default=restArguments(function(D,E){return E=flatten$3(E,!0,!0),filter(D,function(F){return!contains(E,F)})})})),without_default,init_without=__esmMin((()=>{init_restArguments(),init_difference(),without_default=restArguments(function(D,E){return difference_default(D,E)})}));function uniq(D,E,F,J){isBoolean(E)||(J=F,F=E,E=!1),F!=null&&(F=cb(F,J));for(var $e=[],_t=[],lr=0,mr=_getLength_default(D);lr<mr;lr++){var Or=D[lr],Pr=F?F(Or,lr,D):Or;E&&!F?((!lr||_t!==Pr)&&$e.push(Or),_t=Pr):F?contains(_t,Pr)||(_t.push(Pr),$e.push(Or)):contains($e,Or)||$e.push(Or)}return $e}var init_uniq=__esmMin((()=>{init_isBoolean(),init__cb(),init__getLength(),init_contains()})),union_default,init_union=__esmMin((()=>{init_restArguments(),init_uniq(),init__flatten(),union_default=restArguments(function(D){return uniq(flatten$3(D,!0,!0))})}));function intersection(D){for(var E=[],F=arguments.length,J=0,$e=_getLength_default(D);J<$e;J++){var _t=D[J];if(!contains(E,_t)){var lr;for(lr=1;lr<F&&contains(arguments[lr],_t);lr++);lr===F&&E.push(_t)}}return E}var init_intersection=__esmMin((()=>{init__getLength(),init_contains()}));function unzip(D){for(var E=D&&max(D,_getLength_default).length||0,F=Array(E),J=0;J<E;J++)F[J]=pluck(D,J);return F}var init_unzip=__esmMin((()=>{init_max(),init__getLength(),init_pluck()})),zip_default,init_zip=__esmMin((()=>{init_restArguments(),init_unzip(),zip_default=restArguments(unzip)}));function object(D,E){for(var F={},J=0,$e=_getLength_default(D);J<$e;J++)E?F[D[J]]=E[J]:F[D[J][0]]=D[J][1];return F}var init_object=__esmMin((()=>{init__getLength()}));function range(D,E,F){E??(E=D||0,D=0),F||=E<D?-1:1;for(var J=Math.max(Math.ceil((E-D)/F),0),$e=Array(J),_t=0;_t<J;_t++,D+=F)$e[_t]=D;return $e}var init_range=__esmMin((()=>{}));function chunk(D,E){if(E==null||E<1)return[];for(var F=[],J=0,$e=D.length;J<$e;)F.push(slice.call(D,J,J+=E));return F}var init_chunk=__esmMin((()=>{init__setup()}));function chainResult(D,E){return D._chain?_$1(E).chain():E}var init__chainResult=__esmMin((()=>{init_underscore()}));function mixin(D){return each(functions$1(D),function(E){var F=_$1[E]=D[E];_$1.prototype[E]=function(){var J=[this._wrapped];return push.apply(J,arguments),chainResult(this,F.apply(_$1,J))}}),_$1}var init_mixin=__esmMin((()=>{init_underscore(),init_each(),init_functions(),init__setup(),init__chainResult()})),underscore_array_methods_default,init_underscore_array_methods=__esmMin((()=>{init_underscore(),init_each(),init__setup(),init__chainResult(),each(["pop","push","reverse","shift","sort","splice","unshift"],function(D){var E=ArrayProto[D];_$1.prototype[D]=function(){var F=this._wrapped;return F!=null&&(E.apply(F,arguments),(D==="shift"||D==="splice")&&F.length===0&&delete F[0]),chainResult(this,F)}}),each(["concat","join","slice"],function(D){var E=ArrayProto[D];_$1.prototype[D]=function(){var F=this._wrapped;return F!=null&&(F=E.apply(F,arguments)),chainResult(this,F)}}),underscore_array_methods_default=_$1})),modules_exports=__exportAll({VERSION:()=>VERSION,after:()=>after,all:()=>every,allKeys:()=>allKeys,any:()=>some,assign:()=>extendOwn_default,before:()=>before,bind:()=>bind_default,bindAll:()=>bindAll_default,chain:()=>chain,chunk:()=>chunk,clone:()=>clone,collect:()=>map,compact:()=>compact,compose:()=>compose,constant:()=>constant,contains:()=>contains,countBy:()=>countBy_default,create:()=>create,debounce:()=>debounce,default:()=>underscore_array_methods_default,defaults:()=>defaults_default,defer:()=>defer_default,delay:()=>delay_default,detect:()=>find,difference:()=>difference_default,drop:()=>rest,each:()=>each,escape:()=>escape_default,every:()=>every,extend:()=>extend_default,extendOwn:()=>extendOwn_default,filter:()=>filter,find:()=>find,findIndex:()=>findIndex_default,findKey:()=>findKey,findLastIndex:()=>findLastIndex_default,findWhere:()=>findWhere,first:()=>first,flatten:()=>flatten$2,foldl:()=>reduce_default,foldr:()=>reduceRight_default,forEach:()=>each,functions:()=>functions$1,get:()=>get,groupBy:()=>groupBy_default,has:()=>has,head:()=>first,identity:()=>identity,include:()=>contains,includes:()=>contains,indexBy:()=>indexBy_default,indexOf:()=>indexOf_default,initial:()=>initial,inject:()=>reduce_default,intersection:()=>intersection,invert:()=>invert,invoke:()=>invoke_default,isArguments:()=>isArguments_default,isArray:()=>isArray_default,isArrayBuffer:()=>isArrayBuffer_default,isBoolean:()=>isBoolean,isDataView:()=>isDataView_default,isDate:()=>isDate_default,isElement:()=>isElement,isEmpty:()=>isEmpty,isEqual:()=>isEqual,isError:()=>isError_default,isFinite:()=>isFinite$1,isFunction:()=>isFunction_default,isMap:()=>isMap_default,isMatch:()=>isMatch,isNaN:()=>isNaN$1,isNull:()=>isNull,isNumber:()=>isNumber_default,isObject:()=>isObject$2,isRegExp:()=>isRegExp_default,isSet:()=>isSet_default,isString:()=>isString_default,isSymbol:()=>isSymbol_default,isTypedArray:()=>isTypedArray_default,isUndefined:()=>isUndefined,isWeakMap:()=>isWeakMap_default,isWeakSet:()=>isWeakSet_default,iteratee:()=>iteratee,keys:()=>keys,last:()=>last,lastIndexOf:()=>lastIndexOf_default,map:()=>map,mapObject:()=>mapObject,matcher:()=>matcher,matches:()=>matcher,max:()=>max,memoize:()=>memoize,methods:()=>functions$1,min:()=>min,mixin:()=>mixin,negate:()=>negate,noop:()=>noop,now:()=>now_default,object:()=>object,omit:()=>omit_default,once:()=>once_default,pairs:()=>pairs,partial:()=>partial,partition:()=>partition_default,pick:()=>pick_default,pluck:()=>pluck,property:()=>property,propertyOf:()=>propertyOf,random:()=>random,range:()=>range,reduce:()=>reduce_default,reduceRight:()=>reduceRight_default,reject:()=>reject,rest:()=>rest,restArguments:()=>restArguments,result:()=>result,sample:()=>sample,select:()=>filter,shuffle:()=>shuffle,size:()=>size,some:()=>some,sortBy:()=>sortBy,sortedIndex:()=>sortedIndex,tail:()=>rest,take:()=>first,tap:()=>tap,template:()=>template,templateSettings:()=>templateSettings_default,throttle:()=>throttle,times:()=>times,toArray:()=>toArray,toPath:()=>toPath$1,transpose:()=>unzip,unescape:()=>unescape_default,union:()=>union_default,uniq:()=>uniq,unique:()=>uniq,uniqueId:()=>uniqueId,unzip:()=>unzip,values:()=>values,where:()=>where,without:()=>without_default,wrap:()=>wrap$1,zip:()=>zip_default}),init_modules=__esmMin((()=>{init__setup(),init_restArguments(),init_isObject(),init_isNull(),init_isUndefined(),init_isBoolean(),init_isElement(),init_isString(),init_isNumber(),init_isDate(),init_isRegExp(),init_isError(),init_isSymbol(),init_isArrayBuffer(),init_isDataView(),init_isArray(),init_isFunction(),init_isArguments(),init_isFinite(),init_isNaN(),init_isTypedArray(),init_isEmpty(),init_isMatch(),init_isEqual(),init_isMap(),init_isWeakMap(),init_isSet(),init_isWeakSet(),init_keys(),init_allKeys(),init_values(),init_pairs(),init_invert(),init_functions(),init_extend(),init_extendOwn(),init_defaults(),init_create(),init_clone(),init_tap(),init_get(),init_has(),init_mapObject(),init_identity(),init_constant(),init_noop(),init_toPath(),init_property(),init_propertyOf(),init_matcher(),init_times(),init_random(),init_now(),init_escape(),init_unescape(),init_templateSettings(),init_template(),init_result(),init_uniqueId(),init_chain(),init_iteratee(),init_partial(),init_bind(),init_bindAll(),init_memoize(),init_delay(),init_defer(),init_throttle(),init_debounce(),init_wrap(),init_negate(),init_compose(),init_after(),init_before(),init_once(),init_findKey(),init_findIndex(),init_findLastIndex(),init_sortedIndex(),init_indexOf(),init_lastIndexOf(),init_find(),init_findWhere(),init_each(),init_map(),init_reduce(),init_reduceRight(),init_filter(),init_reject(),init_every(),init_some(),init_contains(),init_invoke(),init_pluck(),init_where(),init_max(),init_min(),init_shuffle(),init_sample(),init_sortBy(),init_groupBy(),init_indexBy(),init_countBy(),init_partition(),init_toArray(),init_size(),init_pick(),init_omit(),init_first(),init_initial(),init_last(),init_rest(),init_compact(),init_flatten(),init_without(),init_uniq(),init_union(),init_intersection(),init_difference(),init_unzip(),init_zip(),init_object(),init_range(),init_chunk(),init_mixin(),init_underscore_array_methods()})),_,init_index_default=__esmMin((()=>{init_modules(),_=mixin(modules_exports),_._=_})),index_all_exports=__exportAll({VERSION:()=>VERSION,after:()=>after,all:()=>every,allKeys:()=>allKeys,any:()=>some,assign:()=>extendOwn_default,before:()=>before,bind:()=>bind_default,bindAll:()=>bindAll_default,chain:()=>chain,chunk:()=>chunk,clone:()=>clone,collect:()=>map,compact:()=>compact,compose:()=>compose,constant:()=>constant,contains:()=>contains,countBy:()=>countBy_default,create:()=>create,debounce:()=>debounce,default:()=>_,defaults:()=>defaults_default,defer:()=>defer_default,delay:()=>delay_default,detect:()=>find,difference:()=>difference_default,drop:()=>rest,each:()=>each,escape:()=>escape_default,every:()=>every,extend:()=>extend_default,extendOwn:()=>extendOwn_default,filter:()=>filter,find:()=>find,findIndex:()=>findIndex_default,findKey:()=>findKey,findLastIndex:()=>findLastIndex_default,findWhere:()=>findWhere,first:()=>first,flatten:()=>flatten$2,foldl:()=>reduce_default,foldr:()=>reduceRight_default,forEach:()=>each,functions:()=>functions$1,get:()=>get,groupBy:()=>groupBy_default,has:()=>has,head:()=>first,identity:()=>identity,include:()=>contains,includes:()=>contains,indexBy:()=>indexBy_default,indexOf:()=>indexOf_default,initial:()=>initial,inject:()=>reduce_default,intersection:()=>intersection,invert:()=>invert,invoke:()=>invoke_default,isArguments:()=>isArguments_default,isArray:()=>isArray_default,isArrayBuffer:()=>isArrayBuffer_default,isBoolean:()=>isBoolean,isDataView:()=>isDataView_default,isDate:()=>isDate_default,isElement:()=>isElement,isEmpty:()=>isEmpty,isEqual:()=>isEqual,isError:()=>isError_default,isFinite:()=>isFinite$1,isFunction:()=>isFunction_default,isMap:()=>isMap_default,isMatch:()=>isMatch,isNaN:()=>isNaN$1,isNull:()=>isNull,isNumber:()=>isNumber_default,isObject:()=>isObject$2,isRegExp:()=>isRegExp_default,isSet:()=>isSet_default,isString:()=>isString_default,isSymbol:()=>isSymbol_default,isTypedArray:()=>isTypedArray_default,isUndefined:()=>isUndefined,isWeakMap:()=>isWeakMap_default,isWeakSet:()=>isWeakSet_default,iteratee:()=>iteratee,keys:()=>keys,last:()=>last,lastIndexOf:()=>lastIndexOf_default,map:()=>map,mapObject:()=>mapObject,matcher:()=>matcher,matches:()=>matcher,max:()=>max,memoize:()=>memoize,methods:()=>functions$1,min:()=>min,mixin:()=>mixin,negate:()=>negate,noop:()=>noop,now:()=>now_default,object:()=>object,omit:()=>omit_default,once:()=>once_default,pairs:()=>pairs,partial:()=>partial,partition:()=>partition_default,pick:()=>pick_default,pluck:()=>pluck,property:()=>property,propertyOf:()=>propertyOf,random:()=>random,range:()=>range,reduce:()=>reduce_default,reduceRight:()=>reduceRight_default,reject:()=>reject,rest:()=>rest,restArguments:()=>restArguments,result:()=>result,sample:()=>sample,select:()=>filter,shuffle:()=>shuffle,size:()=>size,some:()=>some,sortBy:()=>sortBy,sortedIndex:()=>sortedIndex,tail:()=>rest,take:()=>first,tap:()=>tap,template:()=>template,templateSettings:()=>templateSettings_default,throttle:()=>throttle,times:()=>times,toArray:()=>toArray,toPath:()=>toPath$1,transpose:()=>unzip,unescape:()=>unescape_default,union:()=>union_default,uniq:()=>uniq,unique:()=>uniq,uniqueId:()=>uniqueId,unzip:()=>unzip,values:()=>values,where:()=>where,without:()=>without_default,wrap:()=>wrap$1,zip:()=>zip_default}),init_index_all=__esmMin((()=>{init_index_default(),init_modules()}));init_index_all();var nonTupleVectorOperators=["vector","altvector"];function coerce_tuple_array_vectors({operator1:D,operator2:E,operands1:F,operands2:J,coerce_tuples_arrays:$e,coerce_vectors:_t}){let lr=D===E;if(!lr){if($e){if(D==="tuple"){if(nonTupleVectorOperators.includes(E))D=E,lr=!0;else if(E==="interval"&&F.length===2){let mr=J[1];mr[1]||mr[2]||(lr=!0,D="interval",F=[["tuple",...F],["tuple",!1,!1]])}}else if(E==="tuple"){if(nonTupleVectorOperators.includes(D))E=D,lr=!0;else if(D==="interval"&&J.length===2){let mr=F[1];mr[1]||mr[2]||(lr=!0,E="interval",J=[["tuple",...J],["tuple",!1,!1]])}}if(!lr){if(D==="array"&&F.length===2){if(E==="interval"){let mr=J[1];mr[1]&&mr[2]&&(lr=!0,D="interval",F=[["tuple",...F],["tuple",!0,!0]])}}else if(E==="array"&&J.length===2&&D==="interval"){let mr=F[1];mr[1]&&mr[2]&&(lr=!0,E="interval",J=[["tuple",...J],["tuple",!0,!0]])}}}!lr&&_t&&nonTupleVectorOperators.includes(D)&&nonTupleVectorOperators.includes(E)&&(lr=!0,D=E="vector")}return{operator1:D,operator2:E,operands1:F,operands2:J}}function handleNaNInfinityStringify(D,E){return E===E?E===1/0?"1/0":E===-1/0?"-1/0":E:"0/0"}function handleNaNInfinityParse(D,E){return E==="0/0"?NaN:E==="1/0"?1/0:E==="-1/0"?-1/0:E}function deepClone(D){return JSON.parse(JSON.stringify(D,handleNaNInfinityStringify),handleNaNInfinityParse)}var equal=function(D,E,{allowed_error_in_numbers:F=0,include_error_in_number_exponents:J=!1,allowed_error_is_absolute:$e=!1,coerce_tuples_arrays:_t=!0,coerce_vectors:lr=!0}={}){if(!(Array.isArray(D)&&Array.isArray(E))){if(typeof D!=typeof E)return!1;if(typeof D=="number"&&Number.isFinite(D)){let gi=1e-14,qi=Math.min(Math.abs(D),Math.abs(E));return $e?(gi*=qi,F>gi&&(gi=F)):(F>gi&&(gi=F),gi*=qi),Math.abs(D-E)<=gi}return D===E}var mr=D[0],Or=D.slice(1),Pr=E[0],dn=E.slice(1);return mr!==Pr&&({operator1:mr,operator2:Pr,operands1:Or,operands2:dn}=coerce_tuple_array_vectors({operator1:mr,operator2:Pr,operands1:Or,operands2:dn,coerce_tuples_arrays:_t,coerce_vectors:lr})),mr!==Pr||Or.length!==dn.length?!1:F>0&&!J&&mr==="^"?equal(Or[0],dn[0],{allowed_error_in_numbers:F,include_error_in_number_exponents:J,allowed_error_is_absolute:$e,coerce_tuples_arrays:_t,coerce_vectors:lr})?equal(Or[1],dn[1],{coerce_tuples_arrays:_t,coerce_vectors:lr}):!1:_.every(_.zip(Or,dn),function(gi){return equal(gi[0],gi[1],{allowed_error_in_numbers:F,include_error_in_number_exponents:J,allowed_error_is_absolute:$e,coerce_tuples_arrays:_t,coerce_vectors:lr})})},match$1=function(D,E,F){var J=!1;F===void 0?F={}:F.allow_extended_match&&(J=!0,F=Object.assign({},F),delete F.allow_extended_match);var $e=F.variables;if($e===void 0){$e={};let Or=variables(E);for(let Pr=0;Pr<Or.length;Pr++)$e[Or[Pr]]=!0;F=Object.assign({},F),F.variables=$e}if(E in $e){let Or=$e[E];if(Or!==!0)if(Or instanceof RegExp){if(typeof D=="string"){if(!D.match(Or))return!1}else if(!JSON.stringify(D).match(Or))return!1}else if(typeof $e[E]=="function"){if(!$e[E](D))return!1}else return!1;let Pr={};return Pr[E]=D,Pr}if(F.allow_permutations&&(D=default_order(D),E=default_order(E)),!Array.isArray(E))return D===E?{}:!1;var _t=allChildren(D),lr=E[0],mr=E.slice(1);if(!Array.isArray(D)||D[0]!==lr||_t.length<mr.length){if(Array.isArray(F.allow_implicit_identities)){let Or=matchImplicitIdentity(D,E,F);if(Or)return Or}if(lr==="*"&&Array.isArray(D)&&D[0]==="-"&&Array.isArray(D[1])&&D[1][0]==="*")_t=allChildren(D[1]),_t[0]=["-",_t[0]];else return!1}return matchOperands(lr,_t,mr,F,J)||(Array.isArray(F.allow_implicit_identities)?matchImplicitIdentity([lr].concat(_t),E,F):!1)};function matchOperands(D,E,F,J,$e){var _t=F.map(gi=>({})),lr=F.length,mr=!1;J.allow_permutations&&(D==="*"?mr=![...E,...F].some(gi=>["tuple","list","vector","altvector","interval","set","array","matrix"].includes(gi[0])):(D==="+"||D==="="||D==="and"||D==="or"||D==="ne"||D==="union"||D==="intersect")&&(mr=!0));function Or(gi,qi,zi){let Hi=1,Qi=1;(is_associative$1[D]||["tuple","vector","altvector"].includes(D))&&(Hi=gi.length-(lr-qi-1),Qi=gi.length),J.max_group!==void 0&&(Hi=J.max_group<Hi?J.max_group:Hi),J.max_last_group!==void 0&&(Qi=J.max_last_group<Qi?J.max_last_group:Qi);let Gi;if(!$e&&qi===lr-1)if(gi.length<=Qi)Gi=[gi];else return!1;else if(mr)Gi=subsets(gi,Hi);else{Gi=[];for(let Zi=1;Zi<=Hi;Zi++)Gi.push(gi.slice(0,Zi))}for(let Zi of Gi){let Xi=_t[qi][Zi];if(Xi===void 0){let ta=Zi.reduce(function(na,ra){return na.concat([E[ra]])},[]);ta=ta.length>1?[D].concat(ta):ta[0],Xi=match$1(ta,F[qi],J),_t[qi][Zi]=Xi}if(!Xi||!_.every(_.intersection(Object.keys(zi),Object.keys(Xi)),function(ta){return equal(zi[ta],Xi[ta])}))continue;let Ki=Object.assign({},Xi);Object.assign(Ki,zi);let ea=gi.filter(ta=>!Zi.includes(ta));if(qi===lr-1)return{matches:Ki,skipped:ea.reduce(function(ta,na){return ta.concat([E[na]])},[])};let Ji=Or(ea,qi+1,Ki);if(Ji)return Ji}return!1}var Pr={},dn=[...Array(E.length).keys()];if(mr){let gi=Or(dn,0,{});return gi?(Pr=gi.matches,gi.skipped.length>0&&(Pr._skipped=gi.skipped),Pr):!1}else{let gi=$e?E.length-lr:0,qi=[],zi;for(let Hi=0;Hi<=gi&&(zi=Or(dn,0,{}),!zi);Hi++)dn=dn.slice(1),qi.push(E[Hi]);return zi?(Pr=zi.matches,zi.skipped.length>0&&(Pr._skipped=zi.skipped),qi.length>0&&(Pr._skipped_before=qi),Pr):!1}}function matchImplicitIdentity(D,E,F){var J=E[0],$e=E.slice(1);if(!(J==="+"||J==="*"||J==="^"))return!1;var _t=[];for(let lr=0;lr<$e.length;lr++){let mr=$e[lr];typeof mr=="string"&&F.allow_implicit_identities.includes(mr)&&_t.push(mr)}if(_t.length===0)return!1;for(let lr of _t){let mr=match_one_implicit_identity(D,E,F,lr);if(mr)return mr}return!1}function match_one_implicit_identity(D,E,F,J){var $e=E[0],_t=E.slice(1),lr={};$e==="+"?lr[J]=0:lr[J]=1,$e==="*"&&_t.includes(J)&&Array.isArray(D)&&D[0]==="-"&&(lr[J]=-1,D=D[1]);var mr=_t.indexOf(J);if(_t.splice(mr,1),$e==="^"&&mr===0)return!1;E=_t.length===1?_t[0]:[$e].concat(_t);var Or=match$1(D,E,F);if(Or){if(J in Or&&!equal(Or[J],lr[J]))return!1;Object.assign(lr,Or)}else return!1;return lr}var substitute$1=function(D,E){return typeof D=="number"||typeof D=="boolean"?D:typeof D=="string"?E[D]===void 0?D:deepClone(E[D]):Array.isArray(D)?[D[0]].concat(D.slice(1).map(function(F){return substitute$1(F,E)})):[]},transform=function(D,E){if(Array.isArray(D)){let F=[D[0]];for(let J=1;J<D.length;J++)F.push(transform(D[J],E));return E(F)}return E(D)},applyAllTransformations=function(D,E,F){F===void 0&&(F=5);for(var J=D,$e;F>0;F--){$e=J;for(let _t=0;_t<E.length;_t++){let lr=E[_t][0],mr=E[_t][1],Or=E[_t][2];Or===void 0&&(Or={}),J=transform(J,function(Pr){let dn=match$1(Pr,lr,Or);if(dn){let gi=substitute$1(mr,dn),qi=Or.assumptions?substitute$1(Or.assumptions,dn):void 0;Or.evaluate_numbers&&(gi=evaluate_numbers(gi,{max_digits:Or.max_digits,evaluate_functions:Or.evaluate_functions,assumptions:qi}));let zi=[],Hi=[];return dn._skipped&&(zi=dn._skipped),dn._skipped_before&&(Hi=dn._skipped_before),(Hi.length>0||zi.length>0)&&(Array.isArray(gi)&&(gi=gi[0]===lr[0]?gi.slice(1):[gi]),gi=[lr[0]].concat(Hi,gi,zi)),Or.evaluate_numbers&&(gi=evaluate_numbers(gi,{max_digits:Or.max_digits,evaluate_functions:Or.evaluate_functions,assumptions:qi})),gi}else return Pr})}if(equal($e,J))return J}return J},math=mathjs_default,operators$2={"+":function(D){return D.length===1?D[0]:new math.OperatorNode("+","add",D)},"*":function(D){return new math.OperatorNode("*","multiply",D)},"/":function(D){return new math.OperatorNode("/","divide",D)},"-":function(D){return new math.OperatorNode("-","unaryMinus",[D[0]])},"^":function(D){return new math.OperatorNode("^","pow",D)},vector:function(D){return new math.ArrayNode(D)},altvector:function(D){return new math.ArrayNode(D)},and:function(D){return new math.OperatorNode("and","and",D)},or:function(D){return new math.OperatorNode("or","or",D)},not:function(D){return new math.OperatorNode("not","not",[D[0]])},"<":function(D){return new math.OperatorNode("<","smaller",D)},">":function(D){return new math.OperatorNode(">","larger",D)},le:function(D){return new math.OperatorNode("<=","smallerEq",D)},ge:function(D){return new math.OperatorNode(">=","largerEq",D)},ne:function(D){return new math.OperatorNode("!=","unequal",D)},binom:function(D){let E=new math.SymbolNode("combinations");return new math.FunctionNode(E,D)}},functionConversions={nCr:"combinations",nPr:"permutations",binom:"combinations"},astToMathjs$2=class{constructor({mathjs:D=null}={}){D&&(math=D)}convert(D){if(typeof D=="number")return Number.isFinite(D)?new math.ConstantNode(D):Number.isNaN(D)?new math.SymbolNode("NaN"):D<0?operators$2["-"]([new math.SymbolNode("Infinity")]):new math.SymbolNode("Infinity");if(typeof D=="string")return new math.SymbolNode(D);if(typeof D=="boolean")throw Error("no support for boolean");if(!Array.isArray(D))throw Error("Invalid ast");let E=D[0],F=D.slice(1);if(E==="apply"){if(typeof F[0]!="string")throw Error("Non string functions not implemented for conversion to mathjs");if(F[0]==="factorial")return new math.OperatorNode("!","factorial",[this.convert(F[1])]);let J=functionConversions[F[0]];J||=F[0];let $e=new math.SymbolNode(J),_t=F[1],lr;return lr=_t[0]==="tuple"?_t.slice(1).map((function(mr,Or){return this.convert(mr)}).bind(this)):[this.convert(_t)],F[0]==="count"&&(lr.length>2||!(lr[0]instanceof math.ArrayNode))&&(lr=[new math.ArrayNode(lr)]),new math.FunctionNode($e,lr)}if(E==="lts"||E==="gts"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=J.slice(1).map((function(Or,Pr){return this.convert(Or)}).bind(this)),lr=[];for(let Or=1;Or<J.length-1;Or++)$e[Or]?E==="lts"?lr.push(new math.OperatorNode("<","smaller",_t.slice(Or-1,Or+1))):lr.push(new math.OperatorNode(">","larger",_t.slice(Or-1,Or+1))):E==="lts"?lr.push(new math.OperatorNode("<=","smallerEq",_t.slice(Or-1,Or+1))):lr.push(new math.OperatorNode(">=","largerEq",_t.slice(Or-1,Or+1)));let mr=new math.OperatorNode("and","and",lr.slice(0,2));for(let Or=2;Or<lr.length;Or++)mr=new math.OperatorNode("and","and",[mr,lr[Or]]);return mr}if(E==="="){let J=F.map((function(lr,mr){return this.convert(lr)}).bind(this)),$e=[];for(let lr=1;lr<J.length;lr++)$e.push(new math.OperatorNode("==","equal",J.slice(lr-1,lr+1)));if($e.length===1)return $e[0];let _t=new math.OperatorNode("and","and",$e.slice(0,2));for(let lr=2;lr<$e.length;lr++)_t=new math.OperatorNode("and","and",[_t,$e[lr]]);return _t}if(E==="in"||E==="notin"||E==="ni"||E==="notni"){let J,$e;if(E==="in"||E==="notin"?(J=F[0],$e=F[1]):(J=F[1],$e=F[0]),typeof J!="number"&&typeof J!="string")throw Error("Set membership non-string variables not implemented for conversion to mathjs");if(J=this.convert(J),$e[0]!=="interval")throw Error("Set membership in non-intervals not implemented for conversion to mathjs");let _t=$e[1],lr=$e[2];if(_t[0]!=="tuple"||lr[0]!=="tuple")throw Error("Badly formed ast");let mr=this.convert(_t[1]),Or=this.convert(_t[2]),Pr=[];lr[1]?Pr.push(new math.OperatorNode(">=","largerEq",[J,mr])):Pr.push(new math.OperatorNode(">","larger",[J,mr])),lr[2]?Pr.push(new math.OperatorNode("<=","smallerEq",[J,Or])):Pr.push(new math.OperatorNode("<","smaller",[J,Or]));let dn=new math.OperatorNode("and","and",Pr);return(E==="notin"||E==="notni")&&(dn=new math.OperatorNode("not","not",[dn])),dn}if(E==="subset"||E==="notsubset"||E==="superset"||E==="notsuperset"){let J,$e;if(E==="subset"||E==="notsubset"?($e=F[0],J=F[1]):($e=F[1],J=F[0]),$e[0]!=="interval"||J[0]!=="interval")throw Error("Set containment of non-intervals not implemented for conversion to mathjs");let _t=$e[1],lr=$e[2],mr=J[1],Or=J[2];if(_t[0]!=="tuple"||lr[0]!=="tuple"||mr[0]!=="tuple"||Or[0]!=="tuple")throw Error("Badly formed ast");let Pr=this.convert(_t[1]),dn=this.convert(_t[2]),gi=this.convert(mr[1]),qi=this.convert(mr[2]),zi=[];lr[1]&&!Or[1]?zi.push(new math.OperatorNode(">","larger",[Pr,gi])):zi.push(new math.OperatorNode(">=","largerEq",[Pr,gi])),lr[2]&&!Or[2]?zi.push(new math.OperatorNode("<","smaller",[dn,qi])):zi.push(new math.OperatorNode("<=","smallerEq",[dn,qi]));let Hi=new math.OperatorNode("and","and",zi);return(E==="notsubset"||E==="notsuperset")&&(Hi=new math.OperatorNode("not","not",[Hi])),Hi}if(E==="matrix"){let J=F[0],$e=J[1],_t=J[2],lr=F[1];if(!Number.isInteger($e)||!Number.isInteger(_t))throw Error("Matrix must have integer dimensions");let mr=[];for(let Or=1;Or<=$e;Or++){let Pr=[];for(let dn=1;dn<=_t;dn++)Pr.push(this.convert(lr[Or][dn]));mr.push(new math.ArrayNode(Pr))}return new math.ArrayNode(mr)}if(E==="array"){let J=F.map($e=>this.convert($e));return new math.ArrayNode(J)}if(E in operators$2)return operators$2[E](F.map((function(J,$e){return this.convert(J)}).bind(this)));throw Error("Operator "+E+" not implemented for conversion to mathjs")}},require_sieve=__commonJSMin(((D,E)=>{E.exports=function(F){for(var J=Array(F),$e=0;$e<F;$e++)J[$e]=!0;for(var $e=2;$e<Math.sqrt(F);$e++)for(var _t=$e*$e;_t<F;_t+=$e)J[_t]=!1;for(var lr=[],$e=2;$e<F;$e++)J[$e]&&lr.push($e);return lr}})),require_factor=__commonJSMin(((D,E)=>{var F=require_sieve(),J=F(1e5);E.exports=function($e){(!J||J[J.length-1]<$e)&&(J=F($e));for(var _t=[],lr=0;lr<J.length&&$e>1;lr++){var mr=J[lr];if($e%mr===0){for(var Or={prime:mr,power:0};$e%mr===0;)Or.power++,$e/=mr;_t.push(Or)}}return $e>1&&_t.push({prime:$e,power:1}),_t}})),require_inc_mixed=__commonJSMin(((D,E)=>{E.exports=function(F,J){var $e=F.map(function(lr){return lr});$e[0]++;for(var _t=0;_t<F.length&&!($e[_t]<=J[_t]);_t++)_t===F.length-1?$e[_t]=0:($e[_t]=0,$e[_t+1]++);return $e}})),require_divisors=__commonJSMin(((D,E)=>{var F=require_factor(),J=require_inc_mixed();E.exports=function($e){for(var _t=F($e),lr=_t.map(function(dn){return 0}),mr=_t.map(function(dn){return dn.power}),Or=[1];;){lr=J(lr,mr);var Pr=lr.map(function(dn,gi){return _t[gi].prime**+dn}).reduce(function(dn,gi){return dn*gi},1);if(Pr===1)break;Or.push(Pr)}return Or.sort(function(dn,gi){return parseInt(dn)-parseInt(gi)}),Or}})),require_prime_factors=__commonJSMin(((D,E)=>{var F=require_factor();E.exports=function(J){return F(J).map(function($e){return $e.prime})}})),require_euler_phi=__commonJSMin(((D,E)=>{var F=require_prime_factors();E.exports=function(J){var $e=function(Or){return Or.reduce(function(Pr,dn){return Pr*dn},1)},_t=F(J),lr=$e(_t.map(function(Or){return Or-1})),mr=$e(_t);return J*lr/mr}})),require_gcd=__commonJSMin(((D,E)=>{E.exports=function(F,J){for(F<0&&(F=-F),J<0&&(J=-J);;){if(J===0)return F;if(F%=J,F===0)return J;J%=F}}})),require_find_divisor=__commonJSMin(((D,E)=>{var F=require_gcd();E.exports=function(J){for(var $e=2*Math.floor(Math.sqrt(Math.sqrt(J))),_t=2,lr=_t,mr,Or=1;Or<$e;Or++)if(_t=(_t*_t+1)%J,lr=(lr*lr+1)%J,lr=(lr*lr+1)%J,mr=F(lr-_t,J),mr!=1)return mr;return 1}})),require_inverse_mod=__commonJSMin(((D,E)=>{E.exports=function(F,J){F<0&&(F=F%J+J);for(var $e=0,_t=1,lr=J,mr=F;mr!==0;){var Or=Math.floor(lr/mr),Pr=$e;$e=_t,_t=Pr-Or*_t;var dn=lr;lr=mr,mr=dn-Or*mr}return lr>1?NaN:$e>0?$e:$e+J}})),require_is_abundant=__commonJSMin(((D,E)=>{var F=require_divisors();E.exports=function(J){if(J===1)return!1;var $e=F(J);return $e.pop(),J<$e.reduce(function(_t,lr){return _t+lr})}})),require_is_deficient=__commonJSMin(((D,E)=>{var F=require_divisors();E.exports=function(J){if(J===1)return!0;var $e=F(J);return $e.pop(),J>$e.reduce(function(_t,lr){return _t+lr})}})),require_is_heptagonal=__commonJSMin(((D,E)=>{E.exports=function(F){return(Math.sqrt(40*F+9)+3)/10%1==0}})),require_is_hexagonal=__commonJSMin(((D,E)=>{E.exports=function(F){return(Math.sqrt(8*F+1)+1)/4%1==0}})),require_is_octagonal=__commonJSMin(((D,E)=>{E.exports=function(F){return(Math.sqrt(3*F+1)+1)/3%1==0}})),require_is_pentagonal=__commonJSMin(((D,E)=>{E.exports=function(F){return(Math.sqrt(24*F+1)+1)/6%1==0}})),require_is_perfect=__commonJSMin(((D,E)=>{var F=require_divisors();E.exports=function(J){if(J===1)return!1;var $e=F(J);return $e.pop(),J===$e.reduce(function(_t,lr){return _t+lr})}})),require_is_prime=__commonJSMin(((D,E)=>{var F=require_factor();E.exports=function(J){var $e=F(J);return $e.length==1?$e[0].power===1:!1}})),require_multiply_mod=__commonJSMin(((D,E)=>{E.exports=function(F,J,$e){if(F<94906265&&J<94906265)return F*J%$e;var _t=0,lr=$e/2;F>=$e&&(F%=$e),J>=$e&&(J%=$e);for(var mr=0;mr<53;mr++)_t=_t>=lr?2*_t-$e:2*_t,F>=4503599627370496&&(_t+=J,F-=0xfffffffffffff),_t>$e&&(_t-=$e),F*=2;return _t}})),require_power_mod=__commonJSMin(((D,E)=>{var F=require_multiply_mod(),J=require_inverse_mod();E.exports=function $e(_t,lr,mr){if(lr<0)return J($e(_t,-lr,mr),mr);var Or=1;for(_t%=mr;lr>0;)lr%2==1&&(Or=F(Or,_t,mr),--lr),lr/=2,_t=F(_t,_t,mr);return Or}})),require_miller=__commonJSMin(((D,E)=>{var F=require_multiply_mod(),J=require_power_mod();E.exports=function($e){if($e<2)return!1;if($e==2||$e==3)return!0;if(!($e&1)||$e%3==0)return!1;for(var _t=$e-1,lr=0;_t%2==0;)_t/=2,lr+=1;for(var mr=$e<1373653?[2,3]:$e<9080191?[31,73]:$e<4759123141?[2,7,61]:$e<1122004669633?[2,13,23,1662803]:$e<2152302898747?[2,3,5,7,11]:$e<3474749660383?[2,3,5,7,11,13]:[2,3,5,7,11,13,17],Or=0;Or<mr.length;Or++){for(var Pr=mr[Or],dn=J(Pr,_t,$e),gi=0,qi=lr;qi>0;){if(gi=F(dn,dn,$e),gi===1&&dn!==1&&dn!==$e-1)return!1;dn=gi,--qi}if(gi!==1)return!1}return!0}})),require_is_square=__commonJSMin(((D,E)=>{E.exports=function(F){return Math.sqrt(F)%1==0}})),require_is_triangular=__commonJSMin(((D,E)=>{E.exports=function(F){return Math.sqrt(8*F+1)%1==0}})),require_jacobi_symbol=__commonJSMin(((D,E)=>{E.exports=function(F,J){if(J%2==0||J<0)return NaN;F<0&&(F=F%J+J);for(var $e=0;;){if(F%=J,F===0)return 0;for(;F%2==0;)$e^=(J%8*(J%8)-1)/8,F/=2;if(F==1)return $e&1?-1:1;$e^=(F%4-1)*(J%4-1)/4;var _t=F;F=J,J=_t}return NaN}})),require_log_mod=__commonJSMin(((D,E)=>{var F=require_power_mod(),J=require_multiply_mod(),$e={};E.exports=function(_t,lr,mr){_t=(_t%mr+mr)%mr;var Or=Math.ceil(Math.sqrt(mr)),Pr={};if($e[mr]===void 0&&($e[mr]={}),$e[mr][lr]===void 0){$e[mr][lr]={},Pr=$e[mr][lr];for(var dn=0;dn<Or;dn++)Pr[F(lr,dn,mr)]=dn}else Pr=$e[mr][lr];for(var gi=F(lr,-Or,mr),qi=_t,zi=0;zi<Or;zi++){if(Pr[qi]!==void 0)return(J(zi,Or,mr)+Pr[qi])%mr;qi=J(qi,gi,mr)}return NaN}})),require_primitive_root=__commonJSMin(((D,E)=>{var F=(init_index_all(),__toCommonJS(index_all_exports)),J=require_euler_phi(),$e=require_prime_factors(),_t=require_power_mod();E.exports=function(lr){for(var mr=J(lr),Or=$e(mr),Pr=2;Pr<lr;Pr++)if(F.every(Or,function(dn){return _t(Pr,mr/dn,lr)!=1}))return Pr;return NaN}})),require_quadratic_nonresidue=__commonJSMin(((D,E)=>{var F=require_jacobi_symbol();E.exports=function(J){for(var $e=2;$e<J;$e++)if(F($e,J)==-1)return $e;return NaN}})),require_random_primitive_root=__commonJSMin(((D,E)=>{var F=require_primitive_root(),J=require_euler_phi(),$e=require_gcd(),_t=require_power_mod();E.exports=function(lr){for(var mr=F(lr),Or=J(lr),Pr=0;Pr<100;Pr++){var dn=Math.floor(Math.random()*Or);if($e(dn,Or)==1)return _t(mr,dn,lr)}return mr}})),require_square_root_mod_prime=__commonJSMin(((D,E)=>{var F=require_jacobi_symbol(),J=require_power_mod(),$e=require_quadratic_nonresidue();E.exports=function(_t,lr){if(F(_t,lr)!=1)return NaN;for(var mr=lr-1,Or=0;mr%2==0;)mr/=2,Or++;if(lr%4==3)return J(_t,(lr+1)/4,lr);for(var Pr=J($e(lr),mr,lr),dn=J(_t,(mr+1)/2,lr),gi=J(_t,mr,lr),qi=Or;;){if(gi%lr==1)return dn;for(var zi=gi,Hi=1;Hi<qi&&(zi=zi*zi%lr,zi!=1);Hi++);var Qi=Hi;Hi++;for(var Gi=Pr;Hi<qi;)Gi=Gi*Gi%lr,Hi++;qi=Qi,dn=dn*Gi%lr,gi=gi*Gi*Gi%lr,Pr=Gi*Gi%lr}return NaN}})),require_square_root_mod=__commonJSMin(((D,E)=>{var F=(init_index_all(),__toCommonJS(index_all_exports)),J=require_factor(),$e=require_square_root_mod_prime(),_t=require_jacobi_symbol(),lr=require_inverse_mod(),mr=require_multiply_mod();E.exports=function(Or,Pr){var dn=1,gi=[0];return J(Pr).forEach(function(qi){var zi=qi.prime,Hi=qi.power,Qi=$e(Or,zi),Gi=[];if(_t(Or,zi)!=1)return[];gi.forEach(function(Ki){Gi.unshift(Ki*zi*lr(zi,dn)+Qi*dn*lr(dn,zi)),Gi.unshift(Ki*zi*lr(zi,dn)-Qi*dn*lr(dn,zi))}),Gi.sort(),gi=F.unique(Gi),dn*=zi;var Zi=1;for(Hi--;Hi>0;){var Xi=zi**+Math.min(Zi,Hi);Hi-=Math.min(Zi,Hi),gi=gi.map(function(Ki){var ea=-((Ki*Ki-Or)/dn),Ji=lr(2*Ki,Xi);return Ki+dn*mr(ea,Ji,Xi)}),dn*=Xi}}),gi.map(function(qi){return(qi%Pr+Pr)%Pr})}})),require_number_theory=__commonJSMin(((D,E)=>{E.exports={divisors:require_divisors(),eulerPhi:require_euler_phi(),factor:require_factor(),findDivisor:require_find_divisor(),gcd:require_gcd(),incMixed:require_inc_mixed(),inverseMod:require_inverse_mod(),isAbundant:require_is_abundant(),isDeficient:require_is_deficient(),isHeptagonal:require_is_heptagonal(),isHexagonal:require_is_hexagonal(),isOctagonal:require_is_octagonal(),isPentagonal:require_is_pentagonal(),isPerfect:require_is_perfect(),isPrime:require_is_prime(),isProbablyPrime:require_miller(),isSquare:require_is_square(),isTriangular:require_is_triangular(),jacobiSymbol:require_jacobi_symbol(),logMod:require_log_mod(),miller:require_miller(),multiplyMod:require_multiply_mod(),powerMod:require_power_mod(),primeFactors:require_prime_factors(),primitiveRoot:require_primitive_root(),quadraticNonresidue:require_quadratic_nonresidue(),randomPrimitiveRoot:require_random_primitive_root(),sieve:require_sieve(),squareRootMod:require_square_root_mod(),squareRootModPrime:require_square_root_mod_prime(),totient:require_euler_phi()}})),import_number_theory=__toESM(require_number_theory());function gcd$2(D,E){return Number.isNaN(D)||Number.isNaN(E)?NaN:import_number_theory.default.gcd(D,E)}function flatten$1(D){return D.reduce(function(E,F){return E.concat(F)},[])}function positiveModulo(D,E){return(D%E+E)%E}var ZmodN=class Xs{constructor(E,F,J=!1){this.values=E.map(function($e){return positiveModulo($e,F)}),this.modulus=F,this.approximate=J}apply(E,F,J){if(J==null||Number.isNaN(J)){if(Number.isNaN(this.modulus)||Number.isNaN(E.modulus))return new Xs([NaN],NaN,this.approximate||E.approximate);J=gcd$2(this.modulus,E.modulus)}return new Xs(flatten$1(this.values.map(function($e){return E.values.map(function(_t){return Number.isNaN($e)||Number.isNaN(_t)?NaN:(J+F($e,_t))%J})})),J,this.approximate||E.approximate)}add(E){return this.apply(E,function(F,J){return F+J})}power(E){var F=this.modulus;return E.modulus==import_number_theory.default.eulerPhi(F)?this.apply(E,function(J,$e){return import_number_theory.default.powerMod(J,$e,F)},F):new Xs([NaN],NaN,this.approximate||E.approximate)}isNaN(){for(var E of this.values)if(isNaN(E))return!0;return!1}subtract(E){return this.apply(E,function(F,J){return F-J})}multiply(E){var F=gcd$2(this.modulus,E.modulus);return this.apply(E,function(J,$e){return import_number_theory.default.multiplyMod(J,$e,F)})}inverse(){var E=this.modulus;return new Xs(this.values.map(function(F){return import_number_theory.default.inverseMod(F,E)}),this.modulus,this.approximate)}negate(){var E=this.modulus;return new Xs(this.values.map(function(F){return E-F}),this.modulus,this.approximate)}divide(E){var F=gcd$2(this.modulus,E.modulus);return new Xs(flatten$1(flatten$1(this.values.map(function(J){return E.values.map(function($e){if(J%$e==0)return[J/$e];var _t=gcd$2($e,F);if(J%_t!=0)return[];var lr=$e/_t,mr=J/_t,Or=import_number_theory.default.multiplyMod(mr,import_number_theory.default.inverseMod(lr,F),F),Pr=[],dn;for(dn=0;dn<_t;dn++)Pr.unshift(Or+import_number_theory.default.multiplyMod(dn,F/_t,F));return Pr})}))),F,this.approximate||E.approximate)}sqrt(){var E=this.modulus;return new Xs(flatten$1(this.values.map(function(F){return import_number_theory.default.squareRootMod(F,E)})),this.modulus,this.approximate)}toString=function(){return"{"+this.values.sort().toString()+"}/"+this.modulus.toString()};equals(E){return this.toString()==E.toString()}},PRIME=10739999,levelFunctions={"+":function(D){return D.reduce(function(E,F){return E.add(F)})},"*":function(D){return D.reduce(function(E,F){return E.multiply(F)})},"/":function(D){return D.reduce(function(E,F){return E.divide(F)})},"-":function(D){return D[0].negate()},"~":function(D){return D.reduce(function(E,F){return E.subtract(F)},new ZmodN([0],D[0].modulus))},factorial:function(D){return ZmodN([NaN],1)},gamma:function(D){return ZmodN([NaN],1)}};function rationalApproximation(D,E=1e15){let F=[[1,0],[0,1]],J;for(;F[1][0]*(J=Math.floor(D))+F[1][1]<=E;){let _t;if(_t=F[0][0]*J+F[0][1],F[0][1]=F[0][0],F[0][0]=_t,_t=F[1][0]*J+F[1][1],F[1][1]=F[1][0],F[1][0]=_t,D==J||(D=1/(D-J),D>2147483647))break}let $e=F[1][0]*J+F[1][1]>E;return{numerator:F[0][0],denominator:F[1][0],approximate:$e}}function finite_field_evaluate_ast(D,E,F,J){if(typeof D=="string")return D==="e"?new ZmodN([import_number_theory.default.primitiveRoot(F)],F):D==="pi"?F%2==0?new ZmodN([F/2],F):new ZmodN([NaN],F):D==="i"?new ZmodN([0],1):D in E?new ZmodN([E[D]],F):D;if(typeof D=="number"){if(Number.isInteger(D))return new ZmodN([D],F);{let zi=rationalApproximation(D),Hi=new ZmodN([zi.numerator],F,zi.approximate),Qi=new ZmodN([zi.denominator],F,zi.approximate);return Hi.divide(Qi)}}var $e=D[0],_t=D.slice(1);if($e==="apply"){if(typeof _t[0]!="string")throw Error("Non string functions not implemented for finite fields");if(_t[0]==="exp"){var lr=finite_field_evaluate_ast("e",{},F),mr=finite_field_evaluate_ast(_t[1],E,import_number_theory.default.eulerPhi(F));return lr.power(mr)}if(_t[0]==="sec")return finite_field_evaluate_ast(["/",1,["apply","cos",_t[1]]],E,F);if(_t[0]==="csc")return finite_field_evaluate_ast(["/",1,["apply","sin",_t[1]]],E,F);if(_t[0]==="cot")return finite_field_evaluate_ast(["/",1,["apply","tan",_t[1]]],E,F);if(_t[0]==="tan"){var Or=import_number_theory.default.eulerPhi(F);return finite_field_evaluate_ast(["/",["apply","sin",_t[1]],["apply","cos",_t[1]]],E,F)}if(_t[0]==="sin"){var Pr=import_number_theory.default.primitiveRoot(F),dn=new ZmodN([Pr],F),Or=import_number_theory.default.eulerPhi(F);if(Or%4!=0)return new ZmodN([NaN],F);var gi=new ZmodN([import_number_theory.default.powerMod(Pr,Or/4,F)],F),qi=finite_field_evaluate_ast(_t[1],E,Or);return dn.power(qi).subtract(dn.power(qi.negate())).divide(gi.add(gi))}if(_t[0]==="cos"){var dn=new ZmodN([import_number_theory.default.primitiveRoot(F)],F),qi=finite_field_evaluate_ast(_t[1],E,import_number_theory.default.eulerPhi(F));return dn.power(qi).add(dn.power(qi.negate())).divide(new ZmodN([2],F))}if(_t[0]==="log")return new ZmodN([NaN],NaN);if(_t[0]==="sqrt")return finite_field_evaluate_ast(_t[1],E,F).sqrt();if(_t[0]==="abs"){let zi=finite_field_evaluate_ast(_t[1],E,F);return zi.multiply(zi).sqrt()}}if($e=="^"){var lr=finite_field_evaluate_ast(_t[0],E,F),mr=finite_field_evaluate_ast(_t[1],E,import_number_theory.default.eulerPhi(F));return lr.power(mr)}return $e in levelFunctions?levelFunctions[$e](_t.map(function(zi,Hi){return finite_field_evaluate_ast(zi,E,F)})):new ZmodN([NaN],F)}var astToFiniteField$1=class{constructor(){}convert(D,E,F=PRIME){return finite_field_evaluate_ast(D,E,F)}},evaluation_exports=__exportAll({evaluate:()=>evaluate,evaluate_to_constant:()=>evaluate_to_constant,f:()=>f,finite_field_evaluate:()=>finite_field_evaluate}),astToMathjs$1=new astToMathjs$2({mathjs:mathjs_default}),astToFiniteField=new astToFiniteField$1,f=function(D){var E=get_tree(D),F=factorial_to_gamma_function(astToMathjs$1.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(E)))));return F.evaluate.bind(F)},evaluate=function(D,E){return f(D)(E)},finite_field_evaluate=function(D,E,F){return astToFiniteField.convert(D.tree,E,F)},evaluate_to_constant=function(D,{remove_units_first:E=!0,scale_based_on_unit:F=!0,nan_for_non_numeric:J=!0}={}){var $e=get_tree(D);if(E&&($e=remove_units($e,F)),typeof $e=="number")return $e;if(typeof $e=="string")return $e==="pi"&&mathjs_default.define_pi?Math.PI:$e==="e"&&mathjs_default.define_e?Math.E:$e==="i"&&mathjs_default.define_i?{re:0,im:1}:J?NaN:null;if(!Array.isArray($e))return J?NaN:null;var _t=[];_t.push([["^","x",["/","m","n"]],["^",["apply","nthRoot",["tuple","x","n"]],"m"],{variables:{x:Or=>Or<0,n:Or=>Number.isInteger(Or)&&Number.isInteger((Or-1)/2),m:Or=>Number.isInteger(Or)}}]),_t.push([["^","x",["-",["/","m","n"]]],["^",["apply","nthRoot",["tuple","x","n"]],["-","m"]],{variables:{x:Or=>Or<0,n:Or=>Number.isInteger(Or)&&Number.isInteger((Or-1)/2),m:Or=>Number.isInteger(Or)}}]),$e=applyAllTransformations($e,_t,40);var lr=J?NaN:null;try{var mr=f($e);lr=mr()}catch{}if(!Number.isNaN(lr)&&(typeof lr=="number"||typeof lr?.re=="number"&&typeof lr?.im=="number")){if(lr.re===1/0||lr.re===-1/0||lr.im===1/0||lr.im===-1/0){let Or;if(typeof lr?.re=="number"&&typeof lr?.im=="number")if(lr.im===0)Or=lr.re;else{let Pr;Pr=lr.im===1?"i":lr.im===-1?["-","i"]:["*",lr.im,"i"],Or=lr.re===0?Pr:["+",lr.re,Pr]}else Or=lr;lr=J?NaN:null;try{var mr=f(Or);lr=mr()}catch{}}else lr.im===0&&(lr=lr.re);return lr}return typeof lr=="object"&&(lr=J?NaN:null),lr};function factorial_to_gamma_function(D){return D.transform(function(E,F,J){if(E.isOperatorNode&&E.op==="!"&&E.fn==="factorial"){var $e=[new mathjs_default.OperatorNode("+","add",[E.args[0],new mathjs_default.ConstantNode(1)])];return new mathjs_default.FunctionNode(new mathjs_default.SymbolNode("gamma"),$e)}else return E})}var functions={C:{},R:{},nonzeroC:{},nonneg:{},pos:{}};functions.C.nonneg=["abs"],functions.C.nonzero=["exp"],functions.C.R=["abs","arg"],functions.C.C=["abs","arg","exp","sign","cos","cosh","sin","sinh","erf","sqrt","log","ln","log10"],functions.R.pos=["exp"],functions.R.nonneg=["abs","exp","arg"],functions.R.R=["abs","arg","exp","sign","cos","cosh","sin","sinh","erf"],functions.R.Z=["sign"],functions.nonzeroC.pos=["abs"],functions.nonneg.nonneg=["abs","exp","arg","sqrt","erf"],functions.nonzeroC.nonzero=["abs"],functions.nonneg.R=[...new Set(functions.R.R.concat(functions.nonneg.nonneg))],functions.pos.pos=["abs","exp","sqrt","erf"],functions.pos.nonneg=functions.pos.pos,functions.pos.nonzero=["abs","exp","sqrt","erf"],functions.pos.R=functions.nonneg.R.concat(["log","ln","log10"]);function negate_adjust(D,E){if(D)return!E;if(D===!1)return E}function narrow_assumptions(D,E){if(!Array.isArray(E))return[];var F=E[0],J=E.slice(1);if(F!=="and")return[];for(var $e=[],_t=0;_t<J.length;_t++)equal(J[_t],D)||$e.push(J[_t]);return $e.length===0?[]:$e.legnth===1?$e[0]:[F].concat($e)}function simple_assumption_combination(D,E,F){return D==="and"?E===void 0?F:F===void 0?E:E||F:E===void 0||F===void 0||E!==F?void 0:E}function is_integer_ast(D,E,F){if(typeof E!="object"&&(E=[]),F===void 0&&(F=E),typeof D=="number")return Number.isInteger(D);var J=evaluate_to_constant(D,{remove_units_first:!1,nan_for_non_numeric:!1});if(J!==null)return Number.isInteger(J);if(typeof D=="string"){let $e;if($e=Array.isArray(E)?E:E.get_assumptions(D),!Array.isArray($e))return;let _t=$e,lr=$e[0],mr=$e.slice(1),Or=!1;for(;lr==="not";){if(Or=!Or,$e=mr[0],!Array.isArray($e))return;lr=$e[0],mr=$e.slice(1)}if(lr==="in"&&mr[0]===D&&mr[1]==="Z")return negate_adjust(!0,Or);if(lr==="notin"&&mr[0]===D&&mr[1]==="Z")return negate_adjust(!1,Or);if(Or===!1){if(lr==="notin"&&(mr[0]===D&&mr[1]==="R"||mr[0]===D&&mr[1]==="C"))return!1}else if(lr==="in"&&(mr[0]===D&&mr[1]==="R"||mr[0]===D&&mr[1]==="Z"))return!1;if(lr==="="&&!Or||lr==="ne"&&Or){let gi=narrow_assumptions(_t,F);if(mr[0]===D)return is_integer_ast(mr[1],gi);if(mr[1]===D)return is_integer_ast(mr[0],gi)}if(lr!=="and"&&lr!=="or"||Or)return;mr.length>2&&($e=unflattenRight($e),mr=$e.slice(1));let Pr=is_integer_ast(D,mr[0],F),dn=is_integer_ast(D,mr[1],F);return simple_assumption_combination(lr,Pr,dn)}if(Array.isArray(D)){let $e;$e=Array.isArray(E)?E:E.get_assumptions([variables(D)]);let _t=D[0],lr=D.slice(1);if(_t==="-")return is_integer_ast(lr[0],$e,F);if(_t==="*")return lr.every(function(mr){return is_integer_ast(mr,$e,F)})?!0:void 0;if(_t==="^"){let mr=is_nonzero_ast(lr[0],$e,F);if(mr){if(is_nonzero_ast(lr[1],$e,F)===!1)return!(lr[0]===1/0||lr[0]===-1/0)}else{if(Number.isNaN(lr[0]))return!1;if(is_positive_ast(lr[1],$e,!0,F)){if(mr===!1)return!0}else return}let Or=is_integer_ast(lr[0],$e,F),Pr=is_integer_ast(lr[1],$e,F);return Or&&(Pr&&is_positive_ast(lr[1],$e,!1,F)?!0:void 0)}if(_t==="+"){let mr=0;for(let Or=0;Or<lr.length;Or++){let Pr=is_integer_ast(lr[Or],$e,F);if(Pr===!1){if(mr>0)return;mr+=1}if(Pr===void 0)return}return mr===0}return _t==="apply"?functions.C.Z&&functions.C.Z.includes(lr[0])&&is_complex_ast(lr[1],$e,F)||functions.R.Z&&functions.R.Z.includes(lr[0])&&is_real_ast(lr[1],$e,F)||functions.nonzeroC.Z&&functions.nonzeroC.Z.includes(lr[0])&&is_nonzero_ast(lr[1],$e,F)&&is_complex_ast(lr[1],$e,F)||functions.nonneg.Z&&functions.nonneg.Z.includes(lr[0])&&is_positive_ast(lr[1],$e,!1,F)||functions.pos.Z&&functions.pos.Z.includes(lr[0])&&is_positive_ast(lr[1],$e,!0,F)?!0:void 0:_t==="/"||_t==="prime"?void 0:!1}return!1}function is_real_ast(D,E,F){if(typeof E!="object"&&(E=[]),F===void 0&&(F=E),typeof D=="number")return Number.isFinite(D);var J=evaluate_to_constant(D,{remove_units_first:!1,nan_for_non_numeric:!1});if(J!==null)return typeof J=="number"?Number.isFinite(J):!1;if(typeof D=="string"){let $e;if($e=Array.isArray(E)?E:E.get_assumptions(D),!Array.isArray($e))return;let _t=$e,lr=$e[0],mr=$e.slice(1),Or=!1;for(;lr==="not";){if(Or=!Or,$e=mr[0],!Array.isArray($e))return;lr=$e[0],mr=$e.slice(1)}if(lr==="in"&&mr[0]===D&&mr[1]==="R")return negate_adjust(!0,Or);if(lr==="notin"&&mr[0]===D&&mr[1]==="R")return negate_adjust(!1,Or);if(Or===!1){if(lr==="in"&&mr[0]===D&&mr[1]==="Z")return!0}else if(lr==="notin"&&mr[0]===D&&mr[1]==="Z")return!0;if(lr==="<"||lr==="le"){let gi=variables($e),qi=functions$2($e);if(gi.indexOf(D)!==-1&&qi.length===0)return!0}if(lr==="="&&!Or||lr==="ne"&&Or){let gi=narrow_assumptions(_t,F);if(mr[0]===D)return is_real_ast(mr[1],gi);if(mr[1]===D)return is_real_ast(mr[0],gi)}if(lr!=="and"&&lr!=="or"||Or)return;mr.length>2&&($e=unflattenRight($e),mr=$e.slice(1));let Pr=is_real_ast(D,mr[0],F),dn=is_real_ast(D,mr[1],F);return simple_assumption_combination(lr,Pr,dn)}if(Array.isArray(D)){let $e;$e=Array.isArray(E)?E:E.get_assumptions([variables(D)]);let _t=D[0],lr=D.slice(1);if(_t==="-")return is_real_ast(lr[0],$e,F);if(_t==="*"||_t==="+"){if(lr.length>2&&(D=unflattenRight(D),lr=D.slice(1)),_t==="*"&&(is_nonzero_ast(lr[0],$e,F)===!1||is_nonzero_ast(lr[1],$e,F)===!1))return!0;let mr=is_real_ast(lr[0],$e,F),Or=is_real_ast(lr[1],$e,F);return mr&&Or?!0:mr&&Or===!1||Or&&mr===!1?!1:void 0}if(_t==="^"){let mr=is_nonzero_ast(lr[0],$e,F),Or=is_positive_ast(lr[1],$e,!0,F);if(mr){if(is_nonzero_ast(lr[1],$e,F)===!1)return!(lr[0]===1/0||lr[0]===-1/0)}else{if(Number.isNaN(lr[0]))return!1;if(Or){if(mr===!1)return!0}else return}let Pr=is_real_ast(lr[0],$e,F),dn=is_real_ast(lr[1],$e,F);return Pr&&dn?is_positive_ast(lr[0],$e,!1,F)?is_positive_ast(lr[0],$e,!0,F)||Or?!0:void 0:is_integer_ast(lr[1],$e,F)?!0:void 0:void 0}return _t==="/"?is_nonzero_ast(lr[1],$e,F)&&(is_nonzero_ast(lr[0],$e,F)===!1||is_real_ast(lr[0],$e,F)&&is_real_ast(lr[1],$e,F))?!0:void 0:_t==="apply"?functions.C.R&&functions.C.R.includes(lr[0])&&is_complex_ast(lr[1],$e,F)||functions.R.R&&functions.R.R.includes(lr[0])&&is_real_ast(lr[1],$e,F)||functions.nonzeroC.R&&functions.nonzeroC.R.includes(lr[0])&&is_nonzero_ast(lr[1],$e,F)&&is_complex_ast(lr[1],$e,F)||functions.nonneg.R&&functions.nonneg.R.includes(lr[0])&&is_positive_ast(lr[1],$e,!1,F)||functions.pos.R&&functions.pos.R.includes(lr[0])&&is_positive_ast(lr[1],$e,!0,F)?!0:void 0:_t==="prime"?void 0:!1}return!1}function is_complex_ast(D,E,F){if(typeof E!="object"&&(E=[]),F===void 0&&(F=E),typeof D=="number")return Number.isFinite(D);var J=evaluate_to_constant(D,{remove_units_first:!1,nan_for_non_numeric:!1});if(J!==null)return typeof J=="number"?Number.isFinite(J):!!(J.re!==void 0&&Number.isFinite(J.re)&&J.im!==void 0&&Number.isFinite(J.im));if(typeof D=="string"){let $e;if($e=Array.isArray(E)?E:E.get_assumptions(D),!Array.isArray($e))return;let _t=$e,lr=$e[0],mr=$e.slice(1),Or=!1;for(;lr==="not";){if(Or=!Or,$e=mr[0],!Array.isArray($e))return;lr=$e[0],mr=$e.slice(1)}if(lr==="in"&&mr[0]===D&&mr[1]==="C")return negate_adjust(!0,Or);if(lr==="notin"&&mr[0]===D&&mr[1]==="C")return negate_adjust(!1,Or);if(Or===!1){if(lr==="in"&&(mr[0]===D&&mr[1]==="Z"||mr[0]===D&&mr[1]==="R"))return!0}else if(lr==="notin"&&(mr[0]===D&&mr[1]==="Z"||mr[0]===D&&mr[1]==="R"))return!0;if(lr==="<"||lr==="le"){let gi=variables($e),qi=functions$2($e);if(gi.indexOf(D)!==-1&&qi.length===0)return!0}if(lr==="="&&!Or||lr==="ne"&&Or){let gi=narrow_assumptions(_t,F);if(mr[0]===D)return is_complex_ast(mr[1],gi);if(mr[1]===D)return is_complex_ast(mr[0],gi)}if(lr!=="and"&&lr!=="or"||Or)return;mr.length>2&&($e=unflattenRight($e),mr=$e.slice(1));let Pr=is_complex_ast(D,mr[0],F),dn=is_complex_ast(D,mr[1],F);return simple_assumption_combination(lr,Pr,dn)}if(Array.isArray(D)){let $e;$e=Array.isArray(E)?E:E.get_assumptions([variables(D)]);let _t=D[0],lr=D.slice(1);if(_t==="-")return is_complex_ast(lr[0],$e,F);if(_t==="*"||_t==="+")return _t==="*"&&!lr.every(mr=>is_nonzero_ast(mr,$e,F)!==!1)||lr.every(mr=>is_complex_ast(mr,$e,F))?!0:void 0;if(_t==="^"){let mr=is_nonzero_ast(lr[0],$e,F),Or=is_positive_ast(lr[1],$e,!0,F);if(mr){if(is_nonzero_ast(lr[1],$e,F)===!1)return!(lr[0]===1/0||lr[0]===-1/0)}else{if(Number.isNaN(lr[0]))return!1;if(Or){if(mr===!1)return!0}else return}let Pr=is_complex_ast(lr[0],$e,F),dn=is_complex_ast(lr[1],$e,F);return Pr&&dn?!0:void 0}return _t==="/"?is_nonzero_ast(lr[1],$e,F)&&(is_nonzero_ast(lr[0],$e,F)===!1||is_complex_ast(lr[0],$e,F)&&is_complex_ast(lr[1],$e,F))?!0:void 0:_t==="apply"?functions.C.C&&functions.C.C.includes(lr[0])&&is_complex_ast(lr[1],$e,F)||functions.R.C&&functions.R.C.includes(lr[0])&&is_real_ast(lr[1],$e,F)||functions.nonzeroC.C&&functions.nonzeroC.C.includes(lr[0])&&is_nonzero_ast(lr[1],$e,F)&&is_complex_ast(lr[1],$e,F)||functions.nonneg.C&&functions.nonneg.C.includes(lr[0])&&is_positive_ast(lr[1],$e,!1,F)||functions.pos.C&&functions.pos.C.includes(lr[0])&&is_positive_ast(lr[1],$e,!0,F)?!0:void 0:_t==="prime"?void 0:!1}return!1}function is_nonzero_ast(D,E,F){if(typeof E!="object"&&(E=[]),F===void 0&&(F=E),typeof D=="number")return Number.isFinite(D)?D!==0:Number.isNaN(D)?void 0:!0;var J=evaluate_to_constant(D,{remove_units_first:!1,nan_for_non_numeric:!1});if(J!==null)return typeof J=="number"?Number.isFinite(J)?J!==0:Number.isNaN(J)?void 0:!0:J.re!==void 0&&J.im!==void 0&&(J.re!==0||J.im!==0)?!0:void 0;if(typeof D=="string"){let $e;if($e=Array.isArray(E)?E:E.get_assumptions(D),!Array.isArray($e))return;let _t=$e,lr=$e[0],mr=$e.slice(1),Or=!1;for(;lr==="not";){if(Or=!Or,$e=mr[0],!Array.isArray($e))return;lr=$e[0],mr=$e.slice(1)}let Pr=narrow_assumptions(_t,F);if(lr==="="&&!Or||lr==="ne"&&Or){if(mr[0]===D)return is_nonzero_ast(mr[1],Pr);if(mr[1]===D)return is_nonzero_ast(mr[0],Pr)}if((lr==="ne"&&!Or||lr==="="&&Or)&&(mr[0]===D&&is_nonzero_ast(mr[1],Pr)===!1||mr[1]===D&&is_nonzero_ast(mr[0],Pr)===!1))return!0;if(lr==="<"){if(Or){if(mr[0]===D&&is_positive_ast(mr[1],Pr,!0)||mr[1]===D&&is_negative_ast(mr[0],Pr,!0))return!0}else if(mr[0]===D&&is_negative_ast(mr[1],Pr,!1)||mr[1]===D&&is_positive_ast(mr[0],Pr,!1))return!0}if(lr==="le"){if(Or){if(mr[0]===D&&is_positive_ast(mr[1],Pr,!1)||mr[1]===D&&is_negative_ast(mr[0],Pr,!1))return!0}else if(mr[0]===D&&is_negative_ast(mr[1],Pr,!0)||mr[1]===D&&is_positive_ast(mr[0],Pr,!0))return!0}if(lr!=="and"&&lr!=="or"||Or)return;mr.length>2&&($e=unflattenRight($e),mr=$e.slice(1));let dn=is_nonzero_ast(D,mr[0],F),gi=is_nonzero_ast(D,mr[1],F);return simple_assumption_combination(lr,dn,gi)}if(Array.isArray(D)){let $e;$e=Array.isArray(E)?E:E.get_assumptions([variables(D)]);let _t=D[0],lr=D.slice(1);if(_t==="-")return is_nonzero_ast(lr[0],$e,F);if(_t==="+"){if(lr.length>2&&(D=unflattenRight(D),lr=D.slice(1)),equal(lr[0],simplify(["-",lr[1]],F)))return!1;let mr=is_nonzero_ast(lr[0],$e,F),Or=is_nonzero_ast(lr[1],$e,F);if(mr===!1)return Or;if(Or===!1)return mr;let Pr=is_real_ast(lr[0],$e,F),dn=is_real_ast(lr[1],$e,F);if(!Pr||!dn)return Pr===!0?dn===!1?!0:void 0:dn===!0&&Pr===!1?!0:void 0;let gi=is_positive_ast(lr[0],$e,!1,F),qi=is_positive_ast(lr[1],$e,!1,F),zi=is_positive_ast(lr[0],$e,!0,F),Hi=is_positive_ast(lr[1],$e,!0,F);return gi&&Hi||zi&&qi||gi===!1&&Hi===!1||zi===!1&&qi===!1?!0:void 0}if(_t==="*"){let mr=!0;for(let Or=0;Or<lr.length;Or++){let Pr=is_nonzero_ast(lr[Or],$e,F);if(Pr===!1)return!1;Pr===void 0&&(mr=!1)}return mr?!0:void 0}if(_t==="/"){let mr=is_nonzero_ast(lr[0],$e,F);return is_nonzero_ast(lr[1],$e,F)?mr:void 0}if(_t==="^"){let mr=is_nonzero_ast(lr[0],$e,F);return mr?(lr[0]===1/0||lr[0]===-1/0)&&is_nonzero_ast(lr[1],$e,F)===!1?void 0:!0:is_positive_ast(lr[1],$e,!0,F)&&mr===!1?!1:void 0}return _t==="apply"?functions.C.nonzero&&functions.C.nonzero.includes(lr[0])&&is_complex_ast(lr[1],$e,F)||functions.R.nonzero&&functions.R.nonzero.includes(lr[0])&&is_real_ast(lr[1],$e,F)||functions.nonzeroC.nonzero&&functions.nonzeroC.nonzero.includes(lr[0])&&is_nonzero_ast(lr[1],$e,F)||functions.nonneg.nonzero&&functions.nonneg.nonzero.includes(lr[0])&&is_positive_ast(lr[1],$e,!1,F)||functions.pos.nonzero&&functions.pos.nonzero.includes(lr[0])&&is_positive_ast(lr[1],$e,!0,F)?!0:void 0:_t==="prime"?void 0:!1}return!1}function is_positive_ast(D,E,F,J){if(typeof E!="object"&&(E=[]),J===void 0&&(J=E),F===void 0&&(F=!0),typeof D=="number")return Number.isFinite(D)?F?D>0:D>=0:!1;var $e=is_real_ast(D,E,J);if(!$e)return $e;var _t=evaluate_to_constant(D,{remove_units_first:!1,nan_for_non_numeric:!1});if(_t!==null)return typeof _t=="number"&&Number.isFinite(_t)?F?_t>0:_t>=0:!1;if(typeof D=="string"){let lr;if(lr=Array.isArray(E)?E:E.get_assumptions(D),!Array.isArray(lr))return;let mr=lr,Or=lr[0],Pr=lr.slice(1),dn=!1;for(;Or==="not";){if(dn=!dn,lr=Pr[0],!Array.isArray(lr))return;Or=lr[0],Pr=lr.slice(1)}let gi=narrow_assumptions(mr,J);if(Or==="="&&!dn||Or==="ne"&&dn){if(Pr[0]===D)return is_positive_ast(Pr[1],gi,F);if(Pr[1]===D)return is_positive_ast(Pr[0],gi,F)}if(Or==="<")if(dn){if(Pr[0]===D&&is_positive_ast(Pr[1],gi,F))return!0;if(Pr[1]===D&&is_negative_ast(Pr[0],gi,!F))return!1}else{if(Pr[0]===D&&is_negative_ast(Pr[1],gi,!1))return!1;if(Pr[1]===D&&is_positive_ast(Pr[0],gi,!1))return!0}if(Or==="le")if(dn){if(Pr[0]===D&&is_positive_ast(Pr[1],gi,!1))return!0;if(Pr[1]===D&&is_negative_ast(Pr[0],gi,!1))return!1}else{if(Pr[0]===D&&is_negative_ast(Pr[1],gi,!F))return!1;if(Pr[1]===D&&is_positive_ast(Pr[0],gi,F))return!0}if(Or!=="and"&&Or!=="or"||dn)return;Pr.length>2&&(lr=unflattenRight(lr),Pr=lr.slice(1));let qi=is_positive_ast(D,Pr[0],F,J),zi=is_positive_ast(D,Pr[1],F,J);return simple_assumption_combination(Or,qi,zi)}if(Array.isArray(D)){let lr;lr=Array.isArray(E)?E:E.get_assumptions([variables(D)]);let mr=D[0],Or=D.slice(1);if(mr==="-")return is_negative_ast(Or[0],lr,F,J);if(mr==="+"){Or.length>2&&(D=unflattenRight(D),Or=D.slice(1));let Pr=is_positive_ast(Or[0],lr,!1,J),dn=is_positive_ast(Or[1],lr,!1,J),gi=is_positive_ast(Or[0],lr,!0,J),qi=is_positive_ast(Or[1],lr,!0,J);if(F){if(Pr&&qi||gi&&dn)return!0}else if(Pr&&dn)return!0;if(F){if(gi===!1&&qi===!1)return!1}else if(Pr===!1&&qi===!1||gi===!1&&dn===!1)return!1;return}if(mr==="*"){if(!Or.every(Qi=>is_nonzero_ast(Qi,lr,J)!==!1))return!F;Or.length>2&&(D=unflattenRight(D),Or=D.slice(1));let Pr=is_real_ast(Or[0],lr,J),dn=is_real_ast(Or[1],lr,J);if(Pr===void 0||dn===void 0)return;if(Pr===!1)return dn===!1?void 0:!1;if(dn===!1)return!1;let gi=is_positive_ast(Or[0],lr,!1,J),qi=is_positive_ast(Or[1],lr,!1,J),zi=is_positive_ast(Or[0],lr,!0,J),Hi=is_positive_ast(Or[1],lr,!0,J);if(F){if(zi&&Hi||gi===!1&&qi===!1)return!0;if(zi===!1&&qi||gi&&Hi===!1)return!1}else{if(gi&&qi||zi===!1&&Hi===!1)return!0;if(zi&&qi===!1||gi===!1&&Hi)return!1}return}if(mr==="/"){if(!is_nonzero_ast(Or[1],lr,J))return;if(is_nonzero_ast(Or[0],lr,J)===!1)return!F;let Pr=is_positive_ast(Or[1],lr,!0,J);if(Pr===void 0)return;let dn=Pr?F:!F,gi=is_positive_ast(Or[0],lr,dn,J);return gi===void 0?void 0:gi===!0?Pr===!0:Pr!==!0}if(mr==="^"){let Pr=is_nonzero_ast(Or[0],lr,J);if(Pr){if(is_nonzero_ast(Or[1],lr,J)===!1)return Or[0]===1/0||Or[0]===-1/0?void 0:!0}else if(is_positive_ast(Or[1],lr,!0,J)){if(Pr===!1)return!F;if(F)return}else return;return is_real_ast(Or[0],lr,J)===!0?is_positive_ast(Or[0],lr,F,J)?is_real_ast(Or[1],lr,J)?!0:void 0:is_integer_ast(simplify(["/",Or[1],2],J),lr,J)?!0:void 0:void 0}return mr==="apply"&&!F?functions.C.nonneg&&functions.C.nonneg.includes(Or[0])&&is_complex_ast(Or[1],lr,J)||functions.R.nonneg&&functions.R.nonneg.includes(Or[0])&&is_real_ast(Or[1],lr,J)||functions.nonzeroC.nonneg&&functions.nonzeroC.nonneg.includes(Or[0])&&is_nonzero_ast(Or[1],lr,J)&&is_complex_ast(Or[1],lr,J)||functions.nonneg.nonneg&&functions.nonneg.nonneg.includes(Or[0])&&is_positive_ast(Or[1],lr,!1,J)||functions.pos.nonneg&&functions.pos.nonneg.includes(Or[0])&&is_positive_ast(Or[1],lr,!0,J)?!0:void 0:mr==="apply"&&F?functions.C.pos&&functions.C.pos.includes(Or[0])&&is_complex_ast(Or[1],lr,J)||functions.R.pos&&functions.R.pos.includes(Or[0])&&is_real_ast(Or[1],lr,J)||functions.nonzeroC.pos&&functions.nonzeroC.pos.includes(Or[0])&&is_nonzero_ast(Or[1],lr,J)&&is_complex_ast(Or[1],lr,J)||functions.nonneg.pos&&functions.nonneg.pos.includes(Or[0])&&is_positive_ast(Or[1],lr,!1,J)||functions.pos.pos&&functions.pos.pos.includes(Or[0])&&is_positive_ast(Or[1],lr,!0,J)?!0:void 0:mr==="prime"?void 0:!1}return!1}function is_negative_ast(D,E,F,J){F===void 0&&(F=!0);var $e=is_real_ast(D,E,J);if($e===!0){let _t=is_positive_ast(D,E,!F,J);return _t===!1?!0:_t===!0?!1:void 0}return $e}function ParseError(D,E){this.name="ParseError",this.message=D||"Error parsing input",this.stack=Error().stack,this.location=E}ParseError.prototype=Object.create(Error.prototype),ParseError.prototype.constructor=ParseError;var lexer=class{constructor(D,E="\\\\s"){this.input="",this.location=0,this.token_rules=[],this.initial_whitespace=RegExp("^("+E+")+");for(let F of D)this.token_rules.push([RegExp("^"+F[0])].concat(F.slice(1)))}set_input(D){if(typeof D!="string")throw Error("Input must be a string");this.input=D,this.location=0}return_state(){return{input:this.input,location:this.location}}set_state({input:D=null,location:E=0}={}){D!==null&&(this.input=D,this.location=E)}advance({remove_initial_space:D=!0}={}){let E=this.initial_whitespace.exec(this.input);if(E){let J=E[0].length;if(this.input=this.input.slice(J),this.location+=J,!D)return{token_type:"SPACE",token_text:E[0],original_text:E[0]}}if(this.input.length===0)return{token_type:"EOF",token_text:"",original_text:""};E=null;for(var F of this.token_rules)if(E=F[0].exec(this.input),E){let J=E[0].length;this.input=this.input.slice(J),this.location+=J;break}return E===null?{token_type:"INVALID",token_text:this.input[0],original_text:this.input[0]}:F.length>2?{token_type:F[1],token_text:F[2],original_text:E[0]}:{token_type:F[1],token_text:E[0],original_text:E[0]}}unput(D){if(typeof D!="string")throw Error("Input must be a string");this.location-=D.length,this.input=D+this.input}},is_associative={"+":!0,"*":!0,and:!0,or:!0,union:!0,intersect:!0};function flatten(D){if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);if(F=F.map(function(_t,lr){return flatten(_t)}),is_associative[E]){for(var J=[],$e=0;$e<F.length;$e++)Array.isArray(F[$e])&&F[$e][0]===E&&F[$e].length>2?J=J.concat(F[$e].slice(1)):J.push(F[$e]);F=J}return[E].concat(F)}var number_rules_sci$1=[["[0-9]+(\\\\.[0-9]*)?(E[+\\\\-]?[0-9]+\\\\s*($|(?=\\\\,|\\\\||\\\\)|\\\\}|\\\\])))?","NUMBER"],["\\\\.[0-9]+(E[+\\\\-]?[0-9]+\\\\s*($|(?=\\\\,|\\\\||\\\\)|\\\\}|\\\\])))?","NUMBER"]],number_rules_non_sci$1=[["[0-9]+(\\\\.[0-9]*)?","NUMBER"],["\\\\.[0-9]+","NUMBER"]],base_text_rules=[["\\\\*\\\\*","^"],["\\\\*","*"],["\\\\xB7","*"],["·","*"],["•","*"],["⋅","*"],["×","*"],["/","/"],["-","-"],["֊","-"],["־","-"],["᠆","-"],["‐","-"],["‑","-"],["‒","-"],["–","-"],["—","-"],["―","-"],["⁻","-"],["₋","-"],["−","-"],["⸺","-"],["⸻","-"],["﹘","-"],["﹣","-"],["－","-"],["\\\\+","+"],["plusminus(?![a-zA-Z0-9])","PM"],["±","PM"],["\\\\^","^"],["‸","^"],["ʌ","^"],["′","\'"],["\\\\|","|"],["\\\\(","("],["\\\\)",")"],["\\\\[","["],["\\\\]","]"],["\\\\{","{"],["\\\\}","}"],["⟨","LANGLE"],["⟩","RANGLE"],["〈","LANGLE"],["〉","RANGLE"],[",",","],[":",":"],["α","VARMULTICHAR","alpha"],["β","VARMULTICHAR","beta"],["ϐ","VARMULTICHAR","beta"],["Γ","VARMULTICHAR","Gamma"],["γ","VARMULTICHAR","gamma"],["Δ","VARMULTICHAR","Delta"],["δ","VARMULTICHAR","delta"],["ε","VARMULTICHAR","epsilon"],["ϵ","VARMULTICHAR","epsilon"],["ζ","VARMULTICHAR","zeta"],["η","VARMULTICHAR","eta"],["Θ","VARMULTICHAR","Theta"],["ϴ","VARMULTICHAR","Theta"],["θ","VARMULTICHAR","theta"],["ᶿ","VARMULTICHAR","theta"],["ϑ","VARMULTICHAR","theta"],["ι","VARMULTICHAR","iota"],["κ","VARMULTICHAR","kappa"],["Λ","VARMULTICHAR","Lambda"],["λ","VARMULTICHAR","lambda"],["μ","VARMULTICHAR","mu"],["µ","VARMULTICHAR","mu"],["ν","VARMULTICHAR","nu"],["Ξ","VARMULTICHAR","Xi"],["ξ","VARMULTICHAR","xi"],["Π","VARMULTICHAR","Pi"],["π","VARMULTICHAR","pi"],["ϖ","VARMULTICHAR","pi"],["ρ","VARMULTICHAR","rho"],["ϱ","VARMULTICHAR","rho"],["Σ","VARMULTICHAR","Sigma"],["σ","VARMULTICHAR","sigma"],["ς","VARMULTICHAR","sigma"],["τ","VARMULTICHAR","tau"],["Υ","VARMULTICHAR","Upsilon"],["υ","VARMULTICHAR","upsilon"],["Φ","VARMULTICHAR","Phi"],["φ","VARMULTICHAR","phi"],["ϕ","VARMULTICHAR","phi"],["Ψ","VARMULTICHAR","Psi"],["ψ","VARMULTICHAR","psi"],["Ω","VARMULTICHAR","Omega"],["ω","VARMULTICHAR","omega"],["∅","VARMULTICHAR","emptyset"],["oo(?![a-zA-Z0-9])","INFINITY"],["OO(?![a-zA-Z0-9])","INFINITY"],["infty(?![a-zA-Z0-9])","INFINITY"],["infinity(?![a-zA-Z0-9])","INFINITY"],["Infinity(?![a-zA-Z0-9])","INFINITY"],["∞","INFINITY"],["ℯ","VAR","e"],["♠","VARMULTICHAR","spade"],["♡","VARMULTICHAR","heart"],["♢","VARMULTICHAR","diamond"],["♣","VARMULTICHAR","club"],["★","VARMULTICHAR","bigstar"],["◯","VARMULTICHAR","bigcirc"],["◊","VARMULTICHAR","lozenge"],["△","VARMULTICHAR","bigtriangleup"],["▽","VARMULTICHAR","bigtriangledown"],["⧫","VARMULTICHAR","blacklozenge"],["■","VARMULTICHAR","blacksquare"],["▲","VARMULTICHAR","blacktriangle"],["▼","VARMULTICHAR","blacktriangledown"],["◀","VARMULTICHAR","blacktriangleleft"],["▶","VARMULTICHAR","blacktriangleright"],["□","VARMULTICHAR","Box"],["∘","VARMULTICHAR","circ"],["⋆","VARMULTICHAR","star"],["and(?![a-zA-Z0-9])","AND"],["\\\\&\\\\&?","AND"],["∧","AND"],["or(?![a-zA-Z0-9])","OR"],["∨","OR"],["not(?![a-zA-Z0-9])","NOT"],["¬","NOT"],["=","="],["᐀","="],["゠","="],["!=","NE"],["≠","NE"],["<=","LE"],["≤","LE"],[">=","GE"],["≥","GE"],["<","<"],[">",">"],["forall(?![a-zA-Z0-9])","FORALL"],["∀","FORALL"],["exists(?![a-zA-Z0-9])","EXISTS"],["∃","EXISTS"],["elementof(?![a-zA-Z0-9])","IN"],["∈","IN"],["notelementof(?![a-zA-Z0-9])","NOTIN"],["∉","NOTIN"],["containselement(?![a-zA-Z0-9])","NI"],["∋","NI"],["notcontainselement(?![a-zA-Z0-9])","NOTNI"],["∌","NOTNI"],["subset(?![a-zA-Z0-9])","SUBSET"],["⊂","SUBSET"],["subseteq(?![a-zA-Z0-9])","SUBSETEQ"],["⊆","SUBSETEQ"],["notsubset(?![a-zA-Z0-9])","NOTSUBSET"],["⊄","NOTSUBSET"],["notsubseteq(?![a-zA-Z0-9])","NOTSUBSETEQ"],["⊈","NOTSUBSETEQ"],["superset(?![a-zA-Z0-9])","SUPERSET"],["⊃","SUPERSET"],["superseteq(?![a-zA-Z0-9])","SUPERSETEQ"],["⊇","SUPERSETEQ"],["notsuperset(?![a-zA-Z0-9])","NOTSUPERSET"],["⊅","NOTSUPERSET"],["notsuperseteq(?![a-zA-Z0-9])","NOTSUPERSETEQ"],["⊉","NOTSUPERSETEQ"],["union(?![a-zA-Z0-9])","UNION"],["∪","UNION"],["intersect(?![a-zA-Z0-9])","INTERSECT"],["∩","INTERSECT"],["rightarrow(?![a-zA-Z0-9])","RIGHTARROW"],["→","RIGHTARROW"],["⟶","RIGHTARROW"],["leftarrow(?![a-zA-Z0-9])","LEFTARROW"],["←","LEFTARROW"],["⟵","LEFTARROW"],["leftrightarrow(?![a-zA-Z0-9])","LEFTRIGHTARROW"],["↔","LEFTRIGHTARROW"],["⟷","LEFTRIGHTARROW"],["implies(?![a-zA-Z0-9])","IMPLIES"],["⇒","IMPLIES"],["⟹","IMPLIES"],["impliedby(?![a-zA-Z0-9])","IMPLIEDBY"],["⇐","IMPLIEDBY"],["⟸","IMPLIEDBY"],["iff(?![a-zA-Z0-9])","IFF"],["⇔","IFF"],["⟺","IFF"],["perp(?![a-zA-Z0-9])","PERP"],["⟂","PERP"],["parallel(?![a-zA-Z0-9])","PARALLEL"],["∥","PARALLEL"],["angle(?![a-zA-Z0-9])","ANGLE"],["∠","ANGLE"],["int(?![a-zA-Z0-9])","INT"],["∫","INT"],["!","!"],["\'","\'"],["_","_"],["\\\\.\\\\.\\\\.","LDOTS"],["[a-zA-Z∂][a-zA-Z∂0-9]*","VAR"],["[＿$%]","VAR"]],allowSimplifiedFunctionApplicationDefault$1=!0,splitSymbolsDefault=!0,unsplitSymbolsDefault="alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.angle.deg.emptyset".split("."),appliedFunctionSymbolsDefault$1="abs.exp.log.ln.log10.sign.sqrt.cbrt.nthroot.mod.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.re.im.det.trace.nPr.nCr.floor.ceil.round".split("."),functionSymbolsDefault$1=["f","g"],operatorSymbolsDefault$1=["binom","vec","linesegment"],unitsDefault$1=get_all_units(),parseLeibnizNotationDefault$1=!0,textToAst$4=class{constructor({allowSimplifiedFunctionApplication:D=allowSimplifiedFunctionApplicationDefault$1,splitSymbols:E=splitSymbolsDefault,unsplitSymbols:F=unsplitSymbolsDefault,appliedFunctionSymbols:J=appliedFunctionSymbolsDefault$1,functionSymbols:$e=functionSymbolsDefault$1,operatorSymbols:_t=operatorSymbolsDefault$1,units:lr=unitsDefault$1,parseLeibnizNotation:mr=parseLeibnizNotationDefault$1,parseScientificNotation:Or=!0}={}){this.allowSimplifiedFunctionApplication=D,this.splitSymbols=E,this.unsplitSymbols=F,this.appliedFunctionSymbols=J,this.functionSymbols=$e,this.operatorSymbols=_t,this.units=lr,this.parseLeibnizNotation=mr;let Pr=base_text_rules;Pr=Or?[...number_rules_sci$1,...Pr]:[...number_rules_non_sci$1,...Pr],this.lexer=new lexer(Pr)}advance(D){if(this.token=this.lexer.advance(D),this.token.token_type==="INVALID")throw new ParseError("Invalid symbol \'"+this.token.original_text+"\'",this.lexer.location)}return_state(){return{lexer_state:this.lexer.return_state(),token:Object.assign({},this.token)}}set_state(D){this.lexer.set_state(D.lexer_state),this.token=Object.assign({},D.token)}convert(D){this.lexer.set_input(D),this.advance();var E=this.statement_list();if(this.token.token_type!=="EOF")throw new ParseError("Invalid location of \'"+this.token.original_text+"\'",this.lexer.location);return flatten(E)}statement_list(){for(var D=[this.statement()];this.token.token_type===",";)this.advance(),D.push(this.statement());return D=D.length>1?["list"].concat(D):D[0],D}statement({inside_absolute_value:D=0}={}){if(this.token.token_type==="LDOTS")return this.advance(),["ldots"];var E;try{E=this.return_state();let F=this.statement_a({inside_absolute_value:D});return this.token.token_type===":"?(this.advance(),[":",F,this.statement_a()]):F}catch(F){try{this.set_state(E);let J=this.statement_a({parse_absolute_value:!1});if(this.token.token_type!=="|")throw F;return this.advance(),["|",J,this.statement_a({parse_absolute_value:!1})]}catch{throw F}}}statement_a({inside_absolute_value:D=0,parse_absolute_value:E=!0}={}){for(var F=this.statement_b({inside_absolute_value:D,parse_absolute_value:E});["IMPLIES","IMPLIEDBY","IFF","LEFTARROW","RIGHTARROW","LEFTRIGHTARROW"].includes(this.token.token_type);){let J=this.token.token_type.toLowerCase();this.advance();let $e=this.statement_b({inside_absolute_value:D,parse_absolute_value:E});F=[J,F,$e]}return F}statement_b({inside_absolute_value:D=0,parse_absolute_value:E=!0}={}){for(var F=this.statement_c({inside_absolute_value:D,parse_absolute_value:E});this.token.token_type==="OR";){let J=this.token.token_type.toLowerCase();this.advance();let $e=this.statement_c({inside_absolute_value:D,parse_absolute_value:E});F=[J,F,$e]}return F}statement_c(D){for(var E=this.relation(D);this.token.token_type==="AND";){let F=this.token.token_type.toLowerCase();this.advance();let J=this.relation(D);E=[F,E,J]}return E}relation(D){if(this.token.token_type==="NOT"||this.token.token_type==="!")return this.advance(),["not",this.relation(D)];if(this.token.token_type==="FORALL"||this.token.token_type==="EXISTS"){let F=this.token.token_type.toLowerCase();return this.advance(),[F,this.relation(D)]}for(var E=this.expression(D);this.token.token_type==="="||this.token.token_type==="NE"||this.token.token_type==="<"||this.token.token_type===">"||this.token.token_type==="LE"||this.token.token_type==="GE"||this.token.token_type==="IN"||this.token.token_type==="NOTIN"||this.token.token_type==="NI"||this.token.token_type==="NOTNI"||this.token.token_type==="SUBSET"||this.token.token_type==="NOTSUBSET"||this.token.token_type==="SUBSETEQ"||this.token.token_type==="NOTSUBSETEQ"||this.token.token_type==="SUPERSET"||this.token.token_type==="NOTSUPERSET"||this.token.token_type==="SUPERSETEQ"||this.token.token_type==="NOTSUPERSETEQ";){let F=this.token.token_type.toLowerCase(),J=0;this.token.token_type==="<"||this.token.token_type==="LE"?J=-1:(this.token.token_type===">"||this.token.token_type==="GE")&&(J=1),this.advance();let $e=this.expression(D);if(J===-1)if(this.token.token_type==="<"||this.token.token_type==="LE"){let _t=["tuple"];F==="<"?_t.push(!0):_t.push(!1);let lr=["tuple",E,$e];for(;this.token.token_type==="<"||this.token.token_type==="LE";)this.token.token_type==="<"?_t.push(!0):_t.push(!1),this.advance(),lr.push(this.expression(D));E=["lts",lr,_t]}else E=[F,E,$e];else if(J===1)if(this.token.token_type===">"||this.token.token_type==="GE"){let _t=["tuple"];F===">"?_t.push(!0):_t.push(!1);let lr=["tuple",E,$e];for(;this.token.token_type===">"||this.token.token_type==="GE";)this.token.token_type===">"?_t.push(!0):_t.push(!1),this.advance(),lr.push(this.expression(D));E=["gts",lr,_t]}else E=[F,E,$e];else if(F==="=")for(E=["=",E,$e];this.token.token_type==="=";)this.advance(),E.push(this.expression(D));else E=[F,E,$e]}return E}expression(D){if(this.token.token_type==="NOT"||this.token.token_type==="!")return this.advance(),["not",this.expression(D)];let E=!1;this.token.token_type==="+"&&(E=!0,this.advance());let F=!1;this.token.token_type==="-"&&(F=!0,this.advance());let J=!1;this.token.token_type==="PM"&&(J=!0,this.advance());var $e=this.term(D);if(F||E){if($e===!1)return(E?"+":"")+(F?"-":"");if(typeof $e=="string"&&[...$e].every(_t=>["+","-"].includes(_t)))return(E?"+":"")+(F?"-":"")+$e}for($e===!1&&($e="＿"),F&&($e=$e>0?-$e:["-",$e]),J&&($e=["pm",$e]),E&&($e=["+",$e]);["+","-","PM","UNION","INTERSECT","PERP","PARALLEL"].includes(this.token.token_type);){let _t=this.token.token_type.toLowerCase(),lr=!1,mr=!1,Or=!1;this.token.token_type==="-"?(_t="+",lr=!0,this.advance()):this.token.token_type==="PM"?(_t="+",mr=!0,this.advance()):(this.advance(),_t==="+"&&(this.token.token_type==="-"?(lr=!0,Or=!0,this.advance()):this.token.token_type==="PM"&&(mr=!0,this.advance())));let Pr=this.term(D);if(_t==="+"){if(Pr===!1&&(typeof $e=="number"||typeof $e=="string")){if(Or)return $e+"+-";if(lr)return $e+"-";if(!mr)return $e+"+"}else if(typeof Pr=="string"&&[...Pr].every(dn=>["+","-"].includes(dn))&&(typeof $e=="number"||typeof $e=="string")){if(Or)return $e+"+-"+Pr;if(lr)return $e+"-"+Pr;if(!mr)return $e+"+"+Pr}}Pr===!1&&(Pr="＿"),lr&&(Pr=Pr>0?-Pr:["-",Pr]),mr&&(Pr=["pm",Pr]),$e=[_t,$e,Pr]}return $e}term(D){var E=this.factor(D),F=!1;do if(F=!1,this.token.token_type==="*"){this.advance(),E===!1&&(E="＿");let J=this.factor(D);J===!1&&(J="＿"),E=["*",E,J],F=!0}else if(this.token.token_type==="/"){this.advance(),E===!1&&(E="＿");let J=this.factor(D);J===!1&&(J="＿"),E=["/",E,J],F=!0}else{let J=Object.assign({},D);J.allow_absolute_value_closing=!0;let $e=this.nonMinusFactor(J);$e!==!1&&(E===!1&&(E="＿"),E=["*",E,$e],F=!0)}while(F);return this.convert_units_in_term(flatten(E))}convert_units_in_term(D){if(!Array.isArray(D))return D;let E=D[0],F=D.slice(1);if(E==="*"){let J=F.length;for(let[$e,_t]of F.entries()){let lr=this.units[_t];if(lr){if(lr.prefix&&$e<J-1){let mr;mr=$e===J-2?F[J-1]:this.convert_units_in_term(["*",...F.slice($e+1)]);let Or=_t;lr.substitute&&(Or=lr.substitute);let Pr=["unit",Or,mr];return $e===0?Pr:["*",...F.slice(0,$e),Pr]}else if(!lr.prefix&&$e>0){let mr=_t;lr.substitute&&(mr=lr.substitute);let Or;return Or=$e===1?["unit",F[0],mr]:["unit",["*",...F.slice(0,$e)],mr],$e===J-1?Or:this.convert_units_in_term(["*",Or,...F.slice($e+1)])}}}return D}else if(E==="/")return["/",this.convert_units_in_term(F[0]),this.convert_units_in_term(F[1])];return D}factor(D){if(this.token.token_text==="+"){this.advance();let F=this.factor(D);return F===!1?"+":typeof F=="string"&&[...F].every(J=>["+","-"].includes(J))?"+"+F:["+",F]}if(this.token.token_type==="-"){this.advance();let F=this.factor(D);return F>0?-F:F===!1?"-":typeof F=="string"&&[...F].every(J=>["+","-"].includes(J))?"-"+F:["-",F]}let E=this.nonMinusFactor(D);return E===!1&&this.token.token_type==="PERP"&&(E="perp",this.advance()),E}nonMinusFactor(D){for(var E=this.baseFactor(D);this.token.token_type==="^"||this.token.token_type==="!"||this.token.token_type==="\'";)if(E===!1&&(E="＿"),this.token.token_type==="^"){this.advance();let F=this.get_subsuperscript(D);E=["^",E,F]}else this.token.token_type==="!"?(E=["apply","factorial",E],this.advance()):(E=["prime",E],this.advance());return E}get_subsuperscript({parse_absolute_value:D}){if(["+","-","PERP"].includes(this.token.token_type)){let E=this.token.token_type.toLowerCase();return this.advance(),E}else{let E=this.baseFactor({parse_absolute_value:D,in_subsuperscript_with_no_delimiters:!0});return E===!1&&(E="＿"),E}}baseFactor({inside_absolute_value:D=0,parse_absolute_value:E=!0,allow_absolute_value_closing:F=!1,in_subsuperscript_with_no_delimiters:J=!1}={}){var $e=!1;if(this.token.token_type==="NUMBER")$e=parseFloat(this.token.token_text),this.advance();else if(this.token.token_type==="INFINITY")$e=1/0,this.advance();else if(this.token.token_type==="VAR"||this.token.token_type==="VARMULTICHAR")if($e=this.token.token_text,this.appliedFunctionSymbols.includes($e)||this.functionSymbols.includes($e)){let _t=!1;if(this.appliedFunctionSymbols.includes($e)&&(_t=!0),this.advance(),this.token.token_type==="_"){this.advance();let lr=this.get_subsuperscript({parse_absolute_value:E});$e=$e==="log"&&lr===10?"log10":["_",$e,lr]}if(J)_t&&($e=["apply",$e,"＿"]);else{for(;this.token.token_type==="\'";)$e=["prime",$e],this.advance();for(;this.token.token_type==="^";){this.advance();let lr=this.get_subsuperscript({parse_absolute_value:E});$e=["^",$e,lr]}if(this.token.token_type==="("){this.advance();let lr=this.statement_list();if(this.token.token_type!==")")throw new ParseError("Expecting )",this.lexer.location);this.advance(),lr[0]==="list"&&(lr[0]="tuple"),$e=["apply",$e,lr]}else if(_t){if(!this.allowSimplifiedFunctionApplication)throw new ParseError("Expecting ( after function",this.lexer.location);let lr=this.factor({parse_absolute_value:E});lr===!1&&(lr="＿"),$e=["apply",$e,lr]}}return $e}else if(this.operatorSymbols.includes($e))if(this.advance(),this.token.token_type==="("){this.advance();let _t=this.statement_list();if(this.token.token_type!==")")throw new ParseError("Expecting )",this.lexer.location);this.advance(),$e=_t[0]==="list"?[$e,..._t.slice(1)]:[$e,_t]}else{let _t=this.factor({parse_absolute_value:E});_t===!1&&(_t="＿"),$e=[$e,_t]}else{if(this.parseLeibnizNotation){let lr=this.return_state(),mr=this.leibniz_notation();if(mr)return mr;this.set_state(lr)}let _t=this.splitSymbols;if(_t&&(this.token.token_type==="VARMULTICHAR"||this.unsplitSymbols.includes($e)||$e.length===1||$e.match(/[\\d]/g))&&(_t=!1),_t){for(let lr=$e.length-1;lr>=0;lr--)this.lexer.unput(" "),this.lexer.unput($e[lr]);return this.advance(),this.baseFactor({inside_absolute_value:D,parse_absolute_value:E,allow_absolute_value_closing:F})}else this.advance()}else if(this.token.token_type==="("||this.token.token_type==="["||this.token.token_type==="{"||this.token.token_type==="LANGLE"){let _t=this.token.token_type,lr,mr;this.token.token_type==="("?(lr=")",mr="]"):this.token.token_type==="["?(lr="]",mr=")"):this.token.token_type==="{"?(lr="}",mr=null):(lr="RANGLE",mr=null),this.advance(),$e=this.statement_list();let Or=1;if($e[0]==="list"&&(Or=$e.length-1),this.token.token_type!==lr){if(Or!==2||mr===null)throw new ParseError("Expecting "+lr,this.lexer.location);if(this.token.token_type!==mr)throw new ParseError("Expecting ) or ]",this.lexer.location);$e[0]="tuple",$e=["interval",$e];let Pr;Pr=_t==="("?["tuple",!1,!0]:["tuple",!0,!1],$e.push(Pr)}else Or>=2?_t==="("?$e[0]="tuple":_t==="["?$e[0]="array":_t==="{"?$e[0]="set":$e[0]="altvector":_t==="{"&&($e=($e[0]==="|"||$e[0],["set",$e]));this.advance()}else if(this.token.token_type==="|"&&E&&(D===0||!F)){if(D+=1,this.advance(),$e=this.statement({inside_absolute_value:D}),$e=["apply","abs",$e],this.token.token_type!=="|")throw new ParseError("Expecting |",this.lexer.location);this.advance()}else if(this.token.token_type==="ANGLE")if(this.advance(),this.token.token_type==="("){this.advance();let _t=this.statement_list();if(this.token.token_type!==")")throw new ParseError("Expecting )",this.lexer.location);this.advance(),_t[0]==="list"?$e=["angle",..._t.slice(1)]:_t[0]==="*"&&($e=["angle",_t])}else{let _t=[],lr=this.nonMinusFactor({parse_absolute_value:E});for(;lr!==!1;)_t.push(lr),lr=this.nonMinusFactor({parse_absolute_value:E});$e=_t.length===0?"angle":["angle",..._t]}else if(this.token.token_type==="INT"){this.advance();let _t="int";if(this.token.token_type==="_"){this.advance();let mr=this.get_subsuperscript({parse_absolute_value:E});_t=["_",_t,mr]}if(this.token.token_type==="^"){this.advance();let mr=this.get_subsuperscript({parse_absolute_value:E});_t=["^",_t,mr]}let lr=flatten(this.term({parse_absolute_value:E}));if(Array.isArray(lr)&&lr[0]==="*"){let mr=[];for(let Or=0;Or<lr.length-1;Or++)if(lr[Or]==="d"){let Pr=lr[Or+1];lr.splice(Or,2),mr.push(["d",Pr]),Or--}lr.push(...mr)}return["apply",_t,lr]}if(this.token.token_type==="_"){$e===!1&&($e="＿"),this.advance();let _t=this.get_subsuperscript({parse_absolute_value:E});$e=["_",$e,_t]}return $e}leibniz_notation(){var D=this.token.token_text;if(!(this.token.token_type==="VAR"&&(D[0]==="d"||D[0]==="∂")&&(D.length===1||D.length===2&&/[a-zA-Z]/.exec(D[1]))))return!1;let E=D[0],F=1,J="",$e=[],_t=[];if(D.length===2)J=D[1];else if(this.advance(),this.token.token_type==="VARMULTICHAR"||this.token.token_type==="VAR"&&!this.token.token_text.includes("∂"))J=this.token.token_text;else{if(this.token.token_type!=="^"||(this.advance(),this.token.token_type!=="NUMBER")||(F=parseFloat(this.token.token_text),!Number.isInteger(F)))return!1;if(this.advance(),this.token.token_type==="VAR"&&!this.token.token_text.includes("∂")||this.token.token_type==="VARMULTICHAR")J=this.token.token_text;else return!1}if(this.advance(),this.token.token_type!=="/")return!1;let lr=0;for(this.advance();;){if(this.token.token_type!=="VAR"||this.token.token_text[0]!==E)return!1;this.token.token_text.length>2&&(this.lexer.unput(this.token.token_text.slice(2)),this.token.token_text=this.token.token_text.slice(0,2));let mr=this.token.token_text;if(mr.length===2)if(/[a-zA-Z]/.exec(mr[1]))$e.push(mr[1]);else return!1;else{if(this.advance(),!(this.token.token_type==="VAR"&&!this.token.token_text.includes("∂")||this.token.token_type==="VARMULTICHAR"))return!1;$e.push(this.token.token_text)}let Or=1,Pr=!1;if(this.advance({remove_initial_space:!1}),this.token.token_type==="SPACE"&&(Pr=!0,this.advance()),this.token.token_type==="^"){if(this.advance(),this.token.token_type!=="NUMBER"||(Or=parseFloat(this.token.token_text),!Number.isInteger(Or)))return!1;Pr=!1,this.advance({remove_initial_space:!1}),this.token.token_type==="SPACE"&&(Pr=!0,this.advance())}if(_t.push(Or),lr+=Or,lr>F)return!1;if(lr===F){if(!Pr&&(this.token.token_type==="VAR"||this.token.token_type==="VARMULTICHAR"))return!1;this.token.token_type==="SPACE"&&this.advance();let dn="derivative_leibniz";E==="∂"&&(dn="partial_"+dn),D=[dn],F===1?D.push(J):D.push(["tuple",J,F]);let gi=[];for(let qi=0;qi<$e.length;qi+=1)_t[qi]===1?gi.push($e[qi]):gi.push(["tuple",$e[qi],_t[qi]]);return gi=["tuple"].concat(gi),D.push(gi),D}}}},MAX_PM_COUNT=10,MAX_PM_EXPANSIONS=1<<MAX_PM_COUNT;function contains_pm(D){if(!Array.isArray(D))return!1;if(D[0]==="pm")return!0;for(let E=1;E<D.length;E++)if(contains_pm(D[E]))return!0;return!1}function count_pm(D){if(!Array.isArray(D))return 0;let E=+(D[0]==="pm");for(let F=1;F<D.length;F++)E+=count_pm(D[F]);return E}function expand_pm_signs(D){let E=count_pm(D);if(E===0)return[D];if(E>MAX_PM_COUNT)throw Error(`pm: cannot expand ${E} plus-minus operators (limit is ${MAX_PM_COUNT} → ${MAX_PM_EXPANSIONS} combinations)`);let F=1<<E,J=[];for(let $e=0;$e<F;$e++)J.push(replace_pm(D,$e,{idx:0}));return J}function replace_pm(D,E,F){if(!Array.isArray(D))return D;if(D[0]==="pm"){let $e=E>>F.idx&1;F.idx+=1;let _t=replace_pm(D[1],E,F);return $e===0?_t:["-",_t]}let J=[D[0]];for(let $e=1;$e<D.length;$e++)J.push(replace_pm(D[$e],E,F));return J}var transformation_exports=__exportAll({expand:()=>expand,expand_relations:()=>expand_relations,get_component:()=>get_component,perform_matrix_multiplications:()=>perform_matrix_multiplications,perform_matrix_scalar_multiplications:()=>perform_matrix_scalar_multiplications,perform_vector_scalar_multiplications:()=>perform_vector_scalar_multiplications,substitute:()=>substitute,substitute_component:()=>substitute_component}),textToAst$3=new textToAst$4;function expand(D,E){var F=get_tree(D);F=perform_matrix_multiplications(F),F=perform_vector_matrix_additions_scalar_multiplications(F);let J=mr=>!Array.isArray(mr)||!["d","*"].includes(mr[0])||mr[0]==="*"&&mr.slice(1).every(Or=>!Array.isArray(Or)||Or[0]!=="d"),$e=mr=>J(mr)&&!contains_pm(mr),_t=mr=>!contains_pm(mr);var lr=[];return lr.push([textToAst$3.convert("a*(b+c)"),textToAst$3.convert("a*b+a*c"),{variables:{a:$e,b:!0,c:!0},allow_extended_match:!0}]),lr.push([textToAst$3.convert("(a+b)*c"),textToAst$3.convert("a*c+b*c"),{variables:{a:!0,b:!0,c:$e},allow_extended_match:!0}]),E||lr.push([textToAst$3.convert("(a+b)/c"),textToAst$3.convert("a/c+b/c"),{variables:{a:!0,b:!0,c:_t}}]),lr.push([textToAst$3.convert("-(a+b)"),textToAst$3.convert("-a-b")]),lr.push([textToAst$3.convert("a(-b)"),textToAst$3.convert("-ab")]),lr.push([textToAst$3.convert("(a+b)^2"),textToAst$3.convert("a^2+2ab+b^2"),{variables:{a:_t,b:_t}}]),lr.push([textToAst$3.convert("(a+b)^3"),textToAst$3.convert("a^3+3a^2b+3ab^2+b^3"),{variables:{a:_t,b:_t}}]),lr.push([textToAst$3.convert("(a+b)^4"),textToAst$3.convert("a^4+4a^3b+6a^2b^2+4ab^3+b^4"),{variables:{a:_t,b:_t}}]),lr.push([textToAst$3.convert("a*(b+c)*d"),textToAst$3.convert("(a*b+a*c)*d"),{variables:{a:_t,b:!0,c:!0,d:!0}}]),F=applyAllTransformations(F,lr,20),F=flatten$5(F),F=evaluate_numbers(F),F=collect_like_terms_factors(F),F=normalize_negatives(F),F}function perform_matrix_multiplications(D,E=!0,F=!0){var J=get_tree(D);function $e(dn,gi){let qi=dn[1][1],zi=dn[1][2],Hi=gi[1][2];if(gi[1][1]!==zi)return{success:!1};let Qi=dn[2],Gi=gi[2],Zi=["tuple"];for(let Xi=0;Xi<qi;Xi++){let Ki=Qi[Xi+1].slice(1),ea=["tuple"];for(let Ji=0;Ji<Hi;Ji++){let ta=Gi.slice(1).map(ra=>ra[Ji+1]);if(Ki.length!==zi||ta.length!==zi)return subtree;let na=["+",...Ki.map((ra,ia)=>["*",ra,ta[ia]])];ea.push(na)}Zi.push(ea)}return{success:!0,newMatrix:["matrix",["tuple",qi,Hi],Zi]}}function _t(dn,gi){if(!Number.isInteger(gi)||gi<1)return{success:!1};if(gi===1)return{success:!0,newMatrix:dn};let qi=dn[1][1];if(dn[1][2]!==qi)return{success:!1};let zi=dn[2],Hi=JSON.parse(JSON.stringify(zi));for(let Qi=1;Qi<gi;Qi++){let Gi=Hi;Hi=["tuple"];for(let Zi=0;Zi<qi;Zi++){let Xi=Gi[Zi+1].slice(1),Ki=["tuple"];for(let ea=0;ea<qi;ea++){let Ji=zi.slice(1).map(na=>na[ea+1]);if(Xi.length!==qi||Ji.length!==qi)return subtree;let ta=["+",...Xi.map((na,ra)=>["*",na,Ji[ra]])];Ki.push(ta)}Hi.push(Ki)}}return{success:!0,newMatrix:["matrix",["tuple",qi,qi],Hi]}}function lr(dn,gi){let qi=dn[1][1],zi=dn[1][2],Hi=dn[2],Qi=["tuple"];for(let Gi=0;Gi<qi;Gi++){let Zi=["tuple"],Xi=Hi[Gi+1];for(let Ki=0;Ki<zi;Ki++)Zi.push(["*",gi,Xi[Ki+1]]);Qi.push(Zi)}return["matrix",["tuple",qi,zi],Qi]}function mr(){let dn=["^",["matrix","size","matrixData"],"p"],gi={variables:{p:qi=>Number.isInteger(qi)&&qi>0,size:!0,matrixData:!0}};J=transform(J,function(qi){let zi=match$1(qi,dn,gi);if(zi){let Hi=_t(["matrix",zi.size,zi.matrixData],zi.p);return Hi.success?Hi.newMatrix:qi}else return qi})}function Or(){let dn=["*","a",["matrix","size","matrixData"],"b"],gi={variables:{a:!0,b:!0,size:!0,matrixData:!0},allow_implicit_identities:["a","b"]};J=transform(J,function(qi){let zi=match$1(qi,dn,gi);if(zi){let Hi=["matrix",zi.size,zi.matrixData],Qi=[],Gi=[];Array.isArray(zi.a)&&zi.a[0]==="*"?Qi.push(...zi.a.slice(1)):Qi.push(zi.a),Array.isArray(zi.b)&&zi.b[0]==="*"?Gi.push(...zi.b.slice(1)):Gi.push(zi.b);let Zi=Qi.length;for(let Xi=Zi-1;Xi>=0;Xi--){let Ki=Qi[Xi][0];if(Ki==="matrix"){let ea=$e(Qi[Xi],Hi);if(ea.success)Hi=ea.newMatrix,Qi.pop();else break}else{if(["tuple","list","vector","altvector","interval","set","array"].includes(Ki))break;Qi[Xi]!==1&&(Hi=lr(Hi,Qi[Xi])),Qi.pop()}}for(;Gi.length>0;){let Xi=Gi[0][0];if(Xi==="matrix"){let Ki=$e(Hi,Gi[0]);if(Ki.success)Hi=Ki.newMatrix,Gi.splice(0,1);else break}else{if(["tuple","list","vector","altvector","interval","set","array"].includes(Xi))break;Gi[0]!==1&&(Hi=lr(Hi,Gi[0])),Gi.splice(0,1)}}return Qi.length>0||Gi.length>0?["*",...Qi,Hi,...Gi]:Hi}else return qi})}function Pr(){let dn=["*",["matrix",["tuple","m","n"],"matrixData"],"b"],gi={variables:{n:Number.isInteger,m:Number.isInteger,matrixData:!0,b:!0}};J=transform(J,function(qi){let zi=match$1(qi,dn,gi);if(zi){let Hi=zi.m,Qi=zi.n,Gi=zi.b,Zi=zi.matrixData,Xi=[];E&&(Xi.push("vector"),Xi.push("altvector")),F&&Xi.push("tuple");let Ki,ea=[];if(Xi.includes(Gi[0]))Ki=Gi;else if(Array.isArray(Gi)&&Gi[0]==="*"&&Xi.includes(Gi[1][0]))Ki=Gi[1],ea=Gi.slice(2);else return qi;let Ji=Ki.slice(1);if(Ji.length!==Qi)return qi;let ta=[Ki[0]];for(let na=0;na<Hi;na++){let ra=["+",...Zi[na+1].slice(1).map((ia,oa)=>["*",ia,Ji[oa]])];ta.push(ra)}return ea.length>0?["*",ta,...ea]:ta}else return qi})}return mr(),Or(),(E||F)&&Pr(),J}function perform_vector_scalar_multiplications(D,E=!0){var F=get_tree(D);let J=function($e,_t){let lr=["*","a",[_t,"vectorData"],"b"],mr={allow_implicit_identities:["a","b"]};return $e=transform($e,function(Or){let Pr=match$1(Or,lr,mr);if(Pr){if(Pr.a===1&&Pr.b===1)return Or;let dn=Pr.vectorData;dn=Array.isArray(dn)&&dn[0]===_t?dn.slice(1):[dn];let gi=[],qi=[];Array.isArray(Pr.a)&&Pr.a[0]==="*"?gi.push(...Pr.a.slice(1)):gi.push(Pr.a),Array.isArray(Pr.b)&&Pr.b[0]==="*"?qi.push(...Pr.b.slice(1)):qi.push(Pr.b);let zi=gi.length;for(let Qi=zi-1;Qi>=0;Qi--){let Gi=gi[Qi][0];if(["tuple","list","vector","altvector","interval","set","array","matrix"].includes(Gi))break;gi[Qi]!==1&&(dn=dn.map(Zi=>["*",Zi,gi[Qi]])),gi.pop()}for(;qi.length>0;){let Qi=qi[0][0];if(["tuple","list","vector","altvector","interval","set","array","matrix"].includes(Qi))break;qi[0]!==1&&(dn=dn.map(Gi=>["*",Gi,qi[0]])),qi.splice(0,1)}let Hi=[_t,...dn];return gi.length>0||qi.length>0?["*",...gi,Hi,...qi]:Hi}else return Or}),$e};return F=J(F,"vector"),F=J(F,"altvector"),E&&(F=J(F,"tuple")),F}function perform_matrix_scalar_multiplications(D){var E=get_tree(D);let F=["*","a",["matrix","size","matrixData"],"b"],J={allow_implicit_identities:["a","b"]};return E=transform(E,function($e){let _t=match$1($e,F,J);if(_t){if(_t.a===1&&_t.b===1)return $e;let lr=_t.matrixData,mr=[],Or=[];Array.isArray(_t.a)&&_t.a[0]==="*"?mr.push(..._t.a.slice(1)):mr.push(_t.a),Array.isArray(_t.b)&&_t.b[0]==="*"?Or.push(..._t.b.slice(1)):Or.push(_t.b);let Pr=mr.length;for(let gi=Pr-1;gi>=0;gi--){let qi=mr[gi][0];if(["tuple","list","vector","altvector","interval","set","array","matrix"].includes(qi))break;mr[gi]!==1&&(lr=lr.map(zi=>zi==="tuple"?zi:zi.map(Hi=>Hi==="tuple"?Hi:["*",Hi,mr[gi]]))),mr.pop()}for(;Or.length>0;){let gi=Or[0][0];if(["tuple","list","vector","altvector","interval","set","array","matrix"].includes(gi))break;Or[0]!==1&&(lr=lr.map(qi=>qi==="tuple"?qi:qi.map(zi=>zi==="tuple"?zi:["*",zi,Or[0]]))),Or.splice(0,1)}let dn=["matrix",_t.size,lr];return mr.length>0||Or.length>0?["*",...mr,dn,...Or]:dn}else return $e}),E}function expand_relations(D){return transform(get_tree(D),expand_relations_transform)}function expand_relations_transform(D){if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);if(E==="="){if(F.length<=2)return D;let J=["and"];for(let $e=0;$e<F.length-1;$e++)J.push(["=",F[$e],F[$e+1]]);return J}if(E==="gts"||E==="lts"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=[];for(let mr=1;mr<J.length-1;mr++){let Or;Or=$e[mr]?E==="lts"?"<":">":E==="lts"?"le":"ge",_t.push([Or,J[mr],J[mr+1]])}let lr=["and",_t[0],_t[1]];for(let mr=2;mr<_t.length;mr++)lr=["and",lr,_t[mr]];return lr}if(E==="in"||E==="notin"||E==="ni"||E==="notni"){let J=!1;(E==="notin"||E==="notni")&&(J=!0);let $e,_t;if(E==="in"||E==="notin"?($e=F[0],_t=F[1]):($e=F[1],_t=F[0]),_t=to_intervals(_t),_t[0]!=="interval")return D;let lr=_t[1],mr=_t[2];if(lr[0]!=="tuple"||mr[0]!=="tuple")throw Error("Badly formed ast");let Or=lr[1],Pr=lr[2],dn=[];mr[1]?J?dn.push(["<",$e,Or]):dn.push(["ge",$e,Or]):J?dn.push(["le",$e,Or]):dn.push([">",$e,Or]),mr[2]?J?dn.push([">",$e,Pr]):dn.push(["le",$e,Pr]):J?dn.push(["ge",$e,Pr]):dn.push(["<",$e,Pr]);let gi;return gi=J?["or"].concat(dn):["and"].concat(dn),gi}if(E==="subset"||E==="notsubset"||E==="superset"||E==="notsuperset"){let J=!1;(E==="notsubset"||E==="notsuperset")&&(J=!0);let $e,_t;if(E==="subset"||E==="notsubset"?($e=F[0],_t=F[1]):($e=F[1],_t=F[0]),$e=to_intervals($e),_t=to_intervals(_t),$e[0]!=="interval"||_t[0]!=="interval")return D;let lr=$e[1],mr=$e[2],Or=_t[1],Pr=_t[2];if(lr[0]!=="tuple"||mr[0]!=="tuple"||Or[0]!=="tuple"||Pr[0]!=="tuple")throw Error("Badly formed ast");let dn=lr[1],gi=lr[2],qi=Or[1],zi=Or[2],Hi=[];mr[1]&&!Pr[1]?J?Hi.push(["le",dn,qi]):Hi.push([">",dn,qi]):J?Hi.push(["<",dn,qi]):Hi.push(["ge",dn,qi]),mr[2]&&!Pr[2]?J?Hi.push(["ge",gi,zi]):Hi.push(["<",gi,zi]):J?Hi.push([">",gi,zi]):Hi.push(["le",gi,zi]);let Qi;return Qi=J?["or"].concat(Hi):["and"].concat(Hi),Qi}return D}function substitute(D,E){var F=get_tree(D),J={};for(let $e in E)J[$e]=get_tree(E[$e]);return substitute$1(F,J)}function substitute_component(D,E,F){let J=get_tree(D);if(get_tree(F),typeof E=="number")E=[E];else if(!Array.isArray(E))throw Error("Invalid substitute_component: "+E);let $e=["list","tuple","vector","altvector","array"];return _t(J,E);function _t(lr,mr,Or){if(mr.length===0)return F;if(!Array.isArray(lr))throw Error("Invalid substitute_component: expected list, tuple, vector, or array");let Pr=lr[0],dn=lr.slice(1);if(!$e.includes(Pr))throw Error("Invalid substitute_component: expected list, tuple, vector, or array");let gi=mr[0];if(gi<0||gi>dn.length-1)throw Error("Invalid substitute_component: component out of range");let qi=mr.slice(1),zi=_t(dn[gi],qi);return[Pr,...dn.slice(0,gi),zi,...dn.slice(gi+1)]}}function get_component(D,E){let F=get_tree(D);if(typeof E=="number")E=[E];else if(!Array.isArray(E))throw Error("Invalid get_component: "+E);let J=["list","tuple","vector","altvector","array"];return $e(F,E);function $e(_t,lr){if(lr.length===0)return _t;if(!Array.isArray(_t))throw Error("Invalid get_component: expected list, tuple, vector, or array");let mr=_t[0],Or=_t.slice(1);if(!J.includes(mr))throw Error("Invalid get_component: expected list, tuple, vector, or array");let Pr=lr[0];if(Pr<0||Pr>Or.length-1)throw Error("Invalid get_component: component out of range");let dn=lr.slice(1);return $e(Or[Pr],dn)}}function apply_root(D,E){return E===2?["apply","sqrt",D]:E===3?["apply","cbrt",D]:["apply","nthroot",["tuple",D,E]]}function pull_number_outside_root(D,E=2){let F=D,J=1,$e=2,_t=mathjs_default.pow($e,E);for(;_t<=Math.abs(F);)F%_t===0?(F/=_t,J*=$e):($e++,_t=mathjs_default.pow($e,E));return{n_outside:J,n_inside:F}}function make_power(D,E){return E===0?1:E===1?D:["^",D,E]}function collect_radicand_factors(D,E){let F=1,J=$e=>{if(Array.isArray($e)&&$e[0]==="*")for(let _t of $e.slice(1))J(_t);else Array.isArray($e)&&$e[0]==="-"?(F=-F,J($e[1])):typeof $e=="number"&&$e<0?(F=-F,E.push(-$e)):E.push($e)};return J(D),F}function combine_factors(D,E){let F=1,J=new Map,$e=new Map,_t=[],lr=[];for(let mr of D){if(typeof mr=="number"){F*=mr;continue}let Or,Pr;if(typeof mr=="string")Or=mr,Pr=1;else if(Array.isArray(mr)&&mr[0]==="^"&&typeof mr[1]=="string"&&Number.isInteger(mr[2]))Or=mr[1],Pr=mr[2];else{lr.push(mr);continue}if($e.has(Or)||$e.set(Or,is_nonzero_ast(Or,E)===!0),Pr<1&&!$e.get(Or)){lr.push(mr);continue}J.has(Or)?J.set(Or,J.get(Or)+Pr):(_t.push(Or),J.set(Or,Pr))}return{numberFactor:F,expByVar:J,varOrder:_t,others:lr}}function pull_factor_into_root(D,E,F,J,$e,_t){let lr=E>=1?Math.floor(E/F):0;if(lr===0){_t.push(make_power(D,E));return}let mr;if(is_positive_ast(D,J,!1))mr=D;else if(F%2==1&&is_real_ast(D,J))mr=D;else if(F%2==0&&is_real_ast(D,J))mr=lr%2==0?D:["apply","abs",D];else{_t.push(make_power(D,E));return}$e.push(make_power(mr,lr)),_t.push(make_power(D,E%F))}function simplify_powers_in_roots(D,E){if(!Array.isArray(D))return D;var F=D[0],J=D.slice(1);if(F==="*"){let $e=[];for(let dn of J){let gi=simplify_powers_in_roots(dn,E);Array.isArray(gi)&&gi[0]==="*"?$e.push(...gi.slice(1)):$e.push(gi)}let{numberFactor:_t,expByVar:lr,varOrder:mr,others:Or}=combine_factors($e,E),Pr=[];_t!==1&&Pr.push(_t);for(let dn of mr){let gi=make_power(dn,lr.get(dn));gi!==1&&Pr.push(gi)}return Pr.push(...Or),Pr.length===0?1:Pr.length===1?Pr[0]:["*",...Pr]}if(F==="apply"&&["sqrt","cbrt","nthroot"].includes(J[0])){let $e=J[0],_t=2,lr=J[1];if($e==="cbrt")_t=3;else if($e==="nthroot")if(Array.isArray(J[1])&&J[1][0]==="tuple")if(Number.isInteger(J[1][2])&&J[1][2]>0)_t=J[1][2],lr=J[1][1];else return["apply","nthroot",...J.slice(1).map(Xi=>simplify_powers_in_roots(Xi,E))];else _t=2;lr=simplify_powers_in_roots(lr,E);let mr=[],Or=collect_radicand_factors(lr,mr),{numberFactor:Pr,expByVar:dn,varOrder:gi,others:qi}=combine_factors(mr,E);if(Pr===0)return 0;let zi=[],Hi=[];if(Number.isInteger(Pr)){let{n_outside:Xi,n_inside:Ki}=pull_number_outside_root(Pr,_t);Xi!==1&&zi.push(Xi),Ki!==1&&Hi.push(Ki)}else Pr!==1&&Hi.push(Pr);for(let Xi of gi)pull_factor_into_root(Xi,dn.get(Xi),_t,E,zi,Hi);for(let Xi of qi)Array.isArray(Xi)&&Xi[0]==="^"&&Number.isInteger(Xi[2])?pull_factor_into_root(Xi[1],Xi[2],_t,E,zi,Hi):Hi.push(Xi);let Qi=Hi.filter(Xi=>Xi!==1),Gi;if(Qi.length===0)Gi=Or<0?-1:1;else{let Xi=Qi.length===1?Qi[0]:["*",...Qi];Gi=Or<0?["-",Xi]:Xi}let Zi=zi.filter(Xi=>Xi!==1);return Gi!==1&&Zi.push(apply_root(Gi,_t)),Zi.length===0?1:Zi.length===1?Zi[0]:["*",...Zi]}return[F,...J.map($e=>simplify_powers_in_roots($e,E))]}var simplify_exports=__exportAll({add_unit:()=>add_unit,clean:()=>clean,collapse_unary_minus:()=>collapse_unary_minus,collect_like_terms_factors:()=>collect_like_terms_factors,default_order:()=>default_order,evaluate_numbers:()=>evaluate_numbers,perform_vector_matrix_additions_scalar_multiplications:()=>perform_vector_matrix_additions_scalar_multiplications,remove_scaling_units:()=>remove_scaling_units,remove_units:()=>remove_units,set_small_zero:()=>set_small_zero,simplify:()=>simplify,simplify_logical:()=>simplify_logical,simplify_ratios:()=>simplify_ratios});function clean(D){return flatten$5(get_tree(D))}function evalf(D,E){return parseFloat(mathjs_default.format(D,{notation:"exponential",precision:E}))}function collapse_unary_minus(D){var E=get_tree(D);if(!Array.isArray(E))return E;var F=E[0],J=E.slice(1);if(J=J.map($e=>collapse_unary_minus($e)),F==="-"){if(typeof J[0]=="number")return-J[0];if(Array.isArray(J[0])&&J[0][0]==="*"&&typeof J[0][1]=="number")return["*",-J[0][1]].concat(J[0].slice(2));if(Array.isArray(J[0])&&J[0][0]==="/"){if(typeof J[0][1]=="number")return["/",-J[0][1],J[0][2]];if(Array.isArray(J[0][1])&&J[0][1][0]==="*"&&typeof J[0][1][1]=="number")return["/",["*",-J[0][1][1]].concat(J[0][1].slice(2)),J[0][2]]}}return[F].concat(J)}function simplify(D,E,F){var J=get_tree(D);return contains_blank(J)||(E===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(E=D.context.get_assumptions([D.variables()])),J=evaluate_numbers(J,{assumptions:E,max_digits:F,evaluate_functions:!0}),!Array.isArray(J))||(J=simplify_logical(J,E),J=perform_vector_matrix_additions_scalar_multiplications(J),J=simplify_integers_in_roots(J),J=collect_like_terms_factors(J,E,F)),J}function simplify_logical(D,E){var F=get_tree(D);if(contains_blank(F))return F;E===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(E=D.context.get_assumptions([D.variables()])),F=evaluate_numbers(F,{assumptions:E}),F=unflattenRight(F);var J=[];return J.push([["not",["not","a"]],"a"]),J.push([["not",["and","a","b"]],["or",["not","a"],["not","b"]]]),J.push([["not",["or","a","b"]],["and",["not","a"],["not","b"]]]),J.push([["not",["=","a","b"]],["ne","a","b"]]),J.push([["not",["ne","a","b"]],["=","a","b"]]),J.push([["not",["<","a","b"]],["le","b","a"]]),J.push([["not",["le","a","b"]],["not",["le","a","b"]]]),J.push([["not",["in","a","b"]],["notin","a","b"]]),J.push([["not",["subset","a","b"]],["notsubset","a","b"]]),F=applyAllTransformations(F,J,20),F=flatten$5(F),F}function simplify_integers_in_roots(D){if(!Array.isArray(D))return D;var E=D[0],F=D.slice(1);if(E==="*"){let J=1,$e=[];for(let _t of F)if(typeof _t=="number")J*=_t;else{let lr=simplify_integers_in_roots(_t);Array.isArray(lr)&&lr[0]==="*"?typeof lr[1]=="number"?(J*=lr[1],$e.push(...lr.slice(2))):$e.push(...lr.slice(1)):$e.push(lr)}return J!==1&&$e.unshift(J),["*",...$e]}if(E==="apply"&&["sqrt","cbrt","nthroot"].includes(F[0])){let J=F[0],$e=2,_t=F[1];if(J==="cbrt")$e=3;else if(J==="nthroot")if(Array.isArray(F[1])&&F[1][0]==="tuple")if(Number.isInteger(F[1][2])&&F[1][2]>0)$e=F[1][2],_t=F[1][1];else return["apply","nthroot",...F.slice(1).map(simplify_integers_in_roots)];else $e=2;if(_t=simplify_integers_in_roots(_t),Number.isInteger(_t)){let{n_outside:lr,n_inside:mr}=pull_number_outside_root(_t,$e);if(lr!==1)return["*",lr,apply_root(mr,$e)]}else if(Array.isArray(_t)&&_t[0]==="*"&&typeof _t[1]=="number"){let{n_outside:lr,n_inside:mr}=pull_number_outside_root(_t[1],$e);if(lr!==1)return["*",lr,apply_root(["*",mr,..._t.slice(2)],$e)]}return apply_root(_t,$e)}return[E,...F.map(simplify_integers_in_roots)]}function perform_vector_matrix_additions_scalar_multiplications(D,E=!0){var F=get_tree(D);F=perform_matrix_scalar_multiplications(F),F=perform_vector_scalar_multiplications(F,E);let J=["+","a","b"];return F=transform(F,function($e){let _t=match$1($e,J,{allow_permutations:!0});if(_t){let lr=["vector","altvector"];E&&lr.push("tuple");let mr={},Or={},Pr=[];if(lr.includes(_t.a[0])){let gi=_t.a.length-1;mr[gi]||(mr[gi]=[]),mr[gi].push(_t.a)}else if(_t.a[0]==="matrix"){let gi=_t.a[1].slice(1).toString();Or[gi]||(Or[gi]=[]),Or[gi].push(_t.a)}else Pr.push(_t.a);if(lr.includes(_t.b[0])){let gi=_t.b.length-1;mr[gi]||(mr[gi]=[]),mr[gi].push(_t.b)}else if(_t.b[0]==="matrix"){let gi=_t.b[1].slice(1).toString();Or[gi]||(Or[gi]=[]),Or[gi].push(_t.b)}else if(_t.b[0]==="+")for(let gi of _t.b.slice(1))if(lr.includes(gi[0])){let qi=gi.length-1;mr[qi]||(mr[qi]=[]),mr[qi].push(gi)}else if(gi[0]==="matrix"){let qi=gi[1].slice(1).toString();Or[qi]||(Or[qi]=[]),Or[qi].push(gi)}else Pr.push(gi);else Pr.push(_t.b);if(Object.values(mr).every(gi=>gi.length<2)&&Object.values(Or).every(gi=>gi.length<2))return $e;let dn=Pr;for(let gi in mr)if(mr[gi].length<2)dn.push(...mr[gi]);else{let qi=mr[gi].some(Gi=>Gi[0]==="vector"),zi=mr[gi].some(Gi=>Gi[0]==="tuple"),Hi=mr[gi].some(Gi=>Gi[0]==="altvector"),Qi;Qi=qi||zi&&Hi?["vector"]:Hi?["altvector"]:["tuple"];for(let Gi=0;Gi<gi;Gi++)Qi.push(["+",...mr[gi].map(Zi=>Zi[Gi+1])]);dn.push(Qi)}for(let gi in Or)if(Or[gi].length<2)dn.push(...Or[gi]);else{let[qi,zi]=gi.split(",").map(Number),Hi=["tuple"];for(let Gi=0;Gi<qi;Gi++){let Zi=["tuple"];for(let Xi=0;Xi<zi;Xi++)Zi.push(["+",...Or[gi].map(Ki=>Ki[2][Gi+1][Xi+1])]);Hi.push(Zi)}let Qi=["matrix",["tuple",qi,zi],Hi];dn.push(Qi)}return dn.length===1?dn[0]:["+",...dn]}else return $e}),F}function contains_decimal_number(D){return typeof D=="string"?!1:typeof D=="number"?!!(Number.isFinite(D)&&!Number.isInteger(D)):Array.isArray(D)?D.slice(1).some(E=>contains_decimal_number(E)):!1}function contains_only_numbers(D,{include_number_symbols:E=!1,evaluate_functions:F=!1}={}){return typeof D=="string"?!!(E&&(D==="e"&&mathjs_default.define_e||D==="pi"&&mathjs_default.define_pi)||D==="i"&&mathjs_default.define_i):typeof D=="number"?!0:Array.isArray(D)?F&&D[0]==="apply"?D.slice(2).every(J=>contains_only_numbers(J,{include_number_symbols:E})):D.slice(1).every(J=>contains_only_numbers(J,{include_number_symbols:E})):!1}function try_evaluate_sum_of_numbers(D,E,F){if(typeof D=="number"){if(D===0)return E;if(typeof E=="number")return D+E;if(Array.isArray(E)&&E[0]==="+"&&typeof E[1]=="number")return["+",D+E[1],E[2]];if(!F&&Array.isArray(E)&&E[0]==="+"&&typeof E[2]=="number")return["+",D+E[2],E[1]]}return typeof E=="number"&&E===0?D:null}function try_evaluate_negate_number(D){if(typeof D=="number")return-D;if(Array.isArray(D)&&D[0]==="*"&&typeof D[1]=="number")return["*",-D[1]].concat(D.slice(2));if(Array.isArray(D)&&D[0]==="/"){if(typeof D[1]=="number")return["/",-D[1],D[2]];if(Array.isArray(D[1])&&D[1][0]==="*"&&typeof D[1][1]=="number")return["/",["*",-D[1][1]].concat(D[1].slice(2)),D[2]]}return null}function try_evaluate_product_of_numbers(D,E){if(typeof D=="number"){if(isNaN(D))return NaN;if(typeof E=="number")return D*E;if(!isFinite(D))return D===1/0&&is_negative_ast(E)||D===-1/0&&is_positive_ast(E)?-1/0:is_nonzero_ast(E)===!1?NaN:1/0;if(D===0)return 0;if(D===1)return E;if(D===-1)return["-",E];if(Array.isArray(E)&&E[0]==="*"&&typeof E[1]=="number")return D*=E[1],E=E[2],D===1?E:D===-1?["-",E]:["*",D,E]}if(typeof E=="number"){if(isNaN(E))return NaN;if(!isFinite(E))return E===1/0&&is_negative_ast(D)||E===-1/0&&is_positive_ast(D)?-1/0:is_nonzero_ast(D)===!1?NaN:1/0;if(E===0)return 0;if(E===1)return D;if(E===-1)return["-",D];if(Array.isArray(D)&&D[0]==="*"&&typeof D[1]=="number")return E*=D[1],D=D[2],E===1?D:E===-1?["-",D]:["*",D,E]}if(mathjs_default.define_i&&D==="i"){if(E==="i")return-1;if(Array.isArray(E)&&E[0]==="*"&&E[1]==="i")return["-",E[2]]}else if(mathjs_default.define_i&&E==="i"&&Array.isArray(D)&&D[0]==="*"&&D[1]==="i")return["-",D[2]];return null}function try_evaluate_quotient_of_numbers(D,E,F,J){if(typeof D=="number"){if(D===0){let $e=is_nonzero_ast(E,F);if($e)return 0;if($e===!1)return NaN}if(typeof E=="number"){let $e=D/E;if(J===1/0||mathjs_default.round($e,J)===$e)return $e;if(E<0)return["/",-D,-E]}if(Array.isArray(E)&&E[0]==="*"&&typeof E[1]=="number"){let $e=D/E[1];if(J===1/0||mathjs_default.round($e,J)===$e)return["/",$e,E[2]]}}else if(typeof E=="number"){if(Array.isArray(D)&&D[0]==="*"&&typeof D[1]=="number"){let _t=D[1]/E;if(J===1/0||mathjs_default.round(_t,J)===_t)return _t===1?D[2]:["*",_t,D[2]];if(E<0)return["/",["*",-D[1],D[2]],-E]}let $e=1/E;if(J===1/0||mathjs_default.round($e,J)===$e)return["*",$e,D];if(E<0)return Array.isArray(D)&&D[0]==="-"?["/",D[1],-E]:["-",["/",D,-E]]}return null}function set_small_zero(D,E=1e-14){var F=get_tree(D);return typeof F=="number"?mathjs_default.abs(F)<E?0:F:Array.isArray(F)?[F[0],...F.slice(1).map(J=>set_small_zero(J,E))]:F}function evaluate_numbers_sub(D,E,F,J,$e,_t){if(D===void 0)return D;if(typeof D=="number")return _t>0&&mathjs_default.abs(D)<_t?0:D;if(contains_only_numbers(D,{include_number_symbols:!0,evaluate_functions:$e})){let Pr=function(dn){if(_t>0&&mathjs_default.abs(dn)<_t)return 0;if(F===1/0||Number.isInteger(dn))return dn;let gi=evalf(dn,14),qi=evalf(dn,F);if(F===0&&(qi=mathjs_default.round(dn)),qi===gi||contains_decimal_number(D)&&contains_only_numbers(D,{include_number_symbols:!0,evaluate_functions:$e}))return dn;let zi=mathjs_default.fraction(dn),Hi={n:mathjs_default.number(zi.n),d:mathjs_default.number(zi.d),s:mathjs_default.number(zi.s)},Qi=evalf(Hi.d,3);return(Hi.n<1e4||Qi===Hi.d)&&evalf(Hi.s*Hi.n/Hi.d,14)===gi?Hi.d===1?Hi.s*Hi.n:["/",Hi.s*Hi.n,Hi.d]:null};var lr=evaluate_to_constant(D,{remove_units_first:!1});if(!Number.isNaN(lr)){if(typeof lr=="number"){if(Number.isFinite(lr)){let dn=Pr(lr);if(dn!==null)return dn}}else if(lr&&Number.isFinite(lr.re)&&Number.isFinite(lr.im)){let dn=Pr(lr.re),gi=Pr(lr.im);if(dn!==null&&gi!==null){if(gi===0)return dn;{let qi;return qi=gi===1?"i":gi===-1?["-","i"]:["*",gi,"i"],dn===0?qi:["+",dn,qi]}}}}}if(!Array.isArray(D))return D;var mr=D[0],Or=D.slice(1).map(Pr=>evaluate_numbers_sub(Pr,E,F,J,$e,_t));if(mr==="+"){let Pr=Or[0],dn=Or[1];if(dn===void 0)return Pr;let gi=try_evaluate_sum_of_numbers(Pr,dn,J);if(gi!==null)return gi;if(Pr[0]==="unit"&&dn[0]==="unit"){let qi=get_unit_of_tree(Pr),zi=get_unit_of_tree(dn);if(qi&&qi===zi){let Hi=try_evaluate_sum_of_numbers(remove_units(Pr,!1),remove_units(dn,!1),J);if(Hi!==null)return add_unit(Hi,qi)}}return[mr].concat(Or)}if(mr==="-"){let Pr=try_evaluate_negate_number(Or[0]);if(Pr!==null)return Pr;if(Or[0][0]==="unit"){let dn=get_unit_of_tree(Or[0]);if(dn){let gi=try_evaluate_negate_number(remove_units(Or[0],!1));if(gi!==null)return add_unit(gi,dn)}}return[mr].concat(Or)}if(mr==="*"){let Pr=Or[0],dn=Or[1];if(dn===void 0)return Pr;let gi=try_evaluate_product_of_numbers(Pr,dn);if(gi!==null)return gi;if(Pr[0]==="unit"&&dn[0]!=="unit"){let qi=get_unit_of_tree(Pr);if(qi){let zi=try_evaluate_product_of_numbers(remove_units(Pr,!1),dn);if(zi!==null)return add_unit(zi,qi)}}if(Pr[0]!=="unit"&&dn[0]==="unit"){let qi=get_unit_of_tree(dn);if(qi){let zi=try_evaluate_product_of_numbers(Pr,remove_units(dn,!1));if(zi!==null)return add_unit(zi,qi)}}return[mr].concat(Or)}if(mr==="/"){let Pr=Or[0],dn=Or[1],gi=try_evaluate_quotient_of_numbers(Pr,dn,E,F);if(gi!==null)return gi;if(Pr[0]==="unit"&&dn[0]!=="unit"){let qi=get_unit_of_tree(Pr);if(qi){let zi=try_evaluate_quotient_of_numbers(remove_units(Pr,!1),dn,E,F);if(zi!==null)return add_unit(zi,qi)}}return[mr].concat(Or)}if(mr==="^"){let Pr=Or[0],dn=Or[1];if(typeof dn=="number")if(dn===0){if(!mathjs_default.pow_strict)return 1;let gi=is_nonzero_ast(Pr,E);if(gi&&Pr!==1/0&&Pr!==-1/0)return 1;if(gi===!1)return NaN}else{if(dn===1)return Pr;if(typeof Pr=="number"){let gi=mathjs_default.pow(Pr,dn);if(F===1/0||mathjs_default.round(gi,F)===gi)return gi}}else if(Pr===1)return 1;return[mr].concat(Or)}return[mr].concat(Or)}function evaluate_numbers(D,{assumptions:E,max_digits:F,skip_ordering:J=!1,evaluate_functions:$e=!1,set_small_zero:_t=0}={}){(F===void 0||!(Number.isInteger(F)||F===1/0))&&(F=0),_t===!0&&(_t=1e-14);var lr=get_tree(D);if(contains_blank(lr))return lr;E===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(E=D.context.get_assumptions([D.variables()]));var mr;return J?(lr=unflattenRight(flatten$5(lr)),mr=evaluate_numbers_sub(lr,E,F,J,$e,_t)):(lr=move_units_outside_products(lr),lr=unflattenRight(default_order(flatten$5(lr))),mr=default_order(evaluate_numbers_sub(lr,E,F,J,$e,_t)),mr=default_order(evaluate_numbers_sub(unflattenRight(mr),E,F,J,$e,_t))),mr=set_negative_zeros_to_zero(mr),flatten$5(mr)}function set_negative_zeros_to_zero(D){return D===0?0:Array.isArray(D)?[D[0],...D.slice(1).map(set_negative_zeros_to_zero)]:D}function collect_like_terms_factors(D,E,F){function J(Pr){return!!(typeof Pr=="number"||Array.isArray(Pr)&&Pr[0]==="-"&&typeof Pr[1]=="number")}function $e(Pr){return!!(typeof Pr=="number"&&Pr<0||Array.isArray(Pr)&&Pr[0]==="-"&&typeof Pr[1]=="number"&&Pr>0)}function _t(Pr){if(typeof Pr=="number"||Array.isArray(Pr)&&Pr[0]==="-"&&typeof Pr[1]=="number")return!0;var dn=evaluate_to_constant(Pr,{remove_units_first:!1});return!!Number.isFinite(dn)}let lr=Pr=>!contains_pm(Pr);var mr=get_tree(D);if(contains_blank(mr))return mr;E===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(E=D.context.get_assumptions([D.variables()])),mr=evaluate_numbers(mr,{assumptions:E,max_digits:F,evaluate_functions:!0});var Or=[];Or.push([["/","x",["^","y","a"]],["*","x",["^","y",["-","a"]]],{evaluate_numbers:!0,max_digits:F}]),Or.push([["/","x",["apply","exp","a"]],["*","x",["apply","exp",["-","a"]]],{evaluate_numbers:!0,max_digits:F,variables:{x:!0,a:!0}}]),Or.push([["/","x","y"],["*","x",["^","y",["-",1]]],{evaluate_numbers:!0,max_digits:F}]),mr=applyAllTransformations(mr,Or,40),Or=[];for(let Pr in all_units)all_units[Pr].prefix?(Or.push([["+",["unit",Pr,"x"],["unit",Pr,"y"]],["unit",Pr,["+","x","y"]],{variables:{x:!0,y:!0},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["unit",Pr,"x"],["-",["unit",Pr,"y"]]],["unit",Pr,["+","x",["-","y"]]],{variables:{x:!0,y:!0},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}])):(Or.push([["+",["unit","x",Pr],["unit","y",Pr]],["unit",["+","x","y"],Pr],{variables:{x:!0,y:!0},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["unit","x",Pr],["-",["unit","y",Pr]]],["unit",["+","x",["-","y"]],Pr],{variables:{x:!0,y:!0},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]));return Or.push([["*",["^","x","n"],["^","x","m"]],["^","x",["+","n","m"]],{variables:{x:Pr=>is_nonzero_ast(Pr,E)&&lr(Pr),n:J,m:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m","n"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["*",["^","x","n"],["^","x","m"]],["^","x",["+","n","m"]],{variables:{x:lr,n:Pr=>J(Pr)&&is_positive_ast(Pr,E),m:Pr=>J(Pr)&&is_positive_ast(Pr,E)},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m","n"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["^",["-","x"],"n"],["^","x","n"],{variables:{x:!0,n:Pr=>Number.isInteger(Pr)&&Number.isInteger(Pr/2)},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,max_group:1}]),Or.push([["^",["-","x"],"n"],["-",["^","x","n"]],{variables:{x:!0,n:Pr=>Number.isInteger(Pr)&&!Number.isInteger(Pr/2)},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,max_group:1}]),Or.push([["*",["^","x","n"],["^","x","m"]],["^","x",["+","n","m"]],{variables:{x:lr,n:Pr=>J(Pr)&&is_negative_ast(Pr,E),m:Pr=>J(Pr)&&is_negative_ast(Pr,E)},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["*",["apply","exp","n"],["apply","exp","m"]],["apply","exp",["+","n","m"]],{variables:{n:J,m:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m","n"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*","n","x"],["*","m","x"]],["*",["+","n","m"],"x"],{variables:{x:lr,n:J,m:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m","n"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*","n1","x"],["*",["/","n2","m2"],"x"]],["*",["+","n1",["/","n2","m2"]],"x"],{variables:{x:lr,n1:J,n2:J,m2:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m2","n1","n2"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*","n1","x"],["*",["-",["/","n2","m2"]],"x"]],["*",["+","n1",["-",["/","n2","m2"]]],"x"],{variables:{x:lr,n1:J,n2:J,m2:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m2","n1","n2"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*",["/","n1","m1"],"x"],["*",["/","n2","m2"],"x"]],["*",["+",["/","n1","m1"],["/","n2","m2"]],"x"],{variables:{x:lr,n1:J,m1:J,n2:J,m2:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m1","m2","n1","n2"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*",["/","n1","m1"],"x"],["*",["-",["/","n2","m2"]],"x"]],["*",["+",["/","n1","m1"],["-",["/","n2","m2"]]],"x"],{variables:{x:lr,n1:J,m1:J,n2:J,m2:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m1","m2","n1","n2"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["+",["*","n","x"],["-",["*","m","x"]]],["*",["+","n",["-","m"]],"x"],{variables:{x:lr,n:J,m:J},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["m","n"],allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["-",["pm","x"]],["pm","x"],{variables:{x:!0}}]),Or.push([["*","c",["pm","x"]],["pm",["*","c","x"]],{variables:{c:Pr=>!contains_pm(Pr),x:!0},allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["^",["*","x","y"],"a"],["*",["^","x","a"],["^","y","a"]],{allow_permutations:!0}]),Or.push([["^",["^","x","n"],"m"],["^","x",["*","n","m"]],{variables:{x:!0,n:J,m:J},evaluate_numbers:!0,max_digits:F,allow_permutations:!0}]),Or.push([["-",["+","a","b"]],["+",["-","a"],["-","b"]]]),Or.push([["apply","cbrt",["*","a","x"]],["-",["apply","cbrt",["-",["*","a","x"]]]],{variables:{a:Pr=>is_negative_ast(Pr,E),x:!0},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["x"]}]),Or.push([["apply","cbrt",["-","x"]],["-",["apply","cbrt","x"]],{variables:{x:!0},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["x"]}]),Or.push([["apply","nthroot",["tuple",["*","a","x"],"n"]],["-",["apply","nthroot",["tuple",["-",["*","a","x"]],"n"]]],{variables:{a:Pr=>is_negative_ast(Pr,E),x:!0,n:Pr=>Number.isInteger(Pr)&&!Number.isInteger(Pr/2)&&Pr>1},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["x"]}]),Or.push([["apply","nthroot",["tuple",["-","x"],"n"]],["-",["apply","nthroot",["tuple","x","n"]]],{variables:{x:!0,n:Pr=>Number.isInteger(Pr)&&!Number.isInteger(Pr/2)&&Pr>1},evaluate_numbers:!0,max_digits:F,allow_implicit_identities:["x"]}]),Or.push([["^",["apply","abs","x"],"n"],["^","x","n"],{variables:{x:!0,n:Pr=>Number.isInteger(Pr)&&Number.isInteger(Pr/2)},evaluate_numbers:!0,max_digits:F}]),Or.push([["*","x","y"],["*","x","y"],{variables:{x:_t,y:_t},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),mr=applyAllTransformations(mr,Or,40),mr=simplify_powers_in_roots(mr,E),Or=[],Or.push([["*","x",["^","y",["-","a"]]],["/","x",["^","y","a"]],{allow_extended_match:!0,allow_permutations:!0,evaluate_numbers:!0,max_digits:F,max_group:1}]),Or.push([["*","x",["apply","exp",["-","a"]]],["/","x",["apply","exp","a"]],{allow_extended_match:!0,allow_permutations:!0,evaluate_numbers:!0,max_digits:F,max_group:1,variables:{x:!0,a:!0}}]),Or.push([["*","x",["^","y","n"]],["/","x",["^","y",["-","n"]]],{variables:{x:!0,y:!0,n:$e},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["*","x",["apply","exp","n"]],["/","x",["apply","exp",["-","n"]]],{variables:{x:!0,n:$e},evaluate_numbers:!0,max_digits:F,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),mr=applyAllTransformations(mr,Or,40),Or=[],Or.push([["^","y","n"],["/",1,["^","y",["-","n"]]],{variables:{y:!0,n:$e},evaluate_numbers:!0,max_digits:F}]),Or.push([["apply","exp","n"],["/",1,["apply","exp",["-","n"]]],{variables:{n:$e},evaluate_numbers:!0,max_digits:F}]),mr=applyAllTransformations(mr,Or,40),Or=[],Or.push([["/",["/","x","y"],"z"],["/","x",["*","y","z"]],{allow_extended_match:!0,allow_permutations:!0}]),Or.push([["/","x",["/","y","z"]],["/",["*","x","z"],"y"],{allow_extended_match:!0,allow_permutations:!0}]),mr=applyAllTransformations(mr,Or,40),Or=[],Or.push([["*","x",["/","y","z"]],["/",["*","x","y"],"z"],{allow_extended_match:!0,allow_permutations:!0,max_group:1}]),Or.push([["/",["/","x","y"],"z"],["/","x",["*","y","z"]],{allow_extended_match:!0,allow_permutations:!0}]),Or.push([["/","x",["/","y","z"]],["/",["*","x","z"],"y"],{allow_extended_match:!0,allow_permutations:!0}]),mr=applyAllTransformations(mr,Or,40),mr=evaluate_numbers(mr,{assumptions:E,max_digits:F,evaluate_functions:!0}),mr}function simplify_ratios(D,E){function F(_t){var lr=1;return _t=_t.map(function(mr){if(typeof mr=="number")return mr<0?(lr*=-1,-mr):mr;if(!Array.isArray(mr))return mr;if(mr[0]==="-")return lr*=-1,mr[1];if(mr[0]!=="+")return mr;var Or=!1;if((typeof mr[1]=="number"&&mr[1]<0||Array.isArray(mr[1])&&mr[1][0]==="-"||Array.isArray(mr[1])&&mr[1][0]==="*"&&Number(mr[1][1])<0)&&(Or=!0),Or){lr*=-1;var Pr=mr.slice(1).map(dn=>["-",dn]);return evaluate_numbers(["+"].concat(Pr))}else return mr}),{factors:_t,sign_change:lr}}function J(_t,lr){if(!Array.isArray(_t))return lr?["-",_t]:_t;var mr=_t[0];if(mr==="-")return J(_t[1],lr=!0);var Or=_t.slice(1).map(Qi=>J(Qi));if(mr!=="/")return lr?["-",[mr,...Or]]:[mr,...Or];var Pr=Or[0],dn=Or[1];Pr=default_order(Pr,{ignore_negatives:!0});var gi=Array.isArray(Pr)&&Pr[0]==="*"?Pr.slice(1):[Pr],qi=F(gi);gi=qi.factors,lr&&(qi.sign_change*=-1),dn=default_order(dn,{ignore_negatives:!0});var zi=Array.isArray(dn)&&dn[0]==="*"?dn.slice(1):[dn],Hi=F(zi);return zi=Hi.factors,qi.sign_change*Hi.sign_change<0&&(gi[0]=["-",gi[0]]),Pr=gi.length===1?gi[0]:["*"].concat(gi),dn=zi.length===1?zi[0]:["*"].concat(zi),["/",Pr,dn]}var $e=get_tree(D);return contains_blank($e)?$e:(E===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(E=D.context.get_assumptions([D.variables()])),J($e))}function contains_blank(D){return D==="＿"?!0:Array.isArray(D)?D.some(contains_blank):!1}var all_units=get_all_units();function remove_units(D,E=!0){var F=get_tree(D);if(!Array.isArray(F))return F;let J=F[0],$e=F.slice(1);if(J==="unit"){let _t=all_units[get_unit_of_tree(F)];if(!_t)return F;let lr=remove_units(_t.prefix?$e[1]:$e[0],E);return E?_t.scale(lr):lr}else return[J,...$e.map(_t=>remove_units(_t,E))]}function remove_scaling_units(D){var E=get_tree(D);if(!Array.isArray(E))return E;let F=E[0],J=E.slice(1);if(F==="unit"){let $e=all_units[get_unit_of_tree(E)];if(!($e&&$e.only_scales))return E;let _t=remove_scaling_units($e.prefix?J[1]:J[0]);return $e.scale(_t)}else return[F,...J.map($e=>remove_scaling_units($e))]}function add_unit(D,E){var F=get_tree(D);let J=all_units[E];return J?J.prefix?["unit",E,F]:["unit",F,E]:F}function move_units_outside_products(D){if(!Array.isArray(D))return D;let E=D[0],F=D.slice(1);if(E==="*"){let J=[],$e=[];for(let lr of F){let mr=get_unit_value_of_tree(lr);mr?(J.push(mr[0]),$e.push(mr[1])):$e.push(lr)}let _t=["*",...$e];for(let lr of J)_t=add_unit(_t,lr);return _t}else return[E,...F.map(move_units_outside_products)]}var solve_exports=__exportAll({solve_linear:()=>solve_linear});function solve_linear(D,E,F){if(typeof E=="string"){F===void 0&&D.context!==void 0&&D.context.get_assumptions!==void 0&&(F=D.context.get_assumptions([D.variables()]));var J=simplify(get_tree(D),F);if(Array.isArray(J)){var $e=J[0],_t=J.slice(1);if($e==="="||$e==="ne"||$e==="<"||$e==="le"||$e===">"||$e==="ge"){var lr=simplify(["+",_t[0],["-",_t[1]]],F),mr=qi=>!variables(qi).includes(E);if(lr=simplify(applyAllTransformations(lr,[[["+",["*","_a",E],["*","_b",E]],["*",["+","_a","_b"],E],{variables:{_a:mr,_b:mr},allow_permutations:!0,allow_extended_match:!0,allow_implicit_identities:["_a","_b"],evaluate_numbers:!0}]],20)),variables(lr).includes(E)){var Or=match$1(lr,["+",["*","_a",E],"_b"],{variables:{_a:mr,_b:mr},allow_permutations:!0,allow_implicit_identities:["_a","_b"]});if(Or){var Pr=simplify(Or._a),dn=simplify(Or._b);if(is_nonzero_ast(Pr,F)){if($e==="="||$e==="ne"||is_positive_ast(Pr,F)){let qi=simplify(["/",["-",dn],Pr]);return[$e,E,qi]}if(is_negative_ast(Pr,F)){var gi=simplify(["/",["-",dn],Pr]);return $e=$e==="<"?">":$e==="le"?"ge":$e===">"?"<":"le",[$e,E,gi]}}}}}}}}function clean_assumptions(D,E){if(!Array.isArray(D)||D.length===0)return D;D=flatten$5(default_order(simplify_logical(expand_relations(D))));var F=D[0],J=D.slice(1);if(F==="and"||F==="or"){if(J=J.reduce(function($e,_t){return $e.every(function(lr){return!equal(lr,_t)})&&$e.push(_t),$e},[]),F==="and"&&E&&Array.isArray(E)){let $e;$e=E[0]==="and"?E.slice(1):[E],J=J.filter(_t=>$e.every(lr=>!equal(lr,_t)))}D=J.length===1?J[0]:[F].concat(J)}if(F!=="and"&&E&&Array.isArray(E)){let $e;if($e=E[0]==="and"?E.slice(1):[E],!$e.every(_t=>!equal(_t,D)))return}return D}function calculate_derived_assumptions(D,E){if(E===void 0){E=[];for(let Or in D.byvar){let Pr=D.byvar[Or];Pr.length>0&&E.push(Pr)}if(E.length===0)return{};E=E.length===1?E[0]:["and"].concat(E),E=clean_assumptions(E)}if(!Array.isArray(E)||E.length===0)return{};var F=E[0],J=E.slice(1);if(F==="and"||F==="or"){let Or=J.map(function(gi){return calculate_derived_assumptions(D,gi)}),Pr=[...new Set(Or.reduce((gi,qi)=>[...gi,...Object.keys(qi)],[]))],dn={};for(let gi of Pr){let qi=Or.reduce(function(zi,Hi){return Hi[gi]!==void 0&&zi.push(Hi[gi]),zi},[]);if(F==="and"||qi.length===Or.length){let zi=dn[gi];zi=zi===void 0?qi.length>1?[F].concat(qi):qi[0]:qi.length>1?["and",zi,[F].concat(qi)]:["and",zi,qi[0]],dn[gi]=clean_assumptions(zi,get_assumptions(D,gi,{omit_derived:!0}))}}return dn}let $e={};if(F==="="||F==="ne"||F==="<"||F==="le"||F==="in"||F==="subset"||F==="notin"||F==="notsubset"){var _t=!1;for(let Or=0;Or<2;Or++){let Pr=J[Or],dn=J[1-Or],gi=variables(dn);if(typeof Pr!="string"||gi.length===0||gi.includes(Pr))continue;_t=!0;var lr=F;Or===1&&(F==="<"?lr=">":F==="le"?lr="ge":F==="in"?lr="ni":F==="subset"?lr="superset":F==="notin"?lr="notni":F==="notsubset"&&(lr="notsuperset"));let qi=get_assumptions_for_expr(D,dn,[Pr]);if(qi=combine_assumptions(Pr,lr,dn,qi),qi!==void 0){let zi=$e[Pr];zi=zi===void 0?qi:["and",zi,qi],$e[Pr]=clean_assumptions(zi,get_assumptions(D,Pr,{omit_derived:!0}))}}if(_t)return $e}let mr=[];for(let Or of J){let Pr=get_assumptions_for_expr(D,Or,[]);Pr!==void 0&&mr.push(Pr)}if(mr.length===0)return{};mr=mr.length===1?mr[0]:["and"].concat(mr);for(let Or of variables(E))$e[Or]=clean_assumptions(mr,get_assumptions(D,Or,{omit_derived:!0}));return $e}function get_assumptions_for_expr(D,E,F){let J=variables(E);if(J=J.filter(zi=>!F.includes(zi)),J.length===0)return;function $e(zi){return!!(typeof zi=="number"||Array.isArray(zi)&&zi[0]==="-"&&typeof zi[1]=="number")}var _t=["_b"],lr=["_b"],mr={_b:$e},Or={};for(let zi=0;zi<J.length;zi++){let Hi="_a"+zi;Or[J[zi]]=Hi,_t.push(["*",Hi,J[zi]]),lr.push(Hi),mr[Hi]=$e}_t=["+"].concat(_t);var Pr=match$1(E,_t,{variables:mr,allow_permutations:!0,allow_extended_match:!1,allow_implicit_identities:lr,max_group:1});if(!Pr){let zi=[];for(let Hi of variables(E)){let Qi=get_assumptions_for_expr(D,Hi,F);Qi!==void 0&&zi.push(Qi)}return zi.length===0?void 0:zi.length===1?zi[0]:["and"].concat(zi)}for(let zi of J)Or[zi]=Pr[Or[zi]];let dn=!1;Pr._b===0&&Pr._a0===1&&J.length===1&&(dn=!0);var gi=get_assumptions(D,[J],{exclude_variables:F});if(gi===void 0)return;return clean_assumptions(qi(gi));function qi(zi){if(!Array.isArray(zi))return;var Hi=zi[0],Qi=zi.slice(1);if(Hi==="and"||Hi==="or"){let ta=Qi.map(qi).filter(na=>na!==void 0);return ta.length===0?void 0:Hi==="or"?ta.length===Qi.length?["or"].concat(ta):void 0:ta.length===1?ta[0]:["and"].concat(ta)}if(!(["=","ne","<","le"].includes(Hi)||["in","notin","subset","notsubset"].includes(Hi)&&dn)){let ta=F.concat(variables(E)),na=[];for(let ra of variables(zi)){if(ta.includes(ra))continue;let ia=get_assumptions_for_expr(D,ra,ta);ia!==void 0&&na.push(ia)}return na.length===0?zi:na.length===1?["and",zi,na[0]]:["and",zi].concat(na)}let Gi=[];for(let ta=0;ta<=1;ta++){let na=Qi[ta],ra=Qi[1-ta];if(typeof na=="string"&&J.includes(na)){var Zi={};Zi[na]=ra;var Xi=simplify(substitute$1(E,Zi)),Ki=!1,ea=Hi;(ta===1&&Or[na]>0||ta===0&&Or[na]<0)&&(Hi==="<"?(Ki=!0,ea=">"):Hi==="le"?(Ki=!0,ea="ge"):Hi==="in"?(Ki=!0,ea="ni"):Hi==="subset"?(Ki=!0,ea="superset"):Hi==="notin"?(Ki=!0,ea="notni"):Hi==="notsubset"&&(Ki=!0,ea="notsuperset")),Ki?Gi.push([Hi,Xi,E]):Gi.push([Hi,E,Xi]);let ia=get_assumptions_for_expr(D,Xi,F.concat([na]));ia=combine_assumptions(E,ea,Xi,ia),ia!==void 0&&Gi.push(ia)}}if(Gi.length===1)return Gi[0];if(Gi.length>1)return["and"].concat(Gi);let Ji=F.concat(variables(E));Gi=[];for(let ta of variables(zi)){if(Ji.includes(ta))continue;let na=get_assumptions_for_expr(D,ta,Ji);na!==void 0&&Gi.push(na)}return Gi.length===0?zi:Gi.length===1?["and",zi,Gi[0]]:["and",zi].concat(Gi)}}function combine_assumptions(D,E,F,J){if(!["=","ne","<","le",">","ge","in","notin","ni","notni","subset","notsubset","superset","notsuperset"].includes(E))return J;if(Array.isArray(J)){var $e=J[0],_t=J.slice(1);if($e==="and"||$e==="or"){let Pr=_t.map(dn=>combine_assumptions(D,E,F,dn)).filter(dn=>dn!==void 0);return Pr.length===0?void 0:$e==="or"?Pr.length===_t.length?[["or"].concat(Pr)]:void 0:Pr.length===1?Pr[0]:["and"].concat(Pr)}if(!["=","ne","<","le","in","notin","subset","notsubset"].includes($e))return J;var lr=$e,mr;if(equal(_t[0],F))mr=_t[1];else if(equal(_t[1],F))mr=_t[0],$e==="<"?lr=">":$e==="le"?lr="ge":$e==="in"?lr="ni":$e==="notin"?lr="notni":$e==="subset"?lr="superset":$e==="notsubset"&&(lr="notsuperset");else return J;var Or;if(E==="=")Or=lr;else if(lr==="=")Or=E;else if(E==="<")if(lr==="<"||lr==="le")Or="<";else return lr==="in"||lr==="notin"?J:void 0;else if(E==="le")if(lr==="<")Or="<";else if(lr==="le")Or="le";else return lr==="in"||lr==="notin"?J:void 0;else if(E===">")if(lr===">"||lr==="ge")Or=">";else return lr==="in"||lr==="notin"?J:void 0;else if(E==="ge")if(lr===">")Or=">";else if(lr==="ge")Or="ge";else return lr==="in"||lr==="notin"?J:void 0;else if(E==="in")if(lr==="subset")Or="in";else return;else if(E==="notin")if(lr==="superset")Or="notin";else return;else if(E==="ni")if(lr==="notin")Or="notsubset";else return;else if(E==="notni")if(lr==="in")Or="notsuperset";else return;else if(E==="subset")if(lr==="subset")Or="subset";else if(lr==="notni")Or="notni";else if(lr==="notsuperset")Or="notsuperset";else return;else if(E==="notsubset")if(lr==="superset")Or="notsubset";else return;else if(E==="superset")if(lr==="superset")Or="superset";else if(lr==="ni")Or="ni";else if(lr==="notsubset")Or="notsubset";else return;else if(E==="notsuperset")if(lr==="subset")Or="notsuperset";else return;else return;return Or===">"?["<",mr,D]:Or==="ge"?["le",mr,D]:Or==="ni"?["in",mr,D]:Or==="notni"?["notin",mr,D]:Or==="superset"?["subset",mr,D]:Or==="notsuperset"?["notsubset",mr,D]:[Or,D,mr]}}function filter_assumptions_from_tree(D,E){if(!(!Array.isArray(D)||D.length===0)){Array.isArray(E)||(E=[E]);var F=D[0],J=D.slice(1);if(F==="and"){var $e=J.map(function(lr){return filter_assumptions_from_tree(lr,E)});return $e=$e.filter(lr=>lr!==void 0),$e.length===0?void 0:$e.length===1?$e[0]:["and"].concat($e)}var _t=variables(D);if(!(E.filter(lr=>_t.includes(lr)).length>0))return D}}function get_assumptions_sub(D,E,F,J){Array.isArray(E)||(E=[E]);var $e=[];if(E.forEach(function(_t){if(D.byvar[_t]||D.derived[_t]){if(D.byvar[_t]&&D.byvar[_t].length>0){var lr=filter_assumptions_from_tree(D.byvar[_t],F);lr!==void 0&&$e.push(lr)}if(D.derived[_t]&&D.derived[_t].length>0&&!J){var mr=filter_assumptions_from_tree(D.derived[_t],F);mr!==void 0&&$e.push(mr)}}else D.generic.length>0&&(_t==="x"||!variables(D.generic).includes(_t))&&$e.push(substitute$1(D.generic,{x:_t}))}),$e.length===1?$e=$e[0]:$e.length>1&&($e=["and"].concat($e)),$e.length>0)return clean_assumptions($e)}function get_assumptions(D,E,F){F===void 0&&(F={});var J=F.exclude_variables;J===void 0?J=[]:Array.isArray(J)||(J=[J]);var $e,_t=get_tree(E);if(typeof _t=="string")$e=[_t];else if(Array.isArray(_t))Array.isArray(_t[0])&&($e=_t[0]);else return;return $e?get_assumptions_sub(D,$e,J,F.omit_derived):get_assumptions_for_expr(D,_t,J)}function add_assumption(D,E,F){var J=get_tree(E);if(!Array.isArray(J))return 0;J=clean_assumptions(simplify(J,D));var $e=add_assumption_sub(D,J,F);return $e&&(D.derived=calculate_derived_assumptions(D)),$e}function add_assumption_sub(D,E,F){if(E[0]==="and")return E.slice(1).map(_t=>add_assumption_sub(D,_t,F)).reduce(function(_t,lr){return _t+lr});var J=variables(E);if(J.length===0)return 0;let $e=0;!F&&D.generic.length>0&&J.forEach(function(_t){D.byvar[_t]===void 0&&(_t==="x"||!variables(D.generic).includes(_t))&&(add_assumption_sub(D,substitute$1(D.generic,{x:_t}),!0),$e+=1)});for(let _t of J){let lr=solve_linear(E,_t,D),mr=E;lr&&(mr=lr);let Or=D.byvar[_t];Or!==void 0&&Or.length!==0&&(mr=["and",Or,mr]),mr=clean_assumptions(mr),equal(mr,Or)||(D.byvar[_t]=mr,$e+=1)}return $e}function add_generic_assumption(D,E){var F=get_tree(E);if(!Array.isArray(F))return 0;F=clean_assumptions(simplify(F,D));var J=add_generic_assumption_sub(D,F);return J&&(D.derived=calculate_derived_assumptions(D)),J}function add_generic_assumption_sub(D,E){if(E[0]==="and")return E.slice(1).map(_t=>add_generic_assumption_sub(D,_t)).reduce(function(_t,lr){return _t+lr});if(!variables(E).includes("x"))return 0;let F=solve_linear(E,"x",D),J=E;F&&(J=F);let $e=D.generic;return $e.length!==0&&(J=["and",$e,J]),J=clean_assumptions(J),equal(J,$e)?0:(D.generic=J,1)}function remove_assumption(D,E){var F=get_tree(E);if(!Array.isArray(F))return 0;F=clean_assumptions(simplify(F,D));var J=remove_assumption_sub(D,F);return J&&(D.derived=calculate_derived_assumptions(D)),J}function remove_assumption_sub(D,E){if(E[0]==="and")return E.slice(1).map($e=>remove_assumption_sub(D,$e)).reduce(function($e,_t){return $e+_t});var F=variables(E);if(F.length===0)return 0;var J=0;for(let $e of F){let _t=solve_linear(E,$e,D),lr=D.byvar[$e];if(!lr||lr.length===0)continue;let mr=lr[0],Or=lr.slice(1),Pr=Or.length,dn;if(mr==="and")if(Or=Or.filter(gi=>!(equal(gi,E)||equal(gi,_t))),Or.length===0)dn=[];else if(Or.length===1)dn=Or[0];else if(Or.length<Pr)dn=[mr].concat(Or);else continue;else if(equal(lr,E)||equal(lr,_t))dn=[];else continue;J+=1,D.byvar[$e]=dn}return J}function remove_generic_assumption(D,E){var F=get_tree(E);if(!Array.isArray(F))return 0;F=clean_assumptions(simplify(F,D));var J=remove_generic_assumption_sub(D,F);return J&&(D.derived=calculate_derived_assumptions(D)),J}function remove_generic_assumption_sub(D,E){if(E[0]==="and")return E.slice(1).map(Or=>remove_generic_assumption_sub(D,Or)).reduce(function(Or,Pr){return Or+Pr});if(!variables(E).includes("x"))return 0;var F=D.generic;if(F.length===0)return 0;let J=solve_linear(E,"x",D);var $e=F[0],_t=F.slice(1),lr=_t.length,mr;if($e==="and")if(_t=_t.filter(Or=>!(equal(Or,E)||equal(Or,J))),_t.length===0)mr=[];else if(_t.length===1)mr=_t[0];else if(_t.length<lr)mr=[$e].concat(_t);else return 0;else if(equal(F,E)||equal(F,J))mr=[];else return 0;return D.generic=mr,1}function initialize_assumptions(){var D={};return D.byvar={},D.derived={},D.generic=[],D.not_commutative=[],D.get_assumptions=function(E,F){return get_assumptions(D,E,F)},D.add_assumption=function(E,F){return add_assumption(D,E,F)},D.add_generic_assumption=function(E){return add_generic_assumption(D,E)},D.remove_assumption=function(E){return remove_assumption(D,E)},D.remove_generic_assumption=function(E){return remove_generic_assumption(D,E)},D}var operators$1={"+":function(D){return D.join(" ")},"-":function(D){return"-"+D[0]},pm:function(D){return"\\\\pm "+D[0]},"*":function(D){return D.join(" ")},"/":function(D){return"\\\\frac{"+D[0]+"}{"+D[1]+"}"},_:function(D){return D[0]+"_{"+D[1]+"}"},"^":function(D){return D[0]+"^{"+D[1]+"}"},prime:function(D){return D[0]+"\'"},tuple:function(D){return"\\\\left( "+D.join(", ")+" \\\\right)"},array:function(D){return"\\\\left[ "+D.join(", ")+" \\\\right]"},list:function(D){return D.join(", ")},set:function(D){return"\\\\left\\\\{ "+D.join(", ")+" \\\\right\\\\}"},vector:function(D){return"\\\\left( "+D.join(", ")+" \\\\right)"},altvector:function(D){return"\\\\left\\\\langle "+D.join(", ")+" \\\\right\\\\rangle"},interval:function(D){return"\\\\left( "+D.join(", ")+" \\\\right)"},matrix:function(D){return"\\\\left( "+D.join(", ")+" \\\\right)"},and:function(D){return D.join(" \\\\land ")},or:function(D){return D.join(" \\\\lor ")},not:function(D){return"\\\\lnot "+D[0]},"=":function(D){return D.join(" = ")},"<":function(D){return D.join(" < ")},">":function(D){return D.join(" > ")},lts:function(D){return D.join(" < ")},gts:function(D){return D.join(" > ")},le:function(D){return D.join(" \\\\le ")},ge:function(D){return D.join(" \\\\ge ")},ne:function(D){return D.join(" \\\\ne ")},forall:function(D){return"\\\\forall "+D[0]},exists:function(D){return"\\\\exists "+D[0]},in:function(D){return D[0]+" \\\\in "+D[1]},notin:function(D){return D[0]+" \\\\notin "+D[1]},ni:function(D){return D[0]+" \\\\ni "+D[1]},notni:function(D){return D[0]+" \\\\not\\\\ni "+D[1]},subset:function(D){return D[0]+" \\\\subset "+D[1]},subseteq:function(D){return D[0]+" \\\\subseteq "+D[1]},notsubset:function(D){return D[0]+" \\\\not\\\\subset "+D[1]},notsubseteq:function(D){return D[0]+" \\\\not\\\\subseteq "+D[1]},superset:function(D){return D[0]+" \\\\supset "+D[1]},superseteq:function(D){return D[0]+" \\\\supseteq "+D[1]},notsuperset:function(D){return D[0]+" \\\\not\\\\supset "+D[1]},notsuperseteq:function(D){return D[0]+" \\\\not\\\\supseteq "+D[1]},union:function(D){return D.join(" \\\\cup ")},intersect:function(D){return D.join(" \\\\cap ")},implies:function(D){return D.join(" \\\\implies ")},impliedby:function(D){return D.join(" \\\\impliedby ")},iff:function(D){return D.join(" \\\\iff ")},leftarrow:function(D){return D.join(" \\\\leftarrow ")},rightarrow:function(D){return D.join(" \\\\rightarrow ")},leftrightarrow:function(D){return D.join(" \\\\leftrightarrow ")},perp:function(D){return D.join(" \\\\perp ")},parallel:function(D){return D.join(" \\\\parallel ")},derivative_leibniz:function(D){return"\\\\frac{d"+D[0]+"}{d"+D[1]+"}"},partial_derivative_leibniz:function(D){return"\\\\frac{d"+D[0]+"}{d"+D[1]+"}"},"|":function(D){return D[0]+" \\\\mid "+D[1]},":":function(D){return D[0]+" : "+D[1]},binom:function(D){return"\\\\binom{"+D[0]+"}{"+D[1]+"}"},vec:function(D){return"\\\\vec{"+D[0]+"}"},linesegment:function(D){return"\\\\overline{"+D.join(" ")+"}"},angle:function(D,E){return E?"\\\\angle "+D.join(""):"\\\\angle\\\\left( "+D.join(", ")+" \\\\right)"},unit:function(D){return D[1]==="\\\\circ"?D[0]+"^{\\\\circ}":D[0]+" "+D[1]}},allowedLatexSymbolsDefault$1="alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.cot.coth.csc.csch.sec.sech.sin.sinh.tan.tanh.arcsin.arccos.arctan.arccsc.arcsec.arccot.arg.Re.Im.det.angle.perp.circ.%.$.int.varnothing".split("."),convertLatexSymbolsDefault={acos:"arccos",acosh:"arccosh",acot:"arccot",acoth:"arccoth",acsc:"arccsc",acsch:"arccsch",asec:"arcsec",asech:"arcsech",asin:"arcsin",asinh:"arcsinh",atan:"arctan",atanh:"arctanh",deg:"circ",emptyset:"varnothing"},matrixEnvironmentDefault="bmatrix",astToLatex$1=class{constructor({allowedLatexSymbols:D=allowedLatexSymbolsDefault$1,convertLatexSymbols:E=convertLatexSymbolsDefault,matrixEnvironment:F=matrixEnvironmentDefault,padToDigits:J=null,padToDecimals:$e=null,avoidScientificNotation:_t=!1,showBlanks:lr=!0}={}){this.allowedLatexSymbols=D,this.convertLatexSymbols=E,this.matrixEnvironment=F,this.padToDigits=J,this.padToDecimals=$e,this.avoidScientificNotation=_t,this.showBlanks=lr}convert(D){return this.statement(normalize_display_negative_fractions(D))}statement(D){if(!Array.isArray(D))return this.single_statement(D);var E=D[0],F=D.slice(1);if(E==="ldots")return"\\\\ldots";if(!(E in operators$1)&&E!=="apply")throw Error("Badly formed ast: operator "+E+" not recognized.");return["implies","impliedby","iff","rightarrow","leftarrow","leftrightarrow"].includes(E)?operators$1[E](F.map(J=>this.statement(J))):E==="and"||E==="or"?operators$1[E](F.map((function(J,$e){let _t=this.single_statement(J);return _t.match(/ /)&&!_t.match(/^\\\\left\\(.*\\\\right\\)$/)?"\\\\left("+_t+"\\\\right)":_t}).bind(this))):this.single_statement(D)}single_statement(D){if(!Array.isArray(D))return this.expression(D);var E=D[0],F=D.slice(1);if(E==="not")return operators$1[E](F.map((function(J,$e){let _t=this.single_statement(J);return _t.match(/ /)&&!_t.match(/^\\\\left\\(.*\\\\right\\)$/)?"\\\\left("+_t+"\\\\right)":_t}).bind(this)));if(E==="exists"||E==="forall")return operators$1[E]([this.single_statement(F[0])]);if(E==="="||E==="ne"||E==="<"||E===">"||E==="le"||E==="ge"||E==="in"||E==="notin"||E==="ni"||E==="notni"||E==="subset"||E==="notsubset"||E==="subseteq"||E==="notsubseteq"||E==="superset"||E==="notsuperset"||E==="superseteq"||E==="notsuperseteq")return operators$1[E](F.map((function(J,$e){return this.expression(J)}).bind(this)));if(E==="lts"||E==="gts"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=this.expression(J[1]);for(let lr=1;lr<J.length-1;lr++)$e[lr]?E==="lts"?_t+=" < ":_t+=" > ":E==="lts"?_t+=" \\\\le ":_t+=" \\\\ge ",_t+=this.expression(J[lr+1]);return _t}return this.expression(D)}expression(D){if(!Array.isArray(D))return this.term(D);var E=D[0],F=D.slice(1);return E==="+"?F.length===1?"+"+this.term(F[0]):operators$1[E](F.map((function(J,$e){return $e>0?this.termWithPlusIfNotNegated(J):this.term(J)}).bind(this))):["union","intersect","perp","parallel"].includes(E)?operators$1[E](F.map((function(J,$e){return this.term(J)}).bind(this))):this.term(D)}term(D){if(!Array.isArray(D))return this.factor(D);var E=D[0],F=D.slice(1);return E==="-"||E==="pm"?operators$1[E](F.map((function(J,$e){return this.term(J)}).bind(this))):E==="*"?operators$1[E](F.map((function(J,$e){let _t;return $e>0?(_t=this.factorWithParenthesesIfNegatedExplicitPlusOrFraction(J),_t.match(/^[0-9]/)?"\\\\cdot "+_t:J[0]==="angle"&&F.length>1?"\\\\left( "+_t+" \\\\right)":_t):(_t=this.factor(J),J[0]==="angle"&&F.length>1?"\\\\left( "+_t+" \\\\right)":_t)}).bind(this))):E==="/"||E==="unit"?operators$1[E](F.map((function(J,$e){return this.expression(J)}).bind(this))):this.factor(D)}simple_factor_or_function_or_parens(D){var E=this.factor(D);return E.length<=1||typeof D=="string"&&D.match(/^\\w+$/)||Array.isArray(D)&&D[0]==="apply"&&!["sqrt","cbrt","nthroot"].includes(D[1])||E.match(/^\\\\left\\(.*\\\\right\\)$/)||E.match(/^\\\\left\\\\langle.*\\\\right\\\\rangle$/)?!0:typeof D=="number"?!!(D>=0&&(this.avoidScientificNotation||!D.toString().includes("e"))):!1}stringConvert(D){return D.length>1?(this.convertLatexSymbols[D]&&(D=this.convertLatexSymbols[D]),this.allowedLatexSymbols.includes(D)?"\\\\"+D:"\\\\operatorname{"+D+"}"):this.allowedLatexSymbols.includes(D)?"\\\\"+D:D==="＿"&&!this.showBlanks?"":D}factor(D){if(typeof D=="string")return this.stringConvert(D);if(typeof D=="number"){if(D===1/0)return"\\\\infty";if(D===-1/0)return"-\\\\infty";if(Number.isNaN(D))return"NaN";{let J=D.toString(),$e=J.indexOf("e");if($e===-1||this.avoidScientificNotation)return $e!==-1&&this.avoidScientificNotation&&(J=expandScientificNotation(J)),(this.padToDigits!==null||this.padToDecimals!==null)&&(J=padNumberStringToDigitsAndDecimals(J,this.padToDigits,this.padToDecimals)),J;let _t=J.substring(0,$e),lr=J.substring($e+1);if(lr[0]==="+"&&(lr=lr.slice(1)),this.padToDigits!==null||this.padToDecimals!==null){let mr=Number(lr);if(mr>0&&this.padToDecimals!==null)return J=D.toLocaleString("fullwide",{useGrouping:!1}),padNumberStringToDigitsAndDecimals(J,this.padToDigits,this.padToDecimals);{let Or=null;this.padToDecimals!==null&&(Or=this.padToDecimals+mr),_t=padNumberStringToDigitsAndDecimals(_t,this.padToDigits,Or)}}return _t+" \\\\cdot 10^{"+lr+"}"}}if(!Array.isArray(D))return"";var E=D[0],F=D.slice(1);if(E==="^"){if(Number.isInteger(F[0])&&Number.isInteger(F[1]))return F[0]<0?"\\\\left("+F[0].toString()+"\\\\right)^{"+F[1].toString()+"}":F[0].toString()+"^{"+F[1].toString()+"}";let J=this.factor(F[0]),$e=F[0];for(;$e[0]==="prime";)$e=$e[1];return this.simple_factor_or_function_or_parens($e)||$e[0]==="_"&&typeof $e[1]=="string"||(J="\\\\left("+J.toString()+"\\\\right)"),J+"^{"+this.statement(F[1])+"}"}else if(E==="_"){let J=this.factor(F[0]);return this.simple_factor_or_function_or_parens(F[0])||(J="\\\\left("+J.toString()+"\\\\right)"),J+"_{"+this.statement(F[1])+"}"}else if(E==="prime"){let J=F[0],$e=1;for(;J[0]==="prime";)$e+=1,J=J[1];let _t=this.factor(J);this.simple_factor_or_function_or_parens(J)||J[0]==="_"&&typeof J[1]=="string"||(_t="\\\\left("+_t+"\\\\right)");for(let lr=0;lr<$e;lr++)_t+="\'";return _t}else{if(E==="/")return this.term(D);if(E==="-")return operators$1[E](F.map((function(J,$e){return this.factor(J)}).bind(this)));if(E==="tuple"||E==="array"||E==="list"||E==="set"||E==="vector"||E==="altvector"||E==="|"||E===":"||E==="binom"||E==="vec"||E==="linesegment")return operators$1[E](F.map((function(J,$e){return this.statement(J)}).bind(this)));if(E==="interval"){let J=F[0],$e=F[1];if(J[0]!=="tuple"||$e[0]!=="tuple")throw Error("Badly formed ast");let _t=this.statement(J[1])+", "+this.statement(J[2]);return _t=$e[1]?"\\\\left[ "+_t:"\\\\left( "+_t,$e[2]?_t+=" \\\\right]":_t+=" \\\\right)",_t}else if(E==="matrix"){let J=F[0],$e=F[1],_t="\\\\begin{"+this.matrixEnvironment+"} ";for(let lr=0;lr<J[1];lr+=1){for(let mr=0;mr<J[2];mr+=1)_t+=this.statement($e[lr+1][mr+1]),mr<J[2]-1&&(_t+=" & ");lr<J[1]-1&&(_t+=" \\\\\\\\ ")}return _t=_t+" \\\\end{"+this.matrixEnvironment+"}",_t}else if(E==="derivative_leibniz"||E==="partial_derivative_leibniz"){let J="d";E==="partial_derivative_leibniz"&&(J="\\\\partial ");let $e=F[0],_t=F[1],lr=1,mr="";Array.isArray($e)?(mr=$e[1],lr=$e[2]):mr=$e;let Or=J;lr>1?Or=Or.trimRight()+"^{"+lr+"}"+this.stringConvert(mr):Or+=this.stringConvert(mr),Or="\\\\frac{ "+Or+" }{ ";let Pr=1;Array.isArray(_t)&&(Pr=_t.length-1);for(let dn=1;dn<=Pr;dn++){let gi=_t[dn],qi=1,zi="";Array.isArray(gi)?(zi=gi[1],qi=gi[2]):zi=gi,Or=Or+J+this.stringConvert(zi),qi>1&&(Or=Or+"^{"+qi+"}"),Or+=" "}return Or+="}",Or}else if(E==="apply"){if(F[0]==="abs")return"\\\\left|"+this.statement(F[1])+"\\\\right|";if(F[0]==="floor")return"\\\\left\\\\lfloor "+this.statement(F[1])+" \\\\right\\\\rfloor";if(F[0]==="ceil")return"\\\\left\\\\lceil "+this.statement(F[1])+" \\\\right\\\\rceil";if(F[0]==="factorial"){let lr=this.factor(F[1]);return this.simple_factor_or_function_or_parens(F[1])||F[1][0]==="_"&&typeof F[1][1]=="string"?lr+"!":"\\\\left("+lr+"\\\\right)!"}else{if(F[0]==="sqrt")return"\\\\sqrt{"+this.statement(F[1])+"}";if(F[0]==="cbrt")return"\\\\sqrt[3]{"+this.statement(F[1])+"}";if(F[0]==="nthroot")return Array.isArray(F[1])&&F[1][0]==="tuple"&&F[1].length===3?"\\\\sqrt["+this.statement(F[1][2])+"]{"+this.statement(F[1][1])+"}":"\\\\sqrt{"+this.statement(F[1])+"}"}let J=F[0];if(J[0]==="^"&&(J=J[1]),J[0]==="_"&&(J=J[1]),J==="int"){let lr=this.factor(F[0]),mr=F[1],Or;if(Array.isArray(mr)&&mr[0]==="*"){let Pr=[],dn=["*"];for(let gi=1;gi<mr.length;gi++){let qi=mr[gi];Array.isArray(qi)&&qi[0]==="d"?Pr.push(qi):dn.push(qi)}Or=this.term(dn),Pr.length>0&&(Or[Or.length-1].match(/[a-zA-Z]/)&&(Or+="\\\\,"),Or+=Pr.map(gi=>"d"+this.factor(gi[1])).join("\\\\,"))}return Or||=this.term(F[1]),lr+" "+Or}let $e;$e=F[0]==="log10"?"\\\\log_{10}":F[0]==="re"?"\\\\Re":F[0]==="im"?"\\\\Im":this.factor(F[0]);let _t=this.statement(F[1]);return F[1][0]!=="tuple"&&(_t="\\\\left("+_t+"\\\\right)"),$e+_t}else if(E==="angle"){let J=F.every($e=>{if(typeof $e=="string"&&$e.length===1)return!0;if(!Array.isArray($e))return!1;let _t=$e[0];return _t==="_"||_t==="^"||_t==="prime"});return operators$1[E](F.map((function($e,_t){return this.statement($e)}).bind(this)),J)}else return E==="+"&&D.length===2?"+ "+this.factor(D[1]):"\\\\left("+this.statement(D)+"\\\\right)"}}factorWithParenthesesIfNegatedExplicitPlusOrFraction(D){var E=this.factor(D);return E.match(/^-/)||E.match(/^\\+/)||D[0]==="/"?"\\\\left("+E+"\\\\right)":E}termWithPlusIfNotNegated(D){var E=this.term(D);return E.match(/^\\\\pm /)?E:E.match(/^-/)?E.match(/^-[^ ]/)?"- "+E.slice(1):E:"+ "+E}},operators={"+,add":function(D){return["+"].concat(D)},"*,multiply":function(D){return["*"].concat(D)},"/,divide":function(D){return["/",D[0],D[1]]},"-,unaryMinus":function(D){return["-",D[0]]},"-,subtract":function(D){return["+",D[0],["-",D[1]]]},"^,pow":function(D){return["^",D[0],D[1]]},"and,and":function(D){return["and"].concat(D)},"or,or":function(D){return["or"].concat(D)},"not,not":function(D){return["not",D[0]]},"==,equal":function(D){return["="].concat(D)},"<,smaller":function(D){return["<",D[0],D[1]]},">,larger":function(D){return[">",D[0],D[1]]},"<=,smallerEq":function(D){return["le",D[0],D[1]]},">=,largerEq":function(D){return["ge",D[0],D[1]]},"!=,unequal":function(D){return["ne",D[0],D[1]]},"!,factorial":function(D){return["apply","factorial",D[0]]}},mathjsToAst$1=class{convert(D){if(D.isConstantNode)return D.value;if(D.isSymbolNode)return D.name;if(D.isOperatorNode){var E=[D.op,D.fn].join(",");if(E in operators)return operators[E](D.args.map((function($e,_t){return this.convert($e)}).bind(this)));throw Error("Unsupported operator: "+D.op+", "+D.fn)}if(D.isFunctionNode){var F=D.args.map((function($e,_t){return this.convert($e)}).bind(this));F=F.length>1?["tuple"].concat(F):F[0];var J=["apply",D.name];return J.push(F),J}if(D.isArrayNode)return["vector"].concat(D.args.map((function($e,_t){return this.convert($e)}).bind(this)));if(D.isParenthesisNode)return this.convert(D.content);throw Error("Unsupported node type: "+D.type)}},differentiation_exports=__exportAll({derivative:()=>derivative,derivativeStory:()=>derivativeStory,derivative_story:()=>derivative_story,derivative_with_story:()=>derivative_with_story}),astToMathjs=new astToMathjs$2({mathjs:mathjs_default}),mathjsToAst=new mathjsToAst$1,textToAst$2=new textToAst$4,astToLatex=new astToLatex$1,derivatives={sin:textToAst$2.convert("cos x"),cos:textToAst$2.convert("-(sin x)"),tan:textToAst$2.convert("(sec x)^2"),cot:textToAst$2.convert("-((csc x)^2)"),sec:textToAst$2.convert("(sec x)*(tan x)"),csc:textToAst$2.convert("-(csc x)*(cot x)"),sqrt:textToAst$2.convert("1/(2*sqrt(x))"),cbrt:textToAst$2.convert("1/(3*x^(2/3))"),log:textToAst$2.convert("1/x"),ln:textToAst$2.convert("1/x"),exp:textToAst$2.convert("exp(x)"),arcsin:textToAst$2.convert("1/sqrt(1 - x^2)"),arccos:textToAst$2.convert("-1/sqrt(1 - x^2)"),arctan:textToAst$2.convert("1/(1 + x^2)"),arccsc:textToAst$2.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"),arcsec:textToAst$2.convert("1/(sqrt(-1/x^2 + 1)*x^2)"),arccot:textToAst$2.convert("-1/(1 + x^2)"),asin:textToAst$2.convert("1/sqrt(1 - x^2)"),acos:textToAst$2.convert("-1/sqrt(1 - x^2)"),atan:textToAst$2.convert("1/(1 + x^2)"),acsc:textToAst$2.convert("-1/(sqrt(-1/x^2 + 1)*x^2)"),asec:textToAst$2.convert("1/(sqrt(-1/x^2 + 1)*x^2)"),acot:textToAst$2.convert("-1/(1 + x^2)"),abs:textToAst$2.convert("abs(x)/x")};function derivative_with_story(D,E,F=[]){var J=get_tree(D),$e="\\\\frac{d}{d"+E+"} ";if(typeof J=="number"||variables(J).indexOf(E)<0)return F.push("The derivative of a constant is zero, that is, \\\\("+$e+astToLatex.convert(J)+" = 0\\\\)."),0;if(typeof J=="string")return E===J?(F.push("We know the derivative of the identity function is one, that is, \\\\("+$e+astToLatex.convert(J)+" = 1\\\\)."),1):(F.push("As far as \\\\("+astToLatex.convert(E)+"\\\\) is concerned, \\\\("+astToLatex.convert(J)+"\\\\) is constant, so "+$e+astToLatex.convert(J)+" = 0\\\\)."),0);if(!Array.isArray(J))return null;var _t=J[0],lr=J.slice(1);if(_t==="apply"&&lr[0]==="nthroot")if(lr[1].length!==3||lr[1][0]!=="tuple")lr[0]="sqrt";else{let mr=lr[1][2];_t="^",lr=[lr[1][1],["/",1,mr]]}if(_t==="+"||_t==="-"||_t==="~"){F.push("Using the sum rule, \\\\("+$e+astToLatex.convert(J)+" = "+lr.map(function(Or,Pr){return $e+astToLatex.convert(Or)}).join(" + ")+"\\\\).");let mr=[_t].concat(lr.map(function(Or,Pr){return derivative_with_story(Or,E,F)}));return mr=simplify(mr),F.push("So using the sum rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(mr)+"\\\\)."),mr}if(_t==="*"){let mr=[],Or=[];for(let gi=0;gi<lr.length;gi++)typeof lr[gi]=="number"||variables(lr[gi]).indexOf(E)<0?Or.push(lr[gi]):mr.push(lr[gi]);if(Or.length>0){if(mr.length===0)return F.push("Since the derivative of a constant is zero, \\\\("+$e+astToLatex.convert(J)+" = 0.\\\\)"),0;let gi=["*"].concat(mr);if(mr.length===1&&(gi=mr[0]),gi===E){F.push("By the constant multiple rule, \\\\("+$e+astToLatex.convert(J)+" = "+Or.map(function(Qi,Gi){return astToLatex.convert(Qi)}).join(" \\\\cdot ")+"\\\\).");let Hi=["*"].concat(Or);return Hi=simplify(Hi),Hi}F.push("By the constant multiple rule, \\\\("+$e+astToLatex.convert(J)+" = "+Or.map(function(Hi,Qi){return astToLatex.convert(Hi)}).join(" \\\\cdot ")+" \\\\cdot "+$e+"\\\\left("+astToLatex.convert(gi)+"\\\\right)\\\\).");let qi=derivative_with_story(gi,E,F),zi=["*"].concat(Or.concat([qi]));return zi=simplify(zi),F.push("And so \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(zi)+"\\\\)."),zi}F.push("Using the product rule, \\\\("+$e+astToLatex.convert(J)+" = "+lr.map(function(gi,qi){return lr.map(function(zi,Hi){return qi===Hi?$e+"\\\\left("+astToLatex.convert(gi)+"\\\\right)":astToLatex.convert(zi)}).join(" \\\\cdot ")}).join(" + ")+"\\\\).");let Pr=lr.slice(),dn=["+"].concat(lr.map(function(gi,qi){return["*"].concat(Pr.map(function(zi,Hi){if(qi===Hi){let Qi=derivative_with_story(zi,E,F);return Qi===1?null:Qi}else return zi}).filter(function(zi){return zi!=null}))}));return dn=simplify(dn),F.push("So using the product rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(dn)+"\\\\)."),dn}if(_t==="/"){let mr=lr[0],Or=lr[1];if(variables(Or).indexOf(E)<0){F.push("By the constant multiple rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(["/",1,Or])+" \\\\cdot "+$e+"\\\\left("+astToLatex.convert(mr)+"\\\\right)\\\\).");let qi=derivative_with_story(mr,E,F),zi=substitute$1(textToAst$2.convert("(1/g)*d"),{d:qi,g:Or});return zi=simplify(zi),F.push("So \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(zi)+"\\\\)."),zi}if(variables(mr).indexOf(E)<0){mr!==1&&F.push("By the constant multiple rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(mr)+" \\\\cdot "+$e+"\\\\left("+astToLatex.convert(["/",1,Or])+"\\\\right)\\\\)."),F.push("Since \\\\(\\\\frac{d}{du} \\\\frac{1}{u}\\\\) is \\\\(\\\\frac{-1}{u^2}\\\\), the chain rule gives \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(mr)+"\\\\cdot \\\\frac{-1}{ "+astToLatex.convert(Or)+"^2} \\\\cdot "+$e+astToLatex.convert(Or)+"\\\\).");let qi=derivative_with_story(Or,E,F),zi=substitute$1(textToAst$2.convert("f * (-a/(g^2))"),{f:mr,a:qi,g:Or});return zi=simplify(zi),F.push("So since \\\\(\\\\frac{d}{du} \\\\frac{1}{u}\\\\) is \\\\(\\\\frac{-1}{u^2}\\\\), the chain rule gives \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(zi)+"\\\\)."),zi}F.push("Using the quotient rule, \\\\("+$e+astToLatex.convert(J)+" = \\\\frac{"+$e+"\\\\left("+astToLatex.convert(mr)+"\\\\right) \\\\cdot "+astToLatex.convert(Or)+" - "+astToLatex.convert(mr)+"\\\\cdot "+$e+"\\\\left("+astToLatex.convert(Or)+"\\\\right)}{ \\\\left( "+astToLatex.convert(Or)+" \\\\right)^2} \\\\).");let Pr=derivative_with_story(mr,E,F),dn=derivative_with_story(Or,E,F),gi=substitute$1(textToAst$2.convert("(a * g - f * b)/(g^2)"),{a:Pr,b:dn,f:mr,g:Or});return gi=simplify(gi),F.push("So using the quotient rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(gi)+"\\\\)."),gi}if(_t==="^"){let mr=lr[0],Or=lr[1];if(variables(Or).indexOf(E)<0){if(typeof mr=="string"&&mr==="x"){if(typeof Or=="number"){let Zi=substitute$1(textToAst$2.convert("n * (f^m)"),{n:Or,m:Or-1,f:mr});return Zi=simplify(Zi),F.push("By the power rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Or)+" \\\\cdot \\\\left("+astToLatex.convert(mr)+"\\\\right)^{"+astToLatex.convert(["-",Or,1])+"}\\\\)."),Zi}let Gi=substitute$1(textToAst$2.convert("n * (f^(n-1))"),{n:Or,f:mr});return Gi=simplify(Gi),F.push("By the power rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Or)+" \\\\cdot \\\\left("+astToLatex.convert(mr)+"\\\\right)^{"+astToLatex.convert(["-",Or,1])+"}\\\\)."),Gi}Or!==1&&F.push("By the power rule and the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Or)+" \\\\cdot \\\\left("+astToLatex.convert(mr)+"\\\\right)^{"+astToLatex.convert(["-",Or,1])+"} \\\\cdot "+$e+astToLatex.convert(mr)+"\\\\).");let Hi=derivative_with_story(mr,E,F);if(Or===1)return Hi;if(typeof Or=="number"){let Gi=substitute$1(textToAst$2.convert("n * (f^m) * a"),{n:Or,m:Or-1,f:mr,a:Hi});return Gi=simplify(Gi),F.push("So by the power rule and the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Gi)+"\\\\)."),Gi}let Qi=substitute$1(textToAst$2.convert("n * (f^(n-1)) * a"),{n:Or,f:mr,a:Hi});return Qi=simplify(Qi),F.push("So by the power rule and the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Qi)+"\\\\)."),Qi}if(mr==="e"&&mathjs_default.define_e){if(typeof Or=="string"&&Or===E){let Qi=substitute$1(textToAst$2.convert("e^(f)"),{f:Or});return Qi=simplify(Qi),F.push("The derivative of \\\\(e^"+astToLatex.convert(E)+"\\\\) is itself, that is, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(J)+"\\\\)."),Qi}F.push("Using the rule for \\\\(e^x\\\\) and the chain rule, we know \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(J)+" \\\\cdot "+$e+astToLatex.convert(Or)+"\\\\).");let Hi=substitute$1(textToAst$2.convert("e^(f)*d"),{f:Or,d:derivative_with_story(Or,E,F)});return Hi=simplify(Hi),F.push("So using the rule for \\\\(e^x\\\\) and the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Hi)+"\\\\)."),Hi}if(typeof mr=="number"){if(typeof Or=="string"&&Or===E){let Gi=substitute$1(textToAst$2.convert("a^(f) * log(a)"),{a:mr,f:Or});return Gi=simplify(Gi),F.push("The derivative of \\\\(a^"+astToLatex.convert(E)+"\\\\) is \\\\(a^{"+astToLatex.convert(E)+"} \\\\, \\\\log a\\\\), that is, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Gi)+"\\\\)."),Gi}let Hi=substitute$1(textToAst$2.convert("a^(f) * log(a)"),{a:mr,f:Or});F.push("Using the rule for \\\\(a^x\\\\) and the chain rule, we know \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Hi)+" \\\\cdot "+$e+astToLatex.convert(Or)+"\\\\).");let Qi=substitute$1(textToAst$2.convert("a^(b)*log(a)*d"),{a:mr,b:Or,d:derivative_with_story(Or,E,F)});return Qi=simplify(Qi),F.push("So using the rule for \\\\(a^x\\\\) and the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Qi)+"\\\\)."),Qi}let Pr=mr,dn=Or;F.push("Recall the general rule for exponents, namely that \\\\(\\\\frac{d}{dx} u(x)^{v(x)} = u(x)^{v(x)} \\\\cdot \\\\left( v\'(x) \\\\cdot \\\\log u(x) + \\\\frac{v(x) \\\\cdot u\'(x)}{u(x)} \\\\right)\\\\).  In this case, \\\\(u(x) = "+astToLatex.convert(Pr)+"\\\\) and \\\\(v(x) = "+astToLatex.convert(dn)+"\\\\).");let gi=derivative_with_story(Pr,E,F),qi=derivative_with_story(dn,E,F),zi=substitute$1(textToAst$2.convert("(f^g)*(b * log(f) + (g * a)/f)"),{a:gi,b:qi,f:Pr,g:dn});return zi=simplify(zi),F.push("So by the general rule for exponents, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(zi)+"\\\\)."),zi}if(_t==="apply"&&!(lr[0]in derivatives)){let mr=lr[1];F.push("By the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(substitute$1(["apply",lr[0]+"\'","x"],{x:mr}))+" \\\\cdot "+$e+astToLatex.convert(mr)+"\\\\).");let Or=["*",substitute$1(["apply",lr[0]+"\'","x"],{x:mr}),derivative_with_story(mr,E,F)];return Or=simplify(Or),F.push("So by the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Or)+"\\\\)."),Or}if(_t==="apply"&&lr[0]in derivatives||_t in derivatives){let mr=!1;_t==="apply"&&(_t=lr[0],lr=lr.slice(1),mr=!0);let Or=lr[0];if(typeof Or=="number")return F.push("The derivative of a constant is zero so \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(0)+"\\\\)."),0;if(typeof Or=="string"&&Or===E){let Pr=["*",substitute$1(derivatives[_t],{x:Or})];return Pr=simplify(Pr),F.push("It is the case that \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(Pr)+"\\\\)."),Pr}else{if(typeof Or=="string"&&Or!==E)return F.push("Since the derivative of a constant is zero, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(0)+"\\\\)."),0;{let Pr=[_t,"u"];mr&&(Pr=["apply"].concat(Pr)),F.push("Recall \\\\(\\\\frac{d}{du}"+astToLatex.convert(Pr)+" = "+astToLatex.convert(derivative_with_story(Pr,"u",[]))+"\\\\)."),F.push("By the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(substitute$1(derivatives[_t],{x:Or}))+" \\\\cdot "+$e+astToLatex.convert(Or)+"\\\\).");let dn=["*",substitute$1(derivatives[_t],{x:Or}),derivative_with_story(Or,E,F)];return dn=simplify(dn),F.push("So by the chain rule, \\\\("+$e+astToLatex.convert(J)+" = "+astToLatex.convert(dn)+"\\\\)."),dn}}}return 0}function lowercaseFirstLetter(D){return D.charAt(0).toLowerCase()+D.slice(1)}function simplify_story(D){for(let E=D.length-1;E>=1;E--)D[E]===D[E-1]&&D.splice(E,1);for(let E=0;E<D.length;E++)for(let F=E+1;F<D.length;F++)D[E]===D[F]&&(D[F]="Again, "+lowercaseFirstLetter(D[F]));return D}function derivative_story(D,E){var F=[];return derivative_with_story(D,E,F),F=simplify_story(F),F}var derivativeStory=derivative_story;function derivative(D,E){var F=get_tree(D);let J=astToMathjs.convert(log_subscript_to_two_arg_log(normalize_function_names(normalize_applied_functions(F)))),$e=mathjs_default.derivative(J,E);return mathjsToAst.convert($e)}function pm_equals_numerical({expr:D,other:E,randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or=0,include_error_in_number_exponents:Pr=!1,allowed_error_is_absolute:dn=!1,rng:gi}){let qi,zi,Hi,Qi,Gi;try{({variables:qi,integer_variables:zi,functions:Hi,expr:Qi,other:Gi}=prepare_exprs_numerical_eval(D,E,J,$e))}catch{return!1}let Zi,Xi;try{Zi=expand_pm_signs(Qi.tree),Xi=expand_pm_signs(Gi.tree)}catch{return!1}let Ki,ea;try{Ki=Zi.map(oa=>J.fromAst(oa).f()),ea=Xi.map(oa=>$e.fromAst(oa).f())}catch{return!1}let Ji,ta;if(Or>0&&Zi.length>0)try{let oa=replace_numbers_with_parameters({expr:Qi,variables:qi,include_exponents:Pr});Ji=oa.parameters;let ua=Object.keys(Ji);if(ua.length>0){let sa;try{sa=expand_pm_signs(oa.expr_with_params)}catch{sa=null}sa&&sa.length===Zi.length&&(ta=sa.map(aa=>{try{let pa=J.fromAst(aa),ma=pa.derivative(ua[0]);dn||(ma=ma.multiply(Ji[ua[0]]));for(let la of ua.slice(1)){let ha=pa.derivative(la);dn||(ha=ha.multiply(Ji[la])),ma=ma.add(ha)}return ma.multiply(Or).f()}catch{return}}))}}catch{}let na=Number.MAX_VALUE*1e-20,ra=[10,1,100,.1,1e3,.01],ia=0;for(let oa=0;oa<1e3;oa++){let ua=ra[Math.floor(oa/20)%ra.length],sa;try{sa=F(gi,qi,ua)}catch{continue}for(let la=0;la<zi.length;la++)sa[zi[la]]=generate_random_integer(-10,10,gi);for(let la=0;la<Hi.length;la++)sa[Hi[la]]=random_cubic(gi);let aa;if(ta){let la=Object.assign({},sa,Ji);aa=Array(ta.length).fill(0);let ha=!1;for(let ga=0;ga<ta.length;ga++){let Aa=ta[ga];if(!Aa)continue;let Fa;try{Fa=mathjs_default.abs(Aa(la))}catch{ha=!0;break}if(!Number.isFinite(Fa)){ha=!0;break}aa[ga]=Fa}if(ha)continue}let pa,ma;try{pa=Ki.map(la=>la(sa)),ma=ea.map(la=>la(sa))}catch{continue}if(!(!pa.every(la=>typeof la!="boolean"&&Number.isFinite(mathjs_default.abs(la))&&mathjs_default.abs(la)<na)||!ma.every(la=>typeof la!="boolean"&&Number.isFinite(mathjs_default.abs(la))&&mathjs_default.abs(la)<na))){if(!value_multisets_match(pa,ma,_t,lr,mr,aa))return!1;if(ia+=1,ia>=10)return!0}}return!1}function value_multisets_match(D,E,F,J,$e,_t){let lr=gi=>_t&&_t[gi]!==void 0?_t[gi]:0,mr=(gi,qi)=>values_close(D[gi],E[qi],F,J,$e,lr(gi));if(D.length!==E.length)return D.every((gi,qi)=>E.some((zi,Hi)=>mr(qi,Hi)))&&E.every((gi,qi)=>D.some((zi,Hi)=>mr(Hi,qi)));let Or=D.length,Pr=Array(Or).fill(-1),dn=(gi,qi)=>{for(let zi=0;zi<Or;zi++)if(!(qi[zi]||!mr(gi,zi))&&(qi[zi]=!0,Pr[zi]===-1||dn(Pr[zi],qi)))return Pr[zi]=gi,!0;return!1};for(let gi=0;gi<Or;gi++)if(!dn(gi,Array(Or).fill(!1)))return!1;return!0}function values_close(D,E,F,J,$e,_t=0){let lr=mathjs_default.abs(D),mr=mathjs_default.abs(E),Or=Math.min(lr,mr),Pr=Math.max(lr,mr),dn=_t;return dn+=Or*F,dn=Math.min(dn,.1*Or),dn===0&&(D===0||E===0)?dn+=$e:dn+=J,Pr===0||mathjs_default.abs(mathjs_default.subtract(D,E))<dn}var astToText=new astToText$2;function generate_random_integer(D,E,F){return D=mathjs_default.ceil(D),E=mathjs_default.floor(E),mathjs_default.floor(F()*(E-D+1))+D}function random_cubic(D){let E=(D()-.5)*1,F=(D()-.5)*2,J=(D()-.5)*6,$e=(D()-.5)*24;return function(_t){return mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(mathjs_default.add(mathjs_default.multiply(E,_t),F),_t),J),_t),$e)}}var equals$6=function({expr:D,other:E,randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t=1e-12,absolute_tolerance:lr=0,tolerance_for_zero:mr=1e-15,allowed_error_in_numbers:Or=0,include_error_in_number_exponents:Pr=!1,allowed_error_is_absolute:dn=!1,coerce_tuples_arrays:gi=!0,coerce_vectors:qi=!0,rng:zi}){if(J||=D.context,$e||=E.context,Array.isArray(D.tree)&&Array.isArray(E.tree)){let Hi=D.tree[0],Qi=D.tree.slice(1),Gi=E.tree[0],Zi=E.tree.slice(1);if(Hi==="tuple"||Hi==="vector"||Hi==="altvector"||Hi==="list"||Hi==="array"||Hi==="matrix"||Hi==="interval"){if(Gi!==Hi&&({operator1:Hi,operator2:Gi,operands1:Qi,operands2:Zi}=coerce_tuple_array_vectors({operator1:Hi,operator2:Gi,operands1:Qi,operands2:Zi,coerce_tuples_arrays:gi,coerce_vectors:qi})),Gi!==Hi||Zi.length!==Qi.length)return!1;for(let Xi=0;Xi<Qi.length;Xi++)if(!equals$6({expr:J.fromAst(Qi[Xi]),other:$e.fromAst(Zi[Xi]),randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,coerce_tuples_arrays:gi,coerce_vectors:qi,rng:zi}))return!1;return!0}if(Qi.length===2&&["=",">","<","ge","le"].includes(Hi)){if(Zi.length!==2||(Hi===">"?(Hi="<",Qi=[Qi[1],Qi[0]]):Hi==="ge"&&(Hi="le",Qi=[Qi[1],Qi[0]]),Gi===">"?(Gi="<",Zi=[Zi[1],Zi[0]]):Gi==="ge"&&(Gi="le",Zi=[Zi[1],Zi[0]]),Hi!==Gi))return!1;let Xi=["+",Qi[0],["-",Qi[1]]],Ki=["+",Zi[0],["-",Zi[1]]],ea=Hi!=="=";if(contains_pm(Xi)||contains_pm(Ki)){if(Hi==="="){let Ji=(ra,ia)=>{let oa=expand_pm_signs(ra),ua=[];for(let sa of oa){let aa=ia.fromAst(sa).simplify().tree;ua.some(pa=>equal(pa,aa))||ua.push(aa)}return ua.length===1?ua[0]:["*",...ua]},ta,na;try{ta=Ji(Xi,J),na=Ji(Ki,$e)}catch{return!1}return component_equals$1({expr:J.fromAst(ta),other:$e.fromAst(na),randomBindings:F,expr_context:J,other_context:$e,allow_proportional:!0,require_positive_proportion:!1,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,coerce_tuples_arrays:gi,coerce_vectors:qi,rng:zi})}return pm_equals_numerical({expr:J.fromAst(Xi),other:$e.fromAst(Ki),randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,rng:zi})}return component_equals$1({expr:J.fromAst(Xi),other:$e.fromAst(Ki),randomBindings:F,expr_context:J,other_context:$e,allow_proportional:!0,require_positive_proportion:ea,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,coerce_tuples_arrays:gi,coerce_vectors:qi,rng:zi})}}return contains_pm(D.tree)||contains_pm(E.tree)?pm_equals_numerical({expr:D,other:E,randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,rng:zi}):component_equals$1({expr:D,other:E,randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:_t,absolute_tolerance:lr,tolerance_for_zero:mr,allowed_error_in_numbers:Or,include_error_in_number_exponents:Pr,allowed_error_is_absolute:dn,coerce_tuples_arrays:gi,coerce_vectors:qi,rng:zi})},component_equals$1=function({expr:D,other:E,randomBindings:F,expr_context:J,other_context:$e,allow_proportional:_t=!1,require_positive_proportion:lr=!1,relative_tolerance:mr,absolute_tolerance:Or,tolerance_for_zero:Pr,allowed_error_in_numbers:dn,include_error_in_number_exponents:gi,allowed_error_is_absolute:qi,coerce_tuples_arrays:zi,coerce_vectors:Hi,rng:Qi}){var Gi=Number.MAX_VALUE*1e-20,Zi=0,Xi=10,Ki=100,ea,Ji,ta;({variables:ea,integer_variables:Ji,functions:ta,expr:D,other:E}=prepare_exprs_numerical_eval(D,E,J,$e));try{var na=D.f(),ra=E.f()}catch{if(D.equalsViaSyntax(E,{allow_blanks:!0,allowed_error_in_numbers:dn,include_error_in_number_exponents:gi,allowed_error_is_absolute:qi,coerce_tuples_arrays:zi,coerce_vectors:Hi}))return!0;if(!(Array.isArray(D.tree)&&Array.isArray(E.tree))||D.tree[0]!==E.tree[0])return!1;let Fa=D.tree.slice(1),$a=E.tree.slice(1);for(let _a=0;_a<Fa.length;_a++)if(!equals$6({expr:J.fromAst(Fa[_a]),other:$e.fromAst($a[_a]),randomBindings:F,expr_context:J,other_context:$e,relative_tolerance:mr,absolute_tolerance:Or,tolerance_for_zero:Pr,allowed_error_in_numbers:dn,include_error_in_number_exponents:gi,allowed_error_is_absolute:qi,coerce_tuples_arrays:zi,coerce_vectors:Hi,rng:Qi}))return!1;return!0}let ia,oa,ua;if(dn>0){let Fa=replace_numbers_with_parameters({expr:D,variables:ea,include_exponents:gi});ia=J.fromAst(Fa.expr_with_params),oa=Fa.parameters;let $a=Object.keys(oa);if($a.length>0){let _a=ia.derivative($a[0]);if(qi||(_a=_a.multiply(oa[$a[0]])),$a.length>1)for(let ka of $a.slice(1)){let ba=ia.derivative(ka);qi||(ba=ba.multiply(oa[ka])),_a=_a.add(ba)}let fa=_a.multiply(dn);try{ua=fa.f()}catch{}}}var sa=1,aa=[10,1,100,.1,1e3,.01],pa=0;let ma=0,la=!0,ha=0;for(let Fa=0;Fa<10*Ki;Fa++){try{var ga=Aa(aa[pa],Qi)}catch{continue}if(ga.always_zero===!1&&(la=!1),!ga.equal&&!ga.out_of_bounds&&!ga.always_zero&&ga.sufficient_finite_values!==!1&&(ha++,ha>Ki))return!1;if(ga.equal)if(ga.always_zero){if(!la)continue;if(ma+=1,ma>5&&(pa+=1,ma=0),pa>=aa.length)return!0;continue}else return!0}return!1;function Aa(Fa,$a){var _a=F($a,ea,Fa);for(let ts=0;ts<Ji.length;ts++)_a[Ji[ts]]=generate_random_integer(-10,10,$a);for(let ts=0;ts<ta.length;ts++)_a[ta[ts]]=random_cubic($a);var fa;ua&&(fa=Object.assign({},_a,oa));var ka=na(_a),ba=ra(_a);if(typeof ka=="boolean"||typeof ba=="boolean")return{out_of_bounds:!0,always_zero:!1};var Pa=mathjs_default.abs(ka),Ia=mathjs_default.abs(ba);if(!(Pa<Gi&&Ia<Gi)||!((Pa===0||Pa>Zi)&&(Ia===0||Ia>Zi)))return{out_of_bounds:!0,always_zero:!1};var Da=Math.min(Pa,Ia),va=Math.max(Pa,Ia),Ca=1;let ya=0;if(ua){try{ya=mathjs_default.abs(ua(fa))}catch{return{equal_at_start:!1,always_zero:!1}}if(!Number.isFinite(ya))return{equal_at_start:!1,always_zero:!1}}if(ya+=Da*mr,ya=Math.min(ya,.1*Da),ya===0&&(ka===0||ba===0)?ya+=Pr:ya+=Or,!(va===0||mathjs_default.abs(mathjs_default.subtract(ka,ba))<ya)&&(!_t||Pa===0||Ia===0||(Ca=mathjs_default.divide(ka,ba),lr&&!(Ca>0))))return{equal_at_start:!1,always_zero:!1};var Na=va===0,za=0;for(let ts=0;ts<100;ts++){var Ta=F($a,ea,sa/100,_a);for(let Ka=0;Ka<Ji.length;Ka++)Ta[Ji[Ka]]=generate_random_integer(-10,10,$a);for(let Ka=0;Ka<ta.length;Ka++)Ta[ta[Ka]]=random_cubic($a);var es;ua&&(es=Object.assign({},Ta,oa));try{ka=na(Ta),ba=mathjs_default.multiply(ra(Ta),Ca)}catch{continue}if(Pa=mathjs_default.abs(ka),Ia=mathjs_default.abs(ba),Pa<Gi&&Ia<Gi){Da=Math.min(Pa,Ia),va=Math.max(Pa,Ia),za++;let Ka=0;if(ua){try{Ka=mathjs_default.abs(ua(es))}catch{continue}if(!Number.isFinite(Ka))continue}if(Ka+=Da*mr,Ka=Math.min(Ka,.1*Da),Ka===0&&(ka===0||ba===0)?Ka+=Pr:Ka+=Or,!(va===0||mathjs_default.abs(mathjs_default.subtract(ka,ba))<Ka))return{equality_in_middle:!1,always_zero:!1};if(Na&&=va===0,za>=Xi)return{equal:!0,always_zero:Na}}}return{sufficient_finite_values:!1,always_zero:Na}}};function prepare_exprs_numerical_eval(D,E,F,J){F||=D.context,J||=E.context,{expr:D,other:E}=normalize_for_equality_checking(D,E,F,J);var $e=[...new Set([...D.variables(),...E.variables()])];mathjs_default.define_pi&&($e=$e.filter(function(Or){return Or!=="pi"})),mathjs_default.define_i&&($e=$e.filter(function(Or){return Or!=="i"})),mathjs_default.define_e&&($e=$e.filter(function(Or){return Or!=="e"}));var _t=[];for(let Or=0;Or<$e.length;Or++)(is_integer_ast($e[Or],F.assumptions)||is_integer_ast($e[Or],J.assumptions))&&_t.push($e[Or]);var lr=[...new Set([...D.functions(),...E.functions()])].filter(Or=>Or.length===1||Or.includes("_")||Or.includes("^")),mr=lr.filter(Or=>$e.includes(Or));if(lr=lr.filter(Or=>!$e.includes(Or)),mr.length>0){let Or=D.tree,Pr=E.tree,dn="x1";for(;[...lr,...$e].includes(dn);)dn+="x1";let gi="x2";for(;[...lr,...$e].includes(gi);)gi+="x2";for(let qi of mr){let zi=qi+qi;for(;[...lr,...$e].includes(zi);)zi+=qi;let Hi=[[["apply",qi,dn],["apply",zi,dn],{variables:{[dn]:!0}}]];Or=applyAllTransformations(Or,Hi),Pr=applyAllTransformations(Pr,Hi),lr.push(zi)}D=F.fromAst(Or),E=J.fromAst(Pr)}return{variables:$e,integer_variables:_t,functions:lr,expr:D,other:E}}function normalize_for_equality_checking(D,E,F,J){F||=D.context,J||=E.context,D=D.normalize_function_names(),E=E.normalize_function_names(),D=D.log_subscript_to_two_arg_log(),E=E.log_subscript_to_two_arg_log(),D=D.subscripts_to_strings(),E=E.subscripts_to_strings(),D=D.normalize_applied_functions(),E=E.normalize_applied_functions();let $e=rename_functions_with_exponents(D.tree),_t=rename_functions_with_exponents(E.tree);return D=F.fromAst(rename_vecs($e)),E=J.fromAst(rename_vecs(_t)),{expr:D,other:E}}function replace_numbers_with_parameters({expr:D,variables:E,include_exponents:F=!1}){let J={},$e=0;function _t(){$e++;let mr="par"+$e;for(;E.includes(mr);)$e++,mr="par"+$e;return mr}function lr(mr){if(typeof mr=="number"){if(mr===0)return mr;{let dn=_t();return J[dn]=mr,dn}}if(typeof mr=="string"){if(mr==="pi"){if(mathjs_default.define_pi){let dn=_t();return J[dn]=mathjs_default.PI,dn}}else if(mr==="e"&&mathjs_default.define_e){let dn=_t();return J[dn]=mathjs_default.e,dn}return mr}if(!Array.isArray(mr))return mr;let Or=mr[0],Pr=mr.slice(1);return Or==="^"&&!F?[Or,lr(Pr[0]),Pr[1]]:[Or,...Pr.map(lr)]}return D=D.evaluate_numbers({max_digits:1/0}),{expr_with_params:lr(D.tree),parameters:J}}function rename_functions_with_exponents(D){if(!Array.isArray(D))return D;let E=D[0],F=D.slice(1);if(E==="apply"){let J=F[0];return Array.isArray(J)&&J[0]==="^"&&J.slice(1).every($e=>["number","string"].includes(typeof $e))&&(J=astToText.convert(J)),["apply",J,F[1]]}return[E,...F.map(rename_functions_with_exponents)]}function rename_vecs(D){if(!Array.isArray(D))return D;let E=D[0],F=D.slice(1);return E==="vec"&&F.length===1?"__vec_"+astToText.convert(F[0]):[E,...F.map(rename_vecs)]}function randomComplexBindings(D,E,F,J){var $e={};return J===void 0?E.forEach(function(_t){$e[_t]=mathjs_default.complex(D()*2*F-F,D()*2*F-F)}):E.forEach(function(_t){$e[_t]=mathjs_default.complex(J[_t].re+D()*2*F-F,J[_t].im+D()*2*F-F)}),$e}var equals$5=function(D,E,{relative_tolerance:F=1e-12,absolute_tolerance:J=0,tolerance_for_zero:$e=1e-15,allowed_error_in_numbers:_t=0,include_error_in_number_exponents:lr=!1,allowed_error_is_absolute:mr=!1,allow_blanks:Or=!1,coerce_tuples_arrays:Pr=!0,coerce_vectors:dn=!0}={}){if(!Or&&(D.variables().includes("＿")||E.variables().includes("＿")))return!1;let gi=(0,import_seedrandom.default)("complex_seed");return D=D.remove_scaling_units(),E=E.remove_scaling_units(),equals$6({expr:D,other:E,randomBindings:randomComplexBindings,expr_context:D.context,other_context:E.context,relative_tolerance:F,absolute_tolerance:J,tolerance_for_zero:$e,allowed_error_in_numbers:_t,include_error_in_number_exponents:lr,allowed_error_is_absolute:mr,coerce_tuples_arrays:Pr,coerce_vectors:dn,rng:gi})};function randomRealBindings(D,E,F,J){var $e={};return J===void 0?E.forEach(function(_t){$e[_t]=D()*2*F-F}):E.forEach(function(_t){$e[_t]=J[_t]+D()*2*F-F}),$e}var equals$4=function(D,E,{relative_tolerance:F=1e-12,absolute_tolerance:J=0,tolerance_for_zero:$e=1e-15,allowed_error_in_numbers:_t=0,include_error_in_number_exponents:lr=!1,allowed_error_is_absolute:mr=!1}={}){if(!D.isAnalytic()||!E.isAnalytic())return!1;let Or=seedrandom("real_seed");return equals$6({expr:D,other:E,randomBindings:randomRealBindings,expr_context:D.context,other_content:E.context,relative_tolerance:F,absolute_tolerance:J,tolerance_for_zero:$e,allowed_error_in_numbers:_t,include_error_in_number_exponents:lr,allowed_error_is_absolute:mr,rng:Or})},equals$3=function(D,E,{allowed_error_in_numbers:F=0,include_error_in_number_exponents:J=!1,allowed_error_is_absolute:$e=!1,allow_blanks:_t=!1,coerce_tuples_arrays:lr=!0,coerce_vectors:mr=!0}={}){if(!_t&&(D.variables().includes("＿")||E.variables().includes("＿")))return!1;let Or=D.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order(),Pr=E.normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order();return equal(Or.tree,Pr.tree,{allowed_error_in_numbers:F,include_error_in_number_exponents:J,allowed_error_is_absolute:$e,coerce_tuples_arrays:lr,coerce_vectors:mr})};function randomFiniteFieldBindings(D,E,F){var J={};return E.forEach(function($e){J[$e]=Math.floor(D()*F)}),J}var equals$2=function(D,E,{allow_blanks:F=!1,coerce_tuples_arrays:J=!0,coerce_vectors:$e=!0}={}){if(!F&&(D.variables().includes("＿")||E.variables().includes("＿")))return!1;let _t=(0,import_seedrandom.default)("finite_field_seed");if(Array.isArray(D.tree)&&Array.isArray(E.tree)){let gi=D.tree[0],qi=D.tree.slice(1),zi=E.tree[0],Hi=E.tree.slice(1);if(gi==="tuple"||gi==="vector"||gi==="altvector"||gi==="list"||gi==="array"||gi==="matrix"||gi==="interval"){if(zi!==gi&&({operator1:gi,operator2:zi,operands1:qi,operands2:Hi}=coerce_tuple_array_vectors({operator1:gi,operator2:zi,operands1:qi,operands2:Hi,coerce_tuples_arrays:J,coerce_vectors:$e})),zi!==gi||Hi.length!==qi.length)return!1;for(let Qi=0;Qi<qi.length;Qi++)if(equals$2(D.context.fromAst(qi[Qi]),E.context.fromAst(Hi[Qi]),_t)===!1)return!1;return}if(qi.length===2&&["=",">","<","ge","le"].includes(gi)){if(Hi.length!==2||(gi===">"?(gi="<",qi=[qi[1],qi[0]]):gi==="ge"&&(gi="le",qi=[qi[1],qi[0]]),zi===">"?(zi="<",Hi=[Hi[1],Hi[0]]):zi==="ge"&&(zi="le",Hi=[Hi[1],Hi[0]]),gi!==zi))return!1;let Qi=["+",qi[0],["-",qi[1]]],Gi=["+",Hi[0],["-",Hi[1]]],Zi=gi!=="=",Xi=D.context.fromAst(Qi),Ki=E.context.fromAst(Gi);try{let ea=prepare_exprs_numerical_eval(Xi,Ki);if(ea.functions.length===0){var lr=ea.expr.f(),mr=ea.other.f();let Ji=Number.MAX_VALUE*1e-20;for(let ta=0;ta<10;ta++){var Or={};ea.variables.forEach(function(oa){Or[oa]=_t()*2-1});for(let oa=0;oa<ea.integer_variables.length;oa++)Or[ea.integer_variables[oa]]=mathjs_default.floor(_t()*21)-10;let na=lr(Or),ra=mr(Or);var Pr=mathjs_default.abs(na),dn=mathjs_default.abs(ra);if(!(Pr<Ji&&dn<Ji)||Pr==0||dn===0)continue;let ia=mathjs_default.divide(na,ra);if(Zi&&!(ia>0))return!1;if(ia!==1){let oa=rationalApproximation(ia);Ki=E.context.fromAst(["*",["/",oa.numerator,oa.denominator],Gi])}break}}}catch{return}return component_equals(Xi,Ki,_t)}}return component_equals(D,E,_t)},component_equals=function(D,E,F){({expr:D,other:E}=normalize_for_equality_checking(D,E));let J=[1181,1187,1193,1201,1213,1217,1223,1229,1231];var $e=[...new Set([...D.variables(),...E.variables()])];for(let _t of J){let lr=randomFiniteFieldBindings(F,$e,_t);try{let mr=D.finite_field_evaluate(lr,_t),Or=E.finite_field_evaluate(lr,_t);if(!mr.approximate&&!Or.approximate&&!mr.isNaN()&&!Or.isNaN()&&mr.values.length>0&&Or.values.length>0&&!mr.equals(Or))return!1}catch{return}}},equals$1=function(D,E,{min_elements_match:F=3,match_partial:J=!1}={}){if(!is_discrete_infinite_set(D))return!1;if(is_discrete_infinite_set(E)){var $e=[];let _t=D.context.get_assumptions(D);if(_t!==void 0&&$e.push(_t),_t=E.context.get_assumptions(E),_t!==void 0&&$e.push(_t),$e=$e.length===0?void 0:$e.length===1?$e[0]:clean_assumptions(["and"].concat($e)),J){let lr=contained_in(D.tree,E.tree,$e,J);if(lr===!1)return 0;let mr=contained_in(E.tree,D.tree,$e,J);return mr===!1?0:lr===!0?mr===!0?1:mr:mr===!0?lr:Math.min(lr,mr)}else return contained_in(D.tree,E.tree,$e,J)&&contained_in(E.tree,D.tree,$e,J)}else{let _t=E.tree;if(_t[0]!=="list")return!1;let lr=_t.length-2;if(_t[lr+1][0]!=="ldots"||lr<F)return!1;let mr=_t.slice(0,lr+1),Or=sequence_from_discrete_infinite(D,lr);return Or?(Or=["list"].concat(Or),equals(D.context.from(Or),E.context.from(mr))):!1}};function is_discrete_infinite_set(D){var E=D.tree;if(!Array.isArray(E)||E[0]!=="discrete_infinite_set")return!1;for(var F of E.slice(1))if(!Array.isArray(F)||F[0]!=="tuple"||F.length!==5)return!1;return!0}function contained_in(D,E,F,J){if(D[0]==="discrete_infinite_set")if(J){let qi=0;for(let Hi of D.slice(1)){let Qi=contained_in(Hi,E,F,J);Qi===!0?qi++:Qi!==!1&&(qi+=Qi)}let zi=D.length-1;return qi===zi?!0:qi===0?!1:qi/zi}else return D.slice(1).every(qi=>contained_in(qi,E,F));var $e=D[1],_t=D[2],lr=evaluate_numbers(D[3],F),mr=D[4];if(lr!==-1/0||mr!==1/0)return!1;$e=simplify(["/",$e,_t],F,1/0);var Or=E.slice(1),Pr=[];for(let qi=0;qi<Or.length;qi++){let zi=evaluate_numbers(Or[qi][3]),Hi=Or[qi][4];if(zi!==-1/0||Hi!==1/0)return!1;let Qi=simplify(["/",Or[qi][1],_t],F,1/0),Gi=simplify(["/",Or[qi][2],_t],F,1/0);if(typeof Gi!="number")return!1;let Zi=mathjs_default.fraction(Gi),Xi=mathjs_default.number(Zi.n),Ki=mathjs_default.number(Zi.d);Pr.push([Xi,Ki,Qi,Gi])}for(Pr.sort();Pr[0][0]===1;){let qi=Pr[0][2],zi=Pr[0][3],Hi=simplify(expand(["+",qi,["-",$e]]),F,1/0);if(Number.isFinite(Hi)&&Number.isFinite(zi)&&(Hi=mathjs_default.mod(Hi,zi),mathjs_default.min(Hi,zi-Hi)<1e-10*zi))return!0;if(Pr.splice(0,1),Pr.length===0)return!1}var dn=[...new Set(Pr.map(qi=>qi[0]))];let gi=0;for(let qi of dn){let zi=Pr.map(function(Qi,Gi){if(mathjs_default.mod(qi,Qi[0])===0){let Zi=qi/Qi[0];return[Qi[0],Zi,Gi]}else return}).filter(Qi=>Qi),Hi=[];for(let Qi of zi){let Gi=Qi[0],Zi=Qi[1],Xi=Qi[2],Ki=Pr[Xi][2],ea=Pr[Xi][3];for(let Ji=0;Ji<Gi;Ji++){let ta=simplify(expand(["+",Ki,["-",["+",$e,Ji]]]),F,1/0);if(Number.isFinite(ta)&&Number.isFinite(ea)&&(ta=mathjs_default.mod(ta,ea),mathjs_default.min(ta,ea-ta)<1e-10*ea)){for(let ra=0;ra<Zi;ra++)Hi[Ji+ra*Gi]=!0;let na=!0;for(let ra=0;ra<qi;ra++)if(!Hi[ra]){na=!1;break}if(na)return!0;break}}}if(J){let Qi=0;for(let Gi=0;Gi<qi;Gi++)Hi[Gi]&&Qi++;Qi/=qi,Qi>gi&&(gi=Qi)}}return J&&gi>0?gi:!1}function sequence_from_discrete_infinite(D,E){var F=D.tree.slice(1);if(F.length>1)return;let J=F[0][1],$e=F[0][2],_t=evaluate_numbers(F[0][3]),lr=F[0][4];if(!Number.isInteger(_t)||lr!==1/0)return;let mr=[];for(let Or=0;Or<E;Or++)mr.push(evaluate_numbers(["+",["*",$e,_t+Or],J]));return mr}var equality_exports=__exportAll({equals:()=>equals,equalsDiscreteInfinite:()=>equals$1,equalsViaComplex:()=>equals$5,equalsViaFiniteField:()=>equals$2,equalsViaReal:()=>equals$4,equalsViaSyntax:()=>equals$3}),equals=function(D,E,{relative_tolerance:F=1e-12,absolute_tolerance:J=0,tolerance_for_zero:$e=1e-15,allowed_error_in_numbers:_t=0,include_error_in_number_exponents:lr=!1,allowed_error_is_absolute:mr=!1,allow_blanks:Or=!1,coerce_tuples_arrays:Pr=!0,coerce_vectors:dn=!0}={}){if(!Or&&(D.variables().includes("＿")||E.variables().includes("＿")))return!1;let gi=D.evaluate_numbers({max_digits:1/0}).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify(),qi=E.evaluate_numbers({max_digits:1/0}).normalize_function_names().normalize_applied_functions().normalize_negative_numbers().normalize_angle_linesegment_arg_order().remove_scaling_units().simplify();return gi.equalsViaSyntax(qi,{allowed_error_in_numbers:_t,include_error_in_number_exponents:lr,allowed_error_is_absolute:mr,allow_blanks:!0,coerce_tuples_arrays:Pr,coerce_vectors:dn})?!0:_t===0&&D.equalsViaFiniteField(E,{allow_blanks:!0,coerce_tuples_arrays:Pr,coerce_vectors:dn})==0?!1:D.equalsViaComplex(E,{relative_tolerance:F,absolute_tolerance:J,tolerance_for_zero:$e,allowed_error_in_numbers:_t,include_error_in_number_exponents:lr,allowed_error_is_absolute:mr,allow_blanks:!0,coerce_tuples_arrays:Pr,coerce_vectors:dn})?!0:!!equals$1(D,E)},sign_error_exports=__exportAll({equalSpecifiedSignErrors:()=>equalSpecifiedSignErrors,equalWithSignErrors:()=>equalWithSignErrors}),equalWithSignErrors=function(D,E,{equalityFunction:F=equals,max_sign_errors:J=1}={}){if(F(D,E))return{matched:!0,n_sign_errors:0};for(let $e=1;$e<=J;$e++)if(equalSpecifiedSignErrors(D,E,{equalityFunction:F,n_sign_errors:$e}))return{matched:!0,n_sign_errors:$e};return{matched:!1}},equalSpecifiedSignErrors=function(D,E,{equalityFunction:F=equals,n_sign_errors:J=1}={}){if(J===0)return F(D,E);if(!(Number.isInteger(J)&&J>0))throw Error(`Have not implemented equality check with ${J} sign errors.`);if(J>1){let dn=F;F=function(gi,qi){return equalSpecifiedSignErrors(gi,qi,{equalityFunction:dn,n_sign_errors:J-1})}}var $e=D.tree,_t=[[$e]],lr=0,mr,Or;D.tree=["-",$e];var Pr=F(D,E);if(D.tree=$e,Pr)return!0;for(;mr=_t[lr++];)if(mr=mr[0],Array.isArray(mr)){for(Or=1;Or<mr.length;Or++)if(_t.push([mr[Or]]),mr[Or]=["-",mr[Or]],Pr=F(D,E),mr[Or]=mr[Or][1],Pr)return!0}return!1},arithmetic_exports=__exportAll({add:()=>add,copy:()=>copy,divide:()=>divide,mod:()=>mod$2,multiply:()=>multiply,pow:()=>pow,subtract:()=>subtract});function add(D,E){return clean(["+",get_tree(D),get_tree(E)])}function subtract(D,E){return clean(["+",get_tree(D),["-",get_tree(E)]])}function multiply(D,E){return clean(["*",get_tree(D),get_tree(E)])}function divide(D,E){return clean(["/",get_tree(D),get_tree(E)])}function pow(D,E){return clean(["^",get_tree(D),get_tree(E)])}function mod$2(D,E){return clean(["apply","mod",["tuple",get_tree(D),get_tree(E)]])}function copy(D){return get_tree(D)}var analytic_exports=__exportAll({isAnalytic:()=>isAnalytic}),analytic_operators=["+","-","*","/","^","tuple","vector","altvector","list","array","matrix","interval","vec"],non_analytic_functions=["abs","sign","arg"],relation_operators=["=","le","ge","<",">"];function isAnalytic(D,{allow_abs:E=!1,allow_arg:F=!1,allow_relation:J=!1}={}){var $e=normalize_applied_functions(normalize_function_names(D));$e=subscripts_to_strings($e);var _t=operators$3($e);for(let mr=0;mr<_t.length;mr++){let Or=_t[mr];if(analytic_operators.indexOf(Or)===-1)if(J){if(relation_operators.indexOf(Or)===-1)return!1}else return!1}var lr=functions$2($e);for(let mr=0;mr<lr.length;mr++){let Or=lr[mr];if(non_analytic_functions.includes(Or)&&!(E&&Or=="abs"||F&&Or=="arg"))return!1}return!0}var sets_exports=__exportAll({create_discrete_infinite_set:()=>create_discrete_infinite_set});function create_discrete_infinite_set({offsets:D,periods:E,min_index:F=["-",1/0],max_index:J=1/0}={}){if(D=get_tree(D),E=get_tree(E),F=get_tree(F),J=get_tree(J),D===void 0||E===void 0)return;let $e=[];if(D[0]==="list")if(E[0]==="list"){if(D.length!==E.length||D.length===1)return;for(let _t=1;_t<D.length;_t++)$e.push(["tuple",D[_t],E[_t],F,J])}else for(let _t=1;_t<D.length;_t++)$e.push(["tuple",D[_t],E,F,J]);else $e.push(["tuple",D,E,F,J]);return["discrete_infinite_set"].concat($e)}var matrix_exports=__exportAll({cross_prod:()=>cross_prod,dot_prod:()=>dot_prod,matrix:()=>matrix,scalar_mul:()=>scalar_mul,vector_add:()=>vector_add,vector_sub:()=>vector_sub});function tuple(D){var E=[];E.push("tuple");var F=D.length;for(let J=0;J<F;J++)E.push(D[J]);return E}function matrix(D){var E=[];E.push("matrix");var F=D.length,J=D[0].length;for(let _t=1;_t<F;_t++)if(D[_t].length!==J)throw Error("Matrix dimensions mismatch");E.push(tuple([F,J]));let $e=[];for(let _t=0;_t<F;_t++)$e.push(tuple(D[_t].map(function(lr){return lr.tree})));return E.push(tuple($e)),E}function vector_add(D,E){if(D=get_tree(D),E=get_tree(E),D.length!==E.length||D[0]!=="tuple"&&D[0]!=="vector"&&D[0]!=="altvector"||E[0]!=="tuple"&&E[0]!=="vector"&&E[0]!=="altvector")throw Error("Can\'t add. Those aren\'t vectors, or the dimensions don\'t match");var F=D[0]==="altvector"&&E[0]==="altvector"?["altvector"]:["vector"],J=D.length;for(let $e=1;$e<J;$e+=1)F.push(["+",D[$e],E[$e]]);return simplify(F)}function scalar_mul(D,E){if(E=get_tree(E),E[0]!=="tuple"&&E[0]!=="vector"&&E[0]!=="altvector")throw Error("Can\'t scalar multiply. Isn\'t a vector");var F=E[0]==="altvector"?["altvector"]:["vector"],J=E.length;for(let $e=1;$e<J;$e+=1)F.push(["*",E[$e],D]);return simplify(F)}function vector_sub(D,E){return vector_add(D,scalar_mul(-1,E))}function dot_prod(D,E){if(D=get_tree(D),E=get_tree(E),D.length!==E.length||D[0]!=="tuple"&&D[0]!=="vector"&&D[0]!=="altvector"||E[0]!=="tuple"&&E[0]!=="vector"&&E[0]!=="altvector")throw Error("Can\'t take dot product. Those aren\'t vectors, or the dimensions don\'t match");var F=0,J=0,$e=D.length;for(let _t=1;_t<$e;_t+=1)J=["*",D[_t],E[_t]],F=["+",F,J];return simplify(F)}function cross_prod(D,E){if(D=get_tree(D),E=get_tree(E),D[0]!=="tuple"&&D[0]!=="vector"&&D[0]!=="altvector"||E[0]!=="tuple"&&E[0]!=="vector"&&E[0]!=="altvector")throw Error("Can\'t take cross product. Those aren\'t vectors");if(D.length===3&&E.length===3)return simplify(["+",["*",D[1],E[2]],["-",["*",D[2],E[1]]]]);if(D.length===4&&E.length===4){var F=["+",["*",D[2],E[3]],["-",["*",D[3],E[2]]]],J=["+",["*",D[3],E[1]],["-",["*",D[1],E[3]]]],$e=["+",["*",D[1],E[2]],["-",["*",D[2],E[1]]]];return simplify([D[0]==="altvector"&&E[0]==="altvector"?"altvector":"vector",F,J,$e])}throw Error("Can\'t take cross product. The dimensions aren\'t both 2 or 3.")}var astToGuppy$1=class Ss{constructor(){this.operators={"+":function(E){return E.join("<e>+</e>")},"-":function(E){return"<e>-"+E.join("-")+"</e>"},"*":function(E){return E.join(\'<f type="*" group="operations" c="yes"><b p="latex">\\\\cdot</b><b p="text">*</b></f>\')},"/":function(E){return Ss.dfrac(E[0],E[1])},"^":function(E){return Ss.power(E[0],E[1])},sin:function(E){return Ss.trig("sin",E[0])},cos:function(E){return Ss.trig("cos",E[0])},tan:function(E){return Ss.trig("tan",E[0])},arcsin:function(E){return Ss.trig("arcsin",E[0])},arccos:function(E){return Ss.trig("arccos",E[0])},arctan:function(E){return Ss.trig("arctan",E[0])},arccsc:function(E){return Ss.trig("arccsc",E[0])},arcsec:function(E){return Ss.trig("arcsec",E[0])},arccot:function(E){return Ss.trig("arccot",E[0])},csc:function(E){return Ss.trig("csc",E[0])},sec:function(E){return Ss.trig("sec",E[0])},cot:function(E){return Ss.trig("cot",E[0])},log:function(E){return Ss.trig("log",E[0])},exp:function(E){return Ss.trig("exp",E[0])},ln:function(E){return Ss.trig("ln",E[0])},sqrt:function(E){return Ss.sqrt(E[0])},abs:function(E){return Ss.abs(E[0])}}}static dfrac(E,F){return\'<f type="fraction" group="functions"><b p="latex">\\\\dfrac{<r ref="1"/>}{<r ref="2"/>}</b><b p="small_latex">\\\\frac{<r ref="1"/>}{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)/(<r ref="2"/>)</b><c up="1" down="2" name="numerator"><e></e>\'+E+\'<e></e></c><c up="1" down="2" name="denominator"><e></e>\'+F+"<e></e></c></f>"}static trig(E,F){return\'<f type="\'+E+\'" group="functions"><b p="latex">\\\\\'+E+\'\\\\left(<r ref="1"/>\\\\right)</b><b p="text"> \'+E+\'(<r ref="1"/>)</b><c delete="1"><e></e>\'+F+"<e></e></c></f>"}static sqrt(E){return\'<f type="square_root" group="functions"><b p="latex">\\\\sqrt{<r ref="1"/>}</b><b p="text">sqrt(<r ref="1"/>)</b><c delete="1"><e></e>\'+E+"<e></e></c></f>"}static power(E,F){return\'<f type="exponential" group="functions"><b p="latex">{<r ref="1"/>}^{<r ref="2"/>}</b><b p="text">(<r ref="1"/>)^(<r ref="2"/>)</b><c up="2" bracket="yes" delete="1" name="base"><e></e>\'+E+\'<e></e></c><c down="1" delete="1" name="exponent" small="yes"><e></e>\'+F+"<e></e></c></f>"}static abs(E){return\'<f type="absolute_value" group="functions"><b p="latex">\\\\left|<r ref="1"/>\\\\right|</b><b p="text">abs(<r ref="1"/>)</b><c delete="1"><e></e>\'+E+"<e></e></c></f>"}static paren(E){return\'<f type="bracket" group="functions"><b p="latex">\\\\left(<r ref="1"/>\\\\right)</b><b p="text">(<r ref="1"/>)</b><c delete="1" is_bracket="yes"><e></e>\'+E+"<e></e></c></f>"}static isFunctionSymbol(E){return["sin","cos","tan","csc","sec","cot","arcsin","arccos","arctan","arccsc","arcsec","arccot","log","ln","exp","sqrt","abs","this.factorial"].indexOf(E)!==-1}static isGreekLetterSymbol(E){return"pi.theta.theta.Theta.alpha.nu.beta.xi.Xi.gamma.Gamma.delta.Delta.pi.Pi.epsilon.epsilon.rho.rho.zeta.sigma.Sigma.eta.tau.upsilon.Upsilon.iota.phi.phi.Phi.kappa.chi.lambda.Lambda.psi.Psi.omega.Omega".split(".").indexOf(E)!==-1}factorWithParenthesesIfNegated(E){var F=this.factor(E);return F.toString().match(/^<e>-/)?Ss.paren(F.toString()):F}factor(E){if(typeof E=="string")return Ss.isGreekLetterSymbol(E)?\'<f type="\'+E+\'" group="greek" c="yes"><b p="latex">\\\\\'+E+\'</b><b p="text"> $\'+E+"</b></f>":"<e>"+E+"</e>";if(typeof E=="number")return"<e>"+E+"</e>";if(!Array.isArray(E))return"<e></e>";var F=E[0],J=E.slice(1);return F==="apply"&&(F=E[1],J=E.slice(2)),F==="abs"?this.operators[F](J.map((function($e,_t){return this.expression($e)}).bind(this))):Ss.isFunctionSymbol(F)?F==="this.factorial"&&(J[0].toString().length===1||J[0].toString().match(/^[0-9]*$/))?this.operators[F](J):this.operators[F](J.map((function($e,_t){return this.factor($e)}).bind(this))):F==="^"||F==="~"?this.operators[F](J.map((function($e,_t){return this.factor($e)}).bind(this))):Ss.paren(this.expression(E))}term(E){if(!Array.isArray(E))return this.factor(E);var F=E[0],J=E.slice(1);return F==="*"?this.operators[F](J.map((function($e,_t){var lr=this.factorWithParenthesesIfNegated($e);return lr.toString().match(/^[0-9]/)&&_t>0?" * "+lr:lr}).bind(this))):F==="/"?this.operators[F](J.map((function($e,_t){return this.factor($e)}).bind(this))):this.factor(E)}expression(E){if(!Array.isArray(E))return this.term(E);var F=E[0],J=E.slice(1);return F==="+"||F==="-"?this.operators[F](J.map((function($e,_t){return this.factorWithParenthesesIfNegated($e)}).bind(this))):this.term(E)}convert(E){return("<m><e></e>"+this.expression(E)+"<e></e></m>").replace(/<\\/e><e>/g,"")}},glslOperators={"+":function(D){var E=D[0];return D.slice(1).forEach(function(F){E=E+"+"+F}),E},"-":function(D){var E="-"+D[0];return D.slice(1).forEach(function(F){E=E+"-"+F}),E},"~":function(D){var E="vec2(0.0,0.0)";return D.forEach(function(F){E=E+"-"+F}),E},"*":function(D){var E=D[0];return D.slice(1).forEach(function(F){E="cmul("+E+","+F+")"}),E},"/":function(D){var E=D[0];return D.slice(1).forEach(function(F){E="cdiv("+E+","+F+")"}),E},sin:function(D){return"csin("+D[0]+")"},cos:function(D){return"ccos("+D[0]+")"},tan:function(D){return"ctan("+D[0]+")"},sinh:function(D){return"csinh("+D[0]+")"},cosh:function(D){return"ccosh("+D[0]+")"},arcsin:function(D){return"carcsin("+D[0]+")"},arccos:function(D){return"carccos("+D[0]+")"},arctan:function(D){return"carctan("+D[0]+")"},arccsc:function(D){return"carcsin(cdiv(vec2(1.0,0),"+D[0]+"))"},arcsec:function(D){return"carccos(cdiv(vec2(1.0,0),"+D[0]+"))"},arccot:function(D){return"carctan(cdiv(vec2(1.0,0),"+D[0]+"))"},csc:function(D){return"ccsc("+D[0]+")"},sec:function(D){return"csec("+D[0]+")"},cot:function(D){return"ccot("+D[0]+")"},exp:function(D){return"cexp("+D[0]+")"},conj:function(D){return"conjugate("+D[0]+")"},sqrt:function(D){return"cpower("+D[0]+",vec2(0.5,0.0))"},log:function(D){return"clog("+D[0]+")"},ln:function(D){return"clog("+D[0]+")"},"^":function(D){return"cpower("+D[0]+","+D[1]+")"},abs:function(D){return"cabs("+D[0]+")"},apply:function(D){return"vec2(NaN,NaN)"}},astToGLSL$1=class{constructor(){}convert(D){if(typeof D=="boolean")throw Error("no support for boolean");if(typeof D=="string")return D==="e"?"vec2(2.71828182845905,0.0)":D==="pi"?"vec2(3.14159265358979,0.0)":D==="i"?"vec2(0.0,1.0)":String(D);if(typeof D=="number")return"vec2("+String(D)+",0.0)";if("real"in D&&"imaginary"in D)return D;if(!Array.isArray(D))throw Error("Invalid ast");var E=D[0],F=D.slice(1);if(E==="apply"){if(typeof F[0]!="string")throw Error("Non string functions not implemented for conversion to GLSL");var E=F[0],F=F.slice(1);return glslOperators[E](F.map((function(_t,lr){return this.convert(_t)}).bind(this)))}if(E in glslOperators)return glslOperators[E](F.map((function(J,$e){return this.convert(J)}).bind(this)));throw Error("Operator "+E+" not implemented for conversion to mathjs")}},printing_exports=__exportAll({tex:()=>tex,toGLSL:()=>toGLSL,toLatex:()=>toLatex,toString:()=>toString,toXML:()=>toXML}),astToGuppy=new astToGuppy$1,astToGLSL=new astToGLSL$1,tex=function(D,E){return new astToLatex$1(E).convert(D.tree)},toLatex=tex,toString=function(D,E){return new astToText$2(E).convert(D.tree)},toGLSL=function(D){return astToGLSL.convert(D.tree)},toXML=function(D){return astToGuppy.convert(D.tree)},integration_exports=__exportAll({integrateNumerically:()=>integrateNumerically}),integrateNumerically=function(D,E,F,J){for(var $e=100,_t=0,lr={},mr=0;mr<$e;mr++)lr[E]=F+(J-F)*(mr+.5)/$e,_t+=D.evaluate(lr);return _t*(J-F)/$e};init_index_all(),init_index_all();function expression_to_polynomial(D){var E=get_tree(D);if(typeof E=="string")return E==="pi"&&mathjs_default.define_pi||E==="i"&&mathjs_default.define_i||E==="e"&&mathjs_default.define_e?E:["polynomial",E,[[1,1]]];if(typeof E=="number")return E;var F=evaluate_to_constant(E,{remove_units_first:!1});if(Number.isFinite(F))return simplify(E);if(!Array.isArray(E)||!operators$3(E).every(Or=>["+","-","*","^","/","_","prime"].includes(Or)))return!1;var J=E[0],$e=E.slice(1);if(J==="+"){let Or=$e.map(expression_to_polynomial);return Or.every(Pr=>Pr!==!1)?Or.reduce((Pr,dn)=>polynomial_add(Pr,dn)):!1}else if(J==="-"){let Or=expression_to_polynomial($e[0]);return Or?polynomial_neg(Or):!1}else if(J==="*"){let Or=$e.map(expression_to_polynomial);return Or.every(Pr=>Pr!==!1)?Or.reduce((Pr,dn)=>polynomial_mul(Pr,dn)):!1}else if(J==="^"){let Or=$e[0],Pr=expression_to_polynomial(Or);if(Pr===!1)return!1;let dn=simplify($e[1]);if(typeof dn!="number"||dn<0||!Number.isInteger(dn)){let gi=evaluate_to_constant(dn,{remove_units_first:!1});if(Number.isFinite(gi)){let qi=mathjs_default.fraction(gi),zi={n:mathjs_default.number(qi.n),d:mathjs_default.number(qi.d),s:mathjs_default.number(qi.s)};if(zi.d<=100){Or=zi.s<0?["^",Or,["/",-1,zi.d]]:["^",Or,["/",1,zi.d]];var _t=["polynomial",simplify(Or),[]];return _t[2].push([zi.n,1]),_t}}return["polynomial",E,[[1,1]]]}return dn===0?1:dn===1?Pr:polynomial_pow(Pr,dn)}else if(J==="/"){var lr=$e[1],mr=evaluate_to_constant(lr,{remove_units_first:!1});return Number.isFinite(mr)?polynomial_mul(expression_to_polynomial($e[0]),["/",1,mr]):["polynomial",E,[[1,1]]]}else return["polynomial",E,[[1,1]]]}function polynomials_in_same_leading_variable(D,E){return D[1]!==E[1]&&(compare_function(D[1],E[1])<0?E=["polynomial",D[1],[[0,E]]]:D=["polynomial",E[1],[[0,D]]]),[D,E]}function polynomial_add(D,E){if(D[0]!=="polynomial"){if(E[0]!=="polynomial")return simplify(["+",D,E]);D=["polynomial",E[1],[[0,D]]]}else if(E[0]!=="polynomial")E=["polynomial",D[1],[[0,E]]];else{let dn=polynomials_in_same_leading_variable(D,E);D=dn[0],E=dn[1]}let F=["polynomial",D[1],[]],J=D[2],$e=E[2],_t=F[2],lr=J.length,mr=$e.length,Or=0,Pr=0;for(;Or<lr||Pr<mr;)if(Or===lr)$e[Pr][1]&&_t.push($e[Pr]),Pr+=1;else if(Pr===mr)J[Or][1]&&_t.push(J[Or]),Or+=1;else if(J[Or][0]===$e[Pr][0]){let dn=polynomial_add(J[Or][1],$e[Pr][1]);dn&&_t.push([J[Or][0],dn]),Or+=1,Pr+=1}else J[Or][0]<$e[Pr][0]?(J[Or][1]&&_t.push(J[Or]),Or+=1):($e[Pr][1]&&_t.push($e[Pr]),Pr+=1);return _t.length===0?0:_t.length===1&&_t[0][0]===0?_t[0][1]:F}function polynomial_neg(D){if(D[0]!=="polynomial")return simplify(["-",D]);let E=["polynomial",D[1],[]],F=D[2],J=E[2],$e=F.length;for(var _t=0;_t<$e;_t+=1)J.push([F[_t][0],polynomial_neg(F[_t][1])]);return E}function polynomial_sub(D,E){return polynomial_add(D,polynomial_neg(E))}function polynomial_mul(D,E){if(D[0]!=="polynomial"){if(E[0]!=="polynomial")return simplify(["*",D,E]);if(D){let dn=["polynomial",E[1],[]],gi=E[2],qi=dn[2];for(let zi of gi)zi[1]&&qi.push([zi[0],polynomial_mul(D,zi[1])]);return dn}}else if(E&&E[0]!=="polynomial"){let dn=["polynomial",D[1],[]],gi=D[2],qi=dn[2];for(let zi of gi)zi[1]&&qi.push([zi[0],polynomial_mul(zi[1],E)]);return dn}let F=polynomials_in_same_leading_variable(D,E);D=F[0],E=F[1];let J=D[2],$e=E[2],_t=["polynomial",D[1],[]],lr=_t[2],mr=J.length,Or=$e.length,Pr=[];for(let dn of J)for(let gi of $e){let qi=!1,zi=dn[0]+gi[0];for(let Hi of Pr)if(zi===Hi){qi=!0;break}qi||Pr.push(zi)}Pr.sort(function(dn,gi){return dn-gi});for(let dn of Pr){let gi=0,qi=0;for(;qi<mr&&J[qi][0]<=dn;){let zi=0;for(;zi<Or&&$e[zi][0]<=dn;){if(J[qi][0]+$e[zi][0]===dn){gi=polynomial_add(gi,polynomial_mul(J[qi][1],$e[zi][1]));break}zi+=1}qi+=1}gi&&lr.push([dn,gi])}return _t}function polynomial_pow(D,E){if(isNaN(E)||E<0||!Number.isInteger(E))return;let F=1;for(;E>0;)E&1&&(F=polynomial_mul(F,D)),D=polynomial_mul(D,D),E>>=1;return F}function polynomial_to_expression(D){if(!Array.isArray(D)||D[0]!=="polynomial")return D;let E=D[1],F=D[2],J=[],$e=F.length;for(var _t=0;_t<$e;_t+=1)F[_t][1]&&(F[_t][0]===0?J.push(polynomial_to_expression(F[_t][1])):F[_t][0]===1?J.push(["*",polynomial_to_expression(F[_t][1]),E]):J.push(["*",polynomial_to_expression(F[_t][1]),["^",E,F[_t][0]]]));return J.length===0?0:(J.length===1?J=J[0]:J.unshift("+"),simplify(J))}function initial_term(D){if(!Array.isArray(D)||D[0]!=="polynomial")return D;let E=[];for(;Array.isArray(D)&&D[0]==="polynomial";){let F=D[1],J=D[2],$e=J[J.length-1][0];D=J[J.length-1][1],E.push([F,$e])}return["monomial",D,E]}function mono_less_than(D,E){if(!Array.isArray(E)||E[0]!=="monomial")return!1;if(!Array.isArray(D)||D[0]!=="monomial")return!0;let F=D[2],J=E[2],$e=F.length,_t=J.length;for(var lr=$e<_t?$e:_t,mr=0;mr<lr;mr++){if(F[mr][0]!==J[mr][0])return!(compare_function(F[mr][0],J[mr][0])<0);if(F[mr][1]<J[mr][1])return!0;if(F[mr][1]>J[mr][1])return!1}return!($e===_t||lr===_t)}function mono_gcd(D,E){if(!Array.isArray(D)||!Array.isArray(E)||D[0]!=="monomial"||E[0]!=="monomial")return 1;let F=D[2],J=E[2],$e=[],_t=F.length,lr=J.length,mr=0,Or=0;for(;mr<_t&&Or<lr;)F[mr][0]===J[Or][0]?(F[mr][1]<J[Or][1]?$e.push(F[mr]):$e.push(J[Or]),mr+=1,Or+=1):compare_function(F[mr][0],J[Or][0])<0?mr+=1:compare_function(J[Or][0],F[mr][0])<0&&(Or+=1);return $e.length===0?1:["monomial",1,$e]}function mono_div(D,E){if(!Array.isArray(E)||E[0]!=="monomial")return E===1?D:!Array.isArray(D)||D[0]!=="monomial"?evaluate_numbers(["/",D,E]):[D[0],evaluate_numbers(["/",D[1],E]),D[2]];if(!Array.isArray(D)||D[0]!=="monomial")return;let F=D[2],J=E[2],$e=[],_t=F.length,lr=J.length,mr=0,Or=0;for(;mr<_t&&Or<lr;)if(F[mr][0]===J[Or][0]){if(F[mr][1]<J[Or][1])return;{let Pr=F[mr][1]-J[Or][1];Pr!==0&&$e.push([F[mr][0],Pr])}mr+=1,Or+=1}else if(compare_function(F[mr][0],J[Or][0])<0)$e.push(F[mr]),mr+=1;else if(compare_function(J[Or][0],F[mr][0])<0)return;if(!(Or<lr)){for(;mr<_t;)$e.push(F[mr]),mr+=1;return $e.length===0?E[1]===1?D[1]:evaluate_numbers(["/",D[1],E[1]]):E[1]===1?["monomial",D[1],$e]:["monomial",evaluate_numbers(["/",D[1],E[1]]),$e]}}function mono_is_div(D,E){if(E===0)return!1;if(!Array.isArray(E)||E[0]!=="monomial")return!0;if(!Array.isArray(D)||D[0]!=="monomial")return!1;let F=D[2],J=E[2],$e=[],_t=F.length,lr=J.length,mr=0,Or=0;for(;mr<_t&&Or<lr;)if(F[mr][0]===J[Or][0]){if(F[mr][1]<J[Or][1])return!1;{let Pr=F[mr][1]-J[Or][1];Pr!==0&&$e.push([F[mr][0],Pr])}mr+=1,Or+=1}else if(compare_function(F[mr][0],J[Or][0])<0)$e.push(F[mr]),mr+=1;else if(compare_function(J[Or][0],F[mr][0])<0)return!1;return!(Or<lr)}function mono_to_poly(D){if(!Array.isArray(D)||D[0]!=="monomial")return D;let E=D[2].length-1,F=D[1];for(;E>=0;){var J=[];J.push([D[2][E][1],F]),F=["polynomial",D[2][E][0],J],--E}return F}function max_div_init(D,E){if(D===0)return 0;let F=D,J=[];for(;Array.isArray(F)&&F[0]==="polynomial";){let mr=F[1],Or=F[2],Pr=Or[Or.length-1][0];F=Or[Or.length-1][1],J.push([mr,Pr])}let $e=["monomial",F,J],_t=E.length;for(var lr=0;lr<_t;lr+=1)if(mono_is_div($e,E[lr]))return[$e,lr];return max_div_init(polynomial_sub(D,mono_to_poly($e)),E)}function poly_div(D,E){let F=[],J=[],$e=[],_t=[],lr=D;for(var mr of E)F.push(initial_term(mr));let Or=max_div_init(lr,F);for(;Or!==0;)$e=Or[1],_t=mono_div(Or[0],F[$e]),J.push([$e,_t]),lr=polynomial_sub(lr,polynomial_mul(mono_to_poly(_t),E[$e])),Or=max_div_init(lr,F);return[J,lr]}function prereduce(D){let E=D.length,F=[];for(var J=0;J<E;J++){if(D[J]!==0&&(!Array.isArray(D[J])||D[J][0]!=="polynomial"))return[1];D[J]!==0&&F.push(D[J])}return F.length===0?[0]:F}function reduce_ith(D,E){let F=[],J=[],$e=[],_t=E[D],lr=E.length;for(var mr=0;mr<lr;mr+=1)mr===D?F.push(0):F.push(initial_term(E[mr]));let Or=max_div_init(_t,F);for(;Or!==0;)J=Or[1],$e=mono_div(Or[0],F[J]),_t=polynomial_sub(_t,polynomial_mul(mono_to_poly($e),E[J])),Or=max_div_init(_t,F);return _t}function reduce(D){let E=0,F=[],J=prereduce(D),$e=J.length;if($e===1)return J;let _t=!0;for(;_t;)for(_t=!1,J=prereduce(J),$e=J.length,E=0;E<$e;)F=reduce_ith(E,J),_.isEqual(F,J[E])||(J[E]=F,_t=!0),E+=1;E=0;let lr=[],mr=0;for(;E<$e;)lr=initial_term(J[E]),!Array.isArray(lr)||lr[0]!=="monomial"?J[E]=1:(mr=lr[1],mr!==1&&(J[E]=polynomial_mul(J[E],["/",1,mr]))),E+=1;return J}function hij(D,E,F){let J=initial_term(F[D]),$e=initial_term(F[E]),_t=mono_gcd(J,$e),lr=mono_to_poly(mono_div(J,_t));return poly_div(polynomial_sub(polynomial_mul(mono_to_poly(mono_div($e,_t)),F[D]),polynomial_mul(lr,F[E])),F)[1]}function build_hij_table(D,E){let F=E.length,J=0,$e=1,_t=[];for(;$e<F;){for(;J<$e;)D[[J,$e]]=hij(J,$e,E),D[[J,$e]]!==0&&_t.push(D[[J,$e]]),J+=1;J=0,$e+=1}return _t.length>0?choice_lowest_degree(_t):0}function update_hij_table(D,E,F){let J=E.length;E.push(F);let $e=0,_t=1,lr=[];for(;_t<J;){for(;$e<_t;)D[[$e,_t]]!==0&&(D[[$e,_t]]=hij($e,_t,E),D[[$e,_t]]!==0&&lr.push(D[[$e,_t]])),$e+=1;$e=0,_t+=1}for(;$e<J;)D[[$e,J]]=hij($e,J,E),D[[$e,J]]!==0&&lr.push(D[[$e,J]]),$e+=1;return lr.length>0?choice_lowest_degree(lr):0}function choice_lowest_degree(D){let E=[],F=D.length;for($e=0;$e<F;$e+=1)E.push(initial_term(D[$e]));let J=0;for(var $e=1;$e<F;$e+=1){if(E[$e]===1)return 1;mono_less_than(E[$e],E[J])&&(J=$e)}return D[J]}function reduced_grobner(D){let E=reduce(D),F={},J=build_hij_table(F,E);for(;J!==0;)J=update_hij_table(F,E,J);return E=reduce(E),E}function poly_lcm(D,E){let F=reduced_grobner([polynomial_mul(["polynomial","_t",[[1,1]]],D),polynomial_mul(["polynomial","_t",[[0,1],[1,-1]]],E)]),J=F.length;for(var $e=0;$e<J;$e+=1){if(!Array.isArray(F[$e])||F[$e][0]!=="polynomial")return 1;if(F[$e][1]!=="_t")return F[$e]}}function poly_gcd(D,E){let F=poly_lcm(D,E),J=poly_div(polynomial_mul(D,E),[F]),$e=0,_t=J[0].length;for(var lr=0;lr<_t;lr+=1)$e=polynomial_add($e,mono_to_poly(J[0][lr][1]));let mr=initial_term($e);if(!Array.isArray(mr)||mr[0]!=="monomial")$e=1;else{let Or=mr[1];Or!==1&&($e=polynomial_mul($e,["/",1,Or]))}return $e}function poly_by_divisor(D,E){let F=poly_div(D,[E]),J=0,$e=F[0].length;for(var _t=0;_t<$e;_t+=1)J=polynomial_add(J,mono_to_poly(F[0][_t][1]));return J}function reduce_rational_expression(D,E){let F=stringify_vars(D),J=stringify_vars(E);D=F[0],E=J[0];let $e=poly_gcd(D,E),_t=initial_term(E)[1],lr=polynomial_mul($e,_t),mr=poly_by_divisor(D,lr),Or=poly_by_divisor(E,lr);return[destringify_vars(destringify_vars(mr,F[1]),J[1]),destringify_vars(destringify_vars(Or,F[1]),J[1])]}function stringify_vars(D){if(!Array.isArray(D)||D[0]!=="polynomial")return[D,{}];let E={},F="z"+JSON.stringify(D[1]);E[F]=D[1],D[1]=F;let J=D[2],$e=[];for(let _t of J){$e=stringify_vars(_t[1]),_t[1]=$e[0];for(let lr in $e[1])E[lr]=$e[1][lr]}return[D,E]}function destringify_vars(D,E){if(!Array.isArray(D)||D[0]!=="polynomial")return D;E[D[1]]&&(D[1]=E[D[1]]);let F=D[2];for(let J of F)J[1]=destringify_vars(J[1],E);return D}var rational_exports=__exportAll({common_denominator:()=>common_denominator,reduce_rational:()=>reduce_rational}),textToAst$1=new textToAst$4;function common_denominator(D,E){D=simplify(D,E);var F=[];return F.push([textToAst$1.convert("a/c+b/c"),textToAst$1.convert("(a+b)/c"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("a/c-b/c"),textToAst$1.convert("(a-b)/c"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("a+b/c"),textToAst$1.convert("(ac+b)/c"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("a-b/c"),textToAst$1.convert("(ac-b)/c"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("a/d+b/c"),textToAst$1.convert("(ac+bd)/(cd)"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("a/d-b/c"),textToAst$1.convert("(ac-bd)/(cd)"),{evaluate_numbers:!0,allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("x*(y/z)"),textToAst$1.convert("(x*y)/z"),{allow_extended_match:!0,allow_permutations:!0,max_group:1}]),F.push([textToAst$1.convert("(x/y)/z"),textToAst$1.convert("x/(y*z)"),{allow_extended_match:!0,allow_permutations:!0}]),F.push([textToAst$1.convert("x/(y/z)"),textToAst$1.convert("xz/y"),{allow_extended_match:!0,allow_permutations:!0}]),D=applyAllTransformations(D,F,40),D=expand(D,!0),D}function as_num_denom(D){var E=get_tree(D);return E=common_denominator(E),E[0]==="/"?[E[1],E[2]]:[E,1]}function reduce_rational(D){var E=get_tree(D),F=as_num_denom(E);if(F[1]===1)return E;var J=reduce_rational_expression(expression_to_polynomial(F[0]),expression_to_polynomial(F[1])),$e=polynomial_to_expression(J[0]),_t=polynomial_to_expression(J[1]);return _t===1?$e:["/",$e,_t]}var round_exports=__exportAll({round_numbers_to_decimals:()=>round_numbers_to_decimals,round_numbers_to_precision:()=>round_numbers_to_precision,round_numbers_to_precision_plus_decimals:()=>round_numbers_to_precision_plus_decimals});function toFixed(D,E){return mathjs_default.format(D,{notation:"fixed",precision:E})}function round_numbers_to_precision(D,E=14){var F=get_tree(D);if(E<1)throw Error("For round_numbers_to_precision, digits must be positive");if(!Number.isFinite(E))throw Error("For round_numbers_to_precision, digits must be a number");return E>15?F:(E=Math.round(E),round_numbers_to_precision_sub(F,E))}var round_numbers_to_precision_sub=function(D,E=14){if(typeof D=="number"&&Number.isFinite(D)&&D!==0){let F=E-mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(D)))-1;return parseFloat(F<0?toFixed(D,F)+"0".repeat(mathjs_default.abs(F)):toFixed(D,F))}return Array.isArray(D)?[D[0],...D.slice(1).map(F=>round_numbers_to_precision_sub(F,E))]:D};function round_numbers_to_decimals(D,E=14){var F=get_tree(D);if(!Number.isFinite(E))throw Error("For round_numbers_to_decimals, ndecimals must be a number");return E=Math.round(E),E=Math.max(-330,Math.min(330,E)),round_numbers_to_decimals_sub(F,E)}var round_numbers_to_decimals_sub=function(D,E=0){return typeof D=="number"?parseFloat(E<0?toFixed(D,E)+"0".repeat(mathjs_default.abs(E)):toFixed(D,E)):Array.isArray(D)?[D[0],...D.slice(1).map(F=>round_numbers_to_decimals_sub(F,E))]:D};function round_numbers_to_precision_plus_decimals(D,E=4,F=2){var J=get_tree(D);let $e=!0,_t=!0;if(E>=1){if(E=Math.round(E),E>15)return J}else $e=!1;return Number.isFinite(F)?(F=Math.round(F),F=Math.max(-330,Math.min(330,F))):_t=!1,$e?_t?round_numbers_to_precision_plus_decimals_sub(J,E,F):round_numbers_to_precision_sub(J,E):_t?round_numbers_to_decimals_sub(J,F):J}var round_numbers_to_precision_plus_decimals_sub=function(D,E=4,F=2){if(typeof D=="number"&&Number.isFinite(D)&&D!==0){let J=mathjs_default.floor(mathjs_default.log10(mathjs_default.abs(D))),$e=Math.max(E-J-1,F);return parseFloat($e<0?toFixed(D,$e)+"0".repeat(mathjs_default.abs($e)):toFixed(D,$e))}return Array.isArray(D)?[D[0],...D.slice(1).map(J=>round_numbers_to_precision_plus_decimals_sub(J,E,F))]:D},match_exports=__exportAll({match:()=>match}),match=function(D,E,F){return match$1(get_tree(D),get_tree(E),F)},expression_to_tree$1=[simplify_exports,differentiation_exports,normalization_exports,arithmetic_exports,transformation_exports,solve_exports,sets_exports,matrix_exports,rational_exports,round_exports],expression_to_other=[variables_exports,printing_exports,equality_exports,integration_exports,evaluation_exports,analytic_exports,sign_error_exports,match_exports],standard_exports=__exportAll({abs:()=>abs,acos:()=>acos,acosh:()=>acosh,acot:()=>acot,acoth:()=>acoth,acsc:()=>acsc,acsch:()=>acsch,asec:()=>asec,asech:()=>asech,asin:()=>asin,asinh:()=>asinh,atan:()=>atan,atan2:()=>atan2,atanh:()=>atanh,conj:()=>conj,cos:()=>cos,cosh:()=>cosh,cot:()=>cot,coth:()=>coth,csc:()=>csc,csch:()=>csch,erf:()=>erf,exp:()=>exp,factorial:()=>factorial,gamma:()=>gamma,im:()=>im,log:()=>log,log10:()=>log10,re:()=>re,sec:()=>sec,sech:()=>sech,sign:()=>sign,sin:()=>sin,sinh:()=>sinh,sqrt:()=>sqrt,tan:()=>tan,tanh:()=>tanh});function abs(D){return["apply","abs",get_tree(D)]}function exp(D){return["apply","exp",get_tree(D)]}function log(D){return["apply","log",get_tree(D)]}function log10(D){return["apply","log10",get_tree(D)]}function sign(D){return["apply","sign",get_tree(D)]}function sqrt(D){return["apply","sqrt",get_tree(D)]}function conj(D){return["apply","conj",get_tree(D)]}function im(D){return["apply","im",get_tree(D)]}function re(D){return["apply","re",get_tree(D)]}function factorial(D){return["apply","factorial",get_tree(D)]}function gamma(D){return["apply","gamma",get_tree(D)]}function erf(D){return["apply","erf",get_tree(D)]}function acos(D){return["apply","acos",get_tree(D)]}function acosh(D){return["apply","acosh",get_tree(D)]}function acot(D){return["apply","acot",get_tree(D)]}function acoth(D){return["apply","acoth",get_tree(D)]}function acsc(D){return["apply","acsc",get_tree(D)]}function acsch(D){return["apply","acsch",get_tree(D)]}function asec(D){return["apply","asec",get_tree(D)]}function asech(D){return["apply","asech",get_tree(D)]}function asin(D){return["apply","asin",get_tree(D)]}function asinh(D){return["apply","asinh",get_tree(D)]}function atan(D){return["apply","atan",get_tree(D)]}function atanh(D){return["apply","atanh",get_tree(D)]}function cos(D){return["apply","cos",get_tree(D)]}function cosh(D){return["apply","cosh",get_tree(D)]}function cot(D){return["apply","cot",get_tree(D)]}function coth(D){return["apply","coth",get_tree(D)]}function csc(D){return["apply","csc",get_tree(D)]}function csch(D){return["apply","csch",get_tree(D)]}function sec(D){return["apply","sec",get_tree(D)]}function sech(D){return["apply","sech",get_tree(D)]}function sin(D){return["apply","sin",get_tree(D)]}function sinh(D){return["apply","sinh",get_tree(D)]}function tan(D){return["apply","tan",get_tree(D)]}function tanh(D){return["apply","tanh",get_tree(D)]}function atan2(D,E){return["apply","atan2",["tuple",get_tree(D),get_tree(E)]]}var expression_to_tree=[standard_exports],whitespace_rule="\\\\s|\\\\\\\\,|\\\\\\\\!|\\\\\\\\ |\\\\\\\\>|\\\\\\\\;|\\\\\\\\:|\\\\\\\\quad\\\\b|\\\\\\\\qquad\\\\b",number_rules_sci=[["[0-9]+(\\\\.[0-9]*)?(E[+\\\\-]?[0-9]+\\\\s*($|(?=\\\\,|&|\\\\||\\\\\\\\\\\\||\\\\)|\\\\}|\\\\\\\\}|\\\\]|\\\\\\\\\\\\\\\\|\\\\\\\\end)))?","NUMBER"],["\\\\.[0-9]+(E[+\\\\-]?[0-9]+\\\\s*($|(?=\\\\,|&|\\\\||\\\\\\\\\\\\||\\\\)|\\\\}|\\\\\\\\}|\\\\]|\\\\\\\\\\\\\\\\|\\\\\\\\end)))?","NUMBER"]],number_rules_non_sci=[["[0-9]+(\\\\.[0-9]*)?","NUMBER"],["\\\\.[0-9]+","NUMBER"]],base_latex_rules=[["\\\\*","*"],["\\\\/","/"],["-","-"],["\\\\+","+"],["\\\\\\\\pm(?![a-zA-Z])","PM"],["\\\\^","^"],["\\\\(","("],["\\\\\\\\left\\\\s*\\\\(","("],["\\\\\\\\bigl\\\\s*\\\\(","("],["\\\\\\\\Bigl\\\\s*\\\\(","("],["\\\\\\\\biggl\\\\s*\\\\(","("],["\\\\\\\\Biggl\\\\s*\\\\(","("],["\\\\)",")"],["\\\\\\\\right\\\\s*\\\\)",")"],["\\\\\\\\bigr\\\\s*\\\\)",")"],["\\\\\\\\Bigr\\\\s*\\\\)",")"],["\\\\\\\\biggr\\\\s*\\\\)",")"],["\\\\\\\\Biggr\\\\s*\\\\)",")"],["\\\\[","["],["\\\\\\\\left\\\\s*\\\\[","["],["\\\\\\\\bigl\\\\s*\\\\[","["],["\\\\\\\\Bigl\\\\s*\\\\[","["],["\\\\\\\\biggl\\\\s*\\\\[","["],["\\\\\\\\Biggl\\\\s*\\\\[","["],["\\\\]","]"],["\\\\\\\\right\\\\s*\\\\]","]"],["\\\\\\\\bigr\\\\s*\\\\]","]"],["\\\\\\\\Bigr\\\\s*\\\\]","]"],["\\\\\\\\biggr\\\\s*\\\\]","]"],["\\\\\\\\Biggr\\\\s*\\\\]","]"],["\\\\|","|"],["\\\\\\\\left\\\\s*\\\\|","|L"],["\\\\\\\\bigl\\\\s*\\\\|","|L"],["\\\\\\\\Bigl\\\\s*\\\\|","|L"],["\\\\\\\\biggl\\\\s*\\\\|","|L"],["\\\\\\\\Biggl\\\\s*\\\\|","|L"],["\\\\\\\\right\\\\s*\\\\|","|"],["\\\\\\\\bigr\\\\s*\\\\|","|"],["\\\\\\\\Bigr\\\\s*\\\\|","|"],["\\\\\\\\biggr\\\\s*\\\\|","|"],["\\\\\\\\Biggr\\\\s*\\\\|","|"],["\\\\\\\\big\\\\s*\\\\|","|"],["\\\\\\\\Big\\\\s*\\\\|","|"],["\\\\\\\\bigg\\\\s*\\\\|","|"],["\\\\\\\\Bigg\\\\s*\\\\|","|"],["{","{"],["}","}"],["\\\\\\\\{","LBRACE"],["\\\\\\\\left\\\\s*\\\\\\\\{","LBRACE"],["\\\\\\\\bigl\\\\s*\\\\\\\\{","LBRACE"],["\\\\\\\\Bigl\\\\s*\\\\\\\\{","LBRACE"],["\\\\\\\\biggl\\\\s*\\\\\\\\{","LBRACE"],["\\\\\\\\Biggl\\\\s*\\\\\\\\{","LBRACE"],["\\\\\\\\}","RBRACE"],["\\\\\\\\right\\\\s*\\\\\\\\}","RBRACE"],["\\\\\\\\bigr\\\\s*\\\\\\\\}","RBRACE"],["\\\\\\\\Bigr\\\\s*\\\\\\\\}","RBRACE"],["\\\\\\\\biggr\\\\s*\\\\\\\\}","RBRACE"],["\\\\\\\\Biggr\\\\s*\\\\\\\\}","RBRACE"],["\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\left\\\\s*\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\bigl\\\\s*\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\Bigl\\\\s*\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\biggl\\\\s*\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\Biggl\\\\s*\\\\\\\\lfloor(?![a-zA-Z])","LFLOOR"],["\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\right\\\\s*\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\bigr\\\\s*\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\Bigr\\\\s*\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\biggr\\\\s*\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\Biggr\\\\s*\\\\\\\\rfloor(?![a-zA-Z])","RFLOOR"],["\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\left\\\\s*\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\bigl\\\\s*\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\Bigl\\\\s*\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\biggl\\\\s*\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\Biggl\\\\s*\\\\\\\\lceil(?![a-zA-Z])","LCEIL"],["\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\right\\\\s*\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\bigr\\\\s*\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\Bigr\\\\s*\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\biggr\\\\s*\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\Biggr\\\\s*\\\\\\\\rceil(?![a-zA-Z])","RCEIL"],["\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\left\\\\s*\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\bigl\\\\s*\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\Bigl\\\\s*\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\biggl\\\\s*\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\Biggl\\\\s*\\\\\\\\langle(?![a-zA-Z])","LANGLE"],["\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\right\\\\s*\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\bigr\\\\s*\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\Bigr\\\\s*\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\biggr\\\\s*\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\Biggr\\\\s*\\\\\\\\rangle(?![a-zA-Z])","RANGLE"],["\\\\\\\\cdot(?![a-zA-Z])","*"],["\\\\\\\\div(?![a-zA-Z])","/"],["\\\\\\\\times(?![a-zA-Z])","*"],[",",","],[":",":"],["\\\\\\\\mid(?![a-zA-Z])","MID"],["\\\\\\\\varnothing(?![a-zA-Z])","LATEXCOMMAND","\\\\emptyset"],["\\\\\\\\vartheta(?![a-zA-Z])","LATEXCOMMAND","\\\\theta"],["\\\\\\\\varepsilon(?![a-zA-Z])","LATEXCOMMAND","\\\\epsilon"],["\\\\\\\\varrho(?![a-zA-Z])","LATEXCOMMAND","\\\\rho"],["\\\\\\\\varphi(?![a-zA-Z])","LATEXCOMMAND","\\\\phi"],["\\\\\\\\infty(?![a-zA-Z])","INFINITY"],["\\\\\\\\asin(?![a-zA-Z])","LATEXCOMMAND","\\\\arcsin"],["\\\\\\\\acos(?![a-zA-Z])","LATEXCOMMAND","\\\\arccos"],["\\\\\\\\atan(?![a-zA-Z])","LATEXCOMMAND","\\\\arctan"],["\\\\\\\\sqrt(?![a-zA-Z])","SQRT"],["\\\\\\\\land(?![a-zA-Z])","AND"],["\\\\\\\\wedge(?![a-zA-Z])","AND"],["\\\\\\\\lor(?![a-zA-Z])","OR"],["\\\\\\\\vee(?![a-zA-Z])","OR"],["\\\\\\\\lnot(?![a-zA-Z])","NOT"],["\\\\\\\\neg(?![a-zA-Z])","NOT"],["=","="],["\\\\\\\\neq(?![a-zA-Z])","NE"],["\\\\\\\\ne(?![a-zA-Z])","NE"],["\\\\\\\\not\\\\s*=","NE"],["\\\\\\\\leq(?![a-zA-Z])","LE"],["\\\\\\\\le(?![a-zA-Z])","LE"],["\\\\\\\\geq(?![a-zA-Z])","GE"],["\\\\\\\\ge(?![a-zA-Z])","GE"],["<","<"],["\\\\\\\\lt(?![a-zA-Z])","<"],[">",">"],["\\\\\\\\gt(?![a-zA-Z])",">"],["\\\\\\\\forall(?![a-zA-Z])","FORALL"],["\\\\\\\\exists(?![a-zA-Z])","EXISTS"],["\\\\\\\\in(?![a-zA-Z])","IN"],["\\\\\\\\notin(?![a-zA-Z])","NOTIN"],["\\\\\\\\not\\\\s*\\\\\\\\in(?![a-zA-Z])","NOTIN"],["\\\\\\\\ni(?![a-zA-Z])","NI"],["\\\\\\\\not\\\\s*\\\\\\\\ni(?![a-zA-Z])","NOTNI"],["\\\\\\\\subset(?![a-zA-Z])","SUBSET"],["\\\\\\\\subseteq(?![a-zA-Z])","SUBSETEQ"],["\\\\\\\\not\\\\s*\\\\\\\\subset(?![a-zA-Z])","NOTSUBSET"],["\\\\\\\\not\\\\s*\\\\\\\\subseteq(?![a-zA-Z])","NOTSUBSETEQ"],["\\\\\\\\supset(?![a-zA-Z])","SUPERSET"],["\\\\\\\\supseteq(?![a-zA-Z])","SUPERSETEQ"],["\\\\\\\\not\\\\s*\\\\\\\\supset(?![a-zA-Z])","NOTSUPERSET"],["\\\\\\\\not\\\\s*\\\\\\\\supseteq(?![a-zA-Z])","NOTSUPERSETEQ"],["\\\\\\\\cup(?![a-zA-Z])","UNION"],["\\\\\\\\cap(?![a-zA-Z])","INTERSECT"],["\\\\\\\\to(?![a-zA-Z])","RIGHTARROW"],["\\\\\\\\rightarrow(?![a-zA-Z])","RIGHTARROW"],["\\\\\\\\longrightarrow(?![a-zA-Z])","RIGHTARROW"],["\\\\\\\\gets(?![a-zA-Z])","LEFTARROW"],["\\\\\\\\leftarrow(?![a-zA-Z])","LEFTARROW"],["\\\\\\\\longleftarrow(?![a-zA-Z])","LEFTARROW"],["\\\\\\\\leftrightarrow(?![a-zA-Z])","LEFTRIGHTARROW"],["\\\\\\\\longleftrightarrow(?![a-zA-Z])","LEFTRIGHTARROW"],["\\\\\\\\implies(?![a-zA-Z])","IMPLIES"],["\\\\\\\\Longrightarrow(?![a-zA-Z])","IMPLIES"],["\\\\\\\\Rightarrow(?![a-zA-Z])","IMPLIES"],["\\\\\\\\impliedby(?![a-zA-Z])","IMPLIEDBY"],["\\\\\\\\Longleftarrow(?![a-zA-Z])","IMPLIEDBY"],["\\\\\\\\Leftarrow(?![a-zA-Z])","IMPLIEDBY"],["\\\\\\\\iff(?![a-zA-Z])","IFF"],["\\\\\\\\Longleftrightarrow(?![a-zA-Z])","IFF"],["\\\\\\\\Leftrightarrow(?![a-zA-Z])","IFF"],["\\\\\\\\perp(?![a-zA-Z])","PERP"],["\\\\\\\\bot(?![a-zA-Z])","PERP"],["\\\\\\\\parallel(?![a-zA-Z])","PARALLEL"],["\\\\\\\\\\\\|","PARALLEL"],["\\\\\\\\angle(?![a-zA-Z])","ANGLE"],["\\\\\\\\int(?![a-zA-Z])","INT"],["!","!"],["\'","\'"],["_","_"],["&","&"],["\\\\\\\\ldots(?![a-zA-Z])","LDOTS"],["\\\\\\\\\\\\\\\\","LINEBREAK"],["\\\\\\\\begin\\\\s*{\\\\s*[a-zA-Z0-9]+\\\\s*}","BEGINENVIRONMENT"],["\\\\\\\\end\\\\s*{\\\\s*[a-zA-Z0-9]+\\\\s*}","ENDENVIRONMENT"],["\\\\\\\\operatorname\\\\s*{\\\\s*[a-zA-Z0-9\\\\+\\\\-]+\\\\s*}","VARMULTICHAR"],["\\\\\\\\[a-zA-Z]+(?![a-zA-Z])","LATEXCOMMAND"],["\\\\\\\\[$%]","LATEXCOMMAND"],["[a-zA-Z＿$%]","VAR"]],allowSimplifiedFunctionApplicationDefault=!0,allowedLatexSymbolsDefault="alpha.beta.gamma.Gamma.delta.Delta.epsilon.zeta.eta.theta.Theta.iota.kappa.lambda.Lambda.mu.nu.xi.Xi.pi.Pi.rho.sigma.Sigma.tau.Tau.upsilon.Upsilon.phi.Phi.chi.psi.Psi.omega.Omega.partial.angle.circ.%.$.emptyset".split("."),appliedFunctionSymbolsDefault="abs.exp.log.ln.log10.sign.sqrt.erf.cos.cosh.acos.acosh.arccos.arccosh.cot.coth.acot.acoth.arccot.arccoth.csc.csch.acsc.acsch.arccsc.arccsch.sec.sech.asec.asech.arcsec.arcsech.sin.sinh.asin.asinh.arcsin.arcsinh.tan.tanh.atan.atan2.atanh.arctan.arctanh.arg.conj.Re.Im.det.trace.nPr.nCr.floor.ceil.round".split("."),functionSymbolsDefault=["f","g"],operatorSymbolsDefault={frac:{nargs:2,substitute:"/"},binom:{nargs:2},vec:{nargs:1},overline:{nargs:1,substitute:"linesegment",remove_products:!0}},unitsDefault=get_all_units();unitsDefault.circ=unitsDefault.deg,unitsDefault.circ.substitute="deg",unitsDefault.circ.isExponent=!0,delete unitsDefault.deg;var parseLeibnizNotationDefault=!0,latexToAst$1=class{constructor({allowSimplifiedFunctionApplication:D=allowSimplifiedFunctionApplicationDefault,allowedLatexSymbols:E=allowedLatexSymbolsDefault,appliedFunctionSymbols:F=appliedFunctionSymbolsDefault,functionSymbols:J=functionSymbolsDefault,operatorSymbols:$e=operatorSymbolsDefault,units:_t=unitsDefault,parseLeibnizNotation:lr=parseLeibnizNotationDefault,parseScientificNotation:mr=!0}={}){this.allowSimplifiedFunctionApplication=D,this.allowedLatexSymbols=E,this.appliedFunctionSymbols=F,this.functionSymbols=J,this.operatorSymbols=$e,this.units=_t,this.parseLeibnizNotation=lr;let Or=base_latex_rules;Or=mr?[...number_rules_sci,...Or]:[...number_rules_non_sci,...Or],this.lexer=new lexer(Or,whitespace_rule)}advance(D){if(this.token=this.lexer.advance(D),this.token.token_type==="INVALID")throw new ParseError("Invalid symbol \'"+this.token.original_text+"\'",this.lexer.location)}return_state(){return{lexer_state:this.lexer.return_state(),token:Object.assign({},this.token)}}set_state(D){this.lexer.set_state(D.lexer_state),this.token=Object.assign({},D.token)}convert(D){this.lexer.set_input(D),this.advance();var E=this.statement_list();if(this.token.token_type!=="EOF")throw new ParseError("Invalid location of \'"+this.token.original_text+"\'",this.lexer.location);return flatten(E)}statement_list(){for(var D=[this.statement()];this.token.token_type===",";)this.advance(),D.push(this.statement());return D=D.length>1?["list"].concat(D):D[0],D}statement({inside_absolute_value:D=0}={}){if(this.token.token_type==="LDOTS")return this.advance(),["ldots"];var E;try{E=this.return_state();let F=this.statement_a({inside_absolute_value:D});if(this.token.token_type!==":"&&this.token.token_type!=="MID")return F;let J=this.token.token_type===":"?":":"|";return this.advance(),[J,F,this.statement_a()]}catch(F){try{this.set_state(E);let J=this.statement_a({parse_absolute_value:!1});if(this.token.token_type[0]!=="|")throw F;return this.advance(),["|",J,this.statement_a({parse_absolute_value:!1})]}catch{throw F}}}statement_a({inside_absolute_value:D=0,parse_absolute_value:E=!0}={}){for(var F=this.statement_b({inside_absolute_value:D,parse_absolute_value:E});["IMPLIES","IMPLIEDBY","IFF","LEFTARROW","RIGHTARROW","LEFTRIGHTARROW"].includes(this.token.token_type);){let J=this.token.token_type.toLowerCase();this.advance();let $e=this.statement_b({inside_absolute_value:D,parse_absolute_value:E});F=[J,F,$e]}return F}statement_b({inside_absolute_value:D=0,parse_absolute_value:E=!0}={}){for(var F=this.statement_c({inside_absolute_value:D,parse_absolute_value:E});this.token.token_type==="OR";){let J=this.token.token_type.toLowerCase();this.advance();let $e=this.statement_c({inside_absolute_value:D,parse_absolute_value:E});F=[J,F,$e]}return F}statement_c(D){for(var E=this.relation(D);this.token.token_type==="AND";){let F=this.token.token_type.toLowerCase();this.advance();let J=this.relation(D);E=[F,E,J]}return E}relation(D){if(this.token.token_type==="NOT"||this.token.token_type==="!")return this.advance(),["not",this.relation(D)];if(this.token.token_type==="FORALL"||this.token.token_type==="EXISTS"){let F=this.token.token_type.toLowerCase();return this.advance(),[F,this.relation(D)]}for(var E=this.expression(D);this.token.token_type==="="||this.token.token_type==="NE"||this.token.token_type==="<"||this.token.token_type===">"||this.token.token_type==="LE"||this.token.token_type==="GE"||this.token.token_type==="IN"||this.token.token_type==="NOTIN"||this.token.token_type==="NI"||this.token.token_type==="NOTNI"||this.token.token_type==="SUBSET"||this.token.token_type==="NOTSUBSET"||this.token.token_type==="SUBSETEQ"||this.token.token_type==="NOTSUBSETEQ"||this.token.token_type==="SUPERSET"||this.token.token_type==="NOTSUPERSET"||this.token.token_type==="SUPERSETEQ"||this.token.token_type==="NOTSUPERSETEQ";){let F=this.token.token_type.toLowerCase(),J=0;this.token.token_type==="<"||this.token.token_type==="LE"?J=-1:(this.token.token_type===">"||this.token.token_type==="GE")&&(J=1),this.advance();let $e=this.expression(D);if(J===-1)if(this.token.token_type==="<"||this.token.token_type==="LE"){let _t=["tuple"];F==="<"?_t.push(!0):_t.push(!1);let lr=["tuple",E,$e];for(;this.token.token_type==="<"||this.token.token_type==="LE";)this.token.token_type==="<"?_t.push(!0):_t.push(!1),this.advance(),lr.push(this.expression(D));E=["lts",lr,_t]}else E=[F,E,$e];else if(J===1)if(this.token.token_type===">"||this.token.token_type==="GE"){let _t=["tuple"];F===">"?_t.push(!0):_t.push(!1);let lr=["tuple",E,$e];for(;this.token.token_type===">"||this.token.token_type==="GE";)this.token.token_type===">"?_t.push(!0):_t.push(!1),this.advance(),lr.push(this.expression(D));E=["gts",lr,_t]}else E=[F,E,$e];else if(F==="=")for(E=["=",E,$e];this.token.token_type==="=";)this.advance(),E.push(this.expression(D));else E=[F,E,$e]}return E}expression(D){if(this.token.token_type==="NOT"||this.token.token_type==="!")return this.advance(),["not",this.expression(D)];let E=!1;this.token.token_type==="+"&&(E=!0,this.advance());let F=!1;this.token.token_type==="-"&&(F=!0,this.advance());let J=!1;this.token.token_type==="PM"&&(J=!0,this.advance());var $e=this.term(D);if(F||E){if($e===!1)return(E?"+":"")+(F?"-":"");if(typeof $e=="string"&&[...$e].every(_t=>["+","-"].includes(_t)))return(E?"+":"")+(F?"-":"")+$e}for($e===!1&&($e="＿"),F&&($e=$e>0?-$e:["-",$e]),J&&($e=["pm",$e]),E&&($e=["+",$e]);["+","-","PM","UNION","INTERSECT","PERP","PARALLEL"].includes(this.token.token_type);){let _t=this.token.token_type.toLowerCase(),lr=!1,mr=!1,Or=!1;this.token.token_type==="-"?(_t="+",lr=!0,this.advance()):this.token.token_type==="PM"?(_t="+",mr=!0,this.advance()):(this.advance(),_t==="+"&&(this.token.token_type==="-"?(lr=!0,Or=!0,this.advance()):this.token.token_type==="PM"&&(mr=!0,this.advance())));let Pr=this.term(D);if(_t==="+"){if(Pr===!1&&(typeof $e=="number"||typeof $e=="string")){if(Or)return $e+"+-";if(lr)return $e+"-";if(!mr)return $e+"+"}else if(typeof Pr=="string"&&[...Pr].every(dn=>["+","-"].includes(dn))&&(typeof $e=="number"||typeof $e=="string")){if(Or)return $e+"+-"+Pr;if(lr)return $e+"-"+Pr;if(!mr)return $e+"+"+Pr}}Pr===!1&&(Pr="＿"),lr&&(Pr=Pr>0?-Pr:["-",Pr]),mr&&(Pr=["pm",Pr]),$e=[_t,$e,Pr]}return $e}term(D){var E=this.factor(D),F=!1;do if(F=!1,this.token.token_type==="*"){this.advance(),E===!1&&(E="＿");let J=this.factor(D);J===!1&&(J="＿"),E=["*",E,J],F=!0}else if(this.token.token_type==="/"){this.advance(),E===!1&&(E="＿");let J=this.factor(D);J===!1&&(J="＿"),E=["/",E,J],F=!0}else{let J=Object.assign({},D);J.allow_absolute_value_closing=!0;let $e=this.nonMinusFactor(J);$e!==!1&&(E===!1&&(E="＿"),E=["*",E,$e],F=!0)}while(F);return this.convert_units_in_term(flatten(E))}convert_units_in_term(D){if(!Array.isArray(D))return D;let E=D[0],F=D.slice(1);if(E==="*"){let J=F.length;for(let[$e,_t]of F.entries()){let lr=this.units[_t];if(lr){if(lr.prefix&&$e<J-1){let mr;mr=$e===J-2?F[J-1]:this.convert_units_in_term(["*",...F.slice($e+1)]);let Or=_t;lr.substitute&&(Or=lr.substitute);let Pr=["unit",Or,mr];return $e===0?Pr:["*",...F.slice(0,$e).map(this.convert_units_in_term.bind(this)),Pr]}else if(!lr.prefix&&$e>0){let mr=_t;lr.substitute&&(mr=lr.substitute);let Or;return Or=$e===1?["unit",F[0],mr]:["unit",["*",...F.slice(0,$e).map(this.convert_units_in_term.bind(this))],mr],$e===J-1?Or:this.convert_units_in_term(["*",Or,...F.slice($e+1)])}}}return[E,...F.map(this.convert_units_in_term.bind(this))]}else{if(E==="/")return["/",this.convert_units_in_term(F[0]),this.convert_units_in_term(F[1])];if(E==="^"){let J=this.units[F[1]];if(J&&J.isExponent){let $e=F[1];return J.substitute&&($e=J.substitute),["unit",F[0],$e]}return[E,...F.map(this.convert_units_in_term.bind(this))]}}return[E,...F.map(this.convert_units_in_term.bind(this))]}factor(D){if(this.token.token_text==="+"){this.advance();let F=this.factor(D);return F===!1?"+":typeof F=="string"&&[...F].every(J=>["+","-"].includes(J))?"+"+F:["+",F]}if(this.token.token_type==="-"){this.advance();let F=this.factor(D);return F>0?-F:F===!1?"-":typeof F=="string"&&[...F].every(J=>["+","-"].includes(J))?"-"+F:["-",F]}let E=this.nonMinusFactor(D);return E===!1&&this.token.token_type==="PERP"&&(E="perp",this.advance()),E}nonMinusFactor(D){for(var E=this.baseFactor(D);this.token.token_type==="^"||this.token.token_type==="!"||this.token.token_type==="\'";)if(E===!1&&(E="＿"),this.token.token_type==="^"){this.advance();let F=this.get_subsuperscript(D);E=["^",E,F]}else this.token.token_type==="!"?(E=["apply","factorial",E],this.advance()):(E=["prime",E],this.advance());return E}get_single_digit_as_number(){if(this.token.token_type==="NUMBER"&&this.token.token_text[0]!=="."){let D=Number(this.token.token_text[0]);return this.token.token_text.length>1&&this.lexer.unput(this.token.token_text.slice(1)),this.advance(),D}return null}get_subsuperscript({parse_absolute_value:D}){let E=this.get_single_digit_as_number();if(E!==null)return E;if(["+","-","PERP"].includes(this.token.token_type)){let F=this.token.token_type.toLowerCase();return this.advance(),F}else{let F=this.baseFactor({parse_absolute_value:D,in_subsuperscript_with_no_delimiters:!0});return F===!1&&(F="＿"),F}}baseFactor({inside_absolute_value:D=0,parse_absolute_value:E=!0,allow_absolute_value_closing:F=!1,in_subsuperscript_with_no_delimiters:J=!1}={}){var $e=!1;if(this.token.token_type==="BEGINENVIRONMENT"){let _t=/\\\\begin\\s*{\\s*([a-zA-Z0-9]+)\\s*}/.exec(this.token.token_text)[1];if(["matrix","pmatrix","bmatrix"].includes(_t)){let lr=0,mr=0,Or=[],Pr=[],dn=0,gi=this.token.token_type;for(this.advance();this.token.token_type!=="ENDENVIRONMENT";)this.token.token_type==="&"?((gi==="&"||gi==="LINEBREAK")&&(Pr.push(0),dn+=1),gi=this.token.token_type,this.advance()):this.token.token_type==="LINEBREAK"?((gi==="&"||gi==="LINEBREAK")&&(Pr.push(0),dn+=1),Or.push(Pr),dn>mr&&(mr=dn),lr+=1,dn=0,Pr=[],gi=this.token.token_type,this.advance()):(Pr.push(this.statement({parse_absolute_value:E})),dn+=1,gi=" ");if(/\\\\end\\s*{\\s*([a-zA-Z0-9]+)\\s*}/.exec(this.token.token_text)[1]!==_t)throw new ParseError("Expecting \\\\end{"+_t+"}",this.lexer.location);gi==="&"&&(Pr.push(0),dn+=1),Or.push(Pr),dn>mr&&(mr=dn),lr+=1,this.advance(),$e=["matrix",["tuple",lr,mr]];let qi=["tuple"];for(let zi of Or){let Hi=["tuple"].concat(zi);for(let Qi=zi.length;Qi<mr;Qi+=1)Hi.push(0);qi.push(Hi)}return $e.push(qi),$e}else throw new ParseError("Unrecognized environment "+_t,this.lexer.location)}if(this.token.token_type==="NUMBER")$e=parseFloat(this.token.token_text),this.advance();else if(this.token.token_type==="INFINITY")$e=1/0,this.advance();else if(this.token.token_type==="SQRT"){this.advance();let _t=2;if(this.token.token_type==="["){this.advance();let mr=this.statement({parse_absolute_value:E});if(this.token.token_type!=="]")throw new ParseError("Expecting ]",this.lexer.location);this.advance(),_t=mr}if(this.token.token_type!=="{")throw new ParseError("Expecting {",this.lexer.location);this.advance();let lr=this.statement({parse_absolute_value:E});if(this.token.token_type!=="}")throw new ParseError("Expecting }",this.lexer.location);this.advance(),$e=_t===2?["apply","sqrt",lr]:_t===3?["apply","cbrt",lr]:["apply","nthroot",["tuple",lr,_t]]}else if(this.token.token_type==="VAR"||this.token.token_type==="LATEXCOMMAND"||this.token.token_type==="VARMULTICHAR"){if($e=this.token.token_text,this.token.token_type==="LATEXCOMMAND"){if($e=$e.slice(1),!(this.appliedFunctionSymbols.includes($e)||this.functionSymbols.includes($e)||this.allowedLatexSymbols.includes($e)||$e in this.operatorSymbols))throw new ParseError("Unrecognized latex command "+this.token.original_text,this.lexer.location)}else this.token.token_type==="VARMULTICHAR"&&($e=/\\\\operatorname\\s*\\{\\s*([a-zA-Z0-9\\+\\-]+)\\s*\\}/.exec($e)[1]);if(this.appliedFunctionSymbols.includes($e)||this.functionSymbols.includes($e)){let _t=!1;if(this.appliedFunctionSymbols.includes($e)&&(_t=!0),["Re","Im"].includes($e)&&($e=$e.toLowerCase()),this.advance(),this.token.token_type==="_"){this.advance();let lr=this.get_subsuperscript({parse_absolute_value:E});$e=$e==="log"&&lr===10?"log10":["_",$e,lr]}if(J)_t&&($e=["apply",$e,"＿"]);else{for(;this.token.token_type==="\'";)$e=["prime",$e],this.advance();for(;this.token.token_type==="^";){this.advance();let lr=this.get_subsuperscript({parse_absolute_value:E});$e=["^",$e,lr]}if(this.token.token_type==="{"||this.token.token_type==="("){let lr;lr=this.token.token_type==="{"?"}":")",this.advance();let mr=this.statement_list();if(this.token.token_type!==lr)throw new ParseError("Expecting "+lr,this.lexer.location);this.advance(),mr[0]==="list"&&(mr[0]="tuple"),$e=["apply",$e,mr]}else if(_t){if(!this.allowSimplifiedFunctionApplication)throw new ParseError("Expecting ( after function",this.lexer.location);let lr=this.factor({parse_absolute_value:E});lr===!1&&(lr="＿"),$e=["apply",$e,lr]}}return $e}else if($e in this.operatorSymbols){if(this.advance(),$e==="frac"&&this.parseLeibnizNotation){let Pr=this.return_state(),dn=this.leibniz_notation();if(dn)return dn;this.set_state(Pr)}let _t=$e;this.operatorSymbols[$e].substitute&&(_t=this.operatorSymbols[$e].substitute);let lr=this.operatorSymbols[$e].nargs,mr=this.operatorSymbols[$e].remove_products,Or=[];for(let Pr=0;Pr<lr;Pr++)if(this.token.token_type==="{"){this.advance();let dn=this.statement({parse_absolute_value:E});if(mr&&Array.isArray(dn)&&dn[0]==="*"?Or.push(...dn.slice(1)):Or.push(dn),this.token.token_type!=="}")throw new ParseError("Expecting }",this.lexer.location);this.advance()}else{let dn=this.get_single_digit_as_number();if(dn===null)if(this.token.token_type==="VAR")dn=this.token.token_text,this.advance();else throw new ParseError("Expecting {",this.lexer.location);Or.push(dn)}$e=[_t,...Or]}else this.advance()}else if(this.token.token_type==="("||this.token.token_type==="["||this.token.token_type==="{"||this.token.token_type==="LBRACE"||this.token.token_type==="LANGLE"){let _t=this.token.token_type,lr,mr;this.token.token_type==="("?(lr=")",mr="]"):this.token.token_type==="["?(lr="]",mr=")"):this.token.token_type==="{"?(lr="}",mr=null):this.token.token_type==="LBRACE"?(lr="RBRACE",mr=null):(lr="RANGLE",mr=null),this.advance(),$e=this.statement_list();let Or=1;if($e[0]==="list"&&(Or=$e.length-1),this.token.token_type!==lr){if(Or!==2||mr===null)throw new ParseError("Expecting "+lr,this.lexer.location);if(this.token.token_type!==mr)throw new ParseError("Expecting ) or ]",this.lexer.location);$e[0]="tuple",$e=["interval",$e];let Pr;Pr=_t==="("?["tuple",!1,!0]:["tuple",!0,!1],$e.push(Pr)}else Or>=2?_t==="("||_t==="{"?$e[0]="tuple":_t==="["?$e[0]="array":_t==="LBRACE"?$e[0]="set":$e[0]="altvector":_t==="LBRACE"&&($e=($e[0]==="|"||$e[0],["set",$e]));this.advance()}else if(this.token.token_type[0]==="|"&&E&&(D===0||!F||this.token.token_type[1]==="L")){if(D+=1,this.advance(),$e=this.statement({inside_absolute_value:D}),$e=["apply","abs",$e],this.token.token_type!=="|")throw new ParseError("Expecting |",this.lexer.location);this.advance()}else if(this.token.token_type==="LFLOOR"||this.token.token_type==="LCEIL"){let _t,lr;if(this.token.token_type==="LFLOOR"?(_t="RFLOOR",lr="floor"):this.token.token_type==="LCEIL"&&(_t="RCEIL",lr="ceil"),this.advance(),$e=this.statement(),$e=["apply",lr,$e],this.token.token_type!==_t)throw new ParseError("Expecting "+_t,this.lexer.location);this.advance()}else if(this.token.token_type==="ANGLE")if(this.advance(),this.token.token_type==="{"||this.token.token_type==="("){let _t;_t=this.token.token_type==="{"?"}":")",this.advance();let lr=this.statement_list();if(this.token.token_type!==_t)throw new ParseError("Expecting "+_t,this.lexer.location);this.advance(),lr[0]==="list"?$e=["angle",...lr.slice(1)]:lr[0]==="*"&&($e=["angle",lr])}else{let _t=[],lr=this.nonMinusFactor({parse_absolute_value:E});for(;lr!==!1;)_t.push(lr),lr=this.nonMinusFactor({parse_absolute_value:E});$e=_t.length===0?"angle":["angle",..._t]}else if(this.token.token_type==="INT"){this.advance();let _t="int";if(this.token.token_type==="_"){this.advance();let mr=this.get_subsuperscript({parse_absolute_value:E});_t=["_",_t,mr]}if(this.token.token_type==="^"){this.advance();let mr=this.get_subsuperscript({parse_absolute_value:E});_t=["^",_t,mr]}let lr=flatten(this.term({parse_absolute_value:E}));if(Array.isArray(lr)&&lr[0]==="*"){let mr=[];for(let Or=0;Or<lr.length-1;Or++)if(lr[Or]==="d"){let Pr=lr[Or+1];lr.splice(Or,2),mr.push(["d",Pr]),Or--}lr.push(...mr)}return["apply",_t,lr]}if(this.token.token_type==="_"){$e===!1&&($e="＿"),this.advance();let _t=this.get_subsuperscript({parse_absolute_value:E});$e=["_",$e,_t]}return $e}leibniz_notation(){if(this.token.token_type!=="{")return!1;this.advance();var D=this.token.token_text;let E="",F=1,J="",$e=[],_t=[];if(this.token.token_type==="LATEXCOMMAND"&&D.slice(1)==="partial")E="∂";else if(this.token.token_type==="VAR"&&D==="d")E="d";else return!1;if(this.advance(),this.token.token_type==="^"){this.advance();let mr=!1;if(this.token.token_type==="{"&&(mr=!0,this.advance()),this.token.token_type!=="NUMBER"||(F=parseFloat(this.token.token_text),!Number.isInteger(F))||mr&&(this.advance(),this.token.token_type!=="}"))return!1;this.advance()}if(this.token.token_type==="VAR")J=this.token.token_text;else if(this.token.token_type==="VARMULTICHAR")J=/\\\\operatorname\\s*\\{\\s*([a-zA-Z0-9\\+\\-]+)\\s*\\}/.exec(this.token.token_text)[1];else if(this.token.token_type==="LATEXCOMMAND")if(D=this.token.token_text.slice(1),this.allowedLatexSymbols.includes(D))J=D;else return!1;if(this.advance(),this.token.token_type!=="}"||(this.advance(),this.token.token_type!=="{"))return!1;this.advance();let lr=0;for(;;){if(!(E==="d"&&this.token.token_type==="VAR"&&this.token.token_text==="d"||E==="∂"&&this.token.token_type==="LATEXCOMMAND"&&this.token.token_text.slice(1)==="partial"))return!1;if(this.advance(),this.token.token_type==="VAR")$e.push(this.token.token_text);else if(this.token.token_type==="VARMULTICHAR")$e.push(/\\\\operatorname\\s*\\{\\s*([a-zA-Z0-9\\+\\-]+)\\s*\\}/.exec(this.token.token_text)[1]);else if(this.token.token_type==="LATEXCOMMAND"){let Or=this.token.token_text.slice(1);if(this.allowedLatexSymbols.includes(Or))$e.push(Or);else return!1}else return!1;let mr=1;if(this.advance(),this.token.token_type==="^"){this.advance();let Or=!1;if(this.token.token_type==="{"&&(Or=!0,this.advance()),this.token.token_type!=="NUMBER"||(mr=parseFloat(this.token.token_text),!Number.isInteger(mr))||Or&&(this.advance(),this.token.token_type!=="}"))return!1;this.advance()}if(_t.push(mr),lr+=mr,lr>F)return!1;if(lr===F){if(this.token.token_type!=="}")return!1;this.advance();let Or="derivative_leibniz";E==="∂"&&(Or="partial_"+Or),D=[Or],F===1?D.push(J):D.push(["tuple",J,F]);let Pr=[];for(let dn=0;dn<$e.length;dn+=1)_t[dn]===1?Pr.push($e[dn]):Pr.push(["tuple",$e[dn],_t[dn]]);return Pr=["tuple"].concat(Pr),D.push(Pr),D}}}},latexToGuppy=class{constructor(){this.latexToAst=new latexToAst$1,this.astToGuppy=new astToGuppy$1}convert(D){return this.astToGuppy.convert(this.latexToAst.convert(D))}},latexToMathjs=class{constructor(){this.latexToAst=new latexToAst$1,this.astToMathjs=new astToMathjs$2}convert(D){return this.astToMathjs.convert(this.latexToAst.convert(D))}},latexToText=class{constructor(){this.latexToAst=new latexToAst$1,this.astToText=new astToText$2}convert(D){return this.astToText.convert(this.latexToAst.convert(D))}},mathjsToGuppy=class{constructor(){this.mathjsToAst=new mathjsToAst$1,this.astToGuppy=new astToGuppy$1}convert(D){return this.astToGuppy.convert(this.mathjsToAst.convert(D))}},mathjsToLatex=class{constructor(){this.mathjsToAst=new mathjsToAst$1,this.astToLatex=new astToLatex$1}convert(D){return this.astToLatex.convert(this.mathjsToAst.convert(D))}},mathjsToText=class{constructor(){this.mathjsToAst=new mathjsToAst$1,this.astToText=new astToText$2}convert(D){return this.astToText.convert(this.mathjsToAst.convert(D))}},require_ms=__commonJSMin(((D,E)=>{var F=1e3,J=F*60,$e=J*60,_t=$e*24,lr=_t*365.25;E.exports=function(gi,qi){qi||={};var zi=typeof gi;if(zi==="string"&&gi.length>0)return mr(gi);if(zi==="number"&&isNaN(gi)===!1)return qi.long?Pr(gi):Or(gi);throw Error("val is not a non-empty string or a valid number. val="+JSON.stringify(gi))};function mr(gi){if(gi=String(gi),!(gi.length>100)){var qi=/^((?:\\d+)?\\.?\\d+) *(milliseconds?|msecs?|ms|seconds?|secs?|s|minutes?|mins?|m|hours?|hrs?|h|days?|d|years?|yrs?|y)?$/i.exec(gi);if(qi){var zi=parseFloat(qi[1]);switch((qi[2]||"ms").toLowerCase()){case"years":case"year":case"yrs":case"yr":case"y":return zi*lr;case"days":case"day":case"d":return zi*_t;case"hours":case"hour":case"hrs":case"hr":case"h":return zi*$e;case"minutes":case"minute":case"mins":case"min":case"m":return zi*J;case"seconds":case"second":case"secs":case"sec":case"s":return zi*F;case"milliseconds":case"millisecond":case"msecs":case"msec":case"ms":return zi;default:return}}}}function Or(gi){return gi>=_t?Math.round(gi/_t)+"d":gi>=$e?Math.round(gi/$e)+"h":gi>=J?Math.round(gi/J)+"m":gi>=F?Math.round(gi/F)+"s":gi+"ms"}function Pr(gi){return dn(gi,_t,"day")||dn(gi,$e,"hour")||dn(gi,J,"minute")||dn(gi,F,"second")||gi+" ms"}function dn(gi,qi,zi){if(!(gi<qi))return gi<qi*1.5?Math.floor(gi/qi)+" "+zi:Math.ceil(gi/qi)+" "+zi+"s"}})),require_debug=__commonJSMin(((D,E)=>{D=E.exports=$e.debug=$e.default=$e,D.coerce=Or,D.disable=lr,D.enable=_t,D.enabled=mr,D.humanize=require_ms(),D.names=[],D.skips=[],D.formatters={};var F;function J(Pr){var dn=0,gi;for(gi in Pr)dn=(dn<<5)-dn+Pr.charCodeAt(gi),dn|=0;return D.colors[Math.abs(dn)%D.colors.length]}function $e(Pr){function dn(){if(dn.enabled){var gi=dn,qi=+new Date;gi.diff=qi-(F||qi),gi.prev=F,gi.curr=qi,F=qi;for(var zi=Array(arguments.length),Hi=0;Hi<zi.length;Hi++)zi[Hi]=arguments[Hi];zi[0]=D.coerce(zi[0]),typeof zi[0]!="string"&&zi.unshift("%O");var Qi=0;zi[0]=zi[0].replace(/%([a-zA-Z%])/g,function(Gi,Zi){if(Gi==="%%")return Gi;Qi++;var Xi=D.formatters[Zi];if(typeof Xi=="function"){var Ki=zi[Qi];Gi=Xi.call(gi,Ki),zi.splice(Qi,1),Qi--}return Gi}),D.formatArgs.call(gi,zi),(dn.log||D.log||console.log.bind(console)).apply(gi,zi)}}return dn.namespace=Pr,dn.enabled=D.enabled(Pr),dn.useColors=D.useColors(),dn.color=J(Pr),typeof D.init=="function"&&D.init(dn),dn}function _t(Pr){D.save(Pr),D.names=[],D.skips=[];for(var dn=(typeof Pr=="string"?Pr:"").split(/[\\s,]+/),gi=dn.length,qi=0;qi<gi;qi++)dn[qi]&&(Pr=dn[qi].replace(/\\*/g,".*?"),Pr[0]==="-"?D.skips.push(RegExp("^"+Pr.substr(1)+"$")):D.names.push(RegExp("^"+Pr+"$")))}function lr(){D.enable("")}function mr(Pr){var dn,gi;for(dn=0,gi=D.skips.length;dn<gi;dn++)if(D.skips[dn].test(Pr))return!1;for(dn=0,gi=D.names.length;dn<gi;dn++)if(D.names[dn].test(Pr))return!0;return!1}function Or(Pr){return Pr instanceof Error?Pr.stack||Pr.message:Pr}})),require_browser=__commonJSMin(((D,E)=>{D=E.exports=require_debug(),D.log=$e,D.formatArgs=J,D.save=_t,D.load=lr,D.useColors=F,D.storage=typeof chrome<"u"&&chrome.storage!==void 0?chrome.storage.local:mr(),D.colors=["lightseagreen","forestgreen","goldenrod","dodgerblue","darkorchid","crimson"];function F(){return typeof window<"u"&&window.process&&window.process.type==="renderer"?!0:typeof document<"u"&&document.documentElement&&document.documentElement.style&&document.documentElement.style.WebkitAppearance||typeof window<"u"&&window.console&&(window.console.firebug||window.console.exception&&window.console.table)||typeof navigator<"u"&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/firefox\\/(\\d+)/)&&parseInt(RegExp.$1,10)>=31||typeof navigator<"u"&&navigator.userAgent&&navigator.userAgent.toLowerCase().match(/applewebkit\\/(\\d+)/)}D.formatters.j=function(Or){try{return JSON.stringify(Or)}catch(Pr){return"[UnexpectedJSONParseError]: "+Pr.message}};function J(Or){var Pr=this.useColors;if(Or[0]=(Pr?"%c":"")+this.namespace+(Pr?" %c":" ")+Or[0]+(Pr?"%c ":" ")+"+"+D.humanize(this.diff),Pr){var dn="color: "+this.color;Or.splice(1,0,dn,"color: inherit");var gi=0,qi=0;Or[0].replace(/%[a-zA-Z%]/g,function(zi){zi!=="%%"&&(gi++,zi==="%c"&&(qi=gi))}),Or.splice(qi,0,dn)}}function $e(){return typeof console=="object"&&console.log&&Function.prototype.apply.call(console.log,console,arguments)}function _t(Or){try{Or==null?D.storage.removeItem("debug"):D.storage.debug=Or}catch{}}function lr(){var Or;try{Or=D.storage.debug}catch{}return!Or&&typeof process<"u"&&"env"in process&&(Or=process.env.DEBUG),Or}D.enable(lr());function mr(){try{return window.localStorage}catch{}}})),require_xml_parser=__commonJSMin(((D,E)=>{var F=require_browser()("xml-parser");E.exports=J;function J($e){return $e=$e.trim(),$e=$e.replace(/<!--[\\s\\S]*?-->/g,""),_t();function _t(){return{declaration:lr(),root:mr()}}function lr(){if(gi(/^<\\?xml\\s*/)){for(var Hi={attributes:{}};!(qi()||zi("?>"));){var Qi=Pr();if(!Qi)return Hi;Hi.attributes[Qi.name]=Qi.value}return gi(/\\?>\\s*/),Hi}}function mr(){F("tag %j",$e);var Hi=gi(/^<([\\w-:.]+)\\s*/);if(Hi){for(var Qi={name:Hi[1],attributes:{},children:[]};!(qi()||zi(">")||zi("?>")||zi("/>"));){var Gi=Pr();if(!Gi)return Qi;Qi.attributes[Gi.name]=Gi.value}if(gi(/^\\s*\\/>\\s*/))return Qi;gi(/\\??>\\s*/),Qi.content=Or();for(var Zi;Zi=mr();)Qi.children.push(Zi);return gi(/^<\\/[\\w-:.]+>\\s*/),Qi}}function Or(){F("content %j",$e);var Hi=gi(/^([^<]*)/);return Hi?Hi[1]:""}function Pr(){F("attribute %j",$e);var Hi=gi(/([\\w:-]+)\\s*=\\s*("[^"]*"|\'[^\']*\'|\\w+)\\s*/);if(Hi)return{name:Hi[1],value:dn(Hi[2])}}function dn(Hi){return Hi.replace(/^[\'"]|[\'"]$/g,"")}function gi(Hi){var Qi=$e.match(Hi);if(Qi)return $e=$e.slice(Qi[0].length),Qi}function qi(){return $e.length==0}function zi(Hi){return $e.indexOf(Hi)==0}}})),import_xml_parser=__toESM(require_xml_parser()),entities={"&#913;":"\\\\Alpha","&Alpha;":"\\\\Alpha","&#x0391;":"\\\\Alpha","\\\\u0391;":"\\\\Alpha","&#914;":"\\\\Beta","&Beta;":"\\\\Beta","&#x0392;":"\\\\Beta","\\\\u0392;":"\\\\Beta","&#915;":"\\\\Gamma","&Gamma;":"\\\\Gamma","&#x0393;":"\\\\Gamma","\\\\u0393;":"\\\\Gamma","&#916;":"\\\\Delta","&Delta;":"\\\\Delta","&#x0394;":"\\\\Delta","\\\\u0394;":"\\\\Delta","&#917;":"\\\\Epsilon","&Epsilon;":"\\\\Epsilon","&#x0395;":"\\\\Epsilon","\\\\u0395;":"\\\\Epsilon","&#918;":"\\\\Zeta","&Zeta;":"\\\\Zeta","&#x0396;":"\\\\Zeta","\\\\u0396;":"\\\\Zeta","&#919;":"\\\\Eta","&Eta;":"\\\\Eta","&#x0397;":"\\\\Eta","\\\\u0397;":"\\\\Eta","&#920;":"\\\\Theta","&Theta;":"\\\\Theta","&#x0398;":"\\\\Theta","\\\\u0398;":"\\\\Theta","&#921;":"\\\\Iota","&Iota;":"\\\\Iota","&#x0399;":"\\\\Iota","\\\\u0399;":"\\\\Iota","&#922;":"\\\\Kappa","&Kappa;":"\\\\Kappa","&#x039A;":"\\\\Kappa","\\\\u039A;":"\\\\Kappa","&#923;":"\\\\Lambda","&Lambda;":"\\\\Lambda","&#x039B;":"\\\\Lambda","\\\\u039B;":"\\\\Lambda","&#924;":"\\\\Mu","&Mu;":"\\\\Mu","&#x039C;":"\\\\Mu","\\\\u039C;":"\\\\Mu","&#925;":"\\\\Nu","&Nu;":"\\\\Nu","&#x039D;":"\\\\Nu","\\\\u039D;":"\\\\Nu","&#926;":"\\\\Xi","&Xi;":"\\\\Xi","&#x039E;":"\\\\Xi","\\\\u039E;":"\\\\Xi","&#927;":"\\\\Omicron","&Omicron;":"\\\\Omicron","&#x039F;":"\\\\Omicron","\\\\u039F;":"\\\\Omicron","&#928;":"\\\\Pi","&Pi;":"\\\\Pi","&#x03A0;":"\\\\Pi","\\\\u03A0;":"\\\\Pi","&#929;":"\\\\Rho","&Rho;":"\\\\Rho","&#x03A1;":"\\\\Rho","\\\\u03A1;":"\\\\Rho","&#931;":"\\\\Sigma","&Sigma;":"\\\\Sigma","&#x03A3;":"\\\\Sigma","\\\\u03A3;":"\\\\Sigma","&#932;":"\\\\Tau","&Tau;":"\\\\Tau","&#x03A4;":"\\\\Tau","\\\\u03A4;":"\\\\Tau","&#933;":"\\\\Upsilon","&Upsilon;":"\\\\Upsilon","&#x03A5;":"\\\\Upsilon","\\\\u03A5;":"\\\\Upsilon","&#934;":"\\\\Phi","&Phi;":"\\\\Phi","&#x03A6;":"\\\\Phi","\\\\u03A6;":"\\\\Phi","&#935;":"\\\\Chi","&Chi;":"\\\\Chi","&#x03A7;":"\\\\Chi","\\\\u03A7;":"\\\\Chi","&#936;":"\\\\Psi","&Psi;":"\\\\Psi","&#x03A8;":"\\\\Psi","\\\\u03A8;":"\\\\Psi","&#937;":"\\\\Omega","&Omega;":"\\\\Omega","&#x03A9;":"\\\\Omega","\\\\u03A9;":"\\\\Omega","&#945;":"\\\\alpha","&alpha;":"\\\\alpha","&#x03B1;":"\\\\alpha","\\\\u03B1;":"\\\\alpha","&#946;":"\\\\beta","&beta;":"\\\\beta","&#x03B2;":"\\\\beta","\\\\u03B2;":"\\\\beta","&#947;":"\\\\gamma","&gamma;":"\\\\gamma","&#x03B3;":"\\\\gamma","\\\\u03B3;":"\\\\gamma","&#948;":"\\\\delta","&delta;":"\\\\delta","&#x03B4;":"\\\\delta","\\\\u03B4;":"\\\\delta","&#949;":"\\\\epsilon","&epsilon;":"\\\\epsilon","&#x03B5;":"\\\\epsilon","\\\\u03B5;":"\\\\epsilon","&#950;":"\\\\zeta","&zeta;":"\\\\zeta","&#x03B6;":"\\\\zeta","\\\\u03B6;":"\\\\zeta","&#951;":"\\\\eta","&eta;":"\\\\eta","&#x03B7;":"\\\\eta","\\\\u03B7;":"\\\\eta","&#952;":"\\\\theta","&theta;":"\\\\theta","&#x03B8;":"\\\\theta","\\\\u03B8;":"\\\\theta","&#953;":"\\\\iota","&iota;":"\\\\iota","&#x03B9;":"\\\\iota","\\\\u03B9;":"\\\\iota","&#954;":"\\\\kappa","&kappa;":"\\\\kappa","&#x03BA;":"\\\\kappa","\\\\u03BA;":"\\\\kappa","&#955;":"\\\\lambda","&lambda;":"\\\\lambda","&#x03BB;":"\\\\lambda","\\\\u03BB;":"\\\\lambda","&#956;":"\\\\mu","&mu;":"\\\\mu","&#x03BC;":"\\\\mu","\\\\u03BC;":"\\\\mu","&#957;":"\\\\nu","&nu;":"\\\\nu","&#x03BD;":"\\\\nu","\\\\u03BD;":"\\\\nu","&#958;":"\\\\xi","&xi;":"\\\\xi","&#x03BE;":"\\\\xi","\\\\u03BE;":"\\\\xi","&#959;":"\\\\omicron","&omicron;":"\\\\omicron","&#x03BF;":"\\\\omicron","\\\\u03BF;":"\\\\omicron","&#960;":"\\\\pi","&pi;":"\\\\pi","&#x03C0;":"\\\\pi","\\\\u03C0;":"\\\\pi","&#961;":"\\\\rho","&rho;":"\\\\rho","&#x03C1;":"\\\\rho","\\\\u03C1;":"\\\\rho","&#962;":"\\\\sigma",";":"\\\\sigma","&#x03C2;":"\\\\sigma","\\\\u03C2;":"\\\\sigma","&#963;":"\\\\sigma","&sigma;":"\\\\sigma","&#x03C3;":"\\\\sigma","\\\\u03C3;":"\\\\sigma","&#964;":"\\\\tau","&tau;":"\\\\tau","&#x03C4;":"\\\\tau","\\\\u03C4;":"\\\\tau","&#965;":"\\\\upsilon","&upsilon;":"\\\\upsilon","&#x03C5;":"\\\\upsilon","\\\\u03C5;":"\\\\upsilon","&#966;":"\\\\phi","&phi;":"\\\\phi","&#x03C6;":"\\\\phi","\\\\u03C6;":"\\\\phi","&#967;":"\\\\chi","&chi;":"\\\\chi","&#x03C7;":"\\\\chi","\\\\u03C7;":"\\\\chi","&#968;":"\\\\psi","&psi;":"\\\\psi","&#x03C8;":"\\\\psi","\\\\u03C8;":"\\\\psi","&#969;":"\\\\omega","&omega;":"\\\\omega","&#x03C9;":"\\\\omega","\\\\u03C9;":"\\\\omega","&#x2212;":"-","&minus;":"-","&#x221E;":"\\\\infty","&#8734;":"\\\\infty","&infin;":"\\\\infty","&sdot;":"\\\\cdot","&#x22C5;":"\\\\cdot","&#8901;":"\\\\cdot","&times;":"\\\\times","&#x00D7;":"\\\\times","&#215;":"\\\\times"},mmlToLatex=class{parse(D){if(D.name==="mi")return entities[D.content]?entities[D.content]:D.content.length>1?"\\\\"+D.content:D.content;if(D.name==="mn")return D.content;if(D.name==="msup")return this.parse(D.children[0])+"^{"+this.parse(D.children[1])+"}";if(D.name==="mroot")return"\\\\sqrt["+this.parse(D.children[1])+"]{"+this.parse(D.children[1])+"}";if(D.name==="mfrac")return"\\\\frac{"+this.parse(D.children[0])+"}{"+this.parse(D.children[1])+"}";if(D.name==="msqrt")return"\\\\sqrt{"+D.children.map((function(E,F){return this.parse(E)}).bind(this)).join(" ")+"}";if(D.name==="mo")return entities[D.content]?entities[D.content]:D.content==="&#x2061;"?" ":D.content;if(D.name==="mrow"&&D.attributes.class==="MJX-TeXAtom-ORD")return D.children.map((function(E,F){return this.parse(E)}).bind(this)).join(" ");if(D.name==="math"||D.name==="mrow")return"("+D.children.map((function(E,F){return this.parse(E)}).bind(this)).join(" ")+")"}convert(D){return this.parse((0,import_xml_parser.default)(D).root)}},mmlToAst$1=class{constructor(){this.mmlToLatex=new mmlToLatex,this.latexToAst=new latexToAst$1}convert(D){return this.latexToAst.convert(this.mmlToLatex.convert(D))}},mmlToGuppy=class{constructor(){this.mmlToLatex=new mmlToLatex,this.latexToAst=new latexToAst$1,this.astToGuppy=new astToGuppy$1}convert(D){return this.astToGuppy.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)))}},mmlToMathjs=class{constructor(){this.mmlToLatex=new mmlToLatex,this.latexToAst=new latexToAst$1,this.astToMathjs=new astToMathjs$2}convert(D){return this.astToMathjs.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)))}},mmlToText=class{constructor(){this.mmlToLatex=new mmlToLatex,this.latexToAst=new latexToAst$1,this.astToText=new astToText$2}convert(D){return this.astToText.convert(this.latexToAst.convert(this.mmlToLatex.convert(D)))}},textToGuppy=class{constructor(){this.textToAst=new textToAst$4,this.astToGuppy=new astToGuppy$1}convert(D){return this.astToGuppy.convert(this.textToAst.convert(D))}},textToLatex=class{constructor(){this.textToAst=new textToAst$4,this.astToLatex=new astToLatex$1}convert(D){return this.astToLatex.convert(this.textToAst.convert(D))}},textToMathjs=class{constructor(){this.textToAst=new textToAst$4,this.astToMathjs=new astToMathjs$2}convert(D){return this.astToMathjs.convert(this.textToAst.convert(D))}},converters_exports=__exportAll({astToFiniteFieldObj:()=>astToFiniteField$1,astToGLSL:()=>astToGLSL$1,astToGuppyObj:()=>astToGuppy$1,astToLatexObj:()=>astToLatex$1,astToMathjsObj:()=>astToMathjs$2,astToTextObj:()=>astToText$2,latexToAstObj:()=>latexToAst$1,latexToGuppyObj:()=>latexToGuppy,latexToMathjsObj:()=>latexToMathjs,latexToTextObj:()=>latexToText,mathjsToAstObj:()=>mathjsToAst$1,mathjsToGuppyObj:()=>mathjsToGuppy,mathjsToLatexObj:()=>mathjsToLatex,mathjsToTextObj:()=>mathjsToText,mmlToAstObj:()=>mmlToAst$1,mmlToGuppyObj:()=>mmlToGuppy,mmlToLatexObj:()=>mmlToLatex,mmlToMathjsObj:()=>mmlToMathjs,mmlToTextObj:()=>mmlToText,textToAstObj:()=>textToAst$4,textToGuppyObj:()=>textToGuppy,textToLatexObj:()=>textToLatex,textToMathjsObj:()=>textToMathjs}),textToAst=new textToAst$4,latexToAst=new latexToAst$1,mmlToAst=new mmlToAst$1,utils={match:match$1,flatten:flatten$5,unflattenLeft,unflattenRight};function Expression(D,E){this.tree=flatten$5(D),this.context=E,this.toJSON=function(){let F={objectType:"math-expression",tree:this.tree},J={};for(let $e in this.context.assumptions)Object.keys(this.context.assumptions[$e]).length>0&&(J[$e]=this.context.assumptions[$e]);return Object.keys(J).length>0&&(F.assumptions=J),F}}function extend(D,E){return flatten_array(Array.prototype.slice.call(arguments,2)).forEach(function(F){if(F)for(var J in F)E?(function(){var $e=J;D[$e]=function(){return this.fromAst(F[$e].apply(null,arguments))}})():D[J]=F[J]}),D}function extend_prototype(D,E){return flatten_array(Array.prototype.slice.call(arguments,2)).forEach(function(F){if(F)for(var J in F)(function(){var $e=J;D[$e]=function(){var _t=[this].concat(Array.prototype.slice.call(arguments));return E?this.context.fromAst(F[$e].apply(null,_t)):F[$e].apply(null,_t)}})()}),D}function create_from_multiple(D,E){if(Array.isArray(D)||typeof D=="number")return new Expression(D,Context);if(typeof D=="string")try{return new Expression(textToAst.convert(D),Context)}catch(F){try{return new Expression(latexToAst.convert(D),Context)}catch(J){try{return new Expression(mmlToAst.convert(D),Context)}catch($e){throw D.indexOf("\\\\")===-1?D.indexOf("</")===-1?F:$e:J}}}}function parseText(D,E){return new Expression(textToAst.convert(D),Context)}function parseLatex(D,E){return new Expression(latexToAst.convert(D),Context)}function parseMml(D,E){return new Expression(mmlToAst.convert(D),Context)}var Context={ZmodN,assumptions:initialize_assumptions(),parser_parameters:{},from:create_from_multiple,fromText:parseText,parse:parseText,fromLaTeX:parseLatex,fromLatex:parseLatex,fromTeX:parseLatex,fromTex:parseLatex,fromMml:parseMml,parse_tex:parseLatex,converters:converters_exports,utils,fromAst:function(D){return new Expression(D,this)},set_to_default:function(){this.assumptions=initialize_assumptions()},get_assumptions:function(D,E){return get_assumptions(this.assumptions,D,E)},add_assumption:function(D,E){return add_assumption(this.assumptions,D,E)},add_generic_assumption:function(D){return add_generic_assumption(this.assumptions,D)},remove_assumption:function(D){return remove_assumption(this.assumptions,D)},remove_generic_assumption:function(D){return remove_generic_assumption(this.assumptions,D)},clear_assumptions:function(){this.assumptions=initialize_assumptions()},math:mathjs_default,reviver:function(D,E){if(E&&E.objectType==="math-expression"&&E.tree!==void 0){let F=Context.fromAst(E.tree);return E.assumptions!==void 0&&(F.assumptions=E.assumptions),F}return E},class:Expression};Context.set_to_default(),extend(Context,!0,expression_to_tree$1,expression_to_tree),extend(Context,!1,expression_to_other),extend_prototype(Expression.prototype,!0,expression_to_tree$1),extend_prototype(Expression.prototype,!1,expression_to_other);function flatten_array(D,E){E=E===void 0?[]:E;for(var F=0;F<D.length;F++)Array.isArray(D[F])?flatten_array(D[F],E):E.push(D[F]);return E}var base32$1={exports:{}},hasRequiredBase32;function requireBase32(){return hasRequiredBase32||(hasRequiredBase32=1,(function(D){(function(){var E=typeof window=="object"?window:{},F=!E.HI_BASE32_NO_NODE_JS&&typeof process=="object"&&process.versions&&process.versions.node;F&&(E=commonjsGlobal);var J=!E.HI_BASE32_NO_COMMON_JS&&!0&&D.exports,$e="ABCDEFGHIJKLMNOPQRSTUVWXYZ234567".split(""),_t={A:0,B:1,C:2,D:3,E:4,F:5,G:6,H:7,I:8,J:9,K:10,L:11,M:12,N:13,O:14,P:15,Q:16,R:17,S:18,T:19,U:20,V:21,W:22,X:23,Y:24,Z:25,2:26,3:27,4:28,5:29,6:30,7:31},lr=[0,0,0,0,0,0,0,0],mr=function(Gi,Zi){Zi.length>10&&(Zi="..."+Zi.substr(-10));var Xi=new Error("Decoded data is not valid UTF-8. Maybe try base32.decode.asBytes()? Partial data after reading "+Gi+" bytes: "+Zi+" <-");throw Xi.position=Gi,Xi},Or=function(Gi){for(var Zi="",Xi=Gi.length,Ki=0,ea=0,Ji,ta;Ki<Xi;){if(Ji=Gi[Ki++],Ji<=127){Zi+=String.fromCharCode(Ji);continue}else Ji>191&&Ji<=223?(ta=Ji&31,ea=1):Ji<=239?(ta=Ji&15,ea=2):Ji<=247?(ta=Ji&7,ea=3):mr(Ki,Zi);for(var na=0;na<ea;++na)Ji=Gi[Ki++],(Ji<128||Ji>191)&&mr(Ki,Zi),ta<<=6,ta+=Ji&63;ta>=55296&&ta<=57343&&mr(Ki,Zi),ta>1114111&&mr(Ki,Zi),ta<=65535?Zi+=String.fromCharCode(ta):(ta-=65536,Zi+=String.fromCharCode((ta>>10)+55296),Zi+=String.fromCharCode((ta&1023)+56320))}return Zi},Pr=function(Gi){if(Gi==="")return[];if(!/^[A-Z2-7=]+$/.test(Gi))throw new Error("Invalid base32 characters");Gi=Gi.replace(/=/g,"");for(var Zi,Xi,Ki,ea,Ji,ta,na,ra,ia=[],oa=0,ua=Gi.length,sa=0,aa=ua>>3<<3;sa<aa;)Zi=_t[Gi.charAt(sa++)],Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ta=_t[Gi.charAt(sa++)],na=_t[Gi.charAt(sa++)],ra=_t[Gi.charAt(sa++)],ia[oa++]=(Zi<<3|Xi>>>2)&255,ia[oa++]=(Xi<<6|Ki<<1|ea>>>4)&255,ia[oa++]=(ea<<4|Ji>>>1)&255,ia[oa++]=(Ji<<7|ta<<2|na>>>3)&255,ia[oa++]=(na<<5|ra)&255;var pa=ua-aa;return pa===2?(Zi=_t[Gi.charAt(sa++)],Xi=_t[Gi.charAt(sa++)],ia[oa++]=(Zi<<3|Xi>>>2)&255):pa===4?(Zi=_t[Gi.charAt(sa++)],Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],ia[oa++]=(Zi<<3|Xi>>>2)&255,ia[oa++]=(Xi<<6|Ki<<1|ea>>>4)&255):pa===5?(Zi=_t[Gi.charAt(sa++)],Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ia[oa++]=(Zi<<3|Xi>>>2)&255,ia[oa++]=(Xi<<6|Ki<<1|ea>>>4)&255,ia[oa++]=(ea<<4|Ji>>>1)&255):pa===7&&(Zi=_t[Gi.charAt(sa++)],Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ta=_t[Gi.charAt(sa++)],na=_t[Gi.charAt(sa++)],ia[oa++]=(Zi<<3|Xi>>>2)&255,ia[oa++]=(Xi<<6|Ki<<1|ea>>>4)&255,ia[oa++]=(ea<<4|Ji>>>1)&255,ia[oa++]=(Ji<<7|ta<<2|na>>>3)&255),ia},dn=function(Gi){for(var Zi,Xi,Ki,ea,Ji,ta="",na=Gi.length,ra=0,ia=parseInt(na/5)*5;ra<ia;)Zi=Gi.charCodeAt(ra++),Xi=Gi.charCodeAt(ra++),Ki=Gi.charCodeAt(ra++),ea=Gi.charCodeAt(ra++),Ji=Gi.charCodeAt(ra++),ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[(ea<<3|Ji>>>5)&31]+$e[Ji&31];var oa=na-ia;return oa===1?(Zi=Gi.charCodeAt(ra),ta+=$e[Zi>>>3]+$e[Zi<<2&31]+"======"):oa===2?(Zi=Gi.charCodeAt(ra++),Xi=Gi.charCodeAt(ra),ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[Xi<<4&31]+"===="):oa===3?(Zi=Gi.charCodeAt(ra++),Xi=Gi.charCodeAt(ra++),Ki=Gi.charCodeAt(ra),ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[Ki<<1&31]+"==="):oa===4&&(Zi=Gi.charCodeAt(ra++),Xi=Gi.charCodeAt(ra++),Ki=Gi.charCodeAt(ra++),ea=Gi.charCodeAt(ra),ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[ea<<3&31]+"="),ta},gi=function(Gi){var Zi,Xi,Ki,ea,Ji,ta,na=!1,ra="",ia=0,oa,ua=0,sa=Gi.length;if(Gi==="")return ra;do{for(lr[0]=lr[5],lr[1]=lr[6],lr[2]=lr[7],oa=ua;ia<sa&&oa<5;++ia)ta=Gi.charCodeAt(ia),ta<128?lr[oa++]=ta:ta<2048?(lr[oa++]=192|ta>>6,lr[oa++]=128|ta&63):ta<55296||ta>=57344?(lr[oa++]=224|ta>>12,lr[oa++]=128|ta>>6&63,lr[oa++]=128|ta&63):(ta=65536+((ta&1023)<<10|Gi.charCodeAt(++ia)&1023),lr[oa++]=240|ta>>18,lr[oa++]=128|ta>>12&63,lr[oa++]=128|ta>>6&63,lr[oa++]=128|ta&63);ua=oa-5,ia===sa&&++ia,ia>sa&&oa<6&&(na=!0),Zi=lr[0],oa>4?(Xi=lr[1],Ki=lr[2],ea=lr[3],Ji=lr[4],ra+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[(ea<<3|Ji>>>5)&31]+$e[Ji&31]):oa===1?ra+=$e[Zi>>>3]+$e[Zi<<2&31]+"======":oa===2?(Xi=lr[1],ra+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[Xi<<4&31]+"===="):oa===3?(Xi=lr[1],Ki=lr[2],ra+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[Ki<<1&31]+"==="):(Xi=lr[1],Ki=lr[2],ea=lr[3],ra+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[ea<<3&31]+"=")}while(!na);return ra},qi=function(Gi){for(var Zi,Xi,Ki,ea,Ji,ta="",na=Gi.length,ra=0,ia=parseInt(na/5)*5;ra<ia;)Zi=Gi[ra++],Xi=Gi[ra++],Ki=Gi[ra++],ea=Gi[ra++],Ji=Gi[ra++],ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[(ea<<3|Ji>>>5)&31]+$e[Ji&31];var oa=na-ia;return oa===1?(Zi=Gi[ra],ta+=$e[Zi>>>3]+$e[Zi<<2&31]+"======"):oa===2?(Zi=Gi[ra++],Xi=Gi[ra],ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[Xi<<4&31]+"===="):oa===3?(Zi=Gi[ra++],Xi=Gi[ra++],Ki=Gi[ra],ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[Ki<<1&31]+"==="):oa===4&&(Zi=Gi[ra++],Xi=Gi[ra++],Ki=Gi[ra++],ea=Gi[ra],ta+=$e[Zi>>>3]+$e[(Zi<<2|Xi>>>6)&31]+$e[Xi>>>1&31]+$e[(Xi<<4|Ki>>>4)&31]+$e[(Ki<<1|ea>>>7)&31]+$e[ea>>>2&31]+$e[ea<<3&31]+"="),ta},zi=function(Gi,Zi){var Xi=typeof Gi!="string";return Xi&&Gi.constructor===ArrayBuffer&&(Gi=new Uint8Array(Gi)),Xi?qi(Gi):Zi?dn(Gi):gi(Gi)},Hi=function(Gi,Zi){if(!Zi)return Or(Pr(Gi));if(Gi==="")return"";if(!/^[A-Z2-7=]+$/.test(Gi))throw new Error("Invalid base32 characters");var Xi,Ki,ea,Ji,ta,na,ra,ia,oa="",ua=Gi.indexOf("=");ua===-1&&(ua=Gi.length);for(var sa=0,aa=ua>>3<<3;sa<aa;)Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ta=_t[Gi.charAt(sa++)],na=_t[Gi.charAt(sa++)],ra=_t[Gi.charAt(sa++)],ia=_t[Gi.charAt(sa++)],oa+=String.fromCharCode((Xi<<3|Ki>>>2)&255)+String.fromCharCode((Ki<<6|ea<<1|Ji>>>4)&255)+String.fromCharCode((Ji<<4|ta>>>1)&255)+String.fromCharCode((ta<<7|na<<2|ra>>>3)&255)+String.fromCharCode((ra<<5|ia)&255);var pa=ua-aa;return pa===2?(Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],oa+=String.fromCharCode((Xi<<3|Ki>>>2)&255)):pa===4?(Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],oa+=String.fromCharCode((Xi<<3|Ki>>>2)&255)+String.fromCharCode((Ki<<6|ea<<1|Ji>>>4)&255)):pa===5?(Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ta=_t[Gi.charAt(sa++)],oa+=String.fromCharCode((Xi<<3|Ki>>>2)&255)+String.fromCharCode((Ki<<6|ea<<1|Ji>>>4)&255)+String.fromCharCode((Ji<<4|ta>>>1)&255)):pa===7&&(Xi=_t[Gi.charAt(sa++)],Ki=_t[Gi.charAt(sa++)],ea=_t[Gi.charAt(sa++)],Ji=_t[Gi.charAt(sa++)],ta=_t[Gi.charAt(sa++)],na=_t[Gi.charAt(sa++)],ra=_t[Gi.charAt(sa++)],oa+=String.fromCharCode((Xi<<3|Ki>>>2)&255)+String.fromCharCode((Ki<<6|ea<<1|Ji>>>4)&255)+String.fromCharCode((Ji<<4|ta>>>1)&255)+String.fromCharCode((ta<<7|na<<2|ra>>>3)&255)),oa},Qi={encode:zi,decode:Hi};Hi.asBytes=Pr,J?D.exports=Qi:E.base32=Qi})()})(base32$1)),base32$1.exports}requireBase32();const{gcd,lcm}=Context.math,{mod}=Context.math,{dopri}=Context.math,DEFAULT_MATH_INPUT_FUNCTION_NAMES=["arg","deg","det","dim","exp","gcd","hom","ker","lg","lim","ln","log","max","min","Pr","cos","cosh","acos","acosh","arccos","arccosh","cot","coth","acot","acoth","arccot","arccoth","csc","csch","acsc","acsch","arccsc","arccsch","sec","sech","asec","asech","arcsec","arcsech","sin","sinh","asin","asinh","arcsin","arcsinh","tan","tanh","atan","atanh","arctan","arctanh","nPr","nCr"];function isValidMathQuillFunctionName(D){if(!/^[a-z|-]+$/i.test(D))return!1;const E=D.split("|");return!(E.length>2||E[0].length<2)}function buildEffectiveMathInputFunctionNames({additional:D=[],removed:E=[],reset:F=null}){if(F!==null){const mr=new Set,Or=[],Pr=[];for(const dn of F)if(!mr.has(dn)){if(mr.add(dn),!isValidMathQuillFunctionName(dn)){Pr.push(dn);continue}Or.push(dn)}return{names:Or,droppedFromAdditional:[],droppedFromReset:Pr}}const J=new Set(E),$e=new Set,_t=[];for(const mr of DEFAULT_MATH_INPUT_FUNCTION_NAMES)J.has(mr)||$e.has(mr)||($e.add(mr),_t.push(mr));const lr=[];for(const mr of D)if(!(J.has(mr)||$e.has(mr))){if($e.add(mr),!isValidMathQuillFunctionName(mr)){lr.push(mr);continue}_t.push(mr)}return{names:_t,droppedFromAdditional:lr,droppedFromReset:[]}}const defaultCreativeCommonsVersion="4.0";function creativeCommonsLicense(D,E,F,J){return{code:D,name:`Creative Commons ${E}`,description:J,kind:"creative-commons",url:($e=defaultCreativeCommonsVersion)=>`https://creativecommons.org/licenses/${F}/${$e}/`}}function fixedUrlLicense(D,E,F,J,$e){return{code:D,name:E,description:J,kind:$e,url:()=>F}}const mediaLicenses=[creativeCommonsLicense("CC-BY","Attribution","by","Creative Commons Attribution: reuse with credit, including commercially."),creativeCommonsLicense("CC-BY-SA","Attribution-ShareAlike","by-sa","Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license."),creativeCommonsLicense("CC-BY-ND","Attribution-NoDerivatives","by-nd","Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit."),creativeCommonsLicense("CC-BY-NC","Attribution-NonCommercial","by-nc","Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes."),creativeCommonsLicense("CC-BY-NC-SA","Attribution-NonCommercial-ShareAlike","by-nc-sa","Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license."),creativeCommonsLicense("CC-BY-NC-ND","Attribution-NonCommercial-NoDerivatives","by-nc-nd","Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit."),fixedUrlLicense("CC0","CC0 1.0 Public Domain Dedication","https://creativecommons.org/publicdomain/zero/1.0/","Creative Commons Zero: the creator has dedicated the work to the public domain.","public-domain"),fixedUrlLicense("PDM","Public Domain Mark 1.0","https://creativecommons.org/publicdomain/mark/1.0/","Public Domain Mark: the work is free of known copyright restrictions.","public-domain"),fixedUrlLicense("GFDL","GNU Free Documentation License","https://www.gnu.org/licenses/fdl-1.3.html","GNU Free Documentation License: copyleft license common on Wikimedia.","license"),fixedUrlLicense("FAL","Free Art License 1.3","https://artlibre.org/licence/lal/en/","Free Art License: copyleft license for artistic works.","license"),fixedUrlLicense("OGL","Open Government Licence v3.0 (UK)","https://www.nationalarchives.gov.uk/doc/open-government-licence/version/3/","UK Open Government Licence: reuse government material with attribution.","license"),fixedUrlLicense("MIT","MIT License","https://opensource.org/license/mit","MIT License: permissive license common for icon and illustration sets.","license"),fixedUrlLicense("APACHE-2.0","Apache License 2.0","https://www.apache.org/licenses/LICENSE-2.0","Apache License 2.0: permissive license common for icon and illustration sets.","license")];Object.fromEntries(mediaLicenses.map(D=>[D.code.toLowerCase(),D]));var cssesc_1,hasRequiredCssesc;function requireCssesc(){if(hasRequiredCssesc)return cssesc_1;hasRequiredCssesc=1;var D={},E=D.hasOwnProperty,F=function(Or,Pr){if(!Or)return Pr;var dn={};for(var gi in Pr)dn[gi]=E.call(Or,gi)?Or[gi]:Pr[gi];return dn},J=/[ -,\\.\\/:-@\\[-\\^`\\{-~]/,$e=/[ -,\\.\\/:-@\\[\\]\\^`\\{-~]/,_t=/(^|\\\\+)?(\\\\[A-F0-9]{1,6})\\x20(?![a-fA-F0-9\\x20])/g,lr=function mr(Or,Pr){Pr=F(Pr,mr.options),Pr.quotes!="single"&&Pr.quotes!="double"&&(Pr.quotes="single");for(var dn=Pr.quotes=="double"?\'"\':"\'",gi=Pr.isIdentifier,qi=Or.charAt(0),zi="",Hi=0,Qi=Or.length;Hi<Qi;){var Gi=Or.charAt(Hi++),Zi=Gi.charCodeAt(),Xi=void 0;if(Zi<32||Zi>126){if(Zi>=55296&&Zi<=56319&&Hi<Qi){var Ki=Or.charCodeAt(Hi++);(Ki&64512)==56320?Zi=((Zi&1023)<<10)+(Ki&1023)+65536:Hi--}Xi="\\\\"+Zi.toString(16).toUpperCase()+" "}else Pr.escapeEverything?J.test(Gi)?Xi="\\\\"+Gi:Xi="\\\\"+Zi.toString(16).toUpperCase()+" ":/[\\t\\n\\f\\r\\x0B]/.test(Gi)?Xi="\\\\"+Zi.toString(16).toUpperCase()+" ":Gi=="\\\\"||!gi&&(Gi==\'"\'&&dn==Gi||Gi=="\'"&&dn==Gi)||gi&&$e.test(Gi)?Xi="\\\\"+Gi:Xi=Gi;zi+=Xi}return gi&&(/^-[-\\d]/.test(zi)?zi="\\\\-"+zi.slice(1):/\\d/.test(qi)&&(zi="\\\\3"+qi+" "+zi.slice(1))),zi=zi.replace(_t,function(ea,Ji,ta){return Ji&&Ji.length%2?ea:(Ji||"")+ta}),!gi&&Pr.wrap?dn+zi+dn:zi};return lr.options={escapeEverything:!1,isIdentifier:!1,quotes:"single",wrap:!1},lr.version="3.0.0",cssesc_1=lr,cssesc_1}requireCssesc();const STYLE_ATTRIBUTE_KEY_BY_LOWER=new Map(Object.keys(styleAttributes).map(D=>[D.toLowerCase(),D]));function isStyleAttributeName(D){return STYLE_ATTRIBUTE_KEY_BY_LOWER.has(D.toLowerCase())}const STYLE_KEY_PREFIXES=coloredItemsForWords,STYLE_KEY_PREFIXES_LOWER=STYLE_KEY_PREFIXES.map(D=>[D.toLowerCase(),D]);function stylePrefixOfKey(D){const E=D.toLowerCase();for(const[F,J]of STYLE_KEY_PREFIXES_LOWER)if(E.startsWith(F))return J}function detectStylePrefixesFromAttributes(D){const E=new Set;for(const F of D){const J=canonicalStyleAttributeKey(F);if(J===void 0)continue;const $e=stylePrefixOfKey(J);$e!==void 0&&E.add($e)}return E}function relevantStyleKeysForPrefixes(D){if(D.size===0)return[];const E=[];for(const F of Object.keys(styleAttributes)){const J=stylePrefixOfKey(F);J!==void 0&&D.has(J)&&E.push(F)}return E}function canonicalStyleAttributeKey(D){return STYLE_ATTRIBUTE_KEY_BY_LOWER.get(D.toLowerCase())}const COLOR_ATTRIBUTE_KEYS=new Set(coloredItemsForWords.flatMap(D=>[`${D}Color`,`${D}ColorDarkMode`]));function isColorAttributeKey(D){return COLOR_ATTRIBUTE_KEYS.has(D)}function readAttributeText(D,E){const F=E.toLowerCase(),J=Object.keys(D.attributes).find(lr=>lr.toLowerCase()===F);if(J===void 0)return;const $e=D.attributes[J];if(!$e)return;const _t=toXml($e.children).trim();return _t.length>0?_t:void 0}function parseStyleNumberAttribute(D){const E=readAttributeText(D,"styleNumber");if(E===void 0)return;const F=Number(E);if(!Number.isFinite(F))return;const J=Math.trunc(F);return J>=1?J:void 0}function resolveActiveStyleNumber(D,E){if(E.name==="styleDefinition")return parseStyleNumberAttribute(E)??1;let F=E;for(;F&&F.type==="element";){const J=parseStyleNumberAttribute(F);if(J!==void 0)return J;F=D.getParent(F)}return 1}function ancestorChainRootToLeaf(D,E){return D.getParents(E).slice().reverse()}function findOwnedStyleDefinitions(D){const E=[];for(const F of D.children)if(F.type==="element"){if(F.name==="styleDefinition"){E.push(F);continue}if(F.name==="setup"){for(const J of F.children)if(J.type==="element"){if(J.name==="styleDefinition")E.push(J);else if(J.name==="styleDefinitions")for(const $e of J.children)$e.type==="element"&&$e.name==="styleDefinition"&&E.push($e)}}}return E}function parseStyleAttributeText(D,E,F){const J=F[D];if(J)switch(J.componentType){case"number":case"integer":{const $e=Number(E);return Number.isFinite($e)?$e:void 0}case"boolean":{const $e=E.trim().toLowerCase();return $e==="true"?!0:$e==="false"?!1:void 0}default:return E.toLowerCase()}}function buildStyleDefinitionBlock(D,E){const F={},J=E?.toLowerCase();for(const $e of Object.keys(D.attributes)){if(J!==void 0&&$e.toLowerCase()===J)continue;const _t=canonicalStyleAttributeKey($e);if(_t===void 0)continue;const lr=readAttributeText(D,$e);if(lr===void 0)continue;const mr=parseStyleAttributeText(_t,lr,styleAttributes);mr!==void 0&&setStyleValue(F,_t,mr)}return addMissingChildStyleColorFields(F),deriveMissingStyleWords(F),F}function mergeBlockInto(D,E){Object.assign(D,unwrapStyleDefinition(E))}let _builtInPresetsCache;function builtInPresets(){if(_builtInPresetsCache)return _builtInPresetsCache;const D=returnDefaultStyleDefinitions(),E=new Map;for(const[F,J]of Object.entries(D))E.set(Number(F),Object.freeze(unwrapStyleDefinition(J)));return _builtInPresetsCache=E,E}function seedStyleDefinition(D){const E=builtInPresets().get(D);return E?{...E}:{...DEFAULT_STYLE_VALUES}}function resolveActiveStyle(D,E,F={}){const J=resolveActiveStyleNumber(D,E),$e=seedStyleDefinition(J);for(const _t of ancestorChainRootToLeaf(D,E))for(const lr of findOwnedStyleDefinitions(_t)){if((parseStyleNumberAttribute(lr)??1)!==J)continue;const Or=F.excludeAttribute&&lr===F.excludeAttribute.node?F.excludeAttribute.attributeName:void 0,Pr=buildStyleDefinitionBlock(lr,Or);mergeBlockInto($e,Pr)}return{styleNumber:J,style:resolveStyleDefinition($e)}}function resolveActiveStyleAttributeValue(D,E,F,J={}){const $e=canonicalStyleAttributeKey(F);if($e===void 0)return;const _t=resolveActiveStyle(D,E,J);return materializeAttributeValue($e,_t)}function materializeAttributeValue(D,E){const F=E.style[D];if(F===void 0)return;const J={value:F,styleNumber:E.styleNumber};if(isColorAttributeKey(D)&&typeof F=="string"){const $e=colorValueToWord(F);$e&&$e.toLowerCase()!==F.toLowerCase()&&(J.colorWord=$e)}return J}function resolveActiveStyleBreakdown(D,E,F={}){const J=resolveActiveStyle(D,E),$e=F.includeKeys?new Set(F.includeKeys):void 0,_t=[];for(const lr of Object.keys(styleAttributes)){if($e&&!$e.has(lr))continue;const mr=materializeAttributeValue(lr,J);if(!mr)continue;const Or={key:lr,value:mr.value};mr.colorWord!==void 0&&(Or.colorWord=mr.colorWord),_t.push(Or)}return{styleNumber:J.styleNumber,entries:_t}}const NONE$1={kind:"none"},MAX_SUGGESTIONS=6;function suggestionsHelp(D,E){const F=E?{elementName:E.name}:{topLevel:!0},J=E?E.name:"document",$e=E?D.sourceObj.getParentElementName(E):void 0,lr=rankedChildSuggestions(D,J,$e).filter(Pr=>Pr.kind==="element").slice(0,MAX_SUGGESTIONS).map(Pr=>{const dn=D.findSchemaElement(Pr.name);return{name:dn?.name??Pr.name,summary:dn?.summary??null,docsSlug:dn?.docsSlug??null}}),mr=D._getAllowedChildren(J,$e).length,Or=D._getAcceptsStringChildren(J,$e);return{kind:"suggestions",context:F,suggested:lr,totalAllowed:mr,acceptsStringChildren:Or}}function findSchemaAttribute(D,E){const F=E.toLowerCase();return D.attributes.find(J=>J.name.toLowerCase()===F)}function findSchemaProperty(D,E){const F=E.toLowerCase();return D.properties?.find(J=>J.name.toLowerCase()===F)}function augmentWithPerInstanceAttributes(D,E){return!D||!E||E.size===0?D:{...D,attributes:mergeDeclaredIntoSchemaAttributes(D.attributes,E)}}function resolveEntriesForNode(D,E){const F=D.findSchemaElement(E.name),J=D.resolveEffectiveSchemaElement(F,D.sourceObj.getParentElementName(E));return[F,J]}function resolveEntriesForContainer(D,E){const[F,J]=resolveEntriesForNode(D,E);return!F||!J?null:{ownEntry:F,effectiveEntry:J}}async function computeContextHelp(D,E,F){await D._refreshModuleInstanceAttributes();const{node:J,cursorPosition:$e}=D.sourceObj.elementAtOffsetWithContext(E),_t=F??D.getCompletionContext(E);if(_t.cursorPos==="refName"||_t.cursorPos==="refMember")return await helpForReferenceUnit(D,E,_t);if(J){const[lr,mr]=resolveEntriesForNode(D,J);if($e==="openTagName"||$e==="closeTagName")return helpForElement(lr,mr,{completer:D,node:J});if($e==="attributeName"||$e==="attributeValue"||$e==="openTag"||$e==="unknown"){const Or=D.sourceObj.attributeAtOffset(E);if(Or){const Pr=augmentWithPerInstanceAttributes(mr,D._moduleInstanceAttributeAllowlist.get(J)),dn=helpForAttribute(lr,Pr,Or.name,{completer:D,node:J});return dn.kind!=="none"?dn:helpForElement(lr,mr,{completer:D,node:J})}if($e==="openTag")return helpForElement(lr,mr,{completer:D,node:J})}}return _t.cursorPos==="body"?suggestionsHelp(D,J):NONE$1}const MACRO_PATH_CHAR_REGEX=/[A-Za-z0-9_.[\\]]/;function macroEndOffset(D,E){const F=D.source,J=F.charAt(E-1);let $e=D.sourceObj.nodeAtOffset(E,{type:"macro",side:"left"})??D.sourceObj.nodeAtOffset(E,{type:"macro",side:"right"});if(!$e&&(J==="."||J==="[")&&($e=D.sourceObj.nodeAtOffset(E-1,{type:"macro",side:"left"})),$e?.position?.end?.offset!==void 0)return $e.position.end.offset;let _t=E;for(;_t<F.length&&MACRO_PATH_CHAR_REGEX.test(F.charAt(_t));)_t++;return _t>E?_t:void 0}async function helpForReferenceUnit(D,E,F){let J=F,$e=E;const _t=macroEndOffset(D,E);if(_t!==void 0&&_t!==E){const lr=D.getCompletionContext(_t);(lr.cursorPos==="refName"||lr.cursorPos==="refMember")&&(J=lr,$e=_t)}return J.cursorPos==="refMember"?await helpForRefMember(D,$e,J):J.cursorPos==="refName"?await helpForRefName(D,$e,J):NONE$1}const SIMPLE_IDENT_CHAR_REGEX=/[A-Za-z0-9_]/,MACRO_IDENT_CHAR_REGEX=/[A-Za-z0-9_-]/;function fullIdentifierAtOffset(D,E,F,J=!1){const $e=J?MACRO_IDENT_CHAR_REGEX:SIMPLE_IDENT_CHAR_REGEX;let _t=F;for(;_t<D.length&&$e.test(D.charAt(_t));)_t++;return D.slice(E,_t)}function isParenthesizedSegment(D,E){return D.charAt(E-1)==="("}const SIMPLE_IDENT_REGEX=/^[A-Za-z_][A-Za-z0-9_]*$/,BRACKET_INDEX_SUFFIX_REGEX=/(\\[[^\\]]*\\])*$/,BRACKET_INDEX_ALL_REGEX=/\\[[^\\]]*\\]/g;function countBracketIndices(D){return D?D.match(BRACKET_INDEX_ALL_REGEX)?.length??0:0}function formatPathSegment(D){const E=D.match(BRACKET_INDEX_SUFFIX_REGEX)?.[0]??"",F=D.slice(0,D.length-E.length);return SIMPLE_IDENT_REGEX.test(F)?D:`(${F})${E}`}function computeStyleBreakdownForElement(D,E){if(!E||D.name!=="styleDefinition")return;const F=resolveActiveStyleBreakdown(E.completer.sourceObj,E.node);if(F.entries.length!==0)return F}function helpForElement(D,E,F){if(!D||!E?.summary)return NONE$1;const J=computeStyleBreakdownForElement(D,F);return{kind:"element",elementName:D.name,summary:E.summary,docsSlug:E.docsSlug??null,...J?{styleBreakdown:J}:{}}}function computeActiveDefaultForAttribute(D,E){if(!E||!isStyleAttributeName(D.name))return;const F=E.node.name==="styleDefinition",J=resolveActiveStyleAttributeValue(E.completer.sourceObj,E.node,D.name,F?{excludeAttribute:{node:E.node,attributeName:D.name}}:void 0);if(!J)return;const $e=D.defaultValue;if((typeof $e=="string"||typeof $e=="number"||typeof $e=="boolean")&&J.value===$e)return;const _t={value:J.value,styleNumber:J.styleNumber};return J.colorWord!==void 0&&(_t.colorWord=J.colorWord),_t}function computeStyleBreakdownForAttribute(D,E,F,J){if(!J)return;const $e=D==="styleDefinition",_t=F.name==="styleNumber";if(!$e&&!_t)return;const lr=$e?void 0:relevantStyleKeysForPrefixes(detectStylePrefixesFromAttributes(E.attributes.map(Or=>Or.name)));if(lr&&lr.length===0)return;const mr=resolveActiveStyleBreakdown(J.completer.sourceObj,J.node,lr?{includeKeys:lr}:void 0);if(mr.entries.length!==0)return mr}const MATH_INPUT_FUNCTION_NAME_ATTRS=new Set(["additionalfunctionnames","removedfunctionnames","resetfunctionnames"]);function readTextListAttribute(D,E){const F=getElementAttributeValue(D,E);if(F===void 0)return[];const J=new Set,$e=[];for(const _t of F.split(/\\s+/))_t.length===0||J.has(_t)||(J.add(_t),$e.push(_t));return $e}function computeFunctionNamesBreakdownForAttribute(D,E,F){if(!F||D!=="mathInput"||!MATH_INPUT_FUNCTION_NAME_ATTRS.has(E.name.toLowerCase()))return;const J=readTextListAttribute(F.node,"additionalFunctionNames"),$e=readTextListAttribute(F.node,"removedFunctionNames"),lr=findAttributeKey(F.node,"resetFunctionNames")!==void 0?readTextListAttribute(F.node,"resetFunctionNames"):null,{names:mr}=buildEffectiveMathInputFunctionNames({additional:J,removed:$e,reset:lr});return{names:mr,added:J,removed:$e,...lr!==null?{reset:lr}:{}}}function helpForAttribute(D,E,F,J){if(!D||!E)return NONE$1;const $e=findSchemaAttribute(E,F);if(!$e?.description)return NONE$1;const _t=computeActiveDefaultForAttribute($e,J),lr=computeStyleBreakdownForAttribute(D.name,E,$e,J),mr=computeFunctionNamesBreakdownForAttribute(D.name,$e,J);return{kind:"attribute",elementName:D.name,attributeName:$e.name,description:$e.description,docsSlug:E.docsSlug??null,allowedValues:$e.autocompleteValues,allowedValuesArePerItem:$e.isList,defaultValue:$e.defaultValue,..._t?{activeDefault:_t}:{},...lr?{styleBreakdown:lr}:{},...mr?{functionNamesBreakdown:mr}:{}}}function tryArrayEntryHelp(D,E,F,J,$e){if(!E||F.length===0)return null;const _t=F[0],lr=resolveEntriesForContainer(D,E);if(!lr)return null;const{ownEntry:mr,effectiveEntry:Or}=lr,Pr=Or.properties?.find(Hi=>Hi.name.toLowerCase()===_t.toLowerCase());if(!Pr)return null;const dn=J.pathParts.length-1-F.length;if(dn<0)return null;const gi=[{name:_t,numIndices:countBracketIndices(J.rawPathParts[dn])}];for(let Hi=1;Hi<F.length;Hi++)gi.push({name:F[Hi],numIndices:countBracketIndices(J.rawPathParts[dn+Hi])});gi.push({name:$e,numIndices:countBracketIndices(J.rawPathParts[J.pathParts.length-1])});const qi=chaseIndexAliases(Pr,gi);if(!qi)return null;const zi=J.rawPathParts.slice(dn).map(formatPathSegment).join(".");return{kind:"arrayEntry",elementName:mr.name,arrayName:Pr.name,aliasPath:qi.aliasPath,displayTail:zi,description:Pr.description??"",leafType:deepestArrayEntryType(Pr),docsSlug:Or.docsSlug??null}}async function helpForRefMember(D,E,F){const J=fullIdentifierAtOffset(D.source,F.replaceFromOffset,E,isParenthesizedSegment(D.source,F.replaceFromOffset));return J?await helpForRefMemberByName(D,E,F,J):NONE$1}function buildMemberDisplayPath(D,E){return[...D.slice(0,-1).map(formatPathSegment),formatPathSegment(E)].join(".")}async function unresolvedRefForChain(D,E,F){const J=await D.classifyReference(E,F.pathParts);return J!=="notFound"&&J!=="multiple"?null:{kind:"unresolvedRef",displayPath:F.rawPathParts.map(formatPathSegment).join("."),reason:J}}async function helpForRefMemberByName(D,E,F,J){const $e=await D.resolveRefMemberContainerAtOffset(E,F.pathParts,F.pathPartHasIndex),_t=$e.node;if(!_t){const Hi=tryArrayEntryHelp(D,$e.partiallyResolvedNode??null,$e.unresolvedPathParts,F,J);if(Hi)return Hi;const Qi=await unresolvedRefForChain(D,E,F);return Qi||(F.pathParts.length>2?{kind:"unsupportedRefChain"}:NONE$1)}const lr=$e.visibleDescendantNames.includes(J)?D.resolveRefMemberDescendantHelp(_t,J):null;if(lr)return{kind:"refName",refName:J,displayPath:buildMemberDisplayPath(F.rawPathParts,J),targetElementName:lr.referent.name,line:lr.line};const mr=D.resolveDerivedRepeatNameOnElement(_t,J);if(mr)return{kind:"refName",refName:J,displayPath:buildMemberDisplayPath(F.rawPathParts,J),targetElementName:_t.name,line:mr.line,derivedFrom:{role:mr.role,ownerElementName:_t.name,ownerLine:mr.line}};const Or=resolveEntriesForContainer(D,_t);if(!Or)return NONE$1;const{ownEntry:Pr,effectiveEntry:dn}=Or,gi=findSchemaProperty(dn,J);if(!gi?.description){const Hi=await unresolvedRefForChain(D,E,F);return Hi||NONE$1}const qi={kind:"property",elementName:Pr.name,propertyName:gi.name,description:gi.description,displayPath:buildMemberDisplayPath(F.rawPathParts,J),isArray:gi.isArray??!1};gi.type!==void 0&&(qi.type=gi.type);const zi=elementStartLine(D,_t);return zi!==void 0&&(qi.line=zi),qi}function elementStartLine(D,E){const F=E.position?.start.offset;if(!(F==null||F>=D.source.length))return D.sourceObj.offsetToRowCol(F).line}async function helpForRefName(D,E,F){const J=fullIdentifierAtOffset(D.source,F.replaceFromOffset,E,isParenthesizedSegment(D.source,F.replaceFromOffset));return J?await helpForRefNameByName(D,E,J):NONE$1}async function helpForRefNameByName(D,E,F){const J=D.resolveRefNameForHelp(E,F);if(J){const{referent:lr,line:mr}=J;return{kind:"refName",refName:F,displayPath:formatPathSegment(F),targetElementName:lr.name,line:mr}}const $e=D.resolveDerivedRepeatNameForHelp(E,F);if($e)return{kind:"refName",refName:F,displayPath:formatPathSegment(F),targetElementName:$e.owner.name,line:$e.line,derivedFrom:{role:$e.role,ownerElementName:$e.owner.name,ownerLine:$e.line}};const _t=await D.classifyReference(E,[F]);return _t==="found"?NONE$1:{kind:"unresolvedRef",displayPath:formatPathSegment(F),reason:_t}}function helpForSnippet(D,E){const F=D.findSnippet(E);return F?{kind:"snippet",snippetKey:F.key,elementName:F.element,description:F.description,snippetText:F.snippet}:NONE$1}async function computeContextHelpForCompletion(D,E,F,J){const $e=F.label;if(!$e)return NONE$1;const _t=F.type;if(_t===COMPLETION_TYPES.snippet)return helpForSnippet(D,$e);await D._refreshModuleInstanceAttributes();const lr=()=>J??D.getCompletionContext(E);if(_t===COMPLETION_TYPES.reference){let mr=$e.startsWith("$")?$e.slice(1):$e;mr.endsWith("[]")&&(mr=mr.slice(0,-2));const Or=lr();return Or.cursorPos==="refMember"?await helpForRefMemberByName(D,E,Or,mr):await helpForRefNameByName(D,E,mr)}if(_t===COMPLETION_TYPES.component||_t===COMPLETION_TYPES.referenceProperty||_t===COMPLETION_TYPES.closeTag||_t==="property"){const mr=lr();if(mr.cursorPos==="refMember")return await helpForRefMemberByName(D,E,mr,$e);if($e.startsWith("/")){const{node:dn}=D.sourceObj.elementAtOffsetWithContext(E);if(!dn)return NONE$1;const[gi,qi]=resolveEntriesForNode(D,dn);return helpForElement(gi,qi,{completer:D,node:dn})}const Or=D.findSchemaElement($e);if(!Or)return NONE$1;const Pr=D.resolveEffectiveSchemaElement(Or,void 0)??Or;return helpForElement(Or,Pr)}if(_t===COMPLETION_TYPES.attributeName){const{node:mr}=D.sourceObj.elementAtOffsetWithContext(E);if(!mr)return NONE$1;const[Or,Pr]=resolveEntriesForNode(D,mr),dn=augmentWithPerInstanceAttributes(Pr,D._moduleInstanceAttributeAllowlist.get(mr)),gi=helpForAttribute(Or,dn,$e,{completer:D,node:mr});return gi.kind!=="none"?gi:helpForElement(Or,Pr,{completer:D,node:mr})}if(_t===COMPLETION_TYPES.attributeValue){const{node:mr}=D.sourceObj.elementAtOffsetWithContext(E);if(!mr)return NONE$1;const[Or,Pr]=resolveEntriesForNode(D,mr),dn=augmentWithPerInstanceAttributes(Pr,D._moduleInstanceAttributeAllowlist.get(mr)),gi=D.sourceObj.attributeAtOffset(E);if(gi){const qi=helpForAttribute(Or,dn,gi.name,{completer:D,node:mr});if(qi.kind!=="none")return qi}return helpForElement(Or,Pr,{completer:D,node:mr})}return NONE$1}const DOENET_LSP_METHODS={setAdditionalDiagnostics:"doenet/setAdditionalDiagnostics",contextHelp:"doenet/contextHelp",contextHelpForCompletion:"doenet/contextHelpForCompletion"};function dedupeLspDiagnostics(D){const E=new Map,F=[];for(const J of D){const $e=diagnosticKey(J),_t=E.get($e);if(_t!==void 0){F[_t]=mergeMissingFields(F[_t],J);continue}E.set($e,F.length),F.push(J)}return F}function diagnosticKey(D){const E=D.severity??"?",F=D.range.start,J=D.range.end;return`${E}|${F.line}:${F.character}-${J.line}:${J.character}|${D.message}`}const MERGEABLE_FIELDS=["code","codeDescription","source","tags","relatedInformation","data"];function mergeMissingFields(D,E){let F=null;for(const J of MERGEABLE_FIELDS)D[J]===void 0&&E[J]!==void 0&&(F===null&&(F={...D}),F[J]=E[J]);return F??D}function addDocumentFormattingSupport(D,E){D.onDocumentFormatting(async F=>{const J=await getDocumentSettings(D,F.textDocument.uri),$e=E.get(F.textDocument.uri);if(!$e)return[];const _t=$e.autoCompleter.sourceObj,lr=_t.dast.position;return[{newText:await prettyPrint(_t.source,{tabWidth:F.options.tabSize,useTabs:!F.options.insertSpaces,doenetSyntax:J.formatMode!=="xml"}),range:{start:_t.offsetToLSPPosition(0),end:_t.offsetToLSPPosition(lr.end.offset)}}]}),D.onRequest("doenet.formatAsXML",async F=>{const J=E.get(F);if(!J)return D.console.log(`Could not find document ${F}`),[];const $e=J.autoCompleter.sourceObj,_t=$e.dast.position;return[{newText:await prettyPrint($e.source,{doenetSyntax:!1}),range:{start:$e.offsetToLSPPosition(0),end:$e.offsetToLSPPosition(_t.end.offset)}}]}),D.onRequest("doenet.formatAsDoenetML",async F=>{const J=E.get(F);if(!J)return D.console.log(`Could not find document ${F}`),[];const $e=J.autoCompleter.sourceObj,_t=$e.dast.position;return[{newText:await prettyPrint($e.source,{doenetSyntax:!0}),range:{start:$e.offsetToLSPPosition(0),end:$e.offsetToLSPPosition(_t.end.offset)}}]}),D.onRequest("doenet.formatAsMarkdown",async F=>{const J=E.get(F);if(!J)return D.console.log(`Could not find document ${F}`),[];const $e=J.autoCompleter.sourceObj,_t=$e.dast.position;return[{newText:doenetToMarkdown($e),range:{start:$e.offsetToLSPPosition(0),end:$e.offsetToLSPPosition(_t.end.offset)}}]})}const proxyMarker=Symbol("Comlink.proxy"),createEndpoint=Symbol("Comlink.endpoint"),releaseProxy=Symbol("Comlink.releaseProxy"),finalizer=Symbol("Comlink.finalizer"),throwMarker=Symbol("Comlink.thrown"),isObject=D=>typeof D=="object"&&D!==null||typeof D=="function",proxyTransferHandler={canHandle:D=>isObject(D)&&D[proxyMarker],serialize(D){const{port1:E,port2:F}=new MessageChannel;return expose(D,E),[F,[F]]},deserialize(D){return D.start(),wrap(D)}},throwTransferHandler={canHandle:D=>isObject(D)&&throwMarker in D,serialize({value:D}){let E;return D instanceof Error?E={isError:!0,value:{message:D.message,name:D.name,stack:D.stack}}:E={isError:!1,value:D},[E,[]]},deserialize(D){throw D.isError?Object.assign(new Error(D.value.message),D.value):D.value}},transferHandlers=new Map([["proxy",proxyTransferHandler],["throw",throwTransferHandler]]);function isAllowedOrigin(D,E){for(const F of D)if(E===F||F==="*"||F instanceof RegExp&&F.test(E))return!0;return!1}function expose(D,E=globalThis,F=["*"]){E.addEventListener("message",function J($e){if(!$e||!$e.data)return;if(!isAllowedOrigin(F,$e.origin)){console.warn(`Invalid origin \'${$e.origin}\' for comlink proxy`);return}const{id:_t,type:lr,path:mr}=Object.assign({path:[]},$e.data),Or=($e.data.argumentList||[]).map(fromWireValue);let Pr;try{const dn=mr.slice(0,-1).reduce((qi,zi)=>qi[zi],D),gi=mr.reduce((qi,zi)=>qi[zi],D);switch(lr){case"GET":Pr=gi;break;case"SET":dn[mr.slice(-1)[0]]=fromWireValue($e.data.value),Pr=!0;break;case"APPLY":Pr=gi.apply(dn,Or);break;case"CONSTRUCT":{const qi=new gi(...Or);Pr=proxy(qi)}break;case"ENDPOINT":{const{port1:qi,port2:zi}=new MessageChannel;expose(D,zi),Pr=transfer(qi,[qi])}break;case"RELEASE":Pr=void 0;break;default:return}}catch(dn){Pr={value:dn,[throwMarker]:0}}Promise.resolve(Pr).catch(dn=>({value:dn,[throwMarker]:0})).then(dn=>{const[gi,qi]=toWireValue(dn);E.postMessage(Object.assign(Object.assign({},gi),{id:_t}),qi),lr==="RELEASE"&&(E.removeEventListener("message",J),closeEndPoint(E),finalizer in D&&typeof D[finalizer]=="function"&&D[finalizer]())}).catch(dn=>{const[gi,qi]=toWireValue({value:new TypeError("Unserializable return value"),[throwMarker]:0});E.postMessage(Object.assign(Object.assign({},gi),{id:_t}),qi)})}),E.start&&E.start()}function isMessagePort(D){return D.constructor.name==="MessagePort"}function closeEndPoint(D){isMessagePort(D)&&D.close()}function wrap(D,E){const F=new Map;return D.addEventListener("message",function($e){const{data:_t}=$e;if(!_t||!_t.id)return;const lr=F.get(_t.id);if(lr)try{lr(_t)}finally{F.delete(_t.id)}}),createProxy(D,F,[],E)}function throwIfProxyReleased(D){if(D)throw new Error("Proxy has been released and is not useable")}function releaseEndpoint(D){return requestResponseMessage(D,new Map,{type:"RELEASE"}).then(()=>{closeEndPoint(D)})}const proxyCounter=new WeakMap,proxyFinalizers="FinalizationRegistry"in globalThis&&new FinalizationRegistry(D=>{const E=(proxyCounter.get(D)||0)-1;proxyCounter.set(D,E),E===0&&releaseEndpoint(D)});function registerProxy(D,E){const F=(proxyCounter.get(E)||0)+1;proxyCounter.set(E,F),proxyFinalizers&&proxyFinalizers.register(D,E,D)}function unregisterProxy(D){proxyFinalizers&&proxyFinalizers.unregister(D)}function createProxy(D,E,F=[],J=function(){}){let $e=!1;const _t=new Proxy(J,{get(lr,mr){if(throwIfProxyReleased($e),mr===releaseProxy)return()=>{unregisterProxy(_t),releaseEndpoint(D),E.clear(),$e=!0};if(mr==="then"){if(F.length===0)return{then:()=>_t};const Or=requestResponseMessage(D,E,{type:"GET",path:F.map(Pr=>Pr.toString())}).then(fromWireValue);return Or.then.bind(Or)}return createProxy(D,E,[...F,mr])},set(lr,mr,Or){throwIfProxyReleased($e);const[Pr,dn]=toWireValue(Or);return requestResponseMessage(D,E,{type:"SET",path:[...F,mr].map(gi=>gi.toString()),value:Pr},dn).then(fromWireValue)},apply(lr,mr,Or){throwIfProxyReleased($e);const Pr=F[F.length-1];if(Pr===createEndpoint)return requestResponseMessage(D,E,{type:"ENDPOINT"}).then(fromWireValue);if(Pr==="bind")return createProxy(D,E,F.slice(0,-1));const[dn,gi]=processArguments(Or);return requestResponseMessage(D,E,{type:"APPLY",path:F.map(qi=>qi.toString()),argumentList:dn},gi).then(fromWireValue)},construct(lr,mr){throwIfProxyReleased($e);const[Or,Pr]=processArguments(mr);return requestResponseMessage(D,E,{type:"CONSTRUCT",path:F.map(dn=>dn.toString()),argumentList:Or},Pr).then(fromWireValue)}});return registerProxy(_t,D),_t}function myFlat(D){return Array.prototype.concat.apply([],D)}function processArguments(D){const E=D.map(toWireValue);return[E.map(F=>F[0]),myFlat(E.map(F=>F[1]))]}const transferCache=new WeakMap;function transfer(D,E){return transferCache.set(D,E),D}function proxy(D){return Object.assign(D,{[proxyMarker]:!0})}function toWireValue(D){for(const[E,F]of transferHandlers)if(F.canHandle(D)){const[J,$e]=F.serialize(D);return[{type:"HANDLER",name:E,value:J},$e]}return[{type:"RAW",value:D},transferCache.get(D)||[]]}function fromWireValue(D){switch(D.type){case"HANDLER":return transferHandlers.get(D.name).deserialize(D.value);case"RAW":return D.value}}function requestResponseMessage(D,E,F,J){return new Promise($e=>{const _t=generateUUID();E.set(_t,$e),D.start&&D.start(),D.postMessage(Object.assign({id:_t},F),J)})}function generateUUID(){return new Array(4).fill(0).map(()=>Math.floor(Math.random()*Number.MAX_SAFE_INTEGER).toString(16)).join("-")}const WORKER_BOOT_TIMEOUT_MS=3e4;async function getRustCore(D){if(!D)return null;let E;try{E=new Worker(D)}catch(lr){return console.warn("Rust core worker could not be created.",lr),null}const F=wrap(E),J=F;let $e=!1;const _t=()=>{$e||($e=!0,F[releaseProxy](),E.terminate())};try{await new Promise((lr,mr)=>{const Or=setTimeout(()=>{mr(new Error("rust core worker boot timed out"))},WORKER_BOOT_TIMEOUT_MS);E.addEventListener("error",Pr=>{clearTimeout(Or),mr(new Error(Pr.message||"rust core worker error"))},{once:!0}),F.setFlags({flags:{}}).then(()=>{clearTimeout(Or),lr()},Pr=>{clearTimeout(Or),mr(Pr)})})}catch(lr){return console.warn("Rust core worker failed to start.",lr),_t(),null}return{core:J,terminate:_t}}const TAKES_INDEX_COMPONENT_TYPES=new Set(doenetSchema.elements.filter(D=>D?.takesIndex).map(D=>D.name)),DAST_ERROR_TYPE_TO_LSP_SEVERITY={error:browserExports.DiagnosticSeverity.Error,warning:browserExports.DiagnosticSeverity.Warning,info:browserExports.DiagnosticSeverity.Information};function addValidationSupport(D,E){D.onDidChangeConfiguration(J=>{config$3.hasConfigurationCapability?documentSettings.clear():config$3.globalSettings=J.settings.doenet||defaultSettings,documents.all().forEach(F)}),D.onRequest(DOENET_LSP_METHODS.setAdditionalDiagnostics,J=>{const{uri:$e,additionalDiagnostics:_t}=J,lr=E.get($e);if(!lr)return;lr.additionalDiagnostics=_t;const mr=documents.get($e);if(!mr){D.sendDiagnostics({uri:$e,diagnostics:lr.additionalDiagnostics});return}F(mr).catch(()=>{})}),documents.onDidChangeContent(async J=>{const $e=J.document.uri;let _t=E.get($e);_t||(_t={autoCompleter:new AutoCompleter,additionalDiagnostics:[],rustState:"uninitialized"},E.set($e,_t)),_t.autoCompleter.setSource(J.document.getText()),_t.additionalDiagnostics.length=0;const lr=_t.rustAdapter?.updateSource(_t.autoCompleter.sourceObj);if(_t.rustState==="uninitialized"){_t.rustState="initializing";const mr=_t;mr.rustReady=(async()=>{let Or=null;try{Or=await getRustCore(config$3.doenetWorkerUrl);const Pr=E.get($e);if(!Pr||Pr!==mr){Or?.terminate();return}if(!Or){mr.rustState="unavailable";return}const dn=new RustResolverAdapter(mr.autoCompleter.sourceObj,{core:Or.core,takesIndexComponentTypes:TAKES_INDEX_COMPONENT_TYPES});await dn.init(),mr.rustCore=Or.core,mr.rustAdapter=dn,mr.rustCoreTerminate=Or.terminate,mr.autoCompleter.setRustResolverAdapter(dn),mr.rustState="ready";const gi=documents.get($e);gi&&await F(gi)}catch(Pr){Or?.terminate(),console.warn("Rust autocomplete unavailable; completions disabled for this document.",Pr),E.get($e)===mr&&(mr.rustState="unavailable")}})()}await F(J.document),await lr}),documents.onDidClose(J=>{E.get(J.document.uri)?.rustCoreTerminate?.(),E.delete(J.document.uri)});async function F(J){const $e=E.get(J.uri);if(!$e)return;const lr=extractDastErrors($e.autoCompleter.sourceObj.dast).map(Pr=>{const dn=DAST_ERROR_TYPE_TO_LSP_SEVERITY[Pr.error_type??"error"],gi={message:Pr.message,severity:dn,range:{start:J.positionAt(Pr.position?.start?.offset||0),end:J.positionAt(Pr.position?.end?.offset||0)}};return config$3.hasDiagnosticRelatedInformationCapability&&(gi.relatedInformation=[]),gi}),mr=await $e.autoCompleter.getSchemaViolations();lr.push(...mr),lr.push(...$e.additionalDiagnostics);const Or=dedupeLspDiagnostics(lr);D.sendDiagnostics({uri:J.uri,diagnostics:Or})}}const RUST_BOOT_WAIT_MS=5e3;function isRefCompletionContext(D){return D.cursorPos==="refName"||D.cursorPos==="refMember"}async function awaitRustBootIfInitializing(D){if(D.rustState!=="initializing"||!D.rustReady)return;let E;await Promise.race([D.rustReady,new Promise(F=>{E=setTimeout(F,RUST_BOOT_WAIT_MS)})]),clearTimeout(E)}function completionItemNeedsRefresh(D){return typeof D.label=="string"&&D.label.startsWith("/")&&D.label.endsWith(">")&&typeof D.filterText=="string"&&D.filterText.startsWith("</")&&D.textEdit!=null?!0:D.kind===browserExports.CompletionItemKind.Snippet&&typeof D.filterText=="string"&&D.filterText.startsWith("<")&&D.textEdit!=null}function shouldKeepCompletionListIncomplete(D){return D.some(completionItemNeedsRefresh)}function addDocumentCompletionSupport(D,E){D.onCompletion(async F=>{const J=E.get(F.textDocument.uri);if(!J)return[];let $e=J.autoCompleter.getCompletionContext(F.position);if(isRefCompletionContext($e)&&(await awaitRustBootIfInitializing(J),$e=J.autoCompleter.getCompletionContext(F.position)),isRefCompletionContext($e)&&(J.rustState!=="ready"||!J.rustAdapter))return[];const _t=F.context?.explicit??!1,lr=await J.autoCompleter.getCompletionItems(F.position,$e,_t);return shouldKeepCompletionListIncomplete(lr)?{isIncomplete:!0,items:lr}:lr}),D.onCompletionResolve(F=>F)}function addDocumentHoverSupport(D,E){D.onHover(F=>null)}const NONE={kind:"none"};function addContextHelpSupport(D,E){D.onRequest(DOENET_LSP_METHODS.contextHelp,async F=>{const J=E.get(F.uri);if(!J)return NONE;try{const $e=await prepareForRefContext(J,F.offset);return await computeContextHelp(J.autoCompleter,F.offset,$e)}catch($e){return D.console.warn(`${DOENET_LSP_METHODS.contextHelp} failed: ${String($e)}`),NONE}}),D.onRequest(DOENET_LSP_METHODS.contextHelpForCompletion,async F=>{const J=E.get(F.uri);if(!J)return NONE;try{const $e=await prepareForRefContext(J,F.offset);return await computeContextHelpForCompletion(J.autoCompleter,F.offset,F.completion,$e)}catch($e){return D.console.warn(`${DOENET_LSP_METHODS.contextHelpForCompletion} failed: ${String($e)}`),NONE}})}async function prepareForRefContext(D,E){let F=D.autoCompleter.getCompletionContext(E);return isRefCompletionContext(F)&&(await awaitRustBootIfInitializing(D),F=D.autoCompleter.getCompletionContext(E)),F}try{globalThis.LSP_GLOBALS={config:config$3,documentInfo,documentSettings,documents}}catch(D){console.log(D)}const messageReader=new browserExports.BrowserMessageReader(self),messageWriter=new browserExports.BrowserMessageWriter(self),connection=browserExports.createConnection(messageReader,messageWriter);connection.onInitialize(D=>{const E=D.capabilities;config$3.hasConfigurationCapability=E.workspace?.configuration||!1,config$3.hasWorkspaceFolderCapability=E.workspace?.workspaceFolders||!1,config$3.hasDiagnosticRelatedInformationCapability=E.textDocument?.publishDiagnostics?.relatedInformation||!1;const F=D.initializationOptions,J=F?.doenetWorkerUrl;typeof J=="string"&&J?config$3.doenetWorkerUrl=J:F&&typeof F=="object"&&"doenetWorkerUrl"in F&&console.warn("[DoenetML LSP] ignoring invalid initializationOptions.doenetWorkerUrl");const $e={capabilities:{textDocumentSync:{openClose:!0,change:browserExports.TextDocumentSyncKind.Incremental},completionProvider:{triggerCharacters:["<",".","$","/",\'"\',"\'","="],resolveProvider:!0},documentFormattingProvider:!0,foldingRangeProvider:!0,documentSymbolProvider:!0,hoverProvider:!0}};return config$3.hasWorkspaceFolderCapability&&($e.capabilities.workspace={workspaceFolders:{supported:!0}}),$e}),connection.onInitialized(()=>{config$3.hasConfigurationCapability&&connection.client.register(browserExports.DidChangeConfigurationNotification.type,void 0),config$3.hasWorkspaceFolderCapability&&connection.workspace.onDidChangeWorkspaceFolders(D=>{connection.console.log("Workspace folder change event received.")})}),documents.onDidClose(D=>{documentSettings.delete(D.document.uri)}),connection.onDidChangeWatchedFiles(D=>{connection.console.log("We received an file change event")}),addValidationSupport(connection,documentInfo),addFoldingRangeSupport(connection,documentInfo),addDocumentSymbolsSupport(connection,documentInfo),addDocumentFormattingSupport(connection,documentInfo),addDocumentCompletionSupport(connection,documentInfo),addDocumentHoverSupport(connection),addContextHelpSupport(connection,documentInfo),documents.listen(connection),connection.listen()})();\n//# sourceMappingURL=index.js.map\n';
var mainExports$1 = requireMain$1$1();
const createLspConnection = (conn) => {
  let capabilities;
  conn.onRequest(mainExports$1.RegistrationRequest.type, ({ registrations }) => {
    for (const { method, registerOptions } of registrations) {
      const provider = METHOD_TO_PROVIDER[method];
      if (provider)
        capabilities[provider] = registerOptions !== null && registerOptions !== void 0 ? registerOptions : true;
    }
  });
  conn.onRequest(mainExports$1.UnregistrationRequest.type, ({ unregisterations }) => {
    for (const { method } of unregisterations) {
      const provider = METHOD_TO_PROVIDER[method];
      if (provider)
        capabilities[provider] = void 0;
    }
  });
  const maybeReq = (cond, type) => (params, token) => cond() ? conn.sendRequest(type, params, token) : Promise.resolve(null);
  const maybeNotify = (cond, type) => (params) => cond() ? conn.sendNotification(type, params) : Promise.resolve();
  const notifier = (type) => (params) => conn.sendNotification(type, params);
  const onNotification = (type) => (handler) => {
    conn.onNotification(type, handler);
  };
  const hasTextDocumentWillSave = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 !== "number" && !!c2.willSave;
  };
  const hasTextDocumentWillSaveWaitUntil = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 !== "number" && !!c2.willSaveWaitUntil;
  };
  const hasTextDocumentDidSave = () => {
    var _a2;
    const c2 = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
    return typeof c2 === "number" ? c2 !== mainExports$1.TextDocumentSyncKind.None : !!c2.save;
  };
  return {
    /** Start listening. */
    listen: () => conn.listen(),
    /** Dispose connection. */
    dispose: () => conn.dispose(),
    /**
     * Send initialize request with params and store the server capability.
     */
    initialize: async (params) => {
      const result2 = await conn.sendRequest(mainExports$1.InitializeRequest.type, params);
      capabilities = result2.capabilities;
      return result2;
    },
    /** Notify that the client initialized. */
    initialized: () => (
      // Need to send empty object literal to prevent ParameterStructures error.
      conn.sendNotification(mainExports$1.InitializedNotification.type, {})
    ),
    /** Send shutdown request. */
    shutdown: () => conn.sendRequest(mainExports$1.ShutdownRequest.type),
    /** Notify exit. */
    exit: () => conn.sendNotification(mainExports$1.ExitNotification.type),
    /** Register an error handler. */
    onError: (handler) => conn.onError(([err, msg, code2]) => handler(err, msg, code2)),
    /** Register a close handler. */
    onClose: (handler) => conn.onClose(() => handler()),
    /** Register a handler for logMessage notification. */
    onLogMessage: onNotification(mainExports$1.LogMessageNotification.type),
    /**
     * Register a handler for showMessage notification.
     * The handler should display the message in the user interface.
     */
    onShowMessage: onNotification(mainExports$1.ShowMessageNotification.type),
    /** Register a handler for diagnostics notification. */
    onDiagnostics: onNotification(mainExports$1.PublishDiagnosticsNotification.type),
    /**
     * Notify newly opened text document.
     *
     * "open" means the document's truth is now managed by the client and
     * the server must not try to read the document's truth using the document's
     * uri. It doesn't necessarily mean it's presented in an editor.
     *
     * The notification must not be sent more than once without a corresponding
     * close notification sent before.
     */
    textDocumentOpened: notifier(mainExports$1.DidOpenTextDocumentNotification.type),
    /**
     * Notify the text document got closed.
     *
     * The document's truth now exists where the document's uri points to
     * and the server is allowed to read it using the document's uri.
     *
     * Requires that the text document is "open".
     */
    textDocumentClosed: notifier(mainExports$1.DidCloseTextDocumentNotification.type),
    /**
     * Notify changes to a text document.
     */
    textDocumentChanged: notifier(mainExports$1.DidChangeTextDocumentNotification.type),
    /**
     * Notify that the text document will be saved.
     */
    textDocumentWillSave: maybeNotify(hasTextDocumentWillSave, mainExports$1.WillSaveTextDocumentNotification.type),
    /**
     * Get text edits to apply before saving.
     */
    getEditsBeforeSave: maybeReq(hasTextDocumentWillSaveWaitUntil, mainExports$1.WillSaveTextDocumentWaitUntilRequest.type),
    /**
     * Notify that the text document got saved in the client.
     */
    textDocumentSaved: maybeNotify(hasTextDocumentDidSave, mainExports$1.DidSaveTextDocumentNotification.type),
    /**
     * Notify that the client's configuration changed.
     */
    configurationChanged: notifier(mainExports$1.DidChangeConfigurationNotification.type),
    /**
     * Notify that the client detected changes to files.
     */
    watchedFilesChanged: notifier(mainExports$1.DidChangeWatchedFilesNotification.type),
    /** If supported, request completion at a given text document position. */
    getCompletion: maybeReq(() => !!capabilities.completionProvider, mainExports$1.CompletionRequest.type),
    /** If supported, resolve additional information for a given completion item. */
    getCompletionItemDetails: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.completionProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.CompletionResolveRequest.type),
    /** If supported, request hover information at a given text document position. */
    getHoverInfo: maybeReq(() => !!capabilities.hoverProvider, mainExports$1.HoverRequest.type),
    /** If supported, request signature information at a given text document position. */
    getSignatureHelp: maybeReq(() => !!capabilities.signatureHelpProvider, mainExports$1.SignatureHelpRequest.type),
    /** If supported, resolve the type definition locations of a symbol at a given text document position. */
    getDeclaration: maybeReq(() => !!capabilities.declarationProvider, mainExports$1.DeclarationRequest.type),
    /** If supported, resolve the definition location of a symbol at a given text document position. */
    getDefinition: maybeReq(() => !!capabilities.definitionProvider, mainExports$1.DefinitionRequest.type),
    /** If supported, resolve the type definition locations of a symbol at a given text document position. */
    getTypeDefinition: maybeReq(() => !!capabilities.typeDefinitionProvider, mainExports$1.TypeDefinitionRequest.type),
    /** If supported, resolve the implementation locations of a symbol at a given text document position. */
    getImplementation: maybeReq(() => !!capabilities.implementationProvider, mainExports$1.ImplementationRequest.type),
    /** If supported, resolve project-wide references for the symbol denoted by the given text document position. */
    getReferences: maybeReq(() => !!capabilities.referencesProvider, mainExports$1.ReferencesRequest.type),
    /** If supported, resolve a DocumentHighlight for a given text document position. */
    getDocumentHighlight: maybeReq(() => !!capabilities.documentHighlightProvider, mainExports$1.DocumentHighlightRequest.type),
    /** If supported, list all symbols found in a given text document. */
    getDocumentSymbol: maybeReq(() => !!capabilities.documentSymbolProvider, mainExports$1.DocumentSymbolRequest.type),
    /** If supported, get commands for the given text document and range. */
    getCodeAction: maybeReq(() => !!capabilities.codeActionProvider, mainExports$1.CodeActionRequest.type),
    /** If supported, get code lens for the given text document. */
    getCodeLens: maybeReq(() => !!capabilities.codeLensProvider, mainExports$1.CodeLensRequest.type),
    /** If supported, resolve a command for a given code lens. */
    resolveCodeLens: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.codeLensProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.CodeLensResolveRequest.type),
    /** If supported, get document links. */
    getDocumentLink: maybeReq(() => !!capabilities.documentLinkProvider, mainExports$1.DocumentLinkRequest.type),
    /** If supported, resolve additional information for a given document link. */
    resolveDocumentLink: maybeReq(() => {
      var _a2;
      return !!((_a2 = capabilities.documentLinkProvider) === null || _a2 === void 0 ? void 0 : _a2.resolveProvider);
    }, mainExports$1.DocumentLinkResolveRequest.type),
    /** If supported, list all color symbols found in a given text document. */
    getColorSymbols: maybeReq(() => !!capabilities.colorProvider, mainExports$1.DocumentColorRequest.type),
    /** If supported, get folding ranges in a document. */
    getFoldingRanges: maybeReq(() => !!capabilities.foldingRangeProvider, mainExports$1.FoldingRangeRequest.type),
    /** If supported, get selection ranges in a document. */
    getSelectionRanges: maybeReq(() => !!capabilities.selectionRangeProvider, mainExports$1.SelectionRangeRequest.type),
    /** If supported, list project-wide symbols matching the query string in params. */
    getWorkspaceSymbols: maybeReq(() => !!capabilities.workspaceSymbolProvider, mainExports$1.WorkspaceSymbolRequest.type),
    get syncsIncrementally() {
      var _a2, _b;
      let syncCapability = (_a2 = capabilities.textDocumentSync) !== null && _a2 !== void 0 ? _a2 : mainExports$1.TextDocumentSyncKind.None;
      if (typeof syncCapability !== "number") {
        syncCapability = (_b = syncCapability.change) !== null && _b !== void 0 ? _b : mainExports$1.TextDocumentSyncKind.None;
      }
      return syncCapability === mainExports$1.TextDocumentSyncKind.Incremental;
    },
    get completionTriggers() {
      var _a2;
      return ((_a2 = capabilities.completionProvider) === null || _a2 === void 0 ? void 0 : _a2.triggerCharacters) || [];
    },
    get signatureHelpTriggers() {
      var _a2;
      return ((_a2 = capabilities.signatureHelpProvider) === null || _a2 === void 0 ? void 0 : _a2.triggerCharacters) || [];
    },
    get signatureHelpRetriggers() {
      var _a2;
      return ((_a2 = capabilities.signatureHelpProvider) === null || _a2 === void 0 ? void 0 : _a2.retriggerCharacters) || [];
    }
  };
};
const METHOD_TO_PROVIDER = {
  "textDocument/codeAction": "codeActionProvider",
  "textDocument/codeLens": "codeLensProvider",
  "textDocument/color": "colorProvider",
  "textDocument/completion": "completionProvider",
  "textDocument/declaration": "declarationProvider",
  "textDocument/definition": "definitionProvider",
  "textDocument/documentFormatting": "documentFormattingProvider",
  "textDocument/documentHighlight": "documentHighlightProvider",
  "textDocument/documentLink": "documentLinkProvider",
  "textDocument/documentOnTypeFormatting": "documentOnTypeFormattingProvider",
  "textDocument/documentRangeFormatting": "documentRangeFormattingProvider",
  "textDocument/documentSymbol": "documentSymbolProvider",
  "textDocument/executeCommand": "executeCommandProvider",
  "textDocument/foldingRange": "foldingRangeProvider",
  "textDocument/hover": "hoverProvider",
  "textDocument/implementation": "implementationProvider",
  "textDocument/references": "referencesProvider",
  "textDocument/rename": "renameProvider",
  "textDocument/signatureHelp": "signatureHelpProvider",
  "textDocument/typeDefinition": "typeDefinitionProvider",
  "textDocument/workspaceSymbol": "workspaceSymbolProvider"
};
var mainExports = requireMain$2();
const createMessageReader = (worker) => {
  const messageEmitter = new mainExports.Emitter();
  const errorEmitter = new mainExports.Emitter();
  const closeEmitter = new mainExports.Emitter();
  const partialMessageEmitter = new mainExports.Emitter();
  const messageHandler = (event) => {
    messageEmitter.fire(event.data);
  };
  const errorHandler = (error) => {
    errorEmitter.fire(error);
  };
  worker.addEventListener("message", messageHandler);
  worker.addEventListener("error", errorHandler);
  worker.addEventListener("messageerror", errorHandler);
  return {
    get onError() {
      return errorEmitter.event;
    },
    get onClose() {
      return closeEmitter.event;
    },
    get onPartialMessage() {
      return partialMessageEmitter.event;
    },
    listen(callback) {
      return messageEmitter.event(callback);
    },
    dispose() {
      worker.removeEventListener("message", messageHandler);
      worker.removeEventListener("error", errorHandler);
      worker.removeEventListener("messageerror", errorHandler);
      messageEmitter.dispose();
      errorEmitter.dispose();
      closeEmitter.dispose();
      partialMessageEmitter.dispose();
    }
  };
};
const createMessageWriter = (worker) => {
  const errorEmitter = new mainExports.Emitter();
  const closeEmitter = new mainExports.Emitter();
  let errorCount = 0;
  const errorHandler = (error) => {
    errorEmitter.fire([toError(error), void 0, ++errorCount]);
  };
  worker.addEventListener("error", errorHandler);
  return {
    get onError() {
      return errorEmitter.event;
    },
    get onClose() {
      return closeEmitter.event;
    },
    async write(msg) {
      try {
        worker.postMessage(msg);
      } catch (e2) {
        errorEmitter.fire([toError(e2), msg, ++errorCount]);
      }
    },
    end() {
    },
    dispose() {
      worker.removeEventListener("error", errorHandler);
      errorEmitter.dispose();
      closeEmitter.dispose();
    }
  };
};
const toError = (err) => err instanceof Error ? err : new Error((err === null || err === void 0 ? void 0 : err.message) || "Unknown error");
const createMessageConnection = (worker, logger = createConsoleLogger()) => {
  const conn = mainExports.createMessageConnection(createMessageReader(worker), createMessageWriter(worker), logger);
  conn.onClose(() => conn.dispose());
  return Promise.resolve(conn);
};
const createConsoleLogger = () => ({
  error: (message) => console.error(message),
  warn: (message) => console.warn(message),
  info: (message) => console.info(message),
  log: (message) => console.log(message)
});
async function initWorker(worker, doenetWorkerUrl) {
  const workerConn = await createMessageConnection(worker);
  const lspConn = createLspConnection(workerConn);
  lspConn.listen();
  await lspConn.initialize({
    capabilities: {
      textDocument: {
        synchronization: {
          dynamicRegistration: true,
          willSave: true,
          willSaveWaitUntil: true,
          didSave: true
        },
        completion: {
          dynamicRegistration: true,
          completionItem: {
            snippetSupport: true,
            insertReplaceSupport: true,
            commitCharactersSupport: false,
            documentationFormat: ["markdown", "plaintext"],
            deprecatedSupport: true,
            preselectSupport: true,
            resolveSupport: {
              properties: ["documentation", "detail"]
            }
          },
          contextSupport: true
        },
        hover: {
          dynamicRegistration: true,
          contentFormat: ["markdown", "plaintext"]
        },
        signatureHelp: {
          dynamicRegistration: true,
          signatureInformation: {
            documentationFormat: ["markdown", "plaintext"],
            parameterInformation: {
              labelOffsetSupport: true
            }
          },
          contextSupport: true
        },
        declaration: {
          dynamicRegistration: true,
          linkSupport: false
        },
        definition: {
          dynamicRegistration: true,
          linkSupport: true
        },
        typeDefinition: {
          dynamicRegistration: true,
          linkSupport: true
        },
        implementation: {
          dynamicRegistration: true,
          linkSupport: true
        },
        references: {
          dynamicRegistration: true
        },
        documentHighlight: {
          dynamicRegistration: true
        },
        documentSymbol: {
          dynamicRegistration: true,
          hierarchicalDocumentSymbolSupport: true
        },
        publishDiagnostics: {
          relatedInformation: true,
          tagSupport: {
            valueSet: [1, 2]
          }
        },
        moniker: {}
      },
      workspace: {
        didChangeConfiguration: {
          dynamicRegistration: true
        },
        didChangeWatchedFiles: {
          dynamicRegistration: false
        }
      }
    },
    initializationOptions: doenetWorkerUrl ? { doenetWorkerUrl } : null,
    processId: null,
    rootUri: "file:///",
    workspaceFolders: null
  });
  await lspConn.initialized();
  return { lspConn, workerConn };
}
function createLspWorkerBlobUrl() {
  return URL.createObjectURL(
    new Blob([lspSource], { type: "application/javascript" })
  );
}
const HELP_NONE$1 = { kind: "none" };
function withResolver() {
  let resolve;
  const promise = new Promise((res) => {
    resolve = res;
  });
  return { resolve, promise };
}
class LSP {
  constructor() {
    this.diagnosticsSubscribersByUri = /* @__PURE__ */ new Map();
    this.versionCounter = {};
    this.diagnosticsHandlerRegistered = false;
    this.initPromise = withResolver();
    this.initStatus = "uninitialized";
    this.completionTriggers = [];
  }
  /**
   * Set the doenet worker URL used during LSP initialization.  Only takes
   * effect before `init()` runs — once the LSP is initialized the URL is
   * locked in for the rest of the session.  If a later `<CodeMirror>`
   * instance passes a *different* URL, it is ignored and a warning is
   * emitted so the conflict is visible to developers.
   */
  setDoenetWorkerUrl(doenetWorkerUrl) {
    if (this.initStatus !== "uninitialized") {
      if (doenetWorkerUrl && doenetWorkerUrl !== this.doenetWorkerUrl) {
        console.warn(
          `DoenetML LSP: doenetWorkerUrl is a process-wide singleton; the URL passed by a later <CodeMirror> instance is being ignored. Using "${this.doenetWorkerUrl}", ignoring "${doenetWorkerUrl}".`
        );
      }
      return;
    }
    if (doenetWorkerUrl) {
      this.doenetWorkerUrl = doenetWorkerUrl;
    }
  }
  ensureDiagnosticsHandlerRegistered() {
    if (!this.lspConn || this.diagnosticsHandlerRegistered) {
      return;
    }
    this.lspConn.onDiagnostics((params) => {
      const uriSubscribers = this.diagnosticsSubscribersByUri.get(
        params.uri
      );
      if (!uriSubscribers) {
        return;
      }
      for (const subscriber of uriSubscribers) {
        subscriber(params);
      }
    });
    this.diagnosticsHandlerRegistered = true;
  }
  async init() {
    if (this.lspConn) {
      return;
    }
    if (this.initStatus === "uninitialized") {
      this.initStatus = "initializing";
      let workerBlobUrl = null;
      try {
        workerBlobUrl = createLspWorkerBlobUrl();
        this.worker = new Worker(workerBlobUrl);
      } finally {
        if (workerBlobUrl) {
          const urlToRevoke = workerBlobUrl;
          queueMicrotask(() => URL.revokeObjectURL(urlToRevoke));
        }
      }
      const { lspConn, workerConn } = await initWorker(
        this.worker,
        this.doenetWorkerUrl
      );
      this.lspConn = lspConn;
      this.workerConn = workerConn;
      this.completionTriggers = this.lspConn.completionTriggers;
      this.ensureDiagnosticsHandlerRegistered();
      this.initPromise.resolve();
      this.initStatus = "initialized";
    }
    if (this.initStatus === "initializing") {
      await this.initPromise.promise;
    }
  }
  /**
   * Subscribe to diagnostics for a specific document URI.
   *
   * Returns an unsubscribe function for immediate/manual cleanup.
   * Subscriptions are also automatically pruned when closeDocument(uri) is called.
   */
  onDiagnostics(uri, callback) {
    const existing = this.diagnosticsSubscribersByUri.get(uri);
    if (existing) {
      existing.add(callback);
    } else {
      this.diagnosticsSubscribersByUri.set(uri, /* @__PURE__ */ new Set([callback]));
    }
    this.init().then(() => {
      this.ensureDiagnosticsHandlerRegistered();
    }).catch((error) => {
      console.error(
        "Failed to initialize diagnostics handler",
        error
      );
    });
    return () => {
      const subscribers = this.diagnosticsSubscribersByUri.get(uri);
      if (!subscribers) {
        return;
      }
      subscribers.delete(callback);
      if (subscribers.size === 0) {
        this.diagnosticsSubscribersByUri.delete(uri);
      }
    };
  }
  async initDocument(uri, text2) {
    if (!this.lspConn) {
      await this.init();
      await this.initDocument(uri, text2);
      return;
    }
    this.versionCounter[uri] = 1;
    await this.lspConn.textDocumentOpened({
      textDocument: {
        uri,
        languageId: "doenet",
        version: 1,
        text: text2
      }
    });
  }
  async closeDocument(uri) {
    if (!this.lspConn) {
      await this.init();
      await this.closeDocument(uri);
      return;
    }
    await this.lspConn.textDocumentClosed({
      textDocument: {
        uri
      }
    });
    delete this.versionCounter[uri];
    this.diagnosticsSubscribersByUri.delete(uri);
  }
  async updateDocument(uri, text2) {
    if (!this.lspConn || !this.versionCounter[uri]) {
      await this.initDocument(uri, text2);
      return;
    }
    this.versionCounter[uri] += 1;
    await this.lspConn.textDocumentChanged({
      textDocument: {
        uri,
        version: this.versionCounter[uri]
      },
      contentChanges: [
        {
          text: text2
        }
      ]
    });
  }
  async getCompletionItems(uri, position2, context) {
    await this.initPromise.promise;
    if (!this.lspConn) {
      console.warn("Cannot get completion items without lspConn");
      return [];
    }
    return await this.lspConn.getCompletion({
      textDocument: { uri },
      position: position2,
      context
    });
  }
  /**
   * This is a special function just for the Doenet LSP.
   * It allows the client to send additional diagnostics that are not generated by the LSP itself.
   * For example, messages generated by an external instance of Core may be sent here and then delivered
   * by the LSP back to the client.
   */
  async sendAdditionalDiagnostics(uri, additionalDiagnostics) {
    await this.initPromise.promise;
    if (!this.workerConn) {
      console.warn(
        "Cannot send additional diagnostics without workerConn"
      );
      return;
    }
    await this.workerConn.sendRequest(
      DOENET_LSP_METHODS.setAdditionalDiagnostics,
      {
        uri,
        additionalDiagnostics
      }
    );
  }
  /**
   * Ask the LSP server for the context-sensitive help payload at the given
   * cursor `offset`.  Implements the editor side of issue #1086 / Option 4:
   * help derivation runs in the LSP worker (which already holds a Rust
   * resolver adapter), so multi-segment refs like `$rep[1].point1.x`
   * resolve correctly here even though the editor itself has no resolver.
   *
   * Returns `{ kind: "none" }` if the LSP hasn't been wired up yet — the
   * editor renders an empty help panel rather than throwing.
   */
  async requestContextHelp(uri, offset2) {
    await this.initPromise.promise;
    if (!this.workerConn) {
      console.warn("Cannot request context help without workerConn");
      return HELP_NONE$1;
    }
    return await this.workerConn.sendRequest(
      DOENET_LSP_METHODS.contextHelp,
      {
        uri,
        offset: offset2
      }
    );
  }
  /**
   * Ask the LSP server for the context-sensitive help payload for the
   * currently-highlighted autocomplete row.  Used while the popup is open:
   * the help panel mirrors the highlighted entry so arrow-key navigation
   * surfaces its docs immediately.
   */
  async requestContextHelpForCompletion(uri, offset2, completion) {
    await this.initPromise.promise;
    if (!this.workerConn) {
      console.warn(
        "Cannot request context help for completion without workerConn"
      );
      return HELP_NONE$1;
    }
    return await this.workerConn.sendRequest(
      DOENET_LSP_METHODS.contextHelpForCompletion,
      { uri, offset: offset2, completion }
    );
  }
}
var browserExports$2 = requireBrowser$1$1();
function getLivePreviewQuoteWrap(data) {
  if (!data || typeof data !== "object") {
    return void 0;
  }
  const marker = data.livePreviewQuoteWrap;
  if (!marker || typeof marker !== "object" || !isNonNegativeInteger(marker.bareValueStartOffset)) {
    return void 0;
  }
  return marker;
}
function isNonNegativeInteger(value) {
  return typeof value === "number" && Number.isInteger(value) && value >= 0;
}
function isCompletionSnippetCursor(value) {
  if (!value || typeof value !== "object") {
    return false;
  }
  const hasCaretOffset = "caretOffset" in value;
  const hasSelectionStartOffset = "selectionStartOffset" in value;
  const hasSelectionEndOffset = "selectionEndOffset" in value;
  if (hasCaretOffset) {
    return !hasSelectionStartOffset && !hasSelectionEndOffset && isNonNegativeInteger(value.caretOffset);
  }
  if (hasSelectionStartOffset && hasSelectionEndOffset) {
    return !hasCaretOffset && isNonNegativeInteger(value.selectionStartOffset) && isNonNegativeInteger(value.selectionEndOffset) && value.selectionStartOffset <= value.selectionEndOffset;
  }
  return false;
}
function getSnippetCursorFromCompletionItemData(data) {
  if (!data || typeof data !== "object") {
    return void 0;
  }
  const snippetCursor = data.snippetCursor;
  if (!isCompletionSnippetCursor(snippetCursor)) {
    return void 0;
  }
  return snippetCursor;
}
function isRefTokenPrefixChar(char) {
  return char === "$" || char === ".";
}
function evaluateReopenLatchTransition({
  reopenLatch,
  docVersion,
  previousToken,
  currentToken,
  tokenPrefixChar,
  isDeleteEvent,
  deletedCount,
  insertedCount
}) {
  if (!reopenLatch || reopenLatch.docVersion !== docVersion || !previousToken || !currentToken || previousToken.from !== reopenLatch.tokenFrom || currentToken.from !== reopenLatch.tokenFrom || !isRefTokenPrefixChar(tokenPrefixChar)) {
    return {
      shouldReopenFromLatch: false,
      keepReopenLatchForNextChange: false
    };
  }
  const isTailInsert = insertedCount === 1 && deletedCount === 0 && currentToken.text.startsWith(previousToken.text) && currentToken.text.length === previousToken.text.length + 1;
  const isTailDelete = isDeleteEvent && deletedCount === 1 && insertedCount === 0 && previousToken.text.startsWith(currentToken.text) && previousToken.text.length === currentToken.text.length + 1;
  return {
    shouldReopenFromLatch: isTailDelete && previousToken.from === currentToken.from && currentToken.text === reopenLatch.previousTokenText && previousToken.text !== currentToken.text,
    keepReopenLatchForNextChange: isTailInsert || isTailDelete
  };
}
function createReopenLatchFromCloseTransition({
  prevCompletionStatus,
  nextCompletionStatus,
  insertedCount,
  deletedCount,
  currentToken,
  previousToken,
  tokenPrefixChar,
  docVersion
}) {
  if (!prevCompletionStatus || nextCompletionStatus || insertedCount !== 1 || deletedCount !== 0 || !currentToken || !previousToken || !isRefTokenPrefixChar(tokenPrefixChar)) {
    return null;
  }
  if (previousToken.from === currentToken.from && currentToken.text.startsWith(previousToken.text) && currentToken.text.length === previousToken.text.length + 1) {
    return {
      tokenFrom: currentToken.from,
      previousTokenText: previousToken.text,
      docVersion: docVersion + 1
    };
  }
  return null;
}
const element$1 = document.createElement("i");
function decodeNamedCharacterReference$1(value) {
  const characterReference2 = "&" + value + ";";
  element$1.innerHTML = characterReference2;
  const character = element$1.textContent;
  if (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character.charCodeAt(character.length - 1) === 59 && value !== "semi"
  ) {
    return false;
  }
  return character === characterReference2 ? false : character;
}
function splice$1(list2, start, remove2, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove2 = remove2 > 0 ? remove2 : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove2);
    list2.splice(...parameters);
  } else {
    if (remove2) list2.splice(start, remove2);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
function push$2(list2, items) {
  if (list2.length > 0) {
    splice$1(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty$1$2 = {}.hasOwnProperty;
function combineExtensions$1(extensions) {
  const all2 = {};
  let index2 = -1;
  while (++index2 < extensions.length) {
    syntaxExtension$1(all2, extensions[index2]);
  }
  return all2;
}
function syntaxExtension$1(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1$2.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let code2;
    if (right) {
      for (code2 in right) {
        if (!hasOwnProperty$1$2.call(left, code2)) left[code2] = [];
        const value = right[code2];
        constructs$1(
          // @ts-expect-error Looks like a list.
          left[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs$1(existing, list2) {
  let index2 = -1;
  const before2 = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before2).push(list2[index2]);
  }
  splice$1(existing, 0, 0, before2);
}
function combineHtmlExtensions$1(htmlExtensions) {
  const handlers2 = {};
  let index2 = -1;
  while (++index2 < htmlExtensions.length) {
    htmlExtension$1(handlers2, htmlExtensions[index2]);
  }
  return handlers2;
}
function htmlExtension$1(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1$2.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let type;
    if (right) {
      for (type in right) {
        left[type] = right[type];
      }
    }
  }
}
function decodeNumericCharacterReference$1(value, base2) {
  const code2 = Number.parseInt(value, base2);
  if (
    // C0 except for HT, LF, FF, CR, space.
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of C0, and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || /* eslint-disable no-bitwise */
    (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    code2 > 1114111
  ) {
    return "�";
  }
  return String.fromCodePoint(code2);
}
const characterReferences$1 = { '"': "quot", "&": "amp", "<": "lt", ">": "gt" };
function encode$3(value) {
  return value.replace(/["&<>]/g, replace2);
  function replace2(value2) {
    return "&" + characterReferences$1[
      /** @type {keyof typeof characterReferences} */
      value2
    ] + ";";
  }
}
function normalizeIdentifier$1(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha$1 = regexCheck$1(/[A-Za-z]/);
const asciiAlphanumeric$1 = regexCheck$1(/[\dA-Za-z]/);
const asciiAtext$1 = regexCheck$1(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl$1(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 !== null && (code2 < 32 || code2 === 127)
  );
}
const asciiDigit$1 = regexCheck$1(/\d/);
const asciiHexDigit$1 = regexCheck$1(/[\dA-Fa-f]/);
const asciiPunctuation$1 = regexCheck$1(/[!-/:-@[-`{-~]/);
function markdownLineEnding$1(code2) {
  return code2 !== null && code2 < -2;
}
function markdownLineEndingOrSpace$1(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
function markdownSpace$1(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
const unicodePunctuation$1 = regexCheck$1(new RegExp("\\p{P}|\\p{S}", "u"));
const unicodeWhitespace$1 = regexCheck$1(/\s/);
function regexCheck$1(regex) {
  return check;
  function check(code2) {
    return code2 !== null && code2 > -1 && regex.test(String.fromCharCode(code2));
  }
}
function sanitizeUri$1(url, protocol2) {
  const value = encode$3(normalizeUri$1(url || ""));
  if (!protocol2) {
    return value;
  }
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol2.test(value.slice(0, colon))
  ) {
    return value;
  }
  return "";
}
function normalizeUri$1(value) {
  const result2 = [];
  let index2 = -1;
  let start = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code2 = value.charCodeAt(index2);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric$1(value.charCodeAt(index2 + 1)) && asciiAlphanumeric$1(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code2 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2))) {
        replace2 = String.fromCharCode(code2);
      }
    } else if (code2 > 55295 && code2 < 57344) {
      const next = value.charCodeAt(index2 + 1);
      if (code2 < 56320 && next > 56319 && next < 57344) {
        replace2 = String.fromCharCode(code2, next);
        skip = 1;
      } else {
        replace2 = "�";
      }
    } else {
      replace2 = String.fromCharCode(code2);
    }
    if (replace2) {
      result2.push(value.slice(start, index2), encodeURIComponent(replace2));
      start = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result2.join("") + value.slice(start);
}
const hasOwnProperty$3 = {}.hasOwnProperty;
const protocolHref$1 = /^(https?|ircs?|mailto|xmpp)$/i;
const protocolSource$1 = /^https?$/i;
function compile$1(options2) {
  const settings = options2 || {};
  let tags2 = true;
  const definitions = {};
  const buffers = [[]];
  const mediaStack = [];
  const tightStack = [];
  const defaultHandlers = {
    enter: {
      blockQuote: onenterblockquote,
      codeFenced: onentercodefenced,
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: onentercodeindented,
      codeText: onentercodetext,
      content: onentercontent,
      definition: onenterdefinition,
      definitionDestinationString: onenterdefinitiondestinationstring,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: onenteremphasis,
      htmlFlow: onenterhtmlflow,
      htmlText: onenterhtml,
      image: onenterimage,
      label: buffer,
      link: onenterlink,
      listItemMarker: onenterlistitemmarker,
      listItemValue: onenterlistitemvalue,
      listOrdered: onenterlistordered,
      listUnordered: onenterlistunordered,
      paragraph: onenterparagraph,
      reference: buffer,
      resource: onenterresource,
      resourceDestinationString: onenterresourcedestinationstring,
      resourceTitleString: buffer,
      setextHeading: onentersetextheading,
      strong: onenterstrong
    },
    exit: {
      atxHeading: onexitatxheading,
      atxHeadingSequence: onexitatxheadingsequence,
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: onexitblockquote,
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: onexitflowcode,
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onresumedrop,
      codeFlowValue: onexitcodeflowvalue,
      codeIndented: onexitflowcode,
      codeText: onexitcodetext,
      codeTextData: onexitdata,
      data: onexitdata,
      definition: onexitdefinition,
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: onexitemphasis,
      hardBreakEscape: onexithardbreak,
      hardBreakTrailing: onexithardbreak,
      htmlFlow: onexithtml,
      htmlFlowData: onexitdata,
      htmlText: onexithtml,
      htmlTextData: onexitdata,
      image: onexitmedia,
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: onexitmedia,
      listOrdered: onexitlistordered,
      listUnordered: onexitlistunordered,
      paragraph: onexitparagraph,
      reference: onresumedrop,
      referenceString: onexitreferencestring,
      resource: onresumedrop,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      setextHeading: onexitsetextheading,
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: onexitstrong,
      thematicBreak: onexitthematicbreak
    }
  };
  const handlers2 = (
    /** @type {NormalizedHtmlExtension} */
    combineHtmlExtensions$1([defaultHandlers, ...settings.htmlExtensions || []])
  );
  const data = {
    definitions,
    tightStack
  };
  const context = {
    buffer,
    encode: encode$12,
    getData,
    lineEndingIfNeeded,
    options: settings,
    raw,
    resume,
    setData,
    tag: tag2
  };
  let lineEndingStyle = settings.defaultLineEnding;
  return compile2;
  function compile2(events2) {
    let index2 = -1;
    let start = 0;
    const listStack = [];
    let head = [];
    let body = [];
    while (++index2 < events2.length) {
      if (!lineEndingStyle && (events2[index2][1].type === "lineEnding" || events2[index2][1].type === "lineEndingBlank")) {
        lineEndingStyle = /** @type {LineEnding} */
        events2[index2][2].sliceSerialize(events2[index2][1]);
      }
      if (events2[index2][1].type === "listOrdered" || events2[index2][1].type === "listUnordered") {
        if (events2[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          prepareList(events2.slice(listStack.pop(), index2));
        }
      }
      if (events2[index2][1].type === "definition") {
        if (events2[index2][0] === "enter") {
          body = push$2(body, events2.slice(start, index2));
          start = index2;
        } else {
          head = push$2(head, events2.slice(start, index2 + 1));
          start = index2 + 1;
        }
      }
    }
    head = push$2(head, body);
    head = push$2(head, events2.slice(start));
    index2 = -1;
    const result2 = head;
    if (handlers2.enter.null) {
      handlers2.enter.null.call(context);
    }
    while (++index2 < events2.length) {
      const handles = handlers2[result2[index2][0]];
      const kind = result2[index2][1].type;
      const handle = handles[kind];
      if (hasOwnProperty$3.call(handles, kind) && handle) {
        handle.call({
          sliceSerialize: result2[index2][2].sliceSerialize,
          ...context
        }, result2[index2][1]);
      }
    }
    if (handlers2.exit.null) {
      handlers2.exit.null.call(context);
    }
    return buffers[0].join("");
  }
  function prepareList(slice2) {
    const length = slice2.length;
    let index2 = 0;
    let containerBalance = 0;
    let loose = false;
    let atMarker;
    while (++index2 < length) {
      const event = slice2[index2];
      if (event[1]._container) {
        atMarker = void 0;
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
      } else switch (event[1].type) {
        case "listItemPrefix": {
          if (event[0] === "exit") {
            atMarker = true;
          }
          break;
        }
        case "linePrefix": {
          break;
        }
        case "lineEndingBlank": {
          if (event[0] === "enter" && !containerBalance) {
            if (atMarker) {
              atMarker = void 0;
            } else {
              loose = true;
            }
          }
          break;
        }
        default: {
          atMarker = void 0;
        }
      }
    }
    slice2[0][1]._loose = loose;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function buffer() {
    buffers.push([]);
  }
  function resume() {
    const buf = buffers.pop();
    return buf.join("");
  }
  function tag2(value) {
    if (!tags2) return;
    setData("lastWasTag", true);
    buffers[buffers.length - 1].push(value);
  }
  function raw(value) {
    setData("lastWasTag");
    buffers[buffers.length - 1].push(value);
  }
  function lineEnding2() {
    raw(lineEndingStyle || "\n");
  }
  function lineEndingIfNeeded() {
    const buffer2 = buffers[buffers.length - 1];
    const slice2 = buffer2[buffer2.length - 1];
    const previous2 = slice2 ? slice2.charCodeAt(slice2.length - 1) : null;
    if (previous2 === 10 || previous2 === 13 || previous2 === null) {
      return;
    }
    lineEnding2();
  }
  function encode$12(value) {
    return getData("ignoreEncode") ? value : encode$3(value);
  }
  function onresumedrop() {
    resume();
  }
  function onenterlistordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ol");
    setData("expectFirstItem", true);
  }
  function onenterlistunordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ul");
    setData("expectFirstItem", true);
  }
  function onenterlistitemvalue(token) {
    if (getData("expectFirstItem")) {
      const value = Number.parseInt(this.sliceSerialize(token), 10);
      if (value !== 1) {
        tag2(' start="' + encode$12(String(value)) + '"');
      }
    }
  }
  function onenterlistitemmarker() {
    if (getData("expectFirstItem")) {
      tag2(">");
    } else {
      onexitlistitem();
    }
    lineEndingIfNeeded();
    tag2("<li>");
    setData("expectFirstItem");
    setData("lastWasTag");
  }
  function onexitlistordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ol>");
  }
  function onexitlistunordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ul>");
  }
  function onexitlistitem() {
    if (getData("lastWasTag") && !getData("slurpAllLineEndings")) {
      lineEndingIfNeeded();
    }
    tag2("</li>");
    setData("slurpAllLineEndings");
  }
  function onenterblockquote() {
    tightStack.push(false);
    lineEndingIfNeeded();
    tag2("<blockquote>");
  }
  function onexitblockquote() {
    tightStack.pop();
    lineEndingIfNeeded();
    tag2("</blockquote>");
    setData("slurpAllLineEndings");
  }
  function onenterparagraph() {
    if (!tightStack[tightStack.length - 1]) {
      lineEndingIfNeeded();
      tag2("<p>");
    }
    setData("slurpAllLineEndings");
  }
  function onexitparagraph() {
    if (tightStack[tightStack.length - 1]) {
      setData("slurpAllLineEndings", true);
    } else {
      tag2("</p>");
    }
  }
  function onentercodefenced() {
    lineEndingIfNeeded();
    tag2("<pre><code");
    setData("fencesCount", 0);
  }
  function onexitcodefencedfenceinfo() {
    const value = resume();
    tag2(' class="language-' + value + '"');
  }
  function onexitcodefencedfence() {
    const count = getData("fencesCount") || 0;
    if (!count) {
      tag2(">");
      setData("slurpOneLineEnding", true);
    }
    setData("fencesCount", count + 1);
  }
  function onentercodeindented() {
    lineEndingIfNeeded();
    tag2("<pre><code>");
  }
  function onexitflowcode() {
    const count = getData("fencesCount");
    if (count !== void 0 && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) {
      lineEnding2();
    }
    if (getData("flowCodeSeenData")) {
      lineEndingIfNeeded();
    }
    tag2("</code></pre>");
    if (count !== void 0 && count < 2) lineEndingIfNeeded();
    setData("flowCodeSeenData");
    setData("fencesCount");
    setData("slurpOneLineEnding");
  }
  function onenterimage() {
    mediaStack.push({
      image: true
    });
    tags2 = void 0;
  }
  function onenterlink() {
    mediaStack.push({});
  }
  function onexitlabeltext(token) {
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onexitlabel() {
    mediaStack[mediaStack.length - 1].label = resume();
  }
  function onexitreferencestring(token) {
    mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
  }
  function onenterresource() {
    buffer();
    mediaStack[mediaStack.length - 1].destination = "";
  }
  function onenterresourcedestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitresourcedestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitresourcetitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitmedia() {
    let index2 = mediaStack.length - 1;
    const media = mediaStack[index2];
    const id2 = media.referenceId || media.labelId;
    const context2 = media.destination === void 0 ? definitions[normalizeIdentifier$1(id2)] : media;
    tags2 = true;
    while (index2--) {
      if (mediaStack[index2].image) {
        tags2 = void 0;
        break;
      }
    }
    if (media.image) {
      tag2('<img src="' + sanitizeUri$1(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolSource$1) + '" alt="');
      raw(media.label);
      tag2('"');
    } else {
      tag2('<a href="' + sanitizeUri$1(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolHref$1) + '"');
    }
    tag2(context2.title ? ' title="' + context2.title + '"' : "");
    if (media.image) {
      tag2(" />");
    } else {
      tag2(">");
      raw(media.label);
      tag2("</a>");
    }
    mediaStack.pop();
  }
  function onenterdefinition() {
    buffer();
    mediaStack.push({});
  }
  function onexitdefinitionlabelstring(token) {
    resume();
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onenterdefinitiondestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitdefinitiondestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitdefinitiontitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitdefinition() {
    const media = mediaStack[mediaStack.length - 1];
    const id2 = normalizeIdentifier$1(media.labelId);
    resume();
    if (!hasOwnProperty$3.call(definitions, id2)) {
      definitions[id2] = mediaStack[mediaStack.length - 1];
    }
    mediaStack.pop();
  }
  function onentercontent() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheadingsequence(token) {
    if (getData("headingRank")) return;
    setData("headingRank", this.sliceSerialize(token).length);
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
  }
  function onentersetextheading() {
    buffer();
    setData("slurpAllLineEndings");
  }
  function onexitsetextheadingtext() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheading() {
    tag2("</h" + getData("headingRank") + ">");
    setData("headingRank");
  }
  function onexitsetextheadinglinesequence(token) {
    setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
  }
  function onexitsetextheading() {
    const value = resume();
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
    raw(value);
    tag2("</h" + getData("headingRank") + ">");
    setData("slurpAllLineEndings");
    setData("headingRank");
  }
  function onexitdata(token) {
    raw(encode$12(this.sliceSerialize(token)));
  }
  function onexitlineending(token) {
    if (getData("slurpAllLineEndings")) {
      return;
    }
    if (getData("slurpOneLineEnding")) {
      setData("slurpOneLineEnding");
      return;
    }
    if (getData("inCodeText")) {
      raw(" ");
      return;
    }
    raw(encode$12(this.sliceSerialize(token)));
  }
  function onexitcodeflowvalue(token) {
    raw(encode$12(this.sliceSerialize(token)));
    setData("flowCodeSeenData", true);
  }
  function onexithardbreak() {
    tag2("<br />");
  }
  function onenterhtmlflow() {
    lineEndingIfNeeded();
    onenterhtml();
  }
  function onexithtml() {
    setData("ignoreEncode");
  }
  function onenterhtml() {
    if (settings.allowDangerousHtml) {
      setData("ignoreEncode", true);
    }
  }
  function onenteremphasis() {
    tag2("<em>");
  }
  function onenterstrong() {
    tag2("<strong>");
  }
  function onentercodetext() {
    setData("inCodeText", true);
    tag2("<code>");
  }
  function onexitcodetext() {
    setData("inCodeText");
    tag2("</code>");
  }
  function onexitemphasis() {
    tag2("</em>");
  }
  function onexitstrong() {
    tag2("</strong>");
  }
  function onexitthematicbreak() {
    lineEndingIfNeeded();
    tag2("<hr />");
  }
  function onexitcharacterreferencemarker(token) {
    setData("characterReferenceType", token.type);
  }
  function onexitcharacterreferencevalue(token) {
    const value = this.sliceSerialize(token);
    const decoded = getData("characterReferenceType") ? decodeNumericCharacterReference$1(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : decodeNamedCharacterReference$1(value);
    raw(encode$12(
      /** @type {string} */
      decoded
    ));
    setData("characterReferenceType");
  }
  function onexitautolinkprotocol(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri$1(uri, settings.allowDangerousProtocol ? void 0 : protocolHref$1) + '">');
    raw(encode$12(uri));
    tag2("</a>");
  }
  function onexitautolinkemail(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri$1("mailto:" + uri) + '">');
    raw(encode$12(uri));
    tag2("</a>");
  }
}
function factorySpace$1(effects, ok2, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size2 = 0;
  return start;
  function start(code2) {
    if (markdownSpace$1(code2)) {
      effects.enter(type);
      return prefix(code2);
    }
    return ok2(code2);
  }
  function prefix(code2) {
    if (markdownSpace$1(code2) && size2++ < limit) {
      effects.consume(code2);
      return prefix;
    }
    effects.exit(type);
    return ok2(code2);
  }
}
const content$1$1 = {
  tokenize: initializeContent$1
};
function initializeContent$1(effects) {
  const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$1(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    const token = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token;
    }
    previous2 = token;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding$1(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
const document$2$1 = {
  tokenize: initializeDocument$1
};
const containerConstruct$1 = {
  tokenize: tokenizeContainer$1
};
function initializeDocument$1(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice$1(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
      return checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code2);
      }
      self2.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }
    self2.containerState = {};
    return effects.check(containerConstruct$1, thereIsANewContainer, thereIsNoNewContainer)(code2);
  }
  function thereIsANewContainer(code2) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code2);
  }
  function documentContinued(code2) {
    self2.containerState = {};
    return effects.attempt(containerConstruct$1, containerContinue, flowStart)(code2);
  }
  function containerContinue(code2) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding$1(code2)) {
      effects.consume(code2);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start;
    }
    effects.consume(code2);
    return flowContinue;
  }
  function writeToChild(token, endOfFile) {
    const stream = self2.sliceStream(token);
    if (endOfFile) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token.start.line]) {
      let index2 = childFlow.events.length;
      while (index2--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        ) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice$1(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
    }
  }
  function exitContainers(size2) {
    let index2 = stack.length;
    while (index2-- > size2) {
      const entry = stack[index2];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size2;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer$1(effects, ok2, nok) {
  return factorySpace$1(effects, effects.attempt(this.parser.constructs.document, ok2, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter$1(code2) {
  if (code2 === null || markdownLineEndingOrSpace$1(code2) || unicodeWhitespace$1(code2)) {
    return 1;
  }
  if (unicodePunctuation$1(code2)) {
    return 2;
  }
}
function resolveAll$1(constructs2, events2, context) {
  const called = [];
  let index2 = -1;
  while (++index2 < constructs2.length) {
    const resolve = constructs2[index2].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events2 = resolve(events2, context);
      called.push(resolve);
    }
  }
  return events2;
}
const attention$1 = {
  name: "attention",
  resolveAll: resolveAllAttention$1,
  tokenize: tokenizeAttention$1
};
function resolveAllAttention$1(events2, context) {
  let index2 = -1;
  let open;
  let group2;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset2;
  while (++index2 < events2.length) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "attentionSequence" && events2[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events2[open][0] === "exit" && events2[open][1].type === "attentionSequence" && events2[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events2[open][1]).charCodeAt(0) === context.sliceSerialize(events2[index2][1]).charCodeAt(0)) {
          if ((events2[open][1]._close || events2[index2][1]._open) && (events2[index2][1].end.offset - events2[index2][1].start.offset) % 3 && !((events2[open][1].end.offset - events2[open][1].start.offset + events2[index2][1].end.offset - events2[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events2[open][1].end.offset - events2[open][1].start.offset > 1 && events2[index2][1].end.offset - events2[index2][1].start.offset > 1 ? 2 : 1;
          const start = {
            ...events2[open][1].end
          };
          const end = {
            ...events2[index2][1].start
          };
          movePoint$1(start, -use);
          movePoint$1(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: {
              ...events2[open][1].end
            }
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events2[index2][1].start
            },
            end
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events2[open][1].end
            },
            end: {
              ...events2[index2][1].start
            }
          };
          group2 = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          };
          events2[open][1].end = {
            ...openingSequence.start
          };
          events2[index2][1].start = {
            ...closingSequence.end
          };
          nextEvents = [];
          if (events2[open][1].end.offset - events2[open][1].start.offset) {
            nextEvents = push$2(nextEvents, [["enter", events2[open][1], context], ["exit", events2[open][1], context]]);
          }
          nextEvents = push$2(nextEvents, [["enter", group2, context], ["enter", openingSequence, context], ["exit", openingSequence, context], ["enter", text2, context]]);
          nextEvents = push$2(nextEvents, resolveAll$1(context.parser.constructs.insideSpan.null, events2.slice(open + 1, index2), context));
          nextEvents = push$2(nextEvents, [["exit", text2, context], ["enter", closingSequence, context], ["exit", closingSequence, context], ["exit", group2, context]]);
          if (events2[index2][1].end.offset - events2[index2][1].start.offset) {
            offset2 = 2;
            nextEvents = push$2(nextEvents, [["enter", events2[index2][1], context], ["exit", events2[index2][1], context]]);
          } else {
            offset2 = 0;
          }
          splice$1(events2, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset2 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events2.length) {
    if (events2[index2][1].type === "attentionSequence") {
      events2[index2][1].type = "data";
    }
  }
  return events2;
}
function tokenizeAttention$1(effects, ok2) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before2 = classifyCharacter$1(previous2);
  let marker;
  return start;
  function start(code2) {
    marker = code2;
    effects.enter("attentionSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    const token = effects.exit("attentionSequence");
    const after2 = classifyCharacter$1(code2);
    const open = !after2 || after2 === 2 && before2 || attentionMarkers2.includes(code2);
    const close = !before2 || before2 === 2 && after2 || attentionMarkers2.includes(previous2);
    token._open = Boolean(marker === 42 ? open : open && (before2 || !close));
    token._close = Boolean(marker === 42 ? close : close && (after2 || !open));
    return ok2(code2);
  }
}
function movePoint$1(point2, offset2) {
  point2.column += offset2;
  point2.offset += offset2;
  point2._bufferIndex += offset2;
}
const autolink$1 = {
  name: "autolink",
  tokenize: tokenizeAutolink$1
};
function tokenizeAutolink$1(effects, ok2, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    if (code2 === 64) {
      return nok(code2);
    }
    return emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    if (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric$1(code2)) {
      size2 = 1;
      return schemeInsideOrEmailAtext(code2);
    }
    return emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      size2 = 0;
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric$1(code2)) && size2++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    size2 = 0;
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    if (code2 === null || code2 === 32 || code2 === 60 || asciiControl$1(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      return emailAtSignOrDot;
    }
    if (asciiAtext$1(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric$1(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric$1(code2)) && size2++ < 63) {
      const next = code2 === 45 ? emailValue : emailLabel;
      effects.consume(code2);
      return next;
    }
    return nok(code2);
  }
}
const blankLine$1 = {
  partial: true,
  tokenize: tokenizeBlankLine$1
};
function tokenizeBlankLine$1(effects, ok2, nok) {
  return start;
  function start(code2) {
    return markdownSpace$1(code2) ? factorySpace$1(effects, after2, "linePrefix")(code2) : after2(code2);
  }
  function after2(code2) {
    return code2 === null || markdownLineEnding$1(code2) ? ok2(code2) : nok(code2);
  }
}
const blockQuote$1 = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation$1
  },
  exit: exit$1,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart$1
};
function tokenizeBlockQuoteStart$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    if (markdownSpace$1(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok2;
    }
    effects.exit("blockQuotePrefix");
    return ok2(code2);
  }
}
function tokenizeBlockQuoteContinuation$1(effects, ok2, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    if (markdownSpace$1(code2)) {
      return factorySpace$1(effects, contBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
    }
    return contBefore(code2);
  }
  function contBefore(code2) {
    return effects.attempt(blockQuote$1, ok2, nok)(code2);
  }
}
function exit$1(effects) {
  effects.exit("blockQuote");
}
const characterEscape$1 = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape$1
};
function tokenizeCharacterEscape$1(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return inside2;
  }
  function inside2(code2) {
    if (asciiPunctuation$1(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok2;
    }
    return nok(code2);
  }
}
const characterReference$1 = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference$1
};
function tokenizeCharacterReference$1(effects, ok2, nok) {
  const self2 = this;
  let size2 = 0;
  let max2;
  let test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric2;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric$1;
    return value(code2);
  }
  function numeric2(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit$1;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit$1;
    return value(code2);
  }
  function value(code2) {
    if (code2 === 59 && size2) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric$1 && !decodeNamedCharacterReference$1(self2.sliceSerialize(token))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok2;
    }
    if (test(code2) && size2++ < max2) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
const nonLazyContinuation$1 = {
  partial: true,
  tokenize: tokenizeNonLazyContinuation$1
};
const codeFenced$1 = {
  concrete: true,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced$1
};
function tokenizeCodeFenced$1(effects, ok2, nok) {
  const self2 = this;
  const closeStart = {
    partial: true,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code2;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      sizeOpen++;
      effects.consume(code2);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code2);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace$1(code2) ? factorySpace$1(effects, infoBefore, "whitespace")(code2) : infoBefore(code2);
  }
  function infoBefore(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok2(code2) : effects.check(nonLazyContinuation$1, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code2);
  }
  function info(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace$1(effects, metaBefore, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return info;
  }
  function metaBefore(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      return infoBefore(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta2(code2);
  }
  function meta2(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return meta2;
  }
  function atNonLazyBreak(code2) {
    return effects.attempt(closeStart, after2, contentBefore)(code2);
  }
  function contentBefore(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace$1(code2) ? factorySpace$1(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      return effects.check(nonLazyContinuation$1, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code2);
  }
  function contentChunk(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code2);
    }
    effects.consume(code2);
    return contentChunk;
  }
  function after2(code2) {
    effects.exit("codeFenced");
    return ok2(code2);
  }
  function tokenizeCloseStart(effects2, ok22, nok2) {
    let size2 = 0;
    return startBefore;
    function startBefore(code2) {
      effects2.enter("lineEnding");
      effects2.consume(code2);
      effects2.exit("lineEnding");
      return start2;
    }
    function start2(code2) {
      effects2.enter("codeFencedFence");
      return markdownSpace$1(code2) ? factorySpace$1(effects2, beforeSequenceClose, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      if (code2 === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code2);
      }
      return nok2(code2);
    }
    function sequenceClose(code2) {
      if (code2 === marker) {
        size2++;
        effects2.consume(code2);
        return sequenceClose;
      }
      if (size2 >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace$1(code2) ? factorySpace$1(effects2, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2);
      }
      return nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      if (code2 === null || markdownLineEnding$1(code2)) {
        effects2.exit("codeFencedFence");
        return ok22(code2);
      }
      return nok2(code2);
    }
  }
}
function tokenizeNonLazyContinuation$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
const codeIndented$1 = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented$1
};
const furtherStart$1 = {
  partial: true,
  tokenize: tokenizeFurtherStart$1
};
function tokenizeCodeIndented$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("codeIndented");
    return factorySpace$1(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    if (code2 === null) {
      return after2(code2);
    }
    if (markdownLineEnding$1(code2)) {
      return effects.attempt(furtherStart$1, atBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("codeFlowValue");
      return atBreak(code2);
    }
    effects.consume(code2);
    return inside2;
  }
  function after2(code2) {
    effects.exit("codeIndented");
    return ok2(code2);
  }
}
function tokenizeFurtherStart$1(effects, ok2, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace$1(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok2(code2) : markdownLineEnding$1(code2) ? furtherStart2(code2) : nok(code2);
  }
}
const codeText$1 = {
  name: "codeText",
  previous: previous$1,
  resolve: resolveCodeText$1,
  tokenize: tokenizeCodeText$1
};
function resolveCodeText$1(events2) {
  let tailExitIndex = events2.length - 4;
  let headEnterIndex = 3;
  let index2;
  let enter;
  if ((events2[headEnterIndex][1].type === "lineEnding" || events2[headEnterIndex][1].type === "space") && (events2[tailExitIndex][1].type === "lineEnding" || events2[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events2[index2][1].type === "codeTextData") {
        events2[headEnterIndex][1].type = "codeTextPadding";
        events2[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter === void 0) {
      if (index2 !== tailExitIndex && events2[index2][1].type !== "lineEnding") {
        enter = index2;
      }
    } else if (index2 === tailExitIndex || events2[index2][1].type === "lineEnding") {
      events2[enter][1].type = "codeTextData";
      if (index2 !== enter + 2) {
        events2[enter][1].end = events2[index2 - 1][1].end;
        events2.splice(enter + 2, index2 - enter - 2);
        tailExitIndex -= index2 - enter - 2;
        index2 = enter + 2;
      }
      enter = void 0;
    }
  }
  return events2;
}
function previous$1(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText$1(effects, ok2, nok) {
  let sizeOpen = 0;
  let size2;
  let token;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code2);
  }
  function between(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return between;
    }
    if (code2 === 96) {
      token = effects.enter("codeTextSequence");
      size2 = 0;
      return sequenceClose(code2);
    }
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return between;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding$1(code2)) {
      effects.exit("codeTextData");
      return between(code2);
    }
    effects.consume(code2);
    return data;
  }
  function sequenceClose(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size2++;
      return sequenceClose;
    }
    if (size2 === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok2(code2);
    }
    token.type = "codeTextData";
    return data(code2);
  }
}
let SpliceBuffer$1 = class SpliceBuffer2 {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial2) {
    this.left = initial2 ? [...initial2] : [];
    this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index2) {
    if (index2 < 0 || index2 >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + index2 + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    if (index2 < this.left.length) return this.left[index2];
    return this.right[this.right.length - index2 + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    const stop = end === null || end === void 0 ? Number.POSITIVE_INFINITY : end;
    if (stop < this.left.length) {
      return this.left.slice(start, stop);
    }
    if (start > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
    }
    return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    if (items) chunkedPush$1(this.left, items);
    return removed.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush$1(this.left, items);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush$1(this.right, items.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n2) {
    if (n2 === this.left.length || n2 > this.left.length && this.right.length === 0 || n2 < 0 && this.left.length === 0) return;
    if (n2 < this.left.length) {
      const removed = this.left.splice(n2, Number.POSITIVE_INFINITY);
      chunkedPush$1(this.right, removed.reverse());
    } else {
      const removed = this.right.splice(this.left.length + this.right.length - n2, Number.POSITIVE_INFINITY);
      chunkedPush$1(this.left, removed.reverse());
    }
  }
};
function chunkedPush$1(list2, right) {
  let chunkStart = 0;
  if (right.length < 1e4) {
    list2.push(...right);
  } else {
    while (chunkStart < right.length) {
      list2.push(...right.slice(chunkStart, chunkStart + 1e4));
      chunkStart += 1e4;
    }
  }
}
function subtokenize$1(eventsArray) {
  const jumps = {};
  let index2 = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  const events2 = new SpliceBuffer$1(eventsArray);
  while (++index2 < events2.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events2.get(index2);
    if (index2 && event[1].type === "chunkFlow" && events2.get(index2 - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent$1(events2, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events2.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events2.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
        else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = {
          ...events2.get(lineIndex)[1].start
        };
        parameters = events2.slice(lineIndex, index2);
        parameters.unshift(event);
        events2.splice(lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  splice$1(eventsArray, 0, Number.POSITIVE_INFINITY, events2.slice(0));
  return !more;
}
function subcontent$1(events2, eventIndex) {
  const token = events2.get(eventIndex)[1];
  const context = events2.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  let tokenizer = token._tokenizer;
  if (!tokenizer) {
    tokenizer = context.parser[token.contentType](token.start);
    if (token._contentTypeTextTrailing) {
      tokenizer._contentTypeTextTrailing = true;
    }
  }
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index2 = -1;
  let current2 = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];
  while (current2) {
    while (events2.get(++startPosition)[1] !== current2) {
    }
    startPositions.push(startPosition);
    if (!current2._tokenizer) {
      stream = context.sliceStream(current2);
      if (!current2.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current2.start);
      }
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current2;
    current2 = current2.next;
  }
  current2 = token;
  while (++index2 < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      start = index2 + 1;
      breaks.push(start);
      current2._tokenizer = void 0;
      current2.previous = void 0;
      current2 = current2.next;
    }
  }
  tokenizer.events = [];
  if (current2) {
    current2._tokenizer = void 0;
    current2.previous = void 0;
  } else {
    breaks.pop();
  }
  index2 = breaks.length;
  while (index2--) {
    const slice2 = childEvents.slice(breaks[index2], breaks[index2 + 1]);
    const start2 = startPositions.pop();
    jumps.push([start2, start2 + slice2.length - 1]);
    events2.splice(start2, 2, slice2);
  }
  jumps.reverse();
  index2 = -1;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
}
const content$3 = {
  resolve: resolveContent$1,
  tokenize: tokenizeContent$1
};
const continuationConstruct$1 = {
  partial: true,
  tokenize: tokenizeContinuation$1
};
function resolveContent$1(events2) {
  subtokenize$1(events2);
  return events2;
}
function tokenizeContent$1(effects, ok2) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code2);
  }
  function chunkInside(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding$1(code2)) {
      return effects.check(continuationConstruct$1, contentContinue, contentEnd)(code2);
    }
    effects.consume(code2);
    return chunkInside;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok2(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation$1(effects, ok2, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$1(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      return nok(code2);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok2(code2);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok2)(code2);
  }
}
function factoryDestination$1(effects, ok2, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code2 === null || code2 === 32 || code2 === 41 || asciiControl$1(code2)) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code2);
  }
  function enclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code2);
  }
  function enclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding$1(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return enclosed;
    }
    return enclosed(code2);
  }
  function raw(code2) {
    if (!balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace$1(code2))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok2(code2);
    }
    if (balance < limit && code2 === 40) {
      effects.consume(code2);
      balance++;
      return raw;
    }
    if (code2 === 41) {
      effects.consume(code2);
      balance--;
      return raw;
    }
    if (code2 === null || code2 === 32 || code2 === 40 || asciiControl$1(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? rawEscape : raw;
  }
  function rawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return raw;
    }
    return raw(code2);
  }
}
function factoryLabel$1(effects, ok2, nok, type, markerType, stringType) {
  const self2 = this;
  let size2 = 0;
  let seen;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (size2 > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code2 === 94 && !size2 && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code2);
  }
  function labelInside(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding$1(code2) || size2++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    if (!seen) seen = !markdownSpace$1(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size2++;
      return labelInside;
    }
    return labelInside(code2);
  }
}
function factoryTitle$1(effects, ok2, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      marker = code2 === 40 ? 41 : code2;
      return begin;
    }
    return nok(code2);
  }
  function begin(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace$1(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? escape2 : inside2;
  }
  function escape2(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return inside2;
    }
    return inside2(code2);
  }
}
function factoryWhitespace$1(effects, ok2) {
  let seen;
  return start;
  function start(code2) {
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace$1(code2)) {
      return factorySpace$1(effects, start, seen ? "linePrefix" : "lineSuffix")(code2);
    }
    return ok2(code2);
  }
}
const definition$1 = {
  name: "definition",
  tokenize: tokenizeDefinition$1
};
const titleBefore$1 = {
  partial: true,
  tokenize: tokenizeTitleBefore$1
};
function tokenizeDefinition$1(effects, ok2, nok) {
  const self2 = this;
  let identifier;
  return start;
  function start(code2) {
    effects.enter("definition");
    return before2(code2);
  }
  function before2(code2) {
    return factoryLabel$1.call(
      self2,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier = normalizeIdentifier$1(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1));
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace$1(code2) ? factoryWhitespace$1(effects, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination$1(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects.attempt(titleBefore$1, after2, after2)(code2);
  }
  function after2(code2) {
    return markdownSpace$1(code2) ? factorySpace$1(effects, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier);
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitleBefore$1(effects, ok2, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace$1(code2) ? factoryWhitespace$1(effects, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle$1(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code2);
  }
  function titleAfter(code2) {
    return markdownSpace$1(code2) ? factorySpace$1(effects, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding$1(code2) ? ok2(code2) : nok(code2);
  }
}
const hardBreakEscape$1 = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape$1
};
function tokenizeHardBreakEscape$1(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.consume(code2);
    return after2;
  }
  function after2(code2) {
    if (markdownLineEnding$1(code2)) {
      effects.exit("hardBreakEscape");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const headingAtx$1 = {
  name: "headingAtx",
  resolve: resolveHeadingAtx$1,
  tokenize: tokenizeHeadingAtx$1
};
function resolveHeadingAtx$1(events2, context) {
  let contentEnd = events2.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events2[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events2[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events2[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events2[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end,
      contentType: "text"
    };
    splice$1(events2, contentStart, contentEnd - contentStart + 1, [["enter", content2, context], ["enter", text2, context], ["exit", text2, context], ["exit", content2, context]]);
  }
  return events2;
}
function tokenizeHeadingAtx$1(effects, ok2, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 35 && size2++ < 6) {
      effects.consume(code2);
      return sequenceOpen;
    }
    if (code2 === null || markdownLineEndingOrSpace$1(code2)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code2);
    }
    return nok(code2);
  }
  function atBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code2);
    }
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("atxHeading");
      return ok2(code2);
    }
    if (markdownSpace$1(code2)) {
      return factorySpace$1(effects, atBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequenceFurther(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace$1(code2)) {
      effects.exit("atxHeadingText");
      return atBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
const htmlBlockNames$1 = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames$1 = ["pre", "script", "style", "textarea"];
const htmlFlow$1 = {
  concrete: true,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow$1,
  tokenize: tokenizeHtmlFlow$1
};
const blankLineBefore$1 = {
  partial: true,
  tokenize: tokenizeBlankLineBefore$1
};
const nonLazyContinuationStart$1 = {
  partial: true,
  tokenize: tokenizeNonLazyContinuationStart$1
};
function resolveToHtmlFlow$1(events2) {
  let index2 = events2.length;
  while (index2--) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events2[index2 - 2][1].type === "linePrefix") {
    events2[index2][1].start = events2[index2 - 2][1].start;
    events2[index2 + 1][1].start = events2[index2 - 2][1].start;
    events2.splice(index2 - 2, 2);
  }
  return events2;
}
function tokenizeHtmlFlow$1(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer;
  let index2;
  let markerB;
  return start;
  function start(code2) {
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      closingTag = true;
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      marker = 3;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      marker = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      marker = 5;
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      marker = 4;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      if (index2 === value.length) {
        return self2.interrupt ? ok2 : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      const slash = code2 === 47;
      const name2 = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames$1.includes(name2)) {
        marker = 1;
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      if (htmlBlockNames$1.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2);
    }
    if (code2 === 45 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha$1(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      markerB = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === markerB) {
      effects.consume(code2);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding$1(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace$1(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace$1(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      return continuation(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && marker === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && marker === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && marker === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && marker === 5) {
      effects.consume(code2);
      return continuationCdataInside;
    }
    if (markdownLineEnding$1(code2) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore$1, continuationAfter, continuationStart)(code2);
    }
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("htmlFlowData");
      return continuationStart(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationStart(code2) {
    return effects.check(nonLazyContinuationStart$1, continuationStartNonLazy, continuationAfter)(code2);
  }
  function continuationStartNonLazy(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      return continuationStart(code2);
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name2 = buffer.toLowerCase();
      if (htmlRawNames$1.includes(name2)) {
        effects.consume(code2);
        return continuationClose;
      }
      return continuation(code2);
    }
    if (asciiAlpha$1(code2) && buffer.length < 8) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCdataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function continuationAfter(code2) {
    effects.exit("htmlFlow");
    return ok2(code2);
  }
}
function tokenizeNonLazyContinuationStart$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (markdownLineEnding$1(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
function tokenizeBlankLineBefore$1(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.attempt(blankLine$1, ok2, nok);
  }
}
const htmlText$1 = {
  name: "htmlText",
  tokenize: tokenizeHtmlText$1
};
function tokenizeHtmlText$1(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let index2;
  let returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      return declaration;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return nok(code2);
  }
  function comment2(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = comment2;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return comment2;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return comment2(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment2(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === value.length ? cdata : cdataOpenInside;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = cdata;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding$1(code2)) {
      returnState = declaration;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return declaration;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = instruction;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha$1(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding$1(code2)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha$1(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric$1(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding$1(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code2);
    }
    if (markdownSpace$1(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding$1(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace$1(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok2;
    }
    return nok(code2);
  }
  function lineEndingBefore(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace$1(code2) ? factorySpace$1(effects, lineEndingAfterPrefix, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
}
const labelEnd$1 = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd$1,
  resolveTo: resolveToLabelEnd$1,
  tokenize: tokenizeLabelEnd$1
};
const resourceConstruct$1 = {
  tokenize: tokenizeResource$1
};
const referenceFullConstruct$1 = {
  tokenize: tokenizeReferenceFull$1
};
const referenceCollapsedConstruct$1 = {
  tokenize: tokenizeReferenceCollapsed$1
};
function resolveAllLabelEnd$1(events2) {
  let index2 = -1;
  const newEvents = [];
  while (++index2 < events2.length) {
    const token = events2[index2][1];
    newEvents.push(events2[index2]);
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      const offset2 = token.type === "labelImage" ? 4 : 2;
      token.type = "data";
      index2 += offset2;
    }
  }
  if (events2.length !== newEvents.length) {
    splice$1(events2, 0, events2.length, newEvents);
  }
  return events2;
}
function resolveToLabelEnd$1(events2, context) {
  let index2 = events2.length;
  let offset2 = 0;
  let token;
  let open;
  let close;
  let media;
  while (index2--) {
    token = events2[index2][1];
    if (open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }
      if (events2[index2][0] === "enter" && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events2[index2][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index2;
        if (token.type !== "labelLink") {
          offset2 = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index2;
    }
  }
  const group2 = {
    type: events2[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  const label2 = {
    type: "label",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[close][1].end
    }
  };
  const text2 = {
    type: "labelText",
    start: {
      ...events2[open + offset2 + 2][1].end
    },
    end: {
      ...events2[close - 2][1].start
    }
  };
  media = [["enter", group2, context], ["enter", label2, context]];
  media = push$2(media, events2.slice(open + 1, open + offset2 + 3));
  media = push$2(media, [["enter", text2, context]]);
  media = push$2(media, resolveAll$1(context.parser.constructs.insideSpan.null, events2.slice(open + offset2 + 4, close - 3), context));
  media = push$2(media, [["exit", text2, context], events2[close - 2], events2[close - 1], ["exit", label2, context]]);
  media = push$2(media, events2.slice(close + 1));
  media = push$2(media, [["exit", group2, context]]);
  splice$1(events2, open, events2.length, media);
  return events2;
}
function tokenizeLabelEnd$1(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  let labelStart;
  let defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) {
      return labelEndNok(code2);
    }
    defined = self2.parser.defined.includes(normalizeIdentifier$1(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after2;
  }
  function after2(code2) {
    if (code2 === 40) {
      return effects.attempt(resourceConstruct$1, labelEndOk, defined ? labelEndOk : labelEndNok)(code2);
    }
    if (code2 === 91) {
      return effects.attempt(referenceFullConstruct$1, labelEndOk, defined ? referenceNotFull : labelEndNok)(code2);
    }
    return defined ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects.attempt(referenceCollapsedConstruct$1, labelEndOk, labelEndNok)(code2);
  }
  function labelEndOk(code2) {
    return ok2(code2);
  }
  function labelEndNok(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource$1(effects, ok2, nok) {
  return resourceStart;
  function resourceStart(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace$1(code2) ? factoryWhitespace$1(effects, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    if (code2 === 41) {
      return resourceEnd(code2);
    }
    return factoryDestination$1(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace$1(code2) ? factoryWhitespace$1(effects, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle$1(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code2);
    }
    return resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace$1(code2) ? factoryWhitespace$1(effects, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok2;
    }
    return nok(code2);
  }
}
function tokenizeReferenceFull$1(effects, ok2, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel$1.call(self2, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(normalizeIdentifier$1(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1))) ? ok2(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
function tokenizeReferenceCollapsed$1(effects, ok2, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok2;
    }
    return nok(code2);
  }
}
const labelStartImage$1 = {
  name: "labelStartImage",
  resolveAll: labelEnd$1.resolveAll,
  tokenize: tokenizeLabelStartImage$1
};
function tokenizeLabelStartImage$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const labelStartLink$1 = {
  name: "labelStartLink",
  resolveAll: labelEnd$1.resolveAll,
  tokenize: tokenizeLabelStartLink$1
};
function tokenizeLabelStartLink$1(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after2;
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const lineEnding$1 = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding$1
};
function tokenizeLineEnding$1(effects, ok2) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace$1(effects, ok2, "linePrefix");
  }
}
const thematicBreak$1 = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak$1
};
function tokenizeThematicBreak$1(effects, ok2, nok) {
  let size2 = 0;
  let marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    return before2(code2);
  }
  function before2(code2) {
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (size2 >= 3 && (code2 === null || markdownLineEnding$1(code2))) {
      effects.exit("thematicBreak");
      return ok2(code2);
    }
    return nok(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size2++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace$1(code2) ? factorySpace$1(effects, atBreak, "whitespace")(code2) : atBreak(code2);
  }
}
const list$1 = {
  continuation: {
    tokenize: tokenizeListContinuation$1
  },
  exit: tokenizeListEnd$1,
  name: "list",
  tokenize: tokenizeListStart$1
};
const listItemPrefixWhitespaceConstruct$1 = {
  partial: true,
  tokenize: tokenizeListItemPrefixWhitespace$1
};
const indentConstruct$1 = {
  partial: true,
  tokenize: tokenizeIndent$1
};
function tokenizeListStart$1(effects, ok2, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size2 = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit$1(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak$1, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside2(code2);
      }
    }
    return nok(code2);
  }
  function inside2(code2) {
    if (asciiDigit$1(code2) && ++size2 < 10) {
      effects.consume(code2);
      return inside2;
    }
    if ((!self2.interrupt || size2 < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      blankLine$1,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(listItemPrefixWhitespaceConstruct$1, endOfPrefix, otherPrefix)
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace$1(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok2(code2);
  }
}
function tokenizeListContinuation$1(effects, ok2, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine$1, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace$1(effects, ok2, "listItemIndent", self2.containerState.size + 1)(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace$1(code2)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct$1, ok2, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace$1(effects, effects.attempt(list$1, ok2, nok), "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
  }
}
function tokenizeIndent$1(effects, ok2, nok) {
  const self2 = this;
  return factorySpace$1(effects, afterPrefix, "listItemIndent", self2.containerState.size + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok2(code2) : nok(code2);
  }
}
function tokenizeListEnd$1(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace$1(effects, ok2, nok) {
  const self2 = this;
  return factorySpace$1(effects, afterPrefix, "listItemPrefixWhitespace", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace$1(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok2(code2) : nok(code2);
  }
}
const setextUnderline$1 = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline$1,
  tokenize: tokenizeSetextUnderline$1
};
function resolveToSetextUnderline$1(events2, context) {
  let index2 = events2.length;
  let content2;
  let text2;
  let definition2;
  while (index2--) {
    if (events2[index2][0] === "enter") {
      if (events2[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events2[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events2[index2][1].type === "content") {
        events2.splice(index2, 1);
      }
      if (!definition2 && events2[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  const heading2 = {
    type: "setextHeading",
    start: {
      ...events2[content2][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  events2[text2][1].type = "setextHeadingText";
  if (definition2) {
    events2.splice(text2, 0, ["enter", heading2, context]);
    events2.splice(definition2 + 1, 0, ["exit", events2[content2][1], context]);
    events2[content2][1].end = {
      ...events2[definition2][1].end
    };
  } else {
    events2[content2][1] = heading2;
  }
  events2.push(["exit", heading2, context]);
  return events2;
}
function tokenizeSetextUnderline$1(effects, ok2, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index2 = self2.events.length;
    let paragraph;
    while (index2--) {
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph = self2.events[index2][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code2;
      return before2(code2);
    }
    return nok(code2);
  }
  function before2(code2) {
    effects.enter("setextHeadingLineSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace$1(code2) ? factorySpace$1(effects, after2, "lineSuffix")(code2) : after2(code2);
  }
  function after2(code2) {
    if (code2 === null || markdownLineEnding$1(code2)) {
      effects.exit("setextHeadingLine");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const flow$1$1 = {
  tokenize: initializeFlow$1
};
function initializeFlow$1(effects) {
  const self2 = this;
  const initial2 = effects.attempt(
    // Try to parse a blank line.
    blankLine$1,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace$1(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content$3, afterConstruct)), "linePrefix"))
  );
  return initial2;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial2;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial2;
  }
}
const resolver$1 = {
  resolveAll: createResolver$1()
};
const string$1$1 = initializeFactory$1("string");
const text$1$1 = initializeFactory$1("text");
function initializeFactory$1(field) {
  return {
    resolveAll: createResolver$1(field === "text" ? resolveAllLineSuffixes$1 : void 0),
    tokenize: initializeText
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      if (code2 === null) {
        return true;
      }
      const list2 = constructs2[code2];
      let index2 = -1;
      if (list2) {
        while (++index2 < list2.length) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver$1(extraResolver) {
  return resolveAllText;
  function resolveAllText(events2, context) {
    let index2 = -1;
    let enter;
    while (++index2 <= events2.length) {
      if (enter === void 0) {
        if (events2[index2] && events2[index2][1].type === "data") {
          enter = index2;
          index2++;
        }
      } else if (!events2[index2] || events2[index2][1].type !== "data") {
        if (index2 !== enter + 2) {
          events2[enter][1].end = events2[index2 - 1][1].end;
          events2.splice(enter + 2, index2 - enter - 2);
          index2 = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events2, context) : events2;
  }
}
function resolveAllLineSuffixes$1(events2, context) {
  let eventIndex = 0;
  while (++eventIndex <= events2.length) {
    if ((eventIndex === events2.length || events2[eventIndex][1].type === "lineEnding") && events2[eventIndex - 1][1].type === "data") {
      const data = events2[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index2 = chunks.length;
      let bufferIndex = -1;
      let size2 = 0;
      let tabs;
      while (index2--) {
        const chunk2 = chunks[index2];
        if (typeof chunk2 === "string") {
          bufferIndex = chunk2.length;
          while (chunk2.charCodeAt(bufferIndex - 1) === 32) {
            size2++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } else if (chunk2 === -2) {
          tabs = true;
          size2++;
        } else if (chunk2 === -1) ;
        else {
          index2++;
          break;
        }
      }
      if (context._contentTypeTextTrailing && eventIndex === events2.length) {
        size2 = 0;
      }
      if (size2) {
        const token = {
          type: eventIndex === events2.length || tabs || size2 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex,
            _index: data.start._index + index2,
            line: data.end.line,
            column: data.end.column - size2,
            offset: data.end.offset - size2
          },
          end: {
            ...data.end
          }
        };
        data.end = {
          ...token.start
        };
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events2.splice(eventIndex, 0, ["enter", token, context], ["exit", token, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events2;
}
const document$1$1 = {
  [42]: list$1,
  [43]: list$1,
  [45]: list$1,
  [48]: list$1,
  [49]: list$1,
  [50]: list$1,
  [51]: list$1,
  [52]: list$1,
  [53]: list$1,
  [54]: list$1,
  [55]: list$1,
  [56]: list$1,
  [57]: list$1,
  [62]: blockQuote$1
};
const contentInitial$1 = {
  [91]: definition$1
};
const flowInitial$1 = {
  [-2]: codeIndented$1,
  [-1]: codeIndented$1,
  [32]: codeIndented$1
};
const flow$2 = {
  [35]: headingAtx$1,
  [42]: thematicBreak$1,
  [45]: [setextUnderline$1, thematicBreak$1],
  [60]: htmlFlow$1,
  [61]: setextUnderline$1,
  [95]: thematicBreak$1,
  [96]: codeFenced$1,
  [126]: codeFenced$1
};
const string$3 = {
  [38]: characterReference$1,
  [92]: characterEscape$1
};
const text$2 = {
  [-5]: lineEnding$1,
  [-4]: lineEnding$1,
  [-3]: lineEnding$1,
  [33]: labelStartImage$1,
  [38]: characterReference$1,
  [42]: attention$1,
  [60]: [autolink$1, htmlText$1],
  [91]: labelStartLink$1,
  [92]: [hardBreakEscape$1, characterEscape$1],
  [93]: labelEnd$1,
  [95]: attention$1,
  [96]: codeText$1
};
const insideSpan$1 = {
  null: [attention$1, resolver$1]
};
const attentionMarkers$1 = {
  null: [42, 95]
};
const disable$1 = {
  null: []
};
const defaultConstructs$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers: attentionMarkers$1,
  contentInitial: contentInitial$1,
  disable: disable$1,
  document: document$1$1,
  flow: flow$2,
  flowInitial: flowInitial$1,
  insideSpan: insideSpan$1,
  string: string$3,
  text: text$2
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer$1(parser2, initialize, from) {
  let point2 = {
    _bufferIndex: -1,
    _index: 0,
    line: from && from.line || 1,
    column: from && from.column || 1,
    offset: from && from.offset || 0
  };
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter,
    exit: exit2,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now,
    parser: parser2,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice2) {
    chunks = push$2(chunks, slice2);
    main2();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll$1(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token, expandTabs) {
    return serializeChunks$1(sliceStream(token), expandTabs);
  }
  function sliceStream(token) {
    return sliceChunks$1(chunks, token);
  }
  function now() {
    const {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    } = point2;
    return {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main2() {
    let chunkIndex;
    while (point2._index < chunks.length) {
      const chunk2 = chunks[point2._index];
      if (typeof chunk2 === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk2.length) {
          go2(chunk2.charCodeAt(point2._bufferIndex));
        }
      } else {
        go2(chunk2);
      }
    }
  }
  function go2(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding$1(code2)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
      // strings.
      /** @type {string} */
      chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(["enter", token, context]);
    stack.push(token);
    return token;
  }
  function exit2(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(["exit", token, context]);
    return token;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_2, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? (
        /* c8 ignore next 1 */
        handleListOfConstructs(constructs2)
      ) : "tokenize" in constructs2 ? (
        // Looks like a construct.
        handleListOfConstructs([
          /** @type {Construct} */
          constructs2
        ])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map2) {
        return start;
        function start(code2) {
          const left = code2 !== null && map2[code2];
          const all2 = code2 !== null && map2.null;
          const list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(left) ? left : left ? [left] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info = store2();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok2,
            nok
          )(code2);
        }
      }
      function ok2(code2) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code2) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from2) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice$1(context.events, from2, context.events.length - from2, construct.resolve(context.events.slice(from2), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store2() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
function sliceChunks$1(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks$1(chunks, expandTabs) {
  let index2 = -1;
  const result2 = [];
  let atTab;
  while (++index2 < chunks.length) {
    const chunk2 = chunks[index2];
    let value;
    if (typeof chunk2 === "string") {
      value = chunk2;
    } else switch (chunk2) {
      case -5: {
        value = "\r";
        break;
      }
      case -4: {
        value = "\n";
        break;
      }
      case -3: {
        value = "\r\n";
        break;
      }
      case -2: {
        value = expandTabs ? " " : "	";
        break;
      }
      case -1: {
        if (!expandTabs && atTab) continue;
        value = " ";
        break;
      }
      default: {
        value = String.fromCharCode(chunk2);
      }
    }
    atTab = chunk2 === -2;
    result2.push(value);
  }
  return result2.join("");
}
function parse$3(options2) {
  const settings = options2 || {};
  const constructs2 = (
    /** @type {FullNormalizedExtension} */
    combineExtensions$1([defaultConstructs$1, ...settings.extensions || []])
  );
  const parser2 = {
    constructs: constructs2,
    content: create2(content$1$1),
    defined: [],
    document: create2(document$2$1),
    flow: create2(flow$1$1),
    lazy: {},
    string: create2(string$1$1),
    text: create2(text$1$1)
  };
  return parser2;
  function create2(initial2) {
    return creator;
    function creator(from) {
      return createTokenizer$1(parser2, initial2, from);
    }
  }
}
function postprocess$1(events2) {
  while (!subtokenize$1(events2)) {
  }
  return events2;
}
const search$1 = /[\0\t\n\r]/g;
function preprocess$1() {
  let column = 1;
  let buffer = "";
  let start = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match2;
    let next;
    let startPosition;
    let endPosition;
    let code2;
    value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value));
    startPosition = 0;
    buffer = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search$1.lastIndex = startPosition;
      match2 = search$1.exec(value);
      endPosition = match2 && match2.index !== void 0 ? match2.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match2) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code2) {
          case 0: {
            chunks.push(65533);
            column++;
            break;
          }
          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);
            while (column++ < next) chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
function micromark$1(value, encoding, options2) {
  if (typeof encoding !== "string") {
    options2 = encoding;
    encoding = void 0;
  }
  return compile$1(options2)(postprocess$1(parse$3(options2).document().write(preprocess$1()(value, encoding, true))));
}
const defaultAllowedDiagnosticTags$1 = /* @__PURE__ */ new Set([
  "P",
  "CODE",
  "EM",
  "STRONG",
  "BR"
]);
function sanitizeDiagnosticHtml$1(html, allowedTags = defaultAllowedDiagnosticTags$1) {
  const template2 = document.createElement("template");
  template2.innerHTML = html;
  const walker = document.createTreeWalker(
    template2.content,
    NodeFilter.SHOW_ELEMENT
  );
  const elements2 = [];
  while (walker.nextNode()) {
    elements2.push(walker.currentNode);
  }
  for (const element2 of elements2) {
    if (!allowedTags.has(element2.tagName)) {
      element2.replaceWith(
        document.createTextNode(element2.textContent ?? "")
      );
      continue;
    }
    for (const { name: name2 } of Array.from(element2.attributes)) {
      element2.removeAttribute(name2);
    }
  }
  return template2.innerHTML;
}
const safeMarkdownOptions$1 = {
  allowDangerousHtml: false,
  allowDangerousProtocol: false
};
function renderDiagnosticMarkdownHtml$1(message) {
  return sanitizeDiagnosticHtml$1(micromark$1(message, safeMarkdownOptions$1));
}
const PATTERN$1 = /`([^`]+)`|\*\*([^*]+)\*\*|\*([^*]+)\*/g;
function parseInlineMarkdown$1(text2) {
  const tokens = [];
  let lastIndex = 0;
  let m2;
  while ((m2 = PATTERN$1.exec(text2)) !== null) {
    if (m2.index > lastIndex) {
      tokens.push({
        kind: "text",
        text: text2.slice(lastIndex, m2.index)
      });
    }
    if (m2[1] !== void 0) {
      tokens.push({ kind: "code", text: m2[1] });
    } else if (m2[2] !== void 0) {
      tokens.push({ kind: "strong", text: m2[2] });
    } else if (m2[3] !== void 0) {
      tokens.push({ kind: "em", text: m2[3] });
    }
    lastIndex = m2.index + m2[0].length;
  }
  if (lastIndex < text2.length) {
    tokens.push({ kind: "text", text: text2.slice(lastIndex) });
  }
  return tokens;
}
const MACRO_IDENTIFIER_CHAR_REGEX = /[A-Za-z0-9_-]/;
const MACRO_IDENTIFIER_SEGMENT_REGEX = /[A-Za-z0-9_-]+$/;
const MACRO_IDENTIFIER_BARE_VALUE_REGEX = /^[A-Za-z0-9_-]+$/;
function escapeHtml(str) {
  return str.replace(/&/g, "&amp;").replace(/</g, "&lt;").replace(/>/g, "&gt;").replace(/"/g, "&quot;").replace(/'/g, "&#39;");
}
const lspDiagnosticToName = {
  [browserExports$2.DiagnosticSeverity.Error]: "Error",
  [browserExports$2.DiagnosticSeverity.Warning]: "Warning",
  [browserExports$2.DiagnosticSeverity.Information]: "Info",
  [browserExports$2.DiagnosticSeverity.Hint]: "Hint"
};
const lspSeverityToCmSeverity = {
  [browserExports$2.DiagnosticSeverity.Error]: "error",
  [browserExports$2.DiagnosticSeverity.Warning]: "warning",
  [browserExports$2.DiagnosticSeverity.Information]: "info",
  [browserExports$2.DiagnosticSeverity.Hint]: "info"
};
function getDiagnosticHeadingClass({
  code: code2,
  source,
  markClass,
  cmSeverity
}) {
  if (code2 === "accessibility-level-1" || markClass?.includes("cm-doenet-accessibility-diagnostic-level-1") || source === "WCAG AA Accessibility Violation") {
    return "accessibility-level-1";
  }
  if (code2 === "accessibility-level-2" || markClass?.includes("cm-doenet-accessibility-diagnostic-level-2") || source === "Accessibility alert") {
    return "accessibility-level-2";
  }
  return cmSeverity;
}
const uniqueLanguageServerInstance = new LSP();
class LSPPlugin {
  constructor(documentId) {
    this.uri = "";
    this.value = "";
    this.diagnostics = [];
    this.docVersion = 0;
    this.reopenLatch = null;
    this._refreshLivePreview = (_current, from, to2, context) => {
      const text2 = context.state.sliceDoc(from, to2);
      if (text2.length === 0 || !MACRO_IDENTIFIER_BARE_VALUE_REGEX.test(text2)) {
        return { from, to: to2, options: [], filter: false };
      }
      const wrapped = `"${text2}"`;
      return {
        from,
        to: to2,
        options: [
          {
            label: text2,
            displayLabel: wrapped,
            apply: (view, _completion, applyFrom, applyTo) => {
              const doc2 = view.state.doc;
              let walk = applyFrom - 1;
              while (walk >= 0 && /\s/.test(doc2.sliceString(walk, walk + 1))) {
                walk -= 1;
              }
              const replaceFrom = walk >= 0 && doc2.sliceString(walk, walk + 1) === "=" ? walk + 1 : applyFrom;
              view.dispatch({
                changes: {
                  from: replaceFrom,
                  to: applyTo,
                  insert: wrapped
                },
                selection: {
                  anchor: replaceFrom + wrapped.length
                }
              });
            },
            // Attribute-value live-preview row; tag it with the shared
            // attribute-value type so its dropdown icon matches the
            // LSP-driven value rows instead of hardcoding the string.
            type: COMPLETION_TYPES.attributeValue
          }
        ],
        filter: false,
        update: this._refreshLivePreview
      };
    };
    this.documentId = documentId;
    this.uri = `file:///${documentId}.doenet`;
  }
  update(update) {
    const prevCompletionStatus = completionStatus(update.startState);
    const nextCompletionStatus = completionStatus(update.state);
    if (shouldInvalidateLatchDueToCursorNavigation(
      update,
      prevCompletionStatus
    )) {
      this.reopenLatch = null;
    }
    const value = update.state.doc.toString();
    if (update.docChanged) {
      this.setValue(value);
      const reopenState = getAutocompleteReopenState({
        update,
        reopenLatch: this.reopenLatch,
        docVersion: this.docVersion,
        prevCompletionStatus,
        nextCompletionStatus
      });
      this.reopenLatch = reopenState.reopenLatch;
      if (reopenState.shouldRestartCompletion) {
        setTimeout(() => {
          if (!this.view || this.view !== update.view) {
            return;
          }
          startCompletion(update.view);
        }, 0);
      }
      if (!reopenState.keepReopenLatchForNextChange) {
        this.reopenLatch = null;
      }
      this.docVersion += 1;
    }
  }
  async setValue(value) {
    if (value === this.value) {
      return;
    }
    await uniqueLanguageServerInstance.updateDocument(this.uri, value);
    this.value = value;
  }
  destroy() {
    this.unsubscribeDiagnostics?.();
    uniqueLanguageServerInstance.closeDocument(this.uri).catch(() => {
    });
  }
  processDiagnostics() {
    if (!this.view) {
      return;
    }
    const diagnostics = [];
    for (const diagnostic2 of this.diagnostics) {
      const { range: range2, message, severity, source, markClass, code: code2 } = diagnostic2;
      const cmSeverity = lspSeverityToCmSeverity[severity] ?? "info";
      const offsets = getValidDiagnosticOffsets(
        this.view.state.doc,
        range2
      );
      if (!offsets) {
        continue;
      }
      const { from, to: to2 } = offsets;
      diagnostics.push({
        from,
        to: to2,
        severity: cmSeverity,
        message,
        ...markClass ? { markClass } : {},
        renderMessage: () => {
          const div2 = document.createElement("div");
          const heading2 = source ?? lspDiagnosticToName[severity] ?? "Info";
          const headingClass = getDiagnosticHeadingClass({
            code: code2,
            source,
            markClass,
            cmSeverity
          });
          div2.innerHTML = `<div class="cm-lint-tooltip"><h4 class="${"heading " + headingClass}">${escapeHtml(
            heading2
          )}</h4><div class="cm-lint-body">${renderDiagnosticMarkdownHtml$1(message)}</div>
                            </div>`;
          return div2.firstChild;
        }
      });
    }
    diagnostics.sort((a2, b2) => {
      if (a2.from < b2.from) {
        return -1;
      } else if (a2.from > b2.from) {
        return 1;
      } else {
        return 0;
      }
    });
    const diagnosticTransaction = setDiagnostics(
      this.view.state,
      diagnostics
    );
    this.view.dispatch(diagnosticTransaction);
  }
  async getCompletions(context) {
    let { state, pos, explicit } = context;
    const line2 = state.doc.lineAt(pos);
    let triggerKind = browserExports$2.CompletionTriggerKind.Invoked;
    let triggerCharacter;
    const charBeforeCursor = line2.text[pos - line2.from - 1];
    const charBeforeParen = charBeforeCursor === "(" ? line2.text[pos - line2.from - 2] : "";
    let isClosingQuoteTrigger = false;
    if (charBeforeCursor === '"' || charBeforeCursor === "'") {
      const quote2 = charBeforeCursor;
      const cursorCol = pos - line2.from;
      let quoteCount = 0;
      for (let k2 = cursorCol - 2; k2 >= 0; k2--) {
        const c2 = line2.text[k2];
        if (c2 === "<") break;
        if (c2 === quote2) quoteCount++;
      }
      isClosingQuoteTrigger = quoteCount % 2 === 1;
    }
    const precedingServerTriggerCharacter = !isClosingQuoteTrigger && uniqueLanguageServerInstance.completionTriggers.includes(
      charBeforeCursor
    );
    const precedingLocalRefTriggerCharacter = charBeforeCursor === "$" || charBeforeCursor === "." || charBeforeCursor === "(" && (charBeforeParen === "$" || charBeforeParen === ".");
    let postWhitespaceTrigger = false;
    if (charBeforeCursor && /\s/.test(charBeforeCursor)) {
      const cursorCol = pos - line2.from;
      let i2 = cursorCol - 1;
      while (i2 >= 0 && /\s/.test(line2.text[i2])) i2--;
      if (i2 >= 0 && line2.text[i2] === "=") {
        postWhitespaceTrigger = true;
      }
    }
    if (!explicit && precedingServerTriggerCharacter) {
      triggerKind = browserExports$2.CompletionTriggerKind.TriggerCharacter;
      triggerCharacter = charBeforeCursor;
    }
    if (triggerKind === browserExports$2.CompletionTriggerKind.Invoked && !context.matchBefore(MACRO_IDENTIFIER_SEGMENT_REGEX) && !precedingServerTriggerCharacter && !precedingLocalRefTriggerCharacter && !postWhitespaceTrigger && !explicit) {
      return null;
    }
    const position2 = offsetToPos(state.doc, pos);
    const result2 = await uniqueLanguageServerInstance.getCompletionItems(
      this.uri,
      { line: position2.line, character: position2.character },
      {
        triggerKind,
        triggerCharacter,
        // Forward the explicit (Ctrl+Space) signal so the server can
        // open the element menu even with no preceding `<` (e.g.
        // between tags). `triggerKind` alone can't carry this: typing
        // an identifier also reports `Invoked`.
        explicit
      }
    );
    if (!this.view) {
      return null;
    }
    if (!result2) {
      return null;
    }
    const items = "items" in result2 ? result2.items : result2;
    let options2 = items.map((rawItem) => {
      const {
        detail,
        label: label2,
        kind,
        textEdit,
        documentation,
        sortText,
        filterText,
        data,
        displayLabel
      } = rawItem;
      const completion = {
        label: label2,
        detail,
        apply: textEdit?.newText ?? label2,
        type: deriveCompletionType(rawItem),
        sortText: sortText ?? label2,
        filterText: filterText ?? label2
      };
      if (displayLabel) {
        completion.displayLabel = displayLabel;
      }
      if (documentation) {
        completion.info = renderDocumentation(documentation);
      }
      if (textEdit && "range" in textEdit) {
        completion._lspTextEditRange = textEdit.range;
      }
      const snippetCursor = getSnippetCursorFromCompletionItemData(data);
      if (snippetCursor) {
        completion._snippetCursor = snippetCursor;
      }
      return completion;
    });
    const [span, match2] = prefixMatch(options2);
    const token = context.matchBefore(match2);
    const isElementNameMenu = options2.length > 0 && options2.every(
      (option) => option.type === COMPLETION_TYPES.component || option.type === COMPLETION_TYPES.snippet || option.type === COMPLETION_TYPES.closeTag
    );
    function filterOptionsForWord(wordLower) {
      options2 = options2.filter(({ filterText }) => {
        const filterLower = filterText.toLowerCase();
        return isElementNameMenu ? filterLower.includes(wordLower) : filterLower.startsWith(wordLower);
      });
    }
    if (token) {
      let word = token.text;
      let fromOffset = 0;
      const lastLt = word.lastIndexOf("<");
      const lastGt = word.lastIndexOf(">");
      if (lastLt > lastGt) {
        fromOffset = lastLt + 1;
      } else if (lastGt >= 0) {
        fromOffset = lastGt + 1;
      }
      word = word.slice(fromOffset);
      pos = token.from + fromOffset;
      const wordLower = word.toLowerCase();
      if (wordLower && MACRO_IDENTIFIER_SEGMENT_REGEX.test(wordLower)) {
        filterOptionsForWord(wordLower);
      }
    } else if (isElementNameMenu) {
      const bareElementToken = context.matchBefore(
        MACRO_IDENTIFIER_SEGMENT_REGEX
      );
      if (bareElementToken) {
        pos = bareElementToken.from;
        filterOptionsForWord(bareElementToken.text.toLowerCase());
      }
    }
    if (options2.length === 0) {
      return null;
    }
    const finalOptions = options2.map((opt) => {
      if (opt._lspTextEditRange) {
        const startPos = normalizePos(opt._lspTextEditRange.start);
        const endPos = normalizePos(opt._lspTextEditRange.end);
        if (startPos && endPos) {
          const insertText = typeof opt.apply === "string" ? opt.apply : "";
          opt.apply = (view, _completion, from, to2) => {
            const rangeStart = posToOffset(
              view.state.doc,
              startPos
            );
            const rangeEnd2 = posToOffset(view.state.doc, endPos);
            const replaceFrom = rangeStart == null ? from : Math.min(rangeStart, from);
            const replaceTo = rangeEnd2 == null ? to2 : Math.max(rangeEnd2, to2);
            const selection2 = getSelectionFromSnippetCursor(
              opt._snippetCursor,
              replaceFrom,
              insertText.length
            ) || {
              anchor: replaceFrom + insertText.length,
              head: replaceFrom + insertText.length
            };
            view.dispatch({
              changes: {
                from: replaceFrom,
                to: replaceTo,
                insert: insertText
              },
              selection: selection2
            });
          };
        }
      }
      return opt;
    });
    const livePreviewMarker = items.map((item) => getLivePreviewQuoteWrap(item.data)).find((m2) => m2 !== void 0);
    if (livePreviewMarker) {
      return {
        from: livePreviewMarker.bareValueStartOffset,
        options: finalOptions,
        filter: false,
        update: this._refreshLivePreview
      };
    }
    const elementMenuHasTypedLt = isElementNameMenu && pos > 0 && state.sliceDoc(pos - 1, pos) === "<";
    return {
      from: pos,
      options: finalOptions,
      ...elementMenuHasTypedLt ? {} : {
        validFor: new RegExp(
          `^${MACRO_IDENTIFIER_CHAR_REGEX.source}*$`
        )
      }
    };
  }
}
const lspPlugin = (documentId, doenetWorkerUrl) => {
  uniqueLanguageServerInstance.setDoenetWorkerUrl(doenetWorkerUrl);
  const plugin = new LSPPlugin(documentId);
  return [
    ViewPlugin.define((view) => {
      plugin.view = view;
      plugin.unsubscribeDiagnostics = uniqueLanguageServerInstance.onDiagnostics(
        plugin.uri,
        (params) => {
          plugin.diagnostics = params.diagnostics;
          plugin.processDiagnostics();
        }
      );
      plugin.setValue(view.state.doc.toString());
      return plugin;
    }),
    hoverTooltip((view, pos) => {
      return null;
    }),
    autocompletion({
      override: [plugin.getCompletions.bind(plugin)]
    })
  ];
};
function posToOffset(doc2, pos) {
  if (pos.line >= doc2.lines) {
    return;
  }
  const offset2 = doc2.line(pos.line + 1).from + pos.character;
  if (offset2 > doc2.length) {
    return;
  }
  return offset2;
}
function offsetToPos(doc2, offset2) {
  const line2 = doc2.lineAt(offset2);
  return {
    line: line2.number - 1,
    character: offset2 - line2.from
  };
}
function getCurrentWordToken(doc2, head) {
  const safeHead = Math.max(0, Math.min(head, doc2.length));
  const line2 = doc2.lineAt(safeHead);
  const beforeCursor = line2.text.slice(0, safeHead - line2.from);
  const match2 = beforeCursor.match(MACRO_IDENTIFIER_SEGMENT_REGEX);
  if (!match2) {
    return null;
  }
  return {
    text: match2[0],
    from: safeHead - match2[0].length
  };
}
function shouldInvalidateLatchDueToCursorNavigation(update, prevCompletionStatus) {
  const startSel = update.startState.selection.main;
  const nextSel = update.state.selection.main;
  const selectionMoved = startSel.head !== nextSel.head || startSel.anchor !== nextSel.anchor;
  return update.selectionSet && selectionMoved && !update.docChanged && !prevCompletionStatus;
}
function getTransactionChangeSummary(update) {
  const isDeleteEvent = update.transactions.every((tr2) => {
    const userEvent = tr2.annotation(Transaction.userEvent);
    return typeof userEvent === "string" && userEvent.startsWith("delete");
  });
  let deletedCount = 0;
  let insertedCount = 0;
  for (const tr2 of update.transactions) {
    tr2.changes.iterChanges((fromA, toA, fromB, toB) => {
      if (toA > fromA) {
        deletedCount += toA - fromA;
      }
      if (toB > fromB) {
        insertedCount += toB - fromB;
      }
    });
  }
  return {
    isDeleteEvent,
    deletedCount,
    insertedCount
  };
}
function getAutocompleteReopenState({
  update,
  reopenLatch,
  docVersion,
  prevCompletionStatus,
  nextCompletionStatus
}) {
  const head = update.state.selection.main.head;
  const line2 = update.state.doc.lineAt(head);
  const charBefore2 = line2.text.charAt(head - line2.from - 1);
  const charBeforeParen = charBefore2 === "(" ? line2.text.charAt(head - line2.from - 2) : "";
  const { isDeleteEvent, deletedCount, insertedCount } = getTransactionChangeSummary(update);
  const currentToken = getCurrentWordToken(update.state.doc, head);
  const tokenPrefixChar = currentToken ? (() => {
    const immediatePrefix = update.state.doc.sliceString(
      Math.max(0, currentToken.from - 1),
      currentToken.from
    );
    if (immediatePrefix !== "(") {
      return immediatePrefix;
    }
    return update.state.doc.sliceString(
      Math.max(0, currentToken.from - 2),
      Math.max(0, currentToken.from - 1)
    );
  })() : "";
  const previousHead = update.startState.selection.main.head;
  const previousToken = getCurrentWordToken(
    update.startState.doc,
    previousHead
  );
  let nextReopenLatch = reopenLatch;
  let keepReopenLatchForNextChange = false;
  const latchEvaluation = evaluateReopenLatchTransition({
    reopenLatch,
    docVersion,
    previousToken,
    currentToken,
    tokenPrefixChar,
    isDeleteEvent,
    deletedCount,
    insertedCount
  });
  if (latchEvaluation.keepReopenLatchForNextChange && nextReopenLatch) {
    keepReopenLatchForNextChange = true;
    nextReopenLatch = {
      ...nextReopenLatch,
      docVersion: docVersion + 1
    };
  }
  const reopenedFromCloseTransition = createReopenLatchFromCloseTransition({
    prevCompletionStatus,
    nextCompletionStatus,
    insertedCount,
    deletedCount,
    currentToken,
    previousToken,
    tokenPrefixChar,
    docVersion
  });
  if (reopenedFromCloseTransition) {
    nextReopenLatch = reopenedFromCloseTransition;
    keepReopenLatchForNextChange = true;
  }
  return {
    reopenLatch: nextReopenLatch,
    keepReopenLatchForNextChange,
    shouldRestartCompletion: charBefore2 === "$" || charBefore2 === "." || charBefore2 === "(" && (charBeforeParen === "$" || charBeforeParen === ".") || latchEvaluation.shouldReopenFromLatch
  };
}
function normalizePos(rangePos) {
  if (!rangePos) {
    return null;
  }
  if ("character" in rangePos) {
    return rangePos;
  }
  if ("column" in rangePos) {
    return {
      line: rangePos.line - 1,
      character: rangePos.column - 1
    };
  }
  return null;
}
function getValidDiagnosticOffsets(doc2, range2) {
  const startPos = normalizePos(range2?.start);
  const endPos = normalizePos(range2?.end);
  if (!startPos || !endPos) {
    return null;
  }
  const startOffset = posToOffset(doc2, startPos);
  const endOffset = posToOffset(doc2, endPos);
  if (startOffset == null || endOffset == null || !Number.isFinite(startOffset) || !Number.isFinite(endOffset)) {
    return null;
  }
  return {
    from: Math.min(startOffset, endOffset),
    to: Math.max(startOffset, endOffset)
  };
}
function setToRegex(chars) {
  let preamble = "";
  let flat = Array.from(chars).join("");
  const words = /\w/.test(flat);
  if (words) {
    preamble += "\\w";
    flat = flat.replace(/\w/g, "");
  }
  return `[${preamble}${flat.replace(/[^\w\s]/g, "\\$&")}]`;
}
function prefixMatch(options2) {
  const first2 = [];
  const rest2 = [];
  for (const completion of options2) {
    const textToAnalyze = completion.apply;
    if (typeof textToAnalyze !== "string" || textToAnalyze.length === 0) {
      continue;
    }
    first2.push(textToAnalyze.charAt(0));
    rest2.push(...textToAnalyze.slice(1).split(""));
  }
  const source = setToRegex(new Set(first2)) + setToRegex(new Set(rest2)) + "*$";
  return [new RegExp("^" + source), new RegExp(source)];
}
function getSelectionFromSnippetCursor(snippetCursor, insertStart, insertTextLength) {
  if (!snippetCursor) {
    return null;
  }
  if ("caretOffset" in snippetCursor) {
    if (snippetCursor.caretOffset > insertTextLength) {
      return null;
    }
    const position2 = insertStart + snippetCursor.caretOffset;
    return {
      anchor: position2,
      head: position2
    };
  }
  if (snippetCursor.selectionStartOffset > insertTextLength || snippetCursor.selectionEndOffset > insertTextLength || snippetCursor.selectionStartOffset > snippetCursor.selectionEndOffset) {
    return null;
  }
  return {
    anchor: insertStart + snippetCursor.selectionStartOffset,
    head: insertStart + snippetCursor.selectionEndOffset
  };
}
function formatContents(contents) {
  if (Array.isArray(contents)) {
    return contents.map((c2) => formatContents(c2) + "\n\n").join("");
  } else if (typeof contents === "string") {
    return contents;
  } else {
    return contents.value;
  }
}
function renderDocumentation(contents) {
  const text2 = formatContents(contents);
  if (!isMarkdown(contents)) {
    return text2;
  }
  return () => {
    const div2 = document.createElement("div");
    appendInlineMarkdown(div2, text2);
    return div2;
  };
}
function isMarkdown(contents) {
  if (Array.isArray(contents)) {
    return contents.some((c2) => isMarkdown(c2));
  }
  if (typeof contents === "string") {
    return false;
  }
  return "kind" in contents && contents.kind === "markdown";
}
function appendInlineMarkdown(parent, text2) {
  for (const token of parseInlineMarkdown$1(text2)) {
    if (token.kind === "text") {
      parent.appendChild(document.createTextNode(token.text));
    } else {
      const el = document.createElement(token.kind);
      el.textContent = token.text;
      parent.appendChild(el);
    }
  }
}
function getGutterColors(darkMode) {
  if (darkMode === "dark") {
    return {
      backgroundColor: "#1e1e1e",
      textColor: "#8b949e",
      borderRight: "1px solid #333",
      activeLineBackgroundColor: "#363636"
    };
  }
  return {
    backgroundColor: "var(--mainGray)",
    textColor: "#595959",
    borderRight: "none",
    activeLineBackgroundColor: "var(--lightBlue)"
  };
}
function colorTheme(darkMode) {
  const gutterColors = getGutterColors(darkMode);
  return EditorView.theme({
    "&": {
      color: "var(--canvasText)",
      height: "100%",
      backgroundColor: "var(--canvas)"
    },
    ".cm-content": {
      caretColor: "#0e9"
    },
    "&.cm-focused .cm-cursor": {
      borderLeftColor: "var(--canvasText)"
    },
    "&.cm-focused .cm-selectionBackground, ::selection": {
      backgroundColor: "var(--mainGray)"
    },
    "&.cm-focused": {
      color: "var(--canvasText)"
    },
    ".cm-gutters": {
      backgroundColor: gutterColors.backgroundColor,
      color: gutterColors.textColor,
      border: "none",
      borderRight: gutterColors.borderRight
    },
    ".cm-activeLine": {
      backgroundColor: "#50505020",
      // Must be explicit: CodeMirror's base theme sets activeLine color
      // to a dark value which is invisible on a dark canvas.
      color: "var(--canvasText)"
    },
    // Subtle gutter highlight on the active line — CodeMirror's base
    // theme uses #e2f2ff (light blue) which is glaring on a dark gutter.
    ".cm-activeLineGutter": {
      backgroundColor: gutterColors.activeLineBackgroundColor
    }
  });
}
function getCompletionIconColors(darkMode) {
  if (darkMode === "dark") {
    return {
      // Verified ≥4.5:1 on #2a2a2a (the dark tooltip surface)
      component: "#58a6ff",
      // blue   ~7.6:1
      enumAttr: "#3fb950",
      // green  ~7.0:1
      value: "#4dd0e1",
      // teal   ~8.8:1
      reference: "#bc8cff",
      // purple ~6.5:1
      snippet: "#f78166"
      // orange ~6.3:1
    };
  }
  return {
    // Verified ≥4.5:1 on white dropdown
    component: "#1f6feb",
    // blue
    enumAttr: "#1a7f37",
    // green
    value: "#0e7c86",
    // teal
    reference: "#8250df",
    // purple
    snippet: "#bc4c00"
    // orange
  };
}
function completionIconTheme(darkMode) {
  const colors = getCompletionIconColors(darkMode);
  return EditorView.theme({
    ".cm-completionIcon-component::after": { content: '"\\25C8"' },
    // ◈
    ".cm-completionIcon-refproperty::after": { content: '"."' },
    ".cm-completionIcon-closetag::after": { content: '"/"' },
    ".cm-completionIcon-enum::after": { content: '"@"' },
    // attribute name
    ".cm-completionIcon-value::after": { content: '"\\25AA"' },
    // ▪ (enum value)
    ".cm-completionIcon-reference::after": { content: '"$"' },
    ".cm-completionIcon-snippet::after": { content: '"\\274F"' },
    // ❏
    ".cm-completionIcon-component": {
      color: colors.component,
      opacity: "1"
    },
    ".cm-completionIcon-enum": { color: colors.enumAttr, opacity: "1" },
    ".cm-completionIcon-value": { color: colors.value, opacity: "1" },
    ".cm-completionIcon-reference": {
      color: colors.reference,
      opacity: "1"
    },
    ".cm-completionIcon-refproperty": {
      color: colors.reference,
      opacity: "1"
    },
    ".cm-completionIcon-snippet": { color: colors.snippet, opacity: "1" },
    ".cm-completionIcon-closetag": {
      color: colors.component,
      opacity: "1"
    },
    // The highlighted option has a solid blue background (CodeMirror's
    // baseTheme: #17c light / #347 dark, with white label text), against
    // which the category colors above are nearly invisible. Render the
    // glyph white on the selected row so it stays legible, matching the
    // label. The descendant selector outranks the single-class color rules
    // above, so it wins regardless of order.
    ".cm-tooltip-autocomplete ul li[aria-selected] .cm-completionIcon": {
      color: "#fff",
      opacity: "1"
    }
  });
}
function readOnlyColorTheme(darkMode) {
  const gutterColors = getGutterColors(darkMode);
  const lineTextColor = darkMode === "dark" ? "#c8c8c8" : "#595959";
  const activeLineBackgroundColor = darkMode === "dark" ? "#50505020" : "var(--mainGray)";
  return EditorView.theme({
    "&": {
      color: "var(--canvasText)",
      height: "100%"
    },
    ".cm-content": {
      caretColor: "#0e9",
      backgroundColor: "#77777720"
    },
    "&.cm-focused .cm-cursor": {
      borderLeftColor: "var(--canvasText)"
    },
    "&.cm-focused .cm-selectionBackground, ::selection": {
      backgroundColor: "var(--mainGray)"
    },
    "&.cm-focused": {
      color: "var(--canvasText)"
    },
    ".cm-gutters": {
      backgroundColor: gutterColors.backgroundColor,
      color: gutterColors.textColor,
      border: "none",
      borderRight: gutterColors.borderRight
    },
    ".cm-activeLine": {
      backgroundColor: activeLineBackgroundColor,
      color: "var(--canvasText)"
    },
    ".cm-activeLineGutter": {
      backgroundColor: gutterColors.activeLineBackgroundColor
    },
    ".cm-line": {
      color: lineTextColor
    }
  });
}
const CodeMirror = React__default.memo(function CodeMirror2({
  value,
  onChange,
  onCursorChange,
  onSelectedCompletionChange,
  readOnly: readOnly2,
  onBlur,
  onFocus,
  languageServerRef,
  ariaLabel = "DoenetML code editor",
  doenetWorkerUrl,
  darkMode = "light"
}) {
  const [documentId, _2] = React__default.useState(
    () => Math.floor(Math.random() * 1e5).toString()
  );
  React__default.useEffect(() => {
    return () => {
      if (readOnly2) {
        return;
      }
      const uri = `file:///${documentId}.doenet`;
      uniqueLanguageServerInstance.closeDocument(uri);
    };
  }, [documentId, readOnly2]);
  React__default.useEffect(() => {
    if (!languageServerRef) {
      return;
    }
    languageServerRef.current = {
      lsp: uniqueLanguageServerInstance,
      documentUri: `file:///${documentId}.doenet`
    };
  }, [languageServerRef]);
  const extensions = React__default.useMemo(() => {
    const extensions2 = [
      syntaxHighlightingExtension(darkMode),
      readOnly2 ? readOnlyColorTheme(darkMode) : colorTheme(darkMode),
      EditorView.lineWrapping,
      // Add aria-label to the contenteditable element for accessibility
      EditorView.contentAttributes.of({ "aria-label": ariaLabel })
    ];
    if (!readOnly2) {
      extensions2.push(tabExtension);
      extensions2.push(autoCloseTagExtension);
      extensions2.push(lspPlugin(documentId, doenetWorkerUrl));
      extensions2.push(completionIconTheme(darkMode));
    } else {
      extensions2.push(EditorState.readOnly.of(true));
    }
    return extensions2;
  }, [documentId, readOnly2, ariaLabel, doenetWorkerUrl, darkMode]);
  return /* @__PURE__ */ React__default.createElement(
    "div",
    {
      className: "mathjax_ignore",
      "data-theme": darkMode,
      style: { height: "100%" }
    },
    /* @__PURE__ */ React__default.createElement(
      ReactCodeMirror,
      {
        style: { height: "100%" },
        value,
        basicSetup: {
          indentOnInput: true,
          highlightActiveLine: !readOnly2,
          highlightActiveLineGutter: !readOnly2
        },
        onChange: (editor, update) => {
          if (onChange) {
            onChange(update.state.doc.toString());
          }
        },
        onUpdate: (viewUpdate) => {
          for (const tr2 of viewUpdate.transactions) {
            if (tr2.selection && onCursorChange) {
              onCursorChange(tr2.selection);
            }
          }
          if (onSelectedCompletionChange) {
            const prev = selectedCompletion(viewUpdate.startState);
            const next = selectedCompletion(viewUpdate.state);
            if (prev !== next) {
              onSelectedCompletionChange(next);
            }
          }
        },
        onBlur,
        onFocus,
        height: "100%",
        extensions
      }
    )
  );
});
const FocusableContext = createContext(true);
function toArray(arg) {
  if (Array.isArray(arg)) return arg;
  return typeof arg !== "undefined" ? [arg] : [];
}
function flatten2DArray(array) {
  const flattened2 = [];
  for (const row of array) flattened2.push(...row);
  return flattened2;
}
function reverseArray(array) {
  return array.slice().reverse();
}
function noop$1(..._2) {
}
function applyState(argument, currentValue) {
  if (isUpdater(argument)) return argument(isLazyValue(currentValue) ? currentValue() : currentValue);
  return argument;
}
function isUpdater(argument) {
  return typeof argument === "function";
}
function isLazyValue(value) {
  return typeof value === "function";
}
function hasOwnProperty$2(object2, prop) {
  if (typeof Object.hasOwn === "function") return Object.hasOwn(object2, prop);
  return Object.prototype.hasOwnProperty.call(object2, prop);
}
function chain(...fns) {
  return (...args) => {
    for (const fn2 of fns) if (typeof fn2 === "function") fn2(...args);
  };
}
function normalizeString(str) {
  return str.normalize("NFD").replace(/[\u0300-\u036f]/g, "");
}
function omit$1(object2, keys2) {
  const result2 = { ...object2 };
  for (const key of keys2) if (hasOwnProperty$2(result2, key)) delete result2[key];
  return result2;
}
function pick$1(object2, paths) {
  const result2 = {};
  for (const key of paths) if (hasOwnProperty$2(object2, key)) result2[key] = object2[key];
  return result2;
}
function identity(value) {
  return value;
}
function afterPaint(cb2 = noop$1) {
  let raf = requestAnimationFrame(() => {
    raf = requestAnimationFrame(cb2);
  });
  return () => cancelAnimationFrame(raf);
}
function invariant(condition, message) {
  if (condition) return;
  if (typeof message !== "string") throw new Error("Invariant failed");
  throw new Error(message);
}
function getKeys(obj) {
  return Object.keys(obj);
}
function isFalsyBooleanCallback(booleanOrCallback, ...args) {
  const result2 = typeof booleanOrCallback === "function" ? booleanOrCallback(...args) : booleanOrCallback;
  if (result2 == null) return false;
  return !result2;
}
function disabledFromProps(props2) {
  return props2.disabled || props2["aria-disabled"] === true || props2["aria-disabled"] === "true";
}
function disabledFromElement(element2) {
  if (element2.getAttribute("aria-disabled") === "true") return true;
  if ("disabled" in element2 && element2.disabled === true) return true;
  return false;
}
function removeUndefinedValues(obj) {
  const result2 = {};
  for (const key in obj) if (obj[key] !== void 0) result2[key] = obj[key];
  return result2;
}
function defaultValue(...values2) {
  for (const value of values2) if (value !== void 0) return value;
}
const canUseDOM = checkIsBrowser();
function checkIsBrowser() {
  return typeof window !== "undefined" && !!window.document?.createElement;
}
function getDocument(node) {
  if (!node) return document;
  if ("self" in node) return node.document;
  return node.ownerDocument || document;
}
function getWindow$1(node) {
  if (!node) return self;
  if ("self" in node) return node.self;
  return getDocument(node).defaultView || window;
}
function getActiveElement(node, activeDescendant = false) {
  const { activeElement } = getDocument(node);
  if (!activeElement?.nodeName) return null;
  if (isFrame(activeElement) && activeElement.contentDocument?.body) return getActiveElement(activeElement.contentDocument.body, activeDescendant);
  if (activeDescendant) {
    const id2 = activeElement.getAttribute("aria-activedescendant");
    if (id2) {
      const element2 = getDocument(activeElement).getElementById(id2);
      if (element2) return element2;
    }
  }
  return activeElement;
}
function contains(parent, child) {
  return parent === child || parent.contains(child);
}
function isElement$2(target) {
  return target?.nodeType === 1;
}
function isNode$1(target) {
  return typeof target?.nodeType === "number";
}
function isFrame(element2) {
  return element2.tagName === "IFRAME";
}
function isButton(element2) {
  const tagName = element2.tagName.toLowerCase();
  if (tagName === "button") return true;
  if (tagName === "input" && element2.type) return buttonInputTypes.indexOf(element2.type) !== -1;
  return false;
}
const buttonInputTypes = [
  "button",
  "color",
  "file",
  "image",
  "reset",
  "submit"
];
function isVisible(element2) {
  if (typeof element2.checkVisibility === "function") return element2.checkVisibility();
  const htmlElement = element2;
  return htmlElement.offsetWidth > 0 || htmlElement.offsetHeight > 0 || element2.getClientRects().length > 0;
}
function isTextField(element2) {
  try {
    if (element2.tagName === "TEXTAREA") return true;
    if (element2.tagName !== "INPUT") return false;
    return element2.selectionStart !== null;
  } catch (_error) {
    return false;
  }
}
function isTextbox(element2) {
  return element2.isContentEditable || isTextField(element2);
}
function getTextboxValue(element2) {
  if (isTextField(element2)) return element2.value;
  if (element2.isContentEditable) {
    const range2 = getDocument(element2).createRange();
    range2.selectNodeContents(element2);
    return range2.toString();
  }
  return "";
}
function getTextboxSelection(element2) {
  let start = 0;
  let end = 0;
  if (isTextField(element2)) {
    start = element2.selectionStart || 0;
    end = element2.selectionEnd || 0;
  } else if (element2.isContentEditable) {
    const selection2 = getDocument(element2).getSelection();
    if (selection2?.rangeCount && selection2.anchorNode && contains(element2, selection2.anchorNode) && selection2.focusNode && contains(element2, selection2.focusNode)) {
      const range2 = selection2.getRangeAt(0);
      const nextRange = range2.cloneRange();
      nextRange.selectNodeContents(element2);
      nextRange.setEnd(range2.startContainer, range2.startOffset);
      start = nextRange.toString().length;
      nextRange.setEnd(range2.endContainer, range2.endOffset);
      end = nextRange.toString().length;
    }
  }
  return {
    start,
    end
  };
}
const allowedPopupRoles = [
  "dialog",
  "menu",
  "listbox",
  "tree",
  "grid"
];
const itemRoleByPopupRole = {
  menu: "menuitem",
  listbox: "option",
  tree: "treeitem"
};
function getPopupRole(element2, fallback) {
  const role = element2?.getAttribute("role");
  if (role && allowedPopupRoles.indexOf(role) !== -1) return role;
  return fallback;
}
function getItemRoleByPopupRole(popupRole) {
  if (popupRole == null) return;
  if (!hasOwnProperty$2(itemRoleByPopupRole, popupRole)) return;
  return itemRoleByPopupRole[popupRole];
}
function getPopupItemRole(element2, fallback) {
  const popupRole = getPopupRole(element2);
  if (typeof popupRole !== "string") return fallback;
  return getItemRoleByPopupRole(popupRole) ?? fallback;
}
function getScrollingElement(element2) {
  if (!element2) return null;
  const isScrollableOverflow = (overflow) => {
    if (overflow === "auto") return true;
    if (overflow === "scroll") return true;
    return false;
  };
  if (element2.clientHeight && element2.scrollHeight > element2.clientHeight) {
    const { overflowY } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowY)) return element2;
  } else if (element2.clientWidth && element2.scrollWidth > element2.clientWidth) {
    const { overflowX } = getComputedStyle(element2);
    if (isScrollableOverflow(overflowX)) return element2;
  }
  const doc2 = getDocument(element2);
  return getScrollingElement(element2.parentElement) || doc2.scrollingElement || doc2.body;
}
function setSelectionRange(element2, ...args) {
  if (/text|search|password|tel|url/i.test(element2.type)) element2.setSelectionRange(...args);
}
function sortBasedOnDOMPosition(items, getElement) {
  const pairs2 = items.map((item, index2) => [index2, item]);
  let isOrderDifferent = false;
  pairs2.sort(([indexA, a2], [indexB, b2]) => {
    const elementA = getElement(a2);
    const elementB = getElement(b2);
    if (elementA === elementB) return 0;
    if (!elementA || !elementB) return 0;
    if (isElementPreceding(elementA, elementB)) {
      if (indexA > indexB) isOrderDifferent = true;
      return -1;
    }
    if (indexA < indexB) isOrderDifferent = true;
    return 1;
  });
  if (isOrderDifferent) return pairs2.map(([_2, item]) => item);
  return items;
}
function isElementPreceding(a2, b2) {
  return Boolean(b2.compareDocumentPosition(a2) & Node.DOCUMENT_POSITION_PRECEDING);
}
function isTouchDevice() {
  return canUseDOM && !!navigator.maxTouchPoints;
}
function isApple() {
  if (!canUseDOM) return false;
  return /mac|iphone|ipad|ipod/i.test(navigator.platform);
}
function isSafari() {
  return canUseDOM && isApple() && /apple/i.test(navigator.vendor);
}
function isFirefox() {
  return canUseDOM && /firefox\//i.test(navigator.userAgent);
}
function isMac() {
  return canUseDOM && navigator.platform.startsWith("Mac") && !isTouchDevice();
}
function isPortalEvent(event) {
  const { currentTarget, target } = event;
  if (!currentTarget) return false;
  if (!isNode$1(target)) return true;
  return !contains(currentTarget, target);
}
function isSelfTarget(event) {
  return event.target === event.currentTarget;
}
function isActivatableNavigationTarget(element2) {
  if (!isElement$2(element2)) return false;
  const target = element2;
  const tagName = target.tagName.toLowerCase();
  if (tagName === "a") return true;
  if (tagName === "button" && target.type === "submit") return true;
  if (tagName === "input" && target.type === "submit") return true;
  return false;
}
function isOpeningInNewTab(event) {
  const isAppleDevice = isApple();
  if (isAppleDevice && !event.metaKey) return false;
  if (!isAppleDevice && !event.ctrlKey) return false;
  return isActivatableNavigationTarget(event.currentTarget);
}
function isDownloading(event) {
  if (!event.altKey) return false;
  return isActivatableNavigationTarget(event.currentTarget);
}
function fireEvent(element2, type, eventInit) {
  const event = new Event(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireBlurEvent(element2, eventInit) {
  const event = new FocusEvent("blur", eventInit);
  const defaultAllowed = element2.dispatchEvent(event);
  const bubbleInit = {
    ...eventInit,
    bubbles: true
  };
  element2.dispatchEvent(new FocusEvent("focusout", bubbleInit));
  return defaultAllowed;
}
function fireKeyboardEvent(element2, type, eventInit) {
  const event = new KeyboardEvent(type, eventInit);
  return element2.dispatchEvent(event);
}
function fireClickEvent(element2, eventInit) {
  const event = new MouseEvent("click", eventInit);
  return element2.dispatchEvent(event);
}
function isFocusEventOutside(event, container) {
  const containerElement = container || event.currentTarget;
  const relatedTarget = event.relatedTarget;
  return !isNode$1(relatedTarget) || !contains(containerElement, relatedTarget);
}
function isInputEvent(event) {
  return event.type === "input";
}
function queueBeforeEvent(element2, type, callback, timeout) {
  const createTimer = (callback2) => {
    const timerId = requestAnimationFrame(callback2);
    return () => cancelAnimationFrame(timerId);
  };
  const cancelTimer = createTimer(() => {
    element2.removeEventListener(type, callSync, true);
    callback();
  });
  const callSync = () => {
    cancelTimer();
    callback();
  };
  element2.addEventListener(type, callSync, {
    once: true,
    capture: true
  });
  return () => {
    cancelTimer();
    element2.removeEventListener(type, callSync, true);
  };
}
function addGlobalEventListener(type, listener, options2, scope = window) {
  const children = [];
  try {
    scope.document.addEventListener(type, listener, options2);
    for (const frame of Array.from(scope.frames)) children.push(addGlobalEventListener(type, listener, options2, frame));
  } catch {
  }
  const removeEventListener2 = () => {
    try {
      scope.document.removeEventListener(type, listener, options2);
    } catch {
    }
    for (const remove2 of children) remove2();
  };
  return removeEventListener2;
}
const selector = "input:not([type='hidden']):not([disabled]), select:not([disabled]), textarea:not([disabled]), a[href], button:not([disabled]), [tabindex], summary, iframe, object, embed, area[href], audio[controls], video[controls], [contenteditable]:not([contenteditable='false'])";
function hasNegativeTabIndex(element2) {
  return Number.parseInt(element2.getAttribute("tabindex") || "0", 10) < 0;
}
function isFocusable(element2) {
  if (!element2.matches(selector)) return false;
  if (!isVisible(element2)) return false;
  if (element2.closest("[inert]")) return false;
  return true;
}
function isTabbable(element2) {
  if (!isFocusable(element2)) return false;
  if (hasNegativeTabIndex(element2)) return false;
  if (!("form" in element2)) return true;
  if (!element2.form) return true;
  if (element2.checked) return true;
  if (element2.type !== "radio") return true;
  const radioGroup = element2.form.elements.namedItem(element2.name);
  if (!radioGroup) return true;
  if (!("length" in radioGroup)) return true;
  const activeElement = getActiveElement(element2);
  if (!activeElement) return true;
  if (activeElement === element2) return true;
  if (!("form" in activeElement)) return true;
  if (activeElement.form !== element2.form) return true;
  if (activeElement.name !== element2.name) return true;
  return false;
}
function getAllFocusableIn(container, includeContainer) {
  const elements2 = Array.from(container.querySelectorAll(selector));
  if (includeContainer) elements2.unshift(container);
  const focusableElements = elements2.filter(isFocusable);
  focusableElements.forEach((element2, i2) => {
    if (!isFrame(element2)) return;
    const frameBody = element2.contentDocument?.body;
    if (!frameBody) return;
    focusableElements.splice(i2, 1, ...getAllFocusableIn(frameBody));
  });
  return focusableElements;
}
function getFirstFocusableIn(container, includeContainer) {
  const [first2] = getAllFocusableIn(container, includeContainer);
  return first2 || null;
}
function getAllTabbableIn(container, includeContainer, fallbackToFocusable) {
  const tabbableElements = Array.from(container.querySelectorAll(selector)).filter(isTabbable);
  if (includeContainer && isTabbable(container)) tabbableElements.unshift(container);
  tabbableElements.forEach((element2, i2) => {
    if (!isFrame(element2)) return;
    const frameBody = element2.contentDocument?.body;
    if (!frameBody) return;
    const allFrameTabbable = getAllTabbableIn(frameBody, false, fallbackToFocusable);
    tabbableElements.splice(i2, 1, ...allFrameTabbable);
  });
  if (!tabbableElements.length && fallbackToFocusable) ;
  return tabbableElements;
}
function getFirstTabbableIn(container, includeContainer, fallbackToFocusable) {
  if (includeContainer && isTabbable(container)) {
    if (!isFrame(container)) return container;
    const containerFrameBody = container.contentDocument?.body;
    if (!containerFrameBody) return container;
    const frameTabbable = getFirstTabbableIn(containerFrameBody, false, fallbackToFocusable);
    if (frameTabbable) return frameTabbable;
  }
  const elements2 = container.querySelectorAll(selector);
  for (const element2 of elements2) {
    if (!isTabbable(element2)) continue;
    if (isFrame(element2)) {
      const frameBody = element2.contentDocument?.body;
      if (!frameBody) return element2;
      const frameTabbable = getFirstTabbableIn(frameBody, false, fallbackToFocusable);
      if (frameTabbable) return frameTabbable;
      continue;
    }
    return element2;
  }
  if (fallbackToFocusable) return getFirstFocusableIn(container);
  return null;
}
function getTabbableInDirection({ container, includeContainer, reverse, fallbackToEdge, fallbackToFocusable }) {
  const activeElement = getActiveElement(container);
  const allFocusable = getAllFocusableIn(container, includeContainer);
  if (reverse) allFocusable.reverse();
  const activeIndex = allFocusable.indexOf(activeElement);
  const candidates = allFocusable.slice(activeIndex + 1);
  return candidates.find(isTabbable) || (fallbackToEdge ? allFocusable.find(isTabbable) : null) || (fallbackToFocusable ? candidates[0] : null) || null;
}
function getNextTabbableIn(container, includeContainer, fallbackToFirst, fallbackToFocusable) {
  return getTabbableInDirection({
    container,
    includeContainer,
    fallbackToEdge: fallbackToFirst,
    fallbackToFocusable
  });
}
function getNextTabbable(fallbackToFirst, fallbackToFocusable) {
  return getNextTabbableIn(document.body, false, fallbackToFirst, fallbackToFocusable);
}
function getPreviousTabbableIn(container, includeContainer, fallbackToLast, fallbackToFocusable) {
  return getTabbableInDirection({
    container,
    includeContainer,
    reverse: true,
    fallbackToEdge: fallbackToLast,
    fallbackToFocusable
  });
}
function getPreviousTabbable(fallbackToLast, fallbackToFocusable) {
  return getPreviousTabbableIn(document.body, false, fallbackToLast, fallbackToFocusable);
}
function hasFocus(element2) {
  const activeElement = getActiveElement(element2);
  if (!activeElement) return false;
  if (activeElement === element2) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  return activeDescendant === element2.id;
}
function hasFocusWithin(element2) {
  const activeElement = getActiveElement(element2);
  if (!activeElement) return false;
  if (contains(element2, activeElement)) return true;
  const activeDescendant = activeElement.getAttribute("aria-activedescendant");
  if (!activeDescendant) return false;
  if (!("id" in element2)) return false;
  if (activeDescendant === element2.id) return true;
  return !!element2.querySelector(`#${CSS.escape(activeDescendant)}`);
}
function disableFocus(element2) {
  const currentTabindex = element2.getAttribute("tabindex") ?? "";
  element2.setAttribute("data-tabindex", currentTabindex);
  element2.setAttribute("tabindex", "-1");
}
function disableFocusIn(container, includeContainer) {
  const tabbableElements = getAllTabbableIn(container, includeContainer);
  for (const element2 of tabbableElements) disableFocus(element2);
}
function restoreFocusIn(container) {
  const elements2 = container.querySelectorAll("[data-tabindex]");
  const restoreTabIndex = (element2) => {
    const tabindex = element2.getAttribute("data-tabindex");
    element2.removeAttribute("data-tabindex");
    if (tabindex) element2.setAttribute("tabindex", tabindex);
    else element2.removeAttribute("tabindex");
  };
  if (container.hasAttribute("data-tabindex")) restoreTabIndex(container);
  for (const element2 of elements2) restoreTabIndex(element2);
}
function focusIntoView(element2, options2) {
  if (!("scrollIntoView" in element2)) element2.focus();
  else {
    element2.focus({ preventScroll: true });
    element2.scrollIntoView({
      block: "nearest",
      inline: "nearest",
      ...options2
    });
  }
}
function createUndoCallback(callback) {
  return async () => {
    const redo2 = await callback?.();
    return createUndoCallback(async () => {
      await redo2?.();
      return callback;
    });
  };
}
createUndoManager();
function createUndoManager({ limit = 100 } = {}) {
  const undoStack = [];
  let redoStack = [];
  let currentGroup = null;
  const canUndo = () => undoStack.length > 0;
  const canRedo = () => redoStack.length > 0;
  const undo2 = async () => {
    if (!canUndo()) return;
    currentGroup = null;
    redoStack.push(await undoStack.pop()?.());
  };
  const redo2 = async () => {
    if (!canRedo()) return;
    currentGroup = null;
    undoStack.push(await redoStack.pop()?.());
  };
  const execute = async (callback, group2) => {
    if (!callback) return;
    const sameGroup = group2 === currentGroup;
    currentGroup = group2 ?? null;
    const nextIndex = sameGroup ? Math.max(0, undoStack.length - 1) : undoStack.length;
    const undoCallback = await callback();
    if (!undoCallback) return;
    redoStack = [];
    const currentUndo = undoStack[nextIndex];
    undoStack[nextIndex] = createUndoCallback(async () => {
      await undoCallback?.();
      const currentRedo = await currentUndo?.();
      return async () => {
        await currentRedo?.();
        await callback?.();
      };
    });
    while (undoStack.length > limit) undoStack.shift();
  };
  return {
    canUndo,
    canRedo,
    undo: undo2,
    redo: redo2,
    execute
  };
}
function setRef(ref, value) {
  if (typeof ref === "function") {
    const cleanup = ref(value);
    if (typeof cleanup === "function") return cleanup;
  } else if (ref) ref.current = value;
}
function isValidElementWithRef(element2) {
  if (!element2) return false;
  if (!isValidElement(element2)) return false;
  if ("ref" in element2.props) return true;
  if ("ref" in element2) return true;
  return false;
}
function getRefProperty(element2) {
  if (!isValidElementWithRef(element2)) return null;
  return { ...element2.props }.ref || element2.ref;
}
function mergeProps(base2, overrides2) {
  const props2 = { ...base2 };
  for (const key in overrides2) {
    if (!hasOwnProperty$2(overrides2, key)) continue;
    if (key === "className") {
      const prop = "className";
      const baseClass = base2[prop];
      const overrideClass = overrides2[prop];
      if (baseClass && overrideClass) props2[prop] = `${baseClass} ${overrideClass}`;
      else props2[prop] = overrideClass || baseClass;
      continue;
    }
    if (key === "style") {
      const prop = "style";
      props2[prop] = base2[prop] ? {
        ...base2[prop],
        ...overrides2[prop]
      } : overrides2[prop];
      continue;
    }
    const overrideValue = overrides2[key];
    if (key.startsWith("on")) {
      if (typeof overrideValue !== "function") continue;
      const baseValue = base2[key];
      if (typeof baseValue === "function") {
        props2[key] = (...args) => {
          overrideValue(...args);
          baseValue(...args);
        };
        continue;
      }
    }
    props2[key] = overrideValue;
  }
  return props2;
}
const _React = { ...React };
const useReactId = _React.useId;
const useReactInsertionEffect = _React.useInsertionEffect;
const useSafeLayoutEffect = canUseDOM ? useLayoutEffect : useEffect;
function useInitialValue(value) {
  const [initialValue] = useState(value);
  return initialValue;
}
function useLiveRef(value) {
  const ref = useRef(value);
  useSafeLayoutEffect(() => {
    ref.current = value;
  });
  return ref;
}
function useEvent(callback) {
  const ref = useRef(() => {
    throw new Error("Cannot call an event handler while rendering.");
  });
  if (useReactInsertionEffect) useReactInsertionEffect(() => {
    ref.current = callback;
  });
  else ref.current = callback;
  return useCallback((...args) => ref.current?.(...args), []);
}
function useTransactionState(callback) {
  const [state, setState] = useState(null);
  useSafeLayoutEffect(() => {
    if (state == null) return;
    if (!callback) return;
    let prevState = null;
    callback((prev) => {
      prevState = prev;
      return state;
    });
    return () => {
      callback(prevState);
    };
  }, [state, callback]);
  return [state, setState];
}
function useMergeRefs(...refs) {
  return useMemo(() => {
    if (!refs.some(Boolean)) return;
    return (value) => {
      const refEffects = [];
      for (const ref of refs) {
        if (!ref) continue;
        const cleanup = setRef(ref, value);
        refEffects.push({
          ref,
          cleanup: typeof cleanup === "function" ? cleanup : void 0
        });
      }
      if (!refEffects.some((effect) => effect.cleanup)) return;
      return () => {
        for (const { ref, cleanup } of refEffects) if (cleanup) cleanup();
        else setRef(ref, null);
      };
    };
  }, refs);
}
function useId(defaultId) {
  if (useReactId) {
    const reactId = useReactId();
    if (defaultId) return defaultId;
    return reactId;
  }
  const [id2, setId] = useState(defaultId);
  useSafeLayoutEffect(() => {
    if (defaultId || id2) return;
    setId(`id-${Math.random().toString(36).slice(2, 8)}`);
  }, [defaultId, id2]);
  return defaultId || id2;
}
function useTagName(refOrElement, type) {
  const stringOrUndefined = (type2) => {
    if (typeof type2 !== "string") return;
    return type2;
  };
  const [tagName, setTagName] = useState(() => stringOrUndefined(type));
  useSafeLayoutEffect(() => {
    setTagName((refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement)?.tagName.toLowerCase() || stringOrUndefined(type));
  }, [refOrElement, type]);
  return tagName;
}
function useAttribute(refOrElement, attributeName, defaultValue2) {
  const initialValue = useInitialValue(defaultValue2);
  const [attribute, setAttribute2] = useState(initialValue);
  useEffect(() => {
    const element2 = refOrElement && "current" in refOrElement ? refOrElement.current : refOrElement;
    if (!element2) return;
    const callback = () => {
      const value = element2.getAttribute(attributeName);
      setAttribute2(value == null ? initialValue : value);
    };
    const observer = new MutationObserver(callback);
    observer.observe(element2, { attributeFilter: [attributeName] });
    callback();
    return () => observer.disconnect();
  }, [
    refOrElement,
    attributeName,
    initialValue
  ]);
  return attribute;
}
function useUpdateEffect(effect, deps) {
  const mounted = useRef(false);
  useEffect(() => {
    if (mounted.current) return effect();
    mounted.current = true;
  }, deps);
  useEffect(() => () => {
    mounted.current = false;
  }, []);
}
function useUpdateLayoutEffect(effect, deps) {
  const mounted = useRef(false);
  useSafeLayoutEffect(() => {
    if (mounted.current) return effect();
    mounted.current = true;
  }, deps);
  useSafeLayoutEffect(() => () => {
    mounted.current = false;
  }, []);
}
function useForceUpdate() {
  return useReducer(() => [], []);
}
function useBooleanEvent(booleanOrCallback) {
  return useEvent(typeof booleanOrCallback === "function" ? booleanOrCallback : () => booleanOrCallback);
}
function useWrapElement(props2, callback, deps = []) {
  const wrapElement = useCallback((element2) => {
    if (props2.wrapElement) element2 = props2.wrapElement(element2);
    return callback(element2);
  }, [...deps, props2.wrapElement]);
  return {
    ...props2,
    wrapElement
  };
}
function usePortalRef(portalProp = false, portalRefProp) {
  const [portalNode, setPortalNode] = useState(null);
  return {
    portalRef: useMergeRefs(setPortalNode, portalRefProp),
    portalNode,
    domReady: !portalProp || portalNode
  };
}
function useMetadataProps(props2, key, value) {
  const parent = props2.onLoadedMetadataCapture;
  const onLoadedMetadataCapture = useMemo(() => {
    return Object.assign(() => {
    }, parent, ...value !== void 0 ? [{ [key]: value }] : []);
  }, [
    parent,
    key,
    value
  ]);
  return [parent?.[key], { onLoadedMetadataCapture }];
}
let hasInstalledGlobalEventListeners$1 = false;
function useIsMouseMoving() {
  useEffect(() => {
    if (hasInstalledGlobalEventListeners$1) return;
    addGlobalEventListener("mousemove", setMouseMoving, true);
    addGlobalEventListener("mousedown", resetMouseMoving, true);
    addGlobalEventListener("mouseup", resetMouseMoving, true);
    addGlobalEventListener("keydown", resetMouseMoving, true);
    addGlobalEventListener("scroll", resetMouseMoving, true);
    hasInstalledGlobalEventListeners$1 = true;
  }, []);
  return useEvent(() => mouseMoving);
}
let mouseMoving = false;
let previousScreenX = 0;
let previousScreenY = 0;
function hasMouseMovement(event) {
  const movementX = event.movementX || event.screenX - previousScreenX;
  const movementY = event.movementY || event.screenY - previousScreenY;
  previousScreenX = event.screenX;
  previousScreenY = event.screenY;
  return movementX || movementY || process.env.NODE_ENV === "test";
}
function setMouseMoving(event) {
  if (!hasMouseMovement(event)) return;
  mouseMoving = true;
}
function resetMouseMoving() {
  mouseMoving = false;
}
function forwardRef(render) {
  const Role3 = React.forwardRef((props2, ref) => render({
    ...props2,
    ref
  }));
  Role3.displayName = render.displayName || render.name;
  return Role3;
}
function memo(Component, propsAreEqual) {
  return React.memo(Component, propsAreEqual);
}
function createElement(Type, props2) {
  const { wrapElement, render, ...rest2 } = props2;
  const mergedRef = useMergeRefs(props2.ref, getRefProperty(render));
  let element2;
  if (React.isValidElement(render)) {
    const renderProps = {
      ...render.props,
      ref: mergedRef
    };
    element2 = React.cloneElement(render, mergeProps(rest2, renderProps));
  } else if (render) element2 = render(rest2);
  else element2 = /* @__PURE__ */ jsxRuntimeExports$3.jsx(Type, { ...rest2 });
  if (wrapElement) return wrapElement(element2);
  return element2;
}
function createHook(useProps) {
  const useRole2 = (props2 = {}) => {
    return useProps(props2);
  };
  useRole2.displayName = useProps.name;
  return useRole2;
}
function createStoreContext(providers = [], scopedProviders = []) {
  const context = React.createContext(void 0);
  const scopedContext = React.createContext(void 0);
  const useContext2 = () => React.useContext(context);
  const useScopedContext = (onlyScoped = false) => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (onlyScoped) return scoped;
    return scoped || store2;
  };
  const useProviderContext = () => {
    const scoped = React.useContext(scopedContext);
    const store2 = useContext2();
    if (scoped && scoped === store2) return;
    return store2;
  };
  const ContextProvider = (props2) => {
    return providers.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider2, {
      ...props2,
      children
    }), /* @__PURE__ */ jsxRuntimeExports$3.jsx(context.Provider, { ...props2 }));
  };
  const ScopedContextProvider = (props2) => {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(ContextProvider, {
      ...props2,
      children: scopedProviders.reduceRight((children, Provider2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider2, {
        ...props2,
        children
      }), /* @__PURE__ */ jsxRuntimeExports$3.jsx(scopedContext.Provider, { ...props2 }))
    });
  };
  return {
    context,
    scopedContext,
    useContext: useContext2,
    useScopedContext,
    useProviderContext,
    ContextProvider,
    ScopedContextProvider
  };
}
const TagName$B = "div";
const accessibleWhenDisabledSymbol = /* @__PURE__ */ Symbol("accessibleWhenDisabled");
const isSafariBrowser$1 = isSafari();
const alwaysFocusVisibleInputTypes = [
  "text",
  "search",
  "url",
  "tel",
  "email",
  "password",
  "number",
  "date",
  "month",
  "week",
  "time",
  "datetime",
  "datetime-local"
];
function isAlwaysFocusVisible(element2) {
  const { tagName, readOnly: readOnly2, type } = element2;
  if (tagName === "TEXTAREA" && !readOnly2) return true;
  if (tagName === "SELECT" && !readOnly2) return true;
  if (tagName === "INPUT" && !readOnly2) return alwaysFocusVisibleInputTypes.includes(type);
  if (element2.isContentEditable) return true;
  if (element2.getAttribute("role") === "combobox" && element2.dataset.name) return true;
  return false;
}
function isNativeTabbable(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "summary" || tagName === "input" || tagName === "select" || tagName === "textarea" || tagName === "a";
}
function supportsDisabledAttribute(tagName) {
  if (!tagName) return true;
  return tagName === "button" || tagName === "input" || tagName === "select" || tagName === "textarea";
}
function isNativeSubmitControl(element2) {
  if (element2.tagName === "BUTTON") {
    const { type } = element2;
    return type === "submit";
  }
  if (element2.tagName === "INPUT") {
    const { type } = element2;
    return type === "submit" || type === "image";
  }
  return false;
}
function getTabIndex({ focusable, trulyDisabled, nativeTabbable, supportsDisabled, safariTabIndex, tabIndexProp }) {
  if (!focusable) return tabIndexProp;
  if (trulyDisabled) {
    if (nativeTabbable && !supportsDisabled) return -1;
    return;
  }
  if (nativeTabbable) {
    if (safariTabIndex && tabIndexProp == null) return 0;
    return tabIndexProp;
  }
  return tabIndexProp ?? 0;
}
function useDisableEvent(onEvent, disabled) {
  return useEvent((event) => {
    onEvent?.(event);
    if (event.defaultPrevented) return;
    if (disabled) {
      event.stopPropagation();
      event.preventDefault();
    }
  });
}
let hasInstalledGlobalEventListeners = false;
let isKeyboardModality = true;
function onGlobalMouseDown(event) {
  const target = event.target;
  if (isElement$2(target) && !target.hasAttribute("data-focus-visible")) isKeyboardModality = false;
}
function onGlobalKeyDown(event) {
  if (event.metaKey) return;
  if (event.ctrlKey) return;
  if (event.altKey) return;
  isKeyboardModality = true;
}
const useFocusable = createHook(function useFocusable3({ focusable = true, accessibleWhenDisabled, autoFocus, onFocusVisible, ...props2 }) {
  const ref = useRef(null);
  const [parentAccessibleWhenDisabled, metadataProps] = useMetadataProps(props2, accessibleWhenDisabledSymbol, accessibleWhenDisabled);
  accessibleWhenDisabled ??= parentAccessibleWhenDisabled;
  useEffect(() => {
    if (!focusable) return;
    if (hasInstalledGlobalEventListeners) return;
    addGlobalEventListener("mousedown", onGlobalMouseDown, true);
    addGlobalEventListener("keydown", onGlobalKeyDown, true);
    hasInstalledGlobalEventListeners = true;
  }, [focusable]);
  const disabled = focusable && disabledFromProps(props2);
  const trulyDisabled = disabled && !accessibleWhenDisabled;
  const [focusVisible, setFocusVisible] = useState(false);
  const focusVisibleRef = useRef(false);
  const nativeSubmitObserverCleanupRef = useRef(null);
  const cleanupFocusVisible = useEvent((element2) => {
    nativeSubmitObserverCleanupRef.current?.();
    nativeSubmitObserverCleanupRef.current = null;
    focusVisibleRef.current = false;
    element2?.removeAttribute("data-focus-visible");
  });
  useEffect(() => {
    if (!focusable) return;
    if (!trulyDisabled) return;
    cleanupFocusVisible(ref.current);
    if (focusVisible) setFocusVisible(false);
  }, [
    focusable,
    trulyDisabled,
    focusVisible,
    cleanupFocusVisible
  ]);
  useEffect(() => {
    if (!focusable) return;
    if (!focusVisible) return;
    const element2 = ref.current;
    if (!element2) return;
    if (typeof IntersectionObserver === "undefined") return;
    const observer = new IntersectionObserver(() => {
      if (!isFocusable(element2)) {
        focusVisibleRef.current = false;
        setFocusVisible(false);
      }
    });
    observer.observe(element2);
    return () => observer.disconnect();
  }, [focusable, focusVisible]);
  useEffect(() => {
    return () => nativeSubmitObserverCleanupRef.current?.();
  }, []);
  const onKeyPressCapture = useDisableEvent(props2.onKeyPressCapture, disabled);
  const onMouseDownCapture = useDisableEvent(props2.onMouseDownCapture, disabled);
  const onClickCapture = useDisableEvent(props2.onClickCapture, disabled);
  const handleFocusVisible = (event, currentTarget) => {
    if (currentTarget) event.currentTarget = currentTarget;
    if (!focusable) return;
    const element2 = event.currentTarget;
    if (!element2) return;
    if (!hasFocus(element2)) return;
    onFocusVisible?.(event);
    if (event.defaultPrevented) return;
    element2.dataset.focusVisible = "true";
    focusVisibleRef.current = true;
    if (isNativeSubmitControl(element2)) {
      nativeSubmitObserverCleanupRef.current?.();
      nativeSubmitObserverCleanupRef.current = null;
      if (typeof IntersectionObserver !== "undefined") {
        const observer = new IntersectionObserver(() => {
          if (isFocusable(element2)) return;
          cleanupFocusVisible(element2);
        });
        observer.observe(element2);
        nativeSubmitObserverCleanupRef.current = () => observer.disconnect();
      }
      return;
    }
    setFocusVisible(true);
  };
  const onKeyDownCaptureProp = props2.onKeyDownCapture;
  const onKeyDownCapture = useEvent((event) => {
    onKeyDownCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (focusVisible) return;
    if (focusVisibleRef.current) return;
    if (event.metaKey) return;
    if (event.altKey) return;
    if (event.ctrlKey) return;
    if (!isSelfTarget(event)) return;
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    queueBeforeEvent(element2, "focusout", applyFocusVisible);
  });
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!focusable) return;
    if (!isSelfTarget(event)) {
      setFocusVisible(false);
      return;
    }
    const element2 = event.currentTarget;
    const applyFocusVisible = () => handleFocusVisible(event, element2);
    if (isKeyboardModality || isAlwaysFocusVisible(event.target)) queueBeforeEvent(event.target, "focusout", applyFocusVisible);
    else setFocusVisible(false);
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent((event) => {
    onBlurProp?.(event);
    if (!focusable) return;
    if (!isFocusEventOutside(event)) return;
    cleanupFocusVisible(event.currentTarget);
    setFocusVisible(false);
  });
  const autoFocusOnShow = useContext(FocusableContext);
  const autoFocusRef = useEvent((element2) => {
    if (!focusable) return;
    if (!autoFocus) return;
    if (!element2) return;
    if (!autoFocusOnShow) return;
    queueMicrotask(() => {
      if (hasFocus(element2)) return;
      if (!isFocusable(element2)) return;
      element2.focus();
    });
  });
  const tagName = useTagName(ref);
  const nativeTabbable = focusable && isNativeTabbable(tagName);
  const supportsDisabled = focusable && supportsDisabledAttribute(tagName);
  const [safariTabIndex, setSafariTabIndex] = useState(false);
  if (isSafariBrowser$1) useEffect(() => {
    if (!focusable) return;
    const element2 = ref.current;
    if (!element2) return;
    const { type } = element2;
    const isNativeCheckboxOrRadio = element2.tagName === "INPUT" && (type === "checkbox" || type === "radio");
    setSafariTabIndex(isButton(element2) || isNativeCheckboxOrRadio);
  }, [focusable]);
  const styleProp = props2.style;
  const style = useMemo(() => {
    if (trulyDisabled) return {
      pointerEvents: "none",
      ...styleProp
    };
    return styleProp;
  }, [trulyDisabled, styleProp]);
  props2 = {
    "data-focus-visible": focusable && focusVisible || void 0,
    "data-autofocus": autoFocus || void 0,
    "aria-disabled": disabled || void 0,
    ...props2,
    ...metadataProps,
    ref: useMergeRefs(ref, autoFocusRef, props2.ref),
    style,
    tabIndex: getTabIndex({
      focusable,
      trulyDisabled,
      nativeTabbable,
      supportsDisabled,
      safariTabIndex,
      tabIndexProp: props2.tabIndex
    }),
    disabled: supportsDisabled && trulyDisabled ? true : void 0,
    contentEditable: disabled ? void 0 : props2.contentEditable,
    onKeyPressCapture,
    onClickCapture,
    onMouseDownCapture,
    onKeyDownCapture,
    onFocusCapture,
    onBlur
  };
  return removeUndefinedValues(props2);
});
forwardRef(function Focusable3(props2) {
  return createElement(TagName$B, useFocusable(props2));
});
const TagName$A = "button";
function isNativeClick(event) {
  if (!event.isTrusted) return false;
  const element2 = event.currentTarget;
  if (event.key === "Enter") return isButton(element2) || element2.tagName === "SUMMARY" || element2.tagName === "A";
  if (event.key === " ") return isButton(element2) || element2.tagName === "SUMMARY" || element2.tagName === "INPUT" || element2.tagName === "SELECT";
  return false;
}
const symbol$2 = /* @__PURE__ */ Symbol("command");
const useCommand = createHook(function useCommand3({ clickOnEnter = true, clickOnSpace = true, ...props2 }) {
  const ref = useRef(null);
  const [isNativeButton, setIsNativeButton] = useState(false);
  useEffect(() => {
    if (!ref.current) return;
    setIsNativeButton(isButton(ref.current));
  }, []);
  const [active, setActive] = useState(false);
  const activeRef = useRef(false);
  const disabled = disabledFromProps(props2);
  const [isDuplicate, metadataProps] = useMetadataProps(props2, symbol$2, true);
  useSafeLayoutEffect(() => {
    if (!disabled) return;
    activeRef.current = false;
    setActive(false);
  }, [disabled]);
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    const element2 = event.currentTarget;
    if (event.defaultPrevented) return;
    if (isDuplicate) return;
    if (disabled) return;
    if (!isSelfTarget(event)) return;
    if (isTextField(element2)) return;
    if (element2.isContentEditable) return;
    const isEnter = clickOnEnter && event.key === "Enter";
    const isSpace2 = clickOnSpace && event.key === " ";
    const shouldPreventEnter = event.key === "Enter" && !clickOnEnter;
    const shouldPreventSpace = event.key === " " && !clickOnSpace;
    if (shouldPreventEnter || shouldPreventSpace) {
      event.preventDefault();
      return;
    }
    if (isEnter || isSpace2) {
      const nativeClick = isNativeClick(event);
      if (isEnter) {
        if (!nativeClick) {
          event.preventDefault();
          const { view, ...eventInit } = event;
          const click = () => fireClickEvent(element2, eventInit);
          if (isFirefox()) queueBeforeEvent(element2, "keyup", click);
          else queueMicrotask(click);
        }
      } else if (isSpace2) {
        activeRef.current = true;
        if (!nativeClick) {
          event.preventDefault();
          setActive(true);
        }
      }
    }
  });
  const onKeyUpProp = props2.onKeyUp;
  const onKeyUp = useEvent((event) => {
    onKeyUpProp?.(event);
    if (isDuplicate) return;
    const isSpace2 = clickOnSpace && event.key === " ";
    if (!activeRef.current || !isSpace2) return;
    const nativeClick = isNativeClick(event);
    activeRef.current = false;
    if (!nativeClick) setActive(false);
    if (event.defaultPrevented) return;
    if (!isSelfTarget(event)) return;
    if (disabled) return;
    if (event.metaKey) return;
    if (nativeClick) return;
    event.preventDefault();
    const element2 = event.currentTarget;
    const { view, ...eventInit } = event;
    queueMicrotask(() => fireClickEvent(element2, eventInit));
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent((event) => {
    onBlurProp?.(event);
    if (!activeRef.current) return;
    activeRef.current = false;
    setActive(false);
  });
  props2 = {
    "data-active": active || void 0,
    type: isNativeButton ? "button" : void 0,
    ...metadataProps,
    ...props2,
    ref: useMergeRefs(ref, props2.ref),
    onKeyDown,
    onKeyUp,
    onBlur
  };
  props2 = useFocusable(props2);
  return props2;
});
forwardRef(function Command4(props2) {
  return createElement(TagName$A, useCommand(props2));
});
const ctx$9 = createStoreContext();
const useCollectionContext = ctx$9.useContext;
ctx$9.useScopedContext;
ctx$9.useProviderContext;
const CollectionContextProvider = ctx$9.ContextProvider;
const CollectionScopedContextProvider = ctx$9.ScopedContextProvider;
const TagName$z = "div";
const useCollectionItem = createHook(function useCollectionItem3({ store: store2, shouldRegisterItem = true, getItem = identity, element: element2, ...props2 }) {
  const context = useCollectionContext();
  store2 = store2 || context;
  const id2 = useId(props2.id);
  const ref = useRef(element2);
  useEffect(() => {
    const element3 = ref.current;
    if (!id2) return;
    if (!element3) return;
    if (!shouldRegisterItem) return;
    const item = getItem({
      id: id2,
      element: element3
    });
    return store2?.renderItem(item);
  }, [
    id2,
    shouldRegisterItem,
    getItem,
    store2
  ]);
  props2 = {
    ...props2,
    ref: useMergeRefs(ref, props2.ref)
  };
  return removeUndefinedValues(props2);
});
forwardRef(function CollectionItem3(props2) {
  return createElement(TagName$z, useCollectionItem(props2));
});
const ctx$8 = createStoreContext([CollectionContextProvider], [CollectionScopedContextProvider]);
const useCompositeScopedContext = ctx$8.useScopedContext;
const useCompositeProviderContext = ctx$8.useProviderContext;
const CompositeContextProvider = ctx$8.ContextProvider;
const CompositeScopedContextProvider = ctx$8.ScopedContextProvider;
const CompositeItemContext = createContext(void 0);
const CompositeRowContext = createContext(void 0);
function getInternal(store2, key) {
  const internals = store2.__unstableInternals;
  invariant(internals, "Invalid store");
  return internals[key];
}
function hasUpdatedKey(keys2, updatedKey) {
  if (!keys2) return true;
  for (const currentKey of keys2) if (updatedKey instanceof Set) {
    if (updatedKey.has(currentKey)) return true;
  } else if (currentKey === updatedKey) return true;
  return false;
}
function isSameValue(value, other) {
  return value === other || value !== value && other !== other;
}
function getCleanupPrevState(prevState, state, stateBeforeCleanup, updatedKey) {
  let cleanupPrevState;
  for (const key of getKeys(state)) {
    if (isSameValue(state[key], stateBeforeCleanup[key])) continue;
    if (updatedKey !== void 0 && hasUpdatedKey([key], updatedKey)) continue;
    cleanupPrevState ??= { ...prevState };
    cleanupPrevState[key] = state[key];
  }
  return cleanupPrevState;
}
const MAX_REPAIR_PASSES = 100;
function addKeyedListener(map2, keys2, listener) {
  if (!keys2) return;
  for (const key of keys2) {
    let listeners = map2.get(key);
    if (!listeners) {
      listeners = /* @__PURE__ */ new Set();
      map2.set(key, listeners);
    }
    listeners.add(listener);
  }
}
function deleteKeyedListener(map2, keys2, listener) {
  if (!map2) return;
  if (!keys2) return;
  for (const key of keys2) {
    const listeners = map2.get(key);
    if (!listeners) continue;
    listeners.delete(listener);
    if (!listeners.size) map2.delete(key);
  }
}
function getFastPathNotifiedListeners(frame) {
  const notifiedListeners = /* @__PURE__ */ new Set();
  const currentListener = frame.currentListener;
  if (!currentListener) return notifiedListeners;
  for (const listener of frame.keyedListeners) {
    notifiedListeners.add(listener);
    if (listener === currentListener) return notifiedListeners;
  }
  notifiedListeners.clear();
  notifiedListeners.add(currentListener);
  return notifiedListeners;
}
function preserveFastPathNotifiedListeners(frame) {
  frame.notifiedListeners ??= getFastPathNotifiedListeners(frame);
}
function hasFastPathPassedListener(frame, listener) {
  if (!frame.currentListener) return false;
  let foundCurrentKeyedListener = false;
  for (const currentListener of frame.keyedListeners) {
    if (currentListener === frame.currentListener) {
      foundCurrentKeyedListener = true;
      continue;
    }
    if (!foundCurrentKeyedListener) continue;
    if (currentListener === listener) return false;
  }
  let foundListener = false;
  for (const currentListener of frame.group.listeners) {
    if (currentListener === frame.currentListener) return foundListener;
    if (currentListener === listener) foundListener = true;
  }
  return false;
}
function preserveFastPathFrames(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (listener && !frame.keyedListeners.has(listener)) continue;
    preserveFastPathNotifiedListeners(frame);
    for (const currentListener of frame.group.listeners) {
      if (currentListener === frame.currentListener) break;
      if (!hasFastPathPassedListener(frame, currentListener)) continue;
      frame.notifiedListeners?.add(currentListener);
    }
  }
}
function preserveFastPathPassedListeners(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!hasFastPathPassedListener(frame, listener)) continue;
    preserveFastPathNotifiedListeners(frame);
    frame.notifiedListeners?.add(listener);
  }
}
function preserveFastPathPassedKeyedListeners({ fastPathFrames, group: group2, keys: keys2, listener }) {
  const wasRegistered = group2.listeners.has(listener);
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    if (hasFastPathPassedListener(frame, listener)) {
      preserveFastPathNotifiedListeners(frame);
      frame.notifiedListeners?.add(listener);
    } else if (wasRegistered) {
      preserveFastPathNotifiedListeners(frame);
      frame.recoverToLive = true;
    }
  }
}
function clearFastPathNotifiedListener(fastPathFrames, group2, listener) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    frame.notifiedListeners?.delete(listener);
  }
}
function addFastPathKeyedListener({ fastPathFrames, group: group2, keys: keys2, listener }) {
  for (const frame of fastPathFrames) {
    if (frame.group !== group2) continue;
    if (frame.recovering) continue;
    if (!keys2.includes(frame.updatedKey)) continue;
    frame.keyedListeners.add(listener);
  }
}
function runPendingCleanup(group2, listener) {
  if (!group2.disposables.size) return;
  const cleanup = group2.disposables.get(listener);
  if (!cleanup) return;
  group2.disposables.delete(listener);
  cleanup();
}
function setListenerCleanup(group2, listener, cleanup) {
  const currentCleanup = group2.disposables.get(listener);
  if (!currentCleanup) {
    group2.disposables.set(listener, cleanup);
    return;
  }
  group2.disposables.set(listener, () => {
    currentCleanup();
    cleanup();
  });
}
function notifyStoreListener(group2, listener, state, prevState, getState, updatedKey) {
  if (group2.suspendCounts?.has(listener)) return;
  const { disposables } = group2;
  const cleanup = disposables.size ? disposables.get(listener) : void 0;
  if (cleanup) {
    disposables.delete(listener);
    const stateBeforeCleanup = state;
    cleanup();
    state = getState?.() ?? state;
    if (state !== stateBeforeCleanup) prevState = getCleanupPrevState(prevState, state, stateBeforeCleanup, updatedKey) ?? prevState;
  }
  const result2 = listener(state, prevState);
  if (result2) setListenerCleanup(group2, listener, result2);
}
function runLiveListeners({ group: group2, getState, prevState, updatedKey, notifiedListeners }) {
  const allKeysListeners = group2.allKeysListeners;
  for (const listener of group2.listeners) {
    if (notifiedListeners?.has(listener)) continue;
    if (!allKeysListeners?.has(listener)) {
      if (!hasUpdatedKey(group2.listenerKeys.get(listener), updatedKey)) continue;
    }
    notifiedListeners?.add(listener);
    notifyStoreListener(group2, listener, getState(), prevState, getState, updatedKey);
  }
}
function createStore(initialState2, ...stores) {
  let state = initialState2;
  let prevStateBatch = state;
  let destroy = noop$1;
  let batchPending = false;
  let inDispatch = false;
  let updatedKeys = /* @__PURE__ */ new Set();
  const instances = /* @__PURE__ */ new Set();
  const setups = /* @__PURE__ */ new Set();
  const syncListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const batchListenerGroup = {
    listeners: /* @__PURE__ */ new Set(),
    disposables: /* @__PURE__ */ new Map(),
    listenerKeys: /* @__PURE__ */ new WeakMap()
  };
  const storeSetup = (callback) => {
    setups.add(callback);
    return () => setups.delete(callback);
  };
  const storeInit = () => {
    const initializedInstances = instances.size;
    const instance = /* @__PURE__ */ Symbol();
    instances.add(instance);
    const maybeDestroy = () => {
      if (!instances.delete(instance)) return;
      if (instances.size) return;
      destroy();
    };
    if (initializedInstances) return maybeDestroy;
    const stateKeys = getKeys(state);
    const desyncs = [];
    for (const store2 of stores) {
      const storeState = store2?.getState?.();
      if (!storeState) continue;
      const keys2 = stateKeys.filter((key) => hasOwnProperty$2(storeState, key));
      if (!keys2.length) continue;
      if (stores.length === 1 || keys2.length === stateKeys.length) {
        for (const key of keys2) desyncs.push(sync(store2, [key], (state2) => {
          setState(key, state2[key], true);
        }));
        continue;
      }
      desyncs.push(subscribe(store2, keys2, (state2, prevState) => {
        for (const key of keys2) {
          if (state2[key] === prevState[key]) continue;
          setState(key, state2[key], true);
        }
      }));
      for (const key of keys2) {
        const liveState = store2?.getState?.();
        if (!liveState) continue;
        setState(key, liveState[key], true);
      }
    }
    const teardowns = [];
    for (const setup2 of setups) teardowns.push(setup2());
    const cleanups2 = stores.map(init);
    destroy = chain(...desyncs, ...teardowns, ...cleanups2);
    return maybeDestroy;
  };
  const deleteListenerIndexes = (group2, listener, keys2) => {
    if (keys2 === void 0) return;
    if (keys2) deleteKeyedListener(group2.listenersByKey, keys2, listener);
    else group2.allKeysListeners?.delete(listener);
  };
  const fastPathFrames = [];
  const registerListener = (keys2, listener, group2 = syncListenerGroup) => {
    const listenerKeysValue = keys2 ? [...keys2] : null;
    const wasRegistered = group2.listeners.has(listener);
    if (!wasRegistered) clearFastPathNotifiedListener(fastPathFrames, group2, listener);
    if (!listenerKeysValue) {
      if (wasRegistered) preserveFastPathFrames(fastPathFrames, group2);
      preserveFastPathPassedListeners(fastPathFrames, group2, listener);
    } else preserveFastPathPassedKeyedListeners({
      fastPathFrames,
      group: group2,
      keys: listenerKeysValue,
      listener
    });
    if (wasRegistered) {
      preserveFastPathFrames(fastPathFrames, group2, listener);
      deleteListenerIndexes(group2, listener, group2.listenerKeys.get(listener));
    }
    group2.listeners.add(listener);
    if (listenerKeysValue) {
      group2.listenersByKey ??= /* @__PURE__ */ new Map();
      addKeyedListener(group2.listenersByKey, listenerKeysValue, listener);
      addFastPathKeyedListener({
        fastPathFrames,
        group: group2,
        keys: listenerKeysValue,
        listener
      });
    } else {
      group2.allKeysListeners ??= /* @__PURE__ */ new Set();
      group2.allKeysListeners.add(listener);
    }
    group2.listenerKeys.set(listener, listenerKeysValue);
    return () => {
      const cleanup = group2.disposables.get(listener);
      group2.disposables.delete(listener);
      preserveFastPathFrames(fastPathFrames, group2, listener);
      const currentKeys = group2.listenerKeys.get(listener);
      deleteListenerIndexes(group2, listener, listenerKeysValue);
      if (currentKeys !== listenerKeysValue) deleteListenerIndexes(group2, listener, currentKeys);
      group2.listenerKeys.delete(listener);
      group2.listeners.delete(listener);
      cleanup?.();
    };
  };
  const storeSubscribe = (keys2, listener) => registerListener(keys2, listener);
  const runInitialListener = (group2, listener, prevState) => {
    const shouldSuspend = group2.listeners.has(listener);
    if (shouldSuspend) {
      group2.suspendCounts ??= /* @__PURE__ */ new Map();
      const count = group2.suspendCounts.get(listener) ?? 0;
      group2.suspendCounts.set(listener, count + 1);
    }
    let cleanupPrevState;
    try {
      const stateBeforeCleanups = state;
      runPendingCleanup(group2, listener);
      if (state !== stateBeforeCleanups) cleanupPrevState = getCleanupPrevState(prevState, state, stateBeforeCleanups);
      const cleanup = listener(state, cleanupPrevState ?? prevState);
      if (cleanup) setListenerCleanup(group2, listener, cleanup);
    } finally {
      if (shouldSuspend) {
        const suspendCounts = group2.suspendCounts;
        const count = suspendCounts?.get(listener);
        if (count && count > 1) suspendCounts?.set(listener, count - 1);
        else suspendCounts?.delete(listener);
        if (!suspendCounts?.size) delete group2.suspendCounts;
      }
    }
  };
  const storeSync = (keys2, listener) => {
    runInitialListener(syncListenerGroup, listener, state);
    return registerListener(keys2, listener);
  };
  const storeBatch = (keys2, listener) => {
    if (!batchListenerGroup.listeners.size && !inDispatch) prevStateBatch = state;
    runInitialListener(batchListenerGroup, listener, prevStateBatch);
    return registerListener(keys2, listener, batchListenerGroup);
  };
  const storePick = (keys2) => createStore(pick$1(state, keys2), finalStore);
  const storeOmit = (keys2) => createStore(omit$1(state, keys2), finalStore);
  const getState = () => state;
  const runListeners = (group2, prevState, updatedKey) => {
    if (!(updatedKey instanceof Set) && !group2.allKeysListeners?.size) {
      const keyedListeners = group2.listenersByKey?.get(updatedKey);
      if (!keyedListeners) return;
      const frame = {
        group: group2,
        keyedListeners,
        updatedKey,
        currentListener: null
      };
      fastPathFrames.push(frame);
      try {
        for (const listener of keyedListeners) {
          if (frame.notifiedListeners?.has(listener)) continue;
          frame.currentListener = listener;
          frame.notifiedListeners?.add(listener);
          notifyStoreListener(group2, listener, state, prevState, getState, updatedKey);
          if (!group2.allKeysListeners?.size && !frame.recoverToLive) continue;
          const notifiedListeners = frame.notifiedListeners ?? getFastPathNotifiedListeners(frame);
          frame.notifiedListeners = notifiedListeners;
          frame.recovering = true;
          runLiveListeners({
            group: group2,
            getState,
            prevState,
            updatedKey,
            notifiedListeners
          });
          return;
        }
      } finally {
        fastPathFrames.pop();
      }
      return;
    }
    runLiveListeners({
      group: group2,
      getState,
      prevState,
      updatedKey
    });
  };
  const setState = (key, value, fromStores = false) => {
    if (!hasOwnProperty$2(state, key)) return;
    const currentValue = state[key];
    const nextValue = typeof value === "function" ? value(currentValue) : value;
    if (isSameValue(nextValue, currentValue)) return;
    const wasInDispatch = inDispatch;
    inDispatch = true;
    const prevState = state;
    const nextState = {
      ...state,
      [key]: nextValue
    };
    state = nextState;
    let superseded = false;
    try {
      if (!fromStores && stores.length) {
        for (const store2 of stores) {
          store2?.setState?.(key, nextValue);
          if (isSameValue(state[key], nextValue)) continue;
          superseded = true;
          break;
        }
        if (superseded) {
          let pass = 0;
          for (; pass < MAX_REPAIR_PASSES; pass += 1) {
            let changed = false;
            for (const store2 of stores) {
              const previousValue = state[key];
              store2?.setState?.(key, previousValue);
              if (!isSameValue(state[key], previousValue)) changed = true;
            }
            if (!changed) break;
          }
          if (process.env.NODE_ENV !== "production" && pass === MAX_REPAIR_PASSES) console.warn("Parent stores did not converge after a superseded fan-out; a parent listener may be rewriting this key in a cycle.");
        }
      }
      if (!superseded) runListeners(syncListenerGroup, state === nextState ? prevState : {
        ...state,
        [key]: prevState[key]
      }, key);
    } finally {
      inDispatch = wasInDispatch;
    }
    if (!batchListenerGroup.listeners.size) {
      if (!inDispatch) prevStateBatch = state;
      return;
    }
    updatedKeys.add(key);
    if (batchPending) return;
    batchPending = true;
    queueMicrotask(() => {
      batchPending = false;
      const snapshot = state;
      const updatedKeysSnapshot = updatedKeys;
      updatedKeys = /* @__PURE__ */ new Set();
      const prevStateBatchBefore = prevStateBatch;
      runListeners(batchListenerGroup, prevStateBatchBefore, updatedKeysSnapshot);
      if (prevStateBatch === prevStateBatchBefore) prevStateBatch = snapshot;
    });
  };
  const finalStore = {
    getState,
    setState,
    __unstableInternals: {
      setup: storeSetup,
      init: storeInit,
      subscribe: storeSubscribe,
      sync: storeSync,
      batch: storeBatch,
      pick: storePick,
      omit: storeOmit
    }
  };
  return finalStore;
}
function setup(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "setup")(...args);
}
function init(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "init")(...args);
}
function subscribe(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "subscribe")(...args);
}
function sync(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "sync")(...args);
}
function batch(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "batch")(...args);
}
function omit(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "omit")(...args);
}
function pick(store2, ...args) {
  if (!store2) return;
  return getInternal(store2, "pick")(...args);
}
function mergeStore(...stores) {
  const initialState2 = {};
  for (const store3 of stores) {
    const nextState = store3?.getState?.();
    if (nextState) Object.assign(initialState2, nextState);
  }
  const store2 = createStore(initialState2, ...stores);
  return Object.assign({}, ...stores, store2);
}
function throwOnConflictingProps(props2, store2) {
  if (process.env.NODE_ENV === "production") return;
  if (!store2) return;
  const defaultKeys = Object.entries(props2).filter(([key, value]) => key.startsWith("default") && value !== void 0).map(([key]) => {
    const stateKey = key.replace("default", "");
    return `${stateKey[0]?.toLowerCase() || ""}${stateKey.slice(1)}`;
  });
  if (!defaultKeys.length) return;
  const storeState = store2.getState();
  if (!defaultKeys.filter((key) => hasOwnProperty$2(storeState, key)).length) return;
  throw new Error(`Passing a store prop in conjunction with a default state is not supported.

const store = useSelectStore();
<SelectProvider store={store} defaultValue="Apple" />
                ^             ^

Instead, pass the default state to the topmost store:

const store = useSelectStore({ defaultValue: "Apple" });
<SelectProvider store={store} />

See https://github.com/ariakit/ariakit/pull/2745 for more details.

If there's a particular need for this, please submit a feature request at https://github.com/ariakit/ariakit
`);
}
function getCommonParent(items) {
  const firstItem = items.find((item) => !!item.element);
  const lastElement = [...items].reverse().find((item) => !!item.element)?.element;
  let parentElement = firstItem?.element?.parentElement;
  if (!lastElement) return getDocument(parentElement).body;
  while (parentElement) {
    if (parentElement.contains(lastElement)) return parentElement;
    parentElement = parentElement.parentElement;
  }
  return getDocument(parentElement).body;
}
function getPrivateStore(store2) {
  return store2?.__unstablePrivateStore;
}
function createCollectionStore(props2 = {}) {
  throwOnConflictingProps(props2, props2.store);
  const syncState = props2.store?.getState();
  const items = defaultValue(props2.items, syncState?.items, props2.defaultItems, []);
  const itemsMap = new Map(items.map((item) => [item.id, item]));
  const initialState2 = {
    items,
    renderedItems: defaultValue(syncState?.renderedItems, [])
  };
  const syncPrivateStore = getPrivateStore(props2.store);
  const privateStore = createStore({
    items,
    renderedItems: initialState2.renderedItems
  }, syncPrivateStore);
  const collection = createStore(initialState2, props2.store);
  const sortItems = (renderedItems) => {
    const sortedItems = sortBasedOnDOMPosition(renderedItems, (i2) => i2.element);
    privateStore.setState("renderedItems", sortedItems);
    collection.setState("renderedItems", sortedItems);
  };
  setup(collection, () => init(privateStore));
  setup(privateStore, () => {
    return batch(privateStore, ["items"], (state) => {
      collection.setState("items", state.items);
    });
  });
  setup(privateStore, () => {
    return batch(privateStore, ["renderedItems"], (state) => {
      let firstRun = true;
      let raf = requestAnimationFrame(() => {
        const { renderedItems } = collection.getState();
        if (state.renderedItems === renderedItems) return;
        sortItems(state.renderedItems);
      });
      if (typeof IntersectionObserver !== "function") return () => cancelAnimationFrame(raf);
      const ioCallback = () => {
        if (firstRun) {
          firstRun = false;
          return;
        }
        cancelAnimationFrame(raf);
        raf = requestAnimationFrame(() => sortItems(state.renderedItems));
      };
      const root2 = getCommonParent(state.renderedItems);
      const observer = new IntersectionObserver(ioCallback, { root: root2 });
      for (const item of state.renderedItems) {
        if (!item.element) continue;
        observer.observe(item.element);
      }
      return () => {
        cancelAnimationFrame(raf);
        observer.disconnect();
      };
    });
  });
  const mergeItem = (item, setItems, canDeleteFromMap = false) => {
    let prevItem;
    setItems((items2) => {
      const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
      const nextItems = items2.slice();
      if (index2 !== -1) {
        prevItem = items2[index2];
        const nextItem = {
          ...prevItem,
          ...item
        };
        nextItems[index2] = nextItem;
        itemsMap.set(item.id, nextItem);
      } else {
        nextItems.push(item);
        itemsMap.set(item.id, item);
      }
      return nextItems;
    });
    const unmergeItem = () => {
      setItems((items2) => {
        if (!prevItem) {
          if (canDeleteFromMap) itemsMap.delete(item.id);
          return items2.filter(({ id: id2 }) => id2 !== item.id);
        }
        const index2 = items2.findIndex(({ id: id2 }) => id2 === item.id);
        if (index2 === -1) return items2;
        const nextItems = items2.slice();
        nextItems[index2] = prevItem;
        itemsMap.set(item.id, prevItem);
        return nextItems;
      });
    };
    return unmergeItem;
  };
  const registerItem = (item) => mergeItem(item, (getItems) => privateStore.setState("items", getItems), true);
  return {
    ...collection,
    registerItem,
    renderItem: (item) => chain(registerItem(item), mergeItem(item, (getItems) => privateStore.setState("renderedItems", getItems))),
    item: (id2) => {
      if (!id2) return null;
      let item = itemsMap.get(id2);
      if (!item) {
        const { items: items2 } = privateStore.getState();
        item = items2.find((item2) => item2.id === id2);
        if (item) itemsMap.set(id2, item);
      }
      return item || null;
    },
    __unstablePrivateStore: privateStore
  };
}
const NULL_ITEM = { id: null };
function findFirstEnabledItem$1(items, excludeId) {
  return items.find((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getEnabledItems$1(items, excludeId) {
  return items.filter((item) => {
    if (excludeId) return !item.disabled && item.id !== excludeId;
    return !item.disabled;
  });
}
function getItemsInRow(items, rowId) {
  return items.filter((item) => item.rowId === rowId);
}
function findEnabledItemId({ items, fromIndex, step, rowId, excludeId }) {
  for (let i2 = fromIndex; i2 >= 0 && i2 < items.length; i2 += step) {
    const item = items[i2];
    if (!item) continue;
    if (item.rowId !== rowId) continue;
    if (item.disabled) continue;
    if (excludeId != null && item.id === excludeId) continue;
    return item.id;
  }
}
function flipItems$1(items, activeId, shouldInsertNullItem = false) {
  const index2 = items.findIndex((item) => item.id === activeId);
  return [
    ...items.slice(index2 + 1),
    ...shouldInsertNullItem ? [NULL_ITEM] : [],
    ...items.slice(0, index2)
  ];
}
function groupItemsByRows$1(items) {
  const rows = [];
  for (const item of items) {
    const row = rows.find((currentRow) => currentRow[0]?.rowId === item.rowId);
    if (row) row.push(item);
    else rows.push([item]);
  }
  return rows;
}
function getMaxRowLength(array) {
  let maxLength = 0;
  for (const { length } of array) if (length > maxLength) maxLength = length;
  return maxLength;
}
function createEmptyItem(rowId) {
  return {
    id: "__EMPTY_ITEM__",
    disabled: true,
    rowId
  };
}
function normalizeRows(rows, activeId, focusShift) {
  const maxLength = getMaxRowLength(rows);
  for (const row of rows) for (let i2 = 0; i2 < maxLength; i2 += 1) {
    const item = row[i2];
    if (!item || focusShift && item.disabled) {
      const previousItem = i2 === 0 && focusShift ? findFirstEnabledItem$1(row) : row[i2 - 1];
      row[i2] = previousItem && activeId !== previousItem.id && focusShift ? previousItem : createEmptyItem(previousItem?.rowId);
    }
  }
  return rows;
}
function verticalizeItems(items) {
  const rows = groupItemsByRows$1(items);
  const maxLength = getMaxRowLength(rows);
  const verticalized = [];
  for (let i2 = 0; i2 < maxLength; i2 += 1) for (const row of rows) {
    const item = row[i2];
    if (item) verticalized.push({
      ...item,
      rowId: item.rowId ? `${i2}` : void 0
    });
  }
  return verticalized;
}
function createCompositeStore(props2 = {}) {
  const syncState = props2.store?.getState();
  const collection = createCollectionStore(props2);
  const activeId = defaultValue(props2.activeId, syncState?.activeId, props2.defaultActiveId);
  const composite = createStore({
    ...collection.getState(),
    id: defaultValue(props2.id, syncState?.id) ?? `id-${Math.random().toString(36).slice(2, 8)}`,
    activeId,
    baseElement: defaultValue(syncState?.baseElement, null),
    includesBaseElement: defaultValue(props2.includesBaseElement, syncState?.includesBaseElement, activeId === null),
    moves: defaultValue(syncState?.moves, 0),
    orientation: defaultValue(props2.orientation, syncState?.orientation, "both"),
    rtl: defaultValue(props2.rtl, syncState?.rtl, false),
    virtualFocus: defaultValue(props2.virtualFocus, syncState?.virtualFocus, false),
    focusLoop: defaultValue(props2.focusLoop, syncState?.focusLoop, false),
    focusWrap: defaultValue(props2.focusWrap, syncState?.focusWrap, false),
    focusShift: defaultValue(props2.focusShift, syncState?.focusShift, false)
  }, collection, props2.store);
  setup(composite, () => sync(composite, ["renderedItems", "activeId"], (state) => {
    composite.setState("activeId", (activeId2) => {
      if (activeId2 !== void 0) return activeId2;
      return findFirstEnabledItem$1(state.renderedItems)?.id;
    });
  }));
  const getNextId = (direction = "next", options2 = {}) => {
    const defaultState = composite.getState();
    const { skip = 0, activeId: activeId2 = defaultState.activeId, focusShift = defaultState.focusShift, focusLoop = defaultState.focusLoop, focusWrap = defaultState.focusWrap, includesBaseElement = defaultState.includesBaseElement, renderedItems = defaultState.renderedItems, rtl = defaultState.rtl } = options2;
    const isVerticalDirection = direction === "up" || direction === "down";
    const isNextDirection = direction === "next" || direction === "down";
    const canReverse = isNextDirection ? rtl && !isVerticalDirection : !rtl || isVerticalDirection;
    const canShift = focusShift && !skip;
    if (!skip && !focusWrap && !includesBaseElement && activeId2 != null) {
      if (!isVerticalDirection ? true : !canShift && !renderedItems.some((item) => item.rowId != null)) {
        const activeIndex2 = renderedItems.findIndex((item) => item.id === activeId2);
        const activeItem2 = renderedItems[activeIndex2];
        if (activeItem2) {
          const step = canReverse ? -1 : 1;
          const nextId = findEnabledItemId({
            items: renderedItems,
            fromIndex: activeIndex2 + step,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
          if (nextId !== void 0) return nextId;
          if (!(focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical"))) return void 0;
          return findEnabledItemId({
            items: renderedItems,
            fromIndex: step === 1 ? 0 : renderedItems.length - 1,
            step,
            rowId: activeItem2.rowId,
            excludeId: activeId2
          });
        }
      }
    }
    let items = !isVerticalDirection ? renderedItems : flatten2DArray(normalizeRows(groupItemsByRows$1(renderedItems), activeId2, canShift));
    items = canReverse ? reverseArray(items) : items;
    items = isVerticalDirection ? verticalizeItems(items) : items;
    if (activeId2 == null) return findFirstEnabledItem$1(items)?.id;
    const activeItem = items.find((item) => item.id === activeId2);
    if (!activeItem) return findFirstEnabledItem$1(items)?.id;
    const isGrid2 = items.some((item) => item.rowId);
    const activeIndex = items.indexOf(activeItem);
    const nextItems = items.slice(activeIndex + 1);
    const nextItemsInRow = getItemsInRow(nextItems, activeItem.rowId);
    if (skip) {
      const nextEnabledItemsInRow = getEnabledItems$1(nextItemsInRow, activeId2);
      return (nextEnabledItemsInRow.slice(skip)[0] || nextEnabledItemsInRow[nextEnabledItemsInRow.length - 1])?.id;
    }
    const canLoop = focusLoop && (isVerticalDirection ? focusLoop !== "horizontal" : focusLoop !== "vertical");
    const canWrap = isGrid2 && focusWrap && (isVerticalDirection ? focusWrap !== "horizontal" : focusWrap !== "vertical");
    const hasNullItem = isNextDirection ? (!isGrid2 || isVerticalDirection) && canLoop && includesBaseElement : isVerticalDirection ? includesBaseElement : false;
    if (canLoop) return findFirstEnabledItem$1(flipItems$1(canWrap && !hasNullItem ? items : getItemsInRow(items, activeItem.rowId), activeId2, hasNullItem), activeId2)?.id;
    if (canWrap) {
      const nextItem2 = findFirstEnabledItem$1(hasNullItem ? nextItemsInRow : nextItems, activeId2);
      return hasNullItem ? nextItem2?.id || null : nextItem2?.id;
    }
    const nextItem = findFirstEnabledItem$1(nextItemsInRow, activeId2);
    if (!nextItem && hasNullItem) return null;
    return nextItem?.id;
  };
  const getNextIdFromOptions = (direction, options2) => {
    if (typeof options2 === "number") return getNextId(direction, { skip: options2 });
    return getNextId(direction, options2);
  };
  return {
    ...collection,
    ...composite,
    setBaseElement: (element2) => composite.setState("baseElement", element2),
    setActiveId: (id2) => composite.setState("activeId", id2),
    move: (id2) => {
      if (id2 === void 0) return;
      composite.setState("activeId", id2);
      composite.setState("moves", (moves) => moves + 1);
    },
    first: () => findFirstEnabledItem$1(composite.getState().renderedItems)?.id,
    last: () => findFirstEnabledItem$1(reverseArray(composite.getState().renderedItems))?.id,
    next: (options2) => getNextIdFromOptions("next", options2),
    previous: (options2) => getNextIdFromOptions("previous", options2),
    down: (options2) => getNextIdFromOptions("down", options2),
    up: (options2) => getNextIdFromOptions("up", options2)
  };
}
const flipItems = flipItems$1;
const findFirstEnabledItem = findFirstEnabledItem$1;
const groupItemsByRows = groupItemsByRows$1;
function getEnabledItem(store2, id2) {
  if (!id2) return null;
  return store2.item(id2) || null;
}
function selectTextField(element2, collapseToEnd = false) {
  if (isTextField(element2)) element2.setSelectionRange(collapseToEnd ? element2.value.length : 0, element2.value.length);
  else if (element2.isContentEditable) {
    const selection2 = getDocument(element2).getSelection();
    selection2?.selectAllChildren(element2);
    if (collapseToEnd) selection2?.collapseToEnd();
  }
}
const FOCUS_SILENTLY = /* @__PURE__ */ Symbol("FOCUS_SILENTLY");
function focusSilently(element2) {
  element2[FOCUS_SILENTLY] = true;
  element2.focus({ preventScroll: true });
}
function silentlyFocused(element2) {
  const isSilentlyFocused = element2[FOCUS_SILENTLY];
  delete element2[FOCUS_SILENTLY];
  return isSilentlyFocused;
}
function isItem(store2, element2, exclude) {
  if (!element2) return false;
  if (element2 === exclude) return false;
  const item = store2.item(element2.id);
  if (!item) return false;
  return true;
}
var shim = { exports: {} };
var useSyncExternalStoreShim_production = {};
var hasRequiredUseSyncExternalStoreShim_production;
function requireUseSyncExternalStoreShim_production() {
  if (hasRequiredUseSyncExternalStoreShim_production) return useSyncExternalStoreShim_production;
  hasRequiredUseSyncExternalStoreShim_production = 1;
  var React2 = React__default;
  function is2(x2, y2) {
    return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
  }
  var objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue;
  function useSyncExternalStore$2(subscribe2, getSnapshot) {
    var value = getSnapshot(), _useState = useState2({ inst: { value, getSnapshot } }), inst = _useState[0].inst, forceUpdate = _useState[1];
    useLayoutEffect2(
      function() {
        inst.value = value;
        inst.getSnapshot = getSnapshot;
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
      },
      [subscribe2, value, getSnapshot]
    );
    useEffect2(
      function() {
        checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        return subscribe2(function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        });
      },
      [subscribe2]
    );
    useDebugValue(value);
    return value;
  }
  function checkIfSnapshotChanged(inst) {
    var latestGetSnapshot = inst.getSnapshot;
    inst = inst.value;
    try {
      var nextValue = latestGetSnapshot();
      return !objectIs(inst, nextValue);
    } catch (error) {
      return true;
    }
  }
  function useSyncExternalStore$1(subscribe2, getSnapshot) {
    return getSnapshot();
  }
  var shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
  useSyncExternalStoreShim_production.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
  return useSyncExternalStoreShim_production;
}
var useSyncExternalStoreShim_development = {};
var hasRequiredUseSyncExternalStoreShim_development;
function requireUseSyncExternalStoreShim_development() {
  if (hasRequiredUseSyncExternalStoreShim_development) return useSyncExternalStoreShim_development;
  hasRequiredUseSyncExternalStoreShim_development = 1;
  "production" !== process.env.NODE_ENV && (function() {
    function is2(x2, y2) {
      return x2 === y2 && (0 !== x2 || 1 / x2 === 1 / y2) || x2 !== x2 && y2 !== y2;
    }
    function useSyncExternalStore$2(subscribe2, getSnapshot) {
      didWarnOld18Alpha || void 0 === React2.startTransition || (didWarnOld18Alpha = true, console.error(
        "You are using an outdated, pre-release alpha of React 18 that does not support useSyncExternalStore. The use-sync-external-store shim will not work correctly. Upgrade to a newer pre-release."
      ));
      var value = getSnapshot();
      if (!didWarnUncachedGetSnapshot) {
        var cachedValue = getSnapshot();
        objectIs(value, cachedValue) || (console.error(
          "The result of getSnapshot should be cached to avoid an infinite loop"
        ), didWarnUncachedGetSnapshot = true);
      }
      cachedValue = useState2({
        inst: { value, getSnapshot }
      });
      var inst = cachedValue[0].inst, forceUpdate = cachedValue[1];
      useLayoutEffect2(
        function() {
          inst.value = value;
          inst.getSnapshot = getSnapshot;
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
        },
        [subscribe2, value, getSnapshot]
      );
      useEffect2(
        function() {
          checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          return subscribe2(function() {
            checkIfSnapshotChanged(inst) && forceUpdate({ inst });
          });
        },
        [subscribe2]
      );
      useDebugValue(value);
      return value;
    }
    function checkIfSnapshotChanged(inst) {
      var latestGetSnapshot = inst.getSnapshot;
      inst = inst.value;
      try {
        var nextValue = latestGetSnapshot();
        return !objectIs(inst, nextValue);
      } catch (error) {
        return true;
      }
    }
    function useSyncExternalStore$1(subscribe2, getSnapshot) {
      return getSnapshot();
    }
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStart(Error());
    var React2 = React__default, objectIs = "function" === typeof Object.is ? Object.is : is2, useState2 = React2.useState, useEffect2 = React2.useEffect, useLayoutEffect2 = React2.useLayoutEffect, useDebugValue = React2.useDebugValue, didWarnOld18Alpha = false, didWarnUncachedGetSnapshot = false, shim2 = "undefined" === typeof window || "undefined" === typeof window.document || "undefined" === typeof window.document.createElement ? useSyncExternalStore$1 : useSyncExternalStore$2;
    useSyncExternalStoreShim_development.useSyncExternalStore = void 0 !== React2.useSyncExternalStore ? React2.useSyncExternalStore : shim2;
    "undefined" !== typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ && "function" === typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop && __REACT_DEVTOOLS_GLOBAL_HOOK__.registerInternalModuleStop(Error());
  })();
  return useSyncExternalStoreShim_development;
}
var hasRequiredShim;
function requireShim() {
  if (hasRequiredShim) return shim.exports;
  hasRequiredShim = 1;
  if (process.env.NODE_ENV === "production") {
    shim.exports = requireUseSyncExternalStoreShim_production();
  } else {
    shim.exports = requireUseSyncExternalStoreShim_development();
  }
  return shim.exports;
}
var shimExports = requireShim();
const noopSubscribe = () => () => {
};
function useStoreState(store2, keyOrSelector = identity) {
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe();
    return subscribe(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const key = typeof keyOrSelector === "string" ? keyOrSelector : null;
    const selector2 = typeof keyOrSelector === "function" ? keyOrSelector : null;
    const state = store2?.getState();
    if (selector2) return selector2(state);
    if (!state) return;
    if (!key) return;
    if (!hasOwnProperty$2(state, key)) return;
    return state[key];
  };
  return shimExports.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreStateObject(store2, object2) {
  const objRef = React.useRef({});
  const storeSubscribe = React.useCallback((callback) => {
    if (!store2) return noopSubscribe();
    return subscribe(store2, null, callback);
  }, [store2]);
  const getSnapshot = () => {
    const state = store2?.getState();
    let updated = false;
    const obj = objRef.current;
    for (const prop in object2) {
      const keyOrSelector = object2[prop];
      if (typeof keyOrSelector === "function") {
        const value = keyOrSelector(state);
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
      if (typeof keyOrSelector === "string") {
        if (!state) continue;
        if (!hasOwnProperty$2(state, keyOrSelector)) continue;
        const value = state[keyOrSelector];
        if (!Object.is(value, obj[prop])) {
          obj[prop] = value;
          updated = true;
        }
      }
    }
    if (updated) objRef.current = { ...obj };
    return objRef.current;
  };
  return shimExports.useSyncExternalStore(storeSubscribe, getSnapshot, getSnapshot);
}
function useStoreProps(store2, props2, key, setKey) {
  const value = hasOwnProperty$2(props2, key) ? props2[key] : void 0;
  const propsRef = useLiveRef({
    value,
    setValue: setKey ? props2[setKey] : void 0
  });
  useSafeLayoutEffect(() => {
    return sync(store2, [key], (state, prev) => {
      const { value: value2, setValue } = propsRef.current;
      if (!setValue) return;
      if (state[key] === prev[key]) return;
      if (state[key] === value2) return;
      setValue(state[key]);
    });
  }, [store2, key]);
  useSafeLayoutEffect(() => {
    if (value === void 0) return;
    store2.setState(key, value);
    return batch(store2, [key], () => {
      if (value === void 0) return;
      store2.setState(key, value);
    });
  });
}
function useStore(createStore2, props2) {
  const [store2, setStore] = React.useState(() => createStore2(props2));
  useSafeLayoutEffect(() => init(store2), [store2]);
  const useState2 = React.useCallback((keyOrSelector) => useStoreState(store2, keyOrSelector), [store2]);
  return [React.useMemo(() => ({
    ...store2,
    useState: useState2
  }), [store2, useState2]), useEvent(() => {
    setStore((store3) => createStore2({
      ...props2,
      ...store3.getState()
    }));
  })];
}
const TagName$y = "button";
function isEditableElement(element2) {
  if (isTextbox(element2)) return true;
  return element2.tagName === "INPUT" && !isButton(element2);
}
function getNextPageOffset(scrollingElement, pageUp = false) {
  const height = scrollingElement.clientHeight;
  const { top: top2 } = scrollingElement.getBoundingClientRect();
  const pageSize = Math.max(height * 0.875, height - 40) * 1.5;
  const pageOffset = pageUp ? height - pageSize + top2 : pageSize + top2;
  if (scrollingElement.tagName === "HTML") return pageOffset + scrollingElement.scrollTop;
  return pageOffset;
}
function getItemOffset(itemElement, pageUp = false) {
  const { top: top2 } = itemElement.getBoundingClientRect();
  if (pageUp) return top2 + itemElement.clientHeight;
  return top2;
}
function findNextPageItemId(element2, store2, next, pageUp = false) {
  if (!store2) return;
  if (!next) return;
  const { renderedItems } = store2.getState();
  const scrollingElement = getScrollingElement(element2);
  if (!scrollingElement) return;
  const nextPageOffset = getNextPageOffset(scrollingElement, pageUp);
  let id2;
  let prevDifference;
  for (let i2 = 0; i2 < renderedItems.length; i2 += 1) {
    const previousId = id2;
    id2 = next(i2);
    if (!id2) break;
    if (id2 === previousId) continue;
    const itemElement = getEnabledItem(store2, id2)?.element;
    if (!itemElement) continue;
    const difference = getItemOffset(itemElement, pageUp) - nextPageOffset;
    const absDifference = Math.abs(difference);
    if (pageUp && difference <= 0 || !pageUp && difference >= 0) {
      if (prevDifference !== void 0 && prevDifference < absDifference) id2 = previousId;
      break;
    }
    prevDifference = absDifference;
  }
  return id2;
}
function targetIsAnotherItem(event, store2) {
  if (isSelfTarget(event)) return false;
  return isItem(store2, event.target);
}
const useCompositeItem = createHook(function useCompositeItem3({ store: store2, rowId: rowIdProp, preventScrollOnKeyDown = false, moveOnKeyPress = true, tabbable = false, getItem: getItemProp, "aria-setsize": ariaSetSizeProp, "aria-posinset": ariaPosInSetProp, ...props2 }) {
  const context = useCompositeScopedContext();
  store2 = store2 || context;
  const id2 = useId(props2.id);
  const ref = useRef(null);
  const row = useContext(CompositeRowContext);
  const trulyDisabled = disabledFromProps(props2) && !props2.accessibleWhenDisabled;
  const shouldRegisterItem = props2.shouldRegisterItem;
  const getRowId = (state) => {
    if (rowIdProp) return rowIdProp;
    if (!state) return;
    if (!row?.baseElement) return;
    if (row.baseElement !== state.baseElement) return;
    return row.id;
  };
  const { rowId, baseElement, isActiveItem, ariaSetSize, ariaPosInSet, isTabbable: isTabbable2 } = useStoreStateObject(store2, {
    rowId: getRowId,
    baseElement(state) {
      return state?.baseElement || void 0;
    },
    isActiveItem(state) {
      return !!state && state.activeId === id2;
    },
    ariaSetSize(state) {
      if (ariaSetSizeProp != null) return ariaSetSizeProp;
      if (!state) return;
      if (!row?.ariaSetSize) return;
      if (row.baseElement !== state.baseElement) return;
      return row.ariaSetSize;
    },
    ariaPosInSet(state) {
      if (ariaPosInSetProp != null) return ariaPosInSetProp;
      if (!state) return;
      if (!row?.ariaPosInSet) return;
      if (row.baseElement !== state.baseElement) return;
      const rowId2 = getRowId(state);
      const itemsInRow = state.renderedItems.filter((item) => item.rowId === rowId2);
      return row.ariaPosInSet + itemsInRow.findIndex((item) => item.id === id2);
    },
    isTabbable(state) {
      if (!state?.renderedItems.length) return true;
      if (state.virtualFocus) return false;
      if (tabbable) return true;
      if (state.activeId === null) return false;
      const item = store2?.item(state.activeId);
      if (item?.disabled) return true;
      if (!item?.element) return true;
      return state.activeId === id2;
    }
  });
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      id: id2 || item.id,
      rowId,
      disabled: trulyDisabled,
      children: item.element?.textContent
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [
    id2,
    rowId,
    trulyDisabled,
    getItemProp
  ]);
  const onFocusProp = props2.onFocus;
  const hasFocusedComposite = useRef(false);
  const cancelScheduledFocusRedirectRef = useRef(null);
  const onFocus = useEvent((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (isPortalEvent(event)) return;
    if (!id2) return;
    if (!store2) return;
    if (targetIsAnotherItem(event, store2)) return;
    const { virtualFocus, baseElement: baseElement2 } = store2.getState();
    store2.setActiveId(id2);
    if (isTextbox(event.currentTarget)) selectTextField(event.currentTarget);
    if (!virtualFocus) return;
    if (!isSelfTarget(event)) return;
    if (isEditableElement(event.currentTarget)) return;
    const redirectFocusToBaseElement = (currentTarget2, relatedTarget2, baseElement3) => {
      if (isSafari() && currentTarget2.hasAttribute("data-autofocus")) currentTarget2.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
      hasFocusedComposite.current = true;
      if (relatedTarget2 === baseElement3 || isItem(store2, relatedTarget2)) focusSilently(baseElement3);
      else baseElement3.focus();
    };
    if (baseElement2?.isConnected) {
      redirectFocusToBaseElement(event.currentTarget, event.relatedTarget, baseElement2);
      return;
    }
    if (shouldRegisterItem === false) return;
    const { currentTarget, relatedTarget } = event;
    const cancelScheduledFocusRedirect = () => {
      cancelScheduledFocusRedirectRef.current?.();
      cancelScheduledFocusRedirectRef.current = null;
    };
    cancelScheduledFocusRedirect();
    cancelScheduledFocusRedirectRef.current = subscribe(store2, null, () => {
      if (getActiveElement(currentTarget) !== currentTarget) {
        cancelScheduledFocusRedirect();
        return;
      }
      const state = store2.getState();
      const nextBaseElement = state.baseElement;
      if (!nextBaseElement?.isConnected) return;
      cancelScheduledFocusRedirect();
      if (!state.virtualFocus) return;
      redirectFocusToBaseElement(currentTarget, relatedTarget, nextBaseElement);
    });
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (store2?.getState()?.virtualFocus && hasFocusedComposite.current) {
      hasFocusedComposite.current = false;
      event.preventDefault();
      event.stopPropagation();
    }
  });
  const onKeyDownProp = props2.onKeyDown;
  const preventScrollOnKeyDownProp = useBooleanEvent(preventScrollOnKeyDown);
  const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (!isSelfTarget(event)) return;
    if (!store2) return;
    const { currentTarget } = event;
    const state = store2.getState();
    const isGrid2 = !!store2.item(id2)?.rowId;
    const isVertical = state.orientation !== "horizontal";
    const isHorizontal = state.orientation !== "vertical";
    const canHomeEnd = () => {
      if (isGrid2) return true;
      if (isHorizontal) return true;
      if (!state.baseElement) return true;
      if (!isTextField(state.baseElement)) return true;
      return false;
    };
    const action = {
      ArrowUp: (isGrid2 || isVertical) && store2.up,
      ArrowRight: (isGrid2 || isHorizontal) && store2.next,
      ArrowDown: (isGrid2 || isVertical) && store2.down,
      ArrowLeft: (isGrid2 || isHorizontal) && store2.previous,
      Home: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.first();
        return store2?.previous(-1);
      },
      End: () => {
        if (!canHomeEnd()) return;
        if (!isGrid2 || event.ctrlKey) return store2?.last();
        return store2?.next(-1);
      },
      PageUp: () => {
        return findNextPageItemId(currentTarget, store2, store2?.up, true);
      },
      PageDown: () => {
        return findNextPageItemId(currentTarget, store2, store2?.down);
      }
    }[event.key];
    if (action) {
      if (isTextbox(currentTarget)) {
        const selection2 = getTextboxSelection(currentTarget);
        const isLeft = isHorizontal && event.key === "ArrowLeft";
        const isRight = isHorizontal && event.key === "ArrowRight";
        const isUp = isVertical && event.key === "ArrowUp";
        const isDown = isVertical && event.key === "ArrowDown";
        if (isRight || isDown) {
          const { length: valueLength } = getTextboxValue(currentTarget);
          if (selection2.end !== valueLength) return;
        } else if ((isLeft || isUp) && selection2.start !== 0) return;
      }
      const nextId = action();
      if (preventScrollOnKeyDownProp(event) || nextId !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(nextId);
      }
    }
  });
  const providerValue = useMemo(() => ({
    id: id2,
    baseElement
  }), [id2, baseElement]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeItemContext.Provider, {
    value: providerValue,
    children: element2
  }), [providerValue]);
  props2 = {
    "data-active-item": isActiveItem || void 0,
    ...props2,
    id: id2,
    ref: useMergeRefs(ref, props2.ref),
    tabIndex: isTabbable2 ? props2.tabIndex : -1,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useCommand(props2);
  props2 = useCollectionItem({
    store: store2,
    ...props2,
    getItem,
    shouldRegisterItem: id2 ? shouldRegisterItem : false
  });
  return removeUndefinedValues({
    ...props2,
    "aria-setsize": ariaSetSize,
    "aria-posinset": ariaPosInSet
  });
});
const CompositeItem = memo(forwardRef(function CompositeItem4(props2) {
  return createElement(TagName$y, useCompositeItem(props2));
}));
const ctx$7 = createStoreContext([CompositeContextProvider], [CompositeScopedContextProvider]);
const useTabScopedContext = ctx$7.useScopedContext;
const useTabProviderContext = ctx$7.useProviderContext;
const TabContextProvider = ctx$7.ContextProvider;
const TabScopedContextProvider = ctx$7.ScopedContextProvider;
const TagName$x = "button";
const useTab = createHook(function useTab3({ store: store2, getItem: getItemProp, ...props2 }) {
  const context = useTabScopedContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Tab must be wrapped in a TabList component.");
  const defaultId = useId();
  const id2 = props2.id || defaultId;
  const dimmed = disabledFromProps(props2);
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      dimmed
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [dimmed, getItemProp]);
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    store2?.setSelectedId(id2);
  });
  const panelId = useStoreState(store2.panels, () => store2.panel(id2)?.id);
  const shouldRegisterItem = defaultId ? props2.shouldRegisterItem : false;
  const isActive = useStoreState(store2, (state) => !!id2 && state.activeId === id2);
  const selected = useStoreState(store2, (state) => !!id2 && state.selectedId === id2);
  const hasActiveItem2 = useStoreState(store2, (state) => !!store2.item(state.activeId));
  const canRegisterComposedItem = isActive || selected && !hasActiveItem2;
  const accessibleWhenDisabled = selected || (props2.accessibleWhenDisabled ?? true);
  if (useStoreState(store2.combobox || store2.composite, "virtualFocus")) props2 = {
    ...props2,
    tabIndex: -1
  };
  props2 = {
    role: "tab",
    "aria-selected": selected,
    "aria-controls": panelId || void 0,
    ...props2,
    id: id2,
    onClick
  };
  if (store2.composite) {
    const defaultProps = {
      id: id2,
      accessibleWhenDisabled,
      store: store2.composite,
      shouldRegisterItem: canRegisterComposedItem && shouldRegisterItem,
      rowId: props2.rowId,
      render: props2.render
    };
    props2 = {
      ...props2,
      render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeItem, {
        ...defaultProps,
        render: store2.combobox && store2.composite !== store2.combobox ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeItem, {
          ...defaultProps,
          store: store2.combobox
        }) : defaultProps.render
      })
    };
  }
  props2 = useCompositeItem({
    store: store2,
    ...props2,
    accessibleWhenDisabled,
    getItem,
    shouldRegisterItem
  });
  return props2;
});
const Tab = memo(forwardRef(function Tab3(props2) {
  return createElement(TagName$x, useTab(props2));
}));
const TagName$w = "div";
function isGrid(items) {
  return items.some((item) => !!item.rowId);
}
function isPrintableKey(event) {
  const target = event.target;
  if (target && !isTextField(target)) return false;
  return event.key.length === 1 && !event.ctrlKey && !event.metaKey;
}
function isModifierKey(event) {
  return event.key === "Shift" || event.key === "Control" || event.key === "Alt" || event.key === "Meta";
}
function useKeyboardEventProxy(store2, onKeyboardEvent, previousElementRef) {
  return useEvent((event) => {
    onKeyboardEvent?.(event);
    if (event.defaultPrevented) return;
    if (event.isPropagationStopped()) return;
    if (!isSelfTarget(event)) return;
    if (isModifierKey(event)) return;
    if (isPrintableKey(event)) return;
    const activeElement = getEnabledItem(store2, store2.getState().activeId)?.element;
    if (!activeElement) return;
    const { view, ...eventInit } = event;
    if (activeElement !== previousElementRef?.current) activeElement.focus();
    if (!fireKeyboardEvent(activeElement, event.type, eventInit)) event.preventDefault();
    if (event.currentTarget.contains(activeElement)) event.stopPropagation();
  });
}
function findFirstEnabledItemInTheLastRow(items) {
  return findFirstEnabledItem(flatten2DArray(reverseArray(groupItemsByRows(items))));
}
function withBaseScrollPreserved(store2, callback) {
  const { virtualFocus, baseElement } = store2.getState();
  if (!virtualFocus || !baseElement || !isTextField(baseElement)) {
    callback();
    return;
  }
  const savedScrollLeft = baseElement.scrollLeft;
  const savedScrollTop = baseElement.scrollTop;
  callback();
  baseElement.scrollLeft = savedScrollLeft;
  baseElement.scrollTop = savedScrollTop;
}
function useScheduleFocus(store2) {
  const [scheduled, setScheduled] = useState(false);
  const schedule = useCallback(() => setScheduled(true), []);
  const activeItem = useStoreState(store2, (state) => scheduled ? getEnabledItem(store2, state.activeId) : null);
  useEffect(() => {
    const activeElement = activeItem?.element;
    if (!scheduled) return;
    if (!activeElement) return;
    setScheduled(false);
    withBaseScrollPreserved(store2, () => {
      activeElement.focus({ preventScroll: true });
    });
  }, [
    store2,
    activeItem,
    scheduled
  ]);
  return schedule;
}
const CompositeFocusOnMove = memo(function CompositeFocusOnMove3({ store: store2, focusOnMove, previousElementRef }) {
  const moves = useStoreState(store2, "moves");
  const baseElement = useStoreState(store2, "baseElement");
  useEffect(() => {
    if (!moves) return;
    if (!focusOnMove) return;
    const { activeId } = store2.getState();
    const itemElement = getEnabledItem(store2, activeId)?.element;
    if (!itemElement) return;
    withBaseScrollPreserved(store2, () => focusIntoView(itemElement));
  }, [
    store2,
    moves,
    focusOnMove
  ]);
  useSafeLayoutEffect(() => {
    if (!moves) return;
    if (!baseElement) return;
    const { activeId } = store2.getState();
    if (!(activeId === null)) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (previousElement) fireBlurEvent(previousElement, { relatedTarget: baseElement });
    if (!hasFocus(baseElement)) baseElement.focus();
  }, [
    store2,
    moves,
    baseElement
  ]);
  return null;
});
const useComposite = createHook(function useComposite3({ store: store2, composite = true, focusOnMove = composite, moveOnKeyPress = true, ...props2 }) {
  const context = useCompositeProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Composite must receive a `store` prop or be wrapped in a CompositeProvider component.");
  const ref = useRef(null);
  const previousElementRef = useRef(null);
  const scheduleFocus = useScheduleFocus(store2);
  const [, setBaseElement] = useTransactionState(composite ? store2.setBaseElement : null);
  const virtualFocus = useStoreState(store2, "virtualFocus");
  const activeId = useStoreState(store2, (state) => state.virtualFocus ? state.activeId : null);
  useSafeLayoutEffect(() => {
    if (!store2) return;
    if (!composite) return;
    if (!virtualFocus) return;
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (!previousElement) return;
    const relatedTarget = getEnabledItem(store2, activeId)?.element || getActiveElement(previousElement);
    if (relatedTarget === previousElement) return;
    fireBlurEvent(previousElement, { relatedTarget });
  }, [
    store2,
    activeId,
    virtualFocus,
    composite
  ]);
  const onKeyDownCapture = useKeyboardEventProxy(store2, props2.onKeyDownCapture, previousElementRef);
  const onKeyUpCapture = useKeyboardEventProxy(store2, props2.onKeyUpCapture, previousElementRef);
  const onFocusCaptureProp = props2.onFocusCapture;
  const onFocusCapture = useEvent((event) => {
    onFocusCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (!virtualFocus2) return;
    const previousActiveElement = event.relatedTarget;
    const isSilentlyFocused = silentlyFocused(event.currentTarget);
    if (isSelfTarget(event) && isSilentlyFocused) {
      event.stopPropagation();
      previousElementRef.current = previousActiveElement;
    }
  });
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    if (!composite) return;
    if (!store2) return;
    const { relatedTarget } = event;
    const { virtualFocus: virtualFocus2 } = store2.getState();
    if (virtualFocus2) {
      if (isSelfTarget(event) && !isItem(store2, relatedTarget)) queueMicrotask(scheduleFocus);
    } else if (isSelfTarget(event)) store2.setActiveId(null);
  });
  const onBlurCaptureProp = props2.onBlurCapture;
  const onBlurCapture = useEvent((event) => {
    onBlurCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { virtualFocus: virtualFocus2, activeId: activeId2 } = store2.getState();
    if (!virtualFocus2) return;
    const activeElement = getEnabledItem(store2, activeId2)?.element;
    const nextActiveElement = event.relatedTarget;
    const nextActiveElementIsItem = isItem(store2, nextActiveElement);
    const previousElement = previousElementRef.current;
    previousElementRef.current = null;
    if (isSelfTarget(event) && nextActiveElementIsItem) {
      if (nextActiveElement === activeElement) {
        if (previousElement && previousElement !== nextActiveElement) fireBlurEvent(previousElement, event);
      } else if (activeElement) fireBlurEvent(activeElement, event);
      else if (previousElement) fireBlurEvent(previousElement, event);
      event.stopPropagation();
    } else if (!isItem(store2, event.target) && activeElement) fireBlurEvent(activeElement, event);
  });
  const onKeyDownProp = props2.onKeyDown;
  const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.nativeEvent.isComposing) return;
    if (event.defaultPrevented) return;
    if (!store2) return;
    if (!isSelfTarget(event)) return;
    const { orientation, renderedItems, activeId: activeId2, rtl } = store2.getState();
    if (getEnabledItem(store2, activeId2)?.element?.isConnected) return;
    const isVertical = orientation !== "horizontal";
    const isHorizontal = orientation !== "vertical";
    const grid = isGrid(renderedItems);
    if ((event.key === "ArrowLeft" || event.key === "ArrowRight" || event.key === "Home" || event.key === "End") && isTextField(event.currentTarget)) return;
    const up = () => {
      if (grid) return findFirstEnabledItemInTheLastRow(renderedItems)?.id;
      return store2?.last();
    };
    const action = {
      ArrowUp: (grid || isVertical) && up,
      ArrowRight: (grid || isHorizontal) && (rtl ? store2.last : store2.first),
      ArrowDown: (grid || isVertical) && store2.first,
      ArrowLeft: (grid || isHorizontal) && (rtl ? store2.first : store2.last),
      Home: store2.first,
      End: store2.last,
      PageUp: store2.first,
      PageDown: store2.last
    }[event.key];
    if (action) {
      const id2 = action();
      if (id2 !== void 0) {
        if (!moveOnKeyPressProp(event)) return;
        event.preventDefault();
        store2.move(id2);
      }
    }
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsxs(CompositeScopedContextProvider, {
    value: store2,
    children: [element2, composite && /* @__PURE__ */ jsxRuntimeExports$3.jsx(CompositeFocusOnMove, {
      store: store2,
      focusOnMove,
      previousElementRef
    })]
  }), [
    store2,
    composite,
    focusOnMove
  ]);
  props2 = {
    "aria-activedescendant": useStoreState(store2, (state) => {
      if (!store2) return;
      if (!composite) return;
      if (!state.virtualFocus) return;
      return getEnabledItem(store2, state.activeId)?.id;
    }),
    ...props2,
    ref: useMergeRefs(ref, setBaseElement, props2.ref),
    onKeyDownCapture,
    onKeyUpCapture,
    onFocusCapture,
    onFocus,
    onBlurCapture,
    onKeyDown
  };
  props2 = useFocusable({
    focusable: useStoreState(store2, (state) => composite && (state.virtualFocus || state.activeId === null)),
    ...props2
  });
  return props2;
});
forwardRef(function Composite4(props2) {
  return createElement(TagName$w, useComposite(props2));
});
const TagName$v = "div";
const useTabList = createHook(function useTabList3({ store: store2, ...props2 }) {
  const context = useTabProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "TabList must receive a `store` prop or be wrapped in a TabProvider component.");
  const orientation = useStoreState(store2, (state) => state.orientation === "both" ? void 0 : state.orientation);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  if (store2.composite) props2 = {
    focusable: false,
    ...props2
  };
  props2 = {
    role: "tablist",
    "aria-orientation": orientation,
    ...props2
  };
  props2 = useComposite({
    store: store2,
    ...props2
  });
  return props2;
});
const TabList = forwardRef(function TabList3(props2) {
  return createElement(TagName$v, useTabList(props2));
});
const ctx$6 = createStoreContext();
const useDisclosureProviderContext = ctx$6.useProviderContext;
const DisclosureContextProvider = ctx$6.ContextProvider;
const DisclosureScopedContextProvider = ctx$6.ScopedContextProvider;
const ctx$5 = createStoreContext([DisclosureContextProvider], [DisclosureScopedContextProvider]);
const useDialogProviderContext = ctx$5.useProviderContext;
const DialogContextProvider = ctx$5.ContextProvider;
const DialogScopedContextProvider = ctx$5.ScopedContextProvider;
const DialogHeadingContext = createContext(void 0);
const DialogDescriptionContext = createContext(void 0);
const TagName$u = "div";
function afterTimeout(timeoutMs, cb2) {
  const timeoutId = setTimeout(cb2, timeoutMs);
  return () => clearTimeout(timeoutId);
}
function parseCSSTime(time) {
  const value = time?.trim() || "0s";
  const multiplier = value.endsWith("ms") ? 1 : 1e3;
  const parsed = Number.parseFloat(value) * multiplier;
  return Number.isNaN(parsed) ? 0 : parsed;
}
function getEndTime(names, delays, durations) {
  const nameList = names.split(",");
  const delayList = delays.split(",");
  const durationList = durations.split(",");
  let endTime = 0;
  for (const [index2, name2] of nameList.entries()) {
    if (name2.trim() === "none") continue;
    const delay = parseCSSTime(delayList[index2 % delayList.length]);
    const duration = parseCSSTime(durationList[index2 % durationList.length]);
    endTime = Math.max(endTime, delay + duration);
  }
  return endTime;
}
function getElementEndTime(element2) {
  const { transitionProperty, transitionDuration, transitionDelay, animationName, animationDuration, animationDelay } = getComputedStyle(element2);
  return Math.max(getEndTime(transitionProperty, transitionDelay, transitionDuration), getEndTime(animationName, animationDelay, animationDuration));
}
function isHidden(mounted, hidden, alwaysVisible) {
  return !alwaysVisible && hidden !== false && (!mounted || !!hidden);
}
const useDisclosureContent = createHook(function useDisclosureContent2({ store: store2, alwaysVisible, unstable_otherElementRef: otherElementRef, ...props2 }) {
  const context = useDisclosureProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "DisclosureContent must receive a `store` prop or be wrapped in a DisclosureProvider component.");
  const ref = useRef(null);
  const id2 = useId(props2.id);
  const [transition, setTransition] = useState(null);
  const open = useStoreState(store2, "open");
  const mounted = useStoreState(store2, "mounted");
  const animated = useStoreState(store2, "animated");
  const contentElement = useStoreState(store2, "contentElement");
  const otherElement = useStoreState(store2.disclosure, "contentElement");
  const hasClosedRef = useRef(false);
  useSafeLayoutEffect(() => {
    if (!ref.current) return;
    store2?.setContentElement(ref.current);
  }, [store2]);
  useSafeLayoutEffect(() => {
    let previousAnimated;
    store2?.setState("animated", (animated2) => {
      previousAnimated = animated2;
      return true;
    });
    return () => {
      if (previousAnimated === void 0) return;
      store2?.setState("animated", previousAnimated);
    };
  }, [store2]);
  useSafeLayoutEffect(() => {
    if (!animated) {
      if (!open) {
        hasClosedRef.current = true;
        setTransition(null);
      } else if (hasClosedRef.current) {
        hasClosedRef.current = false;
        setTransition("enter");
      }
      return;
    }
    if (!contentElement?.isConnected) {
      setTransition(null);
      return;
    }
    return afterPaint(() => {
      setTransition(open ? "enter" : mounted ? "leave" : null);
    });
  }, [
    animated,
    contentElement,
    open,
    mounted
  ]);
  useSafeLayoutEffect(() => {
    if (!store2) return;
    if (!animated) return;
    if (!transition) return;
    if (!contentElement) return;
    const stopAnimation = () => store2?.setState("animating", false);
    const stopAnimationSync = () => flushSync(stopAnimation);
    if (transition === "leave" && open) return;
    if (transition === "enter" && !open) return;
    if (typeof animated === "number") return afterTimeout(animated, stopAnimationSync);
    const elements2 = [contentElement];
    if (otherElement) elements2.push(otherElement);
    const relatedElement = otherElementRef?.current;
    if (relatedElement) elements2.push(relatedElement);
    const timeout = Math.max(...elements2.map(getElementEndTime));
    if (!timeout) {
      if (transition === "enter") store2.setState("animated", false);
      stopAnimation();
      return;
    }
    return afterTimeout(Math.max(timeout - 1e3 / 60, 0), stopAnimationSync);
  }, [
    store2,
    animated,
    contentElement,
    otherElement,
    otherElementRef,
    open,
    transition
  ]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
  const styleProp = props2.style;
  const style = useMemo(() => {
    if (hidden) return {
      ...styleProp,
      display: "none"
    };
    return styleProp;
  }, [hidden, styleProp]);
  props2 = {
    "data-open": open || void 0,
    "data-enter": transition === "enter" || void 0,
    "data-leave": transition === "leave" || void 0,
    hidden,
    ...props2,
    id: id2,
    ref: useMergeRefs(id2 ? store2.setContentElement : null, ref, props2.ref),
    style
  };
  return removeUndefinedValues(props2);
});
const DisclosureContentImpl = forwardRef(function DisclosureContentImpl2(props2) {
  return createElement(TagName$u, useDisclosureContent(props2));
});
forwardRef(function DisclosureContent({ unmountOnHide, ...props2 }) {
  const context = useDisclosureProviderContext();
  if (useStoreState(props2.store || context, (state) => !unmountOnHide || state?.mounted) === false) return null;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(DisclosureContentImpl, { ...props2 });
});
function createDisclosureStore(props2 = {}) {
  const store2 = mergeStore(props2.store, omit(props2.disclosure, ["contentElement", "disclosureElement"]));
  throwOnConflictingProps(props2, store2);
  const syncState = store2?.getState();
  const open = defaultValue(props2.open, syncState?.open, props2.defaultOpen, false);
  const animated = defaultValue(props2.animated, syncState?.animated, false);
  const disclosure = createStore({
    open,
    animated,
    animating: !!animated && open,
    mounted: open,
    contentElement: defaultValue(syncState?.contentElement, null),
    disclosureElement: defaultValue(syncState?.disclosureElement, null)
  }, store2);
  setup(disclosure, () => sync(disclosure, ["animated", "animating"], (state) => {
    if (state.animated) return;
    disclosure.setState("animating", false);
  }));
  setup(disclosure, () => subscribe(disclosure, ["open"], () => {
    if (!disclosure.getState().animated) return;
    disclosure.setState("animating", true);
  }));
  setup(disclosure, () => sync(disclosure, ["open", "animating"], (state) => {
    disclosure.setState("mounted", state.open || state.animating);
  }));
  return {
    ...disclosure,
    disclosure: props2.disclosure,
    setOpen: (value) => disclosure.setState("open", value),
    show: () => disclosure.setState("open", true),
    hide: () => disclosure.setState("open", false),
    toggle: () => disclosure.setState("open", (open2) => !open2),
    stopAnimation: () => disclosure.setState("animating", false),
    setContentElement: (value) => disclosure.setState("contentElement", value),
    setDisclosureElement: (value) => disclosure.setState("disclosureElement", value)
  };
}
function useDisclosureStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.store, props2.disclosure]);
  useStoreProps(store2, props2, "open", "setOpen");
  useStoreProps(store2, props2, "mounted", "setMounted");
  useStoreProps(store2, props2, "animated");
  return Object.assign(store2, { disclosure: props2.disclosure });
}
function useDisclosureStore(props2 = {}) {
  const [store2, update] = useStore(createDisclosureStore, props2);
  return useDisclosureStoreProps(store2, update, props2);
}
const TagName$t = "div";
const useTabPanel = createHook(function useTabPanel2({ store: store2, unmountOnHide, tabId: tabIdProp, getItem: getItemProp, scrollRestoration, scrollElement, ...props2 }) {
  const context = useTabProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "TabPanel must receive a `store` prop or be wrapped in a TabProvider component.");
  const ref = useRef(null);
  const id2 = useId(props2.id);
  const tabId = useStoreState(store2.panels, () => tabIdProp || store2?.panels.item(id2)?.tabId);
  const disclosure = useDisclosureStore({ open: useStoreState(store2, (state) => !!tabId && state.selectedId === tabId) });
  const mounted = useStoreState(disclosure, "mounted");
  const scrollPositionRef = useRef(/* @__PURE__ */ new Map());
  const getScrollElement = useEvent(() => {
    const panelElement = ref.current;
    if (!panelElement) return null;
    if (!scrollElement) return panelElement;
    if (typeof scrollElement === "function") return scrollElement(panelElement);
    if ("current" in scrollElement) return scrollElement.current;
    return scrollElement;
  });
  useEffect(() => {
    if (!scrollRestoration) return;
    if (!mounted) return;
    const element2 = getScrollElement();
    if (!element2) return;
    if (scrollRestoration === "reset") {
      element2.scroll(0, 0);
      return;
    }
    if (!tabId) return;
    const position2 = scrollPositionRef.current.get(tabId);
    element2.scroll(position2?.x ?? 0, position2?.y ?? 0);
    const onScroll = () => {
      scrollPositionRef.current.set(tabId, {
        x: element2.scrollLeft,
        y: element2.scrollTop
      });
    };
    element2.addEventListener("scroll", onScroll);
    return () => {
      element2.removeEventListener("scroll", onScroll);
    };
  }, [
    scrollRestoration,
    mounted,
    tabId,
    getScrollElement
  ]);
  const [hasTabbableChildren, setHasTabbableChildren] = useState(false);
  useSafeLayoutEffect(() => {
    if (!mounted) return;
    const element2 = ref.current;
    if (!element2) return;
    setHasTabbableChildren(!!getFirstTabbableIn(element2));
  }, [mounted, tabId]);
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      id: id2 || item.id,
      tabId: tabIdProp
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [
    id2,
    tabIdProp,
    getItemProp
  ]);
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2?.composite) return;
    const action = {
      ArrowLeft: store2.previous,
      ArrowRight: store2.next,
      Home: store2.first,
      End: store2.last
    }[event.key];
    if (!action) return;
    const { selectedId } = store2.getState();
    const nextId = action({ activeId: selectedId });
    if (!nextId) return;
    event.preventDefault();
    store2.move(nextId);
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  props2 = {
    role: "tabpanel",
    "aria-labelledby": props2["aria-label"] != null ? void 0 : tabId || void 0,
    ...props2,
    id: id2,
    children: unmountOnHide && !mounted ? null : props2.children,
    ref: useMergeRefs(ref, props2.ref),
    onKeyDown
  };
  props2 = useFocusable({
    focusable: !store2.composite && !hasTabbableChildren,
    ...props2
  });
  props2 = useDisclosureContent({
    store: disclosure,
    ...props2
  });
  props2 = useCollectionItem({
    store: store2.panels,
    ...props2,
    getItem
  });
  return props2;
});
const TabPanel = forwardRef(function TabPanel2(props2) {
  return createElement(TagName$t, useTabPanel(props2));
});
const ctx$4 = createStoreContext([DialogContextProvider], [DialogScopedContextProvider]);
const usePopoverContext = ctx$4.useContext;
const usePopoverProviderContext = ctx$4.useProviderContext;
const PopoverContextProvider = ctx$4.ContextProvider;
const PopoverScopedContextProvider = ctx$4.ScopedContextProvider;
const ComboboxListRoleContext = createContext(void 0);
const ctx$3 = createStoreContext([PopoverContextProvider, CompositeContextProvider], [PopoverScopedContextProvider, CompositeScopedContextProvider]);
const useComboboxContext = ctx$3.useContext;
const useComboboxScopedContext = ctx$3.useScopedContext;
const useComboboxProviderContext = ctx$3.useProviderContext;
const ComboboxContextProvider = ctx$3.ContextProvider;
const ComboboxScopedContextProvider = ctx$3.ScopedContextProvider;
const ComboboxItemValueContext = createContext(void 0);
const ComboboxItemCheckedContext = createContext(false);
function useCollectionStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.store]);
  useStoreProps(store2, props2, "items", "setItems");
  return store2;
}
function useCompositeStoreOptions(props2) {
  return {
    id: useId(props2.id),
    ...props2
  };
}
function useCompositeStoreProps(store2, update, props2) {
  store2 = useCollectionStoreProps(store2, update, props2);
  useStoreProps(store2, props2, "activeId", "setActiveId");
  useStoreProps(store2, props2, "includesBaseElement");
  useStoreProps(store2, props2, "virtualFocus");
  useStoreProps(store2, props2, "orientation");
  useStoreProps(store2, props2, "rtl");
  useStoreProps(store2, props2, "focusLoop");
  useStoreProps(store2, props2, "focusWrap");
  useStoreProps(store2, props2, "focusShift");
  return store2;
}
const ctx$2 = createStoreContext([PopoverContextProvider, CompositeContextProvider], [PopoverScopedContextProvider, CompositeScopedContextProvider]);
const useSelectContext = ctx$2.useContext;
const useSelectScopedContext = ctx$2.useScopedContext;
const useSelectProviderContext = ctx$2.useProviderContext;
const SelectContextProvider = ctx$2.ContextProvider;
const SelectScopedContextProvider = ctx$2.ScopedContextProvider;
const SelectItemCheckedContext = createContext(false);
const SelectHeadingContext = createContext(null);
function getFocusedTab(items) {
  const activeElement = items[0]?.element?.ownerDocument.activeElement;
  if (!activeElement) return;
  return items.find((item) => item.element === activeElement);
}
function getTabById(items, id2) {
  if (id2 == null) return;
  return items.find((item) => item.id === id2);
}
function isEnabledTab(item) {
  if (!item) return false;
  if (item.disabled) return false;
  if (item.dimmed) return false;
  return true;
}
function createPanelsStore() {
  const panels = createCollectionStore();
  const panelsByTabId = /* @__PURE__ */ new Map();
  sync(panels, ["items"], (state) => {
    panelsByTabId.clear();
    for (const panel of state.items) {
      const { tabId } = panel;
      if (tabId == null) continue;
      if (panelsByTabId.has(tabId)) continue;
      panelsByTabId.set(tabId, panel);
    }
  });
  return {
    panels,
    panel: (tabId) => {
      if (tabId == null) return null;
      return panelsByTabId.get(tabId) || null;
    }
  };
}
function createTabStore({ composite: parentComposite, combobox, ...props2 } = {}) {
  const independentKeys = [
    "items",
    "renderedItems",
    "moves",
    "orientation",
    "virtualFocus",
    "includesBaseElement",
    "baseElement",
    "focusLoop",
    "focusShift",
    "focusWrap"
  ];
  const store2 = mergeStore(props2.store, omit(parentComposite, independentKeys), omit(combobox, independentKeys));
  const syncState = store2?.getState();
  const composite = createCompositeStore({
    ...props2,
    store: store2,
    includesBaseElement: defaultValue(props2.includesBaseElement, syncState?.includesBaseElement, false),
    orientation: defaultValue(props2.orientation, syncState?.orientation, "horizontal"),
    focusLoop: defaultValue(props2.focusLoop, syncState?.focusLoop, true)
  });
  const { panels, panel } = createPanelsStore();
  const tab2 = createStore({
    ...composite.getState(),
    selectedId: defaultValue(props2.selectedId, syncState?.selectedId, props2.defaultSelectedId),
    selectOnMove: defaultValue(props2.selectOnMove, syncState?.selectOnMove, true)
  }, composite, store2);
  setup(tab2, () => sync(tab2, ["moves"], () => {
    const { activeId, selectOnMove } = tab2.getState();
    if (!selectOnMove) return;
    if (!activeId) return;
    const tabItem = composite.item(activeId);
    if (!isEnabledTab(tabItem)) return;
    tab2.setState("selectedId", tabItem.id);
  }));
  let pendingRestore = false;
  let restoredSelectedId;
  setup(tab2, () => {
    pendingRestore = false;
    return batch(tab2, ["selectedId"], (state, prev) => {
      if (pendingRestore) {
        pendingRestore = false;
        if (state.selectedId === restoredSelectedId) return;
      }
      if (parentComposite && state.selectedId === prev.selectedId) return;
      const { activeId, renderedItems } = tab2.getState();
      const focusedTab = getFocusedTab(renderedItems);
      const selectedTab = getTabById(renderedItems, state.selectedId);
      if (focusedTab && isEnabledTab(selectedTab) && activeId !== selectedTab.id) {
        composite.move(selectedTab.id);
        return;
      }
      tab2.setState("activeId", state.selectedId);
    });
  });
  setup(tab2, () => sync(tab2, ["selectedId", "renderedItems"], (state) => {
    if (state.selectedId !== void 0) return;
    const { activeId, renderedItems } = tab2.getState();
    const tabItem = composite.item(activeId);
    if (isEnabledTab(tabItem)) tab2.setState("selectedId", tabItem.id);
    else {
      const tabItem2 = renderedItems.find(isEnabledTab);
      tab2.setState("selectedId", tabItem2?.id);
    }
  }));
  setup(tab2, () => sync(tab2, ["renderedItems"], (state) => {
    const tabs = state.renderedItems;
    if (!tabs.length) return;
    return sync(panels, ["renderedItems"], (state2) => {
      const items = state2.renderedItems;
      if (!items.some((panel2) => !panel2.tabId)) return;
      items.forEach((panel2, i2) => {
        if (panel2.tabId) return;
        const tabItem = tabs[i2];
        if (!tabItem) return;
        panels.renderItem({
          ...panel2,
          tabId: tabItem.id
        });
      });
    });
  }));
  let selectedIdFromSelectedValue = null;
  setup(tab2, () => {
    const backupSelectedId = () => {
      selectedIdFromSelectedValue = tab2.getState().selectedId;
    };
    const restoreSelectedId = () => {
      const { selectedId } = tab2.getState();
      if (selectedId === selectedIdFromSelectedValue) return;
      pendingRestore = true;
      restoredSelectedId = selectedIdFromSelectedValue;
      tab2.setState("selectedId", selectedIdFromSelectedValue);
    };
    if (parentComposite && "setSelectElement" in parentComposite) return chain(sync(parentComposite, ["value"], backupSelectedId), sync(parentComposite, ["mounted"], restoreSelectedId));
    if (!combobox) return;
    return chain(sync(combobox, ["selectedValue"], backupSelectedId), sync(combobox, ["mounted"], restoreSelectedId));
  });
  return {
    ...composite,
    ...tab2,
    panels,
    panel,
    setSelectedId: (id2) => tab2.setState("selectedId", id2),
    select: (id2) => {
      tab2.setState("selectedId", id2);
      composite.move(id2);
    }
  };
}
function useTabStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.composite, props2.combobox]);
  store2 = useCompositeStoreProps(store2, update, props2);
  useStoreProps(store2, props2, "selectedId", "setSelectedId");
  useStoreProps(store2, props2, "selectOnMove");
  const [panels, updatePanels] = useStore(() => store2.panels, {});
  useUpdateEffect(updatePanels, [store2, updatePanels]);
  return Object.assign(useMemo(() => ({
    ...store2,
    panels
  }), [store2, panels]), {
    composite: props2.composite,
    combobox: props2.combobox
  });
}
function useTabStore(props2 = {}) {
  const combobox = useComboboxContext();
  const composite = useSelectContext() || combobox;
  props2 = {
    ...props2,
    composite: props2.composite !== void 0 ? props2.composite : composite,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  const [store2, update] = useStore(createTabStore, props2);
  return useTabStoreProps(store2, update, props2);
}
function TabProvider(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabContextProvider, {
    value: useTabStore(props2),
    children: props2.children
  });
}
const TagName$s = "div";
const useFocusableContainer = createHook(function useFocusableContainer2({ autoFocusOnShow = true, ...props2 }) {
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusableContext.Provider, {
    value: autoFocusOnShow,
    children: element2
  }), [autoFocusOnShow]);
  return props2;
});
forwardRef(function FocusableContainer(props2) {
  return createElement(TagName$s, useFocusableContainer(props2));
});
const HeadingContext = createContext(0);
function HeadingLevel({ level, children }) {
  const contextLevel = useContext(HeadingContext);
  const nextLevel = Math.max(Math.min(level || contextLevel + 1, 6), 1);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(HeadingContext.Provider, {
    value: nextLevel,
    children
  });
}
const TagName$r = "span";
function getVisuallyHiddenStyle(style) {
  return {
    borderWidth: 0,
    clipPath: "inset(50%)",
    height: "1px",
    margin: "-1px",
    overflow: "hidden",
    padding: 0,
    position: "absolute",
    whiteSpace: "nowrap",
    width: "1px",
    ...style
  };
}
const useVisuallyHidden = createHook(function useVisuallyHidden2(props2) {
  props2 = {
    ...props2,
    style: getVisuallyHiddenStyle(props2.style)
  };
  return props2;
});
forwardRef(function VisuallyHidden(props2) {
  return createElement(TagName$r, useVisuallyHidden(props2));
});
const TagName$q = "span";
const useFocusTrap = createHook(function useFocusTrap2(props2) {
  props2 = {
    "data-focus-trap": "",
    tabIndex: 0,
    "aria-hidden": true,
    ...props2,
    style: {
      position: "fixed",
      top: 0,
      left: 0,
      ...props2.style
    }
  };
  props2 = useVisuallyHidden(props2);
  return props2;
});
const FocusTrap = forwardRef(function FocusTrap2(props2) {
  return createElement(TagName$q, useFocusTrap(props2));
});
const PortalContext = createContext(null);
const TagName$p = "div";
function getRootElement(element2) {
  const doc2 = getDocument(element2);
  const { fullscreenElement } = doc2;
  const HTMLElementClass = doc2.defaultView?.HTMLElement;
  if (HTMLElementClass && fullscreenElement instanceof HTMLElementClass) return fullscreenElement;
  return doc2.body;
}
function getPortalElement(element2, portalElement) {
  if (!portalElement) return getDocument(element2).createElement("div");
  if (typeof portalElement === "function") return portalElement(element2);
  return portalElement;
}
function getRandomId(prefix = "id") {
  return `${prefix ? `${prefix}-` : ""}${Math.random().toString(36).slice(2, 8)}`;
}
function queueFocus(element2) {
  queueMicrotask(() => {
    element2?.focus();
  });
}
function attachPortalRef(ref, node) {
  return {
    ref,
    node,
    cleanup: setRef(ref, node)
  };
}
function detachPortalRef(attached) {
  if (typeof attached.cleanup === "function") attached.cleanup();
  else setRef(attached.ref, null);
}
const usePortal = createHook(function usePortal2({ preserveTabOrder, preserveTabOrderAnchor, portalElement, portalRef, portal = true, ...props2 }) {
  const ref = useRef(null);
  const refProp = useMergeRefs(ref, props2.ref);
  const context = useContext(PortalContext);
  const [portalNode, setPortalNode] = useState(null);
  const [anchorPortalNode, setAnchorPortalNode] = useState(null);
  const outerBeforeRef = useRef(null);
  const innerBeforeRef = useRef(null);
  const innerAfterRef = useRef(null);
  const outerAfterRef = useRef(null);
  const portalRefProp = useLiveRef(portalRef);
  const attachedPortalRefRef = useRef(null);
  useSafeLayoutEffect(() => {
    const element2 = ref.current;
    if (!element2 || !portal) {
      setPortalNode(null);
      return;
    }
    const portalEl = getPortalElement(element2, portalElement);
    if (!portalEl) {
      setPortalNode(null);
      return;
    }
    const isPortalInDocument = portalEl.isConnected;
    if (!isPortalInDocument) (context || getRootElement(element2)).appendChild(portalEl);
    if (!portalEl.id) portalEl.id = element2.id ? `portal/${element2.id}` : getRandomId();
    setPortalNode(portalEl);
    attachedPortalRefRef.current = attachPortalRef(portalRefProp.current, portalEl);
    return () => {
      const attached = attachedPortalRefRef.current;
      if (attached) {
        attachedPortalRefRef.current = null;
        detachPortalRef(attached);
      }
      if (!isPortalInDocument) portalEl.remove();
    };
  }, [
    portal,
    portalElement,
    context
  ]);
  useSafeLayoutEffect(() => {
    const attached = attachedPortalRefRef.current;
    if (!attached) return;
    if (attached.ref === portalRef) return;
    detachPortalRef(attached);
    attachedPortalRefRef.current = attachPortalRef(portalRef, attached.node);
  }, [portalRef]);
  useEffect(() => {
    if (!portalNode) return;
    if (context) return;
    if (portalElement) return;
    const doc2 = getDocument(portalNode);
    const onFullscreenChange = () => {
      const rootElement = getRootElement(portalNode);
      if (portalNode.parentElement !== rootElement) rootElement.appendChild(portalNode);
    };
    if (portalNode.isConnected) onFullscreenChange();
    doc2.addEventListener("fullscreenchange", onFullscreenChange);
    return () => {
      doc2.removeEventListener("fullscreenchange", onFullscreenChange);
    };
  }, [
    portalNode,
    context,
    portalElement
  ]);
  useSafeLayoutEffect(() => {
    if (!portal) return;
    if (!preserveTabOrder) return;
    if (!preserveTabOrderAnchor) return;
    const element2 = getDocument(preserveTabOrderAnchor).createElement("span");
    element2.style.position = "fixed";
    preserveTabOrderAnchor.insertAdjacentElement("afterend", element2);
    setAnchorPortalNode(element2);
    return () => {
      element2.remove();
      setAnchorPortalNode(null);
    };
  }, [
    portal,
    preserveTabOrder,
    preserveTabOrderAnchor
  ]);
  useEffect(() => {
    if (!portalNode) return;
    if (!preserveTabOrder) return;
    let raf = 0;
    const onFocus = (event) => {
      if (!isFocusEventOutside(event)) return;
      const focusing = event.type === "focusin";
      cancelAnimationFrame(raf);
      if (focusing) return restoreFocusIn(portalNode);
      raf = requestAnimationFrame(() => {
        disableFocusIn(portalNode, true);
      });
    };
    portalNode.addEventListener("focusin", onFocus, true);
    portalNode.addEventListener("focusout", onFocus, true);
    return () => {
      cancelAnimationFrame(raf);
      portalNode.removeEventListener("focusin", onFocus, true);
      portalNode.removeEventListener("focusout", onFocus, true);
    };
  }, [portalNode, preserveTabOrder]);
  props2 = useWrapElement(props2, (element2) => {
    element2 = /* @__PURE__ */ jsxRuntimeExports$3.jsx(PortalContext.Provider, {
      value: portalNode || context,
      children: element2
    });
    if (!portal) return element2;
    if (!portalNode) return /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", {
      ref: refProp,
      id: props2.id,
      style: { position: "fixed" },
      hidden: true
    });
    element2 = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
      preserveTabOrder && /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusTrap, {
        ref: innerBeforeRef,
        "data-focus-trap": props2.id,
        className: "__focus-trap-inner-before",
        onFocus: (event) => {
          if (isFocusEventOutside(event, portalNode)) queueFocus(getNextTabbable());
          else queueFocus(outerBeforeRef.current);
        }
      }),
      element2,
      preserveTabOrder && /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusTrap, {
        ref: innerAfterRef,
        "data-focus-trap": props2.id,
        className: "__focus-trap-inner-after",
        onFocus: (event) => {
          if (isFocusEventOutside(event, portalNode)) queueFocus(getPreviousTabbable());
          else queueFocus(outerAfterRef.current);
        }
      })
    ] });
    element2 = createPortal(element2, portalNode);
    let preserveTabOrderElement = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
      preserveTabOrder && /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusTrap, {
        ref: outerBeforeRef,
        "data-focus-trap": props2.id,
        className: "__focus-trap-outer-before",
        onFocus: (event) => {
          if (!(event.relatedTarget === outerAfterRef.current) && isFocusEventOutside(event, portalNode)) queueFocus(innerBeforeRef.current);
          else queueFocus(getPreviousTabbable());
        }
      }),
      preserveTabOrder && /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", {
        "aria-owns": portalNode.id,
        style: { position: "fixed" }
      }),
      preserveTabOrder && /* @__PURE__ */ jsxRuntimeExports$3.jsx(FocusTrap, {
        ref: outerAfterRef,
        "data-focus-trap": props2.id,
        className: "__focus-trap-outer-after",
        onFocus: (event) => {
          if (isFocusEventOutside(event, portalNode)) queueFocus(innerAfterRef.current);
          else {
            const nextTabbable = getNextTabbable();
            if (nextTabbable === innerBeforeRef.current) {
              requestAnimationFrame(() => getNextTabbable()?.focus());
              return;
            }
            queueFocus(nextTabbable);
          }
        }
      })
    ] });
    if (anchorPortalNode && preserveTabOrder) preserveTabOrderElement = createPortal(preserveTabOrderElement, anchorPortalNode);
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [preserveTabOrderElement, element2] });
  }, [
    portalNode,
    context,
    portal,
    props2.id,
    preserveTabOrder,
    anchorPortalNode
  ]);
  props2 = {
    ...props2,
    ref: refProp
  };
  return props2;
});
forwardRef(function Portal(props2) {
  return createElement(TagName$p, usePortal(props2));
});
function isBackdrop(element2, ...ids) {
  if (!element2) return false;
  const backdrop = element2.getAttribute("data-backdrop");
  if (backdrop == null) return false;
  if (backdrop === "") return true;
  if (backdrop === "true") return true;
  if (!ids.length) return true;
  return ids.some((id2) => backdrop === id2);
}
const cleanups = /* @__PURE__ */ new WeakMap();
function flushCleanupStack(elementCleanups, key, stack) {
  while (stack.length) {
    const entry = stack[stack.length - 1];
    if (!entry) {
      elementCleanups.delete(key);
      return;
    }
    if (!entry.disposed) return;
    stack.pop();
    entry.cleanup();
  }
  elementCleanups.delete(key);
}
function orchestrate(element2, key, setup2) {
  let elementCleanups = cleanups.get(element2);
  if (!elementCleanups) {
    elementCleanups = /* @__PURE__ */ new Map();
    cleanups.set(element2, elementCleanups);
  }
  const stack = elementCleanups.get(key) ?? [];
  const entry = {
    cleanup: setup2(),
    disposed: false
  };
  if (!stack.length) elementCleanups.set(key, stack);
  stack.push(entry);
  return () => {
    if (!stack.includes(entry)) return;
    entry.disposed = true;
    flushCleanupStack(elementCleanups, key, stack);
  };
}
function setAttribute(element2, attr, value) {
  const setup2 = () => {
    const previousValue = element2.getAttribute(attr);
    element2.setAttribute(attr, value);
    return () => {
      if (previousValue == null) element2.removeAttribute(attr);
      else element2.setAttribute(attr, previousValue);
    };
  };
  return orchestrate(element2, attr, setup2);
}
function setProperty(element2, property2, value) {
  const setup2 = () => {
    const exists = property2 in element2;
    const previousValue = element2[property2];
    element2[property2] = value;
    return () => {
      if (!exists) delete element2[property2];
      else element2[property2] = previousValue;
    };
  };
  return orchestrate(element2, property2, setup2);
}
function assignStyle(element2, style) {
  if (!element2) return () => {
  };
  const setup2 = () => {
    const prevStyle = element2.style.cssText;
    Object.assign(element2.style, style);
    return () => {
      element2.style.cssText = prevStyle;
    };
  };
  return orchestrate(element2, "style", setup2);
}
function setCSSProperty(element2, property2, value) {
  if (!element2) return () => {
  };
  const setup2 = () => {
    const previousValue = element2.style.getPropertyValue(property2);
    element2.style.setProperty(property2, value);
    return () => {
      if (previousValue) element2.style.setProperty(property2, previousValue);
      else element2.style.removeProperty(property2);
    };
  };
  return orchestrate(element2, property2, setup2);
}
function getPropertyName(id2 = "", kind = "outside") {
  return `__ariakit-dialog-${kind}${id2 ? `-${id2}` : ""}`;
}
function markElement(element2, id2 = "") {
  return chain(setProperty(element2, getPropertyName(), true), setProperty(element2, getPropertyName(id2), true));
}
function markAncestor(element2, id2 = "") {
  return chain(setProperty(element2, getPropertyName("", "ancestor"), true), setProperty(element2, getPropertyName(id2, "ancestor"), true));
}
function markTreeInside(id2, elements2) {
  return chain(...elements2.map((element2) => {
    if (!element2) return void 0;
    return setProperty(element2, getPropertyName(id2, "inside"), true);
  }));
}
function isElementInside(element2, id2) {
  const propertyName2 = getPropertyName(id2, "inside");
  do {
    if (element2[propertyName2]) return true;
    if (!element2.parentElement) return false;
    element2 = element2.parentElement;
  } while (true);
}
function isElementMarked(element2, id2) {
  const ancestorProperty = getPropertyName(id2, "ancestor");
  if (element2[ancestorProperty]) return true;
  const elementProperty = getPropertyName(id2);
  do {
    if (element2[elementProperty]) return true;
    if (!element2.parentElement) return false;
    element2 = element2.parentElement;
  } while (true);
}
function addElementMarkCleanup({ cleanups: cleanups2, element: element2, id: id2, ids }) {
  if (isBackdrop(element2, ...ids)) return;
  cleanups2.push(markElement(element2, id2));
}
function addAncestorMarkCleanup({ cleanups: cleanups2, ancestor, element: element2, id: id2 }) {
  if (element2.hasAttribute("data-dialog") && element2.id !== id2) return;
  cleanups2.push(markAncestor(ancestor, id2));
}
function restoreCleanups(cleanups2) {
  for (let index2 = cleanups2.length - 1; index2 >= 0; index2 -= 1) cleanups2[index2]?.();
}
const ignoreTags = ["SCRIPT", "STYLE"];
function getSnapshotPropertyName(id2) {
  return `__ariakit-dialog-snapshot-${id2}`;
}
function inSnapshot(id2, element2) {
  const doc2 = getDocument(element2);
  const propertyName2 = getSnapshotPropertyName(id2);
  if (!doc2.body[propertyName2]) return true;
  do {
    if (element2 === doc2.body) return false;
    if (element2[propertyName2]) return true;
    if (!element2.parentElement) return false;
    element2 = element2.parentElement;
  } while (true);
}
function shouldWalkElement(id2, element2, ignoredElements) {
  if (ignoreTags.includes(element2.tagName)) return false;
  if (!inSnapshot(id2, element2)) return false;
  return !ignoredElements.some((enabledElement) => enabledElement && contains(element2, enabledElement));
}
function walkTreeOutside(id2, elements2, callback, ancestorCallback) {
  for (let element2 of elements2) {
    if (!element2?.isConnected) continue;
    const hasAncestorAlready = elements2.some((maybeAncestor) => {
      if (!maybeAncestor) return false;
      if (maybeAncestor === element2) return false;
      return maybeAncestor.contains(element2);
    });
    const doc2 = getDocument(element2);
    const originalElement = element2;
    while (element2.parentElement && element2 !== doc2.body) {
      ancestorCallback?.(element2.parentElement, originalElement);
      if (!hasAncestorAlready) {
        for (const child of element2.parentElement.children) if (shouldWalkElement(id2, child, elements2)) callback(child, originalElement);
      }
      element2 = element2.parentElement;
    }
  }
}
function createWalkTreeSnapshot(id2, elements2) {
  const { body } = getDocument(elements2[0]);
  const cleanups2 = [];
  const markElement2 = (element2) => {
    cleanups2.push(setProperty(element2, getSnapshotPropertyName(id2), true));
  };
  walkTreeOutside(id2, elements2, markElement2);
  return chain(setProperty(body, getSnapshotPropertyName(id2), true), () => {
    for (const cleanup of cleanups2) cleanup();
  });
}
function markTreeOutside(id2, elements2) {
  const cleanups2 = [];
  const ids = elements2.map((el) => el?.id);
  walkTreeOutside(id2, elements2, (element2) => {
    addElementMarkCleanup({
      cleanups: cleanups2,
      element: element2,
      id: id2,
      ids
    });
  }, (ancestor, element2) => {
    addAncestorMarkCleanup({
      cleanups: cleanups2,
      ancestor,
      element: element2,
      id: id2
    });
  });
  const restoreAccessibilityTree = () => {
    restoreCleanups(cleanups2);
  };
  return restoreAccessibilityTree;
}
const TagName$o = "div";
const elements$1 = [
  "a",
  "button",
  "details",
  "dialog",
  "div",
  "form",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "header",
  "img",
  "input",
  "label",
  "li",
  "nav",
  "ol",
  "p",
  "section",
  "select",
  "span",
  "summary",
  "textarea",
  "ul",
  "svg"
];
createHook(function useRole(props2) {
  return props2;
});
const Role = forwardRef(function Role2(props2) {
  return createElement(TagName$o, props2);
});
Object.assign(Role, elements$1.reduce((acc, element2) => {
  acc[element2] = forwardRef(function Role3(props2) {
    return createElement(element2, props2);
  });
  return acc;
}, {}));
function DialogBackdrop({ store: store2, backdrop, backdropRef, alwaysVisible, hidden }) {
  const ref = useRef(null);
  const disclosure = useDisclosureStore({ disclosure: store2 });
  const contentElement = useStoreState(store2, "contentElement");
  useSafeLayoutEffect(() => {
    const backdrop2 = ref.current;
    const dialog = contentElement;
    if (!backdrop2) return;
    if (!dialog) return;
    backdrop2.style.zIndex = getComputedStyle(dialog).zIndex;
  }, [contentElement]);
  useSafeLayoutEffect(() => {
    const id2 = contentElement?.id;
    if (!id2) return;
    const backdrop2 = ref.current;
    if (!backdrop2) return;
    return markAncestor(backdrop2, id2);
  }, [contentElement]);
  const props2 = useDisclosureContent({
    ref: useMergeRefs(ref, backdropRef),
    store: disclosure,
    role: "presentation",
    "data-backdrop": contentElement?.id || "",
    alwaysVisible,
    hidden: hidden != null ? hidden : void 0,
    style: {
      position: "fixed",
      top: 0,
      right: 0,
      bottom: 0,
      left: 0
    }
  });
  if (!backdrop) return null;
  if (isValidElement(backdrop)) return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Role, {
    ...props2,
    render: backdrop
  });
  const Component = typeof backdrop !== "boolean" ? backdrop : "div";
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Role, {
    ...props2,
    render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(Component, {})
  });
}
function createDialogStore(props2 = {}) {
  return createDisclosureStore(props2);
}
function useDialogStoreProps(store2, update, props2) {
  return useDisclosureStoreProps(store2, update, props2);
}
function useDialogStore(props2 = {}) {
  const [store2, update] = useStore(createDialogStore, props2);
  return useDialogStoreProps(store2, update, props2);
}
function supportsInert() {
  return "inert" in HTMLElement.prototype;
}
function hideElementFromAccessibilityTree(element2) {
  return setAttribute(element2, "aria-hidden", "true");
}
function isFocusTrap(element2, ...ids) {
  if (!element2) return false;
  const attr = element2.getAttribute("data-focus-trap");
  if (attr == null) return false;
  if (!ids.length) return true;
  if (attr === "") return false;
  return ids.some((id2) => attr === id2);
}
function disableTree(element2, ignoredElements) {
  if (!("style" in element2)) return noop$1;
  if (supportsInert()) return setProperty(element2, "inert", true);
  return chain(...getAllTabbableIn(element2, true).map((element3) => {
    if (ignoredElements?.some((el) => el && contains(el, element3))) return noop$1;
    const restoreFocusMethod = orchestrate(element3, "focus", () => {
      element3.focus = noop$1;
      return () => {
        delete element3.focus;
      };
    });
    return chain(setAttribute(element3, "tabindex", "-1"), restoreFocusMethod);
  }), hideElementFromAccessibilityTree(element2), assignStyle(element2, {
    pointerEvents: "none",
    userSelect: "none",
    cursor: "default"
  }));
}
function addDisabledElementCleanup({ cleanups: cleanups2, element: element2, elements: elements2, ids }) {
  if (isBackdrop(element2, ...ids)) return;
  if (isFocusTrap(element2, ...ids)) return;
  cleanups2.push(disableTree(element2, elements2));
}
function addRoleNoneCleanup(cleanups2, ancestor, elements2) {
  if (!ancestor.hasAttribute("role")) return;
  if (elements2.some((el) => el && contains(el, ancestor))) return;
  cleanups2.push(setAttribute(ancestor, "role", "none"));
}
function markAndDisableTreeOutside(id2, elements2) {
  const cleanups2 = [];
  const ids = elements2.map((el) => el?.id);
  walkTreeOutside(id2, elements2, (element2) => {
    addElementMarkCleanup({
      cleanups: cleanups2,
      element: element2,
      id: id2,
      ids
    });
    addDisabledElementCleanup({
      cleanups: cleanups2,
      element: element2,
      elements: elements2,
      ids
    });
  }, (ancestor, element2) => {
    addAncestorMarkCleanup({
      cleanups: cleanups2,
      ancestor,
      element: element2,
      id: id2
    });
    addRoleNoneCleanup(cleanups2, ancestor, elements2);
  });
  const restoreTreeOutside = () => {
    restoreCleanups(cleanups2);
  };
  return restoreTreeOutside;
}
function prependHiddenDismiss(container, onClick) {
  const button = getDocument(container).createElement("button");
  button.type = "button";
  button.tabIndex = -1;
  button.textContent = "Dismiss popup";
  Object.assign(button.style, getVisuallyHiddenStyle());
  button.addEventListener("click", onClick);
  container.prepend(button);
  const removeHiddenDismiss = () => {
    button.removeEventListener("click", onClick);
    button.remove();
  };
  return removeHiddenDismiss;
}
function usePreviousMouseDownRef(enabled, scope) {
  const previousMouseDownRef = useRef(null);
  useEffect(() => {
    if (!enabled) {
      previousMouseDownRef.current = null;
      return;
    }
    const onMouseDown = (event) => {
      previousMouseDownRef.current = event.target;
    };
    return addGlobalEventListener("mousedown", onMouseDown, true, scope);
  }, [enabled, scope]);
  return previousMouseDownRef;
}
function isInDocument(target) {
  if (target.tagName === "HTML") return true;
  return contains(getDocument(target).body, target);
}
function isDisclosure(disclosure, target) {
  if (!disclosure) return false;
  if (contains(disclosure, target)) return true;
  const activeId = target.getAttribute("aria-activedescendant");
  if (activeId) {
    const activeElement = getDocument(disclosure).getElementById(activeId);
    if (activeElement) return contains(disclosure, activeElement);
  }
  return false;
}
function isMouseEventOnDialog(event, dialog) {
  if (!("clientY" in event)) return false;
  const rect = dialog.getBoundingClientRect();
  if (rect.width === 0 || rect.height === 0) return false;
  return rect.top <= event.clientY && event.clientY <= rect.top + rect.height && rect.left <= event.clientX && event.clientX <= rect.left + rect.width;
}
function useEventOutside({ store: store2, type, listener, capture, open, contentElement, focusedRef }) {
  const callListener = useEvent(listener);
  useEffect(() => {
    if (!open) return;
    const onEvent = (event) => {
      const { contentElement: contentElement2, disclosureElement } = store2.getState();
      const target = event.target;
      if (!contentElement2) return;
      if (!isElement$2(target)) return;
      if (!isInDocument(target)) return;
      if (contains(contentElement2, target)) return;
      if (isDisclosure(disclosureElement, target)) return;
      if (target.hasAttribute("data-focus-trap")) return;
      if (isMouseEventOnDialog(event, contentElement2)) return;
      if (isElementInside(target, contentElement2.id)) return;
      if (focusedRef.current && !isElementMarked(target, contentElement2.id)) return;
      callListener(event);
    };
    return addGlobalEventListener(type, onEvent, capture, contentElement ? getWindow$1(contentElement) : void 0);
  }, [
    open,
    capture,
    store2,
    type,
    callListener,
    contentElement,
    focusedRef
  ]);
}
function shouldHideOnInteractOutside(hideOnInteractOutside, event) {
  if (typeof hideOnInteractOutside === "function") return hideOnInteractOutside(event);
  return !!hideOnInteractOutside;
}
function useHideOnInteractOutside(store2, hideOnInteractOutside, domReady, interactedOutsideRef) {
  const open = useStoreState(store2, "open");
  const contentElement = useStoreState(store2, "contentElement");
  const previousMouseDownRef = usePreviousMouseDownRef(open, contentElement ? getWindow$1(contentElement) : void 0);
  const focusedRef = useRef(false);
  useSafeLayoutEffect(() => {
    if (!open) return;
    if (!domReady) return;
    if (!contentElement) return;
    focusedRef.current = false;
    const onFocus = () => {
      focusedRef.current = true;
    };
    contentElement.addEventListener("focusin", onFocus, true);
    return () => contentElement.removeEventListener("focusin", onFocus, true);
  }, [
    open,
    domReady,
    contentElement
  ]);
  const props2 = {
    store: store2,
    capture: true,
    open,
    contentElement,
    focusedRef
  };
  useEventOutside({
    ...props2,
    type: "click",
    listener: (event) => {
      const { contentElement: contentElement2 } = store2.getState();
      const previousMouseDown = previousMouseDownRef.current;
      if (!previousMouseDown) return;
      if (!isElementMarked(previousMouseDown, contentElement2?.id)) return;
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      if (interactedOutsideRef) interactedOutsideRef.current = true;
      store2.hide();
    }
  });
  useEventOutside({
    ...props2,
    type: "focusin",
    listener: (event) => {
      const { contentElement: contentElement2 } = store2.getState();
      if (!contentElement2) return;
      if (event.target === getDocument(contentElement2)) return;
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      store2.hide();
    }
  });
  useEventOutside({
    ...props2,
    type: "contextmenu",
    listener: (event) => {
      if (!shouldHideOnInteractOutside(hideOnInteractOutside, event)) return;
      if (interactedOutsideRef) interactedOutsideRef.current = true;
      store2.hide();
    }
  });
}
const NestedDialogsContext = createContext({});
function useNestedDialogs(store2) {
  const context = useContext(NestedDialogsContext);
  const [dialogs, setDialogs] = useState([]);
  const add2 = useCallback((dialog) => {
    setDialogs((dialogs2) => [...dialogs2, dialog]);
    return chain(context.add?.(dialog), () => {
      setDialogs((dialogs2) => dialogs2.filter((d2) => d2 !== dialog));
    });
  }, [context]);
  useSafeLayoutEffect(() => {
    return sync(store2, ["open", "contentElement"], (state) => {
      if (!state.open) return;
      if (!state.contentElement) return;
      return context.add?.(store2);
    });
  }, [store2, context]);
  const providerValue = useMemo(() => ({
    store: store2,
    add: add2
  }), [store2, add2]);
  return {
    wrapElement: useCallback((element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(NestedDialogsContext.Provider, {
      value: providerValue,
      children: element2
    }), [providerValue]),
    nestedDialogs: dialogs
  };
}
function useRootDialog({ attribute, contentId, contentElement, enabled }) {
  const [updated, retry] = useForceUpdate();
  const isRootDialog = useCallback(() => {
    if (!enabled) return false;
    if (!contentElement) return false;
    const { body } = getDocument(contentElement);
    const id2 = body.getAttribute(attribute);
    return !id2 || id2 === contentId;
  }, [
    updated,
    enabled,
    contentElement,
    attribute,
    contentId
  ]);
  useSafeLayoutEffect(() => {
    if (!enabled) return;
    if (!contentId) return;
    if (!contentElement) return;
    const { body } = getDocument(contentElement);
    if (isRootDialog()) {
      body.setAttribute(attribute, contentId);
      return () => body.removeAttribute(attribute);
    }
    const observer = new MutationObserver(() => flushSync(retry));
    observer.observe(body, { attributeFilter: [attribute] });
    return () => observer.disconnect();
  }, [
    updated,
    enabled,
    contentId,
    contentElement,
    isRootDialog,
    attribute
  ]);
  return isRootDialog;
}
const isIOS = isApple() && !isMac();
function getPaddingProperty(documentElement) {
  const documentLeft = documentElement.getBoundingClientRect().left;
  return Math.round(documentLeft) + documentElement.scrollLeft ? "paddingLeft" : "paddingRight";
}
function usePreventBodyScroll(contentElement, contentId, enabled) {
  const isRootDialog = useRootDialog({
    attribute: "data-dialog-prevent-body-scroll",
    contentElement,
    contentId,
    enabled
  });
  (isIOS ? useEffect : useSafeLayoutEffect)(() => {
    if (!isRootDialog()) return;
    if (!contentElement) return;
    const doc2 = getDocument(contentElement);
    const win = getWindow$1(contentElement);
    const { documentElement, body } = doc2;
    const cssScrollbarWidth = documentElement.style.getPropertyValue("--scrollbar-width");
    const scrollbarWidth = cssScrollbarWidth ? Number.parseInt(cssScrollbarWidth, 10) : win.innerWidth - documentElement.clientWidth;
    const setScrollbarWidthProperty = () => setCSSProperty(documentElement, "--scrollbar-width", `${scrollbarWidth}px`);
    const paddingProperty = getPaddingProperty(documentElement);
    const setStyle = () => assignStyle(body, {
      overflow: "hidden",
      [paddingProperty]: `${scrollbarWidth}px`
    });
    const setIOSStyle = () => {
      const { scrollX, scrollY, visualViewport } = win;
      const offsetLeft = visualViewport?.offsetLeft ?? 0;
      const offsetTop = visualViewport?.offsetTop ?? 0;
      const restoreStyle = assignStyle(body, {
        position: "fixed",
        overflow: "hidden",
        top: `${-(scrollY - Math.floor(offsetTop))}px`,
        left: `${-(scrollX - Math.floor(offsetLeft))}px`,
        right: "0",
        [paddingProperty]: `${scrollbarWidth}px`
      });
      return () => {
        restoreStyle();
        if (process.env.NODE_ENV !== "test") win.scrollTo({
          left: scrollX,
          top: scrollY,
          behavior: "instant"
        });
      };
    };
    const restore = chain(setScrollbarWidthProperty(), isIOS ? setIOSStyle() : setStyle());
    if (isIOS) return restore;
    return () => {
      queueMicrotask(restore);
    };
  }, [isRootDialog, contentElement]);
}
const TagName$n = "div";
const isSafariBrowser = isSafari();
function isAlreadyFocusingAnotherElement(dialog) {
  const activeElement = getActiveElement(dialog);
  if (!activeElement) return false;
  if (dialog && contains(dialog, activeElement)) return false;
  if (isFocusable(activeElement)) return true;
  return false;
}
function getElementFromProp(prop, focusable = false) {
  if (!prop) return null;
  const element2 = "current" in prop ? prop.current : prop;
  if (!element2) return null;
  if (focusable) return isFocusable(element2) ? element2 : null;
  return element2;
}
const useDialog = createHook(function useDialog2({ store: storeProp, open: openProp, onClose, focusable = true, modal = true, portal = modal, backdrop = modal, hideOnEscape = true, hideOnInteractOutside = true, getPersistentElements, preventBodyScroll = modal, autoFocusOnShow = true, autoFocusOnHide = true, initialFocus, finalFocus, unmountOnHide, unstable_treeSnapshotKey, ...props2 }) {
  const context = useDialogProviderContext();
  const ref = useRef(null);
  const backdropRef = useRef(null);
  const store2 = useDialogStore({
    store: storeProp || context,
    open: openProp,
    setOpen(open2) {
      if (open2) return;
      const dialog = ref.current;
      if (!dialog) return;
      const event = new Event("close", {
        bubbles: false,
        cancelable: true
      });
      if (onClose) dialog.addEventListener("close", onClose, { once: true });
      dialog.dispatchEvent(event);
      if (!event.defaultPrevented) return;
      store2.setOpen(true);
    }
  });
  const { portalRef, domReady } = usePortalRef(portal, props2.portalRef);
  const preserveTabOrderProp = props2.preserveTabOrder;
  const preserveTabOrder = useStoreState(store2, (state) => preserveTabOrderProp && !modal && state.mounted);
  const id2 = useId(props2.id);
  const open = useStoreState(store2, "open");
  const mounted = useStoreState(store2, "mounted");
  const contentElement = useStoreState(store2, "contentElement");
  const hidden = isHidden(mounted, props2.hidden, props2.alwaysVisible);
  usePreventBodyScroll(contentElement, id2, preventBodyScroll && !hidden);
  const interactedOutsideRef = useRef(false);
  useSafeLayoutEffect(() => {
    return sync(store2, ["open"], (state) => {
      if (!state.open) return;
      interactedOutsideRef.current = false;
    });
  }, [store2]);
  useHideOnInteractOutside(store2, hideOnInteractOutside, domReady, interactedOutsideRef);
  const { wrapElement, nestedDialogs } = useNestedDialogs(store2);
  props2 = useWrapElement(props2, wrapElement, [wrapElement]);
  const lastMousedownRef = useRef(null);
  if (isSafariBrowser) useEffect(() => {
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    const doc2 = getDocument(dialog);
    const onMousedown = (event) => {
      lastMousedownRef.current = event.target;
    };
    doc2.addEventListener("mousedown", onMousedown, true);
    return () => {
      doc2.removeEventListener("mousedown", onMousedown, true);
    };
  }, [domReady]);
  useSafeLayoutEffect(() => {
    if (!open) return;
    const dialog = ref.current;
    const activeElement = getActiveElement(dialog, true);
    if (!activeElement) return;
    if (activeElement.tagName === "BODY") {
      const fallback = lastMousedownRef.current;
      lastMousedownRef.current = null;
      if (!fallback?.isConnected) return;
      if (!isFocusable(fallback)) return;
      if (dialog && contains(dialog, fallback)) return;
      store2.setDisclosureElement(fallback);
      return;
    }
    if (dialog && contains(dialog, activeElement)) return;
    store2.setDisclosureElement(activeElement);
  }, [store2, open]);
  useEffect(() => {
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    const win = getWindow$1(dialog);
    const viewport = win.visualViewport || win;
    const setViewportHeight = () => {
      const height = win.visualViewport?.height ?? win.innerHeight;
      dialog.style.setProperty("--dialog-viewport-height", `${height}px`);
    };
    setViewportHeight();
    viewport.addEventListener("resize", setViewportHeight);
    return () => {
      viewport.removeEventListener("resize", setViewportHeight);
    };
  }, [mounted, domReady]);
  useEffect(() => {
    if (!modal) return;
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    if (dialog.querySelector("[data-dialog-dismiss]")) return;
    return prependHiddenDismiss(dialog, store2.hide);
  }, [
    store2,
    modal,
    mounted,
    domReady
  ]);
  useSafeLayoutEffect(() => {
    if (!supportsInert()) return;
    if (open) return;
    if (!mounted) return;
    if (!domReady) return;
    const dialog = ref.current;
    if (!dialog) return;
    return disableTree(dialog);
  }, [
    open,
    mounted,
    domReady
  ]);
  const canTakeTreeSnapshot = open && domReady;
  useSafeLayoutEffect(() => {
    if (!id2) return;
    if (!canTakeTreeSnapshot) return;
    const dialog = ref.current;
    return createWalkTreeSnapshot(id2, [dialog]);
  }, [
    id2,
    canTakeTreeSnapshot,
    unstable_treeSnapshotKey
  ]);
  const getPersistentElementsProp = useEvent(getPersistentElements);
  useSafeLayoutEffect(() => {
    if (!id2) return;
    if (!canTakeTreeSnapshot) return;
    const { disclosureElement } = store2.getState();
    const allElements = [
      ref.current,
      ...getPersistentElementsProp() || [],
      ...nestedDialogs.map((dialog) => dialog.getState().contentElement)
    ];
    const restoreInsideMarks = markTreeInside(id2, allElements);
    if (modal) return chain(restoreInsideMarks, markAndDisableTreeOutside(id2, allElements));
    return chain(restoreInsideMarks, markTreeOutside(id2, [disclosureElement, ...allElements]));
  }, [
    id2,
    store2,
    canTakeTreeSnapshot,
    getPersistentElementsProp,
    nestedDialogs,
    modal,
    unstable_treeSnapshotKey
  ]);
  const mayAutoFocusOnShow = !!autoFocusOnShow;
  const autoFocusOnShowProp = useBooleanEvent(autoFocusOnShow);
  const [autoFocusEnabled, setAutoFocusEnabled] = useState(false);
  useEffect(() => {
    if (!open) return;
    if (!mayAutoFocusOnShow) return;
    if (!domReady) return;
    if (!contentElement?.isConnected) return;
    const element2 = getElementFromProp(initialFocus, true) || contentElement.querySelector("[data-autofocus=true],[autofocus]") || getFirstTabbableIn(contentElement, true, portal && preserveTabOrder) || contentElement;
    const isElementFocusable = isFocusable(element2);
    if (!autoFocusOnShowProp(isElementFocusable ? element2 : null)) return;
    setAutoFocusEnabled(true);
    queueMicrotask(() => {
      if (!store2.getState().open) return;
      element2.focus();
      if (!isSafariBrowser) return;
      if (!isElementFocusable) return;
      element2.scrollIntoView({
        block: "nearest",
        inline: "nearest"
      });
    });
  }, [
    open,
    mayAutoFocusOnShow,
    domReady,
    contentElement,
    initialFocus,
    portal,
    preserveTabOrder,
    store2,
    autoFocusOnShowProp
  ]);
  const mayAutoFocusOnHide = !!autoFocusOnHide;
  const autoFocusOnHideProp = useBooleanEvent(autoFocusOnHide);
  const [hasOpened, setHasOpened] = useState(false);
  useSafeLayoutEffect(() => {
    if (!open) return;
    setHasOpened(true);
    return () => setHasOpened(false);
  }, [open]);
  const focusOnHide = useCallback((dialog, retry = true) => {
    if (interactedOutsideRef.current) return;
    const { disclosureElement } = store2.getState();
    if (isAlreadyFocusingAnotherElement(dialog)) return;
    let element2 = getElementFromProp(finalFocus) || disclosureElement;
    if (element2?.id) {
      const doc2 = getDocument(element2);
      const selector2 = `[aria-activedescendant="${element2.id}"]`;
      const composite = doc2.querySelector(selector2);
      if (composite) element2 = composite;
    }
    if (element2 && !isFocusable(element2)) {
      const maybeParentDialog = element2.closest("[data-dialog]");
      if (maybeParentDialog?.id) {
        const doc2 = getDocument(maybeParentDialog);
        const selector2 = `[aria-controls~="${maybeParentDialog.id}"]`;
        const control = doc2.querySelector(selector2);
        if (control) element2 = control;
      }
    }
    const isElementFocusable = element2 && isFocusable(element2);
    if (!isElementFocusable && retry) {
      requestAnimationFrame(() => focusOnHide(dialog, false));
      return;
    }
    if (!autoFocusOnHideProp(isElementFocusable ? element2 : null)) return;
    if (!isElementFocusable) return;
    element2?.focus();
  }, [
    store2,
    finalFocus,
    autoFocusOnHideProp
  ]);
  const focusedOnHideRef = useRef(false);
  useSafeLayoutEffect(() => {
    if (open) return;
    if (!hasOpened) return;
    if (!mayAutoFocusOnHide) return;
    const dialog = ref.current;
    focusedOnHideRef.current = true;
    focusOnHide(dialog);
  }, [
    open,
    hasOpened,
    domReady,
    mayAutoFocusOnHide,
    focusOnHide
  ]);
  useEffect(() => {
    if (!hasOpened) return;
    if (!mayAutoFocusOnHide) return;
    const dialog = ref.current;
    return () => {
      if (focusedOnHideRef.current) {
        focusedOnHideRef.current = false;
        return;
      }
      focusOnHide(dialog);
    };
  }, [
    hasOpened,
    mayAutoFocusOnHide,
    focusOnHide
  ]);
  const hideOnEscapeProp = useBooleanEvent(hideOnEscape);
  useEffect(() => {
    if (!domReady) return;
    if (!mounted) return;
    const onKeyDown = (event) => {
      if (event.key !== "Escape") return;
      if (event.defaultPrevented) return;
      const dialog = ref.current;
      if (!dialog) return;
      if (isElementMarked(dialog)) return;
      const target = event.target;
      if (!isNode$1(target)) return;
      const { disclosureElement } = store2.getState();
      const isValidTarget = () => {
        if (isElement$2(target) && target.tagName === "BODY") return true;
        if (contains(dialog, target)) return true;
        if (!disclosureElement) return true;
        if (contains(disclosureElement, target)) return true;
        if (isElement$2(target) && isElementMarked(target, dialog.id)) return true;
        return false;
      };
      if (!isValidTarget()) return;
      if (!hideOnEscapeProp(event)) return;
      store2.hide();
    };
    return addGlobalEventListener("keydown", onKeyDown, true, contentElement ? getWindow$1(contentElement) : void 0);
  }, [
    store2,
    domReady,
    mounted,
    contentElement,
    hideOnEscapeProp
  ]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(HeadingLevel, {
    level: modal ? 1 : void 0,
    children: element2
  }), [modal]);
  const hiddenProp = props2.hidden;
  const alwaysVisible = props2.alwaysVisible;
  props2 = useWrapElement(props2, (element2) => {
    if (!backdrop) return element2;
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [/* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogBackdrop, {
      store: store2,
      backdrop,
      backdropRef,
      hidden: hiddenProp,
      alwaysVisible
    }), element2] });
  }, [
    store2,
    backdrop,
    hiddenProp,
    alwaysVisible
  ]);
  const [headingId, setHeadingId] = useState();
  const [descriptionId, setDescriptionId] = useState();
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogScopedContextProvider, {
    value: store2,
    children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogHeadingContext.Provider, {
      value: setHeadingId,
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogDescriptionContext.Provider, {
        value: setDescriptionId,
        children: element2
      })
    })
  }), [store2]);
  props2 = {
    "data-dialog": "",
    role: "dialog",
    tabIndex: focusable ? -1 : void 0,
    "aria-labelledby": props2["aria-label"] != null ? void 0 : headingId,
    "aria-describedby": descriptionId,
    ...props2,
    id: id2,
    ref: useMergeRefs(ref, props2.ref)
  };
  props2 = useFocusableContainer({
    ...props2,
    autoFocusOnShow: autoFocusEnabled
  });
  props2 = useDisclosureContent({
    store: store2,
    ...props2,
    unstable_otherElementRef: backdropRef
  });
  props2 = useFocusable({
    ...props2,
    focusable
  });
  props2 = usePortal({
    portal,
    ...props2,
    portalRef,
    preserveTabOrder
  });
  return props2;
});
function createDialogComponent(Component, useProviderContext = useDialogProviderContext) {
  return forwardRef(function DialogComponent(props2) {
    const context = useProviderContext();
    if (!useStoreState(props2.store || context, (state) => !props2.unmountOnHide || state?.mounted || !!props2.open)) return null;
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Component, { ...props2 });
  });
}
const DialogWithStore = createDialogComponent(forwardRef(function DialogImpl(props2) {
  return createElement(TagName$n, useDialog(props2));
}), useDialogProviderContext);
const DialogWithInternalStore = forwardRef(function DialogWithInternalStore2(props2) {
  const store2 = useDialogStore({ open: props2.open });
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogWithStore, {
    ...props2,
    store: store2
  });
});
forwardRef(function Dialog(props2) {
  const context = useDialogProviderContext();
  if (props2.store || context || !props2.unmountOnHide) return /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogWithStore, { ...props2 });
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(DialogWithInternalStore, { ...props2 });
});
function getBasePlacement(placement) {
  return placement.split("-")[0];
}
const min = Math.min;
const max = Math.max;
const round = Math.round;
const floor = Math.floor;
const createCoords = (v2) => ({
  x: v2,
  y: v2
});
const oppositeSideMap = {
  left: "right",
  right: "left",
  bottom: "top",
  top: "bottom"
};
const oppositeAlignmentMap = {
  start: "end",
  end: "start"
};
function clamp(start, value, end) {
  return max(start, min(value, end));
}
function evaluate(value, param) {
  return typeof value === "function" ? value(param) : value;
}
function getSide(placement) {
  return placement.split("-")[0];
}
function getAlignment(placement) {
  return placement.split("-")[1];
}
function getOppositeAxis(axis) {
  return axis === "x" ? "y" : "x";
}
function getAxisLength(axis) {
  return axis === "y" ? "height" : "width";
}
const yAxisSides = /* @__PURE__ */ new Set(["top", "bottom"]);
function getSideAxis(placement) {
  return yAxisSides.has(getSide(placement)) ? "y" : "x";
}
function getAlignmentAxis(placement) {
  return getOppositeAxis(getSideAxis(placement));
}
function getAlignmentSides(placement, rects, rtl) {
  if (rtl === void 0) {
    rtl = false;
  }
  const alignment = getAlignment(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const length = getAxisLength(alignmentAxis);
  let mainAlignmentSide = alignmentAxis === "x" ? alignment === (rtl ? "end" : "start") ? "right" : "left" : alignment === "start" ? "bottom" : "top";
  if (rects.reference[length] > rects.floating[length]) {
    mainAlignmentSide = getOppositePlacement(mainAlignmentSide);
  }
  return [mainAlignmentSide, getOppositePlacement(mainAlignmentSide)];
}
function getExpandedPlacements(placement) {
  const oppositePlacement = getOppositePlacement(placement);
  return [getOppositeAlignmentPlacement(placement), oppositePlacement, getOppositeAlignmentPlacement(oppositePlacement)];
}
function getOppositeAlignmentPlacement(placement) {
  return placement.replace(/start|end/g, (alignment) => oppositeAlignmentMap[alignment]);
}
const lrPlacement = ["left", "right"];
const rlPlacement = ["right", "left"];
const tbPlacement = ["top", "bottom"];
const btPlacement = ["bottom", "top"];
function getSideList(side, isStart, rtl) {
  switch (side) {
    case "top":
    case "bottom":
      if (rtl) return isStart ? rlPlacement : lrPlacement;
      return isStart ? lrPlacement : rlPlacement;
    case "left":
    case "right":
      return isStart ? tbPlacement : btPlacement;
    default:
      return [];
  }
}
function getOppositeAxisPlacements(placement, flipAlignment, direction, rtl) {
  const alignment = getAlignment(placement);
  let list2 = getSideList(getSide(placement), direction === "start", rtl);
  if (alignment) {
    list2 = list2.map((side) => side + "-" + alignment);
    if (flipAlignment) {
      list2 = list2.concat(list2.map(getOppositeAlignmentPlacement));
    }
  }
  return list2;
}
function getOppositePlacement(placement) {
  return placement.replace(/left|right|bottom|top/g, (side) => oppositeSideMap[side]);
}
function expandPaddingObject(padding) {
  return {
    top: 0,
    right: 0,
    bottom: 0,
    left: 0,
    ...padding
  };
}
function getPaddingObject(padding) {
  return typeof padding !== "number" ? expandPaddingObject(padding) : {
    top: padding,
    right: padding,
    bottom: padding,
    left: padding
  };
}
function rectToClientRect(rect) {
  const {
    x: x2,
    y: y2,
    width,
    height
  } = rect;
  return {
    width,
    height,
    top: y2,
    left: x2,
    right: x2 + width,
    bottom: y2 + height,
    x: x2,
    y: y2
  };
}
function computeCoordsFromPlacement(_ref, placement, rtl) {
  let {
    reference,
    floating
  } = _ref;
  const sideAxis = getSideAxis(placement);
  const alignmentAxis = getAlignmentAxis(placement);
  const alignLength = getAxisLength(alignmentAxis);
  const side = getSide(placement);
  const isVertical = sideAxis === "y";
  const commonX = reference.x + reference.width / 2 - floating.width / 2;
  const commonY = reference.y + reference.height / 2 - floating.height / 2;
  const commonAlign = reference[alignLength] / 2 - floating[alignLength] / 2;
  let coords;
  switch (side) {
    case "top":
      coords = {
        x: commonX,
        y: reference.y - floating.height
      };
      break;
    case "bottom":
      coords = {
        x: commonX,
        y: reference.y + reference.height
      };
      break;
    case "right":
      coords = {
        x: reference.x + reference.width,
        y: commonY
      };
      break;
    case "left":
      coords = {
        x: reference.x - floating.width,
        y: commonY
      };
      break;
    default:
      coords = {
        x: reference.x,
        y: reference.y
      };
  }
  switch (getAlignment(placement)) {
    case "start":
      coords[alignmentAxis] -= commonAlign * (rtl && isVertical ? -1 : 1);
      break;
    case "end":
      coords[alignmentAxis] += commonAlign * (rtl && isVertical ? -1 : 1);
      break;
  }
  return coords;
}
const computePosition$1 = async (reference, floating, config2) => {
  const {
    placement = "bottom",
    strategy = "absolute",
    middleware = [],
    platform: platform2
  } = config2;
  const validMiddleware = middleware.filter(Boolean);
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(floating));
  let rects = await platform2.getElementRects({
    reference,
    floating,
    strategy
  });
  let {
    x: x2,
    y: y2
  } = computeCoordsFromPlacement(rects, placement, rtl);
  let statefulPlacement = placement;
  let middlewareData = {};
  let resetCount = 0;
  for (let i2 = 0; i2 < validMiddleware.length; i2++) {
    const {
      name: name2,
      fn: fn2
    } = validMiddleware[i2];
    const {
      x: nextX,
      y: nextY,
      data,
      reset
    } = await fn2({
      x: x2,
      y: y2,
      initialPlacement: placement,
      placement: statefulPlacement,
      strategy,
      middlewareData,
      rects,
      platform: platform2,
      elements: {
        reference,
        floating
      }
    });
    x2 = nextX != null ? nextX : x2;
    y2 = nextY != null ? nextY : y2;
    middlewareData = {
      ...middlewareData,
      [name2]: {
        ...middlewareData[name2],
        ...data
      }
    };
    if (reset && resetCount <= 50) {
      resetCount++;
      if (typeof reset === "object") {
        if (reset.placement) {
          statefulPlacement = reset.placement;
        }
        if (reset.rects) {
          rects = reset.rects === true ? await platform2.getElementRects({
            reference,
            floating,
            strategy
          }) : reset.rects;
        }
        ({
          x: x2,
          y: y2
        } = computeCoordsFromPlacement(rects, statefulPlacement, rtl));
      }
      i2 = -1;
    }
  }
  return {
    x: x2,
    y: y2,
    placement: statefulPlacement,
    strategy,
    middlewareData
  };
};
async function detectOverflow(state, options2) {
  var _await$platform$isEle;
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    x: x2,
    y: y2,
    platform: platform2,
    rects,
    elements: elements2,
    strategy
  } = state;
  const {
    boundary = "clippingAncestors",
    rootBoundary = "viewport",
    elementContext: elementContext2 = "floating",
    altBoundary = false,
    padding = 0
  } = evaluate(options2, state);
  const paddingObject = getPaddingObject(padding);
  const altContext = elementContext2 === "floating" ? "reference" : "floating";
  const element2 = elements2[altBoundary ? altContext : elementContext2];
  const clippingClientRect = rectToClientRect(await platform2.getClippingRect({
    element: ((_await$platform$isEle = await (platform2.isElement == null ? void 0 : platform2.isElement(element2))) != null ? _await$platform$isEle : true) ? element2 : element2.contextElement || await (platform2.getDocumentElement == null ? void 0 : platform2.getDocumentElement(elements2.floating)),
    boundary,
    rootBoundary,
    strategy
  }));
  const rect = elementContext2 === "floating" ? {
    x: x2,
    y: y2,
    width: rects.floating.width,
    height: rects.floating.height
  } : rects.reference;
  const offsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(elements2.floating));
  const offsetScale = await (platform2.isElement == null ? void 0 : platform2.isElement(offsetParent)) ? await (platform2.getScale == null ? void 0 : platform2.getScale(offsetParent)) || {
    x: 1,
    y: 1
  } : {
    x: 1,
    y: 1
  };
  const elementClientRect = rectToClientRect(platform2.convertOffsetParentRelativeRectToViewportRelativeRect ? await platform2.convertOffsetParentRelativeRectToViewportRelativeRect({
    elements: elements2,
    rect,
    offsetParent,
    strategy
  }) : rect);
  return {
    top: (clippingClientRect.top - elementClientRect.top + paddingObject.top) / offsetScale.y,
    bottom: (elementClientRect.bottom - clippingClientRect.bottom + paddingObject.bottom) / offsetScale.y,
    left: (clippingClientRect.left - elementClientRect.left + paddingObject.left) / offsetScale.x,
    right: (elementClientRect.right - clippingClientRect.right + paddingObject.right) / offsetScale.x
  };
}
const arrow$1 = (options2) => ({
  name: "arrow",
  options: options2,
  async fn(state) {
    const {
      x: x2,
      y: y2,
      placement,
      rects,
      platform: platform2,
      elements: elements2,
      middlewareData
    } = state;
    const {
      element: element2,
      padding = 0
    } = evaluate(options2, state) || {};
    if (element2 == null) {
      return {};
    }
    const paddingObject = getPaddingObject(padding);
    const coords = {
      x: x2,
      y: y2
    };
    const axis = getAlignmentAxis(placement);
    const length = getAxisLength(axis);
    const arrowDimensions = await platform2.getDimensions(element2);
    const isYAxis = axis === "y";
    const minProp = isYAxis ? "top" : "left";
    const maxProp = isYAxis ? "bottom" : "right";
    const clientProp = isYAxis ? "clientHeight" : "clientWidth";
    const endDiff = rects.reference[length] + rects.reference[axis] - coords[axis] - rects.floating[length];
    const startDiff = coords[axis] - rects.reference[axis];
    const arrowOffsetParent = await (platform2.getOffsetParent == null ? void 0 : platform2.getOffsetParent(element2));
    let clientSize = arrowOffsetParent ? arrowOffsetParent[clientProp] : 0;
    if (!clientSize || !await (platform2.isElement == null ? void 0 : platform2.isElement(arrowOffsetParent))) {
      clientSize = elements2.floating[clientProp] || rects.floating[length];
    }
    const centerToReference = endDiff / 2 - startDiff / 2;
    const largestPossiblePadding = clientSize / 2 - arrowDimensions[length] / 2 - 1;
    const minPadding = min(paddingObject[minProp], largestPossiblePadding);
    const maxPadding = min(paddingObject[maxProp], largestPossiblePadding);
    const min$12 = minPadding;
    const max2 = clientSize - arrowDimensions[length] - maxPadding;
    const center = clientSize / 2 - arrowDimensions[length] / 2 + centerToReference;
    const offset2 = clamp(min$12, center, max2);
    const shouldAddOffset = !middlewareData.arrow && getAlignment(placement) != null && center !== offset2 && rects.reference[length] / 2 - (center < min$12 ? minPadding : maxPadding) - arrowDimensions[length] / 2 < 0;
    const alignmentOffset = shouldAddOffset ? center < min$12 ? center - min$12 : center - max2 : 0;
    return {
      [axis]: coords[axis] + alignmentOffset,
      data: {
        [axis]: offset2,
        centerOffset: center - offset2 - alignmentOffset,
        ...shouldAddOffset && {
          alignmentOffset
        }
      },
      reset: shouldAddOffset
    };
  }
});
const flip$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "flip",
    options: options2,
    async fn(state) {
      var _middlewareData$arrow, _middlewareData$flip;
      const {
        placement,
        middlewareData,
        rects,
        initialPlacement,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true,
        fallbackPlacements: specifiedFallbackPlacements,
        fallbackStrategy = "bestFit",
        fallbackAxisSideDirection = "none",
        flipAlignment = true,
        ...detectOverflowOptions
      } = evaluate(options2, state);
      if ((_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      const side = getSide(placement);
      const initialSideAxis = getSideAxis(initialPlacement);
      const isBasePlacement = getSide(initialPlacement) === initialPlacement;
      const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
      const fallbackPlacements = specifiedFallbackPlacements || (isBasePlacement || !flipAlignment ? [getOppositePlacement(initialPlacement)] : getExpandedPlacements(initialPlacement));
      const hasFallbackAxisSideDirection = fallbackAxisSideDirection !== "none";
      if (!specifiedFallbackPlacements && hasFallbackAxisSideDirection) {
        fallbackPlacements.push(...getOppositeAxisPlacements(initialPlacement, flipAlignment, fallbackAxisSideDirection, rtl));
      }
      const placements = [initialPlacement, ...fallbackPlacements];
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const overflows = [];
      let overflowsData = ((_middlewareData$flip = middlewareData.flip) == null ? void 0 : _middlewareData$flip.overflows) || [];
      if (checkMainAxis) {
        overflows.push(overflow[side]);
      }
      if (checkCrossAxis) {
        const sides = getAlignmentSides(placement, rects, rtl);
        overflows.push(overflow[sides[0]], overflow[sides[1]]);
      }
      overflowsData = [...overflowsData, {
        placement,
        overflows
      }];
      if (!overflows.every((side2) => side2 <= 0)) {
        var _middlewareData$flip2, _overflowsData$filter;
        const nextIndex = (((_middlewareData$flip2 = middlewareData.flip) == null ? void 0 : _middlewareData$flip2.index) || 0) + 1;
        const nextPlacement = placements[nextIndex];
        if (nextPlacement) {
          const ignoreCrossAxisOverflow = checkCrossAxis === "alignment" ? initialSideAxis !== getSideAxis(nextPlacement) : false;
          if (!ignoreCrossAxisOverflow || // We leave the current main axis only if every placement on that axis
          // overflows the main axis.
          overflowsData.every((d2) => getSideAxis(d2.placement) === initialSideAxis ? d2.overflows[0] > 0 : true)) {
            return {
              data: {
                index: nextIndex,
                overflows: overflowsData
              },
              reset: {
                placement: nextPlacement
              }
            };
          }
        }
        let resetPlacement = (_overflowsData$filter = overflowsData.filter((d2) => d2.overflows[0] <= 0).sort((a2, b2) => a2.overflows[1] - b2.overflows[1])[0]) == null ? void 0 : _overflowsData$filter.placement;
        if (!resetPlacement) {
          switch (fallbackStrategy) {
            case "bestFit": {
              var _overflowsData$filter2;
              const placement2 = (_overflowsData$filter2 = overflowsData.filter((d2) => {
                if (hasFallbackAxisSideDirection) {
                  const currentSideAxis = getSideAxis(d2.placement);
                  return currentSideAxis === initialSideAxis || // Create a bias to the `y` side axis due to horizontal
                  // reading directions favoring greater width.
                  currentSideAxis === "y";
                }
                return true;
              }).map((d2) => [d2.placement, d2.overflows.filter((overflow2) => overflow2 > 0).reduce((acc, overflow2) => acc + overflow2, 0)]).sort((a2, b2) => a2[1] - b2[1])[0]) == null ? void 0 : _overflowsData$filter2[0];
              if (placement2) {
                resetPlacement = placement2;
              }
              break;
            }
            case "initialPlacement":
              resetPlacement = initialPlacement;
              break;
          }
        }
        if (placement !== resetPlacement) {
          return {
            reset: {
              placement: resetPlacement
            }
          };
        }
      }
      return {};
    }
  };
};
const originSides = /* @__PURE__ */ new Set(["left", "top"]);
async function convertValueToCoords(state, options2) {
  const {
    placement,
    platform: platform2,
    elements: elements2
  } = state;
  const rtl = await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating));
  const side = getSide(placement);
  const alignment = getAlignment(placement);
  const isVertical = getSideAxis(placement) === "y";
  const mainAxisMulti = originSides.has(side) ? -1 : 1;
  const crossAxisMulti = rtl && isVertical ? -1 : 1;
  const rawValue = evaluate(options2, state);
  let {
    mainAxis,
    crossAxis,
    alignmentAxis
  } = typeof rawValue === "number" ? {
    mainAxis: rawValue,
    crossAxis: 0,
    alignmentAxis: null
  } : {
    mainAxis: rawValue.mainAxis || 0,
    crossAxis: rawValue.crossAxis || 0,
    alignmentAxis: rawValue.alignmentAxis
  };
  if (alignment && typeof alignmentAxis === "number") {
    crossAxis = alignment === "end" ? alignmentAxis * -1 : alignmentAxis;
  }
  return isVertical ? {
    x: crossAxis * crossAxisMulti,
    y: mainAxis * mainAxisMulti
  } : {
    x: mainAxis * mainAxisMulti,
    y: crossAxis * crossAxisMulti
  };
}
const offset$1 = function(options2) {
  if (options2 === void 0) {
    options2 = 0;
  }
  return {
    name: "offset",
    options: options2,
    async fn(state) {
      var _middlewareData$offse, _middlewareData$arrow;
      const {
        x: x2,
        y: y2,
        placement,
        middlewareData
      } = state;
      const diffCoords = await convertValueToCoords(state, options2);
      if (placement === ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse.placement) && (_middlewareData$arrow = middlewareData.arrow) != null && _middlewareData$arrow.alignmentOffset) {
        return {};
      }
      return {
        x: x2 + diffCoords.x,
        y: y2 + diffCoords.y,
        data: {
          ...diffCoords,
          placement
        }
      };
    }
  };
};
const shift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "shift",
    options: options2,
    async fn(state) {
      const {
        x: x2,
        y: y2,
        placement
      } = state;
      const {
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = false,
        limiter = {
          fn: (_ref) => {
            let {
              x: x3,
              y: y3
            } = _ref;
            return {
              x: x3,
              y: y3
            };
          }
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y: y2
      };
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const crossAxis = getSideAxis(getSide(placement));
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      if (checkMainAxis) {
        const minSide = mainAxis === "y" ? "top" : "left";
        const maxSide = mainAxis === "y" ? "bottom" : "right";
        const min2 = mainAxisCoord + overflow[minSide];
        const max2 = mainAxisCoord - overflow[maxSide];
        mainAxisCoord = clamp(min2, mainAxisCoord, max2);
      }
      if (checkCrossAxis) {
        const minSide = crossAxis === "y" ? "top" : "left";
        const maxSide = crossAxis === "y" ? "bottom" : "right";
        const min2 = crossAxisCoord + overflow[minSide];
        const max2 = crossAxisCoord - overflow[maxSide];
        crossAxisCoord = clamp(min2, crossAxisCoord, max2);
      }
      const limitedCoords = limiter.fn({
        ...state,
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      });
      return {
        ...limitedCoords,
        data: {
          x: limitedCoords.x - x2,
          y: limitedCoords.y - y2,
          enabled: {
            [mainAxis]: checkMainAxis,
            [crossAxis]: checkCrossAxis
          }
        }
      };
    }
  };
};
const limitShift$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    options: options2,
    fn(state) {
      const {
        x: x2,
        y: y2,
        placement,
        rects,
        middlewareData
      } = state;
      const {
        offset: offset2 = 0,
        mainAxis: checkMainAxis = true,
        crossAxis: checkCrossAxis = true
      } = evaluate(options2, state);
      const coords = {
        x: x2,
        y: y2
      };
      const crossAxis = getSideAxis(placement);
      const mainAxis = getOppositeAxis(crossAxis);
      let mainAxisCoord = coords[mainAxis];
      let crossAxisCoord = coords[crossAxis];
      const rawOffset = evaluate(offset2, state);
      const computedOffset = typeof rawOffset === "number" ? {
        mainAxis: rawOffset,
        crossAxis: 0
      } : {
        mainAxis: 0,
        crossAxis: 0,
        ...rawOffset
      };
      if (checkMainAxis) {
        const len = mainAxis === "y" ? "height" : "width";
        const limitMin = rects.reference[mainAxis] - rects.floating[len] + computedOffset.mainAxis;
        const limitMax = rects.reference[mainAxis] + rects.reference[len] - computedOffset.mainAxis;
        if (mainAxisCoord < limitMin) {
          mainAxisCoord = limitMin;
        } else if (mainAxisCoord > limitMax) {
          mainAxisCoord = limitMax;
        }
      }
      if (checkCrossAxis) {
        var _middlewareData$offse, _middlewareData$offse2;
        const len = mainAxis === "y" ? "width" : "height";
        const isOriginSide = originSides.has(getSide(placement));
        const limitMin = rects.reference[crossAxis] - rects.floating[len] + (isOriginSide ? ((_middlewareData$offse = middlewareData.offset) == null ? void 0 : _middlewareData$offse[crossAxis]) || 0 : 0) + (isOriginSide ? 0 : computedOffset.crossAxis);
        const limitMax = rects.reference[crossAxis] + rects.reference[len] + (isOriginSide ? 0 : ((_middlewareData$offse2 = middlewareData.offset) == null ? void 0 : _middlewareData$offse2[crossAxis]) || 0) - (isOriginSide ? computedOffset.crossAxis : 0);
        if (crossAxisCoord < limitMin) {
          crossAxisCoord = limitMin;
        } else if (crossAxisCoord > limitMax) {
          crossAxisCoord = limitMax;
        }
      }
      return {
        [mainAxis]: mainAxisCoord,
        [crossAxis]: crossAxisCoord
      };
    }
  };
};
const size$1 = function(options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  return {
    name: "size",
    options: options2,
    async fn(state) {
      var _state$middlewareData, _state$middlewareData2;
      const {
        placement,
        rects,
        platform: platform2,
        elements: elements2
      } = state;
      const {
        apply = () => {
        },
        ...detectOverflowOptions
      } = evaluate(options2, state);
      const overflow = await detectOverflow(state, detectOverflowOptions);
      const side = getSide(placement);
      const alignment = getAlignment(placement);
      const isYAxis = getSideAxis(placement) === "y";
      const {
        width,
        height
      } = rects.floating;
      let heightSide;
      let widthSide;
      if (side === "top" || side === "bottom") {
        heightSide = side;
        widthSide = alignment === (await (platform2.isRTL == null ? void 0 : platform2.isRTL(elements2.floating)) ? "start" : "end") ? "left" : "right";
      } else {
        widthSide = side;
        heightSide = alignment === "end" ? "top" : "bottom";
      }
      const maximumClippingHeight = height - overflow.top - overflow.bottom;
      const maximumClippingWidth = width - overflow.left - overflow.right;
      const overflowAvailableHeight = min(height - overflow[heightSide], maximumClippingHeight);
      const overflowAvailableWidth = min(width - overflow[widthSide], maximumClippingWidth);
      const noShift = !state.middlewareData.shift;
      let availableHeight = overflowAvailableHeight;
      let availableWidth = overflowAvailableWidth;
      if ((_state$middlewareData = state.middlewareData.shift) != null && _state$middlewareData.enabled.x) {
        availableWidth = maximumClippingWidth;
      }
      if ((_state$middlewareData2 = state.middlewareData.shift) != null && _state$middlewareData2.enabled.y) {
        availableHeight = maximumClippingHeight;
      }
      if (noShift && !alignment) {
        const xMin = max(overflow.left, 0);
        const xMax = max(overflow.right, 0);
        const yMin = max(overflow.top, 0);
        const yMax = max(overflow.bottom, 0);
        if (isYAxis) {
          availableWidth = width - 2 * (xMin !== 0 || xMax !== 0 ? xMin + xMax : max(overflow.left, overflow.right));
        } else {
          availableHeight = height - 2 * (yMin !== 0 || yMax !== 0 ? yMin + yMax : max(overflow.top, overflow.bottom));
        }
      }
      await apply({
        ...state,
        availableWidth,
        availableHeight
      });
      const nextDimensions = await platform2.getDimensions(elements2.floating);
      if (width !== nextDimensions.width || height !== nextDimensions.height) {
        return {
          reset: {
            rects: true
          }
        };
      }
      return {};
    }
  };
};
function hasWindow() {
  return typeof window !== "undefined";
}
function getNodeName(node) {
  if (isNode(node)) {
    return (node.nodeName || "").toLowerCase();
  }
  return "#document";
}
function getWindow(node) {
  var _node$ownerDocument;
  return (node == null || (_node$ownerDocument = node.ownerDocument) == null ? void 0 : _node$ownerDocument.defaultView) || window;
}
function getDocumentElement(node) {
  var _ref;
  return (_ref = (isNode(node) ? node.ownerDocument : node.document) || window.document) == null ? void 0 : _ref.documentElement;
}
function isNode(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Node || value instanceof getWindow(value).Node;
}
function isElement$1(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof Element || value instanceof getWindow(value).Element;
}
function isHTMLElement(value) {
  if (!hasWindow()) {
    return false;
  }
  return value instanceof HTMLElement || value instanceof getWindow(value).HTMLElement;
}
function isShadowRoot(value) {
  if (!hasWindow() || typeof ShadowRoot === "undefined") {
    return false;
  }
  return value instanceof ShadowRoot || value instanceof getWindow(value).ShadowRoot;
}
const invalidOverflowDisplayValues = /* @__PURE__ */ new Set(["inline", "contents"]);
function isOverflowElement(element2) {
  const {
    overflow,
    overflowX,
    overflowY,
    display
  } = getComputedStyle$1(element2);
  return /auto|scroll|overlay|hidden|clip/.test(overflow + overflowY + overflowX) && !invalidOverflowDisplayValues.has(display);
}
const tableElements = /* @__PURE__ */ new Set(["table", "td", "th"]);
function isTableElement(element2) {
  return tableElements.has(getNodeName(element2));
}
const topLayerSelectors = [":popover-open", ":modal"];
function isTopLayer(element2) {
  return topLayerSelectors.some((selector2) => {
    try {
      return element2.matches(selector2);
    } catch (_e2) {
      return false;
    }
  });
}
const transformProperties = ["transform", "translate", "scale", "rotate", "perspective"];
const willChangeValues = ["transform", "translate", "scale", "rotate", "perspective", "filter"];
const containValues = ["paint", "layout", "strict", "content"];
function isContainingBlock(elementOrCss) {
  const webkit2 = isWebKit();
  const css = isElement$1(elementOrCss) ? getComputedStyle$1(elementOrCss) : elementOrCss;
  return transformProperties.some((value) => css[value] ? css[value] !== "none" : false) || (css.containerType ? css.containerType !== "normal" : false) || !webkit2 && (css.backdropFilter ? css.backdropFilter !== "none" : false) || !webkit2 && (css.filter ? css.filter !== "none" : false) || willChangeValues.some((value) => (css.willChange || "").includes(value)) || containValues.some((value) => (css.contain || "").includes(value));
}
function getContainingBlock(element2) {
  let currentNode = getParentNode(element2);
  while (isHTMLElement(currentNode) && !isLastTraversableNode(currentNode)) {
    if (isContainingBlock(currentNode)) {
      return currentNode;
    } else if (isTopLayer(currentNode)) {
      return null;
    }
    currentNode = getParentNode(currentNode);
  }
  return null;
}
function isWebKit() {
  if (typeof CSS === "undefined" || !CSS.supports) return false;
  return CSS.supports("-webkit-backdrop-filter", "none");
}
const lastTraversableNodeNames = /* @__PURE__ */ new Set(["html", "body", "#document"]);
function isLastTraversableNode(node) {
  return lastTraversableNodeNames.has(getNodeName(node));
}
function getComputedStyle$1(element2) {
  return getWindow(element2).getComputedStyle(element2);
}
function getNodeScroll(element2) {
  if (isElement$1(element2)) {
    return {
      scrollLeft: element2.scrollLeft,
      scrollTop: element2.scrollTop
    };
  }
  return {
    scrollLeft: element2.scrollX,
    scrollTop: element2.scrollY
  };
}
function getParentNode(node) {
  if (getNodeName(node) === "html") {
    return node;
  }
  const result2 = (
    // Step into the shadow DOM of the parent of a slotted node.
    node.assignedSlot || // DOM Element detected.
    node.parentNode || // ShadowRoot detected.
    isShadowRoot(node) && node.host || // Fallback.
    getDocumentElement(node)
  );
  return isShadowRoot(result2) ? result2.host : result2;
}
function getNearestOverflowAncestor(node) {
  const parentNode = getParentNode(node);
  if (isLastTraversableNode(parentNode)) {
    return node.ownerDocument ? node.ownerDocument.body : node.body;
  }
  if (isHTMLElement(parentNode) && isOverflowElement(parentNode)) {
    return parentNode;
  }
  return getNearestOverflowAncestor(parentNode);
}
function getOverflowAncestors(node, list2, traverseIframes) {
  var _node$ownerDocument2;
  if (list2 === void 0) {
    list2 = [];
  }
  if (traverseIframes === void 0) {
    traverseIframes = true;
  }
  const scrollableAncestor = getNearestOverflowAncestor(node);
  const isBody = scrollableAncestor === ((_node$ownerDocument2 = node.ownerDocument) == null ? void 0 : _node$ownerDocument2.body);
  const win = getWindow(scrollableAncestor);
  if (isBody) {
    const frameElement = getFrameElement(win);
    return list2.concat(win, win.visualViewport || [], isOverflowElement(scrollableAncestor) ? scrollableAncestor : [], frameElement && traverseIframes ? getOverflowAncestors(frameElement) : []);
  }
  return list2.concat(scrollableAncestor, getOverflowAncestors(scrollableAncestor, [], traverseIframes));
}
function getFrameElement(win) {
  return win.parent && Object.getPrototypeOf(win.parent) ? win.frameElement : null;
}
function getCssDimensions(element2) {
  const css = getComputedStyle$1(element2);
  let width = parseFloat(css.width) || 0;
  let height = parseFloat(css.height) || 0;
  const hasOffset = isHTMLElement(element2);
  const offsetWidth = hasOffset ? element2.offsetWidth : width;
  const offsetHeight = hasOffset ? element2.offsetHeight : height;
  const shouldFallback = round(width) !== offsetWidth || round(height) !== offsetHeight;
  if (shouldFallback) {
    width = offsetWidth;
    height = offsetHeight;
  }
  return {
    width,
    height,
    $: shouldFallback
  };
}
function unwrapElement(element2) {
  return !isElement$1(element2) ? element2.contextElement : element2;
}
function getScale(element2) {
  const domElement = unwrapElement(element2);
  if (!isHTMLElement(domElement)) {
    return createCoords(1);
  }
  const rect = domElement.getBoundingClientRect();
  const {
    width,
    height,
    $: $2
  } = getCssDimensions(domElement);
  let x2 = ($2 ? round(rect.width) : rect.width) / width;
  let y2 = ($2 ? round(rect.height) : rect.height) / height;
  if (!x2 || !Number.isFinite(x2)) {
    x2 = 1;
  }
  if (!y2 || !Number.isFinite(y2)) {
    y2 = 1;
  }
  return {
    x: x2,
    y: y2
  };
}
const noOffsets = /* @__PURE__ */ createCoords(0);
function getVisualOffsets(element2) {
  const win = getWindow(element2);
  if (!isWebKit() || !win.visualViewport) {
    return noOffsets;
  }
  return {
    x: win.visualViewport.offsetLeft,
    y: win.visualViewport.offsetTop
  };
}
function shouldAddVisualOffsets(element2, isFixed, floatingOffsetParent) {
  if (isFixed === void 0) {
    isFixed = false;
  }
  if (!floatingOffsetParent || isFixed && floatingOffsetParent !== getWindow(element2)) {
    return false;
  }
  return isFixed;
}
function getBoundingClientRect(element2, includeScale, isFixedStrategy, offsetParent) {
  if (includeScale === void 0) {
    includeScale = false;
  }
  if (isFixedStrategy === void 0) {
    isFixedStrategy = false;
  }
  const clientRect = element2.getBoundingClientRect();
  const domElement = unwrapElement(element2);
  let scale = createCoords(1);
  if (includeScale) {
    if (offsetParent) {
      if (isElement$1(offsetParent)) {
        scale = getScale(offsetParent);
      }
    } else {
      scale = getScale(element2);
    }
  }
  const visualOffsets = shouldAddVisualOffsets(domElement, isFixedStrategy, offsetParent) ? getVisualOffsets(domElement) : createCoords(0);
  let x2 = (clientRect.left + visualOffsets.x) / scale.x;
  let y2 = (clientRect.top + visualOffsets.y) / scale.y;
  let width = clientRect.width / scale.x;
  let height = clientRect.height / scale.y;
  if (domElement) {
    const win = getWindow(domElement);
    const offsetWin = offsetParent && isElement$1(offsetParent) ? getWindow(offsetParent) : offsetParent;
    let currentWin = win;
    let currentIFrame = getFrameElement(currentWin);
    while (currentIFrame && offsetParent && offsetWin !== currentWin) {
      const iframeScale = getScale(currentIFrame);
      const iframeRect = currentIFrame.getBoundingClientRect();
      const css = getComputedStyle$1(currentIFrame);
      const left = iframeRect.left + (currentIFrame.clientLeft + parseFloat(css.paddingLeft)) * iframeScale.x;
      const top2 = iframeRect.top + (currentIFrame.clientTop + parseFloat(css.paddingTop)) * iframeScale.y;
      x2 *= iframeScale.x;
      y2 *= iframeScale.y;
      width *= iframeScale.x;
      height *= iframeScale.y;
      x2 += left;
      y2 += top2;
      currentWin = getWindow(currentIFrame);
      currentIFrame = getFrameElement(currentWin);
    }
  }
  return rectToClientRect({
    width,
    height,
    x: x2,
    y: y2
  });
}
function getWindowScrollBarX(element2, rect) {
  const leftScroll = getNodeScroll(element2).scrollLeft;
  if (!rect) {
    return getBoundingClientRect(getDocumentElement(element2)).left + leftScroll;
  }
  return rect.left + leftScroll;
}
function getHTMLOffset(documentElement, scroll) {
  const htmlRect = documentElement.getBoundingClientRect();
  const x2 = htmlRect.left + scroll.scrollLeft - getWindowScrollBarX(documentElement, htmlRect);
  const y2 = htmlRect.top + scroll.scrollTop;
  return {
    x: x2,
    y: y2
  };
}
function convertOffsetParentRelativeRectToViewportRelativeRect(_ref) {
  let {
    elements: elements2,
    rect,
    offsetParent,
    strategy
  } = _ref;
  const isFixed = strategy === "fixed";
  const documentElement = getDocumentElement(offsetParent);
  const topLayer = elements2 ? isTopLayer(elements2.floating) : false;
  if (offsetParent === documentElement || topLayer && isFixed) {
    return rect;
  }
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  let scale = createCoords(1);
  const offsets = createCoords(0);
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isHTMLElement(offsetParent)) {
      const offsetRect = getBoundingClientRect(offsetParent);
      scale = getScale(offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    }
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  return {
    width: rect.width * scale.x,
    height: rect.height * scale.y,
    x: rect.x * scale.x - scroll.scrollLeft * scale.x + offsets.x + htmlOffset.x,
    y: rect.y * scale.y - scroll.scrollTop * scale.y + offsets.y + htmlOffset.y
  };
}
function getClientRects(element2) {
  return Array.from(element2.getClientRects());
}
function getDocumentRect(element2) {
  const html = getDocumentElement(element2);
  const scroll = getNodeScroll(element2);
  const body = element2.ownerDocument.body;
  const width = max(html.scrollWidth, html.clientWidth, body.scrollWidth, body.clientWidth);
  const height = max(html.scrollHeight, html.clientHeight, body.scrollHeight, body.clientHeight);
  let x2 = -scroll.scrollLeft + getWindowScrollBarX(element2);
  const y2 = -scroll.scrollTop;
  if (getComputedStyle$1(body).direction === "rtl") {
    x2 += max(html.clientWidth, body.clientWidth) - width;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
const SCROLLBAR_MAX = 25;
function getViewportRect(element2, strategy) {
  const win = getWindow(element2);
  const html = getDocumentElement(element2);
  const visualViewport = win.visualViewport;
  let width = html.clientWidth;
  let height = html.clientHeight;
  let x2 = 0;
  let y2 = 0;
  if (visualViewport) {
    width = visualViewport.width;
    height = visualViewport.height;
    const visualViewportBased = isWebKit();
    if (!visualViewportBased || visualViewportBased && strategy === "fixed") {
      x2 = visualViewport.offsetLeft;
      y2 = visualViewport.offsetTop;
    }
  }
  const windowScrollbarX = getWindowScrollBarX(html);
  if (windowScrollbarX <= 0) {
    const doc2 = html.ownerDocument;
    const body = doc2.body;
    const bodyStyles = getComputedStyle(body);
    const bodyMarginInline = doc2.compatMode === "CSS1Compat" ? parseFloat(bodyStyles.marginLeft) + parseFloat(bodyStyles.marginRight) || 0 : 0;
    const clippingStableScrollbarWidth = Math.abs(html.clientWidth - body.clientWidth - bodyMarginInline);
    if (clippingStableScrollbarWidth <= SCROLLBAR_MAX) {
      width -= clippingStableScrollbarWidth;
    }
  } else if (windowScrollbarX <= SCROLLBAR_MAX) {
    width += windowScrollbarX;
  }
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
const absoluteOrFixed = /* @__PURE__ */ new Set(["absolute", "fixed"]);
function getInnerBoundingClientRect(element2, strategy) {
  const clientRect = getBoundingClientRect(element2, true, strategy === "fixed");
  const top2 = clientRect.top + element2.clientTop;
  const left = clientRect.left + element2.clientLeft;
  const scale = isHTMLElement(element2) ? getScale(element2) : createCoords(1);
  const width = element2.clientWidth * scale.x;
  const height = element2.clientHeight * scale.y;
  const x2 = left * scale.x;
  const y2 = top2 * scale.y;
  return {
    width,
    height,
    x: x2,
    y: y2
  };
}
function getClientRectFromClippingAncestor(element2, clippingAncestor, strategy) {
  let rect;
  if (clippingAncestor === "viewport") {
    rect = getViewportRect(element2, strategy);
  } else if (clippingAncestor === "document") {
    rect = getDocumentRect(getDocumentElement(element2));
  } else if (isElement$1(clippingAncestor)) {
    rect = getInnerBoundingClientRect(clippingAncestor, strategy);
  } else {
    const visualOffsets = getVisualOffsets(element2);
    rect = {
      x: clippingAncestor.x - visualOffsets.x,
      y: clippingAncestor.y - visualOffsets.y,
      width: clippingAncestor.width,
      height: clippingAncestor.height
    };
  }
  return rectToClientRect(rect);
}
function hasFixedPositionAncestor(element2, stopNode) {
  const parentNode = getParentNode(element2);
  if (parentNode === stopNode || !isElement$1(parentNode) || isLastTraversableNode(parentNode)) {
    return false;
  }
  return getComputedStyle$1(parentNode).position === "fixed" || hasFixedPositionAncestor(parentNode, stopNode);
}
function getClippingElementAncestors(element2, cache) {
  const cachedResult = cache.get(element2);
  if (cachedResult) {
    return cachedResult;
  }
  let result2 = getOverflowAncestors(element2, [], false).filter((el) => isElement$1(el) && getNodeName(el) !== "body");
  let currentContainingBlockComputedStyle = null;
  const elementIsFixed = getComputedStyle$1(element2).position === "fixed";
  let currentNode = elementIsFixed ? getParentNode(element2) : element2;
  while (isElement$1(currentNode) && !isLastTraversableNode(currentNode)) {
    const computedStyle = getComputedStyle$1(currentNode);
    const currentNodeIsContaining = isContainingBlock(currentNode);
    if (!currentNodeIsContaining && computedStyle.position === "fixed") {
      currentContainingBlockComputedStyle = null;
    }
    const shouldDropCurrentNode = elementIsFixed ? !currentNodeIsContaining && !currentContainingBlockComputedStyle : !currentNodeIsContaining && computedStyle.position === "static" && !!currentContainingBlockComputedStyle && absoluteOrFixed.has(currentContainingBlockComputedStyle.position) || isOverflowElement(currentNode) && !currentNodeIsContaining && hasFixedPositionAncestor(element2, currentNode);
    if (shouldDropCurrentNode) {
      result2 = result2.filter((ancestor) => ancestor !== currentNode);
    } else {
      currentContainingBlockComputedStyle = computedStyle;
    }
    currentNode = getParentNode(currentNode);
  }
  cache.set(element2, result2);
  return result2;
}
function getClippingRect(_ref) {
  let {
    element: element2,
    boundary,
    rootBoundary,
    strategy
  } = _ref;
  const elementClippingAncestors = boundary === "clippingAncestors" ? isTopLayer(element2) ? [] : getClippingElementAncestors(element2, this._c) : [].concat(boundary);
  const clippingAncestors = [...elementClippingAncestors, rootBoundary];
  const firstClippingAncestor = clippingAncestors[0];
  const clippingRect = clippingAncestors.reduce((accRect, clippingAncestor) => {
    const rect = getClientRectFromClippingAncestor(element2, clippingAncestor, strategy);
    accRect.top = max(rect.top, accRect.top);
    accRect.right = min(rect.right, accRect.right);
    accRect.bottom = min(rect.bottom, accRect.bottom);
    accRect.left = max(rect.left, accRect.left);
    return accRect;
  }, getClientRectFromClippingAncestor(element2, firstClippingAncestor, strategy));
  return {
    width: clippingRect.right - clippingRect.left,
    height: clippingRect.bottom - clippingRect.top,
    x: clippingRect.left,
    y: clippingRect.top
  };
}
function getDimensions(element2) {
  const {
    width,
    height
  } = getCssDimensions(element2);
  return {
    width,
    height
  };
}
function getRectRelativeToOffsetParent(element2, offsetParent, strategy) {
  const isOffsetParentAnElement = isHTMLElement(offsetParent);
  const documentElement = getDocumentElement(offsetParent);
  const isFixed = strategy === "fixed";
  const rect = getBoundingClientRect(element2, true, isFixed, offsetParent);
  let scroll = {
    scrollLeft: 0,
    scrollTop: 0
  };
  const offsets = createCoords(0);
  function setLeftRTLScrollbarOffset() {
    offsets.x = getWindowScrollBarX(documentElement);
  }
  if (isOffsetParentAnElement || !isOffsetParentAnElement && !isFixed) {
    if (getNodeName(offsetParent) !== "body" || isOverflowElement(documentElement)) {
      scroll = getNodeScroll(offsetParent);
    }
    if (isOffsetParentAnElement) {
      const offsetRect = getBoundingClientRect(offsetParent, true, isFixed, offsetParent);
      offsets.x = offsetRect.x + offsetParent.clientLeft;
      offsets.y = offsetRect.y + offsetParent.clientTop;
    } else if (documentElement) {
      setLeftRTLScrollbarOffset();
    }
  }
  if (isFixed && !isOffsetParentAnElement && documentElement) {
    setLeftRTLScrollbarOffset();
  }
  const htmlOffset = documentElement && !isOffsetParentAnElement && !isFixed ? getHTMLOffset(documentElement, scroll) : createCoords(0);
  const x2 = rect.left + scroll.scrollLeft - offsets.x - htmlOffset.x;
  const y2 = rect.top + scroll.scrollTop - offsets.y - htmlOffset.y;
  return {
    x: x2,
    y: y2,
    width: rect.width,
    height: rect.height
  };
}
function isStaticPositioned(element2) {
  return getComputedStyle$1(element2).position === "static";
}
function getTrueOffsetParent(element2, polyfill) {
  if (!isHTMLElement(element2) || getComputedStyle$1(element2).position === "fixed") {
    return null;
  }
  if (polyfill) {
    return polyfill(element2);
  }
  let rawOffsetParent = element2.offsetParent;
  if (getDocumentElement(element2) === rawOffsetParent) {
    rawOffsetParent = rawOffsetParent.ownerDocument.body;
  }
  return rawOffsetParent;
}
function getOffsetParent(element2, polyfill) {
  const win = getWindow(element2);
  if (isTopLayer(element2)) {
    return win;
  }
  if (!isHTMLElement(element2)) {
    let svgOffsetParent = getParentNode(element2);
    while (svgOffsetParent && !isLastTraversableNode(svgOffsetParent)) {
      if (isElement$1(svgOffsetParent) && !isStaticPositioned(svgOffsetParent)) {
        return svgOffsetParent;
      }
      svgOffsetParent = getParentNode(svgOffsetParent);
    }
    return win;
  }
  let offsetParent = getTrueOffsetParent(element2, polyfill);
  while (offsetParent && isTableElement(offsetParent) && isStaticPositioned(offsetParent)) {
    offsetParent = getTrueOffsetParent(offsetParent, polyfill);
  }
  if (offsetParent && isLastTraversableNode(offsetParent) && isStaticPositioned(offsetParent) && !isContainingBlock(offsetParent)) {
    return win;
  }
  return offsetParent || getContainingBlock(element2) || win;
}
const getElementRects = async function(data) {
  const getOffsetParentFn = this.getOffsetParent || getOffsetParent;
  const getDimensionsFn = this.getDimensions;
  const floatingDimensions = await getDimensionsFn(data.floating);
  return {
    reference: getRectRelativeToOffsetParent(data.reference, await getOffsetParentFn(data.floating), data.strategy),
    floating: {
      x: 0,
      y: 0,
      width: floatingDimensions.width,
      height: floatingDimensions.height
    }
  };
};
function isRTL(element2) {
  return getComputedStyle$1(element2).direction === "rtl";
}
const platform = {
  convertOffsetParentRelativeRectToViewportRelativeRect,
  getDocumentElement,
  getClippingRect,
  getOffsetParent,
  getElementRects,
  getClientRects,
  getDimensions,
  getScale,
  isElement: isElement$1,
  isRTL
};
function rectsAreEqual(a2, b2) {
  return a2.x === b2.x && a2.y === b2.y && a2.width === b2.width && a2.height === b2.height;
}
function observeMove(element2, onMove) {
  let io2 = null;
  let timeoutId;
  const root2 = getDocumentElement(element2);
  function cleanup() {
    var _io;
    clearTimeout(timeoutId);
    (_io = io2) == null || _io.disconnect();
    io2 = null;
  }
  function refresh(skip, threshold) {
    if (skip === void 0) {
      skip = false;
    }
    if (threshold === void 0) {
      threshold = 1;
    }
    cleanup();
    const elementRectForRootMargin = element2.getBoundingClientRect();
    const {
      left,
      top: top2,
      width,
      height
    } = elementRectForRootMargin;
    if (!skip) {
      onMove();
    }
    if (!width || !height) {
      return;
    }
    const insetTop = floor(top2);
    const insetRight = floor(root2.clientWidth - (left + width));
    const insetBottom = floor(root2.clientHeight - (top2 + height));
    const insetLeft = floor(left);
    const rootMargin = -insetTop + "px " + -insetRight + "px " + -insetBottom + "px " + -insetLeft + "px";
    const options2 = {
      rootMargin,
      threshold: max(0, min(1, threshold)) || 1
    };
    let isFirstUpdate = true;
    function handleObserve(entries) {
      const ratio = entries[0].intersectionRatio;
      if (ratio !== threshold) {
        if (!isFirstUpdate) {
          return refresh();
        }
        if (!ratio) {
          timeoutId = setTimeout(() => {
            refresh(false, 1e-7);
          }, 1e3);
        } else {
          refresh(false, ratio);
        }
      }
      if (ratio === 1 && !rectsAreEqual(elementRectForRootMargin, element2.getBoundingClientRect())) {
        refresh();
      }
      isFirstUpdate = false;
    }
    try {
      io2 = new IntersectionObserver(handleObserve, {
        ...options2,
        // Handle <iframe>s
        root: root2.ownerDocument
      });
    } catch (_e2) {
      io2 = new IntersectionObserver(handleObserve, options2);
    }
    io2.observe(element2);
  }
  refresh(true);
  return cleanup;
}
function autoUpdate(reference, floating, update, options2) {
  if (options2 === void 0) {
    options2 = {};
  }
  const {
    ancestorScroll = true,
    ancestorResize = true,
    elementResize = typeof ResizeObserver === "function",
    layoutShift = typeof IntersectionObserver === "function",
    animationFrame = false
  } = options2;
  const referenceEl = unwrapElement(reference);
  const ancestors = ancestorScroll || ancestorResize ? [...referenceEl ? getOverflowAncestors(referenceEl) : [], ...getOverflowAncestors(floating)] : [];
  ancestors.forEach((ancestor) => {
    ancestorScroll && ancestor.addEventListener("scroll", update, {
      passive: true
    });
    ancestorResize && ancestor.addEventListener("resize", update);
  });
  const cleanupIo = referenceEl && layoutShift ? observeMove(referenceEl, update) : null;
  let reobserveFrame = -1;
  let resizeObserver = null;
  if (elementResize) {
    resizeObserver = new ResizeObserver((_ref) => {
      let [firstEntry] = _ref;
      if (firstEntry && firstEntry.target === referenceEl && resizeObserver) {
        resizeObserver.unobserve(floating);
        cancelAnimationFrame(reobserveFrame);
        reobserveFrame = requestAnimationFrame(() => {
          var _resizeObserver;
          (_resizeObserver = resizeObserver) == null || _resizeObserver.observe(floating);
        });
      }
      update();
    });
    if (referenceEl && !animationFrame) {
      resizeObserver.observe(referenceEl);
    }
    resizeObserver.observe(floating);
  }
  let frameId;
  let prevRefRect = animationFrame ? getBoundingClientRect(reference) : null;
  if (animationFrame) {
    frameLoop();
  }
  function frameLoop() {
    const nextRefRect = getBoundingClientRect(reference);
    if (prevRefRect && !rectsAreEqual(prevRefRect, nextRefRect)) {
      update();
    }
    prevRefRect = nextRefRect;
    frameId = requestAnimationFrame(frameLoop);
  }
  update();
  return () => {
    var _resizeObserver2;
    ancestors.forEach((ancestor) => {
      ancestorScroll && ancestor.removeEventListener("scroll", update);
      ancestorResize && ancestor.removeEventListener("resize", update);
    });
    cleanupIo == null || cleanupIo();
    (_resizeObserver2 = resizeObserver) == null || _resizeObserver2.disconnect();
    resizeObserver = null;
    if (animationFrame) {
      cancelAnimationFrame(frameId);
    }
  };
}
const offset = offset$1;
const shift = shift$1;
const flip = flip$1;
const size = size$1;
const arrow = arrow$1;
const limitShift = limitShift$1;
const computePosition = (reference, floating, options2) => {
  const cache = /* @__PURE__ */ new Map();
  const mergedOptions = {
    platform,
    ...options2
  };
  const platformWithCache = {
    ...mergedOptions.platform,
    _c: cache
  };
  return computePosition$1(reference, floating, {
    ...mergedOptions,
    platform: platformWithCache
  });
};
const TagName$m = "div";
function createDOMRect(x2 = 0, y2 = 0, width = 0, height = 0) {
  if (typeof DOMRect === "function") return new DOMRect(x2, y2, width, height);
  const rect = {
    x: x2,
    y: y2,
    width,
    height,
    top: y2,
    right: x2 + width,
    bottom: y2 + height,
    left: x2
  };
  return {
    ...rect,
    toJSON: () => rect
  };
}
function getDOMRect(anchorRect) {
  if (!anchorRect) return createDOMRect();
  const { x: x2, y: y2, width, height } = anchorRect;
  return createDOMRect(x2, y2, width, height);
}
function getAnchorElement(anchorElement, getAnchorRect) {
  return {
    contextElement: anchorElement || void 0,
    getBoundingClientRect: () => {
      const anchor = anchorElement;
      const anchorRect = getAnchorRect?.(anchor);
      if (anchorRect || !anchor) return getDOMRect(anchorRect);
      return anchor.getBoundingClientRect();
    }
  };
}
function isValidPlacement(flip2) {
  return /^(?:top|bottom|left|right)(?:-(?:start|end))?$/.test(flip2);
}
function roundByDPR(value) {
  const dpr = window.devicePixelRatio || 1;
  return Math.round(value * dpr) / dpr;
}
function getOffsetMiddleware(arrowElement, props2) {
  return offset(({ placement }) => {
    const arrowOffset = (arrowElement?.clientHeight || 0) / 2;
    const finalGutter = typeof props2.gutter === "number" ? props2.gutter + arrowOffset : props2.gutter ?? arrowOffset;
    return {
      crossAxis: !!!placement.split("-")[1] ? props2.shift : void 0,
      mainAxis: finalGutter,
      alignmentAxis: props2.shift
    };
  });
}
function getFlipMiddleware(props2) {
  if (props2.flip === false) return;
  const fallbackPlacements = typeof props2.flip === "string" ? props2.flip.split(" ") : void 0;
  invariant(!fallbackPlacements || fallbackPlacements.every(isValidPlacement), process.env.NODE_ENV !== "production" && "`flip` expects a spaced-delimited list of placements");
  return flip({
    padding: props2.overflowPadding,
    fallbackPlacements
  });
}
function getShiftMiddleware(props2) {
  if (!props2.slide && !props2.overlap) return;
  return shift({
    mainAxis: props2.slide,
    crossAxis: props2.overlap,
    padding: props2.overflowPadding,
    limiter: limitShift()
  });
}
function getSizeMiddleware(props2, shouldCancel) {
  return size({
    padding: props2.overflowPadding,
    apply({ elements: elements2, availableWidth, availableHeight, rects }) {
      if (shouldCancel?.()) return;
      const wrapper = elements2.floating;
      const referenceWidth = Math.round(rects.reference.width);
      availableWidth = Math.floor(availableWidth);
      availableHeight = Math.floor(availableHeight);
      wrapper.style.setProperty("--popover-anchor-width", `${referenceWidth}px`);
      wrapper.style.setProperty("--popover-available-width", `${availableWidth}px`);
      wrapper.style.setProperty("--popover-available-height", `${availableHeight}px`);
      if (props2.sameWidth) wrapper.style.width = `${referenceWidth}px`;
      if (props2.fitViewport) {
        wrapper.style.maxWidth = `${availableWidth}px`;
        wrapper.style.maxHeight = `${availableHeight}px`;
      }
    }
  });
}
function getArrowMiddleware(arrowElement, props2) {
  if (!arrowElement) return;
  return arrow({
    element: arrowElement,
    padding: props2.arrowPadding
  });
}
const usePopover = createHook(function usePopover2({ store: store2, modal = false, portal = modal, preserveTabOrder = true, autoFocusOnShow = true, wrapperProps, fixed = false, flip: flip2 = true, shift: shift2 = 0, slide = true, overlap = false, sameWidth = false, fitViewport = false, gutter: gutter2, arrowPadding = 4, overflowPadding = 8, getAnchorRect, updatePosition, ...props2 }) {
  const context = usePopoverProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Popover must receive a `store` prop or be wrapped in a PopoverProvider component.");
  const arrowElement = useStoreState(store2, "arrowElement");
  const anchorElement = useStoreState(store2, "anchorElement");
  const disclosureElement = useStoreState(store2, "disclosureElement");
  const popoverElement = useStoreState(store2, "popoverElement");
  const contentElement = useStoreState(store2, "contentElement");
  const placement = useStoreState(store2, "placement");
  const mounted = useStoreState(store2, "mounted");
  const rendered = useStoreState(store2, "rendered");
  const defaultArrowElementRef = useRef(null);
  const [positioned, setPositioned] = useState(false);
  const { portalRef, domReady } = usePortalRef(portal, props2.portalRef);
  const getAnchorRectProp = useEvent(getAnchorRect);
  const updatePositionProp = useEvent(updatePosition);
  const hasCustomUpdatePosition = !!updatePosition;
  useSafeLayoutEffect(() => {
    if (!popoverElement?.isConnected) return;
    popoverElement.style.setProperty("--popover-overflow-padding", `${overflowPadding}px`);
    const anchor = getAnchorElement(anchorElement, getAnchorRectProp);
    let canceled = false;
    const shouldCancelUpdate = () => {
      if (canceled) return true;
      if (!popoverElement.isConnected) return true;
      return false;
    };
    const updatePosition2 = async () => {
      if (shouldCancelUpdate()) return;
      if (!mounted) return;
      if (!arrowElement) defaultArrowElementRef.current = defaultArrowElementRef.current || document.createElement("div");
      const arrow2 = arrowElement || defaultArrowElementRef.current;
      const middleware = [
        getOffsetMiddleware(arrow2, {
          gutter: gutter2,
          shift: shift2
        }),
        getFlipMiddleware({
          flip: flip2,
          overflowPadding
        }),
        getShiftMiddleware({
          slide,
          overlap,
          overflowPadding
        }),
        getArrowMiddleware(arrow2, { arrowPadding }),
        getSizeMiddleware({
          sameWidth,
          fitViewport,
          overflowPadding
        }, shouldCancelUpdate)
      ];
      const pos = await computePosition(anchor, popoverElement, {
        placement,
        strategy: fixed ? "fixed" : "absolute",
        middleware
      });
      if (shouldCancelUpdate()) return;
      store2?.setState("currentPlacement", pos.placement);
      setPositioned(true);
      const x2 = roundByDPR(pos.x);
      const y2 = roundByDPR(pos.y);
      Object.assign(popoverElement.style, {
        top: "0",
        left: "0",
        transform: `translate3d(${x2}px,${y2}px,0)`
      });
      if (arrow2 && pos.middlewareData.arrow) {
        const { x: arrowX, y: arrowY } = pos.middlewareData.arrow;
        const side = getBasePlacement(pos.placement);
        const centerX = arrow2.clientWidth / 2;
        const centerY = arrow2.clientHeight / 2;
        const originX = arrowX != null ? arrowX + centerX : -centerX;
        const originY = arrowY != null ? arrowY + centerY : -centerY;
        popoverElement.style.setProperty("--popover-transform-origin", {
          top: `${originX}px calc(100% + ${centerY}px)`,
          bottom: `${originX}px ${-centerY}px`,
          left: `calc(100% + ${centerX}px) ${originY}px`,
          right: `${-centerX}px ${originY}px`
        }[side]);
        Object.assign(arrow2.style, {
          left: arrowX != null ? `${arrowX}px` : "",
          top: arrowY != null ? `${arrowY}px` : "",
          right: "",
          bottom: "",
          [side]: "100%"
        });
      }
    };
    const update = async () => {
      if (shouldCancelUpdate()) return;
      if (hasCustomUpdatePosition) {
        await updatePositionProp({ updatePosition: updatePosition2 });
        if (shouldCancelUpdate()) return;
        setPositioned(true);
      } else await updatePosition2();
    };
    const cancelAutoUpdate = autoUpdate(anchor, popoverElement, update, { elementResize: typeof ResizeObserver === "function" });
    return () => {
      canceled = true;
      setPositioned(false);
      cancelAutoUpdate();
    };
  }, [
    store2,
    rendered,
    popoverElement,
    arrowElement,
    anchorElement,
    placement,
    mounted,
    domReady,
    fixed,
    flip2,
    shift2,
    slide,
    overlap,
    sameWidth,
    fitViewport,
    gutter2,
    arrowPadding,
    overflowPadding,
    getAnchorRectProp,
    hasCustomUpdatePosition,
    updatePositionProp
  ]);
  useSafeLayoutEffect(() => {
    if (!mounted) return;
    if (!domReady) return;
    if (!popoverElement?.isConnected) return;
    if (!contentElement?.isConnected) return;
    const applyZIndex = () => {
      popoverElement.style.zIndex = getComputedStyle(contentElement).zIndex;
    };
    applyZIndex();
    let raf = requestAnimationFrame(() => {
      raf = requestAnimationFrame(applyZIndex);
    });
    return () => cancelAnimationFrame(raf);
  }, [
    mounted,
    domReady,
    popoverElement,
    contentElement
  ]);
  const position2 = fixed ? "fixed" : "absolute";
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", {
    ...wrapperProps,
    style: {
      position: position2,
      top: 0,
      left: 0,
      width: "max-content",
      ...wrapperProps?.style
    },
    ref: store2?.setPopoverElement,
    children: element2
  }), [
    store2,
    position2,
    wrapperProps
  ]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(PopoverScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  props2 = {
    "data-placing": !positioned || void 0,
    ...props2,
    style: {
      position: "relative",
      ...props2.style
    }
  };
  props2 = useDialog({
    store: store2,
    modal,
    portal,
    preserveTabOrder,
    preserveTabOrderAnchor: disclosureElement || anchorElement,
    autoFocusOnShow: positioned && autoFocusOnShow,
    ...props2,
    portalRef
  });
  return props2;
});
const Popover = createDialogComponent(forwardRef(function Popover2(props2) {
  return createElement(TagName$m, usePopover(props2));
}), usePopoverProviderContext);
const ctx$1 = createStoreContext([PopoverContextProvider], [PopoverScopedContextProvider]);
const useHovercardProviderContext = ctx$1.useProviderContext;
const HovercardContextProvider = ctx$1.ContextProvider;
const HovercardScopedContextProvider = ctx$1.ScopedContextProvider;
function getEventPoint(event) {
  return [event.clientX, event.clientY];
}
function isPointInPolygon(point2, polygon) {
  const [x2, y2] = point2;
  let inside2 = false;
  const length = polygon.length;
  for (let l2 = length, i2 = 0, j2 = l2 - 1; i2 < l2; j2 = i2++) {
    const currentPoint = polygon[i2];
    const previousPoint = polygon[j2];
    const vertexPoint = polygon[j2 === 0 ? l2 - 1 : j2 - 1];
    if (currentPoint == null) return false;
    if (previousPoint == null) return false;
    if (vertexPoint == null) return false;
    const [xi2, yi2] = currentPoint;
    const [xj, yj] = previousPoint;
    const [, vy] = vertexPoint;
    const where2 = (yi2 - yj) * (x2 - xi2) - (xi2 - xj) * (y2 - yi2);
    if (yj < yi2) {
      if (y2 >= yj && y2 < yi2) {
        if (where2 === 0) return true;
        if (where2 > 0) if (y2 === yj) {
          if (y2 > vy) inside2 = !inside2;
        } else inside2 = !inside2;
      }
    } else if (yi2 < yj) {
      if (y2 > yi2 && y2 <= yj) {
        if (where2 === 0) return true;
        if (where2 < 0) if (y2 === yj) {
          if (y2 < vy) inside2 = !inside2;
        } else inside2 = !inside2;
      }
    } else if (y2 === yi2 && (x2 >= xj && x2 <= xi2 || x2 >= xi2 && x2 <= xj)) return true;
  }
  return inside2;
}
function getEnterPointPlacement(enterPoint, rect) {
  const { top: top2, right, bottom, left } = rect;
  const [x2, y2] = enterPoint;
  return [x2 < left ? "left" : x2 > right ? "right" : null, y2 < top2 ? "top" : y2 > bottom ? "bottom" : null];
}
function getElementPolygon(element2, enterPoint) {
  const rect = element2.getBoundingClientRect();
  const { top: top2, right, bottom, left } = rect;
  const [x2, y2] = getEnterPointPlacement(enterPoint, rect);
  const polygon = [enterPoint];
  if (x2) {
    if (y2 !== "top") polygon.push([x2 === "left" ? left : right, top2]);
    polygon.push([x2 === "left" ? right : left, top2]);
    polygon.push([x2 === "left" ? right : left, bottom]);
    if (y2 !== "bottom") polygon.push([x2 === "left" ? left : right, bottom]);
  } else if (y2 === "top") {
    polygon.push([left, top2]);
    polygon.push([left, bottom]);
    polygon.push([right, bottom]);
    polygon.push([right, top2]);
  } else {
    polygon.push([left, bottom]);
    polygon.push([left, top2]);
    polygon.push([right, top2]);
    polygon.push([right, bottom]);
  }
  return polygon;
}
const TagName$l = "div";
function isMovingOnHovercard(path, card, anchor, nested) {
  if (hasFocusWithin(card)) return true;
  if (path.includes(card)) return true;
  if (anchor && path.includes(anchor)) return true;
  if (nested?.some((card2) => hasFocusWithin(card2) || path.includes(card2))) return true;
  return false;
}
function disableEventOnTransit({ event, element: element2, enterPointRef, disablePointerEvents, refreshEnterPoint = false }) {
  const enterPoint = enterPointRef.current;
  if (!enterPoint) return false;
  const currentPoint = getEventPoint(event);
  if (!isPointInPolygon(currentPoint, getElementPolygon(element2, enterPoint))) return false;
  if (refreshEnterPoint) enterPointRef.current = currentPoint;
  if (disablePointerEvents(event)) {
    event.preventDefault();
    event.stopPropagation();
  }
  return true;
}
function useAutoFocusOnHide({ store: store2, ...props2 }) {
  const [autoFocusOnHide, setAutoFocusOnHide] = useState(false);
  const mounted = useStoreState(store2, "mounted");
  useEffect(() => {
    if (!mounted) setAutoFocusOnHide(false);
  }, [mounted]);
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent((event) => {
    onFocusProp?.(event);
    if (event.defaultPrevented) return;
    setAutoFocusOnHide(true);
  });
  const finalFocusRef = useRef(null);
  useEffect(() => {
    return sync(store2, ["anchorElement"], (state) => {
      finalFocusRef.current = state.anchorElement;
    });
  }, [store2]);
  props2 = {
    autoFocusOnHide,
    finalFocus: finalFocusRef,
    ...props2,
    onFocus
  };
  return props2;
}
const NestedHovercardContext = createContext(null);
const useHovercard = createHook(function useHovercard2({ store: store2, modal = false, portal = modal, hideOnEscape = true, hideOnHoverOutside = true, disablePointerEventsOnApproach = !!hideOnHoverOutside, ...props2 }) {
  const context = useHovercardProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Hovercard must receive a `store` prop or be wrapped in a HovercardProvider component.");
  const ref = useRef(null);
  const nestedHovercardsRef = useRef([]);
  const hideTimeoutRef = useRef(0);
  const enterPointRef = useRef(null);
  const { portalRef, domReady } = usePortalRef(portal, props2.portalRef);
  const isMouseMoving = useIsMouseMoving();
  const mayHideOnHoverOutside = !!hideOnHoverOutside;
  const hideOnHoverOutsideProp = useBooleanEvent(hideOnHoverOutside);
  const mayDisablePointerEvents = !!disablePointerEventsOnApproach;
  const disablePointerEventsProp = useBooleanEvent(disablePointerEventsOnApproach);
  const open = useStoreState(store2, "open");
  const mounted = useStoreState(store2, "mounted");
  const clearHideTimeout = useCallback(() => {
    window.clearTimeout(hideTimeoutRef.current);
    hideTimeoutRef.current = 0;
  }, []);
  useEffect(() => {
    if (!domReady) return;
    if (!mounted) return;
    if (!mayHideOnHoverOutside && !mayDisablePointerEvents) return;
    const element2 = ref.current;
    if (!element2) return;
    const onMouseMove = (event) => {
      if (!store2) return;
      if (!isMouseMoving()) return;
      const { anchorElement, hideTimeout, timeout } = store2.getState();
      const path = event.composedPath();
      const anchor = anchorElement;
      if (isMovingOnHovercard(path, element2, anchor, nestedHovercardsRef.current)) {
        enterPointRef.current = anchor && path.includes(anchor) ? getEventPoint(event) : null;
        clearHideTimeout();
        return;
      }
      if (hideTimeoutRef.current) return;
      if (disableEventOnTransit({
        event,
        element: element2,
        enterPointRef,
        disablePointerEvents: disablePointerEventsProp,
        refreshEnterPoint: true
      })) return;
      if (!hideOnHoverOutsideProp(event)) return;
      hideTimeoutRef.current = window.setTimeout(() => {
        hideTimeoutRef.current = 0;
        store2?.hide();
      }, hideTimeout ?? timeout);
    };
    return chain(addGlobalEventListener("mousemove", onMouseMove, true), clearHideTimeout);
  }, [
    store2,
    isMouseMoving,
    domReady,
    mounted,
    mayHideOnHoverOutside,
    mayDisablePointerEvents,
    nestedHovercardsRef,
    clearHideTimeout,
    disablePointerEventsProp,
    hideOnHoverOutsideProp
  ]);
  useEffect(() => {
    if (!domReady) return;
    if (!mounted) return;
    if (!mayDisablePointerEvents) return;
    const disableEvent = (event) => {
      const element2 = ref.current;
      if (!element2) return;
      disableEventOnTransit({
        event,
        element: element2,
        enterPointRef,
        disablePointerEvents: disablePointerEventsProp
      });
    };
    return chain(addGlobalEventListener("mouseenter", disableEvent, true), addGlobalEventListener("mouseover", disableEvent, true), addGlobalEventListener("mouseout", disableEvent, true), addGlobalEventListener("mouseleave", disableEvent, true));
  }, [
    domReady,
    mounted,
    mayDisablePointerEvents,
    disablePointerEventsProp
  ]);
  useEffect(() => {
    if (!domReady) return;
    if (open) return;
    store2?.setAutoFocusOnShow(false);
  }, [
    store2,
    domReady,
    open
  ]);
  const openRef = useLiveRef(open);
  useEffect(() => {
    if (!domReady) return;
    return () => {
      if (!openRef.current) store2?.setAutoFocusOnShow(false);
    };
  }, [store2, domReady]);
  const registerOnParent = useContext(NestedHovercardContext);
  useSafeLayoutEffect(() => {
    if (modal) return;
    if (!portal) return;
    if (!mounted) return;
    if (!domReady) return;
    const element2 = ref.current;
    if (!element2) return;
    return registerOnParent?.(element2);
  }, [
    modal,
    portal,
    mounted,
    domReady
  ]);
  const registerNestedHovercard = useCallback((element2) => {
    clearHideTimeout();
    nestedHovercardsRef.current = [...nestedHovercardsRef.current, element2];
    const parentUnregister = registerOnParent?.(element2);
    return () => {
      clearHideTimeout();
      nestedHovercardsRef.current = nestedHovercardsRef.current.filter((item) => item !== element2);
      parentUnregister?.();
    };
  }, [clearHideTimeout, registerOnParent]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(HovercardScopedContextProvider, {
    value: store2,
    children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(NestedHovercardContext.Provider, {
      value: registerNestedHovercard,
      children: element2
    })
  }), [store2, registerNestedHovercard]);
  props2 = {
    ...props2,
    ref: useMergeRefs(ref, props2.ref)
  };
  props2 = useAutoFocusOnHide({
    store: store2,
    ...props2
  });
  const autoFocusOnShow = useStoreState(store2, (state) => modal || state.autoFocusOnShow);
  props2 = usePopover({
    store: store2,
    modal,
    portal,
    autoFocusOnShow,
    ...props2,
    portalRef,
    hideOnEscape(event) {
      if (isFalsyBooleanCallback(hideOnEscape, event)) return false;
      requestAnimationFrame(() => {
        requestAnimationFrame(() => {
          store2?.hide();
        });
      });
      return true;
    }
  });
  return props2;
});
createDialogComponent(forwardRef(function Hovercard(props2) {
  return createElement(TagName$l, useHovercard(props2));
}), useHovercardProviderContext);
const TagName$k = "a";
const useHovercardAnchor = createHook(function useHovercardAnchor2({ store: store2, showOnHover = true, ...props2 }) {
  const context = useHovercardProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "HovercardAnchor must receive a `store` prop or be wrapped in a HovercardProvider component.");
  const disabled = disabledFromProps(props2);
  const showTimeoutRef = useRef(0);
  useEffect(() => () => window.clearTimeout(showTimeoutRef.current), []);
  useEffect(() => {
    const onMouseLeave = (event) => {
      if (!store2) return;
      const { anchorElement } = store2.getState();
      if (!anchorElement) return;
      if (event.target !== anchorElement) return;
      window.clearTimeout(showTimeoutRef.current);
      showTimeoutRef.current = 0;
    };
    return addGlobalEventListener("mouseleave", onMouseLeave, true);
  }, [store2]);
  const onMouseMoveProp = props2.onMouseMove;
  const showOnHoverProp = useBooleanEvent(showOnHover);
  const isMouseMoving = useIsMouseMoving();
  const onMouseMove = useEvent((event) => {
    onMouseMoveProp?.(event);
    if (disabled) return;
    if (!store2) return;
    if (event.defaultPrevented) return;
    if (showTimeoutRef.current) return;
    if (!isMouseMoving()) return;
    if (!showOnHoverProp(event)) return;
    const element2 = event.currentTarget;
    store2.setAnchorElement(element2);
    store2.setDisclosureElement(element2);
    const { showTimeout, timeout } = store2.getState();
    const showHovercard = () => {
      showTimeoutRef.current = 0;
      if (!isMouseMoving()) return;
      store2?.setAnchorElement(element2);
      store2?.show();
      queueMicrotask(() => {
        store2?.setDisclosureElement(element2);
      });
    };
    const timeoutMs = showTimeout ?? timeout;
    if (timeoutMs === 0) showHovercard();
    else showTimeoutRef.current = window.setTimeout(showHovercard, timeoutMs);
  });
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (!store2) return;
    window.clearTimeout(showTimeoutRef.current);
    showTimeoutRef.current = 0;
  });
  const ref = useCallback((element2) => {
    if (!store2) return;
    const { anchorElement } = store2.getState();
    if (anchorElement?.isConnected) return;
    store2.setAnchorElement(element2);
  }, [store2]);
  props2 = {
    ...props2,
    ref: useMergeRefs(ref, props2.ref),
    onMouseMove,
    onClick
  };
  props2 = useFocusable(props2);
  return props2;
});
forwardRef(function HovercardAnchor(props2) {
  return createElement(TagName$k, useHovercardAnchor(props2));
});
function createPopoverStore({ popover: otherPopover, ...props2 } = {}) {
  const store2 = mergeStore(props2.store, omit(otherPopover, [
    "arrowElement",
    "anchorElement",
    "contentElement",
    "popoverElement",
    "disclosureElement"
  ]));
  throwOnConflictingProps(props2, store2);
  const syncState = store2?.getState();
  const dialog = createDialogStore({
    ...props2,
    store: store2
  });
  const placement = defaultValue(props2.placement, syncState?.placement, "bottom");
  const popover = createStore({
    ...dialog.getState(),
    placement,
    currentPlacement: placement,
    anchorElement: defaultValue(syncState?.anchorElement, null),
    popoverElement: defaultValue(syncState?.popoverElement, null),
    arrowElement: defaultValue(syncState?.arrowElement, null),
    rendered: /* @__PURE__ */ Symbol("rendered")
  }, dialog, store2);
  return {
    ...dialog,
    ...popover,
    setAnchorElement: (element2) => popover.setState("anchorElement", element2),
    setPopoverElement: (element2) => popover.setState("popoverElement", element2),
    setArrowElement: (element2) => popover.setState("arrowElement", element2),
    render: () => popover.setState("rendered", /* @__PURE__ */ Symbol("rendered"))
  };
}
function usePopoverStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.popover]);
  useStoreProps(store2, props2, "placement");
  return useDialogStoreProps(store2, update, props2);
}
function usePopoverStore(props2 = {}) {
  const [store2, update] = useStore(createPopoverStore, props2);
  return usePopoverStoreProps(store2, update, props2);
}
function createHovercardStore(props2 = {}) {
  const syncState = props2.store?.getState();
  const popover = createPopoverStore({
    ...props2,
    placement: defaultValue(props2.placement, syncState?.placement, "bottom")
  });
  const timeout = defaultValue(props2.timeout, syncState?.timeout, 500);
  const hovercard = createStore({
    ...popover.getState(),
    timeout,
    showTimeout: defaultValue(props2.showTimeout, syncState?.showTimeout),
    hideTimeout: defaultValue(props2.hideTimeout, syncState?.hideTimeout),
    autoFocusOnShow: defaultValue(syncState?.autoFocusOnShow, false)
  }, popover, props2.store);
  return {
    ...popover,
    ...hovercard,
    setAutoFocusOnShow: (value) => hovercard.setState("autoFocusOnShow", value)
  };
}
function useHovercardStoreProps(store2, update, props2) {
  useStoreProps(store2, props2, "timeout");
  useStoreProps(store2, props2, "showTimeout");
  useStoreProps(store2, props2, "hideTimeout");
  return usePopoverStoreProps(store2, update, props2);
}
const menubar = createStoreContext([CompositeContextProvider], [CompositeScopedContextProvider]);
const useMenubarContext = menubar.useContext;
const useMenubarScopedContext = menubar.useScopedContext;
const TagName$j = "div";
const usePopoverAnchor = createHook(function usePopoverAnchor2({ store: store2, ...props2 }) {
  const context = usePopoverProviderContext();
  store2 = store2 || context;
  props2 = {
    ...props2,
    ref: useMergeRefs(store2?.setAnchorElement, props2.ref)
  };
  return props2;
});
const PopoverAnchor = forwardRef(function PopoverAnchor2(props2) {
  return createElement(TagName$j, usePopoverAnchor(props2));
});
const TagName$i = "button";
const useButton = createHook(function useButton3(props2) {
  const ref = useRef(null);
  const tagName = useTagName(ref, TagName$i);
  const [isNativeButton, setIsNativeButton] = useState(() => !!tagName && isButton({
    tagName,
    type: props2.type
  }));
  useEffect(() => {
    if (!ref.current) return;
    setIsNativeButton(isButton(ref.current));
  }, []);
  props2 = {
    role: !isNativeButton && tagName !== "a" ? "button" : void 0,
    ...props2,
    ref: useMergeRefs(ref, props2.ref)
  };
  props2 = useCommand(props2);
  return props2;
});
const Button = forwardRef(function Button4(props2) {
  return createElement(TagName$i, useButton(props2));
});
const TagName$h = "button";
const symbol$1 = /* @__PURE__ */ Symbol("disclosure");
const useDisclosure = createHook(function useDisclosure2({ store: store2, toggleOnClick = true, ...props2 }) {
  const context = useDisclosureProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Disclosure must receive a `store` prop or be wrapped in a DisclosureProvider component.");
  const ref = useRef(null);
  const [expanded, setExpanded] = useState(false);
  const disclosureElement = useStoreState(store2, "disclosureElement");
  const open = useStoreState(store2, "open");
  useEffect(() => {
    let isCurrentDisclosure = disclosureElement === ref.current;
    if (!disclosureElement?.isConnected) {
      store2?.setDisclosureElement(ref.current);
      isCurrentDisclosure = true;
    }
    setExpanded(open && isCurrentDisclosure);
  }, [
    disclosureElement,
    store2,
    open
  ]);
  const onClickProp = props2.onClick;
  const toggleOnClickProp = useBooleanEvent(toggleOnClick);
  const [isDuplicate, metadataProps] = useMetadataProps(props2, symbol$1, true);
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (isDuplicate) return;
    if (!toggleOnClickProp(event)) return;
    store2?.setDisclosureElement(event.currentTarget);
    store2?.toggle();
  });
  props2 = {
    "aria-expanded": expanded,
    "aria-controls": useStoreState(store2, "contentElement")?.id,
    ...metadataProps,
    ...props2,
    ref: useMergeRefs(ref, props2.ref),
    onClick
  };
  props2 = useButton(props2);
  return props2;
});
forwardRef(function Disclosure(props2) {
  return createElement(TagName$h, useDisclosure(props2));
});
const TagName$g = "button";
const useDialogDisclosure = createHook(function useDialogDisclosure2({ store: store2, ...props2 }) {
  const context = useDialogProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "DialogDisclosure must receive a `store` prop or be wrapped in a DialogProvider component.");
  props2 = {
    "aria-haspopup": getPopupRole(useStoreState(store2, "contentElement"), "dialog"),
    ...props2
  };
  props2 = useDisclosure({
    store: store2,
    ...props2
  });
  return props2;
});
forwardRef(function DialogDisclosure(props2) {
  return createElement(TagName$g, useDialogDisclosure(props2));
});
const TagName$f = "button";
const usePopoverDisclosure = createHook(function usePopoverDisclosure2({ store: store2, ...props2 }) {
  const context = usePopoverProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "PopoverDisclosure must receive a `store` prop or be wrapped in a PopoverProvider component.");
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    store2?.setAnchorElement(event.currentTarget);
    onClickProp?.(event);
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(PopoverScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  props2 = {
    ...props2,
    onClick
  };
  props2 = usePopoverAnchor({
    store: store2,
    ...props2
  });
  props2 = useDialogDisclosure({
    store: store2,
    ...props2
  });
  return props2;
});
const PopoverDisclosure = forwardRef(function PopoverDisclosure2(props2) {
  return createElement(TagName$f, usePopoverDisclosure(props2));
});
const TagName$e = "span";
const pointsMap = {
  top: "4,10 8,6 12,10",
  right: "6,4 10,8 6,12",
  bottom: "4,6 8,10 12,6",
  left: "10,4 6,8 10,12"
};
const usePopoverDisclosureArrow = createHook(function usePopoverDisclosureArrow2({ store: store2, placement, ...props2 }) {
  const context = usePopoverContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "PopoverDisclosureArrow must be wrapped in a PopoverDisclosure component.");
  const points = pointsMap[getBasePlacement(useStoreState(store2, (state) => placement || state.placement))];
  props2 = {
    children: useMemo(() => /* @__PURE__ */ jsxRuntimeExports$3.jsx("svg", {
      display: "block",
      fill: "none",
      stroke: "currentColor",
      strokeLinecap: "round",
      strokeLinejoin: "round",
      strokeWidth: 1.5,
      viewBox: "0 0 16 16",
      height: "1em",
      width: "1em",
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("polyline", { points })
    }), [points]),
    "aria-hidden": true,
    ...props2,
    style: {
      width: "1em",
      height: "1em",
      pointerEvents: "none",
      ...props2.style
    }
  };
  return removeUndefinedValues(props2);
});
forwardRef(function PopoverDisclosureArrow(props2) {
  return createElement(TagName$e, usePopoverDisclosureArrow(props2));
});
const TagName$d = "div";
const typeaheadStates = /* @__PURE__ */ new WeakMap();
function getTypeaheadState(store2) {
  let typeaheadState = typeaheadStates.get(store2);
  if (!typeaheadState) {
    typeaheadState = {
      chars: "",
      cleanupTimeout: 0
    };
    typeaheadStates.set(store2, typeaheadState);
  }
  return typeaheadState;
}
function clearChars(typeaheadState) {
  typeaheadState.chars = "";
}
function isValidTypeaheadEvent(event, typeaheadState) {
  const target = event.target;
  if (target && isTextField(target)) return false;
  if (event.key === " " && typeaheadState.chars.length) return true;
  return event.key.length === 1 && !event.ctrlKey && !event.altKey && !event.metaKey && /^[\p{Letter}\p{Number}]$/u.test(event.key);
}
function isSelfTargetOrItem(event, items) {
  if (isSelfTarget(event)) return true;
  const target = event.target;
  if (!target) return false;
  return items.some((item) => item.element === target);
}
function getEnabledItems(items) {
  return items.filter((item) => !item.disabled);
}
function itemTextStartsWith(item, text2) {
  const itemText = item.element?.textContent || item.children || "value" in item && item.value;
  if (!itemText) return false;
  return normalizeString(itemText).trim().toLowerCase().startsWith(text2.toLowerCase());
}
function getSameInitialItems({ activeId, char, items, typeaheadState }) {
  if (!activeId) return items;
  const activeItem = items.find((item) => item.id === activeId);
  if (!activeItem) return items;
  if (!itemTextStartsWith(activeItem, char)) return items;
  const { chars } = typeaheadState;
  if (chars !== char && itemTextStartsWith(activeItem, chars)) return items;
  typeaheadState.chars = char;
  return flipItems(items.filter((item) => itemTextStartsWith(item, char)), activeId).filter((item) => item.id !== activeId);
}
const useCompositeTypeahead = createHook(function useCompositeTypeahead2({ store: store2, typeahead = true, ...props2 }) {
  const context = useCompositeScopedContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "CompositeTypeahead must be a Composite component");
  const onKeyDownCaptureProp = props2.onKeyDownCapture;
  const onKeyDownCapture = useEvent((event) => {
    onKeyDownCaptureProp?.(event);
    if (event.defaultPrevented) return;
    if (!typeahead) return;
    if (!store2) return;
    const typeaheadState = getTypeaheadState(store2);
    if (!isValidTypeaheadEvent(event, typeaheadState)) return clearChars(typeaheadState);
    const { renderedItems, items, activeId, id: id2 } = store2.getState();
    let enabledItems = getEnabledItems(items.length > renderedItems.length ? items : renderedItems);
    const document2 = getDocument(event.currentTarget);
    const selector2 = `[data-offscreen-id="${id2}"]`;
    const offscreenItems = document2.querySelectorAll(selector2);
    for (const element2 of offscreenItems) {
      if (element2.hasAttribute("data-disabled")) continue;
      if ("disabled" in element2 && !!element2.disabled) continue;
      enabledItems.push({
        id: element2.id,
        element: element2
      });
    }
    if (offscreenItems.length) enabledItems = sortBasedOnDOMPosition(enabledItems, (i2) => i2.element);
    if (!isSelfTargetOrItem(event, enabledItems)) return clearChars(typeaheadState);
    event.preventDefault();
    window.clearTimeout(typeaheadState.cleanupTimeout);
    typeaheadState.cleanupTimeout = window.setTimeout(() => {
      clearChars(typeaheadState);
    }, 500);
    const char = event.key.toLowerCase();
    typeaheadState.chars += char;
    enabledItems = getSameInitialItems({
      activeId,
      char,
      items: enabledItems,
      typeaheadState
    });
    const item = enabledItems.find((item2) => itemTextStartsWith(item2, typeaheadState.chars));
    if (item) store2.move(item.id);
    else clearChars(typeaheadState);
  });
  props2 = {
    ...props2,
    onKeyDownCapture
  };
  return removeUndefinedValues(props2);
});
forwardRef(function CompositeTypeahead(props2) {
  return createElement(TagName$d, useCompositeTypeahead(props2));
});
const TagName$c = "span";
const useSelectArrow = createHook(function useSelectArrow2({ store: store2, ...props2 }) {
  const context = useSelectContext();
  store2 = store2 || context;
  props2 = usePopoverDisclosureArrow({
    store: store2,
    ...props2
  });
  return props2;
});
const SelectArrow = forwardRef(function SelectArrow2(props2) {
  return createElement(TagName$c, useSelectArrow(props2));
});
const TagName$b = "button";
function getSelectedValues(select) {
  return Array.from(select.selectedOptions).map((option) => option.value);
}
function nextWithValue(store2, next) {
  return () => {
    const visitedIds = /* @__PURE__ */ new Set();
    let nextId = next();
    while (nextId) {
      const nextItem = store2.item(nextId);
      if (!nextItem) return;
      if (nextItem.value != null) return nextItem.id;
      if (visitedIds.has(nextId)) return;
      visitedIds.add(nextId);
      nextId = next({ activeId: nextId });
    }
  };
}
const useSelect = createHook(function useSelect2({ store: store2, name: name2, form, required, showOnKeyDown = true, moveOnKeyDown = true, toggleOnPress = true, toggleOnClick = toggleOnPress, ...props2 }) {
  const context = useSelectProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Select must receive a `store` prop or be wrapped in a SelectProvider component.");
  const onKeyDownProp = props2.onKeyDown;
  const showOnKeyDownProp = useBooleanEvent(showOnKeyDown);
  const moveOnKeyDownProp = useBooleanEvent(moveOnKeyDown);
  const dir = getBasePlacement(useStoreState(store2, "placement"));
  const value = useStoreState(store2, "value");
  const multiSelectable = Array.isArray(value);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { orientation, items: items2, activeId } = store2.getState();
    const isVertical = orientation !== "horizontal";
    const isHorizontal = orientation !== "vertical";
    const isGrid2 = !!items2.find((item) => !item.disabled && item.value != null)?.rowId;
    const getId = {
      ArrowUp: (isGrid2 || isVertical) && nextWithValue(store2, store2.up),
      ArrowRight: (isGrid2 || isHorizontal) && nextWithValue(store2, store2.next),
      ArrowDown: (isGrid2 || isVertical) && nextWithValue(store2, store2.down),
      ArrowLeft: (isGrid2 || isHorizontal) && nextWithValue(store2, store2.previous)
    }[event.key];
    if (getId && moveOnKeyDownProp(event)) {
      event.preventDefault();
      store2.move(getId());
    }
    const isTopOrBottom = dir === "top" || dir === "bottom";
    if ({
      ArrowDown: isTopOrBottom,
      ArrowUp: isTopOrBottom,
      ArrowLeft: dir === "left",
      ArrowRight: dir === "right"
    }[event.key] && showOnKeyDownProp(event)) {
      event.preventDefault();
      store2.move(activeId);
      queueBeforeEvent(event.currentTarget, "keyup", store2.show);
    }
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  const [autofill, setAutofill] = useState(false);
  const nativeSelectChangedRef = useRef(false);
  useEffect(() => {
    const nativeSelectChanged = nativeSelectChangedRef.current;
    nativeSelectChangedRef.current = false;
    if (nativeSelectChanged) return;
    setAutofill(false);
  }, [value]);
  const labelId = useStoreState(store2, (state) => state.labelElement?.id);
  const label2 = props2["aria-label"];
  const labelledBy = props2["aria-labelledby"] || labelId;
  const items = useStoreState(store2, (state) => {
    if (!name2) return;
    return state.items;
  });
  const values2 = useMemo(() => {
    const itemValues = items?.flatMap((item) => item.value ?? []);
    return [...new Set(itemValues)];
  }, [items]);
  props2 = useWrapElement(props2, (element2) => {
    if (!name2) return element2;
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [/* @__PURE__ */ jsxRuntimeExports$3.jsxs("select", {
      style: getVisuallyHiddenStyle(),
      tabIndex: -1,
      "aria-hidden": true,
      "aria-label": label2,
      "aria-labelledby": label2 != null ? void 0 : labelledBy,
      name: name2,
      form,
      required,
      disabled: props2.disabled,
      value,
      multiple: multiSelectable,
      onFocus: () => store2?.getState().selectElement?.focus(),
      onChange: (event) => {
        nativeSelectChangedRef.current = true;
        setAutofill(true);
        store2?.setValue(multiSelectable ? getSelectedValues(event.target) : event.target.value);
      },
      children: [toArray(value).map((value2) => {
        if (value2 == null) return null;
        if (values2.includes(value2)) return null;
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx("option", {
          value: value2,
          children: value2
        }, value2);
      }), values2.map((value2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx("option", {
        value: value2,
        children: value2
      }, value2))]
    }), element2] });
  }, [
    store2,
    label2,
    labelledBy,
    name2,
    form,
    required,
    value,
    multiSelectable,
    values2,
    props2.disabled
  ]);
  const children = /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [value, /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectArrow, {})] });
  const contentElement = useStoreState(store2, "contentElement");
  props2 = {
    role: "combobox",
    "aria-autocomplete": "none",
    "aria-labelledby": props2["aria-label"] != null ? void 0 : labelId,
    "aria-haspopup": getPopupRole(contentElement, "listbox"),
    "data-autofill": autofill || void 0,
    "data-name": name2,
    children,
    ...props2,
    ref: useMergeRefs(store2.setSelectElement, props2.ref),
    onKeyDown
  };
  props2 = usePopoverDisclosure({
    store: store2,
    toggleOnClick,
    ...props2
  });
  props2 = useCompositeTypeahead({
    store: store2,
    ...props2
  });
  return props2;
});
const Select = forwardRef(function Select2(props2) {
  return createElement(TagName$b, useSelect(props2));
});
const TagName$a = "div";
function hoveringInside(event) {
  const nextElement = event.relatedTarget;
  if (!isElement$2(nextElement)) return false;
  return contains(event.currentTarget, nextElement);
}
const symbol = /* @__PURE__ */ Symbol("composite-hover");
function movingToAnotherItem(event) {
  const { relatedTarget } = event;
  if (!isElement$2(relatedTarget)) return false;
  let dest = relatedTarget;
  do {
    if (hasOwnProperty$2(dest, symbol) && dest[symbol]) return true;
    dest = dest.parentElement;
  } while (dest);
  return false;
}
const useCompositeHover = createHook(function useCompositeHover2({ store: store2, focusOnHover = true, blurOnHoverEnd = !!focusOnHover, ...props2 }) {
  const context = useCompositeScopedContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "CompositeHover must be wrapped in a Composite component.");
  const isMouseMoving = useIsMouseMoving();
  const onMouseMoveProp = props2.onMouseMove;
  const focusOnHoverProp = useBooleanEvent(focusOnHover);
  const onMouseMove = useEvent((event) => {
    onMouseMoveProp?.(event);
    if (event.defaultPrevented) return;
    if (!isMouseMoving()) return;
    if (!focusOnHoverProp(event)) return;
    if (!hasFocusWithin(event.currentTarget)) {
      const baseElement = store2?.getState().baseElement;
      if (baseElement && !hasFocus(baseElement)) baseElement.focus();
    }
    store2?.setActiveId(event.currentTarget.id);
  });
  const onMouseLeaveProp = props2.onMouseLeave;
  const blurOnHoverEndProp = useBooleanEvent(blurOnHoverEnd);
  const onMouseLeave = useEvent((event) => {
    onMouseLeaveProp?.(event);
    if (event.defaultPrevented) return;
    if (!isMouseMoving()) return;
    if (hoveringInside(event)) return;
    if (movingToAnotherItem(event)) return;
    if (!focusOnHoverProp(event)) return;
    if (!blurOnHoverEndProp(event)) return;
    store2?.setActiveId(null);
    store2?.getState().baseElement?.focus();
  });
  const ref = useCallback((element2) => {
    if (!element2) return;
    element2[symbol] = true;
  }, []);
  props2 = {
    ...props2,
    ref: useMergeRefs(ref, props2.ref),
    onMouseMove,
    onMouseLeave
  };
  return removeUndefinedValues(props2);
});
memo(forwardRef(function CompositeHover(props2) {
  return createElement(TagName$a, useCompositeHover(props2));
}));
const TagName$9 = "div";
function isSelected$1(storeValue, itemValue) {
  if (itemValue == null) return;
  if (storeValue == null) return false;
  if (Array.isArray(storeValue)) return storeValue.includes(itemValue);
  return storeValue === itemValue;
}
const useSelectItem = createHook(function useSelectItem2({ store: store2, value, getItem: getItemProp, hideOnClick, setValueOnClick = value != null, preventScrollOnKeyDown = true, focusOnHover = true, ...props2 }) {
  const context = useSelectScopedContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "SelectItem must be wrapped in a SelectList or SelectPopover component.");
  const id2 = useId(props2.id);
  const disabled = disabledFromProps(props2);
  const { listElement, multiSelectable, selected, autoFocus } = useStoreStateObject(store2, {
    listElement: "listElement",
    multiSelectable(state) {
      return Array.isArray(state.value);
    },
    selected(state) {
      return isSelected$1(state.value, value);
    },
    autoFocus(state) {
      if (value == null) return false;
      if (state.value == null) return false;
      if (state.activeId !== id2 && store2?.item(state.activeId)) return false;
      if (Array.isArray(state.value)) return state.value[state.value.length - 1] === value;
      return state.value === value;
    }
  });
  const virtualFocus = useStoreState(store2?.combobox, "virtualFocus");
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      value: disabled ? void 0 : value
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [
    disabled,
    value,
    getItemProp
  ]);
  hideOnClick = hideOnClick ?? (value != null && !multiSelectable);
  const onClickProp = props2.onClick;
  const setValueOnClickProp = useBooleanEvent(setValueOnClick);
  const hideOnClickProp = useBooleanEvent(hideOnClick);
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (isDownloading(event)) return;
    if (isOpeningInNewTab(event)) return;
    if (setValueOnClickProp(event) && value != null) store2?.setValue((prevValue) => {
      if (!Array.isArray(prevValue)) return value;
      if (prevValue.includes(value)) return prevValue.filter((v2) => v2 !== value);
      return [...prevValue, value];
    });
    if (hideOnClickProp(event)) store2?.hide();
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectItemCheckedContext.Provider, {
    value: selected ?? false,
    children: element2
  }), [selected]);
  const shouldAutoFocus = props2.autoFocus ?? autoFocus;
  props2 = {
    role: getPopupItemRole(listElement),
    "aria-selected": selected,
    children: value,
    ...props2,
    id: id2,
    autoFocus: virtualFocus === false ? false : shouldAutoFocus,
    "data-autofocus": shouldAutoFocus || void 0,
    onClick
  };
  props2 = useCompositeItem({
    store: store2,
    getItem,
    preventScrollOnKeyDown,
    ...props2
  });
  const focusOnHoverProp = useBooleanEvent(focusOnHover);
  props2 = useCompositeHover({
    store: store2,
    ...props2,
    focusOnHover(event) {
      if (!focusOnHoverProp(event)) return false;
      return store2.getState().open;
    }
  });
  return props2;
});
const SelectItem = memo(forwardRef(function SelectItem2(props2) {
  return createElement(TagName$9, useSelectItem(props2));
}));
const TagName$8 = "div";
const SelectListContext = createContext(null);
const useSelectList = createHook(function useSelectList2({ store: store2, resetOnEscape = true, hideOnEnter = true, composite, alwaysVisible, ...props2 }) {
  const context = useSelectContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "SelectList must receive a `store` prop or be wrapped in a SelectProvider component.");
  const id2 = useId(props2.id);
  const value = useStoreState(store2, "value");
  const multiSelectable = Array.isArray(value);
  const [defaultValue2, setDefaultValue] = useState(value);
  const mounted = useStoreState(store2, "mounted");
  useEffect(() => {
    if (mounted) return;
    setDefaultValue(value);
  }, [mounted, value]);
  resetOnEscape = resetOnEscape && !multiSelectable;
  const onKeyDownProp = props2.onKeyDown;
  const resetOnEscapeProp = useBooleanEvent(resetOnEscape);
  const hideOnEnterProp = useBooleanEvent(hideOnEnter);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (event.key === "Escape" && resetOnEscapeProp(event)) store2?.setValue(defaultValue2);
    if (event.key === " " || event.key === "Enter") {
      if (isSelfTarget(event) && hideOnEnterProp(event)) {
        event.preventDefault();
        store2?.hide();
      }
    }
  });
  const headingContext = useContext(SelectHeadingContext);
  const headingState = useState();
  const [headingId, setHeadingId] = headingContext || headingState;
  const headingContextValue = useMemo(() => [headingId, setHeadingId], [headingId, setHeadingId]);
  const [childStore, setChildStore] = useState(null);
  const setStore = useContext(SelectListContext);
  useEffect(() => {
    if (!setStore) return;
    setStore(store2);
    return () => setStore(null);
  }, [setStore, store2]);
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectScopedContextProvider, {
    value: store2,
    children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectListContext.Provider, {
      value: setChildStore,
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectHeadingContext.Provider, {
        value: headingContextValue,
        children: element2
      })
    })
  }), [store2, headingContextValue]);
  const hasCombobox = !!store2.combobox;
  composite = composite ?? (!hasCombobox && childStore !== store2);
  const [, setElement] = useTransactionState(composite ? store2.setListElement : null);
  const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
  const style = hidden ? {
    ...props2.style,
    display: "none"
  } : props2.style;
  if (composite) props2 = {
    role: "listbox",
    "aria-multiselectable": multiSelectable || void 0,
    ...props2
  };
  const labelId = useStoreState(store2, (state) => headingId || state.labelElement?.id);
  props2 = {
    "aria-labelledby": props2["aria-label"] != null ? void 0 : labelId,
    hidden,
    ...props2,
    id: id2,
    ref: useMergeRefs(setElement, props2.ref),
    style,
    onKeyDown
  };
  props2 = useComposite({
    store: store2,
    ...props2,
    composite
  });
  props2 = useCompositeTypeahead({
    store: store2,
    typeahead: !hasCombobox,
    ...props2
  });
  return props2;
});
forwardRef(function SelectList(props2) {
  return createElement(TagName$8, useSelectList(props2));
});
const TagName$7 = "div";
const useSelectPopover = createHook(function useSelectPopover2({ store: store2, alwaysVisible, ...props2 }) {
  const context = useSelectProviderContext();
  store2 = store2 || context;
  props2 = useSelectList({
    store: store2,
    alwaysVisible,
    ...props2
  });
  props2 = usePopover({
    store: store2,
    alwaysVisible,
    ...props2
  });
  return props2;
});
const SelectPopover = createDialogComponent(forwardRef(function SelectPopover2(props2) {
  return createElement(TagName$7, useSelectPopover(props2));
}), useSelectProviderContext);
function createSelectStore({ combobox, ...props2 } = {}) {
  const store2 = mergeStore(props2.store, omit(combobox, [
    "value",
    "items",
    "renderedItems",
    "baseElement",
    "arrowElement",
    "anchorElement",
    "contentElement",
    "popoverElement",
    "disclosureElement"
  ]));
  throwOnConflictingProps(props2, store2);
  const syncState = store2.getState();
  const composite = createCompositeStore({
    ...props2,
    store: store2,
    virtualFocus: defaultValue(props2.virtualFocus, syncState.virtualFocus, true),
    includesBaseElement: defaultValue(props2.includesBaseElement, syncState.includesBaseElement, false),
    activeId: defaultValue(props2.activeId, syncState.activeId, props2.defaultActiveId, null),
    orientation: defaultValue(props2.orientation, syncState.orientation, "vertical")
  });
  const popover = createPopoverStore({
    ...props2,
    store: store2,
    placement: defaultValue(props2.placement, syncState.placement, "bottom-start")
  });
  const initialValue = /* @__PURE__ */ new String("");
  const initialState2 = {
    ...composite.getState(),
    ...popover.getState(),
    value: defaultValue(props2.value, syncState.value, props2.defaultValue, initialValue),
    setValueOnMove: defaultValue(props2.setValueOnMove, syncState.setValueOnMove, false),
    labelElement: defaultValue(syncState.labelElement, null),
    selectElement: defaultValue(syncState.selectElement, null),
    listElement: defaultValue(syncState.listElement, null)
  };
  const select = createStore(initialState2, composite, popover, store2);
  setup(select, () => sync(select, ["value", "items"], (state) => {
    if (state.value !== initialValue) return;
    if (!state.items.length) return;
    const item = state.items.find((item2) => !item2.disabled && item2.value != null);
    if (item?.value == null) return;
    select.setState("value", item.value);
  }));
  setup(select, () => sync(select, ["mounted"], (state) => {
    if (state.mounted) return;
    select.setState("activeId", initialState2.activeId);
  }));
  setup(select, () => sync(select, [
    "mounted",
    "items",
    "value"
  ], (state) => {
    if (combobox) return;
    if (state.mounted) return;
    const values2 = toArray(state.value);
    const lastValue = values2[values2.length - 1];
    if (lastValue == null) return;
    const item = state.items.find((item2) => !item2.disabled && item2.value === lastValue);
    if (!item) return;
    select.setState("activeId", item.id);
  }));
  setup(select, () => batch(select, ["setValueOnMove", "moves"], (state) => {
    const { mounted, value, activeId } = select.getState();
    if (!state.setValueOnMove && mounted) return;
    if (Array.isArray(value)) return;
    if (!state.moves) return;
    if (!activeId) return;
    const item = composite.item(activeId);
    if (!item || item.disabled || item.value == null) return;
    select.setState("value", item.value);
  }));
  return {
    ...composite,
    ...popover,
    ...select,
    combobox,
    setValue: (value) => select.setState("value", value),
    setLabelElement: (element2) => select.setState("labelElement", element2),
    setSelectElement: (element2) => select.setState("selectElement", element2),
    setListElement: (element2) => select.setState("listElement", element2)
  };
}
function useSelectStoreOptions(props2) {
  const combobox = useComboboxProviderContext();
  props2 = {
    ...props2,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  return useCompositeStoreOptions(props2);
}
function useSelectStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.combobox]);
  useStoreProps(store2, props2, "value", "setValue");
  useStoreProps(store2, props2, "setValueOnMove");
  return Object.assign(usePopoverStoreProps(useCompositeStoreProps(store2, update, props2), update, props2), { combobox: props2.combobox });
}
function useSelectStore(props2 = {}) {
  props2 = useSelectStoreOptions(props2);
  const [store2, update] = useStore(createSelectStore, props2);
  return useSelectStoreProps(store2, update, props2);
}
function SelectProvider(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(SelectContextProvider, {
    value: useSelectStore(props2),
    children: props2.children
  });
}
const menu = createStoreContext([CompositeContextProvider, HovercardContextProvider], [CompositeScopedContextProvider, HovercardScopedContextProvider]);
const useMenuContext = menu.useContext;
const useMenuScopedContext = menu.useScopedContext;
const useMenuProviderContext = menu.useProviderContext;
const MenuContextProvider = menu.ContextProvider;
const MenuScopedContextProvider = menu.ScopedContextProvider;
createContext(void 0);
const MenuListHiddenContext = createContext(false);
const TagName$6 = "div";
function useAriaLabelledBy({ store: store2, ...props2 }) {
  const [id2, setId] = useState(void 0);
  const label2 = props2["aria-label"];
  const disclosureElement = useStoreState(store2, "disclosureElement");
  const contentElement = useStoreState(store2, "contentElement");
  useEffect(() => {
    const disclosure = disclosureElement;
    if (!disclosure) return;
    const menu2 = contentElement;
    if (!menu2) return;
    if (label2 || menu2.hasAttribute("aria-label")) setId(void 0);
    else if (disclosure.id) setId(disclosure.id);
  }, [
    label2,
    disclosureElement,
    contentElement
  ]);
  return id2;
}
const useMenuList = createHook(function useMenuList2({ store: store2, alwaysVisible, composite, ...props2 }) {
  const context = useMenuProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "MenuList must receive a `store` prop or be wrapped in a MenuProvider component.");
  const parentMenu = store2.parent;
  const parentMenubar = store2.menubar;
  const hasParentMenu = !!parentMenu;
  const id2 = useId(props2.id);
  const onKeyDownProp = props2.onKeyDown;
  const dir = useStoreState(store2, (state) => getBasePlacement(state.placement));
  const orientation = useStoreState(store2, (state) => state.orientation === "both" ? void 0 : state.orientation);
  const isHorizontal = orientation !== "vertical";
  const isMenubarHorizontal = useStoreState(parentMenubar, (state) => !!state && state.orientation !== "vertical");
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    if (hasParentMenu || parentMenubar && !isHorizontal) {
      const action = {
        ArrowRight: () => dir === "left" && !isHorizontal,
        ArrowLeft: () => dir === "right" && !isHorizontal,
        ArrowUp: () => dir === "bottom" && isHorizontal,
        ArrowDown: () => dir === "top" && isHorizontal
      }[event.key];
      if (action?.()) {
        event.stopPropagation();
        event.preventDefault();
        return store2?.hide();
      }
    }
    if (parentMenubar) {
      const action = {
        ArrowRight: () => {
          if (!isMenubarHorizontal) return;
          return parentMenubar.next();
        },
        ArrowLeft: () => {
          if (!isMenubarHorizontal) return;
          return parentMenubar.previous();
        },
        ArrowDown: () => {
          if (isMenubarHorizontal) return;
          return parentMenubar.next();
        },
        ArrowUp: () => {
          if (isMenubarHorizontal) return;
          return parentMenubar.previous();
        }
      }[event.key];
      const id3 = action?.();
      if (id3 !== void 0) {
        event.stopPropagation();
        event.preventDefault();
        parentMenubar.move(id3);
      }
    }
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(MenuScopedContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  const ariaLabelledBy = useAriaLabelledBy({
    store: store2,
    ...props2
  });
  const hidden = isHidden(useStoreState(store2, "mounted"), props2.hidden, alwaysVisible);
  const style = hidden ? {
    ...props2.style,
    display: "none"
  } : props2.style;
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(MenuListHiddenContext.Provider, {
    value: hidden,
    children: element2
  }), [hidden]);
  props2 = {
    "aria-labelledby": ariaLabelledBy,
    hidden,
    ...props2,
    id: id2,
    ref: useMergeRefs(id2 ? store2.setContentElement : null, props2.ref),
    style,
    onKeyDown
  };
  const hasCombobox = !!store2.combobox;
  composite = composite ?? !hasCombobox;
  if (composite) props2 = {
    role: "menu",
    "aria-orientation": orientation,
    ...props2
  };
  props2 = useComposite({
    store: store2,
    composite,
    ...props2
  });
  props2 = useCompositeTypeahead({
    store: store2,
    typeahead: !hasCombobox,
    ...props2
  });
  return props2;
});
forwardRef(function MenuList(props2) {
  return createElement(TagName$6, useMenuList(props2));
});
const TagName$5 = "div";
const useMenu = createHook(function useMenu2({ store: store2, modal: modalProp = false, portal = modalProp, hideOnEscape = true, autoFocusOnShow = true, hideOnHoverOutside, alwaysVisible, ...props2 }) {
  const context = useMenuProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Menu must receive a `store` prop or be wrapped in a MenuProvider component.");
  const ref = useRef(null);
  const parentMenu = store2.parent;
  const parentMenubar = store2.menubar;
  const hasParentMenu = !!parentMenu;
  const parentIsMenubar = !!parentMenubar && !hasParentMenu;
  const modal = hasParentMenu ? false : modalProp;
  props2 = {
    ...props2,
    ref: useMergeRefs(ref, props2.ref)
  };
  const { "aria-labelledby": ariaLabelledBy, ...menuListProps } = useMenuList({
    store: store2,
    alwaysVisible,
    ...props2
  });
  props2 = menuListProps;
  const [initialFocusRef, setInitialFocusRef] = useState();
  const initialFocusElement = useStoreState(store2, (state) => {
    if (!state.autoFocusOnShow) return;
    const isEnabled = (item) => !item.disabled && !!item.element;
    switch (state.initialFocus) {
      case "first":
        return state.renderedItems.find(isEnabled)?.element || null;
      case "last":
        for (let i2 = state.renderedItems.length - 1; i2 >= 0; i2 -= 1) {
          const item = state.renderedItems[i2];
          if (item && isEnabled(item)) return item.element;
        }
        return null;
      default:
        return state.baseElement;
    }
  });
  useEffect(() => {
    let cleaning = false;
    setInitialFocusRef((prevInitialFocusRef) => {
      if (cleaning) return;
      if (modal && prevInitialFocusRef?.current?.isConnected) return prevInitialFocusRef;
      if (initialFocusElement === void 0) return;
      if (initialFocusElement && initialFocusElement === prevInitialFocusRef?.current) return prevInitialFocusRef;
      const ref2 = createRef();
      ref2.current = initialFocusElement;
      return ref2;
    });
    return () => {
      cleaning = true;
    };
  }, [modal, initialFocusElement]);
  const canAutoFocusOnShow = !!initialFocusRef || !!props2.initialFocus || modal;
  const autoFocusOnShowProp = autoFocusOnShow === false ? false : canAutoFocusOnShow && autoFocusOnShow;
  const contentElement = useStoreState(store2.combobox || store2, "contentElement");
  const parentContentElement = useStoreState(parentMenu?.combobox || parentMenu, "contentElement");
  const preserveTabOrderAnchor = useMemo(() => {
    if (!parentContentElement) return;
    if (!contentElement) return;
    const role = contentElement.getAttribute("role");
    const parentRole = parentContentElement.getAttribute("role");
    if ((parentRole === "menu" || parentRole === "menubar") && role === "menu") return;
    return parentContentElement;
  }, [contentElement, parentContentElement]);
  if (preserveTabOrderAnchor !== void 0) props2 = {
    preserveTabOrderAnchor,
    ...props2
  };
  props2 = useHovercard({
    store: store2,
    alwaysVisible,
    initialFocus: initialFocusRef,
    autoFocusOnShow: autoFocusOnShowProp,
    ...props2,
    hideOnEscape(event) {
      if (isFalsyBooleanCallback(hideOnEscape, event)) return false;
      store2?.hideAll();
      return true;
    },
    hideOnHoverOutside(event) {
      const disclosureElement = store2?.getState().disclosureElement;
      const getHideOnHoverOutside = () => {
        if (typeof hideOnHoverOutside === "function") return hideOnHoverOutside(event);
        if (hideOnHoverOutside != null) return hideOnHoverOutside;
        if (hasParentMenu) return true;
        if (!parentIsMenubar) return false;
        if (!disclosureElement) return true;
        if (hasFocusWithin(disclosureElement)) return false;
        return true;
      };
      if (!getHideOnHoverOutside()) return false;
      if (event.defaultPrevented) return true;
      if (!hasParentMenu) return true;
      if (!disclosureElement) return true;
      fireEvent(disclosureElement, "mouseout", event);
      if (!hasFocusWithin(disclosureElement)) return true;
      requestAnimationFrame(() => {
        if (hasFocusWithin(disclosureElement)) return;
        store2?.hide();
      });
      return false;
    },
    modal,
    portal,
    backdrop: hasParentMenu ? false : props2.backdrop
  });
  props2 = {
    "aria-labelledby": ariaLabelledBy,
    ...props2
  };
  return props2;
});
const Menu = createDialogComponent(forwardRef(function Menu2(props2) {
  return createElement(TagName$5, useMenu(props2));
}), useMenuProviderContext);
const TagName$4 = "button";
function getInitialFocus(event, dir) {
  return {
    ArrowDown: dir === "bottom" || dir === "top" ? "first" : false,
    ArrowUp: dir === "bottom" || dir === "top" ? "last" : false,
    ArrowRight: dir === "right" ? "first" : false,
    ArrowLeft: dir === "left" ? "first" : false
  }[event.key];
}
function hasActiveItem(items, excludeElement) {
  return !!items?.some((item) => {
    if (!item.element) return false;
    if (item.element === excludeElement) return false;
    return item.element.getAttribute("aria-expanded") === "true";
  });
}
const useMenuButton = createHook(function useMenuButton2({ store: store2, focusable, accessibleWhenDisabled, showOnHover, ...props2 }) {
  const context = useMenuProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "MenuButton must receive a `store` prop or be wrapped in a MenuProvider component.");
  const ref = useRef(null);
  const parentMenu = store2.parent;
  const parentMenubar = store2.menubar;
  const hasParentMenu = !!parentMenu;
  const parentIsMenubar = !!parentMenubar && !hasParentMenu;
  const disabled = disabledFromProps(props2);
  const isDisabled = (element2) => disabled || disabledFromElement(element2);
  const showMenu = () => {
    const trigger = ref.current;
    if (!trigger) return;
    store2?.setDisclosureElement(trigger);
    store2?.setAnchorElement(trigger);
    store2?.show();
  };
  const onFocusProp = props2.onFocus;
  const onFocus = useEvent((event) => {
    onFocusProp?.(event);
    if (isDisabled(event.currentTarget)) return;
    if (event.defaultPrevented) return;
    store2?.setAutoFocusOnShow(false);
    store2?.setActiveId(null);
    if (!parentMenubar) return;
    if (!parentIsMenubar) return;
    const { items } = parentMenubar.getState();
    if (hasActiveItem(items, event.currentTarget)) showMenu();
  });
  const dir = useStoreState(store2, (state) => getBasePlacement(state.placement));
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (isDisabled(event.currentTarget)) return;
    if (event.defaultPrevented) return;
    const initialFocus = getInitialFocus(event, dir);
    if (initialFocus) {
      event.preventDefault();
      const { open } = store2.getState();
      if (open) {
        const id3 = initialFocus === "last" ? store2.last() : store2.first();
        store2.move(id3);
        return;
      }
      showMenu();
      store2?.setAutoFocusOnShow(true);
      store2?.setInitialFocus(initialFocus);
    }
  });
  const onClickProp = props2.onClick;
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const isKeyboardClick = !event.detail;
    const { open } = store2.getState();
    if (!open || isKeyboardClick) {
      if (!hasParentMenu || isKeyboardClick) store2.setAutoFocusOnShow(true);
      store2.setInitialFocus(isKeyboardClick ? "first" : "container");
    }
    if (hasParentMenu) showMenu();
  });
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(MenuContextProvider, {
    value: store2,
    children: element2
  }), [store2]);
  if (hasParentMenu) props2 = {
    ...props2,
    render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(Role.div, { render: props2.render })
  };
  const id2 = useId(props2.id);
  const parentContentElement = useStoreState(parentMenu?.combobox || parentMenu, "contentElement");
  props2 = {
    role: hasParentMenu || parentIsMenubar ? getPopupItemRole(parentContentElement, "menuitem") : void 0,
    "aria-haspopup": getPopupRole(useStoreState(store2, "contentElement"), !!store2.combobox ? "dialog" : "menu"),
    ...props2,
    id: id2,
    ref: useMergeRefs(ref, props2.ref),
    onFocus,
    onKeyDown,
    onClick
  };
  props2 = useHovercardAnchor({
    store: store2,
    focusable,
    accessibleWhenDisabled,
    ...props2,
    showOnHover: (event) => {
      const getShowOnHover = () => {
        if (typeof showOnHover === "function") return showOnHover(event);
        if (showOnHover != null) return showOnHover;
        if (hasParentMenu) return true;
        if (!parentMenubar) return false;
        const { items } = parentMenubar.getState();
        return parentIsMenubar && hasActiveItem(items);
      };
      if (!getShowOnHover()) return false;
      const parent = parentIsMenubar ? parentMenubar : parentMenu;
      if (!parent) return true;
      parent.setActiveId(event.currentTarget.id);
      return true;
    }
  });
  props2 = usePopoverDisclosure({
    store: store2,
    toggleOnClick: !hasParentMenu,
    focusable,
    accessibleWhenDisabled,
    ...props2
  });
  props2 = useCompositeTypeahead({
    store: store2,
    typeahead: parentIsMenubar,
    ...props2
  });
  return props2;
});
const MenuButton = forwardRef(function MenuButton2(props2) {
  return createElement(TagName$4, useMenuButton(props2));
});
const TagName$3 = "div";
function menuHasFocus(baseElement, items, currentTarget) {
  if (!baseElement) return false;
  if (hasFocusWithin(baseElement)) return true;
  const expandedMenuId = items?.find((item) => {
    if (item.element === currentTarget) return false;
    return item.element?.getAttribute("aria-expanded") === "true";
  })?.element?.getAttribute("aria-controls");
  if (!expandedMenuId) return false;
  const expandedMenu = getDocument(baseElement).getElementById(expandedMenuId);
  if (!expandedMenu) return false;
  if (hasFocusWithin(expandedMenu)) return true;
  return !!expandedMenu.querySelector("[role=menuitem][aria-expanded=true]");
}
const useMenuItem = createHook(function useMenuItem2({ store: store2, hideOnClick = true, preventScrollOnKeyDown = true, focusOnHover, blurOnHoverEnd, ...props2 }) {
  const menuContext = useMenuScopedContext(true);
  const menubarContext = useMenubarScopedContext();
  store2 = store2 || menuContext || menubarContext;
  invariant(store2, process.env.NODE_ENV !== "production" && "MenuItem must be wrapped in a MenuList, Menu or Menubar component");
  const onClickProp = props2.onClick;
  const hideOnClickProp = useBooleanEvent(hideOnClick);
  const hideMenu = "hideAll" in store2 ? store2.hideAll : void 0;
  const isWithinMenu = !!hideMenu;
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (isDownloading(event)) return;
    if (isOpeningInNewTab(event)) return;
    if (!hideMenu) return;
    const popupType = event.currentTarget.getAttribute("aria-haspopup");
    if (popupType && popupType !== "false") return;
    if (!hideOnClickProp(event)) return;
    hideMenu();
  });
  const contentElement = useStoreState(store2, (state) => "contentElement" in state ? state.contentElement : null);
  const menuListHidden = useContext(MenuListHiddenContext);
  props2 = {
    role: getPopupItemRole(contentElement, "menuitem"),
    ...props2,
    onClick
  };
  props2 = useCompositeItem({
    store: store2,
    preventScrollOnKeyDown,
    ...props2,
    shouldRegisterItem: menuListHidden ? false : props2.shouldRegisterItem
  });
  props2 = useCompositeHover({
    store: store2,
    ...props2,
    focusOnHover(event) {
      const getFocusOnHover = () => {
        if (typeof focusOnHover === "function") return focusOnHover(event);
        if (focusOnHover != null) return focusOnHover;
        return true;
      };
      if (!store2) return false;
      if (!getFocusOnHover()) return false;
      const { baseElement, items } = store2.getState();
      if (isWithinMenu) {
        if (event.currentTarget.hasAttribute("aria-expanded")) event.currentTarget.focus();
        return true;
      }
      if (menuHasFocus(baseElement, items, event.currentTarget)) {
        event.currentTarget.focus();
        return true;
      }
      return false;
    },
    blurOnHoverEnd(event) {
      if (typeof blurOnHoverEnd === "function") return blurOnHoverEnd(event);
      if (blurOnHoverEnd != null) return blurOnHoverEnd;
      return isWithinMenu;
    }
  });
  return props2;
});
const MenuItem = memo(forwardRef(function MenuItem2(props2) {
  return createElement(TagName$3, useMenuItem(props2));
}));
function createMenuStore({ combobox, parent, menubar: menubar2, ...props2 } = {}) {
  const parentIsMenubar = !!menubar2 && !parent;
  const store2 = mergeStore(props2.store, pick(parent, ["values"]), omit(combobox, [
    "arrowElement",
    "anchorElement",
    "contentElement",
    "popoverElement",
    "disclosureElement"
  ]));
  throwOnConflictingProps(props2, store2);
  const syncState = store2.getState();
  const composite = createCompositeStore({
    ...props2,
    store: store2,
    orientation: defaultValue(props2.orientation, syncState.orientation, "vertical")
  });
  const hovercard = createHovercardStore({
    ...props2,
    store: store2,
    placement: defaultValue(props2.placement, syncState.placement, "bottom-start"),
    timeout: defaultValue(props2.timeout, syncState.timeout, parentIsMenubar ? 0 : 150),
    hideTimeout: defaultValue(props2.hideTimeout, syncState.hideTimeout, 0)
  });
  const menu2 = createStore({
    ...composite.getState(),
    ...hovercard.getState(),
    initialFocus: defaultValue(syncState.initialFocus, "container"),
    values: defaultValue(props2.values, syncState.values, props2.defaultValues, {})
  }, composite, hovercard, store2);
  setup(menu2, () => sync(menu2, ["mounted"], (state) => {
    if (state.mounted) return;
    menu2.setState("activeId", null);
  }));
  setup(menu2, () => sync(parent, ["orientation"], (state) => {
    menu2.setState("placement", state.orientation === "vertical" ? "right-start" : "bottom-start");
  }));
  return {
    ...composite,
    ...hovercard,
    ...menu2,
    combobox,
    parent,
    menubar: menubar2,
    hideAll: () => {
      hovercard.hide();
      parent?.hideAll();
    },
    setInitialFocus: (value) => menu2.setState("initialFocus", value),
    setValues: (values2) => menu2.setState("values", values2),
    setValue: (name2, value) => {
      if (name2 === "__proto__") return;
      if (name2 === "constructor") return;
      if (Array.isArray(name2)) return;
      menu2.setState("values", (values2) => {
        const prevValue = values2[name2];
        const nextValue = applyState(value, prevValue);
        if (nextValue === prevValue) return values2;
        return {
          ...values2,
          [name2]: nextValue !== void 0 && nextValue
        };
      });
    }
  };
}
function useMenuStoreProps(store2, update, props2) {
  useUpdateEffect(update, [
    props2.combobox,
    props2.parent,
    props2.menubar
  ]);
  useStoreProps(store2, props2, "values", "setValues");
  return Object.assign(useHovercardStoreProps(useCompositeStoreProps(store2, update, props2), update, props2), {
    combobox: props2.combobox,
    parent: props2.parent,
    menubar: props2.menubar
  });
}
function useMenuStore(props2 = {}) {
  const parent = useMenuContext();
  const menubar2 = useMenubarContext();
  const combobox = useComboboxProviderContext();
  props2 = {
    ...props2,
    parent: props2.parent !== void 0 ? props2.parent : parent,
    menubar: props2.menubar !== void 0 ? props2.menubar : menubar2,
    combobox: props2.combobox !== void 0 ? props2.combobox : combobox
  };
  const [store2, update] = useStore(createMenuStore, props2);
  return useMenuStoreProps(store2, update, props2);
}
function MenuProvider(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(MenuContextProvider, {
    value: useMenuStore(props2),
    children: props2.children
  });
}
const TagName$2 = "input";
function isFirstItemAutoSelected(items, activeValue, autoSelect) {
  if (!autoSelect) return false;
  return items.find((item) => !item.disabled && item.value)?.value === activeValue;
}
function hasCompletionString(value, activeValue) {
  if (!activeValue) return false;
  if (value == null) return false;
  const normalizedValue = normalizeString(value);
  const normalizedActiveValue = normalizeString(activeValue);
  if (normalizedValue.length !== value.length) return false;
  if (normalizedActiveValue.length !== activeValue.length) return false;
  return normalizedActiveValue.length > normalizedValue.length && normalizedActiveValue.toLowerCase().startsWith(normalizedValue.toLowerCase());
}
function isAriaAutoCompleteValue(value) {
  return value === "inline" || value === "list" || value === "both" || value === "none";
}
function getDefaultAutoSelectId(items) {
  return items.find((item) => {
    if (item.disabled) return false;
    return item.element?.getAttribute("role") !== "tab";
  })?.id;
}
const useCombobox = createHook(function useCombobox2({ store: store2, focusable = true, autoSelect: autoSelectProp = false, getAutoSelectId, setValueOnChange, showMinLength = 0, showOnChange, showOnMouseDown, showOnClick = showOnMouseDown, showOnKeyDown, showOnKeyPress = showOnKeyDown, blurActiveItemOnClick, setValueOnClick = true, moveOnKeyPress = true, autoComplete = "list", ...props2 }) {
  const context = useComboboxProviderContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "Combobox must receive a `store` prop or be wrapped in a ComboboxProvider component.");
  const ref = useRef(null);
  const [valueUpdated, forceValueUpdate] = useForceUpdate();
  const canAutoSelectRef = useRef(false);
  const composingRef = useRef(false);
  const autoSelect = useStoreState(store2, (state) => state.virtualFocus && autoSelectProp);
  const inline = autoComplete === "inline" || autoComplete === "both";
  const [canInline, setCanInline] = useState(inline);
  useUpdateLayoutEffect(() => {
    if (!inline) return;
    setCanInline(true);
  }, [inline]);
  const storeValue = useStoreState(store2, "value");
  const prevSelectedValueRef = useRef(void 0);
  useEffect(() => {
    return sync(store2, ["selectedValue", "activeId"], (_2, prev) => {
      prevSelectedValueRef.current = prev.selectedValue;
    });
  }, [store2]);
  const inlineActiveValue = useStoreState(store2, (state) => {
    if (!inline) return;
    if (!canInline) return;
    if (state.activeValue && Array.isArray(state.selectedValue)) {
      if (state.selectedValue.includes(state.activeValue)) return;
      if (prevSelectedValueRef.current?.includes(state.activeValue)) return;
    }
    return state.activeValue;
  });
  const items = useStoreState(store2, "renderedItems");
  const open = useStoreState(store2, "open");
  const contentElement = useStoreState(store2, "contentElement");
  const value = useMemo(() => {
    if (!inline) return storeValue;
    if (!canInline) return storeValue;
    if (isFirstItemAutoSelected(items, inlineActiveValue, autoSelect)) {
      if (hasCompletionString(storeValue, inlineActiveValue)) return storeValue + (inlineActiveValue?.slice(storeValue.length) || "");
      return storeValue;
    }
    return inlineActiveValue || storeValue;
  }, [
    inline,
    canInline,
    items,
    inlineActiveValue,
    autoSelect,
    storeValue
  ]);
  useEffect(() => {
    const element2 = ref.current;
    if (!element2) return;
    const onCompositeItemMove = () => setCanInline(true);
    element2.addEventListener("combobox-item-move", onCompositeItemMove);
    return () => {
      element2.removeEventListener("combobox-item-move", onCompositeItemMove);
    };
  }, []);
  useEffect(() => {
    if (!inline) return;
    if (!canInline) return;
    if (!inlineActiveValue) return;
    if (!isFirstItemAutoSelected(items, inlineActiveValue, autoSelect)) return;
    if (!hasCompletionString(storeValue, inlineActiveValue)) return;
    let cleanup = noop$1;
    queueMicrotask(() => {
      const element2 = ref.current;
      if (!element2) return;
      const { start: prevStart, end: prevEnd } = getTextboxSelection(element2);
      const nextStart = storeValue.length;
      const nextEnd = inlineActiveValue.length;
      setSelectionRange(element2, nextStart, nextEnd);
      cleanup = () => {
        if (!hasFocus(element2)) return;
        const { start, end } = getTextboxSelection(element2);
        if (start !== nextStart) return;
        if (end !== nextEnd) return;
        setSelectionRange(element2, prevStart, prevEnd);
      };
    });
    return () => cleanup();
  }, [
    valueUpdated,
    inline,
    canInline,
    inlineActiveValue,
    items,
    autoSelect,
    storeValue
  ]);
  const getAutoSelectIdProp = useEvent(getAutoSelectId);
  const autoSelectIdRef = useRef(null);
  const autoSelectMovedRef = useRef(void 0);
  const userScrolledRef = useRef(false);
  const isAutoScrollingRef = useRef(false);
  useEffect(() => {
    if (!open) return;
    if (!contentElement) return;
    const scrollingElement = getScrollingElement(contentElement);
    if (!scrollingElement) return;
    const onUserScroll = () => {
      canAutoSelectRef.current = false;
      userScrolledRef.current = true;
    };
    const onScroll = () => {
      if (!isAutoScrollingRef.current) userScrolledRef.current = true;
      if (!store2) return;
      if (!canAutoSelectRef.current) return;
      const { activeId } = store2.getState();
      if (activeId === null) return;
      if (activeId === autoSelectIdRef.current) return;
      canAutoSelectRef.current = false;
    };
    const options2 = {
      passive: true,
      capture: true
    };
    scrollingElement.addEventListener("wheel", onUserScroll, options2);
    scrollingElement.addEventListener("touchmove", onUserScroll, options2);
    scrollingElement.addEventListener("scroll", onScroll, options2);
    return () => {
      scrollingElement.removeEventListener("wheel", onUserScroll, true);
      scrollingElement.removeEventListener("touchmove", onUserScroll, true);
      scrollingElement.removeEventListener("scroll", onScroll, true);
    };
  }, [
    open,
    contentElement,
    store2
  ]);
  useSafeLayoutEffect(() => {
    userScrolledRef.current = false;
    if (!storeValue) return;
    if (composingRef.current) return;
    canAutoSelectRef.current = true;
  }, [storeValue]);
  useSafeLayoutEffect(() => {
    if (autoSelect !== "always" && open) return;
    canAutoSelectRef.current = open;
  }, [autoSelect, open]);
  useSafeLayoutEffect(() => {
    if (open) return;
    autoSelectMovedRef.current = void 0;
  }, [open]);
  const resetValueOnSelect = useStoreState(store2, "resetValueOnSelect");
  useUpdateEffect(() => {
    const canAutoSelect = canAutoSelectRef.current;
    if (!store2) return;
    if (!open) return;
    if (!canAutoSelect && (!resetValueOnSelect || userScrolledRef.current)) return;
    const { baseElement, contentElement: contentElement2, activeId } = store2.getState();
    if (baseElement && !hasFocus(baseElement)) return;
    if (contentElement2?.hasAttribute("data-placing")) {
      const observer = new MutationObserver(forceValueUpdate);
      observer.observe(contentElement2, { attributeFilter: ["data-placing"] });
      return () => observer.disconnect();
    }
    if (autoSelect && canAutoSelect) {
      const userAutoSelectId = getAutoSelectIdProp(items);
      const autoSelectId = userAutoSelectId !== void 0 ? userAutoSelectId : getDefaultAutoSelectId(items) ?? store2.first();
      autoSelectIdRef.current = autoSelectId;
      const nextActiveId = autoSelectId ?? null;
      const nextActiveValue = store2.item(nextActiveId)?.value;
      const moved = autoSelectMovedRef.current;
      if (nextActiveId !== activeId || moved?.id !== nextActiveId || moved?.value !== nextActiveValue) {
        autoSelectMovedRef.current = {
          id: nextActiveId,
          value: nextActiveValue
        };
        store2.move(nextActiveId);
      } else store2.setState("activeValue", nextActiveValue);
    } else {
      const element2 = store2.item(activeId || store2.first())?.element;
      if (element2 && "scrollIntoView" in element2) {
        isAutoScrollingRef.current = true;
        element2.scrollIntoView({
          block: "nearest",
          inline: "nearest"
        });
        requestAnimationFrame(() => {
          isAutoScrollingRef.current = false;
        });
      }
    }
  }, [
    store2,
    open,
    valueUpdated,
    storeValue,
    autoSelect,
    resetValueOnSelect,
    getAutoSelectIdProp,
    items
  ]);
  useEffect(() => {
    if (!inline) return;
    const combobox = ref.current;
    if (!combobox) return;
    const elements2 = [combobox, contentElement].filter((value2) => !!value2);
    const onBlur2 = (event) => {
      if (elements2.every((el) => isFocusEventOutside(event, el))) store2?.setValue(value);
    };
    for (const element2 of elements2) element2.addEventListener("focusout", onBlur2);
    return () => {
      for (const element2 of elements2) element2.removeEventListener("focusout", onBlur2);
    };
  }, [
    inline,
    contentElement,
    store2,
    value
  ]);
  const canShow = (event) => {
    return event.currentTarget.value.length >= showMinLength;
  };
  const onChangeProp = props2.onChange;
  const showOnChangeProp = useBooleanEvent(showOnChange ?? canShow);
  const setValueOnChangeProp = useBooleanEvent(setValueOnChange ?? !store2.tag);
  const onChange = useEvent((event) => {
    onChangeProp?.(event);
    if (event.defaultPrevented) return;
    if (!store2) return;
    const currentTarget = event.currentTarget;
    const { value: value2, selectionStart, selectionEnd } = currentTarget;
    const nativeEvent = event.nativeEvent;
    canAutoSelectRef.current = true;
    if (isInputEvent(nativeEvent)) {
      if (nativeEvent.isComposing) {
        canAutoSelectRef.current = false;
        composingRef.current = true;
      }
      if (inline) {
        const textInserted = nativeEvent.inputType === "insertText" || nativeEvent.inputType === "insertCompositionText";
        const caretAtEnd = selectionStart === value2.length;
        setCanInline(textInserted && caretAtEnd);
      }
    }
    if (setValueOnChangeProp(event)) {
      const isSameValue2 = value2 === store2.getState().value;
      store2.setValue(value2);
      queueMicrotask(() => {
        setSelectionRange(currentTarget, selectionStart, selectionEnd);
      });
      if (inline && autoSelect && isSameValue2) forceValueUpdate();
    }
    if (showOnChangeProp(event)) store2.show();
    if (!autoSelect || !canAutoSelectRef.current) store2.setActiveId(null);
  });
  const onCompositionEndProp = props2.onCompositionEnd;
  const onCompositionEnd = useEvent((event) => {
    canAutoSelectRef.current = true;
    composingRef.current = false;
    onCompositionEndProp?.(event);
    if (event.defaultPrevented) return;
    if (!autoSelect) return;
    forceValueUpdate();
  });
  const onMouseDownProp = props2.onMouseDown;
  const blurActiveItemOnClickProp = useBooleanEvent(blurActiveItemOnClick ?? (() => store2.getState().includesBaseElement));
  const setValueOnClickProp = useBooleanEvent(setValueOnClick);
  const showOnClickProp = useBooleanEvent(showOnClick ?? canShow);
  const onMouseDown = useEvent((event) => {
    onMouseDownProp?.(event);
    if (event.defaultPrevented) return;
    if (event.button) return;
    if (event.ctrlKey) return;
    if (!store2) return;
    if (blurActiveItemOnClickProp(event)) store2.setActiveId(null);
    if (setValueOnClickProp(event)) store2.setValue(value);
    if (showOnClickProp(event)) queueBeforeEvent(event.currentTarget, "mouseup", store2.show);
  });
  const onKeyDownProp = props2.onKeyDown;
  const showOnKeyPressProp = useBooleanEvent(showOnKeyPress ?? canShow);
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (!event.repeat) canAutoSelectRef.current = false;
    if (event.defaultPrevented) return;
    if (!store2) return;
    const { open: open2 } = store2.getState();
    if (open2 && event.key === "Enter") {
      event.preventDefault();
      return;
    }
    if (event.ctrlKey) return;
    if (event.altKey) return;
    if (event.shiftKey) return;
    if (event.metaKey) return;
    if (open2) return;
    if (event.key === "ArrowUp" || event.key === "ArrowDown") {
      if (showOnKeyPressProp(event)) {
        event.preventDefault();
        store2.show();
      }
    }
  });
  const onBlurProp = props2.onBlur;
  const onBlur = useEvent((event) => {
    canAutoSelectRef.current = false;
    onBlurProp?.(event);
  });
  const id2 = useId(props2.id);
  const ariaAutoComplete = isAriaAutoCompleteValue(autoComplete) ? autoComplete : void 0;
  const isActiveItem = useStoreState(store2, (state) => state.activeId === null);
  props2 = {
    role: "combobox",
    "aria-autocomplete": ariaAutoComplete,
    "aria-haspopup": getPopupRole(contentElement, "listbox"),
    "aria-expanded": open,
    "aria-controls": contentElement?.id,
    "data-active-item": isActiveItem || void 0,
    value,
    ...props2,
    id: id2,
    ref: useMergeRefs(ref, props2.ref),
    onChange,
    onCompositionEnd,
    onMouseDown,
    onKeyDown,
    onBlur
  };
  props2 = useComposite({
    store: store2,
    focusable,
    ...props2,
    moveOnKeyPress: (event) => {
      if (isFalsyBooleanCallback(moveOnKeyPress, event)) return false;
      if (inline) setCanInline(true);
      return true;
    }
  });
  props2 = usePopoverAnchor({
    store: store2,
    ...props2
  });
  return {
    autoComplete: "off",
    ...props2
  };
});
const Combobox = forwardRef(function Combobox2(props2) {
  return createElement(TagName$2, useCombobox(props2));
});
const TagName$1 = "div";
function isSelected(storeValue, itemValue) {
  if (itemValue == null) return;
  if (storeValue == null) return false;
  if (Array.isArray(storeValue)) return storeValue.includes(itemValue);
  return storeValue === itemValue;
}
function getItemRole(popupRole) {
  return getItemRoleByPopupRole(popupRole) ?? "option";
}
const useComboboxItem = createHook(function useComboboxItem2({ store: store2, value, hideOnClick, setValueOnClick, selectValueOnClick = true, resetValueOnSelect, focusOnHover = false, moveOnKeyPress = true, getItem: getItemProp, ...props2 }) {
  const context = useComboboxScopedContext();
  store2 = store2 || context;
  invariant(store2, process.env.NODE_ENV !== "production" && "ComboboxItem must be wrapped in a ComboboxList or ComboboxPopover component.");
  const { resetValueOnSelectState, multiSelectable, selected } = useStoreStateObject(store2, {
    resetValueOnSelectState: "resetValueOnSelect",
    multiSelectable(state) {
      return Array.isArray(state.selectedValue);
    },
    selected(state) {
      return isSelected(state.selectedValue, value);
    }
  });
  const getItem = useCallback((item) => {
    const nextItem = {
      ...item,
      value
    };
    if (getItemProp) return getItemProp(nextItem);
    return nextItem;
  }, [value, getItemProp]);
  setValueOnClick = setValueOnClick ?? !multiSelectable;
  hideOnClick = hideOnClick ?? (value != null && !multiSelectable);
  const onClickProp = props2.onClick;
  const setValueOnClickProp = useBooleanEvent(setValueOnClick);
  const selectValueOnClickProp = useBooleanEvent(selectValueOnClick);
  const resetValueOnSelectProp = useBooleanEvent(resetValueOnSelect ?? resetValueOnSelectState ?? multiSelectable);
  const hideOnClickProp = useBooleanEvent(hideOnClick);
  const onClick = useEvent((event) => {
    onClickProp?.(event);
    if (event.defaultPrevented) return;
    if (isDownloading(event)) return;
    if (isOpeningInNewTab(event)) return;
    if (value != null) {
      if (selectValueOnClickProp(event)) {
        if (resetValueOnSelectProp(event)) store2?.resetValue();
        store2?.setSelectedValue((prevValue) => {
          if (!Array.isArray(prevValue)) return value;
          if (prevValue.includes(value)) return prevValue.filter((v2) => v2 !== value);
          return [...prevValue, value];
        });
      }
      if (setValueOnClickProp(event)) store2?.setValue(value);
    }
    if (hideOnClickProp(event)) store2?.hide();
  });
  const onKeyDownProp = props2.onKeyDown;
  const onKeyDown = useEvent((event) => {
    onKeyDownProp?.(event);
    if (event.defaultPrevented) return;
    const baseElement = store2?.getState().baseElement;
    if (!baseElement) return;
    if (hasFocus(baseElement)) return;
    const printable = event.key.length === 1 && !event.ctrlKey && !event.metaKey;
    const paste = (!isApple() ? event.ctrlKey : event.metaKey) && event.key.toLowerCase() === "v";
    const deleteKey = event.key === "Backspace" || event.key === "Delete";
    if (printable || paste || deleteKey) {
      queueMicrotask(() => baseElement.focus());
      if (isTextField(baseElement)) store2?.setValue(baseElement.value);
    }
  });
  if (multiSelectable && selected != null) props2 = {
    "aria-selected": selected,
    ...props2
  };
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItemValueContext.Provider, {
    value,
    children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItemCheckedContext.Provider, {
      value: selected ?? false,
      children: element2
    })
  }), [value, selected]);
  props2 = {
    role: getItemRole(useContext(ComboboxListRoleContext)),
    children: value,
    ...props2,
    onClick,
    onKeyDown
  };
  const moveOnKeyPressProp = useBooleanEvent(moveOnKeyPress);
  props2 = useCompositeItem({
    store: store2,
    ...props2,
    getItem,
    moveOnKeyPress: (event) => {
      if (!moveOnKeyPressProp(event)) return false;
      const moveEvent = new Event("combobox-item-move");
      store2?.getState().baseElement?.dispatchEvent(moveEvent);
      return true;
    }
  });
  props2 = useCompositeHover({
    store: store2,
    focusOnHover,
    ...props2
  });
  return props2;
});
const ComboboxItem = memo(forwardRef(function ComboboxItem2(props2) {
  return createElement(TagName$1, useComboboxItem(props2));
}));
const TagName = "div";
const useComboboxList = createHook(function useComboboxList2({ store: store2, alwaysVisible, ...props2 }) {
  const scopedContext = useComboboxScopedContext(true);
  const context = useComboboxContext();
  store2 = store2 || context;
  const scopedContextSameStore = !!store2 && store2 === scopedContext;
  invariant(store2, process.env.NODE_ENV !== "production" && "ComboboxList must receive a `store` prop or be wrapped in a ComboboxProvider component.");
  const ref = useRef(null);
  const id2 = useId(props2.id);
  const mounted = useStoreState(store2, "mounted");
  const hidden = isHidden(mounted, props2.hidden, alwaysVisible);
  const style = hidden ? {
    ...props2.style,
    display: "none"
  } : props2.style;
  const multiSelectable = useStoreState(store2, (state) => Array.isArray(state.selectedValue));
  const role = useAttribute(ref, "role", props2.role);
  const ariaMultiSelectable = role === "listbox" || role === "tree" || role === "grid" ? multiSelectable || void 0 : void 0;
  const [hasListboxInside, setHasListboxInside] = useState(false);
  const contentElement = useStoreState(store2, "contentElement");
  useSafeLayoutEffect(() => {
    if (!mounted) return;
    const element2 = ref.current;
    if (!element2) return;
    if (contentElement !== element2) return;
    const callback = () => {
      setHasListboxInside(!!element2.querySelector("[role='listbox']"));
    };
    const observer = new MutationObserver(callback);
    observer.observe(element2, {
      subtree: true,
      childList: true,
      attributeFilter: ["role"]
    });
    callback();
    return () => observer.disconnect();
  }, [mounted, contentElement]);
  if (!hasListboxInside) props2 = {
    role: "listbox",
    "aria-multiselectable": ariaMultiSelectable,
    ...props2
  };
  props2 = useWrapElement(props2, (element2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxScopedContextProvider, {
    value: store2,
    children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxListRoleContext.Provider, {
      value: role,
      children: element2
    })
  }), [store2, role]);
  const setContentElement = id2 && (!scopedContext || !scopedContextSameStore) ? store2.setContentElement : null;
  props2 = {
    hidden,
    ...props2,
    id: id2,
    ref: useMergeRefs(setContentElement, ref, props2.ref),
    style
  };
  return removeUndefinedValues(props2);
});
const ComboboxList = forwardRef(function ComboboxList2(props2) {
  return createElement(TagName, useComboboxList(props2));
});
createContext(null);
createContext(null);
const ctx = createStoreContext([CompositeContextProvider], [CompositeScopedContextProvider]);
const useTagContext = ctx.useContext;
const isTouchSafari = isSafari() && isTouchDevice();
function createComboboxStore({ tag: tag2, ...props2 } = {}) {
  const store2 = mergeStore(props2.store, pick(tag2, ["value", "rtl"]));
  throwOnConflictingProps(props2, store2);
  const tagState = tag2?.getState();
  const syncState = store2?.getState();
  const activeId = defaultValue(props2.activeId, syncState?.activeId, props2.defaultActiveId, null);
  const composite = createCompositeStore({
    ...props2,
    activeId,
    includesBaseElement: defaultValue(props2.includesBaseElement, syncState?.includesBaseElement, true),
    orientation: defaultValue(props2.orientation, syncState?.orientation, "vertical"),
    focusLoop: defaultValue(props2.focusLoop, syncState?.focusLoop, true),
    focusWrap: defaultValue(props2.focusWrap, syncState?.focusWrap, true),
    virtualFocus: defaultValue(props2.virtualFocus, syncState?.virtualFocus, true)
  });
  const popover = createPopoverStore({
    ...props2,
    placement: defaultValue(props2.placement, syncState?.placement, "bottom-start")
  });
  const value = defaultValue(props2.value, syncState?.value, props2.defaultValue, "");
  const selectedValue = defaultValue(props2.selectedValue, syncState?.selectedValue, tagState?.values, props2.defaultSelectedValue, "");
  const multiSelectable = Array.isArray(selectedValue);
  const initialState2 = {
    ...composite.getState(),
    ...popover.getState(),
    value,
    selectedValue,
    resetValueOnSelect: defaultValue(props2.resetValueOnSelect, syncState?.resetValueOnSelect, multiSelectable),
    resetValueOnHide: defaultValue(props2.resetValueOnHide, syncState?.resetValueOnHide, multiSelectable && !tag2),
    activeValue: syncState?.activeValue
  };
  const combobox = createStore(initialState2, composite, popover, store2);
  if (isTouchSafari) setup(combobox, () => sync(combobox, ["virtualFocus"], () => {
    combobox.setState("virtualFocus", false);
  }));
  setup(combobox, () => {
    if (!tag2) return;
    return chain(sync(combobox, ["selectedValue"], (state) => {
      if (!Array.isArray(state.selectedValue)) return;
      tag2.setValues(state.selectedValue);
    }), sync(tag2, ["values"], (state) => {
      combobox.setState("selectedValue", state.values);
    }));
  });
  setup(combobox, () => sync(combobox, ["resetValueOnHide", "mounted"], (state) => {
    if (!state.resetValueOnHide) return;
    if (state.mounted) return;
    combobox.setState("value", value);
  }));
  setup(combobox, () => sync(combobox, ["open"], (state) => {
    if (state.open) return;
    combobox.setState("activeId", activeId);
    combobox.setState("moves", 0);
  }));
  setup(combobox, () => sync(combobox, ["moves", "activeId"], (state, prevState) => {
    if (state.moves === prevState.moves) combobox.setState("activeValue", void 0);
  }));
  setup(combobox, () => batch(combobox, ["moves", "renderedItems"], (state, prev) => {
    if (state.moves === prev.moves) return;
    const { activeId: activeId2 } = combobox.getState();
    const activeItem = composite.item(activeId2);
    combobox.setState("activeValue", activeItem?.value);
  }));
  return {
    ...popover,
    ...composite,
    ...combobox,
    tag: tag2,
    setValue: (value2) => combobox.setState("value", value2),
    resetValue: () => combobox.setState("value", initialState2.value),
    setSelectedValue: (selectedValue2) => combobox.setState("selectedValue", selectedValue2)
  };
}
function useComboboxStoreOptions(props2) {
  const tag2 = useTagContext();
  props2 = {
    ...props2,
    tag: props2.tag !== void 0 ? props2.tag : tag2
  };
  return useCompositeStoreOptions(props2);
}
function useComboboxStoreProps(store2, update, props2) {
  useUpdateEffect(update, [props2.tag]);
  useStoreProps(store2, props2, "value", "setValue");
  useStoreProps(store2, props2, "selectedValue", "setSelectedValue");
  useStoreProps(store2, props2, "resetValueOnHide");
  useStoreProps(store2, props2, "resetValueOnSelect");
  return Object.assign(useCompositeStoreProps(usePopoverStoreProps(store2, update, props2), update, props2), { tag: props2.tag });
}
function useComboboxStore(props2 = {}) {
  props2 = useComboboxStoreOptions(props2);
  const [store2, update] = useStore(createComboboxStore, props2);
  return useComboboxStoreProps(store2, update, props2);
}
function ComboboxProvider(props2 = {}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxContextProvider, {
    value: useComboboxStore(props2),
    children: props2.children
  });
}
function BsXOctagon(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M4.54.146A.5.5 0 0 1 4.893 0h6.214a.5.5 0 0 1 .353.146l4.394 4.394a.5.5 0 0 1 .146.353v6.214a.5.5 0 0 1-.146.353l-4.394 4.394a.5.5 0 0 1-.353.146H4.893a.5.5 0 0 1-.353-.146L.146 11.46A.5.5 0 0 1 0 11.107V4.893a.5.5 0 0 1 .146-.353zM5.1 1 1 5.1v5.8L5.1 15h5.8l4.1-4.1V5.1L10.9 1z" }, "child": [] }, { "tag": "path", "attr": { "d": "M4.646 4.646a.5.5 0 0 1 .708 0L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 0 1 0-.708" }, "child": [] }] })(props2);
}
function BsXOctagonFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M11.46.146A.5.5 0 0 0 11.107 0H4.893a.5.5 0 0 0-.353.146L.146 4.54A.5.5 0 0 0 0 4.893v6.214a.5.5 0 0 0 .146.353l4.394 4.394a.5.5 0 0 0 .353.146h6.214a.5.5 0 0 0 .353-.146l4.394-4.394a.5.5 0 0 0 .146-.353V4.893a.5.5 0 0 0-.146-.353zm-6.106 4.5L8 7.293l2.646-2.647a.5.5 0 0 1 .708.708L8.707 8l2.647 2.646a.5.5 0 0 1-.708.708L8 8.707l-2.646 2.647a.5.5 0 0 1-.708-.708L7.293 8 4.646 5.354a.5.5 0 1 1 .708-.708" }, "child": [] }] })(props2);
}
function BsThreeDotsVertical(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M9.5 13a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0m0-5a1.5 1.5 0 1 1-3 0 1.5 1.5 0 0 1 3 0" }, "child": [] }] })(props2);
}
function BsInfoCircle(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8 15A7 7 0 1 1 8 1a7 7 0 0 1 0 14m0 1A8 8 0 1 0 8 0a8 8 0 0 0 0 16" }, "child": [] }, { "tag": "path", "attr": { "d": "m8.93 6.588-2.29.287-.082.38.45.083c.294.07.352.176.288.469l-.738 3.468c-.194.897.105 1.319.808 1.319.545 0 1.178-.252 1.465-.598l.088-.416c-.2.176-.492.246-.686.246-.275 0-.375-.193-.304-.533zM9 4.5a1 1 0 1 1-2 0 1 1 0 0 1 2 0" }, "child": [] }] })(props2);
}
function BsInfoCircleFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8 16A8 8 0 1 0 8 0a8 8 0 0 0 0 16m.93-9.412-1 4.705c-.07.34.029.533.304.533.194 0 .487-.07.686-.246l-.088.416c-.287.346-.92.598-1.465.598-.703 0-1.002-.422-.808-1.319l.738-3.468c.064-.293.006-.399-.287-.47l-.451-.081.082-.381 2.29-.287zM8 5.5a1 1 0 1 1 0-2 1 1 0 0 1 0 2" }, "child": [] }] })(props2);
}
function BsExclamationTriangle(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M7.938 2.016A.13.13 0 0 1 8.002 2a.13.13 0 0 1 .063.016.15.15 0 0 1 .054.057l6.857 11.667c.036.06.035.124.002.183a.2.2 0 0 1-.054.06.1.1 0 0 1-.066.017H1.146a.1.1 0 0 1-.066-.017.2.2 0 0 1-.054-.06.18.18 0 0 1 .002-.183L7.884 2.073a.15.15 0 0 1 .054-.057m1.044-.45a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767z" }, "child": [] }, { "tag": "path", "attr": { "d": "M7.002 12a1 1 0 1 1 2 0 1 1 0 0 1-2 0M7.1 5.995a.905.905 0 1 1 1.8 0l-.35 3.507a.552.552 0 0 1-1.1 0z" }, "child": [] }] })(props2);
}
function BsExclamationTriangleFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M8.982 1.566a1.13 1.13 0 0 0-1.96 0L.165 13.233c-.457.778.091 1.767.98 1.767h13.713c.889 0 1.438-.99.98-1.767zM8 5c.535 0 .954.462.9.995l-.35 3.507a.552.552 0 0 1-1.1 0L7.1 5.995A.905.905 0 0 1 8 5m.002 6a1 1 0 1 1 0 2 1 1 0 0 1 0-2" }, "child": [] }] })(props2);
}
function BsCodeSlash(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M10.478 1.647a.5.5 0 1 0-.956-.294l-4 13a.5.5 0 0 0 .956.294zM4.854 4.146a.5.5 0 0 1 0 .708L1.707 8l3.147 3.146a.5.5 0 0 1-.708.708l-3.5-3.5a.5.5 0 0 1 0-.708l3.5-3.5a.5.5 0 0 1 .708 0m6.292 0a.5.5 0 0 0 0 .708L14.293 8l-3.147 3.146a.5.5 0 0 0 .708.708l3.5-3.5a.5.5 0 0 0 0-.708l-3.5-3.5a.5.5 0 0 0-.708 0" }, "child": [] }] })(props2);
}
function BsChatSquareText(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M14 1a1 1 0 0 1 1 1v8a1 1 0 0 1-1 1h-2.5a2 2 0 0 0-1.6.8L8 14.333 6.1 11.8a2 2 0 0 0-1.6-.8H2a1 1 0 0 1-1-1V2a1 1 0 0 1 1-1zM2 0a2 2 0 0 0-2 2v8a2 2 0 0 0 2 2h2.5a1 1 0 0 1 .8.4l1.9 2.533a1 1 0 0 0 1.6 0l1.9-2.533a1 1 0 0 1 .8-.4H14a2 2 0 0 0 2-2V2a2 2 0 0 0-2-2z" }, "child": [] }, { "tag": "path", "attr": { "d": "M3 3.5a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9a.5.5 0 0 1-.5-.5M3 6a.5.5 0 0 1 .5-.5h9a.5.5 0 0 1 0 1h-9A.5.5 0 0 1 3 6m0 2.5a.5.5 0 0 1 .5-.5h5a.5.5 0 0 1 0 1h-5a.5.5 0 0 1-.5-.5" }, "child": [] }] })(props2);
}
function BsChatSquareTextFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M0 2a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v8a2 2 0 0 1-2 2h-2.5a1 1 0 0 0-.8.4l-1.9 2.533a1 1 0 0 1-1.6 0L5.3 12.4a1 1 0 0 0-.8-.4H2a2 2 0 0 1-2-2zm3.5 1a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h9a.5.5 0 0 0 0-1zm0 2.5a.5.5 0 0 0 0 1h5a.5.5 0 0 0 0-1z" }, "child": [] }] })(props2);
}
function BsCaretUpFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "m7.247 4.86-4.796 5.481c-.566.647-.106 1.659.753 1.659h9.592a1 1 0 0 0 .753-1.659l-4.796-5.48a1 1 0 0 0-1.506 0z" }, "child": [] }] })(props2);
}
function BsCaretDownFill(props2) {
  return GenIcon$1({ "attr": { "fill": "currentColor", "viewBox": "0 0 16 16" }, "child": [{ "tag": "path", "attr": { "d": "M7.247 11.14 2.451 5.658C1.885 5.013 2.345 4 3.204 4h9.592a1 1 0 0 1 .753 1.659l-4.796 5.48a1 1 0 0 1-1.506 0z" }, "child": [] }] })(props2);
}
function IoAccessibility(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "path", "attr": { "d": "M256 112a56 56 0 1 1 56-56 56.06 56.06 0 0 1-56 56" }, "child": [] }, { "tag": "path", "attr": { "d": "m432 112.8-.45.12-.42.13c-1 .28-2 .58-3 .89-18.61 5.46-108.93 30.92-172.56 30.92-59.13 0-141.28-22-167.56-29.47a74 74 0 0 0-8-2.58c-19-5-32 14.3-32 31.94 0 17.47 15.7 25.79 31.55 31.76v.28l95.22 29.74c9.73 3.73 12.33 7.54 13.6 10.84 4.13 10.59.83 31.56-.34 38.88l-5.8 45-32.19 176.19q-.15.72-.27 1.47l-.23 1.27c-2.32 16.15 9.54 31.82 32 31.82 19.6 0 28.25-13.53 32-31.94s28-157.57 42-157.57 42.84 157.57 42.84 157.57c3.75 18.41 12.4 31.94 32 31.94 22.52 0 34.38-15.74 32-31.94a57 57 0 0 0-.76-4.06L329 301.27l-5.79-45c-4.19-26.21-.82-34.87.32-36.9a1 1 0 0 0 .08-.15c1.08-2 6-6.48 17.48-10.79l89.28-31.21a17 17 0 0 0 1.62-.52c16-6 32-14.3 32-31.93S451 107.81 432 112.8" }, "child": [] }] })(props2);
}
function IoAccessibilityOutline(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 512 512" }, "child": [{ "tag": "circle", "attr": { "cx": "256", "cy": "56", "r": "40", "fill": "none", "strokeLinejoin": "round", "strokeWidth": "32" }, "child": [] }, { "tag": "path", "attr": { "fill": "none", "strokeLinejoin": "round", "strokeWidth": "32", "d": "M204.23 274.44c2.9-18.06 4.2-35.52-.5-47.59-4-10.38-12.7-16.19-23.2-20.15L88 176.76c-12-4-23.21-10.7-24-23.94-1-17 14-28 29-24 0 0 88 31.14 163 31.14s162-31 162-31c18-5 30 9 30 23.79 0 14.21-11 19.21-24 23.94l-88 31.91c-8 3-21 9-26 18.18-6 10.75-5 29.53-2.1 47.59l5.9 29.63 37.41 163.9c2.8 13.15-6.3 25.44-19.4 27.74S308 489 304.12 476.28l-37.56-115.93q-2.71-8.34-4.8-16.87L256 320l-5.3 21.65q-2.52 10.35-5.8 20.48L208 476.18c-4 12.85-14.5 21.75-27.6 19.46s-22.4-15.59-19.46-27.74l37.39-163.83z" }, "child": [] }] })(props2);
}
const element = document.createElement("i");
function decodeNamedCharacterReference(value) {
  const characterReference2 = "&" + value + ";";
  element.innerHTML = characterReference2;
  const character = element.textContent;
  if (
    // @ts-expect-error: TypeScript is wrong that `textContent` on elements can
    // yield `null`.
    character.charCodeAt(character.length - 1) === 59 && value !== "semi"
  ) {
    return false;
  }
  return character === characterReference2 ? false : character;
}
function splice(list2, start, remove2, items) {
  const end = list2.length;
  let chunkStart = 0;
  let parameters;
  if (start < 0) {
    start = -start > end ? 0 : end + start;
  } else {
    start = start > end ? end : start;
  }
  remove2 = remove2 > 0 ? remove2 : 0;
  if (items.length < 1e4) {
    parameters = Array.from(items);
    parameters.unshift(start, remove2);
    list2.splice(...parameters);
  } else {
    if (remove2) list2.splice(start, remove2);
    while (chunkStart < items.length) {
      parameters = items.slice(chunkStart, chunkStart + 1e4);
      parameters.unshift(start, 0);
      list2.splice(...parameters);
      chunkStart += 1e4;
      start += 1e4;
    }
  }
}
function push(list2, items) {
  if (list2.length > 0) {
    splice(list2, list2.length, 0, items);
    return list2;
  }
  return items;
}
const hasOwnProperty$1 = {}.hasOwnProperty;
function combineExtensions(extensions) {
  const all2 = {};
  let index2 = -1;
  while (++index2 < extensions.length) {
    syntaxExtension(all2, extensions[index2]);
  }
  return all2;
}
function syntaxExtension(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let code2;
    if (right) {
      for (code2 in right) {
        if (!hasOwnProperty$1.call(left, code2)) left[code2] = [];
        const value = right[code2];
        constructs(
          // @ts-expect-error Looks like a list.
          left[code2],
          Array.isArray(value) ? value : value ? [value] : []
        );
      }
    }
  }
}
function constructs(existing, list2) {
  let index2 = -1;
  const before2 = [];
  while (++index2 < list2.length) {
    (list2[index2].add === "after" ? existing : before2).push(list2[index2]);
  }
  splice(existing, 0, 0, before2);
}
function combineHtmlExtensions(htmlExtensions) {
  const handlers2 = {};
  let index2 = -1;
  while (++index2 < htmlExtensions.length) {
    htmlExtension(handlers2, htmlExtensions[index2]);
  }
  return handlers2;
}
function htmlExtension(all2, extension) {
  let hook;
  for (hook in extension) {
    const maybe = hasOwnProperty$1.call(all2, hook) ? all2[hook] : void 0;
    const left = maybe || (all2[hook] = {});
    const right = extension[hook];
    let type;
    if (right) {
      for (type in right) {
        left[type] = right[type];
      }
    }
  }
}
function decodeNumericCharacterReference(value, base2) {
  const code2 = Number.parseInt(value, base2);
  if (
    // C0 except for HT, LF, FF, CR, space.
    code2 < 9 || code2 === 11 || code2 > 13 && code2 < 32 || // Control character (DEL) of C0, and C1 controls.
    code2 > 126 && code2 < 160 || // Lone high surrogates and low surrogates.
    code2 > 55295 && code2 < 57344 || // Noncharacters.
    code2 > 64975 && code2 < 65008 || /* eslint-disable no-bitwise */
    (code2 & 65535) === 65535 || (code2 & 65535) === 65534 || /* eslint-enable no-bitwise */
    // Out of range
    code2 > 1114111
  ) {
    return "�";
  }
  return String.fromCodePoint(code2);
}
const characterReferences = { '"': "quot", "&": "amp", "<": "lt", ">": "gt" };
function encode$2(value) {
  return value.replace(/["&<>]/g, replace2);
  function replace2(value2) {
    return "&" + characterReferences[
      /** @type {keyof typeof characterReferences} */
      value2
    ] + ";";
  }
}
function normalizeIdentifier(value) {
  return value.replace(/[\t\n\r ]+/g, " ").replace(/^ | $/g, "").toLowerCase().toUpperCase();
}
const asciiAlpha = regexCheck(/[A-Za-z]/);
const asciiAlphanumeric = regexCheck(/[\dA-Za-z]/);
const asciiAtext = regexCheck(/[#-'*+\--9=?A-Z^-~]/);
function asciiControl(code2) {
  return (
    // Special whitespace codes (which have negative values), C0 and Control
    // character DEL
    code2 !== null && (code2 < 32 || code2 === 127)
  );
}
const asciiDigit = regexCheck(/\d/);
const asciiHexDigit = regexCheck(/[\dA-Fa-f]/);
const asciiPunctuation = regexCheck(/[!-/:-@[-`{-~]/);
function markdownLineEnding(code2) {
  return code2 !== null && code2 < -2;
}
function markdownLineEndingOrSpace(code2) {
  return code2 !== null && (code2 < 0 || code2 === 32);
}
function markdownSpace(code2) {
  return code2 === -2 || code2 === -1 || code2 === 32;
}
const unicodePunctuation = regexCheck(new RegExp("\\p{P}|\\p{S}", "u"));
const unicodeWhitespace = regexCheck(/\s/);
function regexCheck(regex) {
  return check;
  function check(code2) {
    return code2 !== null && code2 > -1 && regex.test(String.fromCharCode(code2));
  }
}
function sanitizeUri(url, protocol2) {
  const value = encode$2(normalizeUri(url || ""));
  if (!protocol2) {
    return value;
  }
  const colon = value.indexOf(":");
  const questionMark = value.indexOf("?");
  const numberSign = value.indexOf("#");
  const slash = value.indexOf("/");
  if (
    // If there is no protocol, it’s relative.
    colon < 0 || // If the first colon is after a `?`, `#`, or `/`, it’s not a protocol.
    slash > -1 && colon > slash || questionMark > -1 && colon > questionMark || numberSign > -1 && colon > numberSign || // It is a protocol, it should be allowed.
    protocol2.test(value.slice(0, colon))
  ) {
    return value;
  }
  return "";
}
function normalizeUri(value) {
  const result2 = [];
  let index2 = -1;
  let start = 0;
  let skip = 0;
  while (++index2 < value.length) {
    const code2 = value.charCodeAt(index2);
    let replace2 = "";
    if (code2 === 37 && asciiAlphanumeric(value.charCodeAt(index2 + 1)) && asciiAlphanumeric(value.charCodeAt(index2 + 2))) {
      skip = 2;
    } else if (code2 < 128) {
      if (!/[!#$&-;=?-Z_a-z~]/.test(String.fromCharCode(code2))) {
        replace2 = String.fromCharCode(code2);
      }
    } else if (code2 > 55295 && code2 < 57344) {
      const next = value.charCodeAt(index2 + 1);
      if (code2 < 56320 && next > 56319 && next < 57344) {
        replace2 = String.fromCharCode(code2, next);
        skip = 1;
      } else {
        replace2 = "�";
      }
    } else {
      replace2 = String.fromCharCode(code2);
    }
    if (replace2) {
      result2.push(value.slice(start, index2), encodeURIComponent(replace2));
      start = index2 + skip + 1;
      replace2 = "";
    }
    if (skip) {
      index2 += skip;
      skip = 0;
    }
  }
  return result2.join("") + value.slice(start);
}
const hasOwnProperty = {}.hasOwnProperty;
const protocolHref = /^(https?|ircs?|mailto|xmpp)$/i;
const protocolSource = /^https?$/i;
function compile(options2) {
  const settings = options2 || {};
  let tags2 = true;
  const definitions = {};
  const buffers = [[]];
  const mediaStack = [];
  const tightStack = [];
  const defaultHandlers = {
    enter: {
      blockQuote: onenterblockquote,
      codeFenced: onentercodefenced,
      codeFencedFenceInfo: buffer,
      codeFencedFenceMeta: buffer,
      codeIndented: onentercodeindented,
      codeText: onentercodetext,
      content: onentercontent,
      definition: onenterdefinition,
      definitionDestinationString: onenterdefinitiondestinationstring,
      definitionLabelString: buffer,
      definitionTitleString: buffer,
      emphasis: onenteremphasis,
      htmlFlow: onenterhtmlflow,
      htmlText: onenterhtml,
      image: onenterimage,
      label: buffer,
      link: onenterlink,
      listItemMarker: onenterlistitemmarker,
      listItemValue: onenterlistitemvalue,
      listOrdered: onenterlistordered,
      listUnordered: onenterlistunordered,
      paragraph: onenterparagraph,
      reference: buffer,
      resource: onenterresource,
      resourceDestinationString: onenterresourcedestinationstring,
      resourceTitleString: buffer,
      setextHeading: onentersetextheading,
      strong: onenterstrong
    },
    exit: {
      atxHeading: onexitatxheading,
      atxHeadingSequence: onexitatxheadingsequence,
      autolinkEmail: onexitautolinkemail,
      autolinkProtocol: onexitautolinkprotocol,
      blockQuote: onexitblockquote,
      characterEscapeValue: onexitdata,
      characterReferenceMarkerHexadecimal: onexitcharacterreferencemarker,
      characterReferenceMarkerNumeric: onexitcharacterreferencemarker,
      characterReferenceValue: onexitcharacterreferencevalue,
      codeFenced: onexitflowcode,
      codeFencedFence: onexitcodefencedfence,
      codeFencedFenceInfo: onexitcodefencedfenceinfo,
      codeFencedFenceMeta: onresumedrop,
      codeFlowValue: onexitcodeflowvalue,
      codeIndented: onexitflowcode,
      codeText: onexitcodetext,
      codeTextData: onexitdata,
      data: onexitdata,
      definition: onexitdefinition,
      definitionDestinationString: onexitdefinitiondestinationstring,
      definitionLabelString: onexitdefinitionlabelstring,
      definitionTitleString: onexitdefinitiontitlestring,
      emphasis: onexitemphasis,
      hardBreakEscape: onexithardbreak,
      hardBreakTrailing: onexithardbreak,
      htmlFlow: onexithtml,
      htmlFlowData: onexitdata,
      htmlText: onexithtml,
      htmlTextData: onexitdata,
      image: onexitmedia,
      label: onexitlabel,
      labelText: onexitlabeltext,
      lineEnding: onexitlineending,
      link: onexitmedia,
      listOrdered: onexitlistordered,
      listUnordered: onexitlistunordered,
      paragraph: onexitparagraph,
      reference: onresumedrop,
      referenceString: onexitreferencestring,
      resource: onresumedrop,
      resourceDestinationString: onexitresourcedestinationstring,
      resourceTitleString: onexitresourcetitlestring,
      setextHeading: onexitsetextheading,
      setextHeadingLineSequence: onexitsetextheadinglinesequence,
      setextHeadingText: onexitsetextheadingtext,
      strong: onexitstrong,
      thematicBreak: onexitthematicbreak
    }
  };
  const handlers2 = (
    /** @type {NormalizedHtmlExtension} */
    combineHtmlExtensions([defaultHandlers, ...settings.htmlExtensions || []])
  );
  const data = {
    definitions,
    tightStack
  };
  const context = {
    buffer,
    encode: encode$12,
    getData,
    lineEndingIfNeeded,
    options: settings,
    raw,
    resume,
    setData,
    tag: tag2
  };
  let lineEndingStyle = settings.defaultLineEnding;
  return compile2;
  function compile2(events2) {
    let index2 = -1;
    let start = 0;
    const listStack = [];
    let head = [];
    let body = [];
    while (++index2 < events2.length) {
      if (!lineEndingStyle && (events2[index2][1].type === "lineEnding" || events2[index2][1].type === "lineEndingBlank")) {
        lineEndingStyle = /** @type {LineEnding} */
        events2[index2][2].sliceSerialize(events2[index2][1]);
      }
      if (events2[index2][1].type === "listOrdered" || events2[index2][1].type === "listUnordered") {
        if (events2[index2][0] === "enter") {
          listStack.push(index2);
        } else {
          prepareList(events2.slice(listStack.pop(), index2));
        }
      }
      if (events2[index2][1].type === "definition") {
        if (events2[index2][0] === "enter") {
          body = push(body, events2.slice(start, index2));
          start = index2;
        } else {
          head = push(head, events2.slice(start, index2 + 1));
          start = index2 + 1;
        }
      }
    }
    head = push(head, body);
    head = push(head, events2.slice(start));
    index2 = -1;
    const result2 = head;
    if (handlers2.enter.null) {
      handlers2.enter.null.call(context);
    }
    while (++index2 < events2.length) {
      const handles = handlers2[result2[index2][0]];
      const kind = result2[index2][1].type;
      const handle = handles[kind];
      if (hasOwnProperty.call(handles, kind) && handle) {
        handle.call({
          sliceSerialize: result2[index2][2].sliceSerialize,
          ...context
        }, result2[index2][1]);
      }
    }
    if (handlers2.exit.null) {
      handlers2.exit.null.call(context);
    }
    return buffers[0].join("");
  }
  function prepareList(slice2) {
    const length = slice2.length;
    let index2 = 0;
    let containerBalance = 0;
    let loose = false;
    let atMarker;
    while (++index2 < length) {
      const event = slice2[index2];
      if (event[1]._container) {
        atMarker = void 0;
        if (event[0] === "enter") {
          containerBalance++;
        } else {
          containerBalance--;
        }
      } else switch (event[1].type) {
        case "listItemPrefix": {
          if (event[0] === "exit") {
            atMarker = true;
          }
          break;
        }
        case "linePrefix": {
          break;
        }
        case "lineEndingBlank": {
          if (event[0] === "enter" && !containerBalance) {
            if (atMarker) {
              atMarker = void 0;
            } else {
              loose = true;
            }
          }
          break;
        }
        default: {
          atMarker = void 0;
        }
      }
    }
    slice2[0][1]._loose = loose;
  }
  function setData(key, value) {
    data[key] = value;
  }
  function getData(key) {
    return data[key];
  }
  function buffer() {
    buffers.push([]);
  }
  function resume() {
    const buf = buffers.pop();
    return buf.join("");
  }
  function tag2(value) {
    if (!tags2) return;
    setData("lastWasTag", true);
    buffers[buffers.length - 1].push(value);
  }
  function raw(value) {
    setData("lastWasTag");
    buffers[buffers.length - 1].push(value);
  }
  function lineEnding2() {
    raw(lineEndingStyle || "\n");
  }
  function lineEndingIfNeeded() {
    const buffer2 = buffers[buffers.length - 1];
    const slice2 = buffer2[buffer2.length - 1];
    const previous2 = slice2 ? slice2.charCodeAt(slice2.length - 1) : null;
    if (previous2 === 10 || previous2 === 13 || previous2 === null) {
      return;
    }
    lineEnding2();
  }
  function encode$12(value) {
    return getData("ignoreEncode") ? value : encode$2(value);
  }
  function onresumedrop() {
    resume();
  }
  function onenterlistordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ol");
    setData("expectFirstItem", true);
  }
  function onenterlistunordered(token) {
    tightStack.push(!token._loose);
    lineEndingIfNeeded();
    tag2("<ul");
    setData("expectFirstItem", true);
  }
  function onenterlistitemvalue(token) {
    if (getData("expectFirstItem")) {
      const value = Number.parseInt(this.sliceSerialize(token), 10);
      if (value !== 1) {
        tag2(' start="' + encode$12(String(value)) + '"');
      }
    }
  }
  function onenterlistitemmarker() {
    if (getData("expectFirstItem")) {
      tag2(">");
    } else {
      onexitlistitem();
    }
    lineEndingIfNeeded();
    tag2("<li>");
    setData("expectFirstItem");
    setData("lastWasTag");
  }
  function onexitlistordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ol>");
  }
  function onexitlistunordered() {
    onexitlistitem();
    tightStack.pop();
    lineEnding2();
    tag2("</ul>");
  }
  function onexitlistitem() {
    if (getData("lastWasTag") && !getData("slurpAllLineEndings")) {
      lineEndingIfNeeded();
    }
    tag2("</li>");
    setData("slurpAllLineEndings");
  }
  function onenterblockquote() {
    tightStack.push(false);
    lineEndingIfNeeded();
    tag2("<blockquote>");
  }
  function onexitblockquote() {
    tightStack.pop();
    lineEndingIfNeeded();
    tag2("</blockquote>");
    setData("slurpAllLineEndings");
  }
  function onenterparagraph() {
    if (!tightStack[tightStack.length - 1]) {
      lineEndingIfNeeded();
      tag2("<p>");
    }
    setData("slurpAllLineEndings");
  }
  function onexitparagraph() {
    if (tightStack[tightStack.length - 1]) {
      setData("slurpAllLineEndings", true);
    } else {
      tag2("</p>");
    }
  }
  function onentercodefenced() {
    lineEndingIfNeeded();
    tag2("<pre><code");
    setData("fencesCount", 0);
  }
  function onexitcodefencedfenceinfo() {
    const value = resume();
    tag2(' class="language-' + value + '"');
  }
  function onexitcodefencedfence() {
    const count = getData("fencesCount") || 0;
    if (!count) {
      tag2(">");
      setData("slurpOneLineEnding", true);
    }
    setData("fencesCount", count + 1);
  }
  function onentercodeindented() {
    lineEndingIfNeeded();
    tag2("<pre><code>");
  }
  function onexitflowcode() {
    const count = getData("fencesCount");
    if (count !== void 0 && count < 2 && data.tightStack.length > 0 && !getData("lastWasTag")) {
      lineEnding2();
    }
    if (getData("flowCodeSeenData")) {
      lineEndingIfNeeded();
    }
    tag2("</code></pre>");
    if (count !== void 0 && count < 2) lineEndingIfNeeded();
    setData("flowCodeSeenData");
    setData("fencesCount");
    setData("slurpOneLineEnding");
  }
  function onenterimage() {
    mediaStack.push({
      image: true
    });
    tags2 = void 0;
  }
  function onenterlink() {
    mediaStack.push({});
  }
  function onexitlabeltext(token) {
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onexitlabel() {
    mediaStack[mediaStack.length - 1].label = resume();
  }
  function onexitreferencestring(token) {
    mediaStack[mediaStack.length - 1].referenceId = this.sliceSerialize(token);
  }
  function onenterresource() {
    buffer();
    mediaStack[mediaStack.length - 1].destination = "";
  }
  function onenterresourcedestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitresourcedestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitresourcetitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitmedia() {
    let index2 = mediaStack.length - 1;
    const media = mediaStack[index2];
    const id2 = media.referenceId || media.labelId;
    const context2 = media.destination === void 0 ? definitions[normalizeIdentifier(id2)] : media;
    tags2 = true;
    while (index2--) {
      if (mediaStack[index2].image) {
        tags2 = void 0;
        break;
      }
    }
    if (media.image) {
      tag2('<img src="' + sanitizeUri(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolSource) + '" alt="');
      raw(media.label);
      tag2('"');
    } else {
      tag2('<a href="' + sanitizeUri(context2.destination, settings.allowDangerousProtocol ? void 0 : protocolHref) + '"');
    }
    tag2(context2.title ? ' title="' + context2.title + '"' : "");
    if (media.image) {
      tag2(" />");
    } else {
      tag2(">");
      raw(media.label);
      tag2("</a>");
    }
    mediaStack.pop();
  }
  function onenterdefinition() {
    buffer();
    mediaStack.push({});
  }
  function onexitdefinitionlabelstring(token) {
    resume();
    mediaStack[mediaStack.length - 1].labelId = this.sliceSerialize(token);
  }
  function onenterdefinitiondestinationstring() {
    buffer();
    setData("ignoreEncode", true);
  }
  function onexitdefinitiondestinationstring() {
    mediaStack[mediaStack.length - 1].destination = resume();
    setData("ignoreEncode");
  }
  function onexitdefinitiontitlestring() {
    mediaStack[mediaStack.length - 1].title = resume();
  }
  function onexitdefinition() {
    const media = mediaStack[mediaStack.length - 1];
    const id2 = normalizeIdentifier(media.labelId);
    resume();
    if (!hasOwnProperty.call(definitions, id2)) {
      definitions[id2] = mediaStack[mediaStack.length - 1];
    }
    mediaStack.pop();
  }
  function onentercontent() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheadingsequence(token) {
    if (getData("headingRank")) return;
    setData("headingRank", this.sliceSerialize(token).length);
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
  }
  function onentersetextheading() {
    buffer();
    setData("slurpAllLineEndings");
  }
  function onexitsetextheadingtext() {
    setData("slurpAllLineEndings", true);
  }
  function onexitatxheading() {
    tag2("</h" + getData("headingRank") + ">");
    setData("headingRank");
  }
  function onexitsetextheadinglinesequence(token) {
    setData("headingRank", this.sliceSerialize(token).charCodeAt(0) === 61 ? 1 : 2);
  }
  function onexitsetextheading() {
    const value = resume();
    lineEndingIfNeeded();
    tag2("<h" + getData("headingRank") + ">");
    raw(value);
    tag2("</h" + getData("headingRank") + ">");
    setData("slurpAllLineEndings");
    setData("headingRank");
  }
  function onexitdata(token) {
    raw(encode$12(this.sliceSerialize(token)));
  }
  function onexitlineending(token) {
    if (getData("slurpAllLineEndings")) {
      return;
    }
    if (getData("slurpOneLineEnding")) {
      setData("slurpOneLineEnding");
      return;
    }
    if (getData("inCodeText")) {
      raw(" ");
      return;
    }
    raw(encode$12(this.sliceSerialize(token)));
  }
  function onexitcodeflowvalue(token) {
    raw(encode$12(this.sliceSerialize(token)));
    setData("flowCodeSeenData", true);
  }
  function onexithardbreak() {
    tag2("<br />");
  }
  function onenterhtmlflow() {
    lineEndingIfNeeded();
    onenterhtml();
  }
  function onexithtml() {
    setData("ignoreEncode");
  }
  function onenterhtml() {
    if (settings.allowDangerousHtml) {
      setData("ignoreEncode", true);
    }
  }
  function onenteremphasis() {
    tag2("<em>");
  }
  function onenterstrong() {
    tag2("<strong>");
  }
  function onentercodetext() {
    setData("inCodeText", true);
    tag2("<code>");
  }
  function onexitcodetext() {
    setData("inCodeText");
    tag2("</code>");
  }
  function onexitemphasis() {
    tag2("</em>");
  }
  function onexitstrong() {
    tag2("</strong>");
  }
  function onexitthematicbreak() {
    lineEndingIfNeeded();
    tag2("<hr />");
  }
  function onexitcharacterreferencemarker(token) {
    setData("characterReferenceType", token.type);
  }
  function onexitcharacterreferencevalue(token) {
    const value = this.sliceSerialize(token);
    const decoded = getData("characterReferenceType") ? decodeNumericCharacterReference(value, getData("characterReferenceType") === "characterReferenceMarkerNumeric" ? 10 : 16) : decodeNamedCharacterReference(value);
    raw(encode$12(
      /** @type {string} */
      decoded
    ));
    setData("characterReferenceType");
  }
  function onexitautolinkprotocol(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri(uri, settings.allowDangerousProtocol ? void 0 : protocolHref) + '">');
    raw(encode$12(uri));
    tag2("</a>");
  }
  function onexitautolinkemail(token) {
    const uri = this.sliceSerialize(token);
    tag2('<a href="' + sanitizeUri("mailto:" + uri) + '">');
    raw(encode$12(uri));
    tag2("</a>");
  }
}
function factorySpace(effects, ok2, type, max2) {
  const limit = max2 ? max2 - 1 : Number.POSITIVE_INFINITY;
  let size2 = 0;
  return start;
  function start(code2) {
    if (markdownSpace(code2)) {
      effects.enter(type);
      return prefix(code2);
    }
    return ok2(code2);
  }
  function prefix(code2) {
    if (markdownSpace(code2) && size2++ < limit) {
      effects.consume(code2);
      return prefix;
    }
    effects.exit(type);
    return ok2(code2);
  }
}
const content$1 = {
  tokenize: initializeContent
};
function initializeContent(effects) {
  const contentStart = effects.attempt(this.parser.constructs.contentInitial, afterContentStartConstruct, paragraphInitial);
  let previous2;
  return contentStart;
  function afterContentStartConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, contentStart, "linePrefix");
  }
  function paragraphInitial(code2) {
    effects.enter("paragraph");
    return lineStart(code2);
  }
  function lineStart(code2) {
    const token = effects.enter("chunkText", {
      contentType: "text",
      previous: previous2
    });
    if (previous2) {
      previous2.next = token;
    }
    previous2 = token;
    return data(code2);
  }
  function data(code2) {
    if (code2 === null) {
      effects.exit("chunkText");
      effects.exit("paragraph");
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      effects.exit("chunkText");
      return lineStart;
    }
    effects.consume(code2);
    return data;
  }
}
const document$2 = {
  tokenize: initializeDocument
};
const containerConstruct = {
  tokenize: tokenizeContainer
};
function initializeDocument(effects) {
  const self2 = this;
  const stack = [];
  let continued = 0;
  let childFlow;
  let childToken;
  let lineStartOffset;
  return start;
  function start(code2) {
    if (continued < stack.length) {
      const item = stack[continued];
      self2.containerState = item[1];
      return effects.attempt(item[0].continuation, documentContinue, checkNewContainers)(code2);
    }
    return checkNewContainers(code2);
  }
  function documentContinue(code2) {
    continued++;
    if (self2.containerState._closeFlow) {
      self2.containerState._closeFlow = void 0;
      if (childFlow) {
        closeFlow();
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          point2 = self2.events[indexBeforeFlow][1].end;
          break;
        }
      }
      exitContainers(continued);
      let index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
      return checkNewContainers(code2);
    }
    return start(code2);
  }
  function checkNewContainers(code2) {
    if (continued === stack.length) {
      if (!childFlow) {
        return documentContinued(code2);
      }
      if (childFlow.currentConstruct && childFlow.currentConstruct.concrete) {
        return flowStart(code2);
      }
      self2.interrupt = Boolean(childFlow.currentConstruct && !childFlow._gfmTableDynamicInterruptHack);
    }
    self2.containerState = {};
    return effects.check(containerConstruct, thereIsANewContainer, thereIsNoNewContainer)(code2);
  }
  function thereIsANewContainer(code2) {
    if (childFlow) closeFlow();
    exitContainers(continued);
    return documentContinued(code2);
  }
  function thereIsNoNewContainer(code2) {
    self2.parser.lazy[self2.now().line] = continued !== stack.length;
    lineStartOffset = self2.now().offset;
    return flowStart(code2);
  }
  function documentContinued(code2) {
    self2.containerState = {};
    return effects.attempt(containerConstruct, containerContinue, flowStart)(code2);
  }
  function containerContinue(code2) {
    continued++;
    stack.push([self2.currentConstruct, self2.containerState]);
    return documentContinued(code2);
  }
  function flowStart(code2) {
    if (code2 === null) {
      if (childFlow) closeFlow();
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    childFlow = childFlow || self2.parser.flow(self2.now());
    effects.enter("chunkFlow", {
      _tokenizer: childFlow,
      contentType: "flow",
      previous: childToken
    });
    return flowContinue(code2);
  }
  function flowContinue(code2) {
    if (code2 === null) {
      writeToChild(effects.exit("chunkFlow"), true);
      exitContainers(0);
      effects.consume(code2);
      return;
    }
    if (markdownLineEnding(code2)) {
      effects.consume(code2);
      writeToChild(effects.exit("chunkFlow"));
      continued = 0;
      self2.interrupt = void 0;
      return start;
    }
    effects.consume(code2);
    return flowContinue;
  }
  function writeToChild(token, endOfFile) {
    const stream = self2.sliceStream(token);
    if (endOfFile) stream.push(null);
    token.previous = childToken;
    if (childToken) childToken.next = token;
    childToken = token;
    childFlow.defineSkip(token.start);
    childFlow.write(stream);
    if (self2.parser.lazy[token.start.line]) {
      let index2 = childFlow.events.length;
      while (index2--) {
        if (
          // The token starts before the line ending…
          childFlow.events[index2][1].start.offset < lineStartOffset && // …and either is not ended yet…
          (!childFlow.events[index2][1].end || // …or ends after it.
          childFlow.events[index2][1].end.offset > lineStartOffset)
        ) {
          return;
        }
      }
      const indexBeforeExits = self2.events.length;
      let indexBeforeFlow = indexBeforeExits;
      let seen;
      let point2;
      while (indexBeforeFlow--) {
        if (self2.events[indexBeforeFlow][0] === "exit" && self2.events[indexBeforeFlow][1].type === "chunkFlow") {
          if (seen) {
            point2 = self2.events[indexBeforeFlow][1].end;
            break;
          }
          seen = true;
        }
      }
      exitContainers(continued);
      index2 = indexBeforeExits;
      while (index2 < self2.events.length) {
        self2.events[index2][1].end = {
          ...point2
        };
        index2++;
      }
      splice(self2.events, indexBeforeFlow + 1, 0, self2.events.slice(indexBeforeExits));
      self2.events.length = index2;
    }
  }
  function exitContainers(size2) {
    let index2 = stack.length;
    while (index2-- > size2) {
      const entry = stack[index2];
      self2.containerState = entry[1];
      entry[0].exit.call(self2, effects);
    }
    stack.length = size2;
  }
  function closeFlow() {
    childFlow.write([null]);
    childToken = void 0;
    childFlow = void 0;
    self2.containerState._closeFlow = void 0;
  }
}
function tokenizeContainer(effects, ok2, nok) {
  return factorySpace(effects, effects.attempt(this.parser.constructs.document, ok2, nok), "linePrefix", this.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4);
}
function classifyCharacter(code2) {
  if (code2 === null || markdownLineEndingOrSpace(code2) || unicodeWhitespace(code2)) {
    return 1;
  }
  if (unicodePunctuation(code2)) {
    return 2;
  }
}
function resolveAll(constructs2, events2, context) {
  const called = [];
  let index2 = -1;
  while (++index2 < constructs2.length) {
    const resolve = constructs2[index2].resolveAll;
    if (resolve && !called.includes(resolve)) {
      events2 = resolve(events2, context);
      called.push(resolve);
    }
  }
  return events2;
}
const attention = {
  name: "attention",
  resolveAll: resolveAllAttention,
  tokenize: tokenizeAttention
};
function resolveAllAttention(events2, context) {
  let index2 = -1;
  let open;
  let group2;
  let text2;
  let openingSequence;
  let closingSequence;
  let use;
  let nextEvents;
  let offset2;
  while (++index2 < events2.length) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "attentionSequence" && events2[index2][1]._close) {
      open = index2;
      while (open--) {
        if (events2[open][0] === "exit" && events2[open][1].type === "attentionSequence" && events2[open][1]._open && // If the markers are the same:
        context.sliceSerialize(events2[open][1]).charCodeAt(0) === context.sliceSerialize(events2[index2][1]).charCodeAt(0)) {
          if ((events2[open][1]._close || events2[index2][1]._open) && (events2[index2][1].end.offset - events2[index2][1].start.offset) % 3 && !((events2[open][1].end.offset - events2[open][1].start.offset + events2[index2][1].end.offset - events2[index2][1].start.offset) % 3)) {
            continue;
          }
          use = events2[open][1].end.offset - events2[open][1].start.offset > 1 && events2[index2][1].end.offset - events2[index2][1].start.offset > 1 ? 2 : 1;
          const start = {
            ...events2[open][1].end
          };
          const end = {
            ...events2[index2][1].start
          };
          movePoint(start, -use);
          movePoint(end, use);
          openingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start,
            end: {
              ...events2[open][1].end
            }
          };
          closingSequence = {
            type: use > 1 ? "strongSequence" : "emphasisSequence",
            start: {
              ...events2[index2][1].start
            },
            end
          };
          text2 = {
            type: use > 1 ? "strongText" : "emphasisText",
            start: {
              ...events2[open][1].end
            },
            end: {
              ...events2[index2][1].start
            }
          };
          group2 = {
            type: use > 1 ? "strong" : "emphasis",
            start: {
              ...openingSequence.start
            },
            end: {
              ...closingSequence.end
            }
          };
          events2[open][1].end = {
            ...openingSequence.start
          };
          events2[index2][1].start = {
            ...closingSequence.end
          };
          nextEvents = [];
          if (events2[open][1].end.offset - events2[open][1].start.offset) {
            nextEvents = push(nextEvents, [["enter", events2[open][1], context], ["exit", events2[open][1], context]]);
          }
          nextEvents = push(nextEvents, [["enter", group2, context], ["enter", openingSequence, context], ["exit", openingSequence, context], ["enter", text2, context]]);
          nextEvents = push(nextEvents, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + 1, index2), context));
          nextEvents = push(nextEvents, [["exit", text2, context], ["enter", closingSequence, context], ["exit", closingSequence, context], ["exit", group2, context]]);
          if (events2[index2][1].end.offset - events2[index2][1].start.offset) {
            offset2 = 2;
            nextEvents = push(nextEvents, [["enter", events2[index2][1], context], ["exit", events2[index2][1], context]]);
          } else {
            offset2 = 0;
          }
          splice(events2, open - 1, index2 - open + 3, nextEvents);
          index2 = open + nextEvents.length - offset2 - 2;
          break;
        }
      }
    }
  }
  index2 = -1;
  while (++index2 < events2.length) {
    if (events2[index2][1].type === "attentionSequence") {
      events2[index2][1].type = "data";
    }
  }
  return events2;
}
function tokenizeAttention(effects, ok2) {
  const attentionMarkers2 = this.parser.constructs.attentionMarkers.null;
  const previous2 = this.previous;
  const before2 = classifyCharacter(previous2);
  let marker;
  return start;
  function start(code2) {
    marker = code2;
    effects.enter("attentionSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    const token = effects.exit("attentionSequence");
    const after2 = classifyCharacter(code2);
    const open = !after2 || after2 === 2 && before2 || attentionMarkers2.includes(code2);
    const close = !before2 || before2 === 2 && after2 || attentionMarkers2.includes(previous2);
    token._open = Boolean(marker === 42 ? open : open && (before2 || !close));
    token._close = Boolean(marker === 42 ? close : close && (after2 || !open));
    return ok2(code2);
  }
}
function movePoint(point2, offset2) {
  point2.column += offset2;
  point2.offset += offset2;
  point2._bufferIndex += offset2;
}
const autolink = {
  name: "autolink",
  tokenize: tokenizeAutolink
};
function tokenizeAutolink(effects, ok2, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("autolink");
    effects.enter("autolinkMarker");
    effects.consume(code2);
    effects.exit("autolinkMarker");
    effects.enter("autolinkProtocol");
    return open;
  }
  function open(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return schemeOrEmailAtext;
    }
    if (code2 === 64) {
      return nok(code2);
    }
    return emailAtext(code2);
  }
  function schemeOrEmailAtext(code2) {
    if (code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) {
      size2 = 1;
      return schemeInsideOrEmailAtext(code2);
    }
    return emailAtext(code2);
  }
  function schemeInsideOrEmailAtext(code2) {
    if (code2 === 58) {
      effects.consume(code2);
      size2 = 0;
      return urlInside;
    }
    if ((code2 === 43 || code2 === 45 || code2 === 46 || asciiAlphanumeric(code2)) && size2++ < 32) {
      effects.consume(code2);
      return schemeInsideOrEmailAtext;
    }
    size2 = 0;
    return emailAtext(code2);
  }
  function urlInside(code2) {
    if (code2 === 62) {
      effects.exit("autolinkProtocol");
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    if (code2 === null || code2 === 32 || code2 === 60 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return urlInside;
  }
  function emailAtext(code2) {
    if (code2 === 64) {
      effects.consume(code2);
      return emailAtSignOrDot;
    }
    if (asciiAtext(code2)) {
      effects.consume(code2);
      return emailAtext;
    }
    return nok(code2);
  }
  function emailAtSignOrDot(code2) {
    return asciiAlphanumeric(code2) ? emailLabel(code2) : nok(code2);
  }
  function emailLabel(code2) {
    if (code2 === 46) {
      effects.consume(code2);
      size2 = 0;
      return emailAtSignOrDot;
    }
    if (code2 === 62) {
      effects.exit("autolinkProtocol").type = "autolinkEmail";
      effects.enter("autolinkMarker");
      effects.consume(code2);
      effects.exit("autolinkMarker");
      effects.exit("autolink");
      return ok2;
    }
    return emailValue(code2);
  }
  function emailValue(code2) {
    if ((code2 === 45 || asciiAlphanumeric(code2)) && size2++ < 63) {
      const next = code2 === 45 ? emailValue : emailLabel;
      effects.consume(code2);
      return next;
    }
    return nok(code2);
  }
}
const blankLine = {
  partial: true,
  tokenize: tokenizeBlankLine
};
function tokenizeBlankLine(effects, ok2, nok) {
  return start;
  function start(code2) {
    return markdownSpace(code2) ? factorySpace(effects, after2, "linePrefix")(code2) : after2(code2);
  }
  function after2(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
const blockQuote = {
  continuation: {
    tokenize: tokenizeBlockQuoteContinuation
  },
  exit,
  name: "blockQuote",
  tokenize: tokenizeBlockQuoteStart
};
function tokenizeBlockQuoteStart(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === 62) {
      const state = self2.containerState;
      if (!state.open) {
        effects.enter("blockQuote", {
          _container: true
        });
        state.open = true;
      }
      effects.enter("blockQuotePrefix");
      effects.enter("blockQuoteMarker");
      effects.consume(code2);
      effects.exit("blockQuoteMarker");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    if (markdownSpace(code2)) {
      effects.enter("blockQuotePrefixWhitespace");
      effects.consume(code2);
      effects.exit("blockQuotePrefixWhitespace");
      effects.exit("blockQuotePrefix");
      return ok2;
    }
    effects.exit("blockQuotePrefix");
    return ok2(code2);
  }
}
function tokenizeBlockQuoteContinuation(effects, ok2, nok) {
  const self2 = this;
  return contStart;
  function contStart(code2) {
    if (markdownSpace(code2)) {
      return factorySpace(effects, contBefore, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
    }
    return contBefore(code2);
  }
  function contBefore(code2) {
    return effects.attempt(blockQuote, ok2, nok)(code2);
  }
}
function exit(effects) {
  effects.exit("blockQuote");
}
const characterEscape = {
  name: "characterEscape",
  tokenize: tokenizeCharacterEscape
};
function tokenizeCharacterEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("characterEscape");
    effects.enter("escapeMarker");
    effects.consume(code2);
    effects.exit("escapeMarker");
    return inside2;
  }
  function inside2(code2) {
    if (asciiPunctuation(code2)) {
      effects.enter("characterEscapeValue");
      effects.consume(code2);
      effects.exit("characterEscapeValue");
      effects.exit("characterEscape");
      return ok2;
    }
    return nok(code2);
  }
}
const characterReference = {
  name: "characterReference",
  tokenize: tokenizeCharacterReference
};
function tokenizeCharacterReference(effects, ok2, nok) {
  const self2 = this;
  let size2 = 0;
  let max2;
  let test;
  return start;
  function start(code2) {
    effects.enter("characterReference");
    effects.enter("characterReferenceMarker");
    effects.consume(code2);
    effects.exit("characterReferenceMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 35) {
      effects.enter("characterReferenceMarkerNumeric");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerNumeric");
      return numeric2;
    }
    effects.enter("characterReferenceValue");
    max2 = 31;
    test = asciiAlphanumeric;
    return value(code2);
  }
  function numeric2(code2) {
    if (code2 === 88 || code2 === 120) {
      effects.enter("characterReferenceMarkerHexadecimal");
      effects.consume(code2);
      effects.exit("characterReferenceMarkerHexadecimal");
      effects.enter("characterReferenceValue");
      max2 = 6;
      test = asciiHexDigit;
      return value;
    }
    effects.enter("characterReferenceValue");
    max2 = 7;
    test = asciiDigit;
    return value(code2);
  }
  function value(code2) {
    if (code2 === 59 && size2) {
      const token = effects.exit("characterReferenceValue");
      if (test === asciiAlphanumeric && !decodeNamedCharacterReference(self2.sliceSerialize(token))) {
        return nok(code2);
      }
      effects.enter("characterReferenceMarker");
      effects.consume(code2);
      effects.exit("characterReferenceMarker");
      effects.exit("characterReference");
      return ok2;
    }
    if (test(code2) && size2++ < max2) {
      effects.consume(code2);
      return value;
    }
    return nok(code2);
  }
}
const nonLazyContinuation = {
  partial: true,
  tokenize: tokenizeNonLazyContinuation
};
const codeFenced = {
  concrete: true,
  name: "codeFenced",
  tokenize: tokenizeCodeFenced
};
function tokenizeCodeFenced(effects, ok2, nok) {
  const self2 = this;
  const closeStart = {
    partial: true,
    tokenize: tokenizeCloseStart
  };
  let initialPrefix = 0;
  let sizeOpen = 0;
  let marker;
  return start;
  function start(code2) {
    return beforeSequenceOpen(code2);
  }
  function beforeSequenceOpen(code2) {
    const tail = self2.events[self2.events.length - 1];
    initialPrefix = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
    marker = code2;
    effects.enter("codeFenced");
    effects.enter("codeFencedFence");
    effects.enter("codeFencedFenceSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === marker) {
      sizeOpen++;
      effects.consume(code2);
      return sequenceOpen;
    }
    if (sizeOpen < 3) {
      return nok(code2);
    }
    effects.exit("codeFencedFenceSequence");
    return markdownSpace(code2) ? factorySpace(effects, infoBefore, "whitespace")(code2) : infoBefore(code2);
  }
  function infoBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFencedFence");
      return self2.interrupt ? ok2(code2) : effects.check(nonLazyContinuation, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFencedFenceInfo");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return info(code2);
  }
  function info(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return infoBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceInfo");
      return factorySpace(effects, metaBefore, "whitespace")(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return info;
  }
  function metaBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return infoBefore(code2);
    }
    effects.enter("codeFencedFenceMeta");
    effects.enter("chunkString", {
      contentType: "string"
    });
    return meta2(code2);
  }
  function meta2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      effects.exit("codeFencedFenceMeta");
      return infoBefore(code2);
    }
    if (code2 === 96 && code2 === marker) {
      return nok(code2);
    }
    effects.consume(code2);
    return meta2;
  }
  function atNonLazyBreak(code2) {
    return effects.attempt(closeStart, after2, contentBefore)(code2);
  }
  function contentBefore(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return contentStart;
  }
  function contentStart(code2) {
    return initialPrefix > 0 && markdownSpace(code2) ? factorySpace(effects, beforeContentChunk, "linePrefix", initialPrefix + 1)(code2) : beforeContentChunk(code2);
  }
  function beforeContentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return effects.check(nonLazyContinuation, atNonLazyBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return contentChunk(code2);
  }
  function contentChunk(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return beforeContentChunk(code2);
    }
    effects.consume(code2);
    return contentChunk;
  }
  function after2(code2) {
    effects.exit("codeFenced");
    return ok2(code2);
  }
  function tokenizeCloseStart(effects2, ok22, nok2) {
    let size2 = 0;
    return startBefore;
    function startBefore(code2) {
      effects2.enter("lineEnding");
      effects2.consume(code2);
      effects2.exit("lineEnding");
      return start2;
    }
    function start2(code2) {
      effects2.enter("codeFencedFence");
      return markdownSpace(code2) ? factorySpace(effects2, beforeSequenceClose, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : beforeSequenceClose(code2);
    }
    function beforeSequenceClose(code2) {
      if (code2 === marker) {
        effects2.enter("codeFencedFenceSequence");
        return sequenceClose(code2);
      }
      return nok2(code2);
    }
    function sequenceClose(code2) {
      if (code2 === marker) {
        size2++;
        effects2.consume(code2);
        return sequenceClose;
      }
      if (size2 >= sizeOpen) {
        effects2.exit("codeFencedFenceSequence");
        return markdownSpace(code2) ? factorySpace(effects2, sequenceCloseAfter, "whitespace")(code2) : sequenceCloseAfter(code2);
      }
      return nok2(code2);
    }
    function sequenceCloseAfter(code2) {
      if (code2 === null || markdownLineEnding(code2)) {
        effects2.exit("codeFencedFence");
        return ok22(code2);
      }
      return nok2(code2);
    }
  }
}
function tokenizeNonLazyContinuation(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineStart;
  }
  function lineStart(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
const codeIndented = {
  name: "codeIndented",
  tokenize: tokenizeCodeIndented
};
const furtherStart = {
  partial: true,
  tokenize: tokenizeFurtherStart
};
function tokenizeCodeIndented(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("codeIndented");
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? atBreak(code2) : nok(code2);
  }
  function atBreak(code2) {
    if (code2 === null) {
      return after2(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.attempt(furtherStart, atBreak, after2)(code2);
    }
    effects.enter("codeFlowValue");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("codeFlowValue");
      return atBreak(code2);
    }
    effects.consume(code2);
    return inside2;
  }
  function after2(code2) {
    effects.exit("codeIndented");
    return ok2(code2);
  }
}
function tokenizeFurtherStart(effects, ok2, nok) {
  const self2 = this;
  return furtherStart2;
  function furtherStart2(code2) {
    if (self2.parser.lazy[self2.now().line]) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return furtherStart2;
    }
    return factorySpace(effects, afterPrefix, "linePrefix", 4 + 1)(code2);
  }
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4 ? ok2(code2) : markdownLineEnding(code2) ? furtherStart2(code2) : nok(code2);
  }
}
const codeText = {
  name: "codeText",
  previous,
  resolve: resolveCodeText,
  tokenize: tokenizeCodeText
};
function resolveCodeText(events2) {
  let tailExitIndex = events2.length - 4;
  let headEnterIndex = 3;
  let index2;
  let enter;
  if ((events2[headEnterIndex][1].type === "lineEnding" || events2[headEnterIndex][1].type === "space") && (events2[tailExitIndex][1].type === "lineEnding" || events2[tailExitIndex][1].type === "space")) {
    index2 = headEnterIndex;
    while (++index2 < tailExitIndex) {
      if (events2[index2][1].type === "codeTextData") {
        events2[headEnterIndex][1].type = "codeTextPadding";
        events2[tailExitIndex][1].type = "codeTextPadding";
        headEnterIndex += 2;
        tailExitIndex -= 2;
        break;
      }
    }
  }
  index2 = headEnterIndex - 1;
  tailExitIndex++;
  while (++index2 <= tailExitIndex) {
    if (enter === void 0) {
      if (index2 !== tailExitIndex && events2[index2][1].type !== "lineEnding") {
        enter = index2;
      }
    } else if (index2 === tailExitIndex || events2[index2][1].type === "lineEnding") {
      events2[enter][1].type = "codeTextData";
      if (index2 !== enter + 2) {
        events2[enter][1].end = events2[index2 - 1][1].end;
        events2.splice(enter + 2, index2 - enter - 2);
        tailExitIndex -= index2 - enter - 2;
        index2 = enter + 2;
      }
      enter = void 0;
    }
  }
  return events2;
}
function previous(code2) {
  return code2 !== 96 || this.events[this.events.length - 1][1].type === "characterEscape";
}
function tokenizeCodeText(effects, ok2, nok) {
  let sizeOpen = 0;
  let size2;
  let token;
  return start;
  function start(code2) {
    effects.enter("codeText");
    effects.enter("codeTextSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      sizeOpen++;
      return sequenceOpen;
    }
    effects.exit("codeTextSequence");
    return between(code2);
  }
  function between(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 32) {
      effects.enter("space");
      effects.consume(code2);
      effects.exit("space");
      return between;
    }
    if (code2 === 96) {
      token = effects.enter("codeTextSequence");
      size2 = 0;
      return sequenceClose(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return between;
    }
    effects.enter("codeTextData");
    return data(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 32 || code2 === 96 || markdownLineEnding(code2)) {
      effects.exit("codeTextData");
      return between(code2);
    }
    effects.consume(code2);
    return data;
  }
  function sequenceClose(code2) {
    if (code2 === 96) {
      effects.consume(code2);
      size2++;
      return sequenceClose;
    }
    if (size2 === sizeOpen) {
      effects.exit("codeTextSequence");
      effects.exit("codeText");
      return ok2(code2);
    }
    token.type = "codeTextData";
    return data(code2);
  }
}
class SpliceBuffer {
  /**
   * @param {ReadonlyArray<T> | null | undefined} [initial]
   *   Initial items (optional).
   * @returns
   *   Splice buffer.
   */
  constructor(initial2) {
    this.left = initial2 ? [...initial2] : [];
    this.right = [];
  }
  /**
   * Array access;
   * does not move the cursor.
   *
   * @param {number} index
   *   Index.
   * @return {T}
   *   Item.
   */
  get(index2) {
    if (index2 < 0 || index2 >= this.left.length + this.right.length) {
      throw new RangeError("Cannot access index `" + index2 + "` in a splice buffer of size `" + (this.left.length + this.right.length) + "`");
    }
    if (index2 < this.left.length) return this.left[index2];
    return this.right[this.right.length - index2 + this.left.length - 1];
  }
  /**
   * The length of the splice buffer, one greater than the largest index in the
   * array.
   */
  get length() {
    return this.left.length + this.right.length;
  }
  /**
   * Remove and return `list[0]`;
   * moves the cursor to `0`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  shift() {
    this.setCursor(0);
    return this.right.pop();
  }
  /**
   * Slice the buffer to get an array;
   * does not move the cursor.
   *
   * @param {number} start
   *   Start.
   * @param {number | null | undefined} [end]
   *   End (optional).
   * @returns {Array<T>}
   *   Array of items.
   */
  slice(start, end) {
    const stop = end === null || end === void 0 ? Number.POSITIVE_INFINITY : end;
    if (stop < this.left.length) {
      return this.left.slice(start, stop);
    }
    if (start > this.left.length) {
      return this.right.slice(this.right.length - stop + this.left.length, this.right.length - start + this.left.length).reverse();
    }
    return this.left.slice(start).concat(this.right.slice(this.right.length - stop + this.left.length).reverse());
  }
  /**
   * Mimics the behavior of Array.prototype.splice() except for the change of
   * interface necessary to avoid segfaults when patching in very large arrays.
   *
   * This operation moves cursor is moved to `start` and results in the cursor
   * placed after any inserted items.
   *
   * @param {number} start
   *   Start;
   *   zero-based index at which to start changing the array;
   *   negative numbers count backwards from the end of the array and values
   *   that are out-of bounds are clamped to the appropriate end of the array.
   * @param {number | null | undefined} [deleteCount=0]
   *   Delete count (default: `0`);
   *   maximum number of elements to delete, starting from start.
   * @param {Array<T> | null | undefined} [items=[]]
   *   Items to include in place of the deleted items (default: `[]`).
   * @return {Array<T>}
   *   Any removed items.
   */
  splice(start, deleteCount, items) {
    const count = deleteCount || 0;
    this.setCursor(Math.trunc(start));
    const removed = this.right.splice(this.right.length - count, Number.POSITIVE_INFINITY);
    if (items) chunkedPush(this.left, items);
    return removed.reverse();
  }
  /**
   * Remove and return the highest-numbered item in the array, so
   * `list[list.length - 1]`;
   * Moves the cursor to `length`.
   *
   * @returns {T | undefined}
   *   Item, optional.
   */
  pop() {
    this.setCursor(Number.POSITIVE_INFINITY);
    return this.left.pop();
  }
  /**
   * Inserts a single item to the high-numbered side of the array;
   * moves the cursor to `length`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  push(item) {
    this.setCursor(Number.POSITIVE_INFINITY);
    this.left.push(item);
  }
  /**
   * Inserts many items to the high-numbered side of the array.
   * Moves the cursor to `length`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  pushMany(items) {
    this.setCursor(Number.POSITIVE_INFINITY);
    chunkedPush(this.left, items);
  }
  /**
   * Inserts a single item to the low-numbered side of the array;
   * Moves the cursor to `0`.
   *
   * @param {T} item
   *   Item.
   * @returns {undefined}
   *   Nothing.
   */
  unshift(item) {
    this.setCursor(0);
    this.right.push(item);
  }
  /**
   * Inserts many items to the low-numbered side of the array;
   * moves the cursor to `0`.
   *
   * @param {Array<T>} items
   *   Items.
   * @returns {undefined}
   *   Nothing.
   */
  unshiftMany(items) {
    this.setCursor(0);
    chunkedPush(this.right, items.reverse());
  }
  /**
   * Move the cursor to a specific position in the array. Requires
   * time proportional to the distance moved.
   *
   * If `n < 0`, the cursor will end up at the beginning.
   * If `n > length`, the cursor will end up at the end.
   *
   * @param {number} n
   *   Position.
   * @return {undefined}
   *   Nothing.
   */
  setCursor(n2) {
    if (n2 === this.left.length || n2 > this.left.length && this.right.length === 0 || n2 < 0 && this.left.length === 0) return;
    if (n2 < this.left.length) {
      const removed = this.left.splice(n2, Number.POSITIVE_INFINITY);
      chunkedPush(this.right, removed.reverse());
    } else {
      const removed = this.right.splice(this.left.length + this.right.length - n2, Number.POSITIVE_INFINITY);
      chunkedPush(this.left, removed.reverse());
    }
  }
}
function chunkedPush(list2, right) {
  let chunkStart = 0;
  if (right.length < 1e4) {
    list2.push(...right);
  } else {
    while (chunkStart < right.length) {
      list2.push(...right.slice(chunkStart, chunkStart + 1e4));
      chunkStart += 1e4;
    }
  }
}
function subtokenize(eventsArray) {
  const jumps = {};
  let index2 = -1;
  let event;
  let lineIndex;
  let otherIndex;
  let otherEvent;
  let parameters;
  let subevents;
  let more;
  const events2 = new SpliceBuffer(eventsArray);
  while (++index2 < events2.length) {
    while (index2 in jumps) {
      index2 = jumps[index2];
    }
    event = events2.get(index2);
    if (index2 && event[1].type === "chunkFlow" && events2.get(index2 - 1)[1].type === "listItemPrefix") {
      subevents = event[1]._tokenizer.events;
      otherIndex = 0;
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "lineEndingBlank") {
        otherIndex += 2;
      }
      if (otherIndex < subevents.length && subevents[otherIndex][1].type === "content") {
        while (++otherIndex < subevents.length) {
          if (subevents[otherIndex][1].type === "content") {
            break;
          }
          if (subevents[otherIndex][1].type === "chunkText") {
            subevents[otherIndex][1]._isInFirstContentOfListItem = true;
            otherIndex++;
          }
        }
      }
    }
    if (event[0] === "enter") {
      if (event[1].contentType) {
        Object.assign(jumps, subcontent(events2, index2));
        index2 = jumps[index2];
        more = true;
      }
    } else if (event[1]._container) {
      otherIndex = index2;
      lineIndex = void 0;
      while (otherIndex--) {
        otherEvent = events2.get(otherIndex);
        if (otherEvent[1].type === "lineEnding" || otherEvent[1].type === "lineEndingBlank") {
          if (otherEvent[0] === "enter") {
            if (lineIndex) {
              events2.get(lineIndex)[1].type = "lineEndingBlank";
            }
            otherEvent[1].type = "lineEnding";
            lineIndex = otherIndex;
          }
        } else if (otherEvent[1].type === "linePrefix" || otherEvent[1].type === "listItemIndent") ;
        else {
          break;
        }
      }
      if (lineIndex) {
        event[1].end = {
          ...events2.get(lineIndex)[1].start
        };
        parameters = events2.slice(lineIndex, index2);
        parameters.unshift(event);
        events2.splice(lineIndex, index2 - lineIndex + 1, parameters);
      }
    }
  }
  splice(eventsArray, 0, Number.POSITIVE_INFINITY, events2.slice(0));
  return !more;
}
function subcontent(events2, eventIndex) {
  const token = events2.get(eventIndex)[1];
  const context = events2.get(eventIndex)[2];
  let startPosition = eventIndex - 1;
  const startPositions = [];
  let tokenizer = token._tokenizer;
  if (!tokenizer) {
    tokenizer = context.parser[token.contentType](token.start);
    if (token._contentTypeTextTrailing) {
      tokenizer._contentTypeTextTrailing = true;
    }
  }
  const childEvents = tokenizer.events;
  const jumps = [];
  const gaps = {};
  let stream;
  let previous2;
  let index2 = -1;
  let current2 = token;
  let adjust = 0;
  let start = 0;
  const breaks = [start];
  while (current2) {
    while (events2.get(++startPosition)[1] !== current2) {
    }
    startPositions.push(startPosition);
    if (!current2._tokenizer) {
      stream = context.sliceStream(current2);
      if (!current2.next) {
        stream.push(null);
      }
      if (previous2) {
        tokenizer.defineSkip(current2.start);
      }
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = true;
      }
      tokenizer.write(stream);
      if (current2._isInFirstContentOfListItem) {
        tokenizer._gfmTasklistFirstContentOfListItem = void 0;
      }
    }
    previous2 = current2;
    current2 = current2.next;
  }
  current2 = token;
  while (++index2 < childEvents.length) {
    if (
      // Find a void token that includes a break.
      childEvents[index2][0] === "exit" && childEvents[index2 - 1][0] === "enter" && childEvents[index2][1].type === childEvents[index2 - 1][1].type && childEvents[index2][1].start.line !== childEvents[index2][1].end.line
    ) {
      start = index2 + 1;
      breaks.push(start);
      current2._tokenizer = void 0;
      current2.previous = void 0;
      current2 = current2.next;
    }
  }
  tokenizer.events = [];
  if (current2) {
    current2._tokenizer = void 0;
    current2.previous = void 0;
  } else {
    breaks.pop();
  }
  index2 = breaks.length;
  while (index2--) {
    const slice2 = childEvents.slice(breaks[index2], breaks[index2 + 1]);
    const start2 = startPositions.pop();
    jumps.push([start2, start2 + slice2.length - 1]);
    events2.splice(start2, 2, slice2);
  }
  jumps.reverse();
  index2 = -1;
  while (++index2 < jumps.length) {
    gaps[adjust + jumps[index2][0]] = adjust + jumps[index2][1];
    adjust += jumps[index2][1] - jumps[index2][0] - 1;
  }
  return gaps;
}
const content = {
  resolve: resolveContent,
  tokenize: tokenizeContent
};
const continuationConstruct = {
  partial: true,
  tokenize: tokenizeContinuation
};
function resolveContent(events2) {
  subtokenize(events2);
  return events2;
}
function tokenizeContent(effects, ok2) {
  let previous2;
  return chunkStart;
  function chunkStart(code2) {
    effects.enter("content");
    previous2 = effects.enter("chunkContent", {
      contentType: "content"
    });
    return chunkInside(code2);
  }
  function chunkInside(code2) {
    if (code2 === null) {
      return contentEnd(code2);
    }
    if (markdownLineEnding(code2)) {
      return effects.check(continuationConstruct, contentContinue, contentEnd)(code2);
    }
    effects.consume(code2);
    return chunkInside;
  }
  function contentEnd(code2) {
    effects.exit("chunkContent");
    effects.exit("content");
    return ok2(code2);
  }
  function contentContinue(code2) {
    effects.consume(code2);
    effects.exit("chunkContent");
    previous2.next = effects.enter("chunkContent", {
      contentType: "content",
      previous: previous2
    });
    previous2 = previous2.next;
    return chunkInside;
  }
}
function tokenizeContinuation(effects, ok2, nok) {
  const self2 = this;
  return startLookahead;
  function startLookahead(code2) {
    effects.exit("chunkContent");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, prefixed, "linePrefix");
  }
  function prefixed(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    const tail = self2.events[self2.events.length - 1];
    if (!self2.parser.constructs.disable.null.includes("codeIndented") && tail && tail[1].type === "linePrefix" && tail[2].sliceSerialize(tail[1], true).length >= 4) {
      return ok2(code2);
    }
    return effects.interrupt(self2.parser.constructs.flow, nok, ok2)(code2);
  }
}
function factoryDestination(effects, ok2, nok, type, literalType, literalMarkerType, rawType, stringType, max2) {
  const limit = max2 || Number.POSITIVE_INFINITY;
  let balance = 0;
  return start;
  function start(code2) {
    if (code2 === 60) {
      effects.enter(type);
      effects.enter(literalType);
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      return enclosedBefore;
    }
    if (code2 === null || code2 === 32 || code2 === 41 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.enter(type);
    effects.enter(rawType);
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return raw(code2);
  }
  function enclosedBefore(code2) {
    if (code2 === 62) {
      effects.enter(literalMarkerType);
      effects.consume(code2);
      effects.exit(literalMarkerType);
      effects.exit(literalType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    effects.enter("chunkString", {
      contentType: "string"
    });
    return enclosed(code2);
  }
  function enclosed(code2) {
    if (code2 === 62) {
      effects.exit("chunkString");
      effects.exit(stringType);
      return enclosedBefore(code2);
    }
    if (code2 === null || code2 === 60 || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? enclosedEscape : enclosed;
  }
  function enclosedEscape(code2) {
    if (code2 === 60 || code2 === 62 || code2 === 92) {
      effects.consume(code2);
      return enclosed;
    }
    return enclosed(code2);
  }
  function raw(code2) {
    if (!balance && (code2 === null || code2 === 41 || markdownLineEndingOrSpace(code2))) {
      effects.exit("chunkString");
      effects.exit(stringType);
      effects.exit(rawType);
      effects.exit(type);
      return ok2(code2);
    }
    if (balance < limit && code2 === 40) {
      effects.consume(code2);
      balance++;
      return raw;
    }
    if (code2 === 41) {
      effects.consume(code2);
      balance--;
      return raw;
    }
    if (code2 === null || code2 === 32 || code2 === 40 || asciiControl(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? rawEscape : raw;
  }
  function rawEscape(code2) {
    if (code2 === 40 || code2 === 41 || code2 === 92) {
      effects.consume(code2);
      return raw;
    }
    return raw(code2);
  }
}
function factoryLabel(effects, ok2, nok, type, markerType, stringType) {
  const self2 = this;
  let size2 = 0;
  let seen;
  return start;
  function start(code2) {
    effects.enter(type);
    effects.enter(markerType);
    effects.consume(code2);
    effects.exit(markerType);
    effects.enter(stringType);
    return atBreak;
  }
  function atBreak(code2) {
    if (size2 > 999 || code2 === null || code2 === 91 || code2 === 93 && !seen || // To do: remove in the future once we’ve switched from
    // `micromark-extension-footnote` to `micromark-extension-gfm-footnote`,
    // which doesn’t need this.
    // Hidden footnotes hook.
    /* c8 ignore next 3 */
    code2 === 94 && !size2 && "_hiddenFootnoteSupport" in self2.parser.constructs) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.exit(stringType);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return atBreak;
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return labelInside(code2);
  }
  function labelInside(code2) {
    if (code2 === null || code2 === 91 || code2 === 93 || markdownLineEnding(code2) || size2++ > 999) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    if (!seen) seen = !markdownSpace(code2);
    return code2 === 92 ? labelEscape : labelInside;
  }
  function labelEscape(code2) {
    if (code2 === 91 || code2 === 92 || code2 === 93) {
      effects.consume(code2);
      size2++;
      return labelInside;
    }
    return labelInside(code2);
  }
}
function factoryTitle(effects, ok2, nok, type, markerType, stringType) {
  let marker;
  return start;
  function start(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      effects.enter(type);
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      marker = code2 === 40 ? 41 : code2;
      return begin;
    }
    return nok(code2);
  }
  function begin(code2) {
    if (code2 === marker) {
      effects.enter(markerType);
      effects.consume(code2);
      effects.exit(markerType);
      effects.exit(type);
      return ok2;
    }
    effects.enter(stringType);
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.exit(stringType);
      return begin(marker);
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return factorySpace(effects, atBreak, "linePrefix");
    }
    effects.enter("chunkString", {
      contentType: "string"
    });
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker || code2 === null || markdownLineEnding(code2)) {
      effects.exit("chunkString");
      return atBreak(code2);
    }
    effects.consume(code2);
    return code2 === 92 ? escape2 : inside2;
  }
  function escape2(code2) {
    if (code2 === marker || code2 === 92) {
      effects.consume(code2);
      return inside2;
    }
    return inside2(code2);
  }
}
function factoryWhitespace(effects, ok2) {
  let seen;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      seen = true;
      return start;
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, start, seen ? "linePrefix" : "lineSuffix")(code2);
    }
    return ok2(code2);
  }
}
const definition = {
  name: "definition",
  tokenize: tokenizeDefinition
};
const titleBefore = {
  partial: true,
  tokenize: tokenizeTitleBefore
};
function tokenizeDefinition(effects, ok2, nok) {
  const self2 = this;
  let identifier;
  return start;
  function start(code2) {
    effects.enter("definition");
    return before2(code2);
  }
  function before2(code2) {
    return factoryLabel.call(
      self2,
      effects,
      labelAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionLabel",
      "definitionLabelMarker",
      "definitionLabelString"
    )(code2);
  }
  function labelAfter(code2) {
    identifier = normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1));
    if (code2 === 58) {
      effects.enter("definitionMarker");
      effects.consume(code2);
      effects.exit("definitionMarker");
      return markerAfter;
    }
    return nok(code2);
  }
  function markerAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, destinationBefore)(code2) : destinationBefore(code2);
  }
  function destinationBefore(code2) {
    return factoryDestination(
      effects,
      destinationAfter,
      // Note: we don’t need to reset the way `markdown-rs` does.
      nok,
      "definitionDestination",
      "definitionDestinationLiteral",
      "definitionDestinationLiteralMarker",
      "definitionDestinationRaw",
      "definitionDestinationString"
    )(code2);
  }
  function destinationAfter(code2) {
    return effects.attempt(titleBefore, after2, after2)(code2);
  }
  function after2(code2) {
    return markdownSpace(code2) ? factorySpace(effects, afterWhitespace, "whitespace")(code2) : afterWhitespace(code2);
  }
  function afterWhitespace(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("definition");
      self2.parser.defined.push(identifier);
      return ok2(code2);
    }
    return nok(code2);
  }
}
function tokenizeTitleBefore(effects, ok2, nok) {
  return titleBefore2;
  function titleBefore2(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, beforeMarker)(code2) : nok(code2);
  }
  function beforeMarker(code2) {
    return factoryTitle(effects, titleAfter, nok, "definitionTitle", "definitionTitleMarker", "definitionTitleString")(code2);
  }
  function titleAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, titleAfterOptionalWhitespace, "whitespace")(code2) : titleAfterOptionalWhitespace(code2);
  }
  function titleAfterOptionalWhitespace(code2) {
    return code2 === null || markdownLineEnding(code2) ? ok2(code2) : nok(code2);
  }
}
const hardBreakEscape = {
  name: "hardBreakEscape",
  tokenize: tokenizeHardBreakEscape
};
function tokenizeHardBreakEscape(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("hardBreakEscape");
    effects.consume(code2);
    return after2;
  }
  function after2(code2) {
    if (markdownLineEnding(code2)) {
      effects.exit("hardBreakEscape");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const headingAtx = {
  name: "headingAtx",
  resolve: resolveHeadingAtx,
  tokenize: tokenizeHeadingAtx
};
function resolveHeadingAtx(events2, context) {
  let contentEnd = events2.length - 2;
  let contentStart = 3;
  let content2;
  let text2;
  if (events2[contentStart][1].type === "whitespace") {
    contentStart += 2;
  }
  if (contentEnd - 2 > contentStart && events2[contentEnd][1].type === "whitespace") {
    contentEnd -= 2;
  }
  if (events2[contentEnd][1].type === "atxHeadingSequence" && (contentStart === contentEnd - 1 || contentEnd - 4 > contentStart && events2[contentEnd - 2][1].type === "whitespace")) {
    contentEnd -= contentStart + 1 === contentEnd ? 2 : 4;
  }
  if (contentEnd > contentStart) {
    content2 = {
      type: "atxHeadingText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end
    };
    text2 = {
      type: "chunkText",
      start: events2[contentStart][1].start,
      end: events2[contentEnd][1].end,
      contentType: "text"
    };
    splice(events2, contentStart, contentEnd - contentStart + 1, [["enter", content2, context], ["enter", text2, context], ["exit", text2, context], ["exit", content2, context]]);
  }
  return events2;
}
function tokenizeHeadingAtx(effects, ok2, nok) {
  let size2 = 0;
  return start;
  function start(code2) {
    effects.enter("atxHeading");
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("atxHeadingSequence");
    return sequenceOpen(code2);
  }
  function sequenceOpen(code2) {
    if (code2 === 35 && size2++ < 6) {
      effects.consume(code2);
      return sequenceOpen;
    }
    if (code2 === null || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingSequence");
      return atBreak(code2);
    }
    return nok(code2);
  }
  function atBreak(code2) {
    if (code2 === 35) {
      effects.enter("atxHeadingSequence");
      return sequenceFurther(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("atxHeading");
      return ok2(code2);
    }
    if (markdownSpace(code2)) {
      return factorySpace(effects, atBreak, "whitespace")(code2);
    }
    effects.enter("atxHeadingText");
    return data(code2);
  }
  function sequenceFurther(code2) {
    if (code2 === 35) {
      effects.consume(code2);
      return sequenceFurther;
    }
    effects.exit("atxHeadingSequence");
    return atBreak(code2);
  }
  function data(code2) {
    if (code2 === null || code2 === 35 || markdownLineEndingOrSpace(code2)) {
      effects.exit("atxHeadingText");
      return atBreak(code2);
    }
    effects.consume(code2);
    return data;
  }
}
const htmlBlockNames = [
  "address",
  "article",
  "aside",
  "base",
  "basefont",
  "blockquote",
  "body",
  "caption",
  "center",
  "col",
  "colgroup",
  "dd",
  "details",
  "dialog",
  "dir",
  "div",
  "dl",
  "dt",
  "fieldset",
  "figcaption",
  "figure",
  "footer",
  "form",
  "frame",
  "frameset",
  "h1",
  "h2",
  "h3",
  "h4",
  "h5",
  "h6",
  "head",
  "header",
  "hr",
  "html",
  "iframe",
  "legend",
  "li",
  "link",
  "main",
  "menu",
  "menuitem",
  "nav",
  "noframes",
  "ol",
  "optgroup",
  "option",
  "p",
  "param",
  "search",
  "section",
  "summary",
  "table",
  "tbody",
  "td",
  "tfoot",
  "th",
  "thead",
  "title",
  "tr",
  "track",
  "ul"
];
const htmlRawNames = ["pre", "script", "style", "textarea"];
const htmlFlow = {
  concrete: true,
  name: "htmlFlow",
  resolveTo: resolveToHtmlFlow,
  tokenize: tokenizeHtmlFlow
};
const blankLineBefore = {
  partial: true,
  tokenize: tokenizeBlankLineBefore
};
const nonLazyContinuationStart = {
  partial: true,
  tokenize: tokenizeNonLazyContinuationStart
};
function resolveToHtmlFlow(events2) {
  let index2 = events2.length;
  while (index2--) {
    if (events2[index2][0] === "enter" && events2[index2][1].type === "htmlFlow") {
      break;
    }
  }
  if (index2 > 1 && events2[index2 - 2][1].type === "linePrefix") {
    events2[index2][1].start = events2[index2 - 2][1].start;
    events2[index2 + 1][1].start = events2[index2 - 2][1].start;
    events2.splice(index2 - 2, 2);
  }
  return events2;
}
function tokenizeHtmlFlow(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let closingTag;
  let buffer;
  let index2;
  let markerB;
  return start;
  function start(code2) {
    return before2(code2);
  }
  function before2(code2) {
    effects.enter("htmlFlow");
    effects.enter("htmlFlowData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      closingTag = true;
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      marker = 3;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      marker = 2;
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      marker = 5;
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      marker = 4;
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuationDeclarationInside;
    }
    return nok(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      if (index2 === value.length) {
        return self2.interrupt ? ok2 : continuation;
      }
      return cdataOpenInside;
    }
    return nok(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      buffer = String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function tagName(code2) {
    if (code2 === null || code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      const slash = code2 === 47;
      const name2 = buffer.toLowerCase();
      if (!slash && !closingTag && htmlRawNames.includes(name2)) {
        marker = 1;
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      if (htmlBlockNames.includes(buffer.toLowerCase())) {
        marker = 6;
        if (slash) {
          effects.consume(code2);
          return basicSelfClosing;
        }
        return self2.interrupt ? ok2(code2) : continuation(code2);
      }
      marker = 7;
      return self2.interrupt && !self2.parser.lazy[self2.now().line] ? nok(code2) : closingTag ? completeClosingTagAfter(code2) : completeAttributeNameBefore(code2);
    }
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return tagName;
    }
    return nok(code2);
  }
  function basicSelfClosing(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return self2.interrupt ? ok2 : continuation;
    }
    return nok(code2);
  }
  function completeClosingTagAfter(code2) {
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeClosingTagAfter;
    }
    return completeEnd(code2);
  }
  function completeAttributeNameBefore(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return completeEnd;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameBefore;
    }
    return completeEnd(code2);
  }
  function completeAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return completeAttributeName;
    }
    return completeAttributeNameAfter(code2);
  }
  function completeAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeNameAfter;
    }
    return completeAttributeNameBefore(code2);
  }
  function completeAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      markerB = code2;
      return completeAttributeValueQuoted;
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAttributeValueBefore;
    }
    return completeAttributeValueUnquoted(code2);
  }
  function completeAttributeValueQuoted(code2) {
    if (code2 === markerB) {
      effects.consume(code2);
      markerB = null;
      return completeAttributeValueQuotedAfter;
    }
    if (code2 === null || markdownLineEnding(code2)) {
      return nok(code2);
    }
    effects.consume(code2);
    return completeAttributeValueQuoted;
  }
  function completeAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 47 || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96 || markdownLineEndingOrSpace(code2)) {
      return completeAttributeNameAfter(code2);
    }
    effects.consume(code2);
    return completeAttributeValueUnquoted;
  }
  function completeAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownSpace(code2)) {
      return completeAttributeNameBefore(code2);
    }
    return nok(code2);
  }
  function completeEnd(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function completeAfter(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuation(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return completeAfter;
    }
    return nok(code2);
  }
  function continuation(code2) {
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationCommentInside;
    }
    if (code2 === 60 && marker === 1) {
      effects.consume(code2);
      return continuationRawTagOpen;
    }
    if (code2 === 62 && marker === 4) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 63 && marker === 3) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    if (code2 === 93 && marker === 5) {
      effects.consume(code2);
      return continuationCdataInside;
    }
    if (markdownLineEnding(code2) && (marker === 6 || marker === 7)) {
      effects.exit("htmlFlowData");
      return effects.check(blankLineBefore, continuationAfter, continuationStart)(code2);
    }
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationStart(code2);
    }
    effects.consume(code2);
    return continuation;
  }
  function continuationStart(code2) {
    return effects.check(nonLazyContinuationStart, continuationStartNonLazy, continuationAfter)(code2);
  }
  function continuationStartNonLazy(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return continuationBefore;
  }
  function continuationBefore(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      return continuationStart(code2);
    }
    effects.enter("htmlFlowData");
    return continuation(code2);
  }
  function continuationCommentInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationRawTagOpen(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      buffer = "";
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationRawEndTag(code2) {
    if (code2 === 62) {
      const name2 = buffer.toLowerCase();
      if (htmlRawNames.includes(name2)) {
        effects.consume(code2);
        return continuationClose;
      }
      return continuation(code2);
    }
    if (asciiAlpha(code2) && buffer.length < 8) {
      effects.consume(code2);
      buffer += String.fromCharCode(code2);
      return continuationRawEndTag;
    }
    return continuation(code2);
  }
  function continuationCdataInside(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationDeclarationInside(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      return continuationClose;
    }
    if (code2 === 45 && marker === 2) {
      effects.consume(code2);
      return continuationDeclarationInside;
    }
    return continuation(code2);
  }
  function continuationClose(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("htmlFlowData");
      return continuationAfter(code2);
    }
    effects.consume(code2);
    return continuationClose;
  }
  function continuationAfter(code2) {
    effects.exit("htmlFlow");
    return ok2(code2);
  }
}
function tokenizeNonLazyContinuationStart(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    if (markdownLineEnding(code2)) {
      effects.enter("lineEnding");
      effects.consume(code2);
      effects.exit("lineEnding");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return self2.parser.lazy[self2.now().line] ? nok(code2) : ok2(code2);
  }
}
function tokenizeBlankLineBefore(effects, ok2, nok) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return effects.attempt(blankLine, ok2, nok);
  }
}
const htmlText = {
  name: "htmlText",
  tokenize: tokenizeHtmlText
};
function tokenizeHtmlText(effects, ok2, nok) {
  const self2 = this;
  let marker;
  let index2;
  let returnState;
  return start;
  function start(code2) {
    effects.enter("htmlText");
    effects.enter("htmlTextData");
    effects.consume(code2);
    return open;
  }
  function open(code2) {
    if (code2 === 33) {
      effects.consume(code2);
      return declarationOpen;
    }
    if (code2 === 47) {
      effects.consume(code2);
      return tagCloseStart;
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instruction;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    return nok(code2);
  }
  function declarationOpen(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentOpenInside;
    }
    if (code2 === 91) {
      effects.consume(code2);
      index2 = 0;
      return cdataOpenInside;
    }
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return declaration;
    }
    return nok(code2);
  }
  function commentOpenInside(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return nok(code2);
  }
  function comment2(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 45) {
      effects.consume(code2);
      return commentClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = comment2;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return comment2;
  }
  function commentClose(code2) {
    if (code2 === 45) {
      effects.consume(code2);
      return commentEnd;
    }
    return comment2(code2);
  }
  function commentEnd(code2) {
    return code2 === 62 ? end(code2) : code2 === 45 ? commentClose(code2) : comment2(code2);
  }
  function cdataOpenInside(code2) {
    const value = "CDATA[";
    if (code2 === value.charCodeAt(index2++)) {
      effects.consume(code2);
      return index2 === value.length ? cdata : cdataOpenInside;
    }
    return nok(code2);
  }
  function cdata(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = cdata;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return cdata;
  }
  function cdataClose(code2) {
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function cdataEnd(code2) {
    if (code2 === 62) {
      return end(code2);
    }
    if (code2 === 93) {
      effects.consume(code2);
      return cdataEnd;
    }
    return cdata(code2);
  }
  function declaration(code2) {
    if (code2 === null || code2 === 62) {
      return end(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = declaration;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return declaration;
  }
  function instruction(code2) {
    if (code2 === null) {
      return nok(code2);
    }
    if (code2 === 63) {
      effects.consume(code2);
      return instructionClose;
    }
    if (markdownLineEnding(code2)) {
      returnState = instruction;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return instruction;
  }
  function instructionClose(code2) {
    return code2 === 62 ? end(code2) : instruction(code2);
  }
  function tagCloseStart(code2) {
    if (asciiAlpha(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return nok(code2);
  }
  function tagClose(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagClose;
    }
    return tagCloseBetween(code2);
  }
  function tagCloseBetween(code2) {
    if (markdownLineEnding(code2)) {
      returnState = tagCloseBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagCloseBetween;
    }
    return end(code2);
  }
  function tagOpen(code2) {
    if (code2 === 45 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpen;
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function tagOpenBetween(code2) {
    if (code2 === 47) {
      effects.consume(code2);
      return end;
    }
    if (code2 === 58 || code2 === 95 || asciiAlpha(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenBetween;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenBetween;
    }
    return end(code2);
  }
  function tagOpenAttributeName(code2) {
    if (code2 === 45 || code2 === 46 || code2 === 58 || code2 === 95 || asciiAlphanumeric(code2)) {
      effects.consume(code2);
      return tagOpenAttributeName;
    }
    return tagOpenAttributeNameAfter(code2);
  }
  function tagOpenAttributeNameAfter(code2) {
    if (code2 === 61) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeNameAfter;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeNameAfter;
    }
    return tagOpenBetween(code2);
  }
  function tagOpenAttributeValueBefore(code2) {
    if (code2 === null || code2 === 60 || code2 === 61 || code2 === 62 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 34 || code2 === 39) {
      effects.consume(code2);
      marker = code2;
      return tagOpenAttributeValueQuoted;
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueBefore;
      return lineEndingBefore(code2);
    }
    if (markdownSpace(code2)) {
      effects.consume(code2);
      return tagOpenAttributeValueBefore;
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuoted(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      marker = void 0;
      return tagOpenAttributeValueQuotedAfter;
    }
    if (code2 === null) {
      return nok(code2);
    }
    if (markdownLineEnding(code2)) {
      returnState = tagOpenAttributeValueQuoted;
      return lineEndingBefore(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueQuoted;
  }
  function tagOpenAttributeValueUnquoted(code2) {
    if (code2 === null || code2 === 34 || code2 === 39 || code2 === 60 || code2 === 61 || code2 === 96) {
      return nok(code2);
    }
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    effects.consume(code2);
    return tagOpenAttributeValueUnquoted;
  }
  function tagOpenAttributeValueQuotedAfter(code2) {
    if (code2 === 47 || code2 === 62 || markdownLineEndingOrSpace(code2)) {
      return tagOpenBetween(code2);
    }
    return nok(code2);
  }
  function end(code2) {
    if (code2 === 62) {
      effects.consume(code2);
      effects.exit("htmlTextData");
      effects.exit("htmlText");
      return ok2;
    }
    return nok(code2);
  }
  function lineEndingBefore(code2) {
    effects.exit("htmlTextData");
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return lineEndingAfter;
  }
  function lineEndingAfter(code2) {
    return markdownSpace(code2) ? factorySpace(effects, lineEndingAfterPrefix, "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2) : lineEndingAfterPrefix(code2);
  }
  function lineEndingAfterPrefix(code2) {
    effects.enter("htmlTextData");
    return returnState(code2);
  }
}
const labelEnd = {
  name: "labelEnd",
  resolveAll: resolveAllLabelEnd,
  resolveTo: resolveToLabelEnd,
  tokenize: tokenizeLabelEnd
};
const resourceConstruct = {
  tokenize: tokenizeResource
};
const referenceFullConstruct = {
  tokenize: tokenizeReferenceFull
};
const referenceCollapsedConstruct = {
  tokenize: tokenizeReferenceCollapsed
};
function resolveAllLabelEnd(events2) {
  let index2 = -1;
  const newEvents = [];
  while (++index2 < events2.length) {
    const token = events2[index2][1];
    newEvents.push(events2[index2]);
    if (token.type === "labelImage" || token.type === "labelLink" || token.type === "labelEnd") {
      const offset2 = token.type === "labelImage" ? 4 : 2;
      token.type = "data";
      index2 += offset2;
    }
  }
  if (events2.length !== newEvents.length) {
    splice(events2, 0, events2.length, newEvents);
  }
  return events2;
}
function resolveToLabelEnd(events2, context) {
  let index2 = events2.length;
  let offset2 = 0;
  let token;
  let open;
  let close;
  let media;
  while (index2--) {
    token = events2[index2][1];
    if (open) {
      if (token.type === "link" || token.type === "labelLink" && token._inactive) {
        break;
      }
      if (events2[index2][0] === "enter" && token.type === "labelLink") {
        token._inactive = true;
      }
    } else if (close) {
      if (events2[index2][0] === "enter" && (token.type === "labelImage" || token.type === "labelLink") && !token._balanced) {
        open = index2;
        if (token.type !== "labelLink") {
          offset2 = 2;
          break;
        }
      }
    } else if (token.type === "labelEnd") {
      close = index2;
    }
  }
  const group2 = {
    type: events2[open][1].type === "labelLink" ? "link" : "image",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  const label2 = {
    type: "label",
    start: {
      ...events2[open][1].start
    },
    end: {
      ...events2[close][1].end
    }
  };
  const text2 = {
    type: "labelText",
    start: {
      ...events2[open + offset2 + 2][1].end
    },
    end: {
      ...events2[close - 2][1].start
    }
  };
  media = [["enter", group2, context], ["enter", label2, context]];
  media = push(media, events2.slice(open + 1, open + offset2 + 3));
  media = push(media, [["enter", text2, context]]);
  media = push(media, resolveAll(context.parser.constructs.insideSpan.null, events2.slice(open + offset2 + 4, close - 3), context));
  media = push(media, [["exit", text2, context], events2[close - 2], events2[close - 1], ["exit", label2, context]]);
  media = push(media, events2.slice(close + 1));
  media = push(media, [["exit", group2, context]]);
  splice(events2, open, events2.length, media);
  return events2;
}
function tokenizeLabelEnd(effects, ok2, nok) {
  const self2 = this;
  let index2 = self2.events.length;
  let labelStart;
  let defined;
  while (index2--) {
    if ((self2.events[index2][1].type === "labelImage" || self2.events[index2][1].type === "labelLink") && !self2.events[index2][1]._balanced) {
      labelStart = self2.events[index2][1];
      break;
    }
  }
  return start;
  function start(code2) {
    if (!labelStart) {
      return nok(code2);
    }
    if (labelStart._inactive) {
      return labelEndNok(code2);
    }
    defined = self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize({
      start: labelStart.end,
      end: self2.now()
    })));
    effects.enter("labelEnd");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelEnd");
    return after2;
  }
  function after2(code2) {
    if (code2 === 40) {
      return effects.attempt(resourceConstruct, labelEndOk, defined ? labelEndOk : labelEndNok)(code2);
    }
    if (code2 === 91) {
      return effects.attempt(referenceFullConstruct, labelEndOk, defined ? referenceNotFull : labelEndNok)(code2);
    }
    return defined ? labelEndOk(code2) : labelEndNok(code2);
  }
  function referenceNotFull(code2) {
    return effects.attempt(referenceCollapsedConstruct, labelEndOk, labelEndNok)(code2);
  }
  function labelEndOk(code2) {
    return ok2(code2);
  }
  function labelEndNok(code2) {
    labelStart._balanced = true;
    return nok(code2);
  }
}
function tokenizeResource(effects, ok2, nok) {
  return resourceStart;
  function resourceStart(code2) {
    effects.enter("resource");
    effects.enter("resourceMarker");
    effects.consume(code2);
    effects.exit("resourceMarker");
    return resourceBefore;
  }
  function resourceBefore(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceOpen)(code2) : resourceOpen(code2);
  }
  function resourceOpen(code2) {
    if (code2 === 41) {
      return resourceEnd(code2);
    }
    return factoryDestination(effects, resourceDestinationAfter, resourceDestinationMissing, "resourceDestination", "resourceDestinationLiteral", "resourceDestinationLiteralMarker", "resourceDestinationRaw", "resourceDestinationString", 32)(code2);
  }
  function resourceDestinationAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceBetween)(code2) : resourceEnd(code2);
  }
  function resourceDestinationMissing(code2) {
    return nok(code2);
  }
  function resourceBetween(code2) {
    if (code2 === 34 || code2 === 39 || code2 === 40) {
      return factoryTitle(effects, resourceTitleAfter, nok, "resourceTitle", "resourceTitleMarker", "resourceTitleString")(code2);
    }
    return resourceEnd(code2);
  }
  function resourceTitleAfter(code2) {
    return markdownLineEndingOrSpace(code2) ? factoryWhitespace(effects, resourceEnd)(code2) : resourceEnd(code2);
  }
  function resourceEnd(code2) {
    if (code2 === 41) {
      effects.enter("resourceMarker");
      effects.consume(code2);
      effects.exit("resourceMarker");
      effects.exit("resource");
      return ok2;
    }
    return nok(code2);
  }
}
function tokenizeReferenceFull(effects, ok2, nok) {
  const self2 = this;
  return referenceFull;
  function referenceFull(code2) {
    return factoryLabel.call(self2, effects, referenceFullAfter, referenceFullMissing, "reference", "referenceMarker", "referenceString")(code2);
  }
  function referenceFullAfter(code2) {
    return self2.parser.defined.includes(normalizeIdentifier(self2.sliceSerialize(self2.events[self2.events.length - 1][1]).slice(1, -1))) ? ok2(code2) : nok(code2);
  }
  function referenceFullMissing(code2) {
    return nok(code2);
  }
}
function tokenizeReferenceCollapsed(effects, ok2, nok) {
  return referenceCollapsedStart;
  function referenceCollapsedStart(code2) {
    effects.enter("reference");
    effects.enter("referenceMarker");
    effects.consume(code2);
    effects.exit("referenceMarker");
    return referenceCollapsedOpen;
  }
  function referenceCollapsedOpen(code2) {
    if (code2 === 93) {
      effects.enter("referenceMarker");
      effects.consume(code2);
      effects.exit("referenceMarker");
      effects.exit("reference");
      return ok2;
    }
    return nok(code2);
  }
}
const labelStartImage = {
  name: "labelStartImage",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartImage
};
function tokenizeLabelStartImage(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelImage");
    effects.enter("labelImageMarker");
    effects.consume(code2);
    effects.exit("labelImageMarker");
    return open;
  }
  function open(code2) {
    if (code2 === 91) {
      effects.enter("labelMarker");
      effects.consume(code2);
      effects.exit("labelMarker");
      effects.exit("labelImage");
      return after2;
    }
    return nok(code2);
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const labelStartLink = {
  name: "labelStartLink",
  resolveAll: labelEnd.resolveAll,
  tokenize: tokenizeLabelStartLink
};
function tokenizeLabelStartLink(effects, ok2, nok) {
  const self2 = this;
  return start;
  function start(code2) {
    effects.enter("labelLink");
    effects.enter("labelMarker");
    effects.consume(code2);
    effects.exit("labelMarker");
    effects.exit("labelLink");
    return after2;
  }
  function after2(code2) {
    return code2 === 94 && "_hiddenFootnoteSupport" in self2.parser.constructs ? nok(code2) : ok2(code2);
  }
}
const lineEnding = {
  name: "lineEnding",
  tokenize: tokenizeLineEnding
};
function tokenizeLineEnding(effects, ok2) {
  return start;
  function start(code2) {
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    return factorySpace(effects, ok2, "linePrefix");
  }
}
const thematicBreak = {
  name: "thematicBreak",
  tokenize: tokenizeThematicBreak
};
function tokenizeThematicBreak(effects, ok2, nok) {
  let size2 = 0;
  let marker;
  return start;
  function start(code2) {
    effects.enter("thematicBreak");
    return before2(code2);
  }
  function before2(code2) {
    marker = code2;
    return atBreak(code2);
  }
  function atBreak(code2) {
    if (code2 === marker) {
      effects.enter("thematicBreakSequence");
      return sequence(code2);
    }
    if (size2 >= 3 && (code2 === null || markdownLineEnding(code2))) {
      effects.exit("thematicBreak");
      return ok2(code2);
    }
    return nok(code2);
  }
  function sequence(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      size2++;
      return sequence;
    }
    effects.exit("thematicBreakSequence");
    return markdownSpace(code2) ? factorySpace(effects, atBreak, "whitespace")(code2) : atBreak(code2);
  }
}
const list = {
  continuation: {
    tokenize: tokenizeListContinuation
  },
  exit: tokenizeListEnd,
  name: "list",
  tokenize: tokenizeListStart
};
const listItemPrefixWhitespaceConstruct = {
  partial: true,
  tokenize: tokenizeListItemPrefixWhitespace
};
const indentConstruct = {
  partial: true,
  tokenize: tokenizeIndent
};
function tokenizeListStart(effects, ok2, nok) {
  const self2 = this;
  const tail = self2.events[self2.events.length - 1];
  let initialSize = tail && tail[1].type === "linePrefix" ? tail[2].sliceSerialize(tail[1], true).length : 0;
  let size2 = 0;
  return start;
  function start(code2) {
    const kind = self2.containerState.type || (code2 === 42 || code2 === 43 || code2 === 45 ? "listUnordered" : "listOrdered");
    if (kind === "listUnordered" ? !self2.containerState.marker || code2 === self2.containerState.marker : asciiDigit(code2)) {
      if (!self2.containerState.type) {
        self2.containerState.type = kind;
        effects.enter(kind, {
          _container: true
        });
      }
      if (kind === "listUnordered") {
        effects.enter("listItemPrefix");
        return code2 === 42 || code2 === 45 ? effects.check(thematicBreak, nok, atMarker)(code2) : atMarker(code2);
      }
      if (!self2.interrupt || code2 === 49) {
        effects.enter("listItemPrefix");
        effects.enter("listItemValue");
        return inside2(code2);
      }
    }
    return nok(code2);
  }
  function inside2(code2) {
    if (asciiDigit(code2) && ++size2 < 10) {
      effects.consume(code2);
      return inside2;
    }
    if ((!self2.interrupt || size2 < 2) && (self2.containerState.marker ? code2 === self2.containerState.marker : code2 === 41 || code2 === 46)) {
      effects.exit("listItemValue");
      return atMarker(code2);
    }
    return nok(code2);
  }
  function atMarker(code2) {
    effects.enter("listItemMarker");
    effects.consume(code2);
    effects.exit("listItemMarker");
    self2.containerState.marker = self2.containerState.marker || code2;
    return effects.check(
      blankLine,
      // Can’t be empty when interrupting.
      self2.interrupt ? nok : onBlank,
      effects.attempt(listItemPrefixWhitespaceConstruct, endOfPrefix, otherPrefix)
    );
  }
  function onBlank(code2) {
    self2.containerState.initialBlankLine = true;
    initialSize++;
    return endOfPrefix(code2);
  }
  function otherPrefix(code2) {
    if (markdownSpace(code2)) {
      effects.enter("listItemPrefixWhitespace");
      effects.consume(code2);
      effects.exit("listItemPrefixWhitespace");
      return endOfPrefix;
    }
    return nok(code2);
  }
  function endOfPrefix(code2) {
    self2.containerState.size = initialSize + self2.sliceSerialize(effects.exit("listItemPrefix"), true).length;
    return ok2(code2);
  }
}
function tokenizeListContinuation(effects, ok2, nok) {
  const self2 = this;
  self2.containerState._closeFlow = void 0;
  return effects.check(blankLine, onBlank, notBlank);
  function onBlank(code2) {
    self2.containerState.furtherBlankLines = self2.containerState.furtherBlankLines || self2.containerState.initialBlankLine;
    return factorySpace(effects, ok2, "listItemIndent", self2.containerState.size + 1)(code2);
  }
  function notBlank(code2) {
    if (self2.containerState.furtherBlankLines || !markdownSpace(code2)) {
      self2.containerState.furtherBlankLines = void 0;
      self2.containerState.initialBlankLine = void 0;
      return notInCurrentItem(code2);
    }
    self2.containerState.furtherBlankLines = void 0;
    self2.containerState.initialBlankLine = void 0;
    return effects.attempt(indentConstruct, ok2, notInCurrentItem)(code2);
  }
  function notInCurrentItem(code2) {
    self2.containerState._closeFlow = true;
    self2.interrupt = void 0;
    return factorySpace(effects, effects.attempt(list, ok2, nok), "linePrefix", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4)(code2);
  }
}
function tokenizeIndent(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemIndent", self2.containerState.size + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return tail && tail[1].type === "listItemIndent" && tail[2].sliceSerialize(tail[1], true).length === self2.containerState.size ? ok2(code2) : nok(code2);
  }
}
function tokenizeListEnd(effects) {
  effects.exit(this.containerState.type);
}
function tokenizeListItemPrefixWhitespace(effects, ok2, nok) {
  const self2 = this;
  return factorySpace(effects, afterPrefix, "listItemPrefixWhitespace", self2.parser.constructs.disable.null.includes("codeIndented") ? void 0 : 4 + 1);
  function afterPrefix(code2) {
    const tail = self2.events[self2.events.length - 1];
    return !markdownSpace(code2) && tail && tail[1].type === "listItemPrefixWhitespace" ? ok2(code2) : nok(code2);
  }
}
const setextUnderline = {
  name: "setextUnderline",
  resolveTo: resolveToSetextUnderline,
  tokenize: tokenizeSetextUnderline
};
function resolveToSetextUnderline(events2, context) {
  let index2 = events2.length;
  let content2;
  let text2;
  let definition2;
  while (index2--) {
    if (events2[index2][0] === "enter") {
      if (events2[index2][1].type === "content") {
        content2 = index2;
        break;
      }
      if (events2[index2][1].type === "paragraph") {
        text2 = index2;
      }
    } else {
      if (events2[index2][1].type === "content") {
        events2.splice(index2, 1);
      }
      if (!definition2 && events2[index2][1].type === "definition") {
        definition2 = index2;
      }
    }
  }
  const heading2 = {
    type: "setextHeading",
    start: {
      ...events2[content2][1].start
    },
    end: {
      ...events2[events2.length - 1][1].end
    }
  };
  events2[text2][1].type = "setextHeadingText";
  if (definition2) {
    events2.splice(text2, 0, ["enter", heading2, context]);
    events2.splice(definition2 + 1, 0, ["exit", events2[content2][1], context]);
    events2[content2][1].end = {
      ...events2[definition2][1].end
    };
  } else {
    events2[content2][1] = heading2;
  }
  events2.push(["exit", heading2, context]);
  return events2;
}
function tokenizeSetextUnderline(effects, ok2, nok) {
  const self2 = this;
  let marker;
  return start;
  function start(code2) {
    let index2 = self2.events.length;
    let paragraph;
    while (index2--) {
      if (self2.events[index2][1].type !== "lineEnding" && self2.events[index2][1].type !== "linePrefix" && self2.events[index2][1].type !== "content") {
        paragraph = self2.events[index2][1].type === "paragraph";
        break;
      }
    }
    if (!self2.parser.lazy[self2.now().line] && (self2.interrupt || paragraph)) {
      effects.enter("setextHeadingLine");
      marker = code2;
      return before2(code2);
    }
    return nok(code2);
  }
  function before2(code2) {
    effects.enter("setextHeadingLineSequence");
    return inside2(code2);
  }
  function inside2(code2) {
    if (code2 === marker) {
      effects.consume(code2);
      return inside2;
    }
    effects.exit("setextHeadingLineSequence");
    return markdownSpace(code2) ? factorySpace(effects, after2, "lineSuffix")(code2) : after2(code2);
  }
  function after2(code2) {
    if (code2 === null || markdownLineEnding(code2)) {
      effects.exit("setextHeadingLine");
      return ok2(code2);
    }
    return nok(code2);
  }
}
const flow$1 = {
  tokenize: initializeFlow
};
function initializeFlow(effects) {
  const self2 = this;
  const initial2 = effects.attempt(
    // Try to parse a blank line.
    blankLine,
    atBlankEnding,
    // Try to parse initial flow (essentially, only code).
    effects.attempt(this.parser.constructs.flowInitial, afterConstruct, factorySpace(effects, effects.attempt(this.parser.constructs.flow, afterConstruct, effects.attempt(content, afterConstruct)), "linePrefix"))
  );
  return initial2;
  function atBlankEnding(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEndingBlank");
    effects.consume(code2);
    effects.exit("lineEndingBlank");
    self2.currentConstruct = void 0;
    return initial2;
  }
  function afterConstruct(code2) {
    if (code2 === null) {
      effects.consume(code2);
      return;
    }
    effects.enter("lineEnding");
    effects.consume(code2);
    effects.exit("lineEnding");
    self2.currentConstruct = void 0;
    return initial2;
  }
}
const resolver = {
  resolveAll: createResolver()
};
const string$1 = initializeFactory("string");
const text$1 = initializeFactory("text");
function initializeFactory(field) {
  return {
    resolveAll: createResolver(field === "text" ? resolveAllLineSuffixes : void 0),
    tokenize: initializeText
  };
  function initializeText(effects) {
    const self2 = this;
    const constructs2 = this.parser.constructs[field];
    const text2 = effects.attempt(constructs2, start, notText);
    return start;
    function start(code2) {
      return atBreak(code2) ? text2(code2) : notText(code2);
    }
    function notText(code2) {
      if (code2 === null) {
        effects.consume(code2);
        return;
      }
      effects.enter("data");
      effects.consume(code2);
      return data;
    }
    function data(code2) {
      if (atBreak(code2)) {
        effects.exit("data");
        return text2(code2);
      }
      effects.consume(code2);
      return data;
    }
    function atBreak(code2) {
      if (code2 === null) {
        return true;
      }
      const list2 = constructs2[code2];
      let index2 = -1;
      if (list2) {
        while (++index2 < list2.length) {
          const item = list2[index2];
          if (!item.previous || item.previous.call(self2, self2.previous)) {
            return true;
          }
        }
      }
      return false;
    }
  }
}
function createResolver(extraResolver) {
  return resolveAllText;
  function resolveAllText(events2, context) {
    let index2 = -1;
    let enter;
    while (++index2 <= events2.length) {
      if (enter === void 0) {
        if (events2[index2] && events2[index2][1].type === "data") {
          enter = index2;
          index2++;
        }
      } else if (!events2[index2] || events2[index2][1].type !== "data") {
        if (index2 !== enter + 2) {
          events2[enter][1].end = events2[index2 - 1][1].end;
          events2.splice(enter + 2, index2 - enter - 2);
          index2 = enter + 2;
        }
        enter = void 0;
      }
    }
    return extraResolver ? extraResolver(events2, context) : events2;
  }
}
function resolveAllLineSuffixes(events2, context) {
  let eventIndex = 0;
  while (++eventIndex <= events2.length) {
    if ((eventIndex === events2.length || events2[eventIndex][1].type === "lineEnding") && events2[eventIndex - 1][1].type === "data") {
      const data = events2[eventIndex - 1][1];
      const chunks = context.sliceStream(data);
      let index2 = chunks.length;
      let bufferIndex = -1;
      let size2 = 0;
      let tabs;
      while (index2--) {
        const chunk2 = chunks[index2];
        if (typeof chunk2 === "string") {
          bufferIndex = chunk2.length;
          while (chunk2.charCodeAt(bufferIndex - 1) === 32) {
            size2++;
            bufferIndex--;
          }
          if (bufferIndex) break;
          bufferIndex = -1;
        } else if (chunk2 === -2) {
          tabs = true;
          size2++;
        } else if (chunk2 === -1) ;
        else {
          index2++;
          break;
        }
      }
      if (context._contentTypeTextTrailing && eventIndex === events2.length) {
        size2 = 0;
      }
      if (size2) {
        const token = {
          type: eventIndex === events2.length || tabs || size2 < 2 ? "lineSuffix" : "hardBreakTrailing",
          start: {
            _bufferIndex: index2 ? bufferIndex : data.start._bufferIndex + bufferIndex,
            _index: data.start._index + index2,
            line: data.end.line,
            column: data.end.column - size2,
            offset: data.end.offset - size2
          },
          end: {
            ...data.end
          }
        };
        data.end = {
          ...token.start
        };
        if (data.start.offset === data.end.offset) {
          Object.assign(data, token);
        } else {
          events2.splice(eventIndex, 0, ["enter", token, context], ["exit", token, context]);
          eventIndex += 2;
        }
      }
      eventIndex++;
    }
  }
  return events2;
}
const document$1 = {
  [42]: list,
  [43]: list,
  [45]: list,
  [48]: list,
  [49]: list,
  [50]: list,
  [51]: list,
  [52]: list,
  [53]: list,
  [54]: list,
  [55]: list,
  [56]: list,
  [57]: list,
  [62]: blockQuote
};
const contentInitial = {
  [91]: definition
};
const flowInitial = {
  [-2]: codeIndented,
  [-1]: codeIndented,
  [32]: codeIndented
};
const flow = {
  [35]: headingAtx,
  [42]: thematicBreak,
  [45]: [setextUnderline, thematicBreak],
  [60]: htmlFlow,
  [61]: setextUnderline,
  [95]: thematicBreak,
  [96]: codeFenced,
  [126]: codeFenced
};
const string = {
  [38]: characterReference,
  [92]: characterEscape
};
const text = {
  [-5]: lineEnding,
  [-4]: lineEnding,
  [-3]: lineEnding,
  [33]: labelStartImage,
  [38]: characterReference,
  [42]: attention,
  [60]: [autolink, htmlText],
  [91]: labelStartLink,
  [92]: [hardBreakEscape, characterEscape],
  [93]: labelEnd,
  [95]: attention,
  [96]: codeText
};
const insideSpan = {
  null: [attention, resolver]
};
const attentionMarkers = {
  null: [42, 95]
};
const disable = {
  null: []
};
const defaultConstructs = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  attentionMarkers,
  contentInitial,
  disable,
  document: document$1,
  flow,
  flowInitial,
  insideSpan,
  string,
  text
}, Symbol.toStringTag, { value: "Module" }));
function createTokenizer(parser2, initialize, from) {
  let point2 = {
    _bufferIndex: -1,
    _index: 0,
    line: from && from.line || 1,
    column: from && from.column || 1,
    offset: from && from.offset || 0
  };
  const columnStart = {};
  const resolveAllConstructs = [];
  let chunks = [];
  let stack = [];
  const effects = {
    attempt: constructFactory(onsuccessfulconstruct),
    check: constructFactory(onsuccessfulcheck),
    consume,
    enter,
    exit: exit2,
    interrupt: constructFactory(onsuccessfulcheck, {
      interrupt: true
    })
  };
  const context = {
    code: null,
    containerState: {},
    defineSkip,
    events: [],
    now,
    parser: parser2,
    previous: null,
    sliceSerialize,
    sliceStream,
    write
  };
  let state = initialize.tokenize.call(context, effects);
  if (initialize.resolveAll) {
    resolveAllConstructs.push(initialize);
  }
  return context;
  function write(slice2) {
    chunks = push(chunks, slice2);
    main2();
    if (chunks[chunks.length - 1] !== null) {
      return [];
    }
    addResult(initialize, 0);
    context.events = resolveAll(resolveAllConstructs, context.events, context);
    return context.events;
  }
  function sliceSerialize(token, expandTabs) {
    return serializeChunks(sliceStream(token), expandTabs);
  }
  function sliceStream(token) {
    return sliceChunks(chunks, token);
  }
  function now() {
    const {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    } = point2;
    return {
      _bufferIndex,
      _index,
      line: line2,
      column,
      offset: offset2
    };
  }
  function defineSkip(value) {
    columnStart[value.line] = value.column;
    accountForPotentialSkip();
  }
  function main2() {
    let chunkIndex;
    while (point2._index < chunks.length) {
      const chunk2 = chunks[point2._index];
      if (typeof chunk2 === "string") {
        chunkIndex = point2._index;
        if (point2._bufferIndex < 0) {
          point2._bufferIndex = 0;
        }
        while (point2._index === chunkIndex && point2._bufferIndex < chunk2.length) {
          go2(chunk2.charCodeAt(point2._bufferIndex));
        }
      } else {
        go2(chunk2);
      }
    }
  }
  function go2(code2) {
    state = state(code2);
  }
  function consume(code2) {
    if (markdownLineEnding(code2)) {
      point2.line++;
      point2.column = 1;
      point2.offset += code2 === -3 ? 2 : 1;
      accountForPotentialSkip();
    } else if (code2 !== -1) {
      point2.column++;
      point2.offset++;
    }
    if (point2._bufferIndex < 0) {
      point2._index++;
    } else {
      point2._bufferIndex++;
      if (point2._bufferIndex === // Points w/ non-negative `_bufferIndex` reference
      // strings.
      /** @type {string} */
      chunks[point2._index].length) {
        point2._bufferIndex = -1;
        point2._index++;
      }
    }
    context.previous = code2;
  }
  function enter(type, fields) {
    const token = fields || {};
    token.type = type;
    token.start = now();
    context.events.push(["enter", token, context]);
    stack.push(token);
    return token;
  }
  function exit2(type) {
    const token = stack.pop();
    token.end = now();
    context.events.push(["exit", token, context]);
    return token;
  }
  function onsuccessfulconstruct(construct, info) {
    addResult(construct, info.from);
  }
  function onsuccessfulcheck(_2, info) {
    info.restore();
  }
  function constructFactory(onreturn, fields) {
    return hook;
    function hook(constructs2, returnState, bogusState) {
      let listOfConstructs;
      let constructIndex;
      let currentConstruct;
      let info;
      return Array.isArray(constructs2) ? (
        /* c8 ignore next 1 */
        handleListOfConstructs(constructs2)
      ) : "tokenize" in constructs2 ? (
        // Looks like a construct.
        handleListOfConstructs([
          /** @type {Construct} */
          constructs2
        ])
      ) : handleMapOfConstructs(constructs2);
      function handleMapOfConstructs(map2) {
        return start;
        function start(code2) {
          const left = code2 !== null && map2[code2];
          const all2 = code2 !== null && map2.null;
          const list2 = [
            // To do: add more extension tests.
            /* c8 ignore next 2 */
            ...Array.isArray(left) ? left : left ? [left] : [],
            ...Array.isArray(all2) ? all2 : all2 ? [all2] : []
          ];
          return handleListOfConstructs(list2)(code2);
        }
      }
      function handleListOfConstructs(list2) {
        listOfConstructs = list2;
        constructIndex = 0;
        if (list2.length === 0) {
          return bogusState;
        }
        return handleConstruct(list2[constructIndex]);
      }
      function handleConstruct(construct) {
        return start;
        function start(code2) {
          info = store2();
          currentConstruct = construct;
          if (!construct.partial) {
            context.currentConstruct = construct;
          }
          if (construct.name && context.parser.constructs.disable.null.includes(construct.name)) {
            return nok();
          }
          return construct.tokenize.call(
            // If we do have fields, create an object w/ `context` as its
            // prototype.
            // This allows a “live binding”, which is needed for `interrupt`.
            fields ? Object.assign(Object.create(context), fields) : context,
            effects,
            ok2,
            nok
          )(code2);
        }
      }
      function ok2(code2) {
        onreturn(currentConstruct, info);
        return returnState;
      }
      function nok(code2) {
        info.restore();
        if (++constructIndex < listOfConstructs.length) {
          return handleConstruct(listOfConstructs[constructIndex]);
        }
        return bogusState;
      }
    }
  }
  function addResult(construct, from2) {
    if (construct.resolveAll && !resolveAllConstructs.includes(construct)) {
      resolveAllConstructs.push(construct);
    }
    if (construct.resolve) {
      splice(context.events, from2, context.events.length - from2, construct.resolve(context.events.slice(from2), context));
    }
    if (construct.resolveTo) {
      context.events = construct.resolveTo(context.events, context);
    }
  }
  function store2() {
    const startPoint = now();
    const startPrevious = context.previous;
    const startCurrentConstruct = context.currentConstruct;
    const startEventsIndex = context.events.length;
    const startStack = Array.from(stack);
    return {
      from: startEventsIndex,
      restore
    };
    function restore() {
      point2 = startPoint;
      context.previous = startPrevious;
      context.currentConstruct = startCurrentConstruct;
      context.events.length = startEventsIndex;
      stack = startStack;
      accountForPotentialSkip();
    }
  }
  function accountForPotentialSkip() {
    if (point2.line in columnStart && point2.column < 2) {
      point2.column = columnStart[point2.line];
      point2.offset += columnStart[point2.line] - 1;
    }
  }
}
function sliceChunks(chunks, token) {
  const startIndex = token.start._index;
  const startBufferIndex = token.start._bufferIndex;
  const endIndex = token.end._index;
  const endBufferIndex = token.end._bufferIndex;
  let view;
  if (startIndex === endIndex) {
    view = [chunks[startIndex].slice(startBufferIndex, endBufferIndex)];
  } else {
    view = chunks.slice(startIndex, endIndex);
    if (startBufferIndex > -1) {
      const head = view[0];
      if (typeof head === "string") {
        view[0] = head.slice(startBufferIndex);
      } else {
        view.shift();
      }
    }
    if (endBufferIndex > 0) {
      view.push(chunks[endIndex].slice(0, endBufferIndex));
    }
  }
  return view;
}
function serializeChunks(chunks, expandTabs) {
  let index2 = -1;
  const result2 = [];
  let atTab;
  while (++index2 < chunks.length) {
    const chunk2 = chunks[index2];
    let value;
    if (typeof chunk2 === "string") {
      value = chunk2;
    } else switch (chunk2) {
      case -5: {
        value = "\r";
        break;
      }
      case -4: {
        value = "\n";
        break;
      }
      case -3: {
        value = "\r\n";
        break;
      }
      case -2: {
        value = expandTabs ? " " : "	";
        break;
      }
      case -1: {
        if (!expandTabs && atTab) continue;
        value = " ";
        break;
      }
      default: {
        value = String.fromCharCode(chunk2);
      }
    }
    atTab = chunk2 === -2;
    result2.push(value);
  }
  return result2.join("");
}
function parse(options2) {
  const settings = options2 || {};
  const constructs2 = (
    /** @type {FullNormalizedExtension} */
    combineExtensions([defaultConstructs, ...settings.extensions || []])
  );
  const parser2 = {
    constructs: constructs2,
    content: create2(content$1),
    defined: [],
    document: create2(document$2),
    flow: create2(flow$1),
    lazy: {},
    string: create2(string$1),
    text: create2(text$1)
  };
  return parser2;
  function create2(initial2) {
    return creator;
    function creator(from) {
      return createTokenizer(parser2, initial2, from);
    }
  }
}
function postprocess(events2) {
  while (!subtokenize(events2)) {
  }
  return events2;
}
const search = /[\0\t\n\r]/g;
function preprocess() {
  let column = 1;
  let buffer = "";
  let start = true;
  let atCarriageReturn;
  return preprocessor;
  function preprocessor(value, encoding, end) {
    const chunks = [];
    let match2;
    let next;
    let startPosition;
    let endPosition;
    let code2;
    value = buffer + (typeof value === "string" ? value.toString() : new TextDecoder(encoding || void 0).decode(value));
    startPosition = 0;
    buffer = "";
    if (start) {
      if (value.charCodeAt(0) === 65279) {
        startPosition++;
      }
      start = void 0;
    }
    while (startPosition < value.length) {
      search.lastIndex = startPosition;
      match2 = search.exec(value);
      endPosition = match2 && match2.index !== void 0 ? match2.index : value.length;
      code2 = value.charCodeAt(endPosition);
      if (!match2) {
        buffer = value.slice(startPosition);
        break;
      }
      if (code2 === 10 && startPosition === endPosition && atCarriageReturn) {
        chunks.push(-3);
        atCarriageReturn = void 0;
      } else {
        if (atCarriageReturn) {
          chunks.push(-5);
          atCarriageReturn = void 0;
        }
        if (startPosition < endPosition) {
          chunks.push(value.slice(startPosition, endPosition));
          column += endPosition - startPosition;
        }
        switch (code2) {
          case 0: {
            chunks.push(65533);
            column++;
            break;
          }
          case 9: {
            next = Math.ceil(column / 4) * 4;
            chunks.push(-2);
            while (column++ < next) chunks.push(-1);
            break;
          }
          case 10: {
            chunks.push(-4);
            column = 1;
            break;
          }
          default: {
            atCarriageReturn = true;
            column = 1;
          }
        }
      }
      startPosition = endPosition + 1;
    }
    if (end) {
      if (atCarriageReturn) chunks.push(-5);
      if (buffer) chunks.push(buffer);
      chunks.push(null);
    }
    return chunks;
  }
}
function micromark(value, encoding, options2) {
  if (typeof encoding !== "string") {
    options2 = encoding;
    encoding = void 0;
  }
  return compile(options2)(postprocess(parse(options2).document().write(preprocess()(value, encoding, true))));
}
const defaultAllowedDiagnosticTags = /* @__PURE__ */ new Set([
  "P",
  "CODE",
  "EM",
  "STRONG",
  "BR"
]);
function sanitizeDiagnosticHtml(html, allowedTags = defaultAllowedDiagnosticTags) {
  const template2 = document.createElement("template");
  template2.innerHTML = html;
  const walker = document.createTreeWalker(
    template2.content,
    NodeFilter.SHOW_ELEMENT
  );
  const elements2 = [];
  while (walker.nextNode()) {
    elements2.push(walker.currentNode);
  }
  for (const element2 of elements2) {
    if (!allowedTags.has(element2.tagName)) {
      element2.replaceWith(
        document.createTextNode(element2.textContent ?? "")
      );
      continue;
    }
    for (const { name: name2 } of Array.from(element2.attributes)) {
      element2.removeAttribute(name2);
    }
  }
  return template2.innerHTML;
}
const safeMarkdownOptions = {
  allowDangerousHtml: false,
  allowDangerousProtocol: false
};
function renderDiagnosticMarkdownHtml(message) {
  return sanitizeDiagnosticHtml(micromark(message, safeMarkdownOptions));
}
const PATTERN = /`([^`]+)`|\*\*([^*]+)\*\*|\*([^*]+)\*/g;
function parseInlineMarkdown(text2) {
  const tokens = [];
  let lastIndex = 0;
  let m2;
  while ((m2 = PATTERN.exec(text2)) !== null) {
    if (m2.index > lastIndex) {
      tokens.push({
        kind: "text",
        text: text2.slice(lastIndex, m2.index)
      });
    }
    if (m2[1] !== void 0) {
      tokens.push({ kind: "code", text: m2[1] });
    } else if (m2[2] !== void 0) {
      tokens.push({ kind: "strong", text: m2[2] });
    } else if (m2[3] !== void 0) {
      tokens.push({ kind: "em", text: m2[3] });
    }
    lastIndex = m2.index + m2[0].length;
  }
  if (lastIndex < text2.length) {
    tokens.push({ kind: "text", text: text2.slice(lastIndex) });
  }
  return tokens;
}
var dist$1 = {};
var core$1 = {};
var debug$1 = {};
var hasRequiredDebug$1;
function requireDebug$1() {
  if (hasRequiredDebug$1) return debug$1;
  hasRequiredDebug$1 = 1;
  Object.defineProperty(debug$1, "__esModule", { value: true });
  debug$1.getType = getType2;
  debug$1.throwUnknownDataType = throwUnknownDataType;
  debug$1.throwUnsupportedData = throwUnsupportedData;
  function getType2(o2) {
    return Object.prototype.toString.call(o2);
  }
  function throwUnknownDataType(o2) {
    throw new TypeError("unsupported data type: " + getType2(o2));
  }
  function throwUnsupportedData(name2) {
    throw new TypeError("unsupported data type: " + name2);
  }
  return debug$1;
}
var encode$1 = {};
var number$1 = {};
var hasRequiredNumber$1;
function requireNumber$1() {
  if (hasRequiredNumber$1) return number$1;
  hasRequiredNumber$1 = 1;
  Object.defineProperty(number$1, "__esModule", { value: true });
  number$1.s_to_int = s_to_int;
  number$1.s_to_big_int = s_to_big_int;
  number$1.int_to_s = int_to_s;
  number$1.big_int_to_s = big_int_to_s;
  number$1.num_to_s = num_to_s;
  number$1.int_str_to_s = int_str_to_s;
  number$1.s_to_num = s_to_num;
  let i_to_s = "";
  for (let i2 = 0; i2 < 10; i2++) {
    const c2 = String.fromCharCode(48 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + 32 + i2);
    i_to_s += c2;
  }
  const N2 = i_to_s.length;
  const s_to_i = {};
  for (let i2 = 0; i2 < N2; i2++) {
    const s2 = i_to_s[i2];
    s_to_i[s2] = i2;
  }
  function s_to_int(s2) {
    let acc = 0;
    let pow2 = 1;
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = s_to_i[c2];
      x2 *= pow2;
      acc += x2;
      pow2 *= N2;
    }
    return acc;
  }
  function s_to_big_int(s2) {
    let acc = BigInt(0);
    let pow2 = BigInt(1);
    const n2 = BigInt(N2);
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = BigInt(s_to_i[c2]);
      x2 *= pow2;
      acc += x2;
      pow2 *= n2;
    }
    return acc;
  }
  function int_to_s(int) {
    if (int === 0) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== 0) {
      const i2 = int % N2;
      const c2 = i_to_s[i2];
      acc.push(c2);
      int -= i2;
      int /= N2;
    }
    return acc.reverse().join("");
  }
  function big_int_to_s(int) {
    const zero = BigInt(0);
    const n2 = BigInt(N2);
    if (int === zero) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== zero) {
      const i2 = int % n2;
      const c2 = i_to_s[Number(i2)];
      acc.push(c2);
      int /= n2;
    }
    return acc.reverse().join("");
  }
  function reverse(s2) {
    return s2.split("").reverse().join("");
  }
  function num_to_s(num) {
    if (num < 0) {
      return "-" + num_to_s(-num);
    }
    let [a2, b2] = num.toString().split(".");
    if (!b2) {
      if (a2.includes("e")) {
        const [a1, a22] = a2.split("e");
        a2 = a1;
        b2 = "0e" + a22;
      } else {
        return int_to_s(num);
      }
    }
    let c2;
    if (b2) {
      [b2, c2] = b2.split("e");
    }
    a2 = int_str_to_s(a2);
    b2 = reverse(b2);
    b2 = int_str_to_s(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += ".";
      switch (c2[0]) {
        case "+":
          c2 = c2.slice(1);
          break;
        case "-":
          str += "-";
          c2 = c2.slice(1);
          break;
      }
      c2 = int_str_to_s(c2);
      str += c2;
    }
    return str;
  }
  function int_str_to_s(int_str) {
    const num = +int_str;
    if (num.toString() === int_str && num + 1 !== num && num - 1 !== num) {
      return int_to_s(num);
    }
    return ":" + big_int_to_s(BigInt(int_str));
  }
  function s_to_int_str(s2) {
    if (s2[0] === ":") {
      return s_to_big_int(s2.substring(1)).toString();
    }
    return s_to_int(s2).toString();
  }
  function s_to_num(s2) {
    if (s2[0] === "-") {
      return -s_to_num(s2.substr(1));
    }
    let [a2, b2, c2] = s2.split(".");
    if (!b2) {
      return s_to_int(a2);
    }
    a2 = s_to_int_str(a2);
    b2 = s_to_int_str(b2);
    b2 = reverse(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += "e";
      let neg = false;
      if (c2[0] === "-") {
        neg = true;
        c2 = c2.slice(1);
      }
      c2 = s_to_int_str(c2);
      str += neg ? -c2 : +c2;
    }
    return +str;
  }
  return number$1;
}
var hasRequiredEncode$1;
function requireEncode$1() {
  if (hasRequiredEncode$1) return encode$1;
  hasRequiredEncode$1 = 1;
  Object.defineProperty(encode$1, "__esModule", { value: true });
  encode$1.encodeNum = encodeNum;
  encode$1.decodeNum = decodeNum;
  encode$1.decodeKey = decodeKey;
  encode$1.encodeBool = encodeBool;
  encode$1.decodeBool = decodeBool;
  encode$1.encodeStr = encodeStr;
  encode$1.decodeStr = decodeStr;
  const number_1 = requireNumber$1();
  function encodeNum(num) {
    if (num === Infinity) {
      return "N|+";
    }
    if (num === -Infinity) {
      return "N|-";
    }
    if (Number.isNaN(num)) {
      return "N|0";
    }
    return "n|" + (0, number_1.num_to_s)(num);
  }
  function decodeNum(s2) {
    if (s2.length === 3 && s2[0] === "N" && s2[1] === "|") {
      switch (s2[2]) {
        case "+":
          return Infinity;
        case "-":
          return -Infinity;
        case "0":
          return NaN;
      }
    }
    return (0, number_1.s_to_num)(s2.slice(2));
  }
  function decodeKey(key) {
    return typeof key === "number" ? key : (0, number_1.s_to_int)(key);
  }
  function encodeBool(b2) {
    return b2 ? "b|T" : "b|F";
  }
  function decodeBool(s2) {
    if (s2.length === 3 && s2[0] === "b" && s2[1] === "|") {
      switch (s2[2]) {
        case "T":
          return true;
        case "F":
          return false;
      }
    }
    return !!s2;
  }
  function encodeStr(str) {
    if (str[1] === "|") {
      switch (str[0]) {
        case "b":
        case "o":
        case "n":
        case "a":
        case "s":
          return "s|" + str;
      }
    }
    return str;
  }
  function decodeStr(s2) {
    return s2[0] === "s" && s2[1] === "|" ? s2.substr(2) : s2;
  }
  return encode$1;
}
var memory$1 = {};
var config$1 = {};
var hasRequiredConfig$1;
function requireConfig$1() {
  if (hasRequiredConfig$1) return config$1;
  hasRequiredConfig$1 = 1;
  Object.defineProperty(config$1, "__esModule", { value: true });
  config$1.config = void 0;
  config$1.config = {
    // default will not sort the object key
    sort_key: false,
    // default will convert into null silently like JSON.stringify
    preserve_nan: false,
    error_on_nan: false,
    preserve_infinite: false,
    error_on_infinite: false
  };
  return config$1;
}
var hasRequiredMemory$1;
function requireMemory$1() {
  if (hasRequiredMemory$1) return memory$1;
  hasRequiredMemory$1 = 1;
  Object.defineProperty(memory$1, "__esModule", { value: true });
  memory$1.memToValues = memToValues;
  memory$1.makeInMemoryStore = makeInMemoryStore;
  memory$1.makeInMemoryCache = makeInMemoryCache;
  memory$1.makeInMemoryMemory = makeInMemoryMemory;
  memory$1.addValue = addValue;
  const config_1 = requireConfig$1();
  const debug_1 = requireDebug$1();
  const encode_1 = requireEncode$1();
  const number_1 = requireNumber$1();
  function memToValues(mem) {
    return mem.store.toArray();
  }
  function makeInMemoryStore() {
    const mem = [];
    return {
      forEach(cb2) {
        for (let i2 = 0; i2 < mem.length; i2++) {
          if (cb2(mem[i2]) === "break") {
            return;
          }
        }
      },
      add(value) {
        mem.push(value);
      },
      toArray() {
        return mem;
      }
    };
  }
  function makeInMemoryCache() {
    const valueMem = /* @__PURE__ */ Object.create(null);
    const schemaMem = /* @__PURE__ */ Object.create(null);
    return {
      getValue(key) {
        return valueMem[key];
      },
      getSchema(key) {
        return schemaMem[key];
      },
      forEachValue(cb2) {
        for (const [key, value] of Object.entries(valueMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      forEachSchema(cb2) {
        for (const [key, value] of Object.entries(schemaMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      setValue(key, value) {
        valueMem[key] = value;
      },
      setSchema(key, value) {
        schemaMem[key] = value;
      },
      hasValue(key) {
        return key in valueMem;
      },
      hasSchema(key) {
        return key in schemaMem;
      }
    };
  }
  function makeInMemoryMemory() {
    return {
      store: makeInMemoryStore(),
      cache: makeInMemoryCache(),
      keyCount: 0
    };
  }
  function getValueKey(mem, value) {
    if (mem.cache.hasValue(value)) {
      return mem.cache.getValue(value);
    }
    const id2 = mem.keyCount++;
    const key = (0, number_1.num_to_s)(id2);
    mem.store.add(value);
    mem.cache.setValue(value, key);
    return key;
  }
  function getSchema(mem, keys2) {
    if (config_1.config.sort_key) {
      keys2.sort();
    }
    const schema = keys2.join(",");
    if (mem.cache.hasSchema(schema)) {
      return mem.cache.getSchema(schema);
    }
    const key_id = addValue(mem, keys2, void 0);
    mem.cache.setSchema(schema, key_id);
    return key_id;
  }
  function addValue(mem, o2, parent) {
    if (o2 === null) {
      return "";
    }
    switch (typeof o2) {
      case "undefined":
        if (Array.isArray(parent)) {
          return addValue(mem, null, parent);
        }
        break;
      case "object":
        if (o2 === null) {
          return getValueKey(mem, null);
        }
        if (Array.isArray(o2)) {
          let acc = "a";
          for (let i2 = 0; i2 < o2.length; i2++) {
            const v2 = o2[i2];
            const key = v2 === null ? "_" : addValue(mem, v2, o2);
            acc += "|" + key;
          }
          if (acc === "a") {
            acc = "a|";
          }
          return getValueKey(mem, acc);
        } else {
          const keys2 = Object.keys(o2);
          if (keys2.length === 0) {
            return getValueKey(mem, "o|");
          }
          let acc = "o";
          const key_id = getSchema(mem, keys2);
          acc += "|" + key_id;
          for (const key of keys2) {
            const value = o2[key];
            const v2 = addValue(mem, value, o2);
            acc += "|" + v2;
          }
          return getValueKey(mem, acc);
        }
      case "boolean":
        return getValueKey(mem, (0, encode_1.encodeBool)(o2));
      case "number":
        if (Number.isNaN(o2)) {
          if (config_1.config.preserve_nan) {
            return getValueKey(mem, "N|0");
          }
          if (config_1.config.error_on_nan) {
            (0, debug_1.throwUnsupportedData)("[number NaN]");
          }
          return "";
        }
        if (Number.POSITIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|+");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number Infinity]");
          }
          return "";
        }
        if (Number.NEGATIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|-");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number -Infinity]");
          }
          return "";
        }
        return getValueKey(mem, (0, encode_1.encodeNum)(o2));
      case "string":
        return getValueKey(mem, (0, encode_1.encodeStr)(o2));
    }
    return (0, debug_1.throwUnknownDataType)(o2);
  }
  return memory$1;
}
var hasRequiredCore$1;
function requireCore$1() {
  if (hasRequiredCore$1) return core$1;
  hasRequiredCore$1 = 1;
  Object.defineProperty(core$1, "__esModule", { value: true });
  core$1.compress = compress;
  core$1.decode = decode;
  core$1.decompress = decompress;
  const debug_1 = requireDebug$1();
  const encode_1 = requireEncode$1();
  const memory_1 = requireMemory$1();
  const number_1 = requireNumber$1();
  function compress(o2) {
    const mem = (0, memory_1.makeInMemoryMemory)();
    const root2 = (0, memory_1.addValue)(mem, o2, void 0);
    const values2 = (0, memory_1.memToValues)(mem);
    return [values2, root2];
  }
  function decodeObject(values2, s2) {
    if (s2 === "o|") {
      return {};
    }
    const o2 = {};
    const vs = s2.split("|");
    const key_id = vs[1];
    let keys2 = decode(values2, key_id);
    const n2 = vs.length;
    if (n2 - 2 === 1 && !Array.isArray(keys2)) {
      keys2 = [keys2];
    }
    for (let i2 = 2; i2 < n2; i2++) {
      const k2 = keys2[i2 - 2];
      let v2 = vs[i2];
      v2 = decode(values2, v2);
      o2[k2] = v2;
    }
    return o2;
  }
  function decodeArray2(values2, s2) {
    if (s2 === "a|") {
      return [];
    }
    const vs = s2.split("|");
    const n2 = vs.length - 1;
    const xs = new Array(n2);
    for (let i2 = 0; i2 < n2; i2++) {
      let v2 = vs[i2 + 1];
      v2 = decode(values2, v2);
      xs[i2] = v2;
    }
    return xs;
  }
  function decode(values2, key) {
    if (key === "" || key === "_") {
      return null;
    }
    const id2 = (0, encode_1.decodeKey)(key);
    const v2 = values2[id2];
    if (v2 === null) {
      return v2;
    }
    switch (typeof v2) {
      case "undefined":
        return v2;
      case "number":
        return v2;
      case "string":
        if (v2[1] === "|") {
          switch (v2[0]) {
            case "b": {
              switch (v2[2]) {
                case "T":
                  return true;
                case "F":
                  return false;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "o":
              return decodeObject(values2, v2);
            case "n":
              return (0, number_1.s_to_num)(v2.slice(2));
            case "N": {
              switch (v2[2]) {
                case "+":
                  return Infinity;
                case "-":
                  return -Infinity;
                case "0":
                  return NaN;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "a":
              return decodeArray2(values2, v2);
          }
        }
        return (0, encode_1.decodeStr)(v2);
    }
    return (0, debug_1.throwUnknownDataType)(v2);
  }
  function decompress(c2) {
    const [values2, root2] = c2;
    return decode(values2, root2);
  }
  return core$1;
}
var helpers$1 = {};
var hasRequiredHelpers$1;
function requireHelpers$1() {
  if (hasRequiredHelpers$1) return helpers$1;
  hasRequiredHelpers$1 = 1;
  Object.defineProperty(helpers$1, "__esModule", { value: true });
  helpers$1.trimUndefined = trimUndefined;
  helpers$1.trimUndefinedRecursively = trimUndefinedRecursively;
  function trimUndefined(object2) {
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      }
    }
  }
  function trimUndefinedRecursively(object2) {
    trimUndefinedRecursivelyLoop(object2, /* @__PURE__ */ new Set());
  }
  function trimUndefinedRecursivelyLoop(object2, tracks) {
    tracks.add(object2);
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      } else {
        const value = object2[key];
        if (value && typeof value === "object" && !tracks.has(value)) {
          trimUndefinedRecursivelyLoop(value, tracks);
        }
      }
    }
  }
  return helpers$1;
}
var hasRequiredDist$1;
function requireDist$1() {
  if (hasRequiredDist$1) return dist$1;
  hasRequiredDist$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.config = exports2.trimUndefinedRecursively = exports2.trimUndefined = exports2.addValue = exports2.decode = exports2.decompress = exports2.compress = void 0;
    var core_1 = requireCore$1();
    Object.defineProperty(exports2, "compress", { enumerable: true, get: function() {
      return core_1.compress;
    } });
    Object.defineProperty(exports2, "decompress", { enumerable: true, get: function() {
      return core_1.decompress;
    } });
    var core_2 = requireCore$1();
    Object.defineProperty(exports2, "decode", { enumerable: true, get: function() {
      return core_2.decode;
    } });
    var memory_1 = requireMemory$1();
    Object.defineProperty(exports2, "addValue", { enumerable: true, get: function() {
      return memory_1.addValue;
    } });
    var helpers_1 = requireHelpers$1();
    Object.defineProperty(exports2, "trimUndefined", { enumerable: true, get: function() {
      return helpers_1.trimUndefined;
    } });
    Object.defineProperty(exports2, "trimUndefinedRecursively", { enumerable: true, get: function() {
      return helpers_1.trimUndefinedRecursively;
    } });
    var config_1 = requireConfig$1();
    Object.defineProperty(exports2, "config", { enumerable: true, get: function() {
      return config_1.config;
    } });
  })(dist$1);
  return dist$1;
}
var distExports$1 = requireDist$1();
distExports$1.decompress([["elements", "aliasedElements", "a|0|1", "name", "children", "childBuckets", "abstractAncestors", "attributes", "properties", "top", "acceptsStringChildren", "takesIndex", "docsSlug", "summary", "layoutCategory", "a|3|4|5|6|7|8|9|A|B|C|D|E", "title", "rightHandSide", "xLabel", "yLabel", "br", "m", "me", "men", "md", "mdn", "mrow", "not", "and", "or", "xor", "iff", "implies", "isInteger", "isNumber", "isBetween", "sum", "product", "clampNumber", "wrapNumberPeriodic", "round", "setSmallToZero", "convertSetToList", "ceil", "floor", "abs", "sign", "mean", "median", "variance", "standardDeviation", "count", "min", "max", "mod", "gcd", "lcm", "extractMath", "clampFunction", "wrapFunctionPeriodic", "derivative", "extractMathOperator", "em", "alert", "q", "sq", "term", "c", "tag", "tage", "tagc", "attr", "ndash", "mdash", "nbsp", "ellipsis", "lq", "rq", "lsq", "rsq", "odeSystem", "equilibriumPoint", "equilibriumLine", "atom", "ion", "ionicCompound", "electronConfiguration", "span", "displayDoenetML", "matrixInput", "fractionInput", "text", "textList", "boolean", "booleanList", "math", "mathList", "tupleList", "numberList", "collect", "ref", "point", "coords", "line", "bezierControls", "vector", "angle", "answer", "mathInput", "textInput", "booleanInput", "choiceInput", "choice", "number", "integer", "function", "piecewiseFunction", "interval", "sequence", "cell", "repeat", "repeatForSequence", "intersection", "conditionalContent", "asList", "selectFromSequence", "select", "group", "evaluate", "selectRandomNumbers", "sampleRandomNumbers", "selectPrimeNumbers", "samplePrimeNumbers", "substitute", "periodicSet", "intComma", "pluralize", "lorem", "updateValue", "callAction", "triggerSet", "functionIterates", "module", "footnote", "endpoint", "sort", "shuffle", "solveEquations", "subsetOfReals", "split", "bestFitLine", "hasSameFactoring", "label", "matchesPattern", "matrix", "latex", "pointList", "intervalList", "vectorList", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y", "11111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222212221222221112111121222112211111222", "_textOrInline", "_inline", "_base", "a|2b|2c|2d", "description", "type", "a|3|2f|2g", "The name used to reference this component from elsewhere in the document.", "o|2h|3|2i|1T", "defaultValue", "values", "a|3|2f|2k|2l|2g", "hide", "Whether to hide this component from the rendered output.", "b|F", "true", "false", "a|2q|2r", "o|2m|2n|2o|2p|2s|1V", "disabled", "Whether this component is disabled and cannot be interacted with.", "o|2m|2u|2v|2p|2s|1V", "fixed", "Whether this component's value is fixed and cannot be modified.", "o|2m|2x|2y|2p|2s|1V", "fixLocation", "Whether this component's location is fixed (preventing it from being moved while still allowing other modifications).", "o|2m|30|31|2p|2s|1V", "a|3|2f|2k|2g", "styleNumber", "The style number used to select this component's visual styling from the available style definitions.", "n|1", "o|33|34|35|36|1q", "isResponse", "Whether this component is treated as a response for the purposes of assessment.", "o|2m|38|39|2p|2s|1V", "extend", "Extend another component by reference, inheriting its children and attributes. Enter a reference as `$name`.", "reference", "o|2h|3B|3C|3D", "copy", "Create an independent copy of another component by reference. Enter a references a `$name`.", "o|2h|3F|3G|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H", "isArray", "fromAttribute", "a|3|2g|3J|2f|3K", "b|T", "o|3L|2n|1V|2p|2o|3M", "o|3L|34|1q|2p|35|3M", "o|3L|38|1V|2p|39|3M", "a|3|2g|3J|2f", "hidden", "Whether this component is hidden from the rendered output.", "o|3Q|3R|1V|2p|3S", "o|3Q|2u|1V|2p|2v", "o|3Q|2x|1V|2p|2y", "o|3Q|30|1V|2p|31", "doenetML", "The DoenetML source code that produced this component.", "o|3Q|3X|1T|2p|3Y", "value", "The combined content of this component's children.", "o|3Q|3a|G|2p|3b", "The combined content of this component's children, as a plain text string.", "o|3Q|1T|1T|2p|3d", "a|3N|3O|3P|3T|3U|3V|3W|3Z|3c|3e", "Creates a title within a document, section, or other block component", "inline", "o|F|G|2Z|2a|2e|3I|3f|3M|3M|2p|G|3g|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1222211111111111111111111112222222221222202222122222222212222122222122221212222", "a|2c|2d", "highlighted", "autocompleteValues", "a|3|2f|3m|2k|2l|3n|2g", "format", "Input format.", "a|1T|2V", "a|3a|2f", "Plain-text math notation (e.g., `x^2 + 1`).", "o|3s|1T|3t", "LaTeX-formatted math (e.g., `x^{2} + 1`).", "o|3s|2V|3v", "a|3u|3w", "keyword", "o|3o|3p|3q|3M|1T|3r|3x|3y", "simplify", "Level of simplification applied to the expression.", "none", "full", "numbers", "numbersPreserveOrder", "normalizeOrder", "a|42|43|44|45|46|2q|2r", "No simplification is applied.", "o|3s|42|48", "Fully simplify the expression.", "o|3s|43|4A", "Simplify numeric subexpressions only, leaving symbolic structure intact.", "o|3s|44|4C", "Like `numbers`, but does not reorder commutative operands.", "o|3s|45|4E", "Reorder commutative operands into a canonical form without simplifying values.", "o|3s|46|4G", "a|49|4B|4D|4F|4H", "o|3o|40|41|3M|42|47|4I|3y", "expand", "Whether to expand the expression.", "o|2m|4K|4L|2p|2s|1V", "groupName", "a|3|2f|4N|3m|2k|2g", "displayDigits", "Number of significant digits to display when rendering this number.", "number-display", "n|3", "o|4O|4P|4Q|4R|3M|4S|1q", "a|3|2f|4N|2k|2g", "displayDecimals", "Number of decimal places to display when rendering this number.", "n|2", "o|4U|4V|4W|4R|4X|1q", "displaySmallAsZero", "Threshold below which numbers are displayed as zero.", "n|1.0.-E", "o|4U|4Z|4a|4R|4b|1p", "a|3|2f|4N|2k|2l|2g", "padZeros", "Whether to pad displayed numbers with trailing zeros to fill the requested digits/decimals.", "o|4d|4e|4f|4R|2p|2s|1V", "avoidScientificNotation", "Whether to render numbers in full decimal form rather than scientific notation.", "o|4d|4h|4i|4R|2p|2s|1V", "renderMode", 'How the math is rendered (e.g. "inline", "display").', "o|33|4k|4l|3h|1T", "unordered", "Whether tuple- or list-like math expressions should be treated as unordered for comparison.", "o|2m|4n|4o|2p|2s|1V", "createVectors", "Whether tuple-like expressions are interpreted as vectors.", "o|2m|4q|4r|2p|2s|1V", "createIntervals", "Whether range expressions are interpreted as intervals.", "o|2m|4t|4u|2p|2s|1V", "functionSymbols", "Symbols treated as function names when parsing.", "f", "g", "a|4y|4z", "o|33|4w|4x|50|1U", "referencesAreFunctionSymbols", "References whose names should be treated as function symbols when parsing.", "a|", "o|33|52|53|54|3D", "splitSymbols", "Whether multi-character symbols are split into a product of variables.", "o|2m|56|57|3M|2s|1V", "parseScientificNotation", "Whether to parse expressions like 1e3 as scientific notation.", "o|2m|59|5A|2p|2s|1V", "displayBlanks", "Whether blanks (placeholders) are visibly rendered.", "o|2m|5C|5D|3M|2s|1V", "assumptions", "Assumptions applied when simplifying or comparing.", "a|2g|2V", "＿", "o|5H|1X|5I", "o|33|5F|5G|5J|1X", "draggable", "Whether the math component can be dragged on a graph.", "o|2m|5L|5M|3M|2s|1V", "layer", "Z-order layer index when shown on a graph.", "n|0", "o|33|5O|5P|5Q|1p", "anchor", "Coordinates of the anchor point used to position this component on a graph.", "positioning", "\\left( 0, 0 \\right)", "o|5H|1X|5V", "o|4U|5S|5T|5U|5W|1d", "a|3|2f|4N|2k|2l|3n|2g", "positionFromAnchor", "Where this component sits relative to its anchor point.", "center", "upperRight", "upperLeft", "lowerRight", "lowerLeft", "bottom", "left", "right", "a|5c|5d|5e|5f|9|5g|5h|5i|5b", "Place the component above and to the right of the anchor point.", "o|3s|5c|5k", "Place the component above and to the left of the anchor point.", "o|3s|5d|5m", "Place the component below and to the right of the anchor point.", "o|3s|5e|5o", "Place the component below and to the left of the anchor point.", "o|3s|5f|5q", "Place the component directly above the anchor point.", "o|3s|9|5s", "Place the component directly below the anchor point.", "o|3s|5g|5u", "Place the component directly to the left of the anchor point.", "o|3s|5h|5w", "Place the component directly to the right of the anchor point.", "o|3s|5i|5y", "Center the component on the anchor point.", "o|3s|5b|60", "a|5l|5n|5p|5r|5t|5v|5x|5z|61", "o|5Y|5Z|5a|5U|5b|5j|62|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "a|3|2g|3J|2f|3K|3m", "o|65|3p|1T|2p|3q|3M|3M", "o|65|40|1T|2p|41|3M|3M", "o|3L|4K|1V|2p|4L|3M", "o|3L|4k|1T|2p|4l|3M", "o|3L|4q|1V|2p|4r|3M", "o|3L|4t|1V|2p|4u|3M", "o|3L|4w|1U|2p|4x|3M", "o|3L|56|1V|2p|57|3M", "o|3L|59|1V|2p|5A|3M", "o|3L|5C|1V|2p|5D|3M", "o|3L|5F|1X|2p|5G|3M", "o|3L|5L|1V|2p|5M|3M", "o|3L|5O|1p|2p|5P|3M", "a|3|2g|3J|2f|3K|4N", "o|6J|5Z|1T|2p|5a|3M|5U", "textColor", "Human-readable name for this component's text color, derived from the active style and theme.", "o|3Q|6L|1T|2p|6M", "backgroundColor", "Human-readable name for this component's background color, derived from the active style and theme.", "o|3Q|6O|1T|2p|6P", "textStyleDescription", "Human-readable description of this component's text styling (color and any background color).", "o|3Q|6R|1T|2p|6S", "a|3|2g|3J|2f|4N", "The coordinates where this component is anchored on the graph.", "o|6U|5S|1d|2p|6V|5U", "o|3Q|4P|1q|2p|4Q", "o|3Q|4V|1q|2p|4W", "o|3Q|4Z|1p|2p|4a", "o|3Q|4e|1V|2p|4f", "o|3Q|4h|1V|2p|4i", "Whether list-like values are treated as unordered.", "o|3Q|4n|1V|2p|6c", "The math expression value.", "o|3Q|3a|H|2p|6e", "The numeric value of the expression (NaN if not a number).", "o|3Q|1p|1p|2p|6g", "Whether the expression evaluates to a finite number.", "o|3Q|Y|1V|2p|6i", "isNumeric", "Whether the expression evaluates to any number (including infinities).", "o|3Q|6k|1V|2p|6l", "The expression rendered as a LaTeX string.", "o|3Q|2V|2V|2p|6n", "The expression rendered as a plain text string.", "o|3Q|1T|1T|2p|6p", "numDimensions", "The number of dimensions if the math expression is interpreted as a vector or matrix.", "o|3Q|6r|1q|2p|6s", "indexedArrayDescription", "a|3|2g|3J|2f|6r|6u", "The math expression interpreted as a vector (its components).", "a|3J|2g", "o|6x|2p|1h", "a|6y", "o|6v|1h|1X|3M|6w|36|6z", "list", "The math expression interpreted as a list (its elements).", "a|3J|2g|6r", "o|73|3M|1X|36", "a|74", "o|6v|71|1X|3M|72|36|75", "matrixSize", "The size of the math expression as a matrix, as a [numRows, numColumns] list.", "o|3Q|77|1a|2p|78", "numRows", "The number of rows when the math expression is interpreted as a matrix.", "o|3Q|7A|1q|2p|7B", "numColumns", "The number of columns when the math expression is interpreted as a matrix.", "o|3Q|7D|1q|2p|7E", "The math expression interpreted as a matrix (its entries by row and column).", "o|6x|2p|2U", "a|7H|7H", "o|6v|2U|1X|3M|7G|4X|7I", "rows", "The matrix's entries grouped by row.", "o|6v|7K|1X|3M|7L|4X|7I", "columns", "The matrix's entries grouped by column.", "o|6v|7N|1X|3M|7O|4X|7I", "x", "The first component of the math expression when interpreted as a vector.", "o|3Q|7Q|1X|2p|7R", "y", "The second component of the math expression when interpreted as a vector.", "o|3Q|7T|1X|2p|7U", "z", "The third component of the math expression when interpreted as a vector.", "o|3Q|7W|1X|2p|7X", "numListItems", "The number of items when the math expression is interpreted as a list.", "o|3Q|7Z|1q|2p|7a", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|6f|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A right-hand-side expression of an equation in an ODE system", "o|F|H|3j|3k|3l|64|7c|3M|3M|2p|H|7d|3h", "for", "Reference to the component this label is for (e.g., an input).", "o|2h|7f|7g|3D", "forObject", "Reference to the graphical object this label is attached to.", "o|2h|7i|7j|3D", "Whether the label can be dragged on a graph.", "o|2m|5L|7l|3M|2s|1V", "maskLabel", "Whether to give the label an opaque background so it stays legible when it overlaps an axis, grid line, or another object.", "o|2m|7n|7o|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|7h|7k|7m|5R|7p|5X|63", "o|3L|5L|1V|2p|7l|3M", "o|3L|7n|1V|2p|7o|3M", "hasLatex", "Whether the label contains LaTeX content.", "o|3Q|7t|1V|2p|7u", "The label's text content.", "o|3Q|1T|1T|2p|7w", "The label's content as a LaTeX string.", "o|3Q|2V|2V|2p|7y", "The label's content as a label-typed value.", "o|3Q|3a|I|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|81", "A label for the x-axis of a graph", "o|F|I|2Z|2a|3l|7q|82|3M|3M|2p|I|83|3h", "o|3Q|3a|J|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|85", "A label for the y-axis of a graph", "o|F|J|2Z|2a|3l|7q|86|3M|3M|2p|J|87|3h", "statement", "introduction", "conclusion", "hr", "section", "subsection", "subsubsection", "paragraphs", "aside", "objectives", "problem", "exercise", "question", "activity", "example", "definition", "note", "theorem", "part", "task", "proof", "problems", "exercises", "ol", "ul", "cobwebPolyline", "equilibriumCurve", "orbitalDiagram", "orbitalDiagramInput", "sideBySide", "sbsGroup", "stack", "div", "pre", "paginator", "paginatorControls", "solution", "givenAnswer", "document", "p", "lineSegment", "ray", "polyline", "polygon", "triangle", "rectangle", "regularPolygon", "circle", "parabola", "curve", "award", "graph", "annotations", "annotation", "slider", "spreadsheet", "row", "column", "cellBlock", "tabular", "table", "figure", "pegboard", "variantControl", "animateFromSequence", "image", "video", "hint", "feedback", "moduleAttributes", "setup", "caption", "subsetOfRealsInput", "regionBetweenCurveXAxis", "regionBetweenCurves", "regionHalfPlane", "codeEditor", "legend", "eigenDecomposition", "blockQuote", "stickyGroup", "pretzel", "cascade", "a|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|1z|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_block", "a|9W|2d", "aggregateScores", "Whether to aggregate scores of scored descendants into a section credit-achieved value.", "scoring", "o|4d|9Y|9Z|9a|2p|2s|1V", "weight", "Relative weight of this section when aggregated by an enclosing scored section.", "o|4U|9c|9d|9a|36|1p", "sectionWideCheckWork", "Whether to show a single section-wide check-work button instead of per-answer buttons.", "o|4d|9f|9g|9a|2p|2s|1V", "maxNumAttempts", "Maximum number of times the section-wide check-work button can be submitted. Once reached, all enclosed answers are disabled.", "Infinity", "o|4U|9i|9j|9a|9k|1q", "showCorrectness", "Whether to display correctness indicators for the answers it contains.", "o|4d|9m|9n|9a|3M|2s|1V", "colorCorrectness", "Whether to color-code the answers it contains based on correctness.", "o|4d|9p|9q|9a|3M|2s|1V", "colorAnswersSeparately", "When section-wide check work is enabled, color each answer based on its own correctness rather than the section's overall credit.", "o|4d|9s|9t|9a|2p|2s|1V", "submitLabel", "Label for the section-wide submit button when correctness is shown.", "Check Work", "o|4U|9v|9w|9a|9x|1T", "submitLabelNoCorrectness", "Label for the section-wide submit button when correctness is not shown.", "Submit Response", "o|4U|9z|A0|9a|A1|1T", "displayDigitsForCreditAchieved", "Number of significant digits to display for the credit achieved value.", "o|4U|A3|A4|9a|4S|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "o|6J|9c|1p|2p|9d|3M|9a", "o|6J|9f|1V|2p|9g|3M|9a", "o|6J|9i|1q|2p|9j|3M|9a", "o|6J|9v|1T|2p|9w|3M|9a", "o|6J|9z|1T|2p|A0|3M|9a", "o|6J|A3|1q|2p|A4|3M|9a", "numSubmissions", "Number of times the section-wide check-work button has been submitted.", "o|3Q|AD|1q|2p|AE", "numAttemptsLeft", "Remaining number of section-wide submissions before the maximum is reached.", "o|3Q|AG|1q|2p|AH", "Whether scores of scored descendants are aggregated into this section's credit value.", "o|3Q|9Y|1V|2p|AJ", "creditAchieved", "Aggregate credit achieved (between 0 and 1) for scored descendants of this section.", "o|3Q|AL|1p|2p|AM", "percentCreditAchieved", "Aggregate credit achieved as a percentage (between 0 and 100).", "o|3Q|AO|1p|2p|AP", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ", "A block container for the statement of a problem, theorem, or similar", "block", "o|F|89|9U|9V|9X|A6|AR|3M|3M|2p|89|AS|AT", "A block container for the introduction of a section", "o|F|8A|9U|9V|9X|A6|AR|3M|3M|2p|8A|AV|AT", "A block container for the conclusion of a section", "o|F|8B|9U|9V|9X|A6|AR|3M|3M|2p|8B|AX|AT", "", "a|3N|3O|3P|3T|3U|3V|3W|3Z", "A line break", "o|F|K|54|AZ|3l|3I|Aa|3M|2p|2p|K|Ab|3h", "A horizontal rule used to separate content", "o|F|8C|54|AZ|9X|3I|Aa|3M|2p|2p|8C|Ad|AT", "cascadeMessage", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|8W|8X", "1111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222221222122222111211112122211221111122200", "The paragraph's text content.", "o|3Q|1T|1T|2p|Ai", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|Aj", "Placeholder shown inside a `<cascade>` in place of a not-yet-revealed entry", "o|F|Af|Ag|Ah|9X|A6|Ak|2p|3M|2p|Af|Al|AT", "else", "a|2d", "a|3|2f|2l|2g", "condition", "Boolean expression; this case is selected when the condition is true.", "o|Ap|Aq|Ar|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|As", "conditionSatisfied", "Whether this case's condition is currently satisfied.", "o|3Q|Au|1V|2p|Av", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Aw", "Default branch within a `<conditionalContent>`; matched when no `<case>` condition is true", "other", "o|F|An|9U|9V|Ao|At|Ax|2p|3M|2p|An|Ay|Az", "Whether the math display can be dragged on a graph.", "o|2m|5L|B1|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63", "o|3L|5L|1V|2p|B1|3M", "The math content rendered as a LaTeX string.", "o|3Q|2V|2V|2p|B5", "The math content rendered as a plain text string.", "o|3Q|1T|1T|2p|B7", "The math content as a math expression.", "o|3Q|1X|1X|2p|B9", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA", "Inline math rendered with LaTeX", "o|F|L|2Z|2a|3l|B3|BB|3M|3M|2p|L|BC|3h", "Display math rendered with LaTeX", "o|F|M|2Z|2a|3l|B3|BB|3M|3M|2p|M|BE|3h", "equationTag", "The equation number (when numbered).", "o|3Q|BG|1T|2p|BH", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA|BI", "Numbered display math rendered with LaTeX", "o|F|N|2Z|2a|3l|B3|BJ|3M|3M|2p|N|BK|3h", "a|Q|1z", "02", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8", "Display math with multiple aligned rows", "o|F|O|BM|BN|3l|B3|BO|3M|2p|2p|O|BP|3h", "Numbered display math with multiple aligned rows", "o|F|P|BM|BN|3l|B3|BO|3M|2p|2p|P|BR|3h", "Whether to attach an equation number to this row.", "o|Ap|1p|BT|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63|BU", "A row of math within an aligned display", "o|F|Q|2Z|2a|3l|BV|BJ|3M|3M|2p|Q|BW|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "1222211111111111111111111112221222221220202222122222012212222122222111221211222221111111110212120", "_booleanOperatorOneInput", "a|Ba|2c|2d", "symbolicEquality", "Whether children compared via this boolean use symbolic equality.", "o|2m|Bc|Bd|2p|2s|1V", "expandOnCompare", "Whether to expand math expressions before comparing.", "o|2m|Bf|Bg|2p|2s|1V", "a|3|2f|2k|2l|3n|2g", "simplifyOnCompare", "Level of simplification applied to math expressions before comparing.", "No simplification is applied before comparing.", "o|3s|42|Bl", "Fully simplify both expressions before comparing.", "o|3s|43|Bn", "a|Bm|Bo|4D|4F|4H", "o|Bi|Bj|Bk|42|47|Bp|3y", "unorderedCompare", "Whether order is ignored when comparing list-like values.", "o|2m|Br|Bs|2p|2s|1V", "matchByExactPositions", "Whether to match list values by exact position rather than by content.", "o|2m|Bu|Bv|2p|2s|1V", "allowedErrorInNumbers", "Maximum allowed numeric error when comparing numbers.", "o|33|Bx|By|5Q|1p", "includeErrorInNumberExponents", "Whether the allowed numeric error also applies to numbers in exponents.", "o|2m|C0|C1|2p|2s|1V", "allowedErrorIsAbsolute", "Whether allowedErrorInNumbers is interpreted as an absolute (rather than relative) tolerance.", "o|2m|C3|C4|2p|2s|1V", "numSignErrorsMatched", "Maximum number of sign errors that still count as a match.", "o|33|C6|C7|5Q|1p", "numPeriodicSetMatchesRequired", "Number of consecutive elements of a periodic set required to count as a match.", "o|33|C9|CA|4S|1q", "caseInsensitiveMatch", "Whether text comparisons ignore letter case.", "o|2m|CC|CD|2p|2s|1V", "matchBlanks", "Whether unfilled blanks in a math expression count as a match.", "o|2m|CF|CG|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH", "o|3L|Bc|1V|2p|Bd|3M", "o|3L|Bf|1V|2p|Bg|3M", "o|3L|Bj|1T|2p|Bk|3M", "o|3L|Br|1V|2p|Bs|3M", "o|3L|Bu|1V|2p|Bv|3M", "o|3L|Bx|1p|2p|By|3M", "o|3L|C0|1V|2p|C1|3M", "o|3L|C3|1V|2p|C4|3M", "o|3L|C6|1p|2p|C7|3M", "o|3L|C9|1q|2p|CA|3M", "o|3L|CC|1V|2p|CD|3M", "o|3L|CF|1V|2p|CG|3M", 'The boolean rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|CV", "The boolean result of applying this operator to its single boolean input.", "o|3Q|3a|1V|2p|CX", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|CW|CY", "Logical negation of a boolean value", "o|F|R|BY|BZ|Bb|CI|CZ|3M|3M|2p|R|Ca|3h", "a|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|1z|2R|2T", "111111111022211", "_booleanOperator", "a|Ce|2c|2d", "The boolean result of applying this operator to its child boolean values.", "o|3Q|3a|1V|2p|Cg", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Ch|CW", "Logical AND: true only when all child boolean values are true", "o|F|S|Cc|Cd|Cf|CI|Ci|3M|3M|2p|S|Cj|3h", "Logical OR: true when at least one child boolean value is true", "o|F|T|Cc|Cd|Cf|CI|Ci|3M|3M|2p|T|Cl|3h", "Logical exclusive OR: true when exactly one child boolean value is true", "o|F|U|Cc|Cd|Cf|CI|Ci|3M|3M|2p|U|Cn|3h", "IF and only iF: Logical bicondition (IFF): true when all child boolean values are the same", "o|F|V|Cc|Cd|Cf|CI|Ci|3M|3M|2p|V|Cp|3h", "Logical implication (binary): true when the first value is false or the second value is true", "o|F|W|Cc|Cd|Cf|CI|Ci|3M|3M|2p|W|Cr|3h", "_booleanOperatorOfMath", "a|Ct|2c|2d", "The boolean result of applying this operator to its child math values.", "o|3Q|3a|1V|2p|Cv", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Cw|CW", "True when the math child evaluates to an integer", "o|F|X|3j|3k|Cu|CI|Cx|3M|3M|2p|X|Cy|3h", "True when the math child evaluates to a finite number", "o|F|Y|3j|3k|Cu|CI|Cx|3M|3M|2p|Y|D0|3h", "limits", "Numeric limits used by the boolean operator (e.g. bounds for isBetween).", "o|33|D2|D3|54|1a", "strict", "Whether the comparison is strict (e.g. uses < instead of ≤).", "o|2m|D5|D6|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|D4|D7", "o|3L|D2|1a|2p|D3|3M", "o|3L|D5|1V|2p|D6|3M", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|D9|DA|3T|3U|3V|3W|3Z|Cw|CW", "True when a math value is between two given bounds", "o|F|Z|3j|3k|Cu|D8|DB|3M|3M|2p|Z|DC|3h", "1222211111111111111111111112222222221222202222122222012212222122222122221212222", "_mathOperator", "a|DF|2c|2d", "forceSymbolic", "Whether to force the operator to evaluate symbolically rather than numerically.", "o|2m|DH|DI|2p|2s|1V", "forceNumeric", "Whether to force the operator to evaluate numerically rather than symbolically.", "o|2m|DK|DL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM", "o|3L|DH|1V|2p|DI|3M", "o|3L|DK|1V|2p|DL|3M", "o|3Q|3a|a|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DQ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sum of the child math or number values", "o|F|a|3j|DE|DG|DN|DR|3M|3M|2p|a|DS|3h", "o|3Q|3a|b|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DU|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Product of the child math or number values", "o|F|b|3j|DE|DG|DN|DV|3M|3M|2p|b|DW|3h", "_mathOperatorOneInput", "a|DY|2c|2d", "lowerValue", "Lower bound used by the operator.", "o|33|Da|Db|5Q|1p", "upperValue", "Upper bound used by the operator.", "o|33|Dd|De|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dc|Df", "o|3L|Da|1p|2p|Db|3M", "o|3L|Dd|1p|2p|De|3M", "o|3Q|3a|c|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Clamps a number to a specified range", "o|F|c|3j|3k|DZ|Dg|Dk|3M|3M|2p|c|Dl|3h", "o|3Q|3a|d|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dn|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Wraps a number into a periodic range", "o|F|d|3j|3k|DZ|Dg|Do|3M|3M|2p|d|Dp|3h", "n|E", "o|4O|4P|4Q|4R|3M|Dr|1q", "numDecimals", "Number of decimal places (for round-style operators).", "o|33|Dt|Du|5Q|1p", "numDigits", "Number of significant digits (for round-style operators).", "o|33|Dw|Dx||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|Ds|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dv|Dy", "o|3L|Dt|1p|2p|Du|3M", "o|3L|Dw|1p|2p|Dx|3M", "o|3Q|3a|e|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|E0|E1|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|E2|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Rounds a number to a specified precision", "o|F|e|3j|3k|DZ|Dz|E3|3M|3M|2p|e|E4|3h", "threshold", "Threshold value used by the operator.", "o|33|E6|E7|4b|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|E8", "o|3L|E6|1p|2p|E7|3M", "o|3Q|3a|f|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|EA|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Replaces values with magnitude below a threshold with zero", "o|F|f|3j|3k|DZ|E9|EC|3M|3M|2p|f|ED|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|g|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|EG|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Converts a math set expression into a list expression", "o|F|g|3j|3k|DZ|EF|EH|3M|3M|2p|g|EI|3h", "o|3Q|3a|h|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EK|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Smallest integer ≥ the input value", "o|F|h|3j|3k|DZ|64|EL|3M|3M|2p|h|EM|3h", "o|3Q|3a|i|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EO|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Largest integer ≤ the input value", "o|F|i|3j|3k|DZ|64|EP|3M|3M|2p|i|EQ|3h", "o|3Q|3a|j|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ES|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Absolute value of an expression", "o|F|j|3j|3k|DZ|64|ET|3M|3M|2p|j|EU|3h", "o|3Q|3a|k|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EW|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sign of the input (-1, 0, or 1)", "o|F|k|3j|3k|DZ|64|EX|3M|3M|2p|k|EY|3h", "o|3Q|3a|l|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ea|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Arithmetic mean of the child math or number values", "o|F|l|3j|DE|DG|DN|Eb|3M|3M|2p|l|Ec|3h", "o|3Q|3a|m|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ee|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Median of the child math or number values", "o|F|m|3j|DE|DG|DN|Ef|3M|3M|2p|m|Eg|3h", "population", "Whether to use the population formula (rather than sample).", "o|2m|Ei|Ej|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM|Ek", "o|3L|Ei|1V|2p|Ej|3M", "o|3Q|3a|n|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|En|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Variance of the child math or number values", "o|F|n|3j|DE|DG|El|Eo|3M|3M|2p|n|Ep|3h", "o|3Q|3a|o|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Er|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Standard deviation of the child math or number values", "o|F|o|3j|DE|DG|El|Es|3M|3M|2p|o|Et|3h", "o|3Q|3a|p|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ev|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "The number of the child math or number values", "o|F|p|3j|DE|DG|DN|Ew|3M|3M|2p|p|Ex|3h", "o|3Q|3a|q|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ez|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Minimum of the child math or number values", "o|F|q|3j|DE|DG|DN|F0|3M|3M|2p|q|F1|3h", "o|3Q|3a|r|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F3|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Maximum of the child math or number values", "o|F|r|3j|DE|DG|DN|F4|3M|3M|2p|r|F5|3h", "o|3Q|3a|s|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F7|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Modulo (remainder) of two values", "o|F|s|3j|DE|DG|DN|F8|3M|3M|2p|s|F9|3h", "o|3Q|3a|t|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Greatest common divisor of integer inputs", "o|F|t|3j|DE|DG|DN|FC|3M|3M|2p|t|FD|3h", "o|3Q|3a|u|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FF|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Least common multiple of integer inputs", "o|F|u|3j|DE|DG|DN|FG|3M|3M|2p|u|FH|3h", "What kind of sub-expression to extract.", "operand", "functionArgument", "numOperands", "recursiveOperands", "a|FK|1r|FL|FM|FN", "Extract a single operand of the top-level operation.", "o|3s|FK|FP", "Extract the function being applied (for a function call).", "o|3s|1r|FR", "Extract an argument of the function being called.", "o|3s|FL|FT", "Extract the count of operands at the top level.", "o|3s|FM|FV", "Extract all operands found recursively through nested operations.", "o|3s|FN|FX", "a|FQ|FS|FU|FW|FY", "o|Bi|2g|FJ||FO|FZ|3y", "operandNumber", "1-based index of the operand to extract.", "o|33|Fb|Fc||1p", "argumentNumber", "1-based index of the argument to extract.", "o|33|Fe|Ff||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Fa|Fd|Fg", "o|3L|Fb|1p|2p|Fc|3M", "o|3L|Fe|1p|2p|Ff|3M", "o|3Q|3a|v|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Fi|Fj|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Fk|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Extracts a sub-expression from a math expression by name or index", "o|F|v|3j|3k|DZ|Fh|Fl|3M|3M|2p|v|Fm|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|2S", "1222211111111111111111111111112222221222202222122222220112222122222122221212222110", "_functionOperator", "a|Fq|2c|2d", "Level of simplification applied to the function's formula.", "Fully simplify the function's formula.", "o|3s|43|Ft", "a|49|Fu|4D|4F|4H", "o|Bi|40|Fs|43|47|Fv|3y", "Whether to expand the function's formula.", "o|2m|4K|Fx|2p|2s|1V", "xscale", "Scale factor used along the x-axis.", "o|33|Fz|G0|36|1p", "yscale", "Scale factor used along the y-axis.", "o|33|G2|G3|36|1p", "numInputs", "Number of input arguments the function accepts.", "o|2h|G5|G6|1q", "numOutputs", "Number of output values the function produces.", "o|33|G8|G9|36|1q", "domain", "Restriction of the function's domain to a list of intervals.", "o|2h|GB|GC|2X", "labelIsName", "Whether to use this component's name as its rendered label.", "labels", "o|4d|GE|GF|GG|2p|2s|1V", "applyStyleToLabel", "Whether to apply the function's style to its label.", "o|2m|GI|GJ|2p|2s|1V", "labelPosition", "Position of the function's label.", "a|5c|5d|5e|5f|9|5g|5h|5i", "Place the label above and to the right of the function curve.", "o|3s|5c|GO", "Place the label above and to the left of the function curve.", "o|3s|5d|GQ", "Place the label below and to the right of the function curve.", "o|3s|5e|GS", "Place the label below and to the left of the function curve.", "o|3s|5f|GU", "Place the label directly above the function curve.", "o|3s|9|GW", "Place the label directly below the function curve.", "o|3s|5g|GY", "Place the label directly to the left of the function curve.", "o|3s|5h|Ga", "Place the label directly to the right of the function curve.", "o|3s|5i|Gc", "a|GP|GR|GT|GV|GX|GZ|Gb|Gd", "o|Bi|GL|GM|5c|GN|Ge|3y", "Z-order layer index for stacking the function on a graph.", "o|33|5O|Gg|5Q|1p", "minima", "Local minima of an interpolated function.", "extrema", "o|2h|Gi|Gj|Gk", "maxima", "Local maxima of an interpolated function.", "o|2h|Gm|Gn|Gk", "Local extrema (combined minima and maxima) of an interpolated function.", "o|2h|Gk|Gp|Gk", "through", "Points the interpolated function should pass through.", "o|2h|Gr|Gs|2W", "throughSlopes", "Slopes the interpolated function should have at each through-point.", "o|2h|Gu|Gv|1Y", "variables", "Names of the function's input variables.", "_variableNameList", "o|2h|Gx|Gy|Gz", "variable", "Name of the function's single input variable.", "_variableName", "o|2h|H1|H2|H3", "symbolic", "Whether the function should be evaluated symbolically rather than numerically.", "o|2m|H5|H6|3M|2s|1V", "o|4U|4P|4Q|4R|4S|1q", "nearestPointAsCurve", "Whether nearest-point queries should treat the function as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|HA|2p|2s|1V", "a|3|2f|2l|3n|2g", "lineStyle", "Stroke style for lines.", "solid", "dashed", "dotted", "a|HF|HG|HH", "Continuous, unbroken stroke.", "o|3s|HF|HJ", "Stroke composed of evenly-spaced dashes.", "o|3s|HG|HL", "Stroke composed of evenly-spaced dots.", "o|3s|HH|HN", "a|HK|HM|HO", "o|HC|HD|HE|HI|HP|3y", "lineWidth", "Stroke width for lines, in pixels.", "o|2h|HR|HS|1p", "Lower bound for the operator's range.", "o|33|Da|HU|5Q|1p", "Upper bound for the operator's range.", "o|33|Dd|HW|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|HV|HX", "expandSpecified", "o|3Q|HZ|1V|2p|Fx", "o|3L|Fz|1p|2p|G0|3M", "o|3L|G2|1p|2p|G3|3M", "o|6J|GE|1V|2p|GF|3M|GG", "o|3L|GI|1V|2p|GJ|3M", "o|3L|GL|1T|2p|GM|3M", "o|3L|5O|1p|2p|Gg|3M", "o|3L|Da|1p|2p|HU|3M", "o|3L|Dd|1p|2p|HW|3M", "The label rendered with this component.", "o|6U|2S|2S|2p|Hj|GG", "styleDescription", "A textual description of the function's style.", "o|3Q|Hl|1T|2p|Hm", "styleDescriptionWithNoun", 'Style description including the word "function".', "o|3Q|Ho|1T|2p|Hp", "Number of input variables of the function.", "o|3Q|G5|1q|2p|Hr", "Number of output values of the function.", "o|3Q|G8|1q|2p|Ht", "Domain interval(s) of the function.", "o|73|3M|1t|36", "a|Hw", "o|6v|GB|1t|3M|Hv|36|Hx", "Level of simplification applied when displaying the formula.", "o|3Q|40|1T|2p|Hz", "Whether to expand the formula.", "o|3Q|4K|1T|2p|I1", "Whether the function is treated symbolically.", "o|3Q|H5|1V|2p|I3", "The names of the function's input variables.", "o|73|3M|H3|36", "a|I6", "o|6v|Gx|H3|3M|I5|36|I7", "formula", "The symbolic formula of the function produced by this operator.", "o|3Q|I9|1X|2p|IA", "The function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|IC", "The function rendered as a plain text string.", "o|3Q|1T|1T|2p|IE", "numMinima", "Number of local minima of the function.", "o|3Q|IG|1p|2p|IH", "Local minima of the function.", "o|73|3M|1d|36", "o|6x|2p|1d", "a|IK|IL", "o|6v|Gi|1p|3M|IJ|4X|IM", "minimumLocations", "The x-coordinates of the function's local minima.", "o|73|3M|1p|36", "a|IQ", "o|6v|IO|1p|3M|IP|36|IR", "minimumValues", "The values of the function's local minima.", "o|6v|IT|1p|3M|IU|36|IR", "globalMinimum", "The global minimum of the function (if attained).", "a|IL", "o|6v|IW|1p|3M|IX|36|IY", "globalInfimum", "The global infimum of the function.", "o|6v|Ia|1p|3M|Ib|36|IY", "numMaxima", "Number of local maxima of the function.", "o|3Q|Id|1p|2p|Ie", "Local maxima of the function.", "o|6v|Gm|1p|3M|Ig|4X|IM", "maximumLocations", "The x-coordinates of the function's local maxima.", "o|6v|Ii|1p|3M|Ij|36|IR", "maximumValues", "The values of the function's local maxima.", "o|6v|Il|1p|3M|Im|36|IR", "globalMaximum", "The global maximum of the function (if attained).", "o|6v|Io|1p|3M|Ip|36|IY", "globalSupremum", "The global supremum of the function.", "o|6v|Ir|1p|3M|Is|36|IY", "numExtrema", "Number of local extrema (minima + maxima) of the function.", "o|3Q|Iu|1p|2p|Iv", "Local extrema (minima + maxima) of the function.", "o|6v|Gk|1p|3M|Ix|4X|IM", "extremumLocations", "The x-coordinates of the function's local extrema.", "o|6v|Iz|1p|3M|J0|36|IR", "extremumValues", "The values of the function's local extrema.", "o|6v|J2|1p|3M|J3|36|IR", "The function's first input variable name.", "o|3Q|H1|H3|2p|J5", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|Hh|Hi|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function clamped to a specified output range", "o|F|w|Fo|Fp|Fr|HY|J7|3M|3M|2p|w|J8|3h", "A function wrapped into a periodic output range", "o|F|x|Fo|Fp|Fr|HY|J7|3M|3M|2p|x|JA|3h", "derivVariables", "Names of variables to differentiate with respect to.", "o|2h|JC|JD|Gz", "derivVariable", "Name of the variable to differentiate with respect to.", "o|2h|JF|JG|H3", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|JE|JH", "Number of input variables.", "o|3Q|G5|1q|2p|JJ", "Names of the input variables.", "o|6v|Gx|H3|3M|JL|36|I7", "numDerivatives", "Number of derivatives applied.", "o|3Q|JN|1q|2p|JO", "Variables with respect to which derivatives are taken.", "o|6v|JC|H3|3M|JQ|36|I7", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|Hu|Hy|I0|I2|I4|JM|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|JP|JR|J6", "The derivative of a function", "o|F|y|Fo|Fp|Fr|JI|JS|3M|3M|2p|y|JT|3h", "_textOperatorOfMath", "a|JV|2c|2d", "Whether the text can be dragged on a graph.", "o|2m|5L|JX|3M|2s|1V", "isLatex", "Whether the text content is treated as LaTeX.", "o|2m|JZ|Ja|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63", "o|3L|5L|1V|2p|JX|3M", "o|3L|JZ|1V|2p|Ja|3M", "The text result of applying this operator to its child math values.", "o|3Q|3a|1T|2p|Jf", "The text rendered as a plain text string.", "o|3Q|1T|1T|2p|Jh", "The text parsed as a math expression.", "o|3Q|1X|1X|2p|Jj", "The text parsed as a number.", "o|3Q|1p|1p|2p|Jl", "numWords", "The number of words in the text value.", "o|3Q|Jn|1q|2p|Jo", "words", "The text value split into words.", "o|73|3M|1T|36", "a|Js", "o|6v|Jq|1T|3M|Jr|36|Jt", "numCharacters", "The number of characters (graphemes) in the text value.", "o|3Q|Jv|1q|2p|Jw", "characters", "The text value split into characters (graphemes).", "o|6v|Jy|1T|3M|Jz|36|Jt", "The number of comma-separated items when the text is interpreted as a list.", "o|3Q|7Z|1q|2p|K1", "The text value split into items at commas.", "o|6v|71|1T|3M|K3|36|Jt", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|Jg|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", 'Returns the top-level operator of a math expression as text (e.g. "+", "vector")', "o|F|z|3j|3k|JW|Jc|K5|3M|2p|2p|z|K6|3h", "_inlineRenderInlineChildren", "a|K8|2c|2d", "The combined text content of this component's children, with optional begin/end delimiters.", "o|3Q|1T|1T|2p|KA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|KB", "Emphasized inline text (italic by default)", "o|F|10|2Z|2a|K9|3I|KC|3M|3M|2p|10|KD|3h", "Bold text", "o|F|11|2Z|2a|K9|3I|KC|3M|3M|2p|11|KF|3h", "Inline double-quoted text", "o|F|12|2Z|2a|K9|3I|KC|3M|3M|2p|12|KH|3h", "Inline single-quoted text", "o|F|13|2Z|2a|K9|3I|KC|3M|3M|2p|13|KJ|3h", "An inline term, styled distinctively", "o|F|14|2Z|2a|K9|3I|KC|3M|3M|2p|14|KL|3h", "Inline code text", "o|F|15|2Z|2a|K9|3I|KC|3M|3M|2p|15|KN|3h", "Renders enclosed text as an opening tag, `< >`", "o|F|16|2Z|2a|K9|3I|KC|3M|3M|2p|16|KP|3h", "Renders enclosed text as a self-closing tag, `< />`", "o|F|17|2Z|2a|K9|3I|KC|3M|3M|2p|17|KR|3h", "Renders enclosed text as a closing tag, `</ >`", "o|F|18|2Z|2a|K9|3I|KC|3M|3M|2p|18|KT|3h", "Renders a styled attribute name", "o|F|19|2Z|2a|K9|3I|KC|3M|3M|2p|19|KV|3h", "_singleCharacterInline", "a|KX|2c|2d", "The unicode character rendered by this component.", "o|3Q|1T|1T|2p|KZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Ka", "Renders an en-dash (–) character", "o|F|1A|54|AZ|KY|3I|Kb|3M|2p|2p|1A|Kc|3h", "Renders an em-dash (—) character", "o|F|1B|54|AZ|KY|3I|Kb|3M|2p|2p|1B|Ke|3h", "Renders a non-breaking space character", "o|F|1C|54|AZ|KY|3I|Kb|3M|2p|2p|1C|Kg|3h", "Renders a horizontal ellipsis (…) character", "o|F|1D|54|AZ|KY|3I|Kb|3M|2p|2p|1D|Ki|3h", "Renders a left double quotation mark (“)", "o|F|1E|54|AZ|KY|3I|Kb|3M|2p|2p|1E|Kk|3h", "Renders a right double quotation mark (”)", "o|F|1F|54|AZ|KY|3I|Kb|3M|2p|2p|1F|Km|3h", "Renders a left single quotation mark (‘)", "o|F|1G|54|AZ|KY|3I|Kb|3M|2p|2p|1G|Ko|3h", "Renders a right single quotation mark (’)", "o|F|1H|54|AZ|KY|3I|Kb|3M|2p|2p|1H|Kq|3h", "styleDefinition", "feedbackDefinition", "a|1z|9A|G|9H|Ks|Kt|Af|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1000000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_sectioningComponentNumberWithSiblings", "_sectioningComponent", "a|Kw|Kx|9W|2d", "boxed", "Whether to render this section with a visible box around it.", "o|2m|Kz|L0|2p|2s|1V", "includeAutoName", 'Whether to include the auto-generated section name (e.g. "Section") in the rendered title.', "o|2m|L2|L3|2p|2s|1V", "includeAutoNumber", "Whether to include the auto-generated section number in the rendered title.", "o|2m|L5|L6|2p|2s|1V", "noAutoTitle", "Whether to suppress the auto-generated title entirely.", "o|2m|L8|L9|2p|2s|1V", "includeAutoNameIfNoTitle", "Whether to include the auto-generated name when no explicit title is provided.", "o|2m|LB|LC|3M|2s|1V", "includeAutoNumberIfNoTitle", "Whether to include the auto-generated number when no explicit title is provided.", "o|2m|LE|LF|3M|2s|1V", "Whether to render this section's children as a list.", "o|2m|20|LH|2p|2s|1V", "collapsible", "Whether the section can be collapsed and expanded.", "o|2m|LJ|LK|2p|2s|1V", "startOpen", "Whether the collapsible section starts in the open state.", "o|2m|LM|LN|3M|2s|1V", "level", "The heading level for this section (overrides the default level inferred from nesting).", "o|2h|LP|LQ|1q", "completedColor", "Color used to indicate this section has been completed.", "var(--lightGreen)", "o|33|LS|LT|LU|1T", "inProgressColor", "Color used to indicate this section is in progress.", "var(--mainGray)", "o|33|LW|LX|LY|1T", "notStartedColor", "Color used to indicate this section has not been started.", "o|33|La|Lb|LY|1T", "completedColorDarkMode", "Color used to indicate this section has been completed (dark mode). If omitted, the dark-mode color is derived from `completedColor` when that attribute is explicitly set; otherwise falls back to a dark green that meets WCAG AA contrast for white text.", "#1a5e20", "o|33|Ld|Le|Lf|1T", "inProgressColorDarkMode", "Color used to indicate this section is in progress (dark mode). If omitted, the dark-mode color is derived from `inProgressColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "#3a3a3a", "o|33|Lh|Li|Lj|1T", "notStartedColorDarkMode", "Color used to indicate this section has not been started (dark mode). If omitted, the dark-mode color is derived from `notStartedColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "o|33|Ll|Lm|Lj|1T", "includeParentNumber", "Whether to prefix this section's number with the parent section's number.", "o|2m|Lo|Lp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|Lq", "o|3L|L2|1V|2p|L3|3M", "o|3L|L5|1V|2p|L6|3M", "o|3L|L8|1V|2p|L9|3M", "o|3L|LB|1V|2p|LC|3M", "o|3L|LE|1V|2p|LF|3M", "o|3L|20|1V|2p|LH|3M", "o|3L|LJ|1V|2p|LK|3M", "o|3L|Lo|1V|2p|Lp|3M", "Whether this section is rendered with a visible box around it.", "o|3Q|Kz|1V|2p|M0", "sectionNumber", "The displayed number for this section.", "o|3Q|M2|1T|2p|M3", "The displayed title text for this section.", "o|3Q|G|1T|2p|M5", "open", "Whether this section is currently open (for collapsible sections).", "o|3Q|M7|1V|2p|M8", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|Lz|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A section of a document, with a title (auto-generated or custom) and content", "o|F|8D|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8D|MB|AT", "A sectional component nested one heading level deeper than `<section>`", "o|F|8E|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8E|MD|AT", "A sectional component nested one heading level deeper than `<subsection>`", "o|F|8F|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8F|MF|AT", "o|2m|Lo|Lp|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A subsection of paragraphs (rendered at heading level 4)", "o|F|8G|Ku|Kv|Ky|MI|MA|3M|3M|2p|8G|MJ|AT", "o|2m|LJ|LK|3M|2s|1V", "o|2m|LM|LN|2p|2s|1V", "postponeRendering", "Whether to delay rendering this section's contents until expanded.", "o|Ap|MN|MO|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|ML|MM|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|MP", "A note set off from the main flow of the document", "o|F|8H|Ku|Kv|Ky|MQ|MA|3M|3M|2p|8H|MR|AT", "o|2m|Kz|L0|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|MT|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A section listing learning objectives", "o|F|8I|Ku|Kv|Ky|MU|MA|3M|3M|2p|8I|MV|AT", "o|4d|9Y|9Z|9a|3M|2s|1V", "isDistractor", "Whether this section is a distractor (e.g. a wrong-answer choice for matching).", "o|Ap|MY|MZ|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|MX|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|Ma", "A sectional component that defines a scored problem", "o|F|8J|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8J|Mc|AT", "A sectional component that defines a scored exercise", "o|F|8K|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8K|Me|AT", "A sectional component that defines a scored question; similar to a `<problem>`", "o|F|8L|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8L|Mg|AT", "A sectional component with score aggregation, similar to `<problem>`", "o|F|8M|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8M|Mi|AT", "A sectional component that defines an example", "o|F|8N|Ku|Kv|Ky|MI|MA|3M|3M|2p|8N|Mk|AT", "A sectional component for defining a term or concept", "o|F|8O|Ku|Kv|Ky|MI|MA|3M|3M|2p|8O|Mm|AT", "A note section, set off from the main flow of the document", "o|F|8P|Ku|Kv|Ky|MI|MA|3M|3M|2p|8P|Mo|AT", "A sectional component for the statement of a theorem (or similar formal statement)", "o|F|8Q|Ku|Kv|Ky|MI|MA|3M|3M|2p|8Q|Mq|AT", "A subsection-style block rendered as a list item (a part of an exercise or problem)", "o|F|8R|Ku|Kv|Ky|MI|MA|3M|3M|2p|8R|Ms|AT", "A task of a multi-task activity or problem (alias for `<part>`)", "o|F|8S|Ku|Kv|Ky|MI|MA|3M|3M|2p|8S|Mu|AT", "_unnumberedSectioningComponent", "a|Mw|Kx|9W|2d", "o|2m|LE|LF|2p|2s|1V", "renameTo", 'Override the auto-generated section name (e.g. rename "Section" to a custom label).', "o|2h|Mz|N0|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|My|LI|ML|MM|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|MP", "The displayed number for this section (always null for unnumbered sections).", "o|3Q|M2|1T|2p|N3", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|N4|M6|M9", "A proof section", "o|F|8T|Ku|Kv|Mx|N2|N5|3M|3M|2p|8T|N6|AT", "a|Kx|9W|2d", "o|2m|20|LH|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|N9|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A container element grouping `<problem>` components, which are rendered as a list by default", "o|F|8U|Ku|Kv|N8|NA|NB|3M|3M|2p|8U|NC|AT", "A container element grouping `<exercise>` components, which are rendered as a list by default", "o|F|8V|Ku|Kv|N8|NA|NB|3M|3M|2p|8V|NE|AT", "li", "a|NG|1z", "Nesting level of this list (1-based).", "o|2h|LP|NI|1q", "marker", "Marker style for list items (e.g. 'disc', 'circle', '1', 'a').", "o|33|NK|NL||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|NJ|NM|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "An ordered list", "o|F|8W|NH|BN|9X|NN|AR|3M|2p|2p|8W|NO|AT", "An unordered list", "o|F|8X|NH|BN|9X|NN|AR|3M|2p|2p|8X|NQ|AT", "The list's content rendered as plain text.", "o|3Q|1T|1T|2p|NS", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|NT", "A list item within `<ol>` / `<ul>`", "o|F|NG|9U|9V|Ao|A6|NU|2p|3M|2p|NG|NV|Az", "a|H|1z", "independentVariable", "The independent variable of the ODE system.", "t", "o|5H|1X|Na", "o|33|NY|NZ|Nb|H3", "initialIndependentVariableValue", "The value of the independent variable at which the initial conditions are specified.", "0", "o|5H|1X|Nf", "o|33|Nd|Ne|Ng|1X", 'How to format the rendered system of equations (e.g. "align").', "align", "o|33|4k|Ni|Nj|1T", "chunkSize", "Step-size chunk used when numerically integrating the system.", "n|A", "o|33|Nl|Nm|Nn|1p", "tolerance", "Numerical tolerance used by the integrator.", "n|0.Q0u", "o|33|Np|Nq|Nr|1p", "maxIterations", "Maximum number of iterations the integrator may perform.", "n|G8", "o|33|Nt|Nu|Nv|1p", "hideInitialCondition", "Whether to hide the initial condition from the rendered output.", "o|2m|Nx|Ny|2p|2s|1V", "initialConditions", "The initial values of each dependent variable, in order.", "o|2h|O0|O1|1Y", "The dependent variables of the system, in the same order as the right-hand sides.", "o|2h|Gx|O3|Gz", "Whether to display equation numbers next to each equation.", "o|2m|1p|O5|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Nc|Nh|H8|4Y|4c|4g|4j|Nk|No|Ns|Nw|Nz|O2|O4|O6", "o|3L|NY|H3|2p|NZ|3M", "o|3L|Nd|1X|2p|Ne|3M", "o|3L|4k|1T|2p|Ni|3M", "o|3L|Nl|1p|2p|Nm|3M", "o|3L|Np|1p|2p|Nq|3M", "o|3L|Nt|1p|2p|Nu|3M", "o|3L|Nx|1V|2p|Ny|3M", "o|3L|1p|1V|2p|O5|3M", "The dependent variables of the system, in order matching the right-hand sides.", "o|6v|Gx|H3|3M|OG|36|I7", "rhss", "The right-hand-side expressions of each ODE in the system.", "o|6v|OI|1X|3M|OJ|36|75", "The initial values of each dependent variable at the initial independent variable value.", "o|6v|O0|1X|3M|OL|36|75", "The displayed equation number tag (when equation numbering is enabled).", "o|3Q|BG|1T|2p|ON", "The full ODE system rendered as a LaTeX string.", "o|3Q|2V|2V|2p|OP", "numericalSolutions", "Numerical solution functions for each dependent variable, as functions of the independent variable.", "o|73|3M|1r|36", "a|OT", "o|6v|OR|1r|3M|OS|36|OU", "rhs", "The right-hand-side expression of the first ODE in the system.", "o|3Q|OW|1X|2p|OX", "righthandside", "o|3Q|OZ|1X|2p|OX", "righthandsides", "o|6v|Ob|1X|3M|OJ|36|75", "initialCondition", "The initial value of the first dependent variable at the initial independent-variable value.", "o|3Q|Od|1X|2p|Oe", "numericalSolution", "Numerical solution function for the first dependent variable, as a function of the independent variable.", "o|3Q|Og|1r|2p|Oh", "a|3N|3O|3P|O8|O9|OA|OB|OC|OD|OE|OF|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|OH|OK|OM|OO|OQ|OV|OY|Oa|Oc|Of|Oi", "A system of first-order ordinary differential equations with initial conditions, rendered as math and numerically integrable", "o|F|1I|NX|BN|3l|O7|Oj|3M|2p|2p|1I|Ok|3h", "a|I|J|1z|2S", "1120", "_graphical", "a|Oo|2d", "Whether to apply this component's selected style to its label.", "o|2m|GI|Oq|2p|2s|1V", "Z-order layer index used to stack graphical components (higher values render on top).", "o|33|5O|Os|5Q|1q", "Whether the polyline can be dragged on a graph.", "o|2m|5L|Ou|3M|2s|1V", "verticesDraggable", "Whether individual vertices may be dragged independently.", "o|Ap|Ow|Ox|2s|1V", "vertices", "The list of vertex points that define the shape.", "o|2h|Oz|P0|2W", "showCoordsWhenDragging", "Whether to show coordinate labels while dragging.", "o|2m|P2|P3|3M|2s|1V", "rigid", "Whether the polyline is treated as rigid (preserves shape under drag).", "o|2m|P5|P6|2p|2s|1V", "preserveSimilarity", "Whether the shape is preserved up to similarity (uniform scaling) under drag.", "o|2m|P8|P9|2p|2s|1V", "rotationHandleVertices", "Vertex indices that should display rotation handles when the shape is rigid or preserves similarity.", "a|36", "o|33|PB|PC|PD|1a", "rotateAround", "What point to rotate the shape around.", "centroid", "vertex", "a|PH|PI|1d", "Rotate around the centroid of the shape.", "o|3s|PH|PK", "Rotate around the vertex specified by `rotationVertex`.", "o|3s|PI|PM", "Rotate around the explicit point given by `rotationCenter`.", "o|3s|1d|PO", "a|PL|PN|PP", "o|Bi|PF|PG|PH|PJ|PQ|3y", "rotationCenter", "The point to rotate around when rotateAround is 'point'.", "o|33|PS|PT||1d", "rotationVertex", "The vertex index to rotate around when rotateAround is 'vertex'.", "o|33|PV|PW|36|1q", "allowRotation", "Whether the polyline can be rotated under drag.", "o|2m|PY|PZ|3M|2s|1V", "allowTranslation", "Whether the polyline can be translated under drag.", "o|2m|Pb|Pc|3M|2s|1V", "allowDilation", "Whether the shape can be dilated (scaled) under drag.", "o|2m|Pe|Pf|3M|2s|1V", "minShrink", "Minimum scaling factor allowed when dilating.", "n|0.1", "o|33|Ph|Pi|Pj|1p", "allowReflection", "Whether the polyline can be reflected under drag.", "o|2m|Pl|Pm|3M|2s|1V", "attractThreshold", "Distance within which a dragged vertex snaps to the function curve or diagonal.", "n|0.5", "o|33|Po|Pp|Pq|1p", "numPoints", "Number of points (iterations) currently shown on the cobweb diagram.", "o|33|Ps|Pt|36|1p", "Symbol used as the independent variable when displaying iterate values.", "o|5H|1X|7Q", "o|33|H1|Pv|Pw|H3", "numIterationsRequired", "Minimum number of iterations the user is required to perform.", "o|33|Py|Pz|5Q|1p", "initialPoint", "The starting point on the diagonal where iteration begins.", "o|2h|Q1|Q2|1d", "The function being iterated.", "o|2h|1r|Q4|1r", "lockToSolution", "Whether to constrain dragged vertices to the correct cobweb solution.", "o|2m|Q6|Q7|2p|2s|1V", "defaultPoint", "The default location for newly added points on the cobweb diagram.", "o|2h|Q9|QA|1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|Pr|Pu|Px|Q0|Q3|Q5|Q8|QB", "o|3L|GI|1V|2p|Oq|3M", "o|3L|5O|1q|2p|Os|3M", "o|3L|5L|1V|2p|Ou|3M", "o|3L|P2|1V|2p|P3|3M", "o|3L|P5|1V|2p|P6|3M", "o|3L|PY|1V|2p|PZ|3M", "o|3L|Pb|1V|2p|Pc|3M", "o|3L|Pl|1V|2p|Pm|3M", "o|3L|Po|1p|2p|Pp|3M", "o|3L|Ps|1p|2p|Pt|3M", "o|3L|H1|H3|2p|Pv|3M", "o|3L|Py|1p|2p|Pz|3M", "A textual description of the polyline's style.", "o|3Q|Hl|1T|2p|QP", 'Style description including the word "polyline".', "o|3Q|Ho|1T|2p|QR", "Whether the polyline preserves its shape (up to similarity).", "o|3Q|P8|1V|2p|QT", "Whether the polyline can be dilated under drag.", "o|3Q|Pe|1V|2p|QV", "Whether each vertex can be dragged independently.", "o|3Q|Ow|1V|2p|QX", "The number of dimensions the polyline lives in.", "o|3Q|6r|1p|2p|QZ", "indexAliases", "a|3|2g|3J|2f|6r|6u|Qb", "The vertices of the polyline.", "a|7Q|7T|7W", "a|54|Qe", "o|Qc|Oz|1X|3M|Qd|4X|IM|Qf", "length", "The total length of the polyline.", "o|3Q|Qh|1p|2p|Qi", "The centroid of the polyline's vertices.", "o|6v|5b|1X|3M|Qk|36|IY", "o|6v|Q1|1X|3M|Q2|36|IY", "correctVertices", "Per-vertex flags indicating whether each vertex is positioned at the correct cobweb solution.", "o|73|3M|1V|36", "a|Qp", "o|6v|Qn|1V|3M|Qo|36|Qq", "fractionCorrectVertices", "The fraction of vertices placed at correct cobweb positions.", "o|3Q|Qs|1p|2p|Qt", "numGradedVertices", "The number of cobweb vertices that were evaluated for correctness.", "o|3Q|Qv|1p|2p|Qw", "numCorrectVertices", "The number of cobweb vertices placed at correct positions.", "o|3Q|Qy|1p|2p|Qz", "fractionCorrectVerticesAdjusted", "The fraction of correct vertices, scaled by the required minimum number of iterations.", "o|3Q|R1|1p|2p|R2", "numGradedVerticesAdjusted", "The effective number of graded vertices after adjusting for the required minimum number of iterations.", "o|3Q|R4|1p|2p|R5", "numIterateValues", "The number of iterate values produced by the cobweb diagram.", "o|3Q|R7|1p|2p|R8", "iterateValues", "The list of iterate values shown by the cobweb diagram.", "o|6v|RA|1X|3M|RB|36|75", "numVertices", "Number of cobweb vertices currently shown (alias for numPoints).", "o|3Q|RD|1p|2p|RE", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|Qa|Qg|Qj|Ql|Qm|Qr|Qu|Qx|R0|R3|R6|R9|RC|RF", "An interactive cobweb diagram for visualizing iteration of a one-variable function", "o|F|8Y|Om|On|Op|QC|RG|3M|2p|2p|8Y|RH|Az", "constrainToGrid", "constrainToGraph", "attractToGrid", "constrainTo", "attractTo", "constraintUnion", "attractToConstraint", "constrainToInterior", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|RJ|RK|RL|RM|RN|RO|RP|RQ|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "112011111111111111111111111110220101221211112221111111122220122222222222222222222222222222", "markerStyle", "Marker shape.", "square", "triangleUp", "triangleDown", "triangleLeft", "triangleRight", "diamond", "a|8u|RV|8r|RW|RX|RY|RZ|Ra", "Circular marker.", "o|3s|8u|Rc", "Square marker.", "o|3s|RV|Re", 'Triangular marker pointing up (alias for "triangleUp").', "o|3s|8r|Rg", "Triangular marker pointing up.", "o|3s|RW|Ri", "Triangular marker pointing down.", "o|3s|RX|Rk", "Triangular marker pointing left.", "o|3s|RY|Rm", "Triangular marker pointing right.", "o|3s|RZ|Ro", "Diamond-shaped marker.", "o|3s|Ra|Rq", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr", "o|HC|RT|RU|Rb|Rs|3y", "markerSize", "Marker size in pixels.", "o|2h|Ru|Rv|1p", "Whether the point can be dragged on a graph.", "o|2m|5L|Rx|3M|2s|1V", "The first coordinate (x) of the point.", "o|2h|7Q|Rz|1X", "The second coordinate (y) of the point.", "o|2h|7T|S1|1X", "The third coordinate (z) of the point.", "o|2h|7W|S3|1X", "xs", "The point's coordinates as a list.", "o|2h|S5|S6|1Y", "The point's coordinates as a single math expression.", "o|2h|1e|S8|1e", "Position of the point's label.", "Place the label above and to the right of the point.", "o|3s|5c|SB", "Place the label above and to the left of the point.", "o|3s|5d|SD", "Place the label below and to the right of the point.", "o|3s|5e|SF", "Place the label below and to the left of the point.", "o|3s|5f|SH", "Place the label directly above the point.", "o|3s|9|SJ", "Place the label directly below the point.", "o|3s|5g|SL", "Place the label directly to the left of the point.", "o|3s|5h|SN", "Place the label directly to the right of the point.", "o|3s|5i|SP", "a|SC|SE|SG|SI|SK|SM|SO|SQ", "o|Bi|GL|SA|5c|GN|SR|3y", "addControls", "Whether to render interactive control handles.", "both", "xOnly", "yOnly", "a|42|SV|SW|SX|2q|2r", "Show no control handles.", "o|3s|42|SZ", "Show control handles for moving the point in both x and y.", "o|3s|SV|Sb", "Show a control handle that constrains motion to the x direction.", "o|3s|SW|Sd", "Show a control handle that constrains motion to the y direction.", "o|3s|SX|Sf", "a|Sa|Sc|Se|Sg", "o|Bi|ST|SU|SV|SY|Sh|3y", "hideOffGraphIndicator", "Whether to suppress the indicator drawn at the edge when the point is off-screen.", "o|Ap|Sj|Sk|2s|1V", "controlOrder", "Slot order for graph controls (1-indexed; 0 means no explicit slot request).", "o|33|Sm|Sn|5Q|1q", "stable", "Whether the equilibrium is stable (rendered filled) or unstable (rendered open).", "o|2m|Sp|Sq|3M|2s|1V", "switchable", "Whether the user can toggle the stability of this equilibrium by clicking it.", "o|2m|Ss|St|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|Sr|Su", "o|3L|5L|1V|2p|Rx|3M", "o|3L|GL|1T|2p|SA|3M", "o|3L|ST|1T|2p|SU|3M", "o|3L|Sm|1q|2p|Sn|3M", "o|3L|Sp|1V|2p|Sq|3M", "o|3L|Ss|1V|2p|St|3M", "scales", "The graph axis scales (x and y) used when applying this constraint.", "o|3Q|T2|1p|2p|T3", "constraintUsed", "Whether this constraint was applied to the component.", "o|3Q|T5|1V|2p|T6", "A textual description of the point's style.", "o|3Q|Hl|1T|2p|T8", 'Style description including the word "point".', "o|3Q|Ho|1T|2p|TA", "Whether to suppress the off-graph indicator when out of view.", "o|3Q|Sj|1V|2p|TC", "Number of dimensions of the point.", "o|3Q|6r|1p|2p|TE", "o|6v|S5|1X|3M|S6|36|75", "The point's coordinates as a math expression.", "o|3Q|1e|1e|2p|TH", "The point rendered as a LaTeX string.", "o|3Q|2V|2V|2p|TJ", "numDimensionsForConstraints", "Number of dimensions exposed to constraint computations (alias for numDimensions).", "o|3Q|TL|1p|2p|TM", "o|3Q|7Q|1X|2p|Rz", "o|3Q|7T|1X|2p|S1", "o|3Q|7W|1X|2p|S3", "o|3Q|3a|1e|2p|S8", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|T0|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "An equilibrium point of a dynamical system, rendered as a filled point if stable or open if unstable", "o|F|1J|RR|RS|Op|Sv|TS|3M|3M|2p|1J|TT|Az", "a|I|J|1z|2S|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1120122221111111111111111111111222222222122220222212222201221222122222122221212222", "Whether the line can be dragged on a graph.", "o|2m|5L|TX|3M|2s|1V", "equation", "Implicit equation defining the line.", "o|2h|TZ|Ta|1X", "Points the line passes through.", "o|2h|Gr|Tc|2W", "slope", "Slope of the line.", "o|2h|Te|Tf|1p", "perpendicularTo", "Direction the line should be perpendicular to (e.g. another line or vector).", "_directionComponent", "o|2h|Th|Ti|Tj", "parallelTo", "Direction the line should be parallel to (e.g. another line or vector).", "o|2h|Tl|Tm|Tj", "Names of the variables used in the line equation.", "o|2h|Gx|To|Gz", "Where the label sits along this line/curve.", "a|5c|5d|5e|5f|5b|9|5g|5h|5i", "Place the label above and to the right of the line.", "o|3s|5c|Ts", "Place the label above and to the left of the line.", "o|3s|5d|Tu", "Place the label below and to the right of the line.", "o|3s|5e|Tw", "Place the label below and to the left of the line.", "o|3s|5f|Ty", "Place the label at the midpoint of the line.", "o|3s|5b|U0", "Place the label directly above the line.", "o|3s|9|U2", "Place the label directly below the line.", "o|3s|5g|U4", "Place the label directly to the left of the line.", "o|3s|5h|U6", "Place the label directly to the right of the line.", "o|3s|5i|U8", "a|Tt|Tv|Tx|Tz|U1|U3|U5|U7|U9", "o|Bi|GL|Tq|5b|Tr|UA|3y", "Whether the equilibrium is stable (rendered solid) or unstable (rendered dashed).", "o|2m|Sp|UC|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|UD|Su", "o|3L|5L|1V|2p|TX|3M", "o|3L|GL|1T|2p|Tq|3M", "o|3L|Sp|1V|2p|UC|3M", "A textual description of the line's style.", "o|3Q|Hl|1T|2p|UI", 'Style description including the word "line".', "o|3Q|Ho|1T|2p|UK", "Number of dimensions the line lives in.", "o|3Q|6r|1p|2p|UM", "Variable names used in the line's equation.", "o|6v|Gx|H3|3M|UO|36|I7", "points", "Two points the line passes through.", "o|Qc|UQ|1X|3M|UR|4X|IM|Qf", "The line's equation as a math expression.", "o|3Q|TZ|1X|2p|UT", "coeff0", "The constant term in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UV|1X|2p|UW", "coeffvar1", "The coefficient of the first variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UY|1X|2p|UZ", "coeffvar2", "The coefficient of the second variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|Ub|1X|2p|Uc", "The slope of the line (2D only).", "o|3Q|Te|1X|2p|Ue", "xintercept", "The x-intercept of the line.", "o|3Q|Ug|1X|2p|Uh", "yintercept", "The y-intercept of the line.", "o|3Q|Uj|1X|2p|Uk", "The line's equation rendered as LaTeX.", "o|3Q|2V|2V|2p|Um", "The line's equation rendered as plain text.", "o|3Q|1T|1T|2p|Uo", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "An equilibrium line of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|1K|TV|TW|Op|UE|Uq|3M|3M|2p|1K|Ur|Az", "a|I|J|1z|2S|w|x|y|1r|1s|1g|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11201110101222211111111111111111111112222221222202222122222011222122222122221212222", "fillOpacity", "Opacity of solid fills, 0 to 1.", "o|2h|Uv|Uw|1p", "fillPatternOpacity", "Opacity of pattern fills (non-solid fillStyle), 0 to 1.", "o|2h|Uy|Uz|1p", "fillStyle", "Fill pattern used inside closed shapes.", "horizontal", "vertical", "diagonal", "backDiagonal", "dots", "diamonds", "a|HF|V3|V4|V5|V6|V7|V8", "Solid fill.", "o|3s|HF|VA", "Horizontal line pattern.", "o|3s|V3|VC", "Vertical line pattern.", "o|3s|V4|VE", "Diagonal line pattern (/).", "o|3s|V5|VG", "Back-diagonal line pattern (\\).", "o|3s|V6|VI", "Dots pattern.", "o|3s|V7|VK", "Filled diamonds pattern.", "o|3s|V8|VM", "a|VB|VD|VF|VH|VJ|VL|VN", "o|HC|V1|V2|V9|VO|3y", "Whether the curve can be dragged on a graph.", "o|2m|5L|VQ|3M|2s|1V", "Position of the curve's label relative to the curve.", "Place the label above and to the right of the curve.", "o|3s|5c|VT", "Place the label above and to the left of the curve.", "o|3s|5d|VV", "Place the label below and to the right of the curve.", "o|3s|5e|VX", "Place the label below and to the left of the curve.", "o|3s|5f|VZ", "Place the label directly above the curve.", "o|3s|9|Vb", "Place the label directly below the curve.", "o|3s|5g|Vd", "Place the label directly to the left of the curve.", "o|3s|5h|Vf", "Place the label directly to the right of the curve.", "o|3s|5i|Vh", "a|VU|VW|VY|Va|Vc|Ve|Vg|Vi", "o|Bi|GL|VS|5c|GN|Vj|3y", "flipFunction", "Whether to swap the function and its argument (i.e., reflect across y=x).", "o|2m|Vl|Vm|2p|2s|1V", "numDiscretizationPoints", "Number of points used when discretizing the curve for rendering.", "o|33|Vo|Vp|Nv|1p", "periodic", "Whether the curve is treated as periodic when interpolating between control points.", "o|2m|Vr|Vs|2p|2s|1V", "splineTension", "Tension parameter used when fitting a spline through control points.", "n|0.8", "o|33|Vu|Vv|Vw|1p", "extrapolateBackward", "Whether to extrapolate the curve before its first defined point.", "o|2m|Vy|Vz|2p|2s|1V", "extrapolateForward", "Whether to extrapolate the curve beyond its last defined point.", "o|2m|W1|W2|2p|2s|1V", "splineForm", "Form of spline used to interpolate between control points.", "centripetal", "uniform", "a|W6|W7", "Centripetal Catmull-Rom spline (avoids self-intersection at sharp turns).", "o|3s|W6|W9", "Uniform Catmull-Rom spline with evenly spaced parameterization.", "o|3s|W7|WB", "a|WA|WC", "o|Bi|W4|W5|W6|W8|WD|3y", "Name of the curve's parameter or independent variable.", "o|33|H1|WF|Pw|H3", "Points the interpolated curve passes through.", "o|2h|Gr|WH|2W", "parMin", "Minimum value of the curve's parameter (for parametric curves).", "o|2h|WJ|WK|1X", "parMax", "Maximum value of the curve's parameter (for parametric curves).", "o|2h|WM|WN|1X", "Whether to show coordinate labels while dragging the curve.", "o|2m|P2|WP|3M|2s|1V", "Whether nearest-point queries should treat this as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|WR|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j|UD|Su", "o|3L|5L|1V|2p|VQ|3M", "o|3L|GL|1T|2p|VS|3M", "o|3L|Vl|1V|2p|Vm|3M", "o|3L|Vo|1p|2p|Vp|3M", "o|3L|Vr|1V|2p|Vs|3M", "o|3L|Vu|1p|2p|Vv|3M", "o|3L|Vy|1V|2p|Vz|3M", "o|3L|W1|1V|2p|W2|3M", "o|3L|W4|1T|2p|W5|3M", "o|3L|P2|1V|2p|WP|3M", "A textual description of the curve's style.", "o|3Q|Hl|1T|2p|We", 'Style description including the word "curve".', "o|3Q|Ho|1T|2p|Wg", "Maximum value of the curve's parameter.", "o|3Q|WM|1p|2p|Wi", "Minimum value of the curve's parameter.", "o|3Q|WJ|1p|2p|Wk", "Number of dimensions the curve lives in.", "o|3Q|6r|1p|2p|Wm", "throughPoints", "Points the curve is constrained to pass through.", "o|6v|Wo|1X|3M|Wp|4X|IM", "vectorControlDirections", "Direction symmetry of each control vector pair.", "o|6v|Wr|1T|3M|Ws|36|Jt", "hiddenControls", "Whether each control vector is currently hidden.", "o|6v|Wu|1V|3M|Wv|36|Qq", "controlVectors", "The Bezier control vectors at each through-point.", "o|73|3M|1h|4X", "o|73|3M|1h|36", "a|Wz|X0|6y", "a|54|54|Qe", "o|Qc|Wx|1X|3M|Wy|4S|X1|X2", "controlPoints", "The Bezier control points (vertex + offset) for each through-point.", "o|73|3M|1d|4X", "a|X6|IK|IL", "o|6v|X4|1X|3M|X5|4S|X7", "extrapolateBackwardMode", "The extrapolation style used before the first through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|X9|1T|2p|XA", "extrapolateForwardMode", "The extrapolation style used beyond the last through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|XC|1T|2p|XD", "fs", "The component functions of the curve as functions of its parameter.", "o|6v|XF|1r|3M|XG|36|OU", "numXCriticalPoints", "The number of x-critical points (horizontal tangents) on the curve.", "o|3Q|XI|1q|2p|XJ", "xCriticalPoints", "The x-critical points (horizontal tangents) on the curve.", "o|6v|XL|1p|3M|XM|4X|IM", "numYCriticalPoints", "The number of y-critical points (vertical tangents) on the curve.", "o|3Q|XO|1q|2p|XP", "yCriticalPoints", "The y-critical points (vertical tangents) on the curve.", "o|6v|XR|1p|3M|XS|4X|IM", "numCurvatureChangePoints", "The number of points where the curve's curvature changes sign.", "o|3Q|XU|1q|2p|XV", "curvatureChangePoints", "Points where the curve's curvature changes sign (inflection points).", "o|6v|XX|1p|3M|XY|4X|IM", "The first component function of the curve as a function of its parameter.", "o|3Q|4y|1r|2p|Xa", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "An equilibrium curve of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|8Z|Ut|Uu|Op|WT|Xc|3M|3M|2p|8Z|Xd|Az", "symbol", 'The chemical symbol of the atom (e.g. "H", "He", "Li").', "o|2h|Xf|Xg|1T", "atomicNumber", "The atomic number of the atom (number of protons).", "o|2h|Xi|Xj|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Xh|Xk|H8|4Y|4c|4g|4j", "The atomic number of the element.", "o|3Q|Xi|1q|2p|Xm", "The chemical symbol of the element.", "o|3Q|Xf|1T|2p|Xo", "The full name of the element.", "o|3Q|3|1T|2p|Xq", "The group number of the element in the periodic table.", "o|3Q|23|1q|2p|Xs", "atomicMass", "The atomic mass of the element.", "o|3Q|Xu|1p|2p|Xv", "phaseAtSTP", "The phase (solid, liquid, or gas) of the element at standard temperature and pressure.", "o|3Q|Xx|1T|2p|Xy", "chargeOfCommonIon", "The charge of the most common ion of this element.", "o|3Q|Y0|1q|2p|Y1", "metalCategory", "The metal category of the element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Y4", `The descriptive name of the element's periodic group (e.g. "Alkali metals").`, "o|3Q|4N|1T|2p|Y6", "period", "The period number of the element in the periodic table.", "o|3Q|Y8|1q|2p|Y9", "ionizationEnergy", "The first ionization energy of the element.", "o|3Q|YB|1p|2p|YC", "meltingPoint", "The melting point of the element.", "o|3Q|YE|1p|2p|YF", "boilingPoint", "The boiling point of the element.", "o|3Q|YH|1p|2p|YI", "atomicRadius", "The atomic radius of the element.", "o|3Q|YK|1q|2p|YL", "density", "The density of the element at standard conditions.", "o|3Q|YN|1p|2p|YO", "electronegativity", "The Pauling electronegativity of the element.", "o|3Q|YQ|1p|2p|YR", "The electron configuration of the element as a math expression.", "o|3Q|1O|1O|2p|YT", "The orbital diagram of the element.", "o|3Q|8a|8a|2p|YV", "The atom rendered as a math expression with the element symbol.", "o|3Q|1X|1X|2p|YX", "The atom rendered as a LaTeX string.", "o|3Q|2V|2V|2p|YZ", "The atom rendered as a plain text string.", "o|3Q|1T|1T|2p|Yb", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|Xn|Xp|Xr|Xt|Xw|Xz|Y2|Y5|Y7|YA|YD|YG|YJ|YM|YP|YS|YU|YW|YY|Ya|Yc", "Represents a chemical element by symbol or atomic number, exposing its periodic-table properties", "o|F|1L|54|AZ|3l|Xl|Yd|3M|2p|2p|1L|Ye|3h", "a|1L|1z", 'The chemical symbol of the element (e.g. "Na", "Cl").', "o|2h|Xf|Yh|1T", "o|2h|Xi|Xm|1q", "charge", "The charge of the ion (positive for cations, negative for anions).", "o|2h|Yk|Yl|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Yi|Yj|Ym", "The charge of the ion.", "o|3Q|Yk|1q|2p|Yo", 'The full name of the ion (e.g. "sodium ion").', "o|3Q|3|1T|2p|Yq", "The group number of the underlying element in the periodic table.", "o|3Q|23|1q|2p|Ys", "The metal category of the underlying element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Yu", "The descriptive name of the underlying element's periodic group.", "o|3Q|4N|1T|2p|Yw", "The period number of the underlying element in the periodic table.", "o|3Q|Y8|1q|2p|Yy", "The ion rendered as a math expression (element symbol with charge).", "o|3Q|1X|1X|2p|Z0", "The ion rendered as a LaTeX string.", "o|3Q|2V|2V|2p|Z2", "The ion rendered as a plain text string.", "o|3Q|1T|1T|2p|Z4", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|Xn|Xp|Yp|Yr|Yt|Yv|Yx|Yz|Z1|Z3|Z5", "Represents a charged ion specified by element and charge, rendered with its chemical formula", "o|F|1M|Yg|BN|3l|Yn|Z6|3M|2p|2p|1M|Z7|3h", "a|1L|1M|1z", "202", "The chemical symbol of an element in the compound.", "o|2h|Xf|ZB|1T", "The atomic number of an element in the compound.", "o|2h|Xi|ZD|1q", "The charge of an ion in the compound.", "o|2h|Yk|ZF|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ZC|ZE|ZG", "The ionic compound rendered as a math expression of its chemical formula.", "o|3Q|1X|1X|2p|ZI", "The ionic compound rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZK", "The ionic compound rendered as a plain text string.", "o|3Q|1T|1T|2p|ZM", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|ZJ|ZL|ZN", "Forms a balanced ionic compound from constituent ions and renders its chemical formula", "o|F|1N|Z9|ZA|3l|ZH|ZO|3M|2p|2p|1N|ZP|3h", "o|3Q|3a|1O|2p|6e", "The electron configuration rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZS", "The electron configuration rendered as a unicode text string.", "o|3Q|1T|1T|2p|ZU", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ZR|6h|6j|6m|ZT|ZV|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Renders an electron configuration with sublevel labels and superscripted electron counts", "o|F|1O|3j|3k|3l|64|ZW|3M|3M|2p|1O|ZX|3h", "a|1Z|1z|8a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02012222111111111111111111111122222222212222022212222201221222122222122221212222", "Text labels for each orbital row.", "o|33|GG|Zb|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zc", "The orbital diagram value as a list of rows, each with a label and boxes containing up/down arrows.", "o|3Q|3a|8a|2p|Ze", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zf", "Renders an orbital diagram showing electrons in atomic orbitals as up/down arrows in boxes", "o|F|8a|ZZ|Za|9X|Zd|Zg|3M|3M|2p|8a|Zh|AT", "prefill", "An orbital diagram used to prefill the input before the student begins.", "o|33|Zj|Zk|54|8a", "prefillLabel", "Text labels to prefill for each orbital row.", "o|33|Zm|Zn|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zl|Zo", "The current orbital diagram entered by the student.", "o|3Q|3a|8a|2p|Zq", "The orbital diagram rows in display order (reversed from the underlying value).", "o|3Q|7K|8a|2p|Zs", "The number of orbital rows in the diagram.", "o|3Q|7A|1q|2p|Zu", "selectedRowIndex", "Index of the currently selected orbital row (1-based; 0 if none selected).", "o|3Q|Zw|1q|2p|Zx", "selectedBoxIndex", "Index of the currently selected box within the selected row (1-based; 0 if none selected).", "o|3Q|Zz|1q|2p|a0", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zr|Zt|Zv|Zy|a1", "An interactive widget where students fill in an orbital diagram by adding boxes, rows, and up/down arrows (block-level; does not inherit from Input)", "o|F|8b|54|AZ|9X|Zp|a2|3M|2p|2p|8b|a3|AT", "code", "Identifier used to reference this feedback definition.", "o|2h|a5|a6|1T", "Default feedback text for this code.", "o|2h|1T|a8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|a7|a9", "A reusable feedback definition referenced by other components", "o|F|Kt|54|AZ|Ao|aA|Aa|3M|2p|2p|Kt|aB|Az", "Index identifying which style this definition applies to.", "o|33|34|aD|36|1q", "lineColor", "Color used for line strokes (light mode).", "o|2h|aF|aG|1T", "lineColorWord", "Human-readable name of the line color (light mode).", "o|2h|aI|aJ|1T", "lineColorDarkMode", "Color used for line strokes (dark mode).", "o|2h|aL|aM|1T", "lineColorWordDarkMode", "Human-readable name of the line color (dark mode).", "o|2h|aO|aP|1T", "lineOpacity", "Opacity of line strokes, 0 to 1.", "o|2h|aR|aS|1p", "lineWidthWord", "Human-readable name of the line width.", "o|2h|aU|aV|1T", "lineStyleWord", "Human-readable name of the line style.", "o|2h|aX|aY|1T", "markerColor", "Color used for markers/points (light mode).", "o|2h|aa|ab|1T", "markerColorWord", "Human-readable name of the marker color (light mode).", "o|2h|ad|ae|1T", "markerColorDarkMode", "Color used for markers/points (dark mode).", "o|2h|ag|ah|1T", "markerColorWordDarkMode", "Human-readable name of the marker color (dark mode).", "o|2h|aj|ak|1T", "markerOpacity", "Opacity of markers/points, 0 to 1.", "o|2h|am|an|1p", "cross", "plus", "a|8u|RV|8r|RW|RX|RY|RZ|Ra|ap|aq", "Cross-shaped marker (×).", "o|3s|ap|as", "Plus-shaped marker (+).", "o|3s|aq|au", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr|at|av", "o|HC|RT|RU|ar|aw|3y", "markerStyleWord", "Human-readable name of the marker style.", "o|2h|ay|az|1T", "markerFilled", "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior.", "o|Ap|b1|b2|2s|1V", "fillColor", "Fill color used inside closed shapes (light mode).", "o|2h|b4|b5|1T", "fillColorWord", "Human-readable name of the fill color (light mode).", "o|2h|b7|b8|1T", "fillColorDarkMode", "Fill color used inside closed shapes (dark mode).", "o|2h|bA|bB|1T", "fillColorWordDarkMode", "Human-readable name of the fill color (dark mode).", "o|2h|bD|bE|1T", "fillStyleWord", "Human-readable name of the fill style.", "o|2h|bG|bH|1T", "Text color (light mode).", "o|2h|6L|bJ|1T", "textColorWord", "Human-readable name of the text color (light mode).", "o|2h|bL|bM|1T", "textColorDarkMode", "Text color (dark mode).", "o|2h|bO|bP|1T", "textColorWordDarkMode", "Human-readable name of the text color (dark mode).", "o|2h|bR|bS|1T", "highContrastColor", "High-contrast accent color (light mode).", "o|2h|bU|bV|1T", "highContrastColorWord", "Human-readable name of the high-contrast accent color (light mode).", "o|2h|bX|bY|1T", "highContrastColorDarkMode", "High-contrast accent color (dark mode).", "o|2h|ba|bb|1T", "highContrastColorWordDarkMode", "Human-readable name of the high-contrast accent color (dark mode).", "o|2h|bd|be|1T", "Background color (light mode).", "o|2h|6O|bg|1T", "backgroundColorWord", "Human-readable name of the background color (light mode).", "o|2h|bi|bj|1T", "backgroundColorDarkMode", "Background color (dark mode).", "o|2h|bl|bm|1T", "backgroundColorWordDarkMode", "Human-readable name of the background color (dark mode).", "o|2h|bo|bp|1T", "a|2j|2t|2w|2z|32|aE|3A|3E|3H|aH|aK|aN|aQ|aT|HT|aW|HQ|aZ|ac|af|ai|al|ao|ax|b0|Rw|b3|b6|b9|bC|bF|Ux|V0|VP|bI|bK|bN|bQ|bT|bW|bZ|bc|bf|bh|bk|bn|bq", "a|3N|3P|3T|3U|3V|3W|3Z", "A reusable style definition referenced by other components", "o|F|Ks|54|AZ|Ao|br|bs|3M|2p|2p|Ks|bt|Az", "a|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|1b|8y|92|96|97|98|1w|1x|1y|1z|22|23|9C|9D|9E|9F|2D|2I|9I|2L|2M|9J|2P|9N|9Q|9S|9T", "1111111111111111111111111111111111111211111222222111122122121111", "width", "Total rendered width of the side-by-side container.", "componentSize", "o|2h|bx|by|bz", "widths", "List of widths for each panel.", "_componentSizeList", "o|2h|c1|c2|c3", "margins", "List of margin widths between panels.", "o|2h|c5|c6|c3", "valign", "Default vertical alignment for all panels.", "middle", "a|9|cA|5g", "Align panels to the top.", "o|3s|9|cC", "Vertically center panels.", "o|3s|cA|cE", "Align panels to the bottom.", "o|3s|5g|cG", "a|cD|cF|cH", "o|HC|c8|c9|cB|cI|3y", "isList", "a|3|2f|2l|3n|cK|2g", "valigns", "Per-panel vertical alignment values.", "Align the panel to the top.", "o|3s|9|cO", "Vertically center the panel.", "o|3s|cA|cQ", "Align the panel to the bottom.", "o|3s|5g|cS", "a|cP|cR|cT", "o|cL|cM|cN|cB|cU|3M|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|c0|c4|c7|cJ|cV", "absoluteMeasurements", "Whether children's widths are interpreted in absolute units.", "o|3Q|cX|1V|2p|cY", "gapWidth", "The gap width between panels as a percentage of the total container width.", "o|3Q|ca|1p|2p|cb", "The list of child widths.", "o|6v|c1|1p|3M|cd|36|IR", "Margins between adjacent children.", "o|6v|c5|1p|3M|cf|36|IR", "Vertical alignment of each child.", "o|6v|cM|1T|3M|ch|36|Jt", "a|3N|3O|3P|3T|3U|3V|3W|3Z|cZ|cc|ce|cg|ci", "Renders children in a side-by-side horizontal layout", "o|F|8c|bv|bw|9X|cW|cj|3M|2p|2p|8c|ck|AT", "a|8c|1z", "A group of `<sideBySide>` components that share alignment and spacing", "o|F|8d|cm|BN|9X|cW|cj|3M|2p|2p|8d|cn|AT", "A vertical container element for organizing content within a `<sideBySide>`", "o|F|8e|9U|9V|9X|3I|Aa|3M|3M|2p|8e|cp|AT", "A generic block-level container", "o|F|8f|9U|9V|9X|A6|AR|3M|3M|2p|8f|cr|AT", "A generic inline container", "o|F|1P|9U|9V|3l|A6|AR|3M|3M|2p|1P|ct|3h", "A preformatted block preserving whitespace", "o|F|8g|9U|9V|9X|3I|Aa|3M|3M|2p|8g|cv|AT", "The verbatim text content.", "o|3Q|1T|1T|2p|cx", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|cy", "Displays a DoenetML source string verbatim", "o|F|1Q|9U|9V|3l|3I|cz|3M|3M|2p|1Q|d0|3h", "initialPage", "1-based page index shown on first render.", "o|33|d2|d3|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|d4", "numPages", "The total number of pages.", "o|3Q|d6|1q|2p|d7", "currentPage", "The currently displayed page (1-based).", "o|3Q|d9|1q|2p|dA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|d8|dB", "Defines a paginated section of content", "o|F|8h|9U|9V|9X|d5|dC|3M|3M|2p|8h|dD|AT", "previousLabel", 'Label for the "previous page" button.', "Previous", "o|33|dF|dG|dH|1T", "nextLabel", 'Label for the "next page" button.', "Next", "o|33|dJ|dK|dL|1T", "pageLabel", "Label format for the current page indicator.", "Page", "o|33|dN|dO|dP|1T", "Reference to the `<paginator>` these controls operate on.", "o|2h|8h|dR|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dI|dM|dQ|dS", "o|3L|dF|1T|2p|dG|3M", "o|3L|dJ|1T|2p|dK|3M", "o|3L|dN|1T|2p|dO|3M", "disabledDirectly", "Whether the controls are disabled directly (rather than via inheritance).", "o|3Q|dX|1V|2p|dY", "a|3N|3O|3P|dU|dV|dW|3T|3U|3V|3W|3Z|dZ", "Previous/next page controls referencing a paginator elsewhere in the document", "o|F|8i|54|AZ|9X|dT|da|3M|2p|2p|8i|db|AT", "shortDescription", "a|I|J|1z|2S|2f|dd|2U", "1120000", "_input", "a|dg|2c|2d", "Position of the label relative to the input.", "a|5h|5i", "Place the label to the left of the input.", "o|3s|5h|dk", "Place the label to the right of the input.", "o|3s|5i|dm", "a|dl|dn", "o|Bi|GL|di|5h|dj|do|3y", "forAnswer", "References to `<answer>` elements that this input should submit to.", "o|2h|dq|dr|3D", "Number of rows in the matrix input.", "o|33|7A|dt|36|1q", "Number of columns in the matrix input.", "o|33|7D|dv|36|1q", "showSizeControls", "Whether to render controls for resizing the matrix.", "o|2m|dx|dy|3M|2s|1V", "defaultEntry", "Default value used for empty matrix cells.", "o|33|e0|e1|5J|1X", "Initial matrix value displayed in the input.", "o|33|Zj|e3|5J|1X", "Input format for the math entered.", "o|Bi|3p|e5|1T|3r|3x|3y", "o|4U|4P|4Q|4R|Nn|1q", "o|4U|4Z|4a|4R|5Q|1p", "bindValueTo", "Two-way binding target for the input's value.", "o|2h|e9|eA|1X", "unionFromU", 'Whether "U" between sets is parsed as union.', "o|2m|eC|eD|2p|2s|1V", "minComponentWidth", "Minimum rendered width for each cell, in pixels.", "o|33|eF|eG|5Q|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|du|dw|dz|e2|e4|e6|51|58|5B|e7|4Y|e8|4g|4j|eB|eE|eH", "o|3L|GL|1T|2p|di|3M", "o|3L|dx|1V|2p|dy|3M", "o|3L|Zj|1X|2p|e3|3M", "o|3L|3p|1T|2p|e5|3M", "o|3L|eC|1V|2p|eD|3M", "A short accessibility description of this input; it is visible to screen readers but not rendered visually.", "o|3Q|dd|1T|2p|eO", "focused", "Whether the matrix input currently has keyboard focus.", "o|3Q|eQ|1V|2p|eR", "valueChanged", "Whether the value has been changed from its initial state.", "o|3Q|eT|1V|2p|eU", "immediateValueChanged", "Whether the value, including in-progress edits, has been changed from its initial state.", "o|3Q|eW|1V|2p|eX", "The number of rows of the matrix.", "o|3Q|7A|1q|2p|eZ", "The number of columns of the matrix.", "o|3Q|7D|1q|2p|eb", "The matrix value of the input.", "o|3Q|3a|1X|2p|ed", "immediateValue", "The matrix value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|eg", "The current matrix as a text string.", "o|3Q|1T|1T|2p|ei", "The matrix as a math expression.", "o|6v|2U|1X|3M|ek|4X|7I", "a|3N|3O|3P|eJ|Hd|eK|eL|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|eS|6X|6Y|6Z|6a|6b|eV|eY|ea|ec|ee|eh|ej|el|7P|7M", "An interactive matrix input where each cell accepts a math value", "o|F|1R|de|df|dh|eI|em|3M|2p|2p|1R|en|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "112000122221111111111111111111111222222222122220222212222222221222122222122221212222", "prefillNumerator", "Initial value displayed in the numerator input.", "o|33|er|es|5J|1X", "prefillDenominator", "Initial value displayed in the denominator input.", "o|33|eu|ev|5J|1X", "Minimum rendered width for the numerator and denominator, in pixels.", "o|33|eF|ex|5Q|1q", "Two-way binding target for the fraction's value.", "o|2h|e9|ez|1X", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|et|ew|e6|51|58|5B|e7|4Y|e8|4g|4j|eE|ey|f0", "o|3L|er|1X|2p|es|3M", "o|3L|eu|1X|2p|ev|3M", "Whether the fraction input currently has keyboard focus.", "o|3Q|eQ|1V|2p|f4", "The fraction value of the input (numerator divided by denominator).", "o|3Q|3a|1X|2p|f6", "The fraction value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|f8", "numerator", "The numerator of the fraction.", "o|3Q|fA|1X|2p|fB", "denominator", "The denominator of the fraction.", "o|3Q|fD|1X|2p|fE", "The current fraction as a text string.", "o|3Q|1T|1T|2p|fG", "a|3N|3O|3P|eJ|Hd|f2|f3|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|f5|6X|6Y|6Z|6a|6b|eV|f7|eY|f9|fC|fF|fH", "An interactive fraction input with a numerator and a denominator, each accepting a math value.", "o|F|1S|ep|eq|dh|f1|fI|3M|2p|2p|1S|fJ|3h", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "111111111111111111111111111111111111111111111111111111111111111112211111111121212222121212211111111111222222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "Whether the solution is initially hidden.", "o|2m|2n|fN|2p|2s|1V", "a|2j|fO|2w|2z|32|37|3A|3E|3H", "Whether the solution is currently hidden.", "o|3Q|2n|1V|2p|fQ", "Whether the solution is currently open (revealed).", "o|3Q|M7|1V|2p|fS", "a|3O|3P|3T|3U|3V|3W|3Z|fR|fT", "A solution to an exercise, shown on demand", "o|F|8j|fL|fM|9X|fP|fU|3M|3M|2p|8j|fV|AT", 'A sectional component that renders an expandable block labeled "Answer"', "o|F|8k|fL|fM|9X|fP|fU|3M|3M|2p|8k|fX|AT", "a|1z|9A|G|9H|Ks|Kt|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "100000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "xmlns", "XML namespace declaration (accepted for compatibility; not used).", "o|2h|fb|fc|1T", "Document type identifier.", "o|2h|2g|fe|1T", "a|2j|32|3E|3H|9h|9l|9o|9r|9u|9y|A2|A5|fd|ff", "Aggregate credit achieved (0 to 1) for scored content in the document.", "o|3Q|AL|1p|2p|fh", "Aggregate credit achieved as a percentage (0 to 100) for scored content in the document.", "o|3Q|AO|1p|2p|fj", "The document's title.", "o|3Q|G|1T|2p|fl", "a|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|fi|fk|fm", "The top-level container for a DoenetML document (added implicitly if not present)", "o|F|8l|fZ|fa|Ao|fg|fn|3M|3M|2p|8l|fo|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19", "2222222222222222222222222222222222222212220222222222222222222222221122222212111111111111111111", "The text value.", "o|3Q|3a|1T|2p|fs", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|ft|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", "A text string", "o|F|1T|fq|fr|3l|Jc|fu|3M|3M|2p|1T|fv|3h", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X", "2222222222222222222222222222222222222212220222222222222222222222221122222212", "_composite", "a|fz|2d", "a|3|2f|2k", "o|g1|2x|2y|2p", "a|3|2f", "o|g3|38|39", "Whether the order of items should be treated as unordered.", "o|2m|4n|g5|2p|2s|1V", "maxNumber", "Maximum number of items to retain in the list.", "o|33|g7|g8|9k|1p", "Whether to render the items separated by commas (true) or with no separator (false).", "o|2m|20|gA|3M|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|g6|g9|gB", "o|3L|4n|1V|2p|g5|3M", "o|3L|g7|1p|2p|g8|3M", "numComponents", "The number of items in the text list.", "o|3Q|gF|1p|2p|gG", "numValues", "The number of text values in the list.", "o|3Q|gI|1p|2p|gJ", "a|3N|3O|gD|gE|3Z|gH|gK", "A list of texts", "o|F|1U|fx|fy|g0|gC|gL|3M|3M|3M|1U|gM|Az", "A paragraph of inline content", "o|F|8m|Ag|Ah|9X|A6|Ak|3M|3M|2p|8m|gO|AT", "The boolean value (true or false).", "o|3Q|3a|1V|2p|gQ", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|gR|CW", "A boolean value", "o|F|1V|BY|BZ|3l|CI|gS|3M|3M|2p|1V|gT|3h", "Whether the order of items in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|gV|2p|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB", "o|3L|4n|1V|2p|gV|3M", "The number of items in the boolean list.", "o|3Q|gF|1p|2p|gZ", "The number of booleans in the list.", "o|3Q|gI|1p|2p|gb", "a|3N|3O|gY|gE|3Z|ga|gc", "A list of booleans", "o|F|1W|Cc|Cd|g0|gX|gd|3M|3M|3M|1W|ge|Az", "o|3Q|3a|1X|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A math expression", "o|F|1X|3j|3k|3l|64|gh|3M|3M|2p|1X|gi|3h", "mergeMathLists", "Whether nested math-list children should be flattened into this list.", "o|Ap|gk|gl|2s|1V", "o|g3|4P|4Q", "o|g3|4V|4W", "o|g3|4Z|4a", "o|g3|4e|4f", "o|g3|4h|4i", "Symbols treated as function names when parsing items.", "o|33|4w|gs|50|1U", "References whose names should be treated as function symbols when parsing items.", "o|33|52|gu|54|3D", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gm|gB|gn|go|gp|gq|gr|gt|gv|58|5B", "o|3L|4w|1U|2p|gs|3M", "o|3Q|4n|1V|2p|gV", "Whether nested math lists are merged into the parent list.", "o|3Q|gk|1V|2p|gz", "The number of items in the math list.", "o|3Q|gF|1p|2p|h1", "The number of math expressions in the list.", "o|3Q|gI|1p|2p|h3", "a|3N|3O|gE|gx|6D|6E|3Z|gy|h0|h2|h4", "A list of math expressions", "o|F|1Y|3j|3k|g0|gw|h5|3M|3M|3M|1Y|h6|Az", "A list of math tuples, parsed from parenthesized comma-separated pieces", "o|F|1Z|3j|3k|g0|gw|h5|3M|3M|3M|1Z|h8|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1111111111111111111111121220222101122221222221222112222222222222222222222222222", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB|gn|go|gp|gq|gr", "The number of items in the number list.", "o|3Q|gF|1p|2p|hD", "The number of numbers in the list.", "o|3Q|gI|1p|2p|hF", "a|3N|3O|gE|3Z|gy|hE|hG", "A list of numbers", "o|F|1a|hA|hB|g0|hC|hH|3M|3M|3M|1a|hI|Az", "Maximum number of descendants to collect.", "o|33|g7|hK||1p", "from", "Component subtree(s) to collect descendants from.", "o|2h|hM|hN|3D", "componentType", "Component type of descendants to collect.", "o|2h|hP|hQ|1T", "a|2j|32|3E|3H|hL|hO|hR|gB", "o|3L|g7|1p|2p|hK|3M", "a|hT|3Z", "Collects descendants of a component matching a specified component type", "o|F|1b|54|AZ|g0|hS|hU|3M|2p|3M|1b|hV|Az", "to", "The target that the reference points to (component reference or URL string).", "referenceOrText", "o|2h|hX|hY|hZ", "textType", "Type of text to use for the reference label.", "type-global", "o|33|hb|hc|hd|1T", "createButton", "Whether to render this reference as a clickable button.", "o|2m|hf|hg|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ha|he|hh", "o|3L|hb|1T|2p|hc|3M", "url", "The resolved URL of the referenced component.", "o|3Q|hk|1T|2p|hl", "linkText", "The display text used for the link.", "o|3Q|hn|1T|2p|ho", "The text used as the link label.", "o|3Q|1T|1T|2p|hq", "a|3N|3O|3P|hj|3T|3U|3V|3W|3Z|hm|hp|hr", "A link to a component reference or to a URL", "o|F|1c|9U|9V|3l|hi|hs|3M|3M|2p|1c|ht|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|ax|Rw|b3|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point with coordinates that can be displayed and dragged on a graph", "o|F|1d|RR|RS|Op|hv|hw|3M|3M|2p|1d|hx|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1e|2p|6e", "Whether tuple-like expressions render as vectors (always true for `<coords>`).", "o|3Q|4q|1V|2p|i1", "a|3N|3O|3P|66|67|68|69|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|i0|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|i2|7S|7V|7Y|7b", "A math expression treated as a vector of coordinates", "o|F|1e|3j|3k|3l|hz|i3|3M|3M|2p|1e|i4|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "A line through two points or defined by an equation", "o|F|1f|TV|TW|Op|i6|i7|3M|3M|2p|1f|i8|Az", "Whether the line segment can be dragged on a graph.", "o|2m|5L|iA|3M|2s|1V", "endpointsDraggable", "Whether the line segment's endpoints can be dragged.", "o|Ap|iC|iD|2s|1V", "endpoints", "The two endpoints of the line segment.", "o|2h|iF|iG|2W", "a|iF|42|2q|2r", "Show control handles for both endpoints of the segment.", "o|3s|iF|iJ", "a|iK|Sa", "o|Bi|ST|SU|iF|iI|iL|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|iB|iE|iH|iM|P4|UB|H8|4Y|4c|4g|4j|So", "o|3L|5L|1V|2p|iA|3M", "A textual description of the line segment's style.", "o|3Q|Hl|1T|2p|iP", 'Style description including "line segment".', "o|3Q|Ho|1T|2p|iR", "Whether each endpoint can be dragged independently.", "o|3Q|iC|1V|2p|iT", "Number of dimensions the segment lives in.", "o|3Q|6r|1p|2p|iV", "The endpoints of the line segment.", "o|Qc|iF|1X|3M|iX|4X|IM|Qf", "The length of the line segment.", "o|3Q|Qh|1X|2p|iZ", "The slope of the line segment (2D only).", "o|3Q|Te|1p|2p|ib", "a|3N|3O|3P|Hd|QD|7s|QE|iO|Sy|QG|UG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|iQ|iS|iU|iW|iY|ia|ic", "A line segment between two endpoints", "o|F|8n|Om|On|Op|iN|id|3M|2p|2p|8n|ie|Az", "Whether the ray can be dragged on a graph.", "o|2m|5L|ig|3M|2s|1V", "The starting point (endpoint) of the ray.", "o|2h|2K|ii|1d", "A point the ray passes through (used with endpoint or direction).", "o|2h|Gr|ik|1d", "direction", "The direction the ray points in.", "o|2h|im|in|1h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|ih|ij|il|io|UB|H8|4Y|4c|4g|4j", "o|3L|5L|1V|2p|ig|3M", "A textual description of the ray's style.", "o|3Q|Hl|1T|2p|ir", 'Style description including the word "ray".', "o|3Q|Ho|1T|2p|it", "Number of dimensions the ray lives in.", "o|3Q|6r|1p|2p|iv", "The direction vector of the ray.", "o|6v|im|1X|3M|ix|36|6z", "A point the ray passes through.", "a|Qe", "o|Qc|Gr|1X|3M|iz|36|IY|j0", "The starting endpoint of the ray.", "o|Qc|2K|1X|3M|j2|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|iq|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|is|iu|iw|iy|j1|j3", "A ray starting at one point passing through another", "o|F|8o|Om|On|Op|ip|j4|3M|2p|2p|8o|j5|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j", "The number of vertices in the polyline.", "o|3Q|RD|1p|2p|j8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|j9|Qa|Qg|Qj|Ql", "A polyline (open polygon) defined by a list of vertices", "o|F|8p|Om|On|Op|j7|jA|3M|2p|2p|8p|jB|Az", "Whether to render interactive vertex control handles.", "a|5b|42|2q|2r", "Show a control handle for moving the polygon's center.", "o|3s|5b|jF", "a|jG|Sa", "o|Bi|ST|jD|5b|jE|jH|3y", "filled", "Whether to fill the interior of the polygon.", "o|2m|jJ|jK|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|jI|jL|So", "o|3L|ST|1T|2p|jD|3M", "o|3L|jJ|1V|2p|jK|3M", "A textual description of the polygon's style.", "o|3Q|Hl|1T|2p|jP", 'Style description including the word "polygon".', "o|3Q|Ho|1T|2p|jR", "borderStyleDescription", "A textual description of the polygon's border style.", "o|3Q|jT|1T|2p|jU", "fillStyleDescription", "A textual description of the polygon's fill style.", "o|3Q|jW|1T|2p|jX", "perimeter", "The perimeter of the polygon.", "o|3Q|jZ|1p|2p|ja", "area", "The area enclosed by the polygon.", "o|3Q|jc|1p|2p|jd", "numSides", "The number of sides of the polygon.", "o|3Q|jf|1p|2p|jg", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|j9|Qa|Qg|Ql|jV|jY|jb|je|jh", "A polygon defined by a list of vertices", "o|F|8q|Om|On|Op|jM|ji|3M|2p|2p|8q|jj|Az", "The number of vertices (always 3 for a triangle).", "o|3Q|RD|1p|2p|jl", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|jm|Qa|Qg|Ql|jV|jY|jb|je|jh", "A triangle defined by three vertices", "o|F|8r|Om|On|Op|jM|jn|3M|2p|2p|8r|jo|Az", "centerWidthAndHeight", "widthAndHeight", "a|5b|jr|jq|42|2q|2r", "Show a single control handle for moving the rectangle's center.", "o|3s|5b|jt", "Show control handles for resizing width and height.", "o|3s|jr|jv", "Show control handles for both moving the center and resizing.", "o|3s|jq|jx", "a|ju|jw|jy|Sa", "o|Bi|ST|SU|jq|js|jz|3y", "The rectangle's center point.", "o|2h|5b|k1|1d", "The rectangle's width.", "o|2h|bx|k3|1p", "height", "The rectangle's height.", "o|2h|k5|k6|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|k0|jL|So|k2|k4|k7", "The number of vertices (always 4 for a rectangle).", "o|3Q|RD|1p|2p|k9", "The four corner vertices of the rectangle.", "o|Qc|Oz|1X|3M|kB|4X|IM|Qf", "The rectangle's center coordinates.", "o|6v|5b|1X|3M|kD|36|IY", "o|3Q|bx|1p|2p|k3", "o|3Q|k5|1p|2p|k6", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|kA|Qa|kC|kE|jV|jY|jb|je|kF|kG|jh", "A rectangle, potentially defined by width, height, center and/or corner vertices", "o|F|8s|Om|On|Op|k8|kH|3M|2p|2p|8s|kI|Az", "centerAndRadius", "radius", "a|5b|kL|kK|42|2q|2r", "Show a control handle for resizing the polygon's radius.", "o|3s|kL|kN", "Show control handles for both moving the center and resizing the radius.", "o|3s|kK|kP", "a|jG|kO|kQ|Sa", "o|Bi|ST|SU|kK|kM|kR|3y", "Number of vertices in the regular polygon.", "o|33|RD|kT|4S|1q", "Number of sides in the regular polygon (alias for numVertices).", "o|2h|jf|kV|1q", "Center of the regular polygon.", "o|2h|5b|kX|1d", "circumradius", "Distance from center to a vertex (circumscribed-circle radius).", "o|2h|kZ|ka|1p", "Alias for circumradius.", "o|2h|kL|kc|1p", "inradius", "Distance from center to the midpoint of a side (inscribed-circle radius).", "o|2h|ke|kf|1p", "apothem", "Alias for inradius.", "o|2h|kh|ki|1p", "sideLength", "Length of each side of the regular polygon.", "o|2h|kk|kl|1p", "Total perimeter of the regular polygon.", "o|2h|jZ|kn|1p", "Total area enclosed by the regular polygon.", "o|2h|jc|kp|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|kS|jL|So|kU|kW|kY|kb|kd|kg|kj|km|ko|kq", "Whether to preserve similarity when dragging.", "o|3Q|P8|1V|2p|ks", "The number of vertices (sides) of the regular polygon.", "o|3Q|RD|1q|2p|ku", "The center coordinates of the regular polygon.", "o|6v|5b|1X|3M|kw|36|IY", "The radius of the circumscribed circle.", "o|3Q|kZ|1p|2p|ky", "The radius of the inscribed circle.", "o|3Q|ke|1p|2p|l0", "The length of each side.", "o|3Q|kk|1p|2p|l2", "The number of sides of the regular polygon.", "o|3Q|jf|1q|2p|l4", "Distance from center to a vertex (alias for circumradius).", "o|3Q|kL|1p|2p|l6", "Distance from center to the midpoint of a side (alias for inradius).", "o|3Q|kh|1p|2p|l8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|kt|QW|QY|kv|Qa|Qg|kx|jV|jY|jb|je|kz|l1|l3|l5|l7|l9", "A regular polygon with a given number of sides", "o|F|8t|Om|On|Op|kr|lA|3M|2p|2p|8t|lB|Az", "Points the circle passes through.", "o|2h|Gr|lD|2W", "The circle's center point.", "o|2h|5b|lF|1d", "The circle's radius.", "o|2h|kL|lH|1X", "Whether to render interactive control handles on the circle.", "Show a control handle for moving the circle's center.", "o|3s|5b|lK", "Show a control handle for resizing the circle's radius.", "o|3s|kL|lM", "a|lL|lN|kQ|Sa", "o|Bi|ST|lJ|kK|kM|lO|3y", "Whether to fill the interior of the circle.", "o|2m|jJ|lQ|2p|2s|1V", "Whether to suppress the indicator drawn at the edge when the component is off-screen.", "o|Ap|Sj|lS|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|lE|WQ|WS|H8|4Y|4c|4g|4j|lG|lI|lP|lR|lT|So", "o|3L|ST|1T|2p|lJ|3M", "o|3L|jJ|1V|2p|lQ|3M", "A textual description of the circle's style.", "o|3Q|Hl|1T|2p|lX", 'Style description including the word "circle".', "o|3Q|Ho|1T|2p|lZ", "A textual description of the circle's border style.", "o|3Q|jT|1T|2p|lb", "A textual description of the circle's fill style.", "o|3Q|jW|1T|2p|ld", "Whether to suppress the off-graph indicator when the circle is outside the visible area.", "o|3Q|Sj|1V|2p|lf", "Maximum value of the curve parameter (always 2π for a circle).", "o|3Q|WM|1p|2p|lh", "Minimum value of the curve parameter (always 0 for a circle).", "o|3Q|WJ|1p|2p|lj", "Points the circle is constrained to pass through.", "o|Qc|Wo|1X|3M|ll|4X|IM|Qf", "The radius of the circle.", "o|3Q|kL|1X|2p|ln", "diameter", "The diameter of the circle.", "o|3Q|lp|1X|2p|lq", "circumference", "The circumference of the circle.", "o|3Q|ls|1X|2p|lt", "The area enclosed by the circle.", "o|3Q|jc|1X|2p|lv", "The center coordinates of the circle.", "o|Qc|5b|1X|3M|lx|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|lV|lW|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|lY|la|lc|le|lg|li|lk|lm|lo|lr|lu|lw|ly", "A circle, potentially defined by center, radius, and/or points on the circle", "o|F|8u|TV|TW|Op|lU|lz|3M|3M|2p|8u|m0|Az", "Points the parabola passes through.", "o|2h|Gr|m2|2W", "The vertex of the parabola.", "o|33|PI|m4||1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|m3|WQ|WS|H8|4Y|4c|4g|4j|m5", 'Style description including the word "parabola".', "o|3Q|Ho|1T|2p|m7", "Maximum value of the parabola's parameter.", "o|3Q|WM|1p|2p|m9", "Minimum value of the parabola's parameter.", "o|3Q|WJ|1p|2p|mB", "o|6v|Wo|1X|3M|m2|4X|IM", "a", "The leading coefficient of the parabola (in y = a x^2 + b x + c).", "o|3Q|mE|1p|2p|mF", "b", "The linear coefficient in y = a x^2 + b x + c.", "o|3Q|mH|1p|2p|mI", "The constant term in y = a x^2 + b x + c.", "o|3Q|15|1p|2p|mK", "The vertex coordinates of the parabola.", "o|6v|PI|1X|3M|mM|36|IY", "The parabola's equation as a math expression.", "o|3Q|TZ|1X|2p|mO", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|m8|mA|mC|mD|mG|mJ|mL|mN|mP", "A parabola defined by formula or geometric parameters", "o|F|8v|TV|TW|Op|m6|mQ|3M|3M|2p|8v|mR|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "A curve defined by a function, parametric formulas, or control points", "o|F|8w|Ut|Uu|Op|mT|mU|3M|3M|2p|8w|mV|Az", "a|Wx|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02122221111111111111111111111222222222122220222212222201221222122222122221212222", "alwaysVisible", "Whether Bezier control handles are always shown (rather than only when the curve is selected).", "o|2m|mZ|ma|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|mb", "o|3L|mZ|1V|2p|ma|3M", "a|3N|3O|3P|md|3T|3U|3V|3W|3Z", "Defines Bezier control vectors at points along a curve", "o|F|1g|mX|mY|3l|mc|me|3M|3M|2p|1g|mf|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1O|1X|1Y|1Z|1e|1h|1t|1u|1z|21|24|29|2A|2O|2U|2X|2Y|L|M|N|Q|w|x|y|z|1J|1K|1L|1M|1N|1R|1S|1T|1U|1a|1d|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2K|2Q|2V|2W", "1111111111111111111111110221012221211122222222222222222222222222222222222222222", "Whether the order of vectors in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|mj|2p|2s|1V", "Maximum number of vectors to retain in the list.", "o|33|g7|ml|9k|1p", "Direction in which the control vectors apply at the vertex.", "symmetric", "previous", "next", "a|mo|mp|mq|SV|42", "Mirror the control vector on both sides of the vertex.", "o|3s|mo|ms", "Apply the control vector toward the previous segment only.", "o|3s|mp|mu", "Apply the control vector toward the next segment only.", "o|3s|mq|mw", "Apply independent control vectors to both adjacent segments.", "o|3s|SV|my", "No control vector at this vertex.", "o|3s|42|n0", "a|mt|mv|mx|mz|n1", "o|Bi|im|mn|mo|mr|n2|3y", "pointNumber", "1-based index of the vertex these control vectors attach to.", "o|33|n4|n5||1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr|n3|n6", "o|3L|g7|1p|2p|ml|3M", "o|3L|im|1T|2p|mn|3M", "o|3L|n4|1p|2p|n5|3M", "numVectors", "The number of vectors in the list.", "o|3Q|nB|1p|2p|nC", "o|3Q|gI|1p|2p|nC", "a|3N|3O|n8|n9|nA|3Z|gy|nD|nE", "Bezier control vectors at points defining a curve (used inside `<bezierControls>`)", "o|F|Wx|mh|mi|g0|n7|nF|2p|3M|2p|Wx|nG|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "1120111111111111111111111111102201012212111122222220122222222222222222222222222222", "Whether the vector can be dragged on a graph.", "o|2m|5L|nK|3M|2s|1V", "headDraggable", "Whether the vector's head can be dragged.", "o|Ap|nM|nN|2s|1V", "tailDraggable", "Whether the vector's tail can be dragged.", "o|Ap|nP|nQ|2s|1V", "The first component (x) of the vector's displacement.", "o|2h|7Q|nS|1X", "The second component (y) of the vector's displacement.", "o|2h|7T|nU|1X", "The third component (z) of the vector's displacement.", "o|2h|7W|nW|1X", "The vector's displacement components as a list.", "o|2h|S5|nY|1Y", "displacement", "The vector's displacement (head minus tail).", "o|2h|na|nb|1e", "head", "The head (tip) point of the vector.", "o|2h|nd|ne|1d", "tail", "The tail (base) point of the vector.", "o|2h|ng|nh|1d", "headAndTail", "headOnly", "tailOnly", "a|na|nj|nk|nl|42|2q|2r", "Show a control handle for translating the whole vector.", "o|3s|na|nn", "Show control handles for both the head and the tail.", "o|3s|nj|np", "Show a control handle only at the head.", "o|3s|nk|nr", "Show a control handle only at the tail.", "o|3s|nl|nt", "a|no|nq|ns|nu|Sa", "o|Bi|ST|SU|na|nm|nv|3y", "displayWithAngleBrackets", "Whether to display the vector with angle brackets (e.g. ⟨1,2⟩).", "o|2m|nx|ny|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|nL|nO|nR|nT|nV|nX|nZ|nc|nf|ni|nw|UB|H8|4Y|4c|4g|4j|nz|P4|So", "o|3L|5L|1V|2p|nK|3M", "o|3L|nx|1V|2p|ny|3M", "A textual description of the vector's style.", "o|3Q|Hl|1T|2p|o3", 'Style description including the word "vector".', "o|3Q|Ho|1T|2p|o5", "Whether the vector's tail can be dragged independently.", "o|3Q|nP|1V|2p|o7", "Whether the vector's head can be dragged independently.", "o|3Q|nM|1V|2p|o9", "Number of dimensions of the vector.", "o|3Q|6r|1p|2p|oB", "The displacement (head − tail) of the vector.", "o|Qc|na|1X|3M|oD|36|6z|j0", "Coordinates of the vector's head.", "o|Qc|nd|1X|3M|oF|36|IY|j0", "Coordinates of the vector's tail.", "o|Qc|ng|1X|3M|oH|36|IY|j0", "magnitude", "The magnitude (length) of the vector.", "o|3Q|oJ|1X|2p|oK", "The vector rendered as a LaTeX string.", "o|3Q|2V|2V|2p|oM", "o|3Q|7Q|1X|2p|nS", "o|3Q|7T|1X|2p|nU", "o|3Q|7W|1X|2p|nW", "a|3N|3O|3P|Hd|QD|7s|QE|o1|Sy|UG|o2|QG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|o4|o6|o8|oA|oC|oE|oG|oI|oL|oN|oO|oP|oQ", "A geometric vector with tail and head", "o|F|1h|nI|nJ|Op|o0|oR|3M|3M|2p|1h|oS|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1120111111111111111111111112122022210112221222221222112222222222222222222222222222", "Radius of the rendered angle arc.", "1", "o|5H|1X|oX", "o|33|kL|oW|oY|1X", "chooseReflexAngle", "How to handle reflex angles.", "never", "allowed", "always", "a|oc|od|oe", "Always normalize to the non-reflex angle (less than 180°).", "o|3s|oc|og", "Use a reflex angle (greater than 180°) if it matches the input.", "o|3s|od|oi", "Always render the angle as a reflex angle.", "o|3s|oe|ok", "a|oh|oj|ol", "o|Bi|oa|ob|oc|of|om|3y", "inDegrees", "Whether to interpret and display the angle in degrees rather than radians.", "o|2m|oo|op|2p|2s|1V", "radians", "The angle measure in radians.", "o|2h|or|os|1X", "degrees", "The angle measure in degrees.", "o|2h|ou|ov|1X", "Three points (vertex in the middle) defining the angle.", "o|2h|Gr|ox|2W", "betweenLines", "Two lines whose intersection forms the angle.", "_lineListComponent", "o|2h|oz|p0|p1", "emphasizeRightAngle", "Whether to render right angles with the conventional square symbol.", "o|2m|p3|p4|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|oZ|on|oq|ot|ow|oy|p2|H8|4Y|4c|4g|4j|p5", "o|3L|kL|1X|2p|oW|3M", "o|3L|oa|1T|2p|ob|3M", "o|3L|oo|1V|2p|op|3M", "o|3L|p3|1V|2p|p4|3M", "o|3Q|or|1X|2p|os", "o|3Q|ou|1X|2p|ov", "o|3Q|3a|1X|2p|os", "o|3Q|1i|1X|2p|os", "a|3N|3O|3P|Hd|QD|7s|QE|p7|p8|p9|pA|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|pB|pC|pD|pE", "An angle defined by three points or a measure", "o|F|1i|oU|oV|Op|p6|pF|3M|3M|2p|1i|pG|Az", "considerAsResponses", "a|8x|1z|1R|1S|1k|1l|1m|1n|pI|I|J|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2T", "021111110110001222211111111111111111111112221222221000010212220012212221222221112212112221111111110011", "Relative weight of this answer when aggregating credit across multiple answers.", "answer-grading", "o|4U|9c|pL|pM|36|1p", "handGraded", "Whether this answer is graded by hand rather than automatically.", "o|4d|pO|pP|pM|2p|2s|1V", "matchPartial", "Whether to award partial credit when the response is partially correct.", "o|4d|pR|pS|pM|2p|2s|1V", "Maximum number of times the response can be submitted.", "o|4U|9i|pU|pM|9k|1q", "Whether to display whether the submitted response is correct.", "o|4d|9m|pW|pM|3M|2s|1V", "Whether to color-code the response based on its correctness.", "o|4d|9p|pY|pM|3M|2s|1V", "disableAfterCorrect", "Whether to disable the answer after a fully correct response has been submitted.", "o|4d|pa|pb|pM|2p|2s|1V", "Label for the submit button when correctness is shown.", "o|4U|9v|pd|pM|9x|1T", "Label for the submit button when correctness is not shown.", "o|4U|9z|pf|pM|A1|1T", "displayDigitsForResponses", "Number of significant digits to display when rendering numeric responses.", "o|4U|ph|pi|pM|Nn|1q", "o|4U|A3|A4|pM|4S|1q", "a|3|2f|3m|2k|2l|2g", "Whether to render the answer's input inline rather than as a block.", "o|pl|3h|pm|3M|2p|2s|1V", "Whether comparison uses symbolic equality (rather than numeric evaluation).", "o|pl|Bc|po|3M|2p|2s|1V", "forceFullCheckWorkButton", "Whether to always render a full-size check-work button.", "o|2m|pq|pr|2p|2s|1V", "forceSmallCheckWorkButton", "Whether to always render a small check-work button.", "o|2m|pt|pu|2p|2s|1V", "Level of simplification applied to math expressions before comparing them.", "o|Bi|Bj|pw|42|47|Bp|3y", "Whether to expand math expressions before comparing them.", "o|2m|Bf|py|2p|2s|1V", "Whether order is ignored when comparing list-like responses.", "o|2m|Br|q0|2p|2s|1V", "Whether to match list responses by exact position rather than by content.", "o|2m|Bu|q2|2p|2s|1V", "numAwardsCredited", "Maximum number of matching awards whose credits are summed.", "o|33|q4|q5|36|1q", "colorInputsSeparately", "Attempt to color each input separately based on the awards that reference it, rather than all inputs sharing the same overall credit color.", "o|2m|q7|q8|2p|2s|1V", "Maximum allowed numeric error when comparing numbers (relative or absolute).", "o|33|Bx|qA|5Q|1p", "Type of input the answer expects.", "videoWatched", "a|1X|1T|1V|qD", "Expect a math expression answer.", "o|3s|1X|qF", "Expect a text answer.", "o|3s|1T|qH", "Expect a boolean answer.", "o|3s|1V|qJ", "Mark correct when the associated video has been watched.", "o|3s|qD|qL", "a|qG|qI|qK|qM", "o|Bi|2g|qC||qE|qN|3y", "selectMultiple", "For choice answers: whether multiple choices may be selected.", "o|2m|qP|qQ|2p|2s|1V", "shuffleOrder", "For choice answers: whether to display choices in randomized order.", "o|2m|qS|qT|2p|2s|1V", "preserveLastChoice", "For choice answers: whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|qW|2p|2s|1V", "disableWrongChoices", "Whether incorrect choices are disabled after being submitted.", "o|2m|qY|qZ|2p|2s|1V", "creditByAttempt", 'Per-attempt credit multipliers (e.g. "1 0.7 0.5" for full/70%/50% on attempts 1/2/3+).', "o|33|qb|qc|54|1a", "Whether multi-character symbols should be split into a product of single-character variables when parsing.", "o|2m|56|qe|3M|2s|1V", "expanded", "Whether the answer's submitted-response panel is expanded by default.", "o|2m|qg|qh|2p|2s|1V", "showPreview", "Whether to display a preview of the response as the student types.", "o|2m|qj|qk|2p|2s|1V", "Reference to a video; when watched, this answer's videoWatched type marks credit.", "o|2h|9D|qm|3D", "videoCreditLabel", "Label shown next to the credit indicator for a video-watched answer.", "o|2h|qo|qp|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|pn|pp|ps|pv|px|pz|q1|q3|q6|q9|qB|C2|C5|C8|CB|CE|CH|qO|qR|qU|qX|qa|qd|qf|5B|qi|ql|qn|qq|GH", "o|6J|9c|1p|2p|pL|3M|pM", "o|6J|pO|1V|2p|pP|3M|pM", "o|6J|pR|1V|2p|pS|3M|pM", "o|6J|9i|1q|2p|pU|3M|pM", "o|6J|pa|1V|2p|pb|3M|pM", "o|6J|9v|1T|2p|pd|3M|pM", "o|6J|9z|1T|2p|pf|3M|pM", "o|6J|ph|1q|2p|pi|3M|pM", "o|6J|A3|1q|2p|A4|3M|pM", "o|65|3h|1V|2p|pm|3M|3M", "o|65|Bc|1V|2p|po|3M|3M", "o|3L|pq|1V|2p|pr|3M", "o|3L|pt|1V|2p|pu|3M", "o|3L|Bj|1T|2p|pw|3M", "o|3L|Bf|1V|2p|py|3M", "o|3L|Br|1V|2p|q0|3M", "o|3L|Bu|1V|2p|q2|3M", "o|3L|q4|1q|2p|q5|3M", "o|3L|q7|1V|2p|q8|3M", "o|3L|Bx|1p|2p|qA|3M", "o|3L|qP|1V|2p|qQ|3M", "o|3L|qS|1V|2p|qT|3M", "o|3L|qV|1V|2p|qW|3M", "o|3L|qY|1V|2p|qZ|3M", "o|3L|qb|1a|2p|qc|3M", "o|3L|56|1V|2p|qe|3M", "o|3L|qg|1V|2p|qh|3M", "o|3L|qj|1V|2p|qk|3M", "The fraction of credit achieved on the most recent submission (between 0 and 1).", "o|3Q|AL|1p|2p|rK", "responseHasBeenSubmitted", "Whether a response has ever been submitted for this answer.", "o|3Q|rM|1V|2p|rN", "justSubmitted", "Whether the most recent submission for this answer has not yet been changed.", "o|3Q|rP|1V|2p|rQ", "Total number of times a response has been submitted.", "o|3Q|AD|1q|2p|rS", "Remaining number of submission attempts before the maximum is reached.", "o|3Q|AG|1q|2p|rU", "Whether this answer is disabled and is no longer accepting submissions.", "o|3Q|2u|1V|2p|rW", "Whether any input within this answer currently has keyboard focus.", "o|3Q|eQ|1V|2p|rY", "numResponses", "The number of current (unsubmitted) response values from this answer's inputs.", "o|3Q|ra|1p|2p|rb", "a|3|3J|2f|6r|6u", "currentResponses", "The current (unsubmitted) response values from this answer's inputs.", "a|3J|6r", "o|rg|3M|36", "a|rh", "o|rd|re|3M|rf|36|ri", "numSubmittedResponses", "The number of response values from the most recent submission.", "o|3Q|rk|1p|2p|rl", "submittedResponses", "The response values from the most recent submission.", "o|rd|rn|3M|ro|36|ri", "numFeedbacks", "The number of feedback messages produced by matched awards or applicable feedback definitions.", "o|3Q|rq|1p|2p|rr", "feedbacks", "The feedback messages produced by matched awards or applicable feedback definitions.", "o|73|3M|9F|36", "a|rv", "o|6v|rt|9F|3M|ru|36|rw", "a|3|3J|2f", "currentResponse", "The current (unsubmitted) response value from the answer's first input.", "o|ry|rz|2p|s0", "submittedResponse", "The first response value from the most recent submission.", "o|ry|s2|2p|s3", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|r1|r2|r3|r4|r5|r6|r7|r8|r9|rA|rB|CP|CQ|CR|CS|CT|CU|rC|rD|rE|rF|rG|rH|6E|rI|rJ|Hd|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|Hk|rZ|rc|rj|rm|rp|rs|rx|s1|s4", "answer1", "Assigns credit to student responses based on matches or logical rules", "o|F|1j|pJ|pK|3l|qr|s5|3M|2p|2p|s6|s7|3h", "when", "a|s9|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "02122221111111111111111111111222122222122020222212222201221222122222111221211222221111111110212120", "credit", "Fraction of credit (0 to 1) granted when this award matches.", "o|33|sC|sD|36|1p", "o|2m|pR|pS|2p|2s|1V", "o|2m|Bc|po|2p|2s|1V", "feedbackCodes", "Codes that select reusable feedback messages when this award matches.", "o|33|sH|sI|54|1U", "feedbackText", "Custom feedback text shown when this award matches.", "o|33|sK|sL||1T", "referencesAreResponses", "References to components whose values should be treated as responses for this award.", "o|2h|sN|sO|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|sE|sF|sG|pz|px|q1|q3|qB|C2|C5|C8|CB|CE|CH|sJ|sM|sP|qf|5B", "o|3L|sC|1p|2p|sD|3M", "o|3L|pR|1V|2p|pS|3M", "o|3L|Bc|1V|2p|po|3M", "o|3L|sH|1U|2p|sI|3M", "o|3L|sK|1T|2p|sL|3M", "creditAchievedIfSubmit", "Credit (0 to 1) this award would grant if submitted with the current response.", "o|3Q|sW|1p|2p|sX", "fractionSatisfiedIfSubmit", "Fraction (0 to 1) by which this award's match condition is currently satisfied.", "o|3Q|sZ|1p|2p|sa", "fractionSatisfied", "Fraction (0 to 1) by which this award's match condition was satisfied at last submission.", "o|3Q|sc|1p|2p|sd", "Credit (0 to 1) this award granted at the last submission.", "o|3Q|AL|1p|2p|sf", "awarded", "Whether this award was matched at the last submission.", "o|3Q|sh|1V|2p|si", "The number of feedback messages associated with this award.", "o|3Q|rq|1p|2p|sk", "The feedback messages produced by this award.", "o|6v|rt|9F|3M|sm|36|rw", "The first feedback message produced by this award.", "o|3Q|9F|9F|2p|so", "a|3N|3O|3P|sR|sS|sT|r6|r5|r7|r8|rB|CP|CQ|CR|CS|CT|CU|sU|sV|rH|6E|3T|3U|3V|3W|3Z|sY|sb|se|sg|sj|sl|sn|sp", "Specifies conditions for awarding credit in an answer", "o|F|8x|sA|sB|Ao|sQ|sq|3M|3M|2p|8x|sr|Az", "Whether to match partial conditions for partial credit.", "o|2m|pR|st|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|su", "o|3L|pR|1V|2p|st|3M", "Whether the condition is currently true.", "o|3Q|3a|1V|2p|sx", "Fraction of the boolean condition that is satisfied (0 to 1).", "o|3Q|sc|1p|2p|sz", "Whether the condition is currently satisfied; equivalent to value.", "o|3Q|Au|1V|2p|t1", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|sw|3T|3U|3V|3W|3Z|sy|t0|t2|CW", "Defines logical conditions within an `<award>`", "o|F|s9|BY|BZ|3l|sv|t3|2p|3M|2p|s9|t4|3h", "Initial value displayed in the input.", "o|33|Zj|t6|5J|1X", "prefillLatex", "Initial value as a LaTeX string.", "o|33|t8|t9|AZ|2V", "o|Bi|3p|3q|1T|3r|3x|3y", "additionalFunctionNames", "Extra identifiers to auto-format as function names in the editor (e.g., 'erf'). Entries that also appear in `removedFunctionNames` are dropped.", "o|33|tC|tD|54|1U", "removedFunctionNames", "Built-in function names to stop auto-formatting in the editor (e.g., 'min' so 'kg/min' can be typed as a unit).", "o|33|tF|tG|54|1U", "resetFunctionNames", "When set, replaces the entire auto-formatted function name list (defaults, `additionalFunctionNames`, and `removedFunctionNames` are all ignored). Set to an empty value to disable auto-formatting entirely.", "o|33|tI|tJ||1U", "Whether multi-character symbols are split into a product of single-character variables.", "o|2m|56|tL|3M|2s|1V", "hideNaN", "Whether to hide NaN values when displaying the input.", "o|2m|tN|tO|3M|2s|1V", "removeStrings", "Substrings to strip from the input before parsing.", "o|33|tQ|tR||1U", "minWidth", "Minimum rendered width of the input.", "n|o", "o|33|tT|tU|tV|1q", "Whether to display a preview of the parsed math.", "o|2m|qj|tX|2p|2s|1V", "Whether the input can be dragged on a graph.", "o|2m|5L|tZ|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|t7|tA|tB|51|tE|tH|tK|tM|5B|e7|4Y|e8|4g|4j|eB|eE|tP|tS|tW|tY|ta|5X|63", "o|3L|Zj|1X|2p|t6|3M", "o|3L|t8|2V|2p|t9|3M", "o|3L|3p|1T|2p|3q|3M", "o|3L|tC|1U|2p|tD|3M", "o|3L|tF|1U|2p|tG|3M", "o|3L|tI|1U|2p|tJ|3M", "o|3L|56|1V|2p|tL|3M", "o|3L|tN|1V|2p|tO|3M", "o|3L|tT|1q|2p|tU|3M", "o|3L|5L|1V|2p|tZ|3M", "Whether this input currently has keyboard focus.", "o|3Q|eQ|1V|2p|tm", "o|3Q|qj|1V|2p|tX", "The math value of the input.", "o|3Q|3a|1X|2p|tp", "The math value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|tr", "The current input as a text string.", "o|3Q|1T|1T|2p|tt", "rawRendererValue", "The raw value used by the renderer (e.g. LaTeX string).", "o|3Q|tv|2V|2p|tw", "a|3N|3O|3P|eJ|Hd|tc|td|te|6C|tf|tg|th|ti|6E|eN|tj|tk|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6X|6Y|6Z|6a|6b|6W|to|eV|tq|eY|ts|tu|tx|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "An interactive math input", "o|F|1k|ep|eq|dh|tb|ty|3M|3M|2p|1k|tz|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2T|2U|2V|2X", "112000222222222222222222222222222222222222122202222222222222222222222112222212", "Initial text shown in the input before the user types.", "o|33|Zj|u3|AZ|1T", "o|2h|e9|eA|1T", "Whether the input renders as a multi-line text area.", "o|2m|qg|u6|2p|2s|1V", "Display width of the input.", "o|2h|bx|u8|bz", "Display height of the input.", "size", "isAbsolute", "a|uB|uC", "n|1w", "o|uD|uE|3M", "o|33|k5|uA|uF|bz", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|u4|u5|u7|u9|uG|ta|5X|63", "o|3L|Zj|1T|2p|u3|3M", "o|3L|qg|1V|2p|u6|3M", "o|3L|k5|bz|2p|uA|3M", "o|3Q|bx|bz|2p|u8", "The text value of the input.", "o|3Q|3a|1T|2p|uM", "The text value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|uO", "The current text as a plain text string.", "o|3Q|1T|1T|2p|uQ", "a|3N|3O|3P|eJ|Hd|uI|uJ|uK|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|eV|eY|6W|uL|uN|uP|uR|Jp|Ju|Jx|K0|K2|K4", "An interactive text input", "o|F|1l|u1|u2|dh|uH|uS|3M|3M|2p|1l|uT|3h", "a|I|J|1z|2S|2f|dd|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|2R|2T|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11200011111111102211122221111111111111111111111222222222122220222212222201221222122222122221212222", "o|Bi|GL|di|5i|dj|do|3y", "The initial value of the input before the student interacts.", "o|2m|Zj|uY|2p|2s|1V", "asToggleButton", "Whether to render the input as a toggle button rather than a checkbox.", "o|2m|ua|ub|2p|2s|1V", "o|Ap|e9|eA|2s|1V", "Whether the input can be dragged on a graph by its anchor.", "o|2m|5L|ue|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|uX|ds|GH|uZ|uc|ud|uf|5X|63", "o|3L|Zj|1V|2p|uY|3M", "o|3L|ua|1V|2p|ub|3M", "o|3L|5L|1V|2p|ue|3M", "Whether the input's value has been changed from its prefill value.", "o|3Q|eT|1V|2p|uk", "The current boolean value of the input.", "o|3Q|3a|1V|2p|um", 'The current value rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|uo", "a|3N|3O|3P|eJ|Hd|uh|ui|uj|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6W|ul|un|up", "An interactive boolean (toggle/checkbox) input", "o|F|1m|uV|uW|dh|ug|uq|3M|3M|2p|1m|ur|3h", "a|I|J|1z|2S|2f|dd|1o", "Whether multiple choices may be selected.", "o|2m|qP|uu|2p|2s|1V", "Whether to award partial credit when only some correct choices are selected.", "o|2m|pR|uw|2p|2s|1V", "Whether to render the input inline (as a dropdown) rather than as a list of choices.", "o|2m|3h|uy|2p|2s|1V", "Whether to display the choices in randomized order.", "o|2m|qS|v0|2p|2s|1V", "Whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|v2|2p|2s|1V", "preselectChoice", "Index of a choice to pre-select on initial render.", "o|33|v4|v5||1p", "placeHolder", "Placeholder text shown when no choice is selected.", "o|33|v7|v8|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|uv|ux|uz|v1|v3|v6|u5|v9", "o|3L|qP|1V|2p|uu|3M", "o|3L|pR|1V|2p|uw|3M", "o|3L|qS|1V|2p|v0|3M", "o|3L|qV|1V|2p|v2|3M", "Whether the input is rendered inline (as a dropdown).", "o|3Q|3h|1V|2p|vF", "numChoices", "The number of choices available in the input.", "o|3Q|vH|1p|2p|vI", "choiceTexts", "The text contents of all choices in displayed order.", "o|6v|vK|1T|3M|vL|36|Jt", "choiceMaths", "The math expressions of all choices in displayed order.", "o|6v|vN|1X|3M|vO|36|75", "Whether the input's selection has been changed from its initial state.", "o|3Q|eT|1V|2p|vQ", "selectedIndices", "Indices (1-based) of the currently selected choices.", "o|6v|vS|1p|3M|vT|36|IR", "selectedValues", "Text values of the currently selected choices.", "o|rd|vV|3M|vW|36|ri", "The number of feedback messages produced by selected choices.", "o|3Q|rq|1p|2p|vY", "Feedback messages produced by selected choices.", "o|6v|rt|9F|3M|va|36|rw", "selectedIndex", "The 1-based index of the first currently selected choice.", "o|3Q|vc|1p|2p|vd", "selectedValue", "The text value of the first currently selected choice.", "o|ry|vf|2p|vg", "The text values of the currently selected choices.", "o|rd|2l|3M|vi|36|ri", "valueToRecordOnSubmit", "Indices of the currently selected choices (recorded when the answer is submitted).", "o|6v|vk|1p|3M|vl|36|IR", "a|3N|3O|3P|eJ|Hd|vB|vC|vD|vE|3T|3U|3V|3W|3Z|Hk|eP|tn|vG|vJ|vM|vP|vR|vU|vX|vZ|vb|ve|vh|vj|vm", "A multiple-choice input, allowing selection from a list of choices", "o|F|1n|ut|df|dh|vA|vn|3M|2p|2p|1n|vo|3h", "Fraction of credit (0 to 1) granted when this choice is selected.", "o|33|sC|vq|5Q|1p", "Codes that select reusable feedback messages when this choice is selected.", "o|33|sH|vs|54|1U", "Custom feedback text shown when this choice is selected.", "o|33|sK|vu||1T", "preSelect", "Whether this choice is pre-selected on initial render.", "o|2m|vw|vx|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|vr|vt|vv|vy", "o|3L|sC|1p|2p|vq|3M", "o|3L|sH|1U|2p|vs|3M", "o|3L|sK|1T|2p|vu|3M", "The choice's content as a text string.", "o|3Q|1T|1T|2p|w3", "The choice's content interpreted as a math expression.", "o|3Q|1X|1X|2p|w5", "selected", "Whether this choice is currently selected.", "o|3Q|w7|1V|2p|w8", "submitted", "Whether this choice was selected at the most recent submission.", "o|3Q|wA|1V|2p|wB", "Whether this choice is disabled (cannot be selected).", "o|3Q|2u|1V|2p|wD", "feedbacktext", "Feedback messages shown when this choice is selected.", "o|3Q|rt|wF|2p|wG", "a|3N|3O|3P|w0|w1|w2|3T|3V|3W|3Z|w4|w6|w9|wC|wE|wH", "A single choice within a `<choiceInput>` or an `<answer>`.", "o|F|1o|9U|9V|3l|vz|wI|3M|3M|2p|1o|wJ|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m", "111111111111111111111111102022210112222122222111211122222222222222222222222222222111111111021212", "renderAsMath", "Whether to render the number using math typography.", "o|2m|wN|wO|2p|2s|1V", "convertBoolean", "Whether to convert boolean inputs to 1/0 instead of NaN.", "o|2m|wQ|wR|2p|2s|1V", "valueOnNaN", "Numeric value to use when the input cannot be parsed.", "NaN", "o|33|wT|wU|wV|1p", "Whether the number can be dragged on a graph.", "o|2m|5L|wX|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j|wP|wS|wW|wY|5R|5X|63", "o|3L|wN|1V|2p|wO|3M", "o|3L|5L|1V|2p|wX|3M", "The numeric value.", "o|3Q|3a|1p|2p|wc", "The number rendered as plain text.", "o|3Q|1T|1T|2p|we", "The number's value as a math expression.", "o|3Q|1X|1X|2p|wg", "The number rendered as LaTeX.", "o|3Q|2V|2V|2p|wi", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wd|wf|wh|wj", "A numeric floating point value", "o|F|1p|wL|wM|3l|wZ|wk|3M|3M|2p|1p|wl|3h", "The integer value.", "o|3Q|3a|1q|2p|wn", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wf|wh|wj|wo", "An integer value", "o|F|1q|wL|wM|3l|wZ|wp|3M|3M|2p|1q|wq|3h", "a|I|1z|J|dd|2f|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y|9C|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|z|1L|1M|1T|1U|1V|1W|1a|1o|1p|1q|1v|25|26|27|28|2B|2C|2D|2R|2S|2T|2V|1N|1R|1S|1k|O|P|2E|2F|2G|1m|1l|8y|8z", "020001111111111111111111111122211111022211111111111111122122212222121212212111111122200111222222222122022222012222211220212220010000000", "xMin", "Minimum value displayed on the x axis.", "n|-A", "o|33|wu|wv|ww|1p", "xMax", "Maximum value displayed on the x axis.", "o|33|wy|wz|Nn|1p", "yMin", "Minimum value displayed on the y axis.", "o|33|x1|x2|ww|1p", "yMax", "Maximum value displayed on the y axis.", "o|33|x4|x5|Nn|1p", "Explicit width of the graph (overrides size).", "o|2h|bx|x7|bz", "Named size preset for the graph.", "medium", "tiny", "small", "large", "a|xB|xC|xA|xD|43", "About 1/12 the full width.", "o|3s|xB|xF", "About 30% of the full width.", "o|3s|xC|xH", "About half the full width.", "o|3s|xA|xJ", "About 70% of the full width.", "o|3s|xD|xL", "The full available width.", "o|3s|43|xN", "a|xG|xI|xK|xM|xO", "o|Bi|uB|x9|xA|xE|xP|3y", "aspectRatio", "Aspect ratio (width / height) for the graph.", "o|33|xR|xS|36|1p", "displayMode", "How to size the graph.", "a|AT|3h", "Display as a block element on its own line.", "o|3s|AT|xX", "Render inline with surrounding text.", "o|3s|3h|xZ", "a|xY|xa", "o|Bi|xU|xV|AT|xW|xb|3y", "horizontalAlign", "Horizontal alignment of the graph within its container.", "a|5b|5h|5i", "Center the graph horizontally.", "o|3s|5b|xg", "Align the graph to the left edge.", "o|3s|5h|xi", "Align the graph to the right edge.", "o|3s|5i|xk", "a|xh|xj|xl", "o|Bi|xd|xe|5b|xf|xm|3y", "identicalAxisScales", "Whether to force the x and y axis scales to be equal.", "o|2m|xo|xp|2p|2s|1V", "displayXAxis", "Whether to display the x axis.", "o|2m|xr|xs|3M|2s|1V", "displayYAxis", "Whether to display the y axis.", "o|2m|xu|xv|3M|2s|1V", "Whether to render interactive zoom/pan controls.", "all", "slidersOnly", "inputsOnly", "a|xy|xz|y0|42|2q|2r", "Render both sliders and input boxes.", "o|3s|xy|y2", "Render only slider controls.", "o|3s|xz|y4", "Render only input-box controls.", "o|3s|y0|y6", "Render no interactive controls.", "o|3s|42|y8", "a|y3|y5|y7|y9", "o|Bi|ST|xx|42|y1|yA|3y", "controlsPosition", "Position of the graph controls.", "a|5g|5h|5i|9", "Place controls below the graph.", "o|3s|5g|yF", "Place controls to the left of the graph.", "o|3s|5h|yH", "Place controls to the right of the graph.", "o|3s|5i|yJ", "Place controls above the graph.", "o|3s|9|yL", "a|yG|yI|yK|yM", "o|Bi|yC|yD|5h|yE|yN|3y", "displayXAxisTicks", "Whether to display tick marks on the x axis.", "o|2m|yP|yQ|3M|2s|1V", "displayYAxisTicks", "Whether to display tick marks on the y axis.", "o|2m|yS|yT|3M|2s|1V", "displayXAxisTickLabels", "Whether to display labels on x-axis ticks.", "o|2m|yV|yW|3M|2s|1V", "displayYAxisTickLabels", "Whether to display labels on y-axis ticks.", "o|2m|yY|yZ|3M|2s|1V", "xLabelPosition", "Position of the x-axis label.", "a|5i|5h", "Place the x-axis label at the right end of the axis.", "o|3s|5i|ye", "Place the x-axis label at the left end of the axis.", "o|3s|5h|yg", "a|yf|yh", "o|Bi|yb|yc|5i|yd|yi|3y", "xTickScaleFactor", "Scale factor applied to x-axis tick spacing.", "o|33|yk|yl||1X", "yLabelPosition", "Position of the y-axis label.", "a|9|5g", "Place the y-axis label at the top of the axis.", "o|3s|9|yq", "Place the y-axis label at the bottom of the axis.", "o|3s|5g|ys", "a|yr|yt", "o|Bi|yn|yo|9|yp|yu|3y", "yLabelAlignment", "Alignment of the y-axis label.", "Align the y-axis label to the left of the axis.", "o|3s|5h|yy", "Align the y-axis label to the right of the axis.", "o|3s|5i|z0", "a|yz|z1", "o|Bi|yw|yx|5h|dj|z2|3y", "yTickScaleFactor", "Scale factor applied to y-axis tick spacing.", "o|33|z4|z5||1X", "showNavigation", "Whether to show navigation controls (pan/zoom).", "o|2m|z7|z8|3M|2s|1V", "fixAxes", "Whether the axis limits are locked (preventing zoom/pan).", "o|2m|zA|zB|2p|2s|1V", "grid", "Grid density to render on the graph (off, minor, medium, or major).", "o|2h|zD|zE|1T", "showBorder", "Whether to render a border around the graph.", "o|2m|zG|zH|3M|2s|1V", "hideOffGraphIndicators", "Whether to suppress indicators for objects outside the visible region.", "o|2m|zJ|zK|2p|2s|1V", "decorative", "Whether the graph is purely decorative (excluded from a11y tree).", "o|2m|zM|zN|2p|2s|1V", "renderer", "Which renderer to use for the graph.", "doenet", "prefigure", "a|zR|zS", "Render using the built-in Doenet graph renderer.", "o|3s|zR|zU", "Render using the PreFigure SVG-based renderer.", "o|3s|zS|zW", "a|zV|zX", "o|Bi|zP|zQ|zR|zT|zY|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|wx|x0|x3|x6|x8|xQ|xT|xc|xn|xq|xt|xw|yB|yO|yR|yU|yX|ya|yj|ym|yv|z3|z6|z9|zC|zF|H8|4Y|4c|4g|4j|zI|zL|zO|zZ", "o|3L|xU|1T|2p|xV|3M", "o|3L|xd|1T|2p|xe|3M", "o|3L|xo|1V|2p|xp|3M", "o|3L|xr|1V|2p|xs|3M", "o|3L|xu|1V|2p|xv|3M", "o|3L|ST|1T|2p|xx|3M", "o|3L|yC|1T|2p|yD|3M", "o|3L|yP|1V|2p|yQ|3M", "o|3L|yS|1V|2p|yT|3M", "o|3L|yb|1T|2p|yc|3M", "o|3L|yk|1X|2p|yl|3M", "o|3L|yn|1T|2p|yo|3M", "o|3L|yw|1T|2p|yx|3M", "o|3L|z4|1X|2p|z5|3M", "o|3L|z7|1V|2p|z8|3M", "o|3L|zG|1V|2p|zH|3M", "o|3L|zJ|1V|2p|zK|3M", "o|3L|zM|1V|2p|zN|3M", "o|3L|zP|1T|2p|zQ|3M", "A short accessibility description of the graph.", "o|3Q|dd|1T|2p|zu", "Whether the visible axes range is locked.", "o|3Q|zA|1V|2p|zw", "The x-axis label text.", "o|3Q|I|2S|2p|zy", "The y-axis label text.", "o|3Q|J|2S|2p|100", "hasAuthorAnnotations", "Whether the graph contains any author-provided `<annotations>` child.", "o|3Q|102|1V|2p|103", "prefigureXML", "The Prefigure-formatted XML rendered for this graph, or null if not using the Prefigure renderer.", "o|3Q|105|1T|2p|106", "The size of the graph.", "o|3Q|uB|1T|2p|108", "The width of the graph.", "o|3Q|bx|bz|2p|10A", "The aspect ratio (width / height) of the graph.", "o|3Q|xR|1p|2p|10C", "effectiveRenderer", "The renderer actually used after resolving fallbacks.", "o|3Q|10E|1T|2p|10F", "Whether x-axis tick labels are displayed.", "o|3Q|yV|1V|2p|10H", "Whether y-axis tick labels are displayed.", "o|3Q|yY|1V|2p|10J", "Minimum x value displayed.", "o|3Q|wu|1p|2p|10L", "Maximum x value displayed.", "o|3Q|wy|1p|2p|10N", "Minimum y value displayed.", "o|3Q|x1|1p|2p|10P", "Maximum y value displayed.", "o|3Q|x4|1p|2p|10R", "xScale", "Scale used along the x axis (xMax − xMin).", "o|3Q|10T|1p|2p|10U", "yScale", "Scale used along the y axis (yMax − yMin).", "o|3Q|10W|1p|2p|10X", "Grid line spacing on the graph.", "o|ry|zD|2p|10Z", "a|3N|3O|3P|zb|zc|zd|ze|zf|zg|zh|zi|zj|zk|zl|zm|zn|zo|zp|zq|zr|zs|zt|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|zv|zx|zz|101|104|107|109|10B|10D|10G|10I|10K|10M|10O|10Q|10S|10V|10Y|10a", "A 2D coordinate-axis graph", "o|F|8y|ws|wt|9X|za|10b|3M|2p|2p|8y|10c|AT", "a|90|1z", "A container of annotation children for screen reader navigation of a graph", "o|F|8z|10e|BN|Ao|3I|Aa|3M|2p|2p|8z|10f|Az", "Reference to the component this annotation is attached to.", "o|2h|1c|10h|3D", "The annotation text read by screen readers.", "o|33|1T|10j|AZ|1T", "speech", "More detailed spoken text used by screen readers; used if expert mode is activated or extra details are requested.", "o|33|10l|10m|AZ|1T", "sonify", "Whether to play a tone when this annotation is focused and it references a function.", "o|2m|10o|10p|2p|2s|1V", "circular", "Whether navigation through this annotation's children wraps around.", "o|2m|10r|10s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|10i|10k|10n|10q|10t", "o|3L|1T|1T|2p|10j|3M", "o|3L|10l|1T|2p|10m|3M", "o|3L|10o|1V|2p|10p|3M", "o|3L|10r|1V|2p|10s|3M", "a|3N|3O|3P|10v|10w|10x|10y|3T|3U|3V|3W|3Z", "An annotation for screen reader navigation of a graph", "o|F|90|10e|BN|Ao|10u|10z|3M|2p|2p|90|110|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "The symbolic formula of the function.", "o|3Q|I9|1X|2p|113", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|114|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A mathematical function, defined by formula or interpolation", "o|F|1r|Fo|Fp|3l|112|115|3M|3M|2p|1r|116|3h", "a|w|x|y|1r|1s|1z|I|J|2S", "111012110", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|GD|GH|GK|Gf|Gh|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "Number of output values.", "o|3Q|G8|1q|2p|11B", "The piecewise formula of the function.", "o|3Q|I9|1X|2p|11D", "The piecewise function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|11F", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|11C|I0|I2|I4|I8|11E|11G|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function defined piecewise from sub-functions on intervals", "o|F|1s|118|119|3l|11A|11H|3M|2p|2p|1s|11I|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1t|2p|6e", "Whether this math component renders intervals as intervals (always true for `<interval>`).", "o|3Q|4t|1V|2p|11M", "a|3N|3O|3P|66|67|68|69|6A|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|11L|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|11N|7S|7V|7Y|7b", "A math expression treated as an interval of real numbers", "o|F|1t|3j|3k|3l|11K|11O|3M|3M|2p|1t|11P|3h", "option", "selectForVariants", "Variant indices for which this option is selected.", "textListFromString", "o|33|11S|11T|54|11U", "selectWeight", "Relative weight when randomly selecting an option.", "o|33|11W|11X|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11V|11Y", "o|3L|11S|11U|2p|11T|3M", "o|3L|11W|1p|2p|11X|3M", "a|3N|3O|3P|11a|11b|3T|3U|3V|3W|3Z", "A single option within a `<select>` block", "o|F|11R|9U|9V|Ao|11Z|11c|2p|3M|2p|11R|11d|Az", "The kind of values in the sequence.", "letters", "a|1p|1X|11g", "A sequence of numeric values.", "o|3s|1p|11i", "A sequence of math expressions (allows symbolic from/to/step).", "o|3s|1X|11k", "A sequence of letters (single-letter or multi-letter labels).", "o|3s|11g|11m", "a|11j|11l|11n", "o|HC|2g|11f|11h|11o|3y", "The first value in the sequence.", "_componentWithSelectableType", "o|2h|hM|11q|11r", "The last value in the sequence. Used together with from to determine length when length is not specified.", "o|2h|hX|11t|11r", "step", "The increment between successive values in the sequence.", "o|2h|11v|11w|1X", "The number of values in the sequence.", "o|2h|Qh|11y|1q", "exclude", "Values to exclude from the sequence.", "_componentListWithSelectableType", "o|2h|120|121|122", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB", "a|3N|3O|3P|3Z", "Generates a sequence of numbers, math expressions, or letters", "o|F|1u|54|AZ|g0|124|125|3M|2p|3M|1u|126|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|1L|1M|1V|1W|1o|2R|2S|2T", "2222222222222222222222212022222201222222222222112221211222222222222222222202", "Type of value the slider produces.", "a|1p|1T", "Slider produces numeric values between `from` and `to`.", "o|3s|1p|12C", "Slider produces text values, one per child of the slider.", "o|3s|1T|12E", "a|12D|12F", "o|3o|2g|12A|3M|1p|12B|12G|3y", "Display width of the slider.", "n|4q", "o|uD|12J|3M", "o|33|bx|12I|12K|bz", "Display height of the slider.", "n|1c", "o|uD|12N|3M", "o|33|k5|12M|12O|bz", "initialValue", "Initial value of the slider before any user interaction.", "o|33|12Q|12R||11r", "showControls", "Whether to render play/pause controls alongside the slider.", "o|2m|12T|12U|2p|2s|1V", "showTicks", "Whether to render tick marks on the slider.", "o|2m|12W|12X|3M|2s|1V", "rotateTickLabels", "Whether to rotate the tick labels.", "o|2m|12Z|12a|2p|2s|1V", "showValue", "Whether to display the current value next to the slider.", "o|2m|12c|12d|3M|2s|1V", "a|3|2f|3m|2k|2g", "Minimum value of the slider's range.", "o|12f|hM|12g|3M|5Q|1p", "Maximum value of the slider's range.", "o|12f|hX|12i|3M|Nn|1p", "Increment between successive slider positions.", "o|12f|11v|12k|3M|36|1p", "o|2h|e9|eA|11r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|12H|12L|12P|12S|12V|12Y|12b|12e|12h|12j|12l|GH|H8|4Y|4c|4g|4j|12m", "o|3L|bx|bz|2p|12I|3M", "o|3L|k5|bz|2p|12M|3M", "o|3L|12T|1V|2p|12U|3M", "o|3L|12W|1V|2p|12X|3M", "o|3L|12Z|1V|2p|12a|3M", "o|3L|12c|1V|2p|12d|3M", "o|65|hM|1p|2p|12g|3M|3M", "o|65|hX|1p|2p|12i|3M|3M", "o|65|11v|1p|2p|12k|3M|3M", "items", "The values the slider can take.", "o|ry|12x|2p|12y", "numItems", "The total number of values.", "o|3Q|130|1q|2p|131", "The current value of the slider.", "o|ry|3a|2p|133", "a|3N|3O|3P|12o|12p|12q|12r|12s|12t|12u|12v|12w|Hd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|12z|132|134", "An interactive slider input", "o|F|91|128|129|Ao|12n|135|3M|2p|2p|91|136|Az", "a|1v|1z|93|94|95", "02000", "Display width of the spreadsheet.", "o|uD|12N|2p", "o|33|bx|13A|13B|bz", "minNumRows", "Minimum number of rows displayed.", "n|4", "o|33|13D|13E|13F|1p", "minNumColumns", "Minimum number of columns displayed.", "o|33|13H|13I|13F|1p", "Display height of the spreadsheet.", "o|2h|k5|13K|bz", "columnHeaders", "Header labels for the columns.", "o|2m|13M|13N|3M|2s|1V", "rowHeaders", "Header labels for the rows.", "o|2m|13P|13Q|3M|2s|1V", "fixedRowsTop", "Number of top rows fixed in place when scrolling.", "o|33|13S|13T|5Q|1q", "fixedColumnsLeft", "Number of left columns fixed in place when scrolling.", "o|33|13V|13W|5Q|1q", "hiddenColumns", "Indices of columns to hide.", "o|33|13Y|13Z|54|1a", "hiddenRows", "Indices of rows to hide.", "o|33|13b|13c|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|13C|13G|13J|13L|13O|13R|13U|13X|13a|13d", "o|3L|bx|bz|2p|13A|3M", "o|3L|13D|1p|2p|13E|3M", "o|3L|13H|1p|2p|13I|3M", "o|3L|13M|1V|2p|13N|3M", "o|3L|13P|1V|2p|13Q|3M", "o|3L|13S|1q|2p|13T|3M", "o|3L|13V|1q|2p|13W|3M", "o|3L|13Y|1a|2p|13Z|3M", "o|3L|13b|1a|2p|13c|3M", "The number of rows.", "o|3Q|7A|1p|2p|13o", "The number of columns.", "o|3Q|7D|1p|2p|13q", "o|3Q|k5|bz|2p|13K", "cells", "The raw text contents of all cells.", "o|6x|2p|95", "o|6x|2p|93", "a|13v|13w", "o|6v|13t|1v|3M|13u|4X|13x", "The cells grouped by row.", "o|6v|7K|1v|3M|13z|4X|13x", "The cells grouped by column.", "o|6x|2p|94", "a|13v|142", "o|6v|7N|1v|3M|141|4X|143", "evaluatedCells", "The evaluated values of all cells.", "o|6v|145|1v|3M|146|4X|13x", "evaluatedRows", "The evaluated cell values grouped by row.", "o|6v|148|1v|3M|149|4X|13x", "evaluatedColumns", "The evaluated cell values grouped by column.", "o|6v|14B|1v|3M|14C|4X|143", "pointsInCells", "Cells whose values are interpreted as points.", "a|X6|IK", "o|6v|14E|1d|3M|14F|4X|14G", "pointsInRows", "Cell-derived points grouped by row.", "o|6v|14I|1d|3M|14J|4X|14G", "pointsInColumns", "Cell-derived points grouped by column.", "o|6v|14L|1d|3M|14M|4X|14G", "a|3N|3O|3P|13f|13g|13h|13i|13j|13k|13l|13m|13n|3T|3U|3V|3W|3Z|13p|13r|13s|13y|140|144|147|14A|14D|14H|14K|14N", "An interactive spreadsheet", "o|F|92|138|139|9X|13e|14O|3M|2p|2p|92|14P|AT", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|G|I|J|89|8A|8B|K|8C|O|P|R|S|T|U|V|W|X|Y|Z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|8Z|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|8j|8k|8l|8m|1V|1W|1b|1c|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1j|8x|1l|1m|1n|8y|8z|90|91|92|93|94|95|96|97|98|1w|1x|99|1y|20|9A|22|23|9B|9C|9D|9E|9F|2E|2F|2G|2H|2I|9G|9H|2J|9I|2L|2M|2N|9J|2P|9K|9L|9M|9N|2R|9O|2S|2T|9P|9Q|9R|9S|9T", "1111111111111111111111111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "rowNum", "Row number where this cell is placed (1-based).", "o|33|14T|14U||1T", "colNum", "Column number where this cell is placed (1-based).", "o|33|14W|14X||1T", "colSpan", "Number of columns this cell spans.", "o|33|14Z|14a|36|1q", "halign", "Horizontal alignment for the cell's content (left, center, or right).", "o|33|14c|14d|5h|1T", "Border style for the bottom edge of the cell.", "o|33|5g|14f|42|1T", "Border style for the right edge of the cell.", "o|33|5i|14h|42|1T", "Initial text content of the cell.", "o|33|Zj|14j|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|14V|14Y|14b|14e|14g|14i|14k", "o|3L|14T|1T|2p|14U|3M", "o|3L|14W|1T|2p|14X|3M", "o|3L|14Z|1q|2p|14a|3M", "o|3L|Zj|1T|2p|14j|3M", "Horizontal alignment of the cell's content (left, center, or right).", "o|3Q|14c|1T|2p|14q", "o|3Q|5g|1T|2p|14f", "o|3Q|5i|1T|2p|14h", "inHeader", "Whether this cell is in a header row of the table.", "o|3Q|14u|1V|2p|14v", "The cell's content as a text string.", "o|3Q|1T|1T|2p|14x", "The cell's content interpreted as a math expression.", "o|3Q|1X|1X|2p|14z", "The cell's content interpreted as a number.", "o|3Q|1p|1p|2p|151", "a|3N|3O|3P|14m|14n|14o|14p|3T|3U|3V|3W|3Z|14r|14s|14t|14w|14y|150|152", "A single cell within a tabular layout or spreadsheet", "o|F|1v|14R|14S|Ao|14l|153|3M|3M|2p|1v|154|Az", "displayContext", "a|3|4|5|6|7|8|9|A|B|C|D|E|156", "a|1v|1z", "Row number where this row is placed (1-based).", "o|33|14T|159||1T", "header", "Whether this row is a header row.", "o|2m|15B|15C|2p|2s|1V", "Default horizontal alignment for cells in this row.", "o|33|14c|15E|5h|1T", "Default vertical alignment for cells in this row.", "o|33|c8|15G|cA|1T", "Border style for the left edge of this row.", "o|33|5h|15I|42|1T", "Border style for the bottom edge of this row.", "o|33|5g|15K|42|1T", "o|2h|4w|4x|1U", "o|2h|52|53|3D", "o|Ap|56|57|2s|1V", "o|Ap|59|5A|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15A|15D|15F|15H|15J|15L|15M|15N|15O|15P", "o|3L|14T|1T|2p|159|3M", "o|3L|15B|1V|2p|15C|3M", "o|3Q|14c|1T|2p|15E", "o|3Q|c8|1T|2p|15G", "Border style for the left edge of the row.", "o|3Q|5h|1T|2p|15V", "Border style for the bottom edge of the row.", "o|3Q|5g|1T|2p|15X", "a|3N|3O|3P|15R|15S|3T|3U|3V|3W|3Z|15T|15U|15W|15Y", "row_table", "A row within a tabular layout", "in a table", "o|157|93|158|BN|Ao|15Q|15Z|3M|2p|2p|15a|15b|Az|15c", "Column number where this column is placed (1-based).", "o|33|14W|15e||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15f|15M|15N|15O|15P", "o|3L|14W|1T|2p|15e|3M", "a|3N|3O|3P|15h|3T|3U|3V|3W|3Z", "column_table", "A column of cells within a `<spreadsheet>`", "o|157|94|158|BN|Ao|15g|15i|3M|2p|2p|15j|15k|Az|15c", "Row number where this block starts (1-based; can be a letter or number).", "o|33|14T|15m||1T", "Column number where this block starts (1-based; can be a letter or number).", "o|33|14W|15o||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15n|15p", "o|3L|14T|1T|2p|15m|3M", "o|3L|14W|1T|2p|15o|3M", "a|3N|3O|3P|15r|15s|3T|3U|3V|3W|3Z", "Container for grouping `<cell>`, `<row>`, and `<column>` children inside a `<spreadsheet>`", "o|F|95|138|139|Ao|15q|15t|3M|2p|2p|95|15u|Az", "a|93|1z", "Display width of the tabular layout.", "o|33|bx|15x|13B|bz", "Display height of the tabular layout.", "o|33|k5|15z||bz", "Default horizontal alignment for cells.", "justify", "a|5h|5b|5i|162", "Left-align cell content.", "o|3s|5h|164", "Center cell content horizontally.", "o|3s|5b|166", "Right-align cell content.", "o|3s|5i|168", "Justify cell content across the full cell width.", "o|3s|162|16A", "a|165|167|169|16B", "o|Bi|14c|161|5h|163|16C|3y", "Default vertical alignment for cells.", "Align cell content to the top.", "o|3s|9|16F", "Center cell content vertically.", "o|3s|cA|16H", "Align cell content to the bottom.", "o|3s|5g|16J", "a|16G|16I|16K", "o|Bi|c8|16E|cA|cB|16L|3y", "Border style for the top edge of the layout.", "minor", "major", "a|42|16O|xA|16P", "Do not render a border.", "o|3s|42|16R", "Render a thin border line.", "o|3s|16O|16T", "Render a medium-weight border line.", "o|3s|xA|16V", "Render a thick border line.", "o|3s|16P|16X", "a|16S|16U|16W|16Y", "o|Bi|9|16N|42|16Q|16Z|3y", "Border style for the left edge of the layout.", "o|Bi|5h|16b|42|16Q|16Z|3y", "Border style for the bottom edge of the layout.", "o|Bi|5g|16d|42|16Q|16Z|3y", "Border style for the right edge of the layout.", "o|Bi|5i|16f|42|16Q|16Z|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15y|160|16D|16M|16a|16c|16e|16g", "o|3L|bx|bz|2p|15x|3M", "o|3L|k5|bz|2p|15z|3M", "o|3L|14c|1T|2p|161|3M", "o|3L|c8|1T|2p|16E|3M", "o|3L|9|1T|2p|16N|3M", "o|3L|5h|1T|2p|16b|3M", "o|3L|5g|1T|2p|16d|3M", "o|3L|5i|1T|2p|16f|3M", "a|3N|3O|3P|16i|16j|16k|16l|16m|16n|16o|16p|3T|3U|3V|3W|3Z", "A simple tabular layout of cells", "o|F|96|15w|BN|9X|16h|16q|3M|2p|2p|96|16r|AT", "a|G|1z|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "021111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "suppressTableNameInTitle", "Whether to omit the auto-generated table name from the title.", "o|2m|16v|16w|2p|2s|1V", "Whether to display an auto-generated table number.", "o|2m|1p|16y|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|16x|16z", "tableEnumeration", "Auto-generated number for this table.", "o|3Q|171|1T|2p|172", "tableName", "The full display name of the table (e.g., 'Table 2').", "o|3Q|174|1T|2p|175", "The table's title.", "o|3Q|G|1T|2p|177", "a|3N|3O|3P|3T|3U|3V|3W|3Z|173|176|178", "A container element for a `<tabular>`", "o|F|97|16t|16u|9X|170|179|3M|3M|2p|97|17A|AT", "a|1z|9I|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9J|9N|9Q|9S|9T", "201111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222212221222221112111121222112211111222111111111111111111111111111111111111111111111111111", "suppressFigureNameInCaption", "Whether to omit the auto-generated figure name from the caption.", "o|2m|17E|17F|2p|2s|1V", "Whether to display an auto-generated figure number.", "o|2m|1p|17H|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|17G|17I", "figureEnumeration", "Auto-generated number for this figure.", "o|3Q|17K|1T|2p|17L", "figureName", "The full display name of the figure (e.g., 'Figure 3').", "o|3Q|17N|1T|2p|17O", "The figure's caption text.", "o|3Q|9I|1T|2p|17Q", "a|3N|3O|3P|3T|3U|3V|3W|3Z|17M|17P|17R", "A figure container holding graphical content with a caption", "o|F|98|17C|17D|9X|17J|17S|3M|3M|2p|98|17T|AT", "Whether the generated repeats should be treated as responses for assessment.", "o|g3|38|17V", "valueName", "Name to bind the current item to inside the repeat template.", "o|33|17X|17Y||1T", "indexName", "Name to bind the current 1-based index to inside the repeat template.", "o|33|17a|17b||1T", "The collection of items to iterate over when generating repeats.", "o|2h|7f|17d|23", "Component type used to wrap each item in the source.", "o|2h|2g|17f|1T", "a|2j|2t|2w|2z|32|37|17W|3E|3H|17Z|17c|17e|17g|gB", "a|3N|3O|3Z", "Repeats template content for each item in a source", "o|F|1w|9U|9V|g0|17h|17i|3M|3M|3M|1w|17j|Az", "a|2j|2t|2w|2z|32|37|17W|3E|3H|11p|11s|11u|11x|11z|123|17Z|17c|gB", "Repeats template content for each value in an arithmetic sequence", "o|F|1x|9U|9V|g0|17l|17i|3M|3M|3M|1x|17m|Az", "dx", "Horizontal spacing between pegs.", "o|33|17o|17p|36|1p", "dy", "Vertical spacing between pegs.", "o|33|17r|17s|36|1p", "xoffset", "Horizontal offset of the peg grid origin.", "o|33|17u|17v|5Q|1p", "yoffset", "Vertical offset of the peg grid origin.", "o|33|17x|17y|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|17q|17t|17w|17z", "o|3L|17o|1p|2p|17p|3M", "o|3L|17r|1p|2p|17s|3M", "o|3L|17u|1p|2p|17v|3M", "o|3L|17x|1p|2p|17y|3M", "a|3N|3O|3P|Hd|QD|7s|QE|181|182|183|184|3T|3U|3V|3W|3Z|Hk", "Renders a grid of pegs on a graph", "o|F|99|Om|On|Op|180|185|3M|2p|2p|99|186|Az", "_constraint", "a|188|2d", "Horizontal grid spacing.", "o|33|17o|18A|36|1p", "Vertical grid spacing.", "o|33|17r|18C|36|1p", "dz", "Depth-wise grid spacing.", "o|33|18E|18F|36|1p", "Horizontal offset of the grid origin.", "o|33|17u|18H|5Q|1p", "Vertical offset of the grid origin.", "o|33|17x|18J|5Q|1p", "zoffset", "Depth-wise offset of the grid origin.", "o|33|18L|18M|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N", "o|3L|17o|1p|2p|18A|3M", "o|3L|17r|1p|2p|18C|3M", "o|3L|18E|1p|2p|18F|3M", "o|3L|17u|1p|2p|18H|3M", "o|3L|17x|1p|2p|18J|3M", "o|3L|18L|1p|2p|18M|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie on a grid", "o|F|RJ|54|AZ|189|18O|18V|2p|2p|2p|RJ|18W|Az", "buffer", "Distance from the graph edge inside which the position is still considered constrained.", "n|0.A", "o|33|18Y|18Z|18a|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18b", "o|3L|18Y|1p|2p|18Z|3M", "a|3N|3O|3P|18d|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie within a graph's bounds", "o|F|RK|54|AZ|189|18c|18e|2p|2p|2p|RK|18f|Az", "xthreshold", "Horizontal distance within which the position attracts to a grid line.", "n|0.2", "o|33|18h|18i|18j|1p", "ythreshold", "Vertical distance within which the position attracts to a grid line.", "o|33|18l|18m|18j|1p", "zthreshold", "Depth-wise distance within which the position attracts to a grid line.", "o|33|18o|18p|18j|1p", "includeGridlines", "Whether to attract to entire grid lines (in addition to grid intersection points).", "o|2m|18r|18s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N|18k|18n|18q|18t", "o|3L|18h|1p|2p|18i|3M", "o|3L|18l|1p|2p|18m|3M", "o|3L|18o|1p|2p|18p|3M", "o|3L|18r|1V|2p|18s|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|18v|18w|18x|18y|3T|3U|3V|3W|3Z", "Attracts a graphical component's position to grid lines when nearby", "o|F|RL|54|AZ|189|18u|18z|2p|2p|2p|RL|190|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|1z|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "222222222222222222222222221111222221211111111111112222221222222222122221111121222", "relativeToGraphScales", "Whether the constraint is interpreted relative to the enclosing graph's scales.", "o|2m|194|195|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|196", "o|3L|194|1V|2p|195|3M", "a|3N|3O|3P|198|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to be within another component or components", "o|F|RM|192|193|189|197|199|2p|2p|2p|RM|19A|Az", "Whether the attraction threshold is interpreted relative to the enclosing graph's scales rather than absolute coordinates.", "o|2m|194|19C|2p|2s|1V", "Distance within which the position attracts to a target.", "o|2h|E6|19E|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19D|19F", "o|3L|194|1V|2p|19C|3M", "o|3Q|E6|1p|2p|19E", "a|3N|3O|3P|19H|3T|3U|3V|3W|3Z|19I", "Attracts a graphical component's position to another component when nearby", "o|F|RN|192|193|189|19G|19J|2p|2p|2p|RN|19K|Az", "a|RJ|RK|RL|RM|RN|RO|RP|RQ|1z", "111111112", "A constraint that is satisfied if any of its child constraints are satisfied", "o|F|RO|19M|19N|189|3I|Aa|2p|2p|2p|RO|19O|Az", "Distance within which the position attracts to the constraint location.", "o|33|E6|19Q|Pq|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19R", "o|3L|E6|1p|2p|19Q|3M", "a|3N|3O|3P|19T|3T|3U|3V|3W|3Z", "Wraps another constraint so it acts as a soft attraction within a threshold", "o|F|RP|19M|19N|189|19S|19U|2p|2p|2p|RP|19V|Az", "Constrains a graphical component's position to lie inside a region", "o|F|RQ|192|193|189|197|199|2p|2p|2p|RQ|19X|Az", "a|1K|1f|1z|2Q|8n|8u|8q|8r|8s|8t|8Y|8p", "102100011110", "Style number applied to the resulting intersection components.", "o|g3|34|19b", "a|2j|2t|2w|2z|32|19c|3A|3E|3H|gB", "a|3N|3P|3Z", "Renders intersections between graphical objects", "o|F|1y|19Z|19a|g0|19d|19e|3M|2p|2p|1y|19f|Az", "case", "a|1z|19h|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y|An", "101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111110", "Convenience for a single-case form: the boolean condition for which the children are rendered.", "o|Ap|Aq|19k|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19l", "Renders content conditionally based on its `<case>` or `<else>` children", "o|F|1z|19i|19j|g0|19m|125|3M|3M|2p|1z|19n|Az", "The children rendered as a comma-separated text string.", "o|3Q|1T|1T|2p|19p", "The children rendered as a comma-separated LaTeX string.", "o|3Q|2V|2V|2p|19r", "a|3N|3O|3P|3T|3U|3V|3W|3Z|19q|19s", "Renders its children as a comma-separated list", "o|F|20|2Z|2a|3l|3I|19t|3M|3M|2p|20|19u|3h", "numVariants", "The total number of variants to generate.", "o|2h|19w|19x|1q", "uniqueVariants", "Whether to require generated variants to be uniquely distinguishable.", "o|Ap|19z|1A0|2s|1V", "variantsToInclude", "Restrict the available variants to this list (by name or index).", "o|2h|1A2|1A3|11U", "variantsToExclude", "Variants to exclude from those generated.", "o|2h|1A5|1A6|11U", "variantNames", "Names assigned to the generated variants.", "o|2h|1A8|1A9|11U", "seeds", "Random seeds used when generating variants.", "o|2h|1AB|1AC|11U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19y|1A1|1A4|1A7|1AA|1AD", "Configures how variants are generated for the enclosing document or section", "o|F|9A|54|AZ|Ao|1AE|Aa|3M|2p|2p|9A|1AF|Az", "numToSelect", "How many values to select from the sequence.", "o|33|1AH|1AI|36|1q", "withReplacement", "Whether the same value can be selected more than once.", "o|2m|1AK|1AL|2p|2s|1V", "Whether and how to sort the selected values.", "unsorted", "increasing", "decreasing", "a|1AO|1AP|1AQ|2q|2r", "Preserve the random selection order.", "o|3s|1AO|1AS", "Sort the selected values in increasing order.", "o|3s|1AP|1AU", "Sort the selected values in decreasing order.", "o|3s|1AQ|1AW", "a|1AT|1AV|1AX", "o|Bi|2L|1AN|1AO|1AR|1AY|3y", "excludeCombinations", "Lists of value combinations to exclude from the selection.", "_componentListOfListsWithSelectableType", "o|2h|1Aa|1Ab|1Ac", "coprime", "Require the selected numbers to be pairwise coprime (numbers only).", "o|2m|1Ae|1Af|2p|2s|1V", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB|1AJ|1AM|1AZ|1Ad|1Ag", "o|3L|1AH|1q|2p|1AI|3M", "o|3L|1AK|1V|2p|1AL|3M", "o|3L|2L|1T|2p|1AN|3M", "o|3L|1Ae|1V|2p|1Af|3M", "a|3N|3O|3P|1Ai|1Aj|1Ak|1Al|3Z", "Randomly selects values from a sequence of numbers, math expressions, or letters to create document variants", "o|F|21|54|AZ|g0|1Ah|1Am|3M|2p|3M|21|1An|Az", "a|11R|1z", "How many child components to select.", "o|33|1AH|1Aq|36|1q", "Whether the same child can be selected more than once.", "o|2m|1AK|1As|2p|2s|1V", "Component type to select from.", "o|2h|2g|1Au|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ar|1At|1Av|gB", "o|3L|1AH|1q|2p|1Aq|3M", "o|3L|1AK|1V|2p|1As|3M", "a|3N|3O|3P|1Ax|1Ay|3Z", "Randomly selects components from a list of children to create document variants", "o|F|22|1Ap|BN|g0|1Aw|1Az|3M|3M|3M|22|1B0|Az", "Whether this group's children should be treated as responses for assessment.", "o|g3|38|1B2", "rendered", "Whether the group's children are rendered.", "o|2m|1B4|1B5|3M|2s|1V", "createComponentOfType", "Component type to wrap each child as when expanding the group.", "o|2h|1B7|1B8|1T", "Number of components to create when expanding (used with createComponentOfType).", "o|2h|gF|1BA|1p", "Whether to render the group's children separated by commas (true) or with no separator (false).", "o|2m|20|1BC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|1B3|3E|3H|1B6|1B9|1BB|1BD", "o|3L|1B4|1V|2p|1B5|3M", "a|3N|3O|1BF|3Z", "A logical grouping of components", "o|F|23|9U|9V|g0|1BE|1BG|3M|3M|2p|23|1BH|Az", "target", "Reference to the state variable that will be animated.", "o|2h|1BJ|1BK|3D", "animationOn", "Whether the animation is currently playing.", "o|2m|1BM|1BN|2p|2s|1V", "animationMode", "How the animation steps through the sequence.", "increase", "decrease", "increase once", "decrease once", "oscillate", "a|1BR|1BS|1BT|1BU|1BV", "Step through values from first to last, looping back to the start.", "o|3s|1BR|1BX", "Step through values from last to first, looping back to the end.", "o|3s|1BS|1BZ", "Step from first to last and stop without looping.", "o|3s|1BT|1Bb", "Step from last to first and stop without looping.", "o|3s|1BU|1Bd", "Step from first to last, then reverse direction at each end.", "o|3s|1BV|1Bf", "a|1BY|1Ba|1Bc|1Be|1Bg", "o|Bi|1BP|1BQ|1BR|1BW|1Bh|3y", "animationInterval", "Time in milliseconds between successive animation steps.", "o|33|1Bj|1Bk|Nv|1p", "allowAdjustmentsWhileRunning", "Whether sequence parameters can be adjusted while the animation is running.", "o|2m|1Bm|1Bn|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11p|11s|11u|11x|11z|123|1BL|1BO|1Bi|1Bl|1Bo", "o|3L|1BM|1V|2p|1BN|3M", "o|3L|1BP|1T|2p|1BQ|3M", "o|3L|1Bj|1p|2p|1Bk|3M", "o|3L|1Bm|1V|2p|1Bn|3M", "Index of the currently selected value in the sequence (1-based).", "o|3Q|vc|1p|2p|1Bu", "The currently selected value of the animation.", "o|ry|3a|2p|1Bw", "currentAnimationDirection", 'Current direction of the animation ("increase" or "decrease"; flips during oscillation).', "o|3Q|1By|1T|2p|1Bz", "a|3N|3O|3P|1Bq|1Br|1Bs|1Bt|3T|3U|3V|3W|3Z|1Bv|1Bx|1C0", "Animates a value through a sequence over time", "o|F|9B|54|AZ|Ao|1Bp|1C1|3M|2p|2p|9B|1C2|Az", "Whether to treat the inputs as unordered.", "o|2m|4n|1C4|2p|2s|1V", "Whether to force symbolic evaluation.", "o|2m|DH|1C6|2p|2s|1V", "Whether to force numeric evaluation.", "o|2m|DK|1C8|2p|2s|1V", "The function to evaluate.", "o|2h|1r|1CA|1r", "input", "Input value(s) at which to evaluate the function.", "o|2h|1CC|1CD|1Y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1C5|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1C7|1C9|1CB|1CE", "o|3L|4n|1V|2p|1C4|3M", "o|3L|DH|1V|2p|1C6|3M", "o|3L|DK|1V|2p|1C8|3M", "o|3Q|3a|24|2p|6e", "The function evaluated at the inputs as a math expression.", "o|3Q|I9|1X|2p|1CK", "a|3N|3O|3P|66|67|68|69|1CG|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1CH|1CI|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1CJ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1CL|7S|7V|7Y|7b", "Evaluates a function at a math value", "o|F|24|54|AZ|3l|1CF|1CM|3M|2p|2p|24|1CN|3h", "Distribution from which to sample.", "discreteUniform", "gaussian", "a|W7|1CQ|1CR", "Continuous uniform distribution over `[from, to]`.", "o|3s|W7|1CT", "Discrete uniform distribution over integers in `[from, to]`.", "o|3s|1CQ|1CV", "Normal (Gaussian) distribution with the specified mean and standard deviation.", "o|3s|1CR|1CX", "a|1CU|1CW|1CY", "o|Bi|2g|1CP|W7|1CS|1CZ|3y", "Mean of the sampling distribution (Gaussian).", "o|33|l|1Cb|5Q|1p", "Standard deviation of the sampling distribution (Gaussian).", "o|33|o|1Cd|36|1p", "Variance of the sampling distribution (Gaussian).", "o|33|n|1Cf|36|1p", "Lower bound of the sampling range.", "o|33|hM|1Ch||1p", "Upper bound of the sampling range.", "o|33|hX|1Cj||1p", "Step size between samples for the discrete-uniform distribution.", "o|33|11v|1Cl|36|1p", "Values to exclude from the sample space.", "o|33|120|1Cn|54|1a", "How many random numbers to select.", "o|33|1AH|1Cp|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|gB|1Cq", "o|3L|2g|1T|2p|1CP|3M", "o|3L|1AH|1q|2p|1Cp|3M", "Step size between sample values (for discrete distributions).", "o|3Q|11v|1p|2p|1Cu", "o|3Q|hM|1p|2p|1Ch", "o|3Q|hX|1p|2p|1Cj", "Mean of the sampling distribution.", "o|3Q|l|1p|2p|1Cy", "Variance of the sampling distribution.", "o|3Q|n|1p|2p|1D0", "Standard deviation of the sampling distribution.", "o|3Q|o|1p|2p|1D2", "a|3N|3O|3P|1Cs|1Ct|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Selects a fixed set of random numbers to create document variants", "o|F|25|54|AZ|g0|1Cr|1D4|3M|2p|3M|25|1D5|Az", "numSamples", "Number of samples to draw.", "o|33|1D7|1D8|36|1p", "variantDeterminesSeed", "Whether the document's variant index determines the random seed.", "o|Ap|1DA|1DB|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1D9|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|1DC|gB", "o|3L|1D7|1p|2p|1D8|3M", "o|3L|1DA|1V|2p|1DB|3M", "a|3N|3O|3P|1DE|1Cs|1DF|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Samples random numbers from a distribution", "o|F|26|54|AZ|g0|1DD|1DG|3M|2p|3M|26|1DH|Az", "Lower bound (inclusive) of the prime range to select from.", "o|33|hM|1DJ|4X|1q", "Upper bound (inclusive) of the prime range to select from.", "o|33|hX|1DL|12N|1q", "Primes to exclude from the selection.", "o|33|120|1DN|54|1a", "How many prime numbers to select.", "o|33|1AH|1DP|36|1q", "Whether the same prime can be selected more than once.", "o|2m|1AK|1DR|2p|2s|1V", "Sort order applied to the selected primes.", "Sort the selected primes in increasing order.", "o|3s|1AP|1DU", "Sort the selected primes in decreasing order.", "o|3s|1AQ|1DW", "a|1AT|1DV|1DX", "o|Bi|2L|1DT|1AO|1AR|1DY|3y", "Combinations of values that should not be selected together.", "_listOfNumberLists", "o|2h|1Aa|1Da|1Db", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1DK|1DM|1DO|1DQ|1DS|1DZ|1Dc|gB", "o|3L|hM|1q|2p|1DJ|3M", "o|3L|hX|1q|2p|1DL|3M", "o|3L|120|1a|2p|1DN|3M", "o|3L|1AH|1q|2p|1DP|3M", "o|3L|1AK|1V|2p|1DR|3M", "o|3L|2L|1T|2p|1DT|3M", "a|3N|3O|3P|1De|1Df|1Dg|1Dh|1Di|1Dj|3Z", "Randomly selects prime numbers from a range to create document variants", "o|F|27|54|AZ|g0|1Dd|1Dk|3M|2p|3M|27|1Dl|Az", "Number of prime samples to draw.", "o|33|1D7|1Dn|36|1p", "Lower bound (inclusive) of the prime range to sample from.", "o|33|hM|1Dp|4X|1q", "Upper bound (inclusive) of the prime range to sample from.", "o|33|hX|1Dr|12N|1q", "Primes to exclude from the sample.", "o|33|120|1Dt|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Do|1Dq|1Ds|1Du|1DC|gB", "o|3L|1D7|1p|2p|1Dn|3M", "o|3L|hM|1q|2p|1Dp|3M", "o|3L|hX|1q|2p|1Dr|3M", "o|3L|120|1a|2p|1Dt|3M", "a|3N|3O|3P|1Dw|1Dx|1Dy|1Dz|1DF|3Z", "Samples random prime numbers", "o|F|28|54|AZ|g0|1Dv|1E0|3M|2p|3M|28|1E1|Az", "Type of values being substituted.", "a|1X|1T", "Substitute within math expressions.", "o|3s|1X|1E5", "Substitute within text values.", "o|3s|1T|1E7", "a|1E6|1E8", "o|HC|2g|1E3|1E4|1E9|3y", "match", "Pattern to match in the source value.", "o|33|1EB|1EC||11r", "replacement", "Value to substitute in place of each match.", "o|33|1EE|1EF||11r", "Level of simplification applied after substitution.", "Fully simplify the resulting expression.", "o|3s|43|1EI", "a|49|1EJ|4D|4F|4H", "o|Bi|40|1EH|42|47|1EK|3y", "matchWholeWord", "Whether matching is restricted to whole words (text mode).", "o|2m|1EM|1EN|2p|2s|1V", "matchCase", "Whether matching is case-sensitive (text mode).", "o|2m|1EP|1EQ|2p|2s|1V", "preserveCase", "Whether the case of the original is preserved when substituting.", "o|2m|1ES|1ET|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1EA|1ED|1EG|1EL|H8|4Y|4c|4g|4j|1EO|1ER|1EU", "o|3L|2g|1T|2p|1E3|3M", "o|3L|40|1T|2p|1EH|3M", "o|3L|1EM|1V|2p|1EN|3M", "o|3L|1EP|1V|2p|1EQ|3M", "o|3L|1ES|1V|2p|1ET|3M", "a|3N|3O|3P|1EW|1EX|1EY|1EZ|1Ea|3Z|6X|6Y|6Z|6a|6b", "Substitutes math expressions into another expression", "o|F|29|9U|9V|g0|1EV|1Eb|3M|3M|3M|29|1Ec|Az", "o|Ap|4n|4o|2s|1V", "minIndex", "Smallest period index considered when listing offsets.", "-Infinity", "o|33|1Ef|1Eg|1Eh|1q", "maxIndex", "Largest period index considered when listing offsets.", "o|33|1Ej|1Ek|9k|1q", "offsets", "Offsets within one period.", "o|33|1Em|1En||1Y", "The period of the set.", "o|33|Y8|1Ep||1X", "minIndexAsList", "Smallest period index when rendered as a list.", "n|-1", "o|33|1Er|1Es|1Et|1q", "maxIndexAsList", "Largest period index when rendered as a list.", "o|33|1Ev|1Ew|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Ei|1El|1Eo|1Eq|1Eu|1Ex", "o|3L|1Ef|1q|2p|1Eg|3M", "o|3L|1Ej|1q|2p|1Ek|3M", "o|3L|1Em|1Y|2p|1En|3M", "o|3L|Y8|1X|2p|1Ep|3M", "o|3L|1Er|1q|2p|1Es|3M", "o|3L|1Ev|1q|2p|1Ew|3M", "o|3Q|3a|2A|2p|6e", "numOffsets", "The number of distinct offsets within one period.", "o|3Q|1F6|1q|2p|1F7", "redundantOffsets", "Offsets that are redundant given the period.", "o|3Q|1F9|1V|2p|1FA", "The periodic set rendered as a list of explicit values.", "o|3Q|20|1Y|2p|1FC", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1Ez|1F0|1F1|1F2|1F3|1F4|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1F5|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1F8|1FB|1FD|7S|7V|7Y|7b", "A periodic set of real numbers", "o|F|2A|54|AZ|3l|1Ey|1FE|3M|2p|2p|2A|1FF|3h", "a|1z|dd|2f", "200", "Explicit width of the image (overrides size).", "o|33|bx|1FJ||bz", "Named size preset for the image.", "o|Bi|uB|1FL|xA|xE|xP|3y", "Aspect ratio (width / height) for the image.", "o|33|xR|1FN||1p", "How to size the image.", "o|Bi|xU|1FP|AT|xW|xb|3y", "Horizontal alignment of the image within its container.", "Center the image horizontally.", "o|3s|5b|1FS", "Align the image to the left edge.", "o|3s|5h|1FU", "Align the image to the right edge.", "o|3s|5i|1FW", "a|1FT|1FV|1FX", "o|Bi|xd|1FR|5b|xf|1FY|3y", "Whether the image is purely decorative.", "o|2m|zM|1Fa|2p|2s|1V", "source", "URL or path of the image source.", "o|33|1Fc|1Fd|AZ|1T", "authorName", "Name of the author of the image.", "o|33|1Ff|1Fg||1T", "authorUrl", "URL to link the author's name to in the attribution (e.g. the author's profile page).", "o|33|1Fi|1Fj||1T", "imageName", "Name of the image, used in place of the generic word “Image” in the attribution.", "o|33|1Fl|1Fm||1T", "originalUrl", "Original URL where the image can be found, used to link the image name in the attribution.", "o|33|1Fo|1Fp||1T", "licenseName", "Name of the license for the image.", "o|33|1Fr|1Fs||1T", "licenseUrl", "URL for the license of the image.", "o|33|1Fu|1Fv||1T", "a|3|2f|2k|2l|3n|cK|2g", "licenseCodes", "License code(s) for the image. Specify two codes to indicate the image is dual licensed.", "CC-BY", "CC-BY-SA", "CC-BY-ND", "CC-BY-NC", "CC-BY-NC-SA", "CC-BY-NC-ND", "CC0", "PDM", "GFDL", "FAL", "OGL", "MIT", "APACHE-2.0", "a|1G0|1G1|1G2|1G3|1G4|1G5|1G6|1G7|1G8|1G9|1GA|1GB|1GC", "Creative Commons Attribution: reuse with credit, including commercially.", "o|3s|1G0|1GE", "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license.", "o|3s|1G1|1GG", "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit.", "o|3s|1G2|1GI", "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes.", "o|3s|1G3|1GK", "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license.", "o|3s|1G4|1GM", "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit.", "o|3s|1G5|1GO", "Creative Commons Zero: the creator has dedicated the work to the public domain.", "o|3s|1G6|1GQ", "Public Domain Mark: the work is free of known copyright restrictions.", "o|3s|1G7|1GS", "GNU Free Documentation License: copyleft license common on Wikimedia.", "o|3s|1G8|1GU", "Free Art License: copyleft license for artistic works.", "o|3s|1G9|1GW", "UK Open Government Licence: reuse government material with attribution.", "o|3s|1GA|1GY", "MIT License: permissive license common for icon and illustration sets.", "o|3s|1GB|1Ga", "Apache License 2.0: permissive license common for icon and illustration sets.", "o|3s|1GC|1Gc", "a|1GF|1GH|1GJ|1GL|1GN|1GP|1GR|1GT|1GV|1GX|1GZ|1Gb|1Gd", "o|1Fx|1Fy|1Fz||1GD|1Ge|3M|3y", "licenseVersion", "Version of the Creative Commons license(s) given in `licenseCodes` (ignored by non-Creative-Commons licenses).", "4.0", "1.0", "2.0", "2.5", "3.0", "a|1Gj|1Gk|1Gl|1Gm|1Gi", "Creative Commons version 1.0.", "o|3s|1Gj|1Go", "Creative Commons version 2.0.", "o|3s|1Gk|1Gq", "Creative Commons version 2.5.", "o|3s|1Gl|1Gs", "Creative Commons version 3.0.", "o|3s|1Gm|1Gu", "Creative Commons version 4.0.", "o|3s|1Gi|1Gw", "a|1Gp|1Gr|1Gt|1Gv|1Gx", "o|Bi|1Gg|1Gh|1Gi|1Gn|1Gy|3y", "asFileName", "File name to use when downloading the image.", "o|33|1H0|1H1||1T", "mimeType", "MIME type of the image.", "o|33|1H3|1H4||1T", "Whether the image can be dragged on a graph.", "o|2m|5L|1H6|3M|2s|1V", "rotate", "Rotation angle (radians) applied to the image.", "o|33|1H8|1H9|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1FK|1FM|1FO|1FQ|1FZ|1Fb|1Fe|1Fh|1Fk|1Fn|1Fq|1Ft|1Fw|1Gf|1Gz|1H2|1H5|1H7|5R|5X|63|1HA", "o|3L|xU|1T|2p|1FP|3M", "o|3L|xd|1T|2p|1FR|3M", "o|3L|zM|1V|2p|1Fa|3M", "o|3L|1Fc|1T|2p|1Fd|3M", "o|3L|1Ff|1T|2p|1Fg|3M", "o|3L|1Fi|1T|2p|1Fj|3M", "o|3L|1Fl|1T|2p|1Fm|3M", "o|3L|1Fo|1T|2p|1Fp|3M", "o|3L|1Fy|1U|2p|1Fz|3M", "o|3L|1Gg|1T|2p|1Gh|3M", "o|3L|1H0|1T|2p|1H1|3M", "o|3L|1H3|1T|2p|1H4|3M", "o|3L|5L|1V|2p|1H6|3M", "o|3L|1H8|1p|2p|1H9|3M", "A short accessibility description of the image.", "o|3Q|dd|1T|2p|1HQ", "The size of the image.", "o|3Q|uB|1T|2p|1HS", "The display width of the image.", "o|3Q|bx|bz|2p|1HU", "The aspect ratio (width / height) of the image.", "o|3Q|xR|1p|2p|1HW", "licenseNames", "The license name(s) for the image. Derived from `licenseCodes` when given; otherwise from the `licenseName` attribute.", "o|3Q|1HY|1U|2p|1HZ", "licenseUrls", "The license URL(s) for the image. Derived from `licenseCodes` (and `licenseVersion`) when given; otherwise from the `licenseUrl` attribute.", "o|3Q|1Hb|1U|2p|1Hc", "a|3N|3O|3P|1HC|1HD|1HE|1HF|1HG|1HH|1HI|1HJ|1HK|1HL|1HM|1HN|1HO|6I|6K|1HP|3T|3U|3V|3W|3Z|6W|1HR|1HT|1HV|1HX|1Ha|1Hd", "Displays a static image", "o|F|9C|1FH|1FI|9X|1HB|1He|3M|2p|2p|9C|1Hf|AT", "Explicit width of the video player (overrides size).", "o|2h|bx|1Hh|bz", "Named size preset for the video player.", "o|Bi|uB|1Hj|43|xE|xP|3y", "Aspect ratio (width / height) for the video player.", "16 / 9", "o|33|xR|1Hl|1Hm|1p", "How to size the video player.", "o|Bi|xU|1Ho|AT|xW|xb|3y", "Horizontal alignment of the video within its container.", "Center the video horizontally.", "o|3s|5b|1Hr", "Align the video to the left edge.", "o|3s|5h|1Ht", "Align the video to the right edge.", "o|3s|5i|1Hv", "a|1Hs|1Hu|1Hw", "o|Bi|xd|1Hq|5b|xf|1Hx|3y", "youtube", "YouTube video ID to embed.", "o|33|1Hz|1I0||1T", "URL of the video source.", "o|33|1Fc|1I2||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Hi|1Hk|1Hn|1Hp|1Hy|1I1|1I3", "o|3L|xU|1T|2p|1Ho|3M", "o|3L|xd|1T|2p|1Hq|3M", "o|3L|1Hz|1T|2p|1I0|3M", "o|3L|1Fc|1T|2p|1I2|3M", "A short accessibility description of the video.", "o|3Q|dd|1T|2p|1I9", "The size of the video player.", "o|3Q|uB|1T|2p|1IB", "The display width of the video player.", "o|3Q|bx|bz|2p|1ID", "The aspect ratio (width / height) of the video player.", "o|3Q|xR|1p|2p|1IF", "state", "The video's current playback state (e.g. playing, paused).", "o|3Q|1IH|1T|2p|1II", "time", "The current playback time in seconds.", "o|3Q|1IK|1p|2p|1IL", "duration", "The total duration of the video in seconds.", "o|3Q|1IN|1p|2p|1IO", "secondsWatched", "Total seconds the viewer has watched.", "o|3Q|1IQ|1p|2p|1IR", "fractionWatched", "Fraction of the video the viewer has watched (0 to 1).", "o|3Q|1IT|1p|2p|1IU", "a|3N|3O|3P|1I5|1I6|1I7|1I8|3T|3U|3V|3W|3Z|1IA|1IC|1IE|1IG|1IJ|1IM|1IP|1IS|1IV", "Embeds a video player", "o|F|9D|1FH|1FI|9X|1I4|1IW|3M|2p|2p|9D|1IX|AT", "a|G|1z|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "0111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Whether the hint is currently open (revealed).", "o|3Q|M7|1V|2p|1Ib", "The hint's title text.", "o|3Q|G|1T|2p|1Id", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Ic|1Ie", "Hint shown on demand to help with an exercise", "o|F|9E|1IZ|1Ia|9X|3I|1If|3M|3M|2p|9E|1Ig|AT", "The formatted value rendered as a text string.", "o|3Q|1T|1T|2p|1Ii", "The numeric value with thousands separators.", "o|3Q|3a|2B|2p|1Ik", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Ij|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1Il", "Renders a numeric value with thousands separators (e.g. 1,000,000)", "o|F|2B|fq|fr|3l|Jc|1Im|3M|3M|2p|2B|1In|3h", "pluralForm", "Custom plural form to use (overrides automatic pluralization).", "o|33|1Ip|1Iq||1T", "basedOnNumber", "Number that determines whether to use the singular or plural form.", "o|33|1Is|1It||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63|1Ir|1Iu", "o|3L|1Ip|1T|2p|1Iq|3M", "o|3L|1Is|1p|2p|1It|3M", "The selected word as a text string.", "o|3Q|1T|1T|2p|1Iy", "The selected (singular or plural) word.", "o|3Q|3a|1T|2p|1J0", "a|3N|3O|3P|Jd|6I|Je|6K|1Iw|1Ix|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Iz|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1J1", "Renders a word in its singular or plural form based on a count", "o|F|2C|fq|fr|3l|1Iv|1J2|3M|3M|2p|2C|1J3|3h", "Boolean expression; the feedback is shown when the condition is true.", "o|Ap|Aq|1J5|2s|1V", "updateWith", "References whose changes trigger re-evaluation of the feedback.", "o|2h|1J7|1J8|3D", "a|2j|2w|2z|32|37|3A|3E|3H|1J6|1J9", "a|3O|3P|3T|3U|3V|3W|3Z", "Targeted feedback shown when conditions are met", "o|F|9F|9U|9V|9X|1JA|1JB|3M|3M|2p|9F|1JC|AT", "Marks its children as response components for an enclosing answer", "o|F|pI|9U|9V|Ao|3I|Aa|2p|3M|2p|pI|1JE|Az", "A single conditional branch within `<conditionalContent>`", "o|F|19h|9U|9V|Ao|At|Ax|2p|3M|2p|19h|1JG|Az", "minSentencesPerParagraph", "Minimum number of sentences per generated paragraph.", "o|33|1JI|1JJ|13F|1p", "maxSentencesPerParagraph", "Maximum number of sentences per generated paragraph.", "n|8", "o|33|1JL|1JM|1JN|1p", "minWordsPerSentence", "Minimum number of words per generated sentence.", "o|33|1JP|1JQ|13F|1p", "maxWordsPerSentence", "Maximum number of words per generated sentence.", "o|33|1JS|1JT|1JN|1p", "generateWords", "Number of words of lorem-ipsum to generate.", "o|33|1JV|1JW||1p", "generateSentences", "Number of sentences of lorem-ipsum to generate.", "o|33|1JY|1JZ||1p", "generateParagraphs", "Number of paragraphs of lorem-ipsum to generate.", "o|33|1Jb|1Jc||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1JK|1JO|1JR|1JU|1JX|1Ja|1Jd", "o|3L|1JI|1p|2p|1JJ|3M", "o|3L|1JL|1p|2p|1JM|3M", "o|3L|1JP|1p|2p|1JQ|3M", "o|3L|1JS|1p|2p|1JT|3M", "a|3N|3O|3P|1Jf|1Jg|1Jh|1Ji|3Z", "Generates lorem ipsum placeholder text", "o|F|2D|54|AZ|g0|1Je|1Jj|3M|2p|2p|2D|1Jk|Az", "Reference to the state variable that will be updated.", "o|2h|1BJ|1Jm|3D", "Component type used to interpret the new value.", "a|1X|1p|1V|1T", "Treat the new value as a math expression.", "o|3s|1X|1Jq", "Treat the new value as a number.", "o|3s|1p|1Js", "Treat the new value as a boolean.", "o|3s|1V|1Ju", "Treat the new value as text.", "o|3s|1T|1Jw", "a|1Jr|1Jt|1Jv|1Jx", "o|HC|2g|1Jo|1Jp|1Jy|3y", "newValue", "New value to assign to the target.", "o|2h|1K0|1K1|11r", "Whether the update button can be dragged on a graph.", "o|2m|5L|1K3|3M|2s|1V", "triggerWhen", "Boolean expression that fires the action whenever it transitions to true.", "triggering", "o|4d|1K5|1K6|1K7|2p|2s|1V", "a|3|2f|4N|2g", "triggerWith", "References to components whose value changes should fire this action.", "o|1K9|1KA|1KB|1K7|3D", "triggerWhenObjectsClicked", "References to components whose click events should fire this action.", "o|1K9|1KD|1KE|1K7|3D", "triggerWhenObjectsFocused", "References to components whose focus events should fire this action.", "o|1K9|1KG|1KH|1K7|3D", "Level of simplification applied to the new value.", "Fully simplify the new value.", "o|3s|43|1KK", "a|49|1KL|4D|4F|4H", "o|Bi|40|1KJ|42|47|1KM|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Jn|1Jz|1K2|1K4|5X|63|GH|1K8|1KC|1KF|1KI|1KN", "o|3L|5L|1V|2p|1K3|3M", "o|3L|40|1T|2p|1KJ|3M", "a|3N|3O|3P|1KP|6K|Hd|1KQ|3T|3U|3V|3W|3Z|Hk|6W", "Updates one or more state variables on a target component", "o|F|2E|Om|On|3l|1KO|1KR|3M|2p|2p|2E|1KS|3h", "a|I|J|1z|2S|G|H|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1110111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Reference to the component whose action will be invoked.", "o|2h|1BJ|1KW|3D", "actionName", "Name of the action to invoke on the target component.", "o|33|1KY|1KZ||1T", "Whether the action button can be dragged on a graph.", "o|2m|5L|1Kb|3M|2s|1V", "Numeric arguments passed to the invoked action.", "o|2h|44|1Kd|1a", "Numeric argument passed to the invoked action.", "o|2h|1p|1Kf|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1KX|1Ka|1Kc|GH|5X|63|1K8|1KC|1KF|1KI|1Ke|1Kg", "o|3L|1KY|1T|2p|1KZ|3M", "o|3L|5L|1V|2p|1Kb|3M", "a|3N|3O|3P|1Ki|1Kj|Hd|6K|3T|3U|3V|3W|3Z|Hk|6W", "Triggers an action when clicked or in response to a specified user interaction", "o|F|2F|1KU|1KV|3l|1Kh|1Kk|3M|3M|2p|2F|1Kl|3h", "a|1z|2E|2F|I|J|2S", "200110", "Whether the trigger set's button can be dragged on a graph.", "o|2m|5L|1Kp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Kq|5X|63|GH|1K8|1KC|1KF|1KI", "o|3L|5L|1V|2p|1Kp|3M", "a|3N|3O|3P|1Ks|6K|Hd|3T|3U|3V|3W|3Z|Hk|6W", "Groups a set of `<updateValue>` or `<callAction>` components which share a single trigger condition", "o|F|2G|1Kn|1Ko|3l|1Kr|1Kt|3M|2p|2p|2G|1Ku|3h", "numIterates", "Number of iterations to compute.", "o|33|1Kw|1Kx|5Q|1q", "Starting value passed to the function on the first iteration.", "o|33|12Q|1Kz|5J|1X", "The function to iterate.", "o|2h|1r|1L1|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ky|1C7|1C9|1L0|1L2|H8|4Y|4c|4g|4j", "o|3L|1Kw|1q|2p|1Kx|3M", "Number of dimensions of each iterate.", "o|3Q|6r|1q|2p|1L5", "allIterates", "All computed iterates of the function.", "o|3Q|1L7|1Y|2p|1L8", "allIteratesWithInitial", "All iterates including the initial value.", "o|3Q|1LA|1Y|2p|1LB", "iterates", "The list of iterate values.", "o|6v|1LD|1X|3M|1LE|36|75", "finalIterate", "The last iterate value.", "o|3Q|1LG|1X|2p|1LH", "a|3N|3O|3P|1L4|1CH|1CI|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1L6|1L9|1LC|1LF|1LI", "List of values produced by iterating a function", "o|F|2H|54|AZ|3l|1L3|1LJ|3M|2p|2p|2H|1LK|3h", "a|2j|2t|2w|2z|32|1B3|3E|3H|1B6|1B9|1BB|1BD", "a|3N|1BF|3Z", "A reusable group with parameterized attributes; can be copied elsewhere with new parameter values", "o|F|2I|9U|9V|g0|1LM|1LN|3M|3M|2p|2I|1LO|Az", "Declares attributes accepted by an enclosing `<module>`", "o|F|9G|9U|9V|g0|3I|125|3M|3M|2p|9G|1LQ|Az", "a|Ks|1z|Kt|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "010111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Container for components used for setup but not rendered", "o|F|9H|1LS|1LT|g0|3I|125|3M|3M|2p|9H|1LU|Az", "The footnote's body as plain text.", "o|3Q|1T|1T|2p|1LW", "footnoteTag", "The auto-generated marker (number) used to reference this footnote.", "o|3Q|1LY|1T|2p|1LZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1LX|1La", "Inline footnote whose body is shown on demand and is auto-numbered in the document", "o|F|2J|2Z|2a|3l|3I|1Lb|3M|3M|2p|2J|1Lc|3h", "The caption rendered as a plain text string.", "o|3Q|1T|1T|2p|1Le", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Lf", "A caption attached to a figure or table", "o|F|9I|fL|fM|9X|3I|1Lg|3M|3M|2p|9I|1Lh|AT", "Whether the endpoint is open (excluded) rather than closed (included).", "o|2m|M7|1Lj|2p|2s|1V", "Whether the user can toggle the endpoint between open and closed by clicking it.", "o|2m|Ss|1Ll|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|1Lk|1Lm", "o|3L|M7|1V|2p|1Lj|3M", "o|3L|Ss|1V|2p|1Ll|3M", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|1Lo|1Lp|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point that marks the endpoint of an interval, rendered open or closed", "o|F|2K|RR|RS|Op|1Ln|1Lq|3M|3M|2p|2K|1Lr|Az", "sortVectorsBy", "Whether to sort vectors by component or by magnitude.", "a|na|ng", "Sort vectors by their displacement components.", "o|3s|na|1Lw", "Sort vectors by the position of their tail point.", "o|3s|ng|1Ly", "a|1Lx|1Lz", "o|Bi|1Lt|1Lu|na|1Lv|1M0|3y", "sortByComponent", "Index of the component to sort by (when sorting vectors).", "o|33|1M2|1M3|oX|1q", "sortByProp", 'Name of a property to sort by (e.g. "x" for sorting points by x-coordinate).', "o|2h|1M5|1M6|1T", "Component type to sort children as.", "o|2h|2g|1M8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1M1|1M4|1M7|1M9|gB", "o|3L|1Lt|1T|2p|1Lu|3M", "o|3L|1M2|1q|2p|1M3|3M", "a|3N|3O|3P|1MB|1MC|3Z", "Sorts a list according to a comparison function", "o|F|2L|9U|9V|g0|1MA|1MD|3M|3M|3M|2L|1ME|Az", "Component type to shuffle children as.", "o|2h|2g|1MG|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MH|gB", "Randomly shuffles its children", "o|F|2M|9U|9V|g0|1MI|125|3M|3M|3M|2M|1MJ|Az", "Names of the variables to solve for.", "o|2h|Gx|1ML|Gz", "Number of points used when searching for solutions numerically.", "o|33|Vo|1MN|12N|1p", "minVar", "Lower bound of the variable's search range.", "o|33|1MP|1MQ||1p", "maxVar", "Upper bound of the variable's search range.", "o|33|1MS|1MT||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MM|1MO|1MR|1MU", "o|3L|Vo|1p|2p|1MN|3M", "The variables of the equations.", "o|6v|Gx|H3|3M|1MX|36|I7", "numSolutions", "The number of numerical solutions found.", "o|3Q|1MZ|1q|2p|1Ma", "solutions", "The numerical solutions of the equations.", "o|6v|1Mc|1X|3M|1Md|36|75", "The first variable being solved for.", "o|3Q|H1|H3|2p|1Mf", "a|3N|3O|3P|1MW|3T|3U|3V|3W|3Z|1MY|1Mb|1Me|1Mg", "Numerically solves a system of equations", "o|F|2N|3j|3k|3l|1MV|1Mh|3M|3M|2p|2N|1Mi|3h", "Variable name displayed on the number line.", "o|33|H1|1Mk|Pw|H3", "Input format used for parsing entered subsets.", "Parse entered subsets as plain-text notation.", "o|3s|1T|1Mn", "Parse entered subsets as LaTeX notation.", "o|3s|2V|1Mp", "a|1Mo|1Mq", "o|Bi|3p|1Mm|1T|3r|1Mr|3y", "Initial subset displayed in the input.", "o|33|Zj|1Mt|AZ|1T", "o|2h|e9|eA|2O", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ml|1Ms|1Mu|1Mv", "o|3L|H1|H3|2p|1Mk|3M", "o|3L|3p|1T|2p|1Mm|3M", "o|3L|Zj|1T|2p|1Mt|3M", "subsetValue", "The current subset of the reals entered by the user.", "o|3Q|1N0|2O|2p|1N1", "The boundary points that delimit the subset.", "o|6v|UQ|1X|3M|1N3|36|75", "pointsClosed", "Whether each boundary point of the subset is a closed (included) endpoint.", "o|6v|1N5|1V|3M|1N6|36|Qq", "intervals", "The intervals (non-degenerate components) of the subset.", "o|6v|1N8|1X|3M|1N9|36|75", "isolatedPoints", "The isolated (non-interval) points of the subset.", "o|6v|1NB|1X|3M|1NC|36|75", "a|3N|3O|3P|1Mx|1My|1Mz|3T|3U|3V|3W|3Z|1N2|1N4|1N7|1NA|1ND", "An interactive number-line widget for entering a subset of real numbers (block-level; does not inherit from Input)", "o|F|9J|54|AZ|9X|1Mw|1NE|3M|2p|2p|9J|1NF|AT", "o|2m|4t|4u|3M|2s|1V", "Name of the variable used when expressing the subset.", "o|33|H1|1NI|Pw|H3", "How the subset is displayed.", "inequalities", "a|1N8|1NL", "Display the subset using interval notation (e.g., `(0, 1]`).", "o|3s|1N8|1NN", "Display the subset using inequalities (e.g., `0 < x ≤ 1`).", "o|3s|1NL|1NP", "a|1NO|1NQ", "o|Bi|xU|1NK|1N8|1NM|1NR|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|1NH|51|55|58|5B|5E|5K|5N|5R|5X|63|1NJ|1NS", "o|3L|xU|1T|2p|1NK|3M", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1NU|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1N4|1N7|1NA|1ND|7S|7V|7Y|7b", "A subset of the real numbers, defined by intervals and points", "o|F|2O|3j|3k|3l|1NT|1NV|3M|3M|2p|2O|1NW|3h", "Type of value being split.", "a|1T", "Split text values.", "o|3s|1T|1Na", "a|1Nb", "o|HC|2g|1NY|1NZ|1Nc|3y", "splitBy", "How to break the input string into pieces.", "letter", "word", "comma", "a|1Ng|1Nh|1Ni", "Split into individual characters.", "o|3s|1Ng|1Nk", "Split into whitespace-separated words.", "o|3s|1Nh|1Nm", "Split on comma boundaries.", "o|3s|1Ni|1No", "a|1Nl|1Nn|1Np", "o|Bi|1Ne|1Nf|1Ng|1Nj|1Nq|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Nd|1Nr|gB", "Splits a string or list into pieces", "o|F|2P|9U|9V|g0|1Ns|125|3M|3M|2p|2P|1Nt|Az", "data", "The data points to fit a line to.", "o|2h|1Nv|1Nw|2W", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|1Nx", "Number of dimensions of the line (always 2 for a best-fit line).", "o|3Q|6r|1p|2p|1Nz", "Whether the line can be dragged (always false for a best-fit line).", "o|3Q|5L|1V|2p|1O1", "The data points used to compute the best-fit line.", "o|6v|1Nv|1X|3M|1O3|4X|IM", "a|3N|3O|3P|Hd|QD|7s|QE|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|1O0|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up|1O2|1O4", "The best-fit line for a set of points", "o|F|2Q|Om|On|Op|1Ny|1O5|3M|2p|2p|2Q|1O6|Az", "boundaryValues", "Boundary values defining the region's left/right edges.", "a|5Q|36", "o|33|1O8|1O9|1OA|1a", "The function whose graph bounds the region.", "o|2h|1r|1OC|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OB|1OD", "o|3L|1O8|1a|2p|1O9|3M", "A textual description of the region's style.", "o|3Q|Hl|1T|2p|1OG", 'Style description including the word "region".', "o|3Q|Ho|1T|2p|1OI", "a|3N|3O|3P|Hd|QD|7s|QE|1OF|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between a curve and the x-axis", "o|F|9K|Om|On|Op|1OE|1OK|3M|2p|2p|9K|1OL|Az", "a|I|J|1z|2S|w|x|y|1r|1s", "112011101", "Boundary values defining the region's edges.", "o|33|1O8|1OP|1OA|1a", "flipFunctions", "Whether to swap the role of x and y for the input functions.", "o|2m|1OR|1OS|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OQ|1OT", "o|3L|1O8|1a|2p|1OP|3M", "o|3L|1OR|1V|2p|1OS|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1OV|1OW|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between two curves", "o|F|9L|1ON|1OO|Op|1OU|1OX|3M|2p|2p|9L|1OY|Az", "Whether the half-plane extends horizontally, bounded by the vertical line x = boundaryValue. If false, the half-plane extends vertically, bounded by the horizontal line y = boundaryValue.", "o|2m|V3|1Oa|3M|2s|1V", "boundaryValue", "Position of the bounding line: x = boundaryValue when horizontal is true, y = boundaryValue when horizontal is false.", "o|33|1Oc|1Od|5Q|1p", "greaterThan", "Whether the region is the side where the inequality is greater than the boundary.", "o|2m|1Of|1Og|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Ob|1Oe|1Oh", "o|3L|V3|1V|2p|1Oa|3M", "o|3L|1Oc|1p|2p|1Od|3M", "o|3L|1Of|1V|2p|1Og|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Oj|1Ok|1Ol|3T|3U|3V|3W|3Z|Hk", "A half-plane region bounded by a line", "o|F|9M|Om|On|Op|1Oi|1Om|3M|2p|2p|9M|1On|Az", "Initial code shown in the editor before the user types.", "o|33|Zj|1Op|AZ|1T", 'Editor width (e.g. "100%" or "600px").', "100", "o|uD|1Os|2p", "o|33|bx|1Or|1Ot|bz", 'Editor height (e.g. "500px").', "n|6S", "o|uD|1Ow|3M", "o|33|k5|1Ov|1Ox|bz", "viewerRatio", "Fraction of the editor area allotted to the live viewer.", "o|2h|1Oz|1P0|1p", "showResults", "Whether to render the results panel alongside the editor.", "o|2m|1P2|1P3|2p|2s|1V", "showFormatter", "Whether to show a code formatter button.", "o|2m|1P5|1P6|2p|2s|1V", "resultsLocation", "Position of the results panel relative to the editor.", "a|5g|5h|5i", "Place the results panel below the editor.", "o|3s|5g|1PB", "Place the results panel to the left of the editor.", "o|3s|5h|1PD", "Place the results panel to the right of the editor.", "o|3s|5i|1PF", "a|1PC|1PE|1PG", "o|Bi|1P8|1P9|5g|1PA|1PH|3y", "readOnly", "Whether the editor is read-only.", "o|2m|1PJ|1PK|2p|2s|1V", "initialOpenTab", "Which diagnostics/responses tab to open initially.", "first", "errors", "warnings", "info", "accessibility", "responses", "help", "a|42|1PO|1PP|1PQ|1PR|1PS|1PT|1PU", "Panel starts closed.", "o|3s|42|1PW", "Open the first available tab.", "o|3s|1PO|1PY", "Open the errors tab.", "o|3s|1PP|1Pa", "Open the warnings tab.", "o|3s|1PQ|1Pc", "Open the info tab.", "o|3s|1PR|1Pe", "Open the accessibility tab.", "o|3s|1PS|1Pg", "Open the responses tab.", "o|3s|1PT|1Pi", "Open the help tab.", "o|3s|1PU|1Pk", "a|1PX|1PZ|1Pb|1Pd|1Pf|1Ph|1Pj|1Pl", "o|Bi|1PM|1PN|1PO|1PV|1Pm|3y", "renderedName", "Name to assign to the dynamically-rendered DoenetML output.", "o|2h|1Po|1Pp|1T", "staticName", "Name to assign to the static DoenetML source.", "o|2h|1Pr|1Ps|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Oq|u5|1Ou|1Oy|1P1|1P4|1P7|1PI|1PL|1Pn|1Pq|1Pt", "o|3L|Zj|1T|2p|1Op|3M", "o|3L|bx|bz|2p|1Or|3M", "o|3L|k5|bz|2p|1Ov|3M", "o|3L|1P2|1V|2p|1P3|3M", "o|3L|1P5|1V|2p|1P6|3M", "o|3L|1P8|1T|2p|1P9|3M", "o|3L|1PJ|1V|2p|1PK|3M", "o|3L|1PM|1T|2p|1PN|3M", "The code value of the input.", "o|3Q|3a|1T|2p|1Q3", "The code value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|1Q5", "The current code as a plain text string.", "o|3Q|1T|1T|2p|1Q7", "a|3N|3O|3P|1Pv|1Pw|1Px|1Py|1Pz|1Q0|1Q1|1Q2|3T|3U|3V|3W|3Z|eV|eY|1Q4|1Q6|1Q8", "An interactive DoenetML code editor", "o|F|9N|9U|9V|9X|1Pu|1Q9|3M|3M|2p|9N|1QA|AT", "Variable used when comparing factored expressions.", "o|33|H1|1QC|Pw|H3", "restrictDivision", "Whether to disallow dividing through to match factored forms.", "o|2m|1QE|1QF|2p|2s|1V", "monomialFactorMustMatch", "Whether monomial factors must match exactly (implies restrictDivision).", "o|2m|1QH|1QI|2p|2s|1V", "allowOnlySignDifferences", "Whether to count factorizations as equivalent when they differ only by sign.", "o|2m|1QK|1QL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1QD|1QG|1QJ|1QM", "Whether the input math expressions share the same factoring.", "o|3Q|3a|1V|2p|1QO", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|1QP|CW", "Boolean condition that tests for equivalent factoring", "o|F|2R|3j|3k|3l|1QN|1QQ|3M|2p|2p|2R|1QR|3h", "position", "Position of the legend on the graph.", "a|5c|5d|5e|5f", "Place the legend in the upper-right corner.", "o|3s|5c|1QW", "Place the legend in the upper-left corner.", "o|3s|5d|1QY", "Place the legend in the lower-right corner.", "o|3s|5e|1Qa", "Place the legend in the lower-left corner.", "o|3s|5f|1Qc", "a|1QX|1QZ|1Qb|1Qd", "o|Bi|1QT|1QU|5c|1QV|1Qe|3y", "displayClosedSwatches", "Whether to render closed/filled swatches in the legend.", "o|2m|1Qg|1Qh|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Qf|1Qi", "o|3L|1QT|1T|2p|1QU|3M", "o|3L|1Qg|1V|2p|1Qh|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Qk|1Ql|3T|3U|3V|3W|3Z|Hk", "A legend describing the contents of a graph", "o|F|9O|Om|On|Op|1Qj|1Qm|3M|2p|2p|9O|1Qn|Az", "o|3Q|3a|2S|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|1Qp", "A label for an input, answer, button, or graphical object", "o|F|2S|2Z|2a|3l|7q|1Qq|3M|3M|2p|2S|1Qr|3h", "pattern", "Math expression pattern to match against.", "o|2h|1Qt|1Qu|1X", "allowImplicitIdentities", "Whether to allow implicit identity transformations when matching.", "o|2m|1Qw|1Qx|2p|2s|1V", "allowPermutations", "Whether to allow permutations of operands when matching.", "o|2m|1Qz|1R0|3M|2s|1V", "requireNumericMatches", "Whether numeric placeholders must match numbers.", "o|2m|1R2|1R3|2p|2s|1V", "requireVariableMatches", "Whether variable placeholders must match variables.", "o|2m|1R5|1R6|2p|2s|1V", "excludeMatches", "Patterns whose matches are excluded.", "o|33|1R8|1R9|54|1Y", "matchExpressionWithBlanks", "Whether to allow expressions with blanks to match.", "o|2m|1RB|1RC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1Qv|1Qy|1R1|1R4|1R7|1RA|1RD", "o|3L|1Qw|1V|2p|1Qx|3M", "o|3L|1Qz|1V|2p|1R0|3M", "o|3L|1R2|1V|2p|1R3|3M", "o|3L|1R5|1V|2p|1R6|3M", "o|3L|1R8|1Y|2p|1R9|3M", "o|3L|1RB|1V|2p|1RC|3M", "Whether the input matches the pattern.", "o|3Q|3a|1V|2p|1RL", "numMatches", "The number of matches found.", "o|3Q|1RN|1p|2p|1RO", "patternMatches", "The list of matched sub-expressions.", "o|6v|1RQ|1X|3M|1RR|36|75", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|1RF|1RG|1RH|1RI|1RJ|1RK|3T|3U|3V|3W|3Z|1RM|CW|1RP|1RS", "Boolean condition that tests whether input matches a math pattern", "o|F|2T|3j|3k|3l|1RE|1RT|3M|3M|2p|2T|1RU|3h", "childContextHelp", "a|3|4|5|6|7|8|9|A|B|C|D|E|1RW", "a|93|1z|94", "020", "Value used for entries that aren't explicitly specified.", "o|33|e0|1Ra|Ng|1X", "Number of rows in the matrix.", "o|2h|7A|1Rc|1q", "Number of columns in the matrix.", "o|2h|7D|1Re|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Rb|1Rd|1Rf", "Whether matrix entries should be treated as unordered.", "o|3Q|4n|1V|2p|1Rh", "o|3Q|3a|2U|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1Ri|1Rj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A matrix of math values", "a|93|94", "matrixRow", "matrixColumn", "o|1Rm|1Rn|1Ro", "o|1RX|2U|1RY|1RZ|3l|1Rg|1Rk|3M|2p|2p|2U|1Rl|3h|1Rp", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j", "numEigenvectors", "The number of eigenvectors found in the decomposition.", "o|3Q|1Rs|1q|2p|1Rt", "eigenvalues", "The eigenvalues of the matrix.", "o|6v|1Rv|1p|3M|1Rw|36|IR", "eigenvectors", "The eigenvectors of the matrix, as a 2D array (one column per eigenvalue).", "a|X0|6y", "o|Qc|1Ry|1p|3M|1Rz|4X|1S0|Qf", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1Ru|1Rx|1S1", "Computes the eigenvalues and eigenvectors of a square matrix", "o|F|9P|3j|3k|Ao|1Rr|1S2|3M|2p|2p|9P|1S3|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19|w|x|y|1J|1K|1N|1R|1S|1d|1f|1h|1i|1k|1r|1s|2K|2Q|2W|2Y|O|P", "1220111222222222111111111111111111111112210222022212221222212222211121222112111111111111111111222222222222222222201", "o|2m|JZ|Ja|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|1S7|5X|63", "o|3Q|3a|2V|2p|fs", "The LaTeX content as a string.", "o|3Q|2V|2V|2p|1SA", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1S9|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1SB", "A snippet of LaTeX that can be rendered as math", "o|F|2V|1S5|1S6|3l|1S8|1SC|3M|3M|2p|2V|1SD|3h", "A block-level quotation", "o|F|9Q|9U|9V|9X|3I|Aa|3M|3M|2p|9Q|1SF|AT", "Extra information about an enclosing component, shown to all users in a popup or disclosure", "o|F|2f|9U|9V|9X|3I|Aa|2p|3M|2p|2f|1SH|AT", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "112022222222222222222222222222111122222121111111111111222222122222222122221111121222", "Whether the snapping threshold is interpreted relative to graph scales.", "o|2m|194|1SL|2p|2s|1V", "Distance threshold within which group members snap together.", "o|2h|E6|1SN|1p", "angleThreshold", "Angular distance within which group members snap together.", "n|0.:7C4pdy2qXy", "o|33|1SP|1SQ|1SR|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1SM|1SO|1SS", "o|3L|194|1V|2p|1SL|3M", "o|3L|1SP|1p|2p|1SQ|3M", "Distance within which group members attract each other.", "o|3Q|E6|1p|2p|1SW", "a|3N|3O|3P|Hd|QD|7s|QE|1SU|1SV|3T|3U|3V|3W|3Z|Hk|T4|1SX", "Constrains group members to attract to each other when nearby", "o|F|9R|1SJ|1SK|Op|1ST|1SY|3M|2p|2p|9R|1SZ|Az", "a|8J", "_blockScoredComponent", "a|1Sc|9W|2d", "maxNumColumns", "Maximum number of columns when arranging child problems.", "o|33|1Se|1Sf|4X|1q", "mode", "Arrangement mode for the child problems.", "circuit", "a|9S|1Sj", "Interleaved arrangement where each problem's answer feeds the next and one can start with any problem.", "o|3s|9S|1Sl", "A variant of the pretzel where one must start with the first problem.", "o|3s|1Sj|1Sn", "a|1Sm|1So", "o|Bi|1Sh|1Si|9S|1Sk|1Sp|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|1Sg|1Sq", "o|3L|1Se|1q|2p|1Sf|3M", "o|3L|1Sh|1T|2p|1Si|3M", "numProblems", "The number of child problems.", "o|3Q|1Su|1q|2p|1Sv", "The current responses across all child problems.", "o|6v|re|1T|3M|1Sx|36|Jt", "The number of responses submitted.", "o|3Q|rk|1p|2p|1Sz", "The most recently submitted responses.", "o|6v|rn|1T|3M|1T1|36|Jt", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|1Ss|1St|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|1Sw|1Sy|1T0|1T2", "A response-matching component where students enter a sequence to match statements and answers", "o|F|9S|1Sb|Nf|1Sd|1Sr|1T3|3M|2p|2p|9S|1T4|AT", "o|2m|L8|L9|3M|2s|1V", "hideFutureSections", "Whether to hide later cascade sections until previous ones are completed.", "o|2m|1T7|1T8|2p|2s|1V", "revealAll", "Whether all cascade entries should be revealed regardless of progress.", "o|2m|1TA|1TB|2p|2s|1V", "boxAll", "Whether to draw boxes around all cascade entries regardless of progress.", "o|2m|1TD|1TE|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|1T6|LD|LG|LI|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|1T9|1TC|1TF", "o|3L|1T7|1V|2p|1T8|3M", "o|3Q|20|1V|2p|LH", "numCompleted", "The number of cascade sections currently completed.", "o|3Q|1TJ|1q|2p|1TK", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Ly|1TH|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9|1TI|1TL", "Sectional component that reveals its children step-by-step", "o|F|9T|Ku|Kv|N8|1TG|1TM|3M|3M|2p|9T|1TN|AT", "The short description text.", "o|3Q|3a|dd|2p|1TP", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1TQ|3e", "A short accessibility description (e.g. for a `<graph>`) read by screen readers", "o|F|dd|2Z|2a|2e|3I|1TR|2p|3M|2p|dd|1TS|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|1z|21|24|29|2A|2K|2O|2U|2W|2X|2Y|L|M|N|Q|w|x|y|z|1K|1L|1M|1N|1R|1S|1T|1U|1a|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2Q|2V", "1111111111111111111111111022012122212111122222222222222222222222222222222222222", "Whether the order of points in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1TW|2p|2s|1V", "Maximum number of points to retain in the list.", "o|33|g7|1TY|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1TX|1TZ|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1TY|3M", "The number of points in the list.", "o|3Q|Ps|1p|2p|1Tc", "o|3Q|gI|1p|2p|1Tc", "a|3N|3O|1Tb|3Z|gy|1Td|1Te", "A list of points", "o|F|2W|1TU|1TV|g0|1Ta|1Tf|3M|3M|2p|2W|1Tg|Az", "a|1t|1z|2X|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2Y", "0221222211111111111111111111112222222221222202222122222222222212222212222121222", "Whether the order of intervals in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1Tk|2p|2s|1V", "Maximum number of intervals to retain in the list.", "o|33|g7|1Tm|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1Tl|1Tn|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1Tm|3M", "numIntervals", "The number of intervals in the list.", "o|3Q|1Tq|1p|2p|1Tr", "o|3Q|gI|1p|2p|1Tr", "a|3N|3O|1Tp|3Z|gy|1Ts|1Tt", "A list of intervals", "o|F|2X|1Ti|1Tj|g0|1To|1Tu|3M|3M|2p|2X|1Tv|Az", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr", "a|3N|3O|n8|3Z|gy|nD|nE", "A list of vectors", "o|F|2Y|mh|mi|g0|1Tx|1Ty|3M|3M|2p|2Y|1Tz|Az", "a|3i|7e|84|88|AU|AW|AY|Ac|Ae|Am|B0|BD|BF|BL|BQ|BS|BX|Cb|Ck|Cm|Co|Cq|Cs|Cz|D1|DD|DT|DX|Dm|Dq|E5|EE|EJ|EN|ER|EV|EZ|Ed|Eh|Eq|Eu|Ey|F2|F6|FA|FE|FI|Fn|J9|JB|JU|K7|KE|KG|KI|KK|KM|KO|KQ|KS|KU|KW|Kd|Kf|Kh|Kj|Kl|Kn|Kp|Kr|MC|ME|MG|MK|MS|MW|Md|Mf|Mh|Mj|Ml|Mn|Mp|Mr|Mt|Mv|N7|ND|NF|NP|NR|NW|Ol|RI|TU|Us|Xe|Yf|Z8|ZQ|ZY|Zi|a4|aC|bu|cl|co|cq|cs|cu|cw|d1|dE|dc|eo|fK|fW|fY|fp|fw|gN|gP|gU|gf|gj|h7|h9|hJ|hW|hu|hy|i5|i9|if|j6|jC|jk|jp|kJ|lC|m1|mS|mW|mg|nH|oT|pH|s8|ss|t5|u0|uU|us|vp|wK|wm|wr|10d|10g|111|117|11J|11Q|11e|127|137|14Q|155|15d|15l|15v|16s|17B|17U|17k|17n|187|18X|18g|191|19B|19L|19P|19W|19Y|19g|19o|19v|1AG|1Ao|1B1|1BI|1C3|1CO|1D6|1DI|1Dm|1E2|1Ed|1FG|1Hg|1IY|1Ih|1Io|1J4|1JD|1JF|1JH|1Jl|1KT|1Km|1Kv|1LL|1LP|1LR|1LV|1Ld|1Li|1Ls|1MF|1MK|1Mj|1NG|1NX|1Nu|1O7|1OM|1OZ|1Oo|1QB|1QS|1Qo|1Qs|1RV|1Rq|1S4|1SE|1SG|1SI|1Sa|1T5|1TO|1TT|1Th|1Tw|1U0", "a|1Rn|1Ro", "displayName", "a|3|7|8|C|D|4|5|6|A|1U3|156", "row_matrix", "A list of math values defining the row of a matrix", "in a matrix", "o|1U4|1Rn|gw|h5|1U5|1U6|3j|3k|g0|3M|93|1U7", "column_matrix", "A list of math values defining the column of a matrix", "o|1U4|1Ro|gw|h5|1U9|1UA|3j|3k|g0|3M|94|1U7", "o|1U2|1U8|1UB", "o|2|1U1|1UC"], "1UD"]);
function isMathDefaultValue(val) {
  return typeof val === "object" && val !== null && val.type === "math" && typeof val.latex === "string";
}
function renderInlineMarkdown(text2) {
  return parseInlineMarkdown(text2).map((token, i2) => {
    switch (token.kind) {
      case "text":
        return token.text;
      case "code":
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: token.text }, i2);
      case "strong":
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx("strong", { children: token.text }, i2);
      case "em":
        return /* @__PURE__ */ jsxRuntimeExports$3.jsx("em", { children: token.text }, i2);
    }
  });
}
function renderElementName(elementName, docsSlug, docsBase) {
  const text2 = `<${elementName}>`;
  if (!docsSlug) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-element-name", children: text2 });
  }
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "a",
    {
      className: "help-element-name help-element-name-link",
      href: `${docsBase}/reference/${docsSlug}`,
      target: "_blank",
      rel: "noreferrer noopener",
      children: text2
    }
  );
}
const REFERENCES_DOC_PATH = "concepts/references";
function ReferencesDocLink({ docsBase }) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "a",
    {
      className: "help-docs-link",
      href: `${docsBase}/${REFERENCES_DOC_PATH}`,
      target: "_blank",
      rel: "noreferrer noopener",
      children: "Learn about references →"
    }
  );
}
function ContextHelpPanel({
  content: content2,
  docsURL
}) {
  const docsBase = docsURL.replace(/\/+$/, "");
  switch (content2.kind) {
    case "none":
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "help-panel help-panel-empty", children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-placeholder", children: [
        "Place cursor on a tag name, attribute, or",
        " ",
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: "$ref.property" }),
        " for documentation."
      ] }) });
    case "unsupportedRefChain":
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "help-panel help-panel-empty", children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-placeholder", children: [
        "Help for multi-part references like ",
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: "$a.b.c" }),
        " ",
        "is not yet supported."
      ] }) });
    case "unresolvedRef": {
      const { displayPath, reason } = content2;
      const ref = /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `$${displayPath}` });
      const sentence = reason === "notFound" ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        "No referent found for reference: ",
        ref,
        "."
      ] }) : reason === "multiple" ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        "Multiple referents found for reference: ",
        ref,
        "."
      ] }) : /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        "A referent for ",
        ref,
        " could not be determined."
      ] });
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "help-ref-sentence", children: sentence }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(ReferencesDocLink, { docsBase })
      ] });
    }
    case "suggestions": {
      const { context, suggested, totalAllowed, acceptsStringChildren } = content2;
      const location = "elementName" in context ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        "Inside ",
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `<${context.elementName}>` })
      ] }) : "At the top level";
      const headerSuffix = totalAllowed === 0 ? acceptsStringChildren ? " — type text here." : " — nothing goes here." : acceptsStringChildren ? " — type text here, or try:" : " — things to try:";
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-suggestions-header", children: [
          location,
          headerSuffix
        ] }),
        suggested.length > 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsx("ul", { className: "help-suggestions-list", children: suggested.map((s2) => /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          "li",
          {
            className: "help-suggestion-item",
            children: [
              renderElementName(
                s2.name,
                s2.docsSlug,
                docsBase
              ),
              s2.summary && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("span", { className: "help-suggestion-summary", children: [
                " — ",
                renderInlineMarkdown(s2.summary)
              ] })
            ]
          },
          s2.name
        )) }),
        totalAllowed > 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-suggestions-footer", children: [
          "Press ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: "Ctrl+Space" }),
          " to see all",
          " ",
          totalAllowed,
          " components."
        ] })
      ] });
    }
    case "element":
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-element-title", children: [
          renderElementName(
            content2.elementName,
            content2.docsSlug,
            docsBase
          ),
          " — ",
          renderInlineMarkdown(content2.summary)
        ] }),
        content2.styleBreakdown && renderStyleBreakdown(content2.styleBreakdown),
        content2.docsSlug && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          "a",
          {
            className: "help-docs-link",
            href: `${docsBase}/reference/${content2.docsSlug}`,
            target: "_blank",
            rel: "noreferrer noopener",
            children: "Reference page →"
          }
        )
      ] });
    case "refName": {
      const { displayPath, targetElementName, line: line2, derivedFrom } = content2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-ref-sentence", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `$${displayPath}` }),
          " is a reference to",
          " ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `<${targetElementName}>` }),
          line2 !== void 0 ? ` (line ${line2})` : "",
          "."
        ] }),
        derivedFrom && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-ref-derived", children: [
          "Introduced by",
          " ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `<${derivedFrom.ownerElementName}>` }),
          derivedFrom.ownerLine !== void 0 ? ` on line ${derivedFrom.ownerLine}` : "",
          " ",
          "as ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: derivedFrom.role }),
          "."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(ReferencesDocLink, { docsBase })
      ] });
    }
    case "attribute": {
      const {
        elementName,
        attributeName,
        description,
        docsSlug,
        allowedValues,
        allowedValuesArePerItem,
        defaultValue: defaultValue2,
        activeDefault,
        styleBreakdown,
        functionNamesBreakdown
      } = content2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-title", children: [
          renderElementName(elementName, docsSlug, docsBase),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-kind-label", children: "attribute" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-attribute-name", children: attributeName })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "help-description", children: renderInlineMarkdown(description) }),
        defaultValue2 !== void 0 && defaultValue2 !== null && // An empty-array default (e.g. `additionalFunctionNames`,
        // `removedFunctionNames`) would render as just
        // "Default:" with no value, which is noise — suppress
        // the row entirely.
        !(Array.isArray(defaultValue2) && defaultValue2.length === 0) && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: "Default:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "help-values-list", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-value-item", children: formatValue(defaultValue2) }) })
        ] }),
        activeDefault && // Separate row from "Default:" so the author can tell
        // the static schema fallback from the live inherited
        // value (#1198).
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: "Active default:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-values-list", children: [
            renderActiveDefaultValue(activeDefault),
            /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-annotation", children: ` (styleNumber ${activeDefault.styleNumber})` })
          ] })
        ] }),
        styleBreakdown && renderStyleBreakdown(styleBreakdown),
        functionNamesBreakdown && renderFunctionNamesBreakdown(functionNamesBreakdown),
        allowedValues && allowedValues.length > 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail help-allowed-values", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: allowedValuesArePerItem ? "Allowed values (one per item):" : "Allowed values:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("dl", { className: "help-allowed-values-list", children: allowedValues.map(
            ({ value, description: description2 }, idx) => /* @__PURE__ */ jsxRuntimeExports$3.jsxs(React__default.Fragment, { children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx("dt", { className: "help-value-item", children: formatValue(value) }),
              /* @__PURE__ */ jsxRuntimeExports$3.jsx("dd", { className: "help-value-description", children: renderInlineMarkdown(
                description2
              ) })
            ] }, idx)
          ) })
        ] }),
        docsSlug && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          "a",
          {
            className: "help-docs-link",
            href: `${docsBase}/reference/${docsSlug}`,
            target: "_blank",
            rel: "noreferrer noopener",
            children: "Reference page →"
          }
        )
      ] });
    }
    case "snippet": {
      const { snippetKey, elementName, description, snippetText } = content2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-title", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-kind-label", children: "snippet" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-snippet-name", children: snippetKey })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "help-description", children: description }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: "Inserts:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-value", children: `<${elementName}>` })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("pre", { className: "help-snippet-preview", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: snippetText }) })
      ] });
    }
    case "arrayEntry": {
      const {
        elementName,
        aliasPath,
        displayTail,
        description,
        leafType,
        docsSlug
      } = content2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-title", children: [
          renderElementName(elementName, docsSlug, docsBase),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-kind-label", children: "array entry" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-property-name", children: displayTail })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "help-description", children: renderInlineMarkdown(description) }),
        aliasPath.length > 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: aliasPath.length === 1 ? "Coordinate:" : "Coordinates:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-value", children: aliasPath.join(", ") })
        ] }),
        leafType && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: "Type:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-value", children: `<${leafType}>` })
        ] }),
        docsSlug && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          "a",
          {
            className: "help-docs-link",
            href: `${docsBase}/reference/${docsSlug}`,
            target: "_blank",
            rel: "noreferrer noopener",
            children: "Reference page →"
          }
        )
      ] });
    }
    case "property": {
      const {
        elementName,
        propertyName: propertyName2,
        description,
        displayPath,
        line: line2,
        type,
        isArray: isArray2
      } = content2;
      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-panel", children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("p", { className: "help-ref-sentence", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `$${displayPath}` }),
          " is a reference to the",
          " ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: propertyName2 }),
          " property of",
          " ",
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("code", { children: `<${elementName}>` }),
          line2 !== void 0 ? ` (line ${line2})` : "",
          "."
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "help-description", children: renderInlineMarkdown(description) }),
        type !== void 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail", children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: "Type:" }),
          /* @__PURE__ */ jsxRuntimeExports$3.jsxs("span", { className: "help-detail-value", children: [
            `<${type}>`,
            isArray2 ? "[]" : ""
          ] })
        ] }),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(ReferencesDocLink, { docsBase })
      ] });
    }
  }
}
function renderColorValueContent(entry) {
  if (!entry.colorWord || typeof entry.value !== "string") return null;
  const colorText = resolveCssVariables(entry.value);
  const colorStyle = { color: colorText };
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { style: colorStyle, children: colorText }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { style: colorStyle, children: ` (${entry.colorWord})` })
  ] });
}
function renderActiveDefaultValue(activeDefault) {
  const colorContent = renderColorValueContent(activeDefault);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-value-item", children: colorContent ?? formatValue(activeDefault.value) });
}
function renderBreakdownValue(entry) {
  return renderColorValueContent(entry) ?? formatValue(entry.value);
}
function renderStyleBreakdown(breakdown) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail help-style-breakdown", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: `Resolved style (styleNumber ${breakdown.styleNumber}):` }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("dl", { className: "help-style-breakdown-list", children: breakdown.entries.map((entry) => /* @__PURE__ */ jsxRuntimeExports$3.jsxs(React__default.Fragment, { children: [
      /* @__PURE__ */ jsxRuntimeExports$3.jsx("dt", { children: entry.key }),
      /* @__PURE__ */ jsxRuntimeExports$3.jsx("dd", { children: renderBreakdownValue(entry) })
    ] }, entry.key)) })
  ] });
}
function renderLabeledChipList(label2, items) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-label", children: label2 }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "help-values-list", children: items.map((name2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-value-item", children: name2 }, name2)) })
  ] });
}
function renderFunctionNamesBreakdown(breakdown) {
  const isReset = breakdown.reset !== void 0;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "help-detail help-function-names-breakdown", children: [
    renderLabeledChipList("Resolved function names:", breakdown.names),
    isReset ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
      renderLabeledChipList(
        "Reset list on this input:",
        breakdown.reset
      ),
      /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "help-detail-annotation", children: "resetFunctionNames overrides additionalFunctionNames and removedFunctionNames." })
    ] }) : /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
      breakdown.added.length > 0 && renderLabeledChipList(
        "Added on this input:",
        breakdown.added
      ),
      breakdown.removed.length > 0 && renderLabeledChipList(
        "Removed on this input:",
        breakdown.removed
      )
    ] })
  ] });
}
function formatValue(val) {
  if (isMathDefaultValue(val)) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      MathJax,
      {
        inline: true,
        dynamic: true,
        hideUntilTypeset: "first",
        children: `\\(${val.latex}\\)`
      }
    );
  }
  if (Array.isArray(val)) {
    return val.map((v2, i2) => /* @__PURE__ */ jsxRuntimeExports$3.jsxs(React__default.Fragment, { children: [
      i2 > 0 ? " " : null,
      formatValue(v2)
    ] }, i2));
  }
  if (typeof val === "string") {
    return resolveCssVariables(val);
  }
  return JSON.stringify(val);
}
function resolveCssVariables(value) {
  if (typeof document === "undefined" || typeof getComputedStyle !== "function" || !value.includes("var(")) {
    return value;
  }
  const rootStyle = getComputedStyle(document.documentElement);
  return value.replace(/var\(\s*(--[\w-]+)\s*\)/g, (match2, varName) => {
    const resolved = rootStyle.getPropertyValue(varName).trim();
    return resolved || match2;
  });
}
function diagnosticLocationLabel(diagnostic2) {
  return diagnostic2.position ? `Line #${diagnostic2.position.start.line}` : null;
}
function diagnosticIdentityKey(diagnostic2) {
  return [
    diagnostic2.type ?? "",
    diagnostic2.level ?? "",
    diagnostic2.message,
    diagnostic2.sourceDoc ?? "",
    diagnostic2.position?.start?.line ?? "",
    diagnostic2.position?.start?.column ?? "",
    diagnostic2.position?.start?.offset ?? "",
    diagnostic2.position?.end?.line ?? "",
    diagnostic2.position?.end?.column ?? "",
    diagnostic2.position?.end?.offset ?? ""
  ].join("|");
}
function FormattedDiagnosticMessage({ message }) {
  const html = renderDiagnosticMarkdownHtml(message);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "div",
    {
      className: "diagnostic-entry-message",
      dangerouslySetInnerHTML: { __html: html }
    }
  );
}
function DiagnosticList({
  diagnostics,
  emptyMessage,
  testPrefix,
  icon,
  iconClassName
}) {
  if (diagnostics.length === 0) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx(jsxRuntimeExports$3.Fragment, { children: emptyMessage });
  }
  const diagnosticIdentityCounts = /* @__PURE__ */ new Map();
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx("ul", { className: "diagnostic-list", children: diagnostics.map((diagnostic2, i2) => {
    const location = diagnosticLocationLabel(diagnostic2);
    const identity2 = diagnosticIdentityKey(diagnostic2);
    const currentCount = diagnosticIdentityCounts.get(identity2) ?? 0;
    diagnosticIdentityCounts.set(identity2, currentCount + 1);
    const key = currentCount === 0 ? identity2 : `${identity2}#${currentCount}`;
    return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
      "li",
      {
        "data-test": `${testPrefix} ${i2}`,
        className: "diagnostic-entry",
        children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(
            "span",
            {
              className: classNames(
                "diagnostic-entry-icon",
                iconClassName
              ),
              children: icon
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { children: [
            location ? /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "diagnostic-entry-location", children: location }) : null,
            /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              FormattedDiagnosticMessage,
              {
                message: diagnostic2.message
              }
            )
          ] })
        ]
      },
      key
    );
  }) });
}
function AnnotationToggle({
  checked,
  label: label2,
  onChange
}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("label", { className: "diagnostic-editor-toggle", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      "input",
      {
        type: "checkbox",
        checked,
        onChange: (event) => onChange(event.target.checked)
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { children: label2 })
  ] });
}
function DiagnosticsResponseTabContents({
  store: store2,
  warnings,
  errors: errors2,
  infos,
  accessibility,
  submittedResponses,
  isOpen,
  showDiagnostics = true,
  showResponses = true,
  showHelp = true,
  showInfoAnnotations,
  setShowInfoAnnotations,
  showAccessibilityAnnotations,
  setShowAccessibilityAnnotations,
  helpContent,
  docsURL
}) {
  const panels = useRef(null);
  const lastScrolledToBottom = useRef(true);
  function scrollToBottom() {
    if (panels.current) {
      setTimeout(() => {
        if (panels.current) {
          panels.current.scrollTo(0, panels.current.scrollHeight);
        }
      });
    }
  }
  useEffect(() => {
    if (!panels.current) {
      return;
    }
    const panelElement = panels.current;
    function scrollListener() {
      lastScrolledToBottom.current = Math.abs(
        panelElement.scrollHeight - panelElement.scrollTop - panelElement.clientHeight
      ) <= 3;
    }
    panelElement.addEventListener("scroll", scrollListener);
    return () => {
      panelElement.removeEventListener("scroll", scrollListener);
    };
  }, [isOpen]);
  const selectedTabIdForScroll = store2.useState("selectedId");
  useEffect(() => {
    if (isOpen && selectedTabIdForScroll === "responses") {
      scrollToBottom();
    }
  }, [isOpen, selectedTabIdForScroll]);
  useEffect(() => {
    if (isOpen && selectedTabIdForScroll === "responses") {
      if (lastScrolledToBottom.current) {
        scrollToBottom();
      }
    }
  }, [submittedResponses]);
  const level1Accessibility = accessibility.filter(
    (diagnostic2) => diagnostic2.level === 1
  );
  const level2Accessibility = accessibility.filter(
    (diagnostic2) => diagnostic2.level === 2
  );
  const docsBase = docsURL.replace(/\/+$/, "");
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "div",
    {
      className: classNames("diagnostics-response-tabs-container", {
        "is-open": isOpen
      }),
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabProvider, { store: store2, children: isOpen && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
        "div",
        {
          ref: panels,
          className: "diagnostics-response-tabs-panels",
          children: [
            showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              TabPanel,
              {
                store: store2,
                tabId: "errors",
                className: "diagnostic-panel",
                children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                  DiagnosticList,
                  {
                    diagnostics: errors2,
                    emptyMessage: /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No Errors" }),
                    testPrefix: "Error",
                    icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsXOctagonFill, {}),
                    iconClassName: "is-error"
                  }
                )
              }
            ),
            showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              TabPanel,
              {
                store: store2,
                tabId: "warnings",
                className: "diagnostic-panel",
                children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                  DiagnosticList,
                  {
                    diagnostics: warnings,
                    emptyMessage: /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No Warnings" }),
                    testPrefix: "Warning",
                    icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsExclamationTriangleFill, {}),
                    iconClassName: "is-warning"
                  }
                )
              }
            ),
            showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
              TabPanel,
              {
                store: store2,
                tabId: "info",
                className: "diagnostic-panel",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                    AnnotationToggle,
                    {
                      checked: showInfoAnnotations,
                      label: "Show info diagnostics in editor",
                      onChange: setShowInfoAnnotations
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                    DiagnosticList,
                    {
                      diagnostics: infos,
                      emptyMessage: /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No Info Diagnostics" }),
                      testPrefix: "Info",
                      icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsInfoCircleFill, {}),
                      iconClassName: "is-info"
                    }
                  )
                ]
              }
            ),
            showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
              TabPanel,
              {
                store: store2,
                tabId: "accessibility",
                className: "diagnostic-panel accessibility-report",
                children: [
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                    AnnotationToggle,
                    {
                      checked: showAccessibilityAnnotations,
                      label: "Show accessibility diagnostics in editor",
                      onChange: setShowAccessibilityAnnotations
                    }
                  ),
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { className: "accessibility-report-intro", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                    "a",
                    {
                      href: `${docsBase}/concepts/accessibility`,
                      target: "_blank",
                      rel: "noreferrer",
                      children: "Learn how Doenet approaches accessibility"
                    }
                  ) }),
                  /* @__PURE__ */ jsxRuntimeExports$3.jsxs("section", { className: "accessibility-report-section", children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "accessibility-report-heading critical", children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("h3", { children: [
                      "Accessibility violations (",
                      /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                        "a",
                        {
                          href: "https://www.w3.org/WAI/standards-guidelines/wcag/",
                          target: "_blank",
                          children: "WCAG AA"
                        }
                      ),
                      ")"
                    ] }) }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      DiagnosticList,
                      {
                        diagnostics: level1Accessibility,
                        emptyMessage: /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { children: "None found" }),
                        testPrefix: "WCAG AA Accessibility Violation",
                        icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibility, {}),
                        iconClassName: "is-accessibility-critical"
                      }
                    )
                  ] }),
                  /* @__PURE__ */ jsxRuntimeExports$3.jsxs("section", { className: "accessibility-report-section", children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "accessibility-report-heading advisory", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "Other accessibility issues" }) }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      DiagnosticList,
                      {
                        diagnostics: level2Accessibility,
                        emptyMessage: /* @__PURE__ */ jsxRuntimeExports$3.jsx("p", { children: "None found" }),
                        testPrefix: "Accessibility alert",
                        icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibility, {}),
                        iconClassName: "is-accessibility-advisory"
                      }
                    )
                  ] })
                ]
              }
            ),
            showResponses && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              TabPanel,
              {
                store: store2,
                tabId: "responses",
                className: "diagnostic-panel",
                children: submittedResponses.length == 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx("h3", { children: "No submitted responses yet" }) : /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: { minWidth: "fit-content" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("table", { children: [
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx("thead", { children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs("tr", { children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("th", { scope: "col", children: "Answer Id" }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("th", { scope: "col", children: "Response" }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("th", { scope: "col", children: "Credit" }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("th", { scope: "col", children: "Submitted" })
                  ] }) }),
                  /* @__PURE__ */ jsxRuntimeExports$3.jsx("tbody", { children: submittedResponses.map(
                    (resp, i2) => {
                      return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("tr", { children: [
                        /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.answerId }),
                        /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.response }),
                        /* @__PURE__ */ jsxRuntimeExports$3.jsxs("td", { children: [
                          Math.round(
                            resp.creditAchieved * 1e3
                          ) / 10,
                          "%"
                        ] }),
                        /* @__PURE__ */ jsxRuntimeExports$3.jsx("td", { children: resp.submittedAt })
                      ] }, i2);
                    }
                  ) })
                ] }) })
              }
            ),
            showHelp && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              TabPanel,
              {
                store: store2,
                tabId: "help",
                className: "diagnostic-panel",
                children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                  ContextHelpPanel,
                  {
                    content: helpContent,
                    docsURL
                  }
                )
              }
            )
          ]
        }
      ) })
    }
  );
}
var Ru = Object.defineProperty;
var yt = (t4, e2) => {
  for (var r2 in e2) Ru(t4, r2, { get: e2[r2], enumerable: true });
};
var Su = {};
yt(Su, { __debug: () => $i, check: () => Vi, doc: () => ar, format: () => Pu, formatWithCursor: () => Ou, getSupportInfo: () => Wi, util: () => fr, version: () => gu });
var X = (t4, e2) => (r2, n2, ...u2) => r2 | 1 && n2 == null ? void 0 : (e2.call(n2) ?? n2[t4]).apply(n2, u2);
var vu = String.prototype.replaceAll ?? function(t4, e2) {
  return t4.global ? this.replace(t4, e2) : this.split(t4).join(e2);
}, Lu = X("replaceAll", function() {
  if (typeof this == "string") return vu;
}), ne = Lu;
var Ne = class {
  diff(e2, r2, n2 = {}) {
    let u2;
    typeof n2 == "function" ? (u2 = n2, n2 = {}) : "callback" in n2 && (u2 = n2.callback);
    let o2 = this.castInput(e2, n2), i2 = this.castInput(r2, n2), D = this.removeEmpty(this.tokenize(o2, n2)), s2 = this.removeEmpty(this.tokenize(i2, n2));
    return this.diffWithOptionsObj(D, s2, n2, u2);
  }
  diffWithOptionsObj(e2, r2, n2, u2) {
    var o2;
    let i2 = (C2) => {
      if (C2 = this.postProcess(C2, n2), u2) {
        setTimeout(function() {
          u2(C2);
        }, 0);
        return;
      } else return C2;
    }, D = r2.length, s2 = e2.length, a2 = 1, c2 = D + s2;
    n2.maxEditLength != null && (c2 = Math.min(c2, n2.maxEditLength));
    let p2 = (o2 = n2.timeout) !== null && o2 !== void 0 ? o2 : 1 / 0, l2 = Date.now() + p2, m2 = [{ oldPos: -1, lastComponent: void 0 }], f2 = this.extractCommon(m2[0], r2, e2, 0, n2);
    if (m2[0].oldPos + 1 >= s2 && f2 + 1 >= D) return i2(this.buildValues(m2[0].lastComponent, r2, e2));
    let F = -1 / 0, d2 = 1 / 0, E = () => {
      for (let C2 = Math.max(F, -a2); C2 <= Math.min(d2, a2); C2 += 2) {
        let h2, _2 = m2[C2 - 1], P2 = m2[C2 + 1];
        _2 && (m2[C2 - 1] = void 0);
        let A2 = false;
        if (P2) {
          let J = P2.oldPos - C2;
          A2 = P2 && 0 <= J && J < D;
        }
        let B2 = _2 && _2.oldPos + 1 < s2;
        if (!A2 && !B2) {
          m2[C2] = void 0;
          continue;
        }
        if (!B2 || A2 && _2.oldPos < P2.oldPos ? h2 = this.addToPath(P2, true, false, 0, n2) : h2 = this.addToPath(_2, false, true, 1, n2), f2 = this.extractCommon(h2, r2, e2, C2, n2), h2.oldPos + 1 >= s2 && f2 + 1 >= D) return i2(this.buildValues(h2.lastComponent, r2, e2)) || true;
        m2[C2] = h2, h2.oldPos + 1 >= s2 && (d2 = Math.min(d2, C2 - 1)), f2 + 1 >= D && (F = Math.max(F, C2 + 1));
      }
      a2++;
    };
    if (u2) (function C2() {
      setTimeout(function() {
        if (a2 > c2 || Date.now() > l2) return u2(void 0);
        E() || C2();
      }, 0);
    })();
    else for (; a2 <= c2 && Date.now() <= l2; ) {
      let C2 = E();
      if (C2) return C2;
    }
  }
  addToPath(e2, r2, n2, u2, o2) {
    let i2 = e2.lastComponent;
    return i2 && !o2.oneChangePerToken && i2.added === r2 && i2.removed === n2 ? { oldPos: e2.oldPos + u2, lastComponent: { count: i2.count + 1, added: r2, removed: n2, previousComponent: i2.previousComponent } } : { oldPos: e2.oldPos + u2, lastComponent: { count: 1, added: r2, removed: n2, previousComponent: i2 } };
  }
  extractCommon(e2, r2, n2, u2, o2) {
    let i2 = r2.length, D = n2.length, s2 = e2.oldPos, a2 = s2 - u2, c2 = 0;
    for (; a2 + 1 < i2 && s2 + 1 < D && this.equals(n2[s2 + 1], r2[a2 + 1], o2); ) a2++, s2++, c2++, o2.oneChangePerToken && (e2.lastComponent = { count: 1, previousComponent: e2.lastComponent, added: false, removed: false });
    return c2 && !o2.oneChangePerToken && (e2.lastComponent = { count: c2, previousComponent: e2.lastComponent, added: false, removed: false }), e2.oldPos = s2, a2;
  }
  equals(e2, r2, n2) {
    return n2.comparator ? n2.comparator(e2, r2) : e2 === r2 || !!n2.ignoreCase && e2.toLowerCase() === r2.toLowerCase();
  }
  removeEmpty(e2) {
    let r2 = [];
    for (let n2 = 0; n2 < e2.length; n2++) e2[n2] && r2.push(e2[n2]);
    return r2;
  }
  castInput(e2, r2) {
    return e2;
  }
  tokenize(e2, r2) {
    return Array.from(e2);
  }
  join(e2) {
    return e2.join("");
  }
  postProcess(e2, r2) {
    return e2;
  }
  get useLongestToken() {
    return false;
  }
  buildValues(e2, r2, n2) {
    let u2 = [], o2;
    for (; e2; ) u2.push(e2), o2 = e2.previousComponent, delete e2.previousComponent, e2 = o2;
    u2.reverse();
    let i2 = u2.length, D = 0, s2 = 0, a2 = 0;
    for (; D < i2; D++) {
      let c2 = u2[D];
      if (c2.removed) c2.value = this.join(n2.slice(a2, a2 + c2.count)), a2 += c2.count;
      else {
        if (!c2.added && this.useLongestToken) {
          let p2 = r2.slice(s2, s2 + c2.count);
          p2 = p2.map(function(l2, m2) {
            let f2 = n2[a2 + m2];
            return f2.length > l2.length ? f2 : l2;
          }), c2.value = this.join(p2);
        } else c2.value = this.join(r2.slice(s2, s2 + c2.count));
        s2 += c2.count, c2.added || (a2 += c2.count);
      }
    }
    return u2;
  }
};
var At = class extends Ne {
  tokenize(e2) {
    return e2.slice();
  }
  join(e2) {
    return e2;
  }
  removeEmpty(e2) {
    return e2;
  }
}, pr = new At();
function xt(t4, e2, r2) {
  return pr.diff(t4, e2, r2);
}
var Mu = () => {
}, k = Mu;
var dr = "cr", Fr = "crlf", Yu = "lf", ju = Yu, Bt = "\r", Er = `\r
`, ze = `
`, Uu = ze;
function Cr(t4) {
  let e2 = t4.indexOf(Bt);
  return e2 !== -1 ? t4.charAt(e2 + 1) === ze ? Fr : dr : ju;
}
function we(t4) {
  return t4 === dr ? Bt : t4 === Fr ? Er : Uu;
}
var Vu = /* @__PURE__ */ new Map([[ze, /\n/g], [Bt, /\r/g], [Er, /\r\n/g]]);
function Tt(t4, e2) {
  let r2 = Vu.get(e2);
  return t4.match(r2)?.length ?? 0;
}
var Wu = /\r\n?/g;
function hr(t4) {
  return ne(0, t4, Wu, ze);
}
var ue = /* @__PURE__ */ Symbol.for("comments");
function $u(t4) {
  return this[t4 < 0 ? this.length + t4 : t4];
}
var zu = X("at", function() {
  if (Array.isArray(this) || typeof this == "string") return $u;
}), y = zu;
var G = "string", U = "array", V = "cursor", I = "indent", R = "align", v = "trim", x = "group", S = "fill", T$1 = "if-break", L = "indent-if-break", M = "line-suffix", Y = "line-suffix-boundary", g = "line", b = "label", N = "break-parent", Ge = /* @__PURE__ */ new Set([V, I, R, v, x, S, T$1, L, M, Y, g, b, N]);
function gr(t4) {
  let e2 = t4.length;
  for (; e2 > 0 && (t4[e2 - 1] === "\r" || t4[e2 - 1] === `
`); ) e2--;
  return e2 < t4.length ? t4.slice(0, e2) : t4;
}
function Fe(t4, e2, r2) {
  if (!t4.has(e2)) {
    let n2 = r2(e2);
    t4.set(e2, n2);
  }
  return t4.get(e2);
}
function Gu(t4) {
  if (typeof t4 == "string") return G;
  if (Array.isArray(t4)) return U;
  if (!t4) return;
  let { type: e2 } = t4;
  if (Ge.has(e2)) return e2;
}
var q = Gu;
var Ku = (t4) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(t4);
function Hu(t4) {
  let e2 = t4 === null ? "null" : typeof t4;
  if (e2 !== "string" && e2 !== "object") return `Unexpected doc '${e2}', 
Expected it to be 'string' or 'object'.`;
  if (q(t4)) throw new Error("doc is valid.");
  let r2 = Object.prototype.toString.call(t4);
  if (r2 !== "[object Object]") return `Unexpected doc '${r2}'.`;
  let n2 = Ku([...Ge].map((u2) => `'${u2}'`));
  return `Unexpected doc.type '${t4.type}'.
Expected it to be ${n2}.`;
}
var Nt = class extends Error {
  name = "InvalidDocError";
  constructor(e2) {
    super(Hu(e2)), this.doc = e2;
  }
}, Z = Nt;
var _r = {};
function Ju(t4, e2, r2, n2) {
  let u2 = [t4];
  for (; u2.length > 0; ) {
    let o2 = u2.pop();
    if (o2 === _r) {
      r2(u2.pop());
      continue;
    }
    r2 && u2.push(o2, _r);
    let i2 = q(o2);
    if (!i2) throw new Z(o2);
    if (e2?.(o2) !== false) switch (i2) {
      case U:
      case S: {
        let D = i2 === U ? o2 : o2.parts;
        for (let s2 = D.length, a2 = s2 - 1; a2 >= 0; --a2) u2.push(D[a2]);
        break;
      }
      case T$1:
        u2.push(o2.flatContents, o2.breakContents);
        break;
      case x:
        if (n2 && o2.expandedStates) for (let D = o2.expandedStates.length, s2 = D - 1; s2 >= 0; --s2) u2.push(o2.expandedStates[s2]);
        else u2.push(o2.contents);
        break;
      case R:
      case I:
      case L:
      case b:
      case M:
        u2.push(o2.contents);
        break;
      case G:
      case V:
      case v:
      case Y:
      case g:
      case N:
        break;
      default:
        throw new Z(o2);
    }
  }
}
var Oe = Ju;
function Se(t4, e2) {
  if (typeof t4 == "string") return e2(t4);
  let r2 = /* @__PURE__ */ new Map();
  return n2(t4);
  function n2(o2) {
    return Fe(r2, o2, u2);
  }
  function u2(o2) {
    switch (q(o2)) {
      case U:
        return e2(o2.map(n2));
      case S:
        return e2({ ...o2, parts: o2.parts.map(n2) });
      case T$1:
        return e2({ ...o2, breakContents: n2(o2.breakContents), flatContents: n2(o2.flatContents) });
      case x: {
        let { expandedStates: i2, contents: D } = o2;
        return i2 ? (i2 = i2.map(n2), D = i2[0]) : D = n2(D), e2({ ...o2, contents: D, expandedStates: i2 });
      }
      case R:
      case I:
      case L:
      case b:
      case M:
        return e2({ ...o2, contents: n2(o2.contents) });
      case G:
      case V:
      case v:
      case Y:
      case g:
      case N:
        return e2(o2);
      default:
        throw new Z(o2);
    }
  }
}
function Ke(t4, e2, r2) {
  let n2 = r2, u2 = false;
  function o2(i2) {
    if (u2) return false;
    let D = e2(i2);
    D !== void 0 && (u2 = true, n2 = D);
  }
  return Oe(t4, o2), n2;
}
function qu(t4) {
  if (t4.type === x && t4.break || t4.type === g && t4.hard || t4.type === N) return true;
}
function xr(t4) {
  return Ke(t4, qu, false);
}
function yr(t4) {
  if (t4.length > 0) {
    let e2 = y(0, t4, -1);
    !e2.expandedStates && !e2.break && (e2.break = "propagated");
  }
  return null;
}
function Br(t4) {
  let e2 = /* @__PURE__ */ new Set(), r2 = [];
  function n2(o2) {
    if (o2.type === N && yr(r2), o2.type === x) {
      if (r2.push(o2), e2.has(o2)) return false;
      e2.add(o2);
    }
  }
  function u2(o2) {
    o2.type === x && r2.pop().break && yr(r2);
  }
  Oe(t4, n2, u2, true);
}
function Xu(t4) {
  return t4.type === g && !t4.hard ? t4.soft ? "" : " " : t4.type === T$1 ? t4.flatContents : t4;
}
function Tr(t4) {
  return Se(t4, Xu);
}
function Ar(t4) {
  for (t4 = [...t4]; t4.length >= 2 && y(0, t4, -2).type === g && y(0, t4, -1).type === N; ) t4.length -= 2;
  if (t4.length > 0) {
    let e2 = Pe(y(0, t4, -1));
    t4[t4.length - 1] = e2;
  }
  return t4;
}
function Pe(t4) {
  switch (q(t4)) {
    case I:
    case L:
    case x:
    case M:
    case b: {
      let e2 = Pe(t4.contents);
      return { ...t4, contents: e2 };
    }
    case T$1:
      return { ...t4, breakContents: Pe(t4.breakContents), flatContents: Pe(t4.flatContents) };
    case S:
      return { ...t4, parts: Ar(t4.parts) };
    case U:
      return Ar(t4);
    case G:
      return gr(t4);
    case R:
    case V:
    case v:
    case Y:
    case g:
    case N:
      break;
    default:
      throw new Z(t4);
  }
  return t4;
}
function He(t4) {
  return Pe(Zu(t4));
}
function Qu(t4) {
  switch (q(t4)) {
    case S: {
      let { parts: e2 } = t4;
      if (e2.every((r2) => r2 === "")) return "";
      if (e2.length === 1) return e2[0];
      break;
    }
    case x:
      if (!t4.contents && !t4.id && !t4.break && !t4.expandedStates) return "";
      if (t4.contents.type === x && t4.contents.id === t4.id && t4.contents.break === t4.break && t4.contents.expandedStates === t4.expandedStates) return t4.contents;
      break;
    case R:
    case I:
    case L:
    case M:
      if (!t4.contents) return "";
      break;
    case T$1:
      if (!t4.flatContents && !t4.breakContents) return "";
      break;
    case U: {
      let e2 = [];
      for (let r2 of t4) {
        if (!r2) continue;
        let [n2, ...u2] = Array.isArray(r2) ? r2 : [r2];
        typeof n2 == "string" && typeof y(0, e2, -1) == "string" ? e2[e2.length - 1] += n2 : e2.push(n2), e2.push(...u2);
      }
      return e2.length === 0 ? "" : e2.length === 1 ? e2[0] : e2;
    }
    case G:
    case V:
    case v:
    case Y:
    case g:
    case b:
    case N:
      break;
    default:
      throw new Z(t4);
  }
  return t4;
}
function Zu(t4) {
  return Se(t4, (e2) => Qu(e2));
}
function Nr(t4, e2 = Je) {
  return Se(t4, (r2) => typeof r2 == "string" ? be(e2, r2.split(`
`)) : r2);
}
function eo(t4) {
  if (t4.type === g) return true;
}
function wr(t4) {
  return Ke(t4, eo, false);
}
function Ee(t4, e2) {
  return t4.type === b ? { ...t4, contents: e2(t4.contents) } : e2(t4);
}
var qe = k;
function oe(t4) {
  return { type: I, contents: t4 };
}
function De(t4, e2) {
  return { type: R, contents: e2, n: t4 };
}
function Sr(t4) {
  return De(Number.NEGATIVE_INFINITY, t4);
}
function Xe(t4) {
  return De({ type: "root" }, t4);
}
function br(t4) {
  return De(-1, t4);
}
function Qe(t4, e2, r2) {
  let n2 = t4;
  if (e2 > 0) {
    for (let u2 = 0; u2 < Math.floor(e2 / r2); ++u2) n2 = oe(n2);
    n2 = De(e2 % r2, n2), n2 = De(Number.NEGATIVE_INFINITY, n2);
  }
  return n2;
}
var ae = { type: N };
var ee = { type: V };
function kr(t4) {
  return { type: S, parts: t4 };
}
function wt(t4, e2 = {}) {
  return qe(e2.expandedStates), { type: x, id: e2.id, contents: t4, break: !!e2.shouldBreak, expandedStates: e2.expandedStates };
}
function Ir(t4, e2) {
  return wt(t4[0], { ...e2, expandedStates: t4 });
}
function Rr(t4, e2 = "", r2 = {}) {
  return { type: T$1, breakContents: t4, flatContents: e2, groupId: r2.groupId };
}
function vr(t4, e2) {
  return { type: L, contents: t4, groupId: e2.groupId, negate: e2.negate };
}
function be(t4, e2) {
  let r2 = [];
  for (let n2 = 0; n2 < e2.length; n2++) n2 !== 0 && r2.push(t4), r2.push(e2[n2]);
  return r2;
}
function Lr(t4, e2) {
  return t4 ? { type: b, label: t4, contents: e2 } : e2;
}
var Ze = { type: g }, Mr = { type: g, soft: true }, ke = { type: g, hard: true }, W = [ke, ae], Ot = { type: g, hard: true, literal: true }, Je = [Ot, ae];
function Ie(t4) {
  return { type: M, contents: t4 };
}
var Yr = { type: Y };
var jr = { type: v };
function te(t4) {
  if (!t4) return "";
  if (Array.isArray(t4)) {
    let e2 = [];
    for (let r2 of t4) if (Array.isArray(r2)) e2.push(...te(r2));
    else {
      let n2 = te(r2);
      n2 !== "" && e2.push(n2);
    }
    return e2;
  }
  return t4.type === T$1 ? { ...t4, breakContents: te(t4.breakContents), flatContents: te(t4.flatContents) } : t4.type === x ? { ...t4, contents: te(t4.contents), expandedStates: t4.expandedStates?.map(te) } : t4.type === S ? { type: "fill", parts: t4.parts.map(te) } : t4.contents ? { ...t4, contents: te(t4.contents) } : t4;
}
function Ur(t4) {
  let e2 = /* @__PURE__ */ Object.create(null), r2 = /* @__PURE__ */ new Set();
  return n2(te(t4));
  function n2(o2, i2, D) {
    if (typeof o2 == "string") return JSON.stringify(o2);
    if (Array.isArray(o2)) {
      let s2 = o2.map(n2).filter(Boolean);
      return s2.length === 1 ? s2[0] : `[${s2.join(", ")}]`;
    }
    if (o2.type === g) {
      let s2 = D?.[i2 + 1]?.type === N;
      return o2.literal ? s2 ? "literalline" : "literallineWithoutBreakParent" : o2.hard ? s2 ? "hardline" : "hardlineWithoutBreakParent" : o2.soft ? "softline" : "line";
    }
    if (o2.type === N) return D?.[i2 - 1]?.type === g && D[i2 - 1].hard ? void 0 : "breakParent";
    if (o2.type === v) return "trim";
    if (o2.type === I) return "indent(" + n2(o2.contents) + ")";
    if (o2.type === R) return o2.n === Number.NEGATIVE_INFINITY ? "dedentToRoot(" + n2(o2.contents) + ")" : o2.n < 0 ? "dedent(" + n2(o2.contents) + ")" : o2.n.type === "root" ? "markAsRoot(" + n2(o2.contents) + ")" : "align(" + JSON.stringify(o2.n) + ", " + n2(o2.contents) + ")";
    if (o2.type === T$1) return "ifBreak(" + n2(o2.breakContents) + (o2.flatContents ? ", " + n2(o2.flatContents) : "") + (o2.groupId ? (o2.flatContents ? "" : ', ""') + `, { groupId: ${u2(o2.groupId)} }` : "") + ")";
    if (o2.type === L) {
      let s2 = [];
      o2.negate && s2.push("negate: true"), o2.groupId && s2.push(`groupId: ${u2(o2.groupId)}`);
      let a2 = s2.length > 0 ? `, { ${s2.join(", ")} }` : "";
      return `indentIfBreak(${n2(o2.contents)}${a2})`;
    }
    if (o2.type === x) {
      let s2 = [];
      o2.break && o2.break !== "propagated" && s2.push("shouldBreak: true"), o2.id && s2.push(`id: ${u2(o2.id)}`);
      let a2 = s2.length > 0 ? `, { ${s2.join(", ")} }` : "";
      return o2.expandedStates ? `conditionalGroup([${o2.expandedStates.map((c2) => n2(c2)).join(",")}]${a2})` : `group(${n2(o2.contents)}${a2})`;
    }
    if (o2.type === S) return `fill([${o2.parts.map((s2) => n2(s2)).join(", ")}])`;
    if (o2.type === M) return "lineSuffix(" + n2(o2.contents) + ")";
    if (o2.type === Y) return "lineSuffixBoundary";
    if (o2.type === b) return `label(${JSON.stringify(o2.label)}, ${n2(o2.contents)})`;
    if (o2.type === V) return "cursor";
    throw new Error("Unknown doc type " + o2.type);
  }
  function u2(o2) {
    if (typeof o2 != "symbol") return JSON.stringify(String(o2));
    if (o2 in e2) return e2[o2];
    let i2 = o2.description || "symbol";
    for (let D = 0; ; D++) {
      let s2 = i2 + (D > 0 ? ` #${D}` : "");
      if (!r2.has(s2)) return r2.add(s2), e2[o2] = `Symbol.for(${JSON.stringify(s2)})`;
    }
  }
}
var Vr = () => /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
var Wr = 12288, $r = 65510, zr = [12288, 12288, 65281, 65376, 65504, 65510];
var Gr = 4352, Kr = 262141, Pt = [4352, 4447, 8986, 8987, 9001, 9002, 9193, 9196, 9200, 9200, 9203, 9203, 9725, 9726, 9748, 9749, 9776, 9783, 9800, 9811, 9855, 9855, 9866, 9871, 9875, 9875, 9889, 9889, 9898, 9899, 9917, 9918, 9924, 9925, 9934, 9934, 9940, 9940, 9962, 9962, 9970, 9971, 9973, 9973, 9978, 9978, 9981, 9981, 9989, 9989, 9994, 9995, 10024, 10024, 10060, 10060, 10062, 10062, 10067, 10069, 10071, 10071, 10133, 10135, 10160, 10160, 10175, 10175, 11035, 11036, 11088, 11088, 11093, 11093, 11904, 11929, 11931, 12019, 12032, 12245, 12272, 12287, 12289, 12350, 12353, 12438, 12441, 12543, 12549, 12591, 12593, 12686, 12688, 12773, 12783, 12830, 12832, 12871, 12880, 42124, 42128, 42182, 43360, 43388, 44032, 55203, 63744, 64255, 65040, 65049, 65072, 65106, 65108, 65126, 65128, 65131, 94176, 94180, 94192, 94198, 94208, 101589, 101631, 101662, 101760, 101874, 110576, 110579, 110581, 110587, 110589, 110590, 110592, 110882, 110898, 110898, 110928, 110930, 110933, 110933, 110948, 110951, 110960, 111355, 119552, 119638, 119648, 119670, 126980, 126980, 127183, 127183, 127374, 127374, 127377, 127386, 127488, 127490, 127504, 127547, 127552, 127560, 127568, 127569, 127584, 127589, 127744, 127776, 127789, 127797, 127799, 127868, 127870, 127891, 127904, 127946, 127951, 127955, 127968, 127984, 127988, 127988, 127992, 128062, 128064, 128064, 128066, 128252, 128255, 128317, 128331, 128334, 128336, 128359, 128378, 128378, 128405, 128406, 128420, 128420, 128507, 128591, 128640, 128709, 128716, 128716, 128720, 128722, 128725, 128728, 128732, 128735, 128747, 128748, 128756, 128764, 128992, 129003, 129008, 129008, 129292, 129338, 129340, 129349, 129351, 129535, 129648, 129660, 129664, 129674, 129678, 129734, 129736, 129736, 129741, 129756, 129759, 129770, 129775, 129784, 131072, 196605, 196608, 262141];
var St = (t4, e2) => {
  let r2 = 0, n2 = Math.floor(t4.length / 2) - 1;
  for (; r2 <= n2; ) {
    let u2 = Math.floor((r2 + n2) / 2), o2 = u2 * 2;
    if (e2 < t4[o2]) n2 = u2 - 1;
    else if (e2 > t4[o2 + 1]) r2 = u2 + 1;
    else return true;
  }
  return false;
};
var Hr = 19968, [to, ro] = no(Pt);
function no(t4) {
  let e2 = t4[0], r2 = t4[1];
  for (let n2 = 0; n2 < t4.length; n2 += 2) {
    let u2 = t4[n2], o2 = t4[n2 + 1];
    if (Hr >= u2 && Hr <= o2) return [u2, o2];
    o2 - u2 > r2 - e2 && (e2 = u2, r2 = o2);
  }
  return [e2, r2];
}
var bt = (t4) => t4 < Wr || t4 > $r ? false : St(zr, t4);
var kt = (t4) => t4 >= to && t4 <= ro ? true : t4 < Gr || t4 > Kr ? false : St(Pt, t4);
var uo = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF3\uDFF5\uDFF7]|\uD83D[\uDC3F\uDC41\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])$/, Jr = (t4) => uo.test(t4);
var oo = /[^\x20-\x7F]/;
function io(t4) {
  if (!t4) return 0;
  if (!oo.test(t4)) return t4.length;
  let e2 = 0;
  t4 = t4.replace(Vr(), (r2) => (e2 += Jr(r2) ? 1 : 2, ""));
  for (let r2 of t4) {
    let n2 = r2.codePointAt(0);
    n2 <= 31 || n2 >= 127 && n2 <= 159 || n2 >= 768 && n2 <= 879 || n2 >= 65024 && n2 <= 65039 || (e2 += bt(n2) || kt(n2) ? 2 : 1);
  }
  return e2;
}
var Re = io;
var so = { type: 0 }, Do = { type: 1 }, It = { value: "", length: 0, queue: [], get root() {
  return It;
} };
function qr(t4, e2, r2) {
  let n2 = e2.type === 1 ? t4.queue.slice(0, -1) : [...t4.queue, e2], u2 = "", o2 = 0, i2 = 0, D = 0;
  for (let f2 of n2) switch (f2.type) {
    case 0:
      c2(), r2.useTabs ? s2(1) : a2(r2.tabWidth);
      break;
    case 3: {
      let { string: F } = f2;
      c2(), u2 += F, o2 += F.length;
      break;
    }
    case 2: {
      let { width: F } = f2;
      i2 += 1, D += F;
      break;
    }
    default:
      throw new Error(`Unexpected indent comment '${f2.type}'.`);
  }
  return l2(), { ...t4, value: u2, length: o2, queue: n2 };
  function s2(f2) {
    u2 += "	".repeat(f2), o2 += r2.tabWidth * f2;
  }
  function a2(f2) {
    u2 += " ".repeat(f2), o2 += f2;
  }
  function c2() {
    r2.useTabs ? p2() : l2();
  }
  function p2() {
    i2 > 0 && s2(i2), m2();
  }
  function l2() {
    D > 0 && a2(D), m2();
  }
  function m2() {
    i2 = 0, D = 0;
  }
}
function Xr(t4, e2, r2) {
  if (!e2) return t4;
  if (e2.type === "root") return { ...t4, root: t4 };
  if (e2 === Number.NEGATIVE_INFINITY) return t4.root;
  let n2;
  return typeof e2 == "number" ? e2 < 0 ? n2 = Do : n2 = { type: 2, width: e2 } : n2 = { type: 3, string: e2 }, qr(t4, n2, r2);
}
function Qr(t4, e2) {
  return qr(t4, so, e2);
}
function ao(t4) {
  let e2 = 0;
  for (let r2 = t4.length - 1; r2 >= 0; r2--) {
    let n2 = t4[r2];
    if (n2 === " " || n2 === "	") e2++;
    else break;
  }
  return e2;
}
function et(t4) {
  let e2 = ao(t4);
  return { text: e2 === 0 ? t4 : t4.slice(0, t4.length - e2), count: e2 };
}
var Rt = class {
  #t = [];
  #e = "";
  #n = 0;
  #u = [];
  #r = [];
  #o() {
    let e2 = this.#e;
    e2 !== "" && (this.#t.push(e2), this.#n += e2.length, this.#e = "");
    for (let r2 of this.#r) this.#u.push(Math.min(r2, this.#n));
    this.#r.length = 0;
  }
  markPosition() {
    if (this.#u.length + this.#r.length >= 2) throw new Error("There are too many 'cursor' in doc.");
    this.#r.push(this.#n + this.#e.length);
  }
  write(e2) {
    this.#e += e2;
  }
  trim() {
    let { text: e2, count: r2 } = et(this.#e);
    return this.#e = e2, this.#o(), r2;
  }
  finish() {
    return this.#o(), { text: this.#t.join(""), positions: this.#u };
  }
}, Zr = Rt;
var K = /* @__PURE__ */ Symbol("MODE_BREAK"), Q = /* @__PURE__ */ Symbol("MODE_FLAT"), vt = /* @__PURE__ */ Symbol("DOC_FILL_PRINTED_LENGTH");
function tt(t4, e2, r2, n2, u2, o2) {
  if (r2 === Number.POSITIVE_INFINITY) return true;
  let i2 = e2.length, D = false, s2 = [t4], a2 = "";
  for (; r2 >= 0; ) {
    if (s2.length === 0) {
      if (i2 === 0) return true;
      s2.push(e2[--i2]);
      continue;
    }
    let { mode: c2, doc: p2 } = s2.pop(), l2 = q(p2);
    switch (l2) {
      case G:
        p2 && (D && (a2 += " ", r2 -= 1, D = false), a2 += p2, r2 -= Re(p2));
        break;
      case U:
      case S: {
        let m2 = l2 === U ? p2 : p2.parts, f2 = p2[vt] ?? 0;
        for (let F = m2.length - 1; F >= f2; F--) s2.push({ mode: c2, doc: m2[F] });
        break;
      }
      case I:
      case R:
      case L:
      case b:
        s2.push({ mode: c2, doc: p2.contents });
        break;
      case v: {
        let { text: m2, count: f2 } = et(a2);
        a2 = m2, r2 += f2;
        break;
      }
      case x: {
        if (o2 && p2.break) return false;
        let m2 = p2.break ? K : c2, f2 = p2.expandedStates && m2 === K ? y(0, p2.expandedStates, -1) : p2.contents;
        s2.push({ mode: m2, doc: f2 });
        break;
      }
      case T$1: {
        let f2 = (p2.groupId ? u2[p2.groupId] || Q : c2) === K ? p2.breakContents : p2.flatContents;
        f2 && s2.push({ mode: c2, doc: f2 });
        break;
      }
      case g:
        if (c2 === K || p2.hard) return true;
        p2.soft || (D = true);
        break;
      case M:
        n2 = true;
        break;
      case Y:
        if (n2) return false;
        break;
    }
  }
  return false;
}
function Ce(t4, e2) {
  let r2 = /* @__PURE__ */ Object.create(null), n2 = e2.printWidth, u2 = we(e2.endOfLine), o2 = 0, i2 = [{ indent: It, mode: K, doc: t4 }], D = false, s2 = [], a2 = new Zr();
  for (Br(t4); i2.length > 0; ) {
    let { indent: f2, mode: F, doc: d2 } = i2.pop();
    switch (q(d2)) {
      case G: {
        let E = u2 !== `
` ? ne(0, d2, `
`, u2) : d2;
        E && (a2.write(E), i2.length > 0 && (o2 += Re(E)));
        break;
      }
      case U:
        for (let E = d2.length - 1; E >= 0; E--) i2.push({ indent: f2, mode: F, doc: d2[E] });
        break;
      case V:
        a2.markPosition();
        break;
      case I:
        i2.push({ indent: Qr(f2, e2), mode: F, doc: d2.contents });
        break;
      case R:
        i2.push({ indent: Xr(f2, d2.n, e2), mode: F, doc: d2.contents });
        break;
      case v:
        o2 -= a2.trim();
        break;
      case x: {
        let E = (function() {
          if (F === Q && !D) return { indent: f2, mode: d2.break ? K : Q, doc: d2.contents };
          D = false;
          let h2 = n2 - o2, _2 = s2.length > 0, P2 = { indent: f2, mode: Q, doc: d2.contents };
          if (!d2.break && tt(P2, i2, h2, _2, r2)) return P2;
          if (!d2.expandedStates) return { indent: f2, mode: K, doc: d2.contents };
          if (!d2.break) for (let A2 = 1; A2 < d2.expandedStates.length - 1; A2++) {
            let B2 = { indent: f2, mode: Q, doc: d2.expandedStates[A2] };
            if (tt(B2, i2, h2, _2, r2)) return B2;
          }
          return { indent: f2, mode: K, doc: y(0, d2.expandedStates, -1) };
        })();
        i2.push(E), d2.id && (r2[d2.id] = E.mode);
        break;
      }
      case S: {
        let E = n2 - o2, C2 = d2[vt] ?? 0, { parts: h2 } = d2, _2 = h2.length - C2;
        if (_2 === 0) break;
        let P2 = h2[C2 + 0], A2 = h2[C2 + 1], B2 = { indent: f2, mode: Q, doc: P2 }, J = { indent: f2, mode: K, doc: P2 }, $e = tt(B2, [], E, s2.length > 0, r2, true);
        if (_2 === 1) {
          $e ? i2.push(B2) : i2.push(J);
          break;
        }
        let lr = { indent: f2, mode: Q, doc: A2 }, _t = { indent: f2, mode: K, doc: A2 };
        if (_2 === 2) {
          $e ? i2.push(lr, B2) : i2.push(_t, J);
          break;
        }
        let bu = h2[C2 + 2], ku = { indent: f2, mode: F, doc: { ...d2, [vt]: C2 + 2 } }, Iu = tt({ indent: f2, mode: Q, doc: [P2, A2, bu] }, [], E, s2.length > 0, r2, true);
        i2.push(ku), Iu ? i2.push(lr, B2) : $e ? i2.push(_t, B2) : i2.push(_t, J);
        break;
      }
      case T$1:
      case L: {
        let E = d2.groupId ? r2[d2.groupId] : F;
        if (E === K) {
          let C2 = d2.type === T$1 ? d2.breakContents : d2.negate ? d2.contents : oe(d2.contents);
          C2 && i2.push({ indent: f2, mode: F, doc: C2 });
        }
        if (E === Q) {
          let C2 = d2.type === T$1 ? d2.flatContents : d2.negate ? oe(d2.contents) : d2.contents;
          C2 && i2.push({ indent: f2, mode: F, doc: C2 });
        }
        break;
      }
      case M:
        s2.push({ indent: f2, mode: F, doc: d2.contents });
        break;
      case Y:
        s2.length > 0 && i2.push({ indent: f2, mode: F, doc: ke });
        break;
      case g:
        switch (F) {
          case Q:
            if (!d2.hard) {
              d2.soft || (a2.write(" "), o2 += 1);
              break;
            }
            D = true;
          case K:
            if (s2.length > 0) {
              i2.push({ indent: f2, mode: F, doc: d2 }, ...s2.reverse()), s2.length = 0;
              break;
            }
            d2.literal ? (a2.write(u2), o2 = 0, f2.root && (f2.root.value && a2.write(f2.root.value), o2 = f2.root.length)) : (a2.trim(), a2.write(u2 + f2.value), o2 = f2.length);
            break;
        }
        break;
      case b:
        i2.push({ indent: f2, mode: F, doc: d2.contents });
        break;
      case N:
        break;
      default:
        throw new Z(d2);
    }
    i2.length === 0 && s2.length > 0 && (i2.push(...s2.reverse()), s2.length = 0);
  }
  let { text: c2, positions: p2 } = a2.finish();
  if (p2.length !== 2) return { formatted: c2 };
  let [l2, m2] = p2;
  return { formatted: c2, cursorNodeStart: l2, cursorNodeText: c2.slice(l2, m2) };
}
function co(t4, e2, r2 = 0) {
  let n2 = 0;
  for (let u2 = r2; u2 < t4.length; ++u2) t4[u2] === "	" ? n2 = n2 + e2 - n2 % e2 : n2++;
  return n2;
}
var he = co;
var Lt = class {
  constructor(e2) {
    this.stack = [e2];
  }
  get key() {
    let { stack: e2, siblings: r2 } = this;
    return y(0, e2, r2 === null ? -2 : -4) ?? null;
  }
  get index() {
    return this.siblings === null ? null : y(0, this.stack, -2);
  }
  get node() {
    return y(0, this.stack, -1);
  }
  get parent() {
    return this.getNode(1);
  }
  get grandparent() {
    return this.getNode(2);
  }
  get isInArray() {
    return this.siblings !== null;
  }
  get siblings() {
    let { stack: e2 } = this, r2 = y(0, e2, -3);
    return Array.isArray(r2) ? r2 : null;
  }
  get next() {
    let { siblings: e2 } = this;
    return e2 === null ? null : e2[this.index + 1];
  }
  get previous() {
    let { siblings: e2 } = this;
    return e2 === null ? null : e2[this.index - 1];
  }
  get isFirst() {
    return this.index === 0;
  }
  get isLast() {
    let { siblings: e2, index: r2 } = this;
    return e2 !== null && r2 === e2.length - 1;
  }
  get isRoot() {
    return this.stack.length === 1;
  }
  get root() {
    return this.stack[0];
  }
  get ancestors() {
    return [...this.#e()];
  }
  getName() {
    let { stack: e2 } = this, { length: r2 } = e2;
    return r2 > 1 ? y(0, e2, -2) : null;
  }
  getValue() {
    return y(0, this.stack, -1);
  }
  getNode(e2 = 0) {
    let r2 = this.#t(e2);
    return r2 === -1 ? null : this.stack[r2];
  }
  getParentNode(e2 = 0) {
    return this.getNode(e2 + 1);
  }
  #t(e2) {
    let { stack: r2 } = this;
    for (let n2 = r2.length - 1; n2 >= 0; n2 -= 2) if (!Array.isArray(r2[n2]) && --e2 < 0) return n2;
    return -1;
  }
  call(e2, ...r2) {
    let { stack: n2 } = this, { length: u2 } = n2, o2 = y(0, n2, -1);
    for (let i2 of r2) o2 = o2?.[i2], n2.push(i2, o2);
    try {
      return e2(this);
    } finally {
      n2.length = u2;
    }
  }
  callParent(e2, r2 = 0) {
    let n2 = this.#t(r2 + 1), u2 = this.stack.splice(n2 + 1);
    try {
      return e2(this);
    } finally {
      this.stack.push(...u2);
    }
  }
  each(e2, ...r2) {
    let { stack: n2 } = this, { length: u2 } = n2, o2 = y(0, n2, -1);
    for (let i2 of r2) o2 = o2[i2], n2.push(i2, o2);
    try {
      for (let i2 = 0; i2 < o2.length; ++i2) n2.push(i2, o2[i2]), e2(this, i2, o2), n2.length -= 2;
    } finally {
      n2.length = u2;
    }
  }
  map(e2, ...r2) {
    let n2 = [];
    return this.each((u2, o2, i2) => {
      n2[o2] = e2(u2, o2, i2);
    }, ...r2), n2;
  }
  match(...e2) {
    let r2 = this.stack.length - 1, n2 = null, u2 = this.stack[r2--];
    for (let o2 of e2) {
      if (u2 === void 0) return false;
      let i2 = null;
      if (typeof n2 == "number" && (i2 = n2, n2 = this.stack[r2--], u2 = this.stack[r2--]), o2 && !o2(u2, n2, i2)) return false;
      n2 = this.stack[r2--], u2 = this.stack[r2--];
    }
    return true;
  }
  findAncestor(e2) {
    for (let r2 of this.#e()) if (e2(r2)) return r2;
  }
  hasAncestor(e2) {
    for (let r2 of this.#e()) if (e2(r2)) return true;
    return false;
  }
  *#e() {
    let { stack: e2 } = this;
    for (let r2 = e2.length - 3; r2 >= 0; r2 -= 2) {
      let n2 = e2[r2];
      Array.isArray(n2) || (yield n2);
    }
  }
}, en = Lt;
function fo(t4) {
  return Array.isArray(t4) && t4.length > 0;
}
var rt = fo;
function lo(t4) {
  return t4 !== null && typeof t4 == "object";
}
var ge = lo;
function _e(t4) {
  return (e2, r2, n2) => {
    if (r2 === false) return false;
    let u2 = !!n2?.backwards, { length: o2 } = e2, i2 = r2;
    for (; i2 >= 0 && i2 < o2; ) {
      let D = e2.charAt(i2);
      if (t4 instanceof RegExp) {
        if (!t4.test(D)) return i2;
      } else if (!t4.includes(D)) return i2;
      u2 ? i2-- : i2++;
    }
    return i2 === -1 || i2 === o2 ? i2 : false;
  };
}
var tn = _e(/\s/), j = _e(" 	"), nt = _e(",; 	"), ut = _e(/[^\n\r]/);
var rn = (t4) => t4 === `
` || t4 === "\r" || t4 === "\u2028" || t4 === "\u2029";
function po(t4, e2, r2) {
  if (e2 === false) return false;
  let n2 = !!r2?.backwards, u2 = t4.charAt(e2);
  if (n2) {
    if (t4.charAt(e2 - 1) === "\r" && u2 === `
`) return e2 - 2;
    if (rn(u2)) return e2 - 1;
  } else {
    if (u2 === "\r" && t4.charAt(e2 + 1) === `
`) return e2 + 2;
    if (rn(u2)) return e2 + 1;
  }
  return e2;
}
var $ = po;
function mo(t4, e2, r2 = {}) {
  let n2 = j(t4, r2.backwards ? e2 - 1 : e2, r2), u2 = $(t4, n2, r2);
  return n2 !== u2;
}
var H = mo;
function* ye(t4, e2) {
  let { getVisitorKeys: r2, filter: n2 = () => true } = e2, u2 = (o2) => ge(o2) && n2(o2);
  for (let o2 of r2(t4)) {
    let i2 = t4[o2];
    if (Array.isArray(i2)) for (let D of i2) u2(D) && (yield D);
    else u2(i2) && (yield i2);
  }
}
function* nn(t4, e2) {
  let r2 = [t4];
  for (let n2 = 0; n2 < r2.length; n2++) {
    let u2 = r2[n2];
    for (let o2 of ye(u2, e2)) yield o2, r2.push(o2);
  }
}
function un(t4, e2) {
  return ye(t4, e2).next().done;
}
function Fo(t4, e2, r2) {
  let { filter: n2 } = r2;
  if (!n2) return [];
  let u2, o2 = (r2.getChildren?.(t4, r2) ?? [...ye(t4, { getVisitorKeys: r2.getVisitorKeys })]).flatMap((s2) => (u2 ?? (u2 = [t4, ...e2]), n2(s2, u2) ? [s2] : on(s2, u2, r2))), { locStart: i2, locEnd: D } = r2;
  return o2.sort((s2, a2) => i2(s2) - i2(a2) || D(s2) - D(a2)), o2;
}
function on(t4, e2, r2) {
  return Fe(r2.cache, t4, (n2) => Fo(n2, e2, r2));
}
var ot = on;
function Eo(t4) {
  let e2 = t4.type || t4.kind || "(unknown type)", r2 = String(t4.name || t4.id && (typeof t4.id == "object" ? t4.id.name : t4.id) || t4.key && (typeof t4.key == "object" ? t4.key.name : t4.key) || t4.value && (typeof t4.value == "object" ? "" : String(t4.value)) || t4.operator || "");
  return r2.length > 20 && (r2 = r2.slice(0, 19) + "…"), e2 + (r2 ? " " + r2 : "");
}
function Mt(t4, e2) {
  (t4.comments ?? (t4.comments = [])).push(e2), e2.printed = false, e2.nodeDescription = Eo(t4);
}
function ce(t4, e2) {
  e2.leading = true, e2.trailing = false, Mt(t4, e2);
}
function re(t4, e2, r2) {
  e2.leading = false, e2.trailing = false, r2 && (e2.marker = r2), Mt(t4, e2);
}
function fe(t4, e2) {
  e2.leading = false, e2.trailing = true, Mt(t4, e2);
}
var Ut = /* @__PURE__ */ new WeakMap();
function Dn(t4, e2, r2, n2, u2 = []) {
  let { locStart: o2, locEnd: i2 } = r2, D = o2(e2), s2 = i2(e2), a2 = ot(t4, u2, { cache: Ut, locStart: o2, locEnd: i2, getVisitorKeys: r2.getVisitorKeys, filter: r2.printer.canAttachComment, getChildren: r2.printer.getCommentChildNodes }), c2, p2, l2 = 0, m2 = a2.length;
  for (; l2 < m2; ) {
    let f2 = l2 + m2 >> 1, F = a2[f2], d2 = o2(F), E = i2(F);
    if (d2 <= D && s2 <= E) return Dn(F, e2, r2, F, [F, ...u2]);
    if (E <= D) {
      c2 = F, l2 = f2 + 1;
      continue;
    }
    if (s2 <= d2) {
      p2 = F, m2 = f2;
      continue;
    }
    throw new Error("Comment location overlaps with node location");
  }
  if (n2?.type === "TemplateLiteral") {
    let { quasis: f2 } = n2, F = jt(f2, e2, r2);
    c2 && jt(f2, c2, r2) !== F && (c2 = null), p2 && jt(f2, p2, r2) !== F && (p2 = null);
  }
  return { enclosingNode: n2, precedingNode: c2, followingNode: p2 };
}
var Yt = () => false;
function an(t4, e2) {
  let { comments: r2 } = t4;
  if (delete t4.comments, !rt(r2) || !e2.printer.canAttachComment) return;
  let n2 = [], { printer: { features: { experimental_avoidAstMutation: u2 }, handleComments: o2 = {} }, originalText: i2 } = e2, { ownLine: D = Yt, endOfLine: s2 = Yt, remaining: a2 = Yt } = o2, c2 = r2.map((l2, m2) => ({ ...Dn(t4, l2, e2), comment: l2, text: i2, options: e2, ast: t4, isLastComment: r2.length - 1 === m2, placement: void 0 })), p2 = !u2;
  for (let [l2, m2] of c2.entries()) {
    let { comment: f2, precedingNode: F, enclosingNode: d2, followingNode: E, text: C2, options: h2, ast: _2, isLastComment: P2 } = m2, A2 = Co(C2, h2, c2, l2) ? "ownLine" : ho(C2, h2, c2, l2) ? "endOfLine" : "remaining", B2;
    if (u2 ? (m2.placement = A2, B2 = [m2]) : B2 = [f2, C2, h2, _2, P2], p2 && (f2.placement = A2, f2.enclosingNode = d2, f2.precedingNode = F, f2.followingNode = E), A2 === "ownLine") D(...B2) || (E ? ce(E, f2) : F ? fe(F, f2) : d2 ? re(d2, f2) : re(_2, f2));
    else if (A2 === "endOfLine") s2(...B2) || (F ? fe(F, f2) : E ? ce(E, f2) : d2 ? re(d2, f2) : re(_2, f2));
    else if (!a2(...B2)) if (F && E) {
      let J = n2.length;
      J > 0 && n2[J - 1].followingNode !== E && sn(n2, h2), n2.push(m2);
    } else F ? fe(F, f2) : E ? ce(E, f2) : d2 ? re(d2, f2) : re(_2, f2);
  }
  if (sn(n2, e2), p2) for (let l2 of r2) delete l2.precedingNode, delete l2.enclosingNode, delete l2.followingNode, delete l2.placement;
}
var cn = (t4) => !/[\S\n\u2028\u2029]/.test(t4);
function Co(t4, e2, r2, n2) {
  let { comment: u2, precedingNode: o2 } = r2[n2], { locStart: i2, locEnd: D } = e2, s2 = i2(u2);
  if (o2) for (let a2 = n2 - 1; a2 >= 0; a2--) {
    let { comment: c2, precedingNode: p2 } = r2[a2];
    if (p2 !== o2 || !cn(t4.slice(D(c2), s2))) break;
    s2 = i2(c2);
  }
  return H(t4, s2, { backwards: true });
}
function ho(t4, e2, r2, n2) {
  let { comment: u2, followingNode: o2 } = r2[n2], { locStart: i2, locEnd: D } = e2, s2 = D(u2);
  if (o2) for (let a2 = n2 + 1; a2 < r2.length; a2++) {
    let { comment: c2, followingNode: p2 } = r2[a2];
    if (p2 !== o2 || !cn(t4.slice(s2, i2(c2)))) break;
    s2 = D(c2);
  }
  return H(t4, s2);
}
function sn(t4, e2) {
  let r2 = t4.length;
  if (r2 === 0) return;
  let { precedingNode: n2, followingNode: u2 } = t4[0], o2 = e2.locStart(u2), i2;
  for (i2 = r2; i2 > 0; --i2) {
    let { comment: D, precedingNode: s2, followingNode: a2 } = t4[i2 - 1];
    let c2 = e2.originalText.slice(e2.locEnd(D), o2);
    if (e2.printer.isGap?.(c2, e2) ?? /^[\s(]*$/.test(c2)) o2 = e2.locStart(D);
    else break;
  }
  for (let [D, { comment: s2 }] of t4.entries()) D < i2 ? fe(n2, s2) : ce(u2, s2);
  for (let D of [n2, u2]) D.comments && D.comments.length > 1 && D.comments.sort((s2, a2) => e2.locStart(s2) - e2.locStart(a2));
  t4.length = 0;
}
function jt(t4, e2, r2) {
  let n2 = r2.locStart(e2) - 1;
  for (let u2 = 1; u2 < t4.length; ++u2) if (n2 < r2.locStart(t4[u2])) return u2 - 1;
  return 0;
}
function go(t4, e2) {
  let r2 = e2 - 1;
  r2 = j(t4, r2, { backwards: true }), r2 = $(t4, r2, { backwards: true }), r2 = j(t4, r2, { backwards: true });
  let n2 = $(t4, r2, { backwards: true });
  return r2 !== n2;
}
var ve = go;
var fn = () => true;
function ln(t4, e2) {
  let r2 = t4.node;
  return r2.printed = true, e2.printer.printComment(t4, e2);
}
function _o(t4, e2) {
  let r2 = t4.node, n2 = [ln(t4, e2)], { printer: u2, originalText: o2, locStart: i2, locEnd: D } = e2;
  if (u2.isBlockComment?.(r2)) {
    let c2 = " ";
    H(o2, D(r2)) && (H(o2, i2(r2), { backwards: true }) ? c2 = W : c2 = Ze), n2.push(c2);
  } else n2.push(W);
  let a2 = $(o2, j(o2, D(r2)));
  return a2 !== false && H(o2, a2) && n2.push(W), n2;
}
function yo(t4, e2, r2) {
  let n2 = t4.node, u2 = ln(t4, e2), { printer: o2, originalText: i2, locStart: D } = e2, s2 = o2.isBlockComment?.(n2);
  if (r2?.hasLineSuffix && !r2?.isBlock || H(i2, D(n2), { backwards: true })) {
    let a2 = ve(i2, D(n2));
    return { doc: Ie([W, a2 ? W : "", u2]), isBlock: s2, hasLineSuffix: true };
  }
  return !s2 || r2?.hasLineSuffix ? { doc: [Ie([" ", u2]), ae], isBlock: s2, hasLineSuffix: true } : { doc: [" ", u2], isBlock: s2, hasLineSuffix: false };
}
function Ao(t4, e2, r2) {
  let n2 = e2[/* @__PURE__ */ Symbol.for("printedComments")], u2 = fn, o2 = new Set(t4.node?.comments?.filter((i2) => !n2?.has(i2) && i2.leading && u2()));
  return o2.size === 0 ? "" : t4.map(({ node: i2 }) => o2.has(i2) ? _o(t4, e2) : "", "comments").filter(Boolean);
}
function xo(t4, e2, r2) {
  let n2 = t4.node?.comments, u2 = new Set(n2?.filter((c2) => c2.trailing)), o2 = e2[/* @__PURE__ */ Symbol.for("printedComments")], i2 = fn, D = new Set(n2?.filter((c2) => u2.has(c2) && !o2?.has(c2) && i2()));
  if (D.size === 0) return "";
  let s2 = [], a2;
  return t4.each(({ node: c2 }) => {
    u2.has(c2) && (a2 = yo(t4, e2, a2), D.has(c2) && s2.push(a2.doc));
  }, "comments"), s2;
}
function pn(t4, e2, r2, n2) {
  let u2 = Ao(t4, r2), o2 = xo(t4, r2);
  return u2 || o2 ? Ee(e2, (i2) => [u2, i2, o2]) : e2;
}
function mn(t4) {
  let { [ue]: e2, [/* @__PURE__ */ Symbol.for("printedComments")]: r2 } = t4;
  for (let n2 of e2) {
    if (!n2.printed && !r2.has(n2)) throw new Error('Comment "' + n2.value.trim() + '" was not printed. Please report this error!');
    delete n2.printed;
  }
}
var Le = class extends Error {
  name = "ConfigError";
}, Me = class extends Error {
  name = "UndefinedParserError";
};
var Bo = Object.hasOwn ?? Function.prototype.call.bind(Object.prototype.hasOwnProperty), le = Bo;
var Fn = { checkIgnorePragma: { category: "Special", type: "boolean", default: false, description: "Check whether the file's first docblock comment contains '@noprettier' or '@noformat' to determine if it should be formatted.", cliCategory: "Other" }, cursorOffset: { category: "Special", type: "int", default: -1, range: { start: -1, end: 1 / 0, step: 1 }, description: "Print (to stderr) where a cursor at the given position would move to after formatting.", cliCategory: "Editor" }, endOfLine: { category: "Global", type: "choice", default: "lf", description: "Which end of line characters to apply.", choices: [{ value: "lf", description: "Line Feed only (\\n), common on Linux and macOS as well as inside git repos" }, { value: "crlf", description: "Carriage Return + Line Feed characters (\\r\\n), common on Windows" }, { value: "cr", description: "Carriage Return character only (\\r), used very rarely" }, { value: "auto", description: `Maintain existing
(mixed values within one file are normalised by looking at what's used after the first line)` }] }, filepath: { category: "Special", type: "path", description: "Specify the input filepath. This will be used to do parser inference.", cliName: "stdin-filepath", cliCategory: "Other", cliDescription: "Path to the file to pretend that stdin comes from." }, insertPragma: { category: "Special", type: "boolean", default: false, description: "Insert @format pragma into file's first docblock comment.", cliCategory: "Other" }, parser: { category: "Global", type: "choice", default: void 0, description: "Which parser to use.", exception: (t4) => typeof t4 == "string" || typeof t4 == "function", choices: [{ value: "flow", description: "Flow" }, { value: "babel", description: "JavaScript" }, { value: "babel-flow", description: "Flow" }, { value: "babel-ts", description: "TypeScript" }, { value: "typescript", description: "TypeScript" }, { value: "acorn", description: "JavaScript" }, { value: "espree", description: "JavaScript" }, { value: "meriyah", description: "JavaScript" }, { value: "css", description: "CSS" }, { value: "less", description: "Less" }, { value: "scss", description: "SCSS" }, { value: "json", description: "JSON" }, { value: "json5", description: "JSON5" }, { value: "jsonc", description: "JSON with Comments" }, { value: "json-stringify", description: "JSON.stringify" }, { value: "graphql", description: "GraphQL" }, { value: "markdown", description: "Markdown" }, { value: "mdx", description: "MDX" }, { value: "vue", description: "Vue" }, { value: "yaml", description: "YAML" }, { value: "glimmer", description: "Ember / Handlebars" }, { value: "html", description: "HTML" }, { value: "angular", description: "Angular" }, { value: "lwc", description: "Lightning Web Components" }, { value: "mjml", description: "MJML" }] }, plugins: { type: "path", array: true, default: [{ value: [] }], category: "Global", description: "Add a plugin. Multiple plugins can be passed as separate `--plugin`s.", exception: (t4) => typeof t4 == "string" || typeof t4 == "object", cliName: "plugin", cliCategory: "Config" }, printWidth: { category: "Global", type: "int", default: 80, description: "The line length where Prettier will try wrap.", range: { start: 0, end: 1 / 0, step: 1 } }, rangeEnd: { category: "Special", type: "int", default: 1 / 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code ending at a given character offset (exclusive).
The range will extend forwards to the end of the selected statement.`, cliCategory: "Editor" }, rangeStart: { category: "Special", type: "int", default: 0, range: { start: 0, end: 1 / 0, step: 1 }, description: `Format code starting at a given character offset.
The range will extend backwards to the start of the first line containing the selected statement.`, cliCategory: "Editor" }, requirePragma: { category: "Special", type: "boolean", default: false, description: "Require either '@prettier' or '@format' to be present in the file's first docblock comment in order for it to be formatted.", cliCategory: "Other" }, tabWidth: { type: "int", category: "Global", default: 2, description: "Number of spaces per indentation level.", range: { start: 0, end: 1 / 0, step: 1 } }, useTabs: { category: "Global", type: "boolean", default: false, description: "Indent with tabs instead of spaces." }, embeddedLanguageFormatting: { category: "Global", type: "choice", default: "auto", description: "Control how Prettier formats quoted code embedded in the file.", choices: [{ value: "auto", description: "Format embedded code if Prettier can automatically identify it." }, { value: "off", description: "Never automatically format embedded code." }] } };
function it({ plugins: t4 = [], showDeprecated: e2 = false } = {}) {
  let r2 = t4.flatMap((u2) => u2.languages ?? []), n2 = [];
  for (let u2 of No(Object.assign({}, ...t4.map(({ options: o2 }) => o2), Fn))) !e2 && u2.deprecated || (Array.isArray(u2.choices) && (e2 || (u2.choices = u2.choices.filter((o2) => !o2.deprecated)), u2.name === "parser" && (u2.choices = [...u2.choices, ...To(u2.choices, r2, t4)])), u2.pluginDefaults = Object.fromEntries(t4.filter((o2) => o2.defaultOptions?.[u2.name] !== void 0).map((o2) => [o2.name, o2.defaultOptions[u2.name]])), n2.push(u2));
  return { languages: r2, options: n2 };
}
function* To(t4, e2, r2) {
  let n2 = new Set(t4.map((u2) => u2.value));
  for (let u2 of e2) if (u2.parsers) {
    for (let o2 of u2.parsers) if (!n2.has(o2)) {
      n2.add(o2);
      let i2 = r2.find((s2) => s2.parsers && le(s2.parsers, o2)), D = u2.name;
      i2?.name && (D += ` (plugin: ${i2.name})`), yield { value: o2, description: D };
    }
  }
}
function No(t4) {
  let e2 = [];
  for (let [r2, n2] of Object.entries(t4)) {
    let u2 = { name: r2, ...n2 };
    Array.isArray(u2.default) && (u2.default = y(0, u2.default, -1).value), e2.push(u2);
  }
  return e2;
}
var wo = Array.prototype.toReversed ?? function() {
  return [...this].reverse();
}, Oo = X("toReversed", function() {
  if (Array.isArray(this)) return wo;
}), En = Oo;
function Po() {
  let t4 = globalThis, e2 = t4.process?.platform;
  if (typeof e2 == "string") return e2.startsWith("win");
  let r2 = t4.Deno?.build?.os;
  return typeof r2 == "string" ? r2 === "windows" : t4.navigator?.platform?.startsWith("Win") ?? false;
}
var So = Po();
function Cn(t4) {
  if (t4 = t4 instanceof URL ? t4 : new URL(t4), t4.protocol !== "file:") throw new TypeError(`URL must be a file URL: received "${t4.protocol}"`);
  return t4;
}
function bo(t4) {
  return t4 = Cn(t4), decodeURIComponent(t4.pathname.replace(/%(?![0-9A-Fa-f]{2})/g, "%25"));
}
function ko(t4) {
  t4 = Cn(t4);
  let e2 = decodeURIComponent(t4.pathname.replace(/\//g, "\\").replace(/%(?![0-9A-Fa-f]{2})/g, "%25")).replace(/^\\*([A-Za-z]:)(\\|$)/, "$1\\");
  return t4.hostname !== "" && (e2 = `\\\\${t4.hostname}${e2}`), e2;
}
function Vt(t4) {
  return So ? ko(t4) : bo(t4);
}
var hn = (t4) => String(t4).split(/[/\\]/).pop(), gn = (t4) => String(t4).startsWith("file:");
function _n(t4, e2) {
  if (!e2) return;
  let r2 = hn(e2).toLowerCase();
  return t4.find(({ filenames: n2 }) => n2?.some((u2) => u2.toLowerCase() === r2)) ?? t4.find(({ extensions: n2 }) => n2?.some((u2) => r2.endsWith(u2)));
}
function Io(t4, e2) {
  if (e2) return t4.find(({ name: r2 }) => r2.toLowerCase() === e2) ?? t4.find(({ aliases: r2 }) => r2?.includes(e2)) ?? t4.find(({ extensions: r2 }) => r2?.includes(`.${e2}`));
}
var Ro = void 0;
function yn(t4, e2) {
  if (e2) {
    if (gn(e2)) try {
      e2 = Vt(e2);
    } catch {
      return;
    }
    if (typeof e2 == "string") return t4.find(({ isSupported: r2 }) => r2?.({ filepath: e2 }));
  }
}
function vo(t4, e2) {
  let r2 = En(0, t4.plugins).flatMap((u2) => u2.languages ?? []);
  return (Io(r2, e2.language) ?? _n(r2, e2.physicalFile) ?? _n(r2, e2.file) ?? yn(r2, e2.physicalFile) ?? yn(r2, e2.file) ?? Ro?.(r2, e2.physicalFile))?.parsers[0];
}
var st = vo;
var ie = { key: (t4) => /^[$_a-zA-Z][$_a-zA-Z0-9]*$/.test(t4) ? t4 : JSON.stringify(t4), value(t4) {
  if (t4 === null || typeof t4 != "object") return JSON.stringify(t4);
  if (Array.isArray(t4)) return `[${t4.map((r2) => ie.value(r2)).join(", ")}]`;
  let e2 = Object.keys(t4);
  return e2.length === 0 ? "{}" : `{ ${e2.map((r2) => `${ie.key(r2)}: ${ie.value(t4[r2])}`).join(", ")} }`;
}, pair: ({ key: t4, value: e2 }) => ie.value({ [t4]: e2 }) };
var An = new Proxy(String, { get: () => An }), z = An;
var xn = (t4, e2, { descriptor: r2 }) => {
  let n2 = [`${z.yellow(typeof t4 == "string" ? r2.key(t4) : r2.pair(t4))} is deprecated`];
  return e2 && n2.push(`we now treat it as ${z.blue(typeof e2 == "string" ? r2.key(e2) : r2.pair(e2))}`), n2.join("; ") + ".";
};
var Dt = /* @__PURE__ */ Symbol.for("vnopts.VALUE_NOT_EXIST"), Ae = /* @__PURE__ */ Symbol.for("vnopts.VALUE_UNCHANGED");
var Bn = " ".repeat(2), Nn = (t4, e2, r2) => {
  let { text: n2, list: u2 } = r2.normalizeExpectedResult(r2.schemas[t4].expected(r2)), o2 = [];
  return n2 && o2.push(Tn(t4, e2, n2, r2.descriptor)), u2 && o2.push([Tn(t4, e2, u2.title, r2.descriptor)].concat(u2.values.map((i2) => wn(i2, r2.loggerPrintWidth))).join(`
`)), On(o2, r2.loggerPrintWidth);
};
function Tn(t4, e2, r2, n2) {
  return [`Invalid ${z.red(n2.key(t4))} value.`, `Expected ${z.blue(r2)},`, `but received ${e2 === Dt ? z.gray("nothing") : z.red(n2.value(e2))}.`].join(" ");
}
function wn({ text: t4, list: e2 }, r2) {
  let n2 = [];
  return t4 && n2.push(`- ${z.blue(t4)}`), e2 && n2.push([`- ${z.blue(e2.title)}:`].concat(e2.values.map((u2) => wn(u2, r2 - Bn.length).replace(/^|\n/g, `$&${Bn}`))).join(`
`)), On(n2, r2);
}
function On(t4, e2) {
  if (t4.length === 1) return t4[0];
  let [r2, n2] = t4, [u2, o2] = t4.map((i2) => i2.split(`
`, 1)[0].length);
  return u2 > e2 && u2 > o2 ? n2 : r2;
}
var xe = [], Wt = [];
function at$1(t4, e2, r2) {
  if (t4 === e2) return 0;
  let n2 = r2?.maxDistance, u2 = t4;
  t4.length > e2.length && (t4 = e2, e2 = u2);
  let o2 = t4.length, i2 = e2.length;
  for (; o2 > 0 && t4.charCodeAt(~-o2) === e2.charCodeAt(~-i2); ) o2--, i2--;
  let D = 0;
  for (; D < o2 && t4.charCodeAt(D) === e2.charCodeAt(D); ) D++;
  if (o2 -= D, i2 -= D, n2 !== void 0 && i2 - o2 > n2) return n2;
  if (o2 === 0) return n2 !== void 0 && i2 > n2 ? n2 : i2;
  let s2, a2, c2, p2, l2 = 0, m2 = 0;
  for (; l2 < o2; ) Wt[l2] = t4.charCodeAt(D + l2), xe[l2] = ++l2;
  for (; m2 < i2; ) {
    for (s2 = e2.charCodeAt(D + m2), c2 = m2++, a2 = m2, l2 = 0; l2 < o2; l2++) p2 = s2 === Wt[l2] ? c2 : c2 + 1, c2 = xe[l2], a2 = xe[l2] = c2 > a2 ? p2 > a2 ? a2 + 1 : p2 : p2 > c2 ? c2 + 1 : p2;
    if (n2 !== void 0) {
      let f2 = a2;
      for (l2 = 0; l2 < o2; l2++) xe[l2] < f2 && (f2 = xe[l2]);
      if (f2 > n2) return n2;
    }
  }
  return xe.length = o2, Wt.length = o2, n2 !== void 0 && a2 > n2 ? n2 : a2;
}
function Pn(t4, e2, r2) {
  if (!Array.isArray(e2) || e2.length === 0) return;
  let n2 = r2?.maxDistance, u2 = t4.length;
  for (let s2 of e2) if (s2 === t4) return s2;
  let o2, i2 = Number.POSITIVE_INFINITY, D = /* @__PURE__ */ new Set();
  for (let s2 of e2) {
    if (D.has(s2)) continue;
    D.add(s2);
    let a2 = Math.abs(s2.length - u2);
    if (a2 >= i2 || a2 > n2) continue;
    let c2 = Number.isFinite(i2) ? Math.min(i2, n2) : n2, p2 = c2 === void 0 ? at$1(t4, s2) : at$1(t4, s2, { maxDistance: c2 });
    if (p2 > n2) continue;
    let l2 = p2;
    if (c2 !== void 0 && p2 === c2 && c2 === n2 && (l2 = at$1(t4, s2)), l2 < i2 && (i2 = l2, o2 = s2, i2 === 0)) break;
  }
  if (!(i2 > n2)) return o2;
}
var ct = (t4, e2, { descriptor: r2, logger: n2, schemas: u2 }) => {
  let o2 = [`Ignored unknown option ${z.yellow(r2.pair({ key: t4, value: e2 }))}.`], i2 = Pn(t4, Object.keys(u2), { maxDistance: 3 });
  i2 && o2.push(`Did you mean ${z.blue(r2.key(i2))}?`), n2.warn(o2.join(" "));
};
var Lo = ["default", "expected", "validate", "deprecated", "forward", "redirect", "overlap", "preprocess", "postprocess"];
function Mo(t4, e2) {
  let r2 = new t4(e2), n2 = Object.create(r2);
  for (let u2 of Lo) u2 in e2 && (n2[u2] = Yo(e2[u2], r2, O.prototype[u2].length));
  return n2;
}
var O = class {
  static create(e2) {
    return Mo(this, e2);
  }
  constructor(e2) {
    this.name = e2.name;
  }
  default(e2) {
  }
  expected(e2) {
    return "nothing";
  }
  validate(e2, r2) {
    return false;
  }
  deprecated(e2, r2) {
    return false;
  }
  forward(e2, r2) {
  }
  redirect(e2, r2) {
  }
  overlap(e2, r2, n2) {
    return e2;
  }
  preprocess(e2, r2) {
    return e2;
  }
  postprocess(e2, r2) {
    return Ae;
  }
};
function Yo(t4, e2, r2) {
  return typeof t4 == "function" ? (...n2) => t4(...n2.slice(0, r2 - 1), e2, ...n2.slice(r2 - 1)) : () => t4;
}
var ft = class extends O {
  constructor(e2) {
    super(e2), this._sourceName = e2.sourceName;
  }
  expected(e2) {
    return e2.schemas[this._sourceName].expected(e2);
  }
  validate(e2, r2) {
    return r2.schemas[this._sourceName].validate(e2, r2);
  }
  redirect(e2, r2) {
    return this._sourceName;
  }
};
var lt = class extends O {
  expected() {
    return "anything";
  }
  validate() {
    return true;
  }
};
var pt = class extends O {
  constructor({ valueSchema: e2, name: r2 = e2.name, ...n2 }) {
    super({ ...n2, name: r2 }), this._valueSchema = e2;
  }
  expected(e2) {
    let { text: r2, list: n2 } = e2.normalizeExpectedResult(this._valueSchema.expected(e2));
    return { text: r2 && `an array of ${r2}`, list: n2 && { title: "an array of the following values", values: [{ list: n2 }] } };
  }
  validate(e2, r2) {
    if (!Array.isArray(e2)) return false;
    let n2 = [];
    for (let u2 of e2) {
      let o2 = r2.normalizeValidateResult(this._valueSchema.validate(u2, r2), u2);
      o2 !== true && n2.push(o2.value);
    }
    return n2.length === 0 ? true : { value: n2 };
  }
  deprecated(e2, r2) {
    let n2 = [];
    for (let u2 of e2) {
      let o2 = r2.normalizeDeprecatedResult(this._valueSchema.deprecated(u2, r2), u2);
      o2 !== false && n2.push(...o2.map(({ value: i2 }) => ({ value: [i2] })));
    }
    return n2;
  }
  forward(e2, r2) {
    let n2 = [];
    for (let u2 of e2) {
      let o2 = r2.normalizeForwardResult(this._valueSchema.forward(u2, r2), u2);
      n2.push(...o2.map(Sn));
    }
    return n2;
  }
  redirect(e2, r2) {
    let n2 = [], u2 = [];
    for (let o2 of e2) {
      let i2 = r2.normalizeRedirectResult(this._valueSchema.redirect(o2, r2), o2);
      "remain" in i2 && n2.push(i2.remain), u2.push(...i2.redirect.map(Sn));
    }
    return n2.length === 0 ? { redirect: u2 } : { redirect: u2, remain: n2 };
  }
  overlap(e2, r2) {
    return e2.concat(r2);
  }
};
function Sn({ from: t4, to: e2 }) {
  return { from: [t4], to: e2 };
}
var mt = class extends O {
  expected() {
    return "true or false";
  }
  validate(e2) {
    return typeof e2 == "boolean";
  }
};
function kn(t4, e2) {
  let r2 = /* @__PURE__ */ Object.create(null);
  for (let n2 of t4) {
    let u2 = n2[e2];
    if (r2[u2]) throw new Error(`Duplicate ${e2} ${JSON.stringify(u2)}`);
    r2[u2] = n2;
  }
  return r2;
}
function In(t4, e2) {
  let r2 = /* @__PURE__ */ new Map();
  for (let n2 of t4) {
    let u2 = n2[e2];
    if (r2.has(u2)) throw new Error(`Duplicate ${e2} ${JSON.stringify(u2)}`);
    r2.set(u2, n2);
  }
  return r2;
}
function Rn() {
  let t4 = /* @__PURE__ */ Object.create(null);
  return (e2) => {
    let r2 = JSON.stringify(e2);
    return t4[r2] ? true : (t4[r2] = true, false);
  };
}
function vn(t4, e2) {
  let r2 = [], n2 = [];
  for (let u2 of t4) e2(u2) ? r2.push(u2) : n2.push(u2);
  return [r2, n2];
}
function Ln(t4) {
  return t4 === Math.floor(t4);
}
function Mn(t4, e2) {
  if (t4 === e2) return 0;
  let r2 = typeof t4, n2 = typeof e2, u2 = ["undefined", "object", "boolean", "number", "string"];
  return r2 !== n2 ? u2.indexOf(r2) - u2.indexOf(n2) : r2 !== "string" ? Number(t4) - Number(e2) : t4.localeCompare(e2);
}
function Yn(t4) {
  return (...e2) => {
    let r2 = t4(...e2);
    return typeof r2 == "string" ? new Error(r2) : r2;
  };
}
function $t(t4) {
  return t4 === void 0 ? {} : t4;
}
function zt(t4) {
  if (typeof t4 == "string") return { text: t4 };
  let { text: e2, list: r2 } = t4;
  return jo((e2 || r2) !== void 0, "Unexpected `expected` result, there should be at least one field."), r2 ? { text: e2, list: { title: r2.title, values: r2.values.map(zt) } } : { text: e2 };
}
function Gt(t4, e2) {
  return t4 === true ? true : t4 === false ? { value: e2 } : t4;
}
function Kt(t4, e2, r2 = false) {
  return t4 === false ? false : t4 === true ? r2 ? true : [{ value: e2 }] : "value" in t4 ? [t4] : t4.length === 0 ? false : t4;
}
function bn(t4, e2) {
  return typeof t4 == "string" || "key" in t4 ? { from: e2, to: t4 } : "from" in t4 ? { from: t4.from, to: t4.to } : { from: e2, to: t4.to };
}
function dt(t4, e2) {
  return t4 === void 0 ? [] : Array.isArray(t4) ? t4.map((r2) => bn(r2, e2)) : [bn(t4, e2)];
}
function Ht(t4, e2) {
  let r2 = dt(typeof t4 == "object" && "redirect" in t4 ? t4.redirect : t4, e2);
  return r2.length === 0 ? { remain: e2, redirect: r2 } : typeof t4 == "object" && "remain" in t4 ? { remain: t4.remain, redirect: r2 } : { redirect: r2 };
}
function jo(t4, e2) {
  if (!t4) throw new Error(e2);
}
var Ft = class extends O {
  constructor(e2) {
    super(e2), this._choices = In(e2.choices.map((r2) => r2 && typeof r2 == "object" ? r2 : { value: r2 }), "value");
  }
  expected({ descriptor: e2 }) {
    let r2 = Array.from(this._choices.keys()).map((i2) => this._choices.get(i2)).filter(({ hidden: i2 }) => !i2).map((i2) => i2.value).sort(Mn).map(e2.value), n2 = r2.slice(0, -2), u2 = r2.slice(-2);
    return { text: n2.concat(u2.join(" or ")).join(", "), list: { title: "one of the following values", values: r2 } };
  }
  validate(e2) {
    return this._choices.has(e2);
  }
  deprecated(e2) {
    let r2 = this._choices.get(e2);
    return r2 && r2.deprecated ? { value: e2 } : false;
  }
  forward(e2) {
    let r2 = this._choices.get(e2);
    return r2 ? r2.forward : void 0;
  }
  redirect(e2) {
    let r2 = this._choices.get(e2);
    return r2 ? r2.redirect : void 0;
  }
};
var Et = class extends O {
  expected() {
    return "a number";
  }
  validate(e2, r2) {
    return typeof e2 == "number";
  }
};
var Ct = class extends Et {
  expected() {
    return "an integer";
  }
  validate(e2, r2) {
    return r2.normalizeValidateResult(super.validate(e2, r2), e2) === true && Ln(e2);
  }
};
var Ye = class extends O {
  expected() {
    return "a string";
  }
  validate(e2) {
    return typeof e2 == "string";
  }
};
var jn = ie, Un = ct, Vn = Nn, Wn = xn;
var ht = class {
  constructor(e2, r2) {
    let { logger: n2 = console, loggerPrintWidth: u2 = 80, descriptor: o2 = jn, unknown: i2 = Un, invalid: D = Vn, deprecated: s2 = Wn, missing: a2 = () => false, required: c2 = () => false, preprocess: p2 = (m2) => m2, postprocess: l2 = () => Ae } = r2 || {};
    this._utils = { descriptor: o2, logger: n2 || { warn: () => {
    } }, loggerPrintWidth: u2, schemas: kn(e2, "name"), normalizeDefaultResult: $t, normalizeExpectedResult: zt, normalizeDeprecatedResult: Kt, normalizeForwardResult: dt, normalizeRedirectResult: Ht, normalizeValidateResult: Gt }, this._unknownHandler = i2, this._invalidHandler = Yn(D), this._deprecatedHandler = s2, this._identifyMissing = (m2, f2) => !(m2 in f2) || a2(m2, f2), this._identifyRequired = c2, this._preprocess = p2, this._postprocess = l2, this.cleanHistory();
  }
  cleanHistory() {
    this._hasDeprecationWarned = Rn();
  }
  normalize(e2) {
    let r2 = {}, u2 = [this._preprocess(e2, this._utils)], o2 = () => {
      for (; u2.length !== 0; ) {
        let i2 = u2.shift(), D = this._applyNormalization(i2, r2);
        u2.push(...D);
      }
    };
    o2();
    for (let i2 of Object.keys(this._utils.schemas)) {
      let D = this._utils.schemas[i2];
      if (!(i2 in r2)) {
        let s2 = $t(D.default(this._utils));
        "value" in s2 && u2.push({ [i2]: s2.value });
      }
    }
    o2();
    for (let i2 of Object.keys(this._utils.schemas)) {
      if (!(i2 in r2)) continue;
      let D = this._utils.schemas[i2], s2 = r2[i2], a2 = D.postprocess(s2, this._utils);
      a2 !== Ae && (this._applyValidation(a2, i2, D), r2[i2] = a2);
    }
    return this._applyPostprocess(r2), this._applyRequiredCheck(r2), r2;
  }
  _applyNormalization(e2, r2) {
    let n2 = [], { knownKeys: u2, unknownKeys: o2 } = this._partitionOptionKeys(e2);
    for (let i2 of u2) {
      let D = this._utils.schemas[i2], s2 = D.preprocess(e2[i2], this._utils);
      this._applyValidation(s2, i2, D);
      let a2 = ({ from: m2, to: f2 }) => {
        n2.push(typeof f2 == "string" ? { [f2]: m2 } : { [f2.key]: f2.value });
      }, c2 = ({ value: m2, redirectTo: f2 }) => {
        let F = Kt(D.deprecated(m2, this._utils), s2, true);
        if (F !== false) if (F === true) this._hasDeprecationWarned(i2) || this._utils.logger.warn(this._deprecatedHandler(i2, f2, this._utils));
        else for (let { value: d2 } of F) {
          let E = { key: i2, value: d2 };
          if (!this._hasDeprecationWarned(E)) {
            let C2 = typeof f2 == "string" ? { key: f2, value: d2 } : f2;
            this._utils.logger.warn(this._deprecatedHandler(E, C2, this._utils));
          }
        }
      };
      dt(D.forward(s2, this._utils), s2).forEach(a2);
      let l2 = Ht(D.redirect(s2, this._utils), s2);
      if (l2.redirect.forEach(a2), "remain" in l2) {
        let m2 = l2.remain;
        r2[i2] = i2 in r2 ? D.overlap(r2[i2], m2, this._utils) : m2, c2({ value: m2 });
      }
      for (let { from: m2, to: f2 } of l2.redirect) c2({ value: m2, redirectTo: f2 });
    }
    for (let i2 of o2) {
      let D = e2[i2];
      this._applyUnknownHandler(i2, D, r2, (s2, a2) => {
        n2.push({ [s2]: a2 });
      });
    }
    return n2;
  }
  _applyRequiredCheck(e2) {
    for (let r2 of Object.keys(this._utils.schemas)) if (this._identifyMissing(r2, e2) && this._identifyRequired(r2)) throw this._invalidHandler(r2, Dt, this._utils);
  }
  _partitionOptionKeys(e2) {
    let [r2, n2] = vn(Object.keys(e2).filter((u2) => !this._identifyMissing(u2, e2)), (u2) => u2 in this._utils.schemas);
    return { knownKeys: r2, unknownKeys: n2 };
  }
  _applyValidation(e2, r2, n2) {
    let u2 = Gt(n2.validate(e2, this._utils), e2);
    if (u2 !== true) throw this._invalidHandler(r2, u2.value, this._utils);
  }
  _applyUnknownHandler(e2, r2, n2, u2) {
    let o2 = this._unknownHandler(e2, r2, this._utils);
    if (o2) for (let i2 of Object.keys(o2)) {
      if (this._identifyMissing(i2, o2)) continue;
      let D = o2[i2];
      i2 in this._utils.schemas ? u2(i2, D) : n2[i2] = D;
    }
  }
  _applyPostprocess(e2) {
    let r2 = this._postprocess(e2, this._utils);
    if (r2 !== Ae) {
      if (r2.delete) for (let n2 of r2.delete) delete e2[n2];
      if (r2.override) {
        let { knownKeys: n2, unknownKeys: u2 } = this._partitionOptionKeys(r2.override);
        for (let o2 of n2) {
          let i2 = r2.override[o2];
          this._applyValidation(i2, o2, this._utils.schemas[o2]), e2[o2] = i2;
        }
        for (let o2 of u2) {
          let i2 = r2.override[o2];
          this._applyUnknownHandler(o2, i2, e2, (D, s2) => {
            let a2 = this._utils.schemas[D];
            this._applyValidation(s2, D, a2), e2[D] = s2;
          });
        }
      }
    }
  }
};
var Jt;
function Uo(t4, e2, { logger: r2 = false, isCLI: n2 = false, passThrough: u2 = false, FlagSchema: o2, descriptor: i2 } = {}) {
  if (n2) {
    if (!o2) throw new Error("'FlagSchema' option is required.");
    if (!i2) throw new Error("'descriptor' option is required.");
  } else i2 = ie;
  let D = u2 ? Array.isArray(u2) ? (l2, m2) => u2.includes(l2) ? { [l2]: m2 } : void 0 : (l2, m2) => ({ [l2]: m2 }) : (l2, m2, f2) => {
    let { _: F, ...d2 } = f2.schemas;
    return ct(l2, m2, { ...f2, schemas: d2 });
  }, s2 = Vo(e2, { isCLI: n2, FlagSchema: o2 }), a2 = new ht(s2, { logger: r2, unknown: D, descriptor: i2 }), c2 = r2 !== false;
  c2 && Jt && (a2._hasDeprecationWarned = Jt);
  let p2 = a2.normalize(t4);
  return c2 && (Jt = a2._hasDeprecationWarned), p2;
}
function Vo(t4, { isCLI: e2, FlagSchema: r2 }) {
  let n2 = [];
  e2 && n2.push(lt.create({ name: "_" }));
  for (let u2 of t4) n2.push(Wo(u2, { isCLI: e2, optionInfos: t4, FlagSchema: r2 })), u2.alias && e2 && n2.push(ft.create({ name: u2.alias, sourceName: u2.name }));
  return n2;
}
function Wo(t4, { isCLI: e2, optionInfos: r2, FlagSchema: n2 }) {
  let { name: u2 } = t4, o2 = { name: u2 }, i2, D = {};
  switch (t4.type) {
    case "int":
      i2 = Ct, e2 && (o2.preprocess = Number);
      break;
    case "string":
      i2 = Ye;
      break;
    case "choice":
      i2 = Ft, o2.choices = t4.choices.map((s2) => s2?.redirect ? { ...s2, redirect: { to: { key: t4.name, value: s2.redirect } } } : s2);
      break;
    case "boolean":
      i2 = mt;
      break;
    case "flag":
      i2 = n2, o2.flags = r2.flatMap((s2) => [s2.alias, s2.description && s2.name, s2.oppositeDescription && `no-${s2.name}`].filter(Boolean));
      break;
    case "path":
      i2 = Ye;
      break;
    default:
      throw new Error(`Unexpected type ${t4.type}`);
  }
  if (t4.exception ? o2.validate = (s2, a2, c2) => t4.exception(s2) || a2.validate(s2, c2) : o2.validate = (s2, a2, c2) => s2 === void 0 || a2.validate(s2, c2), t4.redirect && (D.redirect = (s2) => s2 ? { to: typeof t4.redirect == "string" ? t4.redirect : { key: t4.redirect.option, value: t4.redirect.value } } : void 0), t4.deprecated && (D.deprecated = true), e2 && !t4.array) {
    let s2 = o2.preprocess || ((a2) => a2);
    o2.preprocess = (a2, c2, p2) => c2.preprocess(s2(Array.isArray(a2) ? y(0, a2, -1) : a2), p2);
  }
  return t4.array ? pt.create({ ...e2 ? { preprocess: (s2) => Array.isArray(s2) ? s2 : [s2] } : {}, ...D, valueSchema: i2.create(o2) }) : i2.create({ ...o2, ...D });
}
var $n = Uo;
var $o = Array.prototype.findLast ?? function(t4) {
  for (let e2 = this.length - 1; e2 >= 0; e2--) {
    let r2 = this[e2];
    if (t4(r2, e2, this)) return r2;
  }
}, zo = X("findLast", function() {
  if (Array.isArray(this)) return $o;
}), qt = zo;
var zn = /* @__PURE__ */ Symbol.for("PRETTIER_IS_FRONT_MATTER"), Xt = [];
function Go(t4) {
  return !!t4?.[zn];
}
var pe = Go;
var Gn = /* @__PURE__ */ new Set(["yaml", "toml"]), je = ({ node: t4 }) => pe(t4) && Gn.has(t4.language);
async function Qt(t4, e2, r2, n2) {
  let { node: u2 } = r2, { language: o2 } = u2;
  if (!Gn.has(o2)) return;
  let i2 = u2.value.trim(), D;
  if (i2) {
    let s2 = o2 === "yaml" ? o2 : st(n2, { language: o2 });
    if (!s2) return;
    D = i2 ? await t4(i2, { parser: s2 }) : "";
  } else D = i2;
  return Xe([u2.startDelimiter, u2.explicitLanguage ?? "", W, D, D ? W : "", u2.endDelimiter]);
}
function Ko(t4, e2) {
  return je({ node: t4 }) && (delete e2.end, delete e2.raw, delete e2.value), e2;
}
var Zt = Ko;
function Ho({ node: t4 }) {
  return t4.raw;
}
var er = Ho;
var Kn = /* @__PURE__ */ new Set(["tokens", "comments", "parent", "enclosingNode", "precedingNode", "followingNode"]), Jo = (t4) => Object.keys(t4).filter((e2) => !Kn.has(e2));
function qo(t4, e2) {
  let r2 = t4 ? (n2) => t4(n2, Kn) : Jo;
  return e2 ? new Proxy(r2, { apply: (n2, u2, o2) => pe(o2[0]) ? Xt : Reflect.apply(n2, u2, o2) }) : r2;
}
var tr = qo;
function rr(t4, e2) {
  if (!e2) throw new Error("parserName is required.");
  let r2 = qt(0, t4, (u2) => u2.parsers && le(u2.parsers, e2));
  if (r2) return r2;
  let n2 = `Couldn't resolve parser "${e2}".`;
  throw n2 += " Plugins must be explicitly added to the standalone bundle.", new Le(n2);
}
function Hn(t4, e2) {
  if (!e2) throw new Error("astFormat is required.");
  let r2 = qt(0, t4, (u2) => u2.printers && le(u2.printers, e2));
  if (r2) return r2;
  let n2 = `Couldn't find plugin for AST format "${e2}".`;
  throw n2 += " Plugins must be explicitly added to the standalone bundle.", new Le(n2);
}
function Ue({ plugins: t4, parser: e2 }) {
  let r2 = rr(t4, e2);
  return nr(r2, e2);
}
function nr(t4, e2) {
  let r2 = t4.parsers[e2];
  return typeof r2 == "function" ? r2() : r2;
}
async function Jn(t4, e2) {
  let r2 = t4.printers[e2], n2 = typeof r2 == "function" ? await r2() : r2;
  return Zo(n2);
}
function Xo(t4) {
  let { features: e2, getVisitorKeys: r2, embed: n2, massageAstNode: u2, print: o2, ...i2 } = t4;
  e2 = ni(e2);
  let D = e2.experimental_frontMatterSupport;
  r2 = tr(r2, D.massageAstNode || D.embed || D.print);
  let s2 = u2;
  u2 && D.massageAstNode && (s2 = new Proxy(u2, { apply(l2, m2, f2) {
    return Zt(...f2), Reflect.apply(l2, m2, f2);
  } }));
  let a2 = n2;
  if (n2) {
    let l2;
    a2 = new Proxy(n2, { get(m2, f2, F) {
      return f2 === "getVisitorKeys" ? (l2 ?? (l2 = n2.getVisitorKeys ? tr(n2.getVisitorKeys, D.massageAstNode || D.embed) : r2), l2) : Reflect.get(m2, f2, F);
    }, apply: (m2, f2, F) => D.embed && je(...F) ? Qt : Reflect.apply(m2, f2, F) });
  }
  let c2 = o2;
  return D.print && (c2 = new Proxy(o2, { apply(l2, m2, f2) {
    let [F] = f2;
    return pe(F.node) ? er(F) : Reflect.apply(l2, m2, f2);
  } })), { features: e2, getVisitorKeys: r2, embed: a2, massageAstNode: s2, print: c2, ...i2 };
}
var Qo = /* @__PURE__ */ new WeakMap();
function Zo(t4) {
  return Fe(Qo, t4, Xo);
}
var ei = ["clean", "embed", "print"], ti = Object.fromEntries(ei.map((t4) => [t4, false]));
function ri(t4) {
  return { ...ti, ...t4 };
}
function ni(t4) {
  return { experimental_avoidAstMutation: false, ...t4, experimental_frontMatterSupport: ri(t4?.experimental_frontMatterSupport) };
}
var qn = { astFormat: "estree", printer: {}, originalText: void 0, locStart: null, locEnd: null, getVisitorKeys: null };
async function ui(t4, e2 = {}) {
  let r2 = { ...t4 };
  if (!r2.parser) {
    if (!r2.filepath) throw new Me("No parser and no file path given, couldn't infer a parser.");
    if (r2.parser = st(r2, { physicalFile: r2.filepath }), !r2.parser) throw new Me(`No parser could be inferred for file "${r2.filepath}".`);
  }
  let n2 = it({ plugins: t4.plugins, showDeprecated: true }).options, u2 = { ...qn, ...Object.fromEntries(n2.filter((p2) => p2.default !== void 0).map((p2) => [p2.name, p2.default])) }, o2 = rr(r2.plugins, r2.parser), i2 = await nr(o2, r2.parser);
  r2.astFormat = i2.astFormat, r2.locEnd = i2.locEnd, r2.locStart = i2.locStart;
  let D = o2.printers?.[i2.astFormat] ? o2 : Hn(r2.plugins, i2.astFormat), s2 = await Jn(D, i2.astFormat);
  r2.printer = s2, r2.getVisitorKeys = s2.getVisitorKeys;
  let a2 = D.defaultOptions ? Object.fromEntries(Object.entries(D.defaultOptions).filter(([, p2]) => p2 !== void 0)) : {}, c2 = { ...u2, ...a2 };
  for (let [p2, l2] of Object.entries(c2)) r2[p2] ?? (r2[p2] = l2);
  return r2.parser === "json" && (r2.trailingComma = "none"), $n(r2, n2, { passThrough: Object.keys(qn), ...e2 });
}
var se = ui;
var Xn = /\r\n|[\n\r\u2028\u2029]/;
function oi(t4, e2, r2, n2) {
  let u2 = { column: null, line: -1, ...t4.start }, o2 = { ...u2, ...t4.end }, { linesAbove: i2 = 2, linesBelow: D = 3 } = r2 || {}, s2 = u2.line - n2, a2 = u2.column, c2 = o2.line - n2, p2 = o2.column, l2 = Math.max(s2 - (i2 + 1), 0), m2 = Math.min(e2.length, c2 + D);
  s2 === -1 && (l2 = 0), c2 === -1 && (m2 = e2.length);
  let f2 = c2 - s2, F = {};
  if (f2) for (let d2 = 0; d2 <= f2; d2++) {
    let E = d2 + s2;
    if (a2 == null) F[E] = true;
    else if (d2 === 0) {
      let C2 = e2[E - 1].length;
      F[E] = [a2, C2 - a2];
    } else if (d2 === f2) F[E] = [0, p2];
    else {
      let C2 = e2[E - 1].length;
      F[E] = [0, C2];
    }
  }
  else if (a2 === p2) a2 != null ? F[s2] = [a2, 0] : F[s2] = true;
  else {
    let d2 = a2 ?? 0, E = p2 ?? d2;
    F[s2] = [d2, E - d2];
  }
  return { start: l2, end: m2, markerLines: F };
}
function Qn(t4, e2, r2 = {}, n2) {
  let { defs: u2, highlight: o2 } = { defs: { gutter: String, marker: String, message: String, reset: String }, highlight: String }, i2 = (r2.startLine || 1) - 1, D = t4.split(Xn), { start: s2, end: a2, markerLines: c2 } = oi(e2, D, r2, i2), p2 = e2.start && typeof e2.start.column == "number", l2 = String(a2 + i2).length, f2 = o2(t4).split(Xn, a2).slice(s2, a2).map((F, d2) => {
    let E = s2 + 1 + d2, h2 = ` ${` ${E + i2}`.slice(-l2)} |`, _2 = c2[E], P2 = !c2[E + 1];
    if (_2) {
      let A2 = "";
      if (Array.isArray(_2)) {
        let B2 = F.slice(0, _2[0]).replace(/[^\t]/g, " "), J = _2[1] || 1;
        A2 = [`
 `, u2.gutter(h2.replace(/\d/g, " ")), " ", B2, u2.marker("^").repeat(J)].join(""), P2 && r2.message && (A2 += " " + u2.message(r2.message));
      }
      return [u2.marker(">"), u2.gutter(h2), F.length > 0 ? ` ${F}` : "", A2].join("");
    } else return ` ${u2.gutter(h2)}${F.length > 0 ? ` ${F}` : ""}`;
  }).join(`
`);
  return r2.message && !p2 && (f2 = `${" ".repeat(l2 + 1)}${r2.message}
${f2}`), u2.reset(f2);
}
function Zn(t4, e2, r2 = {}) {
  return Qn(t4, e2, r2);
}
async function ii(t4, e2) {
  let r2 = await Ue(e2), n2 = r2.preprocess ? await r2.preprocess(t4, e2) : t4;
  e2.originalText = n2;
  let u2;
  try {
    u2 = await r2.parse(n2, e2, e2);
  } catch (o2) {
    si(o2, t4);
  }
  return { text: n2, ast: u2 };
}
function si(t4, e2) {
  let { loc: r2 } = t4;
  if (r2) {
    let { start: n2, end: u2 } = r2;
    n2 && (n2 = { line: n2.line, column: n2.column - 1 }), u2 && (u2 = { line: u2.line, column: u2.column - 1 });
    let o2 = Zn(e2, { start: n2, end: u2 }, {});
    t4.message += `
` + o2, t4.codeFrame = o2;
  }
  throw t4;
}
var me = ii;
async function eu(t4, e2, r2, n2, u2) {
  if (r2.embeddedLanguageFormatting !== "auto") return;
  let { printer: o2 } = r2, { embed: i2 } = o2;
  if (!i2) return;
  if (i2.length > 2) throw new Error("printer.embed has too many parameters. The API changed in Prettier v3. Please update your plugin. See https://prettier.io/docs/plugins#optional-embed");
  let { hasPrettierIgnore: D } = o2, { getVisitorKeys: s2 } = i2, a2 = [];
  l2();
  let c2 = t4.stack;
  for (let { print: m2, node: f2, pathStack: F } of a2) try {
    t4.stack = F;
    let d2 = await m2(p2, e2, t4, r2);
    d2 && u2.set(f2, d2);
  } catch (d2) {
    if (globalThis.PRETTIER_DEBUG) throw d2;
  }
  t4.stack = c2;
  function p2(m2, f2) {
    return Di(m2, f2, r2, n2);
  }
  function l2() {
    let { node: m2 } = t4;
    if (m2 === null || typeof m2 != "object" || D?.(t4)) return;
    for (let F of s2(m2)) Array.isArray(m2[F]) ? t4.each(l2, F) : t4.call(l2, F);
    let f2 = i2(t4, r2);
    if (f2) {
      if (typeof f2 == "function") {
        a2.push({ print: f2, node: m2, pathStack: [...t4.stack] });
        return;
      }
      u2.set(m2, f2);
    }
  }
}
async function Di(t4, e2, r2, n2) {
  let u2 = await se({ ...r2, ...e2, parentParser: r2.parser, originalText: t4, cursorOffset: void 0, rangeStart: void 0, rangeEnd: void 0 }, { passThrough: true }), { ast: o2 } = await me(t4, u2), i2 = await n2(o2, u2);
  return He(i2);
}
function ai(t4, e2, r2, n2) {
  let { originalText: u2, [ue]: o2, locStart: i2, locEnd: D, [/* @__PURE__ */ Symbol.for("printedComments")]: s2 } = e2, { node: a2 } = t4, c2 = i2(a2), p2 = D(a2);
  for (let m2 of o2) i2(m2) >= c2 && D(m2) <= p2 && s2.add(m2);
  let { printPrettierIgnored: l2 } = e2.printer;
  return l2 ? l2(t4, e2, r2, n2) : u2.slice(c2, p2);
}
var tu = ai;
async function Ve(t4, e2) {
  ({ ast: t4 } = await ur(t4, e2));
  let r2 = /* @__PURE__ */ new Map(), n2 = new en(t4), o2 = /* @__PURE__ */ new Map();
  await eu(n2, D, e2, Ve, o2);
  let i2 = await ru(n2, e2, D, void 0, o2);
  if (mn(e2), e2.cursorOffset >= 0) {
    if (e2.nodeAfterCursor && !e2.nodeBeforeCursor) return [ee, i2];
    if (e2.nodeBeforeCursor && !e2.nodeAfterCursor) return [i2, ee];
  }
  return i2;
  function D(a2, c2) {
    return a2 === void 0 || a2 === n2 ? s2(c2) : Array.isArray(a2) ? n2.call(() => s2(c2), ...a2) : n2.call(() => s2(c2), a2);
  }
  function s2(a2) {
    let c2 = n2.node;
    if (c2 == null) return "";
    let p2 = ge(c2) && a2 === void 0;
    if (p2 && r2.has(c2)) return r2.get(c2);
    let l2 = ru(n2, e2, D, a2, o2);
    return p2 && r2.set(c2, l2), l2;
  }
}
function ru(t4, e2, r2, n2, u2) {
  let { node: o2 } = t4, { printer: i2 } = e2, D;
  switch (i2.hasPrettierIgnore?.(t4) ? D = tu(t4, e2, r2, n2) : u2.has(o2) ? D = u2.get(o2) : D = i2.print(t4, e2, r2, n2), o2) {
    case e2.cursorNode:
      D = Ee(D, (s2) => [ee, s2, ee]);
      break;
    case e2.nodeBeforeCursor:
      D = Ee(D, (s2) => [s2, ee]);
      break;
    case e2.nodeAfterCursor:
      D = Ee(D, (s2) => [ee, s2]);
      break;
  }
  return i2.printComment && rt(o2.comments) && !i2.willPrintOwnComments?.(t4, e2) && (D = pn(t4, D, e2)), D;
}
async function ur(t4, e2) {
  let r2 = t4.comments ?? [];
  e2[ue] = r2, e2[/* @__PURE__ */ Symbol.for("printedComments")] = /* @__PURE__ */ new Set(), an(t4, e2);
  let { printer: { preprocess: n2 } } = e2;
  return t4 = n2 ? await n2(t4, e2) : t4, { ast: t4, comments: r2 };
}
function ci(t4, e2) {
  let { cursorOffset: r2, locStart: n2, locEnd: u2, getVisitorKeys: o2 } = e2, i2 = (m2) => n2(m2) <= r2 && u2(m2) >= r2, D = t4, s2 = [t4];
  for (let m2 of nn(t4, { getVisitorKeys: o2, filter: i2 })) s2.push(m2), D = m2;
  if (un(D, { getVisitorKeys: o2 })) return { cursorNode: D };
  let a2, c2, p2 = -1, l2 = Number.POSITIVE_INFINITY;
  for (; s2.length > 0 && (a2 === void 0 || c2 === void 0); ) {
    D = s2.pop();
    let m2 = a2 !== void 0, f2 = c2 !== void 0;
    for (let F of ye(D, { getVisitorKeys: o2 })) {
      if (!m2) {
        let d2 = u2(F);
        d2 <= r2 && d2 > p2 && (a2 = F, p2 = d2);
      }
      if (!f2) {
        let d2 = n2(F);
        d2 >= r2 && d2 < l2 && (c2 = F, l2 = d2);
      }
    }
  }
  return { nodeBeforeCursor: a2, nodeAfterCursor: c2 };
}
var or = ci;
function fi(t4, e2) {
  let { printer: r2 } = e2, n2 = r2.massageAstNode;
  if (!n2) return t4;
  let { getVisitorKeys: u2 } = r2, { ignoredProperties: o2 } = n2;
  return i2(t4);
  function i2(D, s2) {
    if (!ge(D)) return D;
    if (Array.isArray(D)) return D.map((l2) => i2(l2, s2)).filter(Boolean);
    let a2 = {}, c2 = new Set(u2(D));
    for (let l2 in D) !le(D, l2) || o2?.has(l2) || (c2.has(l2) ? a2[l2] = i2(D[l2], D) : a2[l2] = D[l2]);
    let p2 = n2(D, a2, s2);
    if (p2 !== null) return p2 ?? a2;
  }
}
var nu = fi;
var li = Array.prototype.findLastIndex ?? function(t4) {
  for (let e2 = this.length - 1; e2 >= 0; e2--) {
    let r2 = this[e2];
    if (t4(r2, e2, this)) return e2;
  }
  return -1;
}, pi = X("findLastIndex", function() {
  if (Array.isArray(this)) return li;
}), uu = pi;
function mi(t4, e2) {
  return e2 = new Set(e2), t4.find((r2) => su.has(r2.type) && e2.has(r2));
}
function ou(t4) {
  let e2 = uu(0, t4, (r2) => r2.type !== "Program" && r2.type !== "File");
  return e2 === -1 ? t4 : t4.slice(0, e2 + 1);
}
function di(t4, e2, { locStart: r2, locEnd: n2 }) {
  let [u2, ...o2] = t4, [i2, ...D] = e2;
  if (u2 === i2) return [u2, i2];
  let s2 = r2(u2);
  for (let c2 of ou(D)) if (r2(c2) >= s2) i2 = c2;
  else break;
  let a2 = n2(i2);
  for (let c2 of ou(o2)) {
    if (n2(c2) <= a2) u2 = c2;
    else break;
    if (u2 === i2) break;
  }
  return [u2, i2];
}
function ir(t4, e2, r2, n2, u2 = [], o2, i2) {
  let { locStart: D, locEnd: s2 } = i2, a2 = D(t4), c2 = s2(t4);
  if (e2 > c2 || e2 < a2 || o2 === "rangeEnd" && e2 === a2 || o2 === "rangeStart" && e2 === c2) return;
  let p2 = [t4, ...u2], l2 = ot(t4, p2, { cache: Ut, locStart: D, locEnd: s2, getVisitorKeys: r2.getVisitorKeys, filter: r2.printer.canAttachComment, getChildren: r2.printer.getCommentChildNodes });
  for (let m2 of l2) {
    let f2 = ir(m2, e2, r2, n2, p2, o2, i2);
    if (f2) return f2;
  }
  if (n2(t4, u2[0])) return p2;
}
function Fi(t4, e2) {
  return e2 !== "DeclareExportDeclaration" && t4 !== "TypeParameterDeclaration" && (t4 === "Directive" || t4 === "TypeAlias" || t4 === "TSExportAssignment" || t4.startsWith("Declare") || t4.startsWith("TSDeclare") || t4.endsWith("Statement") || t4.endsWith("Declaration"));
}
var su = /* @__PURE__ */ new Set(["JsonRoot", "ObjectExpression", "ArrayExpression", "StringLiteral", "NumericLiteral", "BooleanLiteral", "NullLiteral", "UnaryExpression", "TemplateLiteral"]), Ei = /* @__PURE__ */ new Set(["OperationDefinition", "FragmentDefinition", "VariableDefinition", "TypeExtensionDefinition", "ObjectTypeDefinition", "FieldDefinition", "DirectiveDefinition", "EnumTypeDefinition", "EnumValueDefinition", "InputValueDefinition", "InputObjectTypeDefinition", "SchemaDefinition", "OperationTypeDefinition", "InterfaceTypeDefinition", "UnionTypeDefinition", "ScalarTypeDefinition"]);
function iu(t4, e2, r2) {
  if (!e2) return false;
  switch (t4.parser) {
    case "flow":
    case "hermes":
    case "babel":
    case "babel-flow":
    case "babel-ts":
    case "typescript":
    case "acorn":
    case "espree":
    case "meriyah":
    case "oxc":
    case "oxc-ts":
    case "__babel_estree":
      return Fi(e2.type, r2?.type);
    case "json":
    case "json5":
    case "jsonc":
    case "json-stringify":
      return su.has(e2.type);
    case "graphql":
      return Ei.has(e2.kind);
    case "vue":
      return e2.tag !== "root";
  }
  return false;
}
function Du(t4, e2, r2) {
  let { rangeStart: n2, rangeEnd: u2 } = e2;
  let o2 = t4.slice(n2, u2).search(/\S/), i2 = o2 === -1;
  if (!i2) for (n2 += o2; u2 > n2 && !/\S/.test(t4[u2 - 1]); --u2) ;
  let D = e2.printer.features?.experimental_locForRangeFormat ?? e2, s2 = ir(r2, n2, e2, (f2, F) => iu(e2, f2, F), [], "rangeStart", D);
  if (!s2) return;
  let a2 = i2 ? s2 : ir(r2, u2, e2, (f2) => iu(e2, f2), [], "rangeEnd", D);
  if (!a2) return;
  let c2, p2;
  if (r2.type === "JsonRoot") {
    let f2 = mi(s2, a2);
    c2 = f2, p2 = f2;
  } else [c2, p2] = di(s2, a2, e2);
  let { locStart: l2, locEnd: m2 } = D;
  return [Math.min(l2(c2), l2(p2)), Math.max(m2(c2), m2(p2))];
}
var lu = "\uFEFF", au = /* @__PURE__ */ Symbol("cursor");
async function pu(t4, e2, r2 = 0) {
  if (!t4 || t4.trim().length === 0) return { formatted: "", cursorOffset: -1, comments: [] };
  let { ast: n2, text: u2 } = await me(t4, e2);
  e2.cursorOffset >= 0 && (e2 = { ...e2, ...or(n2, e2) });
  let o2 = await Ve(n2, e2);
  r2 > 0 && (o2 = Qe([W, o2], r2, e2.tabWidth));
  let i2 = Ce(o2, e2);
  if (r2 > 0) {
    let s2 = i2.formatted.trim();
    i2.cursorNodeStart !== void 0 && (i2.cursorNodeStart -= i2.formatted.indexOf(s2), i2.cursorNodeStart < 0 && (i2.cursorNodeStart = 0, i2.cursorNodeText = i2.cursorNodeText.trimStart()), i2.cursorNodeStart + i2.cursorNodeText.length > s2.length && (i2.cursorNodeText = i2.cursorNodeText.trimEnd())), i2.formatted = s2 + we(e2.endOfLine);
  }
  let D = e2[ue];
  if (e2.cursorOffset >= 0) {
    let s2, a2, c2, p2;
    if ((e2.cursorNode || e2.nodeBeforeCursor || e2.nodeAfterCursor) && i2.cursorNodeText) if (c2 = i2.cursorNodeStart, p2 = i2.cursorNodeText, e2.cursorNode) s2 = e2.locStart(e2.cursorNode), a2 = u2.slice(s2, e2.locEnd(e2.cursorNode));
    else {
      if (!e2.nodeBeforeCursor && !e2.nodeAfterCursor) throw new Error("Cursor location must contain at least one of cursorNode, nodeBeforeCursor, nodeAfterCursor");
      s2 = e2.nodeBeforeCursor ? e2.locEnd(e2.nodeBeforeCursor) : 0;
      let E = e2.nodeAfterCursor ? e2.locStart(e2.nodeAfterCursor) : u2.length;
      a2 = u2.slice(s2, E);
    }
    else s2 = 0, a2 = u2, c2 = 0, p2 = i2.formatted;
    let l2 = e2.cursorOffset - s2;
    if (a2 === p2) return { formatted: i2.formatted, cursorOffset: c2 + l2, comments: D };
    let m2 = a2.split("");
    m2.splice(l2, 0, au);
    let f2 = p2.split(""), F = xt(m2, f2), d2 = c2;
    for (let E of F) if (E.removed) {
      if (E.value.includes(au)) break;
    } else d2 += E.count;
    return { formatted: i2.formatted, cursorOffset: d2, comments: D };
  }
  return { formatted: i2.formatted, cursorOffset: -1, comments: D };
}
async function Ci(t4, e2) {
  let { ast: r2, text: n2 } = await me(t4, e2), [u2, o2] = Du(n2, e2, r2) ?? [0, 0], i2 = n2.slice(u2, o2), D = Math.min(u2, n2.lastIndexOf(`
`, u2) + 1), s2 = n2.slice(D, u2).match(/^\s*/)[0], a2 = he(s2, e2.tabWidth), c2 = await pu(i2, { ...e2, rangeStart: 0, rangeEnd: Number.POSITIVE_INFINITY, cursorOffset: e2.cursorOffset > u2 && e2.cursorOffset <= o2 ? e2.cursorOffset - u2 : -1, endOfLine: "lf" }, a2), p2 = c2.formatted.trimEnd(), { cursorOffset: l2 } = e2;
  l2 > o2 ? l2 += p2.length - i2.length : c2.cursorOffset >= 0 && (l2 = c2.cursorOffset + u2);
  let m2 = n2.slice(0, u2) + p2 + n2.slice(o2);
  if (e2.endOfLine !== "lf") {
    let f2 = we(e2.endOfLine);
    l2 >= 0 && f2 === `\r
` && (l2 += Tt(m2.slice(0, l2), `
`)), m2 = ne(0, m2, `
`, f2);
  }
  return { formatted: m2, cursorOffset: l2, comments: c2.comments };
}
function sr(t4, e2, r2) {
  return typeof e2 != "number" || Number.isNaN(e2) || e2 < 0 || e2 > t4.length ? r2 : e2;
}
function cu(t4, e2) {
  let { cursorOffset: r2, rangeStart: n2, rangeEnd: u2 } = e2;
  return r2 = sr(t4, r2, -1), n2 = sr(t4, n2, 0), u2 = sr(t4, u2, t4.length), { ...e2, cursorOffset: r2, rangeStart: n2, rangeEnd: u2 };
}
function mu(t4, e2) {
  let { cursorOffset: r2, rangeStart: n2, rangeEnd: u2, endOfLine: o2 } = cu(t4, e2), i2 = t4.charAt(0) === lu;
  if (i2 && (t4 = t4.slice(1), r2--, n2--, u2--), o2 === "auto" && (o2 = Cr(t4)), t4.includes("\r")) {
    let D = (s2) => Tt(t4.slice(0, Math.max(s2, 0)), `\r
`);
    r2 -= D(r2), n2 -= D(n2), u2 -= D(u2), t4 = hr(t4);
  }
  return { hasBOM: i2, text: t4, options: cu(t4, { ...e2, cursorOffset: r2, rangeStart: n2, rangeEnd: u2, endOfLine: o2 }) };
}
async function fu(t4, e2) {
  let r2 = await Ue(e2);
  return !r2.hasPragma || r2.hasPragma(t4);
}
async function hi(t4, e2) {
  return (await Ue(e2)).hasIgnorePragma?.(t4);
}
async function Dr(t4, e2) {
  let { hasBOM: r2, text: n2, options: u2 } = mu(t4, await se(e2));
  if (u2.rangeStart >= u2.rangeEnd && n2 !== "" || u2.requirePragma && !await fu(n2, u2) || u2.checkIgnorePragma && await hi(n2, u2)) return { formatted: t4, cursorOffset: e2.cursorOffset, comments: [] };
  let o2;
  return u2.rangeStart > 0 || u2.rangeEnd < n2.length ? o2 = await Ci(n2, u2) : (!u2.requirePragma && u2.insertPragma && u2.printer.insertPragma && !await fu(n2, u2) && (n2 = u2.printer.insertPragma(n2)), o2 = await pu(n2, u2)), r2 && (o2.formatted = lu + o2.formatted, o2.cursorOffset >= 0 && o2.cursorOffset++), o2;
}
async function du(t4, e2, r2) {
  let { text: n2, options: u2 } = mu(t4, await se(e2)), o2 = await me(n2, u2);
  return r2 && (r2.preprocessForPrint && (o2.ast = await ur(o2.ast, u2)), r2.massage && (o2.ast = nu(o2.ast, u2))), o2;
}
async function Fu(t4, e2) {
  e2 = await se(e2);
  let r2 = await Ve(t4, e2);
  return Ce(r2, e2);
}
async function Eu(t4, e2) {
  let r2 = Ur(t4), { formatted: n2 } = await Dr(r2, { ...e2, parser: "__js_expression" });
  return n2;
}
async function Cu(t4, e2) {
  e2 = await se(e2);
  let { ast: r2 } = await me(t4, e2);
  return e2.cursorOffset >= 0 && (e2 = { ...e2, ...or(r2, e2) }), Ve(r2, e2);
}
async function hu(t4, e2) {
  return Ce(t4, await se(e2));
}
var ar = {};
yt(ar, { builders: () => _i, printer: () => yi, utils: () => Ai });
var _i = { join: be, line: Ze, softline: Mr, hardline: W, literalline: Je, group: wt, conditionalGroup: Ir, fill: kr, lineSuffix: Ie, lineSuffixBoundary: Yr, cursor: ee, breakParent: ae, ifBreak: Rr, trim: jr, indent: oe, indentIfBreak: vr, align: De, addAlignmentToDoc: Qe, markAsRoot: Xe, dedentToRoot: Sr, dedent: br, hardlineWithoutBreakParent: ke, literallineWithoutBreakParent: Ot, label: Lr, concat: (t4) => t4 }, yi = { printDocToString: Ce }, Ai = { willBreak: xr, traverseDoc: Oe, findInDoc: Ke, mapDoc: Se, removeLines: Tr, stripTrailingHardline: He, replaceEndOfLine: Nr, canBreak: wr };
var gu = "3.9.4";
var fr = {};
yt(fr, { addDanglingComment: () => re, addLeadingComment: () => ce, addTrailingComment: () => fe, getAlignmentSize: () => he, getIndentSize: () => _u, getMaxContinuousCount: () => yu, getNextNonSpaceNonCommentCharacter: () => Au, getNextNonSpaceNonCommentCharacterIndex: () => vi, getPreferredQuote: () => Tu, getStringWidth: () => Re, hasNewline: () => H, hasNewlineInRange: () => Nu, hasSpaces: () => wu, isNextLineEmpty: () => Ui, isNextLineEmptyAfterIndex: () => gt, isPreviousLineEmpty: () => Mi, makeString: () => ji, skip: () => _e, skipEverythingButNewLine: () => ut, skipInlineComment: () => Be, skipNewline: () => $, skipSpaces: () => j, skipToLineEnd: () => nt, skipTrailingComment: () => Te, skipWhitespace: () => tn });
function xi(t4, e2) {
  if (e2 === false) return false;
  if (t4.charAt(e2) === "/" && t4.charAt(e2 + 1) === "*") {
    for (let r2 = e2 + 2; r2 < t4.length; ++r2) if (t4.charAt(r2) === "*" && t4.charAt(r2 + 1) === "/") return r2 + 2;
  }
  return e2;
}
var Be = xi;
function Bi(t4, e2) {
  return e2 === false ? false : t4.charAt(e2) === "/" && t4.charAt(e2 + 1) === "/" ? ut(t4, e2) : e2;
}
var Te = Bi;
function Ti(t4, e2) {
  let r2 = null, n2 = e2;
  for (; n2 !== r2; ) r2 = n2, n2 = j(t4, n2), n2 = Be(t4, n2), n2 = Te(t4, n2), n2 = $(t4, n2);
  return n2;
}
var We = Ti;
function Ni(t4, e2) {
  let r2 = null, n2 = e2;
  for (; n2 !== r2; ) r2 = n2, n2 = nt(t4, n2), n2 = Be(t4, n2), n2 = j(t4, n2);
  return n2 = Te(t4, n2), n2 = $(t4, n2), n2 !== false && H(t4, n2);
}
var gt = Ni;
function wi(t4, e2) {
  let r2 = t4.lastIndexOf(`
`);
  return r2 === -1 ? 0 : he(t4.slice(r2 + 1).match(/^[\t ]*/)[0], e2);
}
var _u = wi;
function cr(t4) {
  if (typeof t4 != "string") throw new TypeError("Expected a string");
  return t4.replace(/[|\\{}()[\]^$+*?.]/g, "\\$&").replace(/-/g, "\\x2d");
}
function Oi(t4, e2) {
  let r2 = t4.matchAll(new RegExp(`(?:${cr(e2)})+`, "g"));
  return r2.reduce || (r2 = [...r2]), r2.reduce((n2, [u2]) => Math.max(n2, u2.length), 0) / e2.length;
}
var yu = Oi;
function Pi(t4, e2) {
  let r2 = We(t4, e2);
  return r2 === false ? "" : t4.charAt(r2);
}
var Au = Pi;
var xu = Object.freeze({ character: "'", codePoint: 39 }), Bu = Object.freeze({ character: '"', codePoint: 34 }), Si = Object.freeze({ preferred: xu, alternate: Bu }), bi = Object.freeze({ preferred: Bu, alternate: xu });
function Tu(t4, e2) {
  let { preferred: r2, alternate: n2 } = e2 === true || e2 === "'" ? Si : bi, { length: u2 } = t4, o2 = 0, i2 = 0;
  for (let D = 0; D < u2; D++) {
    let s2 = t4.charCodeAt(D);
    s2 === r2.codePoint ? o2++ : s2 === n2.codePoint && i2++;
  }
  return (o2 > i2 ? n2 : r2).character;
}
function ki(t4, e2, r2) {
  for (let n2 = e2; n2 < r2; ++n2) if (t4.charAt(n2) === `
`) return true;
  return false;
}
var Nu = ki;
function Ii(t4, e2, r2 = {}) {
  return j(t4, r2.backwards ? e2 - 1 : e2, r2) !== e2;
}
var wu = Ii;
function Ri(t4, e2, r2) {
  return We(t4, r2(e2));
}
function vi(t4, e2) {
  return arguments.length === 2 || typeof e2 == "number" ? We(t4, e2) : Ri(...arguments);
}
function Li(t4, e2, r2) {
  return ve(t4, r2(e2));
}
function Mi(t4, e2) {
  return arguments.length === 2 || typeof e2 == "number" ? ve(t4, e2) : Li(...arguments);
}
function Yi(t4, e2, r2) {
  return gt(t4, r2(e2));
}
function ji(t4, e2, r2) {
  let n2 = e2 === '"' ? "'" : '"', o2 = ne(0, t4, /\\(.)|(["'])/gs, (i2, D, s2) => D === n2 ? D : s2 === e2 ? "\\" + s2 : s2 || (r2 && /^[^\n\r"'0-7\\bfnrt-vx\u2028\u2029]$/.test(D) ? D : "\\" + D));
  return e2 + o2 + e2;
}
function Ui(t4, e2) {
  return arguments.length === 2 || typeof e2 == "number" ? gt(t4, e2) : Yi(...arguments);
}
function de(t4, e2 = 1) {
  return async (...r2) => {
    let n2 = r2[e2] ?? {}, u2 = n2.plugins ?? [];
    return r2[e2] = { ...n2, plugins: Array.isArray(u2) ? u2 : Object.values(u2) }, await t4(...r2);
  };
}
var Ou = de(Dr);
async function Pu(t4, e2) {
  let { formatted: r2 } = await Ou(t4, { ...e2, cursorOffset: -1 });
  return r2;
}
async function Vi(t4, e2) {
  return await Pu(t4, e2) === t4;
}
var Wi = de(it, 0), $i = { parse: de(du), formatAST: de(Fu), formatDoc: de(Eu), printToDoc: de(Cu), printDocToString: de(hu) };
const expandCdataPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node) => {
      if (Array.isArray(node)) {
        return;
      }
      if (node.type === "cdata") {
        return { type: "text", value: node.value };
      }
    });
  };
};
var dist = {};
var core = {};
var debug = {};
var hasRequiredDebug;
function requireDebug() {
  if (hasRequiredDebug) return debug;
  hasRequiredDebug = 1;
  Object.defineProperty(debug, "__esModule", { value: true });
  debug.getType = getType2;
  debug.throwUnknownDataType = throwUnknownDataType;
  debug.throwUnsupportedData = throwUnsupportedData;
  function getType2(o2) {
    return Object.prototype.toString.call(o2);
  }
  function throwUnknownDataType(o2) {
    throw new TypeError("unsupported data type: " + getType2(o2));
  }
  function throwUnsupportedData(name2) {
    throw new TypeError("unsupported data type: " + name2);
  }
  return debug;
}
var encode = {};
var number = {};
var hasRequiredNumber;
function requireNumber() {
  if (hasRequiredNumber) return number;
  hasRequiredNumber = 1;
  Object.defineProperty(number, "__esModule", { value: true });
  number.s_to_int = s_to_int;
  number.s_to_big_int = s_to_big_int;
  number.int_to_s = int_to_s;
  number.big_int_to_s = big_int_to_s;
  number.num_to_s = num_to_s;
  number.int_str_to_s = int_str_to_s;
  number.s_to_num = s_to_num;
  let i_to_s = "";
  for (let i2 = 0; i2 < 10; i2++) {
    const c2 = String.fromCharCode(48 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + i2);
    i_to_s += c2;
  }
  for (let i2 = 0; i2 < 26; i2++) {
    const c2 = String.fromCharCode(65 + 32 + i2);
    i_to_s += c2;
  }
  const N2 = i_to_s.length;
  const s_to_i = {};
  for (let i2 = 0; i2 < N2; i2++) {
    const s2 = i_to_s[i2];
    s_to_i[s2] = i2;
  }
  function s_to_int(s2) {
    let acc = 0;
    let pow2 = 1;
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = s_to_i[c2];
      x2 *= pow2;
      acc += x2;
      pow2 *= N2;
    }
    return acc;
  }
  function s_to_big_int(s2) {
    let acc = BigInt(0);
    let pow2 = BigInt(1);
    const n2 = BigInt(N2);
    for (let i2 = s2.length - 1; i2 >= 0; i2--) {
      const c2 = s2[i2];
      let x2 = BigInt(s_to_i[c2]);
      x2 *= pow2;
      acc += x2;
      pow2 *= n2;
    }
    return acc;
  }
  function int_to_s(int) {
    if (int === 0) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== 0) {
      const i2 = int % N2;
      const c2 = i_to_s[i2];
      acc.push(c2);
      int -= i2;
      int /= N2;
    }
    return acc.reverse().join("");
  }
  function big_int_to_s(int) {
    const zero = BigInt(0);
    const n2 = BigInt(N2);
    if (int === zero) {
      return i_to_s[0];
    }
    const acc = [];
    while (int !== zero) {
      const i2 = int % n2;
      const c2 = i_to_s[Number(i2)];
      acc.push(c2);
      int /= n2;
    }
    return acc.reverse().join("");
  }
  function reverse(s2) {
    return s2.split("").reverse().join("");
  }
  function num_to_s(num) {
    if (num < 0) {
      return "-" + num_to_s(-num);
    }
    let [a2, b2] = num.toString().split(".");
    if (!b2) {
      if (a2.includes("e")) {
        const [a1, a22] = a2.split("e");
        a2 = a1;
        b2 = "0e" + a22;
      } else {
        return int_to_s(num);
      }
    }
    let c2;
    if (b2) {
      [b2, c2] = b2.split("e");
    }
    a2 = int_str_to_s(a2);
    b2 = reverse(b2);
    b2 = int_str_to_s(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += ".";
      switch (c2[0]) {
        case "+":
          c2 = c2.slice(1);
          break;
        case "-":
          str += "-";
          c2 = c2.slice(1);
          break;
      }
      c2 = int_str_to_s(c2);
      str += c2;
    }
    return str;
  }
  function int_str_to_s(int_str) {
    const num = +int_str;
    if (num.toString() === int_str && num + 1 !== num && num - 1 !== num) {
      return int_to_s(num);
    }
    return ":" + big_int_to_s(BigInt(int_str));
  }
  function s_to_int_str(s2) {
    if (s2[0] === ":") {
      return s_to_big_int(s2.substring(1)).toString();
    }
    return s_to_int(s2).toString();
  }
  function s_to_num(s2) {
    if (s2[0] === "-") {
      return -s_to_num(s2.substr(1));
    }
    let [a2, b2, c2] = s2.split(".");
    if (!b2) {
      return s_to_int(a2);
    }
    a2 = s_to_int_str(a2);
    b2 = s_to_int_str(b2);
    b2 = reverse(b2);
    let str = a2 + "." + b2;
    if (c2) {
      str += "e";
      let neg = false;
      if (c2[0] === "-") {
        neg = true;
        c2 = c2.slice(1);
      }
      c2 = s_to_int_str(c2);
      str += neg ? -c2 : +c2;
    }
    return +str;
  }
  return number;
}
var hasRequiredEncode;
function requireEncode() {
  if (hasRequiredEncode) return encode;
  hasRequiredEncode = 1;
  Object.defineProperty(encode, "__esModule", { value: true });
  encode.encodeNum = encodeNum;
  encode.decodeNum = decodeNum;
  encode.decodeKey = decodeKey;
  encode.encodeBool = encodeBool;
  encode.decodeBool = decodeBool;
  encode.encodeStr = encodeStr;
  encode.decodeStr = decodeStr;
  const number_1 = requireNumber();
  function encodeNum(num) {
    if (num === Infinity) {
      return "N|+";
    }
    if (num === -Infinity) {
      return "N|-";
    }
    if (Number.isNaN(num)) {
      return "N|0";
    }
    return "n|" + (0, number_1.num_to_s)(num);
  }
  function decodeNum(s2) {
    if (s2.length === 3 && s2[0] === "N" && s2[1] === "|") {
      switch (s2[2]) {
        case "+":
          return Infinity;
        case "-":
          return -Infinity;
        case "0":
          return NaN;
      }
    }
    return (0, number_1.s_to_num)(s2.slice(2));
  }
  function decodeKey(key) {
    return typeof key === "number" ? key : (0, number_1.s_to_int)(key);
  }
  function encodeBool(b2) {
    return b2 ? "b|T" : "b|F";
  }
  function decodeBool(s2) {
    if (s2.length === 3 && s2[0] === "b" && s2[1] === "|") {
      switch (s2[2]) {
        case "T":
          return true;
        case "F":
          return false;
      }
    }
    return !!s2;
  }
  function encodeStr(str) {
    if (str[1] === "|") {
      switch (str[0]) {
        case "b":
        case "o":
        case "n":
        case "a":
        case "s":
          return "s|" + str;
      }
    }
    return str;
  }
  function decodeStr(s2) {
    return s2[0] === "s" && s2[1] === "|" ? s2.substr(2) : s2;
  }
  return encode;
}
var memory = {};
var config = {};
var hasRequiredConfig;
function requireConfig() {
  if (hasRequiredConfig) return config;
  hasRequiredConfig = 1;
  Object.defineProperty(config, "__esModule", { value: true });
  config.config = void 0;
  config.config = {
    // default will not sort the object key
    sort_key: false,
    // default will convert into null silently like JSON.stringify
    preserve_nan: false,
    error_on_nan: false,
    preserve_infinite: false,
    error_on_infinite: false
  };
  return config;
}
var hasRequiredMemory;
function requireMemory() {
  if (hasRequiredMemory) return memory;
  hasRequiredMemory = 1;
  Object.defineProperty(memory, "__esModule", { value: true });
  memory.memToValues = memToValues;
  memory.makeInMemoryStore = makeInMemoryStore;
  memory.makeInMemoryCache = makeInMemoryCache;
  memory.makeInMemoryMemory = makeInMemoryMemory;
  memory.addValue = addValue;
  const config_1 = requireConfig();
  const debug_1 = requireDebug();
  const encode_1 = requireEncode();
  const number_1 = requireNumber();
  function memToValues(mem) {
    return mem.store.toArray();
  }
  function makeInMemoryStore() {
    const mem = [];
    return {
      forEach(cb2) {
        for (let i2 = 0; i2 < mem.length; i2++) {
          if (cb2(mem[i2]) === "break") {
            return;
          }
        }
      },
      add(value) {
        mem.push(value);
      },
      toArray() {
        return mem;
      }
    };
  }
  function makeInMemoryCache() {
    const valueMem = /* @__PURE__ */ Object.create(null);
    const schemaMem = /* @__PURE__ */ Object.create(null);
    return {
      getValue(key) {
        return valueMem[key];
      },
      getSchema(key) {
        return schemaMem[key];
      },
      forEachValue(cb2) {
        for (const [key, value] of Object.entries(valueMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      forEachSchema(cb2) {
        for (const [key, value] of Object.entries(schemaMem)) {
          if (cb2(key, value) === "break") {
            return;
          }
        }
      },
      setValue(key, value) {
        valueMem[key] = value;
      },
      setSchema(key, value) {
        schemaMem[key] = value;
      },
      hasValue(key) {
        return key in valueMem;
      },
      hasSchema(key) {
        return key in schemaMem;
      }
    };
  }
  function makeInMemoryMemory() {
    return {
      store: makeInMemoryStore(),
      cache: makeInMemoryCache(),
      keyCount: 0
    };
  }
  function getValueKey(mem, value) {
    if (mem.cache.hasValue(value)) {
      return mem.cache.getValue(value);
    }
    const id2 = mem.keyCount++;
    const key = (0, number_1.num_to_s)(id2);
    mem.store.add(value);
    mem.cache.setValue(value, key);
    return key;
  }
  function getSchema(mem, keys2) {
    if (config_1.config.sort_key) {
      keys2.sort();
    }
    const schema = keys2.join(",");
    if (mem.cache.hasSchema(schema)) {
      return mem.cache.getSchema(schema);
    }
    const key_id = addValue(mem, keys2, void 0);
    mem.cache.setSchema(schema, key_id);
    return key_id;
  }
  function addValue(mem, o2, parent) {
    if (o2 === null) {
      return "";
    }
    switch (typeof o2) {
      case "undefined":
        if (Array.isArray(parent)) {
          return addValue(mem, null, parent);
        }
        break;
      case "object":
        if (o2 === null) {
          return getValueKey(mem, null);
        }
        if (Array.isArray(o2)) {
          let acc = "a";
          for (let i2 = 0; i2 < o2.length; i2++) {
            const v2 = o2[i2];
            const key = v2 === null ? "_" : addValue(mem, v2, o2);
            acc += "|" + key;
          }
          if (acc === "a") {
            acc = "a|";
          }
          return getValueKey(mem, acc);
        } else {
          const keys2 = Object.keys(o2);
          if (keys2.length === 0) {
            return getValueKey(mem, "o|");
          }
          let acc = "o";
          const key_id = getSchema(mem, keys2);
          acc += "|" + key_id;
          for (const key of keys2) {
            const value = o2[key];
            const v2 = addValue(mem, value, o2);
            acc += "|" + v2;
          }
          return getValueKey(mem, acc);
        }
      case "boolean":
        return getValueKey(mem, (0, encode_1.encodeBool)(o2));
      case "number":
        if (Number.isNaN(o2)) {
          if (config_1.config.preserve_nan) {
            return getValueKey(mem, "N|0");
          }
          if (config_1.config.error_on_nan) {
            (0, debug_1.throwUnsupportedData)("[number NaN]");
          }
          return "";
        }
        if (Number.POSITIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|+");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number Infinity]");
          }
          return "";
        }
        if (Number.NEGATIVE_INFINITY === o2) {
          if (config_1.config.preserve_infinite) {
            return getValueKey(mem, "N|-");
          }
          if (config_1.config.error_on_infinite) {
            (0, debug_1.throwUnsupportedData)("[number -Infinity]");
          }
          return "";
        }
        return getValueKey(mem, (0, encode_1.encodeNum)(o2));
      case "string":
        return getValueKey(mem, (0, encode_1.encodeStr)(o2));
    }
    return (0, debug_1.throwUnknownDataType)(o2);
  }
  return memory;
}
var hasRequiredCore;
function requireCore() {
  if (hasRequiredCore) return core;
  hasRequiredCore = 1;
  Object.defineProperty(core, "__esModule", { value: true });
  core.compress = compress;
  core.decode = decode;
  core.decompress = decompress;
  const debug_1 = requireDebug();
  const encode_1 = requireEncode();
  const memory_1 = requireMemory();
  const number_1 = requireNumber();
  function compress(o2) {
    const mem = (0, memory_1.makeInMemoryMemory)();
    const root2 = (0, memory_1.addValue)(mem, o2, void 0);
    const values2 = (0, memory_1.memToValues)(mem);
    return [values2, root2];
  }
  function decodeObject(values2, s2) {
    if (s2 === "o|") {
      return {};
    }
    const o2 = {};
    const vs = s2.split("|");
    const key_id = vs[1];
    let keys2 = decode(values2, key_id);
    const n2 = vs.length;
    if (n2 - 2 === 1 && !Array.isArray(keys2)) {
      keys2 = [keys2];
    }
    for (let i2 = 2; i2 < n2; i2++) {
      const k2 = keys2[i2 - 2];
      let v2 = vs[i2];
      v2 = decode(values2, v2);
      o2[k2] = v2;
    }
    return o2;
  }
  function decodeArray2(values2, s2) {
    if (s2 === "a|") {
      return [];
    }
    const vs = s2.split("|");
    const n2 = vs.length - 1;
    const xs = new Array(n2);
    for (let i2 = 0; i2 < n2; i2++) {
      let v2 = vs[i2 + 1];
      v2 = decode(values2, v2);
      xs[i2] = v2;
    }
    return xs;
  }
  function decode(values2, key) {
    if (key === "" || key === "_") {
      return null;
    }
    const id2 = (0, encode_1.decodeKey)(key);
    const v2 = values2[id2];
    if (v2 === null) {
      return v2;
    }
    switch (typeof v2) {
      case "undefined":
        return v2;
      case "number":
        return v2;
      case "string":
        if (v2[1] === "|") {
          switch (v2[0]) {
            case "b": {
              switch (v2[2]) {
                case "T":
                  return true;
                case "F":
                  return false;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "o":
              return decodeObject(values2, v2);
            case "n":
              return (0, number_1.s_to_num)(v2.slice(2));
            case "N": {
              switch (v2[2]) {
                case "+":
                  return Infinity;
                case "-":
                  return -Infinity;
                case "0":
                  return NaN;
                default:
                  return (0, debug_1.throwUnknownDataType)(v2);
              }
            }
            case "a":
              return decodeArray2(values2, v2);
          }
        }
        return (0, encode_1.decodeStr)(v2);
    }
    return (0, debug_1.throwUnknownDataType)(v2);
  }
  function decompress(c2) {
    const [values2, root2] = c2;
    return decode(values2, root2);
  }
  return core;
}
var helpers = {};
var hasRequiredHelpers;
function requireHelpers() {
  if (hasRequiredHelpers) return helpers;
  hasRequiredHelpers = 1;
  Object.defineProperty(helpers, "__esModule", { value: true });
  helpers.trimUndefined = trimUndefined;
  helpers.trimUndefinedRecursively = trimUndefinedRecursively;
  function trimUndefined(object2) {
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      }
    }
  }
  function trimUndefinedRecursively(object2) {
    trimUndefinedRecursivelyLoop(object2, /* @__PURE__ */ new Set());
  }
  function trimUndefinedRecursivelyLoop(object2, tracks) {
    tracks.add(object2);
    for (const key in object2) {
      if (object2[key] === void 0) {
        delete object2[key];
      } else {
        const value = object2[key];
        if (value && typeof value === "object" && !tracks.has(value)) {
          trimUndefinedRecursivelyLoop(value, tracks);
        }
      }
    }
  }
  return helpers;
}
var hasRequiredDist;
function requireDist() {
  if (hasRequiredDist) return dist;
  hasRequiredDist = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.config = exports2.trimUndefinedRecursively = exports2.trimUndefined = exports2.addValue = exports2.decode = exports2.decompress = exports2.compress = void 0;
    var core_1 = requireCore();
    Object.defineProperty(exports2, "compress", { enumerable: true, get: function() {
      return core_1.compress;
    } });
    Object.defineProperty(exports2, "decompress", { enumerable: true, get: function() {
      return core_1.decompress;
    } });
    var core_2 = requireCore();
    Object.defineProperty(exports2, "decode", { enumerable: true, get: function() {
      return core_2.decode;
    } });
    var memory_1 = requireMemory();
    Object.defineProperty(exports2, "addValue", { enumerable: true, get: function() {
      return memory_1.addValue;
    } });
    var helpers_1 = requireHelpers();
    Object.defineProperty(exports2, "trimUndefined", { enumerable: true, get: function() {
      return helpers_1.trimUndefined;
    } });
    Object.defineProperty(exports2, "trimUndefinedRecursively", { enumerable: true, get: function() {
      return helpers_1.trimUndefinedRecursively;
    } });
    var config_1 = requireConfig();
    Object.defineProperty(exports2, "config", { enumerable: true, get: function() {
      return config_1.config;
    } });
  })(dist);
  return dist;
}
var distExports = requireDist();
const doenetSchema = distExports.decompress([["elements", "aliasedElements", "a|0|1", "name", "children", "childBuckets", "abstractAncestors", "attributes", "properties", "top", "acceptsStringChildren", "takesIndex", "docsSlug", "summary", "layoutCategory", "a|3|4|5|6|7|8|9|A|B|C|D|E", "title", "rightHandSide", "xLabel", "yLabel", "br", "m", "me", "men", "md", "mdn", "mrow", "not", "and", "or", "xor", "iff", "implies", "isInteger", "isNumber", "isBetween", "sum", "product", "clampNumber", "wrapNumberPeriodic", "round", "setSmallToZero", "convertSetToList", "ceil", "floor", "abs", "sign", "mean", "median", "variance", "standardDeviation", "count", "min", "max", "mod", "gcd", "lcm", "extractMath", "clampFunction", "wrapFunctionPeriodic", "derivative", "extractMathOperator", "em", "alert", "q", "sq", "term", "c", "tag", "tage", "tagc", "attr", "ndash", "mdash", "nbsp", "ellipsis", "lq", "rq", "lsq", "rsq", "odeSystem", "equilibriumPoint", "equilibriumLine", "atom", "ion", "ionicCompound", "electronConfiguration", "span", "displayDoenetML", "matrixInput", "fractionInput", "text", "textList", "boolean", "booleanList", "math", "mathList", "tupleList", "numberList", "collect", "ref", "point", "coords", "line", "bezierControls", "vector", "angle", "answer", "mathInput", "textInput", "booleanInput", "choiceInput", "choice", "number", "integer", "function", "piecewiseFunction", "interval", "sequence", "cell", "repeat", "repeatForSequence", "intersection", "conditionalContent", "asList", "selectFromSequence", "select", "group", "evaluate", "selectRandomNumbers", "sampleRandomNumbers", "selectPrimeNumbers", "samplePrimeNumbers", "substitute", "periodicSet", "intComma", "pluralize", "lorem", "updateValue", "callAction", "triggerSet", "functionIterates", "module", "footnote", "endpoint", "sort", "shuffle", "solveEquations", "subsetOfReals", "split", "bestFitLine", "hasSameFactoring", "label", "matchesPattern", "matrix", "latex", "pointList", "intervalList", "vectorList", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y", "11111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222212221222221112111121222112211111222", "_textOrInline", "_inline", "_base", "a|2b|2c|2d", "description", "type", "a|3|2f|2g", "The name used to reference this component from elsewhere in the document.", "o|2h|3|2i|1T", "defaultValue", "values", "a|3|2f|2k|2l|2g", "hide", "Whether to hide this component from the rendered output.", "b|F", "true", "false", "a|2q|2r", "o|2m|2n|2o|2p|2s|1V", "disabled", "Whether this component is disabled and cannot be interacted with.", "o|2m|2u|2v|2p|2s|1V", "fixed", "Whether this component's value is fixed and cannot be modified.", "o|2m|2x|2y|2p|2s|1V", "fixLocation", "Whether this component's location is fixed (preventing it from being moved while still allowing other modifications).", "o|2m|30|31|2p|2s|1V", "a|3|2f|2k|2g", "styleNumber", "The style number used to select this component's visual styling from the available style definitions.", "n|1", "o|33|34|35|36|1q", "isResponse", "Whether this component is treated as a response for the purposes of assessment.", "o|2m|38|39|2p|2s|1V", "extend", "Extend another component by reference, inheriting its children and attributes. Enter a reference as `$name`.", "reference", "o|2h|3B|3C|3D", "copy", "Create an independent copy of another component by reference. Enter a references a `$name`.", "o|2h|3F|3G|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H", "isArray", "fromAttribute", "a|3|2g|3J|2f|3K", "b|T", "o|3L|2n|1V|2p|2o|3M", "o|3L|34|1q|2p|35|3M", "o|3L|38|1V|2p|39|3M", "a|3|2g|3J|2f", "hidden", "Whether this component is hidden from the rendered output.", "o|3Q|3R|1V|2p|3S", "o|3Q|2u|1V|2p|2v", "o|3Q|2x|1V|2p|2y", "o|3Q|30|1V|2p|31", "doenetML", "The DoenetML source code that produced this component.", "o|3Q|3X|1T|2p|3Y", "value", "The combined content of this component's children.", "o|3Q|3a|G|2p|3b", "The combined content of this component's children, as a plain text string.", "o|3Q|1T|1T|2p|3d", "a|3N|3O|3P|3T|3U|3V|3W|3Z|3c|3e", "Creates a title within a document, section, or other block component", "inline", "o|F|G|2Z|2a|2e|3I|3f|3M|3M|2p|G|3g|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1222211111111111111111111112222222221222202222122222222212222122222122221212222", "a|2c|2d", "highlighted", "autocompleteValues", "a|3|2f|3m|2k|2l|3n|2g", "format", "Input format.", "a|1T|2V", "a|3a|2f", "Plain-text math notation (e.g., `x^2 + 1`).", "o|3s|1T|3t", "LaTeX-formatted math (e.g., `x^{2} + 1`).", "o|3s|2V|3v", "a|3u|3w", "keyword", "o|3o|3p|3q|3M|1T|3r|3x|3y", "simplify", "Level of simplification applied to the expression.", "none", "full", "numbers", "numbersPreserveOrder", "normalizeOrder", "a|42|43|44|45|46|2q|2r", "No simplification is applied.", "o|3s|42|48", "Fully simplify the expression.", "o|3s|43|4A", "Simplify numeric subexpressions only, leaving symbolic structure intact.", "o|3s|44|4C", "Like `numbers`, but does not reorder commutative operands.", "o|3s|45|4E", "Reorder commutative operands into a canonical form without simplifying values.", "o|3s|46|4G", "a|49|4B|4D|4F|4H", "o|3o|40|41|3M|42|47|4I|3y", "expand", "Whether to expand the expression.", "o|2m|4K|4L|2p|2s|1V", "groupName", "a|3|2f|4N|3m|2k|2g", "displayDigits", "Number of significant digits to display when rendering this number.", "number-display", "n|3", "o|4O|4P|4Q|4R|3M|4S|1q", "a|3|2f|4N|2k|2g", "displayDecimals", "Number of decimal places to display when rendering this number.", "n|2", "o|4U|4V|4W|4R|4X|1q", "displaySmallAsZero", "Threshold below which numbers are displayed as zero.", "n|1.0.-E", "o|4U|4Z|4a|4R|4b|1p", "a|3|2f|4N|2k|2l|2g", "padZeros", "Whether to pad displayed numbers with trailing zeros to fill the requested digits/decimals.", "o|4d|4e|4f|4R|2p|2s|1V", "avoidScientificNotation", "Whether to render numbers in full decimal form rather than scientific notation.", "o|4d|4h|4i|4R|2p|2s|1V", "renderMode", 'How the math is rendered (e.g. "inline", "display").', "o|33|4k|4l|3h|1T", "unordered", "Whether tuple- or list-like math expressions should be treated as unordered for comparison.", "o|2m|4n|4o|2p|2s|1V", "createVectors", "Whether tuple-like expressions are interpreted as vectors.", "o|2m|4q|4r|2p|2s|1V", "createIntervals", "Whether range expressions are interpreted as intervals.", "o|2m|4t|4u|2p|2s|1V", "functionSymbols", "Symbols treated as function names when parsing.", "f", "g", "a|4y|4z", "o|33|4w|4x|50|1U", "referencesAreFunctionSymbols", "References whose names should be treated as function symbols when parsing.", "a|", "o|33|52|53|54|3D", "splitSymbols", "Whether multi-character symbols are split into a product of variables.", "o|2m|56|57|3M|2s|1V", "parseScientificNotation", "Whether to parse expressions like 1e3 as scientific notation.", "o|2m|59|5A|2p|2s|1V", "displayBlanks", "Whether blanks (placeholders) are visibly rendered.", "o|2m|5C|5D|3M|2s|1V", "assumptions", "Assumptions applied when simplifying or comparing.", "a|2g|2V", "＿", "o|5H|1X|5I", "o|33|5F|5G|5J|1X", "draggable", "Whether the math component can be dragged on a graph.", "o|2m|5L|5M|3M|2s|1V", "layer", "Z-order layer index when shown on a graph.", "n|0", "o|33|5O|5P|5Q|1p", "anchor", "Coordinates of the anchor point used to position this component on a graph.", "positioning", "\\left( 0, 0 \\right)", "o|5H|1X|5V", "o|4U|5S|5T|5U|5W|1d", "a|3|2f|4N|2k|2l|3n|2g", "positionFromAnchor", "Where this component sits relative to its anchor point.", "center", "upperRight", "upperLeft", "lowerRight", "lowerLeft", "bottom", "left", "right", "a|5c|5d|5e|5f|9|5g|5h|5i|5b", "Place the component above and to the right of the anchor point.", "o|3s|5c|5k", "Place the component above and to the left of the anchor point.", "o|3s|5d|5m", "Place the component below and to the right of the anchor point.", "o|3s|5e|5o", "Place the component below and to the left of the anchor point.", "o|3s|5f|5q", "Place the component directly above the anchor point.", "o|3s|9|5s", "Place the component directly below the anchor point.", "o|3s|5g|5u", "Place the component directly to the left of the anchor point.", "o|3s|5h|5w", "Place the component directly to the right of the anchor point.", "o|3s|5i|5y", "Center the component on the anchor point.", "o|3s|5b|60", "a|5l|5n|5p|5r|5t|5v|5x|5z|61", "o|5Y|5Z|5a|5U|5b|5j|62|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "a|3|2g|3J|2f|3K|3m", "o|65|3p|1T|2p|3q|3M|3M", "o|65|40|1T|2p|41|3M|3M", "o|3L|4K|1V|2p|4L|3M", "o|3L|4k|1T|2p|4l|3M", "o|3L|4q|1V|2p|4r|3M", "o|3L|4t|1V|2p|4u|3M", "o|3L|4w|1U|2p|4x|3M", "o|3L|56|1V|2p|57|3M", "o|3L|59|1V|2p|5A|3M", "o|3L|5C|1V|2p|5D|3M", "o|3L|5F|1X|2p|5G|3M", "o|3L|5L|1V|2p|5M|3M", "o|3L|5O|1p|2p|5P|3M", "a|3|2g|3J|2f|3K|4N", "o|6J|5Z|1T|2p|5a|3M|5U", "textColor", "Human-readable name for this component's text color, derived from the active style and theme.", "o|3Q|6L|1T|2p|6M", "backgroundColor", "Human-readable name for this component's background color, derived from the active style and theme.", "o|3Q|6O|1T|2p|6P", "textStyleDescription", "Human-readable description of this component's text styling (color and any background color).", "o|3Q|6R|1T|2p|6S", "a|3|2g|3J|2f|4N", "The coordinates where this component is anchored on the graph.", "o|6U|5S|1d|2p|6V|5U", "o|3Q|4P|1q|2p|4Q", "o|3Q|4V|1q|2p|4W", "o|3Q|4Z|1p|2p|4a", "o|3Q|4e|1V|2p|4f", "o|3Q|4h|1V|2p|4i", "Whether list-like values are treated as unordered.", "o|3Q|4n|1V|2p|6c", "The math expression value.", "o|3Q|3a|H|2p|6e", "The numeric value of the expression (NaN if not a number).", "o|3Q|1p|1p|2p|6g", "Whether the expression evaluates to a finite number.", "o|3Q|Y|1V|2p|6i", "isNumeric", "Whether the expression evaluates to any number (including infinities).", "o|3Q|6k|1V|2p|6l", "The expression rendered as a LaTeX string.", "o|3Q|2V|2V|2p|6n", "The expression rendered as a plain text string.", "o|3Q|1T|1T|2p|6p", "numDimensions", "The number of dimensions if the math expression is interpreted as a vector or matrix.", "o|3Q|6r|1q|2p|6s", "indexedArrayDescription", "a|3|2g|3J|2f|6r|6u", "The math expression interpreted as a vector (its components).", "a|3J|2g", "o|6x|2p|1h", "a|6y", "o|6v|1h|1X|3M|6w|36|6z", "list", "The math expression interpreted as a list (its elements).", "a|3J|2g|6r", "o|73|3M|1X|36", "a|74", "o|6v|71|1X|3M|72|36|75", "matrixSize", "The size of the math expression as a matrix, as a [numRows, numColumns] list.", "o|3Q|77|1a|2p|78", "numRows", "The number of rows when the math expression is interpreted as a matrix.", "o|3Q|7A|1q|2p|7B", "numColumns", "The number of columns when the math expression is interpreted as a matrix.", "o|3Q|7D|1q|2p|7E", "The math expression interpreted as a matrix (its entries by row and column).", "o|6x|2p|2U", "a|7H|7H", "o|6v|2U|1X|3M|7G|4X|7I", "rows", "The matrix's entries grouped by row.", "o|6v|7K|1X|3M|7L|4X|7I", "columns", "The matrix's entries grouped by column.", "o|6v|7N|1X|3M|7O|4X|7I", "x", "The first component of the math expression when interpreted as a vector.", "o|3Q|7Q|1X|2p|7R", "y", "The second component of the math expression when interpreted as a vector.", "o|3Q|7T|1X|2p|7U", "z", "The third component of the math expression when interpreted as a vector.", "o|3Q|7W|1X|2p|7X", "numListItems", "The number of items when the math expression is interpreted as a list.", "o|3Q|7Z|1q|2p|7a", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|6f|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A right-hand-side expression of an equation in an ODE system", "o|F|H|3j|3k|3l|64|7c|3M|3M|2p|H|7d|3h", "for", "Reference to the component this label is for (e.g., an input).", "o|2h|7f|7g|3D", "forObject", "Reference to the graphical object this label is attached to.", "o|2h|7i|7j|3D", "Whether the label can be dragged on a graph.", "o|2m|5L|7l|3M|2s|1V", "maskLabel", "Whether to give the label an opaque background so it stays legible when it overlaps an axis, grid line, or another object.", "o|2m|7n|7o|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|7h|7k|7m|5R|7p|5X|63", "o|3L|5L|1V|2p|7l|3M", "o|3L|7n|1V|2p|7o|3M", "hasLatex", "Whether the label contains LaTeX content.", "o|3Q|7t|1V|2p|7u", "The label's text content.", "o|3Q|1T|1T|2p|7w", "The label's content as a LaTeX string.", "o|3Q|2V|2V|2p|7y", "The label's content as a label-typed value.", "o|3Q|3a|I|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|81", "A label for the x-axis of a graph", "o|F|I|2Z|2a|3l|7q|82|3M|3M|2p|I|83|3h", "o|3Q|3a|J|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|85", "A label for the y-axis of a graph", "o|F|J|2Z|2a|3l|7q|86|3M|3M|2p|J|87|3h", "statement", "introduction", "conclusion", "hr", "section", "subsection", "subsubsection", "paragraphs", "aside", "objectives", "problem", "exercise", "question", "activity", "example", "definition", "note", "theorem", "part", "task", "proof", "problems", "exercises", "ol", "ul", "cobwebPolyline", "equilibriumCurve", "orbitalDiagram", "orbitalDiagramInput", "sideBySide", "sbsGroup", "stack", "div", "pre", "paginator", "paginatorControls", "solution", "givenAnswer", "document", "p", "lineSegment", "ray", "polyline", "polygon", "triangle", "rectangle", "regularPolygon", "circle", "parabola", "curve", "award", "graph", "annotations", "annotation", "slider", "spreadsheet", "row", "column", "cellBlock", "tabular", "table", "figure", "pegboard", "variantControl", "animateFromSequence", "image", "video", "hint", "feedback", "moduleAttributes", "setup", "caption", "subsetOfRealsInput", "regionBetweenCurveXAxis", "regionBetweenCurves", "regionHalfPlane", "codeEditor", "legend", "eigenDecomposition", "blockQuote", "stickyGroup", "pretzel", "cascade", "a|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|1z|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_block", "a|9W|2d", "aggregateScores", "Whether to aggregate scores of scored descendants into a section credit-achieved value.", "scoring", "o|4d|9Y|9Z|9a|2p|2s|1V", "weight", "Relative weight of this section when aggregated by an enclosing scored section.", "o|4U|9c|9d|9a|36|1p", "sectionWideCheckWork", "Whether to show a single section-wide check-work button instead of per-answer buttons.", "o|4d|9f|9g|9a|2p|2s|1V", "maxNumAttempts", "Maximum number of times the section-wide check-work button can be submitted. Once reached, all enclosed answers are disabled.", "Infinity", "o|4U|9i|9j|9a|9k|1q", "showCorrectness", "Whether to display correctness indicators for the answers it contains.", "o|4d|9m|9n|9a|3M|2s|1V", "colorCorrectness", "Whether to color-code the answers it contains based on correctness.", "o|4d|9p|9q|9a|3M|2s|1V", "colorAnswersSeparately", "When section-wide check work is enabled, color each answer based on its own correctness rather than the section's overall credit.", "o|4d|9s|9t|9a|2p|2s|1V", "submitLabel", "Label for the section-wide submit button when correctness is shown.", "Check Work", "o|4U|9v|9w|9a|9x|1T", "submitLabelNoCorrectness", "Label for the section-wide submit button when correctness is not shown.", "Submit Response", "o|4U|9z|A0|9a|A1|1T", "displayDigitsForCreditAchieved", "Number of significant digits to display for the credit achieved value.", "o|4U|A3|A4|9a|4S|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "o|6J|9c|1p|2p|9d|3M|9a", "o|6J|9f|1V|2p|9g|3M|9a", "o|6J|9i|1q|2p|9j|3M|9a", "o|6J|9v|1T|2p|9w|3M|9a", "o|6J|9z|1T|2p|A0|3M|9a", "o|6J|A3|1q|2p|A4|3M|9a", "numSubmissions", "Number of times the section-wide check-work button has been submitted.", "o|3Q|AD|1q|2p|AE", "numAttemptsLeft", "Remaining number of section-wide submissions before the maximum is reached.", "o|3Q|AG|1q|2p|AH", "Whether scores of scored descendants are aggregated into this section's credit value.", "o|3Q|9Y|1V|2p|AJ", "creditAchieved", "Aggregate credit achieved (between 0 and 1) for scored descendants of this section.", "o|3Q|AL|1p|2p|AM", "percentCreditAchieved", "Aggregate credit achieved as a percentage (between 0 and 100).", "o|3Q|AO|1p|2p|AP", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ", "A block container for the statement of a problem, theorem, or similar", "block", "o|F|89|9U|9V|9X|A6|AR|3M|3M|2p|89|AS|AT", "A block container for the introduction of a section", "o|F|8A|9U|9V|9X|A6|AR|3M|3M|2p|8A|AV|AT", "A block container for the conclusion of a section", "o|F|8B|9U|9V|9X|A6|AR|3M|3M|2p|8B|AX|AT", "", "a|3N|3O|3P|3T|3U|3V|3W|3Z", "A line break", "o|F|K|54|AZ|3l|3I|Aa|3M|2p|2p|K|Ab|3h", "A horizontal rule used to separate content", "o|F|8C|54|AZ|9X|3I|Aa|3M|2p|2p|8C|Ad|AT", "cascadeMessage", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|8W|8X", "1111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222221222122222111211112122211221111122200", "The paragraph's text content.", "o|3Q|1T|1T|2p|Ai", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|Aj", "Placeholder shown inside a `<cascade>` in place of a not-yet-revealed entry", "o|F|Af|Ag|Ah|9X|A6|Ak|2p|3M|2p|Af|Al|AT", "else", "a|2d", "a|3|2f|2l|2g", "condition", "Boolean expression; this case is selected when the condition is true.", "o|Ap|Aq|Ar|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|As", "conditionSatisfied", "Whether this case's condition is currently satisfied.", "o|3Q|Au|1V|2p|Av", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Aw", "Default branch within a `<conditionalContent>`; matched when no `<case>` condition is true", "other", "o|F|An|9U|9V|Ao|At|Ax|2p|3M|2p|An|Ay|Az", "Whether the math display can be dragged on a graph.", "o|2m|5L|B1|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63", "o|3L|5L|1V|2p|B1|3M", "The math content rendered as a LaTeX string.", "o|3Q|2V|2V|2p|B5", "The math content rendered as a plain text string.", "o|3Q|1T|1T|2p|B7", "The math content as a math expression.", "o|3Q|1X|1X|2p|B9", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA", "Inline math rendered with LaTeX", "o|F|L|2Z|2a|3l|B3|BB|3M|3M|2p|L|BC|3h", "Display math rendered with LaTeX", "o|F|M|2Z|2a|3l|B3|BB|3M|3M|2p|M|BE|3h", "equationTag", "The equation number (when numbered).", "o|3Q|BG|1T|2p|BH", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8|BA|BI", "Numbered display math rendered with LaTeX", "o|F|N|2Z|2a|3l|B3|BJ|3M|3M|2p|N|BK|3h", "a|Q|1z", "02", "a|3N|3O|3P|B4|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|B6|B8", "Display math with multiple aligned rows", "o|F|O|BM|BN|3l|B3|BO|3M|2p|2p|O|BP|3h", "Numbered display math with multiple aligned rows", "o|F|P|BM|BN|3l|B3|BO|3M|2p|2p|P|BR|3h", "Whether to attach an equation number to this row.", "o|Ap|1p|BT|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|B2|5R|5X|63|BU", "A row of math within an aligned display", "o|F|Q|2Z|2a|3l|BV|BJ|3M|3M|2p|Q|BW|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "1222211111111111111111111112221222221220202222122222012212222122222111221211222221111111110212120", "_booleanOperatorOneInput", "a|Ba|2c|2d", "symbolicEquality", "Whether children compared via this boolean use symbolic equality.", "o|2m|Bc|Bd|2p|2s|1V", "expandOnCompare", "Whether to expand math expressions before comparing.", "o|2m|Bf|Bg|2p|2s|1V", "a|3|2f|2k|2l|3n|2g", "simplifyOnCompare", "Level of simplification applied to math expressions before comparing.", "No simplification is applied before comparing.", "o|3s|42|Bl", "Fully simplify both expressions before comparing.", "o|3s|43|Bn", "a|Bm|Bo|4D|4F|4H", "o|Bi|Bj|Bk|42|47|Bp|3y", "unorderedCompare", "Whether order is ignored when comparing list-like values.", "o|2m|Br|Bs|2p|2s|1V", "matchByExactPositions", "Whether to match list values by exact position rather than by content.", "o|2m|Bu|Bv|2p|2s|1V", "allowedErrorInNumbers", "Maximum allowed numeric error when comparing numbers.", "o|33|Bx|By|5Q|1p", "includeErrorInNumberExponents", "Whether the allowed numeric error also applies to numbers in exponents.", "o|2m|C0|C1|2p|2s|1V", "allowedErrorIsAbsolute", "Whether allowedErrorInNumbers is interpreted as an absolute (rather than relative) tolerance.", "o|2m|C3|C4|2p|2s|1V", "numSignErrorsMatched", "Maximum number of sign errors that still count as a match.", "o|33|C6|C7|5Q|1p", "numPeriodicSetMatchesRequired", "Number of consecutive elements of a periodic set required to count as a match.", "o|33|C9|CA|4S|1q", "caseInsensitiveMatch", "Whether text comparisons ignore letter case.", "o|2m|CC|CD|2p|2s|1V", "matchBlanks", "Whether unfilled blanks in a math expression count as a match.", "o|2m|CF|CG|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH", "o|3L|Bc|1V|2p|Bd|3M", "o|3L|Bf|1V|2p|Bg|3M", "o|3L|Bj|1T|2p|Bk|3M", "o|3L|Br|1V|2p|Bs|3M", "o|3L|Bu|1V|2p|Bv|3M", "o|3L|Bx|1p|2p|By|3M", "o|3L|C0|1V|2p|C1|3M", "o|3L|C3|1V|2p|C4|3M", "o|3L|C6|1p|2p|C7|3M", "o|3L|C9|1q|2p|CA|3M", "o|3L|CC|1V|2p|CD|3M", "o|3L|CF|1V|2p|CG|3M", 'The boolean rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|CV", "The boolean result of applying this operator to its single boolean input.", "o|3Q|3a|1V|2p|CX", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|CW|CY", "Logical negation of a boolean value", "o|F|R|BY|BZ|Bb|CI|CZ|3M|3M|2p|R|Ca|3h", "a|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|1z|2R|2T", "111111111022211", "_booleanOperator", "a|Ce|2c|2d", "The boolean result of applying this operator to its child boolean values.", "o|3Q|3a|1V|2p|Cg", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Ch|CW", "Logical AND: true only when all child boolean values are true", "o|F|S|Cc|Cd|Cf|CI|Ci|3M|3M|2p|S|Cj|3h", "Logical OR: true when at least one child boolean value is true", "o|F|T|Cc|Cd|Cf|CI|Ci|3M|3M|2p|T|Cl|3h", "Logical exclusive OR: true when exactly one child boolean value is true", "o|F|U|Cc|Cd|Cf|CI|Ci|3M|3M|2p|U|Cn|3h", "IF and only iF: Logical bicondition (IFF): true when all child boolean values are the same", "o|F|V|Cc|Cd|Cf|CI|Ci|3M|3M|2p|V|Cp|3h", "Logical implication (binary): true when the first value is false or the second value is true", "o|F|W|Cc|Cd|Cf|CI|Ci|3M|3M|2p|W|Cr|3h", "_booleanOperatorOfMath", "a|Ct|2c|2d", "The boolean result of applying this operator to its child math values.", "o|3Q|3a|1V|2p|Cv", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|Cw|CW", "True when the math child evaluates to an integer", "o|F|X|3j|3k|Cu|CI|Cx|3M|3M|2p|X|Cy|3h", "True when the math child evaluates to a finite number", "o|F|Y|3j|3k|Cu|CI|Cx|3M|3M|2p|Y|D0|3h", "limits", "Numeric limits used by the boolean operator (e.g. bounds for isBetween).", "o|33|D2|D3|54|1a", "strict", "Whether the comparison is strict (e.g. uses < instead of ≤).", "o|2m|D5|D6|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|D4|D7", "o|3L|D2|1a|2p|D3|3M", "o|3L|D5|1V|2p|D6|3M", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|D9|DA|3T|3U|3V|3W|3Z|Cw|CW", "True when a math value is between two given bounds", "o|F|Z|3j|3k|Cu|D8|DB|3M|3M|2p|Z|DC|3h", "1222211111111111111111111112222222221222202222122222012212222122222122221212222", "_mathOperator", "a|DF|2c|2d", "forceSymbolic", "Whether to force the operator to evaluate symbolically rather than numerically.", "o|2m|DH|DI|2p|2s|1V", "forceNumeric", "Whether to force the operator to evaluate numerically rather than symbolically.", "o|2m|DK|DL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM", "o|3L|DH|1V|2p|DI|3M", "o|3L|DK|1V|2p|DL|3M", "o|3Q|3a|a|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DQ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sum of the child math or number values", "o|F|a|3j|DE|DG|DN|DR|3M|3M|2p|a|DS|3h", "o|3Q|3a|b|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|DU|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Product of the child math or number values", "o|F|b|3j|DE|DG|DN|DV|3M|3M|2p|b|DW|3h", "_mathOperatorOneInput", "a|DY|2c|2d", "lowerValue", "Lower bound used by the operator.", "o|33|Da|Db|5Q|1p", "upperValue", "Upper bound used by the operator.", "o|33|Dd|De|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dc|Df", "o|3L|Da|1p|2p|Db|3M", "o|3L|Dd|1p|2p|De|3M", "o|3Q|3a|c|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Clamps a number to a specified range", "o|F|c|3j|3k|DZ|Dg|Dk|3M|3M|2p|c|Dl|3h", "o|3Q|3a|d|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Dh|Di|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Dn|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Wraps a number into a periodic range", "o|F|d|3j|3k|DZ|Dg|Do|3M|3M|2p|d|Dp|3h", "n|E", "o|4O|4P|4Q|4R|3M|Dr|1q", "numDecimals", "Number of decimal places (for round-style operators).", "o|33|Dt|Du|5Q|1p", "numDigits", "Number of significant digits (for round-style operators).", "o|33|Dw|Dx||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|Ds|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Dv|Dy", "o|3L|Dt|1p|2p|Du|3M", "o|3L|Dw|1p|2p|Dx|3M", "o|3Q|3a|e|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|E0|E1|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|E2|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Rounds a number to a specified precision", "o|F|e|3j|3k|DZ|Dz|E3|3M|3M|2p|e|E4|3h", "threshold", "Threshold value used by the operator.", "o|33|E6|E7|4b|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|E8", "o|3L|E6|1p|2p|E7|3M", "o|3Q|3a|f|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|EA|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Replaces values with magnitude below a threshold with zero", "o|F|f|3j|3k|DZ|E9|EC|3M|3M|2p|f|ED|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|g|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|EG|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Converts a math set expression into a list expression", "o|F|g|3j|3k|DZ|EF|EH|3M|3M|2p|g|EI|3h", "o|3Q|3a|h|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EK|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Smallest integer ≥ the input value", "o|F|h|3j|3k|DZ|64|EL|3M|3M|2p|h|EM|3h", "o|3Q|3a|i|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EO|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Largest integer ≤ the input value", "o|F|i|3j|3k|DZ|64|EP|3M|3M|2p|i|EQ|3h", "o|3Q|3a|j|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ES|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Absolute value of an expression", "o|F|j|3j|3k|DZ|64|ET|3M|3M|2p|j|EU|3h", "o|3Q|3a|k|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|EW|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Sign of the input (-1, 0, or 1)", "o|F|k|3j|3k|DZ|64|EX|3M|3M|2p|k|EY|3h", "o|3Q|3a|l|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ea|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Arithmetic mean of the child math or number values", "o|F|l|3j|DE|DG|DN|Eb|3M|3M|2p|l|Ec|3h", "o|3Q|3a|m|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ee|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Median of the child math or number values", "o|F|m|3j|DE|DG|DN|Ef|3M|3M|2p|m|Eg|3h", "population", "Whether to use the population formula (rather than sample).", "o|2m|Ei|Ej|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|DJ|DM|Ek", "o|3L|Ei|1V|2p|Ej|3M", "o|3Q|3a|n|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|En|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Variance of the child math or number values", "o|F|n|3j|DE|DG|El|Eo|3M|3M|2p|n|Ep|3h", "o|3Q|3a|o|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|Em|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Er|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Standard deviation of the child math or number values", "o|F|o|3j|DE|DG|El|Es|3M|3M|2p|o|Et|3h", "o|3Q|3a|p|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ev|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "The number of the child math or number values", "o|F|p|3j|DE|DG|DN|Ew|3M|3M|2p|p|Ex|3h", "o|3Q|3a|q|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Ez|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Minimum of the child math or number values", "o|F|q|3j|DE|DG|DN|F0|3M|3M|2p|q|F1|3h", "o|3Q|3a|r|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F3|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Maximum of the child math or number values", "o|F|r|3j|DE|DG|DN|F4|3M|3M|2p|r|F5|3h", "o|3Q|3a|s|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|F7|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Modulo (remainder) of two values", "o|F|s|3j|DE|DG|DN|F8|3M|3M|2p|s|F9|3h", "o|3Q|3a|t|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FB|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Greatest common divisor of integer inputs", "o|F|t|3j|DE|DG|DN|FC|3M|3M|2p|t|FD|3h", "o|3Q|3a|u|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|DO|DP|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|FF|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Least common multiple of integer inputs", "o|F|u|3j|DE|DG|DN|FG|3M|3M|2p|u|FH|3h", "What kind of sub-expression to extract.", "operand", "functionArgument", "numOperands", "recursiveOperands", "a|FK|1r|FL|FM|FN", "Extract a single operand of the top-level operation.", "o|3s|FK|FP", "Extract the function being applied (for a function call).", "o|3s|1r|FR", "Extract an argument of the function being called.", "o|3s|FL|FT", "Extract the count of operands at the top level.", "o|3s|FM|FV", "Extract all operands found recursively through nested operations.", "o|3s|FN|FX", "a|FQ|FS|FU|FW|FY", "o|Bi|2g|FJ||FO|FZ|3y", "operandNumber", "1-based index of the operand to extract.", "o|33|Fb|Fc||1p", "argumentNumber", "1-based index of the argument to extract.", "o|33|Fe|Ff||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|Fa|Fd|Fg", "o|3L|Fb|1p|2p|Fc|3M", "o|3L|Fe|1p|2p|Ff|3M", "o|3Q|3a|v|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|Fi|Fj|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|Fk|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Extracts a sub-expression from a math expression by name or index", "o|F|v|3j|3k|DZ|Fh|Fl|3M|3M|2p|v|Fm|3h", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|2S", "1222211111111111111111111111112222221222202222122222220112222122222122221212222110", "_functionOperator", "a|Fq|2c|2d", "Level of simplification applied to the function's formula.", "Fully simplify the function's formula.", "o|3s|43|Ft", "a|49|Fu|4D|4F|4H", "o|Bi|40|Fs|43|47|Fv|3y", "Whether to expand the function's formula.", "o|2m|4K|Fx|2p|2s|1V", "xscale", "Scale factor used along the x-axis.", "o|33|Fz|G0|36|1p", "yscale", "Scale factor used along the y-axis.", "o|33|G2|G3|36|1p", "numInputs", "Number of input arguments the function accepts.", "o|2h|G5|G6|1q", "numOutputs", "Number of output values the function produces.", "o|33|G8|G9|36|1q", "domain", "Restriction of the function's domain to a list of intervals.", "o|2h|GB|GC|2X", "labelIsName", "Whether to use this component's name as its rendered label.", "labels", "o|4d|GE|GF|GG|2p|2s|1V", "applyStyleToLabel", "Whether to apply the function's style to its label.", "o|2m|GI|GJ|2p|2s|1V", "labelPosition", "Position of the function's label.", "a|5c|5d|5e|5f|9|5g|5h|5i", "Place the label above and to the right of the function curve.", "o|3s|5c|GO", "Place the label above and to the left of the function curve.", "o|3s|5d|GQ", "Place the label below and to the right of the function curve.", "o|3s|5e|GS", "Place the label below and to the left of the function curve.", "o|3s|5f|GU", "Place the label directly above the function curve.", "o|3s|9|GW", "Place the label directly below the function curve.", "o|3s|5g|GY", "Place the label directly to the left of the function curve.", "o|3s|5h|Ga", "Place the label directly to the right of the function curve.", "o|3s|5i|Gc", "a|GP|GR|GT|GV|GX|GZ|Gb|Gd", "o|Bi|GL|GM|5c|GN|Ge|3y", "Z-order layer index for stacking the function on a graph.", "o|33|5O|Gg|5Q|1p", "minima", "Local minima of an interpolated function.", "extrema", "o|2h|Gi|Gj|Gk", "maxima", "Local maxima of an interpolated function.", "o|2h|Gm|Gn|Gk", "Local extrema (combined minima and maxima) of an interpolated function.", "o|2h|Gk|Gp|Gk", "through", "Points the interpolated function should pass through.", "o|2h|Gr|Gs|2W", "throughSlopes", "Slopes the interpolated function should have at each through-point.", "o|2h|Gu|Gv|1Y", "variables", "Names of the function's input variables.", "_variableNameList", "o|2h|Gx|Gy|Gz", "variable", "Name of the function's single input variable.", "_variableName", "o|2h|H1|H2|H3", "symbolic", "Whether the function should be evaluated symbolically rather than numerically.", "o|2m|H5|H6|3M|2s|1V", "o|4U|4P|4Q|4R|4S|1q", "nearestPointAsCurve", "Whether nearest-point queries should treat the function as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|HA|2p|2s|1V", "a|3|2f|2l|3n|2g", "lineStyle", "Stroke style for lines.", "solid", "dashed", "dotted", "a|HF|HG|HH", "Continuous, unbroken stroke.", "o|3s|HF|HJ", "Stroke composed of evenly-spaced dashes.", "o|3s|HG|HL", "Stroke composed of evenly-spaced dots.", "o|3s|HH|HN", "a|HK|HM|HO", "o|HC|HD|HE|HI|HP|3y", "lineWidth", "Stroke width for lines, in pixels.", "o|2h|HR|HS|1p", "Lower bound for the operator's range.", "o|33|Da|HU|5Q|1p", "Upper bound for the operator's range.", "o|33|Dd|HW|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|HV|HX", "expandSpecified", "o|3Q|HZ|1V|2p|Fx", "o|3L|Fz|1p|2p|G0|3M", "o|3L|G2|1p|2p|G3|3M", "o|6J|GE|1V|2p|GF|3M|GG", "o|3L|GI|1V|2p|GJ|3M", "o|3L|GL|1T|2p|GM|3M", "o|3L|5O|1p|2p|Gg|3M", "o|3L|Da|1p|2p|HU|3M", "o|3L|Dd|1p|2p|HW|3M", "The label rendered with this component.", "o|6U|2S|2S|2p|Hj|GG", "styleDescription", "A textual description of the function's style.", "o|3Q|Hl|1T|2p|Hm", "styleDescriptionWithNoun", 'Style description including the word "function".', "o|3Q|Ho|1T|2p|Hp", "Number of input variables of the function.", "o|3Q|G5|1q|2p|Hr", "Number of output values of the function.", "o|3Q|G8|1q|2p|Ht", "Domain interval(s) of the function.", "o|73|3M|1t|36", "a|Hw", "o|6v|GB|1t|3M|Hv|36|Hx", "Level of simplification applied when displaying the formula.", "o|3Q|40|1T|2p|Hz", "Whether to expand the formula.", "o|3Q|4K|1T|2p|I1", "Whether the function is treated symbolically.", "o|3Q|H5|1V|2p|I3", "The names of the function's input variables.", "o|73|3M|H3|36", "a|I6", "o|6v|Gx|H3|3M|I5|36|I7", "formula", "The symbolic formula of the function produced by this operator.", "o|3Q|I9|1X|2p|IA", "The function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|IC", "The function rendered as a plain text string.", "o|3Q|1T|1T|2p|IE", "numMinima", "Number of local minima of the function.", "o|3Q|IG|1p|2p|IH", "Local minima of the function.", "o|73|3M|1d|36", "o|6x|2p|1d", "a|IK|IL", "o|6v|Gi|1p|3M|IJ|4X|IM", "minimumLocations", "The x-coordinates of the function's local minima.", "o|73|3M|1p|36", "a|IQ", "o|6v|IO|1p|3M|IP|36|IR", "minimumValues", "The values of the function's local minima.", "o|6v|IT|1p|3M|IU|36|IR", "globalMinimum", "The global minimum of the function (if attained).", "a|IL", "o|6v|IW|1p|3M|IX|36|IY", "globalInfimum", "The global infimum of the function.", "o|6v|Ia|1p|3M|Ib|36|IY", "numMaxima", "Number of local maxima of the function.", "o|3Q|Id|1p|2p|Ie", "Local maxima of the function.", "o|6v|Gm|1p|3M|Ig|4X|IM", "maximumLocations", "The x-coordinates of the function's local maxima.", "o|6v|Ii|1p|3M|Ij|36|IR", "maximumValues", "The values of the function's local maxima.", "o|6v|Il|1p|3M|Im|36|IR", "globalMaximum", "The global maximum of the function (if attained).", "o|6v|Io|1p|3M|Ip|36|IY", "globalSupremum", "The global supremum of the function.", "o|6v|Ir|1p|3M|Is|36|IY", "numExtrema", "Number of local extrema (minima + maxima) of the function.", "o|3Q|Iu|1p|2p|Iv", "Local extrema (minima + maxima) of the function.", "o|6v|Gk|1p|3M|Ix|4X|IM", "extremumLocations", "The x-coordinates of the function's local extrema.", "o|6v|Iz|1p|3M|J0|36|IR", "extremumValues", "The values of the function's local extrema.", "o|6v|J2|1p|3M|J3|36|IR", "The function's first input variable name.", "o|3Q|H1|H3|2p|J5", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|Hh|Hi|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function clamped to a specified output range", "o|F|w|Fo|Fp|Fr|HY|J7|3M|3M|2p|w|J8|3h", "A function wrapped into a periodic output range", "o|F|x|Fo|Fp|Fr|HY|J7|3M|3M|2p|x|JA|3h", "derivVariables", "Names of variables to differentiate with respect to.", "o|2h|JC|JD|Gz", "derivVariable", "Name of the variable to differentiate with respect to.", "o|2h|JF|JG|H3", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT|JE|JH", "Number of input variables.", "o|3Q|G5|1q|2p|JJ", "Names of the input variables.", "o|6v|Gx|H3|3M|JL|36|I7", "numDerivatives", "Number of derivatives applied.", "o|3Q|JN|1q|2p|JO", "Variables with respect to which derivatives are taken.", "o|6v|JC|H3|3M|JQ|36|I7", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|Hu|Hy|I0|I2|I4|JM|IB|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|JP|JR|J6", "The derivative of a function", "o|F|y|Fo|Fp|Fr|JI|JS|3M|3M|2p|y|JT|3h", "_textOperatorOfMath", "a|JV|2c|2d", "Whether the text can be dragged on a graph.", "o|2m|5L|JX|3M|2s|1V", "isLatex", "Whether the text content is treated as LaTeX.", "o|2m|JZ|Ja|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63", "o|3L|5L|1V|2p|JX|3M", "o|3L|JZ|1V|2p|Ja|3M", "The text result of applying this operator to its child math values.", "o|3Q|3a|1T|2p|Jf", "The text rendered as a plain text string.", "o|3Q|1T|1T|2p|Jh", "The text parsed as a math expression.", "o|3Q|1X|1X|2p|Jj", "The text parsed as a number.", "o|3Q|1p|1p|2p|Jl", "numWords", "The number of words in the text value.", "o|3Q|Jn|1q|2p|Jo", "words", "The text value split into words.", "o|73|3M|1T|36", "a|Js", "o|6v|Jq|1T|3M|Jr|36|Jt", "numCharacters", "The number of characters (graphemes) in the text value.", "o|3Q|Jv|1q|2p|Jw", "characters", "The text value split into characters (graphemes).", "o|6v|Jy|1T|3M|Jz|36|Jt", "The number of comma-separated items when the text is interpreted as a list.", "o|3Q|7Z|1q|2p|K1", "The text value split into items at commas.", "o|6v|71|1T|3M|K3|36|Jt", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|Jg|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", 'Returns the top-level operator of a math expression as text (e.g. "+", "vector")', "o|F|z|3j|3k|JW|Jc|K5|3M|2p|2p|z|K6|3h", "_inlineRenderInlineChildren", "a|K8|2c|2d", "The combined text content of this component's children, with optional begin/end delimiters.", "o|3Q|1T|1T|2p|KA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|KB", "Emphasized inline text (italic by default)", "o|F|10|2Z|2a|K9|3I|KC|3M|3M|2p|10|KD|3h", "Bold text", "o|F|11|2Z|2a|K9|3I|KC|3M|3M|2p|11|KF|3h", "Inline double-quoted text", "o|F|12|2Z|2a|K9|3I|KC|3M|3M|2p|12|KH|3h", "Inline single-quoted text", "o|F|13|2Z|2a|K9|3I|KC|3M|3M|2p|13|KJ|3h", "An inline term, styled distinctively", "o|F|14|2Z|2a|K9|3I|KC|3M|3M|2p|14|KL|3h", "Inline code text", "o|F|15|2Z|2a|K9|3I|KC|3M|3M|2p|15|KN|3h", "Renders enclosed text as an opening tag, `< >`", "o|F|16|2Z|2a|K9|3I|KC|3M|3M|2p|16|KP|3h", "Renders enclosed text as a self-closing tag, `< />`", "o|F|17|2Z|2a|K9|3I|KC|3M|3M|2p|17|KR|3h", "Renders enclosed text as a closing tag, `</ >`", "o|F|18|2Z|2a|K9|3I|KC|3M|3M|2p|18|KT|3h", "Renders a styled attribute name", "o|F|19|2Z|2a|K9|3I|KC|3M|3M|2p|19|KV|3h", "_singleCharacterInline", "a|KX|2c|2d", "The unicode character rendered by this component.", "o|3Q|1T|1T|2p|KZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Ka", "Renders an en-dash (–) character", "o|F|1A|54|AZ|KY|3I|Kb|3M|2p|2p|1A|Kc|3h", "Renders an em-dash (—) character", "o|F|1B|54|AZ|KY|3I|Kb|3M|2p|2p|1B|Ke|3h", "Renders a non-breaking space character", "o|F|1C|54|AZ|KY|3I|Kb|3M|2p|2p|1C|Kg|3h", "Renders a horizontal ellipsis (…) character", "o|F|1D|54|AZ|KY|3I|Kb|3M|2p|2p|1D|Ki|3h", "Renders a left double quotation mark (“)", "o|F|1E|54|AZ|KY|3I|Kb|3M|2p|2p|1E|Kk|3h", "Renders a right double quotation mark (”)", "o|F|1F|54|AZ|KY|3I|Kb|3M|2p|2p|1F|Km|3h", "Renders a left single quotation mark (‘)", "o|F|1G|54|AZ|KY|3I|Kb|3M|2p|2p|1G|Ko|3h", "Renders a right single quotation mark (’)", "o|F|1H|54|AZ|KY|3I|Kb|3M|2p|2p|1H|Kq|3h", "styleDefinition", "feedbackDefinition", "a|1z|9A|G|9H|Ks|Kt|Af|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1000000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "_sectioningComponentNumberWithSiblings", "_sectioningComponent", "a|Kw|Kx|9W|2d", "boxed", "Whether to render this section with a visible box around it.", "o|2m|Kz|L0|2p|2s|1V", "includeAutoName", 'Whether to include the auto-generated section name (e.g. "Section") in the rendered title.', "o|2m|L2|L3|2p|2s|1V", "includeAutoNumber", "Whether to include the auto-generated section number in the rendered title.", "o|2m|L5|L6|2p|2s|1V", "noAutoTitle", "Whether to suppress the auto-generated title entirely.", "o|2m|L8|L9|2p|2s|1V", "includeAutoNameIfNoTitle", "Whether to include the auto-generated name when no explicit title is provided.", "o|2m|LB|LC|3M|2s|1V", "includeAutoNumberIfNoTitle", "Whether to include the auto-generated number when no explicit title is provided.", "o|2m|LE|LF|3M|2s|1V", "Whether to render this section's children as a list.", "o|2m|20|LH|2p|2s|1V", "collapsible", "Whether the section can be collapsed and expanded.", "o|2m|LJ|LK|2p|2s|1V", "startOpen", "Whether the collapsible section starts in the open state.", "o|2m|LM|LN|3M|2s|1V", "level", "The heading level for this section (overrides the default level inferred from nesting).", "o|2h|LP|LQ|1q", "completedColor", "Color used to indicate this section has been completed.", "var(--lightGreen)", "o|33|LS|LT|LU|1T", "inProgressColor", "Color used to indicate this section is in progress.", "var(--mainGray)", "o|33|LW|LX|LY|1T", "notStartedColor", "Color used to indicate this section has not been started.", "o|33|La|Lb|LY|1T", "completedColorDarkMode", "Color used to indicate this section has been completed (dark mode). If omitted, the dark-mode color is derived from `completedColor` when that attribute is explicitly set; otherwise falls back to a dark green that meets WCAG AA contrast for white text.", "#1a5e20", "o|33|Ld|Le|Lf|1T", "inProgressColorDarkMode", "Color used to indicate this section is in progress (dark mode). If omitted, the dark-mode color is derived from `inProgressColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "#3a3a3a", "o|33|Lh|Li|Lj|1T", "notStartedColorDarkMode", "Color used to indicate this section has not been started (dark mode). If omitted, the dark-mode color is derived from `notStartedColor` when that attribute is explicitly set; otherwise falls back to a dark gray that meets WCAG AA contrast for white text.", "o|33|Ll|Lm|Lj|1T", "includeParentNumber", "Whether to prefix this section's number with the parent section's number.", "o|2m|Lo|Lp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|Lq", "o|3L|L2|1V|2p|L3|3M", "o|3L|L5|1V|2p|L6|3M", "o|3L|L8|1V|2p|L9|3M", "o|3L|LB|1V|2p|LC|3M", "o|3L|LE|1V|2p|LF|3M", "o|3L|20|1V|2p|LH|3M", "o|3L|LJ|1V|2p|LK|3M", "o|3L|Lo|1V|2p|Lp|3M", "Whether this section is rendered with a visible box around it.", "o|3Q|Kz|1V|2p|M0", "sectionNumber", "The displayed number for this section.", "o|3Q|M2|1T|2p|M3", "The displayed title text for this section.", "o|3Q|G|1T|2p|M5", "open", "Whether this section is currently open (for collapsible sections).", "o|3Q|M7|1V|2p|M8", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|Lz|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A section of a document, with a title (auto-generated or custom) and content", "o|F|8D|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8D|MB|AT", "A sectional component nested one heading level deeper than `<section>`", "o|F|8E|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8E|MD|AT", "A sectional component nested one heading level deeper than `<subsection>`", "o|F|8F|Ku|Kv|Ky|Lr|MA|3M|3M|2p|8F|MF|AT", "o|2m|Lo|Lp|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A subsection of paragraphs (rendered at heading level 4)", "o|F|8G|Ku|Kv|Ky|MI|MA|3M|3M|2p|8G|MJ|AT", "o|2m|LJ|LK|3M|2s|1V", "o|2m|LM|LN|2p|2s|1V", "postponeRendering", "Whether to delay rendering this section's contents until expanded.", "o|Ap|MN|MO|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|ML|MM|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|MP", "A note set off from the main flow of the document", "o|F|8H|Ku|Kv|Ky|MQ|MA|3M|3M|2p|8H|MR|AT", "o|2m|Kz|L0|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|MT|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH", "A section listing learning objectives", "o|F|8I|Ku|Kv|Ky|MU|MA|3M|3M|2p|8I|MV|AT", "o|4d|9Y|9Z|9a|3M|2s|1V", "isDistractor", "Whether this section is a distractor (e.g. a wrong-answer choice for matching).", "o|Ap|MY|MZ|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|MX|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|LI|LL|LO|LR|LV|LZ|Lc|Lg|Lk|Ln|MH|Ma", "A sectional component that defines a scored problem", "o|F|8J|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8J|Mc|AT", "A sectional component that defines a scored exercise", "o|F|8K|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8K|Me|AT", "A sectional component that defines a scored question; similar to a `<problem>`", "o|F|8L|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8L|Mg|AT", "A sectional component with score aggregation, similar to `<problem>`", "o|F|8M|Ku|Kv|Ky|Mb|MA|3M|3M|2p|8M|Mi|AT", "A sectional component that defines an example", "o|F|8N|Ku|Kv|Ky|MI|MA|3M|3M|2p|8N|Mk|AT", "A sectional component for defining a term or concept", "o|F|8O|Ku|Kv|Ky|MI|MA|3M|3M|2p|8O|Mm|AT", "A note section, set off from the main flow of the document", "o|F|8P|Ku|Kv|Ky|MI|MA|3M|3M|2p|8P|Mo|AT", "A sectional component for the statement of a theorem (or similar formal statement)", "o|F|8Q|Ku|Kv|Ky|MI|MA|3M|3M|2p|8Q|Mq|AT", "A subsection-style block rendered as a list item (a part of an exercise or problem)", "o|F|8R|Ku|Kv|Ky|MI|MA|3M|3M|2p|8R|Ms|AT", "A task of a multi-task activity or problem (alias for `<part>`)", "o|F|8S|Ku|Kv|Ky|MI|MA|3M|3M|2p|8S|Mu|AT", "_unnumberedSectioningComponent", "a|Mw|Kx|9W|2d", "o|2m|LE|LF|2p|2s|1V", "renameTo", 'Override the auto-generated section name (e.g. rename "Section" to a custom label).', "o|2h|Mz|N0|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|My|LI|ML|MM|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|MP", "The displayed number for this section (always null for unnumbered sections).", "o|3Q|M2|1T|2p|N3", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|N4|M6|M9", "A proof section", "o|F|8T|Ku|Kv|Mx|N2|N5|3M|3M|2p|8T|N6|AT", "a|Kx|9W|2d", "o|2m|20|LH|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|LA|LD|LG|N9|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Lx|Ly|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9", "A container element grouping `<problem>` components, which are rendered as a list by default", "o|F|8U|Ku|Kv|N8|NA|NB|3M|3M|2p|8U|NC|AT", "A container element grouping `<exercise>` components, which are rendered as a list by default", "o|F|8V|Ku|Kv|N8|NA|NB|3M|3M|2p|8V|NE|AT", "li", "a|NG|1z", "Nesting level of this list (1-based).", "o|2h|LP|NI|1q", "marker", "Marker style for list items (e.g. 'disc', 'circle', '1', 'a').", "o|33|NK|NL||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|NJ|NM|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5", "An ordered list", "o|F|8W|NH|BN|9X|NN|AR|3M|2p|2p|8W|NO|AT", "An unordered list", "o|F|8X|NH|BN|9X|NN|AR|3M|2p|2p|8X|NQ|AT", "The list's content rendered as plain text.", "o|3Q|1T|1T|2p|NS", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|NT", "A list item within `<ol>` / `<ul>`", "o|F|NG|9U|9V|Ao|A6|NU|2p|3M|2p|NG|NV|Az", "a|H|1z", "independentVariable", "The independent variable of the ODE system.", "t", "o|5H|1X|Na", "o|33|NY|NZ|Nb|H3", "initialIndependentVariableValue", "The value of the independent variable at which the initial conditions are specified.", "0", "o|5H|1X|Nf", "o|33|Nd|Ne|Ng|1X", 'How to format the rendered system of equations (e.g. "align").', "align", "o|33|4k|Ni|Nj|1T", "chunkSize", "Step-size chunk used when numerically integrating the system.", "n|A", "o|33|Nl|Nm|Nn|1p", "tolerance", "Numerical tolerance used by the integrator.", "n|0.Q0u", "o|33|Np|Nq|Nr|1p", "maxIterations", "Maximum number of iterations the integrator may perform.", "n|G8", "o|33|Nt|Nu|Nv|1p", "hideInitialCondition", "Whether to hide the initial condition from the rendered output.", "o|2m|Nx|Ny|2p|2s|1V", "initialConditions", "The initial values of each dependent variable, in order.", "o|2h|O0|O1|1Y", "The dependent variables of the system, in the same order as the right-hand sides.", "o|2h|Gx|O3|Gz", "Whether to display equation numbers next to each equation.", "o|2m|1p|O5|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Nc|Nh|H8|4Y|4c|4g|4j|Nk|No|Ns|Nw|Nz|O2|O4|O6", "o|3L|NY|H3|2p|NZ|3M", "o|3L|Nd|1X|2p|Ne|3M", "o|3L|4k|1T|2p|Ni|3M", "o|3L|Nl|1p|2p|Nm|3M", "o|3L|Np|1p|2p|Nq|3M", "o|3L|Nt|1p|2p|Nu|3M", "o|3L|Nx|1V|2p|Ny|3M", "o|3L|1p|1V|2p|O5|3M", "The dependent variables of the system, in order matching the right-hand sides.", "o|6v|Gx|H3|3M|OG|36|I7", "rhss", "The right-hand-side expressions of each ODE in the system.", "o|6v|OI|1X|3M|OJ|36|75", "The initial values of each dependent variable at the initial independent variable value.", "o|6v|O0|1X|3M|OL|36|75", "The displayed equation number tag (when equation numbering is enabled).", "o|3Q|BG|1T|2p|ON", "The full ODE system rendered as a LaTeX string.", "o|3Q|2V|2V|2p|OP", "numericalSolutions", "Numerical solution functions for each dependent variable, as functions of the independent variable.", "o|73|3M|1r|36", "a|OT", "o|6v|OR|1r|3M|OS|36|OU", "rhs", "The right-hand-side expression of the first ODE in the system.", "o|3Q|OW|1X|2p|OX", "righthandside", "o|3Q|OZ|1X|2p|OX", "righthandsides", "o|6v|Ob|1X|3M|OJ|36|75", "initialCondition", "The initial value of the first dependent variable at the initial independent-variable value.", "o|3Q|Od|1X|2p|Oe", "numericalSolution", "Numerical solution function for the first dependent variable, as a function of the independent variable.", "o|3Q|Og|1r|2p|Oh", "a|3N|3O|3P|O8|O9|OA|OB|OC|OD|OE|OF|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|OH|OK|OM|OO|OQ|OV|OY|Oa|Oc|Of|Oi", "A system of first-order ordinary differential equations with initial conditions, rendered as math and numerically integrable", "o|F|1I|NX|BN|3l|O7|Oj|3M|2p|2p|1I|Ok|3h", "a|I|J|1z|2S", "1120", "_graphical", "a|Oo|2d", "Whether to apply this component's selected style to its label.", "o|2m|GI|Oq|2p|2s|1V", "Z-order layer index used to stack graphical components (higher values render on top).", "o|33|5O|Os|5Q|1q", "Whether the polyline can be dragged on a graph.", "o|2m|5L|Ou|3M|2s|1V", "verticesDraggable", "Whether individual vertices may be dragged independently.", "o|Ap|Ow|Ox|2s|1V", "vertices", "The list of vertex points that define the shape.", "o|2h|Oz|P0|2W", "showCoordsWhenDragging", "Whether to show coordinate labels while dragging.", "o|2m|P2|P3|3M|2s|1V", "rigid", "Whether the polyline is treated as rigid (preserves shape under drag).", "o|2m|P5|P6|2p|2s|1V", "preserveSimilarity", "Whether the shape is preserved up to similarity (uniform scaling) under drag.", "o|2m|P8|P9|2p|2s|1V", "rotationHandleVertices", "Vertex indices that should display rotation handles when the shape is rigid or preserves similarity.", "a|36", "o|33|PB|PC|PD|1a", "rotateAround", "What point to rotate the shape around.", "centroid", "vertex", "a|PH|PI|1d", "Rotate around the centroid of the shape.", "o|3s|PH|PK", "Rotate around the vertex specified by `rotationVertex`.", "o|3s|PI|PM", "Rotate around the explicit point given by `rotationCenter`.", "o|3s|1d|PO", "a|PL|PN|PP", "o|Bi|PF|PG|PH|PJ|PQ|3y", "rotationCenter", "The point to rotate around when rotateAround is 'point'.", "o|33|PS|PT||1d", "rotationVertex", "The vertex index to rotate around when rotateAround is 'vertex'.", "o|33|PV|PW|36|1q", "allowRotation", "Whether the polyline can be rotated under drag.", "o|2m|PY|PZ|3M|2s|1V", "allowTranslation", "Whether the polyline can be translated under drag.", "o|2m|Pb|Pc|3M|2s|1V", "allowDilation", "Whether the shape can be dilated (scaled) under drag.", "o|2m|Pe|Pf|3M|2s|1V", "minShrink", "Minimum scaling factor allowed when dilating.", "n|0.1", "o|33|Ph|Pi|Pj|1p", "allowReflection", "Whether the polyline can be reflected under drag.", "o|2m|Pl|Pm|3M|2s|1V", "attractThreshold", "Distance within which a dragged vertex snaps to the function curve or diagonal.", "n|0.5", "o|33|Po|Pp|Pq|1p", "numPoints", "Number of points (iterations) currently shown on the cobweb diagram.", "o|33|Ps|Pt|36|1p", "Symbol used as the independent variable when displaying iterate values.", "o|5H|1X|7Q", "o|33|H1|Pv|Pw|H3", "numIterationsRequired", "Minimum number of iterations the user is required to perform.", "o|33|Py|Pz|5Q|1p", "initialPoint", "The starting point on the diagonal where iteration begins.", "o|2h|Q1|Q2|1d", "The function being iterated.", "o|2h|1r|Q4|1r", "lockToSolution", "Whether to constrain dragged vertices to the correct cobweb solution.", "o|2m|Q6|Q7|2p|2s|1V", "defaultPoint", "The default location for newly added points on the cobweb diagram.", "o|2h|Q9|QA|1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|Pr|Pu|Px|Q0|Q3|Q5|Q8|QB", "o|3L|GI|1V|2p|Oq|3M", "o|3L|5O|1q|2p|Os|3M", "o|3L|5L|1V|2p|Ou|3M", "o|3L|P2|1V|2p|P3|3M", "o|3L|P5|1V|2p|P6|3M", "o|3L|PY|1V|2p|PZ|3M", "o|3L|Pb|1V|2p|Pc|3M", "o|3L|Pl|1V|2p|Pm|3M", "o|3L|Po|1p|2p|Pp|3M", "o|3L|Ps|1p|2p|Pt|3M", "o|3L|H1|H3|2p|Pv|3M", "o|3L|Py|1p|2p|Pz|3M", "A textual description of the polyline's style.", "o|3Q|Hl|1T|2p|QP", 'Style description including the word "polyline".', "o|3Q|Ho|1T|2p|QR", "Whether the polyline preserves its shape (up to similarity).", "o|3Q|P8|1V|2p|QT", "Whether the polyline can be dilated under drag.", "o|3Q|Pe|1V|2p|QV", "Whether each vertex can be dragged independently.", "o|3Q|Ow|1V|2p|QX", "The number of dimensions the polyline lives in.", "o|3Q|6r|1p|2p|QZ", "indexAliases", "a|3|2g|3J|2f|6r|6u|Qb", "The vertices of the polyline.", "a|7Q|7T|7W", "a|54|Qe", "o|Qc|Oz|1X|3M|Qd|4X|IM|Qf", "length", "The total length of the polyline.", "o|3Q|Qh|1p|2p|Qi", "The centroid of the polyline's vertices.", "o|6v|5b|1X|3M|Qk|36|IY", "o|6v|Q1|1X|3M|Q2|36|IY", "correctVertices", "Per-vertex flags indicating whether each vertex is positioned at the correct cobweb solution.", "o|73|3M|1V|36", "a|Qp", "o|6v|Qn|1V|3M|Qo|36|Qq", "fractionCorrectVertices", "The fraction of vertices placed at correct cobweb positions.", "o|3Q|Qs|1p|2p|Qt", "numGradedVertices", "The number of cobweb vertices that were evaluated for correctness.", "o|3Q|Qv|1p|2p|Qw", "numCorrectVertices", "The number of cobweb vertices placed at correct positions.", "o|3Q|Qy|1p|2p|Qz", "fractionCorrectVerticesAdjusted", "The fraction of correct vertices, scaled by the required minimum number of iterations.", "o|3Q|R1|1p|2p|R2", "numGradedVerticesAdjusted", "The effective number of graded vertices after adjusting for the required minimum number of iterations.", "o|3Q|R4|1p|2p|R5", "numIterateValues", "The number of iterate values produced by the cobweb diagram.", "o|3Q|R7|1p|2p|R8", "iterateValues", "The list of iterate values shown by the cobweb diagram.", "o|6v|RA|1X|3M|RB|36|75", "numVertices", "Number of cobweb vertices currently shown (alias for numPoints).", "o|3Q|RD|1p|2p|RE", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|QL|QM|QN|QO|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|Qa|Qg|Qj|Ql|Qm|Qr|Qu|Qx|R0|R3|R6|R9|RC|RF", "An interactive cobweb diagram for visualizing iteration of a one-variable function", "o|F|8Y|Om|On|Op|QC|RG|3M|2p|2p|8Y|RH|Az", "constrainToGrid", "constrainToGraph", "attractToGrid", "constrainTo", "attractTo", "constraintUnion", "attractToConstraint", "constrainToInterior", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|RJ|RK|RL|RM|RN|RO|RP|RQ|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "112011111111111111111111111110220101221211112221111111122220122222222222222222222222222222", "markerStyle", "Marker shape.", "square", "triangleUp", "triangleDown", "triangleLeft", "triangleRight", "diamond", "a|8u|RV|8r|RW|RX|RY|RZ|Ra", "Circular marker.", "o|3s|8u|Rc", "Square marker.", "o|3s|RV|Re", 'Triangular marker pointing up (alias for "triangleUp").', "o|3s|8r|Rg", "Triangular marker pointing up.", "o|3s|RW|Ri", "Triangular marker pointing down.", "o|3s|RX|Rk", "Triangular marker pointing left.", "o|3s|RY|Rm", "Triangular marker pointing right.", "o|3s|RZ|Ro", "Diamond-shaped marker.", "o|3s|Ra|Rq", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr", "o|HC|RT|RU|Rb|Rs|3y", "markerSize", "Marker size in pixels.", "o|2h|Ru|Rv|1p", "Whether the point can be dragged on a graph.", "o|2m|5L|Rx|3M|2s|1V", "The first coordinate (x) of the point.", "o|2h|7Q|Rz|1X", "The second coordinate (y) of the point.", "o|2h|7T|S1|1X", "The third coordinate (z) of the point.", "o|2h|7W|S3|1X", "xs", "The point's coordinates as a list.", "o|2h|S5|S6|1Y", "The point's coordinates as a single math expression.", "o|2h|1e|S8|1e", "Position of the point's label.", "Place the label above and to the right of the point.", "o|3s|5c|SB", "Place the label above and to the left of the point.", "o|3s|5d|SD", "Place the label below and to the right of the point.", "o|3s|5e|SF", "Place the label below and to the left of the point.", "o|3s|5f|SH", "Place the label directly above the point.", "o|3s|9|SJ", "Place the label directly below the point.", "o|3s|5g|SL", "Place the label directly to the left of the point.", "o|3s|5h|SN", "Place the label directly to the right of the point.", "o|3s|5i|SP", "a|SC|SE|SG|SI|SK|SM|SO|SQ", "o|Bi|GL|SA|5c|GN|SR|3y", "addControls", "Whether to render interactive control handles.", "both", "xOnly", "yOnly", "a|42|SV|SW|SX|2q|2r", "Show no control handles.", "o|3s|42|SZ", "Show control handles for moving the point in both x and y.", "o|3s|SV|Sb", "Show a control handle that constrains motion to the x direction.", "o|3s|SW|Sd", "Show a control handle that constrains motion to the y direction.", "o|3s|SX|Sf", "a|Sa|Sc|Se|Sg", "o|Bi|ST|SU|SV|SY|Sh|3y", "hideOffGraphIndicator", "Whether to suppress the indicator drawn at the edge when the point is off-screen.", "o|Ap|Sj|Sk|2s|1V", "controlOrder", "Slot order for graph controls (1-indexed; 0 means no explicit slot request).", "o|33|Sm|Sn|5Q|1q", "stable", "Whether the equilibrium is stable (rendered filled) or unstable (rendered open).", "o|2m|Sp|Sq|3M|2s|1V", "switchable", "Whether the user can toggle the stability of this equilibrium by clicking it.", "o|2m|Ss|St|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|Sr|Su", "o|3L|5L|1V|2p|Rx|3M", "o|3L|GL|1T|2p|SA|3M", "o|3L|ST|1T|2p|SU|3M", "o|3L|Sm|1q|2p|Sn|3M", "o|3L|Sp|1V|2p|Sq|3M", "o|3L|Ss|1V|2p|St|3M", "scales", "The graph axis scales (x and y) used when applying this constraint.", "o|3Q|T2|1p|2p|T3", "constraintUsed", "Whether this constraint was applied to the component.", "o|3Q|T5|1V|2p|T6", "A textual description of the point's style.", "o|3Q|Hl|1T|2p|T8", 'Style description including the word "point".', "o|3Q|Ho|1T|2p|TA", "Whether to suppress the off-graph indicator when out of view.", "o|3Q|Sj|1V|2p|TC", "Number of dimensions of the point.", "o|3Q|6r|1p|2p|TE", "o|6v|S5|1X|3M|S6|36|75", "The point's coordinates as a math expression.", "o|3Q|1e|1e|2p|TH", "The point rendered as a LaTeX string.", "o|3Q|2V|2V|2p|TJ", "numDimensionsForConstraints", "Number of dimensions exposed to constraint computations (alias for numDimensions).", "o|3Q|TL|1p|2p|TM", "o|3Q|7Q|1X|2p|Rz", "o|3Q|7T|1X|2p|S1", "o|3Q|7W|1X|2p|S3", "o|3Q|3a|1e|2p|S8", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|T0|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "An equilibrium point of a dynamical system, rendered as a filled point if stable or open if unstable", "o|F|1J|RR|RS|Op|Sv|TS|3M|3M|2p|1J|TT|Az", "a|I|J|1z|2S|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "1120122221111111111111111111111222222222122220222212222201221222122222122221212222", "Whether the line can be dragged on a graph.", "o|2m|5L|TX|3M|2s|1V", "equation", "Implicit equation defining the line.", "o|2h|TZ|Ta|1X", "Points the line passes through.", "o|2h|Gr|Tc|2W", "slope", "Slope of the line.", "o|2h|Te|Tf|1p", "perpendicularTo", "Direction the line should be perpendicular to (e.g. another line or vector).", "_directionComponent", "o|2h|Th|Ti|Tj", "parallelTo", "Direction the line should be parallel to (e.g. another line or vector).", "o|2h|Tl|Tm|Tj", "Names of the variables used in the line equation.", "o|2h|Gx|To|Gz", "Where the label sits along this line/curve.", "a|5c|5d|5e|5f|5b|9|5g|5h|5i", "Place the label above and to the right of the line.", "o|3s|5c|Ts", "Place the label above and to the left of the line.", "o|3s|5d|Tu", "Place the label below and to the right of the line.", "o|3s|5e|Tw", "Place the label below and to the left of the line.", "o|3s|5f|Ty", "Place the label at the midpoint of the line.", "o|3s|5b|U0", "Place the label directly above the line.", "o|3s|9|U2", "Place the label directly below the line.", "o|3s|5g|U4", "Place the label directly to the left of the line.", "o|3s|5h|U6", "Place the label directly to the right of the line.", "o|3s|5i|U8", "a|Tt|Tv|Tx|Tz|U1|U3|U5|U7|U9", "o|Bi|GL|Tq|5b|Tr|UA|3y", "Whether the equilibrium is stable (rendered solid) or unstable (rendered dashed).", "o|2m|Sp|UC|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|UD|Su", "o|3L|5L|1V|2p|TX|3M", "o|3L|GL|1T|2p|Tq|3M", "o|3L|Sp|1V|2p|UC|3M", "A textual description of the line's style.", "o|3Q|Hl|1T|2p|UI", 'Style description including the word "line".', "o|3Q|Ho|1T|2p|UK", "Number of dimensions the line lives in.", "o|3Q|6r|1p|2p|UM", "Variable names used in the line's equation.", "o|6v|Gx|H3|3M|UO|36|I7", "points", "Two points the line passes through.", "o|Qc|UQ|1X|3M|UR|4X|IM|Qf", "The line's equation as a math expression.", "o|3Q|TZ|1X|2p|UT", "coeff0", "The constant term in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UV|1X|2p|UW", "coeffvar1", "The coefficient of the first variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|UY|1X|2p|UZ", "coeffvar2", "The coefficient of the second variable in the implicit line equation coeff0 + coeffvar1·x + coeffvar2·y = 0.", "o|3Q|Ub|1X|2p|Uc", "The slope of the line (2D only).", "o|3Q|Te|1X|2p|Ue", "xintercept", "The x-intercept of the line.", "o|3Q|Ug|1X|2p|Uh", "yintercept", "The y-intercept of the line.", "o|3Q|Uj|1X|2p|Uk", "The line's equation rendered as LaTeX.", "o|3Q|2V|2V|2p|Um", "The line's equation rendered as plain text.", "o|3Q|1T|1T|2p|Uo", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "An equilibrium line of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|1K|TV|TW|Op|UE|Uq|3M|3M|2p|1K|Ur|Az", "a|I|J|1z|2S|w|x|y|1r|1s|1g|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11201110101222211111111111111111111112222221222202222122222011222122222122221212222", "fillOpacity", "Opacity of solid fills, 0 to 1.", "o|2h|Uv|Uw|1p", "fillPatternOpacity", "Opacity of pattern fills (non-solid fillStyle), 0 to 1.", "o|2h|Uy|Uz|1p", "fillStyle", "Fill pattern used inside closed shapes.", "horizontal", "vertical", "diagonal", "backDiagonal", "dots", "diamonds", "a|HF|V3|V4|V5|V6|V7|V8", "Solid fill.", "o|3s|HF|VA", "Horizontal line pattern.", "o|3s|V3|VC", "Vertical line pattern.", "o|3s|V4|VE", "Diagonal line pattern (/).", "o|3s|V5|VG", "Back-diagonal line pattern (\\).", "o|3s|V6|VI", "Dots pattern.", "o|3s|V7|VK", "Filled diamonds pattern.", "o|3s|V8|VM", "a|VB|VD|VF|VH|VJ|VL|VN", "o|HC|V1|V2|V9|VO|3y", "Whether the curve can be dragged on a graph.", "o|2m|5L|VQ|3M|2s|1V", "Position of the curve's label relative to the curve.", "Place the label above and to the right of the curve.", "o|3s|5c|VT", "Place the label above and to the left of the curve.", "o|3s|5d|VV", "Place the label below and to the right of the curve.", "o|3s|5e|VX", "Place the label below and to the left of the curve.", "o|3s|5f|VZ", "Place the label directly above the curve.", "o|3s|9|Vb", "Place the label directly below the curve.", "o|3s|5g|Vd", "Place the label directly to the left of the curve.", "o|3s|5h|Vf", "Place the label directly to the right of the curve.", "o|3s|5i|Vh", "a|VU|VW|VY|Va|Vc|Ve|Vg|Vi", "o|Bi|GL|VS|5c|GN|Vj|3y", "flipFunction", "Whether to swap the function and its argument (i.e., reflect across y=x).", "o|2m|Vl|Vm|2p|2s|1V", "numDiscretizationPoints", "Number of points used when discretizing the curve for rendering.", "o|33|Vo|Vp|Nv|1p", "periodic", "Whether the curve is treated as periodic when interpolating between control points.", "o|2m|Vr|Vs|2p|2s|1V", "splineTension", "Tension parameter used when fitting a spline through control points.", "n|0.8", "o|33|Vu|Vv|Vw|1p", "extrapolateBackward", "Whether to extrapolate the curve before its first defined point.", "o|2m|Vy|Vz|2p|2s|1V", "extrapolateForward", "Whether to extrapolate the curve beyond its last defined point.", "o|2m|W1|W2|2p|2s|1V", "splineForm", "Form of spline used to interpolate between control points.", "centripetal", "uniform", "a|W6|W7", "Centripetal Catmull-Rom spline (avoids self-intersection at sharp turns).", "o|3s|W6|W9", "Uniform Catmull-Rom spline with evenly spaced parameterization.", "o|3s|W7|WB", "a|WA|WC", "o|Bi|W4|W5|W6|W8|WD|3y", "Name of the curve's parameter or independent variable.", "o|33|H1|WF|Pw|H3", "Points the interpolated curve passes through.", "o|2h|Gr|WH|2W", "parMin", "Minimum value of the curve's parameter (for parametric curves).", "o|2h|WJ|WK|1X", "parMax", "Maximum value of the curve's parameter (for parametric curves).", "o|2h|WM|WN|1X", "Whether to show coordinate labels while dragging the curve.", "o|2m|P2|WP|3M|2s|1V", "Whether nearest-point queries should treat this as a curve in the plane rather than a graph y = f(x).", "o|2m|H9|WR|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j|UD|Su", "o|3L|5L|1V|2p|VQ|3M", "o|3L|GL|1T|2p|VS|3M", "o|3L|Vl|1V|2p|Vm|3M", "o|3L|Vo|1p|2p|Vp|3M", "o|3L|Vr|1V|2p|Vs|3M", "o|3L|Vu|1p|2p|Vv|3M", "o|3L|Vy|1V|2p|Vz|3M", "o|3L|W1|1V|2p|W2|3M", "o|3L|W4|1T|2p|W5|3M", "o|3L|P2|1V|2p|WP|3M", "A textual description of the curve's style.", "o|3Q|Hl|1T|2p|We", 'Style description including the word "curve".', "o|3Q|Ho|1T|2p|Wg", "Maximum value of the curve's parameter.", "o|3Q|WM|1p|2p|Wi", "Minimum value of the curve's parameter.", "o|3Q|WJ|1p|2p|Wk", "Number of dimensions the curve lives in.", "o|3Q|6r|1p|2p|Wm", "throughPoints", "Points the curve is constrained to pass through.", "o|6v|Wo|1X|3M|Wp|4X|IM", "vectorControlDirections", "Direction symmetry of each control vector pair.", "o|6v|Wr|1T|3M|Ws|36|Jt", "hiddenControls", "Whether each control vector is currently hidden.", "o|6v|Wu|1V|3M|Wv|36|Qq", "controlVectors", "The Bezier control vectors at each through-point.", "o|73|3M|1h|4X", "o|73|3M|1h|36", "a|Wz|X0|6y", "a|54|54|Qe", "o|Qc|Wx|1X|3M|Wy|4S|X1|X2", "controlPoints", "The Bezier control points (vertex + offset) for each through-point.", "o|73|3M|1d|4X", "a|X6|IK|IL", "o|6v|X4|1X|3M|X5|4S|X7", "extrapolateBackwardMode", "The extrapolation style used before the first through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|X9|1T|2p|XA", "extrapolateForwardMode", "The extrapolation style used beyond the last through-point (e.g., 'line', 'parabolaHorizontal', 'parabolaVertical').", "o|3Q|XC|1T|2p|XD", "fs", "The component functions of the curve as functions of its parameter.", "o|6v|XF|1r|3M|XG|36|OU", "numXCriticalPoints", "The number of x-critical points (horizontal tangents) on the curve.", "o|3Q|XI|1q|2p|XJ", "xCriticalPoints", "The x-critical points (horizontal tangents) on the curve.", "o|6v|XL|1p|3M|XM|4X|IM", "numYCriticalPoints", "The number of y-critical points (vertical tangents) on the curve.", "o|3Q|XO|1q|2p|XP", "yCriticalPoints", "The y-critical points (vertical tangents) on the curve.", "o|6v|XR|1p|3M|XS|4X|IM", "numCurvatureChangePoints", "The number of points where the curve's curvature changes sign.", "o|3Q|XU|1q|2p|XV", "curvatureChangePoints", "Points where the curve's curvature changes sign (inflection points).", "o|6v|XX|1p|3M|XY|4X|IM", "The first component function of the curve as a function of its parameter.", "o|3Q|4y|1r|2p|Xa", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|UH|T1|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "An equilibrium curve of a dynamical system, rendered solid if stable or dashed if unstable", "o|F|8Z|Ut|Uu|Op|WT|Xc|3M|3M|2p|8Z|Xd|Az", "symbol", 'The chemical symbol of the atom (e.g. "H", "He", "Li").', "o|2h|Xf|Xg|1T", "atomicNumber", "The atomic number of the atom (number of protons).", "o|2h|Xi|Xj|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Xh|Xk|H8|4Y|4c|4g|4j", "The atomic number of the element.", "o|3Q|Xi|1q|2p|Xm", "The chemical symbol of the element.", "o|3Q|Xf|1T|2p|Xo", "The full name of the element.", "o|3Q|3|1T|2p|Xq", "The group number of the element in the periodic table.", "o|3Q|23|1q|2p|Xs", "atomicMass", "The atomic mass of the element.", "o|3Q|Xu|1p|2p|Xv", "phaseAtSTP", "The phase (solid, liquid, or gas) of the element at standard temperature and pressure.", "o|3Q|Xx|1T|2p|Xy", "chargeOfCommonIon", "The charge of the most common ion of this element.", "o|3Q|Y0|1q|2p|Y1", "metalCategory", "The metal category of the element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Y4", `The descriptive name of the element's periodic group (e.g. "Alkali metals").`, "o|3Q|4N|1T|2p|Y6", "period", "The period number of the element in the periodic table.", "o|3Q|Y8|1q|2p|Y9", "ionizationEnergy", "The first ionization energy of the element.", "o|3Q|YB|1p|2p|YC", "meltingPoint", "The melting point of the element.", "o|3Q|YE|1p|2p|YF", "boilingPoint", "The boiling point of the element.", "o|3Q|YH|1p|2p|YI", "atomicRadius", "The atomic radius of the element.", "o|3Q|YK|1q|2p|YL", "density", "The density of the element at standard conditions.", "o|3Q|YN|1p|2p|YO", "electronegativity", "The Pauling electronegativity of the element.", "o|3Q|YQ|1p|2p|YR", "The electron configuration of the element as a math expression.", "o|3Q|1O|1O|2p|YT", "The orbital diagram of the element.", "o|3Q|8a|8a|2p|YV", "The atom rendered as a math expression with the element symbol.", "o|3Q|1X|1X|2p|YX", "The atom rendered as a LaTeX string.", "o|3Q|2V|2V|2p|YZ", "The atom rendered as a plain text string.", "o|3Q|1T|1T|2p|Yb", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|6N|6Q|6T|Xn|Xp|Xr|Xt|Xw|Xz|Y2|Y5|Y7|YA|YD|YG|YJ|YM|YP|YS|YU|YW|YY|Ya|Yc", "Represents a chemical element by symbol or atomic number, exposing its periodic-table properties", "o|F|1L|54|AZ|3l|Xl|Yd|3M|2p|2p|1L|Ye|3h", "a|1L|1z", 'The chemical symbol of the element (e.g. "Na", "Cl").', "o|2h|Xf|Yh|1T", "o|2h|Xi|Xm|1q", "charge", "The charge of the ion (positive for cations, negative for anions).", "o|2h|Yk|Yl|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Yi|Yj|Ym", "The charge of the ion.", "o|3Q|Yk|1q|2p|Yo", 'The full name of the ion (e.g. "sodium ion").', "o|3Q|3|1T|2p|Yq", "The group number of the underlying element in the periodic table.", "o|3Q|23|1q|2p|Ys", "The metal category of the underlying element (e.g. alkali metal, transition metal, nonmetal).", "o|3Q|Y3|1T|2p|Yu", "The descriptive name of the underlying element's periodic group.", "o|3Q|4N|1T|2p|Yw", "The period number of the underlying element in the periodic table.", "o|3Q|Y8|1q|2p|Yy", "The ion rendered as a math expression (element symbol with charge).", "o|3Q|1X|1X|2p|Z0", "The ion rendered as a LaTeX string.", "o|3Q|2V|2V|2p|Z2", "The ion rendered as a plain text string.", "o|3Q|1T|1T|2p|Z4", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|Xn|Xp|Yp|Yr|Yt|Yv|Yx|Yz|Z1|Z3|Z5", "Represents a charged ion specified by element and charge, rendered with its chemical formula", "o|F|1M|Yg|BN|3l|Yn|Z6|3M|2p|2p|1M|Z7|3h", "a|1L|1M|1z", "202", "The chemical symbol of an element in the compound.", "o|2h|Xf|ZB|1T", "The atomic number of an element in the compound.", "o|2h|Xi|ZD|1q", "The charge of an ion in the compound.", "o|2h|Yk|ZF|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ZC|ZE|ZG", "The ionic compound rendered as a math expression of its chemical formula.", "o|3Q|1X|1X|2p|ZI", "The ionic compound rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZK", "The ionic compound rendered as a plain text string.", "o|3Q|1T|1T|2p|ZM", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|ZJ|ZL|ZN", "Forms a balanced ionic compound from constituent ions and renders its chemical formula", "o|F|1N|Z9|ZA|3l|ZH|ZO|3M|2p|2p|1N|ZP|3h", "o|3Q|3a|1O|2p|6e", "The electron configuration rendered as a LaTeX string.", "o|3Q|2V|2V|2p|ZS", "The electron configuration rendered as a unicode text string.", "o|3Q|1T|1T|2p|ZU", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|ZR|6h|6j|6m|ZT|ZV|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "Renders an electron configuration with sublevel labels and superscripted electron counts", "o|F|1O|3j|3k|3l|64|ZW|3M|3M|2p|1O|ZX|3h", "a|1Z|1z|8a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02012222111111111111111111111122222222212222022212222201221222122222122221212222", "Text labels for each orbital row.", "o|33|GG|Zb|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zc", "The orbital diagram value as a list of rows, each with a label and boxes containing up/down arrows.", "o|3Q|3a|8a|2p|Ze", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zf", "Renders an orbital diagram showing electrons in atomic orbitals as up/down arrows in boxes", "o|F|8a|ZZ|Za|9X|Zd|Zg|3M|3M|2p|8a|Zh|AT", "prefill", "An orbital diagram used to prefill the input before the student begins.", "o|33|Zj|Zk|54|8a", "prefillLabel", "Text labels to prefill for each orbital row.", "o|33|Zm|Zn|54|1U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Zl|Zo", "The current orbital diagram entered by the student.", "o|3Q|3a|8a|2p|Zq", "The orbital diagram rows in display order (reversed from the underlying value).", "o|3Q|7K|8a|2p|Zs", "The number of orbital rows in the diagram.", "o|3Q|7A|1q|2p|Zu", "selectedRowIndex", "Index of the currently selected orbital row (1-based; 0 if none selected).", "o|3Q|Zw|1q|2p|Zx", "selectedBoxIndex", "Index of the currently selected box within the selected row (1-based; 0 if none selected).", "o|3Q|Zz|1q|2p|a0", "a|3N|3O|3P|3T|3U|3V|3W|3Z|Zr|Zt|Zv|Zy|a1", "An interactive widget where students fill in an orbital diagram by adding boxes, rows, and up/down arrows (block-level; does not inherit from Input)", "o|F|8b|54|AZ|9X|Zp|a2|3M|2p|2p|8b|a3|AT", "code", "Identifier used to reference this feedback definition.", "o|2h|a5|a6|1T", "Default feedback text for this code.", "o|2h|1T|a8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|a7|a9", "A reusable feedback definition referenced by other components", "o|F|Kt|54|AZ|Ao|aA|Aa|3M|2p|2p|Kt|aB|Az", "Index identifying which style this definition applies to.", "o|33|34|aD|36|1q", "lineColor", "Color used for line strokes (light mode).", "o|2h|aF|aG|1T", "lineColorWord", "Human-readable name of the line color (light mode).", "o|2h|aI|aJ|1T", "lineColorDarkMode", "Color used for line strokes (dark mode).", "o|2h|aL|aM|1T", "lineColorWordDarkMode", "Human-readable name of the line color (dark mode).", "o|2h|aO|aP|1T", "lineOpacity", "Opacity of line strokes, 0 to 1.", "o|2h|aR|aS|1p", "lineWidthWord", "Human-readable name of the line width.", "o|2h|aU|aV|1T", "lineStyleWord", "Human-readable name of the line style.", "o|2h|aX|aY|1T", "markerColor", "Color used for markers/points (light mode).", "o|2h|aa|ab|1T", "markerColorWord", "Human-readable name of the marker color (light mode).", "o|2h|ad|ae|1T", "markerColorDarkMode", "Color used for markers/points (dark mode).", "o|2h|ag|ah|1T", "markerColorWordDarkMode", "Human-readable name of the marker color (dark mode).", "o|2h|aj|ak|1T", "markerOpacity", "Opacity of markers/points, 0 to 1.", "o|2h|am|an|1p", "cross", "plus", "a|8u|RV|8r|RW|RX|RY|RZ|Ra|ap|aq", "Cross-shaped marker (×).", "o|3s|ap|as", "Plus-shaped marker (+).", "o|3s|aq|au", "a|Rd|Rf|Rh|Rj|Rl|Rn|Rp|Rr|at|av", "o|HC|RT|RU|ar|aw|3y", "markerStyleWord", "Human-readable name of the marker style.", "o|2h|ay|az|1T", "markerFilled", "Whether the marker is rendered filled (true) or open (false). Has no effect when markerStyle is cross or plus, which have no interior.", "o|Ap|b1|b2|2s|1V", "fillColor", "Fill color used inside closed shapes (light mode).", "o|2h|b4|b5|1T", "fillColorWord", "Human-readable name of the fill color (light mode).", "o|2h|b7|b8|1T", "fillColorDarkMode", "Fill color used inside closed shapes (dark mode).", "o|2h|bA|bB|1T", "fillColorWordDarkMode", "Human-readable name of the fill color (dark mode).", "o|2h|bD|bE|1T", "fillStyleWord", "Human-readable name of the fill style.", "o|2h|bG|bH|1T", "Text color (light mode).", "o|2h|6L|bJ|1T", "textColorWord", "Human-readable name of the text color (light mode).", "o|2h|bL|bM|1T", "textColorDarkMode", "Text color (dark mode).", "o|2h|bO|bP|1T", "textColorWordDarkMode", "Human-readable name of the text color (dark mode).", "o|2h|bR|bS|1T", "highContrastColor", "High-contrast accent color (light mode).", "o|2h|bU|bV|1T", "highContrastColorWord", "Human-readable name of the high-contrast accent color (light mode).", "o|2h|bX|bY|1T", "highContrastColorDarkMode", "High-contrast accent color (dark mode).", "o|2h|ba|bb|1T", "highContrastColorWordDarkMode", "Human-readable name of the high-contrast accent color (dark mode).", "o|2h|bd|be|1T", "Background color (light mode).", "o|2h|6O|bg|1T", "backgroundColorWord", "Human-readable name of the background color (light mode).", "o|2h|bi|bj|1T", "backgroundColorDarkMode", "Background color (dark mode).", "o|2h|bl|bm|1T", "backgroundColorWordDarkMode", "Human-readable name of the background color (dark mode).", "o|2h|bo|bp|1T", "a|2j|2t|2w|2z|32|aE|3A|3E|3H|aH|aK|aN|aQ|aT|HT|aW|HQ|aZ|ac|af|ai|al|ao|ax|b0|Rw|b3|b6|b9|bC|bF|Ux|V0|VP|bI|bK|bN|bQ|bT|bW|bZ|bc|bf|bh|bk|bn|bq", "a|3N|3P|3T|3U|3V|3W|3Z", "A reusable style definition referenced by other components", "o|F|Ks|54|AZ|Ao|br|bs|3M|2p|2p|Ks|bt|Az", "a|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|1b|8y|92|96|97|98|1w|1x|1y|1z|22|23|9C|9D|9E|9F|2D|2I|9I|2L|2M|9J|2P|9N|9Q|9S|9T", "1111111111111111111111111111111111111211111222222111122122121111", "width", "Total rendered width of the side-by-side container.", "componentSize", "o|2h|bx|by|bz", "widths", "List of widths for each panel.", "_componentSizeList", "o|2h|c1|c2|c3", "margins", "List of margin widths between panels.", "o|2h|c5|c6|c3", "valign", "Default vertical alignment for all panels.", "middle", "a|9|cA|5g", "Align panels to the top.", "o|3s|9|cC", "Vertically center panels.", "o|3s|cA|cE", "Align panels to the bottom.", "o|3s|5g|cG", "a|cD|cF|cH", "o|HC|c8|c9|cB|cI|3y", "isList", "a|3|2f|2l|3n|cK|2g", "valigns", "Per-panel vertical alignment values.", "Align the panel to the top.", "o|3s|9|cO", "Vertically center the panel.", "o|3s|cA|cQ", "Align the panel to the bottom.", "o|3s|5g|cS", "a|cP|cR|cT", "o|cL|cM|cN|cB|cU|3M|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|c0|c4|c7|cJ|cV", "absoluteMeasurements", "Whether children's widths are interpreted in absolute units.", "o|3Q|cX|1V|2p|cY", "gapWidth", "The gap width between panels as a percentage of the total container width.", "o|3Q|ca|1p|2p|cb", "The list of child widths.", "o|6v|c1|1p|3M|cd|36|IR", "Margins between adjacent children.", "o|6v|c5|1p|3M|cf|36|IR", "Vertical alignment of each child.", "o|6v|cM|1T|3M|ch|36|Jt", "a|3N|3O|3P|3T|3U|3V|3W|3Z|cZ|cc|ce|cg|ci", "Renders children in a side-by-side horizontal layout", "o|F|8c|bv|bw|9X|cW|cj|3M|2p|2p|8c|ck|AT", "a|8c|1z", "A group of `<sideBySide>` components that share alignment and spacing", "o|F|8d|cm|BN|9X|cW|cj|3M|2p|2p|8d|cn|AT", "A vertical container element for organizing content within a `<sideBySide>`", "o|F|8e|9U|9V|9X|3I|Aa|3M|3M|2p|8e|cp|AT", "A generic block-level container", "o|F|8f|9U|9V|9X|A6|AR|3M|3M|2p|8f|cr|AT", "A generic inline container", "o|F|1P|9U|9V|3l|A6|AR|3M|3M|2p|1P|ct|3h", "A preformatted block preserving whitespace", "o|F|8g|9U|9V|9X|3I|Aa|3M|3M|2p|8g|cv|AT", "The verbatim text content.", "o|3Q|1T|1T|2p|cx", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6N|6Q|6T|cy", "Displays a DoenetML source string verbatim", "o|F|1Q|9U|9V|3l|3I|cz|3M|3M|2p|1Q|d0|3h", "initialPage", "1-based page index shown on first render.", "o|33|d2|d3|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|d4", "numPages", "The total number of pages.", "o|3Q|d6|1q|2p|d7", "currentPage", "The currently displayed page (1-based).", "o|3Q|d9|1q|2p|dA", "a|3N|3O|3P|3T|3U|3V|3W|3Z|d8|dB", "Defines a paginated section of content", "o|F|8h|9U|9V|9X|d5|dC|3M|3M|2p|8h|dD|AT", "previousLabel", 'Label for the "previous page" button.', "Previous", "o|33|dF|dG|dH|1T", "nextLabel", 'Label for the "next page" button.', "Next", "o|33|dJ|dK|dL|1T", "pageLabel", "Label format for the current page indicator.", "Page", "o|33|dN|dO|dP|1T", "Reference to the `<paginator>` these controls operate on.", "o|2h|8h|dR|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dI|dM|dQ|dS", "o|3L|dF|1T|2p|dG|3M", "o|3L|dJ|1T|2p|dK|3M", "o|3L|dN|1T|2p|dO|3M", "disabledDirectly", "Whether the controls are disabled directly (rather than via inheritance).", "o|3Q|dX|1V|2p|dY", "a|3N|3O|3P|dU|dV|dW|3T|3U|3V|3W|3Z|dZ", "Previous/next page controls referencing a paginator elsewhere in the document", "o|F|8i|54|AZ|9X|dT|da|3M|2p|2p|8i|db|AT", "shortDescription", "a|I|J|1z|2S|2f|dd|2U", "1120000", "_input", "a|dg|2c|2d", "Position of the label relative to the input.", "a|5h|5i", "Place the label to the left of the input.", "o|3s|5h|dk", "Place the label to the right of the input.", "o|3s|5i|dm", "a|dl|dn", "o|Bi|GL|di|5h|dj|do|3y", "forAnswer", "References to `<answer>` elements that this input should submit to.", "o|2h|dq|dr|3D", "Number of rows in the matrix input.", "o|33|7A|dt|36|1q", "Number of columns in the matrix input.", "o|33|7D|dv|36|1q", "showSizeControls", "Whether to render controls for resizing the matrix.", "o|2m|dx|dy|3M|2s|1V", "defaultEntry", "Default value used for empty matrix cells.", "o|33|e0|e1|5J|1X", "Initial matrix value displayed in the input.", "o|33|Zj|e3|5J|1X", "Input format for the math entered.", "o|Bi|3p|e5|1T|3r|3x|3y", "o|4U|4P|4Q|4R|Nn|1q", "o|4U|4Z|4a|4R|5Q|1p", "bindValueTo", "Two-way binding target for the input's value.", "o|2h|e9|eA|1X", "unionFromU", 'Whether "U" between sets is parsed as union.', "o|2m|eC|eD|2p|2s|1V", "minComponentWidth", "Minimum rendered width for each cell, in pixels.", "o|33|eF|eG|5Q|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|du|dw|dz|e2|e4|e6|51|58|5B|e7|4Y|e8|4g|4j|eB|eE|eH", "o|3L|GL|1T|2p|di|3M", "o|3L|dx|1V|2p|dy|3M", "o|3L|Zj|1X|2p|e3|3M", "o|3L|3p|1T|2p|e5|3M", "o|3L|eC|1V|2p|eD|3M", "A short accessibility description of this input; it is visible to screen readers but not rendered visually.", "o|3Q|dd|1T|2p|eO", "focused", "Whether the matrix input currently has keyboard focus.", "o|3Q|eQ|1V|2p|eR", "valueChanged", "Whether the value has been changed from its initial state.", "o|3Q|eT|1V|2p|eU", "immediateValueChanged", "Whether the value, including in-progress edits, has been changed from its initial state.", "o|3Q|eW|1V|2p|eX", "The number of rows of the matrix.", "o|3Q|7A|1q|2p|eZ", "The number of columns of the matrix.", "o|3Q|7D|1q|2p|eb", "The matrix value of the input.", "o|3Q|3a|1X|2p|ed", "immediateValue", "The matrix value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|eg", "The current matrix as a text string.", "o|3Q|1T|1T|2p|ei", "The matrix as a math expression.", "o|6v|2U|1X|3M|ek|4X|7I", "a|3N|3O|3P|eJ|Hd|eK|eL|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|eS|6X|6Y|6Z|6a|6b|eV|eY|ea|ec|ee|eh|ej|el|7P|7M", "An interactive matrix input where each cell accepts a math value", "o|F|1R|de|df|dh|eI|em|3M|2p|2p|1R|en|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "112000122221111111111111111111111222222222122220222212222222221222122222122221212222", "prefillNumerator", "Initial value displayed in the numerator input.", "o|33|er|es|5J|1X", "prefillDenominator", "Initial value displayed in the denominator input.", "o|33|eu|ev|5J|1X", "Minimum rendered width for the numerator and denominator, in pixels.", "o|33|eF|ex|5Q|1q", "Two-way binding target for the fraction's value.", "o|2h|e9|ez|1X", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|et|ew|e6|51|58|5B|e7|4Y|e8|4g|4j|eE|ey|f0", "o|3L|er|1X|2p|es|3M", "o|3L|eu|1X|2p|ev|3M", "Whether the fraction input currently has keyboard focus.", "o|3Q|eQ|1V|2p|f4", "The fraction value of the input (numerator divided by denominator).", "o|3Q|3a|1X|2p|f6", "The fraction value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|f8", "numerator", "The numerator of the fraction.", "o|3Q|fA|1X|2p|fB", "denominator", "The denominator of the fraction.", "o|3Q|fD|1X|2p|fE", "The current fraction as a text string.", "o|3Q|1T|1T|2p|fG", "a|3N|3O|3P|eJ|Hd|f2|f3|eM|6C|6D|6E|eN|3T|3U|3V|3W|3Z|Hk|eP|f5|6X|6Y|6Z|6a|6b|eV|f7|eY|f9|fC|fF|fH", "An interactive fraction input with a numerator and a denominator, each accepting a math value.", "o|F|1S|ep|eq|dh|f1|fI|3M|2p|2p|1S|fJ|3h", "a|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|1z|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "111111111111111111111111111111111111111111111111111111111111111112211111111121212222121212211111111111222222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "Whether the solution is initially hidden.", "o|2m|2n|fN|2p|2s|1V", "a|2j|fO|2w|2z|32|37|3A|3E|3H", "Whether the solution is currently hidden.", "o|3Q|2n|1V|2p|fQ", "Whether the solution is currently open (revealed).", "o|3Q|M7|1V|2p|fS", "a|3O|3P|3T|3U|3V|3W|3Z|fR|fT", "A solution to an exercise, shown on demand", "o|F|8j|fL|fM|9X|fP|fU|3M|3M|2p|8j|fV|AT", 'A sectional component that renders an expandable block labeled "Answer"', "o|F|8k|fL|fM|9X|fP|fU|3M|3M|2p|8k|fX|AT", "a|1z|9A|G|9H|Ks|Kt|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "100000111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "xmlns", "XML namespace declaration (accepted for compatibility; not used).", "o|2h|fb|fc|1T", "Document type identifier.", "o|2h|2g|fe|1T", "a|2j|32|3E|3H|9h|9l|9o|9r|9u|9y|A2|A5|fd|ff", "Aggregate credit achieved (0 to 1) for scored content in the document.", "o|3Q|AL|1p|2p|fh", "Aggregate credit achieved as a percentage (0 to 100) for scored content in the document.", "o|3Q|AO|1p|2p|fj", "The document's title.", "o|3Q|G|1T|2p|fl", "a|A8|A9|AA|AB|AC|3T|3U|3V|3W|3Z|AF|AI|fi|fk|fm", "The top-level container for a DoenetML document (added implicitly if not present)", "o|F|8l|fZ|fa|Ao|fg|fn|3M|3M|2p|8l|fo|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19", "2222222222222222222222222222222222222212220222222222222222222222221122222212111111111111111111", "The text value.", "o|3Q|3a|1T|2p|fs", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|ft|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4", "A text string", "o|F|1T|fq|fr|3l|Jc|fu|3M|3M|2p|1T|fv|3h", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X", "2222222222222222222222222222222222222212220222222222222222222222221122222212", "_composite", "a|fz|2d", "a|3|2f|2k", "o|g1|2x|2y|2p", "a|3|2f", "o|g3|38|39", "Whether the order of items should be treated as unordered.", "o|2m|4n|g5|2p|2s|1V", "maxNumber", "Maximum number of items to retain in the list.", "o|33|g7|g8|9k|1p", "Whether to render the items separated by commas (true) or with no separator (false).", "o|2m|20|gA|3M|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|g6|g9|gB", "o|3L|4n|1V|2p|g5|3M", "o|3L|g7|1p|2p|g8|3M", "numComponents", "The number of items in the text list.", "o|3Q|gF|1p|2p|gG", "numValues", "The number of text values in the list.", "o|3Q|gI|1p|2p|gJ", "a|3N|3O|gD|gE|3Z|gH|gK", "A list of texts", "o|F|1U|fx|fy|g0|gC|gL|3M|3M|3M|1U|gM|Az", "A paragraph of inline content", "o|F|8m|Ag|Ah|9X|A6|Ak|3M|3M|2p|8m|gO|AT", "The boolean value (true or false).", "o|3Q|3a|1V|2p|gQ", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|gR|CW", "A boolean value", "o|F|1V|BY|BZ|3l|CI|gS|3M|3M|2p|1V|gT|3h", "Whether the order of items in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|gV|2p|2s|1V", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB", "o|3L|4n|1V|2p|gV|3M", "The number of items in the boolean list.", "o|3Q|gF|1p|2p|gZ", "The number of booleans in the list.", "o|3Q|gI|1p|2p|gb", "a|3N|3O|gY|gE|3Z|ga|gc", "A list of booleans", "o|F|1W|Cc|Cd|g0|gX|gd|3M|3M|3M|1W|ge|Az", "o|3Q|3a|1X|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A math expression", "o|F|1X|3j|3k|3l|64|gh|3M|3M|2p|1X|gi|3h", "mergeMathLists", "Whether nested math-list children should be flattened into this list.", "o|Ap|gk|gl|2s|1V", "o|g3|4P|4Q", "o|g3|4V|4W", "o|g3|4Z|4a", "o|g3|4e|4f", "o|g3|4h|4i", "Symbols treated as function names when parsing items.", "o|33|4w|gs|50|1U", "References whose names should be treated as function symbols when parsing items.", "o|33|52|gu|54|3D", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gm|gB|gn|go|gp|gq|gr|gt|gv|58|5B", "o|3L|4w|1U|2p|gs|3M", "o|3Q|4n|1V|2p|gV", "Whether nested math lists are merged into the parent list.", "o|3Q|gk|1V|2p|gz", "The number of items in the math list.", "o|3Q|gF|1p|2p|h1", "The number of math expressions in the list.", "o|3Q|gI|1p|2p|h3", "a|3N|3O|gE|gx|6D|6E|3Z|gy|h0|h2|h4", "A list of math expressions", "o|F|1Y|3j|3k|g0|gw|h5|3M|3M|3M|1Y|h6|Az", "A list of math tuples, parsed from parenthesized comma-separated pieces", "o|F|1Z|3j|3k|g0|gw|h5|3M|3M|3M|1Z|h8|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1111111111111111111111121220222101122221222221222112222222222222222222222222222", "a|2j|2t|2w|g2|32|37|g4|3E|3H|gW|g9|gB|gn|go|gp|gq|gr", "The number of items in the number list.", "o|3Q|gF|1p|2p|hD", "The number of numbers in the list.", "o|3Q|gI|1p|2p|hF", "a|3N|3O|gE|3Z|gy|hE|hG", "A list of numbers", "o|F|1a|hA|hB|g0|hC|hH|3M|3M|3M|1a|hI|Az", "Maximum number of descendants to collect.", "o|33|g7|hK||1p", "from", "Component subtree(s) to collect descendants from.", "o|2h|hM|hN|3D", "componentType", "Component type of descendants to collect.", "o|2h|hP|hQ|1T", "a|2j|32|3E|3H|hL|hO|hR|gB", "o|3L|g7|1p|2p|hK|3M", "a|hT|3Z", "Collects descendants of a component matching a specified component type", "o|F|1b|54|AZ|g0|hS|hU|3M|2p|3M|1b|hV|Az", "to", "The target that the reference points to (component reference or URL string).", "referenceOrText", "o|2h|hX|hY|hZ", "textType", "Type of text to use for the reference label.", "type-global", "o|33|hb|hc|hd|1T", "createButton", "Whether to render this reference as a clickable button.", "o|2m|hf|hg|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|ha|he|hh", "o|3L|hb|1T|2p|hc|3M", "url", "The resolved URL of the referenced component.", "o|3Q|hk|1T|2p|hl", "linkText", "The display text used for the link.", "o|3Q|hn|1T|2p|ho", "The text used as the link label.", "o|3Q|1T|1T|2p|hq", "a|3N|3O|3P|hj|3T|3U|3V|3W|3Z|hm|hp|hr", "A link to a component reference or to a URL", "o|F|1c|9U|9V|3l|hi|hs|3M|3M|2p|1c|ht|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|ax|Rw|b3|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point with coordinates that can be displayed and dragged on a graph", "o|F|1d|RR|RS|Op|hv|hw|3M|3M|2p|1d|hx|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4v|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1e|2p|6e", "Whether tuple-like expressions render as vectors (always true for `<coords>`).", "o|3Q|4q|1V|2p|i1", "a|3N|3O|3P|66|67|68|69|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|i0|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|i2|7S|7V|7Y|7b", "A math expression treated as a vector of coordinates", "o|F|1e|3j|3k|3l|hz|i3|3M|3M|2p|1e|i4|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|TY|Tb|Td|Tg|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB", "a|3N|3O|3P|Hd|QD|7s|QE|UF|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|UN|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up", "A line through two points or defined by an equation", "o|F|1f|TV|TW|Op|i6|i7|3M|3M|2p|1f|i8|Az", "Whether the line segment can be dragged on a graph.", "o|2m|5L|iA|3M|2s|1V", "endpointsDraggable", "Whether the line segment's endpoints can be dragged.", "o|Ap|iC|iD|2s|1V", "endpoints", "The two endpoints of the line segment.", "o|2h|iF|iG|2W", "a|iF|42|2q|2r", "Show control handles for both endpoints of the segment.", "o|3s|iF|iJ", "a|iK|Sa", "o|Bi|ST|SU|iF|iI|iL|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|iB|iE|iH|iM|P4|UB|H8|4Y|4c|4g|4j|So", "o|3L|5L|1V|2p|iA|3M", "A textual description of the line segment's style.", "o|3Q|Hl|1T|2p|iP", 'Style description including "line segment".', "o|3Q|Ho|1T|2p|iR", "Whether each endpoint can be dragged independently.", "o|3Q|iC|1V|2p|iT", "Number of dimensions the segment lives in.", "o|3Q|6r|1p|2p|iV", "The endpoints of the line segment.", "o|Qc|iF|1X|3M|iX|4X|IM|Qf", "The length of the line segment.", "o|3Q|Qh|1X|2p|iZ", "The slope of the line segment (2D only).", "o|3Q|Te|1p|2p|ib", "a|3N|3O|3P|Hd|QD|7s|QE|iO|Sy|QG|UG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|iQ|iS|iU|iW|iY|ia|ic", "A line segment between two endpoints", "o|F|8n|Om|On|Op|iN|id|3M|2p|2p|8n|ie|Az", "Whether the ray can be dragged on a graph.", "o|2m|5L|ig|3M|2s|1V", "The starting point (endpoint) of the ray.", "o|2h|2K|ii|1d", "A point the ray passes through (used with endpoint or direction).", "o|2h|Gr|ik|1d", "direction", "The direction the ray points in.", "o|2h|im|in|1h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|ih|ij|il|io|UB|H8|4Y|4c|4g|4j", "o|3L|5L|1V|2p|ig|3M", "A textual description of the ray's style.", "o|3Q|Hl|1T|2p|ir", 'Style description including the word "ray".', "o|3Q|Ho|1T|2p|it", "Number of dimensions the ray lives in.", "o|3Q|6r|1p|2p|iv", "The direction vector of the ray.", "o|6v|im|1X|3M|ix|36|6z", "A point the ray passes through.", "a|Qe", "o|Qc|Gr|1X|3M|iz|36|IY|j0", "The starting endpoint of the ray.", "o|Qc|2K|1X|3M|j2|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|iq|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|is|iu|iw|iy|j1|j3", "A ray starting at one point passing through another", "o|F|8o|Om|On|Op|ip|j4|3M|2p|2p|8o|j5|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j", "The number of vertices in the polyline.", "o|3Q|RD|1p|2p|j8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|QQ|QS|QU|QW|QY|j9|Qa|Qg|Qj|Ql", "A polyline (open polygon) defined by a list of vertices", "o|F|8p|Om|On|Op|j7|jA|3M|2p|2p|8p|jB|Az", "Whether to render interactive vertex control handles.", "a|5b|42|2q|2r", "Show a control handle for moving the polygon's center.", "o|3s|5b|jF", "a|jG|Sa", "o|Bi|ST|jD|5b|jE|jH|3y", "filled", "Whether to fill the interior of the polygon.", "o|2m|jJ|jK|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|jI|jL|So", "o|3L|ST|1T|2p|jD|3M", "o|3L|jJ|1V|2p|jK|3M", "A textual description of the polygon's style.", "o|3Q|Hl|1T|2p|jP", 'Style description including the word "polygon".', "o|3Q|Ho|1T|2p|jR", "borderStyleDescription", "A textual description of the polygon's border style.", "o|3Q|jT|1T|2p|jU", "fillStyleDescription", "A textual description of the polygon's fill style.", "o|3Q|jW|1T|2p|jX", "perimeter", "The perimeter of the polygon.", "o|3Q|jZ|1p|2p|ja", "area", "The area enclosed by the polygon.", "o|3Q|jc|1p|2p|jd", "numSides", "The number of sides of the polygon.", "o|3Q|jf|1p|2p|jg", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|j9|Qa|Qg|Ql|jV|jY|jb|je|jh", "A polygon defined by a list of vertices", "o|F|8q|Om|On|Op|jM|ji|3M|2p|2p|8q|jj|Az", "The number of vertices (always 3 for a triangle).", "o|3Q|RD|1p|2p|jl", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|jN|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|jm|Qa|Qg|Ql|jV|jY|jb|je|jh", "A triangle defined by three vertices", "o|F|8r|Om|On|Op|jM|jn|3M|2p|2p|8r|jo|Az", "centerWidthAndHeight", "widthAndHeight", "a|5b|jr|jq|42|2q|2r", "Show a single control handle for moving the rectangle's center.", "o|3s|5b|jt", "Show control handles for resizing width and height.", "o|3s|jr|jv", "Show control handles for both moving the center and resizing.", "o|3s|jq|jx", "a|ju|jw|jy|Sa", "o|Bi|ST|SU|jq|js|jz|3y", "The rectangle's center point.", "o|2h|5b|k1|1d", "The rectangle's width.", "o|2h|bx|k3|1p", "height", "The rectangle's height.", "o|2h|k5|k6|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PA|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|k0|jL|So|k2|k4|k7", "The number of vertices (always 4 for a rectangle).", "o|3Q|RD|1p|2p|k9", "The four corner vertices of the rectangle.", "o|Qc|Oz|1X|3M|kB|4X|IM|Qf", "The rectangle's center coordinates.", "o|6v|5b|1X|3M|kD|36|IY", "o|3Q|bx|1p|2p|k3", "o|3Q|k5|1p|2p|k6", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|QU|QW|QY|kA|Qa|kC|kE|jV|jY|jb|je|kF|kG|jh", "A rectangle, potentially defined by width, height, center and/or corner vertices", "o|F|8s|Om|On|Op|k8|kH|3M|2p|2p|8s|kI|Az", "centerAndRadius", "radius", "a|5b|kL|kK|42|2q|2r", "Show a control handle for resizing the polygon's radius.", "o|3s|kL|kN", "Show control handles for both moving the center and resizing the radius.", "o|3s|kK|kP", "a|jG|kO|kQ|Sa", "o|Bi|ST|SU|kK|kM|kR|3y", "Number of vertices in the regular polygon.", "o|33|RD|kT|4S|1q", "Number of sides in the regular polygon (alias for numVertices).", "o|2h|jf|kV|1q", "Center of the regular polygon.", "o|2h|5b|kX|1d", "circumradius", "Distance from center to a vertex (circumscribed-circle radius).", "o|2h|kZ|ka|1p", "Alias for circumradius.", "o|2h|kL|kc|1p", "inradius", "Distance from center to the midpoint of a side (inscribed-circle radius).", "o|2h|ke|kf|1p", "apothem", "Alias for inradius.", "o|2h|kh|ki|1p", "sideLength", "Length of each side of the regular polygon.", "o|2h|kk|kl|1p", "Total perimeter of the regular polygon.", "o|2h|jZ|kn|1p", "Total area enclosed by the regular polygon.", "o|2h|jc|kp|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|Ov|Oy|P1|P4|P7|PE|PR|PU|PX|Pa|Pd|Pg|Pk|Pn|H8|4Y|4c|4g|4j|kS|jL|So|kU|kW|kY|kb|kd|kg|kj|km|ko|kq", "Whether to preserve similarity when dragging.", "o|3Q|P8|1V|2p|ks", "The number of vertices (sides) of the regular polygon.", "o|3Q|RD|1q|2p|ku", "The center coordinates of the regular polygon.", "o|6v|5b|1X|3M|kw|36|IY", "The radius of the circumscribed circle.", "o|3Q|kZ|1p|2p|ky", "The radius of the inscribed circle.", "o|3Q|ke|1p|2p|l0", "The length of each side.", "o|3Q|kk|1p|2p|l2", "The number of sides of the regular polygon.", "o|3Q|jf|1q|2p|l4", "Distance from center to a vertex (alias for circumradius).", "o|3Q|kL|1p|2p|l6", "Distance from center to the midpoint of a side (alias for inradius).", "o|3Q|kh|1p|2p|l8", "a|3N|3O|3P|Hd|QD|7s|QE|QF|QG|QH|QI|QJ|QK|Sy|jO|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|jQ|jS|kt|QW|QY|kv|Qa|Qg|kx|jV|jY|jb|je|kz|l1|l3|l5|l7|l9", "A regular polygon with a given number of sides", "o|F|8t|Om|On|Op|kr|lA|3M|2p|2p|8t|lB|Az", "Points the circle passes through.", "o|2h|Gr|lD|2W", "The circle's center point.", "o|2h|5b|lF|1d", "The circle's radius.", "o|2h|kL|lH|1X", "Whether to render interactive control handles on the circle.", "Show a control handle for moving the circle's center.", "o|3s|5b|lK", "Show a control handle for resizing the circle's radius.", "o|3s|kL|lM", "a|lL|lN|kQ|Sa", "o|Bi|ST|lJ|kK|kM|lO|3y", "Whether to fill the interior of the circle.", "o|2m|jJ|lQ|2p|2s|1V", "Whether to suppress the indicator drawn at the edge when the component is off-screen.", "o|Ap|Sj|lS|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|lE|WQ|WS|H8|4Y|4c|4g|4j|lG|lI|lP|lR|lT|So", "o|3L|ST|1T|2p|lJ|3M", "o|3L|jJ|1V|2p|lQ|3M", "A textual description of the circle's style.", "o|3Q|Hl|1T|2p|lX", 'Style description including the word "circle".', "o|3Q|Ho|1T|2p|lZ", "A textual description of the circle's border style.", "o|3Q|jT|1T|2p|lb", "A textual description of the circle's fill style.", "o|3Q|jW|1T|2p|ld", "Whether to suppress the off-graph indicator when the circle is outside the visible area.", "o|3Q|Sj|1V|2p|lf", "Maximum value of the curve parameter (always 2π for a circle).", "o|3Q|WM|1p|2p|lh", "Minimum value of the curve parameter (always 0 for a circle).", "o|3Q|WJ|1p|2p|lj", "Points the circle is constrained to pass through.", "o|Qc|Wo|1X|3M|ll|4X|IM|Qf", "The radius of the circle.", "o|3Q|kL|1X|2p|ln", "diameter", "The diameter of the circle.", "o|3Q|lp|1X|2p|lq", "circumference", "The circumference of the circle.", "o|3Q|ls|1X|2p|lt", "The area enclosed by the circle.", "o|3Q|jc|1X|2p|lv", "The center coordinates of the circle.", "o|Qc|5b|1X|3M|lx|36|IY|j0", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|lV|lW|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|lY|la|lc|le|lg|li|lk|lm|lo|lr|lu|lw|ly", "A circle, potentially defined by center, radius, and/or points on the circle", "o|F|8u|TV|TW|Op|lU|lz|3M|3M|2p|8u|m0|Az", "Points the parabola passes through.", "o|2h|Gr|m2|2W", "The vertex of the parabola.", "o|33|PI|m4||1d", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|m3|WQ|WS|H8|4Y|4c|4g|4j|m5", 'Style description including the word "parabola".', "o|3Q|Ho|1T|2p|m7", "Maximum value of the parabola's parameter.", "o|3Q|WM|1p|2p|m9", "Minimum value of the parabola's parameter.", "o|3Q|WJ|1p|2p|mB", "o|6v|Wo|1X|3M|m2|4X|IM", "a", "The leading coefficient of the parabola (in y = a x^2 + b x + c).", "o|3Q|mE|1p|2p|mF", "b", "The linear coefficient in y = a x^2 + b x + c.", "o|3Q|mH|1p|2p|mI", "The constant term in y = a x^2 + b x + c.", "o|3Q|15|1p|2p|mK", "The vertex coordinates of the parabola.", "o|6v|PI|1X|3M|mM|36|IY", "The parabola's equation as a math expression.", "o|3Q|TZ|1X|2p|mO", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|m8|mA|mC|mD|mG|mJ|mL|mN|mP", "A parabola defined by formula or geometric parameters", "o|F|8v|TV|TW|Op|m6|mQ|3M|3M|2p|8v|mR|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Ux|V0|VP|VR|Vk|Vn|Vq|Vt|Vx|W0|W3|WE|WG|WI|WL|WO|WQ|WS|H8|4Y|4c|4g|4j", "a|3N|3O|3P|Hd|QD|7s|QE|WU|WV|WW|WX|WY|WZ|Wa|Wb|Wc|Wd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|Wf|Wh|Wj|Wl|Wn|Wq|Wt|Ww|X3|X8|XB|XE|XH|XK|XN|XQ|XT|XW|XZ|Xb", "A curve defined by a function, parametric formulas, or control points", "o|F|8w|Ut|Uu|Op|mT|mU|3M|3M|2p|8w|mV|Az", "a|Wx|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "02122221111111111111111111111222222222122220222212222201221222122222122221212222", "alwaysVisible", "Whether Bezier control handles are always shown (rather than only when the curve is selected).", "o|2m|mZ|ma|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|mb", "o|3L|mZ|1V|2p|ma|3M", "a|3N|3O|3P|md|3T|3U|3V|3W|3Z", "Defines Bezier control vectors at points along a curve", "o|F|1g|mX|mY|3l|mc|me|3M|3M|2p|1g|mf|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1O|1X|1Y|1Z|1e|1h|1t|1u|1z|21|24|29|2A|2O|2U|2X|2Y|L|M|N|Q|w|x|y|z|1J|1K|1L|1M|1N|1R|1S|1T|1U|1a|1d|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2K|2Q|2V|2W", "1111111111111111111111110221012221211122222222222222222222222222222222222222222", "Whether the order of vectors in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|mj|2p|2s|1V", "Maximum number of vectors to retain in the list.", "o|33|g7|ml|9k|1p", "Direction in which the control vectors apply at the vertex.", "symmetric", "previous", "next", "a|mo|mp|mq|SV|42", "Mirror the control vector on both sides of the vertex.", "o|3s|mo|ms", "Apply the control vector toward the previous segment only.", "o|3s|mp|mu", "Apply the control vector toward the next segment only.", "o|3s|mq|mw", "Apply independent control vectors to both adjacent segments.", "o|3s|SV|my", "No control vector at this vertex.", "o|3s|42|n0", "a|mt|mv|mx|mz|n1", "o|Bi|im|mn|mo|mr|n2|3y", "pointNumber", "1-based index of the vertex these control vectors attach to.", "o|33|n4|n5||1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr|n3|n6", "o|3L|g7|1p|2p|ml|3M", "o|3L|im|1T|2p|mn|3M", "o|3L|n4|1p|2p|n5|3M", "numVectors", "The number of vectors in the list.", "o|3Q|nB|1p|2p|nC", "o|3Q|gI|1p|2p|nC", "a|3N|3O|n8|n9|nA|3Z|gy|nD|nE", "Bezier control vectors at points defining a curve (used inside `<bezierControls>`)", "o|F|Wx|mh|mi|g0|n7|nF|2p|3M|2p|Wx|nG|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|21|24|29|2A|2K|2O|2U|2W|2X|2Y|z|1T|1U|1a|1p|1q|1v|25|26|27|28|2B|2C|2D|2V|L|M|N|Q|w|x|y|1K|1L|1M|1N|1R|1S|1f|1i|1k|1o|1r|1s|2Q", "1120111111111111111111111111102201012212111122222220122222222222222222222222222222", "Whether the vector can be dragged on a graph.", "o|2m|5L|nK|3M|2s|1V", "headDraggable", "Whether the vector's head can be dragged.", "o|Ap|nM|nN|2s|1V", "tailDraggable", "Whether the vector's tail can be dragged.", "o|Ap|nP|nQ|2s|1V", "The first component (x) of the vector's displacement.", "o|2h|7Q|nS|1X", "The second component (y) of the vector's displacement.", "o|2h|7T|nU|1X", "The third component (z) of the vector's displacement.", "o|2h|7W|nW|1X", "The vector's displacement components as a list.", "o|2h|S5|nY|1Y", "displacement", "The vector's displacement (head minus tail).", "o|2h|na|nb|1e", "head", "The head (tip) point of the vector.", "o|2h|nd|ne|1d", "tail", "The tail (base) point of the vector.", "o|2h|ng|nh|1d", "headAndTail", "headOnly", "tailOnly", "a|na|nj|nk|nl|42|2q|2r", "Show a control handle for translating the whole vector.", "o|3s|na|nn", "Show control handles for both the head and the tail.", "o|3s|nj|np", "Show a control handle only at the head.", "o|3s|nk|nr", "Show a control handle only at the tail.", "o|3s|nl|nt", "a|no|nq|ns|nu|Sa", "o|Bi|ST|SU|na|nm|nv|3y", "displayWithAngleBrackets", "Whether to display the vector with angle brackets (e.g. ⟨1,2⟩).", "o|2m|nx|ny|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|nL|nO|nR|nT|nV|nX|nZ|nc|nf|ni|nw|UB|H8|4Y|4c|4g|4j|nz|P4|So", "o|3L|5L|1V|2p|nK|3M", "o|3L|nx|1V|2p|ny|3M", "A textual description of the vector's style.", "o|3Q|Hl|1T|2p|o3", 'Style description including the word "vector".', "o|3Q|Ho|1T|2p|o5", "Whether the vector's tail can be dragged independently.", "o|3Q|nP|1V|2p|o7", "Whether the vector's head can be dragged independently.", "o|3Q|nM|1V|2p|o9", "Number of dimensions of the vector.", "o|3Q|6r|1p|2p|oB", "The displacement (head − tail) of the vector.", "o|Qc|na|1X|3M|oD|36|6z|j0", "Coordinates of the vector's head.", "o|Qc|nd|1X|3M|oF|36|IY|j0", "Coordinates of the vector's tail.", "o|Qc|ng|1X|3M|oH|36|IY|j0", "magnitude", "The magnitude (length) of the vector.", "o|3Q|oJ|1X|2p|oK", "The vector rendered as a LaTeX string.", "o|3Q|2V|2V|2p|oM", "o|3Q|7Q|1X|2p|nS", "o|3Q|7T|1X|2p|nU", "o|3Q|7W|1X|2p|nW", "a|3N|3O|3P|Hd|QD|7s|QE|o1|Sy|UG|o2|QG|Sz|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|o4|o6|o8|oA|oC|oE|oG|oI|oL|oN|oO|oP|oQ", "A geometric vector with tail and head", "o|F|1h|nI|nJ|Op|o0|oR|3M|3M|2p|1h|oS|Az", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y", "1120111111111111111111111112122022210112221222221222112222222222222222222222222222", "Radius of the rendered angle arc.", "1", "o|5H|1X|oX", "o|33|kL|oW|oY|1X", "chooseReflexAngle", "How to handle reflex angles.", "never", "allowed", "always", "a|oc|od|oe", "Always normalize to the non-reflex angle (less than 180°).", "o|3s|oc|og", "Use a reflex angle (greater than 180°) if it matches the input.", "o|3s|od|oi", "Always render the angle as a reflex angle.", "o|3s|oe|ok", "a|oh|oj|ol", "o|Bi|oa|ob|oc|of|om|3y", "inDegrees", "Whether to interpret and display the angle in degrees rather than radians.", "o|2m|oo|op|2p|2s|1V", "radians", "The angle measure in radians.", "o|2h|or|os|1X", "degrees", "The angle measure in degrees.", "o|2h|ou|ov|1X", "Three points (vertex in the middle) defining the angle.", "o|2h|Gr|ox|2W", "betweenLines", "Two lines whose intersection forms the angle.", "_lineListComponent", "o|2h|oz|p0|p1", "emphasizeRightAngle", "Whether to render right angles with the conventional square symbol.", "o|2m|p3|p4|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|oZ|on|oq|ot|ow|oy|p2|H8|4Y|4c|4g|4j|p5", "o|3L|kL|1X|2p|oW|3M", "o|3L|oa|1T|2p|ob|3M", "o|3L|oo|1V|2p|op|3M", "o|3L|p3|1V|2p|p4|3M", "o|3Q|or|1X|2p|os", "o|3Q|ou|1X|2p|ov", "o|3Q|3a|1X|2p|os", "o|3Q|1i|1X|2p|os", "a|3N|3O|3P|Hd|QD|7s|QE|p7|p8|p9|pA|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|pB|pC|pD|pE", "An angle defined by three points or a measure", "o|F|1i|oU|oV|Op|p6|pF|3M|3M|2p|1i|pG|Az", "considerAsResponses", "a|8x|1z|1R|1S|1k|1l|1m|1n|pI|I|J|2S|2f|dd|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2T", "021111110110001222211111111111111111111112221222221000010212220012212221222221112212112221111111110011", "Relative weight of this answer when aggregating credit across multiple answers.", "answer-grading", "o|4U|9c|pL|pM|36|1p", "handGraded", "Whether this answer is graded by hand rather than automatically.", "o|4d|pO|pP|pM|2p|2s|1V", "matchPartial", "Whether to award partial credit when the response is partially correct.", "o|4d|pR|pS|pM|2p|2s|1V", "Maximum number of times the response can be submitted.", "o|4U|9i|pU|pM|9k|1q", "Whether to display whether the submitted response is correct.", "o|4d|9m|pW|pM|3M|2s|1V", "Whether to color-code the response based on its correctness.", "o|4d|9p|pY|pM|3M|2s|1V", "disableAfterCorrect", "Whether to disable the answer after a fully correct response has been submitted.", "o|4d|pa|pb|pM|2p|2s|1V", "Label for the submit button when correctness is shown.", "o|4U|9v|pd|pM|9x|1T", "Label for the submit button when correctness is not shown.", "o|4U|9z|pf|pM|A1|1T", "displayDigitsForResponses", "Number of significant digits to display when rendering numeric responses.", "o|4U|ph|pi|pM|Nn|1q", "o|4U|A3|A4|pM|4S|1q", "a|3|2f|3m|2k|2l|2g", "Whether to render the answer's input inline rather than as a block.", "o|pl|3h|pm|3M|2p|2s|1V", "Whether comparison uses symbolic equality (rather than numeric evaluation).", "o|pl|Bc|po|3M|2p|2s|1V", "forceFullCheckWorkButton", "Whether to always render a full-size check-work button.", "o|2m|pq|pr|2p|2s|1V", "forceSmallCheckWorkButton", "Whether to always render a small check-work button.", "o|2m|pt|pu|2p|2s|1V", "Level of simplification applied to math expressions before comparing them.", "o|Bi|Bj|pw|42|47|Bp|3y", "Whether to expand math expressions before comparing them.", "o|2m|Bf|py|2p|2s|1V", "Whether order is ignored when comparing list-like responses.", "o|2m|Br|q0|2p|2s|1V", "Whether to match list responses by exact position rather than by content.", "o|2m|Bu|q2|2p|2s|1V", "numAwardsCredited", "Maximum number of matching awards whose credits are summed.", "o|33|q4|q5|36|1q", "colorInputsSeparately", "Attempt to color each input separately based on the awards that reference it, rather than all inputs sharing the same overall credit color.", "o|2m|q7|q8|2p|2s|1V", "Maximum allowed numeric error when comparing numbers (relative or absolute).", "o|33|Bx|qA|5Q|1p", "Type of input the answer expects.", "videoWatched", "a|1X|1T|1V|qD", "Expect a math expression answer.", "o|3s|1X|qF", "Expect a text answer.", "o|3s|1T|qH", "Expect a boolean answer.", "o|3s|1V|qJ", "Mark correct when the associated video has been watched.", "o|3s|qD|qL", "a|qG|qI|qK|qM", "o|Bi|2g|qC||qE|qN|3y", "selectMultiple", "For choice answers: whether multiple choices may be selected.", "o|2m|qP|qQ|2p|2s|1V", "shuffleOrder", "For choice answers: whether to display choices in randomized order.", "o|2m|qS|qT|2p|2s|1V", "preserveLastChoice", "For choice answers: whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|qW|2p|2s|1V", "disableWrongChoices", "Whether incorrect choices are disabled after being submitted.", "o|2m|qY|qZ|2p|2s|1V", "creditByAttempt", 'Per-attempt credit multipliers (e.g. "1 0.7 0.5" for full/70%/50% on attempts 1/2/3+).', "o|33|qb|qc|54|1a", "Whether multi-character symbols should be split into a product of single-character variables when parsing.", "o|2m|56|qe|3M|2s|1V", "expanded", "Whether the answer's submitted-response panel is expanded by default.", "o|2m|qg|qh|2p|2s|1V", "showPreview", "Whether to display a preview of the response as the student types.", "o|2m|qj|qk|2p|2s|1V", "Reference to a video; when watched, this answer's videoWatched type marks credit.", "o|2h|9D|qm|3D", "videoCreditLabel", "Label shown next to the credit indicator for a video-watched answer.", "o|2h|qo|qp|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|pn|pp|ps|pv|px|pz|q1|q3|q6|q9|qB|C2|C5|C8|CB|CE|CH|qO|qR|qU|qX|qa|qd|qf|5B|qi|ql|qn|qq|GH", "o|6J|9c|1p|2p|pL|3M|pM", "o|6J|pO|1V|2p|pP|3M|pM", "o|6J|pR|1V|2p|pS|3M|pM", "o|6J|9i|1q|2p|pU|3M|pM", "o|6J|pa|1V|2p|pb|3M|pM", "o|6J|9v|1T|2p|pd|3M|pM", "o|6J|9z|1T|2p|pf|3M|pM", "o|6J|ph|1q|2p|pi|3M|pM", "o|6J|A3|1q|2p|A4|3M|pM", "o|65|3h|1V|2p|pm|3M|3M", "o|65|Bc|1V|2p|po|3M|3M", "o|3L|pq|1V|2p|pr|3M", "o|3L|pt|1V|2p|pu|3M", "o|3L|Bj|1T|2p|pw|3M", "o|3L|Bf|1V|2p|py|3M", "o|3L|Br|1V|2p|q0|3M", "o|3L|Bu|1V|2p|q2|3M", "o|3L|q4|1q|2p|q5|3M", "o|3L|q7|1V|2p|q8|3M", "o|3L|Bx|1p|2p|qA|3M", "o|3L|qP|1V|2p|qQ|3M", "o|3L|qS|1V|2p|qT|3M", "o|3L|qV|1V|2p|qW|3M", "o|3L|qY|1V|2p|qZ|3M", "o|3L|qb|1a|2p|qc|3M", "o|3L|56|1V|2p|qe|3M", "o|3L|qg|1V|2p|qh|3M", "o|3L|qj|1V|2p|qk|3M", "The fraction of credit achieved on the most recent submission (between 0 and 1).", "o|3Q|AL|1p|2p|rK", "responseHasBeenSubmitted", "Whether a response has ever been submitted for this answer.", "o|3Q|rM|1V|2p|rN", "justSubmitted", "Whether the most recent submission for this answer has not yet been changed.", "o|3Q|rP|1V|2p|rQ", "Total number of times a response has been submitted.", "o|3Q|AD|1q|2p|rS", "Remaining number of submission attempts before the maximum is reached.", "o|3Q|AG|1q|2p|rU", "Whether this answer is disabled and is no longer accepting submissions.", "o|3Q|2u|1V|2p|rW", "Whether any input within this answer currently has keyboard focus.", "o|3Q|eQ|1V|2p|rY", "numResponses", "The number of current (unsubmitted) response values from this answer's inputs.", "o|3Q|ra|1p|2p|rb", "a|3|3J|2f|6r|6u", "currentResponses", "The current (unsubmitted) response values from this answer's inputs.", "a|3J|6r", "o|rg|3M|36", "a|rh", "o|rd|re|3M|rf|36|ri", "numSubmittedResponses", "The number of response values from the most recent submission.", "o|3Q|rk|1p|2p|rl", "submittedResponses", "The response values from the most recent submission.", "o|rd|rn|3M|ro|36|ri", "numFeedbacks", "The number of feedback messages produced by matched awards or applicable feedback definitions.", "o|3Q|rq|1p|2p|rr", "feedbacks", "The feedback messages produced by matched awards or applicable feedback definitions.", "o|73|3M|9F|36", "a|rv", "o|6v|rt|9F|3M|ru|36|rw", "a|3|3J|2f", "currentResponse", "The current (unsubmitted) response value from the answer's first input.", "o|ry|rz|2p|s0", "submittedResponse", "The first response value from the most recent submission.", "o|ry|s2|2p|s3", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|r1|r2|r3|r4|r5|r6|r7|r8|r9|rA|rB|CP|CQ|CR|CS|CT|CU|rC|rD|rE|rF|rG|rH|6E|rI|rJ|Hd|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|Hk|rZ|rc|rj|rm|rp|rs|rx|s1|s4", "answer1", "Assigns credit to student responses based on matches or logical rules", "o|F|1j|pJ|pK|3l|qr|s5|3M|2p|2p|s6|s7|3h", "when", "a|s9|1z|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m|8a", "02122221111111111111111111111222122222122020222212222201221222122222111221211222221111111110212120", "credit", "Fraction of credit (0 to 1) granted when this award matches.", "o|33|sC|sD|36|1p", "o|2m|pR|pS|2p|2s|1V", "o|2m|Bc|po|2p|2s|1V", "feedbackCodes", "Codes that select reusable feedback messages when this award matches.", "o|33|sH|sI|54|1U", "feedbackText", "Custom feedback text shown when this award matches.", "o|33|sK|sL||1T", "referencesAreResponses", "References to components whose values should be treated as responses for this award.", "o|2h|sN|sO|3D", "a|2j|2t|2w|2z|32|37|3A|3E|3H|sE|sF|sG|pz|px|q1|q3|qB|C2|C5|C8|CB|CE|CH|sJ|sM|sP|qf|5B", "o|3L|sC|1p|2p|sD|3M", "o|3L|pR|1V|2p|pS|3M", "o|3L|Bc|1V|2p|po|3M", "o|3L|sH|1U|2p|sI|3M", "o|3L|sK|1T|2p|sL|3M", "creditAchievedIfSubmit", "Credit (0 to 1) this award would grant if submitted with the current response.", "o|3Q|sW|1p|2p|sX", "fractionSatisfiedIfSubmit", "Fraction (0 to 1) by which this award's match condition is currently satisfied.", "o|3Q|sZ|1p|2p|sa", "fractionSatisfied", "Fraction (0 to 1) by which this award's match condition was satisfied at last submission.", "o|3Q|sc|1p|2p|sd", "Credit (0 to 1) this award granted at the last submission.", "o|3Q|AL|1p|2p|sf", "awarded", "Whether this award was matched at the last submission.", "o|3Q|sh|1V|2p|si", "The number of feedback messages associated with this award.", "o|3Q|rq|1p|2p|sk", "The feedback messages produced by this award.", "o|6v|rt|9F|3M|sm|36|rw", "The first feedback message produced by this award.", "o|3Q|9F|9F|2p|so", "a|3N|3O|3P|sR|sS|sT|r6|r5|r7|r8|rB|CP|CQ|CR|CS|CT|CU|sU|sV|rH|6E|3T|3U|3V|3W|3Z|sY|sb|se|sg|sj|sl|sn|sp", "Specifies conditions for awarding credit in an answer", "o|F|8x|sA|sB|Ao|sQ|sq|3M|3M|2p|8x|sr|Az", "Whether to match partial conditions for partial credit.", "o|2m|pR|st|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|su", "o|3L|pR|1V|2p|st|3M", "Whether the condition is currently true.", "o|3Q|3a|1V|2p|sx", "Fraction of the boolean condition that is satisfied (0 to 1).", "o|3Q|sc|1p|2p|sz", "Whether the condition is currently satisfied; equivalent to value.", "o|3Q|Au|1V|2p|t1", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|sw|3T|3U|3V|3W|3Z|sy|t0|t2|CW", "Defines logical conditions within an `<award>`", "o|F|s9|BY|BZ|3l|sv|t3|2p|3M|2p|s9|t4|3h", "Initial value displayed in the input.", "o|33|Zj|t6|5J|1X", "prefillLatex", "Initial value as a LaTeX string.", "o|33|t8|t9|AZ|2V", "o|Bi|3p|3q|1T|3r|3x|3y", "additionalFunctionNames", "Extra identifiers to auto-format as function names in the editor (e.g., 'erf'). Entries that also appear in `removedFunctionNames` are dropped.", "o|33|tC|tD|54|1U", "removedFunctionNames", "Built-in function names to stop auto-formatting in the editor (e.g., 'min' so 'kg/min' can be typed as a unit).", "o|33|tF|tG|54|1U", "resetFunctionNames", "When set, replaces the entire auto-formatted function name list (defaults, `additionalFunctionNames`, and `removedFunctionNames` are all ignored). Set to an empty value to disable auto-formatting entirely.", "o|33|tI|tJ||1U", "Whether multi-character symbols are split into a product of single-character variables.", "o|2m|56|tL|3M|2s|1V", "hideNaN", "Whether to hide NaN values when displaying the input.", "o|2m|tN|tO|3M|2s|1V", "removeStrings", "Substrings to strip from the input before parsing.", "o|33|tQ|tR||1U", "minWidth", "Minimum rendered width of the input.", "n|o", "o|33|tT|tU|tV|1q", "Whether to display a preview of the parsed math.", "o|2m|qj|tX|2p|2s|1V", "Whether the input can be dragged on a graph.", "o|2m|5L|tZ|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|t7|tA|tB|51|tE|tH|tK|tM|5B|e7|4Y|e8|4g|4j|eB|eE|tP|tS|tW|tY|ta|5X|63", "o|3L|Zj|1X|2p|t6|3M", "o|3L|t8|2V|2p|t9|3M", "o|3L|3p|1T|2p|3q|3M", "o|3L|tC|1U|2p|tD|3M", "o|3L|tF|1U|2p|tG|3M", "o|3L|tI|1U|2p|tJ|3M", "o|3L|56|1V|2p|tL|3M", "o|3L|tN|1V|2p|tO|3M", "o|3L|tT|1q|2p|tU|3M", "o|3L|5L|1V|2p|tZ|3M", "Whether this input currently has keyboard focus.", "o|3Q|eQ|1V|2p|tm", "o|3Q|qj|1V|2p|tX", "The math value of the input.", "o|3Q|3a|1X|2p|tp", "The math value reflecting the user's in-progress edits.", "o|3Q|ef|1X|2p|tr", "The current input as a text string.", "o|3Q|1T|1T|2p|tt", "rawRendererValue", "The raw value used by the renderer (e.g. LaTeX string).", "o|3Q|tv|2V|2p|tw", "a|3N|3O|3P|eJ|Hd|tc|td|te|6C|tf|tg|th|ti|6E|eN|tj|tk|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6X|6Y|6Z|6a|6b|6W|to|eV|tq|eY|ts|tu|tx|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "An interactive math input", "o|F|1k|ep|eq|dh|tb|ty|3M|3M|2p|1k|tz|3h", "a|I|J|1z|2S|2f|dd|H|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2T|2U|2V|2X", "112000222222222222222222222222222222222222122202222222222222222222222112222212", "Initial text shown in the input before the user types.", "o|33|Zj|u3|AZ|1T", "o|2h|e9|eA|1T", "Whether the input renders as a multi-line text area.", "o|2m|qg|u6|2p|2s|1V", "Display width of the input.", "o|2h|bx|u8|bz", "Display height of the input.", "size", "isAbsolute", "a|uB|uC", "n|1w", "o|uD|uE|3M", "o|33|k5|uA|uF|bz", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|u4|u5|u7|u9|uG|ta|5X|63", "o|3L|Zj|1T|2p|u3|3M", "o|3L|qg|1V|2p|u6|3M", "o|3L|k5|bz|2p|uA|3M", "o|3Q|bx|bz|2p|u8", "The text value of the input.", "o|3Q|3a|1T|2p|uM", "The text value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|uO", "The current text as a plain text string.", "o|3Q|1T|1T|2p|uQ", "a|3N|3O|3P|eJ|Hd|uI|uJ|uK|tl|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|eV|eY|6W|uL|uN|uP|uR|Jp|Ju|Jx|K0|K2|K4", "An interactive text input", "o|F|1l|u1|u2|dh|uH|uS|3M|3M|2p|1l|uT|3h", "a|I|J|1z|2S|2f|dd|R|S|T|U|V|W|X|Y|Z|1V|1W|1m|2R|2T|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y", "11200011111111102211122221111111111111111111111222222222122220222212222201221222122222122221212222", "o|Bi|GL|di|5i|dj|do|3y", "The initial value of the input before the student interacts.", "o|2m|Zj|uY|2p|2s|1V", "asToggleButton", "Whether to render the input as a toggle button rather than a checkbox.", "o|2m|ua|ub|2p|2s|1V", "o|Ap|e9|eA|2s|1V", "Whether the input can be dragged on a graph by its anchor.", "o|2m|5L|ue|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|uX|ds|GH|uZ|uc|ud|uf|5X|63", "o|3L|Zj|1V|2p|uY|3M", "o|3L|ua|1V|2p|ub|3M", "o|3L|5L|1V|2p|ue|3M", "Whether the input's value has been changed from its prefill value.", "o|3Q|eT|1V|2p|uk", "The current boolean value of the input.", "o|3Q|3a|1V|2p|um", 'The current value rendered as a text string ("true" or "false").', "o|3Q|1T|1T|2p|uo", "a|3N|3O|3P|eJ|Hd|uh|ui|uj|6K|3T|3U|3V|3W|3Z|Hk|eP|tn|6W|ul|un|up", "An interactive boolean (toggle/checkbox) input", "o|F|1m|uV|uW|dh|ug|uq|3M|3M|2p|1m|ur|3h", "a|I|J|1z|2S|2f|dd|1o", "Whether multiple choices may be selected.", "o|2m|qP|uu|2p|2s|1V", "Whether to award partial credit when only some correct choices are selected.", "o|2m|pR|uw|2p|2s|1V", "Whether to render the input inline (as a dropdown) rather than as a list of choices.", "o|2m|3h|uy|2p|2s|1V", "Whether to display the choices in randomized order.", "o|2m|qS|v0|2p|2s|1V", "Whether the last-rendered choice keeps its position when shuffling.", "o|2m|qV|v2|2p|2s|1V", "preselectChoice", "Index of a choice to pre-select on initial render.", "o|33|v4|v5||1p", "placeHolder", "Placeholder text shown when no choice is selected.", "o|33|v7|v8|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|dp|ds|GH|uv|ux|uz|v1|v3|v6|u5|v9", "o|3L|qP|1V|2p|uu|3M", "o|3L|pR|1V|2p|uw|3M", "o|3L|qS|1V|2p|v0|3M", "o|3L|qV|1V|2p|v2|3M", "Whether the input is rendered inline (as a dropdown).", "o|3Q|3h|1V|2p|vF", "numChoices", "The number of choices available in the input.", "o|3Q|vH|1p|2p|vI", "choiceTexts", "The text contents of all choices in displayed order.", "o|6v|vK|1T|3M|vL|36|Jt", "choiceMaths", "The math expressions of all choices in displayed order.", "o|6v|vN|1X|3M|vO|36|75", "Whether the input's selection has been changed from its initial state.", "o|3Q|eT|1V|2p|vQ", "selectedIndices", "Indices (1-based) of the currently selected choices.", "o|6v|vS|1p|3M|vT|36|IR", "selectedValues", "Text values of the currently selected choices.", "o|rd|vV|3M|vW|36|ri", "The number of feedback messages produced by selected choices.", "o|3Q|rq|1p|2p|vY", "Feedback messages produced by selected choices.", "o|6v|rt|9F|3M|va|36|rw", "selectedIndex", "The 1-based index of the first currently selected choice.", "o|3Q|vc|1p|2p|vd", "selectedValue", "The text value of the first currently selected choice.", "o|ry|vf|2p|vg", "The text values of the currently selected choices.", "o|rd|2l|3M|vi|36|ri", "valueToRecordOnSubmit", "Indices of the currently selected choices (recorded when the answer is submitted).", "o|6v|vk|1p|3M|vl|36|IR", "a|3N|3O|3P|eJ|Hd|vB|vC|vD|vE|3T|3U|3V|3W|3Z|Hk|eP|tn|vG|vJ|vM|vP|vR|vU|vX|vZ|vb|ve|vh|vj|vm", "A multiple-choice input, allowing selection from a list of choices", "o|F|1n|ut|df|dh|vA|vn|3M|2p|2p|1n|vo|3h", "Fraction of credit (0 to 1) granted when this choice is selected.", "o|33|sC|vq|5Q|1p", "Codes that select reusable feedback messages when this choice is selected.", "o|33|sH|vs|54|1U", "Custom feedback text shown when this choice is selected.", "o|33|sK|vu||1T", "preSelect", "Whether this choice is pre-selected on initial render.", "o|2m|vw|vx|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|vr|vt|vv|vy", "o|3L|sC|1p|2p|vq|3M", "o|3L|sH|1U|2p|vs|3M", "o|3L|sK|1T|2p|vu|3M", "The choice's content as a text string.", "o|3Q|1T|1T|2p|w3", "The choice's content interpreted as a math expression.", "o|3Q|1X|1X|2p|w5", "selected", "Whether this choice is currently selected.", "o|3Q|w7|1V|2p|w8", "submitted", "Whether this choice was selected at the most recent submission.", "o|3Q|wA|1V|2p|wB", "Whether this choice is disabled (cannot be selected).", "o|3Q|2u|1V|2p|wD", "feedbacktext", "Feedback messages shown when this choice is selected.", "o|3Q|rt|wF|2p|wG", "a|3N|3O|3P|w0|w1|w2|3T|3V|3W|3Z|w4|w6|w9|wC|wE|wH", "A single choice within a `<choiceInput>` or an `<answer>`.", "o|F|1o|9U|9V|3l|vz|wI|3M|3M|2p|1o|wJ|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|L|M|N|Q|w|x|y|1J|1K|1L|1M|1N|1R|1S|1d|1f|1h|1i|1k|1o|1r|1s|2K|2Q|2W|2Y|I|J|R|S|T|U|V|W|X|Y|Z|1V|1W|2R|2S|2T|1m", "111111111111111111111111102022210112222122222111211122222222222222222222222222222111111111021212", "renderAsMath", "Whether to render the number using math typography.", "o|2m|wN|wO|2p|2s|1V", "convertBoolean", "Whether to convert boolean inputs to 1/0 instead of NaN.", "o|2m|wQ|wR|2p|2s|1V", "valueOnNaN", "Numeric value to use when the input cannot be parsed.", "NaN", "o|33|wT|wU|wV|1p", "Whether the number can be dragged on a graph.", "o|2m|5L|wX|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j|wP|wS|wW|wY|5R|5X|63", "o|3L|wN|1V|2p|wO|3M", "o|3L|5L|1V|2p|wX|3M", "The numeric value.", "o|3Q|3a|1p|2p|wc", "The number rendered as plain text.", "o|3Q|1T|1T|2p|we", "The number's value as a math expression.", "o|3Q|1X|1X|2p|wg", "The number rendered as LaTeX.", "o|3Q|2V|2V|2p|wi", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wd|wf|wh|wj", "A numeric floating point value", "o|F|1p|wL|wM|3l|wZ|wk|3M|3M|2p|1p|wl|3h", "The integer value.", "o|3Q|3a|1q|2p|wn", "a|3N|3O|3P|wa|wb|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|wf|wh|wj|wo", "An integer value", "o|F|1q|wL|wM|3l|wZ|wp|3M|3M|2p|1q|wq|3h", "a|I|1z|J|dd|2f|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y|9C|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|z|1L|1M|1T|1U|1V|1W|1a|1o|1p|1q|1v|25|26|27|28|2B|2C|2D|2R|2S|2T|2V|1N|1R|1S|1k|O|P|2E|2F|2G|1m|1l|8y|8z", "020001111111111111111111111122211111022211111111111111122122212222121212212111111122200111222222222122022222012222211220212220010000000", "xMin", "Minimum value displayed on the x axis.", "n|-A", "o|33|wu|wv|ww|1p", "xMax", "Maximum value displayed on the x axis.", "o|33|wy|wz|Nn|1p", "yMin", "Minimum value displayed on the y axis.", "o|33|x1|x2|ww|1p", "yMax", "Maximum value displayed on the y axis.", "o|33|x4|x5|Nn|1p", "Explicit width of the graph (overrides size).", "o|2h|bx|x7|bz", "Named size preset for the graph.", "medium", "tiny", "small", "large", "a|xB|xC|xA|xD|43", "About 1/12 the full width.", "o|3s|xB|xF", "About 30% of the full width.", "o|3s|xC|xH", "About half the full width.", "o|3s|xA|xJ", "About 70% of the full width.", "o|3s|xD|xL", "The full available width.", "o|3s|43|xN", "a|xG|xI|xK|xM|xO", "o|Bi|uB|x9|xA|xE|xP|3y", "aspectRatio", "Aspect ratio (width / height) for the graph.", "o|33|xR|xS|36|1p", "displayMode", "How to size the graph.", "a|AT|3h", "Display as a block element on its own line.", "o|3s|AT|xX", "Render inline with surrounding text.", "o|3s|3h|xZ", "a|xY|xa", "o|Bi|xU|xV|AT|xW|xb|3y", "horizontalAlign", "Horizontal alignment of the graph within its container.", "a|5b|5h|5i", "Center the graph horizontally.", "o|3s|5b|xg", "Align the graph to the left edge.", "o|3s|5h|xi", "Align the graph to the right edge.", "o|3s|5i|xk", "a|xh|xj|xl", "o|Bi|xd|xe|5b|xf|xm|3y", "identicalAxisScales", "Whether to force the x and y axis scales to be equal.", "o|2m|xo|xp|2p|2s|1V", "displayXAxis", "Whether to display the x axis.", "o|2m|xr|xs|3M|2s|1V", "displayYAxis", "Whether to display the y axis.", "o|2m|xu|xv|3M|2s|1V", "Whether to render interactive zoom/pan controls.", "all", "slidersOnly", "inputsOnly", "a|xy|xz|y0|42|2q|2r", "Render both sliders and input boxes.", "o|3s|xy|y2", "Render only slider controls.", "o|3s|xz|y4", "Render only input-box controls.", "o|3s|y0|y6", "Render no interactive controls.", "o|3s|42|y8", "a|y3|y5|y7|y9", "o|Bi|ST|xx|42|y1|yA|3y", "controlsPosition", "Position of the graph controls.", "a|5g|5h|5i|9", "Place controls below the graph.", "o|3s|5g|yF", "Place controls to the left of the graph.", "o|3s|5h|yH", "Place controls to the right of the graph.", "o|3s|5i|yJ", "Place controls above the graph.", "o|3s|9|yL", "a|yG|yI|yK|yM", "o|Bi|yC|yD|5h|yE|yN|3y", "displayXAxisTicks", "Whether to display tick marks on the x axis.", "o|2m|yP|yQ|3M|2s|1V", "displayYAxisTicks", "Whether to display tick marks on the y axis.", "o|2m|yS|yT|3M|2s|1V", "displayXAxisTickLabels", "Whether to display labels on x-axis ticks.", "o|2m|yV|yW|3M|2s|1V", "displayYAxisTickLabels", "Whether to display labels on y-axis ticks.", "o|2m|yY|yZ|3M|2s|1V", "xLabelPosition", "Position of the x-axis label.", "a|5i|5h", "Place the x-axis label at the right end of the axis.", "o|3s|5i|ye", "Place the x-axis label at the left end of the axis.", "o|3s|5h|yg", "a|yf|yh", "o|Bi|yb|yc|5i|yd|yi|3y", "xTickScaleFactor", "Scale factor applied to x-axis tick spacing.", "o|33|yk|yl||1X", "yLabelPosition", "Position of the y-axis label.", "a|9|5g", "Place the y-axis label at the top of the axis.", "o|3s|9|yq", "Place the y-axis label at the bottom of the axis.", "o|3s|5g|ys", "a|yr|yt", "o|Bi|yn|yo|9|yp|yu|3y", "yLabelAlignment", "Alignment of the y-axis label.", "Align the y-axis label to the left of the axis.", "o|3s|5h|yy", "Align the y-axis label to the right of the axis.", "o|3s|5i|z0", "a|yz|z1", "o|Bi|yw|yx|5h|dj|z2|3y", "yTickScaleFactor", "Scale factor applied to y-axis tick spacing.", "o|33|z4|z5||1X", "showNavigation", "Whether to show navigation controls (pan/zoom).", "o|2m|z7|z8|3M|2s|1V", "fixAxes", "Whether the axis limits are locked (preventing zoom/pan).", "o|2m|zA|zB|2p|2s|1V", "grid", "Grid density to render on the graph (off, minor, medium, or major).", "o|2h|zD|zE|1T", "showBorder", "Whether to render a border around the graph.", "o|2m|zG|zH|3M|2s|1V", "hideOffGraphIndicators", "Whether to suppress indicators for objects outside the visible region.", "o|2m|zJ|zK|2p|2s|1V", "decorative", "Whether the graph is purely decorative (excluded from a11y tree).", "o|2m|zM|zN|2p|2s|1V", "renderer", "Which renderer to use for the graph.", "doenet", "prefigure", "a|zR|zS", "Render using the built-in Doenet graph renderer.", "o|3s|zR|zU", "Render using the PreFigure SVG-based renderer.", "o|3s|zS|zW", "a|zV|zX", "o|Bi|zP|zQ|zR|zT|zY|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|wx|x0|x3|x6|x8|xQ|xT|xc|xn|xq|xt|xw|yB|yO|yR|yU|yX|ya|yj|ym|yv|z3|z6|z9|zC|zF|H8|4Y|4c|4g|4j|zI|zL|zO|zZ", "o|3L|xU|1T|2p|xV|3M", "o|3L|xd|1T|2p|xe|3M", "o|3L|xo|1V|2p|xp|3M", "o|3L|xr|1V|2p|xs|3M", "o|3L|xu|1V|2p|xv|3M", "o|3L|ST|1T|2p|xx|3M", "o|3L|yC|1T|2p|yD|3M", "o|3L|yP|1V|2p|yQ|3M", "o|3L|yS|1V|2p|yT|3M", "o|3L|yb|1T|2p|yc|3M", "o|3L|yk|1X|2p|yl|3M", "o|3L|yn|1T|2p|yo|3M", "o|3L|yw|1T|2p|yx|3M", "o|3L|z4|1X|2p|z5|3M", "o|3L|z7|1V|2p|z8|3M", "o|3L|zG|1V|2p|zH|3M", "o|3L|zJ|1V|2p|zK|3M", "o|3L|zM|1V|2p|zN|3M", "o|3L|zP|1T|2p|zQ|3M", "A short accessibility description of the graph.", "o|3Q|dd|1T|2p|zu", "Whether the visible axes range is locked.", "o|3Q|zA|1V|2p|zw", "The x-axis label text.", "o|3Q|I|2S|2p|zy", "The y-axis label text.", "o|3Q|J|2S|2p|100", "hasAuthorAnnotations", "Whether the graph contains any author-provided `<annotations>` child.", "o|3Q|102|1V|2p|103", "prefigureXML", "The Prefigure-formatted XML rendered for this graph, or null if not using the Prefigure renderer.", "o|3Q|105|1T|2p|106", "The size of the graph.", "o|3Q|uB|1T|2p|108", "The width of the graph.", "o|3Q|bx|bz|2p|10A", "The aspect ratio (width / height) of the graph.", "o|3Q|xR|1p|2p|10C", "effectiveRenderer", "The renderer actually used after resolving fallbacks.", "o|3Q|10E|1T|2p|10F", "Whether x-axis tick labels are displayed.", "o|3Q|yV|1V|2p|10H", "Whether y-axis tick labels are displayed.", "o|3Q|yY|1V|2p|10J", "Minimum x value displayed.", "o|3Q|wu|1p|2p|10L", "Maximum x value displayed.", "o|3Q|wy|1p|2p|10N", "Minimum y value displayed.", "o|3Q|x1|1p|2p|10P", "Maximum y value displayed.", "o|3Q|x4|1p|2p|10R", "xScale", "Scale used along the x axis (xMax − xMin).", "o|3Q|10T|1p|2p|10U", "yScale", "Scale used along the y axis (yMax − yMin).", "o|3Q|10W|1p|2p|10X", "Grid line spacing on the graph.", "o|ry|zD|2p|10Z", "a|3N|3O|3P|zb|zc|zd|ze|zf|zg|zh|zi|zj|zk|zl|zm|zn|zo|zp|zq|zr|zs|zt|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|zv|zx|zz|101|104|107|109|10B|10D|10G|10I|10K|10M|10O|10Q|10S|10V|10Y|10a", "A 2D coordinate-axis graph", "o|F|8y|ws|wt|9X|za|10b|3M|2p|2p|8y|10c|AT", "a|90|1z", "A container of annotation children for screen reader navigation of a graph", "o|F|8z|10e|BN|Ao|3I|Aa|3M|2p|2p|8z|10f|Az", "Reference to the component this annotation is attached to.", "o|2h|1c|10h|3D", "The annotation text read by screen readers.", "o|33|1T|10j|AZ|1T", "speech", "More detailed spoken text used by screen readers; used if expert mode is activated or extra details are requested.", "o|33|10l|10m|AZ|1T", "sonify", "Whether to play a tone when this annotation is focused and it references a function.", "o|2m|10o|10p|2p|2s|1V", "circular", "Whether navigation through this annotation's children wraps around.", "o|2m|10r|10s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|10i|10k|10n|10q|10t", "o|3L|1T|1T|2p|10j|3M", "o|3L|10l|1T|2p|10m|3M", "o|3L|10o|1V|2p|10p|3M", "o|3L|10r|1V|2p|10s|3M", "a|3N|3O|3P|10v|10w|10x|10y|3T|3U|3V|3W|3Z", "An annotation for screen reader navigation of a graph", "o|F|90|10e|BN|Ao|10u|10z|3M|2p|2p|90|110|Az", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|G7|GA|GD|GH|GK|Gf|Gh|Gl|Go|Gq|Gt|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "The symbolic formula of the function.", "o|3Q|I9|1X|2p|113", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|Hs|Hu|Hy|I0|I2|I4|I8|114|ID|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A mathematical function, defined by formula or interpolation", "o|F|1r|Fo|Fp|3l|112|115|3M|3M|2p|1r|116|3h", "a|w|x|y|1r|1s|1z|I|J|2S", "111012110", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Fw|Fy|G1|G4|GD|GH|GK|Gf|Gh|Gw|H0|H4|H7|H8|4Y|4c|4g|4j|HB|HQ|HT", "Number of output values.", "o|3Q|G8|1q|2p|11B", "The piecewise formula of the function.", "o|3Q|I9|1X|2p|11D", "The piecewise function rendered as a LaTeX string.", "o|3Q|2V|2V|2p|11F", "a|3N|3O|3P|Ha|Hb|Hc|Hd|He|Hf|Hg|3T|3U|3V|3W|3Z|Hk|6N|6Q|6T|Hn|Hq|6X|6Y|6Z|6a|6b|JK|11C|I0|I2|I4|I8|11E|11G|IF|II|IN|IS|IV|IZ|Ic|If|Ih|Ik|In|Iq|It|Iw|Iy|J1|J4|J6", "A function defined piecewise from sub-functions on intervals", "o|F|1s|118|119|3l|11A|11H|3M|2p|2p|1s|11I|3h", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|51|55|58|5B|5E|5K|5N|5R|5X|63", "o|3Q|3a|1t|2p|6e", "Whether this math component renders intervals as intervals (always true for `<interval>`).", "o|3Q|4t|1V|2p|11M", "a|3N|3O|3P|66|67|68|69|6A|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|11L|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|11N|7S|7V|7Y|7b", "A math expression treated as an interval of real numbers", "o|F|1t|3j|3k|3l|11K|11O|3M|3M|2p|1t|11P|3h", "option", "selectForVariants", "Variant indices for which this option is selected.", "textListFromString", "o|33|11S|11T|54|11U", "selectWeight", "Relative weight when randomly selecting an option.", "o|33|11W|11X|36|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11V|11Y", "o|3L|11S|11U|2p|11T|3M", "o|3L|11W|1p|2p|11X|3M", "a|3N|3O|3P|11a|11b|3T|3U|3V|3W|3Z", "A single option within a `<select>` block", "o|F|11R|9U|9V|Ao|11Z|11c|2p|3M|2p|11R|11d|Az", "The kind of values in the sequence.", "letters", "a|1p|1X|11g", "A sequence of numeric values.", "o|3s|1p|11i", "A sequence of math expressions (allows symbolic from/to/step).", "o|3s|1X|11k", "A sequence of letters (single-letter or multi-letter labels).", "o|3s|11g|11m", "a|11j|11l|11n", "o|HC|2g|11f|11h|11o|3y", "The first value in the sequence.", "_componentWithSelectableType", "o|2h|hM|11q|11r", "The last value in the sequence. Used together with from to determine length when length is not specified.", "o|2h|hX|11t|11r", "step", "The increment between successive values in the sequence.", "o|2h|11v|11w|1X", "The number of values in the sequence.", "o|2h|Qh|11y|1q", "exclude", "Values to exclude from the sequence.", "_componentListWithSelectableType", "o|2h|120|121|122", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB", "a|3N|3O|3P|3Z", "Generates a sequence of numbers, math expressions, or letters", "o|F|1u|54|AZ|g0|124|125|3M|2p|3M|1u|126|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1O|1T|1U|1X|1Y|1Z|1a|1e|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2U|2V|2X|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|1L|1M|1V|1W|1o|2R|2S|2T", "2222222222222222222222212022222201222222222222112221211222222222222222222202", "Type of value the slider produces.", "a|1p|1T", "Slider produces numeric values between `from` and `to`.", "o|3s|1p|12C", "Slider produces text values, one per child of the slider.", "o|3s|1T|12E", "a|12D|12F", "o|3o|2g|12A|3M|1p|12B|12G|3y", "Display width of the slider.", "n|4q", "o|uD|12J|3M", "o|33|bx|12I|12K|bz", "Display height of the slider.", "n|1c", "o|uD|12N|3M", "o|33|k5|12M|12O|bz", "initialValue", "Initial value of the slider before any user interaction.", "o|33|12Q|12R||11r", "showControls", "Whether to render play/pause controls alongside the slider.", "o|2m|12T|12U|2p|2s|1V", "showTicks", "Whether to render tick marks on the slider.", "o|2m|12W|12X|3M|2s|1V", "rotateTickLabels", "Whether to rotate the tick labels.", "o|2m|12Z|12a|2p|2s|1V", "showValue", "Whether to display the current value next to the slider.", "o|2m|12c|12d|3M|2s|1V", "a|3|2f|3m|2k|2g", "Minimum value of the slider's range.", "o|12f|hM|12g|3M|5Q|1p", "Maximum value of the slider's range.", "o|12f|hX|12i|3M|Nn|1p", "Increment between successive slider positions.", "o|12f|11v|12k|3M|36|1p", "o|2h|e9|eA|11r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|12H|12L|12P|12S|12V|12Y|12b|12e|12h|12j|12l|GH|H8|4Y|4c|4g|4j|12m", "o|3L|bx|bz|2p|12I|3M", "o|3L|k5|bz|2p|12M|3M", "o|3L|12T|1V|2p|12U|3M", "o|3L|12W|1V|2p|12X|3M", "o|3L|12Z|1V|2p|12a|3M", "o|3L|12c|1V|2p|12d|3M", "o|65|hM|1p|2p|12g|3M|3M", "o|65|hX|1p|2p|12i|3M|3M", "o|65|11v|1p|2p|12k|3M|3M", "items", "The values the slider can take.", "o|ry|12x|2p|12y", "numItems", "The total number of values.", "o|3Q|130|1q|2p|131", "The current value of the slider.", "o|ry|3a|2p|133", "a|3N|3O|3P|12o|12p|12q|12r|12s|12t|12u|12v|12w|Hd|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|12z|132|134", "An interactive slider input", "o|F|91|128|129|Ao|12n|135|3M|2p|2p|91|136|Az", "a|1v|1z|93|94|95", "02000", "Display width of the spreadsheet.", "o|uD|12N|2p", "o|33|bx|13A|13B|bz", "minNumRows", "Minimum number of rows displayed.", "n|4", "o|33|13D|13E|13F|1p", "minNumColumns", "Minimum number of columns displayed.", "o|33|13H|13I|13F|1p", "Display height of the spreadsheet.", "o|2h|k5|13K|bz", "columnHeaders", "Header labels for the columns.", "o|2m|13M|13N|3M|2s|1V", "rowHeaders", "Header labels for the rows.", "o|2m|13P|13Q|3M|2s|1V", "fixedRowsTop", "Number of top rows fixed in place when scrolling.", "o|33|13S|13T|5Q|1q", "fixedColumnsLeft", "Number of left columns fixed in place when scrolling.", "o|33|13V|13W|5Q|1q", "hiddenColumns", "Indices of columns to hide.", "o|33|13Y|13Z|54|1a", "hiddenRows", "Indices of rows to hide.", "o|33|13b|13c|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|13C|13G|13J|13L|13O|13R|13U|13X|13a|13d", "o|3L|bx|bz|2p|13A|3M", "o|3L|13D|1p|2p|13E|3M", "o|3L|13H|1p|2p|13I|3M", "o|3L|13M|1V|2p|13N|3M", "o|3L|13P|1V|2p|13Q|3M", "o|3L|13S|1q|2p|13T|3M", "o|3L|13V|1q|2p|13W|3M", "o|3L|13Y|1a|2p|13Z|3M", "o|3L|13b|1a|2p|13c|3M", "The number of rows.", "o|3Q|7A|1p|2p|13o", "The number of columns.", "o|3Q|7D|1p|2p|13q", "o|3Q|k5|bz|2p|13K", "cells", "The raw text contents of all cells.", "o|6x|2p|95", "o|6x|2p|93", "a|13v|13w", "o|6v|13t|1v|3M|13u|4X|13x", "The cells grouped by row.", "o|6v|7K|1v|3M|13z|4X|13x", "The cells grouped by column.", "o|6x|2p|94", "a|13v|142", "o|6v|7N|1v|3M|141|4X|143", "evaluatedCells", "The evaluated values of all cells.", "o|6v|145|1v|3M|146|4X|13x", "evaluatedRows", "The evaluated cell values grouped by row.", "o|6v|148|1v|3M|149|4X|13x", "evaluatedColumns", "The evaluated cell values grouped by column.", "o|6v|14B|1v|3M|14C|4X|143", "pointsInCells", "Cells whose values are interpreted as points.", "a|X6|IK", "o|6v|14E|1d|3M|14F|4X|14G", "pointsInRows", "Cell-derived points grouped by row.", "o|6v|14I|1d|3M|14J|4X|14G", "pointsInColumns", "Cell-derived points grouped by column.", "o|6v|14L|1d|3M|14M|4X|14G", "a|3N|3O|3P|13f|13g|13h|13i|13j|13k|13l|13m|13n|3T|3U|3V|3W|3Z|13p|13r|13s|13y|140|144|147|14A|14D|14H|14K|14N", "An interactive spreadsheet", "o|F|92|138|139|9X|13e|14O|3M|2p|2p|92|14P|AT", "a|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2X|2Y|G|I|J|89|8A|8B|K|8C|O|P|R|S|T|U|V|W|X|Y|Z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|8Z|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|8j|8k|8l|8m|1V|1W|1b|1c|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1j|8x|1l|1m|1n|8y|8z|90|91|92|93|94|95|96|97|98|1w|1x|99|1y|20|9A|22|23|9B|9C|9D|9E|9F|2E|2F|2G|2H|2I|9G|9H|2J|9I|2L|2M|2N|9J|2P|9K|9L|9M|9N|2R|9O|2S|2T|9P|9Q|9R|9S|9T", "1111111111111111111111111111111111111111101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "rowNum", "Row number where this cell is placed (1-based).", "o|33|14T|14U||1T", "colNum", "Column number where this cell is placed (1-based).", "o|33|14W|14X||1T", "colSpan", "Number of columns this cell spans.", "o|33|14Z|14a|36|1q", "halign", "Horizontal alignment for the cell's content (left, center, or right).", "o|33|14c|14d|5h|1T", "Border style for the bottom edge of the cell.", "o|33|5g|14f|42|1T", "Border style for the right edge of the cell.", "o|33|5i|14h|42|1T", "Initial text content of the cell.", "o|33|Zj|14j|AZ|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|14V|14Y|14b|14e|14g|14i|14k", "o|3L|14T|1T|2p|14U|3M", "o|3L|14W|1T|2p|14X|3M", "o|3L|14Z|1q|2p|14a|3M", "o|3L|Zj|1T|2p|14j|3M", "Horizontal alignment of the cell's content (left, center, or right).", "o|3Q|14c|1T|2p|14q", "o|3Q|5g|1T|2p|14f", "o|3Q|5i|1T|2p|14h", "inHeader", "Whether this cell is in a header row of the table.", "o|3Q|14u|1V|2p|14v", "The cell's content as a text string.", "o|3Q|1T|1T|2p|14x", "The cell's content interpreted as a math expression.", "o|3Q|1X|1X|2p|14z", "The cell's content interpreted as a number.", "o|3Q|1p|1p|2p|151", "a|3N|3O|3P|14m|14n|14o|14p|3T|3U|3V|3W|3Z|14r|14s|14t|14w|14y|150|152", "A single cell within a tabular layout or spreadsheet", "o|F|1v|14R|14S|Ao|14l|153|3M|3M|2p|1v|154|Az", "displayContext", "a|3|4|5|6|7|8|9|A|B|C|D|E|156", "a|1v|1z", "Row number where this row is placed (1-based).", "o|33|14T|159||1T", "header", "Whether this row is a header row.", "o|2m|15B|15C|2p|2s|1V", "Default horizontal alignment for cells in this row.", "o|33|14c|15E|5h|1T", "Default vertical alignment for cells in this row.", "o|33|c8|15G|cA|1T", "Border style for the left edge of this row.", "o|33|5h|15I|42|1T", "Border style for the bottom edge of this row.", "o|33|5g|15K|42|1T", "o|2h|4w|4x|1U", "o|2h|52|53|3D", "o|Ap|56|57|2s|1V", "o|Ap|59|5A|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15A|15D|15F|15H|15J|15L|15M|15N|15O|15P", "o|3L|14T|1T|2p|159|3M", "o|3L|15B|1V|2p|15C|3M", "o|3Q|14c|1T|2p|15E", "o|3Q|c8|1T|2p|15G", "Border style for the left edge of the row.", "o|3Q|5h|1T|2p|15V", "Border style for the bottom edge of the row.", "o|3Q|5g|1T|2p|15X", "a|3N|3O|3P|15R|15S|3T|3U|3V|3W|3Z|15T|15U|15W|15Y", "row_table", "A row within a tabular layout", "in a table", "o|157|93|158|BN|Ao|15Q|15Z|3M|2p|2p|15a|15b|Az|15c", "Column number where this column is placed (1-based).", "o|33|14W|15e||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15f|15M|15N|15O|15P", "o|3L|14W|1T|2p|15e|3M", "a|3N|3O|3P|15h|3T|3U|3V|3W|3Z", "column_table", "A column of cells within a `<spreadsheet>`", "o|157|94|158|BN|Ao|15g|15i|3M|2p|2p|15j|15k|Az|15c", "Row number where this block starts (1-based; can be a letter or number).", "o|33|14T|15m||1T", "Column number where this block starts (1-based; can be a letter or number).", "o|33|14W|15o||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15n|15p", "o|3L|14T|1T|2p|15m|3M", "o|3L|14W|1T|2p|15o|3M", "a|3N|3O|3P|15r|15s|3T|3U|3V|3W|3Z", "Container for grouping `<cell>`, `<row>`, and `<column>` children inside a `<spreadsheet>`", "o|F|95|138|139|Ao|15q|15t|3M|2p|2p|95|15u|Az", "a|93|1z", "Display width of the tabular layout.", "o|33|bx|15x|13B|bz", "Display height of the tabular layout.", "o|33|k5|15z||bz", "Default horizontal alignment for cells.", "justify", "a|5h|5b|5i|162", "Left-align cell content.", "o|3s|5h|164", "Center cell content horizontally.", "o|3s|5b|166", "Right-align cell content.", "o|3s|5i|168", "Justify cell content across the full cell width.", "o|3s|162|16A", "a|165|167|169|16B", "o|Bi|14c|161|5h|163|16C|3y", "Default vertical alignment for cells.", "Align cell content to the top.", "o|3s|9|16F", "Center cell content vertically.", "o|3s|cA|16H", "Align cell content to the bottom.", "o|3s|5g|16J", "a|16G|16I|16K", "o|Bi|c8|16E|cA|cB|16L|3y", "Border style for the top edge of the layout.", "minor", "major", "a|42|16O|xA|16P", "Do not render a border.", "o|3s|42|16R", "Render a thin border line.", "o|3s|16O|16T", "Render a medium-weight border line.", "o|3s|xA|16V", "Render a thick border line.", "o|3s|16P|16X", "a|16S|16U|16W|16Y", "o|Bi|9|16N|42|16Q|16Z|3y", "Border style for the left edge of the layout.", "o|Bi|5h|16b|42|16Q|16Z|3y", "Border style for the bottom edge of the layout.", "o|Bi|5g|16d|42|16Q|16Z|3y", "Border style for the right edge of the layout.", "o|Bi|5i|16f|42|16Q|16Z|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|15y|160|16D|16M|16a|16c|16e|16g", "o|3L|bx|bz|2p|15x|3M", "o|3L|k5|bz|2p|15z|3M", "o|3L|14c|1T|2p|161|3M", "o|3L|c8|1T|2p|16E|3M", "o|3L|9|1T|2p|16N|3M", "o|3L|5h|1T|2p|16b|3M", "o|3L|5g|1T|2p|16d|3M", "o|3L|5i|1T|2p|16f|3M", "a|3N|3O|3P|16i|16j|16k|16l|16m|16n|16o|16p|3T|3U|3V|3W|3Z", "A simple tabular layout of cells", "o|F|96|15w|BN|9X|16h|16q|3M|2p|2p|96|16r|AT", "a|G|1z|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9I|9J|9N|9Q|9S|9T", "021111111111111111111111111111111111111111111111111111111111111111221111111112121222212121221111111111122222122212222211121111212221122111112221111111111111111111111111111111111111111111111111111", "suppressTableNameInTitle", "Whether to omit the auto-generated table name from the title.", "o|2m|16v|16w|2p|2s|1V", "Whether to display an auto-generated table number.", "o|2m|1p|16y|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|16x|16z", "tableEnumeration", "Auto-generated number for this table.", "o|3Q|171|1T|2p|172", "tableName", "The full display name of the table (e.g., 'Table 2').", "o|3Q|174|1T|2p|175", "The table's title.", "o|3Q|G|1T|2p|177", "a|3N|3O|3P|3T|3U|3V|3W|3Z|173|176|178", "A container element for a `<tabular>`", "o|F|97|16t|16u|9X|170|179|3M|3M|2p|97|17A|AT", "a|1z|9I|G|H|I|J|K|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|1I|1J|1K|1L|1M|1N|1O|1P|1Q|1R|1S|1T|1U|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|1g|1h|1i|1j|1k|1l|1m|1n|1o|1p|1q|1r|1s|1t|1u|1v|1w|1x|1y|20|21|22|23|24|25|26|27|28|29|2A|2B|2C|2D|2E|2F|2G|2H|2I|2J|2K|2L|2M|2N|2O|2P|2Q|2R|2S|2T|2U|2V|2W|2X|2Y|89|8A|8B|8C|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|8a|8b|8c|8d|8e|8f|8g|8h|8i|8j|8k|8m|8y|92|96|97|98|9C|9D|9E|9F|9J|9N|9Q|9S|9T", "201111111111111111111111111111111111111111111111111111111111111111122111111111212122221212122111111111112222212221222221112111121222112211111222111111111111111111111111111111111111111111111111111", "suppressFigureNameInCaption", "Whether to omit the auto-generated figure name from the caption.", "o|2m|17E|17F|2p|2s|1V", "Whether to display an auto-generated figure number.", "o|2m|1p|17H|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|17G|17I", "figureEnumeration", "Auto-generated number for this figure.", "o|3Q|17K|1T|2p|17L", "figureName", "The full display name of the figure (e.g., 'Figure 3').", "o|3Q|17N|1T|2p|17O", "The figure's caption text.", "o|3Q|9I|1T|2p|17Q", "a|3N|3O|3P|3T|3U|3V|3W|3Z|17M|17P|17R", "A figure container holding graphical content with a caption", "o|F|98|17C|17D|9X|17J|17S|3M|3M|2p|98|17T|AT", "Whether the generated repeats should be treated as responses for assessment.", "o|g3|38|17V", "valueName", "Name to bind the current item to inside the repeat template.", "o|33|17X|17Y||1T", "indexName", "Name to bind the current 1-based index to inside the repeat template.", "o|33|17a|17b||1T", "The collection of items to iterate over when generating repeats.", "o|2h|7f|17d|23", "Component type used to wrap each item in the source.", "o|2h|2g|17f|1T", "a|2j|2t|2w|2z|32|37|17W|3E|3H|17Z|17c|17e|17g|gB", "a|3N|3O|3Z", "Repeats template content for each item in a source", "o|F|1w|9U|9V|g0|17h|17i|3M|3M|3M|1w|17j|Az", "a|2j|2t|2w|2z|32|37|17W|3E|3H|11p|11s|11u|11x|11z|123|17Z|17c|gB", "Repeats template content for each value in an arithmetic sequence", "o|F|1x|9U|9V|g0|17l|17i|3M|3M|3M|1x|17m|Az", "dx", "Horizontal spacing between pegs.", "o|33|17o|17p|36|1p", "dy", "Vertical spacing between pegs.", "o|33|17r|17s|36|1p", "xoffset", "Horizontal offset of the peg grid origin.", "o|33|17u|17v|5Q|1p", "yoffset", "Vertical offset of the peg grid origin.", "o|33|17x|17y|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|17q|17t|17w|17z", "o|3L|17o|1p|2p|17p|3M", "o|3L|17r|1p|2p|17s|3M", "o|3L|17u|1p|2p|17v|3M", "o|3L|17x|1p|2p|17y|3M", "a|3N|3O|3P|Hd|QD|7s|QE|181|182|183|184|3T|3U|3V|3W|3Z|Hk", "Renders a grid of pegs on a graph", "o|F|99|Om|On|Op|180|185|3M|2p|2p|99|186|Az", "_constraint", "a|188|2d", "Horizontal grid spacing.", "o|33|17o|18A|36|1p", "Vertical grid spacing.", "o|33|17r|18C|36|1p", "dz", "Depth-wise grid spacing.", "o|33|18E|18F|36|1p", "Horizontal offset of the grid origin.", "o|33|17u|18H|5Q|1p", "Vertical offset of the grid origin.", "o|33|17x|18J|5Q|1p", "zoffset", "Depth-wise offset of the grid origin.", "o|33|18L|18M|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N", "o|3L|17o|1p|2p|18A|3M", "o|3L|17r|1p|2p|18C|3M", "o|3L|18E|1p|2p|18F|3M", "o|3L|17u|1p|2p|18H|3M", "o|3L|17x|1p|2p|18J|3M", "o|3L|18L|1p|2p|18M|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie on a grid", "o|F|RJ|54|AZ|189|18O|18V|2p|2p|2p|RJ|18W|Az", "buffer", "Distance from the graph edge inside which the position is still considered constrained.", "n|0.A", "o|33|18Y|18Z|18a|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18b", "o|3L|18Y|1p|2p|18Z|3M", "a|3N|3O|3P|18d|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to lie within a graph's bounds", "o|F|RK|54|AZ|189|18c|18e|2p|2p|2p|RK|18f|Az", "xthreshold", "Horizontal distance within which the position attracts to a grid line.", "n|0.2", "o|33|18h|18i|18j|1p", "ythreshold", "Vertical distance within which the position attracts to a grid line.", "o|33|18l|18m|18j|1p", "zthreshold", "Depth-wise distance within which the position attracts to a grid line.", "o|33|18o|18p|18j|1p", "includeGridlines", "Whether to attract to entire grid lines (in addition to grid intersection points).", "o|2m|18r|18s|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|18B|18D|18G|18I|18K|18N|18k|18n|18q|18t", "o|3L|18h|1p|2p|18i|3M", "o|3L|18l|1p|2p|18m|3M", "o|3L|18o|1p|2p|18p|3M", "o|3L|18r|1V|2p|18s|3M", "a|3N|3O|3P|18P|18Q|18R|18S|18T|18U|18v|18w|18x|18y|3T|3U|3V|3W|3Z", "Attracts a graphical component's position to grid lines when nearby", "o|F|RL|54|AZ|189|18u|18z|2p|2p|2p|RL|190|Az", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|1z|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "222222222222222222222222221111222221211111111111112222221222222222122221111121222", "relativeToGraphScales", "Whether the constraint is interpreted relative to the enclosing graph's scales.", "o|2m|194|195|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|196", "o|3L|194|1V|2p|195|3M", "a|3N|3O|3P|198|3T|3U|3V|3W|3Z", "Constrains a graphical component's position to be within another component or components", "o|F|RM|192|193|189|197|199|2p|2p|2p|RM|19A|Az", "Whether the attraction threshold is interpreted relative to the enclosing graph's scales rather than absolute coordinates.", "o|2m|194|19C|2p|2s|1V", "Distance within which the position attracts to a target.", "o|2h|E6|19E|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19D|19F", "o|3L|194|1V|2p|19C|3M", "o|3Q|E6|1p|2p|19E", "a|3N|3O|3P|19H|3T|3U|3V|3W|3Z|19I", "Attracts a graphical component's position to another component when nearby", "o|F|RN|192|193|189|19G|19J|2p|2p|2p|RN|19K|Az", "a|RJ|RK|RL|RM|RN|RO|RP|RQ|1z", "111111112", "A constraint that is satisfied if any of its child constraints are satisfied", "o|F|RO|19M|19N|189|3I|Aa|2p|2p|2p|RO|19O|Az", "Distance within which the position attracts to the constraint location.", "o|33|E6|19Q|Pq|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19R", "o|3L|E6|1p|2p|19Q|3M", "a|3N|3O|3P|19T|3T|3U|3V|3W|3Z", "Wraps another constraint so it acts as a soft attraction within a threshold", "o|F|RP|19M|19N|189|19S|19U|2p|2p|2p|RP|19V|Az", "Constrains a graphical component's position to lie inside a region", "o|F|RQ|192|193|189|197|199|2p|2p|2p|RQ|19X|Az", "a|1K|1f|1z|2Q|8n|8u|8q|8r|8s|8t|8Y|8p", "102100011110", "Style number applied to the resulting intersection components.", "o|g3|34|19b", "a|2j|2t|2w|2z|32|19c|3A|3E|3H|gB", "a|3N|3P|3Z", "Renders intersections between graphical objects", "o|F|1y|19Z|19a|g0|19d|19e|3M|2p|2p|1y|19f|Az", "case", "a|1z|19h|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y|An", "101111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111110", "Convenience for a single-case form: the boolean condition for which the children are rendered.", "o|Ap|Aq|19k|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19l", "Renders content conditionally based on its `<case>` or `<else>` children", "o|F|1z|19i|19j|g0|19m|125|3M|3M|2p|1z|19n|Az", "The children rendered as a comma-separated text string.", "o|3Q|1T|1T|2p|19p", "The children rendered as a comma-separated LaTeX string.", "o|3Q|2V|2V|2p|19r", "a|3N|3O|3P|3T|3U|3V|3W|3Z|19q|19s", "Renders its children as a comma-separated list", "o|F|20|2Z|2a|3l|3I|19t|3M|3M|2p|20|19u|3h", "numVariants", "The total number of variants to generate.", "o|2h|19w|19x|1q", "uniqueVariants", "Whether to require generated variants to be uniquely distinguishable.", "o|Ap|19z|1A0|2s|1V", "variantsToInclude", "Restrict the available variants to this list (by name or index).", "o|2h|1A2|1A3|11U", "variantsToExclude", "Variants to exclude from those generated.", "o|2h|1A5|1A6|11U", "variantNames", "Names assigned to the generated variants.", "o|2h|1A8|1A9|11U", "seeds", "Random seeds used when generating variants.", "o|2h|1AB|1AC|11U", "a|2j|2t|2w|2z|32|37|3A|3E|3H|19y|1A1|1A4|1A7|1AA|1AD", "Configures how variants are generated for the enclosing document or section", "o|F|9A|54|AZ|Ao|1AE|Aa|3M|2p|2p|9A|1AF|Az", "numToSelect", "How many values to select from the sequence.", "o|33|1AH|1AI|36|1q", "withReplacement", "Whether the same value can be selected more than once.", "o|2m|1AK|1AL|2p|2s|1V", "Whether and how to sort the selected values.", "unsorted", "increasing", "decreasing", "a|1AO|1AP|1AQ|2q|2r", "Preserve the random selection order.", "o|3s|1AO|1AS", "Sort the selected values in increasing order.", "o|3s|1AP|1AU", "Sort the selected values in decreasing order.", "o|3s|1AQ|1AW", "a|1AT|1AV|1AX", "o|Bi|2L|1AN|1AO|1AR|1AY|3y", "excludeCombinations", "Lists of value combinations to exclude from the selection.", "_componentListOfListsWithSelectableType", "o|2h|1Aa|1Ab|1Ac", "coprime", "Require the selected numbers to be pairwise coprime (numbers only).", "o|2m|1Ae|1Af|2p|2s|1V", "a|2j|2t|2w|g2|32|37|3A|3E|3H|gn|go|gp|gq|gr|11p|11s|11u|11x|11z|123|gB|1AJ|1AM|1AZ|1Ad|1Ag", "o|3L|1AH|1q|2p|1AI|3M", "o|3L|1AK|1V|2p|1AL|3M", "o|3L|2L|1T|2p|1AN|3M", "o|3L|1Ae|1V|2p|1Af|3M", "a|3N|3O|3P|1Ai|1Aj|1Ak|1Al|3Z", "Randomly selects values from a sequence of numbers, math expressions, or letters to create document variants", "o|F|21|54|AZ|g0|1Ah|1Am|3M|2p|3M|21|1An|Az", "a|11R|1z", "How many child components to select.", "o|33|1AH|1Aq|36|1q", "Whether the same child can be selected more than once.", "o|2m|1AK|1As|2p|2s|1V", "Component type to select from.", "o|2h|2g|1Au|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ar|1At|1Av|gB", "o|3L|1AH|1q|2p|1Aq|3M", "o|3L|1AK|1V|2p|1As|3M", "a|3N|3O|3P|1Ax|1Ay|3Z", "Randomly selects components from a list of children to create document variants", "o|F|22|1Ap|BN|g0|1Aw|1Az|3M|3M|3M|22|1B0|Az", "Whether this group's children should be treated as responses for assessment.", "o|g3|38|1B2", "rendered", "Whether the group's children are rendered.", "o|2m|1B4|1B5|3M|2s|1V", "createComponentOfType", "Component type to wrap each child as when expanding the group.", "o|2h|1B7|1B8|1T", "Number of components to create when expanding (used with createComponentOfType).", "o|2h|gF|1BA|1p", "Whether to render the group's children separated by commas (true) or with no separator (false).", "o|2m|20|1BC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|1B3|3E|3H|1B6|1B9|1BB|1BD", "o|3L|1B4|1V|2p|1B5|3M", "a|3N|3O|1BF|3Z", "A logical grouping of components", "o|F|23|9U|9V|g0|1BE|1BG|3M|3M|2p|23|1BH|Az", "target", "Reference to the state variable that will be animated.", "o|2h|1BJ|1BK|3D", "animationOn", "Whether the animation is currently playing.", "o|2m|1BM|1BN|2p|2s|1V", "animationMode", "How the animation steps through the sequence.", "increase", "decrease", "increase once", "decrease once", "oscillate", "a|1BR|1BS|1BT|1BU|1BV", "Step through values from first to last, looping back to the start.", "o|3s|1BR|1BX", "Step through values from last to first, looping back to the end.", "o|3s|1BS|1BZ", "Step from first to last and stop without looping.", "o|3s|1BT|1Bb", "Step from last to first and stop without looping.", "o|3s|1BU|1Bd", "Step from first to last, then reverse direction at each end.", "o|3s|1BV|1Bf", "a|1BY|1Ba|1Bc|1Be|1Bg", "o|Bi|1BP|1BQ|1BR|1BW|1Bh|3y", "animationInterval", "Time in milliseconds between successive animation steps.", "o|33|1Bj|1Bk|Nv|1p", "allowAdjustmentsWhileRunning", "Whether sequence parameters can be adjusted while the animation is running.", "o|2m|1Bm|1Bn|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|11p|11s|11u|11x|11z|123|1BL|1BO|1Bi|1Bl|1Bo", "o|3L|1BM|1V|2p|1BN|3M", "o|3L|1BP|1T|2p|1BQ|3M", "o|3L|1Bj|1p|2p|1Bk|3M", "o|3L|1Bm|1V|2p|1Bn|3M", "Index of the currently selected value in the sequence (1-based).", "o|3Q|vc|1p|2p|1Bu", "The currently selected value of the animation.", "o|ry|3a|2p|1Bw", "currentAnimationDirection", 'Current direction of the animation ("increase" or "decrease"; flips during oscillation).', "o|3Q|1By|1T|2p|1Bz", "a|3N|3O|3P|1Bq|1Br|1Bs|1Bt|3T|3U|3V|3W|3Z|1Bv|1Bx|1C0", "Animates a value through a sequence over time", "o|F|9B|54|AZ|Ao|1Bp|1C1|3M|2p|2p|9B|1C2|Az", "Whether to treat the inputs as unordered.", "o|2m|4n|1C4|2p|2s|1V", "Whether to force symbolic evaluation.", "o|2m|DH|1C6|2p|2s|1V", "Whether to force numeric evaluation.", "o|2m|DK|1C8|2p|2s|1V", "The function to evaluate.", "o|2h|1r|1CA|1r", "input", "Input value(s) at which to evaluate the function.", "o|2h|1CC|1CD|1Y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1C5|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1C7|1C9|1CB|1CE", "o|3L|4n|1V|2p|1C4|3M", "o|3L|DH|1V|2p|1C6|3M", "o|3L|DK|1V|2p|1C8|3M", "o|3Q|3a|24|2p|6e", "The function evaluated at the inputs as a math expression.", "o|3Q|I9|1X|2p|1CK", "a|3N|3O|3P|66|67|68|69|1CG|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1CH|1CI|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1CJ|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1CL|7S|7V|7Y|7b", "Evaluates a function at a math value", "o|F|24|54|AZ|3l|1CF|1CM|3M|2p|2p|24|1CN|3h", "Distribution from which to sample.", "discreteUniform", "gaussian", "a|W7|1CQ|1CR", "Continuous uniform distribution over `[from, to]`.", "o|3s|W7|1CT", "Discrete uniform distribution over integers in `[from, to]`.", "o|3s|1CQ|1CV", "Normal (Gaussian) distribution with the specified mean and standard deviation.", "o|3s|1CR|1CX", "a|1CU|1CW|1CY", "o|Bi|2g|1CP|W7|1CS|1CZ|3y", "Mean of the sampling distribution (Gaussian).", "o|33|l|1Cb|5Q|1p", "Standard deviation of the sampling distribution (Gaussian).", "o|33|o|1Cd|36|1p", "Variance of the sampling distribution (Gaussian).", "o|33|n|1Cf|36|1p", "Lower bound of the sampling range.", "o|33|hM|1Ch||1p", "Upper bound of the sampling range.", "o|33|hX|1Cj||1p", "Step size between samples for the discrete-uniform distribution.", "o|33|11v|1Cl|36|1p", "Values to exclude from the sample space.", "o|33|120|1Cn|54|1a", "How many random numbers to select.", "o|33|1AH|1Cp|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|gB|1Cq", "o|3L|2g|1T|2p|1CP|3M", "o|3L|1AH|1q|2p|1Cp|3M", "Step size between sample values (for discrete distributions).", "o|3Q|11v|1p|2p|1Cu", "o|3Q|hM|1p|2p|1Ch", "o|3Q|hX|1p|2p|1Cj", "Mean of the sampling distribution.", "o|3Q|l|1p|2p|1Cy", "Variance of the sampling distribution.", "o|3Q|n|1p|2p|1D0", "Standard deviation of the sampling distribution.", "o|3Q|o|1p|2p|1D2", "a|3N|3O|3P|1Cs|1Ct|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Selects a fixed set of random numbers to create document variants", "o|F|25|54|AZ|g0|1Cr|1D4|3M|2p|3M|25|1D5|Az", "numSamples", "Number of samples to draw.", "o|33|1D7|1D8|36|1p", "variantDeterminesSeed", "Whether the document's variant index determines the random seed.", "o|Ap|1DA|1DB|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1D9|1Ca|1Cc|1Ce|1Cg|1Ci|1Ck|1Cm|1Co|gn|go|gp|gq|gr|1DC|gB", "o|3L|1D7|1p|2p|1D8|3M", "o|3L|1DA|1V|2p|1DB|3M", "a|3N|3O|3P|1DE|1Cs|1DF|3Z|1Cv|1Cw|1Cx|1Cz|1D1|1D3", "Samples random numbers from a distribution", "o|F|26|54|AZ|g0|1DD|1DG|3M|2p|3M|26|1DH|Az", "Lower bound (inclusive) of the prime range to select from.", "o|33|hM|1DJ|4X|1q", "Upper bound (inclusive) of the prime range to select from.", "o|33|hX|1DL|12N|1q", "Primes to exclude from the selection.", "o|33|120|1DN|54|1a", "How many prime numbers to select.", "o|33|1AH|1DP|36|1q", "Whether the same prime can be selected more than once.", "o|2m|1AK|1DR|2p|2s|1V", "Sort order applied to the selected primes.", "Sort the selected primes in increasing order.", "o|3s|1AP|1DU", "Sort the selected primes in decreasing order.", "o|3s|1AQ|1DW", "a|1AT|1DV|1DX", "o|Bi|2L|1DT|1AO|1AR|1DY|3y", "Combinations of values that should not be selected together.", "_listOfNumberLists", "o|2h|1Aa|1Da|1Db", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1DK|1DM|1DO|1DQ|1DS|1DZ|1Dc|gB", "o|3L|hM|1q|2p|1DJ|3M", "o|3L|hX|1q|2p|1DL|3M", "o|3L|120|1a|2p|1DN|3M", "o|3L|1AH|1q|2p|1DP|3M", "o|3L|1AK|1V|2p|1DR|3M", "o|3L|2L|1T|2p|1DT|3M", "a|3N|3O|3P|1De|1Df|1Dg|1Dh|1Di|1Dj|3Z", "Randomly selects prime numbers from a range to create document variants", "o|F|27|54|AZ|g0|1Dd|1Dk|3M|2p|3M|27|1Dl|Az", "Number of prime samples to draw.", "o|33|1D7|1Dn|36|1p", "Lower bound (inclusive) of the prime range to sample from.", "o|33|hM|1Dp|4X|1q", "Upper bound (inclusive) of the prime range to sample from.", "o|33|hX|1Dr|12N|1q", "Primes to exclude from the sample.", "o|33|120|1Dt|54|1a", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Do|1Dq|1Ds|1Du|1DC|gB", "o|3L|1D7|1p|2p|1Dn|3M", "o|3L|hM|1q|2p|1Dp|3M", "o|3L|hX|1q|2p|1Dr|3M", "o|3L|120|1a|2p|1Dt|3M", "a|3N|3O|3P|1Dw|1Dx|1Dy|1Dz|1DF|3Z", "Samples random prime numbers", "o|F|28|54|AZ|g0|1Dv|1E0|3M|2p|3M|28|1E1|Az", "Type of values being substituted.", "a|1X|1T", "Substitute within math expressions.", "o|3s|1X|1E5", "Substitute within text values.", "o|3s|1T|1E7", "a|1E6|1E8", "o|HC|2g|1E3|1E4|1E9|3y", "match", "Pattern to match in the source value.", "o|33|1EB|1EC||11r", "replacement", "Value to substitute in place of each match.", "o|33|1EE|1EF||11r", "Level of simplification applied after substitution.", "Fully simplify the resulting expression.", "o|3s|43|1EI", "a|49|1EJ|4D|4F|4H", "o|Bi|40|1EH|42|47|1EK|3y", "matchWholeWord", "Whether matching is restricted to whole words (text mode).", "o|2m|1EM|1EN|2p|2s|1V", "matchCase", "Whether matching is case-sensitive (text mode).", "o|2m|1EP|1EQ|2p|2s|1V", "preserveCase", "Whether the case of the original is preserved when substituting.", "o|2m|1ES|1ET|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1EA|1ED|1EG|1EL|H8|4Y|4c|4g|4j|1EO|1ER|1EU", "o|3L|2g|1T|2p|1E3|3M", "o|3L|40|1T|2p|1EH|3M", "o|3L|1EM|1V|2p|1EN|3M", "o|3L|1EP|1V|2p|1EQ|3M", "o|3L|1ES|1V|2p|1ET|3M", "a|3N|3O|3P|1EW|1EX|1EY|1EZ|1Ea|3Z|6X|6Y|6Z|6a|6b", "Substitutes math expressions into another expression", "o|F|29|9U|9V|g0|1EV|1Eb|3M|3M|3M|29|1Ec|Az", "o|Ap|4n|4o|2s|1V", "minIndex", "Smallest period index considered when listing offsets.", "-Infinity", "o|33|1Ef|1Eg|1Eh|1q", "maxIndex", "Largest period index considered when listing offsets.", "o|33|1Ej|1Ek|9k|1q", "offsets", "Offsets within one period.", "o|33|1Em|1En||1Y", "The period of the set.", "o|33|Y8|1Ep||1X", "minIndexAsList", "Smallest period index when rendered as a list.", "n|-1", "o|33|1Er|1Es|1Et|1q", "maxIndexAsList", "Largest period index when rendered as a list.", "o|33|1Ev|1Ew|36|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Ei|1El|1Eo|1Eq|1Eu|1Ex", "o|3L|1Ef|1q|2p|1Eg|3M", "o|3L|1Ej|1q|2p|1Ek|3M", "o|3L|1Em|1Y|2p|1En|3M", "o|3L|Y8|1X|2p|1Ep|3M", "o|3L|1Er|1q|2p|1Es|3M", "o|3L|1Ev|1q|2p|1Ew|3M", "o|3Q|3a|2A|2p|6e", "numOffsets", "The number of distinct offsets within one period.", "o|3Q|1F6|1q|2p|1F7", "redundantOffsets", "Offsets that are redundant given the period.", "o|3Q|1F9|1V|2p|1FA", "The periodic set rendered as a list of explicit values.", "o|3Q|20|1Y|2p|1FC", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1Ez|1F0|1F1|1F2|1F3|1F4|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1F5|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1F8|1FB|1FD|7S|7V|7Y|7b", "A periodic set of real numbers", "o|F|2A|54|AZ|3l|1Ey|1FE|3M|2p|2p|2A|1FF|3h", "a|1z|dd|2f", "200", "Explicit width of the image (overrides size).", "o|33|bx|1FJ||bz", "Named size preset for the image.", "o|Bi|uB|1FL|xA|xE|xP|3y", "Aspect ratio (width / height) for the image.", "o|33|xR|1FN||1p", "How to size the image.", "o|Bi|xU|1FP|AT|xW|xb|3y", "Horizontal alignment of the image within its container.", "Center the image horizontally.", "o|3s|5b|1FS", "Align the image to the left edge.", "o|3s|5h|1FU", "Align the image to the right edge.", "o|3s|5i|1FW", "a|1FT|1FV|1FX", "o|Bi|xd|1FR|5b|xf|1FY|3y", "Whether the image is purely decorative.", "o|2m|zM|1Fa|2p|2s|1V", "source", "URL or path of the image source.", "o|33|1Fc|1Fd|AZ|1T", "authorName", "Name of the author of the image.", "o|33|1Ff|1Fg||1T", "authorUrl", "URL to link the author's name to in the attribution (e.g. the author's profile page).", "o|33|1Fi|1Fj||1T", "imageName", "Name of the image, used in place of the generic word “Image” in the attribution.", "o|33|1Fl|1Fm||1T", "originalUrl", "Original URL where the image can be found, used to link the image name in the attribution.", "o|33|1Fo|1Fp||1T", "licenseName", "Name of the license for the image.", "o|33|1Fr|1Fs||1T", "licenseUrl", "URL for the license of the image.", "o|33|1Fu|1Fv||1T", "a|3|2f|2k|2l|3n|cK|2g", "licenseCodes", "License code(s) for the image. Specify two codes to indicate the image is dual licensed.", "CC-BY", "CC-BY-SA", "CC-BY-ND", "CC-BY-NC", "CC-BY-NC-SA", "CC-BY-NC-ND", "CC0", "PDM", "GFDL", "FAL", "OGL", "MIT", "APACHE-2.0", "a|1G0|1G1|1G2|1G3|1G4|1G5|1G6|1G7|1G8|1G9|1GA|1GB|1GC", "Creative Commons Attribution: reuse with credit, including commercially.", "o|3s|1G0|1GE", "Creative Commons Attribution-ShareAlike: reuse with credit; adaptations keep the same license.", "o|3s|1G1|1GG", "Creative Commons Attribution-NoDerivatives: reuse unchanged, with credit.", "o|3s|1G2|1GI", "Creative Commons Attribution-NonCommercial: reuse with credit for noncommercial purposes.", "o|3s|1G3|1GK", "Creative Commons Attribution-NonCommercial-ShareAlike: noncommercial reuse with credit; adaptations keep the same license.", "o|3s|1G4|1GM", "Creative Commons Attribution-NonCommercial-NoDerivatives: reuse unchanged for noncommercial purposes, with credit.", "o|3s|1G5|1GO", "Creative Commons Zero: the creator has dedicated the work to the public domain.", "o|3s|1G6|1GQ", "Public Domain Mark: the work is free of known copyright restrictions.", "o|3s|1G7|1GS", "GNU Free Documentation License: copyleft license common on Wikimedia.", "o|3s|1G8|1GU", "Free Art License: copyleft license for artistic works.", "o|3s|1G9|1GW", "UK Open Government Licence: reuse government material with attribution.", "o|3s|1GA|1GY", "MIT License: permissive license common for icon and illustration sets.", "o|3s|1GB|1Ga", "Apache License 2.0: permissive license common for icon and illustration sets.", "o|3s|1GC|1Gc", "a|1GF|1GH|1GJ|1GL|1GN|1GP|1GR|1GT|1GV|1GX|1GZ|1Gb|1Gd", "o|1Fx|1Fy|1Fz||1GD|1Ge|3M|3y", "licenseVersion", "Version of the Creative Commons license(s) given in `licenseCodes` (ignored by non-Creative-Commons licenses).", "4.0", "1.0", "2.0", "2.5", "3.0", "a|1Gj|1Gk|1Gl|1Gm|1Gi", "Creative Commons version 1.0.", "o|3s|1Gj|1Go", "Creative Commons version 2.0.", "o|3s|1Gk|1Gq", "Creative Commons version 2.5.", "o|3s|1Gl|1Gs", "Creative Commons version 3.0.", "o|3s|1Gm|1Gu", "Creative Commons version 4.0.", "o|3s|1Gi|1Gw", "a|1Gp|1Gr|1Gt|1Gv|1Gx", "o|Bi|1Gg|1Gh|1Gi|1Gn|1Gy|3y", "asFileName", "File name to use when downloading the image.", "o|33|1H0|1H1||1T", "mimeType", "MIME type of the image.", "o|33|1H3|1H4||1T", "Whether the image can be dragged on a graph.", "o|2m|5L|1H6|3M|2s|1V", "rotate", "Rotation angle (radians) applied to the image.", "o|33|1H8|1H9|5Q|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1FK|1FM|1FO|1FQ|1FZ|1Fb|1Fe|1Fh|1Fk|1Fn|1Fq|1Ft|1Fw|1Gf|1Gz|1H2|1H5|1H7|5R|5X|63|1HA", "o|3L|xU|1T|2p|1FP|3M", "o|3L|xd|1T|2p|1FR|3M", "o|3L|zM|1V|2p|1Fa|3M", "o|3L|1Fc|1T|2p|1Fd|3M", "o|3L|1Ff|1T|2p|1Fg|3M", "o|3L|1Fi|1T|2p|1Fj|3M", "o|3L|1Fl|1T|2p|1Fm|3M", "o|3L|1Fo|1T|2p|1Fp|3M", "o|3L|1Fy|1U|2p|1Fz|3M", "o|3L|1Gg|1T|2p|1Gh|3M", "o|3L|1H0|1T|2p|1H1|3M", "o|3L|1H3|1T|2p|1H4|3M", "o|3L|5L|1V|2p|1H6|3M", "o|3L|1H8|1p|2p|1H9|3M", "A short accessibility description of the image.", "o|3Q|dd|1T|2p|1HQ", "The size of the image.", "o|3Q|uB|1T|2p|1HS", "The display width of the image.", "o|3Q|bx|bz|2p|1HU", "The aspect ratio (width / height) of the image.", "o|3Q|xR|1p|2p|1HW", "licenseNames", "The license name(s) for the image. Derived from `licenseCodes` when given; otherwise from the `licenseName` attribute.", "o|3Q|1HY|1U|2p|1HZ", "licenseUrls", "The license URL(s) for the image. Derived from `licenseCodes` (and `licenseVersion`) when given; otherwise from the `licenseUrl` attribute.", "o|3Q|1Hb|1U|2p|1Hc", "a|3N|3O|3P|1HC|1HD|1HE|1HF|1HG|1HH|1HI|1HJ|1HK|1HL|1HM|1HN|1HO|6I|6K|1HP|3T|3U|3V|3W|3Z|6W|1HR|1HT|1HV|1HX|1Ha|1Hd", "Displays a static image", "o|F|9C|1FH|1FI|9X|1HB|1He|3M|2p|2p|9C|1Hf|AT", "Explicit width of the video player (overrides size).", "o|2h|bx|1Hh|bz", "Named size preset for the video player.", "o|Bi|uB|1Hj|43|xE|xP|3y", "Aspect ratio (width / height) for the video player.", "16 / 9", "o|33|xR|1Hl|1Hm|1p", "How to size the video player.", "o|Bi|xU|1Ho|AT|xW|xb|3y", "Horizontal alignment of the video within its container.", "Center the video horizontally.", "o|3s|5b|1Hr", "Align the video to the left edge.", "o|3s|5h|1Ht", "Align the video to the right edge.", "o|3s|5i|1Hv", "a|1Hs|1Hu|1Hw", "o|Bi|xd|1Hq|5b|xf|1Hx|3y", "youtube", "YouTube video ID to embed.", "o|33|1Hz|1I0||1T", "URL of the video source.", "o|33|1Fc|1I2||1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Hi|1Hk|1Hn|1Hp|1Hy|1I1|1I3", "o|3L|xU|1T|2p|1Ho|3M", "o|3L|xd|1T|2p|1Hq|3M", "o|3L|1Hz|1T|2p|1I0|3M", "o|3L|1Fc|1T|2p|1I2|3M", "A short accessibility description of the video.", "o|3Q|dd|1T|2p|1I9", "The size of the video player.", "o|3Q|uB|1T|2p|1IB", "The display width of the video player.", "o|3Q|bx|bz|2p|1ID", "The aspect ratio (width / height) of the video player.", "o|3Q|xR|1p|2p|1IF", "state", "The video's current playback state (e.g. playing, paused).", "o|3Q|1IH|1T|2p|1II", "time", "The current playback time in seconds.", "o|3Q|1IK|1p|2p|1IL", "duration", "The total duration of the video in seconds.", "o|3Q|1IN|1p|2p|1IO", "secondsWatched", "Total seconds the viewer has watched.", "o|3Q|1IQ|1p|2p|1IR", "fractionWatched", "Fraction of the video the viewer has watched (0 to 1).", "o|3Q|1IT|1p|2p|1IU", "a|3N|3O|3P|1I5|1I6|1I7|1I8|3T|3U|3V|3W|3Z|1IA|1IC|1IE|1IG|1IJ|1IM|1IP|1IS|1IV", "Embeds a video player", "o|F|9D|1FH|1FI|9X|1I4|1IW|3M|2p|2p|9D|1IX|AT", "a|G|1z|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "0111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Whether the hint is currently open (revealed).", "o|3Q|M7|1V|2p|1Ib", "The hint's title text.", "o|3Q|G|1T|2p|1Id", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Ic|1Ie", "Hint shown on demand to help with an exercise", "o|F|9E|1IZ|1Ia|9X|3I|1If|3M|3M|2p|9E|1Ig|AT", "The formatted value rendered as a text string.", "o|3Q|1T|1T|2p|1Ii", "The numeric value with thousands separators.", "o|3Q|3a|2B|2p|1Ik", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Ij|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1Il", "Renders a numeric value with thousands separators (e.g. 1,000,000)", "o|F|2B|fq|fr|3l|Jc|1Im|3M|3M|2p|2B|1In|3h", "pluralForm", "Custom plural form to use (overrides automatic pluralization).", "o|33|1Ip|1Iq||1T", "basedOnNumber", "Number that determines whether to use the singular or plural form.", "o|33|1Is|1It||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|Jb|5X|63|1Ir|1Iu", "o|3L|1Ip|1T|2p|1Iq|3M", "o|3L|1Is|1p|2p|1It|3M", "The selected word as a text string.", "o|3Q|1T|1T|2p|1Iy", "The selected (singular or plural) word.", "o|3Q|3a|1T|2p|1J0", "a|3N|3O|3P|Jd|6I|Je|6K|1Iw|1Ix|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1Iz|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1J1", "Renders a word in its singular or plural form based on a count", "o|F|2C|fq|fr|3l|1Iv|1J2|3M|3M|2p|2C|1J3|3h", "Boolean expression; the feedback is shown when the condition is true.", "o|Ap|Aq|1J5|2s|1V", "updateWith", "References whose changes trigger re-evaluation of the feedback.", "o|2h|1J7|1J8|3D", "a|2j|2w|2z|32|37|3A|3E|3H|1J6|1J9", "a|3O|3P|3T|3U|3V|3W|3Z", "Targeted feedback shown when conditions are met", "o|F|9F|9U|9V|9X|1JA|1JB|3M|3M|2p|9F|1JC|AT", "Marks its children as response components for an enclosing answer", "o|F|pI|9U|9V|Ao|3I|Aa|2p|3M|2p|pI|1JE|Az", "A single conditional branch within `<conditionalContent>`", "o|F|19h|9U|9V|Ao|At|Ax|2p|3M|2p|19h|1JG|Az", "minSentencesPerParagraph", "Minimum number of sentences per generated paragraph.", "o|33|1JI|1JJ|13F|1p", "maxSentencesPerParagraph", "Maximum number of sentences per generated paragraph.", "n|8", "o|33|1JL|1JM|1JN|1p", "minWordsPerSentence", "Minimum number of words per generated sentence.", "o|33|1JP|1JQ|13F|1p", "maxWordsPerSentence", "Maximum number of words per generated sentence.", "o|33|1JS|1JT|1JN|1p", "generateWords", "Number of words of lorem-ipsum to generate.", "o|33|1JV|1JW||1p", "generateSentences", "Number of sentences of lorem-ipsum to generate.", "o|33|1JY|1JZ||1p", "generateParagraphs", "Number of paragraphs of lorem-ipsum to generate.", "o|33|1Jb|1Jc||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1JK|1JO|1JR|1JU|1JX|1Ja|1Jd", "o|3L|1JI|1p|2p|1JJ|3M", "o|3L|1JL|1p|2p|1JM|3M", "o|3L|1JP|1p|2p|1JQ|3M", "o|3L|1JS|1p|2p|1JT|3M", "a|3N|3O|3P|1Jf|1Jg|1Jh|1Ji|3Z", "Generates lorem ipsum placeholder text", "o|F|2D|54|AZ|g0|1Je|1Jj|3M|2p|2p|2D|1Jk|Az", "Reference to the state variable that will be updated.", "o|2h|1BJ|1Jm|3D", "Component type used to interpret the new value.", "a|1X|1p|1V|1T", "Treat the new value as a math expression.", "o|3s|1X|1Jq", "Treat the new value as a number.", "o|3s|1p|1Js", "Treat the new value as a boolean.", "o|3s|1V|1Ju", "Treat the new value as text.", "o|3s|1T|1Jw", "a|1Jr|1Jt|1Jv|1Jx", "o|HC|2g|1Jo|1Jp|1Jy|3y", "newValue", "New value to assign to the target.", "o|2h|1K0|1K1|11r", "Whether the update button can be dragged on a graph.", "o|2m|5L|1K3|3M|2s|1V", "triggerWhen", "Boolean expression that fires the action whenever it transitions to true.", "triggering", "o|4d|1K5|1K6|1K7|2p|2s|1V", "a|3|2f|4N|2g", "triggerWith", "References to components whose value changes should fire this action.", "o|1K9|1KA|1KB|1K7|3D", "triggerWhenObjectsClicked", "References to components whose click events should fire this action.", "o|1K9|1KD|1KE|1K7|3D", "triggerWhenObjectsFocused", "References to components whose focus events should fire this action.", "o|1K9|1KG|1KH|1K7|3D", "Level of simplification applied to the new value.", "Fully simplify the new value.", "o|3s|43|1KK", "a|49|1KL|4D|4F|4H", "o|Bi|40|1KJ|42|47|1KM|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Jn|1Jz|1K2|1K4|5X|63|GH|1K8|1KC|1KF|1KI|1KN", "o|3L|5L|1V|2p|1K3|3M", "o|3L|40|1T|2p|1KJ|3M", "a|3N|3O|3P|1KP|6K|Hd|1KQ|3T|3U|3V|3W|3Z|Hk|6W", "Updates one or more state variables on a target component", "o|F|2E|Om|On|3l|1KO|1KR|3M|2p|2p|2E|1KS|3h", "a|I|J|1z|2S|G|H|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "1110111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Reference to the component whose action will be invoked.", "o|2h|1BJ|1KW|3D", "actionName", "Name of the action to invoke on the target component.", "o|33|1KY|1KZ||1T", "Whether the action button can be dragged on a graph.", "o|2m|5L|1Kb|3M|2s|1V", "Numeric arguments passed to the invoked action.", "o|2h|44|1Kd|1a", "Numeric argument passed to the invoked action.", "o|2h|1p|1Kf|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1KX|1Ka|1Kc|GH|5X|63|1K8|1KC|1KF|1KI|1Ke|1Kg", "o|3L|1KY|1T|2p|1KZ|3M", "o|3L|5L|1V|2p|1Kb|3M", "a|3N|3O|3P|1Ki|1Kj|Hd|6K|3T|3U|3V|3W|3Z|Hk|6W", "Triggers an action when clicked or in response to a specified user interaction", "o|F|2F|1KU|1KV|3l|1Kh|1Kk|3M|3M|2p|2F|1Kl|3h", "a|1z|2E|2F|I|J|2S", "200110", "Whether the trigger set's button can be dragged on a graph.", "o|2m|5L|1Kp|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Kq|5X|63|GH|1K8|1KC|1KF|1KI", "o|3L|5L|1V|2p|1Kp|3M", "a|3N|3O|3P|1Ks|6K|Hd|3T|3U|3V|3W|3Z|Hk|6W", "Groups a set of `<updateValue>` or `<callAction>` components which share a single trigger condition", "o|F|2G|1Kn|1Ko|3l|1Kr|1Kt|3M|2p|2p|2G|1Ku|3h", "numIterates", "Number of iterations to compute.", "o|33|1Kw|1Kx|5Q|1q", "Starting value passed to the function on the first iteration.", "o|33|12Q|1Kz|5J|1X", "The function to iterate.", "o|2h|1r|1L1|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ky|1C7|1C9|1L0|1L2|H8|4Y|4c|4g|4j", "o|3L|1Kw|1q|2p|1Kx|3M", "Number of dimensions of each iterate.", "o|3Q|6r|1q|2p|1L5", "allIterates", "All computed iterates of the function.", "o|3Q|1L7|1Y|2p|1L8", "allIteratesWithInitial", "All iterates including the initial value.", "o|3Q|1LA|1Y|2p|1LB", "iterates", "The list of iterate values.", "o|6v|1LD|1X|3M|1LE|36|75", "finalIterate", "The last iterate value.", "o|3Q|1LG|1X|2p|1LH", "a|3N|3O|3P|1L4|1CH|1CI|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1L6|1L9|1LC|1LF|1LI", "List of values produced by iterating a function", "o|F|2H|54|AZ|3l|1L3|1LJ|3M|2p|2p|2H|1LK|3h", "a|2j|2t|2w|2z|32|1B3|3E|3H|1B6|1B9|1BB|1BD", "a|3N|1BF|3Z", "A reusable group with parameterized attributes; can be copied elsewhere with new parameter values", "o|F|2I|9U|9V|g0|1LM|1LN|3M|3M|2p|2I|1LO|Az", "Declares attributes accepted by an enclosing `<module>`", "o|F|9G|9U|9V|g0|3I|125|3M|3M|2p|9G|1LQ|Az", "a|Ks|1z|Kt|G|H|I|J|89|8A|8B|K|8C|L|M|N|O|P|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|10|11|12|13|14|15|16|17|18|19|1A|1B|1C|1D|1E|1F|1G|1H|8D|8E|8F|8G|8H|8I|8J|8K|8L|8M|8N|8O|8P|8Q|8R|8S|8T|8U|8V|8W|8X|1I|8Y|1J|1K|8Z|1L|1M|1N|1O|8a|8b|8c|8d|8e|8f|1P|8g|1Q|8h|8i|1R|1S|8j|8k|8l|1T|1U|8m|1V|1W|1X|1Y|1Z|1a|1b|1c|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1g|1h|1i|1j|8x|1k|1l|1m|1n|1o|1p|1q|8y|8z|90|1r|1s|1t|1u|91|92|1v|93|94|95|96|97|98|1w|1x|99|1y|20|9A|21|22|23|9B|24|25|26|27|28|29|2A|9C|9D|9E|2B|2C|9F|2D|2E|2F|2G|2H|2I|9G|9H|2J|9I|2K|2L|2M|2N|9J|2O|2P|2Q|9K|9L|9M|9N|2R|9O|2S|2T|2U|9P|2V|9Q|9R|9S|9T|2W|2X|2Y", "010111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111111", "Container for components used for setup but not rendered", "o|F|9H|1LS|1LT|g0|3I|125|3M|3M|2p|9H|1LU|Az", "The footnote's body as plain text.", "o|3Q|1T|1T|2p|1LW", "footnoteTag", "The auto-generated marker (number) used to reference this footnote.", "o|3Q|1LY|1T|2p|1LZ", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1LX|1La", "Inline footnote whose body is shown on demand and is auto-numbered in the document", "o|F|2J|2Z|2a|3l|3I|1Lb|3M|3M|2p|2J|1Lc|3h", "The caption rendered as a plain text string.", "o|3Q|1T|1T|2p|1Le", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1Lf", "A caption attached to a figure or table", "o|F|9I|fL|fM|9X|3I|1Lg|3M|3M|2p|9I|1Lh|AT", "Whether the endpoint is open (excluded) rather than closed (included).", "o|2m|M7|1Lj|2p|2s|1V", "Whether the user can toggle the endpoint between open and closed by clicking it.", "o|2m|Ss|1Ll|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Rt|Rw|Ry|S0|S2|S4|S7|S9|H8|4Y|4c|4g|4j|SS|P4|Si|Sl|So|1Lk|1Lm", "o|3L|M7|1V|2p|1Lj|3M", "o|3L|Ss|1V|2p|1Ll|3M", "a|3N|3O|3P|Hd|QD|7s|QE|Sw|Sx|QG|Sy|Sz|1Lo|1Lp|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|T4|T7|6N|6Q|6T|T9|TB|TD|TF|TG|TI|TK|TN|TO|TP|TQ|TR", "A point that marks the endpoint of an interval, rendered open or closed", "o|F|2K|RR|RS|Op|1Ln|1Lq|3M|3M|2p|2K|1Lr|Az", "sortVectorsBy", "Whether to sort vectors by component or by magnitude.", "a|na|ng", "Sort vectors by their displacement components.", "o|3s|na|1Lw", "Sort vectors by the position of their tail point.", "o|3s|ng|1Ly", "a|1Lx|1Lz", "o|Bi|1Lt|1Lu|na|1Lv|1M0|3y", "sortByComponent", "Index of the component to sort by (when sorting vectors).", "o|33|1M2|1M3|oX|1q", "sortByProp", 'Name of a property to sort by (e.g. "x" for sorting points by x-coordinate).', "o|2h|1M5|1M6|1T", "Component type to sort children as.", "o|2h|2g|1M8|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1M1|1M4|1M7|1M9|gB", "o|3L|1Lt|1T|2p|1Lu|3M", "o|3L|1M2|1q|2p|1M3|3M", "a|3N|3O|3P|1MB|1MC|3Z", "Sorts a list according to a comparison function", "o|F|2L|9U|9V|g0|1MA|1MD|3M|3M|3M|2L|1ME|Az", "Component type to shuffle children as.", "o|2h|2g|1MG|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MH|gB", "Randomly shuffles its children", "o|F|2M|9U|9V|g0|1MI|125|3M|3M|3M|2M|1MJ|Az", "Names of the variables to solve for.", "o|2h|Gx|1ML|Gz", "Number of points used when searching for solutions numerically.", "o|33|Vo|1MN|12N|1p", "minVar", "Lower bound of the variable's search range.", "o|33|1MP|1MQ||1p", "maxVar", "Upper bound of the variable's search range.", "o|33|1MS|1MT||1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1MM|1MO|1MR|1MU", "o|3L|Vo|1p|2p|1MN|3M", "The variables of the equations.", "o|6v|Gx|H3|3M|1MX|36|I7", "numSolutions", "The number of numerical solutions found.", "o|3Q|1MZ|1q|2p|1Ma", "solutions", "The numerical solutions of the equations.", "o|6v|1Mc|1X|3M|1Md|36|75", "The first variable being solved for.", "o|3Q|H1|H3|2p|1Mf", "a|3N|3O|3P|1MW|3T|3U|3V|3W|3Z|1MY|1Mb|1Me|1Mg", "Numerically solves a system of equations", "o|F|2N|3j|3k|3l|1MV|1Mh|3M|3M|2p|2N|1Mi|3h", "Variable name displayed on the number line.", "o|33|H1|1Mk|Pw|H3", "Input format used for parsing entered subsets.", "Parse entered subsets as plain-text notation.", "o|3s|1T|1Mn", "Parse entered subsets as LaTeX notation.", "o|3s|2V|1Mp", "a|1Mo|1Mq", "o|Bi|3p|1Mm|1T|3r|1Mr|3y", "Initial subset displayed in the input.", "o|33|Zj|1Mt|AZ|1T", "o|2h|e9|eA|2O", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Ml|1Ms|1Mu|1Mv", "o|3L|H1|H3|2p|1Mk|3M", "o|3L|3p|1T|2p|1Mm|3M", "o|3L|Zj|1T|2p|1Mt|3M", "subsetValue", "The current subset of the reals entered by the user.", "o|3Q|1N0|2O|2p|1N1", "The boundary points that delimit the subset.", "o|6v|UQ|1X|3M|1N3|36|75", "pointsClosed", "Whether each boundary point of the subset is a closed (included) endpoint.", "o|6v|1N5|1V|3M|1N6|36|Qq", "intervals", "The intervals (non-degenerate components) of the subset.", "o|6v|1N8|1X|3M|1N9|36|75", "isolatedPoints", "The isolated (non-interval) points of the subset.", "o|6v|1NB|1X|3M|1NC|36|75", "a|3N|3O|3P|1Mx|1My|1Mz|3T|3U|3V|3W|3Z|1N2|1N4|1N7|1NA|1ND", "An interactive number-line widget for entering a subset of real numbers (block-level; does not inherit from Input)", "o|F|9J|54|AZ|9X|1Mw|1NE|3M|2p|2p|9J|1NF|AT", "o|2m|4t|4u|3M|2s|1V", "Name of the variable used when expressing the subset.", "o|33|H1|1NI|Pw|H3", "How the subset is displayed.", "inequalities", "a|1N8|1NL", "Display the subset using interval notation (e.g., `(0, 1]`).", "o|3s|1N8|1NN", "Display the subset using inequalities (e.g., `0 < x ≤ 1`).", "o|3s|1NL|1NP", "a|1NO|1NQ", "o|Bi|xU|1NK|1N8|1NM|1NR|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|4p|4s|1NH|51|55|58|5B|5E|5K|5N|5R|5X|63|1NJ|1NS", "o|3L|xU|1T|2p|1NK|3M", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|1NU|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|6d|gg|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|1N4|1N7|1NA|1ND|7S|7V|7Y|7b", "A subset of the real numbers, defined by intervals and points", "o|F|2O|3j|3k|3l|1NT|1NV|3M|3M|2p|2O|1NW|3h", "Type of value being split.", "a|1T", "Split text values.", "o|3s|1T|1Na", "a|1Nb", "o|HC|2g|1NY|1NZ|1Nc|3y", "splitBy", "How to break the input string into pieces.", "letter", "word", "comma", "a|1Ng|1Nh|1Ni", "Split into individual characters.", "o|3s|1Ng|1Nk", "Split into whitespace-separated words.", "o|3s|1Nh|1Nm", "Split on comma boundaries.", "o|3s|1Ni|1No", "a|1Nl|1Nn|1Np", "o|Bi|1Ne|1Nf|1Ng|1Nj|1Nq|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Nd|1Nr|gB", "Splits a string or list into pieces", "o|F|2P|9U|9V|g0|1Ns|125|3M|3M|2p|2P|1Nt|Az", "data", "The data points to fit a line to.", "o|2h|1Nv|1Nw|2W", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|HQ|HT|Tk|Tn|Tp|H8|4Y|4c|4g|4j|UB|1Nx", "Number of dimensions of the line (always 2 for a best-fit line).", "o|3Q|6r|1p|2p|1Nz", "Whether the line can be dragged (always false for a best-fit line).", "o|3Q|5L|1V|2p|1O1", "The data points used to compute the best-fit line.", "o|6v|1Nv|1X|3M|1O3|4X|IM", "a|3N|3O|3P|Hd|QD|7s|QE|UG|3T|3U|3V|3W|3Z|Hk|6X|6Y|6Z|6a|6b|6N|6Q|6T|UJ|UL|1O0|UP|US|UU|UX|Ua|Ud|Uf|Ui|Ul|Un|Up|1O2|1O4", "The best-fit line for a set of points", "o|F|2Q|Om|On|Op|1Ny|1O5|3M|2p|2p|2Q|1O6|Az", "boundaryValues", "Boundary values defining the region's left/right edges.", "a|5Q|36", "o|33|1O8|1O9|1OA|1a", "The function whose graph bounds the region.", "o|2h|1r|1OC|1r", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OB|1OD", "o|3L|1O8|1a|2p|1O9|3M", "A textual description of the region's style.", "o|3Q|Hl|1T|2p|1OG", 'Style description including the word "region".', "o|3Q|Ho|1T|2p|1OI", "a|3N|3O|3P|Hd|QD|7s|QE|1OF|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between a curve and the x-axis", "o|F|9K|Om|On|Op|1OE|1OK|3M|2p|2p|9K|1OL|Az", "a|I|J|1z|2S|w|x|y|1r|1s", "112011101", "Boundary values defining the region's edges.", "o|33|1O8|1OP|1OA|1a", "flipFunctions", "Whether to swap the role of x and y for the input functions.", "o|2m|1OR|1OS|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|Ux|V0|VP|1OQ|1OT", "o|3L|1O8|1a|2p|1OP|3M", "o|3L|1OR|1V|2p|1OS|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1OV|1OW|3T|3U|3V|3W|3Z|Hk|1OH|1OJ", "A region bounded between two curves", "o|F|9L|1ON|1OO|Op|1OU|1OX|3M|2p|2p|9L|1OY|Az", "Whether the half-plane extends horizontally, bounded by the vertical line x = boundaryValue. If false, the half-plane extends vertically, bounded by the horizontal line y = boundaryValue.", "o|2m|V3|1Oa|3M|2s|1V", "boundaryValue", "Position of the bounding line: x = boundaryValue when horizontal is true, y = boundaryValue when horizontal is false.", "o|33|1Oc|1Od|5Q|1p", "greaterThan", "Whether the region is the side where the inequality is greater than the boundary.", "o|2m|1Of|1Og|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Ob|1Oe|1Oh", "o|3L|V3|1V|2p|1Oa|3M", "o|3L|1Oc|1p|2p|1Od|3M", "o|3L|1Of|1V|2p|1Og|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Oj|1Ok|1Ol|3T|3U|3V|3W|3Z|Hk", "A half-plane region bounded by a line", "o|F|9M|Om|On|Op|1Oi|1Om|3M|2p|2p|9M|1On|Az", "Initial code shown in the editor before the user types.", "o|33|Zj|1Op|AZ|1T", 'Editor width (e.g. "100%" or "600px").', "100", "o|uD|1Os|2p", "o|33|bx|1Or|1Ot|bz", 'Editor height (e.g. "500px").', "n|6S", "o|uD|1Ow|3M", "o|33|k5|1Ov|1Ox|bz", "viewerRatio", "Fraction of the editor area allotted to the live viewer.", "o|2h|1Oz|1P0|1p", "showResults", "Whether to render the results panel alongside the editor.", "o|2m|1P2|1P3|2p|2s|1V", "showFormatter", "Whether to show a code formatter button.", "o|2m|1P5|1P6|2p|2s|1V", "resultsLocation", "Position of the results panel relative to the editor.", "a|5g|5h|5i", "Place the results panel below the editor.", "o|3s|5g|1PB", "Place the results panel to the left of the editor.", "o|3s|5h|1PD", "Place the results panel to the right of the editor.", "o|3s|5i|1PF", "a|1PC|1PE|1PG", "o|Bi|1P8|1P9|5g|1PA|1PH|3y", "readOnly", "Whether the editor is read-only.", "o|2m|1PJ|1PK|2p|2s|1V", "initialOpenTab", "Which diagnostics/responses tab to open initially.", "first", "errors", "warnings", "info", "accessibility", "responses", "help", "a|42|1PO|1PP|1PQ|1PR|1PS|1PT|1PU", "Panel starts closed.", "o|3s|42|1PW", "Open the first available tab.", "o|3s|1PO|1PY", "Open the errors tab.", "o|3s|1PP|1Pa", "Open the warnings tab.", "o|3s|1PQ|1Pc", "Open the info tab.", "o|3s|1PR|1Pe", "Open the accessibility tab.", "o|3s|1PS|1Pg", "Open the responses tab.", "o|3s|1PT|1Pi", "Open the help tab.", "o|3s|1PU|1Pk", "a|1PX|1PZ|1Pb|1Pd|1Pf|1Ph|1Pj|1Pl", "o|Bi|1PM|1PN|1PO|1PV|1Pm|3y", "renderedName", "Name to assign to the dynamically-rendered DoenetML output.", "o|2h|1Po|1Pp|1T", "staticName", "Name to assign to the static DoenetML source.", "o|2h|1Pr|1Ps|1T", "a|2j|2t|2w|2z|32|37|3A|3E|3H|1Oq|u5|1Ou|1Oy|1P1|1P4|1P7|1PI|1PL|1Pn|1Pq|1Pt", "o|3L|Zj|1T|2p|1Op|3M", "o|3L|bx|bz|2p|1Or|3M", "o|3L|k5|bz|2p|1Ov|3M", "o|3L|1P2|1V|2p|1P3|3M", "o|3L|1P5|1V|2p|1P6|3M", "o|3L|1P8|1T|2p|1P9|3M", "o|3L|1PJ|1V|2p|1PK|3M", "o|3L|1PM|1T|2p|1PN|3M", "The code value of the input.", "o|3Q|3a|1T|2p|1Q3", "The code value reflecting the user's in-progress edits.", "o|3Q|ef|1T|2p|1Q5", "The current code as a plain text string.", "o|3Q|1T|1T|2p|1Q7", "a|3N|3O|3P|1Pv|1Pw|1Px|1Py|1Pz|1Q0|1Q1|1Q2|3T|3U|3V|3W|3Z|eV|eY|1Q4|1Q6|1Q8", "An interactive DoenetML code editor", "o|F|9N|9U|9V|9X|1Pu|1Q9|3M|3M|2p|9N|1QA|AT", "Variable used when comparing factored expressions.", "o|33|H1|1QC|Pw|H3", "restrictDivision", "Whether to disallow dividing through to match factored forms.", "o|2m|1QE|1QF|2p|2s|1V", "monomialFactorMustMatch", "Whether monomial factors must match exactly (implies restrictDivision).", "o|2m|1QH|1QI|2p|2s|1V", "allowOnlySignDifferences", "Whether to count factorizations as equivalent when they differ only by sign.", "o|2m|1QK|1QL|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1QD|1QG|1QJ|1QM", "Whether the input math expressions share the same factoring.", "o|3Q|3a|1V|2p|1QO", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|3T|3U|3V|3W|3Z|1QP|CW", "Boolean condition that tests for equivalent factoring", "o|F|2R|3j|3k|3l|1QN|1QQ|3M|2p|2p|2R|1QR|3h", "position", "Position of the legend on the graph.", "a|5c|5d|5e|5f", "Place the legend in the upper-right corner.", "o|3s|5c|1QW", "Place the legend in the upper-left corner.", "o|3s|5d|1QY", "Place the legend in the lower-right corner.", "o|3s|5e|1Qa", "Place the legend in the lower-left corner.", "o|3s|5f|1Qc", "a|1QX|1QZ|1Qb|1Qd", "o|Bi|1QT|1QU|5c|1QV|1Qe|3y", "displayClosedSwatches", "Whether to render closed/filled swatches in the legend.", "o|2m|1Qg|1Qh|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1Qf|1Qi", "o|3L|1QT|1T|2p|1QU|3M", "o|3L|1Qg|1V|2p|1Qh|3M", "a|3N|3O|3P|Hd|QD|7s|QE|1Qk|1Ql|3T|3U|3V|3W|3Z|Hk", "A legend describing the contents of a graph", "o|F|9O|Om|On|Op|1Qj|1Qm|3M|2p|2p|9O|1Qn|Az", "o|3Q|3a|2S|2p|80", "a|3N|3O|3P|7r|6I|7s|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|7v|7x|7z|1Qp", "A label for an input, answer, button, or graphical object", "o|F|2S|2Z|2a|3l|7q|1Qq|3M|3M|2p|2S|1Qr|3h", "pattern", "Math expression pattern to match against.", "o|2h|1Qt|1Qu|1X", "allowImplicitIdentities", "Whether to allow implicit identity transformations when matching.", "o|2m|1Qw|1Qx|2p|2s|1V", "allowPermutations", "Whether to allow permutations of operands when matching.", "o|2m|1Qz|1R0|3M|2s|1V", "requireNumericMatches", "Whether numeric placeholders must match numbers.", "o|2m|1R2|1R3|2p|2s|1V", "requireVariableMatches", "Whether variable placeholders must match variables.", "o|2m|1R5|1R6|2p|2s|1V", "excludeMatches", "Patterns whose matches are excluded.", "o|33|1R8|1R9|54|1Y", "matchExpressionWithBlanks", "Whether to allow expressions with blanks to match.", "o|2m|1RB|1RC|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|Be|Bh|Bq|Bt|Bw|Bz|C2|C5|C8|CB|CE|CH|1Qv|1Qy|1R1|1R4|1R7|1RA|1RD", "o|3L|1Qw|1V|2p|1Qx|3M", "o|3L|1Qz|1V|2p|1R0|3M", "o|3L|1R2|1V|2p|1R3|3M", "o|3L|1R5|1V|2p|1R6|3M", "o|3L|1R8|1Y|2p|1R9|3M", "o|3L|1RB|1V|2p|1RC|3M", "Whether the input matches the pattern.", "o|3Q|3a|1V|2p|1RL", "numMatches", "The number of matches found.", "o|3Q|1RN|1p|2p|1RO", "patternMatches", "The list of matched sub-expressions.", "o|6v|1RQ|1X|3M|1RR|36|75", "a|3N|3O|3P|CJ|CK|CL|CM|CN|CO|CP|CQ|CR|CS|CT|CU|1RF|1RG|1RH|1RI|1RJ|1RK|3T|3U|3V|3W|3Z|1RM|CW|1RP|1RS", "Boolean condition that tests whether input matches a math pattern", "o|F|2T|3j|3k|3l|1RE|1RT|3M|3M|2p|2T|1RU|3h", "childContextHelp", "a|3|4|5|6|7|8|9|A|B|C|D|E|1RW", "a|93|1z|94", "020", "Value used for entries that aren't explicitly specified.", "o|33|e0|1Ra|Ng|1X", "Number of rows in the matrix.", "o|2h|7A|1Rc|1q", "Number of columns in the matrix.", "o|2h|7D|1Re|1q", "a|2j|2t|2w|2z|32|37|3A|3E|3H|3z|4J|4M|4T|4Y|4c|4g|4j|4m|1Ee|4s|4v|51|55|58|5B|5E|5K|5N|5R|5X|63|1Rb|1Rd|1Rf", "Whether matrix entries should be treated as unordered.", "o|3Q|4n|1V|2p|1Rh", "o|3Q|3a|2U|2p|6e", "a|3N|3O|3P|66|67|68|69|6A|6B|6C|6D|6E|6F|6G|6H|6I|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|6X|6Y|6Z|6a|6b|1Ri|1Rj|6h|6j|6m|6o|6q|6t|70|76|79|7C|7F|7J|7M|7P|7S|7V|7Y|7b", "A matrix of math values", "a|93|94", "matrixRow", "matrixColumn", "o|1Rm|1Rn|1Ro", "o|1RX|2U|1RY|1RZ|3l|1Rg|1Rk|3M|2p|2p|2U|1Rl|3h|1Rp", "a|2j|2t|2w|2z|32|37|3A|3E|3H|H8|4Y|4c|4g|4j", "numEigenvectors", "The number of eigenvectors found in the decomposition.", "o|3Q|1Rs|1q|2p|1Rt", "eigenvalues", "The eigenvalues of the matrix.", "o|6v|1Rv|1p|3M|1Rw|36|IR", "eigenvectors", "The eigenvectors of the matrix, as a 2D array (one column per eigenvalue).", "a|X0|6y", "o|Qc|1Ry|1p|3M|1Rz|4X|1S0|Qf", "a|3N|3O|3P|3T|3U|3V|3W|3Z|6X|6Y|6Z|6a|6b|1Ru|1Rx|1S1", "Computes the eigenvalues and eigenvectors of a square matrix", "o|F|9P|3j|3k|Ao|1Rr|1S2|3M|2p|2p|9P|1S3|Az", "a|H|I|J|L|M|N|Q|R|S|T|U|V|W|X|Y|Z|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|z|1L|1M|1O|1T|1U|1V|1W|1X|1Y|1Z|1a|1e|1o|1p|1q|1t|1u|1v|1z|21|24|25|26|27|28|29|2A|2B|2C|2D|2O|2R|2S|2T|2U|2V|2X|1A|1B|1C|1D|1E|1F|1G|1H|10|11|12|13|14|15|16|17|18|19|w|x|y|1J|1K|1N|1R|1S|1d|1f|1h|1i|1k|1r|1s|2K|2Q|2W|2Y|O|P", "1220111222222222111111111111111111111112210222022212221222212222211121222112111111111111111111222222222222222222201", "o|2m|JZ|Ja|3M|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|JY|5R|1S7|5X|63", "o|3Q|3a|2V|2p|fs", "The LaTeX content as a string.", "o|3Q|2V|2V|2p|1SA", "a|3N|3O|3P|Jd|6I|Je|6K|3T|3U|3V|3W|3Z|6N|6Q|6T|6W|1S9|Ji|Jk|Jm|Jp|Ju|Jx|K0|K2|K4|1SB", "A snippet of LaTeX that can be rendered as math", "o|F|2V|1S5|1S6|3l|1S8|1SC|3M|3M|2p|2V|1SD|3h", "A block-level quotation", "o|F|9Q|9U|9V|9X|3I|Aa|3M|3M|2p|9Q|1SF|AT", "Extra information about an enclosing component, shown to all users in a popup or disclosure", "o|F|2f|9U|9V|9X|3I|Aa|2p|3M|2p|2f|1SH|AT", "a|I|J|1z|2S|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|8Y|1J|1K|8Z|1O|1X|1Y|1Z|1b|1d|1e|1f|8n|8o|8p|8q|8r|8s|8t|8u|8v|8w|1h|1i|1r|1s|1t|1u|1w|1x|99|1y|21|22|23|24|29|2A|2I|2K|2L|2M|2O|2P|2Q|9K|9L|9M|9O|2U|9R|2W|2X|2Y", "112022222222222222222222222222111122222121111111111111222222122222222122221111121222", "Whether the snapping threshold is interpreted relative to graph scales.", "o|2m|194|1SL|2p|2s|1V", "Distance threshold within which group members snap together.", "o|2h|E6|1SN|1p", "angleThreshold", "Angular distance within which group members snap together.", "n|0.:7C4pdy2qXy", "o|33|1SP|1SQ|1SR|1p", "a|2j|2t|2w|2z|32|37|3A|3E|3H|GH|Or|7p|Ot|1SM|1SO|1SS", "o|3L|194|1V|2p|1SL|3M", "o|3L|1SP|1p|2p|1SQ|3M", "Distance within which group members attract each other.", "o|3Q|E6|1p|2p|1SW", "a|3N|3O|3P|Hd|QD|7s|QE|1SU|1SV|3T|3U|3V|3W|3Z|Hk|T4|1SX", "Constrains group members to attract to each other when nearby", "o|F|9R|1SJ|1SK|Op|1ST|1SY|3M|2p|2p|9R|1SZ|Az", "a|8J", "_blockScoredComponent", "a|1Sc|9W|2d", "maxNumColumns", "Maximum number of columns when arranging child problems.", "o|33|1Se|1Sf|4X|1q", "mode", "Arrangement mode for the child problems.", "circuit", "a|9S|1Sj", "Interleaved arrangement where each problem's answer feeds the next and one can start with any problem.", "o|3s|9S|1Sl", "A variant of the pretzel where one must start with the first problem.", "o|3s|1Sj|1Sn", "a|1Sm|1So", "o|Bi|1Sh|1Si|9S|1Sk|1Sp|3y", "a|2j|2t|2w|2z|32|37|3A|3E|3H|pN|pQ|pT|pV|pX|pZ|pc|pe|pg|pj|pk|1Sg|1Sq", "o|3L|1Se|1q|2p|1Sf|3M", "o|3L|1Sh|1T|2p|1Si|3M", "numProblems", "The number of child problems.", "o|3Q|1Su|1q|2p|1Sv", "The current responses across all child problems.", "o|6v|re|1T|3M|1Sx|36|Jt", "The number of responses submitted.", "o|3Q|rk|1p|2p|1Sz", "The most recently submitted responses.", "o|6v|rn|1T|3M|1T1|36|Jt", "a|3N|3O|3P|qs|qt|qu|qv|qw|qx|qy|qz|r0|1Ss|1St|3T|3V|3W|3Z|rL|rO|rR|rT|rV|rX|1Sw|1Sy|1T0|1T2", "A response-matching component where students enter a sequence to match statements and answers", "o|F|9S|1Sb|Nf|1Sd|1Sr|1T3|3M|2p|2p|9S|1T4|AT", "o|2m|L8|L9|3M|2s|1V", "hideFutureSections", "Whether to hide later cascade sections until previous ones are completed.", "o|2m|1T7|1T8|2p|2s|1V", "revealAll", "Whether all cascade entries should be revealed regardless of progress.", "o|2m|1TA|1TB|2p|2s|1V", "boxAll", "Whether to draw boxes around all cascade entries regardless of progress.", "o|2m|1TD|1TE|2p|2s|1V", "a|2j|2t|2w|2z|32|37|3A|3E|3H|9b|9e|9h|9l|9o|9r|9u|9y|A2|A5|L1|L4|L7|1T6|LD|LG|LI|LL|LO|LR|N1|LV|LZ|Lc|Lg|Lk|Ln|1T9|1TC|1TF", "o|3L|1T7|1V|2p|1T8|3M", "o|3Q|20|1V|2p|LH", "numCompleted", "The number of cascade sections currently completed.", "o|3Q|1TJ|1q|2p|1TK", "a|3N|3O|3P|A7|A8|A9|AA|AB|AC|Ls|Lt|Lu|Lv|Lw|Ly|1TH|3T|3U|3V|3W|3Z|AF|AI|AK|AN|AQ|M1|M4|M6|M9|1TI|1TL", "Sectional component that reveals its children step-by-step", "o|F|9T|Ku|Kv|N8|1TG|1TM|3M|3M|2p|9T|1TN|AT", "The short description text.", "o|3Q|3a|dd|2p|1TP", "a|3N|3O|3P|3T|3U|3V|3W|3Z|1TQ|3e", "A short accessibility description (e.g. for a `<graph>`) read by screen readers", "o|F|dd|2Z|2a|2e|3I|1TR|2p|3M|2p|dd|1TS|3h", "a|H|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|1J|1O|1X|1Y|1Z|1d|1e|1h|1t|1u|1z|21|24|29|2A|2K|2O|2U|2W|2X|2Y|L|M|N|Q|w|x|y|z|1K|1L|1M|1N|1R|1S|1T|1U|1a|1f|1i|1k|1o|1p|1q|1r|1s|1v|25|26|27|28|2B|2C|2D|2Q|2V", "1111111111111111111111111022012122212111122222222222222222222222222222222222222", "Whether the order of points in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1TW|2p|2s|1V", "Maximum number of points to retain in the list.", "o|33|g7|1TY|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1TX|1TZ|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1TY|3M", "The number of points in the list.", "o|3Q|Ps|1p|2p|1Tc", "o|3Q|gI|1p|2p|1Tc", "a|3N|3O|1Tb|3Z|gy|1Td|1Te", "A list of points", "o|F|2W|1TU|1TV|g0|1Ta|1Tf|3M|3M|2p|2W|1Tg|Az", "a|1t|1z|2X|H|L|M|N|Q|a|b|c|d|e|f|g|h|i|j|k|l|m|n|o|p|q|r|s|t|u|v|w|x|y|z|1J|1K|1L|1M|1N|1O|1R|1S|1T|1U|1X|1Y|1Z|1a|1d|1e|1f|1h|1i|1k|1o|1p|1q|1r|1s|1u|1v|21|24|25|26|27|28|29|2A|2B|2C|2D|2K|2O|2Q|2U|2V|2W|2Y", "0221222211111111111111111111112222222221222202222122222222222212222212222121222", "Whether the order of intervals in this list should be treated as unordered (e.g. for matching).", "o|2m|4n|1Tk|2p|2s|1V", "Maximum number of intervals to retain in the list.", "o|33|g7|1Tm|9k|1p", "a|2j|2t|2w|g2|32|37|g4|3E|3H|1Tl|1Tn|gB|gn|go|gp|gq|gr", "o|3L|g7|1p|2p|1Tm|3M", "numIntervals", "The number of intervals in the list.", "o|3Q|1Tq|1p|2p|1Tr", "o|3Q|gI|1p|2p|1Tr", "a|3N|3O|1Tp|3Z|gy|1Ts|1Tt", "A list of intervals", "o|F|2X|1Ti|1Tj|g0|1To|1Tu|3M|3M|2p|2X|1Tv|Az", "a|2j|2t|2w|g2|32|37|g4|3E|3H|mk|mm|gB|gn|go|gp|gq|gr", "a|3N|3O|n8|3Z|gy|nD|nE", "A list of vectors", "o|F|2Y|mh|mi|g0|1Tx|1Ty|3M|3M|2p|2Y|1Tz|Az", "a|3i|7e|84|88|AU|AW|AY|Ac|Ae|Am|B0|BD|BF|BL|BQ|BS|BX|Cb|Ck|Cm|Co|Cq|Cs|Cz|D1|DD|DT|DX|Dm|Dq|E5|EE|EJ|EN|ER|EV|EZ|Ed|Eh|Eq|Eu|Ey|F2|F6|FA|FE|FI|Fn|J9|JB|JU|K7|KE|KG|KI|KK|KM|KO|KQ|KS|KU|KW|Kd|Kf|Kh|Kj|Kl|Kn|Kp|Kr|MC|ME|MG|MK|MS|MW|Md|Mf|Mh|Mj|Ml|Mn|Mp|Mr|Mt|Mv|N7|ND|NF|NP|NR|NW|Ol|RI|TU|Us|Xe|Yf|Z8|ZQ|ZY|Zi|a4|aC|bu|cl|co|cq|cs|cu|cw|d1|dE|dc|eo|fK|fW|fY|fp|fw|gN|gP|gU|gf|gj|h7|h9|hJ|hW|hu|hy|i5|i9|if|j6|jC|jk|jp|kJ|lC|m1|mS|mW|mg|nH|oT|pH|s8|ss|t5|u0|uU|us|vp|wK|wm|wr|10d|10g|111|117|11J|11Q|11e|127|137|14Q|155|15d|15l|15v|16s|17B|17U|17k|17n|187|18X|18g|191|19B|19L|19P|19W|19Y|19g|19o|19v|1AG|1Ao|1B1|1BI|1C3|1CO|1D6|1DI|1Dm|1E2|1Ed|1FG|1Hg|1IY|1Ih|1Io|1J4|1JD|1JF|1JH|1Jl|1KT|1Km|1Kv|1LL|1LP|1LR|1LV|1Ld|1Li|1Ls|1MF|1MK|1Mj|1NG|1NX|1Nu|1O7|1OM|1OZ|1Oo|1QB|1QS|1Qo|1Qs|1RV|1Rq|1S4|1SE|1SG|1SI|1Sa|1T5|1TO|1TT|1Th|1Tw|1U0", "a|1Rn|1Ro", "displayName", "a|3|7|8|C|D|4|5|6|A|1U3|156", "row_matrix", "A list of math values defining the row of a matrix", "in a matrix", "o|1U4|1Rn|gw|h5|1U5|1U6|3j|3k|g0|3M|93|1U7", "column_matrix", "A list of math values defining the column of a matrix", "o|1U4|1Ro|gw|h5|1U9|1UA|3j|3k|g0|3M|94|1U7", "o|1U2|1U8|1UB", "o|2|1U1|1UC"], "1UD"]);
const elements = doenetSchema.elements;
const BLOCK_OVERRIDES = /* @__PURE__ */ new Set(["title", "choice"]);
const OTHER_BLOCK_NAMES = /* @__PURE__ */ new Set([
  // List / tabular structural
  "li",
  "row",
  "cell",
  "cellBlock",
  "column",
  // Case-like / answer-like branches
  "case",
  "else",
  "award",
  "option",
  // Top-level structural
  "document",
  "module",
  "moduleAttributes",
  "setup",
  // Top-level config / definition blocks
  "feedbackDefinition",
  "styleDefinition",
  "variantControl",
  "considerAsResponses",
  // Conditional container
  "conditionalContent",
  // Graph legend
  "legend",
  // Graph children — each on its own line inside <graph>
  "point",
  "line",
  "lineSegment",
  "ray",
  "vector",
  "curve",
  "polygon",
  "polyline",
  "regularPolygon",
  "circle",
  "parabola",
  "rectangle",
  "angle",
  "triangle",
  "endpoint",
  "controlVectors",
  "pegboard",
  "stickyGroup",
  "bestFitLine",
  "cobwebPolyline",
  "equilibriumCurve",
  "equilibriumLine",
  "equilibriumPoint",
  "regionBetweenCurveXAxis",
  "regionBetweenCurves",
  "regionHalfPlane"
]);
const BLOCK_ELEMENTS_LOWER = new Set(
  [
    ...elements.filter(
      (e2) => e2.layoutCategory === "block" || e2.layoutCategory === "other" && OTHER_BLOCK_NAMES.has(e2.name)
    ).map((e2) => e2.name),
    ...BLOCK_OVERRIDES
  ].map((n2) => n2.toLowerCase())
);
const ALWAYS_BREAK_PARENTS_LOWER = new Set(
  [
    "document",
    "module",
    "section",
    "subsection",
    "subsubsection",
    "problem",
    "exercise",
    "exercises",
    "problems",
    "ol",
    "ul",
    "dl",
    "graph",
    "table",
    "tabular",
    "figure",
    "spreadsheet",
    "codeEditor",
    "paragraphs",
    "setup",
    "moduleAttributes"
  ].map((n2) => n2.toLowerCase())
);
function isBlock(name2) {
  return BLOCK_ELEMENTS_LOWER.has(name2.toLowerCase());
}
function isAlwaysBreakParent(name2) {
  return ALWAYS_BREAK_PARENTS_LOWER.has(name2.toLowerCase());
}
const DEFINITIONAL_CONTAINERS_LOWER = new Set(
  ["setup", "moduleAttributes"].map((n2) => n2.toLowerCase())
);
function isDefinitionalContainer(name2) {
  return DEFINITIONAL_CONTAINERS_LOWER.has(name2.toLowerCase());
}
function isElement(node) {
  return node && node.type === "element";
}
function isText(node) {
  return node && node.type === "text";
}
function hasBlankLineBefore(node) {
  return !!node?.data?.prettyBlankLineBefore;
}
function mark(node) {
  (node.data ??= {}).prettyBlankLineBefore = true;
}
const TRAILING_BLANK_LINE = /\n[^\S\n]*\n[^\S\n]*$/;
const LEADING_BLANK_LINE = /^[^\S\n]*\n[^\S\n]*\n/;
const markBlankLinesPlugin = function() {
  return (root2) => {
    visit$1(root2, (node) => {
      if (!isElement(node) && node.type !== "root") {
        return;
      }
      const children = node.children;
      if (!children) return;
      for (let i2 = 1; i2 < children.length; i2++) {
        const prev = children[i2 - 1];
        const curr = children[i2];
        if (isText(prev) && prev.value.trim().length === 0 && /\n[^\S\n]*\n/.test(prev.value)) {
          mark(curr);
          continue;
        }
        if (isText(prev) && prev.value.trim().length > 0 && isElement(curr) && isBlock(curr.name) && TRAILING_BLANK_LINE.test(prev.value)) {
          mark(curr);
          prev.value = prev.value.replace(
            TRAILING_BLANK_LINE,
            ""
          );
          continue;
        }
        if (isText(curr) && curr.value.trim().length > 0 && isElement(prev) && isBlock(prev.name) && LEADING_BLANK_LINE.test(curr.value)) {
          mark(curr);
          curr.value = curr.value.replace(LEADING_BLANK_LINE, "");
          continue;
        }
      }
    });
  };
};
const mergeAdjacentTextPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node) => {
      if (!("children" in node)) {
        return;
      }
      const children = node.children;
      let prevNode = null;
      let needsMerging = false;
      for (const n2 of children) {
        if (prevNode && prevNode.type === "text" && n2.type === "text") {
          needsMerging = true;
          break;
        }
        prevNode = n2;
      }
      if (!needsMerging) {
        return;
      }
      prevNode = null;
      const newChildren = [];
      for (const n2 of children) {
        if (!prevNode) {
          newChildren.push(n2);
          prevNode = n2;
          continue;
        }
        if (prevNode.type === "text" && n2.type === "text") {
          prevNode.value += n2.value;
          continue;
        }
        newChildren.push(n2);
        prevNode = n2;
      }
      node.children = newChildren;
      return node;
    });
  };
};
const PRE_ELEMENTS = /* @__PURE__ */ new Set([
  "cline",
  "input",
  "output",
  "prompt",
  "pre"
]);
const INDENTABLE_PRE_ELEMENTS = /* @__PURE__ */ new Set([
  "latex-image",
  "latex-image-preamble",
  "macros",
  "asymptote"
]);
const mergeWhitespacePlugin = function() {
  return (root2) => {
    visit$1(root2, (node, info) => {
      if (isElement(node) && (PRE_ELEMENTS.has(node.name) || INDENTABLE_PRE_ELEMENTS.has(node.name))) {
        return SKIP$1;
      }
      if (!isText(node)) {
        return;
      }
      node.value = normalizeWhitespace(node.value);
    });
  };
};
function normalizeWhitespace(str) {
  str = str.replace(/[^\S\r\n]*\n[^\S\r\n]*/g, "\n");
  let parts = str.split(/\n\n+/);
  parts = parts.map((part) => part.replace(/([^\S\r\n]|\n(?!\n))+/g, " "));
  str = parts.join("\n\n");
  return str;
}
const removeEmptyTextNodesPlugin = function() {
  return (root2) => {
    replaceNode(root2, (node) => {
      if (!isText(node)) {
        return;
      }
      if (!node.value) {
        return null;
      }
    });
  };
};
const removeInternodeWhitespacePlugin = function() {
  return (root2) => {
    replaceNode(root2, (node, info) => {
      const parent = info.parents[0];
      if (!isText(node) || node.value.trim().length > 0 || PRE_ELEMENTS.has(parent?.name)) {
        return;
      }
      const containingArray = info.containingArray;
      const index2 = info.index;
      if (!containingArray || index2 == null) {
        return;
      }
      const prevNode = containingArray[index2 - 1];
      const nextNode = containingArray[index2 + 1];
      if (isElement(prevNode) && isBlock(prevNode.name) || isElement(nextNode) && isBlock(nextNode.name)) {
        return null;
      }
    });
  };
};
const trimWhitespacePlugin = function() {
  return (root2) => {
    visit$1(root2, (node) => {
      if (node.type === "element") {
        if (!isBlock(node.name) || PRE_ELEMENTS.has(node.name) || INDENTABLE_PRE_ELEMENTS.has(node.name)) {
          return;
        }
      } else if (node.type !== "root") {
        return;
      }
      const firstChild = node.children[0];
      const lastChild = node.children[node.children.length - 1];
      if (firstChild?.type === "text") {
        firstChild.value = firstChild.value.trimStart();
      }
      if (lastChild?.type === "text") {
        lastChild.value = lastChild.value.trimEnd();
      }
    });
  };
};
const normalizeDoenetMlPlugin = function() {
  const processor = unified().use(expandCdataPlugin).use(mergeAdjacentTextPlugin).use(mergeWhitespacePlugin).use(markBlankLinesPlugin).use(removeInternodeWhitespacePlugin).use(trimWhitespacePlugin).use(removeEmptyTextNodesPlugin);
  return (root2, file) => {
    const processed = processor.runSync(root2, file);
    return processed;
  };
};
function normalize(root2) {
  const processor = unified().use(normalizeDoenetMlPlugin);
  return processor.runSync(root2);
}
var __defProp = Object.defineProperty;
var __export = (target, all2) => {
  for (var name2 in all2)
    __defProp(target, name2, { get: all2[name2], enumerable: true });
};
var public_exports = {};
__export(public_exports, {
  builders: () => builders,
  printer: () => printer,
  utils: () => utils
});
var OPTIONAL_OBJECT = 1;
var createMethodShim = (methodName, getImplementation) => (flags, object2, ...arguments_) => {
  if (flags | OPTIONAL_OBJECT && (object2 === void 0 || object2 === null)) {
    return;
  }
  const implementation = getImplementation.call(object2) ?? object2[methodName];
  return implementation.apply(object2, arguments_);
};
function stringOrArrayAt(index2) {
  return this[index2 < 0 ? this.length + index2 : index2];
}
var at = /* @__PURE__ */ createMethodShim("at", function() {
  if (Array.isArray(this) || typeof this === "string") {
    return stringOrArrayAt;
  }
});
var method_at_default = at;
var noop = () => {
};
var noop_default = noop;
var DOC_TYPE_STRING = (
  /** @type {const} */
  "string"
);
var DOC_TYPE_ARRAY = (
  /** @type {const} */
  "array"
);
var DOC_TYPE_CURSOR = (
  /** @type {const} */
  "cursor"
);
var DOC_TYPE_INDENT = (
  /** @type {const} */
  "indent"
);
var DOC_TYPE_ALIGN = (
  /** @type {const} */
  "align"
);
var DOC_TYPE_TRIM = (
  /** @type {const} */
  "trim"
);
var DOC_TYPE_GROUP = (
  /** @type {const} */
  "group"
);
var DOC_TYPE_FILL = (
  /** @type {const} */
  "fill"
);
var DOC_TYPE_IF_BREAK = (
  /** @type {const} */
  "if-break"
);
var DOC_TYPE_INDENT_IF_BREAK = (
  /** @type {const} */
  "indent-if-break"
);
var DOC_TYPE_LINE_SUFFIX = (
  /** @type {const} */
  "line-suffix"
);
var DOC_TYPE_LINE_SUFFIX_BOUNDARY = (
  /** @type {const} */
  "line-suffix-boundary"
);
var DOC_TYPE_LINE = (
  /** @type {const} */
  "line"
);
var DOC_TYPE_LABEL = (
  /** @type {const} */
  "label"
);
var DOC_TYPE_BREAK_PARENT = (
  /** @type {const} */
  "break-parent"
);
var VALID_OBJECT_DOC_TYPES = /* @__PURE__ */ new Set([
  DOC_TYPE_CURSOR,
  DOC_TYPE_INDENT,
  DOC_TYPE_ALIGN,
  DOC_TYPE_TRIM,
  DOC_TYPE_GROUP,
  DOC_TYPE_FILL,
  DOC_TYPE_IF_BREAK,
  DOC_TYPE_INDENT_IF_BREAK,
  DOC_TYPE_LINE_SUFFIX,
  DOC_TYPE_LINE_SUFFIX_BOUNDARY,
  DOC_TYPE_LINE,
  DOC_TYPE_LABEL,
  DOC_TYPE_BREAK_PARENT
]);
function trimNewlinesEnd(string2) {
  let end = string2.length;
  while (end > 0 && (string2[end - 1] === "\r" || string2[end - 1] === "\n")) {
    end--;
  }
  return end < string2.length ? string2.slice(0, end) : string2;
}
function getOrInsertComputed(map2, key, callback) {
  if (!map2.has(key)) {
    const value = callback(key);
    map2.set(key, value);
  }
  return map2.get(key);
}
function getDocType(doc2) {
  if (typeof doc2 === "string") {
    return DOC_TYPE_STRING;
  }
  if (Array.isArray(doc2)) {
    return DOC_TYPE_ARRAY;
  }
  if (!doc2) {
    return;
  }
  const { type } = doc2;
  if (VALID_OBJECT_DOC_TYPES.has(type)) {
    return type;
  }
}
var get_doc_type_default = getDocType;
var disjunctionListFormat = (list2) => new Intl.ListFormat("en-US", { type: "disjunction" }).format(list2);
function getDocErrorMessage(doc2) {
  const type = doc2 === null ? "null" : typeof doc2;
  if (type !== "string" && type !== "object") {
    return `Unexpected doc '${type}', 
Expected it to be 'string' or 'object'.`;
  }
  if (get_doc_type_default(doc2)) {
    throw new Error("doc is valid.");
  }
  const objectType = Object.prototype.toString.call(doc2);
  if (objectType !== "[object Object]") {
    return `Unexpected doc '${objectType}'.`;
  }
  const EXPECTED_TYPE_VALUES = disjunctionListFormat(
    [...VALID_OBJECT_DOC_TYPES].map((type2) => `'${type2}'`)
  );
  return `Unexpected doc.type '${doc2.type}'.
Expected it to be ${EXPECTED_TYPE_VALUES}.`;
}
var InvalidDocError = class extends Error {
  name = "InvalidDocError";
  constructor(doc2) {
    super(getDocErrorMessage(doc2));
    this.doc = doc2;
  }
};
var invalid_doc_error_default = InvalidDocError;
var traverseDocOnExitStackMarker = {};
function traverseDoc(doc2, onEnter, onExit, shouldTraverseConditionalGroups) {
  const docsStack = [doc2];
  while (docsStack.length > 0) {
    const doc22 = docsStack.pop();
    if (doc22 === traverseDocOnExitStackMarker) {
      onExit(docsStack.pop());
      continue;
    }
    if (onExit) {
      docsStack.push(doc22, traverseDocOnExitStackMarker);
    }
    const docType = get_doc_type_default(doc22);
    if (!docType) {
      throw new invalid_doc_error_default(doc22);
    }
    if (onEnter?.(doc22) === false) {
      continue;
    }
    switch (docType) {
      case DOC_TYPE_ARRAY:
      case DOC_TYPE_FILL: {
        const parts = docType === DOC_TYPE_ARRAY ? doc22 : doc22.parts;
        for (let ic = parts.length, i2 = ic - 1; i2 >= 0; --i2) {
          docsStack.push(parts[i2]);
        }
        break;
      }
      case DOC_TYPE_IF_BREAK:
        docsStack.push(doc22.flatContents, doc22.breakContents);
        break;
      case DOC_TYPE_GROUP:
        if (shouldTraverseConditionalGroups && doc22.expandedStates) {
          for (let ic = doc22.expandedStates.length, i2 = ic - 1; i2 >= 0; --i2) {
            docsStack.push(doc22.expandedStates[i2]);
          }
        } else {
          docsStack.push(doc22.contents);
        }
        break;
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
      case DOC_TYPE_LINE_SUFFIX:
        docsStack.push(doc22.contents);
        break;
      case DOC_TYPE_STRING:
      case DOC_TYPE_CURSOR:
      case DOC_TYPE_TRIM:
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
      case DOC_TYPE_LINE:
      case DOC_TYPE_BREAK_PARENT:
        break;
      default:
        throw new invalid_doc_error_default(doc22);
    }
  }
}
var traverse_doc_default = traverseDoc;
function mapDoc(doc2, cb2) {
  if (typeof doc2 === "string") {
    return cb2(doc2);
  }
  const mapped = /* @__PURE__ */ new Map();
  return rec(doc2);
  function rec(doc22) {
    return getOrInsertComputed(mapped, doc22, process2);
  }
  function process2(doc22) {
    switch (get_doc_type_default(doc22)) {
      case DOC_TYPE_ARRAY:
        return cb2(doc22.map(rec));
      case DOC_TYPE_FILL:
        return cb2({
          ...doc22,
          parts: doc22.parts.map(rec)
        });
      case DOC_TYPE_IF_BREAK:
        return cb2({
          ...doc22,
          breakContents: rec(doc22.breakContents),
          flatContents: rec(doc22.flatContents)
        });
      case DOC_TYPE_GROUP: {
        let {
          expandedStates,
          contents
        } = doc22;
        if (expandedStates) {
          expandedStates = expandedStates.map(rec);
          contents = expandedStates[0];
        } else {
          contents = rec(contents);
        }
        return cb2({
          ...doc22,
          contents,
          expandedStates
        });
      }
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
      case DOC_TYPE_LINE_SUFFIX:
        return cb2({
          ...doc22,
          contents: rec(doc22.contents)
        });
      case DOC_TYPE_STRING:
      case DOC_TYPE_CURSOR:
      case DOC_TYPE_TRIM:
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
      case DOC_TYPE_LINE:
      case DOC_TYPE_BREAK_PARENT:
        return cb2(doc22);
      default:
        throw new invalid_doc_error_default(doc22);
    }
  }
}
function findInDoc(doc2, fn2, defaultValue2) {
  let result2 = defaultValue2;
  let shouldSkipFurtherProcessing = false;
  function findInDocOnEnterFn(doc22) {
    if (shouldSkipFurtherProcessing) {
      return false;
    }
    const maybeResult = fn2(doc22);
    if (maybeResult !== void 0) {
      shouldSkipFurtherProcessing = true;
      result2 = maybeResult;
    }
  }
  traverse_doc_default(doc2, findInDocOnEnterFn);
  return result2;
}
function willBreakFn(doc2) {
  if (doc2.type === DOC_TYPE_GROUP && doc2.break) {
    return true;
  }
  if (doc2.type === DOC_TYPE_LINE && doc2.hard) {
    return true;
  }
  if (doc2.type === DOC_TYPE_BREAK_PARENT) {
    return true;
  }
}
function willBreak(doc2) {
  return findInDoc(doc2, willBreakFn, false);
}
function breakParentGroup(groupStack) {
  if (groupStack.length > 0) {
    const parentGroup = method_at_default(
      /* OPTIONAL_OBJECT: false */
      0,
      groupStack,
      -1
    );
    if (!parentGroup.expandedStates && !parentGroup.break) {
      parentGroup.break = "propagated";
    }
  }
  return null;
}
function propagateBreaks(doc2) {
  const alreadyVisitedSet = /* @__PURE__ */ new Set();
  const groupStack = [];
  function propagateBreaksOnEnterFn(doc22) {
    if (doc22.type === DOC_TYPE_BREAK_PARENT) {
      breakParentGroup(groupStack);
    }
    if (doc22.type === DOC_TYPE_GROUP) {
      groupStack.push(doc22);
      if (alreadyVisitedSet.has(doc22)) {
        return false;
      }
      alreadyVisitedSet.add(doc22);
    }
  }
  function propagateBreaksOnExitFn(doc22) {
    if (doc22.type === DOC_TYPE_GROUP) {
      const group2 = groupStack.pop();
      if (group2.break) {
        breakParentGroup(groupStack);
      }
    }
  }
  traverse_doc_default(
    doc2,
    propagateBreaksOnEnterFn,
    propagateBreaksOnExitFn,
    /* shouldTraverseConditionalGroups */
    true
  );
}
function removeLinesFn(doc2) {
  if (doc2.type === DOC_TYPE_LINE && !doc2.hard) {
    return doc2.soft ? "" : " ";
  }
  if (doc2.type === DOC_TYPE_IF_BREAK) {
    return doc2.flatContents;
  }
  return doc2;
}
function removeLines(doc2) {
  return mapDoc(doc2, removeLinesFn);
}
function stripTrailingHardlineFromParts(parts) {
  parts = [...parts];
  while (parts.length >= 2 && method_at_default(
    /* OPTIONAL_OBJECT: false */
    0,
    parts,
    -2
  ).type === DOC_TYPE_LINE && method_at_default(
    /* OPTIONAL_OBJECT: false */
    0,
    parts,
    -1
  ).type === DOC_TYPE_BREAK_PARENT) {
    parts.length -= 2;
  }
  if (parts.length > 0) {
    const lastPart = stripTrailingHardlineFromDoc(method_at_default(
      /* OPTIONAL_OBJECT: false */
      0,
      parts,
      -1
    ));
    parts[parts.length - 1] = lastPart;
  }
  return parts;
}
function stripTrailingHardlineFromDoc(doc2) {
  switch (get_doc_type_default(doc2)) {
    case DOC_TYPE_INDENT:
    case DOC_TYPE_INDENT_IF_BREAK:
    case DOC_TYPE_GROUP:
    case DOC_TYPE_LINE_SUFFIX:
    case DOC_TYPE_LABEL: {
      const contents = stripTrailingHardlineFromDoc(doc2.contents);
      return {
        ...doc2,
        contents
      };
    }
    case DOC_TYPE_IF_BREAK:
      return {
        ...doc2,
        breakContents: stripTrailingHardlineFromDoc(doc2.breakContents),
        flatContents: stripTrailingHardlineFromDoc(doc2.flatContents)
      };
    case DOC_TYPE_FILL:
      return {
        ...doc2,
        parts: stripTrailingHardlineFromParts(doc2.parts)
      };
    case DOC_TYPE_ARRAY:
      return stripTrailingHardlineFromParts(doc2);
    case DOC_TYPE_STRING:
      return trimNewlinesEnd(doc2);
    case DOC_TYPE_ALIGN:
    case DOC_TYPE_CURSOR:
    case DOC_TYPE_TRIM:
    case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
    case DOC_TYPE_LINE:
    case DOC_TYPE_BREAK_PARENT:
      break;
    default:
      throw new invalid_doc_error_default(doc2);
  }
  return doc2;
}
function stripTrailingHardline(doc2) {
  return stripTrailingHardlineFromDoc(cleanDoc(doc2));
}
function cleanDocFn(doc2) {
  switch (get_doc_type_default(doc2)) {
    case DOC_TYPE_FILL: {
      const {
        parts
      } = doc2;
      if (parts.every((part) => part === "")) {
        return "";
      }
      if (parts.length === 1) {
        return parts[0];
      }
      break;
    }
    case DOC_TYPE_GROUP:
      if (!doc2.contents && !doc2.id && !doc2.break && !doc2.expandedStates) {
        return "";
      }
      if (doc2.contents.type === DOC_TYPE_GROUP && doc2.contents.id === doc2.id && doc2.contents.break === doc2.break && doc2.contents.expandedStates === doc2.expandedStates) {
        return doc2.contents;
      }
      break;
    case DOC_TYPE_ALIGN:
    case DOC_TYPE_INDENT:
    case DOC_TYPE_INDENT_IF_BREAK:
    case DOC_TYPE_LINE_SUFFIX:
      if (!doc2.contents) {
        return "";
      }
      break;
    case DOC_TYPE_IF_BREAK:
      if (!doc2.flatContents && !doc2.breakContents) {
        return "";
      }
      break;
    case DOC_TYPE_ARRAY: {
      const parts = [];
      for (const part of doc2) {
        if (!part) {
          continue;
        }
        const [currentPart, ...restParts] = Array.isArray(part) ? part : [part];
        if (typeof currentPart === "string" && typeof method_at_default(
          /* OPTIONAL_OBJECT: false */
          0,
          parts,
          -1
        ) === "string") {
          parts[parts.length - 1] += currentPart;
        } else {
          parts.push(currentPart);
        }
        parts.push(...restParts);
      }
      if (parts.length === 0) {
        return "";
      }
      if (parts.length === 1) {
        return parts[0];
      }
      return parts;
    }
    case DOC_TYPE_STRING:
    case DOC_TYPE_CURSOR:
    case DOC_TYPE_TRIM:
    case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
    case DOC_TYPE_LINE:
    case DOC_TYPE_LABEL:
    case DOC_TYPE_BREAK_PARENT:
      break;
    default:
      throw new invalid_doc_error_default(doc2);
  }
  return doc2;
}
function cleanDoc(doc2) {
  return mapDoc(doc2, (currentDoc) => cleanDocFn(currentDoc));
}
function replaceEndOfLine(doc2, replacement = literalline) {
  return mapDoc(doc2, (currentDoc) => typeof currentDoc === "string" ? join$1(replacement, currentDoc.split("\n")) : currentDoc);
}
function canBreakFn(doc2) {
  if (doc2.type === DOC_TYPE_LINE) {
    return true;
  }
}
function canBreak(doc2) {
  return findInDoc(doc2, canBreakFn, false);
}
var assertDocArray = noop_default;
function indent$1(contents) {
  return { type: DOC_TYPE_INDENT, contents };
}
function align(alignType, contents) {
  return { type: DOC_TYPE_ALIGN, contents, n: alignType };
}
function dedentToRoot(contents) {
  return align(Number.NEGATIVE_INFINITY, contents);
}
function markAsRoot(contents) {
  return align({ type: "root" }, contents);
}
function dedent(contents) {
  return align(-1, contents);
}
function addAlignmentToDoc(doc2, size2, tabWidth) {
  let aligned = doc2;
  if (size2 > 0) {
    for (let level = 0; level < Math.floor(size2 / tabWidth); ++level) {
      aligned = indent$1(aligned);
    }
    aligned = align(size2 % tabWidth, aligned);
    aligned = align(Number.NEGATIVE_INFINITY, aligned);
  }
  return aligned;
}
var breakParent$1 = { type: DOC_TYPE_BREAK_PARENT };
var cursor = { type: DOC_TYPE_CURSOR };
function fill$1(parts) {
  return { type: DOC_TYPE_FILL, parts };
}
function group$1(contents, options2 = {}) {
  assertDocArray(
    options2.expandedStates
  );
  return {
    type: DOC_TYPE_GROUP,
    id: options2.id,
    contents,
    break: Boolean(options2.shouldBreak),
    expandedStates: options2.expandedStates
  };
}
function conditionalGroup(states, options2) {
  return group$1(states[0], { ...options2, expandedStates: states });
}
function ifBreak(breakContents, flatContents = "", options2 = {}) {
  return {
    type: DOC_TYPE_IF_BREAK,
    breakContents,
    flatContents,
    groupId: options2.groupId
  };
}
function indentIfBreak(contents, options2) {
  return {
    type: DOC_TYPE_INDENT_IF_BREAK,
    contents,
    groupId: options2.groupId,
    negate: options2.negate
  };
}
function join$1(separator, docs) {
  const parts = [];
  for (let i2 = 0; i2 < docs.length; i2++) {
    if (i2 !== 0) {
      parts.push(separator);
    }
    parts.push(docs[i2]);
  }
  return parts;
}
function label(label2, contents) {
  return label2 ? { type: DOC_TYPE_LABEL, label: label2, contents } : contents;
}
var line$1 = { type: DOC_TYPE_LINE };
var softline$1 = { type: DOC_TYPE_LINE, soft: true };
var hardlineWithoutBreakParent = { type: DOC_TYPE_LINE, hard: true };
var hardline$1 = [hardlineWithoutBreakParent, breakParent$1];
var literallineWithoutBreakParent = {
  type: DOC_TYPE_LINE,
  hard: true,
  literal: true
};
var literalline = [literallineWithoutBreakParent, breakParent$1];
function lineSuffix(contents) {
  return { type: DOC_TYPE_LINE_SUFFIX, contents };
}
var lineSuffixBoundary = { type: DOC_TYPE_LINE_SUFFIX_BOUNDARY };
var trim = { type: DOC_TYPE_TRIM };
var stringReplaceAll = String.prototype.replaceAll ?? function(pattern, replacement) {
  if (pattern.global) {
    return this.replace(pattern, replacement);
  }
  return this.split(pattern).join(replacement);
};
var replaceAll = /* @__PURE__ */ createMethodShim("replaceAll", function() {
  if (typeof this === "string") {
    return stringReplaceAll;
  }
});
var method_replace_all_default = replaceAll;
var OPTION_CR = "cr";
var OPTION_CRLF = "crlf";
var CHARACTER_CR = "\r";
var CHARACTER_CRLF = "\r\n";
var CHARACTER_LF = "\n";
var DEFAULT_EOL = CHARACTER_LF;
function convertEndOfLineOptionToCharacter(endOfLineOption) {
  return endOfLineOption === OPTION_CR ? CHARACTER_CR : endOfLineOption === OPTION_CRLF ? CHARACTER_CRLF : DEFAULT_EOL;
}
var emoji_regex_default = () => {
  return /[#*0-9]\uFE0F?\u20E3|[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u231A\u231B\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u25FE\u2600-\u2604\u260E\u2611\u2614\u2615\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u2648-\u2653\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u267F\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26AA\u26B0\u26B1\u26BD\u26BE\u26C4\u26C8\u26CF\u26D1\u26E9\u26F0-\u26F5\u26F7\u26F8\u26FA\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2757\u2763\u27A1\u2934\u2935\u2B05-\u2B07\u2B1B\u2B1C\u2B55\u3030\u303D\u3297\u3299]\uFE0F?|[\u261D\u270C\u270D](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\u270A\u270B](?:\uD83C[\uDFFB-\uDFFF])?|[\u23E9-\u23EC\u23F0\u23F3\u25FD\u2693\u26A1\u26AB\u26C5\u26CE\u26D4\u26EA\u26FD\u2705\u2728\u274C\u274E\u2753-\u2755\u2795-\u2797\u27B0\u27BF\u2B50]|\u26D3\uFE0F?(?:\u200D\uD83D\uDCA5)?|\u26F9(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\u2764\uFE0F?(?:\u200D(?:\uD83D\uDD25|\uD83E\uDE79))?|\uD83C(?:[\uDC04\uDD70\uDD71\uDD7E\uDD7F\uDE02\uDE37\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF5\uDFF7]\uFE0F?|[\uDF85\uDFC2\uDFC7](?:\uD83C[\uDFFB-\uDFFF])?|[\uDFC4\uDFCA](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDFCB\uDFCC](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDCCF\uDD8E\uDD91-\uDD9A\uDE01\uDE1A\uDE2F\uDE32-\uDE36\uDE38-\uDE3A\uDE50\uDE51\uDF00-\uDF20\uDF2D-\uDF35\uDF37-\uDF43\uDF45-\uDF4A\uDF4C-\uDF7C\uDF7E-\uDF84\uDF86-\uDF93\uDFA0-\uDFC1\uDFC5\uDFC6\uDFC8\uDFC9\uDFCF-\uDFD3\uDFE0-\uDFF0\uDFF8-\uDFFF]|\uDDE6\uD83C[\uDDE8-\uDDEC\uDDEE\uDDF1\uDDF2\uDDF4\uDDF6-\uDDFA\uDDFC\uDDFD\uDDFF]|\uDDE7\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEF\uDDF1-\uDDF4\uDDF6-\uDDF9\uDDFB\uDDFC\uDDFE\uDDFF]|\uDDE8\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDEE\uDDF0-\uDDF7\uDDFA-\uDDFF]|\uDDE9\uD83C[\uDDEA\uDDEC\uDDEF\uDDF0\uDDF2\uDDF4\uDDFF]|\uDDEA\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDED\uDDF7-\uDDFA]|\uDDEB\uD83C[\uDDEE-\uDDF0\uDDF2\uDDF4\uDDF7]|\uDDEC\uD83C[\uDDE6\uDDE7\uDDE9-\uDDEE\uDDF1-\uDDF3\uDDF5-\uDDFA\uDDFC\uDDFE]|\uDDED\uD83C[\uDDF0\uDDF2\uDDF3\uDDF7\uDDF9\uDDFA]|\uDDEE\uD83C[\uDDE8-\uDDEA\uDDF1-\uDDF4\uDDF6-\uDDF9]|\uDDEF\uD83C[\uDDEA\uDDF2\uDDF4\uDDF5]|\uDDF0\uD83C[\uDDEA\uDDEC-\uDDEE\uDDF2\uDDF3\uDDF5\uDDF7\uDDFC\uDDFE\uDDFF]|\uDDF1\uD83C[\uDDE6-\uDDE8\uDDEE\uDDF0\uDDF7-\uDDFB\uDDFE]|\uDDF2\uD83C[\uDDE6\uDDE8-\uDDED\uDDF0-\uDDFF]|\uDDF3\uD83C[\uDDE6\uDDE8\uDDEA-\uDDEC\uDDEE\uDDF1\uDDF4\uDDF5\uDDF7\uDDFA\uDDFF]|\uDDF4\uD83C\uDDF2|\uDDF5\uD83C[\uDDE6\uDDEA-\uDDED\uDDF0-\uDDF3\uDDF7-\uDDF9\uDDFC\uDDFE]|\uDDF6\uD83C\uDDE6|\uDDF7\uD83C[\uDDEA\uDDF4\uDDF8\uDDFA\uDDFC]|\uDDF8\uD83C[\uDDE6-\uDDEA\uDDEC-\uDDF4\uDDF7-\uDDF9\uDDFB\uDDFD-\uDDFF]|\uDDF9\uD83C[\uDDE6\uDDE8\uDDE9\uDDEB-\uDDED\uDDEF-\uDDF4\uDDF7\uDDF9\uDDFB\uDDFC\uDDFF]|\uDDFA\uD83C[\uDDE6\uDDEC\uDDF2\uDDF3\uDDF8\uDDFE\uDDFF]|\uDDFB\uD83C[\uDDE6\uDDE8\uDDEA\uDDEC\uDDEE\uDDF3\uDDFA]|\uDDFC\uD83C[\uDDEB\uDDF8]|\uDDFD\uD83C\uDDF0|\uDDFE\uD83C[\uDDEA\uDDF9]|\uDDFF\uD83C[\uDDE6\uDDF2\uDDFC]|\uDF44(?:\u200D\uD83D\uDFEB)?|\uDF4B(?:\u200D\uD83D\uDFE9)?|\uDFC3(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDFF3\uFE0F?(?:\u200D(?:\u26A7\uFE0F?|\uD83C\uDF08))?|\uDFF4(?:\u200D\u2620\uFE0F?|\uDB40\uDC67\uDB40\uDC62\uDB40(?:\uDC65\uDB40\uDC6E\uDB40\uDC67|\uDC73\uDB40\uDC63\uDB40\uDC74|\uDC77\uDB40\uDC6C\uDB40\uDC73)\uDB40\uDC7F)?)|\uD83D(?:[\uDC3F\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3]\uFE0F?|[\uDC42\uDC43\uDC46-\uDC50\uDC66\uDC67\uDC6B-\uDC6D\uDC72\uDC74-\uDC76\uDC78\uDC7C\uDC83\uDC85\uDC8F\uDC91\uDCAA\uDD7A\uDD95\uDD96\uDE4C\uDE4F\uDEC0\uDECC](?:\uD83C[\uDFFB-\uDFFF])?|[\uDC6E-\uDC71\uDC73\uDC77\uDC81\uDC82\uDC86\uDC87\uDE45-\uDE47\uDE4B\uDE4D\uDE4E\uDEA3\uDEB4\uDEB5](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD74\uDD90](?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?|[\uDC00-\uDC07\uDC09-\uDC14\uDC16-\uDC25\uDC27-\uDC3A\uDC3C-\uDC3E\uDC40\uDC44\uDC45\uDC51-\uDC65\uDC6A\uDC79-\uDC7B\uDC7D-\uDC80\uDC84\uDC88-\uDC8E\uDC90\uDC92-\uDCA9\uDCAB-\uDCFC\uDCFF-\uDD3D\uDD4B-\uDD4E\uDD50-\uDD67\uDDA4\uDDFB-\uDE2D\uDE2F-\uDE34\uDE37-\uDE41\uDE43\uDE44\uDE48-\uDE4A\uDE80-\uDEA2\uDEA4-\uDEB3\uDEB7-\uDEBF\uDEC1-\uDEC5\uDED0-\uDED2\uDED5-\uDED8\uDEDC-\uDEDF\uDEEB\uDEEC\uDEF4-\uDEFC\uDFE0-\uDFEB\uDFF0]|\uDC08(?:\u200D\u2B1B)?|\uDC15(?:\u200D\uD83E\uDDBA)?|\uDC26(?:\u200D(?:\u2B1B|\uD83D\uDD25))?|\uDC3B(?:\u200D\u2744\uFE0F?)?|\uDC41\uFE0F?(?:\u200D\uD83D\uDDE8\uFE0F?)?|\uDC68(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDC68\uDC69]\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?)|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFC-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFD-\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFD\uDFFF]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?\uDC68\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDD1D\uDEEF]\u200D\uD83D\uDC68\uD83C[\uDFFB-\uDFFE]|[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3])))?))?|\uDC69(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:\uDC8B\u200D\uD83D)?[\uDC68\uDC69]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?|\uDC69\u200D\uD83D(?:\uDC66(?:\u200D\uD83D\uDC66)?|\uDC67(?:\u200D\uD83D[\uDC66\uDC67])?))|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFC-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFD-\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFD\uDFFF]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D\uD83D(?:[\uDC68\uDC69]|\uDC8B\u200D\uD83D[\uDC68\uDC69])\uD83C[\uDFFB-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3]|\uDD1D\u200D\uD83D[\uDC68\uDC69]\uD83C[\uDFFB-\uDFFE]|\uDEEF\u200D\uD83D\uDC69\uD83C[\uDFFB-\uDFFE])))?))?|\uDD75(?:\uD83C[\uDFFB-\uDFFF]|\uFE0F)?(?:\u200D[\u2640\u2642]\uFE0F?)?|\uDE2E(?:\u200D\uD83D\uDCA8)?|\uDE35(?:\u200D\uD83D\uDCAB)?|\uDE36(?:\u200D\uD83C\uDF2B\uFE0F?)?|\uDE42(?:\u200D[\u2194\u2195]\uFE0F?)?|\uDEB6(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?)|\uD83E(?:[\uDD0C\uDD0F\uDD18-\uDD1F\uDD30-\uDD34\uDD36\uDD77\uDDB5\uDDB6\uDDBB\uDDD2\uDDD3\uDDD5\uDEC3-\uDEC5\uDEF0\uDEF2-\uDEF8](?:\uD83C[\uDFFB-\uDFFF])?|[\uDD26\uDD35\uDD37-\uDD39\uDD3C-\uDD3E\uDDB8\uDDB9\uDDCD\uDDCF\uDDD4\uDDD6-\uDDDD](?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDDDE\uDDDF](?:\u200D[\u2640\u2642]\uFE0F?)?|[\uDD0D\uDD0E\uDD10-\uDD17\uDD20-\uDD25\uDD27-\uDD2F\uDD3A\uDD3F-\uDD45\uDD47-\uDD76\uDD78-\uDDB4\uDDB7\uDDBA\uDDBC-\uDDCC\uDDD0\uDDE0-\uDDFF\uDE70-\uDE7C\uDE80-\uDE8A\uDE8E-\uDEC2\uDEC6\uDEC8\uDECD-\uDEDC\uDEDF-\uDEEA\uDEEF]|\uDDCE(?:\uD83C[\uDFFB-\uDFFF])?(?:\u200D(?:[\u2640\u2642]\uFE0F?(?:\u200D\u27A1\uFE0F?)?|\u27A1\uFE0F?))?|\uDDD1(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1|\uDDD1\u200D\uD83E\uDDD2(?:\u200D\uD83E\uDDD2)?|\uDDD2(?:\u200D\uD83E\uDDD2)?))|\uD83C(?:\uDFFB(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFC-\uDFFF])))?|\uDFFC(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFD-\uDFFF])))?|\uDFFD(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])))?|\uDFFE(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFD\uDFFF])))?|\uDFFF(?:\u200D(?:[\u2695\u2696\u2708]\uFE0F?|\u2764\uFE0F?\u200D(?:\uD83D\uDC8B\u200D)?\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE]|\uD83C[\uDF3E\uDF73\uDF7C\uDF84\uDF93\uDFA4\uDFA8\uDFEB\uDFED]|\uD83D(?:[\uDCBB\uDCBC\uDD27\uDD2C\uDE80\uDE92]|\uDC30\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])|\uD83E(?:[\uDDAF\uDDBC\uDDBD](?:\u200D\u27A1\uFE0F?)?|[\uDDB0-\uDDB3\uDE70]|\uDD1D\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFF]|\uDEEF\u200D\uD83E\uDDD1\uD83C[\uDFFB-\uDFFE])))?))?|\uDEF1(?:\uD83C(?:\uDFFB(?:\u200D\uD83E\uDEF2\uD83C[\uDFFC-\uDFFF])?|\uDFFC(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFD-\uDFFF])?|\uDFFD(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB\uDFFC\uDFFE\uDFFF])?|\uDFFE(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFD\uDFFF])?|\uDFFF(?:\u200D\uD83E\uDEF2\uD83C[\uDFFB-\uDFFE])?))?)/g;
};
var fullwidthMinimalCodePoint = 12288;
var fullwidthMaximumCodePoint = 65510;
var fullwidthRanges = [12288, 12288, 65281, 65376, 65504, 65510];
var wideMinimalCodePoint = 4352;
var wideMaximumCodePoint = 262141;
var wideRanges = [4352, 4447, 8986, 8987, 9001, 9002, 9193, 9196, 9200, 9200, 9203, 9203, 9725, 9726, 9748, 9749, 9776, 9783, 9800, 9811, 9855, 9855, 9866, 9871, 9875, 9875, 9889, 9889, 9898, 9899, 9917, 9918, 9924, 9925, 9934, 9934, 9940, 9940, 9962, 9962, 9970, 9971, 9973, 9973, 9978, 9978, 9981, 9981, 9989, 9989, 9994, 9995, 10024, 10024, 10060, 10060, 10062, 10062, 10067, 10069, 10071, 10071, 10133, 10135, 10160, 10160, 10175, 10175, 11035, 11036, 11088, 11088, 11093, 11093, 11904, 11929, 11931, 12019, 12032, 12245, 12272, 12287, 12289, 12350, 12353, 12438, 12441, 12543, 12549, 12591, 12593, 12686, 12688, 12773, 12783, 12830, 12832, 12871, 12880, 42124, 42128, 42182, 43360, 43388, 44032, 55203, 63744, 64255, 65040, 65049, 65072, 65106, 65108, 65126, 65128, 65131, 94176, 94180, 94192, 94198, 94208, 101589, 101631, 101662, 101760, 101874, 110576, 110579, 110581, 110587, 110589, 110590, 110592, 110882, 110898, 110898, 110928, 110930, 110933, 110933, 110948, 110951, 110960, 111355, 119552, 119638, 119648, 119670, 126980, 126980, 127183, 127183, 127374, 127374, 127377, 127386, 127488, 127490, 127504, 127547, 127552, 127560, 127568, 127569, 127584, 127589, 127744, 127776, 127789, 127797, 127799, 127868, 127870, 127891, 127904, 127946, 127951, 127955, 127968, 127984, 127988, 127988, 127992, 128062, 128064, 128064, 128066, 128252, 128255, 128317, 128331, 128334, 128336, 128359, 128378, 128378, 128405, 128406, 128420, 128420, 128507, 128591, 128640, 128709, 128716, 128716, 128720, 128722, 128725, 128728, 128732, 128735, 128747, 128748, 128756, 128764, 128992, 129003, 129008, 129008, 129292, 129338, 129340, 129349, 129351, 129535, 129648, 129660, 129664, 129674, 129678, 129734, 129736, 129736, 129741, 129756, 129759, 129770, 129775, 129784, 131072, 196605, 196608, 262141];
var isInRange = (ranges, codePoint) => {
  let low = 0;
  let high = Math.floor(ranges.length / 2) - 1;
  while (low <= high) {
    const mid = Math.floor((low + high) / 2);
    const i2 = mid * 2;
    if (codePoint < ranges[i2]) {
      high = mid - 1;
    } else if (codePoint > ranges[i2 + 1]) {
      low = mid + 1;
    } else {
      return true;
    }
  }
  return false;
};
var commonCjkCodePoint = 19968;
var [wideFastPathStart, wideFastPathEnd] = /* @__PURE__ */ findWideFastPathRange(wideRanges);
function findWideFastPathRange(ranges) {
  let fastPathStart = ranges[0];
  let fastPathEnd = ranges[1];
  for (let index2 = 0; index2 < ranges.length; index2 += 2) {
    const start = ranges[index2];
    const end = ranges[index2 + 1];
    if (commonCjkCodePoint >= start && commonCjkCodePoint <= end) {
      return [start, end];
    }
    if (end - start > fastPathEnd - fastPathStart) {
      fastPathStart = start;
      fastPathEnd = end;
    }
  }
  return [fastPathStart, fastPathEnd];
}
var isFullWidth = (codePoint) => {
  if (codePoint < fullwidthMinimalCodePoint || codePoint > fullwidthMaximumCodePoint) {
    return false;
  }
  return isInRange(fullwidthRanges, codePoint);
};
var isWide = (codePoint) => {
  if (codePoint >= wideFastPathStart && codePoint <= wideFastPathEnd) {
    return true;
  }
  if (codePoint < wideMinimalCodePoint || codePoint > wideMaximumCodePoint) {
    return false;
  }
  return isInRange(wideRanges, codePoint);
};
var narrowEmojiRegexp = /^(?:[\xA9\xAE\u203C\u2049\u2122\u2139\u2194-\u2199\u21A9\u21AA\u2328\u23CF\u23ED-\u23EF\u23F1\u23F2\u23F8-\u23FA\u24C2\u25AA\u25AB\u25B6\u25C0\u25FB\u25FC\u2600-\u2604\u260E\u2611\u2618\u2620\u2622\u2623\u2626\u262A\u262E\u262F\u2638-\u263A\u2640\u2642\u265F\u2660\u2663\u2665\u2666\u2668\u267B\u267E\u2692\u2694-\u2697\u2699\u269B\u269C\u26A0\u26A7\u26B0\u26B1\u26C8\u26CF\u26D1\u26D3\u26E9\u26F0\u26F1\u26F4\u26F7\u26F8\u2702\u2708\u2709\u270F\u2712\u2714\u2716\u271D\u2721\u2733\u2734\u2744\u2747\u2763\u2764\u27A1\u2934\u2935\u2B05-\u2B07]|\uD83C[\uDD70\uDD71\uDD7E\uDD7F\uDF21\uDF24-\uDF2C\uDF36\uDF7D\uDF96\uDF97\uDF99-\uDF9B\uDF9E\uDF9F\uDFCD\uDFCE\uDFD4-\uDFDF\uDFF3\uDFF5\uDFF7]|\uD83D[\uDC3F\uDC41\uDCFD\uDD49\uDD4A\uDD6F\uDD70\uDD73\uDD76-\uDD79\uDD87\uDD8A-\uDD8D\uDDA5\uDDA8\uDDB1\uDDB2\uDDBC\uDDC2-\uDDC4\uDDD1-\uDDD3\uDDDC-\uDDDE\uDDE1\uDDE3\uDDE8\uDDEF\uDDF3\uDDFA\uDECB\uDECD-\uDECF\uDEE0-\uDEE5\uDEE9\uDEF0\uDEF3])$/;
var isNarrowEmojiCharacter = (character) => narrowEmojiRegexp.test(character);
var notAsciiRegex = /[^\x20-\x7F]/;
function getStringWidth(text2) {
  if (!text2) {
    return 0;
  }
  if (!notAsciiRegex.test(text2)) {
    return text2.length;
  }
  let width = 0;
  text2 = text2.replace(emoji_regex_default(), (character) => {
    width += isNarrowEmojiCharacter(character) ? 1 : 2;
    return "";
  });
  for (const character of text2) {
    const codePoint = character.codePointAt(0);
    if (codePoint <= 31 || codePoint >= 127 && codePoint <= 159) {
      continue;
    }
    if (codePoint >= 768 && codePoint <= 879) {
      continue;
    }
    if (codePoint >= 65024 && codePoint <= 65039) {
      continue;
    }
    width += isFullWidth(codePoint) || isWide(codePoint) ? 2 : 1;
  }
  return width;
}
var get_string_width_default = getStringWidth;
var INDENT_COMMAND_TYPE_INDENT = 0;
var INDENT_COMMAND_TYPE_DEDENT = 1;
var INDENT_COMMAND_TYPE_WIDTH = 2;
var INDENT_COMMAND_TYPE_STRING = 3;
var INDENT_COMMAND_INDENT = { type: INDENT_COMMAND_TYPE_INDENT };
var INDENT_COMMAND_DEDENT = { type: INDENT_COMMAND_TYPE_DEDENT };
var ROOT_INDENT = {
  value: "",
  length: 0,
  queue: [],
  get root() {
    return ROOT_INDENT;
  }
};
function generateIndent(indent2, command2, options2) {
  const queue = command2.type === INDENT_COMMAND_TYPE_DEDENT ? indent2.queue.slice(0, -1) : [...indent2.queue, command2];
  let value = "";
  let length = 0;
  let lastTabs = 0;
  let lastSpaces = 0;
  for (const command22 of queue) {
    switch (command22.type) {
      case INDENT_COMMAND_TYPE_INDENT:
        flush();
        if (options2.useTabs) {
          addTabs(1);
        } else {
          addSpaces(options2.tabWidth);
        }
        break;
      case INDENT_COMMAND_TYPE_STRING: {
        const { string: string2 } = command22;
        flush();
        value += string2;
        length += string2.length;
        break;
      }
      case INDENT_COMMAND_TYPE_WIDTH: {
        const { width } = command22;
        lastTabs += 1;
        lastSpaces += width;
        break;
      }
      default:
        throw new Error(`Unexpected indent comment '${command22.type}'.`);
    }
  }
  flushSpaces();
  return { ...indent2, value, length, queue };
  function addTabs(count) {
    value += "	".repeat(count);
    length += options2.tabWidth * count;
  }
  function addSpaces(count) {
    value += " ".repeat(count);
    length += count;
  }
  function flush() {
    if (options2.useTabs) {
      flushTabs();
    } else {
      flushSpaces();
    }
  }
  function flushTabs() {
    if (lastTabs > 0) {
      addTabs(lastTabs);
    }
    resetLast();
  }
  function flushSpaces() {
    if (lastSpaces > 0) {
      addSpaces(lastSpaces);
    }
    resetLast();
  }
  function resetLast() {
    lastTabs = 0;
    lastSpaces = 0;
  }
}
function makeAlign(indent2, indentOptions, options2) {
  if (!indentOptions) {
    return indent2;
  }
  if (indentOptions.type === "root") {
    return { ...indent2, root: indent2 };
  }
  if (indentOptions === Number.NEGATIVE_INFINITY) {
    return indent2.root;
  }
  let command2;
  if (typeof indentOptions === "number") {
    if (indentOptions < 0) {
      command2 = INDENT_COMMAND_DEDENT;
    } else {
      command2 = { type: INDENT_COMMAND_TYPE_WIDTH, width: indentOptions };
    }
  } else {
    command2 = { type: INDENT_COMMAND_TYPE_STRING, string: indentOptions };
  }
  return generateIndent(indent2, command2, options2);
}
function makeIndent(indent2, options2) {
  return generateIndent(indent2, INDENT_COMMAND_INDENT, options2);
}
function getTrailingIndentionLength(text2) {
  let length = 0;
  for (let index2 = text2.length - 1; index2 >= 0; index2--) {
    const character = text2[index2];
    if (character === " " || character === "	") {
      length++;
    } else {
      break;
    }
  }
  return length;
}
function trimIndentation(text2) {
  const length = getTrailingIndentionLength(text2);
  const trimmed = length === 0 ? text2 : text2.slice(0, text2.length - length);
  return { text: trimmed, count: length };
}
var printResult = class {
  /** @type {string[]} */
  #settledTexts = [];
  #unsettledText = "";
  #settledTextLength = 0;
  /** @type {number[]} */
  #settledPositions = [];
  /** @type {number[]} */
  #unsettledPositions = [];
  #settle() {
    const text2 = this.#unsettledText;
    if (text2 !== "") {
      this.#settledTexts.push(text2);
      this.#settledTextLength += text2.length;
      this.#unsettledText = "";
    }
    for (const position2 of this.#unsettledPositions) {
      this.#settledPositions.push(Math.min(position2, this.#settledTextLength));
    }
    this.#unsettledPositions.length = 0;
  }
  markPosition() {
    if (this.#settledPositions.length + this.#unsettledPositions.length >= 2) {
      throw new Error("There are too many 'cursor' in doc.");
    }
    this.#unsettledPositions.push(
      this.#settledTextLength + this.#unsettledText.length
    );
  }
  /**
  @param {string} text
  */
  write(text2) {
    this.#unsettledText += text2;
  }
  trim() {
    const { text: trimmed, count } = trimIndentation(this.#unsettledText);
    this.#unsettledText = trimmed;
    this.#settle();
    return count;
  }
  finish() {
    this.#settle();
    return {
      text: this.#settledTexts.join(""),
      positions: this.#settledPositions
    };
  }
};
var print_result_default = printResult;
var MODE_BREAK = /* @__PURE__ */ Symbol("MODE_BREAK");
var MODE_FLAT = /* @__PURE__ */ Symbol("MODE_FLAT");
var DOC_FILL_PRINTED_LENGTH = /* @__PURE__ */ Symbol("DOC_FILL_PRINTED_LENGTH");
function fits(next, restCommands, remainingWidth, hasLineSuffix, groupModeMap, mustBeFlat) {
  if (remainingWidth === Number.POSITIVE_INFINITY) {
    return true;
  }
  let restCommandsIndex = restCommands.length;
  let hasPendingSpace = false;
  const commands = [next];
  let output = "";
  while (remainingWidth >= 0) {
    if (commands.length === 0) {
      if (restCommandsIndex === 0) {
        return true;
      }
      commands.push(restCommands[--restCommandsIndex]);
      continue;
    }
    const {
      mode,
      doc: doc2
    } = commands.pop();
    const docType = get_doc_type_default(doc2);
    switch (docType) {
      case DOC_TYPE_STRING:
        if (doc2) {
          if (hasPendingSpace) {
            output += " ";
            remainingWidth -= 1;
            hasPendingSpace = false;
          }
          output += doc2;
          remainingWidth -= get_string_width_default(doc2);
        }
        break;
      case DOC_TYPE_ARRAY:
      case DOC_TYPE_FILL: {
        const parts = docType === DOC_TYPE_ARRAY ? doc2 : doc2.parts;
        const end = doc2[DOC_FILL_PRINTED_LENGTH] ?? 0;
        for (let index2 = parts.length - 1; index2 >= end; index2--) {
          commands.push({
            mode,
            doc: parts[index2]
          });
        }
        break;
      }
      case DOC_TYPE_INDENT:
      case DOC_TYPE_ALIGN:
      case DOC_TYPE_INDENT_IF_BREAK:
      case DOC_TYPE_LABEL:
        commands.push({
          mode,
          doc: doc2.contents
        });
        break;
      case DOC_TYPE_TRIM: {
        const {
          text: text2,
          count
        } = trimIndentation(output);
        output = text2;
        remainingWidth += count;
        break;
      }
      case DOC_TYPE_GROUP: {
        if (mustBeFlat && doc2.break) {
          return false;
        }
        const groupMode = doc2.break ? MODE_BREAK : mode;
        const contents = doc2.expandedStates && groupMode === MODE_BREAK ? method_at_default(
          /* OPTIONAL_OBJECT: false */
          0,
          doc2.expandedStates,
          -1
        ) : doc2.contents;
        commands.push({
          mode: groupMode,
          doc: contents
        });
        break;
      }
      case DOC_TYPE_IF_BREAK: {
        const groupMode = doc2.groupId ? groupModeMap[doc2.groupId] || MODE_FLAT : mode;
        const contents = groupMode === MODE_BREAK ? doc2.breakContents : doc2.flatContents;
        if (contents) {
          commands.push({
            mode,
            doc: contents
          });
        }
        break;
      }
      case DOC_TYPE_LINE:
        if (mode === MODE_BREAK || doc2.hard) {
          return true;
        }
        if (!doc2.soft) {
          hasPendingSpace = true;
        }
        break;
      case DOC_TYPE_LINE_SUFFIX:
        hasLineSuffix = true;
        break;
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
        if (hasLineSuffix) {
          return false;
        }
        break;
    }
  }
  return false;
}
function printDocToString(doc2, options2) {
  const groupModeMap = /* @__PURE__ */ Object.create(null);
  const width = options2.printWidth;
  const newLine = convertEndOfLineOptionToCharacter(options2.endOfLine);
  let position2 = 0;
  const commands = [{
    indent: ROOT_INDENT,
    mode: MODE_BREAK,
    doc: doc2
  }];
  let shouldRemeasure = false;
  const lineSuffix2 = [];
  const result2 = new print_result_default();
  propagateBreaks(doc2);
  while (commands.length > 0) {
    const {
      indent: indent2,
      mode,
      doc: doc22
    } = commands.pop();
    switch (get_doc_type_default(doc22)) {
      case DOC_TYPE_STRING: {
        const formatted2 = newLine !== "\n" ? method_replace_all_default(
          /* OPTIONAL_OBJECT: false */
          0,
          doc22,
          "\n",
          newLine
        ) : doc22;
        if (formatted2) {
          result2.write(formatted2);
          if (commands.length > 0) {
            position2 += get_string_width_default(formatted2);
          }
        }
        break;
      }
      case DOC_TYPE_ARRAY:
        for (let index2 = doc22.length - 1; index2 >= 0; index2--) {
          commands.push({
            indent: indent2,
            mode,
            doc: doc22[index2]
          });
        }
        break;
      case DOC_TYPE_CURSOR:
        result2.markPosition();
        break;
      case DOC_TYPE_INDENT:
        commands.push({
          indent: makeIndent(indent2, options2),
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_ALIGN:
        commands.push({
          indent: makeAlign(indent2, doc22.n, options2),
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_TRIM:
        position2 -= result2.trim();
        break;
      case DOC_TYPE_GROUP: {
        const command2 = (function printGroup() {
          if (mode === MODE_FLAT && !shouldRemeasure) {
            return {
              indent: indent2,
              mode: doc22.break ? MODE_BREAK : MODE_FLAT,
              doc: doc22.contents
            };
          }
          shouldRemeasure = false;
          const remainingWidth = width - position2;
          const hasLineSuffix = lineSuffix2.length > 0;
          const flatCommand = {
            indent: indent2,
            mode: MODE_FLAT,
            doc: doc22.contents
          };
          if (!doc22.break && fits(flatCommand, commands, remainingWidth, hasLineSuffix, groupModeMap)) {
            return flatCommand;
          }
          if (!doc22.expandedStates) {
            return {
              indent: indent2,
              mode: MODE_BREAK,
              doc: doc22.contents
            };
          }
          if (!doc22.break) {
            for (let index2 = 1; index2 < doc22.expandedStates.length - 1; index2++) {
              const flatCommand2 = {
                indent: indent2,
                mode: MODE_FLAT,
                doc: doc22.expandedStates[index2]
              };
              if (fits(flatCommand2, commands, remainingWidth, hasLineSuffix, groupModeMap)) {
                return flatCommand2;
              }
            }
          }
          return {
            indent: indent2,
            mode: MODE_BREAK,
            doc: method_at_default(
              /* OPTIONAL_OBJECT: false */
              0,
              doc22.expandedStates,
              -1
            )
          };
        })();
        commands.push(command2);
        if (doc22.id) {
          groupModeMap[doc22.id] = command2.mode;
        }
        break;
      }
      // Fills each line with as much code as possible before moving to a new
      // line with the same indentation.
      //
      // Expects doc.parts to be an array of alternating content and
      // whitespace. The whitespace contains the linebreaks.
      //
      // For example:
      //   ["I", line, "love", line, "monkeys"]
      // or
      //   [{ type: group, ... }, softline, { type: group, ... }]
      //
      // It uses this parts structure to handle three main layout cases:
      // * The first two content items fit on the same line without
      //   breaking
      //   -> output the first content item and the whitespace "flat".
      // * Only the first content item fits on the line without breaking
      //   -> output the first content item "flat" and the whitespace with
      //   "break".
      // * Neither content item fits on the line without breaking
      //   -> output the first content item and the whitespace with "break".
      case DOC_TYPE_FILL: {
        const remainingWidth = width - position2;
        const offset2 = doc22[DOC_FILL_PRINTED_LENGTH] ?? 0;
        const {
          parts
        } = doc22;
        const length = parts.length - offset2;
        if (length === 0) {
          break;
        }
        const content2 = parts[offset2 + 0];
        const whitespace = parts[offset2 + 1];
        const contentFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: content2
        };
        const contentBreakCommand = {
          indent: indent2,
          mode: MODE_BREAK,
          doc: content2
        };
        const contentFits = fits(contentFlatCommand, [], remainingWidth, lineSuffix2.length > 0, groupModeMap, true);
        if (length === 1) {
          if (contentFits) {
            commands.push(contentFlatCommand);
          } else {
            commands.push(contentBreakCommand);
          }
          break;
        }
        const whitespaceFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: whitespace
        };
        const whitespaceBreakCommand = {
          indent: indent2,
          mode: MODE_BREAK,
          doc: whitespace
        };
        if (length === 2) {
          if (contentFits) {
            commands.push(whitespaceFlatCommand, contentFlatCommand);
          } else {
            commands.push(whitespaceBreakCommand, contentBreakCommand);
          }
          break;
        }
        const secondContent = parts[offset2 + 2];
        const remainingCommand = {
          indent: indent2,
          mode,
          doc: {
            ...doc22,
            [DOC_FILL_PRINTED_LENGTH]: offset2 + 2
          }
        };
        const firstAndSecondContentFlatCommand = {
          indent: indent2,
          mode: MODE_FLAT,
          doc: [content2, whitespace, secondContent]
        };
        const firstAndSecondContentFits = fits(firstAndSecondContentFlatCommand, [], remainingWidth, lineSuffix2.length > 0, groupModeMap, true);
        commands.push(remainingCommand);
        if (firstAndSecondContentFits) {
          commands.push(whitespaceFlatCommand, contentFlatCommand);
        } else if (contentFits) {
          commands.push(whitespaceBreakCommand, contentFlatCommand);
        } else {
          commands.push(whitespaceBreakCommand, contentBreakCommand);
        }
        break;
      }
      case DOC_TYPE_IF_BREAK:
      case DOC_TYPE_INDENT_IF_BREAK: {
        const groupMode = doc22.groupId ? groupModeMap[doc22.groupId] : mode;
        if (groupMode === MODE_BREAK) {
          const breakContents = doc22.type === DOC_TYPE_IF_BREAK ? doc22.breakContents : doc22.negate ? doc22.contents : indent$1(doc22.contents);
          if (breakContents) {
            commands.push({
              indent: indent2,
              mode,
              doc: breakContents
            });
          }
        }
        if (groupMode === MODE_FLAT) {
          const flatContents = doc22.type === DOC_TYPE_IF_BREAK ? doc22.flatContents : doc22.negate ? indent$1(doc22.contents) : doc22.contents;
          if (flatContents) {
            commands.push({
              indent: indent2,
              mode,
              doc: flatContents
            });
          }
        }
        break;
      }
      case DOC_TYPE_LINE_SUFFIX:
        lineSuffix2.push({
          indent: indent2,
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_LINE_SUFFIX_BOUNDARY:
        if (lineSuffix2.length > 0) {
          commands.push({
            indent: indent2,
            mode,
            doc: hardlineWithoutBreakParent
          });
        }
        break;
      case DOC_TYPE_LINE:
        switch (mode) {
          case MODE_FLAT:
            if (!doc22.hard) {
              if (!doc22.soft) {
                result2.write(" ");
                position2 += 1;
              }
              break;
            }
            shouldRemeasure = true;
          // fallthrough
          case MODE_BREAK:
            if (lineSuffix2.length > 0) {
              commands.push({
                indent: indent2,
                mode,
                doc: doc22
              }, ...lineSuffix2.reverse());
              lineSuffix2.length = 0;
              break;
            }
            if (doc22.literal) {
              result2.write(newLine);
              position2 = 0;
              if (indent2.root) {
                if (indent2.root.value) {
                  result2.write(indent2.root.value);
                }
                position2 = indent2.root.length;
              }
            } else {
              result2.trim();
              result2.write(newLine + indent2.value);
              position2 = indent2.length;
            }
            break;
        }
        break;
      case DOC_TYPE_LABEL:
        commands.push({
          indent: indent2,
          mode,
          doc: doc22.contents
        });
        break;
      case DOC_TYPE_BREAK_PARENT:
        break;
      default:
        throw new invalid_doc_error_default(doc22);
    }
    if (commands.length === 0 && lineSuffix2.length > 0) {
      commands.push(...lineSuffix2.reverse());
      lineSuffix2.length = 0;
    }
  }
  const {
    text: formatted,
    positions: cursorPositions
  } = result2.finish();
  if (cursorPositions.length !== 2) {
    return {
      formatted
    };
  }
  const [cursorNodeStart, cursorNodeEnd] = cursorPositions;
  return {
    formatted,
    cursorNodeStart,
    cursorNodeText: formatted.slice(cursorNodeStart, cursorNodeEnd)
  };
}
var builders = {
  join: join$1,
  line: line$1,
  softline: softline$1,
  hardline: hardline$1,
  literalline,
  group: group$1,
  conditionalGroup,
  fill: fill$1,
  lineSuffix,
  lineSuffixBoundary,
  cursor,
  breakParent: breakParent$1,
  ifBreak,
  trim,
  indent: indent$1,
  indentIfBreak,
  align,
  addAlignmentToDoc,
  markAsRoot,
  dedentToRoot,
  dedent,
  hardlineWithoutBreakParent,
  literallineWithoutBreakParent,
  label,
  // TODO: Remove this in v4
  concat: (parts) => parts
};
var printer = { printDocToString };
var utils = {
  willBreak,
  traverseDoc: traverse_doc_default,
  findInDoc,
  mapDoc,
  removeLines,
  stripTrailingHardline,
  replaceEndOfLine,
  canBreak
};
const { line, indent, softline, join, fill, group, hardline, breakParent } = builders;
function classifyContentMode(node) {
  if (PRE_ELEMENTS.has(node.name)) return "pre";
  if (node.children.length === 0) return "empty";
  if (isAlwaysBreakParent(node.name)) return "block";
  return node.children.some(isBlockChildNode) ? "block" : "inline";
}
function isBlockChildNode(node) {
  switch (node.type) {
    case "element":
      return isBlock(node.name);
    case "comment":
    case "cdata":
    case "doctype":
    case "instruction":
      return true;
    default:
      return false;
  }
}
const print = function print2(path, _options, print2) {
  const options2 = _options;
  const node = path.node;
  switch (node.type) {
    case "root": {
      const printedRootChildren = path.map(print2, "children");
      return printChildSequenceAsBlock(
        node.children,
        printedRootChildren
      );
    }
    case "cdata": {
      const unsafe = /]]>/g;
      const subset = [">"];
      return ["<![CDATA[", escape$3(node.value, subset, unsafe), "]]>"];
    }
    case "comment":
      return ["<!--", node.value, "-->"];
    case "doctype": {
      const nodeName = name$d(node.name);
      const pub = node.public;
      const sys = node.system;
      let result2 = ["<!DOCTYPE"];
      if (nodeName !== "") {
        result2.push(" ", nodeName);
      }
      if (pub) {
        result2.push(" ", "PUBLIC", " ", quote$1(pub));
      } else if (sys) {
        result2.push(" ", "SYSTEM");
      }
      if (sys) {
        result2.push(" ", quote$1(sys));
      }
      result2.push(">");
      return result2;
    }
    case "element": {
      const nodeName = name$d(node.name);
      const openingTag = ["<", nodeName];
      const attributes = node.attributes || [];
      const printedAttrs = [];
      for (const attr of Object.values(attributes)) {
        const attrName = name$d(attr.name);
        if (attr.children.length === 0) {
          if (options2.doenetSyntax) {
            printedAttrs.push(line, attrName);
          } else {
            printedAttrs.push(line, attrName, "=", '"true"');
          }
        } else {
          printedAttrs.push(
            line,
            attrName,
            "=",
            quote$1(nodesToXml$1(attr.children, options2))
          );
        }
      }
      if (printedAttrs.length > 0) {
        openingTag.push(indent(printedAttrs));
      }
      const mode = classifyContentMode(node);
      if (mode === "empty") {
        openingTag.push(printedAttrs.length > 0 ? line : " ", "/>");
        return group(openingTag);
      }
      openingTag.push(printedAttrs.length > 0 ? softline : "", ">");
      const closingTag = ["</", nodeName, ">"];
      if (mode === "pre") {
        return [
          group(openingTag),
          toXml$1(node.children, options2),
          closingTag
        ];
      }
      if (mode === "inline") {
        const children = flattenForFill(path.map(print2, "children"));
        return group([
          group(openingTag),
          indent([softline, fill(children)]),
          softline,
          closingTag
        ]);
      }
      const blockBody = printChildSequenceAsBlock(
        node.children,
        path.map(print2, "children"),
        isDefinitionalContainer(node.name)
      );
      return [
        group(openingTag),
        indent([hardline, blockBody]),
        hardline,
        closingTag,
        breakParent
      ];
    }
    case "error":
      return "";
    case "instruction": {
      const unsafe = /\?>/g;
      const subset = [">"];
      const nodeName = name$d(node.name);
      const result2 = escape$3(node.value, subset, unsafe);
      return ["<?", nodeName, result2 ? " " + result2 : "", "?>"];
    }
    case "text": {
      let escapedText = escape$3(node.value, ["&", "<"]);
      if (options2.doenetSyntax) {
        escapedText = escapedText.replace(/&lt;(?=\s|=)/g, "<");
        escapedText = escapedText.replace(/&amp;(?!\S*;)/g, "&");
      }
      return join(
        [hardline, hardline],
        escapedText.split(/\n\n+/).map((str) => join(line, str.split(/\s+/)))
      ).flat();
    }
    case "macro":
    case "function":
      return toXml$1(node, options2);
    default: {
      const unhandledType = node;
      console.warn(
        `Unhandled node type when pretty-printing: ${unhandledType}`
      );
    }
  }
  return "";
};
function printChildSequenceAsBlock(children, printedChildren, treatAllElementsAsBlock = false) {
  const runs = [];
  let inlineBuf = null;
  function flushInline() {
    if (!inlineBuf) return;
    const fillContent = flattenForFill(inlineBuf.printed);
    if (fillContent.length > 0) {
      runs.push({
        firstNode: inlineBuf.firstNode,
        doc: fill(fillContent)
      });
    }
    inlineBuf = null;
  }
  for (let i2 = 0; i2 < children.length; i2++) {
    const child = children[i2];
    const printed = printedChildren[i2];
    const childIsBlock = isBlockChildNode(child) || treatAllElementsAsBlock && child.type === "element";
    if (childIsBlock) {
      flushInline();
      runs.push({ firstNode: child, doc: printed });
    } else {
      if (!inlineBuf) inlineBuf = { firstNode: child, printed: [] };
      inlineBuf.printed.push(printed);
    }
  }
  flushInline();
  const parts = [];
  for (let r2 = 0; r2 < runs.length; r2++) {
    const run = runs[r2];
    if (r2 > 0) {
      parts.push(
        hasBlankLineBefore(run.firstNode) ? [hardline, hardline] : hardline
      );
    }
    parts.push(run.doc);
  }
  return parts;
}
function flattenForFill(children) {
  const result2 = [];
  for (const item of children.flat()) {
    if (item === "") continue;
    if (isSoftLine(item) && (result2.length === 0 || isSoftLine(result2[result2.length - 1]))) {
      continue;
    }
    result2.push(item);
  }
  while (result2.length > 0 && isSoftLine(result2[result2.length - 1])) {
    result2.pop();
  }
  return result2;
}
function isSoftLine(item) {
  return item === line || item === softline;
}
const languages = [
  { name: "doenet", extensions: [".doenet"], parsers: ["doenet-parser"] }
];
const parsers = {
  "doenet-parser": {
    parse(source, options2) {
      return normalize(lezerToDast$1(source));
    },
    astFormat: "dast",
    locStart: (node) => (node.position || { start: { offset: 0 } }).start.offset || 0,
    locEnd: (node) => (node.position || { end: { offset: 0 } }).end.offset || 0
  }
};
const printers = {
  dast: {
    print
  }
};
const options = {
  /**
   * Whether to render with the DoenetML syntax rather than true XML.
   * That means `<` and `&` characters are allowed unescaped in the output.
   */
  doenetSyntax: {
    category: "Global",
    type: "boolean",
    default: false,
    description: "Whether to render with the DoenetML syntax rather than true XML. That means `<` and `&` characters are allowed unescaped in the output."
  },
  /**
   * Whether to output XML error nodes when there are processing errors.
   */
  inlineErrors: {
    category: "Global",
    type: "boolean",
    default: false,
    description: "Whether to output XML error nodes when there are processing errors."
  }
};
const prettierPluginDoenet = { languages, parsers, printers, options };
const prettierPluginDoenet$1 = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  default: prettierPluginDoenet,
  languages,
  options,
  parsers,
  printers
}, Symbol.toStringTag, { value: "Module" }));
async function prettyPrint(source = "", options2 = {}) {
  const plugins2 = options2.plugins || [];
  plugins2.push(prettierPluginDoenet$1);
  return await Pu(source, {
    printWidth: 80,
    useTabs: false,
    tabWidth: 4,
    ...options2,
    parser: "doenet-parser",
    plugins: plugins2
  });
}
const THROTTLE_MS = 100;
function DynamicMath({ latex }) {
  const visibleRef = useRef(null);
  const bufferRef = useRef(null);
  const pending = useRef(null);
  const current2 = useRef(null);
  const busy = useRef(false);
  const lastTypesetAt = useRef(0);
  const mounted = useRef(true);
  useEffect(() => {
    mounted.current = true;
    return () => {
      mounted.current = false;
      bufferRef.current?.remove();
      bufferRef.current = null;
    };
  }, []);
  useEffect(() => {
    pending.current = latex;
    renderPendingLatex().catch((e2) => {
      console.error("DynamicMath: MathJax typesetting failed", e2);
    });
    async function renderPendingLatex() {
      if (busy.current) {
        return;
      }
      const visible = visibleRef.current;
      if (!visible) {
        return;
      }
      busy.current = true;
      try {
        const MathJax2 = await loadMathJax$1();
        await MathJax2.startup.promise;
        while (mounted.current && pending.current !== null && pending.current !== current2.current) {
          const wait = THROTTLE_MS - (performance.now() - lastTypesetAt.current);
          if (wait > 0) {
            await new Promise(
              (resolve) => setTimeout(resolve, wait)
            );
          }
          if (!mounted.current) {
            break;
          }
          const next = pending.current;
          if (next === null) {
            break;
          }
          pending.current = null;
          const buffer = ensureBuffer(bufferRef);
          buffer.innerHTML = next;
          await MathJax2.typesetPromise([buffer]);
          MathJax2.typesetClear([buffer]);
          if (!mounted.current) {
            break;
          }
          visible.replaceChildren(...Array.from(buffer.childNodes));
          current2.current = next;
          lastTypesetAt.current = performance.now();
        }
      } finally {
        busy.current = false;
      }
    }
  }, [latex]);
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { ref: visibleRef, style: { display: "inline" } });
}
function ensureBuffer(bufferRef) {
  let buffer = bufferRef.current;
  if (!buffer) {
    buffer = document.createElement("span");
    buffer.setAttribute("aria-hidden", "true");
    buffer.style.position = "absolute";
    buffer.style.visibility = "hidden";
    buffer.style.left = "-9999px";
    buffer.style.top = "0";
    document.body.appendChild(buffer);
    bufferRef.current = buffer;
  }
  return buffer;
}
function formatResponse(response, componentTypes) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(jsxRuntimeExports$3.Fragment, { children: response.map((v2, i2) => {
    const componentType = componentTypes[i2];
    if (["math", "point", "matrix", "vector"].indexOf(
      componentType
    ) !== -1) {
      const expr = Context$2.fromAst(v2).round_numbers_to_precision_plus_decimals(6, 2);
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        DynamicMath,
        {
          latex: (
            //@ts-ignore
            "\\(" + expr.toLatex() + "\\)"
          )
        }
      ) }, i2);
    } else {
      return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { style: { whiteSpace: "pre-line" }, children: String(v2) }, i2);
    }
  }) });
}
function TabTrigger({
  id: id2,
  icon,
  label: label2,
  count,
  inlineLabel,
  iconClassName,
  onActivate
}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    Tab,
    {
      id: id2,
      title: label2,
      "aria-label": count === void 0 ? label2 : `${label2}: ${count}`,
      className: "diagnostic-tab-trigger",
      "data-test": `footer-tab-${id2}`,
      onClick: () => onActivate(id2),
      children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: classNames("diagnostic-tab-icon", iconClassName), children: icon }),
        inlineLabel !== void 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "diagnostic-tab-label", children: inlineLabel }),
        count !== void 0 && /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { className: "diagnostic-tab-count", children: count })
      ]
    }
  );
}
function EditorFooter({
  store: store2,
  isOpen,
  activateTab,
  showDiagnostics,
  showResponses,
  showHelp,
  showFormatter,
  reserveKeyboardButtonSpace,
  onFormat,
  diagnosticsSummary,
  submittedResponsesCount
}) {
  const {
    warningsCount,
    errorsCount,
    infosCount,
    accessibilityLevel1Count,
    accessibilityLevel2Count
  } = diagnosticsSummary;
  const accessibilityCount = accessibilityLevel1Count + accessibilityLevel2Count;
  const anyTabs = showDiagnostics || showResponses || showHelp;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
    "div",
    {
      className: classNames("editor-footer", {
        "reserve-keyboard-button-space": reserveKeyboardButtonSpace
      }),
      children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          "div",
          {
            className: "doenetml-version",
            title: `DoenetML version ${"0.7.21-dev.343"}`,
            children: [
              "v",
              "0.7.21-dev.343"
            ]
          }
        ),
        anyTabs && /* @__PURE__ */ jsxRuntimeExports$3.jsx(TabProvider, { store: store2, children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          TabList,
          {
            store: store2,
            className: classNames("footer-icons", {
              "is-open": isOpen
            }),
            children: [
              showHelp && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "help",
                  icon: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsCodeSlash, {}),
                  iconClassName: "is-help",
                  label: "Context-sensitive help",
                  inlineLabel: "Context",
                  onActivate: activateTab
                }
              ),
              showHelp && showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                "div",
                {
                  className: "footer-icons-group-gap",
                  "aria-hidden": "true"
                }
              ),
              showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "errors",
                  icon: errorsCount > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsXOctagonFill, {}) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsXOctagon, {}),
                  iconClassName: errorsCount > 0 ? "is-error" : void 0,
                  label: "Errors",
                  count: errorsCount,
                  onActivate: activateTab
                }
              ),
              showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "warnings",
                  icon: warningsCount > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsExclamationTriangleFill, {}) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsExclamationTriangle, {}),
                  iconClassName: warningsCount > 0 ? "is-warning" : void 0,
                  label: "Warnings",
                  count: warningsCount,
                  onActivate: activateTab
                }
              ),
              showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "info",
                  icon: infosCount > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsInfoCircleFill, {}) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsInfoCircle, {}),
                  iconClassName: infosCount > 0 ? "is-info" : void 0,
                  label: "Info",
                  count: infosCount,
                  onActivate: activateTab
                }
              ),
              showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "accessibility",
                  icon: accessibilityCount > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibility, {}) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibilityOutline, {}),
                  iconClassName: accessibilityLevel1Count > 0 ? "is-accessibility-critical" : accessibilityLevel2Count > 0 ? "is-accessibility-advisory" : void 0,
                  label: "Accessibility",
                  count: accessibilityCount,
                  onActivate: activateTab
                }
              ),
              showResponses && (showHelp || showDiagnostics) && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                "div",
                {
                  className: "footer-icons-group-gap",
                  "aria-hidden": "true"
                }
              ),
              showResponses && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                TabTrigger,
                {
                  id: "responses",
                  icon: submittedResponsesCount > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsChatSquareTextFill, {}) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsChatSquareText, {}),
                  iconClassName: submittedResponsesCount > 0 ? "is-responses" : void 0,
                  label: "Submitted responses",
                  count: submittedResponsesCount,
                  onActivate: activateTab
                }
              )
            ]
          }
        ) }),
        showFormatter && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(MenuProvider, { children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(
            MenuButton,
            {
              className: "footer-menu-button",
              title: "Editor options",
              "aria-label": "Editor options",
              "data-test": "footer-menu-button",
              children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsThreeDotsVertical, {})
            }
          ),
          /* @__PURE__ */ jsxRuntimeExports$3.jsxs(Menu, { className: "footer-menu", gutter: 4, children: [
            /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              MenuItem,
              {
                className: "footer-menu-item",
                onClick: () => {
                  onFormat(true).catch(
                    (err) => console.error(
                      "EditorFooter: format as DoenetML failed",
                      err
                    )
                  );
                },
                "data-test": "footer-menu-format-doenetml",
                children: "Format as DoenetML"
              }
            ),
            /* @__PURE__ */ jsxRuntimeExports$3.jsx(
              MenuItem,
              {
                className: "footer-menu-item",
                onClick: () => {
                  onFormat(false).catch(
                    (err) => console.error(
                      "EditorFooter: format as XML failed",
                      err
                    )
                  );
                },
                "data-test": "footer-menu-format-xml",
                children: "Format as XML"
              }
            )
          ] })
        ] })
      ]
    }
  );
}
function RxUpdate(props2) {
  return GenIcon$1({ "attr": { "viewBox": "0 0 15 15", "fill": "none" }, "child": [{ "tag": "path", "attr": { "d": "M7.98779 1.56268C8.0409 1.27989 8.3134 1.09275 8.59619 1.14569L8.86475 1.20233C11.6292 1.83955 14.0531 4.23823 14.0532 7.70331C14.0532 9.23977 13.3539 10.4478 12.5376 11.3664C11.9526 12.0246 11.2828 12.5586 10.7446 12.968L12.3823 12.968C12.6583 12.9681 12.8822 13.192 12.8823 13.468C12.8823 13.744 12.6583 13.9678 12.3823 13.968L9.38232 13.968C9.10618 13.968 8.88232 13.7441 8.88232 13.468L8.88232 10.468C8.88242 10.1919 9.10624 9.96796 9.38232 9.96796C9.65828 9.96811 9.88223 10.192 9.88232 10.468L9.88232 12.3137L10.064 12.176C10.5978 11.7712 11.2158 11.2844 11.7583 10.674C12.4727 9.87007 13.0102 8.89839 13.0103 7.70331C13.0101 4.69155 10.8502 2.63051 8.40381 2.17108L8.30225 2.14081C8.07811 2.04924 7.94169 1.80992 7.98779 1.56268ZM0.86084 7.29706C0.860904 5.76062 1.56016 4.55258 2.37646 3.63397C2.96144 2.97579 3.63128 2.44174 4.16943 2.03241L2.53174 2.03241C2.25581 2.03224 2.03185 1.80835 2.03174 1.53241C2.03174 1.25637 2.25574 1.03258 2.53174 1.03241L5.53174 1.03241C5.80788 1.03241 6.03174 1.25627 6.03174 1.53241L6.03174 4.53241C6.03162 4.80845 5.80781 5.03241 5.53174 5.03241C5.25581 5.03224 5.03185 4.80835 5.03174 4.53241L5.03174 2.68671L4.8501 2.8244C4.3163 3.22913 3.6983 3.71593 3.15576 4.32635C2.44134 5.13029 1.90387 6.10199 1.90381 7.29706C1.90397 10.3411 4.11093 12.4148 6.58936 12.8439C6.87264 12.8932 7.06302 13.1631 7.01416 13.4465C6.96499 13.7298 6.69498 13.92 6.41162 13.8713C3.50004 13.3671 0.860998 10.9128 0.86084 7.29706Z", "fill": "currentColor" }, "child": [] }] })(props2);
}
function getAccessibilityStatusTitle({
  accessibilityLevel1Count,
  accessibilityLevel2Count,
  isAccessibilityReportOpen
}) {
  const action = isAccessibilityReportOpen ? "close" : "open";
  if (accessibilityLevel1Count > 0) {
    return `WCAG AA accessibility violation identified. Click to ${action} accessibility report.`;
  }
  if (accessibilityLevel2Count > 0) {
    return `Click to ${action} accessibility report. No WCAG AA violations were found, but additional accessibility recommendations are available.`;
  }
  return `Click to ${action} accessibility report. No accessibility issues were found.`;
}
function getAccessibilityStatusAriaLabel({
  accessibilityLevel1Count,
  accessibilityLevel2Count,
  isAccessibilityReportOpen
}) {
  const action = isAccessibilityReportOpen ? "close" : "open";
  if (accessibilityLevel1Count > 0) {
    return `WCAG AA accessibility violation identified. ${accessibilityLevel1Count} WCAG AA violation${accessibilityLevel1Count === 1 ? "" : "s"} found. Click to ${action} accessibility report.`;
  }
  if (accessibilityLevel2Count > 0) {
    return `No WCAG AA violations identified. ${accessibilityLevel2Count} additional accessibility recommendation${accessibilityLevel2Count === 1 ? "" : "s"} found. Click to ${action} accessibility report.`;
  }
  return `No WCAG AA violations identified. Click to ${action} accessibility report.`;
}
function AccessibilityStatusButton({
  accessibilityLevel1Count,
  accessibilityLevel2Count,
  isAccessibilityReportOpen,
  onToggle
}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    "button",
    {
      type: "button",
      className: `accessibility-status-button ${accessibilityLevel1Count > 0 ? "has-level-1-issues" : "no-level-1-issues"}`,
      onClick: onToggle,
      title: getAccessibilityStatusTitle({
        accessibilityLevel1Count,
        accessibilityLevel2Count,
        isAccessibilityReportOpen
      }),
      "aria-label": getAccessibilityStatusAriaLabel({
        accessibilityLevel1Count,
        accessibilityLevel2Count,
        isAccessibilityReportOpen
      }),
      children: accessibilityLevel1Count > 0 ? /* @__PURE__ */ jsxRuntimeExports$3.jsxs(jsxRuntimeExports$3.Fragment, { children: [
        /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibility, {}),
        /* @__PURE__ */ jsxRuntimeExports$3.jsx("span", { children: "WCAG" })
      ] }) : /* @__PURE__ */ jsxRuntimeExports$3.jsx(IoAccessibility, {})
    }
  );
}
function VariantSelect({
  darkMode = "light",
  array = [],
  onChange = () => {
  },
  syncIndex
  //Optional attribute to keep several variant selects in sync
}) {
  const [index2, setIndex] = useState(0);
  const [inputValue, setInputValue] = useState("");
  const value = array[index2] ?? "";
  function selectIndex(nextIndex) {
    setIndex(nextIndex);
    setInputValue("");
    onChange(nextIndex);
  }
  useEffect(() => {
    if (syncIndex != void 0 && index2 != syncIndex - 1) {
      setIndex(syncIndex - 1);
      setInputValue("");
    }
  }, [index2, syncIndex, array]);
  const filteredArray = array.filter(
    (string2) => inputValue === "" ? true : string2.includes(inputValue)
  );
  const matches2 = filteredArray.length > 0 ? filteredArray : array;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "variant-select", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "wrapper", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      ComboboxProvider,
      {
        resetValueOnHide: true,
        setValue: (value2) => {
          React__default.startTransition(() => {
            setInputValue(value2);
          });
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
          SelectProvider,
          {
            value,
            setValue: (val) => {
              const nextIndex = array.indexOf(val);
              if (nextIndex !== -1) {
                selectIndex(nextIndex);
              }
            },
            children: [
              /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                Select,
                {
                  className: "doenet-ui-button button select-button",
                  title: "Variant"
                }
              ),
              /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
                SelectPopover,
                {
                  gutter: 4,
                  sameWidth: true,
                  "data-theme": darkMode,
                  className: "popover",
                  children: [
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "combobox-wrapper", children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      Combobox,
                      {
                        autoSelect: true,
                        placeholder: "Filter...",
                        className: "combobox"
                      }
                    ) }),
                    /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxList, { children: matches2.map((value2) => /* @__PURE__ */ jsxRuntimeExports$3.jsx(
                      SelectItem,
                      {
                        value: value2,
                        className: "select-item",
                        render: /* @__PURE__ */ jsxRuntimeExports$3.jsx(ComboboxItem, {})
                      },
                      value2
                    )) })
                  ]
                }
              )
            ]
          }
        )
      }
    ) }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      Button,
      {
        title: "Select next variant",
        "data-test": "Next Variant",
        className: "doenet-ui-button button prev-next-button",
        disabled: index2 == array.length - 1,
        onClick: () => {
          if (index2 == array.length - 1) {
            return;
          }
          selectIndex(index2 + 1);
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsCaretDownFill, {})
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      Button,
      {
        title: "Select previous variant",
        "data-test": "Previous Variant",
        className: "doenet-ui-button button prev-next-button",
        disabled: index2 < 1,
        onClick: () => {
          if (index2 < 1) {
            return;
          }
          selectIndex(index2 - 1);
        },
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(BsCaretUpFill, {})
      }
    )
  ] });
}
function setVariantIndex(setVariants, index2) {
  setVariants((prev) => ({
    ...prev,
    index: index2 + 1
  }));
}
function setVariantsFromCallback(x2, variants, setVariants) {
  const allPossibleVariants = x2.allPossibleVariants;
  if (Array.isArray(allPossibleVariants)) {
    const numVariants = allPossibleVariants.length;
    if (typeof x2.variantInfo === "object" && typeof x2.variantInfo.index === "number") {
      const index2 = x2.variantInfo.index;
      if (index2 !== variants.index || numVariants !== variants.numVariants || allPossibleVariants.some(
        (v2, i2) => v2 !== variants.allPossibleVariants[i2]
      )) {
        setVariants({
          index: index2,
          numVariants,
          allPossibleVariants
        });
      }
    }
  }
}
function ViewerControlsBar({
  id: id2,
  readOnly: readOnly2,
  codeChanged,
  documentInteracted,
  updateWord,
  onUpdateViewer,
  variants,
  setVariants,
  showDiagnostics,
  accessibilityLevel1Count,
  accessibilityLevel2Count,
  isAccessibilityReportOpen,
  onToggleAccessibilityReport,
  darkMode
}) {
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "viewer-controls", id: `${id2}-viewer-controls`, children: [
    !readOnly2 && /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
      UiButton,
      {
        "data-test": "Viewer Update Button",
        disabled: !codeChanged && !documentInteracted,
        title: codeChanged ? isMacPlatform() ? `${updateWord} Viewer cmd+s` : `${updateWord} Viewer ctrl+s` : `${updateWord} Viewer`,
        onClick: onUpdateViewer,
        children: [
          /* @__PURE__ */ jsxRuntimeExports$3.jsx(RxUpdate, {}),
          " ",
          updateWord,
          " ",
          codeChanged ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
            BsExclamationTriangleFill,
            {
              fontSize: "18px",
              color: "var(--mainBlue)"
            }
          ) : void 0
        ]
      }
    ),
    variants.numVariants > 1 && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      VariantSelect,
      {
        darkMode,
        array: variants.allPossibleVariants,
        syncIndex: variants.index,
        onChange: (index2) => setVariantIndex(setVariants, index2)
      }
    ),
    showDiagnostics && /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      AccessibilityStatusButton,
      {
        accessibilityLevel1Count,
        accessibilityLevel2Count,
        isAccessibilityReportOpen,
        onToggle: onToggleAccessibilityReport
      }
    )
  ] });
}
var main$2 = {};
var main$1 = {};
var ril = {};
var api$1 = {};
var messages$1 = {};
var is$1 = {};
var hasRequiredIs$1;
function requireIs$1() {
  if (hasRequiredIs$1) return is$1;
  hasRequiredIs$1 = 1;
  Object.defineProperty(is$1, "__esModule", { value: true });
  is$1.stringArray = is$1.array = is$1.func = is$1.error = is$1.number = is$1.string = is$1.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is$1.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is$1.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is$1.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is$1.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is$1.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is$1.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is$1.stringArray = stringArray;
  return is$1;
}
var hasRequiredMessages$1;
function requireMessages$1() {
  if (hasRequiredMessages$1) return messages$1;
  hasRequiredMessages$1 = 1;
  Object.defineProperty(messages$1, "__esModule", { value: true });
  messages$1.Message = messages$1.NotificationType9 = messages$1.NotificationType8 = messages$1.NotificationType7 = messages$1.NotificationType6 = messages$1.NotificationType5 = messages$1.NotificationType4 = messages$1.NotificationType3 = messages$1.NotificationType2 = messages$1.NotificationType1 = messages$1.NotificationType0 = messages$1.NotificationType = messages$1.RequestType9 = messages$1.RequestType8 = messages$1.RequestType7 = messages$1.RequestType6 = messages$1.RequestType5 = messages$1.RequestType4 = messages$1.RequestType3 = messages$1.RequestType2 = messages$1.RequestType1 = messages$1.RequestType = messages$1.RequestType0 = messages$1.AbstractMessageSignature = messages$1.ParameterStructures = messages$1.ResponseError = messages$1.ErrorCodes = void 0;
  const is2 = requireIs$1();
  var ErrorCodes;
  (function(ErrorCodes2) {
    ErrorCodes2.ParseError = -32700;
    ErrorCodes2.InvalidRequest = -32600;
    ErrorCodes2.MethodNotFound = -32601;
    ErrorCodes2.InvalidParams = -32602;
    ErrorCodes2.InternalError = -32603;
    ErrorCodes2.jsonrpcReservedErrorRangeStart = -32099;
    ErrorCodes2.serverErrorStart = -32099;
    ErrorCodes2.MessageWriteError = -32099;
    ErrorCodes2.MessageReadError = -32098;
    ErrorCodes2.PendingResponseRejected = -32097;
    ErrorCodes2.ConnectionInactive = -32096;
    ErrorCodes2.ServerNotInitialized = -32002;
    ErrorCodes2.UnknownErrorCode = -32001;
    ErrorCodes2.jsonrpcReservedErrorRangeEnd = -32e3;
    ErrorCodes2.serverErrorEnd = -32e3;
  })(ErrorCodes || (messages$1.ErrorCodes = ErrorCodes = {}));
  class ResponseError extends Error {
    constructor(code2, message, data) {
      super(message);
      this.code = is2.number(code2) ? code2 : ErrorCodes.UnknownErrorCode;
      this.data = data;
      Object.setPrototypeOf(this, ResponseError.prototype);
    }
    toJson() {
      const result2 = {
        code: this.code,
        message: this.message
      };
      if (this.data !== void 0) {
        result2.data = this.data;
      }
      return result2;
    }
  }
  messages$1.ResponseError = ResponseError;
  class ParameterStructures {
    constructor(kind) {
      this.kind = kind;
    }
    static is(value) {
      return value === ParameterStructures.auto || value === ParameterStructures.byName || value === ParameterStructures.byPosition;
    }
    toString() {
      return this.kind;
    }
  }
  messages$1.ParameterStructures = ParameterStructures;
  ParameterStructures.auto = new ParameterStructures("auto");
  ParameterStructures.byPosition = new ParameterStructures("byPosition");
  ParameterStructures.byName = new ParameterStructures("byName");
  class AbstractMessageSignature {
    constructor(method, numberOfParams) {
      this.method = method;
      this.numberOfParams = numberOfParams;
    }
    get parameterStructures() {
      return ParameterStructures.auto;
    }
  }
  messages$1.AbstractMessageSignature = AbstractMessageSignature;
  class RequestType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1.RequestType0 = RequestType0;
  class RequestType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.RequestType = RequestType;
  class RequestType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.RequestType1 = RequestType1;
  class RequestType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1.RequestType2 = RequestType2;
  class RequestType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1.RequestType3 = RequestType3;
  class RequestType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1.RequestType4 = RequestType4;
  class RequestType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1.RequestType5 = RequestType5;
  class RequestType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1.RequestType6 = RequestType6;
  class RequestType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1.RequestType7 = RequestType7;
  class RequestType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1.RequestType8 = RequestType8;
  class RequestType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1.RequestType9 = RequestType9;
  class NotificationType extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.NotificationType = NotificationType;
  class NotificationType0 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 0);
    }
  }
  messages$1.NotificationType0 = NotificationType0;
  class NotificationType1 extends AbstractMessageSignature {
    constructor(method, _parameterStructures = ParameterStructures.auto) {
      super(method, 1);
      this._parameterStructures = _parameterStructures;
    }
    get parameterStructures() {
      return this._parameterStructures;
    }
  }
  messages$1.NotificationType1 = NotificationType1;
  class NotificationType2 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 2);
    }
  }
  messages$1.NotificationType2 = NotificationType2;
  class NotificationType3 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 3);
    }
  }
  messages$1.NotificationType3 = NotificationType3;
  class NotificationType4 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 4);
    }
  }
  messages$1.NotificationType4 = NotificationType4;
  class NotificationType5 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 5);
    }
  }
  messages$1.NotificationType5 = NotificationType5;
  class NotificationType6 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 6);
    }
  }
  messages$1.NotificationType6 = NotificationType6;
  class NotificationType7 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 7);
    }
  }
  messages$1.NotificationType7 = NotificationType7;
  class NotificationType8 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 8);
    }
  }
  messages$1.NotificationType8 = NotificationType8;
  class NotificationType9 extends AbstractMessageSignature {
    constructor(method) {
      super(method, 9);
    }
  }
  messages$1.NotificationType9 = NotificationType9;
  var Message;
  (function(Message2) {
    function isRequest(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && (is2.string(candidate.id) || is2.number(candidate.id));
    }
    Message2.isRequest = isRequest;
    function isNotification(message) {
      const candidate = message;
      return candidate && is2.string(candidate.method) && message.id === void 0;
    }
    Message2.isNotification = isNotification;
    function isResponse(message) {
      const candidate = message;
      return candidate && (candidate.result !== void 0 || !!candidate.error) && (is2.string(candidate.id) || is2.number(candidate.id) || candidate.id === null);
    }
    Message2.isResponse = isResponse;
  })(Message || (messages$1.Message = Message = {}));
  return messages$1;
}
var linkedMap = {};
var hasRequiredLinkedMap;
function requireLinkedMap() {
  if (hasRequiredLinkedMap) return linkedMap;
  hasRequiredLinkedMap = 1;
  var _a2;
  Object.defineProperty(linkedMap, "__esModule", { value: true });
  linkedMap.LRUCache = linkedMap.LinkedMap = linkedMap.Touch = void 0;
  var Touch;
  (function(Touch2) {
    Touch2.None = 0;
    Touch2.First = 1;
    Touch2.AsOld = Touch2.First;
    Touch2.Last = 2;
    Touch2.AsNew = Touch2.Last;
  })(Touch || (linkedMap.Touch = Touch = {}));
  class LinkedMap {
    constructor() {
      this[_a2] = "LinkedMap";
      this._map = /* @__PURE__ */ new Map();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state = 0;
    }
    clear() {
      this._map.clear();
      this._head = void 0;
      this._tail = void 0;
      this._size = 0;
      this._state++;
    }
    isEmpty() {
      return !this._head && !this._tail;
    }
    get size() {
      return this._size;
    }
    get first() {
      return this._head?.value;
    }
    get last() {
      return this._tail?.value;
    }
    has(key) {
      return this._map.has(key);
    }
    get(key, touch = Touch.None) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      if (touch !== Touch.None) {
        this.touch(item, touch);
      }
      return item.value;
    }
    set(key, value, touch = Touch.None) {
      let item = this._map.get(key);
      if (item) {
        item.value = value;
        if (touch !== Touch.None) {
          this.touch(item, touch);
        }
      } else {
        item = { key, value, next: void 0, previous: void 0 };
        switch (touch) {
          case Touch.None:
            this.addItemLast(item);
            break;
          case Touch.First:
            this.addItemFirst(item);
            break;
          case Touch.Last:
            this.addItemLast(item);
            break;
          default:
            this.addItemLast(item);
            break;
        }
        this._map.set(key, item);
        this._size++;
      }
      return this;
    }
    delete(key) {
      return !!this.remove(key);
    }
    remove(key) {
      const item = this._map.get(key);
      if (!item) {
        return void 0;
      }
      this._map.delete(key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    shift() {
      if (!this._head && !this._tail) {
        return void 0;
      }
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      const item = this._head;
      this._map.delete(item.key);
      this.removeItem(item);
      this._size--;
      return item.value;
    }
    forEach(callbackfn, thisArg) {
      const state = this._state;
      let current2 = this._head;
      while (current2) {
        if (thisArg) {
          callbackfn.bind(thisArg)(current2.value, current2.key, this);
        } else {
          callbackfn(current2.value, current2.key, this);
        }
        if (this._state !== state) {
          throw new Error(`LinkedMap got modified during iteration.`);
        }
        current2 = current2.next;
      }
    }
    keys() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.key, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    values() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: current2.value, done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    entries() {
      const state = this._state;
      let current2 = this._head;
      const iterator = {
        [Symbol.iterator]: () => {
          return iterator;
        },
        next: () => {
          if (this._state !== state) {
            throw new Error(`LinkedMap got modified during iteration.`);
          }
          if (current2) {
            const result2 = { value: [current2.key, current2.value], done: false };
            current2 = current2.next;
            return result2;
          } else {
            return { value: void 0, done: true };
          }
        }
      };
      return iterator;
    }
    [(_a2 = Symbol.toStringTag, Symbol.iterator)]() {
      return this.entries();
    }
    trimOld(newSize) {
      if (newSize >= this.size) {
        return;
      }
      if (newSize === 0) {
        this.clear();
        return;
      }
      let current2 = this._head;
      let currentSize = this.size;
      while (current2 && currentSize > newSize) {
        this._map.delete(current2.key);
        current2 = current2.next;
        currentSize--;
      }
      this._head = current2;
      this._size = currentSize;
      if (current2) {
        current2.previous = void 0;
      }
      this._state++;
    }
    addItemFirst(item) {
      if (!this._head && !this._tail) {
        this._tail = item;
      } else if (!this._head) {
        throw new Error("Invalid list");
      } else {
        item.next = this._head;
        this._head.previous = item;
      }
      this._head = item;
      this._state++;
    }
    addItemLast(item) {
      if (!this._head && !this._tail) {
        this._head = item;
      } else if (!this._tail) {
        throw new Error("Invalid list");
      } else {
        item.previous = this._tail;
        this._tail.next = item;
      }
      this._tail = item;
      this._state++;
    }
    removeItem(item) {
      if (item === this._head && item === this._tail) {
        this._head = void 0;
        this._tail = void 0;
      } else if (item === this._head) {
        if (!item.next) {
          throw new Error("Invalid list");
        }
        item.next.previous = void 0;
        this._head = item.next;
      } else if (item === this._tail) {
        if (!item.previous) {
          throw new Error("Invalid list");
        }
        item.previous.next = void 0;
        this._tail = item.previous;
      } else {
        const next = item.next;
        const previous2 = item.previous;
        if (!next || !previous2) {
          throw new Error("Invalid list");
        }
        next.previous = previous2;
        previous2.next = next;
      }
      item.next = void 0;
      item.previous = void 0;
      this._state++;
    }
    touch(item, touch) {
      if (!this._head || !this._tail) {
        throw new Error("Invalid list");
      }
      if (touch !== Touch.First && touch !== Touch.Last) {
        return;
      }
      if (touch === Touch.First) {
        if (item === this._head) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._tail) {
          previous2.next = void 0;
          this._tail = previous2;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.previous = void 0;
        item.next = this._head;
        this._head.previous = item;
        this._head = item;
        this._state++;
      } else if (touch === Touch.Last) {
        if (item === this._tail) {
          return;
        }
        const next = item.next;
        const previous2 = item.previous;
        if (item === this._head) {
          next.previous = void 0;
          this._head = next;
        } else {
          next.previous = previous2;
          previous2.next = next;
        }
        item.next = void 0;
        item.previous = this._tail;
        this._tail.next = item;
        this._tail = item;
        this._state++;
      }
    }
    toJSON() {
      const data = [];
      this.forEach((value, key) => {
        data.push([key, value]);
      });
      return data;
    }
    fromJSON(data) {
      this.clear();
      for (const [key, value] of data) {
        this.set(key, value);
      }
    }
  }
  linkedMap.LinkedMap = LinkedMap;
  class LRUCache extends LinkedMap {
    constructor(limit, ratio = 1) {
      super();
      this._limit = limit;
      this._ratio = Math.min(Math.max(0, ratio), 1);
    }
    get limit() {
      return this._limit;
    }
    set limit(limit) {
      this._limit = limit;
      this.checkTrim();
    }
    get ratio() {
      return this._ratio;
    }
    set ratio(ratio) {
      this._ratio = Math.min(Math.max(0, ratio), 1);
      this.checkTrim();
    }
    get(key, touch = Touch.AsNew) {
      return super.get(key, touch);
    }
    peek(key) {
      return super.get(key, Touch.None);
    }
    set(key, value) {
      super.set(key, value, Touch.Last);
      this.checkTrim();
      return this;
    }
    checkTrim() {
      if (this.size > this._limit) {
        this.trimOld(Math.round(this._limit * this._ratio));
      }
    }
  }
  linkedMap.LRUCache = LRUCache;
  return linkedMap;
}
var disposable = {};
var hasRequiredDisposable;
function requireDisposable() {
  if (hasRequiredDisposable) return disposable;
  hasRequiredDisposable = 1;
  Object.defineProperty(disposable, "__esModule", { value: true });
  disposable.Disposable = void 0;
  var Disposable;
  (function(Disposable2) {
    function create2(func) {
      return {
        dispose: func
      };
    }
    Disposable2.create = create2;
  })(Disposable || (disposable.Disposable = Disposable = {}));
  return disposable;
}
var events = {};
var ral = {};
var hasRequiredRal;
function requireRal() {
  if (hasRequiredRal) return ral;
  hasRequiredRal = 1;
  Object.defineProperty(ral, "__esModule", { value: true });
  let _ral;
  function RAL() {
    if (_ral === void 0) {
      throw new Error(`No runtime abstraction layer installed`);
    }
    return _ral;
  }
  (function(RAL2) {
    function install(ral2) {
      if (ral2 === void 0) {
        throw new Error(`No runtime abstraction layer provided`);
      }
      _ral = ral2;
    }
    RAL2.install = install;
  })(RAL || (RAL = {}));
  ral.default = RAL;
  return ral;
}
var hasRequiredEvents;
function requireEvents() {
  if (hasRequiredEvents) return events;
  hasRequiredEvents = 1;
  Object.defineProperty(events, "__esModule", { value: true });
  events.Emitter = events.Event = void 0;
  const ral_1 = requireRal();
  var Event2;
  (function(Event3) {
    const _disposable = { dispose() {
    } };
    Event3.None = function() {
      return _disposable;
    };
  })(Event2 || (events.Event = Event2 = {}));
  class CallbackList {
    add(callback, context = null, bucket) {
      if (!this._callbacks) {
        this._callbacks = [];
        this._contexts = [];
      }
      this._callbacks.push(callback);
      this._contexts.push(context);
      if (Array.isArray(bucket)) {
        bucket.push({ dispose: () => this.remove(callback, context) });
      }
    }
    remove(callback, context = null) {
      if (!this._callbacks) {
        return;
      }
      let foundCallbackWithDifferentContext = false;
      for (let i2 = 0, len = this._callbacks.length; i2 < len; i2++) {
        if (this._callbacks[i2] === callback) {
          if (this._contexts[i2] === context) {
            this._callbacks.splice(i2, 1);
            this._contexts.splice(i2, 1);
            return;
          } else {
            foundCallbackWithDifferentContext = true;
          }
        }
      }
      if (foundCallbackWithDifferentContext) {
        throw new Error("When adding a listener with a context, you should remove it with the same context");
      }
    }
    invoke(...args) {
      if (!this._callbacks) {
        return [];
      }
      const ret = [], callbacks = this._callbacks.slice(0), contexts = this._contexts.slice(0);
      for (let i2 = 0, len = callbacks.length; i2 < len; i2++) {
        try {
          ret.push(callbacks[i2].apply(contexts[i2], args));
        } catch (e2) {
          (0, ral_1.default)().console.error(e2);
        }
      }
      return ret;
    }
    isEmpty() {
      return !this._callbacks || this._callbacks.length === 0;
    }
    dispose() {
      this._callbacks = void 0;
      this._contexts = void 0;
    }
  }
  class Emitter {
    constructor(_options) {
      this._options = _options;
    }
    /**
     * For the public to allow to subscribe
     * to events from this Emitter
     */
    get event() {
      if (!this._event) {
        this._event = (listener, thisArgs, disposables) => {
          if (!this._callbacks) {
            this._callbacks = new CallbackList();
          }
          if (this._options && this._options.onFirstListenerAdd && this._callbacks.isEmpty()) {
            this._options.onFirstListenerAdd(this);
          }
          this._callbacks.add(listener, thisArgs);
          const result2 = {
            dispose: () => {
              if (!this._callbacks) {
                return;
              }
              this._callbacks.remove(listener, thisArgs);
              result2.dispose = Emitter._noop;
              if (this._options && this._options.onLastListenerRemove && this._callbacks.isEmpty()) {
                this._options.onLastListenerRemove(this);
              }
            }
          };
          if (Array.isArray(disposables)) {
            disposables.push(result2);
          }
          return result2;
        };
      }
      return this._event;
    }
    /**
     * To be kept private to fire an event to
     * subscribers
     */
    fire(event) {
      if (this._callbacks) {
        this._callbacks.invoke.call(this._callbacks, event);
      }
    }
    dispose() {
      if (this._callbacks) {
        this._callbacks.dispose();
        this._callbacks = void 0;
      }
    }
  }
  events.Emitter = Emitter;
  Emitter._noop = function() {
  };
  return events;
}
var cancellation = {};
var hasRequiredCancellation;
function requireCancellation() {
  if (hasRequiredCancellation) return cancellation;
  hasRequiredCancellation = 1;
  Object.defineProperty(cancellation, "__esModule", { value: true });
  cancellation.CancellationTokenSource = cancellation.CancellationToken = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const events_1 = requireEvents();
  var CancellationToken;
  (function(CancellationToken2) {
    CancellationToken2.None = Object.freeze({
      isCancellationRequested: false,
      onCancellationRequested: events_1.Event.None
    });
    CancellationToken2.Cancelled = Object.freeze({
      isCancellationRequested: true,
      onCancellationRequested: events_1.Event.None
    });
    function is2(value) {
      const candidate = value;
      return candidate && (candidate === CancellationToken2.None || candidate === CancellationToken2.Cancelled || Is2.boolean(candidate.isCancellationRequested) && !!candidate.onCancellationRequested);
    }
    CancellationToken2.is = is2;
  })(CancellationToken || (cancellation.CancellationToken = CancellationToken = {}));
  const shortcutEvent = Object.freeze(function(callback, context) {
    const handle = (0, ral_1.default)().timer.setTimeout(callback.bind(context), 0);
    return { dispose() {
      handle.dispose();
    } };
  });
  class MutableToken {
    constructor() {
      this._isCancelled = false;
    }
    cancel() {
      if (!this._isCancelled) {
        this._isCancelled = true;
        if (this._emitter) {
          this._emitter.fire(void 0);
          this.dispose();
        }
      }
    }
    get isCancellationRequested() {
      return this._isCancelled;
    }
    get onCancellationRequested() {
      if (this._isCancelled) {
        return shortcutEvent;
      }
      if (!this._emitter) {
        this._emitter = new events_1.Emitter();
      }
      return this._emitter.event;
    }
    dispose() {
      if (this._emitter) {
        this._emitter.dispose();
        this._emitter = void 0;
      }
    }
  }
  class CancellationTokenSource {
    get token() {
      if (!this._token) {
        this._token = new MutableToken();
      }
      return this._token;
    }
    cancel() {
      if (!this._token) {
        this._token = CancellationToken.Cancelled;
      } else {
        this._token.cancel();
      }
    }
    dispose() {
      if (!this._token) {
        this._token = CancellationToken.None;
      } else if (this._token instanceof MutableToken) {
        this._token.dispose();
      }
    }
  }
  cancellation.CancellationTokenSource = CancellationTokenSource;
  return cancellation;
}
var sharedArrayCancellation = {};
var hasRequiredSharedArrayCancellation;
function requireSharedArrayCancellation() {
  if (hasRequiredSharedArrayCancellation) return sharedArrayCancellation;
  hasRequiredSharedArrayCancellation = 1;
  Object.defineProperty(sharedArrayCancellation, "__esModule", { value: true });
  sharedArrayCancellation.SharedArrayReceiverStrategy = sharedArrayCancellation.SharedArraySenderStrategy = void 0;
  const cancellation_1 = requireCancellation();
  var CancellationState;
  (function(CancellationState2) {
    CancellationState2.Continue = 0;
    CancellationState2.Cancelled = 1;
  })(CancellationState || (CancellationState = {}));
  class SharedArraySenderStrategy {
    constructor() {
      this.buffers = /* @__PURE__ */ new Map();
    }
    enableCancellation(request) {
      if (request.id === null) {
        return;
      }
      const buffer = new SharedArrayBuffer(4);
      const data = new Int32Array(buffer, 0, 1);
      data[0] = CancellationState.Continue;
      this.buffers.set(request.id, buffer);
      request.$cancellationData = buffer;
    }
    async sendCancellation(_conn, id2) {
      const buffer = this.buffers.get(id2);
      if (buffer === void 0) {
        return;
      }
      const data = new Int32Array(buffer, 0, 1);
      Atomics.store(data, 0, CancellationState.Cancelled);
    }
    cleanup(id2) {
      this.buffers.delete(id2);
    }
    dispose() {
      this.buffers.clear();
    }
  }
  sharedArrayCancellation.SharedArraySenderStrategy = SharedArraySenderStrategy;
  class SharedArrayBufferCancellationToken {
    constructor(buffer) {
      this.data = new Int32Array(buffer, 0, 1);
    }
    get isCancellationRequested() {
      return Atomics.load(this.data, 0) === CancellationState.Cancelled;
    }
    get onCancellationRequested() {
      throw new Error(`Cancellation over SharedArrayBuffer doesn't support cancellation events`);
    }
  }
  class SharedArrayBufferCancellationTokenSource {
    constructor(buffer) {
      this.token = new SharedArrayBufferCancellationToken(buffer);
    }
    cancel() {
    }
    dispose() {
    }
  }
  class SharedArrayReceiverStrategy {
    constructor() {
      this.kind = "request";
    }
    createCancellationTokenSource(request) {
      const buffer = request.$cancellationData;
      if (buffer === void 0) {
        return new cancellation_1.CancellationTokenSource();
      }
      return new SharedArrayBufferCancellationTokenSource(buffer);
    }
  }
  sharedArrayCancellation.SharedArrayReceiverStrategy = SharedArrayReceiverStrategy;
  return sharedArrayCancellation;
}
var messageReader = {};
var semaphore = {};
var hasRequiredSemaphore;
function requireSemaphore() {
  if (hasRequiredSemaphore) return semaphore;
  hasRequiredSemaphore = 1;
  Object.defineProperty(semaphore, "__esModule", { value: true });
  semaphore.Semaphore = void 0;
  const ral_1 = requireRal();
  class Semaphore {
    constructor(capacity = 1) {
      if (capacity <= 0) {
        throw new Error("Capacity must be greater than 0");
      }
      this._capacity = capacity;
      this._active = 0;
      this._waiting = [];
    }
    lock(thunk2) {
      return new Promise((resolve, reject2) => {
        this._waiting.push({ thunk: thunk2, resolve, reject: reject2 });
        this.runNext();
      });
    }
    get active() {
      return this._active;
    }
    runNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      (0, ral_1.default)().timer.setImmediate(() => this.doRunNext());
    }
    doRunNext() {
      if (this._waiting.length === 0 || this._active === this._capacity) {
        return;
      }
      const next = this._waiting.shift();
      this._active++;
      if (this._active > this._capacity) {
        throw new Error(`To many thunks active`);
      }
      try {
        const result2 = next.thunk();
        if (result2 instanceof Promise) {
          result2.then((value) => {
            this._active--;
            next.resolve(value);
            this.runNext();
          }, (err) => {
            this._active--;
            next.reject(err);
            this.runNext();
          });
        } else {
          this._active--;
          next.resolve(result2);
          this.runNext();
        }
      } catch (err) {
        this._active--;
        next.reject(err);
        this.runNext();
      }
    }
  }
  semaphore.Semaphore = Semaphore;
  return semaphore;
}
var hasRequiredMessageReader;
function requireMessageReader() {
  if (hasRequiredMessageReader) return messageReader;
  hasRequiredMessageReader = 1;
  Object.defineProperty(messageReader, "__esModule", { value: true });
  messageReader.ReadableStreamMessageReader = messageReader.AbstractMessageReader = messageReader.MessageReader = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const events_1 = requireEvents();
  const semaphore_1 = requireSemaphore();
  var MessageReader;
  (function(MessageReader2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.listen) && Is2.func(candidate.dispose) && Is2.func(candidate.onError) && Is2.func(candidate.onClose) && Is2.func(candidate.onPartialMessage);
    }
    MessageReader2.is = is2;
  })(MessageReader || (messageReader.MessageReader = MessageReader = {}));
  class AbstractMessageReader {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
      this.partialMessageEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error) {
      this.errorEmitter.fire(this.asError(error));
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    get onPartialMessage() {
      return this.partialMessageEmitter.event;
    }
    firePartialMessage(info) {
      this.partialMessageEmitter.fire(info);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Reader received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageReader.AbstractMessageReader = AbstractMessageReader;
  var ResolvedMessageReaderOptions;
  (function(ResolvedMessageReaderOptions2) {
    function fromOptions(options2) {
      let charset;
      let contentDecoder;
      const contentDecoders = /* @__PURE__ */ new Map();
      let contentTypeDecoder;
      const contentTypeDecoders = /* @__PURE__ */ new Map();
      if (options2 === void 0 || typeof options2 === "string") {
        charset = options2 ?? "utf-8";
      } else {
        charset = options2.charset ?? "utf-8";
        if (options2.contentDecoder !== void 0) {
          contentDecoder = options2.contentDecoder;
          contentDecoders.set(contentDecoder.name, contentDecoder);
        }
        if (options2.contentDecoders !== void 0) {
          for (const decoder of options2.contentDecoders) {
            contentDecoders.set(decoder.name, decoder);
          }
        }
        if (options2.contentTypeDecoder !== void 0) {
          contentTypeDecoder = options2.contentTypeDecoder;
          contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
        }
        if (options2.contentTypeDecoders !== void 0) {
          for (const decoder of options2.contentTypeDecoders) {
            contentTypeDecoders.set(decoder.name, decoder);
          }
        }
      }
      if (contentTypeDecoder === void 0) {
        contentTypeDecoder = (0, ral_1.default)().applicationJson.decoder;
        contentTypeDecoders.set(contentTypeDecoder.name, contentTypeDecoder);
      }
      return { charset, contentDecoder, contentDecoders, contentTypeDecoder, contentTypeDecoders };
    }
    ResolvedMessageReaderOptions2.fromOptions = fromOptions;
  })(ResolvedMessageReaderOptions || (ResolvedMessageReaderOptions = {}));
  class ReadableStreamMessageReader extends AbstractMessageReader {
    constructor(readable, options2) {
      super();
      this.readable = readable;
      this.options = ResolvedMessageReaderOptions.fromOptions(options2);
      this.buffer = (0, ral_1.default)().messageBuffer.create(this.options.charset);
      this._partialMessageTimeout = 1e4;
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.readSemaphore = new semaphore_1.Semaphore(1);
    }
    set partialMessageTimeout(timeout) {
      this._partialMessageTimeout = timeout;
    }
    get partialMessageTimeout() {
      return this._partialMessageTimeout;
    }
    listen(callback) {
      this.nextMessageLength = -1;
      this.messageToken = 0;
      this.partialMessageTimer = void 0;
      this.callback = callback;
      const result2 = this.readable.onData((data) => {
        this.onData(data);
      });
      this.readable.onError((error) => this.fireError(error));
      this.readable.onClose(() => this.fireClose());
      return result2;
    }
    onData(data) {
      try {
        this.buffer.append(data);
        while (true) {
          if (this.nextMessageLength === -1) {
            const headers = this.buffer.tryReadHeaders(true);
            if (!headers) {
              return;
            }
            const contentLength = headers.get("content-length");
            if (!contentLength) {
              this.fireError(new Error(`Header must provide a Content-Length property.
${JSON.stringify(Object.fromEntries(headers))}`));
              return;
            }
            const length = parseInt(contentLength);
            if (isNaN(length)) {
              this.fireError(new Error(`Content-Length value must be a number. Got ${contentLength}`));
              return;
            }
            this.nextMessageLength = length;
          }
          const body = this.buffer.tryReadBody(this.nextMessageLength);
          if (body === void 0) {
            this.setPartialMessageTimer();
            return;
          }
          this.clearPartialMessageTimer();
          this.nextMessageLength = -1;
          this.readSemaphore.lock(async () => {
            const bytes = this.options.contentDecoder !== void 0 ? await this.options.contentDecoder.decode(body) : body;
            const message = await this.options.contentTypeDecoder.decode(bytes, this.options);
            this.callback(message);
          }).catch((error) => {
            this.fireError(error);
          });
        }
      } catch (error) {
        this.fireError(error);
      }
    }
    clearPartialMessageTimer() {
      if (this.partialMessageTimer) {
        this.partialMessageTimer.dispose();
        this.partialMessageTimer = void 0;
      }
    }
    setPartialMessageTimer() {
      this.clearPartialMessageTimer();
      if (this._partialMessageTimeout <= 0) {
        return;
      }
      this.partialMessageTimer = (0, ral_1.default)().timer.setTimeout((token, timeout) => {
        this.partialMessageTimer = void 0;
        if (token === this.messageToken) {
          this.firePartialMessage({ messageToken: token, waitingTime: timeout });
          this.setPartialMessageTimer();
        }
      }, this._partialMessageTimeout, this.messageToken, this._partialMessageTimeout);
    }
  }
  messageReader.ReadableStreamMessageReader = ReadableStreamMessageReader;
  return messageReader;
}
var messageWriter = {};
var hasRequiredMessageWriter;
function requireMessageWriter() {
  if (hasRequiredMessageWriter) return messageWriter;
  hasRequiredMessageWriter = 1;
  Object.defineProperty(messageWriter, "__esModule", { value: true });
  messageWriter.WriteableStreamMessageWriter = messageWriter.AbstractMessageWriter = messageWriter.MessageWriter = void 0;
  const ral_1 = requireRal();
  const Is2 = requireIs$1();
  const semaphore_1 = requireSemaphore();
  const events_1 = requireEvents();
  const ContentLength = "Content-Length: ";
  const CRLF = "\r\n";
  var MessageWriter;
  (function(MessageWriter2) {
    function is2(value) {
      let candidate = value;
      return candidate && Is2.func(candidate.dispose) && Is2.func(candidate.onClose) && Is2.func(candidate.onError) && Is2.func(candidate.write);
    }
    MessageWriter2.is = is2;
  })(MessageWriter || (messageWriter.MessageWriter = MessageWriter = {}));
  class AbstractMessageWriter {
    constructor() {
      this.errorEmitter = new events_1.Emitter();
      this.closeEmitter = new events_1.Emitter();
    }
    dispose() {
      this.errorEmitter.dispose();
      this.closeEmitter.dispose();
    }
    get onError() {
      return this.errorEmitter.event;
    }
    fireError(error, message, count) {
      this.errorEmitter.fire([this.asError(error), message, count]);
    }
    get onClose() {
      return this.closeEmitter.event;
    }
    fireClose() {
      this.closeEmitter.fire(void 0);
    }
    asError(error) {
      if (error instanceof Error) {
        return error;
      } else {
        return new Error(`Writer received error. Reason: ${Is2.string(error.message) ? error.message : "unknown"}`);
      }
    }
  }
  messageWriter.AbstractMessageWriter = AbstractMessageWriter;
  var ResolvedMessageWriterOptions;
  (function(ResolvedMessageWriterOptions2) {
    function fromOptions(options2) {
      if (options2 === void 0 || typeof options2 === "string") {
        return { charset: options2 ?? "utf-8", contentTypeEncoder: (0, ral_1.default)().applicationJson.encoder };
      } else {
        return { charset: options2.charset ?? "utf-8", contentEncoder: options2.contentEncoder, contentTypeEncoder: options2.contentTypeEncoder ?? (0, ral_1.default)().applicationJson.encoder };
      }
    }
    ResolvedMessageWriterOptions2.fromOptions = fromOptions;
  })(ResolvedMessageWriterOptions || (ResolvedMessageWriterOptions = {}));
  class WriteableStreamMessageWriter extends AbstractMessageWriter {
    constructor(writable, options2) {
      super();
      this.writable = writable;
      this.options = ResolvedMessageWriterOptions.fromOptions(options2);
      this.errorCount = 0;
      this.writeSemaphore = new semaphore_1.Semaphore(1);
      this.writable.onError((error) => this.fireError(error));
      this.writable.onClose(() => this.fireClose());
    }
    async write(msg) {
      return this.writeSemaphore.lock(async () => {
        const payload = this.options.contentTypeEncoder.encode(msg, this.options).then((buffer) => {
          if (this.options.contentEncoder !== void 0) {
            return this.options.contentEncoder.encode(buffer);
          } else {
            return buffer;
          }
        });
        return payload.then((buffer) => {
          const headers = [];
          headers.push(ContentLength, buffer.byteLength.toString(), CRLF);
          headers.push(CRLF);
          return this.doWrite(msg, headers, buffer);
        }, (error) => {
          this.fireError(error);
          throw error;
        });
      });
    }
    async doWrite(msg, headers, data) {
      try {
        await this.writable.write(headers.join(""), "ascii");
        return this.writable.write(data);
      } catch (error) {
        this.handleError(error, msg);
        return Promise.reject(error);
      }
    }
    handleError(error, msg) {
      this.errorCount++;
      this.fireError(error, msg, this.errorCount);
    }
    end() {
      this.writable.end();
    }
  }
  messageWriter.WriteableStreamMessageWriter = WriteableStreamMessageWriter;
  return messageWriter;
}
var messageBuffer = {};
var hasRequiredMessageBuffer;
function requireMessageBuffer() {
  if (hasRequiredMessageBuffer) return messageBuffer;
  hasRequiredMessageBuffer = 1;
  Object.defineProperty(messageBuffer, "__esModule", { value: true });
  messageBuffer.AbstractMessageBuffer = void 0;
  const CR = 13;
  const LF = 10;
  const CRLF = "\r\n";
  class AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      this._encoding = encoding;
      this._chunks = [];
      this._totalLength = 0;
    }
    get encoding() {
      return this._encoding;
    }
    append(chunk2) {
      const toAppend = typeof chunk2 === "string" ? this.fromString(chunk2, this._encoding) : chunk2;
      this._chunks.push(toAppend);
      this._totalLength += toAppend.byteLength;
    }
    tryReadHeaders(lowerCaseKeys = false) {
      if (this._chunks.length === 0) {
        return void 0;
      }
      let state = 0;
      let chunkIndex = 0;
      let offset2 = 0;
      let chunkBytesRead = 0;
      row: while (chunkIndex < this._chunks.length) {
        const chunk2 = this._chunks[chunkIndex];
        offset2 = 0;
        while (offset2 < chunk2.length) {
          const value = chunk2[offset2];
          switch (value) {
            case CR:
              switch (state) {
                case 0:
                  state = 1;
                  break;
                case 2:
                  state = 3;
                  break;
                default:
                  state = 0;
              }
              break;
            case LF:
              switch (state) {
                case 1:
                  state = 2;
                  break;
                case 3:
                  state = 4;
                  offset2++;
                  break row;
                default:
                  state = 0;
              }
              break;
            default:
              state = 0;
          }
          offset2++;
        }
        chunkBytesRead += chunk2.byteLength;
        chunkIndex++;
      }
      if (state !== 4) {
        return void 0;
      }
      const buffer = this._read(chunkBytesRead + offset2);
      const result2 = /* @__PURE__ */ new Map();
      const headers = this.toString(buffer, "ascii").split(CRLF);
      if (headers.length < 2) {
        return result2;
      }
      for (let i2 = 0; i2 < headers.length - 2; i2++) {
        const header = headers[i2];
        const index2 = header.indexOf(":");
        if (index2 === -1) {
          throw new Error(`Message header must separate key and value using ':'
${header}`);
        }
        const key = header.substr(0, index2);
        const value = header.substr(index2 + 1).trim();
        result2.set(lowerCaseKeys ? key.toLowerCase() : key, value);
      }
      return result2;
    }
    tryReadBody(length) {
      if (this._totalLength < length) {
        return void 0;
      }
      return this._read(length);
    }
    get numberOfBytes() {
      return this._totalLength;
    }
    _read(byteCount) {
      if (byteCount === 0) {
        return this.emptyBuffer();
      }
      if (byteCount > this._totalLength) {
        throw new Error(`Cannot read so many bytes!`);
      }
      if (this._chunks[0].byteLength === byteCount) {
        const chunk2 = this._chunks[0];
        this._chunks.shift();
        this._totalLength -= byteCount;
        return this.asNative(chunk2);
      }
      if (this._chunks[0].byteLength > byteCount) {
        const chunk2 = this._chunks[0];
        const result3 = this.asNative(chunk2, byteCount);
        this._chunks[0] = chunk2.slice(byteCount);
        this._totalLength -= byteCount;
        return result3;
      }
      const result2 = this.allocNative(byteCount);
      let resultOffset = 0;
      let chunkIndex = 0;
      while (byteCount > 0) {
        const chunk2 = this._chunks[chunkIndex];
        if (chunk2.byteLength > byteCount) {
          const chunkPart = chunk2.slice(0, byteCount);
          result2.set(chunkPart, resultOffset);
          resultOffset += byteCount;
          this._chunks[chunkIndex] = chunk2.slice(byteCount);
          this._totalLength -= byteCount;
          byteCount -= byteCount;
        } else {
          result2.set(chunk2, resultOffset);
          resultOffset += chunk2.byteLength;
          this._chunks.shift();
          this._totalLength -= chunk2.byteLength;
          byteCount -= chunk2.byteLength;
        }
      }
      return result2;
    }
  }
  messageBuffer.AbstractMessageBuffer = AbstractMessageBuffer;
  return messageBuffer;
}
var connection$1 = {};
var hasRequiredConnection$1;
function requireConnection$1() {
  if (hasRequiredConnection$1) return connection$1;
  hasRequiredConnection$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createMessageConnection = exports2.ConnectionOptions = exports2.MessageStrategy = exports2.CancellationStrategy = exports2.CancellationSenderStrategy = exports2.CancellationReceiverStrategy = exports2.RequestCancellationReceiverStrategy = exports2.IdCancellationReceiverStrategy = exports2.ConnectionStrategy = exports2.ConnectionError = exports2.ConnectionErrors = exports2.LogTraceNotification = exports2.SetTraceNotification = exports2.TraceFormat = exports2.TraceValues = exports2.Trace = exports2.NullLogger = exports2.ProgressType = exports2.ProgressToken = void 0;
    const ral_1 = requireRal();
    const Is2 = requireIs$1();
    const messages_1 = requireMessages$1();
    const linkedMap_1 = requireLinkedMap();
    const events_1 = requireEvents();
    const cancellation_1 = requireCancellation();
    var CancelNotification;
    (function(CancelNotification2) {
      CancelNotification2.type = new messages_1.NotificationType("$/cancelRequest");
    })(CancelNotification || (CancelNotification = {}));
    var ProgressToken;
    (function(ProgressToken2) {
      function is2(value) {
        return typeof value === "string" || typeof value === "number";
      }
      ProgressToken2.is = is2;
    })(ProgressToken || (exports2.ProgressToken = ProgressToken = {}));
    var ProgressNotification;
    (function(ProgressNotification2) {
      ProgressNotification2.type = new messages_1.NotificationType("$/progress");
    })(ProgressNotification || (ProgressNotification = {}));
    class ProgressType {
      constructor() {
      }
    }
    exports2.ProgressType = ProgressType;
    var StarRequestHandler;
    (function(StarRequestHandler2) {
      function is2(value) {
        return Is2.func(value);
      }
      StarRequestHandler2.is = is2;
    })(StarRequestHandler || (StarRequestHandler = {}));
    exports2.NullLogger = Object.freeze({
      error: () => {
      },
      warn: () => {
      },
      info: () => {
      },
      log: () => {
      }
    });
    var Trace;
    (function(Trace2) {
      Trace2[Trace2["Off"] = 0] = "Off";
      Trace2[Trace2["Messages"] = 1] = "Messages";
      Trace2[Trace2["Compact"] = 2] = "Compact";
      Trace2[Trace2["Verbose"] = 3] = "Verbose";
    })(Trace || (exports2.Trace = Trace = {}));
    var TraceValues;
    (function(TraceValues2) {
      TraceValues2.Off = "off";
      TraceValues2.Messages = "messages";
      TraceValues2.Compact = "compact";
      TraceValues2.Verbose = "verbose";
    })(TraceValues || (exports2.TraceValues = TraceValues = {}));
    (function(Trace2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return Trace2.Off;
        }
        value = value.toLowerCase();
        switch (value) {
          case "off":
            return Trace2.Off;
          case "messages":
            return Trace2.Messages;
          case "compact":
            return Trace2.Compact;
          case "verbose":
            return Trace2.Verbose;
          default:
            return Trace2.Off;
        }
      }
      Trace2.fromString = fromString;
      function toString2(value) {
        switch (value) {
          case Trace2.Off:
            return "off";
          case Trace2.Messages:
            return "messages";
          case Trace2.Compact:
            return "compact";
          case Trace2.Verbose:
            return "verbose";
          default:
            return "off";
        }
      }
      Trace2.toString = toString2;
    })(Trace || (exports2.Trace = Trace = {}));
    var TraceFormat;
    (function(TraceFormat2) {
      TraceFormat2["Text"] = "text";
      TraceFormat2["JSON"] = "json";
    })(TraceFormat || (exports2.TraceFormat = TraceFormat = {}));
    (function(TraceFormat2) {
      function fromString(value) {
        if (!Is2.string(value)) {
          return TraceFormat2.Text;
        }
        value = value.toLowerCase();
        if (value === "json") {
          return TraceFormat2.JSON;
        } else {
          return TraceFormat2.Text;
        }
      }
      TraceFormat2.fromString = fromString;
    })(TraceFormat || (exports2.TraceFormat = TraceFormat = {}));
    var SetTraceNotification;
    (function(SetTraceNotification2) {
      SetTraceNotification2.type = new messages_1.NotificationType("$/setTrace");
    })(SetTraceNotification || (exports2.SetTraceNotification = SetTraceNotification = {}));
    var LogTraceNotification;
    (function(LogTraceNotification2) {
      LogTraceNotification2.type = new messages_1.NotificationType("$/logTrace");
    })(LogTraceNotification || (exports2.LogTraceNotification = LogTraceNotification = {}));
    var ConnectionErrors;
    (function(ConnectionErrors2) {
      ConnectionErrors2[ConnectionErrors2["Closed"] = 1] = "Closed";
      ConnectionErrors2[ConnectionErrors2["Disposed"] = 2] = "Disposed";
      ConnectionErrors2[ConnectionErrors2["AlreadyListening"] = 3] = "AlreadyListening";
    })(ConnectionErrors || (exports2.ConnectionErrors = ConnectionErrors = {}));
    class ConnectionError extends Error {
      constructor(code2, message) {
        super(message);
        this.code = code2;
        Object.setPrototypeOf(this, ConnectionError.prototype);
      }
    }
    exports2.ConnectionError = ConnectionError;
    var ConnectionStrategy;
    (function(ConnectionStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.cancelUndispatched);
      }
      ConnectionStrategy2.is = is2;
    })(ConnectionStrategy || (exports2.ConnectionStrategy = ConnectionStrategy = {}));
    var IdCancellationReceiverStrategy;
    (function(IdCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.kind === void 0 || candidate.kind === "id") && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      IdCancellationReceiverStrategy2.is = is2;
    })(IdCancellationReceiverStrategy || (exports2.IdCancellationReceiverStrategy = IdCancellationReceiverStrategy = {}));
    var RequestCancellationReceiverStrategy;
    (function(RequestCancellationReceiverStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && candidate.kind === "request" && Is2.func(candidate.createCancellationTokenSource) && (candidate.dispose === void 0 || Is2.func(candidate.dispose));
      }
      RequestCancellationReceiverStrategy2.is = is2;
    })(RequestCancellationReceiverStrategy || (exports2.RequestCancellationReceiverStrategy = RequestCancellationReceiverStrategy = {}));
    var CancellationReceiverStrategy;
    (function(CancellationReceiverStrategy2) {
      CancellationReceiverStrategy2.Message = Object.freeze({
        createCancellationTokenSource(_2) {
          return new cancellation_1.CancellationTokenSource();
        }
      });
      function is2(value) {
        return IdCancellationReceiverStrategy.is(value) || RequestCancellationReceiverStrategy.is(value);
      }
      CancellationReceiverStrategy2.is = is2;
    })(CancellationReceiverStrategy || (exports2.CancellationReceiverStrategy = CancellationReceiverStrategy = {}));
    var CancellationSenderStrategy;
    (function(CancellationSenderStrategy2) {
      CancellationSenderStrategy2.Message = Object.freeze({
        sendCancellation(conn, id2) {
          return conn.sendNotification(CancelNotification.type, { id: id2 });
        },
        cleanup(_2) {
        }
      });
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.sendCancellation) && Is2.func(candidate.cleanup);
      }
      CancellationSenderStrategy2.is = is2;
    })(CancellationSenderStrategy || (exports2.CancellationSenderStrategy = CancellationSenderStrategy = {}));
    var CancellationStrategy;
    (function(CancellationStrategy2) {
      CancellationStrategy2.Message = Object.freeze({
        receiver: CancellationReceiverStrategy.Message,
        sender: CancellationSenderStrategy.Message
      });
      function is2(value) {
        const candidate = value;
        return candidate && CancellationReceiverStrategy.is(candidate.receiver) && CancellationSenderStrategy.is(candidate.sender);
      }
      CancellationStrategy2.is = is2;
    })(CancellationStrategy || (exports2.CancellationStrategy = CancellationStrategy = {}));
    var MessageStrategy;
    (function(MessageStrategy2) {
      function is2(value) {
        const candidate = value;
        return candidate && Is2.func(candidate.handleMessage);
      }
      MessageStrategy2.is = is2;
    })(MessageStrategy || (exports2.MessageStrategy = MessageStrategy = {}));
    var ConnectionOptions;
    (function(ConnectionOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (CancellationStrategy.is(candidate.cancellationStrategy) || ConnectionStrategy.is(candidate.connectionStrategy) || MessageStrategy.is(candidate.messageStrategy));
      }
      ConnectionOptions2.is = is2;
    })(ConnectionOptions || (exports2.ConnectionOptions = ConnectionOptions = {}));
    var ConnectionState;
    (function(ConnectionState2) {
      ConnectionState2[ConnectionState2["New"] = 1] = "New";
      ConnectionState2[ConnectionState2["Listening"] = 2] = "Listening";
      ConnectionState2[ConnectionState2["Closed"] = 3] = "Closed";
      ConnectionState2[ConnectionState2["Disposed"] = 4] = "Disposed";
    })(ConnectionState || (ConnectionState = {}));
    function createMessageConnection2(messageReader2, messageWriter2, _logger, options2) {
      const logger = _logger !== void 0 ? _logger : exports2.NullLogger;
      let sequenceNumber = 0;
      let notificationSequenceNumber = 0;
      let unknownResponseSequenceNumber = 0;
      const version2 = "2.0";
      let starRequestHandler = void 0;
      const requestHandlers = /* @__PURE__ */ new Map();
      let starNotificationHandler = void 0;
      const notificationHandlers = /* @__PURE__ */ new Map();
      const progressHandlers = /* @__PURE__ */ new Map();
      let timer;
      let messageQueue = new linkedMap_1.LinkedMap();
      let responsePromises = /* @__PURE__ */ new Map();
      let knownCanceledRequests = /* @__PURE__ */ new Set();
      let requestTokens = /* @__PURE__ */ new Map();
      let trace = Trace.Off;
      let traceFormat = TraceFormat.Text;
      let tracer;
      let state = ConnectionState.New;
      const errorEmitter = new events_1.Emitter();
      const closeEmitter = new events_1.Emitter();
      const unhandledNotificationEmitter = new events_1.Emitter();
      const unhandledProgressEmitter = new events_1.Emitter();
      const disposeEmitter = new events_1.Emitter();
      const cancellationStrategy = options2 && options2.cancellationStrategy ? options2.cancellationStrategy : CancellationStrategy.Message;
      function createRequestQueueKey(id2) {
        if (id2 === null) {
          throw new Error(`Can't send requests with id null since the response can't be correlated.`);
        }
        return "req-" + id2.toString();
      }
      function createResponseQueueKey(id2) {
        if (id2 === null) {
          return "res-unknown-" + (++unknownResponseSequenceNumber).toString();
        } else {
          return "res-" + id2.toString();
        }
      }
      function createNotificationQueueKey() {
        return "not-" + (++notificationSequenceNumber).toString();
      }
      function addMessageToQueue(queue, message) {
        if (messages_1.Message.isRequest(message)) {
          queue.set(createRequestQueueKey(message.id), message);
        } else if (messages_1.Message.isResponse(message)) {
          queue.set(createResponseQueueKey(message.id), message);
        } else {
          queue.set(createNotificationQueueKey(), message);
        }
      }
      function cancelUndispatched(_message) {
        return void 0;
      }
      function isListening() {
        return state === ConnectionState.Listening;
      }
      function isClosed() {
        return state === ConnectionState.Closed;
      }
      function isDisposed() {
        return state === ConnectionState.Disposed;
      }
      function closeHandler() {
        if (state === ConnectionState.New || state === ConnectionState.Listening) {
          state = ConnectionState.Closed;
          closeEmitter.fire(void 0);
        }
      }
      function readErrorHandler(error) {
        errorEmitter.fire([error, void 0, void 0]);
      }
      function writeErrorHandler(data) {
        errorEmitter.fire(data);
      }
      messageReader2.onClose(closeHandler);
      messageReader2.onError(readErrorHandler);
      messageWriter2.onClose(closeHandler);
      messageWriter2.onError(writeErrorHandler);
      function triggerMessageQueue() {
        if (timer || messageQueue.size === 0) {
          return;
        }
        timer = (0, ral_1.default)().timer.setImmediate(() => {
          timer = void 0;
          processMessageQueue();
        });
      }
      function handleMessage(message) {
        if (messages_1.Message.isRequest(message)) {
          handleRequest(message);
        } else if (messages_1.Message.isNotification(message)) {
          handleNotification(message);
        } else if (messages_1.Message.isResponse(message)) {
          handleResponse(message);
        } else {
          handleInvalidMessage(message);
        }
      }
      function processMessageQueue() {
        if (messageQueue.size === 0) {
          return;
        }
        const message = messageQueue.shift();
        try {
          const messageStrategy = options2?.messageStrategy;
          if (MessageStrategy.is(messageStrategy)) {
            messageStrategy.handleMessage(message, handleMessage);
          } else {
            handleMessage(message);
          }
        } finally {
          triggerMessageQueue();
        }
      }
      const callback = (message) => {
        try {
          if (messages_1.Message.isNotification(message) && message.method === CancelNotification.type.method) {
            const cancelId = message.params.id;
            const key = createRequestQueueKey(cancelId);
            const toCancel = messageQueue.get(key);
            if (messages_1.Message.isRequest(toCancel)) {
              const strategy = options2?.connectionStrategy;
              const response = strategy && strategy.cancelUndispatched ? strategy.cancelUndispatched(toCancel, cancelUndispatched) : cancelUndispatched(toCancel);
              if (response && (response.error !== void 0 || response.result !== void 0)) {
                messageQueue.delete(key);
                requestTokens.delete(cancelId);
                response.id = toCancel.id;
                traceSendingResponse(response, message.method, Date.now());
                messageWriter2.write(response).catch(() => logger.error(`Sending response for canceled message failed.`));
                return;
              }
            }
            const cancellationToken = requestTokens.get(cancelId);
            if (cancellationToken !== void 0) {
              cancellationToken.cancel();
              traceReceivedNotification(message);
              return;
            } else {
              knownCanceledRequests.add(cancelId);
            }
          }
          addMessageToQueue(messageQueue, message);
        } finally {
          triggerMessageQueue();
        }
      };
      function handleRequest(requestMessage) {
        if (isDisposed()) {
          return;
        }
        function reply(resultOrError, method, startTime2) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id
          };
          if (resultOrError instanceof messages_1.ResponseError) {
            message.error = resultOrError.toJson();
          } else {
            message.result = resultOrError === void 0 ? null : resultOrError;
          }
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replyError(error, method, startTime2) {
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            error: error.toJson()
          };
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        function replySuccess(result2, method, startTime2) {
          if (result2 === void 0) {
            result2 = null;
          }
          const message = {
            jsonrpc: version2,
            id: requestMessage.id,
            result: result2
          };
          traceSendingResponse(message, method, startTime2);
          messageWriter2.write(message).catch(() => logger.error(`Sending response failed.`));
        }
        traceReceivedRequest(requestMessage);
        const element2 = requestHandlers.get(requestMessage.method);
        let type;
        let requestHandler;
        if (element2) {
          type = element2.type;
          requestHandler = element2.handler;
        }
        const startTime = Date.now();
        if (requestHandler || starRequestHandler) {
          const tokenKey = requestMessage.id ?? String(Date.now());
          const cancellationSource = IdCancellationReceiverStrategy.is(cancellationStrategy.receiver) ? cancellationStrategy.receiver.createCancellationTokenSource(tokenKey) : cancellationStrategy.receiver.createCancellationTokenSource(requestMessage);
          if (requestMessage.id !== null && knownCanceledRequests.has(requestMessage.id)) {
            cancellationSource.cancel();
          }
          if (requestMessage.id !== null) {
            requestTokens.set(tokenKey, cancellationSource);
          }
          try {
            let handlerResult;
            if (requestHandler) {
              if (requestMessage.params === void 0) {
                if (type !== void 0 && type.numberOfParams !== 0) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines ${type.numberOfParams} params but received none.`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(cancellationSource.token);
              } else if (Array.isArray(requestMessage.params)) {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byName) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by name but received parameters by position`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(...requestMessage.params, cancellationSource.token);
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InvalidParams, `Request ${requestMessage.method} defines parameters by position but received parameters by name`), requestMessage.method, startTime);
                  return;
                }
                handlerResult = requestHandler(requestMessage.params, cancellationSource.token);
              }
            } else if (starRequestHandler) {
              handlerResult = starRequestHandler(requestMessage.method, requestMessage.params, cancellationSource.token);
            }
            const promise = handlerResult;
            if (!handlerResult) {
              requestTokens.delete(tokenKey);
              replySuccess(handlerResult, requestMessage.method, startTime);
            } else if (promise.then) {
              promise.then((resultOrError) => {
                requestTokens.delete(tokenKey);
                reply(resultOrError, requestMessage.method, startTime);
              }, (error) => {
                requestTokens.delete(tokenKey);
                if (error instanceof messages_1.ResponseError) {
                  replyError(error, requestMessage.method, startTime);
                } else if (error && Is2.string(error.message)) {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime);
                } else {
                  replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime);
                }
              });
            } else {
              requestTokens.delete(tokenKey);
              reply(handlerResult, requestMessage.method, startTime);
            }
          } catch (error) {
            requestTokens.delete(tokenKey);
            if (error instanceof messages_1.ResponseError) {
              reply(error, requestMessage.method, startTime);
            } else if (error && Is2.string(error.message)) {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed with message: ${error.message}`), requestMessage.method, startTime);
            } else {
              replyError(new messages_1.ResponseError(messages_1.ErrorCodes.InternalError, `Request ${requestMessage.method} failed unexpectedly without providing any details.`), requestMessage.method, startTime);
            }
          }
        } else {
          replyError(new messages_1.ResponseError(messages_1.ErrorCodes.MethodNotFound, `Unhandled method ${requestMessage.method}`), requestMessage.method, startTime);
        }
      }
      function handleResponse(responseMessage) {
        if (isDisposed()) {
          return;
        }
        if (responseMessage.id === null) {
          if (responseMessage.error) {
            logger.error(`Received response message without id: Error is: 
${JSON.stringify(responseMessage.error, void 0, 4)}`);
          } else {
            logger.error(`Received response message without id. No further error information provided.`);
          }
        } else {
          const key = responseMessage.id;
          const responsePromise = responsePromises.get(key);
          traceReceivedResponse(responseMessage, responsePromise);
          if (responsePromise !== void 0) {
            responsePromises.delete(key);
            try {
              if (responseMessage.error) {
                const error = responseMessage.error;
                responsePromise.reject(new messages_1.ResponseError(error.code, error.message, error.data));
              } else if (responseMessage.result !== void 0) {
                responsePromise.resolve(responseMessage.result);
              } else {
                throw new Error("Should never happen.");
              }
            } catch (error) {
              if (error.message) {
                logger.error(`Response handler '${responsePromise.method}' failed with message: ${error.message}`);
              } else {
                logger.error(`Response handler '${responsePromise.method}' failed unexpectedly.`);
              }
            }
          }
        }
      }
      function handleNotification(message) {
        if (isDisposed()) {
          return;
        }
        let type = void 0;
        let notificationHandler;
        if (message.method === CancelNotification.type.method) {
          const cancelId = message.params.id;
          knownCanceledRequests.delete(cancelId);
          traceReceivedNotification(message);
          return;
        } else {
          const element2 = notificationHandlers.get(message.method);
          if (element2) {
            notificationHandler = element2.handler;
            type = element2.type;
          }
        }
        if (notificationHandler || starNotificationHandler) {
          try {
            traceReceivedNotification(message);
            if (notificationHandler) {
              if (message.params === void 0) {
                if (type !== void 0) {
                  if (type.numberOfParams !== 0 && type.parameterStructures !== messages_1.ParameterStructures.byName) {
                    logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received none.`);
                  }
                }
                notificationHandler();
              } else if (Array.isArray(message.params)) {
                const params = message.params;
                if (message.method === ProgressNotification.type.method && params.length === 2 && ProgressToken.is(params[0])) {
                  notificationHandler({ token: params[0], value: params[1] });
                } else {
                  if (type !== void 0) {
                    if (type.parameterStructures === messages_1.ParameterStructures.byName) {
                      logger.error(`Notification ${message.method} defines parameters by name but received parameters by position`);
                    }
                    if (type.numberOfParams !== message.params.length) {
                      logger.error(`Notification ${message.method} defines ${type.numberOfParams} params but received ${params.length} arguments`);
                    }
                  }
                  notificationHandler(...params);
                }
              } else {
                if (type !== void 0 && type.parameterStructures === messages_1.ParameterStructures.byPosition) {
                  logger.error(`Notification ${message.method} defines parameters by position but received parameters by name`);
                }
                notificationHandler(message.params);
              }
            } else if (starNotificationHandler) {
              starNotificationHandler(message.method, message.params);
            }
          } catch (error) {
            if (error.message) {
              logger.error(`Notification handler '${message.method}' failed with message: ${error.message}`);
            } else {
              logger.error(`Notification handler '${message.method}' failed unexpectedly.`);
            }
          }
        } else {
          unhandledNotificationEmitter.fire(message);
        }
      }
      function handleInvalidMessage(message) {
        if (!message) {
          logger.error("Received empty message.");
          return;
        }
        logger.error(`Received message which is neither a response nor a notification message:
${JSON.stringify(message, null, 4)}`);
        const responseMessage = message;
        if (Is2.string(responseMessage.id) || Is2.number(responseMessage.id)) {
          const key = responseMessage.id;
          const responseHandler = responsePromises.get(key);
          if (responseHandler) {
            responseHandler.reject(new Error("The received response has neither a result nor an error property."));
          }
        }
      }
      function stringifyTrace(params) {
        if (params === void 0 || params === null) {
          return void 0;
        }
        switch (trace) {
          case Trace.Verbose:
            return JSON.stringify(params, null, 4);
          case Trace.Compact:
            return JSON.stringify(params);
          default:
            return void 0;
        }
      }
      function traceSendingRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Sending request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("send-request", message);
        }
      }
      function traceSendingNotification(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Sending notification '${message.method}'.`, data);
        } else {
          logLSPMessage("send-notification", message);
        }
      }
      function traceSendingResponse(message, method, startTime) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          tracer.log(`Sending response '${method} - (${message.id})'. Processing request took ${Date.now() - startTime}ms`, data);
        } else {
          logLSPMessage("send-response", message);
        }
      }
      function traceReceivedRequest(message) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if ((trace === Trace.Verbose || trace === Trace.Compact) && message.params) {
            data = `Params: ${stringifyTrace(message.params)}

`;
          }
          tracer.log(`Received request '${message.method} - (${message.id})'.`, data);
        } else {
          logLSPMessage("receive-request", message);
        }
      }
      function traceReceivedNotification(message) {
        if (trace === Trace.Off || !tracer || message.method === LogTraceNotification.type.method) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.params) {
              data = `Params: ${stringifyTrace(message.params)}

`;
            } else {
              data = "No parameters provided.\n\n";
            }
          }
          tracer.log(`Received notification '${message.method}'.`, data);
        } else {
          logLSPMessage("receive-notification", message);
        }
      }
      function traceReceivedResponse(message, responsePromise) {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        if (traceFormat === TraceFormat.Text) {
          let data = void 0;
          if (trace === Trace.Verbose || trace === Trace.Compact) {
            if (message.error && message.error.data) {
              data = `Error data: ${stringifyTrace(message.error.data)}

`;
            } else {
              if (message.result) {
                data = `Result: ${stringifyTrace(message.result)}

`;
              } else if (message.error === void 0) {
                data = "No result returned.\n\n";
              }
            }
          }
          if (responsePromise) {
            const error = message.error ? ` Request failed: ${message.error.message} (${message.error.code}).` : "";
            tracer.log(`Received response '${responsePromise.method} - (${message.id})' in ${Date.now() - responsePromise.timerStart}ms.${error}`, data);
          } else {
            tracer.log(`Received response ${message.id} without active response promise.`, data);
          }
        } else {
          logLSPMessage("receive-response", message);
        }
      }
      function logLSPMessage(type, message) {
        if (!tracer || trace === Trace.Off) {
          return;
        }
        const lspMessage = {
          isLSPMessage: true,
          type,
          message,
          timestamp: Date.now()
        };
        tracer.log(lspMessage);
      }
      function throwIfClosedOrDisposed() {
        if (isClosed()) {
          throw new ConnectionError(ConnectionErrors.Closed, "Connection is closed.");
        }
        if (isDisposed()) {
          throw new ConnectionError(ConnectionErrors.Disposed, "Connection is disposed.");
        }
      }
      function throwIfListening() {
        if (isListening()) {
          throw new ConnectionError(ConnectionErrors.AlreadyListening, "Connection is already listening");
        }
      }
      function throwIfNotListening() {
        if (!isListening()) {
          throw new Error("Call listen() first.");
        }
      }
      function undefinedToNull(param) {
        if (param === void 0) {
          return null;
        } else {
          return param;
        }
      }
      function nullToUndefined(param) {
        if (param === null) {
          return void 0;
        } else {
          return param;
        }
      }
      function isNamedParam(param) {
        return param !== void 0 && param !== null && !Array.isArray(param) && typeof param === "object";
      }
      function computeSingleParam(parameterStructures, param) {
        switch (parameterStructures) {
          case messages_1.ParameterStructures.auto:
            if (isNamedParam(param)) {
              return nullToUndefined(param);
            } else {
              return [undefinedToNull(param)];
            }
          case messages_1.ParameterStructures.byName:
            if (!isNamedParam(param)) {
              throw new Error(`Received parameters by name but param is not an object literal.`);
            }
            return nullToUndefined(param);
          case messages_1.ParameterStructures.byPosition:
            return [undefinedToNull(param)];
          default:
            throw new Error(`Unknown parameter structure ${parameterStructures.toString()}`);
        }
      }
      function computeMessageParams(type, params) {
        let result2;
        const numberOfParams = type.numberOfParams;
        switch (numberOfParams) {
          case 0:
            result2 = void 0;
            break;
          case 1:
            result2 = computeSingleParam(type.parameterStructures, params[0]);
            break;
          default:
            result2 = [];
            for (let i2 = 0; i2 < params.length && i2 < numberOfParams; i2++) {
              result2.push(undefinedToNull(params[i2]));
            }
            if (params.length < numberOfParams) {
              for (let i2 = params.length; i2 < numberOfParams; i2++) {
                result2.push(null);
              }
            }
            break;
        }
        return result2;
      }
      const connection2 = {
        sendNotification: (type, ...args) => {
          throwIfClosedOrDisposed();
          let method;
          let messageParams;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' notification parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
          }
          const notificationMessage = {
            jsonrpc: version2,
            method,
            params: messageParams
          };
          traceSendingNotification(notificationMessage);
          return messageWriter2.write(notificationMessage).catch((error) => {
            logger.error(`Sending notification failed.`);
            throw error;
          });
        },
        onNotification: (type, handler) => {
          throwIfClosedOrDisposed();
          let method;
          if (Is2.func(type)) {
            starNotificationHandler = type;
          } else if (handler) {
            if (Is2.string(type)) {
              method = type;
              notificationHandlers.set(type, { type: void 0, handler });
            } else {
              method = type.method;
              notificationHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method !== void 0) {
                notificationHandlers.delete(method);
              } else {
                starNotificationHandler = void 0;
              }
            }
          };
        },
        onProgress: (_type, token, handler) => {
          if (progressHandlers.has(token)) {
            throw new Error(`Progress handler for token ${token} already registered`);
          }
          progressHandlers.set(token, handler);
          return {
            dispose: () => {
              progressHandlers.delete(token);
            }
          };
        },
        sendProgress: (_type, token, value) => {
          return connection2.sendNotification(ProgressNotification.type, { token, value });
        },
        onUnhandledProgress: unhandledProgressEmitter.event,
        sendRequest: (type, ...args) => {
          throwIfClosedOrDisposed();
          throwIfNotListening();
          let method;
          let messageParams;
          let token = void 0;
          if (Is2.string(type)) {
            method = type;
            const first2 = args[0];
            const last2 = args[args.length - 1];
            let paramStart = 0;
            let parameterStructures = messages_1.ParameterStructures.auto;
            if (messages_1.ParameterStructures.is(first2)) {
              paramStart = 1;
              parameterStructures = first2;
            }
            let paramEnd = args.length;
            if (cancellation_1.CancellationToken.is(last2)) {
              paramEnd = paramEnd - 1;
              token = last2;
            }
            const numberOfParams = paramEnd - paramStart;
            switch (numberOfParams) {
              case 0:
                messageParams = void 0;
                break;
              case 1:
                messageParams = computeSingleParam(parameterStructures, args[paramStart]);
                break;
              default:
                if (parameterStructures === messages_1.ParameterStructures.byName) {
                  throw new Error(`Received ${numberOfParams} parameters for 'by Name' request parameter structure.`);
                }
                messageParams = args.slice(paramStart, paramEnd).map((value) => undefinedToNull(value));
                break;
            }
          } else {
            const params = args;
            method = type.method;
            messageParams = computeMessageParams(type, params);
            const numberOfParams = type.numberOfParams;
            token = cancellation_1.CancellationToken.is(params[numberOfParams]) ? params[numberOfParams] : void 0;
          }
          const id2 = sequenceNumber++;
          let disposable2;
          if (token) {
            disposable2 = token.onCancellationRequested(() => {
              const p2 = cancellationStrategy.sender.sendCancellation(connection2, id2);
              if (p2 === void 0) {
                logger.log(`Received no promise from cancellation strategy when cancelling id ${id2}`);
                return Promise.resolve();
              } else {
                return p2.catch(() => {
                  logger.log(`Sending cancellation messages for id ${id2} failed`);
                });
              }
            });
          }
          const requestMessage = {
            jsonrpc: version2,
            id: id2,
            method,
            params: messageParams
          };
          traceSendingRequest(requestMessage);
          if (typeof cancellationStrategy.sender.enableCancellation === "function") {
            cancellationStrategy.sender.enableCancellation(requestMessage);
          }
          return new Promise(async (resolve, reject2) => {
            const resolveWithCleanup = (r2) => {
              resolve(r2);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const rejectWithCleanup = (r2) => {
              reject2(r2);
              cancellationStrategy.sender.cleanup(id2);
              disposable2?.dispose();
            };
            const responsePromise = { method, timerStart: Date.now(), resolve: resolveWithCleanup, reject: rejectWithCleanup };
            try {
              responsePromises.set(id2, responsePromise);
              await messageWriter2.write(requestMessage);
            } catch (error) {
              responsePromises.delete(id2);
              responsePromise.reject(new messages_1.ResponseError(messages_1.ErrorCodes.MessageWriteError, error.message ? error.message : "Unknown reason"));
              logger.error(`Sending request failed.`);
              throw error;
            }
          });
        },
        onRequest: (type, handler) => {
          throwIfClosedOrDisposed();
          let method = null;
          if (StarRequestHandler.is(type)) {
            method = void 0;
            starRequestHandler = type;
          } else if (Is2.string(type)) {
            method = null;
            if (handler !== void 0) {
              method = type;
              requestHandlers.set(type, { handler, type: void 0 });
            }
          } else {
            if (handler !== void 0) {
              method = type.method;
              requestHandlers.set(type.method, { type, handler });
            }
          }
          return {
            dispose: () => {
              if (method === null) {
                return;
              }
              if (method !== void 0) {
                requestHandlers.delete(method);
              } else {
                starRequestHandler = void 0;
              }
            }
          };
        },
        hasPendingResponse: () => {
          return responsePromises.size > 0;
        },
        trace: async (_value, _tracer, sendNotificationOrTraceOptions) => {
          let _sendNotification = false;
          let _traceFormat = TraceFormat.Text;
          if (sendNotificationOrTraceOptions !== void 0) {
            if (Is2.boolean(sendNotificationOrTraceOptions)) {
              _sendNotification = sendNotificationOrTraceOptions;
            } else {
              _sendNotification = sendNotificationOrTraceOptions.sendNotification || false;
              _traceFormat = sendNotificationOrTraceOptions.traceFormat || TraceFormat.Text;
            }
          }
          trace = _value;
          traceFormat = _traceFormat;
          if (trace === Trace.Off) {
            tracer = void 0;
          } else {
            tracer = _tracer;
          }
          if (_sendNotification && !isClosed() && !isDisposed()) {
            await connection2.sendNotification(SetTraceNotification.type, { value: Trace.toString(_value) });
          }
        },
        onError: errorEmitter.event,
        onClose: closeEmitter.event,
        onUnhandledNotification: unhandledNotificationEmitter.event,
        onDispose: disposeEmitter.event,
        end: () => {
          messageWriter2.end();
        },
        dispose: () => {
          if (isDisposed()) {
            return;
          }
          state = ConnectionState.Disposed;
          disposeEmitter.fire(void 0);
          const error = new messages_1.ResponseError(messages_1.ErrorCodes.PendingResponseRejected, "Pending response rejected since connection got disposed");
          for (const promise of responsePromises.values()) {
            promise.reject(error);
          }
          responsePromises = /* @__PURE__ */ new Map();
          requestTokens = /* @__PURE__ */ new Map();
          knownCanceledRequests = /* @__PURE__ */ new Set();
          messageQueue = new linkedMap_1.LinkedMap();
          if (Is2.func(messageWriter2.dispose)) {
            messageWriter2.dispose();
          }
          if (Is2.func(messageReader2.dispose)) {
            messageReader2.dispose();
          }
        },
        listen: () => {
          throwIfClosedOrDisposed();
          throwIfListening();
          state = ConnectionState.Listening;
          messageReader2.listen(callback);
        },
        inspect: () => {
          (0, ral_1.default)().console.log("inspect");
        }
      };
      connection2.onNotification(LogTraceNotification.type, (params) => {
        if (trace === Trace.Off || !tracer) {
          return;
        }
        const verbose2 = trace === Trace.Verbose || trace === Trace.Compact;
        tracer.log(params.message, verbose2 ? params.verbose : void 0);
      });
      connection2.onNotification(ProgressNotification.type, (params) => {
        const handler = progressHandlers.get(params.token);
        if (handler) {
          handler(params.value);
        } else {
          unhandledProgressEmitter.fire(params);
        }
      });
      return connection2;
    }
    exports2.createMessageConnection = createMessageConnection2;
  })(connection$1);
  return connection$1;
}
var hasRequiredApi$1;
function requireApi$1() {
  if (hasRequiredApi$1) return api$1;
  hasRequiredApi$1 = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.ProgressType = exports2.ProgressToken = exports2.createMessageConnection = exports2.NullLogger = exports2.ConnectionOptions = exports2.ConnectionStrategy = exports2.AbstractMessageBuffer = exports2.WriteableStreamMessageWriter = exports2.AbstractMessageWriter = exports2.MessageWriter = exports2.ReadableStreamMessageReader = exports2.AbstractMessageReader = exports2.MessageReader = exports2.SharedArrayReceiverStrategy = exports2.SharedArraySenderStrategy = exports2.CancellationToken = exports2.CancellationTokenSource = exports2.Emitter = exports2.Event = exports2.Disposable = exports2.LRUCache = exports2.Touch = exports2.LinkedMap = exports2.ParameterStructures = exports2.NotificationType9 = exports2.NotificationType8 = exports2.NotificationType7 = exports2.NotificationType6 = exports2.NotificationType5 = exports2.NotificationType4 = exports2.NotificationType3 = exports2.NotificationType2 = exports2.NotificationType1 = exports2.NotificationType0 = exports2.NotificationType = exports2.ErrorCodes = exports2.ResponseError = exports2.RequestType9 = exports2.RequestType8 = exports2.RequestType7 = exports2.RequestType6 = exports2.RequestType5 = exports2.RequestType4 = exports2.RequestType3 = exports2.RequestType2 = exports2.RequestType1 = exports2.RequestType0 = exports2.RequestType = exports2.Message = exports2.RAL = void 0;
    exports2.MessageStrategy = exports2.CancellationStrategy = exports2.CancellationSenderStrategy = exports2.CancellationReceiverStrategy = exports2.ConnectionError = exports2.ConnectionErrors = exports2.LogTraceNotification = exports2.SetTraceNotification = exports2.TraceFormat = exports2.TraceValues = exports2.Trace = void 0;
    const messages_1 = requireMessages$1();
    Object.defineProperty(exports2, "Message", { enumerable: true, get: function() {
      return messages_1.Message;
    } });
    Object.defineProperty(exports2, "RequestType", { enumerable: true, get: function() {
      return messages_1.RequestType;
    } });
    Object.defineProperty(exports2, "RequestType0", { enumerable: true, get: function() {
      return messages_1.RequestType0;
    } });
    Object.defineProperty(exports2, "RequestType1", { enumerable: true, get: function() {
      return messages_1.RequestType1;
    } });
    Object.defineProperty(exports2, "RequestType2", { enumerable: true, get: function() {
      return messages_1.RequestType2;
    } });
    Object.defineProperty(exports2, "RequestType3", { enumerable: true, get: function() {
      return messages_1.RequestType3;
    } });
    Object.defineProperty(exports2, "RequestType4", { enumerable: true, get: function() {
      return messages_1.RequestType4;
    } });
    Object.defineProperty(exports2, "RequestType5", { enumerable: true, get: function() {
      return messages_1.RequestType5;
    } });
    Object.defineProperty(exports2, "RequestType6", { enumerable: true, get: function() {
      return messages_1.RequestType6;
    } });
    Object.defineProperty(exports2, "RequestType7", { enumerable: true, get: function() {
      return messages_1.RequestType7;
    } });
    Object.defineProperty(exports2, "RequestType8", { enumerable: true, get: function() {
      return messages_1.RequestType8;
    } });
    Object.defineProperty(exports2, "RequestType9", { enumerable: true, get: function() {
      return messages_1.RequestType9;
    } });
    Object.defineProperty(exports2, "ResponseError", { enumerable: true, get: function() {
      return messages_1.ResponseError;
    } });
    Object.defineProperty(exports2, "ErrorCodes", { enumerable: true, get: function() {
      return messages_1.ErrorCodes;
    } });
    Object.defineProperty(exports2, "NotificationType", { enumerable: true, get: function() {
      return messages_1.NotificationType;
    } });
    Object.defineProperty(exports2, "NotificationType0", { enumerable: true, get: function() {
      return messages_1.NotificationType0;
    } });
    Object.defineProperty(exports2, "NotificationType1", { enumerable: true, get: function() {
      return messages_1.NotificationType1;
    } });
    Object.defineProperty(exports2, "NotificationType2", { enumerable: true, get: function() {
      return messages_1.NotificationType2;
    } });
    Object.defineProperty(exports2, "NotificationType3", { enumerable: true, get: function() {
      return messages_1.NotificationType3;
    } });
    Object.defineProperty(exports2, "NotificationType4", { enumerable: true, get: function() {
      return messages_1.NotificationType4;
    } });
    Object.defineProperty(exports2, "NotificationType5", { enumerable: true, get: function() {
      return messages_1.NotificationType5;
    } });
    Object.defineProperty(exports2, "NotificationType6", { enumerable: true, get: function() {
      return messages_1.NotificationType6;
    } });
    Object.defineProperty(exports2, "NotificationType7", { enumerable: true, get: function() {
      return messages_1.NotificationType7;
    } });
    Object.defineProperty(exports2, "NotificationType8", { enumerable: true, get: function() {
      return messages_1.NotificationType8;
    } });
    Object.defineProperty(exports2, "NotificationType9", { enumerable: true, get: function() {
      return messages_1.NotificationType9;
    } });
    Object.defineProperty(exports2, "ParameterStructures", { enumerable: true, get: function() {
      return messages_1.ParameterStructures;
    } });
    const linkedMap_1 = requireLinkedMap();
    Object.defineProperty(exports2, "LinkedMap", { enumerable: true, get: function() {
      return linkedMap_1.LinkedMap;
    } });
    Object.defineProperty(exports2, "LRUCache", { enumerable: true, get: function() {
      return linkedMap_1.LRUCache;
    } });
    Object.defineProperty(exports2, "Touch", { enumerable: true, get: function() {
      return linkedMap_1.Touch;
    } });
    const disposable_1 = requireDisposable();
    Object.defineProperty(exports2, "Disposable", { enumerable: true, get: function() {
      return disposable_1.Disposable;
    } });
    const events_1 = requireEvents();
    Object.defineProperty(exports2, "Event", { enumerable: true, get: function() {
      return events_1.Event;
    } });
    Object.defineProperty(exports2, "Emitter", { enumerable: true, get: function() {
      return events_1.Emitter;
    } });
    const cancellation_1 = requireCancellation();
    Object.defineProperty(exports2, "CancellationTokenSource", { enumerable: true, get: function() {
      return cancellation_1.CancellationTokenSource;
    } });
    Object.defineProperty(exports2, "CancellationToken", { enumerable: true, get: function() {
      return cancellation_1.CancellationToken;
    } });
    const sharedArrayCancellation_1 = requireSharedArrayCancellation();
    Object.defineProperty(exports2, "SharedArraySenderStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArraySenderStrategy;
    } });
    Object.defineProperty(exports2, "SharedArrayReceiverStrategy", { enumerable: true, get: function() {
      return sharedArrayCancellation_1.SharedArrayReceiverStrategy;
    } });
    const messageReader_1 = requireMessageReader();
    Object.defineProperty(exports2, "MessageReader", { enumerable: true, get: function() {
      return messageReader_1.MessageReader;
    } });
    Object.defineProperty(exports2, "AbstractMessageReader", { enumerable: true, get: function() {
      return messageReader_1.AbstractMessageReader;
    } });
    Object.defineProperty(exports2, "ReadableStreamMessageReader", { enumerable: true, get: function() {
      return messageReader_1.ReadableStreamMessageReader;
    } });
    const messageWriter_1 = requireMessageWriter();
    Object.defineProperty(exports2, "MessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.MessageWriter;
    } });
    Object.defineProperty(exports2, "AbstractMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.AbstractMessageWriter;
    } });
    Object.defineProperty(exports2, "WriteableStreamMessageWriter", { enumerable: true, get: function() {
      return messageWriter_1.WriteableStreamMessageWriter;
    } });
    const messageBuffer_1 = requireMessageBuffer();
    Object.defineProperty(exports2, "AbstractMessageBuffer", { enumerable: true, get: function() {
      return messageBuffer_1.AbstractMessageBuffer;
    } });
    const connection_1 = requireConnection$1();
    Object.defineProperty(exports2, "ConnectionStrategy", { enumerable: true, get: function() {
      return connection_1.ConnectionStrategy;
    } });
    Object.defineProperty(exports2, "ConnectionOptions", { enumerable: true, get: function() {
      return connection_1.ConnectionOptions;
    } });
    Object.defineProperty(exports2, "NullLogger", { enumerable: true, get: function() {
      return connection_1.NullLogger;
    } });
    Object.defineProperty(exports2, "createMessageConnection", { enumerable: true, get: function() {
      return connection_1.createMessageConnection;
    } });
    Object.defineProperty(exports2, "ProgressToken", { enumerable: true, get: function() {
      return connection_1.ProgressToken;
    } });
    Object.defineProperty(exports2, "ProgressType", { enumerable: true, get: function() {
      return connection_1.ProgressType;
    } });
    Object.defineProperty(exports2, "Trace", { enumerable: true, get: function() {
      return connection_1.Trace;
    } });
    Object.defineProperty(exports2, "TraceValues", { enumerable: true, get: function() {
      return connection_1.TraceValues;
    } });
    Object.defineProperty(exports2, "TraceFormat", { enumerable: true, get: function() {
      return connection_1.TraceFormat;
    } });
    Object.defineProperty(exports2, "SetTraceNotification", { enumerable: true, get: function() {
      return connection_1.SetTraceNotification;
    } });
    Object.defineProperty(exports2, "LogTraceNotification", { enumerable: true, get: function() {
      return connection_1.LogTraceNotification;
    } });
    Object.defineProperty(exports2, "ConnectionErrors", { enumerable: true, get: function() {
      return connection_1.ConnectionErrors;
    } });
    Object.defineProperty(exports2, "ConnectionError", { enumerable: true, get: function() {
      return connection_1.ConnectionError;
    } });
    Object.defineProperty(exports2, "CancellationReceiverStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationReceiverStrategy;
    } });
    Object.defineProperty(exports2, "CancellationSenderStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationSenderStrategy;
    } });
    Object.defineProperty(exports2, "CancellationStrategy", { enumerable: true, get: function() {
      return connection_1.CancellationStrategy;
    } });
    Object.defineProperty(exports2, "MessageStrategy", { enumerable: true, get: function() {
      return connection_1.MessageStrategy;
    } });
    const ral_1 = requireRal();
    exports2.RAL = ral_1.default;
  })(api$1);
  return api$1;
}
var hasRequiredRil;
function requireRil() {
  if (hasRequiredRil) return ril;
  hasRequiredRil = 1;
  Object.defineProperty(ril, "__esModule", { value: true });
  const api_1 = requireApi$1();
  class MessageBuffer extends api_1.AbstractMessageBuffer {
    constructor(encoding = "utf-8") {
      super(encoding);
      this.asciiDecoder = new TextDecoder("ascii");
    }
    emptyBuffer() {
      return MessageBuffer.emptyBuffer;
    }
    fromString(value, _encoding) {
      return new TextEncoder().encode(value);
    }
    toString(value, encoding) {
      if (encoding === "ascii") {
        return this.asciiDecoder.decode(value);
      } else {
        return new TextDecoder(encoding).decode(value);
      }
    }
    asNative(buffer, length) {
      if (length === void 0) {
        return buffer;
      } else {
        return buffer.slice(0, length);
      }
    }
    allocNative(length) {
      return new Uint8Array(length);
    }
  }
  MessageBuffer.emptyBuffer = new Uint8Array(0);
  class ReadableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
      this._onData = new api_1.Emitter();
      this._messageListener = (event) => {
        const blob = event.data;
        blob.arrayBuffer().then((buffer) => {
          this._onData.fire(new Uint8Array(buffer));
        }, () => {
          (0, api_1.RAL)().console.error(`Converting blob to array buffer failed.`);
        });
      };
      this.socket.addEventListener("message", this._messageListener);
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    onData(listener) {
      return this._onData.event(listener);
    }
  }
  class WritableStreamWrapper {
    constructor(socket) {
      this.socket = socket;
    }
    onClose(listener) {
      this.socket.addEventListener("close", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("close", listener));
    }
    onError(listener) {
      this.socket.addEventListener("error", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("error", listener));
    }
    onEnd(listener) {
      this.socket.addEventListener("end", listener);
      return api_1.Disposable.create(() => this.socket.removeEventListener("end", listener));
    }
    write(data, encoding) {
      if (typeof data === "string") {
        if (encoding !== void 0 && encoding !== "utf-8") {
          throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${encoding}`);
        }
        this.socket.send(data);
      } else {
        this.socket.send(data);
      }
      return Promise.resolve();
    }
    end() {
      this.socket.close();
    }
  }
  const _textEncoder = new TextEncoder();
  const _ril = Object.freeze({
    messageBuffer: Object.freeze({
      create: (encoding) => new MessageBuffer(encoding)
    }),
    applicationJson: Object.freeze({
      encoder: Object.freeze({
        name: "application/json",
        encode: (msg, options2) => {
          if (options2.charset !== "utf-8") {
            throw new Error(`In a Browser environments only utf-8 text encoding is supported. But got encoding: ${options2.charset}`);
          }
          return Promise.resolve(_textEncoder.encode(JSON.stringify(msg, void 0, 0)));
        }
      }),
      decoder: Object.freeze({
        name: "application/json",
        decode: (buffer, options2) => {
          if (!(buffer instanceof Uint8Array)) {
            throw new Error(`In a Browser environments only Uint8Arrays are supported.`);
          }
          return Promise.resolve(JSON.parse(new TextDecoder(options2.charset).decode(buffer)));
        }
      })
    }),
    stream: Object.freeze({
      asReadableStream: (socket) => new ReadableStreamWrapper(socket),
      asWritableStream: (socket) => new WritableStreamWrapper(socket)
    }),
    console,
    timer: Object.freeze({
      setTimeout(callback, ms, ...args) {
        const handle = setTimeout(callback, ms, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setImmediate(callback, ...args) {
        const handle = setTimeout(callback, 0, ...args);
        return { dispose: () => clearTimeout(handle) };
      },
      setInterval(callback, ms, ...args) {
        const handle = setInterval(callback, ms, ...args);
        return { dispose: () => clearInterval(handle) };
      }
    })
  });
  function RIL() {
    return _ril;
  }
  (function(RIL2) {
    function install() {
      api_1.RAL.install(_ril);
    }
    RIL2.install = install;
  })(RIL || (RIL = {}));
  ril.default = RIL;
  return ril;
}
var hasRequiredMain$1;
function requireMain$1() {
  if (hasRequiredMain$1) return main$1;
  hasRequiredMain$1 = 1;
  (function(exports2) {
    var __createBinding = main$1 && main$1.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = main$1 && main$1.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createMessageConnection = exports2.BrowserMessageWriter = exports2.BrowserMessageReader = void 0;
    const ril_1 = requireRil();
    ril_1.default.install();
    const api_1 = requireApi$1();
    __exportStar(requireApi$1(), exports2);
    class BrowserMessageReader extends api_1.AbstractMessageReader {
      constructor(port) {
        super();
        this._onData = new api_1.Emitter();
        this._messageListener = (event) => {
          this._onData.fire(event.data);
        };
        port.addEventListener("error", (event) => this.fireError(event));
        port.onmessage = this._messageListener;
      }
      listen(callback) {
        return this._onData.event(callback);
      }
    }
    exports2.BrowserMessageReader = BrowserMessageReader;
    class BrowserMessageWriter extends api_1.AbstractMessageWriter {
      constructor(port) {
        super();
        this.port = port;
        this.errorCount = 0;
        port.addEventListener("error", (event) => this.fireError(event));
      }
      write(msg) {
        try {
          this.port.postMessage(msg);
          return Promise.resolve();
        } catch (error) {
          this.handleError(error, msg);
          return Promise.reject(error);
        }
      }
      handleError(error, msg) {
        this.errorCount++;
        this.fireError(error, msg, this.errorCount);
      }
      end() {
      }
    }
    exports2.BrowserMessageWriter = BrowserMessageWriter;
    function createMessageConnection2(reader, writer, logger, options2) {
      if (logger === void 0) {
        logger = api_1.NullLogger;
      }
      if (api_1.ConnectionStrategy.is(options2)) {
        options2 = { connectionStrategy: options2 };
      }
      return (0, api_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports2.createMessageConnection = createMessageConnection2;
  })(main$1);
  return main$1;
}
var browser$1;
var hasRequiredBrowser$1;
function requireBrowser$1() {
  if (hasRequiredBrowser$1) return browser$1;
  hasRequiredBrowser$1 = 1;
  browser$1 = requireMain$1();
  return browser$1;
}
var api = {};
var DocumentUri;
(function(DocumentUri2) {
  function is2(value) {
    return typeof value === "string";
  }
  DocumentUri2.is = is2;
})(DocumentUri || (DocumentUri = {}));
var URI;
(function(URI2) {
  function is2(value) {
    return typeof value === "string";
  }
  URI2.is = is2;
})(URI || (URI = {}));
var integer;
(function(integer2) {
  integer2.MIN_VALUE = -2147483648;
  integer2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && integer2.MIN_VALUE <= value && value <= integer2.MAX_VALUE;
  }
  integer2.is = is2;
})(integer || (integer = {}));
var uinteger;
(function(uinteger2) {
  uinteger2.MIN_VALUE = 0;
  uinteger2.MAX_VALUE = 2147483647;
  function is2(value) {
    return typeof value === "number" && uinteger2.MIN_VALUE <= value && value <= uinteger2.MAX_VALUE;
  }
  uinteger2.is = is2;
})(uinteger || (uinteger = {}));
var Position;
(function(Position2) {
  function create2(line2, character) {
    if (line2 === Number.MAX_VALUE) {
      line2 = uinteger.MAX_VALUE;
    }
    if (character === Number.MAX_VALUE) {
      character = uinteger.MAX_VALUE;
    }
    return { line: line2, character };
  }
  Position2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Is.uinteger(candidate.line) && Is.uinteger(candidate.character);
  }
  Position2.is = is2;
})(Position || (Position = {}));
var Range;
(function(Range5) {
  function create2(one, two, three, four) {
    if (Is.uinteger(one) && Is.uinteger(two) && Is.uinteger(three) && Is.uinteger(four)) {
      return { start: Position.create(one, two), end: Position.create(three, four) };
    } else if (Position.is(one) && Position.is(two)) {
      return { start: one, end: two };
    } else {
      throw new Error(`Range#create called with invalid arguments[${one}, ${two}, ${three}, ${four}]`);
    }
  }
  Range5.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Position.is(candidate.start) && Position.is(candidate.end);
  }
  Range5.is = is2;
})(Range || (Range = {}));
var Location;
(function(Location2) {
  function create2(uri, range2) {
    return { uri, range: range2 };
  }
  Location2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range.is(candidate.range) && (Is.string(candidate.uri) || Is.undefined(candidate.uri));
  }
  Location2.is = is2;
})(Location || (Location = {}));
var LocationLink;
(function(LocationLink2) {
  function create2(targetUri, targetRange, targetSelectionRange, originSelectionRange) {
    return { targetUri, targetRange, targetSelectionRange, originSelectionRange };
  }
  LocationLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range.is(candidate.targetRange) && Is.string(candidate.targetUri) && Range.is(candidate.targetSelectionRange) && (Range.is(candidate.originSelectionRange) || Is.undefined(candidate.originSelectionRange));
  }
  LocationLink2.is = is2;
})(LocationLink || (LocationLink = {}));
var Color;
(function(Color2) {
  function create2(red, green, blue, alpha) {
    return {
      red,
      green,
      blue,
      alpha
    };
  }
  Color2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.numberRange(candidate.red, 0, 1) && Is.numberRange(candidate.green, 0, 1) && Is.numberRange(candidate.blue, 0, 1) && Is.numberRange(candidate.alpha, 0, 1);
  }
  Color2.is = is2;
})(Color || (Color = {}));
var ColorInformation;
(function(ColorInformation2) {
  function create2(range2, color) {
    return {
      range: range2,
      color
    };
  }
  ColorInformation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Range.is(candidate.range) && Color.is(candidate.color);
  }
  ColorInformation2.is = is2;
})(ColorInformation || (ColorInformation = {}));
var ColorPresentation;
(function(ColorPresentation2) {
  function create2(label2, textEdit, additionalTextEdits) {
    return {
      label: label2,
      textEdit,
      additionalTextEdits
    };
  }
  ColorPresentation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.undefined(candidate.textEdit) || TextEdit.is(candidate)) && (Is.undefined(candidate.additionalTextEdits) || Is.typedArray(candidate.additionalTextEdits, TextEdit.is));
  }
  ColorPresentation2.is = is2;
})(ColorPresentation || (ColorPresentation = {}));
var FoldingRangeKind;
(function(FoldingRangeKind2) {
  FoldingRangeKind2.Comment = "comment";
  FoldingRangeKind2.Imports = "imports";
  FoldingRangeKind2.Region = "region";
})(FoldingRangeKind || (FoldingRangeKind = {}));
var FoldingRange;
(function(FoldingRange2) {
  function create2(startLine, endLine, startCharacter, endCharacter, kind, collapsedText) {
    const result2 = {
      startLine,
      endLine
    };
    if (Is.defined(startCharacter)) {
      result2.startCharacter = startCharacter;
    }
    if (Is.defined(endCharacter)) {
      result2.endCharacter = endCharacter;
    }
    if (Is.defined(kind)) {
      result2.kind = kind;
    }
    if (Is.defined(collapsedText)) {
      result2.collapsedText = collapsedText;
    }
    return result2;
  }
  FoldingRange2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.uinteger(candidate.startLine) && Is.uinteger(candidate.startLine) && (Is.undefined(candidate.startCharacter) || Is.uinteger(candidate.startCharacter)) && (Is.undefined(candidate.endCharacter) || Is.uinteger(candidate.endCharacter)) && (Is.undefined(candidate.kind) || Is.string(candidate.kind));
  }
  FoldingRange2.is = is2;
})(FoldingRange || (FoldingRange = {}));
var DiagnosticRelatedInformation;
(function(DiagnosticRelatedInformation2) {
  function create2(location, message) {
    return {
      location,
      message
    };
  }
  DiagnosticRelatedInformation2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Location.is(candidate.location) && Is.string(candidate.message);
  }
  DiagnosticRelatedInformation2.is = is2;
})(DiagnosticRelatedInformation || (DiagnosticRelatedInformation = {}));
var DiagnosticSeverity;
(function(DiagnosticSeverity2) {
  DiagnosticSeverity2.Error = 1;
  DiagnosticSeverity2.Warning = 2;
  DiagnosticSeverity2.Information = 3;
  DiagnosticSeverity2.Hint = 4;
})(DiagnosticSeverity || (DiagnosticSeverity = {}));
var DiagnosticTag;
(function(DiagnosticTag2) {
  DiagnosticTag2.Unnecessary = 1;
  DiagnosticTag2.Deprecated = 2;
})(DiagnosticTag || (DiagnosticTag = {}));
var CodeDescription;
(function(CodeDescription2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.href);
  }
  CodeDescription2.is = is2;
})(CodeDescription || (CodeDescription = {}));
var Diagnostic;
(function(Diagnostic2) {
  function create2(range2, message, severity, code2, source, relatedInformation) {
    let result2 = { range: range2, message };
    if (Is.defined(severity)) {
      result2.severity = severity;
    }
    if (Is.defined(code2)) {
      result2.code = code2;
    }
    if (Is.defined(source)) {
      result2.source = source;
    }
    if (Is.defined(relatedInformation)) {
      result2.relatedInformation = relatedInformation;
    }
    return result2;
  }
  Diagnostic2.create = create2;
  function is2(value) {
    var _a2;
    let candidate = value;
    return Is.defined(candidate) && Range.is(candidate.range) && Is.string(candidate.message) && (Is.number(candidate.severity) || Is.undefined(candidate.severity)) && (Is.integer(candidate.code) || Is.string(candidate.code) || Is.undefined(candidate.code)) && (Is.undefined(candidate.codeDescription) || Is.string((_a2 = candidate.codeDescription) === null || _a2 === void 0 ? void 0 : _a2.href)) && (Is.string(candidate.source) || Is.undefined(candidate.source)) && (Is.undefined(candidate.relatedInformation) || Is.typedArray(candidate.relatedInformation, DiagnosticRelatedInformation.is));
  }
  Diagnostic2.is = is2;
})(Diagnostic || (Diagnostic = {}));
var Command;
(function(Command5) {
  function create2(title, command2, ...args) {
    let result2 = { title, command: command2 };
    if (Is.defined(args) && args.length > 0) {
      result2.arguments = args;
    }
    return result2;
  }
  Command5.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.title) && Is.string(candidate.command);
  }
  Command5.is = is2;
})(Command || (Command = {}));
var TextEdit;
(function(TextEdit2) {
  function replace2(range2, newText) {
    return { range: range2, newText };
  }
  TextEdit2.replace = replace2;
  function insert2(position2, newText) {
    return { range: { start: position2, end: position2 }, newText };
  }
  TextEdit2.insert = insert2;
  function del(range2) {
    return { range: range2, newText: "" };
  }
  TextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.newText) && Range.is(candidate.range);
  }
  TextEdit2.is = is2;
})(TextEdit || (TextEdit = {}));
var ChangeAnnotation;
(function(ChangeAnnotation2) {
  function create2(label2, needsConfirmation, description) {
    const result2 = { label: label2 };
    if (needsConfirmation !== void 0) {
      result2.needsConfirmation = needsConfirmation;
    }
    if (description !== void 0) {
      result2.description = description;
    }
    return result2;
  }
  ChangeAnnotation2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Is.string(candidate.label) && (Is.boolean(candidate.needsConfirmation) || candidate.needsConfirmation === void 0) && (Is.string(candidate.description) || candidate.description === void 0);
  }
  ChangeAnnotation2.is = is2;
})(ChangeAnnotation || (ChangeAnnotation = {}));
var ChangeAnnotationIdentifier;
(function(ChangeAnnotationIdentifier2) {
  function is2(value) {
    const candidate = value;
    return Is.string(candidate);
  }
  ChangeAnnotationIdentifier2.is = is2;
})(ChangeAnnotationIdentifier || (ChangeAnnotationIdentifier = {}));
var AnnotatedTextEdit;
(function(AnnotatedTextEdit2) {
  function replace2(range2, newText, annotation) {
    return { range: range2, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.replace = replace2;
  function insert2(position2, newText, annotation) {
    return { range: { start: position2, end: position2 }, newText, annotationId: annotation };
  }
  AnnotatedTextEdit2.insert = insert2;
  function del(range2, annotation) {
    return { range: range2, newText: "", annotationId: annotation };
  }
  AnnotatedTextEdit2.del = del;
  function is2(value) {
    const candidate = value;
    return TextEdit.is(candidate) && (ChangeAnnotation.is(candidate.annotationId) || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  AnnotatedTextEdit2.is = is2;
})(AnnotatedTextEdit || (AnnotatedTextEdit = {}));
var TextDocumentEdit;
(function(TextDocumentEdit2) {
  function create2(textDocument, edits) {
    return { textDocument, edits };
  }
  TextDocumentEdit2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && OptionalVersionedTextDocumentIdentifier.is(candidate.textDocument) && Array.isArray(candidate.edits);
  }
  TextDocumentEdit2.is = is2;
})(TextDocumentEdit || (TextDocumentEdit = {}));
var CreateFile;
(function(CreateFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "create",
      uri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  CreateFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "create" && Is.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  CreateFile2.is = is2;
})(CreateFile || (CreateFile = {}));
var RenameFile;
(function(RenameFile2) {
  function create2(oldUri, newUri, options2, annotation) {
    let result2 = {
      kind: "rename",
      oldUri,
      newUri
    };
    if (options2 !== void 0 && (options2.overwrite !== void 0 || options2.ignoreIfExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  RenameFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "rename" && Is.string(candidate.oldUri) && Is.string(candidate.newUri) && (candidate.options === void 0 || (candidate.options.overwrite === void 0 || Is.boolean(candidate.options.overwrite)) && (candidate.options.ignoreIfExists === void 0 || Is.boolean(candidate.options.ignoreIfExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  RenameFile2.is = is2;
})(RenameFile || (RenameFile = {}));
var DeleteFile;
(function(DeleteFile2) {
  function create2(uri, options2, annotation) {
    let result2 = {
      kind: "delete",
      uri
    };
    if (options2 !== void 0 && (options2.recursive !== void 0 || options2.ignoreIfNotExists !== void 0)) {
      result2.options = options2;
    }
    if (annotation !== void 0) {
      result2.annotationId = annotation;
    }
    return result2;
  }
  DeleteFile2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && candidate.kind === "delete" && Is.string(candidate.uri) && (candidate.options === void 0 || (candidate.options.recursive === void 0 || Is.boolean(candidate.options.recursive)) && (candidate.options.ignoreIfNotExists === void 0 || Is.boolean(candidate.options.ignoreIfNotExists))) && (candidate.annotationId === void 0 || ChangeAnnotationIdentifier.is(candidate.annotationId));
  }
  DeleteFile2.is = is2;
})(DeleteFile || (DeleteFile = {}));
var WorkspaceEdit;
(function(WorkspaceEdit2) {
  function is2(value) {
    let candidate = value;
    return candidate && (candidate.changes !== void 0 || candidate.documentChanges !== void 0) && (candidate.documentChanges === void 0 || candidate.documentChanges.every((change) => {
      if (Is.string(change.kind)) {
        return CreateFile.is(change) || RenameFile.is(change) || DeleteFile.is(change);
      } else {
        return TextDocumentEdit.is(change);
      }
    }));
  }
  WorkspaceEdit2.is = is2;
})(WorkspaceEdit || (WorkspaceEdit = {}));
class TextEditChangeImpl {
  constructor(edits, changeAnnotations) {
    this.edits = edits;
    this.changeAnnotations = changeAnnotations;
  }
  insert(position2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.insert(position2, newText);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.insert(position2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.insert(position2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  replace(range2, newText, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.replace(range2, newText);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.replace(range2, newText, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.replace(range2, newText, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  delete(range2, annotation) {
    let edit;
    let id2;
    if (annotation === void 0) {
      edit = TextEdit.del(range2);
    } else if (ChangeAnnotationIdentifier.is(annotation)) {
      id2 = annotation;
      edit = AnnotatedTextEdit.del(range2, annotation);
    } else {
      this.assertChangeAnnotations(this.changeAnnotations);
      id2 = this.changeAnnotations.manage(annotation);
      edit = AnnotatedTextEdit.del(range2, id2);
    }
    this.edits.push(edit);
    if (id2 !== void 0) {
      return id2;
    }
  }
  add(edit) {
    this.edits.push(edit);
  }
  all() {
    return this.edits;
  }
  clear() {
    this.edits.splice(0, this.edits.length);
  }
  assertChangeAnnotations(value) {
    if (value === void 0) {
      throw new Error(`Text edit change is not configured to manage change annotations.`);
    }
  }
}
class ChangeAnnotations {
  constructor(annotations) {
    this._annotations = annotations === void 0 ? /* @__PURE__ */ Object.create(null) : annotations;
    this._counter = 0;
    this._size = 0;
  }
  all() {
    return this._annotations;
  }
  get size() {
    return this._size;
  }
  manage(idOrAnnotation, annotation) {
    let id2;
    if (ChangeAnnotationIdentifier.is(idOrAnnotation)) {
      id2 = idOrAnnotation;
    } else {
      id2 = this.nextId();
      annotation = idOrAnnotation;
    }
    if (this._annotations[id2] !== void 0) {
      throw new Error(`Id ${id2} is already in use.`);
    }
    if (annotation === void 0) {
      throw new Error(`No annotation provided for id ${id2}`);
    }
    this._annotations[id2] = annotation;
    this._size++;
    return id2;
  }
  nextId() {
    this._counter++;
    return this._counter.toString();
  }
}
class WorkspaceChange {
  constructor(workspaceEdit) {
    this._textEditChanges = /* @__PURE__ */ Object.create(null);
    if (workspaceEdit !== void 0) {
      this._workspaceEdit = workspaceEdit;
      if (workspaceEdit.documentChanges) {
        this._changeAnnotations = new ChangeAnnotations(workspaceEdit.changeAnnotations);
        workspaceEdit.changeAnnotations = this._changeAnnotations.all();
        workspaceEdit.documentChanges.forEach((change) => {
          if (TextDocumentEdit.is(change)) {
            const textEditChange = new TextEditChangeImpl(change.edits, this._changeAnnotations);
            this._textEditChanges[change.textDocument.uri] = textEditChange;
          }
        });
      } else if (workspaceEdit.changes) {
        Object.keys(workspaceEdit.changes).forEach((key) => {
          const textEditChange = new TextEditChangeImpl(workspaceEdit.changes[key]);
          this._textEditChanges[key] = textEditChange;
        });
      }
    } else {
      this._workspaceEdit = {};
    }
  }
  /**
   * Returns the underlying {@link WorkspaceEdit} literal
   * use to be returned from a workspace edit operation like rename.
   */
  get edit() {
    this.initDocumentChanges();
    if (this._changeAnnotations !== void 0) {
      if (this._changeAnnotations.size === 0) {
        this._workspaceEdit.changeAnnotations = void 0;
      } else {
        this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
      }
    }
    return this._workspaceEdit;
  }
  getTextEditChange(key) {
    if (OptionalVersionedTextDocumentIdentifier.is(key)) {
      this.initDocumentChanges();
      if (this._workspaceEdit.documentChanges === void 0) {
        throw new Error("Workspace edit is not configured for document changes.");
      }
      const textDocument = { uri: key.uri, version: key.version };
      let result2 = this._textEditChanges[textDocument.uri];
      if (!result2) {
        const edits = [];
        const textDocumentEdit = {
          textDocument,
          edits
        };
        this._workspaceEdit.documentChanges.push(textDocumentEdit);
        result2 = new TextEditChangeImpl(edits, this._changeAnnotations);
        this._textEditChanges[textDocument.uri] = result2;
      }
      return result2;
    } else {
      this.initChanges();
      if (this._workspaceEdit.changes === void 0) {
        throw new Error("Workspace edit is not configured for normal text edit changes.");
      }
      let result2 = this._textEditChanges[key];
      if (!result2) {
        let edits = [];
        this._workspaceEdit.changes[key] = edits;
        result2 = new TextEditChangeImpl(edits);
        this._textEditChanges[key] = result2;
      }
      return result2;
    }
  }
  initDocumentChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._changeAnnotations = new ChangeAnnotations();
      this._workspaceEdit.documentChanges = [];
      this._workspaceEdit.changeAnnotations = this._changeAnnotations.all();
    }
  }
  initChanges() {
    if (this._workspaceEdit.documentChanges === void 0 && this._workspaceEdit.changes === void 0) {
      this._workspaceEdit.changes = /* @__PURE__ */ Object.create(null);
    }
  }
  createFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = CreateFile.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = CreateFile.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  renameFile(oldUri, newUri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = RenameFile.create(oldUri, newUri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = RenameFile.create(oldUri, newUri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
  deleteFile(uri, optionsOrAnnotation, options2) {
    this.initDocumentChanges();
    if (this._workspaceEdit.documentChanges === void 0) {
      throw new Error("Workspace edit is not configured for document changes.");
    }
    let annotation;
    if (ChangeAnnotation.is(optionsOrAnnotation) || ChangeAnnotationIdentifier.is(optionsOrAnnotation)) {
      annotation = optionsOrAnnotation;
    } else {
      options2 = optionsOrAnnotation;
    }
    let operation;
    let id2;
    if (annotation === void 0) {
      operation = DeleteFile.create(uri, options2);
    } else {
      id2 = ChangeAnnotationIdentifier.is(annotation) ? annotation : this._changeAnnotations.manage(annotation);
      operation = DeleteFile.create(uri, options2, id2);
    }
    this._workspaceEdit.documentChanges.push(operation);
    if (id2 !== void 0) {
      return id2;
    }
  }
}
var TextDocumentIdentifier;
(function(TextDocumentIdentifier2) {
  function create2(uri) {
    return { uri };
  }
  TextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri);
  }
  TextDocumentIdentifier2.is = is2;
})(TextDocumentIdentifier || (TextDocumentIdentifier = {}));
var VersionedTextDocumentIdentifier;
(function(VersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  VersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && Is.integer(candidate.version);
  }
  VersionedTextDocumentIdentifier2.is = is2;
})(VersionedTextDocumentIdentifier || (VersionedTextDocumentIdentifier = {}));
var OptionalVersionedTextDocumentIdentifier;
(function(OptionalVersionedTextDocumentIdentifier2) {
  function create2(uri, version2) {
    return { uri, version: version2 };
  }
  OptionalVersionedTextDocumentIdentifier2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && (candidate.version === null || Is.integer(candidate.version));
  }
  OptionalVersionedTextDocumentIdentifier2.is = is2;
})(OptionalVersionedTextDocumentIdentifier || (OptionalVersionedTextDocumentIdentifier = {}));
var TextDocumentItem;
(function(TextDocumentItem2) {
  function create2(uri, languageId, version2, text2) {
    return { uri, languageId, version: version2, text: text2 };
  }
  TextDocumentItem2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && Is.string(candidate.languageId) && Is.integer(candidate.version) && Is.string(candidate.text);
  }
  TextDocumentItem2.is = is2;
})(TextDocumentItem || (TextDocumentItem = {}));
var MarkupKind;
(function(MarkupKind2) {
  MarkupKind2.PlainText = "plaintext";
  MarkupKind2.Markdown = "markdown";
  function is2(value) {
    const candidate = value;
    return candidate === MarkupKind2.PlainText || candidate === MarkupKind2.Markdown;
  }
  MarkupKind2.is = is2;
})(MarkupKind || (MarkupKind = {}));
var MarkupContent;
(function(MarkupContent2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(value) && MarkupKind.is(candidate.kind) && Is.string(candidate.value);
  }
  MarkupContent2.is = is2;
})(MarkupContent || (MarkupContent = {}));
var CompletionItemKind;
(function(CompletionItemKind2) {
  CompletionItemKind2.Text = 1;
  CompletionItemKind2.Method = 2;
  CompletionItemKind2.Function = 3;
  CompletionItemKind2.Constructor = 4;
  CompletionItemKind2.Field = 5;
  CompletionItemKind2.Variable = 6;
  CompletionItemKind2.Class = 7;
  CompletionItemKind2.Interface = 8;
  CompletionItemKind2.Module = 9;
  CompletionItemKind2.Property = 10;
  CompletionItemKind2.Unit = 11;
  CompletionItemKind2.Value = 12;
  CompletionItemKind2.Enum = 13;
  CompletionItemKind2.Keyword = 14;
  CompletionItemKind2.Snippet = 15;
  CompletionItemKind2.Color = 16;
  CompletionItemKind2.File = 17;
  CompletionItemKind2.Reference = 18;
  CompletionItemKind2.Folder = 19;
  CompletionItemKind2.EnumMember = 20;
  CompletionItemKind2.Constant = 21;
  CompletionItemKind2.Struct = 22;
  CompletionItemKind2.Event = 23;
  CompletionItemKind2.Operator = 24;
  CompletionItemKind2.TypeParameter = 25;
})(CompletionItemKind || (CompletionItemKind = {}));
var InsertTextFormat;
(function(InsertTextFormat2) {
  InsertTextFormat2.PlainText = 1;
  InsertTextFormat2.Snippet = 2;
})(InsertTextFormat || (InsertTextFormat = {}));
var CompletionItemTag;
(function(CompletionItemTag2) {
  CompletionItemTag2.Deprecated = 1;
})(CompletionItemTag || (CompletionItemTag = {}));
var InsertReplaceEdit;
(function(InsertReplaceEdit2) {
  function create2(newText, insert2, replace2) {
    return { newText, insert: insert2, replace: replace2 };
  }
  InsertReplaceEdit2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate && Is.string(candidate.newText) && Range.is(candidate.insert) && Range.is(candidate.replace);
  }
  InsertReplaceEdit2.is = is2;
})(InsertReplaceEdit || (InsertReplaceEdit = {}));
var InsertTextMode;
(function(InsertTextMode2) {
  InsertTextMode2.asIs = 1;
  InsertTextMode2.adjustIndentation = 2;
})(InsertTextMode || (InsertTextMode = {}));
var CompletionItemLabelDetails;
(function(CompletionItemLabelDetails2) {
  function is2(value) {
    const candidate = value;
    return candidate && (Is.string(candidate.detail) || candidate.detail === void 0) && (Is.string(candidate.description) || candidate.description === void 0);
  }
  CompletionItemLabelDetails2.is = is2;
})(CompletionItemLabelDetails || (CompletionItemLabelDetails = {}));
var CompletionItem;
(function(CompletionItem2) {
  function create2(label2) {
    return { label: label2 };
  }
  CompletionItem2.create = create2;
})(CompletionItem || (CompletionItem = {}));
var CompletionList;
(function(CompletionList2) {
  function create2(items, isIncomplete) {
    return { items: items ? items : [], isIncomplete: !!isIncomplete };
  }
  CompletionList2.create = create2;
})(CompletionList || (CompletionList = {}));
var MarkedString;
(function(MarkedString2) {
  function fromPlainText(plainText) {
    return plainText.replace(/[\\`*_{}[\]()#+\-.!]/g, "\\$&");
  }
  MarkedString2.fromPlainText = fromPlainText;
  function is2(value) {
    const candidate = value;
    return Is.string(candidate) || Is.objectLiteral(candidate) && Is.string(candidate.language) && Is.string(candidate.value);
  }
  MarkedString2.is = is2;
})(MarkedString || (MarkedString = {}));
var Hover;
(function(Hover2) {
  function is2(value) {
    let candidate = value;
    return !!candidate && Is.objectLiteral(candidate) && (MarkupContent.is(candidate.contents) || MarkedString.is(candidate.contents) || Is.typedArray(candidate.contents, MarkedString.is)) && (value.range === void 0 || Range.is(value.range));
  }
  Hover2.is = is2;
})(Hover || (Hover = {}));
var ParameterInformation;
(function(ParameterInformation2) {
  function create2(label2, documentation) {
    return documentation ? { label: label2, documentation } : { label: label2 };
  }
  ParameterInformation2.create = create2;
})(ParameterInformation || (ParameterInformation = {}));
var SignatureInformation;
(function(SignatureInformation2) {
  function create2(label2, documentation, ...parameters) {
    let result2 = { label: label2 };
    if (Is.defined(documentation)) {
      result2.documentation = documentation;
    }
    if (Is.defined(parameters)) {
      result2.parameters = parameters;
    } else {
      result2.parameters = [];
    }
    return result2;
  }
  SignatureInformation2.create = create2;
})(SignatureInformation || (SignatureInformation = {}));
var DocumentHighlightKind;
(function(DocumentHighlightKind2) {
  DocumentHighlightKind2.Text = 1;
  DocumentHighlightKind2.Read = 2;
  DocumentHighlightKind2.Write = 3;
})(DocumentHighlightKind || (DocumentHighlightKind = {}));
var DocumentHighlight;
(function(DocumentHighlight2) {
  function create2(range2, kind) {
    let result2 = { range: range2 };
    if (Is.number(kind)) {
      result2.kind = kind;
    }
    return result2;
  }
  DocumentHighlight2.create = create2;
})(DocumentHighlight || (DocumentHighlight = {}));
var SymbolKind;
(function(SymbolKind2) {
  SymbolKind2.File = 1;
  SymbolKind2.Module = 2;
  SymbolKind2.Namespace = 3;
  SymbolKind2.Package = 4;
  SymbolKind2.Class = 5;
  SymbolKind2.Method = 6;
  SymbolKind2.Property = 7;
  SymbolKind2.Field = 8;
  SymbolKind2.Constructor = 9;
  SymbolKind2.Enum = 10;
  SymbolKind2.Interface = 11;
  SymbolKind2.Function = 12;
  SymbolKind2.Variable = 13;
  SymbolKind2.Constant = 14;
  SymbolKind2.String = 15;
  SymbolKind2.Number = 16;
  SymbolKind2.Boolean = 17;
  SymbolKind2.Array = 18;
  SymbolKind2.Object = 19;
  SymbolKind2.Key = 20;
  SymbolKind2.Null = 21;
  SymbolKind2.EnumMember = 22;
  SymbolKind2.Struct = 23;
  SymbolKind2.Event = 24;
  SymbolKind2.Operator = 25;
  SymbolKind2.TypeParameter = 26;
})(SymbolKind || (SymbolKind = {}));
var SymbolTag;
(function(SymbolTag2) {
  SymbolTag2.Deprecated = 1;
})(SymbolTag || (SymbolTag = {}));
var SymbolInformation;
(function(SymbolInformation2) {
  function create2(name2, kind, range2, uri, containerName) {
    let result2 = {
      name: name2,
      kind,
      location: { uri, range: range2 }
    };
    if (containerName) {
      result2.containerName = containerName;
    }
    return result2;
  }
  SymbolInformation2.create = create2;
})(SymbolInformation || (SymbolInformation = {}));
var WorkspaceSymbol;
(function(WorkspaceSymbol2) {
  function create2(name2, kind, uri, range2) {
    return range2 !== void 0 ? { name: name2, kind, location: { uri, range: range2 } } : { name: name2, kind, location: { uri } };
  }
  WorkspaceSymbol2.create = create2;
})(WorkspaceSymbol || (WorkspaceSymbol = {}));
var DocumentSymbol;
(function(DocumentSymbol2) {
  function create2(name2, detail, kind, range2, selectionRange, children) {
    let result2 = {
      name: name2,
      detail,
      kind,
      range: range2,
      selectionRange
    };
    if (children !== void 0) {
      result2.children = children;
    }
    return result2;
  }
  DocumentSymbol2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is.string(candidate.name) && Is.number(candidate.kind) && Range.is(candidate.range) && Range.is(candidate.selectionRange) && (candidate.detail === void 0 || Is.string(candidate.detail)) && (candidate.deprecated === void 0 || Is.boolean(candidate.deprecated)) && (candidate.children === void 0 || Array.isArray(candidate.children)) && (candidate.tags === void 0 || Array.isArray(candidate.tags));
  }
  DocumentSymbol2.is = is2;
})(DocumentSymbol || (DocumentSymbol = {}));
var CodeActionKind;
(function(CodeActionKind2) {
  CodeActionKind2.Empty = "";
  CodeActionKind2.QuickFix = "quickfix";
  CodeActionKind2.Refactor = "refactor";
  CodeActionKind2.RefactorExtract = "refactor.extract";
  CodeActionKind2.RefactorInline = "refactor.inline";
  CodeActionKind2.RefactorRewrite = "refactor.rewrite";
  CodeActionKind2.Source = "source";
  CodeActionKind2.SourceOrganizeImports = "source.organizeImports";
  CodeActionKind2.SourceFixAll = "source.fixAll";
})(CodeActionKind || (CodeActionKind = {}));
var CodeActionTriggerKind;
(function(CodeActionTriggerKind2) {
  CodeActionTriggerKind2.Invoked = 1;
  CodeActionTriggerKind2.Automatic = 2;
})(CodeActionTriggerKind || (CodeActionTriggerKind = {}));
var CodeActionContext;
(function(CodeActionContext2) {
  function create2(diagnostics, only, triggerKind) {
    let result2 = { diagnostics };
    if (only !== void 0 && only !== null) {
      result2.only = only;
    }
    if (triggerKind !== void 0 && triggerKind !== null) {
      result2.triggerKind = triggerKind;
    }
    return result2;
  }
  CodeActionContext2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.typedArray(candidate.diagnostics, Diagnostic.is) && (candidate.only === void 0 || Is.typedArray(candidate.only, Is.string)) && (candidate.triggerKind === void 0 || candidate.triggerKind === CodeActionTriggerKind.Invoked || candidate.triggerKind === CodeActionTriggerKind.Automatic);
  }
  CodeActionContext2.is = is2;
})(CodeActionContext || (CodeActionContext = {}));
var CodeAction;
(function(CodeAction2) {
  function create2(title, kindOrCommandOrEdit, kind) {
    let result2 = { title };
    let checkKind = true;
    if (typeof kindOrCommandOrEdit === "string") {
      checkKind = false;
      result2.kind = kindOrCommandOrEdit;
    } else if (Command.is(kindOrCommandOrEdit)) {
      result2.command = kindOrCommandOrEdit;
    } else {
      result2.edit = kindOrCommandOrEdit;
    }
    if (checkKind && kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  CodeAction2.create = create2;
  function is2(value) {
    let candidate = value;
    return candidate && Is.string(candidate.title) && (candidate.diagnostics === void 0 || Is.typedArray(candidate.diagnostics, Diagnostic.is)) && (candidate.kind === void 0 || Is.string(candidate.kind)) && (candidate.edit !== void 0 || candidate.command !== void 0) && (candidate.command === void 0 || Command.is(candidate.command)) && (candidate.isPreferred === void 0 || Is.boolean(candidate.isPreferred)) && (candidate.edit === void 0 || WorkspaceEdit.is(candidate.edit));
  }
  CodeAction2.is = is2;
})(CodeAction || (CodeAction = {}));
var CodeLens;
(function(CodeLens2) {
  function create2(range2, data) {
    let result2 = { range: range2 };
    if (Is.defined(data)) {
      result2.data = data;
    }
    return result2;
  }
  CodeLens2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.command) || Command.is(candidate.command));
  }
  CodeLens2.is = is2;
})(CodeLens || (CodeLens = {}));
var FormattingOptions;
(function(FormattingOptions2) {
  function create2(tabSize, insertSpaces) {
    return { tabSize, insertSpaces };
  }
  FormattingOptions2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.uinteger(candidate.tabSize) && Is.boolean(candidate.insertSpaces);
  }
  FormattingOptions2.is = is2;
})(FormattingOptions || (FormattingOptions = {}));
var DocumentLink;
(function(DocumentLink2) {
  function create2(range2, target, data) {
    return { range: range2, target, data };
  }
  DocumentLink2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Range.is(candidate.range) && (Is.undefined(candidate.target) || Is.string(candidate.target));
  }
  DocumentLink2.is = is2;
})(DocumentLink || (DocumentLink = {}));
var SelectionRange;
(function(SelectionRange3) {
  function create2(range2, parent) {
    return { range: range2, parent };
  }
  SelectionRange3.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.objectLiteral(candidate) && Range.is(candidate.range) && (candidate.parent === void 0 || SelectionRange3.is(candidate.parent));
  }
  SelectionRange3.is = is2;
})(SelectionRange || (SelectionRange = {}));
var SemanticTokenTypes;
(function(SemanticTokenTypes2) {
  SemanticTokenTypes2["namespace"] = "namespace";
  SemanticTokenTypes2["type"] = "type";
  SemanticTokenTypes2["class"] = "class";
  SemanticTokenTypes2["enum"] = "enum";
  SemanticTokenTypes2["interface"] = "interface";
  SemanticTokenTypes2["struct"] = "struct";
  SemanticTokenTypes2["typeParameter"] = "typeParameter";
  SemanticTokenTypes2["parameter"] = "parameter";
  SemanticTokenTypes2["variable"] = "variable";
  SemanticTokenTypes2["property"] = "property";
  SemanticTokenTypes2["enumMember"] = "enumMember";
  SemanticTokenTypes2["event"] = "event";
  SemanticTokenTypes2["function"] = "function";
  SemanticTokenTypes2["method"] = "method";
  SemanticTokenTypes2["macro"] = "macro";
  SemanticTokenTypes2["keyword"] = "keyword";
  SemanticTokenTypes2["modifier"] = "modifier";
  SemanticTokenTypes2["comment"] = "comment";
  SemanticTokenTypes2["string"] = "string";
  SemanticTokenTypes2["number"] = "number";
  SemanticTokenTypes2["regexp"] = "regexp";
  SemanticTokenTypes2["operator"] = "operator";
  SemanticTokenTypes2["decorator"] = "decorator";
})(SemanticTokenTypes || (SemanticTokenTypes = {}));
var SemanticTokenModifiers;
(function(SemanticTokenModifiers2) {
  SemanticTokenModifiers2["declaration"] = "declaration";
  SemanticTokenModifiers2["definition"] = "definition";
  SemanticTokenModifiers2["readonly"] = "readonly";
  SemanticTokenModifiers2["static"] = "static";
  SemanticTokenModifiers2["deprecated"] = "deprecated";
  SemanticTokenModifiers2["abstract"] = "abstract";
  SemanticTokenModifiers2["async"] = "async";
  SemanticTokenModifiers2["modification"] = "modification";
  SemanticTokenModifiers2["documentation"] = "documentation";
  SemanticTokenModifiers2["defaultLibrary"] = "defaultLibrary";
})(SemanticTokenModifiers || (SemanticTokenModifiers = {}));
var SemanticTokens;
(function(SemanticTokens2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && (candidate.resultId === void 0 || typeof candidate.resultId === "string") && Array.isArray(candidate.data) && (candidate.data.length === 0 || typeof candidate.data[0] === "number");
  }
  SemanticTokens2.is = is2;
})(SemanticTokens || (SemanticTokens = {}));
var InlineValueText;
(function(InlineValueText2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  InlineValueText2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range.is(candidate.range) && Is.string(candidate.text);
  }
  InlineValueText2.is = is2;
})(InlineValueText || (InlineValueText = {}));
var InlineValueVariableLookup;
(function(InlineValueVariableLookup2) {
  function create2(range2, variableName, caseSensitiveLookup) {
    return { range: range2, variableName, caseSensitiveLookup };
  }
  InlineValueVariableLookup2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range.is(candidate.range) && Is.boolean(candidate.caseSensitiveLookup) && (Is.string(candidate.variableName) || candidate.variableName === void 0);
  }
  InlineValueVariableLookup2.is = is2;
})(InlineValueVariableLookup || (InlineValueVariableLookup = {}));
var InlineValueEvaluatableExpression;
(function(InlineValueEvaluatableExpression2) {
  function create2(range2, expression) {
    return { range: range2, expression };
  }
  InlineValueEvaluatableExpression2.create = create2;
  function is2(value) {
    const candidate = value;
    return candidate !== void 0 && candidate !== null && Range.is(candidate.range) && (Is.string(candidate.expression) || candidate.expression === void 0);
  }
  InlineValueEvaluatableExpression2.is = is2;
})(InlineValueEvaluatableExpression || (InlineValueEvaluatableExpression = {}));
var InlineValueContext;
(function(InlineValueContext2) {
  function create2(frameId, stoppedLocation) {
    return { frameId, stoppedLocation };
  }
  InlineValueContext2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.defined(candidate) && Range.is(value.stoppedLocation);
  }
  InlineValueContext2.is = is2;
})(InlineValueContext || (InlineValueContext = {}));
var InlayHintKind;
(function(InlayHintKind2) {
  InlayHintKind2.Type = 1;
  InlayHintKind2.Parameter = 2;
  function is2(value) {
    return value === 1 || value === 2;
  }
  InlayHintKind2.is = is2;
})(InlayHintKind || (InlayHintKind = {}));
var InlayHintLabelPart;
(function(InlayHintLabelPart2) {
  function create2(value) {
    return { value };
  }
  InlayHintLabelPart2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && (candidate.tooltip === void 0 || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.location === void 0 || Location.is(candidate.location)) && (candidate.command === void 0 || Command.is(candidate.command));
  }
  InlayHintLabelPart2.is = is2;
})(InlayHintLabelPart || (InlayHintLabelPart = {}));
var InlayHint;
(function(InlayHint2) {
  function create2(position2, label2, kind) {
    const result2 = { position: position2, label: label2 };
    if (kind !== void 0) {
      result2.kind = kind;
    }
    return result2;
  }
  InlayHint2.create = create2;
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && Position.is(candidate.position) && (Is.string(candidate.label) || Is.typedArray(candidate.label, InlayHintLabelPart.is)) && (candidate.kind === void 0 || InlayHintKind.is(candidate.kind)) && candidate.textEdits === void 0 || Is.typedArray(candidate.textEdits, TextEdit.is) && (candidate.tooltip === void 0 || Is.string(candidate.tooltip) || MarkupContent.is(candidate.tooltip)) && (candidate.paddingLeft === void 0 || Is.boolean(candidate.paddingLeft)) && (candidate.paddingRight === void 0 || Is.boolean(candidate.paddingRight));
  }
  InlayHint2.is = is2;
})(InlayHint || (InlayHint = {}));
var StringValue;
(function(StringValue2) {
  function createSnippet(value) {
    return { kind: "snippet", value };
  }
  StringValue2.createSnippet = createSnippet;
})(StringValue || (StringValue = {}));
var InlineCompletionItem;
(function(InlineCompletionItem2) {
  function create2(insertText, filterText, range2, command2) {
    return { insertText, filterText, range: range2, command: command2 };
  }
  InlineCompletionItem2.create = create2;
})(InlineCompletionItem || (InlineCompletionItem = {}));
var InlineCompletionList;
(function(InlineCompletionList2) {
  function create2(items) {
    return { items };
  }
  InlineCompletionList2.create = create2;
})(InlineCompletionList || (InlineCompletionList = {}));
var InlineCompletionTriggerKind;
(function(InlineCompletionTriggerKind2) {
  InlineCompletionTriggerKind2.Invoked = 0;
  InlineCompletionTriggerKind2.Automatic = 1;
})(InlineCompletionTriggerKind || (InlineCompletionTriggerKind = {}));
var SelectedCompletionInfo;
(function(SelectedCompletionInfo2) {
  function create2(range2, text2) {
    return { range: range2, text: text2 };
  }
  SelectedCompletionInfo2.create = create2;
})(SelectedCompletionInfo || (SelectedCompletionInfo = {}));
var InlineCompletionContext;
(function(InlineCompletionContext2) {
  function create2(triggerKind, selectedCompletionInfo) {
    return { triggerKind, selectedCompletionInfo };
  }
  InlineCompletionContext2.create = create2;
})(InlineCompletionContext || (InlineCompletionContext = {}));
var WorkspaceFolder;
(function(WorkspaceFolder2) {
  function is2(value) {
    const candidate = value;
    return Is.objectLiteral(candidate) && URI.is(candidate.uri) && Is.string(candidate.name);
  }
  WorkspaceFolder2.is = is2;
})(WorkspaceFolder || (WorkspaceFolder = {}));
const EOL = ["\n", "\r\n", "\r"];
var TextDocument;
(function(TextDocument2) {
  function create2(uri, languageId, version2, content2) {
    return new FullTextDocument(uri, languageId, version2, content2);
  }
  TextDocument2.create = create2;
  function is2(value) {
    let candidate = value;
    return Is.defined(candidate) && Is.string(candidate.uri) && (Is.undefined(candidate.languageId) || Is.string(candidate.languageId)) && Is.uinteger(candidate.lineCount) && Is.func(candidate.getText) && Is.func(candidate.positionAt) && Is.func(candidate.offsetAt) ? true : false;
  }
  TextDocument2.is = is2;
  function applyEdits(document2, edits) {
    let text2 = document2.getText();
    let sortedEdits = mergeSort(edits, (a2, b2) => {
      let diff = a2.range.start.line - b2.range.start.line;
      if (diff === 0) {
        return a2.range.start.character - b2.range.start.character;
      }
      return diff;
    });
    let lastModifiedOffset = text2.length;
    for (let i2 = sortedEdits.length - 1; i2 >= 0; i2--) {
      let e2 = sortedEdits[i2];
      let startOffset = document2.offsetAt(e2.range.start);
      let endOffset = document2.offsetAt(e2.range.end);
      if (endOffset <= lastModifiedOffset) {
        text2 = text2.substring(0, startOffset) + e2.newText + text2.substring(endOffset, text2.length);
      } else {
        throw new Error("Overlapping edit");
      }
      lastModifiedOffset = startOffset;
    }
    return text2;
  }
  TextDocument2.applyEdits = applyEdits;
  function mergeSort(data, compare2) {
    if (data.length <= 1) {
      return data;
    }
    const p2 = data.length / 2 | 0;
    const left = data.slice(0, p2);
    const right = data.slice(p2);
    mergeSort(left, compare2);
    mergeSort(right, compare2);
    let leftIdx = 0;
    let rightIdx = 0;
    let i2 = 0;
    while (leftIdx < left.length && rightIdx < right.length) {
      let ret = compare2(left[leftIdx], right[rightIdx]);
      if (ret <= 0) {
        data[i2++] = left[leftIdx++];
      } else {
        data[i2++] = right[rightIdx++];
      }
    }
    while (leftIdx < left.length) {
      data[i2++] = left[leftIdx++];
    }
    while (rightIdx < right.length) {
      data[i2++] = right[rightIdx++];
    }
    return data;
  }
})(TextDocument || (TextDocument = {}));
class FullTextDocument {
  constructor(uri, languageId, version2, content2) {
    this._uri = uri;
    this._languageId = languageId;
    this._version = version2;
    this._content = content2;
    this._lineOffsets = void 0;
  }
  get uri() {
    return this._uri;
  }
  get languageId() {
    return this._languageId;
  }
  get version() {
    return this._version;
  }
  getText(range2) {
    if (range2) {
      let start = this.offsetAt(range2.start);
      let end = this.offsetAt(range2.end);
      return this._content.substring(start, end);
    }
    return this._content;
  }
  update(event, version2) {
    this._content = event.text;
    this._version = version2;
    this._lineOffsets = void 0;
  }
  getLineOffsets() {
    if (this._lineOffsets === void 0) {
      let lineOffsets = [];
      let text2 = this._content;
      let isLineStart = true;
      for (let i2 = 0; i2 < text2.length; i2++) {
        if (isLineStart) {
          lineOffsets.push(i2);
          isLineStart = false;
        }
        let ch = text2.charAt(i2);
        isLineStart = ch === "\r" || ch === "\n";
        if (ch === "\r" && i2 + 1 < text2.length && text2.charAt(i2 + 1) === "\n") {
          i2++;
        }
      }
      if (isLineStart && text2.length > 0) {
        lineOffsets.push(text2.length);
      }
      this._lineOffsets = lineOffsets;
    }
    return this._lineOffsets;
  }
  positionAt(offset2) {
    offset2 = Math.max(Math.min(offset2, this._content.length), 0);
    let lineOffsets = this.getLineOffsets();
    let low = 0, high = lineOffsets.length;
    if (high === 0) {
      return Position.create(0, offset2);
    }
    while (low < high) {
      let mid = Math.floor((low + high) / 2);
      if (lineOffsets[mid] > offset2) {
        high = mid;
      } else {
        low = mid + 1;
      }
    }
    let line2 = low - 1;
    return Position.create(line2, offset2 - lineOffsets[line2]);
  }
  offsetAt(position2) {
    let lineOffsets = this.getLineOffsets();
    if (position2.line >= lineOffsets.length) {
      return this._content.length;
    } else if (position2.line < 0) {
      return 0;
    }
    let lineOffset = lineOffsets[position2.line];
    let nextLineOffset = position2.line + 1 < lineOffsets.length ? lineOffsets[position2.line + 1] : this._content.length;
    return Math.max(Math.min(lineOffset + position2.character, nextLineOffset), lineOffset);
  }
  get lineCount() {
    return this.getLineOffsets().length;
  }
}
var Is;
(function(Is2) {
  const toString2 = Object.prototype.toString;
  function defined(value) {
    return typeof value !== "undefined";
  }
  Is2.defined = defined;
  function undefined$1(value) {
    return typeof value === "undefined";
  }
  Is2.undefined = undefined$1;
  function boolean(value) {
    return value === true || value === false;
  }
  Is2.boolean = boolean;
  function string2(value) {
    return toString2.call(value) === "[object String]";
  }
  Is2.string = string2;
  function number2(value) {
    return toString2.call(value) === "[object Number]";
  }
  Is2.number = number2;
  function numberRange(value, min2, max2) {
    return toString2.call(value) === "[object Number]" && min2 <= value && value <= max2;
  }
  Is2.numberRange = numberRange;
  function integer2(value) {
    return toString2.call(value) === "[object Number]" && -2147483648 <= value && value <= 2147483647;
  }
  Is2.integer = integer2;
  function uinteger2(value) {
    return toString2.call(value) === "[object Number]" && 0 <= value && value <= 2147483647;
  }
  Is2.uinteger = uinteger2;
  function func(value) {
    return toString2.call(value) === "[object Function]";
  }
  Is2.func = func;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  Is2.objectLiteral = objectLiteral;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  Is2.typedArray = typedArray;
})(Is || (Is = {}));
const main = /* @__PURE__ */ Object.freeze(/* @__PURE__ */ Object.defineProperty({
  __proto__: null,
  get AnnotatedTextEdit() {
    return AnnotatedTextEdit;
  },
  get ChangeAnnotation() {
    return ChangeAnnotation;
  },
  get ChangeAnnotationIdentifier() {
    return ChangeAnnotationIdentifier;
  },
  get CodeAction() {
    return CodeAction;
  },
  get CodeActionContext() {
    return CodeActionContext;
  },
  get CodeActionKind() {
    return CodeActionKind;
  },
  get CodeActionTriggerKind() {
    return CodeActionTriggerKind;
  },
  get CodeDescription() {
    return CodeDescription;
  },
  get CodeLens() {
    return CodeLens;
  },
  get Color() {
    return Color;
  },
  get ColorInformation() {
    return ColorInformation;
  },
  get ColorPresentation() {
    return ColorPresentation;
  },
  get Command() {
    return Command;
  },
  get CompletionItem() {
    return CompletionItem;
  },
  get CompletionItemKind() {
    return CompletionItemKind;
  },
  get CompletionItemLabelDetails() {
    return CompletionItemLabelDetails;
  },
  get CompletionItemTag() {
    return CompletionItemTag;
  },
  get CompletionList() {
    return CompletionList;
  },
  get CreateFile() {
    return CreateFile;
  },
  get DeleteFile() {
    return DeleteFile;
  },
  get Diagnostic() {
    return Diagnostic;
  },
  get DiagnosticRelatedInformation() {
    return DiagnosticRelatedInformation;
  },
  get DiagnosticSeverity() {
    return DiagnosticSeverity;
  },
  get DiagnosticTag() {
    return DiagnosticTag;
  },
  get DocumentHighlight() {
    return DocumentHighlight;
  },
  get DocumentHighlightKind() {
    return DocumentHighlightKind;
  },
  get DocumentLink() {
    return DocumentLink;
  },
  get DocumentSymbol() {
    return DocumentSymbol;
  },
  get DocumentUri() {
    return DocumentUri;
  },
  EOL,
  get FoldingRange() {
    return FoldingRange;
  },
  get FoldingRangeKind() {
    return FoldingRangeKind;
  },
  get FormattingOptions() {
    return FormattingOptions;
  },
  get Hover() {
    return Hover;
  },
  get InlayHint() {
    return InlayHint;
  },
  get InlayHintKind() {
    return InlayHintKind;
  },
  get InlayHintLabelPart() {
    return InlayHintLabelPart;
  },
  get InlineCompletionContext() {
    return InlineCompletionContext;
  },
  get InlineCompletionItem() {
    return InlineCompletionItem;
  },
  get InlineCompletionList() {
    return InlineCompletionList;
  },
  get InlineCompletionTriggerKind() {
    return InlineCompletionTriggerKind;
  },
  get InlineValueContext() {
    return InlineValueContext;
  },
  get InlineValueEvaluatableExpression() {
    return InlineValueEvaluatableExpression;
  },
  get InlineValueText() {
    return InlineValueText;
  },
  get InlineValueVariableLookup() {
    return InlineValueVariableLookup;
  },
  get InsertReplaceEdit() {
    return InsertReplaceEdit;
  },
  get InsertTextFormat() {
    return InsertTextFormat;
  },
  get InsertTextMode() {
    return InsertTextMode;
  },
  get Location() {
    return Location;
  },
  get LocationLink() {
    return LocationLink;
  },
  get MarkedString() {
    return MarkedString;
  },
  get MarkupContent() {
    return MarkupContent;
  },
  get MarkupKind() {
    return MarkupKind;
  },
  get OptionalVersionedTextDocumentIdentifier() {
    return OptionalVersionedTextDocumentIdentifier;
  },
  get ParameterInformation() {
    return ParameterInformation;
  },
  get Position() {
    return Position;
  },
  get Range() {
    return Range;
  },
  get RenameFile() {
    return RenameFile;
  },
  get SelectedCompletionInfo() {
    return SelectedCompletionInfo;
  },
  get SelectionRange() {
    return SelectionRange;
  },
  get SemanticTokenModifiers() {
    return SemanticTokenModifiers;
  },
  get SemanticTokenTypes() {
    return SemanticTokenTypes;
  },
  get SemanticTokens() {
    return SemanticTokens;
  },
  get SignatureInformation() {
    return SignatureInformation;
  },
  get StringValue() {
    return StringValue;
  },
  get SymbolInformation() {
    return SymbolInformation;
  },
  get SymbolKind() {
    return SymbolKind;
  },
  get SymbolTag() {
    return SymbolTag;
  },
  get TextDocument() {
    return TextDocument;
  },
  get TextDocumentEdit() {
    return TextDocumentEdit;
  },
  get TextDocumentIdentifier() {
    return TextDocumentIdentifier;
  },
  get TextDocumentItem() {
    return TextDocumentItem;
  },
  get TextEdit() {
    return TextEdit;
  },
  get URI() {
    return URI;
  },
  get VersionedTextDocumentIdentifier() {
    return VersionedTextDocumentIdentifier;
  },
  WorkspaceChange,
  get WorkspaceEdit() {
    return WorkspaceEdit;
  },
  get WorkspaceFolder() {
    return WorkspaceFolder;
  },
  get WorkspaceSymbol() {
    return WorkspaceSymbol;
  },
  get integer() {
    return integer;
  },
  get uinteger() {
    return uinteger;
  }
}, Symbol.toStringTag, { value: "Module" }));
const require$$1 = /* @__PURE__ */ getAugmentedNamespace$1(main);
var messages = {};
var hasRequiredMessages;
function requireMessages() {
  if (hasRequiredMessages) return messages;
  hasRequiredMessages = 1;
  Object.defineProperty(messages, "__esModule", { value: true });
  messages.ProtocolNotificationType = messages.ProtocolNotificationType0 = messages.ProtocolRequestType = messages.ProtocolRequestType0 = messages.RegistrationType = messages.MessageDirection = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  var MessageDirection;
  (function(MessageDirection2) {
    MessageDirection2["clientToServer"] = "clientToServer";
    MessageDirection2["serverToClient"] = "serverToClient";
    MessageDirection2["both"] = "both";
  })(MessageDirection || (messages.MessageDirection = MessageDirection = {}));
  class RegistrationType {
    constructor(method) {
      this.method = method;
    }
  }
  messages.RegistrationType = RegistrationType;
  class ProtocolRequestType0 extends vscode_jsonrpc_1.RequestType0 {
    constructor(method) {
      super(method);
    }
  }
  messages.ProtocolRequestType0 = ProtocolRequestType0;
  class ProtocolRequestType extends vscode_jsonrpc_1.RequestType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages.ProtocolRequestType = ProtocolRequestType;
  class ProtocolNotificationType0 extends vscode_jsonrpc_1.NotificationType0 {
    constructor(method) {
      super(method);
    }
  }
  messages.ProtocolNotificationType0 = ProtocolNotificationType0;
  class ProtocolNotificationType extends vscode_jsonrpc_1.NotificationType {
    constructor(method) {
      super(method, vscode_jsonrpc_1.ParameterStructures.byName);
    }
  }
  messages.ProtocolNotificationType = ProtocolNotificationType;
  return messages;
}
var protocol = {};
var is = {};
var hasRequiredIs;
function requireIs() {
  if (hasRequiredIs) return is;
  hasRequiredIs = 1;
  Object.defineProperty(is, "__esModule", { value: true });
  is.objectLiteral = is.typedArray = is.stringArray = is.array = is.func = is.error = is.number = is.string = is.boolean = void 0;
  function boolean(value) {
    return value === true || value === false;
  }
  is.boolean = boolean;
  function string2(value) {
    return typeof value === "string" || value instanceof String;
  }
  is.string = string2;
  function number2(value) {
    return typeof value === "number" || value instanceof Number;
  }
  is.number = number2;
  function error(value) {
    return value instanceof Error;
  }
  is.error = error;
  function func(value) {
    return typeof value === "function";
  }
  is.func = func;
  function array(value) {
    return Array.isArray(value);
  }
  is.array = array;
  function stringArray(value) {
    return array(value) && value.every((elem) => string2(elem));
  }
  is.stringArray = stringArray;
  function typedArray(value, check) {
    return Array.isArray(value) && value.every(check);
  }
  is.typedArray = typedArray;
  function objectLiteral(value) {
    return value !== null && typeof value === "object";
  }
  is.objectLiteral = objectLiteral;
  return is;
}
var protocol_implementation = {};
var hasRequiredProtocol_implementation;
function requireProtocol_implementation() {
  if (hasRequiredProtocol_implementation) return protocol_implementation;
  hasRequiredProtocol_implementation = 1;
  Object.defineProperty(protocol_implementation, "__esModule", { value: true });
  protocol_implementation.ImplementationRequest = void 0;
  const messages_1 = requireMessages();
  var ImplementationRequest;
  (function(ImplementationRequest2) {
    ImplementationRequest2.method = "textDocument/implementation";
    ImplementationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ImplementationRequest2.type = new messages_1.ProtocolRequestType(ImplementationRequest2.method);
  })(ImplementationRequest || (protocol_implementation.ImplementationRequest = ImplementationRequest = {}));
  return protocol_implementation;
}
var protocol_typeDefinition = {};
var hasRequiredProtocol_typeDefinition;
function requireProtocol_typeDefinition() {
  if (hasRequiredProtocol_typeDefinition) return protocol_typeDefinition;
  hasRequiredProtocol_typeDefinition = 1;
  Object.defineProperty(protocol_typeDefinition, "__esModule", { value: true });
  protocol_typeDefinition.TypeDefinitionRequest = void 0;
  const messages_1 = requireMessages();
  var TypeDefinitionRequest;
  (function(TypeDefinitionRequest2) {
    TypeDefinitionRequest2.method = "textDocument/typeDefinition";
    TypeDefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeDefinitionRequest2.type = new messages_1.ProtocolRequestType(TypeDefinitionRequest2.method);
  })(TypeDefinitionRequest || (protocol_typeDefinition.TypeDefinitionRequest = TypeDefinitionRequest = {}));
  return protocol_typeDefinition;
}
var protocol_workspaceFolder = {};
var hasRequiredProtocol_workspaceFolder;
function requireProtocol_workspaceFolder() {
  if (hasRequiredProtocol_workspaceFolder) return protocol_workspaceFolder;
  hasRequiredProtocol_workspaceFolder = 1;
  Object.defineProperty(protocol_workspaceFolder, "__esModule", { value: true });
  protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification = protocol_workspaceFolder.WorkspaceFoldersRequest = void 0;
  const messages_1 = requireMessages();
  var WorkspaceFoldersRequest;
  (function(WorkspaceFoldersRequest2) {
    WorkspaceFoldersRequest2.method = "workspace/workspaceFolders";
    WorkspaceFoldersRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkspaceFoldersRequest2.type = new messages_1.ProtocolRequestType0(WorkspaceFoldersRequest2.method);
  })(WorkspaceFoldersRequest || (protocol_workspaceFolder.WorkspaceFoldersRequest = WorkspaceFoldersRequest = {}));
  var DidChangeWorkspaceFoldersNotification;
  (function(DidChangeWorkspaceFoldersNotification2) {
    DidChangeWorkspaceFoldersNotification2.method = "workspace/didChangeWorkspaceFolders";
    DidChangeWorkspaceFoldersNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeWorkspaceFoldersNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWorkspaceFoldersNotification2.method);
  })(DidChangeWorkspaceFoldersNotification || (protocol_workspaceFolder.DidChangeWorkspaceFoldersNotification = DidChangeWorkspaceFoldersNotification = {}));
  return protocol_workspaceFolder;
}
var protocol_configuration = {};
var hasRequiredProtocol_configuration;
function requireProtocol_configuration() {
  if (hasRequiredProtocol_configuration) return protocol_configuration;
  hasRequiredProtocol_configuration = 1;
  Object.defineProperty(protocol_configuration, "__esModule", { value: true });
  protocol_configuration.ConfigurationRequest = void 0;
  const messages_1 = requireMessages();
  var ConfigurationRequest;
  (function(ConfigurationRequest2) {
    ConfigurationRequest2.method = "workspace/configuration";
    ConfigurationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ConfigurationRequest2.type = new messages_1.ProtocolRequestType(ConfigurationRequest2.method);
  })(ConfigurationRequest || (protocol_configuration.ConfigurationRequest = ConfigurationRequest = {}));
  return protocol_configuration;
}
var protocol_colorProvider = {};
var hasRequiredProtocol_colorProvider;
function requireProtocol_colorProvider() {
  if (hasRequiredProtocol_colorProvider) return protocol_colorProvider;
  hasRequiredProtocol_colorProvider = 1;
  Object.defineProperty(protocol_colorProvider, "__esModule", { value: true });
  protocol_colorProvider.ColorPresentationRequest = protocol_colorProvider.DocumentColorRequest = void 0;
  const messages_1 = requireMessages();
  var DocumentColorRequest;
  (function(DocumentColorRequest2) {
    DocumentColorRequest2.method = "textDocument/documentColor";
    DocumentColorRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentColorRequest2.type = new messages_1.ProtocolRequestType(DocumentColorRequest2.method);
  })(DocumentColorRequest || (protocol_colorProvider.DocumentColorRequest = DocumentColorRequest = {}));
  var ColorPresentationRequest;
  (function(ColorPresentationRequest2) {
    ColorPresentationRequest2.method = "textDocument/colorPresentation";
    ColorPresentationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    ColorPresentationRequest2.type = new messages_1.ProtocolRequestType(ColorPresentationRequest2.method);
  })(ColorPresentationRequest || (protocol_colorProvider.ColorPresentationRequest = ColorPresentationRequest = {}));
  return protocol_colorProvider;
}
var protocol_foldingRange = {};
var hasRequiredProtocol_foldingRange;
function requireProtocol_foldingRange() {
  if (hasRequiredProtocol_foldingRange) return protocol_foldingRange;
  hasRequiredProtocol_foldingRange = 1;
  Object.defineProperty(protocol_foldingRange, "__esModule", { value: true });
  protocol_foldingRange.FoldingRangeRefreshRequest = protocol_foldingRange.FoldingRangeRequest = void 0;
  const messages_1 = requireMessages();
  var FoldingRangeRequest;
  (function(FoldingRangeRequest2) {
    FoldingRangeRequest2.method = "textDocument/foldingRange";
    FoldingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    FoldingRangeRequest2.type = new messages_1.ProtocolRequestType(FoldingRangeRequest2.method);
  })(FoldingRangeRequest || (protocol_foldingRange.FoldingRangeRequest = FoldingRangeRequest = {}));
  var FoldingRangeRefreshRequest;
  (function(FoldingRangeRefreshRequest2) {
    FoldingRangeRefreshRequest2.method = `workspace/foldingRange/refresh`;
    FoldingRangeRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    FoldingRangeRefreshRequest2.type = new messages_1.ProtocolRequestType0(FoldingRangeRefreshRequest2.method);
  })(FoldingRangeRefreshRequest || (protocol_foldingRange.FoldingRangeRefreshRequest = FoldingRangeRefreshRequest = {}));
  return protocol_foldingRange;
}
var protocol_declaration = {};
var hasRequiredProtocol_declaration;
function requireProtocol_declaration() {
  if (hasRequiredProtocol_declaration) return protocol_declaration;
  hasRequiredProtocol_declaration = 1;
  Object.defineProperty(protocol_declaration, "__esModule", { value: true });
  protocol_declaration.DeclarationRequest = void 0;
  const messages_1 = requireMessages();
  var DeclarationRequest;
  (function(DeclarationRequest2) {
    DeclarationRequest2.method = "textDocument/declaration";
    DeclarationRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DeclarationRequest2.type = new messages_1.ProtocolRequestType(DeclarationRequest2.method);
  })(DeclarationRequest || (protocol_declaration.DeclarationRequest = DeclarationRequest = {}));
  return protocol_declaration;
}
var protocol_selectionRange = {};
var hasRequiredProtocol_selectionRange;
function requireProtocol_selectionRange() {
  if (hasRequiredProtocol_selectionRange) return protocol_selectionRange;
  hasRequiredProtocol_selectionRange = 1;
  Object.defineProperty(protocol_selectionRange, "__esModule", { value: true });
  protocol_selectionRange.SelectionRangeRequest = void 0;
  const messages_1 = requireMessages();
  var SelectionRangeRequest;
  (function(SelectionRangeRequest2) {
    SelectionRangeRequest2.method = "textDocument/selectionRange";
    SelectionRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SelectionRangeRequest2.type = new messages_1.ProtocolRequestType(SelectionRangeRequest2.method);
  })(SelectionRangeRequest || (protocol_selectionRange.SelectionRangeRequest = SelectionRangeRequest = {}));
  return protocol_selectionRange;
}
var protocol_progress = {};
var hasRequiredProtocol_progress;
function requireProtocol_progress() {
  if (hasRequiredProtocol_progress) return protocol_progress;
  hasRequiredProtocol_progress = 1;
  Object.defineProperty(protocol_progress, "__esModule", { value: true });
  protocol_progress.WorkDoneProgressCancelNotification = protocol_progress.WorkDoneProgressCreateRequest = protocol_progress.WorkDoneProgress = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  const messages_1 = requireMessages();
  var WorkDoneProgress;
  (function(WorkDoneProgress2) {
    WorkDoneProgress2.type = new vscode_jsonrpc_1.ProgressType();
    function is2(value) {
      return value === WorkDoneProgress2.type;
    }
    WorkDoneProgress2.is = is2;
  })(WorkDoneProgress || (protocol_progress.WorkDoneProgress = WorkDoneProgress = {}));
  var WorkDoneProgressCreateRequest;
  (function(WorkDoneProgressCreateRequest2) {
    WorkDoneProgressCreateRequest2.method = "window/workDoneProgress/create";
    WorkDoneProgressCreateRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    WorkDoneProgressCreateRequest2.type = new messages_1.ProtocolRequestType(WorkDoneProgressCreateRequest2.method);
  })(WorkDoneProgressCreateRequest || (protocol_progress.WorkDoneProgressCreateRequest = WorkDoneProgressCreateRequest = {}));
  var WorkDoneProgressCancelNotification;
  (function(WorkDoneProgressCancelNotification2) {
    WorkDoneProgressCancelNotification2.method = "window/workDoneProgress/cancel";
    WorkDoneProgressCancelNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkDoneProgressCancelNotification2.type = new messages_1.ProtocolNotificationType(WorkDoneProgressCancelNotification2.method);
  })(WorkDoneProgressCancelNotification || (protocol_progress.WorkDoneProgressCancelNotification = WorkDoneProgressCancelNotification = {}));
  return protocol_progress;
}
var protocol_callHierarchy = {};
var hasRequiredProtocol_callHierarchy;
function requireProtocol_callHierarchy() {
  if (hasRequiredProtocol_callHierarchy) return protocol_callHierarchy;
  hasRequiredProtocol_callHierarchy = 1;
  Object.defineProperty(protocol_callHierarchy, "__esModule", { value: true });
  protocol_callHierarchy.CallHierarchyOutgoingCallsRequest = protocol_callHierarchy.CallHierarchyIncomingCallsRequest = protocol_callHierarchy.CallHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages();
  var CallHierarchyPrepareRequest;
  (function(CallHierarchyPrepareRequest2) {
    CallHierarchyPrepareRequest2.method = "textDocument/prepareCallHierarchy";
    CallHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyPrepareRequest2.method);
  })(CallHierarchyPrepareRequest || (protocol_callHierarchy.CallHierarchyPrepareRequest = CallHierarchyPrepareRequest = {}));
  var CallHierarchyIncomingCallsRequest;
  (function(CallHierarchyIncomingCallsRequest2) {
    CallHierarchyIncomingCallsRequest2.method = "callHierarchy/incomingCalls";
    CallHierarchyIncomingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyIncomingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyIncomingCallsRequest2.method);
  })(CallHierarchyIncomingCallsRequest || (protocol_callHierarchy.CallHierarchyIncomingCallsRequest = CallHierarchyIncomingCallsRequest = {}));
  var CallHierarchyOutgoingCallsRequest;
  (function(CallHierarchyOutgoingCallsRequest2) {
    CallHierarchyOutgoingCallsRequest2.method = "callHierarchy/outgoingCalls";
    CallHierarchyOutgoingCallsRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    CallHierarchyOutgoingCallsRequest2.type = new messages_1.ProtocolRequestType(CallHierarchyOutgoingCallsRequest2.method);
  })(CallHierarchyOutgoingCallsRequest || (protocol_callHierarchy.CallHierarchyOutgoingCallsRequest = CallHierarchyOutgoingCallsRequest = {}));
  return protocol_callHierarchy;
}
var protocol_semanticTokens = {};
var hasRequiredProtocol_semanticTokens;
function requireProtocol_semanticTokens() {
  if (hasRequiredProtocol_semanticTokens) return protocol_semanticTokens;
  hasRequiredProtocol_semanticTokens = 1;
  Object.defineProperty(protocol_semanticTokens, "__esModule", { value: true });
  protocol_semanticTokens.SemanticTokensRefreshRequest = protocol_semanticTokens.SemanticTokensRangeRequest = protocol_semanticTokens.SemanticTokensDeltaRequest = protocol_semanticTokens.SemanticTokensRequest = protocol_semanticTokens.SemanticTokensRegistrationType = protocol_semanticTokens.TokenFormat = void 0;
  const messages_1 = requireMessages();
  var TokenFormat;
  (function(TokenFormat2) {
    TokenFormat2.Relative = "relative";
  })(TokenFormat || (protocol_semanticTokens.TokenFormat = TokenFormat = {}));
  var SemanticTokensRegistrationType;
  (function(SemanticTokensRegistrationType2) {
    SemanticTokensRegistrationType2.method = "textDocument/semanticTokens";
    SemanticTokensRegistrationType2.type = new messages_1.RegistrationType(SemanticTokensRegistrationType2.method);
  })(SemanticTokensRegistrationType || (protocol_semanticTokens.SemanticTokensRegistrationType = SemanticTokensRegistrationType = {}));
  var SemanticTokensRequest;
  (function(SemanticTokensRequest2) {
    SemanticTokensRequest2.method = "textDocument/semanticTokens/full";
    SemanticTokensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRequest2.method);
    SemanticTokensRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRequest || (protocol_semanticTokens.SemanticTokensRequest = SemanticTokensRequest = {}));
  var SemanticTokensDeltaRequest;
  (function(SemanticTokensDeltaRequest2) {
    SemanticTokensDeltaRequest2.method = "textDocument/semanticTokens/full/delta";
    SemanticTokensDeltaRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensDeltaRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensDeltaRequest2.method);
    SemanticTokensDeltaRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensDeltaRequest || (protocol_semanticTokens.SemanticTokensDeltaRequest = SemanticTokensDeltaRequest = {}));
  var SemanticTokensRangeRequest;
  (function(SemanticTokensRangeRequest2) {
    SemanticTokensRangeRequest2.method = "textDocument/semanticTokens/range";
    SemanticTokensRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    SemanticTokensRangeRequest2.type = new messages_1.ProtocolRequestType(SemanticTokensRangeRequest2.method);
    SemanticTokensRangeRequest2.registrationMethod = SemanticTokensRegistrationType.method;
  })(SemanticTokensRangeRequest || (protocol_semanticTokens.SemanticTokensRangeRequest = SemanticTokensRangeRequest = {}));
  var SemanticTokensRefreshRequest;
  (function(SemanticTokensRefreshRequest2) {
    SemanticTokensRefreshRequest2.method = `workspace/semanticTokens/refresh`;
    SemanticTokensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    SemanticTokensRefreshRequest2.type = new messages_1.ProtocolRequestType0(SemanticTokensRefreshRequest2.method);
  })(SemanticTokensRefreshRequest || (protocol_semanticTokens.SemanticTokensRefreshRequest = SemanticTokensRefreshRequest = {}));
  return protocol_semanticTokens;
}
var protocol_showDocument = {};
var hasRequiredProtocol_showDocument;
function requireProtocol_showDocument() {
  if (hasRequiredProtocol_showDocument) return protocol_showDocument;
  hasRequiredProtocol_showDocument = 1;
  Object.defineProperty(protocol_showDocument, "__esModule", { value: true });
  protocol_showDocument.ShowDocumentRequest = void 0;
  const messages_1 = requireMessages();
  var ShowDocumentRequest;
  (function(ShowDocumentRequest2) {
    ShowDocumentRequest2.method = "window/showDocument";
    ShowDocumentRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    ShowDocumentRequest2.type = new messages_1.ProtocolRequestType(ShowDocumentRequest2.method);
  })(ShowDocumentRequest || (protocol_showDocument.ShowDocumentRequest = ShowDocumentRequest = {}));
  return protocol_showDocument;
}
var protocol_linkedEditingRange = {};
var hasRequiredProtocol_linkedEditingRange;
function requireProtocol_linkedEditingRange() {
  if (hasRequiredProtocol_linkedEditingRange) return protocol_linkedEditingRange;
  hasRequiredProtocol_linkedEditingRange = 1;
  Object.defineProperty(protocol_linkedEditingRange, "__esModule", { value: true });
  protocol_linkedEditingRange.LinkedEditingRangeRequest = void 0;
  const messages_1 = requireMessages();
  var LinkedEditingRangeRequest;
  (function(LinkedEditingRangeRequest2) {
    LinkedEditingRangeRequest2.method = "textDocument/linkedEditingRange";
    LinkedEditingRangeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    LinkedEditingRangeRequest2.type = new messages_1.ProtocolRequestType(LinkedEditingRangeRequest2.method);
  })(LinkedEditingRangeRequest || (protocol_linkedEditingRange.LinkedEditingRangeRequest = LinkedEditingRangeRequest = {}));
  return protocol_linkedEditingRange;
}
var protocol_fileOperations = {};
var hasRequiredProtocol_fileOperations;
function requireProtocol_fileOperations() {
  if (hasRequiredProtocol_fileOperations) return protocol_fileOperations;
  hasRequiredProtocol_fileOperations = 1;
  Object.defineProperty(protocol_fileOperations, "__esModule", { value: true });
  protocol_fileOperations.WillDeleteFilesRequest = protocol_fileOperations.DidDeleteFilesNotification = protocol_fileOperations.DidRenameFilesNotification = protocol_fileOperations.WillRenameFilesRequest = protocol_fileOperations.DidCreateFilesNotification = protocol_fileOperations.WillCreateFilesRequest = protocol_fileOperations.FileOperationPatternKind = void 0;
  const messages_1 = requireMessages();
  var FileOperationPatternKind;
  (function(FileOperationPatternKind2) {
    FileOperationPatternKind2.file = "file";
    FileOperationPatternKind2.folder = "folder";
  })(FileOperationPatternKind || (protocol_fileOperations.FileOperationPatternKind = FileOperationPatternKind = {}));
  var WillCreateFilesRequest;
  (function(WillCreateFilesRequest2) {
    WillCreateFilesRequest2.method = "workspace/willCreateFiles";
    WillCreateFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillCreateFilesRequest2.type = new messages_1.ProtocolRequestType(WillCreateFilesRequest2.method);
  })(WillCreateFilesRequest || (protocol_fileOperations.WillCreateFilesRequest = WillCreateFilesRequest = {}));
  var DidCreateFilesNotification;
  (function(DidCreateFilesNotification2) {
    DidCreateFilesNotification2.method = "workspace/didCreateFiles";
    DidCreateFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCreateFilesNotification2.type = new messages_1.ProtocolNotificationType(DidCreateFilesNotification2.method);
  })(DidCreateFilesNotification || (protocol_fileOperations.DidCreateFilesNotification = DidCreateFilesNotification = {}));
  var WillRenameFilesRequest;
  (function(WillRenameFilesRequest2) {
    WillRenameFilesRequest2.method = "workspace/willRenameFiles";
    WillRenameFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillRenameFilesRequest2.type = new messages_1.ProtocolRequestType(WillRenameFilesRequest2.method);
  })(WillRenameFilesRequest || (protocol_fileOperations.WillRenameFilesRequest = WillRenameFilesRequest = {}));
  var DidRenameFilesNotification;
  (function(DidRenameFilesNotification2) {
    DidRenameFilesNotification2.method = "workspace/didRenameFiles";
    DidRenameFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidRenameFilesNotification2.type = new messages_1.ProtocolNotificationType(DidRenameFilesNotification2.method);
  })(DidRenameFilesNotification || (protocol_fileOperations.DidRenameFilesNotification = DidRenameFilesNotification = {}));
  var DidDeleteFilesNotification;
  (function(DidDeleteFilesNotification2) {
    DidDeleteFilesNotification2.method = "workspace/didDeleteFiles";
    DidDeleteFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidDeleteFilesNotification2.type = new messages_1.ProtocolNotificationType(DidDeleteFilesNotification2.method);
  })(DidDeleteFilesNotification || (protocol_fileOperations.DidDeleteFilesNotification = DidDeleteFilesNotification = {}));
  var WillDeleteFilesRequest;
  (function(WillDeleteFilesRequest2) {
    WillDeleteFilesRequest2.method = "workspace/willDeleteFiles";
    WillDeleteFilesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WillDeleteFilesRequest2.type = new messages_1.ProtocolRequestType(WillDeleteFilesRequest2.method);
  })(WillDeleteFilesRequest || (protocol_fileOperations.WillDeleteFilesRequest = WillDeleteFilesRequest = {}));
  return protocol_fileOperations;
}
var protocol_moniker = {};
var hasRequiredProtocol_moniker;
function requireProtocol_moniker() {
  if (hasRequiredProtocol_moniker) return protocol_moniker;
  hasRequiredProtocol_moniker = 1;
  Object.defineProperty(protocol_moniker, "__esModule", { value: true });
  protocol_moniker.MonikerRequest = protocol_moniker.MonikerKind = protocol_moniker.UniquenessLevel = void 0;
  const messages_1 = requireMessages();
  var UniquenessLevel;
  (function(UniquenessLevel2) {
    UniquenessLevel2.document = "document";
    UniquenessLevel2.project = "project";
    UniquenessLevel2.group = "group";
    UniquenessLevel2.scheme = "scheme";
    UniquenessLevel2.global = "global";
  })(UniquenessLevel || (protocol_moniker.UniquenessLevel = UniquenessLevel = {}));
  var MonikerKind;
  (function(MonikerKind2) {
    MonikerKind2.$import = "import";
    MonikerKind2.$export = "export";
    MonikerKind2.local = "local";
  })(MonikerKind || (protocol_moniker.MonikerKind = MonikerKind = {}));
  var MonikerRequest;
  (function(MonikerRequest2) {
    MonikerRequest2.method = "textDocument/moniker";
    MonikerRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    MonikerRequest2.type = new messages_1.ProtocolRequestType(MonikerRequest2.method);
  })(MonikerRequest || (protocol_moniker.MonikerRequest = MonikerRequest = {}));
  return protocol_moniker;
}
var protocol_typeHierarchy = {};
var hasRequiredProtocol_typeHierarchy;
function requireProtocol_typeHierarchy() {
  if (hasRequiredProtocol_typeHierarchy) return protocol_typeHierarchy;
  hasRequiredProtocol_typeHierarchy = 1;
  Object.defineProperty(protocol_typeHierarchy, "__esModule", { value: true });
  protocol_typeHierarchy.TypeHierarchySubtypesRequest = protocol_typeHierarchy.TypeHierarchySupertypesRequest = protocol_typeHierarchy.TypeHierarchyPrepareRequest = void 0;
  const messages_1 = requireMessages();
  var TypeHierarchyPrepareRequest;
  (function(TypeHierarchyPrepareRequest2) {
    TypeHierarchyPrepareRequest2.method = "textDocument/prepareTypeHierarchy";
    TypeHierarchyPrepareRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchyPrepareRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchyPrepareRequest2.method);
  })(TypeHierarchyPrepareRequest || (protocol_typeHierarchy.TypeHierarchyPrepareRequest = TypeHierarchyPrepareRequest = {}));
  var TypeHierarchySupertypesRequest;
  (function(TypeHierarchySupertypesRequest2) {
    TypeHierarchySupertypesRequest2.method = "typeHierarchy/supertypes";
    TypeHierarchySupertypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySupertypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySupertypesRequest2.method);
  })(TypeHierarchySupertypesRequest || (protocol_typeHierarchy.TypeHierarchySupertypesRequest = TypeHierarchySupertypesRequest = {}));
  var TypeHierarchySubtypesRequest;
  (function(TypeHierarchySubtypesRequest2) {
    TypeHierarchySubtypesRequest2.method = "typeHierarchy/subtypes";
    TypeHierarchySubtypesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    TypeHierarchySubtypesRequest2.type = new messages_1.ProtocolRequestType(TypeHierarchySubtypesRequest2.method);
  })(TypeHierarchySubtypesRequest || (protocol_typeHierarchy.TypeHierarchySubtypesRequest = TypeHierarchySubtypesRequest = {}));
  return protocol_typeHierarchy;
}
var protocol_inlineValue = {};
var hasRequiredProtocol_inlineValue;
function requireProtocol_inlineValue() {
  if (hasRequiredProtocol_inlineValue) return protocol_inlineValue;
  hasRequiredProtocol_inlineValue = 1;
  Object.defineProperty(protocol_inlineValue, "__esModule", { value: true });
  protocol_inlineValue.InlineValueRefreshRequest = protocol_inlineValue.InlineValueRequest = void 0;
  const messages_1 = requireMessages();
  var InlineValueRequest;
  (function(InlineValueRequest2) {
    InlineValueRequest2.method = "textDocument/inlineValue";
    InlineValueRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineValueRequest2.type = new messages_1.ProtocolRequestType(InlineValueRequest2.method);
  })(InlineValueRequest || (protocol_inlineValue.InlineValueRequest = InlineValueRequest = {}));
  var InlineValueRefreshRequest;
  (function(InlineValueRefreshRequest2) {
    InlineValueRefreshRequest2.method = `workspace/inlineValue/refresh`;
    InlineValueRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlineValueRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlineValueRefreshRequest2.method);
  })(InlineValueRefreshRequest || (protocol_inlineValue.InlineValueRefreshRequest = InlineValueRefreshRequest = {}));
  return protocol_inlineValue;
}
var protocol_inlayHint = {};
var hasRequiredProtocol_inlayHint;
function requireProtocol_inlayHint() {
  if (hasRequiredProtocol_inlayHint) return protocol_inlayHint;
  hasRequiredProtocol_inlayHint = 1;
  Object.defineProperty(protocol_inlayHint, "__esModule", { value: true });
  protocol_inlayHint.InlayHintRefreshRequest = protocol_inlayHint.InlayHintResolveRequest = protocol_inlayHint.InlayHintRequest = void 0;
  const messages_1 = requireMessages();
  var InlayHintRequest;
  (function(InlayHintRequest2) {
    InlayHintRequest2.method = "textDocument/inlayHint";
    InlayHintRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintRequest2.type = new messages_1.ProtocolRequestType(InlayHintRequest2.method);
  })(InlayHintRequest || (protocol_inlayHint.InlayHintRequest = InlayHintRequest = {}));
  var InlayHintResolveRequest;
  (function(InlayHintResolveRequest2) {
    InlayHintResolveRequest2.method = "inlayHint/resolve";
    InlayHintResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlayHintResolveRequest2.type = new messages_1.ProtocolRequestType(InlayHintResolveRequest2.method);
  })(InlayHintResolveRequest || (protocol_inlayHint.InlayHintResolveRequest = InlayHintResolveRequest = {}));
  var InlayHintRefreshRequest;
  (function(InlayHintRefreshRequest2) {
    InlayHintRefreshRequest2.method = `workspace/inlayHint/refresh`;
    InlayHintRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    InlayHintRefreshRequest2.type = new messages_1.ProtocolRequestType0(InlayHintRefreshRequest2.method);
  })(InlayHintRefreshRequest || (protocol_inlayHint.InlayHintRefreshRequest = InlayHintRefreshRequest = {}));
  return protocol_inlayHint;
}
var protocol_diagnostic = {};
var hasRequiredProtocol_diagnostic;
function requireProtocol_diagnostic() {
  if (hasRequiredProtocol_diagnostic) return protocol_diagnostic;
  hasRequiredProtocol_diagnostic = 1;
  Object.defineProperty(protocol_diagnostic, "__esModule", { value: true });
  protocol_diagnostic.DiagnosticRefreshRequest = protocol_diagnostic.WorkspaceDiagnosticRequest = protocol_diagnostic.DocumentDiagnosticRequest = protocol_diagnostic.DocumentDiagnosticReportKind = protocol_diagnostic.DiagnosticServerCancellationData = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  const Is2 = requireIs();
  const messages_1 = requireMessages();
  var DiagnosticServerCancellationData;
  (function(DiagnosticServerCancellationData2) {
    function is2(value) {
      const candidate = value;
      return candidate && Is2.boolean(candidate.retriggerRequest);
    }
    DiagnosticServerCancellationData2.is = is2;
  })(DiagnosticServerCancellationData || (protocol_diagnostic.DiagnosticServerCancellationData = DiagnosticServerCancellationData = {}));
  var DocumentDiagnosticReportKind;
  (function(DocumentDiagnosticReportKind2) {
    DocumentDiagnosticReportKind2.Full = "full";
    DocumentDiagnosticReportKind2.Unchanged = "unchanged";
  })(DocumentDiagnosticReportKind || (protocol_diagnostic.DocumentDiagnosticReportKind = DocumentDiagnosticReportKind = {}));
  var DocumentDiagnosticRequest;
  (function(DocumentDiagnosticRequest2) {
    DocumentDiagnosticRequest2.method = "textDocument/diagnostic";
    DocumentDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    DocumentDiagnosticRequest2.type = new messages_1.ProtocolRequestType(DocumentDiagnosticRequest2.method);
    DocumentDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(DocumentDiagnosticRequest || (protocol_diagnostic.DocumentDiagnosticRequest = DocumentDiagnosticRequest = {}));
  var WorkspaceDiagnosticRequest;
  (function(WorkspaceDiagnosticRequest2) {
    WorkspaceDiagnosticRequest2.method = "workspace/diagnostic";
    WorkspaceDiagnosticRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    WorkspaceDiagnosticRequest2.type = new messages_1.ProtocolRequestType(WorkspaceDiagnosticRequest2.method);
    WorkspaceDiagnosticRequest2.partialResult = new vscode_jsonrpc_1.ProgressType();
  })(WorkspaceDiagnosticRequest || (protocol_diagnostic.WorkspaceDiagnosticRequest = WorkspaceDiagnosticRequest = {}));
  var DiagnosticRefreshRequest;
  (function(DiagnosticRefreshRequest2) {
    DiagnosticRefreshRequest2.method = `workspace/diagnostic/refresh`;
    DiagnosticRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
    DiagnosticRefreshRequest2.type = new messages_1.ProtocolRequestType0(DiagnosticRefreshRequest2.method);
  })(DiagnosticRefreshRequest || (protocol_diagnostic.DiagnosticRefreshRequest = DiagnosticRefreshRequest = {}));
  return protocol_diagnostic;
}
var protocol_notebook = {};
var hasRequiredProtocol_notebook;
function requireProtocol_notebook() {
  if (hasRequiredProtocol_notebook) return protocol_notebook;
  hasRequiredProtocol_notebook = 1;
  Object.defineProperty(protocol_notebook, "__esModule", { value: true });
  protocol_notebook.DidCloseNotebookDocumentNotification = protocol_notebook.DidSaveNotebookDocumentNotification = protocol_notebook.DidChangeNotebookDocumentNotification = protocol_notebook.NotebookCellArrayChange = protocol_notebook.DidOpenNotebookDocumentNotification = protocol_notebook.NotebookDocumentSyncRegistrationType = protocol_notebook.NotebookDocument = protocol_notebook.NotebookCell = protocol_notebook.ExecutionSummary = protocol_notebook.NotebookCellKind = void 0;
  const vscode_languageserver_types_1 = require$$1;
  const Is2 = requireIs();
  const messages_1 = requireMessages();
  var NotebookCellKind;
  (function(NotebookCellKind2) {
    NotebookCellKind2.Markup = 1;
    NotebookCellKind2.Code = 2;
    function is2(value) {
      return value === 1 || value === 2;
    }
    NotebookCellKind2.is = is2;
  })(NotebookCellKind || (protocol_notebook.NotebookCellKind = NotebookCellKind = {}));
  var ExecutionSummary;
  (function(ExecutionSummary2) {
    function create2(executionOrder, success) {
      const result2 = { executionOrder };
      if (success === true || success === false) {
        result2.success = success;
      }
      return result2;
    }
    ExecutionSummary2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.executionOrder) && (candidate.success === void 0 || Is2.boolean(candidate.success));
    }
    ExecutionSummary2.is = is2;
    function equals2(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      return one.executionOrder === other.executionOrder && one.success === other.success;
    }
    ExecutionSummary2.equals = equals2;
  })(ExecutionSummary || (protocol_notebook.ExecutionSummary = ExecutionSummary = {}));
  var NotebookCell;
  (function(NotebookCell2) {
    function create2(kind, document2) {
      return { kind, document: document2 };
    }
    NotebookCell2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && NotebookCellKind.is(candidate.kind) && vscode_languageserver_types_1.DocumentUri.is(candidate.document) && (candidate.metadata === void 0 || Is2.objectLiteral(candidate.metadata));
    }
    NotebookCell2.is = is2;
    function diff(one, two) {
      const result2 = /* @__PURE__ */ new Set();
      if (one.document !== two.document) {
        result2.add("document");
      }
      if (one.kind !== two.kind) {
        result2.add("kind");
      }
      if (one.executionSummary !== two.executionSummary) {
        result2.add("executionSummary");
      }
      if ((one.metadata !== void 0 || two.metadata !== void 0) && !equalsMetadata(one.metadata, two.metadata)) {
        result2.add("metadata");
      }
      if ((one.executionSummary !== void 0 || two.executionSummary !== void 0) && !ExecutionSummary.equals(one.executionSummary, two.executionSummary)) {
        result2.add("executionSummary");
      }
      return result2;
    }
    NotebookCell2.diff = diff;
    function equalsMetadata(one, other) {
      if (one === other) {
        return true;
      }
      if (one === null || one === void 0 || other === null || other === void 0) {
        return false;
      }
      if (typeof one !== typeof other) {
        return false;
      }
      if (typeof one !== "object") {
        return false;
      }
      const oneArray = Array.isArray(one);
      const otherArray = Array.isArray(other);
      if (oneArray !== otherArray) {
        return false;
      }
      if (oneArray && otherArray) {
        if (one.length !== other.length) {
          return false;
        }
        for (let i2 = 0; i2 < one.length; i2++) {
          if (!equalsMetadata(one[i2], other[i2])) {
            return false;
          }
        }
      }
      if (Is2.objectLiteral(one) && Is2.objectLiteral(other)) {
        const oneKeys = Object.keys(one);
        const otherKeys = Object.keys(other);
        if (oneKeys.length !== otherKeys.length) {
          return false;
        }
        oneKeys.sort();
        otherKeys.sort();
        if (!equalsMetadata(oneKeys, otherKeys)) {
          return false;
        }
        for (let i2 = 0; i2 < oneKeys.length; i2++) {
          const prop = oneKeys[i2];
          if (!equalsMetadata(one[prop], other[prop])) {
            return false;
          }
        }
      }
      return true;
    }
  })(NotebookCell || (protocol_notebook.NotebookCell = NotebookCell = {}));
  var NotebookDocument;
  (function(NotebookDocument2) {
    function create2(uri, notebookType, version2, cells) {
      return { uri, notebookType, version: version2, cells };
    }
    NotebookDocument2.create = create2;
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && Is2.string(candidate.uri) && vscode_languageserver_types_1.integer.is(candidate.version) && Is2.typedArray(candidate.cells, NotebookCell.is);
    }
    NotebookDocument2.is = is2;
  })(NotebookDocument || (protocol_notebook.NotebookDocument = NotebookDocument = {}));
  var NotebookDocumentSyncRegistrationType;
  (function(NotebookDocumentSyncRegistrationType2) {
    NotebookDocumentSyncRegistrationType2.method = "notebookDocument/sync";
    NotebookDocumentSyncRegistrationType2.messageDirection = messages_1.MessageDirection.clientToServer;
    NotebookDocumentSyncRegistrationType2.type = new messages_1.RegistrationType(NotebookDocumentSyncRegistrationType2.method);
  })(NotebookDocumentSyncRegistrationType || (protocol_notebook.NotebookDocumentSyncRegistrationType = NotebookDocumentSyncRegistrationType = {}));
  var DidOpenNotebookDocumentNotification;
  (function(DidOpenNotebookDocumentNotification2) {
    DidOpenNotebookDocumentNotification2.method = "notebookDocument/didOpen";
    DidOpenNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidOpenNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenNotebookDocumentNotification2.method);
    DidOpenNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidOpenNotebookDocumentNotification || (protocol_notebook.DidOpenNotebookDocumentNotification = DidOpenNotebookDocumentNotification = {}));
  var NotebookCellArrayChange;
  (function(NotebookCellArrayChange2) {
    function is2(value) {
      const candidate = value;
      return Is2.objectLiteral(candidate) && vscode_languageserver_types_1.uinteger.is(candidate.start) && vscode_languageserver_types_1.uinteger.is(candidate.deleteCount) && (candidate.cells === void 0 || Is2.typedArray(candidate.cells, NotebookCell.is));
    }
    NotebookCellArrayChange2.is = is2;
    function create2(start, deleteCount, cells) {
      const result2 = { start, deleteCount };
      if (cells !== void 0) {
        result2.cells = cells;
      }
      return result2;
    }
    NotebookCellArrayChange2.create = create2;
  })(NotebookCellArrayChange || (protocol_notebook.NotebookCellArrayChange = NotebookCellArrayChange = {}));
  var DidChangeNotebookDocumentNotification;
  (function(DidChangeNotebookDocumentNotification2) {
    DidChangeNotebookDocumentNotification2.method = "notebookDocument/didChange";
    DidChangeNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidChangeNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeNotebookDocumentNotification2.method);
    DidChangeNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidChangeNotebookDocumentNotification || (protocol_notebook.DidChangeNotebookDocumentNotification = DidChangeNotebookDocumentNotification = {}));
  var DidSaveNotebookDocumentNotification;
  (function(DidSaveNotebookDocumentNotification2) {
    DidSaveNotebookDocumentNotification2.method = "notebookDocument/didSave";
    DidSaveNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidSaveNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveNotebookDocumentNotification2.method);
    DidSaveNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidSaveNotebookDocumentNotification || (protocol_notebook.DidSaveNotebookDocumentNotification = DidSaveNotebookDocumentNotification = {}));
  var DidCloseNotebookDocumentNotification;
  (function(DidCloseNotebookDocumentNotification2) {
    DidCloseNotebookDocumentNotification2.method = "notebookDocument/didClose";
    DidCloseNotebookDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
    DidCloseNotebookDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseNotebookDocumentNotification2.method);
    DidCloseNotebookDocumentNotification2.registrationMethod = NotebookDocumentSyncRegistrationType.method;
  })(DidCloseNotebookDocumentNotification || (protocol_notebook.DidCloseNotebookDocumentNotification = DidCloseNotebookDocumentNotification = {}));
  return protocol_notebook;
}
var protocol_inlineCompletion = {};
var hasRequiredProtocol_inlineCompletion;
function requireProtocol_inlineCompletion() {
  if (hasRequiredProtocol_inlineCompletion) return protocol_inlineCompletion;
  hasRequiredProtocol_inlineCompletion = 1;
  Object.defineProperty(protocol_inlineCompletion, "__esModule", { value: true });
  protocol_inlineCompletion.InlineCompletionRequest = void 0;
  const messages_1 = requireMessages();
  var InlineCompletionRequest;
  (function(InlineCompletionRequest2) {
    InlineCompletionRequest2.method = "textDocument/inlineCompletion";
    InlineCompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
    InlineCompletionRequest2.type = new messages_1.ProtocolRequestType(InlineCompletionRequest2.method);
  })(InlineCompletionRequest || (protocol_inlineCompletion.InlineCompletionRequest = InlineCompletionRequest = {}));
  return protocol_inlineCompletion;
}
var hasRequiredProtocol;
function requireProtocol() {
  if (hasRequiredProtocol) return protocol;
  hasRequiredProtocol = 1;
  (function(exports2) {
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.WorkspaceSymbolRequest = exports2.CodeActionResolveRequest = exports2.CodeActionRequest = exports2.DocumentSymbolRequest = exports2.DocumentHighlightRequest = exports2.ReferencesRequest = exports2.DefinitionRequest = exports2.SignatureHelpRequest = exports2.SignatureHelpTriggerKind = exports2.HoverRequest = exports2.CompletionResolveRequest = exports2.CompletionRequest = exports2.CompletionTriggerKind = exports2.PublishDiagnosticsNotification = exports2.WatchKind = exports2.RelativePattern = exports2.FileChangeType = exports2.DidChangeWatchedFilesNotification = exports2.WillSaveTextDocumentWaitUntilRequest = exports2.WillSaveTextDocumentNotification = exports2.TextDocumentSaveReason = exports2.DidSaveTextDocumentNotification = exports2.DidCloseTextDocumentNotification = exports2.DidChangeTextDocumentNotification = exports2.TextDocumentContentChangeEvent = exports2.DidOpenTextDocumentNotification = exports2.TextDocumentSyncKind = exports2.TelemetryEventNotification = exports2.LogMessageNotification = exports2.ShowMessageRequest = exports2.ShowMessageNotification = exports2.MessageType = exports2.DidChangeConfigurationNotification = exports2.ExitNotification = exports2.ShutdownRequest = exports2.InitializedNotification = exports2.InitializeErrorCodes = exports2.InitializeRequest = exports2.WorkDoneProgressOptions = exports2.TextDocumentRegistrationOptions = exports2.StaticRegistrationOptions = exports2.PositionEncodingKind = exports2.FailureHandlingKind = exports2.ResourceOperationKind = exports2.UnregistrationRequest = exports2.RegistrationRequest = exports2.DocumentSelector = exports2.NotebookCellTextDocumentFilter = exports2.NotebookDocumentFilter = exports2.TextDocumentFilter = void 0;
    exports2.MonikerRequest = exports2.MonikerKind = exports2.UniquenessLevel = exports2.WillDeleteFilesRequest = exports2.DidDeleteFilesNotification = exports2.WillRenameFilesRequest = exports2.DidRenameFilesNotification = exports2.WillCreateFilesRequest = exports2.DidCreateFilesNotification = exports2.FileOperationPatternKind = exports2.LinkedEditingRangeRequest = exports2.ShowDocumentRequest = exports2.SemanticTokensRegistrationType = exports2.SemanticTokensRefreshRequest = exports2.SemanticTokensRangeRequest = exports2.SemanticTokensDeltaRequest = exports2.SemanticTokensRequest = exports2.TokenFormat = exports2.CallHierarchyPrepareRequest = exports2.CallHierarchyOutgoingCallsRequest = exports2.CallHierarchyIncomingCallsRequest = exports2.WorkDoneProgressCancelNotification = exports2.WorkDoneProgressCreateRequest = exports2.WorkDoneProgress = exports2.SelectionRangeRequest = exports2.DeclarationRequest = exports2.FoldingRangeRefreshRequest = exports2.FoldingRangeRequest = exports2.ColorPresentationRequest = exports2.DocumentColorRequest = exports2.ConfigurationRequest = exports2.DidChangeWorkspaceFoldersNotification = exports2.WorkspaceFoldersRequest = exports2.TypeDefinitionRequest = exports2.ImplementationRequest = exports2.ApplyWorkspaceEditRequest = exports2.ExecuteCommandRequest = exports2.PrepareRenameRequest = exports2.RenameRequest = exports2.PrepareSupportDefaultBehavior = exports2.DocumentOnTypeFormattingRequest = exports2.DocumentRangesFormattingRequest = exports2.DocumentRangeFormattingRequest = exports2.DocumentFormattingRequest = exports2.DocumentLinkResolveRequest = exports2.DocumentLinkRequest = exports2.CodeLensRefreshRequest = exports2.CodeLensResolveRequest = exports2.CodeLensRequest = exports2.WorkspaceSymbolResolveRequest = void 0;
    exports2.InlineCompletionRequest = exports2.DidCloseNotebookDocumentNotification = exports2.DidSaveNotebookDocumentNotification = exports2.DidChangeNotebookDocumentNotification = exports2.NotebookCellArrayChange = exports2.DidOpenNotebookDocumentNotification = exports2.NotebookDocumentSyncRegistrationType = exports2.NotebookDocument = exports2.NotebookCell = exports2.ExecutionSummary = exports2.NotebookCellKind = exports2.DiagnosticRefreshRequest = exports2.WorkspaceDiagnosticRequest = exports2.DocumentDiagnosticRequest = exports2.DocumentDiagnosticReportKind = exports2.DiagnosticServerCancellationData = exports2.InlayHintRefreshRequest = exports2.InlayHintResolveRequest = exports2.InlayHintRequest = exports2.InlineValueRefreshRequest = exports2.InlineValueRequest = exports2.TypeHierarchySupertypesRequest = exports2.TypeHierarchySubtypesRequest = exports2.TypeHierarchyPrepareRequest = void 0;
    const messages_1 = requireMessages();
    const vscode_languageserver_types_1 = require$$1;
    const Is2 = requireIs();
    const protocol_implementation_1 = requireProtocol_implementation();
    Object.defineProperty(exports2, "ImplementationRequest", { enumerable: true, get: function() {
      return protocol_implementation_1.ImplementationRequest;
    } });
    const protocol_typeDefinition_1 = requireProtocol_typeDefinition();
    Object.defineProperty(exports2, "TypeDefinitionRequest", { enumerable: true, get: function() {
      return protocol_typeDefinition_1.TypeDefinitionRequest;
    } });
    const protocol_workspaceFolder_1 = requireProtocol_workspaceFolder();
    Object.defineProperty(exports2, "WorkspaceFoldersRequest", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.WorkspaceFoldersRequest;
    } });
    Object.defineProperty(exports2, "DidChangeWorkspaceFoldersNotification", { enumerable: true, get: function() {
      return protocol_workspaceFolder_1.DidChangeWorkspaceFoldersNotification;
    } });
    const protocol_configuration_1 = requireProtocol_configuration();
    Object.defineProperty(exports2, "ConfigurationRequest", { enumerable: true, get: function() {
      return protocol_configuration_1.ConfigurationRequest;
    } });
    const protocol_colorProvider_1 = requireProtocol_colorProvider();
    Object.defineProperty(exports2, "DocumentColorRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.DocumentColorRequest;
    } });
    Object.defineProperty(exports2, "ColorPresentationRequest", { enumerable: true, get: function() {
      return protocol_colorProvider_1.ColorPresentationRequest;
    } });
    const protocol_foldingRange_1 = requireProtocol_foldingRange();
    Object.defineProperty(exports2, "FoldingRangeRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRequest;
    } });
    Object.defineProperty(exports2, "FoldingRangeRefreshRequest", { enumerable: true, get: function() {
      return protocol_foldingRange_1.FoldingRangeRefreshRequest;
    } });
    const protocol_declaration_1 = requireProtocol_declaration();
    Object.defineProperty(exports2, "DeclarationRequest", { enumerable: true, get: function() {
      return protocol_declaration_1.DeclarationRequest;
    } });
    const protocol_selectionRange_1 = requireProtocol_selectionRange();
    Object.defineProperty(exports2, "SelectionRangeRequest", { enumerable: true, get: function() {
      return protocol_selectionRange_1.SelectionRangeRequest;
    } });
    const protocol_progress_1 = requireProtocol_progress();
    Object.defineProperty(exports2, "WorkDoneProgress", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgress;
    } });
    Object.defineProperty(exports2, "WorkDoneProgressCreateRequest", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCreateRequest;
    } });
    Object.defineProperty(exports2, "WorkDoneProgressCancelNotification", { enumerable: true, get: function() {
      return protocol_progress_1.WorkDoneProgressCancelNotification;
    } });
    const protocol_callHierarchy_1 = requireProtocol_callHierarchy();
    Object.defineProperty(exports2, "CallHierarchyIncomingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyIncomingCallsRequest;
    } });
    Object.defineProperty(exports2, "CallHierarchyOutgoingCallsRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyOutgoingCallsRequest;
    } });
    Object.defineProperty(exports2, "CallHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_callHierarchy_1.CallHierarchyPrepareRequest;
    } });
    const protocol_semanticTokens_1 = requireProtocol_semanticTokens();
    Object.defineProperty(exports2, "TokenFormat", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.TokenFormat;
    } });
    Object.defineProperty(exports2, "SemanticTokensRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensDeltaRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensDeltaRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRangeRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRangeRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRefreshRequest", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRefreshRequest;
    } });
    Object.defineProperty(exports2, "SemanticTokensRegistrationType", { enumerable: true, get: function() {
      return protocol_semanticTokens_1.SemanticTokensRegistrationType;
    } });
    const protocol_showDocument_1 = requireProtocol_showDocument();
    Object.defineProperty(exports2, "ShowDocumentRequest", { enumerable: true, get: function() {
      return protocol_showDocument_1.ShowDocumentRequest;
    } });
    const protocol_linkedEditingRange_1 = requireProtocol_linkedEditingRange();
    Object.defineProperty(exports2, "LinkedEditingRangeRequest", { enumerable: true, get: function() {
      return protocol_linkedEditingRange_1.LinkedEditingRangeRequest;
    } });
    const protocol_fileOperations_1 = requireProtocol_fileOperations();
    Object.defineProperty(exports2, "FileOperationPatternKind", { enumerable: true, get: function() {
      return protocol_fileOperations_1.FileOperationPatternKind;
    } });
    Object.defineProperty(exports2, "DidCreateFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidCreateFilesNotification;
    } });
    Object.defineProperty(exports2, "WillCreateFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillCreateFilesRequest;
    } });
    Object.defineProperty(exports2, "DidRenameFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidRenameFilesNotification;
    } });
    Object.defineProperty(exports2, "WillRenameFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillRenameFilesRequest;
    } });
    Object.defineProperty(exports2, "DidDeleteFilesNotification", { enumerable: true, get: function() {
      return protocol_fileOperations_1.DidDeleteFilesNotification;
    } });
    Object.defineProperty(exports2, "WillDeleteFilesRequest", { enumerable: true, get: function() {
      return protocol_fileOperations_1.WillDeleteFilesRequest;
    } });
    const protocol_moniker_1 = requireProtocol_moniker();
    Object.defineProperty(exports2, "UniquenessLevel", { enumerable: true, get: function() {
      return protocol_moniker_1.UniquenessLevel;
    } });
    Object.defineProperty(exports2, "MonikerKind", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerKind;
    } });
    Object.defineProperty(exports2, "MonikerRequest", { enumerable: true, get: function() {
      return protocol_moniker_1.MonikerRequest;
    } });
    const protocol_typeHierarchy_1 = requireProtocol_typeHierarchy();
    Object.defineProperty(exports2, "TypeHierarchyPrepareRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchyPrepareRequest;
    } });
    Object.defineProperty(exports2, "TypeHierarchySubtypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySubtypesRequest;
    } });
    Object.defineProperty(exports2, "TypeHierarchySupertypesRequest", { enumerable: true, get: function() {
      return protocol_typeHierarchy_1.TypeHierarchySupertypesRequest;
    } });
    const protocol_inlineValue_1 = requireProtocol_inlineValue();
    Object.defineProperty(exports2, "InlineValueRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRequest;
    } });
    Object.defineProperty(exports2, "InlineValueRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlineValue_1.InlineValueRefreshRequest;
    } });
    const protocol_inlayHint_1 = requireProtocol_inlayHint();
    Object.defineProperty(exports2, "InlayHintRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRequest;
    } });
    Object.defineProperty(exports2, "InlayHintResolveRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintResolveRequest;
    } });
    Object.defineProperty(exports2, "InlayHintRefreshRequest", { enumerable: true, get: function() {
      return protocol_inlayHint_1.InlayHintRefreshRequest;
    } });
    const protocol_diagnostic_1 = requireProtocol_diagnostic();
    Object.defineProperty(exports2, "DiagnosticServerCancellationData", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticServerCancellationData;
    } });
    Object.defineProperty(exports2, "DocumentDiagnosticReportKind", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticReportKind;
    } });
    Object.defineProperty(exports2, "DocumentDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DocumentDiagnosticRequest;
    } });
    Object.defineProperty(exports2, "WorkspaceDiagnosticRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.WorkspaceDiagnosticRequest;
    } });
    Object.defineProperty(exports2, "DiagnosticRefreshRequest", { enumerable: true, get: function() {
      return protocol_diagnostic_1.DiagnosticRefreshRequest;
    } });
    const protocol_notebook_1 = requireProtocol_notebook();
    Object.defineProperty(exports2, "NotebookCellKind", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellKind;
    } });
    Object.defineProperty(exports2, "ExecutionSummary", { enumerable: true, get: function() {
      return protocol_notebook_1.ExecutionSummary;
    } });
    Object.defineProperty(exports2, "NotebookCell", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCell;
    } });
    Object.defineProperty(exports2, "NotebookDocument", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocument;
    } });
    Object.defineProperty(exports2, "NotebookDocumentSyncRegistrationType", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookDocumentSyncRegistrationType;
    } });
    Object.defineProperty(exports2, "DidOpenNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidOpenNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "NotebookCellArrayChange", { enumerable: true, get: function() {
      return protocol_notebook_1.NotebookCellArrayChange;
    } });
    Object.defineProperty(exports2, "DidChangeNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidChangeNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "DidSaveNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidSaveNotebookDocumentNotification;
    } });
    Object.defineProperty(exports2, "DidCloseNotebookDocumentNotification", { enumerable: true, get: function() {
      return protocol_notebook_1.DidCloseNotebookDocumentNotification;
    } });
    const protocol_inlineCompletion_1 = requireProtocol_inlineCompletion();
    Object.defineProperty(exports2, "InlineCompletionRequest", { enumerable: true, get: function() {
      return protocol_inlineCompletion_1.InlineCompletionRequest;
    } });
    var TextDocumentFilter;
    (function(TextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.string(candidate) || (Is2.string(candidate.language) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      TextDocumentFilter2.is = is2;
    })(TextDocumentFilter || (exports2.TextDocumentFilter = TextDocumentFilter = {}));
    var NotebookDocumentFilter;
    (function(NotebookDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebookType) || Is2.string(candidate.scheme) || Is2.string(candidate.pattern));
      }
      NotebookDocumentFilter2.is = is2;
    })(NotebookDocumentFilter || (exports2.NotebookDocumentFilter = NotebookDocumentFilter = {}));
    var NotebookCellTextDocumentFilter;
    (function(NotebookCellTextDocumentFilter2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (Is2.string(candidate.notebook) || NotebookDocumentFilter.is(candidate.notebook)) && (candidate.language === void 0 || Is2.string(candidate.language));
      }
      NotebookCellTextDocumentFilter2.is = is2;
    })(NotebookCellTextDocumentFilter || (exports2.NotebookCellTextDocumentFilter = NotebookCellTextDocumentFilter = {}));
    var DocumentSelector;
    (function(DocumentSelector2) {
      function is2(value) {
        if (!Array.isArray(value)) {
          return false;
        }
        for (let elem of value) {
          if (!Is2.string(elem) && !TextDocumentFilter.is(elem) && !NotebookCellTextDocumentFilter.is(elem)) {
            return false;
          }
        }
        return true;
      }
      DocumentSelector2.is = is2;
    })(DocumentSelector || (exports2.DocumentSelector = DocumentSelector = {}));
    var RegistrationRequest;
    (function(RegistrationRequest2) {
      RegistrationRequest2.method = "client/registerCapability";
      RegistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      RegistrationRequest2.type = new messages_1.ProtocolRequestType(RegistrationRequest2.method);
    })(RegistrationRequest || (exports2.RegistrationRequest = RegistrationRequest = {}));
    var UnregistrationRequest;
    (function(UnregistrationRequest2) {
      UnregistrationRequest2.method = "client/unregisterCapability";
      UnregistrationRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      UnregistrationRequest2.type = new messages_1.ProtocolRequestType(UnregistrationRequest2.method);
    })(UnregistrationRequest || (exports2.UnregistrationRequest = UnregistrationRequest = {}));
    var ResourceOperationKind;
    (function(ResourceOperationKind2) {
      ResourceOperationKind2.Create = "create";
      ResourceOperationKind2.Rename = "rename";
      ResourceOperationKind2.Delete = "delete";
    })(ResourceOperationKind || (exports2.ResourceOperationKind = ResourceOperationKind = {}));
    var FailureHandlingKind;
    (function(FailureHandlingKind2) {
      FailureHandlingKind2.Abort = "abort";
      FailureHandlingKind2.Transactional = "transactional";
      FailureHandlingKind2.TextOnlyTransactional = "textOnlyTransactional";
      FailureHandlingKind2.Undo = "undo";
    })(FailureHandlingKind || (exports2.FailureHandlingKind = FailureHandlingKind = {}));
    var PositionEncodingKind;
    (function(PositionEncodingKind2) {
      PositionEncodingKind2.UTF8 = "utf-8";
      PositionEncodingKind2.UTF16 = "utf-16";
      PositionEncodingKind2.UTF32 = "utf-32";
    })(PositionEncodingKind || (exports2.PositionEncodingKind = PositionEncodingKind = {}));
    var StaticRegistrationOptions;
    (function(StaticRegistrationOptions2) {
      function hasId(value) {
        const candidate = value;
        return candidate && Is2.string(candidate.id) && candidate.id.length > 0;
      }
      StaticRegistrationOptions2.hasId = hasId;
    })(StaticRegistrationOptions || (exports2.StaticRegistrationOptions = StaticRegistrationOptions = {}));
    var TextDocumentRegistrationOptions;
    (function(TextDocumentRegistrationOptions2) {
      function is2(value) {
        const candidate = value;
        return candidate && (candidate.documentSelector === null || DocumentSelector.is(candidate.documentSelector));
      }
      TextDocumentRegistrationOptions2.is = is2;
    })(TextDocumentRegistrationOptions || (exports2.TextDocumentRegistrationOptions = TextDocumentRegistrationOptions = {}));
    var WorkDoneProgressOptions;
    (function(WorkDoneProgressOptions2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (candidate.workDoneProgress === void 0 || Is2.boolean(candidate.workDoneProgress));
      }
      WorkDoneProgressOptions2.is = is2;
      function hasWorkDoneProgress(value) {
        const candidate = value;
        return candidate && Is2.boolean(candidate.workDoneProgress);
      }
      WorkDoneProgressOptions2.hasWorkDoneProgress = hasWorkDoneProgress;
    })(WorkDoneProgressOptions || (exports2.WorkDoneProgressOptions = WorkDoneProgressOptions = {}));
    var InitializeRequest;
    (function(InitializeRequest2) {
      InitializeRequest2.method = "initialize";
      InitializeRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializeRequest2.type = new messages_1.ProtocolRequestType(InitializeRequest2.method);
    })(InitializeRequest || (exports2.InitializeRequest = InitializeRequest = {}));
    var InitializeErrorCodes;
    (function(InitializeErrorCodes2) {
      InitializeErrorCodes2.unknownProtocolVersion = 1;
    })(InitializeErrorCodes || (exports2.InitializeErrorCodes = InitializeErrorCodes = {}));
    var InitializedNotification;
    (function(InitializedNotification2) {
      InitializedNotification2.method = "initialized";
      InitializedNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      InitializedNotification2.type = new messages_1.ProtocolNotificationType(InitializedNotification2.method);
    })(InitializedNotification || (exports2.InitializedNotification = InitializedNotification = {}));
    var ShutdownRequest;
    (function(ShutdownRequest2) {
      ShutdownRequest2.method = "shutdown";
      ShutdownRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ShutdownRequest2.type = new messages_1.ProtocolRequestType0(ShutdownRequest2.method);
    })(ShutdownRequest || (exports2.ShutdownRequest = ShutdownRequest = {}));
    var ExitNotification;
    (function(ExitNotification2) {
      ExitNotification2.method = "exit";
      ExitNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExitNotification2.type = new messages_1.ProtocolNotificationType0(ExitNotification2.method);
    })(ExitNotification || (exports2.ExitNotification = ExitNotification = {}));
    var DidChangeConfigurationNotification;
    (function(DidChangeConfigurationNotification2) {
      DidChangeConfigurationNotification2.method = "workspace/didChangeConfiguration";
      DidChangeConfigurationNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeConfigurationNotification2.type = new messages_1.ProtocolNotificationType(DidChangeConfigurationNotification2.method);
    })(DidChangeConfigurationNotification || (exports2.DidChangeConfigurationNotification = DidChangeConfigurationNotification = {}));
    var MessageType;
    (function(MessageType2) {
      MessageType2.Error = 1;
      MessageType2.Warning = 2;
      MessageType2.Info = 3;
      MessageType2.Log = 4;
      MessageType2.Debug = 5;
    })(MessageType || (exports2.MessageType = MessageType = {}));
    var ShowMessageNotification;
    (function(ShowMessageNotification2) {
      ShowMessageNotification2.method = "window/showMessage";
      ShowMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageNotification2.type = new messages_1.ProtocolNotificationType(ShowMessageNotification2.method);
    })(ShowMessageNotification || (exports2.ShowMessageNotification = ShowMessageNotification = {}));
    var ShowMessageRequest;
    (function(ShowMessageRequest2) {
      ShowMessageRequest2.method = "window/showMessageRequest";
      ShowMessageRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ShowMessageRequest2.type = new messages_1.ProtocolRequestType(ShowMessageRequest2.method);
    })(ShowMessageRequest || (exports2.ShowMessageRequest = ShowMessageRequest = {}));
    var LogMessageNotification;
    (function(LogMessageNotification2) {
      LogMessageNotification2.method = "window/logMessage";
      LogMessageNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      LogMessageNotification2.type = new messages_1.ProtocolNotificationType(LogMessageNotification2.method);
    })(LogMessageNotification || (exports2.LogMessageNotification = LogMessageNotification = {}));
    var TelemetryEventNotification;
    (function(TelemetryEventNotification2) {
      TelemetryEventNotification2.method = "telemetry/event";
      TelemetryEventNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      TelemetryEventNotification2.type = new messages_1.ProtocolNotificationType(TelemetryEventNotification2.method);
    })(TelemetryEventNotification || (exports2.TelemetryEventNotification = TelemetryEventNotification = {}));
    var TextDocumentSyncKind;
    (function(TextDocumentSyncKind2) {
      TextDocumentSyncKind2.None = 0;
      TextDocumentSyncKind2.Full = 1;
      TextDocumentSyncKind2.Incremental = 2;
    })(TextDocumentSyncKind || (exports2.TextDocumentSyncKind = TextDocumentSyncKind = {}));
    var DidOpenTextDocumentNotification;
    (function(DidOpenTextDocumentNotification2) {
      DidOpenTextDocumentNotification2.method = "textDocument/didOpen";
      DidOpenTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidOpenTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidOpenTextDocumentNotification2.method);
    })(DidOpenTextDocumentNotification || (exports2.DidOpenTextDocumentNotification = DidOpenTextDocumentNotification = {}));
    var TextDocumentContentChangeEvent;
    (function(TextDocumentContentChangeEvent2) {
      function isIncremental(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range !== void 0 && (candidate.rangeLength === void 0 || typeof candidate.rangeLength === "number");
      }
      TextDocumentContentChangeEvent2.isIncremental = isIncremental;
      function isFull(event) {
        let candidate = event;
        return candidate !== void 0 && candidate !== null && typeof candidate.text === "string" && candidate.range === void 0 && candidate.rangeLength === void 0;
      }
      TextDocumentContentChangeEvent2.isFull = isFull;
    })(TextDocumentContentChangeEvent || (exports2.TextDocumentContentChangeEvent = TextDocumentContentChangeEvent = {}));
    var DidChangeTextDocumentNotification;
    (function(DidChangeTextDocumentNotification2) {
      DidChangeTextDocumentNotification2.method = "textDocument/didChange";
      DidChangeTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidChangeTextDocumentNotification2.method);
    })(DidChangeTextDocumentNotification || (exports2.DidChangeTextDocumentNotification = DidChangeTextDocumentNotification = {}));
    var DidCloseTextDocumentNotification;
    (function(DidCloseTextDocumentNotification2) {
      DidCloseTextDocumentNotification2.method = "textDocument/didClose";
      DidCloseTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidCloseTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidCloseTextDocumentNotification2.method);
    })(DidCloseTextDocumentNotification || (exports2.DidCloseTextDocumentNotification = DidCloseTextDocumentNotification = {}));
    var DidSaveTextDocumentNotification;
    (function(DidSaveTextDocumentNotification2) {
      DidSaveTextDocumentNotification2.method = "textDocument/didSave";
      DidSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(DidSaveTextDocumentNotification2.method);
    })(DidSaveTextDocumentNotification || (exports2.DidSaveTextDocumentNotification = DidSaveTextDocumentNotification = {}));
    var TextDocumentSaveReason;
    (function(TextDocumentSaveReason2) {
      TextDocumentSaveReason2.Manual = 1;
      TextDocumentSaveReason2.AfterDelay = 2;
      TextDocumentSaveReason2.FocusOut = 3;
    })(TextDocumentSaveReason || (exports2.TextDocumentSaveReason = TextDocumentSaveReason = {}));
    var WillSaveTextDocumentNotification;
    (function(WillSaveTextDocumentNotification2) {
      WillSaveTextDocumentNotification2.method = "textDocument/willSave";
      WillSaveTextDocumentNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentNotification2.type = new messages_1.ProtocolNotificationType(WillSaveTextDocumentNotification2.method);
    })(WillSaveTextDocumentNotification || (exports2.WillSaveTextDocumentNotification = WillSaveTextDocumentNotification = {}));
    var WillSaveTextDocumentWaitUntilRequest;
    (function(WillSaveTextDocumentWaitUntilRequest2) {
      WillSaveTextDocumentWaitUntilRequest2.method = "textDocument/willSaveWaitUntil";
      WillSaveTextDocumentWaitUntilRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WillSaveTextDocumentWaitUntilRequest2.type = new messages_1.ProtocolRequestType(WillSaveTextDocumentWaitUntilRequest2.method);
    })(WillSaveTextDocumentWaitUntilRequest || (exports2.WillSaveTextDocumentWaitUntilRequest = WillSaveTextDocumentWaitUntilRequest = {}));
    var DidChangeWatchedFilesNotification;
    (function(DidChangeWatchedFilesNotification2) {
      DidChangeWatchedFilesNotification2.method = "workspace/didChangeWatchedFiles";
      DidChangeWatchedFilesNotification2.messageDirection = messages_1.MessageDirection.clientToServer;
      DidChangeWatchedFilesNotification2.type = new messages_1.ProtocolNotificationType(DidChangeWatchedFilesNotification2.method);
    })(DidChangeWatchedFilesNotification || (exports2.DidChangeWatchedFilesNotification = DidChangeWatchedFilesNotification = {}));
    var FileChangeType;
    (function(FileChangeType2) {
      FileChangeType2.Created = 1;
      FileChangeType2.Changed = 2;
      FileChangeType2.Deleted = 3;
    })(FileChangeType || (exports2.FileChangeType = FileChangeType = {}));
    var RelativePattern;
    (function(RelativePattern2) {
      function is2(value) {
        const candidate = value;
        return Is2.objectLiteral(candidate) && (vscode_languageserver_types_1.URI.is(candidate.baseUri) || vscode_languageserver_types_1.WorkspaceFolder.is(candidate.baseUri)) && Is2.string(candidate.pattern);
      }
      RelativePattern2.is = is2;
    })(RelativePattern || (exports2.RelativePattern = RelativePattern = {}));
    var WatchKind;
    (function(WatchKind2) {
      WatchKind2.Create = 1;
      WatchKind2.Change = 2;
      WatchKind2.Delete = 4;
    })(WatchKind || (exports2.WatchKind = WatchKind = {}));
    var PublishDiagnosticsNotification;
    (function(PublishDiagnosticsNotification2) {
      PublishDiagnosticsNotification2.method = "textDocument/publishDiagnostics";
      PublishDiagnosticsNotification2.messageDirection = messages_1.MessageDirection.serverToClient;
      PublishDiagnosticsNotification2.type = new messages_1.ProtocolNotificationType(PublishDiagnosticsNotification2.method);
    })(PublishDiagnosticsNotification || (exports2.PublishDiagnosticsNotification = PublishDiagnosticsNotification = {}));
    var CompletionTriggerKind;
    (function(CompletionTriggerKind2) {
      CompletionTriggerKind2.Invoked = 1;
      CompletionTriggerKind2.TriggerCharacter = 2;
      CompletionTriggerKind2.TriggerForIncompleteCompletions = 3;
    })(CompletionTriggerKind || (exports2.CompletionTriggerKind = CompletionTriggerKind = {}));
    var CompletionRequest;
    (function(CompletionRequest2) {
      CompletionRequest2.method = "textDocument/completion";
      CompletionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionRequest2.type = new messages_1.ProtocolRequestType(CompletionRequest2.method);
    })(CompletionRequest || (exports2.CompletionRequest = CompletionRequest = {}));
    var CompletionResolveRequest;
    (function(CompletionResolveRequest2) {
      CompletionResolveRequest2.method = "completionItem/resolve";
      CompletionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CompletionResolveRequest2.type = new messages_1.ProtocolRequestType(CompletionResolveRequest2.method);
    })(CompletionResolveRequest || (exports2.CompletionResolveRequest = CompletionResolveRequest = {}));
    var HoverRequest;
    (function(HoverRequest2) {
      HoverRequest2.method = "textDocument/hover";
      HoverRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      HoverRequest2.type = new messages_1.ProtocolRequestType(HoverRequest2.method);
    })(HoverRequest || (exports2.HoverRequest = HoverRequest = {}));
    var SignatureHelpTriggerKind;
    (function(SignatureHelpTriggerKind2) {
      SignatureHelpTriggerKind2.Invoked = 1;
      SignatureHelpTriggerKind2.TriggerCharacter = 2;
      SignatureHelpTriggerKind2.ContentChange = 3;
    })(SignatureHelpTriggerKind || (exports2.SignatureHelpTriggerKind = SignatureHelpTriggerKind = {}));
    var SignatureHelpRequest;
    (function(SignatureHelpRequest2) {
      SignatureHelpRequest2.method = "textDocument/signatureHelp";
      SignatureHelpRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      SignatureHelpRequest2.type = new messages_1.ProtocolRequestType(SignatureHelpRequest2.method);
    })(SignatureHelpRequest || (exports2.SignatureHelpRequest = SignatureHelpRequest = {}));
    var DefinitionRequest;
    (function(DefinitionRequest2) {
      DefinitionRequest2.method = "textDocument/definition";
      DefinitionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DefinitionRequest2.type = new messages_1.ProtocolRequestType(DefinitionRequest2.method);
    })(DefinitionRequest || (exports2.DefinitionRequest = DefinitionRequest = {}));
    var ReferencesRequest;
    (function(ReferencesRequest2) {
      ReferencesRequest2.method = "textDocument/references";
      ReferencesRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ReferencesRequest2.type = new messages_1.ProtocolRequestType(ReferencesRequest2.method);
    })(ReferencesRequest || (exports2.ReferencesRequest = ReferencesRequest = {}));
    var DocumentHighlightRequest;
    (function(DocumentHighlightRequest2) {
      DocumentHighlightRequest2.method = "textDocument/documentHighlight";
      DocumentHighlightRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentHighlightRequest2.type = new messages_1.ProtocolRequestType(DocumentHighlightRequest2.method);
    })(DocumentHighlightRequest || (exports2.DocumentHighlightRequest = DocumentHighlightRequest = {}));
    var DocumentSymbolRequest;
    (function(DocumentSymbolRequest2) {
      DocumentSymbolRequest2.method = "textDocument/documentSymbol";
      DocumentSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentSymbolRequest2.type = new messages_1.ProtocolRequestType(DocumentSymbolRequest2.method);
    })(DocumentSymbolRequest || (exports2.DocumentSymbolRequest = DocumentSymbolRequest = {}));
    var CodeActionRequest;
    (function(CodeActionRequest2) {
      CodeActionRequest2.method = "textDocument/codeAction";
      CodeActionRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionRequest2.type = new messages_1.ProtocolRequestType(CodeActionRequest2.method);
    })(CodeActionRequest || (exports2.CodeActionRequest = CodeActionRequest = {}));
    var CodeActionResolveRequest;
    (function(CodeActionResolveRequest2) {
      CodeActionResolveRequest2.method = "codeAction/resolve";
      CodeActionResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeActionResolveRequest2.type = new messages_1.ProtocolRequestType(CodeActionResolveRequest2.method);
    })(CodeActionResolveRequest || (exports2.CodeActionResolveRequest = CodeActionResolveRequest = {}));
    var WorkspaceSymbolRequest;
    (function(WorkspaceSymbolRequest2) {
      WorkspaceSymbolRequest2.method = "workspace/symbol";
      WorkspaceSymbolRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolRequest2.method);
    })(WorkspaceSymbolRequest || (exports2.WorkspaceSymbolRequest = WorkspaceSymbolRequest = {}));
    var WorkspaceSymbolResolveRequest;
    (function(WorkspaceSymbolResolveRequest2) {
      WorkspaceSymbolResolveRequest2.method = "workspaceSymbol/resolve";
      WorkspaceSymbolResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      WorkspaceSymbolResolveRequest2.type = new messages_1.ProtocolRequestType(WorkspaceSymbolResolveRequest2.method);
    })(WorkspaceSymbolResolveRequest || (exports2.WorkspaceSymbolResolveRequest = WorkspaceSymbolResolveRequest = {}));
    var CodeLensRequest;
    (function(CodeLensRequest2) {
      CodeLensRequest2.method = "textDocument/codeLens";
      CodeLensRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensRequest2.type = new messages_1.ProtocolRequestType(CodeLensRequest2.method);
    })(CodeLensRequest || (exports2.CodeLensRequest = CodeLensRequest = {}));
    var CodeLensResolveRequest;
    (function(CodeLensResolveRequest2) {
      CodeLensResolveRequest2.method = "codeLens/resolve";
      CodeLensResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      CodeLensResolveRequest2.type = new messages_1.ProtocolRequestType(CodeLensResolveRequest2.method);
    })(CodeLensResolveRequest || (exports2.CodeLensResolveRequest = CodeLensResolveRequest = {}));
    var CodeLensRefreshRequest;
    (function(CodeLensRefreshRequest2) {
      CodeLensRefreshRequest2.method = `workspace/codeLens/refresh`;
      CodeLensRefreshRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      CodeLensRefreshRequest2.type = new messages_1.ProtocolRequestType0(CodeLensRefreshRequest2.method);
    })(CodeLensRefreshRequest || (exports2.CodeLensRefreshRequest = CodeLensRefreshRequest = {}));
    var DocumentLinkRequest;
    (function(DocumentLinkRequest2) {
      DocumentLinkRequest2.method = "textDocument/documentLink";
      DocumentLinkRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkRequest2.method);
    })(DocumentLinkRequest || (exports2.DocumentLinkRequest = DocumentLinkRequest = {}));
    var DocumentLinkResolveRequest;
    (function(DocumentLinkResolveRequest2) {
      DocumentLinkResolveRequest2.method = "documentLink/resolve";
      DocumentLinkResolveRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentLinkResolveRequest2.type = new messages_1.ProtocolRequestType(DocumentLinkResolveRequest2.method);
    })(DocumentLinkResolveRequest || (exports2.DocumentLinkResolveRequest = DocumentLinkResolveRequest = {}));
    var DocumentFormattingRequest;
    (function(DocumentFormattingRequest2) {
      DocumentFormattingRequest2.method = "textDocument/formatting";
      DocumentFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentFormattingRequest2.method);
    })(DocumentFormattingRequest || (exports2.DocumentFormattingRequest = DocumentFormattingRequest = {}));
    var DocumentRangeFormattingRequest;
    (function(DocumentRangeFormattingRequest2) {
      DocumentRangeFormattingRequest2.method = "textDocument/rangeFormatting";
      DocumentRangeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangeFormattingRequest2.method);
    })(DocumentRangeFormattingRequest || (exports2.DocumentRangeFormattingRequest = DocumentRangeFormattingRequest = {}));
    var DocumentRangesFormattingRequest;
    (function(DocumentRangesFormattingRequest2) {
      DocumentRangesFormattingRequest2.method = "textDocument/rangesFormatting";
      DocumentRangesFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentRangesFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentRangesFormattingRequest2.method);
    })(DocumentRangesFormattingRequest || (exports2.DocumentRangesFormattingRequest = DocumentRangesFormattingRequest = {}));
    var DocumentOnTypeFormattingRequest;
    (function(DocumentOnTypeFormattingRequest2) {
      DocumentOnTypeFormattingRequest2.method = "textDocument/onTypeFormatting";
      DocumentOnTypeFormattingRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      DocumentOnTypeFormattingRequest2.type = new messages_1.ProtocolRequestType(DocumentOnTypeFormattingRequest2.method);
    })(DocumentOnTypeFormattingRequest || (exports2.DocumentOnTypeFormattingRequest = DocumentOnTypeFormattingRequest = {}));
    var PrepareSupportDefaultBehavior;
    (function(PrepareSupportDefaultBehavior2) {
      PrepareSupportDefaultBehavior2.Identifier = 1;
    })(PrepareSupportDefaultBehavior || (exports2.PrepareSupportDefaultBehavior = PrepareSupportDefaultBehavior = {}));
    var RenameRequest;
    (function(RenameRequest2) {
      RenameRequest2.method = "textDocument/rename";
      RenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      RenameRequest2.type = new messages_1.ProtocolRequestType(RenameRequest2.method);
    })(RenameRequest || (exports2.RenameRequest = RenameRequest = {}));
    var PrepareRenameRequest;
    (function(PrepareRenameRequest2) {
      PrepareRenameRequest2.method = "textDocument/prepareRename";
      PrepareRenameRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      PrepareRenameRequest2.type = new messages_1.ProtocolRequestType(PrepareRenameRequest2.method);
    })(PrepareRenameRequest || (exports2.PrepareRenameRequest = PrepareRenameRequest = {}));
    var ExecuteCommandRequest;
    (function(ExecuteCommandRequest2) {
      ExecuteCommandRequest2.method = "workspace/executeCommand";
      ExecuteCommandRequest2.messageDirection = messages_1.MessageDirection.clientToServer;
      ExecuteCommandRequest2.type = new messages_1.ProtocolRequestType(ExecuteCommandRequest2.method);
    })(ExecuteCommandRequest || (exports2.ExecuteCommandRequest = ExecuteCommandRequest = {}));
    var ApplyWorkspaceEditRequest;
    (function(ApplyWorkspaceEditRequest2) {
      ApplyWorkspaceEditRequest2.method = "workspace/applyEdit";
      ApplyWorkspaceEditRequest2.messageDirection = messages_1.MessageDirection.serverToClient;
      ApplyWorkspaceEditRequest2.type = new messages_1.ProtocolRequestType("workspace/applyEdit");
    })(ApplyWorkspaceEditRequest || (exports2.ApplyWorkspaceEditRequest = ApplyWorkspaceEditRequest = {}));
  })(protocol);
  return protocol;
}
var connection = {};
var hasRequiredConnection;
function requireConnection() {
  if (hasRequiredConnection) return connection;
  hasRequiredConnection = 1;
  Object.defineProperty(connection, "__esModule", { value: true });
  connection.createProtocolConnection = void 0;
  const vscode_jsonrpc_1 = requireMain$1();
  function createProtocolConnection(input, output, logger, options2) {
    if (vscode_jsonrpc_1.ConnectionStrategy.is(options2)) {
      options2 = { connectionStrategy: options2 };
    }
    return (0, vscode_jsonrpc_1.createMessageConnection)(input, output, logger, options2);
  }
  connection.createProtocolConnection = createProtocolConnection;
  return connection;
}
var hasRequiredApi;
function requireApi() {
  if (hasRequiredApi) return api;
  hasRequiredApi = 1;
  (function(exports2) {
    var __createBinding = api && api.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = api && api.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.LSPErrorCodes = exports2.createProtocolConnection = void 0;
    __exportStar(requireMain$1(), exports2);
    __exportStar(require$$1, exports2);
    __exportStar(requireMessages(), exports2);
    __exportStar(requireProtocol(), exports2);
    var connection_1 = requireConnection();
    Object.defineProperty(exports2, "createProtocolConnection", { enumerable: true, get: function() {
      return connection_1.createProtocolConnection;
    } });
    var LSPErrorCodes;
    (function(LSPErrorCodes2) {
      LSPErrorCodes2.lspReservedErrorRangeStart = -32899;
      LSPErrorCodes2.RequestFailed = -32803;
      LSPErrorCodes2.ServerCancelled = -32802;
      LSPErrorCodes2.ContentModified = -32801;
      LSPErrorCodes2.RequestCancelled = -32800;
      LSPErrorCodes2.lspReservedErrorRangeEnd = -32800;
    })(LSPErrorCodes || (exports2.LSPErrorCodes = LSPErrorCodes = {}));
  })(api);
  return api;
}
var hasRequiredMain;
function requireMain() {
  if (hasRequiredMain) return main$2;
  hasRequiredMain = 1;
  (function(exports2) {
    var __createBinding = main$2 && main$2.__createBinding || (Object.create ? (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      var desc = Object.getOwnPropertyDescriptor(m2, k2);
      if (!desc || ("get" in desc ? !m2.__esModule : desc.writable || desc.configurable)) {
        desc = { enumerable: true, get: function() {
          return m2[k2];
        } };
      }
      Object.defineProperty(o2, k22, desc);
    }) : (function(o2, m2, k2, k22) {
      if (k22 === void 0) k22 = k2;
      o2[k22] = m2[k2];
    }));
    var __exportStar = main$2 && main$2.__exportStar || function(m2, exports3) {
      for (var p2 in m2) if (p2 !== "default" && !Object.prototype.hasOwnProperty.call(exports3, p2)) __createBinding(exports3, m2, p2);
    };
    Object.defineProperty(exports2, "__esModule", { value: true });
    exports2.createProtocolConnection = void 0;
    const browser_1 = requireBrowser$1();
    __exportStar(requireBrowser$1(), exports2);
    __exportStar(requireApi(), exports2);
    function createProtocolConnection(reader, writer, logger, options2) {
      return (0, browser_1.createMessageConnection)(reader, writer, logger, options2);
    }
    exports2.createProtocolConnection = createProtocolConnection;
  })(main$2);
  return main$2;
}
var browser;
var hasRequiredBrowser;
function requireBrowser() {
  if (hasRequiredBrowser) return browser;
  hasRequiredBrowser = 1;
  browser = requireMain();
  return browser;
}
var browserExports = requireBrowser();
function dastPositionToLspRange(position2) {
  return {
    start: {
      line: position2.start.line - 1,
      character: position2.start.column - 1
    },
    end: {
      line: position2.end.line - 1,
      character: position2.end.column - 1
    }
  };
}
const DIAGNOSTIC_TYPE_TO_LSP_SEVERITY = {
  error: browserExports.DiagnosticSeverity.Error,
  warning: browserExports.DiagnosticSeverity.Warning,
  info: browserExports.DiagnosticSeverity.Information
};
function toLspDiagnostic(diagnostic2) {
  const range2 = dastPositionToLspRange(diagnostic2.position);
  if (isAccessibilityRecord(diagnostic2)) {
    return {
      message: diagnostic2.message,
      severity: browserExports.DiagnosticSeverity.Warning,
      range: range2,
      code: `accessibility-level-${diagnostic2.level}`,
      source: diagnostic2.level === 1 ? "WCAG AA Accessibility Violation" : "Accessibility alert",
      markClass: `cm-doenet-accessibility-diagnostic cm-doenet-accessibility-diagnostic-level-${diagnostic2.level}`
    };
  }
  return {
    message: diagnostic2.message,
    severity: DIAGNOSTIC_TYPE_TO_LSP_SEVERITY[diagnostic2.type],
    range: range2
  };
}
function toAdditionalDiagnosticsForLsp({
  diagnostics,
  showInfoAnnotations,
  showAccessibilityAnnotations
}) {
  return diagnostics.filter((diagnostic2) => {
    if (!diagnostic2.position) {
      return false;
    }
    if (diagnostic2.type === "error") {
      return true;
    }
    if (diagnostic2.type === "warning") {
      return true;
    }
    if (diagnostic2.type === "info") {
      return showInfoAnnotations;
    }
    if (isAccessibilityRecord(diagnostic2)) {
      return showAccessibilityAnnotations;
    }
    return false;
  }).map(toLspDiagnostic);
}
function mergeDiagnosticsByType({
  initialDiagnostics,
  diagnostics
}) {
  const warnings = [
    ...initialDiagnostics.filter(
      (diagnostic2) => diagnostic2.type === "warning"
    ),
    ...diagnostics.filter(
      (diagnostic2) => diagnostic2.type === "warning"
    )
  ];
  const errors2 = [
    ...initialDiagnostics.filter(
      (diagnostic2) => diagnostic2.type === "error"
    ),
    ...diagnostics.filter(
      (diagnostic2) => diagnostic2.type === "error"
    )
  ];
  const infos = [
    ...initialDiagnostics.filter(
      (diagnostic2) => diagnostic2.type === "info"
    ),
    ...diagnostics.filter(
      (diagnostic2) => diagnostic2.type === "info"
    )
  ];
  const accessibility = [
    ...initialDiagnostics.filter(isAccessibilityRecord),
    ...diagnostics.filter(isAccessibilityRecord)
  ];
  return {
    warnings,
    errors: errors2,
    infos,
    accessibility,
    warningsCount: warnings.length,
    errorsCount: errors2.length,
    infosCount: infos.length,
    accessibilityLevel1Count: accessibility.filter(
      (diagnostic2) => diagnostic2.level === 1
    ).length,
    accessibilityLevel2Count: accessibility.filter(
      (diagnostic2) => diagnostic2.level === 2
    ).length
  };
}
const HELP_NONE = { kind: "none" };
const EMPTY_INITIAL_DIAGNOSTICS$1 = [];
function firstEnabledTab({
  showDiagnostics,
  showResponses,
  showHelp
}) {
  if (showHelp) return "help";
  if (showDiagnostics) return "errors";
  if (showResponses) return "responses";
  return null;
}
function isTabEnabled(tabId, { showDiagnostics, showResponses, showHelp }) {
  if (tabId === "responses") {
    return showResponses;
  }
  if (tabId === "help") {
    return showHelp;
  }
  return showDiagnostics;
}
const EditorViewer = React__default.forwardRef(function EditorViewer2({
  doenetML: initialDoenetML,
  activityId: specifiedActivityId,
  prefixForIds = "",
  doenetViewerUrl,
  doenetImagesUrl,
  darkMode = "light",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  width = "100%",
  height = "500px",
  showViewer = true,
  viewerLocation = "right",
  doenetmlChangeCallback,
  immediateDoenetmlChangeCallback,
  documentStructureCallback,
  diagnosticsSummaryCallback,
  id: specifiedId,
  readOnly: readOnly2 = false,
  showFormatter = true,
  showDiagnostics = true,
  showResponses = true,
  showHelp = true,
  addVirtualKeyboard = false,
  border = "1px solid",
  initialDiagnostics = EMPTY_INITIAL_DIAGNOSTICS$1,
  fetchExternalDoenetML,
  docsURL = "https://docs.doenet.org",
  initialOpenTab
}, ref) {
  if (readOnly2) {
    showFormatter = false;
  }
  if (!showViewer) {
    showResponses = false;
  }
  const lspRef = useRef(null);
  const [id2, setId] = useState(specifiedId ?? "editor-" + nanoid$1(5));
  const [activityId, setActivityId] = useState(specifiedActivityId ?? id2);
  const [codeChanged, setCodeChanged] = useState(false);
  const [documentInteracted, setDocumentInteracted] = useState(false);
  const [updateWord, setUpdateWord] = useState("Reset");
  const codeChangedRef = useRef(false);
  codeChangedRef.current = codeChanged;
  const documentInteractedRef = useRef(false);
  documentInteractedRef.current = documentInteracted;
  const [viewerDoenetML, setViewerDoenetML] = useState(initialDoenetML);
  const lastReportedDoenetML = useRef(initialDoenetML);
  const editorDoenetMLRef = useRef(initialDoenetML);
  const [editorDoenetML, setEditorDoenetML] = useState(initialDoenetML);
  const updateValueTimer = useRef(null);
  const viewerContainer = useRef(null);
  const [viewerResetNum, setViewerResetNum] = useState(0);
  const [variants, setVariants] = useState({
    index: 1,
    numVariants: 1,
    allPossibleVariants: ["a"]
  });
  const tabVisibility = { showDiagnostics, showResponses, showHelp };
  const [{ resolvedInitialOpenTab, initialOpenTabWarning }] = useState(() => {
    if (initialOpenTab === null) {
      return {
        resolvedInitialOpenTab: null,
        initialOpenTabWarning: null
      };
    }
    if (initialOpenTab === void 0) {
      return {
        resolvedInitialOpenTab: firstEnabledTab(tabVisibility),
        initialOpenTabWarning: null
      };
    }
    if (!isTabEnabled(initialOpenTab, tabVisibility)) {
      return {
        resolvedInitialOpenTab: firstEnabledTab(tabVisibility),
        initialOpenTabWarning: `DoenetEditor: initialOpenTab="${initialOpenTab}" is not enabled (showDiagnostics=${showDiagnostics}, showResponses=${showResponses}, showHelp=${showHelp}); falling back to default.`
      };
    }
    return {
      resolvedInitialOpenTab: initialOpenTab,
      initialOpenTabWarning: null
    };
  });
  useEffect(() => {
    if (initialOpenTabWarning) {
      console.warn(initialOpenTabWarning);
    }
  }, [initialOpenTabWarning]);
  const [infoPanelIsOpen, setInfoPanelIsOpen] = useState(
    resolvedInitialOpenTab !== null
  );
  const [diagnostics, setDiagnostics2] = useState([]);
  const [diagnosticsSource, setDiagnosticsSource] = useState(initialDoenetML);
  const [receivedDiagnosticsFromViewer, setReceivedDiagnosticsFromViewer] = useState(false);
  const [showInfoAnnotations, setShowInfoAnnotations] = useState(false);
  const [showAccessibilityAnnotations, setShowAccessibilityAnnotations] = useState(true);
  const [helpContent, setHelpContent] = useState(HELP_NONE);
  const cursorDebounceTimer = useRef(void 0);
  const lastCursorOffsetRef = useRef(null);
  const helpIsVisibleRef = useRef(false);
  const selectedCompletionRef = useRef(null);
  const helpRequestIdRef = useRef(0);
  const lastSourceResetAtRef = useRef(0);
  const helpRetryTimerRef = useRef(void 0);
  const tabStore = useTabStore({
    defaultSelectedId: resolvedInitialOpenTab ?? firstEnabledTab(tabVisibility) ?? void 0
  });
  const selectedTabId = tabStore.useState("selectedId");
  const isAccessibilityReportOpen = infoPanelIsOpen && selectedTabId === "accessibility";
  const activateTab = useCallback(
    (tabId) => {
      if (infoPanelIsOpen && selectedTabId === tabId) {
        setInfoPanelIsOpen(false);
        return;
      }
      tabStore.setSelectedId(tabId);
      setInfoPanelIsOpen(true);
    },
    [infoPanelIsOpen, selectedTabId, tabStore]
  );
  const toggleAccessibilityReport = useCallback(
    () => activateTab("accessibility"),
    [activateTab]
  );
  const updateViewer = useCallback(() => {
    if (!codeChangedRef.current && !documentInteractedRef.current) {
      return;
    }
    setDocumentInteracted(false);
    setResponses([]);
    if (codeChangedRef.current) {
      setViewerDoenetML(editorDoenetMLRef.current);
      window.clearTimeout(updateValueTimer.current ?? void 0);
      if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
        lastReportedDoenetML.current = editorDoenetMLRef.current;
        if (!showViewer) {
          doenetmlChangeCallbackRef.current?.(
            editorDoenetMLRef.current
          );
        }
      }
      setCodeChanged(false);
      updateValueTimer.current = null;
    } else {
      setViewerResetNum((n2) => n2 + 1);
    }
  }, [showViewer]);
  useImperativeHandle(
    ref,
    () => ({
      openDiagnosticsTab(tabId) {
        if (!isTabEnabled(tabId, tabVisibility)) {
          console.warn(
            `DoenetEditor: openDiagnosticsTab("${tabId}") ignored — tab is not enabled (showDiagnostics=${showDiagnostics}, showResponses=${showResponses}, showHelp=${showHelp}).`
          );
          return;
        }
        tabStore.setSelectedId(tabId);
        setInfoPanelIsOpen(true);
      },
      closeDiagnosticsPanel() {
        setInfoPanelIsOpen(false);
      },
      updateRenderedView() {
        if (!showViewer) {
          console.warn(
            "DoenetEditor: updateRenderedView() ignored — showViewer is false; nothing to update."
          );
          return;
        }
        updateViewer();
      }
    }),
    [
      tabStore,
      showDiagnostics,
      showResponses,
      showHelp,
      showViewer,
      updateViewer
    ]
  );
  function setDiagnosticsCallback(newDiagnostics, source) {
    setDiagnostics2(newDiagnostics);
    setDiagnosticsSource(source);
    setReceivedDiagnosticsFromViewer(true);
  }
  useEffect(() => {
    const additionalDiagnostics = toAdditionalDiagnosticsForLsp({
      diagnostics: [...initialDiagnostics, ...diagnostics],
      showInfoAnnotations,
      showAccessibilityAnnotations
    });
    lspRef.current?.lsp.sendAdditionalDiagnostics(
      lspRef.current.documentUri,
      additionalDiagnostics
    );
  }, [
    initialDiagnostics,
    diagnostics,
    showInfoAnnotations,
    showAccessibilityAnnotations
  ]);
  const {
    warnings: warningsObjs,
    errors: errorsObjs,
    infos: infoObjs,
    accessibility: accessibilityObjs,
    warningsCount,
    errorsCount,
    infosCount,
    accessibilityLevel1Count,
    accessibilityLevel2Count
  } = useMemo(
    () => mergeDiagnosticsByType({
      initialDiagnostics,
      diagnostics
    }),
    [initialDiagnostics, diagnostics]
  );
  const diagnosticsSummaryCallbackRef = useRef(diagnosticsSummaryCallback);
  diagnosticsSummaryCallbackRef.current = diagnosticsSummaryCallback;
  const doenetmlChangeCallbackRef = useRef(doenetmlChangeCallback);
  doenetmlChangeCallbackRef.current = doenetmlChangeCallback;
  const immediateDoenetmlChangeCallbackRef = useRef(
    immediateDoenetmlChangeCallback
  );
  immediateDoenetmlChangeCallbackRef.current = immediateDoenetmlChangeCallback;
  const documentStructureCallbackRef = useRef(documentStructureCallback);
  documentStructureCallbackRef.current = documentStructureCallback;
  useEffect(() => {
    if (!receivedDiagnosticsFromViewer) {
      return;
    }
    diagnosticsSummaryCallbackRef.current?.(
      {
        warningsCount,
        errorsCount,
        infosCount,
        accessibilityLevel1Count,
        accessibilityLevel2Count
      },
      diagnosticsSource
    );
  }, [diagnostics, receivedDiagnosticsFromViewer, diagnosticsSource]);
  const [responses, setResponses] = useState([]);
  useEffect(() => setResponses([]), [initialDoenetML]);
  useEffect(() => {
    function submittedResponseListener(event) {
      if (event.data.subject == "SPLICE.sendEvent") {
        const data = event.data.data;
        if (data.activityId !== activityId) {
          return;
        }
        if (data.verb !== "experienced" && data.verb !== "isVisible") {
          setDocumentInteracted(true);
          if (!codeChangedRef.current) {
            setUpdateWord("Reset");
          }
        }
        if (data.verb === "submitted") {
          const object2 = JSON.parse(data.object);
          const answerId = object2.rootName;
          if (answerId) {
            const result2 = JSON.parse(
              data.result,
              nanInfinityReviver
            );
            const answerCreditAchieved = result2.creditAchieved;
            const response = result2.response;
            const componentTypes = result2.componentTypes;
            if (response !== void 0 && componentTypes !== void 0 && response.length === componentTypes.length) {
              const responseElement = formatResponse(
                response,
                componentTypes
              );
              setResponses((was) => {
                const arr = [...was];
                arr.push({
                  answerId,
                  response: responseElement,
                  creditAchieved: answerCreditAchieved,
                  submittedAt: (/* @__PURE__ */ new Date()).toLocaleTimeString()
                });
                return arr;
              });
            }
          }
        }
      }
    }
    addEventListener("message", submittedResponseListener);
    return () => {
      removeEventListener("message", submittedResponseListener);
    };
  }, [activityId]);
  useEffect(() => {
    editorDoenetMLRef.current = initialDoenetML;
    setEditorDoenetML(initialDoenetML);
    window.clearTimeout(cursorDebounceTimer.current);
    window.clearTimeout(helpRetryTimerRef.current);
    helpRequestIdRef.current += 1;
    setHelpContent(HELP_NONE);
    lastSourceResetAtRef.current = Date.now();
  }, [initialDoenetML]);
  const documentStructureThenChangeCallback = useCallback((obj) => {
    documentStructureCallbackRef.current?.(obj);
    doenetmlChangeCallbackRef.current?.(editorDoenetMLRef.current);
  }, []);
  const onEditorChange = useCallback((value) => {
    if (editorDoenetMLRef.current !== value) {
      editorDoenetMLRef.current = value;
      if (!codeChangedRef.current) {
        setCodeChanged(true);
        setUpdateWord("Update");
      }
      immediateDoenetmlChangeCallbackRef.current?.(value);
      clearTimeout(updateValueTimer.current ?? void 0);
      updateValueTimer.current = window.setTimeout(function() {
        if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
          lastReportedDoenetML.current = editorDoenetMLRef.current;
          doenetmlChangeCallbackRef.current?.(
            editorDoenetMLRef.current
          );
        }
        updateValueTimer.current = null;
      }, 3e3);
    }
  }, []);
  const onBlur = useCallback(() => {
    window.clearTimeout(updateValueTimer.current ?? void 0);
    if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
      lastReportedDoenetML.current = editorDoenetMLRef.current;
      doenetmlChangeCallbackRef.current?.(editorDoenetMLRef.current);
    }
    updateValueTimer.current = null;
  }, []);
  const runHelpRequest = useCallback(
    async (warnLabel, rpc) => {
      const myId = ++helpRequestIdRef.current;
      const bundle = lspRef.current;
      if (!bundle) {
        if (helpIsVisibleRef.current) setHelpContent(HELP_NONE);
        return;
      }
      try {
        const result2 = await rpc(bundle);
        if (myId !== helpRequestIdRef.current) return;
        if (!helpIsVisibleRef.current) return;
        setHelpContent(result2);
        if (result2.kind === "none" && Date.now() - lastSourceResetAtRef.current < 3e3) {
          const retryId = myId;
          window.clearTimeout(helpRetryTimerRef.current);
          helpRetryTimerRef.current = window.setTimeout(() => {
            if (retryId !== helpRequestIdRef.current) return;
            if (!helpIsVisibleRef.current) return;
            void runHelpRequest(warnLabel, rpc);
          }, 400);
        }
      } catch (err) {
        if (myId !== helpRequestIdRef.current) return;
        console.warn(`${warnLabel} request failed`, err);
        if (!helpIsVisibleRef.current) return;
        setHelpContent(HELP_NONE);
      }
    },
    []
  );
  const requestHelpForCursor = useCallback(
    (offset2) => runHelpRequest(
      "contextHelp",
      (bundle) => bundle.lsp.requestContextHelp(bundle.documentUri, offset2)
    ),
    [runHelpRequest]
  );
  const requestHelpForCompletion = useCallback(
    (offset2, completion) => runHelpRequest(
      "contextHelpForCompletion",
      (bundle) => bundle.lsp.requestContextHelpForCompletion(
        bundle.documentUri,
        offset2,
        { label: completion.label, type: completion.type }
      )
    ),
    [runHelpRequest]
  );
  const onCursorChange = useCallback(
    (selection2) => {
      const offset2 = selection2.main.head;
      lastCursorOffsetRef.current = offset2;
      window.clearTimeout(cursorDebounceTimer.current);
      if (!helpIsVisibleRef.current) return;
      if (selectedCompletionRef.current) return;
      cursorDebounceTimer.current = window.setTimeout(() => {
        void requestHelpForCursor(offset2);
      }, 150);
    },
    [requestHelpForCursor]
  );
  const onSelectedCompletionChange = useCallback(
    (completion) => {
      selectedCompletionRef.current = completion;
      if (!helpIsVisibleRef.current) return;
      window.clearTimeout(cursorDebounceTimer.current);
      const offset2 = lastCursorOffsetRef.current;
      if (offset2 == null) return;
      if (completion) {
        void requestHelpForCompletion(offset2, completion);
      } else {
        void requestHelpForCursor(offset2);
      }
    },
    [requestHelpForCursor, requestHelpForCompletion]
  );
  useEffect(() => {
    const visible = infoPanelIsOpen && selectedTabId === "help";
    helpIsVisibleRef.current = visible;
    if (!visible) {
      window.clearTimeout(cursorDebounceTimer.current);
      helpRequestIdRef.current += 1;
      setHelpContent(HELP_NONE);
      return;
    }
    const offset2 = lastCursorOffsetRef.current;
    if (offset2 == null) return;
    const completion = selectedCompletionRef.current;
    if (completion) {
      void requestHelpForCompletion(offset2, completion);
    } else {
      void requestHelpForCursor(offset2);
    }
  }, [
    infoPanelIsOpen,
    selectedTabId,
    requestHelpForCursor,
    requestHelpForCompletion
  ]);
  useEffect(() => {
    const handleEditorKeyDown = (event) => {
      if (isSaveShortcutKeydown(event)) {
        event.preventDefault();
        event.stopPropagation();
        if (codeChangedRef.current) {
          updateViewer();
        }
      }
    };
    let codeEditorContainer = document.getElementById(id2);
    let viewerPanelContainer = viewerContainer.current;
    if (showViewer) {
      codeEditorContainer?.addEventListener(
        "keydown",
        handleEditorKeyDown
      );
      viewerPanelContainer?.addEventListener(
        "keydown",
        handleEditorKeyDown
      );
    }
    return () => {
      codeEditorContainer?.removeEventListener(
        "keydown",
        handleEditorKeyDown
      );
      viewerPanelContainer?.removeEventListener(
        "keydown",
        handleEditorKeyDown
      );
    };
  }, [showViewer, id2, updateViewer]);
  useEffect(() => {
    return () => {
      if (updateValueTimer.current !== null) {
        window.clearTimeout(updateValueTimer.current);
        if (lastReportedDoenetML.current !== editorDoenetMLRef.current) {
          lastReportedDoenetML.current = editorDoenetMLRef.current;
          doenetmlChangeCallbackRef.current?.(
            editorDoenetMLRef.current
          );
        }
      }
      window.clearTimeout(cursorDebounceTimer.current);
      window.clearTimeout(helpRetryTimerRef.current);
    };
  }, []);
  const codeMirror = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    CodeMirror,
    {
      value: editorDoenetML,
      readOnly: readOnly2,
      onBlur,
      onChange: onEditorChange,
      onCursorChange,
      onSelectedCompletionChange,
      languageServerRef: lspRef,
      doenetWorkerUrl: doenetGlobalConfig.doenetWorkerUrl,
      darkMode
    }
  );
  const editorAndCollapsiblePanel = showDiagnostics || showResponses || showHelp ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ResizableCollapsiblePanelPair,
    {
      mainPanel: codeMirror,
      subPanel: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        DiagnosticsResponseTabContents,
        {
          store: tabStore,
          warnings: warningsObjs,
          errors: errorsObjs,
          infos: infoObjs,
          accessibility: accessibilityObjs,
          submittedResponses: responses,
          isOpen: infoPanelIsOpen,
          showDiagnostics,
          showResponses,
          showHelp,
          showInfoAnnotations,
          setShowInfoAnnotations,
          showAccessibilityAnnotations,
          setShowAccessibilityAnnotations,
          helpContent,
          docsURL
        }
      ),
      isOpen: infoPanelIsOpen,
      setIsOpen: setInfoPanelIsOpen,
      defaultSize: 25,
      collapsedSize: 10
    }
  ) : codeMirror;
  const editorPanel = /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "editor-panel", id: id2, children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "editor-and-collapsible-panel", children: editorAndCollapsiblePanel }),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      EditorFooter,
      {
        store: tabStore,
        isOpen: infoPanelIsOpen,
        activateTab,
        showDiagnostics,
        showResponses,
        showHelp,
        showFormatter,
        reserveKeyboardButtonSpace: addVirtualKeyboard && (!showViewer || viewerLocation === "left" || viewerLocation === "top"),
        diagnosticsSummary: {
          warningsCount,
          errorsCount,
          infosCount,
          accessibilityLevel1Count,
          accessibilityLevel2Count
        },
        submittedResponsesCount: responses.length,
        onFormat: async (asDoenetML) => {
          const currentBuffer = editorDoenetMLRef.current;
          const printed = await prettyPrint(currentBuffer, {
            doenetSyntax: asDoenetML,
            tabWidth: 2
          });
          onEditorChange(printed);
          if (printed !== currentBuffer) {
            flushSync(() => setEditorDoenetML(currentBuffer));
          }
          setEditorDoenetML(printed);
        }
      }
    )
  ] });
  if (!showViewer) {
    return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { "data-theme": darkMode, style: { display: "contents" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      "div",
      {
        style: {
          display: "flex",
          width,
          height,
          border,
          boxSizing: "border-box"
        },
        children: editorPanel
      }
    ) });
  }
  function requestScrollTo(offset2) {
    if (viewerContainer.current) {
      viewerContainer.current.scrollTo({
        top: offset2 - 40,
        behavior: "smooth"
      });
    }
  }
  const viewerPanel = /* @__PURE__ */ jsxRuntimeExports$3.jsxs("div", { className: "viewer-panel", id: id2 + "-viewer-panel", children: [
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      ViewerControlsBar,
      {
        id: id2,
        readOnly: readOnly2,
        codeChanged,
        documentInteracted,
        updateWord,
        onUpdateViewer: updateViewer,
        variants,
        setVariants,
        showDiagnostics,
        accessibilityLevel1Count,
        accessibilityLevel2Count,
        isAccessibilityReportOpen,
        onToggleAccessibilityReport: toggleAccessibilityReport,
        darkMode
      }
    ),
    /* @__PURE__ */ jsxRuntimeExports$3.jsx(
      "div",
      {
        className: "viewer",
        id: id2 + "-viewer",
        ref: viewerContainer,
        tabIndex: -1,
        children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
          DocViewer,
          {
            doenetML: viewerDoenetML,
            flags: {
              showCorrectness: true,
              solutionDisplayMode: "button",
              showFeedback: true,
              showHints: true,
              autoSubmit: false,
              allowLoadState: false,
              allowSaveState: false,
              saveRendererState: false,
              allowLocalState: false,
              allowSaveEvents: true,
              messageParent: false,
              readOnly: false
            },
            activityId,
            prefixForIds,
            attemptNumber: 1,
            generatedVariantCallback: (x2) => {
              setVariantsFromCallback(x2, variants, setVariants);
            },
            requestedVariantIndex: variants.index,
            setDiagnosticsCallback,
            documentStructureCallback: documentStructureThenChangeCallback,
            doenetViewerUrl,
            doenetImagesUrl,
            darkMode,
            showAnswerResponseButton,
            answerResponseCounts,
            fetchExternalDoenetML,
            requestScrollTo
          },
          viewerResetNum
        )
      }
    )
  ] });
  const viewerFirst = viewerLocation === "left" || viewerLocation === "top";
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { "data-theme": darkMode, style: { display: "contents" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ResizablePanelPair,
    {
      panelA: viewerFirst ? viewerPanel : editorPanel,
      panelB: viewerFirst ? editorPanel : viewerPanel,
      preferredDirection: viewerLocation === "bottom" || viewerLocation === "top" ? "vertical" : "horizontal",
      width,
      height,
      border
    }
  ) });
});
function useRecordVisibilityChanges(ref, callAction, actions, skipRecording = false) {
  useEffect(() => {
    if (skipRecording) {
      return;
    }
    if (ref.current) {
      const observer = new IntersectionObserver(([entry]) => {
        callAction({
          action: actions.recordVisibilityChange,
          args: { isVisible: entry.isIntersecting }
        });
      });
      observer.observe(ref.current);
      return () => {
        observer.disconnect();
        callAction({
          action: actions.recordVisibilityChange,
          args: { isVisible: false }
        });
      };
    }
  }, [ref]);
}
function isEntryOnPage(entry) {
  if (entry.isIntersecting) {
    return true;
  }
  const rect = entry.boundingClientRect;
  const zeroArea = rect.width === 0 || rect.height === 0;
  return zeroArea && entry.target.getClientRects().length > 0;
}
function useIsOnPage(ref) {
  const [isIntersecting, setIntersecting] = useState(false);
  useEffect(() => {
    const observer = new IntersectionObserver(
      ([entry]) => setIntersecting(isEntryOnPage(entry)),
      { rootMargin: "1000000px" }
    );
    if (ref.current) {
      observer.observe(ref.current);
    }
    return () => {
      observer.disconnect();
    };
  }, [ref]);
  return isIntersecting;
}
function subscribeToPinnedTheme() {
  return () => {
  };
}
function useResolvedTheme(setting) {
  const subscribe2 = setting === "system" ? subscribeToSystemTheme : subscribeToPinnedTheme;
  const systemTheme = useSyncExternalStore(
    subscribe2,
    getSystemTheme,
    () => "light"
  );
  if (setting === "system") {
    return systemTheme;
  }
  return setting;
}
const defaultFlags = {
  showCorrectness: true,
  readOnly: false,
  solutionDisplayMode: "button",
  showFeedback: true,
  showHints: true,
  allowLoadState: true,
  allowSaveState: true,
  saveRendererState: false,
  allowLocalState: false,
  allowSaveEvents: true,
  messageParent: false,
  autoSubmit: false
};
let warnedShowErrorsWarningsDeprecation = false;
let warnedInitialErrorsWarningsDeprecation = false;
const EMPTY_INITIAL_DIAGNOSTICS = [];
const FocusedMathInputContext = React__default.createContext({ current: null });
window.global = window.global || window;
function DoenetViewer({
  doenetML,
  flags: specifiedFlags = {},
  activityId = "a",
  docId = "1",
  prefixForIds = "",
  userId,
  attemptNumber = 1,
  render = true,
  requestedVariantIndex,
  initialState: initialState2,
  reportScoreAndStateCallback,
  setIsInErrorState,
  generatedVariantCallback: specifiedGeneratedVariantCallback,
  documentStructureCallback,
  initializedCallback,
  setDiagnosticsCallback,
  setErrorsAndWarningsCallback,
  forceDisable = false,
  forceShowCorrectness = false,
  forceShowSolution = false,
  forceUnsuppressCheckWork = false,
  addVirtualKeyboard = true,
  externalVirtualKeyboardProvided = false,
  doenetViewerUrl,
  doenetImagesUrl,
  darkMode = "system",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  includeVariantSelector = false,
  initializeCounters = {},
  fetchExternalDoenetML,
  requestScrollTo,
  mathjaxUrl,
  useExistingMathjax = false,
  onInit = () => {
  }
}) {
  const [variants, setVariants] = useState({
    index: 1,
    numVariants: 1,
    allPossibleVariants: ["a"]
  });
  const thisPropSet = [doenetML, activityId, userId, requestedVariantIndex];
  const lastPropSet = useRef([]);
  const variantIndex = useRef(1);
  const resolvedTheme = useResolvedTheme(darkMode);
  const ref = useRef(null);
  const isOnPage = useIsOnPage(ref);
  const [hidden, setHidden] = useState(true);
  useEffect(() => {
    if (isOnPage) {
      setHidden(false);
    }
  }, [isOnPage]);
  useEffect(() => {
    if (setErrorsAndWarningsCallback) {
      console.warn(
        "DoenetViewer: setErrorsAndWarningsCallback is deprecated. Use setDiagnosticsCallback instead."
      );
    }
  }, []);
  const effectiveDiagnosticsCallback = setErrorsAndWarningsCallback ? (diagnostics, source) => {
    setDiagnosticsCallback?.(diagnostics, source);
    setErrorsAndWarningsCallback({
      errors: diagnostics.filter(isErrorRecord),
      warnings: diagnostics.filter(isWarningRecord)
    });
  } : setDiagnosticsCallback;
  const flags = { ...defaultFlags, ...specifiedFlags };
  if ((flags.allowLocalState || flags.allowLoadState) && includeVariantSelector) {
    console.warn(
      "includeVariantSelector cannot be used with allowLocalState or allowLoadState. Disabling includeVariantSelector."
    );
    includeVariantSelector = false;
  }
  const generatedVariantCallback = useCallback(
    (x2) => {
      specifiedGeneratedVariantCallback?.(x2);
      if (includeVariantSelector) {
        setVariantsFromCallback(x2, variants, setVariants);
      }
    },
    [specifiedGeneratedVariantCallback, includeVariantSelector, variants]
  );
  let variantSelector = null;
  if (includeVariantSelector) {
    variantIndex.current = variants.index;
    if (variants.numVariants > 1) {
      variantSelector = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        VariantSelect,
        {
          darkMode: resolvedTheme,
          array: variants.allPossibleVariants,
          syncIndex: variants.index,
          onChange: (index2) => setVariantIndex(setVariants, index2)
        }
      );
    }
  } else {
    if (thisPropSet.some((v2, i2) => v2 !== lastPropSet.current[i2])) {
      if (requestedVariantIndex === void 0) {
        let rng = seedrandom$1();
        requestedVariantIndex = Math.floor(rng() * 1e6) + 1;
      }
      variantIndex.current = Math.round(requestedVariantIndex);
      if (!Number.isInteger(variantIndex.current)) {
        variantIndex.current = 1;
      }
      lastPropSet.current = thisPropSet;
    }
  }
  const viewer = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    DocViewer,
    {
      doenetML,
      flags,
      activityId,
      docId,
      prefixForIds,
      userId,
      attemptNumber,
      render,
      hidden,
      requestedVariantIndex: variantIndex.current,
      initialState: initialState2,
      reportScoreAndStateCallback,
      setIsInErrorState,
      generatedVariantCallback,
      documentStructureCallback,
      initializedCallback,
      setDiagnosticsCallback: effectiveDiagnosticsCallback,
      forceDisable,
      forceShowCorrectness,
      forceShowSolution,
      forceUnsuppressCheckWork,
      doenetViewerUrl,
      doenetImagesUrl,
      darkMode: resolvedTheme,
      showAnswerResponseButton,
      answerResponseCounts,
      initializeCounters,
      fetchExternalDoenetML,
      requestScrollTo
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider_default, { store, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    MathJaxContext$1,
    {
      config: mathjaxConfig$1,
      version: 4,
      src: mathjaxUrl,
      useExistingMathJax: useExistingMathjax,
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        "div",
        {
          "data-theme": resolvedTheme,
          ref: (r2) => {
            ref.current = r2;
            if (onInit && r2) {
              onInit(r2);
            }
          },
          children: /* @__PURE__ */ jsxRuntimeExports$3.jsxs(
            WrapWithKeyboard,
            {
              addVirtualKeyboard,
              externalVirtualKeyboardProvided,
              theme: resolvedTheme,
              children: [
                variantSelector,
                viewer
              ]
            }
          )
        }
      )
    }
  ) });
}
const DoenetEditor = React__default.forwardRef(function DoenetEditor2({
  doenetML,
  activityId = "a",
  prefixForIds = "",
  addVirtualKeyboard = true,
  externalVirtualKeyboardProvided = false,
  doenetViewerUrl,
  doenetImagesUrl,
  darkMode = "system",
  showAnswerResponseButton = false,
  answerResponseCounts = {},
  width,
  height,
  viewerLocation,
  backgroundColor,
  showViewer,
  doenetmlChangeCallback,
  immediateDoenetmlChangeCallback,
  documentStructureCallback,
  diagnosticsSummaryCallback,
  id: id2,
  readOnly: readOnly2 = false,
  showFormatter = true,
  showDiagnostics,
  showErrorsWarnings,
  showResponses = true,
  showHelp = true,
  border = "1px solid",
  initialDiagnostics = EMPTY_INITIAL_DIAGNOSTICS,
  initialErrors,
  initialWarnings,
  fetchExternalDoenetML,
  docsURL,
  initialOpenTab,
  mathjaxUrl,
  useExistingMathjax = false
}, ref) {
  const resolvedTheme = useResolvedTheme(darkMode);
  const normalizedShowDiagnostics = showDiagnostics ?? showErrorsWarnings ?? true;
  if (showDiagnostics === void 0 && showErrorsWarnings !== void 0 && !warnedShowErrorsWarningsDeprecation) {
    warnedShowErrorsWarningsDeprecation = true;
    console.warn(
      "DoenetEditor: showErrorsWarnings is deprecated. Use showDiagnostics instead."
    );
  }
  if ((initialErrors !== void 0 || initialWarnings !== void 0) && !warnedInitialErrorsWarningsDeprecation) {
    warnedInitialErrorsWarningsDeprecation = true;
    console.warn(
      "DoenetEditor: initialErrors and initialWarnings are deprecated. Use initialDiagnostics instead."
    );
  }
  const normalizedInitialDiagnostics = useMemo(
    () => [
      ...initialDiagnostics,
      ...initialErrors ?? [],
      ...initialWarnings ?? []
    ],
    [initialDiagnostics, initialErrors, initialWarnings]
  );
  const editor = /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    EditorViewer,
    {
      ref,
      doenetML,
      activityId,
      prefixForIds,
      doenetViewerUrl,
      doenetImagesUrl,
      darkMode: resolvedTheme,
      showAnswerResponseButton,
      answerResponseCounts,
      width,
      height,
      viewerLocation,
      showViewer,
      doenetmlChangeCallback,
      immediateDoenetmlChangeCallback,
      documentStructureCallback,
      diagnosticsSummaryCallback,
      id: id2,
      readOnly: readOnly2,
      showFormatter,
      showDiagnostics: normalizedShowDiagnostics,
      showResponses,
      showHelp,
      addVirtualKeyboard,
      border,
      initialDiagnostics: normalizedInitialDiagnostics,
      fetchExternalDoenetML,
      docsURL,
      initialOpenTab
    }
  );
  return /* @__PURE__ */ jsxRuntimeExports$3.jsx(Provider_default, { store, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    MathJaxContext$1,
    {
      config: mathjaxConfig$1,
      version: 4,
      src: mathjaxUrl,
      useExistingMathJax: useExistingMathjax,
      children: /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { "data-theme": resolvedTheme, style: { display: "contents" }, children: /* @__PURE__ */ jsxRuntimeExports$3.jsx(
        WrapWithKeyboard,
        {
          addVirtualKeyboard,
          externalVirtualKeyboardProvided,
          theme: resolvedTheme,
          children: editor
        }
      ) })
    }
  ) });
});
function WrapWithKeyboard({
  addVirtualKeyboard,
  externalVirtualKeyboardProvided,
  theme: theme2,
  children
}) {
  const dispatch = useAppDispatch();
  const focusedMathInput = useRef(null);
  const keyboard = addVirtualKeyboard ? /* @__PURE__ */ jsxRuntimeExports$3.jsx(
    ExternalAwareVirtualKeyboard,
    {
      externalVirtualKeyboardProvided,
      ownerRef: focusedMathInput,
      theme: theme2,
      onClick: (keyCommands) => {
        dispatch(keyboardSlice.actions.setKeyboardInput(keyCommands));
      }
    }
  ) : null;
  return /* @__PURE__ */ jsxRuntimeExports$3.jsxs(FocusedMathInputContext.Provider, { value: focusedMathInput, children: [
    children,
    /* @__PURE__ */ jsxRuntimeExports$3.jsx("div", { className: "before-keyboard" }),
    keyboard
  ] });
}
export {
  Popover as $,
  deepCompare as A,
  Button2 as B,
  CodeMirror as C,
  DoenetEditor as D,
  ActionButtonGroup as E,
  ActionButton as F,
  ToggleButtonGroup as G,
  EditorViewer as H,
  memo as I,
  forwardRef as J,
  createElement as K,
  createHook as L,
  MathJax as M,
  usePopoverContext as N,
  invariant as O,
  useStoreState as P,
  getBasePlacement as Q,
  useId as R,
  useMergeRefs as S,
  ToggleButton as T,
  removeUndefinedValues as U,
  useSafeLayoutEffect as V,
  getWindow$1 as W,
  usePopoverStore as X,
  PopoverDisclosure as Y,
  MdInfoOutline as Z,
  __variableDynamicImportRuntimeHelper as _,
  DoenetViewer as a,
  keyboardSlice as a0,
  FocusedMathInputContext as a1,
  DEFAULT_MATH_INPUT_FUNCTION_NAMES as a2,
  PopoverAnchor as a3,
  createStoreContext as a4,
  HovercardScopedContextProvider as a5,
  HovercardContextProvider as a6,
  createDialogComponent as a7,
  useWrapElement as a8,
  useHovercard as a9,
  isFalsyBooleanCallback as aa,
  contains as ab,
  sync as ac,
  chain as ad,
  useEvent as ae,
  useHovercardAnchor as af,
  createStore as ag,
  createHovercardStore as ah,
  defaultValue as ai,
  useStore as aj,
  useStoreProps as ak,
  useHovercardStoreProps as al,
  getDefaultExportFromCjs$5 as am,
  roundForDisplay as an,
  autoUpdate as ao,
  CANVAS_DARK_MODE_COLOR as ap,
  creativeCommonsVersions as b,
  cidFromText as c,
  defaultCreativeCommonsVersion$2 as d,
  getMediaLicenseInfo as e,
  mediaLicenses$2 as f,
  getMediaLicenseDisplay as g,
  serializedComponentsReviver as h,
  doenetGlobalConfig as i,
  getDefaultExportFromCjs$4 as j,
  jsxRuntimeExports$3 as k,
  DocContext as l,
  mathjaxConfig$1 as m,
  DynamicMath as n,
  Context$2 as o,
  cesc as p,
  createFunctionFromDefinition as q,
  retrieveTextFileForCid as r,
  serializedComponentsReplacer as s,
  textRendererStyle as t,
  useRecordVisibilityChanges as u,
  Button as v,
  useAppSelector as w,
  mainSlice as x,
  renderersLoadComponent as y,
  encodeFillPatternColorToken as z
};
